import { __wbindgen_object_drop_ref } from './cardano_serialization_lib_bg.js';
import { __wbindgen_string_new } from './cardano_serialization_lib_bg.js';
import { __wbindgen_string_get } from './cardano_serialization_lib_bg.js';
import { __wbg_getRandomValues_98117e9a7e993920 } from './cardano_serialization_lib_bg.js';
import { __wbg_randomFillSync_64cc7d048f228ca8 } from './cardano_serialization_lib_bg.js';
import { __wbg_process_2f24d6544ea7b200 } from './cardano_serialization_lib_bg.js';
import { __wbindgen_is_object } from './cardano_serialization_lib_bg.js';
import { __wbg_versions_6164651e75405d4a } from './cardano_serialization_lib_bg.js';
import { __wbg_node_4b517d861cbcb3bc } from './cardano_serialization_lib_bg.js';
import { __wbindgen_is_string } from './cardano_serialization_lib_bg.js';
import { __wbg_crypto_98fc271021c7d2ad } from './cardano_serialization_lib_bg.js';
import { __wbg_msCrypto_a2cdb043d2bfe57f } from './cardano_serialization_lib_bg.js';
import { __wbg_modulerequire_3440a4bcf44437db } from './cardano_serialization_lib_bg.js';
import { __wbg_newnoargs_9fdd8f3961dd1bee } from './cardano_serialization_lib_bg.js';
import { __wbg_call_ba36642bd901572b } from './cardano_serialization_lib_bg.js';
import { __wbg_self_bb69a836a72ec6e9 } from './cardano_serialization_lib_bg.js';
import { __wbg_window_3304fc4b414c9693 } from './cardano_serialization_lib_bg.js';
import { __wbg_globalThis_e0d21cabc6630763 } from './cardano_serialization_lib_bg.js';
import { __wbg_global_8463719227271676 } from './cardano_serialization_lib_bg.js';
import { __wbindgen_is_undefined } from './cardano_serialization_lib_bg.js';
import { __wbg_buffer_9e184d6f785de5ed } from './cardano_serialization_lib_bg.js';
import { __wbg_new_e8101319e4cf95fc } from './cardano_serialization_lib_bg.js';
import { __wbg_set_e8ae7b27314e8b98 } from './cardano_serialization_lib_bg.js';
import { __wbg_length_2d56cb37075fcfb1 } from './cardano_serialization_lib_bg.js';
import { __wbg_newwithlength_a8d1dbcbe703a5c6 } from './cardano_serialization_lib_bg.js';
import { __wbg_subarray_901ede8318da52a6 } from './cardano_serialization_lib_bg.js';
import { __wbindgen_object_clone_ref } from './cardano_serialization_lib_bg.js';
import { __wbg_new_3a746f2619705add } from './cardano_serialization_lib_bg.js';
import { __wbg_call_f54d3a6dadb199ca } from './cardano_serialization_lib_bg.js';
import { __wbindgen_jsval_eq } from './cardano_serialization_lib_bg.js';
import { __wbg_self_ac379e780a0d8b94 } from './cardano_serialization_lib_bg.js';
import { __wbg_crypto_1e4302b85d4f64a2 } from './cardano_serialization_lib_bg.js';
import { __wbg_getRandomValues_1b4ba144162a5c9e } from './cardano_serialization_lib_bg.js';
import { __wbg_require_6461b1e9a0d7c34a } from './cardano_serialization_lib_bg.js';
import { __wbg_randomFillSync_1b52c8482374c55b } from './cardano_serialization_lib_bg.js';
import { __wbg_getRandomValues_1ef11e888e5228e9 } from './cardano_serialization_lib_bg.js';
import { __wbindgen_debug_string } from './cardano_serialization_lib_bg.js';
import { __wbindgen_throw } from './cardano_serialization_lib_bg.js';
import { __wbindgen_rethrow } from './cardano_serialization_lib_bg.js';
import { __wbindgen_memory } from './cardano_serialization_lib_bg.js';


  var scratchBuffer = new ArrayBuffer(16);
  var i32ScratchView = new Int32Array(scratchBuffer);
  var f32ScratchView = new Float32Array(scratchBuffer);
  var f64ScratchView = new Float64Array(scratchBuffer);
  
  function wasm2js_scratch_load_i32(index) {
    return i32ScratchView[index];
  }
      
  function wasm2js_scratch_store_i32(index, value) {
    i32ScratchView[index] = value;
  }
      
  function wasm2js_scratch_load_f64() {
    return f64ScratchView[0];
  }
      
  function wasm2js_scratch_store_f64(value) {
    f64ScratchView[0] = value;
  }
      
function asmFunc(global, env, buffer) {
 var HEAP8 = new global.Int8Array(buffer);
 var HEAP16 = new global.Int16Array(buffer);
 var HEAP32 = new global.Int32Array(buffer);
 var HEAPU8 = new global.Uint8Array(buffer);
 var HEAPU16 = new global.Uint16Array(buffer);
 var HEAPU32 = new global.Uint32Array(buffer);
 var HEAPF32 = new global.Float32Array(buffer);
 var HEAPF64 = new global.Float64Array(buffer);
 var Math_imul = global.Math.imul;
 var Math_fround = global.Math.fround;
 var Math_abs = global.Math.abs;
 var Math_clz32 = global.Math.clz32;
 var Math_min = global.Math.min;
 var Math_max = global.Math.max;
 var Math_floor = global.Math.floor;
 var Math_ceil = global.Math.ceil;
 var Math_sqrt = global.Math.sqrt;
 var abort = env.abort;
 var nan = global.NaN;
 var infinity = global.Infinity;
 var wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00 = env.__wbindgen_object_drop_ref;
 var wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12 = env.__wbindgen_string_new;
 var wasm_bindgen____wbindgen_string_get__h2745c23336ae3bc7 = env.__wbindgen_string_get;
 var getrandom__imp__BrowserCrypto__get_random_values____wbg_getRandomValues_98117e9a7e993920__h513dd1919c1b7151 = env.__wbg_getRandomValues_98117e9a7e993920;
 var getrandom__imp__NodeCrypto__random_fill_sync____wbg_randomFillSync_64cc7d048f228ca8__hc4ebf80f4c684d80 = env.__wbg_randomFillSync_64cc7d048f228ca8;
 var getrandom__imp__Global__process____wbg_process_2f24d6544ea7b200__hf9233875d912cc2e = env.__wbg_process_2f24d6544ea7b200;
 var wasm_bindgen____wbindgen_is_object__he91ec6fcc6bd8d2d = env.__wbindgen_is_object;
 var getrandom__imp__Process__versions____wbg_versions_6164651e75405d4a__h5d40cbd4a8a1f87e = env.__wbg_versions_6164651e75405d4a;
 var getrandom__imp__Versions__node____wbg_node_4b517d861cbcb3bc__hf2838fd3d35618a9 = env.__wbg_node_4b517d861cbcb3bc;
 var wasm_bindgen____wbindgen_is_string__h68847b1d3af057dc = env.__wbindgen_is_string;
 var getrandom__imp__Global__crypto____wbg_crypto_98fc271021c7d2ad__hf326796a2c49061a = env.__wbg_crypto_98fc271021c7d2ad;
 var getrandom__imp__Global__ms_crypto____wbg_msCrypto_a2cdb043d2bfe57f__h238dd6f4c0c88606 = env.__wbg_msCrypto_a2cdb043d2bfe57f;
 var getrandom__imp__require____wbg_modulerequire_3440a4bcf44437db__h38943d7066d3d873 = env.__wbg_modulerequire_3440a4bcf44437db;
 var js_sys__Function__new_no_args____wbg_newnoargs_9fdd8f3961dd1bee__hc36cbac083d07783 = env.__wbg_newnoargs_9fdd8f3961dd1bee;
 var js_sys__Function__call0____wbg_call_ba36642bd901572b__h933f412500003ba9 = env.__wbg_call_ba36642bd901572b;
 var js_sys__global__get_global_object__Global__get_self____wbg_self_bb69a836a72ec6e9__hab2f593d29e5290f = env.__wbg_self_bb69a836a72ec6e9;
 var js_sys__global__get_global_object__Global__get_window____wbg_window_3304fc4b414c9693__h28126c6ba54fe93c = env.__wbg_window_3304fc4b414c9693;
 var js_sys__global__get_global_object__Global__get_global_this____wbg_globalThis_e0d21cabc6630763__he5b75e175a333dd0 = env.__wbg_globalThis_e0d21cabc6630763;
 var js_sys__global__get_global_object__Global__get_global____wbg_global_8463719227271676__h39c679b75424de91 = env.__wbg_global_8463719227271676;
 var wasm_bindgen____wbindgen_is_undefined__h5ac6d522a5572e68 = env.__wbindgen_is_undefined;
 var js_sys__WebAssembly__Memory__buffer____wbg_buffer_9e184d6f785de5ed__hbbd35f6f4e666239 = env.__wbg_buffer_9e184d6f785de5ed;
 var js_sys__Uint8Array__new____wbg_new_e8101319e4cf95fc__h29b60a20cce29d79 = env.__wbg_new_e8101319e4cf95fc;
 var js_sys__Uint8Array__set____wbg_set_e8ae7b27314e8b98__h24bb59d4e6b448b6 = env.__wbg_set_e8ae7b27314e8b98;
 var js_sys__Uint8Array__length____wbg_length_2d56cb37075fcfb1__h284dd29f7015605d = env.__wbg_length_2d56cb37075fcfb1;
 var js_sys__Uint8Array__new_with_length____wbg_newwithlength_a8d1dbcbe703a5c6__h94c2bc7ccb6effb8 = env.__wbg_newwithlength_a8d1dbcbe703a5c6;
 var js_sys__Uint8Array__subarray____wbg_subarray_901ede8318da52a6__h26391248f17215ed = env.__wbg_subarray_901ede8318da52a6;
 var wasm_bindgen____wbindgen_object_clone_ref__hf1c010c1b4d1cb75 = env.__wbindgen_object_clone_ref;
 var rand_os____wbg_shims__Function__new____wbg_new_3a746f2619705add__h8c98d638ba9d03f8 = env.__wbg_new_3a746f2619705add;
 var rand_os____wbg_shims__Function__call____wbg_call_f54d3a6dadb199ca__h958f935d1097bc3d = env.__wbg_call_f54d3a6dadb199ca;
 var wasm_bindgen____wbindgen_jsval_eq__h96dce91e58c74d93 = env.__wbindgen_jsval_eq;
 var rand_os____wbg_shims__This__self_____wbg_self_ac379e780a0d8b94__h86c21d27210df5ab = env.__wbg_self_ac379e780a0d8b94;
 var rand_os____wbg_shims__This__crypto____wbg_crypto_1e4302b85d4f64a2__h892a87f3db5a36b1 = env.__wbg_crypto_1e4302b85d4f64a2;
 var rand_os____wbg_shims__BrowserCrypto__get_random_values_fn____wbg_getRandomValues_1b4ba144162a5c9e__h16db3aca26429713 = env.__wbg_getRandomValues_1b4ba144162a5c9e;
 var rand_os____wbg_shims__node_require____wbg_require_6461b1e9a0d7c34a__h9fba9c86ad0dcc55 = env.__wbg_require_6461b1e9a0d7c34a;
 var rand_os____wbg_shims__NodeCrypto__random_fill_sync____wbg_randomFillSync_1b52c8482374c55b__h054169d5fc75e020 = env.__wbg_randomFillSync_1b52c8482374c55b;
 var rand_os____wbg_shims__BrowserCrypto__get_random_values____wbg_getRandomValues_1ef11e888e5228e9__ha019132b81f6681b = env.__wbg_getRandomValues_1ef11e888e5228e9;
 var wasm_bindgen____wbindgen_debug_string__haec7489361e91b07 = env.__wbindgen_debug_string;
 var wasm_bindgen____wbindgen_throw__hcf6180e87a5e875d = env.__wbindgen_throw;
 var wasm_bindgen____wbindgen_rethrow__h5656950dd1426493 = env.__wbindgen_rethrow;
 var wasm_bindgen____wbindgen_memory__he39953569aa4e74e = env.__wbindgen_memory;
 var global$0 = 1048576;
 var __wasm_intrinsics_temp_i64 = 0;
 var __wasm_intrinsics_temp_i64$hi = 0;
 var i64toi32_i32$HIGH_BITS = 0;
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__ProtocolParamUpdate___deserialize__hcf5b8de9802712c3($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$4 = 0, $31 = 0, $31$hi = 0, $32$hi = 0, $32 = 0, $30$hi = 0, $52 = 0, $47 = 0, $47$hi = 0, $15 = 0, $52$hi = 0, $30 = 0, $51 = 0, $51$hi = 0, $48 = 0, $48$hi = 0, $20 = 0, $46 = 0, $46$hi = 0, $49 = 0, $49$hi = 0, $50 = 0, $50$hi = 0, $19 = 0, $14 = 0, $53 = 0, $53$hi = 0, $356 = 0, $5 = 0, $357 = 0, $3 = 0, $6 = 0, $7 = 0, $33 = 0, $33$hi = 0, $34 = 0, $34$hi = 0, $35 = 0, $35$hi = 0, $36 = 0, $36$hi = 0, $37 = 0, $37$hi = 0, $38 = 0, $38$hi = 0, $39 = 0, $39$hi = 0, $40 = 0, $40$hi = 0, $41 = 0, $41$hi = 0, $8 = 0, $9 = 0, $42 = 0, $42$hi = 0, $43 = 0, $43$hi = 0, $10 = 0, $11 = 0, $12 = 0, $44 = 0, $44$hi = 0, $45 = 0, $45$hi = 0, $358 = 0, $359 = 0, $360 = 0, $361 = 0, $362 = 0, $363 = 0, $364 = 0, $365 = 0, $366 = 0, $367 = 0, $368 = 0, $369 = 0, $54 = 0, $54$hi = 0, $4 = 0, $13 = 0, $18 = 0, $370 = 0, $371 = 0, $372 = 0, $373 = 0, $374 = 0, $375 = 0, $376 = 0, $377 = 0, $378 = 0, $379 = 0, $380 = 0, $381 = 0, $382 = 0, $383 = 0, $384 = 0, $385 = 0, $386 = 0, $387 = 0, $388 = 0, $389 = 0, $390 = 0, $391 = 0, $394 = 0, $395 = 0, $55 = 0, $55$hi = 0, $56 = 0, $56$hi = 0, $396 = 0, $397 = 0, $398 = 0, $399 = 0, $400 = 0, $401 = 0, $402 = 0, $403 = 0, $404 = 0, $405 = 0, $406 = 0, $407 = 0, $408 = 0, $409 = 0, $410 = 0, $411 = 0, $412 = 0, $413 = 0, $414 = 0, $416 = 0, $417 = 0, $418 = 0, $420 = 0, $421 = 0, $422 = 0, $423 = 0, $424 = 0, $425 = 0, $427 = 0, $428 = 0, $429 = 0, $430 = 0, $431 = 0, $432 = 0, $433 = 0, $434 = 0, $435 = 0, $436 = 0, $437 = 0, $438 = 0, $439 = 0, $441 = 0, $442 = 0, $444 = 0, $445 = 0, $446 = 0, $447 = 0, $448 = 0, $449 = 0, $450 = 0, $451 = 0, $452 = 0, $453 = 0, $454 = 0, $455 = 0, $456 = 0, $457 = 0, $458 = 0, $459 = 0, $460 = 0, $461 = 0, $462 = 0, $463 = 0, $464 = 0, $16 = 0, $17 = 0, $148 = 0, $148$hi = 0, $151 = 0, $151$hi = 0, $155$hi = 0, $157$hi = 0, $159$hi = 0, $162 = 0, $162$hi = 0, $189 = 0, $392 = 0, $392$hi = 0, $393 = 0, $393$hi = 0, $395$hi = 0, $397$hi = 0, $415 = 0, $419 = 0, $426 = 0, $440 = 0, $443 = 0, $21 = 0, $558 = 0, $558$hi = 0, $559 = 0, $559$hi = 0, $561$hi = 0, $563$hi = 0, $581 = 0, $585 = 0, $592 = 0, $606 = 0, $609 = 0, $722 = 0, $722$hi = 0, $723 = 0, $723$hi = 0, $725$hi = 0, $727$hi = 0, $745 = 0, $749 = 0, $756 = 0, $770 = 0, $773 = 0, $837 = 0, $851 = 0, $880 = 0, $884 = 0, $891 = 0, $962 = 0, $976 = 0, $1005 = 0, $1009 = 0, $1016 = 0, $1073 = 0, $1073$hi = 0, $1077 = 0, $1077$hi = 0, $1082$hi = 0, $1084$hi = 0, $1102 = 0, $1111 = 0, $1115 = 0, $1133 = 0, $1137 = 0, $1144 = 0, $1157 = 0, $1160 = 0, $1262 = 0, $1262$hi = 0, $1263 = 0, $1263$hi = 0, $1265$hi = 0, $1267$hi = 0, $1285 = 0, $1289 = 0, $1296 = 0, $1310 = 0, $1313 = 0, $1377 = 0, $1391 = 0, $1422 = 0, $1426 = 0, $1433 = 0, $1506 = 0, $1520 = 0, $1551 = 0, $1555 = 0, $1562 = 0, $1681 = 0, $1681$hi = 0, $1682 = 0, $1682$hi = 0, $1684$hi = 0, $1686$hi = 0, $1704 = 0, $1708 = 0, $1715 = 0, $1729 = 0, $1732 = 0, $1789 = 0, $1799 = 0, $1803 = 0, $1805 = 0, $1805$hi = 0, $1808 = 0, $1808$hi = 0, $1812$hi = 0, $1814$hi = 0, $1840 = 0, $1844 = 0, $1851 = 0, $1865 = 0, $1868 = 0, $1926 = 0, $1940 = 0, $1969 = 0, $1973 = 0, $1980 = 0, $2051 = 0, $2065 = 0, $2094 = 0, $2098 = 0, $2105 = 0, $2176 = 0, $2190 = 0, $2219 = 0, $2223 = 0, $2230 = 0, $2301 = 0, $2315 = 0, $2344 = 0, $2348 = 0, $2355 = 0, $2475 = 0, $2475$hi = 0, $2476 = 0, $2476$hi = 0, $2478$hi = 0, $2480$hi = 0, $2498 = 0, $2502 = 0, $2509 = 0, $2523 = 0, $2526 = 0, $2639 = 0, $2639$hi = 0, $2640 = 0, $2640$hi = 0, $2642$hi = 0, $2644$hi = 0, $2662 = 0, $2666 = 0, $2673 = 0, $2687 = 0, $2690 = 0, $2754 = 0, $2768 = 0, $2799 = 0, $2803 = 0, $2810 = 0, $2883 = 0, $2897 = 0, $2928 = 0, $2932 = 0, $2939 = 0, $3061 = 0, $3061$hi = 0, $3062 = 0, $3062$hi = 0, $3064$hi = 0, $3066$hi = 0, $3084 = 0, $3088 = 0, $3095 = 0, $3109 = 0, $3112 = 0, $3225 = 0, $3225$hi = 0, $3226 = 0, $3226$hi = 0, $3228$hi = 0, $3230$hi = 0, $3248 = 0, $3252 = 0, $3259 = 0, $3273 = 0, $3276 = 0, $3389 = 0, $3389$hi = 0, $3390 = 0, $3390$hi = 0, $3392$hi = 0, $3394$hi = 0, $3412 = 0, $3416 = 0, $3423 = 0, $3437 = 0, $3440 = 0, $3504 = 0, $3518 = 0, $3549 = 0, $3553 = 0, $3560 = 0, $3633 = 0, $3647 = 0, $3678 = 0, $3682 = 0, $3689 = 0, $22 = 0, $23 = 0, $57 = 0, $57$hi = 0, $58 = 0, $58$hi = 0, $59 = 0, $59$hi = 0, $60 = 0, $60$hi = 0, $3753 = 0, $3758 = 0, $61 = 0, $61$hi = 0, $3791 = 0, $62 = 0, $62$hi = 0, $63 = 0, $63$hi = 0, $3821 = 0, $64 = 0, $64$hi = 0, $65 = 0, $65$hi = 0, $24 = 0, $66 = 0, $66$hi = 0, $67 = 0, $67$hi = 0, $68 = 0, $68$hi = 0, $69 = 0, $69$hi = 0, $70 = 0, $70$hi = 0, $71 = 0, $71$hi = 0, $72 = 0, $72$hi = 0, $73 = 0, $73$hi = 0, $74 = 0, $74$hi = 0, $25 = 0, $26 = 0, $75 = 0, $75$hi = 0, $76 = 0, $76$hi = 0, $27 = 0, $28 = 0, $29 = 0, $77 = 0, $77$hi = 0, $78 = 0, $78$hi = 0, $3949 = 0, $3963 = 0, $3974 = 0, $4144 = 0, $4147 = 0, $4189 = 0, $4189$hi = 0, $4191 = 0, $4191$hi = 0, $4192 = 0;
  $2 = global$0 - 272 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___map__h7c2a4e830d885a05($2 + 200 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2 + 216 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  $30$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 208 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 212 | 0) >> 2] | 0;
  $31 = i64toi32_i32$1;
  $31$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          i64toi32_i32$2 = $2;
          i64toi32_i32$0 = HEAP32[($2 + 200 | 0) >> 2] | 0;
          i64toi32_i32$1 = HEAP32[($2 + 204 | 0) >> 2] | 0;
          i64toi32_i32$2 = i64toi32_i32$0;
          i64toi32_i32$0 = 0;
          i64toi32_i32$3 = 1;
          if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
           break label$8
          }
          $3 = 0;
          HEAP32[($2 + 32 | 0) >> 2] = 0;
          HEAP32[($2 + 48 | 0) >> 2] = 0;
          i64toi32_i32$2 = $30$hi;
          $4 = $30;
          label$9 : {
           i64toi32_i32$2 = $31$hi;
           i64toi32_i32$3 = $31;
           i64toi32_i32$1 = 0;
           i64toi32_i32$0 = 1;
           if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
            break label$9
           }
           if ($4) {
            break label$9
           }
           $5 = 2;
           i64toi32_i32$3 = 0;
           $32 = 0;
           $32$hi = i64toi32_i32$3;
           $6 = 0;
           $7 = 0;
           i64toi32_i32$3 = 0;
           $33 = 0;
           $33$hi = i64toi32_i32$3;
           i64toi32_i32$3 = 0;
           $34 = 0;
           $34$hi = i64toi32_i32$3;
           i64toi32_i32$3 = 0;
           $35 = 0;
           $35$hi = i64toi32_i32$3;
           i64toi32_i32$3 = 0;
           $36 = 0;
           $36$hi = i64toi32_i32$3;
           i64toi32_i32$3 = 0;
           $37 = 0;
           $37$hi = i64toi32_i32$3;
           i64toi32_i32$3 = 0;
           $38 = 0;
           $38$hi = i64toi32_i32$3;
           i64toi32_i32$3 = 0;
           $39 = 0;
           $39$hi = i64toi32_i32$3;
           i64toi32_i32$3 = 0;
           $40 = 0;
           $40$hi = i64toi32_i32$3;
           i64toi32_i32$3 = 0;
           $41 = 0;
           $41$hi = i64toi32_i32$3;
           $8 = 0;
           $9 = 0;
           i64toi32_i32$3 = 0;
           $42 = 0;
           $42$hi = i64toi32_i32$3;
           i64toi32_i32$3 = 0;
           $43 = 0;
           $43$hi = i64toi32_i32$3;
           $10 = 0;
           $11 = 0;
           $12 = 0;
           i64toi32_i32$3 = 0;
           $44 = 0;
           $44$hi = i64toi32_i32$3;
           i64toi32_i32$3 = 0;
           $45 = 0;
           $45$hi = i64toi32_i32$3;
           break label$5;
          }
          $5 = 2;
          $13 = $2 + 64 | 0 | 2 | 0;
          $14 = $2 + 72 | 0;
          $15 = 1;
          $16 = $2 + 168 | 0 | 1 | 0;
          $17 = $2 + 200 | 0 | 1 | 0;
          $18 = $2 + 64 | 0 | 1 | 0;
          $19 = 0;
          i64toi32_i32$3 = 0;
          $46 = 0;
          $46$hi = i64toi32_i32$3;
          i64toi32_i32$3 = 0;
          $32 = 0;
          $32$hi = i64toi32_i32$3;
          i64toi32_i32$3 = 0;
          $45 = 0;
          $45$hi = i64toi32_i32$3;
          i64toi32_i32$3 = 0;
          $44 = 0;
          $44$hi = i64toi32_i32$3;
          $12 = 0;
          $11 = 0;
          $10 = 0;
          i64toi32_i32$3 = 0;
          $43 = 0;
          $43$hi = i64toi32_i32$3;
          i64toi32_i32$3 = 0;
          $42 = 0;
          $42$hi = i64toi32_i32$3;
          $9 = 0;
          $8 = 0;
          i64toi32_i32$3 = 0;
          $41 = 0;
          $41$hi = i64toi32_i32$3;
          i64toi32_i32$3 = 0;
          $40 = 0;
          $40$hi = i64toi32_i32$3;
          i64toi32_i32$3 = 0;
          $39 = 0;
          $39$hi = i64toi32_i32$3;
          i64toi32_i32$3 = 0;
          $38 = 0;
          $38$hi = i64toi32_i32$3;
          i64toi32_i32$3 = 0;
          $37 = 0;
          $37$hi = i64toi32_i32$3;
          i64toi32_i32$3 = 0;
          $36 = 0;
          $36$hi = i64toi32_i32$3;
          i64toi32_i32$3 = 0;
          $35 = 0;
          $35$hi = i64toi32_i32$3;
          i64toi32_i32$3 = 0;
          $34 = 0;
          $34$hi = i64toi32_i32$3;
          i64toi32_i32$3 = 0;
          $33 = 0;
          $33$hi = i64toi32_i32$3;
          $7 = 0;
          $6 = 0;
          $3 = 0;
          label$10 : while (1) {
           $20 = $15;
           std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 16 | 0 | 0, $1 | 0);
           i64toi32_i32$3 = 0;
           $47 = 2;
           $47$hi = i64toi32_i32$3;
           label$11 : {
            if (HEAP32[($2 + 20 | 0) >> 2] | 0) {
             break label$11
            }
            i64toi32_i32$3 = 0;
            $48 = 8;
            $48$hi = i64toi32_i32$3;
            break label$6;
           }
           label$12 : {
            $15 = ($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[($2 + 16 | 0) >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0;
            if (!$15) {
             break label$12
            }
            label$13 : {
             switch ($15 + -3 | 0 | 0) {
             default:
              i64toi32_i32$3 = 0;
              i64toi32_i32$0 = $15;
              i64toi32_i32$2 = 0;
              i64toi32_i32$1 = 8;
              i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
              if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
               i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
               $370 = 0;
              } else {
               i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$4 | 0) | 0;
               $370 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
              }
              $46 = $370;
              $46$hi = i64toi32_i32$2;
              i64toi32_i32$3 = $46;
              i64toi32_i32$0 = 0;
              i64toi32_i32$1 = 17;
              i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
              $47 = i64toi32_i32$3 | i64toi32_i32$1 | 0;
              $47$hi = i64toi32_i32$0;
              break label$4;
             case 4:
              label$16 : {
               i64toi32_i32$0 = $31$hi;
               i64toi32_i32$2 = $31;
               i64toi32_i32$3 = 0;
               i64toi32_i32$1 = 1;
               if ((i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$3 | 0) | 0) {
                break label$16
               }
               i64toi32_i32$2 = 0;
               $47 = 1;
               $47$hi = i64toi32_i32$2;
               break label$4;
              }
              cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 200 | 0 | 0, $1 | 0);
              $1 = HEAPU8[($2 + 208 | 0) >> 0] | 0;
              label$17 : {
               i64toi32_i32$1 = $2;
               i64toi32_i32$2 = HEAP32[($2 + 200 | 0) >> 2] | 0;
               i64toi32_i32$0 = HEAP32[($2 + 204 | 0) >> 2] | 0;
               i64toi32_i32$1 = i64toi32_i32$2;
               i64toi32_i32$2 = 0;
               i64toi32_i32$3 = 1;
               if ((i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) | 0) {
                break label$17
               }
               if (($1 & 255 | 0 | 0) == (5 | 0)) {
                break label$3
               }
               i64toi32_i32$1 = 0;
               $47 = 5;
               $47$hi = i64toi32_i32$1;
               break label$4;
              }
              i64toi32_i32$3 = $2;
              i64toi32_i32$1 = HEAPU8[($2 + 209 | 0) >> 0] | 0 | ((HEAPU8[($2 + 210 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 211 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 212 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              i64toi32_i32$0 = 0;
              $148 = i64toi32_i32$1;
              $148$hi = i64toi32_i32$0;
              i64toi32_i32$3 = $2 + 213 | 0;
              i64toi32_i32$0 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
              i64toi32_i32$1 = 0;
              $151 = i64toi32_i32$0;
              $151$hi = i64toi32_i32$1;
              i64toi32_i32$3 = $2 + 215 | 0;
              i64toi32_i32$1 = HEAPU8[i64toi32_i32$3 >> 0] | 0;
              i64toi32_i32$0 = 0;
              i64toi32_i32$3 = i64toi32_i32$1;
              i64toi32_i32$1 = 0;
              i64toi32_i32$2 = 16;
              i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
              if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
               i64toi32_i32$1 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
               $371 = 0;
              } else {
               i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
               $371 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
              }
              $155$hi = i64toi32_i32$1;
              i64toi32_i32$1 = $151$hi;
              i64toi32_i32$0 = $151;
              i64toi32_i32$3 = $155$hi;
              i64toi32_i32$2 = $371;
              i64toi32_i32$3 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
              i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
              i64toi32_i32$0 = 0;
              i64toi32_i32$2 = 32;
              i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
              if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
               i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
               $372 = 0;
              } else {
               i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$4 | 0) | 0;
               $372 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
              }
              $157$hi = i64toi32_i32$0;
              i64toi32_i32$0 = $148$hi;
              i64toi32_i32$3 = $148;
              i64toi32_i32$1 = $157$hi;
              i64toi32_i32$2 = $372;
              i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
              i64toi32_i32$0 = i64toi32_i32$3 | i64toi32_i32$2 | 0;
              i64toi32_i32$3 = 0;
              i64toi32_i32$2 = 8;
              i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
              if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
               i64toi32_i32$3 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
               $373 = 0;
              } else {
               i64toi32_i32$3 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
               $373 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
              }
              $159$hi = i64toi32_i32$3;
              i64toi32_i32$3 = 0;
              i64toi32_i32$1 = $1;
              i64toi32_i32$0 = 0;
              i64toi32_i32$2 = 255;
              i64toi32_i32$0 = i64toi32_i32$3 & i64toi32_i32$0 | 0;
              $162 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
              $162$hi = i64toi32_i32$0;
              i64toi32_i32$0 = $159$hi;
              i64toi32_i32$3 = $373;
              i64toi32_i32$1 = $162$hi;
              i64toi32_i32$2 = $162;
              i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
              $48 = i64toi32_i32$3 | i64toi32_i32$2 | 0;
              $48$hi = i64toi32_i32$1;
              i64toi32_i32$0 = $2 + 240 | 0;
              i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
              i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
              $49 = i64toi32_i32$1;
              $49$hi = i64toi32_i32$3;
              i64toi32_i32$0 = $2 + 232 | 0;
              i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
              i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
              $50 = i64toi32_i32$3;
              $50$hi = i64toi32_i32$1;
              i64toi32_i32$0 = $2 + 224 | 0;
              i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
              i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
              $32 = i64toi32_i32$1;
              $32$hi = i64toi32_i32$3;
              i64toi32_i32$0 = $2 + 216 | 0;
              i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
              i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
              $51 = i64toi32_i32$3;
              $51$hi = i64toi32_i32$1;
              break label$4;
             case 0:
              break label$13;
             };
            }
            cbor_event__de__Deserializer_R___text__h764f26557f652908($2 + 200 | 0 | 0, $1 | 0);
            label$18 : {
             if ((HEAP32[($2 + 200 | 0) >> 2] | 0 | 0) == (1 | 0)) {
              break label$18
             }
             HEAP32[($2 + 64 | 0) >> 2] = HEAP32[($2 + 204 | 0) >> 2] | 0;
             $1 = $2 + 208 | 0;
             i64toi32_i32$0 = $1;
             i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
             i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
             $189 = i64toi32_i32$1;
             i64toi32_i32$1 = $2;
             HEAP32[($2 + 68 | 0) >> 2] = $189;
             HEAP32[($2 + 72 | 0) >> 2] = i64toi32_i32$3;
             $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $2 + 64 | 0 | 0);
             alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($2 + 212 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
             HEAP32[i64toi32_i32$0 >> 2] = 0;
             HEAP8[($2 + 200 | 0) >> 0] = 16;
             i64toi32_i32$0 = $2;
             i64toi32_i32$3 = HEAP32[($2 + 200 | 0) >> 2] | 0;
             i64toi32_i32$1 = HEAP32[($2 + 204 | 0) >> 2] | 0;
             $47 = i64toi32_i32$3;
             $47$hi = i64toi32_i32$1;
             i64toi32_i32$0 = i64toi32_i32$3;
             i64toi32_i32$3 = -1;
             i64toi32_i32$2 = -256;
             i64toi32_i32$3 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
             $46 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
             $46$hi = i64toi32_i32$3;
             i64toi32_i32$1 = $2 + 224 | 0;
             i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
             i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
             $32 = i64toi32_i32$3;
             $32$hi = i64toi32_i32$0;
             i64toi32_i32$1 = $2 + 232 | 0;
             i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
             i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
             $50 = i64toi32_i32$0;
             $50$hi = i64toi32_i32$3;
             i64toi32_i32$1 = $2 + 240 | 0;
             i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
             i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
             $49 = i64toi32_i32$3;
             $49$hi = i64toi32_i32$0;
             i64toi32_i32$1 = $1;
             i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
             i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
             $48 = i64toi32_i32$0;
             $48$hi = i64toi32_i32$3;
             i64toi32_i32$1 = ($2 + 200 | 0) + 16 | 0;
             i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
             i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
             $51 = i64toi32_i32$3;
             $51$hi = i64toi32_i32$0;
             $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 64 | 0 | 0);
             $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 64 | 0 | 0);
             break label$4;
            }
            i64toi32_i32$1 = $2 + 240 | 0;
            i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
            i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
            $49 = i64toi32_i32$0;
            $49$hi = i64toi32_i32$3;
            i64toi32_i32$1 = $2 + 232 | 0;
            i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
            i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
            $50 = i64toi32_i32$3;
            $50$hi = i64toi32_i32$0;
            i64toi32_i32$1 = $2 + 224 | 0;
            i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
            i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
            $32 = i64toi32_i32$0;
            $32$hi = i64toi32_i32$3;
            i64toi32_i32$1 = $2 + 216 | 0;
            i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
            i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
            $51 = i64toi32_i32$3;
            $51$hi = i64toi32_i32$0;
            i64toi32_i32$1 = $2 + 208 | 0;
            i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
            i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
            $48 = i64toi32_i32$0;
            $48$hi = i64toi32_i32$3;
            i64toi32_i32$3 = 0;
            $47 = 2;
            $47$hi = i64toi32_i32$3;
            i64toi32_i32$3 = 0;
            $46 = 0;
            $46$hi = i64toi32_i32$3;
            break label$4;
           }
           cbor_event__de__Deserializer_R___unsigned_integer__h1ed99c0b7fe7eea1($2 + 200 | 0 | 0, $1 | 0);
           i64toi32_i32$1 = $2;
           i64toi32_i32$3 = HEAP32[($2 + 208 | 0) >> 2] | 0;
           i64toi32_i32$0 = HEAP32[($2 + 212 | 0) >> 2] | 0;
           $52 = i64toi32_i32$3;
           $52$hi = i64toi32_i32$0;
           label$19 : {
            label$20 : {
             label$21 : {
              label$22 : {
               label$23 : {
                label$24 : {
                 label$25 : {
                  label$26 : {
                   label$27 : {
                    label$28 : {
                     label$29 : {
                      label$30 : {
                       label$31 : {
                        label$32 : {
                         label$33 : {
                          label$34 : {
                           label$35 : {
                            label$36 : {
                             label$37 : {
                              label$38 : {
                               label$39 : {
                                label$40 : {
                                 label$41 : {
                                  label$42 : {
                                   label$43 : {
                                    label$44 : {
                                     label$45 : {
                                      label$46 : {
                                       label$47 : {
                                        label$48 : {
                                         label$49 : {
                                          label$50 : {
                                           label$51 : {
                                            label$52 : {
                                             label$53 : {
                                              label$54 : {
                                               label$55 : {
                                                label$56 : {
                                                 label$57 : {
                                                  label$58 : {
                                                   label$59 : {
                                                    label$60 : {
                                                     label$61 : {
                                                      label$62 : {
                                                       label$63 : {
                                                        label$64 : {
                                                         label$65 : {
                                                          label$66 : {
                                                           label$67 : {
                                                            label$68 : {
                                                             label$69 : {
                                                              label$70 : {
                                                               label$71 : {
                                                                label$72 : {
                                                                 label$73 : {
                                                                  label$74 : {
                                                                   label$75 : {
                                                                    label$76 : {
                                                                     label$77 : {
                                                                      label$78 : {
                                                                       label$79 : {
                                                                        label$80 : {
                                                                         label$81 : {
                                                                          label$82 : {
                                                                           label$83 : {
                                                                            label$84 : {
                                                                             label$85 : {
                                                                              label$86 : {
                                                                               label$87 : {
                                                                                label$88 : {
                                                                                 label$89 : {
                                                                                  label$90 : {
                                                                                   i64toi32_i32$1 = $2;
                                                                                   i64toi32_i32$0 = HEAP32[($2 + 200 | 0) >> 2] | 0;
                                                                                   i64toi32_i32$3 = HEAP32[($2 + 204 | 0) >> 2] | 0;
                                                                                   i64toi32_i32$1 = i64toi32_i32$0;
                                                                                   i64toi32_i32$0 = 0;
                                                                                   i64toi32_i32$2 = 1;
                                                                                   if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) | 0) {
                                                                                    break label$90
                                                                                   }
                                                                                   i64toi32_i32$1 = 0;
                                                                                   $48 = 1;
                                                                                   $48$hi = i64toi32_i32$1;
                                                                                   i64toi32_i32$1 = 0;
                                                                                   $47 = 16;
                                                                                   $47$hi = i64toi32_i32$1;
                                                                                   label$91 : {
                                                                                    i64toi32_i32$1 = $52$hi;
                                                                                    i64toi32_i32$2 = $52;
                                                                                    i64toi32_i32$3 = 0;
                                                                                    i64toi32_i32$0 = 24;
                                                                                    if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$2 >>> 0 <= i64toi32_i32$0 >>> 0 | 0) | 0) {
                                                                                     break label$91
                                                                                    }
                                                                                    i64toi32_i32$2 = $52$hi;
                                                                                    $51 = $52;
                                                                                    $51$hi = i64toi32_i32$2;
                                                                                    break label$4;
                                                                                   }
                                                                                   i64toi32_i32$2 = $52$hi;
                                                                                   $51 = $52;
                                                                                   $51$hi = i64toi32_i32$2;
                                                                                   switch ($52 | 0) {
                                                                                   case 15:
                                                                                    break label$4;
                                                                                   case 24:
                                                                                    break label$66;
                                                                                   case 23:
                                                                                    break label$67;
                                                                                   case 22:
                                                                                    break label$68;
                                                                                   case 21:
                                                                                    break label$69;
                                                                                   case 20:
                                                                                    break label$70;
                                                                                   case 19:
                                                                                    break label$71;
                                                                                   case 18:
                                                                                    break label$72;
                                                                                   case 17:
                                                                                    break label$73;
                                                                                   case 16:
                                                                                    break label$74;
                                                                                   case 14:
                                                                                    break label$75;
                                                                                   case 13:
                                                                                    break label$76;
                                                                                   case 12:
                                                                                    break label$77;
                                                                                   case 11:
                                                                                    break label$78;
                                                                                   case 10:
                                                                                    break label$79;
                                                                                   case 9:
                                                                                    break label$80;
                                                                                   case 8:
                                                                                    break label$81;
                                                                                   case 7:
                                                                                    break label$82;
                                                                                   case 6:
                                                                                    break label$83;
                                                                                   case 5:
                                                                                    break label$84;
                                                                                   case 4:
                                                                                    break label$85;
                                                                                   case 3:
                                                                                    break label$86;
                                                                                   case 2:
                                                                                    break label$87;
                                                                                   case 1:
                                                                                    break label$88;
                                                                                   default:
                                                                                    break label$89;
                                                                                   };
                                                                                  }
                                                                                  i64toi32_i32$0 = $2 + 240 | 0;
                                                                                  i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                                                  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                                                  $49 = i64toi32_i32$2;
                                                                                  $49$hi = i64toi32_i32$1;
                                                                                  i64toi32_i32$0 = $2 + 232 | 0;
                                                                                  i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                                                  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                                                  $50 = i64toi32_i32$1;
                                                                                  $50$hi = i64toi32_i32$2;
                                                                                  i64toi32_i32$0 = $2 + 224 | 0;
                                                                                  i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                                                  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                                                  $32 = i64toi32_i32$2;
                                                                                  $32$hi = i64toi32_i32$1;
                                                                                  i64toi32_i32$0 = $2 + 216 | 0;
                                                                                  i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                                                  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                                                  $51 = i64toi32_i32$1;
                                                                                  $51$hi = i64toi32_i32$2;
                                                                                  i64toi32_i32$2 = $52$hi;
                                                                                  $48 = $52;
                                                                                  $48$hi = i64toi32_i32$2;
                                                                                  break label$4;
                                                                                 }
                                                                                 i64toi32_i32$2 = 0;
                                                                                 $48 = 1;
                                                                                 $48$hi = i64toi32_i32$2;
                                                                                 i64toi32_i32$2 = $45$hi;
                                                                                 i64toi32_i32$0 = $45;
                                                                                 i64toi32_i32$1 = 0;
                                                                                 i64toi32_i32$3 = 1;
                                                                                 if ((i64toi32_i32$0 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
                                                                                  break label$43
                                                                                 }
                                                                                 i64toi32_i32$0 = 0;
                                                                                 $47 = 4;
                                                                                 $47$hi = i64toi32_i32$0;
                                                                                 break label$6;
                                                                                }
                                                                                i64toi32_i32$0 = 0;
                                                                                $51 = 1;
                                                                                $51$hi = i64toi32_i32$0;
                                                                                i64toi32_i32$0 = $44$hi;
                                                                                i64toi32_i32$3 = $44;
                                                                                i64toi32_i32$2 = 0;
                                                                                i64toi32_i32$1 = 1;
                                                                                if ((i64toi32_i32$3 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$2 | 0) | 0) {
                                                                                 break label$44
                                                                                }
                                                                                i64toi32_i32$3 = 0;
                                                                                $47 = 4;
                                                                                $47$hi = i64toi32_i32$3;
                                                                                i64toi32_i32$3 = 0;
                                                                                $48 = 1;
                                                                                $48$hi = i64toi32_i32$3;
                                                                                break label$4;
                                                                               }
                                                                               if (($12 | 0) != (1 | 0)) {
                                                                                break label$45
                                                                               }
                                                                               i64toi32_i32$3 = 0;
                                                                               $51 = 2;
                                                                               $51$hi = i64toi32_i32$3;
                                                                               break label$7;
                                                                              }
                                                                              if (($11 | 0) != (1 | 0)) {
                                                                               break label$46
                                                                              }
                                                                              i64toi32_i32$3 = 0;
                                                                              $51 = 3;
                                                                              $51$hi = i64toi32_i32$3;
                                                                              break label$7;
                                                                             }
                                                                             if (($10 | 0) != (1 | 0)) {
                                                                              break label$47
                                                                             }
                                                                             i64toi32_i32$3 = 0;
                                                                             $47 = 4;
                                                                             $47$hi = i64toi32_i32$3;
                                                                             i64toi32_i32$3 = 0;
                                                                             $51 = 4;
                                                                             $51$hi = i64toi32_i32$3;
                                                                             break label$4;
                                                                            }
                                                                            i64toi32_i32$3 = 0;
                                                                            $48 = 1;
                                                                            $48$hi = i64toi32_i32$3;
                                                                            i64toi32_i32$3 = $43$hi;
                                                                            i64toi32_i32$1 = $43;
                                                                            i64toi32_i32$0 = 0;
                                                                            i64toi32_i32$2 = 1;
                                                                            if ((i64toi32_i32$1 | 0) != (i64toi32_i32$2 | 0) | (i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | 0) {
                                                                             break label$48
                                                                            }
                                                                            i64toi32_i32$1 = 0;
                                                                            $51 = 5;
                                                                            $51$hi = i64toi32_i32$1;
                                                                            break label$7;
                                                                           }
                                                                           i64toi32_i32$1 = 0;
                                                                           $48 = 1;
                                                                           $48$hi = i64toi32_i32$1;
                                                                           i64toi32_i32$1 = $42$hi;
                                                                           i64toi32_i32$2 = $42;
                                                                           i64toi32_i32$3 = 0;
                                                                           i64toi32_i32$0 = 1;
                                                                           if ((i64toi32_i32$2 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$3 | 0) | 0) {
                                                                            break label$49
                                                                           }
                                                                           i64toi32_i32$2 = 0;
                                                                           $51 = 6;
                                                                           $51$hi = i64toi32_i32$2;
                                                                           break label$7;
                                                                          }
                                                                          if (($9 | 0) != (1 | 0)) {
                                                                           break label$50
                                                                          }
                                                                          i64toi32_i32$2 = 0;
                                                                          $51 = 7;
                                                                          $51$hi = i64toi32_i32$2;
                                                                          break label$7;
                                                                         }
                                                                         if (($8 | 0) != (1 | 0)) {
                                                                          break label$51
                                                                         }
                                                                         i64toi32_i32$2 = 0;
                                                                         $51 = 8;
                                                                         $51$hi = i64toi32_i32$2;
                                                                         break label$7;
                                                                        }
                                                                        i64toi32_i32$2 = 0;
                                                                        $48 = 1;
                                                                        $48$hi = i64toi32_i32$2;
                                                                        i64toi32_i32$2 = $41$hi;
                                                                        i64toi32_i32$0 = $41;
                                                                        i64toi32_i32$1 = 0;
                                                                        i64toi32_i32$3 = 1;
                                                                        if ((i64toi32_i32$0 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
                                                                         break label$52
                                                                        }
                                                                        i64toi32_i32$0 = 0;
                                                                        $51 = 9;
                                                                        $51$hi = i64toi32_i32$0;
                                                                        break label$7;
                                                                       }
                                                                       i64toi32_i32$0 = 0;
                                                                       $48 = 1;
                                                                       $48$hi = i64toi32_i32$0;
                                                                       i64toi32_i32$0 = $40$hi;
                                                                       i64toi32_i32$3 = $40;
                                                                       i64toi32_i32$2 = 0;
                                                                       i64toi32_i32$1 = 1;
                                                                       if ((i64toi32_i32$3 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$2 | 0) | 0) {
                                                                        break label$53
                                                                       }
                                                                       i64toi32_i32$3 = 0;
                                                                       $51 = 10;
                                                                       $51$hi = i64toi32_i32$3;
                                                                       break label$7;
                                                                      }
                                                                      i64toi32_i32$3 = 0;
                                                                      $48 = 1;
                                                                      $48$hi = i64toi32_i32$3;
                                                                      i64toi32_i32$3 = $39$hi;
                                                                      i64toi32_i32$1 = $39;
                                                                      i64toi32_i32$0 = 0;
                                                                      i64toi32_i32$2 = 1;
                                                                      if ((i64toi32_i32$1 | 0) != (i64toi32_i32$2 | 0) | (i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | 0) {
                                                                       break label$54
                                                                      }
                                                                      i64toi32_i32$1 = 0;
                                                                      $51 = 11;
                                                                      $51$hi = i64toi32_i32$1;
                                                                      break label$7;
                                                                     }
                                                                     i64toi32_i32$1 = 0;
                                                                     $48 = 1;
                                                                     $48$hi = i64toi32_i32$1;
                                                                     i64toi32_i32$1 = $38$hi;
                                                                     i64toi32_i32$2 = $38;
                                                                     i64toi32_i32$3 = 0;
                                                                     i64toi32_i32$0 = 1;
                                                                     if ((i64toi32_i32$2 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$3 | 0) | 0) {
                                                                      break label$55
                                                                     }
                                                                     i64toi32_i32$2 = 0;
                                                                     $51 = 12;
                                                                     $51$hi = i64toi32_i32$2;
                                                                     break label$7;
                                                                    }
                                                                    if (($5 & 255 | 0 | 0) == (2 | 0)) {
                                                                     break label$56
                                                                    }
                                                                    i64toi32_i32$2 = 0;
                                                                    $51 = 13;
                                                                    $51$hi = i64toi32_i32$2;
                                                                    break label$7;
                                                                   }
                                                                   if (!(HEAP32[($2 + 32 | 0) >> 2] | 0)) {
                                                                    break label$57
                                                                   }
                                                                   i64toi32_i32$2 = 0;
                                                                   $51 = 14;
                                                                   $51$hi = i64toi32_i32$2;
                                                                   break label$7;
                                                                  }
                                                                  i64toi32_i32$2 = 0;
                                                                  $48 = 1;
                                                                  $48$hi = i64toi32_i32$2;
                                                                  i64toi32_i32$2 = $37$hi;
                                                                  i64toi32_i32$0 = $37;
                                                                  i64toi32_i32$1 = 0;
                                                                  i64toi32_i32$3 = 1;
                                                                  if ((i64toi32_i32$0 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
                                                                   break label$58
                                                                  }
                                                                  i64toi32_i32$0 = 0;
                                                                  $51 = 16;
                                                                  $51$hi = i64toi32_i32$0;
                                                                  break label$7;
                                                                 }
                                                                 i64toi32_i32$0 = 0;
                                                                 $48 = 1;
                                                                 $48$hi = i64toi32_i32$0;
                                                                 i64toi32_i32$0 = $36$hi;
                                                                 i64toi32_i32$3 = $36;
                                                                 i64toi32_i32$2 = 0;
                                                                 i64toi32_i32$1 = 1;
                                                                 if ((i64toi32_i32$3 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$2 | 0) | 0) {
                                                                  break label$59
                                                                 }
                                                                 i64toi32_i32$3 = 0;
                                                                 $51 = 17;
                                                                 $51$hi = i64toi32_i32$3;
                                                                 break label$7;
                                                                }
                                                                if ((HEAP32[($2 + 48 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                                                                 break label$60
                                                                }
                                                                i64toi32_i32$3 = 0;
                                                                $51 = 18;
                                                                $51$hi = i64toi32_i32$3;
                                                                break label$7;
                                                               }
                                                               i64toi32_i32$3 = 0;
                                                               $48 = 1;
                                                               $48$hi = i64toi32_i32$3;
                                                               i64toi32_i32$3 = $35$hi;
                                                               i64toi32_i32$1 = $35;
                                                               i64toi32_i32$0 = 0;
                                                               i64toi32_i32$2 = 1;
                                                               if ((i64toi32_i32$1 | 0) != (i64toi32_i32$2 | 0) | (i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | 0) {
                                                                break label$61
                                                               }
                                                               i64toi32_i32$1 = 0;
                                                               $51 = 19;
                                                               $51$hi = i64toi32_i32$1;
                                                               break label$7;
                                                              }
                                                              i64toi32_i32$1 = 0;
                                                              $48 = 1;
                                                              $48$hi = i64toi32_i32$1;
                                                              i64toi32_i32$1 = $34$hi;
                                                              i64toi32_i32$2 = $34;
                                                              i64toi32_i32$3 = 0;
                                                              i64toi32_i32$0 = 1;
                                                              if ((i64toi32_i32$2 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$3 | 0) | 0) {
                                                               break label$62
                                                              }
                                                              i64toi32_i32$2 = 0;
                                                              $51 = 20;
                                                              $51$hi = i64toi32_i32$2;
                                                              break label$7;
                                                             }
                                                             i64toi32_i32$2 = 0;
                                                             $48 = 1;
                                                             $48$hi = i64toi32_i32$2;
                                                             i64toi32_i32$2 = $33$hi;
                                                             i64toi32_i32$0 = $33;
                                                             i64toi32_i32$1 = 0;
                                                             i64toi32_i32$3 = 1;
                                                             if ((i64toi32_i32$0 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
                                                              break label$63
                                                             }
                                                             i64toi32_i32$0 = 0;
                                                             $51 = 21;
                                                             $51$hi = i64toi32_i32$0;
                                                             break label$7;
                                                            }
                                                            if (($7 | 0) != (1 | 0)) {
                                                             break label$64
                                                            }
                                                            i64toi32_i32$0 = 0;
                                                            $51 = 22;
                                                            $51$hi = i64toi32_i32$0;
                                                            break label$7;
                                                           }
                                                           if (($6 | 0) != (1 | 0)) {
                                                            break label$65
                                                           }
                                                           i64toi32_i32$0 = 0;
                                                           $51 = 23;
                                                           $51$hi = i64toi32_i32$0;
                                                           break label$7;
                                                          }
                                                          label$92 : {
                                                           if (($3 | 0) != (1 | 0)) {
                                                            break label$92
                                                           }
                                                           i64toi32_i32$0 = 0;
                                                           $51 = 24;
                                                           $51$hi = i64toi32_i32$0;
                                                           break label$7;
                                                          }
                                                          label$93 : {
                                                           label$94 : {
                                                            label$95 : {
                                                             i64toi32_i32$0 = $31$hi;
                                                             i64toi32_i32$3 = $31;
                                                             i64toi32_i32$2 = 0;
                                                             i64toi32_i32$1 = 1;
                                                             if ((i64toi32_i32$3 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$2 | 0) | 0) {
                                                              break label$95
                                                             }
                                                             i64toi32_i32$3 = $32$hi;
                                                             i64toi32_i32$1 = $32;
                                                             i64toi32_i32$0 = 0;
                                                             i64toi32_i32$2 = 1;
                                                             i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
                                                             i64toi32_i32$5 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
                                                             if (i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0) {
                                                              i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
                                                             }
                                                             $32 = i64toi32_i32$4;
                                                             $32$hi = i64toi32_i32$5;
                                                             i64toi32_i32$5 = $30$hi;
                                                             i64toi32_i32$5 = $32$hi;
                                                             i64toi32_i32$3 = i64toi32_i32$4;
                                                             i64toi32_i32$1 = $30$hi;
                                                             i64toi32_i32$2 = $30;
                                                             if (i64toi32_i32$5 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$3 >>> 0 <= i64toi32_i32$2 >>> 0 | 0) | 0) {
                                                              break label$95
                                                             }
                                                             i64toi32_i32$3 = 0;
                                                             $52 = 0;
                                                             $52$hi = i64toi32_i32$3;
                                                             $1 = 3;
                                                             $15 = 0;
                                                             break label$94;
                                                            }
                                                            $T_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hf422f9333a8bbafa($2 + 200 | 0 | 0, $1 | 0);
                                                            $3 = 1;
                                                            if ((HEAP32[($2 + 200 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                                                             break label$93
                                                            }
                                                            i64toi32_i32$2 = $2 + 248 | 0;
                                                            i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                                            i64toi32_i32$5 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                                            $31 = i64toi32_i32$3;
                                                            $31$hi = i64toi32_i32$5;
                                                            i64toi32_i32$3 = ($2 + 184 | 0) + 8 | 0;
                                                            HEAP32[i64toi32_i32$3 >> 2] = $31;
                                                            HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
                                                            $20 = HEAP32[($2 + 268 | 0) >> 2] | 0;
                                                            HEAP32[(($2 + 168 | 0) + 8 | 0) >> 2] = $20;
                                                            i64toi32_i32$3 = ($2 + 152 | 0) + 8 | 0;
                                                            HEAP32[i64toi32_i32$3 >> 2] = $31;
                                                            HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
                                                            i64toi32_i32$2 = $2 + 240 | 0;
                                                            i64toi32_i32$5 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                                            i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                                            $31 = i64toi32_i32$5;
                                                            $31$hi = i64toi32_i32$3;
                                                            i64toi32_i32$5 = $2;
                                                            HEAP32[($2 + 184 | 0) >> 2] = $31;
                                                            HEAP32[($2 + 188 | 0) >> 2] = i64toi32_i32$3;
                                                            i64toi32_i32$2 = $2 + 260 | 0;
                                                            i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                                            i64toi32_i32$5 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                                            $32 = i64toi32_i32$3;
                                                            $32$hi = i64toi32_i32$5;
                                                            i64toi32_i32$3 = $2;
                                                            HEAP32[($2 + 168 | 0) >> 2] = $32;
                                                            HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$5;
                                                            i64toi32_i32$5 = $31$hi;
                                                            i64toi32_i32$3 = $2;
                                                            HEAP32[($2 + 152 | 0) >> 2] = $31;
                                                            HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$5;
                                                            i64toi32_i32$2 = $2 + 232 | 0;
                                                            i64toi32_i32$5 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                                            i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                                            $47 = i64toi32_i32$5;
                                                            $47$hi = i64toi32_i32$3;
                                                            i64toi32_i32$2 = $2 + 224 | 0;
                                                            i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                                            i64toi32_i32$5 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                                            $52 = i64toi32_i32$3;
                                                            $52$hi = i64toi32_i32$5;
                                                            i64toi32_i32$2 = $2 + 216 | 0;
                                                            i64toi32_i32$5 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                                            i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                                            $30 = i64toi32_i32$5;
                                                            $30$hi = i64toi32_i32$3;
                                                            $1 = HEAPU8[(($2 + 200 | 0) + 8 | 0) >> 0] | 0;
                                                            $15 = HEAP32[($2 + 256 | 0) >> 2] | 0;
                                                            i64toi32_i32$2 = $2 + 209 | 0;
                                                            i64toi32_i32$3 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                                            i64toi32_i32$5 = 0;
                                                            $31 = i64toi32_i32$3;
                                                            $31$hi = i64toi32_i32$5;
                                                            i64toi32_i32$2 = $2 + 213 | 0;
                                                            i64toi32_i32$5 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
                                                            i64toi32_i32$3 = 0;
                                                            $48 = i64toi32_i32$5;
                                                            $48$hi = i64toi32_i32$3;
                                                            i64toi32_i32$2 = $2 + 215 | 0;
                                                            i64toi32_i32$3 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
                                                            i64toi32_i32$5 = 0;
                                                            $51 = i64toi32_i32$3;
                                                            $51$hi = i64toi32_i32$5;
                                                            HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] = $20;
                                                            i64toi32_i32$5 = $32$hi;
                                                            i64toi32_i32$3 = $2;
                                                            HEAP32[($2 + 136 | 0) >> 2] = $32;
                                                            HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$5;
                                                            i64toi32_i32$5 = $31$hi;
                                                            $392 = $31;
                                                            $392$hi = i64toi32_i32$5;
                                                            i64toi32_i32$5 = $48$hi;
                                                            $393 = $48;
                                                            $393$hi = i64toi32_i32$5;
                                                            i64toi32_i32$5 = $51$hi;
                                                            i64toi32_i32$2 = $51;
                                                            i64toi32_i32$3 = 0;
                                                            i64toi32_i32$1 = 16;
                                                            i64toi32_i32$0 = i64toi32_i32$1 & 31 | 0;
                                                            if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                                                             i64toi32_i32$3 = i64toi32_i32$2 << i64toi32_i32$0 | 0;
                                                             $374 = 0;
                                                            } else {
                                                             i64toi32_i32$3 = ((1 << i64toi32_i32$0 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$0 | 0) | 0) | 0 | (i64toi32_i32$5 << i64toi32_i32$0 | 0) | 0;
                                                             $374 = i64toi32_i32$2 << i64toi32_i32$0 | 0;
                                                            }
                                                            $395$hi = i64toi32_i32$3;
                                                            i64toi32_i32$3 = $393$hi;
                                                            i64toi32_i32$5 = $393;
                                                            i64toi32_i32$2 = $395$hi;
                                                            i64toi32_i32$1 = $374;
                                                            i64toi32_i32$2 = i64toi32_i32$3 | i64toi32_i32$2 | 0;
                                                            i64toi32_i32$3 = i64toi32_i32$5 | i64toi32_i32$1 | 0;
                                                            i64toi32_i32$5 = 0;
                                                            i64toi32_i32$1 = 32;
                                                            i64toi32_i32$0 = i64toi32_i32$1 & 31 | 0;
                                                            if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                                                             i64toi32_i32$5 = i64toi32_i32$3 << i64toi32_i32$0 | 0;
                                                             $375 = 0;
                                                            } else {
                                                             i64toi32_i32$5 = ((1 << i64toi32_i32$0 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$0 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$0 | 0) | 0;
                                                             $375 = i64toi32_i32$3 << i64toi32_i32$0 | 0;
                                                            }
                                                            $397$hi = i64toi32_i32$5;
                                                            i64toi32_i32$5 = $392$hi;
                                                            i64toi32_i32$2 = $392;
                                                            i64toi32_i32$3 = $397$hi;
                                                            i64toi32_i32$1 = $375;
                                                            i64toi32_i32$3 = i64toi32_i32$5 | i64toi32_i32$3 | 0;
                                                            $31 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
                                                            $31$hi = i64toi32_i32$3;
                                                           }
                                                           i64toi32_i32$3 = $47$hi;
                                                           i64toi32_i32$2 = ($2 + 200 | 0) + 24 | 0;
                                                           HEAP32[i64toi32_i32$2 >> 2] = $47;
                                                           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                                                           i64toi32_i32$3 = $52$hi;
                                                           i64toi32_i32$2 = ($2 + 200 | 0) + 16 | 0;
                                                           HEAP32[i64toi32_i32$2 >> 2] = $52;
                                                           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                                                           i64toi32_i32$3 = $30$hi;
                                                           i64toi32_i32$2 = ($2 + 200 | 0) + 8 | 0;
                                                           HEAP32[i64toi32_i32$2 >> 2] = $30;
                                                           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                                                           i64toi32_i32$5 = $2;
                                                           i64toi32_i32$3 = HEAP32[($2 + 152 | 0) >> 2] | 0;
                                                           i64toi32_i32$2 = HEAP32[($2 + 156 | 0) >> 2] | 0;
                                                           $415 = i64toi32_i32$3;
                                                           i64toi32_i32$3 = ($2 + 200 | 0) + 32 | 0;
                                                           HEAP32[i64toi32_i32$3 >> 2] = $415;
                                                           HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                                                           i64toi32_i32$5 = $2;
                                                           i64toi32_i32$2 = HEAP32[($2 + 136 | 0) >> 2] | 0;
                                                           i64toi32_i32$3 = HEAP32[($2 + 140 | 0) >> 2] | 0;
                                                           $419 = i64toi32_i32$2;
                                                           i64toi32_i32$2 = $2 + 252 | 0;
                                                           HEAP32[i64toi32_i32$2 >> 2] = $419;
                                                           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                                                           i64toi32_i32$5 = ($2 + 152 | 0) + 8 | 0;
                                                           i64toi32_i32$3 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                                           i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                                           $426 = i64toi32_i32$3;
                                                           i64toi32_i32$3 = ($2 + 200 | 0) + 40 | 0;
                                                           HEAP32[i64toi32_i32$3 >> 2] = $426;
                                                           HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                                                           HEAP32[(($2 + 200 | 0) + 60 | 0) >> 2] = HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] | 0;
                                                           HEAP8[($2 + 200 | 0) >> 0] = $1;
                                                           HEAP32[($2 + 248 | 0) >> 2] = $15;
                                                           i64toi32_i32$2 = $31$hi;
                                                           HEAP8[($2 + 201 | 0) >> 0] = $31;
                                                           HEAP8[($2 + 202 | 0) >> 0] = $31 >>> 8 | 0;
                                                           HEAP8[($2 + 203 | 0) >> 0] = $31 >>> 16 | 0;
                                                           HEAP8[($2 + 204 | 0) >> 0] = $31 >>> 24 | 0;
                                                           $440 = $2;
                                                           i64toi32_i32$5 = $31;
                                                           i64toi32_i32$3 = 0;
                                                           i64toi32_i32$1 = 48;
                                                           i64toi32_i32$0 = i64toi32_i32$1 & 31 | 0;
                                                           if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                                                            i64toi32_i32$3 = 0;
                                                            $376 = i64toi32_i32$2 >>> i64toi32_i32$0 | 0;
                                                           } else {
                                                            i64toi32_i32$3 = i64toi32_i32$2 >>> i64toi32_i32$0 | 0;
                                                            $376 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$0 | 0) | 0;
                                                           }
                                                           HEAP8[($440 + 207 | 0) >> 0] = $376;
                                                           $443 = $2;
                                                           i64toi32_i32$3 = $31$hi;
                                                           i64toi32_i32$2 = $31;
                                                           i64toi32_i32$5 = 0;
                                                           i64toi32_i32$1 = 32;
                                                           i64toi32_i32$0 = i64toi32_i32$1 & 31 | 0;
                                                           if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                                                            i64toi32_i32$5 = 0;
                                                            $377 = i64toi32_i32$3 >>> i64toi32_i32$0 | 0;
                                                           } else {
                                                            i64toi32_i32$5 = i64toi32_i32$3 >>> i64toi32_i32$0 | 0;
                                                            $377 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$0 | 0) | 0;
                                                           }
                                                           $378 = $443;
                                                           $379 = $377;
                                                           HEAP8[($378 + 205 | 0) >> 0] = $379;
                                                           HEAP8[($378 + 206 | 0) >> 0] = $379 >>> 8 | 0;
                                                           cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($14 | 0, $2 + 200 | 0 | 0, 1052521 | 0, 21 | 0);
                                                           i64toi32_i32$3 = $2;
                                                           i64toi32_i32$5 = HEAP32[($2 + 72 | 0) >> 2] | 0;
                                                           i64toi32_i32$2 = HEAP32[($2 + 76 | 0) >> 2] | 0;
                                                           $47 = i64toi32_i32$5;
                                                           $47$hi = i64toi32_i32$2;
                                                           i64toi32_i32$3 = i64toi32_i32$5;
                                                           i64toi32_i32$5 = -1;
                                                           i64toi32_i32$1 = -256;
                                                           i64toi32_i32$5 = i64toi32_i32$2 & i64toi32_i32$5 | 0;
                                                           $46 = i64toi32_i32$3 & i64toi32_i32$1 | 0;
                                                           $46$hi = i64toi32_i32$5;
                                                           i64toi32_i32$2 = ($2 + 64 | 0) + 16 | 0;
                                                           i64toi32_i32$5 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                                           i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                                           $48 = i64toi32_i32$5;
                                                           $48$hi = i64toi32_i32$3;
                                                           i64toi32_i32$2 = ($2 + 64 | 0) + 24 | 0;
                                                           i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                                           i64toi32_i32$5 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                                           $51 = i64toi32_i32$3;
                                                           $51$hi = i64toi32_i32$5;
                                                           i64toi32_i32$2 = ($2 + 64 | 0) + 32 | 0;
                                                           i64toi32_i32$5 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                                           i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                                           $32 = i64toi32_i32$5;
                                                           $32$hi = i64toi32_i32$3;
                                                           i64toi32_i32$2 = ($2 + 64 | 0) + 40 | 0;
                                                           i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                                           i64toi32_i32$5 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                                           $50 = i64toi32_i32$3;
                                                           $50$hi = i64toi32_i32$5;
                                                           i64toi32_i32$2 = $2 + 112 | 0;
                                                           i64toi32_i32$5 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                                           i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                                           $49 = i64toi32_i32$5;
                                                           $49$hi = i64toi32_i32$3;
                                                           $19 = HEAP32[($2 + 120 | 0) >> 2] | 0;
                                                           $15 = HEAP32[(($2 + 64 | 0) + 60 | 0) >> 2] | 0;
                                                           i64toi32_i32$2 = $2 + 128 | 0;
                                                           i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                                           i64toi32_i32$5 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                                           $53 = i64toi32_i32$3;
                                                           $53$hi = i64toi32_i32$5;
                                                           break label$4;
                                                          }
                                                          $21 = HEAP32[($2 + 204 | 0) >> 2] | 0;
                                                          break label$19;
                                                         }
                                                         label$96 : {
                                                          label$97 : {
                                                           i64toi32_i32$5 = $31$hi;
                                                           i64toi32_i32$2 = $31;
                                                           i64toi32_i32$3 = 0;
                                                           i64toi32_i32$1 = 1;
                                                           if ((i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$5 | 0) != (i64toi32_i32$3 | 0) | 0) {
                                                            break label$97
                                                           }
                                                           i64toi32_i32$2 = $32$hi;
                                                           i64toi32_i32$1 = $32;
                                                           i64toi32_i32$5 = 0;
                                                           i64toi32_i32$3 = 1;
                                                           i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
                                                           i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
                                                           if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
                                                            i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
                                                           }
                                                           $32 = i64toi32_i32$0;
                                                           $32$hi = i64toi32_i32$4;
                                                           i64toi32_i32$4 = $30$hi;
                                                           i64toi32_i32$4 = $32$hi;
                                                           i64toi32_i32$2 = i64toi32_i32$0;
                                                           i64toi32_i32$1 = $30$hi;
                                                           i64toi32_i32$3 = $30;
                                                           if (i64toi32_i32$4 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$2 >>> 0 <= i64toi32_i32$3 >>> 0 | 0) | 0) {
                                                            break label$97
                                                           }
                                                           i64toi32_i32$2 = 0;
                                                           $52 = 0;
                                                           $52$hi = i64toi32_i32$2;
                                                           $1 = 3;
                                                           $15 = 0;
                                                           break label$96;
                                                          }
                                                          $T_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hf422f9333a8bbafa($2 + 200 | 0 | 0, $1 | 0);
                                                          $6 = 1;
                                                          if ((HEAP32[($2 + 200 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                                                           break label$42
                                                          }
                                                          i64toi32_i32$3 = $2 + 248 | 0;
                                                          i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                                          i64toi32_i32$4 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                                          $31 = i64toi32_i32$2;
                                                          $31$hi = i64toi32_i32$4;
                                                          i64toi32_i32$2 = ($2 + 184 | 0) + 8 | 0;
                                                          HEAP32[i64toi32_i32$2 >> 2] = $31;
                                                          HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$4;
                                                          $20 = HEAP32[($2 + 268 | 0) >> 2] | 0;
                                                          HEAP32[(($2 + 168 | 0) + 8 | 0) >> 2] = $20;
                                                          i64toi32_i32$2 = ($2 + 152 | 0) + 8 | 0;
                                                          HEAP32[i64toi32_i32$2 >> 2] = $31;
                                                          HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$4;
                                                          i64toi32_i32$3 = $2 + 240 | 0;
                                                          i64toi32_i32$4 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                                          i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                                          $31 = i64toi32_i32$4;
                                                          $31$hi = i64toi32_i32$2;
                                                          i64toi32_i32$4 = $2;
                                                          HEAP32[($2 + 184 | 0) >> 2] = $31;
                                                          HEAP32[($2 + 188 | 0) >> 2] = i64toi32_i32$2;
                                                          i64toi32_i32$3 = $2 + 260 | 0;
                                                          i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                                          i64toi32_i32$4 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                                          $32 = i64toi32_i32$2;
                                                          $32$hi = i64toi32_i32$4;
                                                          i64toi32_i32$2 = $2;
                                                          HEAP32[($2 + 168 | 0) >> 2] = $32;
                                                          HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$4;
                                                          i64toi32_i32$4 = $31$hi;
                                                          i64toi32_i32$2 = $2;
                                                          HEAP32[($2 + 152 | 0) >> 2] = $31;
                                                          HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$4;
                                                          i64toi32_i32$3 = $2 + 232 | 0;
                                                          i64toi32_i32$4 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                                          i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                                          $47 = i64toi32_i32$4;
                                                          $47$hi = i64toi32_i32$2;
                                                          i64toi32_i32$3 = $2 + 224 | 0;
                                                          i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                                          i64toi32_i32$4 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                                          $52 = i64toi32_i32$2;
                                                          $52$hi = i64toi32_i32$4;
                                                          i64toi32_i32$3 = $2 + 216 | 0;
                                                          i64toi32_i32$4 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                                          i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                                          $30 = i64toi32_i32$4;
                                                          $30$hi = i64toi32_i32$2;
                                                          $1 = HEAPU8[(($2 + 200 | 0) + 8 | 0) >> 0] | 0;
                                                          $15 = HEAP32[($2 + 256 | 0) >> 2] | 0;
                                                          i64toi32_i32$3 = $2 + 209 | 0;
                                                          i64toi32_i32$2 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                                          i64toi32_i32$4 = 0;
                                                          $31 = i64toi32_i32$2;
                                                          $31$hi = i64toi32_i32$4;
                                                          i64toi32_i32$3 = $2 + 213 | 0;
                                                          i64toi32_i32$4 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
                                                          i64toi32_i32$2 = 0;
                                                          $48 = i64toi32_i32$4;
                                                          $48$hi = i64toi32_i32$2;
                                                          i64toi32_i32$3 = $2 + 215 | 0;
                                                          i64toi32_i32$2 = HEAPU8[i64toi32_i32$3 >> 0] | 0;
                                                          i64toi32_i32$4 = 0;
                                                          $51 = i64toi32_i32$2;
                                                          $51$hi = i64toi32_i32$4;
                                                          HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] = $20;
                                                          i64toi32_i32$4 = $32$hi;
                                                          i64toi32_i32$2 = $2;
                                                          HEAP32[($2 + 136 | 0) >> 2] = $32;
                                                          HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$4;
                                                          i64toi32_i32$4 = $31$hi;
                                                          $558 = $31;
                                                          $558$hi = i64toi32_i32$4;
                                                          i64toi32_i32$4 = $48$hi;
                                                          $559 = $48;
                                                          $559$hi = i64toi32_i32$4;
                                                          i64toi32_i32$4 = $51$hi;
                                                          i64toi32_i32$3 = $51;
                                                          i64toi32_i32$2 = 0;
                                                          i64toi32_i32$1 = 16;
                                                          i64toi32_i32$5 = i64toi32_i32$1 & 31 | 0;
                                                          if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                                                           i64toi32_i32$2 = i64toi32_i32$3 << i64toi32_i32$5 | 0;
                                                           $380 = 0;
                                                          } else {
                                                           i64toi32_i32$2 = ((1 << i64toi32_i32$5 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$5 | 0) | 0) | 0 | (i64toi32_i32$4 << i64toi32_i32$5 | 0) | 0;
                                                           $380 = i64toi32_i32$3 << i64toi32_i32$5 | 0;
                                                          }
                                                          $561$hi = i64toi32_i32$2;
                                                          i64toi32_i32$2 = $559$hi;
                                                          i64toi32_i32$4 = $559;
                                                          i64toi32_i32$3 = $561$hi;
                                                          i64toi32_i32$1 = $380;
                                                          i64toi32_i32$3 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
                                                          i64toi32_i32$2 = i64toi32_i32$4 | i64toi32_i32$1 | 0;
                                                          i64toi32_i32$4 = 0;
                                                          i64toi32_i32$1 = 32;
                                                          i64toi32_i32$5 = i64toi32_i32$1 & 31 | 0;
                                                          if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                                                           i64toi32_i32$4 = i64toi32_i32$2 << i64toi32_i32$5 | 0;
                                                           $381 = 0;
                                                          } else {
                                                           i64toi32_i32$4 = ((1 << i64toi32_i32$5 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$5 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$5 | 0) | 0;
                                                           $381 = i64toi32_i32$2 << i64toi32_i32$5 | 0;
                                                          }
                                                          $563$hi = i64toi32_i32$4;
                                                          i64toi32_i32$4 = $558$hi;
                                                          i64toi32_i32$3 = $558;
                                                          i64toi32_i32$2 = $563$hi;
                                                          i64toi32_i32$1 = $381;
                                                          i64toi32_i32$2 = i64toi32_i32$4 | i64toi32_i32$2 | 0;
                                                          $31 = i64toi32_i32$3 | i64toi32_i32$1 | 0;
                                                          $31$hi = i64toi32_i32$2;
                                                         }
                                                         i64toi32_i32$2 = $47$hi;
                                                         i64toi32_i32$3 = ($2 + 200 | 0) + 24 | 0;
                                                         HEAP32[i64toi32_i32$3 >> 2] = $47;
                                                         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                                                         i64toi32_i32$2 = $52$hi;
                                                         i64toi32_i32$3 = ($2 + 200 | 0) + 16 | 0;
                                                         HEAP32[i64toi32_i32$3 >> 2] = $52;
                                                         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                                                         i64toi32_i32$2 = $30$hi;
                                                         i64toi32_i32$3 = ($2 + 200 | 0) + 8 | 0;
                                                         HEAP32[i64toi32_i32$3 >> 2] = $30;
                                                         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                                                         i64toi32_i32$4 = $2;
                                                         i64toi32_i32$2 = HEAP32[($2 + 152 | 0) >> 2] | 0;
                                                         i64toi32_i32$3 = HEAP32[($2 + 156 | 0) >> 2] | 0;
                                                         $581 = i64toi32_i32$2;
                                                         i64toi32_i32$2 = ($2 + 200 | 0) + 32 | 0;
                                                         HEAP32[i64toi32_i32$2 >> 2] = $581;
                                                         HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                                                         i64toi32_i32$4 = $2;
                                                         i64toi32_i32$3 = HEAP32[($2 + 136 | 0) >> 2] | 0;
                                                         i64toi32_i32$2 = HEAP32[($2 + 140 | 0) >> 2] | 0;
                                                         $585 = i64toi32_i32$3;
                                                         i64toi32_i32$3 = $2 + 252 | 0;
                                                         HEAP32[i64toi32_i32$3 >> 2] = $585;
                                                         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                                                         i64toi32_i32$4 = ($2 + 152 | 0) + 8 | 0;
                                                         i64toi32_i32$2 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                                         i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                                         $592 = i64toi32_i32$2;
                                                         i64toi32_i32$2 = ($2 + 200 | 0) + 40 | 0;
                                                         HEAP32[i64toi32_i32$2 >> 2] = $592;
                                                         HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                                                         HEAP32[(($2 + 200 | 0) + 60 | 0) >> 2] = HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] | 0;
                                                         HEAP8[($2 + 200 | 0) >> 0] = $1;
                                                         HEAP32[($2 + 248 | 0) >> 2] = $15;
                                                         i64toi32_i32$3 = $31$hi;
                                                         HEAP8[($2 + 201 | 0) >> 0] = $31;
                                                         HEAP8[($2 + 202 | 0) >> 0] = $31 >>> 8 | 0;
                                                         HEAP8[($2 + 203 | 0) >> 0] = $31 >>> 16 | 0;
                                                         HEAP8[($2 + 204 | 0) >> 0] = $31 >>> 24 | 0;
                                                         $606 = $2;
                                                         i64toi32_i32$4 = $31;
                                                         i64toi32_i32$2 = 0;
                                                         i64toi32_i32$1 = 48;
                                                         i64toi32_i32$5 = i64toi32_i32$1 & 31 | 0;
                                                         if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                                                          i64toi32_i32$2 = 0;
                                                          $382 = i64toi32_i32$3 >>> i64toi32_i32$5 | 0;
                                                         } else {
                                                          i64toi32_i32$2 = i64toi32_i32$3 >>> i64toi32_i32$5 | 0;
                                                          $382 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$5 | 0) | 0;
                                                         }
                                                         HEAP8[($606 + 207 | 0) >> 0] = $382;
                                                         $609 = $2;
                                                         i64toi32_i32$2 = $31$hi;
                                                         i64toi32_i32$3 = $31;
                                                         i64toi32_i32$4 = 0;
                                                         i64toi32_i32$1 = 32;
                                                         i64toi32_i32$5 = i64toi32_i32$1 & 31 | 0;
                                                         if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                                                          i64toi32_i32$4 = 0;
                                                          $383 = i64toi32_i32$2 >>> i64toi32_i32$5 | 0;
                                                         } else {
                                                          i64toi32_i32$4 = i64toi32_i32$2 >>> i64toi32_i32$5 | 0;
                                                          $383 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$5 | 0) | 0;
                                                         }
                                                         $384 = $609;
                                                         $385 = $383;
                                                         HEAP8[($384 + 205 | 0) >> 0] = $385;
                                                         HEAP8[($384 + 206 | 0) >> 0] = $385 >>> 8 | 0;
                                                         cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($14 | 0, $2 + 200 | 0 | 0, 1052500 | 0, 21 | 0);
                                                         i64toi32_i32$2 = $2;
                                                         i64toi32_i32$4 = HEAP32[($2 + 72 | 0) >> 2] | 0;
                                                         i64toi32_i32$3 = HEAP32[($2 + 76 | 0) >> 2] | 0;
                                                         $47 = i64toi32_i32$4;
                                                         $47$hi = i64toi32_i32$3;
                                                         i64toi32_i32$2 = i64toi32_i32$4;
                                                         i64toi32_i32$4 = -1;
                                                         i64toi32_i32$1 = -256;
                                                         i64toi32_i32$4 = i64toi32_i32$3 & i64toi32_i32$4 | 0;
                                                         $46 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
                                                         $46$hi = i64toi32_i32$4;
                                                         i64toi32_i32$3 = ($2 + 64 | 0) + 16 | 0;
                                                         i64toi32_i32$4 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                                         i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                                         $48 = i64toi32_i32$4;
                                                         $48$hi = i64toi32_i32$2;
                                                         i64toi32_i32$3 = ($2 + 64 | 0) + 24 | 0;
                                                         i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                                         i64toi32_i32$4 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                                         $51 = i64toi32_i32$2;
                                                         $51$hi = i64toi32_i32$4;
                                                         i64toi32_i32$3 = ($2 + 64 | 0) + 32 | 0;
                                                         i64toi32_i32$4 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                                         i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                                         $32 = i64toi32_i32$4;
                                                         $32$hi = i64toi32_i32$2;
                                                         i64toi32_i32$3 = ($2 + 64 | 0) + 40 | 0;
                                                         i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                                         i64toi32_i32$4 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                                         $50 = i64toi32_i32$2;
                                                         $50$hi = i64toi32_i32$4;
                                                         i64toi32_i32$3 = $2 + 112 | 0;
                                                         i64toi32_i32$4 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                                         i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                                         $49 = i64toi32_i32$4;
                                                         $49$hi = i64toi32_i32$2;
                                                         $19 = HEAP32[($2 + 120 | 0) >> 2] | 0;
                                                         $15 = HEAP32[(($2 + 64 | 0) + 60 | 0) >> 2] | 0;
                                                         i64toi32_i32$3 = $2 + 128 | 0;
                                                         i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                                         i64toi32_i32$4 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                                         $53 = i64toi32_i32$2;
                                                         $53$hi = i64toi32_i32$4;
                                                         break label$4;
                                                        }
                                                        label$98 : {
                                                         label$99 : {
                                                          i64toi32_i32$4 = $31$hi;
                                                          i64toi32_i32$3 = $31;
                                                          i64toi32_i32$2 = 0;
                                                          i64toi32_i32$1 = 1;
                                                          if ((i64toi32_i32$3 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$4 | 0) != (i64toi32_i32$2 | 0) | 0) {
                                                           break label$99
                                                          }
                                                          i64toi32_i32$3 = $32$hi;
                                                          i64toi32_i32$1 = $32;
                                                          i64toi32_i32$4 = 0;
                                                          i64toi32_i32$2 = 1;
                                                          i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
                                                          i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$4 | 0;
                                                          if (i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0) {
                                                           i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
                                                          }
                                                          $32 = i64toi32_i32$5;
                                                          $32$hi = i64toi32_i32$0;
                                                          i64toi32_i32$0 = $30$hi;
                                                          i64toi32_i32$0 = $32$hi;
                                                          i64toi32_i32$3 = i64toi32_i32$5;
                                                          i64toi32_i32$1 = $30$hi;
                                                          i64toi32_i32$2 = $30;
                                                          if (i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$3 >>> 0 <= i64toi32_i32$2 >>> 0 | 0) | 0) {
                                                           break label$99
                                                          }
                                                          i64toi32_i32$3 = 0;
                                                          $52 = 0;
                                                          $52$hi = i64toi32_i32$3;
                                                          $1 = 3;
                                                          $15 = 0;
                                                          break label$98;
                                                         }
                                                         $T_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hf422f9333a8bbafa($2 + 200 | 0 | 0, $1 | 0);
                                                         $7 = 1;
                                                         if ((HEAP32[($2 + 200 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                                                          break label$41
                                                         }
                                                         i64toi32_i32$2 = $2 + 248 | 0;
                                                         i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                                         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                                         $31 = i64toi32_i32$3;
                                                         $31$hi = i64toi32_i32$0;
                                                         i64toi32_i32$3 = ($2 + 184 | 0) + 8 | 0;
                                                         HEAP32[i64toi32_i32$3 >> 2] = $31;
                                                         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
                                                         $20 = HEAP32[($2 + 268 | 0) >> 2] | 0;
                                                         HEAP32[(($2 + 168 | 0) + 8 | 0) >> 2] = $20;
                                                         i64toi32_i32$3 = ($2 + 152 | 0) + 8 | 0;
                                                         HEAP32[i64toi32_i32$3 >> 2] = $31;
                                                         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
                                                         i64toi32_i32$2 = $2 + 240 | 0;
                                                         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                                         i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                                         $31 = i64toi32_i32$0;
                                                         $31$hi = i64toi32_i32$3;
                                                         i64toi32_i32$0 = $2;
                                                         HEAP32[($2 + 184 | 0) >> 2] = $31;
                                                         HEAP32[($2 + 188 | 0) >> 2] = i64toi32_i32$3;
                                                         i64toi32_i32$2 = $2 + 260 | 0;
                                                         i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                                         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                                         $32 = i64toi32_i32$3;
                                                         $32$hi = i64toi32_i32$0;
                                                         i64toi32_i32$3 = $2;
                                                         HEAP32[($2 + 168 | 0) >> 2] = $32;
                                                         HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$0;
                                                         i64toi32_i32$0 = $31$hi;
                                                         i64toi32_i32$3 = $2;
                                                         HEAP32[($2 + 152 | 0) >> 2] = $31;
                                                         HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
                                                         i64toi32_i32$2 = $2 + 232 | 0;
                                                         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                                         i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                                         $47 = i64toi32_i32$0;
                                                         $47$hi = i64toi32_i32$3;
                                                         i64toi32_i32$2 = $2 + 224 | 0;
                                                         i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                                         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                                         $52 = i64toi32_i32$3;
                                                         $52$hi = i64toi32_i32$0;
                                                         i64toi32_i32$2 = $2 + 216 | 0;
                                                         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                                         i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                                         $30 = i64toi32_i32$0;
                                                         $30$hi = i64toi32_i32$3;
                                                         $1 = HEAPU8[(($2 + 200 | 0) + 8 | 0) >> 0] | 0;
                                                         $15 = HEAP32[($2 + 256 | 0) >> 2] | 0;
                                                         i64toi32_i32$2 = $2 + 209 | 0;
                                                         i64toi32_i32$3 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                                         i64toi32_i32$0 = 0;
                                                         $31 = i64toi32_i32$3;
                                                         $31$hi = i64toi32_i32$0;
                                                         i64toi32_i32$2 = $2 + 213 | 0;
                                                         i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
                                                         i64toi32_i32$3 = 0;
                                                         $48 = i64toi32_i32$0;
                                                         $48$hi = i64toi32_i32$3;
                                                         i64toi32_i32$2 = $2 + 215 | 0;
                                                         i64toi32_i32$3 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
                                                         i64toi32_i32$0 = 0;
                                                         $51 = i64toi32_i32$3;
                                                         $51$hi = i64toi32_i32$0;
                                                         HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] = $20;
                                                         i64toi32_i32$0 = $32$hi;
                                                         i64toi32_i32$3 = $2;
                                                         HEAP32[($2 + 136 | 0) >> 2] = $32;
                                                         HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$0;
                                                         i64toi32_i32$0 = $31$hi;
                                                         $722 = $31;
                                                         $722$hi = i64toi32_i32$0;
                                                         i64toi32_i32$0 = $48$hi;
                                                         $723 = $48;
                                                         $723$hi = i64toi32_i32$0;
                                                         i64toi32_i32$0 = $51$hi;
                                                         i64toi32_i32$2 = $51;
                                                         i64toi32_i32$3 = 0;
                                                         i64toi32_i32$1 = 16;
                                                         i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
                                                         if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                                                          i64toi32_i32$3 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
                                                          $386 = 0;
                                                         } else {
                                                          i64toi32_i32$3 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
                                                          $386 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
                                                         }
                                                         $725$hi = i64toi32_i32$3;
                                                         i64toi32_i32$3 = $723$hi;
                                                         i64toi32_i32$0 = $723;
                                                         i64toi32_i32$2 = $725$hi;
                                                         i64toi32_i32$1 = $386;
                                                         i64toi32_i32$2 = i64toi32_i32$3 | i64toi32_i32$2 | 0;
                                                         i64toi32_i32$3 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
                                                         i64toi32_i32$0 = 0;
                                                         i64toi32_i32$1 = 32;
                                                         i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
                                                         if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                                                          i64toi32_i32$0 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
                                                          $387 = 0;
                                                         } else {
                                                          i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
                                                          $387 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
                                                         }
                                                         $727$hi = i64toi32_i32$0;
                                                         i64toi32_i32$0 = $722$hi;
                                                         i64toi32_i32$2 = $722;
                                                         i64toi32_i32$3 = $727$hi;
                                                         i64toi32_i32$1 = $387;
                                                         i64toi32_i32$3 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
                                                         $31 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
                                                         $31$hi = i64toi32_i32$3;
                                                        }
                                                        i64toi32_i32$3 = $47$hi;
                                                        i64toi32_i32$2 = ($2 + 200 | 0) + 24 | 0;
                                                        HEAP32[i64toi32_i32$2 >> 2] = $47;
                                                        HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                                                        i64toi32_i32$3 = $52$hi;
                                                        i64toi32_i32$2 = ($2 + 200 | 0) + 16 | 0;
                                                        HEAP32[i64toi32_i32$2 >> 2] = $52;
                                                        HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                                                        i64toi32_i32$3 = $30$hi;
                                                        i64toi32_i32$2 = ($2 + 200 | 0) + 8 | 0;
                                                        HEAP32[i64toi32_i32$2 >> 2] = $30;
                                                        HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                                                        i64toi32_i32$0 = $2;
                                                        i64toi32_i32$3 = HEAP32[($2 + 152 | 0) >> 2] | 0;
                                                        i64toi32_i32$2 = HEAP32[($2 + 156 | 0) >> 2] | 0;
                                                        $745 = i64toi32_i32$3;
                                                        i64toi32_i32$3 = ($2 + 200 | 0) + 32 | 0;
                                                        HEAP32[i64toi32_i32$3 >> 2] = $745;
                                                        HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                                                        i64toi32_i32$0 = $2;
                                                        i64toi32_i32$2 = HEAP32[($2 + 136 | 0) >> 2] | 0;
                                                        i64toi32_i32$3 = HEAP32[($2 + 140 | 0) >> 2] | 0;
                                                        $749 = i64toi32_i32$2;
                                                        i64toi32_i32$2 = $2 + 252 | 0;
                                                        HEAP32[i64toi32_i32$2 >> 2] = $749;
                                                        HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                                                        i64toi32_i32$0 = ($2 + 152 | 0) + 8 | 0;
                                                        i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                        i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                        $756 = i64toi32_i32$3;
                                                        i64toi32_i32$3 = ($2 + 200 | 0) + 40 | 0;
                                                        HEAP32[i64toi32_i32$3 >> 2] = $756;
                                                        HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                                                        HEAP32[(($2 + 200 | 0) + 60 | 0) >> 2] = HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] | 0;
                                                        HEAP8[($2 + 200 | 0) >> 0] = $1;
                                                        HEAP32[($2 + 248 | 0) >> 2] = $15;
                                                        i64toi32_i32$2 = $31$hi;
                                                        HEAP8[($2 + 201 | 0) >> 0] = $31;
                                                        HEAP8[($2 + 202 | 0) >> 0] = $31 >>> 8 | 0;
                                                        HEAP8[($2 + 203 | 0) >> 0] = $31 >>> 16 | 0;
                                                        HEAP8[($2 + 204 | 0) >> 0] = $31 >>> 24 | 0;
                                                        $770 = $2;
                                                        i64toi32_i32$0 = $31;
                                                        i64toi32_i32$3 = 0;
                                                        i64toi32_i32$1 = 48;
                                                        i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
                                                        if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                                                         i64toi32_i32$3 = 0;
                                                         $388 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
                                                        } else {
                                                         i64toi32_i32$3 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
                                                         $388 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
                                                        }
                                                        HEAP8[($770 + 207 | 0) >> 0] = $388;
                                                        $773 = $2;
                                                        i64toi32_i32$3 = $31$hi;
                                                        i64toi32_i32$2 = $31;
                                                        i64toi32_i32$0 = 0;
                                                        i64toi32_i32$1 = 32;
                                                        i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
                                                        if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                                                         i64toi32_i32$0 = 0;
                                                         $389 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
                                                        } else {
                                                         i64toi32_i32$0 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
                                                         $389 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
                                                        }
                                                        $390 = $773;
                                                        $391 = $389;
                                                        HEAP8[($390 + 205 | 0) >> 0] = $391;
                                                        HEAP8[($390 + 206 | 0) >> 0] = $391 >>> 8 | 0;
                                                        cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($14 | 0, $2 + 200 | 0 | 0, 1052486 | 0, 14 | 0);
                                                        i64toi32_i32$3 = $2;
                                                        i64toi32_i32$0 = HEAP32[($2 + 72 | 0) >> 2] | 0;
                                                        i64toi32_i32$2 = HEAP32[($2 + 76 | 0) >> 2] | 0;
                                                        $47 = i64toi32_i32$0;
                                                        $47$hi = i64toi32_i32$2;
                                                        i64toi32_i32$3 = i64toi32_i32$0;
                                                        i64toi32_i32$0 = -1;
                                                        i64toi32_i32$1 = -256;
                                                        i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
                                                        $46 = i64toi32_i32$3 & i64toi32_i32$1 | 0;
                                                        $46$hi = i64toi32_i32$0;
                                                        i64toi32_i32$2 = ($2 + 64 | 0) + 16 | 0;
                                                        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                                        i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                                        $48 = i64toi32_i32$0;
                                                        $48$hi = i64toi32_i32$3;
                                                        i64toi32_i32$2 = ($2 + 64 | 0) + 24 | 0;
                                                        i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                                        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                                        $51 = i64toi32_i32$3;
                                                        $51$hi = i64toi32_i32$0;
                                                        i64toi32_i32$2 = ($2 + 64 | 0) + 32 | 0;
                                                        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                                        i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                                        $32 = i64toi32_i32$0;
                                                        $32$hi = i64toi32_i32$3;
                                                        i64toi32_i32$2 = ($2 + 64 | 0) + 40 | 0;
                                                        i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                                        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                                        $50 = i64toi32_i32$3;
                                                        $50$hi = i64toi32_i32$0;
                                                        i64toi32_i32$2 = $2 + 112 | 0;
                                                        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                                        i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                                        $49 = i64toi32_i32$0;
                                                        $49$hi = i64toi32_i32$3;
                                                        $19 = HEAP32[($2 + 120 | 0) >> 2] | 0;
                                                        $15 = HEAP32[(($2 + 64 | 0) + 60 | 0) >> 2] | 0;
                                                        i64toi32_i32$2 = $2 + 128 | 0;
                                                        i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                                        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                                        $53 = i64toi32_i32$3;
                                                        $53$hi = i64toi32_i32$0;
                                                        break label$4;
                                                       }
                                                       label$100 : {
                                                        label$101 : {
                                                         i64toi32_i32$0 = $31$hi;
                                                         i64toi32_i32$2 = $31;
                                                         i64toi32_i32$3 = 0;
                                                         i64toi32_i32$1 = 1;
                                                         if ((i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$3 | 0) | 0) {
                                                          break label$101
                                                         }
                                                         i64toi32_i32$2 = $32$hi;
                                                         i64toi32_i32$1 = $32;
                                                         i64toi32_i32$0 = 0;
                                                         i64toi32_i32$3 = 1;
                                                         i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
                                                         i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
                                                         if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
                                                          i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
                                                         }
                                                         $32 = i64toi32_i32$4;
                                                         $32$hi = i64toi32_i32$5;
                                                         i64toi32_i32$5 = $30$hi;
                                                         i64toi32_i32$5 = $32$hi;
                                                         i64toi32_i32$2 = i64toi32_i32$4;
                                                         i64toi32_i32$1 = $30$hi;
                                                         i64toi32_i32$3 = $30;
                                                         if (i64toi32_i32$5 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$2 >>> 0 <= i64toi32_i32$3 >>> 0 | 0) | 0) {
                                                          break label$101
                                                         }
                                                         i64toi32_i32$2 = 0;
                                                         $31 = 0;
                                                         $31$hi = i64toi32_i32$2;
                                                         i64toi32_i32$2 = 0;
                                                         $52 = 3;
                                                         $52$hi = i64toi32_i32$2;
                                                         $1 = 0;
                                                         break label$100;
                                                        }
                                                        $cardano_serialization_lib__plutus__ExUnits_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h32fa18bd273d182d($2 + 200 | 0 | 0, $1 | 0);
                                                        i64toi32_i32$3 = $2;
                                                        i64toi32_i32$2 = HEAP32[($2 + 200 | 0) >> 2] | 0;
                                                        i64toi32_i32$5 = HEAP32[($2 + 204 | 0) >> 2] | 0;
                                                        i64toi32_i32$3 = i64toi32_i32$2;
                                                        i64toi32_i32$2 = 0;
                                                        i64toi32_i32$1 = 1;
                                                        if ((i64toi32_i32$3 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$5 | 0) != (i64toi32_i32$2 | 0) | 0) {
                                                         break label$40
                                                        }
                                                        $1 = HEAP32[($2 + 268 | 0) >> 2] | 0;
                                                        HEAP32[(($2 + 168 | 0) + 8 | 0) >> 2] = $1;
                                                        i64toi32_i32$1 = $2 + 248 | 0;
                                                        i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                                        i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                                        $837 = i64toi32_i32$3;
                                                        i64toi32_i32$3 = ($2 + 152 | 0) + 8 | 0;
                                                        HEAP32[i64toi32_i32$3 >> 2] = $837;
                                                        HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
                                                        HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] = $1;
                                                        i64toi32_i32$1 = $2;
                                                        i64toi32_i32$5 = HEAP32[($2 + 260 | 0) >> 2] | 0;
                                                        i64toi32_i32$3 = HEAP32[($2 + 264 | 0) >> 2] | 0;
                                                        $31 = i64toi32_i32$5;
                                                        $31$hi = i64toi32_i32$3;
                                                        i64toi32_i32$5 = $2;
                                                        HEAP32[($2 + 168 | 0) >> 2] = $31;
                                                        HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$3;
                                                        i64toi32_i32$5 = $2;
                                                        HEAP32[($2 + 136 | 0) >> 2] = $31;
                                                        HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$3;
                                                        i64toi32_i32$1 = $2 + 240 | 0;
                                                        i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                                        i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                                        $851 = i64toi32_i32$3;
                                                        i64toi32_i32$3 = $2;
                                                        HEAP32[($2 + 152 | 0) >> 2] = $851;
                                                        HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$5;
                                                        i64toi32_i32$1 = $2 + 232 | 0;
                                                        i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                                        i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                                        $47 = i64toi32_i32$5;
                                                        $47$hi = i64toi32_i32$3;
                                                        i64toi32_i32$1 = $2 + 224 | 0;
                                                        i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                                        i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                                        $31 = i64toi32_i32$3;
                                                        $31$hi = i64toi32_i32$5;
                                                        $1 = HEAP32[($2 + 256 | 0) >> 2] | 0;
                                                        i64toi32_i32$1 = $2;
                                                        i64toi32_i32$5 = HEAP32[($2 + 216 | 0) >> 2] | 0;
                                                        i64toi32_i32$3 = HEAP32[($2 + 220 | 0) >> 2] | 0;
                                                        $30 = i64toi32_i32$5;
                                                        $30$hi = i64toi32_i32$3;
                                                        i64toi32_i32$1 = $2;
                                                        i64toi32_i32$3 = HEAP32[($2 + 208 | 0) >> 2] | 0;
                                                        i64toi32_i32$5 = HEAP32[($2 + 212 | 0) >> 2] | 0;
                                                        $52 = i64toi32_i32$3;
                                                        $52$hi = i64toi32_i32$5;
                                                       }
                                                       i64toi32_i32$5 = $47$hi;
                                                       i64toi32_i32$3 = ($2 + 200 | 0) + 24 | 0;
                                                       HEAP32[i64toi32_i32$3 >> 2] = $47;
                                                       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
                                                       i64toi32_i32$5 = $31$hi;
                                                       i64toi32_i32$3 = $2 + 216 | 0;
                                                       HEAP32[i64toi32_i32$3 >> 2] = $31;
                                                       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
                                                       i64toi32_i32$5 = $30$hi;
                                                       i64toi32_i32$3 = ($2 + 200 | 0) + 8 | 0;
                                                       HEAP32[i64toi32_i32$3 >> 2] = $30;
                                                       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
                                                       i64toi32_i32$1 = $2;
                                                       i64toi32_i32$5 = HEAP32[($2 + 152 | 0) >> 2] | 0;
                                                       i64toi32_i32$3 = HEAP32[($2 + 156 | 0) >> 2] | 0;
                                                       $880 = i64toi32_i32$5;
                                                       i64toi32_i32$5 = ($2 + 200 | 0) + 32 | 0;
                                                       HEAP32[i64toi32_i32$5 >> 2] = $880;
                                                       HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$3;
                                                       i64toi32_i32$1 = $2;
                                                       i64toi32_i32$3 = HEAP32[($2 + 136 | 0) >> 2] | 0;
                                                       i64toi32_i32$5 = HEAP32[($2 + 140 | 0) >> 2] | 0;
                                                       $884 = i64toi32_i32$3;
                                                       i64toi32_i32$3 = $2 + 252 | 0;
                                                       HEAP32[i64toi32_i32$3 >> 2] = $884;
                                                       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
                                                       i64toi32_i32$1 = ($2 + 152 | 0) + 8 | 0;
                                                       i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                                       i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                                       $891 = i64toi32_i32$5;
                                                       i64toi32_i32$5 = ($2 + 200 | 0) + 40 | 0;
                                                       HEAP32[i64toi32_i32$5 >> 2] = $891;
                                                       HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$3;
                                                       HEAP32[(($2 + 200 | 0) + 60 | 0) >> 2] = HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] | 0;
                                                       i64toi32_i32$3 = $52$hi;
                                                       i64toi32_i32$5 = $2;
                                                       HEAP32[($2 + 200 | 0) >> 2] = $52;
                                                       HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$3;
                                                       HEAP32[($2 + 248 | 0) >> 2] = $1;
                                                       cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($14 | 0, $2 + 200 | 0 | 0, 1052468 | 0, 18 | 0);
                                                       i64toi32_i32$1 = $2;
                                                       i64toi32_i32$3 = HEAP32[($2 + 72 | 0) >> 2] | 0;
                                                       i64toi32_i32$5 = HEAP32[($2 + 76 | 0) >> 2] | 0;
                                                       $47 = i64toi32_i32$3;
                                                       $47$hi = i64toi32_i32$5;
                                                       i64toi32_i32$1 = i64toi32_i32$3;
                                                       i64toi32_i32$3 = -1;
                                                       i64toi32_i32$2 = -256;
                                                       i64toi32_i32$3 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
                                                       $46 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
                                                       $46$hi = i64toi32_i32$3;
                                                       i64toi32_i32$5 = ($2 + 64 | 0) + 24 | 0;
                                                       i64toi32_i32$3 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                                       i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                                       $51 = i64toi32_i32$3;
                                                       $51$hi = i64toi32_i32$1;
                                                       i64toi32_i32$5 = ($2 + 64 | 0) + 32 | 0;
                                                       i64toi32_i32$1 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                                       i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                                       $32 = i64toi32_i32$1;
                                                       $32$hi = i64toi32_i32$3;
                                                       i64toi32_i32$5 = ($2 + 64 | 0) + 40 | 0;
                                                       i64toi32_i32$3 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                                       i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                                       $50 = i64toi32_i32$3;
                                                       $50$hi = i64toi32_i32$1;
                                                       i64toi32_i32$5 = $2 + 112 | 0;
                                                       i64toi32_i32$1 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                                       i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                                       $49 = i64toi32_i32$1;
                                                       $49$hi = i64toi32_i32$3;
                                                       $19 = HEAP32[($2 + 120 | 0) >> 2] | 0;
                                                       $15 = HEAP32[(($2 + 64 | 0) + 60 | 0) >> 2] | 0;
                                                       i64toi32_i32$5 = $2 + 128 | 0;
                                                       i64toi32_i32$3 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                                       i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                                       $53 = i64toi32_i32$3;
                                                       $53$hi = i64toi32_i32$1;
                                                       i64toi32_i32$5 = $2;
                                                       i64toi32_i32$1 = HEAP32[($2 + 80 | 0) >> 2] | 0;
                                                       i64toi32_i32$3 = HEAP32[($2 + 84 | 0) >> 2] | 0;
                                                       $48 = i64toi32_i32$1;
                                                       $48$hi = i64toi32_i32$3;
                                                       break label$4;
                                                      }
                                                      label$102 : {
                                                       label$103 : {
                                                        i64toi32_i32$3 = $31$hi;
                                                        i64toi32_i32$5 = $31;
                                                        i64toi32_i32$1 = 0;
                                                        i64toi32_i32$2 = 1;
                                                        if ((i64toi32_i32$5 | 0) != (i64toi32_i32$2 | 0) | (i64toi32_i32$3 | 0) != (i64toi32_i32$1 | 0) | 0) {
                                                         break label$103
                                                        }
                                                        i64toi32_i32$5 = $32$hi;
                                                        i64toi32_i32$2 = $32;
                                                        i64toi32_i32$3 = 0;
                                                        i64toi32_i32$1 = 1;
                                                        i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
                                                        i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
                                                        if (i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0) {
                                                         i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
                                                        }
                                                        $32 = i64toi32_i32$0;
                                                        $32$hi = i64toi32_i32$4;
                                                        i64toi32_i32$4 = $30$hi;
                                                        i64toi32_i32$4 = $32$hi;
                                                        i64toi32_i32$5 = i64toi32_i32$0;
                                                        i64toi32_i32$2 = $30$hi;
                                                        i64toi32_i32$1 = $30;
                                                        if (i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$5 >>> 0 <= i64toi32_i32$1 >>> 0 | 0) | 0) {
                                                         break label$103
                                                        }
                                                        i64toi32_i32$5 = 0;
                                                        $31 = 0;
                                                        $31$hi = i64toi32_i32$5;
                                                        i64toi32_i32$5 = 0;
                                                        $52 = 3;
                                                        $52$hi = i64toi32_i32$5;
                                                        $1 = 0;
                                                        break label$102;
                                                       }
                                                       $cardano_serialization_lib__plutus__ExUnits_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h32fa18bd273d182d($2 + 200 | 0 | 0, $1 | 0);
                                                       i64toi32_i32$1 = $2;
                                                       i64toi32_i32$5 = HEAP32[($2 + 200 | 0) >> 2] | 0;
                                                       i64toi32_i32$4 = HEAP32[($2 + 204 | 0) >> 2] | 0;
                                                       i64toi32_i32$1 = i64toi32_i32$5;
                                                       i64toi32_i32$5 = 0;
                                                       i64toi32_i32$2 = 1;
                                                       if ((i64toi32_i32$1 | 0) != (i64toi32_i32$2 | 0) | (i64toi32_i32$4 | 0) != (i64toi32_i32$5 | 0) | 0) {
                                                        break label$39
                                                       }
                                                       $1 = HEAP32[($2 + 268 | 0) >> 2] | 0;
                                                       HEAP32[(($2 + 168 | 0) + 8 | 0) >> 2] = $1;
                                                       i64toi32_i32$2 = $2 + 248 | 0;
                                                       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                                       i64toi32_i32$4 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                                       $962 = i64toi32_i32$1;
                                                       i64toi32_i32$1 = ($2 + 152 | 0) + 8 | 0;
                                                       HEAP32[i64toi32_i32$1 >> 2] = $962;
                                                       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$4;
                                                       HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] = $1;
                                                       i64toi32_i32$2 = $2;
                                                       i64toi32_i32$4 = HEAP32[($2 + 260 | 0) >> 2] | 0;
                                                       i64toi32_i32$1 = HEAP32[($2 + 264 | 0) >> 2] | 0;
                                                       $31 = i64toi32_i32$4;
                                                       $31$hi = i64toi32_i32$1;
                                                       i64toi32_i32$4 = $2;
                                                       HEAP32[($2 + 168 | 0) >> 2] = $31;
                                                       HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$1;
                                                       i64toi32_i32$4 = $2;
                                                       HEAP32[($2 + 136 | 0) >> 2] = $31;
                                                       HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$1;
                                                       i64toi32_i32$2 = $2 + 240 | 0;
                                                       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                                       i64toi32_i32$4 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                                       $976 = i64toi32_i32$1;
                                                       i64toi32_i32$1 = $2;
                                                       HEAP32[($2 + 152 | 0) >> 2] = $976;
                                                       HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$4;
                                                       i64toi32_i32$2 = $2 + 232 | 0;
                                                       i64toi32_i32$4 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                                       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                                       $47 = i64toi32_i32$4;
                                                       $47$hi = i64toi32_i32$1;
                                                       i64toi32_i32$2 = $2 + 224 | 0;
                                                       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                                       i64toi32_i32$4 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                                       $31 = i64toi32_i32$1;
                                                       $31$hi = i64toi32_i32$4;
                                                       $1 = HEAP32[($2 + 256 | 0) >> 2] | 0;
                                                       i64toi32_i32$2 = $2;
                                                       i64toi32_i32$4 = HEAP32[($2 + 216 | 0) >> 2] | 0;
                                                       i64toi32_i32$1 = HEAP32[($2 + 220 | 0) >> 2] | 0;
                                                       $30 = i64toi32_i32$4;
                                                       $30$hi = i64toi32_i32$1;
                                                       i64toi32_i32$2 = $2;
                                                       i64toi32_i32$1 = HEAP32[($2 + 208 | 0) >> 2] | 0;
                                                       i64toi32_i32$4 = HEAP32[($2 + 212 | 0) >> 2] | 0;
                                                       $52 = i64toi32_i32$1;
                                                       $52$hi = i64toi32_i32$4;
                                                      }
                                                      i64toi32_i32$4 = $47$hi;
                                                      i64toi32_i32$1 = ($2 + 200 | 0) + 24 | 0;
                                                      HEAP32[i64toi32_i32$1 >> 2] = $47;
                                                      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$4;
                                                      i64toi32_i32$4 = $31$hi;
                                                      i64toi32_i32$1 = $2 + 216 | 0;
                                                      HEAP32[i64toi32_i32$1 >> 2] = $31;
                                                      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$4;
                                                      i64toi32_i32$4 = $30$hi;
                                                      i64toi32_i32$1 = ($2 + 200 | 0) + 8 | 0;
                                                      HEAP32[i64toi32_i32$1 >> 2] = $30;
                                                      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$4;
                                                      i64toi32_i32$2 = $2;
                                                      i64toi32_i32$4 = HEAP32[($2 + 152 | 0) >> 2] | 0;
                                                      i64toi32_i32$1 = HEAP32[($2 + 156 | 0) >> 2] | 0;
                                                      $1005 = i64toi32_i32$4;
                                                      i64toi32_i32$4 = ($2 + 200 | 0) + 32 | 0;
                                                      HEAP32[i64toi32_i32$4 >> 2] = $1005;
                                                      HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$1;
                                                      i64toi32_i32$2 = $2;
                                                      i64toi32_i32$1 = HEAP32[($2 + 136 | 0) >> 2] | 0;
                                                      i64toi32_i32$4 = HEAP32[($2 + 140 | 0) >> 2] | 0;
                                                      $1009 = i64toi32_i32$1;
                                                      i64toi32_i32$1 = $2 + 252 | 0;
                                                      HEAP32[i64toi32_i32$1 >> 2] = $1009;
                                                      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$4;
                                                      i64toi32_i32$2 = ($2 + 152 | 0) + 8 | 0;
                                                      i64toi32_i32$4 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                                      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                                      $1016 = i64toi32_i32$4;
                                                      i64toi32_i32$4 = ($2 + 200 | 0) + 40 | 0;
                                                      HEAP32[i64toi32_i32$4 >> 2] = $1016;
                                                      HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$1;
                                                      HEAP32[(($2 + 200 | 0) + 60 | 0) >> 2] = HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] | 0;
                                                      i64toi32_i32$1 = $52$hi;
                                                      i64toi32_i32$4 = $2;
                                                      HEAP32[($2 + 200 | 0) >> 2] = $52;
                                                      HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$1;
                                                      HEAP32[($2 + 248 | 0) >> 2] = $1;
                                                      cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($14 | 0, $2 + 200 | 0 | 0, 1052453 | 0, 15 | 0);
                                                      i64toi32_i32$2 = $2;
                                                      i64toi32_i32$1 = HEAP32[($2 + 72 | 0) >> 2] | 0;
                                                      i64toi32_i32$4 = HEAP32[($2 + 76 | 0) >> 2] | 0;
                                                      $47 = i64toi32_i32$1;
                                                      $47$hi = i64toi32_i32$4;
                                                      i64toi32_i32$2 = i64toi32_i32$1;
                                                      i64toi32_i32$1 = -1;
                                                      i64toi32_i32$5 = -256;
                                                      i64toi32_i32$1 = i64toi32_i32$4 & i64toi32_i32$1 | 0;
                                                      $46 = i64toi32_i32$2 & i64toi32_i32$5 | 0;
                                                      $46$hi = i64toi32_i32$1;
                                                      i64toi32_i32$4 = ($2 + 64 | 0) + 24 | 0;
                                                      i64toi32_i32$1 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                                      i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                                      $51 = i64toi32_i32$1;
                                                      $51$hi = i64toi32_i32$2;
                                                      i64toi32_i32$4 = ($2 + 64 | 0) + 32 | 0;
                                                      i64toi32_i32$2 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                                      i64toi32_i32$1 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                                      $32 = i64toi32_i32$2;
                                                      $32$hi = i64toi32_i32$1;
                                                      i64toi32_i32$4 = ($2 + 64 | 0) + 40 | 0;
                                                      i64toi32_i32$1 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                                      i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                                      $50 = i64toi32_i32$1;
                                                      $50$hi = i64toi32_i32$2;
                                                      i64toi32_i32$4 = $2 + 112 | 0;
                                                      i64toi32_i32$2 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                                      i64toi32_i32$1 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                                      $49 = i64toi32_i32$2;
                                                      $49$hi = i64toi32_i32$1;
                                                      $19 = HEAP32[($2 + 120 | 0) >> 2] | 0;
                                                      $15 = HEAP32[(($2 + 64 | 0) + 60 | 0) >> 2] | 0;
                                                      i64toi32_i32$4 = $2 + 128 | 0;
                                                      i64toi32_i32$1 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                                      i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                                      $53 = i64toi32_i32$1;
                                                      $53$hi = i64toi32_i32$2;
                                                      i64toi32_i32$4 = $2;
                                                      i64toi32_i32$2 = HEAP32[($2 + 80 | 0) >> 2] | 0;
                                                      i64toi32_i32$1 = HEAP32[($2 + 84 | 0) >> 2] | 0;
                                                      $48 = i64toi32_i32$2;
                                                      $48$hi = i64toi32_i32$1;
                                                      break label$4;
                                                     }
                                                     label$104 : {
                                                      label$105 : {
                                                       i64toi32_i32$1 = $31$hi;
                                                       i64toi32_i32$4 = $31;
                                                       i64toi32_i32$2 = 0;
                                                       i64toi32_i32$5 = 1;
                                                       if ((i64toi32_i32$4 | 0) != (i64toi32_i32$5 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$2 | 0) | 0) {
                                                        break label$105
                                                       }
                                                       i64toi32_i32$4 = $32$hi;
                                                       i64toi32_i32$5 = $32;
                                                       i64toi32_i32$1 = 0;
                                                       i64toi32_i32$2 = 1;
                                                       i64toi32_i32$3 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
                                                       i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
                                                       if (i64toi32_i32$3 >>> 0 < i64toi32_i32$2 >>> 0) {
                                                        i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
                                                       }
                                                       $32 = i64toi32_i32$3;
                                                       $32$hi = i64toi32_i32$0;
                                                       i64toi32_i32$0 = $30$hi;
                                                       i64toi32_i32$0 = $32$hi;
                                                       i64toi32_i32$4 = i64toi32_i32$3;
                                                       i64toi32_i32$5 = $30$hi;
                                                       i64toi32_i32$2 = $30;
                                                       if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$3 >>> 0 <= i64toi32_i32$2 >>> 0 | 0) | 0) {
                                                        break label$105
                                                       }
                                                       i64toi32_i32$4 = 0;
                                                       $54 = 0;
                                                       $54$hi = i64toi32_i32$4;
                                                       $15 = 3;
                                                       $1 = 0;
                                                       break label$104;
                                                      }
                                                      $cardano_serialization_lib__plutus__ExUnitPrices_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hb43adfd468752d01($2 + 200 | 0 | 0, $1 | 0);
                                                      i64toi32_i32$2 = $2;
                                                      i64toi32_i32$4 = HEAPU8[($2 + 209 | 0) >> 0] | 0 | ((HEAPU8[($2 + 210 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 211 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 212 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                                      i64toi32_i32$0 = 0;
                                                      $1073 = i64toi32_i32$4;
                                                      $1073$hi = i64toi32_i32$0;
                                                      i64toi32_i32$2 = ($2 + 200 | 0) + 13 | 0;
                                                      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
                                                      i64toi32_i32$4 = 0;
                                                      $1077 = i64toi32_i32$0;
                                                      $1077$hi = i64toi32_i32$4;
                                                      i64toi32_i32$2 = ($2 + 200 | 0) + 15 | 0;
                                                      i64toi32_i32$4 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
                                                      i64toi32_i32$0 = 0;
                                                      i64toi32_i32$2 = i64toi32_i32$4;
                                                      i64toi32_i32$4 = 0;
                                                      i64toi32_i32$5 = 16;
                                                      i64toi32_i32$1 = i64toi32_i32$5 & 31 | 0;
                                                      if (32 >>> 0 <= (i64toi32_i32$5 & 63 | 0) >>> 0) {
                                                       i64toi32_i32$4 = i64toi32_i32$2 << i64toi32_i32$1 | 0;
                                                       $394 = 0;
                                                      } else {
                                                       i64toi32_i32$4 = ((1 << i64toi32_i32$1 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$1 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$1 | 0) | 0;
                                                       $394 = i64toi32_i32$2 << i64toi32_i32$1 | 0;
                                                      }
                                                      $1082$hi = i64toi32_i32$4;
                                                      i64toi32_i32$4 = $1077$hi;
                                                      i64toi32_i32$0 = $1077;
                                                      i64toi32_i32$2 = $1082$hi;
                                                      i64toi32_i32$5 = $394;
                                                      i64toi32_i32$2 = i64toi32_i32$4 | i64toi32_i32$2 | 0;
                                                      i64toi32_i32$4 = i64toi32_i32$0 | i64toi32_i32$5 | 0;
                                                      i64toi32_i32$0 = 0;
                                                      i64toi32_i32$5 = 32;
                                                      i64toi32_i32$1 = i64toi32_i32$5 & 31 | 0;
                                                      if (32 >>> 0 <= (i64toi32_i32$5 & 63 | 0) >>> 0) {
                                                       i64toi32_i32$0 = i64toi32_i32$4 << i64toi32_i32$1 | 0;
                                                       $395 = 0;
                                                      } else {
                                                       i64toi32_i32$0 = ((1 << i64toi32_i32$1 | 0) - 1 | 0) & (i64toi32_i32$4 >>> (32 - i64toi32_i32$1 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$1 | 0) | 0;
                                                       $395 = i64toi32_i32$4 << i64toi32_i32$1 | 0;
                                                      }
                                                      $1084$hi = i64toi32_i32$0;
                                                      i64toi32_i32$0 = $1073$hi;
                                                      i64toi32_i32$2 = $1073;
                                                      i64toi32_i32$4 = $1084$hi;
                                                      i64toi32_i32$5 = $395;
                                                      i64toi32_i32$4 = i64toi32_i32$0 | i64toi32_i32$4 | 0;
                                                      $52 = i64toi32_i32$2 | i64toi32_i32$5 | 0;
                                                      $52$hi = i64toi32_i32$4;
                                                      i64toi32_i32$0 = $2;
                                                      i64toi32_i32$4 = HEAP32[($2 + 232 | 0) >> 2] | 0;
                                                      i64toi32_i32$2 = HEAP32[($2 + 236 | 0) >> 2] | 0;
                                                      $55 = i64toi32_i32$4;
                                                      $55$hi = i64toi32_i32$2;
                                                      i64toi32_i32$0 = $2;
                                                      i64toi32_i32$2 = HEAP32[($2 + 224 | 0) >> 2] | 0;
                                                      i64toi32_i32$4 = HEAP32[($2 + 228 | 0) >> 2] | 0;
                                                      $54 = i64toi32_i32$2;
                                                      $54$hi = i64toi32_i32$4;
                                                      i64toi32_i32$0 = $2;
                                                      i64toi32_i32$4 = HEAP32[($2 + 216 | 0) >> 2] | 0;
                                                      i64toi32_i32$2 = HEAP32[($2 + 220 | 0) >> 2] | 0;
                                                      $56 = i64toi32_i32$4;
                                                      $56$hi = i64toi32_i32$2;
                                                      $15 = HEAPU8[($2 + 208 | 0) >> 0] | 0;
                                                      i64toi32_i32$0 = $2;
                                                      i64toi32_i32$2 = HEAP32[($2 + 200 | 0) >> 2] | 0;
                                                      i64toi32_i32$4 = HEAP32[($2 + 204 | 0) >> 2] | 0;
                                                      i64toi32_i32$0 = i64toi32_i32$2;
                                                      i64toi32_i32$2 = 0;
                                                      i64toi32_i32$5 = 1;
                                                      if ((i64toi32_i32$0 | 0) != (i64toi32_i32$5 | 0) | (i64toi32_i32$4 | 0) != (i64toi32_i32$2 | 0) | 0) {
                                                       break label$38
                                                      }
                                                      i64toi32_i32$5 = $2 + 248 | 0;
                                                      i64toi32_i32$0 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                                      i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                                      $1102 = i64toi32_i32$0;
                                                      i64toi32_i32$0 = ($2 + 184 | 0) + 8 | 0;
                                                      HEAP32[i64toi32_i32$0 >> 2] = $1102;
                                                      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$4;
                                                      HEAP32[(($2 + 152 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 268 | 0) >> 2] | 0;
                                                      i64toi32_i32$5 = $2;
                                                      i64toi32_i32$4 = HEAP32[($2 + 260 | 0) >> 2] | 0;
                                                      i64toi32_i32$0 = HEAP32[($2 + 264 | 0) >> 2] | 0;
                                                      $1111 = i64toi32_i32$4;
                                                      i64toi32_i32$4 = $2;
                                                      HEAP32[($2 + 152 | 0) >> 2] = $1111;
                                                      HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
                                                      i64toi32_i32$5 = $2 + 240 | 0;
                                                      i64toi32_i32$0 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                                      i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                                      $1115 = i64toi32_i32$0;
                                                      i64toi32_i32$0 = $2;
                                                      HEAP32[($2 + 184 | 0) >> 2] = $1115;
                                                      HEAP32[($2 + 188 | 0) >> 2] = i64toi32_i32$4;
                                                      $1 = HEAP32[($2 + 256 | 0) >> 2] | 0;
                                                      i64toi32_i32$4 = $56$hi;
                                                      $30 = $56;
                                                      $30$hi = i64toi32_i32$4;
                                                     }
                                                     i64toi32_i32$4 = $55$hi;
                                                     i64toi32_i32$0 = $2 + 224 | 0;
                                                     HEAP32[i64toi32_i32$0 >> 2] = $55;
                                                     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$4;
                                                     i64toi32_i32$4 = $54$hi;
                                                     i64toi32_i32$0 = $2 + 216 | 0;
                                                     HEAP32[i64toi32_i32$0 >> 2] = $54;
                                                     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$4;
                                                     i64toi32_i32$4 = $30$hi;
                                                     i64toi32_i32$0 = ($2 + 200 | 0) + 8 | 0;
                                                     HEAP32[i64toi32_i32$0 >> 2] = $30;
                                                     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$4;
                                                     i64toi32_i32$5 = $2;
                                                     i64toi32_i32$4 = HEAP32[($2 + 184 | 0) >> 2] | 0;
                                                     i64toi32_i32$0 = HEAP32[($2 + 188 | 0) >> 2] | 0;
                                                     $1133 = i64toi32_i32$4;
                                                     i64toi32_i32$4 = $2 + 232 | 0;
                                                     HEAP32[i64toi32_i32$4 >> 2] = $1133;
                                                     HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$0;
                                                     i64toi32_i32$5 = $2;
                                                     i64toi32_i32$0 = HEAP32[($2 + 152 | 0) >> 2] | 0;
                                                     i64toi32_i32$4 = HEAP32[($2 + 156 | 0) >> 2] | 0;
                                                     $1137 = i64toi32_i32$0;
                                                     i64toi32_i32$0 = $2 + 252 | 0;
                                                     HEAP32[i64toi32_i32$0 >> 2] = $1137;
                                                     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$4;
                                                     i64toi32_i32$5 = ($2 + 184 | 0) + 8 | 0;
                                                     i64toi32_i32$4 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                                     i64toi32_i32$0 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                                     $1144 = i64toi32_i32$4;
                                                     i64toi32_i32$4 = ($2 + 200 | 0) + 40 | 0;
                                                     HEAP32[i64toi32_i32$4 >> 2] = $1144;
                                                     HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$0;
                                                     HEAP32[($2 + 260 | 0) >> 2] = HEAP32[(($2 + 152 | 0) + 8 | 0) >> 2] | 0;
                                                     HEAP8[($2 + 200 | 0) >> 0] = $15;
                                                     HEAP32[($2 + 248 | 0) >> 2] = $1;
                                                     i64toi32_i32$0 = $52$hi;
                                                     HEAP8[($2 + 201 | 0) >> 0] = $52;
                                                     HEAP8[($2 + 202 | 0) >> 0] = $52 >>> 8 | 0;
                                                     HEAP8[($2 + 203 | 0) >> 0] = $52 >>> 16 | 0;
                                                     HEAP8[($2 + 204 | 0) >> 0] = $52 >>> 24 | 0;
                                                     $1157 = $2;
                                                     i64toi32_i32$5 = $52;
                                                     i64toi32_i32$4 = 0;
                                                     i64toi32_i32$2 = 48;
                                                     i64toi32_i32$1 = i64toi32_i32$2 & 31 | 0;
                                                     if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                                                      i64toi32_i32$4 = 0;
                                                      $396 = i64toi32_i32$0 >>> i64toi32_i32$1 | 0;
                                                     } else {
                                                      i64toi32_i32$4 = i64toi32_i32$0 >>> i64toi32_i32$1 | 0;
                                                      $396 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$1 | 0) | 0;
                                                     }
                                                     HEAP8[($1157 + 207 | 0) >> 0] = $396;
                                                     $1160 = $2;
                                                     i64toi32_i32$4 = $52$hi;
                                                     i64toi32_i32$0 = $52;
                                                     i64toi32_i32$5 = 0;
                                                     i64toi32_i32$2 = 32;
                                                     i64toi32_i32$1 = i64toi32_i32$2 & 31 | 0;
                                                     if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                                                      i64toi32_i32$5 = 0;
                                                      $397 = i64toi32_i32$4 >>> i64toi32_i32$1 | 0;
                                                     } else {
                                                      i64toi32_i32$5 = i64toi32_i32$4 >>> i64toi32_i32$1 | 0;
                                                      $397 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$1 | 0) | 0;
                                                     }
                                                     $398 = $1160;
                                                     $399 = $397;
                                                     HEAP8[($398 + 205 | 0) >> 0] = $399;
                                                     HEAP8[($398 + 206 | 0) >> 0] = $399 >>> 8 | 0;
                                                     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($14 | 0, $2 + 200 | 0 | 0, 1052438 | 0, 15 | 0);
                                                     i64toi32_i32$4 = $2;
                                                     i64toi32_i32$5 = HEAP32[($2 + 72 | 0) >> 2] | 0;
                                                     i64toi32_i32$0 = HEAP32[($2 + 76 | 0) >> 2] | 0;
                                                     $47 = i64toi32_i32$5;
                                                     $47$hi = i64toi32_i32$0;
                                                     i64toi32_i32$4 = i64toi32_i32$5;
                                                     i64toi32_i32$5 = -1;
                                                     i64toi32_i32$2 = -256;
                                                     i64toi32_i32$5 = i64toi32_i32$0 & i64toi32_i32$5 | 0;
                                                     $46 = i64toi32_i32$4 & i64toi32_i32$2 | 0;
                                                     $46$hi = i64toi32_i32$5;
                                                     i64toi32_i32$0 = ($2 + 64 | 0) + 40 | 0;
                                                     i64toi32_i32$5 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                     i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                     $50 = i64toi32_i32$5;
                                                     $50$hi = i64toi32_i32$4;
                                                     i64toi32_i32$0 = $2 + 112 | 0;
                                                     i64toi32_i32$4 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                     i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                     $49 = i64toi32_i32$4;
                                                     $49$hi = i64toi32_i32$5;
                                                     $19 = HEAP32[($2 + 120 | 0) >> 2] | 0;
                                                     i64toi32_i32$0 = $2 + 128 | 0;
                                                     i64toi32_i32$5 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                     i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                     $53 = i64toi32_i32$5;
                                                     $53$hi = i64toi32_i32$4;
                                                     i64toi32_i32$0 = $2;
                                                     i64toi32_i32$4 = HEAP32[($2 + 80 | 0) >> 2] | 0;
                                                     i64toi32_i32$5 = HEAP32[($2 + 84 | 0) >> 2] | 0;
                                                     $48 = i64toi32_i32$4;
                                                     $48$hi = i64toi32_i32$5;
                                                     i64toi32_i32$0 = $2;
                                                     i64toi32_i32$5 = HEAP32[($2 + 88 | 0) >> 2] | 0;
                                                     i64toi32_i32$4 = HEAP32[($2 + 92 | 0) >> 2] | 0;
                                                     $51 = i64toi32_i32$5;
                                                     $51$hi = i64toi32_i32$4;
                                                     i64toi32_i32$0 = $2;
                                                     i64toi32_i32$4 = HEAP32[($2 + 96 | 0) >> 2] | 0;
                                                     i64toi32_i32$5 = HEAP32[($2 + 100 | 0) >> 2] | 0;
                                                     $32 = i64toi32_i32$4;
                                                     $32$hi = i64toi32_i32$5;
                                                     $15 = HEAP32[($2 + 124 | 0) >> 2] | 0;
                                                     break label$4;
                                                    }
                                                    label$106 : {
                                                     label$107 : {
                                                      i64toi32_i32$5 = $31$hi;
                                                      i64toi32_i32$0 = $31;
                                                      i64toi32_i32$4 = 0;
                                                      i64toi32_i32$2 = 1;
                                                      if ((i64toi32_i32$0 | 0) != (i64toi32_i32$2 | 0) | (i64toi32_i32$5 | 0) != (i64toi32_i32$4 | 0) | 0) {
                                                       break label$107
                                                      }
                                                      i64toi32_i32$0 = $32$hi;
                                                      i64toi32_i32$2 = $32;
                                                      i64toi32_i32$5 = 0;
                                                      i64toi32_i32$4 = 1;
                                                      i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
                                                      i64toi32_i32$3 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
                                                      if (i64toi32_i32$1 >>> 0 < i64toi32_i32$4 >>> 0) {
                                                       i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
                                                      }
                                                      $32 = i64toi32_i32$1;
                                                      $32$hi = i64toi32_i32$3;
                                                      i64toi32_i32$3 = $30$hi;
                                                      i64toi32_i32$3 = $32$hi;
                                                      i64toi32_i32$0 = i64toi32_i32$1;
                                                      i64toi32_i32$2 = $30$hi;
                                                      i64toi32_i32$4 = $30;
                                                      if (i64toi32_i32$3 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$0 >>> 0 <= i64toi32_i32$4 >>> 0 | 0) | 0) {
                                                       break label$107
                                                      }
                                                      i64toi32_i32$0 = 0;
                                                      $52 = 0;
                                                      $52$hi = i64toi32_i32$0;
                                                      $1 = 3;
                                                      $15 = 0;
                                                      break label$106;
                                                     }
                                                     $cardano_serialization_lib__plutus__Costmdls_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hfe094af3bf4c55f1($2 + 200 | 0 | 0, $1 | 0);
                                                     if ((HEAP32[($2 + 200 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                                                      break label$37
                                                     }
                                                     i64toi32_i32$4 = $2 + 248 | 0;
                                                     i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                                     i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                                     $31 = i64toi32_i32$0;
                                                     $31$hi = i64toi32_i32$3;
                                                     i64toi32_i32$0 = ($2 + 184 | 0) + 8 | 0;
                                                     HEAP32[i64toi32_i32$0 >> 2] = $31;
                                                     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
                                                     $20 = HEAP32[($2 + 268 | 0) >> 2] | 0;
                                                     HEAP32[(($2 + 168 | 0) + 8 | 0) >> 2] = $20;
                                                     i64toi32_i32$0 = ($2 + 152 | 0) + 8 | 0;
                                                     HEAP32[i64toi32_i32$0 >> 2] = $31;
                                                     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
                                                     i64toi32_i32$4 = $2 + 240 | 0;
                                                     i64toi32_i32$3 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                                     i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                                     $31 = i64toi32_i32$3;
                                                     $31$hi = i64toi32_i32$0;
                                                     i64toi32_i32$3 = $2;
                                                     HEAP32[($2 + 184 | 0) >> 2] = $31;
                                                     HEAP32[($2 + 188 | 0) >> 2] = i64toi32_i32$0;
                                                     i64toi32_i32$4 = $2 + 260 | 0;
                                                     i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                                     i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                                     $32 = i64toi32_i32$0;
                                                     $32$hi = i64toi32_i32$3;
                                                     i64toi32_i32$0 = $2;
                                                     HEAP32[($2 + 168 | 0) >> 2] = $32;
                                                     HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$3;
                                                     i64toi32_i32$3 = $31$hi;
                                                     i64toi32_i32$0 = $2;
                                                     HEAP32[($2 + 152 | 0) >> 2] = $31;
                                                     HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$3;
                                                     i64toi32_i32$4 = $2 + 232 | 0;
                                                     i64toi32_i32$3 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                                     i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                                     $47 = i64toi32_i32$3;
                                                     $47$hi = i64toi32_i32$0;
                                                     i64toi32_i32$4 = $2 + 224 | 0;
                                                     i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                                     i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                                     $52 = i64toi32_i32$0;
                                                     $52$hi = i64toi32_i32$3;
                                                     i64toi32_i32$4 = $2 + 216 | 0;
                                                     i64toi32_i32$3 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                                     i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                                     $30 = i64toi32_i32$3;
                                                     $30$hi = i64toi32_i32$0;
                                                     $15 = HEAP32[($2 + 256 | 0) >> 2] | 0;
                                                     i64toi32_i32$4 = $2 + 213 | 0;
                                                     i64toi32_i32$0 = HEAPU8[i64toi32_i32$4 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$4 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
                                                     i64toi32_i32$3 = 0;
                                                     $31 = i64toi32_i32$0;
                                                     $31$hi = i64toi32_i32$3;
                                                     i64toi32_i32$4 = $2 + 215 | 0;
                                                     i64toi32_i32$3 = HEAPU8[i64toi32_i32$4 >> 0] | 0;
                                                     i64toi32_i32$0 = 0;
                                                     $48 = i64toi32_i32$3;
                                                     $48$hi = i64toi32_i32$0;
                                                     $1 = HEAPU8[($2 + 208 | 0) >> 0] | 0;
                                                     i64toi32_i32$4 = $2;
                                                     i64toi32_i32$0 = HEAPU8[($2 + 209 | 0) >> 0] | 0 | ((HEAPU8[($2 + 210 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 211 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 212 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                                     i64toi32_i32$3 = 0;
                                                     $51 = i64toi32_i32$0;
                                                     $51$hi = i64toi32_i32$3;
                                                     HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] = $20;
                                                     i64toi32_i32$3 = $32$hi;
                                                     i64toi32_i32$0 = $2;
                                                     HEAP32[($2 + 136 | 0) >> 2] = $32;
                                                     HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$3;
                                                     i64toi32_i32$3 = $51$hi;
                                                     $1262 = $51;
                                                     $1262$hi = i64toi32_i32$3;
                                                     i64toi32_i32$3 = $31$hi;
                                                     $1263 = $31;
                                                     $1263$hi = i64toi32_i32$3;
                                                     i64toi32_i32$3 = $48$hi;
                                                     i64toi32_i32$4 = $48;
                                                     i64toi32_i32$0 = 0;
                                                     i64toi32_i32$2 = 16;
                                                     i64toi32_i32$5 = i64toi32_i32$2 & 31 | 0;
                                                     if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                                                      i64toi32_i32$0 = i64toi32_i32$4 << i64toi32_i32$5 | 0;
                                                      $400 = 0;
                                                     } else {
                                                      i64toi32_i32$0 = ((1 << i64toi32_i32$5 | 0) - 1 | 0) & (i64toi32_i32$4 >>> (32 - i64toi32_i32$5 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$5 | 0) | 0;
                                                      $400 = i64toi32_i32$4 << i64toi32_i32$5 | 0;
                                                     }
                                                     $1265$hi = i64toi32_i32$0;
                                                     i64toi32_i32$0 = $1263$hi;
                                                     i64toi32_i32$3 = $1263;
                                                     i64toi32_i32$4 = $1265$hi;
                                                     i64toi32_i32$2 = $400;
                                                     i64toi32_i32$4 = i64toi32_i32$0 | i64toi32_i32$4 | 0;
                                                     i64toi32_i32$0 = i64toi32_i32$3 | i64toi32_i32$2 | 0;
                                                     i64toi32_i32$3 = 0;
                                                     i64toi32_i32$2 = 32;
                                                     i64toi32_i32$5 = i64toi32_i32$2 & 31 | 0;
                                                     if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                                                      i64toi32_i32$3 = i64toi32_i32$0 << i64toi32_i32$5 | 0;
                                                      $401 = 0;
                                                     } else {
                                                      i64toi32_i32$3 = ((1 << i64toi32_i32$5 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$5 | 0) | 0) | 0 | (i64toi32_i32$4 << i64toi32_i32$5 | 0) | 0;
                                                      $401 = i64toi32_i32$0 << i64toi32_i32$5 | 0;
                                                     }
                                                     $1267$hi = i64toi32_i32$3;
                                                     i64toi32_i32$3 = $1262$hi;
                                                     i64toi32_i32$4 = $1262;
                                                     i64toi32_i32$0 = $1267$hi;
                                                     i64toi32_i32$2 = $401;
                                                     i64toi32_i32$0 = i64toi32_i32$3 | i64toi32_i32$0 | 0;
                                                     $31 = i64toi32_i32$4 | i64toi32_i32$2 | 0;
                                                     $31$hi = i64toi32_i32$0;
                                                    }
                                                    i64toi32_i32$0 = $47$hi;
                                                    i64toi32_i32$4 = ($2 + 200 | 0) + 24 | 0;
                                                    HEAP32[i64toi32_i32$4 >> 2] = $47;
                                                    HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$0;
                                                    i64toi32_i32$0 = $52$hi;
                                                    i64toi32_i32$4 = ($2 + 200 | 0) + 16 | 0;
                                                    HEAP32[i64toi32_i32$4 >> 2] = $52;
                                                    HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$0;
                                                    i64toi32_i32$0 = $30$hi;
                                                    i64toi32_i32$4 = ($2 + 200 | 0) + 8 | 0;
                                                    HEAP32[i64toi32_i32$4 >> 2] = $30;
                                                    HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$0;
                                                    i64toi32_i32$3 = $2;
                                                    i64toi32_i32$0 = HEAP32[($2 + 152 | 0) >> 2] | 0;
                                                    i64toi32_i32$4 = HEAP32[($2 + 156 | 0) >> 2] | 0;
                                                    $1285 = i64toi32_i32$0;
                                                    i64toi32_i32$0 = ($2 + 200 | 0) + 32 | 0;
                                                    HEAP32[i64toi32_i32$0 >> 2] = $1285;
                                                    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$4;
                                                    i64toi32_i32$3 = $2;
                                                    i64toi32_i32$4 = HEAP32[($2 + 136 | 0) >> 2] | 0;
                                                    i64toi32_i32$0 = HEAP32[($2 + 140 | 0) >> 2] | 0;
                                                    $1289 = i64toi32_i32$4;
                                                    i64toi32_i32$4 = $2 + 252 | 0;
                                                    HEAP32[i64toi32_i32$4 >> 2] = $1289;
                                                    HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$0;
                                                    i64toi32_i32$3 = ($2 + 152 | 0) + 8 | 0;
                                                    i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                                    i64toi32_i32$4 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                                    $1296 = i64toi32_i32$0;
                                                    i64toi32_i32$0 = ($2 + 200 | 0) + 40 | 0;
                                                    HEAP32[i64toi32_i32$0 >> 2] = $1296;
                                                    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$4;
                                                    HEAP32[(($2 + 200 | 0) + 60 | 0) >> 2] = HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] | 0;
                                                    HEAP8[($2 + 200 | 0) >> 0] = $1;
                                                    HEAP32[($2 + 248 | 0) >> 2] = $15;
                                                    i64toi32_i32$4 = $31$hi;
                                                    HEAP8[($2 + 201 | 0) >> 0] = $31;
                                                    HEAP8[($2 + 202 | 0) >> 0] = $31 >>> 8 | 0;
                                                    HEAP8[($2 + 203 | 0) >> 0] = $31 >>> 16 | 0;
                                                    HEAP8[($2 + 204 | 0) >> 0] = $31 >>> 24 | 0;
                                                    $1310 = $2;
                                                    i64toi32_i32$3 = $31;
                                                    i64toi32_i32$0 = 0;
                                                    i64toi32_i32$2 = 48;
                                                    i64toi32_i32$5 = i64toi32_i32$2 & 31 | 0;
                                                    if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                                                     i64toi32_i32$0 = 0;
                                                     $402 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
                                                    } else {
                                                     i64toi32_i32$0 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
                                                     $402 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$5 | 0) | 0;
                                                    }
                                                    HEAP8[($1310 + 207 | 0) >> 0] = $402;
                                                    $1313 = $2;
                                                    i64toi32_i32$0 = $31$hi;
                                                    i64toi32_i32$4 = $31;
                                                    i64toi32_i32$3 = 0;
                                                    i64toi32_i32$2 = 32;
                                                    i64toi32_i32$5 = i64toi32_i32$2 & 31 | 0;
                                                    if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                                                     i64toi32_i32$3 = 0;
                                                     $403 = i64toi32_i32$0 >>> i64toi32_i32$5 | 0;
                                                    } else {
                                                     i64toi32_i32$3 = i64toi32_i32$0 >>> i64toi32_i32$5 | 0;
                                                     $403 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$5 | 0) | 0;
                                                    }
                                                    $404 = $1313;
                                                    $405 = $403;
                                                    HEAP8[($404 + 205 | 0) >> 0] = $405;
                                                    HEAP8[($404 + 206 | 0) >> 0] = $405 >>> 8 | 0;
                                                    cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($14 | 0, $2 + 200 | 0 | 0, 1052427 | 0, 11 | 0);
                                                    i64toi32_i32$0 = $2;
                                                    i64toi32_i32$3 = HEAP32[($2 + 72 | 0) >> 2] | 0;
                                                    i64toi32_i32$4 = HEAP32[($2 + 76 | 0) >> 2] | 0;
                                                    $47 = i64toi32_i32$3;
                                                    $47$hi = i64toi32_i32$4;
                                                    i64toi32_i32$0 = i64toi32_i32$3;
                                                    i64toi32_i32$3 = -1;
                                                    i64toi32_i32$2 = -256;
                                                    i64toi32_i32$3 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
                                                    $46 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
                                                    $46$hi = i64toi32_i32$3;
                                                    i64toi32_i32$4 = ($2 + 64 | 0) + 16 | 0;
                                                    i64toi32_i32$3 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                                    i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                                    $48 = i64toi32_i32$3;
                                                    $48$hi = i64toi32_i32$0;
                                                    i64toi32_i32$4 = ($2 + 64 | 0) + 24 | 0;
                                                    i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                                    i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                                    $51 = i64toi32_i32$0;
                                                    $51$hi = i64toi32_i32$3;
                                                    i64toi32_i32$4 = ($2 + 64 | 0) + 32 | 0;
                                                    i64toi32_i32$3 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                                    i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                                    $32 = i64toi32_i32$3;
                                                    $32$hi = i64toi32_i32$0;
                                                    i64toi32_i32$4 = ($2 + 64 | 0) + 40 | 0;
                                                    i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                                    i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                                    $50 = i64toi32_i32$0;
                                                    $50$hi = i64toi32_i32$3;
                                                    i64toi32_i32$4 = $2 + 112 | 0;
                                                    i64toi32_i32$3 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                                    i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                                    $49 = i64toi32_i32$3;
                                                    $49$hi = i64toi32_i32$0;
                                                    $19 = HEAP32[($2 + 120 | 0) >> 2] | 0;
                                                    $15 = HEAP32[(($2 + 64 | 0) + 60 | 0) >> 2] | 0;
                                                    i64toi32_i32$4 = $2 + 128 | 0;
                                                    i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                                    i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                                    $53 = i64toi32_i32$0;
                                                    $53$hi = i64toi32_i32$3;
                                                    break label$4;
                                                   }
                                                   label$108 : {
                                                    label$109 : {
                                                     i64toi32_i32$3 = $31$hi;
                                                     i64toi32_i32$4 = $31;
                                                     i64toi32_i32$0 = 0;
                                                     i64toi32_i32$2 = 1;
                                                     if ((i64toi32_i32$4 | 0) != (i64toi32_i32$2 | 0) | (i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | 0) {
                                                      break label$109
                                                     }
                                                     i64toi32_i32$4 = $32$hi;
                                                     i64toi32_i32$2 = $32;
                                                     i64toi32_i32$3 = 0;
                                                     i64toi32_i32$0 = 1;
                                                     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
                                                     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
                                                     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$0 >>> 0) {
                                                      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
                                                     }
                                                     $32 = i64toi32_i32$5;
                                                     $32$hi = i64toi32_i32$1;
                                                     i64toi32_i32$1 = $30$hi;
                                                     i64toi32_i32$1 = $32$hi;
                                                     i64toi32_i32$4 = i64toi32_i32$5;
                                                     i64toi32_i32$2 = $30$hi;
                                                     i64toi32_i32$0 = $30;
                                                     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$5 >>> 0 <= i64toi32_i32$0 >>> 0 | 0) | 0) {
                                                      break label$109
                                                     }
                                                     i64toi32_i32$4 = 0;
                                                     $31 = 0;
                                                     $31$hi = i64toi32_i32$4;
                                                     i64toi32_i32$4 = 0;
                                                     $52 = 3;
                                                     $52$hi = i64toi32_i32$4;
                                                     $1 = 0;
                                                     break label$108;
                                                    }
                                                    $cardano_serialization_lib__utils__BigNum_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h29637bb571dceb02($2 + 200 | 0 | 0, $1 | 0);
                                                    i64toi32_i32$0 = $2;
                                                    i64toi32_i32$4 = HEAP32[($2 + 200 | 0) >> 2] | 0;
                                                    i64toi32_i32$1 = HEAP32[($2 + 204 | 0) >> 2] | 0;
                                                    i64toi32_i32$0 = i64toi32_i32$4;
                                                    i64toi32_i32$4 = 0;
                                                    i64toi32_i32$2 = 1;
                                                    if ((i64toi32_i32$0 | 0) != (i64toi32_i32$2 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$4 | 0) | 0) {
                                                     break label$36
                                                    }
                                                    $1 = HEAP32[($2 + 268 | 0) >> 2] | 0;
                                                    HEAP32[(($2 + 168 | 0) + 8 | 0) >> 2] = $1;
                                                    i64toi32_i32$2 = $2 + 248 | 0;
                                                    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                                    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                                    $1377 = i64toi32_i32$0;
                                                    i64toi32_i32$0 = ($2 + 152 | 0) + 8 | 0;
                                                    HEAP32[i64toi32_i32$0 >> 2] = $1377;
                                                    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
                                                    HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] = $1;
                                                    i64toi32_i32$2 = $2;
                                                    i64toi32_i32$1 = HEAP32[($2 + 260 | 0) >> 2] | 0;
                                                    i64toi32_i32$0 = HEAP32[($2 + 264 | 0) >> 2] | 0;
                                                    $31 = i64toi32_i32$1;
                                                    $31$hi = i64toi32_i32$0;
                                                    i64toi32_i32$1 = $2;
                                                    HEAP32[($2 + 168 | 0) >> 2] = $31;
                                                    HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$0;
                                                    i64toi32_i32$1 = $2;
                                                    HEAP32[($2 + 136 | 0) >> 2] = $31;
                                                    HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$0;
                                                    i64toi32_i32$2 = $2 + 240 | 0;
                                                    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                                    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                                    $1391 = i64toi32_i32$0;
                                                    i64toi32_i32$0 = $2;
                                                    HEAP32[($2 + 152 | 0) >> 2] = $1391;
                                                    HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$1;
                                                    i64toi32_i32$2 = $2 + 232 | 0;
                                                    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                                    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                                    $47 = i64toi32_i32$1;
                                                    $47$hi = i64toi32_i32$0;
                                                    i64toi32_i32$2 = $2 + 224 | 0;
                                                    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                                    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                                    $31 = i64toi32_i32$0;
                                                    $31$hi = i64toi32_i32$1;
                                                    i64toi32_i32$2 = $2 + 216 | 0;
                                                    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                                    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                                    $30 = i64toi32_i32$1;
                                                    $30$hi = i64toi32_i32$0;
                                                    $1 = HEAP32[($2 + 256 | 0) >> 2] | 0;
                                                    i64toi32_i32$2 = $2;
                                                    i64toi32_i32$0 = HEAP32[($2 + 208 | 0) >> 2] | 0;
                                                    i64toi32_i32$1 = HEAP32[($2 + 212 | 0) >> 2] | 0;
                                                    $52 = i64toi32_i32$0;
                                                    $52$hi = i64toi32_i32$1;
                                                   }
                                                   i64toi32_i32$1 = $47$hi;
                                                   i64toi32_i32$0 = ($2 + 200 | 0) + 24 | 0;
                                                   HEAP32[i64toi32_i32$0 >> 2] = $47;
                                                   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
                                                   i64toi32_i32$1 = $31$hi;
                                                   i64toi32_i32$0 = ($2 + 200 | 0) + 16 | 0;
                                                   HEAP32[i64toi32_i32$0 >> 2] = $31;
                                                   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
                                                   i64toi32_i32$1 = $30$hi;
                                                   i64toi32_i32$0 = ($2 + 200 | 0) + 8 | 0;
                                                   HEAP32[i64toi32_i32$0 >> 2] = $30;
                                                   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
                                                   i64toi32_i32$2 = $2;
                                                   i64toi32_i32$1 = HEAP32[($2 + 152 | 0) >> 2] | 0;
                                                   i64toi32_i32$0 = HEAP32[($2 + 156 | 0) >> 2] | 0;
                                                   $1422 = i64toi32_i32$1;
                                                   i64toi32_i32$1 = ($2 + 200 | 0) + 32 | 0;
                                                   HEAP32[i64toi32_i32$1 >> 2] = $1422;
                                                   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                                                   i64toi32_i32$2 = $2;
                                                   i64toi32_i32$0 = HEAP32[($2 + 136 | 0) >> 2] | 0;
                                                   i64toi32_i32$1 = HEAP32[($2 + 140 | 0) >> 2] | 0;
                                                   $1426 = i64toi32_i32$0;
                                                   i64toi32_i32$0 = $2 + 252 | 0;
                                                   HEAP32[i64toi32_i32$0 >> 2] = $1426;
                                                   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
                                                   i64toi32_i32$2 = ($2 + 152 | 0) + 8 | 0;
                                                   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                                   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                                   $1433 = i64toi32_i32$1;
                                                   i64toi32_i32$1 = ($2 + 200 | 0) + 40 | 0;
                                                   HEAP32[i64toi32_i32$1 >> 2] = $1433;
                                                   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                                                   HEAP32[(($2 + 200 | 0) + 60 | 0) >> 2] = HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] | 0;
                                                   i64toi32_i32$0 = $52$hi;
                                                   i64toi32_i32$1 = $2;
                                                   HEAP32[($2 + 200 | 0) >> 2] = $52;
                                                   HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$0;
                                                   HEAP32[($2 + 248 | 0) >> 2] = $1;
                                                   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($14 | 0, $2 + 200 | 0 | 0, 1052410 | 0, 17 | 0);
                                                   i64toi32_i32$2 = $2;
                                                   i64toi32_i32$0 = HEAP32[($2 + 72 | 0) >> 2] | 0;
                                                   i64toi32_i32$1 = HEAP32[($2 + 76 | 0) >> 2] | 0;
                                                   $47 = i64toi32_i32$0;
                                                   $47$hi = i64toi32_i32$1;
                                                   i64toi32_i32$2 = i64toi32_i32$0;
                                                   i64toi32_i32$0 = -1;
                                                   i64toi32_i32$4 = -256;
                                                   i64toi32_i32$0 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
                                                   $46 = i64toi32_i32$2 & i64toi32_i32$4 | 0;
                                                   $46$hi = i64toi32_i32$0;
                                                   i64toi32_i32$1 = ($2 + 64 | 0) + 16 | 0;
                                                   i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                                   i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                                   $48 = i64toi32_i32$0;
                                                   $48$hi = i64toi32_i32$2;
                                                   i64toi32_i32$1 = ($2 + 64 | 0) + 24 | 0;
                                                   i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                                   i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                                   $51 = i64toi32_i32$2;
                                                   $51$hi = i64toi32_i32$0;
                                                   i64toi32_i32$1 = ($2 + 64 | 0) + 32 | 0;
                                                   i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                                   i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                                   $32 = i64toi32_i32$0;
                                                   $32$hi = i64toi32_i32$2;
                                                   i64toi32_i32$1 = ($2 + 64 | 0) + 40 | 0;
                                                   i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                                   i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                                   $50 = i64toi32_i32$2;
                                                   $50$hi = i64toi32_i32$0;
                                                   i64toi32_i32$1 = $2 + 112 | 0;
                                                   i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                                   i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                                   $49 = i64toi32_i32$0;
                                                   $49$hi = i64toi32_i32$2;
                                                   $19 = HEAP32[($2 + 120 | 0) >> 2] | 0;
                                                   $15 = HEAP32[(($2 + 64 | 0) + 60 | 0) >> 2] | 0;
                                                   i64toi32_i32$1 = $2 + 128 | 0;
                                                   i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                                   i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                                   $53 = i64toi32_i32$2;
                                                   $53$hi = i64toi32_i32$0;
                                                   break label$4;
                                                  }
                                                  label$110 : {
                                                   label$111 : {
                                                    i64toi32_i32$0 = $31$hi;
                                                    i64toi32_i32$1 = $31;
                                                    i64toi32_i32$2 = 0;
                                                    i64toi32_i32$4 = 1;
                                                    if ((i64toi32_i32$1 | 0) != (i64toi32_i32$4 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$2 | 0) | 0) {
                                                     break label$111
                                                    }
                                                    i64toi32_i32$1 = $32$hi;
                                                    i64toi32_i32$4 = $32;
                                                    i64toi32_i32$0 = 0;
                                                    i64toi32_i32$2 = 1;
                                                    i64toi32_i32$3 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
                                                    i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
                                                    if (i64toi32_i32$3 >>> 0 < i64toi32_i32$2 >>> 0) {
                                                     i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
                                                    }
                                                    $32 = i64toi32_i32$3;
                                                    $32$hi = i64toi32_i32$5;
                                                    i64toi32_i32$5 = $30$hi;
                                                    i64toi32_i32$5 = $32$hi;
                                                    i64toi32_i32$1 = i64toi32_i32$3;
                                                    i64toi32_i32$4 = $30$hi;
                                                    i64toi32_i32$2 = $30;
                                                    if (i64toi32_i32$5 >>> 0 < i64toi32_i32$4 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$4 | 0) & i64toi32_i32$3 >>> 0 <= i64toi32_i32$2 >>> 0 | 0) | 0) {
                                                     break label$111
                                                    }
                                                    i64toi32_i32$1 = 0;
                                                    $31 = 0;
                                                    $31$hi = i64toi32_i32$1;
                                                    i64toi32_i32$1 = 0;
                                                    $52 = 3;
                                                    $52$hi = i64toi32_i32$1;
                                                    $1 = 0;
                                                    break label$110;
                                                   }
                                                   $cardano_serialization_lib__utils__BigNum_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h29637bb571dceb02($2 + 200 | 0 | 0, $1 | 0);
                                                   i64toi32_i32$2 = $2;
                                                   i64toi32_i32$1 = HEAP32[($2 + 200 | 0) >> 2] | 0;
                                                   i64toi32_i32$5 = HEAP32[($2 + 204 | 0) >> 2] | 0;
                                                   i64toi32_i32$2 = i64toi32_i32$1;
                                                   i64toi32_i32$1 = 0;
                                                   i64toi32_i32$4 = 1;
                                                   if ((i64toi32_i32$2 | 0) != (i64toi32_i32$4 | 0) | (i64toi32_i32$5 | 0) != (i64toi32_i32$1 | 0) | 0) {
                                                    break label$35
                                                   }
                                                   $1 = HEAP32[($2 + 268 | 0) >> 2] | 0;
                                                   HEAP32[(($2 + 168 | 0) + 8 | 0) >> 2] = $1;
                                                   i64toi32_i32$4 = $2 + 248 | 0;
                                                   i64toi32_i32$2 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                                   i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                                   $1506 = i64toi32_i32$2;
                                                   i64toi32_i32$2 = ($2 + 152 | 0) + 8 | 0;
                                                   HEAP32[i64toi32_i32$2 >> 2] = $1506;
                                                   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$5;
                                                   HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] = $1;
                                                   i64toi32_i32$4 = $2;
                                                   i64toi32_i32$5 = HEAP32[($2 + 260 | 0) >> 2] | 0;
                                                   i64toi32_i32$2 = HEAP32[($2 + 264 | 0) >> 2] | 0;
                                                   $31 = i64toi32_i32$5;
                                                   $31$hi = i64toi32_i32$2;
                                                   i64toi32_i32$5 = $2;
                                                   HEAP32[($2 + 168 | 0) >> 2] = $31;
                                                   HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$2;
                                                   i64toi32_i32$5 = $2;
                                                   HEAP32[($2 + 136 | 0) >> 2] = $31;
                                                   HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$2;
                                                   i64toi32_i32$4 = $2 + 240 | 0;
                                                   i64toi32_i32$2 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                                   i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                                   $1520 = i64toi32_i32$2;
                                                   i64toi32_i32$2 = $2;
                                                   HEAP32[($2 + 152 | 0) >> 2] = $1520;
                                                   HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$5;
                                                   i64toi32_i32$4 = $2 + 232 | 0;
                                                   i64toi32_i32$5 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                                   i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                                   $47 = i64toi32_i32$5;
                                                   $47$hi = i64toi32_i32$2;
                                                   i64toi32_i32$4 = $2 + 224 | 0;
                                                   i64toi32_i32$2 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                                   i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                                   $31 = i64toi32_i32$2;
                                                   $31$hi = i64toi32_i32$5;
                                                   i64toi32_i32$4 = $2 + 216 | 0;
                                                   i64toi32_i32$5 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                                   i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                                   $30 = i64toi32_i32$5;
                                                   $30$hi = i64toi32_i32$2;
                                                   $1 = HEAP32[($2 + 256 | 0) >> 2] | 0;
                                                   i64toi32_i32$4 = $2;
                                                   i64toi32_i32$2 = HEAP32[($2 + 208 | 0) >> 2] | 0;
                                                   i64toi32_i32$5 = HEAP32[($2 + 212 | 0) >> 2] | 0;
                                                   $52 = i64toi32_i32$2;
                                                   $52$hi = i64toi32_i32$5;
                                                  }
                                                  i64toi32_i32$5 = $47$hi;
                                                  i64toi32_i32$2 = ($2 + 200 | 0) + 24 | 0;
                                                  HEAP32[i64toi32_i32$2 >> 2] = $47;
                                                  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$5;
                                                  i64toi32_i32$5 = $31$hi;
                                                  i64toi32_i32$2 = ($2 + 200 | 0) + 16 | 0;
                                                  HEAP32[i64toi32_i32$2 >> 2] = $31;
                                                  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$5;
                                                  i64toi32_i32$5 = $30$hi;
                                                  i64toi32_i32$2 = ($2 + 200 | 0) + 8 | 0;
                                                  HEAP32[i64toi32_i32$2 >> 2] = $30;
                                                  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$5;
                                                  i64toi32_i32$4 = $2;
                                                  i64toi32_i32$5 = HEAP32[($2 + 152 | 0) >> 2] | 0;
                                                  i64toi32_i32$2 = HEAP32[($2 + 156 | 0) >> 2] | 0;
                                                  $1551 = i64toi32_i32$5;
                                                  i64toi32_i32$5 = ($2 + 200 | 0) + 32 | 0;
                                                  HEAP32[i64toi32_i32$5 >> 2] = $1551;
                                                  HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$2;
                                                  i64toi32_i32$4 = $2;
                                                  i64toi32_i32$2 = HEAP32[($2 + 136 | 0) >> 2] | 0;
                                                  i64toi32_i32$5 = HEAP32[($2 + 140 | 0) >> 2] | 0;
                                                  $1555 = i64toi32_i32$2;
                                                  i64toi32_i32$2 = $2 + 252 | 0;
                                                  HEAP32[i64toi32_i32$2 >> 2] = $1555;
                                                  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$5;
                                                  i64toi32_i32$4 = ($2 + 152 | 0) + 8 | 0;
                                                  i64toi32_i32$5 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                                  i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                                  $1562 = i64toi32_i32$5;
                                                  i64toi32_i32$5 = ($2 + 200 | 0) + 40 | 0;
                                                  HEAP32[i64toi32_i32$5 >> 2] = $1562;
                                                  HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$2;
                                                  HEAP32[(($2 + 200 | 0) + 60 | 0) >> 2] = HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] | 0;
                                                  i64toi32_i32$2 = $52$hi;
                                                  i64toi32_i32$5 = $2;
                                                  HEAP32[($2 + 200 | 0) >> 2] = $52;
                                                  HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$2;
                                                  HEAP32[($2 + 248 | 0) >> 2] = $1;
                                                  cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($14 | 0, $2 + 200 | 0 | 0, 1052397 | 0, 13 | 0);
                                                  i64toi32_i32$4 = $2;
                                                  i64toi32_i32$2 = HEAP32[($2 + 72 | 0) >> 2] | 0;
                                                  i64toi32_i32$5 = HEAP32[($2 + 76 | 0) >> 2] | 0;
                                                  $47 = i64toi32_i32$2;
                                                  $47$hi = i64toi32_i32$5;
                                                  i64toi32_i32$4 = i64toi32_i32$2;
                                                  i64toi32_i32$2 = -1;
                                                  i64toi32_i32$1 = -256;
                                                  i64toi32_i32$2 = i64toi32_i32$5 & i64toi32_i32$2 | 0;
                                                  $46 = i64toi32_i32$4 & i64toi32_i32$1 | 0;
                                                  $46$hi = i64toi32_i32$2;
                                                  i64toi32_i32$5 = ($2 + 64 | 0) + 16 | 0;
                                                  i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                                  i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                                  $48 = i64toi32_i32$2;
                                                  $48$hi = i64toi32_i32$4;
                                                  i64toi32_i32$5 = ($2 + 64 | 0) + 24 | 0;
                                                  i64toi32_i32$4 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                                  i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                                  $51 = i64toi32_i32$4;
                                                  $51$hi = i64toi32_i32$2;
                                                  i64toi32_i32$5 = ($2 + 64 | 0) + 32 | 0;
                                                  i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                                  i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                                  $32 = i64toi32_i32$2;
                                                  $32$hi = i64toi32_i32$4;
                                                  i64toi32_i32$5 = ($2 + 64 | 0) + 40 | 0;
                                                  i64toi32_i32$4 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                                  i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                                  $50 = i64toi32_i32$4;
                                                  $50$hi = i64toi32_i32$2;
                                                  i64toi32_i32$5 = $2 + 112 | 0;
                                                  i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                                  i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                                  $49 = i64toi32_i32$2;
                                                  $49$hi = i64toi32_i32$4;
                                                  $19 = HEAP32[($2 + 120 | 0) >> 2] | 0;
                                                  $15 = HEAP32[(($2 + 64 | 0) + 60 | 0) >> 2] | 0;
                                                  i64toi32_i32$5 = $2 + 128 | 0;
                                                  i64toi32_i32$4 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                                  i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                                  $53 = i64toi32_i32$4;
                                                  $53$hi = i64toi32_i32$2;
                                                  break label$4;
                                                 }
                                                 label$112 : {
                                                  label$113 : {
                                                   i64toi32_i32$2 = $31$hi;
                                                   i64toi32_i32$5 = $31;
                                                   i64toi32_i32$4 = 0;
                                                   i64toi32_i32$1 = 1;
                                                   if ((i64toi32_i32$5 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$4 | 0) | 0) {
                                                    break label$113
                                                   }
                                                   i64toi32_i32$5 = $32$hi;
                                                   i64toi32_i32$1 = $32;
                                                   i64toi32_i32$2 = 0;
                                                   i64toi32_i32$4 = 1;
                                                   i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
                                                   i64toi32_i32$3 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
                                                   if (i64toi32_i32$0 >>> 0 < i64toi32_i32$4 >>> 0) {
                                                    i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
                                                   }
                                                   $32 = i64toi32_i32$0;
                                                   $32$hi = i64toi32_i32$3;
                                                   i64toi32_i32$3 = $30$hi;
                                                   i64toi32_i32$3 = $32$hi;
                                                   i64toi32_i32$5 = i64toi32_i32$0;
                                                   i64toi32_i32$1 = $30$hi;
                                                   i64toi32_i32$4 = $30;
                                                   if (i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$5 >>> 0 <= i64toi32_i32$4 >>> 0 | 0) | 0) {
                                                    break label$113
                                                   }
                                                   i64toi32_i32$5 = 0;
                                                   $52 = 0;
                                                   $52$hi = i64toi32_i32$5;
                                                   $1 = 3;
                                                   $15 = 0;
                                                   break label$112;
                                                  }
                                                  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__ProtocolVersions___deserialize__hb8264e18664de337($2 + 200 | 0 | 0, $1 | 0);
                                                  if ((HEAP32[($2 + 200 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                                                   break label$34
                                                  }
                                                  i64toi32_i32$4 = $2 + 248 | 0;
                                                  i64toi32_i32$5 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                                  i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                                  $31 = i64toi32_i32$5;
                                                  $31$hi = i64toi32_i32$3;
                                                  i64toi32_i32$5 = ($2 + 184 | 0) + 8 | 0;
                                                  HEAP32[i64toi32_i32$5 >> 2] = $31;
                                                  HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$3;
                                                  $20 = HEAP32[($2 + 268 | 0) >> 2] | 0;
                                                  HEAP32[(($2 + 168 | 0) + 8 | 0) >> 2] = $20;
                                                  i64toi32_i32$5 = ($2 + 152 | 0) + 8 | 0;
                                                  HEAP32[i64toi32_i32$5 >> 2] = $31;
                                                  HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$3;
                                                  i64toi32_i32$4 = $2 + 240 | 0;
                                                  i64toi32_i32$3 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                                  i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                                  $31 = i64toi32_i32$3;
                                                  $31$hi = i64toi32_i32$5;
                                                  i64toi32_i32$3 = $2;
                                                  HEAP32[($2 + 184 | 0) >> 2] = $31;
                                                  HEAP32[($2 + 188 | 0) >> 2] = i64toi32_i32$5;
                                                  i64toi32_i32$4 = $2 + 260 | 0;
                                                  i64toi32_i32$5 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                                  i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                                  $32 = i64toi32_i32$5;
                                                  $32$hi = i64toi32_i32$3;
                                                  i64toi32_i32$5 = $2;
                                                  HEAP32[($2 + 168 | 0) >> 2] = $32;
                                                  HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$3;
                                                  i64toi32_i32$3 = $31$hi;
                                                  i64toi32_i32$5 = $2;
                                                  HEAP32[($2 + 152 | 0) >> 2] = $31;
                                                  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$3;
                                                  i64toi32_i32$4 = $2 + 232 | 0;
                                                  i64toi32_i32$3 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                                  i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                                  $47 = i64toi32_i32$3;
                                                  $47$hi = i64toi32_i32$5;
                                                  i64toi32_i32$4 = $2 + 224 | 0;
                                                  i64toi32_i32$5 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                                  i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                                  $52 = i64toi32_i32$5;
                                                  $52$hi = i64toi32_i32$3;
                                                  i64toi32_i32$4 = $2 + 216 | 0;
                                                  i64toi32_i32$3 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                                  i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                                  $30 = i64toi32_i32$3;
                                                  $30$hi = i64toi32_i32$5;
                                                  $15 = HEAP32[($2 + 256 | 0) >> 2] | 0;
                                                  i64toi32_i32$4 = $2 + 213 | 0;
                                                  i64toi32_i32$5 = HEAPU8[i64toi32_i32$4 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$4 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
                                                  i64toi32_i32$3 = 0;
                                                  $31 = i64toi32_i32$5;
                                                  $31$hi = i64toi32_i32$3;
                                                  i64toi32_i32$4 = $2 + 215 | 0;
                                                  i64toi32_i32$3 = HEAPU8[i64toi32_i32$4 >> 0] | 0;
                                                  i64toi32_i32$5 = 0;
                                                  $48 = i64toi32_i32$3;
                                                  $48$hi = i64toi32_i32$5;
                                                  $1 = HEAPU8[($2 + 208 | 0) >> 0] | 0;
                                                  i64toi32_i32$4 = $2;
                                                  i64toi32_i32$5 = HEAPU8[($2 + 209 | 0) >> 0] | 0 | ((HEAPU8[($2 + 210 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 211 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 212 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                                  i64toi32_i32$3 = 0;
                                                  $51 = i64toi32_i32$5;
                                                  $51$hi = i64toi32_i32$3;
                                                  HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] = $20;
                                                  i64toi32_i32$3 = $32$hi;
                                                  i64toi32_i32$5 = $2;
                                                  HEAP32[($2 + 136 | 0) >> 2] = $32;
                                                  HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$3;
                                                  i64toi32_i32$3 = $51$hi;
                                                  $1681 = $51;
                                                  $1681$hi = i64toi32_i32$3;
                                                  i64toi32_i32$3 = $31$hi;
                                                  $1682 = $31;
                                                  $1682$hi = i64toi32_i32$3;
                                                  i64toi32_i32$3 = $48$hi;
                                                  i64toi32_i32$4 = $48;
                                                  i64toi32_i32$5 = 0;
                                                  i64toi32_i32$1 = 16;
                                                  i64toi32_i32$2 = i64toi32_i32$1 & 31 | 0;
                                                  if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                                                   i64toi32_i32$5 = i64toi32_i32$4 << i64toi32_i32$2 | 0;
                                                   $406 = 0;
                                                  } else {
                                                   i64toi32_i32$5 = ((1 << i64toi32_i32$2 | 0) - 1 | 0) & (i64toi32_i32$4 >>> (32 - i64toi32_i32$2 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$2 | 0) | 0;
                                                   $406 = i64toi32_i32$4 << i64toi32_i32$2 | 0;
                                                  }
                                                  $1684$hi = i64toi32_i32$5;
                                                  i64toi32_i32$5 = $1682$hi;
                                                  i64toi32_i32$3 = $1682;
                                                  i64toi32_i32$4 = $1684$hi;
                                                  i64toi32_i32$1 = $406;
                                                  i64toi32_i32$4 = i64toi32_i32$5 | i64toi32_i32$4 | 0;
                                                  i64toi32_i32$5 = i64toi32_i32$3 | i64toi32_i32$1 | 0;
                                                  i64toi32_i32$3 = 0;
                                                  i64toi32_i32$1 = 32;
                                                  i64toi32_i32$2 = i64toi32_i32$1 & 31 | 0;
                                                  if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                                                   i64toi32_i32$3 = i64toi32_i32$5 << i64toi32_i32$2 | 0;
                                                   $407 = 0;
                                                  } else {
                                                   i64toi32_i32$3 = ((1 << i64toi32_i32$2 | 0) - 1 | 0) & (i64toi32_i32$5 >>> (32 - i64toi32_i32$2 | 0) | 0) | 0 | (i64toi32_i32$4 << i64toi32_i32$2 | 0) | 0;
                                                   $407 = i64toi32_i32$5 << i64toi32_i32$2 | 0;
                                                  }
                                                  $1686$hi = i64toi32_i32$3;
                                                  i64toi32_i32$3 = $1681$hi;
                                                  i64toi32_i32$4 = $1681;
                                                  i64toi32_i32$5 = $1686$hi;
                                                  i64toi32_i32$1 = $407;
                                                  i64toi32_i32$5 = i64toi32_i32$3 | i64toi32_i32$5 | 0;
                                                  $31 = i64toi32_i32$4 | i64toi32_i32$1 | 0;
                                                  $31$hi = i64toi32_i32$5;
                                                 }
                                                 i64toi32_i32$5 = $47$hi;
                                                 i64toi32_i32$4 = ($2 + 200 | 0) + 24 | 0;
                                                 HEAP32[i64toi32_i32$4 >> 2] = $47;
                                                 HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
                                                 i64toi32_i32$5 = $52$hi;
                                                 i64toi32_i32$4 = ($2 + 200 | 0) + 16 | 0;
                                                 HEAP32[i64toi32_i32$4 >> 2] = $52;
                                                 HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
                                                 i64toi32_i32$5 = $30$hi;
                                                 i64toi32_i32$4 = ($2 + 200 | 0) + 8 | 0;
                                                 HEAP32[i64toi32_i32$4 >> 2] = $30;
                                                 HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
                                                 i64toi32_i32$3 = $2;
                                                 i64toi32_i32$5 = HEAP32[($2 + 152 | 0) >> 2] | 0;
                                                 i64toi32_i32$4 = HEAP32[($2 + 156 | 0) >> 2] | 0;
                                                 $1704 = i64toi32_i32$5;
                                                 i64toi32_i32$5 = ($2 + 200 | 0) + 32 | 0;
                                                 HEAP32[i64toi32_i32$5 >> 2] = $1704;
                                                 HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$4;
                                                 i64toi32_i32$3 = $2;
                                                 i64toi32_i32$4 = HEAP32[($2 + 136 | 0) >> 2] | 0;
                                                 i64toi32_i32$5 = HEAP32[($2 + 140 | 0) >> 2] | 0;
                                                 $1708 = i64toi32_i32$4;
                                                 i64toi32_i32$4 = $2 + 252 | 0;
                                                 HEAP32[i64toi32_i32$4 >> 2] = $1708;
                                                 HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
                                                 i64toi32_i32$3 = ($2 + 152 | 0) + 8 | 0;
                                                 i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                                 i64toi32_i32$4 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                                 $1715 = i64toi32_i32$5;
                                                 i64toi32_i32$5 = ($2 + 200 | 0) + 40 | 0;
                                                 HEAP32[i64toi32_i32$5 >> 2] = $1715;
                                                 HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$4;
                                                 HEAP32[(($2 + 200 | 0) + 60 | 0) >> 2] = HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] | 0;
                                                 HEAP8[($2 + 200 | 0) >> 0] = $1;
                                                 HEAP32[($2 + 248 | 0) >> 2] = $15;
                                                 i64toi32_i32$4 = $31$hi;
                                                 HEAP8[($2 + 201 | 0) >> 0] = $31;
                                                 HEAP8[($2 + 202 | 0) >> 0] = $31 >>> 8 | 0;
                                                 HEAP8[($2 + 203 | 0) >> 0] = $31 >>> 16 | 0;
                                                 HEAP8[($2 + 204 | 0) >> 0] = $31 >>> 24 | 0;
                                                 $1729 = $2;
                                                 i64toi32_i32$3 = $31;
                                                 i64toi32_i32$5 = 0;
                                                 i64toi32_i32$1 = 48;
                                                 i64toi32_i32$2 = i64toi32_i32$1 & 31 | 0;
                                                 if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                                                  i64toi32_i32$5 = 0;
                                                  $408 = i64toi32_i32$4 >>> i64toi32_i32$2 | 0;
                                                 } else {
                                                  i64toi32_i32$5 = i64toi32_i32$4 >>> i64toi32_i32$2 | 0;
                                                  $408 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$2 | 0) | 0;
                                                 }
                                                 HEAP8[($1729 + 207 | 0) >> 0] = $408;
                                                 $1732 = $2;
                                                 i64toi32_i32$5 = $31$hi;
                                                 i64toi32_i32$4 = $31;
                                                 i64toi32_i32$3 = 0;
                                                 i64toi32_i32$1 = 32;
                                                 i64toi32_i32$2 = i64toi32_i32$1 & 31 | 0;
                                                 if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                                                  i64toi32_i32$3 = 0;
                                                  $409 = i64toi32_i32$5 >>> i64toi32_i32$2 | 0;
                                                 } else {
                                                  i64toi32_i32$3 = i64toi32_i32$5 >>> i64toi32_i32$2 | 0;
                                                  $409 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$2 | 0) | 0;
                                                 }
                                                 $410 = $1732;
                                                 $411 = $409;
                                                 HEAP8[($410 + 205 | 0) >> 0] = $411;
                                                 HEAP8[($410 + 206 | 0) >> 0] = $411 >>> 8 | 0;
                                                 cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($14 | 0, $2 + 200 | 0 | 0, 1052381 | 0, 16 | 0);
                                                 i64toi32_i32$5 = $2;
                                                 i64toi32_i32$3 = HEAP32[($2 + 72 | 0) >> 2] | 0;
                                                 i64toi32_i32$4 = HEAP32[($2 + 76 | 0) >> 2] | 0;
                                                 $47 = i64toi32_i32$3;
                                                 $47$hi = i64toi32_i32$4;
                                                 i64toi32_i32$5 = i64toi32_i32$3;
                                                 i64toi32_i32$3 = -1;
                                                 i64toi32_i32$1 = -256;
                                                 i64toi32_i32$3 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
                                                 $46 = i64toi32_i32$5 & i64toi32_i32$1 | 0;
                                                 $46$hi = i64toi32_i32$3;
                                                 i64toi32_i32$4 = ($2 + 64 | 0) + 16 | 0;
                                                 i64toi32_i32$3 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                                 i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                                 $48 = i64toi32_i32$3;
                                                 $48$hi = i64toi32_i32$5;
                                                 i64toi32_i32$4 = ($2 + 64 | 0) + 24 | 0;
                                                 i64toi32_i32$5 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                                 i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                                 $51 = i64toi32_i32$5;
                                                 $51$hi = i64toi32_i32$3;
                                                 i64toi32_i32$4 = ($2 + 64 | 0) + 32 | 0;
                                                 i64toi32_i32$3 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                                 i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                                 $32 = i64toi32_i32$3;
                                                 $32$hi = i64toi32_i32$5;
                                                 i64toi32_i32$4 = ($2 + 64 | 0) + 40 | 0;
                                                 i64toi32_i32$5 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                                 i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                                 $50 = i64toi32_i32$5;
                                                 $50$hi = i64toi32_i32$3;
                                                 i64toi32_i32$4 = $2 + 112 | 0;
                                                 i64toi32_i32$3 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                                 i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                                 $49 = i64toi32_i32$3;
                                                 $49$hi = i64toi32_i32$5;
                                                 $19 = HEAP32[($2 + 120 | 0) >> 2] | 0;
                                                 $15 = HEAP32[(($2 + 64 | 0) + 60 | 0) >> 2] | 0;
                                                 i64toi32_i32$4 = $2 + 128 | 0;
                                                 i64toi32_i32$5 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                                 i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                                 $53 = i64toi32_i32$5;
                                                 $53$hi = i64toi32_i32$3;
                                                 break label$4;
                                                }
                                                label$114 : {
                                                 label$115 : {
                                                  i64toi32_i32$3 = $31$hi;
                                                  i64toi32_i32$4 = $31;
                                                  i64toi32_i32$5 = 0;
                                                  i64toi32_i32$1 = 1;
                                                  if ((i64toi32_i32$4 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$3 | 0) != (i64toi32_i32$5 | 0) | 0) {
                                                   break label$115
                                                  }
                                                  i64toi32_i32$4 = $32$hi;
                                                  i64toi32_i32$1 = $32;
                                                  i64toi32_i32$3 = 0;
                                                  i64toi32_i32$5 = 1;
                                                  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
                                                  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
                                                  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0) {
                                                   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
                                                  }
                                                  $32 = i64toi32_i32$2;
                                                  $32$hi = i64toi32_i32$0;
                                                  i64toi32_i32$0 = $30$hi;
                                                  i64toi32_i32$0 = $32$hi;
                                                  i64toi32_i32$4 = i64toi32_i32$2;
                                                  i64toi32_i32$1 = $30$hi;
                                                  i64toi32_i32$5 = $30;
                                                  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$2 >>> 0 <= i64toi32_i32$5 >>> 0 | 0) | 0) {
                                                   break label$115
                                                  }
                                                  i64toi32_i32$4 = 0;
                                                  $52 = 0;
                                                  $52$hi = i64toi32_i32$4;
                                                  $1 = 3;
                                                  $15 = 0;
                                                  break label$114;
                                                 }
                                                 $cardano_serialization_lib__crypto__Nonce_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h5cb63bdaa73c6bd6($2 + 200 | 0 | 0, $1 | 0);
                                                 if ((HEAPU8[($2 + 200 | 0) >> 0] | 0 | 0) != (1 | 0)) {
                                                  break label$33
                                                 }
                                                 i64toi32_i32$5 = $2 + 248 | 0;
                                                 i64toi32_i32$4 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                                 i64toi32_i32$0 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                                 $1789 = i64toi32_i32$4;
                                                 i64toi32_i32$4 = ($2 + 184 | 0) + 8 | 0;
                                                 HEAP32[i64toi32_i32$4 >> 2] = $1789;
                                                 HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$0;
                                                 HEAP32[(($2 + 152 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 268 | 0) >> 2] | 0;
                                                 i64toi32_i32$5 = $2 + 240 | 0;
                                                 i64toi32_i32$0 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                                 i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                                 $1799 = i64toi32_i32$0;
                                                 i64toi32_i32$0 = $2;
                                                 HEAP32[($2 + 184 | 0) >> 2] = $1799;
                                                 HEAP32[($2 + 188 | 0) >> 2] = i64toi32_i32$4;
                                                 i64toi32_i32$5 = $2 + 260 | 0;
                                                 i64toi32_i32$4 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                                 i64toi32_i32$0 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                                 $1803 = i64toi32_i32$4;
                                                 i64toi32_i32$4 = $2;
                                                 HEAP32[($2 + 152 | 0) >> 2] = $1803;
                                                 HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
                                                 i64toi32_i32$5 = $2;
                                                 i64toi32_i32$0 = HEAPU8[($2 + 209 | 0) >> 0] | 0 | ((HEAPU8[($2 + 210 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 211 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 212 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                                 i64toi32_i32$4 = 0;
                                                 $1805 = i64toi32_i32$0;
                                                 $1805$hi = i64toi32_i32$4;
                                                 i64toi32_i32$5 = $2 + 213 | 0;
                                                 i64toi32_i32$4 = HEAPU8[i64toi32_i32$5 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$5 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
                                                 i64toi32_i32$0 = 0;
                                                 $1808 = i64toi32_i32$4;
                                                 $1808$hi = i64toi32_i32$0;
                                                 i64toi32_i32$5 = $2 + 215 | 0;
                                                 i64toi32_i32$0 = HEAPU8[i64toi32_i32$5 >> 0] | 0;
                                                 i64toi32_i32$4 = 0;
                                                 i64toi32_i32$5 = i64toi32_i32$0;
                                                 i64toi32_i32$0 = 0;
                                                 i64toi32_i32$1 = 16;
                                                 i64toi32_i32$3 = i64toi32_i32$1 & 31 | 0;
                                                 if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                                                  i64toi32_i32$0 = i64toi32_i32$5 << i64toi32_i32$3 | 0;
                                                  $412 = 0;
                                                 } else {
                                                  i64toi32_i32$0 = ((1 << i64toi32_i32$3 | 0) - 1 | 0) & (i64toi32_i32$5 >>> (32 - i64toi32_i32$3 | 0) | 0) | 0 | (i64toi32_i32$4 << i64toi32_i32$3 | 0) | 0;
                                                  $412 = i64toi32_i32$5 << i64toi32_i32$3 | 0;
                                                 }
                                                 $1812$hi = i64toi32_i32$0;
                                                 i64toi32_i32$0 = $1808$hi;
                                                 i64toi32_i32$4 = $1808;
                                                 i64toi32_i32$5 = $1812$hi;
                                                 i64toi32_i32$1 = $412;
                                                 i64toi32_i32$5 = i64toi32_i32$0 | i64toi32_i32$5 | 0;
                                                 i64toi32_i32$0 = i64toi32_i32$4 | i64toi32_i32$1 | 0;
                                                 i64toi32_i32$4 = 0;
                                                 i64toi32_i32$1 = 32;
                                                 i64toi32_i32$3 = i64toi32_i32$1 & 31 | 0;
                                                 if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                                                  i64toi32_i32$4 = i64toi32_i32$0 << i64toi32_i32$3 | 0;
                                                  $413 = 0;
                                                 } else {
                                                  i64toi32_i32$4 = ((1 << i64toi32_i32$3 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$3 | 0) | 0) | 0 | (i64toi32_i32$5 << i64toi32_i32$3 | 0) | 0;
                                                  $413 = i64toi32_i32$0 << i64toi32_i32$3 | 0;
                                                 }
                                                 $1814$hi = i64toi32_i32$4;
                                                 i64toi32_i32$4 = $1805$hi;
                                                 i64toi32_i32$5 = $1805;
                                                 i64toi32_i32$0 = $1814$hi;
                                                 i64toi32_i32$1 = $413;
                                                 i64toi32_i32$0 = i64toi32_i32$4 | i64toi32_i32$0 | 0;
                                                 $31 = i64toi32_i32$5 | i64toi32_i32$1 | 0;
                                                 $31$hi = i64toi32_i32$0;
                                                 $15 = HEAP32[($2 + 256 | 0) >> 2] | 0;
                                                 i64toi32_i32$4 = $2;
                                                 i64toi32_i32$0 = HEAP32[($2 + 232 | 0) >> 2] | 0;
                                                 i64toi32_i32$5 = HEAP32[($2 + 236 | 0) >> 2] | 0;
                                                 $47 = i64toi32_i32$0;
                                                 $47$hi = i64toi32_i32$5;
                                                 i64toi32_i32$4 = $2;
                                                 i64toi32_i32$5 = HEAP32[($2 + 224 | 0) >> 2] | 0;
                                                 i64toi32_i32$0 = HEAP32[($2 + 228 | 0) >> 2] | 0;
                                                 $52 = i64toi32_i32$5;
                                                 $52$hi = i64toi32_i32$0;
                                                 i64toi32_i32$4 = $2;
                                                 i64toi32_i32$0 = HEAP32[($2 + 216 | 0) >> 2] | 0;
                                                 i64toi32_i32$5 = HEAP32[($2 + 220 | 0) >> 2] | 0;
                                                 $30 = i64toi32_i32$0;
                                                 $30$hi = i64toi32_i32$5;
                                                 $1 = HEAPU8[($2 + 208 | 0) >> 0] | 0;
                                                }
                                                i64toi32_i32$5 = $47$hi;
                                                i64toi32_i32$0 = $2 + 224 | 0;
                                                HEAP32[i64toi32_i32$0 >> 2] = $47;
                                                HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$5;
                                                i64toi32_i32$5 = $52$hi;
                                                i64toi32_i32$0 = $2 + 216 | 0;
                                                HEAP32[i64toi32_i32$0 >> 2] = $52;
                                                HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$5;
                                                i64toi32_i32$5 = $30$hi;
                                                i64toi32_i32$0 = ($2 + 200 | 0) + 8 | 0;
                                                HEAP32[i64toi32_i32$0 >> 2] = $30;
                                                HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$5;
                                                i64toi32_i32$4 = $2;
                                                i64toi32_i32$5 = HEAP32[($2 + 184 | 0) >> 2] | 0;
                                                i64toi32_i32$0 = HEAP32[($2 + 188 | 0) >> 2] | 0;
                                                $1840 = i64toi32_i32$5;
                                                i64toi32_i32$5 = $2 + 232 | 0;
                                                HEAP32[i64toi32_i32$5 >> 2] = $1840;
                                                HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
                                                i64toi32_i32$4 = $2;
                                                i64toi32_i32$0 = HEAP32[($2 + 152 | 0) >> 2] | 0;
                                                i64toi32_i32$5 = HEAP32[($2 + 156 | 0) >> 2] | 0;
                                                $1844 = i64toi32_i32$0;
                                                i64toi32_i32$0 = $2 + 252 | 0;
                                                HEAP32[i64toi32_i32$0 >> 2] = $1844;
                                                HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$5;
                                                i64toi32_i32$4 = ($2 + 184 | 0) + 8 | 0;
                                                i64toi32_i32$5 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                                i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                                $1851 = i64toi32_i32$5;
                                                i64toi32_i32$5 = ($2 + 200 | 0) + 40 | 0;
                                                HEAP32[i64toi32_i32$5 >> 2] = $1851;
                                                HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
                                                HEAP32[(($2 + 200 | 0) + 60 | 0) >> 2] = HEAP32[(($2 + 152 | 0) + 8 | 0) >> 2] | 0;
                                                HEAP8[($2 + 200 | 0) >> 0] = $1;
                                                HEAP32[($2 + 248 | 0) >> 2] = $15;
                                                i64toi32_i32$0 = $31$hi;
                                                HEAP8[($2 + 201 | 0) >> 0] = $31;
                                                HEAP8[($2 + 202 | 0) >> 0] = $31 >>> 8 | 0;
                                                HEAP8[($2 + 203 | 0) >> 0] = $31 >>> 16 | 0;
                                                HEAP8[($2 + 204 | 0) >> 0] = $31 >>> 24 | 0;
                                                $1865 = $2;
                                                i64toi32_i32$4 = $31;
                                                i64toi32_i32$5 = 0;
                                                i64toi32_i32$1 = 48;
                                                i64toi32_i32$3 = i64toi32_i32$1 & 31 | 0;
                                                if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                                                 i64toi32_i32$5 = 0;
                                                 $414 = i64toi32_i32$0 >>> i64toi32_i32$3 | 0;
                                                } else {
                                                 i64toi32_i32$5 = i64toi32_i32$0 >>> i64toi32_i32$3 | 0;
                                                 $414 = (((1 << i64toi32_i32$3 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$3 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$3 | 0) | 0;
                                                }
                                                HEAP8[($1865 + 207 | 0) >> 0] = $414;
                                                $1868 = $2;
                                                i64toi32_i32$5 = $31$hi;
                                                i64toi32_i32$0 = $31;
                                                i64toi32_i32$4 = 0;
                                                i64toi32_i32$1 = 32;
                                                i64toi32_i32$3 = i64toi32_i32$1 & 31 | 0;
                                                if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                                                 i64toi32_i32$4 = 0;
                                                 $416 = i64toi32_i32$5 >>> i64toi32_i32$3 | 0;
                                                } else {
                                                 i64toi32_i32$4 = i64toi32_i32$5 >>> i64toi32_i32$3 | 0;
                                                 $416 = (((1 << i64toi32_i32$3 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$3 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$3 | 0) | 0;
                                                }
                                                $417 = $1868;
                                                $418 = $416;
                                                HEAP8[($417 + 205 | 0) >> 0] = $418;
                                                HEAP8[($417 + 206 | 0) >> 0] = $418 >>> 8 | 0;
                                                cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($14 | 0, $2 + 200 | 0 | 0, 1052368 | 0, 13 | 0);
                                                i64toi32_i32$5 = $2;
                                                i64toi32_i32$4 = HEAP32[($2 + 72 | 0) >> 2] | 0;
                                                i64toi32_i32$0 = HEAP32[($2 + 76 | 0) >> 2] | 0;
                                                $47 = i64toi32_i32$4;
                                                $47$hi = i64toi32_i32$0;
                                                i64toi32_i32$5 = i64toi32_i32$4;
                                                i64toi32_i32$4 = -1;
                                                i64toi32_i32$1 = -256;
                                                i64toi32_i32$4 = i64toi32_i32$0 & i64toi32_i32$4 | 0;
                                                $46 = i64toi32_i32$5 & i64toi32_i32$1 | 0;
                                                $46$hi = i64toi32_i32$4;
                                                i64toi32_i32$0 = ($2 + 64 | 0) + 40 | 0;
                                                i64toi32_i32$4 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                $50 = i64toi32_i32$4;
                                                $50$hi = i64toi32_i32$5;
                                                i64toi32_i32$0 = $2 + 112 | 0;
                                                i64toi32_i32$5 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                $49 = i64toi32_i32$5;
                                                $49$hi = i64toi32_i32$4;
                                                $19 = HEAP32[($2 + 120 | 0) >> 2] | 0;
                                                $15 = HEAP32[(($2 + 64 | 0) + 60 | 0) >> 2] | 0;
                                                i64toi32_i32$0 = $2 + 128 | 0;
                                                i64toi32_i32$4 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                $53 = i64toi32_i32$4;
                                                $53$hi = i64toi32_i32$5;
                                                i64toi32_i32$0 = $2;
                                                i64toi32_i32$5 = HEAP32[($2 + 80 | 0) >> 2] | 0;
                                                i64toi32_i32$4 = HEAP32[($2 + 84 | 0) >> 2] | 0;
                                                $48 = i64toi32_i32$5;
                                                $48$hi = i64toi32_i32$4;
                                                i64toi32_i32$0 = $2;
                                                i64toi32_i32$4 = HEAP32[($2 + 88 | 0) >> 2] | 0;
                                                i64toi32_i32$5 = HEAP32[($2 + 92 | 0) >> 2] | 0;
                                                $51 = i64toi32_i32$4;
                                                $51$hi = i64toi32_i32$5;
                                                i64toi32_i32$0 = $2;
                                                i64toi32_i32$5 = HEAP32[($2 + 96 | 0) >> 2] | 0;
                                                i64toi32_i32$4 = HEAP32[($2 + 100 | 0) >> 2] | 0;
                                                $32 = i64toi32_i32$5;
                                                $32$hi = i64toi32_i32$4;
                                                break label$4;
                                               }
                                               label$116 : {
                                                label$117 : {
                                                 i64toi32_i32$4 = $31$hi;
                                                 i64toi32_i32$0 = $31;
                                                 i64toi32_i32$5 = 0;
                                                 i64toi32_i32$1 = 1;
                                                 if ((i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$4 | 0) != (i64toi32_i32$5 | 0) | 0) {
                                                  break label$117
                                                 }
                                                 i64toi32_i32$0 = $32$hi;
                                                 i64toi32_i32$1 = $32;
                                                 i64toi32_i32$4 = 0;
                                                 i64toi32_i32$5 = 1;
                                                 i64toi32_i32$3 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
                                                 i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
                                                 if (i64toi32_i32$3 >>> 0 < i64toi32_i32$5 >>> 0) {
                                                  i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
                                                 }
                                                 $32 = i64toi32_i32$3;
                                                 $32$hi = i64toi32_i32$2;
                                                 i64toi32_i32$2 = $30$hi;
                                                 i64toi32_i32$2 = $32$hi;
                                                 i64toi32_i32$0 = i64toi32_i32$3;
                                                 i64toi32_i32$1 = $30$hi;
                                                 i64toi32_i32$5 = $30;
                                                 if (i64toi32_i32$2 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$3 >>> 0 <= i64toi32_i32$5 >>> 0 | 0) | 0) {
                                                  break label$117
                                                 }
                                                 i64toi32_i32$0 = 0;
                                                 $31 = 0;
                                                 $31$hi = i64toi32_i32$0;
                                                 i64toi32_i32$0 = 0;
                                                 $52 = 3;
                                                 $52$hi = i64toi32_i32$0;
                                                 $1 = 0;
                                                 break label$116;
                                                }
                                                cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__UnitInterval___deserialize__h50a71b45bc03a6b4($2 + 200 | 0 | 0, $1 | 0);
                                                i64toi32_i32$5 = $2;
                                                i64toi32_i32$0 = HEAP32[($2 + 200 | 0) >> 2] | 0;
                                                i64toi32_i32$2 = HEAP32[($2 + 204 | 0) >> 2] | 0;
                                                i64toi32_i32$5 = i64toi32_i32$0;
                                                i64toi32_i32$0 = 0;
                                                i64toi32_i32$1 = 1;
                                                if ((i64toi32_i32$5 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$0 | 0) | 0) {
                                                 break label$32
                                                }
                                                $1 = HEAP32[($2 + 268 | 0) >> 2] | 0;
                                                HEAP32[(($2 + 168 | 0) + 8 | 0) >> 2] = $1;
                                                i64toi32_i32$1 = $2 + 248 | 0;
                                                i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                                i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                                $1926 = i64toi32_i32$5;
                                                i64toi32_i32$5 = ($2 + 152 | 0) + 8 | 0;
                                                HEAP32[i64toi32_i32$5 >> 2] = $1926;
                                                HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$2;
                                                HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] = $1;
                                                i64toi32_i32$1 = $2;
                                                i64toi32_i32$2 = HEAP32[($2 + 260 | 0) >> 2] | 0;
                                                i64toi32_i32$5 = HEAP32[($2 + 264 | 0) >> 2] | 0;
                                                $31 = i64toi32_i32$2;
                                                $31$hi = i64toi32_i32$5;
                                                i64toi32_i32$2 = $2;
                                                HEAP32[($2 + 168 | 0) >> 2] = $31;
                                                HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$5;
                                                i64toi32_i32$2 = $2;
                                                HEAP32[($2 + 136 | 0) >> 2] = $31;
                                                HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$5;
                                                i64toi32_i32$1 = $2 + 240 | 0;
                                                i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                                i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                                $1940 = i64toi32_i32$5;
                                                i64toi32_i32$5 = $2;
                                                HEAP32[($2 + 152 | 0) >> 2] = $1940;
                                                HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$2;
                                                i64toi32_i32$1 = $2 + 232 | 0;
                                                i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                                i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                                $47 = i64toi32_i32$2;
                                                $47$hi = i64toi32_i32$5;
                                                i64toi32_i32$1 = $2 + 224 | 0;
                                                i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                                i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                                $31 = i64toi32_i32$5;
                                                $31$hi = i64toi32_i32$2;
                                                $1 = HEAP32[($2 + 256 | 0) >> 2] | 0;
                                                i64toi32_i32$1 = $2;
                                                i64toi32_i32$2 = HEAP32[($2 + 216 | 0) >> 2] | 0;
                                                i64toi32_i32$5 = HEAP32[($2 + 220 | 0) >> 2] | 0;
                                                $30 = i64toi32_i32$2;
                                                $30$hi = i64toi32_i32$5;
                                                i64toi32_i32$1 = $2;
                                                i64toi32_i32$5 = HEAP32[($2 + 208 | 0) >> 2] | 0;
                                                i64toi32_i32$2 = HEAP32[($2 + 212 | 0) >> 2] | 0;
                                                $52 = i64toi32_i32$5;
                                                $52$hi = i64toi32_i32$2;
                                               }
                                               i64toi32_i32$2 = $47$hi;
                                               i64toi32_i32$5 = ($2 + 200 | 0) + 24 | 0;
                                               HEAP32[i64toi32_i32$5 >> 2] = $47;
                                               HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$2;
                                               i64toi32_i32$2 = $31$hi;
                                               i64toi32_i32$5 = $2 + 216 | 0;
                                               HEAP32[i64toi32_i32$5 >> 2] = $31;
                                               HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$2;
                                               i64toi32_i32$2 = $30$hi;
                                               i64toi32_i32$5 = ($2 + 200 | 0) + 8 | 0;
                                               HEAP32[i64toi32_i32$5 >> 2] = $30;
                                               HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$2;
                                               i64toi32_i32$1 = $2;
                                               i64toi32_i32$2 = HEAP32[($2 + 152 | 0) >> 2] | 0;
                                               i64toi32_i32$5 = HEAP32[($2 + 156 | 0) >> 2] | 0;
                                               $1969 = i64toi32_i32$2;
                                               i64toi32_i32$2 = ($2 + 200 | 0) + 32 | 0;
                                               HEAP32[i64toi32_i32$2 >> 2] = $1969;
                                               HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$5;
                                               i64toi32_i32$1 = $2;
                                               i64toi32_i32$5 = HEAP32[($2 + 136 | 0) >> 2] | 0;
                                               i64toi32_i32$2 = HEAP32[($2 + 140 | 0) >> 2] | 0;
                                               $1973 = i64toi32_i32$5;
                                               i64toi32_i32$5 = $2 + 252 | 0;
                                               HEAP32[i64toi32_i32$5 >> 2] = $1973;
                                               HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$2;
                                               i64toi32_i32$1 = ($2 + 152 | 0) + 8 | 0;
                                               i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                               i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                               $1980 = i64toi32_i32$2;
                                               i64toi32_i32$2 = ($2 + 200 | 0) + 40 | 0;
                                               HEAP32[i64toi32_i32$2 >> 2] = $1980;
                                               HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$5;
                                               HEAP32[(($2 + 200 | 0) + 60 | 0) >> 2] = HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] | 0;
                                               i64toi32_i32$5 = $52$hi;
                                               i64toi32_i32$2 = $2;
                                               HEAP32[($2 + 200 | 0) >> 2] = $52;
                                               HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$5;
                                               HEAP32[($2 + 248 | 0) >> 2] = $1;
                                               cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($14 | 0, $2 + 200 | 0 | 0, 1052367 | 0, 1 | 0);
                                               i64toi32_i32$1 = $2;
                                               i64toi32_i32$5 = HEAP32[($2 + 72 | 0) >> 2] | 0;
                                               i64toi32_i32$2 = HEAP32[($2 + 76 | 0) >> 2] | 0;
                                               $47 = i64toi32_i32$5;
                                               $47$hi = i64toi32_i32$2;
                                               i64toi32_i32$1 = i64toi32_i32$5;
                                               i64toi32_i32$5 = -1;
                                               i64toi32_i32$0 = -256;
                                               i64toi32_i32$5 = i64toi32_i32$2 & i64toi32_i32$5 | 0;
                                               $46 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
                                               $46$hi = i64toi32_i32$5;
                                               i64toi32_i32$2 = ($2 + 64 | 0) + 24 | 0;
                                               i64toi32_i32$5 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                               i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                               $51 = i64toi32_i32$5;
                                               $51$hi = i64toi32_i32$1;
                                               i64toi32_i32$2 = ($2 + 64 | 0) + 32 | 0;
                                               i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                               i64toi32_i32$5 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                               $32 = i64toi32_i32$1;
                                               $32$hi = i64toi32_i32$5;
                                               i64toi32_i32$2 = ($2 + 64 | 0) + 40 | 0;
                                               i64toi32_i32$5 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                               i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                               $50 = i64toi32_i32$5;
                                               $50$hi = i64toi32_i32$1;
                                               i64toi32_i32$2 = $2 + 112 | 0;
                                               i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                               i64toi32_i32$5 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                               $49 = i64toi32_i32$1;
                                               $49$hi = i64toi32_i32$5;
                                               $19 = HEAP32[($2 + 120 | 0) >> 2] | 0;
                                               $15 = HEAP32[(($2 + 64 | 0) + 60 | 0) >> 2] | 0;
                                               i64toi32_i32$2 = $2 + 128 | 0;
                                               i64toi32_i32$5 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                               i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                               $53 = i64toi32_i32$5;
                                               $53$hi = i64toi32_i32$1;
                                               i64toi32_i32$2 = $2;
                                               i64toi32_i32$1 = HEAP32[($2 + 80 | 0) >> 2] | 0;
                                               i64toi32_i32$5 = HEAP32[($2 + 84 | 0) >> 2] | 0;
                                               $48 = i64toi32_i32$1;
                                               $48$hi = i64toi32_i32$5;
                                               break label$4;
                                              }
                                              label$118 : {
                                               label$119 : {
                                                i64toi32_i32$5 = $31$hi;
                                                i64toi32_i32$2 = $31;
                                                i64toi32_i32$1 = 0;
                                                i64toi32_i32$0 = 1;
                                                if ((i64toi32_i32$2 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$5 | 0) != (i64toi32_i32$1 | 0) | 0) {
                                                 break label$119
                                                }
                                                i64toi32_i32$2 = $32$hi;
                                                i64toi32_i32$0 = $32;
                                                i64toi32_i32$5 = 0;
                                                i64toi32_i32$1 = 1;
                                                i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
                                                i64toi32_i32$3 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
                                                if (i64toi32_i32$4 >>> 0 < i64toi32_i32$1 >>> 0) {
                                                 i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
                                                }
                                                $32 = i64toi32_i32$4;
                                                $32$hi = i64toi32_i32$3;
                                                i64toi32_i32$3 = $30$hi;
                                                i64toi32_i32$3 = $32$hi;
                                                i64toi32_i32$2 = i64toi32_i32$4;
                                                i64toi32_i32$0 = $30$hi;
                                                i64toi32_i32$1 = $30;
                                                if (i64toi32_i32$3 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$2 >>> 0 <= i64toi32_i32$1 >>> 0 | 0) | 0) {
                                                 break label$119
                                                }
                                                i64toi32_i32$2 = 0;
                                                $31 = 0;
                                                $31$hi = i64toi32_i32$2;
                                                i64toi32_i32$2 = 0;
                                                $52 = 3;
                                                $52$hi = i64toi32_i32$2;
                                                $1 = 0;
                                                break label$118;
                                               }
                                               cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__UnitInterval___deserialize__h50a71b45bc03a6b4($2 + 200 | 0 | 0, $1 | 0);
                                               i64toi32_i32$1 = $2;
                                               i64toi32_i32$2 = HEAP32[($2 + 200 | 0) >> 2] | 0;
                                               i64toi32_i32$3 = HEAP32[($2 + 204 | 0) >> 2] | 0;
                                               i64toi32_i32$1 = i64toi32_i32$2;
                                               i64toi32_i32$2 = 0;
                                               i64toi32_i32$0 = 1;
                                               if ((i64toi32_i32$1 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$3 | 0) != (i64toi32_i32$2 | 0) | 0) {
                                                break label$31
                                               }
                                               $1 = HEAP32[($2 + 268 | 0) >> 2] | 0;
                                               HEAP32[(($2 + 168 | 0) + 8 | 0) >> 2] = $1;
                                               i64toi32_i32$0 = $2 + 248 | 0;
                                               i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                               i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                               $2051 = i64toi32_i32$1;
                                               i64toi32_i32$1 = ($2 + 152 | 0) + 8 | 0;
                                               HEAP32[i64toi32_i32$1 >> 2] = $2051;
                                               HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
                                               HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] = $1;
                                               i64toi32_i32$0 = $2;
                                               i64toi32_i32$3 = HEAP32[($2 + 260 | 0) >> 2] | 0;
                                               i64toi32_i32$1 = HEAP32[($2 + 264 | 0) >> 2] | 0;
                                               $31 = i64toi32_i32$3;
                                               $31$hi = i64toi32_i32$1;
                                               i64toi32_i32$3 = $2;
                                               HEAP32[($2 + 168 | 0) >> 2] = $31;
                                               HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$1;
                                               i64toi32_i32$3 = $2;
                                               HEAP32[($2 + 136 | 0) >> 2] = $31;
                                               HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$1;
                                               i64toi32_i32$0 = $2 + 240 | 0;
                                               i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                               i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                               $2065 = i64toi32_i32$1;
                                               i64toi32_i32$1 = $2;
                                               HEAP32[($2 + 152 | 0) >> 2] = $2065;
                                               HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$3;
                                               i64toi32_i32$0 = $2 + 232 | 0;
                                               i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                               i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                               $47 = i64toi32_i32$3;
                                               $47$hi = i64toi32_i32$1;
                                               i64toi32_i32$0 = $2 + 224 | 0;
                                               i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                               i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                               $31 = i64toi32_i32$1;
                                               $31$hi = i64toi32_i32$3;
                                               $1 = HEAP32[($2 + 256 | 0) >> 2] | 0;
                                               i64toi32_i32$0 = $2;
                                               i64toi32_i32$3 = HEAP32[($2 + 216 | 0) >> 2] | 0;
                                               i64toi32_i32$1 = HEAP32[($2 + 220 | 0) >> 2] | 0;
                                               $30 = i64toi32_i32$3;
                                               $30$hi = i64toi32_i32$1;
                                               i64toi32_i32$0 = $2;
                                               i64toi32_i32$1 = HEAP32[($2 + 208 | 0) >> 2] | 0;
                                               i64toi32_i32$3 = HEAP32[($2 + 212 | 0) >> 2] | 0;
                                               $52 = i64toi32_i32$1;
                                               $52$hi = i64toi32_i32$3;
                                              }
                                              i64toi32_i32$3 = $47$hi;
                                              i64toi32_i32$1 = ($2 + 200 | 0) + 24 | 0;
                                              HEAP32[i64toi32_i32$1 >> 2] = $47;
                                              HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
                                              i64toi32_i32$3 = $31$hi;
                                              i64toi32_i32$1 = $2 + 216 | 0;
                                              HEAP32[i64toi32_i32$1 >> 2] = $31;
                                              HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
                                              i64toi32_i32$3 = $30$hi;
                                              i64toi32_i32$1 = ($2 + 200 | 0) + 8 | 0;
                                              HEAP32[i64toi32_i32$1 >> 2] = $30;
                                              HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
                                              i64toi32_i32$0 = $2;
                                              i64toi32_i32$3 = HEAP32[($2 + 152 | 0) >> 2] | 0;
                                              i64toi32_i32$1 = HEAP32[($2 + 156 | 0) >> 2] | 0;
                                              $2094 = i64toi32_i32$3;
                                              i64toi32_i32$3 = ($2 + 200 | 0) + 32 | 0;
                                              HEAP32[i64toi32_i32$3 >> 2] = $2094;
                                              HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
                                              i64toi32_i32$0 = $2;
                                              i64toi32_i32$1 = HEAP32[($2 + 136 | 0) >> 2] | 0;
                                              i64toi32_i32$3 = HEAP32[($2 + 140 | 0) >> 2] | 0;
                                              $2098 = i64toi32_i32$1;
                                              i64toi32_i32$1 = $2 + 252 | 0;
                                              HEAP32[i64toi32_i32$1 >> 2] = $2098;
                                              HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
                                              i64toi32_i32$0 = ($2 + 152 | 0) + 8 | 0;
                                              i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                              i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                              $2105 = i64toi32_i32$3;
                                              i64toi32_i32$3 = ($2 + 200 | 0) + 40 | 0;
                                              HEAP32[i64toi32_i32$3 >> 2] = $2105;
                                              HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
                                              HEAP32[(($2 + 200 | 0) + 60 | 0) >> 2] = HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] | 0;
                                              i64toi32_i32$1 = $52$hi;
                                              i64toi32_i32$3 = $2;
                                              HEAP32[($2 + 200 | 0) >> 2] = $52;
                                              HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$1;
                                              HEAP32[($2 + 248 | 0) >> 2] = $1;
                                              cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($14 | 0, $2 + 200 | 0 | 0, 1052347 | 0, 20 | 0);
                                              i64toi32_i32$0 = $2;
                                              i64toi32_i32$1 = HEAP32[($2 + 72 | 0) >> 2] | 0;
                                              i64toi32_i32$3 = HEAP32[($2 + 76 | 0) >> 2] | 0;
                                              $47 = i64toi32_i32$1;
                                              $47$hi = i64toi32_i32$3;
                                              i64toi32_i32$0 = i64toi32_i32$1;
                                              i64toi32_i32$1 = -1;
                                              i64toi32_i32$2 = -256;
                                              i64toi32_i32$1 = i64toi32_i32$3 & i64toi32_i32$1 | 0;
                                              $46 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
                                              $46$hi = i64toi32_i32$1;
                                              i64toi32_i32$3 = ($2 + 64 | 0) + 24 | 0;
                                              i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                              i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                              $51 = i64toi32_i32$1;
                                              $51$hi = i64toi32_i32$0;
                                              i64toi32_i32$3 = ($2 + 64 | 0) + 32 | 0;
                                              i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                              i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                              $32 = i64toi32_i32$0;
                                              $32$hi = i64toi32_i32$1;
                                              i64toi32_i32$3 = ($2 + 64 | 0) + 40 | 0;
                                              i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                              i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                              $50 = i64toi32_i32$1;
                                              $50$hi = i64toi32_i32$0;
                                              i64toi32_i32$3 = $2 + 112 | 0;
                                              i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                              i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                              $49 = i64toi32_i32$0;
                                              $49$hi = i64toi32_i32$1;
                                              $19 = HEAP32[($2 + 120 | 0) >> 2] | 0;
                                              $15 = HEAP32[(($2 + 64 | 0) + 60 | 0) >> 2] | 0;
                                              i64toi32_i32$3 = $2 + 128 | 0;
                                              i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                              i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                              $53 = i64toi32_i32$1;
                                              $53$hi = i64toi32_i32$0;
                                              i64toi32_i32$3 = $2;
                                              i64toi32_i32$0 = HEAP32[($2 + 80 | 0) >> 2] | 0;
                                              i64toi32_i32$1 = HEAP32[($2 + 84 | 0) >> 2] | 0;
                                              $48 = i64toi32_i32$0;
                                              $48$hi = i64toi32_i32$1;
                                              break label$4;
                                             }
                                             label$120 : {
                                              label$121 : {
                                               i64toi32_i32$1 = $31$hi;
                                               i64toi32_i32$3 = $31;
                                               i64toi32_i32$0 = 0;
                                               i64toi32_i32$2 = 1;
                                               if ((i64toi32_i32$3 | 0) != (i64toi32_i32$2 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$0 | 0) | 0) {
                                                break label$121
                                               }
                                               i64toi32_i32$3 = $32$hi;
                                               i64toi32_i32$2 = $32;
                                               i64toi32_i32$1 = 0;
                                               i64toi32_i32$0 = 1;
                                               i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
                                               i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
                                               if (i64toi32_i32$5 >>> 0 < i64toi32_i32$0 >>> 0) {
                                                i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
                                               }
                                               $32 = i64toi32_i32$5;
                                               $32$hi = i64toi32_i32$4;
                                               i64toi32_i32$4 = $30$hi;
                                               i64toi32_i32$4 = $32$hi;
                                               i64toi32_i32$3 = i64toi32_i32$5;
                                               i64toi32_i32$2 = $30$hi;
                                               i64toi32_i32$0 = $30;
                                               if (i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$3 >>> 0 <= i64toi32_i32$0 >>> 0 | 0) | 0) {
                                                break label$121
                                               }
                                               i64toi32_i32$3 = 0;
                                               $31 = 0;
                                               $31$hi = i64toi32_i32$3;
                                               i64toi32_i32$3 = 0;
                                               $52 = 3;
                                               $52$hi = i64toi32_i32$3;
                                               $1 = 0;
                                               break label$120;
                                              }
                                              cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__UnitInterval___deserialize__h50a71b45bc03a6b4($2 + 200 | 0 | 0, $1 | 0);
                                              i64toi32_i32$0 = $2;
                                              i64toi32_i32$3 = HEAP32[($2 + 200 | 0) >> 2] | 0;
                                              i64toi32_i32$4 = HEAP32[($2 + 204 | 0) >> 2] | 0;
                                              i64toi32_i32$0 = i64toi32_i32$3;
                                              i64toi32_i32$3 = 0;
                                              i64toi32_i32$2 = 1;
                                              if ((i64toi32_i32$0 | 0) != (i64toi32_i32$2 | 0) | (i64toi32_i32$4 | 0) != (i64toi32_i32$3 | 0) | 0) {
                                               break label$30
                                              }
                                              $1 = HEAP32[($2 + 268 | 0) >> 2] | 0;
                                              HEAP32[(($2 + 168 | 0) + 8 | 0) >> 2] = $1;
                                              i64toi32_i32$2 = $2 + 248 | 0;
                                              i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                              i64toi32_i32$4 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                              $2176 = i64toi32_i32$0;
                                              i64toi32_i32$0 = ($2 + 152 | 0) + 8 | 0;
                                              HEAP32[i64toi32_i32$0 >> 2] = $2176;
                                              HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$4;
                                              HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] = $1;
                                              i64toi32_i32$2 = $2;
                                              i64toi32_i32$4 = HEAP32[($2 + 260 | 0) >> 2] | 0;
                                              i64toi32_i32$0 = HEAP32[($2 + 264 | 0) >> 2] | 0;
                                              $31 = i64toi32_i32$4;
                                              $31$hi = i64toi32_i32$0;
                                              i64toi32_i32$4 = $2;
                                              HEAP32[($2 + 168 | 0) >> 2] = $31;
                                              HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$0;
                                              i64toi32_i32$4 = $2;
                                              HEAP32[($2 + 136 | 0) >> 2] = $31;
                                              HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$0;
                                              i64toi32_i32$2 = $2 + 240 | 0;
                                              i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                              i64toi32_i32$4 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                              $2190 = i64toi32_i32$0;
                                              i64toi32_i32$0 = $2;
                                              HEAP32[($2 + 152 | 0) >> 2] = $2190;
                                              HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$4;
                                              i64toi32_i32$2 = $2 + 232 | 0;
                                              i64toi32_i32$4 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                              i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                              $47 = i64toi32_i32$4;
                                              $47$hi = i64toi32_i32$0;
                                              i64toi32_i32$2 = $2 + 224 | 0;
                                              i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                              i64toi32_i32$4 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                              $31 = i64toi32_i32$0;
                                              $31$hi = i64toi32_i32$4;
                                              $1 = HEAP32[($2 + 256 | 0) >> 2] | 0;
                                              i64toi32_i32$2 = $2;
                                              i64toi32_i32$4 = HEAP32[($2 + 216 | 0) >> 2] | 0;
                                              i64toi32_i32$0 = HEAP32[($2 + 220 | 0) >> 2] | 0;
                                              $30 = i64toi32_i32$4;
                                              $30$hi = i64toi32_i32$0;
                                              i64toi32_i32$2 = $2;
                                              i64toi32_i32$0 = HEAP32[($2 + 208 | 0) >> 2] | 0;
                                              i64toi32_i32$4 = HEAP32[($2 + 212 | 0) >> 2] | 0;
                                              $52 = i64toi32_i32$0;
                                              $52$hi = i64toi32_i32$4;
                                             }
                                             i64toi32_i32$4 = $47$hi;
                                             i64toi32_i32$0 = ($2 + 200 | 0) + 24 | 0;
                                             HEAP32[i64toi32_i32$0 >> 2] = $47;
                                             HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$4;
                                             i64toi32_i32$4 = $31$hi;
                                             i64toi32_i32$0 = $2 + 216 | 0;
                                             HEAP32[i64toi32_i32$0 >> 2] = $31;
                                             HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$4;
                                             i64toi32_i32$4 = $30$hi;
                                             i64toi32_i32$0 = ($2 + 200 | 0) + 8 | 0;
                                             HEAP32[i64toi32_i32$0 >> 2] = $30;
                                             HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$4;
                                             i64toi32_i32$2 = $2;
                                             i64toi32_i32$4 = HEAP32[($2 + 152 | 0) >> 2] | 0;
                                             i64toi32_i32$0 = HEAP32[($2 + 156 | 0) >> 2] | 0;
                                             $2219 = i64toi32_i32$4;
                                             i64toi32_i32$4 = ($2 + 200 | 0) + 32 | 0;
                                             HEAP32[i64toi32_i32$4 >> 2] = $2219;
                                             HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$0;
                                             i64toi32_i32$2 = $2;
                                             i64toi32_i32$0 = HEAP32[($2 + 136 | 0) >> 2] | 0;
                                             i64toi32_i32$4 = HEAP32[($2 + 140 | 0) >> 2] | 0;
                                             $2223 = i64toi32_i32$0;
                                             i64toi32_i32$0 = $2 + 252 | 0;
                                             HEAP32[i64toi32_i32$0 >> 2] = $2223;
                                             HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$4;
                                             i64toi32_i32$2 = ($2 + 152 | 0) + 8 | 0;
                                             i64toi32_i32$4 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                             i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                             $2230 = i64toi32_i32$4;
                                             i64toi32_i32$4 = ($2 + 200 | 0) + 40 | 0;
                                             HEAP32[i64toi32_i32$4 >> 2] = $2230;
                                             HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$0;
                                             HEAP32[(($2 + 200 | 0) + 60 | 0) >> 2] = HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] | 0;
                                             i64toi32_i32$0 = $52$hi;
                                             i64toi32_i32$4 = $2;
                                             HEAP32[($2 + 200 | 0) >> 2] = $52;
                                             HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$0;
                                             HEAP32[($2 + 248 | 0) >> 2] = $1;
                                             cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($14 | 0, $2 + 200 | 0 | 0, 1052333 | 0, 14 | 0);
                                             i64toi32_i32$2 = $2;
                                             i64toi32_i32$0 = HEAP32[($2 + 72 | 0) >> 2] | 0;
                                             i64toi32_i32$4 = HEAP32[($2 + 76 | 0) >> 2] | 0;
                                             $47 = i64toi32_i32$0;
                                             $47$hi = i64toi32_i32$4;
                                             i64toi32_i32$2 = i64toi32_i32$0;
                                             i64toi32_i32$0 = -1;
                                             i64toi32_i32$3 = -256;
                                             i64toi32_i32$0 = i64toi32_i32$4 & i64toi32_i32$0 | 0;
                                             $46 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
                                             $46$hi = i64toi32_i32$0;
                                             i64toi32_i32$4 = ($2 + 64 | 0) + 24 | 0;
                                             i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                             i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                             $51 = i64toi32_i32$0;
                                             $51$hi = i64toi32_i32$2;
                                             i64toi32_i32$4 = ($2 + 64 | 0) + 32 | 0;
                                             i64toi32_i32$2 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                             i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                             $32 = i64toi32_i32$2;
                                             $32$hi = i64toi32_i32$0;
                                             i64toi32_i32$4 = ($2 + 64 | 0) + 40 | 0;
                                             i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                             i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                             $50 = i64toi32_i32$0;
                                             $50$hi = i64toi32_i32$2;
                                             i64toi32_i32$4 = $2 + 112 | 0;
                                             i64toi32_i32$2 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                             i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                             $49 = i64toi32_i32$2;
                                             $49$hi = i64toi32_i32$0;
                                             $19 = HEAP32[($2 + 120 | 0) >> 2] | 0;
                                             $15 = HEAP32[(($2 + 64 | 0) + 60 | 0) >> 2] | 0;
                                             i64toi32_i32$4 = $2 + 128 | 0;
                                             i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                             i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                             $53 = i64toi32_i32$0;
                                             $53$hi = i64toi32_i32$2;
                                             i64toi32_i32$4 = $2;
                                             i64toi32_i32$2 = HEAP32[($2 + 80 | 0) >> 2] | 0;
                                             i64toi32_i32$0 = HEAP32[($2 + 84 | 0) >> 2] | 0;
                                             $48 = i64toi32_i32$2;
                                             $48$hi = i64toi32_i32$0;
                                             break label$4;
                                            }
                                            label$122 : {
                                             label$123 : {
                                              i64toi32_i32$0 = $31$hi;
                                              i64toi32_i32$4 = $31;
                                              i64toi32_i32$2 = 0;
                                              i64toi32_i32$3 = 1;
                                              if ((i64toi32_i32$4 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$2 | 0) | 0) {
                                               break label$123
                                              }
                                              i64toi32_i32$4 = $32$hi;
                                              i64toi32_i32$3 = $32;
                                              i64toi32_i32$0 = 0;
                                              i64toi32_i32$2 = 1;
                                              i64toi32_i32$1 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
                                              i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
                                              if (i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0) {
                                               i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
                                              }
                                              $32 = i64toi32_i32$1;
                                              $32$hi = i64toi32_i32$5;
                                              i64toi32_i32$5 = $30$hi;
                                              i64toi32_i32$5 = $32$hi;
                                              i64toi32_i32$4 = i64toi32_i32$1;
                                              i64toi32_i32$3 = $30$hi;
                                              i64toi32_i32$2 = $30;
                                              if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$1 >>> 0 <= i64toi32_i32$2 >>> 0 | 0) | 0) {
                                               break label$123
                                              }
                                              i64toi32_i32$4 = 0;
                                              $31 = 0;
                                              $31$hi = i64toi32_i32$4;
                                              i64toi32_i32$4 = 0;
                                              $52 = 3;
                                              $52$hi = i64toi32_i32$4;
                                              $1 = 0;
                                              break label$122;
                                             }
                                             cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__UnitInterval___deserialize__h50a71b45bc03a6b4($2 + 200 | 0 | 0, $1 | 0);
                                             i64toi32_i32$2 = $2;
                                             i64toi32_i32$4 = HEAP32[($2 + 200 | 0) >> 2] | 0;
                                             i64toi32_i32$5 = HEAP32[($2 + 204 | 0) >> 2] | 0;
                                             i64toi32_i32$2 = i64toi32_i32$4;
                                             i64toi32_i32$4 = 0;
                                             i64toi32_i32$3 = 1;
                                             if ((i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$5 | 0) != (i64toi32_i32$4 | 0) | 0) {
                                              break label$29
                                             }
                                             $1 = HEAP32[($2 + 268 | 0) >> 2] | 0;
                                             HEAP32[(($2 + 168 | 0) + 8 | 0) >> 2] = $1;
                                             i64toi32_i32$3 = $2 + 248 | 0;
                                             i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                             i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                             $2301 = i64toi32_i32$2;
                                             i64toi32_i32$2 = ($2 + 152 | 0) + 8 | 0;
                                             HEAP32[i64toi32_i32$2 >> 2] = $2301;
                                             HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$5;
                                             HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] = $1;
                                             i64toi32_i32$3 = $2;
                                             i64toi32_i32$5 = HEAP32[($2 + 260 | 0) >> 2] | 0;
                                             i64toi32_i32$2 = HEAP32[($2 + 264 | 0) >> 2] | 0;
                                             $31 = i64toi32_i32$5;
                                             $31$hi = i64toi32_i32$2;
                                             i64toi32_i32$5 = $2;
                                             HEAP32[($2 + 168 | 0) >> 2] = $31;
                                             HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$2;
                                             i64toi32_i32$5 = $2;
                                             HEAP32[($2 + 136 | 0) >> 2] = $31;
                                             HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$2;
                                             i64toi32_i32$3 = $2 + 240 | 0;
                                             i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                             i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                             $2315 = i64toi32_i32$2;
                                             i64toi32_i32$2 = $2;
                                             HEAP32[($2 + 152 | 0) >> 2] = $2315;
                                             HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$5;
                                             i64toi32_i32$3 = $2 + 232 | 0;
                                             i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                             i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                             $47 = i64toi32_i32$5;
                                             $47$hi = i64toi32_i32$2;
                                             i64toi32_i32$3 = $2 + 224 | 0;
                                             i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                             i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                             $31 = i64toi32_i32$2;
                                             $31$hi = i64toi32_i32$5;
                                             $1 = HEAP32[($2 + 256 | 0) >> 2] | 0;
                                             i64toi32_i32$3 = $2;
                                             i64toi32_i32$5 = HEAP32[($2 + 216 | 0) >> 2] | 0;
                                             i64toi32_i32$2 = HEAP32[($2 + 220 | 0) >> 2] | 0;
                                             $30 = i64toi32_i32$5;
                                             $30$hi = i64toi32_i32$2;
                                             i64toi32_i32$3 = $2;
                                             i64toi32_i32$2 = HEAP32[($2 + 208 | 0) >> 2] | 0;
                                             i64toi32_i32$5 = HEAP32[($2 + 212 | 0) >> 2] | 0;
                                             $52 = i64toi32_i32$2;
                                             $52$hi = i64toi32_i32$5;
                                            }
                                            i64toi32_i32$5 = $47$hi;
                                            i64toi32_i32$2 = ($2 + 200 | 0) + 24 | 0;
                                            HEAP32[i64toi32_i32$2 >> 2] = $47;
                                            HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$5;
                                            i64toi32_i32$5 = $31$hi;
                                            i64toi32_i32$2 = $2 + 216 | 0;
                                            HEAP32[i64toi32_i32$2 >> 2] = $31;
                                            HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$5;
                                            i64toi32_i32$5 = $30$hi;
                                            i64toi32_i32$2 = ($2 + 200 | 0) + 8 | 0;
                                            HEAP32[i64toi32_i32$2 >> 2] = $30;
                                            HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$5;
                                            i64toi32_i32$3 = $2;
                                            i64toi32_i32$5 = HEAP32[($2 + 152 | 0) >> 2] | 0;
                                            i64toi32_i32$2 = HEAP32[($2 + 156 | 0) >> 2] | 0;
                                            $2344 = i64toi32_i32$5;
                                            i64toi32_i32$5 = ($2 + 200 | 0) + 32 | 0;
                                            HEAP32[i64toi32_i32$5 >> 2] = $2344;
                                            HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$2;
                                            i64toi32_i32$3 = $2;
                                            i64toi32_i32$2 = HEAP32[($2 + 136 | 0) >> 2] | 0;
                                            i64toi32_i32$5 = HEAP32[($2 + 140 | 0) >> 2] | 0;
                                            $2348 = i64toi32_i32$2;
                                            i64toi32_i32$2 = $2 + 252 | 0;
                                            HEAP32[i64toi32_i32$2 >> 2] = $2348;
                                            HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$5;
                                            i64toi32_i32$3 = ($2 + 152 | 0) + 8 | 0;
                                            i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                            i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                            $2355 = i64toi32_i32$5;
                                            i64toi32_i32$5 = ($2 + 200 | 0) + 40 | 0;
                                            HEAP32[i64toi32_i32$5 >> 2] = $2355;
                                            HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$2;
                                            HEAP32[(($2 + 200 | 0) + 60 | 0) >> 2] = HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] | 0;
                                            i64toi32_i32$2 = $52$hi;
                                            i64toi32_i32$5 = $2;
                                            HEAP32[($2 + 200 | 0) >> 2] = $52;
                                            HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$2;
                                            HEAP32[($2 + 248 | 0) >> 2] = $1;
                                            cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($14 | 0, $2 + 200 | 0 | 0, 1052312 | 0, 21 | 0);
                                            i64toi32_i32$3 = $2;
                                            i64toi32_i32$2 = HEAP32[($2 + 72 | 0) >> 2] | 0;
                                            i64toi32_i32$5 = HEAP32[($2 + 76 | 0) >> 2] | 0;
                                            $47 = i64toi32_i32$2;
                                            $47$hi = i64toi32_i32$5;
                                            i64toi32_i32$3 = i64toi32_i32$2;
                                            i64toi32_i32$2 = -1;
                                            i64toi32_i32$4 = -256;
                                            i64toi32_i32$2 = i64toi32_i32$5 & i64toi32_i32$2 | 0;
                                            $46 = i64toi32_i32$3 & i64toi32_i32$4 | 0;
                                            $46$hi = i64toi32_i32$2;
                                            i64toi32_i32$5 = ($2 + 64 | 0) + 24 | 0;
                                            i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                            i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                            $51 = i64toi32_i32$2;
                                            $51$hi = i64toi32_i32$3;
                                            i64toi32_i32$5 = ($2 + 64 | 0) + 32 | 0;
                                            i64toi32_i32$3 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                            i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                            $32 = i64toi32_i32$3;
                                            $32$hi = i64toi32_i32$2;
                                            i64toi32_i32$5 = ($2 + 64 | 0) + 40 | 0;
                                            i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                            i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                            $50 = i64toi32_i32$2;
                                            $50$hi = i64toi32_i32$3;
                                            i64toi32_i32$5 = $2 + 112 | 0;
                                            i64toi32_i32$3 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                            i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                            $49 = i64toi32_i32$3;
                                            $49$hi = i64toi32_i32$2;
                                            $19 = HEAP32[($2 + 120 | 0) >> 2] | 0;
                                            $15 = HEAP32[(($2 + 64 | 0) + 60 | 0) >> 2] | 0;
                                            i64toi32_i32$5 = $2 + 128 | 0;
                                            i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                            i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                            $53 = i64toi32_i32$2;
                                            $53$hi = i64toi32_i32$3;
                                            i64toi32_i32$5 = $2;
                                            i64toi32_i32$3 = HEAP32[($2 + 80 | 0) >> 2] | 0;
                                            i64toi32_i32$2 = HEAP32[($2 + 84 | 0) >> 2] | 0;
                                            $48 = i64toi32_i32$3;
                                            $48$hi = i64toi32_i32$2;
                                            break label$4;
                                           }
                                           label$124 : {
                                            label$125 : {
                                             i64toi32_i32$2 = $31$hi;
                                             i64toi32_i32$5 = $31;
                                             i64toi32_i32$3 = 0;
                                             i64toi32_i32$4 = 1;
                                             if ((i64toi32_i32$5 | 0) != (i64toi32_i32$4 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | 0) {
                                              break label$125
                                             }
                                             i64toi32_i32$5 = $32$hi;
                                             i64toi32_i32$4 = $32;
                                             i64toi32_i32$2 = 0;
                                             i64toi32_i32$3 = 1;
                                             i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
                                             i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
                                             if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
                                              i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
                                             }
                                             $32 = i64toi32_i32$0;
                                             $32$hi = i64toi32_i32$1;
                                             i64toi32_i32$1 = $30$hi;
                                             i64toi32_i32$1 = $32$hi;
                                             i64toi32_i32$5 = i64toi32_i32$0;
                                             i64toi32_i32$4 = $30$hi;
                                             i64toi32_i32$3 = $30;
                                             if (i64toi32_i32$1 >>> 0 < i64toi32_i32$4 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$4 | 0) & i64toi32_i32$5 >>> 0 <= i64toi32_i32$3 >>> 0 | 0) | 0) {
                                              break label$125
                                             }
                                             i64toi32_i32$5 = 0;
                                             $52 = 0;
                                             $52$hi = i64toi32_i32$5;
                                             $1 = 3;
                                             $15 = 0;
                                             break label$124;
                                            }
                                            $T_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hf422f9333a8bbafa($2 + 200 | 0 | 0, $1 | 0);
                                            $8 = 1;
                                            if ((HEAP32[($2 + 200 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                                             break label$28
                                            }
                                            i64toi32_i32$3 = $2 + 248 | 0;
                                            i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                            i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                            $31 = i64toi32_i32$5;
                                            $31$hi = i64toi32_i32$1;
                                            i64toi32_i32$5 = ($2 + 184 | 0) + 8 | 0;
                                            HEAP32[i64toi32_i32$5 >> 2] = $31;
                                            HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$1;
                                            $20 = HEAP32[($2 + 268 | 0) >> 2] | 0;
                                            HEAP32[(($2 + 168 | 0) + 8 | 0) >> 2] = $20;
                                            i64toi32_i32$5 = ($2 + 152 | 0) + 8 | 0;
                                            HEAP32[i64toi32_i32$5 >> 2] = $31;
                                            HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$1;
                                            i64toi32_i32$3 = $2 + 240 | 0;
                                            i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                            i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                            $31 = i64toi32_i32$1;
                                            $31$hi = i64toi32_i32$5;
                                            i64toi32_i32$1 = $2;
                                            HEAP32[($2 + 184 | 0) >> 2] = $31;
                                            HEAP32[($2 + 188 | 0) >> 2] = i64toi32_i32$5;
                                            i64toi32_i32$3 = $2 + 260 | 0;
                                            i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                            i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                            $32 = i64toi32_i32$5;
                                            $32$hi = i64toi32_i32$1;
                                            i64toi32_i32$5 = $2;
                                            HEAP32[($2 + 168 | 0) >> 2] = $32;
                                            HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$1;
                                            i64toi32_i32$1 = $31$hi;
                                            i64toi32_i32$5 = $2;
                                            HEAP32[($2 + 152 | 0) >> 2] = $31;
                                            HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$1;
                                            i64toi32_i32$3 = $2 + 232 | 0;
                                            i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                            i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                            $47 = i64toi32_i32$1;
                                            $47$hi = i64toi32_i32$5;
                                            i64toi32_i32$3 = $2 + 224 | 0;
                                            i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                            i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                            $52 = i64toi32_i32$5;
                                            $52$hi = i64toi32_i32$1;
                                            i64toi32_i32$3 = $2 + 216 | 0;
                                            i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                            i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                            $30 = i64toi32_i32$1;
                                            $30$hi = i64toi32_i32$5;
                                            $1 = HEAPU8[(($2 + 200 | 0) + 8 | 0) >> 0] | 0;
                                            $15 = HEAP32[($2 + 256 | 0) >> 2] | 0;
                                            i64toi32_i32$3 = $2 + 209 | 0;
                                            i64toi32_i32$5 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                            i64toi32_i32$1 = 0;
                                            $31 = i64toi32_i32$5;
                                            $31$hi = i64toi32_i32$1;
                                            i64toi32_i32$3 = $2 + 213 | 0;
                                            i64toi32_i32$1 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
                                            i64toi32_i32$5 = 0;
                                            $48 = i64toi32_i32$1;
                                            $48$hi = i64toi32_i32$5;
                                            i64toi32_i32$3 = $2 + 215 | 0;
                                            i64toi32_i32$5 = HEAPU8[i64toi32_i32$3 >> 0] | 0;
                                            i64toi32_i32$1 = 0;
                                            $51 = i64toi32_i32$5;
                                            $51$hi = i64toi32_i32$1;
                                            HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] = $20;
                                            i64toi32_i32$1 = $32$hi;
                                            i64toi32_i32$5 = $2;
                                            HEAP32[($2 + 136 | 0) >> 2] = $32;
                                            HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$1;
                                            i64toi32_i32$1 = $31$hi;
                                            $2475 = $31;
                                            $2475$hi = i64toi32_i32$1;
                                            i64toi32_i32$1 = $48$hi;
                                            $2476 = $48;
                                            $2476$hi = i64toi32_i32$1;
                                            i64toi32_i32$1 = $51$hi;
                                            i64toi32_i32$3 = $51;
                                            i64toi32_i32$5 = 0;
                                            i64toi32_i32$4 = 16;
                                            i64toi32_i32$2 = i64toi32_i32$4 & 31 | 0;
                                            if (32 >>> 0 <= (i64toi32_i32$4 & 63 | 0) >>> 0) {
                                             i64toi32_i32$5 = i64toi32_i32$3 << i64toi32_i32$2 | 0;
                                             $420 = 0;
                                            } else {
                                             i64toi32_i32$5 = ((1 << i64toi32_i32$2 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$2 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$2 | 0) | 0;
                                             $420 = i64toi32_i32$3 << i64toi32_i32$2 | 0;
                                            }
                                            $2478$hi = i64toi32_i32$5;
                                            i64toi32_i32$5 = $2476$hi;
                                            i64toi32_i32$1 = $2476;
                                            i64toi32_i32$3 = $2478$hi;
                                            i64toi32_i32$4 = $420;
                                            i64toi32_i32$3 = i64toi32_i32$5 | i64toi32_i32$3 | 0;
                                            i64toi32_i32$5 = i64toi32_i32$1 | i64toi32_i32$4 | 0;
                                            i64toi32_i32$1 = 0;
                                            i64toi32_i32$4 = 32;
                                            i64toi32_i32$2 = i64toi32_i32$4 & 31 | 0;
                                            if (32 >>> 0 <= (i64toi32_i32$4 & 63 | 0) >>> 0) {
                                             i64toi32_i32$1 = i64toi32_i32$5 << i64toi32_i32$2 | 0;
                                             $421 = 0;
                                            } else {
                                             i64toi32_i32$1 = ((1 << i64toi32_i32$2 | 0) - 1 | 0) & (i64toi32_i32$5 >>> (32 - i64toi32_i32$2 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$2 | 0) | 0;
                                             $421 = i64toi32_i32$5 << i64toi32_i32$2 | 0;
                                            }
                                            $2480$hi = i64toi32_i32$1;
                                            i64toi32_i32$1 = $2475$hi;
                                            i64toi32_i32$3 = $2475;
                                            i64toi32_i32$5 = $2480$hi;
                                            i64toi32_i32$4 = $421;
                                            i64toi32_i32$5 = i64toi32_i32$1 | i64toi32_i32$5 | 0;
                                            $31 = i64toi32_i32$3 | i64toi32_i32$4 | 0;
                                            $31$hi = i64toi32_i32$5;
                                           }
                                           i64toi32_i32$5 = $47$hi;
                                           i64toi32_i32$3 = ($2 + 200 | 0) + 24 | 0;
                                           HEAP32[i64toi32_i32$3 >> 2] = $47;
                                           HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
                                           i64toi32_i32$5 = $52$hi;
                                           i64toi32_i32$3 = ($2 + 200 | 0) + 16 | 0;
                                           HEAP32[i64toi32_i32$3 >> 2] = $52;
                                           HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
                                           i64toi32_i32$5 = $30$hi;
                                           i64toi32_i32$3 = ($2 + 200 | 0) + 8 | 0;
                                           HEAP32[i64toi32_i32$3 >> 2] = $30;
                                           HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
                                           i64toi32_i32$1 = $2;
                                           i64toi32_i32$5 = HEAP32[($2 + 152 | 0) >> 2] | 0;
                                           i64toi32_i32$3 = HEAP32[($2 + 156 | 0) >> 2] | 0;
                                           $2498 = i64toi32_i32$5;
                                           i64toi32_i32$5 = ($2 + 200 | 0) + 32 | 0;
                                           HEAP32[i64toi32_i32$5 >> 2] = $2498;
                                           HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$3;
                                           i64toi32_i32$1 = $2;
                                           i64toi32_i32$3 = HEAP32[($2 + 136 | 0) >> 2] | 0;
                                           i64toi32_i32$5 = HEAP32[($2 + 140 | 0) >> 2] | 0;
                                           $2502 = i64toi32_i32$3;
                                           i64toi32_i32$3 = $2 + 252 | 0;
                                           HEAP32[i64toi32_i32$3 >> 2] = $2502;
                                           HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
                                           i64toi32_i32$1 = ($2 + 152 | 0) + 8 | 0;
                                           i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                           i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                           $2509 = i64toi32_i32$5;
                                           i64toi32_i32$5 = ($2 + 200 | 0) + 40 | 0;
                                           HEAP32[i64toi32_i32$5 >> 2] = $2509;
                                           HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$3;
                                           HEAP32[(($2 + 200 | 0) + 60 | 0) >> 2] = HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] | 0;
                                           HEAP8[($2 + 200 | 0) >> 0] = $1;
                                           HEAP32[($2 + 248 | 0) >> 2] = $15;
                                           i64toi32_i32$3 = $31$hi;
                                           HEAP8[($2 + 201 | 0) >> 0] = $31;
                                           HEAP8[($2 + 202 | 0) >> 0] = $31 >>> 8 | 0;
                                           HEAP8[($2 + 203 | 0) >> 0] = $31 >>> 16 | 0;
                                           HEAP8[($2 + 204 | 0) >> 0] = $31 >>> 24 | 0;
                                           $2523 = $2;
                                           i64toi32_i32$1 = $31;
                                           i64toi32_i32$5 = 0;
                                           i64toi32_i32$4 = 48;
                                           i64toi32_i32$2 = i64toi32_i32$4 & 31 | 0;
                                           if (32 >>> 0 <= (i64toi32_i32$4 & 63 | 0) >>> 0) {
                                            i64toi32_i32$5 = 0;
                                            $422 = i64toi32_i32$3 >>> i64toi32_i32$2 | 0;
                                           } else {
                                            i64toi32_i32$5 = i64toi32_i32$3 >>> i64toi32_i32$2 | 0;
                                            $422 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$2 | 0) | 0;
                                           }
                                           HEAP8[($2523 + 207 | 0) >> 0] = $422;
                                           $2526 = $2;
                                           i64toi32_i32$5 = $31$hi;
                                           i64toi32_i32$3 = $31;
                                           i64toi32_i32$1 = 0;
                                           i64toi32_i32$4 = 32;
                                           i64toi32_i32$2 = i64toi32_i32$4 & 31 | 0;
                                           if (32 >>> 0 <= (i64toi32_i32$4 & 63 | 0) >>> 0) {
                                            i64toi32_i32$1 = 0;
                                            $423 = i64toi32_i32$5 >>> i64toi32_i32$2 | 0;
                                           } else {
                                            i64toi32_i32$1 = i64toi32_i32$5 >>> i64toi32_i32$2 | 0;
                                            $423 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$2 | 0) | 0;
                                           }
                                           $424 = $2526;
                                           $425 = $423;
                                           HEAP8[($424 + 205 | 0) >> 0] = $425;
                                           HEAP8[($424 + 206 | 0) >> 0] = $425 >>> 8 | 0;
                                           cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($14 | 0, $2 + 200 | 0 | 0, 1052307 | 0, 5 | 0);
                                           i64toi32_i32$5 = $2;
                                           i64toi32_i32$1 = HEAP32[($2 + 72 | 0) >> 2] | 0;
                                           i64toi32_i32$3 = HEAP32[($2 + 76 | 0) >> 2] | 0;
                                           $47 = i64toi32_i32$1;
                                           $47$hi = i64toi32_i32$3;
                                           i64toi32_i32$5 = i64toi32_i32$1;
                                           i64toi32_i32$1 = -1;
                                           i64toi32_i32$4 = -256;
                                           i64toi32_i32$1 = i64toi32_i32$3 & i64toi32_i32$1 | 0;
                                           $46 = i64toi32_i32$5 & i64toi32_i32$4 | 0;
                                           $46$hi = i64toi32_i32$1;
                                           i64toi32_i32$3 = ($2 + 64 | 0) + 16 | 0;
                                           i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                           i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                           $48 = i64toi32_i32$1;
                                           $48$hi = i64toi32_i32$5;
                                           i64toi32_i32$3 = ($2 + 64 | 0) + 24 | 0;
                                           i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                           i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                           $51 = i64toi32_i32$5;
                                           $51$hi = i64toi32_i32$1;
                                           i64toi32_i32$3 = ($2 + 64 | 0) + 32 | 0;
                                           i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                           i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                           $32 = i64toi32_i32$1;
                                           $32$hi = i64toi32_i32$5;
                                           i64toi32_i32$3 = ($2 + 64 | 0) + 40 | 0;
                                           i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                           i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                           $50 = i64toi32_i32$5;
                                           $50$hi = i64toi32_i32$1;
                                           i64toi32_i32$3 = $2 + 112 | 0;
                                           i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                           i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                           $49 = i64toi32_i32$1;
                                           $49$hi = i64toi32_i32$5;
                                           $19 = HEAP32[($2 + 120 | 0) >> 2] | 0;
                                           $15 = HEAP32[(($2 + 64 | 0) + 60 | 0) >> 2] | 0;
                                           i64toi32_i32$3 = $2 + 128 | 0;
                                           i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                           i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                           $53 = i64toi32_i32$5;
                                           $53$hi = i64toi32_i32$1;
                                           break label$4;
                                          }
                                          label$126 : {
                                           label$127 : {
                                            i64toi32_i32$1 = $31$hi;
                                            i64toi32_i32$3 = $31;
                                            i64toi32_i32$5 = 0;
                                            i64toi32_i32$4 = 1;
                                            if ((i64toi32_i32$3 | 0) != (i64toi32_i32$4 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$5 | 0) | 0) {
                                             break label$127
                                            }
                                            i64toi32_i32$3 = $32$hi;
                                            i64toi32_i32$4 = $32;
                                            i64toi32_i32$1 = 0;
                                            i64toi32_i32$5 = 1;
                                            i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
                                            i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
                                            if (i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0) {
                                             i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
                                            }
                                            $32 = i64toi32_i32$2;
                                            $32$hi = i64toi32_i32$0;
                                            i64toi32_i32$0 = $30$hi;
                                            i64toi32_i32$0 = $32$hi;
                                            i64toi32_i32$3 = i64toi32_i32$2;
                                            i64toi32_i32$4 = $30$hi;
                                            i64toi32_i32$5 = $30;
                                            if (i64toi32_i32$0 >>> 0 < i64toi32_i32$4 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$4 | 0) & i64toi32_i32$3 >>> 0 <= i64toi32_i32$5 >>> 0 | 0) | 0) {
                                             break label$127
                                            }
                                            i64toi32_i32$3 = 0;
                                            $52 = 0;
                                            $52$hi = i64toi32_i32$3;
                                            $1 = 3;
                                            $15 = 0;
                                            break label$126;
                                           }
                                           $T_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hf422f9333a8bbafa($2 + 200 | 0 | 0, $1 | 0);
                                           $9 = 1;
                                           if ((HEAP32[($2 + 200 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                                            break label$27
                                           }
                                           i64toi32_i32$5 = $2 + 248 | 0;
                                           i64toi32_i32$3 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                           i64toi32_i32$0 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                           $31 = i64toi32_i32$3;
                                           $31$hi = i64toi32_i32$0;
                                           i64toi32_i32$3 = ($2 + 184 | 0) + 8 | 0;
                                           HEAP32[i64toi32_i32$3 >> 2] = $31;
                                           HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
                                           $20 = HEAP32[($2 + 268 | 0) >> 2] | 0;
                                           HEAP32[(($2 + 168 | 0) + 8 | 0) >> 2] = $20;
                                           i64toi32_i32$3 = ($2 + 152 | 0) + 8 | 0;
                                           HEAP32[i64toi32_i32$3 >> 2] = $31;
                                           HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
                                           i64toi32_i32$5 = $2 + 240 | 0;
                                           i64toi32_i32$0 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                           i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                           $31 = i64toi32_i32$0;
                                           $31$hi = i64toi32_i32$3;
                                           i64toi32_i32$0 = $2;
                                           HEAP32[($2 + 184 | 0) >> 2] = $31;
                                           HEAP32[($2 + 188 | 0) >> 2] = i64toi32_i32$3;
                                           i64toi32_i32$5 = $2 + 260 | 0;
                                           i64toi32_i32$3 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                           i64toi32_i32$0 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                           $32 = i64toi32_i32$3;
                                           $32$hi = i64toi32_i32$0;
                                           i64toi32_i32$3 = $2;
                                           HEAP32[($2 + 168 | 0) >> 2] = $32;
                                           HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$0;
                                           i64toi32_i32$0 = $31$hi;
                                           i64toi32_i32$3 = $2;
                                           HEAP32[($2 + 152 | 0) >> 2] = $31;
                                           HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
                                           i64toi32_i32$5 = $2 + 232 | 0;
                                           i64toi32_i32$0 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                           i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                           $47 = i64toi32_i32$0;
                                           $47$hi = i64toi32_i32$3;
                                           i64toi32_i32$5 = $2 + 224 | 0;
                                           i64toi32_i32$3 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                           i64toi32_i32$0 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                           $52 = i64toi32_i32$3;
                                           $52$hi = i64toi32_i32$0;
                                           i64toi32_i32$5 = $2 + 216 | 0;
                                           i64toi32_i32$0 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                           i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                           $30 = i64toi32_i32$0;
                                           $30$hi = i64toi32_i32$3;
                                           $1 = HEAPU8[(($2 + 200 | 0) + 8 | 0) >> 0] | 0;
                                           $15 = HEAP32[($2 + 256 | 0) >> 2] | 0;
                                           i64toi32_i32$5 = $2 + 209 | 0;
                                           i64toi32_i32$3 = HEAPU8[i64toi32_i32$5 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$5 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$5 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$5 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                           i64toi32_i32$0 = 0;
                                           $31 = i64toi32_i32$3;
                                           $31$hi = i64toi32_i32$0;
                                           i64toi32_i32$5 = $2 + 213 | 0;
                                           i64toi32_i32$0 = HEAPU8[i64toi32_i32$5 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$5 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
                                           i64toi32_i32$3 = 0;
                                           $48 = i64toi32_i32$0;
                                           $48$hi = i64toi32_i32$3;
                                           i64toi32_i32$5 = $2 + 215 | 0;
                                           i64toi32_i32$3 = HEAPU8[i64toi32_i32$5 >> 0] | 0;
                                           i64toi32_i32$0 = 0;
                                           $51 = i64toi32_i32$3;
                                           $51$hi = i64toi32_i32$0;
                                           HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] = $20;
                                           i64toi32_i32$0 = $32$hi;
                                           i64toi32_i32$3 = $2;
                                           HEAP32[($2 + 136 | 0) >> 2] = $32;
                                           HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$0;
                                           i64toi32_i32$0 = $31$hi;
                                           $2639 = $31;
                                           $2639$hi = i64toi32_i32$0;
                                           i64toi32_i32$0 = $48$hi;
                                           $2640 = $48;
                                           $2640$hi = i64toi32_i32$0;
                                           i64toi32_i32$0 = $51$hi;
                                           i64toi32_i32$5 = $51;
                                           i64toi32_i32$3 = 0;
                                           i64toi32_i32$4 = 16;
                                           i64toi32_i32$1 = i64toi32_i32$4 & 31 | 0;
                                           if (32 >>> 0 <= (i64toi32_i32$4 & 63 | 0) >>> 0) {
                                            i64toi32_i32$3 = i64toi32_i32$5 << i64toi32_i32$1 | 0;
                                            $427 = 0;
                                           } else {
                                            i64toi32_i32$3 = ((1 << i64toi32_i32$1 | 0) - 1 | 0) & (i64toi32_i32$5 >>> (32 - i64toi32_i32$1 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$1 | 0) | 0;
                                            $427 = i64toi32_i32$5 << i64toi32_i32$1 | 0;
                                           }
                                           $2642$hi = i64toi32_i32$3;
                                           i64toi32_i32$3 = $2640$hi;
                                           i64toi32_i32$0 = $2640;
                                           i64toi32_i32$5 = $2642$hi;
                                           i64toi32_i32$4 = $427;
                                           i64toi32_i32$5 = i64toi32_i32$3 | i64toi32_i32$5 | 0;
                                           i64toi32_i32$3 = i64toi32_i32$0 | i64toi32_i32$4 | 0;
                                           i64toi32_i32$0 = 0;
                                           i64toi32_i32$4 = 32;
                                           i64toi32_i32$1 = i64toi32_i32$4 & 31 | 0;
                                           if (32 >>> 0 <= (i64toi32_i32$4 & 63 | 0) >>> 0) {
                                            i64toi32_i32$0 = i64toi32_i32$3 << i64toi32_i32$1 | 0;
                                            $428 = 0;
                                           } else {
                                            i64toi32_i32$0 = ((1 << i64toi32_i32$1 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$1 | 0) | 0) | 0 | (i64toi32_i32$5 << i64toi32_i32$1 | 0) | 0;
                                            $428 = i64toi32_i32$3 << i64toi32_i32$1 | 0;
                                           }
                                           $2644$hi = i64toi32_i32$0;
                                           i64toi32_i32$0 = $2639$hi;
                                           i64toi32_i32$5 = $2639;
                                           i64toi32_i32$3 = $2644$hi;
                                           i64toi32_i32$4 = $428;
                                           i64toi32_i32$3 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
                                           $31 = i64toi32_i32$5 | i64toi32_i32$4 | 0;
                                           $31$hi = i64toi32_i32$3;
                                          }
                                          i64toi32_i32$3 = $47$hi;
                                          i64toi32_i32$5 = ($2 + 200 | 0) + 24 | 0;
                                          HEAP32[i64toi32_i32$5 >> 2] = $47;
                                          HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$3;
                                          i64toi32_i32$3 = $52$hi;
                                          i64toi32_i32$5 = ($2 + 200 | 0) + 16 | 0;
                                          HEAP32[i64toi32_i32$5 >> 2] = $52;
                                          HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$3;
                                          i64toi32_i32$3 = $30$hi;
                                          i64toi32_i32$5 = ($2 + 200 | 0) + 8 | 0;
                                          HEAP32[i64toi32_i32$5 >> 2] = $30;
                                          HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$3;
                                          i64toi32_i32$0 = $2;
                                          i64toi32_i32$3 = HEAP32[($2 + 152 | 0) >> 2] | 0;
                                          i64toi32_i32$5 = HEAP32[($2 + 156 | 0) >> 2] | 0;
                                          $2662 = i64toi32_i32$3;
                                          i64toi32_i32$3 = ($2 + 200 | 0) + 32 | 0;
                                          HEAP32[i64toi32_i32$3 >> 2] = $2662;
                                          HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
                                          i64toi32_i32$0 = $2;
                                          i64toi32_i32$5 = HEAP32[($2 + 136 | 0) >> 2] | 0;
                                          i64toi32_i32$3 = HEAP32[($2 + 140 | 0) >> 2] | 0;
                                          $2666 = i64toi32_i32$5;
                                          i64toi32_i32$5 = $2 + 252 | 0;
                                          HEAP32[i64toi32_i32$5 >> 2] = $2666;
                                          HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$3;
                                          i64toi32_i32$0 = ($2 + 152 | 0) + 8 | 0;
                                          i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                          i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                          $2673 = i64toi32_i32$3;
                                          i64toi32_i32$3 = ($2 + 200 | 0) + 40 | 0;
                                          HEAP32[i64toi32_i32$3 >> 2] = $2673;
                                          HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
                                          HEAP32[(($2 + 200 | 0) + 60 | 0) >> 2] = HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] | 0;
                                          HEAP8[($2 + 200 | 0) >> 0] = $1;
                                          HEAP32[($2 + 248 | 0) >> 2] = $15;
                                          i64toi32_i32$5 = $31$hi;
                                          HEAP8[($2 + 201 | 0) >> 0] = $31;
                                          HEAP8[($2 + 202 | 0) >> 0] = $31 >>> 8 | 0;
                                          HEAP8[($2 + 203 | 0) >> 0] = $31 >>> 16 | 0;
                                          HEAP8[($2 + 204 | 0) >> 0] = $31 >>> 24 | 0;
                                          $2687 = $2;
                                          i64toi32_i32$0 = $31;
                                          i64toi32_i32$3 = 0;
                                          i64toi32_i32$4 = 48;
                                          i64toi32_i32$1 = i64toi32_i32$4 & 31 | 0;
                                          if (32 >>> 0 <= (i64toi32_i32$4 & 63 | 0) >>> 0) {
                                           i64toi32_i32$3 = 0;
                                           $429 = i64toi32_i32$5 >>> i64toi32_i32$1 | 0;
                                          } else {
                                           i64toi32_i32$3 = i64toi32_i32$5 >>> i64toi32_i32$1 | 0;
                                           $429 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$1 | 0) | 0;
                                          }
                                          HEAP8[($2687 + 207 | 0) >> 0] = $429;
                                          $2690 = $2;
                                          i64toi32_i32$3 = $31$hi;
                                          i64toi32_i32$5 = $31;
                                          i64toi32_i32$0 = 0;
                                          i64toi32_i32$4 = 32;
                                          i64toi32_i32$1 = i64toi32_i32$4 & 31 | 0;
                                          if (32 >>> 0 <= (i64toi32_i32$4 & 63 | 0) >>> 0) {
                                           i64toi32_i32$0 = 0;
                                           $430 = i64toi32_i32$3 >>> i64toi32_i32$1 | 0;
                                          } else {
                                           i64toi32_i32$0 = i64toi32_i32$3 >>> i64toi32_i32$1 | 0;
                                           $430 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$1 | 0) | 0;
                                          }
                                          $431 = $2690;
                                          $432 = $430;
                                          HEAP8[($431 + 205 | 0) >> 0] = $432;
                                          HEAP8[($431 + 206 | 0) >> 0] = $432 >>> 8 | 0;
                                          cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($14 | 0, $2 + 200 | 0 | 0, 1052298 | 0, 9 | 0);
                                          i64toi32_i32$3 = $2;
                                          i64toi32_i32$0 = HEAP32[($2 + 72 | 0) >> 2] | 0;
                                          i64toi32_i32$5 = HEAP32[($2 + 76 | 0) >> 2] | 0;
                                          $47 = i64toi32_i32$0;
                                          $47$hi = i64toi32_i32$5;
                                          i64toi32_i32$3 = i64toi32_i32$0;
                                          i64toi32_i32$0 = -1;
                                          i64toi32_i32$4 = -256;
                                          i64toi32_i32$0 = i64toi32_i32$5 & i64toi32_i32$0 | 0;
                                          $46 = i64toi32_i32$3 & i64toi32_i32$4 | 0;
                                          $46$hi = i64toi32_i32$0;
                                          i64toi32_i32$5 = ($2 + 64 | 0) + 16 | 0;
                                          i64toi32_i32$0 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                          i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                          $48 = i64toi32_i32$0;
                                          $48$hi = i64toi32_i32$3;
                                          i64toi32_i32$5 = ($2 + 64 | 0) + 24 | 0;
                                          i64toi32_i32$3 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                          i64toi32_i32$0 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                          $51 = i64toi32_i32$3;
                                          $51$hi = i64toi32_i32$0;
                                          i64toi32_i32$5 = ($2 + 64 | 0) + 32 | 0;
                                          i64toi32_i32$0 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                          i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                          $32 = i64toi32_i32$0;
                                          $32$hi = i64toi32_i32$3;
                                          i64toi32_i32$5 = ($2 + 64 | 0) + 40 | 0;
                                          i64toi32_i32$3 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                          i64toi32_i32$0 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                          $50 = i64toi32_i32$3;
                                          $50$hi = i64toi32_i32$0;
                                          i64toi32_i32$5 = $2 + 112 | 0;
                                          i64toi32_i32$0 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                          i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                          $49 = i64toi32_i32$0;
                                          $49$hi = i64toi32_i32$3;
                                          $19 = HEAP32[($2 + 120 | 0) >> 2] | 0;
                                          $15 = HEAP32[(($2 + 64 | 0) + 60 | 0) >> 2] | 0;
                                          i64toi32_i32$5 = $2 + 128 | 0;
                                          i64toi32_i32$3 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                          i64toi32_i32$0 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                          $53 = i64toi32_i32$3;
                                          $53$hi = i64toi32_i32$0;
                                          break label$4;
                                         }
                                         label$128 : {
                                          label$129 : {
                                           i64toi32_i32$0 = $31$hi;
                                           i64toi32_i32$5 = $31;
                                           i64toi32_i32$3 = 0;
                                           i64toi32_i32$4 = 1;
                                           if ((i64toi32_i32$5 | 0) != (i64toi32_i32$4 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$3 | 0) | 0) {
                                            break label$129
                                           }
                                           i64toi32_i32$5 = $32$hi;
                                           i64toi32_i32$4 = $32;
                                           i64toi32_i32$0 = 0;
                                           i64toi32_i32$3 = 1;
                                           i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
                                           i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
                                           if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
                                            i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
                                           }
                                           $32 = i64toi32_i32$1;
                                           $32$hi = i64toi32_i32$2;
                                           i64toi32_i32$2 = $30$hi;
                                           i64toi32_i32$2 = $32$hi;
                                           i64toi32_i32$5 = i64toi32_i32$1;
                                           i64toi32_i32$4 = $30$hi;
                                           i64toi32_i32$3 = $30;
                                           if (i64toi32_i32$2 >>> 0 < i64toi32_i32$4 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$4 | 0) & i64toi32_i32$5 >>> 0 <= i64toi32_i32$3 >>> 0 | 0) | 0) {
                                            break label$129
                                           }
                                           i64toi32_i32$5 = 0;
                                           $31 = 0;
                                           $31$hi = i64toi32_i32$5;
                                           i64toi32_i32$5 = 0;
                                           $52 = 3;
                                           $52$hi = i64toi32_i32$5;
                                           $1 = 0;
                                           break label$128;
                                          }
                                          $cardano_serialization_lib__utils__BigNum_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h29637bb571dceb02($2 + 200 | 0 | 0, $1 | 0);
                                          i64toi32_i32$3 = $2;
                                          i64toi32_i32$5 = HEAP32[($2 + 200 | 0) >> 2] | 0;
                                          i64toi32_i32$2 = HEAP32[($2 + 204 | 0) >> 2] | 0;
                                          i64toi32_i32$3 = i64toi32_i32$5;
                                          i64toi32_i32$5 = 0;
                                          i64toi32_i32$4 = 1;
                                          if ((i64toi32_i32$3 | 0) != (i64toi32_i32$4 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$5 | 0) | 0) {
                                           break label$26
                                          }
                                          $1 = HEAP32[($2 + 268 | 0) >> 2] | 0;
                                          HEAP32[(($2 + 168 | 0) + 8 | 0) >> 2] = $1;
                                          i64toi32_i32$4 = $2 + 248 | 0;
                                          i64toi32_i32$3 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                          i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                          $2754 = i64toi32_i32$3;
                                          i64toi32_i32$3 = ($2 + 152 | 0) + 8 | 0;
                                          HEAP32[i64toi32_i32$3 >> 2] = $2754;
                                          HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                                          HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] = $1;
                                          i64toi32_i32$4 = $2;
                                          i64toi32_i32$2 = HEAP32[($2 + 260 | 0) >> 2] | 0;
                                          i64toi32_i32$3 = HEAP32[($2 + 264 | 0) >> 2] | 0;
                                          $31 = i64toi32_i32$2;
                                          $31$hi = i64toi32_i32$3;
                                          i64toi32_i32$2 = $2;
                                          HEAP32[($2 + 168 | 0) >> 2] = $31;
                                          HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$3;
                                          i64toi32_i32$2 = $2;
                                          HEAP32[($2 + 136 | 0) >> 2] = $31;
                                          HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$3;
                                          i64toi32_i32$4 = $2 + 240 | 0;
                                          i64toi32_i32$3 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                          i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                          $2768 = i64toi32_i32$3;
                                          i64toi32_i32$3 = $2;
                                          HEAP32[($2 + 152 | 0) >> 2] = $2768;
                                          HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$2;
                                          i64toi32_i32$4 = $2 + 232 | 0;
                                          i64toi32_i32$2 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                          i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                          $47 = i64toi32_i32$2;
                                          $47$hi = i64toi32_i32$3;
                                          i64toi32_i32$4 = $2 + 224 | 0;
                                          i64toi32_i32$3 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                          i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                          $31 = i64toi32_i32$3;
                                          $31$hi = i64toi32_i32$2;
                                          i64toi32_i32$4 = $2 + 216 | 0;
                                          i64toi32_i32$2 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                          i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                          $30 = i64toi32_i32$2;
                                          $30$hi = i64toi32_i32$3;
                                          $1 = HEAP32[($2 + 256 | 0) >> 2] | 0;
                                          i64toi32_i32$4 = $2;
                                          i64toi32_i32$3 = HEAP32[($2 + 208 | 0) >> 2] | 0;
                                          i64toi32_i32$2 = HEAP32[($2 + 212 | 0) >> 2] | 0;
                                          $52 = i64toi32_i32$3;
                                          $52$hi = i64toi32_i32$2;
                                         }
                                         i64toi32_i32$2 = $47$hi;
                                         i64toi32_i32$3 = ($2 + 200 | 0) + 24 | 0;
                                         HEAP32[i64toi32_i32$3 >> 2] = $47;
                                         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                                         i64toi32_i32$2 = $31$hi;
                                         i64toi32_i32$3 = ($2 + 200 | 0) + 16 | 0;
                                         HEAP32[i64toi32_i32$3 >> 2] = $31;
                                         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                                         i64toi32_i32$2 = $30$hi;
                                         i64toi32_i32$3 = ($2 + 200 | 0) + 8 | 0;
                                         HEAP32[i64toi32_i32$3 >> 2] = $30;
                                         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                                         i64toi32_i32$4 = $2;
                                         i64toi32_i32$2 = HEAP32[($2 + 152 | 0) >> 2] | 0;
                                         i64toi32_i32$3 = HEAP32[($2 + 156 | 0) >> 2] | 0;
                                         $2799 = i64toi32_i32$2;
                                         i64toi32_i32$2 = ($2 + 200 | 0) + 32 | 0;
                                         HEAP32[i64toi32_i32$2 >> 2] = $2799;
                                         HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                                         i64toi32_i32$4 = $2;
                                         i64toi32_i32$3 = HEAP32[($2 + 136 | 0) >> 2] | 0;
                                         i64toi32_i32$2 = HEAP32[($2 + 140 | 0) >> 2] | 0;
                                         $2803 = i64toi32_i32$3;
                                         i64toi32_i32$3 = $2 + 252 | 0;
                                         HEAP32[i64toi32_i32$3 >> 2] = $2803;
                                         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                                         i64toi32_i32$4 = ($2 + 152 | 0) + 8 | 0;
                                         i64toi32_i32$2 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                         i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                         $2810 = i64toi32_i32$2;
                                         i64toi32_i32$2 = ($2 + 200 | 0) + 40 | 0;
                                         HEAP32[i64toi32_i32$2 >> 2] = $2810;
                                         HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                                         HEAP32[(($2 + 200 | 0) + 60 | 0) >> 2] = HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] | 0;
                                         i64toi32_i32$3 = $52$hi;
                                         i64toi32_i32$2 = $2;
                                         HEAP32[($2 + 200 | 0) >> 2] = $52;
                                         HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$3;
                                         HEAP32[($2 + 248 | 0) >> 2] = $1;
                                         cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($14 | 0, $2 + 200 | 0 | 0, 1052286 | 0, 12 | 0);
                                         i64toi32_i32$4 = $2;
                                         i64toi32_i32$3 = HEAP32[($2 + 72 | 0) >> 2] | 0;
                                         i64toi32_i32$2 = HEAP32[($2 + 76 | 0) >> 2] | 0;
                                         $47 = i64toi32_i32$3;
                                         $47$hi = i64toi32_i32$2;
                                         i64toi32_i32$4 = i64toi32_i32$3;
                                         i64toi32_i32$3 = -1;
                                         i64toi32_i32$5 = -256;
                                         i64toi32_i32$3 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
                                         $46 = i64toi32_i32$4 & i64toi32_i32$5 | 0;
                                         $46$hi = i64toi32_i32$3;
                                         i64toi32_i32$2 = ($2 + 64 | 0) + 16 | 0;
                                         i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                         i64toi32_i32$4 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                         $48 = i64toi32_i32$3;
                                         $48$hi = i64toi32_i32$4;
                                         i64toi32_i32$2 = ($2 + 64 | 0) + 24 | 0;
                                         i64toi32_i32$4 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                         i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                         $51 = i64toi32_i32$4;
                                         $51$hi = i64toi32_i32$3;
                                         i64toi32_i32$2 = ($2 + 64 | 0) + 32 | 0;
                                         i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                         i64toi32_i32$4 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                         $32 = i64toi32_i32$3;
                                         $32$hi = i64toi32_i32$4;
                                         i64toi32_i32$2 = ($2 + 64 | 0) + 40 | 0;
                                         i64toi32_i32$4 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                         i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                         $50 = i64toi32_i32$4;
                                         $50$hi = i64toi32_i32$3;
                                         i64toi32_i32$2 = $2 + 112 | 0;
                                         i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                         i64toi32_i32$4 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                         $49 = i64toi32_i32$3;
                                         $49$hi = i64toi32_i32$4;
                                         $19 = HEAP32[($2 + 120 | 0) >> 2] | 0;
                                         $15 = HEAP32[(($2 + 64 | 0) + 60 | 0) >> 2] | 0;
                                         i64toi32_i32$2 = $2 + 128 | 0;
                                         i64toi32_i32$4 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                         i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                         $53 = i64toi32_i32$4;
                                         $53$hi = i64toi32_i32$3;
                                         break label$4;
                                        }
                                        label$130 : {
                                         label$131 : {
                                          i64toi32_i32$3 = $31$hi;
                                          i64toi32_i32$2 = $31;
                                          i64toi32_i32$4 = 0;
                                          i64toi32_i32$5 = 1;
                                          if ((i64toi32_i32$2 | 0) != (i64toi32_i32$5 | 0) | (i64toi32_i32$3 | 0) != (i64toi32_i32$4 | 0) | 0) {
                                           break label$131
                                          }
                                          i64toi32_i32$2 = $32$hi;
                                          i64toi32_i32$5 = $32;
                                          i64toi32_i32$3 = 0;
                                          i64toi32_i32$4 = 1;
                                          i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
                                          i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
                                          if (i64toi32_i32$0 >>> 0 < i64toi32_i32$4 >>> 0) {
                                           i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
                                          }
                                          $32 = i64toi32_i32$0;
                                          $32$hi = i64toi32_i32$1;
                                          i64toi32_i32$1 = $30$hi;
                                          i64toi32_i32$1 = $32$hi;
                                          i64toi32_i32$2 = i64toi32_i32$0;
                                          i64toi32_i32$5 = $30$hi;
                                          i64toi32_i32$4 = $30;
                                          if (i64toi32_i32$1 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$2 >>> 0 <= i64toi32_i32$4 >>> 0 | 0) | 0) {
                                           break label$131
                                          }
                                          i64toi32_i32$2 = 0;
                                          $31 = 0;
                                          $31$hi = i64toi32_i32$2;
                                          i64toi32_i32$2 = 0;
                                          $52 = 3;
                                          $52$hi = i64toi32_i32$2;
                                          $1 = 0;
                                          break label$130;
                                         }
                                         $cardano_serialization_lib__utils__BigNum_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h29637bb571dceb02($2 + 200 | 0 | 0, $1 | 0);
                                         i64toi32_i32$4 = $2;
                                         i64toi32_i32$2 = HEAP32[($2 + 200 | 0) >> 2] | 0;
                                         i64toi32_i32$1 = HEAP32[($2 + 204 | 0) >> 2] | 0;
                                         i64toi32_i32$4 = i64toi32_i32$2;
                                         i64toi32_i32$2 = 0;
                                         i64toi32_i32$5 = 1;
                                         if ((i64toi32_i32$4 | 0) != (i64toi32_i32$5 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$2 | 0) | 0) {
                                          break label$25
                                         }
                                         $1 = HEAP32[($2 + 268 | 0) >> 2] | 0;
                                         HEAP32[(($2 + 168 | 0) + 8 | 0) >> 2] = $1;
                                         i64toi32_i32$5 = $2 + 248 | 0;
                                         i64toi32_i32$4 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                         i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                         $2883 = i64toi32_i32$4;
                                         i64toi32_i32$4 = ($2 + 152 | 0) + 8 | 0;
                                         HEAP32[i64toi32_i32$4 >> 2] = $2883;
                                         HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$1;
                                         HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] = $1;
                                         i64toi32_i32$5 = $2;
                                         i64toi32_i32$1 = HEAP32[($2 + 260 | 0) >> 2] | 0;
                                         i64toi32_i32$4 = HEAP32[($2 + 264 | 0) >> 2] | 0;
                                         $31 = i64toi32_i32$1;
                                         $31$hi = i64toi32_i32$4;
                                         i64toi32_i32$1 = $2;
                                         HEAP32[($2 + 168 | 0) >> 2] = $31;
                                         HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$4;
                                         i64toi32_i32$1 = $2;
                                         HEAP32[($2 + 136 | 0) >> 2] = $31;
                                         HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$4;
                                         i64toi32_i32$5 = $2 + 240 | 0;
                                         i64toi32_i32$4 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                         i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                         $2897 = i64toi32_i32$4;
                                         i64toi32_i32$4 = $2;
                                         HEAP32[($2 + 152 | 0) >> 2] = $2897;
                                         HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$1;
                                         i64toi32_i32$5 = $2 + 232 | 0;
                                         i64toi32_i32$1 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                         i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                         $47 = i64toi32_i32$1;
                                         $47$hi = i64toi32_i32$4;
                                         i64toi32_i32$5 = $2 + 224 | 0;
                                         i64toi32_i32$4 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                         i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                         $31 = i64toi32_i32$4;
                                         $31$hi = i64toi32_i32$1;
                                         i64toi32_i32$5 = $2 + 216 | 0;
                                         i64toi32_i32$1 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                         i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                         $30 = i64toi32_i32$1;
                                         $30$hi = i64toi32_i32$4;
                                         $1 = HEAP32[($2 + 256 | 0) >> 2] | 0;
                                         i64toi32_i32$5 = $2;
                                         i64toi32_i32$4 = HEAP32[($2 + 208 | 0) >> 2] | 0;
                                         i64toi32_i32$1 = HEAP32[($2 + 212 | 0) >> 2] | 0;
                                         $52 = i64toi32_i32$4;
                                         $52$hi = i64toi32_i32$1;
                                        }
                                        i64toi32_i32$1 = $47$hi;
                                        i64toi32_i32$4 = ($2 + 200 | 0) + 24 | 0;
                                        HEAP32[i64toi32_i32$4 >> 2] = $47;
                                        HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$1;
                                        i64toi32_i32$1 = $31$hi;
                                        i64toi32_i32$4 = ($2 + 200 | 0) + 16 | 0;
                                        HEAP32[i64toi32_i32$4 >> 2] = $31;
                                        HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$1;
                                        i64toi32_i32$1 = $30$hi;
                                        i64toi32_i32$4 = ($2 + 200 | 0) + 8 | 0;
                                        HEAP32[i64toi32_i32$4 >> 2] = $30;
                                        HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$1;
                                        i64toi32_i32$5 = $2;
                                        i64toi32_i32$1 = HEAP32[($2 + 152 | 0) >> 2] | 0;
                                        i64toi32_i32$4 = HEAP32[($2 + 156 | 0) >> 2] | 0;
                                        $2928 = i64toi32_i32$1;
                                        i64toi32_i32$1 = ($2 + 200 | 0) + 32 | 0;
                                        HEAP32[i64toi32_i32$1 >> 2] = $2928;
                                        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$4;
                                        i64toi32_i32$5 = $2;
                                        i64toi32_i32$4 = HEAP32[($2 + 136 | 0) >> 2] | 0;
                                        i64toi32_i32$1 = HEAP32[($2 + 140 | 0) >> 2] | 0;
                                        $2932 = i64toi32_i32$4;
                                        i64toi32_i32$4 = $2 + 252 | 0;
                                        HEAP32[i64toi32_i32$4 >> 2] = $2932;
                                        HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$1;
                                        i64toi32_i32$5 = ($2 + 152 | 0) + 8 | 0;
                                        i64toi32_i32$1 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                        i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                        $2939 = i64toi32_i32$1;
                                        i64toi32_i32$1 = ($2 + 200 | 0) + 40 | 0;
                                        HEAP32[i64toi32_i32$1 >> 2] = $2939;
                                        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$4;
                                        HEAP32[(($2 + 200 | 0) + 60 | 0) >> 2] = HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] | 0;
                                        i64toi32_i32$4 = $52$hi;
                                        i64toi32_i32$1 = $2;
                                        HEAP32[($2 + 200 | 0) >> 2] = $52;
                                        HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$4;
                                        HEAP32[($2 + 248 | 0) >> 2] = $1;
                                        cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($14 | 0, $2 + 200 | 0 | 0, 1052275 | 0, 11 | 0);
                                        i64toi32_i32$5 = $2;
                                        i64toi32_i32$4 = HEAP32[($2 + 72 | 0) >> 2] | 0;
                                        i64toi32_i32$1 = HEAP32[($2 + 76 | 0) >> 2] | 0;
                                        $47 = i64toi32_i32$4;
                                        $47$hi = i64toi32_i32$1;
                                        i64toi32_i32$5 = i64toi32_i32$4;
                                        i64toi32_i32$4 = -1;
                                        i64toi32_i32$2 = -256;
                                        i64toi32_i32$4 = i64toi32_i32$1 & i64toi32_i32$4 | 0;
                                        $46 = i64toi32_i32$5 & i64toi32_i32$2 | 0;
                                        $46$hi = i64toi32_i32$4;
                                        i64toi32_i32$1 = ($2 + 64 | 0) + 16 | 0;
                                        i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                        i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                        $48 = i64toi32_i32$4;
                                        $48$hi = i64toi32_i32$5;
                                        i64toi32_i32$1 = ($2 + 64 | 0) + 24 | 0;
                                        i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                        i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                        $51 = i64toi32_i32$5;
                                        $51$hi = i64toi32_i32$4;
                                        i64toi32_i32$1 = ($2 + 64 | 0) + 32 | 0;
                                        i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                        i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                        $32 = i64toi32_i32$4;
                                        $32$hi = i64toi32_i32$5;
                                        i64toi32_i32$1 = ($2 + 64 | 0) + 40 | 0;
                                        i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                        i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                        $50 = i64toi32_i32$5;
                                        $50$hi = i64toi32_i32$4;
                                        i64toi32_i32$1 = $2 + 112 | 0;
                                        i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                        i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                        $49 = i64toi32_i32$4;
                                        $49$hi = i64toi32_i32$5;
                                        $19 = HEAP32[($2 + 120 | 0) >> 2] | 0;
                                        $15 = HEAP32[(($2 + 64 | 0) + 60 | 0) >> 2] | 0;
                                        i64toi32_i32$1 = $2 + 128 | 0;
                                        i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                        i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                        $53 = i64toi32_i32$5;
                                        $53$hi = i64toi32_i32$4;
                                        break label$4;
                                       }
                                       label$132 : {
                                        label$133 : {
                                         i64toi32_i32$4 = $31$hi;
                                         i64toi32_i32$1 = $31;
                                         i64toi32_i32$5 = 0;
                                         i64toi32_i32$2 = 1;
                                         if ((i64toi32_i32$1 | 0) != (i64toi32_i32$2 | 0) | (i64toi32_i32$4 | 0) != (i64toi32_i32$5 | 0) | 0) {
                                          break label$133
                                         }
                                         i64toi32_i32$1 = $32$hi;
                                         i64toi32_i32$2 = $32;
                                         i64toi32_i32$4 = 0;
                                         i64toi32_i32$5 = 1;
                                         i64toi32_i32$3 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
                                         i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
                                         if (i64toi32_i32$3 >>> 0 < i64toi32_i32$5 >>> 0) {
                                          i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
                                         }
                                         $32 = i64toi32_i32$3;
                                         $32$hi = i64toi32_i32$0;
                                         i64toi32_i32$0 = $30$hi;
                                         i64toi32_i32$0 = $32$hi;
                                         i64toi32_i32$1 = i64toi32_i32$3;
                                         i64toi32_i32$2 = $30$hi;
                                         i64toi32_i32$5 = $30;
                                         if (i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$3 >>> 0 <= i64toi32_i32$5 >>> 0 | 0) | 0) {
                                          break label$133
                                         }
                                         i64toi32_i32$1 = 0;
                                         $52 = 0;
                                         $52$hi = i64toi32_i32$1;
                                         $1 = 3;
                                         $15 = 0;
                                         break label$132;
                                        }
                                        $T_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hf422f9333a8bbafa($2 + 200 | 0 | 0, $1 | 0);
                                        $10 = 1;
                                        if ((HEAP32[($2 + 200 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                                         break label$24
                                        }
                                        i64toi32_i32$5 = $2 + 248 | 0;
                                        i64toi32_i32$1 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                        i64toi32_i32$0 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                        $31 = i64toi32_i32$1;
                                        $31$hi = i64toi32_i32$0;
                                        i64toi32_i32$1 = ($2 + 184 | 0) + 8 | 0;
                                        HEAP32[i64toi32_i32$1 >> 2] = $31;
                                        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                                        $20 = HEAP32[($2 + 268 | 0) >> 2] | 0;
                                        HEAP32[(($2 + 168 | 0) + 8 | 0) >> 2] = $20;
                                        i64toi32_i32$1 = ($2 + 152 | 0) + 8 | 0;
                                        HEAP32[i64toi32_i32$1 >> 2] = $31;
                                        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                                        i64toi32_i32$5 = $2 + 240 | 0;
                                        i64toi32_i32$0 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                        i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                        $31 = i64toi32_i32$0;
                                        $31$hi = i64toi32_i32$1;
                                        i64toi32_i32$0 = $2;
                                        HEAP32[($2 + 184 | 0) >> 2] = $31;
                                        HEAP32[($2 + 188 | 0) >> 2] = i64toi32_i32$1;
                                        i64toi32_i32$5 = $2 + 260 | 0;
                                        i64toi32_i32$1 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                        i64toi32_i32$0 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                        $32 = i64toi32_i32$1;
                                        $32$hi = i64toi32_i32$0;
                                        i64toi32_i32$1 = $2;
                                        HEAP32[($2 + 168 | 0) >> 2] = $32;
                                        HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$0;
                                        i64toi32_i32$0 = $31$hi;
                                        i64toi32_i32$1 = $2;
                                        HEAP32[($2 + 152 | 0) >> 2] = $31;
                                        HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
                                        i64toi32_i32$5 = $2 + 232 | 0;
                                        i64toi32_i32$0 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                        i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                        $47 = i64toi32_i32$0;
                                        $47$hi = i64toi32_i32$1;
                                        i64toi32_i32$5 = $2 + 224 | 0;
                                        i64toi32_i32$1 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                        i64toi32_i32$0 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                        $52 = i64toi32_i32$1;
                                        $52$hi = i64toi32_i32$0;
                                        i64toi32_i32$5 = $2 + 216 | 0;
                                        i64toi32_i32$0 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                        i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                        $30 = i64toi32_i32$0;
                                        $30$hi = i64toi32_i32$1;
                                        $1 = HEAPU8[(($2 + 200 | 0) + 8 | 0) >> 0] | 0;
                                        $15 = HEAP32[($2 + 256 | 0) >> 2] | 0;
                                        i64toi32_i32$5 = $2 + 209 | 0;
                                        i64toi32_i32$1 = HEAPU8[i64toi32_i32$5 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$5 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$5 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$5 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                        i64toi32_i32$0 = 0;
                                        $31 = i64toi32_i32$1;
                                        $31$hi = i64toi32_i32$0;
                                        i64toi32_i32$5 = $2 + 213 | 0;
                                        i64toi32_i32$0 = HEAPU8[i64toi32_i32$5 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$5 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
                                        i64toi32_i32$1 = 0;
                                        $48 = i64toi32_i32$0;
                                        $48$hi = i64toi32_i32$1;
                                        i64toi32_i32$5 = $2 + 215 | 0;
                                        i64toi32_i32$1 = HEAPU8[i64toi32_i32$5 >> 0] | 0;
                                        i64toi32_i32$0 = 0;
                                        $51 = i64toi32_i32$1;
                                        $51$hi = i64toi32_i32$0;
                                        HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] = $20;
                                        i64toi32_i32$0 = $32$hi;
                                        i64toi32_i32$1 = $2;
                                        HEAP32[($2 + 136 | 0) >> 2] = $32;
                                        HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$0;
                                        i64toi32_i32$0 = $31$hi;
                                        $3061 = $31;
                                        $3061$hi = i64toi32_i32$0;
                                        i64toi32_i32$0 = $48$hi;
                                        $3062 = $48;
                                        $3062$hi = i64toi32_i32$0;
                                        i64toi32_i32$0 = $51$hi;
                                        i64toi32_i32$5 = $51;
                                        i64toi32_i32$1 = 0;
                                        i64toi32_i32$2 = 16;
                                        i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
                                        if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                                         i64toi32_i32$1 = i64toi32_i32$5 << i64toi32_i32$4 | 0;
                                         $433 = 0;
                                        } else {
                                         i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$5 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
                                         $433 = i64toi32_i32$5 << i64toi32_i32$4 | 0;
                                        }
                                        $3064$hi = i64toi32_i32$1;
                                        i64toi32_i32$1 = $3062$hi;
                                        i64toi32_i32$0 = $3062;
                                        i64toi32_i32$5 = $3064$hi;
                                        i64toi32_i32$2 = $433;
                                        i64toi32_i32$5 = i64toi32_i32$1 | i64toi32_i32$5 | 0;
                                        i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
                                        i64toi32_i32$0 = 0;
                                        i64toi32_i32$2 = 32;
                                        i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
                                        if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                                         i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
                                         $434 = 0;
                                        } else {
                                         i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$5 << i64toi32_i32$4 | 0) | 0;
                                         $434 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
                                        }
                                        $3066$hi = i64toi32_i32$0;
                                        i64toi32_i32$0 = $3061$hi;
                                        i64toi32_i32$5 = $3061;
                                        i64toi32_i32$1 = $3066$hi;
                                        i64toi32_i32$2 = $434;
                                        i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
                                        $31 = i64toi32_i32$5 | i64toi32_i32$2 | 0;
                                        $31$hi = i64toi32_i32$1;
                                       }
                                       i64toi32_i32$1 = $47$hi;
                                       i64toi32_i32$5 = ($2 + 200 | 0) + 24 | 0;
                                       HEAP32[i64toi32_i32$5 >> 2] = $47;
                                       HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$1;
                                       i64toi32_i32$1 = $52$hi;
                                       i64toi32_i32$5 = ($2 + 200 | 0) + 16 | 0;
                                       HEAP32[i64toi32_i32$5 >> 2] = $52;
                                       HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$1;
                                       i64toi32_i32$1 = $30$hi;
                                       i64toi32_i32$5 = ($2 + 200 | 0) + 8 | 0;
                                       HEAP32[i64toi32_i32$5 >> 2] = $30;
                                       HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$1;
                                       i64toi32_i32$0 = $2;
                                       i64toi32_i32$1 = HEAP32[($2 + 152 | 0) >> 2] | 0;
                                       i64toi32_i32$5 = HEAP32[($2 + 156 | 0) >> 2] | 0;
                                       $3084 = i64toi32_i32$1;
                                       i64toi32_i32$1 = ($2 + 200 | 0) + 32 | 0;
                                       HEAP32[i64toi32_i32$1 >> 2] = $3084;
                                       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$5;
                                       i64toi32_i32$0 = $2;
                                       i64toi32_i32$5 = HEAP32[($2 + 136 | 0) >> 2] | 0;
                                       i64toi32_i32$1 = HEAP32[($2 + 140 | 0) >> 2] | 0;
                                       $3088 = i64toi32_i32$5;
                                       i64toi32_i32$5 = $2 + 252 | 0;
                                       HEAP32[i64toi32_i32$5 >> 2] = $3088;
                                       HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$1;
                                       i64toi32_i32$0 = ($2 + 152 | 0) + 8 | 0;
                                       i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                       i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                       $3095 = i64toi32_i32$1;
                                       i64toi32_i32$1 = ($2 + 200 | 0) + 40 | 0;
                                       HEAP32[i64toi32_i32$1 >> 2] = $3095;
                                       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$5;
                                       HEAP32[(($2 + 200 | 0) + 60 | 0) >> 2] = HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] | 0;
                                       HEAP8[($2 + 200 | 0) >> 0] = $1;
                                       HEAP32[($2 + 248 | 0) >> 2] = $15;
                                       i64toi32_i32$5 = $31$hi;
                                       HEAP8[($2 + 201 | 0) >> 0] = $31;
                                       HEAP8[($2 + 202 | 0) >> 0] = $31 >>> 8 | 0;
                                       HEAP8[($2 + 203 | 0) >> 0] = $31 >>> 16 | 0;
                                       HEAP8[($2 + 204 | 0) >> 0] = $31 >>> 24 | 0;
                                       $3109 = $2;
                                       i64toi32_i32$0 = $31;
                                       i64toi32_i32$1 = 0;
                                       i64toi32_i32$2 = 48;
                                       i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
                                       if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                                        i64toi32_i32$1 = 0;
                                        $435 = i64toi32_i32$5 >>> i64toi32_i32$4 | 0;
                                       } else {
                                        i64toi32_i32$1 = i64toi32_i32$5 >>> i64toi32_i32$4 | 0;
                                        $435 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
                                       }
                                       HEAP8[($3109 + 207 | 0) >> 0] = $435;
                                       $3112 = $2;
                                       i64toi32_i32$1 = $31$hi;
                                       i64toi32_i32$5 = $31;
                                       i64toi32_i32$0 = 0;
                                       i64toi32_i32$2 = 32;
                                       i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
                                       if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                                        i64toi32_i32$0 = 0;
                                        $436 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
                                       } else {
                                        i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
                                        $436 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$4 | 0) | 0;
                                       }
                                       $437 = $3112;
                                       $438 = $436;
                                       HEAP8[($437 + 205 | 0) >> 0] = $438;
                                       HEAP8[($437 + 206 | 0) >> 0] = $438 >>> 8 | 0;
                                       cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($14 | 0, $2 + 200 | 0 | 0, 1052254 | 0, 21 | 0);
                                       i64toi32_i32$1 = $2;
                                       i64toi32_i32$0 = HEAP32[($2 + 72 | 0) >> 2] | 0;
                                       i64toi32_i32$5 = HEAP32[($2 + 76 | 0) >> 2] | 0;
                                       $47 = i64toi32_i32$0;
                                       $47$hi = i64toi32_i32$5;
                                       i64toi32_i32$1 = i64toi32_i32$0;
                                       i64toi32_i32$0 = -1;
                                       i64toi32_i32$2 = -256;
                                       i64toi32_i32$0 = i64toi32_i32$5 & i64toi32_i32$0 | 0;
                                       $46 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
                                       $46$hi = i64toi32_i32$0;
                                       i64toi32_i32$5 = ($2 + 64 | 0) + 16 | 0;
                                       i64toi32_i32$0 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                       i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                       $48 = i64toi32_i32$0;
                                       $48$hi = i64toi32_i32$1;
                                       i64toi32_i32$5 = ($2 + 64 | 0) + 24 | 0;
                                       i64toi32_i32$1 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                       i64toi32_i32$0 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                       $51 = i64toi32_i32$1;
                                       $51$hi = i64toi32_i32$0;
                                       i64toi32_i32$5 = ($2 + 64 | 0) + 32 | 0;
                                       i64toi32_i32$0 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                       i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                       $32 = i64toi32_i32$0;
                                       $32$hi = i64toi32_i32$1;
                                       i64toi32_i32$5 = ($2 + 64 | 0) + 40 | 0;
                                       i64toi32_i32$1 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                       i64toi32_i32$0 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                       $50 = i64toi32_i32$1;
                                       $50$hi = i64toi32_i32$0;
                                       i64toi32_i32$5 = $2 + 112 | 0;
                                       i64toi32_i32$0 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                       i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                       $49 = i64toi32_i32$0;
                                       $49$hi = i64toi32_i32$1;
                                       $19 = HEAP32[($2 + 120 | 0) >> 2] | 0;
                                       $15 = HEAP32[(($2 + 64 | 0) + 60 | 0) >> 2] | 0;
                                       i64toi32_i32$5 = $2 + 128 | 0;
                                       i64toi32_i32$1 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                       i64toi32_i32$0 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                       $53 = i64toi32_i32$1;
                                       $53$hi = i64toi32_i32$0;
                                       break label$4;
                                      }
                                      label$134 : {
                                       label$135 : {
                                        i64toi32_i32$0 = $31$hi;
                                        i64toi32_i32$5 = $31;
                                        i64toi32_i32$1 = 0;
                                        i64toi32_i32$2 = 1;
                                        if ((i64toi32_i32$5 | 0) != (i64toi32_i32$2 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | 0) {
                                         break label$135
                                        }
                                        i64toi32_i32$5 = $32$hi;
                                        i64toi32_i32$2 = $32;
                                        i64toi32_i32$0 = 0;
                                        i64toi32_i32$1 = 1;
                                        i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
                                        i64toi32_i32$3 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
                                        if (i64toi32_i32$4 >>> 0 < i64toi32_i32$1 >>> 0) {
                                         i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
                                        }
                                        $32 = i64toi32_i32$4;
                                        $32$hi = i64toi32_i32$3;
                                        i64toi32_i32$3 = $30$hi;
                                        i64toi32_i32$3 = $32$hi;
                                        i64toi32_i32$5 = i64toi32_i32$4;
                                        i64toi32_i32$2 = $30$hi;
                                        i64toi32_i32$1 = $30;
                                        if (i64toi32_i32$3 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$5 >>> 0 <= i64toi32_i32$1 >>> 0 | 0) | 0) {
                                         break label$135
                                        }
                                        $1 = 0;
                                        i64toi32_i32$5 = 0;
                                        $52 = 0;
                                        $52$hi = i64toi32_i32$5;
                                        $15 = 3;
                                        break label$134;
                                       }
                                       $T_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hf422f9333a8bbafa($2 + 200 | 0 | 0, $1 | 0);
                                       $11 = 1;
                                       if ((HEAP32[($2 + 200 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                                        break label$23
                                       }
                                       i64toi32_i32$1 = $2 + 248 | 0;
                                       i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                       i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                       $31 = i64toi32_i32$5;
                                       $31$hi = i64toi32_i32$3;
                                       i64toi32_i32$5 = ($2 + 184 | 0) + 8 | 0;
                                       HEAP32[i64toi32_i32$5 >> 2] = $31;
                                       HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$3;
                                       $20 = HEAP32[($2 + 268 | 0) >> 2] | 0;
                                       HEAP32[(($2 + 168 | 0) + 8 | 0) >> 2] = $20;
                                       i64toi32_i32$5 = ($2 + 152 | 0) + 8 | 0;
                                       HEAP32[i64toi32_i32$5 >> 2] = $31;
                                       HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$3;
                                       i64toi32_i32$1 = $2 + 240 | 0;
                                       i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                       i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                       $31 = i64toi32_i32$3;
                                       $31$hi = i64toi32_i32$5;
                                       i64toi32_i32$3 = $2;
                                       HEAP32[($2 + 184 | 0) >> 2] = $31;
                                       HEAP32[($2 + 188 | 0) >> 2] = i64toi32_i32$5;
                                       i64toi32_i32$1 = $2 + 260 | 0;
                                       i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                       i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                       $32 = i64toi32_i32$5;
                                       $32$hi = i64toi32_i32$3;
                                       i64toi32_i32$5 = $2;
                                       HEAP32[($2 + 168 | 0) >> 2] = $32;
                                       HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$3;
                                       i64toi32_i32$3 = $31$hi;
                                       i64toi32_i32$5 = $2;
                                       HEAP32[($2 + 152 | 0) >> 2] = $31;
                                       HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$3;
                                       i64toi32_i32$1 = $2 + 232 | 0;
                                       i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                       i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                       $47 = i64toi32_i32$3;
                                       $47$hi = i64toi32_i32$5;
                                       i64toi32_i32$1 = $2 + 224 | 0;
                                       i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                       i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                       $52 = i64toi32_i32$5;
                                       $52$hi = i64toi32_i32$3;
                                       i64toi32_i32$1 = $2 + 216 | 0;
                                       i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                       i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                       $30 = i64toi32_i32$3;
                                       $30$hi = i64toi32_i32$5;
                                       $15 = HEAPU8[(($2 + 200 | 0) + 8 | 0) >> 0] | 0;
                                       $1 = HEAP32[($2 + 256 | 0) >> 2] | 0;
                                       i64toi32_i32$1 = $2 + 209 | 0;
                                       i64toi32_i32$5 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                       i64toi32_i32$3 = 0;
                                       $31 = i64toi32_i32$5;
                                       $31$hi = i64toi32_i32$3;
                                       i64toi32_i32$1 = $2 + 213 | 0;
                                       i64toi32_i32$3 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
                                       i64toi32_i32$5 = 0;
                                       $48 = i64toi32_i32$3;
                                       $48$hi = i64toi32_i32$5;
                                       i64toi32_i32$1 = $2 + 215 | 0;
                                       i64toi32_i32$5 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
                                       i64toi32_i32$3 = 0;
                                       $51 = i64toi32_i32$5;
                                       $51$hi = i64toi32_i32$3;
                                       HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] = $20;
                                       i64toi32_i32$3 = $32$hi;
                                       i64toi32_i32$5 = $2;
                                       HEAP32[($2 + 136 | 0) >> 2] = $32;
                                       HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$3;
                                       i64toi32_i32$3 = $31$hi;
                                       $3225 = $31;
                                       $3225$hi = i64toi32_i32$3;
                                       i64toi32_i32$3 = $48$hi;
                                       $3226 = $48;
                                       $3226$hi = i64toi32_i32$3;
                                       i64toi32_i32$3 = $51$hi;
                                       i64toi32_i32$1 = $51;
                                       i64toi32_i32$5 = 0;
                                       i64toi32_i32$2 = 16;
                                       i64toi32_i32$0 = i64toi32_i32$2 & 31 | 0;
                                       if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                                        i64toi32_i32$5 = i64toi32_i32$1 << i64toi32_i32$0 | 0;
                                        $439 = 0;
                                       } else {
                                        i64toi32_i32$5 = ((1 << i64toi32_i32$0 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$0 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$0 | 0) | 0;
                                        $439 = i64toi32_i32$1 << i64toi32_i32$0 | 0;
                                       }
                                       $3228$hi = i64toi32_i32$5;
                                       i64toi32_i32$5 = $3226$hi;
                                       i64toi32_i32$3 = $3226;
                                       i64toi32_i32$1 = $3228$hi;
                                       i64toi32_i32$2 = $439;
                                       i64toi32_i32$1 = i64toi32_i32$5 | i64toi32_i32$1 | 0;
                                       i64toi32_i32$5 = i64toi32_i32$3 | i64toi32_i32$2 | 0;
                                       i64toi32_i32$3 = 0;
                                       i64toi32_i32$2 = 32;
                                       i64toi32_i32$0 = i64toi32_i32$2 & 31 | 0;
                                       if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                                        i64toi32_i32$3 = i64toi32_i32$5 << i64toi32_i32$0 | 0;
                                        $441 = 0;
                                       } else {
                                        i64toi32_i32$3 = ((1 << i64toi32_i32$0 | 0) - 1 | 0) & (i64toi32_i32$5 >>> (32 - i64toi32_i32$0 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$0 | 0) | 0;
                                        $441 = i64toi32_i32$5 << i64toi32_i32$0 | 0;
                                       }
                                       $3230$hi = i64toi32_i32$3;
                                       i64toi32_i32$3 = $3225$hi;
                                       i64toi32_i32$1 = $3225;
                                       i64toi32_i32$5 = $3230$hi;
                                       i64toi32_i32$2 = $441;
                                       i64toi32_i32$5 = i64toi32_i32$3 | i64toi32_i32$5 | 0;
                                       $31 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
                                       $31$hi = i64toi32_i32$5;
                                      }
                                      i64toi32_i32$5 = $47$hi;
                                      i64toi32_i32$1 = ($2 + 200 | 0) + 24 | 0;
                                      HEAP32[i64toi32_i32$1 >> 2] = $47;
                                      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$5;
                                      i64toi32_i32$5 = $52$hi;
                                      i64toi32_i32$1 = ($2 + 200 | 0) + 16 | 0;
                                      HEAP32[i64toi32_i32$1 >> 2] = $52;
                                      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$5;
                                      i64toi32_i32$5 = $30$hi;
                                      i64toi32_i32$1 = ($2 + 200 | 0) + 8 | 0;
                                      HEAP32[i64toi32_i32$1 >> 2] = $30;
                                      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$5;
                                      i64toi32_i32$3 = $2;
                                      i64toi32_i32$5 = HEAP32[($2 + 152 | 0) >> 2] | 0;
                                      i64toi32_i32$1 = HEAP32[($2 + 156 | 0) >> 2] | 0;
                                      $3248 = i64toi32_i32$5;
                                      i64toi32_i32$5 = ($2 + 200 | 0) + 32 | 0;
                                      HEAP32[i64toi32_i32$5 >> 2] = $3248;
                                      HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$1;
                                      i64toi32_i32$3 = $2;
                                      i64toi32_i32$1 = HEAP32[($2 + 136 | 0) >> 2] | 0;
                                      i64toi32_i32$5 = HEAP32[($2 + 140 | 0) >> 2] | 0;
                                      $3252 = i64toi32_i32$1;
                                      i64toi32_i32$1 = $2 + 252 | 0;
                                      HEAP32[i64toi32_i32$1 >> 2] = $3252;
                                      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$5;
                                      i64toi32_i32$3 = ($2 + 152 | 0) + 8 | 0;
                                      i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                      i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                      $3259 = i64toi32_i32$5;
                                      i64toi32_i32$5 = ($2 + 200 | 0) + 40 | 0;
                                      HEAP32[i64toi32_i32$5 >> 2] = $3259;
                                      HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$1;
                                      HEAP32[(($2 + 200 | 0) + 60 | 0) >> 2] = HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] | 0;
                                      HEAP8[($2 + 200 | 0) >> 0] = $15;
                                      HEAP32[($2 + 248 | 0) >> 2] = $1;
                                      i64toi32_i32$1 = $31$hi;
                                      HEAP8[($2 + 201 | 0) >> 0] = $31;
                                      HEAP8[($2 + 202 | 0) >> 0] = $31 >>> 8 | 0;
                                      HEAP8[($2 + 203 | 0) >> 0] = $31 >>> 16 | 0;
                                      HEAP8[($2 + 204 | 0) >> 0] = $31 >>> 24 | 0;
                                      $3273 = $2;
                                      i64toi32_i32$3 = $31;
                                      i64toi32_i32$5 = 0;
                                      i64toi32_i32$2 = 48;
                                      i64toi32_i32$0 = i64toi32_i32$2 & 31 | 0;
                                      if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                                       i64toi32_i32$5 = 0;
                                       $442 = i64toi32_i32$1 >>> i64toi32_i32$0 | 0;
                                      } else {
                                       i64toi32_i32$5 = i64toi32_i32$1 >>> i64toi32_i32$0 | 0;
                                       $442 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$0 | 0) | 0;
                                      }
                                      HEAP8[($3273 + 207 | 0) >> 0] = $442;
                                      $3276 = $2;
                                      i64toi32_i32$5 = $31$hi;
                                      i64toi32_i32$1 = $31;
                                      i64toi32_i32$3 = 0;
                                      i64toi32_i32$2 = 32;
                                      i64toi32_i32$0 = i64toi32_i32$2 & 31 | 0;
                                      if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                                       i64toi32_i32$3 = 0;
                                       $444 = i64toi32_i32$5 >>> i64toi32_i32$0 | 0;
                                      } else {
                                       i64toi32_i32$3 = i64toi32_i32$5 >>> i64toi32_i32$0 | 0;
                                       $444 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$0 | 0) | 0;
                                      }
                                      $445 = $3276;
                                      $446 = $444;
                                      HEAP8[($445 + 205 | 0) >> 0] = $446;
                                      HEAP8[($445 + 206 | 0) >> 0] = $446 >>> 8 | 0;
                                      cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($14 | 0, $2 + 200 | 0 | 0, 1052243 | 0, 11 | 0);
                                      i64toi32_i32$5 = $2;
                                      i64toi32_i32$3 = HEAP32[($2 + 72 | 0) >> 2] | 0;
                                      i64toi32_i32$1 = HEAP32[($2 + 76 | 0) >> 2] | 0;
                                      $47 = i64toi32_i32$3;
                                      $47$hi = i64toi32_i32$1;
                                      i64toi32_i32$5 = i64toi32_i32$3;
                                      i64toi32_i32$3 = -1;
                                      i64toi32_i32$2 = -256;
                                      i64toi32_i32$3 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
                                      $46 = i64toi32_i32$5 & i64toi32_i32$2 | 0;
                                      $46$hi = i64toi32_i32$3;
                                      i64toi32_i32$1 = ($2 + 64 | 0) + 16 | 0;
                                      i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                      i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                      $48 = i64toi32_i32$3;
                                      $48$hi = i64toi32_i32$5;
                                      i64toi32_i32$1 = ($2 + 64 | 0) + 24 | 0;
                                      i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                      i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                      $51 = i64toi32_i32$5;
                                      $51$hi = i64toi32_i32$3;
                                      i64toi32_i32$1 = ($2 + 64 | 0) + 32 | 0;
                                      i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                      i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                      $32 = i64toi32_i32$3;
                                      $32$hi = i64toi32_i32$5;
                                      i64toi32_i32$1 = ($2 + 64 | 0) + 40 | 0;
                                      i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                      i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                      $50 = i64toi32_i32$5;
                                      $50$hi = i64toi32_i32$3;
                                      i64toi32_i32$1 = $2 + 112 | 0;
                                      i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                      i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                      $49 = i64toi32_i32$3;
                                      $49$hi = i64toi32_i32$5;
                                      $19 = HEAP32[($2 + 120 | 0) >> 2] | 0;
                                      $15 = HEAP32[(($2 + 64 | 0) + 60 | 0) >> 2] | 0;
                                      i64toi32_i32$1 = $2 + 128 | 0;
                                      i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                      i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                      $53 = i64toi32_i32$5;
                                      $53$hi = i64toi32_i32$3;
                                      break label$4;
                                     }
                                     label$136 : {
                                      label$137 : {
                                       i64toi32_i32$3 = $31$hi;
                                       i64toi32_i32$1 = $31;
                                       i64toi32_i32$5 = 0;
                                       i64toi32_i32$2 = 1;
                                       if ((i64toi32_i32$1 | 0) != (i64toi32_i32$2 | 0) | (i64toi32_i32$3 | 0) != (i64toi32_i32$5 | 0) | 0) {
                                        break label$137
                                       }
                                       i64toi32_i32$1 = $32$hi;
                                       i64toi32_i32$2 = $32;
                                       i64toi32_i32$3 = 0;
                                       i64toi32_i32$5 = 1;
                                       i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
                                       i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
                                       if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
                                        i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
                                       }
                                       $32 = i64toi32_i32$0;
                                       $32$hi = i64toi32_i32$4;
                                       i64toi32_i32$4 = $30$hi;
                                       i64toi32_i32$4 = $32$hi;
                                       i64toi32_i32$1 = i64toi32_i32$0;
                                       i64toi32_i32$2 = $30$hi;
                                       i64toi32_i32$5 = $30;
                                       if (i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$0 >>> 0 <= i64toi32_i32$5 >>> 0 | 0) | 0) {
                                        break label$137
                                       }
                                       $1 = 0;
                                       i64toi32_i32$1 = 0;
                                       $52 = 0;
                                       $52$hi = i64toi32_i32$1;
                                       $15 = 3;
                                       break label$136;
                                      }
                                      $T_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hf422f9333a8bbafa($2 + 200 | 0 | 0, $1 | 0);
                                      $12 = 1;
                                      if ((HEAP32[($2 + 200 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                                       break label$22
                                      }
                                      i64toi32_i32$5 = $2 + 248 | 0;
                                      i64toi32_i32$1 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                      i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                      $31 = i64toi32_i32$1;
                                      $31$hi = i64toi32_i32$4;
                                      i64toi32_i32$1 = ($2 + 184 | 0) + 8 | 0;
                                      HEAP32[i64toi32_i32$1 >> 2] = $31;
                                      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$4;
                                      $20 = HEAP32[($2 + 268 | 0) >> 2] | 0;
                                      HEAP32[(($2 + 168 | 0) + 8 | 0) >> 2] = $20;
                                      i64toi32_i32$1 = ($2 + 152 | 0) + 8 | 0;
                                      HEAP32[i64toi32_i32$1 >> 2] = $31;
                                      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$4;
                                      i64toi32_i32$5 = $2 + 240 | 0;
                                      i64toi32_i32$4 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                      i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                      $31 = i64toi32_i32$4;
                                      $31$hi = i64toi32_i32$1;
                                      i64toi32_i32$4 = $2;
                                      HEAP32[($2 + 184 | 0) >> 2] = $31;
                                      HEAP32[($2 + 188 | 0) >> 2] = i64toi32_i32$1;
                                      i64toi32_i32$5 = $2 + 260 | 0;
                                      i64toi32_i32$1 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                      i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                      $32 = i64toi32_i32$1;
                                      $32$hi = i64toi32_i32$4;
                                      i64toi32_i32$1 = $2;
                                      HEAP32[($2 + 168 | 0) >> 2] = $32;
                                      HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$4;
                                      i64toi32_i32$4 = $31$hi;
                                      i64toi32_i32$1 = $2;
                                      HEAP32[($2 + 152 | 0) >> 2] = $31;
                                      HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$4;
                                      i64toi32_i32$5 = $2 + 232 | 0;
                                      i64toi32_i32$4 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                      i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                      $47 = i64toi32_i32$4;
                                      $47$hi = i64toi32_i32$1;
                                      i64toi32_i32$5 = $2 + 224 | 0;
                                      i64toi32_i32$1 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                      i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                      $52 = i64toi32_i32$1;
                                      $52$hi = i64toi32_i32$4;
                                      i64toi32_i32$5 = $2 + 216 | 0;
                                      i64toi32_i32$4 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                      i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                      $30 = i64toi32_i32$4;
                                      $30$hi = i64toi32_i32$1;
                                      $15 = HEAPU8[(($2 + 200 | 0) + 8 | 0) >> 0] | 0;
                                      $1 = HEAP32[($2 + 256 | 0) >> 2] | 0;
                                      i64toi32_i32$5 = $2 + 209 | 0;
                                      i64toi32_i32$1 = HEAPU8[i64toi32_i32$5 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$5 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$5 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$5 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                      i64toi32_i32$4 = 0;
                                      $31 = i64toi32_i32$1;
                                      $31$hi = i64toi32_i32$4;
                                      i64toi32_i32$5 = $2 + 213 | 0;
                                      i64toi32_i32$4 = HEAPU8[i64toi32_i32$5 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$5 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
                                      i64toi32_i32$1 = 0;
                                      $48 = i64toi32_i32$4;
                                      $48$hi = i64toi32_i32$1;
                                      i64toi32_i32$5 = $2 + 215 | 0;
                                      i64toi32_i32$1 = HEAPU8[i64toi32_i32$5 >> 0] | 0;
                                      i64toi32_i32$4 = 0;
                                      $51 = i64toi32_i32$1;
                                      $51$hi = i64toi32_i32$4;
                                      HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] = $20;
                                      i64toi32_i32$4 = $32$hi;
                                      i64toi32_i32$1 = $2;
                                      HEAP32[($2 + 136 | 0) >> 2] = $32;
                                      HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$4;
                                      i64toi32_i32$4 = $31$hi;
                                      $3389 = $31;
                                      $3389$hi = i64toi32_i32$4;
                                      i64toi32_i32$4 = $48$hi;
                                      $3390 = $48;
                                      $3390$hi = i64toi32_i32$4;
                                      i64toi32_i32$4 = $51$hi;
                                      i64toi32_i32$5 = $51;
                                      i64toi32_i32$1 = 0;
                                      i64toi32_i32$2 = 16;
                                      i64toi32_i32$3 = i64toi32_i32$2 & 31 | 0;
                                      if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                                       i64toi32_i32$1 = i64toi32_i32$5 << i64toi32_i32$3 | 0;
                                       $447 = 0;
                                      } else {
                                       i64toi32_i32$1 = ((1 << i64toi32_i32$3 | 0) - 1 | 0) & (i64toi32_i32$5 >>> (32 - i64toi32_i32$3 | 0) | 0) | 0 | (i64toi32_i32$4 << i64toi32_i32$3 | 0) | 0;
                                       $447 = i64toi32_i32$5 << i64toi32_i32$3 | 0;
                                      }
                                      $3392$hi = i64toi32_i32$1;
                                      i64toi32_i32$1 = $3390$hi;
                                      i64toi32_i32$4 = $3390;
                                      i64toi32_i32$5 = $3392$hi;
                                      i64toi32_i32$2 = $447;
                                      i64toi32_i32$5 = i64toi32_i32$1 | i64toi32_i32$5 | 0;
                                      i64toi32_i32$1 = i64toi32_i32$4 | i64toi32_i32$2 | 0;
                                      i64toi32_i32$4 = 0;
                                      i64toi32_i32$2 = 32;
                                      i64toi32_i32$3 = i64toi32_i32$2 & 31 | 0;
                                      if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                                       i64toi32_i32$4 = i64toi32_i32$1 << i64toi32_i32$3 | 0;
                                       $448 = 0;
                                      } else {
                                       i64toi32_i32$4 = ((1 << i64toi32_i32$3 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$3 | 0) | 0) | 0 | (i64toi32_i32$5 << i64toi32_i32$3 | 0) | 0;
                                       $448 = i64toi32_i32$1 << i64toi32_i32$3 | 0;
                                      }
                                      $3394$hi = i64toi32_i32$4;
                                      i64toi32_i32$4 = $3389$hi;
                                      i64toi32_i32$5 = $3389;
                                      i64toi32_i32$1 = $3394$hi;
                                      i64toi32_i32$2 = $448;
                                      i64toi32_i32$1 = i64toi32_i32$4 | i64toi32_i32$1 | 0;
                                      $31 = i64toi32_i32$5 | i64toi32_i32$2 | 0;
                                      $31$hi = i64toi32_i32$1;
                                     }
                                     i64toi32_i32$1 = $47$hi;
                                     i64toi32_i32$5 = ($2 + 200 | 0) + 24 | 0;
                                     HEAP32[i64toi32_i32$5 >> 2] = $47;
                                     HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$1;
                                     i64toi32_i32$1 = $52$hi;
                                     i64toi32_i32$5 = ($2 + 200 | 0) + 16 | 0;
                                     HEAP32[i64toi32_i32$5 >> 2] = $52;
                                     HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$1;
                                     i64toi32_i32$1 = $30$hi;
                                     i64toi32_i32$5 = ($2 + 200 | 0) + 8 | 0;
                                     HEAP32[i64toi32_i32$5 >> 2] = $30;
                                     HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$1;
                                     i64toi32_i32$4 = $2;
                                     i64toi32_i32$1 = HEAP32[($2 + 152 | 0) >> 2] | 0;
                                     i64toi32_i32$5 = HEAP32[($2 + 156 | 0) >> 2] | 0;
                                     $3412 = i64toi32_i32$1;
                                     i64toi32_i32$1 = ($2 + 200 | 0) + 32 | 0;
                                     HEAP32[i64toi32_i32$1 >> 2] = $3412;
                                     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$5;
                                     i64toi32_i32$4 = $2;
                                     i64toi32_i32$5 = HEAP32[($2 + 136 | 0) >> 2] | 0;
                                     i64toi32_i32$1 = HEAP32[($2 + 140 | 0) >> 2] | 0;
                                     $3416 = i64toi32_i32$5;
                                     i64toi32_i32$5 = $2 + 252 | 0;
                                     HEAP32[i64toi32_i32$5 >> 2] = $3416;
                                     HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$1;
                                     i64toi32_i32$4 = ($2 + 152 | 0) + 8 | 0;
                                     i64toi32_i32$1 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                     i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                     $3423 = i64toi32_i32$1;
                                     i64toi32_i32$1 = ($2 + 200 | 0) + 40 | 0;
                                     HEAP32[i64toi32_i32$1 >> 2] = $3423;
                                     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$5;
                                     HEAP32[(($2 + 200 | 0) + 60 | 0) >> 2] = HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] | 0;
                                     HEAP8[($2 + 200 | 0) >> 0] = $15;
                                     HEAP32[($2 + 248 | 0) >> 2] = $1;
                                     i64toi32_i32$5 = $31$hi;
                                     HEAP8[($2 + 201 | 0) >> 0] = $31;
                                     HEAP8[($2 + 202 | 0) >> 0] = $31 >>> 8 | 0;
                                     HEAP8[($2 + 203 | 0) >> 0] = $31 >>> 16 | 0;
                                     HEAP8[($2 + 204 | 0) >> 0] = $31 >>> 24 | 0;
                                     $3437 = $2;
                                     i64toi32_i32$4 = $31;
                                     i64toi32_i32$1 = 0;
                                     i64toi32_i32$2 = 48;
                                     i64toi32_i32$3 = i64toi32_i32$2 & 31 | 0;
                                     if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                                      i64toi32_i32$1 = 0;
                                      $449 = i64toi32_i32$5 >>> i64toi32_i32$3 | 0;
                                     } else {
                                      i64toi32_i32$1 = i64toi32_i32$5 >>> i64toi32_i32$3 | 0;
                                      $449 = (((1 << i64toi32_i32$3 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$3 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$3 | 0) | 0;
                                     }
                                     HEAP8[($3437 + 207 | 0) >> 0] = $449;
                                     $3440 = $2;
                                     i64toi32_i32$1 = $31$hi;
                                     i64toi32_i32$5 = $31;
                                     i64toi32_i32$4 = 0;
                                     i64toi32_i32$2 = 32;
                                     i64toi32_i32$3 = i64toi32_i32$2 & 31 | 0;
                                     if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                                      i64toi32_i32$4 = 0;
                                      $450 = i64toi32_i32$1 >>> i64toi32_i32$3 | 0;
                                     } else {
                                      i64toi32_i32$4 = i64toi32_i32$1 >>> i64toi32_i32$3 | 0;
                                      $450 = (((1 << i64toi32_i32$3 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$3 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$3 | 0) | 0;
                                     }
                                     $451 = $3440;
                                     $452 = $450;
                                     HEAP8[($451 + 205 | 0) >> 0] = $452;
                                     HEAP8[($451 + 206 | 0) >> 0] = $452 >>> 8 | 0;
                                     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($14 | 0, $2 + 200 | 0 | 0, 1052224 | 0, 19 | 0);
                                     i64toi32_i32$1 = $2;
                                     i64toi32_i32$4 = HEAP32[($2 + 72 | 0) >> 2] | 0;
                                     i64toi32_i32$5 = HEAP32[($2 + 76 | 0) >> 2] | 0;
                                     $47 = i64toi32_i32$4;
                                     $47$hi = i64toi32_i32$5;
                                     i64toi32_i32$1 = i64toi32_i32$4;
                                     i64toi32_i32$4 = -1;
                                     i64toi32_i32$2 = -256;
                                     i64toi32_i32$4 = i64toi32_i32$5 & i64toi32_i32$4 | 0;
                                     $46 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
                                     $46$hi = i64toi32_i32$4;
                                     i64toi32_i32$5 = ($2 + 64 | 0) + 16 | 0;
                                     i64toi32_i32$4 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                     i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                     $48 = i64toi32_i32$4;
                                     $48$hi = i64toi32_i32$1;
                                     i64toi32_i32$5 = ($2 + 64 | 0) + 24 | 0;
                                     i64toi32_i32$1 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                     i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                     $51 = i64toi32_i32$1;
                                     $51$hi = i64toi32_i32$4;
                                     i64toi32_i32$5 = ($2 + 64 | 0) + 32 | 0;
                                     i64toi32_i32$4 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                     i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                     $32 = i64toi32_i32$4;
                                     $32$hi = i64toi32_i32$1;
                                     i64toi32_i32$5 = ($2 + 64 | 0) + 40 | 0;
                                     i64toi32_i32$1 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                     i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                     $50 = i64toi32_i32$1;
                                     $50$hi = i64toi32_i32$4;
                                     i64toi32_i32$5 = $2 + 112 | 0;
                                     i64toi32_i32$4 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                     i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                     $49 = i64toi32_i32$4;
                                     $49$hi = i64toi32_i32$1;
                                     $19 = HEAP32[($2 + 120 | 0) >> 2] | 0;
                                     $15 = HEAP32[(($2 + 64 | 0) + 60 | 0) >> 2] | 0;
                                     i64toi32_i32$5 = $2 + 128 | 0;
                                     i64toi32_i32$1 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                     i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                     $53 = i64toi32_i32$1;
                                     $53$hi = i64toi32_i32$4;
                                     break label$4;
                                    }
                                    label$138 : {
                                     label$139 : {
                                      i64toi32_i32$4 = $31$hi;
                                      i64toi32_i32$5 = $31;
                                      i64toi32_i32$1 = 0;
                                      i64toi32_i32$2 = 1;
                                      if ((i64toi32_i32$5 | 0) != (i64toi32_i32$2 | 0) | (i64toi32_i32$4 | 0) != (i64toi32_i32$1 | 0) | 0) {
                                       break label$139
                                      }
                                      i64toi32_i32$5 = $32$hi;
                                      i64toi32_i32$2 = $32;
                                      i64toi32_i32$4 = 0;
                                      i64toi32_i32$1 = 1;
                                      i64toi32_i32$3 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
                                      i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
                                      if (i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0) {
                                       i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
                                      }
                                      $32 = i64toi32_i32$3;
                                      $32$hi = i64toi32_i32$0;
                                      i64toi32_i32$0 = $30$hi;
                                      i64toi32_i32$0 = $32$hi;
                                      i64toi32_i32$5 = i64toi32_i32$3;
                                      i64toi32_i32$2 = $30$hi;
                                      i64toi32_i32$1 = $30;
                                      if (i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$3 >>> 0 <= i64toi32_i32$1 >>> 0 | 0) | 0) {
                                       break label$139
                                      }
                                      $1 = 0;
                                      i64toi32_i32$5 = 0;
                                      $31 = 0;
                                      $31$hi = i64toi32_i32$5;
                                      i64toi32_i32$5 = 0;
                                      $52 = 3;
                                      $52$hi = i64toi32_i32$5;
                                      break label$138;
                                     }
                                     $cardano_serialization_lib__utils__BigNum_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h29637bb571dceb02($2 + 200 | 0 | 0, $1 | 0);
                                     i64toi32_i32$1 = $2;
                                     i64toi32_i32$5 = HEAP32[($2 + 200 | 0) >> 2] | 0;
                                     i64toi32_i32$0 = HEAP32[($2 + 204 | 0) >> 2] | 0;
                                     i64toi32_i32$1 = i64toi32_i32$5;
                                     i64toi32_i32$5 = 0;
                                     i64toi32_i32$2 = 1;
                                     if ((i64toi32_i32$1 | 0) != (i64toi32_i32$2 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$5 | 0) | 0) {
                                      break label$21
                                     }
                                     $1 = HEAP32[($2 + 268 | 0) >> 2] | 0;
                                     HEAP32[(($2 + 168 | 0) + 8 | 0) >> 2] = $1;
                                     i64toi32_i32$2 = $2 + 248 | 0;
                                     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                     $3504 = i64toi32_i32$1;
                                     i64toi32_i32$1 = ($2 + 152 | 0) + 8 | 0;
                                     HEAP32[i64toi32_i32$1 >> 2] = $3504;
                                     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                                     HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] = $1;
                                     i64toi32_i32$2 = $2;
                                     i64toi32_i32$0 = HEAP32[($2 + 260 | 0) >> 2] | 0;
                                     i64toi32_i32$1 = HEAP32[($2 + 264 | 0) >> 2] | 0;
                                     $31 = i64toi32_i32$0;
                                     $31$hi = i64toi32_i32$1;
                                     i64toi32_i32$0 = $2;
                                     HEAP32[($2 + 168 | 0) >> 2] = $31;
                                     HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$1;
                                     i64toi32_i32$0 = $2;
                                     HEAP32[($2 + 136 | 0) >> 2] = $31;
                                     HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$1;
                                     i64toi32_i32$2 = $2 + 240 | 0;
                                     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                     $3518 = i64toi32_i32$1;
                                     i64toi32_i32$1 = $2;
                                     HEAP32[($2 + 152 | 0) >> 2] = $3518;
                                     HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
                                     i64toi32_i32$2 = $2 + 232 | 0;
                                     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                     $47 = i64toi32_i32$0;
                                     $47$hi = i64toi32_i32$1;
                                     i64toi32_i32$2 = $2 + 224 | 0;
                                     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                     $31 = i64toi32_i32$1;
                                     $31$hi = i64toi32_i32$0;
                                     i64toi32_i32$2 = $2 + 216 | 0;
                                     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                     $30 = i64toi32_i32$0;
                                     $30$hi = i64toi32_i32$1;
                                     $1 = HEAP32[($2 + 256 | 0) >> 2] | 0;
                                     i64toi32_i32$2 = $2;
                                     i64toi32_i32$1 = HEAP32[($2 + 208 | 0) >> 2] | 0;
                                     i64toi32_i32$0 = HEAP32[($2 + 212 | 0) >> 2] | 0;
                                     $52 = i64toi32_i32$1;
                                     $52$hi = i64toi32_i32$0;
                                    }
                                    i64toi32_i32$0 = $47$hi;
                                    i64toi32_i32$1 = ($2 + 200 | 0) + 24 | 0;
                                    HEAP32[i64toi32_i32$1 >> 2] = $47;
                                    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                                    i64toi32_i32$0 = $31$hi;
                                    i64toi32_i32$1 = ($2 + 200 | 0) + 16 | 0;
                                    HEAP32[i64toi32_i32$1 >> 2] = $31;
                                    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                                    i64toi32_i32$0 = $30$hi;
                                    i64toi32_i32$1 = ($2 + 200 | 0) + 8 | 0;
                                    HEAP32[i64toi32_i32$1 >> 2] = $30;
                                    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                                    i64toi32_i32$2 = $2;
                                    i64toi32_i32$0 = HEAP32[($2 + 152 | 0) >> 2] | 0;
                                    i64toi32_i32$1 = HEAP32[($2 + 156 | 0) >> 2] | 0;
                                    $3549 = i64toi32_i32$0;
                                    i64toi32_i32$0 = ($2 + 200 | 0) + 32 | 0;
                                    HEAP32[i64toi32_i32$0 >> 2] = $3549;
                                    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
                                    i64toi32_i32$2 = $2;
                                    i64toi32_i32$1 = HEAP32[($2 + 136 | 0) >> 2] | 0;
                                    i64toi32_i32$0 = HEAP32[($2 + 140 | 0) >> 2] | 0;
                                    $3553 = i64toi32_i32$1;
                                    i64toi32_i32$1 = $2 + 252 | 0;
                                    HEAP32[i64toi32_i32$1 >> 2] = $3553;
                                    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                                    i64toi32_i32$2 = ($2 + 152 | 0) + 8 | 0;
                                    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                    $3560 = i64toi32_i32$0;
                                    i64toi32_i32$0 = ($2 + 200 | 0) + 40 | 0;
                                    HEAP32[i64toi32_i32$0 >> 2] = $3560;
                                    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
                                    HEAP32[(($2 + 200 | 0) + 60 | 0) >> 2] = HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] | 0;
                                    i64toi32_i32$1 = $52$hi;
                                    i64toi32_i32$0 = $2;
                                    HEAP32[($2 + 200 | 0) >> 2] = $52;
                                    HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$1;
                                    HEAP32[($2 + 248 | 0) >> 2] = $1;
                                    cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($14 | 0, $2 + 200 | 0 | 0, 1052216 | 0, 8 | 0);
                                    i64toi32_i32$2 = $2;
                                    i64toi32_i32$1 = HEAP32[($2 + 72 | 0) >> 2] | 0;
                                    i64toi32_i32$0 = HEAP32[($2 + 76 | 0) >> 2] | 0;
                                    $47 = i64toi32_i32$1;
                                    $47$hi = i64toi32_i32$0;
                                    i64toi32_i32$2 = i64toi32_i32$1;
                                    i64toi32_i32$1 = -1;
                                    i64toi32_i32$5 = -256;
                                    i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
                                    $46 = i64toi32_i32$2 & i64toi32_i32$5 | 0;
                                    $46$hi = i64toi32_i32$1;
                                    i64toi32_i32$0 = ($2 + 64 | 0) + 16 | 0;
                                    i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                    i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                    $48 = i64toi32_i32$1;
                                    $48$hi = i64toi32_i32$2;
                                    i64toi32_i32$0 = ($2 + 64 | 0) + 24 | 0;
                                    i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                    i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                    $51 = i64toi32_i32$2;
                                    $51$hi = i64toi32_i32$1;
                                    i64toi32_i32$0 = ($2 + 64 | 0) + 32 | 0;
                                    i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                    i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                    $32 = i64toi32_i32$1;
                                    $32$hi = i64toi32_i32$2;
                                    i64toi32_i32$0 = ($2 + 64 | 0) + 40 | 0;
                                    i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                    i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                    $50 = i64toi32_i32$2;
                                    $50$hi = i64toi32_i32$1;
                                    i64toi32_i32$0 = $2 + 112 | 0;
                                    i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                    i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                    $49 = i64toi32_i32$1;
                                    $49$hi = i64toi32_i32$2;
                                    $19 = HEAP32[($2 + 120 | 0) >> 2] | 0;
                                    $15 = HEAP32[(($2 + 64 | 0) + 60 | 0) >> 2] | 0;
                                    i64toi32_i32$0 = $2 + 128 | 0;
                                    i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                    i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                    $53 = i64toi32_i32$2;
                                    $53$hi = i64toi32_i32$1;
                                    break label$4;
                                   }
                                   label$140 : {
                                    label$141 : {
                                     i64toi32_i32$1 = $31$hi;
                                     i64toi32_i32$0 = $31;
                                     i64toi32_i32$2 = 0;
                                     i64toi32_i32$5 = 1;
                                     if ((i64toi32_i32$0 | 0) != (i64toi32_i32$5 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$2 | 0) | 0) {
                                      break label$141
                                     }
                                     i64toi32_i32$0 = $32$hi;
                                     i64toi32_i32$5 = $32;
                                     i64toi32_i32$1 = 0;
                                     i64toi32_i32$2 = 1;
                                     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
                                     i64toi32_i32$3 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
                                     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0) {
                                      i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
                                     }
                                     $32 = i64toi32_i32$4;
                                     $32$hi = i64toi32_i32$3;
                                     i64toi32_i32$3 = $30$hi;
                                     i64toi32_i32$3 = $32$hi;
                                     i64toi32_i32$0 = i64toi32_i32$4;
                                     i64toi32_i32$5 = $30$hi;
                                     i64toi32_i32$2 = $30;
                                     if (i64toi32_i32$3 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$0 >>> 0 <= i64toi32_i32$2 >>> 0 | 0) | 0) {
                                      break label$141
                                     }
                                     $1 = 0;
                                     i64toi32_i32$0 = 0;
                                     $31 = 0;
                                     $31$hi = i64toi32_i32$0;
                                     i64toi32_i32$0 = 0;
                                     $52 = 3;
                                     $52$hi = i64toi32_i32$0;
                                     break label$140;
                                    }
                                    $cardano_serialization_lib__utils__BigNum_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h29637bb571dceb02($2 + 200 | 0 | 0, $1 | 0);
                                    i64toi32_i32$2 = $2;
                                    i64toi32_i32$0 = HEAP32[($2 + 200 | 0) >> 2] | 0;
                                    i64toi32_i32$3 = HEAP32[($2 + 204 | 0) >> 2] | 0;
                                    i64toi32_i32$2 = i64toi32_i32$0;
                                    i64toi32_i32$0 = 0;
                                    i64toi32_i32$5 = 1;
                                    if ((i64toi32_i32$2 | 0) != (i64toi32_i32$5 | 0) | (i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | 0) {
                                     break label$20
                                    }
                                    $1 = HEAP32[($2 + 268 | 0) >> 2] | 0;
                                    HEAP32[(($2 + 168 | 0) + 8 | 0) >> 2] = $1;
                                    i64toi32_i32$5 = $2 + 248 | 0;
                                    i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                    i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                    $3633 = i64toi32_i32$2;
                                    i64toi32_i32$2 = ($2 + 152 | 0) + 8 | 0;
                                    HEAP32[i64toi32_i32$2 >> 2] = $3633;
                                    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                                    HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] = $1;
                                    i64toi32_i32$5 = $2;
                                    i64toi32_i32$3 = HEAP32[($2 + 260 | 0) >> 2] | 0;
                                    i64toi32_i32$2 = HEAP32[($2 + 264 | 0) >> 2] | 0;
                                    $31 = i64toi32_i32$3;
                                    $31$hi = i64toi32_i32$2;
                                    i64toi32_i32$3 = $2;
                                    HEAP32[($2 + 168 | 0) >> 2] = $31;
                                    HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$2;
                                    i64toi32_i32$3 = $2;
                                    HEAP32[($2 + 136 | 0) >> 2] = $31;
                                    HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$2;
                                    i64toi32_i32$5 = $2 + 240 | 0;
                                    i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                    i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                    $3647 = i64toi32_i32$2;
                                    i64toi32_i32$2 = $2;
                                    HEAP32[($2 + 152 | 0) >> 2] = $3647;
                                    HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$3;
                                    i64toi32_i32$5 = $2 + 232 | 0;
                                    i64toi32_i32$3 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                    i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                    $47 = i64toi32_i32$3;
                                    $47$hi = i64toi32_i32$2;
                                    i64toi32_i32$5 = $2 + 224 | 0;
                                    i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                    i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                    $31 = i64toi32_i32$2;
                                    $31$hi = i64toi32_i32$3;
                                    i64toi32_i32$5 = $2 + 216 | 0;
                                    i64toi32_i32$3 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                    i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                    $30 = i64toi32_i32$3;
                                    $30$hi = i64toi32_i32$2;
                                    $1 = HEAP32[($2 + 256 | 0) >> 2] | 0;
                                    i64toi32_i32$5 = $2;
                                    i64toi32_i32$2 = HEAP32[($2 + 208 | 0) >> 2] | 0;
                                    i64toi32_i32$3 = HEAP32[($2 + 212 | 0) >> 2] | 0;
                                    $52 = i64toi32_i32$2;
                                    $52$hi = i64toi32_i32$3;
                                   }
                                   i64toi32_i32$3 = $47$hi;
                                   i64toi32_i32$2 = ($2 + 200 | 0) + 24 | 0;
                                   HEAP32[i64toi32_i32$2 >> 2] = $47;
                                   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                                   i64toi32_i32$3 = $31$hi;
                                   i64toi32_i32$2 = ($2 + 200 | 0) + 16 | 0;
                                   HEAP32[i64toi32_i32$2 >> 2] = $31;
                                   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                                   i64toi32_i32$3 = $30$hi;
                                   i64toi32_i32$2 = ($2 + 200 | 0) + 8 | 0;
                                   HEAP32[i64toi32_i32$2 >> 2] = $30;
                                   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                                   i64toi32_i32$5 = $2;
                                   i64toi32_i32$3 = HEAP32[($2 + 152 | 0) >> 2] | 0;
                                   i64toi32_i32$2 = HEAP32[($2 + 156 | 0) >> 2] | 0;
                                   $3678 = i64toi32_i32$3;
                                   i64toi32_i32$3 = ($2 + 200 | 0) + 32 | 0;
                                   HEAP32[i64toi32_i32$3 >> 2] = $3678;
                                   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                                   i64toi32_i32$5 = $2;
                                   i64toi32_i32$2 = HEAP32[($2 + 136 | 0) >> 2] | 0;
                                   i64toi32_i32$3 = HEAP32[($2 + 140 | 0) >> 2] | 0;
                                   $3682 = i64toi32_i32$2;
                                   i64toi32_i32$2 = $2 + 252 | 0;
                                   HEAP32[i64toi32_i32$2 >> 2] = $3682;
                                   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                                   i64toi32_i32$5 = ($2 + 152 | 0) + 8 | 0;
                                   i64toi32_i32$3 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                   i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                   $3689 = i64toi32_i32$3;
                                   i64toi32_i32$3 = ($2 + 200 | 0) + 40 | 0;
                                   HEAP32[i64toi32_i32$3 >> 2] = $3689;
                                   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                                   HEAP32[(($2 + 200 | 0) + 60 | 0) >> 2] = HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] | 0;
                                   i64toi32_i32$2 = $52$hi;
                                   i64toi32_i32$3 = $2;
                                   HEAP32[($2 + 200 | 0) >> 2] = $52;
                                   HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$2;
                                   HEAP32[($2 + 248 | 0) >> 2] = $1;
                                   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($14 | 0, $2 + 200 | 0 | 0, 1052208 | 0, 8 | 0);
                                   i64toi32_i32$5 = $2;
                                   i64toi32_i32$2 = HEAP32[($2 + 72 | 0) >> 2] | 0;
                                   i64toi32_i32$3 = HEAP32[($2 + 76 | 0) >> 2] | 0;
                                   $47 = i64toi32_i32$2;
                                   $47$hi = i64toi32_i32$3;
                                   i64toi32_i32$5 = i64toi32_i32$2;
                                   i64toi32_i32$2 = -1;
                                   i64toi32_i32$0 = -256;
                                   i64toi32_i32$2 = i64toi32_i32$3 & i64toi32_i32$2 | 0;
                                   $46 = i64toi32_i32$5 & i64toi32_i32$0 | 0;
                                   $46$hi = i64toi32_i32$2;
                                   i64toi32_i32$3 = ($2 + 64 | 0) + 16 | 0;
                                   i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                   i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                   $48 = i64toi32_i32$2;
                                   $48$hi = i64toi32_i32$5;
                                   i64toi32_i32$3 = ($2 + 64 | 0) + 24 | 0;
                                   i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                   i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                   $51 = i64toi32_i32$5;
                                   $51$hi = i64toi32_i32$2;
                                   i64toi32_i32$3 = ($2 + 64 | 0) + 32 | 0;
                                   i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                   i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                   $32 = i64toi32_i32$2;
                                   $32$hi = i64toi32_i32$5;
                                   i64toi32_i32$3 = ($2 + 64 | 0) + 40 | 0;
                                   i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                   i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                   $50 = i64toi32_i32$5;
                                   $50$hi = i64toi32_i32$2;
                                   i64toi32_i32$3 = $2 + 112 | 0;
                                   i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                   i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                   $49 = i64toi32_i32$2;
                                   $49$hi = i64toi32_i32$5;
                                   $19 = HEAP32[($2 + 120 | 0) >> 2] | 0;
                                   $15 = HEAP32[(($2 + 64 | 0) + 60 | 0) >> 2] | 0;
                                   i64toi32_i32$3 = $2 + 128 | 0;
                                   i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                   i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                   $53 = i64toi32_i32$5;
                                   $53$hi = i64toi32_i32$2;
                                   break label$4;
                                  }
                                  $22 = HEAP32[($2 + 204 | 0) >> 2] | 0;
                                  break label$19;
                                 }
                                 $23 = HEAP32[($2 + 204 | 0) >> 2] | 0;
                                 break label$19;
                                }
                                i64toi32_i32$3 = $2;
                                i64toi32_i32$2 = HEAP32[($2 + 216 | 0) >> 2] | 0;
                                i64toi32_i32$5 = HEAP32[($2 + 220 | 0) >> 2] | 0;
                                $57 = i64toi32_i32$2;
                                $57$hi = i64toi32_i32$5;
                                i64toi32_i32$3 = $2;
                                i64toi32_i32$5 = HEAP32[($2 + 208 | 0) >> 2] | 0;
                                i64toi32_i32$2 = HEAP32[($2 + 212 | 0) >> 2] | 0;
                                $58 = i64toi32_i32$5;
                                $58$hi = i64toi32_i32$2;
                                i64toi32_i32$2 = 0;
                                $33 = 1;
                                $33$hi = i64toi32_i32$2;
                                break label$19;
                               }
                               i64toi32_i32$3 = $2;
                               i64toi32_i32$2 = HEAP32[($2 + 216 | 0) >> 2] | 0;
                               i64toi32_i32$5 = HEAP32[($2 + 220 | 0) >> 2] | 0;
                               $59 = i64toi32_i32$2;
                               $59$hi = i64toi32_i32$5;
                               i64toi32_i32$3 = $2;
                               i64toi32_i32$5 = HEAP32[($2 + 208 | 0) >> 2] | 0;
                               i64toi32_i32$2 = HEAP32[($2 + 212 | 0) >> 2] | 0;
                               $60 = i64toi32_i32$5;
                               $60$hi = i64toi32_i32$2;
                               i64toi32_i32$2 = 0;
                               $34 = 1;
                               $34$hi = i64toi32_i32$2;
                               break label$19;
                              }
                              i64toi32_i32$2 = $52$hi;
                              HEAP8[($2 + 73 | 0) >> 0] = $52;
                              HEAP8[($2 + 74 | 0) >> 0] = $52 >>> 8 | 0;
                              HEAP8[($2 + 75 | 0) >> 0] = $52 >>> 16 | 0;
                              HEAP8[($2 + 76 | 0) >> 0] = $52 >>> 24 | 0;
                              $3753 = ($2 + 64 | 0) + 15 | 0;
                              i64toi32_i32$3 = $52;
                              i64toi32_i32$5 = 0;
                              i64toi32_i32$0 = 48;
                              i64toi32_i32$1 = i64toi32_i32$0 & 31 | 0;
                              if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
                               i64toi32_i32$5 = 0;
                               $453 = i64toi32_i32$2 >>> i64toi32_i32$1 | 0;
                              } else {
                               i64toi32_i32$5 = i64toi32_i32$2 >>> i64toi32_i32$1 | 0;
                               $453 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$1 | 0) | 0;
                              }
                              HEAP8[$3753 >> 0] = $453;
                              $3758 = ($2 + 64 | 0) + 13 | 0;
                              i64toi32_i32$5 = $52$hi;
                              i64toi32_i32$2 = $52;
                              i64toi32_i32$3 = 0;
                              i64toi32_i32$0 = 32;
                              i64toi32_i32$1 = i64toi32_i32$0 & 31 | 0;
                              if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
                               i64toi32_i32$3 = 0;
                               $454 = i64toi32_i32$5 >>> i64toi32_i32$1 | 0;
                              } else {
                               i64toi32_i32$3 = i64toi32_i32$5 >>> i64toi32_i32$1 | 0;
                               $454 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$1 | 0) | 0;
                              }
                              $455 = $3758;
                              $456 = $454;
                              HEAP8[$455 >> 0] = $456;
                              HEAP8[($455 + 1 | 0) >> 0] = $456 >>> 8 | 0;
                              HEAP8[($2 + 72 | 0) >> 0] = $15;
                              i64toi32_i32$5 = $2;
                              i64toi32_i32$3 = HEAP32[($2 + 72 | 0) >> 2] | 0;
                              i64toi32_i32$2 = HEAP32[($2 + 76 | 0) >> 2] | 0;
                              $61 = i64toi32_i32$3;
                              $61$hi = i64toi32_i32$2;
                              i64toi32_i32$2 = 0;
                              $35 = 1;
                              $35$hi = i64toi32_i32$2;
                              break label$19;
                             }
                             i64toi32_i32$5 = ($2 + 200 | 0) + 15 | 0;
                             i64toi32_i32$2 = HEAPU8[i64toi32_i32$5 >> 0] | 0;
                             i64toi32_i32$3 = 0;
                             HEAP8[(($2 + 64 | 0) + 15 | 0) >> 0] = i64toi32_i32$2;
                             i64toi32_i32$5 = ($2 + 200 | 0) + 13 | 0;
                             i64toi32_i32$3 = HEAPU8[i64toi32_i32$5 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$5 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
                             i64toi32_i32$2 = 0;
                             $457 = ($2 + 64 | 0) + 13 | 0;
                             HEAP8[$457 >> 0] = i64toi32_i32$3;
                             HEAP8[($457 + 1 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
                             i64toi32_i32$5 = $2;
                             i64toi32_i32$2 = HEAPU8[($2 + 209 | 0) >> 0] | 0 | ((HEAPU8[($2 + 210 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 211 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 212 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                             i64toi32_i32$3 = 0;
                             HEAP8[($2 + 73 | 0) >> 0] = i64toi32_i32$2;
                             HEAP8[($2 + 74 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
                             HEAP8[($2 + 75 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
                             HEAP8[($2 + 76 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
                             HEAP8[($2 + 72 | 0) >> 0] = HEAPU8[($2 + 208 | 0) >> 0] | 0;
                             HEAP32[($2 + 52 | 0) >> 2] = HEAP32[($2 + 204 | 0) >> 2] | 0;
                             HEAP32[($2 + 48 | 0) >> 2] = 1;
                             i64toi32_i32$5 = $2;
                             i64toi32_i32$3 = HEAP32[($2 + 72 | 0) >> 2] | 0;
                             i64toi32_i32$2 = HEAP32[($2 + 76 | 0) >> 2] | 0;
                             $3791 = i64toi32_i32$3;
                             i64toi32_i32$3 = $2;
                             HEAP32[($2 + 56 | 0) >> 2] = $3791;
                             HEAP32[($2 + 60 | 0) >> 2] = i64toi32_i32$2;
                             break label$19;
                            }
                            i64toi32_i32$5 = $2;
                            i64toi32_i32$2 = HEAP32[($2 + 208 | 0) >> 2] | 0;
                            i64toi32_i32$3 = HEAP32[($2 + 212 | 0) >> 2] | 0;
                            $62 = i64toi32_i32$2;
                            $62$hi = i64toi32_i32$3;
                            i64toi32_i32$3 = 0;
                            $36 = 1;
                            $36$hi = i64toi32_i32$3;
                            break label$19;
                           }
                           i64toi32_i32$5 = $2;
                           i64toi32_i32$3 = HEAP32[($2 + 208 | 0) >> 2] | 0;
                           i64toi32_i32$2 = HEAP32[($2 + 212 | 0) >> 2] | 0;
                           $63 = i64toi32_i32$3;
                           $63$hi = i64toi32_i32$2;
                           i64toi32_i32$2 = 0;
                           $37 = 1;
                           $37$hi = i64toi32_i32$2;
                           break label$19;
                          }
                          i64toi32_i32$5 = ($2 + 200 | 0) + 15 | 0;
                          i64toi32_i32$2 = HEAPU8[i64toi32_i32$5 >> 0] | 0;
                          i64toi32_i32$3 = 0;
                          HEAP8[(($2 + 64 | 0) + 15 | 0) >> 0] = i64toi32_i32$2;
                          i64toi32_i32$5 = ($2 + 200 | 0) + 13 | 0;
                          i64toi32_i32$3 = HEAPU8[i64toi32_i32$5 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$5 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
                          i64toi32_i32$2 = 0;
                          $458 = ($2 + 64 | 0) + 13 | 0;
                          HEAP8[$458 >> 0] = i64toi32_i32$3;
                          HEAP8[($458 + 1 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
                          i64toi32_i32$5 = $2;
                          i64toi32_i32$2 = HEAPU8[($2 + 209 | 0) >> 0] | 0 | ((HEAPU8[($2 + 210 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 211 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 212 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                          i64toi32_i32$3 = 0;
                          HEAP8[($2 + 73 | 0) >> 0] = i64toi32_i32$2;
                          HEAP8[($2 + 74 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
                          HEAP8[($2 + 75 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
                          HEAP8[($2 + 76 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
                          HEAP8[($2 + 72 | 0) >> 0] = HEAPU8[($2 + 208 | 0) >> 0] | 0;
                          HEAP32[($2 + 32 | 0) >> 2] = HEAP32[($2 + 204 | 0) >> 2] | 0;
                          i64toi32_i32$5 = $2;
                          i64toi32_i32$3 = HEAP32[($2 + 72 | 0) >> 2] | 0;
                          i64toi32_i32$2 = HEAP32[($2 + 76 | 0) >> 2] | 0;
                          $3821 = i64toi32_i32$3;
                          i64toi32_i32$3 = $2;
                          HEAP32[($2 + 36 | 0) >> 2] = $3821;
                          HEAP32[($2 + 40 | 0) >> 2] = i64toi32_i32$2;
                          break label$19;
                         }
                         $357 = $17;
                         $356 = $16;
                         $358 = HEAPU8[$357 >> 0] | 0 | ((HEAPU8[($357 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($357 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($357 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                         HEAP8[$356 >> 0] = $358;
                         HEAP8[($356 + 1 | 0) >> 0] = $358 >>> 8 | 0;
                         HEAP8[($356 + 2 | 0) >> 0] = $358 >>> 16 | 0;
                         HEAP8[($356 + 3 | 0) >> 0] = $358 >>> 24 | 0;
                         $15 = $356 + 3 | 0;
                         $359 = $357 + 3 | 0;
                         $360 = HEAPU8[$359 >> 0] | 0 | ((HEAPU8[($359 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($359 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($359 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                         HEAP8[$15 >> 0] = $360;
                         HEAP8[($15 + 1 | 0) >> 0] = $360 >>> 8 | 0;
                         HEAP8[($15 + 2 | 0) >> 0] = $360 >>> 16 | 0;
                         HEAP8[($15 + 3 | 0) >> 0] = $360 >>> 24 | 0;
                         i64toi32_i32$5 = ($2 + 200 | 0) + 15 | 0;
                         i64toi32_i32$2 = HEAPU8[i64toi32_i32$5 >> 0] | 0;
                         i64toi32_i32$3 = 0;
                         HEAP8[(($2 + 64 | 0) + 15 | 0) >> 0] = i64toi32_i32$2;
                         i64toi32_i32$5 = ($2 + 200 | 0) + 13 | 0;
                         i64toi32_i32$3 = HEAPU8[i64toi32_i32$5 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$5 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
                         i64toi32_i32$2 = 0;
                         $459 = ($2 + 64 | 0) + 13 | 0;
                         HEAP8[$459 >> 0] = i64toi32_i32$3;
                         HEAP8[($459 + 1 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
                         i64toi32_i32$5 = $2;
                         i64toi32_i32$2 = HEAP32[($2 + 216 | 0) >> 2] | 0;
                         i64toi32_i32$3 = HEAP32[($2 + 220 | 0) >> 2] | 0;
                         $64 = i64toi32_i32$2;
                         $64$hi = i64toi32_i32$3;
                         i64toi32_i32$5 = $2;
                         i64toi32_i32$3 = HEAP32[($2 + 224 | 0) >> 2] | 0;
                         i64toi32_i32$2 = HEAP32[($2 + 228 | 0) >> 2] | 0;
                         $65 = i64toi32_i32$3;
                         $65$hi = i64toi32_i32$2;
                         $24 = HEAPU16[($2 + 232 | 0) >> 1] | 0;
                         $5 = HEAPU8[($2 + 208 | 0) >> 0] | 0;
                         i64toi32_i32$5 = $2;
                         i64toi32_i32$2 = HEAPU8[($2 + 209 | 0) >> 0] | 0 | ((HEAPU8[($2 + 210 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 211 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 212 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                         i64toi32_i32$3 = 0;
                         $52 = i64toi32_i32$2;
                         $52$hi = i64toi32_i32$3;
                         $361 = $18 + 3 | 0;
                         $362 = HEAPU8[$15 >> 0] | 0 | ((HEAPU8[($15 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($15 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($15 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                         HEAP8[$361 >> 0] = $362;
                         HEAP8[($361 + 1 | 0) >> 0] = $362 >>> 8 | 0;
                         HEAP8[($361 + 2 | 0) >> 0] = $362 >>> 16 | 0;
                         HEAP8[($361 + 3 | 0) >> 0] = $362 >>> 24 | 0;
                         $363 = $18;
                         $364 = HEAPU8[$356 >> 0] | 0 | ((HEAPU8[($356 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($356 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($356 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                         HEAP8[$363 >> 0] = $364;
                         HEAP8[($363 + 1 | 0) >> 0] = $364 >>> 8 | 0;
                         HEAP8[($363 + 2 | 0) >> 0] = $364 >>> 16 | 0;
                         HEAP8[($363 + 3 | 0) >> 0] = $364 >>> 24 | 0;
                         HEAP8[($2 + 73 | 0) >> 0] = i64toi32_i32$2;
                         HEAP8[($2 + 74 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
                         HEAP8[($2 + 75 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
                         HEAP8[($2 + 76 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
                         HEAP8[($2 + 72 | 0) >> 0] = $5;
                         $5 = HEAPU8[($2 + 65 | 0) >> 0] | 0;
                         $460 = $13 + 4 | 0;
                         HEAP16[(($2 + 24 | 0) + 4 | 0) >> 1] = HEAPU8[$460 >> 0] | 0 | ((HEAPU8[($460 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
                         $365 = $13;
                         HEAP32[($2 + 24 | 0) >> 2] = HEAPU8[$365 >> 0] | 0 | ((HEAPU8[($365 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($365 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($365 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                         i64toi32_i32$5 = $2;
                         i64toi32_i32$3 = HEAP32[($2 + 72 | 0) >> 2] | 0;
                         i64toi32_i32$2 = HEAP32[($2 + 76 | 0) >> 2] | 0;
                         $66 = i64toi32_i32$3;
                         $66$hi = i64toi32_i32$2;
                         break label$19;
                        }
                        i64toi32_i32$5 = $2;
                        i64toi32_i32$2 = HEAP32[($2 + 216 | 0) >> 2] | 0;
                        i64toi32_i32$3 = HEAP32[($2 + 220 | 0) >> 2] | 0;
                        $67 = i64toi32_i32$2;
                        $67$hi = i64toi32_i32$3;
                        i64toi32_i32$5 = $2;
                        i64toi32_i32$3 = HEAP32[($2 + 208 | 0) >> 2] | 0;
                        i64toi32_i32$2 = HEAP32[($2 + 212 | 0) >> 2] | 0;
                        $68 = i64toi32_i32$3;
                        $68$hi = i64toi32_i32$2;
                        i64toi32_i32$2 = 0;
                        $38 = 1;
                        $38$hi = i64toi32_i32$2;
                        break label$19;
                       }
                       i64toi32_i32$5 = $2;
                       i64toi32_i32$2 = HEAP32[($2 + 216 | 0) >> 2] | 0;
                       i64toi32_i32$3 = HEAP32[($2 + 220 | 0) >> 2] | 0;
                       $69 = i64toi32_i32$2;
                       $69$hi = i64toi32_i32$3;
                       i64toi32_i32$5 = $2;
                       i64toi32_i32$3 = HEAP32[($2 + 208 | 0) >> 2] | 0;
                       i64toi32_i32$2 = HEAP32[($2 + 212 | 0) >> 2] | 0;
                       $70 = i64toi32_i32$3;
                       $70$hi = i64toi32_i32$2;
                       i64toi32_i32$2 = 0;
                       $39 = 1;
                       $39$hi = i64toi32_i32$2;
                       break label$19;
                      }
                      i64toi32_i32$5 = $2;
                      i64toi32_i32$2 = HEAP32[($2 + 216 | 0) >> 2] | 0;
                      i64toi32_i32$3 = HEAP32[($2 + 220 | 0) >> 2] | 0;
                      $71 = i64toi32_i32$2;
                      $71$hi = i64toi32_i32$3;
                      i64toi32_i32$5 = $2;
                      i64toi32_i32$3 = HEAP32[($2 + 208 | 0) >> 2] | 0;
                      i64toi32_i32$2 = HEAP32[($2 + 212 | 0) >> 2] | 0;
                      $72 = i64toi32_i32$3;
                      $72$hi = i64toi32_i32$2;
                      i64toi32_i32$2 = 0;
                      $40 = 1;
                      $40$hi = i64toi32_i32$2;
                      break label$19;
                     }
                     i64toi32_i32$5 = $2;
                     i64toi32_i32$2 = HEAP32[($2 + 216 | 0) >> 2] | 0;
                     i64toi32_i32$3 = HEAP32[($2 + 220 | 0) >> 2] | 0;
                     $73 = i64toi32_i32$2;
                     $73$hi = i64toi32_i32$3;
                     i64toi32_i32$5 = $2;
                     i64toi32_i32$3 = HEAP32[($2 + 208 | 0) >> 2] | 0;
                     i64toi32_i32$2 = HEAP32[($2 + 212 | 0) >> 2] | 0;
                     $74 = i64toi32_i32$3;
                     $74$hi = i64toi32_i32$2;
                     i64toi32_i32$2 = 0;
                     $41 = 1;
                     $41$hi = i64toi32_i32$2;
                     break label$19;
                    }
                    $25 = HEAP32[($2 + 204 | 0) >> 2] | 0;
                    break label$19;
                   }
                   $26 = HEAP32[($2 + 204 | 0) >> 2] | 0;
                   break label$19;
                  }
                  i64toi32_i32$5 = $2;
                  i64toi32_i32$2 = HEAP32[($2 + 208 | 0) >> 2] | 0;
                  i64toi32_i32$3 = HEAP32[($2 + 212 | 0) >> 2] | 0;
                  $75 = i64toi32_i32$2;
                  $75$hi = i64toi32_i32$3;
                  i64toi32_i32$3 = 0;
                  $42 = 1;
                  $42$hi = i64toi32_i32$3;
                  break label$19;
                 }
                 i64toi32_i32$5 = $2;
                 i64toi32_i32$3 = HEAP32[($2 + 208 | 0) >> 2] | 0;
                 i64toi32_i32$2 = HEAP32[($2 + 212 | 0) >> 2] | 0;
                 $76 = i64toi32_i32$3;
                 $76$hi = i64toi32_i32$2;
                 i64toi32_i32$2 = 0;
                 $43 = 1;
                 $43$hi = i64toi32_i32$2;
                 break label$19;
                }
                $27 = HEAP32[($2 + 204 | 0) >> 2] | 0;
                break label$19;
               }
               $28 = HEAP32[($2 + 204 | 0) >> 2] | 0;
               break label$19;
              }
              $29 = HEAP32[($2 + 204 | 0) >> 2] | 0;
              break label$19;
             }
             i64toi32_i32$5 = $2;
             i64toi32_i32$2 = HEAP32[($2 + 208 | 0) >> 2] | 0;
             i64toi32_i32$3 = HEAP32[($2 + 212 | 0) >> 2] | 0;
             $77 = i64toi32_i32$2;
             $77$hi = i64toi32_i32$3;
             i64toi32_i32$3 = 0;
             $44 = 1;
             $44$hi = i64toi32_i32$3;
             break label$19;
            }
            i64toi32_i32$5 = $2;
            i64toi32_i32$3 = HEAP32[($2 + 208 | 0) >> 2] | 0;
            i64toi32_i32$2 = HEAP32[($2 + 212 | 0) >> 2] | 0;
            $78 = i64toi32_i32$3;
            $78$hi = i64toi32_i32$2;
            i64toi32_i32$2 = 0;
            $45 = 1;
            $45$hi = i64toi32_i32$2;
           }
           $15 = $20 + 1 | 0;
           i64toi32_i32$2 = $31$hi;
           i64toi32_i32$5 = $31;
           i64toi32_i32$3 = 0;
           i64toi32_i32$0 = 1;
           if ((i64toi32_i32$5 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | 0) {
            continue label$10
           }
           if ($20 >>> 0 >= $4 >>> 0) {
            break label$5
           }
           continue label$10;
          };
         }
         i64toi32_i32$0 = $2 + 240 | 0;
         i64toi32_i32$5 = HEAP32[i64toi32_i32$0 >> 2] | 0;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
         $49 = i64toi32_i32$5;
         $49$hi = i64toi32_i32$2;
         i64toi32_i32$0 = $2 + 232 | 0;
         i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
         i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
         $50 = i64toi32_i32$2;
         $50$hi = i64toi32_i32$5;
         i64toi32_i32$0 = $2 + 224 | 0;
         i64toi32_i32$5 = HEAP32[i64toi32_i32$0 >> 2] | 0;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
         $32 = i64toi32_i32$5;
         $32$hi = i64toi32_i32$2;
         $19 = 0;
         i64toi32_i32$2 = 0;
         $47 = 2;
         $47$hi = i64toi32_i32$2;
         i64toi32_i32$2 = 0;
         $46 = 0;
         $46$hi = i64toi32_i32$2;
         i64toi32_i32$2 = $30$hi;
         $51 = $30;
         $51$hi = i64toi32_i32$2;
         i64toi32_i32$2 = $31$hi;
         $48 = $31;
         $48$hi = i64toi32_i32$2;
         break label$2;
        }
        i64toi32_i32$2 = 0;
        $47 = 4;
        $47$hi = i64toi32_i32$2;
        break label$4;
       }
       i64toi32_i32$2 = 0;
       $51 = 0;
       $51$hi = i64toi32_i32$2;
       break label$4;
      }
      i64toi32_i32$2 = $32$hi;
      i64toi32_i32$2 = $30$hi;
      i64toi32_i32$2 = $32$hi;
      i64toi32_i32$0 = $32;
      i64toi32_i32$5 = $30$hi;
      i64toi32_i32$3 = $30;
      if ((i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$5 | 0) | 0) {
       break label$3
      }
      i64toi32_i32$0 = 0;
      $51 = 1;
      $51$hi = i64toi32_i32$0;
      $19 = 0;
      i64toi32_i32$0 = 0;
      $47 = 3;
      $47$hi = i64toi32_i32$0;
      i64toi32_i32$0 = 0;
      $46 = 0;
      $46$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $30$hi;
      $48 = $30;
      $48$hi = i64toi32_i32$0;
     }
     label$142 : {
      if (!(HEAP32[($2 + 48 | 0) >> 2] | 0)) {
       break label$142
      }
      $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h5f5dc70d320637e0($2 + 48 | 0 | 4 | 0 | 0);
     }
     if (!(HEAP32[($2 + 32 | 0) >> 2] | 0)) {
      break label$2
     }
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h1737752c75bae0f3($2 + 32 | 0 | 0);
     break label$2;
    }
    i64toi32_i32$3 = $2;
    i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($2 + 36 | 0) >> 2] | 0;
    $3949 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 328 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $3949;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    HEAP32[($0 + 336 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
    $1 = ($2 + 200 | 0) + 8 | 0;
    i64toi32_i32$3 = ($2 + 48 | 0) + 8 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $3963 = i64toi32_i32$2;
    i64toi32_i32$2 = $1;
    HEAP32[i64toi32_i32$2 >> 2] = $3963;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
    $15 = ($2 + 64 | 0) + 4 | 0;
    HEAP16[$15 >> 1] = HEAPU16[(($2 + 24 | 0) + 4 | 0) >> 1] | 0;
    i64toi32_i32$3 = $2;
    i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($2 + 52 | 0) >> 2] | 0;
    $3974 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[($2 + 200 | 0) >> 2] = $3974;
    HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$2;
    HEAP32[($2 + 64 | 0) >> 2] = HEAP32[($2 + 24 | 0) >> 2] | 0;
    HEAP32[($0 + 324 | 0) >> 2] = $25;
    HEAP32[($0 + 320 | 0) >> 2] = $8;
    HEAP32[($0 + 316 | 0) >> 2] = $26;
    HEAP32[($0 + 312 | 0) >> 2] = $9;
    HEAP32[($0 + 308 | 0) >> 2] = $27;
    HEAP32[($0 + 304 | 0) >> 2] = $10;
    HEAP32[($0 + 300 | 0) >> 2] = $28;
    HEAP32[($0 + 296 | 0) >> 2] = $11;
    HEAP32[($0 + 292 | 0) >> 2] = $29;
    HEAP32[($0 + 288 | 0) >> 2] = $12;
    i64toi32_i32$2 = $57$hi;
    i64toi32_i32$0 = $0 + 280 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $57;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $58$hi;
    i64toi32_i32$0 = $0 + 272 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $58;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $33$hi;
    i64toi32_i32$0 = $0 + 264 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $33;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $59$hi;
    i64toi32_i32$0 = $0 + 256 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $59;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $60$hi;
    i64toi32_i32$0 = $0 + 248 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $60;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $34$hi;
    i64toi32_i32$0 = $0 + 240 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $34;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $55$hi;
    i64toi32_i32$0 = $0 + 232 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $55;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $54$hi;
    i64toi32_i32$0 = $0 + 224 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $54;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $56$hi;
    i64toi32_i32$0 = $0 + 216 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $56;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $61$hi;
    i64toi32_i32$0 = $0 + 208 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $61;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $35$hi;
    i64toi32_i32$0 = $0 + 200 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $35;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $62$hi;
    i64toi32_i32$0 = $0 + 192 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $62;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $36$hi;
    i64toi32_i32$0 = $0 + 184 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $36;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $63$hi;
    i64toi32_i32$0 = $0 + 176 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $63;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $37$hi;
    i64toi32_i32$0 = $0 + 168 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $37;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $67$hi;
    i64toi32_i32$0 = $0 + 160 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $67;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $68$hi;
    i64toi32_i32$0 = $0 + 152 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $68;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $38$hi;
    i64toi32_i32$0 = $0 + 144 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $38;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $69$hi;
    i64toi32_i32$0 = $0 + 136 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $69;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $70$hi;
    i64toi32_i32$0 = $0 + 128 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $70;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $39$hi;
    i64toi32_i32$0 = $0 + 120 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $39;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $71$hi;
    i64toi32_i32$0 = $0 + 112 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $71;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $72$hi;
    i64toi32_i32$0 = $0 + 104 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $72;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $40$hi;
    i64toi32_i32$0 = $0 + 96 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $40;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $73$hi;
    i64toi32_i32$0 = $0 + 88 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $73;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $74$hi;
    i64toi32_i32$0 = $0 + 80 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $74;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $41$hi;
    i64toi32_i32$0 = $0 + 72 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $41;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $75$hi;
    i64toi32_i32$0 = $0 + 64 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $75;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    HEAP32[($0 + 60 | 0) >> 2] = 0;
    i64toi32_i32$2 = $42$hi;
    HEAP32[($0 + 56 | 0) >> 2] = $42;
    i64toi32_i32$2 = $76$hi;
    i64toi32_i32$0 = $0 + 48 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $76;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $43$hi;
    i64toi32_i32$0 = $0 + 40 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $43;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $77$hi;
    i64toi32_i32$0 = $0 + 32 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $77;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $44$hi;
    i64toi32_i32$0 = $0 + 24 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $44;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $78$hi;
    i64toi32_i32$0 = $0 + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $78;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $45$hi;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $45;
    HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
    HEAP8[(i64toi32_i32$0 + 380 | 0) >> 0] = $5;
    HEAP32[(i64toi32_i32$0 + 376 | 0) >> 2] = $21;
    HEAP32[(i64toi32_i32$0 + 372 | 0) >> 2] = $3;
    HEAP32[(i64toi32_i32$0 + 368 | 0) >> 2] = $22;
    HEAP32[(i64toi32_i32$0 + 364 | 0) >> 2] = $6;
    HEAP32[(i64toi32_i32$0 + 360 | 0) >> 2] = $23;
    HEAP32[(i64toi32_i32$0 + 356 | 0) >> 2] = $7;
    $461 = $24;
    HEAP8[(i64toi32_i32$0 + 411 | 0) >> 0] = $461;
    HEAP8[(i64toi32_i32$0 + 412 | 0) >> 0] = $461 >>> 8 | 0;
    i64toi32_i32$2 = $65$hi;
    $366 = $65;
    HEAP8[(i64toi32_i32$0 + 403 | 0) >> 0] = $366;
    HEAP8[(i64toi32_i32$0 + 404 | 0) >> 0] = $366 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 405 | 0) >> 0] = $366 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 406 | 0) >> 0] = $366 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 407 | 0) >> 0] = i64toi32_i32$2;
    HEAP8[(i64toi32_i32$0 + 408 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 409 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 410 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
    i64toi32_i32$2 = $64$hi;
    $367 = $64;
    HEAP8[(i64toi32_i32$0 + 395 | 0) >> 0] = $367;
    HEAP8[(i64toi32_i32$0 + 396 | 0) >> 0] = $367 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 397 | 0) >> 0] = $367 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 398 | 0) >> 0] = $367 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 399 | 0) >> 0] = i64toi32_i32$2;
    HEAP8[(i64toi32_i32$0 + 400 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 401 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 402 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
    i64toi32_i32$2 = $66$hi;
    $368 = $66;
    HEAP8[(i64toi32_i32$0 + 387 | 0) >> 0] = $368;
    HEAP8[(i64toi32_i32$0 + 388 | 0) >> 0] = $368 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 389 | 0) >> 0] = $368 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 390 | 0) >> 0] = $368 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 391 | 0) >> 0] = i64toi32_i32$2;
    HEAP8[(i64toi32_i32$0 + 392 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 393 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 394 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
    i64toi32_i32$3 = $1;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $4144 = i64toi32_i32$2;
    i64toi32_i32$2 = $0 + 348 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $4144;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$3 = $2;
    i64toi32_i32$0 = HEAP32[($2 + 200 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($2 + 204 | 0) >> 2] | 0;
    $4147 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 340 | 0) >> 2] = $4147;
    HEAP32[(i64toi32_i32$0 + 344 | 0) >> 2] = i64toi32_i32$2;
    $369 = HEAP32[($2 + 64 | 0) >> 2] | 0;
    HEAP8[(i64toi32_i32$0 + 381 | 0) >> 0] = $369;
    HEAP8[(i64toi32_i32$0 + 382 | 0) >> 0] = $369 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 383 | 0) >> 0] = $369 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 384 | 0) >> 0] = $369 >>> 24 | 0;
    $462 = i64toi32_i32$0 + 385 | 0;
    $463 = HEAPU16[$15 >> 1] | 0;
    HEAP8[$462 >> 0] = $463;
    HEAP8[($462 + 1 | 0) >> 0] = $463 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 415 | 0) >> 0] = HEAPU8[($2 + 186 | 0) >> 0] | 0;
    $464 = HEAPU8[($2 + 184 | 0) >> 0] | 0 | ((HEAPU8[($2 + 185 | 0) >> 0] | 0) << 8 | 0) | 0;
    HEAP8[(i64toi32_i32$0 + 413 | 0) >> 0] = $464;
    HEAP8[(i64toi32_i32$0 + 414 | 0) >> 0] = $464 >>> 8 | 0;
    i64toi32_i32$2 = 0;
    $31 = 0;
    $31$hi = i64toi32_i32$2;
    break label$1;
   }
   i64toi32_i32$2 = $53$hi;
   i64toi32_i32$0 = $2 + 256 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $53;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   HEAP32[($2 + 252 | 0) >> 2] = $15;
   i64toi32_i32$2 = $49$hi;
   i64toi32_i32$0 = $2 + 240 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $49;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$2 = $50$hi;
   i64toi32_i32$0 = $2 + 232 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $50;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$2 = $32$hi;
   i64toi32_i32$0 = $2 + 224 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $32;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$2 = $51$hi;
   i64toi32_i32$0 = $2 + 216 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $51;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$2 = $48$hi;
   i64toi32_i32$0 = ($2 + 200 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $48;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   HEAP32[($2 + 248 | 0) >> 2] = $19;
   i64toi32_i32$2 = $47$hi;
   i64toi32_i32$3 = $47;
   i64toi32_i32$0 = 0;
   i64toi32_i32$5 = 255;
   i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
   $4189 = i64toi32_i32$3 & i64toi32_i32$5 | 0;
   $4189$hi = i64toi32_i32$0;
   i64toi32_i32$0 = $46$hi;
   i64toi32_i32$2 = $46;
   i64toi32_i32$3 = -1;
   i64toi32_i32$5 = -256;
   i64toi32_i32$3 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
   $4191 = i64toi32_i32$2 & i64toi32_i32$5 | 0;
   $4191$hi = i64toi32_i32$3;
   i64toi32_i32$3 = $4189$hi;
   i64toi32_i32$0 = $4189;
   i64toi32_i32$2 = $4191$hi;
   i64toi32_i32$5 = $4191;
   i64toi32_i32$2 = i64toi32_i32$3 | i64toi32_i32$2 | 0;
   $4192 = i64toi32_i32$0 | i64toi32_i32$5 | 0;
   i64toi32_i32$0 = $2;
   HEAP32[($2 + 200 | 0) >> 2] = $4192;
   HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$2;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 200 | 0 | 0, 1052542 | 0, 19 | 0);
   i64toi32_i32$2 = 0;
   $31 = 1;
   $31$hi = i64toi32_i32$2;
  }
  i64toi32_i32$2 = $31$hi;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $31;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  global$0 = $2 + 272 | 0;
 }
 
 function cardano_serialization_lib__tx_builder__TransactionBuilder__add_inputs_from__hcbc35da9d29fe71b($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$5 = 0, i64toi32_i32$1 = 0, i64toi32_i32$4 = 0, i64toi32_i32$2 = 0, $6 = 0, $5 = 0, $28$hi = 0, $26 = 0, $28 = 0, $23 = 0, $27 = 0, $12 = 0, $29$hi = 0, i64toi32_i32$6 = 0, $21 = 0, $29 = 0, $30$hi = 0, $30 = 0, $20 = 0, $14 = 0, $19 = 0, $24 = 0, $33$hi = 0, $15 = 0, $33 = 0, $22 = 0, $31$hi = 0, $17 = 0, $31 = 0, $32$hi = 0, $25 = 0, $10 = 0, $32 = 0, $314 = 0, $315 = 0, $316 = 0, $317 = 0, $318 = 0, $320 = 0, $321 = 0, $322 = 0, $323 = 0, $324 = 0, $325 = 0, $327 = 0, $16 = 0, $7 = 0, $9 = 0, $18 = 0, $328 = 0, $330 = 0, $331 = 0, $332 = 0, $333 = 0, $334 = 0, $335 = 0, $336 = 0, $337 = 0, $338 = 0, $339 = 0, $340 = 0, $341 = 0, $342 = 0, $343 = 0, $344 = 0, $345 = 0, $346 = 0, $347 = 0, $348 = 0, $349 = 0, $350 = 0, $351 = 0, $352 = 0, $353 = 0, $354 = 0, $355 = 0, $356 = 0, $357 = 0, $358 = 0, $52 = 0, $60 = 0, $66 = 0, $77 = 0, $82 = 0, $85 = 0, $97 = 0, $112 = 0, $119 = 0, $124 = 0, $225 = 0, $257 = 0, $264 = 0, $267 = 0, $8 = 0, $11 = 0, $13 = 0, $319 = 0, $326 = 0, $329 = 0, $469 = 0, $566 = 0, $604 = 0, $609 = 0, $618 = 0, $624 = 0, $628 = 0, $631 = 0, $639 = 0, $643 = 0, $646 = 0, $650 = 0, $656 = 0, $662 = 0, $782 = 0, $782$hi = 0, $790 = 0, $790$hi = 0, $791 = 0, $791$hi = 0, $794 = 0, $801 = 0, $801$hi = 0, $811 = 0, $811$hi = 0, $812 = 0, $812$hi = 0, $815 = 0, $822 = 0, $822$hi = 0, $823 = 0, $826 = 0, $827$hi = 0, $828$hi = 0, $835 = 0, $836$hi = 0, $837$hi = 0, $950 = 0, $955 = 0, $958 = 0, $967 = 0, $972 = 0, $975 = 0, $993 = 0, $999 = 0, $1002 = 0, $1011 = 0, $1016 = 0, $1019 = 0, $1286 = 0, $1286$hi = 0, $1309 = 0, $1314 = 0, $1323 = 0, $1329 = 0, $1333 = 0, $1336 = 0, $1344 = 0, $1348 = 0, $1351 = 0, $1355 = 0, $1361 = 0, $1367 = 0, $1480 = 0, $1480$hi = 0, $1488 = 0, $1488$hi = 0, $1489 = 0, $1489$hi = 0, $1492 = 0, $1499 = 0, $1499$hi = 0, $1509 = 0, $1509$hi = 0, $1510 = 0, $1510$hi = 0, $1513 = 0, $1520 = 0, $1520$hi = 0, $1521 = 0, $1524 = 0, $1525$hi = 0, $1526$hi = 0, $1533 = 0, $1534$hi = 0, $1535$hi = 0, $1664 = 0, $1672 = 0, $1675 = 0, $1684 = 0, $1689 = 0, $1692 = 0, $1710 = 0, $1716 = 0, $1719 = 0, $1728 = 0, $1733 = 0, $1736 = 0, $1784 = 0, $1784$hi = 0, $1786 = 0, $1786$hi = 0, $1906 = 0, $1914 = 0, $1917 = 0, $1926 = 0, $1931 = 0, $1934 = 0, $1952 = 0, $1958 = 0, $1961 = 0, $1970 = 0, $1975 = 0, $1978 = 0, $1984 = 0, $1984$hi = 0, $1986 = 0, $1986$hi = 0, $2099 = 0, $2099$hi = 0, $2101 = 0, $2101$hi = 0, $2153 = 0, $2161 = 0, $2164 = 0, $2173 = 0, $2178 = 0, $2181 = 0, $2199 = 0, $2205 = 0, $2208 = 0, $2217 = 0, $2222 = 0, $2225 = 0, $2279 = 0, $2279$hi = 0, $2281 = 0, $2281$hi = 0, $2517 = 0, $2517$hi = 0, $2540 = 0, $2545 = 0, $2554 = 0, $2560 = 0, $2564 = 0, $2567 = 0, $2575 = 0, $2579 = 0, $2582 = 0, $2586 = 0, $2592 = 0, $2598 = 0, $2711 = 0, $2711$hi = 0, $2719 = 0, $2719$hi = 0, $2720 = 0, $2720$hi = 0, $2723 = 0, $2730 = 0, $2730$hi = 0, $2740 = 0, $2740$hi = 0, $2741 = 0, $2741$hi = 0, $2744 = 0, $2751 = 0, $2751$hi = 0, $2752 = 0, $2755 = 0, $2756$hi = 0, $2757$hi = 0, $2764 = 0, $2765$hi = 0, $2766$hi = 0, $2895 = 0, $2903 = 0, $2906 = 0, $2915 = 0, $2920 = 0, $2923 = 0, $2941 = 0, $2947 = 0, $2950 = 0, $2959 = 0, $2964 = 0, $2967 = 0, $3015 = 0, $3015$hi = 0, $3017 = 0, $3017$hi = 0, $3137 = 0, $3145 = 0, $3148 = 0, $3157 = 0, $3162 = 0, $3165 = 0, $3183 = 0, $3189 = 0, $3192 = 0, $3201 = 0, $3206 = 0, $3209 = 0, $3215 = 0, $3215$hi = 0, $3217 = 0, $3217$hi = 0, $3291 = 0, $3323 = 0, $3330 = 0, $3333 = 0, $3379 = 0, $3386 = 0, $3389 = 0, $3492 = 0, $3527 = 0, $3594 = 0, $3599 = 0, $3602 = 0, $3611 = 0, $3616 = 0, $3619 = 0, $3637 = 0, $3643 = 0, $3646 = 0, $3655 = 0, $3660 = 0, $3663 = 0, $3754 = 0, $3788 = 0, $3918 = 0, $3918$hi = 0, $3920 = 0, $3920$hi = 0, $3972 = 0, $3980 = 0, $3983 = 0, $3992 = 0, $3997 = 0, $4000 = 0, $4018 = 0, $4024 = 0, $4027 = 0, $4036 = 0, $4041 = 0, $4044 = 0, $4099 = 0, $4099$hi = 0, $4101 = 0, $4101$hi = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $4 = global$0 - 992 | 0;
  global$0 = $4;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h5a227c01abc6e4c4($4 + 352 | 0 | 0, $2 | 0);
  cardano_serialization_lib__tx_builder__TransactionBuilder__get_total_input__hf80aba4988a4a524($4 + 712 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           label$10 : {
            label$11 : {
             label$12 : {
              label$13 : {
               label$14 : {
                label$15 : {
                 label$16 : {
                  label$17 : {
                   label$18 : {
                    label$19 : {
                     if ((HEAP32[($4 + 712 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                      break label$19
                     }
                     $2 = $4 + 736 | 0;
                     i64toi32_i32$2 = $2;
                     i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
                     i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
                     $52 = i64toi32_i32$0;
                     i64toi32_i32$0 = ($4 + 368 | 0) + 16 | 0;
                     HEAP32[i64toi32_i32$0 >> 2] = $52;
                     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
                     $5 = ($4 + 712 | 0) + 16 | 0;
                     i64toi32_i32$2 = $5;
                     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                     $60 = i64toi32_i32$1;
                     i64toi32_i32$1 = ($4 + 368 | 0) + 8 | 0;
                     HEAP32[i64toi32_i32$1 >> 2] = $60;
                     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                     $6 = ($4 + 712 | 0) + 8 | 0;
                     i64toi32_i32$2 = $6;
                     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                     $66 = i64toi32_i32$0;
                     i64toi32_i32$0 = $4;
                     HEAP32[($4 + 368 | 0) >> 2] = $66;
                     HEAP32[($4 + 372 | 0) >> 2] = i64toi32_i32$1;
                     cardano_serialization_lib__tx_builder__TransactionBuilder__get_total_output__h93b375eebf85cbd8($4 + 712 | 0 | 0, $1 | 0);
                     if ((HEAP32[($4 + 712 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                      break label$18
                     }
                     i64toi32_i32$2 = $2;
                     i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
                     i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
                     $77 = i64toi32_i32$1;
                     i64toi32_i32$1 = ($4 + 680 | 0) + 16 | 0;
                     HEAP32[i64toi32_i32$1 >> 2] = $77;
                     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                     i64toi32_i32$2 = $5;
                     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                     $82 = i64toi32_i32$0;
                     i64toi32_i32$0 = ($4 + 680 | 0) + 8 | 0;
                     HEAP32[i64toi32_i32$0 >> 2] = $82;
                     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
                     i64toi32_i32$2 = $6;
                     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                     $85 = i64toi32_i32$1;
                     i64toi32_i32$1 = $4;
                     HEAP32[($4 + 680 | 0) >> 2] = $85;
                     HEAP32[($4 + 684 | 0) >> 2] = i64toi32_i32$0;
                     cardano_serialization_lib__tx_builder__TransactionBuilder__min_fee__h0562480e064561ee($4 + 568 | 0 | 0, $1 | 0);
                     if ((HEAP32[($4 + 568 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                      break label$17
                     }
                     HEAP32[($4 + 720 | 0) >> 2] = 0;
                     i64toi32_i32$2 = ($4 + 568 | 0) + 8 | 0;
                     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                     $97 = i64toi32_i32$0;
                     i64toi32_i32$0 = $4;
                     HEAP32[($4 + 712 | 0) >> 2] = $97;
                     HEAP32[($4 + 716 | 0) >> 2] = i64toi32_i32$1;
                     cardano_serialization_lib__utils__Value__checked_add__h5184687782847801($4 + 864 | 0 | 0, $4 + 680 | 0 | 0, $4 + 712 | 0 | 0);
                     if ((HEAP32[($4 + 864 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                      break label$16
                     }
                     i64toi32_i32$2 = $4 + 888 | 0;
                     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                     $112 = i64toi32_i32$1;
                     i64toi32_i32$1 = ($4 + 392 | 0) + 16 | 0;
                     HEAP32[i64toi32_i32$1 >> 2] = $112;
                     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                     i64toi32_i32$2 = ($4 + 864 | 0) + 16 | 0;
                     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                     $119 = i64toi32_i32$0;
                     i64toi32_i32$0 = ($4 + 392 | 0) + 8 | 0;
                     HEAP32[i64toi32_i32$0 >> 2] = $119;
                     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
                     i64toi32_i32$2 = ($4 + 864 | 0) + 8 | 0;
                     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                     $124 = i64toi32_i32$1;
                     i64toi32_i32$1 = $4;
                     HEAP32[($4 + 392 | 0) >> 2] = $124;
                     HEAP32[($4 + 396 | 0) >> 2] = i64toi32_i32$0;
                     label$20 : {
                      if (!(HEAP32[($4 + 720 | 0) >> 2] | 0)) {
                       break label$20
                      }
                      $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($4 + 724 | 0 | 0);
                     }
                     label$21 : {
                      if (!(HEAP32[($4 + 688 | 0) >> 2] | 0)) {
                       break label$21
                      }
                      $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($4 + 692 | 0 | 0);
                     }
                     switch ($3 & 255 | 0 | 0) {
                     case 2:
                      break label$10;
                     case 3:
                      break label$13;
                     case 1:
                      break label$14;
                     default:
                      break label$15;
                     };
                    }
                    $3 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($4 + 716 | 0) >> 2] | 0 | 0) | 0;
                    break label$2;
                   }
                   $3 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($4 + 716 | 0) >> 2] | 0 | 0) | 0;
                   break label$3;
                  }
                  $3 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($4 + 572 | 0) >> 2] | 0 | 0) | 0;
                  break label$4;
                 }
                 $3 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($4 + 868 | 0) >> 2] | 0 | 0) | 0;
                 if (!(HEAP32[($4 + 720 | 0) >> 2] | 0)) {
                  break label$4
                 }
                 $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($4 + 724 | 0 | 0);
                 break label$4;
                }
                $2 = (HEAP32[($1 + 424 | 0) >> 2] | 0) << 7 | 0;
                $3 = HEAP32[($1 + 416 | 0) >> 2] | 0;
                label$22 : while (1) {
                 if (!$2) {
                  break label$12
                 }
                 $2 = $2 + -128 | 0;
                 $5 = $3 + 72 | 0;
                 $3 = $3 + 128 | 0;
                 if ((HEAP32[$5 >> 2] | 0 | 0) != (1 | 0)) {
                  continue label$22
                 }
                 break label$22;
                };
                $3 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1064684 | 0, 82 | 0) | 0;
                break label$5;
               }
               $2 = (HEAP32[($1 + 424 | 0) >> 2] | 0) << 7 | 0;
               $3 = HEAP32[($1 + 416 | 0) >> 2] | 0;
               label$23 : while (1) {
                if (!$2) {
                 break label$11
                }
                $2 = $2 + -128 | 0;
                $5 = $3 + 72 | 0;
                $3 = $3 + 128 | 0;
                if ((HEAP32[$5 >> 2] | 0 | 0) != (1 | 0)) {
                 continue label$23
                }
                break label$23;
               };
               $3 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1064568 | 0, 84 | 0) | 0;
               break label$5;
              }
              (wasm2js_i32$0 = $4, wasm2js_i32$1 = rand__rngs__thread__thread_rng__h15df01d3d7282652() | 0), HEAP32[(wasm2js_i32$0 + 420 | 0) >> 2] = wasm2js_i32$1;
              i64toi32_i32$1 = $4;
              i64toi32_i32$0 = 0;
              HEAP32[($4 + 428 | 0) >> 2] = 0;
              HEAP32[($4 + 432 | 0) >> 2] = i64toi32_i32$0;
              label$24 : {
               $3 = HEAP32[($4 + 360 | 0) >> 2] | 0;
               if (!$3) {
                break label$24
               }
               $2 = 0;
               label$25 : while (1) {
                alloc__collections__btree__map__BTreeMap_K_2cV___insert__h358bbc5e89c1a147($4 + 424 | 0 | 0, $2 | 0) | 0;
                $2 = $2 + 1 | 0;
                if (($3 | 0) != ($2 | 0)) {
                 continue label$25
                }
                break label$25;
               };
              }
              label$26 : {
               if ((HEAP32[($4 + 400 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                break label$26
               }
               $7 = ($4 + 392 | 0) + 12 | 0;
               $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($4 + 440 | 0 | 4 | 0 | 0, $7 | 0);
               HEAP32[($4 + 440 | 0) >> 2] = 1;
               HEAP32[($4 + 464 | 0) >> 2] = HEAP32[(($4 + 440 | 0) + 12 | 0) >> 2] | 0;
               i64toi32_i32$2 = $4;
               i64toi32_i32$0 = HEAP32[($4 + 444 | 0) >> 2] | 0;
               i64toi32_i32$1 = HEAP32[($4 + 448 | 0) >> 2] | 0;
               $225 = i64toi32_i32$0;
               i64toi32_i32$0 = $4;
               HEAP32[($4 + 456 | 0) >> 2] = $225;
               HEAP32[($4 + 460 | 0) >> 2] = i64toi32_i32$1;
               label$27 : {
                label$28 : {
                 $2 = HEAP32[($4 + 460 | 0) >> 2] | 0;
                 if (!$2) {
                  break label$28
                 }
                 $3 = HEAP32[($4 + 456 | 0) >> 2] | 0;
                 alloc__collections__btree__navigate__full_range__hd4dadfd3315a2ab8($4 + 472 | 0 | 0, $3 | 0, $2 | 0, $3 | 0, $2 | 0);
                 $2 = HEAP32[($4 + 464 | 0) >> 2] | 0;
                 break label$27;
                }
                $2 = 0;
                HEAP32[($4 + 488 | 0) >> 2] = 0;
                HEAP32[($4 + 476 | 0) >> 2] = 0;
               }
               HEAP32[(($4 + 472 | 0) + 24 | 0) >> 2] = $2;
               HEAP32[(($4 + 504 | 0) + 24 | 0) >> 2] = $2;
               i64toi32_i32$2 = ($4 + 472 | 0) + 16 | 0;
               i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
               i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
               $257 = i64toi32_i32$1;
               i64toi32_i32$1 = ($4 + 504 | 0) + 16 | 0;
               HEAP32[i64toi32_i32$1 >> 2] = $257;
               HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
               i64toi32_i32$2 = ($4 + 472 | 0) + 8 | 0;
               i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
               i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
               $264 = i64toi32_i32$0;
               i64toi32_i32$0 = ($4 + 504 | 0) + 8 | 0;
               HEAP32[i64toi32_i32$0 >> 2] = $264;
               HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
               i64toi32_i32$2 = $4;
               i64toi32_i32$1 = HEAP32[($4 + 472 | 0) >> 2] | 0;
               i64toi32_i32$0 = HEAP32[($4 + 476 | 0) >> 2] | 0;
               $267 = i64toi32_i32$1;
               i64toi32_i32$1 = $4;
               HEAP32[($4 + 504 | 0) >> 2] = $267;
               HEAP32[($4 + 508 | 0) >> 2] = i64toi32_i32$0;
               $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h03cc330b7b1e4522($4 + 344 | 0 | 0, $4 + 504 | 0 | 0);
               label$29 : {
                $2 = HEAP32[($4 + 344 | 0) >> 2] | 0;
                if (!$2) {
                 break label$29
                }
                $3 = HEAP32[($4 + 348 | 0) >> 2] | 0;
                $8 = $1 + 96 | 0;
                $9 = ($4 + 864 | 0) + 12 | 0;
                $10 = ($4 + 712 | 0) + 8 | 0;
                $11 = ($4 + 368 | 0) + 12 | 0;
                $5 = ($4 + 864 | 0) + 89 | 0;
                $12 = ($4 + 864 | 0) + 72 | 0;
                $13 = $4 + 680 | 0 | 4 | 0;
                $14 = $4 + 712 | 0 | 4 | 0;
                label$30 : while (1) {
                 HEAP32[($4 + 532 | 0) >> 2] = $2;
                 alloc__collections__btree__map__BTreeMap_K_2cV___iter__ha89c9458aca0228d($4 + 536 | 0 | 0, $3 | 0);
                 HEAP32[(($4 + 568 | 0) + 24 | 0) >> 2] = HEAP32[(($4 + 536 | 0) + 24 | 0) >> 2] | 0;
                 i64toi32_i32$2 = ($4 + 536 | 0) + 16 | 0;
                 i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                 i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                 $319 = i64toi32_i32$0;
                 i64toi32_i32$0 = ($4 + 568 | 0) + 16 | 0;
                 HEAP32[i64toi32_i32$0 >> 2] = $319;
                 HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
                 i64toi32_i32$2 = ($4 + 536 | 0) + 8 | 0;
                 i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                 i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                 $326 = i64toi32_i32$1;
                 i64toi32_i32$1 = ($4 + 568 | 0) + 8 | 0;
                 HEAP32[i64toi32_i32$1 >> 2] = $326;
                 HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                 i64toi32_i32$2 = $4;
                 i64toi32_i32$0 = HEAP32[($4 + 536 | 0) >> 2] | 0;
                 i64toi32_i32$1 = HEAP32[($4 + 540 | 0) >> 2] | 0;
                 $329 = i64toi32_i32$0;
                 i64toi32_i32$0 = $4;
                 HEAP32[($4 + 568 | 0) >> 2] = $329;
                 HEAP32[($4 + 572 | 0) >> 2] = i64toi32_i32$1;
                 $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h36ca092f81b9a0fa($4 + 336 | 0 | 0, $4 + 568 | 0 | 0);
                 label$31 : {
                  $2 = HEAP32[($4 + 336 | 0) >> 2] | 0;
                  if (!$2) {
                   break label$31
                  }
                  label$32 : while (1) {
                   HEAP32[($4 + 600 | 0) >> 2] = $2;
                   HEAP32[($4 + 612 | 0) >> 2] = $4 + 600 | 0;
                   HEAP32[($4 + 608 | 0) >> 2] = $4 + 532 | 0;
                   HEAP32[($4 + 604 | 0) >> 2] = $4 + 352 | 0;
                   label$33 : {
                    label$34 : {
                     $2 = HEAP32[($4 + 428 | 0) >> 2] | 0;
                     if (!$2) {
                      break label$34
                     }
                     $3 = HEAP32[($4 + 424 | 0) >> 2] | 0;
                     alloc__collections__btree__navigate__full_range__hfcebc6cee2db4b73($4 + 712 | 0 | 0, $3 | 0, $2 | 0, $3 | 0, $2 | 0);
                     $2 = HEAP32[($4 + 432 | 0) >> 2] | 0;
                     break label$33;
                    }
                    $2 = 0;
                    HEAP32[($4 + 728 | 0) >> 2] = 0;
                    HEAP32[($4 + 716 | 0) >> 2] = 0;
                   }
                   HEAP32[(($4 + 864 | 0) + 24 | 0) >> 2] = $2;
                   $15 = ($4 + 864 | 0) + 8 | 0;
                   i64toi32_i32$2 = $10;
                   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                   $28 = i64toi32_i32$1;
                   $28$hi = i64toi32_i32$0;
                   i64toi32_i32$1 = $15;
                   HEAP32[i64toi32_i32$1 >> 2] = $28;
                   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                   $16 = ($4 + 864 | 0) + 16 | 0;
                   $3 = ($4 + 712 | 0) + 16 | 0;
                   i64toi32_i32$2 = $3;
                   i64toi32_i32$0 = HEAP32[$3 >> 2] | 0;
                   i64toi32_i32$1 = HEAP32[($3 + 4 | 0) >> 2] | 0;
                   $29 = i64toi32_i32$0;
                   $29$hi = i64toi32_i32$1;
                   i64toi32_i32$0 = $16;
                   HEAP32[i64toi32_i32$0 >> 2] = $29;
                   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
                   i64toi32_i32$2 = $4;
                   i64toi32_i32$1 = HEAP32[($4 + 712 | 0) >> 2] | 0;
                   i64toi32_i32$0 = HEAP32[($4 + 716 | 0) >> 2] | 0;
                   $30 = i64toi32_i32$1;
                   $30$hi = i64toi32_i32$0;
                   i64toi32_i32$1 = $4;
                   HEAP32[($4 + 864 | 0) >> 2] = $30;
                   HEAP32[($4 + 868 | 0) >> 2] = i64toi32_i32$0;
                   HEAP32[(($4 + 712 | 0) + 24 | 0) >> 2] = $2;
                   i64toi32_i32$0 = $29$hi;
                   i64toi32_i32$1 = $3;
                   HEAP32[i64toi32_i32$1 >> 2] = $29;
                   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                   i64toi32_i32$0 = $28$hi;
                   i64toi32_i32$1 = $10;
                   HEAP32[i64toi32_i32$1 >> 2] = $28;
                   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                   i64toi32_i32$0 = $30$hi;
                   i64toi32_i32$1 = $4;
                   HEAP32[($4 + 712 | 0) >> 2] = $30;
                   HEAP32[($4 + 716 | 0) >> 2] = i64toi32_i32$0;
                   HEAP32[($4 + 744 | 0) >> 2] = $4 + 604 | 0;
                   HEAP32[($4 + 740 | 0) >> 2] = $4 + 608 | 0;
                   $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__he7cc99f5dd5f1b16($4 + 616 | 0 | 0, $4 + 712 | 0 | 0);
                   i64toi32_i32$1 = $4;
                   i64toi32_i32$0 = 0;
                   HEAP32[($4 + 636 | 0) >> 2] = 0;
                   HEAP32[($4 + 640 | 0) >> 2] = i64toi32_i32$0;
                   $2 = HEAP32[($1 + 424 | 0) >> 2] | 0;
                   $3 = HEAP32[($1 + 416 | 0) >> 2] | 0;
                   HEAP32[($4 + 712 | 0) >> 2] = $3;
                   HEAP32[($4 + 716 | 0) >> 2] = $3 + ($2 << 7 | 0) | 0;
                   HEAP32[($4 + 720 | 0) >> 2] = $4 + 608 | 0;
                   $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__hfa703853cabd0820($4 + 648 | 0 | 0, $4 + 712 | 0 | 0);
                   $2 = HEAP32[($4 + 648 | 0) >> 2] | 0;
                   $17 = HEAP32[($4 + 656 | 0) >> 2] | 0;
                   HEAP32[($4 + 712 | 0) >> 2] = $4 + 608 | 0;
                   alloc__slice__merge_sort__h665fa44369f3a6bc($2 | 0, $17 | 0, $4 + 712 | 0 | 0);
                   $18 = $2 + ($17 << 7 | 0) | 0;
                   $3 = $18;
                   label$35 : {
                    label$36 : {
                     if (!$17) {
                      break label$36
                     }
                     label$37 : {
                      label$38 : {
                       label$39 : {
                        label$40 : {
                         label$41 : {
                          label$42 : {
                           label$43 : while (1) {
                            $19 = $3 + -56 | 0;
                            if ((HEAP32[$19 >> 2] | 0 | 0) != (1 | 0)) {
                             break label$38
                            }
                            cardano_serialization_lib__MultiAsset__get__had0c36a2c855d776($4 + 712 | 0 | 0, $3 + -52 | 0 | 0, HEAP32[(HEAP32[($4 + 608 | 0) >> 2] | 0) >> 2] | 0 | 0);
                            if ((HEAP32[($4 + 712 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                             break label$38
                            }
                            $20 = $14 + 8 | 0;
                            HEAP32[$15 >> 2] = HEAP32[$20 >> 2] | 0;
                            i64toi32_i32$2 = $14;
                            i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                            i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                            $469 = i64toi32_i32$0;
                            i64toi32_i32$0 = $4;
                            HEAP32[($4 + 864 | 0) >> 2] = $469;
                            HEAP32[($4 + 868 | 0) >> 2] = i64toi32_i32$1;
                            $6 = alloc__collections__btree__map__BTreeMap_K_2cV___get__h825f34112f7eacbf($4 + 864 | 0 | 0, HEAP32[(HEAP32[($4 + 612 | 0) >> 2] | 0) >> 2] | 0 | 0) | 0;
                            if (!$6) {
                             break label$39
                            }
                            $21 = $3 + -128 | 0;
                            i64toi32_i32$2 = $6;
                            i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                            i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                            $30 = i64toi32_i32$1;
                            $30$hi = i64toi32_i32$0;
                            $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h6c9f94f0f82ce2b5($4 + 864 | 0 | 0);
                            label$44 : {
                             label$45 : {
                              if (!(i64toi32_i32$1 | i64toi32_i32$0 | 0)) {
                               break label$45
                              }
                              $22 = $3 + -64 | 0;
                              $23 = $21 + 89 | 0;
                              $24 = $3 + -40 | 0;
                              $25 = $21 + 76 | 0;
                              i64toi32_i32$0 = 0;
                              $28 = 0;
                              $28$hi = i64toi32_i32$0;
                              label$46 : while (1) {
                               $3 = HEAP32[($4 + 624 | 0) >> 2] | 0;
                               if (!$3) {
                                break label$42
                               }
                               $3 = rand__rng__Rng__gen_range__he28987be934355f0($4 + 420 | 0 | 0, 0 | 0, $3 | 0) | 0;
                               $6 = HEAP32[($4 + 624 | 0) >> 2] | 0;
                               if ($6 >>> 0 <= $3 >>> 0) {
                                break label$41
                               }
                               $26 = HEAP32[($4 + 616 | 0) >> 2] | 0;
                               $3 = $26 + ($3 << 2 | 0) | 0;
                               $27 = HEAP32[$3 >> 2] | 0;
                               $6 = $6 + -1 | 0;
                               HEAP32[($4 + 624 | 0) >> 2] = $6;
                               HEAP32[$3 >> 2] = HEAP32[($26 + ($6 << 2 | 0) | 0) >> 2] | 0;
                               HEAP32[($4 + 660 | 0) >> 2] = $27;
                               alloc__collections__btree__map__BTreeMap_K_2cV___remove_entry__haaee74feca9cfb03($4 + 328 | 0 | 0, $4 + 424 | 0 | 0, $4 + 660 | 0 | 0);
                               $6 = HEAP32[($4 + 604 | 0) >> 2] | 0;
                               $26 = HEAP32[($6 + 8 | 0) >> 2] | 0;
                               $3 = HEAP32[($4 + 660 | 0) >> 2] | 0;
                               if ($26 >>> 0 <= $3 >>> 0) {
                                break label$40
                               }
                               label$47 : {
                                label$48 : {
                                 $3 = (HEAP32[$6 >> 2] | 0) + Math_imul($3, 168) | 0;
                                 if ((HEAP32[($3 + 72 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                                  break label$48
                                 }
                                 cardano_serialization_lib__MultiAsset__get__had0c36a2c855d776($4 + 712 | 0 | 0, $3 + 76 | 0 | 0, HEAP32[(HEAP32[($4 + 608 | 0) >> 2] | 0) >> 2] | 0 | 0);
                                 if ((HEAP32[($4 + 712 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                                  break label$48
                                 }
                                 HEAP32[$15 >> 2] = HEAP32[$20 >> 2] | 0;
                                 i64toi32_i32$2 = $14;
                                 i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                 i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                 $566 = i64toi32_i32$0;
                                 i64toi32_i32$0 = $4;
                                 HEAP32[($4 + 864 | 0) >> 2] = $566;
                                 HEAP32[($4 + 868 | 0) >> 2] = i64toi32_i32$1;
                                 $3 = alloc__collections__btree__map__BTreeMap_K_2cV___get__h825f34112f7eacbf($4 + 864 | 0 | 0, HEAP32[(HEAP32[($4 + 612 | 0) >> 2] | 0) >> 2] | 0 | 0) | 0;
                                 if ($3) {
                                  break label$47
                                 }
                                 $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h6c9f94f0f82ce2b5($4 + 864 | 0 | 0);
                                }
                                core__option__expect_failed__h66afff61e82fdd86(1064766 | 0, 52 | 0, 1064944 | 0);
                                abort();
                               }
                               i64toi32_i32$2 = $3;
                               i64toi32_i32$1 = HEAP32[$3 >> 2] | 0;
                               i64toi32_i32$0 = HEAP32[($3 + 4 | 0) >> 2] | 0;
                               $29 = i64toi32_i32$1;
                               $29$hi = i64toi32_i32$0;
                               $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h6c9f94f0f82ce2b5($4 + 864 | 0 | 0);
                               i64toi32_i32$0 = $28$hi;
                               i64toi32_i32$0 = $29$hi;
                               i64toi32_i32$0 = $28$hi;
                               i64toi32_i32$2 = $28;
                               i64toi32_i32$1 = $29$hi;
                               i64toi32_i32$3 = $29;
                               i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
                               i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
                               if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
                                i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
                               }
                               $29 = i64toi32_i32$4;
                               $29$hi = i64toi32_i32$5;
                               i64toi32_i32$5 = $28$hi;
                               i64toi32_i32$5 = $29$hi;
                               i64toi32_i32$0 = i64toi32_i32$4;
                               i64toi32_i32$2 = $28$hi;
                               i64toi32_i32$3 = $28;
                               if (i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0) {
                                break label$44
                               }
                               $cardano_serialization_lib__address__Address_20as_20core__clone__Clone___clone__h0eb465a6e349d507_2($4 + 712 | 0 | 0, $21 | 0);
                               i64toi32_i32$3 = $22;
                               i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                               i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                               $28 = i64toi32_i32$0;
                               $28$hi = i64toi32_i32$5;
                               $3 = 0;
                               $6 = 0;
                               label$49 : {
                                if ((HEAP32[$19 >> 2] | 0 | 0) != (1 | 0)) {
                                 break label$49
                                }
                                $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($13 | 0, $25 | 0);
                                $6 = 1;
                               }
                               $27 = ($4 + 664 | 0) + 8 | 0;
                               $26 = ($4 + 680 | 0) + 8 | 0;
                               i64toi32_i32$3 = $26;
                               i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                               i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                               $604 = i64toi32_i32$5;
                               i64toi32_i32$5 = $27;
                               HEAP32[i64toi32_i32$5 >> 2] = $604;
                               HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
                               HEAP32[($4 + 680 | 0) >> 2] = $6;
                               i64toi32_i32$3 = $4;
                               i64toi32_i32$0 = HEAP32[($4 + 680 | 0) >> 2] | 0;
                               i64toi32_i32$5 = HEAP32[($4 + 684 | 0) >> 2] | 0;
                               $609 = i64toi32_i32$0;
                               i64toi32_i32$0 = $4;
                               HEAP32[($4 + 664 | 0) >> 2] = $609;
                               HEAP32[($4 + 668 | 0) >> 2] = i64toi32_i32$5;
                               label$50 : {
                                if ((HEAPU8[$24 >> 0] | 0 | 0) != (1 | 0)) {
                                 break label$50
                                }
                                i64toi32_i32$3 = $23 + 24 | 0;
                                i64toi32_i32$5 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                i64toi32_i32$0 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                $618 = i64toi32_i32$5;
                                i64toi32_i32$5 = ($4 + 680 | 0) + 24 | 0;
                                HEAP32[i64toi32_i32$5 >> 2] = $618;
                                HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
                                i64toi32_i32$3 = $23 + 16 | 0;
                                i64toi32_i32$0 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                i64toi32_i32$5 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                $624 = i64toi32_i32$0;
                                i64toi32_i32$0 = ($4 + 680 | 0) + 16 | 0;
                                HEAP32[i64toi32_i32$0 >> 2] = $624;
                                HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$5;
                                i64toi32_i32$3 = $23 + 8 | 0;
                                i64toi32_i32$5 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                i64toi32_i32$0 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                $628 = i64toi32_i32$5;
                                i64toi32_i32$5 = $26;
                                HEAP32[i64toi32_i32$5 >> 2] = $628;
                                HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
                                i64toi32_i32$3 = $23;
                                i64toi32_i32$0 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                i64toi32_i32$5 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                $631 = i64toi32_i32$0;
                                i64toi32_i32$0 = $4;
                                HEAP32[($4 + 680 | 0) >> 2] = $631;
                                HEAP32[($4 + 684 | 0) >> 2] = i64toi32_i32$5;
                                $3 = 1;
                               }
                               memcpy($4 + 864 | 0 | 0, $4 + 712 | 0 | 0, 64 | 0) | 0;
                               i64toi32_i32$3 = $4;
                               i64toi32_i32$5 = HEAP32[($4 + 664 | 0) >> 2] | 0;
                               i64toi32_i32$0 = HEAP32[($4 + 668 | 0) >> 2] | 0;
                               $639 = i64toi32_i32$5;
                               i64toi32_i32$5 = $12;
                               HEAP32[i64toi32_i32$5 >> 2] = $639;
                               HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
                               i64toi32_i32$3 = $27;
                               i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                               i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                               $643 = i64toi32_i32$0;
                               i64toi32_i32$0 = $12 + 8 | 0;
                               HEAP32[i64toi32_i32$0 >> 2] = $643;
                               HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$5;
                               i64toi32_i32$3 = $4;
                               i64toi32_i32$5 = HEAP32[($4 + 680 | 0) >> 2] | 0;
                               i64toi32_i32$0 = HEAP32[($4 + 684 | 0) >> 2] | 0;
                               $646 = i64toi32_i32$5;
                               i64toi32_i32$5 = $5;
                               $314 = $646;
                               HEAP8[i64toi32_i32$5 >> 0] = $314;
                               HEAP8[(i64toi32_i32$5 + 1 | 0) >> 0] = $314 >>> 8 | 0;
                               HEAP8[(i64toi32_i32$5 + 2 | 0) >> 0] = $314 >>> 16 | 0;
                               HEAP8[(i64toi32_i32$5 + 3 | 0) >> 0] = $314 >>> 24 | 0;
                               HEAP8[(i64toi32_i32$5 + 4 | 0) >> 0] = i64toi32_i32$0;
                               HEAP8[(i64toi32_i32$5 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                               HEAP8[(i64toi32_i32$5 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
                               HEAP8[(i64toi32_i32$5 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
                               i64toi32_i32$3 = $26;
                               i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                               i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                               $650 = i64toi32_i32$0;
                               i64toi32_i32$0 = $5 + 8 | 0;
                               $315 = $650;
                               HEAP8[i64toi32_i32$0 >> 0] = $315;
                               HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $315 >>> 8 | 0;
                               HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $315 >>> 16 | 0;
                               HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $315 >>> 24 | 0;
                               HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$5;
                               HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$5 >>> 8 | 0;
                               HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$5 >>> 16 | 0;
                               HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$5 >>> 24 | 0;
                               i64toi32_i32$3 = ($4 + 680 | 0) + 16 | 0;
                               i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                               i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                               $656 = i64toi32_i32$5;
                               i64toi32_i32$5 = $5 + 16 | 0;
                               $316 = $656;
                               HEAP8[i64toi32_i32$5 >> 0] = $316;
                               HEAP8[(i64toi32_i32$5 + 1 | 0) >> 0] = $316 >>> 8 | 0;
                               HEAP8[(i64toi32_i32$5 + 2 | 0) >> 0] = $316 >>> 16 | 0;
                               HEAP8[(i64toi32_i32$5 + 3 | 0) >> 0] = $316 >>> 24 | 0;
                               HEAP8[(i64toi32_i32$5 + 4 | 0) >> 0] = i64toi32_i32$0;
                               HEAP8[(i64toi32_i32$5 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                               HEAP8[(i64toi32_i32$5 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
                               HEAP8[(i64toi32_i32$5 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
                               i64toi32_i32$3 = ($4 + 680 | 0) + 24 | 0;
                               i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                               i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                               $662 = i64toi32_i32$0;
                               i64toi32_i32$0 = $5 + 24 | 0;
                               $317 = $662;
                               HEAP8[i64toi32_i32$0 >> 0] = $317;
                               HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $317 >>> 8 | 0;
                               HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $317 >>> 16 | 0;
                               HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $317 >>> 24 | 0;
                               HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$5;
                               HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$5 >>> 8 | 0;
                               HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$5 >>> 16 | 0;
                               HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$5 >>> 24 | 0;
                               i64toi32_i32$5 = $28$hi;
                               i64toi32_i32$0 = $4;
                               HEAP32[($4 + 928 | 0) >> 2] = $28;
                               HEAP32[($4 + 932 | 0) >> 2] = i64toi32_i32$5;
                               HEAP8[($4 + 952 | 0) >> 0] = $3;
                               alloc__collections__btree__map__BTreeMap_K_2cV___entry__hf5f68610bd8a4a4c($4 + 712 | 0 | 0, $4 + 632 | 0 | 0, $4 + 864 | 0 | 0);
                               $3 = alloc__collections__btree__map__entry__Entry_K_2cV___or_default__h1c00ee87c8b7cd04($4 + 712 | 0 | 0) | 0;
                               $26 = HEAP32[($4 + 660 | 0) >> 2] | 0;
                               label$51 : {
                                $6 = HEAP32[($3 + 8 | 0) >> 2] | 0;
                                if (($6 | 0) != (HEAP32[($3 + 4 | 0) >> 2] | 0 | 0)) {
                                 break label$51
                                }
                                alloc__vec__Vec_T_2cA___reserve__h71af5692fa531ae6($3 | 0, 1 | 0);
                                $6 = HEAP32[($3 + 8 | 0) >> 2] | 0;
                               }
                               HEAP32[((HEAP32[$3 >> 2] | 0) + ($6 << 2 | 0) | 0) >> 2] = $26;
                               HEAP32[($3 + 8 | 0) >> 2] = (HEAP32[($3 + 8 | 0) >> 2] | 0) + 1 | 0;
                               i64toi32_i32$5 = $29$hi;
                               $28 = $29;
                               $28$hi = i64toi32_i32$5;
                               i64toi32_i32$5 = $30$hi;
                               i64toi32_i32$5 = $28$hi;
                               i64toi32_i32$3 = $28;
                               i64toi32_i32$0 = $30$hi;
                               i64toi32_i32$2 = $30;
                               if (i64toi32_i32$5 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$3 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0) {
                                continue label$46
                               }
                               break label$46;
                              };
                             }
                             $3 = $21;
                             if (($2 | 0) == ($3 | 0)) {
                              break label$37
                             }
                             continue label$43;
                            }
                            break label$43;
                           };
                           $3 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1058732 | 0, 8 | 0) | 0 | 0) | 0;
                           break label$35;
                          }
                          $3 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1064884 | 0, 25 | 0) | 0;
                          break label$35;
                         }
                         alloc__vec__Vec_T_2cA___swap_remove__assert_failed__h35befc50802f56b5($3 | 0, $6 | 0);
                         abort();
                        }
                        core__panicking__panic_bounds_check__h808b524af17640b1($3 | 0, $26 | 0, 1064928 | 0);
                        abort();
                       }
                       $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h6c9f94f0f82ce2b5($4 + 864 | 0 | 0);
                      }
                      core__panicking__panic__h2fd385a887c8bf13(1063668 | 0, 43 | 0, 1064912 | 0);
                      abort();
                     }
                     label$52 : {
                      if (!$17) {
                       break label$52
                      }
                      if (!(HEAP32[($4 + 624 | 0) >> 2] | 0)) {
                       break label$52
                      }
                      label$53 : while (1) {
                       label$54 : {
                        label$55 : {
                         label$56 : {
                          label$57 : {
                           label$58 : {
                            $3 = alloc__collections__btree__map__BTreeMap_K_2cV___get_mut__hd032fad84dac0c7f($4 + 632 | 0 | 0, $2 | 0) | 0;
                            if (!$3) {
                             break label$58
                            }
                            $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__DerefMut___deref_mut__h42fc515862cf6b48($4 + 320 | 0 | 0, $3 | 0);
                            $6 = HEAP32[($4 + 324 | 0) >> 2] | 0;
                            if (!$6) {
                             break label$54
                            }
                            $3 = HEAP32[($4 + 320 | 0) >> 2] | 0;
                            $23 = $6 << 2 | 0;
                            label$59 : while (1) {
                             $6 = rand__rng__Rng__gen_range__he28987be934355f0($4 + 420 | 0 | 0, 0 | 0, HEAP32[($4 + 624 | 0) >> 2] | 0 | 0) | 0;
                             $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__DerefMut___deref_mut__h42fc515862cf6b48($4 + 312 | 0 | 0, $4 + 616 | 0 | 0);
                             if ($6 >>> 0 >= (HEAP32[($4 + 316 | 0) >> 2] | 0) >>> 0) {
                              break label$57
                             }
                             $21 = HEAP32[($4 + 312 | 0) >> 2] | 0;
                             if (!$21) {
                              break label$57
                             }
                             $20 = HEAP32[($4 + 604 | 0) >> 2] | 0;
                             $27 = HEAP32[($20 + 8 | 0) >> 2] | 0;
                             $26 = HEAP32[$3 >> 2] | 0;
                             if ($27 >>> 0 <= $26 >>> 0) {
                              break label$56
                             }
                             $21 = $21 + ($6 << 2 | 0) | 0;
                             $6 = HEAP32[$21 >> 2] | 0;
                             if ($27 >>> 0 <= $6 >>> 0) {
                              break label$55
                             }
                             label$60 : {
                              $27 = HEAP32[$20 >> 2] | 0;
                              i64toi32_i32$2 = $27 + Math_imul($6, 168) | 0;
                              i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
                              i64toi32_i32$5 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
                              $29 = i64toi32_i32$3;
                              $29$hi = i64toi32_i32$5;
                              i64toi32_i32$2 = $2;
                              i64toi32_i32$5 = HEAP32[($2 + 64 | 0) >> 2] | 0;
                              i64toi32_i32$3 = HEAP32[($2 + 68 | 0) >> 2] | 0;
                              $28 = i64toi32_i32$5;
                              $28$hi = i64toi32_i32$3;
                              i64toi32_i32$5 = 0;
                              i64toi32_i32$5 = __wasm_i64_mul($28 | 0, i64toi32_i32$3 | 0, 3 | 0, i64toi32_i32$5 | 0) | 0;
                              i64toi32_i32$3 = i64toi32_i32$HIGH_BITS;
                              $782 = i64toi32_i32$5;
                              $782$hi = i64toi32_i32$3;
                              i64toi32_i32$3 = $29$hi;
                              i64toi32_i32$2 = $29;
                              i64toi32_i32$5 = $782$hi;
                              i64toi32_i32$0 = $782;
                              if (i64toi32_i32$3 >>> 0 > i64toi32_i32$5 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$2 >>> 0 >= i64toi32_i32$0 >>> 0 | 0) | 0) {
                               break label$60
                              }
                              i64toi32_i32$2 = $28$hi;
                              i64toi32_i32$0 = $28;
                              i64toi32_i32$3 = 0;
                              i64toi32_i32$5 = 1;
                              i64toi32_i32$1 = i64toi32_i32$5 & 31 | 0;
                              if (32 >>> 0 <= (i64toi32_i32$5 & 63 | 0) >>> 0) {
                               i64toi32_i32$3 = i64toi32_i32$0 << i64toi32_i32$1 | 0;
                               $328 = 0;
                              } else {
                               i64toi32_i32$3 = ((1 << i64toi32_i32$1 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$1 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$1 | 0) | 0;
                               $328 = i64toi32_i32$0 << i64toi32_i32$1 | 0;
                              }
                              $28 = $328;
                              $28$hi = i64toi32_i32$3;
                              i64toi32_i32$3 = $29$hi;
                              i64toi32_i32$3 = $28$hi;
                              i64toi32_i32$2 = $28;
                              i64toi32_i32$0 = $29$hi;
                              i64toi32_i32$5 = $29;
                              i64toi32_i32$1 = i64toi32_i32$2 - i64toi32_i32$5 | 0;
                              i64toi32_i32$6 = i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0;
                              i64toi32_i32$4 = i64toi32_i32$6 + i64toi32_i32$0 | 0;
                              i64toi32_i32$4 = i64toi32_i32$3 - i64toi32_i32$4 | 0;
                              $30 = i64toi32_i32$1;
                              $30$hi = i64toi32_i32$4;
                              i64toi32_i32$4 = 0;
                              i64toi32_i32$3 = 0;
                              i64toi32_i32$2 = $30$hi;
                              i64toi32_i32$5 = i64toi32_i32$1;
                              i64toi32_i32$0 = i64toi32_i32$3 - i64toi32_i32$5 | 0;
                              i64toi32_i32$6 = i64toi32_i32$3 >>> 0 < i64toi32_i32$5 >>> 0;
                              i64toi32_i32$1 = i64toi32_i32$6 + i64toi32_i32$2 | 0;
                              i64toi32_i32$1 = i64toi32_i32$4 - i64toi32_i32$1 | 0;
                              $790 = i64toi32_i32$0;
                              $790$hi = i64toi32_i32$1;
                              i64toi32_i32$1 = i64toi32_i32$2;
                              $791 = i64toi32_i32$5;
                              $791$hi = i64toi32_i32$1;
                              i64toi32_i32$1 = $28$hi;
                              i64toi32_i32$1 = $29$hi;
                              i64toi32_i32$1 = $28$hi;
                              i64toi32_i32$4 = $28;
                              i64toi32_i32$3 = $29$hi;
                              i64toi32_i32$5 = $29;
                              $794 = i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$4 >>> 0 < i64toi32_i32$5 >>> 0 | 0) | 0;
                              i64toi32_i32$4 = 0;
                              $31 = $794;
                              $31$hi = i64toi32_i32$4;
                              i64toi32_i32$4 = 0;
                              i64toi32_i32$5 = 0;
                              i64toi32_i32$1 = $31$hi;
                              i64toi32_i32$3 = $31;
                              i64toi32_i32$2 = i64toi32_i32$5 - i64toi32_i32$3 | 0;
                              i64toi32_i32$6 = i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0;
                              i64toi32_i32$0 = i64toi32_i32$6 + i64toi32_i32$1 | 0;
                              i64toi32_i32$0 = i64toi32_i32$4 - i64toi32_i32$0 | 0;
                              $32 = i64toi32_i32$2;
                              $32$hi = i64toi32_i32$0;
                              i64toi32_i32$4 = i64toi32_i32$2;
                              i64toi32_i32$5 = 0;
                              i64toi32_i32$3 = 0;
                              if ((i64toi32_i32$0 | 0) < (i64toi32_i32$5 | 0)) {
                               $330 = 1
                              } else {
                               if ((i64toi32_i32$0 | 0) <= (i64toi32_i32$5 | 0)) {
                                if (i64toi32_i32$4 >>> 0 >= i64toi32_i32$3 >>> 0) {
                                 $331 = 0
                                } else {
                                 $331 = 1
                                }
                                $332 = $331;
                               } else {
                                $332 = 0
                               }
                               $330 = $332;
                              }
                              $20 = $330;
                              i64toi32_i32$1 = $20;
                              i64toi32_i32$4 = $790$hi;
                              i64toi32_i32$0 = $791$hi;
                              i64toi32_i32$5 = i64toi32_i32$1 ? $790 : $791;
                              i64toi32_i32$3 = i64toi32_i32$1 ? i64toi32_i32$4 : i64toi32_i32$0;
                              $801 = i64toi32_i32$5;
                              $801$hi = i64toi32_i32$3;
                              i64toi32_i32$3 = $28$hi;
                              i64toi32_i32$1 = $27 + Math_imul($26, 168) | 0;
                              i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] | 0;
                              i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] | 0;
                              $33 = i64toi32_i32$3;
                              $33$hi = i64toi32_i32$5;
                              i64toi32_i32$5 = $28$hi;
                              i64toi32_i32$1 = $28;
                              i64toi32_i32$3 = $33$hi;
                              i64toi32_i32$4 = $33;
                              i64toi32_i32$0 = i64toi32_i32$1 - i64toi32_i32$4 | 0;
                              i64toi32_i32$6 = i64toi32_i32$1 >>> 0 < i64toi32_i32$4 >>> 0;
                              i64toi32_i32$2 = i64toi32_i32$6 + i64toi32_i32$3 | 0;
                              i64toi32_i32$2 = i64toi32_i32$5 - i64toi32_i32$2 | 0;
                              $29 = i64toi32_i32$0;
                              $29$hi = i64toi32_i32$2;
                              i64toi32_i32$2 = 0;
                              i64toi32_i32$5 = 0;
                              i64toi32_i32$1 = $29$hi;
                              i64toi32_i32$4 = i64toi32_i32$0;
                              i64toi32_i32$3 = i64toi32_i32$5 - i64toi32_i32$0 | 0;
                              i64toi32_i32$6 = i64toi32_i32$5 >>> 0 < i64toi32_i32$0 >>> 0;
                              i64toi32_i32$0 = i64toi32_i32$6 + i64toi32_i32$1 | 0;
                              i64toi32_i32$0 = i64toi32_i32$2 - i64toi32_i32$0 | 0;
                              $811 = i64toi32_i32$3;
                              $811$hi = i64toi32_i32$0;
                              i64toi32_i32$0 = i64toi32_i32$1;
                              $812 = i64toi32_i32$4;
                              $812$hi = i64toi32_i32$0;
                              i64toi32_i32$0 = $28$hi;
                              i64toi32_i32$0 = $33$hi;
                              i64toi32_i32$0 = $28$hi;
                              i64toi32_i32$2 = $28;
                              i64toi32_i32$5 = $33$hi;
                              i64toi32_i32$4 = $33;
                              $815 = i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$4 >>> 0 | 0) | 0;
                              i64toi32_i32$2 = 0;
                              $28 = $815;
                              $28$hi = i64toi32_i32$2;
                              i64toi32_i32$2 = 0;
                              i64toi32_i32$4 = 0;
                              i64toi32_i32$0 = $28$hi;
                              i64toi32_i32$5 = $28;
                              i64toi32_i32$1 = i64toi32_i32$4 - i64toi32_i32$5 | 0;
                              i64toi32_i32$6 = i64toi32_i32$4 >>> 0 < i64toi32_i32$5 >>> 0;
                              i64toi32_i32$3 = i64toi32_i32$6 + i64toi32_i32$0 | 0;
                              i64toi32_i32$3 = i64toi32_i32$2 - i64toi32_i32$3 | 0;
                              $33 = i64toi32_i32$1;
                              $33$hi = i64toi32_i32$3;
                              i64toi32_i32$2 = i64toi32_i32$1;
                              i64toi32_i32$4 = 0;
                              i64toi32_i32$5 = 0;
                              if ((i64toi32_i32$3 | 0) < (i64toi32_i32$4 | 0)) {
                               $333 = 1
                              } else {
                               if ((i64toi32_i32$3 | 0) <= (i64toi32_i32$4 | 0)) {
                                if (i64toi32_i32$2 >>> 0 >= i64toi32_i32$5 >>> 0) {
                                 $334 = 0
                                } else {
                                 $334 = 1
                                }
                                $335 = $334;
                               } else {
                                $335 = 0
                               }
                               $333 = $335;
                              }
                              $27 = $333;
                              i64toi32_i32$0 = $27;
                              i64toi32_i32$2 = $811$hi;
                              i64toi32_i32$3 = $812$hi;
                              i64toi32_i32$4 = i64toi32_i32$0 ? $811 : $812;
                              i64toi32_i32$5 = i64toi32_i32$0 ? i64toi32_i32$2 : i64toi32_i32$3;
                              $822 = i64toi32_i32$4;
                              $822$hi = i64toi32_i32$5;
                              i64toi32_i32$5 = $801$hi;
                              i64toi32_i32$0 = $801;
                              i64toi32_i32$4 = $822$hi;
                              i64toi32_i32$2 = $822;
                              $823 = i64toi32_i32$5 >>> 0 > i64toi32_i32$4 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$4 | 0) & i64toi32_i32$0 >>> 0 >= i64toi32_i32$2 >>> 0 | 0) | 0;
                              i64toi32_i32$0 = $31$hi;
                              i64toi32_i32$0 = $30$hi;
                              i64toi32_i32$2 = $30;
                              i64toi32_i32$5 = 0;
                              i64toi32_i32$4 = 0;
                              $826 = (i64toi32_i32$2 | 0) != (i64toi32_i32$4 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$5 | 0) | 0;
                              i64toi32_i32$2 = 0;
                              $827$hi = i64toi32_i32$2;
                              i64toi32_i32$2 = $31$hi;
                              i64toi32_i32$4 = $31;
                              i64toi32_i32$0 = $827$hi;
                              i64toi32_i32$5 = $826;
                              i64toi32_i32$3 = i64toi32_i32$4 - i64toi32_i32$5 | 0;
                              i64toi32_i32$6 = i64toi32_i32$4 >>> 0 < i64toi32_i32$5 >>> 0;
                              i64toi32_i32$1 = i64toi32_i32$6 + i64toi32_i32$0 | 0;
                              i64toi32_i32$1 = i64toi32_i32$2 - i64toi32_i32$1 | 0;
                              $828$hi = i64toi32_i32$1;
                              i64toi32_i32$1 = $32$hi;
                              i64toi32_i32$0 = $20;
                              i64toi32_i32$1 = $828$hi;
                              i64toi32_i32$4 = $32$hi;
                              i64toi32_i32$5 = i64toi32_i32$0 ? i64toi32_i32$3 : $32;
                              i64toi32_i32$2 = i64toi32_i32$0 ? i64toi32_i32$1 : i64toi32_i32$4;
                              $30 = i64toi32_i32$5;
                              $30$hi = i64toi32_i32$2;
                              i64toi32_i32$2 = $28$hi;
                              i64toi32_i32$2 = $29$hi;
                              i64toi32_i32$0 = $29;
                              i64toi32_i32$5 = 0;
                              i64toi32_i32$1 = 0;
                              $835 = (i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$5 | 0) | 0;
                              i64toi32_i32$0 = 0;
                              $836$hi = i64toi32_i32$0;
                              i64toi32_i32$0 = $28$hi;
                              i64toi32_i32$1 = $28;
                              i64toi32_i32$2 = $836$hi;
                              i64toi32_i32$5 = $835;
                              i64toi32_i32$4 = i64toi32_i32$1 - i64toi32_i32$5 | 0;
                              i64toi32_i32$6 = i64toi32_i32$1 >>> 0 < i64toi32_i32$5 >>> 0;
                              i64toi32_i32$3 = i64toi32_i32$6 + i64toi32_i32$2 | 0;
                              i64toi32_i32$3 = i64toi32_i32$0 - i64toi32_i32$3 | 0;
                              $837$hi = i64toi32_i32$3;
                              i64toi32_i32$3 = $33$hi;
                              i64toi32_i32$2 = $27;
                              i64toi32_i32$3 = $837$hi;
                              i64toi32_i32$1 = $33$hi;
                              i64toi32_i32$5 = i64toi32_i32$2 ? i64toi32_i32$4 : $33;
                              i64toi32_i32$0 = i64toi32_i32$2 ? i64toi32_i32$3 : i64toi32_i32$1;
                              $28 = i64toi32_i32$5;
                              $28$hi = i64toi32_i32$0;
                              i64toi32_i32$0 = $30$hi;
                              i64toi32_i32$2 = $30;
                              i64toi32_i32$5 = $28$hi;
                              i64toi32_i32$3 = $28;
                              if ((i64toi32_i32$0 | 0) > (i64toi32_i32$5 | 0)) {
                               $336 = 1
                              } else {
                               if ((i64toi32_i32$0 | 0) >= (i64toi32_i32$5 | 0)) {
                                if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
                                 $337 = 0
                                } else {
                                 $337 = 1
                                }
                                $338 = $337;
                               } else {
                                $338 = 0
                               }
                               $336 = $338;
                              }
                              i64toi32_i32$2 = $30$hi;
                              i64toi32_i32$2 = $28$hi;
                              i64toi32_i32$2 = $30$hi;
                              i64toi32_i32$3 = $30;
                              i64toi32_i32$0 = $28$hi;
                              i64toi32_i32$5 = $28;
                              if ((i64toi32_i32$3 | 0) == (i64toi32_i32$5 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) | 0 ? $823 : $336) {
                               break label$60
                              }
                              HEAP32[$21 >> 2] = $26;
                              HEAP32[$3 >> 2] = $6;
                              alloc__collections__btree__map__BTreeMap_K_2cV___insert__h358bbc5e89c1a147($4 + 424 | 0 | 0, HEAP32[$3 >> 2] | 0 | 0) | 0;
                              alloc__collections__btree__map__BTreeMap_K_2cV___remove_entry__haaee74feca9cfb03($4 + 304 | 0 | 0, $4 + 424 | 0 | 0, $21 | 0);
                             }
                             $3 = $3 + 4 | 0;
                             $23 = $23 + -4 | 0;
                             if (!$23) {
                              break label$54
                             }
                             continue label$59;
                            };
                           }
                           core__panicking__panic__h2fd385a887c8bf13(1063668 | 0, 43 | 0, 1064960 | 0);
                           abort();
                          }
                          core__panicking__panic__h2fd385a887c8bf13(1063668 | 0, 43 | 0, 1064976 | 0);
                          abort();
                         }
                         core__panicking__panic_bounds_check__h808b524af17640b1($26 | 0, $27 | 0, 1064992 | 0);
                         abort();
                        }
                        core__panicking__panic_bounds_check__h808b524af17640b1($6 | 0, $27 | 0, 1065008 | 0);
                        abort();
                       }
                       $2 = $2 + 128 | 0;
                       if (($2 | 0) != ($18 | 0)) {
                        continue label$53
                       }
                       break label$53;
                      };
                      $17 = HEAP32[($4 + 656 | 0) >> 2] | 0;
                      $2 = HEAP32[($4 + 648 | 0) >> 2] | 0;
                     }
                     if (!$17) {
                      break label$36
                     }
                     $20 = $17 << 7 | 0;
                     $19 = $2 + $20 | 0;
                     $21 = $2;
                     label$61 : while (1) {
                      label$62 : {
                       label$63 : {
                        label$64 : {
                         label$65 : {
                          label$66 : {
                           $3 = alloc__collections__btree__map__BTreeMap_K_2cV___get__h46e97faa3debbf61($4 + 632 | 0 | 0, $21 | 0) | 0;
                           if (!$3) {
                            break label$66
                           }
                           $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h0f0d6987a7f36efc($4 + 296 | 0 | 0, $3 | 0);
                           $3 = HEAP32[($4 + 300 | 0) >> 2] | 0;
                           if (!$3) {
                            break label$62
                           }
                           $6 = HEAP32[($4 + 296 | 0) >> 2] | 0;
                           $27 = $3 << 2 | 0;
                           label$67 : while (1) {
                            $26 = HEAP32[($4 + 604 | 0) >> 2] | 0;
                            $23 = HEAP32[($26 + 8 | 0) >> 2] | 0;
                            $3 = HEAP32[$6 >> 2] | 0;
                            if ($23 >>> 0 <= $3 >>> 0) {
                             break label$65
                            }
                            $3 = (HEAP32[$26 >> 2] | 0) + Math_imul($3, 168) | 0;
                            $23 = $3 + 128 | 0;
                            $26 = $3 + 64 | 0;
                            cardano_serialization_lib__tx_builder__TransactionBuilder__fee_for_input__ha5a0f735cbb9ab50($4 + 712 | 0 | 0, $1 | 0, $3 | 0, $23 | 0, $26 | 0);
                            if ((HEAP32[($4 + 712 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                             break label$64
                            }
                            i64toi32_i32$5 = $4;
                            i64toi32_i32$3 = HEAP32[($4 + 720 | 0) >> 2] | 0;
                            i64toi32_i32$2 = HEAP32[($4 + 724 | 0) >> 2] | 0;
                            $28 = i64toi32_i32$3;
                            $28$hi = i64toi32_i32$2;
                            cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__add_input__hd22960e5a7d88824($8 | 0, $3 | 0, $23 | 0, $26 | 0);
                            cardano_serialization_lib__utils__Value__checked_add__h5184687782847801($4 + 712 | 0 | 0, $4 + 368 | 0 | 0, $26 | 0);
                            if ((HEAP32[($4 + 712 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                             break label$63
                            }
                            $3 = $10 + 16 | 0;
                            i64toi32_i32$5 = $3;
                            i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                            i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                            $950 = i64toi32_i32$2;
                            i64toi32_i32$2 = $16;
                            HEAP32[i64toi32_i32$2 >> 2] = $950;
                            HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                            $26 = $10 + 8 | 0;
                            i64toi32_i32$5 = $26;
                            i64toi32_i32$3 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                            i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                            $955 = i64toi32_i32$3;
                            i64toi32_i32$3 = $15;
                            HEAP32[i64toi32_i32$3 >> 2] = $955;
                            HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                            i64toi32_i32$5 = $10;
                            i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                            i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                            $958 = i64toi32_i32$2;
                            i64toi32_i32$2 = $4;
                            HEAP32[($4 + 864 | 0) >> 2] = $958;
                            HEAP32[($4 + 868 | 0) >> 2] = i64toi32_i32$3;
                            label$68 : {
                             if (!(HEAP32[($4 + 376 | 0) >> 2] | 0)) {
                              break label$68
                             }
                             $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($11 | 0);
                            }
                            i64toi32_i32$5 = $16;
                            i64toi32_i32$3 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                            i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                            $967 = i64toi32_i32$3;
                            i64toi32_i32$3 = ($4 + 368 | 0) + 16 | 0;
                            HEAP32[i64toi32_i32$3 >> 2] = $967;
                            HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                            i64toi32_i32$5 = $15;
                            i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                            i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                            $972 = i64toi32_i32$2;
                            i64toi32_i32$2 = ($4 + 368 | 0) + 8 | 0;
                            HEAP32[i64toi32_i32$2 >> 2] = $972;
                            HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                            i64toi32_i32$5 = $4;
                            i64toi32_i32$3 = HEAP32[($4 + 864 | 0) >> 2] | 0;
                            i64toi32_i32$2 = HEAP32[($4 + 868 | 0) >> 2] | 0;
                            $975 = i64toi32_i32$3;
                            i64toi32_i32$3 = $4;
                            HEAP32[($4 + 368 | 0) >> 2] = $975;
                            HEAP32[($4 + 372 | 0) >> 2] = i64toi32_i32$2;
                            HEAP32[($4 + 872 | 0) >> 2] = 0;
                            i64toi32_i32$2 = $28$hi;
                            i64toi32_i32$3 = $4;
                            HEAP32[($4 + 864 | 0) >> 2] = $28;
                            HEAP32[($4 + 868 | 0) >> 2] = i64toi32_i32$2;
                            cardano_serialization_lib__utils__Value__checked_add__h5184687782847801($4 + 712 | 0 | 0, $4 + 392 | 0 | 0, $4 + 864 | 0 | 0);
                            label$69 : {
                             if ((HEAP32[($4 + 712 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                              break label$69
                             }
                             $23 = ($4 + 680 | 0) + 16 | 0;
                             i64toi32_i32$5 = $3;
                             i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                             i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                             $993 = i64toi32_i32$2;
                             i64toi32_i32$2 = $23;
                             HEAP32[i64toi32_i32$2 >> 2] = $993;
                             HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                             $3 = ($4 + 680 | 0) + 8 | 0;
                             i64toi32_i32$5 = $26;
                             i64toi32_i32$3 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                             i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                             $999 = i64toi32_i32$3;
                             i64toi32_i32$3 = $3;
                             HEAP32[i64toi32_i32$3 >> 2] = $999;
                             HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                             i64toi32_i32$5 = $10;
                             i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                             i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                             $1002 = i64toi32_i32$2;
                             i64toi32_i32$2 = $4;
                             HEAP32[($4 + 680 | 0) >> 2] = $1002;
                             HEAP32[($4 + 684 | 0) >> 2] = i64toi32_i32$3;
                             label$70 : {
                              if (!(HEAP32[($4 + 400 | 0) >> 2] | 0)) {
                               break label$70
                              }
                              $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($7 | 0);
                             }
                             i64toi32_i32$5 = $23;
                             i64toi32_i32$3 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                             i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                             $1011 = i64toi32_i32$3;
                             i64toi32_i32$3 = ($4 + 392 | 0) + 16 | 0;
                             HEAP32[i64toi32_i32$3 >> 2] = $1011;
                             HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                             i64toi32_i32$5 = $3;
                             i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                             i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                             $1016 = i64toi32_i32$2;
                             i64toi32_i32$2 = ($4 + 392 | 0) + 8 | 0;
                             HEAP32[i64toi32_i32$2 >> 2] = $1016;
                             HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                             i64toi32_i32$5 = $4;
                             i64toi32_i32$3 = HEAP32[($4 + 680 | 0) >> 2] | 0;
                             i64toi32_i32$2 = HEAP32[($4 + 684 | 0) >> 2] | 0;
                             $1019 = i64toi32_i32$3;
                             i64toi32_i32$3 = $4;
                             HEAP32[($4 + 392 | 0) >> 2] = $1019;
                             HEAP32[($4 + 396 | 0) >> 2] = i64toi32_i32$2;
                             label$71 : {
                              if (!(HEAP32[($4 + 872 | 0) >> 2] | 0)) {
                               break label$71
                              }
                              $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($9 | 0);
                             }
                             $6 = $6 + 4 | 0;
                             $27 = $27 + -4 | 0;
                             if (!$27) {
                              break label$62
                             }
                             continue label$67;
                            }
                            break label$67;
                           };
                           $3 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($4 + 716 | 0) >> 2] | 0 | 0) | 0;
                           if (!(HEAP32[($4 + 872 | 0) >> 2] | 0)) {
                            break label$35
                           }
                           $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($9 | 0);
                           break label$35;
                          }
                          core__panicking__panic__h2fd385a887c8bf13(1063668 | 0, 43 | 0, 1065024 | 0);
                          abort();
                         }
                         core__panicking__panic_bounds_check__h808b524af17640b1($3 | 0, $23 | 0, 1065040 | 0);
                         abort();
                        }
                        $3 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($4 + 716 | 0) >> 2] | 0 | 0) | 0;
                        break label$35;
                       }
                       $3 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($4 + 716 | 0) >> 2] | 0 | 0) | 0;
                       break label$35;
                      }
                      $21 = $21 + 128 | 0;
                      if (($21 | 0) != ($19 | 0)) {
                       continue label$61
                      }
                      break label$61;
                     };
                     label$72 : while (1) {
                      core__ptr__drop_in_place_cardano_serialization_lib__TransactionOutput___h632b3a99817e6ac5_1($2 | 0);
                      $2 = $2 + 128 | 0;
                      $20 = $20 + -128 | 0;
                      if ($20) {
                       continue label$72
                      }
                      break label$72;
                     };
                    }
                    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h5107e2b13c386680($4 + 648 | 0 | 0);
                    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h903e00ab7dfc505c($4 + 632 | 0 | 0);
                    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hb513c626355ab1b6($4 + 616 | 0 | 0);
                    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h515a508dccfbb69c($4 + 616 | 0 | 0);
                    $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h36ca092f81b9a0fa($4 + 288 | 0 | 0, $4 + 568 | 0 | 0);
                    $2 = HEAP32[($4 + 288 | 0) >> 2] | 0;
                    if (!$2) {
                     break label$31
                    }
                    continue label$32;
                   }
                   break label$32;
                  };
                  $1 = $17 << 7 | 0;
                  label$73 : while (1) {
                   core__ptr__drop_in_place_cardano_serialization_lib__TransactionOutput___h632b3a99817e6ac5_1($2 | 0);
                   $2 = $2 + 128 | 0;
                   $1 = $1 + -128 | 0;
                   if ($1) {
                    continue label$73
                   }
                   break label$73;
                  };
                  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h5107e2b13c386680($4 + 648 | 0 | 0);
                  $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h903e00ab7dfc505c($4 + 632 | 0 | 0);
                  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hb513c626355ab1b6($4 + 616 | 0 | 0);
                  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h515a508dccfbb69c($4 + 616 | 0 | 0);
                  $3 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($3 | 0) | 0;
                  $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($4 + 456 | 0 | 0);
                  break label$6;
                 }
                 $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h03cc330b7b1e4522($4 + 280 | 0 | 0, $4 + 504 | 0 | 0);
                 $3 = HEAP32[($4 + 284 | 0) >> 2] | 0;
                 $2 = HEAP32[($4 + 280 | 0) >> 2] | 0;
                 if ($2) {
                  continue label$30
                 }
                 break label$30;
                };
               }
               $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($4 + 456 | 0 | 0);
              }
              HEAP32[($4 + 440 | 0) >> 2] = $4 + 352 | 0;
              label$74 : {
               label$75 : {
                $2 = HEAP32[($4 + 428 | 0) >> 2] | 0;
                if (!$2) {
                 break label$75
                }
                $3 = HEAP32[($4 + 424 | 0) >> 2] | 0;
                alloc__collections__btree__navigate__full_range__hfcebc6cee2db4b73($4 + 712 | 0 | 0, $3 | 0, $2 | 0, $3 | 0, $2 | 0);
                $2 = HEAP32[($4 + 432 | 0) >> 2] | 0;
                break label$74;
               }
               $2 = 0;
               HEAP32[($4 + 728 | 0) >> 2] = 0;
               HEAP32[($4 + 716 | 0) >> 2] = 0;
              }
              HEAP32[(($4 + 864 | 0) + 24 | 0) >> 2] = $2;
              $3 = ($4 + 712 | 0) + 8 | 0;
              i64toi32_i32$5 = $3;
              i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
              i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
              $28 = i64toi32_i32$2;
              $28$hi = i64toi32_i32$3;
              i64toi32_i32$2 = ($4 + 864 | 0) + 8 | 0;
              HEAP32[i64toi32_i32$2 >> 2] = $28;
              HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
              $5 = ($4 + 712 | 0) + 16 | 0;
              i64toi32_i32$5 = $5;
              i64toi32_i32$3 = HEAP32[i64toi32_i32$5 >> 2] | 0;
              i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
              $29 = i64toi32_i32$3;
              $29$hi = i64toi32_i32$2;
              i64toi32_i32$3 = ($4 + 864 | 0) + 16 | 0;
              HEAP32[i64toi32_i32$3 >> 2] = $29;
              HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
              i64toi32_i32$5 = $4;
              i64toi32_i32$2 = HEAP32[($4 + 712 | 0) >> 2] | 0;
              i64toi32_i32$3 = HEAP32[($4 + 716 | 0) >> 2] | 0;
              $30 = i64toi32_i32$2;
              $30$hi = i64toi32_i32$3;
              i64toi32_i32$2 = $4;
              HEAP32[($4 + 864 | 0) >> 2] = $30;
              HEAP32[($4 + 868 | 0) >> 2] = i64toi32_i32$3;
              HEAP32[(($4 + 712 | 0) + 24 | 0) >> 2] = $2;
              i64toi32_i32$3 = $29$hi;
              i64toi32_i32$2 = $5;
              HEAP32[i64toi32_i32$2 >> 2] = $29;
              HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
              i64toi32_i32$3 = $28$hi;
              i64toi32_i32$2 = $3;
              HEAP32[$3 >> 2] = $28;
              HEAP32[($3 + 4 | 0) >> 2] = i64toi32_i32$3;
              i64toi32_i32$3 = $30$hi;
              i64toi32_i32$2 = $4;
              HEAP32[($4 + 712 | 0) >> 2] = $30;
              HEAP32[($4 + 716 | 0) >> 2] = i64toi32_i32$3;
              HEAP32[($4 + 744 | 0) >> 2] = $4 + 440 | 0;
              HEAP32[($4 + 740 | 0) >> 2] = $4 + 616 | 0;
              $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__h25f3281440c3e21a($4 + 472 | 0 | 0, $4 + 712 | 0 | 0);
              i64toi32_i32$2 = $4;
              i64toi32_i32$3 = 0;
              HEAP32[($4 + 508 | 0) >> 2] = 0;
              HEAP32[($4 + 512 | 0) >> 2] = i64toi32_i32$3;
              $2 = HEAP32[($1 + 424 | 0) >> 2] | 0;
              $3 = HEAP32[($1 + 416 | 0) >> 2] | 0;
              HEAP32[($4 + 712 | 0) >> 2] = $3;
              HEAP32[($4 + 716 | 0) >> 2] = $3 + ($2 << 7 | 0) | 0;
              HEAP32[($4 + 720 | 0) >> 2] = $4 + 616 | 0;
              $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__h739679d8ae9565cc($4 + 536 | 0 | 0, $4 + 712 | 0 | 0);
              $2 = HEAP32[($4 + 536 | 0) >> 2] | 0;
              $24 = HEAP32[($4 + 544 | 0) >> 2] | 0;
              HEAP32[($4 + 712 | 0) >> 2] = $4 + 616 | 0;
              alloc__slice__merge_sort__h6d9049cfeabc5e2d($2 | 0, $24 | 0, $4 + 712 | 0 | 0);
              label$76 : {
               label$77 : {
                label$78 : {
                 if (!$24) {
                  break label$78
                 }
                 $5 = ($4 + 864 | 0) + 89 | 0;
                 $12 = $4 + 936 | 0;
                 $22 = $4 + 680 | 0 | 4 | 0;
                 $25 = $2 + ($24 << 7 | 0) | 0;
                 $3 = $25;
                 label$79 : {
                  label$80 : {
                   label$81 : {
                    label$82 : while (1) {
                     $21 = $3 + -128 | 0;
                     label$83 : {
                      $14 = $3 + -64 | 0;
                      i64toi32_i32$5 = $14;
                      i64toi32_i32$3 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                      i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                      $30 = i64toi32_i32$3;
                      $30$hi = i64toi32_i32$2;
                      if (!(i64toi32_i32$3 | i64toi32_i32$2 | 0)) {
                       break label$83
                      }
                      $23 = $21 + 89 | 0;
                      $15 = $3 + -40 | 0;
                      $19 = $21 + 76 | 0;
                      $20 = $3 + -56 | 0;
                      i64toi32_i32$2 = 0;
                      $28 = 0;
                      $28$hi = i64toi32_i32$2;
                      label$84 : while (1) {
                       $3 = HEAP32[($4 + 480 | 0) >> 2] | 0;
                       if (!$3) {
                        break label$8
                       }
                       $3 = rand__rng__Rng__gen_range__he28987be934355f0($4 + 420 | 0 | 0, 0 | 0, $3 | 0) | 0;
                       $6 = HEAP32[($4 + 480 | 0) >> 2] | 0;
                       if ($6 >>> 0 <= $3 >>> 0) {
                        break label$76
                       }
                       $26 = HEAP32[($4 + 472 | 0) >> 2] | 0;
                       $3 = $26 + ($3 << 2 | 0) | 0;
                       $27 = HEAP32[$3 >> 2] | 0;
                       $6 = $6 + -1 | 0;
                       HEAP32[($4 + 480 | 0) >> 2] = $6;
                       HEAP32[$3 >> 2] = HEAP32[($26 + ($6 << 2 | 0) | 0) >> 2] | 0;
                       HEAP32[($4 + 664 | 0) >> 2] = $27;
                       alloc__collections__btree__map__BTreeMap_K_2cV___remove_entry__haaee74feca9cfb03($4 + 272 | 0 | 0, $4 + 424 | 0 | 0, $4 + 664 | 0 | 0);
                       $6 = HEAP32[($4 + 440 | 0) >> 2] | 0;
                       $26 = HEAP32[($6 + 8 | 0) >> 2] | 0;
                       $3 = HEAP32[($4 + 664 | 0) >> 2] | 0;
                       if ($26 >>> 0 <= $3 >>> 0) {
                        break label$77
                       }
                       i64toi32_i32$2 = $28$hi;
                       i64toi32_i32$5 = (HEAP32[$6 >> 2] | 0) + Math_imul($3, 168) | 0;
                       i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 64 | 0) >> 2] | 0;
                       i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 68 | 0) >> 2] | 0;
                       $1286 = i64toi32_i32$2;
                       $1286$hi = i64toi32_i32$3;
                       i64toi32_i32$3 = $28$hi;
                       i64toi32_i32$5 = $28;
                       i64toi32_i32$2 = $1286$hi;
                       i64toi32_i32$0 = $1286;
                       i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
                       i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
                       if (i64toi32_i32$1 >>> 0 < i64toi32_i32$0 >>> 0) {
                        i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
                       }
                       $29 = i64toi32_i32$1;
                       $29$hi = i64toi32_i32$4;
                       i64toi32_i32$4 = $28$hi;
                       i64toi32_i32$4 = $29$hi;
                       i64toi32_i32$3 = i64toi32_i32$1;
                       i64toi32_i32$5 = $28$hi;
                       i64toi32_i32$0 = $28;
                       if (i64toi32_i32$4 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$3 >>> 0 < i64toi32_i32$0 >>> 0 | 0) | 0) {
                        break label$81
                       }
                       $cardano_serialization_lib__address__Address_20as_20core__clone__Clone___clone__h0eb465a6e349d507_2($4 + 712 | 0 | 0, $21 | 0);
                       i64toi32_i32$0 = $14;
                       i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                       i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                       $28 = i64toi32_i32$3;
                       $28$hi = i64toi32_i32$4;
                       $3 = 0;
                       $6 = 0;
                       label$85 : {
                        if ((HEAP32[$20 >> 2] | 0 | 0) != (1 | 0)) {
                         break label$85
                        }
                        $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($22 | 0, $19 | 0);
                        $6 = 1;
                       }
                       $27 = ($4 + 568 | 0) + 8 | 0;
                       $26 = ($4 + 680 | 0) + 8 | 0;
                       i64toi32_i32$0 = $26;
                       i64toi32_i32$4 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                       i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                       $1309 = i64toi32_i32$4;
                       i64toi32_i32$4 = $27;
                       HEAP32[i64toi32_i32$4 >> 2] = $1309;
                       HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$3;
                       HEAP32[($4 + 680 | 0) >> 2] = $6;
                       i64toi32_i32$0 = $4;
                       i64toi32_i32$3 = HEAP32[($4 + 680 | 0) >> 2] | 0;
                       i64toi32_i32$4 = HEAP32[($4 + 684 | 0) >> 2] | 0;
                       $1314 = i64toi32_i32$3;
                       i64toi32_i32$3 = $4;
                       HEAP32[($4 + 568 | 0) >> 2] = $1314;
                       HEAP32[($4 + 572 | 0) >> 2] = i64toi32_i32$4;
                       label$86 : {
                        if ((HEAPU8[$15 >> 0] | 0 | 0) != (1 | 0)) {
                         break label$86
                        }
                        i64toi32_i32$0 = $23 + 24 | 0;
                        i64toi32_i32$4 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                        i64toi32_i32$3 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                        $1323 = i64toi32_i32$4;
                        i64toi32_i32$4 = ($4 + 680 | 0) + 24 | 0;
                        HEAP32[i64toi32_i32$4 >> 2] = $1323;
                        HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$3;
                        i64toi32_i32$0 = $23 + 16 | 0;
                        i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                        i64toi32_i32$4 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                        $1329 = i64toi32_i32$3;
                        i64toi32_i32$3 = ($4 + 680 | 0) + 16 | 0;
                        HEAP32[i64toi32_i32$3 >> 2] = $1329;
                        HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$4;
                        i64toi32_i32$0 = $23 + 8 | 0;
                        i64toi32_i32$4 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                        i64toi32_i32$3 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                        $1333 = i64toi32_i32$4;
                        i64toi32_i32$4 = $26;
                        HEAP32[i64toi32_i32$4 >> 2] = $1333;
                        HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$3;
                        i64toi32_i32$0 = $23;
                        i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                        i64toi32_i32$4 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                        $1336 = i64toi32_i32$3;
                        i64toi32_i32$3 = $4;
                        HEAP32[($4 + 680 | 0) >> 2] = $1336;
                        HEAP32[($4 + 684 | 0) >> 2] = i64toi32_i32$4;
                        $3 = 1;
                       }
                       memcpy($4 + 864 | 0 | 0, $4 + 712 | 0 | 0, 64 | 0) | 0;
                       i64toi32_i32$0 = $4;
                       i64toi32_i32$4 = HEAP32[($4 + 568 | 0) >> 2] | 0;
                       i64toi32_i32$3 = HEAP32[($4 + 572 | 0) >> 2] | 0;
                       $1344 = i64toi32_i32$4;
                       i64toi32_i32$4 = $12;
                       HEAP32[i64toi32_i32$4 >> 2] = $1344;
                       HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$3;
                       i64toi32_i32$0 = $27;
                       i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                       i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                       $1348 = i64toi32_i32$3;
                       i64toi32_i32$3 = $12 + 8 | 0;
                       HEAP32[i64toi32_i32$3 >> 2] = $1348;
                       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$4;
                       i64toi32_i32$0 = $4;
                       i64toi32_i32$4 = HEAP32[($4 + 680 | 0) >> 2] | 0;
                       i64toi32_i32$3 = HEAP32[($4 + 684 | 0) >> 2] | 0;
                       $1351 = i64toi32_i32$4;
                       i64toi32_i32$4 = $5;
                       $318 = $1351;
                       HEAP8[i64toi32_i32$4 >> 0] = $318;
                       HEAP8[(i64toi32_i32$4 + 1 | 0) >> 0] = $318 >>> 8 | 0;
                       HEAP8[(i64toi32_i32$4 + 2 | 0) >> 0] = $318 >>> 16 | 0;
                       HEAP8[(i64toi32_i32$4 + 3 | 0) >> 0] = $318 >>> 24 | 0;
                       HEAP8[(i64toi32_i32$4 + 4 | 0) >> 0] = i64toi32_i32$3;
                       HEAP8[(i64toi32_i32$4 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
                       HEAP8[(i64toi32_i32$4 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
                       HEAP8[(i64toi32_i32$4 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
                       i64toi32_i32$0 = $26;
                       i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                       i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                       $1355 = i64toi32_i32$3;
                       i64toi32_i32$3 = $5 + 8 | 0;
                       $320 = $1355;
                       HEAP8[i64toi32_i32$3 >> 0] = $320;
                       HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $320 >>> 8 | 0;
                       HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $320 >>> 16 | 0;
                       HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $320 >>> 24 | 0;
                       HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$4;
                       HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$4 >>> 8 | 0;
                       HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$4 >>> 16 | 0;
                       HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$4 >>> 24 | 0;
                       i64toi32_i32$0 = ($4 + 680 | 0) + 16 | 0;
                       i64toi32_i32$4 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                       i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                       $1361 = i64toi32_i32$4;
                       i64toi32_i32$4 = $5 + 16 | 0;
                       $321 = $1361;
                       HEAP8[i64toi32_i32$4 >> 0] = $321;
                       HEAP8[(i64toi32_i32$4 + 1 | 0) >> 0] = $321 >>> 8 | 0;
                       HEAP8[(i64toi32_i32$4 + 2 | 0) >> 0] = $321 >>> 16 | 0;
                       HEAP8[(i64toi32_i32$4 + 3 | 0) >> 0] = $321 >>> 24 | 0;
                       HEAP8[(i64toi32_i32$4 + 4 | 0) >> 0] = i64toi32_i32$3;
                       HEAP8[(i64toi32_i32$4 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
                       HEAP8[(i64toi32_i32$4 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
                       HEAP8[(i64toi32_i32$4 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
                       i64toi32_i32$0 = ($4 + 680 | 0) + 24 | 0;
                       i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                       i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                       $1367 = i64toi32_i32$3;
                       i64toi32_i32$3 = $5 + 24 | 0;
                       $322 = $1367;
                       HEAP8[i64toi32_i32$3 >> 0] = $322;
                       HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $322 >>> 8 | 0;
                       HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $322 >>> 16 | 0;
                       HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $322 >>> 24 | 0;
                       HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$4;
                       HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$4 >>> 8 | 0;
                       HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$4 >>> 16 | 0;
                       HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$4 >>> 24 | 0;
                       i64toi32_i32$4 = $28$hi;
                       i64toi32_i32$3 = $4;
                       HEAP32[($4 + 928 | 0) >> 2] = $28;
                       HEAP32[($4 + 932 | 0) >> 2] = i64toi32_i32$4;
                       HEAP8[($4 + 952 | 0) >> 0] = $3;
                       alloc__collections__btree__map__BTreeMap_K_2cV___entry__hf5f68610bd8a4a4c($4 + 712 | 0 | 0, $4 + 504 | 0 | 0, $4 + 864 | 0 | 0);
                       $3 = alloc__collections__btree__map__entry__Entry_K_2cV___or_default__h1c00ee87c8b7cd04($4 + 712 | 0 | 0) | 0;
                       $26 = HEAP32[($4 + 664 | 0) >> 2] | 0;
                       label$87 : {
                        $6 = HEAP32[($3 + 8 | 0) >> 2] | 0;
                        if (($6 | 0) != (HEAP32[($3 + 4 | 0) >> 2] | 0 | 0)) {
                         break label$87
                        }
                        alloc__vec__Vec_T_2cA___reserve__h71af5692fa531ae6($3 | 0, 1 | 0);
                        $6 = HEAP32[($3 + 8 | 0) >> 2] | 0;
                       }
                       HEAP32[((HEAP32[$3 >> 2] | 0) + ($6 << 2 | 0) | 0) >> 2] = $26;
                       HEAP32[($3 + 8 | 0) >> 2] = (HEAP32[($3 + 8 | 0) >> 2] | 0) + 1 | 0;
                       i64toi32_i32$4 = $29$hi;
                       $28 = $29;
                       $28$hi = i64toi32_i32$4;
                       i64toi32_i32$4 = $30$hi;
                       i64toi32_i32$4 = $28$hi;
                       i64toi32_i32$0 = $28;
                       i64toi32_i32$3 = $30$hi;
                       i64toi32_i32$5 = $30;
                       if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0 | 0) | 0) {
                        continue label$84
                       }
                       break label$84;
                      };
                     }
                     $3 = $21;
                     if (($2 | 0) != ($3 | 0)) {
                      continue label$82
                     }
                     break label$82;
                    };
                    if (!$24) {
                     break label$79
                    }
                    if (!(HEAP32[($4 + 480 | 0) >> 2] | 0)) {
                     break label$79
                    }
                    break label$80;
                   }
                   $3 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1058732 | 0, 8 | 0) | 0 | 0) | 0;
                   break label$7;
                  }
                  label$88 : while (1) {
                   label$89 : {
                    label$90 : {
                     label$91 : {
                      label$92 : {
                       label$93 : {
                        $3 = alloc__collections__btree__map__BTreeMap_K_2cV___get_mut__hd032fad84dac0c7f($4 + 504 | 0 | 0, $2 | 0) | 0;
                        if (!$3) {
                         break label$93
                        }
                        $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__DerefMut___deref_mut__h42fc515862cf6b48($4 + 264 | 0 | 0, $3 | 0);
                        $5 = HEAP32[($4 + 268 | 0) >> 2] | 0;
                        if (!$5) {
                         break label$89
                        }
                        $3 = HEAP32[($4 + 264 | 0) >> 2] | 0;
                        $26 = $5 << 2 | 0;
                        label$94 : while (1) {
                         $5 = rand__rng__Rng__gen_range__he28987be934355f0($4 + 420 | 0 | 0, 0 | 0, HEAP32[($4 + 480 | 0) >> 2] | 0 | 0) | 0;
                         $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__DerefMut___deref_mut__h42fc515862cf6b48($4 + 256 | 0 | 0, $4 + 472 | 0 | 0);
                         if ($5 >>> 0 >= (HEAP32[($4 + 260 | 0) >> 2] | 0) >>> 0) {
                          break label$92
                         }
                         $12 = HEAP32[($4 + 256 | 0) >> 2] | 0;
                         if (!$12) {
                          break label$92
                         }
                         $27 = HEAP32[($4 + 440 | 0) >> 2] | 0;
                         $23 = HEAP32[($27 + 8 | 0) >> 2] | 0;
                         $6 = HEAP32[$3 >> 2] | 0;
                         if ($23 >>> 0 <= $6 >>> 0) {
                          break label$91
                         }
                         $12 = $12 + ($5 << 2 | 0) | 0;
                         $5 = HEAP32[$12 >> 2] | 0;
                         if ($23 >>> 0 <= $5 >>> 0) {
                          break label$90
                         }
                         label$95 : {
                          $23 = HEAP32[$27 >> 2] | 0;
                          i64toi32_i32$5 = $23 + Math_imul($5, 168) | 0;
                          i64toi32_i32$0 = HEAP32[(i64toi32_i32$5 + 64 | 0) >> 2] | 0;
                          i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 68 | 0) >> 2] | 0;
                          $29 = i64toi32_i32$0;
                          $29$hi = i64toi32_i32$4;
                          i64toi32_i32$5 = $2;
                          i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 64 | 0) >> 2] | 0;
                          i64toi32_i32$0 = HEAP32[(i64toi32_i32$5 + 68 | 0) >> 2] | 0;
                          $28 = i64toi32_i32$4;
                          $28$hi = i64toi32_i32$0;
                          i64toi32_i32$4 = 0;
                          i64toi32_i32$4 = __wasm_i64_mul($28 | 0, i64toi32_i32$0 | 0, 3 | 0, i64toi32_i32$4 | 0) | 0;
                          i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
                          $1480 = i64toi32_i32$4;
                          $1480$hi = i64toi32_i32$0;
                          i64toi32_i32$0 = $29$hi;
                          i64toi32_i32$5 = $29;
                          i64toi32_i32$4 = $1480$hi;
                          i64toi32_i32$3 = $1480;
                          if (i64toi32_i32$0 >>> 0 > i64toi32_i32$4 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$4 | 0) & i64toi32_i32$5 >>> 0 >= i64toi32_i32$3 >>> 0 | 0) | 0) {
                           break label$95
                          }
                          i64toi32_i32$5 = $28$hi;
                          i64toi32_i32$3 = $28;
                          i64toi32_i32$0 = 0;
                          i64toi32_i32$4 = 1;
                          i64toi32_i32$2 = i64toi32_i32$4 & 31 | 0;
                          if (32 >>> 0 <= (i64toi32_i32$4 & 63 | 0) >>> 0) {
                           i64toi32_i32$0 = i64toi32_i32$3 << i64toi32_i32$2 | 0;
                           $339 = 0;
                          } else {
                           i64toi32_i32$0 = ((1 << i64toi32_i32$2 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$2 | 0) | 0) | 0 | (i64toi32_i32$5 << i64toi32_i32$2 | 0) | 0;
                           $339 = i64toi32_i32$3 << i64toi32_i32$2 | 0;
                          }
                          $28 = $339;
                          $28$hi = i64toi32_i32$0;
                          i64toi32_i32$0 = $29$hi;
                          i64toi32_i32$0 = $28$hi;
                          i64toi32_i32$5 = $28;
                          i64toi32_i32$3 = $29$hi;
                          i64toi32_i32$4 = $29;
                          i64toi32_i32$2 = i64toi32_i32$5 - i64toi32_i32$4 | 0;
                          i64toi32_i32$6 = i64toi32_i32$5 >>> 0 < i64toi32_i32$4 >>> 0;
                          i64toi32_i32$1 = i64toi32_i32$6 + i64toi32_i32$3 | 0;
                          i64toi32_i32$1 = i64toi32_i32$0 - i64toi32_i32$1 | 0;
                          $30 = i64toi32_i32$2;
                          $30$hi = i64toi32_i32$1;
                          i64toi32_i32$1 = 0;
                          i64toi32_i32$0 = 0;
                          i64toi32_i32$5 = $30$hi;
                          i64toi32_i32$4 = i64toi32_i32$2;
                          i64toi32_i32$3 = i64toi32_i32$0 - i64toi32_i32$4 | 0;
                          i64toi32_i32$6 = i64toi32_i32$0 >>> 0 < i64toi32_i32$4 >>> 0;
                          i64toi32_i32$2 = i64toi32_i32$6 + i64toi32_i32$5 | 0;
                          i64toi32_i32$2 = i64toi32_i32$1 - i64toi32_i32$2 | 0;
                          $1488 = i64toi32_i32$3;
                          $1488$hi = i64toi32_i32$2;
                          i64toi32_i32$2 = i64toi32_i32$5;
                          $1489 = i64toi32_i32$4;
                          $1489$hi = i64toi32_i32$5;
                          i64toi32_i32$2 = $28$hi;
                          i64toi32_i32$2 = $29$hi;
                          i64toi32_i32$2 = $28$hi;
                          i64toi32_i32$1 = $28;
                          i64toi32_i32$0 = $29$hi;
                          i64toi32_i32$4 = $29;
                          $1492 = i64toi32_i32$2 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$4 >>> 0 | 0) | 0;
                          i64toi32_i32$1 = 0;
                          $31 = $1492;
                          $31$hi = i64toi32_i32$1;
                          i64toi32_i32$1 = 0;
                          i64toi32_i32$4 = 0;
                          i64toi32_i32$2 = $31$hi;
                          i64toi32_i32$0 = $31;
                          i64toi32_i32$5 = i64toi32_i32$4 - i64toi32_i32$0 | 0;
                          i64toi32_i32$6 = i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0;
                          i64toi32_i32$3 = i64toi32_i32$6 + i64toi32_i32$2 | 0;
                          i64toi32_i32$3 = i64toi32_i32$1 - i64toi32_i32$3 | 0;
                          $32 = i64toi32_i32$5;
                          $32$hi = i64toi32_i32$3;
                          i64toi32_i32$1 = i64toi32_i32$5;
                          i64toi32_i32$4 = 0;
                          i64toi32_i32$0 = 0;
                          if ((i64toi32_i32$3 | 0) < (i64toi32_i32$4 | 0)) {
                           $340 = 1
                          } else {
                           if ((i64toi32_i32$3 | 0) <= (i64toi32_i32$4 | 0)) {
                            if (i64toi32_i32$1 >>> 0 >= i64toi32_i32$0 >>> 0) {
                             $341 = 0
                            } else {
                             $341 = 1
                            }
                            $342 = $341;
                           } else {
                            $342 = 0
                           }
                           $340 = $342;
                          }
                          $27 = $340;
                          i64toi32_i32$2 = $27;
                          i64toi32_i32$1 = $1488$hi;
                          i64toi32_i32$3 = $1489$hi;
                          i64toi32_i32$4 = i64toi32_i32$2 ? $1488 : $1489;
                          i64toi32_i32$0 = i64toi32_i32$2 ? i64toi32_i32$1 : i64toi32_i32$3;
                          $1499 = i64toi32_i32$4;
                          $1499$hi = i64toi32_i32$0;
                          i64toi32_i32$0 = $28$hi;
                          i64toi32_i32$2 = $23 + Math_imul($6, 168) | 0;
                          i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
                          i64toi32_i32$4 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
                          $33 = i64toi32_i32$0;
                          $33$hi = i64toi32_i32$4;
                          i64toi32_i32$4 = $28$hi;
                          i64toi32_i32$2 = $28;
                          i64toi32_i32$0 = $33$hi;
                          i64toi32_i32$1 = $33;
                          i64toi32_i32$3 = i64toi32_i32$2 - i64toi32_i32$1 | 0;
                          i64toi32_i32$6 = i64toi32_i32$2 >>> 0 < i64toi32_i32$1 >>> 0;
                          i64toi32_i32$5 = i64toi32_i32$6 + i64toi32_i32$0 | 0;
                          i64toi32_i32$5 = i64toi32_i32$4 - i64toi32_i32$5 | 0;
                          $29 = i64toi32_i32$3;
                          $29$hi = i64toi32_i32$5;
                          i64toi32_i32$5 = 0;
                          i64toi32_i32$4 = 0;
                          i64toi32_i32$2 = $29$hi;
                          i64toi32_i32$1 = i64toi32_i32$3;
                          i64toi32_i32$0 = i64toi32_i32$4 - i64toi32_i32$3 | 0;
                          i64toi32_i32$6 = i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0;
                          i64toi32_i32$3 = i64toi32_i32$6 + i64toi32_i32$2 | 0;
                          i64toi32_i32$3 = i64toi32_i32$5 - i64toi32_i32$3 | 0;
                          $1509 = i64toi32_i32$0;
                          $1509$hi = i64toi32_i32$3;
                          i64toi32_i32$3 = i64toi32_i32$2;
                          $1510 = i64toi32_i32$1;
                          $1510$hi = i64toi32_i32$3;
                          i64toi32_i32$3 = $28$hi;
                          i64toi32_i32$3 = $33$hi;
                          i64toi32_i32$3 = $28$hi;
                          i64toi32_i32$5 = $28;
                          i64toi32_i32$4 = $33$hi;
                          i64toi32_i32$1 = $33;
                          $1513 = i64toi32_i32$3 >>> 0 < i64toi32_i32$4 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$4 | 0) & i64toi32_i32$5 >>> 0 < i64toi32_i32$1 >>> 0 | 0) | 0;
                          i64toi32_i32$5 = 0;
                          $28 = $1513;
                          $28$hi = i64toi32_i32$5;
                          i64toi32_i32$5 = 0;
                          i64toi32_i32$1 = 0;
                          i64toi32_i32$3 = $28$hi;
                          i64toi32_i32$4 = $28;
                          i64toi32_i32$2 = i64toi32_i32$1 - i64toi32_i32$4 | 0;
                          i64toi32_i32$6 = i64toi32_i32$1 >>> 0 < i64toi32_i32$4 >>> 0;
                          i64toi32_i32$0 = i64toi32_i32$6 + i64toi32_i32$3 | 0;
                          i64toi32_i32$0 = i64toi32_i32$5 - i64toi32_i32$0 | 0;
                          $33 = i64toi32_i32$2;
                          $33$hi = i64toi32_i32$0;
                          i64toi32_i32$5 = i64toi32_i32$2;
                          i64toi32_i32$1 = 0;
                          i64toi32_i32$4 = 0;
                          if ((i64toi32_i32$0 | 0) < (i64toi32_i32$1 | 0)) {
                           $343 = 1
                          } else {
                           if ((i64toi32_i32$0 | 0) <= (i64toi32_i32$1 | 0)) {
                            if (i64toi32_i32$5 >>> 0 >= i64toi32_i32$4 >>> 0) {
                             $344 = 0
                            } else {
                             $344 = 1
                            }
                            $345 = $344;
                           } else {
                            $345 = 0
                           }
                           $343 = $345;
                          }
                          $23 = $343;
                          i64toi32_i32$3 = $23;
                          i64toi32_i32$5 = $1509$hi;
                          i64toi32_i32$0 = $1510$hi;
                          i64toi32_i32$1 = i64toi32_i32$3 ? $1509 : $1510;
                          i64toi32_i32$4 = i64toi32_i32$3 ? i64toi32_i32$5 : i64toi32_i32$0;
                          $1520 = i64toi32_i32$1;
                          $1520$hi = i64toi32_i32$4;
                          i64toi32_i32$4 = $1499$hi;
                          i64toi32_i32$3 = $1499;
                          i64toi32_i32$1 = $1520$hi;
                          i64toi32_i32$5 = $1520;
                          $1521 = i64toi32_i32$4 >>> 0 > i64toi32_i32$1 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$3 >>> 0 >= i64toi32_i32$5 >>> 0 | 0) | 0;
                          i64toi32_i32$3 = $31$hi;
                          i64toi32_i32$3 = $30$hi;
                          i64toi32_i32$5 = $30;
                          i64toi32_i32$4 = 0;
                          i64toi32_i32$1 = 0;
                          $1524 = (i64toi32_i32$5 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$3 | 0) != (i64toi32_i32$4 | 0) | 0;
                          i64toi32_i32$5 = 0;
                          $1525$hi = i64toi32_i32$5;
                          i64toi32_i32$5 = $31$hi;
                          i64toi32_i32$1 = $31;
                          i64toi32_i32$3 = $1525$hi;
                          i64toi32_i32$4 = $1524;
                          i64toi32_i32$0 = i64toi32_i32$1 - i64toi32_i32$4 | 0;
                          i64toi32_i32$6 = i64toi32_i32$1 >>> 0 < i64toi32_i32$4 >>> 0;
                          i64toi32_i32$2 = i64toi32_i32$6 + i64toi32_i32$3 | 0;
                          i64toi32_i32$2 = i64toi32_i32$5 - i64toi32_i32$2 | 0;
                          $1526$hi = i64toi32_i32$2;
                          i64toi32_i32$2 = $32$hi;
                          i64toi32_i32$3 = $27;
                          i64toi32_i32$2 = $1526$hi;
                          i64toi32_i32$1 = $32$hi;
                          i64toi32_i32$4 = i64toi32_i32$3 ? i64toi32_i32$0 : $32;
                          i64toi32_i32$5 = i64toi32_i32$3 ? i64toi32_i32$2 : i64toi32_i32$1;
                          $30 = i64toi32_i32$4;
                          $30$hi = i64toi32_i32$5;
                          i64toi32_i32$5 = $28$hi;
                          i64toi32_i32$5 = $29$hi;
                          i64toi32_i32$3 = $29;
                          i64toi32_i32$4 = 0;
                          i64toi32_i32$2 = 0;
                          $1533 = (i64toi32_i32$3 | 0) != (i64toi32_i32$2 | 0) | (i64toi32_i32$5 | 0) != (i64toi32_i32$4 | 0) | 0;
                          i64toi32_i32$3 = 0;
                          $1534$hi = i64toi32_i32$3;
                          i64toi32_i32$3 = $28$hi;
                          i64toi32_i32$2 = $28;
                          i64toi32_i32$5 = $1534$hi;
                          i64toi32_i32$4 = $1533;
                          i64toi32_i32$1 = i64toi32_i32$2 - i64toi32_i32$4 | 0;
                          i64toi32_i32$6 = i64toi32_i32$2 >>> 0 < i64toi32_i32$4 >>> 0;
                          i64toi32_i32$0 = i64toi32_i32$6 + i64toi32_i32$5 | 0;
                          i64toi32_i32$0 = i64toi32_i32$3 - i64toi32_i32$0 | 0;
                          $1535$hi = i64toi32_i32$0;
                          i64toi32_i32$0 = $33$hi;
                          i64toi32_i32$5 = $23;
                          i64toi32_i32$0 = $1535$hi;
                          i64toi32_i32$2 = $33$hi;
                          i64toi32_i32$4 = i64toi32_i32$5 ? i64toi32_i32$1 : $33;
                          i64toi32_i32$3 = i64toi32_i32$5 ? i64toi32_i32$0 : i64toi32_i32$2;
                          $28 = i64toi32_i32$4;
                          $28$hi = i64toi32_i32$3;
                          i64toi32_i32$3 = $30$hi;
                          i64toi32_i32$5 = $30;
                          i64toi32_i32$4 = $28$hi;
                          i64toi32_i32$0 = $28;
                          if ((i64toi32_i32$3 | 0) > (i64toi32_i32$4 | 0)) {
                           $346 = 1
                          } else {
                           if ((i64toi32_i32$3 | 0) >= (i64toi32_i32$4 | 0)) {
                            if (i64toi32_i32$5 >>> 0 < i64toi32_i32$0 >>> 0) {
                             $347 = 0
                            } else {
                             $347 = 1
                            }
                            $348 = $347;
                           } else {
                            $348 = 0
                           }
                           $346 = $348;
                          }
                          i64toi32_i32$5 = $30$hi;
                          i64toi32_i32$5 = $28$hi;
                          i64toi32_i32$5 = $30$hi;
                          i64toi32_i32$0 = $30;
                          i64toi32_i32$3 = $28$hi;
                          i64toi32_i32$4 = $28;
                          if ((i64toi32_i32$0 | 0) == (i64toi32_i32$4 | 0) & (i64toi32_i32$5 | 0) == (i64toi32_i32$3 | 0) | 0 ? $1521 : $346) {
                           break label$95
                          }
                          HEAP32[$12 >> 2] = $6;
                          HEAP32[$3 >> 2] = $5;
                          alloc__collections__btree__map__BTreeMap_K_2cV___insert__h358bbc5e89c1a147($4 + 424 | 0 | 0, HEAP32[$3 >> 2] | 0 | 0) | 0;
                          alloc__collections__btree__map__BTreeMap_K_2cV___remove_entry__haaee74feca9cfb03($4 + 248 | 0 | 0, $4 + 424 | 0 | 0, $12 | 0);
                         }
                         $3 = $3 + 4 | 0;
                         $26 = $26 + -4 | 0;
                         if (!$26) {
                          break label$89
                         }
                         continue label$94;
                        };
                       }
                       core__panicking__panic__h2fd385a887c8bf13(1063668 | 0, 43 | 0, 1064960 | 0);
                       abort();
                      }
                      core__panicking__panic__h2fd385a887c8bf13(1063668 | 0, 43 | 0, 1064976 | 0);
                      abort();
                     }
                     core__panicking__panic_bounds_check__h808b524af17640b1($6 | 0, $23 | 0, 1064992 | 0);
                     abort();
                    }
                    core__panicking__panic_bounds_check__h808b524af17640b1($5 | 0, $23 | 0, 1065008 | 0);
                    abort();
                   }
                   $2 = $2 + 128 | 0;
                   if (($2 | 0) != ($25 | 0)) {
                    continue label$88
                   }
                   break label$88;
                  };
                  $24 = HEAP32[($4 + 544 | 0) >> 2] | 0;
                  $2 = HEAP32[($4 + 536 | 0) >> 2] | 0;
                 }
                 if (!$24) {
                  break label$78
                 }
                 $22 = $2 + ($24 << 7 | 0) | 0;
                 $21 = $1 + 96 | 0;
                 $14 = ($4 + 864 | 0) + 12 | 0;
                 $20 = ($4 + 392 | 0) + 12 | 0;
                 $5 = ($4 + 712 | 0) + 8 | 0;
                 $15 = ($4 + 368 | 0) + 12 | 0;
                 $19 = $2;
                 label$96 : while (1) {
                  label$97 : {
                   label$98 : {
                    label$99 : {
                     label$100 : {
                      label$101 : {
                       $3 = alloc__collections__btree__map__BTreeMap_K_2cV___get__h46e97faa3debbf61($4 + 504 | 0 | 0, $19 | 0) | 0;
                       if (!$3) {
                        break label$101
                       }
                       $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h0f0d6987a7f36efc($4 + 240 | 0 | 0, $3 | 0);
                       $3 = HEAP32[($4 + 244 | 0) >> 2] | 0;
                       if (!$3) {
                        break label$97
                       }
                       $6 = HEAP32[($4 + 240 | 0) >> 2] | 0;
                       $12 = $3 << 2 | 0;
                       label$102 : while (1) {
                        $26 = HEAP32[($4 + 440 | 0) >> 2] | 0;
                        $23 = HEAP32[($26 + 8 | 0) >> 2] | 0;
                        $3 = HEAP32[$6 >> 2] | 0;
                        if ($23 >>> 0 <= $3 >>> 0) {
                         break label$100
                        }
                        $3 = (HEAP32[$26 >> 2] | 0) + Math_imul($3, 168) | 0;
                        $23 = $3 + 128 | 0;
                        $26 = $3 + 64 | 0;
                        cardano_serialization_lib__tx_builder__TransactionBuilder__fee_for_input__ha5a0f735cbb9ab50($4 + 712 | 0 | 0, $1 | 0, $3 | 0, $23 | 0, $26 | 0);
                        if ((HEAP32[($4 + 712 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                         break label$99
                        }
                        i64toi32_i32$4 = $4;
                        i64toi32_i32$0 = HEAP32[($4 + 720 | 0) >> 2] | 0;
                        i64toi32_i32$5 = HEAP32[($4 + 724 | 0) >> 2] | 0;
                        $28 = i64toi32_i32$0;
                        $28$hi = i64toi32_i32$5;
                        cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__add_input__hd22960e5a7d88824($21 | 0, $3 | 0, $23 | 0, $26 | 0);
                        cardano_serialization_lib__utils__Value__checked_add__h5184687782847801($4 + 712 | 0 | 0, $4 + 368 | 0 | 0, $26 | 0);
                        if ((HEAP32[($4 + 712 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                         break label$98
                        }
                        $3 = ($4 + 864 | 0) + 16 | 0;
                        $23 = $5 + 16 | 0;
                        i64toi32_i32$4 = $23;
                        i64toi32_i32$5 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                        i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                        $1664 = i64toi32_i32$5;
                        i64toi32_i32$5 = $3;
                        HEAP32[i64toi32_i32$5 >> 2] = $1664;
                        HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
                        $26 = ($4 + 864 | 0) + 8 | 0;
                        $27 = $5 + 8 | 0;
                        i64toi32_i32$4 = $27;
                        i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                        i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                        $1672 = i64toi32_i32$0;
                        i64toi32_i32$0 = $26;
                        HEAP32[i64toi32_i32$0 >> 2] = $1672;
                        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$5;
                        i64toi32_i32$4 = $5;
                        i64toi32_i32$5 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                        i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                        $1675 = i64toi32_i32$5;
                        i64toi32_i32$5 = $4;
                        HEAP32[($4 + 864 | 0) >> 2] = $1675;
                        HEAP32[($4 + 868 | 0) >> 2] = i64toi32_i32$0;
                        label$103 : {
                         if (!(HEAP32[($4 + 376 | 0) >> 2] | 0)) {
                          break label$103
                         }
                         $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($15 | 0);
                        }
                        i64toi32_i32$4 = $3;
                        i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                        i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                        $1684 = i64toi32_i32$0;
                        i64toi32_i32$0 = ($4 + 368 | 0) + 16 | 0;
                        HEAP32[i64toi32_i32$0 >> 2] = $1684;
                        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$5;
                        i64toi32_i32$4 = $26;
                        i64toi32_i32$5 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                        i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                        $1689 = i64toi32_i32$5;
                        i64toi32_i32$5 = ($4 + 368 | 0) + 8 | 0;
                        HEAP32[i64toi32_i32$5 >> 2] = $1689;
                        HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
                        i64toi32_i32$4 = $4;
                        i64toi32_i32$0 = HEAP32[($4 + 864 | 0) >> 2] | 0;
                        i64toi32_i32$5 = HEAP32[($4 + 868 | 0) >> 2] | 0;
                        $1692 = i64toi32_i32$0;
                        i64toi32_i32$0 = $4;
                        HEAP32[($4 + 368 | 0) >> 2] = $1692;
                        HEAP32[($4 + 372 | 0) >> 2] = i64toi32_i32$5;
                        HEAP32[($4 + 872 | 0) >> 2] = 0;
                        i64toi32_i32$5 = $28$hi;
                        i64toi32_i32$0 = $4;
                        HEAP32[($4 + 864 | 0) >> 2] = $28;
                        HEAP32[($4 + 868 | 0) >> 2] = i64toi32_i32$5;
                        cardano_serialization_lib__utils__Value__checked_add__h5184687782847801($4 + 712 | 0 | 0, $4 + 392 | 0 | 0, $4 + 864 | 0 | 0);
                        label$104 : {
                         if ((HEAP32[($4 + 712 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                          break label$104
                         }
                         $3 = ($4 + 680 | 0) + 16 | 0;
                         i64toi32_i32$4 = $23;
                         i64toi32_i32$5 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                         i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                         $1710 = i64toi32_i32$5;
                         i64toi32_i32$5 = $3;
                         HEAP32[i64toi32_i32$5 >> 2] = $1710;
                         HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
                         $26 = ($4 + 680 | 0) + 8 | 0;
                         i64toi32_i32$4 = $27;
                         i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                         i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                         $1716 = i64toi32_i32$0;
                         i64toi32_i32$0 = $26;
                         HEAP32[i64toi32_i32$0 >> 2] = $1716;
                         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$5;
                         i64toi32_i32$4 = $5;
                         i64toi32_i32$5 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                         i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                         $1719 = i64toi32_i32$5;
                         i64toi32_i32$5 = $4;
                         HEAP32[($4 + 680 | 0) >> 2] = $1719;
                         HEAP32[($4 + 684 | 0) >> 2] = i64toi32_i32$0;
                         label$105 : {
                          if (!(HEAP32[($4 + 400 | 0) >> 2] | 0)) {
                           break label$105
                          }
                          $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($20 | 0);
                         }
                         i64toi32_i32$4 = $3;
                         i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                         i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                         $1728 = i64toi32_i32$0;
                         i64toi32_i32$0 = ($4 + 392 | 0) + 16 | 0;
                         HEAP32[i64toi32_i32$0 >> 2] = $1728;
                         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$5;
                         i64toi32_i32$4 = $26;
                         i64toi32_i32$5 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                         i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                         $1733 = i64toi32_i32$5;
                         i64toi32_i32$5 = ($4 + 392 | 0) + 8 | 0;
                         HEAP32[i64toi32_i32$5 >> 2] = $1733;
                         HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
                         i64toi32_i32$4 = $4;
                         i64toi32_i32$0 = HEAP32[($4 + 680 | 0) >> 2] | 0;
                         i64toi32_i32$5 = HEAP32[($4 + 684 | 0) >> 2] | 0;
                         $1736 = i64toi32_i32$0;
                         i64toi32_i32$0 = $4;
                         HEAP32[($4 + 392 | 0) >> 2] = $1736;
                         HEAP32[($4 + 396 | 0) >> 2] = i64toi32_i32$5;
                         label$106 : {
                          if (!(HEAP32[($4 + 872 | 0) >> 2] | 0)) {
                           break label$106
                          }
                          $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($14 | 0);
                         }
                         $6 = $6 + 4 | 0;
                         $12 = $12 + -4 | 0;
                         if (!$12) {
                          break label$97
                         }
                         continue label$102;
                        }
                        break label$102;
                       };
                       $3 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($4 + 716 | 0) >> 2] | 0 | 0) | 0;
                       if (!(HEAP32[($4 + 872 | 0) >> 2] | 0)) {
                        break label$7
                       }
                       $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($14 | 0);
                       break label$7;
                      }
                      core__panicking__panic__h2fd385a887c8bf13(1063668 | 0, 43 | 0, 1065024 | 0);
                      abort();
                     }
                     core__panicking__panic_bounds_check__h808b524af17640b1($3 | 0, $23 | 0, 1065040 | 0);
                     abort();
                    }
                    $3 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($4 + 716 | 0) >> 2] | 0 | 0) | 0;
                    break label$7;
                   }
                   $3 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($4 + 716 | 0) >> 2] | 0 | 0) | 0;
                   break label$7;
                  }
                  $19 = $19 + 128 | 0;
                  if (($19 | 0) != ($22 | 0)) {
                   continue label$96
                  }
                  break label$96;
                 };
                 $3 = $24 << 7 | 0;
                 label$107 : while (1) {
                  core__ptr__drop_in_place_cardano_serialization_lib__TransactionOutput___h632b3a99817e6ac5_1($2 | 0);
                  $2 = $2 + 128 | 0;
                  $3 = $3 + -128 | 0;
                  if ($3) {
                   continue label$107
                  }
                  break label$107;
                 };
                }
                $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h5107e2b13c386680($4 + 536 | 0 | 0);
                $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h903e00ab7dfc505c($4 + 504 | 0 | 0);
                $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hb513c626355ab1b6($4 + 472 | 0 | 0);
                $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h515a508dccfbb69c($4 + 472 | 0 | 0);
                label$108 : {
                 label$109 : {
                  label$110 : {
                   label$111 : {
                    label$112 : {
                     label$113 : {
                      label$114 : {
                       label$115 : {
                        i64toi32_i32$4 = $4;
                        i64toi32_i32$5 = HEAP32[($4 + 368 | 0) >> 2] | 0;
                        i64toi32_i32$0 = HEAP32[($4 + 372 | 0) >> 2] | 0;
                        $1784 = i64toi32_i32$5;
                        $1784$hi = i64toi32_i32$0;
                        i64toi32_i32$4 = $4;
                        i64toi32_i32$0 = HEAP32[($4 + 392 | 0) >> 2] | 0;
                        i64toi32_i32$5 = HEAP32[($4 + 396 | 0) >> 2] | 0;
                        $1786 = i64toi32_i32$0;
                        $1786$hi = i64toi32_i32$5;
                        i64toi32_i32$5 = $1784$hi;
                        i64toi32_i32$4 = $1784;
                        i64toi32_i32$0 = $1786$hi;
                        i64toi32_i32$3 = $1786;
                        if (i64toi32_i32$5 >>> 0 > i64toi32_i32$0 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$4 >>> 0 >= i64toi32_i32$3 >>> 0 | 0) | 0) {
                         break label$115
                        }
                        $23 = $1 + 96 | 0;
                        $12 = ($4 + 864 | 0) + 12 | 0;
                        $21 = ($4 + 392 | 0) + 12 | 0;
                        $5 = ($4 + 712 | 0) + 8 | 0;
                        $27 = ($4 + 368 | 0) + 12 | 0;
                        label$116 : while (1) {
                         $2 = HEAP32[($4 + 432 | 0) >> 2] | 0;
                         if (!$2) {
                          break label$110
                         }
                         label$117 : {
                          label$118 : {
                           $3 = HEAP32[($4 + 428 | 0) >> 2] | 0;
                           if (!$3) {
                            break label$118
                           }
                           $6 = HEAP32[($4 + 424 | 0) >> 2] | 0;
                           alloc__collections__btree__navigate__full_range__hfcebc6cee2db4b73($4 + 712 | 0 | 0, $6 | 0, $3 | 0, $6 | 0, $3 | 0);
                           $3 = HEAP32[($4 + 432 | 0) >> 2] | 0;
                           break label$117;
                          }
                          HEAP32[($4 + 728 | 0) >> 2] = 0;
                          HEAP32[($4 + 716 | 0) >> 2] = 0;
                          $3 = $2;
                          $2 = 0;
                         }
                         HEAP32[($4 + 736 | 0) >> 2] = $2;
                         label$119 : {
                          $3 = rand__rng__Rng__gen_range__he28987be934355f0($4 + 420 | 0 | 0, 0 | 0, $3 | 0) | 0;
                          if (!$3) {
                           break label$119
                          }
                          $2 = 0;
                          label$120 : while (1) {
                           $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h1af0b182f7766c68($4 + 232 | 0 | 0, $4 + 712 | 0 | 0);
                           if (!(HEAP32[($4 + 232 | 0) >> 2] | 0)) {
                            break label$113
                           }
                           $2 = $2 + 1 | 0;
                           if (($3 | 0) != ($2 | 0)) {
                            continue label$120
                           }
                           break label$120;
                          };
                         }
                         $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h1af0b182f7766c68($4 + 224 | 0 | 0, $4 + 712 | 0 | 0);
                         $2 = HEAP32[($4 + 224 | 0) >> 2] | 0;
                         if (!$2) {
                          break label$112
                         }
                         HEAP32[($4 + 568 | 0) >> 2] = HEAP32[$2 >> 2] | 0;
                         alloc__collections__btree__map__BTreeMap_K_2cV___remove_entry__haaee74feca9cfb03($4 + 216 | 0 | 0, $4 + 424 | 0 | 0, $4 + 568 | 0 | 0);
                         $3 = HEAP32[($4 + 360 | 0) >> 2] | 0;
                         $2 = HEAP32[($4 + 568 | 0) >> 2] | 0;
                         if ($3 >>> 0 <= $2 >>> 0) {
                          break label$111
                         }
                         $2 = (HEAP32[($4 + 352 | 0) >> 2] | 0) + Math_imul($2, 168) | 0;
                         $6 = $2 + 128 | 0;
                         $3 = $2 + 64 | 0;
                         cardano_serialization_lib__tx_builder__TransactionBuilder__fee_for_input__ha5a0f735cbb9ab50($4 + 712 | 0 | 0, $1 | 0, $2 | 0, $6 | 0, $3 | 0);
                         if ((HEAP32[($4 + 712 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                          break label$109
                         }
                         i64toi32_i32$3 = $4;
                         i64toi32_i32$4 = HEAP32[($4 + 720 | 0) >> 2] | 0;
                         i64toi32_i32$5 = HEAP32[($4 + 724 | 0) >> 2] | 0;
                         $28 = i64toi32_i32$4;
                         $28$hi = i64toi32_i32$5;
                         cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__add_input__hd22960e5a7d88824($23 | 0, $2 | 0, $6 | 0, $3 | 0);
                         cardano_serialization_lib__utils__Value__checked_add__h5184687782847801($4 + 712 | 0 | 0, $4 + 368 | 0 | 0, $3 | 0);
                         if ((HEAP32[($4 + 712 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                          break label$108
                         }
                         $2 = ($4 + 864 | 0) + 16 | 0;
                         $6 = $5 + 16 | 0;
                         i64toi32_i32$3 = $6;
                         i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                         i64toi32_i32$4 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                         $1906 = i64toi32_i32$5;
                         i64toi32_i32$5 = $2;
                         HEAP32[i64toi32_i32$5 >> 2] = $1906;
                         HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$4;
                         $3 = ($4 + 864 | 0) + 8 | 0;
                         $26 = $5 + 8 | 0;
                         i64toi32_i32$3 = $26;
                         i64toi32_i32$4 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                         i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                         $1914 = i64toi32_i32$4;
                         i64toi32_i32$4 = $3;
                         HEAP32[i64toi32_i32$4 >> 2] = $1914;
                         HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
                         i64toi32_i32$3 = $5;
                         i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                         i64toi32_i32$4 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                         $1917 = i64toi32_i32$5;
                         i64toi32_i32$5 = $4;
                         HEAP32[($4 + 864 | 0) >> 2] = $1917;
                         HEAP32[($4 + 868 | 0) >> 2] = i64toi32_i32$4;
                         label$121 : {
                          if (!(HEAP32[($4 + 376 | 0) >> 2] | 0)) {
                           break label$121
                          }
                          $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($27 | 0);
                         }
                         i64toi32_i32$3 = $2;
                         i64toi32_i32$4 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                         i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                         $1926 = i64toi32_i32$4;
                         i64toi32_i32$4 = ($4 + 368 | 0) + 16 | 0;
                         HEAP32[i64toi32_i32$4 >> 2] = $1926;
                         HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
                         i64toi32_i32$3 = $3;
                         i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                         i64toi32_i32$4 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                         $1931 = i64toi32_i32$5;
                         i64toi32_i32$5 = ($4 + 368 | 0) + 8 | 0;
                         HEAP32[i64toi32_i32$5 >> 2] = $1931;
                         HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$4;
                         i64toi32_i32$3 = $4;
                         i64toi32_i32$4 = HEAP32[($4 + 864 | 0) >> 2] | 0;
                         i64toi32_i32$5 = HEAP32[($4 + 868 | 0) >> 2] | 0;
                         $1934 = i64toi32_i32$4;
                         i64toi32_i32$4 = $4;
                         HEAP32[($4 + 368 | 0) >> 2] = $1934;
                         HEAP32[($4 + 372 | 0) >> 2] = i64toi32_i32$5;
                         HEAP32[($4 + 872 | 0) >> 2] = 0;
                         i64toi32_i32$5 = $28$hi;
                         i64toi32_i32$4 = $4;
                         HEAP32[($4 + 864 | 0) >> 2] = $28;
                         HEAP32[($4 + 868 | 0) >> 2] = i64toi32_i32$5;
                         cardano_serialization_lib__utils__Value__checked_add__h5184687782847801($4 + 712 | 0 | 0, $4 + 392 | 0 | 0, $4 + 864 | 0 | 0);
                         if ((HEAP32[($4 + 712 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                          break label$114
                         }
                         $2 = ($4 + 680 | 0) + 16 | 0;
                         i64toi32_i32$3 = $6;
                         i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                         i64toi32_i32$4 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                         $1952 = i64toi32_i32$5;
                         i64toi32_i32$5 = $2;
                         HEAP32[i64toi32_i32$5 >> 2] = $1952;
                         HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$4;
                         $3 = ($4 + 680 | 0) + 8 | 0;
                         i64toi32_i32$3 = $26;
                         i64toi32_i32$4 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                         i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                         $1958 = i64toi32_i32$4;
                         i64toi32_i32$4 = $3;
                         HEAP32[i64toi32_i32$4 >> 2] = $1958;
                         HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
                         i64toi32_i32$3 = $5;
                         i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                         i64toi32_i32$4 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                         $1961 = i64toi32_i32$5;
                         i64toi32_i32$5 = $4;
                         HEAP32[($4 + 680 | 0) >> 2] = $1961;
                         HEAP32[($4 + 684 | 0) >> 2] = i64toi32_i32$4;
                         label$122 : {
                          if (!(HEAP32[($4 + 400 | 0) >> 2] | 0)) {
                           break label$122
                          }
                          $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($21 | 0);
                         }
                         i64toi32_i32$3 = $2;
                         i64toi32_i32$4 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                         i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                         $1970 = i64toi32_i32$4;
                         i64toi32_i32$4 = ($4 + 392 | 0) + 16 | 0;
                         HEAP32[i64toi32_i32$4 >> 2] = $1970;
                         HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
                         i64toi32_i32$3 = $3;
                         i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                         i64toi32_i32$4 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                         $1975 = i64toi32_i32$5;
                         i64toi32_i32$5 = ($4 + 392 | 0) + 8 | 0;
                         HEAP32[i64toi32_i32$5 >> 2] = $1975;
                         HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$4;
                         i64toi32_i32$3 = $4;
                         i64toi32_i32$4 = HEAP32[($4 + 680 | 0) >> 2] | 0;
                         i64toi32_i32$5 = HEAP32[($4 + 684 | 0) >> 2] | 0;
                         $1978 = i64toi32_i32$4;
                         i64toi32_i32$4 = $4;
                         HEAP32[($4 + 392 | 0) >> 2] = $1978;
                         HEAP32[($4 + 396 | 0) >> 2] = i64toi32_i32$5;
                         label$123 : {
                          if (!(HEAP32[($4 + 872 | 0) >> 2] | 0)) {
                           break label$123
                          }
                          $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($12 | 0);
                         }
                         i64toi32_i32$3 = $4;
                         i64toi32_i32$5 = HEAP32[($4 + 368 | 0) >> 2] | 0;
                         i64toi32_i32$4 = HEAP32[($4 + 372 | 0) >> 2] | 0;
                         $1984 = i64toi32_i32$5;
                         $1984$hi = i64toi32_i32$4;
                         i64toi32_i32$3 = $4;
                         i64toi32_i32$4 = HEAP32[($4 + 392 | 0) >> 2] | 0;
                         i64toi32_i32$5 = HEAP32[($4 + 396 | 0) >> 2] | 0;
                         $1986 = i64toi32_i32$4;
                         $1986$hi = i64toi32_i32$5;
                         i64toi32_i32$5 = $1984$hi;
                         i64toi32_i32$3 = $1984;
                         i64toi32_i32$4 = $1986$hi;
                         i64toi32_i32$0 = $1986;
                         if (i64toi32_i32$5 >>> 0 < i64toi32_i32$4 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$4 | 0) & i64toi32_i32$3 >>> 0 < i64toi32_i32$0 >>> 0 | 0) | 0) {
                          continue label$116
                         }
                         break label$116;
                        };
                       }
                       $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h6e0c34e8fa561cb7($4 + 424 | 0 | 0);
                       $alloc__rc__Rc_T__20as_20core__ops__drop__Drop___drop__h9c6f1ce9a80847e3($4 + 420 | 0 | 0);
                       break label$9;
                      }
                      $3 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($4 + 716 | 0) >> 2] | 0 | 0) | 0;
                      if (!(HEAP32[($4 + 872 | 0) >> 2] | 0)) {
                       break label$6
                      }
                      $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($12 | 0);
                      break label$6;
                     }
                     $T_20as_20core__convert__From_T____from__h09bdeba94dd58819($2 | 0) | 0;
                    }
                    core__panicking__panic__h2fd385a887c8bf13(1063668 | 0, 43 | 0, 1064536 | 0);
                    abort();
                   }
                   core__panicking__panic_bounds_check__h808b524af17640b1($2 | 0, $3 | 0, 1064552 | 0);
                   abort();
                  }
                  $3 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1064505 | 0, 28 | 0) | 0;
                  break label$6;
                 }
                 $3 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($4 + 716 | 0) >> 2] | 0 | 0) | 0;
                 break label$6;
                }
                $3 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($4 + 716 | 0) >> 2] | 0 | 0) | 0;
                break label$6;
               }
               core__panicking__panic_bounds_check__h808b524af17640b1($3 | 0, $26 | 0, 1064928 | 0);
               abort();
              }
              alloc__vec__Vec_T_2cA___swap_remove__assert_failed__h35befc50802f56b5($3 | 0, $6 | 0);
              abort();
             }
             $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter__SpecFromIter_T_2cI____from_iter__h6366b5bc3d433487($4 + 536 | 0 | 0, 0 | 0, HEAP32[($4 + 360 | 0) >> 2] | 0 | 0);
             HEAP32[($4 + 504 | 0) >> 2] = $4 + 352 | 0;
             $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h0f0d6987a7f36efc($4 + 32 | 0 | 0, $4 + 536 | 0 | 0);
             $3 = HEAP32[($4 + 32 | 0) >> 2] | 0;
             $2 = HEAP32[($4 + 36 | 0) >> 2] | 0;
             alloc__raw_vec__RawVec_T_2cA___allocate_in__h5dada854c892eb3e($4 + 24 | 0 | 0, $2 | 0, 0 | 0);
             HEAP32[($4 + 572 | 0) >> 2] = HEAP32[($4 + 28 | 0) >> 2] | 0;
             $5 = HEAP32[($4 + 24 | 0) >> 2] | 0;
             HEAP32[($4 + 568 | 0) >> 2] = $5;
             memcpy($5 | 0, $3 | 0, $2 << 2 | 0 | 0) | 0;
             HEAP32[($4 + 576 | 0) >> 2] = $2;
             alloc__vec__Vec_T_2cA___retain__hf8f37eb0a6dc1345($4 + 568 | 0 | 0, $4 + 616 | 0 | 0, $4 + 504 | 0 | 0);
             $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__DerefMut___deref_mut__h42fc515862cf6b48($4 + 16 | 0 | 0, $4 + 568 | 0 | 0);
             $2 = HEAP32[($4 + 20 | 0) >> 2] | 0;
             $3 = HEAP32[($4 + 16 | 0) >> 2] | 0;
             HEAP32[($4 + 716 | 0) >> 2] = $4 + 504 | 0;
             HEAP32[($4 + 712 | 0) >> 2] = $4 + 616 | 0;
             alloc__slice__merge_sort__hb2cc5bc1726bb0e1($3 | 0, $2 | 0, $4 + 712 | 0 | 0);
             $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h0f0d6987a7f36efc($4 + 8 | 0 | 0, $4 + 568 | 0 | 0);
             label$124 : {
              label$125 : {
               label$126 : {
                label$127 : {
                 label$128 : {
                  label$129 : {
                   label$130 : {
                    label$131 : {
                     $2 = HEAP32[($4 + 12 | 0) >> 2] | 0;
                     if (!$2) {
                      break label$131
                     }
                     $27 = $1 + 96 | 0;
                     $21 = HEAP32[($4 + 8 | 0) >> 2] | 0;
                     $23 = $21 + ($2 << 2 | 0) | 0;
                     $14 = ($4 + 864 | 0) + 12 | 0;
                     $20 = ($4 + 392 | 0) + 12 | 0;
                     $12 = ($4 + 712 | 0) + 8 | 0;
                     $15 = ($4 + 368 | 0) + 12 | 0;
                     label$132 : while (1) {
                      i64toi32_i32$0 = $4;
                      i64toi32_i32$3 = HEAP32[($4 + 368 | 0) >> 2] | 0;
                      i64toi32_i32$5 = HEAP32[($4 + 372 | 0) >> 2] | 0;
                      $2099 = i64toi32_i32$3;
                      $2099$hi = i64toi32_i32$5;
                      i64toi32_i32$0 = $4;
                      i64toi32_i32$5 = HEAP32[($4 + 392 | 0) >> 2] | 0;
                      i64toi32_i32$3 = HEAP32[($4 + 396 | 0) >> 2] | 0;
                      $2101 = i64toi32_i32$5;
                      $2101$hi = i64toi32_i32$3;
                      i64toi32_i32$3 = $2099$hi;
                      i64toi32_i32$0 = $2099;
                      i64toi32_i32$5 = $2101$hi;
                      i64toi32_i32$4 = $2101;
                      if (i64toi32_i32$3 >>> 0 > i64toi32_i32$5 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$0 >>> 0 >= i64toi32_i32$4 >>> 0 | 0) | 0) {
                       break label$131
                      }
                      $3 = HEAP32[($4 + 504 | 0) >> 2] | 0;
                      $5 = HEAP32[($3 + 8 | 0) >> 2] | 0;
                      $23 = $23 + -4 | 0;
                      $2 = HEAP32[$23 >> 2] | 0;
                      if ($5 >>> 0 <= $2 >>> 0) {
                       break label$127
                      }
                      $2 = (HEAP32[$3 >> 2] | 0) + Math_imul($2, 168) | 0;
                      $5 = $2 + 128 | 0;
                      $3 = $2 + 64 | 0;
                      cardano_serialization_lib__tx_builder__TransactionBuilder__fee_for_input__ha5a0f735cbb9ab50($4 + 712 | 0 | 0, $1 | 0, $2 | 0, $5 | 0, $3 | 0);
                      if ((HEAP32[($4 + 712 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                       break label$128
                      }
                      i64toi32_i32$4 = $4;
                      i64toi32_i32$0 = HEAP32[($4 + 720 | 0) >> 2] | 0;
                      i64toi32_i32$3 = HEAP32[($4 + 724 | 0) >> 2] | 0;
                      $28 = i64toi32_i32$0;
                      $28$hi = i64toi32_i32$3;
                      cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__add_input__hd22960e5a7d88824($27 | 0, $2 | 0, $5 | 0, $3 | 0);
                      cardano_serialization_lib__utils__Value__checked_add__h5184687782847801($4 + 712 | 0 | 0, $4 + 368 | 0 | 0, $3 | 0);
                      if ((HEAP32[($4 + 712 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                       break label$126
                      }
                      $2 = ($4 + 864 | 0) + 16 | 0;
                      $5 = $12 + 16 | 0;
                      i64toi32_i32$4 = $5;
                      i64toi32_i32$3 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                      i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                      $2153 = i64toi32_i32$3;
                      i64toi32_i32$3 = $2;
                      HEAP32[i64toi32_i32$3 >> 2] = $2153;
                      HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
                      $3 = ($4 + 864 | 0) + 8 | 0;
                      $6 = $12 + 8 | 0;
                      i64toi32_i32$4 = $6;
                      i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                      i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                      $2161 = i64toi32_i32$0;
                      i64toi32_i32$0 = $3;
                      HEAP32[i64toi32_i32$0 >> 2] = $2161;
                      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
                      i64toi32_i32$4 = $12;
                      i64toi32_i32$3 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                      i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                      $2164 = i64toi32_i32$3;
                      i64toi32_i32$3 = $4;
                      HEAP32[($4 + 864 | 0) >> 2] = $2164;
                      HEAP32[($4 + 868 | 0) >> 2] = i64toi32_i32$0;
                      label$133 : {
                       if (!(HEAP32[($4 + 376 | 0) >> 2] | 0)) {
                        break label$133
                       }
                       $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($15 | 0);
                      }
                      i64toi32_i32$4 = $2;
                      i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                      i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                      $2173 = i64toi32_i32$0;
                      i64toi32_i32$0 = ($4 + 368 | 0) + 16 | 0;
                      HEAP32[i64toi32_i32$0 >> 2] = $2173;
                      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
                      i64toi32_i32$4 = $3;
                      i64toi32_i32$3 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                      i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                      $2178 = i64toi32_i32$3;
                      i64toi32_i32$3 = ($4 + 368 | 0) + 8 | 0;
                      HEAP32[i64toi32_i32$3 >> 2] = $2178;
                      HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
                      i64toi32_i32$4 = $4;
                      i64toi32_i32$0 = HEAP32[($4 + 864 | 0) >> 2] | 0;
                      i64toi32_i32$3 = HEAP32[($4 + 868 | 0) >> 2] | 0;
                      $2181 = i64toi32_i32$0;
                      i64toi32_i32$0 = $4;
                      HEAP32[($4 + 368 | 0) >> 2] = $2181;
                      HEAP32[($4 + 372 | 0) >> 2] = i64toi32_i32$3;
                      HEAP32[($4 + 872 | 0) >> 2] = 0;
                      i64toi32_i32$3 = $28$hi;
                      i64toi32_i32$0 = $4;
                      HEAP32[($4 + 864 | 0) >> 2] = $28;
                      HEAP32[($4 + 868 | 0) >> 2] = i64toi32_i32$3;
                      cardano_serialization_lib__utils__Value__checked_add__h5184687782847801($4 + 712 | 0 | 0, $4 + 392 | 0 | 0, $4 + 864 | 0 | 0);
                      if ((HEAP32[($4 + 712 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                       break label$130
                      }
                      $2 = ($4 + 680 | 0) + 16 | 0;
                      i64toi32_i32$4 = $5;
                      i64toi32_i32$3 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                      i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                      $2199 = i64toi32_i32$3;
                      i64toi32_i32$3 = $2;
                      HEAP32[i64toi32_i32$3 >> 2] = $2199;
                      HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
                      $3 = ($4 + 680 | 0) + 8 | 0;
                      i64toi32_i32$4 = $6;
                      i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                      i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                      $2205 = i64toi32_i32$0;
                      i64toi32_i32$0 = $3;
                      HEAP32[i64toi32_i32$0 >> 2] = $2205;
                      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
                      i64toi32_i32$4 = $12;
                      i64toi32_i32$3 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                      i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                      $2208 = i64toi32_i32$3;
                      i64toi32_i32$3 = $4;
                      HEAP32[($4 + 680 | 0) >> 2] = $2208;
                      HEAP32[($4 + 684 | 0) >> 2] = i64toi32_i32$0;
                      label$134 : {
                       if (!(HEAP32[($4 + 400 | 0) >> 2] | 0)) {
                        break label$134
                       }
                       $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($20 | 0);
                      }
                      i64toi32_i32$4 = $2;
                      i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                      i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                      $2217 = i64toi32_i32$0;
                      i64toi32_i32$0 = ($4 + 392 | 0) + 16 | 0;
                      HEAP32[i64toi32_i32$0 >> 2] = $2217;
                      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
                      i64toi32_i32$4 = $3;
                      i64toi32_i32$3 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                      i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                      $2222 = i64toi32_i32$3;
                      i64toi32_i32$3 = ($4 + 392 | 0) + 8 | 0;
                      HEAP32[i64toi32_i32$3 >> 2] = $2222;
                      HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
                      i64toi32_i32$4 = $4;
                      i64toi32_i32$0 = HEAP32[($4 + 680 | 0) >> 2] | 0;
                      i64toi32_i32$3 = HEAP32[($4 + 684 | 0) >> 2] | 0;
                      $2225 = i64toi32_i32$0;
                      i64toi32_i32$0 = $4;
                      HEAP32[($4 + 392 | 0) >> 2] = $2225;
                      HEAP32[($4 + 396 | 0) >> 2] = i64toi32_i32$3;
                      label$135 : {
                       if (!(HEAP32[($4 + 872 | 0) >> 2] | 0)) {
                        break label$135
                       }
                       $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($14 | 0);
                      }
                      $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h0f0d6987a7f36efc($4 | 0, $4 + 536 | 0 | 0);
                      label$136 : {
                       label$137 : {
                        $2 = HEAP32[($4 + 4 | 0) >> 2] | 0;
                        if (!$2) {
                         break label$137
                        }
                        $5 = HEAP32[$4 >> 2] | 0;
                        $26 = $2 << 2 | 0;
                        $6 = HEAP32[$23 >> 2] | 0;
                        $2 = 0;
                        $3 = 0;
                        label$138 : while (1) {
                         if (($6 | 0) == (HEAP32[($5 + $2 | 0) >> 2] | 0 | 0)) {
                          break label$136
                         }
                         $3 = $3 + 1 | 0;
                         $2 = $2 + 4 | 0;
                         if (($26 | 0) != ($2 | 0)) {
                          continue label$138
                         }
                         break label$138;
                        };
                       }
                       core__panicking__panic__h2fd385a887c8bf13(1063668 | 0, 43 | 0, 1064852 | 0);
                       abort();
                      }
                      $5 = HEAP32[($4 + 544 | 0) >> 2] | 0;
                      if ($5 >>> 0 <= $3 >>> 0) {
                       break label$125
                      }
                      $3 = HEAP32[($4 + 536 | 0) >> 2] | 0;
                      $5 = $5 + -1 | 0;
                      HEAP32[($4 + 544 | 0) >> 2] = $5;
                      HEAP32[($3 + $2 | 0) >> 2] = HEAP32[($3 + ($5 << 2 | 0) | 0) >> 2] | 0;
                      if (($21 | 0) != ($23 | 0)) {
                       continue label$132
                      }
                      break label$132;
                     };
                    }
                    i64toi32_i32$4 = $4;
                    i64toi32_i32$3 = HEAP32[($4 + 368 | 0) >> 2] | 0;
                    i64toi32_i32$0 = HEAP32[($4 + 372 | 0) >> 2] | 0;
                    $2279 = i64toi32_i32$3;
                    $2279$hi = i64toi32_i32$0;
                    i64toi32_i32$4 = $4;
                    i64toi32_i32$0 = HEAP32[($4 + 392 | 0) >> 2] | 0;
                    i64toi32_i32$3 = HEAP32[($4 + 396 | 0) >> 2] | 0;
                    $2281 = i64toi32_i32$0;
                    $2281$hi = i64toi32_i32$3;
                    i64toi32_i32$3 = $2279$hi;
                    i64toi32_i32$4 = $2279;
                    i64toi32_i32$0 = $2281$hi;
                    i64toi32_i32$5 = $2281;
                    if (i64toi32_i32$3 >>> 0 > i64toi32_i32$0 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$4 >>> 0 >= i64toi32_i32$5 >>> 0 | 0) | 0) {
                     break label$129
                    }
                    $2 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1064884 | 0, 25 | 0) | 0;
                    break label$124;
                   }
                   $2 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($4 + 716 | 0) >> 2] | 0 | 0) | 0;
                   if (!(HEAP32[($4 + 872 | 0) >> 2] | 0)) {
                    break label$124
                   }
                   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($14 | 0);
                   break label$124;
                  }
                  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hb513c626355ab1b6($4 + 568 | 0 | 0);
                  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h515a508dccfbb69c($4 + 568 | 0 | 0);
                  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hb513c626355ab1b6($4 + 536 | 0 | 0);
                  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h515a508dccfbb69c($4 + 536 | 0 | 0);
                  break label$9;
                 }
                 $2 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($4 + 716 | 0) >> 2] | 0 | 0) | 0;
                 break label$124;
                }
                core__panicking__panic_bounds_check__h808b524af17640b1($2 | 0, $5 | 0, 1064836 | 0);
                abort();
               }
               $2 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($4 + 716 | 0) >> 2] | 0 | 0) | 0;
               break label$124;
              }
              alloc__vec__Vec_T_2cA___swap_remove__assert_failed__h35befc50802f56b5($3 | 0, $5 | 0);
              abort();
             }
             $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hb513c626355ab1b6($4 + 568 | 0 | 0);
             $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h515a508dccfbb69c($4 + 568 | 0 | 0);
             $3 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($2 | 0) | 0;
             $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hb513c626355ab1b6($4 + 536 | 0 | 0);
             $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h515a508dccfbb69c($4 + 536 | 0 | 0);
             break label$5;
            }
            (wasm2js_i32$0 = $4, wasm2js_i32$1 = rand__rngs__thread__thread_rng__h15df01d3d7282652() | 0), HEAP32[(wasm2js_i32$0 + 632 | 0) >> 2] = wasm2js_i32$1;
            i64toi32_i32$3 = $4;
            i64toi32_i32$4 = 0;
            HEAP32[($4 + 668 | 0) >> 2] = 0;
            HEAP32[($4 + 672 | 0) >> 2] = i64toi32_i32$4;
            label$139 : {
             label$140 : {
              $3 = HEAP32[($4 + 360 | 0) >> 2] | 0;
              if (!$3) {
               break label$140
              }
              $2 = 0;
              label$141 : while (1) {
               alloc__collections__btree__map__BTreeMap_K_2cV___insert__h358bbc5e89c1a147($4 + 664 | 0 | 0, $2 | 0) | 0;
               $2 = $2 + 1 | 0;
               if (($3 | 0) != ($2 | 0)) {
                continue label$141
               }
               break label$141;
              };
              $2 = HEAP32[($4 + 668 | 0) >> 2] | 0;
              break label$139;
             }
             $2 = 0;
            }
            HEAP32[($4 + 648 | 0) >> 2] = $4 + 352 | 0;
            label$142 : {
             label$143 : {
              if (!$2) {
               break label$143
              }
              $3 = HEAP32[($4 + 664 | 0) >> 2] | 0;
              alloc__collections__btree__navigate__full_range__hfcebc6cee2db4b73($4 + 712 | 0 | 0, $3 | 0, $2 | 0, $3 | 0, $2 | 0);
              $2 = HEAP32[($4 + 672 | 0) >> 2] | 0;
              break label$142;
             }
             $2 = 0;
             HEAP32[($4 + 728 | 0) >> 2] = 0;
             HEAP32[($4 + 716 | 0) >> 2] = 0;
            }
            HEAP32[(($4 + 864 | 0) + 24 | 0) >> 2] = $2;
            $3 = ($4 + 712 | 0) + 8 | 0;
            i64toi32_i32$5 = $3;
            i64toi32_i32$4 = HEAP32[i64toi32_i32$5 >> 2] | 0;
            i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
            $28 = i64toi32_i32$4;
            $28$hi = i64toi32_i32$3;
            i64toi32_i32$4 = ($4 + 864 | 0) + 8 | 0;
            HEAP32[i64toi32_i32$4 >> 2] = $28;
            HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$3;
            $5 = ($4 + 712 | 0) + 16 | 0;
            i64toi32_i32$5 = $5;
            i64toi32_i32$3 = HEAP32[i64toi32_i32$5 >> 2] | 0;
            i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
            $29 = i64toi32_i32$3;
            $29$hi = i64toi32_i32$4;
            i64toi32_i32$3 = ($4 + 864 | 0) + 16 | 0;
            HEAP32[i64toi32_i32$3 >> 2] = $29;
            HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$4;
            i64toi32_i32$5 = $4;
            i64toi32_i32$4 = HEAP32[($4 + 712 | 0) >> 2] | 0;
            i64toi32_i32$3 = HEAP32[($4 + 716 | 0) >> 2] | 0;
            $30 = i64toi32_i32$4;
            $30$hi = i64toi32_i32$3;
            i64toi32_i32$4 = $4;
            HEAP32[($4 + 864 | 0) >> 2] = $30;
            HEAP32[($4 + 868 | 0) >> 2] = i64toi32_i32$3;
            HEAP32[(($4 + 712 | 0) + 24 | 0) >> 2] = $2;
            i64toi32_i32$3 = $29$hi;
            i64toi32_i32$4 = $5;
            HEAP32[i64toi32_i32$4 >> 2] = $29;
            HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$3;
            i64toi32_i32$3 = $28$hi;
            i64toi32_i32$4 = $3;
            HEAP32[i64toi32_i32$4 >> 2] = $28;
            HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$3;
            i64toi32_i32$3 = $30$hi;
            i64toi32_i32$4 = $4;
            HEAP32[($4 + 712 | 0) >> 2] = $30;
            HEAP32[($4 + 716 | 0) >> 2] = i64toi32_i32$3;
            HEAP32[($4 + 744 | 0) >> 2] = $4 + 648 | 0;
            HEAP32[($4 + 740 | 0) >> 2] = $4 + 616 | 0;
            $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__h4f76cb21839b1a36($4 + 472 | 0 | 0, $4 + 712 | 0 | 0);
            i64toi32_i32$4 = $4;
            i64toi32_i32$3 = 0;
            HEAP32[($4 + 508 | 0) >> 2] = 0;
            HEAP32[($4 + 512 | 0) >> 2] = i64toi32_i32$3;
            $2 = HEAP32[($1 + 424 | 0) >> 2] | 0;
            $3 = HEAP32[($1 + 416 | 0) >> 2] | 0;
            HEAP32[($4 + 712 | 0) >> 2] = $3;
            HEAP32[($4 + 716 | 0) >> 2] = $3 + ($2 << 7 | 0) | 0;
            HEAP32[($4 + 720 | 0) >> 2] = $4 + 616 | 0;
            $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__ha2b0cca8c537833f($4 + 536 | 0 | 0, $4 + 712 | 0 | 0);
            $2 = HEAP32[($4 + 536 | 0) >> 2] | 0;
            $24 = HEAP32[($4 + 544 | 0) >> 2] | 0;
            HEAP32[($4 + 712 | 0) >> 2] = $4 + 616 | 0;
            alloc__slice__merge_sort__h1ac5e792f8b4e83b($2 | 0, $24 | 0, $4 + 712 | 0 | 0);
            label$144 : {
             label$145 : {
              label$146 : {
               label$147 : {
                label$148 : {
                 label$149 : {
                  if (!$24) {
                   break label$149
                  }
                  $5 = ($4 + 864 | 0) + 89 | 0;
                  $12 = $4 + 936 | 0;
                  $22 = $4 + 680 | 0 | 4 | 0;
                  $25 = $2 + ($24 << 7 | 0) | 0;
                  $3 = $25;
                  label$150 : {
                   label$151 : {
                    label$152 : {
                     label$153 : while (1) {
                      $21 = $3 + -128 | 0;
                      label$154 : {
                       $14 = $3 + -64 | 0;
                       i64toi32_i32$5 = $14;
                       i64toi32_i32$3 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                       i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                       $30 = i64toi32_i32$3;
                       $30$hi = i64toi32_i32$4;
                       if (!(i64toi32_i32$3 | i64toi32_i32$4 | 0)) {
                        break label$154
                       }
                       $23 = $21 + 89 | 0;
                       $15 = $3 + -40 | 0;
                       $19 = $21 + 76 | 0;
                       $20 = $3 + -56 | 0;
                       i64toi32_i32$4 = 0;
                       $28 = 0;
                       $28$hi = i64toi32_i32$4;
                       label$155 : while (1) {
                        $3 = HEAP32[($4 + 480 | 0) >> 2] | 0;
                        if (!$3) {
                         break label$146
                        }
                        $3 = rand__rng__Rng__gen_range__he28987be934355f0($4 + 632 | 0 | 0, 0 | 0, $3 | 0) | 0;
                        $6 = HEAP32[($4 + 480 | 0) >> 2] | 0;
                        if ($6 >>> 0 <= $3 >>> 0) {
                         break label$147
                        }
                        $26 = HEAP32[($4 + 472 | 0) >> 2] | 0;
                        $3 = $26 + ($3 << 2 | 0) | 0;
                        $27 = HEAP32[$3 >> 2] | 0;
                        $6 = $6 + -1 | 0;
                        HEAP32[($4 + 480 | 0) >> 2] = $6;
                        HEAP32[$3 >> 2] = HEAP32[($26 + ($6 << 2 | 0) | 0) >> 2] | 0;
                        HEAP32[($4 + 440 | 0) >> 2] = $27;
                        alloc__collections__btree__map__BTreeMap_K_2cV___remove_entry__haaee74feca9cfb03($4 + 96 | 0 | 0, $4 + 664 | 0 | 0, $4 + 440 | 0 | 0);
                        $6 = HEAP32[($4 + 648 | 0) >> 2] | 0;
                        $26 = HEAP32[($6 + 8 | 0) >> 2] | 0;
                        $3 = HEAP32[($4 + 440 | 0) >> 2] | 0;
                        if ($26 >>> 0 <= $3 >>> 0) {
                         break label$148
                        }
                        i64toi32_i32$4 = $28$hi;
                        i64toi32_i32$5 = (HEAP32[$6 >> 2] | 0) + Math_imul($3, 168) | 0;
                        i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 64 | 0) >> 2] | 0;
                        i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 68 | 0) >> 2] | 0;
                        $2517 = i64toi32_i32$4;
                        $2517$hi = i64toi32_i32$3;
                        i64toi32_i32$3 = $28$hi;
                        i64toi32_i32$5 = $28;
                        i64toi32_i32$4 = $2517$hi;
                        i64toi32_i32$0 = $2517;
                        i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
                        i64toi32_i32$1 = i64toi32_i32$3 + i64toi32_i32$4 | 0;
                        if (i64toi32_i32$2 >>> 0 < i64toi32_i32$0 >>> 0) {
                         i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
                        }
                        $29 = i64toi32_i32$2;
                        $29$hi = i64toi32_i32$1;
                        i64toi32_i32$1 = $28$hi;
                        i64toi32_i32$1 = $29$hi;
                        i64toi32_i32$3 = i64toi32_i32$2;
                        i64toi32_i32$5 = $28$hi;
                        i64toi32_i32$0 = $28;
                        if (i64toi32_i32$1 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$3 >>> 0 < i64toi32_i32$0 >>> 0 | 0) | 0) {
                         break label$152
                        }
                        $cardano_serialization_lib__address__Address_20as_20core__clone__Clone___clone__h0eb465a6e349d507_2($4 + 712 | 0 | 0, $21 | 0);
                        i64toi32_i32$0 = $14;
                        i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                        i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                        $28 = i64toi32_i32$3;
                        $28$hi = i64toi32_i32$1;
                        $3 = 0;
                        $6 = 0;
                        label$156 : {
                         if ((HEAP32[$20 >> 2] | 0 | 0) != (1 | 0)) {
                          break label$156
                         }
                         $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($22 | 0, $19 | 0);
                         $6 = 1;
                        }
                        $27 = ($4 + 568 | 0) + 8 | 0;
                        $26 = ($4 + 680 | 0) + 8 | 0;
                        i64toi32_i32$0 = $26;
                        i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                        i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                        $2540 = i64toi32_i32$1;
                        i64toi32_i32$1 = $27;
                        HEAP32[i64toi32_i32$1 >> 2] = $2540;
                        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
                        HEAP32[($4 + 680 | 0) >> 2] = $6;
                        i64toi32_i32$0 = $4;
                        i64toi32_i32$3 = HEAP32[($4 + 680 | 0) >> 2] | 0;
                        i64toi32_i32$1 = HEAP32[($4 + 684 | 0) >> 2] | 0;
                        $2545 = i64toi32_i32$3;
                        i64toi32_i32$3 = $4;
                        HEAP32[($4 + 568 | 0) >> 2] = $2545;
                        HEAP32[($4 + 572 | 0) >> 2] = i64toi32_i32$1;
                        label$157 : {
                         if ((HEAPU8[$15 >> 0] | 0 | 0) != (1 | 0)) {
                          break label$157
                         }
                         i64toi32_i32$0 = $23 + 24 | 0;
                         i64toi32_i32$1 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                         i64toi32_i32$3 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                         $2554 = i64toi32_i32$1;
                         i64toi32_i32$1 = ($4 + 680 | 0) + 24 | 0;
                         HEAP32[i64toi32_i32$1 >> 2] = $2554;
                         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
                         i64toi32_i32$0 = $23 + 16 | 0;
                         i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                         i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                         $2560 = i64toi32_i32$3;
                         i64toi32_i32$3 = ($4 + 680 | 0) + 16 | 0;
                         HEAP32[i64toi32_i32$3 >> 2] = $2560;
                         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
                         i64toi32_i32$0 = $23 + 8 | 0;
                         i64toi32_i32$1 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                         i64toi32_i32$3 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                         $2564 = i64toi32_i32$1;
                         i64toi32_i32$1 = $26;
                         HEAP32[i64toi32_i32$1 >> 2] = $2564;
                         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
                         i64toi32_i32$0 = $23;
                         i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                         i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                         $2567 = i64toi32_i32$3;
                         i64toi32_i32$3 = $4;
                         HEAP32[($4 + 680 | 0) >> 2] = $2567;
                         HEAP32[($4 + 684 | 0) >> 2] = i64toi32_i32$1;
                         $3 = 1;
                        }
                        memcpy($4 + 864 | 0 | 0, $4 + 712 | 0 | 0, 64 | 0) | 0;
                        i64toi32_i32$0 = $4;
                        i64toi32_i32$1 = HEAP32[($4 + 568 | 0) >> 2] | 0;
                        i64toi32_i32$3 = HEAP32[($4 + 572 | 0) >> 2] | 0;
                        $2575 = i64toi32_i32$1;
                        i64toi32_i32$1 = $12;
                        HEAP32[i64toi32_i32$1 >> 2] = $2575;
                        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
                        i64toi32_i32$0 = $27;
                        i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                        i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                        $2579 = i64toi32_i32$3;
                        i64toi32_i32$3 = $12 + 8 | 0;
                        HEAP32[i64toi32_i32$3 >> 2] = $2579;
                        HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
                        i64toi32_i32$0 = $4;
                        i64toi32_i32$1 = HEAP32[($4 + 680 | 0) >> 2] | 0;
                        i64toi32_i32$3 = HEAP32[($4 + 684 | 0) >> 2] | 0;
                        $2582 = i64toi32_i32$1;
                        i64toi32_i32$1 = $5;
                        $323 = $2582;
                        HEAP8[i64toi32_i32$1 >> 0] = $323;
                        HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $323 >>> 8 | 0;
                        HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $323 >>> 16 | 0;
                        HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $323 >>> 24 | 0;
                        HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$3;
                        HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
                        HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
                        HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
                        i64toi32_i32$0 = $26;
                        i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                        i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                        $2586 = i64toi32_i32$3;
                        i64toi32_i32$3 = $5 + 8 | 0;
                        $324 = $2586;
                        HEAP8[i64toi32_i32$3 >> 0] = $324;
                        HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $324 >>> 8 | 0;
                        HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $324 >>> 16 | 0;
                        HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $324 >>> 24 | 0;
                        HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$1;
                        HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
                        HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
                        HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
                        i64toi32_i32$0 = ($4 + 680 | 0) + 16 | 0;
                        i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                        i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                        $2592 = i64toi32_i32$1;
                        i64toi32_i32$1 = $5 + 16 | 0;
                        $325 = $2592;
                        HEAP8[i64toi32_i32$1 >> 0] = $325;
                        HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $325 >>> 8 | 0;
                        HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $325 >>> 16 | 0;
                        HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $325 >>> 24 | 0;
                        HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$3;
                        HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
                        HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
                        HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
                        i64toi32_i32$0 = ($4 + 680 | 0) + 24 | 0;
                        i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                        i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                        $2598 = i64toi32_i32$3;
                        i64toi32_i32$3 = $5 + 24 | 0;
                        $327 = $2598;
                        HEAP8[i64toi32_i32$3 >> 0] = $327;
                        HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $327 >>> 8 | 0;
                        HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $327 >>> 16 | 0;
                        HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $327 >>> 24 | 0;
                        HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$1;
                        HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
                        HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
                        HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
                        i64toi32_i32$1 = $28$hi;
                        i64toi32_i32$3 = $4;
                        HEAP32[($4 + 928 | 0) >> 2] = $28;
                        HEAP32[($4 + 932 | 0) >> 2] = i64toi32_i32$1;
                        HEAP8[($4 + 952 | 0) >> 0] = $3;
                        alloc__collections__btree__map__BTreeMap_K_2cV___entry__hf5f68610bd8a4a4c($4 + 712 | 0 | 0, $4 + 504 | 0 | 0, $4 + 864 | 0 | 0);
                        $3 = alloc__collections__btree__map__entry__Entry_K_2cV___or_default__h1c00ee87c8b7cd04($4 + 712 | 0 | 0) | 0;
                        $26 = HEAP32[($4 + 440 | 0) >> 2] | 0;
                        label$158 : {
                         $6 = HEAP32[($3 + 8 | 0) >> 2] | 0;
                         if (($6 | 0) != (HEAP32[($3 + 4 | 0) >> 2] | 0 | 0)) {
                          break label$158
                         }
                         alloc__vec__Vec_T_2cA___reserve__h71af5692fa531ae6($3 | 0, 1 | 0);
                         $6 = HEAP32[($3 + 8 | 0) >> 2] | 0;
                        }
                        HEAP32[((HEAP32[$3 >> 2] | 0) + ($6 << 2 | 0) | 0) >> 2] = $26;
                        HEAP32[($3 + 8 | 0) >> 2] = (HEAP32[($3 + 8 | 0) >> 2] | 0) + 1 | 0;
                        i64toi32_i32$1 = $29$hi;
                        $28 = $29;
                        $28$hi = i64toi32_i32$1;
                        i64toi32_i32$1 = $30$hi;
                        i64toi32_i32$1 = $28$hi;
                        i64toi32_i32$0 = $28;
                        i64toi32_i32$3 = $30$hi;
                        i64toi32_i32$5 = $30;
                        if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0 | 0) | 0) {
                         continue label$155
                        }
                        break label$155;
                       };
                      }
                      $3 = $21;
                      if (($2 | 0) != ($3 | 0)) {
                       continue label$153
                      }
                      break label$153;
                     };
                     if (!$24) {
                      break label$150
                     }
                     if (!(HEAP32[($4 + 480 | 0) >> 2] | 0)) {
                      break label$150
                     }
                     break label$151;
                    }
                    $3 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1058732 | 0, 8 | 0) | 0 | 0) | 0;
                    break label$145;
                   }
                   label$159 : while (1) {
                    label$160 : {
                     label$161 : {
                      label$162 : {
                       label$163 : {
                        label$164 : {
                         $3 = alloc__collections__btree__map__BTreeMap_K_2cV___get_mut__hd032fad84dac0c7f($4 + 504 | 0 | 0, $2 | 0) | 0;
                         if (!$3) {
                          break label$164
                         }
                         $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__DerefMut___deref_mut__h42fc515862cf6b48($4 + 88 | 0 | 0, $3 | 0);
                         $5 = HEAP32[($4 + 92 | 0) >> 2] | 0;
                         if (!$5) {
                          break label$160
                         }
                         $3 = HEAP32[($4 + 88 | 0) >> 2] | 0;
                         $26 = $5 << 2 | 0;
                         label$165 : while (1) {
                          $5 = rand__rng__Rng__gen_range__he28987be934355f0($4 + 632 | 0 | 0, 0 | 0, HEAP32[($4 + 480 | 0) >> 2] | 0 | 0) | 0;
                          $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__DerefMut___deref_mut__h42fc515862cf6b48($4 + 80 | 0 | 0, $4 + 472 | 0 | 0);
                          if ($5 >>> 0 >= (HEAP32[($4 + 84 | 0) >> 2] | 0) >>> 0) {
                           break label$163
                          }
                          $12 = HEAP32[($4 + 80 | 0) >> 2] | 0;
                          if (!$12) {
                           break label$163
                          }
                          $27 = HEAP32[($4 + 648 | 0) >> 2] | 0;
                          $23 = HEAP32[($27 + 8 | 0) >> 2] | 0;
                          $6 = HEAP32[$3 >> 2] | 0;
                          if ($23 >>> 0 <= $6 >>> 0) {
                           break label$162
                          }
                          $12 = $12 + ($5 << 2 | 0) | 0;
                          $5 = HEAP32[$12 >> 2] | 0;
                          if ($23 >>> 0 <= $5 >>> 0) {
                           break label$161
                          }
                          label$166 : {
                           $23 = HEAP32[$27 >> 2] | 0;
                           i64toi32_i32$5 = $23 + Math_imul($5, 168) | 0;
                           i64toi32_i32$0 = HEAP32[(i64toi32_i32$5 + 64 | 0) >> 2] | 0;
                           i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 68 | 0) >> 2] | 0;
                           $29 = i64toi32_i32$0;
                           $29$hi = i64toi32_i32$1;
                           i64toi32_i32$5 = $2;
                           i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 64 | 0) >> 2] | 0;
                           i64toi32_i32$0 = HEAP32[(i64toi32_i32$5 + 68 | 0) >> 2] | 0;
                           $28 = i64toi32_i32$1;
                           $28$hi = i64toi32_i32$0;
                           i64toi32_i32$1 = 0;
                           i64toi32_i32$1 = __wasm_i64_mul($28 | 0, i64toi32_i32$0 | 0, 3 | 0, i64toi32_i32$1 | 0) | 0;
                           i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
                           $2711 = i64toi32_i32$1;
                           $2711$hi = i64toi32_i32$0;
                           i64toi32_i32$0 = $29$hi;
                           i64toi32_i32$5 = $29;
                           i64toi32_i32$1 = $2711$hi;
                           i64toi32_i32$3 = $2711;
                           if (i64toi32_i32$0 >>> 0 > i64toi32_i32$1 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$5 >>> 0 >= i64toi32_i32$3 >>> 0 | 0) | 0) {
                            break label$166
                           }
                           i64toi32_i32$5 = $28$hi;
                           i64toi32_i32$3 = $28;
                           i64toi32_i32$0 = 0;
                           i64toi32_i32$1 = 1;
                           i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
                           if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                            i64toi32_i32$0 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
                            $349 = 0;
                           } else {
                            i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$5 << i64toi32_i32$4 | 0) | 0;
                            $349 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
                           }
                           $28 = $349;
                           $28$hi = i64toi32_i32$0;
                           i64toi32_i32$0 = $29$hi;
                           i64toi32_i32$0 = $28$hi;
                           i64toi32_i32$5 = $28;
                           i64toi32_i32$3 = $29$hi;
                           i64toi32_i32$1 = $29;
                           i64toi32_i32$4 = i64toi32_i32$5 - i64toi32_i32$1 | 0;
                           i64toi32_i32$6 = i64toi32_i32$5 >>> 0 < i64toi32_i32$1 >>> 0;
                           i64toi32_i32$2 = i64toi32_i32$6 + i64toi32_i32$3 | 0;
                           i64toi32_i32$2 = i64toi32_i32$0 - i64toi32_i32$2 | 0;
                           $30 = i64toi32_i32$4;
                           $30$hi = i64toi32_i32$2;
                           i64toi32_i32$2 = 0;
                           i64toi32_i32$0 = 0;
                           i64toi32_i32$5 = $30$hi;
                           i64toi32_i32$1 = i64toi32_i32$4;
                           i64toi32_i32$3 = i64toi32_i32$0 - i64toi32_i32$1 | 0;
                           i64toi32_i32$6 = i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0;
                           i64toi32_i32$4 = i64toi32_i32$6 + i64toi32_i32$5 | 0;
                           i64toi32_i32$4 = i64toi32_i32$2 - i64toi32_i32$4 | 0;
                           $2719 = i64toi32_i32$3;
                           $2719$hi = i64toi32_i32$4;
                           i64toi32_i32$4 = i64toi32_i32$5;
                           $2720 = i64toi32_i32$1;
                           $2720$hi = i64toi32_i32$5;
                           i64toi32_i32$4 = $28$hi;
                           i64toi32_i32$4 = $29$hi;
                           i64toi32_i32$4 = $28$hi;
                           i64toi32_i32$2 = $28;
                           i64toi32_i32$0 = $29$hi;
                           i64toi32_i32$1 = $29;
                           $2723 = i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$1 >>> 0 | 0) | 0;
                           i64toi32_i32$2 = 0;
                           $31 = $2723;
                           $31$hi = i64toi32_i32$2;
                           i64toi32_i32$2 = 0;
                           i64toi32_i32$1 = 0;
                           i64toi32_i32$4 = $31$hi;
                           i64toi32_i32$0 = $31;
                           i64toi32_i32$5 = i64toi32_i32$1 - i64toi32_i32$0 | 0;
                           i64toi32_i32$6 = i64toi32_i32$1 >>> 0 < i64toi32_i32$0 >>> 0;
                           i64toi32_i32$3 = i64toi32_i32$6 + i64toi32_i32$4 | 0;
                           i64toi32_i32$3 = i64toi32_i32$2 - i64toi32_i32$3 | 0;
                           $32 = i64toi32_i32$5;
                           $32$hi = i64toi32_i32$3;
                           i64toi32_i32$2 = i64toi32_i32$5;
                           i64toi32_i32$1 = 0;
                           i64toi32_i32$0 = 0;
                           if ((i64toi32_i32$3 | 0) < (i64toi32_i32$1 | 0)) {
                            $350 = 1
                           } else {
                            if ((i64toi32_i32$3 | 0) <= (i64toi32_i32$1 | 0)) {
                             if (i64toi32_i32$2 >>> 0 >= i64toi32_i32$0 >>> 0) {
                              $351 = 0
                             } else {
                              $351 = 1
                             }
                             $352 = $351;
                            } else {
                             $352 = 0
                            }
                            $350 = $352;
                           }
                           $27 = $350;
                           i64toi32_i32$4 = $27;
                           i64toi32_i32$2 = $2719$hi;
                           i64toi32_i32$3 = $2720$hi;
                           i64toi32_i32$1 = i64toi32_i32$4 ? $2719 : $2720;
                           i64toi32_i32$0 = i64toi32_i32$4 ? i64toi32_i32$2 : i64toi32_i32$3;
                           $2730 = i64toi32_i32$1;
                           $2730$hi = i64toi32_i32$0;
                           i64toi32_i32$0 = $28$hi;
                           i64toi32_i32$4 = $23 + Math_imul($6, 168) | 0;
                           i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 64 | 0) >> 2] | 0;
                           i64toi32_i32$1 = HEAP32[(i64toi32_i32$4 + 68 | 0) >> 2] | 0;
                           $33 = i64toi32_i32$0;
                           $33$hi = i64toi32_i32$1;
                           i64toi32_i32$1 = $28$hi;
                           i64toi32_i32$4 = $28;
                           i64toi32_i32$0 = $33$hi;
                           i64toi32_i32$2 = $33;
                           i64toi32_i32$3 = i64toi32_i32$4 - i64toi32_i32$2 | 0;
                           i64toi32_i32$6 = i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0;
                           i64toi32_i32$5 = i64toi32_i32$6 + i64toi32_i32$0 | 0;
                           i64toi32_i32$5 = i64toi32_i32$1 - i64toi32_i32$5 | 0;
                           $29 = i64toi32_i32$3;
                           $29$hi = i64toi32_i32$5;
                           i64toi32_i32$5 = 0;
                           i64toi32_i32$1 = 0;
                           i64toi32_i32$4 = $29$hi;
                           i64toi32_i32$2 = i64toi32_i32$3;
                           i64toi32_i32$0 = i64toi32_i32$1 - i64toi32_i32$3 | 0;
                           i64toi32_i32$6 = i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0;
                           i64toi32_i32$3 = i64toi32_i32$6 + i64toi32_i32$4 | 0;
                           i64toi32_i32$3 = i64toi32_i32$5 - i64toi32_i32$3 | 0;
                           $2740 = i64toi32_i32$0;
                           $2740$hi = i64toi32_i32$3;
                           i64toi32_i32$3 = i64toi32_i32$4;
                           $2741 = i64toi32_i32$2;
                           $2741$hi = i64toi32_i32$3;
                           i64toi32_i32$3 = $28$hi;
                           i64toi32_i32$3 = $33$hi;
                           i64toi32_i32$3 = $28$hi;
                           i64toi32_i32$5 = $28;
                           i64toi32_i32$1 = $33$hi;
                           i64toi32_i32$2 = $33;
                           $2744 = i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0;
                           i64toi32_i32$5 = 0;
                           $28 = $2744;
                           $28$hi = i64toi32_i32$5;
                           i64toi32_i32$5 = 0;
                           i64toi32_i32$2 = 0;
                           i64toi32_i32$3 = $28$hi;
                           i64toi32_i32$1 = $28;
                           i64toi32_i32$4 = i64toi32_i32$2 - i64toi32_i32$1 | 0;
                           i64toi32_i32$6 = i64toi32_i32$2 >>> 0 < i64toi32_i32$1 >>> 0;
                           i64toi32_i32$0 = i64toi32_i32$6 + i64toi32_i32$3 | 0;
                           i64toi32_i32$0 = i64toi32_i32$5 - i64toi32_i32$0 | 0;
                           $33 = i64toi32_i32$4;
                           $33$hi = i64toi32_i32$0;
                           i64toi32_i32$5 = i64toi32_i32$4;
                           i64toi32_i32$2 = 0;
                           i64toi32_i32$1 = 0;
                           if ((i64toi32_i32$0 | 0) < (i64toi32_i32$2 | 0)) {
                            $353 = 1
                           } else {
                            if ((i64toi32_i32$0 | 0) <= (i64toi32_i32$2 | 0)) {
                             if (i64toi32_i32$5 >>> 0 >= i64toi32_i32$1 >>> 0) {
                              $354 = 0
                             } else {
                              $354 = 1
                             }
                             $355 = $354;
                            } else {
                             $355 = 0
                            }
                            $353 = $355;
                           }
                           $23 = $353;
                           i64toi32_i32$3 = $23;
                           i64toi32_i32$5 = $2740$hi;
                           i64toi32_i32$0 = $2741$hi;
                           i64toi32_i32$2 = i64toi32_i32$3 ? $2740 : $2741;
                           i64toi32_i32$1 = i64toi32_i32$3 ? i64toi32_i32$5 : i64toi32_i32$0;
                           $2751 = i64toi32_i32$2;
                           $2751$hi = i64toi32_i32$1;
                           i64toi32_i32$1 = $2730$hi;
                           i64toi32_i32$3 = $2730;
                           i64toi32_i32$2 = $2751$hi;
                           i64toi32_i32$5 = $2751;
                           $2752 = i64toi32_i32$1 >>> 0 > i64toi32_i32$2 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$3 >>> 0 >= i64toi32_i32$5 >>> 0 | 0) | 0;
                           i64toi32_i32$3 = $31$hi;
                           i64toi32_i32$3 = $30$hi;
                           i64toi32_i32$5 = $30;
                           i64toi32_i32$1 = 0;
                           i64toi32_i32$2 = 0;
                           $2755 = (i64toi32_i32$5 | 0) != (i64toi32_i32$2 | 0) | (i64toi32_i32$3 | 0) != (i64toi32_i32$1 | 0) | 0;
                           i64toi32_i32$5 = 0;
                           $2756$hi = i64toi32_i32$5;
                           i64toi32_i32$5 = $31$hi;
                           i64toi32_i32$2 = $31;
                           i64toi32_i32$3 = $2756$hi;
                           i64toi32_i32$1 = $2755;
                           i64toi32_i32$0 = i64toi32_i32$2 - i64toi32_i32$1 | 0;
                           i64toi32_i32$6 = i64toi32_i32$2 >>> 0 < i64toi32_i32$1 >>> 0;
                           i64toi32_i32$4 = i64toi32_i32$6 + i64toi32_i32$3 | 0;
                           i64toi32_i32$4 = i64toi32_i32$5 - i64toi32_i32$4 | 0;
                           $2757$hi = i64toi32_i32$4;
                           i64toi32_i32$4 = $32$hi;
                           i64toi32_i32$3 = $27;
                           i64toi32_i32$4 = $2757$hi;
                           i64toi32_i32$2 = $32$hi;
                           i64toi32_i32$1 = i64toi32_i32$3 ? i64toi32_i32$0 : $32;
                           i64toi32_i32$5 = i64toi32_i32$3 ? i64toi32_i32$4 : i64toi32_i32$2;
                           $30 = i64toi32_i32$1;
                           $30$hi = i64toi32_i32$5;
                           i64toi32_i32$5 = $28$hi;
                           i64toi32_i32$5 = $29$hi;
                           i64toi32_i32$3 = $29;
                           i64toi32_i32$1 = 0;
                           i64toi32_i32$4 = 0;
                           $2764 = (i64toi32_i32$3 | 0) != (i64toi32_i32$4 | 0) | (i64toi32_i32$5 | 0) != (i64toi32_i32$1 | 0) | 0;
                           i64toi32_i32$3 = 0;
                           $2765$hi = i64toi32_i32$3;
                           i64toi32_i32$3 = $28$hi;
                           i64toi32_i32$4 = $28;
                           i64toi32_i32$5 = $2765$hi;
                           i64toi32_i32$1 = $2764;
                           i64toi32_i32$2 = i64toi32_i32$4 - i64toi32_i32$1 | 0;
                           i64toi32_i32$6 = i64toi32_i32$4 >>> 0 < i64toi32_i32$1 >>> 0;
                           i64toi32_i32$0 = i64toi32_i32$6 + i64toi32_i32$5 | 0;
                           i64toi32_i32$0 = i64toi32_i32$3 - i64toi32_i32$0 | 0;
                           $2766$hi = i64toi32_i32$0;
                           i64toi32_i32$0 = $33$hi;
                           i64toi32_i32$5 = $23;
                           i64toi32_i32$0 = $2766$hi;
                           i64toi32_i32$4 = $33$hi;
                           i64toi32_i32$1 = i64toi32_i32$5 ? i64toi32_i32$2 : $33;
                           i64toi32_i32$3 = i64toi32_i32$5 ? i64toi32_i32$0 : i64toi32_i32$4;
                           $28 = i64toi32_i32$1;
                           $28$hi = i64toi32_i32$3;
                           i64toi32_i32$3 = $30$hi;
                           i64toi32_i32$5 = $30;
                           i64toi32_i32$1 = $28$hi;
                           i64toi32_i32$0 = $28;
                           if ((i64toi32_i32$3 | 0) > (i64toi32_i32$1 | 0)) {
                            $356 = 1
                           } else {
                            if ((i64toi32_i32$3 | 0) >= (i64toi32_i32$1 | 0)) {
                             if (i64toi32_i32$5 >>> 0 < i64toi32_i32$0 >>> 0) {
                              $357 = 0
                             } else {
                              $357 = 1
                             }
                             $358 = $357;
                            } else {
                             $358 = 0
                            }
                            $356 = $358;
                           }
                           i64toi32_i32$5 = $30$hi;
                           i64toi32_i32$5 = $28$hi;
                           i64toi32_i32$5 = $30$hi;
                           i64toi32_i32$0 = $30;
                           i64toi32_i32$3 = $28$hi;
                           i64toi32_i32$1 = $28;
                           if ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$5 | 0) == (i64toi32_i32$3 | 0) | 0 ? $2752 : $356) {
                            break label$166
                           }
                           HEAP32[$12 >> 2] = $6;
                           HEAP32[$3 >> 2] = $5;
                           alloc__collections__btree__map__BTreeMap_K_2cV___insert__h358bbc5e89c1a147($4 + 664 | 0 | 0, HEAP32[$3 >> 2] | 0 | 0) | 0;
                           alloc__collections__btree__map__BTreeMap_K_2cV___remove_entry__haaee74feca9cfb03($4 + 72 | 0 | 0, $4 + 664 | 0 | 0, $12 | 0);
                          }
                          $3 = $3 + 4 | 0;
                          $26 = $26 + -4 | 0;
                          if (!$26) {
                           break label$160
                          }
                          continue label$165;
                         };
                        }
                        core__panicking__panic__h2fd385a887c8bf13(1063668 | 0, 43 | 0, 1064960 | 0);
                        abort();
                       }
                       core__panicking__panic__h2fd385a887c8bf13(1063668 | 0, 43 | 0, 1064976 | 0);
                       abort();
                      }
                      core__panicking__panic_bounds_check__h808b524af17640b1($6 | 0, $23 | 0, 1064992 | 0);
                      abort();
                     }
                     core__panicking__panic_bounds_check__h808b524af17640b1($5 | 0, $23 | 0, 1065008 | 0);
                     abort();
                    }
                    $2 = $2 + 128 | 0;
                    if (($2 | 0) != ($25 | 0)) {
                     continue label$159
                    }
                    break label$159;
                   };
                   $24 = HEAP32[($4 + 544 | 0) >> 2] | 0;
                   $2 = HEAP32[($4 + 536 | 0) >> 2] | 0;
                  }
                  if (!$24) {
                   break label$149
                  }
                  $22 = $2 + ($24 << 7 | 0) | 0;
                  $21 = $1 + 96 | 0;
                  $14 = ($4 + 864 | 0) + 12 | 0;
                  $20 = ($4 + 392 | 0) + 12 | 0;
                  $5 = ($4 + 712 | 0) + 8 | 0;
                  $15 = ($4 + 368 | 0) + 12 | 0;
                  $19 = $2;
                  label$167 : while (1) {
                   label$168 : {
                    label$169 : {
                     label$170 : {
                      label$171 : {
                       label$172 : {
                        $3 = alloc__collections__btree__map__BTreeMap_K_2cV___get__h46e97faa3debbf61($4 + 504 | 0 | 0, $19 | 0) | 0;
                        if (!$3) {
                         break label$172
                        }
                        $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h0f0d6987a7f36efc($4 + 64 | 0 | 0, $3 | 0);
                        $3 = HEAP32[($4 + 68 | 0) >> 2] | 0;
                        if (!$3) {
                         break label$168
                        }
                        $6 = HEAP32[($4 + 64 | 0) >> 2] | 0;
                        $12 = $3 << 2 | 0;
                        label$173 : while (1) {
                         $26 = HEAP32[($4 + 648 | 0) >> 2] | 0;
                         $23 = HEAP32[($26 + 8 | 0) >> 2] | 0;
                         $3 = HEAP32[$6 >> 2] | 0;
                         if ($23 >>> 0 <= $3 >>> 0) {
                          break label$171
                         }
                         $3 = (HEAP32[$26 >> 2] | 0) + Math_imul($3, 168) | 0;
                         $23 = $3 + 128 | 0;
                         $26 = $3 + 64 | 0;
                         cardano_serialization_lib__tx_builder__TransactionBuilder__fee_for_input__ha5a0f735cbb9ab50($4 + 712 | 0 | 0, $1 | 0, $3 | 0, $23 | 0, $26 | 0);
                         if ((HEAP32[($4 + 712 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                          break label$170
                         }
                         i64toi32_i32$1 = $4;
                         i64toi32_i32$0 = HEAP32[($4 + 720 | 0) >> 2] | 0;
                         i64toi32_i32$5 = HEAP32[($4 + 724 | 0) >> 2] | 0;
                         $28 = i64toi32_i32$0;
                         $28$hi = i64toi32_i32$5;
                         cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__add_input__hd22960e5a7d88824($21 | 0, $3 | 0, $23 | 0, $26 | 0);
                         cardano_serialization_lib__utils__Value__checked_add__h5184687782847801($4 + 712 | 0 | 0, $4 + 368 | 0 | 0, $26 | 0);
                         if ((HEAP32[($4 + 712 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                          break label$169
                         }
                         $3 = ($4 + 864 | 0) + 16 | 0;
                         $23 = $5 + 16 | 0;
                         i64toi32_i32$1 = $23;
                         i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                         i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                         $2895 = i64toi32_i32$5;
                         i64toi32_i32$5 = $3;
                         HEAP32[i64toi32_i32$5 >> 2] = $2895;
                         HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
                         $26 = ($4 + 864 | 0) + 8 | 0;
                         $27 = $5 + 8 | 0;
                         i64toi32_i32$1 = $27;
                         i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                         i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                         $2903 = i64toi32_i32$0;
                         i64toi32_i32$0 = $26;
                         HEAP32[i64toi32_i32$0 >> 2] = $2903;
                         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$5;
                         i64toi32_i32$1 = $5;
                         i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                         i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                         $2906 = i64toi32_i32$5;
                         i64toi32_i32$5 = $4;
                         HEAP32[($4 + 864 | 0) >> 2] = $2906;
                         HEAP32[($4 + 868 | 0) >> 2] = i64toi32_i32$0;
                         label$174 : {
                          if (!(HEAP32[($4 + 376 | 0) >> 2] | 0)) {
                           break label$174
                          }
                          $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($15 | 0);
                         }
                         i64toi32_i32$1 = $3;
                         i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                         i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                         $2915 = i64toi32_i32$0;
                         i64toi32_i32$0 = ($4 + 368 | 0) + 16 | 0;
                         HEAP32[i64toi32_i32$0 >> 2] = $2915;
                         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$5;
                         i64toi32_i32$1 = $26;
                         i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                         i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                         $2920 = i64toi32_i32$5;
                         i64toi32_i32$5 = ($4 + 368 | 0) + 8 | 0;
                         HEAP32[i64toi32_i32$5 >> 2] = $2920;
                         HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
                         i64toi32_i32$1 = $4;
                         i64toi32_i32$0 = HEAP32[($4 + 864 | 0) >> 2] | 0;
                         i64toi32_i32$5 = HEAP32[($4 + 868 | 0) >> 2] | 0;
                         $2923 = i64toi32_i32$0;
                         i64toi32_i32$0 = $4;
                         HEAP32[($4 + 368 | 0) >> 2] = $2923;
                         HEAP32[($4 + 372 | 0) >> 2] = i64toi32_i32$5;
                         HEAP32[($4 + 872 | 0) >> 2] = 0;
                         i64toi32_i32$5 = $28$hi;
                         i64toi32_i32$0 = $4;
                         HEAP32[($4 + 864 | 0) >> 2] = $28;
                         HEAP32[($4 + 868 | 0) >> 2] = i64toi32_i32$5;
                         cardano_serialization_lib__utils__Value__checked_add__h5184687782847801($4 + 712 | 0 | 0, $4 + 392 | 0 | 0, $4 + 864 | 0 | 0);
                         label$175 : {
                          if ((HEAP32[($4 + 712 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                           break label$175
                          }
                          $3 = ($4 + 680 | 0) + 16 | 0;
                          i64toi32_i32$1 = $23;
                          i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                          i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                          $2941 = i64toi32_i32$5;
                          i64toi32_i32$5 = $3;
                          HEAP32[i64toi32_i32$5 >> 2] = $2941;
                          HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
                          $26 = ($4 + 680 | 0) + 8 | 0;
                          i64toi32_i32$1 = $27;
                          i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                          i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                          $2947 = i64toi32_i32$0;
                          i64toi32_i32$0 = $26;
                          HEAP32[i64toi32_i32$0 >> 2] = $2947;
                          HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$5;
                          i64toi32_i32$1 = $5;
                          i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                          i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                          $2950 = i64toi32_i32$5;
                          i64toi32_i32$5 = $4;
                          HEAP32[($4 + 680 | 0) >> 2] = $2950;
                          HEAP32[($4 + 684 | 0) >> 2] = i64toi32_i32$0;
                          label$176 : {
                           if (!(HEAP32[($4 + 400 | 0) >> 2] | 0)) {
                            break label$176
                           }
                           $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($20 | 0);
                          }
                          i64toi32_i32$1 = $3;
                          i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                          i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                          $2959 = i64toi32_i32$0;
                          i64toi32_i32$0 = ($4 + 392 | 0) + 16 | 0;
                          HEAP32[i64toi32_i32$0 >> 2] = $2959;
                          HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$5;
                          i64toi32_i32$1 = $26;
                          i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                          i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                          $2964 = i64toi32_i32$5;
                          i64toi32_i32$5 = ($4 + 392 | 0) + 8 | 0;
                          HEAP32[i64toi32_i32$5 >> 2] = $2964;
                          HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
                          i64toi32_i32$1 = $4;
                          i64toi32_i32$0 = HEAP32[($4 + 680 | 0) >> 2] | 0;
                          i64toi32_i32$5 = HEAP32[($4 + 684 | 0) >> 2] | 0;
                          $2967 = i64toi32_i32$0;
                          i64toi32_i32$0 = $4;
                          HEAP32[($4 + 392 | 0) >> 2] = $2967;
                          HEAP32[($4 + 396 | 0) >> 2] = i64toi32_i32$5;
                          label$177 : {
                           if (!(HEAP32[($4 + 872 | 0) >> 2] | 0)) {
                            break label$177
                           }
                           $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($14 | 0);
                          }
                          $6 = $6 + 4 | 0;
                          $12 = $12 + -4 | 0;
                          if (!$12) {
                           break label$168
                          }
                          continue label$173;
                         }
                         break label$173;
                        };
                        $3 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($4 + 716 | 0) >> 2] | 0 | 0) | 0;
                        if (!(HEAP32[($4 + 872 | 0) >> 2] | 0)) {
                         break label$145
                        }
                        $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($14 | 0);
                        break label$145;
                       }
                       core__panicking__panic__h2fd385a887c8bf13(1063668 | 0, 43 | 0, 1065024 | 0);
                       abort();
                      }
                      core__panicking__panic_bounds_check__h808b524af17640b1($3 | 0, $23 | 0, 1065040 | 0);
                      abort();
                     }
                     $3 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($4 + 716 | 0) >> 2] | 0 | 0) | 0;
                     break label$145;
                    }
                    $3 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($4 + 716 | 0) >> 2] | 0 | 0) | 0;
                    break label$145;
                   }
                   $19 = $19 + 128 | 0;
                   if (($19 | 0) != ($22 | 0)) {
                    continue label$167
                   }
                   break label$167;
                  };
                  $3 = $24 << 7 | 0;
                  label$178 : while (1) {
                   core__ptr__drop_in_place_cardano_serialization_lib__TransactionOutput___h632b3a99817e6ac5_1($2 | 0);
                   $2 = $2 + 128 | 0;
                   $3 = $3 + -128 | 0;
                   if ($3) {
                    continue label$178
                   }
                   break label$178;
                  };
                 }
                 $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h5107e2b13c386680($4 + 536 | 0 | 0);
                 $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h903e00ab7dfc505c($4 + 504 | 0 | 0);
                 $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hb513c626355ab1b6($4 + 472 | 0 | 0);
                 $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h515a508dccfbb69c($4 + 472 | 0 | 0);
                 label$179 : {
                  label$180 : {
                   label$181 : {
                    label$182 : {
                     label$183 : {
                      label$184 : {
                       label$185 : {
                        label$186 : {
                         i64toi32_i32$1 = $4;
                         i64toi32_i32$5 = HEAP32[($4 + 368 | 0) >> 2] | 0;
                         i64toi32_i32$0 = HEAP32[($4 + 372 | 0) >> 2] | 0;
                         $3015 = i64toi32_i32$5;
                         $3015$hi = i64toi32_i32$0;
                         i64toi32_i32$1 = $4;
                         i64toi32_i32$0 = HEAP32[($4 + 392 | 0) >> 2] | 0;
                         i64toi32_i32$5 = HEAP32[($4 + 396 | 0) >> 2] | 0;
                         $3017 = i64toi32_i32$0;
                         $3017$hi = i64toi32_i32$5;
                         i64toi32_i32$5 = $3015$hi;
                         i64toi32_i32$1 = $3015;
                         i64toi32_i32$0 = $3017$hi;
                         i64toi32_i32$3 = $3017;
                         if (i64toi32_i32$5 >>> 0 > i64toi32_i32$0 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$1 >>> 0 >= i64toi32_i32$3 >>> 0 | 0) | 0) {
                          break label$186
                         }
                         $23 = $1 + 96 | 0;
                         $27 = ($4 + 864 | 0) + 12 | 0;
                         $21 = ($4 + 392 | 0) + 12 | 0;
                         $5 = ($4 + 712 | 0) + 8 | 0;
                         $12 = ($4 + 368 | 0) + 12 | 0;
                         label$187 : while (1) {
                          $2 = HEAP32[($4 + 672 | 0) >> 2] | 0;
                          if (!$2) {
                           break label$181
                          }
                          label$188 : {
                           label$189 : {
                            $3 = HEAP32[($4 + 668 | 0) >> 2] | 0;
                            if (!$3) {
                             break label$189
                            }
                            $6 = HEAP32[($4 + 664 | 0) >> 2] | 0;
                            alloc__collections__btree__navigate__full_range__hfcebc6cee2db4b73($4 + 712 | 0 | 0, $6 | 0, $3 | 0, $6 | 0, $3 | 0);
                            $3 = HEAP32[($4 + 672 | 0) >> 2] | 0;
                            break label$188;
                           }
                           HEAP32[($4 + 728 | 0) >> 2] = 0;
                           HEAP32[($4 + 716 | 0) >> 2] = 0;
                           $3 = $2;
                           $2 = 0;
                          }
                          HEAP32[($4 + 736 | 0) >> 2] = $2;
                          label$190 : {
                           $3 = rand__rng__Rng__gen_range__he28987be934355f0($4 + 632 | 0 | 0, 0 | 0, $3 | 0) | 0;
                           if (!$3) {
                            break label$190
                           }
                           $2 = 0;
                           label$191 : while (1) {
                            $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h1af0b182f7766c68($4 + 56 | 0 | 0, $4 + 712 | 0 | 0);
                            if (!(HEAP32[($4 + 56 | 0) >> 2] | 0)) {
                             break label$184
                            }
                            $2 = $2 + 1 | 0;
                            if (($3 | 0) != ($2 | 0)) {
                             continue label$191
                            }
                            break label$191;
                           };
                          }
                          $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h1af0b182f7766c68($4 + 48 | 0 | 0, $4 + 712 | 0 | 0);
                          $2 = HEAP32[($4 + 48 | 0) >> 2] | 0;
                          if (!$2) {
                           break label$183
                          }
                          HEAP32[($4 + 568 | 0) >> 2] = HEAP32[$2 >> 2] | 0;
                          alloc__collections__btree__map__BTreeMap_K_2cV___remove_entry__haaee74feca9cfb03($4 + 40 | 0 | 0, $4 + 664 | 0 | 0, $4 + 568 | 0 | 0);
                          $3 = HEAP32[($4 + 360 | 0) >> 2] | 0;
                          $2 = HEAP32[($4 + 568 | 0) >> 2] | 0;
                          if ($3 >>> 0 <= $2 >>> 0) {
                           break label$182
                          }
                          $2 = (HEAP32[($4 + 352 | 0) >> 2] | 0) + Math_imul($2, 168) | 0;
                          $6 = $2 + 128 | 0;
                          $3 = $2 + 64 | 0;
                          cardano_serialization_lib__tx_builder__TransactionBuilder__fee_for_input__ha5a0f735cbb9ab50($4 + 712 | 0 | 0, $1 | 0, $2 | 0, $6 | 0, $3 | 0);
                          if ((HEAP32[($4 + 712 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                           break label$180
                          }
                          i64toi32_i32$3 = $4;
                          i64toi32_i32$1 = HEAP32[($4 + 720 | 0) >> 2] | 0;
                          i64toi32_i32$5 = HEAP32[($4 + 724 | 0) >> 2] | 0;
                          $28 = i64toi32_i32$1;
                          $28$hi = i64toi32_i32$5;
                          cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__add_input__hd22960e5a7d88824($23 | 0, $2 | 0, $6 | 0, $3 | 0);
                          cardano_serialization_lib__utils__Value__checked_add__h5184687782847801($4 + 712 | 0 | 0, $4 + 368 | 0 | 0, $3 | 0);
                          if ((HEAP32[($4 + 712 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                           break label$179
                          }
                          $2 = ($4 + 864 | 0) + 16 | 0;
                          $6 = $5 + 16 | 0;
                          i64toi32_i32$3 = $6;
                          i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                          i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                          $3137 = i64toi32_i32$5;
                          i64toi32_i32$5 = $2;
                          HEAP32[i64toi32_i32$5 >> 2] = $3137;
                          HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$1;
                          $3 = ($4 + 864 | 0) + 8 | 0;
                          $26 = $5 + 8 | 0;
                          i64toi32_i32$3 = $26;
                          i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                          i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                          $3145 = i64toi32_i32$1;
                          i64toi32_i32$1 = $3;
                          HEAP32[i64toi32_i32$1 >> 2] = $3145;
                          HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$5;
                          i64toi32_i32$3 = $5;
                          i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                          i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                          $3148 = i64toi32_i32$5;
                          i64toi32_i32$5 = $4;
                          HEAP32[($4 + 864 | 0) >> 2] = $3148;
                          HEAP32[($4 + 868 | 0) >> 2] = i64toi32_i32$1;
                          label$192 : {
                           if (!(HEAP32[($4 + 376 | 0) >> 2] | 0)) {
                            break label$192
                           }
                           $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($12 | 0);
                          }
                          i64toi32_i32$3 = $2;
                          i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                          i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                          $3157 = i64toi32_i32$1;
                          i64toi32_i32$1 = ($4 + 368 | 0) + 16 | 0;
                          HEAP32[i64toi32_i32$1 >> 2] = $3157;
                          HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$5;
                          i64toi32_i32$3 = $3;
                          i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                          i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                          $3162 = i64toi32_i32$5;
                          i64toi32_i32$5 = ($4 + 368 | 0) + 8 | 0;
                          HEAP32[i64toi32_i32$5 >> 2] = $3162;
                          HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$1;
                          i64toi32_i32$3 = $4;
                          i64toi32_i32$1 = HEAP32[($4 + 864 | 0) >> 2] | 0;
                          i64toi32_i32$5 = HEAP32[($4 + 868 | 0) >> 2] | 0;
                          $3165 = i64toi32_i32$1;
                          i64toi32_i32$1 = $4;
                          HEAP32[($4 + 368 | 0) >> 2] = $3165;
                          HEAP32[($4 + 372 | 0) >> 2] = i64toi32_i32$5;
                          HEAP32[($4 + 872 | 0) >> 2] = 0;
                          i64toi32_i32$5 = $28$hi;
                          i64toi32_i32$1 = $4;
                          HEAP32[($4 + 864 | 0) >> 2] = $28;
                          HEAP32[($4 + 868 | 0) >> 2] = i64toi32_i32$5;
                          cardano_serialization_lib__utils__Value__checked_add__h5184687782847801($4 + 712 | 0 | 0, $4 + 392 | 0 | 0, $4 + 864 | 0 | 0);
                          if ((HEAP32[($4 + 712 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                           break label$185
                          }
                          $2 = ($4 + 680 | 0) + 16 | 0;
                          i64toi32_i32$3 = $6;
                          i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                          i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                          $3183 = i64toi32_i32$5;
                          i64toi32_i32$5 = $2;
                          HEAP32[i64toi32_i32$5 >> 2] = $3183;
                          HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$1;
                          $3 = ($4 + 680 | 0) + 8 | 0;
                          i64toi32_i32$3 = $26;
                          i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                          i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                          $3189 = i64toi32_i32$1;
                          i64toi32_i32$1 = $3;
                          HEAP32[i64toi32_i32$1 >> 2] = $3189;
                          HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$5;
                          i64toi32_i32$3 = $5;
                          i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                          i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                          $3192 = i64toi32_i32$5;
                          i64toi32_i32$5 = $4;
                          HEAP32[($4 + 680 | 0) >> 2] = $3192;
                          HEAP32[($4 + 684 | 0) >> 2] = i64toi32_i32$1;
                          label$193 : {
                           if (!(HEAP32[($4 + 400 | 0) >> 2] | 0)) {
                            break label$193
                           }
                           $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($21 | 0);
                          }
                          i64toi32_i32$3 = $2;
                          i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                          i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                          $3201 = i64toi32_i32$1;
                          i64toi32_i32$1 = ($4 + 392 | 0) + 16 | 0;
                          HEAP32[i64toi32_i32$1 >> 2] = $3201;
                          HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$5;
                          i64toi32_i32$3 = $3;
                          i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                          i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                          $3206 = i64toi32_i32$5;
                          i64toi32_i32$5 = ($4 + 392 | 0) + 8 | 0;
                          HEAP32[i64toi32_i32$5 >> 2] = $3206;
                          HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$1;
                          i64toi32_i32$3 = $4;
                          i64toi32_i32$1 = HEAP32[($4 + 680 | 0) >> 2] | 0;
                          i64toi32_i32$5 = HEAP32[($4 + 684 | 0) >> 2] | 0;
                          $3209 = i64toi32_i32$1;
                          i64toi32_i32$1 = $4;
                          HEAP32[($4 + 392 | 0) >> 2] = $3209;
                          HEAP32[($4 + 396 | 0) >> 2] = i64toi32_i32$5;
                          label$194 : {
                           if (!(HEAP32[($4 + 872 | 0) >> 2] | 0)) {
                            break label$194
                           }
                           $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($27 | 0);
                          }
                          i64toi32_i32$3 = $4;
                          i64toi32_i32$5 = HEAP32[($4 + 368 | 0) >> 2] | 0;
                          i64toi32_i32$1 = HEAP32[($4 + 372 | 0) >> 2] | 0;
                          $3215 = i64toi32_i32$5;
                          $3215$hi = i64toi32_i32$1;
                          i64toi32_i32$3 = $4;
                          i64toi32_i32$1 = HEAP32[($4 + 392 | 0) >> 2] | 0;
                          i64toi32_i32$5 = HEAP32[($4 + 396 | 0) >> 2] | 0;
                          $3217 = i64toi32_i32$1;
                          $3217$hi = i64toi32_i32$5;
                          i64toi32_i32$5 = $3215$hi;
                          i64toi32_i32$3 = $3215;
                          i64toi32_i32$1 = $3217$hi;
                          i64toi32_i32$0 = $3217;
                          if (i64toi32_i32$5 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$3 >>> 0 < i64toi32_i32$0 >>> 0 | 0) | 0) {
                           continue label$187
                          }
                          break label$187;
                         };
                        }
                        $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h6e0c34e8fa561cb7($4 + 664 | 0 | 0);
                        $alloc__rc__Rc_T__20as_20core__ops__drop__Drop___drop__h9c6f1ce9a80847e3($4 + 632 | 0 | 0);
                        break label$9;
                       }
                       $3 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($4 + 716 | 0) >> 2] | 0 | 0) | 0;
                       if (!(HEAP32[($4 + 872 | 0) >> 2] | 0)) {
                        break label$144
                       }
                       $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($27 | 0);
                       break label$144;
                      }
                      $T_20as_20core__convert__From_T____from__h09bdeba94dd58819($2 | 0) | 0;
                     }
                     core__panicking__panic__h2fd385a887c8bf13(1063668 | 0, 43 | 0, 1064652 | 0);
                     abort();
                    }
                    core__panicking__panic_bounds_check__h808b524af17640b1($2 | 0, $3 | 0, 1064668 | 0);
                    abort();
                   }
                   $3 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1064505 | 0, 28 | 0) | 0;
                   break label$144;
                  }
                  $3 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($4 + 716 | 0) >> 2] | 0 | 0) | 0;
                  break label$144;
                 }
                 $3 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($4 + 716 | 0) >> 2] | 0 | 0) | 0;
                 break label$144;
                }
                core__panicking__panic_bounds_check__h808b524af17640b1($3 | 0, $26 | 0, 1064928 | 0);
                abort();
               }
               alloc__vec__Vec_T_2cA___swap_remove__assert_failed__h35befc50802f56b5($3 | 0, $6 | 0);
               abort();
              }
              $3 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1064884 | 0, 25 | 0) | 0;
             }
             $1 = $24 << 7 | 0;
             label$195 : while (1) {
              core__ptr__drop_in_place_cardano_serialization_lib__TransactionOutput___h632b3a99817e6ac5_1($2 | 0);
              $2 = $2 + 128 | 0;
              $1 = $1 + -128 | 0;
              if ($1) {
               continue label$195
              }
              break label$195;
             };
             $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h5107e2b13c386680($4 + 536 | 0 | 0);
             $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h903e00ab7dfc505c($4 + 504 | 0 | 0);
             $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hb513c626355ab1b6($4 + 472 | 0 | 0);
             $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h515a508dccfbb69c($4 + 472 | 0 | 0);
             $3 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($3 | 0) | 0;
            }
            $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h6e0c34e8fa561cb7($4 + 664 | 0 | 0);
            $alloc__rc__Rc_T__20as_20core__ops__drop__Drop___drop__h9c6f1ce9a80847e3($4 + 632 | 0 | 0);
            break label$5;
           }
           $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter__SpecFromIter_T_2cI____from_iter__h6366b5bc3d433487($4 + 632 | 0 | 0, 0 | 0, HEAP32[($4 + 360 | 0) >> 2] | 0 | 0);
           label$196 : {
            label$197 : {
             if ((HEAP32[($4 + 400 | 0) >> 2] | 0 | 0) != (1 | 0)) {
              break label$197
             }
             $19 = ($4 + 392 | 0) + 12 | 0;
             $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($4 + 664 | 0 | 4 | 0 | 0, $19 | 0);
             HEAP32[($4 + 664 | 0) >> 2] = 1;
             HEAP32[($4 + 656 | 0) >> 2] = HEAP32[(($4 + 664 | 0) + 12 | 0) >> 2] | 0;
             i64toi32_i32$0 = $4;
             i64toi32_i32$3 = HEAP32[($4 + 668 | 0) >> 2] | 0;
             i64toi32_i32$5 = HEAP32[($4 + 672 | 0) >> 2] | 0;
             $3291 = i64toi32_i32$3;
             i64toi32_i32$3 = $4;
             HEAP32[($4 + 648 | 0) >> 2] = $3291;
             HEAP32[($4 + 652 | 0) >> 2] = i64toi32_i32$5;
             label$198 : {
              label$199 : {
               $2 = HEAP32[($4 + 652 | 0) >> 2] | 0;
               if (!$2) {
                break label$199
               }
               $3 = HEAP32[($4 + 648 | 0) >> 2] | 0;
               alloc__collections__btree__navigate__full_range__hd4dadfd3315a2ab8($4 + 536 | 0 | 0, $3 | 0, $2 | 0, $3 | 0, $2 | 0);
               $2 = HEAP32[($4 + 656 | 0) >> 2] | 0;
               break label$198;
              }
              $2 = 0;
              HEAP32[($4 + 552 | 0) >> 2] = 0;
              HEAP32[($4 + 540 | 0) >> 2] = 0;
             }
             HEAP32[(($4 + 536 | 0) + 24 | 0) >> 2] = $2;
             HEAP32[(($4 + 568 | 0) + 24 | 0) >> 2] = $2;
             i64toi32_i32$0 = ($4 + 536 | 0) + 16 | 0;
             i64toi32_i32$5 = HEAP32[i64toi32_i32$0 >> 2] | 0;
             i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
             $3323 = i64toi32_i32$5;
             i64toi32_i32$5 = ($4 + 568 | 0) + 16 | 0;
             HEAP32[i64toi32_i32$5 >> 2] = $3323;
             HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$3;
             i64toi32_i32$0 = ($4 + 536 | 0) + 8 | 0;
             i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
             i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
             $3330 = i64toi32_i32$3;
             i64toi32_i32$3 = ($4 + 568 | 0) + 8 | 0;
             HEAP32[i64toi32_i32$3 >> 2] = $3330;
             HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
             i64toi32_i32$0 = $4;
             i64toi32_i32$5 = HEAP32[($4 + 536 | 0) >> 2] | 0;
             i64toi32_i32$3 = HEAP32[($4 + 540 | 0) >> 2] | 0;
             $3333 = i64toi32_i32$5;
             i64toi32_i32$5 = $4;
             HEAP32[($4 + 568 | 0) >> 2] = $3333;
             HEAP32[($4 + 572 | 0) >> 2] = i64toi32_i32$3;
             $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h03cc330b7b1e4522($4 + 208 | 0 | 0, $4 + 568 | 0 | 0);
             label$200 : {
              $2 = HEAP32[($4 + 208 | 0) >> 2] | 0;
              if (!$2) {
               break label$200
              }
              $3 = HEAP32[($4 + 212 | 0) >> 2] | 0;
              $15 = $1 + 96 | 0;
              $27 = $4 + 712 | 0 | 4 | 0;
              $22 = ($4 + 504 | 0) + 12 | 0;
              $12 = ($4 + 712 | 0) + 8 | 0;
              $14 = ($4 + 368 | 0) + 12 | 0;
              $21 = ($4 + 392 | 0) + 12 | 0;
              label$201 : while (1) {
               HEAP32[($4 + 608 | 0) >> 2] = $2;
               alloc__collections__btree__map__BTreeMap_K_2cV___iter__ha89c9458aca0228d($4 + 680 | 0 | 0, $3 | 0);
               HEAP32[(($4 + 864 | 0) + 24 | 0) >> 2] = HEAP32[(($4 + 680 | 0) + 24 | 0) >> 2] | 0;
               i64toi32_i32$0 = ($4 + 680 | 0) + 16 | 0;
               i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
               i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
               $3379 = i64toi32_i32$3;
               i64toi32_i32$3 = ($4 + 864 | 0) + 16 | 0;
               HEAP32[i64toi32_i32$3 >> 2] = $3379;
               HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
               i64toi32_i32$0 = ($4 + 680 | 0) + 8 | 0;
               i64toi32_i32$5 = HEAP32[i64toi32_i32$0 >> 2] | 0;
               i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
               $3386 = i64toi32_i32$5;
               i64toi32_i32$5 = ($4 + 864 | 0) + 8 | 0;
               HEAP32[i64toi32_i32$5 >> 2] = $3386;
               HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$3;
               i64toi32_i32$0 = $4;
               i64toi32_i32$3 = HEAP32[($4 + 680 | 0) >> 2] | 0;
               i64toi32_i32$5 = HEAP32[($4 + 684 | 0) >> 2] | 0;
               $3389 = i64toi32_i32$3;
               i64toi32_i32$3 = $4;
               HEAP32[($4 + 864 | 0) >> 2] = $3389;
               HEAP32[($4 + 868 | 0) >> 2] = i64toi32_i32$5;
               $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h36ca092f81b9a0fa($4 + 200 | 0 | 0, $4 + 864 | 0 | 0);
               label$202 : {
                $2 = HEAP32[($4 + 200 | 0) >> 2] | 0;
                if (!$2) {
                 break label$202
                }
                label$203 : {
                 label$204 : while (1) {
                  HEAP32[($4 + 424 | 0) >> 2] = $2;
                  HEAP32[($4 + 620 | 0) >> 2] = $4 + 424 | 0;
                  HEAP32[($4 + 616 | 0) >> 2] = $4 + 608 | 0;
                  HEAP32[($4 + 456 | 0) >> 2] = $4 + 352 | 0;
                  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h0f0d6987a7f36efc($4 + 192 | 0 | 0, $4 + 632 | 0 | 0);
                  $3 = HEAP32[($4 + 192 | 0) >> 2] | 0;
                  $2 = HEAP32[($4 + 196 | 0) >> 2] | 0;
                  alloc__raw_vec__RawVec_T_2cA___allocate_in__h5dada854c892eb3e($4 + 184 | 0 | 0, $2 | 0, 0 | 0);
                  HEAP32[($4 + 444 | 0) >> 2] = HEAP32[($4 + 188 | 0) >> 2] | 0;
                  $5 = HEAP32[($4 + 184 | 0) >> 2] | 0;
                  HEAP32[($4 + 440 | 0) >> 2] = $5;
                  memcpy($5 | 0, $3 | 0, $2 << 2 | 0 | 0) | 0;
                  HEAP32[($4 + 448 | 0) >> 2] = $2;
                  alloc__vec__Vec_T_2cA___retain__h41a06215048992f1($4 + 440 | 0 | 0, $4 + 616 | 0 | 0, $4 + 456 | 0 | 0);
                  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__DerefMut___deref_mut__h42fc515862cf6b48($4 + 176 | 0 | 0, $4 + 440 | 0 | 0);
                  $2 = HEAP32[($4 + 180 | 0) >> 2] | 0;
                  $3 = HEAP32[($4 + 176 | 0) >> 2] | 0;
                  HEAP32[($4 + 716 | 0) >> 2] = $4 + 456 | 0;
                  HEAP32[($4 + 712 | 0) >> 2] = $4 + 616 | 0;
                  alloc__slice__merge_sort__h5aa492ad566875d8($3 | 0, $2 | 0, $4 + 712 | 0 | 0);
                  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h0f0d6987a7f36efc($4 + 168 | 0 | 0, $4 + 440 | 0 | 0);
                  label$205 : {
                   $2 = HEAP32[($4 + 172 | 0) >> 2] | 0;
                   if (!$2) {
                    break label$205
                   }
                   $20 = HEAP32[($4 + 168 | 0) >> 2] | 0;
                   $23 = $20 + ($2 << 2 | 0) | 0;
                   label$206 : {
                    label$207 : {
                     label$208 : {
                      label$209 : while (1) {
                       label$210 : {
                        label$211 : {
                         if ((HEAP32[($4 + 376 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                          break label$211
                         }
                         cardano_serialization_lib__MultiAsset__get__had0c36a2c855d776($4 + 712 | 0 | 0, $14 | 0, HEAP32[(HEAP32[($4 + 616 | 0) >> 2] | 0) >> 2] | 0 | 0);
                         if ((HEAP32[($4 + 712 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                          break label$211
                         }
                         HEAP32[(($4 + 504 | 0) + 8 | 0) >> 2] = HEAP32[($27 + 8 | 0) >> 2] | 0;
                         i64toi32_i32$0 = $27;
                         i64toi32_i32$5 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                         i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                         $3492 = i64toi32_i32$5;
                         i64toi32_i32$5 = $4;
                         HEAP32[($4 + 504 | 0) >> 2] = $3492;
                         HEAP32[($4 + 508 | 0) >> 2] = i64toi32_i32$3;
                         label$212 : {
                          $2 = alloc__collections__btree__map__BTreeMap_K_2cV___get__h825f34112f7eacbf($4 + 504 | 0 | 0, HEAP32[(HEAP32[($4 + 620 | 0) >> 2] | 0) >> 2] | 0 | 0) | 0;
                          if (!$2) {
                           break label$212
                          }
                          i64toi32_i32$0 = $2;
                          i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                          i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                          $28 = i64toi32_i32$3;
                          $28$hi = i64toi32_i32$5;
                         }
                         $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h6c9f94f0f82ce2b5($4 + 504 | 0 | 0);
                         if ($2) {
                          break label$210
                         }
                        }
                        i64toi32_i32$5 = 0;
                        $28 = 0;
                        $28$hi = i64toi32_i32$5;
                       }
                       label$213 : {
                        label$214 : {
                         if ((HEAP32[($4 + 400 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                          break label$214
                         }
                         cardano_serialization_lib__MultiAsset__get__had0c36a2c855d776($4 + 712 | 0 | 0, $21 | 0, HEAP32[(HEAP32[($4 + 616 | 0) >> 2] | 0) >> 2] | 0 | 0);
                         if ((HEAP32[($4 + 712 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                          break label$214
                         }
                         $5 = ($4 + 504 | 0) + 8 | 0;
                         HEAP32[$5 >> 2] = HEAP32[($27 + 8 | 0) >> 2] | 0;
                         i64toi32_i32$0 = $27;
                         i64toi32_i32$5 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                         i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                         $3527 = i64toi32_i32$5;
                         i64toi32_i32$5 = $4;
                         HEAP32[($4 + 504 | 0) >> 2] = $3527;
                         HEAP32[($4 + 508 | 0) >> 2] = i64toi32_i32$3;
                         $2 = alloc__collections__btree__map__BTreeMap_K_2cV___get__h825f34112f7eacbf($4 + 504 | 0 | 0, HEAP32[(HEAP32[($4 + 620 | 0) >> 2] | 0) >> 2] | 0 | 0) | 0;
                         if ($2) {
                          break label$213
                         }
                         $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h6c9f94f0f82ce2b5($4 + 504 | 0 | 0);
                        }
                        core__option__expect_failed__h66afff61e82fdd86(1064766 | 0, 52 | 0, 1064820 | 0);
                        abort();
                       }
                       i64toi32_i32$0 = $2;
                       i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                       i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                       $29 = i64toi32_i32$3;
                       $29$hi = i64toi32_i32$5;
                       $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h6c9f94f0f82ce2b5($4 + 504 | 0 | 0);
                       i64toi32_i32$5 = $28$hi;
                       i64toi32_i32$5 = $29$hi;
                       i64toi32_i32$5 = $28$hi;
                       i64toi32_i32$0 = $28;
                       i64toi32_i32$3 = $29$hi;
                       i64toi32_i32$1 = $29;
                       if (i64toi32_i32$5 >>> 0 > i64toi32_i32$3 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$0 >>> 0 >= i64toi32_i32$1 >>> 0 | 0) | 0) {
                        break label$205
                       }
                       $3 = HEAP32[($4 + 456 | 0) >> 2] | 0;
                       $6 = HEAP32[($3 + 8 | 0) >> 2] | 0;
                       $23 = $23 + -4 | 0;
                       $2 = HEAP32[$23 >> 2] | 0;
                       if ($6 >>> 0 <= $2 >>> 0) {
                        break label$207
                       }
                       $2 = (HEAP32[$3 >> 2] | 0) + Math_imul($2, 168) | 0;
                       $6 = $2 + 128 | 0;
                       $3 = $2 + 64 | 0;
                       cardano_serialization_lib__tx_builder__TransactionBuilder__fee_for_input__ha5a0f735cbb9ab50($4 + 712 | 0 | 0, $1 | 0, $2 | 0, $6 | 0, $3 | 0);
                       if ((HEAP32[($4 + 712 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                        break label$208
                       }
                       i64toi32_i32$1 = $4;
                       i64toi32_i32$0 = HEAP32[($4 + 720 | 0) >> 2] | 0;
                       i64toi32_i32$5 = HEAP32[($4 + 724 | 0) >> 2] | 0;
                       $28 = i64toi32_i32$0;
                       $28$hi = i64toi32_i32$5;
                       cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__add_input__hd22960e5a7d88824($15 | 0, $2 | 0, $6 | 0, $3 | 0);
                       cardano_serialization_lib__utils__Value__checked_add__h5184687782847801($4 + 712 | 0 | 0, $4 + 368 | 0 | 0, $3 | 0);
                       label$215 : {
                        label$216 : {
                         label$217 : {
                          if ((HEAP32[($4 + 712 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                           break label$217
                          }
                          $2 = ($4 + 504 | 0) + 16 | 0;
                          $3 = $12 + 16 | 0;
                          i64toi32_i32$1 = $3;
                          i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                          i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                          $3594 = i64toi32_i32$5;
                          i64toi32_i32$5 = $2;
                          HEAP32[i64toi32_i32$5 >> 2] = $3594;
                          HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
                          $6 = $12 + 8 | 0;
                          i64toi32_i32$1 = $6;
                          i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                          i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                          $3599 = i64toi32_i32$0;
                          i64toi32_i32$0 = $5;
                          HEAP32[i64toi32_i32$0 >> 2] = $3599;
                          HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$5;
                          i64toi32_i32$1 = $12;
                          i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                          i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                          $3602 = i64toi32_i32$5;
                          i64toi32_i32$5 = $4;
                          HEAP32[($4 + 504 | 0) >> 2] = $3602;
                          HEAP32[($4 + 508 | 0) >> 2] = i64toi32_i32$0;
                          label$218 : {
                           if (!(HEAP32[($4 + 376 | 0) >> 2] | 0)) {
                            break label$218
                           }
                           $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($14 | 0);
                          }
                          i64toi32_i32$1 = $2;
                          i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                          i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                          $3611 = i64toi32_i32$0;
                          i64toi32_i32$0 = ($4 + 368 | 0) + 16 | 0;
                          HEAP32[i64toi32_i32$0 >> 2] = $3611;
                          HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$5;
                          i64toi32_i32$1 = $5;
                          i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                          i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                          $3616 = i64toi32_i32$5;
                          i64toi32_i32$5 = ($4 + 368 | 0) + 8 | 0;
                          HEAP32[i64toi32_i32$5 >> 2] = $3616;
                          HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
                          i64toi32_i32$1 = $4;
                          i64toi32_i32$0 = HEAP32[($4 + 504 | 0) >> 2] | 0;
                          i64toi32_i32$5 = HEAP32[($4 + 508 | 0) >> 2] | 0;
                          $3619 = i64toi32_i32$0;
                          i64toi32_i32$0 = $4;
                          HEAP32[($4 + 368 | 0) >> 2] = $3619;
                          HEAP32[($4 + 372 | 0) >> 2] = i64toi32_i32$5;
                          HEAP32[($4 + 512 | 0) >> 2] = 0;
                          i64toi32_i32$5 = $28$hi;
                          i64toi32_i32$0 = $4;
                          HEAP32[($4 + 504 | 0) >> 2] = $28;
                          HEAP32[($4 + 508 | 0) >> 2] = i64toi32_i32$5;
                          cardano_serialization_lib__utils__Value__checked_add__h5184687782847801($4 + 712 | 0 | 0, $4 + 392 | 0 | 0, $4 + 504 | 0 | 0);
                          if ((HEAP32[($4 + 712 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                           break label$215
                          }
                          $2 = ($4 + 472 | 0) + 16 | 0;
                          i64toi32_i32$1 = $3;
                          i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                          i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                          $3637 = i64toi32_i32$5;
                          i64toi32_i32$5 = $2;
                          HEAP32[i64toi32_i32$5 >> 2] = $3637;
                          HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
                          $3 = ($4 + 472 | 0) + 8 | 0;
                          i64toi32_i32$1 = $6;
                          i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                          i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                          $3643 = i64toi32_i32$0;
                          i64toi32_i32$0 = $3;
                          HEAP32[i64toi32_i32$0 >> 2] = $3643;
                          HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$5;
                          i64toi32_i32$1 = $12;
                          i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                          i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                          $3646 = i64toi32_i32$5;
                          i64toi32_i32$5 = $4;
                          HEAP32[($4 + 472 | 0) >> 2] = $3646;
                          HEAP32[($4 + 476 | 0) >> 2] = i64toi32_i32$0;
                          label$219 : {
                           if (!(HEAP32[($4 + 400 | 0) >> 2] | 0)) {
                            break label$219
                           }
                           $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($19 | 0);
                          }
                          i64toi32_i32$1 = $2;
                          i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                          i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                          $3655 = i64toi32_i32$0;
                          i64toi32_i32$0 = ($4 + 392 | 0) + 16 | 0;
                          HEAP32[i64toi32_i32$0 >> 2] = $3655;
                          HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$5;
                          i64toi32_i32$1 = $3;
                          i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                          i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                          $3660 = i64toi32_i32$5;
                          i64toi32_i32$5 = ($4 + 392 | 0) + 8 | 0;
                          HEAP32[i64toi32_i32$5 >> 2] = $3660;
                          HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
                          i64toi32_i32$1 = $4;
                          i64toi32_i32$0 = HEAP32[($4 + 472 | 0) >> 2] | 0;
                          i64toi32_i32$5 = HEAP32[($4 + 476 | 0) >> 2] | 0;
                          $3663 = i64toi32_i32$0;
                          i64toi32_i32$0 = $4;
                          HEAP32[($4 + 392 | 0) >> 2] = $3663;
                          HEAP32[($4 + 396 | 0) >> 2] = i64toi32_i32$5;
                          label$220 : {
                           if (!(HEAP32[($4 + 512 | 0) >> 2] | 0)) {
                            break label$220
                           }
                           $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($22 | 0);
                          }
                          $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h0f0d6987a7f36efc($4 + 160 | 0 | 0, $4 + 632 | 0 | 0);
                          label$221 : {
                           $2 = HEAP32[($4 + 164 | 0) >> 2] | 0;
                           if (!$2) {
                            break label$221
                           }
                           $5 = HEAP32[($4 + 160 | 0) >> 2] | 0;
                           $26 = $2 << 2 | 0;
                           $6 = HEAP32[$23 >> 2] | 0;
                           $2 = 0;
                           $3 = 0;
                           label$222 : while (1) {
                            if (($6 | 0) == (HEAP32[($5 + $2 | 0) >> 2] | 0 | 0)) {
                             break label$216
                            }
                            $3 = $3 + 1 | 0;
                            $2 = $2 + 4 | 0;
                            if (($26 | 0) != ($2 | 0)) {
                             continue label$222
                            }
                            break label$222;
                           };
                          }
                          core__panicking__panic__h2fd385a887c8bf13(1063668 | 0, 43 | 0, 1064852 | 0);
                          abort();
                         }
                         $2 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($4 + 716 | 0) >> 2] | 0 | 0) | 0;
                         break label$203;
                        }
                        $5 = HEAP32[($4 + 640 | 0) >> 2] | 0;
                        if ($5 >>> 0 <= $3 >>> 0) {
                         break label$206
                        }
                        $3 = HEAP32[($4 + 632 | 0) >> 2] | 0;
                        $5 = $5 + -1 | 0;
                        HEAP32[($4 + 640 | 0) >> 2] = $5;
                        HEAP32[($3 + $2 | 0) >> 2] = HEAP32[($3 + ($5 << 2 | 0) | 0) >> 2] | 0;
                        if (($20 | 0) != ($23 | 0)) {
                         continue label$209
                        }
                        break label$205;
                       }
                       break label$209;
                      };
                      $2 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($4 + 716 | 0) >> 2] | 0 | 0) | 0;
                      if (!(HEAP32[($4 + 512 | 0) >> 2] | 0)) {
                       break label$203
                      }
                      $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($22 | 0);
                      break label$203;
                     }
                     $2 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($4 + 716 | 0) >> 2] | 0 | 0) | 0;
                     break label$203;
                    }
                    core__panicking__panic_bounds_check__h808b524af17640b1($2 | 0, $6 | 0, 1064836 | 0);
                    abort();
                   }
                   alloc__vec__Vec_T_2cA___swap_remove__assert_failed__h35befc50802f56b5($3 | 0, $5 | 0);
                   abort();
                  }
                  label$223 : {
                   label$224 : {
                    if ((HEAP32[($4 + 376 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                     break label$224
                    }
                    cardano_serialization_lib__MultiAsset__get__had0c36a2c855d776($4 + 712 | 0 | 0, $14 | 0, HEAP32[(HEAP32[($4 + 616 | 0) >> 2] | 0) >> 2] | 0 | 0);
                    if ((HEAP32[($4 + 712 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                     break label$224
                    }
                    HEAP32[(($4 + 504 | 0) + 8 | 0) >> 2] = HEAP32[($27 + 8 | 0) >> 2] | 0;
                    i64toi32_i32$1 = $27;
                    i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                    i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                    $3754 = i64toi32_i32$5;
                    i64toi32_i32$5 = $4;
                    HEAP32[($4 + 504 | 0) >> 2] = $3754;
                    HEAP32[($4 + 508 | 0) >> 2] = i64toi32_i32$0;
                    label$225 : {
                     $2 = alloc__collections__btree__map__BTreeMap_K_2cV___get__h825f34112f7eacbf($4 + 504 | 0 | 0, HEAP32[(HEAP32[($4 + 620 | 0) >> 2] | 0) >> 2] | 0 | 0) | 0;
                     if ($2) {
                      break label$225
                     }
                     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h6c9f94f0f82ce2b5($4 + 504 | 0 | 0);
                     break label$224;
                    }
                    i64toi32_i32$1 = $2;
                    i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                    i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                    $28 = i64toi32_i32$0;
                    $28$hi = i64toi32_i32$5;
                    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h6c9f94f0f82ce2b5($4 + 504 | 0 | 0);
                    break label$223;
                   }
                   i64toi32_i32$5 = 0;
                   $28 = 0;
                   $28$hi = i64toi32_i32$5;
                  }
                  label$226 : {
                   label$227 : {
                    if ((HEAP32[($4 + 400 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                     break label$227
                    }
                    cardano_serialization_lib__MultiAsset__get__had0c36a2c855d776($4 + 712 | 0 | 0, $21 | 0, HEAP32[(HEAP32[($4 + 616 | 0) >> 2] | 0) >> 2] | 0 | 0);
                    if ((HEAP32[($4 + 712 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                     break label$227
                    }
                    HEAP32[(($4 + 504 | 0) + 8 | 0) >> 2] = HEAP32[($27 + 8 | 0) >> 2] | 0;
                    i64toi32_i32$1 = $27;
                    i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                    i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                    $3788 = i64toi32_i32$5;
                    i64toi32_i32$5 = $4;
                    HEAP32[($4 + 504 | 0) >> 2] = $3788;
                    HEAP32[($4 + 508 | 0) >> 2] = i64toi32_i32$0;
                    $2 = alloc__collections__btree__map__BTreeMap_K_2cV___get__h825f34112f7eacbf($4 + 504 | 0 | 0, HEAP32[(HEAP32[($4 + 620 | 0) >> 2] | 0) >> 2] | 0 | 0) | 0;
                    if ($2) {
                     break label$226
                    }
                    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h6c9f94f0f82ce2b5($4 + 504 | 0 | 0);
                   }
                   core__option__expect_failed__h66afff61e82fdd86(1064766 | 0, 52 | 0, 1064868 | 0);
                   abort();
                  }
                  i64toi32_i32$1 = $2;
                  i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                  i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                  $29 = i64toi32_i32$0;
                  $29$hi = i64toi32_i32$5;
                  $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h6c9f94f0f82ce2b5($4 + 504 | 0 | 0);
                  label$228 : {
                   i64toi32_i32$5 = $28$hi;
                   i64toi32_i32$5 = $29$hi;
                   i64toi32_i32$5 = $28$hi;
                   i64toi32_i32$1 = $28;
                   i64toi32_i32$0 = $29$hi;
                   i64toi32_i32$3 = $29;
                   if (i64toi32_i32$5 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0) {
                    break label$228
                   }
                   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hb513c626355ab1b6($4 + 440 | 0 | 0);
                   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h515a508dccfbb69c($4 + 440 | 0 | 0);
                   $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h36ca092f81b9a0fa($4 + 152 | 0 | 0, $4 + 864 | 0 | 0);
                   $2 = HEAP32[($4 + 152 | 0) >> 2] | 0;
                   if (!$2) {
                    break label$202
                   }
                   continue label$204;
                  }
                  break label$204;
                 };
                 $2 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1064884 | 0, 25 | 0) | 0;
                }
                $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hb513c626355ab1b6($4 + 440 | 0 | 0);
                $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h515a508dccfbb69c($4 + 440 | 0 | 0);
                $3 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($2 | 0) | 0;
                $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($4 + 648 | 0 | 0);
                break label$196;
               }
               $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h03cc330b7b1e4522($4 + 144 | 0 | 0, $4 + 568 | 0 | 0);
               $3 = HEAP32[($4 + 148 | 0) >> 2] | 0;
               $2 = HEAP32[($4 + 144 | 0) >> 2] | 0;
               if ($2) {
                continue label$201
               }
               break label$201;
              };
             }
             $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($4 + 648 | 0 | 0);
            }
            HEAP32[($4 + 536 | 0) >> 2] = $4 + 352 | 0;
            $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h0f0d6987a7f36efc($4 + 136 | 0 | 0, $4 + 632 | 0 | 0);
            $3 = HEAP32[($4 + 136 | 0) >> 2] | 0;
            $2 = HEAP32[($4 + 140 | 0) >> 2] | 0;
            alloc__raw_vec__RawVec_T_2cA___allocate_in__h5dada854c892eb3e($4 + 128 | 0 | 0, $2 | 0, 0 | 0);
            HEAP32[($4 + 572 | 0) >> 2] = HEAP32[($4 + 132 | 0) >> 2] | 0;
            $5 = HEAP32[($4 + 128 | 0) >> 2] | 0;
            HEAP32[($4 + 568 | 0) >> 2] = $5;
            memcpy($5 | 0, $3 | 0, $2 << 2 | 0 | 0) | 0;
            HEAP32[($4 + 576 | 0) >> 2] = $2;
            alloc__vec__Vec_T_2cA___retain__h9a0026799b18fd04($4 + 568 | 0 | 0, $4 + 616 | 0 | 0, $4 + 536 | 0 | 0);
            $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__DerefMut___deref_mut__h42fc515862cf6b48($4 + 120 | 0 | 0, $4 + 568 | 0 | 0);
            $2 = HEAP32[($4 + 124 | 0) >> 2] | 0;
            $3 = HEAP32[($4 + 120 | 0) >> 2] | 0;
            HEAP32[($4 + 716 | 0) >> 2] = $4 + 536 | 0;
            HEAP32[($4 + 712 | 0) >> 2] = $4 + 616 | 0;
            alloc__slice__merge_sort__haa2cda52d62906c4($3 | 0, $2 | 0, $4 + 712 | 0 | 0);
            $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h0f0d6987a7f36efc($4 + 112 | 0 | 0, $4 + 568 | 0 | 0);
            label$229 : {
             label$230 : {
              label$231 : {
               label$232 : {
                label$233 : {
                 label$234 : {
                  label$235 : {
                   label$236 : {
                    $2 = HEAP32[($4 + 116 | 0) >> 2] | 0;
                    if (!$2) {
                     break label$236
                    }
                    $27 = $1 + 96 | 0;
                    $21 = HEAP32[($4 + 112 | 0) >> 2] | 0;
                    $23 = $21 + ($2 << 2 | 0) | 0;
                    $14 = ($4 + 864 | 0) + 12 | 0;
                    $20 = ($4 + 392 | 0) + 12 | 0;
                    $12 = ($4 + 712 | 0) + 8 | 0;
                    $15 = ($4 + 368 | 0) + 12 | 0;
                    label$237 : while (1) {
                     i64toi32_i32$3 = $4;
                     i64toi32_i32$1 = HEAP32[($4 + 368 | 0) >> 2] | 0;
                     i64toi32_i32$5 = HEAP32[($4 + 372 | 0) >> 2] | 0;
                     $3918 = i64toi32_i32$1;
                     $3918$hi = i64toi32_i32$5;
                     i64toi32_i32$3 = $4;
                     i64toi32_i32$5 = HEAP32[($4 + 392 | 0) >> 2] | 0;
                     i64toi32_i32$1 = HEAP32[($4 + 396 | 0) >> 2] | 0;
                     $3920 = i64toi32_i32$5;
                     $3920$hi = i64toi32_i32$1;
                     i64toi32_i32$1 = $3918$hi;
                     i64toi32_i32$3 = $3918;
                     i64toi32_i32$5 = $3920$hi;
                     i64toi32_i32$0 = $3920;
                     if (i64toi32_i32$1 >>> 0 > i64toi32_i32$5 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$3 >>> 0 >= i64toi32_i32$0 >>> 0 | 0) | 0) {
                      break label$236
                     }
                     $3 = HEAP32[($4 + 536 | 0) >> 2] | 0;
                     $5 = HEAP32[($3 + 8 | 0) >> 2] | 0;
                     $23 = $23 + -4 | 0;
                     $2 = HEAP32[$23 >> 2] | 0;
                     if ($5 >>> 0 <= $2 >>> 0) {
                      break label$232
                     }
                     $2 = (HEAP32[$3 >> 2] | 0) + Math_imul($2, 168) | 0;
                     $5 = $2 + 128 | 0;
                     $3 = $2 + 64 | 0;
                     cardano_serialization_lib__tx_builder__TransactionBuilder__fee_for_input__ha5a0f735cbb9ab50($4 + 712 | 0 | 0, $1 | 0, $2 | 0, $5 | 0, $3 | 0);
                     if ((HEAP32[($4 + 712 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                      break label$233
                     }
                     i64toi32_i32$0 = $4;
                     i64toi32_i32$3 = HEAP32[($4 + 720 | 0) >> 2] | 0;
                     i64toi32_i32$1 = HEAP32[($4 + 724 | 0) >> 2] | 0;
                     $28 = i64toi32_i32$3;
                     $28$hi = i64toi32_i32$1;
                     cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__add_input__hd22960e5a7d88824($27 | 0, $2 | 0, $5 | 0, $3 | 0);
                     cardano_serialization_lib__utils__Value__checked_add__h5184687782847801($4 + 712 | 0 | 0, $4 + 368 | 0 | 0, $3 | 0);
                     if ((HEAP32[($4 + 712 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                      break label$231
                     }
                     $2 = ($4 + 864 | 0) + 16 | 0;
                     $5 = $12 + 16 | 0;
                     i64toi32_i32$0 = $5;
                     i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                     i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                     $3972 = i64toi32_i32$1;
                     i64toi32_i32$1 = $2;
                     HEAP32[i64toi32_i32$1 >> 2] = $3972;
                     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
                     $3 = ($4 + 864 | 0) + 8 | 0;
                     $6 = $12 + 8 | 0;
                     i64toi32_i32$0 = $6;
                     i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                     i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                     $3980 = i64toi32_i32$3;
                     i64toi32_i32$3 = $3;
                     HEAP32[i64toi32_i32$3 >> 2] = $3980;
                     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
                     i64toi32_i32$0 = $12;
                     i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                     i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                     $3983 = i64toi32_i32$1;
                     i64toi32_i32$1 = $4;
                     HEAP32[($4 + 864 | 0) >> 2] = $3983;
                     HEAP32[($4 + 868 | 0) >> 2] = i64toi32_i32$3;
                     label$238 : {
                      if (!(HEAP32[($4 + 376 | 0) >> 2] | 0)) {
                       break label$238
                      }
                      $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($15 | 0);
                     }
                     i64toi32_i32$0 = $2;
                     i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                     i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                     $3992 = i64toi32_i32$3;
                     i64toi32_i32$3 = ($4 + 368 | 0) + 16 | 0;
                     HEAP32[i64toi32_i32$3 >> 2] = $3992;
                     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
                     i64toi32_i32$0 = $3;
                     i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                     i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                     $3997 = i64toi32_i32$1;
                     i64toi32_i32$1 = ($4 + 368 | 0) + 8 | 0;
                     HEAP32[i64toi32_i32$1 >> 2] = $3997;
                     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
                     i64toi32_i32$0 = $4;
                     i64toi32_i32$3 = HEAP32[($4 + 864 | 0) >> 2] | 0;
                     i64toi32_i32$1 = HEAP32[($4 + 868 | 0) >> 2] | 0;
                     $4000 = i64toi32_i32$3;
                     i64toi32_i32$3 = $4;
                     HEAP32[($4 + 368 | 0) >> 2] = $4000;
                     HEAP32[($4 + 372 | 0) >> 2] = i64toi32_i32$1;
                     HEAP32[($4 + 872 | 0) >> 2] = 0;
                     i64toi32_i32$1 = $28$hi;
                     i64toi32_i32$3 = $4;
                     HEAP32[($4 + 864 | 0) >> 2] = $28;
                     HEAP32[($4 + 868 | 0) >> 2] = i64toi32_i32$1;
                     cardano_serialization_lib__utils__Value__checked_add__h5184687782847801($4 + 712 | 0 | 0, $4 + 392 | 0 | 0, $4 + 864 | 0 | 0);
                     if ((HEAP32[($4 + 712 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                      break label$235
                     }
                     $2 = ($4 + 680 | 0) + 16 | 0;
                     i64toi32_i32$0 = $5;
                     i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                     i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                     $4018 = i64toi32_i32$1;
                     i64toi32_i32$1 = $2;
                     HEAP32[i64toi32_i32$1 >> 2] = $4018;
                     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
                     $3 = ($4 + 680 | 0) + 8 | 0;
                     i64toi32_i32$0 = $6;
                     i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                     i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                     $4024 = i64toi32_i32$3;
                     i64toi32_i32$3 = $3;
                     HEAP32[i64toi32_i32$3 >> 2] = $4024;
                     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
                     i64toi32_i32$0 = $12;
                     i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                     i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                     $4027 = i64toi32_i32$1;
                     i64toi32_i32$1 = $4;
                     HEAP32[($4 + 680 | 0) >> 2] = $4027;
                     HEAP32[($4 + 684 | 0) >> 2] = i64toi32_i32$3;
                     label$239 : {
                      if (!(HEAP32[($4 + 400 | 0) >> 2] | 0)) {
                       break label$239
                      }
                      $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($20 | 0);
                     }
                     i64toi32_i32$0 = $2;
                     i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                     i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                     $4036 = i64toi32_i32$3;
                     i64toi32_i32$3 = ($4 + 392 | 0) + 16 | 0;
                     HEAP32[i64toi32_i32$3 >> 2] = $4036;
                     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
                     i64toi32_i32$0 = $3;
                     i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                     i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                     $4041 = i64toi32_i32$1;
                     i64toi32_i32$1 = ($4 + 392 | 0) + 8 | 0;
                     HEAP32[i64toi32_i32$1 >> 2] = $4041;
                     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
                     i64toi32_i32$0 = $4;
                     i64toi32_i32$3 = HEAP32[($4 + 680 | 0) >> 2] | 0;
                     i64toi32_i32$1 = HEAP32[($4 + 684 | 0) >> 2] | 0;
                     $4044 = i64toi32_i32$3;
                     i64toi32_i32$3 = $4;
                     HEAP32[($4 + 392 | 0) >> 2] = $4044;
                     HEAP32[($4 + 396 | 0) >> 2] = i64toi32_i32$1;
                     label$240 : {
                      if (!(HEAP32[($4 + 872 | 0) >> 2] | 0)) {
                       break label$240
                      }
                      $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($14 | 0);
                     }
                     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h0f0d6987a7f36efc($4 + 104 | 0 | 0, $4 + 632 | 0 | 0);
                     label$241 : {
                      label$242 : {
                       $2 = HEAP32[($4 + 108 | 0) >> 2] | 0;
                       if (!$2) {
                        break label$242
                       }
                       $5 = HEAP32[($4 + 104 | 0) >> 2] | 0;
                       $26 = $2 << 2 | 0;
                       $6 = HEAP32[$23 >> 2] | 0;
                       $2 = 0;
                       $3 = 0;
                       label$243 : while (1) {
                        if (($6 | 0) == (HEAP32[($5 + $2 | 0) >> 2] | 0 | 0)) {
                         break label$241
                        }
                        $3 = $3 + 1 | 0;
                        $2 = $2 + 4 | 0;
                        if (($26 | 0) != ($2 | 0)) {
                         continue label$243
                        }
                        break label$243;
                       };
                      }
                      core__panicking__panic__h2fd385a887c8bf13(1063668 | 0, 43 | 0, 1064852 | 0);
                      abort();
                     }
                     $5 = HEAP32[($4 + 640 | 0) >> 2] | 0;
                     if ($5 >>> 0 <= $3 >>> 0) {
                      break label$230
                     }
                     $3 = HEAP32[($4 + 632 | 0) >> 2] | 0;
                     $5 = $5 + -1 | 0;
                     HEAP32[($4 + 640 | 0) >> 2] = $5;
                     HEAP32[($3 + $2 | 0) >> 2] = HEAP32[($3 + ($5 << 2 | 0) | 0) >> 2] | 0;
                     if (($21 | 0) != ($23 | 0)) {
                      continue label$237
                     }
                     break label$237;
                    };
                   }
                   i64toi32_i32$0 = $4;
                   i64toi32_i32$1 = HEAP32[($4 + 368 | 0) >> 2] | 0;
                   i64toi32_i32$3 = HEAP32[($4 + 372 | 0) >> 2] | 0;
                   $4099 = i64toi32_i32$1;
                   $4099$hi = i64toi32_i32$3;
                   i64toi32_i32$0 = $4;
                   i64toi32_i32$3 = HEAP32[($4 + 392 | 0) >> 2] | 0;
                   i64toi32_i32$1 = HEAP32[($4 + 396 | 0) >> 2] | 0;
                   $4101 = i64toi32_i32$3;
                   $4101$hi = i64toi32_i32$1;
                   i64toi32_i32$1 = $4099$hi;
                   i64toi32_i32$0 = $4099;
                   i64toi32_i32$3 = $4101$hi;
                   i64toi32_i32$5 = $4101;
                   if (i64toi32_i32$1 >>> 0 > i64toi32_i32$3 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$0 >>> 0 >= i64toi32_i32$5 >>> 0 | 0) | 0) {
                    break label$234
                   }
                   $2 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1064884 | 0, 25 | 0) | 0;
                   break label$229;
                  }
                  $2 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($4 + 716 | 0) >> 2] | 0 | 0) | 0;
                  if (!(HEAP32[($4 + 872 | 0) >> 2] | 0)) {
                   break label$229
                  }
                  $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($14 | 0);
                  break label$229;
                 }
                 $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hb513c626355ab1b6($4 + 568 | 0 | 0);
                 $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h515a508dccfbb69c($4 + 568 | 0 | 0);
                 $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hb513c626355ab1b6($4 + 632 | 0 | 0);
                 $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h515a508dccfbb69c($4 + 632 | 0 | 0);
                 break label$9;
                }
                $2 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($4 + 716 | 0) >> 2] | 0 | 0) | 0;
                break label$229;
               }
               core__panicking__panic_bounds_check__h808b524af17640b1($2 | 0, $5 | 0, 1064836 | 0);
               abort();
              }
              $2 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($4 + 716 | 0) >> 2] | 0 | 0) | 0;
              break label$229;
             }
             alloc__vec__Vec_T_2cA___swap_remove__assert_failed__h35befc50802f56b5($3 | 0, $5 | 0);
             abort();
            }
            $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hb513c626355ab1b6($4 + 568 | 0 | 0);
            $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h515a508dccfbb69c($4 + 568 | 0 | 0);
            $3 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($2 | 0) | 0;
           }
           $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hb513c626355ab1b6($4 + 632 | 0 | 0);
           $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h515a508dccfbb69c($4 + 632 | 0 | 0);
           break label$5;
          }
          label$244 : {
           if (!(HEAP32[($4 + 400 | 0) >> 2] | 0)) {
            break label$244
           }
           $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($4 + 404 | 0 | 0);
          }
          label$245 : {
           if (!(HEAP32[($4 + 376 | 0) >> 2] | 0)) {
            break label$245
           }
           $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($4 + 380 | 0 | 0);
          }
          label$246 : {
           $1 = HEAP32[($4 + 360 | 0) >> 2] | 0;
           if (!$1) {
            break label$246
           }
           $2 = HEAP32[($4 + 352 | 0) >> 2] | 0;
           $1 = Math_imul($1, 168);
           label$247 : while (1) {
            core__ptr__drop_in_place_cardano_serialization_lib__TransactionOutput___h632b3a99817e6ac5_1($2 | 0);
            $2 = $2 + 168 | 0;
            $1 = $1 + -168 | 0;
            if ($1) {
             continue label$247
            }
            break label$247;
           };
          }
          $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h48e03889c2b030fa($4 + 352 | 0 | 0);
          $2 = 0;
          break label$1;
         }
         $3 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1064884 | 0, 25 | 0) | 0;
        }
        $1 = $24 << 7 | 0;
        label$248 : while (1) {
         core__ptr__drop_in_place_cardano_serialization_lib__TransactionOutput___h632b3a99817e6ac5_1($2 | 0);
         $2 = $2 + 128 | 0;
         $1 = $1 + -128 | 0;
         if ($1) {
          continue label$248
         }
         break label$248;
        };
        $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h5107e2b13c386680($4 + 536 | 0 | 0);
        $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h903e00ab7dfc505c($4 + 504 | 0 | 0);
        $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hb513c626355ab1b6($4 + 472 | 0 | 0);
        $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h515a508dccfbb69c($4 + 472 | 0 | 0);
        $3 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($3 | 0) | 0;
       }
       $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h6e0c34e8fa561cb7($4 + 424 | 0 | 0);
       $alloc__rc__Rc_T__20as_20core__ops__drop__Drop___drop__h9c6f1ce9a80847e3($4 + 420 | 0 | 0);
      }
      if (!(HEAP32[($4 + 400 | 0) >> 2] | 0)) {
       break label$3
      }
      $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($4 + 404 | 0 | 0);
      break label$3;
     }
     if (!(HEAP32[($4 + 688 | 0) >> 2] | 0)) {
      break label$3
     }
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($4 + 692 | 0 | 0);
    }
    if (!(HEAP32[($4 + 376 | 0) >> 2] | 0)) {
     break label$2
    }
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($4 + 380 | 0 | 0);
   }
   label$249 : {
    $1 = HEAP32[($4 + 360 | 0) >> 2] | 0;
    if (!$1) {
     break label$249
    }
    $2 = HEAP32[($4 + 352 | 0) >> 2] | 0;
    $1 = Math_imul($1, 168);
    label$250 : while (1) {
     core__ptr__drop_in_place_cardano_serialization_lib__TransactionOutput___h632b3a99817e6ac5_1($2 | 0);
     $2 = $2 + 168 | 0;
     $1 = $1 + -168 | 0;
     if ($1) {
      continue label$250
     }
     break label$250;
    };
   }
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h48e03889c2b030fa($4 + 352 | 0 | 0);
   $2 = 1;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $3;
  HEAP32[$0 >> 2] = $2;
  global$0 = $4 + 992 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__TransactionBody___deserialize__h3099fdd842acebc9($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, i64toi32_i32$5 = 0, i64toi32_i32$2 = 0, $28 = 0, $28$hi = 0, $25$hi = 0, $25 = 0, $8 = 0, $30 = 0, $22$hi = 0, $30$hi = 0, $18 = 0, $31$hi = 0, $22 = 0, $31 = 0, $5 = 0, $34 = 0, $34$hi = 0, $29 = 0, $29$hi = 0, $13 = 0, $19 = 0, $3 = 0, $12 = 0, $32 = 0, $32$hi = 0, $7 = 0, $33 = 0, $33$hi = 0, $10 = 0, $6 = 0, $4 = 0, $14 = 0, $23 = 0, $23$hi = 0, $24 = 0, $24$hi = 0, $26 = 0, $26$hi = 0, $27 = 0, $27$hi = 0, $9 = 0, $11 = 0, $324 = 0, $325 = 0, $326 = 0, $327 = 0, $328 = 0, $329 = 0, $330 = 0, $331 = 0, $332 = 0, $333 = 0, $334 = 0, $335 = 0, $336 = 0, $337 = 0, $338 = 0, $339 = 0, $340 = 0, $342 = 0, $343 = 0, $344 = 0, $345 = 0, $347 = 0, $348 = 0, $349 = 0, $350 = 0, $351 = 0, $352 = 0, $353 = 0, $355 = 0, $356 = 0, $357 = 0, $358 = 0, $359 = 0, $360 = 0, $361 = 0, $362 = 0, $363 = 0, $364 = 0, $365 = 0, $366 = 0, $367 = 0, $369 = 0, $370 = 0, $372 = 0, $373 = 0, $374 = 0, $375 = 0, $376 = 0, $377 = 0, $378 = 0, $379 = 0, $380 = 0, $381 = 0, $382 = 0, $383 = 0, $384 = 0, $385 = 0, $386 = 0, $387 = 0, $388 = 0, $389 = 0, $391 = 0, $392 = 0, $393 = 0, $394 = 0, $395 = 0, $396 = 0, $397 = 0, $398 = 0, $399 = 0, $400 = 0, $401 = 0, $402 = 0, $403 = 0, $404 = 0, $405 = 0, $406 = 0, $407 = 0, $408 = 0, $409 = 0, $410 = 0, $411 = 0, $412 = 0, $413 = 0, $414 = 0, $15 = 0, $16 = 0, $35 = 0, $35$hi = 0, $36 = 0, $36$hi = 0, $17 = 0, $415 = 0, $416 = 0, $417 = 0, $418 = 0, $419 = 0, $420 = 0, $421 = 0, $422 = 0, $423 = 0, $424 = 0, $425 = 0, $426 = 0, $427 = 0, $428 = 0, $429 = 0, $430 = 0, $431 = 0, $432 = 0, $433 = 0, $434 = 0, $435 = 0, $436 = 0, $437 = 0, $438 = 0, $439 = 0, $441 = 0, $442 = 0, $443 = 0, $445 = 0, $446 = 0, $447 = 0, $449 = 0, $450 = 0, $452 = 0, $453 = 0, $455 = 0, $456 = 0, $457 = 0, $458 = 0, $459 = 0, $460 = 0, $461 = 0, $462 = 0, $463 = 0, $464 = 0, $465 = 0, $466 = 0, $467 = 0, $468 = 0, $469 = 0, $470 = 0, $471 = 0, $472 = 0, $473 = 0, $474 = 0, $37 = 0, $37$hi = 0, $475 = 0, $476 = 0, $477 = 0, $478 = 0, $479 = 0, $480 = 0, $481 = 0, $482 = 0, $483 = 0, $484 = 0, $485 = 0, $486 = 0, $490 = 0, $491 = 0, $492 = 0, $493 = 0, $494 = 0, $495 = 0, $496 = 0, $497 = 0, $142 = 0, $285 = 0, $289 = 0, $293 = 0, $296 = 0, $296$hi = 0, $299 = 0, $299$hi = 0, $303$hi = 0, $305$hi = 0, $341 = 0, $346 = 0, $354 = 0, $368 = 0, $371 = 0, $390 = 0, $440 = 0, $444 = 0, $448 = 0, $451 = 0, $454 = 0, $487 = 0, $488 = 0, $488$hi = 0, $489 = 0, $489$hi = 0, $491$hi = 0, $493$hi = 0, $510 = 0, $515 = 0, $523 = 0, $537 = 0, $540 = 0, $556 = 0, $604 = 0, $608 = 0, $612 = 0, $615 = 0, $618 = 0, $651 = 0, $652 = 0, $652$hi = 0, $653 = 0, $653$hi = 0, $655$hi = 0, $657$hi = 0, $674 = 0, $679 = 0, $687 = 0, $701 = 0, $704 = 0, $720 = 0, $769 = 0, $773 = 0, $777 = 0, $780 = 0, $783 = 0, $813 = 0, $814 = 0, $814$hi = 0, $815 = 0, $815$hi = 0, $817$hi = 0, $819$hi = 0, $835 = 0, $839 = 0, $847 = 0, $861 = 0, $864 = 0, $880 = 0, $916 = 0, $920 = 0, $924 = 0, $927 = 0, $930 = 0, $963 = 0, $964 = 0, $964$hi = 0, $965 = 0, $965$hi = 0, $967$hi = 0, $969$hi = 0, $986 = 0, $991 = 0, $999 = 0, $1013 = 0, $1016 = 0, $1032 = 0, $1082 = 0, $1086 = 0, $1089 = 0, $1092 = 0, $1095 = 0, $1118 = 0, $1134 = 0, $1139 = 0, $1147 = 0, $1169 = 0, $1218 = 0, $1222 = 0, $1226 = 0, $1229 = 0, $1232 = 0, $1262 = 0, $1263 = 0, $1263$hi = 0, $1264 = 0, $1264$hi = 0, $1266$hi = 0, $1268$hi = 0, $1283 = 0, $1287 = 0, $1295 = 0, $1309 = 0, $1312 = 0, $1328 = 0, $1360 = 0, $1363 = 0, $1365 = 0, $1365$hi = 0, $1369 = 0, $1369$hi = 0, $1374$hi = 0, $1376$hi = 0, $1402 = 0, $1405 = 0, $1425 = 0, $1429 = 0, $1437 = 0, $1450 = 0, $1453 = 0, $1467 = 0, $1498 = 0, $1501 = 0, $1503 = 0, $1503$hi = 0, $1507 = 0, $1507$hi = 0, $1512$hi = 0, $1514$hi = 0, $1538 = 0, $1541 = 0, $1564 = 0, $1568 = 0, $1575 = 0, $1588 = 0, $1591 = 0, $1605 = 0, $1645 = 0, $1649 = 0, $1653 = 0, $1656 = 0, $1659 = 0, $1692 = 0, $1693 = 0, $1693$hi = 0, $1694 = 0, $1694$hi = 0, $1696$hi = 0, $1698$hi = 0, $1715 = 0, $1720 = 0, $1728 = 0, $1742 = 0, $1745 = 0, $1761 = 0, $1811 = 0, $1815 = 0, $1818 = 0, $1821 = 0, $1824 = 0, $1847 = 0, $1863 = 0, $1868 = 0, $1876 = 0, $1898 = 0, $1943 = 0, $1949 = 0, $1952 = 0, $1955 = 0, $1958 = 0, $1990 = 0, $2006 = 0, $2009 = 0, $2015 = 0, $2032 = 0, $2092 = 0, $2103 = 0, $2109 = 0, $2115 = 0, $2118 = 0, $2121 = 0, $2163 = 0, $2185 = 0, $2188 = 0, $2194 = 0, $2212 = 0, $2272 = 0, $2283 = 0, $2289 = 0, $2295 = 0, $2298 = 0, $2301 = 0, $2343 = 0, $2365 = 0, $2368 = 0, $2374 = 0, $2392 = 0, $2422 = 0, $2422$hi = 0, $2425 = 0, $2425$hi = 0, $2429$hi = 0, $2431$hi = 0, $2433$hi = 0, $2436 = 0, $2436$hi = 0, $2475 = 0, $2501 = 0, $38 = 0, $38$hi = 0, $39 = 0, $39$hi = 0, $20 = 0, $40 = 0, $40$hi = 0, $2589 = 0, $41 = 0, $41$hi = 0, $42 = 0, $42$hi = 0, $21 = 0, $43 = 0, $43$hi = 0, $2655 = 0, $2660 = 0, $2665 = 0, $2668 = 0, $2672 = 0, $2675 = 0, $2704 = 0, $2709 = 0, $2714 = 0, $2717 = 0, $2721 = 0, $2724 = 0, $2806 = 0, $2819 = 0, $2853 = 0, $2857 = 0, $2879 = 0, $2902 = 0, $2918 = 0, $2929 = 0, $2932 = 0, $2935 = 0, $2983 = 0, $2990 = 0, $2994 = 0, $2997 = 0, $3106 = 0, $3117 = 0, $3117$hi = 0, $3119 = 0, $3119$hi = 0, $3120 = 0;
  $2 = global$0 - 512 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___map__h7c2a4e830d885a05($2 + 440 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2 + 456 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $22 = i64toi32_i32$0;
  $22$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 448 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 452 | 0) >> 2] | 0;
  $23 = i64toi32_i32$1;
  $23$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 440 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 444 | 0) >> 2] | 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
         break label$6
        }
        i64toi32_i32$2 = 0;
        $24 = 0;
        $24$hi = i64toi32_i32$2;
        i64toi32_i32$2 = 0;
        $25 = 0;
        $25$hi = i64toi32_i32$2;
        label$7 : {
         label$8 : {
          label$9 : {
           i64toi32_i32$2 = $23$hi;
           i64toi32_i32$3 = $23;
           i64toi32_i32$1 = 0;
           i64toi32_i32$0 = 1;
           if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
            break label$9
           }
           i64toi32_i32$3 = 0;
           $25 = 3;
           $25$hi = i64toi32_i32$3;
           i64toi32_i32$3 = $22$hi;
           i64toi32_i32$0 = $22;
           i64toi32_i32$2 = 0;
           i64toi32_i32$1 = 3;
           if (i64toi32_i32$3 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0 | 0) | 0) {
            break label$8
           }
          }
          $3 = 0;
          HEAP32[($2 + 88 | 0) >> 2] = 0;
          HEAP32[($2 + 104 | 0) >> 2] = 0;
          HEAP32[($2 + 120 | 0) >> 2] = 0;
          HEAP32[($2 + 156 | 0) >> 2] = 0;
          HEAP32[($2 + 196 | 0) >> 2] = 0;
          HEAP32[($2 + 232 | 0) >> 2] = 0;
          HEAP32[($2 + 256 | 0) >> 2] = 0;
          HEAP32[($2 + 272 | 0) >> 2] = 0;
          i64toi32_i32$0 = $22$hi;
          $4 = $22;
          i64toi32_i32$0 = $23$hi;
          i64toi32_i32$1 = $23;
          i64toi32_i32$3 = 0;
          i64toi32_i32$2 = 1;
          $5 = (i64toi32_i32$1 | 0) != (i64toi32_i32$2 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$3 | 0) | 0;
          if ($5) {
           break label$7
          }
          if ($4) {
           break label$7
          }
          $6 = 2;
          $7 = 0;
          i64toi32_i32$1 = 0;
          $26 = 0;
          $26$hi = i64toi32_i32$1;
          i64toi32_i32$1 = 0;
          $27 = 0;
          $27$hi = i64toi32_i32$1;
          break label$4;
         }
         $8 = 0;
         i64toi32_i32$1 = 0;
         $28 = 3;
         $28$hi = i64toi32_i32$1;
         i64toi32_i32$1 = 0;
         $29 = 0;
         $29$hi = i64toi32_i32$1;
         i64toi32_i32$1 = 0;
         $30 = 0;
         $30$hi = i64toi32_i32$1;
         i64toi32_i32$1 = $22$hi;
         $31 = $22;
         $31$hi = i64toi32_i32$1;
         break label$2;
        }
        $9 = ($2 + 328 | 0) + 33 | 0;
        $10 = $2 + 336 | 0;
        $11 = 1;
        $12 = $2 + 328 | 0 | 1 | 0;
        $13 = $2 + 304 | 0 | 1 | 0;
        $14 = $2 + 440 | 0 | 1 | 0;
        $15 = 0;
        $16 = ($2 + 440 | 0) + 33 | 0;
        $17 = $16 + 7 | 0;
        $8 = 1;
        i64toi32_i32$1 = 0;
        $27 = 0;
        $27$hi = i64toi32_i32$1;
        i64toi32_i32$1 = 0;
        $26 = 0;
        $26$hi = i64toi32_i32$1;
        $7 = 0;
        i64toi32_i32$1 = 0;
        $24 = 0;
        $24$hi = i64toi32_i32$1;
        $3 = 0;
        $6 = 2;
        label$10 : while (1) {
         $18 = $8;
         std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 16 | 0 | 0, $1 | 0);
         i64toi32_i32$1 = 0;
         $28 = 2;
         $28$hi = i64toi32_i32$1;
         label$11 : {
          if (HEAP32[($2 + 20 | 0) >> 2] | 0) {
           break label$11
          }
          i64toi32_i32$1 = 0;
          $31 = 8;
          $31$hi = i64toi32_i32$1;
          i64toi32_i32$1 = 0;
          $29 = 0;
          $29$hi = i64toi32_i32$1;
          $8 = 0;
          i64toi32_i32$1 = 0;
          $30 = 0;
          $30$hi = i64toi32_i32$1;
          break label$3;
         }
         label$12 : {
          label$13 : {
           label$14 : {
            label$15 : {
             label$16 : {
              label$17 : {
               label$18 : {
                label$19 : {
                 label$20 : {
                  label$21 : {
                   label$22 : {
                    label$23 : {
                     label$24 : {
                      label$25 : {
                       $8 = ($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[($2 + 16 | 0) >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0;
                       if (!$8) {
                        break label$25
                       }
                       label$26 : {
                        switch ($8 + -3 | 0 | 0) {
                        default:
                         i64toi32_i32$1 = 0;
                         i64toi32_i32$2 = $8;
                         i64toi32_i32$0 = 0;
                         i64toi32_i32$3 = 8;
                         i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
                         if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                          i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
                          $415 = 0;
                         } else {
                          i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
                          $415 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
                         }
                         $29 = $415;
                         $29$hi = i64toi32_i32$0;
                         i64toi32_i32$1 = $29;
                         i64toi32_i32$2 = 0;
                         i64toi32_i32$3 = 17;
                         i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
                         $28 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
                         $28$hi = i64toi32_i32$2;
                         $8 = 0;
                         break label$23;
                        case 4:
                         label$29 : {
                          i64toi32_i32$2 = $23$hi;
                          i64toi32_i32$0 = $23;
                          i64toi32_i32$1 = 0;
                          i64toi32_i32$3 = 1;
                          if ((i64toi32_i32$0 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
                           break label$29
                          }
                          $8 = 0;
                          i64toi32_i32$0 = 0;
                          $29 = 0;
                          $29$hi = i64toi32_i32$0;
                          i64toi32_i32$0 = 0;
                          $28 = 1;
                          $28$hi = i64toi32_i32$0;
                          break label$23;
                         }
                         cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 440 | 0 | 0, $1 | 0);
                         $1 = HEAPU8[($2 + 448 | 0) >> 0] | 0;
                         i64toi32_i32$3 = $2;
                         i64toi32_i32$0 = HEAP32[($2 + 440 | 0) >> 2] | 0;
                         i64toi32_i32$2 = HEAP32[($2 + 444 | 0) >> 2] | 0;
                         i64toi32_i32$3 = i64toi32_i32$0;
                         i64toi32_i32$0 = 0;
                         i64toi32_i32$1 = 1;
                         if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) | 0) {
                          break label$24
                         }
                         if (($1 & 255 | 0 | 0) == (5 | 0)) {
                          break label$4
                         }
                         $8 = 0;
                         i64toi32_i32$3 = 0;
                         $28 = 5;
                         $28$hi = i64toi32_i32$3;
                         i64toi32_i32$3 = 0;
                         $29 = 0;
                         $29$hi = i64toi32_i32$3;
                         break label$23;
                        case 0:
                         break label$26;
                        };
                       }
                       cbor_event__de__Deserializer_R___text__h764f26557f652908($2 + 440 | 0 | 0, $1 | 0);
                       label$30 : {
                        label$31 : {
                         if ((HEAP32[($2 + 440 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                          break label$31
                         }
                         HEAP32[($2 + 328 | 0) >> 2] = HEAP32[($2 + 444 | 0) >> 2] | 0;
                         $1 = $2 + 448 | 0;
                         i64toi32_i32$1 = $1;
                         i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                         i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                         $142 = i64toi32_i32$3;
                         i64toi32_i32$3 = $2;
                         HEAP32[($2 + 332 | 0) >> 2] = $142;
                         HEAP32[($2 + 336 | 0) >> 2] = i64toi32_i32$2;
                         $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $2 + 328 | 0 | 0);
                         alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($2 + 452 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
                         HEAP32[i64toi32_i32$1 >> 2] = 0;
                         HEAP8[($2 + 440 | 0) >> 0] = 16;
                         i64toi32_i32$1 = $2;
                         i64toi32_i32$2 = HEAP32[($2 + 440 | 0) >> 2] | 0;
                         i64toi32_i32$3 = HEAP32[($2 + 444 | 0) >> 2] | 0;
                         $28 = i64toi32_i32$2;
                         $28$hi = i64toi32_i32$3;
                         i64toi32_i32$1 = i64toi32_i32$2;
                         i64toi32_i32$2 = -1;
                         i64toi32_i32$0 = -256;
                         i64toi32_i32$2 = i64toi32_i32$3 & i64toi32_i32$2 | 0;
                         $29 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
                         $29$hi = i64toi32_i32$2;
                         i64toi32_i32$3 = $2 + 464 | 0;
                         i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                         i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                         $25 = i64toi32_i32$2;
                         $25$hi = i64toi32_i32$1;
                         i64toi32_i32$3 = $2 + 472 | 0;
                         i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                         i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                         $32 = i64toi32_i32$1;
                         $32$hi = i64toi32_i32$2;
                         i64toi32_i32$3 = $2 + 480 | 0;
                         i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                         i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                         $33 = i64toi32_i32$2;
                         $33$hi = i64toi32_i32$1;
                         i64toi32_i32$3 = $1;
                         i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                         i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                         $31 = i64toi32_i32$1;
                         $31$hi = i64toi32_i32$2;
                         i64toi32_i32$3 = ($2 + 440 | 0) + 16 | 0;
                         i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                         i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                         $30 = i64toi32_i32$2;
                         $30$hi = i64toi32_i32$1;
                         $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 328 | 0 | 0);
                         $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 328 | 0 | 0);
                         break label$30;
                        }
                        i64toi32_i32$3 = $2 + 480 | 0;
                        i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                        i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                        $33 = i64toi32_i32$1;
                        $33$hi = i64toi32_i32$2;
                        i64toi32_i32$3 = $2 + 472 | 0;
                        i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                        i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                        $32 = i64toi32_i32$2;
                        $32$hi = i64toi32_i32$1;
                        i64toi32_i32$3 = $2 + 464 | 0;
                        i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                        i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                        $25 = i64toi32_i32$1;
                        $25$hi = i64toi32_i32$2;
                        i64toi32_i32$3 = $2 + 456 | 0;
                        i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                        i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                        $30 = i64toi32_i32$2;
                        $30$hi = i64toi32_i32$1;
                        i64toi32_i32$3 = $2 + 448 | 0;
                        i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                        i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                        $31 = i64toi32_i32$1;
                        $31$hi = i64toi32_i32$2;
                        i64toi32_i32$2 = 0;
                        $28 = 2;
                        $28$hi = i64toi32_i32$2;
                        i64toi32_i32$2 = 0;
                        $29 = 0;
                        $29$hi = i64toi32_i32$2;
                       }
                       $8 = 0;
                       $11 = 1;
                       break label$23;
                      }
                      cbor_event__de__Deserializer_R___unsigned_integer__h1ed99c0b7fe7eea1($2 + 440 | 0 | 0, $1 | 0);
                      i64toi32_i32$3 = $2;
                      i64toi32_i32$2 = HEAP32[($2 + 448 | 0) >> 2] | 0;
                      i64toi32_i32$1 = HEAP32[($2 + 452 | 0) >> 2] | 0;
                      $34 = i64toi32_i32$2;
                      $34$hi = i64toi32_i32$1;
                      label$32 : {
                       label$33 : {
                        label$34 : {
                         label$35 : {
                          label$36 : {
                           label$37 : {
                            label$38 : {
                             label$39 : {
                              label$40 : {
                               label$41 : {
                                label$42 : {
                                 label$43 : {
                                  label$44 : {
                                   label$45 : {
                                    label$46 : {
                                     label$47 : {
                                      label$48 : {
                                       label$49 : {
                                        label$50 : {
                                         label$51 : {
                                          label$52 : {
                                           label$53 : {
                                            label$54 : {
                                             label$55 : {
                                              label$56 : {
                                               label$57 : {
                                                label$58 : {
                                                 label$59 : {
                                                  label$60 : {
                                                   i64toi32_i32$3 = $2;
                                                   i64toi32_i32$1 = HEAP32[($2 + 440 | 0) >> 2] | 0;
                                                   i64toi32_i32$2 = HEAP32[($2 + 444 | 0) >> 2] | 0;
                                                   i64toi32_i32$3 = i64toi32_i32$1;
                                                   i64toi32_i32$1 = 0;
                                                   i64toi32_i32$0 = 1;
                                                   if ((i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$1 | 0) | 0) {
                                                    break label$60
                                                   }
                                                   i64toi32_i32$3 = 0;
                                                   $31 = 1;
                                                   $31$hi = i64toi32_i32$3;
                                                   $8 = 0;
                                                   i64toi32_i32$3 = 0;
                                                   $28 = 16;
                                                   $28$hi = i64toi32_i32$3;
                                                   i64toi32_i32$3 = 0;
                                                   $29 = 0;
                                                   $29$hi = i64toi32_i32$3;
                                                   label$61 : {
                                                    i64toi32_i32$3 = $34$hi;
                                                    i64toi32_i32$0 = $34;
                                                    i64toi32_i32$2 = 0;
                                                    i64toi32_i32$1 = 15;
                                                    if (i64toi32_i32$3 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$0 >>> 0 <= i64toi32_i32$1 >>> 0 | 0) | 0) {
                                                     break label$61
                                                    }
                                                    i64toi32_i32$0 = $34$hi;
                                                    $30 = $34;
                                                    $30$hi = i64toi32_i32$0;
                                                    break label$3;
                                                   }
                                                   i64toi32_i32$0 = $34$hi;
                                                   $30 = $34;
                                                   $30$hi = i64toi32_i32$0;
                                                   switch ($34 | 0) {
                                                   case 10:
                                                   case 12:
                                                    break label$3;
                                                   case 15:
                                                    break label$46;
                                                   case 14:
                                                    break label$47;
                                                   case 13:
                                                    break label$48;
                                                   case 11:
                                                    break label$49;
                                                   case 9:
                                                    break label$50;
                                                   case 8:
                                                    break label$51;
                                                   case 7:
                                                    break label$52;
                                                   case 6:
                                                    break label$53;
                                                   case 5:
                                                    break label$54;
                                                   case 4:
                                                    break label$55;
                                                   case 3:
                                                    break label$56;
                                                   case 2:
                                                    break label$57;
                                                   case 1:
                                                    break label$58;
                                                   default:
                                                    break label$59;
                                                   };
                                                  }
                                                  i64toi32_i32$1 = $2 + 480 | 0;
                                                  i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                                  i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                                  $33 = i64toi32_i32$0;
                                                  $33$hi = i64toi32_i32$3;
                                                  i64toi32_i32$0 = $2 + 296 | 0;
                                                  HEAP32[i64toi32_i32$0 >> 2] = $33;
                                                  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
                                                  i64toi32_i32$1 = $2 + 472 | 0;
                                                  i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                                  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                                  $32 = i64toi32_i32$3;
                                                  $32$hi = i64toi32_i32$0;
                                                  i64toi32_i32$3 = $2;
                                                  HEAP32[($2 + 288 | 0) >> 2] = $32;
                                                  HEAP32[($2 + 292 | 0) >> 2] = i64toi32_i32$0;
                                                  i64toi32_i32$1 = $2 + 464 | 0;
                                                  i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                                  i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                                  $25 = i64toi32_i32$0;
                                                  $25$hi = i64toi32_i32$3;
                                                  i64toi32_i32$1 = $2 + 456 | 0;
                                                  i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                                  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                                  $30 = i64toi32_i32$3;
                                                  $30$hi = i64toi32_i32$0;
                                                  $8 = 0;
                                                  i64toi32_i32$0 = 0;
                                                  $28 = 2;
                                                  $28$hi = i64toi32_i32$0;
                                                  i64toi32_i32$0 = 0;
                                                  $29 = 0;
                                                  $29$hi = i64toi32_i32$0;
                                                  i64toi32_i32$0 = $34$hi;
                                                  $31 = $34;
                                                  $31$hi = i64toi32_i32$0;
                                                  break label$3;
                                                 }
                                                 if (!(HEAP32[($2 + 88 | 0) >> 2] | 0)) {
                                                  break label$32
                                                 }
                                                 i64toi32_i32$0 = 0;
                                                 $28 = 4;
                                                 $28$hi = i64toi32_i32$0;
                                                 i64toi32_i32$0 = 0;
                                                 $29 = 0;
                                                 $29$hi = i64toi32_i32$0;
                                                 i64toi32_i32$0 = 0;
                                                 $30 = 0;
                                                 $30$hi = i64toi32_i32$0;
                                                 break label$3;
                                                }
                                                if (!(HEAP32[($2 + 104 | 0) >> 2] | 0)) {
                                                 break label$33
                                                }
                                                i64toi32_i32$0 = 0;
                                                $30 = 1;
                                                $30$hi = i64toi32_i32$0;
                                                i64toi32_i32$0 = 0;
                                                $28 = 4;
                                                $28$hi = i64toi32_i32$0;
                                                i64toi32_i32$0 = 0;
                                                $31 = 1;
                                                $31$hi = i64toi32_i32$0;
                                                break label$3;
                                               }
                                               i64toi32_i32$0 = 0;
                                               $31 = 1;
                                               $31$hi = i64toi32_i32$0;
                                               i64toi32_i32$0 = $27$hi;
                                               i64toi32_i32$1 = $27;
                                               i64toi32_i32$3 = 0;
                                               i64toi32_i32$2 = 1;
                                               if ((i64toi32_i32$1 | 0) != (i64toi32_i32$2 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$3 | 0) | 0) {
                                                break label$34
                                               }
                                               i64toi32_i32$1 = 0;
                                               $30 = 2;
                                               $30$hi = i64toi32_i32$1;
                                               break label$5;
                                              }
                                              i64toi32_i32$1 = 0;
                                              $31 = 1;
                                              $31$hi = i64toi32_i32$1;
                                              i64toi32_i32$1 = $26$hi;
                                              i64toi32_i32$2 = $26;
                                              i64toi32_i32$0 = 0;
                                              i64toi32_i32$3 = 1;
                                              if ((i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$0 | 0) | 0) {
                                               break label$35
                                              }
                                              i64toi32_i32$2 = 0;
                                              $30 = 3;
                                              $30$hi = i64toi32_i32$2;
                                              break label$5;
                                             }
                                             if (!(HEAP32[($2 + 120 | 0) >> 2] | 0)) {
                                              break label$36
                                             }
                                             i64toi32_i32$2 = 0;
                                             $28 = 4;
                                             $28$hi = i64toi32_i32$2;
                                             i64toi32_i32$2 = 0;
                                             $30 = 4;
                                             $30$hi = i64toi32_i32$2;
                                             break label$3;
                                            }
                                            if (!(HEAP32[($2 + 156 | 0) >> 2] | 0)) {
                                             break label$37
                                            }
                                            i64toi32_i32$2 = 0;
                                            $30 = 5;
                                            $30$hi = i64toi32_i32$2;
                                            break label$5;
                                           }
                                           if (!(HEAP32[($2 + 196 | 0) >> 2] | 0)) {
                                            break label$38
                                           }
                                           i64toi32_i32$2 = 0;
                                           $30 = 6;
                                           $30$hi = i64toi32_i32$2;
                                           break label$5;
                                          }
                                          if (!($7 & 255 | 0)) {
                                           break label$40
                                          }
                                          i64toi32_i32$2 = 0;
                                          $30 = 7;
                                          $30$hi = i64toi32_i32$2;
                                          break label$5;
                                         }
                                         i64toi32_i32$2 = 0;
                                         $31 = 1;
                                         $31$hi = i64toi32_i32$2;
                                         i64toi32_i32$2 = $24$hi;
                                         i64toi32_i32$3 = $24;
                                         i64toi32_i32$1 = 0;
                                         i64toi32_i32$0 = 1;
                                         if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
                                          break label$41
                                         }
                                         i64toi32_i32$3 = 0;
                                         $30 = 8;
                                         $30$hi = i64toi32_i32$3;
                                         break label$5;
                                        }
                                        if ((HEAP32[($2 + 232 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                                         break label$42
                                        }
                                        i64toi32_i32$3 = 0;
                                        $30 = 9;
                                        $30$hi = i64toi32_i32$3;
                                        break label$5;
                                       }
                                       if (!($3 & 255 | 0)) {
                                        break label$43
                                       }
                                       i64toi32_i32$3 = 0;
                                       $30 = 11;
                                       $30$hi = i64toi32_i32$3;
                                       break label$5;
                                      }
                                      if (!(HEAP32[($2 + 256 | 0) >> 2] | 0)) {
                                       break label$44
                                      }
                                      i64toi32_i32$3 = 0;
                                      $30 = 13;
                                      $30$hi = i64toi32_i32$3;
                                      break label$5;
                                     }
                                     if (!(HEAP32[($2 + 272 | 0) >> 2] | 0)) {
                                      break label$45
                                     }
                                     i64toi32_i32$3 = 0;
                                     $30 = 14;
                                     $30$hi = i64toi32_i32$3;
                                     break label$5;
                                    }
                                    label$62 : {
                                     if (($6 & 255 | 0 | 0) == (2 | 0)) {
                                      break label$62
                                     }
                                     i64toi32_i32$3 = 0;
                                     $30 = 15;
                                     $30$hi = i64toi32_i32$3;
                                     break label$5;
                                    }
                                    label$63 : {
                                     label$64 : {
                                      label$65 : {
                                       if ($5) {
                                        break label$65
                                       }
                                       i64toi32_i32$3 = $25$hi;
                                       i64toi32_i32$0 = $25;
                                       i64toi32_i32$2 = 0;
                                       i64toi32_i32$1 = 1;
                                       i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
                                       i64toi32_i32$5 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
                                       if (i64toi32_i32$4 >>> 0 < i64toi32_i32$1 >>> 0) {
                                        i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
                                       }
                                       $25 = i64toi32_i32$4;
                                       $25$hi = i64toi32_i32$5;
                                       i64toi32_i32$5 = $22$hi;
                                       i64toi32_i32$5 = $25$hi;
                                       i64toi32_i32$3 = i64toi32_i32$4;
                                       i64toi32_i32$0 = $22$hi;
                                       i64toi32_i32$1 = $22;
                                       if (i64toi32_i32$5 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$4 >>> 0 <= i64toi32_i32$1 >>> 0 | 0) | 0) {
                                        break label$65
                                       }
                                       $1 = 0;
                                       i64toi32_i32$3 = 0;
                                       $25 = 0;
                                       $25$hi = i64toi32_i32$3;
                                       $18 = 3;
                                       break label$64;
                                      }
                                      cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__NetworkId___deserialize__h50b68885855d805d($2 + 440 | 0 | 0, $1 | 0);
                                      if ((HEAPU8[($2 + 440 | 0) >> 0] | 0 | 0) != (1 | 0)) {
                                       break label$63
                                      }
                                      HEAP32[(($2 + 424 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 508 | 0) >> 2] | 0;
                                      i64toi32_i32$1 = $2 + 473 | 0;
                                      i64toi32_i32$3 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                      i64toi32_i32$5 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                      $285 = i64toi32_i32$3;
                                      i64toi32_i32$3 = $2;
                                      HEAP32[($2 + 400 | 0) >> 2] = $285;
                                      HEAP32[($2 + 404 | 0) >> 2] = i64toi32_i32$5;
                                      i64toi32_i32$1 = $2 + 480 | 0;
                                      i64toi32_i32$5 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                      i64toi32_i32$3 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                      $289 = i64toi32_i32$5;
                                      i64toi32_i32$5 = $2;
                                      $324 = $289;
                                      HEAP8[($2 + 407 | 0) >> 0] = $324;
                                      HEAP8[($2 + 408 | 0) >> 0] = $324 >>> 8 | 0;
                                      HEAP8[($2 + 409 | 0) >> 0] = $324 >>> 16 | 0;
                                      HEAP8[($2 + 410 | 0) >> 0] = $324 >>> 24 | 0;
                                      HEAP8[($2 + 411 | 0) >> 0] = i64toi32_i32$3;
                                      HEAP8[($2 + 412 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
                                      HEAP8[($2 + 413 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
                                      HEAP8[($2 + 414 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
                                      i64toi32_i32$1 = $2 + 500 | 0;
                                      i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                      i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                      $293 = i64toi32_i32$3;
                                      i64toi32_i32$3 = $2;
                                      HEAP32[($2 + 424 | 0) >> 2] = $293;
                                      HEAP32[($2 + 428 | 0) >> 2] = i64toi32_i32$5;
                                      i64toi32_i32$1 = $2 + 449 | 0;
                                      i64toi32_i32$5 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                      i64toi32_i32$3 = 0;
                                      $296 = i64toi32_i32$5;
                                      $296$hi = i64toi32_i32$3;
                                      i64toi32_i32$1 = $2 + 453 | 0;
                                      i64toi32_i32$3 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
                                      i64toi32_i32$5 = 0;
                                      $299 = i64toi32_i32$3;
                                      $299$hi = i64toi32_i32$5;
                                      i64toi32_i32$1 = $2 + 455 | 0;
                                      i64toi32_i32$5 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
                                      i64toi32_i32$3 = 0;
                                      i64toi32_i32$1 = i64toi32_i32$5;
                                      i64toi32_i32$5 = 0;
                                      i64toi32_i32$0 = 16;
                                      i64toi32_i32$2 = i64toi32_i32$0 & 31 | 0;
                                      if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
                                       i64toi32_i32$5 = i64toi32_i32$1 << i64toi32_i32$2 | 0;
                                       $416 = 0;
                                      } else {
                                       i64toi32_i32$5 = ((1 << i64toi32_i32$2 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$2 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$2 | 0) | 0;
                                       $416 = i64toi32_i32$1 << i64toi32_i32$2 | 0;
                                      }
                                      $303$hi = i64toi32_i32$5;
                                      i64toi32_i32$5 = $299$hi;
                                      i64toi32_i32$3 = $299;
                                      i64toi32_i32$1 = $303$hi;
                                      i64toi32_i32$0 = $416;
                                      i64toi32_i32$1 = i64toi32_i32$5 | i64toi32_i32$1 | 0;
                                      i64toi32_i32$5 = i64toi32_i32$3 | i64toi32_i32$0 | 0;
                                      i64toi32_i32$3 = 0;
                                      i64toi32_i32$0 = 32;
                                      i64toi32_i32$2 = i64toi32_i32$0 & 31 | 0;
                                      if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
                                       i64toi32_i32$3 = i64toi32_i32$5 << i64toi32_i32$2 | 0;
                                       $417 = 0;
                                      } else {
                                       i64toi32_i32$3 = ((1 << i64toi32_i32$2 | 0) - 1 | 0) & (i64toi32_i32$5 >>> (32 - i64toi32_i32$2 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$2 | 0) | 0;
                                       $417 = i64toi32_i32$5 << i64toi32_i32$2 | 0;
                                      }
                                      $305$hi = i64toi32_i32$3;
                                      i64toi32_i32$3 = $296$hi;
                                      i64toi32_i32$1 = $296;
                                      i64toi32_i32$5 = $305$hi;
                                      i64toi32_i32$0 = $417;
                                      i64toi32_i32$5 = i64toi32_i32$3 | i64toi32_i32$5 | 0;
                                      $28 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
                                      $28$hi = i64toi32_i32$5;
                                      $8 = HEAPU8[($2 + 472 | 0) >> 0] | 0;
                                      i64toi32_i32$3 = $2 + 464 | 0;
                                      i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                      i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                      $25 = i64toi32_i32$5;
                                      $25$hi = i64toi32_i32$1;
                                      i64toi32_i32$3 = $2 + 456 | 0;
                                      i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                      i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                      $22 = i64toi32_i32$1;
                                      $22$hi = i64toi32_i32$5;
                                      $18 = HEAPU8[(($2 + 440 | 0) + 8 | 0) >> 0] | 0;
                                      i64toi32_i32$3 = $2 + 488 | 0;
                                      i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                      i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                      $34 = i64toi32_i32$5;
                                      $34$hi = i64toi32_i32$1;
                                      $1 = HEAP32[($2 + 496 | 0) >> 2] | 0;
                                     }
                                     HEAP8[(($2 + 440 | 0) + 24 | 0) >> 0] = $8;
                                     i64toi32_i32$1 = $25$hi;
                                     i64toi32_i32$5 = ($2 + 440 | 0) + 16 | 0;
                                     HEAP32[i64toi32_i32$5 >> 2] = $25;
                                     HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$1;
                                     i64toi32_i32$1 = $22$hi;
                                     i64toi32_i32$5 = ($2 + 440 | 0) + 8 | 0;
                                     HEAP32[i64toi32_i32$5 >> 2] = $22;
                                     HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$1;
                                     i64toi32_i32$3 = $2;
                                     i64toi32_i32$1 = HEAP32[($2 + 400 | 0) >> 2] | 0;
                                     i64toi32_i32$5 = HEAP32[($2 + 404 | 0) >> 2] | 0;
                                     $341 = i64toi32_i32$1;
                                     i64toi32_i32$1 = $2 + 465 | 0;
                                     $325 = $341;
                                     HEAP8[i64toi32_i32$1 >> 0] = $325;
                                     HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $325 >>> 8 | 0;
                                     HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $325 >>> 16 | 0;
                                     HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $325 >>> 24 | 0;
                                     HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$5;
                                     HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$5 >>> 8 | 0;
                                     HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$5 >>> 16 | 0;
                                     HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$5 >>> 24 | 0;
                                     i64toi32_i32$3 = $2;
                                     i64toi32_i32$5 = HEAPU8[($2 + 407 | 0) >> 0] | 0 | ((HEAPU8[($2 + 408 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 409 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 410 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                     i64toi32_i32$1 = HEAPU8[($2 + 411 | 0) >> 0] | 0 | ((HEAPU8[($2 + 412 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 413 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 414 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                     $346 = i64toi32_i32$5;
                                     i64toi32_i32$5 = ($2 + 440 | 0) + 32 | 0;
                                     $326 = $346;
                                     HEAP8[i64toi32_i32$5 >> 0] = $326;
                                     HEAP8[(i64toi32_i32$5 + 1 | 0) >> 0] = $326 >>> 8 | 0;
                                     HEAP8[(i64toi32_i32$5 + 2 | 0) >> 0] = $326 >>> 16 | 0;
                                     HEAP8[(i64toi32_i32$5 + 3 | 0) >> 0] = $326 >>> 24 | 0;
                                     HEAP8[(i64toi32_i32$5 + 4 | 0) >> 0] = i64toi32_i32$1;
                                     HEAP8[(i64toi32_i32$5 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
                                     HEAP8[(i64toi32_i32$5 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
                                     HEAP8[(i64toi32_i32$5 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
                                     i64toi32_i32$1 = $34$hi;
                                     i64toi32_i32$5 = ($2 + 440 | 0) + 40 | 0;
                                     HEAP32[i64toi32_i32$5 >> 2] = $34;
                                     HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$1;
                                     i64toi32_i32$3 = $2;
                                     i64toi32_i32$1 = HEAP32[($2 + 424 | 0) >> 2] | 0;
                                     i64toi32_i32$5 = HEAP32[($2 + 428 | 0) >> 2] | 0;
                                     $354 = i64toi32_i32$1;
                                     i64toi32_i32$1 = $2 + 492 | 0;
                                     HEAP32[i64toi32_i32$1 >> 2] = $354;
                                     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$5;
                                     HEAP32[(($2 + 440 | 0) + 60 | 0) >> 2] = HEAP32[(($2 + 424 | 0) + 8 | 0) >> 2] | 0;
                                     HEAP8[($2 + 440 | 0) >> 0] = $18;
                                     HEAP32[($2 + 488 | 0) >> 2] = $1;
                                     i64toi32_i32$5 = $28$hi;
                                     HEAP8[($2 + 441 | 0) >> 0] = $28;
                                     HEAP8[($2 + 442 | 0) >> 0] = $28 >>> 8 | 0;
                                     HEAP8[($2 + 443 | 0) >> 0] = $28 >>> 16 | 0;
                                     HEAP8[($2 + 444 | 0) >> 0] = $28 >>> 24 | 0;
                                     $368 = $2;
                                     i64toi32_i32$3 = $28;
                                     i64toi32_i32$1 = 0;
                                     i64toi32_i32$0 = 48;
                                     i64toi32_i32$2 = i64toi32_i32$0 & 31 | 0;
                                     if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
                                      i64toi32_i32$1 = 0;
                                      $418 = i64toi32_i32$5 >>> i64toi32_i32$2 | 0;
                                     } else {
                                      i64toi32_i32$1 = i64toi32_i32$5 >>> i64toi32_i32$2 | 0;
                                      $418 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$2 | 0) | 0;
                                     }
                                     HEAP8[($368 + 447 | 0) >> 0] = $418;
                                     $371 = $2;
                                     i64toi32_i32$1 = $28$hi;
                                     i64toi32_i32$5 = $28;
                                     i64toi32_i32$3 = 0;
                                     i64toi32_i32$0 = 32;
                                     i64toi32_i32$2 = i64toi32_i32$0 & 31 | 0;
                                     if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
                                      i64toi32_i32$3 = 0;
                                      $419 = i64toi32_i32$1 >>> i64toi32_i32$2 | 0;
                                     } else {
                                      i64toi32_i32$3 = i64toi32_i32$1 >>> i64toi32_i32$2 | 0;
                                      $419 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$2 | 0) | 0;
                                     }
                                     $420 = $371;
                                     $421 = $419;
                                     HEAP8[($420 + 445 | 0) >> 0] = $421;
                                     HEAP8[($420 + 446 | 0) >> 0] = $421 >>> 8 | 0;
                                     $1 = ($2 + 328 | 0) + 8 | 0;
                                     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $2 + 440 | 0 | 0, 1050577 | 0, 10 | 0);
                                     HEAP32[(($2 + 24 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 396 | 0) >> 2] | 0;
                                     i64toi32_i32$1 = ($2 + 328 | 0) + 60 | 0;
                                     i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                     i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                     $390 = i64toi32_i32$3;
                                     i64toi32_i32$3 = $2;
                                     HEAP32[($2 + 24 | 0) >> 2] = $390;
                                     HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$5;
                                     i64toi32_i32$1 = $1;
                                     i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                     i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                     $28 = i64toi32_i32$5;
                                     $28$hi = i64toi32_i32$3;
                                     i64toi32_i32$1 = i64toi32_i32$5;
                                     i64toi32_i32$5 = -1;
                                     i64toi32_i32$0 = -256;
                                     i64toi32_i32$5 = i64toi32_i32$3 & i64toi32_i32$5 | 0;
                                     $29 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
                                     $29$hi = i64toi32_i32$5;
                                     i64toi32_i32$3 = ($2 + 328 | 0) + 16 | 0;
                                     i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                     i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                     $31 = i64toi32_i32$5;
                                     $31$hi = i64toi32_i32$1;
                                     i64toi32_i32$3 = ($2 + 328 | 0) + 24 | 0;
                                     i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                     i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                     $30 = i64toi32_i32$1;
                                     $30$hi = i64toi32_i32$5;
                                     i64toi32_i32$3 = ($2 + 328 | 0) + 32 | 0;
                                     i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                     i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                     $25 = i64toi32_i32$5;
                                     $25$hi = i64toi32_i32$1;
                                     i64toi32_i32$3 = ($2 + 328 | 0) + 40 | 0;
                                     i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                     i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                     $32 = i64toi32_i32$1;
                                     $32$hi = i64toi32_i32$5;
                                     i64toi32_i32$3 = $2 + 376 | 0;
                                     i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                     i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                     $33 = i64toi32_i32$5;
                                     $33$hi = i64toi32_i32$1;
                                     $8 = HEAP32[($2 + 384 | 0) >> 2] | 0;
                                     break label$3;
                                    }
                                    $6 = HEAPU8[($2 + 441 | 0) >> 0] | 0;
                                    break label$12;
                                   }
                                   label$66 : {
                                    label$67 : {
                                     if ($5) {
                                      break label$67
                                     }
                                     i64toi32_i32$1 = $25$hi;
                                     i64toi32_i32$3 = $25;
                                     i64toi32_i32$5 = 0;
                                     i64toi32_i32$0 = 1;
                                     i64toi32_i32$2 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
                                     i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
                                     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$0 >>> 0) {
                                      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
                                     }
                                     $25 = i64toi32_i32$2;
                                     $25$hi = i64toi32_i32$4;
                                     i64toi32_i32$4 = $22$hi;
                                     i64toi32_i32$4 = $25$hi;
                                     i64toi32_i32$1 = i64toi32_i32$2;
                                     i64toi32_i32$3 = $22$hi;
                                     i64toi32_i32$0 = $22;
                                     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$1 >>> 0 <= i64toi32_i32$0 >>> 0 | 0) | 0) {
                                      break label$67
                                     }
                                     $1 = 0;
                                     i64toi32_i32$1 = 0;
                                     $25 = 0;
                                     $25$hi = i64toi32_i32$1;
                                     $18 = 3;
                                     break label$66;
                                    }
                                    cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__Ed25519KeyHashes___deserialize__hae609f6be80519f0($2 + 440 | 0 | 0, $1 | 0);
                                    if ((HEAP32[($2 + 440 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                                     break label$22
                                    }
                                    $5 = ($2 + 424 | 0) + 8 | 0;
                                    HEAP32[$5 >> 2] = HEAP32[($2 + 508 | 0) >> 2] | 0;
                                    i64toi32_i32$0 = $2;
                                    i64toi32_i32$1 = HEAPU8[($2 + 473 | 0) >> 0] | 0 | ((HEAPU8[($2 + 474 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 475 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 476 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                    i64toi32_i32$4 = HEAPU8[($2 + 477 | 0) >> 0] | 0 | ((HEAPU8[($2 + 478 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 479 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 480 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                    $440 = i64toi32_i32$1;
                                    i64toi32_i32$1 = $2;
                                    HEAP32[($2 + 24 | 0) >> 2] = $440;
                                    HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$4;
                                    i64toi32_i32$0 = $2 + 480 | 0;
                                    i64toi32_i32$4 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                    $444 = i64toi32_i32$4;
                                    i64toi32_i32$4 = $2;
                                    $327 = $444;
                                    HEAP8[($2 + 31 | 0) >> 0] = $327;
                                    HEAP8[($2 + 32 | 0) >> 0] = $327 >>> 8 | 0;
                                    HEAP8[($2 + 33 | 0) >> 0] = $327 >>> 16 | 0;
                                    HEAP8[($2 + 34 | 0) >> 0] = $327 >>> 24 | 0;
                                    HEAP8[($2 + 35 | 0) >> 0] = i64toi32_i32$1;
                                    HEAP8[($2 + 36 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
                                    HEAP8[($2 + 37 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
                                    HEAP8[($2 + 38 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
                                    i64toi32_i32$0 = $2 + 500 | 0;
                                    i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                    i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                    $448 = i64toi32_i32$1;
                                    i64toi32_i32$1 = $2;
                                    HEAP32[($2 + 424 | 0) >> 2] = $448;
                                    HEAP32[($2 + 428 | 0) >> 2] = i64toi32_i32$4;
                                    i64toi32_i32$0 = $2;
                                    i64toi32_i32$4 = HEAP32[($2 + 24 | 0) >> 2] | 0;
                                    i64toi32_i32$1 = HEAP32[($2 + 28 | 0) >> 2] | 0;
                                    $451 = i64toi32_i32$4;
                                    i64toi32_i32$4 = $2;
                                    HEAP32[($2 + 400 | 0) >> 2] = $451;
                                    HEAP32[($2 + 404 | 0) >> 2] = i64toi32_i32$1;
                                    i64toi32_i32$0 = $2;
                                    i64toi32_i32$1 = HEAPU8[($2 + 31 | 0) >> 0] | 0 | ((HEAPU8[($2 + 32 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 33 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 34 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                    i64toi32_i32$4 = HEAPU8[($2 + 35 | 0) >> 0] | 0 | ((HEAPU8[($2 + 36 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 37 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 38 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                    $454 = i64toi32_i32$1;
                                    i64toi32_i32$1 = $2;
                                    $328 = $454;
                                    HEAP8[($2 + 407 | 0) >> 0] = $328;
                                    HEAP8[($2 + 408 | 0) >> 0] = $328 >>> 8 | 0;
                                    HEAP8[($2 + 409 | 0) >> 0] = $328 >>> 16 | 0;
                                    HEAP8[($2 + 410 | 0) >> 0] = $328 >>> 24 | 0;
                                    HEAP8[($2 + 411 | 0) >> 0] = i64toi32_i32$4;
                                    HEAP8[($2 + 412 | 0) >> 0] = i64toi32_i32$4 >>> 8 | 0;
                                    HEAP8[($2 + 413 | 0) >> 0] = i64toi32_i32$4 >>> 16 | 0;
                                    HEAP8[($2 + 414 | 0) >> 0] = i64toi32_i32$4 >>> 24 | 0;
                                    $8 = HEAPU8[($2 + 472 | 0) >> 0] | 0;
                                    i64toi32_i32$0 = $2 + 464 | 0;
                                    i64toi32_i32$4 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                    i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                    $25 = i64toi32_i32$4;
                                    $25$hi = i64toi32_i32$1;
                                    i64toi32_i32$0 = $2 + 456 | 0;
                                    i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                    i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                    $22 = i64toi32_i32$1;
                                    $22$hi = i64toi32_i32$4;
                                    i64toi32_i32$0 = $2 + 488 | 0;
                                    i64toi32_i32$4 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                    i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                    $34 = i64toi32_i32$4;
                                    $34$hi = i64toi32_i32$1;
                                    $1 = HEAP32[($2 + 496 | 0) >> 2] | 0;
                                    i64toi32_i32$0 = $2 + 453 | 0;
                                    i64toi32_i32$1 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
                                    i64toi32_i32$4 = 0;
                                    $28 = i64toi32_i32$1;
                                    $28$hi = i64toi32_i32$4;
                                    i64toi32_i32$0 = $2 + 455 | 0;
                                    i64toi32_i32$4 = HEAPU8[i64toi32_i32$0 >> 0] | 0;
                                    i64toi32_i32$1 = 0;
                                    $31 = i64toi32_i32$4;
                                    $31$hi = i64toi32_i32$1;
                                    $18 = HEAPU8[($2 + 448 | 0) >> 0] | 0;
                                    i64toi32_i32$0 = $2;
                                    i64toi32_i32$1 = HEAPU8[($2 + 449 | 0) >> 0] | 0 | ((HEAPU8[($2 + 450 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 451 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 452 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                    i64toi32_i32$4 = 0;
                                    $30 = i64toi32_i32$1;
                                    $30$hi = i64toi32_i32$4;
                                    HEAP32[(($2 + 312 | 0) + 8 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
                                    i64toi32_i32$0 = $2;
                                    i64toi32_i32$4 = HEAP32[($2 + 424 | 0) >> 2] | 0;
                                    i64toi32_i32$1 = HEAP32[($2 + 428 | 0) >> 2] | 0;
                                    $487 = i64toi32_i32$4;
                                    i64toi32_i32$4 = $2;
                                    HEAP32[($2 + 312 | 0) >> 2] = $487;
                                    HEAP32[($2 + 316 | 0) >> 2] = i64toi32_i32$1;
                                    i64toi32_i32$1 = $30$hi;
                                    $488 = $30;
                                    $488$hi = i64toi32_i32$1;
                                    i64toi32_i32$1 = $28$hi;
                                    $489 = $28;
                                    $489$hi = i64toi32_i32$1;
                                    i64toi32_i32$1 = $31$hi;
                                    i64toi32_i32$0 = $31;
                                    i64toi32_i32$4 = 0;
                                    i64toi32_i32$3 = 16;
                                    i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
                                    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                                     i64toi32_i32$4 = i64toi32_i32$0 << i64toi32_i32$5 | 0;
                                     $422 = 0;
                                    } else {
                                     i64toi32_i32$4 = ((1 << i64toi32_i32$5 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$5 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$5 | 0) | 0;
                                     $422 = i64toi32_i32$0 << i64toi32_i32$5 | 0;
                                    }
                                    $491$hi = i64toi32_i32$4;
                                    i64toi32_i32$4 = $489$hi;
                                    i64toi32_i32$1 = $489;
                                    i64toi32_i32$0 = $491$hi;
                                    i64toi32_i32$3 = $422;
                                    i64toi32_i32$0 = i64toi32_i32$4 | i64toi32_i32$0 | 0;
                                    i64toi32_i32$4 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
                                    i64toi32_i32$1 = 0;
                                    i64toi32_i32$3 = 32;
                                    i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
                                    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                                     i64toi32_i32$1 = i64toi32_i32$4 << i64toi32_i32$5 | 0;
                                     $423 = 0;
                                    } else {
                                     i64toi32_i32$1 = ((1 << i64toi32_i32$5 | 0) - 1 | 0) & (i64toi32_i32$4 >>> (32 - i64toi32_i32$5 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$5 | 0) | 0;
                                     $423 = i64toi32_i32$4 << i64toi32_i32$5 | 0;
                                    }
                                    $493$hi = i64toi32_i32$1;
                                    i64toi32_i32$1 = $488$hi;
                                    i64toi32_i32$0 = $488;
                                    i64toi32_i32$4 = $493$hi;
                                    i64toi32_i32$3 = $423;
                                    i64toi32_i32$4 = i64toi32_i32$1 | i64toi32_i32$4 | 0;
                                    $28 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
                                    $28$hi = i64toi32_i32$4;
                                   }
                                   HEAP8[(($2 + 440 | 0) + 24 | 0) >> 0] = $8;
                                   i64toi32_i32$4 = $25$hi;
                                   i64toi32_i32$0 = ($2 + 440 | 0) + 16 | 0;
                                   HEAP32[i64toi32_i32$0 >> 2] = $25;
                                   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$4;
                                   i64toi32_i32$4 = $22$hi;
                                   i64toi32_i32$0 = ($2 + 440 | 0) + 8 | 0;
                                   HEAP32[i64toi32_i32$0 >> 2] = $22;
                                   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$4;
                                   i64toi32_i32$1 = $2;
                                   i64toi32_i32$4 = HEAP32[($2 + 400 | 0) >> 2] | 0;
                                   i64toi32_i32$0 = HEAP32[($2 + 404 | 0) >> 2] | 0;
                                   $510 = i64toi32_i32$4;
                                   i64toi32_i32$4 = $2 + 465 | 0;
                                   $329 = $510;
                                   HEAP8[i64toi32_i32$4 >> 0] = $329;
                                   HEAP8[(i64toi32_i32$4 + 1 | 0) >> 0] = $329 >>> 8 | 0;
                                   HEAP8[(i64toi32_i32$4 + 2 | 0) >> 0] = $329 >>> 16 | 0;
                                   HEAP8[(i64toi32_i32$4 + 3 | 0) >> 0] = $329 >>> 24 | 0;
                                   HEAP8[(i64toi32_i32$4 + 4 | 0) >> 0] = i64toi32_i32$0;
                                   HEAP8[(i64toi32_i32$4 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                                   HEAP8[(i64toi32_i32$4 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
                                   HEAP8[(i64toi32_i32$4 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
                                   i64toi32_i32$1 = $2;
                                   i64toi32_i32$0 = HEAPU8[($2 + 407 | 0) >> 0] | 0 | ((HEAPU8[($2 + 408 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 409 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 410 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                   i64toi32_i32$4 = HEAPU8[($2 + 411 | 0) >> 0] | 0 | ((HEAPU8[($2 + 412 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 413 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 414 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                   $515 = i64toi32_i32$0;
                                   i64toi32_i32$0 = ($2 + 440 | 0) + 32 | 0;
                                   $330 = $515;
                                   HEAP8[i64toi32_i32$0 >> 0] = $330;
                                   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $330 >>> 8 | 0;
                                   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $330 >>> 16 | 0;
                                   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $330 >>> 24 | 0;
                                   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$4;
                                   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$4 >>> 8 | 0;
                                   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$4 >>> 16 | 0;
                                   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$4 >>> 24 | 0;
                                   i64toi32_i32$4 = $34$hi;
                                   i64toi32_i32$0 = ($2 + 440 | 0) + 40 | 0;
                                   HEAP32[i64toi32_i32$0 >> 2] = $34;
                                   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$4;
                                   i64toi32_i32$1 = $2;
                                   i64toi32_i32$4 = HEAP32[($2 + 312 | 0) >> 2] | 0;
                                   i64toi32_i32$0 = HEAP32[($2 + 316 | 0) >> 2] | 0;
                                   $523 = i64toi32_i32$4;
                                   i64toi32_i32$4 = $2 + 492 | 0;
                                   HEAP32[i64toi32_i32$4 >> 2] = $523;
                                   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$0;
                                   HEAP32[(($2 + 440 | 0) + 60 | 0) >> 2] = HEAP32[(($2 + 312 | 0) + 8 | 0) >> 2] | 0;
                                   HEAP8[($2 + 440 | 0) >> 0] = $18;
                                   HEAP32[($2 + 488 | 0) >> 2] = $1;
                                   i64toi32_i32$0 = $28$hi;
                                   HEAP8[($2 + 441 | 0) >> 0] = $28;
                                   HEAP8[($2 + 442 | 0) >> 0] = $28 >>> 8 | 0;
                                   HEAP8[($2 + 443 | 0) >> 0] = $28 >>> 16 | 0;
                                   HEAP8[($2 + 444 | 0) >> 0] = $28 >>> 24 | 0;
                                   $537 = $2;
                                   i64toi32_i32$1 = $28;
                                   i64toi32_i32$4 = 0;
                                   i64toi32_i32$3 = 48;
                                   i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
                                   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                                    i64toi32_i32$4 = 0;
                                    $424 = i64toi32_i32$0 >>> i64toi32_i32$5 | 0;
                                   } else {
                                    i64toi32_i32$4 = i64toi32_i32$0 >>> i64toi32_i32$5 | 0;
                                    $424 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$5 | 0) | 0;
                                   }
                                   HEAP8[($537 + 447 | 0) >> 0] = $424;
                                   $540 = $2;
                                   i64toi32_i32$4 = $28$hi;
                                   i64toi32_i32$0 = $28;
                                   i64toi32_i32$1 = 0;
                                   i64toi32_i32$3 = 32;
                                   i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
                                   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                                    i64toi32_i32$1 = 0;
                                    $425 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
                                   } else {
                                    i64toi32_i32$1 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
                                    $425 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$5 | 0) | 0;
                                   }
                                   $426 = $540;
                                   $427 = $425;
                                   HEAP8[($426 + 445 | 0) >> 0] = $427;
                                   HEAP8[($426 + 446 | 0) >> 0] = $427 >>> 8 | 0;
                                   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($10 | 0, $2 + 440 | 0 | 0, 1050561 | 0, 16 | 0);
                                   HEAP32[(($2 + 24 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 396 | 0) >> 2] | 0;
                                   i64toi32_i32$4 = ($2 + 328 | 0) + 60 | 0;
                                   i64toi32_i32$1 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                   i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                   $556 = i64toi32_i32$1;
                                   i64toi32_i32$1 = $2;
                                   HEAP32[($2 + 24 | 0) >> 2] = $556;
                                   HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$0;
                                   i64toi32_i32$4 = $2;
                                   i64toi32_i32$0 = HEAP32[($2 + 336 | 0) >> 2] | 0;
                                   i64toi32_i32$1 = HEAP32[($2 + 340 | 0) >> 2] | 0;
                                   $28 = i64toi32_i32$0;
                                   $28$hi = i64toi32_i32$1;
                                   i64toi32_i32$4 = i64toi32_i32$0;
                                   i64toi32_i32$0 = -1;
                                   i64toi32_i32$3 = -256;
                                   i64toi32_i32$0 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
                                   $29 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
                                   $29$hi = i64toi32_i32$0;
                                   i64toi32_i32$1 = ($2 + 328 | 0) + 16 | 0;
                                   i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                   $31 = i64toi32_i32$0;
                                   $31$hi = i64toi32_i32$4;
                                   i64toi32_i32$1 = ($2 + 328 | 0) + 24 | 0;
                                   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                   i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                   $30 = i64toi32_i32$4;
                                   $30$hi = i64toi32_i32$0;
                                   i64toi32_i32$1 = ($2 + 328 | 0) + 32 | 0;
                                   i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                   $25 = i64toi32_i32$0;
                                   $25$hi = i64toi32_i32$4;
                                   i64toi32_i32$1 = ($2 + 328 | 0) + 40 | 0;
                                   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                   i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                   $32 = i64toi32_i32$4;
                                   $32$hi = i64toi32_i32$0;
                                   i64toi32_i32$1 = $2 + 376 | 0;
                                   i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                   $33 = i64toi32_i32$0;
                                   $33$hi = i64toi32_i32$4;
                                   $8 = HEAP32[($2 + 384 | 0) >> 2] | 0;
                                   break label$3;
                                  }
                                  label$68 : {
                                   label$69 : {
                                    if ($5) {
                                     break label$69
                                    }
                                    i64toi32_i32$4 = $25$hi;
                                    i64toi32_i32$1 = $25;
                                    i64toi32_i32$0 = 0;
                                    i64toi32_i32$3 = 1;
                                    i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
                                    i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
                                    if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
                                     i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
                                    }
                                    $25 = i64toi32_i32$5;
                                    $25$hi = i64toi32_i32$2;
                                    i64toi32_i32$2 = $22$hi;
                                    i64toi32_i32$2 = $25$hi;
                                    i64toi32_i32$4 = i64toi32_i32$5;
                                    i64toi32_i32$1 = $22$hi;
                                    i64toi32_i32$3 = $22;
                                    if (i64toi32_i32$2 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$4 >>> 0 <= i64toi32_i32$3 >>> 0 | 0) | 0) {
                                     break label$69
                                    }
                                    $1 = 0;
                                    i64toi32_i32$4 = 0;
                                    $25 = 0;
                                    $25$hi = i64toi32_i32$4;
                                    $18 = 3;
                                    break label$68;
                                   }
                                   cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__TransactionInputs___deserialize__hccdd71f9bd7c3281($2 + 440 | 0 | 0, $1 | 0);
                                   if ((HEAP32[($2 + 440 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                                    break label$21
                                   }
                                   $5 = ($2 + 424 | 0) + 8 | 0;
                                   HEAP32[$5 >> 2] = HEAP32[($2 + 508 | 0) >> 2] | 0;
                                   i64toi32_i32$3 = $2;
                                   i64toi32_i32$4 = HEAPU8[($2 + 473 | 0) >> 0] | 0 | ((HEAPU8[($2 + 474 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 475 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 476 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                   i64toi32_i32$2 = HEAPU8[($2 + 477 | 0) >> 0] | 0 | ((HEAPU8[($2 + 478 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 479 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 480 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                   $604 = i64toi32_i32$4;
                                   i64toi32_i32$4 = $2;
                                   HEAP32[($2 + 24 | 0) >> 2] = $604;
                                   HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$2;
                                   i64toi32_i32$3 = $2 + 480 | 0;
                                   i64toi32_i32$2 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                   i64toi32_i32$4 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                   $608 = i64toi32_i32$2;
                                   i64toi32_i32$2 = $2;
                                   $331 = $608;
                                   HEAP8[($2 + 31 | 0) >> 0] = $331;
                                   HEAP8[($2 + 32 | 0) >> 0] = $331 >>> 8 | 0;
                                   HEAP8[($2 + 33 | 0) >> 0] = $331 >>> 16 | 0;
                                   HEAP8[($2 + 34 | 0) >> 0] = $331 >>> 24 | 0;
                                   HEAP8[($2 + 35 | 0) >> 0] = i64toi32_i32$4;
                                   HEAP8[($2 + 36 | 0) >> 0] = i64toi32_i32$4 >>> 8 | 0;
                                   HEAP8[($2 + 37 | 0) >> 0] = i64toi32_i32$4 >>> 16 | 0;
                                   HEAP8[($2 + 38 | 0) >> 0] = i64toi32_i32$4 >>> 24 | 0;
                                   i64toi32_i32$3 = $2 + 500 | 0;
                                   i64toi32_i32$4 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                   i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                   $612 = i64toi32_i32$4;
                                   i64toi32_i32$4 = $2;
                                   HEAP32[($2 + 424 | 0) >> 2] = $612;
                                   HEAP32[($2 + 428 | 0) >> 2] = i64toi32_i32$2;
                                   i64toi32_i32$3 = $2;
                                   i64toi32_i32$2 = HEAP32[($2 + 24 | 0) >> 2] | 0;
                                   i64toi32_i32$4 = HEAP32[($2 + 28 | 0) >> 2] | 0;
                                   $615 = i64toi32_i32$2;
                                   i64toi32_i32$2 = $2;
                                   HEAP32[($2 + 400 | 0) >> 2] = $615;
                                   HEAP32[($2 + 404 | 0) >> 2] = i64toi32_i32$4;
                                   i64toi32_i32$3 = $2;
                                   i64toi32_i32$4 = HEAPU8[($2 + 31 | 0) >> 0] | 0 | ((HEAPU8[($2 + 32 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 33 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 34 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                   i64toi32_i32$2 = HEAPU8[($2 + 35 | 0) >> 0] | 0 | ((HEAPU8[($2 + 36 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 37 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 38 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                   $618 = i64toi32_i32$4;
                                   i64toi32_i32$4 = $2;
                                   $332 = $618;
                                   HEAP8[($2 + 407 | 0) >> 0] = $332;
                                   HEAP8[($2 + 408 | 0) >> 0] = $332 >>> 8 | 0;
                                   HEAP8[($2 + 409 | 0) >> 0] = $332 >>> 16 | 0;
                                   HEAP8[($2 + 410 | 0) >> 0] = $332 >>> 24 | 0;
                                   HEAP8[($2 + 411 | 0) >> 0] = i64toi32_i32$2;
                                   HEAP8[($2 + 412 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
                                   HEAP8[($2 + 413 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
                                   HEAP8[($2 + 414 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
                                   $8 = HEAPU8[($2 + 472 | 0) >> 0] | 0;
                                   i64toi32_i32$3 = $2 + 464 | 0;
                                   i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                   i64toi32_i32$4 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                   $25 = i64toi32_i32$2;
                                   $25$hi = i64toi32_i32$4;
                                   i64toi32_i32$3 = $2 + 456 | 0;
                                   i64toi32_i32$4 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                   i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                   $22 = i64toi32_i32$4;
                                   $22$hi = i64toi32_i32$2;
                                   i64toi32_i32$3 = $2 + 488 | 0;
                                   i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                   i64toi32_i32$4 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                   $34 = i64toi32_i32$2;
                                   $34$hi = i64toi32_i32$4;
                                   $1 = HEAP32[($2 + 496 | 0) >> 2] | 0;
                                   i64toi32_i32$3 = $2 + 453 | 0;
                                   i64toi32_i32$4 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
                                   i64toi32_i32$2 = 0;
                                   $28 = i64toi32_i32$4;
                                   $28$hi = i64toi32_i32$2;
                                   i64toi32_i32$3 = $2 + 455 | 0;
                                   i64toi32_i32$2 = HEAPU8[i64toi32_i32$3 >> 0] | 0;
                                   i64toi32_i32$4 = 0;
                                   $31 = i64toi32_i32$2;
                                   $31$hi = i64toi32_i32$4;
                                   $18 = HEAPU8[($2 + 448 | 0) >> 0] | 0;
                                   i64toi32_i32$3 = $2;
                                   i64toi32_i32$4 = HEAPU8[($2 + 449 | 0) >> 0] | 0 | ((HEAPU8[($2 + 450 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 451 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 452 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                   i64toi32_i32$2 = 0;
                                   $30 = i64toi32_i32$4;
                                   $30$hi = i64toi32_i32$2;
                                   HEAP32[(($2 + 312 | 0) + 8 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
                                   i64toi32_i32$3 = $2;
                                   i64toi32_i32$2 = HEAP32[($2 + 424 | 0) >> 2] | 0;
                                   i64toi32_i32$4 = HEAP32[($2 + 428 | 0) >> 2] | 0;
                                   $651 = i64toi32_i32$2;
                                   i64toi32_i32$2 = $2;
                                   HEAP32[($2 + 312 | 0) >> 2] = $651;
                                   HEAP32[($2 + 316 | 0) >> 2] = i64toi32_i32$4;
                                   i64toi32_i32$4 = $30$hi;
                                   $652 = $30;
                                   $652$hi = i64toi32_i32$4;
                                   i64toi32_i32$4 = $28$hi;
                                   $653 = $28;
                                   $653$hi = i64toi32_i32$4;
                                   i64toi32_i32$4 = $31$hi;
                                   i64toi32_i32$3 = $31;
                                   i64toi32_i32$2 = 0;
                                   i64toi32_i32$1 = 16;
                                   i64toi32_i32$0 = i64toi32_i32$1 & 31 | 0;
                                   if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                                    i64toi32_i32$2 = i64toi32_i32$3 << i64toi32_i32$0 | 0;
                                    $428 = 0;
                                   } else {
                                    i64toi32_i32$2 = ((1 << i64toi32_i32$0 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$0 | 0) | 0) | 0 | (i64toi32_i32$4 << i64toi32_i32$0 | 0) | 0;
                                    $428 = i64toi32_i32$3 << i64toi32_i32$0 | 0;
                                   }
                                   $655$hi = i64toi32_i32$2;
                                   i64toi32_i32$2 = $653$hi;
                                   i64toi32_i32$4 = $653;
                                   i64toi32_i32$3 = $655$hi;
                                   i64toi32_i32$1 = $428;
                                   i64toi32_i32$3 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
                                   i64toi32_i32$2 = i64toi32_i32$4 | i64toi32_i32$1 | 0;
                                   i64toi32_i32$4 = 0;
                                   i64toi32_i32$1 = 32;
                                   i64toi32_i32$0 = i64toi32_i32$1 & 31 | 0;
                                   if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                                    i64toi32_i32$4 = i64toi32_i32$2 << i64toi32_i32$0 | 0;
                                    $429 = 0;
                                   } else {
                                    i64toi32_i32$4 = ((1 << i64toi32_i32$0 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$0 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$0 | 0) | 0;
                                    $429 = i64toi32_i32$2 << i64toi32_i32$0 | 0;
                                   }
                                   $657$hi = i64toi32_i32$4;
                                   i64toi32_i32$4 = $652$hi;
                                   i64toi32_i32$3 = $652;
                                   i64toi32_i32$2 = $657$hi;
                                   i64toi32_i32$1 = $429;
                                   i64toi32_i32$2 = i64toi32_i32$4 | i64toi32_i32$2 | 0;
                                   $28 = i64toi32_i32$3 | i64toi32_i32$1 | 0;
                                   $28$hi = i64toi32_i32$2;
                                  }
                                  HEAP8[(($2 + 440 | 0) + 24 | 0) >> 0] = $8;
                                  i64toi32_i32$2 = $25$hi;
                                  i64toi32_i32$3 = ($2 + 440 | 0) + 16 | 0;
                                  HEAP32[i64toi32_i32$3 >> 2] = $25;
                                  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                                  i64toi32_i32$2 = $22$hi;
                                  i64toi32_i32$3 = ($2 + 440 | 0) + 8 | 0;
                                  HEAP32[i64toi32_i32$3 >> 2] = $22;
                                  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                                  i64toi32_i32$4 = $2;
                                  i64toi32_i32$2 = HEAP32[($2 + 400 | 0) >> 2] | 0;
                                  i64toi32_i32$3 = HEAP32[($2 + 404 | 0) >> 2] | 0;
                                  $674 = i64toi32_i32$2;
                                  i64toi32_i32$2 = $2 + 465 | 0;
                                  $333 = $674;
                                  HEAP8[i64toi32_i32$2 >> 0] = $333;
                                  HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $333 >>> 8 | 0;
                                  HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $333 >>> 16 | 0;
                                  HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $333 >>> 24 | 0;
                                  HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$3;
                                  HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
                                  HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
                                  HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
                                  i64toi32_i32$4 = $2;
                                  i64toi32_i32$3 = HEAPU8[($2 + 407 | 0) >> 0] | 0 | ((HEAPU8[($2 + 408 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 409 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 410 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                  i64toi32_i32$2 = HEAPU8[($2 + 411 | 0) >> 0] | 0 | ((HEAPU8[($2 + 412 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 413 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 414 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                  $679 = i64toi32_i32$3;
                                  i64toi32_i32$3 = ($2 + 440 | 0) + 32 | 0;
                                  $334 = $679;
                                  HEAP8[i64toi32_i32$3 >> 0] = $334;
                                  HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $334 >>> 8 | 0;
                                  HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $334 >>> 16 | 0;
                                  HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $334 >>> 24 | 0;
                                  HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$2;
                                  HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
                                  HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
                                  HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
                                  i64toi32_i32$2 = $34$hi;
                                  i64toi32_i32$3 = ($2 + 440 | 0) + 40 | 0;
                                  HEAP32[i64toi32_i32$3 >> 2] = $34;
                                  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                                  i64toi32_i32$4 = $2;
                                  i64toi32_i32$2 = HEAP32[($2 + 312 | 0) >> 2] | 0;
                                  i64toi32_i32$3 = HEAP32[($2 + 316 | 0) >> 2] | 0;
                                  $687 = i64toi32_i32$2;
                                  i64toi32_i32$2 = $2 + 492 | 0;
                                  HEAP32[i64toi32_i32$2 >> 2] = $687;
                                  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                                  HEAP32[(($2 + 440 | 0) + 60 | 0) >> 2] = HEAP32[(($2 + 312 | 0) + 8 | 0) >> 2] | 0;
                                  HEAP8[($2 + 440 | 0) >> 0] = $18;
                                  HEAP32[($2 + 488 | 0) >> 2] = $1;
                                  i64toi32_i32$3 = $28$hi;
                                  HEAP8[($2 + 441 | 0) >> 0] = $28;
                                  HEAP8[($2 + 442 | 0) >> 0] = $28 >>> 8 | 0;
                                  HEAP8[($2 + 443 | 0) >> 0] = $28 >>> 16 | 0;
                                  HEAP8[($2 + 444 | 0) >> 0] = $28 >>> 24 | 0;
                                  $701 = $2;
                                  i64toi32_i32$4 = $28;
                                  i64toi32_i32$2 = 0;
                                  i64toi32_i32$1 = 48;
                                  i64toi32_i32$0 = i64toi32_i32$1 & 31 | 0;
                                  if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                                   i64toi32_i32$2 = 0;
                                   $430 = i64toi32_i32$3 >>> i64toi32_i32$0 | 0;
                                  } else {
                                   i64toi32_i32$2 = i64toi32_i32$3 >>> i64toi32_i32$0 | 0;
                                   $430 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$0 | 0) | 0;
                                  }
                                  HEAP8[($701 + 447 | 0) >> 0] = $430;
                                  $704 = $2;
                                  i64toi32_i32$2 = $28$hi;
                                  i64toi32_i32$3 = $28;
                                  i64toi32_i32$4 = 0;
                                  i64toi32_i32$1 = 32;
                                  i64toi32_i32$0 = i64toi32_i32$1 & 31 | 0;
                                  if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                                   i64toi32_i32$4 = 0;
                                   $431 = i64toi32_i32$2 >>> i64toi32_i32$0 | 0;
                                  } else {
                                   i64toi32_i32$4 = i64toi32_i32$2 >>> i64toi32_i32$0 | 0;
                                   $431 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$0 | 0) | 0;
                                  }
                                  $432 = $704;
                                  $433 = $431;
                                  HEAP8[($432 + 445 | 0) >> 0] = $433;
                                  HEAP8[($432 + 446 | 0) >> 0] = $433 >>> 8 | 0;
                                  cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($10 | 0, $2 + 440 | 0 | 0, 1050551 | 0, 10 | 0);
                                  HEAP32[(($2 + 24 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 396 | 0) >> 2] | 0;
                                  i64toi32_i32$2 = ($2 + 328 | 0) + 60 | 0;
                                  i64toi32_i32$4 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                  i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                  $720 = i64toi32_i32$4;
                                  i64toi32_i32$4 = $2;
                                  HEAP32[($2 + 24 | 0) >> 2] = $720;
                                  HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$3;
                                  i64toi32_i32$2 = $2;
                                  i64toi32_i32$3 = HEAP32[($2 + 336 | 0) >> 2] | 0;
                                  i64toi32_i32$4 = HEAP32[($2 + 340 | 0) >> 2] | 0;
                                  $28 = i64toi32_i32$3;
                                  $28$hi = i64toi32_i32$4;
                                  i64toi32_i32$2 = i64toi32_i32$3;
                                  i64toi32_i32$3 = -1;
                                  i64toi32_i32$1 = -256;
                                  i64toi32_i32$3 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
                                  $29 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
                                  $29$hi = i64toi32_i32$3;
                                  i64toi32_i32$4 = ($2 + 328 | 0) + 16 | 0;
                                  i64toi32_i32$3 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                  i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                  $31 = i64toi32_i32$3;
                                  $31$hi = i64toi32_i32$2;
                                  i64toi32_i32$4 = ($2 + 328 | 0) + 24 | 0;
                                  i64toi32_i32$2 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                  i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                  $30 = i64toi32_i32$2;
                                  $30$hi = i64toi32_i32$3;
                                  i64toi32_i32$4 = ($2 + 328 | 0) + 32 | 0;
                                  i64toi32_i32$3 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                  i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                  $25 = i64toi32_i32$3;
                                  $25$hi = i64toi32_i32$2;
                                  i64toi32_i32$4 = ($2 + 328 | 0) + 40 | 0;
                                  i64toi32_i32$2 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                  i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                  $32 = i64toi32_i32$2;
                                  $32$hi = i64toi32_i32$3;
                                  i64toi32_i32$4 = $2 + 376 | 0;
                                  i64toi32_i32$3 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                  i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                  $33 = i64toi32_i32$3;
                                  $33$hi = i64toi32_i32$2;
                                  $8 = HEAP32[($2 + 384 | 0) >> 2] | 0;
                                  break label$3;
                                 }
                                 label$70 : {
                                  label$71 : {
                                   if ($5) {
                                    break label$71
                                   }
                                   i64toi32_i32$2 = $25$hi;
                                   i64toi32_i32$4 = $25;
                                   i64toi32_i32$3 = 0;
                                   i64toi32_i32$1 = 1;
                                   i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
                                   i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
                                   if (i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0) {
                                    i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
                                   }
                                   $25 = i64toi32_i32$0;
                                   $25$hi = i64toi32_i32$5;
                                   i64toi32_i32$5 = $22$hi;
                                   i64toi32_i32$5 = $25$hi;
                                   i64toi32_i32$2 = i64toi32_i32$0;
                                   i64toi32_i32$4 = $22$hi;
                                   i64toi32_i32$1 = $22;
                                   if (i64toi32_i32$5 >>> 0 < i64toi32_i32$4 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$4 | 0) & i64toi32_i32$0 >>> 0 <= i64toi32_i32$1 >>> 0 | 0) | 0) {
                                    break label$71
                                   }
                                   $1 = 0;
                                   i64toi32_i32$2 = 0;
                                   $25 = 0;
                                   $25$hi = i64toi32_i32$2;
                                   $18 = 3;
                                   break label$70;
                                  }
                                  $cardano_serialization_lib__crypto__ScriptDataHash_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h6a388763d9e64234($2 + 440 | 0 | 0, $1 | 0);
                                  if ((HEAPU8[($2 + 440 | 0) >> 0] | 0 | 0) != (1 | 0)) {
                                   break label$20
                                  }
                                  $5 = ($2 + 424 | 0) + 8 | 0;
                                  HEAP32[$5 >> 2] = HEAP32[($2 + 508 | 0) >> 2] | 0;
                                  i64toi32_i32$1 = $2 + 480 | 0;
                                  i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                  i64toi32_i32$5 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                  $769 = i64toi32_i32$2;
                                  i64toi32_i32$2 = $2;
                                  $335 = $769;
                                  HEAP8[($2 + 31 | 0) >> 0] = $335;
                                  HEAP8[($2 + 32 | 0) >> 0] = $335 >>> 8 | 0;
                                  HEAP8[($2 + 33 | 0) >> 0] = $335 >>> 16 | 0;
                                  HEAP8[($2 + 34 | 0) >> 0] = $335 >>> 24 | 0;
                                  HEAP8[($2 + 35 | 0) >> 0] = i64toi32_i32$5;
                                  HEAP8[($2 + 36 | 0) >> 0] = i64toi32_i32$5 >>> 8 | 0;
                                  HEAP8[($2 + 37 | 0) >> 0] = i64toi32_i32$5 >>> 16 | 0;
                                  HEAP8[($2 + 38 | 0) >> 0] = i64toi32_i32$5 >>> 24 | 0;
                                  i64toi32_i32$1 = $2 + 473 | 0;
                                  i64toi32_i32$5 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                  i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                  $773 = i64toi32_i32$5;
                                  i64toi32_i32$5 = $2;
                                  HEAP32[($2 + 24 | 0) >> 2] = $773;
                                  HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$2;
                                  i64toi32_i32$1 = $2 + 500 | 0;
                                  i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                  i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                  $777 = i64toi32_i32$2;
                                  i64toi32_i32$2 = $2;
                                  HEAP32[($2 + 424 | 0) >> 2] = $777;
                                  HEAP32[($2 + 428 | 0) >> 2] = i64toi32_i32$5;
                                  i64toi32_i32$1 = $2;
                                  i64toi32_i32$5 = HEAP32[($2 + 24 | 0) >> 2] | 0;
                                  i64toi32_i32$2 = HEAP32[($2 + 28 | 0) >> 2] | 0;
                                  $780 = i64toi32_i32$5;
                                  i64toi32_i32$5 = $2;
                                  HEAP32[($2 + 400 | 0) >> 2] = $780;
                                  HEAP32[($2 + 404 | 0) >> 2] = i64toi32_i32$2;
                                  i64toi32_i32$1 = $2;
                                  i64toi32_i32$2 = HEAPU8[($2 + 31 | 0) >> 0] | 0 | ((HEAPU8[($2 + 32 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 33 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 34 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                  i64toi32_i32$5 = HEAPU8[($2 + 35 | 0) >> 0] | 0 | ((HEAPU8[($2 + 36 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 37 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 38 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                  $783 = i64toi32_i32$2;
                                  i64toi32_i32$2 = $2;
                                  $336 = $783;
                                  HEAP8[($2 + 407 | 0) >> 0] = $336;
                                  HEAP8[($2 + 408 | 0) >> 0] = $336 >>> 8 | 0;
                                  HEAP8[($2 + 409 | 0) >> 0] = $336 >>> 16 | 0;
                                  HEAP8[($2 + 410 | 0) >> 0] = $336 >>> 24 | 0;
                                  HEAP8[($2 + 411 | 0) >> 0] = i64toi32_i32$5;
                                  HEAP8[($2 + 412 | 0) >> 0] = i64toi32_i32$5 >>> 8 | 0;
                                  HEAP8[($2 + 413 | 0) >> 0] = i64toi32_i32$5 >>> 16 | 0;
                                  HEAP8[($2 + 414 | 0) >> 0] = i64toi32_i32$5 >>> 24 | 0;
                                  i64toi32_i32$1 = $2 + 488 | 0;
                                  i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                  $34 = i64toi32_i32$5;
                                  $34$hi = i64toi32_i32$2;
                                  $1 = HEAP32[($2 + 496 | 0) >> 2] | 0;
                                  i64toi32_i32$1 = $2 + 453 | 0;
                                  i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
                                  i64toi32_i32$5 = 0;
                                  $28 = i64toi32_i32$2;
                                  $28$hi = i64toi32_i32$5;
                                  i64toi32_i32$1 = $2 + 455 | 0;
                                  i64toi32_i32$5 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
                                  i64toi32_i32$2 = 0;
                                  $31 = i64toi32_i32$5;
                                  $31$hi = i64toi32_i32$2;
                                  $8 = HEAPU8[($2 + 472 | 0) >> 0] | 0;
                                  i64toi32_i32$1 = $2;
                                  i64toi32_i32$2 = HEAP32[($2 + 464 | 0) >> 2] | 0;
                                  i64toi32_i32$5 = HEAP32[($2 + 468 | 0) >> 2] | 0;
                                  $25 = i64toi32_i32$2;
                                  $25$hi = i64toi32_i32$5;
                                  i64toi32_i32$1 = $2;
                                  i64toi32_i32$5 = HEAP32[($2 + 456 | 0) >> 2] | 0;
                                  i64toi32_i32$2 = HEAP32[($2 + 460 | 0) >> 2] | 0;
                                  $22 = i64toi32_i32$5;
                                  $22$hi = i64toi32_i32$2;
                                  $18 = HEAPU8[($2 + 448 | 0) >> 0] | 0;
                                  i64toi32_i32$1 = $2;
                                  i64toi32_i32$2 = HEAPU8[($2 + 449 | 0) >> 0] | 0 | ((HEAPU8[($2 + 450 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 451 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 452 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                  i64toi32_i32$5 = 0;
                                  $30 = i64toi32_i32$2;
                                  $30$hi = i64toi32_i32$5;
                                  HEAP32[(($2 + 312 | 0) + 8 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
                                  i64toi32_i32$1 = $2;
                                  i64toi32_i32$5 = HEAP32[($2 + 424 | 0) >> 2] | 0;
                                  i64toi32_i32$2 = HEAP32[($2 + 428 | 0) >> 2] | 0;
                                  $813 = i64toi32_i32$5;
                                  i64toi32_i32$5 = $2;
                                  HEAP32[($2 + 312 | 0) >> 2] = $813;
                                  HEAP32[($2 + 316 | 0) >> 2] = i64toi32_i32$2;
                                  i64toi32_i32$2 = $30$hi;
                                  $814 = $30;
                                  $814$hi = i64toi32_i32$2;
                                  i64toi32_i32$2 = $28$hi;
                                  $815 = $28;
                                  $815$hi = i64toi32_i32$2;
                                  i64toi32_i32$2 = $31$hi;
                                  i64toi32_i32$1 = $31;
                                  i64toi32_i32$5 = 0;
                                  i64toi32_i32$4 = 16;
                                  i64toi32_i32$3 = i64toi32_i32$4 & 31 | 0;
                                  if (32 >>> 0 <= (i64toi32_i32$4 & 63 | 0) >>> 0) {
                                   i64toi32_i32$5 = i64toi32_i32$1 << i64toi32_i32$3 | 0;
                                   $434 = 0;
                                  } else {
                                   i64toi32_i32$5 = ((1 << i64toi32_i32$3 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$3 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$3 | 0) | 0;
                                   $434 = i64toi32_i32$1 << i64toi32_i32$3 | 0;
                                  }
                                  $817$hi = i64toi32_i32$5;
                                  i64toi32_i32$5 = $815$hi;
                                  i64toi32_i32$2 = $815;
                                  i64toi32_i32$1 = $817$hi;
                                  i64toi32_i32$4 = $434;
                                  i64toi32_i32$1 = i64toi32_i32$5 | i64toi32_i32$1 | 0;
                                  i64toi32_i32$5 = i64toi32_i32$2 | i64toi32_i32$4 | 0;
                                  i64toi32_i32$2 = 0;
                                  i64toi32_i32$4 = 32;
                                  i64toi32_i32$3 = i64toi32_i32$4 & 31 | 0;
                                  if (32 >>> 0 <= (i64toi32_i32$4 & 63 | 0) >>> 0) {
                                   i64toi32_i32$2 = i64toi32_i32$5 << i64toi32_i32$3 | 0;
                                   $435 = 0;
                                  } else {
                                   i64toi32_i32$2 = ((1 << i64toi32_i32$3 | 0) - 1 | 0) & (i64toi32_i32$5 >>> (32 - i64toi32_i32$3 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$3 | 0) | 0;
                                   $435 = i64toi32_i32$5 << i64toi32_i32$3 | 0;
                                  }
                                  $819$hi = i64toi32_i32$2;
                                  i64toi32_i32$2 = $814$hi;
                                  i64toi32_i32$1 = $814;
                                  i64toi32_i32$5 = $819$hi;
                                  i64toi32_i32$4 = $435;
                                  i64toi32_i32$5 = i64toi32_i32$2 | i64toi32_i32$5 | 0;
                                  $28 = i64toi32_i32$1 | i64toi32_i32$4 | 0;
                                  $28$hi = i64toi32_i32$5;
                                 }
                                 HEAP8[($2 + 464 | 0) >> 0] = $8;
                                 i64toi32_i32$5 = $25$hi;
                                 i64toi32_i32$1 = ($2 + 440 | 0) + 16 | 0;
                                 HEAP32[i64toi32_i32$1 >> 2] = $25;
                                 HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$5;
                                 i64toi32_i32$5 = $22$hi;
                                 i64toi32_i32$1 = ($2 + 440 | 0) + 8 | 0;
                                 HEAP32[i64toi32_i32$1 >> 2] = $22;
                                 HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$5;
                                 i64toi32_i32$2 = $2;
                                 i64toi32_i32$5 = HEAP32[($2 + 400 | 0) >> 2] | 0;
                                 i64toi32_i32$1 = HEAP32[($2 + 404 | 0) >> 2] | 0;
                                 $835 = i64toi32_i32$5;
                                 i64toi32_i32$5 = $2 + 465 | 0;
                                 $337 = $835;
                                 HEAP8[i64toi32_i32$5 >> 0] = $337;
                                 HEAP8[(i64toi32_i32$5 + 1 | 0) >> 0] = $337 >>> 8 | 0;
                                 HEAP8[(i64toi32_i32$5 + 2 | 0) >> 0] = $337 >>> 16 | 0;
                                 HEAP8[(i64toi32_i32$5 + 3 | 0) >> 0] = $337 >>> 24 | 0;
                                 HEAP8[(i64toi32_i32$5 + 4 | 0) >> 0] = i64toi32_i32$1;
                                 HEAP8[(i64toi32_i32$5 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
                                 HEAP8[(i64toi32_i32$5 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
                                 HEAP8[(i64toi32_i32$5 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
                                 i64toi32_i32$2 = $2;
                                 i64toi32_i32$1 = HEAPU8[($2 + 407 | 0) >> 0] | 0 | ((HEAPU8[($2 + 408 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 409 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 410 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                 i64toi32_i32$5 = HEAPU8[($2 + 411 | 0) >> 0] | 0 | ((HEAPU8[($2 + 412 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 413 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 414 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                 $839 = i64toi32_i32$1;
                                 i64toi32_i32$1 = $2 + 472 | 0;
                                 $338 = $839;
                                 HEAP8[i64toi32_i32$1 >> 0] = $338;
                                 HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $338 >>> 8 | 0;
                                 HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $338 >>> 16 | 0;
                                 HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $338 >>> 24 | 0;
                                 HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$5;
                                 HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$5 >>> 8 | 0;
                                 HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$5 >>> 16 | 0;
                                 HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$5 >>> 24 | 0;
                                 i64toi32_i32$5 = $34$hi;
                                 i64toi32_i32$1 = ($2 + 440 | 0) + 40 | 0;
                                 HEAP32[i64toi32_i32$1 >> 2] = $34;
                                 HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$5;
                                 i64toi32_i32$2 = $2;
                                 i64toi32_i32$5 = HEAP32[($2 + 312 | 0) >> 2] | 0;
                                 i64toi32_i32$1 = HEAP32[($2 + 316 | 0) >> 2] | 0;
                                 $847 = i64toi32_i32$5;
                                 i64toi32_i32$5 = $2 + 492 | 0;
                                 HEAP32[i64toi32_i32$5 >> 2] = $847;
                                 HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$1;
                                 HEAP32[(($2 + 440 | 0) + 60 | 0) >> 2] = HEAP32[(($2 + 312 | 0) + 8 | 0) >> 2] | 0;
                                 HEAP8[($2 + 440 | 0) >> 0] = $18;
                                 HEAP32[($2 + 488 | 0) >> 2] = $1;
                                 i64toi32_i32$1 = $28$hi;
                                 HEAP8[($2 + 441 | 0) >> 0] = $28;
                                 HEAP8[($2 + 442 | 0) >> 0] = $28 >>> 8 | 0;
                                 HEAP8[($2 + 443 | 0) >> 0] = $28 >>> 16 | 0;
                                 HEAP8[($2 + 444 | 0) >> 0] = $28 >>> 24 | 0;
                                 $861 = $2;
                                 i64toi32_i32$2 = $28;
                                 i64toi32_i32$5 = 0;
                                 i64toi32_i32$4 = 48;
                                 i64toi32_i32$3 = i64toi32_i32$4 & 31 | 0;
                                 if (32 >>> 0 <= (i64toi32_i32$4 & 63 | 0) >>> 0) {
                                  i64toi32_i32$5 = 0;
                                  $436 = i64toi32_i32$1 >>> i64toi32_i32$3 | 0;
                                 } else {
                                  i64toi32_i32$5 = i64toi32_i32$1 >>> i64toi32_i32$3 | 0;
                                  $436 = (((1 << i64toi32_i32$3 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$3 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$3 | 0) | 0;
                                 }
                                 HEAP8[($861 + 447 | 0) >> 0] = $436;
                                 $864 = $2;
                                 i64toi32_i32$5 = $28$hi;
                                 i64toi32_i32$1 = $28;
                                 i64toi32_i32$2 = 0;
                                 i64toi32_i32$4 = 32;
                                 i64toi32_i32$3 = i64toi32_i32$4 & 31 | 0;
                                 if (32 >>> 0 <= (i64toi32_i32$4 & 63 | 0) >>> 0) {
                                  i64toi32_i32$2 = 0;
                                  $437 = i64toi32_i32$5 >>> i64toi32_i32$3 | 0;
                                 } else {
                                  i64toi32_i32$2 = i64toi32_i32$5 >>> i64toi32_i32$3 | 0;
                                  $437 = (((1 << i64toi32_i32$3 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$3 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$3 | 0) | 0;
                                 }
                                 $438 = $864;
                                 $439 = $437;
                                 HEAP8[($438 + 445 | 0) >> 0] = $439;
                                 HEAP8[($438 + 446 | 0) >> 0] = $439 >>> 8 | 0;
                                 cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($10 | 0, $2 + 440 | 0 | 0, 1050535 | 0, 16 | 0);
                                 HEAP32[(($2 + 24 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 396 | 0) >> 2] | 0;
                                 i64toi32_i32$5 = ($2 + 328 | 0) + 60 | 0;
                                 i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                 i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                                 $880 = i64toi32_i32$2;
                                 i64toi32_i32$2 = $2;
                                 HEAP32[($2 + 24 | 0) >> 2] = $880;
                                 HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$1;
                                 i64toi32_i32$5 = $2;
                                 i64toi32_i32$1 = HEAP32[($2 + 336 | 0) >> 2] | 0;
                                 i64toi32_i32$2 = HEAP32[($2 + 340 | 0) >> 2] | 0;
                                 $28 = i64toi32_i32$1;
                                 $28$hi = i64toi32_i32$2;
                                 i64toi32_i32$5 = i64toi32_i32$1;
                                 i64toi32_i32$1 = -1;
                                 i64toi32_i32$4 = -256;
                                 i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
                                 $29 = i64toi32_i32$5 & i64toi32_i32$4 | 0;
                                 $29$hi = i64toi32_i32$1;
                                 i64toi32_i32$2 = ($2 + 328 | 0) + 40 | 0;
                                 i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                 i64toi32_i32$5 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                 $32 = i64toi32_i32$1;
                                 $32$hi = i64toi32_i32$5;
                                 i64toi32_i32$2 = $2 + 376 | 0;
                                 i64toi32_i32$5 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                 i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                 $33 = i64toi32_i32$5;
                                 $33$hi = i64toi32_i32$1;
                                 $8 = HEAP32[($2 + 384 | 0) >> 2] | 0;
                                 break label$39;
                                }
                                label$72 : {
                                 label$73 : {
                                  if ($5) {
                                   break label$73
                                  }
                                  i64toi32_i32$1 = $25$hi;
                                  i64toi32_i32$2 = $25;
                                  i64toi32_i32$5 = 0;
                                  i64toi32_i32$4 = 1;
                                  i64toi32_i32$3 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
                                  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
                                  if (i64toi32_i32$3 >>> 0 < i64toi32_i32$4 >>> 0) {
                                   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
                                  }
                                  $25 = i64toi32_i32$3;
                                  $25$hi = i64toi32_i32$0;
                                  i64toi32_i32$0 = $22$hi;
                                  i64toi32_i32$0 = $25$hi;
                                  i64toi32_i32$1 = i64toi32_i32$3;
                                  i64toi32_i32$2 = $22$hi;
                                  i64toi32_i32$4 = $22;
                                  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$1 >>> 0 <= i64toi32_i32$4 >>> 0 | 0) | 0) {
                                   break label$73
                                  }
                                  $1 = 0;
                                  i64toi32_i32$1 = 0;
                                  $25 = 0;
                                  $25$hi = i64toi32_i32$1;
                                  $18 = 3;
                                  break label$72;
                                 }
                                 cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__Mint___deserialize__hd75757d6517eec3f($2 + 440 | 0 | 0, $1 | 0);
                                 if ((HEAP32[($2 + 440 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                                  break label$19
                                 }
                                 $5 = ($2 + 424 | 0) + 8 | 0;
                                 HEAP32[$5 >> 2] = HEAP32[($2 + 508 | 0) >> 2] | 0;
                                 i64toi32_i32$4 = $2;
                                 i64toi32_i32$1 = HEAPU8[($2 + 473 | 0) >> 0] | 0 | ((HEAPU8[($2 + 474 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 475 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 476 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                 i64toi32_i32$0 = HEAPU8[($2 + 477 | 0) >> 0] | 0 | ((HEAPU8[($2 + 478 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 479 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 480 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                 $916 = i64toi32_i32$1;
                                 i64toi32_i32$1 = $2;
                                 HEAP32[($2 + 24 | 0) >> 2] = $916;
                                 HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$0;
                                 i64toi32_i32$4 = $2 + 480 | 0;
                                 i64toi32_i32$0 = HEAPU8[i64toi32_i32$4 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$4 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$4 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$4 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                 i64toi32_i32$1 = HEAPU8[(i64toi32_i32$4 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$4 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$4 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$4 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                 $920 = i64toi32_i32$0;
                                 i64toi32_i32$0 = $2;
                                 $339 = $920;
                                 HEAP8[($2 + 31 | 0) >> 0] = $339;
                                 HEAP8[($2 + 32 | 0) >> 0] = $339 >>> 8 | 0;
                                 HEAP8[($2 + 33 | 0) >> 0] = $339 >>> 16 | 0;
                                 HEAP8[($2 + 34 | 0) >> 0] = $339 >>> 24 | 0;
                                 HEAP8[($2 + 35 | 0) >> 0] = i64toi32_i32$1;
                                 HEAP8[($2 + 36 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
                                 HEAP8[($2 + 37 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
                                 HEAP8[($2 + 38 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
                                 i64toi32_i32$4 = $2 + 500 | 0;
                                 i64toi32_i32$1 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                 i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                 $924 = i64toi32_i32$1;
                                 i64toi32_i32$1 = $2;
                                 HEAP32[($2 + 424 | 0) >> 2] = $924;
                                 HEAP32[($2 + 428 | 0) >> 2] = i64toi32_i32$0;
                                 i64toi32_i32$4 = $2;
                                 i64toi32_i32$0 = HEAP32[($2 + 24 | 0) >> 2] | 0;
                                 i64toi32_i32$1 = HEAP32[($2 + 28 | 0) >> 2] | 0;
                                 $927 = i64toi32_i32$0;
                                 i64toi32_i32$0 = $2;
                                 HEAP32[($2 + 400 | 0) >> 2] = $927;
                                 HEAP32[($2 + 404 | 0) >> 2] = i64toi32_i32$1;
                                 i64toi32_i32$4 = $2;
                                 i64toi32_i32$1 = HEAPU8[($2 + 31 | 0) >> 0] | 0 | ((HEAPU8[($2 + 32 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 33 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 34 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                 i64toi32_i32$0 = HEAPU8[($2 + 35 | 0) >> 0] | 0 | ((HEAPU8[($2 + 36 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 37 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 38 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                 $930 = i64toi32_i32$1;
                                 i64toi32_i32$1 = $2;
                                 $340 = $930;
                                 HEAP8[($2 + 407 | 0) >> 0] = $340;
                                 HEAP8[($2 + 408 | 0) >> 0] = $340 >>> 8 | 0;
                                 HEAP8[($2 + 409 | 0) >> 0] = $340 >>> 16 | 0;
                                 HEAP8[($2 + 410 | 0) >> 0] = $340 >>> 24 | 0;
                                 HEAP8[($2 + 411 | 0) >> 0] = i64toi32_i32$0;
                                 HEAP8[($2 + 412 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                                 HEAP8[($2 + 413 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
                                 HEAP8[($2 + 414 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
                                 $8 = HEAPU8[($2 + 472 | 0) >> 0] | 0;
                                 i64toi32_i32$4 = $2 + 464 | 0;
                                 i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                 i64toi32_i32$1 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                 $25 = i64toi32_i32$0;
                                 $25$hi = i64toi32_i32$1;
                                 i64toi32_i32$4 = $2 + 456 | 0;
                                 i64toi32_i32$1 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                 i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                 $22 = i64toi32_i32$1;
                                 $22$hi = i64toi32_i32$0;
                                 i64toi32_i32$4 = $2 + 488 | 0;
                                 i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                 i64toi32_i32$1 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                 $34 = i64toi32_i32$0;
                                 $34$hi = i64toi32_i32$1;
                                 $1 = HEAP32[($2 + 496 | 0) >> 2] | 0;
                                 i64toi32_i32$4 = $2 + 453 | 0;
                                 i64toi32_i32$1 = HEAPU8[i64toi32_i32$4 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$4 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
                                 i64toi32_i32$0 = 0;
                                 $28 = i64toi32_i32$1;
                                 $28$hi = i64toi32_i32$0;
                                 i64toi32_i32$4 = $2 + 455 | 0;
                                 i64toi32_i32$0 = HEAPU8[i64toi32_i32$4 >> 0] | 0;
                                 i64toi32_i32$1 = 0;
                                 $31 = i64toi32_i32$0;
                                 $31$hi = i64toi32_i32$1;
                                 $18 = HEAPU8[($2 + 448 | 0) >> 0] | 0;
                                 i64toi32_i32$4 = $2;
                                 i64toi32_i32$1 = HEAPU8[($2 + 449 | 0) >> 0] | 0 | ((HEAPU8[($2 + 450 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 451 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 452 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                 i64toi32_i32$0 = 0;
                                 $30 = i64toi32_i32$1;
                                 $30$hi = i64toi32_i32$0;
                                 HEAP32[(($2 + 312 | 0) + 8 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
                                 i64toi32_i32$4 = $2;
                                 i64toi32_i32$0 = HEAP32[($2 + 424 | 0) >> 2] | 0;
                                 i64toi32_i32$1 = HEAP32[($2 + 428 | 0) >> 2] | 0;
                                 $963 = i64toi32_i32$0;
                                 i64toi32_i32$0 = $2;
                                 HEAP32[($2 + 312 | 0) >> 2] = $963;
                                 HEAP32[($2 + 316 | 0) >> 2] = i64toi32_i32$1;
                                 i64toi32_i32$1 = $30$hi;
                                 $964 = $30;
                                 $964$hi = i64toi32_i32$1;
                                 i64toi32_i32$1 = $28$hi;
                                 $965 = $28;
                                 $965$hi = i64toi32_i32$1;
                                 i64toi32_i32$1 = $31$hi;
                                 i64toi32_i32$4 = $31;
                                 i64toi32_i32$0 = 0;
                                 i64toi32_i32$2 = 16;
                                 i64toi32_i32$5 = i64toi32_i32$2 & 31 | 0;
                                 if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                                  i64toi32_i32$0 = i64toi32_i32$4 << i64toi32_i32$5 | 0;
                                  $441 = 0;
                                 } else {
                                  i64toi32_i32$0 = ((1 << i64toi32_i32$5 | 0) - 1 | 0) & (i64toi32_i32$4 >>> (32 - i64toi32_i32$5 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$5 | 0) | 0;
                                  $441 = i64toi32_i32$4 << i64toi32_i32$5 | 0;
                                 }
                                 $967$hi = i64toi32_i32$0;
                                 i64toi32_i32$0 = $965$hi;
                                 i64toi32_i32$1 = $965;
                                 i64toi32_i32$4 = $967$hi;
                                 i64toi32_i32$2 = $441;
                                 i64toi32_i32$4 = i64toi32_i32$0 | i64toi32_i32$4 | 0;
                                 i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
                                 i64toi32_i32$1 = 0;
                                 i64toi32_i32$2 = 32;
                                 i64toi32_i32$5 = i64toi32_i32$2 & 31 | 0;
                                 if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                                  i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$5 | 0;
                                  $442 = 0;
                                 } else {
                                  i64toi32_i32$1 = ((1 << i64toi32_i32$5 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$5 | 0) | 0) | 0 | (i64toi32_i32$4 << i64toi32_i32$5 | 0) | 0;
                                  $442 = i64toi32_i32$0 << i64toi32_i32$5 | 0;
                                 }
                                 $969$hi = i64toi32_i32$1;
                                 i64toi32_i32$1 = $964$hi;
                                 i64toi32_i32$4 = $964;
                                 i64toi32_i32$0 = $969$hi;
                                 i64toi32_i32$2 = $442;
                                 i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
                                 $28 = i64toi32_i32$4 | i64toi32_i32$2 | 0;
                                 $28$hi = i64toi32_i32$0;
                                }
                                HEAP8[(($2 + 440 | 0) + 24 | 0) >> 0] = $8;
                                i64toi32_i32$0 = $25$hi;
                                i64toi32_i32$4 = ($2 + 440 | 0) + 16 | 0;
                                HEAP32[i64toi32_i32$4 >> 2] = $25;
                                HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$0;
                                i64toi32_i32$0 = $22$hi;
                                i64toi32_i32$4 = ($2 + 440 | 0) + 8 | 0;
                                HEAP32[i64toi32_i32$4 >> 2] = $22;
                                HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$0;
                                i64toi32_i32$1 = $2;
                                i64toi32_i32$0 = HEAP32[($2 + 400 | 0) >> 2] | 0;
                                i64toi32_i32$4 = HEAP32[($2 + 404 | 0) >> 2] | 0;
                                $986 = i64toi32_i32$0;
                                i64toi32_i32$0 = $2 + 465 | 0;
                                $342 = $986;
                                HEAP8[i64toi32_i32$0 >> 0] = $342;
                                HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $342 >>> 8 | 0;
                                HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $342 >>> 16 | 0;
                                HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $342 >>> 24 | 0;
                                HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$4;
                                HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$4 >>> 8 | 0;
                                HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$4 >>> 16 | 0;
                                HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$4 >>> 24 | 0;
                                i64toi32_i32$1 = $2;
                                i64toi32_i32$4 = HEAPU8[($2 + 407 | 0) >> 0] | 0 | ((HEAPU8[($2 + 408 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 409 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 410 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                i64toi32_i32$0 = HEAPU8[($2 + 411 | 0) >> 0] | 0 | ((HEAPU8[($2 + 412 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 413 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 414 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                $991 = i64toi32_i32$4;
                                i64toi32_i32$4 = ($2 + 440 | 0) + 32 | 0;
                                $343 = $991;
                                HEAP8[i64toi32_i32$4 >> 0] = $343;
                                HEAP8[(i64toi32_i32$4 + 1 | 0) >> 0] = $343 >>> 8 | 0;
                                HEAP8[(i64toi32_i32$4 + 2 | 0) >> 0] = $343 >>> 16 | 0;
                                HEAP8[(i64toi32_i32$4 + 3 | 0) >> 0] = $343 >>> 24 | 0;
                                HEAP8[(i64toi32_i32$4 + 4 | 0) >> 0] = i64toi32_i32$0;
                                HEAP8[(i64toi32_i32$4 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                                HEAP8[(i64toi32_i32$4 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
                                HEAP8[(i64toi32_i32$4 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
                                i64toi32_i32$0 = $34$hi;
                                i64toi32_i32$4 = ($2 + 440 | 0) + 40 | 0;
                                HEAP32[i64toi32_i32$4 >> 2] = $34;
                                HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$0;
                                i64toi32_i32$1 = $2;
                                i64toi32_i32$0 = HEAP32[($2 + 312 | 0) >> 2] | 0;
                                i64toi32_i32$4 = HEAP32[($2 + 316 | 0) >> 2] | 0;
                                $999 = i64toi32_i32$0;
                                i64toi32_i32$0 = $2 + 492 | 0;
                                HEAP32[i64toi32_i32$0 >> 2] = $999;
                                HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$4;
                                HEAP32[(($2 + 440 | 0) + 60 | 0) >> 2] = HEAP32[(($2 + 312 | 0) + 8 | 0) >> 2] | 0;
                                HEAP8[($2 + 440 | 0) >> 0] = $18;
                                HEAP32[($2 + 488 | 0) >> 2] = $1;
                                i64toi32_i32$4 = $28$hi;
                                HEAP8[($2 + 441 | 0) >> 0] = $28;
                                HEAP8[($2 + 442 | 0) >> 0] = $28 >>> 8 | 0;
                                HEAP8[($2 + 443 | 0) >> 0] = $28 >>> 16 | 0;
                                HEAP8[($2 + 444 | 0) >> 0] = $28 >>> 24 | 0;
                                $1013 = $2;
                                i64toi32_i32$1 = $28;
                                i64toi32_i32$0 = 0;
                                i64toi32_i32$2 = 48;
                                i64toi32_i32$5 = i64toi32_i32$2 & 31 | 0;
                                if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                                 i64toi32_i32$0 = 0;
                                 $443 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
                                } else {
                                 i64toi32_i32$0 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
                                 $443 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$5 | 0) | 0;
                                }
                                HEAP8[($1013 + 447 | 0) >> 0] = $443;
                                $1016 = $2;
                                i64toi32_i32$0 = $28$hi;
                                i64toi32_i32$4 = $28;
                                i64toi32_i32$1 = 0;
                                i64toi32_i32$2 = 32;
                                i64toi32_i32$5 = i64toi32_i32$2 & 31 | 0;
                                if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                                 i64toi32_i32$1 = 0;
                                 $445 = i64toi32_i32$0 >>> i64toi32_i32$5 | 0;
                                } else {
                                 i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$5 | 0;
                                 $445 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$5 | 0) | 0;
                                }
                                $446 = $1016;
                                $447 = $445;
                                HEAP8[($446 + 445 | 0) >> 0] = $447;
                                HEAP8[($446 + 446 | 0) >> 0] = $447 >>> 8 | 0;
                                cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($10 | 0, $2 + 440 | 0 | 0, 1050531 | 0, 4 | 0);
                                HEAP32[(($2 + 24 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 396 | 0) >> 2] | 0;
                                i64toi32_i32$0 = ($2 + 328 | 0) + 60 | 0;
                                i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                $1032 = i64toi32_i32$1;
                                i64toi32_i32$1 = $2;
                                HEAP32[($2 + 24 | 0) >> 2] = $1032;
                                HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$4;
                                i64toi32_i32$0 = $2;
                                i64toi32_i32$4 = HEAP32[($2 + 336 | 0) >> 2] | 0;
                                i64toi32_i32$1 = HEAP32[($2 + 340 | 0) >> 2] | 0;
                                $28 = i64toi32_i32$4;
                                $28$hi = i64toi32_i32$1;
                                i64toi32_i32$0 = i64toi32_i32$4;
                                i64toi32_i32$4 = -1;
                                i64toi32_i32$2 = -256;
                                i64toi32_i32$4 = i64toi32_i32$1 & i64toi32_i32$4 | 0;
                                $29 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
                                $29$hi = i64toi32_i32$4;
                                i64toi32_i32$1 = ($2 + 328 | 0) + 16 | 0;
                                i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                $31 = i64toi32_i32$4;
                                $31$hi = i64toi32_i32$0;
                                i64toi32_i32$1 = ($2 + 328 | 0) + 24 | 0;
                                i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                $30 = i64toi32_i32$0;
                                $30$hi = i64toi32_i32$4;
                                i64toi32_i32$1 = ($2 + 328 | 0) + 32 | 0;
                                i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                $25 = i64toi32_i32$4;
                                $25$hi = i64toi32_i32$0;
                                i64toi32_i32$1 = ($2 + 328 | 0) + 40 | 0;
                                i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                $32 = i64toi32_i32$0;
                                $32$hi = i64toi32_i32$4;
                                i64toi32_i32$1 = $2 + 376 | 0;
                                i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                $33 = i64toi32_i32$4;
                                $33$hi = i64toi32_i32$0;
                                $8 = HEAP32[($2 + 384 | 0) >> 2] | 0;
                                break label$3;
                               }
                               label$74 : {
                                label$75 : {
                                 if ($5) {
                                  break label$75
                                 }
                                 i64toi32_i32$0 = $25$hi;
                                 i64toi32_i32$1 = $25;
                                 i64toi32_i32$4 = 0;
                                 i64toi32_i32$2 = 1;
                                 i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
                                 i64toi32_i32$3 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
                                 if (i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0) {
                                  i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
                                 }
                                 $25 = i64toi32_i32$5;
                                 $25$hi = i64toi32_i32$3;
                                 i64toi32_i32$3 = $22$hi;
                                 i64toi32_i32$3 = $25$hi;
                                 i64toi32_i32$0 = i64toi32_i32$5;
                                 i64toi32_i32$1 = $22$hi;
                                 i64toi32_i32$2 = $22;
                                 if (i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$0 >>> 0 <= i64toi32_i32$2 >>> 0 | 0) | 0) {
                                  break label$75
                                 }
                                 $1 = 0;
                                 i64toi32_i32$0 = 0;
                                 $28 = 0;
                                 $28$hi = i64toi32_i32$0;
                                 i64toi32_i32$0 = 0;
                                 $35 = 3;
                                 $35$hi = i64toi32_i32$0;
                                 break label$74;
                                }
                                $cardano_serialization_lib__utils__BigNum_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h29637bb571dceb02($2 + 440 | 0 | 0, $1 | 0);
                                i64toi32_i32$2 = $2;
                                i64toi32_i32$0 = HEAP32[($2 + 448 | 0) >> 2] | 0;
                                i64toi32_i32$3 = HEAP32[($2 + 452 | 0) >> 2] | 0;
                                $35 = i64toi32_i32$0;
                                $35$hi = i64toi32_i32$3;
                                i64toi32_i32$2 = $2;
                                i64toi32_i32$3 = HEAP32[($2 + 440 | 0) >> 2] | 0;
                                i64toi32_i32$0 = HEAP32[($2 + 444 | 0) >> 2] | 0;
                                i64toi32_i32$2 = i64toi32_i32$3;
                                i64toi32_i32$3 = 0;
                                i64toi32_i32$1 = 1;
                                if ((i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$3 | 0) | 0) {
                                 break label$18
                                }
                                $8 = ($2 + 424 | 0) + 8 | 0;
                                HEAP32[$8 >> 2] = HEAP32[($2 + 508 | 0) >> 2] | 0;
                                i64toi32_i32$1 = $2;
                                i64toi32_i32$2 = HEAPU8[($2 + 473 | 0) >> 0] | 0 | ((HEAPU8[($2 + 474 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 475 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 476 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                i64toi32_i32$0 = HEAPU8[($2 + 477 | 0) >> 0] | 0 | ((HEAPU8[($2 + 478 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 479 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 480 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                $1082 = i64toi32_i32$2;
                                i64toi32_i32$2 = $2;
                                HEAP32[($2 + 24 | 0) >> 2] = $1082;
                                HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$0;
                                i64toi32_i32$1 = $2 + 480 | 0;
                                i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                $1086 = i64toi32_i32$0;
                                i64toi32_i32$0 = $2;
                                $344 = $1086;
                                HEAP8[($2 + 31 | 0) >> 0] = $344;
                                HEAP8[($2 + 32 | 0) >> 0] = $344 >>> 8 | 0;
                                HEAP8[($2 + 33 | 0) >> 0] = $344 >>> 16 | 0;
                                HEAP8[($2 + 34 | 0) >> 0] = $344 >>> 24 | 0;
                                HEAP8[($2 + 35 | 0) >> 0] = i64toi32_i32$2;
                                HEAP8[($2 + 36 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
                                HEAP8[($2 + 37 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
                                HEAP8[($2 + 38 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
                                i64toi32_i32$1 = $2;
                                i64toi32_i32$2 = HEAP32[($2 + 500 | 0) >> 2] | 0;
                                i64toi32_i32$0 = HEAP32[($2 + 504 | 0) >> 2] | 0;
                                $1089 = i64toi32_i32$2;
                                i64toi32_i32$2 = $2;
                                HEAP32[($2 + 424 | 0) >> 2] = $1089;
                                HEAP32[($2 + 428 | 0) >> 2] = i64toi32_i32$0;
                                i64toi32_i32$1 = $2;
                                i64toi32_i32$0 = HEAP32[($2 + 24 | 0) >> 2] | 0;
                                i64toi32_i32$2 = HEAP32[($2 + 28 | 0) >> 2] | 0;
                                $1092 = i64toi32_i32$0;
                                i64toi32_i32$0 = $2;
                                HEAP32[($2 + 400 | 0) >> 2] = $1092;
                                HEAP32[($2 + 404 | 0) >> 2] = i64toi32_i32$2;
                                i64toi32_i32$1 = $2;
                                i64toi32_i32$2 = HEAPU8[($2 + 31 | 0) >> 0] | 0 | ((HEAPU8[($2 + 32 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 33 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 34 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                i64toi32_i32$0 = HEAPU8[($2 + 35 | 0) >> 0] | 0 | ((HEAPU8[($2 + 36 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 37 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 38 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                $1095 = i64toi32_i32$2;
                                i64toi32_i32$2 = $2;
                                $345 = $1095;
                                HEAP8[($2 + 407 | 0) >> 0] = $345;
                                HEAP8[($2 + 408 | 0) >> 0] = $345 >>> 8 | 0;
                                HEAP8[($2 + 409 | 0) >> 0] = $345 >>> 16 | 0;
                                HEAP8[($2 + 410 | 0) >> 0] = $345 >>> 24 | 0;
                                HEAP8[($2 + 411 | 0) >> 0] = i64toi32_i32$0;
                                HEAP8[($2 + 412 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                                HEAP8[($2 + 413 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
                                HEAP8[($2 + 414 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
                                $18 = HEAPU8[($2 + 472 | 0) >> 0] | 0;
                                i64toi32_i32$1 = $2 + 464 | 0;
                                i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                $28 = i64toi32_i32$0;
                                $28$hi = i64toi32_i32$2;
                                i64toi32_i32$1 = $2 + 456 | 0;
                                i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                $22 = i64toi32_i32$2;
                                $22$hi = i64toi32_i32$0;
                                i64toi32_i32$1 = $2 + 488 | 0;
                                i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                $25 = i64toi32_i32$0;
                                $25$hi = i64toi32_i32$2;
                                $1 = HEAP32[($2 + 496 | 0) >> 2] | 0;
                                HEAP32[(($2 + 312 | 0) + 8 | 0) >> 2] = HEAP32[$8 >> 2] | 0;
                                i64toi32_i32$1 = $2;
                                i64toi32_i32$2 = HEAP32[($2 + 424 | 0) >> 2] | 0;
                                i64toi32_i32$0 = HEAP32[($2 + 428 | 0) >> 2] | 0;
                                $1118 = i64toi32_i32$2;
                                i64toi32_i32$2 = $2;
                                HEAP32[($2 + 312 | 0) >> 2] = $1118;
                                HEAP32[($2 + 316 | 0) >> 2] = i64toi32_i32$0;
                               }
                               HEAP8[(($2 + 440 | 0) + 24 | 0) >> 0] = $18;
                               i64toi32_i32$0 = $28$hi;
                               i64toi32_i32$2 = ($2 + 440 | 0) + 16 | 0;
                               HEAP32[i64toi32_i32$2 >> 2] = $28;
                               HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
                               i64toi32_i32$0 = $22$hi;
                               i64toi32_i32$2 = ($2 + 440 | 0) + 8 | 0;
                               HEAP32[i64toi32_i32$2 >> 2] = $22;
                               HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
                               i64toi32_i32$1 = $2;
                               i64toi32_i32$0 = HEAP32[($2 + 400 | 0) >> 2] | 0;
                               i64toi32_i32$2 = HEAP32[($2 + 404 | 0) >> 2] | 0;
                               $1134 = i64toi32_i32$0;
                               i64toi32_i32$0 = $2 + 465 | 0;
                               $347 = $1134;
                               HEAP8[i64toi32_i32$0 >> 0] = $347;
                               HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $347 >>> 8 | 0;
                               HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $347 >>> 16 | 0;
                               HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $347 >>> 24 | 0;
                               HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$2;
                               HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
                               HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
                               HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
                               i64toi32_i32$1 = $2;
                               i64toi32_i32$2 = HEAPU8[($2 + 407 | 0) >> 0] | 0 | ((HEAPU8[($2 + 408 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 409 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 410 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                               i64toi32_i32$0 = HEAPU8[($2 + 411 | 0) >> 0] | 0 | ((HEAPU8[($2 + 412 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 413 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 414 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                               $1139 = i64toi32_i32$2;
                               i64toi32_i32$2 = ($2 + 440 | 0) + 32 | 0;
                               $348 = $1139;
                               HEAP8[i64toi32_i32$2 >> 0] = $348;
                               HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $348 >>> 8 | 0;
                               HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $348 >>> 16 | 0;
                               HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $348 >>> 24 | 0;
                               HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$0;
                               HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                               HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
                               HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
                               i64toi32_i32$0 = $25$hi;
                               i64toi32_i32$2 = ($2 + 440 | 0) + 40 | 0;
                               HEAP32[i64toi32_i32$2 >> 2] = $25;
                               HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
                               i64toi32_i32$1 = $2;
                               i64toi32_i32$0 = HEAP32[($2 + 312 | 0) >> 2] | 0;
                               i64toi32_i32$2 = HEAP32[($2 + 316 | 0) >> 2] | 0;
                               $1147 = i64toi32_i32$0;
                               i64toi32_i32$0 = $2 + 492 | 0;
                               HEAP32[i64toi32_i32$0 >> 2] = $1147;
                               HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
                               HEAP32[($2 + 500 | 0) >> 2] = HEAP32[(($2 + 312 | 0) + 8 | 0) >> 2] | 0;
                               i64toi32_i32$2 = $35$hi;
                               i64toi32_i32$0 = $2;
                               HEAP32[($2 + 440 | 0) >> 2] = $35;
                               HEAP32[($2 + 444 | 0) >> 2] = i64toi32_i32$2;
                               HEAP32[($2 + 488 | 0) >> 2] = $1;
                               cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($10 | 0, $2 + 440 | 0 | 0, 1050508 | 0, 23 | 0);
                               HEAP32[(($2 + 24 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 396 | 0) >> 2] | 0;
                               i64toi32_i32$1 = $2;
                               i64toi32_i32$2 = HEAP32[($2 + 388 | 0) >> 2] | 0;
                               i64toi32_i32$0 = HEAP32[($2 + 392 | 0) >> 2] | 0;
                               $1169 = i64toi32_i32$2;
                               i64toi32_i32$2 = $2;
                               HEAP32[($2 + 24 | 0) >> 2] = $1169;
                               HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$0;
                               i64toi32_i32$1 = $2;
                               i64toi32_i32$0 = HEAP32[($2 + 336 | 0) >> 2] | 0;
                               i64toi32_i32$2 = HEAP32[($2 + 340 | 0) >> 2] | 0;
                               $28 = i64toi32_i32$0;
                               $28$hi = i64toi32_i32$2;
                               i64toi32_i32$1 = i64toi32_i32$0;
                               i64toi32_i32$0 = -1;
                               i64toi32_i32$3 = -256;
                               i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
                               $29 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
                               $29$hi = i64toi32_i32$0;
                               i64toi32_i32$2 = ($2 + 328 | 0) + 16 | 0;
                               i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                               i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                               $31 = i64toi32_i32$0;
                               $31$hi = i64toi32_i32$1;
                               i64toi32_i32$2 = ($2 + 328 | 0) + 24 | 0;
                               i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                               i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                               $30 = i64toi32_i32$1;
                               $30$hi = i64toi32_i32$0;
                               i64toi32_i32$2 = ($2 + 328 | 0) + 32 | 0;
                               i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                               i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                               $25 = i64toi32_i32$0;
                               $25$hi = i64toi32_i32$1;
                               i64toi32_i32$2 = ($2 + 328 | 0) + 40 | 0;
                               i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                               i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                               $32 = i64toi32_i32$1;
                               $32$hi = i64toi32_i32$0;
                               i64toi32_i32$2 = $2 + 376 | 0;
                               i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                               i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                               $33 = i64toi32_i32$0;
                               $33$hi = i64toi32_i32$1;
                               $8 = HEAP32[($2 + 384 | 0) >> 2] | 0;
                               break label$3;
                              }
                              label$76 : {
                               label$77 : {
                                if ($5) {
                                 break label$77
                                }
                                i64toi32_i32$1 = $25$hi;
                                i64toi32_i32$2 = $25;
                                i64toi32_i32$0 = 0;
                                i64toi32_i32$3 = 1;
                                i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
                                i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
                                if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
                                 i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
                                }
                                $25 = i64toi32_i32$4;
                                $25$hi = i64toi32_i32$5;
                                i64toi32_i32$5 = $22$hi;
                                i64toi32_i32$5 = $25$hi;
                                i64toi32_i32$1 = i64toi32_i32$4;
                                i64toi32_i32$2 = $22$hi;
                                i64toi32_i32$3 = $22;
                                if (i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$1 >>> 0 <= i64toi32_i32$3 >>> 0 | 0) | 0) {
                                 break label$77
                                }
                                $1 = 0;
                                i64toi32_i32$1 = 0;
                                $25 = 0;
                                $25$hi = i64toi32_i32$1;
                                $18 = 3;
                                break label$76;
                               }
                               $cardano_serialization_lib__crypto__AuxiliaryDataHash_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h7e449458f02a8fab($2 + 440 | 0 | 0, $1 | 0);
                               if ((HEAPU8[($2 + 440 | 0) >> 0] | 0 | 0) != (1 | 0)) {
                                break label$17
                               }
                               $5 = ($2 + 424 | 0) + 8 | 0;
                               HEAP32[$5 >> 2] = HEAP32[($2 + 508 | 0) >> 2] | 0;
                               i64toi32_i32$3 = $2 + 480 | 0;
                               i64toi32_i32$1 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                               i64toi32_i32$5 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                               $1218 = i64toi32_i32$1;
                               i64toi32_i32$1 = $2;
                               $349 = $1218;
                               HEAP8[($2 + 31 | 0) >> 0] = $349;
                               HEAP8[($2 + 32 | 0) >> 0] = $349 >>> 8 | 0;
                               HEAP8[($2 + 33 | 0) >> 0] = $349 >>> 16 | 0;
                               HEAP8[($2 + 34 | 0) >> 0] = $349 >>> 24 | 0;
                               HEAP8[($2 + 35 | 0) >> 0] = i64toi32_i32$5;
                               HEAP8[($2 + 36 | 0) >> 0] = i64toi32_i32$5 >>> 8 | 0;
                               HEAP8[($2 + 37 | 0) >> 0] = i64toi32_i32$5 >>> 16 | 0;
                               HEAP8[($2 + 38 | 0) >> 0] = i64toi32_i32$5 >>> 24 | 0;
                               i64toi32_i32$3 = $2 + 473 | 0;
                               i64toi32_i32$5 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                               i64toi32_i32$1 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                               $1222 = i64toi32_i32$5;
                               i64toi32_i32$5 = $2;
                               HEAP32[($2 + 24 | 0) >> 2] = $1222;
                               HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$1;
                               i64toi32_i32$3 = $2 + 500 | 0;
                               i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                               i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                               $1226 = i64toi32_i32$1;
                               i64toi32_i32$1 = $2;
                               HEAP32[($2 + 424 | 0) >> 2] = $1226;
                               HEAP32[($2 + 428 | 0) >> 2] = i64toi32_i32$5;
                               i64toi32_i32$3 = $2;
                               i64toi32_i32$5 = HEAP32[($2 + 24 | 0) >> 2] | 0;
                               i64toi32_i32$1 = HEAP32[($2 + 28 | 0) >> 2] | 0;
                               $1229 = i64toi32_i32$5;
                               i64toi32_i32$5 = $2;
                               HEAP32[($2 + 400 | 0) >> 2] = $1229;
                               HEAP32[($2 + 404 | 0) >> 2] = i64toi32_i32$1;
                               i64toi32_i32$3 = $2;
                               i64toi32_i32$1 = HEAPU8[($2 + 31 | 0) >> 0] | 0 | ((HEAPU8[($2 + 32 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 33 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 34 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                               i64toi32_i32$5 = HEAPU8[($2 + 35 | 0) >> 0] | 0 | ((HEAPU8[($2 + 36 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 37 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 38 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                               $1232 = i64toi32_i32$1;
                               i64toi32_i32$1 = $2;
                               $350 = $1232;
                               HEAP8[($2 + 407 | 0) >> 0] = $350;
                               HEAP8[($2 + 408 | 0) >> 0] = $350 >>> 8 | 0;
                               HEAP8[($2 + 409 | 0) >> 0] = $350 >>> 16 | 0;
                               HEAP8[($2 + 410 | 0) >> 0] = $350 >>> 24 | 0;
                               HEAP8[($2 + 411 | 0) >> 0] = i64toi32_i32$5;
                               HEAP8[($2 + 412 | 0) >> 0] = i64toi32_i32$5 >>> 8 | 0;
                               HEAP8[($2 + 413 | 0) >> 0] = i64toi32_i32$5 >>> 16 | 0;
                               HEAP8[($2 + 414 | 0) >> 0] = i64toi32_i32$5 >>> 24 | 0;
                               i64toi32_i32$3 = $2 + 488 | 0;
                               i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                               i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                               $34 = i64toi32_i32$5;
                               $34$hi = i64toi32_i32$1;
                               $1 = HEAP32[($2 + 496 | 0) >> 2] | 0;
                               i64toi32_i32$3 = $2 + 453 | 0;
                               i64toi32_i32$1 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
                               i64toi32_i32$5 = 0;
                               $28 = i64toi32_i32$1;
                               $28$hi = i64toi32_i32$5;
                               i64toi32_i32$3 = $2 + 455 | 0;
                               i64toi32_i32$5 = HEAPU8[i64toi32_i32$3 >> 0] | 0;
                               i64toi32_i32$1 = 0;
                               $31 = i64toi32_i32$5;
                               $31$hi = i64toi32_i32$1;
                               $8 = HEAPU8[($2 + 472 | 0) >> 0] | 0;
                               i64toi32_i32$3 = $2;
                               i64toi32_i32$1 = HEAP32[($2 + 464 | 0) >> 2] | 0;
                               i64toi32_i32$5 = HEAP32[($2 + 468 | 0) >> 2] | 0;
                               $25 = i64toi32_i32$1;
                               $25$hi = i64toi32_i32$5;
                               i64toi32_i32$3 = $2;
                               i64toi32_i32$5 = HEAP32[($2 + 456 | 0) >> 2] | 0;
                               i64toi32_i32$1 = HEAP32[($2 + 460 | 0) >> 2] | 0;
                               $22 = i64toi32_i32$5;
                               $22$hi = i64toi32_i32$1;
                               $18 = HEAPU8[($2 + 448 | 0) >> 0] | 0;
                               i64toi32_i32$3 = $2;
                               i64toi32_i32$1 = HEAPU8[($2 + 449 | 0) >> 0] | 0 | ((HEAPU8[($2 + 450 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 451 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 452 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                               i64toi32_i32$5 = 0;
                               $30 = i64toi32_i32$1;
                               $30$hi = i64toi32_i32$5;
                               HEAP32[(($2 + 312 | 0) + 8 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
                               i64toi32_i32$3 = $2;
                               i64toi32_i32$5 = HEAP32[($2 + 424 | 0) >> 2] | 0;
                               i64toi32_i32$1 = HEAP32[($2 + 428 | 0) >> 2] | 0;
                               $1262 = i64toi32_i32$5;
                               i64toi32_i32$5 = $2;
                               HEAP32[($2 + 312 | 0) >> 2] = $1262;
                               HEAP32[($2 + 316 | 0) >> 2] = i64toi32_i32$1;
                               i64toi32_i32$1 = $30$hi;
                               $1263 = $30;
                               $1263$hi = i64toi32_i32$1;
                               i64toi32_i32$1 = $28$hi;
                               $1264 = $28;
                               $1264$hi = i64toi32_i32$1;
                               i64toi32_i32$1 = $31$hi;
                               i64toi32_i32$3 = $31;
                               i64toi32_i32$5 = 0;
                               i64toi32_i32$2 = 16;
                               i64toi32_i32$0 = i64toi32_i32$2 & 31 | 0;
                               if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                                i64toi32_i32$5 = i64toi32_i32$3 << i64toi32_i32$0 | 0;
                                $449 = 0;
                               } else {
                                i64toi32_i32$5 = ((1 << i64toi32_i32$0 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$0 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$0 | 0) | 0;
                                $449 = i64toi32_i32$3 << i64toi32_i32$0 | 0;
                               }
                               $1266$hi = i64toi32_i32$5;
                               i64toi32_i32$5 = $1264$hi;
                               i64toi32_i32$1 = $1264;
                               i64toi32_i32$3 = $1266$hi;
                               i64toi32_i32$2 = $449;
                               i64toi32_i32$3 = i64toi32_i32$5 | i64toi32_i32$3 | 0;
                               i64toi32_i32$5 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
                               i64toi32_i32$1 = 0;
                               i64toi32_i32$2 = 32;
                               i64toi32_i32$0 = i64toi32_i32$2 & 31 | 0;
                               if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                                i64toi32_i32$1 = i64toi32_i32$5 << i64toi32_i32$0 | 0;
                                $450 = 0;
                               } else {
                                i64toi32_i32$1 = ((1 << i64toi32_i32$0 | 0) - 1 | 0) & (i64toi32_i32$5 >>> (32 - i64toi32_i32$0 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$0 | 0) | 0;
                                $450 = i64toi32_i32$5 << i64toi32_i32$0 | 0;
                               }
                               $1268$hi = i64toi32_i32$1;
                               i64toi32_i32$1 = $1263$hi;
                               i64toi32_i32$3 = $1263;
                               i64toi32_i32$5 = $1268$hi;
                               i64toi32_i32$2 = $450;
                               i64toi32_i32$5 = i64toi32_i32$1 | i64toi32_i32$5 | 0;
                               $28 = i64toi32_i32$3 | i64toi32_i32$2 | 0;
                               $28$hi = i64toi32_i32$5;
                              }
                              HEAP8[($2 + 464 | 0) >> 0] = $8;
                              i64toi32_i32$5 = $25$hi;
                              i64toi32_i32$3 = $2 + 456 | 0;
                              HEAP32[i64toi32_i32$3 >> 2] = $25;
                              HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
                              i64toi32_i32$5 = $22$hi;
                              i64toi32_i32$3 = ($2 + 440 | 0) + 8 | 0;
                              HEAP32[i64toi32_i32$3 >> 2] = $22;
                              HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
                              i64toi32_i32$1 = $2;
                              i64toi32_i32$5 = HEAP32[($2 + 400 | 0) >> 2] | 0;
                              i64toi32_i32$3 = HEAP32[($2 + 404 | 0) >> 2] | 0;
                              $1283 = i64toi32_i32$5;
                              i64toi32_i32$5 = $2 + 465 | 0;
                              $351 = $1283;
                              HEAP8[i64toi32_i32$5 >> 0] = $351;
                              HEAP8[(i64toi32_i32$5 + 1 | 0) >> 0] = $351 >>> 8 | 0;
                              HEAP8[(i64toi32_i32$5 + 2 | 0) >> 0] = $351 >>> 16 | 0;
                              HEAP8[(i64toi32_i32$5 + 3 | 0) >> 0] = $351 >>> 24 | 0;
                              HEAP8[(i64toi32_i32$5 + 4 | 0) >> 0] = i64toi32_i32$3;
                              HEAP8[(i64toi32_i32$5 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
                              HEAP8[(i64toi32_i32$5 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
                              HEAP8[(i64toi32_i32$5 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
                              i64toi32_i32$1 = $2;
                              i64toi32_i32$3 = HEAPU8[($2 + 407 | 0) >> 0] | 0 | ((HEAPU8[($2 + 408 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 409 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 410 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                              i64toi32_i32$5 = HEAPU8[($2 + 411 | 0) >> 0] | 0 | ((HEAPU8[($2 + 412 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 413 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 414 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                              $1287 = i64toi32_i32$3;
                              i64toi32_i32$3 = $2 + 472 | 0;
                              $352 = $1287;
                              HEAP8[i64toi32_i32$3 >> 0] = $352;
                              HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $352 >>> 8 | 0;
                              HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $352 >>> 16 | 0;
                              HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $352 >>> 24 | 0;
                              HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$5;
                              HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$5 >>> 8 | 0;
                              HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$5 >>> 16 | 0;
                              HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$5 >>> 24 | 0;
                              i64toi32_i32$5 = $34$hi;
                              i64toi32_i32$3 = ($2 + 440 | 0) + 40 | 0;
                              HEAP32[i64toi32_i32$3 >> 2] = $34;
                              HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
                              i64toi32_i32$1 = $2;
                              i64toi32_i32$5 = HEAP32[($2 + 312 | 0) >> 2] | 0;
                              i64toi32_i32$3 = HEAP32[($2 + 316 | 0) >> 2] | 0;
                              $1295 = i64toi32_i32$5;
                              i64toi32_i32$5 = $2 + 492 | 0;
                              HEAP32[i64toi32_i32$5 >> 2] = $1295;
                              HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$3;
                              HEAP32[(($2 + 440 | 0) + 60 | 0) >> 2] = HEAP32[(($2 + 312 | 0) + 8 | 0) >> 2] | 0;
                              HEAP8[($2 + 440 | 0) >> 0] = $18;
                              HEAP32[($2 + 488 | 0) >> 2] = $1;
                              i64toi32_i32$3 = $28$hi;
                              HEAP8[($2 + 441 | 0) >> 0] = $28;
                              HEAP8[($2 + 442 | 0) >> 0] = $28 >>> 8 | 0;
                              HEAP8[($2 + 443 | 0) >> 0] = $28 >>> 16 | 0;
                              HEAP8[($2 + 444 | 0) >> 0] = $28 >>> 24 | 0;
                              $1309 = $2;
                              i64toi32_i32$1 = $28;
                              i64toi32_i32$5 = 0;
                              i64toi32_i32$2 = 48;
                              i64toi32_i32$0 = i64toi32_i32$2 & 31 | 0;
                              if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                               i64toi32_i32$5 = 0;
                               $452 = i64toi32_i32$3 >>> i64toi32_i32$0 | 0;
                              } else {
                               i64toi32_i32$5 = i64toi32_i32$3 >>> i64toi32_i32$0 | 0;
                               $452 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$0 | 0) | 0;
                              }
                              HEAP8[($1309 + 447 | 0) >> 0] = $452;
                              $1312 = $2;
                              i64toi32_i32$5 = $28$hi;
                              i64toi32_i32$3 = $28;
                              i64toi32_i32$1 = 0;
                              i64toi32_i32$2 = 32;
                              i64toi32_i32$0 = i64toi32_i32$2 & 31 | 0;
                              if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                               i64toi32_i32$1 = 0;
                               $453 = i64toi32_i32$5 >>> i64toi32_i32$0 | 0;
                              } else {
                               i64toi32_i32$1 = i64toi32_i32$5 >>> i64toi32_i32$0 | 0;
                               $453 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$0 | 0) | 0;
                              }
                              $455 = $1312;
                              $456 = $453;
                              HEAP8[($455 + 445 | 0) >> 0] = $456;
                              HEAP8[($455 + 446 | 0) >> 0] = $456 >>> 8 | 0;
                              cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($10 | 0, $2 + 440 | 0 | 0, 1050489 | 0, 19 | 0);
                              HEAP32[(($2 + 24 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 396 | 0) >> 2] | 0;
                              i64toi32_i32$5 = ($2 + 328 | 0) + 60 | 0;
                              i64toi32_i32$1 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                              i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                              $1328 = i64toi32_i32$1;
                              i64toi32_i32$1 = $2;
                              HEAP32[($2 + 24 | 0) >> 2] = $1328;
                              HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$3;
                              i64toi32_i32$5 = $2;
                              i64toi32_i32$3 = HEAP32[($2 + 336 | 0) >> 2] | 0;
                              i64toi32_i32$1 = HEAP32[($2 + 340 | 0) >> 2] | 0;
                              $28 = i64toi32_i32$3;
                              $28$hi = i64toi32_i32$1;
                              i64toi32_i32$5 = i64toi32_i32$3;
                              i64toi32_i32$3 = -1;
                              i64toi32_i32$2 = -256;
                              i64toi32_i32$3 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
                              $29 = i64toi32_i32$5 & i64toi32_i32$2 | 0;
                              $29$hi = i64toi32_i32$3;
                              i64toi32_i32$1 = ($2 + 328 | 0) + 40 | 0;
                              i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                              i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                              $32 = i64toi32_i32$3;
                              $32$hi = i64toi32_i32$5;
                              i64toi32_i32$1 = $2 + 376 | 0;
                              i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                              i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                              $33 = i64toi32_i32$5;
                              $33$hi = i64toi32_i32$3;
                              $8 = HEAP32[($2 + 384 | 0) >> 2] | 0;
                             }
                             i64toi32_i32$1 = $2;
                             i64toi32_i32$3 = HEAP32[($2 + 344 | 0) >> 2] | 0;
                             i64toi32_i32$5 = HEAP32[($2 + 348 | 0) >> 2] | 0;
                             $31 = i64toi32_i32$3;
                             $31$hi = i64toi32_i32$5;
                             i64toi32_i32$1 = $2;
                             i64toi32_i32$5 = HEAP32[($2 + 352 | 0) >> 2] | 0;
                             i64toi32_i32$3 = HEAP32[($2 + 356 | 0) >> 2] | 0;
                             $30 = i64toi32_i32$5;
                             $30$hi = i64toi32_i32$3;
                             i64toi32_i32$1 = $2;
                             i64toi32_i32$3 = HEAP32[($2 + 360 | 0) >> 2] | 0;
                             i64toi32_i32$5 = HEAP32[($2 + 364 | 0) >> 2] | 0;
                             $25 = i64toi32_i32$3;
                             $25$hi = i64toi32_i32$5;
                             break label$3;
                            }
                            label$78 : {
                             label$79 : {
                              if ($5) {
                               break label$79
                              }
                              i64toi32_i32$5 = $25$hi;
                              i64toi32_i32$1 = $25;
                              i64toi32_i32$3 = 0;
                              i64toi32_i32$2 = 1;
                              i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
                              i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
                              if (i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0) {
                               i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
                              }
                              $25 = i64toi32_i32$0;
                              $25$hi = i64toi32_i32$4;
                              i64toi32_i32$4 = $22$hi;
                              i64toi32_i32$4 = $25$hi;
                              i64toi32_i32$5 = i64toi32_i32$0;
                              i64toi32_i32$1 = $22$hi;
                              i64toi32_i32$2 = $22;
                              if (i64toi32_i32$4 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$0 >>> 0 <= i64toi32_i32$2 >>> 0 | 0) | 0) {
                               break label$79
                              }
                              i64toi32_i32$5 = 0;
                              $34 = 0;
                              $34$hi = i64toi32_i32$5;
                              $8 = 3;
                              $1 = 0;
                              break label$78;
                             }
                             cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__Update___deserialize__h5a4f342350ad0ea2($2 + 440 | 0 | 0, $1 | 0);
                             i64toi32_i32$2 = $16;
                             i64toi32_i32$5 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                             i64toi32_i32$4 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                             $1360 = i64toi32_i32$5;
                             i64toi32_i32$5 = $2;
                             HEAP32[($2 + 24 | 0) >> 2] = $1360;
                             HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$4;
                             i64toi32_i32$2 = $17;
                             i64toi32_i32$4 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                             i64toi32_i32$5 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                             $1363 = i64toi32_i32$4;
                             i64toi32_i32$4 = $2;
                             $353 = $1363;
                             HEAP8[($2 + 31 | 0) >> 0] = $353;
                             HEAP8[($2 + 32 | 0) >> 0] = $353 >>> 8 | 0;
                             HEAP8[($2 + 33 | 0) >> 0] = $353 >>> 16 | 0;
                             HEAP8[($2 + 34 | 0) >> 0] = $353 >>> 24 | 0;
                             HEAP8[($2 + 35 | 0) >> 0] = i64toi32_i32$5;
                             HEAP8[($2 + 36 | 0) >> 0] = i64toi32_i32$5 >>> 8 | 0;
                             HEAP8[($2 + 37 | 0) >> 0] = i64toi32_i32$5 >>> 16 | 0;
                             HEAP8[($2 + 38 | 0) >> 0] = i64toi32_i32$5 >>> 24 | 0;
                             i64toi32_i32$2 = $2;
                             i64toi32_i32$5 = HEAPU8[($2 + 449 | 0) >> 0] | 0 | ((HEAPU8[($2 + 450 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 451 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 452 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                             i64toi32_i32$4 = 0;
                             $1365 = i64toi32_i32$5;
                             $1365$hi = i64toi32_i32$4;
                             i64toi32_i32$2 = ($2 + 440 | 0) + 13 | 0;
                             i64toi32_i32$4 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
                             i64toi32_i32$5 = 0;
                             $1369 = i64toi32_i32$4;
                             $1369$hi = i64toi32_i32$5;
                             i64toi32_i32$2 = ($2 + 440 | 0) + 15 | 0;
                             i64toi32_i32$5 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
                             i64toi32_i32$4 = 0;
                             i64toi32_i32$2 = i64toi32_i32$5;
                             i64toi32_i32$5 = 0;
                             i64toi32_i32$1 = 16;
                             i64toi32_i32$3 = i64toi32_i32$1 & 31 | 0;
                             if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                              i64toi32_i32$5 = i64toi32_i32$2 << i64toi32_i32$3 | 0;
                              $457 = 0;
                             } else {
                              i64toi32_i32$5 = ((1 << i64toi32_i32$3 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$3 | 0) | 0) | 0 | (i64toi32_i32$4 << i64toi32_i32$3 | 0) | 0;
                              $457 = i64toi32_i32$2 << i64toi32_i32$3 | 0;
                             }
                             $1374$hi = i64toi32_i32$5;
                             i64toi32_i32$5 = $1369$hi;
                             i64toi32_i32$4 = $1369;
                             i64toi32_i32$2 = $1374$hi;
                             i64toi32_i32$1 = $457;
                             i64toi32_i32$2 = i64toi32_i32$5 | i64toi32_i32$2 | 0;
                             i64toi32_i32$5 = i64toi32_i32$4 | i64toi32_i32$1 | 0;
                             i64toi32_i32$4 = 0;
                             i64toi32_i32$1 = 32;
                             i64toi32_i32$3 = i64toi32_i32$1 & 31 | 0;
                             if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                              i64toi32_i32$4 = i64toi32_i32$5 << i64toi32_i32$3 | 0;
                              $458 = 0;
                             } else {
                              i64toi32_i32$4 = ((1 << i64toi32_i32$3 | 0) - 1 | 0) & (i64toi32_i32$5 >>> (32 - i64toi32_i32$3 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$3 | 0) | 0;
                              $458 = i64toi32_i32$5 << i64toi32_i32$3 | 0;
                             }
                             $1376$hi = i64toi32_i32$4;
                             i64toi32_i32$4 = $1365$hi;
                             i64toi32_i32$2 = $1365;
                             i64toi32_i32$5 = $1376$hi;
                             i64toi32_i32$1 = $458;
                             i64toi32_i32$5 = i64toi32_i32$4 | i64toi32_i32$5 | 0;
                             $28 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
                             $28$hi = i64toi32_i32$5;
                             i64toi32_i32$4 = $2;
                             i64toi32_i32$5 = HEAP32[($2 + 488 | 0) >> 2] | 0;
                             i64toi32_i32$2 = HEAP32[($2 + 492 | 0) >> 2] | 0;
                             $31 = i64toi32_i32$5;
                             $31$hi = i64toi32_i32$2;
                             $19 = HEAPU8[($2 + 472 | 0) >> 0] | 0;
                             i64toi32_i32$4 = $2;
                             i64toi32_i32$2 = HEAP32[($2 + 464 | 0) >> 2] | 0;
                             i64toi32_i32$5 = HEAP32[($2 + 468 | 0) >> 2] | 0;
                             $34 = i64toi32_i32$2;
                             $34$hi = i64toi32_i32$5;
                             i64toi32_i32$4 = $2;
                             i64toi32_i32$5 = HEAP32[($2 + 456 | 0) >> 2] | 0;
                             i64toi32_i32$2 = HEAP32[($2 + 460 | 0) >> 2] | 0;
                             $30 = i64toi32_i32$5;
                             $30$hi = i64toi32_i32$2;
                             $8 = HEAPU8[($2 + 448 | 0) >> 0] | 0;
                             i64toi32_i32$4 = $2;
                             i64toi32_i32$2 = HEAP32[($2 + 440 | 0) >> 2] | 0;
                             i64toi32_i32$5 = HEAP32[($2 + 444 | 0) >> 2] | 0;
                             i64toi32_i32$4 = i64toi32_i32$2;
                             i64toi32_i32$2 = 0;
                             i64toi32_i32$1 = 1;
                             if ((i64toi32_i32$4 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$5 | 0) != (i64toi32_i32$2 | 0) | 0) {
                              break label$16
                             }
                             HEAP32[($2 + 320 | 0) >> 2] = HEAP32[($2 + 508 | 0) >> 2] | 0;
                             i64toi32_i32$1 = $2;
                             i64toi32_i32$4 = HEAP32[($2 + 500 | 0) >> 2] | 0;
                             i64toi32_i32$5 = HEAP32[($2 + 504 | 0) >> 2] | 0;
                             $25 = i64toi32_i32$4;
                             $25$hi = i64toi32_i32$5;
                             i64toi32_i32$4 = $2;
                             HEAP32[($2 + 424 | 0) >> 2] = $25;
                             HEAP32[($2 + 428 | 0) >> 2] = i64toi32_i32$5;
                             i64toi32_i32$1 = $2;
                             i64toi32_i32$5 = HEAP32[($2 + 24 | 0) >> 2] | 0;
                             i64toi32_i32$4 = HEAP32[($2 + 28 | 0) >> 2] | 0;
                             $1402 = i64toi32_i32$5;
                             i64toi32_i32$5 = $2;
                             HEAP32[($2 + 400 | 0) >> 2] = $1402;
                             HEAP32[($2 + 404 | 0) >> 2] = i64toi32_i32$4;
                             i64toi32_i32$1 = $2;
                             i64toi32_i32$4 = HEAPU8[($2 + 31 | 0) >> 0] | 0 | ((HEAPU8[($2 + 32 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 33 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 34 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                             i64toi32_i32$5 = HEAPU8[($2 + 35 | 0) >> 0] | 0 | ((HEAPU8[($2 + 36 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 37 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 38 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                             $1405 = i64toi32_i32$4;
                             i64toi32_i32$4 = $2;
                             $355 = $1405;
                             HEAP8[($2 + 407 | 0) >> 0] = $355;
                             HEAP8[($2 + 408 | 0) >> 0] = $355 >>> 8 | 0;
                             HEAP8[($2 + 409 | 0) >> 0] = $355 >>> 16 | 0;
                             HEAP8[($2 + 410 | 0) >> 0] = $355 >>> 24 | 0;
                             HEAP8[($2 + 411 | 0) >> 0] = i64toi32_i32$5;
                             HEAP8[($2 + 412 | 0) >> 0] = i64toi32_i32$5 >>> 8 | 0;
                             HEAP8[($2 + 413 | 0) >> 0] = i64toi32_i32$5 >>> 16 | 0;
                             HEAP8[($2 + 414 | 0) >> 0] = i64toi32_i32$5 >>> 24 | 0;
                             i64toi32_i32$5 = $25$hi;
                             i64toi32_i32$4 = $2;
                             HEAP32[($2 + 312 | 0) >> 2] = $25;
                             HEAP32[($2 + 316 | 0) >> 2] = i64toi32_i32$5;
                             $1 = HEAP32[($2 + 496 | 0) >> 2] | 0;
                             i64toi32_i32$5 = $30$hi;
                             $22 = $30;
                             $22$hi = i64toi32_i32$5;
                            }
                            HEAP8[($2 + 464 | 0) >> 0] = $19;
                            i64toi32_i32$5 = $34$hi;
                            i64toi32_i32$4 = $2 + 456 | 0;
                            HEAP32[i64toi32_i32$4 >> 2] = $34;
                            HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
                            i64toi32_i32$5 = $22$hi;
                            i64toi32_i32$4 = ($2 + 440 | 0) + 8 | 0;
                            HEAP32[i64toi32_i32$4 >> 2] = $22;
                            HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
                            i64toi32_i32$1 = $2;
                            i64toi32_i32$5 = HEAP32[($2 + 400 | 0) >> 2] | 0;
                            i64toi32_i32$4 = HEAP32[($2 + 404 | 0) >> 2] | 0;
                            $1425 = i64toi32_i32$5;
                            i64toi32_i32$5 = $2 + 465 | 0;
                            $356 = $1425;
                            HEAP8[i64toi32_i32$5 >> 0] = $356;
                            HEAP8[(i64toi32_i32$5 + 1 | 0) >> 0] = $356 >>> 8 | 0;
                            HEAP8[(i64toi32_i32$5 + 2 | 0) >> 0] = $356 >>> 16 | 0;
                            HEAP8[(i64toi32_i32$5 + 3 | 0) >> 0] = $356 >>> 24 | 0;
                            HEAP8[(i64toi32_i32$5 + 4 | 0) >> 0] = i64toi32_i32$4;
                            HEAP8[(i64toi32_i32$5 + 5 | 0) >> 0] = i64toi32_i32$4 >>> 8 | 0;
                            HEAP8[(i64toi32_i32$5 + 6 | 0) >> 0] = i64toi32_i32$4 >>> 16 | 0;
                            HEAP8[(i64toi32_i32$5 + 7 | 0) >> 0] = i64toi32_i32$4 >>> 24 | 0;
                            i64toi32_i32$1 = $2;
                            i64toi32_i32$4 = HEAPU8[($2 + 407 | 0) >> 0] | 0 | ((HEAPU8[($2 + 408 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 409 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 410 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                            i64toi32_i32$5 = HEAPU8[($2 + 411 | 0) >> 0] | 0 | ((HEAPU8[($2 + 412 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 413 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 414 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                            $1429 = i64toi32_i32$4;
                            i64toi32_i32$4 = $2 + 472 | 0;
                            $357 = $1429;
                            HEAP8[i64toi32_i32$4 >> 0] = $357;
                            HEAP8[(i64toi32_i32$4 + 1 | 0) >> 0] = $357 >>> 8 | 0;
                            HEAP8[(i64toi32_i32$4 + 2 | 0) >> 0] = $357 >>> 16 | 0;
                            HEAP8[(i64toi32_i32$4 + 3 | 0) >> 0] = $357 >>> 24 | 0;
                            HEAP8[(i64toi32_i32$4 + 4 | 0) >> 0] = i64toi32_i32$5;
                            HEAP8[(i64toi32_i32$4 + 5 | 0) >> 0] = i64toi32_i32$5 >>> 8 | 0;
                            HEAP8[(i64toi32_i32$4 + 6 | 0) >> 0] = i64toi32_i32$5 >>> 16 | 0;
                            HEAP8[(i64toi32_i32$4 + 7 | 0) >> 0] = i64toi32_i32$5 >>> 24 | 0;
                            i64toi32_i32$5 = $31$hi;
                            i64toi32_i32$4 = ($2 + 440 | 0) + 40 | 0;
                            HEAP32[i64toi32_i32$4 >> 2] = $31;
                            HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
                            i64toi32_i32$1 = $2;
                            i64toi32_i32$5 = HEAP32[($2 + 312 | 0) >> 2] | 0;
                            i64toi32_i32$4 = HEAP32[($2 + 316 | 0) >> 2] | 0;
                            $1437 = i64toi32_i32$5;
                            i64toi32_i32$5 = $2 + 492 | 0;
                            HEAP32[i64toi32_i32$5 >> 2] = $1437;
                            HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$4;
                            HEAP32[($2 + 500 | 0) >> 2] = HEAP32[(($2 + 312 | 0) + 8 | 0) >> 2] | 0;
                            HEAP8[($2 + 440 | 0) >> 0] = $8;
                            HEAP32[($2 + 488 | 0) >> 2] = $1;
                            i64toi32_i32$4 = $28$hi;
                            HEAP8[($2 + 441 | 0) >> 0] = $28;
                            HEAP8[($2 + 442 | 0) >> 0] = $28 >>> 8 | 0;
                            HEAP8[($2 + 443 | 0) >> 0] = $28 >>> 16 | 0;
                            HEAP8[($2 + 444 | 0) >> 0] = $28 >>> 24 | 0;
                            $1450 = $2;
                            i64toi32_i32$1 = $28;
                            i64toi32_i32$5 = 0;
                            i64toi32_i32$2 = 48;
                            i64toi32_i32$3 = i64toi32_i32$2 & 31 | 0;
                            if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                             i64toi32_i32$5 = 0;
                             $459 = i64toi32_i32$4 >>> i64toi32_i32$3 | 0;
                            } else {
                             i64toi32_i32$5 = i64toi32_i32$4 >>> i64toi32_i32$3 | 0;
                             $459 = (((1 << i64toi32_i32$3 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$3 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$3 | 0) | 0;
                            }
                            HEAP8[($1450 + 447 | 0) >> 0] = $459;
                            $1453 = $2;
                            i64toi32_i32$5 = $28$hi;
                            i64toi32_i32$4 = $28;
                            i64toi32_i32$1 = 0;
                            i64toi32_i32$2 = 32;
                            i64toi32_i32$3 = i64toi32_i32$2 & 31 | 0;
                            if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                             i64toi32_i32$1 = 0;
                             $460 = i64toi32_i32$5 >>> i64toi32_i32$3 | 0;
                            } else {
                             i64toi32_i32$1 = i64toi32_i32$5 >>> i64toi32_i32$3 | 0;
                             $460 = (((1 << i64toi32_i32$3 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$3 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$3 | 0) | 0;
                            }
                            $461 = $1453;
                            $462 = $460;
                            HEAP8[($461 + 445 | 0) >> 0] = $462;
                            HEAP8[($461 + 446 | 0) >> 0] = $462 >>> 8 | 0;
                            cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($10 | 0, $2 + 440 | 0 | 0, 1050483 | 0, 6 | 0);
                            HEAP32[(($2 + 24 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 396 | 0) >> 2] | 0;
                            i64toi32_i32$5 = $2;
                            i64toi32_i32$1 = HEAP32[($2 + 388 | 0) >> 2] | 0;
                            i64toi32_i32$4 = HEAP32[($2 + 392 | 0) >> 2] | 0;
                            $1467 = i64toi32_i32$1;
                            i64toi32_i32$1 = $2;
                            HEAP32[($2 + 24 | 0) >> 2] = $1467;
                            HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$4;
                            i64toi32_i32$5 = $2;
                            i64toi32_i32$4 = HEAP32[($2 + 336 | 0) >> 2] | 0;
                            i64toi32_i32$1 = HEAP32[($2 + 340 | 0) >> 2] | 0;
                            $28 = i64toi32_i32$4;
                            $28$hi = i64toi32_i32$1;
                            i64toi32_i32$5 = i64toi32_i32$4;
                            i64toi32_i32$4 = -1;
                            i64toi32_i32$2 = -256;
                            i64toi32_i32$4 = i64toi32_i32$1 & i64toi32_i32$4 | 0;
                            $29 = i64toi32_i32$5 & i64toi32_i32$2 | 0;
                            $29$hi = i64toi32_i32$4;
                            i64toi32_i32$1 = ($2 + 328 | 0) + 40 | 0;
                            i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                            i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                            $32 = i64toi32_i32$4;
                            $32$hi = i64toi32_i32$5;
                            $8 = HEAP32[($2 + 384 | 0) >> 2] | 0;
                            i64toi32_i32$1 = $2;
                            i64toi32_i32$5 = HEAP32[($2 + 344 | 0) >> 2] | 0;
                            i64toi32_i32$4 = HEAP32[($2 + 348 | 0) >> 2] | 0;
                            $31 = i64toi32_i32$5;
                            $31$hi = i64toi32_i32$4;
                            i64toi32_i32$1 = $2;
                            i64toi32_i32$4 = HEAP32[($2 + 352 | 0) >> 2] | 0;
                            i64toi32_i32$5 = HEAP32[($2 + 356 | 0) >> 2] | 0;
                            $30 = i64toi32_i32$4;
                            $30$hi = i64toi32_i32$5;
                            i64toi32_i32$1 = $2;
                            i64toi32_i32$5 = HEAP32[($2 + 360 | 0) >> 2] | 0;
                            i64toi32_i32$4 = HEAP32[($2 + 364 | 0) >> 2] | 0;
                            $25 = i64toi32_i32$5;
                            $25$hi = i64toi32_i32$4;
                            i64toi32_i32$1 = $2;
                            i64toi32_i32$4 = HEAP32[($2 + 376 | 0) >> 2] | 0;
                            i64toi32_i32$5 = HEAP32[($2 + 380 | 0) >> 2] | 0;
                            $33 = i64toi32_i32$4;
                            $33$hi = i64toi32_i32$5;
                            break label$3;
                           }
                           label$80 : {
                            label$81 : {
                             if ($5) {
                              break label$81
                             }
                             i64toi32_i32$5 = $25$hi;
                             i64toi32_i32$1 = $25;
                             i64toi32_i32$4 = 0;
                             i64toi32_i32$2 = 1;
                             i64toi32_i32$3 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
                             i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
                             if (i64toi32_i32$3 >>> 0 < i64toi32_i32$2 >>> 0) {
                              i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
                             }
                             $25 = i64toi32_i32$3;
                             $25$hi = i64toi32_i32$0;
                             i64toi32_i32$0 = $22$hi;
                             i64toi32_i32$0 = $25$hi;
                             i64toi32_i32$5 = i64toi32_i32$3;
                             i64toi32_i32$1 = $22$hi;
                             i64toi32_i32$2 = $22;
                             if (i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$3 >>> 0 <= i64toi32_i32$2 >>> 0 | 0) | 0) {
                              break label$81
                             }
                             i64toi32_i32$5 = 0;
                             $34 = 0;
                             $34$hi = i64toi32_i32$5;
                             $8 = 3;
                             $1 = 0;
                             break label$80;
                            }
                            cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__Withdrawals___deserialize__h7582bde99e83c579($2 + 440 | 0 | 0, $1 | 0);
                            i64toi32_i32$2 = $16;
                            i64toi32_i32$5 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                            i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                            $1498 = i64toi32_i32$5;
                            i64toi32_i32$5 = $2;
                            HEAP32[($2 + 24 | 0) >> 2] = $1498;
                            HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$0;
                            i64toi32_i32$2 = $17;
                            i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                            i64toi32_i32$5 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                            $1501 = i64toi32_i32$0;
                            i64toi32_i32$0 = $2;
                            $358 = $1501;
                            HEAP8[($2 + 31 | 0) >> 0] = $358;
                            HEAP8[($2 + 32 | 0) >> 0] = $358 >>> 8 | 0;
                            HEAP8[($2 + 33 | 0) >> 0] = $358 >>> 16 | 0;
                            HEAP8[($2 + 34 | 0) >> 0] = $358 >>> 24 | 0;
                            HEAP8[($2 + 35 | 0) >> 0] = i64toi32_i32$5;
                            HEAP8[($2 + 36 | 0) >> 0] = i64toi32_i32$5 >>> 8 | 0;
                            HEAP8[($2 + 37 | 0) >> 0] = i64toi32_i32$5 >>> 16 | 0;
                            HEAP8[($2 + 38 | 0) >> 0] = i64toi32_i32$5 >>> 24 | 0;
                            i64toi32_i32$2 = $2;
                            i64toi32_i32$5 = HEAPU8[($2 + 449 | 0) >> 0] | 0 | ((HEAPU8[($2 + 450 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 451 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 452 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                            i64toi32_i32$0 = 0;
                            $1503 = i64toi32_i32$5;
                            $1503$hi = i64toi32_i32$0;
                            i64toi32_i32$2 = ($2 + 440 | 0) + 13 | 0;
                            i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
                            i64toi32_i32$5 = 0;
                            $1507 = i64toi32_i32$0;
                            $1507$hi = i64toi32_i32$5;
                            i64toi32_i32$2 = ($2 + 440 | 0) + 15 | 0;
                            i64toi32_i32$5 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
                            i64toi32_i32$0 = 0;
                            i64toi32_i32$2 = i64toi32_i32$5;
                            i64toi32_i32$5 = 0;
                            i64toi32_i32$1 = 16;
                            i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
                            if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                             i64toi32_i32$5 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
                             $463 = 0;
                            } else {
                             i64toi32_i32$5 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
                             $463 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
                            }
                            $1512$hi = i64toi32_i32$5;
                            i64toi32_i32$5 = $1507$hi;
                            i64toi32_i32$0 = $1507;
                            i64toi32_i32$2 = $1512$hi;
                            i64toi32_i32$1 = $463;
                            i64toi32_i32$2 = i64toi32_i32$5 | i64toi32_i32$2 | 0;
                            i64toi32_i32$5 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
                            i64toi32_i32$0 = 0;
                            i64toi32_i32$1 = 32;
                            i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
                            if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                             i64toi32_i32$0 = i64toi32_i32$5 << i64toi32_i32$4 | 0;
                             $464 = 0;
                            } else {
                             i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$5 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
                             $464 = i64toi32_i32$5 << i64toi32_i32$4 | 0;
                            }
                            $1514$hi = i64toi32_i32$0;
                            i64toi32_i32$0 = $1503$hi;
                            i64toi32_i32$2 = $1503;
                            i64toi32_i32$5 = $1514$hi;
                            i64toi32_i32$1 = $464;
                            i64toi32_i32$5 = i64toi32_i32$0 | i64toi32_i32$5 | 0;
                            $28 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
                            $28$hi = i64toi32_i32$5;
                            $19 = HEAPU8[($2 + 472 | 0) >> 0] | 0;
                            i64toi32_i32$0 = $2;
                            i64toi32_i32$5 = HEAP32[($2 + 464 | 0) >> 2] | 0;
                            i64toi32_i32$2 = HEAP32[($2 + 468 | 0) >> 2] | 0;
                            $34 = i64toi32_i32$5;
                            $34$hi = i64toi32_i32$2;
                            i64toi32_i32$0 = $2;
                            i64toi32_i32$2 = HEAP32[($2 + 456 | 0) >> 2] | 0;
                            i64toi32_i32$5 = HEAP32[($2 + 460 | 0) >> 2] | 0;
                            $31 = i64toi32_i32$2;
                            $31$hi = i64toi32_i32$5;
                            $8 = HEAPU8[($2 + 448 | 0) >> 0] | 0;
                            i64toi32_i32$0 = $2;
                            i64toi32_i32$5 = HEAP32[($2 + 440 | 0) >> 2] | 0;
                            i64toi32_i32$2 = HEAP32[($2 + 444 | 0) >> 2] | 0;
                            i64toi32_i32$0 = i64toi32_i32$5;
                            i64toi32_i32$5 = 0;
                            i64toi32_i32$1 = 1;
                            if ((i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$5 | 0) | 0) {
                             break label$15
                            }
                            HEAP32[($2 + 320 | 0) >> 2] = HEAP32[($2 + 508 | 0) >> 2] | 0;
                            i64toi32_i32$1 = $2;
                            i64toi32_i32$0 = HEAP32[($2 + 500 | 0) >> 2] | 0;
                            i64toi32_i32$2 = HEAP32[($2 + 504 | 0) >> 2] | 0;
                            $25 = i64toi32_i32$0;
                            $25$hi = i64toi32_i32$2;
                            i64toi32_i32$0 = $2;
                            HEAP32[($2 + 424 | 0) >> 2] = $25;
                            HEAP32[($2 + 428 | 0) >> 2] = i64toi32_i32$2;
                            i64toi32_i32$1 = $2;
                            i64toi32_i32$2 = HEAP32[($2 + 24 | 0) >> 2] | 0;
                            i64toi32_i32$0 = HEAP32[($2 + 28 | 0) >> 2] | 0;
                            $1538 = i64toi32_i32$2;
                            i64toi32_i32$2 = $2;
                            HEAP32[($2 + 400 | 0) >> 2] = $1538;
                            HEAP32[($2 + 404 | 0) >> 2] = i64toi32_i32$0;
                            i64toi32_i32$1 = $2;
                            i64toi32_i32$0 = HEAPU8[($2 + 31 | 0) >> 0] | 0 | ((HEAPU8[($2 + 32 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 33 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 34 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                            i64toi32_i32$2 = HEAPU8[($2 + 35 | 0) >> 0] | 0 | ((HEAPU8[($2 + 36 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 37 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 38 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                            $1541 = i64toi32_i32$0;
                            i64toi32_i32$0 = $2;
                            $359 = $1541;
                            HEAP8[($2 + 407 | 0) >> 0] = $359;
                            HEAP8[($2 + 408 | 0) >> 0] = $359 >>> 8 | 0;
                            HEAP8[($2 + 409 | 0) >> 0] = $359 >>> 16 | 0;
                            HEAP8[($2 + 410 | 0) >> 0] = $359 >>> 24 | 0;
                            HEAP8[($2 + 411 | 0) >> 0] = i64toi32_i32$2;
                            HEAP8[($2 + 412 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
                            HEAP8[($2 + 413 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
                            HEAP8[($2 + 414 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
                            i64toi32_i32$2 = $25$hi;
                            i64toi32_i32$0 = $2;
                            HEAP32[($2 + 312 | 0) >> 2] = $25;
                            HEAP32[($2 + 316 | 0) >> 2] = i64toi32_i32$2;
                            $1 = HEAP32[($2 + 496 | 0) >> 2] | 0;
                            i64toi32_i32$1 = $2 + 488 | 0;
                            i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                            i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                            $25 = i64toi32_i32$2;
                            $25$hi = i64toi32_i32$0;
                            i64toi32_i32$0 = $31$hi;
                            $22 = $31;
                            $22$hi = i64toi32_i32$0;
                           }
                           HEAP8[($2 + 464 | 0) >> 0] = $19;
                           i64toi32_i32$0 = $34$hi;
                           i64toi32_i32$2 = $2 + 456 | 0;
                           HEAP32[i64toi32_i32$2 >> 2] = $34;
                           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
                           i64toi32_i32$0 = $22$hi;
                           i64toi32_i32$2 = ($2 + 440 | 0) + 8 | 0;
                           HEAP32[i64toi32_i32$2 >> 2] = $22;
                           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
                           i64toi32_i32$1 = $2;
                           i64toi32_i32$0 = HEAP32[($2 + 400 | 0) >> 2] | 0;
                           i64toi32_i32$2 = HEAP32[($2 + 404 | 0) >> 2] | 0;
                           $1564 = i64toi32_i32$0;
                           i64toi32_i32$0 = $2 + 465 | 0;
                           $360 = $1564;
                           HEAP8[i64toi32_i32$0 >> 0] = $360;
                           HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $360 >>> 8 | 0;
                           HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $360 >>> 16 | 0;
                           HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $360 >>> 24 | 0;
                           HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$2;
                           HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
                           HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
                           HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
                           i64toi32_i32$1 = $2;
                           i64toi32_i32$2 = HEAPU8[($2 + 407 | 0) >> 0] | 0 | ((HEAPU8[($2 + 408 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 409 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 410 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                           i64toi32_i32$0 = HEAPU8[($2 + 411 | 0) >> 0] | 0 | ((HEAPU8[($2 + 412 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 413 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 414 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                           $1568 = i64toi32_i32$2;
                           i64toi32_i32$2 = $2 + 472 | 0;
                           $361 = $1568;
                           HEAP8[i64toi32_i32$2 >> 0] = $361;
                           HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $361 >>> 8 | 0;
                           HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $361 >>> 16 | 0;
                           HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $361 >>> 24 | 0;
                           HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$0;
                           HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                           HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
                           HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
                           i64toi32_i32$0 = $25$hi;
                           i64toi32_i32$2 = $2 + 480 | 0;
                           HEAP32[i64toi32_i32$2 >> 2] = $25;
                           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
                           i64toi32_i32$1 = $2;
                           i64toi32_i32$0 = HEAP32[($2 + 312 | 0) >> 2] | 0;
                           i64toi32_i32$2 = HEAP32[($2 + 316 | 0) >> 2] | 0;
                           $1575 = i64toi32_i32$0;
                           i64toi32_i32$0 = $2 + 492 | 0;
                           HEAP32[i64toi32_i32$0 >> 2] = $1575;
                           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
                           HEAP32[($2 + 500 | 0) >> 2] = HEAP32[(($2 + 312 | 0) + 8 | 0) >> 2] | 0;
                           HEAP8[($2 + 440 | 0) >> 0] = $8;
                           HEAP32[($2 + 488 | 0) >> 2] = $1;
                           i64toi32_i32$2 = $28$hi;
                           HEAP8[($2 + 441 | 0) >> 0] = $28;
                           HEAP8[($2 + 442 | 0) >> 0] = $28 >>> 8 | 0;
                           HEAP8[($2 + 443 | 0) >> 0] = $28 >>> 16 | 0;
                           HEAP8[($2 + 444 | 0) >> 0] = $28 >>> 24 | 0;
                           $1588 = $2;
                           i64toi32_i32$1 = $28;
                           i64toi32_i32$0 = 0;
                           i64toi32_i32$5 = 48;
                           i64toi32_i32$4 = i64toi32_i32$5 & 31 | 0;
                           if (32 >>> 0 <= (i64toi32_i32$5 & 63 | 0) >>> 0) {
                            i64toi32_i32$0 = 0;
                            $465 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
                           } else {
                            i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
                            $465 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
                           }
                           HEAP8[($1588 + 447 | 0) >> 0] = $465;
                           $1591 = $2;
                           i64toi32_i32$0 = $28$hi;
                           i64toi32_i32$2 = $28;
                           i64toi32_i32$1 = 0;
                           i64toi32_i32$5 = 32;
                           i64toi32_i32$4 = i64toi32_i32$5 & 31 | 0;
                           if (32 >>> 0 <= (i64toi32_i32$5 & 63 | 0) >>> 0) {
                            i64toi32_i32$1 = 0;
                            $466 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
                           } else {
                            i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
                            $466 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
                           }
                           $467 = $1591;
                           $468 = $466;
                           HEAP8[($467 + 445 | 0) >> 0] = $468;
                           HEAP8[($467 + 446 | 0) >> 0] = $468 >>> 8 | 0;
                           cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($10 | 0, $2 + 440 | 0 | 0, 1050472 | 0, 11 | 0);
                           HEAP32[(($2 + 24 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 396 | 0) >> 2] | 0;
                           i64toi32_i32$0 = $2;
                           i64toi32_i32$1 = HEAP32[($2 + 388 | 0) >> 2] | 0;
                           i64toi32_i32$2 = HEAP32[($2 + 392 | 0) >> 2] | 0;
                           $1605 = i64toi32_i32$1;
                           i64toi32_i32$1 = $2;
                           HEAP32[($2 + 24 | 0) >> 2] = $1605;
                           HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$2;
                           i64toi32_i32$0 = $2;
                           i64toi32_i32$2 = HEAP32[($2 + 336 | 0) >> 2] | 0;
                           i64toi32_i32$1 = HEAP32[($2 + 340 | 0) >> 2] | 0;
                           $28 = i64toi32_i32$2;
                           $28$hi = i64toi32_i32$1;
                           i64toi32_i32$0 = i64toi32_i32$2;
                           i64toi32_i32$2 = -1;
                           i64toi32_i32$5 = -256;
                           i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
                           $29 = i64toi32_i32$0 & i64toi32_i32$5 | 0;
                           $29$hi = i64toi32_i32$2;
                           i64toi32_i32$1 = $2 + 376 | 0;
                           i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                           i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                           $33 = i64toi32_i32$2;
                           $33$hi = i64toi32_i32$0;
                           $8 = HEAP32[($2 + 384 | 0) >> 2] | 0;
                           i64toi32_i32$1 = $2;
                           i64toi32_i32$0 = HEAP32[($2 + 344 | 0) >> 2] | 0;
                           i64toi32_i32$2 = HEAP32[($2 + 348 | 0) >> 2] | 0;
                           $31 = i64toi32_i32$0;
                           $31$hi = i64toi32_i32$2;
                           i64toi32_i32$1 = $2;
                           i64toi32_i32$2 = HEAP32[($2 + 352 | 0) >> 2] | 0;
                           i64toi32_i32$0 = HEAP32[($2 + 356 | 0) >> 2] | 0;
                           $30 = i64toi32_i32$2;
                           $30$hi = i64toi32_i32$0;
                           i64toi32_i32$1 = $2;
                           i64toi32_i32$0 = HEAP32[($2 + 360 | 0) >> 2] | 0;
                           i64toi32_i32$2 = HEAP32[($2 + 364 | 0) >> 2] | 0;
                           $25 = i64toi32_i32$0;
                           $25$hi = i64toi32_i32$2;
                           i64toi32_i32$1 = $2;
                           i64toi32_i32$2 = HEAP32[($2 + 368 | 0) >> 2] | 0;
                           i64toi32_i32$0 = HEAP32[($2 + 372 | 0) >> 2] | 0;
                           $32 = i64toi32_i32$2;
                           $32$hi = i64toi32_i32$0;
                           break label$3;
                          }
                          label$82 : {
                           label$83 : {
                            if ($5) {
                             break label$83
                            }
                            i64toi32_i32$0 = $25$hi;
                            i64toi32_i32$1 = $25;
                            i64toi32_i32$2 = 0;
                            i64toi32_i32$5 = 1;
                            i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
                            i64toi32_i32$3 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
                            if (i64toi32_i32$4 >>> 0 < i64toi32_i32$5 >>> 0) {
                             i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
                            }
                            $25 = i64toi32_i32$4;
                            $25$hi = i64toi32_i32$3;
                            i64toi32_i32$3 = $22$hi;
                            i64toi32_i32$3 = $25$hi;
                            i64toi32_i32$0 = i64toi32_i32$4;
                            i64toi32_i32$1 = $22$hi;
                            i64toi32_i32$5 = $22;
                            if (i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$0 >>> 0 <= i64toi32_i32$5 >>> 0 | 0) | 0) {
                             break label$83
                            }
                            i64toi32_i32$0 = 0;
                            $25 = 0;
                            $25$hi = i64toi32_i32$0;
                            $1 = 0;
                            $18 = 3;
                            break label$82;
                           }
                           cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__Certificates___deserialize__hd24284feaee200d9($2 + 440 | 0 | 0, $1 | 0);
                           if ((HEAP32[($2 + 440 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                            break label$14
                           }
                           $5 = ($2 + 424 | 0) + 8 | 0;
                           HEAP32[$5 >> 2] = HEAP32[($2 + 508 | 0) >> 2] | 0;
                           i64toi32_i32$5 = $2;
                           i64toi32_i32$0 = HEAPU8[($2 + 473 | 0) >> 0] | 0 | ((HEAPU8[($2 + 474 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 475 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 476 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                           i64toi32_i32$3 = HEAPU8[($2 + 477 | 0) >> 0] | 0 | ((HEAPU8[($2 + 478 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 479 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 480 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                           $1645 = i64toi32_i32$0;
                           i64toi32_i32$0 = $2;
                           HEAP32[($2 + 24 | 0) >> 2] = $1645;
                           HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$3;
                           i64toi32_i32$5 = $2 + 480 | 0;
                           i64toi32_i32$3 = HEAPU8[i64toi32_i32$5 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$5 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$5 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$5 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                           i64toi32_i32$0 = HEAPU8[(i64toi32_i32$5 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$5 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$5 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$5 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                           $1649 = i64toi32_i32$3;
                           i64toi32_i32$3 = $2;
                           $362 = $1649;
                           HEAP8[($2 + 31 | 0) >> 0] = $362;
                           HEAP8[($2 + 32 | 0) >> 0] = $362 >>> 8 | 0;
                           HEAP8[($2 + 33 | 0) >> 0] = $362 >>> 16 | 0;
                           HEAP8[($2 + 34 | 0) >> 0] = $362 >>> 24 | 0;
                           HEAP8[($2 + 35 | 0) >> 0] = i64toi32_i32$0;
                           HEAP8[($2 + 36 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                           HEAP8[($2 + 37 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
                           HEAP8[($2 + 38 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
                           i64toi32_i32$5 = $2 + 500 | 0;
                           i64toi32_i32$0 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                           i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                           $1653 = i64toi32_i32$0;
                           i64toi32_i32$0 = $2;
                           HEAP32[($2 + 424 | 0) >> 2] = $1653;
                           HEAP32[($2 + 428 | 0) >> 2] = i64toi32_i32$3;
                           i64toi32_i32$5 = $2;
                           i64toi32_i32$3 = HEAP32[($2 + 24 | 0) >> 2] | 0;
                           i64toi32_i32$0 = HEAP32[($2 + 28 | 0) >> 2] | 0;
                           $1656 = i64toi32_i32$3;
                           i64toi32_i32$3 = $2;
                           HEAP32[($2 + 400 | 0) >> 2] = $1656;
                           HEAP32[($2 + 404 | 0) >> 2] = i64toi32_i32$0;
                           i64toi32_i32$5 = $2;
                           i64toi32_i32$0 = HEAPU8[($2 + 31 | 0) >> 0] | 0 | ((HEAPU8[($2 + 32 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 33 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 34 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                           i64toi32_i32$3 = HEAPU8[($2 + 35 | 0) >> 0] | 0 | ((HEAPU8[($2 + 36 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 37 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 38 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                           $1659 = i64toi32_i32$0;
                           i64toi32_i32$0 = $2;
                           $363 = $1659;
                           HEAP8[($2 + 407 | 0) >> 0] = $363;
                           HEAP8[($2 + 408 | 0) >> 0] = $363 >>> 8 | 0;
                           HEAP8[($2 + 409 | 0) >> 0] = $363 >>> 16 | 0;
                           HEAP8[($2 + 410 | 0) >> 0] = $363 >>> 24 | 0;
                           HEAP8[($2 + 411 | 0) >> 0] = i64toi32_i32$3;
                           HEAP8[($2 + 412 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
                           HEAP8[($2 + 413 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
                           HEAP8[($2 + 414 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
                           $8 = HEAPU8[($2 + 472 | 0) >> 0] | 0;
                           i64toi32_i32$5 = $2 + 464 | 0;
                           i64toi32_i32$3 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                           i64toi32_i32$0 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                           $25 = i64toi32_i32$3;
                           $25$hi = i64toi32_i32$0;
                           i64toi32_i32$5 = $2 + 456 | 0;
                           i64toi32_i32$0 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                           i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                           $22 = i64toi32_i32$0;
                           $22$hi = i64toi32_i32$3;
                           i64toi32_i32$5 = $2 + 488 | 0;
                           i64toi32_i32$3 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                           i64toi32_i32$0 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                           $34 = i64toi32_i32$3;
                           $34$hi = i64toi32_i32$0;
                           $1 = HEAP32[($2 + 496 | 0) >> 2] | 0;
                           i64toi32_i32$5 = $2 + 453 | 0;
                           i64toi32_i32$0 = HEAPU8[i64toi32_i32$5 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$5 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
                           i64toi32_i32$3 = 0;
                           $28 = i64toi32_i32$0;
                           $28$hi = i64toi32_i32$3;
                           i64toi32_i32$5 = $2 + 455 | 0;
                           i64toi32_i32$3 = HEAPU8[i64toi32_i32$5 >> 0] | 0;
                           i64toi32_i32$0 = 0;
                           $31 = i64toi32_i32$3;
                           $31$hi = i64toi32_i32$0;
                           $18 = HEAPU8[($2 + 448 | 0) >> 0] | 0;
                           i64toi32_i32$5 = $2;
                           i64toi32_i32$0 = HEAPU8[($2 + 449 | 0) >> 0] | 0 | ((HEAPU8[($2 + 450 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 451 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 452 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                           i64toi32_i32$3 = 0;
                           $30 = i64toi32_i32$0;
                           $30$hi = i64toi32_i32$3;
                           HEAP32[(($2 + 312 | 0) + 8 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
                           i64toi32_i32$5 = $2;
                           i64toi32_i32$3 = HEAP32[($2 + 424 | 0) >> 2] | 0;
                           i64toi32_i32$0 = HEAP32[($2 + 428 | 0) >> 2] | 0;
                           $1692 = i64toi32_i32$3;
                           i64toi32_i32$3 = $2;
                           HEAP32[($2 + 312 | 0) >> 2] = $1692;
                           HEAP32[($2 + 316 | 0) >> 2] = i64toi32_i32$0;
                           i64toi32_i32$0 = $30$hi;
                           $1693 = $30;
                           $1693$hi = i64toi32_i32$0;
                           i64toi32_i32$0 = $28$hi;
                           $1694 = $28;
                           $1694$hi = i64toi32_i32$0;
                           i64toi32_i32$0 = $31$hi;
                           i64toi32_i32$5 = $31;
                           i64toi32_i32$3 = 0;
                           i64toi32_i32$1 = 16;
                           i64toi32_i32$2 = i64toi32_i32$1 & 31 | 0;
                           if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                            i64toi32_i32$3 = i64toi32_i32$5 << i64toi32_i32$2 | 0;
                            $469 = 0;
                           } else {
                            i64toi32_i32$3 = ((1 << i64toi32_i32$2 | 0) - 1 | 0) & (i64toi32_i32$5 >>> (32 - i64toi32_i32$2 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$2 | 0) | 0;
                            $469 = i64toi32_i32$5 << i64toi32_i32$2 | 0;
                           }
                           $1696$hi = i64toi32_i32$3;
                           i64toi32_i32$3 = $1694$hi;
                           i64toi32_i32$0 = $1694;
                           i64toi32_i32$5 = $1696$hi;
                           i64toi32_i32$1 = $469;
                           i64toi32_i32$5 = i64toi32_i32$3 | i64toi32_i32$5 | 0;
                           i64toi32_i32$3 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
                           i64toi32_i32$0 = 0;
                           i64toi32_i32$1 = 32;
                           i64toi32_i32$2 = i64toi32_i32$1 & 31 | 0;
                           if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                            i64toi32_i32$0 = i64toi32_i32$3 << i64toi32_i32$2 | 0;
                            $470 = 0;
                           } else {
                            i64toi32_i32$0 = ((1 << i64toi32_i32$2 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$2 | 0) | 0) | 0 | (i64toi32_i32$5 << i64toi32_i32$2 | 0) | 0;
                            $470 = i64toi32_i32$3 << i64toi32_i32$2 | 0;
                           }
                           $1698$hi = i64toi32_i32$0;
                           i64toi32_i32$0 = $1693$hi;
                           i64toi32_i32$5 = $1693;
                           i64toi32_i32$3 = $1698$hi;
                           i64toi32_i32$1 = $470;
                           i64toi32_i32$3 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
                           $28 = i64toi32_i32$5 | i64toi32_i32$1 | 0;
                           $28$hi = i64toi32_i32$3;
                          }
                          HEAP8[(($2 + 440 | 0) + 24 | 0) >> 0] = $8;
                          i64toi32_i32$3 = $25$hi;
                          i64toi32_i32$5 = ($2 + 440 | 0) + 16 | 0;
                          HEAP32[i64toi32_i32$5 >> 2] = $25;
                          HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$3;
                          i64toi32_i32$3 = $22$hi;
                          i64toi32_i32$5 = ($2 + 440 | 0) + 8 | 0;
                          HEAP32[i64toi32_i32$5 >> 2] = $22;
                          HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$3;
                          i64toi32_i32$0 = $2;
                          i64toi32_i32$3 = HEAP32[($2 + 400 | 0) >> 2] | 0;
                          i64toi32_i32$5 = HEAP32[($2 + 404 | 0) >> 2] | 0;
                          $1715 = i64toi32_i32$3;
                          i64toi32_i32$3 = $2 + 465 | 0;
                          $364 = $1715;
                          HEAP8[i64toi32_i32$3 >> 0] = $364;
                          HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $364 >>> 8 | 0;
                          HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $364 >>> 16 | 0;
                          HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $364 >>> 24 | 0;
                          HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$5;
                          HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$5 >>> 8 | 0;
                          HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$5 >>> 16 | 0;
                          HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$5 >>> 24 | 0;
                          i64toi32_i32$0 = $2;
                          i64toi32_i32$5 = HEAPU8[($2 + 407 | 0) >> 0] | 0 | ((HEAPU8[($2 + 408 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 409 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 410 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                          i64toi32_i32$3 = HEAPU8[($2 + 411 | 0) >> 0] | 0 | ((HEAPU8[($2 + 412 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 413 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 414 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                          $1720 = i64toi32_i32$5;
                          i64toi32_i32$5 = ($2 + 440 | 0) + 32 | 0;
                          $365 = $1720;
                          HEAP8[i64toi32_i32$5 >> 0] = $365;
                          HEAP8[(i64toi32_i32$5 + 1 | 0) >> 0] = $365 >>> 8 | 0;
                          HEAP8[(i64toi32_i32$5 + 2 | 0) >> 0] = $365 >>> 16 | 0;
                          HEAP8[(i64toi32_i32$5 + 3 | 0) >> 0] = $365 >>> 24 | 0;
                          HEAP8[(i64toi32_i32$5 + 4 | 0) >> 0] = i64toi32_i32$3;
                          HEAP8[(i64toi32_i32$5 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
                          HEAP8[(i64toi32_i32$5 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
                          HEAP8[(i64toi32_i32$5 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
                          i64toi32_i32$3 = $34$hi;
                          i64toi32_i32$5 = ($2 + 440 | 0) + 40 | 0;
                          HEAP32[i64toi32_i32$5 >> 2] = $34;
                          HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$3;
                          i64toi32_i32$0 = $2;
                          i64toi32_i32$3 = HEAP32[($2 + 312 | 0) >> 2] | 0;
                          i64toi32_i32$5 = HEAP32[($2 + 316 | 0) >> 2] | 0;
                          $1728 = i64toi32_i32$3;
                          i64toi32_i32$3 = $2 + 492 | 0;
                          HEAP32[i64toi32_i32$3 >> 2] = $1728;
                          HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
                          HEAP32[(($2 + 440 | 0) + 60 | 0) >> 2] = HEAP32[(($2 + 312 | 0) + 8 | 0) >> 2] | 0;
                          HEAP8[($2 + 440 | 0) >> 0] = $18;
                          HEAP32[($2 + 488 | 0) >> 2] = $1;
                          i64toi32_i32$5 = $28$hi;
                          HEAP8[($2 + 441 | 0) >> 0] = $28;
                          HEAP8[($2 + 442 | 0) >> 0] = $28 >>> 8 | 0;
                          HEAP8[($2 + 443 | 0) >> 0] = $28 >>> 16 | 0;
                          HEAP8[($2 + 444 | 0) >> 0] = $28 >>> 24 | 0;
                          $1742 = $2;
                          i64toi32_i32$0 = $28;
                          i64toi32_i32$3 = 0;
                          i64toi32_i32$1 = 48;
                          i64toi32_i32$2 = i64toi32_i32$1 & 31 | 0;
                          if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                           i64toi32_i32$3 = 0;
                           $471 = i64toi32_i32$5 >>> i64toi32_i32$2 | 0;
                          } else {
                           i64toi32_i32$3 = i64toi32_i32$5 >>> i64toi32_i32$2 | 0;
                           $471 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$2 | 0) | 0;
                          }
                          HEAP8[($1742 + 447 | 0) >> 0] = $471;
                          $1745 = $2;
                          i64toi32_i32$3 = $28$hi;
                          i64toi32_i32$5 = $28;
                          i64toi32_i32$0 = 0;
                          i64toi32_i32$1 = 32;
                          i64toi32_i32$2 = i64toi32_i32$1 & 31 | 0;
                          if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                           i64toi32_i32$0 = 0;
                           $472 = i64toi32_i32$3 >>> i64toi32_i32$2 | 0;
                          } else {
                           i64toi32_i32$0 = i64toi32_i32$3 >>> i64toi32_i32$2 | 0;
                           $472 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$2 | 0) | 0;
                          }
                          $473 = $1745;
                          $474 = $472;
                          HEAP8[($473 + 445 | 0) >> 0] = $474;
                          HEAP8[($473 + 446 | 0) >> 0] = $474 >>> 8 | 0;
                          cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($10 | 0, $2 + 440 | 0 | 0, 1050467 | 0, 5 | 0);
                          HEAP32[(($2 + 24 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 396 | 0) >> 2] | 0;
                          i64toi32_i32$3 = ($2 + 328 | 0) + 60 | 0;
                          i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                          i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                          $1761 = i64toi32_i32$0;
                          i64toi32_i32$0 = $2;
                          HEAP32[($2 + 24 | 0) >> 2] = $1761;
                          HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$5;
                          i64toi32_i32$3 = $2;
                          i64toi32_i32$5 = HEAP32[($2 + 336 | 0) >> 2] | 0;
                          i64toi32_i32$0 = HEAP32[($2 + 340 | 0) >> 2] | 0;
                          $28 = i64toi32_i32$5;
                          $28$hi = i64toi32_i32$0;
                          i64toi32_i32$3 = i64toi32_i32$5;
                          i64toi32_i32$5 = -1;
                          i64toi32_i32$1 = -256;
                          i64toi32_i32$5 = i64toi32_i32$0 & i64toi32_i32$5 | 0;
                          $29 = i64toi32_i32$3 & i64toi32_i32$1 | 0;
                          $29$hi = i64toi32_i32$5;
                          i64toi32_i32$0 = ($2 + 328 | 0) + 16 | 0;
                          i64toi32_i32$5 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                          i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                          $31 = i64toi32_i32$5;
                          $31$hi = i64toi32_i32$3;
                          i64toi32_i32$0 = ($2 + 328 | 0) + 24 | 0;
                          i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                          i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                          $30 = i64toi32_i32$3;
                          $30$hi = i64toi32_i32$5;
                          i64toi32_i32$0 = ($2 + 328 | 0) + 32 | 0;
                          i64toi32_i32$5 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                          i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                          $25 = i64toi32_i32$5;
                          $25$hi = i64toi32_i32$3;
                          i64toi32_i32$0 = ($2 + 328 | 0) + 40 | 0;
                          i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                          i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                          $32 = i64toi32_i32$3;
                          $32$hi = i64toi32_i32$5;
                          i64toi32_i32$0 = $2 + 376 | 0;
                          i64toi32_i32$5 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                          i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                          $33 = i64toi32_i32$5;
                          $33$hi = i64toi32_i32$3;
                          $8 = HEAP32[($2 + 384 | 0) >> 2] | 0;
                          break label$3;
                         }
                         label$84 : {
                          label$85 : {
                           if ($5) {
                            break label$85
                           }
                           i64toi32_i32$3 = $25$hi;
                           i64toi32_i32$0 = $25;
                           i64toi32_i32$5 = 0;
                           i64toi32_i32$1 = 1;
                           i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
                           i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
                           if (i64toi32_i32$2 >>> 0 < i64toi32_i32$1 >>> 0) {
                            i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
                           }
                           $25 = i64toi32_i32$2;
                           $25$hi = i64toi32_i32$4;
                           i64toi32_i32$4 = $22$hi;
                           i64toi32_i32$4 = $25$hi;
                           i64toi32_i32$3 = i64toi32_i32$2;
                           i64toi32_i32$0 = $22$hi;
                           i64toi32_i32$1 = $22;
                           if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$3 >>> 0 <= i64toi32_i32$1 >>> 0 | 0) | 0) {
                            break label$85
                           }
                           i64toi32_i32$3 = 0;
                           $28 = 0;
                           $28$hi = i64toi32_i32$3;
                           i64toi32_i32$3 = 0;
                           $36 = 3;
                           $36$hi = i64toi32_i32$3;
                           $1 = 0;
                           break label$84;
                          }
                          $cardano_serialization_lib__utils__BigNum_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h29637bb571dceb02($2 + 440 | 0 | 0, $1 | 0);
                          i64toi32_i32$1 = $2;
                          i64toi32_i32$3 = HEAP32[($2 + 448 | 0) >> 2] | 0;
                          i64toi32_i32$4 = HEAP32[($2 + 452 | 0) >> 2] | 0;
                          $36 = i64toi32_i32$3;
                          $36$hi = i64toi32_i32$4;
                          i64toi32_i32$1 = $2;
                          i64toi32_i32$4 = HEAP32[($2 + 440 | 0) >> 2] | 0;
                          i64toi32_i32$3 = HEAP32[($2 + 444 | 0) >> 2] | 0;
                          i64toi32_i32$1 = i64toi32_i32$4;
                          i64toi32_i32$4 = 0;
                          i64toi32_i32$0 = 1;
                          if ((i64toi32_i32$1 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$3 | 0) != (i64toi32_i32$4 | 0) | 0) {
                           break label$13
                          }
                          $8 = ($2 + 424 | 0) + 8 | 0;
                          HEAP32[$8 >> 2] = HEAP32[($2 + 508 | 0) >> 2] | 0;
                          i64toi32_i32$0 = $2;
                          i64toi32_i32$1 = HEAPU8[($2 + 473 | 0) >> 0] | 0 | ((HEAPU8[($2 + 474 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 475 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 476 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                          i64toi32_i32$3 = HEAPU8[($2 + 477 | 0) >> 0] | 0 | ((HEAPU8[($2 + 478 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 479 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 480 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                          $1811 = i64toi32_i32$1;
                          i64toi32_i32$1 = $2;
                          HEAP32[($2 + 24 | 0) >> 2] = $1811;
                          HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$3;
                          i64toi32_i32$0 = $2 + 480 | 0;
                          i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                          i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                          $1815 = i64toi32_i32$3;
                          i64toi32_i32$3 = $2;
                          $366 = $1815;
                          HEAP8[($2 + 31 | 0) >> 0] = $366;
                          HEAP8[($2 + 32 | 0) >> 0] = $366 >>> 8 | 0;
                          HEAP8[($2 + 33 | 0) >> 0] = $366 >>> 16 | 0;
                          HEAP8[($2 + 34 | 0) >> 0] = $366 >>> 24 | 0;
                          HEAP8[($2 + 35 | 0) >> 0] = i64toi32_i32$1;
                          HEAP8[($2 + 36 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
                          HEAP8[($2 + 37 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
                          HEAP8[($2 + 38 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
                          i64toi32_i32$0 = $2;
                          i64toi32_i32$1 = HEAP32[($2 + 500 | 0) >> 2] | 0;
                          i64toi32_i32$3 = HEAP32[($2 + 504 | 0) >> 2] | 0;
                          $1818 = i64toi32_i32$1;
                          i64toi32_i32$1 = $2;
                          HEAP32[($2 + 424 | 0) >> 2] = $1818;
                          HEAP32[($2 + 428 | 0) >> 2] = i64toi32_i32$3;
                          i64toi32_i32$0 = $2;
                          i64toi32_i32$3 = HEAP32[($2 + 24 | 0) >> 2] | 0;
                          i64toi32_i32$1 = HEAP32[($2 + 28 | 0) >> 2] | 0;
                          $1821 = i64toi32_i32$3;
                          i64toi32_i32$3 = $2;
                          HEAP32[($2 + 400 | 0) >> 2] = $1821;
                          HEAP32[($2 + 404 | 0) >> 2] = i64toi32_i32$1;
                          i64toi32_i32$0 = $2;
                          i64toi32_i32$1 = HEAPU8[($2 + 31 | 0) >> 0] | 0 | ((HEAPU8[($2 + 32 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 33 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 34 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                          i64toi32_i32$3 = HEAPU8[($2 + 35 | 0) >> 0] | 0 | ((HEAPU8[($2 + 36 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 37 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 38 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                          $1824 = i64toi32_i32$1;
                          i64toi32_i32$1 = $2;
                          $367 = $1824;
                          HEAP8[($2 + 407 | 0) >> 0] = $367;
                          HEAP8[($2 + 408 | 0) >> 0] = $367 >>> 8 | 0;
                          HEAP8[($2 + 409 | 0) >> 0] = $367 >>> 16 | 0;
                          HEAP8[($2 + 410 | 0) >> 0] = $367 >>> 24 | 0;
                          HEAP8[($2 + 411 | 0) >> 0] = i64toi32_i32$3;
                          HEAP8[($2 + 412 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
                          HEAP8[($2 + 413 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
                          HEAP8[($2 + 414 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
                          $18 = HEAPU8[($2 + 472 | 0) >> 0] | 0;
                          i64toi32_i32$0 = $2 + 464 | 0;
                          i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                          i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                          $28 = i64toi32_i32$3;
                          $28$hi = i64toi32_i32$1;
                          i64toi32_i32$0 = $2 + 456 | 0;
                          i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                          i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                          $22 = i64toi32_i32$1;
                          $22$hi = i64toi32_i32$3;
                          i64toi32_i32$0 = $2 + 488 | 0;
                          i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                          i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                          $25 = i64toi32_i32$3;
                          $25$hi = i64toi32_i32$1;
                          $1 = HEAP32[($2 + 496 | 0) >> 2] | 0;
                          HEAP32[(($2 + 312 | 0) + 8 | 0) >> 2] = HEAP32[$8 >> 2] | 0;
                          i64toi32_i32$0 = $2;
                          i64toi32_i32$1 = HEAP32[($2 + 424 | 0) >> 2] | 0;
                          i64toi32_i32$3 = HEAP32[($2 + 428 | 0) >> 2] | 0;
                          $1847 = i64toi32_i32$1;
                          i64toi32_i32$1 = $2;
                          HEAP32[($2 + 312 | 0) >> 2] = $1847;
                          HEAP32[($2 + 316 | 0) >> 2] = i64toi32_i32$3;
                         }
                         HEAP8[(($2 + 440 | 0) + 24 | 0) >> 0] = $18;
                         i64toi32_i32$3 = $28$hi;
                         i64toi32_i32$1 = ($2 + 440 | 0) + 16 | 0;
                         HEAP32[i64toi32_i32$1 >> 2] = $28;
                         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
                         i64toi32_i32$3 = $22$hi;
                         i64toi32_i32$1 = ($2 + 440 | 0) + 8 | 0;
                         HEAP32[i64toi32_i32$1 >> 2] = $22;
                         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
                         i64toi32_i32$0 = $2;
                         i64toi32_i32$3 = HEAP32[($2 + 400 | 0) >> 2] | 0;
                         i64toi32_i32$1 = HEAP32[($2 + 404 | 0) >> 2] | 0;
                         $1863 = i64toi32_i32$3;
                         i64toi32_i32$3 = $2 + 465 | 0;
                         $369 = $1863;
                         HEAP8[i64toi32_i32$3 >> 0] = $369;
                         HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $369 >>> 8 | 0;
                         HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $369 >>> 16 | 0;
                         HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $369 >>> 24 | 0;
                         HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$1;
                         HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
                         HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
                         HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
                         i64toi32_i32$0 = $2;
                         i64toi32_i32$1 = HEAPU8[($2 + 407 | 0) >> 0] | 0 | ((HEAPU8[($2 + 408 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 409 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 410 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                         i64toi32_i32$3 = HEAPU8[($2 + 411 | 0) >> 0] | 0 | ((HEAPU8[($2 + 412 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 413 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 414 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                         $1868 = i64toi32_i32$1;
                         i64toi32_i32$1 = ($2 + 440 | 0) + 32 | 0;
                         $370 = $1868;
                         HEAP8[i64toi32_i32$1 >> 0] = $370;
                         HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $370 >>> 8 | 0;
                         HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $370 >>> 16 | 0;
                         HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $370 >>> 24 | 0;
                         HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$3;
                         HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
                         HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
                         HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
                         i64toi32_i32$3 = $25$hi;
                         i64toi32_i32$1 = ($2 + 440 | 0) + 40 | 0;
                         HEAP32[i64toi32_i32$1 >> 2] = $25;
                         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
                         i64toi32_i32$0 = $2;
                         i64toi32_i32$3 = HEAP32[($2 + 312 | 0) >> 2] | 0;
                         i64toi32_i32$1 = HEAP32[($2 + 316 | 0) >> 2] | 0;
                         $1876 = i64toi32_i32$3;
                         i64toi32_i32$3 = $2 + 492 | 0;
                         HEAP32[i64toi32_i32$3 >> 2] = $1876;
                         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
                         HEAP32[($2 + 500 | 0) >> 2] = HEAP32[(($2 + 312 | 0) + 8 | 0) >> 2] | 0;
                         i64toi32_i32$1 = $36$hi;
                         i64toi32_i32$3 = $2;
                         HEAP32[($2 + 440 | 0) >> 2] = $36;
                         HEAP32[($2 + 444 | 0) >> 2] = i64toi32_i32$1;
                         HEAP32[($2 + 488 | 0) >> 2] = $1;
                         cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($10 | 0, $2 + 440 | 0 | 0, 1050464 | 0, 3 | 0);
                         HEAP32[(($2 + 24 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 396 | 0) >> 2] | 0;
                         i64toi32_i32$0 = $2;
                         i64toi32_i32$1 = HEAP32[($2 + 388 | 0) >> 2] | 0;
                         i64toi32_i32$3 = HEAP32[($2 + 392 | 0) >> 2] | 0;
                         $1898 = i64toi32_i32$1;
                         i64toi32_i32$1 = $2;
                         HEAP32[($2 + 24 | 0) >> 2] = $1898;
                         HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$3;
                         i64toi32_i32$0 = $2;
                         i64toi32_i32$3 = HEAP32[($2 + 336 | 0) >> 2] | 0;
                         i64toi32_i32$1 = HEAP32[($2 + 340 | 0) >> 2] | 0;
                         $28 = i64toi32_i32$3;
                         $28$hi = i64toi32_i32$1;
                         i64toi32_i32$0 = i64toi32_i32$3;
                         i64toi32_i32$3 = -1;
                         i64toi32_i32$4 = -256;
                         i64toi32_i32$3 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
                         $29 = i64toi32_i32$0 & i64toi32_i32$4 | 0;
                         $29$hi = i64toi32_i32$3;
                         i64toi32_i32$1 = ($2 + 328 | 0) + 16 | 0;
                         i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                         i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                         $31 = i64toi32_i32$3;
                         $31$hi = i64toi32_i32$0;
                         i64toi32_i32$1 = ($2 + 328 | 0) + 24 | 0;
                         i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                         i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                         $30 = i64toi32_i32$0;
                         $30$hi = i64toi32_i32$3;
                         i64toi32_i32$1 = ($2 + 328 | 0) + 32 | 0;
                         i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                         i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                         $25 = i64toi32_i32$3;
                         $25$hi = i64toi32_i32$0;
                         i64toi32_i32$1 = ($2 + 328 | 0) + 40 | 0;
                         i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                         i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                         $32 = i64toi32_i32$0;
                         $32$hi = i64toi32_i32$3;
                         i64toi32_i32$1 = $2 + 376 | 0;
                         i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                         i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                         $33 = i64toi32_i32$3;
                         $33$hi = i64toi32_i32$0;
                         $8 = HEAP32[($2 + 384 | 0) >> 2] | 0;
                         break label$3;
                        }
                        $cardano_serialization_lib__utils__BigNum_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h29637bb571dceb02($2 + 440 | 0 | 0, $1 | 0);
                        i64toi32_i32$1 = $2;
                        i64toi32_i32$0 = HEAP32[($2 + 448 | 0) >> 2] | 0;
                        i64toi32_i32$3 = HEAP32[($2 + 452 | 0) >> 2] | 0;
                        $37 = i64toi32_i32$0;
                        $37$hi = i64toi32_i32$3;
                        label$86 : {
                         i64toi32_i32$1 = $2;
                         i64toi32_i32$3 = HEAP32[($2 + 440 | 0) >> 2] | 0;
                         i64toi32_i32$0 = HEAP32[($2 + 444 | 0) >> 2] | 0;
                         i64toi32_i32$1 = i64toi32_i32$3;
                         i64toi32_i32$3 = 0;
                         i64toi32_i32$4 = 1;
                         if ((i64toi32_i32$1 | 0) == (i64toi32_i32$4 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) | 0) {
                          break label$86
                         }
                         i64toi32_i32$1 = 0;
                         $27 = 1;
                         $27$hi = i64toi32_i32$1;
                         break label$12;
                        }
                        $1 = ($2 + 424 | 0) + 8 | 0;
                        HEAP32[$1 >> 2] = HEAP32[(($2 + 440 | 0) + 68 | 0) >> 2] | 0;
                        i64toi32_i32$4 = $2;
                        i64toi32_i32$1 = HEAPU8[($2 + 473 | 0) >> 0] | 0 | ((HEAPU8[($2 + 474 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 475 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 476 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                        i64toi32_i32$0 = HEAPU8[($2 + 477 | 0) >> 0] | 0 | ((HEAPU8[($2 + 478 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 479 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 480 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                        $1943 = i64toi32_i32$1;
                        i64toi32_i32$1 = $2;
                        HEAP32[($2 + 24 | 0) >> 2] = $1943;
                        HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$0;
                        $18 = ($2 + 440 | 0) + 40 | 0;
                        i64toi32_i32$4 = $18;
                        i64toi32_i32$0 = HEAPU8[i64toi32_i32$4 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$4 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$4 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$4 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                        i64toi32_i32$1 = HEAPU8[(i64toi32_i32$4 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$4 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$4 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$4 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                        $1949 = i64toi32_i32$0;
                        i64toi32_i32$0 = $2;
                        $372 = $1949;
                        HEAP8[($2 + 31 | 0) >> 0] = $372;
                        HEAP8[($2 + 32 | 0) >> 0] = $372 >>> 8 | 0;
                        HEAP8[($2 + 33 | 0) >> 0] = $372 >>> 16 | 0;
                        HEAP8[($2 + 34 | 0) >> 0] = $372 >>> 24 | 0;
                        HEAP8[($2 + 35 | 0) >> 0] = i64toi32_i32$1;
                        HEAP8[($2 + 36 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
                        HEAP8[($2 + 37 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
                        HEAP8[($2 + 38 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
                        i64toi32_i32$4 = $2;
                        i64toi32_i32$1 = HEAP32[($2 + 500 | 0) >> 2] | 0;
                        i64toi32_i32$0 = HEAP32[($2 + 504 | 0) >> 2] | 0;
                        $1952 = i64toi32_i32$1;
                        i64toi32_i32$1 = $2;
                        HEAP32[($2 + 424 | 0) >> 2] = $1952;
                        HEAP32[($2 + 428 | 0) >> 2] = i64toi32_i32$0;
                        i64toi32_i32$4 = $2;
                        i64toi32_i32$0 = HEAP32[($2 + 24 | 0) >> 2] | 0;
                        i64toi32_i32$1 = HEAP32[($2 + 28 | 0) >> 2] | 0;
                        $1955 = i64toi32_i32$0;
                        i64toi32_i32$0 = $2;
                        HEAP32[($2 + 400 | 0) >> 2] = $1955;
                        HEAP32[($2 + 404 | 0) >> 2] = i64toi32_i32$1;
                        i64toi32_i32$4 = $2;
                        i64toi32_i32$1 = HEAPU8[($2 + 31 | 0) >> 0] | 0 | ((HEAPU8[($2 + 32 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 33 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 34 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                        i64toi32_i32$0 = HEAPU8[($2 + 35 | 0) >> 0] | 0 | ((HEAPU8[($2 + 36 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 37 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 38 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                        $1958 = i64toi32_i32$1;
                        i64toi32_i32$1 = $2;
                        $373 = $1958;
                        HEAP8[($2 + 407 | 0) >> 0] = $373;
                        HEAP8[($2 + 408 | 0) >> 0] = $373 >>> 8 | 0;
                        HEAP8[($2 + 409 | 0) >> 0] = $373 >>> 16 | 0;
                        HEAP8[($2 + 410 | 0) >> 0] = $373 >>> 24 | 0;
                        HEAP8[($2 + 411 | 0) >> 0] = i64toi32_i32$0;
                        HEAP8[($2 + 412 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                        HEAP8[($2 + 413 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
                        HEAP8[($2 + 414 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
                        $8 = HEAP32[(($2 + 440 | 0) + 56 | 0) >> 2] | 0;
                        i64toi32_i32$4 = ($2 + 440 | 0) + 48 | 0;
                        i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                        i64toi32_i32$1 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                        $28 = i64toi32_i32$0;
                        $28$hi = i64toi32_i32$1;
                        $5 = ($2 + 440 | 0) + 16 | 0;
                        i64toi32_i32$4 = $5;
                        i64toi32_i32$1 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                        i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                        $25 = i64toi32_i32$1;
                        $25$hi = i64toi32_i32$0;
                        $4 = ($2 + 440 | 0) + 24 | 0;
                        i64toi32_i32$4 = $4;
                        i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                        i64toi32_i32$1 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                        $22 = i64toi32_i32$0;
                        $22$hi = i64toi32_i32$1;
                        $3 = ($2 + 440 | 0) + 32 | 0;
                        $6 = HEAPU8[$3 >> 0] | 0;
                        $7 = ($2 + 312 | 0) + 8 | 0;
                        HEAP32[$7 >> 2] = HEAP32[$1 >> 2] | 0;
                        i64toi32_i32$4 = $2;
                        i64toi32_i32$1 = HEAP32[($2 + 424 | 0) >> 2] | 0;
                        i64toi32_i32$0 = HEAP32[($2 + 428 | 0) >> 2] | 0;
                        $1990 = i64toi32_i32$1;
                        i64toi32_i32$1 = $2;
                        HEAP32[($2 + 312 | 0) >> 2] = $1990;
                        HEAP32[($2 + 316 | 0) >> 2] = i64toi32_i32$0;
                        HEAP8[$4 >> 0] = $6;
                        i64toi32_i32$0 = $22$hi;
                        i64toi32_i32$1 = $5;
                        HEAP32[i64toi32_i32$1 >> 2] = $22;
                        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                        i64toi32_i32$0 = $25$hi;
                        i64toi32_i32$1 = ($2 + 440 | 0) + 8 | 0;
                        HEAP32[i64toi32_i32$1 >> 2] = $25;
                        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                        i64toi32_i32$0 = $28$hi;
                        i64toi32_i32$1 = $18;
                        HEAP32[i64toi32_i32$1 >> 2] = $28;
                        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                        i64toi32_i32$0 = $37$hi;
                        i64toi32_i32$1 = $2;
                        HEAP32[($2 + 440 | 0) >> 2] = $37;
                        HEAP32[($2 + 444 | 0) >> 2] = i64toi32_i32$0;
                        i64toi32_i32$4 = $2;
                        i64toi32_i32$0 = HEAP32[($2 + 400 | 0) >> 2] | 0;
                        i64toi32_i32$1 = HEAP32[($2 + 404 | 0) >> 2] | 0;
                        $2006 = i64toi32_i32$0;
                        i64toi32_i32$0 = $2 + 465 | 0;
                        $374 = $2006;
                        HEAP8[i64toi32_i32$0 >> 0] = $374;
                        HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $374 >>> 8 | 0;
                        HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $374 >>> 16 | 0;
                        HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $374 >>> 24 | 0;
                        HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
                        HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
                        HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
                        HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
                        i64toi32_i32$4 = $2;
                        i64toi32_i32$1 = HEAPU8[($2 + 407 | 0) >> 0] | 0 | ((HEAPU8[($2 + 408 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 409 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 410 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                        i64toi32_i32$0 = HEAPU8[($2 + 411 | 0) >> 0] | 0 | ((HEAPU8[($2 + 412 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 413 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 414 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                        $2009 = i64toi32_i32$1;
                        i64toi32_i32$1 = $3;
                        $375 = $2009;
                        HEAP8[i64toi32_i32$1 >> 0] = $375;
                        HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $375 >>> 8 | 0;
                        HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $375 >>> 16 | 0;
                        HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $375 >>> 24 | 0;
                        HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
                        HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                        HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
                        HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
                        HEAP32[($2 + 488 | 0) >> 2] = $8;
                        i64toi32_i32$4 = $2;
                        i64toi32_i32$0 = HEAP32[($2 + 312 | 0) >> 2] | 0;
                        i64toi32_i32$1 = HEAP32[($2 + 316 | 0) >> 2] | 0;
                        $2015 = i64toi32_i32$0;
                        i64toi32_i32$0 = $2 + 492 | 0;
                        HEAP32[i64toi32_i32$0 >> 2] = $2015;
                        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
                        HEAP32[($2 + 500 | 0) >> 2] = HEAP32[$7 >> 2] | 0;
                        cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($10 | 0, $2 + 440 | 0 | 0, 1050461 | 0, 3 | 0);
                        HEAP32[(($2 + 24 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 328 | 0) + 68 | 0) >> 2] | 0;
                        i64toi32_i32$4 = $2;
                        i64toi32_i32$1 = HEAP32[($2 + 388 | 0) >> 2] | 0;
                        i64toi32_i32$0 = HEAP32[($2 + 392 | 0) >> 2] | 0;
                        $2032 = i64toi32_i32$1;
                        i64toi32_i32$1 = $2;
                        HEAP32[($2 + 24 | 0) >> 2] = $2032;
                        HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$0;
                        i64toi32_i32$4 = $2;
                        i64toi32_i32$0 = HEAP32[($2 + 336 | 0) >> 2] | 0;
                        i64toi32_i32$1 = HEAP32[($2 + 340 | 0) >> 2] | 0;
                        $28 = i64toi32_i32$0;
                        $28$hi = i64toi32_i32$1;
                        i64toi32_i32$4 = i64toi32_i32$0;
                        i64toi32_i32$0 = -1;
                        i64toi32_i32$3 = -256;
                        i64toi32_i32$0 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
                        $29 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
                        $29$hi = i64toi32_i32$0;
                        i64toi32_i32$1 = ($2 + 328 | 0) + 16 | 0;
                        i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                        i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                        $31 = i64toi32_i32$0;
                        $31$hi = i64toi32_i32$4;
                        i64toi32_i32$1 = ($2 + 328 | 0) + 24 | 0;
                        i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                        i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                        $30 = i64toi32_i32$4;
                        $30$hi = i64toi32_i32$0;
                        i64toi32_i32$1 = ($2 + 328 | 0) + 32 | 0;
                        i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                        i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                        $25 = i64toi32_i32$0;
                        $25$hi = i64toi32_i32$4;
                        i64toi32_i32$1 = ($2 + 328 | 0) + 40 | 0;
                        i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                        i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                        $32 = i64toi32_i32$4;
                        $32$hi = i64toi32_i32$0;
                        i64toi32_i32$1 = ($2 + 328 | 0) + 48 | 0;
                        i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                        i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                        $33 = i64toi32_i32$0;
                        $33$hi = i64toi32_i32$4;
                        $8 = HEAP32[(($2 + 328 | 0) + 56 | 0) >> 2] | 0;
                        break label$3;
                       }
                       cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__TransactionOutputs___deserialize__h3f9df29df082d970($2 + 440 | 0 | 0, $1 | 0);
                       label$87 : {
                        if ((HEAP32[($2 + 440 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                         break label$87
                        }
                        i64toi32_i32$1 = ($2 + 440 | 0) + 15 | 0;
                        i64toi32_i32$4 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
                        i64toi32_i32$0 = 0;
                        HEAP8[(($2 + 328 | 0) + 15 | 0) >> 0] = i64toi32_i32$4;
                        i64toi32_i32$1 = ($2 + 440 | 0) + 13 | 0;
                        i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
                        i64toi32_i32$4 = 0;
                        $475 = ($2 + 328 | 0) + 13 | 0;
                        HEAP8[$475 >> 0] = i64toi32_i32$0;
                        HEAP8[($475 + 1 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                        i64toi32_i32$1 = $2;
                        i64toi32_i32$4 = HEAPU8[($2 + 449 | 0) >> 0] | 0 | ((HEAPU8[($2 + 450 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 451 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 452 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                        i64toi32_i32$0 = 0;
                        HEAP8[($2 + 337 | 0) >> 0] = i64toi32_i32$4;
                        HEAP8[($2 + 338 | 0) >> 0] = i64toi32_i32$4 >>> 8 | 0;
                        HEAP8[($2 + 339 | 0) >> 0] = i64toi32_i32$4 >>> 16 | 0;
                        HEAP8[($2 + 340 | 0) >> 0] = i64toi32_i32$4 >>> 24 | 0;
                        HEAP8[($2 + 336 | 0) >> 0] = HEAPU8[($2 + 448 | 0) >> 0] | 0;
                        HEAP32[($2 + 104 | 0) >> 2] = HEAP32[($2 + 444 | 0) >> 2] | 0;
                        i64toi32_i32$1 = $2;
                        i64toi32_i32$0 = HEAP32[($2 + 336 | 0) >> 2] | 0;
                        i64toi32_i32$4 = HEAP32[($2 + 340 | 0) >> 2] | 0;
                        $2092 = i64toi32_i32$0;
                        i64toi32_i32$0 = $2;
                        HEAP32[($2 + 108 | 0) >> 2] = $2092;
                        HEAP32[($2 + 112 | 0) >> 2] = i64toi32_i32$4;
                        break label$12;
                       }
                       $1 = ($2 + 424 | 0) + 8 | 0;
                       HEAP32[$1 >> 2] = HEAP32[(($2 + 440 | 0) + 68 | 0) >> 2] | 0;
                       i64toi32_i32$1 = $2;
                       i64toi32_i32$4 = HEAPU8[($2 + 473 | 0) >> 0] | 0 | ((HEAPU8[($2 + 474 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 475 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 476 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                       i64toi32_i32$0 = HEAPU8[($2 + 477 | 0) >> 0] | 0 | ((HEAPU8[($2 + 478 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 479 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 480 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                       $2103 = i64toi32_i32$4;
                       i64toi32_i32$4 = $2;
                       HEAP32[($2 + 24 | 0) >> 2] = $2103;
                       HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$0;
                       $18 = ($2 + 440 | 0) + 40 | 0;
                       i64toi32_i32$1 = $18;
                       i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                       i64toi32_i32$4 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                       $2109 = i64toi32_i32$0;
                       i64toi32_i32$0 = $2;
                       $376 = $2109;
                       HEAP8[($2 + 31 | 0) >> 0] = $376;
                       HEAP8[($2 + 32 | 0) >> 0] = $376 >>> 8 | 0;
                       HEAP8[($2 + 33 | 0) >> 0] = $376 >>> 16 | 0;
                       HEAP8[($2 + 34 | 0) >> 0] = $376 >>> 24 | 0;
                       HEAP8[($2 + 35 | 0) >> 0] = i64toi32_i32$4;
                       HEAP8[($2 + 36 | 0) >> 0] = i64toi32_i32$4 >>> 8 | 0;
                       HEAP8[($2 + 37 | 0) >> 0] = i64toi32_i32$4 >>> 16 | 0;
                       HEAP8[($2 + 38 | 0) >> 0] = i64toi32_i32$4 >>> 24 | 0;
                       $8 = ($2 + 440 | 0) + 60 | 0;
                       i64toi32_i32$1 = $8;
                       i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                       i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                       $2115 = i64toi32_i32$4;
                       i64toi32_i32$4 = $2;
                       HEAP32[($2 + 424 | 0) >> 2] = $2115;
                       HEAP32[($2 + 428 | 0) >> 2] = i64toi32_i32$0;
                       i64toi32_i32$1 = $2;
                       i64toi32_i32$0 = HEAP32[($2 + 24 | 0) >> 2] | 0;
                       i64toi32_i32$4 = HEAP32[($2 + 28 | 0) >> 2] | 0;
                       $2118 = i64toi32_i32$0;
                       i64toi32_i32$0 = $2;
                       HEAP32[($2 + 400 | 0) >> 2] = $2118;
                       HEAP32[($2 + 404 | 0) >> 2] = i64toi32_i32$4;
                       i64toi32_i32$1 = $2;
                       i64toi32_i32$4 = HEAPU8[($2 + 31 | 0) >> 0] | 0 | ((HEAPU8[($2 + 32 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 33 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 34 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                       i64toi32_i32$0 = HEAPU8[($2 + 35 | 0) >> 0] | 0 | ((HEAPU8[($2 + 36 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 37 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 38 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                       $2121 = i64toi32_i32$4;
                       i64toi32_i32$4 = $2;
                       $377 = $2121;
                       HEAP8[($2 + 407 | 0) >> 0] = $377;
                       HEAP8[($2 + 408 | 0) >> 0] = $377 >>> 8 | 0;
                       HEAP8[($2 + 409 | 0) >> 0] = $377 >>> 16 | 0;
                       HEAP8[($2 + 410 | 0) >> 0] = $377 >>> 24 | 0;
                       HEAP8[($2 + 411 | 0) >> 0] = i64toi32_i32$0;
                       HEAP8[($2 + 412 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                       HEAP8[($2 + 413 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
                       HEAP8[($2 + 414 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
                       $5 = HEAP32[(($2 + 440 | 0) + 56 | 0) >> 2] | 0;
                       i64toi32_i32$1 = $2 + 453 | 0;
                       i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
                       i64toi32_i32$4 = 0;
                       $28 = i64toi32_i32$0;
                       $28$hi = i64toi32_i32$4;
                       i64toi32_i32$1 = $2 + 455 | 0;
                       i64toi32_i32$4 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
                       i64toi32_i32$0 = 0;
                       $25 = i64toi32_i32$4;
                       $25$hi = i64toi32_i32$0;
                       i64toi32_i32$1 = ($2 + 440 | 0) + 48 | 0;
                       i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                       i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                       $22 = i64toi32_i32$0;
                       $22$hi = i64toi32_i32$4;
                       $4 = ($2 + 440 | 0) + 16 | 0;
                       i64toi32_i32$1 = $4;
                       i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                       i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                       $34 = i64toi32_i32$4;
                       $34$hi = i64toi32_i32$0;
                       $3 = ($2 + 440 | 0) + 24 | 0;
                       i64toi32_i32$1 = $3;
                       i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                       i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                       $31 = i64toi32_i32$0;
                       $31$hi = i64toi32_i32$4;
                       $6 = ($2 + 440 | 0) + 32 | 0;
                       $7 = HEAPU8[$6 >> 0] | 0;
                       $12 = HEAPU8[($2 + 448 | 0) >> 0] | 0;
                       i64toi32_i32$1 = $2;
                       i64toi32_i32$4 = HEAPU8[($2 + 449 | 0) >> 0] | 0 | ((HEAPU8[($2 + 450 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 451 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 452 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                       i64toi32_i32$0 = 0;
                       $30 = i64toi32_i32$4;
                       $30$hi = i64toi32_i32$0;
                       $13 = ($2 + 312 | 0) + 8 | 0;
                       HEAP32[$13 >> 2] = HEAP32[$1 >> 2] | 0;
                       i64toi32_i32$1 = $2;
                       i64toi32_i32$0 = HEAP32[($2 + 424 | 0) >> 2] | 0;
                       i64toi32_i32$4 = HEAP32[($2 + 428 | 0) >> 2] | 0;
                       $2163 = i64toi32_i32$0;
                       i64toi32_i32$0 = $2;
                       HEAP32[($2 + 312 | 0) >> 2] = $2163;
                       HEAP32[($2 + 316 | 0) >> 2] = i64toi32_i32$4;
                       HEAP8[$3 >> 0] = $7;
                       i64toi32_i32$4 = $31$hi;
                       i64toi32_i32$0 = $4;
                       HEAP32[i64toi32_i32$0 >> 2] = $31;
                       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$4;
                       i64toi32_i32$4 = $34$hi;
                       i64toi32_i32$0 = ($2 + 440 | 0) + 8 | 0;
                       HEAP32[i64toi32_i32$0 >> 2] = $34;
                       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$4;
                       i64toi32_i32$4 = $22$hi;
                       i64toi32_i32$0 = $18;
                       HEAP32[i64toi32_i32$0 >> 2] = $22;
                       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$4;
                       i64toi32_i32$4 = $25$hi;
                       HEAP8[($2 + 447 | 0) >> 0] = $25;
                       i64toi32_i32$4 = $28$hi;
                       HEAP8[($2 + 445 | 0) >> 0] = $28;
                       HEAP8[($2 + 446 | 0) >> 0] = $28 >>> 8 | 0;
                       i64toi32_i32$4 = $30$hi;
                       HEAP8[($2 + 441 | 0) >> 0] = $30;
                       HEAP8[($2 + 442 | 0) >> 0] = $30 >>> 8 | 0;
                       HEAP8[($2 + 443 | 0) >> 0] = $30 >>> 16 | 0;
                       HEAP8[($2 + 444 | 0) >> 0] = $30 >>> 24 | 0;
                       HEAP8[($2 + 440 | 0) >> 0] = $12;
                       i64toi32_i32$1 = $2;
                       i64toi32_i32$4 = HEAP32[($2 + 400 | 0) >> 2] | 0;
                       i64toi32_i32$0 = HEAP32[($2 + 404 | 0) >> 2] | 0;
                       $2185 = i64toi32_i32$4;
                       i64toi32_i32$4 = $2 + 465 | 0;
                       $378 = $2185;
                       HEAP8[i64toi32_i32$4 >> 0] = $378;
                       HEAP8[(i64toi32_i32$4 + 1 | 0) >> 0] = $378 >>> 8 | 0;
                       HEAP8[(i64toi32_i32$4 + 2 | 0) >> 0] = $378 >>> 16 | 0;
                       HEAP8[(i64toi32_i32$4 + 3 | 0) >> 0] = $378 >>> 24 | 0;
                       HEAP8[(i64toi32_i32$4 + 4 | 0) >> 0] = i64toi32_i32$0;
                       HEAP8[(i64toi32_i32$4 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                       HEAP8[(i64toi32_i32$4 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
                       HEAP8[(i64toi32_i32$4 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
                       i64toi32_i32$1 = $2;
                       i64toi32_i32$0 = HEAPU8[($2 + 407 | 0) >> 0] | 0 | ((HEAPU8[($2 + 408 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 409 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 410 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                       i64toi32_i32$4 = HEAPU8[($2 + 411 | 0) >> 0] | 0 | ((HEAPU8[($2 + 412 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 413 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 414 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                       $2188 = i64toi32_i32$0;
                       i64toi32_i32$0 = $6;
                       $379 = $2188;
                       HEAP8[i64toi32_i32$0 >> 0] = $379;
                       HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $379 >>> 8 | 0;
                       HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $379 >>> 16 | 0;
                       HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $379 >>> 24 | 0;
                       HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$4;
                       HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$4 >>> 8 | 0;
                       HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$4 >>> 16 | 0;
                       HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$4 >>> 24 | 0;
                       HEAP32[($2 + 488 | 0) >> 2] = $5;
                       i64toi32_i32$1 = $2;
                       i64toi32_i32$4 = HEAP32[($2 + 312 | 0) >> 2] | 0;
                       i64toi32_i32$0 = HEAP32[($2 + 316 | 0) >> 2] | 0;
                       $2194 = i64toi32_i32$4;
                       i64toi32_i32$4 = $2 + 492 | 0;
                       HEAP32[i64toi32_i32$4 >> 2] = $2194;
                       HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$0;
                       HEAP32[$8 >> 2] = HEAP32[$13 >> 2] | 0;
                       cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($10 | 0, $2 + 440 | 0 | 0, 1050454 | 0, 7 | 0);
                       HEAP32[(($2 + 24 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 328 | 0) + 68 | 0) >> 2] | 0;
                       i64toi32_i32$1 = ($2 + 328 | 0) + 60 | 0;
                       i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                       i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                       $2212 = i64toi32_i32$0;
                       i64toi32_i32$0 = $2;
                       HEAP32[($2 + 24 | 0) >> 2] = $2212;
                       HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$4;
                       i64toi32_i32$1 = $2;
                       i64toi32_i32$4 = HEAP32[($2 + 336 | 0) >> 2] | 0;
                       i64toi32_i32$0 = HEAP32[($2 + 340 | 0) >> 2] | 0;
                       $28 = i64toi32_i32$4;
                       $28$hi = i64toi32_i32$0;
                       i64toi32_i32$1 = i64toi32_i32$4;
                       i64toi32_i32$4 = -1;
                       i64toi32_i32$3 = -256;
                       i64toi32_i32$4 = i64toi32_i32$0 & i64toi32_i32$4 | 0;
                       $29 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
                       $29$hi = i64toi32_i32$4;
                       i64toi32_i32$0 = ($2 + 328 | 0) + 16 | 0;
                       i64toi32_i32$4 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                       i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                       $31 = i64toi32_i32$4;
                       $31$hi = i64toi32_i32$1;
                       i64toi32_i32$0 = ($2 + 328 | 0) + 24 | 0;
                       i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                       i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                       $30 = i64toi32_i32$1;
                       $30$hi = i64toi32_i32$4;
                       i64toi32_i32$0 = ($2 + 328 | 0) + 32 | 0;
                       i64toi32_i32$4 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                       i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                       $25 = i64toi32_i32$4;
                       $25$hi = i64toi32_i32$1;
                       i64toi32_i32$0 = ($2 + 328 | 0) + 40 | 0;
                       i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                       i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                       $32 = i64toi32_i32$1;
                       $32$hi = i64toi32_i32$4;
                       i64toi32_i32$0 = ($2 + 328 | 0) + 48 | 0;
                       i64toi32_i32$4 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                       i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                       $33 = i64toi32_i32$4;
                       $33$hi = i64toi32_i32$1;
                       $8 = HEAP32[(($2 + 328 | 0) + 56 | 0) >> 2] | 0;
                       break label$3;
                      }
                      cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__TransactionInputs___deserialize__hccdd71f9bd7c3281($2 + 440 | 0 | 0, $1 | 0);
                      label$88 : {
                       if ((HEAP32[($2 + 440 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                        break label$88
                       }
                       i64toi32_i32$0 = ($2 + 440 | 0) + 15 | 0;
                       i64toi32_i32$1 = HEAPU8[i64toi32_i32$0 >> 0] | 0;
                       i64toi32_i32$4 = 0;
                       HEAP8[(($2 + 328 | 0) + 15 | 0) >> 0] = i64toi32_i32$1;
                       i64toi32_i32$0 = ($2 + 440 | 0) + 13 | 0;
                       i64toi32_i32$4 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
                       i64toi32_i32$1 = 0;
                       $476 = ($2 + 328 | 0) + 13 | 0;
                       HEAP8[$476 >> 0] = i64toi32_i32$4;
                       HEAP8[($476 + 1 | 0) >> 0] = i64toi32_i32$4 >>> 8 | 0;
                       i64toi32_i32$0 = $2;
                       i64toi32_i32$1 = HEAPU8[($2 + 449 | 0) >> 0] | 0 | ((HEAPU8[($2 + 450 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 451 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 452 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                       i64toi32_i32$4 = 0;
                       HEAP8[($2 + 337 | 0) >> 0] = i64toi32_i32$1;
                       HEAP8[($2 + 338 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
                       HEAP8[($2 + 339 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
                       HEAP8[($2 + 340 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
                       HEAP8[($2 + 336 | 0) >> 0] = HEAPU8[($2 + 448 | 0) >> 0] | 0;
                       HEAP32[($2 + 88 | 0) >> 2] = HEAP32[($2 + 444 | 0) >> 2] | 0;
                       i64toi32_i32$0 = $2;
                       i64toi32_i32$4 = HEAP32[($2 + 336 | 0) >> 2] | 0;
                       i64toi32_i32$1 = HEAP32[($2 + 340 | 0) >> 2] | 0;
                       $2272 = i64toi32_i32$4;
                       i64toi32_i32$4 = $2;
                       HEAP32[($2 + 92 | 0) >> 2] = $2272;
                       HEAP32[($2 + 96 | 0) >> 2] = i64toi32_i32$1;
                       break label$12;
                      }
                      $1 = ($2 + 424 | 0) + 8 | 0;
                      HEAP32[$1 >> 2] = HEAP32[(($2 + 440 | 0) + 68 | 0) >> 2] | 0;
                      i64toi32_i32$0 = $2;
                      i64toi32_i32$1 = HEAPU8[($2 + 473 | 0) >> 0] | 0 | ((HEAPU8[($2 + 474 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 475 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 476 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                      i64toi32_i32$4 = HEAPU8[($2 + 477 | 0) >> 0] | 0 | ((HEAPU8[($2 + 478 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 479 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 480 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                      $2283 = i64toi32_i32$1;
                      i64toi32_i32$1 = $2;
                      HEAP32[($2 + 24 | 0) >> 2] = $2283;
                      HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$4;
                      $18 = ($2 + 440 | 0) + 40 | 0;
                      i64toi32_i32$0 = $18;
                      i64toi32_i32$4 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                      $2289 = i64toi32_i32$4;
                      i64toi32_i32$4 = $2;
                      $380 = $2289;
                      HEAP8[($2 + 31 | 0) >> 0] = $380;
                      HEAP8[($2 + 32 | 0) >> 0] = $380 >>> 8 | 0;
                      HEAP8[($2 + 33 | 0) >> 0] = $380 >>> 16 | 0;
                      HEAP8[($2 + 34 | 0) >> 0] = $380 >>> 24 | 0;
                      HEAP8[($2 + 35 | 0) >> 0] = i64toi32_i32$1;
                      HEAP8[($2 + 36 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
                      HEAP8[($2 + 37 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
                      HEAP8[($2 + 38 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
                      $8 = ($2 + 440 | 0) + 60 | 0;
                      i64toi32_i32$0 = $8;
                      i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                      i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                      $2295 = i64toi32_i32$1;
                      i64toi32_i32$1 = $2;
                      HEAP32[($2 + 424 | 0) >> 2] = $2295;
                      HEAP32[($2 + 428 | 0) >> 2] = i64toi32_i32$4;
                      i64toi32_i32$0 = $2;
                      i64toi32_i32$4 = HEAP32[($2 + 24 | 0) >> 2] | 0;
                      i64toi32_i32$1 = HEAP32[($2 + 28 | 0) >> 2] | 0;
                      $2298 = i64toi32_i32$4;
                      i64toi32_i32$4 = $2;
                      HEAP32[($2 + 400 | 0) >> 2] = $2298;
                      HEAP32[($2 + 404 | 0) >> 2] = i64toi32_i32$1;
                      i64toi32_i32$0 = $2;
                      i64toi32_i32$1 = HEAPU8[($2 + 31 | 0) >> 0] | 0 | ((HEAPU8[($2 + 32 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 33 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 34 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                      i64toi32_i32$4 = HEAPU8[($2 + 35 | 0) >> 0] | 0 | ((HEAPU8[($2 + 36 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 37 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 38 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                      $2301 = i64toi32_i32$1;
                      i64toi32_i32$1 = $2;
                      $381 = $2301;
                      HEAP8[($2 + 407 | 0) >> 0] = $381;
                      HEAP8[($2 + 408 | 0) >> 0] = $381 >>> 8 | 0;
                      HEAP8[($2 + 409 | 0) >> 0] = $381 >>> 16 | 0;
                      HEAP8[($2 + 410 | 0) >> 0] = $381 >>> 24 | 0;
                      HEAP8[($2 + 411 | 0) >> 0] = i64toi32_i32$4;
                      HEAP8[($2 + 412 | 0) >> 0] = i64toi32_i32$4 >>> 8 | 0;
                      HEAP8[($2 + 413 | 0) >> 0] = i64toi32_i32$4 >>> 16 | 0;
                      HEAP8[($2 + 414 | 0) >> 0] = i64toi32_i32$4 >>> 24 | 0;
                      $5 = HEAP32[(($2 + 440 | 0) + 56 | 0) >> 2] | 0;
                      i64toi32_i32$0 = $2 + 453 | 0;
                      i64toi32_i32$4 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
                      i64toi32_i32$1 = 0;
                      $28 = i64toi32_i32$4;
                      $28$hi = i64toi32_i32$1;
                      i64toi32_i32$0 = $2 + 455 | 0;
                      i64toi32_i32$1 = HEAPU8[i64toi32_i32$0 >> 0] | 0;
                      i64toi32_i32$4 = 0;
                      $25 = i64toi32_i32$1;
                      $25$hi = i64toi32_i32$4;
                      i64toi32_i32$0 = ($2 + 440 | 0) + 48 | 0;
                      i64toi32_i32$4 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                      i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                      $22 = i64toi32_i32$4;
                      $22$hi = i64toi32_i32$1;
                      $4 = ($2 + 440 | 0) + 16 | 0;
                      i64toi32_i32$0 = $4;
                      i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                      i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                      $34 = i64toi32_i32$1;
                      $34$hi = i64toi32_i32$4;
                      $3 = ($2 + 440 | 0) + 24 | 0;
                      i64toi32_i32$0 = $3;
                      i64toi32_i32$4 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                      i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                      $31 = i64toi32_i32$4;
                      $31$hi = i64toi32_i32$1;
                      $6 = ($2 + 440 | 0) + 32 | 0;
                      $7 = HEAPU8[$6 >> 0] | 0;
                      $12 = HEAPU8[($2 + 448 | 0) >> 0] | 0;
                      i64toi32_i32$0 = $2;
                      i64toi32_i32$1 = HEAPU8[($2 + 449 | 0) >> 0] | 0 | ((HEAPU8[($2 + 450 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 451 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 452 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                      i64toi32_i32$4 = 0;
                      $30 = i64toi32_i32$1;
                      $30$hi = i64toi32_i32$4;
                      $13 = ($2 + 312 | 0) + 8 | 0;
                      HEAP32[$13 >> 2] = HEAP32[$1 >> 2] | 0;
                      i64toi32_i32$0 = $2;
                      i64toi32_i32$4 = HEAP32[($2 + 424 | 0) >> 2] | 0;
                      i64toi32_i32$1 = HEAP32[($2 + 428 | 0) >> 2] | 0;
                      $2343 = i64toi32_i32$4;
                      i64toi32_i32$4 = $2;
                      HEAP32[($2 + 312 | 0) >> 2] = $2343;
                      HEAP32[($2 + 316 | 0) >> 2] = i64toi32_i32$1;
                      HEAP8[$3 >> 0] = $7;
                      i64toi32_i32$1 = $31$hi;
                      i64toi32_i32$4 = $4;
                      HEAP32[i64toi32_i32$4 >> 2] = $31;
                      HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$1;
                      i64toi32_i32$1 = $34$hi;
                      i64toi32_i32$4 = ($2 + 440 | 0) + 8 | 0;
                      HEAP32[i64toi32_i32$4 >> 2] = $34;
                      HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$1;
                      i64toi32_i32$1 = $22$hi;
                      i64toi32_i32$4 = $18;
                      HEAP32[i64toi32_i32$4 >> 2] = $22;
                      HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$1;
                      i64toi32_i32$1 = $25$hi;
                      HEAP8[($2 + 447 | 0) >> 0] = $25;
                      i64toi32_i32$1 = $28$hi;
                      HEAP8[($2 + 445 | 0) >> 0] = $28;
                      HEAP8[($2 + 446 | 0) >> 0] = $28 >>> 8 | 0;
                      i64toi32_i32$1 = $30$hi;
                      HEAP8[($2 + 441 | 0) >> 0] = $30;
                      HEAP8[($2 + 442 | 0) >> 0] = $30 >>> 8 | 0;
                      HEAP8[($2 + 443 | 0) >> 0] = $30 >>> 16 | 0;
                      HEAP8[($2 + 444 | 0) >> 0] = $30 >>> 24 | 0;
                      HEAP8[($2 + 440 | 0) >> 0] = $12;
                      i64toi32_i32$0 = $2;
                      i64toi32_i32$1 = HEAP32[($2 + 400 | 0) >> 2] | 0;
                      i64toi32_i32$4 = HEAP32[($2 + 404 | 0) >> 2] | 0;
                      $2365 = i64toi32_i32$1;
                      i64toi32_i32$1 = $2 + 465 | 0;
                      $382 = $2365;
                      HEAP8[i64toi32_i32$1 >> 0] = $382;
                      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $382 >>> 8 | 0;
                      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $382 >>> 16 | 0;
                      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $382 >>> 24 | 0;
                      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$4;
                      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$4 >>> 8 | 0;
                      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$4 >>> 16 | 0;
                      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$4 >>> 24 | 0;
                      i64toi32_i32$0 = $2;
                      i64toi32_i32$4 = HEAPU8[($2 + 407 | 0) >> 0] | 0 | ((HEAPU8[($2 + 408 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 409 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 410 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                      i64toi32_i32$1 = HEAPU8[($2 + 411 | 0) >> 0] | 0 | ((HEAPU8[($2 + 412 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 413 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 414 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                      $2368 = i64toi32_i32$4;
                      i64toi32_i32$4 = $6;
                      $383 = $2368;
                      HEAP8[i64toi32_i32$4 >> 0] = $383;
                      HEAP8[(i64toi32_i32$4 + 1 | 0) >> 0] = $383 >>> 8 | 0;
                      HEAP8[(i64toi32_i32$4 + 2 | 0) >> 0] = $383 >>> 16 | 0;
                      HEAP8[(i64toi32_i32$4 + 3 | 0) >> 0] = $383 >>> 24 | 0;
                      HEAP8[(i64toi32_i32$4 + 4 | 0) >> 0] = i64toi32_i32$1;
                      HEAP8[(i64toi32_i32$4 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
                      HEAP8[(i64toi32_i32$4 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
                      HEAP8[(i64toi32_i32$4 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
                      HEAP32[($2 + 488 | 0) >> 2] = $5;
                      i64toi32_i32$0 = $2;
                      i64toi32_i32$1 = HEAP32[($2 + 312 | 0) >> 2] | 0;
                      i64toi32_i32$4 = HEAP32[($2 + 316 | 0) >> 2] | 0;
                      $2374 = i64toi32_i32$1;
                      i64toi32_i32$1 = $2 + 492 | 0;
                      HEAP32[i64toi32_i32$1 >> 2] = $2374;
                      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$4;
                      HEAP32[$8 >> 2] = HEAP32[$13 >> 2] | 0;
                      cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($10 | 0, $2 + 440 | 0 | 0, 1050448 | 0, 6 | 0);
                      HEAP32[(($2 + 24 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 328 | 0) + 68 | 0) >> 2] | 0;
                      i64toi32_i32$0 = ($2 + 328 | 0) + 60 | 0;
                      i64toi32_i32$4 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                      i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                      $2392 = i64toi32_i32$4;
                      i64toi32_i32$4 = $2;
                      HEAP32[($2 + 24 | 0) >> 2] = $2392;
                      HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$1;
                      i64toi32_i32$0 = $2;
                      i64toi32_i32$1 = HEAP32[($2 + 336 | 0) >> 2] | 0;
                      i64toi32_i32$4 = HEAP32[($2 + 340 | 0) >> 2] | 0;
                      $28 = i64toi32_i32$1;
                      $28$hi = i64toi32_i32$4;
                      i64toi32_i32$0 = i64toi32_i32$1;
                      i64toi32_i32$1 = -1;
                      i64toi32_i32$3 = -256;
                      i64toi32_i32$1 = i64toi32_i32$4 & i64toi32_i32$1 | 0;
                      $29 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
                      $29$hi = i64toi32_i32$1;
                      i64toi32_i32$4 = ($2 + 328 | 0) + 16 | 0;
                      i64toi32_i32$1 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                      i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                      $31 = i64toi32_i32$1;
                      $31$hi = i64toi32_i32$0;
                      i64toi32_i32$4 = ($2 + 328 | 0) + 24 | 0;
                      i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                      i64toi32_i32$1 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                      $30 = i64toi32_i32$0;
                      $30$hi = i64toi32_i32$1;
                      i64toi32_i32$4 = ($2 + 328 | 0) + 32 | 0;
                      i64toi32_i32$1 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                      i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                      $25 = i64toi32_i32$1;
                      $25$hi = i64toi32_i32$0;
                      i64toi32_i32$4 = ($2 + 328 | 0) + 40 | 0;
                      i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                      i64toi32_i32$1 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                      $32 = i64toi32_i32$0;
                      $32$hi = i64toi32_i32$1;
                      i64toi32_i32$4 = ($2 + 328 | 0) + 48 | 0;
                      i64toi32_i32$1 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                      i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                      $33 = i64toi32_i32$1;
                      $33$hi = i64toi32_i32$0;
                      $8 = HEAP32[(($2 + 328 | 0) + 56 | 0) >> 2] | 0;
                      break label$3;
                     }
                     i64toi32_i32$4 = $2;
                     i64toi32_i32$0 = HEAPU8[($2 + 449 | 0) >> 0] | 0 | ((HEAPU8[($2 + 450 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 451 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 452 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                     i64toi32_i32$1 = 0;
                     $2422 = i64toi32_i32$0;
                     $2422$hi = i64toi32_i32$1;
                     i64toi32_i32$4 = $2 + 453 | 0;
                     i64toi32_i32$1 = HEAPU8[i64toi32_i32$4 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$4 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
                     i64toi32_i32$0 = 0;
                     $2425 = i64toi32_i32$1;
                     $2425$hi = i64toi32_i32$0;
                     i64toi32_i32$4 = $2 + 455 | 0;
                     i64toi32_i32$0 = HEAPU8[i64toi32_i32$4 >> 0] | 0;
                     i64toi32_i32$1 = 0;
                     i64toi32_i32$4 = i64toi32_i32$0;
                     i64toi32_i32$0 = 0;
                     i64toi32_i32$3 = 16;
                     i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
                     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                      i64toi32_i32$0 = i64toi32_i32$4 << i64toi32_i32$5 | 0;
                      $477 = 0;
                     } else {
                      i64toi32_i32$0 = ((1 << i64toi32_i32$5 | 0) - 1 | 0) & (i64toi32_i32$4 >>> (32 - i64toi32_i32$5 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$5 | 0) | 0;
                      $477 = i64toi32_i32$4 << i64toi32_i32$5 | 0;
                     }
                     $2429$hi = i64toi32_i32$0;
                     i64toi32_i32$0 = $2425$hi;
                     i64toi32_i32$1 = $2425;
                     i64toi32_i32$4 = $2429$hi;
                     i64toi32_i32$3 = $477;
                     i64toi32_i32$4 = i64toi32_i32$0 | i64toi32_i32$4 | 0;
                     i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
                     i64toi32_i32$1 = 0;
                     i64toi32_i32$3 = 32;
                     i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
                     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                      i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$5 | 0;
                      $478 = 0;
                     } else {
                      i64toi32_i32$1 = ((1 << i64toi32_i32$5 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$5 | 0) | 0) | 0 | (i64toi32_i32$4 << i64toi32_i32$5 | 0) | 0;
                      $478 = i64toi32_i32$0 << i64toi32_i32$5 | 0;
                     }
                     $2431$hi = i64toi32_i32$1;
                     i64toi32_i32$1 = $2422$hi;
                     i64toi32_i32$4 = $2422;
                     i64toi32_i32$0 = $2431$hi;
                     i64toi32_i32$3 = $478;
                     i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
                     i64toi32_i32$1 = i64toi32_i32$4 | i64toi32_i32$3 | 0;
                     i64toi32_i32$4 = 0;
                     i64toi32_i32$3 = 8;
                     i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
                     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                      i64toi32_i32$4 = i64toi32_i32$1 << i64toi32_i32$5 | 0;
                      $479 = 0;
                     } else {
                      i64toi32_i32$4 = ((1 << i64toi32_i32$5 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$5 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$5 | 0) | 0;
                      $479 = i64toi32_i32$1 << i64toi32_i32$5 | 0;
                     }
                     $2433$hi = i64toi32_i32$4;
                     i64toi32_i32$4 = 0;
                     i64toi32_i32$0 = $1;
                     i64toi32_i32$1 = 0;
                     i64toi32_i32$3 = 255;
                     i64toi32_i32$1 = i64toi32_i32$4 & i64toi32_i32$1 | 0;
                     $2436 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
                     $2436$hi = i64toi32_i32$1;
                     i64toi32_i32$1 = $2433$hi;
                     i64toi32_i32$4 = $479;
                     i64toi32_i32$0 = $2436$hi;
                     i64toi32_i32$3 = $2436;
                     i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
                     $31 = i64toi32_i32$4 | i64toi32_i32$3 | 0;
                     $31$hi = i64toi32_i32$0;
                     i64toi32_i32$1 = $2 + 480 | 0;
                     i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                     i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                     $33 = i64toi32_i32$0;
                     $33$hi = i64toi32_i32$4;
                     i64toi32_i32$1 = $2 + 472 | 0;
                     i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                     i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                     $32 = i64toi32_i32$4;
                     $32$hi = i64toi32_i32$0;
                     i64toi32_i32$1 = $2 + 464 | 0;
                     i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                     i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                     $25 = i64toi32_i32$0;
                     $25$hi = i64toi32_i32$4;
                     i64toi32_i32$1 = $2 + 456 | 0;
                     i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                     i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                     $30 = i64toi32_i32$4;
                     $30$hi = i64toi32_i32$0;
                     $8 = 0;
                     i64toi32_i32$0 = 0;
                     $29 = 0;
                     $29$hi = i64toi32_i32$0;
                    }
                    $15 = 0;
                    break label$3;
                   }
                   i64toi32_i32$1 = ($2 + 440 | 0) + 15 | 0;
                   i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
                   i64toi32_i32$4 = 0;
                   HEAP8[(($2 + 328 | 0) + 15 | 0) >> 0] = i64toi32_i32$0;
                   i64toi32_i32$1 = ($2 + 440 | 0) + 13 | 0;
                   i64toi32_i32$4 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
                   i64toi32_i32$0 = 0;
                   $480 = ($2 + 328 | 0) + 13 | 0;
                   HEAP8[$480 >> 0] = i64toi32_i32$4;
                   HEAP8[($480 + 1 | 0) >> 0] = i64toi32_i32$4 >>> 8 | 0;
                   i64toi32_i32$1 = $2;
                   i64toi32_i32$0 = HEAPU8[($2 + 449 | 0) >> 0] | 0 | ((HEAPU8[($2 + 450 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 451 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 452 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                   i64toi32_i32$4 = 0;
                   HEAP8[($2 + 337 | 0) >> 0] = i64toi32_i32$0;
                   HEAP8[($2 + 338 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                   HEAP8[($2 + 339 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
                   HEAP8[($2 + 340 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
                   HEAP8[($2 + 336 | 0) >> 0] = HEAPU8[($2 + 448 | 0) >> 0] | 0;
                   HEAP32[($2 + 272 | 0) >> 2] = HEAP32[($2 + 444 | 0) >> 2] | 0;
                   i64toi32_i32$1 = $2;
                   i64toi32_i32$4 = HEAP32[($2 + 336 | 0) >> 2] | 0;
                   i64toi32_i32$0 = HEAP32[($2 + 340 | 0) >> 2] | 0;
                   $2475 = i64toi32_i32$4;
                   i64toi32_i32$4 = $2;
                   HEAP32[($2 + 276 | 0) >> 2] = $2475;
                   HEAP32[($2 + 280 | 0) >> 2] = i64toi32_i32$0;
                   break label$12;
                  }
                  i64toi32_i32$1 = ($2 + 440 | 0) + 15 | 0;
                  i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
                  i64toi32_i32$4 = 0;
                  HEAP8[(($2 + 328 | 0) + 15 | 0) >> 0] = i64toi32_i32$0;
                  i64toi32_i32$1 = ($2 + 440 | 0) + 13 | 0;
                  i64toi32_i32$4 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
                  i64toi32_i32$0 = 0;
                  $481 = ($2 + 328 | 0) + 13 | 0;
                  HEAP8[$481 >> 0] = i64toi32_i32$4;
                  HEAP8[($481 + 1 | 0) >> 0] = i64toi32_i32$4 >>> 8 | 0;
                  i64toi32_i32$1 = $2;
                  i64toi32_i32$0 = HEAPU8[($2 + 449 | 0) >> 0] | 0 | ((HEAPU8[($2 + 450 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 451 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 452 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                  i64toi32_i32$4 = 0;
                  HEAP8[($2 + 337 | 0) >> 0] = i64toi32_i32$0;
                  HEAP8[($2 + 338 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                  HEAP8[($2 + 339 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
                  HEAP8[($2 + 340 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
                  HEAP8[($2 + 336 | 0) >> 0] = HEAPU8[($2 + 448 | 0) >> 0] | 0;
                  HEAP32[($2 + 256 | 0) >> 2] = HEAP32[($2 + 444 | 0) >> 2] | 0;
                  i64toi32_i32$1 = $2;
                  i64toi32_i32$4 = HEAP32[($2 + 336 | 0) >> 2] | 0;
                  i64toi32_i32$0 = HEAP32[($2 + 340 | 0) >> 2] | 0;
                  $2501 = i64toi32_i32$4;
                  i64toi32_i32$4 = $2;
                  HEAP32[($2 + 260 | 0) >> 2] = $2501;
                  HEAP32[($2 + 264 | 0) >> 2] = i64toi32_i32$0;
                  break label$12;
                 }
                 HEAP32[($2 + 416 | 0) >> 2] = HEAPU8[$14 >> 0] | 0 | ((HEAPU8[($14 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($14 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($14 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 $384 = $14 + 3 | 0;
                 $385 = HEAPU8[$384 >> 0] | 0 | ((HEAPU8[($384 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($384 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($384 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 HEAP8[($2 + 419 | 0) >> 0] = $385;
                 HEAP8[($2 + 420 | 0) >> 0] = $385 >>> 8 | 0;
                 HEAP8[($2 + 421 | 0) >> 0] = $385 >>> 16 | 0;
                 HEAP8[($2 + 422 | 0) >> 0] = $385 >>> 24 | 0;
                 i64toi32_i32$1 = ($2 + 440 | 0) + 13 | 0;
                 i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
                 i64toi32_i32$4 = 0;
                 $28 = i64toi32_i32$0;
                 $28$hi = i64toi32_i32$4;
                 i64toi32_i32$1 = ($2 + 440 | 0) + 15 | 0;
                 i64toi32_i32$4 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
                 i64toi32_i32$0 = 0;
                 $34 = i64toi32_i32$4;
                 $34$hi = i64toi32_i32$0;
                 i64toi32_i32$1 = $2;
                 i64toi32_i32$0 = HEAP32[($2 + 456 | 0) >> 2] | 0;
                 i64toi32_i32$4 = HEAP32[($2 + 460 | 0) >> 2] | 0;
                 $38 = i64toi32_i32$0;
                 $38$hi = i64toi32_i32$4;
                 i64toi32_i32$1 = $2;
                 i64toi32_i32$4 = HEAP32[($2 + 464 | 0) >> 2] | 0;
                 i64toi32_i32$0 = HEAP32[($2 + 468 | 0) >> 2] | 0;
                 $39 = i64toi32_i32$4;
                 $39$hi = i64toi32_i32$0;
                 $20 = HEAPU8[($2 + 472 | 0) >> 0] | 0;
                 $8 = HEAPU8[($2 + 448 | 0) >> 0] | 0;
                 i64toi32_i32$1 = $2;
                 i64toi32_i32$0 = HEAPU8[($2 + 449 | 0) >> 0] | 0 | ((HEAPU8[($2 + 450 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 451 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 452 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 i64toi32_i32$4 = 0;
                 $31 = i64toi32_i32$0;
                 $31$hi = i64toi32_i32$4;
                 $3 = $13 + 3 | 0;
                 $386 = HEAPU8[($2 + 419 | 0) >> 0] | 0 | ((HEAPU8[($2 + 420 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 421 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 422 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 HEAP8[$3 >> 0] = $386;
                 HEAP8[($3 + 1 | 0) >> 0] = $386 >>> 8 | 0;
                 HEAP8[($3 + 2 | 0) >> 0] = $386 >>> 16 | 0;
                 HEAP8[($3 + 3 | 0) >> 0] = $386 >>> 24 | 0;
                 $387 = HEAP32[($2 + 416 | 0) >> 2] | 0;
                 HEAP8[$13 >> 0] = $387;
                 HEAP8[($13 + 1 | 0) >> 0] = $387 >>> 8 | 0;
                 HEAP8[($13 + 2 | 0) >> 0] = $387 >>> 16 | 0;
                 HEAP8[($13 + 3 | 0) >> 0] = $387 >>> 24 | 0;
                 $19 = $12 + 3 | 0;
                 $388 = HEAPU8[$3 >> 0] | 0 | ((HEAPU8[($3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 HEAP8[$19 >> 0] = $388;
                 HEAP8[($19 + 1 | 0) >> 0] = $388 >>> 8 | 0;
                 HEAP8[($19 + 2 | 0) >> 0] = $388 >>> 16 | 0;
                 HEAP8[($19 + 3 | 0) >> 0] = $388 >>> 24 | 0;
                 $389 = HEAPU8[$13 >> 0] | 0 | ((HEAPU8[($13 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($13 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($13 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 HEAP8[$12 >> 0] = $389;
                 HEAP8[($12 + 1 | 0) >> 0] = $389 >>> 8 | 0;
                 HEAP8[($12 + 2 | 0) >> 0] = $389 >>> 16 | 0;
                 HEAP8[($12 + 3 | 0) >> 0] = $389 >>> 24 | 0;
                 i64toi32_i32$4 = $34$hi;
                 HEAP8[(($2 + 328 | 0) + 15 | 0) >> 0] = $34;
                 i64toi32_i32$4 = $28$hi;
                 $482 = ($2 + 328 | 0) + 13 | 0;
                 HEAP8[$482 >> 0] = $28;
                 HEAP8[($482 + 1 | 0) >> 0] = $28 >>> 8 | 0;
                 i64toi32_i32$4 = $31$hi;
                 HEAP8[($2 + 337 | 0) >> 0] = i64toi32_i32$0;
                 HEAP8[($2 + 338 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                 HEAP8[($2 + 339 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
                 HEAP8[($2 + 340 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
                 HEAP8[($2 + 336 | 0) >> 0] = $8;
                 $391 = HEAPU8[$19 >> 0] | 0 | ((HEAPU8[($19 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($19 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($19 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 HEAP8[($2 + 251 | 0) >> 0] = $391;
                 HEAP8[($2 + 252 | 0) >> 0] = $391 >>> 8 | 0;
                 HEAP8[($2 + 253 | 0) >> 0] = $391 >>> 16 | 0;
                 HEAP8[($2 + 254 | 0) >> 0] = $391 >>> 24 | 0;
                 HEAP32[($2 + 248 | 0) >> 2] = HEAPU8[$12 >> 0] | 0 | ((HEAPU8[($12 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($12 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($12 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 i64toi32_i32$1 = $2;
                 i64toi32_i32$4 = HEAP32[($2 + 336 | 0) >> 2] | 0;
                 i64toi32_i32$0 = HEAP32[($2 + 340 | 0) >> 2] | 0;
                 $40 = i64toi32_i32$4;
                 $40$hi = i64toi32_i32$0;
                 $3 = 1;
                 break label$12;
                }
                i64toi32_i32$1 = ($2 + 440 | 0) + 15 | 0;
                i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
                i64toi32_i32$4 = 0;
                HEAP8[(($2 + 328 | 0) + 15 | 0) >> 0] = i64toi32_i32$0;
                i64toi32_i32$1 = ($2 + 440 | 0) + 13 | 0;
                i64toi32_i32$4 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
                i64toi32_i32$0 = 0;
                $483 = ($2 + 328 | 0) + 13 | 0;
                HEAP8[$483 >> 0] = i64toi32_i32$4;
                HEAP8[($483 + 1 | 0) >> 0] = i64toi32_i32$4 >>> 8 | 0;
                i64toi32_i32$1 = $2;
                i64toi32_i32$0 = HEAPU8[($2 + 449 | 0) >> 0] | 0 | ((HEAPU8[($2 + 450 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 451 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 452 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                i64toi32_i32$4 = 0;
                HEAP8[($2 + 337 | 0) >> 0] = i64toi32_i32$0;
                HEAP8[($2 + 338 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                HEAP8[($2 + 339 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
                HEAP8[($2 + 340 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
                HEAP8[($2 + 336 | 0) >> 0] = HEAPU8[($2 + 448 | 0) >> 0] | 0;
                HEAP32[($2 + 236 | 0) >> 2] = HEAP32[($2 + 444 | 0) >> 2] | 0;
                HEAP32[($2 + 232 | 0) >> 2] = 1;
                i64toi32_i32$1 = $2;
                i64toi32_i32$4 = HEAP32[($2 + 336 | 0) >> 2] | 0;
                i64toi32_i32$0 = HEAP32[($2 + 340 | 0) >> 2] | 0;
                $2589 = i64toi32_i32$4;
                i64toi32_i32$4 = $2;
                HEAP32[($2 + 240 | 0) >> 2] = $2589;
                HEAP32[($2 + 244 | 0) >> 2] = i64toi32_i32$0;
                break label$12;
               }
               i64toi32_i32$0 = 0;
               $24 = 1;
               $24$hi = i64toi32_i32$0;
               break label$12;
              }
              HEAP32[($2 + 416 | 0) >> 2] = HEAPU8[$14 >> 0] | 0 | ((HEAPU8[($14 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($14 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($14 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              $392 = $14 + 3 | 0;
              $393 = HEAPU8[$392 >> 0] | 0 | ((HEAPU8[($392 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($392 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($392 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              HEAP8[($2 + 419 | 0) >> 0] = $393;
              HEAP8[($2 + 420 | 0) >> 0] = $393 >>> 8 | 0;
              HEAP8[($2 + 421 | 0) >> 0] = $393 >>> 16 | 0;
              HEAP8[($2 + 422 | 0) >> 0] = $393 >>> 24 | 0;
              i64toi32_i32$1 = ($2 + 440 | 0) + 13 | 0;
              i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
              i64toi32_i32$4 = 0;
              $28 = i64toi32_i32$0;
              $28$hi = i64toi32_i32$4;
              i64toi32_i32$1 = ($2 + 440 | 0) + 15 | 0;
              i64toi32_i32$4 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
              i64toi32_i32$0 = 0;
              $34 = i64toi32_i32$4;
              $34$hi = i64toi32_i32$0;
              i64toi32_i32$1 = $2;
              i64toi32_i32$0 = HEAP32[($2 + 456 | 0) >> 2] | 0;
              i64toi32_i32$4 = HEAP32[($2 + 460 | 0) >> 2] | 0;
              $41 = i64toi32_i32$0;
              $41$hi = i64toi32_i32$4;
              i64toi32_i32$1 = $2;
              i64toi32_i32$4 = HEAP32[($2 + 464 | 0) >> 2] | 0;
              i64toi32_i32$0 = HEAP32[($2 + 468 | 0) >> 2] | 0;
              $42 = i64toi32_i32$4;
              $42$hi = i64toi32_i32$0;
              $21 = HEAPU8[($2 + 472 | 0) >> 0] | 0;
              $8 = HEAPU8[($2 + 448 | 0) >> 0] | 0;
              i64toi32_i32$1 = $2;
              i64toi32_i32$0 = HEAPU8[($2 + 449 | 0) >> 0] | 0 | ((HEAPU8[($2 + 450 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 451 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 452 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              i64toi32_i32$4 = 0;
              $31 = i64toi32_i32$0;
              $31$hi = i64toi32_i32$4;
              $7 = $13 + 3 | 0;
              $394 = HEAPU8[($2 + 419 | 0) >> 0] | 0 | ((HEAPU8[($2 + 420 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 421 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 422 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              HEAP8[$7 >> 0] = $394;
              HEAP8[($7 + 1 | 0) >> 0] = $394 >>> 8 | 0;
              HEAP8[($7 + 2 | 0) >> 0] = $394 >>> 16 | 0;
              HEAP8[($7 + 3 | 0) >> 0] = $394 >>> 24 | 0;
              $395 = HEAP32[($2 + 416 | 0) >> 2] | 0;
              HEAP8[$13 >> 0] = $395;
              HEAP8[($13 + 1 | 0) >> 0] = $395 >>> 8 | 0;
              HEAP8[($13 + 2 | 0) >> 0] = $395 >>> 16 | 0;
              HEAP8[($13 + 3 | 0) >> 0] = $395 >>> 24 | 0;
              $19 = $12 + 3 | 0;
              $396 = HEAPU8[$7 >> 0] | 0 | ((HEAPU8[($7 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($7 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($7 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              HEAP8[$19 >> 0] = $396;
              HEAP8[($19 + 1 | 0) >> 0] = $396 >>> 8 | 0;
              HEAP8[($19 + 2 | 0) >> 0] = $396 >>> 16 | 0;
              HEAP8[($19 + 3 | 0) >> 0] = $396 >>> 24 | 0;
              $397 = HEAPU8[$13 >> 0] | 0 | ((HEAPU8[($13 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($13 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($13 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              HEAP8[$12 >> 0] = $397;
              HEAP8[($12 + 1 | 0) >> 0] = $397 >>> 8 | 0;
              HEAP8[($12 + 2 | 0) >> 0] = $397 >>> 16 | 0;
              HEAP8[($12 + 3 | 0) >> 0] = $397 >>> 24 | 0;
              i64toi32_i32$4 = $34$hi;
              HEAP8[(($2 + 328 | 0) + 15 | 0) >> 0] = $34;
              i64toi32_i32$4 = $28$hi;
              $484 = ($2 + 328 | 0) + 13 | 0;
              HEAP8[$484 >> 0] = $28;
              HEAP8[($484 + 1 | 0) >> 0] = $28 >>> 8 | 0;
              i64toi32_i32$4 = $31$hi;
              HEAP8[($2 + 337 | 0) >> 0] = i64toi32_i32$0;
              HEAP8[($2 + 338 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
              HEAP8[($2 + 339 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
              HEAP8[($2 + 340 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
              HEAP8[($2 + 336 | 0) >> 0] = $8;
              $398 = HEAPU8[$19 >> 0] | 0 | ((HEAPU8[($19 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($19 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($19 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              HEAP8[($2 + 227 | 0) >> 0] = $398;
              HEAP8[($2 + 228 | 0) >> 0] = $398 >>> 8 | 0;
              HEAP8[($2 + 229 | 0) >> 0] = $398 >>> 16 | 0;
              HEAP8[($2 + 230 | 0) >> 0] = $398 >>> 24 | 0;
              HEAP32[($2 + 224 | 0) >> 2] = HEAPU8[$12 >> 0] | 0 | ((HEAPU8[($12 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($12 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($12 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              i64toi32_i32$1 = $2;
              i64toi32_i32$4 = HEAP32[($2 + 336 | 0) >> 2] | 0;
              i64toi32_i32$0 = HEAP32[($2 + 340 | 0) >> 2] | 0;
              $43 = i64toi32_i32$4;
              $43$hi = i64toi32_i32$0;
              $7 = 1;
              break label$12;
             }
             i64toi32_i32$0 = $28$hi;
             HEAP8[($2 + 337 | 0) >> 0] = $28;
             HEAP8[($2 + 338 | 0) >> 0] = $28 >>> 8 | 0;
             HEAP8[($2 + 339 | 0) >> 0] = $28 >>> 16 | 0;
             HEAP8[($2 + 340 | 0) >> 0] = $28 >>> 24 | 0;
             $2655 = ($2 + 328 | 0) + 15 | 0;
             i64toi32_i32$1 = $28;
             i64toi32_i32$4 = 0;
             i64toi32_i32$3 = 48;
             i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
             if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
              i64toi32_i32$4 = 0;
              $485 = i64toi32_i32$0 >>> i64toi32_i32$5 | 0;
             } else {
              i64toi32_i32$4 = i64toi32_i32$0 >>> i64toi32_i32$5 | 0;
              $485 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$5 | 0) | 0;
             }
             HEAP8[$2655 >> 0] = $485;
             $2660 = ($2 + 328 | 0) + 13 | 0;
             i64toi32_i32$4 = $28$hi;
             i64toi32_i32$0 = $28;
             i64toi32_i32$1 = 0;
             i64toi32_i32$3 = 32;
             i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
             if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
              i64toi32_i32$1 = 0;
              $486 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
             } else {
              i64toi32_i32$1 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
              $486 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$5 | 0) | 0;
             }
             $490 = $2660;
             $491 = $486;
             HEAP8[$490 >> 0] = $491;
             HEAP8[($490 + 1 | 0) >> 0] = $491 >>> 8 | 0;
             i64toi32_i32$4 = $2;
             i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
             i64toi32_i32$0 = HEAP32[($2 + 28 | 0) >> 2] | 0;
             $2665 = i64toi32_i32$1;
             i64toi32_i32$1 = $2;
             HEAP32[($2 + 400 | 0) >> 2] = $2665;
             HEAP32[($2 + 404 | 0) >> 2] = i64toi32_i32$0;
             i64toi32_i32$4 = $2;
             i64toi32_i32$0 = HEAPU8[($2 + 31 | 0) >> 0] | 0 | ((HEAPU8[($2 + 32 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 33 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 34 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             i64toi32_i32$1 = HEAPU8[($2 + 35 | 0) >> 0] | 0 | ((HEAPU8[($2 + 36 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 37 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 38 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             $2668 = i64toi32_i32$0;
             i64toi32_i32$0 = $2;
             $399 = $2668;
             HEAP8[($2 + 407 | 0) >> 0] = $399;
             HEAP8[($2 + 408 | 0) >> 0] = $399 >>> 8 | 0;
             HEAP8[($2 + 409 | 0) >> 0] = $399 >>> 16 | 0;
             HEAP8[($2 + 410 | 0) >> 0] = $399 >>> 24 | 0;
             HEAP8[($2 + 411 | 0) >> 0] = i64toi32_i32$1;
             HEAP8[($2 + 412 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
             HEAP8[($2 + 413 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
             HEAP8[($2 + 414 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
             i64toi32_i32$4 = $2;
             i64toi32_i32$1 = HEAPU8[($2 + 407 | 0) >> 0] | 0 | ((HEAPU8[($2 + 408 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 409 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 410 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             i64toi32_i32$0 = HEAPU8[($2 + 411 | 0) >> 0] | 0 | ((HEAPU8[($2 + 412 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 413 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 414 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             $2672 = i64toi32_i32$1;
             i64toi32_i32$1 = $9 + 7 | 0;
             $400 = $2672;
             HEAP8[i64toi32_i32$1 >> 0] = $400;
             HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $400 >>> 8 | 0;
             HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $400 >>> 16 | 0;
             HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $400 >>> 24 | 0;
             HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
             HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
             HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
             HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
             i64toi32_i32$4 = $2;
             i64toi32_i32$0 = HEAP32[($2 + 400 | 0) >> 2] | 0;
             i64toi32_i32$1 = HEAP32[($2 + 404 | 0) >> 2] | 0;
             $2675 = i64toi32_i32$0;
             i64toi32_i32$0 = $9;
             $401 = $2675;
             HEAP8[i64toi32_i32$0 >> 0] = $401;
             HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $401 >>> 8 | 0;
             HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $401 >>> 16 | 0;
             HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $401 >>> 24 | 0;
             HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
             HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
             HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
             HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
             HEAP8[($2 + 336 | 0) >> 0] = $8;
             HEAP8[($2 + 360 | 0) >> 0] = $19;
             i64toi32_i32$4 = $2;
             i64toi32_i32$1 = HEAP32[($2 + 336 | 0) >> 2] | 0;
             i64toi32_i32$0 = HEAP32[($2 + 340 | 0) >> 2] | 0;
             $28 = i64toi32_i32$1;
             $28$hi = i64toi32_i32$0;
             i64toi32_i32$4 = $2;
             i64toi32_i32$0 = HEAP32[($2 + 360 | 0) >> 2] | 0;
             i64toi32_i32$1 = HEAP32[($2 + 364 | 0) >> 2] | 0;
             $29 = i64toi32_i32$0;
             $29$hi = i64toi32_i32$1;
             i64toi32_i32$4 = $2;
             i64toi32_i32$1 = HEAP32[($2 + 368 | 0) >> 2] | 0;
             i64toi32_i32$0 = HEAP32[($2 + 372 | 0) >> 2] | 0;
             $32 = i64toi32_i32$1;
             $32$hi = i64toi32_i32$0;
             core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__Update____hc1ce6150a8713009($2 + 176 | 0 | 0);
             i64toi32_i32$0 = $31$hi;
             i64toi32_i32$1 = $2;
             HEAP32[($2 + 216 | 0) >> 2] = $31;
             HEAP32[($2 + 220 | 0) >> 2] = i64toi32_i32$0;
             i64toi32_i32$0 = $32$hi;
             i64toi32_i32$1 = $2;
             HEAP32[($2 + 208 | 0) >> 2] = $32;
             HEAP32[($2 + 212 | 0) >> 2] = i64toi32_i32$0;
             i64toi32_i32$0 = $29$hi;
             i64toi32_i32$1 = $2;
             HEAP32[($2 + 200 | 0) >> 2] = $29;
             HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$0;
             i64toi32_i32$0 = $34$hi;
             i64toi32_i32$1 = $2;
             HEAP32[($2 + 192 | 0) >> 2] = $34;
             HEAP32[($2 + 196 | 0) >> 2] = i64toi32_i32$0;
             i64toi32_i32$0 = $30$hi;
             i64toi32_i32$1 = $2;
             HEAP32[($2 + 184 | 0) >> 2] = $30;
             HEAP32[($2 + 188 | 0) >> 2] = i64toi32_i32$0;
             i64toi32_i32$0 = $28$hi;
             i64toi32_i32$1 = $2;
             HEAP32[($2 + 176 | 0) >> 2] = $28;
             HEAP32[($2 + 180 | 0) >> 2] = i64toi32_i32$0;
             break label$12;
            }
            i64toi32_i32$0 = $28$hi;
            HEAP8[($2 + 337 | 0) >> 0] = $28;
            HEAP8[($2 + 338 | 0) >> 0] = $28 >>> 8 | 0;
            HEAP8[($2 + 339 | 0) >> 0] = $28 >>> 16 | 0;
            HEAP8[($2 + 340 | 0) >> 0] = $28 >>> 24 | 0;
            $2704 = ($2 + 328 | 0) + 15 | 0;
            i64toi32_i32$4 = $28;
            i64toi32_i32$1 = 0;
            i64toi32_i32$3 = 48;
            i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
            if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
             i64toi32_i32$1 = 0;
             $492 = i64toi32_i32$0 >>> i64toi32_i32$5 | 0;
            } else {
             i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$5 | 0;
             $492 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$5 | 0) | 0;
            }
            HEAP8[$2704 >> 0] = $492;
            $2709 = ($2 + 328 | 0) + 13 | 0;
            i64toi32_i32$1 = $28$hi;
            i64toi32_i32$0 = $28;
            i64toi32_i32$4 = 0;
            i64toi32_i32$3 = 32;
            i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
            if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
             i64toi32_i32$4 = 0;
             $493 = i64toi32_i32$1 >>> i64toi32_i32$5 | 0;
            } else {
             i64toi32_i32$4 = i64toi32_i32$1 >>> i64toi32_i32$5 | 0;
             $493 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$5 | 0) | 0;
            }
            $494 = $2709;
            $495 = $493;
            HEAP8[$494 >> 0] = $495;
            HEAP8[($494 + 1 | 0) >> 0] = $495 >>> 8 | 0;
            i64toi32_i32$1 = $2;
            i64toi32_i32$4 = HEAP32[($2 + 24 | 0) >> 2] | 0;
            i64toi32_i32$0 = HEAP32[($2 + 28 | 0) >> 2] | 0;
            $2714 = i64toi32_i32$4;
            i64toi32_i32$4 = $2;
            HEAP32[($2 + 400 | 0) >> 2] = $2714;
            HEAP32[($2 + 404 | 0) >> 2] = i64toi32_i32$0;
            i64toi32_i32$1 = $2;
            i64toi32_i32$0 = HEAPU8[($2 + 31 | 0) >> 0] | 0 | ((HEAPU8[($2 + 32 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 33 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 34 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            i64toi32_i32$4 = HEAPU8[($2 + 35 | 0) >> 0] | 0 | ((HEAPU8[($2 + 36 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 37 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 38 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            $2717 = i64toi32_i32$0;
            i64toi32_i32$0 = $2;
            $402 = $2717;
            HEAP8[($2 + 407 | 0) >> 0] = $402;
            HEAP8[($2 + 408 | 0) >> 0] = $402 >>> 8 | 0;
            HEAP8[($2 + 409 | 0) >> 0] = $402 >>> 16 | 0;
            HEAP8[($2 + 410 | 0) >> 0] = $402 >>> 24 | 0;
            HEAP8[($2 + 411 | 0) >> 0] = i64toi32_i32$4;
            HEAP8[($2 + 412 | 0) >> 0] = i64toi32_i32$4 >>> 8 | 0;
            HEAP8[($2 + 413 | 0) >> 0] = i64toi32_i32$4 >>> 16 | 0;
            HEAP8[($2 + 414 | 0) >> 0] = i64toi32_i32$4 >>> 24 | 0;
            i64toi32_i32$1 = $2;
            i64toi32_i32$4 = HEAPU8[($2 + 407 | 0) >> 0] | 0 | ((HEAPU8[($2 + 408 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 409 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 410 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            i64toi32_i32$0 = HEAPU8[($2 + 411 | 0) >> 0] | 0 | ((HEAPU8[($2 + 412 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 413 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 414 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            $2721 = i64toi32_i32$4;
            i64toi32_i32$4 = $9 + 7 | 0;
            $403 = $2721;
            HEAP8[i64toi32_i32$4 >> 0] = $403;
            HEAP8[(i64toi32_i32$4 + 1 | 0) >> 0] = $403 >>> 8 | 0;
            HEAP8[(i64toi32_i32$4 + 2 | 0) >> 0] = $403 >>> 16 | 0;
            HEAP8[(i64toi32_i32$4 + 3 | 0) >> 0] = $403 >>> 24 | 0;
            HEAP8[(i64toi32_i32$4 + 4 | 0) >> 0] = i64toi32_i32$0;
            HEAP8[(i64toi32_i32$4 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
            HEAP8[(i64toi32_i32$4 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
            HEAP8[(i64toi32_i32$4 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
            i64toi32_i32$1 = $2;
            i64toi32_i32$0 = HEAP32[($2 + 400 | 0) >> 2] | 0;
            i64toi32_i32$4 = HEAP32[($2 + 404 | 0) >> 2] | 0;
            $2724 = i64toi32_i32$0;
            i64toi32_i32$0 = $9;
            $404 = $2724;
            HEAP8[i64toi32_i32$0 >> 0] = $404;
            HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $404 >>> 8 | 0;
            HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $404 >>> 16 | 0;
            HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $404 >>> 24 | 0;
            HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$4;
            HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$4 >>> 8 | 0;
            HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$4 >>> 16 | 0;
            HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$4 >>> 24 | 0;
            HEAP8[($2 + 336 | 0) >> 0] = $8;
            HEAP8[($2 + 360 | 0) >> 0] = $19;
            i64toi32_i32$1 = $2;
            i64toi32_i32$4 = HEAP32[($2 + 336 | 0) >> 2] | 0;
            i64toi32_i32$0 = HEAP32[($2 + 340 | 0) >> 2] | 0;
            $28 = i64toi32_i32$4;
            $28$hi = i64toi32_i32$0;
            i64toi32_i32$1 = $2;
            i64toi32_i32$0 = HEAP32[($2 + 360 | 0) >> 2] | 0;
            i64toi32_i32$4 = HEAP32[($2 + 364 | 0) >> 2] | 0;
            $30 = i64toi32_i32$0;
            $30$hi = i64toi32_i32$4;
            i64toi32_i32$1 = $2;
            i64toi32_i32$4 = HEAP32[($2 + 368 | 0) >> 2] | 0;
            i64toi32_i32$0 = HEAP32[($2 + 372 | 0) >> 2] | 0;
            $29 = i64toi32_i32$4;
            $29$hi = i64toi32_i32$0;
            core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__Withdrawals____heaf2605773ce1c75($2 + 136 | 0 | 0);
            i64toi32_i32$4 = $2;
            HEAP32[($2 + 168 | 0) >> 2] = $29;
            HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$0;
            i64toi32_i32$0 = $30$hi;
            i64toi32_i32$4 = $2;
            HEAP32[($2 + 160 | 0) >> 2] = $30;
            HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$0;
            i64toi32_i32$0 = $34$hi;
            i64toi32_i32$4 = $2;
            HEAP32[($2 + 152 | 0) >> 2] = $34;
            HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
            i64toi32_i32$0 = $31$hi;
            i64toi32_i32$4 = $2;
            HEAP32[($2 + 144 | 0) >> 2] = $31;
            HEAP32[($2 + 148 | 0) >> 2] = i64toi32_i32$0;
            i64toi32_i32$0 = $28$hi;
            i64toi32_i32$4 = $2;
            HEAP32[($2 + 136 | 0) >> 2] = $28;
            HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$0;
            break label$12;
           }
           i64toi32_i32$1 = ($2 + 440 | 0) + 15 | 0;
           i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
           i64toi32_i32$4 = 0;
           HEAP8[(($2 + 328 | 0) + 15 | 0) >> 0] = i64toi32_i32$0;
           i64toi32_i32$1 = ($2 + 440 | 0) + 13 | 0;
           i64toi32_i32$4 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
           i64toi32_i32$0 = 0;
           $496 = ($2 + 328 | 0) + 13 | 0;
           HEAP8[$496 >> 0] = i64toi32_i32$4;
           HEAP8[($496 + 1 | 0) >> 0] = i64toi32_i32$4 >>> 8 | 0;
           i64toi32_i32$1 = $2;
           i64toi32_i32$0 = HEAPU8[($2 + 449 | 0) >> 0] | 0 | ((HEAPU8[($2 + 450 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 451 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 452 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$4 = 0;
           HEAP8[($2 + 337 | 0) >> 0] = i64toi32_i32$0;
           HEAP8[($2 + 338 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
           HEAP8[($2 + 339 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
           HEAP8[($2 + 340 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
           HEAP8[($2 + 336 | 0) >> 0] = HEAPU8[($2 + 448 | 0) >> 0] | 0;
           $8 = HEAP32[($2 + 444 | 0) >> 2] | 0;
           i64toi32_i32$1 = $2;
           i64toi32_i32$4 = HEAP32[($2 + 336 | 0) >> 2] | 0;
           i64toi32_i32$0 = HEAP32[($2 + 340 | 0) >> 2] | 0;
           $28 = i64toi32_i32$4;
           $28$hi = i64toi32_i32$0;
           core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__Certificates____h3bab90286ab8bbb4($2 + 120 | 0 | 0);
           i64toi32_i32$4 = $2;
           HEAP32[($2 + 124 | 0) >> 2] = $28;
           HEAP32[($2 + 128 | 0) >> 2] = i64toi32_i32$0;
           HEAP32[($2 + 120 | 0) >> 2] = $8;
           break label$12;
          }
          i64toi32_i32$0 = 0;
          $26 = 1;
          $26$hi = i64toi32_i32$0;
         }
         $8 = $18 + 1 | 0;
         if ($5) {
          continue label$10
         }
         if ($18 >>> 0 >= $4 >>> 0) {
          break label$4
         }
         continue label$10;
        };
       }
       i64toi32_i32$1 = $2 + 480 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $33 = i64toi32_i32$0;
       $33$hi = i64toi32_i32$4;
       i64toi32_i32$1 = $2 + 472 | 0;
       i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $32 = i64toi32_i32$4;
       $32$hi = i64toi32_i32$0;
       i64toi32_i32$1 = $2 + 464 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $25 = i64toi32_i32$0;
       $25$hi = i64toi32_i32$4;
       $8 = 0;
       i64toi32_i32$4 = 0;
       $28 = 2;
       $28$hi = i64toi32_i32$4;
       i64toi32_i32$4 = 0;
       $29 = 0;
       $29$hi = i64toi32_i32$4;
       i64toi32_i32$4 = $22$hi;
       $30 = $22;
       $30$hi = i64toi32_i32$4;
       i64toi32_i32$4 = $23$hi;
       $31 = $23;
       $31$hi = i64toi32_i32$4;
       break label$2;
      }
      i64toi32_i32$4 = 0;
      $28 = 4;
      $28$hi = i64toi32_i32$4;
      break label$3;
     }
     i64toi32_i32$4 = 0;
     $29 = 0;
     $29$hi = i64toi32_i32$4;
     label$89 : {
      label$90 : {
       label$91 : {
        $5 = HEAP32[($2 + 88 | 0) >> 2] | 0;
        if ($5) {
         break label$91
        }
        $11 = 1;
        i64toi32_i32$4 = 0;
        $22 = 1;
        $22$hi = i64toi32_i32$4;
        i64toi32_i32$4 = 0;
        $28 = 9;
        $28$hi = i64toi32_i32$4;
        i64toi32_i32$4 = 0;
        $30 = 0;
        $30$hi = i64toi32_i32$4;
        break label$90;
       }
       HEAP32[(($2 + 288 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 88 | 0) + 8 | 0) >> 2] | 0;
       i64toi32_i32$1 = $2;
       i64toi32_i32$4 = HEAP32[($2 + 88 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[($2 + 92 | 0) >> 2] | 0;
       $2806 = i64toi32_i32$4;
       i64toi32_i32$4 = $2;
       HEAP32[($2 + 288 | 0) >> 2] = $2806;
       HEAP32[($2 + 292 | 0) >> 2] = i64toi32_i32$0;
       label$92 : {
        label$93 : {
         $8 = HEAP32[($2 + 104 | 0) >> 2] | 0;
         if ($8) {
          break label$93
         }
         i64toi32_i32$0 = 0;
         $30 = 1;
         $30$hi = i64toi32_i32$0;
         i64toi32_i32$0 = 0;
         $28 = 9;
         $28$hi = i64toi32_i32$0;
         i64toi32_i32$0 = 0;
         $22 = 1;
         $22$hi = i64toi32_i32$0;
         break label$92;
        }
        HEAP32[(($2 + 328 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 104 | 0) + 8 | 0) >> 2] | 0;
        i64toi32_i32$1 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 104 | 0) >> 2] | 0;
        i64toi32_i32$4 = HEAP32[($2 + 108 | 0) >> 2] | 0;
        $2819 = i64toi32_i32$0;
        i64toi32_i32$0 = $2;
        HEAP32[($2 + 328 | 0) >> 2] = $2819;
        HEAP32[($2 + 332 | 0) >> 2] = i64toi32_i32$4;
        label$94 : {
         label$95 : {
          i64toi32_i32$4 = $27$hi;
          i64toi32_i32$1 = $27;
          i64toi32_i32$0 = 0;
          i64toi32_i32$3 = 1;
          if ((i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$4 | 0) == (i64toi32_i32$0 | 0) | 0) {
           break label$95
          }
          i64toi32_i32$1 = 0;
          $30 = 2;
          $30$hi = i64toi32_i32$1;
          i64toi32_i32$1 = 0;
          $28 = 9;
          $28$hi = i64toi32_i32$1;
          i64toi32_i32$1 = 0;
          $22 = 1;
          $22$hi = i64toi32_i32$1;
          break label$94;
         }
         i64toi32_i32$1 = 0;
         $30 = 1;
         $30$hi = i64toi32_i32$1;
         i64toi32_i32$1 = $23$hi;
         i64toi32_i32$3 = $23;
         i64toi32_i32$4 = 0;
         i64toi32_i32$0 = 1;
         if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$4 | 0) | 0) {
          break label$89
         }
         i64toi32_i32$3 = 0;
         $28 = 3;
         $28$hi = i64toi32_i32$3;
         i64toi32_i32$3 = $25$hi;
         i64toi32_i32$3 = $22$hi;
         i64toi32_i32$3 = $25$hi;
         i64toi32_i32$0 = $25;
         i64toi32_i32$1 = $22$hi;
         i64toi32_i32$4 = $22;
         if ((i64toi32_i32$0 | 0) == (i64toi32_i32$4 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) | 0) {
          break label$89
         }
        }
        label$96 : {
         $18 = HEAP32[($2 + 336 | 0) >> 2] | 0;
         if (!$18) {
          break label$96
         }
         $1 = HEAP32[($2 + 328 | 0) >> 2] | 0;
         $18 = $18 << 7 | 0;
         label$97 : while (1) {
          core__ptr__drop_in_place_cardano_serialization_lib__TransactionOutput___h632b3a99817e6ac5_1($1 | 0);
          $1 = $1 + 128 | 0;
          $18 = $18 + -128 | 0;
          if ($18) {
           continue label$97
          }
          break label$97;
         };
        }
        $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h5107e2b13c386680($2 + 328 | 0 | 0);
       }
       $11 = !$8;
       $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h98bad0b07702c13e($2 + 288 | 0 | 0);
      }
      $8 = 0;
      $15 = ($5 | 0) != (0 | 0);
      i64toi32_i32$0 = $22$hi;
      $31 = $22;
      $31$hi = i64toi32_i32$0;
      break label$3;
     }
     i64toi32_i32$4 = $2;
     i64toi32_i32$0 = HEAP32[($2 + 88 | 0) >> 2] | 0;
     i64toi32_i32$3 = HEAP32[($2 + 92 | 0) >> 2] | 0;
     $2853 = i64toi32_i32$0;
     i64toi32_i32$0 = $0 + 136 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $2853;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$4 = $2;
     i64toi32_i32$3 = HEAP32[($2 + 120 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 124 | 0) >> 2] | 0;
     $2857 = i64toi32_i32$3;
     i64toi32_i32$3 = $0 + 160 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $2857;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($0 + 144 | 0) >> 2] = HEAP32[(($2 + 88 | 0) + 8 | 0) >> 2] | 0;
     HEAP32[($0 + 168 | 0) >> 2] = HEAP32[(($2 + 120 | 0) + 8 | 0) >> 2] | 0;
     HEAP32[(($2 + 24 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 172 | 0) >> 2] | 0;
     i64toi32_i32$4 = $2 + 164 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
     $2879 = i64toi32_i32$0;
     i64toi32_i32$0 = $2;
     HEAP32[($2 + 24 | 0) >> 2] = $2879;
     HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$4 = $2;
     i64toi32_i32$3 = HEAP32[($2 + 136 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 140 | 0) >> 2] | 0;
     $28 = i64toi32_i32$3;
     $28$hi = i64toi32_i32$0;
     i64toi32_i32$4 = $2;
     i64toi32_i32$0 = HEAP32[($2 + 144 | 0) >> 2] | 0;
     i64toi32_i32$3 = HEAP32[($2 + 148 | 0) >> 2] | 0;
     $25 = i64toi32_i32$0;
     $25$hi = i64toi32_i32$3;
     i64toi32_i32$4 = $2;
     i64toi32_i32$3 = HEAP32[($2 + 152 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 156 | 0) >> 2] | 0;
     $22 = i64toi32_i32$3;
     $22$hi = i64toi32_i32$0;
     $1 = HEAP32[($2 + 160 | 0) >> 2] | 0;
     memcpy($2 + 36 | 0 | 0, $2 + 176 | 0 | 0, 48 | 0) | 0;
     HEAP32[($0 + 208 | 0) >> 2] = HEAP32[(($2 + 272 | 0) + 8 | 0) >> 2] | 0;
     i64toi32_i32$4 = $2;
     i64toi32_i32$0 = HEAP32[($2 + 272 | 0) >> 2] | 0;
     i64toi32_i32$3 = HEAP32[($2 + 276 | 0) >> 2] | 0;
     $2902 = i64toi32_i32$0;
     i64toi32_i32$0 = $0 + 200 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $2902;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
     $18 = ($2 + 400 | 0) + 8 | 0;
     HEAP32[$18 >> 2] = HEAP32[(($2 + 104 | 0) + 8 | 0) >> 2] | 0;
     $8 = ($2 + 440 | 0) + 8 | 0;
     i64toi32_i32$4 = ($2 + 232 | 0) + 8 | 0;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$4 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
     $2918 = i64toi32_i32$3;
     i64toi32_i32$3 = $8;
     HEAP32[i64toi32_i32$3 >> 2] = $2918;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
     $5 = ($2 + 424 | 0) + 8 | 0;
     HEAP32[$5 >> 2] = HEAP32[(($2 + 256 | 0) + 8 | 0) >> 2] | 0;
     i64toi32_i32$4 = $2;
     i64toi32_i32$0 = HEAP32[($2 + 104 | 0) >> 2] | 0;
     i64toi32_i32$3 = HEAP32[($2 + 108 | 0) >> 2] | 0;
     $2929 = i64toi32_i32$0;
     i64toi32_i32$0 = $2;
     HEAP32[($2 + 400 | 0) >> 2] = $2929;
     HEAP32[($2 + 404 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$4 = $2;
     i64toi32_i32$3 = HEAP32[($2 + 232 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 236 | 0) >> 2] | 0;
     $2932 = i64toi32_i32$3;
     i64toi32_i32$3 = $2;
     HEAP32[($2 + 440 | 0) >> 2] = $2932;
     HEAP32[($2 + 444 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$4 = $2;
     i64toi32_i32$0 = HEAP32[($2 + 256 | 0) >> 2] | 0;
     i64toi32_i32$3 = HEAP32[($2 + 260 | 0) >> 2] | 0;
     $2935 = i64toi32_i32$0;
     i64toi32_i32$0 = $2;
     HEAP32[($2 + 424 | 0) >> 2] = $2935;
     HEAP32[($2 + 428 | 0) >> 2] = i64toi32_i32$3;
     $405 = HEAPU8[($2 + 227 | 0) >> 0] | 0 | ((HEAPU8[($2 + 228 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 229 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 230 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($2 + 315 | 0) >> 0] = $405;
     HEAP8[($2 + 316 | 0) >> 0] = $405 >>> 8 | 0;
     HEAP8[($2 + 317 | 0) >> 0] = $405 >>> 16 | 0;
     HEAP8[($2 + 318 | 0) >> 0] = $405 >>> 24 | 0;
     HEAP32[($2 + 312 | 0) >> 2] = HEAP32[($2 + 224 | 0) >> 2] | 0;
     $406 = HEAPU8[($2 + 251 | 0) >> 0] | 0 | ((HEAPU8[($2 + 252 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 253 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 254 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($2 + 307 | 0) >> 0] = $406;
     HEAP8[($2 + 308 | 0) >> 0] = $406 >>> 8 | 0;
     HEAP8[($2 + 309 | 0) >> 0] = $406 >>> 16 | 0;
     HEAP8[($2 + 310 | 0) >> 0] = $406 >>> 24 | 0;
     HEAP32[($2 + 304 | 0) >> 2] = HEAP32[($2 + 248 | 0) >> 2] | 0;
     HEAP32[($0 + 56 | 0) >> 2] = $1;
     i64toi32_i32$3 = $22$hi;
     i64toi32_i32$0 = $0 + 48 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $22;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$3 = $25$hi;
     i64toi32_i32$0 = $0 + 40 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $25;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$3 = $28$hi;
     i64toi32_i32$0 = $0 + 32 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $28;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$3 = $36$hi;
     i64toi32_i32$0 = $0 + 24 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $36;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$3 = $26$hi;
     i64toi32_i32$0 = $0 + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $26;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$3 = $37$hi;
     i64toi32_i32$0 = $0;
     HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $37;
     HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$3;
     memcpy(i64toi32_i32$0 + 60 | 0 | 0, $2 + 24 | 0 | 0, 60 | 0) | 0;
     i64toi32_i32$3 = $35$hi;
     i64toi32_i32$0 = i64toi32_i32$0 + 128 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $35;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$3 = $24$hi;
     i64toi32_i32$0 = $0 + 120 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $24;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
     HEAP8[($0 + 212 | 0) >> 0] = $7;
     i64toi32_i32$4 = $2;
     i64toi32_i32$3 = HEAP32[($2 + 400 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 404 | 0) >> 2] | 0;
     $2983 = i64toi32_i32$3;
     i64toi32_i32$3 = $0;
     HEAP32[(i64toi32_i32$3 + 148 | 0) >> 2] = $2983;
     HEAP32[(i64toi32_i32$3 + 152 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[(i64toi32_i32$3 + 156 | 0) >> 2] = HEAP32[$18 >> 2] | 0;
     i64toi32_i32$4 = $2;
     i64toi32_i32$0 = HEAP32[($2 + 440 | 0) >> 2] | 0;
     i64toi32_i32$3 = HEAP32[($2 + 444 | 0) >> 2] | 0;
     $2990 = i64toi32_i32$0;
     i64toi32_i32$0 = $0;
     HEAP32[(i64toi32_i32$0 + 172 | 0) >> 2] = $2990;
     HEAP32[(i64toi32_i32$0 + 176 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$4 = $8;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$4 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
     $2994 = i64toi32_i32$3;
     i64toi32_i32$3 = $0 + 180 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $2994;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$4 = $2;
     i64toi32_i32$0 = HEAP32[($2 + 424 | 0) >> 2] | 0;
     i64toi32_i32$3 = HEAP32[($2 + 428 | 0) >> 2] | 0;
     $2997 = i64toi32_i32$0;
     i64toi32_i32$0 = $0;
     HEAP32[(i64toi32_i32$0 + 188 | 0) >> 2] = $2997;
     HEAP32[(i64toi32_i32$0 + 192 | 0) >> 2] = i64toi32_i32$3;
     HEAP32[(i64toi32_i32$0 + 196 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
     $407 = HEAP32[($2 + 312 | 0) >> 2] | 0;
     HEAP8[(i64toi32_i32$0 + 213 | 0) >> 0] = $407;
     HEAP8[(i64toi32_i32$0 + 214 | 0) >> 0] = $407 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 215 | 0) >> 0] = $407 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 216 | 0) >> 0] = $407 >>> 24 | 0;
     $408 = i64toi32_i32$0 + 216 | 0;
     $409 = HEAPU8[($2 + 315 | 0) >> 0] | 0 | ((HEAPU8[($2 + 316 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 317 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 318 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[$408 >> 0] = $409;
     HEAP8[($408 + 1 | 0) >> 0] = $409 >>> 8 | 0;
     HEAP8[($408 + 2 | 0) >> 0] = $409 >>> 16 | 0;
     HEAP8[($408 + 3 | 0) >> 0] = $409 >>> 24 | 0;
     HEAP8[(i64toi32_i32$0 + 245 | 0) >> 0] = $3;
     HEAP8[(i64toi32_i32$0 + 244 | 0) >> 0] = $21;
     i64toi32_i32$3 = $42$hi;
     HEAP32[(i64toi32_i32$0 + 236 | 0) >> 2] = $42;
     HEAP32[(i64toi32_i32$0 + 240 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$3 = $41$hi;
     HEAP32[(i64toi32_i32$0 + 228 | 0) >> 2] = $41;
     HEAP32[(i64toi32_i32$0 + 232 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$3 = $43$hi;
     HEAP32[(i64toi32_i32$0 + 220 | 0) >> 2] = $43;
     HEAP32[(i64toi32_i32$0 + 224 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$3 = $40$hi;
     $410 = $40;
     HEAP8[(i64toi32_i32$0 + 253 | 0) >> 0] = $410;
     HEAP8[(i64toi32_i32$0 + 254 | 0) >> 0] = $410 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 255 | 0) >> 0] = $410 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 256 | 0) >> 0] = $410 >>> 24 | 0;
     HEAP8[(i64toi32_i32$0 + 257 | 0) >> 0] = i64toi32_i32$3;
     HEAP8[(i64toi32_i32$0 + 258 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 259 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 260 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
     i64toi32_i32$3 = $38$hi;
     $411 = $38;
     HEAP8[(i64toi32_i32$0 + 261 | 0) >> 0] = $411;
     HEAP8[(i64toi32_i32$0 + 262 | 0) >> 0] = $411 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 263 | 0) >> 0] = $411 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 264 | 0) >> 0] = $411 >>> 24 | 0;
     HEAP8[(i64toi32_i32$0 + 265 | 0) >> 0] = i64toi32_i32$3;
     HEAP8[(i64toi32_i32$0 + 266 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 267 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 268 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
     i64toi32_i32$3 = $39$hi;
     $412 = $39;
     HEAP8[(i64toi32_i32$0 + 269 | 0) >> 0] = $412;
     HEAP8[(i64toi32_i32$0 + 270 | 0) >> 0] = $412 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 271 | 0) >> 0] = $412 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 272 | 0) >> 0] = $412 >>> 24 | 0;
     HEAP8[(i64toi32_i32$0 + 273 | 0) >> 0] = i64toi32_i32$3;
     HEAP8[(i64toi32_i32$0 + 274 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 275 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 276 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
     HEAP8[(i64toi32_i32$0 + 278 | 0) >> 0] = $6;
     HEAP8[(i64toi32_i32$0 + 277 | 0) >> 0] = $20;
     $413 = i64toi32_i32$0 + 249 | 0;
     $414 = HEAPU8[($2 + 307 | 0) >> 0] | 0 | ((HEAPU8[($2 + 308 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 309 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 310 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[$413 >> 0] = $414;
     HEAP8[($413 + 1 | 0) >> 0] = $414 >>> 8 | 0;
     HEAP8[($413 + 2 | 0) >> 0] = $414 >>> 16 | 0;
     HEAP8[($413 + 3 | 0) >> 0] = $414 >>> 24 | 0;
     $497 = HEAP32[($2 + 304 | 0) >> 2] | 0;
     HEAP16[(i64toi32_i32$0 + 246 | 0) >> 1] = $497;
     HEAP16[(i64toi32_i32$0 + 248 | 0) >> 1] = $497 >>> 16 | 0;
     i64toi32_i32$3 = 0;
     $28 = 0;
     $28$hi = i64toi32_i32$3;
     break label$1;
    }
    label$98 : {
     if (!(HEAP32[($2 + 272 | 0) >> 2] | 0)) {
      break label$98
     }
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h72de9eab2f0e4669($2 + 272 | 0 | 0);
    }
    label$99 : {
     if (!(HEAP32[($2 + 256 | 0) >> 2] | 0)) {
      break label$99
     }
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h98bad0b07702c13e($2 + 256 | 0 | 0);
    }
    label$100 : {
     if (!(HEAP32[($2 + 232 | 0) >> 2] | 0)) {
      break label$100
     }
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h3981a4152bf24dd0($2 + 232 | 0 | 4 | 0 | 0);
    }
    core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__Update____hc1ce6150a8713009($2 + 176 | 0 | 0);
    core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__Withdrawals____heaf2605773ce1c75($2 + 136 | 0 | 0);
    core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__Certificates____h3bab90286ab8bbb4($2 + 120 | 0 | 0);
    label$101 : {
     $1 = HEAP32[($2 + 104 | 0) >> 2] | 0;
     if (!($11 & ($1 | 0) != (0 | 0) | 0)) {
      break label$101
     }
     label$102 : {
      $18 = HEAP32[($2 + 112 | 0) >> 2] | 0;
      if (!$18) {
       break label$102
      }
      $18 = $18 << 7 | 0;
      label$103 : while (1) {
       core__ptr__drop_in_place_cardano_serialization_lib__TransactionOutput___h632b3a99817e6ac5_1($1 | 0);
       $1 = $1 + 128 | 0;
       $18 = $18 + -128 | 0;
       if ($18) {
        continue label$103
       }
       break label$103;
      };
     }
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h5107e2b13c386680($2 + 104 | 0 | 0);
    }
    if ($15 | !(HEAP32[($2 + 88 | 0) >> 2] | 0) | 0) {
     break label$2
    }
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h98bad0b07702c13e($2 + 88 | 0 | 0);
   }
   i64toi32_i32$3 = $33$hi;
   i64toi32_i32$0 = $2 + 480 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $33;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$3 = $32$hi;
   i64toi32_i32$0 = $2 + 472 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $32;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$3 = $25$hi;
   i64toi32_i32$0 = $2 + 464 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $25;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$3 = $30$hi;
   i64toi32_i32$0 = $2 + 456 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $30;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$3 = $31$hi;
   i64toi32_i32$0 = ($2 + 440 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $31;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$4 = $2;
   i64toi32_i32$3 = HEAP32[($2 + 24 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 28 | 0) >> 2] | 0;
   $3106 = i64toi32_i32$3;
   i64toi32_i32$3 = $2 + 492 | 0;
   HEAP32[i64toi32_i32$3 >> 2] = $3106;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($2 + 500 | 0) >> 2] = HEAP32[(($2 + 24 | 0) + 8 | 0) >> 2] | 0;
   HEAP32[($2 + 488 | 0) >> 2] = $8;
   i64toi32_i32$0 = $28$hi;
   i64toi32_i32$4 = $28;
   i64toi32_i32$3 = 0;
   i64toi32_i32$1 = 255;
   i64toi32_i32$3 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
   $3117 = i64toi32_i32$4 & i64toi32_i32$1 | 0;
   $3117$hi = i64toi32_i32$3;
   i64toi32_i32$3 = $29$hi;
   i64toi32_i32$0 = $29;
   i64toi32_i32$4 = -1;
   i64toi32_i32$1 = -256;
   i64toi32_i32$4 = i64toi32_i32$3 & i64toi32_i32$4 | 0;
   $3119 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
   $3119$hi = i64toi32_i32$4;
   i64toi32_i32$4 = $3117$hi;
   i64toi32_i32$3 = $3117;
   i64toi32_i32$0 = $3119$hi;
   i64toi32_i32$1 = $3119;
   i64toi32_i32$0 = i64toi32_i32$4 | i64toi32_i32$0 | 0;
   $3120 = i64toi32_i32$3 | i64toi32_i32$1 | 0;
   i64toi32_i32$3 = $2;
   HEAP32[($2 + 440 | 0) >> 2] = $3120;
   HEAP32[($2 + 444 | 0) >> 2] = i64toi32_i32$0;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 440 | 0 | 0, 1050587 | 0, 15 | 0);
   i64toi32_i32$0 = 0;
   $28 = 1;
   $28$hi = i64toi32_i32$0;
  }
  i64toi32_i32$0 = $28$hi;
  i64toi32_i32$3 = $0;
  HEAP32[i64toi32_i32$3 >> 2] = $28;
  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 512 | 0;
 }
 
 function cryptoxide__hashing__sha2__impl512__reference__digest_block__h5deb88f07cb6a5e7($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$4 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$3 = 0, $13$hi = 0, $6$hi = 0, $7$hi = 0, $89$hi = 0, $12$hi = 0, $19$hi = 0, $13 = 0, $6 = 0, $24$hi = 0, $7 = 0, i64toi32_i32$6 = 0, $89 = 0, $12 = 0, $19 = 0, $24 = 0, $3 = 0, $11$hi = 0, $17$hi = 0, $22$hi = 0, $28$hi = 0, $26$hi = 0, $5$hi = 0, $11 = 0, $17 = 0, $5 = 0, $22 = 0, $26 = 0, $28 = 0, $85$hi = 0, $8$hi = 0, $85 = 0, $10$hi = 0, $94$hi = 0, $8 = 0, $9$hi = 0, $15$hi = 0, $88$hi = 0, $14$hi = 0, $16$hi = 0, $21$hi = 0, $25$hi = 0, $27$hi = 0, $29$hi = 0, $31$hi = 0, $32$hi = 0, $33$hi = 0, $35$hi = 0, $36$hi = 0, $37$hi = 0, $39$hi = 0, $40$hi = 0, $41$hi = 0, $43$hi = 0, $44$hi = 0, $45$hi = 0, $47$hi = 0, $48$hi = 0, $49$hi = 0, $51$hi = 0, $52$hi = 0, $53$hi = 0, $55$hi = 0, $56$hi = 0, $57$hi = 0, $59$hi = 0, $60$hi = 0, $61$hi = 0, $63$hi = 0, $64$hi = 0, $65$hi = 0, $67$hi = 0, $68$hi = 0, $10 = 0, $14 = 0, $18$hi = 0, $23$hi = 0, $30$hi = 0, $34$hi = 0, $38$hi = 0, $42$hi = 0, $46$hi = 0, $50$hi = 0, $54$hi = 0, $58$hi = 0, $62$hi = 0, $66$hi = 0, $87$hi = 0, $91$hi = 0, $92$hi = 0, $93$hi = 0, $94 = 0, $4 = 0, $9 = 0, $15 = 0, $20$hi = 0, $30 = 0, $32 = 0, $34 = 0, $36 = 0, $38 = 0, $40 = 0, $42 = 0, $44 = 0, $46 = 0, $48 = 0, $50 = 0, $52 = 0, $54 = 0, $56 = 0, $58 = 0, $60 = 0, $62 = 0, $64 = 0, $66 = 0, $68 = 0, $69$hi = 0, $70$hi = 0, $71$hi = 0, $72$hi = 0, $73$hi = 0, $75$hi = 0, $76$hi = 0, $88 = 0, $16 = 0, $18 = 0, $21 = 0, $23 = 0, $25 = 0, $27 = 0, $29 = 0, $31 = 0, $33 = 0, $35 = 0, $37 = 0, $39 = 0, $41 = 0, $43 = 0, $45 = 0, $47 = 0, $49 = 0, $51 = 0, $53 = 0, $55 = 0, $57 = 0, $59 = 0, $61 = 0, $63 = 0, $65 = 0, $67 = 0, $70 = 0, $74$hi = 0, $87 = 0, $92 = 0, $20 = 0, $69 = 0, $71 = 0, $72 = 0, $73 = 0, $74 = 0, $75 = 0, $76 = 0, $77$hi = 0, $78 = 0, $78$hi = 0, $79$hi = 0, $80$hi = 0, $81$hi = 0, $86$hi = 0, $91 = 0, $93 = 0, $95$hi = 0, $3364 = 0, $3367 = 0, $3370 = 0, $3371 = 0, $3373 = 0, $3375 = 0, $3378 = 0, $3381 = 0, $77 = 0, $79 = 0, $80 = 0, $81 = 0, $82 = 0, $82$hi = 0, $83$hi = 0, $84$hi = 0, $86 = 0, $90 = 0, $90$hi = 0, $96$hi = 0, $110 = 0, $116 = 0, $116$hi = 0, $119 = 0, $119$hi = 0, $120 = 0, $120$hi = 0, $123 = 0, $123$hi = 0, $126 = 0, $126$hi = 0, $127 = 0, $127$hi = 0, $128 = 0, $128$hi = 0, $131 = 0, $131$hi = 0, $134 = 0, $134$hi = 0, $135 = 0, $135$hi = 0, $138 = 0, $138$hi = 0, $140$hi = 0, $141 = 0, $141$hi = 0, $142 = 0, $142$hi = 0, $143 = 0, $83 = 0, $84 = 0, $595 = 0, $596 = 0, $596$hi = 0, $597 = 0, $597$hi = 0, $598 = 0, $598$hi = 0, $599 = 0, $599$hi = 0, $600 = 0, $600$hi = 0, $601 = 0, $601$hi = 0, $602 = 0, $602$hi = 0, $603 = 0, $603$hi = 0, $604 = 0, $604$hi = 0, $605 = 0, $605$hi = 0, $606 = 0, $606$hi = 0, $607 = 0, $607$hi = 0, $608 = 0, $608$hi = 0, $609 = 0, $609$hi = 0, $610 = 0, $610$hi = 0, $611 = 0, $611$hi = 0, $612 = 0, $612$hi = 0, $613 = 0, $613$hi = 0, $617 = 0, $617$hi = 0, $619 = 0, $619$hi = 0, $620 = 0, $620$hi = 0, $622 = 0, $622$hi = 0, $623 = 0, $623$hi = 0, $627$hi = 0, $634$hi = 0, $636$hi = 0, $638 = 0, $638$hi = 0, $639$hi = 0, $650 = 0, $650$hi = 0, $653 = 0, $653$hi = 0, $656 = 0, $656$hi = 0, $659$hi = 0, $663 = 0, $663$hi = 0, $664$hi = 0, $666 = 0, $666$hi = 0, $667$hi = 0, $669 = 0, $669$hi = 0, $671 = 0, $671$hi = 0, $672 = 0, $672$hi = 0, $674 = 0, $674$hi = 0, $675 = 0, $675$hi = 0, $686 = 0, $686$hi = 0, $687$hi = 0, $689 = 0, $689$hi = 0, $690$hi = 0, $692 = 0, $692$hi = 0, $694 = 0, $694$hi = 0, $695 = 0, $695$hi = 0, $697 = 0, $697$hi = 0, $698 = 0, $698$hi = 0, $709 = 0, $709$hi = 0, $710$hi = 0, $712 = 0, $712$hi = 0, $713$hi = 0, $715 = 0, $715$hi = 0, $717 = 0, $717$hi = 0, $718 = 0, $718$hi = 0, $720 = 0, $720$hi = 0, $721 = 0, $721$hi = 0, $95 = 0, $732 = 0, $732$hi = 0, $733$hi = 0, $735 = 0, $735$hi = 0, $736$hi = 0, $738 = 0, $738$hi = 0, $740 = 0, $740$hi = 0, $741 = 0, $741$hi = 0, $743 = 0, $743$hi = 0, $744 = 0, $744$hi = 0, $96 = 0, $747 = 0, $747$hi = 0, $750$hi = 0, $752 = 0, $752$hi = 0, $755 = 0, $755$hi = 0, $756 = 0, $756$hi = 0, $758 = 0, $758$hi = 0, $760 = 0, $760$hi = 0, $761 = 0, $761$hi = 0, $763 = 0, $763$hi = 0, $764 = 0, $764$hi = 0, $765$hi = 0, $771 = 0, $771$hi = 0, $774 = 0, $774$hi = 0, $777 = 0, $777$hi = 0, $780$hi = 0, $784 = 0, $784$hi = 0, $785$hi = 0, $787 = 0, $787$hi = 0, $788$hi = 0, $790 = 0, $790$hi = 0, $792 = 0, $792$hi = 0, $793 = 0, $793$hi = 0, $795 = 0, $795$hi = 0, $796 = 0, $796$hi = 0, $799 = 0, $799$hi = 0, $801 = 0, $801$hi = 0, $803 = 0, $803$hi = 0, $804 = 0, $804$hi = 0, $806 = 0, $806$hi = 0, $807 = 0, $807$hi = 0, $811 = 0, $811$hi = 0, $812 = 0, $812$hi = 0, $815 = 0, $815$hi = 0, $816 = 0, $816$hi = 0, $817$hi = 0, $825 = 0, $825$hi = 0, $826$hi = 0, $828 = 0, $828$hi = 0, $829$hi = 0, $831 = 0, $831$hi = 0, $833 = 0, $833$hi = 0, $834 = 0, $834$hi = 0, $836 = 0, $836$hi = 0, $837 = 0, $837$hi = 0, $840 = 0, $840$hi = 0, $842 = 0, $842$hi = 0, $844 = 0, $844$hi = 0, $845 = 0, $845$hi = 0, $847 = 0, $847$hi = 0, $848 = 0, $848$hi = 0, $852 = 0, $852$hi = 0, $853 = 0, $853$hi = 0, $856 = 0, $856$hi = 0, $857 = 0, $857$hi = 0, $858$hi = 0, $866 = 0, $866$hi = 0, $867$hi = 0, $869 = 0, $869$hi = 0, $870$hi = 0, $872 = 0, $872$hi = 0, $874 = 0, $874$hi = 0, $875 = 0, $875$hi = 0, $877 = 0, $877$hi = 0, $878 = 0, $878$hi = 0, $881 = 0, $881$hi = 0, $883 = 0, $883$hi = 0, $885 = 0, $885$hi = 0, $886 = 0, $886$hi = 0, $888 = 0, $888$hi = 0, $889 = 0, $889$hi = 0, $893 = 0, $893$hi = 0, $894 = 0, $894$hi = 0, $897 = 0, $897$hi = 0, $898 = 0, $898$hi = 0, $899$hi = 0, $907 = 0, $907$hi = 0, $908$hi = 0, $910 = 0, $910$hi = 0, $911$hi = 0, $913 = 0, $913$hi = 0, $915 = 0, $915$hi = 0, $916 = 0, $916$hi = 0, $918 = 0, $918$hi = 0, $919 = 0, $919$hi = 0, $922 = 0, $922$hi = 0, $924 = 0, $924$hi = 0, $926 = 0, $926$hi = 0, $927 = 0, $927$hi = 0, $929 = 0, $929$hi = 0, $930 = 0, $930$hi = 0, $934 = 0, $934$hi = 0, $935 = 0, $935$hi = 0, $938 = 0, $938$hi = 0, $939 = 0, $939$hi = 0, $940$hi = 0, $946 = 0, $946$hi = 0, $949 = 0, $949$hi = 0, $952 = 0, $952$hi = 0, $955$hi = 0, $959 = 0, $959$hi = 0, $960$hi = 0, $962 = 0, $962$hi = 0, $963$hi = 0, $965 = 0, $965$hi = 0, $967 = 0, $967$hi = 0, $968 = 0, $968$hi = 0, $970 = 0, $970$hi = 0, $971 = 0, $971$hi = 0, $974 = 0, $974$hi = 0, $976 = 0, $976$hi = 0, $978 = 0, $978$hi = 0, $979 = 0, $979$hi = 0, $981 = 0, $981$hi = 0, $982 = 0, $982$hi = 0, $986 = 0, $986$hi = 0, $987 = 0, $987$hi = 0, $990 = 0, $990$hi = 0, $991 = 0, $991$hi = 0, $992$hi = 0, $1000 = 0, $1000$hi = 0, $1001$hi = 0, $1003 = 0, $1003$hi = 0, $1004$hi = 0, $1006 = 0, $1006$hi = 0, $1008 = 0, $1008$hi = 0, $1009 = 0, $1009$hi = 0, $1011 = 0, $1011$hi = 0, $1012 = 0, $1012$hi = 0, $1015 = 0, $1015$hi = 0, $1017 = 0, $1017$hi = 0, $1019 = 0, $1019$hi = 0, $1020 = 0, $1020$hi = 0, $1022 = 0, $1022$hi = 0, $1023 = 0, $1023$hi = 0, $1027 = 0, $1027$hi = 0, $1028 = 0, $1028$hi = 0, $1031 = 0, $1031$hi = 0, $1032 = 0, $1032$hi = 0, $1033$hi = 0, $1041 = 0, $1041$hi = 0, $1042$hi = 0, $1044 = 0, $1044$hi = 0, $1045$hi = 0, $1047 = 0, $1047$hi = 0, $1049 = 0, $1049$hi = 0, $1050 = 0, $1050$hi = 0, $1052 = 0, $1052$hi = 0, $1053 = 0, $1053$hi = 0, $1056 = 0, $1056$hi = 0, $1058 = 0, $1058$hi = 0, $1060 = 0, $1060$hi = 0, $1061 = 0, $1061$hi = 0, $1063 = 0, $1063$hi = 0, $1064 = 0, $1064$hi = 0, $1068 = 0, $1068$hi = 0, $1069 = 0, $1069$hi = 0, $1072 = 0, $1072$hi = 0, $1073 = 0, $1073$hi = 0, $1074$hi = 0, $1082 = 0, $1082$hi = 0, $1083$hi = 0, $1085 = 0, $1085$hi = 0, $1086$hi = 0, $1088 = 0, $1088$hi = 0, $1090 = 0, $1090$hi = 0, $1091 = 0, $1091$hi = 0, $1093 = 0, $1093$hi = 0, $1094 = 0, $1094$hi = 0, $1097 = 0, $1097$hi = 0, $1099 = 0, $1099$hi = 0, $1101 = 0, $1101$hi = 0, $1102 = 0, $1102$hi = 0, $1104 = 0, $1104$hi = 0, $1105 = 0, $1105$hi = 0, $1109 = 0, $1109$hi = 0, $1110 = 0, $1110$hi = 0, $1113 = 0, $1113$hi = 0, $1114 = 0, $1114$hi = 0, $1115$hi = 0, $1121 = 0, $1121$hi = 0, $1124 = 0, $1124$hi = 0, $1127 = 0, $1127$hi = 0, $1130$hi = 0, $1134 = 0, $1134$hi = 0, $1135$hi = 0, $1137 = 0, $1137$hi = 0, $1138$hi = 0, $1140 = 0, $1140$hi = 0, $1142 = 0, $1142$hi = 0, $1143 = 0, $1143$hi = 0, $1145 = 0, $1145$hi = 0, $1146 = 0, $1146$hi = 0, $1149 = 0, $1149$hi = 0, $1151 = 0, $1151$hi = 0, $1153 = 0, $1153$hi = 0, $1154 = 0, $1154$hi = 0, $1156 = 0, $1156$hi = 0, $1157 = 0, $1157$hi = 0, $1161 = 0, $1161$hi = 0, $1162 = 0, $1162$hi = 0, $1165 = 0, $1165$hi = 0, $1166 = 0, $1166$hi = 0, $1167$hi = 0, $1175 = 0, $1175$hi = 0, $1176$hi = 0, $1178 = 0, $1178$hi = 0, $1179$hi = 0, $1181 = 0, $1181$hi = 0, $1183 = 0, $1183$hi = 0, $1184 = 0, $1184$hi = 0, $1186 = 0, $1186$hi = 0, $1187 = 0, $1187$hi = 0, $1190 = 0, $1190$hi = 0, $1192 = 0, $1192$hi = 0, $1194 = 0, $1194$hi = 0, $1195 = 0, $1195$hi = 0, $1197 = 0, $1197$hi = 0, $1198 = 0, $1198$hi = 0, $1202 = 0, $1202$hi = 0, $1203 = 0, $1203$hi = 0, $1206 = 0, $1206$hi = 0, $1207 = 0, $1207$hi = 0, $1208$hi = 0, $1216 = 0, $1216$hi = 0, $1217$hi = 0, $1219 = 0, $1219$hi = 0, $1220$hi = 0, $1222 = 0, $1222$hi = 0, $1224 = 0, $1224$hi = 0, $1225 = 0, $1225$hi = 0, $1227 = 0, $1227$hi = 0, $1228 = 0, $1228$hi = 0, $1231 = 0, $1231$hi = 0, $1233 = 0, $1233$hi = 0, $1235 = 0, $1235$hi = 0, $1236 = 0, $1236$hi = 0, $1238 = 0, $1238$hi = 0, $1239 = 0, $1239$hi = 0, $1243 = 0, $1243$hi = 0, $1244 = 0, $1244$hi = 0, $1247 = 0, $1247$hi = 0, $1248 = 0, $1248$hi = 0, $1249$hi = 0, $1257 = 0, $1257$hi = 0, $1258$hi = 0, $1260 = 0, $1260$hi = 0, $1261$hi = 0, $1263 = 0, $1263$hi = 0, $1265 = 0, $1265$hi = 0, $1266 = 0, $1266$hi = 0, $1268 = 0, $1268$hi = 0, $1269 = 0, $1269$hi = 0, $1272 = 0, $1272$hi = 0, $1274 = 0, $1274$hi = 0, $1276 = 0, $1276$hi = 0, $1277 = 0, $1277$hi = 0, $1279 = 0, $1279$hi = 0, $1280 = 0, $1280$hi = 0, $1284 = 0, $1284$hi = 0, $1285 = 0, $1285$hi = 0, $1288 = 0, $1288$hi = 0, $1289 = 0, $1289$hi = 0, $1290$hi = 0, $1296 = 0, $1296$hi = 0, $1299 = 0, $1299$hi = 0, $1302 = 0, $1302$hi = 0, $1305$hi = 0, $1309 = 0, $1309$hi = 0, $1310$hi = 0, $1312 = 0, $1312$hi = 0, $1313$hi = 0, $1315 = 0, $1315$hi = 0, $1317 = 0, $1317$hi = 0, $1318 = 0, $1318$hi = 0, $1320 = 0, $1320$hi = 0, $1321 = 0, $1321$hi = 0, $1324 = 0, $1324$hi = 0, $1326 = 0, $1326$hi = 0, $1328 = 0, $1328$hi = 0, $1329 = 0, $1329$hi = 0, $1331 = 0, $1331$hi = 0, $1332 = 0, $1332$hi = 0, $1336 = 0, $1336$hi = 0, $1337 = 0, $1337$hi = 0, $1340 = 0, $1340$hi = 0, $1341 = 0, $1341$hi = 0, $1342$hi = 0, $1350 = 0, $1350$hi = 0, $1351$hi = 0, $1353 = 0, $1353$hi = 0, $1354$hi = 0, $1356 = 0, $1356$hi = 0, $1358 = 0, $1358$hi = 0, $1359 = 0, $1359$hi = 0, $1361 = 0, $1361$hi = 0, $1362 = 0, $1362$hi = 0, $1365 = 0, $1365$hi = 0, $1367 = 0, $1367$hi = 0, $1369 = 0, $1369$hi = 0, $1370 = 0, $1370$hi = 0, $1372 = 0, $1372$hi = 0, $1373 = 0, $1373$hi = 0, $1377 = 0, $1377$hi = 0, $1378 = 0, $1378$hi = 0, $1381 = 0, $1381$hi = 0, $1382 = 0, $1382$hi = 0, $1383$hi = 0, $1391 = 0, $1391$hi = 0, $1392$hi = 0, $1394 = 0, $1394$hi = 0, $1395$hi = 0, $1397 = 0, $1397$hi = 0, $1399 = 0, $1399$hi = 0, $1400 = 0, $1400$hi = 0, $1402 = 0, $1402$hi = 0, $1403 = 0, $1403$hi = 0, $1406 = 0, $1406$hi = 0, $1408 = 0, $1408$hi = 0, $1410 = 0, $1410$hi = 0, $1411 = 0, $1411$hi = 0, $1413 = 0, $1413$hi = 0, $1414 = 0, $1414$hi = 0, $1418 = 0, $1418$hi = 0, $1419 = 0, $1419$hi = 0, $1422 = 0, $1422$hi = 0, $1423 = 0, $1423$hi = 0, $1424$hi = 0, $1432 = 0, $1432$hi = 0, $1433$hi = 0, $1435 = 0, $1435$hi = 0, $1436$hi = 0, $1438 = 0, $1438$hi = 0, $1440 = 0, $1440$hi = 0, $1441 = 0, $1441$hi = 0, $1443 = 0, $1443$hi = 0, $1444 = 0, $1444$hi = 0, $1447 = 0, $1447$hi = 0, $1449 = 0, $1449$hi = 0, $1451 = 0, $1451$hi = 0, $1452 = 0, $1452$hi = 0, $1454 = 0, $1454$hi = 0, $1455 = 0, $1455$hi = 0, $1459 = 0, $1459$hi = 0, $1460 = 0, $1460$hi = 0, $1463 = 0, $1463$hi = 0, $1464 = 0, $1464$hi = 0, $1465$hi = 0, $1471 = 0, $1471$hi = 0, $1474 = 0, $1474$hi = 0, $1477 = 0, $1477$hi = 0, $1480$hi = 0, $1484 = 0, $1484$hi = 0, $1485$hi = 0, $1487 = 0, $1487$hi = 0, $1488$hi = 0, $1490 = 0, $1490$hi = 0, $1492 = 0, $1492$hi = 0, $1493 = 0, $1493$hi = 0, $1495 = 0, $1495$hi = 0, $1496 = 0, $1496$hi = 0, $1499 = 0, $1499$hi = 0, $1501 = 0, $1501$hi = 0, $1503 = 0, $1503$hi = 0, $1504 = 0, $1504$hi = 0, $1506 = 0, $1506$hi = 0, $1507 = 0, $1507$hi = 0, $1511 = 0, $1511$hi = 0, $1512 = 0, $1512$hi = 0, $1515 = 0, $1515$hi = 0, $1516 = 0, $1516$hi = 0, $1517$hi = 0, $1525 = 0, $1525$hi = 0, $1526$hi = 0, $1528 = 0, $1528$hi = 0, $1529$hi = 0, $1531 = 0, $1531$hi = 0, $1533 = 0, $1533$hi = 0, $1534 = 0, $1534$hi = 0, $1536 = 0, $1536$hi = 0, $1537 = 0, $1537$hi = 0, $1540 = 0, $1540$hi = 0, $1542 = 0, $1542$hi = 0, $1544 = 0, $1544$hi = 0, $1545 = 0, $1545$hi = 0, $1547 = 0, $1547$hi = 0, $1548 = 0, $1548$hi = 0, $1552 = 0, $1552$hi = 0, $1553 = 0, $1553$hi = 0, $1556 = 0, $1556$hi = 0, $1557 = 0, $1557$hi = 0, $1558$hi = 0, $1566 = 0, $1566$hi = 0, $1567$hi = 0, $1569 = 0, $1569$hi = 0, $1570$hi = 0, $1572 = 0, $1572$hi = 0, $1574 = 0, $1574$hi = 0, $1575 = 0, $1575$hi = 0, $1577 = 0, $1577$hi = 0, $1578 = 0, $1578$hi = 0, $1581 = 0, $1581$hi = 0, $1583 = 0, $1583$hi = 0, $1585 = 0, $1585$hi = 0, $1586 = 0, $1586$hi = 0, $1588 = 0, $1588$hi = 0, $1589 = 0, $1589$hi = 0, $1593 = 0, $1593$hi = 0, $1594 = 0, $1594$hi = 0, $1597 = 0, $1597$hi = 0, $1598 = 0, $1598$hi = 0, $1599$hi = 0, $1607 = 0, $1607$hi = 0, $1608$hi = 0, $1610 = 0, $1610$hi = 0, $1611$hi = 0, $1613 = 0, $1613$hi = 0, $1615 = 0, $1615$hi = 0, $1616 = 0, $1616$hi = 0, $1618 = 0, $1618$hi = 0, $1619 = 0, $1619$hi = 0, $1622 = 0, $1622$hi = 0, $1624 = 0, $1624$hi = 0, $1626 = 0, $1626$hi = 0, $1627 = 0, $1627$hi = 0, $1629 = 0, $1629$hi = 0, $1630 = 0, $1630$hi = 0, $1634 = 0, $1634$hi = 0, $1635 = 0, $1635$hi = 0, $1638 = 0, $1638$hi = 0, $1639 = 0, $1639$hi = 0, $1640$hi = 0, $1646 = 0, $1646$hi = 0, $1649 = 0, $1649$hi = 0, $1652 = 0, $1652$hi = 0, $1655$hi = 0, $1659 = 0, $1659$hi = 0, $1660$hi = 0, $1662 = 0, $1662$hi = 0, $1663$hi = 0, $1665 = 0, $1665$hi = 0, $1667 = 0, $1667$hi = 0, $1668 = 0, $1668$hi = 0, $1670 = 0, $1670$hi = 0, $1671 = 0, $1671$hi = 0, $1674 = 0, $1674$hi = 0, $1676 = 0, $1676$hi = 0, $1678 = 0, $1678$hi = 0, $1679 = 0, $1679$hi = 0, $1681 = 0, $1681$hi = 0, $1682 = 0, $1682$hi = 0, $1686 = 0, $1686$hi = 0, $1687 = 0, $1687$hi = 0, $1690 = 0, $1690$hi = 0, $1691 = 0, $1691$hi = 0, $1692$hi = 0, $1700 = 0, $1700$hi = 0, $1701$hi = 0, $1703 = 0, $1703$hi = 0, $1704$hi = 0, $1706 = 0, $1706$hi = 0, $1708 = 0, $1708$hi = 0, $1709 = 0, $1709$hi = 0, $1711 = 0, $1711$hi = 0, $1712 = 0, $1712$hi = 0, $1715 = 0, $1715$hi = 0, $1717 = 0, $1717$hi = 0, $1719 = 0, $1719$hi = 0, $1720 = 0, $1720$hi = 0, $1722 = 0, $1722$hi = 0, $1723 = 0, $1723$hi = 0, $1727 = 0, $1727$hi = 0, $1728 = 0, $1728$hi = 0, $1731 = 0, $1731$hi = 0, $1732 = 0, $1732$hi = 0, $1733$hi = 0, $1741 = 0, $1741$hi = 0, $1742$hi = 0, $1744 = 0, $1744$hi = 0, $1745$hi = 0, $1747 = 0, $1747$hi = 0, $1749 = 0, $1749$hi = 0, $1750 = 0, $1750$hi = 0, $1752 = 0, $1752$hi = 0, $1753 = 0, $1753$hi = 0, $1756 = 0, $1756$hi = 0, $1758 = 0, $1758$hi = 0, $1760 = 0, $1760$hi = 0, $1761 = 0, $1761$hi = 0, $1763 = 0, $1763$hi = 0, $1764 = 0, $1764$hi = 0, $1768 = 0, $1768$hi = 0, $1769 = 0, $1769$hi = 0, $1772 = 0, $1772$hi = 0, $1773 = 0, $1773$hi = 0, $1774$hi = 0, $1782 = 0, $1782$hi = 0, $1783$hi = 0, $1785 = 0, $1785$hi = 0, $1786$hi = 0, $1788 = 0, $1788$hi = 0, $1790 = 0, $1790$hi = 0, $1791 = 0, $1791$hi = 0, $1793 = 0, $1793$hi = 0, $1794 = 0, $1794$hi = 0, $1797 = 0, $1797$hi = 0, $1799 = 0, $1799$hi = 0, $1801 = 0, $1801$hi = 0, $1802 = 0, $1802$hi = 0, $1804 = 0, $1804$hi = 0, $1805 = 0, $1805$hi = 0, $1809 = 0, $1809$hi = 0, $1810 = 0, $1810$hi = 0, $1813 = 0, $1813$hi = 0, $1814 = 0, $1814$hi = 0, $1815$hi = 0, $1821 = 0, $1821$hi = 0, $1824 = 0, $1824$hi = 0, $1827 = 0, $1827$hi = 0, $1830$hi = 0, $1834 = 0, $1834$hi = 0, $1835$hi = 0, $1837 = 0, $1837$hi = 0, $1838$hi = 0, $1840 = 0, $1840$hi = 0, $1842 = 0, $1842$hi = 0, $1843 = 0, $1843$hi = 0, $1845 = 0, $1845$hi = 0, $1846 = 0, $1846$hi = 0, $1849 = 0, $1849$hi = 0, $1851 = 0, $1851$hi = 0, $1853 = 0, $1853$hi = 0, $1854 = 0, $1854$hi = 0, $1856 = 0, $1856$hi = 0, $1857 = 0, $1857$hi = 0, $1861 = 0, $1861$hi = 0, $1862 = 0, $1862$hi = 0, $1865 = 0, $1865$hi = 0, $1866 = 0, $1866$hi = 0, $1867$hi = 0, $1875 = 0, $1875$hi = 0, $1876$hi = 0, $1878 = 0, $1878$hi = 0, $1879$hi = 0, $1881 = 0, $1881$hi = 0, $1883 = 0, $1883$hi = 0, $1884 = 0, $1884$hi = 0, $1886 = 0, $1886$hi = 0, $1887 = 0, $1887$hi = 0, $1890 = 0, $1890$hi = 0, $1892 = 0, $1892$hi = 0, $1894 = 0, $1894$hi = 0, $1895 = 0, $1895$hi = 0, $1897 = 0, $1897$hi = 0, $1898 = 0, $1898$hi = 0, $1902 = 0, $1902$hi = 0, $1903 = 0, $1903$hi = 0, $1906 = 0, $1906$hi = 0, $1907 = 0, $1907$hi = 0, $1908$hi = 0, $1916 = 0, $1916$hi = 0, $1917$hi = 0, $1919 = 0, $1919$hi = 0, $1920$hi = 0, $1922 = 0, $1922$hi = 0, $1924 = 0, $1924$hi = 0, $1925 = 0, $1925$hi = 0, $1927 = 0, $1927$hi = 0, $1928 = 0, $1928$hi = 0, $1931 = 0, $1931$hi = 0, $1933 = 0, $1933$hi = 0, $1935 = 0, $1935$hi = 0, $1936 = 0, $1936$hi = 0, $1938 = 0, $1938$hi = 0, $1939 = 0, $1939$hi = 0, $1943 = 0, $1943$hi = 0, $1944 = 0, $1944$hi = 0, $1947 = 0, $1947$hi = 0, $1948 = 0, $1948$hi = 0, $1949$hi = 0, $1957 = 0, $1957$hi = 0, $1958$hi = 0, $1960 = 0, $1960$hi = 0, $1961$hi = 0, $1963 = 0, $1963$hi = 0, $1965 = 0, $1965$hi = 0, $1966 = 0, $1966$hi = 0, $1968 = 0, $1968$hi = 0, $1969 = 0, $1969$hi = 0, $1972 = 0, $1972$hi = 0, $1974 = 0, $1974$hi = 0, $1976 = 0, $1976$hi = 0, $1977 = 0, $1977$hi = 0, $1979 = 0, $1979$hi = 0, $1980 = 0, $1980$hi = 0, $1984 = 0, $1984$hi = 0, $1985 = 0, $1985$hi = 0, $1988 = 0, $1988$hi = 0, $1989 = 0, $1989$hi = 0, $1990$hi = 0, $1996 = 0, $1996$hi = 0, $1999 = 0, $1999$hi = 0, $2002 = 0, $2002$hi = 0, $2005$hi = 0, $2009 = 0, $2009$hi = 0, $2010$hi = 0, $2012 = 0, $2012$hi = 0, $2013$hi = 0, $2015 = 0, $2015$hi = 0, $2017 = 0, $2017$hi = 0, $2018 = 0, $2018$hi = 0, $2020 = 0, $2020$hi = 0, $2021 = 0, $2021$hi = 0, $2024 = 0, $2024$hi = 0, $2026 = 0, $2026$hi = 0, $2028 = 0, $2028$hi = 0, $2029 = 0, $2029$hi = 0, $2031 = 0, $2031$hi = 0, $2032 = 0, $2032$hi = 0, $2036 = 0, $2036$hi = 0, $2037 = 0, $2037$hi = 0, $2040 = 0, $2040$hi = 0, $2041 = 0, $2041$hi = 0, $2042$hi = 0, $2050 = 0, $2050$hi = 0, $2051$hi = 0, $2053 = 0, $2053$hi = 0, $2054$hi = 0, $2056 = 0, $2056$hi = 0, $2058 = 0, $2058$hi = 0, $2059 = 0, $2059$hi = 0, $2061 = 0, $2061$hi = 0, $2062 = 0, $2062$hi = 0, $2065 = 0, $2065$hi = 0, $2067 = 0, $2067$hi = 0, $2069 = 0, $2069$hi = 0, $2070 = 0, $2070$hi = 0, $2072 = 0, $2072$hi = 0, $2073 = 0, $2073$hi = 0, $2077 = 0, $2077$hi = 0, $2078 = 0, $2078$hi = 0, $2081 = 0, $2081$hi = 0, $2082 = 0, $2082$hi = 0, $2083$hi = 0, $2091 = 0, $2091$hi = 0, $2092$hi = 0, $2094 = 0, $2094$hi = 0, $2095$hi = 0, $2097 = 0, $2097$hi = 0, $2099 = 0, $2099$hi = 0, $2100 = 0, $2100$hi = 0, $2102 = 0, $2102$hi = 0, $2103 = 0, $2103$hi = 0, $2106 = 0, $2106$hi = 0, $2108 = 0, $2108$hi = 0, $2110 = 0, $2110$hi = 0, $2111 = 0, $2111$hi = 0, $2113 = 0, $2113$hi = 0, $2114 = 0, $2114$hi = 0, $2118 = 0, $2118$hi = 0, $2119 = 0, $2119$hi = 0, $2122 = 0, $2122$hi = 0, $2123 = 0, $2123$hi = 0, $2124$hi = 0, $2132 = 0, $2132$hi = 0, $2133$hi = 0, $2135 = 0, $2135$hi = 0, $2136$hi = 0, $2138 = 0, $2138$hi = 0, $2140 = 0, $2140$hi = 0, $2141 = 0, $2141$hi = 0, $2143 = 0, $2143$hi = 0, $2144 = 0, $2144$hi = 0, $2147 = 0, $2147$hi = 0, $2149 = 0, $2149$hi = 0, $2151 = 0, $2151$hi = 0, $2152 = 0, $2152$hi = 0, $2154 = 0, $2154$hi = 0, $2155 = 0, $2155$hi = 0, $2159 = 0, $2159$hi = 0, $2160 = 0, $2160$hi = 0, $2163 = 0, $2163$hi = 0, $2164 = 0, $2164$hi = 0, $2165$hi = 0, $2171 = 0, $2171$hi = 0, $2174 = 0, $2174$hi = 0, $2177 = 0, $2177$hi = 0, $2180$hi = 0, $2184 = 0, $2184$hi = 0, $2185$hi = 0, $2187 = 0, $2187$hi = 0, $2188$hi = 0, $2190 = 0, $2190$hi = 0, $2192 = 0, $2192$hi = 0, $2193 = 0, $2193$hi = 0, $2195 = 0, $2195$hi = 0, $2196 = 0, $2196$hi = 0, $2199 = 0, $2199$hi = 0, $2201 = 0, $2201$hi = 0, $2203 = 0, $2203$hi = 0, $2204 = 0, $2204$hi = 0, $2206 = 0, $2206$hi = 0, $2207 = 0, $2207$hi = 0, $2211 = 0, $2211$hi = 0, $2212 = 0, $2212$hi = 0, $2215 = 0, $2215$hi = 0, $2216 = 0, $2216$hi = 0, $2217$hi = 0, $2225 = 0, $2225$hi = 0, $2226$hi = 0, $2228 = 0, $2228$hi = 0, $2229$hi = 0, $2231 = 0, $2231$hi = 0, $2233 = 0, $2233$hi = 0, $2234 = 0, $2234$hi = 0, $2236 = 0, $2236$hi = 0, $2237 = 0, $2237$hi = 0, $2240 = 0, $2240$hi = 0, $2242 = 0, $2242$hi = 0, $2244 = 0, $2244$hi = 0, $2245 = 0, $2245$hi = 0, $2247 = 0, $2247$hi = 0, $2248 = 0, $2248$hi = 0, $2252 = 0, $2252$hi = 0, $2253 = 0, $2253$hi = 0, $2256 = 0, $2256$hi = 0, $2257 = 0, $2257$hi = 0, $2258$hi = 0, $2266 = 0, $2266$hi = 0, $2267$hi = 0, $2269 = 0, $2269$hi = 0, $2270$hi = 0, $2272 = 0, $2272$hi = 0, $2274 = 0, $2274$hi = 0, $2275 = 0, $2275$hi = 0, $2277 = 0, $2277$hi = 0, $2278 = 0, $2278$hi = 0, $2281 = 0, $2281$hi = 0, $2283 = 0, $2283$hi = 0, $2285 = 0, $2285$hi = 0, $2286 = 0, $2286$hi = 0, $2288 = 0, $2288$hi = 0, $2289 = 0, $2289$hi = 0, $2293 = 0, $2293$hi = 0, $2294 = 0, $2294$hi = 0, $2297 = 0, $2297$hi = 0, $2298 = 0, $2298$hi = 0, $2299$hi = 0, $2307 = 0, $2307$hi = 0, $2308$hi = 0, $2310 = 0, $2310$hi = 0, $2311$hi = 0, $2313 = 0, $2313$hi = 0, $2315 = 0, $2315$hi = 0, $2316 = 0, $2316$hi = 0, $2318 = 0, $2318$hi = 0, $2319 = 0, $2319$hi = 0, $2322 = 0, $2322$hi = 0, $2324 = 0, $2324$hi = 0, $2326 = 0, $2326$hi = 0, $2327 = 0, $2327$hi = 0, $2329 = 0, $2329$hi = 0, $2330 = 0, $2330$hi = 0, $2334 = 0, $2334$hi = 0, $2335 = 0, $2335$hi = 0, $2338 = 0, $2338$hi = 0, $2339 = 0, $2339$hi = 0, $2340$hi = 0, $2346 = 0, $2346$hi = 0, $2349 = 0, $2349$hi = 0, $2352 = 0, $2352$hi = 0, $2355$hi = 0, $2359 = 0, $2359$hi = 0, $2360$hi = 0, $2362 = 0, $2362$hi = 0, $2363$hi = 0, $2365 = 0, $2365$hi = 0, $2367 = 0, $2367$hi = 0, $2368 = 0, $2368$hi = 0, $2370 = 0, $2370$hi = 0, $2371 = 0, $2371$hi = 0, $2374 = 0, $2374$hi = 0, $2376 = 0, $2376$hi = 0, $2378 = 0, $2378$hi = 0, $2379 = 0, $2379$hi = 0, $2381 = 0, $2381$hi = 0, $2382 = 0, $2382$hi = 0, $2386 = 0, $2386$hi = 0, $2387 = 0, $2387$hi = 0, $2390 = 0, $2390$hi = 0, $2391 = 0, $2391$hi = 0, $2392$hi = 0, $2400 = 0, $2400$hi = 0, $2401$hi = 0, $2403 = 0, $2403$hi = 0, $2404$hi = 0, $2406 = 0, $2406$hi = 0, $2408 = 0, $2408$hi = 0, $2409 = 0, $2409$hi = 0, $2411 = 0, $2411$hi = 0, $2412 = 0, $2412$hi = 0, $2415 = 0, $2415$hi = 0, $2417 = 0, $2417$hi = 0, $2419 = 0, $2419$hi = 0, $2420 = 0, $2420$hi = 0, $2422 = 0, $2422$hi = 0, $2423 = 0, $2423$hi = 0, $2427 = 0, $2427$hi = 0, $2428 = 0, $2428$hi = 0, $2431 = 0, $2431$hi = 0, $2432 = 0, $2432$hi = 0, $2433$hi = 0, $2441 = 0, $2441$hi = 0, $2442$hi = 0, $2444 = 0, $2444$hi = 0, $2445$hi = 0, $2447 = 0, $2447$hi = 0, $2449 = 0, $2449$hi = 0, $2450 = 0, $2450$hi = 0, $2452 = 0, $2452$hi = 0, $2453 = 0, $2453$hi = 0, $2456 = 0, $2456$hi = 0, $2458 = 0, $2458$hi = 0, $2460 = 0, $2460$hi = 0, $2461 = 0, $2461$hi = 0, $2463 = 0, $2463$hi = 0, $2464 = 0, $2464$hi = 0, $2468 = 0, $2468$hi = 0, $2469 = 0, $2469$hi = 0, $2472 = 0, $2472$hi = 0, $2473 = 0, $2473$hi = 0, $2474$hi = 0, $2482 = 0, $2482$hi = 0, $2483$hi = 0, $2485 = 0, $2485$hi = 0, $2486$hi = 0, $2488 = 0, $2488$hi = 0, $2490 = 0, $2490$hi = 0, $2491 = 0, $2491$hi = 0, $2493 = 0, $2493$hi = 0, $2494 = 0, $2494$hi = 0, $2497 = 0, $2497$hi = 0, $2499 = 0, $2499$hi = 0, $2501 = 0, $2501$hi = 0, $2502 = 0, $2502$hi = 0, $2504 = 0, $2504$hi = 0, $2505 = 0, $2505$hi = 0, $2509 = 0, $2509$hi = 0, $2510 = 0, $2510$hi = 0, $2513 = 0, $2513$hi = 0, $2514 = 0, $2514$hi = 0, $2515$hi = 0, $2521 = 0, $2521$hi = 0, $2524 = 0, $2524$hi = 0, $2527 = 0, $2527$hi = 0, $2530$hi = 0, $2534 = 0, $2534$hi = 0, $2535$hi = 0, $2537 = 0, $2537$hi = 0, $2538$hi = 0, $2540 = 0, $2540$hi = 0, $2542 = 0, $2542$hi = 0, $2543 = 0, $2543$hi = 0, $2545 = 0, $2545$hi = 0, $2546 = 0, $2546$hi = 0, $2549 = 0, $2549$hi = 0, $2551 = 0, $2551$hi = 0, $2553 = 0, $2553$hi = 0, $2554 = 0, $2554$hi = 0, $2556 = 0, $2556$hi = 0, $2557 = 0, $2557$hi = 0, $2561 = 0, $2561$hi = 0, $2562 = 0, $2562$hi = 0, $2565 = 0, $2565$hi = 0, $2566 = 0, $2566$hi = 0, $2567$hi = 0, $2575 = 0, $2575$hi = 0, $2576$hi = 0, $2578 = 0, $2578$hi = 0, $2579$hi = 0, $2581 = 0, $2581$hi = 0, $2583 = 0, $2583$hi = 0, $2584 = 0, $2584$hi = 0, $2586 = 0, $2586$hi = 0, $2587 = 0, $2587$hi = 0, $2590 = 0, $2590$hi = 0, $2592 = 0, $2592$hi = 0, $2594 = 0, $2594$hi = 0, $2595 = 0, $2595$hi = 0, $2597 = 0, $2597$hi = 0, $2598 = 0, $2598$hi = 0, $2602 = 0, $2602$hi = 0, $2603 = 0, $2603$hi = 0, $2606 = 0, $2606$hi = 0, $2607 = 0, $2607$hi = 0, $2608$hi = 0, $2616 = 0, $2616$hi = 0, $2617$hi = 0, $2619 = 0, $2619$hi = 0, $2620$hi = 0, $2622 = 0, $2622$hi = 0, $2624 = 0, $2624$hi = 0, $2625 = 0, $2625$hi = 0, $2627 = 0, $2627$hi = 0, $2628 = 0, $2628$hi = 0, $2631 = 0, $2631$hi = 0, $2633 = 0, $2633$hi = 0, $2635 = 0, $2635$hi = 0, $2636 = 0, $2636$hi = 0, $2638 = 0, $2638$hi = 0, $2639 = 0, $2639$hi = 0, $2643 = 0, $2643$hi = 0, $2644 = 0, $2644$hi = 0, $2647 = 0, $2647$hi = 0, $2648 = 0, $2648$hi = 0, $2649$hi = 0, $2657 = 0, $2657$hi = 0, $2658$hi = 0, $2660 = 0, $2660$hi = 0, $2661$hi = 0, $2663 = 0, $2663$hi = 0, $2665 = 0, $2665$hi = 0, $2666 = 0, $2666$hi = 0, $2668 = 0, $2668$hi = 0, $2669 = 0, $2669$hi = 0, $2672 = 0, $2672$hi = 0, $2674 = 0, $2674$hi = 0, $2676 = 0, $2676$hi = 0, $2677 = 0, $2677$hi = 0, $2679 = 0, $2679$hi = 0, $2680 = 0, $2680$hi = 0, $2684 = 0, $2684$hi = 0, $2685 = 0, $2685$hi = 0, $2688 = 0, $2688$hi = 0, $2689 = 0, $2689$hi = 0, $2690$hi = 0, $2696 = 0, $2696$hi = 0, $2699 = 0, $2699$hi = 0, $2702 = 0, $2702$hi = 0, $2705$hi = 0, $2709 = 0, $2709$hi = 0, $2710$hi = 0, $2712 = 0, $2712$hi = 0, $2713$hi = 0, $2715 = 0, $2715$hi = 0, $2717 = 0, $2717$hi = 0, $2718 = 0, $2718$hi = 0, $2720 = 0, $2720$hi = 0, $2721 = 0, $2721$hi = 0, $2724 = 0, $2724$hi = 0, $2726 = 0, $2726$hi = 0, $2728 = 0, $2728$hi = 0, $2729 = 0, $2729$hi = 0, $2731 = 0, $2731$hi = 0, $2732 = 0, $2732$hi = 0, $2736 = 0, $2736$hi = 0, $2737 = 0, $2737$hi = 0, $2740 = 0, $2740$hi = 0, $2741 = 0, $2741$hi = 0, $2742$hi = 0, $2750 = 0, $2750$hi = 0, $2751$hi = 0, $2753 = 0, $2753$hi = 0, $2754$hi = 0, $2756 = 0, $2756$hi = 0, $2758 = 0, $2758$hi = 0, $2759 = 0, $2759$hi = 0, $2761 = 0, $2761$hi = 0, $2762 = 0, $2762$hi = 0, $2765 = 0, $2765$hi = 0, $2767 = 0, $2767$hi = 0, $2769 = 0, $2769$hi = 0, $2770 = 0, $2770$hi = 0, $2772 = 0, $2772$hi = 0, $2773 = 0, $2773$hi = 0, $2777 = 0, $2777$hi = 0, $2778 = 0, $2778$hi = 0, $2781 = 0, $2781$hi = 0, $2782 = 0, $2782$hi = 0, $2783$hi = 0, $2791 = 0, $2791$hi = 0, $2792$hi = 0, $2794 = 0, $2794$hi = 0, $2795$hi = 0, $2797 = 0, $2797$hi = 0, $2799 = 0, $2799$hi = 0, $2800 = 0, $2800$hi = 0, $2802 = 0, $2802$hi = 0, $2803 = 0, $2803$hi = 0, $2806 = 0, $2806$hi = 0, $2808 = 0, $2808$hi = 0, $2810 = 0, $2810$hi = 0, $2811 = 0, $2811$hi = 0, $2813 = 0, $2813$hi = 0, $2814 = 0, $2814$hi = 0, $2818 = 0, $2818$hi = 0, $2819 = 0, $2819$hi = 0, $2822 = 0, $2822$hi = 0, $2823 = 0, $2823$hi = 0, $2824$hi = 0, $2832 = 0, $2832$hi = 0, $2833$hi = 0, $2835 = 0, $2835$hi = 0, $2836$hi = 0, $2838 = 0, $2838$hi = 0, $2840 = 0, $2840$hi = 0, $2841 = 0, $2841$hi = 0, $2843 = 0, $2843$hi = 0, $2844 = 0, $2844$hi = 0, $2847 = 0, $2847$hi = 0, $2849 = 0, $2849$hi = 0, $2851 = 0, $2851$hi = 0, $2852 = 0, $2852$hi = 0, $2854 = 0, $2854$hi = 0, $2855 = 0, $2855$hi = 0, $2859 = 0, $2859$hi = 0, $2860 = 0, $2860$hi = 0, $2863 = 0, $2863$hi = 0, $2864 = 0, $2864$hi = 0, $2865$hi = 0, $2871 = 0, $2871$hi = 0, $2874 = 0, $2874$hi = 0, $2877 = 0, $2877$hi = 0, $2880$hi = 0, $2884 = 0, $2884$hi = 0, $2885$hi = 0, $2887 = 0, $2887$hi = 0, $2888$hi = 0, $2890 = 0, $2890$hi = 0, $2892 = 0, $2892$hi = 0, $2893 = 0, $2893$hi = 0, $2895 = 0, $2895$hi = 0, $2896 = 0, $2896$hi = 0, $2899 = 0, $2899$hi = 0, $2901 = 0, $2901$hi = 0, $2903 = 0, $2903$hi = 0, $2904 = 0, $2904$hi = 0, $2906 = 0, $2906$hi = 0, $2907 = 0, $2907$hi = 0, $2911 = 0, $2911$hi = 0, $2912 = 0, $2912$hi = 0, $2915 = 0, $2915$hi = 0, $2916 = 0, $2916$hi = 0, $2917$hi = 0, $2925 = 0, $2925$hi = 0, $2926$hi = 0, $2928 = 0, $2928$hi = 0, $2929$hi = 0, $2931 = 0, $2931$hi = 0, $2933 = 0, $2933$hi = 0, $2934 = 0, $2934$hi = 0, $2936 = 0, $2936$hi = 0, $2937 = 0, $2937$hi = 0, $2940 = 0, $2940$hi = 0, $2942 = 0, $2942$hi = 0, $2944 = 0, $2944$hi = 0, $2945 = 0, $2945$hi = 0, $2947 = 0, $2947$hi = 0, $2948 = 0, $2948$hi = 0, $2952 = 0, $2952$hi = 0, $2953 = 0, $2953$hi = 0, $2956 = 0, $2956$hi = 0, $2957 = 0, $2957$hi = 0, $2958$hi = 0, $2966 = 0, $2966$hi = 0, $2967$hi = 0, $2969 = 0, $2969$hi = 0, $2970$hi = 0, $2972 = 0, $2972$hi = 0, $2974 = 0, $2974$hi = 0, $2975 = 0, $2975$hi = 0, $2977 = 0, $2977$hi = 0, $2978 = 0, $2978$hi = 0, $2981 = 0, $2981$hi = 0, $2983 = 0, $2983$hi = 0, $2985 = 0, $2985$hi = 0, $2986 = 0, $2986$hi = 0, $2988 = 0, $2988$hi = 0, $2989 = 0, $2989$hi = 0, $2993 = 0, $2993$hi = 0, $2994 = 0, $2994$hi = 0, $2997 = 0, $2997$hi = 0, $2998 = 0, $2998$hi = 0, $2999$hi = 0, $3007 = 0, $3007$hi = 0, $3008$hi = 0, $3010 = 0, $3010$hi = 0, $3011$hi = 0, $3013 = 0, $3013$hi = 0, $3015 = 0, $3015$hi = 0, $3016 = 0, $3016$hi = 0, $3018 = 0, $3018$hi = 0, $3019 = 0, $3019$hi = 0, $3022 = 0, $3022$hi = 0, $3024 = 0, $3024$hi = 0, $3026 = 0, $3026$hi = 0, $3027 = 0, $3027$hi = 0, $3029 = 0, $3029$hi = 0, $3030 = 0, $3030$hi = 0, $3034 = 0, $3034$hi = 0, $3035 = 0, $3035$hi = 0, $3038 = 0, $3038$hi = 0, $3039 = 0, $3039$hi = 0, $3040$hi = 0, $3046 = 0, $3046$hi = 0, $3049 = 0, $3049$hi = 0, $3052 = 0, $3052$hi = 0, $3055$hi = 0, $3059 = 0, $3059$hi = 0, $3060$hi = 0, $3062 = 0, $3062$hi = 0, $3063$hi = 0, $3065 = 0, $3065$hi = 0, $3067 = 0, $3067$hi = 0, $3068 = 0, $3068$hi = 0, $3070 = 0, $3070$hi = 0, $3071 = 0, $3071$hi = 0, $3074 = 0, $3074$hi = 0, $3076 = 0, $3076$hi = 0, $3078 = 0, $3078$hi = 0, $3079 = 0, $3079$hi = 0, $3081 = 0, $3081$hi = 0, $3082 = 0, $3082$hi = 0, $3086 = 0, $3086$hi = 0, $3087 = 0, $3087$hi = 0, $3090 = 0, $3090$hi = 0, $3091 = 0, $3091$hi = 0, $3092$hi = 0, $3100 = 0, $3100$hi = 0, $3101$hi = 0, $3103 = 0, $3103$hi = 0, $3104$hi = 0, $3106 = 0, $3106$hi = 0, $3108 = 0, $3108$hi = 0, $3109 = 0, $3109$hi = 0, $3111 = 0, $3111$hi = 0, $3112 = 0, $3112$hi = 0, $3115 = 0, $3115$hi = 0, $3117 = 0, $3117$hi = 0, $3119 = 0, $3119$hi = 0, $3120 = 0, $3120$hi = 0, $3122 = 0, $3122$hi = 0, $3123 = 0, $3123$hi = 0, $3127 = 0, $3127$hi = 0, $3128 = 0, $3128$hi = 0, $3131 = 0, $3131$hi = 0, $3132 = 0, $3132$hi = 0, $3133$hi = 0, $3141 = 0, $3141$hi = 0, $3142$hi = 0, $3144 = 0, $3144$hi = 0, $3145$hi = 0, $3147 = 0, $3147$hi = 0, $3149 = 0, $3149$hi = 0, $3150 = 0, $3150$hi = 0, $3152 = 0, $3152$hi = 0, $3153 = 0, $3153$hi = 0, $3156 = 0, $3156$hi = 0, $3158 = 0, $3158$hi = 0, $3160 = 0, $3160$hi = 0, $3161 = 0, $3161$hi = 0, $3163 = 0, $3163$hi = 0, $3164 = 0, $3164$hi = 0, $3168 = 0, $3168$hi = 0, $3169 = 0, $3169$hi = 0, $3172 = 0, $3172$hi = 0, $3173 = 0, $3173$hi = 0, $3174$hi = 0, $3182 = 0, $3182$hi = 0, $3183$hi = 0, $3185 = 0, $3185$hi = 0, $3186$hi = 0, $3188 = 0, $3188$hi = 0, $3190 = 0, $3190$hi = 0, $3191 = 0, $3191$hi = 0, $3193 = 0, $3193$hi = 0, $3194 = 0, $3194$hi = 0, $3197 = 0, $3197$hi = 0, $3199 = 0, $3199$hi = 0, $3201 = 0, $3201$hi = 0, $3202 = 0, $3202$hi = 0, $3204 = 0, $3204$hi = 0, $3205 = 0, $3205$hi = 0, $3209 = 0, $3209$hi = 0, $3210 = 0, $3210$hi = 0, $3213 = 0, $3213$hi = 0, $3214 = 0, $3214$hi = 0, $3215$hi = 0, $3221 = 0, $3221$hi = 0, $3224 = 0, $3224$hi = 0, $3227 = 0, $3227$hi = 0, $3230$hi = 0, $3234 = 0, $3234$hi = 0, $3235$hi = 0, $3237 = 0, $3237$hi = 0, $3238$hi = 0, $3240 = 0, $3240$hi = 0, $3242 = 0, $3242$hi = 0, $3243 = 0, $3243$hi = 0, $3245 = 0, $3245$hi = 0, $3246 = 0, $3246$hi = 0, $3249 = 0, $3249$hi = 0, $3251 = 0, $3251$hi = 0, $3253 = 0, $3253$hi = 0, $3254 = 0, $3254$hi = 0, $3256 = 0, $3256$hi = 0, $3257 = 0, $3257$hi = 0, $3261 = 0, $3261$hi = 0, $3262 = 0, $3262$hi = 0, $3265 = 0, $3265$hi = 0, $3266 = 0, $3266$hi = 0, $3267$hi = 0, $3275 = 0, $3275$hi = 0, $3276$hi = 0, $3278 = 0, $3278$hi = 0, $3279$hi = 0, $3281 = 0, $3281$hi = 0, $3283 = 0, $3283$hi = 0, $3284 = 0, $3284$hi = 0, $3286 = 0, $3286$hi = 0, $3287 = 0, $3287$hi = 0, $3290 = 0, $3290$hi = 0, $3292 = 0, $3292$hi = 0, $3294 = 0, $3294$hi = 0, $3295 = 0, $3295$hi = 0, $3297 = 0, $3297$hi = 0, $3298 = 0, $3298$hi = 0, $3302 = 0, $3302$hi = 0, $3303 = 0, $3303$hi = 0, $3306 = 0, $3306$hi = 0, $3307 = 0, $3307$hi = 0, $3308$hi = 0, $3316 = 0, $3316$hi = 0, $3317$hi = 0, $3319 = 0, $3319$hi = 0, $3320$hi = 0, $3322 = 0, $3322$hi = 0, $3324 = 0, $3324$hi = 0, $3325 = 0, $3325$hi = 0, $3327 = 0, $3327$hi = 0, $3328 = 0, $3328$hi = 0, $3331 = 0, $3331$hi = 0, $3333 = 0, $3333$hi = 0, $3335 = 0, $3335$hi = 0, $3336 = 0, $3336$hi = 0, $3338 = 0, $3338$hi = 0, $3339 = 0, $3339$hi = 0, $3343 = 0, $3343$hi = 0, $3344 = 0, $3344$hi = 0, $3347 = 0, $3347$hi = 0, $3348 = 0, $3348$hi = 0, $3349$hi = 0, $3357 = 0, $3357$hi = 0, $3358$hi = 0, $3360 = 0, $3360$hi = 0, $3361$hi = 0, $3363 = 0, $3363$hi = 0, $3365 = 0, $3365$hi = 0, $3366 = 0, $3366$hi = 0, $3368 = 0, $3368$hi = 0, $3369 = 0, $3369$hi = 0, $3372 = 0, $3372$hi = 0, $3374 = 0, $3374$hi = 0, $3376 = 0, $3376$hi = 0, $3377 = 0, $3377$hi = 0, $3379 = 0, $3379$hi = 0, $3380 = 0, $3380$hi = 0, $3384 = 0, $3384$hi = 0, $3385 = 0, $3385$hi = 0, $3388 = 0, $3388$hi = 0, $3389 = 0, $3389$hi = 0, $3390$hi = 0, $3396 = 0, $3396$hi = 0, $3399 = 0, $3399$hi = 0, $3402 = 0, $3402$hi = 0, $3405$hi = 0, $3409 = 0, $3409$hi = 0, $3410$hi = 0, $3412 = 0, $3412$hi = 0, $3413$hi = 0, $3415 = 0, $3415$hi = 0, $3417 = 0, $3417$hi = 0, $3418 = 0, $3418$hi = 0, $3420 = 0, $3420$hi = 0, $3421 = 0, $3421$hi = 0, $3424 = 0, $3424$hi = 0, $3426 = 0, $3426$hi = 0, $3428 = 0, $3428$hi = 0, $3429 = 0, $3429$hi = 0, $3431 = 0, $3431$hi = 0, $3432 = 0, $3432$hi = 0, $3436 = 0, $3436$hi = 0, $3437 = 0, $3437$hi = 0, $3440 = 0, $3440$hi = 0, $3441 = 0, $3441$hi = 0, $3442$hi = 0, $3450 = 0, $3450$hi = 0, $3451$hi = 0, $3453 = 0, $3453$hi = 0, $3454$hi = 0, $3456 = 0, $3456$hi = 0, $3458 = 0, $3458$hi = 0, $3459 = 0, $3459$hi = 0, $3461 = 0, $3461$hi = 0, $3462 = 0, $3462$hi = 0, $3465 = 0, $3465$hi = 0, $3467 = 0, $3467$hi = 0, $3469 = 0, $3469$hi = 0, $3470 = 0, $3470$hi = 0, $3472 = 0, $3472$hi = 0, $3473 = 0, $3473$hi = 0, $3477 = 0, $3477$hi = 0, $3478 = 0, $3478$hi = 0, $3481 = 0, $3481$hi = 0, $3482 = 0, $3482$hi = 0, $3483$hi = 0, $3491 = 0, $3491$hi = 0, $3492$hi = 0, $3494 = 0, $3494$hi = 0, $3495$hi = 0, $3497 = 0, $3497$hi = 0, $3499 = 0, $3499$hi = 0, $3500 = 0, $3500$hi = 0, $3502 = 0, $3502$hi = 0, $3503 = 0, $3503$hi = 0, $3506 = 0, $3506$hi = 0, $3508 = 0, $3508$hi = 0, $3510 = 0, $3510$hi = 0, $3511 = 0, $3511$hi = 0, $3513 = 0, $3513$hi = 0, $3514 = 0, $3514$hi = 0, $3518 = 0, $3518$hi = 0, $3519 = 0, $3519$hi = 0, $3522 = 0, $3522$hi = 0, $3523 = 0, $3523$hi = 0, $3524$hi = 0, $3532 = 0, $3532$hi = 0, $3533$hi = 0, $3535 = 0, $3535$hi = 0, $3536$hi = 0, $3538 = 0, $3538$hi = 0, $3540 = 0, $3540$hi = 0, $3541 = 0, $3541$hi = 0, $3543 = 0, $3543$hi = 0, $3544 = 0, $3544$hi = 0, $3547 = 0, $3547$hi = 0, $3549 = 0, $3549$hi = 0, $3551 = 0, $3551$hi = 0, $3552 = 0, $3552$hi = 0, $3554 = 0, $3554$hi = 0, $3555 = 0, $3555$hi = 0, $3559 = 0, $3559$hi = 0, $3560 = 0, $3560$hi = 0, $3563 = 0, $3563$hi = 0, $3564 = 0, $3564$hi = 0, $3565$hi = 0, $3571 = 0, $3571$hi = 0, $3574 = 0, $3574$hi = 0, $3577 = 0, $3577$hi = 0, $3580$hi = 0, $3584 = 0, $3584$hi = 0, $3585$hi = 0, $3587 = 0, $3587$hi = 0, $3588$hi = 0, $3590 = 0, $3590$hi = 0, $3592 = 0, $3592$hi = 0, $3593 = 0, $3593$hi = 0, $3595 = 0, $3595$hi = 0, $3596 = 0, $3596$hi = 0, $3599 = 0, $3599$hi = 0, $3601 = 0, $3601$hi = 0, $3603 = 0, $3603$hi = 0, $3604 = 0, $3604$hi = 0, $3606 = 0, $3606$hi = 0, $3607 = 0, $3607$hi = 0, $3611 = 0, $3611$hi = 0, $3612 = 0, $3612$hi = 0, $3615 = 0, $3615$hi = 0, $3616 = 0, $3616$hi = 0, $3617$hi = 0, $3625 = 0, $3625$hi = 0, $3626$hi = 0, $3628 = 0, $3628$hi = 0, $3629$hi = 0, $3631 = 0, $3631$hi = 0, $3633 = 0, $3633$hi = 0, $3634 = 0, $3634$hi = 0, $3636 = 0, $3636$hi = 0, $3637 = 0, $3637$hi = 0, $3640 = 0, $3640$hi = 0, $3642 = 0, $3642$hi = 0, $3644 = 0, $3644$hi = 0, $3645 = 0, $3645$hi = 0, $3647 = 0, $3647$hi = 0, $3648 = 0, $3648$hi = 0, $3652 = 0, $3652$hi = 0, $3653 = 0, $3653$hi = 0, $3656 = 0, $3656$hi = 0, $3657 = 0, $3657$hi = 0, $3658$hi = 0, $3666 = 0, $3666$hi = 0, $3667$hi = 0, $3669 = 0, $3669$hi = 0, $3670$hi = 0, $3672 = 0, $3672$hi = 0, $3674 = 0, $3674$hi = 0, $3675 = 0, $3675$hi = 0, $3677 = 0, $3677$hi = 0, $3678 = 0, $3678$hi = 0, $3681 = 0, $3681$hi = 0, $3683 = 0, $3683$hi = 0, $3685 = 0, $3685$hi = 0, $3686 = 0, $3686$hi = 0, $3688 = 0, $3688$hi = 0, $3689 = 0, $3689$hi = 0, $3693 = 0, $3693$hi = 0, $3694 = 0, $3694$hi = 0, $3697 = 0, $3697$hi = 0, $3698 = 0, $3698$hi = 0, $3699$hi = 0, $3707 = 0, $3707$hi = 0, $3708$hi = 0, $3710 = 0, $3710$hi = 0, $3711$hi = 0, $3713 = 0, $3713$hi = 0, $3715 = 0, $3715$hi = 0, $3716 = 0, $3716$hi = 0, $3718 = 0, $3718$hi = 0, $3719 = 0, $3719$hi = 0, $3722 = 0, $3722$hi = 0, $3724 = 0, $3724$hi = 0, $3726 = 0, $3726$hi = 0, $3727 = 0, $3727$hi = 0, $3729 = 0, $3729$hi = 0, $3730 = 0, $3730$hi = 0, $3734 = 0, $3734$hi = 0, $3735 = 0, $3735$hi = 0, $3738 = 0, $3738$hi = 0, $3739 = 0, $3739$hi = 0, $3740$hi = 0, $3746 = 0, $3746$hi = 0, $3749 = 0, $3749$hi = 0, $3752 = 0, $3752$hi = 0, $3755$hi = 0, $3759 = 0, $3759$hi = 0, $3760$hi = 0, $3762 = 0, $3762$hi = 0, $3763$hi = 0, $3765 = 0, $3765$hi = 0, $3767 = 0, $3767$hi = 0, $3768 = 0, $3768$hi = 0, $3770 = 0, $3770$hi = 0, $3771 = 0, $3771$hi = 0, $3774 = 0, $3774$hi = 0, $3776 = 0, $3776$hi = 0, $3778 = 0, $3778$hi = 0, $3779 = 0, $3779$hi = 0, $3781 = 0, $3781$hi = 0, $3782 = 0, $3782$hi = 0, $3786 = 0, $3786$hi = 0, $3787 = 0, $3787$hi = 0, $3790 = 0, $3790$hi = 0, $3791 = 0, $3791$hi = 0, $3792$hi = 0, $3800 = 0, $3800$hi = 0, $3801$hi = 0, $3803 = 0, $3803$hi = 0, $3804$hi = 0, $3806 = 0, $3806$hi = 0, $3808 = 0, $3808$hi = 0, $3809 = 0, $3809$hi = 0, $3811 = 0, $3811$hi = 0, $3812 = 0, $3812$hi = 0, $3815 = 0, $3815$hi = 0, $3817 = 0, $3817$hi = 0, $3819 = 0, $3819$hi = 0, $3820 = 0, $3820$hi = 0, $3822 = 0, $3822$hi = 0, $3823 = 0, $3823$hi = 0, $3827 = 0, $3827$hi = 0, $3828 = 0, $3828$hi = 0, $3831 = 0, $3831$hi = 0, $3832 = 0, $3832$hi = 0, $3833$hi = 0, $3841 = 0, $3841$hi = 0, $3842$hi = 0, $3844 = 0, $3844$hi = 0, $3845$hi = 0, $3847 = 0, $3847$hi = 0, $3849 = 0, $3849$hi = 0, $3850 = 0, $3850$hi = 0, $3852 = 0, $3852$hi = 0, $3853 = 0, $3853$hi = 0, $3856 = 0, $3856$hi = 0, $3858 = 0, $3858$hi = 0, $3860 = 0, $3860$hi = 0, $3861 = 0, $3861$hi = 0, $3863 = 0, $3863$hi = 0, $3864 = 0, $3864$hi = 0, $3868 = 0, $3868$hi = 0, $3869 = 0, $3869$hi = 0, $3872 = 0, $3872$hi = 0, $3873 = 0, $3873$hi = 0, $3874$hi = 0, $3882 = 0, $3882$hi = 0, $3883$hi = 0, $3885 = 0, $3885$hi = 0, $3886$hi = 0, $3888 = 0, $3888$hi = 0, $3890 = 0, $3890$hi = 0, $3891 = 0, $3891$hi = 0, $3893 = 0, $3893$hi = 0, $3894 = 0, $3894$hi = 0, $3897 = 0, $3897$hi = 0, $3899 = 0, $3899$hi = 0, $3901 = 0, $3901$hi = 0, $3902 = 0, $3902$hi = 0, $3904 = 0, $3904$hi = 0, $3905 = 0, $3905$hi = 0, $3909 = 0, $3909$hi = 0, $3910 = 0, $3910$hi = 0, $3913 = 0, $3913$hi = 0, $3914 = 0, $3914$hi = 0, $3915$hi = 0, $3923 = 0, $3924 = 0, $3924$hi = 0, $3926 = 0, $3926$hi = 0, $3928 = 0, $3928$hi = 0, $3929 = 0, $3929$hi = 0, $3931 = 0, $3931$hi = 0, $3932 = 0, $3932$hi = 0, $3936 = 0, $3936$hi = 0, $3937 = 0, $3937$hi = 0, $3940 = 0, $3940$hi = 0, $3941 = 0, $3941$hi = 0, $3942$hi = 0, $3946 = 0, $3946$hi = 0, $3948 = 0, $3948$hi = 0, $3949 = 0, $3949$hi = 0, $3951 = 0, $3951$hi = 0, $3952 = 0, $3952$hi = 0, $3956 = 0, $3956$hi = 0, $3957 = 0, $3957$hi = 0, $3960 = 0, $3960$hi = 0, $3961 = 0, $3961$hi = 0, $3962$hi = 0, $3966 = 0, $3966$hi = 0, $3968 = 0, $3968$hi = 0, $3969 = 0, $3969$hi = 0, $3971 = 0, $3971$hi = 0, $3972 = 0, $3972$hi = 0, $3976 = 0, $3976$hi = 0, $3977 = 0, $3977$hi = 0, $3980 = 0, $3980$hi = 0, $3981 = 0, $3981$hi = 0, $3982$hi = 0, $3986 = 0, $3986$hi = 0, $3988 = 0, $3988$hi = 0, $3989 = 0, $3989$hi = 0, $3991 = 0, $3991$hi = 0, $3992 = 0, $3992$hi = 0, $3996 = 0, $3996$hi = 0, $3997 = 0, $3997$hi = 0, $4000 = 0, $4000$hi = 0, $4001 = 0, $4001$hi = 0, $4002$hi = 0, $4007 = 0, $4008 = 0, $4008$hi = 0, $4011$hi = 0, $4015 = 0, $4015$hi = 0, $4016$hi = 0, $4018 = 0, $4018$hi = 0, $4019$hi = 0, $4021 = 0, $4021$hi = 0, $4023 = 0, $4023$hi = 0, $4024 = 0, $4024$hi = 0, $4026 = 0, $4026$hi = 0, $4027 = 0, $4027$hi = 0, $4035 = 0, $4036 = 0, $4036$hi = 0, $4038 = 0, $4038$hi = 0, $4040 = 0, $4040$hi = 0, $4041 = 0, $4041$hi = 0, $4043 = 0, $4043$hi = 0, $4044 = 0, $4044$hi = 0, $4048 = 0, $4048$hi = 0, $4049 = 0, $4049$hi = 0, $4052 = 0, $4052$hi = 0, $4053 = 0, $4053$hi = 0, $4054$hi = 0, $4059 = 0, $4060 = 0, $4060$hi = 0, $4063$hi = 0, $4067 = 0, $4067$hi = 0, $4068$hi = 0, $4070 = 0, $4070$hi = 0, $4071$hi = 0, $4073 = 0, $4073$hi = 0, $4075 = 0, $4075$hi = 0, $4076 = 0, $4076$hi = 0, $4078 = 0, $4078$hi = 0, $4079 = 0, $4079$hi = 0, $4087 = 0, $4088 = 0, $4088$hi = 0, $4090 = 0, $4090$hi = 0, $4092 = 0, $4092$hi = 0, $4093 = 0, $4093$hi = 0, $4095 = 0, $4095$hi = 0, $4096 = 0, $4096$hi = 0, $4100 = 0, $4100$hi = 0, $4101 = 0, $4101$hi = 0, $4104 = 0, $4104$hi = 0, $4105 = 0, $4105$hi = 0, $4106$hi = 0, $4111 = 0, $4114 = 0, $4114$hi = 0, $4117$hi = 0, $4121 = 0, $4121$hi = 0, $4122$hi = 0, $4124 = 0, $4124$hi = 0, $4125$hi = 0, $4127 = 0, $4127$hi = 0, $4129 = 0, $4129$hi = 0, $4130 = 0, $4130$hi = 0, $4132 = 0, $4132$hi = 0, $4133 = 0, $4133$hi = 0, $4138 = 0, $4143 = 0, $4143$hi = 0, $4144 = 0, $4144$hi = 0, $4147 = 0, $4147$hi = 0, $4148 = 0, $4148$hi = 0, $4149$hi = 0, $4151 = 0, $4151$hi = 0, $4153 = 0, $4153$hi = 0, $4154 = 0, $4154$hi = 0, $4156 = 0, $4156$hi = 0, $4157 = 0, $4157$hi = 0, $4158$hi = 0;
  $3 = global$0 - 640 | 0;
  global$0 = $3;
  memset($3 + 512 | 0 | 0, 0 | 0, 128 | 0) | 0;
  label$1 : {
   label$2 : {
    if (!$2) {
     break label$2
    }
    label$3 : while (1) {
     if ($2 >>> 0 <= 127 >>> 0) {
      break label$1
     }
     $4 = 0;
     label$4 : while (1) {
      $110 = ($3 + 512 | 0) + $4 | 0;
      i64toi32_i32$2 = $1 + $4 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $5 = i64toi32_i32$0;
      $5$hi = i64toi32_i32$1;
      i64toi32_i32$2 = i64toi32_i32$0;
      i64toi32_i32$0 = 0;
      i64toi32_i32$3 = 56;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       $3364 = 0;
      } else {
       i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
       $3364 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
      }
      $116 = $3364;
      $116$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $5$hi;
      i64toi32_i32$1 = $5;
      i64toi32_i32$2 = 0;
      i64toi32_i32$3 = 40;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       $3367 = 0;
      } else {
       i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
       $3367 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
      }
      i64toi32_i32$0 = $3367;
      i64toi32_i32$1 = 16711680;
      i64toi32_i32$3 = 0;
      i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
      $119 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
      $119$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $116$hi;
      i64toi32_i32$2 = $116;
      i64toi32_i32$0 = $119$hi;
      i64toi32_i32$3 = $119;
      i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
      $120 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
      $120$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $5$hi;
      i64toi32_i32$1 = $5;
      i64toi32_i32$2 = 0;
      i64toi32_i32$3 = 24;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       $3370 = 0;
      } else {
       i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
       $3370 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
      }
      i64toi32_i32$0 = $3370;
      i64toi32_i32$1 = 65280;
      i64toi32_i32$3 = 0;
      i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
      $123 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
      $123$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $5$hi;
      i64toi32_i32$2 = $5;
      i64toi32_i32$0 = 0;
      i64toi32_i32$3 = 8;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       $3371 = 0;
      } else {
       i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
       $3371 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
      }
      i64toi32_i32$1 = $3371;
      i64toi32_i32$2 = 255;
      i64toi32_i32$3 = 0;
      i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
      $126 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
      $126$hi = i64toi32_i32$2;
      i64toi32_i32$2 = $123$hi;
      i64toi32_i32$0 = $123;
      i64toi32_i32$1 = $126$hi;
      i64toi32_i32$3 = $126;
      i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
      $127 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
      $127$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $120$hi;
      i64toi32_i32$2 = $120;
      i64toi32_i32$0 = $127$hi;
      i64toi32_i32$3 = $127;
      i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
      $128 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
      $128$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $5$hi;
      i64toi32_i32$1 = $5;
      i64toi32_i32$2 = 0;
      i64toi32_i32$3 = 8;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$2 = 0;
       $3373 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
      } else {
       i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       $3373 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
      }
      i64toi32_i32$0 = $3373;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = -16777216;
      i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
      $131 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
      $131$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $5$hi;
      i64toi32_i32$2 = $5;
      i64toi32_i32$0 = 0;
      i64toi32_i32$3 = 24;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$0 = 0;
       $3375 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
      } else {
       i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
       $3375 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
      }
      i64toi32_i32$1 = $3375;
      i64toi32_i32$2 = 0;
      i64toi32_i32$3 = 16711680;
      i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
      $134 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
      $134$hi = i64toi32_i32$2;
      i64toi32_i32$2 = $131$hi;
      i64toi32_i32$0 = $131;
      i64toi32_i32$1 = $134$hi;
      i64toi32_i32$3 = $134;
      i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
      $135 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
      $135$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $5$hi;
      i64toi32_i32$2 = $5;
      i64toi32_i32$0 = 0;
      i64toi32_i32$3 = 40;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$0 = 0;
       $3378 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
      } else {
       i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
       $3378 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
      }
      i64toi32_i32$1 = $3378;
      i64toi32_i32$2 = 0;
      i64toi32_i32$3 = 65280;
      i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
      $138 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
      $138$hi = i64toi32_i32$2;
      i64toi32_i32$2 = $5$hi;
      i64toi32_i32$0 = $5;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 56;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$1 = 0;
       $3381 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
      } else {
       i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
       $3381 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
      }
      $140$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $138$hi;
      i64toi32_i32$2 = $138;
      i64toi32_i32$0 = $140$hi;
      i64toi32_i32$3 = $3381;
      i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
      $141 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
      $141$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $135$hi;
      i64toi32_i32$1 = $135;
      i64toi32_i32$2 = $141$hi;
      i64toi32_i32$3 = $141;
      i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
      $142 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
      $142$hi = i64toi32_i32$2;
      i64toi32_i32$2 = $128$hi;
      i64toi32_i32$0 = $128;
      i64toi32_i32$1 = $142$hi;
      i64toi32_i32$3 = $142;
      i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
      $143 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
      i64toi32_i32$0 = $110;
      HEAP32[i64toi32_i32$0 >> 2] = $143;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      $4 = $4 + 8 | 0;
      if (($4 | 0) != (128 | 0)) {
       continue label$4
      }
      break label$4;
     };
     i64toi32_i32$2 = $3;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 520 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 524 | 0) >> 2] | 0;
     $6 = i64toi32_i32$1;
     $6$hi = i64toi32_i32$0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 512 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 516 | 0) >> 2] | 0;
     $5 = i64toi32_i32$0;
     $5$hi = i64toi32_i32$1;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 528 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 532 | 0) >> 2] | 0;
     $7 = i64toi32_i32$1;
     $7$hi = i64toi32_i32$0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 592 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 596 | 0) >> 2] | 0;
     $8 = i64toi32_i32$0;
     $8$hi = i64toi32_i32$1;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 584 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 588 | 0) >> 2] | 0;
     $9 = i64toi32_i32$1;
     $9$hi = i64toi32_i32$0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 632 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 636 | 0) >> 2] | 0;
     $10 = i64toi32_i32$0;
     $10$hi = i64toi32_i32$1;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 624 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 628 | 0) >> 2] | 0;
     $11 = i64toi32_i32$1;
     $11$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$1 = $5$hi;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$3 = $8$hi;
     i64toi32_i32$4 = $9$hi;
     i64toi32_i32$5 = $10$hi;
     i64toi32_i32$6 = $11$hi;
     cryptoxide__hashing__sha2__impl512__reference__schedule_x2__hd52256e5a67097ab($3 + 496 | 0 | 0, $6 | 0, i64toi32_i32$0 | 0, $5 | 0, i64toi32_i32$1 | 0, $7 | 0, i64toi32_i32$2 | 0, $8 | 0, i64toi32_i32$3 | 0, $9 | 0, i64toi32_i32$4 | 0, $10 | 0, i64toi32_i32$5 | 0, $11 | 0, i64toi32_i32$6 | 0);
     i64toi32_i32$4 = $3;
     i64toi32_i32$6 = HEAP32[(i64toi32_i32$4 + 536 | 0) >> 2] | 0;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 540 | 0) >> 2] | 0;
     $12 = i64toi32_i32$6;
     $12$hi = i64toi32_i32$5;
     i64toi32_i32$5 = i64toi32_i32$2;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 544 | 0) >> 2] | 0;
     i64toi32_i32$6 = HEAP32[(i64toi32_i32$4 + 548 | 0) >> 2] | 0;
     $13 = i64toi32_i32$5;
     $13$hi = i64toi32_i32$6;
     i64toi32_i32$6 = $13$hi;
     i64toi32_i32$6 = HEAP32[(i64toi32_i32$4 + 608 | 0) >> 2] | 0;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 612 | 0) >> 2] | 0;
     $14 = i64toi32_i32$6;
     $14$hi = i64toi32_i32$5;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 600 | 0) >> 2] | 0;
     i64toi32_i32$6 = HEAP32[(i64toi32_i32$4 + 604 | 0) >> 2] | 0;
     $15 = i64toi32_i32$5;
     $15$hi = i64toi32_i32$6;
     i64toi32_i32$6 = HEAP32[(i64toi32_i32$4 + 496 | 0) >> 2] | 0;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 500 | 0) >> 2] | 0;
     $16 = i64toi32_i32$6;
     $16$hi = i64toi32_i32$5;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 504 | 0) >> 2] | 0;
     i64toi32_i32$6 = HEAP32[(i64toi32_i32$4 + 508 | 0) >> 2] | 0;
     $17 = i64toi32_i32$5;
     $17$hi = i64toi32_i32$6;
     i64toi32_i32$6 = $12$hi;
     i64toi32_i32$5 = i64toi32_i32$2;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$3 = $14$hi;
     i64toi32_i32$2 = $15$hi;
     i64toi32_i32$1 = $16$hi;
     i64toi32_i32$0 = $17$hi;
     cryptoxide__hashing__sha2__impl512__reference__schedule_x2__hd52256e5a67097ab($3 + 480 | 0 | 0, $12 | 0, i64toi32_i32$6 | 0, $7 | 0, i64toi32_i32$5 | 0, $13 | 0, i64toi32_i32$4 | 0, $14 | 0, i64toi32_i32$3 | 0, $15 | 0, i64toi32_i32$2 | 0, $16 | 0, i64toi32_i32$1 | 0, $17 | 0, i64toi32_i32$0 | 0);
     i64toi32_i32$2 = $3;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 552 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 556 | 0) >> 2] | 0;
     $18 = i64toi32_i32$0;
     $18$hi = i64toi32_i32$1;
     i64toi32_i32$1 = i64toi32_i32$4;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 560 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 564 | 0) >> 2] | 0;
     $19 = i64toi32_i32$1;
     $19$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $11$hi;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 616 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 620 | 0) >> 2] | 0;
     $20 = i64toi32_i32$0;
     $20$hi = i64toi32_i32$1;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 480 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 484 | 0) >> 2] | 0;
     $21 = i64toi32_i32$1;
     $21$hi = i64toi32_i32$0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 488 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 492 | 0) >> 2] | 0;
     $22 = i64toi32_i32$0;
     $22$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $18$hi;
     i64toi32_i32$0 = i64toi32_i32$4;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$3 = $11$hi;
     i64toi32_i32$4 = $20$hi;
     i64toi32_i32$5 = $21$hi;
     i64toi32_i32$6 = $22$hi;
     cryptoxide__hashing__sha2__impl512__reference__schedule_x2__hd52256e5a67097ab($3 + 464 | 0 | 0, $18 | 0, i64toi32_i32$1 | 0, $13 | 0, i64toi32_i32$0 | 0, $19 | 0, i64toi32_i32$2 | 0, $11 | 0, i64toi32_i32$3 | 0, $20 | 0, i64toi32_i32$4 | 0, $21 | 0, i64toi32_i32$5 | 0, $22 | 0, i64toi32_i32$6 | 0);
     i64toi32_i32$4 = $3;
     i64toi32_i32$6 = HEAP32[(i64toi32_i32$4 + 568 | 0) >> 2] | 0;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 572 | 0) >> 2] | 0;
     $23 = i64toi32_i32$6;
     $23$hi = i64toi32_i32$5;
     i64toi32_i32$5 = i64toi32_i32$2;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 576 | 0) >> 2] | 0;
     i64toi32_i32$6 = HEAP32[(i64toi32_i32$4 + 580 | 0) >> 2] | 0;
     $24 = i64toi32_i32$5;
     $24$hi = i64toi32_i32$6;
     i64toi32_i32$6 = $17$hi;
     i64toi32_i32$6 = $10$hi;
     i64toi32_i32$6 = HEAP32[(i64toi32_i32$4 + 464 | 0) >> 2] | 0;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 468 | 0) >> 2] | 0;
     $25 = i64toi32_i32$6;
     $25$hi = i64toi32_i32$5;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 472 | 0) >> 2] | 0;
     i64toi32_i32$6 = HEAP32[(i64toi32_i32$4 + 476 | 0) >> 2] | 0;
     $26 = i64toi32_i32$5;
     $26$hi = i64toi32_i32$6;
     i64toi32_i32$6 = $23$hi;
     i64toi32_i32$5 = i64toi32_i32$2;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$3 = $17$hi;
     i64toi32_i32$2 = $10$hi;
     i64toi32_i32$0 = $25$hi;
     i64toi32_i32$1 = $26$hi;
     cryptoxide__hashing__sha2__impl512__reference__schedule_x2__hd52256e5a67097ab($3 + 448 | 0 | 0, $23 | 0, i64toi32_i32$6 | 0, $19 | 0, i64toi32_i32$5 | 0, $24 | 0, i64toi32_i32$4 | 0, $17 | 0, i64toi32_i32$3 | 0, $10 | 0, i64toi32_i32$2 | 0, $25 | 0, i64toi32_i32$0 | 0, $26 | 0, i64toi32_i32$1 | 0);
     i64toi32_i32$1 = $9$hi;
     i64toi32_i32$1 = i64toi32_i32$4;
     i64toi32_i32$1 = $8$hi;
     i64toi32_i32$1 = $22$hi;
     i64toi32_i32$1 = $16$hi;
     i64toi32_i32$2 = $3;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 448 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 452 | 0) >> 2] | 0;
     $27 = i64toi32_i32$1;
     $27$hi = i64toi32_i32$0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 456 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 460 | 0) >> 2] | 0;
     $28 = i64toi32_i32$0;
     $28$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $9$hi;
     i64toi32_i32$0 = i64toi32_i32$4;
     i64toi32_i32$2 = $8$hi;
     i64toi32_i32$3 = $22$hi;
     i64toi32_i32$4 = $16$hi;
     i64toi32_i32$5 = $27$hi;
     i64toi32_i32$6 = $28$hi;
     cryptoxide__hashing__sha2__impl512__reference__schedule_x2__hd52256e5a67097ab($3 + 432 | 0 | 0, $9 | 0, i64toi32_i32$1 | 0, $24 | 0, i64toi32_i32$0 | 0, $8 | 0, i64toi32_i32$2 | 0, $22 | 0, i64toi32_i32$3 | 0, $16 | 0, i64toi32_i32$4 | 0, $27 | 0, i64toi32_i32$5 | 0, $28 | 0, i64toi32_i32$6 | 0);
     i64toi32_i32$6 = $15$hi;
     i64toi32_i32$6 = i64toi32_i32$2;
     i64toi32_i32$6 = $14$hi;
     i64toi32_i32$6 = $26$hi;
     i64toi32_i32$6 = $21$hi;
     i64toi32_i32$4 = $3;
     i64toi32_i32$6 = HEAP32[(i64toi32_i32$4 + 432 | 0) >> 2] | 0;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 436 | 0) >> 2] | 0;
     $29 = i64toi32_i32$6;
     $29$hi = i64toi32_i32$5;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 440 | 0) >> 2] | 0;
     i64toi32_i32$6 = HEAP32[(i64toi32_i32$4 + 444 | 0) >> 2] | 0;
     $30 = i64toi32_i32$5;
     $30$hi = i64toi32_i32$6;
     i64toi32_i32$6 = $15$hi;
     i64toi32_i32$5 = i64toi32_i32$2;
     i64toi32_i32$4 = $14$hi;
     i64toi32_i32$3 = $26$hi;
     i64toi32_i32$2 = $21$hi;
     i64toi32_i32$0 = $29$hi;
     i64toi32_i32$1 = $30$hi;
     cryptoxide__hashing__sha2__impl512__reference__schedule_x2__hd52256e5a67097ab($3 + 416 | 0 | 0, $15 | 0, i64toi32_i32$6 | 0, $8 | 0, i64toi32_i32$5 | 0, $14 | 0, i64toi32_i32$4 | 0, $26 | 0, i64toi32_i32$3 | 0, $21 | 0, i64toi32_i32$2 | 0, $29 | 0, i64toi32_i32$0 | 0, $30 | 0, i64toi32_i32$1 | 0);
     i64toi32_i32$1 = $20$hi;
     i64toi32_i32$1 = i64toi32_i32$4;
     i64toi32_i32$1 = $11$hi;
     i64toi32_i32$1 = $28$hi;
     i64toi32_i32$1 = $25$hi;
     i64toi32_i32$2 = $3;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 416 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 420 | 0) >> 2] | 0;
     $31 = i64toi32_i32$1;
     $31$hi = i64toi32_i32$0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 424 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 428 | 0) >> 2] | 0;
     $32 = i64toi32_i32$0;
     $32$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $20$hi;
     i64toi32_i32$0 = i64toi32_i32$4;
     i64toi32_i32$2 = $11$hi;
     i64toi32_i32$3 = $28$hi;
     i64toi32_i32$4 = $25$hi;
     i64toi32_i32$5 = $31$hi;
     i64toi32_i32$6 = $32$hi;
     cryptoxide__hashing__sha2__impl512__reference__schedule_x2__hd52256e5a67097ab($3 + 400 | 0 | 0, $20 | 0, i64toi32_i32$1 | 0, $14 | 0, i64toi32_i32$0 | 0, $11 | 0, i64toi32_i32$2 | 0, $28 | 0, i64toi32_i32$3 | 0, $25 | 0, i64toi32_i32$4 | 0, $31 | 0, i64toi32_i32$5 | 0, $32 | 0, i64toi32_i32$6 | 0);
     i64toi32_i32$6 = $10$hi;
     i64toi32_i32$6 = i64toi32_i32$2;
     i64toi32_i32$6 = $17$hi;
     i64toi32_i32$6 = $30$hi;
     i64toi32_i32$6 = $27$hi;
     i64toi32_i32$4 = $3;
     i64toi32_i32$6 = HEAP32[(i64toi32_i32$4 + 400 | 0) >> 2] | 0;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 404 | 0) >> 2] | 0;
     $33 = i64toi32_i32$6;
     $33$hi = i64toi32_i32$5;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 408 | 0) >> 2] | 0;
     i64toi32_i32$6 = HEAP32[(i64toi32_i32$4 + 412 | 0) >> 2] | 0;
     $34 = i64toi32_i32$5;
     $34$hi = i64toi32_i32$6;
     i64toi32_i32$6 = $10$hi;
     i64toi32_i32$5 = i64toi32_i32$2;
     i64toi32_i32$4 = $17$hi;
     i64toi32_i32$3 = $30$hi;
     i64toi32_i32$2 = $27$hi;
     i64toi32_i32$0 = $33$hi;
     i64toi32_i32$1 = $34$hi;
     cryptoxide__hashing__sha2__impl512__reference__schedule_x2__hd52256e5a67097ab($3 + 384 | 0 | 0, $10 | 0, i64toi32_i32$6 | 0, $11 | 0, i64toi32_i32$5 | 0, $17 | 0, i64toi32_i32$4 | 0, $30 | 0, i64toi32_i32$3 | 0, $27 | 0, i64toi32_i32$2 | 0, $33 | 0, i64toi32_i32$0 | 0, $34 | 0, i64toi32_i32$1 | 0);
     i64toi32_i32$1 = $16$hi;
     i64toi32_i32$1 = i64toi32_i32$4;
     i64toi32_i32$1 = $22$hi;
     i64toi32_i32$1 = $32$hi;
     i64toi32_i32$1 = $29$hi;
     i64toi32_i32$2 = $3;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 384 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 388 | 0) >> 2] | 0;
     $35 = i64toi32_i32$1;
     $35$hi = i64toi32_i32$0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 392 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 396 | 0) >> 2] | 0;
     $36 = i64toi32_i32$0;
     $36$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $16$hi;
     i64toi32_i32$0 = i64toi32_i32$4;
     i64toi32_i32$2 = $22$hi;
     i64toi32_i32$3 = $32$hi;
     i64toi32_i32$4 = $29$hi;
     i64toi32_i32$5 = $35$hi;
     i64toi32_i32$6 = $36$hi;
     cryptoxide__hashing__sha2__impl512__reference__schedule_x2__hd52256e5a67097ab($3 + 368 | 0 | 0, $16 | 0, i64toi32_i32$1 | 0, $17 | 0, i64toi32_i32$0 | 0, $22 | 0, i64toi32_i32$2 | 0, $32 | 0, i64toi32_i32$3 | 0, $29 | 0, i64toi32_i32$4 | 0, $35 | 0, i64toi32_i32$5 | 0, $36 | 0, i64toi32_i32$6 | 0);
     i64toi32_i32$6 = $21$hi;
     i64toi32_i32$6 = i64toi32_i32$2;
     i64toi32_i32$6 = $26$hi;
     i64toi32_i32$6 = $34$hi;
     i64toi32_i32$6 = $31$hi;
     i64toi32_i32$4 = $3;
     i64toi32_i32$6 = HEAP32[(i64toi32_i32$4 + 368 | 0) >> 2] | 0;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 372 | 0) >> 2] | 0;
     $37 = i64toi32_i32$6;
     $37$hi = i64toi32_i32$5;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 376 | 0) >> 2] | 0;
     i64toi32_i32$6 = HEAP32[(i64toi32_i32$4 + 380 | 0) >> 2] | 0;
     $38 = i64toi32_i32$5;
     $38$hi = i64toi32_i32$6;
     i64toi32_i32$6 = $21$hi;
     i64toi32_i32$5 = i64toi32_i32$2;
     i64toi32_i32$4 = $26$hi;
     i64toi32_i32$3 = $34$hi;
     i64toi32_i32$2 = $31$hi;
     i64toi32_i32$0 = $37$hi;
     i64toi32_i32$1 = $38$hi;
     cryptoxide__hashing__sha2__impl512__reference__schedule_x2__hd52256e5a67097ab($3 + 352 | 0 | 0, $21 | 0, i64toi32_i32$6 | 0, $22 | 0, i64toi32_i32$5 | 0, $26 | 0, i64toi32_i32$4 | 0, $34 | 0, i64toi32_i32$3 | 0, $31 | 0, i64toi32_i32$2 | 0, $37 | 0, i64toi32_i32$0 | 0, $38 | 0, i64toi32_i32$1 | 0);
     i64toi32_i32$1 = $25$hi;
     i64toi32_i32$1 = i64toi32_i32$4;
     i64toi32_i32$1 = $28$hi;
     i64toi32_i32$1 = $36$hi;
     i64toi32_i32$1 = $33$hi;
     i64toi32_i32$2 = $3;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 352 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 356 | 0) >> 2] | 0;
     $39 = i64toi32_i32$1;
     $39$hi = i64toi32_i32$0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 360 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 364 | 0) >> 2] | 0;
     $40 = i64toi32_i32$0;
     $40$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $25$hi;
     i64toi32_i32$0 = i64toi32_i32$4;
     i64toi32_i32$2 = $28$hi;
     i64toi32_i32$3 = $36$hi;
     i64toi32_i32$4 = $33$hi;
     i64toi32_i32$5 = $39$hi;
     i64toi32_i32$6 = $40$hi;
     cryptoxide__hashing__sha2__impl512__reference__schedule_x2__hd52256e5a67097ab($3 + 336 | 0 | 0, $25 | 0, i64toi32_i32$1 | 0, $26 | 0, i64toi32_i32$0 | 0, $28 | 0, i64toi32_i32$2 | 0, $36 | 0, i64toi32_i32$3 | 0, $33 | 0, i64toi32_i32$4 | 0, $39 | 0, i64toi32_i32$5 | 0, $40 | 0, i64toi32_i32$6 | 0);
     i64toi32_i32$6 = $27$hi;
     i64toi32_i32$6 = i64toi32_i32$2;
     i64toi32_i32$6 = $30$hi;
     i64toi32_i32$6 = $38$hi;
     i64toi32_i32$6 = $35$hi;
     i64toi32_i32$4 = $3;
     i64toi32_i32$6 = HEAP32[(i64toi32_i32$4 + 336 | 0) >> 2] | 0;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 340 | 0) >> 2] | 0;
     $41 = i64toi32_i32$6;
     $41$hi = i64toi32_i32$5;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 344 | 0) >> 2] | 0;
     i64toi32_i32$6 = HEAP32[(i64toi32_i32$4 + 348 | 0) >> 2] | 0;
     $42 = i64toi32_i32$5;
     $42$hi = i64toi32_i32$6;
     i64toi32_i32$6 = $27$hi;
     i64toi32_i32$5 = i64toi32_i32$2;
     i64toi32_i32$4 = $30$hi;
     i64toi32_i32$3 = $38$hi;
     i64toi32_i32$2 = $35$hi;
     i64toi32_i32$0 = $41$hi;
     i64toi32_i32$1 = $42$hi;
     cryptoxide__hashing__sha2__impl512__reference__schedule_x2__hd52256e5a67097ab($3 + 320 | 0 | 0, $27 | 0, i64toi32_i32$6 | 0, $28 | 0, i64toi32_i32$5 | 0, $30 | 0, i64toi32_i32$4 | 0, $38 | 0, i64toi32_i32$3 | 0, $35 | 0, i64toi32_i32$2 | 0, $41 | 0, i64toi32_i32$0 | 0, $42 | 0, i64toi32_i32$1 | 0);
     i64toi32_i32$1 = $29$hi;
     i64toi32_i32$1 = i64toi32_i32$4;
     i64toi32_i32$1 = $32$hi;
     i64toi32_i32$1 = $40$hi;
     i64toi32_i32$1 = $37$hi;
     i64toi32_i32$2 = $3;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 320 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 324 | 0) >> 2] | 0;
     $43 = i64toi32_i32$1;
     $43$hi = i64toi32_i32$0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 328 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 332 | 0) >> 2] | 0;
     $44 = i64toi32_i32$0;
     $44$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $29$hi;
     i64toi32_i32$0 = i64toi32_i32$4;
     i64toi32_i32$2 = $32$hi;
     i64toi32_i32$3 = $40$hi;
     i64toi32_i32$4 = $37$hi;
     i64toi32_i32$5 = $43$hi;
     i64toi32_i32$6 = $44$hi;
     cryptoxide__hashing__sha2__impl512__reference__schedule_x2__hd52256e5a67097ab($3 + 304 | 0 | 0, $29 | 0, i64toi32_i32$1 | 0, $30 | 0, i64toi32_i32$0 | 0, $32 | 0, i64toi32_i32$2 | 0, $40 | 0, i64toi32_i32$3 | 0, $37 | 0, i64toi32_i32$4 | 0, $43 | 0, i64toi32_i32$5 | 0, $44 | 0, i64toi32_i32$6 | 0);
     i64toi32_i32$6 = $31$hi;
     i64toi32_i32$6 = i64toi32_i32$2;
     i64toi32_i32$6 = $34$hi;
     i64toi32_i32$6 = $42$hi;
     i64toi32_i32$6 = $39$hi;
     i64toi32_i32$4 = $3;
     i64toi32_i32$6 = HEAP32[(i64toi32_i32$4 + 304 | 0) >> 2] | 0;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 308 | 0) >> 2] | 0;
     $45 = i64toi32_i32$6;
     $45$hi = i64toi32_i32$5;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 312 | 0) >> 2] | 0;
     i64toi32_i32$6 = HEAP32[(i64toi32_i32$4 + 316 | 0) >> 2] | 0;
     $46 = i64toi32_i32$5;
     $46$hi = i64toi32_i32$6;
     i64toi32_i32$6 = $31$hi;
     i64toi32_i32$5 = i64toi32_i32$2;
     i64toi32_i32$4 = $34$hi;
     i64toi32_i32$3 = $42$hi;
     i64toi32_i32$2 = $39$hi;
     i64toi32_i32$0 = $45$hi;
     i64toi32_i32$1 = $46$hi;
     cryptoxide__hashing__sha2__impl512__reference__schedule_x2__hd52256e5a67097ab($3 + 288 | 0 | 0, $31 | 0, i64toi32_i32$6 | 0, $32 | 0, i64toi32_i32$5 | 0, $34 | 0, i64toi32_i32$4 | 0, $42 | 0, i64toi32_i32$3 | 0, $39 | 0, i64toi32_i32$2 | 0, $45 | 0, i64toi32_i32$0 | 0, $46 | 0, i64toi32_i32$1 | 0);
     i64toi32_i32$1 = $33$hi;
     i64toi32_i32$1 = i64toi32_i32$4;
     i64toi32_i32$1 = $36$hi;
     i64toi32_i32$1 = $44$hi;
     i64toi32_i32$1 = $41$hi;
     i64toi32_i32$2 = $3;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 288 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 292 | 0) >> 2] | 0;
     $47 = i64toi32_i32$1;
     $47$hi = i64toi32_i32$0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 296 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 300 | 0) >> 2] | 0;
     $48 = i64toi32_i32$0;
     $48$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $33$hi;
     i64toi32_i32$0 = i64toi32_i32$4;
     i64toi32_i32$2 = $36$hi;
     i64toi32_i32$3 = $44$hi;
     i64toi32_i32$4 = $41$hi;
     i64toi32_i32$5 = $47$hi;
     i64toi32_i32$6 = $48$hi;
     cryptoxide__hashing__sha2__impl512__reference__schedule_x2__hd52256e5a67097ab($3 + 272 | 0 | 0, $33 | 0, i64toi32_i32$1 | 0, $34 | 0, i64toi32_i32$0 | 0, $36 | 0, i64toi32_i32$2 | 0, $44 | 0, i64toi32_i32$3 | 0, $41 | 0, i64toi32_i32$4 | 0, $47 | 0, i64toi32_i32$5 | 0, $48 | 0, i64toi32_i32$6 | 0);
     i64toi32_i32$6 = $35$hi;
     i64toi32_i32$6 = i64toi32_i32$2;
     i64toi32_i32$6 = $38$hi;
     i64toi32_i32$6 = $46$hi;
     i64toi32_i32$6 = $43$hi;
     i64toi32_i32$4 = $3;
     i64toi32_i32$6 = HEAP32[(i64toi32_i32$4 + 272 | 0) >> 2] | 0;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 276 | 0) >> 2] | 0;
     $49 = i64toi32_i32$6;
     $49$hi = i64toi32_i32$5;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 280 | 0) >> 2] | 0;
     i64toi32_i32$6 = HEAP32[(i64toi32_i32$4 + 284 | 0) >> 2] | 0;
     $50 = i64toi32_i32$5;
     $50$hi = i64toi32_i32$6;
     i64toi32_i32$6 = $35$hi;
     i64toi32_i32$5 = i64toi32_i32$2;
     i64toi32_i32$4 = $38$hi;
     i64toi32_i32$3 = $46$hi;
     i64toi32_i32$2 = $43$hi;
     i64toi32_i32$0 = $49$hi;
     i64toi32_i32$1 = $50$hi;
     cryptoxide__hashing__sha2__impl512__reference__schedule_x2__hd52256e5a67097ab($3 + 256 | 0 | 0, $35 | 0, i64toi32_i32$6 | 0, $36 | 0, i64toi32_i32$5 | 0, $38 | 0, i64toi32_i32$4 | 0, $46 | 0, i64toi32_i32$3 | 0, $43 | 0, i64toi32_i32$2 | 0, $49 | 0, i64toi32_i32$0 | 0, $50 | 0, i64toi32_i32$1 | 0);
     i64toi32_i32$1 = $37$hi;
     i64toi32_i32$1 = i64toi32_i32$4;
     i64toi32_i32$1 = $40$hi;
     i64toi32_i32$1 = $48$hi;
     i64toi32_i32$1 = $45$hi;
     i64toi32_i32$2 = $3;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 256 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 260 | 0) >> 2] | 0;
     $51 = i64toi32_i32$1;
     $51$hi = i64toi32_i32$0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 264 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 268 | 0) >> 2] | 0;
     $52 = i64toi32_i32$0;
     $52$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $37$hi;
     i64toi32_i32$0 = i64toi32_i32$4;
     i64toi32_i32$2 = $40$hi;
     i64toi32_i32$3 = $48$hi;
     i64toi32_i32$4 = $45$hi;
     i64toi32_i32$5 = $51$hi;
     i64toi32_i32$6 = $52$hi;
     cryptoxide__hashing__sha2__impl512__reference__schedule_x2__hd52256e5a67097ab($3 + 240 | 0 | 0, $37 | 0, i64toi32_i32$1 | 0, $38 | 0, i64toi32_i32$0 | 0, $40 | 0, i64toi32_i32$2 | 0, $48 | 0, i64toi32_i32$3 | 0, $45 | 0, i64toi32_i32$4 | 0, $51 | 0, i64toi32_i32$5 | 0, $52 | 0, i64toi32_i32$6 | 0);
     i64toi32_i32$6 = $39$hi;
     i64toi32_i32$6 = i64toi32_i32$2;
     i64toi32_i32$6 = $42$hi;
     i64toi32_i32$6 = $50$hi;
     i64toi32_i32$6 = $47$hi;
     i64toi32_i32$4 = $3;
     i64toi32_i32$6 = HEAP32[(i64toi32_i32$4 + 240 | 0) >> 2] | 0;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 244 | 0) >> 2] | 0;
     $53 = i64toi32_i32$6;
     $53$hi = i64toi32_i32$5;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 248 | 0) >> 2] | 0;
     i64toi32_i32$6 = HEAP32[(i64toi32_i32$4 + 252 | 0) >> 2] | 0;
     $54 = i64toi32_i32$5;
     $54$hi = i64toi32_i32$6;
     i64toi32_i32$6 = $39$hi;
     i64toi32_i32$5 = i64toi32_i32$2;
     i64toi32_i32$4 = $42$hi;
     i64toi32_i32$3 = $50$hi;
     i64toi32_i32$2 = $47$hi;
     i64toi32_i32$0 = $53$hi;
     i64toi32_i32$1 = $54$hi;
     cryptoxide__hashing__sha2__impl512__reference__schedule_x2__hd52256e5a67097ab($3 + 224 | 0 | 0, $39 | 0, i64toi32_i32$6 | 0, $40 | 0, i64toi32_i32$5 | 0, $42 | 0, i64toi32_i32$4 | 0, $50 | 0, i64toi32_i32$3 | 0, $47 | 0, i64toi32_i32$2 | 0, $53 | 0, i64toi32_i32$0 | 0, $54 | 0, i64toi32_i32$1 | 0);
     i64toi32_i32$1 = $41$hi;
     i64toi32_i32$1 = i64toi32_i32$4;
     i64toi32_i32$1 = $44$hi;
     i64toi32_i32$1 = $52$hi;
     i64toi32_i32$1 = $49$hi;
     i64toi32_i32$2 = $3;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 224 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 228 | 0) >> 2] | 0;
     $55 = i64toi32_i32$1;
     $55$hi = i64toi32_i32$0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 232 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 236 | 0) >> 2] | 0;
     $56 = i64toi32_i32$0;
     $56$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $41$hi;
     i64toi32_i32$0 = i64toi32_i32$4;
     i64toi32_i32$2 = $44$hi;
     i64toi32_i32$3 = $52$hi;
     i64toi32_i32$4 = $49$hi;
     i64toi32_i32$5 = $55$hi;
     i64toi32_i32$6 = $56$hi;
     cryptoxide__hashing__sha2__impl512__reference__schedule_x2__hd52256e5a67097ab($3 + 208 | 0 | 0, $41 | 0, i64toi32_i32$1 | 0, $42 | 0, i64toi32_i32$0 | 0, $44 | 0, i64toi32_i32$2 | 0, $52 | 0, i64toi32_i32$3 | 0, $49 | 0, i64toi32_i32$4 | 0, $55 | 0, i64toi32_i32$5 | 0, $56 | 0, i64toi32_i32$6 | 0);
     i64toi32_i32$6 = $43$hi;
     i64toi32_i32$6 = i64toi32_i32$2;
     i64toi32_i32$6 = $46$hi;
     i64toi32_i32$6 = $54$hi;
     i64toi32_i32$6 = $51$hi;
     i64toi32_i32$4 = $3;
     i64toi32_i32$6 = HEAP32[(i64toi32_i32$4 + 208 | 0) >> 2] | 0;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 212 | 0) >> 2] | 0;
     $57 = i64toi32_i32$6;
     $57$hi = i64toi32_i32$5;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 216 | 0) >> 2] | 0;
     i64toi32_i32$6 = HEAP32[(i64toi32_i32$4 + 220 | 0) >> 2] | 0;
     $58 = i64toi32_i32$5;
     $58$hi = i64toi32_i32$6;
     i64toi32_i32$6 = $43$hi;
     i64toi32_i32$5 = i64toi32_i32$2;
     i64toi32_i32$4 = $46$hi;
     i64toi32_i32$3 = $54$hi;
     i64toi32_i32$2 = $51$hi;
     i64toi32_i32$0 = $57$hi;
     i64toi32_i32$1 = $58$hi;
     cryptoxide__hashing__sha2__impl512__reference__schedule_x2__hd52256e5a67097ab($3 + 192 | 0 | 0, $43 | 0, i64toi32_i32$6 | 0, $44 | 0, i64toi32_i32$5 | 0, $46 | 0, i64toi32_i32$4 | 0, $54 | 0, i64toi32_i32$3 | 0, $51 | 0, i64toi32_i32$2 | 0, $57 | 0, i64toi32_i32$0 | 0, $58 | 0, i64toi32_i32$1 | 0);
     i64toi32_i32$1 = $45$hi;
     i64toi32_i32$1 = i64toi32_i32$4;
     i64toi32_i32$1 = $48$hi;
     i64toi32_i32$1 = $56$hi;
     i64toi32_i32$1 = $53$hi;
     i64toi32_i32$2 = $3;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 192 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 196 | 0) >> 2] | 0;
     $59 = i64toi32_i32$1;
     $59$hi = i64toi32_i32$0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 200 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 204 | 0) >> 2] | 0;
     $60 = i64toi32_i32$0;
     $60$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $45$hi;
     i64toi32_i32$0 = i64toi32_i32$4;
     i64toi32_i32$2 = $48$hi;
     i64toi32_i32$3 = $56$hi;
     i64toi32_i32$4 = $53$hi;
     i64toi32_i32$5 = $59$hi;
     i64toi32_i32$6 = $60$hi;
     cryptoxide__hashing__sha2__impl512__reference__schedule_x2__hd52256e5a67097ab($3 + 176 | 0 | 0, $45 | 0, i64toi32_i32$1 | 0, $46 | 0, i64toi32_i32$0 | 0, $48 | 0, i64toi32_i32$2 | 0, $56 | 0, i64toi32_i32$3 | 0, $53 | 0, i64toi32_i32$4 | 0, $59 | 0, i64toi32_i32$5 | 0, $60 | 0, i64toi32_i32$6 | 0);
     i64toi32_i32$6 = $47$hi;
     i64toi32_i32$6 = i64toi32_i32$2;
     i64toi32_i32$6 = $50$hi;
     i64toi32_i32$6 = $58$hi;
     i64toi32_i32$6 = $55$hi;
     i64toi32_i32$4 = $3;
     i64toi32_i32$6 = HEAP32[(i64toi32_i32$4 + 176 | 0) >> 2] | 0;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 180 | 0) >> 2] | 0;
     $61 = i64toi32_i32$6;
     $61$hi = i64toi32_i32$5;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 184 | 0) >> 2] | 0;
     i64toi32_i32$6 = HEAP32[(i64toi32_i32$4 + 188 | 0) >> 2] | 0;
     $62 = i64toi32_i32$5;
     $62$hi = i64toi32_i32$6;
     i64toi32_i32$6 = $47$hi;
     i64toi32_i32$5 = i64toi32_i32$2;
     i64toi32_i32$4 = $50$hi;
     i64toi32_i32$3 = $58$hi;
     i64toi32_i32$2 = $55$hi;
     i64toi32_i32$0 = $61$hi;
     i64toi32_i32$1 = $62$hi;
     cryptoxide__hashing__sha2__impl512__reference__schedule_x2__hd52256e5a67097ab($3 + 160 | 0 | 0, $47 | 0, i64toi32_i32$6 | 0, $48 | 0, i64toi32_i32$5 | 0, $50 | 0, i64toi32_i32$4 | 0, $58 | 0, i64toi32_i32$3 | 0, $55 | 0, i64toi32_i32$2 | 0, $61 | 0, i64toi32_i32$0 | 0, $62 | 0, i64toi32_i32$1 | 0);
     i64toi32_i32$1 = $49$hi;
     i64toi32_i32$1 = i64toi32_i32$4;
     i64toi32_i32$1 = $52$hi;
     i64toi32_i32$1 = $60$hi;
     i64toi32_i32$1 = $57$hi;
     i64toi32_i32$2 = $3;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 160 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 164 | 0) >> 2] | 0;
     $63 = i64toi32_i32$1;
     $63$hi = i64toi32_i32$0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 168 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 172 | 0) >> 2] | 0;
     $64 = i64toi32_i32$0;
     $64$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $49$hi;
     i64toi32_i32$0 = i64toi32_i32$4;
     i64toi32_i32$2 = $52$hi;
     i64toi32_i32$3 = $60$hi;
     i64toi32_i32$4 = $57$hi;
     i64toi32_i32$5 = $63$hi;
     i64toi32_i32$6 = $64$hi;
     cryptoxide__hashing__sha2__impl512__reference__schedule_x2__hd52256e5a67097ab($3 + 144 | 0 | 0, $49 | 0, i64toi32_i32$1 | 0, $50 | 0, i64toi32_i32$0 | 0, $52 | 0, i64toi32_i32$2 | 0, $60 | 0, i64toi32_i32$3 | 0, $57 | 0, i64toi32_i32$4 | 0, $63 | 0, i64toi32_i32$5 | 0, $64 | 0, i64toi32_i32$6 | 0);
     i64toi32_i32$6 = $51$hi;
     i64toi32_i32$6 = i64toi32_i32$2;
     i64toi32_i32$6 = $54$hi;
     i64toi32_i32$6 = $62$hi;
     i64toi32_i32$6 = $59$hi;
     i64toi32_i32$4 = $3;
     i64toi32_i32$6 = HEAP32[(i64toi32_i32$4 + 144 | 0) >> 2] | 0;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 148 | 0) >> 2] | 0;
     $65 = i64toi32_i32$6;
     $65$hi = i64toi32_i32$5;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 152 | 0) >> 2] | 0;
     i64toi32_i32$6 = HEAP32[(i64toi32_i32$4 + 156 | 0) >> 2] | 0;
     $66 = i64toi32_i32$5;
     $66$hi = i64toi32_i32$6;
     i64toi32_i32$6 = $51$hi;
     i64toi32_i32$5 = i64toi32_i32$2;
     i64toi32_i32$4 = $54$hi;
     i64toi32_i32$3 = $62$hi;
     i64toi32_i32$2 = $59$hi;
     i64toi32_i32$0 = $65$hi;
     i64toi32_i32$1 = $66$hi;
     cryptoxide__hashing__sha2__impl512__reference__schedule_x2__hd52256e5a67097ab($3 + 128 | 0 | 0, $51 | 0, i64toi32_i32$6 | 0, $52 | 0, i64toi32_i32$5 | 0, $54 | 0, i64toi32_i32$4 | 0, $62 | 0, i64toi32_i32$3 | 0, $59 | 0, i64toi32_i32$2 | 0, $65 | 0, i64toi32_i32$0 | 0, $66 | 0, i64toi32_i32$1 | 0);
     i64toi32_i32$1 = $53$hi;
     i64toi32_i32$1 = i64toi32_i32$4;
     i64toi32_i32$1 = $56$hi;
     i64toi32_i32$1 = $64$hi;
     i64toi32_i32$1 = $61$hi;
     i64toi32_i32$2 = $3;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 128 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 132 | 0) >> 2] | 0;
     $67 = i64toi32_i32$1;
     $67$hi = i64toi32_i32$0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 136 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 140 | 0) >> 2] | 0;
     $68 = i64toi32_i32$0;
     $68$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $53$hi;
     i64toi32_i32$0 = i64toi32_i32$4;
     i64toi32_i32$2 = $56$hi;
     i64toi32_i32$3 = $64$hi;
     i64toi32_i32$4 = $61$hi;
     i64toi32_i32$5 = $67$hi;
     i64toi32_i32$6 = $68$hi;
     cryptoxide__hashing__sha2__impl512__reference__schedule_x2__hd52256e5a67097ab($3 + 112 | 0 | 0, $53 | 0, i64toi32_i32$1 | 0, $54 | 0, i64toi32_i32$0 | 0, $56 | 0, i64toi32_i32$2 | 0, $64 | 0, i64toi32_i32$3 | 0, $61 | 0, i64toi32_i32$4 | 0, $67 | 0, i64toi32_i32$5 | 0, $68 | 0, i64toi32_i32$6 | 0);
     i64toi32_i32$6 = $55$hi;
     i64toi32_i32$6 = i64toi32_i32$2;
     i64toi32_i32$6 = $58$hi;
     i64toi32_i32$6 = $66$hi;
     i64toi32_i32$6 = $63$hi;
     i64toi32_i32$4 = $3;
     i64toi32_i32$6 = HEAP32[(i64toi32_i32$4 + 112 | 0) >> 2] | 0;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 116 | 0) >> 2] | 0;
     $69 = i64toi32_i32$6;
     $69$hi = i64toi32_i32$5;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 120 | 0) >> 2] | 0;
     i64toi32_i32$6 = HEAP32[(i64toi32_i32$4 + 124 | 0) >> 2] | 0;
     $70 = i64toi32_i32$5;
     $70$hi = i64toi32_i32$6;
     i64toi32_i32$6 = $55$hi;
     i64toi32_i32$5 = i64toi32_i32$2;
     i64toi32_i32$4 = $58$hi;
     i64toi32_i32$3 = $66$hi;
     i64toi32_i32$2 = $63$hi;
     i64toi32_i32$0 = $69$hi;
     i64toi32_i32$1 = $70$hi;
     cryptoxide__hashing__sha2__impl512__reference__schedule_x2__hd52256e5a67097ab($3 + 96 | 0 | 0, $55 | 0, i64toi32_i32$6 | 0, $56 | 0, i64toi32_i32$5 | 0, $58 | 0, i64toi32_i32$4 | 0, $66 | 0, i64toi32_i32$3 | 0, $63 | 0, i64toi32_i32$2 | 0, $69 | 0, i64toi32_i32$0 | 0, $70 | 0, i64toi32_i32$1 | 0);
     i64toi32_i32$1 = $57$hi;
     i64toi32_i32$1 = i64toi32_i32$4;
     i64toi32_i32$1 = $60$hi;
     i64toi32_i32$1 = $68$hi;
     i64toi32_i32$1 = $65$hi;
     i64toi32_i32$2 = $3;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 100 | 0) >> 2] | 0;
     $71 = i64toi32_i32$1;
     $71$hi = i64toi32_i32$0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 104 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 108 | 0) >> 2] | 0;
     $72 = i64toi32_i32$0;
     $72$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $57$hi;
     i64toi32_i32$0 = i64toi32_i32$4;
     i64toi32_i32$2 = $60$hi;
     i64toi32_i32$3 = $68$hi;
     i64toi32_i32$4 = $65$hi;
     i64toi32_i32$5 = $71$hi;
     i64toi32_i32$6 = $72$hi;
     cryptoxide__hashing__sha2__impl512__reference__schedule_x2__hd52256e5a67097ab($3 + 80 | 0 | 0, $57 | 0, i64toi32_i32$1 | 0, $58 | 0, i64toi32_i32$0 | 0, $60 | 0, i64toi32_i32$2 | 0, $68 | 0, i64toi32_i32$3 | 0, $65 | 0, i64toi32_i32$4 | 0, $71 | 0, i64toi32_i32$5 | 0, $72 | 0, i64toi32_i32$6 | 0);
     i64toi32_i32$6 = $59$hi;
     i64toi32_i32$6 = i64toi32_i32$2;
     i64toi32_i32$6 = $62$hi;
     i64toi32_i32$6 = $70$hi;
     i64toi32_i32$6 = $67$hi;
     i64toi32_i32$4 = $3;
     i64toi32_i32$6 = HEAP32[(i64toi32_i32$4 + 80 | 0) >> 2] | 0;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 84 | 0) >> 2] | 0;
     $73 = i64toi32_i32$6;
     $73$hi = i64toi32_i32$5;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 88 | 0) >> 2] | 0;
     i64toi32_i32$6 = HEAP32[(i64toi32_i32$4 + 92 | 0) >> 2] | 0;
     $74 = i64toi32_i32$5;
     $74$hi = i64toi32_i32$6;
     i64toi32_i32$6 = $59$hi;
     i64toi32_i32$5 = i64toi32_i32$2;
     i64toi32_i32$4 = $62$hi;
     i64toi32_i32$3 = $70$hi;
     i64toi32_i32$2 = $67$hi;
     i64toi32_i32$0 = $73$hi;
     i64toi32_i32$1 = $74$hi;
     cryptoxide__hashing__sha2__impl512__reference__schedule_x2__hd52256e5a67097ab($3 + 64 | 0 | 0, $59 | 0, i64toi32_i32$6 | 0, $60 | 0, i64toi32_i32$5 | 0, $62 | 0, i64toi32_i32$4 | 0, $70 | 0, i64toi32_i32$3 | 0, $67 | 0, i64toi32_i32$2 | 0, $73 | 0, i64toi32_i32$0 | 0, $74 | 0, i64toi32_i32$1 | 0);
     i64toi32_i32$1 = $61$hi;
     i64toi32_i32$1 = i64toi32_i32$4;
     i64toi32_i32$1 = $64$hi;
     i64toi32_i32$1 = $72$hi;
     i64toi32_i32$1 = $69$hi;
     i64toi32_i32$2 = $3;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
     $75 = i64toi32_i32$1;
     $75$hi = i64toi32_i32$0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 72 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 76 | 0) >> 2] | 0;
     $76 = i64toi32_i32$0;
     $76$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $61$hi;
     i64toi32_i32$0 = i64toi32_i32$4;
     i64toi32_i32$2 = $64$hi;
     i64toi32_i32$3 = $72$hi;
     i64toi32_i32$4 = $69$hi;
     i64toi32_i32$5 = $75$hi;
     i64toi32_i32$6 = $76$hi;
     cryptoxide__hashing__sha2__impl512__reference__schedule_x2__hd52256e5a67097ab($3 + 48 | 0 | 0, $61 | 0, i64toi32_i32$1 | 0, $62 | 0, i64toi32_i32$0 | 0, $64 | 0, i64toi32_i32$2 | 0, $72 | 0, i64toi32_i32$3 | 0, $69 | 0, i64toi32_i32$4 | 0, $75 | 0, i64toi32_i32$5 | 0, $76 | 0, i64toi32_i32$6 | 0);
     i64toi32_i32$6 = $63$hi;
     i64toi32_i32$6 = i64toi32_i32$2;
     i64toi32_i32$6 = $66$hi;
     i64toi32_i32$6 = $74$hi;
     i64toi32_i32$6 = $71$hi;
     i64toi32_i32$4 = $3;
     i64toi32_i32$6 = HEAP32[(i64toi32_i32$4 + 48 | 0) >> 2] | 0;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 52 | 0) >> 2] | 0;
     $77 = i64toi32_i32$6;
     $77$hi = i64toi32_i32$5;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 56 | 0) >> 2] | 0;
     i64toi32_i32$6 = HEAP32[(i64toi32_i32$4 + 60 | 0) >> 2] | 0;
     $78 = i64toi32_i32$5;
     $78$hi = i64toi32_i32$6;
     i64toi32_i32$6 = $63$hi;
     i64toi32_i32$5 = i64toi32_i32$2;
     i64toi32_i32$4 = $66$hi;
     i64toi32_i32$3 = $74$hi;
     i64toi32_i32$2 = $71$hi;
     i64toi32_i32$0 = $77$hi;
     i64toi32_i32$1 = $78$hi;
     cryptoxide__hashing__sha2__impl512__reference__schedule_x2__hd52256e5a67097ab($3 + 32 | 0 | 0, $63 | 0, i64toi32_i32$6 | 0, $64 | 0, i64toi32_i32$5 | 0, $66 | 0, i64toi32_i32$4 | 0, $74 | 0, i64toi32_i32$3 | 0, $71 | 0, i64toi32_i32$2 | 0, $77 | 0, i64toi32_i32$0 | 0, $78 | 0, i64toi32_i32$1 | 0);
     i64toi32_i32$1 = $65$hi;
     i64toi32_i32$1 = i64toi32_i32$4;
     i64toi32_i32$1 = $68$hi;
     i64toi32_i32$1 = $76$hi;
     i64toi32_i32$1 = $73$hi;
     i64toi32_i32$2 = $3;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
     $79 = i64toi32_i32$1;
     $79$hi = i64toi32_i32$0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] | 0;
     $80 = i64toi32_i32$0;
     $80$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $65$hi;
     i64toi32_i32$0 = i64toi32_i32$4;
     i64toi32_i32$2 = $68$hi;
     i64toi32_i32$3 = $76$hi;
     i64toi32_i32$4 = $73$hi;
     i64toi32_i32$5 = $79$hi;
     i64toi32_i32$6 = $80$hi;
     cryptoxide__hashing__sha2__impl512__reference__schedule_x2__hd52256e5a67097ab($3 + 16 | 0 | 0, $65 | 0, i64toi32_i32$1 | 0, $66 | 0, i64toi32_i32$0 | 0, $68 | 0, i64toi32_i32$2 | 0, $76 | 0, i64toi32_i32$3 | 0, $73 | 0, i64toi32_i32$4 | 0, $79 | 0, i64toi32_i32$5 | 0, $80 | 0, i64toi32_i32$6 | 0);
     i64toi32_i32$6 = $67$hi;
     i64toi32_i32$6 = i64toi32_i32$2;
     i64toi32_i32$6 = $70$hi;
     i64toi32_i32$6 = $78$hi;
     i64toi32_i32$6 = $75$hi;
     i64toi32_i32$4 = $3;
     i64toi32_i32$6 = HEAP32[(i64toi32_i32$4 + 16 | 0) >> 2] | 0;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 20 | 0) >> 2] | 0;
     $81 = i64toi32_i32$6;
     $81$hi = i64toi32_i32$5;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 24 | 0) >> 2] | 0;
     i64toi32_i32$6 = HEAP32[(i64toi32_i32$4 + 28 | 0) >> 2] | 0;
     $82 = i64toi32_i32$5;
     $82$hi = i64toi32_i32$6;
     i64toi32_i32$6 = $67$hi;
     i64toi32_i32$5 = i64toi32_i32$2;
     i64toi32_i32$4 = $70$hi;
     i64toi32_i32$3 = $78$hi;
     i64toi32_i32$2 = $75$hi;
     i64toi32_i32$0 = $81$hi;
     i64toi32_i32$1 = $82$hi;
     cryptoxide__hashing__sha2__impl512__reference__schedule_x2__hd52256e5a67097ab($3 | 0, $67 | 0, i64toi32_i32$6 | 0, $68 | 0, i64toi32_i32$5 | 0, $70 | 0, i64toi32_i32$4 | 0, $78 | 0, i64toi32_i32$3 | 0, $75 | 0, i64toi32_i32$2 | 0, $81 | 0, i64toi32_i32$0 | 0, $82 | 0, i64toi32_i32$1 | 0);
     i64toi32_i32$2 = $3;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $83 = i64toi32_i32$1;
     $83$hi = i64toi32_i32$0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
     $84 = i64toi32_i32$0;
     $84$hi = i64toi32_i32$1;
     $595 = $0;
     i64toi32_i32$1 = $82$hi;
     $596 = $82;
     $596$hi = i64toi32_i32$1;
     i64toi32_i32$1 = i64toi32_i32$3;
     $597 = $78;
     $597$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $74$hi;
     $598 = $74;
     $598$hi = i64toi32_i32$1;
     i64toi32_i32$1 = i64toi32_i32$4;
     $599 = $70;
     $599$hi = i64toi32_i32$4;
     i64toi32_i32$1 = $66$hi;
     $600 = $66;
     $600$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $62$hi;
     $601 = $62;
     $601$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $58$hi;
     $602 = $58;
     $602$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $54$hi;
     $603 = $54;
     $603$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $50$hi;
     $604 = $50;
     $604$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $46$hi;
     $605 = $46;
     $605$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $42$hi;
     $606 = $42;
     $606$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $38$hi;
     $607 = $38;
     $607$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $34$hi;
     $608 = $34;
     $608$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $30$hi;
     $609 = $30;
     $609$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $26$hi;
     $610 = $26;
     $610$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $17$hi;
     $611 = $17;
     $611$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $14$hi;
     $612 = $14;
     $612$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $24$hi;
     $613 = $24;
     $613$hi = i64toi32_i32$1;
     i64toi32_i32$2 = $0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
     $85 = i64toi32_i32$1;
     $85$hi = i64toi32_i32$0;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($85 | 0, i64toi32_i32$0 | 0, 50 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $617 = i64toi32_i32$1;
     $617$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $85$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($85 | 0, i64toi32_i32$0 | 0, 46 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $619 = i64toi32_i32$1;
     $619$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $617$hi;
     i64toi32_i32$2 = $617;
     i64toi32_i32$1 = $619$hi;
     i64toi32_i32$3 = $619;
     i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
     $620 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $620$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $85$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($85 | 0, i64toi32_i32$1 | 0, 23 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $622 = i64toi32_i32$2;
     $622$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $620$hi;
     i64toi32_i32$0 = $620;
     i64toi32_i32$2 = $622$hi;
     i64toi32_i32$3 = $622;
     i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
     $623 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $623$hi = i64toi32_i32$2;
     i64toi32_i32$1 = $0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 56 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 60 | 0) >> 2] | 0;
     $86 = i64toi32_i32$2;
     $86$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $623$hi;
     i64toi32_i32$1 = $623;
     i64toi32_i32$2 = $86$hi;
     i64toi32_i32$3 = $86;
     i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $627$hi = i64toi32_i32$5;
     i64toi32_i32$0 = $0;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 48 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 52 | 0) >> 2] | 0;
     $87 = i64toi32_i32$5;
     $87$hi = i64toi32_i32$1;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 40 | 0) >> 2] | 0;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 44 | 0) >> 2] | 0;
     $88 = i64toi32_i32$1;
     $88$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $87$hi;
     i64toi32_i32$0 = $87;
     i64toi32_i32$1 = $88$hi;
     i64toi32_i32$3 = $88;
     i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
     $634$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $85$hi;
     i64toi32_i32$1 = $634$hi;
     i64toi32_i32$5 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     i64toi32_i32$0 = $85$hi;
     i64toi32_i32$3 = $85;
     i64toi32_i32$0 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
     $636$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $87$hi;
     i64toi32_i32$0 = $636$hi;
     i64toi32_i32$1 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     i64toi32_i32$5 = $87$hi;
     i64toi32_i32$3 = $87;
     i64toi32_i32$5 = i64toi32_i32$0 ^ i64toi32_i32$5 | 0;
     $638 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $638$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $627$hi;
     i64toi32_i32$0 = i64toi32_i32$4;
     i64toi32_i32$1 = $638$hi;
     i64toi32_i32$3 = $638;
     i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $639$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $5$hi;
     i64toi32_i32$4 = $639$hi;
     i64toi32_i32$5 = i64toi32_i32$2;
     i64toi32_i32$0 = $5$hi;
     i64toi32_i32$3 = $5;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     i64toi32_i32$4 = i64toi32_i32$1;
     i64toi32_i32$5 = 1116352408;
     i64toi32_i32$3 = -685199838;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $89 = i64toi32_i32$0;
     $89$hi = i64toi32_i32$1;
     i64toi32_i32$2 = $0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
     i64toi32_i32$4 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
     $90 = i64toi32_i32$1;
     $90$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$2 = i64toi32_i32$0;
     i64toi32_i32$1 = $90$hi;
     i64toi32_i32$3 = $90;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $5 = i64toi32_i32$5;
     $5$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$0 = $5$hi;
     i64toi32_i32$4 = i64toi32_i32$5;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $650 = i64toi32_i32$1;
     $650$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $85$hi;
     i64toi32_i32$5 = $12$hi;
     i64toi32_i32$5 = $85$hi;
     i64toi32_i32$0 = $85;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $653 = i64toi32_i32$2;
     $653$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $88$hi;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$1 = $88$hi;
     i64toi32_i32$5 = $88;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $656 = i64toi32_i32$4;
     $656$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $87$hi;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$2 = $87$hi;
     i64toi32_i32$1 = $87;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $659$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $5$hi;
     i64toi32_i32$4 = $88$hi;
     i64toi32_i32$4 = $85$hi;
     i64toi32_i32$4 = $88$hi;
     i64toi32_i32$2 = $88;
     i64toi32_i32$1 = $85$hi;
     i64toi32_i32$3 = $85;
     i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
     $663 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $663$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $5$hi;
     i64toi32_i32$4 = $5;
     i64toi32_i32$2 = $663$hi;
     i64toi32_i32$3 = $663;
     i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
     $664$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $88$hi;
     i64toi32_i32$2 = $664$hi;
     i64toi32_i32$1 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     i64toi32_i32$4 = $88$hi;
     i64toi32_i32$3 = $88;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $666 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $666$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $659$hi;
     i64toi32_i32$2 = i64toi32_i32$0;
     i64toi32_i32$1 = $666$hi;
     i64toi32_i32$3 = $666;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $667$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $5$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($5 | 0, i64toi32_i32$0 | 0, 50 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $669 = i64toi32_i32$2;
     $669$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $5$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($5 | 0, i64toi32_i32$0 | 0, 46 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $671 = i64toi32_i32$2;
     $671$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $669$hi;
     i64toi32_i32$4 = $669;
     i64toi32_i32$2 = $671$hi;
     i64toi32_i32$3 = $671;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $672 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $672$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $5$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($5 | 0, i64toi32_i32$2 | 0, 23 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $674 = i64toi32_i32$4;
     $674$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $672$hi;
     i64toi32_i32$0 = $672;
     i64toi32_i32$4 = $674$hi;
     i64toi32_i32$3 = $674;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $675 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $675$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $667$hi;
     i64toi32_i32$2 = i64toi32_i32$5;
     i64toi32_i32$0 = $675$hi;
     i64toi32_i32$3 = $675;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     i64toi32_i32$4 = i64toi32_i32$1;
     i64toi32_i32$2 = 1899447441;
     i64toi32_i32$3 = 602891725;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $91 = i64toi32_i32$0;
     $91$hi = i64toi32_i32$1;
     i64toi32_i32$5 = $0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 16 | 0) >> 2] | 0;
     i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 20 | 0) >> 2] | 0;
     $92 = i64toi32_i32$1;
     $92$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $91$hi;
     i64toi32_i32$5 = i64toi32_i32$0;
     i64toi32_i32$1 = $92$hi;
     i64toi32_i32$3 = $92;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $13 = i64toi32_i32$2;
     $13$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $5$hi;
     i64toi32_i32$0 = $85$hi;
     i64toi32_i32$0 = $5$hi;
     i64toi32_i32$4 = $5;
     i64toi32_i32$5 = $85$hi;
     i64toi32_i32$3 = $85;
     i64toi32_i32$5 = i64toi32_i32$0 ^ i64toi32_i32$5 | 0;
     $686 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $686$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$0 = i64toi32_i32$2;
     i64toi32_i32$4 = $686$hi;
     i64toi32_i32$3 = $686;
     i64toi32_i32$4 = i64toi32_i32$5 & i64toi32_i32$4 | 0;
     $687$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $85$hi;
     i64toi32_i32$4 = $687$hi;
     i64toi32_i32$5 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     i64toi32_i32$0 = $85$hi;
     i64toi32_i32$3 = $85;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $689 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $689$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $656$hi;
     i64toi32_i32$4 = $656;
     i64toi32_i32$5 = $689$hi;
     i64toi32_i32$3 = $689;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $690$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($13 | 0, i64toi32_i32$2 | 0, 50 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $692 = i64toi32_i32$4;
     $692$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($13 | 0, i64toi32_i32$2 | 0, 46 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $694 = i64toi32_i32$4;
     $694$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $692$hi;
     i64toi32_i32$0 = $692;
     i64toi32_i32$4 = $694$hi;
     i64toi32_i32$3 = $694;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $695 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $695$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($13 | 0, i64toi32_i32$4 | 0, 23 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $697 = i64toi32_i32$0;
     $697$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $695$hi;
     i64toi32_i32$2 = $695;
     i64toi32_i32$0 = $697$hi;
     i64toi32_i32$3 = $697;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $698 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $698$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $690$hi;
     i64toi32_i32$4 = i64toi32_i32$1;
     i64toi32_i32$2 = $698$hi;
     i64toi32_i32$3 = $698;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     i64toi32_i32$0 = i64toi32_i32$5;
     i64toi32_i32$4 = -1245643825;
     i64toi32_i32$3 = -330482897;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $93 = i64toi32_i32$2;
     $93$hi = i64toi32_i32$5;
     i64toi32_i32$1 = $0;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] | 0;
     $94 = i64toi32_i32$5;
     $94$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $93$hi;
     i64toi32_i32$1 = i64toi32_i32$2;
     i64toi32_i32$5 = $94$hi;
     i64toi32_i32$3 = $94;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $6 = i64toi32_i32$4;
     $6$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$2 = $5$hi;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$0 = $13;
     i64toi32_i32$1 = $5$hi;
     i64toi32_i32$3 = $5;
     i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
     $709 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $709$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$2 = i64toi32_i32$4;
     i64toi32_i32$0 = $709$hi;
     i64toi32_i32$3 = $709;
     i64toi32_i32$0 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
     $710$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $5$hi;
     i64toi32_i32$0 = $710$hi;
     i64toi32_i32$1 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     i64toi32_i32$2 = $5$hi;
     i64toi32_i32$3 = $5;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $712 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $712$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $653$hi;
     i64toi32_i32$0 = $653;
     i64toi32_i32$1 = $712$hi;
     i64toi32_i32$3 = $712;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $713$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($6 | 0, i64toi32_i32$4 | 0, 50 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $715 = i64toi32_i32$0;
     $715$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($6 | 0, i64toi32_i32$4 | 0, 46 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $717 = i64toi32_i32$0;
     $717$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $715$hi;
     i64toi32_i32$2 = $715;
     i64toi32_i32$0 = $717$hi;
     i64toi32_i32$3 = $717;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $718 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $718$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($6 | 0, i64toi32_i32$0 | 0, 23 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $720 = i64toi32_i32$2;
     $720$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $718$hi;
     i64toi32_i32$4 = $718;
     i64toi32_i32$2 = $720$hi;
     i64toi32_i32$3 = $720;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $721 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $721$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $713$hi;
     i64toi32_i32$0 = i64toi32_i32$5;
     i64toi32_i32$4 = $721$hi;
     i64toi32_i32$3 = $721;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$0 = -373957723;
     i64toi32_i32$3 = -2121671748;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $95 = i64toi32_i32$4;
     $95$hi = i64toi32_i32$1;
     i64toi32_i32$5 = $0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$5 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
     $5 = i64toi32_i32$1;
     $5$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $95$hi;
     i64toi32_i32$5 = i64toi32_i32$4;
     i64toi32_i32$1 = $5$hi;
     i64toi32_i32$3 = $5;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $12 = i64toi32_i32$0;
     $12$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$2 = $6;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
     $732 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $732$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $12$hi;
     i64toi32_i32$4 = i64toi32_i32$0;
     i64toi32_i32$2 = $732$hi;
     i64toi32_i32$3 = $732;
     i64toi32_i32$2 = i64toi32_i32$5 & i64toi32_i32$2 | 0;
     $733$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$2 = $733$hi;
     i64toi32_i32$5 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $735 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $735$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $650$hi;
     i64toi32_i32$2 = $650;
     i64toi32_i32$5 = $735$hi;
     i64toi32_i32$3 = $735;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $736$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($12 | 0, i64toi32_i32$0 | 0, 50 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $738 = i64toi32_i32$2;
     $738$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($12 | 0, i64toi32_i32$0 | 0, 46 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $740 = i64toi32_i32$2;
     $740$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $738$hi;
     i64toi32_i32$4 = $738;
     i64toi32_i32$2 = $740$hi;
     i64toi32_i32$3 = $740;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $741 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $741$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($12 | 0, i64toi32_i32$2 | 0, 23 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $743 = i64toi32_i32$4;
     $743$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $741$hi;
     i64toi32_i32$0 = $741;
     i64toi32_i32$4 = $743$hi;
     i64toi32_i32$3 = $743;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $744 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $744$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $736$hi;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$0 = $744$hi;
     i64toi32_i32$3 = $744;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     i64toi32_i32$4 = i64toi32_i32$5;
     i64toi32_i32$2 = 961987163;
     i64toi32_i32$3 = -213338824;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $96 = i64toi32_i32$0;
     $96$hi = i64toi32_i32$5;
     $747 = i64toi32_i32$0;
     $747$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $92$hi;
     i64toi32_i32$5 = $94$hi;
     i64toi32_i32$5 = $92$hi;
     i64toi32_i32$1 = $92;
     i64toi32_i32$4 = $94$hi;
     i64toi32_i32$3 = $94;
     i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
     $750$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $5$hi;
     i64toi32_i32$4 = $750$hi;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     i64toi32_i32$1 = $5$hi;
     i64toi32_i32$3 = $5;
     i64toi32_i32$1 = i64toi32_i32$4 & i64toi32_i32$1 | 0;
     $752 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $752$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $92$hi;
     i64toi32_i32$1 = $94$hi;
     i64toi32_i32$1 = $92$hi;
     i64toi32_i32$4 = $92;
     i64toi32_i32$5 = $94$hi;
     i64toi32_i32$3 = $94;
     i64toi32_i32$5 = i64toi32_i32$1 & i64toi32_i32$5 | 0;
     $755 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     $755$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $752$hi;
     i64toi32_i32$1 = $752;
     i64toi32_i32$4 = $755$hi;
     i64toi32_i32$3 = $755;
     i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
     $756 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $756$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $5$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($5 | 0, i64toi32_i32$4 | 0, 36 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $758 = i64toi32_i32$1;
     $758$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $5$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($5 | 0, i64toi32_i32$4 | 0, 30 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $760 = i64toi32_i32$1;
     $760$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $758$hi;
     i64toi32_i32$5 = $758;
     i64toi32_i32$1 = $760$hi;
     i64toi32_i32$3 = $760;
     i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
     $761 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $761$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $5$hi;
     i64toi32_i32$5 = 0;
     i64toi32_i32$5 = __wasm_rotl_i64($5 | 0, i64toi32_i32$1 | 0, 25 | 0, i64toi32_i32$5 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $763 = i64toi32_i32$5;
     $763$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $761$hi;
     i64toi32_i32$4 = $761;
     i64toi32_i32$5 = $763$hi;
     i64toi32_i32$3 = $763;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $764 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $764$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $756$hi;
     i64toi32_i32$1 = $756;
     i64toi32_i32$4 = $764$hi;
     i64toi32_i32$3 = $764;
     i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $765$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$0 = $765$hi;
     i64toi32_i32$5 = i64toi32_i32$2;
     i64toi32_i32$1 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $7 = i64toi32_i32$4;
     $7$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $747$hi;
     i64toi32_i32$0 = $747;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$3 = i64toi32_i32$4;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $89 = i64toi32_i32$1;
     $89$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $613$hi;
     i64toi32_i32$2 = $613;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$3 = i64toi32_i32$1;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $771 = i64toi32_i32$5;
     $771$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $23$hi;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$1 = $23$hi;
     i64toi32_i32$4 = $23;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $774 = i64toi32_i32$0;
     $774$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $19$hi;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$5 = $19$hi;
     i64toi32_i32$1 = $19;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $777 = i64toi32_i32$2;
     $777$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $18$hi;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$0 = $18$hi;
     i64toi32_i32$5 = $18;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $780$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$0 = $12;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
     $784 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $784$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$2 = $89;
     i64toi32_i32$0 = $784$hi;
     i64toi32_i32$3 = $784;
     i64toi32_i32$0 = i64toi32_i32$5 & i64toi32_i32$0 | 0;
     $785$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$0 = $785$hi;
     i64toi32_i32$5 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $787 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $787$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $780$hi;
     i64toi32_i32$0 = i64toi32_i32$4;
     i64toi32_i32$5 = $787$hi;
     i64toi32_i32$3 = $787;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $788$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($89 | 0, i64toi32_i32$4 | 0, 50 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $790 = i64toi32_i32$0;
     $790$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($89 | 0, i64toi32_i32$4 | 0, 46 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $792 = i64toi32_i32$0;
     $792$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $790$hi;
     i64toi32_i32$2 = $790;
     i64toi32_i32$0 = $792$hi;
     i64toi32_i32$3 = $792;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $793 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $793$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($89 | 0, i64toi32_i32$0 | 0, 23 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $795 = i64toi32_i32$2;
     $795$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $793$hi;
     i64toi32_i32$4 = $793;
     i64toi32_i32$2 = $795$hi;
     i64toi32_i32$3 = $795;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $796 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $796$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $788$hi;
     i64toi32_i32$0 = i64toi32_i32$1;
     i64toi32_i32$4 = $796$hi;
     i64toi32_i32$3 = $796;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     i64toi32_i32$2 = i64toi32_i32$5;
     i64toi32_i32$0 = 1508970993;
     i64toi32_i32$3 = -1241133031;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $18 = i64toi32_i32$4;
     $18$hi = i64toi32_i32$5;
     $799 = i64toi32_i32$4;
     $799$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 36 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $801 = i64toi32_i32$2;
     $801$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 30 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $803 = i64toi32_i32$2;
     $803$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $801$hi;
     i64toi32_i32$1 = $801;
     i64toi32_i32$2 = $803$hi;
     i64toi32_i32$3 = $803;
     i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
     $804 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $804$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($7 | 0, i64toi32_i32$2 | 0, 25 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $806 = i64toi32_i32$1;
     $806$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $804$hi;
     i64toi32_i32$5 = $804;
     i64toi32_i32$1 = $806$hi;
     i64toi32_i32$3 = $806;
     i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
     $807 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $807$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$1 = $94$hi;
     i64toi32_i32$1 = $5$hi;
     i64toi32_i32$1 = $94$hi;
     i64toi32_i32$2 = $94;
     i64toi32_i32$5 = $5$hi;
     i64toi32_i32$3 = $5;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $811 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $811$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$1 = $7;
     i64toi32_i32$2 = $811$hi;
     i64toi32_i32$3 = $811;
     i64toi32_i32$2 = i64toi32_i32$5 & i64toi32_i32$2 | 0;
     $812 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $812$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $94$hi;
     i64toi32_i32$2 = $5$hi;
     i64toi32_i32$2 = $94$hi;
     i64toi32_i32$5 = $94;
     i64toi32_i32$1 = $5$hi;
     i64toi32_i32$3 = $5;
     i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
     $815 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $815$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $812$hi;
     i64toi32_i32$2 = $812;
     i64toi32_i32$5 = $815$hi;
     i64toi32_i32$3 = $815;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $816 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $816$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $807$hi;
     i64toi32_i32$1 = $807;
     i64toi32_i32$2 = $816$hi;
     i64toi32_i32$3 = $816;
     i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $817$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $91$hi;
     i64toi32_i32$4 = $817$hi;
     i64toi32_i32$5 = i64toi32_i32$0;
     i64toi32_i32$1 = $91$hi;
     i64toi32_i32$3 = $91;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $13 = i64toi32_i32$2;
     $13$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $799$hi;
     i64toi32_i32$4 = $799;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$3 = i64toi32_i32$2;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $19 = i64toi32_i32$1;
     $19$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$0 = $89;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $825 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $825$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$0 = $825$hi;
     i64toi32_i32$3 = $825;
     i64toi32_i32$0 = i64toi32_i32$4 & i64toi32_i32$0 | 0;
     $826$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$0 = $826$hi;
     i64toi32_i32$4 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $828 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $828$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $777$hi;
     i64toi32_i32$0 = $777;
     i64toi32_i32$4 = $828$hi;
     i64toi32_i32$3 = $828;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $829$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $19$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($19 | 0, i64toi32_i32$1 | 0, 50 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $831 = i64toi32_i32$0;
     $831$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $19$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($19 | 0, i64toi32_i32$1 | 0, 46 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $833 = i64toi32_i32$0;
     $833$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $831$hi;
     i64toi32_i32$2 = $831;
     i64toi32_i32$0 = $833$hi;
     i64toi32_i32$3 = $833;
     i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
     $834 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $834$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($19 | 0, i64toi32_i32$0 | 0, 23 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $836 = i64toi32_i32$2;
     $836$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $834$hi;
     i64toi32_i32$1 = $834;
     i64toi32_i32$2 = $836$hi;
     i64toi32_i32$3 = $836;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $837 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $837$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $829$hi;
     i64toi32_i32$0 = i64toi32_i32$5;
     i64toi32_i32$1 = $837$hi;
     i64toi32_i32$3 = $837;
     i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     i64toi32_i32$2 = i64toi32_i32$4;
     i64toi32_i32$0 = -1841331548;
     i64toi32_i32$3 = -1357295717;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $23 = i64toi32_i32$1;
     $23$hi = i64toi32_i32$4;
     $840 = i64toi32_i32$1;
     $840$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($13 | 0, i64toi32_i32$4 | 0, 36 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $842 = i64toi32_i32$2;
     $842$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($13 | 0, i64toi32_i32$4 | 0, 30 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $844 = i64toi32_i32$2;
     $844$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $842$hi;
     i64toi32_i32$5 = $842;
     i64toi32_i32$2 = $844$hi;
     i64toi32_i32$3 = $844;
     i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
     $845 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $845$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$5 = 0;
     i64toi32_i32$5 = __wasm_rotl_i64($13 | 0, i64toi32_i32$2 | 0, 25 | 0, i64toi32_i32$5 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $847 = i64toi32_i32$5;
     $847$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $845$hi;
     i64toi32_i32$4 = $845;
     i64toi32_i32$5 = $847$hi;
     i64toi32_i32$3 = $847;
     i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
     $848 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $848$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$5 = $5$hi;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$2 = $7;
     i64toi32_i32$4 = $5$hi;
     i64toi32_i32$3 = $5;
     i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
     $852 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $852$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$5 = $13;
     i64toi32_i32$2 = $852$hi;
     i64toi32_i32$3 = $852;
     i64toi32_i32$2 = i64toi32_i32$4 & i64toi32_i32$2 | 0;
     $853 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $853$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$2 = $5$hi;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$4 = $7;
     i64toi32_i32$5 = $5$hi;
     i64toi32_i32$3 = $5;
     i64toi32_i32$5 = i64toi32_i32$2 & i64toi32_i32$5 | 0;
     $856 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     $856$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $853$hi;
     i64toi32_i32$2 = $853;
     i64toi32_i32$4 = $856$hi;
     i64toi32_i32$3 = $856;
     i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
     $857 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $857$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $848$hi;
     i64toi32_i32$5 = $848;
     i64toi32_i32$2 = $857$hi;
     i64toi32_i32$3 = $857;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $858$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $93$hi;
     i64toi32_i32$1 = $858$hi;
     i64toi32_i32$4 = i64toi32_i32$0;
     i64toi32_i32$5 = $93$hi;
     i64toi32_i32$3 = $93;
     i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $6 = i64toi32_i32$2;
     $6$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $840$hi;
     i64toi32_i32$1 = $840;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$3 = i64toi32_i32$2;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $12 = i64toi32_i32$5;
     $12$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$0 = $19;
     i64toi32_i32$1 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
     $866 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $866$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$2 = i64toi32_i32$5;
     i64toi32_i32$0 = $866$hi;
     i64toi32_i32$3 = $866;
     i64toi32_i32$0 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
     $867$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$0 = $867$hi;
     i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $869 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $869$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $774$hi;
     i64toi32_i32$0 = $774;
     i64toi32_i32$1 = $869$hi;
     i64toi32_i32$3 = $869;
     i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $870$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $12$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($12 | 0, i64toi32_i32$5 | 0, 50 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $872 = i64toi32_i32$0;
     $872$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $12$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($12 | 0, i64toi32_i32$5 | 0, 46 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $874 = i64toi32_i32$0;
     $874$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $872$hi;
     i64toi32_i32$2 = $872;
     i64toi32_i32$0 = $874$hi;
     i64toi32_i32$3 = $874;
     i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
     $875 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $875$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($12 | 0, i64toi32_i32$0 | 0, 23 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $877 = i64toi32_i32$2;
     $877$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $875$hi;
     i64toi32_i32$5 = $875;
     i64toi32_i32$2 = $877$hi;
     i64toi32_i32$3 = $877;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $878 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $878$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $870$hi;
     i64toi32_i32$0 = i64toi32_i32$4;
     i64toi32_i32$5 = $878$hi;
     i64toi32_i32$3 = $878;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$0 = -1424204075;
     i64toi32_i32$3 = -630357736;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $91 = i64toi32_i32$5;
     $91$hi = i64toi32_i32$1;
     $881 = i64toi32_i32$5;
     $881$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($6 | 0, i64toi32_i32$1 | 0, 36 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $883 = i64toi32_i32$2;
     $883$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($6 | 0, i64toi32_i32$1 | 0, 30 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $885 = i64toi32_i32$2;
     $885$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $883$hi;
     i64toi32_i32$4 = $883;
     i64toi32_i32$2 = $885$hi;
     i64toi32_i32$3 = $885;
     i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
     $886 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $886$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($6 | 0, i64toi32_i32$2 | 0, 25 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $888 = i64toi32_i32$4;
     $888$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $886$hi;
     i64toi32_i32$1 = $886;
     i64toi32_i32$4 = $888$hi;
     i64toi32_i32$3 = $888;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $889 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $889$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$2 = $13;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
     $893 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $893$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$4 = $6;
     i64toi32_i32$2 = $893$hi;
     i64toi32_i32$3 = $893;
     i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
     $894 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     $894$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$1 = $13;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$4 = i64toi32_i32$2 & i64toi32_i32$4 | 0;
     $897 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $897$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $894$hi;
     i64toi32_i32$2 = $894;
     i64toi32_i32$1 = $897$hi;
     i64toi32_i32$3 = $897;
     i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
     $898 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $898$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $889$hi;
     i64toi32_i32$4 = $889;
     i64toi32_i32$2 = $898$hi;
     i64toi32_i32$3 = $898;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $899$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $95$hi;
     i64toi32_i32$5 = $899$hi;
     i64toi32_i32$1 = i64toi32_i32$0;
     i64toi32_i32$4 = $95$hi;
     i64toi32_i32$3 = $95;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $7 = i64toi32_i32$2;
     $7$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $881$hi;
     i64toi32_i32$5 = $881;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$3 = i64toi32_i32$2;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $89 = i64toi32_i32$4;
     $89$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$0 = $12;
     i64toi32_i32$5 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
     $907 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $907$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$2 = i64toi32_i32$4;
     i64toi32_i32$0 = $907$hi;
     i64toi32_i32$3 = $907;
     i64toi32_i32$0 = i64toi32_i32$5 & i64toi32_i32$0 | 0;
     $908$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$0 = $908$hi;
     i64toi32_i32$5 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $910 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $910$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $771$hi;
     i64toi32_i32$0 = $771;
     i64toi32_i32$5 = $910$hi;
     i64toi32_i32$3 = $910;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $911$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($89 | 0, i64toi32_i32$4 | 0, 50 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $913 = i64toi32_i32$0;
     $913$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($89 | 0, i64toi32_i32$4 | 0, 46 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $915 = i64toi32_i32$0;
     $915$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $913$hi;
     i64toi32_i32$2 = $913;
     i64toi32_i32$0 = $915$hi;
     i64toi32_i32$3 = $915;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $916 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $916$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($89 | 0, i64toi32_i32$0 | 0, 23 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $918 = i64toi32_i32$2;
     $918$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $916$hi;
     i64toi32_i32$4 = $916;
     i64toi32_i32$2 = $918$hi;
     i64toi32_i32$3 = $918;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $919 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $919$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $911$hi;
     i64toi32_i32$0 = i64toi32_i32$1;
     i64toi32_i32$4 = $919$hi;
     i64toi32_i32$3 = $919;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     i64toi32_i32$2 = i64toi32_i32$5;
     i64toi32_i32$0 = -670586216;
     i64toi32_i32$3 = -1560083902;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $93 = i64toi32_i32$4;
     $93$hi = i64toi32_i32$5;
     $922 = i64toi32_i32$4;
     $922$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 36 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $924 = i64toi32_i32$2;
     $924$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 30 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $926 = i64toi32_i32$2;
     $926$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $924$hi;
     i64toi32_i32$1 = $924;
     i64toi32_i32$2 = $926$hi;
     i64toi32_i32$3 = $926;
     i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
     $927 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $927$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($7 | 0, i64toi32_i32$2 | 0, 25 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $929 = i64toi32_i32$1;
     $929$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $927$hi;
     i64toi32_i32$5 = $927;
     i64toi32_i32$1 = $929$hi;
     i64toi32_i32$3 = $929;
     i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
     $930 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $930$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$2 = $6;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $934 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $934$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$1 = $7;
     i64toi32_i32$2 = $934$hi;
     i64toi32_i32$3 = $934;
     i64toi32_i32$2 = i64toi32_i32$5 & i64toi32_i32$2 | 0;
     $935 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $935$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$5 = $6;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
     $938 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $938$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $935$hi;
     i64toi32_i32$2 = $935;
     i64toi32_i32$5 = $938$hi;
     i64toi32_i32$3 = $938;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $939 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $939$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $930$hi;
     i64toi32_i32$1 = $930;
     i64toi32_i32$2 = $939$hi;
     i64toi32_i32$3 = $939;
     i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $940$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $96$hi;
     i64toi32_i32$4 = $940$hi;
     i64toi32_i32$5 = i64toi32_i32$0;
     i64toi32_i32$1 = $96$hi;
     i64toi32_i32$3 = $96;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $13 = i64toi32_i32$2;
     $13$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $922$hi;
     i64toi32_i32$4 = $922;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$3 = i64toi32_i32$2;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $24 = i64toi32_i32$1;
     $24$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $612$hi;
     i64toi32_i32$0 = $612;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$3 = i64toi32_i32$1;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $946 = i64toi32_i32$5;
     $946$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $15$hi;
     i64toi32_i32$1 = $89$hi;
     i64toi32_i32$1 = $15$hi;
     i64toi32_i32$2 = $15;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $949 = i64toi32_i32$4;
     $949$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $8$hi;
     i64toi32_i32$5 = $12$hi;
     i64toi32_i32$5 = $8$hi;
     i64toi32_i32$1 = $8;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $952 = i64toi32_i32$0;
     $952$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $9$hi;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$4 = $9$hi;
     i64toi32_i32$5 = $9;
     i64toi32_i32$1 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $955$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$4 = $89;
     i64toi32_i32$5 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$5 = i64toi32_i32$0 ^ i64toi32_i32$5 | 0;
     $959 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $959$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $24$hi;
     i64toi32_i32$0 = $24;
     i64toi32_i32$4 = $959$hi;
     i64toi32_i32$3 = $959;
     i64toi32_i32$4 = i64toi32_i32$5 & i64toi32_i32$4 | 0;
     $960$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$4 = $960$hi;
     i64toi32_i32$5 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $962 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $962$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $955$hi;
     i64toi32_i32$4 = i64toi32_i32$2;
     i64toi32_i32$5 = $962$hi;
     i64toi32_i32$3 = $962;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $963$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($24 | 0, i64toi32_i32$2 | 0, 50 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $965 = i64toi32_i32$4;
     $965$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($24 | 0, i64toi32_i32$2 | 0, 46 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $967 = i64toi32_i32$4;
     $967$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $965$hi;
     i64toi32_i32$0 = $965;
     i64toi32_i32$4 = $967$hi;
     i64toi32_i32$3 = $967;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $968 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $968$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($24 | 0, i64toi32_i32$4 | 0, 23 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $970 = i64toi32_i32$0;
     $970$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $968$hi;
     i64toi32_i32$2 = $968;
     i64toi32_i32$0 = $970$hi;
     i64toi32_i32$3 = $970;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $971 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $971$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $963$hi;
     i64toi32_i32$4 = i64toi32_i32$1;
     i64toi32_i32$2 = $971$hi;
     i64toi32_i32$3 = $971;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     i64toi32_i32$0 = i64toi32_i32$5;
     i64toi32_i32$4 = 310598401;
     i64toi32_i32$3 = 1164996542;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $8 = i64toi32_i32$2;
     $8$hi = i64toi32_i32$5;
     $974 = i64toi32_i32$2;
     $974$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($13 | 0, i64toi32_i32$5 | 0, 36 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $976 = i64toi32_i32$0;
     $976$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($13 | 0, i64toi32_i32$5 | 0, 30 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $978 = i64toi32_i32$0;
     $978$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $976$hi;
     i64toi32_i32$1 = $976;
     i64toi32_i32$0 = $978$hi;
     i64toi32_i32$3 = $978;
     i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
     $979 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $979$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($13 | 0, i64toi32_i32$0 | 0, 25 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $981 = i64toi32_i32$1;
     $981$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $979$hi;
     i64toi32_i32$5 = $979;
     i64toi32_i32$1 = $981$hi;
     i64toi32_i32$3 = $981;
     i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
     $982 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $982$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$0 = $7;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $986 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $986$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$1 = $13;
     i64toi32_i32$0 = $986$hi;
     i64toi32_i32$3 = $986;
     i64toi32_i32$0 = i64toi32_i32$5 & i64toi32_i32$0 | 0;
     $987 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $987$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$5 = $7;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
     $990 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $990$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $987$hi;
     i64toi32_i32$0 = $987;
     i64toi32_i32$5 = $990$hi;
     i64toi32_i32$3 = $990;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $991 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $991$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $982$hi;
     i64toi32_i32$1 = $982;
     i64toi32_i32$0 = $991$hi;
     i64toi32_i32$3 = $991;
     i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $992$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $18$hi;
     i64toi32_i32$2 = $992$hi;
     i64toi32_i32$5 = i64toi32_i32$4;
     i64toi32_i32$1 = $18$hi;
     i64toi32_i32$3 = $18;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $6 = i64toi32_i32$0;
     $6$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $974$hi;
     i64toi32_i32$2 = $974;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$3 = i64toi32_i32$0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $12 = i64toi32_i32$1;
     $12$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$4 = $24;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $1000 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $1000$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$0 = i64toi32_i32$1;
     i64toi32_i32$4 = $1000$hi;
     i64toi32_i32$3 = $1000;
     i64toi32_i32$4 = i64toi32_i32$2 & i64toi32_i32$4 | 0;
     $1001$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$4 = $1001$hi;
     i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $1003 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $1003$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $952$hi;
     i64toi32_i32$4 = $952;
     i64toi32_i32$2 = $1003$hi;
     i64toi32_i32$3 = $1003;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $1004$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($12 | 0, i64toi32_i32$1 | 0, 50 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $1006 = i64toi32_i32$4;
     $1006$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($12 | 0, i64toi32_i32$1 | 0, 46 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $1008 = i64toi32_i32$4;
     $1008$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $1006$hi;
     i64toi32_i32$0 = $1006;
     i64toi32_i32$4 = $1008$hi;
     i64toi32_i32$3 = $1008;
     i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
     $1009 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $1009$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($12 | 0, i64toi32_i32$4 | 0, 23 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $1011 = i64toi32_i32$0;
     $1011$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1009$hi;
     i64toi32_i32$1 = $1009;
     i64toi32_i32$0 = $1011$hi;
     i64toi32_i32$3 = $1011;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $1012 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $1012$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $1004$hi;
     i64toi32_i32$4 = i64toi32_i32$5;
     i64toi32_i32$1 = $1012$hi;
     i64toi32_i32$3 = $1012;
     i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     i64toi32_i32$0 = i64toi32_i32$2;
     i64toi32_i32$4 = 607225278;
     i64toi32_i32$3 = 1323610764;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $14 = i64toi32_i32$1;
     $14$hi = i64toi32_i32$2;
     $1015 = i64toi32_i32$1;
     $1015$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($6 | 0, i64toi32_i32$2 | 0, 36 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $1017 = i64toi32_i32$0;
     $1017$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($6 | 0, i64toi32_i32$2 | 0, 30 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $1019 = i64toi32_i32$0;
     $1019$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1017$hi;
     i64toi32_i32$5 = $1017;
     i64toi32_i32$0 = $1019$hi;
     i64toi32_i32$3 = $1019;
     i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
     $1020 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $1020$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$5 = 0;
     i64toi32_i32$5 = __wasm_rotl_i64($6 | 0, i64toi32_i32$0 | 0, 25 | 0, i64toi32_i32$5 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $1022 = i64toi32_i32$5;
     $1022$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $1020$hi;
     i64toi32_i32$2 = $1020;
     i64toi32_i32$5 = $1022$hi;
     i64toi32_i32$3 = $1022;
     i64toi32_i32$5 = i64toi32_i32$0 ^ i64toi32_i32$5 | 0;
     $1023 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $1023$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$0 = $13;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
     $1027 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $1027$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$5 = $6;
     i64toi32_i32$0 = $1027$hi;
     i64toi32_i32$3 = $1027;
     i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
     $1028 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $1028$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$2 = $13;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$5 = i64toi32_i32$0 & i64toi32_i32$5 | 0;
     $1031 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     $1031$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $1028$hi;
     i64toi32_i32$0 = $1028;
     i64toi32_i32$2 = $1031$hi;
     i64toi32_i32$3 = $1031;
     i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
     $1032 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $1032$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1023$hi;
     i64toi32_i32$5 = $1023;
     i64toi32_i32$0 = $1032$hi;
     i64toi32_i32$3 = $1032;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $1033$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $23$hi;
     i64toi32_i32$1 = $1033$hi;
     i64toi32_i32$2 = i64toi32_i32$4;
     i64toi32_i32$5 = $23$hi;
     i64toi32_i32$3 = $23;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $7 = i64toi32_i32$0;
     $7$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1015$hi;
     i64toi32_i32$1 = $1015;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$3 = i64toi32_i32$0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $89 = i64toi32_i32$5;
     $89$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$4 = $12;
     i64toi32_i32$1 = $24$hi;
     i64toi32_i32$3 = $24;
     i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
     $1041 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $1041$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $89$hi;
     i64toi32_i32$0 = i64toi32_i32$5;
     i64toi32_i32$4 = $1041$hi;
     i64toi32_i32$3 = $1041;
     i64toi32_i32$4 = i64toi32_i32$1 & i64toi32_i32$4 | 0;
     $1042$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$4 = $1042$hi;
     i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$3 = $24;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $1044 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $1044$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $949$hi;
     i64toi32_i32$4 = $949;
     i64toi32_i32$1 = $1044$hi;
     i64toi32_i32$3 = $1044;
     i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $1045$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($89 | 0, i64toi32_i32$5 | 0, 50 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $1047 = i64toi32_i32$4;
     $1047$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($89 | 0, i64toi32_i32$5 | 0, 46 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $1049 = i64toi32_i32$4;
     $1049$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $1047$hi;
     i64toi32_i32$0 = $1047;
     i64toi32_i32$4 = $1049$hi;
     i64toi32_i32$3 = $1049;
     i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
     $1050 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $1050$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($89 | 0, i64toi32_i32$4 | 0, 23 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $1052 = i64toi32_i32$0;
     $1052$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1050$hi;
     i64toi32_i32$5 = $1050;
     i64toi32_i32$0 = $1052$hi;
     i64toi32_i32$3 = $1052;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $1053 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $1053$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $1045$hi;
     i64toi32_i32$4 = i64toi32_i32$2;
     i64toi32_i32$5 = $1053$hi;
     i64toi32_i32$3 = $1053;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     i64toi32_i32$0 = i64toi32_i32$1;
     i64toi32_i32$4 = 1426881987;
     i64toi32_i32$3 = -704662302;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $9 = i64toi32_i32$5;
     $9$hi = i64toi32_i32$1;
     $1056 = i64toi32_i32$5;
     $1056$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($7 | 0, i64toi32_i32$1 | 0, 36 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $1058 = i64toi32_i32$0;
     $1058$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($7 | 0, i64toi32_i32$1 | 0, 30 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $1060 = i64toi32_i32$0;
     $1060$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $1058$hi;
     i64toi32_i32$2 = $1058;
     i64toi32_i32$0 = $1060$hi;
     i64toi32_i32$3 = $1060;
     i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
     $1061 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $1061$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 25 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $1063 = i64toi32_i32$2;
     $1063$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $1061$hi;
     i64toi32_i32$1 = $1061;
     i64toi32_i32$2 = $1063$hi;
     i64toi32_i32$3 = $1063;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $1064 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $1064$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$0 = $6;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
     $1068 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $1068$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$2 = $7;
     i64toi32_i32$0 = $1068$hi;
     i64toi32_i32$3 = $1068;
     i64toi32_i32$0 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
     $1069 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     $1069$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$1 = $6;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
     $1072 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $1072$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1069$hi;
     i64toi32_i32$0 = $1069;
     i64toi32_i32$1 = $1072$hi;
     i64toi32_i32$3 = $1072;
     i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
     $1073 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $1073$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $1064$hi;
     i64toi32_i32$2 = $1064;
     i64toi32_i32$0 = $1073$hi;
     i64toi32_i32$3 = $1073;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $1074$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $91$hi;
     i64toi32_i32$5 = $1074$hi;
     i64toi32_i32$1 = i64toi32_i32$4;
     i64toi32_i32$2 = $91$hi;
     i64toi32_i32$3 = $91;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $13 = i64toi32_i32$0;
     $13$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1056$hi;
     i64toi32_i32$5 = $1056;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$3 = i64toi32_i32$0;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $19 = i64toi32_i32$2;
     $19$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$4 = $89;
     i64toi32_i32$5 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$5 = i64toi32_i32$0 ^ i64toi32_i32$5 | 0;
     $1082 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $1082$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $19$hi;
     i64toi32_i32$0 = i64toi32_i32$2;
     i64toi32_i32$4 = $1082$hi;
     i64toi32_i32$3 = $1082;
     i64toi32_i32$4 = i64toi32_i32$5 & i64toi32_i32$4 | 0;
     $1083$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$4 = $1083$hi;
     i64toi32_i32$5 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $1085 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $1085$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $946$hi;
     i64toi32_i32$4 = $946;
     i64toi32_i32$5 = $1085$hi;
     i64toi32_i32$3 = $1085;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $1086$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($19 | 0, i64toi32_i32$2 | 0, 50 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $1088 = i64toi32_i32$4;
     $1088$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($19 | 0, i64toi32_i32$2 | 0, 46 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $1090 = i64toi32_i32$4;
     $1090$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1088$hi;
     i64toi32_i32$0 = $1088;
     i64toi32_i32$4 = $1090$hi;
     i64toi32_i32$3 = $1090;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $1091 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $1091$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($19 | 0, i64toi32_i32$4 | 0, 23 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $1093 = i64toi32_i32$0;
     $1093$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1091$hi;
     i64toi32_i32$2 = $1091;
     i64toi32_i32$0 = $1093$hi;
     i64toi32_i32$3 = $1093;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $1094 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $1094$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $1086$hi;
     i64toi32_i32$4 = i64toi32_i32$1;
     i64toi32_i32$2 = $1094$hi;
     i64toi32_i32$3 = $1094;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     i64toi32_i32$0 = i64toi32_i32$5;
     i64toi32_i32$4 = 1925078388;
     i64toi32_i32$3 = -226784913;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $15 = i64toi32_i32$2;
     $15$hi = i64toi32_i32$5;
     $1097 = i64toi32_i32$2;
     $1097$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($13 | 0, i64toi32_i32$5 | 0, 36 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $1099 = i64toi32_i32$0;
     $1099$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($13 | 0, i64toi32_i32$5 | 0, 30 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $1101 = i64toi32_i32$0;
     $1101$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $1099$hi;
     i64toi32_i32$1 = $1099;
     i64toi32_i32$0 = $1101$hi;
     i64toi32_i32$3 = $1101;
     i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
     $1102 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $1102$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($13 | 0, i64toi32_i32$0 | 0, 25 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $1104 = i64toi32_i32$1;
     $1104$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $1102$hi;
     i64toi32_i32$5 = $1102;
     i64toi32_i32$1 = $1104$hi;
     i64toi32_i32$3 = $1104;
     i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
     $1105 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $1105$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$0 = $7;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $1109 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $1109$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$1 = $13;
     i64toi32_i32$0 = $1109$hi;
     i64toi32_i32$3 = $1109;
     i64toi32_i32$0 = i64toi32_i32$5 & i64toi32_i32$0 | 0;
     $1110 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $1110$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$5 = $7;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
     $1113 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $1113$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $1110$hi;
     i64toi32_i32$0 = $1110;
     i64toi32_i32$5 = $1113$hi;
     i64toi32_i32$3 = $1113;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $1114 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $1114$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $1105$hi;
     i64toi32_i32$1 = $1105;
     i64toi32_i32$0 = $1114$hi;
     i64toi32_i32$3 = $1114;
     i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $1115$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $93$hi;
     i64toi32_i32$2 = $1115$hi;
     i64toi32_i32$5 = i64toi32_i32$4;
     i64toi32_i32$1 = $93$hi;
     i64toi32_i32$3 = $93;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $6 = i64toi32_i32$0;
     $6$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1097$hi;
     i64toi32_i32$2 = $1097;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$3 = i64toi32_i32$0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $24 = i64toi32_i32$1;
     $24$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $611$hi;
     i64toi32_i32$4 = $611;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$3 = i64toi32_i32$1;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $1121 = i64toi32_i32$5;
     $1121$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $10$hi;
     i64toi32_i32$1 = $19$hi;
     i64toi32_i32$1 = $10$hi;
     i64toi32_i32$0 = $10;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $1124 = i64toi32_i32$2;
     $1124$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $11$hi;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$5 = $11$hi;
     i64toi32_i32$1 = $11;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $1127 = i64toi32_i32$4;
     $1127$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $20$hi;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$2 = $20$hi;
     i64toi32_i32$5 = $20;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $1130$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$2 = $19;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
     $1134 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $1134$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $24$hi;
     i64toi32_i32$4 = $24;
     i64toi32_i32$2 = $1134$hi;
     i64toi32_i32$3 = $1134;
     i64toi32_i32$2 = i64toi32_i32$5 & i64toi32_i32$2 | 0;
     $1135$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$2 = $1135$hi;
     i64toi32_i32$5 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $1137 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $1137$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1130$hi;
     i64toi32_i32$2 = i64toi32_i32$0;
     i64toi32_i32$5 = $1137$hi;
     i64toi32_i32$3 = $1137;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $1138$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($24 | 0, i64toi32_i32$0 | 0, 50 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $1140 = i64toi32_i32$2;
     $1140$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($24 | 0, i64toi32_i32$0 | 0, 46 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $1142 = i64toi32_i32$2;
     $1142$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $1140$hi;
     i64toi32_i32$4 = $1140;
     i64toi32_i32$2 = $1142$hi;
     i64toi32_i32$3 = $1142;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $1143 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $1143$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($24 | 0, i64toi32_i32$2 | 0, 23 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $1145 = i64toi32_i32$4;
     $1145$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1143$hi;
     i64toi32_i32$0 = $1143;
     i64toi32_i32$4 = $1145$hi;
     i64toi32_i32$3 = $1145;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $1146 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $1146$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1138$hi;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$0 = $1146$hi;
     i64toi32_i32$3 = $1146;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     i64toi32_i32$4 = i64toi32_i32$5;
     i64toi32_i32$2 = -2132889090;
     i64toi32_i32$3 = 991336113;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $11 = i64toi32_i32$0;
     $11$hi = i64toi32_i32$5;
     $1149 = i64toi32_i32$0;
     $1149$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($6 | 0, i64toi32_i32$5 | 0, 36 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $1151 = i64toi32_i32$4;
     $1151$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($6 | 0, i64toi32_i32$5 | 0, 30 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $1153 = i64toi32_i32$4;
     $1153$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $1151$hi;
     i64toi32_i32$1 = $1151;
     i64toi32_i32$4 = $1153$hi;
     i64toi32_i32$3 = $1153;
     i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
     $1154 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $1154$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($6 | 0, i64toi32_i32$4 | 0, 25 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $1156 = i64toi32_i32$1;
     $1156$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1154$hi;
     i64toi32_i32$5 = $1154;
     i64toi32_i32$1 = $1156$hi;
     i64toi32_i32$3 = $1156;
     i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
     $1157 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $1157$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$4 = $13;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $1161 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $1161$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$1 = $6;
     i64toi32_i32$4 = $1161$hi;
     i64toi32_i32$3 = $1161;
     i64toi32_i32$4 = i64toi32_i32$5 & i64toi32_i32$4 | 0;
     $1162 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $1162$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$5 = $13;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$1 = i64toi32_i32$4 & i64toi32_i32$1 | 0;
     $1165 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $1165$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $1162$hi;
     i64toi32_i32$4 = $1162;
     i64toi32_i32$5 = $1165$hi;
     i64toi32_i32$3 = $1165;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $1166 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $1166$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $1157$hi;
     i64toi32_i32$1 = $1157;
     i64toi32_i32$4 = $1166$hi;
     i64toi32_i32$3 = $1166;
     i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $1167$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $8$hi;
     i64toi32_i32$0 = $1167$hi;
     i64toi32_i32$5 = i64toi32_i32$2;
     i64toi32_i32$1 = $8$hi;
     i64toi32_i32$3 = $8;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $7 = i64toi32_i32$4;
     $7$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1149$hi;
     i64toi32_i32$0 = $1149;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$3 = i64toi32_i32$4;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $12 = i64toi32_i32$1;
     $12$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$2 = $24;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $1175 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $1175$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$4 = i64toi32_i32$1;
     i64toi32_i32$2 = $1175$hi;
     i64toi32_i32$3 = $1175;
     i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
     $1176$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$2 = $1176$hi;
     i64toi32_i32$0 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $1178 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $1178$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1127$hi;
     i64toi32_i32$2 = $1127;
     i64toi32_i32$0 = $1178$hi;
     i64toi32_i32$3 = $1178;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $1179$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($12 | 0, i64toi32_i32$1 | 0, 50 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $1181 = i64toi32_i32$2;
     $1181$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($12 | 0, i64toi32_i32$1 | 0, 46 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $1183 = i64toi32_i32$2;
     $1183$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $1181$hi;
     i64toi32_i32$4 = $1181;
     i64toi32_i32$2 = $1183$hi;
     i64toi32_i32$3 = $1183;
     i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
     $1184 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $1184$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($12 | 0, i64toi32_i32$2 | 0, 23 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $1186 = i64toi32_i32$4;
     $1186$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1184$hi;
     i64toi32_i32$1 = $1184;
     i64toi32_i32$4 = $1186$hi;
     i64toi32_i32$3 = $1186;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $1187 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $1187$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1179$hi;
     i64toi32_i32$2 = i64toi32_i32$5;
     i64toi32_i32$1 = $1187$hi;
     i64toi32_i32$3 = $1187;
     i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     i64toi32_i32$4 = i64toi32_i32$0;
     i64toi32_i32$2 = -1680079193;
     i64toi32_i32$3 = 633803317;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $17 = i64toi32_i32$1;
     $17$hi = i64toi32_i32$0;
     $1190 = i64toi32_i32$1;
     $1190$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 36 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $1192 = i64toi32_i32$4;
     $1192$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 30 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $1194 = i64toi32_i32$4;
     $1194$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $1192$hi;
     i64toi32_i32$5 = $1192;
     i64toi32_i32$4 = $1194$hi;
     i64toi32_i32$3 = $1194;
     i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
     $1195 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $1195$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$5 = 0;
     i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 25 | 0, i64toi32_i32$5 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $1197 = i64toi32_i32$5;
     $1197$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1195$hi;
     i64toi32_i32$0 = $1195;
     i64toi32_i32$5 = $1197$hi;
     i64toi32_i32$3 = $1197;
     i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
     $1198 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $1198$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$4 = $6;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
     $1202 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $1202$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$5 = $7;
     i64toi32_i32$4 = $1202$hi;
     i64toi32_i32$3 = $1202;
     i64toi32_i32$4 = i64toi32_i32$0 & i64toi32_i32$4 | 0;
     $1203 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $1203$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$0 = $6;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$5 = i64toi32_i32$4 & i64toi32_i32$5 | 0;
     $1206 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
     $1206$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $1203$hi;
     i64toi32_i32$4 = $1203;
     i64toi32_i32$0 = $1206$hi;
     i64toi32_i32$3 = $1206;
     i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
     $1207 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $1207$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $1198$hi;
     i64toi32_i32$5 = $1198;
     i64toi32_i32$4 = $1207$hi;
     i64toi32_i32$3 = $1207;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $1208$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $14$hi;
     i64toi32_i32$1 = $1208$hi;
     i64toi32_i32$0 = i64toi32_i32$2;
     i64toi32_i32$5 = $14$hi;
     i64toi32_i32$3 = $14;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $13 = i64toi32_i32$4;
     $13$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1190$hi;
     i64toi32_i32$1 = $1190;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$3 = i64toi32_i32$4;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $89 = i64toi32_i32$5;
     $89$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$2 = $12;
     i64toi32_i32$1 = $24$hi;
     i64toi32_i32$3 = $24;
     i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
     $1216 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $1216$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $89$hi;
     i64toi32_i32$4 = i64toi32_i32$5;
     i64toi32_i32$2 = $1216$hi;
     i64toi32_i32$3 = $1216;
     i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
     $1217$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$2 = $1217$hi;
     i64toi32_i32$1 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$3 = $24;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $1219 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $1219$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1124$hi;
     i64toi32_i32$2 = $1124;
     i64toi32_i32$1 = $1219$hi;
     i64toi32_i32$3 = $1219;
     i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $1220$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($89 | 0, i64toi32_i32$5 | 0, 50 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $1222 = i64toi32_i32$2;
     $1222$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($89 | 0, i64toi32_i32$5 | 0, 46 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $1224 = i64toi32_i32$2;
     $1224$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $1222$hi;
     i64toi32_i32$4 = $1222;
     i64toi32_i32$2 = $1224$hi;
     i64toi32_i32$3 = $1224;
     i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
     $1225 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $1225$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($89 | 0, i64toi32_i32$2 | 0, 23 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $1227 = i64toi32_i32$4;
     $1227$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1225$hi;
     i64toi32_i32$5 = $1225;
     i64toi32_i32$4 = $1227$hi;
     i64toi32_i32$3 = $1227;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $1228 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $1228$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1220$hi;
     i64toi32_i32$2 = i64toi32_i32$0;
     i64toi32_i32$5 = $1228$hi;
     i64toi32_i32$3 = $1228;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     i64toi32_i32$4 = i64toi32_i32$1;
     i64toi32_i32$2 = -1046744716;
     i64toi32_i32$3 = -815192428;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $8 = i64toi32_i32$5;
     $8$hi = i64toi32_i32$1;
     $1231 = i64toi32_i32$5;
     $1231$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($13 | 0, i64toi32_i32$1 | 0, 36 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $1233 = i64toi32_i32$4;
     $1233$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($13 | 0, i64toi32_i32$1 | 0, 30 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $1235 = i64toi32_i32$4;
     $1235$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $1233$hi;
     i64toi32_i32$0 = $1233;
     i64toi32_i32$4 = $1235$hi;
     i64toi32_i32$3 = $1235;
     i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
     $1236 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $1236$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($13 | 0, i64toi32_i32$4 | 0, 25 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $1238 = i64toi32_i32$0;
     $1238$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1236$hi;
     i64toi32_i32$1 = $1236;
     i64toi32_i32$0 = $1238$hi;
     i64toi32_i32$3 = $1238;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $1239 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $1239$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$4 = $7;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
     $1243 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $1243$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$0 = $13;
     i64toi32_i32$4 = $1243$hi;
     i64toi32_i32$3 = $1243;
     i64toi32_i32$4 = i64toi32_i32$1 & i64toi32_i32$4 | 0;
     $1244 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
     $1244$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$1 = $7;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$0 = i64toi32_i32$4 & i64toi32_i32$0 | 0;
     $1247 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $1247$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $1244$hi;
     i64toi32_i32$4 = $1244;
     i64toi32_i32$1 = $1247$hi;
     i64toi32_i32$3 = $1247;
     i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
     $1248 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $1248$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $1239$hi;
     i64toi32_i32$0 = $1239;
     i64toi32_i32$4 = $1248$hi;
     i64toi32_i32$3 = $1248;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $1249$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $9$hi;
     i64toi32_i32$5 = $1249$hi;
     i64toi32_i32$1 = i64toi32_i32$2;
     i64toi32_i32$0 = $9$hi;
     i64toi32_i32$3 = $9;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $6 = i64toi32_i32$4;
     $6$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1231$hi;
     i64toi32_i32$5 = $1231;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$3 = i64toi32_i32$4;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $19 = i64toi32_i32$0;
     $19$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$2 = $89;
     i64toi32_i32$5 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
     $1257 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $1257$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $19$hi;
     i64toi32_i32$4 = i64toi32_i32$0;
     i64toi32_i32$2 = $1257$hi;
     i64toi32_i32$3 = $1257;
     i64toi32_i32$2 = i64toi32_i32$5 & i64toi32_i32$2 | 0;
     $1258$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$2 = $1258$hi;
     i64toi32_i32$5 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $1260 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $1260$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1121$hi;
     i64toi32_i32$2 = $1121;
     i64toi32_i32$5 = $1260$hi;
     i64toi32_i32$3 = $1260;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $1261$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($19 | 0, i64toi32_i32$0 | 0, 50 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $1263 = i64toi32_i32$2;
     $1263$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($19 | 0, i64toi32_i32$0 | 0, 46 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $1265 = i64toi32_i32$2;
     $1265$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $1263$hi;
     i64toi32_i32$4 = $1263;
     i64toi32_i32$2 = $1265$hi;
     i64toi32_i32$3 = $1265;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $1266 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $1266$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($19 | 0, i64toi32_i32$2 | 0, 23 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $1268 = i64toi32_i32$4;
     $1268$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1266$hi;
     i64toi32_i32$0 = $1266;
     i64toi32_i32$4 = $1268$hi;
     i64toi32_i32$3 = $1268;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $1269 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $1269$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1261$hi;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$0 = $1269$hi;
     i64toi32_i32$3 = $1269;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     i64toi32_i32$4 = i64toi32_i32$5;
     i64toi32_i32$2 = -459576895;
     i64toi32_i32$3 = -1628353838;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $10 = i64toi32_i32$0;
     $10$hi = i64toi32_i32$5;
     $1272 = i64toi32_i32$0;
     $1272$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($6 | 0, i64toi32_i32$5 | 0, 36 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $1274 = i64toi32_i32$4;
     $1274$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($6 | 0, i64toi32_i32$5 | 0, 30 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $1276 = i64toi32_i32$4;
     $1276$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $1274$hi;
     i64toi32_i32$1 = $1274;
     i64toi32_i32$4 = $1276$hi;
     i64toi32_i32$3 = $1276;
     i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
     $1277 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $1277$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($6 | 0, i64toi32_i32$4 | 0, 25 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $1279 = i64toi32_i32$1;
     $1279$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1277$hi;
     i64toi32_i32$5 = $1277;
     i64toi32_i32$1 = $1279$hi;
     i64toi32_i32$3 = $1279;
     i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
     $1280 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $1280$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$4 = $13;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $1284 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $1284$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$1 = $6;
     i64toi32_i32$4 = $1284$hi;
     i64toi32_i32$3 = $1284;
     i64toi32_i32$4 = i64toi32_i32$5 & i64toi32_i32$4 | 0;
     $1285 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $1285$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$5 = $13;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$1 = i64toi32_i32$4 & i64toi32_i32$1 | 0;
     $1288 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $1288$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $1285$hi;
     i64toi32_i32$4 = $1285;
     i64toi32_i32$5 = $1288$hi;
     i64toi32_i32$3 = $1288;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $1289 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $1289$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $1280$hi;
     i64toi32_i32$1 = $1280;
     i64toi32_i32$4 = $1289$hi;
     i64toi32_i32$3 = $1289;
     i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $1290$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $15$hi;
     i64toi32_i32$0 = $1290$hi;
     i64toi32_i32$5 = i64toi32_i32$2;
     i64toi32_i32$1 = $15$hi;
     i64toi32_i32$3 = $15;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $7 = i64toi32_i32$4;
     $7$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1272$hi;
     i64toi32_i32$0 = $1272;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$3 = i64toi32_i32$4;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $24 = i64toi32_i32$1;
     $24$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $610$hi;
     i64toi32_i32$2 = $610;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$3 = i64toi32_i32$1;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $1296 = i64toi32_i32$5;
     $1296$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $21$hi;
     i64toi32_i32$1 = $19$hi;
     i64toi32_i32$1 = $21$hi;
     i64toi32_i32$4 = $21;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $1299 = i64toi32_i32$0;
     $1299$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $22$hi;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$5 = $22$hi;
     i64toi32_i32$1 = $22;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $1302 = i64toi32_i32$2;
     $1302$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $16$hi;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$0 = $16$hi;
     i64toi32_i32$5 = $16;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $1305$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$0 = $19;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
     $1309 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $1309$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $24$hi;
     i64toi32_i32$2 = $24;
     i64toi32_i32$0 = $1309$hi;
     i64toi32_i32$3 = $1309;
     i64toi32_i32$0 = i64toi32_i32$5 & i64toi32_i32$0 | 0;
     $1310$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$0 = $1310$hi;
     i64toi32_i32$5 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $1312 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $1312$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1305$hi;
     i64toi32_i32$0 = i64toi32_i32$4;
     i64toi32_i32$5 = $1312$hi;
     i64toi32_i32$3 = $1312;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $1313$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($24 | 0, i64toi32_i32$4 | 0, 50 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $1315 = i64toi32_i32$0;
     $1315$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($24 | 0, i64toi32_i32$4 | 0, 46 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $1317 = i64toi32_i32$0;
     $1317$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1315$hi;
     i64toi32_i32$2 = $1315;
     i64toi32_i32$0 = $1317$hi;
     i64toi32_i32$3 = $1317;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $1318 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $1318$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($24 | 0, i64toi32_i32$0 | 0, 23 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $1320 = i64toi32_i32$2;
     $1320$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $1318$hi;
     i64toi32_i32$4 = $1318;
     i64toi32_i32$2 = $1320$hi;
     i64toi32_i32$3 = $1320;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $1321 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $1321$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1313$hi;
     i64toi32_i32$0 = i64toi32_i32$1;
     i64toi32_i32$4 = $1321$hi;
     i64toi32_i32$3 = $1321;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     i64toi32_i32$2 = i64toi32_i32$5;
     i64toi32_i32$0 = -272742522;
     i64toi32_i32$3 = 944711139;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $22 = i64toi32_i32$4;
     $22$hi = i64toi32_i32$5;
     $1324 = i64toi32_i32$4;
     $1324$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 36 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $1326 = i64toi32_i32$2;
     $1326$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 30 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $1328 = i64toi32_i32$2;
     $1328$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $1326$hi;
     i64toi32_i32$1 = $1326;
     i64toi32_i32$2 = $1328$hi;
     i64toi32_i32$3 = $1328;
     i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
     $1329 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $1329$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($7 | 0, i64toi32_i32$2 | 0, 25 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $1331 = i64toi32_i32$1;
     $1331$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1329$hi;
     i64toi32_i32$5 = $1329;
     i64toi32_i32$1 = $1331$hi;
     i64toi32_i32$3 = $1331;
     i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
     $1332 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $1332$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$2 = $6;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $1336 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $1336$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$1 = $7;
     i64toi32_i32$2 = $1336$hi;
     i64toi32_i32$3 = $1336;
     i64toi32_i32$2 = i64toi32_i32$5 & i64toi32_i32$2 | 0;
     $1337 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $1337$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$5 = $6;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
     $1340 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $1340$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $1337$hi;
     i64toi32_i32$2 = $1337;
     i64toi32_i32$5 = $1340$hi;
     i64toi32_i32$3 = $1340;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $1341 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $1341$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $1332$hi;
     i64toi32_i32$1 = $1332;
     i64toi32_i32$2 = $1341$hi;
     i64toi32_i32$3 = $1341;
     i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $1342$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $11$hi;
     i64toi32_i32$4 = $1342$hi;
     i64toi32_i32$5 = i64toi32_i32$0;
     i64toi32_i32$1 = $11$hi;
     i64toi32_i32$3 = $11;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $13 = i64toi32_i32$2;
     $13$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $1324$hi;
     i64toi32_i32$4 = $1324;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$3 = i64toi32_i32$2;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $12 = i64toi32_i32$1;
     $12$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$0 = $24;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $1350 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $1350$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$0 = $1350$hi;
     i64toi32_i32$3 = $1350;
     i64toi32_i32$0 = i64toi32_i32$4 & i64toi32_i32$0 | 0;
     $1351$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$0 = $1351$hi;
     i64toi32_i32$4 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $1353 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $1353$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1302$hi;
     i64toi32_i32$0 = $1302;
     i64toi32_i32$4 = $1353$hi;
     i64toi32_i32$3 = $1353;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $1354$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($12 | 0, i64toi32_i32$1 | 0, 50 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $1356 = i64toi32_i32$0;
     $1356$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($12 | 0, i64toi32_i32$1 | 0, 46 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $1358 = i64toi32_i32$0;
     $1358$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $1356$hi;
     i64toi32_i32$2 = $1356;
     i64toi32_i32$0 = $1358$hi;
     i64toi32_i32$3 = $1358;
     i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
     $1359 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $1359$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($12 | 0, i64toi32_i32$0 | 0, 23 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $1361 = i64toi32_i32$2;
     $1361$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $1359$hi;
     i64toi32_i32$1 = $1359;
     i64toi32_i32$2 = $1361$hi;
     i64toi32_i32$3 = $1361;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $1362 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $1362$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1354$hi;
     i64toi32_i32$0 = i64toi32_i32$5;
     i64toi32_i32$1 = $1362$hi;
     i64toi32_i32$3 = $1362;
     i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     i64toi32_i32$2 = i64toi32_i32$4;
     i64toi32_i32$0 = 264347078;
     i64toi32_i32$3 = -1953704523;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $11 = i64toi32_i32$1;
     $11$hi = i64toi32_i32$4;
     $1365 = i64toi32_i32$1;
     $1365$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($13 | 0, i64toi32_i32$4 | 0, 36 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $1367 = i64toi32_i32$2;
     $1367$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($13 | 0, i64toi32_i32$4 | 0, 30 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $1369 = i64toi32_i32$2;
     $1369$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1367$hi;
     i64toi32_i32$5 = $1367;
     i64toi32_i32$2 = $1369$hi;
     i64toi32_i32$3 = $1369;
     i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
     $1370 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $1370$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$5 = 0;
     i64toi32_i32$5 = __wasm_rotl_i64($13 | 0, i64toi32_i32$2 | 0, 25 | 0, i64toi32_i32$5 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $1372 = i64toi32_i32$5;
     $1372$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1370$hi;
     i64toi32_i32$4 = $1370;
     i64toi32_i32$5 = $1372$hi;
     i64toi32_i32$3 = $1372;
     i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
     $1373 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $1373$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$2 = $7;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
     $1377 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $1377$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$5 = $13;
     i64toi32_i32$2 = $1377$hi;
     i64toi32_i32$3 = $1377;
     i64toi32_i32$2 = i64toi32_i32$4 & i64toi32_i32$2 | 0;
     $1378 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $1378$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$4 = $7;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$5 = i64toi32_i32$2 & i64toi32_i32$5 | 0;
     $1381 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     $1381$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $1378$hi;
     i64toi32_i32$2 = $1378;
     i64toi32_i32$4 = $1381$hi;
     i64toi32_i32$3 = $1381;
     i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
     $1382 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $1382$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1373$hi;
     i64toi32_i32$5 = $1373;
     i64toi32_i32$2 = $1382$hi;
     i64toi32_i32$3 = $1382;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $1383$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $17$hi;
     i64toi32_i32$1 = $1383$hi;
     i64toi32_i32$4 = i64toi32_i32$0;
     i64toi32_i32$5 = $17$hi;
     i64toi32_i32$3 = $17;
     i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $6 = i64toi32_i32$2;
     $6$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $1365$hi;
     i64toi32_i32$1 = $1365;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$3 = i64toi32_i32$2;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $89 = i64toi32_i32$5;
     $89$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$0 = $12;
     i64toi32_i32$1 = $24$hi;
     i64toi32_i32$3 = $24;
     i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
     $1391 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $1391$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $89$hi;
     i64toi32_i32$2 = i64toi32_i32$5;
     i64toi32_i32$0 = $1391$hi;
     i64toi32_i32$3 = $1391;
     i64toi32_i32$0 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
     $1392$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$0 = $1392$hi;
     i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$3 = $24;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $1394 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $1394$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1299$hi;
     i64toi32_i32$0 = $1299;
     i64toi32_i32$1 = $1394$hi;
     i64toi32_i32$3 = $1394;
     i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $1395$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($89 | 0, i64toi32_i32$5 | 0, 50 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $1397 = i64toi32_i32$0;
     $1397$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($89 | 0, i64toi32_i32$5 | 0, 46 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $1399 = i64toi32_i32$0;
     $1399$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $1397$hi;
     i64toi32_i32$2 = $1397;
     i64toi32_i32$0 = $1399$hi;
     i64toi32_i32$3 = $1399;
     i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
     $1400 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $1400$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($89 | 0, i64toi32_i32$0 | 0, 23 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $1402 = i64toi32_i32$2;
     $1402$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $1400$hi;
     i64toi32_i32$5 = $1400;
     i64toi32_i32$2 = $1402$hi;
     i64toi32_i32$3 = $1402;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $1403 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $1403$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1395$hi;
     i64toi32_i32$0 = i64toi32_i32$4;
     i64toi32_i32$5 = $1403$hi;
     i64toi32_i32$3 = $1403;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$0 = 604807628;
     i64toi32_i32$3 = 2007800933;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $17 = i64toi32_i32$5;
     $17$hi = i64toi32_i32$1;
     $1406 = i64toi32_i32$5;
     $1406$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($6 | 0, i64toi32_i32$1 | 0, 36 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $1408 = i64toi32_i32$2;
     $1408$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($6 | 0, i64toi32_i32$1 | 0, 30 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $1410 = i64toi32_i32$2;
     $1410$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $1408$hi;
     i64toi32_i32$4 = $1408;
     i64toi32_i32$2 = $1410$hi;
     i64toi32_i32$3 = $1410;
     i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
     $1411 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $1411$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($6 | 0, i64toi32_i32$2 | 0, 25 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $1413 = i64toi32_i32$4;
     $1413$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1411$hi;
     i64toi32_i32$1 = $1411;
     i64toi32_i32$4 = $1413$hi;
     i64toi32_i32$3 = $1413;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $1414 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $1414$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$2 = $13;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
     $1418 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $1418$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$4 = $6;
     i64toi32_i32$2 = $1418$hi;
     i64toi32_i32$3 = $1418;
     i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
     $1419 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     $1419$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$1 = $13;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$4 = i64toi32_i32$2 & i64toi32_i32$4 | 0;
     $1422 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $1422$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1419$hi;
     i64toi32_i32$2 = $1419;
     i64toi32_i32$1 = $1422$hi;
     i64toi32_i32$3 = $1422;
     i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
     $1423 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $1423$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $1414$hi;
     i64toi32_i32$4 = $1414;
     i64toi32_i32$2 = $1423$hi;
     i64toi32_i32$3 = $1423;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $1424$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $8$hi;
     i64toi32_i32$5 = $1424$hi;
     i64toi32_i32$1 = i64toi32_i32$0;
     i64toi32_i32$4 = $8$hi;
     i64toi32_i32$3 = $8;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $7 = i64toi32_i32$2;
     $7$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $1406$hi;
     i64toi32_i32$5 = $1406;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$3 = i64toi32_i32$2;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $19 = i64toi32_i32$4;
     $19$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$0 = $89;
     i64toi32_i32$5 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
     $1432 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $1432$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $19$hi;
     i64toi32_i32$2 = i64toi32_i32$4;
     i64toi32_i32$0 = $1432$hi;
     i64toi32_i32$3 = $1432;
     i64toi32_i32$0 = i64toi32_i32$5 & i64toi32_i32$0 | 0;
     $1433$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$0 = $1433$hi;
     i64toi32_i32$5 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $1435 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $1435$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1296$hi;
     i64toi32_i32$0 = $1296;
     i64toi32_i32$5 = $1435$hi;
     i64toi32_i32$3 = $1435;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $1436$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($19 | 0, i64toi32_i32$4 | 0, 50 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $1438 = i64toi32_i32$0;
     $1438$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($19 | 0, i64toi32_i32$4 | 0, 46 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $1440 = i64toi32_i32$0;
     $1440$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1438$hi;
     i64toi32_i32$2 = $1438;
     i64toi32_i32$0 = $1440$hi;
     i64toi32_i32$3 = $1440;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $1441 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $1441$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($19 | 0, i64toi32_i32$0 | 0, 23 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $1443 = i64toi32_i32$2;
     $1443$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $1441$hi;
     i64toi32_i32$4 = $1441;
     i64toi32_i32$2 = $1443$hi;
     i64toi32_i32$3 = $1443;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $1444 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $1444$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1436$hi;
     i64toi32_i32$0 = i64toi32_i32$1;
     i64toi32_i32$4 = $1444$hi;
     i64toi32_i32$3 = $1444;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     i64toi32_i32$2 = i64toi32_i32$5;
     i64toi32_i32$0 = 770255983;
     i64toi32_i32$3 = 1495990901;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $26 = i64toi32_i32$4;
     $26$hi = i64toi32_i32$5;
     $1447 = i64toi32_i32$4;
     $1447$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 36 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $1449 = i64toi32_i32$2;
     $1449$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 30 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $1451 = i64toi32_i32$2;
     $1451$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $1449$hi;
     i64toi32_i32$1 = $1449;
     i64toi32_i32$2 = $1451$hi;
     i64toi32_i32$3 = $1451;
     i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
     $1452 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $1452$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($7 | 0, i64toi32_i32$2 | 0, 25 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $1454 = i64toi32_i32$1;
     $1454$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1452$hi;
     i64toi32_i32$5 = $1452;
     i64toi32_i32$1 = $1454$hi;
     i64toi32_i32$3 = $1454;
     i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
     $1455 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $1455$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$2 = $6;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $1459 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $1459$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$1 = $7;
     i64toi32_i32$2 = $1459$hi;
     i64toi32_i32$3 = $1459;
     i64toi32_i32$2 = i64toi32_i32$5 & i64toi32_i32$2 | 0;
     $1460 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $1460$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$5 = $6;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
     $1463 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $1463$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $1460$hi;
     i64toi32_i32$2 = $1460;
     i64toi32_i32$5 = $1463$hi;
     i64toi32_i32$3 = $1463;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $1464 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $1464$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $1455$hi;
     i64toi32_i32$1 = $1455;
     i64toi32_i32$2 = $1464$hi;
     i64toi32_i32$3 = $1464;
     i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $1465$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $10$hi;
     i64toi32_i32$4 = $1465$hi;
     i64toi32_i32$5 = i64toi32_i32$0;
     i64toi32_i32$1 = $10$hi;
     i64toi32_i32$3 = $10;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $13 = i64toi32_i32$2;
     $13$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $1447$hi;
     i64toi32_i32$4 = $1447;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$3 = i64toi32_i32$2;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $24 = i64toi32_i32$1;
     $24$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $609$hi;
     i64toi32_i32$0 = $609;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$3 = i64toi32_i32$1;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $1471 = i64toi32_i32$5;
     $1471$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $27$hi;
     i64toi32_i32$1 = $19$hi;
     i64toi32_i32$1 = $27$hi;
     i64toi32_i32$2 = $27;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $1474 = i64toi32_i32$4;
     $1474$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $28$hi;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$5 = $28$hi;
     i64toi32_i32$1 = $28;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $1477 = i64toi32_i32$0;
     $1477$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $25$hi;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$4 = $25$hi;
     i64toi32_i32$5 = $25;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $1480$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$4 = $19;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$5 = i64toi32_i32$0 ^ i64toi32_i32$5 | 0;
     $1484 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $1484$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $24$hi;
     i64toi32_i32$0 = $24;
     i64toi32_i32$4 = $1484$hi;
     i64toi32_i32$3 = $1484;
     i64toi32_i32$4 = i64toi32_i32$5 & i64toi32_i32$4 | 0;
     $1485$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$4 = $1485$hi;
     i64toi32_i32$5 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $1487 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $1487$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $1480$hi;
     i64toi32_i32$4 = i64toi32_i32$2;
     i64toi32_i32$5 = $1487$hi;
     i64toi32_i32$3 = $1487;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $1488$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($24 | 0, i64toi32_i32$2 | 0, 50 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $1490 = i64toi32_i32$4;
     $1490$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($24 | 0, i64toi32_i32$2 | 0, 46 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $1492 = i64toi32_i32$4;
     $1492$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1490$hi;
     i64toi32_i32$0 = $1490;
     i64toi32_i32$4 = $1492$hi;
     i64toi32_i32$3 = $1492;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $1493 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $1493$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($24 | 0, i64toi32_i32$4 | 0, 23 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $1495 = i64toi32_i32$0;
     $1495$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1493$hi;
     i64toi32_i32$2 = $1493;
     i64toi32_i32$0 = $1495$hi;
     i64toi32_i32$3 = $1495;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $1496 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $1496$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $1488$hi;
     i64toi32_i32$4 = i64toi32_i32$1;
     i64toi32_i32$2 = $1496$hi;
     i64toi32_i32$3 = $1496;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     i64toi32_i32$0 = i64toi32_i32$5;
     i64toi32_i32$4 = 1249150122;
     i64toi32_i32$3 = 1856431235;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $28 = i64toi32_i32$2;
     $28$hi = i64toi32_i32$5;
     $1499 = i64toi32_i32$2;
     $1499$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($13 | 0, i64toi32_i32$5 | 0, 36 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $1501 = i64toi32_i32$0;
     $1501$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($13 | 0, i64toi32_i32$5 | 0, 30 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $1503 = i64toi32_i32$0;
     $1503$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $1501$hi;
     i64toi32_i32$1 = $1501;
     i64toi32_i32$0 = $1503$hi;
     i64toi32_i32$3 = $1503;
     i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
     $1504 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $1504$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($13 | 0, i64toi32_i32$0 | 0, 25 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $1506 = i64toi32_i32$1;
     $1506$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $1504$hi;
     i64toi32_i32$5 = $1504;
     i64toi32_i32$1 = $1506$hi;
     i64toi32_i32$3 = $1506;
     i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
     $1507 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $1507$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$0 = $7;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $1511 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $1511$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$1 = $13;
     i64toi32_i32$0 = $1511$hi;
     i64toi32_i32$3 = $1511;
     i64toi32_i32$0 = i64toi32_i32$5 & i64toi32_i32$0 | 0;
     $1512 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $1512$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$5 = $7;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
     $1515 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $1515$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $1512$hi;
     i64toi32_i32$0 = $1512;
     i64toi32_i32$5 = $1515$hi;
     i64toi32_i32$3 = $1515;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $1516 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $1516$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $1507$hi;
     i64toi32_i32$1 = $1507;
     i64toi32_i32$0 = $1516$hi;
     i64toi32_i32$3 = $1516;
     i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $1517$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $22$hi;
     i64toi32_i32$2 = $1517$hi;
     i64toi32_i32$5 = i64toi32_i32$4;
     i64toi32_i32$1 = $22$hi;
     i64toi32_i32$3 = $22;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $6 = i64toi32_i32$0;
     $6$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1499$hi;
     i64toi32_i32$2 = $1499;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$3 = i64toi32_i32$0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $12 = i64toi32_i32$1;
     $12$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$4 = $24;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $1525 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $1525$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$0 = i64toi32_i32$1;
     i64toi32_i32$4 = $1525$hi;
     i64toi32_i32$3 = $1525;
     i64toi32_i32$4 = i64toi32_i32$2 & i64toi32_i32$4 | 0;
     $1526$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$4 = $1526$hi;
     i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $1528 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $1528$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $1477$hi;
     i64toi32_i32$4 = $1477;
     i64toi32_i32$2 = $1528$hi;
     i64toi32_i32$3 = $1528;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $1529$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($12 | 0, i64toi32_i32$1 | 0, 50 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $1531 = i64toi32_i32$4;
     $1531$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($12 | 0, i64toi32_i32$1 | 0, 46 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $1533 = i64toi32_i32$4;
     $1533$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $1531$hi;
     i64toi32_i32$0 = $1531;
     i64toi32_i32$4 = $1533$hi;
     i64toi32_i32$3 = $1533;
     i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
     $1534 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $1534$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($12 | 0, i64toi32_i32$4 | 0, 23 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $1536 = i64toi32_i32$0;
     $1536$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1534$hi;
     i64toi32_i32$1 = $1534;
     i64toi32_i32$0 = $1536$hi;
     i64toi32_i32$3 = $1536;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $1537 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $1537$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $1529$hi;
     i64toi32_i32$4 = i64toi32_i32$5;
     i64toi32_i32$1 = $1537$hi;
     i64toi32_i32$3 = $1537;
     i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     i64toi32_i32$0 = i64toi32_i32$2;
     i64toi32_i32$4 = 1555081692;
     i64toi32_i32$3 = -1119749164;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $22 = i64toi32_i32$1;
     $22$hi = i64toi32_i32$2;
     $1540 = i64toi32_i32$1;
     $1540$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($6 | 0, i64toi32_i32$2 | 0, 36 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $1542 = i64toi32_i32$0;
     $1542$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($6 | 0, i64toi32_i32$2 | 0, 30 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $1544 = i64toi32_i32$0;
     $1544$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1542$hi;
     i64toi32_i32$5 = $1542;
     i64toi32_i32$0 = $1544$hi;
     i64toi32_i32$3 = $1544;
     i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
     $1545 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $1545$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$5 = 0;
     i64toi32_i32$5 = __wasm_rotl_i64($6 | 0, i64toi32_i32$0 | 0, 25 | 0, i64toi32_i32$5 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $1547 = i64toi32_i32$5;
     $1547$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $1545$hi;
     i64toi32_i32$2 = $1545;
     i64toi32_i32$5 = $1547$hi;
     i64toi32_i32$3 = $1547;
     i64toi32_i32$5 = i64toi32_i32$0 ^ i64toi32_i32$5 | 0;
     $1548 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $1548$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$0 = $13;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
     $1552 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $1552$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$5 = $6;
     i64toi32_i32$0 = $1552$hi;
     i64toi32_i32$3 = $1552;
     i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
     $1553 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $1553$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$2 = $13;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$5 = i64toi32_i32$0 & i64toi32_i32$5 | 0;
     $1556 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     $1556$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $1553$hi;
     i64toi32_i32$0 = $1553;
     i64toi32_i32$2 = $1556$hi;
     i64toi32_i32$3 = $1556;
     i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
     $1557 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $1557$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1548$hi;
     i64toi32_i32$5 = $1548;
     i64toi32_i32$0 = $1557$hi;
     i64toi32_i32$3 = $1557;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $1558$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $11$hi;
     i64toi32_i32$1 = $1558$hi;
     i64toi32_i32$2 = i64toi32_i32$4;
     i64toi32_i32$5 = $11$hi;
     i64toi32_i32$3 = $11;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $7 = i64toi32_i32$0;
     $7$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1540$hi;
     i64toi32_i32$1 = $1540;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$3 = i64toi32_i32$0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $89 = i64toi32_i32$5;
     $89$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$4 = $12;
     i64toi32_i32$1 = $24$hi;
     i64toi32_i32$3 = $24;
     i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
     $1566 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $1566$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $89$hi;
     i64toi32_i32$0 = i64toi32_i32$5;
     i64toi32_i32$4 = $1566$hi;
     i64toi32_i32$3 = $1566;
     i64toi32_i32$4 = i64toi32_i32$1 & i64toi32_i32$4 | 0;
     $1567$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$4 = $1567$hi;
     i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$3 = $24;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $1569 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $1569$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $1474$hi;
     i64toi32_i32$4 = $1474;
     i64toi32_i32$1 = $1569$hi;
     i64toi32_i32$3 = $1569;
     i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $1570$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($89 | 0, i64toi32_i32$5 | 0, 50 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $1572 = i64toi32_i32$4;
     $1572$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($89 | 0, i64toi32_i32$5 | 0, 46 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $1574 = i64toi32_i32$4;
     $1574$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $1572$hi;
     i64toi32_i32$0 = $1572;
     i64toi32_i32$4 = $1574$hi;
     i64toi32_i32$3 = $1574;
     i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
     $1575 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $1575$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($89 | 0, i64toi32_i32$4 | 0, 23 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $1577 = i64toi32_i32$0;
     $1577$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1575$hi;
     i64toi32_i32$5 = $1575;
     i64toi32_i32$0 = $1577$hi;
     i64toi32_i32$3 = $1577;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $1578 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $1578$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $1570$hi;
     i64toi32_i32$4 = i64toi32_i32$2;
     i64toi32_i32$5 = $1578$hi;
     i64toi32_i32$3 = $1578;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     i64toi32_i32$0 = i64toi32_i32$1;
     i64toi32_i32$4 = 1996064986;
     i64toi32_i32$3 = -2096016459;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $11 = i64toi32_i32$5;
     $11$hi = i64toi32_i32$1;
     $1581 = i64toi32_i32$5;
     $1581$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($7 | 0, i64toi32_i32$1 | 0, 36 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $1583 = i64toi32_i32$0;
     $1583$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($7 | 0, i64toi32_i32$1 | 0, 30 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $1585 = i64toi32_i32$0;
     $1585$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $1583$hi;
     i64toi32_i32$2 = $1583;
     i64toi32_i32$0 = $1585$hi;
     i64toi32_i32$3 = $1585;
     i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
     $1586 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $1586$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 25 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $1588 = i64toi32_i32$2;
     $1588$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $1586$hi;
     i64toi32_i32$1 = $1586;
     i64toi32_i32$2 = $1588$hi;
     i64toi32_i32$3 = $1588;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $1589 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $1589$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$0 = $6;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
     $1593 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $1593$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$2 = $7;
     i64toi32_i32$0 = $1593$hi;
     i64toi32_i32$3 = $1593;
     i64toi32_i32$0 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
     $1594 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     $1594$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$1 = $6;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
     $1597 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $1597$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1594$hi;
     i64toi32_i32$0 = $1594;
     i64toi32_i32$1 = $1597$hi;
     i64toi32_i32$3 = $1597;
     i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
     $1598 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $1598$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $1589$hi;
     i64toi32_i32$2 = $1589;
     i64toi32_i32$0 = $1598$hi;
     i64toi32_i32$3 = $1598;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $1599$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $17$hi;
     i64toi32_i32$5 = $1599$hi;
     i64toi32_i32$1 = i64toi32_i32$4;
     i64toi32_i32$2 = $17$hi;
     i64toi32_i32$3 = $17;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $13 = i64toi32_i32$0;
     $13$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1581$hi;
     i64toi32_i32$5 = $1581;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$3 = i64toi32_i32$0;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $19 = i64toi32_i32$2;
     $19$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$4 = $89;
     i64toi32_i32$5 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$5 = i64toi32_i32$0 ^ i64toi32_i32$5 | 0;
     $1607 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $1607$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $19$hi;
     i64toi32_i32$0 = i64toi32_i32$2;
     i64toi32_i32$4 = $1607$hi;
     i64toi32_i32$3 = $1607;
     i64toi32_i32$4 = i64toi32_i32$5 & i64toi32_i32$4 | 0;
     $1608$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$4 = $1608$hi;
     i64toi32_i32$5 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $1610 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $1610$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $1471$hi;
     i64toi32_i32$4 = $1471;
     i64toi32_i32$5 = $1610$hi;
     i64toi32_i32$3 = $1610;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $1611$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($19 | 0, i64toi32_i32$2 | 0, 50 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $1613 = i64toi32_i32$4;
     $1613$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($19 | 0, i64toi32_i32$2 | 0, 46 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $1615 = i64toi32_i32$4;
     $1615$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1613$hi;
     i64toi32_i32$0 = $1613;
     i64toi32_i32$4 = $1615$hi;
     i64toi32_i32$3 = $1615;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $1616 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $1616$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($19 | 0, i64toi32_i32$4 | 0, 23 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $1618 = i64toi32_i32$0;
     $1618$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1616$hi;
     i64toi32_i32$2 = $1616;
     i64toi32_i32$0 = $1618$hi;
     i64toi32_i32$3 = $1618;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $1619 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $1619$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $1611$hi;
     i64toi32_i32$4 = i64toi32_i32$1;
     i64toi32_i32$2 = $1619$hi;
     i64toi32_i32$3 = $1619;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     i64toi32_i32$0 = i64toi32_i32$5;
     i64toi32_i32$4 = -1740746414;
     i64toi32_i32$3 = -295247957;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $17 = i64toi32_i32$2;
     $17$hi = i64toi32_i32$5;
     $1622 = i64toi32_i32$2;
     $1622$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($13 | 0, i64toi32_i32$5 | 0, 36 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $1624 = i64toi32_i32$0;
     $1624$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($13 | 0, i64toi32_i32$5 | 0, 30 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $1626 = i64toi32_i32$0;
     $1626$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $1624$hi;
     i64toi32_i32$1 = $1624;
     i64toi32_i32$0 = $1626$hi;
     i64toi32_i32$3 = $1626;
     i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
     $1627 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $1627$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($13 | 0, i64toi32_i32$0 | 0, 25 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $1629 = i64toi32_i32$1;
     $1629$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $1627$hi;
     i64toi32_i32$5 = $1627;
     i64toi32_i32$1 = $1629$hi;
     i64toi32_i32$3 = $1629;
     i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
     $1630 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $1630$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$0 = $7;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $1634 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $1634$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$1 = $13;
     i64toi32_i32$0 = $1634$hi;
     i64toi32_i32$3 = $1634;
     i64toi32_i32$0 = i64toi32_i32$5 & i64toi32_i32$0 | 0;
     $1635 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $1635$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$5 = $7;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
     $1638 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $1638$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $1635$hi;
     i64toi32_i32$0 = $1635;
     i64toi32_i32$5 = $1638$hi;
     i64toi32_i32$3 = $1638;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $1639 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $1639$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $1630$hi;
     i64toi32_i32$1 = $1630;
     i64toi32_i32$0 = $1639$hi;
     i64toi32_i32$3 = $1639;
     i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $1640$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $26$hi;
     i64toi32_i32$2 = $1640$hi;
     i64toi32_i32$5 = i64toi32_i32$4;
     i64toi32_i32$1 = $26$hi;
     i64toi32_i32$3 = $26;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $6 = i64toi32_i32$0;
     $6$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1622$hi;
     i64toi32_i32$2 = $1622;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$3 = i64toi32_i32$0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $24 = i64toi32_i32$1;
     $24$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $608$hi;
     i64toi32_i32$4 = $608;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$3 = i64toi32_i32$1;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $1646 = i64toi32_i32$5;
     $1646$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $31$hi;
     i64toi32_i32$1 = $19$hi;
     i64toi32_i32$1 = $31$hi;
     i64toi32_i32$0 = $31;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $1649 = i64toi32_i32$2;
     $1649$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $32$hi;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$5 = $32$hi;
     i64toi32_i32$1 = $32;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $1652 = i64toi32_i32$4;
     $1652$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $29$hi;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$2 = $29$hi;
     i64toi32_i32$5 = $29;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $1655$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$2 = $19;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
     $1659 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $1659$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $24$hi;
     i64toi32_i32$4 = $24;
     i64toi32_i32$2 = $1659$hi;
     i64toi32_i32$3 = $1659;
     i64toi32_i32$2 = i64toi32_i32$5 & i64toi32_i32$2 | 0;
     $1660$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$2 = $1660$hi;
     i64toi32_i32$5 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $1662 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $1662$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1655$hi;
     i64toi32_i32$2 = i64toi32_i32$0;
     i64toi32_i32$5 = $1662$hi;
     i64toi32_i32$3 = $1662;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $1663$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($24 | 0, i64toi32_i32$0 | 0, 50 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $1665 = i64toi32_i32$2;
     $1665$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($24 | 0, i64toi32_i32$0 | 0, 46 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $1667 = i64toi32_i32$2;
     $1667$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $1665$hi;
     i64toi32_i32$4 = $1665;
     i64toi32_i32$2 = $1667$hi;
     i64toi32_i32$3 = $1667;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $1668 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $1668$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($24 | 0, i64toi32_i32$2 | 0, 23 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $1670 = i64toi32_i32$4;
     $1670$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1668$hi;
     i64toi32_i32$0 = $1668;
     i64toi32_i32$4 = $1670$hi;
     i64toi32_i32$3 = $1670;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $1671 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $1671$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1663$hi;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$0 = $1671$hi;
     i64toi32_i32$3 = $1671;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     i64toi32_i32$4 = i64toi32_i32$5;
     i64toi32_i32$2 = -1473132947;
     i64toi32_i32$3 = 766784016;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $26 = i64toi32_i32$0;
     $26$hi = i64toi32_i32$5;
     $1674 = i64toi32_i32$0;
     $1674$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($6 | 0, i64toi32_i32$5 | 0, 36 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $1676 = i64toi32_i32$4;
     $1676$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($6 | 0, i64toi32_i32$5 | 0, 30 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $1678 = i64toi32_i32$4;
     $1678$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $1676$hi;
     i64toi32_i32$1 = $1676;
     i64toi32_i32$4 = $1678$hi;
     i64toi32_i32$3 = $1678;
     i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
     $1679 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $1679$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($6 | 0, i64toi32_i32$4 | 0, 25 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $1681 = i64toi32_i32$1;
     $1681$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1679$hi;
     i64toi32_i32$5 = $1679;
     i64toi32_i32$1 = $1681$hi;
     i64toi32_i32$3 = $1681;
     i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
     $1682 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $1682$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$4 = $13;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $1686 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $1686$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$1 = $6;
     i64toi32_i32$4 = $1686$hi;
     i64toi32_i32$3 = $1686;
     i64toi32_i32$4 = i64toi32_i32$5 & i64toi32_i32$4 | 0;
     $1687 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $1687$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$5 = $13;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$1 = i64toi32_i32$4 & i64toi32_i32$1 | 0;
     $1690 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $1690$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $1687$hi;
     i64toi32_i32$4 = $1687;
     i64toi32_i32$5 = $1690$hi;
     i64toi32_i32$3 = $1690;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $1691 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $1691$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $1682$hi;
     i64toi32_i32$1 = $1682;
     i64toi32_i32$4 = $1691$hi;
     i64toi32_i32$3 = $1691;
     i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $1692$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $28$hi;
     i64toi32_i32$0 = $1692$hi;
     i64toi32_i32$5 = i64toi32_i32$2;
     i64toi32_i32$1 = $28$hi;
     i64toi32_i32$3 = $28;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $7 = i64toi32_i32$4;
     $7$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1674$hi;
     i64toi32_i32$0 = $1674;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$3 = i64toi32_i32$4;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $12 = i64toi32_i32$1;
     $12$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$2 = $24;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $1700 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $1700$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$4 = i64toi32_i32$1;
     i64toi32_i32$2 = $1700$hi;
     i64toi32_i32$3 = $1700;
     i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
     $1701$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$2 = $1701$hi;
     i64toi32_i32$0 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $1703 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $1703$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1652$hi;
     i64toi32_i32$2 = $1652;
     i64toi32_i32$0 = $1703$hi;
     i64toi32_i32$3 = $1703;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $1704$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($12 | 0, i64toi32_i32$1 | 0, 50 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $1706 = i64toi32_i32$2;
     $1706$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($12 | 0, i64toi32_i32$1 | 0, 46 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $1708 = i64toi32_i32$2;
     $1708$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $1706$hi;
     i64toi32_i32$4 = $1706;
     i64toi32_i32$2 = $1708$hi;
     i64toi32_i32$3 = $1708;
     i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
     $1709 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $1709$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($12 | 0, i64toi32_i32$2 | 0, 23 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $1711 = i64toi32_i32$4;
     $1711$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1709$hi;
     i64toi32_i32$1 = $1709;
     i64toi32_i32$4 = $1711$hi;
     i64toi32_i32$3 = $1711;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $1712 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $1712$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1704$hi;
     i64toi32_i32$2 = i64toi32_i32$5;
     i64toi32_i32$1 = $1712$hi;
     i64toi32_i32$3 = $1712;
     i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     i64toi32_i32$4 = i64toi32_i32$0;
     i64toi32_i32$2 = -1341970488;
     i64toi32_i32$3 = -1728372417;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $28 = i64toi32_i32$1;
     $28$hi = i64toi32_i32$0;
     $1715 = i64toi32_i32$1;
     $1715$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 36 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $1717 = i64toi32_i32$4;
     $1717$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 30 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $1719 = i64toi32_i32$4;
     $1719$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $1717$hi;
     i64toi32_i32$5 = $1717;
     i64toi32_i32$4 = $1719$hi;
     i64toi32_i32$3 = $1719;
     i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
     $1720 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $1720$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$5 = 0;
     i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 25 | 0, i64toi32_i32$5 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $1722 = i64toi32_i32$5;
     $1722$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1720$hi;
     i64toi32_i32$0 = $1720;
     i64toi32_i32$5 = $1722$hi;
     i64toi32_i32$3 = $1722;
     i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
     $1723 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $1723$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$4 = $6;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
     $1727 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $1727$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$5 = $7;
     i64toi32_i32$4 = $1727$hi;
     i64toi32_i32$3 = $1727;
     i64toi32_i32$4 = i64toi32_i32$0 & i64toi32_i32$4 | 0;
     $1728 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $1728$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$0 = $6;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$5 = i64toi32_i32$4 & i64toi32_i32$5 | 0;
     $1731 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
     $1731$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $1728$hi;
     i64toi32_i32$4 = $1728;
     i64toi32_i32$0 = $1731$hi;
     i64toi32_i32$3 = $1731;
     i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
     $1732 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $1732$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $1723$hi;
     i64toi32_i32$5 = $1723;
     i64toi32_i32$4 = $1732$hi;
     i64toi32_i32$3 = $1732;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $1733$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $22$hi;
     i64toi32_i32$1 = $1733$hi;
     i64toi32_i32$0 = i64toi32_i32$2;
     i64toi32_i32$5 = $22$hi;
     i64toi32_i32$3 = $22;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $13 = i64toi32_i32$4;
     $13$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1715$hi;
     i64toi32_i32$1 = $1715;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$3 = i64toi32_i32$4;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $89 = i64toi32_i32$5;
     $89$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$2 = $12;
     i64toi32_i32$1 = $24$hi;
     i64toi32_i32$3 = $24;
     i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
     $1741 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $1741$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $89$hi;
     i64toi32_i32$4 = i64toi32_i32$5;
     i64toi32_i32$2 = $1741$hi;
     i64toi32_i32$3 = $1741;
     i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
     $1742$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$2 = $1742$hi;
     i64toi32_i32$1 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$3 = $24;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $1744 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $1744$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1649$hi;
     i64toi32_i32$2 = $1649;
     i64toi32_i32$1 = $1744$hi;
     i64toi32_i32$3 = $1744;
     i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $1745$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($89 | 0, i64toi32_i32$5 | 0, 50 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $1747 = i64toi32_i32$2;
     $1747$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($89 | 0, i64toi32_i32$5 | 0, 46 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $1749 = i64toi32_i32$2;
     $1749$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $1747$hi;
     i64toi32_i32$4 = $1747;
     i64toi32_i32$2 = $1749$hi;
     i64toi32_i32$3 = $1749;
     i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
     $1750 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $1750$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($89 | 0, i64toi32_i32$2 | 0, 23 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $1752 = i64toi32_i32$4;
     $1752$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1750$hi;
     i64toi32_i32$5 = $1750;
     i64toi32_i32$4 = $1752$hi;
     i64toi32_i32$3 = $1752;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $1753 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $1753$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1745$hi;
     i64toi32_i32$2 = i64toi32_i32$0;
     i64toi32_i32$5 = $1753$hi;
     i64toi32_i32$3 = $1753;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     i64toi32_i32$4 = i64toi32_i32$1;
     i64toi32_i32$2 = -1084653625;
     i64toi32_i32$3 = -1091629340;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $22 = i64toi32_i32$5;
     $22$hi = i64toi32_i32$1;
     $1756 = i64toi32_i32$5;
     $1756$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($13 | 0, i64toi32_i32$1 | 0, 36 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $1758 = i64toi32_i32$4;
     $1758$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($13 | 0, i64toi32_i32$1 | 0, 30 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $1760 = i64toi32_i32$4;
     $1760$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $1758$hi;
     i64toi32_i32$0 = $1758;
     i64toi32_i32$4 = $1760$hi;
     i64toi32_i32$3 = $1760;
     i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
     $1761 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $1761$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($13 | 0, i64toi32_i32$4 | 0, 25 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $1763 = i64toi32_i32$0;
     $1763$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1761$hi;
     i64toi32_i32$1 = $1761;
     i64toi32_i32$0 = $1763$hi;
     i64toi32_i32$3 = $1763;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $1764 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $1764$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$4 = $7;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
     $1768 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $1768$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$0 = $13;
     i64toi32_i32$4 = $1768$hi;
     i64toi32_i32$3 = $1768;
     i64toi32_i32$4 = i64toi32_i32$1 & i64toi32_i32$4 | 0;
     $1769 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
     $1769$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$1 = $7;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$0 = i64toi32_i32$4 & i64toi32_i32$0 | 0;
     $1772 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $1772$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $1769$hi;
     i64toi32_i32$4 = $1769;
     i64toi32_i32$1 = $1772$hi;
     i64toi32_i32$3 = $1772;
     i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
     $1773 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $1773$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $1764$hi;
     i64toi32_i32$0 = $1764;
     i64toi32_i32$4 = $1773$hi;
     i64toi32_i32$3 = $1773;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $1774$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $11$hi;
     i64toi32_i32$5 = $1774$hi;
     i64toi32_i32$1 = i64toi32_i32$2;
     i64toi32_i32$0 = $11$hi;
     i64toi32_i32$3 = $11;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $6 = i64toi32_i32$4;
     $6$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1756$hi;
     i64toi32_i32$5 = $1756;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$3 = i64toi32_i32$4;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $19 = i64toi32_i32$0;
     $19$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$2 = $89;
     i64toi32_i32$5 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
     $1782 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $1782$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $19$hi;
     i64toi32_i32$4 = i64toi32_i32$0;
     i64toi32_i32$2 = $1782$hi;
     i64toi32_i32$3 = $1782;
     i64toi32_i32$2 = i64toi32_i32$5 & i64toi32_i32$2 | 0;
     $1783$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$2 = $1783$hi;
     i64toi32_i32$5 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $1785 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $1785$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1646$hi;
     i64toi32_i32$2 = $1646;
     i64toi32_i32$5 = $1785$hi;
     i64toi32_i32$3 = $1785;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $1786$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($19 | 0, i64toi32_i32$0 | 0, 50 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $1788 = i64toi32_i32$2;
     $1788$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($19 | 0, i64toi32_i32$0 | 0, 46 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $1790 = i64toi32_i32$2;
     $1790$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $1788$hi;
     i64toi32_i32$4 = $1788;
     i64toi32_i32$2 = $1790$hi;
     i64toi32_i32$3 = $1790;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $1791 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $1791$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($19 | 0, i64toi32_i32$2 | 0, 23 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $1793 = i64toi32_i32$4;
     $1793$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1791$hi;
     i64toi32_i32$0 = $1791;
     i64toi32_i32$4 = $1793$hi;
     i64toi32_i32$3 = $1793;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $1794 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $1794$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1786$hi;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$0 = $1794$hi;
     i64toi32_i32$3 = $1794;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     i64toi32_i32$4 = i64toi32_i32$5;
     i64toi32_i32$2 = -958395405;
     i64toi32_i32$3 = 1034457026;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $11 = i64toi32_i32$0;
     $11$hi = i64toi32_i32$5;
     $1797 = i64toi32_i32$0;
     $1797$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($6 | 0, i64toi32_i32$5 | 0, 36 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $1799 = i64toi32_i32$4;
     $1799$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($6 | 0, i64toi32_i32$5 | 0, 30 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $1801 = i64toi32_i32$4;
     $1801$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $1799$hi;
     i64toi32_i32$1 = $1799;
     i64toi32_i32$4 = $1801$hi;
     i64toi32_i32$3 = $1801;
     i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
     $1802 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $1802$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($6 | 0, i64toi32_i32$4 | 0, 25 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $1804 = i64toi32_i32$1;
     $1804$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1802$hi;
     i64toi32_i32$5 = $1802;
     i64toi32_i32$1 = $1804$hi;
     i64toi32_i32$3 = $1804;
     i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
     $1805 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $1805$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$4 = $13;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $1809 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $1809$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$1 = $6;
     i64toi32_i32$4 = $1809$hi;
     i64toi32_i32$3 = $1809;
     i64toi32_i32$4 = i64toi32_i32$5 & i64toi32_i32$4 | 0;
     $1810 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $1810$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$5 = $13;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$1 = i64toi32_i32$4 & i64toi32_i32$1 | 0;
     $1813 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $1813$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $1810$hi;
     i64toi32_i32$4 = $1810;
     i64toi32_i32$5 = $1813$hi;
     i64toi32_i32$3 = $1813;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $1814 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $1814$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $1805$hi;
     i64toi32_i32$1 = $1805;
     i64toi32_i32$4 = $1814$hi;
     i64toi32_i32$3 = $1814;
     i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $1815$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $17$hi;
     i64toi32_i32$0 = $1815$hi;
     i64toi32_i32$5 = i64toi32_i32$2;
     i64toi32_i32$1 = $17$hi;
     i64toi32_i32$3 = $17;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $7 = i64toi32_i32$4;
     $7$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1797$hi;
     i64toi32_i32$0 = $1797;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$3 = i64toi32_i32$4;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $24 = i64toi32_i32$1;
     $24$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $607$hi;
     i64toi32_i32$2 = $607;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$3 = i64toi32_i32$1;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $1821 = i64toi32_i32$5;
     $1821$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $35$hi;
     i64toi32_i32$1 = $19$hi;
     i64toi32_i32$1 = $35$hi;
     i64toi32_i32$4 = $35;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $1824 = i64toi32_i32$0;
     $1824$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $36$hi;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$5 = $36$hi;
     i64toi32_i32$1 = $36;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $1827 = i64toi32_i32$2;
     $1827$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $33$hi;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$0 = $33$hi;
     i64toi32_i32$5 = $33;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $1830$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$0 = $19;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
     $1834 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $1834$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $24$hi;
     i64toi32_i32$2 = $24;
     i64toi32_i32$0 = $1834$hi;
     i64toi32_i32$3 = $1834;
     i64toi32_i32$0 = i64toi32_i32$5 & i64toi32_i32$0 | 0;
     $1835$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$0 = $1835$hi;
     i64toi32_i32$5 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $1837 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $1837$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1830$hi;
     i64toi32_i32$0 = i64toi32_i32$4;
     i64toi32_i32$5 = $1837$hi;
     i64toi32_i32$3 = $1837;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $1838$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($24 | 0, i64toi32_i32$4 | 0, 50 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $1840 = i64toi32_i32$0;
     $1840$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($24 | 0, i64toi32_i32$4 | 0, 46 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $1842 = i64toi32_i32$0;
     $1842$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1840$hi;
     i64toi32_i32$2 = $1840;
     i64toi32_i32$0 = $1842$hi;
     i64toi32_i32$3 = $1842;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $1843 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $1843$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($24 | 0, i64toi32_i32$0 | 0, 23 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $1845 = i64toi32_i32$2;
     $1845$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $1843$hi;
     i64toi32_i32$4 = $1843;
     i64toi32_i32$2 = $1845$hi;
     i64toi32_i32$3 = $1845;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $1846 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $1846$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1838$hi;
     i64toi32_i32$0 = i64toi32_i32$1;
     i64toi32_i32$4 = $1846$hi;
     i64toi32_i32$3 = $1846;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     i64toi32_i32$2 = i64toi32_i32$5;
     i64toi32_i32$0 = -710438585;
     i64toi32_i32$3 = -1828018395;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $17 = i64toi32_i32$4;
     $17$hi = i64toi32_i32$5;
     $1849 = i64toi32_i32$4;
     $1849$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 36 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $1851 = i64toi32_i32$2;
     $1851$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 30 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $1853 = i64toi32_i32$2;
     $1853$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $1851$hi;
     i64toi32_i32$1 = $1851;
     i64toi32_i32$2 = $1853$hi;
     i64toi32_i32$3 = $1853;
     i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
     $1854 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $1854$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($7 | 0, i64toi32_i32$2 | 0, 25 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $1856 = i64toi32_i32$1;
     $1856$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1854$hi;
     i64toi32_i32$5 = $1854;
     i64toi32_i32$1 = $1856$hi;
     i64toi32_i32$3 = $1856;
     i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
     $1857 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $1857$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$2 = $6;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $1861 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $1861$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$1 = $7;
     i64toi32_i32$2 = $1861$hi;
     i64toi32_i32$3 = $1861;
     i64toi32_i32$2 = i64toi32_i32$5 & i64toi32_i32$2 | 0;
     $1862 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $1862$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$5 = $6;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
     $1865 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $1865$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $1862$hi;
     i64toi32_i32$2 = $1862;
     i64toi32_i32$5 = $1865$hi;
     i64toi32_i32$3 = $1865;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $1866 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $1866$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $1857$hi;
     i64toi32_i32$1 = $1857;
     i64toi32_i32$2 = $1866$hi;
     i64toi32_i32$3 = $1866;
     i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $1867$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $26$hi;
     i64toi32_i32$4 = $1867$hi;
     i64toi32_i32$5 = i64toi32_i32$0;
     i64toi32_i32$1 = $26$hi;
     i64toi32_i32$3 = $26;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $13 = i64toi32_i32$2;
     $13$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $1849$hi;
     i64toi32_i32$4 = $1849;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$3 = i64toi32_i32$2;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $12 = i64toi32_i32$1;
     $12$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$0 = $24;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $1875 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $1875$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$0 = $1875$hi;
     i64toi32_i32$3 = $1875;
     i64toi32_i32$0 = i64toi32_i32$4 & i64toi32_i32$0 | 0;
     $1876$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$0 = $1876$hi;
     i64toi32_i32$4 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $1878 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $1878$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1827$hi;
     i64toi32_i32$0 = $1827;
     i64toi32_i32$4 = $1878$hi;
     i64toi32_i32$3 = $1878;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $1879$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($12 | 0, i64toi32_i32$1 | 0, 50 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $1881 = i64toi32_i32$0;
     $1881$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($12 | 0, i64toi32_i32$1 | 0, 46 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $1883 = i64toi32_i32$0;
     $1883$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $1881$hi;
     i64toi32_i32$2 = $1881;
     i64toi32_i32$0 = $1883$hi;
     i64toi32_i32$3 = $1883;
     i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
     $1884 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $1884$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($12 | 0, i64toi32_i32$0 | 0, 23 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $1886 = i64toi32_i32$2;
     $1886$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $1884$hi;
     i64toi32_i32$1 = $1884;
     i64toi32_i32$2 = $1886$hi;
     i64toi32_i32$3 = $1886;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $1887 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $1887$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1879$hi;
     i64toi32_i32$0 = i64toi32_i32$5;
     i64toi32_i32$1 = $1887$hi;
     i64toi32_i32$3 = $1887;
     i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     i64toi32_i32$2 = i64toi32_i32$4;
     i64toi32_i32$0 = 113926993;
     i64toi32_i32$3 = -536640913;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $26 = i64toi32_i32$1;
     $26$hi = i64toi32_i32$4;
     $1890 = i64toi32_i32$1;
     $1890$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($13 | 0, i64toi32_i32$4 | 0, 36 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $1892 = i64toi32_i32$2;
     $1892$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($13 | 0, i64toi32_i32$4 | 0, 30 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $1894 = i64toi32_i32$2;
     $1894$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1892$hi;
     i64toi32_i32$5 = $1892;
     i64toi32_i32$2 = $1894$hi;
     i64toi32_i32$3 = $1894;
     i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
     $1895 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $1895$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$5 = 0;
     i64toi32_i32$5 = __wasm_rotl_i64($13 | 0, i64toi32_i32$2 | 0, 25 | 0, i64toi32_i32$5 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $1897 = i64toi32_i32$5;
     $1897$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1895$hi;
     i64toi32_i32$4 = $1895;
     i64toi32_i32$5 = $1897$hi;
     i64toi32_i32$3 = $1897;
     i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
     $1898 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $1898$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$2 = $7;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
     $1902 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $1902$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$5 = $13;
     i64toi32_i32$2 = $1902$hi;
     i64toi32_i32$3 = $1902;
     i64toi32_i32$2 = i64toi32_i32$4 & i64toi32_i32$2 | 0;
     $1903 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $1903$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$4 = $7;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$5 = i64toi32_i32$2 & i64toi32_i32$5 | 0;
     $1906 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     $1906$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $1903$hi;
     i64toi32_i32$2 = $1903;
     i64toi32_i32$4 = $1906$hi;
     i64toi32_i32$3 = $1906;
     i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
     $1907 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $1907$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1898$hi;
     i64toi32_i32$5 = $1898;
     i64toi32_i32$2 = $1907$hi;
     i64toi32_i32$3 = $1907;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $1908$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $28$hi;
     i64toi32_i32$1 = $1908$hi;
     i64toi32_i32$4 = i64toi32_i32$0;
     i64toi32_i32$5 = $28$hi;
     i64toi32_i32$3 = $28;
     i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $6 = i64toi32_i32$2;
     $6$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $1890$hi;
     i64toi32_i32$1 = $1890;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$3 = i64toi32_i32$2;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $89 = i64toi32_i32$5;
     $89$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$0 = $12;
     i64toi32_i32$1 = $24$hi;
     i64toi32_i32$3 = $24;
     i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
     $1916 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $1916$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $89$hi;
     i64toi32_i32$2 = i64toi32_i32$5;
     i64toi32_i32$0 = $1916$hi;
     i64toi32_i32$3 = $1916;
     i64toi32_i32$0 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
     $1917$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$0 = $1917$hi;
     i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$3 = $24;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $1919 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $1919$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1824$hi;
     i64toi32_i32$0 = $1824;
     i64toi32_i32$1 = $1919$hi;
     i64toi32_i32$3 = $1919;
     i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $1920$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($89 | 0, i64toi32_i32$5 | 0, 50 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $1922 = i64toi32_i32$0;
     $1922$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($89 | 0, i64toi32_i32$5 | 0, 46 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $1924 = i64toi32_i32$0;
     $1924$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $1922$hi;
     i64toi32_i32$2 = $1922;
     i64toi32_i32$0 = $1924$hi;
     i64toi32_i32$3 = $1924;
     i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
     $1925 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $1925$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($89 | 0, i64toi32_i32$0 | 0, 23 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $1927 = i64toi32_i32$2;
     $1927$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $1925$hi;
     i64toi32_i32$5 = $1925;
     i64toi32_i32$2 = $1927$hi;
     i64toi32_i32$3 = $1927;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $1928 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $1928$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1920$hi;
     i64toi32_i32$0 = i64toi32_i32$4;
     i64toi32_i32$5 = $1928$hi;
     i64toi32_i32$3 = $1928;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$0 = 338241895;
     i64toi32_i32$3 = 168717936;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $28 = i64toi32_i32$5;
     $28$hi = i64toi32_i32$1;
     $1931 = i64toi32_i32$5;
     $1931$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($6 | 0, i64toi32_i32$1 | 0, 36 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $1933 = i64toi32_i32$2;
     $1933$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($6 | 0, i64toi32_i32$1 | 0, 30 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $1935 = i64toi32_i32$2;
     $1935$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $1933$hi;
     i64toi32_i32$4 = $1933;
     i64toi32_i32$2 = $1935$hi;
     i64toi32_i32$3 = $1935;
     i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
     $1936 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $1936$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($6 | 0, i64toi32_i32$2 | 0, 25 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $1938 = i64toi32_i32$4;
     $1938$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1936$hi;
     i64toi32_i32$1 = $1936;
     i64toi32_i32$4 = $1938$hi;
     i64toi32_i32$3 = $1938;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $1939 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $1939$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$2 = $13;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
     $1943 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $1943$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$4 = $6;
     i64toi32_i32$2 = $1943$hi;
     i64toi32_i32$3 = $1943;
     i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
     $1944 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     $1944$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$1 = $13;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$4 = i64toi32_i32$2 & i64toi32_i32$4 | 0;
     $1947 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $1947$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1944$hi;
     i64toi32_i32$2 = $1944;
     i64toi32_i32$1 = $1947$hi;
     i64toi32_i32$3 = $1947;
     i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
     $1948 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $1948$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $1939$hi;
     i64toi32_i32$4 = $1939;
     i64toi32_i32$2 = $1948$hi;
     i64toi32_i32$3 = $1948;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $1949$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $22$hi;
     i64toi32_i32$5 = $1949$hi;
     i64toi32_i32$1 = i64toi32_i32$0;
     i64toi32_i32$4 = $22$hi;
     i64toi32_i32$3 = $22;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $7 = i64toi32_i32$2;
     $7$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $1931$hi;
     i64toi32_i32$5 = $1931;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$3 = i64toi32_i32$2;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $19 = i64toi32_i32$4;
     $19$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$0 = $89;
     i64toi32_i32$5 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
     $1957 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $1957$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $19$hi;
     i64toi32_i32$2 = i64toi32_i32$4;
     i64toi32_i32$0 = $1957$hi;
     i64toi32_i32$3 = $1957;
     i64toi32_i32$0 = i64toi32_i32$5 & i64toi32_i32$0 | 0;
     $1958$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$0 = $1958$hi;
     i64toi32_i32$5 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $1960 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $1960$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1821$hi;
     i64toi32_i32$0 = $1821;
     i64toi32_i32$5 = $1960$hi;
     i64toi32_i32$3 = $1960;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $1961$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($19 | 0, i64toi32_i32$4 | 0, 50 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $1963 = i64toi32_i32$0;
     $1963$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($19 | 0, i64toi32_i32$4 | 0, 46 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $1965 = i64toi32_i32$0;
     $1965$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1963$hi;
     i64toi32_i32$2 = $1963;
     i64toi32_i32$0 = $1965$hi;
     i64toi32_i32$3 = $1965;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $1966 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $1966$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($19 | 0, i64toi32_i32$0 | 0, 23 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $1968 = i64toi32_i32$2;
     $1968$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $1966$hi;
     i64toi32_i32$4 = $1966;
     i64toi32_i32$2 = $1968$hi;
     i64toi32_i32$3 = $1968;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $1969 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $1969$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1961$hi;
     i64toi32_i32$0 = i64toi32_i32$1;
     i64toi32_i32$4 = $1969$hi;
     i64toi32_i32$3 = $1969;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     i64toi32_i32$2 = i64toi32_i32$5;
     i64toi32_i32$0 = 666307205;
     i64toi32_i32$3 = 1188179964;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $22 = i64toi32_i32$4;
     $22$hi = i64toi32_i32$5;
     $1972 = i64toi32_i32$4;
     $1972$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 36 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $1974 = i64toi32_i32$2;
     $1974$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 30 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $1976 = i64toi32_i32$2;
     $1976$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $1974$hi;
     i64toi32_i32$1 = $1974;
     i64toi32_i32$2 = $1976$hi;
     i64toi32_i32$3 = $1976;
     i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
     $1977 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $1977$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($7 | 0, i64toi32_i32$2 | 0, 25 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $1979 = i64toi32_i32$1;
     $1979$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1977$hi;
     i64toi32_i32$5 = $1977;
     i64toi32_i32$1 = $1979$hi;
     i64toi32_i32$3 = $1979;
     i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
     $1980 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $1980$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$2 = $6;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $1984 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $1984$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$1 = $7;
     i64toi32_i32$2 = $1984$hi;
     i64toi32_i32$3 = $1984;
     i64toi32_i32$2 = i64toi32_i32$5 & i64toi32_i32$2 | 0;
     $1985 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $1985$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$5 = $6;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
     $1988 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $1988$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $1985$hi;
     i64toi32_i32$2 = $1985;
     i64toi32_i32$5 = $1988$hi;
     i64toi32_i32$3 = $1988;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $1989 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $1989$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $1980$hi;
     i64toi32_i32$1 = $1980;
     i64toi32_i32$2 = $1989$hi;
     i64toi32_i32$3 = $1989;
     i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $1990$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $11$hi;
     i64toi32_i32$4 = $1990$hi;
     i64toi32_i32$5 = i64toi32_i32$0;
     i64toi32_i32$1 = $11$hi;
     i64toi32_i32$3 = $11;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $13 = i64toi32_i32$2;
     $13$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $1972$hi;
     i64toi32_i32$4 = $1972;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$3 = i64toi32_i32$2;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $24 = i64toi32_i32$1;
     $24$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $606$hi;
     i64toi32_i32$0 = $606;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$3 = i64toi32_i32$1;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $1996 = i64toi32_i32$5;
     $1996$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $39$hi;
     i64toi32_i32$1 = $19$hi;
     i64toi32_i32$1 = $39$hi;
     i64toi32_i32$2 = $39;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $1999 = i64toi32_i32$4;
     $1999$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $40$hi;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$5 = $40$hi;
     i64toi32_i32$1 = $40;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $2002 = i64toi32_i32$0;
     $2002$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $37$hi;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$4 = $37$hi;
     i64toi32_i32$5 = $37;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $2005$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$4 = $19;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$5 = i64toi32_i32$0 ^ i64toi32_i32$5 | 0;
     $2009 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $2009$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $24$hi;
     i64toi32_i32$0 = $24;
     i64toi32_i32$4 = $2009$hi;
     i64toi32_i32$3 = $2009;
     i64toi32_i32$4 = i64toi32_i32$5 & i64toi32_i32$4 | 0;
     $2010$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$4 = $2010$hi;
     i64toi32_i32$5 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $2012 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $2012$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $2005$hi;
     i64toi32_i32$4 = i64toi32_i32$2;
     i64toi32_i32$5 = $2012$hi;
     i64toi32_i32$3 = $2012;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $2013$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($24 | 0, i64toi32_i32$2 | 0, 50 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $2015 = i64toi32_i32$4;
     $2015$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($24 | 0, i64toi32_i32$2 | 0, 46 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $2017 = i64toi32_i32$4;
     $2017$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2015$hi;
     i64toi32_i32$0 = $2015;
     i64toi32_i32$4 = $2017$hi;
     i64toi32_i32$3 = $2017;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $2018 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $2018$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($24 | 0, i64toi32_i32$4 | 0, 23 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $2020 = i64toi32_i32$0;
     $2020$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2018$hi;
     i64toi32_i32$2 = $2018;
     i64toi32_i32$0 = $2020$hi;
     i64toi32_i32$3 = $2020;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $2021 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $2021$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $2013$hi;
     i64toi32_i32$4 = i64toi32_i32$1;
     i64toi32_i32$2 = $2021$hi;
     i64toi32_i32$3 = $2021;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     i64toi32_i32$0 = i64toi32_i32$5;
     i64toi32_i32$4 = 773529912;
     i64toi32_i32$3 = 1546045734;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $11 = i64toi32_i32$2;
     $11$hi = i64toi32_i32$5;
     $2024 = i64toi32_i32$2;
     $2024$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($13 | 0, i64toi32_i32$5 | 0, 36 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $2026 = i64toi32_i32$0;
     $2026$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($13 | 0, i64toi32_i32$5 | 0, 30 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $2028 = i64toi32_i32$0;
     $2028$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $2026$hi;
     i64toi32_i32$1 = $2026;
     i64toi32_i32$0 = $2028$hi;
     i64toi32_i32$3 = $2028;
     i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
     $2029 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $2029$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($13 | 0, i64toi32_i32$0 | 0, 25 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $2031 = i64toi32_i32$1;
     $2031$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $2029$hi;
     i64toi32_i32$5 = $2029;
     i64toi32_i32$1 = $2031$hi;
     i64toi32_i32$3 = $2031;
     i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
     $2032 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $2032$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$0 = $7;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $2036 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $2036$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$1 = $13;
     i64toi32_i32$0 = $2036$hi;
     i64toi32_i32$3 = $2036;
     i64toi32_i32$0 = i64toi32_i32$5 & i64toi32_i32$0 | 0;
     $2037 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $2037$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$5 = $7;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
     $2040 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $2040$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $2037$hi;
     i64toi32_i32$0 = $2037;
     i64toi32_i32$5 = $2040$hi;
     i64toi32_i32$3 = $2040;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $2041 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $2041$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $2032$hi;
     i64toi32_i32$1 = $2032;
     i64toi32_i32$0 = $2041$hi;
     i64toi32_i32$3 = $2041;
     i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $2042$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $17$hi;
     i64toi32_i32$2 = $2042$hi;
     i64toi32_i32$5 = i64toi32_i32$4;
     i64toi32_i32$1 = $17$hi;
     i64toi32_i32$3 = $17;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $6 = i64toi32_i32$0;
     $6$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2024$hi;
     i64toi32_i32$2 = $2024;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$3 = i64toi32_i32$0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $12 = i64toi32_i32$1;
     $12$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$4 = $24;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $2050 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $2050$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$0 = i64toi32_i32$1;
     i64toi32_i32$4 = $2050$hi;
     i64toi32_i32$3 = $2050;
     i64toi32_i32$4 = i64toi32_i32$2 & i64toi32_i32$4 | 0;
     $2051$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$4 = $2051$hi;
     i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $2053 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $2053$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $2002$hi;
     i64toi32_i32$4 = $2002;
     i64toi32_i32$2 = $2053$hi;
     i64toi32_i32$3 = $2053;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $2054$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($12 | 0, i64toi32_i32$1 | 0, 50 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $2056 = i64toi32_i32$4;
     $2056$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($12 | 0, i64toi32_i32$1 | 0, 46 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $2058 = i64toi32_i32$4;
     $2058$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $2056$hi;
     i64toi32_i32$0 = $2056;
     i64toi32_i32$4 = $2058$hi;
     i64toi32_i32$3 = $2058;
     i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
     $2059 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $2059$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($12 | 0, i64toi32_i32$4 | 0, 23 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $2061 = i64toi32_i32$0;
     $2061$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2059$hi;
     i64toi32_i32$1 = $2059;
     i64toi32_i32$0 = $2061$hi;
     i64toi32_i32$3 = $2061;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $2062 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $2062$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $2054$hi;
     i64toi32_i32$4 = i64toi32_i32$5;
     i64toi32_i32$1 = $2062$hi;
     i64toi32_i32$3 = $2062;
     i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     i64toi32_i32$0 = i64toi32_i32$2;
     i64toi32_i32$4 = 1294757372;
     i64toi32_i32$3 = 1522805485;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $17 = i64toi32_i32$1;
     $17$hi = i64toi32_i32$2;
     $2065 = i64toi32_i32$1;
     $2065$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($6 | 0, i64toi32_i32$2 | 0, 36 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $2067 = i64toi32_i32$0;
     $2067$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($6 | 0, i64toi32_i32$2 | 0, 30 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $2069 = i64toi32_i32$0;
     $2069$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2067$hi;
     i64toi32_i32$5 = $2067;
     i64toi32_i32$0 = $2069$hi;
     i64toi32_i32$3 = $2069;
     i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
     $2070 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $2070$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$5 = 0;
     i64toi32_i32$5 = __wasm_rotl_i64($6 | 0, i64toi32_i32$0 | 0, 25 | 0, i64toi32_i32$5 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $2072 = i64toi32_i32$5;
     $2072$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $2070$hi;
     i64toi32_i32$2 = $2070;
     i64toi32_i32$5 = $2072$hi;
     i64toi32_i32$3 = $2072;
     i64toi32_i32$5 = i64toi32_i32$0 ^ i64toi32_i32$5 | 0;
     $2073 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $2073$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$0 = $13;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
     $2077 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $2077$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$5 = $6;
     i64toi32_i32$0 = $2077$hi;
     i64toi32_i32$3 = $2077;
     i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
     $2078 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $2078$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$2 = $13;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$5 = i64toi32_i32$0 & i64toi32_i32$5 | 0;
     $2081 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     $2081$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $2078$hi;
     i64toi32_i32$0 = $2078;
     i64toi32_i32$2 = $2081$hi;
     i64toi32_i32$3 = $2081;
     i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
     $2082 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $2082$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2073$hi;
     i64toi32_i32$5 = $2073;
     i64toi32_i32$0 = $2082$hi;
     i64toi32_i32$3 = $2082;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $2083$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $26$hi;
     i64toi32_i32$1 = $2083$hi;
     i64toi32_i32$2 = i64toi32_i32$4;
     i64toi32_i32$5 = $26$hi;
     i64toi32_i32$3 = $26;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $7 = i64toi32_i32$0;
     $7$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2065$hi;
     i64toi32_i32$1 = $2065;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$3 = i64toi32_i32$0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $89 = i64toi32_i32$5;
     $89$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$4 = $12;
     i64toi32_i32$1 = $24$hi;
     i64toi32_i32$3 = $24;
     i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
     $2091 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $2091$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $89$hi;
     i64toi32_i32$0 = i64toi32_i32$5;
     i64toi32_i32$4 = $2091$hi;
     i64toi32_i32$3 = $2091;
     i64toi32_i32$4 = i64toi32_i32$1 & i64toi32_i32$4 | 0;
     $2092$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$4 = $2092$hi;
     i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$3 = $24;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $2094 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $2094$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $1999$hi;
     i64toi32_i32$4 = $1999;
     i64toi32_i32$1 = $2094$hi;
     i64toi32_i32$3 = $2094;
     i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $2095$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($89 | 0, i64toi32_i32$5 | 0, 50 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $2097 = i64toi32_i32$4;
     $2097$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($89 | 0, i64toi32_i32$5 | 0, 46 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $2099 = i64toi32_i32$4;
     $2099$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $2097$hi;
     i64toi32_i32$0 = $2097;
     i64toi32_i32$4 = $2099$hi;
     i64toi32_i32$3 = $2099;
     i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
     $2100 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $2100$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($89 | 0, i64toi32_i32$4 | 0, 23 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $2102 = i64toi32_i32$0;
     $2102$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2100$hi;
     i64toi32_i32$5 = $2100;
     i64toi32_i32$0 = $2102$hi;
     i64toi32_i32$3 = $2102;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $2103 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $2103$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $2095$hi;
     i64toi32_i32$4 = i64toi32_i32$2;
     i64toi32_i32$5 = $2103$hi;
     i64toi32_i32$3 = $2103;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     i64toi32_i32$0 = i64toi32_i32$1;
     i64toi32_i32$4 = 1396182291;
     i64toi32_i32$3 = -1651133473;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $26 = i64toi32_i32$5;
     $26$hi = i64toi32_i32$1;
     $2106 = i64toi32_i32$5;
     $2106$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($7 | 0, i64toi32_i32$1 | 0, 36 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $2108 = i64toi32_i32$0;
     $2108$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($7 | 0, i64toi32_i32$1 | 0, 30 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $2110 = i64toi32_i32$0;
     $2110$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $2108$hi;
     i64toi32_i32$2 = $2108;
     i64toi32_i32$0 = $2110$hi;
     i64toi32_i32$3 = $2110;
     i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
     $2111 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $2111$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 25 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $2113 = i64toi32_i32$2;
     $2113$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $2111$hi;
     i64toi32_i32$1 = $2111;
     i64toi32_i32$2 = $2113$hi;
     i64toi32_i32$3 = $2113;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $2114 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $2114$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$0 = $6;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
     $2118 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $2118$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$2 = $7;
     i64toi32_i32$0 = $2118$hi;
     i64toi32_i32$3 = $2118;
     i64toi32_i32$0 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
     $2119 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     $2119$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$1 = $6;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
     $2122 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $2122$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2119$hi;
     i64toi32_i32$0 = $2119;
     i64toi32_i32$1 = $2122$hi;
     i64toi32_i32$3 = $2122;
     i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
     $2123 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $2123$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $2114$hi;
     i64toi32_i32$2 = $2114;
     i64toi32_i32$0 = $2123$hi;
     i64toi32_i32$3 = $2123;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $2124$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $28$hi;
     i64toi32_i32$5 = $2124$hi;
     i64toi32_i32$1 = i64toi32_i32$4;
     i64toi32_i32$2 = $28$hi;
     i64toi32_i32$3 = $28;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $13 = i64toi32_i32$0;
     $13$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2106$hi;
     i64toi32_i32$5 = $2106;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$3 = i64toi32_i32$0;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $19 = i64toi32_i32$2;
     $19$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$4 = $89;
     i64toi32_i32$5 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$5 = i64toi32_i32$0 ^ i64toi32_i32$5 | 0;
     $2132 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $2132$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $19$hi;
     i64toi32_i32$0 = i64toi32_i32$2;
     i64toi32_i32$4 = $2132$hi;
     i64toi32_i32$3 = $2132;
     i64toi32_i32$4 = i64toi32_i32$5 & i64toi32_i32$4 | 0;
     $2133$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$4 = $2133$hi;
     i64toi32_i32$5 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $2135 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $2135$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $1996$hi;
     i64toi32_i32$4 = $1996;
     i64toi32_i32$5 = $2135$hi;
     i64toi32_i32$3 = $2135;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $2136$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($19 | 0, i64toi32_i32$2 | 0, 50 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $2138 = i64toi32_i32$4;
     $2138$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($19 | 0, i64toi32_i32$2 | 0, 46 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $2140 = i64toi32_i32$4;
     $2140$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2138$hi;
     i64toi32_i32$0 = $2138;
     i64toi32_i32$4 = $2140$hi;
     i64toi32_i32$3 = $2140;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $2141 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $2141$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($19 | 0, i64toi32_i32$4 | 0, 23 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $2143 = i64toi32_i32$0;
     $2143$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2141$hi;
     i64toi32_i32$2 = $2141;
     i64toi32_i32$0 = $2143$hi;
     i64toi32_i32$3 = $2143;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $2144 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $2144$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $2136$hi;
     i64toi32_i32$4 = i64toi32_i32$1;
     i64toi32_i32$2 = $2144$hi;
     i64toi32_i32$3 = $2144;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     i64toi32_i32$0 = i64toi32_i32$5;
     i64toi32_i32$4 = 1695183700;
     i64toi32_i32$3 = -1951439906;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $28 = i64toi32_i32$2;
     $28$hi = i64toi32_i32$5;
     $2147 = i64toi32_i32$2;
     $2147$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($13 | 0, i64toi32_i32$5 | 0, 36 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $2149 = i64toi32_i32$0;
     $2149$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($13 | 0, i64toi32_i32$5 | 0, 30 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $2151 = i64toi32_i32$0;
     $2151$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $2149$hi;
     i64toi32_i32$1 = $2149;
     i64toi32_i32$0 = $2151$hi;
     i64toi32_i32$3 = $2151;
     i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
     $2152 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $2152$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($13 | 0, i64toi32_i32$0 | 0, 25 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $2154 = i64toi32_i32$1;
     $2154$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $2152$hi;
     i64toi32_i32$5 = $2152;
     i64toi32_i32$1 = $2154$hi;
     i64toi32_i32$3 = $2154;
     i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
     $2155 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $2155$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$0 = $7;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $2159 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $2159$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$1 = $13;
     i64toi32_i32$0 = $2159$hi;
     i64toi32_i32$3 = $2159;
     i64toi32_i32$0 = i64toi32_i32$5 & i64toi32_i32$0 | 0;
     $2160 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $2160$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$5 = $7;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
     $2163 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $2163$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $2160$hi;
     i64toi32_i32$0 = $2160;
     i64toi32_i32$5 = $2163$hi;
     i64toi32_i32$3 = $2163;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $2164 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $2164$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $2155$hi;
     i64toi32_i32$1 = $2155;
     i64toi32_i32$0 = $2164$hi;
     i64toi32_i32$3 = $2164;
     i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $2165$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $22$hi;
     i64toi32_i32$2 = $2165$hi;
     i64toi32_i32$5 = i64toi32_i32$4;
     i64toi32_i32$1 = $22$hi;
     i64toi32_i32$3 = $22;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $6 = i64toi32_i32$0;
     $6$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2147$hi;
     i64toi32_i32$2 = $2147;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$3 = i64toi32_i32$0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $24 = i64toi32_i32$1;
     $24$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $605$hi;
     i64toi32_i32$4 = $605;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$3 = i64toi32_i32$1;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $2171 = i64toi32_i32$5;
     $2171$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $43$hi;
     i64toi32_i32$1 = $19$hi;
     i64toi32_i32$1 = $43$hi;
     i64toi32_i32$0 = $43;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $2174 = i64toi32_i32$2;
     $2174$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $44$hi;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$5 = $44$hi;
     i64toi32_i32$1 = $44;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $2177 = i64toi32_i32$4;
     $2177$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $41$hi;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$2 = $41$hi;
     i64toi32_i32$5 = $41;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $2180$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$2 = $19;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
     $2184 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $2184$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $24$hi;
     i64toi32_i32$4 = $24;
     i64toi32_i32$2 = $2184$hi;
     i64toi32_i32$3 = $2184;
     i64toi32_i32$2 = i64toi32_i32$5 & i64toi32_i32$2 | 0;
     $2185$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$2 = $2185$hi;
     i64toi32_i32$5 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $2187 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $2187$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2180$hi;
     i64toi32_i32$2 = i64toi32_i32$0;
     i64toi32_i32$5 = $2187$hi;
     i64toi32_i32$3 = $2187;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $2188$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($24 | 0, i64toi32_i32$0 | 0, 50 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $2190 = i64toi32_i32$2;
     $2190$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($24 | 0, i64toi32_i32$0 | 0, 46 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $2192 = i64toi32_i32$2;
     $2192$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $2190$hi;
     i64toi32_i32$4 = $2190;
     i64toi32_i32$2 = $2192$hi;
     i64toi32_i32$3 = $2192;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $2193 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $2193$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($24 | 0, i64toi32_i32$2 | 0, 23 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $2195 = i64toi32_i32$4;
     $2195$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2193$hi;
     i64toi32_i32$0 = $2193;
     i64toi32_i32$4 = $2195$hi;
     i64toi32_i32$3 = $2195;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $2196 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $2196$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2188$hi;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$0 = $2196$hi;
     i64toi32_i32$3 = $2196;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     i64toi32_i32$4 = i64toi32_i32$5;
     i64toi32_i32$2 = 1986661051;
     i64toi32_i32$3 = 1014477480;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $22 = i64toi32_i32$0;
     $22$hi = i64toi32_i32$5;
     $2199 = i64toi32_i32$0;
     $2199$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($6 | 0, i64toi32_i32$5 | 0, 36 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $2201 = i64toi32_i32$4;
     $2201$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($6 | 0, i64toi32_i32$5 | 0, 30 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $2203 = i64toi32_i32$4;
     $2203$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $2201$hi;
     i64toi32_i32$1 = $2201;
     i64toi32_i32$4 = $2203$hi;
     i64toi32_i32$3 = $2203;
     i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
     $2204 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $2204$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($6 | 0, i64toi32_i32$4 | 0, 25 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $2206 = i64toi32_i32$1;
     $2206$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2204$hi;
     i64toi32_i32$5 = $2204;
     i64toi32_i32$1 = $2206$hi;
     i64toi32_i32$3 = $2206;
     i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
     $2207 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $2207$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$4 = $13;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $2211 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $2211$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$1 = $6;
     i64toi32_i32$4 = $2211$hi;
     i64toi32_i32$3 = $2211;
     i64toi32_i32$4 = i64toi32_i32$5 & i64toi32_i32$4 | 0;
     $2212 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $2212$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$5 = $13;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$1 = i64toi32_i32$4 & i64toi32_i32$1 | 0;
     $2215 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $2215$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $2212$hi;
     i64toi32_i32$4 = $2212;
     i64toi32_i32$5 = $2215$hi;
     i64toi32_i32$3 = $2215;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $2216 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $2216$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $2207$hi;
     i64toi32_i32$1 = $2207;
     i64toi32_i32$4 = $2216$hi;
     i64toi32_i32$3 = $2216;
     i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $2217$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $11$hi;
     i64toi32_i32$0 = $2217$hi;
     i64toi32_i32$5 = i64toi32_i32$2;
     i64toi32_i32$1 = $11$hi;
     i64toi32_i32$3 = $11;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $7 = i64toi32_i32$4;
     $7$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2199$hi;
     i64toi32_i32$0 = $2199;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$3 = i64toi32_i32$4;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $12 = i64toi32_i32$1;
     $12$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$2 = $24;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $2225 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $2225$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$4 = i64toi32_i32$1;
     i64toi32_i32$2 = $2225$hi;
     i64toi32_i32$3 = $2225;
     i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
     $2226$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$2 = $2226$hi;
     i64toi32_i32$0 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $2228 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $2228$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2177$hi;
     i64toi32_i32$2 = $2177;
     i64toi32_i32$0 = $2228$hi;
     i64toi32_i32$3 = $2228;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $2229$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($12 | 0, i64toi32_i32$1 | 0, 50 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $2231 = i64toi32_i32$2;
     $2231$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($12 | 0, i64toi32_i32$1 | 0, 46 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $2233 = i64toi32_i32$2;
     $2233$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $2231$hi;
     i64toi32_i32$4 = $2231;
     i64toi32_i32$2 = $2233$hi;
     i64toi32_i32$3 = $2233;
     i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
     $2234 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $2234$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($12 | 0, i64toi32_i32$2 | 0, 23 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $2236 = i64toi32_i32$4;
     $2236$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2234$hi;
     i64toi32_i32$1 = $2234;
     i64toi32_i32$4 = $2236$hi;
     i64toi32_i32$3 = $2236;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $2237 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $2237$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2229$hi;
     i64toi32_i32$2 = i64toi32_i32$5;
     i64toi32_i32$1 = $2237$hi;
     i64toi32_i32$3 = $2237;
     i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     i64toi32_i32$4 = i64toi32_i32$0;
     i64toi32_i32$2 = -2117940946;
     i64toi32_i32$3 = 1206759142;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $11 = i64toi32_i32$1;
     $11$hi = i64toi32_i32$0;
     $2240 = i64toi32_i32$1;
     $2240$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 36 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $2242 = i64toi32_i32$4;
     $2242$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 30 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $2244 = i64toi32_i32$4;
     $2244$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $2242$hi;
     i64toi32_i32$5 = $2242;
     i64toi32_i32$4 = $2244$hi;
     i64toi32_i32$3 = $2244;
     i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
     $2245 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $2245$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$5 = 0;
     i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 25 | 0, i64toi32_i32$5 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $2247 = i64toi32_i32$5;
     $2247$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2245$hi;
     i64toi32_i32$0 = $2245;
     i64toi32_i32$5 = $2247$hi;
     i64toi32_i32$3 = $2247;
     i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
     $2248 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $2248$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$4 = $6;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
     $2252 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $2252$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$5 = $7;
     i64toi32_i32$4 = $2252$hi;
     i64toi32_i32$3 = $2252;
     i64toi32_i32$4 = i64toi32_i32$0 & i64toi32_i32$4 | 0;
     $2253 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $2253$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$0 = $6;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$5 = i64toi32_i32$4 & i64toi32_i32$5 | 0;
     $2256 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
     $2256$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $2253$hi;
     i64toi32_i32$4 = $2253;
     i64toi32_i32$0 = $2256$hi;
     i64toi32_i32$3 = $2256;
     i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
     $2257 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $2257$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $2248$hi;
     i64toi32_i32$5 = $2248;
     i64toi32_i32$4 = $2257$hi;
     i64toi32_i32$3 = $2257;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $2258$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $17$hi;
     i64toi32_i32$1 = $2258$hi;
     i64toi32_i32$0 = i64toi32_i32$2;
     i64toi32_i32$5 = $17$hi;
     i64toi32_i32$3 = $17;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $13 = i64toi32_i32$4;
     $13$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2240$hi;
     i64toi32_i32$1 = $2240;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$3 = i64toi32_i32$4;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $89 = i64toi32_i32$5;
     $89$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$2 = $12;
     i64toi32_i32$1 = $24$hi;
     i64toi32_i32$3 = $24;
     i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
     $2266 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $2266$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $89$hi;
     i64toi32_i32$4 = i64toi32_i32$5;
     i64toi32_i32$2 = $2266$hi;
     i64toi32_i32$3 = $2266;
     i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
     $2267$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$2 = $2267$hi;
     i64toi32_i32$1 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$3 = $24;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $2269 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $2269$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2174$hi;
     i64toi32_i32$2 = $2174;
     i64toi32_i32$1 = $2269$hi;
     i64toi32_i32$3 = $2269;
     i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $2270$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($89 | 0, i64toi32_i32$5 | 0, 50 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $2272 = i64toi32_i32$2;
     $2272$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($89 | 0, i64toi32_i32$5 | 0, 46 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $2274 = i64toi32_i32$2;
     $2274$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $2272$hi;
     i64toi32_i32$4 = $2272;
     i64toi32_i32$2 = $2274$hi;
     i64toi32_i32$3 = $2274;
     i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
     $2275 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $2275$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($89 | 0, i64toi32_i32$2 | 0, 23 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $2277 = i64toi32_i32$4;
     $2277$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2275$hi;
     i64toi32_i32$5 = $2275;
     i64toi32_i32$4 = $2277$hi;
     i64toi32_i32$3 = $2277;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $2278 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $2278$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2270$hi;
     i64toi32_i32$2 = i64toi32_i32$0;
     i64toi32_i32$5 = $2278$hi;
     i64toi32_i32$3 = $2278;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     i64toi32_i32$4 = i64toi32_i32$1;
     i64toi32_i32$2 = -1838011259;
     i64toi32_i32$3 = 344077627;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $17 = i64toi32_i32$5;
     $17$hi = i64toi32_i32$1;
     $2281 = i64toi32_i32$5;
     $2281$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($13 | 0, i64toi32_i32$1 | 0, 36 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $2283 = i64toi32_i32$4;
     $2283$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($13 | 0, i64toi32_i32$1 | 0, 30 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $2285 = i64toi32_i32$4;
     $2285$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $2283$hi;
     i64toi32_i32$0 = $2283;
     i64toi32_i32$4 = $2285$hi;
     i64toi32_i32$3 = $2285;
     i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
     $2286 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $2286$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($13 | 0, i64toi32_i32$4 | 0, 25 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $2288 = i64toi32_i32$0;
     $2288$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2286$hi;
     i64toi32_i32$1 = $2286;
     i64toi32_i32$0 = $2288$hi;
     i64toi32_i32$3 = $2288;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $2289 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $2289$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$4 = $7;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
     $2293 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $2293$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$0 = $13;
     i64toi32_i32$4 = $2293$hi;
     i64toi32_i32$3 = $2293;
     i64toi32_i32$4 = i64toi32_i32$1 & i64toi32_i32$4 | 0;
     $2294 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
     $2294$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$1 = $7;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$0 = i64toi32_i32$4 & i64toi32_i32$0 | 0;
     $2297 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $2297$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $2294$hi;
     i64toi32_i32$4 = $2294;
     i64toi32_i32$1 = $2297$hi;
     i64toi32_i32$3 = $2297;
     i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
     $2298 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $2298$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $2289$hi;
     i64toi32_i32$0 = $2289;
     i64toi32_i32$4 = $2298$hi;
     i64toi32_i32$3 = $2298;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $2299$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $26$hi;
     i64toi32_i32$5 = $2299$hi;
     i64toi32_i32$1 = i64toi32_i32$2;
     i64toi32_i32$0 = $26$hi;
     i64toi32_i32$3 = $26;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $6 = i64toi32_i32$4;
     $6$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2281$hi;
     i64toi32_i32$5 = $2281;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$3 = i64toi32_i32$4;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $19 = i64toi32_i32$0;
     $19$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$2 = $89;
     i64toi32_i32$5 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
     $2307 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $2307$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $19$hi;
     i64toi32_i32$4 = i64toi32_i32$0;
     i64toi32_i32$2 = $2307$hi;
     i64toi32_i32$3 = $2307;
     i64toi32_i32$2 = i64toi32_i32$5 & i64toi32_i32$2 | 0;
     $2308$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$2 = $2308$hi;
     i64toi32_i32$5 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $2310 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $2310$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2171$hi;
     i64toi32_i32$2 = $2171;
     i64toi32_i32$5 = $2310$hi;
     i64toi32_i32$3 = $2310;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $2311$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($19 | 0, i64toi32_i32$0 | 0, 50 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $2313 = i64toi32_i32$2;
     $2313$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($19 | 0, i64toi32_i32$0 | 0, 46 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $2315 = i64toi32_i32$2;
     $2315$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $2313$hi;
     i64toi32_i32$4 = $2313;
     i64toi32_i32$2 = $2315$hi;
     i64toi32_i32$3 = $2315;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $2316 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $2316$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($19 | 0, i64toi32_i32$2 | 0, 23 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $2318 = i64toi32_i32$4;
     $2318$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2316$hi;
     i64toi32_i32$0 = $2316;
     i64toi32_i32$4 = $2318$hi;
     i64toi32_i32$3 = $2318;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $2319 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $2319$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2311$hi;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$0 = $2319$hi;
     i64toi32_i32$3 = $2319;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     i64toi32_i32$4 = i64toi32_i32$5;
     i64toi32_i32$2 = -1564481375;
     i64toi32_i32$3 = 1290863460;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $26 = i64toi32_i32$0;
     $26$hi = i64toi32_i32$5;
     $2322 = i64toi32_i32$0;
     $2322$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($6 | 0, i64toi32_i32$5 | 0, 36 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $2324 = i64toi32_i32$4;
     $2324$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($6 | 0, i64toi32_i32$5 | 0, 30 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $2326 = i64toi32_i32$4;
     $2326$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $2324$hi;
     i64toi32_i32$1 = $2324;
     i64toi32_i32$4 = $2326$hi;
     i64toi32_i32$3 = $2326;
     i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
     $2327 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $2327$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($6 | 0, i64toi32_i32$4 | 0, 25 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $2329 = i64toi32_i32$1;
     $2329$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2327$hi;
     i64toi32_i32$5 = $2327;
     i64toi32_i32$1 = $2329$hi;
     i64toi32_i32$3 = $2329;
     i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
     $2330 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $2330$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$4 = $13;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $2334 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $2334$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$1 = $6;
     i64toi32_i32$4 = $2334$hi;
     i64toi32_i32$3 = $2334;
     i64toi32_i32$4 = i64toi32_i32$5 & i64toi32_i32$4 | 0;
     $2335 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $2335$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$5 = $13;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$1 = i64toi32_i32$4 & i64toi32_i32$1 | 0;
     $2338 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $2338$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $2335$hi;
     i64toi32_i32$4 = $2335;
     i64toi32_i32$5 = $2338$hi;
     i64toi32_i32$3 = $2338;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $2339 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $2339$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $2330$hi;
     i64toi32_i32$1 = $2330;
     i64toi32_i32$4 = $2339$hi;
     i64toi32_i32$3 = $2339;
     i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $2340$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $28$hi;
     i64toi32_i32$0 = $2340$hi;
     i64toi32_i32$5 = i64toi32_i32$2;
     i64toi32_i32$1 = $28$hi;
     i64toi32_i32$3 = $28;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $7 = i64toi32_i32$4;
     $7$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2322$hi;
     i64toi32_i32$0 = $2322;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$3 = i64toi32_i32$4;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $24 = i64toi32_i32$1;
     $24$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $604$hi;
     i64toi32_i32$2 = $604;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$3 = i64toi32_i32$1;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $2346 = i64toi32_i32$5;
     $2346$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $47$hi;
     i64toi32_i32$1 = $19$hi;
     i64toi32_i32$1 = $47$hi;
     i64toi32_i32$4 = $47;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $2349 = i64toi32_i32$0;
     $2349$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $48$hi;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$5 = $48$hi;
     i64toi32_i32$1 = $48;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $2352 = i64toi32_i32$2;
     $2352$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $45$hi;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$0 = $45$hi;
     i64toi32_i32$5 = $45;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $2355$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$0 = $19;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
     $2359 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $2359$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $24$hi;
     i64toi32_i32$2 = $24;
     i64toi32_i32$0 = $2359$hi;
     i64toi32_i32$3 = $2359;
     i64toi32_i32$0 = i64toi32_i32$5 & i64toi32_i32$0 | 0;
     $2360$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$0 = $2360$hi;
     i64toi32_i32$5 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $2362 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $2362$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2355$hi;
     i64toi32_i32$0 = i64toi32_i32$4;
     i64toi32_i32$5 = $2362$hi;
     i64toi32_i32$3 = $2362;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $2363$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($24 | 0, i64toi32_i32$4 | 0, 50 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $2365 = i64toi32_i32$0;
     $2365$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($24 | 0, i64toi32_i32$4 | 0, 46 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $2367 = i64toi32_i32$0;
     $2367$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2365$hi;
     i64toi32_i32$2 = $2365;
     i64toi32_i32$0 = $2367$hi;
     i64toi32_i32$3 = $2367;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $2368 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $2368$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($24 | 0, i64toi32_i32$0 | 0, 23 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $2370 = i64toi32_i32$2;
     $2370$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $2368$hi;
     i64toi32_i32$4 = $2368;
     i64toi32_i32$2 = $2370$hi;
     i64toi32_i32$3 = $2370;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $2371 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $2371$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2363$hi;
     i64toi32_i32$0 = i64toi32_i32$1;
     i64toi32_i32$4 = $2371$hi;
     i64toi32_i32$3 = $2371;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     i64toi32_i32$2 = i64toi32_i32$5;
     i64toi32_i32$0 = -1474664885;
     i64toi32_i32$3 = -1136513023;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $28 = i64toi32_i32$4;
     $28$hi = i64toi32_i32$5;
     $2374 = i64toi32_i32$4;
     $2374$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 36 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $2376 = i64toi32_i32$2;
     $2376$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 30 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $2378 = i64toi32_i32$2;
     $2378$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $2376$hi;
     i64toi32_i32$1 = $2376;
     i64toi32_i32$2 = $2378$hi;
     i64toi32_i32$3 = $2378;
     i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
     $2379 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $2379$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($7 | 0, i64toi32_i32$2 | 0, 25 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $2381 = i64toi32_i32$1;
     $2381$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2379$hi;
     i64toi32_i32$5 = $2379;
     i64toi32_i32$1 = $2381$hi;
     i64toi32_i32$3 = $2381;
     i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
     $2382 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $2382$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$2 = $6;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $2386 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $2386$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$1 = $7;
     i64toi32_i32$2 = $2386$hi;
     i64toi32_i32$3 = $2386;
     i64toi32_i32$2 = i64toi32_i32$5 & i64toi32_i32$2 | 0;
     $2387 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $2387$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$5 = $6;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
     $2390 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $2390$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $2387$hi;
     i64toi32_i32$2 = $2387;
     i64toi32_i32$5 = $2390$hi;
     i64toi32_i32$3 = $2390;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $2391 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $2391$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $2382$hi;
     i64toi32_i32$1 = $2382;
     i64toi32_i32$2 = $2391$hi;
     i64toi32_i32$3 = $2391;
     i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $2392$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $22$hi;
     i64toi32_i32$4 = $2392$hi;
     i64toi32_i32$5 = i64toi32_i32$0;
     i64toi32_i32$1 = $22$hi;
     i64toi32_i32$3 = $22;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $13 = i64toi32_i32$2;
     $13$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $2374$hi;
     i64toi32_i32$4 = $2374;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$3 = i64toi32_i32$2;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $12 = i64toi32_i32$1;
     $12$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$0 = $24;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $2400 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $2400$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$0 = $2400$hi;
     i64toi32_i32$3 = $2400;
     i64toi32_i32$0 = i64toi32_i32$4 & i64toi32_i32$0 | 0;
     $2401$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$0 = $2401$hi;
     i64toi32_i32$4 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $2403 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $2403$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2352$hi;
     i64toi32_i32$0 = $2352;
     i64toi32_i32$4 = $2403$hi;
     i64toi32_i32$3 = $2403;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $2404$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($12 | 0, i64toi32_i32$1 | 0, 50 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $2406 = i64toi32_i32$0;
     $2406$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($12 | 0, i64toi32_i32$1 | 0, 46 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $2408 = i64toi32_i32$0;
     $2408$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $2406$hi;
     i64toi32_i32$2 = $2406;
     i64toi32_i32$0 = $2408$hi;
     i64toi32_i32$3 = $2408;
     i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
     $2409 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $2409$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($12 | 0, i64toi32_i32$0 | 0, 23 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $2411 = i64toi32_i32$2;
     $2411$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $2409$hi;
     i64toi32_i32$1 = $2409;
     i64toi32_i32$2 = $2411$hi;
     i64toi32_i32$3 = $2411;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $2412 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $2412$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2404$hi;
     i64toi32_i32$0 = i64toi32_i32$5;
     i64toi32_i32$1 = $2412$hi;
     i64toi32_i32$3 = $2412;
     i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     i64toi32_i32$2 = i64toi32_i32$4;
     i64toi32_i32$0 = -1035236496;
     i64toi32_i32$3 = -789014639;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $22 = i64toi32_i32$1;
     $22$hi = i64toi32_i32$4;
     $2415 = i64toi32_i32$1;
     $2415$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($13 | 0, i64toi32_i32$4 | 0, 36 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $2417 = i64toi32_i32$2;
     $2417$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($13 | 0, i64toi32_i32$4 | 0, 30 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $2419 = i64toi32_i32$2;
     $2419$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2417$hi;
     i64toi32_i32$5 = $2417;
     i64toi32_i32$2 = $2419$hi;
     i64toi32_i32$3 = $2419;
     i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
     $2420 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $2420$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$5 = 0;
     i64toi32_i32$5 = __wasm_rotl_i64($13 | 0, i64toi32_i32$2 | 0, 25 | 0, i64toi32_i32$5 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $2422 = i64toi32_i32$5;
     $2422$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2420$hi;
     i64toi32_i32$4 = $2420;
     i64toi32_i32$5 = $2422$hi;
     i64toi32_i32$3 = $2422;
     i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
     $2423 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $2423$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$2 = $7;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
     $2427 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $2427$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$5 = $13;
     i64toi32_i32$2 = $2427$hi;
     i64toi32_i32$3 = $2427;
     i64toi32_i32$2 = i64toi32_i32$4 & i64toi32_i32$2 | 0;
     $2428 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $2428$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$4 = $7;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$5 = i64toi32_i32$2 & i64toi32_i32$5 | 0;
     $2431 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     $2431$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $2428$hi;
     i64toi32_i32$2 = $2428;
     i64toi32_i32$4 = $2431$hi;
     i64toi32_i32$3 = $2431;
     i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
     $2432 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $2432$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2423$hi;
     i64toi32_i32$5 = $2423;
     i64toi32_i32$2 = $2432$hi;
     i64toi32_i32$3 = $2432;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $2433$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $11$hi;
     i64toi32_i32$1 = $2433$hi;
     i64toi32_i32$4 = i64toi32_i32$0;
     i64toi32_i32$5 = $11$hi;
     i64toi32_i32$3 = $11;
     i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $6 = i64toi32_i32$2;
     $6$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $2415$hi;
     i64toi32_i32$1 = $2415;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$3 = i64toi32_i32$2;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $89 = i64toi32_i32$5;
     $89$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$0 = $12;
     i64toi32_i32$1 = $24$hi;
     i64toi32_i32$3 = $24;
     i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
     $2441 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $2441$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $89$hi;
     i64toi32_i32$2 = i64toi32_i32$5;
     i64toi32_i32$0 = $2441$hi;
     i64toi32_i32$3 = $2441;
     i64toi32_i32$0 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
     $2442$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$0 = $2442$hi;
     i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$3 = $24;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $2444 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $2444$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2349$hi;
     i64toi32_i32$0 = $2349;
     i64toi32_i32$1 = $2444$hi;
     i64toi32_i32$3 = $2444;
     i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $2445$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($89 | 0, i64toi32_i32$5 | 0, 50 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $2447 = i64toi32_i32$0;
     $2447$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($89 | 0, i64toi32_i32$5 | 0, 46 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $2449 = i64toi32_i32$0;
     $2449$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $2447$hi;
     i64toi32_i32$2 = $2447;
     i64toi32_i32$0 = $2449$hi;
     i64toi32_i32$3 = $2449;
     i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
     $2450 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $2450$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($89 | 0, i64toi32_i32$0 | 0, 23 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $2452 = i64toi32_i32$2;
     $2452$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $2450$hi;
     i64toi32_i32$5 = $2450;
     i64toi32_i32$2 = $2452$hi;
     i64toi32_i32$3 = $2452;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $2453 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $2453$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2445$hi;
     i64toi32_i32$0 = i64toi32_i32$4;
     i64toi32_i32$5 = $2453$hi;
     i64toi32_i32$3 = $2453;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$0 = -949202525;
     i64toi32_i32$3 = 106217008;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $11 = i64toi32_i32$5;
     $11$hi = i64toi32_i32$1;
     $2456 = i64toi32_i32$5;
     $2456$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($6 | 0, i64toi32_i32$1 | 0, 36 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $2458 = i64toi32_i32$2;
     $2458$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($6 | 0, i64toi32_i32$1 | 0, 30 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $2460 = i64toi32_i32$2;
     $2460$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $2458$hi;
     i64toi32_i32$4 = $2458;
     i64toi32_i32$2 = $2460$hi;
     i64toi32_i32$3 = $2460;
     i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
     $2461 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $2461$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($6 | 0, i64toi32_i32$2 | 0, 25 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $2463 = i64toi32_i32$4;
     $2463$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2461$hi;
     i64toi32_i32$1 = $2461;
     i64toi32_i32$4 = $2463$hi;
     i64toi32_i32$3 = $2463;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $2464 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $2464$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$2 = $13;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
     $2468 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $2468$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$4 = $6;
     i64toi32_i32$2 = $2468$hi;
     i64toi32_i32$3 = $2468;
     i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
     $2469 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     $2469$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$1 = $13;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$4 = i64toi32_i32$2 & i64toi32_i32$4 | 0;
     $2472 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $2472$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2469$hi;
     i64toi32_i32$2 = $2469;
     i64toi32_i32$1 = $2472$hi;
     i64toi32_i32$3 = $2472;
     i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
     $2473 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $2473$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $2464$hi;
     i64toi32_i32$4 = $2464;
     i64toi32_i32$2 = $2473$hi;
     i64toi32_i32$3 = $2473;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $2474$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $17$hi;
     i64toi32_i32$5 = $2474$hi;
     i64toi32_i32$1 = i64toi32_i32$0;
     i64toi32_i32$4 = $17$hi;
     i64toi32_i32$3 = $17;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $7 = i64toi32_i32$2;
     $7$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $2456$hi;
     i64toi32_i32$5 = $2456;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$3 = i64toi32_i32$2;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $19 = i64toi32_i32$4;
     $19$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$0 = $89;
     i64toi32_i32$5 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
     $2482 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $2482$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $19$hi;
     i64toi32_i32$2 = i64toi32_i32$4;
     i64toi32_i32$0 = $2482$hi;
     i64toi32_i32$3 = $2482;
     i64toi32_i32$0 = i64toi32_i32$5 & i64toi32_i32$0 | 0;
     $2483$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$0 = $2483$hi;
     i64toi32_i32$5 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $2485 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $2485$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2346$hi;
     i64toi32_i32$0 = $2346;
     i64toi32_i32$5 = $2485$hi;
     i64toi32_i32$3 = $2485;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $2486$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($19 | 0, i64toi32_i32$4 | 0, 50 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $2488 = i64toi32_i32$0;
     $2488$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($19 | 0, i64toi32_i32$4 | 0, 46 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $2490 = i64toi32_i32$0;
     $2490$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2488$hi;
     i64toi32_i32$2 = $2488;
     i64toi32_i32$0 = $2490$hi;
     i64toi32_i32$3 = $2490;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $2491 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $2491$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($19 | 0, i64toi32_i32$0 | 0, 23 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $2493 = i64toi32_i32$2;
     $2493$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $2491$hi;
     i64toi32_i32$4 = $2491;
     i64toi32_i32$2 = $2493$hi;
     i64toi32_i32$3 = $2493;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $2494 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $2494$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2486$hi;
     i64toi32_i32$0 = i64toi32_i32$1;
     i64toi32_i32$4 = $2494$hi;
     i64toi32_i32$3 = $2494;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     i64toi32_i32$2 = i64toi32_i32$5;
     i64toi32_i32$0 = -778901479;
     i64toi32_i32$3 = -688958952;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $17 = i64toi32_i32$4;
     $17$hi = i64toi32_i32$5;
     $2497 = i64toi32_i32$4;
     $2497$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 36 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $2499 = i64toi32_i32$2;
     $2499$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 30 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $2501 = i64toi32_i32$2;
     $2501$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $2499$hi;
     i64toi32_i32$1 = $2499;
     i64toi32_i32$2 = $2501$hi;
     i64toi32_i32$3 = $2501;
     i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
     $2502 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $2502$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($7 | 0, i64toi32_i32$2 | 0, 25 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $2504 = i64toi32_i32$1;
     $2504$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2502$hi;
     i64toi32_i32$5 = $2502;
     i64toi32_i32$1 = $2504$hi;
     i64toi32_i32$3 = $2504;
     i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
     $2505 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $2505$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$2 = $6;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $2509 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $2509$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$1 = $7;
     i64toi32_i32$2 = $2509$hi;
     i64toi32_i32$3 = $2509;
     i64toi32_i32$2 = i64toi32_i32$5 & i64toi32_i32$2 | 0;
     $2510 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $2510$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$5 = $6;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
     $2513 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $2513$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $2510$hi;
     i64toi32_i32$2 = $2510;
     i64toi32_i32$5 = $2513$hi;
     i64toi32_i32$3 = $2513;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $2514 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $2514$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $2505$hi;
     i64toi32_i32$1 = $2505;
     i64toi32_i32$2 = $2514$hi;
     i64toi32_i32$3 = $2514;
     i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $2515$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $26$hi;
     i64toi32_i32$4 = $2515$hi;
     i64toi32_i32$5 = i64toi32_i32$0;
     i64toi32_i32$1 = $26$hi;
     i64toi32_i32$3 = $26;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $13 = i64toi32_i32$2;
     $13$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $2497$hi;
     i64toi32_i32$4 = $2497;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$3 = i64toi32_i32$2;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $24 = i64toi32_i32$1;
     $24$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $603$hi;
     i64toi32_i32$0 = $603;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$3 = i64toi32_i32$1;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $2521 = i64toi32_i32$5;
     $2521$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $51$hi;
     i64toi32_i32$1 = $19$hi;
     i64toi32_i32$1 = $51$hi;
     i64toi32_i32$2 = $51;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $2524 = i64toi32_i32$4;
     $2524$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $52$hi;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$5 = $52$hi;
     i64toi32_i32$1 = $52;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $2527 = i64toi32_i32$0;
     $2527$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $49$hi;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$4 = $49$hi;
     i64toi32_i32$5 = $49;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $2530$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$4 = $19;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$5 = i64toi32_i32$0 ^ i64toi32_i32$5 | 0;
     $2534 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $2534$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $24$hi;
     i64toi32_i32$0 = $24;
     i64toi32_i32$4 = $2534$hi;
     i64toi32_i32$3 = $2534;
     i64toi32_i32$4 = i64toi32_i32$5 & i64toi32_i32$4 | 0;
     $2535$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$4 = $2535$hi;
     i64toi32_i32$5 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $2537 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $2537$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $2530$hi;
     i64toi32_i32$4 = i64toi32_i32$2;
     i64toi32_i32$5 = $2537$hi;
     i64toi32_i32$3 = $2537;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $2538$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($24 | 0, i64toi32_i32$2 | 0, 50 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $2540 = i64toi32_i32$4;
     $2540$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($24 | 0, i64toi32_i32$2 | 0, 46 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $2542 = i64toi32_i32$4;
     $2542$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2540$hi;
     i64toi32_i32$0 = $2540;
     i64toi32_i32$4 = $2542$hi;
     i64toi32_i32$3 = $2542;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $2543 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $2543$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($24 | 0, i64toi32_i32$4 | 0, 23 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $2545 = i64toi32_i32$0;
     $2545$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2543$hi;
     i64toi32_i32$2 = $2543;
     i64toi32_i32$0 = $2545$hi;
     i64toi32_i32$3 = $2545;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $2546 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $2546$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $2538$hi;
     i64toi32_i32$4 = i64toi32_i32$1;
     i64toi32_i32$2 = $2546$hi;
     i64toi32_i32$3 = $2546;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     i64toi32_i32$0 = i64toi32_i32$5;
     i64toi32_i32$4 = -694614492;
     i64toi32_i32$3 = 1432725776;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $26 = i64toi32_i32$2;
     $26$hi = i64toi32_i32$5;
     $2549 = i64toi32_i32$2;
     $2549$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($13 | 0, i64toi32_i32$5 | 0, 36 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $2551 = i64toi32_i32$0;
     $2551$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($13 | 0, i64toi32_i32$5 | 0, 30 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $2553 = i64toi32_i32$0;
     $2553$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $2551$hi;
     i64toi32_i32$1 = $2551;
     i64toi32_i32$0 = $2553$hi;
     i64toi32_i32$3 = $2553;
     i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
     $2554 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $2554$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($13 | 0, i64toi32_i32$0 | 0, 25 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $2556 = i64toi32_i32$1;
     $2556$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $2554$hi;
     i64toi32_i32$5 = $2554;
     i64toi32_i32$1 = $2556$hi;
     i64toi32_i32$3 = $2556;
     i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
     $2557 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $2557$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$0 = $7;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $2561 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $2561$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$1 = $13;
     i64toi32_i32$0 = $2561$hi;
     i64toi32_i32$3 = $2561;
     i64toi32_i32$0 = i64toi32_i32$5 & i64toi32_i32$0 | 0;
     $2562 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $2562$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$5 = $7;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
     $2565 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $2565$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $2562$hi;
     i64toi32_i32$0 = $2562;
     i64toi32_i32$5 = $2565$hi;
     i64toi32_i32$3 = $2565;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $2566 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $2566$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $2557$hi;
     i64toi32_i32$1 = $2557;
     i64toi32_i32$0 = $2566$hi;
     i64toi32_i32$3 = $2566;
     i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $2567$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $28$hi;
     i64toi32_i32$2 = $2567$hi;
     i64toi32_i32$5 = i64toi32_i32$4;
     i64toi32_i32$1 = $28$hi;
     i64toi32_i32$3 = $28;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $6 = i64toi32_i32$0;
     $6$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2549$hi;
     i64toi32_i32$2 = $2549;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$3 = i64toi32_i32$0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $12 = i64toi32_i32$1;
     $12$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$4 = $24;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $2575 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $2575$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$0 = i64toi32_i32$1;
     i64toi32_i32$4 = $2575$hi;
     i64toi32_i32$3 = $2575;
     i64toi32_i32$4 = i64toi32_i32$2 & i64toi32_i32$4 | 0;
     $2576$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$4 = $2576$hi;
     i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $2578 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $2578$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $2527$hi;
     i64toi32_i32$4 = $2527;
     i64toi32_i32$2 = $2578$hi;
     i64toi32_i32$3 = $2578;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $2579$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($12 | 0, i64toi32_i32$1 | 0, 50 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $2581 = i64toi32_i32$4;
     $2581$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($12 | 0, i64toi32_i32$1 | 0, 46 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $2583 = i64toi32_i32$4;
     $2583$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $2581$hi;
     i64toi32_i32$0 = $2581;
     i64toi32_i32$4 = $2583$hi;
     i64toi32_i32$3 = $2583;
     i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
     $2584 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $2584$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($12 | 0, i64toi32_i32$4 | 0, 23 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $2586 = i64toi32_i32$0;
     $2586$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2584$hi;
     i64toi32_i32$1 = $2584;
     i64toi32_i32$0 = $2586$hi;
     i64toi32_i32$3 = $2586;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $2587 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $2587$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $2579$hi;
     i64toi32_i32$4 = i64toi32_i32$5;
     i64toi32_i32$1 = $2587$hi;
     i64toi32_i32$3 = $2587;
     i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     i64toi32_i32$0 = i64toi32_i32$2;
     i64toi32_i32$4 = -200395387;
     i64toi32_i32$3 = 1467031594;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $28 = i64toi32_i32$1;
     $28$hi = i64toi32_i32$2;
     $2590 = i64toi32_i32$1;
     $2590$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($6 | 0, i64toi32_i32$2 | 0, 36 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $2592 = i64toi32_i32$0;
     $2592$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($6 | 0, i64toi32_i32$2 | 0, 30 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $2594 = i64toi32_i32$0;
     $2594$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2592$hi;
     i64toi32_i32$5 = $2592;
     i64toi32_i32$0 = $2594$hi;
     i64toi32_i32$3 = $2594;
     i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
     $2595 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $2595$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$5 = 0;
     i64toi32_i32$5 = __wasm_rotl_i64($6 | 0, i64toi32_i32$0 | 0, 25 | 0, i64toi32_i32$5 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $2597 = i64toi32_i32$5;
     $2597$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $2595$hi;
     i64toi32_i32$2 = $2595;
     i64toi32_i32$5 = $2597$hi;
     i64toi32_i32$3 = $2597;
     i64toi32_i32$5 = i64toi32_i32$0 ^ i64toi32_i32$5 | 0;
     $2598 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $2598$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$0 = $13;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
     $2602 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $2602$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$5 = $6;
     i64toi32_i32$0 = $2602$hi;
     i64toi32_i32$3 = $2602;
     i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
     $2603 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $2603$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$2 = $13;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$5 = i64toi32_i32$0 & i64toi32_i32$5 | 0;
     $2606 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     $2606$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $2603$hi;
     i64toi32_i32$0 = $2603;
     i64toi32_i32$2 = $2606$hi;
     i64toi32_i32$3 = $2606;
     i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
     $2607 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $2607$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2598$hi;
     i64toi32_i32$5 = $2598;
     i64toi32_i32$0 = $2607$hi;
     i64toi32_i32$3 = $2607;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $2608$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $22$hi;
     i64toi32_i32$1 = $2608$hi;
     i64toi32_i32$2 = i64toi32_i32$4;
     i64toi32_i32$5 = $22$hi;
     i64toi32_i32$3 = $22;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $7 = i64toi32_i32$0;
     $7$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2590$hi;
     i64toi32_i32$1 = $2590;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$3 = i64toi32_i32$0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $89 = i64toi32_i32$5;
     $89$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$4 = $12;
     i64toi32_i32$1 = $24$hi;
     i64toi32_i32$3 = $24;
     i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
     $2616 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $2616$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $89$hi;
     i64toi32_i32$0 = i64toi32_i32$5;
     i64toi32_i32$4 = $2616$hi;
     i64toi32_i32$3 = $2616;
     i64toi32_i32$4 = i64toi32_i32$1 & i64toi32_i32$4 | 0;
     $2617$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$4 = $2617$hi;
     i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$3 = $24;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $2619 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $2619$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $2524$hi;
     i64toi32_i32$4 = $2524;
     i64toi32_i32$1 = $2619$hi;
     i64toi32_i32$3 = $2619;
     i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $2620$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($89 | 0, i64toi32_i32$5 | 0, 50 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $2622 = i64toi32_i32$4;
     $2622$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($89 | 0, i64toi32_i32$5 | 0, 46 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $2624 = i64toi32_i32$4;
     $2624$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $2622$hi;
     i64toi32_i32$0 = $2622;
     i64toi32_i32$4 = $2624$hi;
     i64toi32_i32$3 = $2624;
     i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
     $2625 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $2625$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($89 | 0, i64toi32_i32$4 | 0, 23 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $2627 = i64toi32_i32$0;
     $2627$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2625$hi;
     i64toi32_i32$5 = $2625;
     i64toi32_i32$0 = $2627$hi;
     i64toi32_i32$3 = $2627;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $2628 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $2628$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $2620$hi;
     i64toi32_i32$4 = i64toi32_i32$2;
     i64toi32_i32$5 = $2628$hi;
     i64toi32_i32$3 = $2628;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     i64toi32_i32$0 = i64toi32_i32$1;
     i64toi32_i32$4 = 275423344;
     i64toi32_i32$3 = 851169720;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $22 = i64toi32_i32$5;
     $22$hi = i64toi32_i32$1;
     $2631 = i64toi32_i32$5;
     $2631$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($7 | 0, i64toi32_i32$1 | 0, 36 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $2633 = i64toi32_i32$0;
     $2633$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($7 | 0, i64toi32_i32$1 | 0, 30 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $2635 = i64toi32_i32$0;
     $2635$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $2633$hi;
     i64toi32_i32$2 = $2633;
     i64toi32_i32$0 = $2635$hi;
     i64toi32_i32$3 = $2635;
     i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
     $2636 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $2636$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 25 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $2638 = i64toi32_i32$2;
     $2638$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $2636$hi;
     i64toi32_i32$1 = $2636;
     i64toi32_i32$2 = $2638$hi;
     i64toi32_i32$3 = $2638;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $2639 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $2639$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$0 = $6;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
     $2643 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $2643$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$2 = $7;
     i64toi32_i32$0 = $2643$hi;
     i64toi32_i32$3 = $2643;
     i64toi32_i32$0 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
     $2644 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     $2644$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$1 = $6;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
     $2647 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $2647$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2644$hi;
     i64toi32_i32$0 = $2644;
     i64toi32_i32$1 = $2647$hi;
     i64toi32_i32$3 = $2647;
     i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
     $2648 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $2648$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $2639$hi;
     i64toi32_i32$2 = $2639;
     i64toi32_i32$0 = $2648$hi;
     i64toi32_i32$3 = $2648;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $2649$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $11$hi;
     i64toi32_i32$5 = $2649$hi;
     i64toi32_i32$1 = i64toi32_i32$4;
     i64toi32_i32$2 = $11$hi;
     i64toi32_i32$3 = $11;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $13 = i64toi32_i32$0;
     $13$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2631$hi;
     i64toi32_i32$5 = $2631;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$3 = i64toi32_i32$0;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $19 = i64toi32_i32$2;
     $19$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$4 = $89;
     i64toi32_i32$5 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$5 = i64toi32_i32$0 ^ i64toi32_i32$5 | 0;
     $2657 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $2657$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $19$hi;
     i64toi32_i32$0 = i64toi32_i32$2;
     i64toi32_i32$4 = $2657$hi;
     i64toi32_i32$3 = $2657;
     i64toi32_i32$4 = i64toi32_i32$5 & i64toi32_i32$4 | 0;
     $2658$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$4 = $2658$hi;
     i64toi32_i32$5 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $2660 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $2660$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $2521$hi;
     i64toi32_i32$4 = $2521;
     i64toi32_i32$5 = $2660$hi;
     i64toi32_i32$3 = $2660;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $2661$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($19 | 0, i64toi32_i32$2 | 0, 50 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $2663 = i64toi32_i32$4;
     $2663$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($19 | 0, i64toi32_i32$2 | 0, 46 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $2665 = i64toi32_i32$4;
     $2665$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2663$hi;
     i64toi32_i32$0 = $2663;
     i64toi32_i32$4 = $2665$hi;
     i64toi32_i32$3 = $2665;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $2666 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $2666$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($19 | 0, i64toi32_i32$4 | 0, 23 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $2668 = i64toi32_i32$0;
     $2668$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2666$hi;
     i64toi32_i32$2 = $2666;
     i64toi32_i32$0 = $2668$hi;
     i64toi32_i32$3 = $2668;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $2669 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $2669$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $2661$hi;
     i64toi32_i32$4 = i64toi32_i32$1;
     i64toi32_i32$2 = $2669$hi;
     i64toi32_i32$3 = $2669;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     i64toi32_i32$0 = i64toi32_i32$5;
     i64toi32_i32$4 = 430227734;
     i64toi32_i32$3 = -1194143544;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $11 = i64toi32_i32$2;
     $11$hi = i64toi32_i32$5;
     $2672 = i64toi32_i32$2;
     $2672$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($13 | 0, i64toi32_i32$5 | 0, 36 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $2674 = i64toi32_i32$0;
     $2674$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($13 | 0, i64toi32_i32$5 | 0, 30 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $2676 = i64toi32_i32$0;
     $2676$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $2674$hi;
     i64toi32_i32$1 = $2674;
     i64toi32_i32$0 = $2676$hi;
     i64toi32_i32$3 = $2676;
     i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
     $2677 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $2677$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($13 | 0, i64toi32_i32$0 | 0, 25 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $2679 = i64toi32_i32$1;
     $2679$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $2677$hi;
     i64toi32_i32$5 = $2677;
     i64toi32_i32$1 = $2679$hi;
     i64toi32_i32$3 = $2679;
     i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
     $2680 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $2680$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$0 = $7;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $2684 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $2684$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$1 = $13;
     i64toi32_i32$0 = $2684$hi;
     i64toi32_i32$3 = $2684;
     i64toi32_i32$0 = i64toi32_i32$5 & i64toi32_i32$0 | 0;
     $2685 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $2685$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$5 = $7;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
     $2688 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $2688$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $2685$hi;
     i64toi32_i32$0 = $2685;
     i64toi32_i32$5 = $2688$hi;
     i64toi32_i32$3 = $2688;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $2689 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $2689$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $2680$hi;
     i64toi32_i32$1 = $2680;
     i64toi32_i32$0 = $2689$hi;
     i64toi32_i32$3 = $2689;
     i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $2690$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $17$hi;
     i64toi32_i32$2 = $2690$hi;
     i64toi32_i32$5 = i64toi32_i32$4;
     i64toi32_i32$1 = $17$hi;
     i64toi32_i32$3 = $17;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $6 = i64toi32_i32$0;
     $6$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2672$hi;
     i64toi32_i32$2 = $2672;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$3 = i64toi32_i32$0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $24 = i64toi32_i32$1;
     $24$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $602$hi;
     i64toi32_i32$4 = $602;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$3 = i64toi32_i32$1;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $2696 = i64toi32_i32$5;
     $2696$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $55$hi;
     i64toi32_i32$1 = $19$hi;
     i64toi32_i32$1 = $55$hi;
     i64toi32_i32$0 = $55;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $2699 = i64toi32_i32$2;
     $2699$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $56$hi;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$5 = $56$hi;
     i64toi32_i32$1 = $56;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $2702 = i64toi32_i32$4;
     $2702$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $53$hi;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$2 = $53$hi;
     i64toi32_i32$5 = $53;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $2705$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$2 = $19;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
     $2709 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $2709$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $24$hi;
     i64toi32_i32$4 = $24;
     i64toi32_i32$2 = $2709$hi;
     i64toi32_i32$3 = $2709;
     i64toi32_i32$2 = i64toi32_i32$5 & i64toi32_i32$2 | 0;
     $2710$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$2 = $2710$hi;
     i64toi32_i32$5 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $2712 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $2712$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2705$hi;
     i64toi32_i32$2 = i64toi32_i32$0;
     i64toi32_i32$5 = $2712$hi;
     i64toi32_i32$3 = $2712;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $2713$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($24 | 0, i64toi32_i32$0 | 0, 50 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $2715 = i64toi32_i32$2;
     $2715$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($24 | 0, i64toi32_i32$0 | 0, 46 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $2717 = i64toi32_i32$2;
     $2717$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $2715$hi;
     i64toi32_i32$4 = $2715;
     i64toi32_i32$2 = $2717$hi;
     i64toi32_i32$3 = $2717;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $2718 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $2718$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($24 | 0, i64toi32_i32$2 | 0, 23 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $2720 = i64toi32_i32$4;
     $2720$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2718$hi;
     i64toi32_i32$0 = $2718;
     i64toi32_i32$4 = $2720$hi;
     i64toi32_i32$3 = $2720;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $2721 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $2721$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2713$hi;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$0 = $2721$hi;
     i64toi32_i32$3 = $2721;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     i64toi32_i32$4 = i64toi32_i32$5;
     i64toi32_i32$2 = 506948616;
     i64toi32_i32$3 = 1363258195;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $17 = i64toi32_i32$0;
     $17$hi = i64toi32_i32$5;
     $2724 = i64toi32_i32$0;
     $2724$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($6 | 0, i64toi32_i32$5 | 0, 36 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $2726 = i64toi32_i32$4;
     $2726$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($6 | 0, i64toi32_i32$5 | 0, 30 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $2728 = i64toi32_i32$4;
     $2728$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $2726$hi;
     i64toi32_i32$1 = $2726;
     i64toi32_i32$4 = $2728$hi;
     i64toi32_i32$3 = $2728;
     i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
     $2729 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $2729$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($6 | 0, i64toi32_i32$4 | 0, 25 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $2731 = i64toi32_i32$1;
     $2731$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2729$hi;
     i64toi32_i32$5 = $2729;
     i64toi32_i32$1 = $2731$hi;
     i64toi32_i32$3 = $2731;
     i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
     $2732 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $2732$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$4 = $13;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $2736 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $2736$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$1 = $6;
     i64toi32_i32$4 = $2736$hi;
     i64toi32_i32$3 = $2736;
     i64toi32_i32$4 = i64toi32_i32$5 & i64toi32_i32$4 | 0;
     $2737 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $2737$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$5 = $13;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$1 = i64toi32_i32$4 & i64toi32_i32$1 | 0;
     $2740 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $2740$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $2737$hi;
     i64toi32_i32$4 = $2737;
     i64toi32_i32$5 = $2740$hi;
     i64toi32_i32$3 = $2740;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $2741 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $2741$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $2732$hi;
     i64toi32_i32$1 = $2732;
     i64toi32_i32$4 = $2741$hi;
     i64toi32_i32$3 = $2741;
     i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $2742$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $26$hi;
     i64toi32_i32$0 = $2742$hi;
     i64toi32_i32$5 = i64toi32_i32$2;
     i64toi32_i32$1 = $26$hi;
     i64toi32_i32$3 = $26;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $7 = i64toi32_i32$4;
     $7$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2724$hi;
     i64toi32_i32$0 = $2724;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$3 = i64toi32_i32$4;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $12 = i64toi32_i32$1;
     $12$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$2 = $24;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $2750 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $2750$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$4 = i64toi32_i32$1;
     i64toi32_i32$2 = $2750$hi;
     i64toi32_i32$3 = $2750;
     i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
     $2751$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$2 = $2751$hi;
     i64toi32_i32$0 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $2753 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $2753$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2702$hi;
     i64toi32_i32$2 = $2702;
     i64toi32_i32$0 = $2753$hi;
     i64toi32_i32$3 = $2753;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $2754$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($12 | 0, i64toi32_i32$1 | 0, 50 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $2756 = i64toi32_i32$2;
     $2756$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($12 | 0, i64toi32_i32$1 | 0, 46 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $2758 = i64toi32_i32$2;
     $2758$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $2756$hi;
     i64toi32_i32$4 = $2756;
     i64toi32_i32$2 = $2758$hi;
     i64toi32_i32$3 = $2758;
     i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
     $2759 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $2759$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($12 | 0, i64toi32_i32$2 | 0, 23 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $2761 = i64toi32_i32$4;
     $2761$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2759$hi;
     i64toi32_i32$1 = $2759;
     i64toi32_i32$4 = $2761$hi;
     i64toi32_i32$3 = $2761;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $2762 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $2762$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2754$hi;
     i64toi32_i32$2 = i64toi32_i32$5;
     i64toi32_i32$1 = $2762$hi;
     i64toi32_i32$3 = $2762;
     i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     i64toi32_i32$4 = i64toi32_i32$0;
     i64toi32_i32$2 = 659060556;
     i64toi32_i32$3 = -544281703;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $26 = i64toi32_i32$1;
     $26$hi = i64toi32_i32$0;
     $2765 = i64toi32_i32$1;
     $2765$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 36 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $2767 = i64toi32_i32$4;
     $2767$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 30 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $2769 = i64toi32_i32$4;
     $2769$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $2767$hi;
     i64toi32_i32$5 = $2767;
     i64toi32_i32$4 = $2769$hi;
     i64toi32_i32$3 = $2769;
     i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
     $2770 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $2770$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$5 = 0;
     i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 25 | 0, i64toi32_i32$5 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $2772 = i64toi32_i32$5;
     $2772$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2770$hi;
     i64toi32_i32$0 = $2770;
     i64toi32_i32$5 = $2772$hi;
     i64toi32_i32$3 = $2772;
     i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
     $2773 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $2773$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$4 = $6;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
     $2777 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $2777$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$5 = $7;
     i64toi32_i32$4 = $2777$hi;
     i64toi32_i32$3 = $2777;
     i64toi32_i32$4 = i64toi32_i32$0 & i64toi32_i32$4 | 0;
     $2778 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $2778$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$0 = $6;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$5 = i64toi32_i32$4 & i64toi32_i32$5 | 0;
     $2781 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
     $2781$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $2778$hi;
     i64toi32_i32$4 = $2778;
     i64toi32_i32$0 = $2781$hi;
     i64toi32_i32$3 = $2781;
     i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
     $2782 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $2782$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $2773$hi;
     i64toi32_i32$5 = $2773;
     i64toi32_i32$4 = $2782$hi;
     i64toi32_i32$3 = $2782;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $2783$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $28$hi;
     i64toi32_i32$1 = $2783$hi;
     i64toi32_i32$0 = i64toi32_i32$2;
     i64toi32_i32$5 = $28$hi;
     i64toi32_i32$3 = $28;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $13 = i64toi32_i32$4;
     $13$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2765$hi;
     i64toi32_i32$1 = $2765;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$3 = i64toi32_i32$4;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $89 = i64toi32_i32$5;
     $89$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$2 = $12;
     i64toi32_i32$1 = $24$hi;
     i64toi32_i32$3 = $24;
     i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
     $2791 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $2791$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $89$hi;
     i64toi32_i32$4 = i64toi32_i32$5;
     i64toi32_i32$2 = $2791$hi;
     i64toi32_i32$3 = $2791;
     i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
     $2792$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$2 = $2792$hi;
     i64toi32_i32$1 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$3 = $24;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $2794 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $2794$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2699$hi;
     i64toi32_i32$2 = $2699;
     i64toi32_i32$1 = $2794$hi;
     i64toi32_i32$3 = $2794;
     i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $2795$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($89 | 0, i64toi32_i32$5 | 0, 50 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $2797 = i64toi32_i32$2;
     $2797$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($89 | 0, i64toi32_i32$5 | 0, 46 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $2799 = i64toi32_i32$2;
     $2799$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $2797$hi;
     i64toi32_i32$4 = $2797;
     i64toi32_i32$2 = $2799$hi;
     i64toi32_i32$3 = $2799;
     i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
     $2800 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $2800$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($89 | 0, i64toi32_i32$2 | 0, 23 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $2802 = i64toi32_i32$4;
     $2802$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2800$hi;
     i64toi32_i32$5 = $2800;
     i64toi32_i32$4 = $2802$hi;
     i64toi32_i32$3 = $2802;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $2803 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $2803$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2795$hi;
     i64toi32_i32$2 = i64toi32_i32$0;
     i64toi32_i32$5 = $2803$hi;
     i64toi32_i32$3 = $2803;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     i64toi32_i32$4 = i64toi32_i32$1;
     i64toi32_i32$2 = 883997877;
     i64toi32_i32$3 = -509917016;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $28 = i64toi32_i32$5;
     $28$hi = i64toi32_i32$1;
     $2806 = i64toi32_i32$5;
     $2806$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($13 | 0, i64toi32_i32$1 | 0, 36 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $2808 = i64toi32_i32$4;
     $2808$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($13 | 0, i64toi32_i32$1 | 0, 30 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $2810 = i64toi32_i32$4;
     $2810$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $2808$hi;
     i64toi32_i32$0 = $2808;
     i64toi32_i32$4 = $2810$hi;
     i64toi32_i32$3 = $2810;
     i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
     $2811 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $2811$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($13 | 0, i64toi32_i32$4 | 0, 25 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $2813 = i64toi32_i32$0;
     $2813$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2811$hi;
     i64toi32_i32$1 = $2811;
     i64toi32_i32$0 = $2813$hi;
     i64toi32_i32$3 = $2813;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $2814 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $2814$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$4 = $7;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
     $2818 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $2818$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$0 = $13;
     i64toi32_i32$4 = $2818$hi;
     i64toi32_i32$3 = $2818;
     i64toi32_i32$4 = i64toi32_i32$1 & i64toi32_i32$4 | 0;
     $2819 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
     $2819$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$1 = $7;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$0 = i64toi32_i32$4 & i64toi32_i32$0 | 0;
     $2822 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $2822$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $2819$hi;
     i64toi32_i32$4 = $2819;
     i64toi32_i32$1 = $2822$hi;
     i64toi32_i32$3 = $2822;
     i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
     $2823 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $2823$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $2814$hi;
     i64toi32_i32$0 = $2814;
     i64toi32_i32$4 = $2823$hi;
     i64toi32_i32$3 = $2823;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $2824$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $22$hi;
     i64toi32_i32$5 = $2824$hi;
     i64toi32_i32$1 = i64toi32_i32$2;
     i64toi32_i32$0 = $22$hi;
     i64toi32_i32$3 = $22;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $6 = i64toi32_i32$4;
     $6$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2806$hi;
     i64toi32_i32$5 = $2806;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$3 = i64toi32_i32$4;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $19 = i64toi32_i32$0;
     $19$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$2 = $89;
     i64toi32_i32$5 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
     $2832 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $2832$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $19$hi;
     i64toi32_i32$4 = i64toi32_i32$0;
     i64toi32_i32$2 = $2832$hi;
     i64toi32_i32$3 = $2832;
     i64toi32_i32$2 = i64toi32_i32$5 & i64toi32_i32$2 | 0;
     $2833$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$2 = $2833$hi;
     i64toi32_i32$5 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $2835 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $2835$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2696$hi;
     i64toi32_i32$2 = $2696;
     i64toi32_i32$5 = $2835$hi;
     i64toi32_i32$3 = $2835;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $2836$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($19 | 0, i64toi32_i32$0 | 0, 50 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $2838 = i64toi32_i32$2;
     $2838$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($19 | 0, i64toi32_i32$0 | 0, 46 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $2840 = i64toi32_i32$2;
     $2840$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $2838$hi;
     i64toi32_i32$4 = $2838;
     i64toi32_i32$2 = $2840$hi;
     i64toi32_i32$3 = $2840;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $2841 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $2841$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($19 | 0, i64toi32_i32$2 | 0, 23 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $2843 = i64toi32_i32$4;
     $2843$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2841$hi;
     i64toi32_i32$0 = $2841;
     i64toi32_i32$4 = $2843$hi;
     i64toi32_i32$3 = $2843;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $2844 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $2844$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2836$hi;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$0 = $2844$hi;
     i64toi32_i32$3 = $2844;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     i64toi32_i32$4 = i64toi32_i32$5;
     i64toi32_i32$2 = 958139571;
     i64toi32_i32$3 = -976659869;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $22 = i64toi32_i32$0;
     $22$hi = i64toi32_i32$5;
     $2847 = i64toi32_i32$0;
     $2847$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($6 | 0, i64toi32_i32$5 | 0, 36 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $2849 = i64toi32_i32$4;
     $2849$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($6 | 0, i64toi32_i32$5 | 0, 30 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $2851 = i64toi32_i32$4;
     $2851$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $2849$hi;
     i64toi32_i32$1 = $2849;
     i64toi32_i32$4 = $2851$hi;
     i64toi32_i32$3 = $2851;
     i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
     $2852 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $2852$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($6 | 0, i64toi32_i32$4 | 0, 25 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $2854 = i64toi32_i32$1;
     $2854$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2852$hi;
     i64toi32_i32$5 = $2852;
     i64toi32_i32$1 = $2854$hi;
     i64toi32_i32$3 = $2854;
     i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
     $2855 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $2855$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$4 = $13;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $2859 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $2859$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$1 = $6;
     i64toi32_i32$4 = $2859$hi;
     i64toi32_i32$3 = $2859;
     i64toi32_i32$4 = i64toi32_i32$5 & i64toi32_i32$4 | 0;
     $2860 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $2860$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$5 = $13;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$1 = i64toi32_i32$4 & i64toi32_i32$1 | 0;
     $2863 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $2863$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $2860$hi;
     i64toi32_i32$4 = $2860;
     i64toi32_i32$5 = $2863$hi;
     i64toi32_i32$3 = $2863;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $2864 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $2864$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $2855$hi;
     i64toi32_i32$1 = $2855;
     i64toi32_i32$4 = $2864$hi;
     i64toi32_i32$3 = $2864;
     i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $2865$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $11$hi;
     i64toi32_i32$0 = $2865$hi;
     i64toi32_i32$5 = i64toi32_i32$2;
     i64toi32_i32$1 = $11$hi;
     i64toi32_i32$3 = $11;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $7 = i64toi32_i32$4;
     $7$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2847$hi;
     i64toi32_i32$0 = $2847;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$3 = i64toi32_i32$4;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $24 = i64toi32_i32$1;
     $24$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $601$hi;
     i64toi32_i32$2 = $601;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$3 = i64toi32_i32$1;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $2871 = i64toi32_i32$5;
     $2871$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $59$hi;
     i64toi32_i32$1 = $19$hi;
     i64toi32_i32$1 = $59$hi;
     i64toi32_i32$4 = $59;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $2874 = i64toi32_i32$0;
     $2874$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $60$hi;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$5 = $60$hi;
     i64toi32_i32$1 = $60;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $2877 = i64toi32_i32$2;
     $2877$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $57$hi;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$0 = $57$hi;
     i64toi32_i32$5 = $57;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $2880$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$0 = $19;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
     $2884 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $2884$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $24$hi;
     i64toi32_i32$2 = $24;
     i64toi32_i32$0 = $2884$hi;
     i64toi32_i32$3 = $2884;
     i64toi32_i32$0 = i64toi32_i32$5 & i64toi32_i32$0 | 0;
     $2885$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$0 = $2885$hi;
     i64toi32_i32$5 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $2887 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $2887$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2880$hi;
     i64toi32_i32$0 = i64toi32_i32$4;
     i64toi32_i32$5 = $2887$hi;
     i64toi32_i32$3 = $2887;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $2888$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($24 | 0, i64toi32_i32$4 | 0, 50 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $2890 = i64toi32_i32$0;
     $2890$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($24 | 0, i64toi32_i32$4 | 0, 46 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $2892 = i64toi32_i32$0;
     $2892$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2890$hi;
     i64toi32_i32$2 = $2890;
     i64toi32_i32$0 = $2892$hi;
     i64toi32_i32$3 = $2892;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $2893 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $2893$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($24 | 0, i64toi32_i32$0 | 0, 23 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $2895 = i64toi32_i32$2;
     $2895$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $2893$hi;
     i64toi32_i32$4 = $2893;
     i64toi32_i32$2 = $2895$hi;
     i64toi32_i32$3 = $2895;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $2896 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $2896$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2888$hi;
     i64toi32_i32$0 = i64toi32_i32$1;
     i64toi32_i32$4 = $2896$hi;
     i64toi32_i32$3 = $2896;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     i64toi32_i32$2 = i64toi32_i32$5;
     i64toi32_i32$0 = 1322822218;
     i64toi32_i32$3 = -482243893;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $11 = i64toi32_i32$4;
     $11$hi = i64toi32_i32$5;
     $2899 = i64toi32_i32$4;
     $2899$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 36 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $2901 = i64toi32_i32$2;
     $2901$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 30 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $2903 = i64toi32_i32$2;
     $2903$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $2901$hi;
     i64toi32_i32$1 = $2901;
     i64toi32_i32$2 = $2903$hi;
     i64toi32_i32$3 = $2903;
     i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
     $2904 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $2904$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($7 | 0, i64toi32_i32$2 | 0, 25 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $2906 = i64toi32_i32$1;
     $2906$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2904$hi;
     i64toi32_i32$5 = $2904;
     i64toi32_i32$1 = $2906$hi;
     i64toi32_i32$3 = $2906;
     i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
     $2907 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $2907$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$2 = $6;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $2911 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $2911$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$1 = $7;
     i64toi32_i32$2 = $2911$hi;
     i64toi32_i32$3 = $2911;
     i64toi32_i32$2 = i64toi32_i32$5 & i64toi32_i32$2 | 0;
     $2912 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $2912$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$5 = $6;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
     $2915 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $2915$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $2912$hi;
     i64toi32_i32$2 = $2912;
     i64toi32_i32$5 = $2915$hi;
     i64toi32_i32$3 = $2915;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $2916 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $2916$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $2907$hi;
     i64toi32_i32$1 = $2907;
     i64toi32_i32$2 = $2916$hi;
     i64toi32_i32$3 = $2916;
     i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $2917$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $17$hi;
     i64toi32_i32$4 = $2917$hi;
     i64toi32_i32$5 = i64toi32_i32$0;
     i64toi32_i32$1 = $17$hi;
     i64toi32_i32$3 = $17;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $13 = i64toi32_i32$2;
     $13$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $2899$hi;
     i64toi32_i32$4 = $2899;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$3 = i64toi32_i32$2;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $12 = i64toi32_i32$1;
     $12$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$0 = $24;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $2925 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $2925$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$0 = $2925$hi;
     i64toi32_i32$3 = $2925;
     i64toi32_i32$0 = i64toi32_i32$4 & i64toi32_i32$0 | 0;
     $2926$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$0 = $2926$hi;
     i64toi32_i32$4 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $2928 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $2928$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2877$hi;
     i64toi32_i32$0 = $2877;
     i64toi32_i32$4 = $2928$hi;
     i64toi32_i32$3 = $2928;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $2929$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($12 | 0, i64toi32_i32$1 | 0, 50 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $2931 = i64toi32_i32$0;
     $2931$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($12 | 0, i64toi32_i32$1 | 0, 46 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $2933 = i64toi32_i32$0;
     $2933$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $2931$hi;
     i64toi32_i32$2 = $2931;
     i64toi32_i32$0 = $2933$hi;
     i64toi32_i32$3 = $2933;
     i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
     $2934 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $2934$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($12 | 0, i64toi32_i32$0 | 0, 23 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $2936 = i64toi32_i32$2;
     $2936$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $2934$hi;
     i64toi32_i32$1 = $2934;
     i64toi32_i32$2 = $2936$hi;
     i64toi32_i32$3 = $2936;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $2937 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $2937$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2929$hi;
     i64toi32_i32$0 = i64toi32_i32$5;
     i64toi32_i32$1 = $2937$hi;
     i64toi32_i32$3 = $2937;
     i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     i64toi32_i32$2 = i64toi32_i32$4;
     i64toi32_i32$0 = 1537002063;
     i64toi32_i32$3 = 2003034995;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $17 = i64toi32_i32$1;
     $17$hi = i64toi32_i32$4;
     $2940 = i64toi32_i32$1;
     $2940$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($13 | 0, i64toi32_i32$4 | 0, 36 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $2942 = i64toi32_i32$2;
     $2942$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($13 | 0, i64toi32_i32$4 | 0, 30 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $2944 = i64toi32_i32$2;
     $2944$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2942$hi;
     i64toi32_i32$5 = $2942;
     i64toi32_i32$2 = $2944$hi;
     i64toi32_i32$3 = $2944;
     i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
     $2945 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $2945$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$5 = 0;
     i64toi32_i32$5 = __wasm_rotl_i64($13 | 0, i64toi32_i32$2 | 0, 25 | 0, i64toi32_i32$5 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $2947 = i64toi32_i32$5;
     $2947$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2945$hi;
     i64toi32_i32$4 = $2945;
     i64toi32_i32$5 = $2947$hi;
     i64toi32_i32$3 = $2947;
     i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
     $2948 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $2948$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$2 = $7;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
     $2952 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $2952$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$5 = $13;
     i64toi32_i32$2 = $2952$hi;
     i64toi32_i32$3 = $2952;
     i64toi32_i32$2 = i64toi32_i32$4 & i64toi32_i32$2 | 0;
     $2953 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $2953$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$4 = $7;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$5 = i64toi32_i32$2 & i64toi32_i32$5 | 0;
     $2956 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     $2956$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $2953$hi;
     i64toi32_i32$2 = $2953;
     i64toi32_i32$4 = $2956$hi;
     i64toi32_i32$3 = $2956;
     i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
     $2957 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $2957$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2948$hi;
     i64toi32_i32$5 = $2948;
     i64toi32_i32$2 = $2957$hi;
     i64toi32_i32$3 = $2957;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $2958$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $26$hi;
     i64toi32_i32$1 = $2958$hi;
     i64toi32_i32$4 = i64toi32_i32$0;
     i64toi32_i32$5 = $26$hi;
     i64toi32_i32$3 = $26;
     i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $6 = i64toi32_i32$2;
     $6$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $2940$hi;
     i64toi32_i32$1 = $2940;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$3 = i64toi32_i32$2;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $89 = i64toi32_i32$5;
     $89$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$0 = $12;
     i64toi32_i32$1 = $24$hi;
     i64toi32_i32$3 = $24;
     i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
     $2966 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $2966$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $89$hi;
     i64toi32_i32$2 = i64toi32_i32$5;
     i64toi32_i32$0 = $2966$hi;
     i64toi32_i32$3 = $2966;
     i64toi32_i32$0 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
     $2967$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$0 = $2967$hi;
     i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$3 = $24;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $2969 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $2969$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2874$hi;
     i64toi32_i32$0 = $2874;
     i64toi32_i32$1 = $2969$hi;
     i64toi32_i32$3 = $2969;
     i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $2970$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($89 | 0, i64toi32_i32$5 | 0, 50 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $2972 = i64toi32_i32$0;
     $2972$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($89 | 0, i64toi32_i32$5 | 0, 46 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $2974 = i64toi32_i32$0;
     $2974$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $2972$hi;
     i64toi32_i32$2 = $2972;
     i64toi32_i32$0 = $2974$hi;
     i64toi32_i32$3 = $2974;
     i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
     $2975 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $2975$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($89 | 0, i64toi32_i32$0 | 0, 23 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $2977 = i64toi32_i32$2;
     $2977$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $2975$hi;
     i64toi32_i32$5 = $2975;
     i64toi32_i32$2 = $2977$hi;
     i64toi32_i32$3 = $2977;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $2978 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $2978$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2970$hi;
     i64toi32_i32$0 = i64toi32_i32$4;
     i64toi32_i32$5 = $2978$hi;
     i64toi32_i32$3 = $2978;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$0 = 1747873779;
     i64toi32_i32$3 = -692930397;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $26 = i64toi32_i32$5;
     $26$hi = i64toi32_i32$1;
     $2981 = i64toi32_i32$5;
     $2981$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($6 | 0, i64toi32_i32$1 | 0, 36 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $2983 = i64toi32_i32$2;
     $2983$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($6 | 0, i64toi32_i32$1 | 0, 30 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $2985 = i64toi32_i32$2;
     $2985$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $2983$hi;
     i64toi32_i32$4 = $2983;
     i64toi32_i32$2 = $2985$hi;
     i64toi32_i32$3 = $2985;
     i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
     $2986 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $2986$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($6 | 0, i64toi32_i32$2 | 0, 25 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $2988 = i64toi32_i32$4;
     $2988$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2986$hi;
     i64toi32_i32$1 = $2986;
     i64toi32_i32$4 = $2988$hi;
     i64toi32_i32$3 = $2988;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $2989 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $2989$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$2 = $13;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
     $2993 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $2993$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$4 = $6;
     i64toi32_i32$2 = $2993$hi;
     i64toi32_i32$3 = $2993;
     i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
     $2994 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     $2994$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$1 = $13;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$4 = i64toi32_i32$2 & i64toi32_i32$4 | 0;
     $2997 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $2997$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $2994$hi;
     i64toi32_i32$2 = $2994;
     i64toi32_i32$1 = $2997$hi;
     i64toi32_i32$3 = $2997;
     i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
     $2998 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $2998$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $2989$hi;
     i64toi32_i32$4 = $2989;
     i64toi32_i32$2 = $2998$hi;
     i64toi32_i32$3 = $2998;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $2999$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $28$hi;
     i64toi32_i32$5 = $2999$hi;
     i64toi32_i32$1 = i64toi32_i32$0;
     i64toi32_i32$4 = $28$hi;
     i64toi32_i32$3 = $28;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $7 = i64toi32_i32$2;
     $7$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $2981$hi;
     i64toi32_i32$5 = $2981;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$3 = i64toi32_i32$2;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $19 = i64toi32_i32$4;
     $19$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$0 = $89;
     i64toi32_i32$5 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
     $3007 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $3007$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $19$hi;
     i64toi32_i32$2 = i64toi32_i32$4;
     i64toi32_i32$0 = $3007$hi;
     i64toi32_i32$3 = $3007;
     i64toi32_i32$0 = i64toi32_i32$5 & i64toi32_i32$0 | 0;
     $3008$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$0 = $3008$hi;
     i64toi32_i32$5 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $3010 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $3010$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $2871$hi;
     i64toi32_i32$0 = $2871;
     i64toi32_i32$5 = $3010$hi;
     i64toi32_i32$3 = $3010;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $3011$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($19 | 0, i64toi32_i32$4 | 0, 50 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $3013 = i64toi32_i32$0;
     $3013$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($19 | 0, i64toi32_i32$4 | 0, 46 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $3015 = i64toi32_i32$0;
     $3015$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3013$hi;
     i64toi32_i32$2 = $3013;
     i64toi32_i32$0 = $3015$hi;
     i64toi32_i32$3 = $3015;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $3016 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $3016$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($19 | 0, i64toi32_i32$0 | 0, 23 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $3018 = i64toi32_i32$2;
     $3018$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3016$hi;
     i64toi32_i32$4 = $3016;
     i64toi32_i32$2 = $3018$hi;
     i64toi32_i32$3 = $3018;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $3019 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $3019$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $3011$hi;
     i64toi32_i32$0 = i64toi32_i32$1;
     i64toi32_i32$4 = $3019$hi;
     i64toi32_i32$3 = $3019;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     i64toi32_i32$2 = i64toi32_i32$5;
     i64toi32_i32$0 = 1955562222;
     i64toi32_i32$3 = 1575990012;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $28 = i64toi32_i32$4;
     $28$hi = i64toi32_i32$5;
     $3022 = i64toi32_i32$4;
     $3022$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 36 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $3024 = i64toi32_i32$2;
     $3024$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 30 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $3026 = i64toi32_i32$2;
     $3026$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $3024$hi;
     i64toi32_i32$1 = $3024;
     i64toi32_i32$2 = $3026$hi;
     i64toi32_i32$3 = $3026;
     i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
     $3027 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $3027$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($7 | 0, i64toi32_i32$2 | 0, 25 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $3029 = i64toi32_i32$1;
     $3029$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $3027$hi;
     i64toi32_i32$5 = $3027;
     i64toi32_i32$1 = $3029$hi;
     i64toi32_i32$3 = $3029;
     i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
     $3030 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $3030$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$2 = $6;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $3034 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $3034$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$1 = $7;
     i64toi32_i32$2 = $3034$hi;
     i64toi32_i32$3 = $3034;
     i64toi32_i32$2 = i64toi32_i32$5 & i64toi32_i32$2 | 0;
     $3035 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $3035$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$5 = $6;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
     $3038 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $3038$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $3035$hi;
     i64toi32_i32$2 = $3035;
     i64toi32_i32$5 = $3038$hi;
     i64toi32_i32$3 = $3038;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $3039 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $3039$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $3030$hi;
     i64toi32_i32$1 = $3030;
     i64toi32_i32$2 = $3039$hi;
     i64toi32_i32$3 = $3039;
     i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $3040$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $22$hi;
     i64toi32_i32$4 = $3040$hi;
     i64toi32_i32$5 = i64toi32_i32$0;
     i64toi32_i32$1 = $22$hi;
     i64toi32_i32$3 = $22;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $13 = i64toi32_i32$2;
     $13$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3022$hi;
     i64toi32_i32$4 = $3022;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$3 = i64toi32_i32$2;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $24 = i64toi32_i32$1;
     $24$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $600$hi;
     i64toi32_i32$0 = $600;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$3 = i64toi32_i32$1;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $3046 = i64toi32_i32$5;
     $3046$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $63$hi;
     i64toi32_i32$1 = $19$hi;
     i64toi32_i32$1 = $63$hi;
     i64toi32_i32$2 = $63;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $3049 = i64toi32_i32$4;
     $3049$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $64$hi;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$5 = $64$hi;
     i64toi32_i32$1 = $64;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $3052 = i64toi32_i32$0;
     $3052$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $61$hi;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$4 = $61$hi;
     i64toi32_i32$5 = $61;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $3055$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$4 = $19;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$5 = i64toi32_i32$0 ^ i64toi32_i32$5 | 0;
     $3059 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $3059$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $24$hi;
     i64toi32_i32$0 = $24;
     i64toi32_i32$4 = $3059$hi;
     i64toi32_i32$3 = $3059;
     i64toi32_i32$4 = i64toi32_i32$5 & i64toi32_i32$4 | 0;
     $3060$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$4 = $3060$hi;
     i64toi32_i32$5 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $3062 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $3062$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3055$hi;
     i64toi32_i32$4 = i64toi32_i32$2;
     i64toi32_i32$5 = $3062$hi;
     i64toi32_i32$3 = $3062;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $3063$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($24 | 0, i64toi32_i32$2 | 0, 50 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $3065 = i64toi32_i32$4;
     $3065$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($24 | 0, i64toi32_i32$2 | 0, 46 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $3067 = i64toi32_i32$4;
     $3067$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $3065$hi;
     i64toi32_i32$0 = $3065;
     i64toi32_i32$4 = $3067$hi;
     i64toi32_i32$3 = $3067;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $3068 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $3068$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($24 | 0, i64toi32_i32$4 | 0, 23 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $3070 = i64toi32_i32$0;
     $3070$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3068$hi;
     i64toi32_i32$2 = $3068;
     i64toi32_i32$0 = $3070$hi;
     i64toi32_i32$3 = $3070;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $3071 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $3071$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3063$hi;
     i64toi32_i32$4 = i64toi32_i32$1;
     i64toi32_i32$2 = $3071$hi;
     i64toi32_i32$3 = $3071;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     i64toi32_i32$0 = i64toi32_i32$5;
     i64toi32_i32$4 = 2024104815;
     i64toi32_i32$3 = 1125592928;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $22 = i64toi32_i32$2;
     $22$hi = i64toi32_i32$5;
     $3074 = i64toi32_i32$2;
     $3074$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($13 | 0, i64toi32_i32$5 | 0, 36 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $3076 = i64toi32_i32$0;
     $3076$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($13 | 0, i64toi32_i32$5 | 0, 30 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $3078 = i64toi32_i32$0;
     $3078$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $3076$hi;
     i64toi32_i32$1 = $3076;
     i64toi32_i32$0 = $3078$hi;
     i64toi32_i32$3 = $3078;
     i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
     $3079 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $3079$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($13 | 0, i64toi32_i32$0 | 0, 25 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $3081 = i64toi32_i32$1;
     $3081$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3079$hi;
     i64toi32_i32$5 = $3079;
     i64toi32_i32$1 = $3081$hi;
     i64toi32_i32$3 = $3081;
     i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
     $3082 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $3082$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$0 = $7;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $3086 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $3086$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$1 = $13;
     i64toi32_i32$0 = $3086$hi;
     i64toi32_i32$3 = $3086;
     i64toi32_i32$0 = i64toi32_i32$5 & i64toi32_i32$0 | 0;
     $3087 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $3087$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$5 = $7;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
     $3090 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $3090$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $3087$hi;
     i64toi32_i32$0 = $3087;
     i64toi32_i32$5 = $3090$hi;
     i64toi32_i32$3 = $3090;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $3091 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $3091$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $3082$hi;
     i64toi32_i32$1 = $3082;
     i64toi32_i32$0 = $3091$hi;
     i64toi32_i32$3 = $3091;
     i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $3092$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $11$hi;
     i64toi32_i32$2 = $3092$hi;
     i64toi32_i32$5 = i64toi32_i32$4;
     i64toi32_i32$1 = $11$hi;
     i64toi32_i32$3 = $11;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $6 = i64toi32_i32$0;
     $6$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3074$hi;
     i64toi32_i32$2 = $3074;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$3 = i64toi32_i32$0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $12 = i64toi32_i32$1;
     $12$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$4 = $24;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $3100 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $3100$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$0 = i64toi32_i32$1;
     i64toi32_i32$4 = $3100$hi;
     i64toi32_i32$3 = $3100;
     i64toi32_i32$4 = i64toi32_i32$2 & i64toi32_i32$4 | 0;
     $3101$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$4 = $3101$hi;
     i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $3103 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $3103$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3052$hi;
     i64toi32_i32$4 = $3052;
     i64toi32_i32$2 = $3103$hi;
     i64toi32_i32$3 = $3103;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $3104$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($12 | 0, i64toi32_i32$1 | 0, 50 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $3106 = i64toi32_i32$4;
     $3106$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($12 | 0, i64toi32_i32$1 | 0, 46 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $3108 = i64toi32_i32$4;
     $3108$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $3106$hi;
     i64toi32_i32$0 = $3106;
     i64toi32_i32$4 = $3108$hi;
     i64toi32_i32$3 = $3108;
     i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
     $3109 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $3109$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($12 | 0, i64toi32_i32$4 | 0, 23 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $3111 = i64toi32_i32$0;
     $3111$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3109$hi;
     i64toi32_i32$1 = $3109;
     i64toi32_i32$0 = $3111$hi;
     i64toi32_i32$3 = $3111;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $3112 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $3112$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3104$hi;
     i64toi32_i32$4 = i64toi32_i32$5;
     i64toi32_i32$1 = $3112$hi;
     i64toi32_i32$3 = $3112;
     i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     i64toi32_i32$0 = i64toi32_i32$2;
     i64toi32_i32$4 = -2067236844;
     i64toi32_i32$3 = -1578062990;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $11 = i64toi32_i32$1;
     $11$hi = i64toi32_i32$2;
     $3115 = i64toi32_i32$1;
     $3115$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($6 | 0, i64toi32_i32$2 | 0, 36 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $3117 = i64toi32_i32$0;
     $3117$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($6 | 0, i64toi32_i32$2 | 0, 30 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $3119 = i64toi32_i32$0;
     $3119$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $3117$hi;
     i64toi32_i32$5 = $3117;
     i64toi32_i32$0 = $3119$hi;
     i64toi32_i32$3 = $3119;
     i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
     $3120 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $3120$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$5 = 0;
     i64toi32_i32$5 = __wasm_rotl_i64($6 | 0, i64toi32_i32$0 | 0, 25 | 0, i64toi32_i32$5 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $3122 = i64toi32_i32$5;
     $3122$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3120$hi;
     i64toi32_i32$2 = $3120;
     i64toi32_i32$5 = $3122$hi;
     i64toi32_i32$3 = $3122;
     i64toi32_i32$5 = i64toi32_i32$0 ^ i64toi32_i32$5 | 0;
     $3123 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $3123$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$0 = $13;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
     $3127 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $3127$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$5 = $6;
     i64toi32_i32$0 = $3127$hi;
     i64toi32_i32$3 = $3127;
     i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
     $3128 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $3128$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$2 = $13;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$5 = i64toi32_i32$0 & i64toi32_i32$5 | 0;
     $3131 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     $3131$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $3128$hi;
     i64toi32_i32$0 = $3128;
     i64toi32_i32$2 = $3131$hi;
     i64toi32_i32$3 = $3131;
     i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
     $3132 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $3132$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $3123$hi;
     i64toi32_i32$5 = $3123;
     i64toi32_i32$0 = $3132$hi;
     i64toi32_i32$3 = $3132;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $3133$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $17$hi;
     i64toi32_i32$1 = $3133$hi;
     i64toi32_i32$2 = i64toi32_i32$4;
     i64toi32_i32$5 = $17$hi;
     i64toi32_i32$3 = $17;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $7 = i64toi32_i32$0;
     $7$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3115$hi;
     i64toi32_i32$1 = $3115;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$3 = i64toi32_i32$0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $89 = i64toi32_i32$5;
     $89$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$4 = $12;
     i64toi32_i32$1 = $24$hi;
     i64toi32_i32$3 = $24;
     i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
     $3141 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $3141$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $89$hi;
     i64toi32_i32$0 = i64toi32_i32$5;
     i64toi32_i32$4 = $3141$hi;
     i64toi32_i32$3 = $3141;
     i64toi32_i32$4 = i64toi32_i32$1 & i64toi32_i32$4 | 0;
     $3142$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$4 = $3142$hi;
     i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$3 = $24;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $3144 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $3144$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3049$hi;
     i64toi32_i32$4 = $3049;
     i64toi32_i32$1 = $3144$hi;
     i64toi32_i32$3 = $3144;
     i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $3145$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($89 | 0, i64toi32_i32$5 | 0, 50 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $3147 = i64toi32_i32$4;
     $3147$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($89 | 0, i64toi32_i32$5 | 0, 46 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $3149 = i64toi32_i32$4;
     $3149$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $3147$hi;
     i64toi32_i32$0 = $3147;
     i64toi32_i32$4 = $3149$hi;
     i64toi32_i32$3 = $3149;
     i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
     $3150 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $3150$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($89 | 0, i64toi32_i32$4 | 0, 23 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $3152 = i64toi32_i32$0;
     $3152$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3150$hi;
     i64toi32_i32$5 = $3150;
     i64toi32_i32$0 = $3152$hi;
     i64toi32_i32$3 = $3152;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $3153 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $3153$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3145$hi;
     i64toi32_i32$4 = i64toi32_i32$2;
     i64toi32_i32$5 = $3153$hi;
     i64toi32_i32$3 = $3153;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     i64toi32_i32$0 = i64toi32_i32$1;
     i64toi32_i32$4 = -1933114872;
     i64toi32_i32$3 = 442776044;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $17 = i64toi32_i32$5;
     $17$hi = i64toi32_i32$1;
     $3156 = i64toi32_i32$5;
     $3156$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($7 | 0, i64toi32_i32$1 | 0, 36 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $3158 = i64toi32_i32$0;
     $3158$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($7 | 0, i64toi32_i32$1 | 0, 30 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $3160 = i64toi32_i32$0;
     $3160$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $3158$hi;
     i64toi32_i32$2 = $3158;
     i64toi32_i32$0 = $3160$hi;
     i64toi32_i32$3 = $3160;
     i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
     $3161 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $3161$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 25 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $3163 = i64toi32_i32$2;
     $3163$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3161$hi;
     i64toi32_i32$1 = $3161;
     i64toi32_i32$2 = $3163$hi;
     i64toi32_i32$3 = $3163;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $3164 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $3164$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$0 = $6;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
     $3168 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $3168$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$2 = $7;
     i64toi32_i32$0 = $3168$hi;
     i64toi32_i32$3 = $3168;
     i64toi32_i32$0 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
     $3169 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     $3169$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$1 = $6;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
     $3172 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $3172$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $3169$hi;
     i64toi32_i32$0 = $3169;
     i64toi32_i32$1 = $3172$hi;
     i64toi32_i32$3 = $3172;
     i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
     $3173 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $3173$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $3164$hi;
     i64toi32_i32$2 = $3164;
     i64toi32_i32$0 = $3173$hi;
     i64toi32_i32$3 = $3173;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $3174$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $26$hi;
     i64toi32_i32$5 = $3174$hi;
     i64toi32_i32$1 = i64toi32_i32$4;
     i64toi32_i32$2 = $26$hi;
     i64toi32_i32$3 = $26;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $13 = i64toi32_i32$0;
     $13$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3156$hi;
     i64toi32_i32$5 = $3156;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$3 = i64toi32_i32$0;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $19 = i64toi32_i32$2;
     $19$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$4 = $89;
     i64toi32_i32$5 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$5 = i64toi32_i32$0 ^ i64toi32_i32$5 | 0;
     $3182 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $3182$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $19$hi;
     i64toi32_i32$0 = i64toi32_i32$2;
     i64toi32_i32$4 = $3182$hi;
     i64toi32_i32$3 = $3182;
     i64toi32_i32$4 = i64toi32_i32$5 & i64toi32_i32$4 | 0;
     $3183$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$4 = $3183$hi;
     i64toi32_i32$5 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $3185 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $3185$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3046$hi;
     i64toi32_i32$4 = $3046;
     i64toi32_i32$5 = $3185$hi;
     i64toi32_i32$3 = $3185;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $3186$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($19 | 0, i64toi32_i32$2 | 0, 50 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $3188 = i64toi32_i32$4;
     $3188$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($19 | 0, i64toi32_i32$2 | 0, 46 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $3190 = i64toi32_i32$4;
     $3190$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $3188$hi;
     i64toi32_i32$0 = $3188;
     i64toi32_i32$4 = $3190$hi;
     i64toi32_i32$3 = $3190;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $3191 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $3191$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($19 | 0, i64toi32_i32$4 | 0, 23 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $3193 = i64toi32_i32$0;
     $3193$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3191$hi;
     i64toi32_i32$2 = $3191;
     i64toi32_i32$0 = $3193$hi;
     i64toi32_i32$3 = $3193;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $3194 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $3194$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3186$hi;
     i64toi32_i32$4 = i64toi32_i32$1;
     i64toi32_i32$2 = $3194$hi;
     i64toi32_i32$3 = $3194;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     i64toi32_i32$0 = i64toi32_i32$5;
     i64toi32_i32$4 = -1866530822;
     i64toi32_i32$3 = 593698344;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $26 = i64toi32_i32$2;
     $26$hi = i64toi32_i32$5;
     $3197 = i64toi32_i32$2;
     $3197$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($13 | 0, i64toi32_i32$5 | 0, 36 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $3199 = i64toi32_i32$0;
     $3199$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($13 | 0, i64toi32_i32$5 | 0, 30 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $3201 = i64toi32_i32$0;
     $3201$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $3199$hi;
     i64toi32_i32$1 = $3199;
     i64toi32_i32$0 = $3201$hi;
     i64toi32_i32$3 = $3201;
     i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
     $3202 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $3202$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($13 | 0, i64toi32_i32$0 | 0, 25 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $3204 = i64toi32_i32$1;
     $3204$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3202$hi;
     i64toi32_i32$5 = $3202;
     i64toi32_i32$1 = $3204$hi;
     i64toi32_i32$3 = $3204;
     i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
     $3205 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $3205$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$0 = $7;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $3209 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $3209$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$1 = $13;
     i64toi32_i32$0 = $3209$hi;
     i64toi32_i32$3 = $3209;
     i64toi32_i32$0 = i64toi32_i32$5 & i64toi32_i32$0 | 0;
     $3210 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $3210$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$5 = $7;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
     $3213 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $3213$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $3210$hi;
     i64toi32_i32$0 = $3210;
     i64toi32_i32$5 = $3213$hi;
     i64toi32_i32$3 = $3213;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $3214 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $3214$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $3205$hi;
     i64toi32_i32$1 = $3205;
     i64toi32_i32$0 = $3214$hi;
     i64toi32_i32$3 = $3214;
     i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $3215$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $28$hi;
     i64toi32_i32$2 = $3215$hi;
     i64toi32_i32$5 = i64toi32_i32$4;
     i64toi32_i32$1 = $28$hi;
     i64toi32_i32$3 = $28;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $6 = i64toi32_i32$0;
     $6$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3197$hi;
     i64toi32_i32$2 = $3197;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$3 = i64toi32_i32$0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $24 = i64toi32_i32$1;
     $24$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $599$hi;
     i64toi32_i32$4 = $599;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$3 = i64toi32_i32$1;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $3221 = i64toi32_i32$5;
     $3221$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $67$hi;
     i64toi32_i32$1 = $19$hi;
     i64toi32_i32$1 = $67$hi;
     i64toi32_i32$0 = $67;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $3224 = i64toi32_i32$2;
     $3224$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $68$hi;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$5 = $68$hi;
     i64toi32_i32$1 = $68;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $3227 = i64toi32_i32$4;
     $3227$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $65$hi;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$2 = $65$hi;
     i64toi32_i32$5 = $65;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $3230$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$2 = $19;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
     $3234 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $3234$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $24$hi;
     i64toi32_i32$4 = $24;
     i64toi32_i32$2 = $3234$hi;
     i64toi32_i32$3 = $3234;
     i64toi32_i32$2 = i64toi32_i32$5 & i64toi32_i32$2 | 0;
     $3235$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$2 = $3235$hi;
     i64toi32_i32$5 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $3237 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $3237$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3230$hi;
     i64toi32_i32$2 = i64toi32_i32$0;
     i64toi32_i32$5 = $3237$hi;
     i64toi32_i32$3 = $3237;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $3238$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($24 | 0, i64toi32_i32$0 | 0, 50 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $3240 = i64toi32_i32$2;
     $3240$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($24 | 0, i64toi32_i32$0 | 0, 46 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $3242 = i64toi32_i32$2;
     $3242$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3240$hi;
     i64toi32_i32$4 = $3240;
     i64toi32_i32$2 = $3242$hi;
     i64toi32_i32$3 = $3242;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $3243 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $3243$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($24 | 0, i64toi32_i32$2 | 0, 23 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $3245 = i64toi32_i32$4;
     $3245$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $3243$hi;
     i64toi32_i32$0 = $3243;
     i64toi32_i32$4 = $3245$hi;
     i64toi32_i32$3 = $3245;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $3246 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $3246$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3238$hi;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$0 = $3246$hi;
     i64toi32_i32$3 = $3246;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     i64toi32_i32$4 = i64toi32_i32$5;
     i64toi32_i32$2 = -1538233109;
     i64toi32_i32$3 = -561857047;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $28 = i64toi32_i32$0;
     $28$hi = i64toi32_i32$5;
     $3249 = i64toi32_i32$0;
     $3249$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($6 | 0, i64toi32_i32$5 | 0, 36 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $3251 = i64toi32_i32$4;
     $3251$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($6 | 0, i64toi32_i32$5 | 0, 30 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $3253 = i64toi32_i32$4;
     $3253$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $3251$hi;
     i64toi32_i32$1 = $3251;
     i64toi32_i32$4 = $3253$hi;
     i64toi32_i32$3 = $3253;
     i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
     $3254 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $3254$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($6 | 0, i64toi32_i32$4 | 0, 25 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $3256 = i64toi32_i32$1;
     $3256$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3254$hi;
     i64toi32_i32$5 = $3254;
     i64toi32_i32$1 = $3256$hi;
     i64toi32_i32$3 = $3256;
     i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
     $3257 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $3257$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$4 = $13;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $3261 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $3261$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$1 = $6;
     i64toi32_i32$4 = $3261$hi;
     i64toi32_i32$3 = $3261;
     i64toi32_i32$4 = i64toi32_i32$5 & i64toi32_i32$4 | 0;
     $3262 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $3262$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$5 = $13;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$1 = i64toi32_i32$4 & i64toi32_i32$1 | 0;
     $3265 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $3265$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $3262$hi;
     i64toi32_i32$4 = $3262;
     i64toi32_i32$5 = $3265$hi;
     i64toi32_i32$3 = $3265;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $3266 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $3266$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $3257$hi;
     i64toi32_i32$1 = $3257;
     i64toi32_i32$4 = $3266$hi;
     i64toi32_i32$3 = $3266;
     i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $3267$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $22$hi;
     i64toi32_i32$0 = $3267$hi;
     i64toi32_i32$5 = i64toi32_i32$2;
     i64toi32_i32$1 = $22$hi;
     i64toi32_i32$3 = $22;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $7 = i64toi32_i32$4;
     $7$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $3249$hi;
     i64toi32_i32$0 = $3249;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$3 = i64toi32_i32$4;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $12 = i64toi32_i32$1;
     $12$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$2 = $24;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $3275 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $3275$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$4 = i64toi32_i32$1;
     i64toi32_i32$2 = $3275$hi;
     i64toi32_i32$3 = $3275;
     i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
     $3276$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$2 = $3276$hi;
     i64toi32_i32$0 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $3278 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $3278$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3227$hi;
     i64toi32_i32$2 = $3227;
     i64toi32_i32$0 = $3278$hi;
     i64toi32_i32$3 = $3278;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $3279$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($12 | 0, i64toi32_i32$1 | 0, 50 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $3281 = i64toi32_i32$2;
     $3281$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($12 | 0, i64toi32_i32$1 | 0, 46 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $3283 = i64toi32_i32$2;
     $3283$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $3281$hi;
     i64toi32_i32$4 = $3281;
     i64toi32_i32$2 = $3283$hi;
     i64toi32_i32$3 = $3283;
     i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
     $3284 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $3284$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($12 | 0, i64toi32_i32$2 | 0, 23 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $3286 = i64toi32_i32$4;
     $3286$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $3284$hi;
     i64toi32_i32$1 = $3284;
     i64toi32_i32$4 = $3286$hi;
     i64toi32_i32$3 = $3286;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $3287 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $3287$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3279$hi;
     i64toi32_i32$2 = i64toi32_i32$5;
     i64toi32_i32$1 = $3287$hi;
     i64toi32_i32$3 = $3287;
     i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     i64toi32_i32$4 = i64toi32_i32$0;
     i64toi32_i32$2 = -1090935817;
     i64toi32_i32$3 = -1295615723;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $22 = i64toi32_i32$1;
     $22$hi = i64toi32_i32$0;
     $3290 = i64toi32_i32$1;
     $3290$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 36 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $3292 = i64toi32_i32$4;
     $3292$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 30 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $3294 = i64toi32_i32$4;
     $3294$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3292$hi;
     i64toi32_i32$5 = $3292;
     i64toi32_i32$4 = $3294$hi;
     i64toi32_i32$3 = $3294;
     i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
     $3295 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $3295$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$5 = 0;
     i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 25 | 0, i64toi32_i32$5 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $3297 = i64toi32_i32$5;
     $3297$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3295$hi;
     i64toi32_i32$0 = $3295;
     i64toi32_i32$5 = $3297$hi;
     i64toi32_i32$3 = $3297;
     i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
     $3298 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $3298$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$4 = $6;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
     $3302 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $3302$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$5 = $7;
     i64toi32_i32$4 = $3302$hi;
     i64toi32_i32$3 = $3302;
     i64toi32_i32$4 = i64toi32_i32$0 & i64toi32_i32$4 | 0;
     $3303 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $3303$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$0 = $6;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$5 = i64toi32_i32$4 & i64toi32_i32$5 | 0;
     $3306 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
     $3306$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $3303$hi;
     i64toi32_i32$4 = $3303;
     i64toi32_i32$0 = $3306$hi;
     i64toi32_i32$3 = $3306;
     i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
     $3307 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $3307$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3298$hi;
     i64toi32_i32$5 = $3298;
     i64toi32_i32$4 = $3307$hi;
     i64toi32_i32$3 = $3307;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $3308$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $11$hi;
     i64toi32_i32$1 = $3308$hi;
     i64toi32_i32$0 = i64toi32_i32$2;
     i64toi32_i32$5 = $11$hi;
     i64toi32_i32$3 = $11;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $13 = i64toi32_i32$4;
     $13$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $3290$hi;
     i64toi32_i32$1 = $3290;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$3 = i64toi32_i32$4;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $89 = i64toi32_i32$5;
     $89$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$2 = $12;
     i64toi32_i32$1 = $24$hi;
     i64toi32_i32$3 = $24;
     i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
     $3316 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $3316$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $89$hi;
     i64toi32_i32$4 = i64toi32_i32$5;
     i64toi32_i32$2 = $3316$hi;
     i64toi32_i32$3 = $3316;
     i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
     $3317$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$2 = $3317$hi;
     i64toi32_i32$1 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$3 = $24;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $3319 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $3319$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3224$hi;
     i64toi32_i32$2 = $3224;
     i64toi32_i32$1 = $3319$hi;
     i64toi32_i32$3 = $3319;
     i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $3320$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($89 | 0, i64toi32_i32$5 | 0, 50 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $3322 = i64toi32_i32$2;
     $3322$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($89 | 0, i64toi32_i32$5 | 0, 46 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $3324 = i64toi32_i32$2;
     $3324$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $3322$hi;
     i64toi32_i32$4 = $3322;
     i64toi32_i32$2 = $3324$hi;
     i64toi32_i32$3 = $3324;
     i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
     $3325 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $3325$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($89 | 0, i64toi32_i32$2 | 0, 23 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $3327 = i64toi32_i32$4;
     $3327$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $3325$hi;
     i64toi32_i32$5 = $3325;
     i64toi32_i32$4 = $3327$hi;
     i64toi32_i32$3 = $3327;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $3328 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $3328$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3320$hi;
     i64toi32_i32$2 = i64toi32_i32$0;
     i64toi32_i32$5 = $3328$hi;
     i64toi32_i32$3 = $3328;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     i64toi32_i32$4 = i64toi32_i32$1;
     i64toi32_i32$2 = -965641998;
     i64toi32_i32$3 = -479046869;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $11 = i64toi32_i32$5;
     $11$hi = i64toi32_i32$1;
     $3331 = i64toi32_i32$5;
     $3331$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($13 | 0, i64toi32_i32$1 | 0, 36 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $3333 = i64toi32_i32$4;
     $3333$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($13 | 0, i64toi32_i32$1 | 0, 30 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $3335 = i64toi32_i32$4;
     $3335$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $3333$hi;
     i64toi32_i32$0 = $3333;
     i64toi32_i32$4 = $3335$hi;
     i64toi32_i32$3 = $3335;
     i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
     $3336 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $3336$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($13 | 0, i64toi32_i32$4 | 0, 25 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $3338 = i64toi32_i32$0;
     $3338$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3336$hi;
     i64toi32_i32$1 = $3336;
     i64toi32_i32$0 = $3338$hi;
     i64toi32_i32$3 = $3338;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $3339 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $3339$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$4 = $7;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
     $3343 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $3343$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$0 = $13;
     i64toi32_i32$4 = $3343$hi;
     i64toi32_i32$3 = $3343;
     i64toi32_i32$4 = i64toi32_i32$1 & i64toi32_i32$4 | 0;
     $3344 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
     $3344$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$1 = $7;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$0 = i64toi32_i32$4 & i64toi32_i32$0 | 0;
     $3347 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $3347$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3344$hi;
     i64toi32_i32$4 = $3344;
     i64toi32_i32$1 = $3347$hi;
     i64toi32_i32$3 = $3347;
     i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
     $3348 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $3348$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $3339$hi;
     i64toi32_i32$0 = $3339;
     i64toi32_i32$4 = $3348$hi;
     i64toi32_i32$3 = $3348;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $3349$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $17$hi;
     i64toi32_i32$5 = $3349$hi;
     i64toi32_i32$1 = i64toi32_i32$2;
     i64toi32_i32$0 = $17$hi;
     i64toi32_i32$3 = $17;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $6 = i64toi32_i32$4;
     $6$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $3331$hi;
     i64toi32_i32$5 = $3331;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$3 = i64toi32_i32$4;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $19 = i64toi32_i32$0;
     $19$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$2 = $89;
     i64toi32_i32$5 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
     $3357 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $3357$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $19$hi;
     i64toi32_i32$4 = i64toi32_i32$0;
     i64toi32_i32$2 = $3357$hi;
     i64toi32_i32$3 = $3357;
     i64toi32_i32$2 = i64toi32_i32$5 & i64toi32_i32$2 | 0;
     $3358$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$2 = $3358$hi;
     i64toi32_i32$5 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $3360 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $3360$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3221$hi;
     i64toi32_i32$2 = $3221;
     i64toi32_i32$5 = $3360$hi;
     i64toi32_i32$3 = $3360;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $3361$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($19 | 0, i64toi32_i32$0 | 0, 50 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $3363 = i64toi32_i32$2;
     $3363$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($19 | 0, i64toi32_i32$0 | 0, 46 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $3365 = i64toi32_i32$2;
     $3365$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3363$hi;
     i64toi32_i32$4 = $3363;
     i64toi32_i32$2 = $3365$hi;
     i64toi32_i32$3 = $3365;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $3366 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $3366$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($19 | 0, i64toi32_i32$2 | 0, 23 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $3368 = i64toi32_i32$4;
     $3368$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $3366$hi;
     i64toi32_i32$0 = $3366;
     i64toi32_i32$4 = $3368$hi;
     i64toi32_i32$3 = $3368;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $3369 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $3369$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3361$hi;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$0 = $3369$hi;
     i64toi32_i32$3 = $3369;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     i64toi32_i32$4 = i64toi32_i32$5;
     i64toi32_i32$2 = -903397682;
     i64toi32_i32$3 = -366583396;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $17 = i64toi32_i32$0;
     $17$hi = i64toi32_i32$5;
     $3372 = i64toi32_i32$0;
     $3372$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($6 | 0, i64toi32_i32$5 | 0, 36 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $3374 = i64toi32_i32$4;
     $3374$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($6 | 0, i64toi32_i32$5 | 0, 30 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $3376 = i64toi32_i32$4;
     $3376$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $3374$hi;
     i64toi32_i32$1 = $3374;
     i64toi32_i32$4 = $3376$hi;
     i64toi32_i32$3 = $3376;
     i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
     $3377 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $3377$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($6 | 0, i64toi32_i32$4 | 0, 25 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $3379 = i64toi32_i32$1;
     $3379$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3377$hi;
     i64toi32_i32$5 = $3377;
     i64toi32_i32$1 = $3379$hi;
     i64toi32_i32$3 = $3379;
     i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
     $3380 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $3380$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$4 = $13;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $3384 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $3384$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$1 = $6;
     i64toi32_i32$4 = $3384$hi;
     i64toi32_i32$3 = $3384;
     i64toi32_i32$4 = i64toi32_i32$5 & i64toi32_i32$4 | 0;
     $3385 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $3385$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$5 = $13;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$1 = i64toi32_i32$4 & i64toi32_i32$1 | 0;
     $3388 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $3388$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $3385$hi;
     i64toi32_i32$4 = $3385;
     i64toi32_i32$5 = $3388$hi;
     i64toi32_i32$3 = $3388;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $3389 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $3389$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $3380$hi;
     i64toi32_i32$1 = $3380;
     i64toi32_i32$4 = $3389$hi;
     i64toi32_i32$3 = $3389;
     i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $3390$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $26$hi;
     i64toi32_i32$0 = $3390$hi;
     i64toi32_i32$5 = i64toi32_i32$2;
     i64toi32_i32$1 = $26$hi;
     i64toi32_i32$3 = $26;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $7 = i64toi32_i32$4;
     $7$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $3372$hi;
     i64toi32_i32$0 = $3372;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$3 = i64toi32_i32$4;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $24 = i64toi32_i32$1;
     $24$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $598$hi;
     i64toi32_i32$2 = $598;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$3 = i64toi32_i32$1;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $3396 = i64toi32_i32$5;
     $3396$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $71$hi;
     i64toi32_i32$1 = $19$hi;
     i64toi32_i32$1 = $71$hi;
     i64toi32_i32$4 = $71;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $3399 = i64toi32_i32$0;
     $3399$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $72$hi;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$5 = $72$hi;
     i64toi32_i32$1 = $72;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $3402 = i64toi32_i32$2;
     $3402$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $69$hi;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$0 = $69$hi;
     i64toi32_i32$5 = $69;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $3405$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$0 = $19;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
     $3409 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $3409$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $24$hi;
     i64toi32_i32$2 = $24;
     i64toi32_i32$0 = $3409$hi;
     i64toi32_i32$3 = $3409;
     i64toi32_i32$0 = i64toi32_i32$5 & i64toi32_i32$0 | 0;
     $3410$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$0 = $3410$hi;
     i64toi32_i32$5 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $3412 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $3412$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $3405$hi;
     i64toi32_i32$0 = i64toi32_i32$4;
     i64toi32_i32$5 = $3412$hi;
     i64toi32_i32$3 = $3412;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $3413$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($24 | 0, i64toi32_i32$4 | 0, 50 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $3415 = i64toi32_i32$0;
     $3415$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($24 | 0, i64toi32_i32$4 | 0, 46 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $3417 = i64toi32_i32$0;
     $3417$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3415$hi;
     i64toi32_i32$2 = $3415;
     i64toi32_i32$0 = $3417$hi;
     i64toi32_i32$3 = $3417;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $3418 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $3418$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($24 | 0, i64toi32_i32$0 | 0, 23 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $3420 = i64toi32_i32$2;
     $3420$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3418$hi;
     i64toi32_i32$4 = $3418;
     i64toi32_i32$2 = $3420$hi;
     i64toi32_i32$3 = $3420;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $3421 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $3421$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $3413$hi;
     i64toi32_i32$0 = i64toi32_i32$1;
     i64toi32_i32$4 = $3421$hi;
     i64toi32_i32$3 = $3421;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     i64toi32_i32$2 = i64toi32_i32$5;
     i64toi32_i32$0 = -779700025;
     i64toi32_i32$3 = 566280711;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $26 = i64toi32_i32$4;
     $26$hi = i64toi32_i32$5;
     $3424 = i64toi32_i32$4;
     $3424$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 36 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $3426 = i64toi32_i32$2;
     $3426$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 30 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $3428 = i64toi32_i32$2;
     $3428$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $3426$hi;
     i64toi32_i32$1 = $3426;
     i64toi32_i32$2 = $3428$hi;
     i64toi32_i32$3 = $3428;
     i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
     $3429 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $3429$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($7 | 0, i64toi32_i32$2 | 0, 25 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $3431 = i64toi32_i32$1;
     $3431$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $3429$hi;
     i64toi32_i32$5 = $3429;
     i64toi32_i32$1 = $3431$hi;
     i64toi32_i32$3 = $3431;
     i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
     $3432 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $3432$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$2 = $6;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $3436 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $3436$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$1 = $7;
     i64toi32_i32$2 = $3436$hi;
     i64toi32_i32$3 = $3436;
     i64toi32_i32$2 = i64toi32_i32$5 & i64toi32_i32$2 | 0;
     $3437 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $3437$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$5 = $6;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
     $3440 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $3440$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $3437$hi;
     i64toi32_i32$2 = $3437;
     i64toi32_i32$5 = $3440$hi;
     i64toi32_i32$3 = $3440;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $3441 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $3441$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $3432$hi;
     i64toi32_i32$1 = $3432;
     i64toi32_i32$2 = $3441$hi;
     i64toi32_i32$3 = $3441;
     i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $3442$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $28$hi;
     i64toi32_i32$4 = $3442$hi;
     i64toi32_i32$5 = i64toi32_i32$0;
     i64toi32_i32$1 = $28$hi;
     i64toi32_i32$3 = $28;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $13 = i64toi32_i32$2;
     $13$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3424$hi;
     i64toi32_i32$4 = $3424;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$3 = i64toi32_i32$2;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $12 = i64toi32_i32$1;
     $12$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$0 = $24;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $3450 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $3450$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$0 = $3450$hi;
     i64toi32_i32$3 = $3450;
     i64toi32_i32$0 = i64toi32_i32$4 & i64toi32_i32$0 | 0;
     $3451$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$0 = $3451$hi;
     i64toi32_i32$4 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $3453 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $3453$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $3402$hi;
     i64toi32_i32$0 = $3402;
     i64toi32_i32$4 = $3453$hi;
     i64toi32_i32$3 = $3453;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $3454$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($12 | 0, i64toi32_i32$1 | 0, 50 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $3456 = i64toi32_i32$0;
     $3456$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($12 | 0, i64toi32_i32$1 | 0, 46 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $3458 = i64toi32_i32$0;
     $3458$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $3456$hi;
     i64toi32_i32$2 = $3456;
     i64toi32_i32$0 = $3458$hi;
     i64toi32_i32$3 = $3458;
     i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
     $3459 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $3459$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($12 | 0, i64toi32_i32$0 | 0, 23 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $3461 = i64toi32_i32$2;
     $3461$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3459$hi;
     i64toi32_i32$1 = $3459;
     i64toi32_i32$2 = $3461$hi;
     i64toi32_i32$3 = $3461;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $3462 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $3462$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $3454$hi;
     i64toi32_i32$0 = i64toi32_i32$5;
     i64toi32_i32$1 = $3462$hi;
     i64toi32_i32$3 = $3462;
     i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     i64toi32_i32$2 = i64toi32_i32$4;
     i64toi32_i32$0 = -354779690;
     i64toi32_i32$3 = -840897762;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $28 = i64toi32_i32$1;
     $28$hi = i64toi32_i32$4;
     $3465 = i64toi32_i32$1;
     $3465$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($13 | 0, i64toi32_i32$4 | 0, 36 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $3467 = i64toi32_i32$2;
     $3467$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($13 | 0, i64toi32_i32$4 | 0, 30 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $3469 = i64toi32_i32$2;
     $3469$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3467$hi;
     i64toi32_i32$5 = $3467;
     i64toi32_i32$2 = $3469$hi;
     i64toi32_i32$3 = $3469;
     i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
     $3470 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $3470$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$5 = 0;
     i64toi32_i32$5 = __wasm_rotl_i64($13 | 0, i64toi32_i32$2 | 0, 25 | 0, i64toi32_i32$5 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $3472 = i64toi32_i32$5;
     $3472$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $3470$hi;
     i64toi32_i32$4 = $3470;
     i64toi32_i32$5 = $3472$hi;
     i64toi32_i32$3 = $3472;
     i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
     $3473 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $3473$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$2 = $7;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
     $3477 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $3477$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$5 = $13;
     i64toi32_i32$2 = $3477$hi;
     i64toi32_i32$3 = $3477;
     i64toi32_i32$2 = i64toi32_i32$4 & i64toi32_i32$2 | 0;
     $3478 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $3478$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$4 = $7;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$5 = i64toi32_i32$2 & i64toi32_i32$5 | 0;
     $3481 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     $3481$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $3478$hi;
     i64toi32_i32$2 = $3478;
     i64toi32_i32$4 = $3481$hi;
     i64toi32_i32$3 = $3481;
     i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
     $3482 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $3482$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3473$hi;
     i64toi32_i32$5 = $3473;
     i64toi32_i32$2 = $3482$hi;
     i64toi32_i32$3 = $3482;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $3483$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $22$hi;
     i64toi32_i32$1 = $3483$hi;
     i64toi32_i32$4 = i64toi32_i32$0;
     i64toi32_i32$5 = $22$hi;
     i64toi32_i32$3 = $22;
     i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $6 = i64toi32_i32$2;
     $6$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3465$hi;
     i64toi32_i32$1 = $3465;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$3 = i64toi32_i32$2;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $89 = i64toi32_i32$5;
     $89$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$0 = $12;
     i64toi32_i32$1 = $24$hi;
     i64toi32_i32$3 = $24;
     i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
     $3491 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $3491$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $89$hi;
     i64toi32_i32$2 = i64toi32_i32$5;
     i64toi32_i32$0 = $3491$hi;
     i64toi32_i32$3 = $3491;
     i64toi32_i32$0 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
     $3492$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$0 = $3492$hi;
     i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$3 = $24;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $3494 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $3494$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $3399$hi;
     i64toi32_i32$0 = $3399;
     i64toi32_i32$1 = $3494$hi;
     i64toi32_i32$3 = $3494;
     i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $3495$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($89 | 0, i64toi32_i32$5 | 0, 50 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $3497 = i64toi32_i32$0;
     $3497$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($89 | 0, i64toi32_i32$5 | 0, 46 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $3499 = i64toi32_i32$0;
     $3499$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $3497$hi;
     i64toi32_i32$2 = $3497;
     i64toi32_i32$0 = $3499$hi;
     i64toi32_i32$3 = $3499;
     i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
     $3500 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $3500$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($89 | 0, i64toi32_i32$0 | 0, 23 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $3502 = i64toi32_i32$2;
     $3502$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3500$hi;
     i64toi32_i32$5 = $3500;
     i64toi32_i32$2 = $3502$hi;
     i64toi32_i32$3 = $3502;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $3503 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $3503$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $3495$hi;
     i64toi32_i32$0 = i64toi32_i32$4;
     i64toi32_i32$5 = $3503$hi;
     i64toi32_i32$3 = $3503;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$0 = -176337025;
     i64toi32_i32$3 = -294727304;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $22 = i64toi32_i32$5;
     $22$hi = i64toi32_i32$1;
     $3506 = i64toi32_i32$5;
     $3506$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($6 | 0, i64toi32_i32$1 | 0, 36 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $3508 = i64toi32_i32$2;
     $3508$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($6 | 0, i64toi32_i32$1 | 0, 30 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $3510 = i64toi32_i32$2;
     $3510$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $3508$hi;
     i64toi32_i32$4 = $3508;
     i64toi32_i32$2 = $3510$hi;
     i64toi32_i32$3 = $3510;
     i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
     $3511 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $3511$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($6 | 0, i64toi32_i32$2 | 0, 25 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $3513 = i64toi32_i32$4;
     $3513$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $3511$hi;
     i64toi32_i32$1 = $3511;
     i64toi32_i32$4 = $3513$hi;
     i64toi32_i32$3 = $3513;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $3514 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $3514$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$2 = $13;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
     $3518 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $3518$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$4 = $6;
     i64toi32_i32$2 = $3518$hi;
     i64toi32_i32$3 = $3518;
     i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
     $3519 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     $3519$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$1 = $13;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$4 = i64toi32_i32$2 & i64toi32_i32$4 | 0;
     $3522 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $3522$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3519$hi;
     i64toi32_i32$2 = $3519;
     i64toi32_i32$1 = $3522$hi;
     i64toi32_i32$3 = $3522;
     i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
     $3523 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $3523$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $3514$hi;
     i64toi32_i32$4 = $3514;
     i64toi32_i32$2 = $3523$hi;
     i64toi32_i32$3 = $3523;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $3524$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $11$hi;
     i64toi32_i32$5 = $3524$hi;
     i64toi32_i32$1 = i64toi32_i32$0;
     i64toi32_i32$4 = $11$hi;
     i64toi32_i32$3 = $11;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $7 = i64toi32_i32$2;
     $7$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3506$hi;
     i64toi32_i32$5 = $3506;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$3 = i64toi32_i32$2;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $19 = i64toi32_i32$4;
     $19$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$0 = $89;
     i64toi32_i32$5 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
     $3532 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $3532$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $19$hi;
     i64toi32_i32$2 = i64toi32_i32$4;
     i64toi32_i32$0 = $3532$hi;
     i64toi32_i32$3 = $3532;
     i64toi32_i32$0 = i64toi32_i32$5 & i64toi32_i32$0 | 0;
     $3533$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$0 = $3533$hi;
     i64toi32_i32$5 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $3535 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $3535$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $3396$hi;
     i64toi32_i32$0 = $3396;
     i64toi32_i32$5 = $3535$hi;
     i64toi32_i32$3 = $3535;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $3536$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($19 | 0, i64toi32_i32$4 | 0, 50 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $3538 = i64toi32_i32$0;
     $3538$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($19 | 0, i64toi32_i32$4 | 0, 46 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $3540 = i64toi32_i32$0;
     $3540$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3538$hi;
     i64toi32_i32$2 = $3538;
     i64toi32_i32$0 = $3540$hi;
     i64toi32_i32$3 = $3540;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $3541 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $3541$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($19 | 0, i64toi32_i32$0 | 0, 23 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $3543 = i64toi32_i32$2;
     $3543$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3541$hi;
     i64toi32_i32$4 = $3541;
     i64toi32_i32$2 = $3543$hi;
     i64toi32_i32$3 = $3543;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $3544 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $3544$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $3536$hi;
     i64toi32_i32$0 = i64toi32_i32$1;
     i64toi32_i32$4 = $3544$hi;
     i64toi32_i32$3 = $3544;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     i64toi32_i32$2 = i64toi32_i32$5;
     i64toi32_i32$0 = 116418474;
     i64toi32_i32$3 = 1914138554;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $11 = i64toi32_i32$4;
     $11$hi = i64toi32_i32$5;
     $3547 = i64toi32_i32$4;
     $3547$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 36 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $3549 = i64toi32_i32$2;
     $3549$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 30 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $3551 = i64toi32_i32$2;
     $3551$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $3549$hi;
     i64toi32_i32$1 = $3549;
     i64toi32_i32$2 = $3551$hi;
     i64toi32_i32$3 = $3551;
     i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
     $3552 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $3552$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($7 | 0, i64toi32_i32$2 | 0, 25 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $3554 = i64toi32_i32$1;
     $3554$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $3552$hi;
     i64toi32_i32$5 = $3552;
     i64toi32_i32$1 = $3554$hi;
     i64toi32_i32$3 = $3554;
     i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
     $3555 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $3555$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$2 = $6;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $3559 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $3559$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$1 = $7;
     i64toi32_i32$2 = $3559$hi;
     i64toi32_i32$3 = $3559;
     i64toi32_i32$2 = i64toi32_i32$5 & i64toi32_i32$2 | 0;
     $3560 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $3560$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$5 = $6;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
     $3563 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $3563$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $3560$hi;
     i64toi32_i32$2 = $3560;
     i64toi32_i32$5 = $3563$hi;
     i64toi32_i32$3 = $3563;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $3564 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $3564$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $3555$hi;
     i64toi32_i32$1 = $3555;
     i64toi32_i32$2 = $3564$hi;
     i64toi32_i32$3 = $3564;
     i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $3565$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $17$hi;
     i64toi32_i32$4 = $3565$hi;
     i64toi32_i32$5 = i64toi32_i32$0;
     i64toi32_i32$1 = $17$hi;
     i64toi32_i32$3 = $17;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $13 = i64toi32_i32$2;
     $13$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3547$hi;
     i64toi32_i32$4 = $3547;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$3 = i64toi32_i32$2;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $24 = i64toi32_i32$1;
     $24$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $597$hi;
     i64toi32_i32$0 = $597;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$3 = i64toi32_i32$1;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $3571 = i64toi32_i32$5;
     $3571$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $75$hi;
     i64toi32_i32$1 = $19$hi;
     i64toi32_i32$1 = $75$hi;
     i64toi32_i32$2 = $75;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $3574 = i64toi32_i32$4;
     $3574$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $76$hi;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$5 = $76$hi;
     i64toi32_i32$1 = $76;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $3577 = i64toi32_i32$0;
     $3577$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $73$hi;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$4 = $73$hi;
     i64toi32_i32$5 = $73;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $3580$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$4 = $19;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$5 = i64toi32_i32$0 ^ i64toi32_i32$5 | 0;
     $3584 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $3584$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $24$hi;
     i64toi32_i32$0 = $24;
     i64toi32_i32$4 = $3584$hi;
     i64toi32_i32$3 = $3584;
     i64toi32_i32$4 = i64toi32_i32$5 & i64toi32_i32$4 | 0;
     $3585$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$4 = $3585$hi;
     i64toi32_i32$5 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $3587 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $3587$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3580$hi;
     i64toi32_i32$4 = i64toi32_i32$2;
     i64toi32_i32$5 = $3587$hi;
     i64toi32_i32$3 = $3587;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $3588$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($24 | 0, i64toi32_i32$2 | 0, 50 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $3590 = i64toi32_i32$4;
     $3590$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($24 | 0, i64toi32_i32$2 | 0, 46 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $3592 = i64toi32_i32$4;
     $3592$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $3590$hi;
     i64toi32_i32$0 = $3590;
     i64toi32_i32$4 = $3592$hi;
     i64toi32_i32$3 = $3592;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $3593 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $3593$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($24 | 0, i64toi32_i32$4 | 0, 23 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $3595 = i64toi32_i32$0;
     $3595$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3593$hi;
     i64toi32_i32$2 = $3593;
     i64toi32_i32$0 = $3595$hi;
     i64toi32_i32$3 = $3595;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $3596 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $3596$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3588$hi;
     i64toi32_i32$4 = i64toi32_i32$1;
     i64toi32_i32$2 = $3596$hi;
     i64toi32_i32$3 = $3596;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     i64toi32_i32$0 = i64toi32_i32$5;
     i64toi32_i32$4 = 174292421;
     i64toi32_i32$3 = -1563912026;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $17 = i64toi32_i32$2;
     $17$hi = i64toi32_i32$5;
     $3599 = i64toi32_i32$2;
     $3599$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($13 | 0, i64toi32_i32$5 | 0, 36 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $3601 = i64toi32_i32$0;
     $3601$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($13 | 0, i64toi32_i32$5 | 0, 30 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $3603 = i64toi32_i32$0;
     $3603$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $3601$hi;
     i64toi32_i32$1 = $3601;
     i64toi32_i32$0 = $3603$hi;
     i64toi32_i32$3 = $3603;
     i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
     $3604 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $3604$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($13 | 0, i64toi32_i32$0 | 0, 25 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $3606 = i64toi32_i32$1;
     $3606$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3604$hi;
     i64toi32_i32$5 = $3604;
     i64toi32_i32$1 = $3606$hi;
     i64toi32_i32$3 = $3606;
     i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
     $3607 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $3607$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$0 = $7;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $3611 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $3611$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$1 = $13;
     i64toi32_i32$0 = $3611$hi;
     i64toi32_i32$3 = $3611;
     i64toi32_i32$0 = i64toi32_i32$5 & i64toi32_i32$0 | 0;
     $3612 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $3612$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$5 = $7;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
     $3615 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $3615$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $3612$hi;
     i64toi32_i32$0 = $3612;
     i64toi32_i32$5 = $3615$hi;
     i64toi32_i32$3 = $3615;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $3616 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $3616$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $3607$hi;
     i64toi32_i32$1 = $3607;
     i64toi32_i32$0 = $3616$hi;
     i64toi32_i32$3 = $3616;
     i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $3617$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $26$hi;
     i64toi32_i32$2 = $3617$hi;
     i64toi32_i32$5 = i64toi32_i32$4;
     i64toi32_i32$1 = $26$hi;
     i64toi32_i32$3 = $26;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $6 = i64toi32_i32$0;
     $6$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3599$hi;
     i64toi32_i32$2 = $3599;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$3 = i64toi32_i32$0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $12 = i64toi32_i32$1;
     $12$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$4 = $24;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $3625 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $3625$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$0 = i64toi32_i32$1;
     i64toi32_i32$4 = $3625$hi;
     i64toi32_i32$3 = $3625;
     i64toi32_i32$4 = i64toi32_i32$2 & i64toi32_i32$4 | 0;
     $3626$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$4 = $3626$hi;
     i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $3628 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $3628$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3577$hi;
     i64toi32_i32$4 = $3577;
     i64toi32_i32$2 = $3628$hi;
     i64toi32_i32$3 = $3628;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $3629$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($12 | 0, i64toi32_i32$1 | 0, 50 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $3631 = i64toi32_i32$4;
     $3631$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($12 | 0, i64toi32_i32$1 | 0, 46 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $3633 = i64toi32_i32$4;
     $3633$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $3631$hi;
     i64toi32_i32$0 = $3631;
     i64toi32_i32$4 = $3633$hi;
     i64toi32_i32$3 = $3633;
     i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
     $3634 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $3634$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($12 | 0, i64toi32_i32$4 | 0, 23 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $3636 = i64toi32_i32$0;
     $3636$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3634$hi;
     i64toi32_i32$1 = $3634;
     i64toi32_i32$0 = $3636$hi;
     i64toi32_i32$3 = $3636;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $3637 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $3637$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3629$hi;
     i64toi32_i32$4 = i64toi32_i32$5;
     i64toi32_i32$1 = $3637$hi;
     i64toi32_i32$3 = $3637;
     i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     i64toi32_i32$0 = i64toi32_i32$2;
     i64toi32_i32$4 = 289380356;
     i64toi32_i32$3 = -1090974290;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $26 = i64toi32_i32$1;
     $26$hi = i64toi32_i32$2;
     $3640 = i64toi32_i32$1;
     $3640$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($6 | 0, i64toi32_i32$2 | 0, 36 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $3642 = i64toi32_i32$0;
     $3642$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($6 | 0, i64toi32_i32$2 | 0, 30 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $3644 = i64toi32_i32$0;
     $3644$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $3642$hi;
     i64toi32_i32$5 = $3642;
     i64toi32_i32$0 = $3644$hi;
     i64toi32_i32$3 = $3644;
     i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
     $3645 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $3645$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$5 = 0;
     i64toi32_i32$5 = __wasm_rotl_i64($6 | 0, i64toi32_i32$0 | 0, 25 | 0, i64toi32_i32$5 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $3647 = i64toi32_i32$5;
     $3647$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3645$hi;
     i64toi32_i32$2 = $3645;
     i64toi32_i32$5 = $3647$hi;
     i64toi32_i32$3 = $3647;
     i64toi32_i32$5 = i64toi32_i32$0 ^ i64toi32_i32$5 | 0;
     $3648 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $3648$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$0 = $13;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
     $3652 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $3652$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$5 = $6;
     i64toi32_i32$0 = $3652$hi;
     i64toi32_i32$3 = $3652;
     i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
     $3653 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $3653$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$2 = $13;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$5 = i64toi32_i32$0 & i64toi32_i32$5 | 0;
     $3656 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     $3656$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $3653$hi;
     i64toi32_i32$0 = $3653;
     i64toi32_i32$2 = $3656$hi;
     i64toi32_i32$3 = $3656;
     i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
     $3657 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $3657$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $3648$hi;
     i64toi32_i32$5 = $3648;
     i64toi32_i32$0 = $3657$hi;
     i64toi32_i32$3 = $3657;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $3658$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $28$hi;
     i64toi32_i32$1 = $3658$hi;
     i64toi32_i32$2 = i64toi32_i32$4;
     i64toi32_i32$5 = $28$hi;
     i64toi32_i32$3 = $28;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $7 = i64toi32_i32$0;
     $7$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3640$hi;
     i64toi32_i32$1 = $3640;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$3 = i64toi32_i32$0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $89 = i64toi32_i32$5;
     $89$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$4 = $12;
     i64toi32_i32$1 = $24$hi;
     i64toi32_i32$3 = $24;
     i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
     $3666 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $3666$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $89$hi;
     i64toi32_i32$0 = i64toi32_i32$5;
     i64toi32_i32$4 = $3666$hi;
     i64toi32_i32$3 = $3666;
     i64toi32_i32$4 = i64toi32_i32$1 & i64toi32_i32$4 | 0;
     $3667$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$4 = $3667$hi;
     i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$3 = $24;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $3669 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $3669$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3574$hi;
     i64toi32_i32$4 = $3574;
     i64toi32_i32$1 = $3669$hi;
     i64toi32_i32$3 = $3669;
     i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $3670$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($89 | 0, i64toi32_i32$5 | 0, 50 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $3672 = i64toi32_i32$4;
     $3672$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($89 | 0, i64toi32_i32$5 | 0, 46 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $3674 = i64toi32_i32$4;
     $3674$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $3672$hi;
     i64toi32_i32$0 = $3672;
     i64toi32_i32$4 = $3674$hi;
     i64toi32_i32$3 = $3674;
     i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
     $3675 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $3675$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($89 | 0, i64toi32_i32$4 | 0, 23 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $3677 = i64toi32_i32$0;
     $3677$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3675$hi;
     i64toi32_i32$5 = $3675;
     i64toi32_i32$0 = $3677$hi;
     i64toi32_i32$3 = $3677;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $3678 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $3678$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3670$hi;
     i64toi32_i32$4 = i64toi32_i32$2;
     i64toi32_i32$5 = $3678$hi;
     i64toi32_i32$3 = $3678;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     i64toi32_i32$0 = i64toi32_i32$1;
     i64toi32_i32$4 = 460393269;
     i64toi32_i32$3 = 320620315;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $28 = i64toi32_i32$5;
     $28$hi = i64toi32_i32$1;
     $3681 = i64toi32_i32$5;
     $3681$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($7 | 0, i64toi32_i32$1 | 0, 36 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $3683 = i64toi32_i32$0;
     $3683$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($7 | 0, i64toi32_i32$1 | 0, 30 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $3685 = i64toi32_i32$0;
     $3685$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $3683$hi;
     i64toi32_i32$2 = $3683;
     i64toi32_i32$0 = $3685$hi;
     i64toi32_i32$3 = $3685;
     i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
     $3686 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $3686$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 25 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $3688 = i64toi32_i32$2;
     $3688$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3686$hi;
     i64toi32_i32$1 = $3686;
     i64toi32_i32$2 = $3688$hi;
     i64toi32_i32$3 = $3688;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $3689 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $3689$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$0 = $6;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
     $3693 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $3693$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$2 = $7;
     i64toi32_i32$0 = $3693$hi;
     i64toi32_i32$3 = $3693;
     i64toi32_i32$0 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
     $3694 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     $3694$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$1 = $6;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
     $3697 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $3697$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $3694$hi;
     i64toi32_i32$0 = $3694;
     i64toi32_i32$1 = $3697$hi;
     i64toi32_i32$3 = $3697;
     i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
     $3698 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $3698$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $3689$hi;
     i64toi32_i32$2 = $3689;
     i64toi32_i32$0 = $3698$hi;
     i64toi32_i32$3 = $3698;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $3699$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $22$hi;
     i64toi32_i32$5 = $3699$hi;
     i64toi32_i32$1 = i64toi32_i32$4;
     i64toi32_i32$2 = $22$hi;
     i64toi32_i32$3 = $22;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $13 = i64toi32_i32$0;
     $13$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3681$hi;
     i64toi32_i32$5 = $3681;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$3 = i64toi32_i32$0;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $19 = i64toi32_i32$2;
     $19$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$4 = $89;
     i64toi32_i32$5 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$5 = i64toi32_i32$0 ^ i64toi32_i32$5 | 0;
     $3707 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $3707$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $19$hi;
     i64toi32_i32$0 = i64toi32_i32$2;
     i64toi32_i32$4 = $3707$hi;
     i64toi32_i32$3 = $3707;
     i64toi32_i32$4 = i64toi32_i32$5 & i64toi32_i32$4 | 0;
     $3708$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$4 = $3708$hi;
     i64toi32_i32$5 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $3710 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $3710$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3571$hi;
     i64toi32_i32$4 = $3571;
     i64toi32_i32$5 = $3710$hi;
     i64toi32_i32$3 = $3710;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $3711$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($19 | 0, i64toi32_i32$2 | 0, 50 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $3713 = i64toi32_i32$4;
     $3713$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($19 | 0, i64toi32_i32$2 | 0, 46 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $3715 = i64toi32_i32$4;
     $3715$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $3713$hi;
     i64toi32_i32$0 = $3713;
     i64toi32_i32$4 = $3715$hi;
     i64toi32_i32$3 = $3715;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $3716 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $3716$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($19 | 0, i64toi32_i32$4 | 0, 23 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $3718 = i64toi32_i32$0;
     $3718$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3716$hi;
     i64toi32_i32$2 = $3716;
     i64toi32_i32$0 = $3718$hi;
     i64toi32_i32$3 = $3718;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $3719 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $3719$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3711$hi;
     i64toi32_i32$4 = i64toi32_i32$1;
     i64toi32_i32$2 = $3719$hi;
     i64toi32_i32$3 = $3719;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     i64toi32_i32$0 = i64toi32_i32$5;
     i64toi32_i32$4 = 685471733;
     i64toi32_i32$3 = 587496836;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $22 = i64toi32_i32$2;
     $22$hi = i64toi32_i32$5;
     $3722 = i64toi32_i32$2;
     $3722$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($13 | 0, i64toi32_i32$5 | 0, 36 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $3724 = i64toi32_i32$0;
     $3724$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($13 | 0, i64toi32_i32$5 | 0, 30 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $3726 = i64toi32_i32$0;
     $3726$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $3724$hi;
     i64toi32_i32$1 = $3724;
     i64toi32_i32$0 = $3726$hi;
     i64toi32_i32$3 = $3726;
     i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
     $3727 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $3727$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($13 | 0, i64toi32_i32$0 | 0, 25 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $3729 = i64toi32_i32$1;
     $3729$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3727$hi;
     i64toi32_i32$5 = $3727;
     i64toi32_i32$1 = $3729$hi;
     i64toi32_i32$3 = $3729;
     i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
     $3730 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $3730$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$0 = $7;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $3734 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $3734$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$1 = $13;
     i64toi32_i32$0 = $3734$hi;
     i64toi32_i32$3 = $3734;
     i64toi32_i32$0 = i64toi32_i32$5 & i64toi32_i32$0 | 0;
     $3735 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $3735$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$5 = $7;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
     $3738 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $3738$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $3735$hi;
     i64toi32_i32$0 = $3735;
     i64toi32_i32$5 = $3738$hi;
     i64toi32_i32$3 = $3738;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $3739 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $3739$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $3730$hi;
     i64toi32_i32$1 = $3730;
     i64toi32_i32$0 = $3739$hi;
     i64toi32_i32$3 = $3739;
     i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $3740$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $11$hi;
     i64toi32_i32$2 = $3740$hi;
     i64toi32_i32$5 = i64toi32_i32$4;
     i64toi32_i32$1 = $11$hi;
     i64toi32_i32$3 = $11;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $6 = i64toi32_i32$0;
     $6$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3722$hi;
     i64toi32_i32$2 = $3722;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$3 = i64toi32_i32$0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $24 = i64toi32_i32$1;
     $24$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $596$hi;
     i64toi32_i32$4 = $596;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$3 = i64toi32_i32$1;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $3746 = i64toi32_i32$5;
     $3746$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $79$hi;
     i64toi32_i32$1 = $19$hi;
     i64toi32_i32$1 = $79$hi;
     i64toi32_i32$0 = $79;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $3749 = i64toi32_i32$2;
     $3749$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $80$hi;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$5 = $80$hi;
     i64toi32_i32$1 = $80;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $3752 = i64toi32_i32$4;
     $3752$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $77$hi;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$2 = $77$hi;
     i64toi32_i32$5 = $77;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $3755$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$2 = $19;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
     $3759 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $3759$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $24$hi;
     i64toi32_i32$4 = $24;
     i64toi32_i32$2 = $3759$hi;
     i64toi32_i32$3 = $3759;
     i64toi32_i32$2 = i64toi32_i32$5 & i64toi32_i32$2 | 0;
     $3760$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$2 = $3760$hi;
     i64toi32_i32$5 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $3762 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $3762$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3755$hi;
     i64toi32_i32$2 = i64toi32_i32$0;
     i64toi32_i32$5 = $3762$hi;
     i64toi32_i32$3 = $3762;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $3763$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($24 | 0, i64toi32_i32$0 | 0, 50 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $3765 = i64toi32_i32$2;
     $3765$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($24 | 0, i64toi32_i32$0 | 0, 46 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $3767 = i64toi32_i32$2;
     $3767$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3765$hi;
     i64toi32_i32$4 = $3765;
     i64toi32_i32$2 = $3767$hi;
     i64toi32_i32$3 = $3767;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $3768 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $3768$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($24 | 0, i64toi32_i32$2 | 0, 23 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $3770 = i64toi32_i32$4;
     $3770$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $3768$hi;
     i64toi32_i32$0 = $3768;
     i64toi32_i32$4 = $3770$hi;
     i64toi32_i32$3 = $3770;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $3771 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $3771$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3763$hi;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$0 = $3771$hi;
     i64toi32_i32$3 = $3771;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     i64toi32_i32$4 = i64toi32_i32$5;
     i64toi32_i32$2 = 852142971;
     i64toi32_i32$3 = 1086792851;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $12 = i64toi32_i32$0;
     $12$hi = i64toi32_i32$5;
     $3774 = i64toi32_i32$0;
     $3774$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($6 | 0, i64toi32_i32$5 | 0, 36 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $3776 = i64toi32_i32$4;
     $3776$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($6 | 0, i64toi32_i32$5 | 0, 30 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $3778 = i64toi32_i32$4;
     $3778$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $3776$hi;
     i64toi32_i32$1 = $3776;
     i64toi32_i32$4 = $3778$hi;
     i64toi32_i32$3 = $3778;
     i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
     $3779 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $3779$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($6 | 0, i64toi32_i32$4 | 0, 25 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $3781 = i64toi32_i32$1;
     $3781$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3779$hi;
     i64toi32_i32$5 = $3779;
     i64toi32_i32$1 = $3781$hi;
     i64toi32_i32$3 = $3781;
     i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
     $3782 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $3782$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$4 = $13;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $3786 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $3786$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$1 = $6;
     i64toi32_i32$4 = $3786$hi;
     i64toi32_i32$3 = $3786;
     i64toi32_i32$4 = i64toi32_i32$5 & i64toi32_i32$4 | 0;
     $3787 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $3787$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$5 = $13;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$1 = i64toi32_i32$4 & i64toi32_i32$1 | 0;
     $3790 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $3790$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $3787$hi;
     i64toi32_i32$4 = $3787;
     i64toi32_i32$5 = $3790$hi;
     i64toi32_i32$3 = $3790;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $3791 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $3791$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $3782$hi;
     i64toi32_i32$1 = $3782;
     i64toi32_i32$4 = $3791$hi;
     i64toi32_i32$3 = $3791;
     i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $3792$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $17$hi;
     i64toi32_i32$0 = $3792$hi;
     i64toi32_i32$5 = i64toi32_i32$2;
     i64toi32_i32$1 = $17$hi;
     i64toi32_i32$3 = $17;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $7 = i64toi32_i32$4;
     $7$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $3774$hi;
     i64toi32_i32$0 = $3774;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$3 = i64toi32_i32$4;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $89 = i64toi32_i32$1;
     $89$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$2 = $24;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $3800 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $3800$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$4 = i64toi32_i32$1;
     i64toi32_i32$2 = $3800$hi;
     i64toi32_i32$3 = $3800;
     i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
     $3801$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$2 = $3801$hi;
     i64toi32_i32$0 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $3803 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $3803$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3752$hi;
     i64toi32_i32$2 = $3752;
     i64toi32_i32$0 = $3803$hi;
     i64toi32_i32$3 = $3803;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $3804$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $89$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($89 | 0, i64toi32_i32$1 | 0, 50 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $3806 = i64toi32_i32$2;
     $3806$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $89$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($89 | 0, i64toi32_i32$1 | 0, 46 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $3808 = i64toi32_i32$2;
     $3808$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $3806$hi;
     i64toi32_i32$4 = $3806;
     i64toi32_i32$2 = $3808$hi;
     i64toi32_i32$3 = $3808;
     i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
     $3809 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $3809$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($89 | 0, i64toi32_i32$2 | 0, 23 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $3811 = i64toi32_i32$4;
     $3811$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $3809$hi;
     i64toi32_i32$1 = $3809;
     i64toi32_i32$4 = $3811$hi;
     i64toi32_i32$3 = $3811;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $3812 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $3812$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3804$hi;
     i64toi32_i32$2 = i64toi32_i32$5;
     i64toi32_i32$1 = $3812$hi;
     i64toi32_i32$3 = $3812;
     i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     i64toi32_i32$4 = i64toi32_i32$0;
     i64toi32_i32$2 = 1017036298;
     i64toi32_i32$3 = 365543100;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $17 = i64toi32_i32$1;
     $17$hi = i64toi32_i32$0;
     $3815 = i64toi32_i32$1;
     $3815$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 36 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $3817 = i64toi32_i32$4;
     $3817$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 30 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $3819 = i64toi32_i32$4;
     $3819$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3817$hi;
     i64toi32_i32$5 = $3817;
     i64toi32_i32$4 = $3819$hi;
     i64toi32_i32$3 = $3819;
     i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
     $3820 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $3820$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$5 = 0;
     i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 25 | 0, i64toi32_i32$5 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $3822 = i64toi32_i32$5;
     $3822$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3820$hi;
     i64toi32_i32$0 = $3820;
     i64toi32_i32$5 = $3822$hi;
     i64toi32_i32$3 = $3822;
     i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
     $3823 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $3823$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$4 = $6;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
     $3827 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $3827$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$5 = $7;
     i64toi32_i32$4 = $3827$hi;
     i64toi32_i32$3 = $3827;
     i64toi32_i32$4 = i64toi32_i32$0 & i64toi32_i32$4 | 0;
     $3828 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $3828$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$0 = $6;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$5 = i64toi32_i32$4 & i64toi32_i32$5 | 0;
     $3831 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
     $3831$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $3828$hi;
     i64toi32_i32$4 = $3828;
     i64toi32_i32$0 = $3831$hi;
     i64toi32_i32$3 = $3831;
     i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
     $3832 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $3832$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3823$hi;
     i64toi32_i32$5 = $3823;
     i64toi32_i32$4 = $3832$hi;
     i64toi32_i32$3 = $3832;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $3833$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $26$hi;
     i64toi32_i32$1 = $3833$hi;
     i64toi32_i32$0 = i64toi32_i32$2;
     i64toi32_i32$5 = $26$hi;
     i64toi32_i32$3 = $26;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $13 = i64toi32_i32$4;
     $13$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $3815$hi;
     i64toi32_i32$1 = $3815;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$3 = i64toi32_i32$4;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $19 = i64toi32_i32$5;
     $19$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$2 = $89;
     i64toi32_i32$1 = $24$hi;
     i64toi32_i32$3 = $24;
     i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
     $3841 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $3841$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $19$hi;
     i64toi32_i32$4 = i64toi32_i32$5;
     i64toi32_i32$2 = $3841$hi;
     i64toi32_i32$3 = $3841;
     i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
     $3842$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$2 = $3842$hi;
     i64toi32_i32$1 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$3 = $24;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $3844 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $3844$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3749$hi;
     i64toi32_i32$2 = $3749;
     i64toi32_i32$1 = $3844$hi;
     i64toi32_i32$3 = $3844;
     i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $3845$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $19$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($19 | 0, i64toi32_i32$5 | 0, 50 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $3847 = i64toi32_i32$2;
     $3847$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $19$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($19 | 0, i64toi32_i32$5 | 0, 46 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $3849 = i64toi32_i32$2;
     $3849$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $3847$hi;
     i64toi32_i32$4 = $3847;
     i64toi32_i32$2 = $3849$hi;
     i64toi32_i32$3 = $3849;
     i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
     $3850 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $3850$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($19 | 0, i64toi32_i32$2 | 0, 23 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $3852 = i64toi32_i32$4;
     $3852$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $3850$hi;
     i64toi32_i32$5 = $3850;
     i64toi32_i32$4 = $3852$hi;
     i64toi32_i32$3 = $3852;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $3853 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $3853$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3845$hi;
     i64toi32_i32$2 = i64toi32_i32$0;
     i64toi32_i32$5 = $3853$hi;
     i64toi32_i32$3 = $3853;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     i64toi32_i32$4 = i64toi32_i32$1;
     i64toi32_i32$2 = 1126000580;
     i64toi32_i32$3 = -1676669620;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $26 = i64toi32_i32$5;
     $26$hi = i64toi32_i32$1;
     $3856 = i64toi32_i32$5;
     $3856$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($13 | 0, i64toi32_i32$1 | 0, 36 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $3858 = i64toi32_i32$4;
     $3858$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($13 | 0, i64toi32_i32$1 | 0, 30 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $3860 = i64toi32_i32$4;
     $3860$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $3858$hi;
     i64toi32_i32$0 = $3858;
     i64toi32_i32$4 = $3860$hi;
     i64toi32_i32$3 = $3860;
     i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
     $3861 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $3861$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($13 | 0, i64toi32_i32$4 | 0, 25 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $3863 = i64toi32_i32$0;
     $3863$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3861$hi;
     i64toi32_i32$1 = $3861;
     i64toi32_i32$0 = $3863$hi;
     i64toi32_i32$3 = $3863;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $3864 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $3864$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$4 = $7;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
     $3868 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $3868$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$0 = $13;
     i64toi32_i32$4 = $3868$hi;
     i64toi32_i32$3 = $3868;
     i64toi32_i32$4 = i64toi32_i32$1 & i64toi32_i32$4 | 0;
     $3869 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
     $3869$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$1 = $7;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$0 = i64toi32_i32$4 & i64toi32_i32$0 | 0;
     $3872 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $3872$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3869$hi;
     i64toi32_i32$4 = $3869;
     i64toi32_i32$1 = $3872$hi;
     i64toi32_i32$3 = $3872;
     i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
     $3873 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $3873$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $3864$hi;
     i64toi32_i32$0 = $3864;
     i64toi32_i32$4 = $3873$hi;
     i64toi32_i32$3 = $3873;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $3874$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $28$hi;
     i64toi32_i32$5 = $3874$hi;
     i64toi32_i32$1 = i64toi32_i32$2;
     i64toi32_i32$0 = $28$hi;
     i64toi32_i32$3 = $28;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $6 = i64toi32_i32$4;
     $6$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $3856$hi;
     i64toi32_i32$5 = $3856;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$3 = i64toi32_i32$4;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $24 = i64toi32_i32$0;
     $24$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$2 = $19;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
     $3882 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $3882$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $24$hi;
     i64toi32_i32$4 = i64toi32_i32$0;
     i64toi32_i32$2 = $3882$hi;
     i64toi32_i32$3 = $3882;
     i64toi32_i32$2 = i64toi32_i32$5 & i64toi32_i32$2 | 0;
     $3883$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$2 = $3883$hi;
     i64toi32_i32$5 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $3885 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $3885$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3746$hi;
     i64toi32_i32$2 = $3746;
     i64toi32_i32$5 = $3885$hi;
     i64toi32_i32$3 = $3885;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $3886$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($24 | 0, i64toi32_i32$0 | 0, 50 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $3888 = i64toi32_i32$2;
     $3888$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($24 | 0, i64toi32_i32$0 | 0, 46 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $3890 = i64toi32_i32$2;
     $3890$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3888$hi;
     i64toi32_i32$4 = $3888;
     i64toi32_i32$2 = $3890$hi;
     i64toi32_i32$3 = $3890;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $3891 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $3891$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($24 | 0, i64toi32_i32$2 | 0, 23 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $3893 = i64toi32_i32$4;
     $3893$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $3891$hi;
     i64toi32_i32$0 = $3891;
     i64toi32_i32$4 = $3893$hi;
     i64toi32_i32$3 = $3893;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $3894 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $3894$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3886$hi;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$0 = $3894$hi;
     i64toi32_i32$3 = $3894;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     i64toi32_i32$4 = i64toi32_i32$5;
     i64toi32_i32$2 = 1288033470;
     i64toi32_i32$3 = -885112138;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $28 = i64toi32_i32$0;
     $28$hi = i64toi32_i32$5;
     $3897 = i64toi32_i32$0;
     $3897$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($6 | 0, i64toi32_i32$5 | 0, 36 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $3899 = i64toi32_i32$4;
     $3899$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($6 | 0, i64toi32_i32$5 | 0, 30 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $3901 = i64toi32_i32$4;
     $3901$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $3899$hi;
     i64toi32_i32$1 = $3899;
     i64toi32_i32$4 = $3901$hi;
     i64toi32_i32$3 = $3901;
     i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
     $3902 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $3902$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($6 | 0, i64toi32_i32$4 | 0, 25 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $3904 = i64toi32_i32$1;
     $3904$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3902$hi;
     i64toi32_i32$5 = $3902;
     i64toi32_i32$1 = $3904$hi;
     i64toi32_i32$3 = $3904;
     i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
     $3905 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $3905$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$4 = $13;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $3909 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $3909$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$1 = $6;
     i64toi32_i32$4 = $3909$hi;
     i64toi32_i32$3 = $3909;
     i64toi32_i32$4 = i64toi32_i32$5 & i64toi32_i32$4 | 0;
     $3910 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $3910$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$5 = $13;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$1 = i64toi32_i32$4 & i64toi32_i32$1 | 0;
     $3913 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $3913$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $3910$hi;
     i64toi32_i32$4 = $3910;
     i64toi32_i32$5 = $3913$hi;
     i64toi32_i32$3 = $3913;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $3914 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $3914$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $3905$hi;
     i64toi32_i32$1 = $3905;
     i64toi32_i32$4 = $3914$hi;
     i64toi32_i32$3 = $3914;
     i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $3915$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $22$hi;
     i64toi32_i32$0 = $3915$hi;
     i64toi32_i32$5 = i64toi32_i32$2;
     i64toi32_i32$1 = $22$hi;
     i64toi32_i32$3 = $22;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $7 = i64toi32_i32$4;
     $7$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $3897$hi;
     i64toi32_i32$0 = $3897;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$3 = i64toi32_i32$4;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $11 = i64toi32_i32$1;
     $11$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $86$hi;
     i64toi32_i32$4 = $11$hi;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$0 = $86$hi;
     i64toi32_i32$3 = $86;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     i64toi32_i32$2 = $595;
     HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] = i64toi32_i32$5;
     HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] = i64toi32_i32$1;
     $3923 = $0;
     i64toi32_i32$1 = $90$hi;
     $3924 = $90;
     $3924$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$1 | 0, 36 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $3926 = i64toi32_i32$2;
     $3926$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$1 | 0, 30 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $3928 = i64toi32_i32$2;
     $3928$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $3926$hi;
     i64toi32_i32$4 = $3926;
     i64toi32_i32$2 = $3928$hi;
     i64toi32_i32$3 = $3928;
     i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
     $3929 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $3929$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($7 | 0, i64toi32_i32$2 | 0, 25 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $3931 = i64toi32_i32$4;
     $3931$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $3929$hi;
     i64toi32_i32$1 = $3929;
     i64toi32_i32$4 = $3931$hi;
     i64toi32_i32$3 = $3931;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $3932 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $3932$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$2 = $6;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
     $3936 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $3936$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$4 = $7;
     i64toi32_i32$2 = $3936$hi;
     i64toi32_i32$3 = $3936;
     i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
     $3937 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     $3937$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$1 = $6;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$4 = i64toi32_i32$2 & i64toi32_i32$4 | 0;
     $3940 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $3940$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3937$hi;
     i64toi32_i32$2 = $3937;
     i64toi32_i32$1 = $3940$hi;
     i64toi32_i32$3 = $3940;
     i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
     $3941 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $3941$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $3932$hi;
     i64toi32_i32$4 = $3932;
     i64toi32_i32$2 = $3941$hi;
     i64toi32_i32$3 = $3941;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $3942$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $12$hi;
     i64toi32_i32$5 = $3942$hi;
     i64toi32_i32$1 = i64toi32_i32$0;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $13 = i64toi32_i32$2;
     $13$hi = i64toi32_i32$0;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64(i64toi32_i32$2 | 0, i64toi32_i32$0 | 0, 36 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $3946 = i64toi32_i32$1;
     $3946$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64(i64toi32_i32$2 | 0, i64toi32_i32$0 | 0, 30 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $3948 = i64toi32_i32$1;
     $3948$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3946$hi;
     i64toi32_i32$5 = $3946;
     i64toi32_i32$1 = $3948$hi;
     i64toi32_i32$3 = $3948;
     i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
     $3949 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $3949$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$5 = 0;
     i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$2 | 0, i64toi32_i32$1 | 0, 25 | 0, i64toi32_i32$5 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $3951 = i64toi32_i32$5;
     $3951$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $3949$hi;
     i64toi32_i32$0 = $3949;
     i64toi32_i32$5 = $3951$hi;
     i64toi32_i32$3 = $3951;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $3952 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $3952$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$1 = $7;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
     $3956 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $3956$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$5 = i64toi32_i32$2;
     i64toi32_i32$1 = $3956$hi;
     i64toi32_i32$3 = $3956;
     i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
     $3957 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     $3957$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$0 = $7;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$5 = i64toi32_i32$1 & i64toi32_i32$5 | 0;
     $3960 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
     $3960$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $3957$hi;
     i64toi32_i32$1 = $3957;
     i64toi32_i32$0 = $3960$hi;
     i64toi32_i32$3 = $3960;
     i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
     $3961 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $3961$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3952$hi;
     i64toi32_i32$5 = $3952;
     i64toi32_i32$1 = $3961$hi;
     i64toi32_i32$3 = $3961;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $3962$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $17$hi;
     i64toi32_i32$2 = $3962$hi;
     i64toi32_i32$0 = i64toi32_i32$4;
     i64toi32_i32$5 = $17$hi;
     i64toi32_i32$3 = $17;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $6 = i64toi32_i32$1;
     $6$hi = i64toi32_i32$4;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$4 | 0, 36 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $3966 = i64toi32_i32$0;
     $3966$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$4 | 0, 30 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $3968 = i64toi32_i32$0;
     $3968$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3966$hi;
     i64toi32_i32$2 = $3966;
     i64toi32_i32$0 = $3968$hi;
     i64toi32_i32$3 = $3968;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $3969 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $3969$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$0 | 0, 25 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $3971 = i64toi32_i32$2;
     $3971$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3969$hi;
     i64toi32_i32$4 = $3969;
     i64toi32_i32$2 = $3971$hi;
     i64toi32_i32$3 = $3971;
     i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
     $3972 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $3972$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$0 = $13;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $3976 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $3976$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$0 = $3976$hi;
     i64toi32_i32$3 = $3976;
     i64toi32_i32$0 = i64toi32_i32$4 & i64toi32_i32$0 | 0;
     $3977 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     $3977$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$4 = $13;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
     $3980 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     $3980$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $3977$hi;
     i64toi32_i32$0 = $3977;
     i64toi32_i32$4 = $3980$hi;
     i64toi32_i32$3 = $3980;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $3981 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $3981$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3972$hi;
     i64toi32_i32$2 = $3972;
     i64toi32_i32$0 = $3981$hi;
     i64toi32_i32$3 = $3981;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $3982$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $26$hi;
     i64toi32_i32$1 = $3982$hi;
     i64toi32_i32$4 = i64toi32_i32$5;
     i64toi32_i32$2 = $26$hi;
     i64toi32_i32$3 = $26;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $7 = i64toi32_i32$0;
     $7$hi = i64toi32_i32$5;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64(i64toi32_i32$0 | 0, i64toi32_i32$5 | 0, 36 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $3986 = i64toi32_i32$4;
     $3986$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64(i64toi32_i32$0 | 0, i64toi32_i32$5 | 0, 30 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $3988 = i64toi32_i32$4;
     $3988$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $3986$hi;
     i64toi32_i32$1 = $3986;
     i64toi32_i32$4 = $3988$hi;
     i64toi32_i32$3 = $3988;
     i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
     $3989 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $3989$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64(i64toi32_i32$0 | 0, i64toi32_i32$4 | 0, 25 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $3991 = i64toi32_i32$1;
     $3991$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $3989$hi;
     i64toi32_i32$5 = $3989;
     i64toi32_i32$1 = $3991$hi;
     i64toi32_i32$3 = $3991;
     i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
     $3992 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $3992$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$4 = $6;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $3996 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $3996$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$1 = i64toi32_i32$0;
     i64toi32_i32$4 = $3996$hi;
     i64toi32_i32$3 = $3996;
     i64toi32_i32$4 = i64toi32_i32$5 & i64toi32_i32$4 | 0;
     $3997 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
     $3997$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$5 = $6;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$1 = i64toi32_i32$4 & i64toi32_i32$1 | 0;
     $4000 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $4000$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $3997$hi;
     i64toi32_i32$4 = $3997;
     i64toi32_i32$5 = $4000$hi;
     i64toi32_i32$3 = $4000;
     i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
     $4001 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $4001$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $3992$hi;
     i64toi32_i32$1 = $3992;
     i64toi32_i32$4 = $4001$hi;
     i64toi32_i32$3 = $4001;
     i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $4002$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $28$hi;
     i64toi32_i32$0 = $4002$hi;
     i64toi32_i32$5 = i64toi32_i32$2;
     i64toi32_i32$1 = $28$hi;
     i64toi32_i32$3 = $28;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $12 = i64toi32_i32$4;
     $12$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $3924$hi;
     i64toi32_i32$0 = $3924;
     i64toi32_i32$5 = $12$hi;
     i64toi32_i32$3 = i64toi32_i32$4;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     i64toi32_i32$0 = $3923;
     HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = i64toi32_i32$4;
     $4007 = $0;
     i64toi32_i32$4 = $87$hi;
     $4008 = $87;
     $4008$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $81$hi;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$4 = $81$hi;
     i64toi32_i32$2 = $81;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$3 = $89;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $4011$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $11$hi;
     i64toi32_i32$1 = $24$hi;
     i64toi32_i32$1 = $19$hi;
     i64toi32_i32$1 = $24$hi;
     i64toi32_i32$4 = $24;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
     $4015 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $4015$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $11$hi;
     i64toi32_i32$1 = $11;
     i64toi32_i32$4 = $4015$hi;
     i64toi32_i32$3 = $4015;
     i64toi32_i32$4 = i64toi32_i32$2 & i64toi32_i32$4 | 0;
     $4016$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$4 = $4016$hi;
     i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     i64toi32_i32$1 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
     $4018 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $4018$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $4011$hi;
     i64toi32_i32$4 = i64toi32_i32$5;
     i64toi32_i32$2 = $4018$hi;
     i64toi32_i32$3 = $4018;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $4019$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $11$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($11 | 0, i64toi32_i32$5 | 0, 50 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $4021 = i64toi32_i32$4;
     $4021$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $11$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($11 | 0, i64toi32_i32$5 | 0, 46 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $4023 = i64toi32_i32$4;
     $4023$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $4021$hi;
     i64toi32_i32$1 = $4021;
     i64toi32_i32$4 = $4023$hi;
     i64toi32_i32$3 = $4023;
     i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
     $4024 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $4024$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $11$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($11 | 0, i64toi32_i32$4 | 0, 23 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $4026 = i64toi32_i32$1;
     $4026$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $4024$hi;
     i64toi32_i32$5 = $4024;
     i64toi32_i32$1 = $4026$hi;
     i64toi32_i32$3 = $4026;
     i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
     $4027 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $4027$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $4019$hi;
     i64toi32_i32$4 = i64toi32_i32$0;
     i64toi32_i32$5 = $4027$hi;
     i64toi32_i32$3 = $4027;
     i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     i64toi32_i32$1 = i64toi32_i32$2;
     i64toi32_i32$4 = 1501505948;
     i64toi32_i32$3 = -60457430;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $17 = i64toi32_i32$5;
     $17$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$2 = $17$hi;
     i64toi32_i32$0 = i64toi32_i32$5;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$3 = $13;
     i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $89 = i64toi32_i32$4;
     $89$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $4008$hi;
     i64toi32_i32$2 = $4008;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$3 = i64toi32_i32$4;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     i64toi32_i32$2 = $4007;
     HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = i64toi32_i32$4;
     $4035 = $0;
     i64toi32_i32$4 = $92$hi;
     $4036 = $92;
     $4036$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($12 | 0, i64toi32_i32$4 | 0, 36 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $4038 = i64toi32_i32$2;
     $4038$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($12 | 0, i64toi32_i32$4 | 0, 30 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $4040 = i64toi32_i32$2;
     $4040$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $4038$hi;
     i64toi32_i32$5 = $4038;
     i64toi32_i32$2 = $4040$hi;
     i64toi32_i32$3 = $4040;
     i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
     $4041 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $4041$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$5 = 0;
     i64toi32_i32$5 = __wasm_rotl_i64($12 | 0, i64toi32_i32$2 | 0, 25 | 0, i64toi32_i32$5 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $4043 = i64toi32_i32$5;
     $4043$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $4041$hi;
     i64toi32_i32$4 = $4041;
     i64toi32_i32$5 = $4043$hi;
     i64toi32_i32$3 = $4043;
     i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
     $4044 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $4044$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $12$hi;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$2 = $7;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
     $4048 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $4048$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$5 = $12;
     i64toi32_i32$2 = $4048$hi;
     i64toi32_i32$3 = $4048;
     i64toi32_i32$2 = i64toi32_i32$4 & i64toi32_i32$2 | 0;
     $4049 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $4049$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$4 = $7;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$5 = i64toi32_i32$2 & i64toi32_i32$5 | 0;
     $4052 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     $4052$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $4049$hi;
     i64toi32_i32$2 = $4049;
     i64toi32_i32$4 = $4052$hi;
     i64toi32_i32$3 = $4052;
     i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
     $4053 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $4053$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $4044$hi;
     i64toi32_i32$5 = $4044;
     i64toi32_i32$2 = $4053$hi;
     i64toi32_i32$3 = $4053;
     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $4054$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $17$hi;
     i64toi32_i32$1 = $4054$hi;
     i64toi32_i32$4 = i64toi32_i32$0;
     i64toi32_i32$5 = $17$hi;
     i64toi32_i32$3 = $17;
     i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $13 = i64toi32_i32$2;
     $13$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $4036$hi;
     i64toi32_i32$1 = $4036;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$3 = i64toi32_i32$2;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     i64toi32_i32$1 = $4035;
     HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = i64toi32_i32$5;
     HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$2;
     $4059 = $0;
     i64toi32_i32$2 = $88$hi;
     $4060 = $88;
     $4060$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $84$hi;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$2 = $84$hi;
     i64toi32_i32$0 = $84;
     i64toi32_i32$1 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $4063$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $89$hi;
     i64toi32_i32$5 = $11$hi;
     i64toi32_i32$5 = $24$hi;
     i64toi32_i32$5 = $11$hi;
     i64toi32_i32$2 = $11;
     i64toi32_i32$0 = $24$hi;
     i64toi32_i32$3 = $24;
     i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
     $4067 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $4067$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $89$hi;
     i64toi32_i32$5 = $89;
     i64toi32_i32$2 = $4067$hi;
     i64toi32_i32$3 = $4067;
     i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
     $4068$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $24$hi;
     i64toi32_i32$2 = $4068$hi;
     i64toi32_i32$0 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     i64toi32_i32$5 = $24$hi;
     i64toi32_i32$3 = $24;
     i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
     $4070 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $4070$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $4063$hi;
     i64toi32_i32$2 = i64toi32_i32$4;
     i64toi32_i32$0 = $4070$hi;
     i64toi32_i32$3 = $4070;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $4071$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($89 | 0, i64toi32_i32$4 | 0, 50 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $4073 = i64toi32_i32$2;
     $4073$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $89$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($89 | 0, i64toi32_i32$4 | 0, 46 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $4075 = i64toi32_i32$2;
     $4075$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $4073$hi;
     i64toi32_i32$5 = $4073;
     i64toi32_i32$2 = $4075$hi;
     i64toi32_i32$3 = $4075;
     i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
     $4076 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $4076$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$5 = 0;
     i64toi32_i32$5 = __wasm_rotl_i64($89 | 0, i64toi32_i32$2 | 0, 23 | 0, i64toi32_i32$5 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $4078 = i64toi32_i32$5;
     $4078$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $4076$hi;
     i64toi32_i32$4 = $4076;
     i64toi32_i32$5 = $4078$hi;
     i64toi32_i32$3 = $4078;
     i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
     $4079 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $4079$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $4071$hi;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$4 = $4079$hi;
     i64toi32_i32$3 = $4079;
     i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     i64toi32_i32$5 = i64toi32_i32$0;
     i64toi32_i32$2 = 1607167915;
     i64toi32_i32$3 = 987167468;
     i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $19 = i64toi32_i32$4;
     $19$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$0 = $19$hi;
     i64toi32_i32$1 = i64toi32_i32$4;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $6 = i64toi32_i32$2;
     $6$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $4060$hi;
     i64toi32_i32$0 = $4060;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$3 = i64toi32_i32$2;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
     i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     i64toi32_i32$0 = $4059;
     HEAP32[(i64toi32_i32$0 + 40 | 0) >> 2] = i64toi32_i32$5;
     HEAP32[(i64toi32_i32$0 + 44 | 0) >> 2] = i64toi32_i32$2;
     $4087 = $0;
     i64toi32_i32$2 = $94$hi;
     $4088 = $94;
     $4088$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($13 | 0, i64toi32_i32$2 | 0, 36 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $4090 = i64toi32_i32$0;
     $4090$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($13 | 0, i64toi32_i32$2 | 0, 30 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $4092 = i64toi32_i32$0;
     $4092$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $4090$hi;
     i64toi32_i32$4 = $4090;
     i64toi32_i32$0 = $4092$hi;
     i64toi32_i32$3 = $4092;
     i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
     $4093 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $4093$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($13 | 0, i64toi32_i32$0 | 0, 25 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $4095 = i64toi32_i32$4;
     $4095$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $4093$hi;
     i64toi32_i32$2 = $4093;
     i64toi32_i32$4 = $4095$hi;
     i64toi32_i32$3 = $4095;
     i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
     $4096 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $4096$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $13$hi;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$0 = $12;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
     $4100 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $4100$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$4 = $13;
     i64toi32_i32$0 = $4100$hi;
     i64toi32_i32$3 = $4100;
     i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
     $4101 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     $4101$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$2 = $12;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$4 = i64toi32_i32$0 & i64toi32_i32$4 | 0;
     $4104 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     $4104$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $4101$hi;
     i64toi32_i32$0 = $4101;
     i64toi32_i32$2 = $4104$hi;
     i64toi32_i32$3 = $4104;
     i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
     $4105 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $4105$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $4096$hi;
     i64toi32_i32$4 = $4096;
     i64toi32_i32$0 = $4105$hi;
     i64toi32_i32$3 = $4105;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $4106$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $19$hi;
     i64toi32_i32$5 = $4106$hi;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$3 = $19;
     i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $19 = i64toi32_i32$0;
     $19$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $4088$hi;
     i64toi32_i32$5 = $4088;
     i64toi32_i32$2 = $19$hi;
     i64toi32_i32$3 = i64toi32_i32$0;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
     i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     i64toi32_i32$5 = $4087;
     HEAP32[(i64toi32_i32$5 + 8 | 0) >> 2] = i64toi32_i32$4;
     HEAP32[(i64toi32_i32$5 + 12 | 0) >> 2] = i64toi32_i32$0;
     $4111 = $0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$0 = $85$hi;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$1 = $7;
     i64toi32_i32$5 = $85$hi;
     i64toi32_i32$3 = $85;
     i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $4114 = i64toi32_i32$2;
     $4114$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $83$hi;
     i64toi32_i32$4 = $24$hi;
     i64toi32_i32$4 = $83$hi;
     i64toi32_i32$0 = $83;
     i64toi32_i32$1 = $24$hi;
     i64toi32_i32$3 = $24;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $4117$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$2 = $11$hi;
     i64toi32_i32$2 = $89$hi;
     i64toi32_i32$4 = $89;
     i64toi32_i32$0 = $11$hi;
     i64toi32_i32$3 = $11;
     i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
     $4121 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $4121$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$2 = $6;
     i64toi32_i32$4 = $4121$hi;
     i64toi32_i32$3 = $4121;
     i64toi32_i32$4 = i64toi32_i32$0 & i64toi32_i32$4 | 0;
     $4122$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $11$hi;
     i64toi32_i32$4 = $4122$hi;
     i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     i64toi32_i32$2 = $11$hi;
     i64toi32_i32$3 = $11;
     i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
     $4124 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $4124$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $4117$hi;
     i64toi32_i32$4 = i64toi32_i32$5;
     i64toi32_i32$0 = $4124$hi;
     i64toi32_i32$3 = $4124;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $4125$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($6 | 0, i64toi32_i32$5 | 0, 50 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $4127 = i64toi32_i32$4;
     $4127$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($6 | 0, i64toi32_i32$5 | 0, 46 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $4129 = i64toi32_i32$4;
     $4129$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $4127$hi;
     i64toi32_i32$2 = $4127;
     i64toi32_i32$4 = $4129$hi;
     i64toi32_i32$3 = $4129;
     i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
     $4130 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $4130$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$2 = 0;
     i64toi32_i32$2 = __wasm_rotl_i64($6 | 0, i64toi32_i32$4 | 0, 23 | 0, i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $4132 = i64toi32_i32$2;
     $4132$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $4130$hi;
     i64toi32_i32$5 = $4130;
     i64toi32_i32$2 = $4132$hi;
     i64toi32_i32$3 = $4132;
     i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
     $4133 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
     $4133$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $4125$hi;
     i64toi32_i32$4 = i64toi32_i32$1;
     i64toi32_i32$5 = $4133$hi;
     i64toi32_i32$3 = $4133;
     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     i64toi32_i32$2 = i64toi32_i32$0;
     i64toi32_i32$4 = 1816402316;
     i64toi32_i32$3 = 1246189591;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     $85 = i64toi32_i32$5;
     $85$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $4114$hi;
     i64toi32_i32$1 = $4114;
     i64toi32_i32$2 = $85$hi;
     i64toi32_i32$3 = i64toi32_i32$5;
     i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     i64toi32_i32$1 = $4111;
     HEAP32[(i64toi32_i32$1 + 32 | 0) >> 2] = i64toi32_i32$4;
     HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] = i64toi32_i32$5;
     $4138 = $0;
     i64toi32_i32$5 = $5$hi;
     i64toi32_i32$5 = $19$hi;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$5 = $12$hi;
     i64toi32_i32$5 = $13$hi;
     i64toi32_i32$0 = $13;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
     $4143 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $4143$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $19$hi;
     i64toi32_i32$5 = $19;
     i64toi32_i32$0 = $4143$hi;
     i64toi32_i32$3 = $4143;
     i64toi32_i32$0 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
     $4144 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     $4144$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$1 = $13;
     i64toi32_i32$5 = $12$hi;
     i64toi32_i32$3 = $12;
     i64toi32_i32$5 = i64toi32_i32$0 & i64toi32_i32$5 | 0;
     $4147 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $4147$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $4144$hi;
     i64toi32_i32$0 = $4144;
     i64toi32_i32$1 = $4147$hi;
     i64toi32_i32$3 = $4147;
     i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
     $4148 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $4148$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $5$hi;
     i64toi32_i32$5 = $5;
     i64toi32_i32$0 = $4148$hi;
     i64toi32_i32$3 = $4148;
     i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $4149$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$5 = 0;
     i64toi32_i32$5 = __wasm_rotl_i64($19 | 0, i64toi32_i32$4 | 0, 36 | 0, i64toi32_i32$5 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $4151 = i64toi32_i32$5;
     $4151$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $19$hi;
     i64toi32_i32$5 = 0;
     i64toi32_i32$5 = __wasm_rotl_i64($19 | 0, i64toi32_i32$4 | 0, 30 | 0, i64toi32_i32$5 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $4153 = i64toi32_i32$5;
     $4153$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $4151$hi;
     i64toi32_i32$1 = $4151;
     i64toi32_i32$5 = $4153$hi;
     i64toi32_i32$3 = $4153;
     i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
     $4154 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $4154$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $19$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($19 | 0, i64toi32_i32$5 | 0, 25 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $4156 = i64toi32_i32$1;
     $4156$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $4154$hi;
     i64toi32_i32$4 = $4154;
     i64toi32_i32$1 = $4156$hi;
     i64toi32_i32$3 = $4156;
     i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
     $4157 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
     $4157$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $4149$hi;
     i64toi32_i32$5 = i64toi32_i32$2;
     i64toi32_i32$4 = $4157$hi;
     i64toi32_i32$3 = $4157;
     i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $4158$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $85$hi;
     i64toi32_i32$2 = $4158$hi;
     i64toi32_i32$1 = i64toi32_i32$0;
     i64toi32_i32$5 = $85$hi;
     i64toi32_i32$3 = $85;
     i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
     }
     i64toi32_i32$1 = $4138;
     HEAP32[i64toi32_i32$1 >> 2] = i64toi32_i32$4;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     $1 = $1 + 128 | 0;
     $2 = $2 + -128 | 0;
     if ($2) {
      continue label$3
     }
     break label$3;
    };
   }
   global$0 = $3 + 640 | 0;
   return;
  }
  core__slice__index__slice_end_index_len_fail__h192505a15ac4b345(128 | 0, $2 | 0, 1138084 | 0);
  abort();
 }
 
 function $rand_chacha__chacha__ChaCha12Core_20as_20rand_core__block__BlockRngCore___generate__h177e060232a47155($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$5 = 0, i64toi32_i32$4 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $4 = 0, $5 = 0, $6 = 0, $3 = 0, i64toi32_i32$3 = 0, $7 = 0, $10 = 0, $8 = 0, $11 = 0, $12 = 0, $109 = 0, $15 = 0, $16 = 0, $17 = 0, $44 = 0, $80 = 0, $9 = 0, $32 = 0, $33 = 0, $45 = 0, $108 = 0, $21 = 0, $18 = 0, $19 = 0, $20 = 0, $34 = 0, $36 = 0, $38 = 0, $108$hi = 0, $109$hi = 0, $22 = 0, $43 = 0, $81 = 0, $82 = 0, $83 = 0, $23 = 0, $24 = 0, $25 = 0, $27 = 0, $28 = 0, $29 = 0, $46 = 0, $47 = 0, $48 = 0, $49 = 0, $50 = 0, $51 = 0, $52 = 0, $110 = 0, $40 = 0, $41 = 0, $42 = 0, $110$hi = 0, $30 = 0, $53 = 0, $54 = 0, $56 = 0, $57 = 0, $58 = 0, $59 = 0, $60 = 0, $61 = 0, $62 = 0, $63 = 0, $64 = 0, $65 = 0, $66 = 0, $67 = 0, $68 = 0, $69 = 0, $70 = 0, $71 = 0, $72 = 0, $73 = 0, $74 = 0, $75 = 0, $76 = 0, $77 = 0, $78 = 0, $79 = 0, $26 = 0, $529 = 0, $530 = 0, $532 = 0, $533 = 0, $534 = 0, $535 = 0, $537 = 0, $538 = 0, $14 = 0, $35 = 0, $37 = 0, $39 = 0, $55 = 0, $540 = 0, $541 = 0, $542 = 0, $543 = 0, $111 = 0, $112 = 0, $113 = 0, $114 = 0, $115 = 0, $13 = 0, $544 = 0, $545 = 0, $546 = 0, $547 = 0, $179 = 0, $182$hi = 0, $184$hi = 0, $191 = 0, $194 = 0, $200 = 0, $203 = 0, $209 = 0, $111$hi = 0, $112$hi = 0, $113$hi = 0, $114$hi = 0, $115$hi = 0, $31 = 0, $503 = 0, $506 = 0, $514 = 0, $517 = 0, $528 = 0, $531 = 0, $536 = 0, $539 = 0, $549 = 0, $552 = 0, $557 = 0, $560 = 0, $570 = 0, $573 = 0, $578 = 0, $581 = 0, $603 = 0, $606 = 0, $612 = 0, $615 = 0, $626 = 0, $629 = 0, $632 = 0, $635 = 0, $645 = 0, $648 = 0, $651 = 0, $654 = 0, $664 = 0, $667 = 0, $670 = 0, $673 = 0, $686 = 0, $689 = 0, $698 = 0, $701 = 0, $709 = 0, $712 = 0, $720 = 0, $723 = 0, $744 = 0, $747 = 0, $750 = 0, $753 = 0, $763 = 0, $766 = 0, $769 = 0, $772 = 0, $782 = 0, $785 = 0, $788 = 0, $791 = 0, $801 = 0, $804 = 0, $807 = 0, $810 = 0, $826 = 0, $829 = 0, $832 = 0, $835 = 0, $844 = 0, $847 = 0, $850 = 0, $853 = 0, $861 = 0, $864 = 0, $867 = 0, $870 = 0, $878 = 0, $881 = 0, $884 = 0, $887 = 0, $900 = 0, $903 = 0, $910 = 0, $913 = 0, $919 = 0, $922 = 0, $928 = 0, $931 = 0, $950 = 0, $953 = 0, $956 = 0, $959 = 0, $968 = 0, $971 = 0, $974 = 0, $977 = 0, $985 = 0, $988 = 0, $991 = 0, $994 = 0, $1002 = 0, $1005 = 0, $1008 = 0, $1011 = 0, $1028 = 0, $1031 = 0, $1034 = 0, $1037 = 0, $1046 = 0, $1049 = 0, $1052 = 0, $1055 = 0, $1063 = 0, $1066 = 0, $1069 = 0, $1072 = 0, $1080 = 0, $1083 = 0, $1086 = 0, $1089 = 0, $1102 = 0, $1105 = 0, $1112 = 0, $1115 = 0, $1121 = 0, $1124 = 0, $1130 = 0, $1133 = 0, $1152 = 0, $1155 = 0, $1158 = 0, $1161 = 0, $1169 = 0, $1172 = 0, $1175 = 0, $1178 = 0, $1186 = 0, $1189 = 0, $1192 = 0, $1195 = 0, $1203 = 0, $1206 = 0, $1209 = 0, $1212 = 0, $1228 = 0, $1231 = 0, $1234 = 0, $1237 = 0, $1248 = 0, $1251 = 0, $1254 = 0, $1257 = 0, $1267 = 0, $1270 = 0, $1273 = 0, $1276 = 0, $1286 = 0, $1289 = 0, $1292 = 0, $1295 = 0, $1308 = 0, $1311 = 0, $1318 = 0, $1321 = 0, $1327 = 0, $1330 = 0, $1336 = 0, $1339 = 0, $84 = 0, $85 = 0, $86 = 0, $87 = 0, $88 = 0, $89 = 0, $90 = 0, $91 = 0, $92 = 0, $93 = 0, $94 = 0, $95 = 0, $96 = 0, $97 = 0, $98 = 0, $99 = 0, $100 = 0, $101 = 0, $102 = 0, $103 = 0, $104 = 0, $105 = 0, $106 = 0, $107 = 0, $1461 = 0, $1464 = 0, $1471 = 0, $1474 = 0, $1480 = 0, $1483 = 0, $1489 = 0, $1492 = 0, $1612 = 0, $1615 = 0, $1618 = 0, $1621 = 0, $1630 = 0, $1633 = 0, $1636 = 0, $1639 = 0, $1647 = 0, $1650 = 0, $1653 = 0, $1656 = 0, $1664 = 0, $1667 = 0, $1670 = 0, $1673 = 0, $1690 = 0, $1693 = 0, $1696 = 0, $1699 = 0, $1708 = 0, $1711 = 0, $1714 = 0, $1717 = 0, $1725 = 0, $1728 = 0, $1731 = 0, $1734 = 0, $1742 = 0, $1745 = 0, $1748 = 0, $1751 = 0, $1764 = 0, $1767 = 0, $1774 = 0, $1777 = 0, $1783 = 0, $1786 = 0, $1792 = 0, $1795 = 0, $1814 = 0, $1817 = 0, $1820 = 0, $1823 = 0, $1831 = 0, $1834 = 0, $1837 = 0, $1840 = 0, $1848 = 0, $1851 = 0, $1854 = 0, $1857 = 0, $1865 = 0, $1868 = 0, $1871 = 0, $1874 = 0, $1890 = 0, $1893 = 0, $1896 = 0, $1899 = 0, $1908 = 0, $1911 = 0, $1914 = 0, $1917 = 0, $1925 = 0, $1928 = 0, $1931 = 0, $1934 = 0, $1942 = 0, $1945 = 0, $1948 = 0, $1951 = 0, $1964 = 0, $1967 = 0, $1974 = 0, $1977 = 0, $1983 = 0, $1986 = 0, $1992 = 0, $1995 = 0, $2014 = 0, $2017 = 0, $2020 = 0, $2023 = 0, $2032 = 0, $2035 = 0, $2038 = 0, $2041 = 0, $2049 = 0, $2052 = 0, $2055 = 0, $2058 = 0, $2066 = 0, $2069 = 0, $2072 = 0, $2075 = 0, $2092 = 0, $2095 = 0, $2098 = 0, $2101 = 0, $2110 = 0, $2113 = 0, $2116 = 0, $2119 = 0, $2127 = 0, $2130 = 0, $2133 = 0, $2136 = 0, $2144 = 0, $2147 = 0, $2150 = 0, $2153 = 0, $2166 = 0, $2169 = 0, $2176 = 0, $2179 = 0, $2185 = 0, $2188 = 0, $2194 = 0, $2197 = 0, $2216 = 0, $2219 = 0, $2222 = 0, $2225 = 0, $2233 = 0, $2236 = 0, $2239 = 0, $2242 = 0, $2250 = 0, $2253 = 0, $2256 = 0, $2259 = 0, $2267 = 0, $2270 = 0, $2273 = 0, $2276 = 0, $2292 = 0, $2295 = 0, $2298 = 0, $2301 = 0, $2310 = 0, $2313 = 0, $2316 = 0, $2319 = 0, $2327 = 0, $2330 = 0, $2333 = 0, $2336 = 0, $2344 = 0, $2347 = 0, $2350 = 0, $2353 = 0, $2366 = 0, $2369 = 0, $2376 = 0, $2379 = 0, $2385 = 0, $2388 = 0, $2394 = 0, $2397 = 0, $2517 = 0, $2520 = 0, $2527 = 0, $2530 = 0, $2536 = 0, $2539 = 0, $2545 = 0, $2548 = 0, $2735 = 0, $2738 = 0, $2745 = 0, $2748 = 0, $2766 = 0, $2767 = 0, $2773 = 0, $2776 = 0, $2782 = 0, $2785 = 0, $2791 = 0, $2796 = 0, $2799 = 0, $2803 = 0, $2837 = 0, $2846 = 0, $2849 = 0, $2953 = 0, $2956 = 0, $2963 = 0, $2966 = 0, $2973 = 0, $2976 = 0, $2983 = 0, $2986 = 0, $2993 = 0, $2996 = 0, $3012 = 0, $3015 = 0, $3026 = 0, $3029 = 0, $3032 = 0, $3035 = 0, $3038 = 0, $3041 = 0, $3050 = 0, $3053 = 0, $3061 = 0, $3065 = 0, $3068 = 0, $3071 = 0, $3074 = 0, $3077 = 0, $3086 = 0, $3089 = 0, $3097 = 0, $3101 = 0, $3104 = 0, $3107 = 0, $3110 = 0, $3113 = 0, $3122 = 0, $3125 = 0, $3133 = 0, $3137 = 0;
  $2 = global$0 - 976 | 0;
  global$0 = $2;
  $3 = HEAP32[($0 + 36 | 0) >> 2] | 0;
  i64toi32_i32$2 = $0 + 40 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $108 = i64toi32_i32$0;
  $108$hi = i64toi32_i32$1;
  $4 = HEAP32[($0 + 12 | 0) >> 2] | 0;
  $5 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  $6 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $7 = HEAP32[$0 >> 2] | 0;
  $8 = HEAP32[($0 + 32 | 0) >> 2] | 0;
  $9 = ($2 + 112 | 0) + 8 | 0;
  i64toi32_i32$2 = $0 + 24 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $109 = i64toi32_i32$1;
  $109$hi = i64toi32_i32$0;
  i64toi32_i32$1 = $9;
  HEAP32[i64toi32_i32$1 >> 2] = $109;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $10 = ($2 + 112 | 0) + 24 | 0;
  i64toi32_i32$1 = $10;
  HEAP32[i64toi32_i32$1 >> 2] = $109;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $11 = ($2 + 112 | 0) + 40 | 0;
  i64toi32_i32$1 = $11;
  HEAP32[i64toi32_i32$1 >> 2] = $109;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $12 = ($2 + 112 | 0) + 56 | 0;
  i64toi32_i32$1 = $12;
  HEAP32[i64toi32_i32$1 >> 2] = $109;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $109 = i64toi32_i32$0;
  $109$hi = i64toi32_i32$1;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 112 | 0) >> 2] = $109;
  HEAP32[($2 + 116 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 128 | 0) >> 2] = $109;
  HEAP32[($2 + 132 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 144 | 0) >> 2] = $109;
  HEAP32[($2 + 148 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 160 | 0) >> 2] = $109;
  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
  memcpy($2 + 48 | 0 | 0, $2 + 112 | 0 | 0, 64 | 0) | 0;
  i64toi32_i32$1 = $108$hi;
  i64toi32_i32$0 = $12;
  HEAP32[i64toi32_i32$0 >> 2] = $108;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$0 = $11;
  HEAP32[i64toi32_i32$0 >> 2] = $108;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$0 = $10;
  HEAP32[i64toi32_i32$0 >> 2] = $108;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $179 = $2;
  i64toi32_i32$1 = 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $540 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $540 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $182$hi = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  $184$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $182$hi;
  i64toi32_i32$1 = $540;
  i64toi32_i32$2 = $184$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  $109 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  $109$hi = i64toi32_i32$2;
  i64toi32_i32$0 = $109;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 3;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $110 = i64toi32_i32$4;
  $110$hi = i64toi32_i32$5;
  HEAP32[($179 + 160 | 0) >> 2] = i64toi32_i32$4;
  $191 = ($2 + 112 | 0) + 52 | 0;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$1 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $541 = i64toi32_i32$5 >>> i64toi32_i32$1 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$5 >>> i64toi32_i32$1 | 0;
   $541 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$1 | 0) | 0;
  }
  HEAP32[$191 >> 2] = $541;
  $194 = $2;
  i64toi32_i32$0 = $109$hi;
  i64toi32_i32$5 = $109;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 2;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $110 = i64toi32_i32$1;
  $110$hi = i64toi32_i32$4;
  HEAP32[($194 + 144 | 0) >> 2] = i64toi32_i32$1;
  $200 = ($2 + 112 | 0) + 36 | 0;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$2 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$5 = 0;
   $542 = i64toi32_i32$4 >>> i64toi32_i32$2 | 0;
  } else {
   i64toi32_i32$5 = i64toi32_i32$4 >>> i64toi32_i32$2 | 0;
   $542 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$2 | 0) | 0;
  }
  HEAP32[$200 >> 2] = $542;
  $203 = $2;
  i64toi32_i32$5 = $109$hi;
  i64toi32_i32$4 = $109;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 1;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $109 = i64toi32_i32$2;
  $109$hi = i64toi32_i32$1;
  HEAP32[($203 + 128 | 0) >> 2] = i64toi32_i32$2;
  $209 = ($2 + 112 | 0) + 20 | 0;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$4 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$0 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$4 = 0;
   $543 = i64toi32_i32$1 >>> i64toi32_i32$0 | 0;
  } else {
   i64toi32_i32$4 = i64toi32_i32$1 >>> i64toi32_i32$0 | 0;
   $543 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$0 | 0) | 0;
  }
  HEAP32[$209 >> 2] = $543;
  i64toi32_i32$4 = $108$hi;
  i64toi32_i32$5 = $2;
  HEAP32[(i64toi32_i32$5 + 120 | 0) >> 2] = $108;
  HEAP32[(i64toi32_i32$5 + 124 | 0) >> 2] = i64toi32_i32$4;
  HEAP32[(i64toi32_i32$5 + 116 | 0) >> 2] = $3;
  HEAP32[(i64toi32_i32$5 + 112 | 0) >> 2] = $8;
  $T_20as_20core__convert__Into_U____into__h7f4f73dcbb1683ac(i64toi32_i32$5 + 528 | 0 | 0, i64toi32_i32$5 + 112 | 0 | 0);
  memcpy(i64toi32_i32$5 + 112 | 0 | 0, i64toi32_i32$5 + 528 | 0 | 0, 64 | 0) | 0;
  i64toi32_i32$1 = $10;
  i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $108 = i64toi32_i32$4;
  $108$hi = i64toi32_i32$5;
  i64toi32_i32$4 = ($2 + 784 | 0) + 24 | 0;
  HEAP32[i64toi32_i32$4 >> 2] = $108;
  HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
  i64toi32_i32$1 = $11;
  i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $109 = i64toi32_i32$5;
  $109$hi = i64toi32_i32$4;
  i64toi32_i32$5 = ($2 + 784 | 0) + 40 | 0;
  HEAP32[i64toi32_i32$5 >> 2] = $109;
  HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$4;
  i64toi32_i32$1 = $12;
  i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $110 = i64toi32_i32$4;
  $110$hi = i64toi32_i32$5;
  i64toi32_i32$4 = ($2 + 784 | 0) + 56 | 0;
  HEAP32[i64toi32_i32$4 >> 2] = $110;
  HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
  $3 = ($2 + 528 | 0) + 8 | 0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $111 = i64toi32_i32$5;
  $111$hi = i64toi32_i32$4;
  i64toi32_i32$5 = ($2 + 784 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$5 >> 2] = $111;
  HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$4;
  i64toi32_i32$1 = $2;
  i64toi32_i32$4 = HEAP32[($2 + 128 | 0) >> 2] | 0;
  i64toi32_i32$5 = HEAP32[($2 + 132 | 0) >> 2] | 0;
  $112 = i64toi32_i32$4;
  $112$hi = i64toi32_i32$5;
  i64toi32_i32$4 = $2;
  HEAP32[(i64toi32_i32$4 + 800 | 0) >> 2] = $112;
  HEAP32[(i64toi32_i32$4 + 804 | 0) >> 2] = i64toi32_i32$5;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 144 | 0) >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$4 + 148 | 0) >> 2] | 0;
  $113 = i64toi32_i32$5;
  $113$hi = i64toi32_i32$4;
  i64toi32_i32$5 = $2;
  HEAP32[(i64toi32_i32$5 + 816 | 0) >> 2] = $113;
  HEAP32[(i64toi32_i32$5 + 820 | 0) >> 2] = i64toi32_i32$4;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 160 | 0) >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$5 + 164 | 0) >> 2] | 0;
  $114 = i64toi32_i32$4;
  $114$hi = i64toi32_i32$5;
  i64toi32_i32$4 = $2;
  HEAP32[(i64toi32_i32$4 + 832 | 0) >> 2] = $114;
  HEAP32[(i64toi32_i32$4 + 836 | 0) >> 2] = i64toi32_i32$5;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 528 | 0) >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$4 + 532 | 0) >> 2] | 0;
  $115 = i64toi32_i32$5;
  $115$hi = i64toi32_i32$4;
  i64toi32_i32$5 = $2;
  HEAP32[(i64toi32_i32$5 + 784 | 0) >> 2] = $115;
  HEAP32[(i64toi32_i32$5 + 788 | 0) >> 2] = i64toi32_i32$4;
  $13 = $0 + 16 | 0;
  $14 = $0 + 32 | 0;
  $15 = HEAP32[((i64toi32_i32$5 + 784 | 0) + 20 | 0) >> 2] | 0;
  $16 = HEAP32[(i64toi32_i32$5 + 812 | 0) >> 2] | 0;
  $17 = HEAP32[((i64toi32_i32$5 + 784 | 0) + 36 | 0) >> 2] | 0;
  $18 = HEAP32[(i64toi32_i32$5 + 828 | 0) >> 2] | 0;
  $19 = HEAP32[((i64toi32_i32$5 + 784 | 0) + 52 | 0) >> 2] | 0;
  $20 = HEAP32[(i64toi32_i32$5 + 844 | 0) >> 2] | 0;
  $21 = HEAP32[(i64toi32_i32$5 + 788 | 0) >> 2] | 0;
  $22 = HEAP32[(i64toi32_i32$5 + 796 | 0) >> 2] | 0;
  $23 = i64toi32_i32$5 + 288 | 0;
  $24 = i64toi32_i32$5 + 272 | 0;
  $25 = i64toi32_i32$5 + 256 | 0;
  $26 = i64toi32_i32$5 + 304 | 0;
  $27 = (i64toi32_i32$5 + 112 | 0) + 48 | 0;
  $28 = (i64toi32_i32$5 + 112 | 0) + 32 | 0;
  $29 = (i64toi32_i32$5 + 112 | 0) + 16 | 0;
  $30 = (i64toi32_i32$5 + 112 | 0) + 64 | 0;
  $31 = i64toi32_i32$5 + 240 | 0;
  $12 = (i64toi32_i32$5 + 528 | 0) + 48 | 0;
  $32 = (i64toi32_i32$5 + 528 | 0) + 32 | 0;
  $33 = (i64toi32_i32$5 + 528 | 0) + 16 | 0;
  $34 = (i64toi32_i32$5 + 912 | 0) + 48 | 0;
  $35 = (i64toi32_i32$5 + 848 | 0) + 48 | 0;
  $36 = (i64toi32_i32$5 + 912 | 0) + 32 | 0;
  $37 = (i64toi32_i32$5 + 848 | 0) + 32 | 0;
  $38 = (i64toi32_i32$5 + 912 | 0) + 16 | 0;
  $39 = (i64toi32_i32$5 + 848 | 0) + 16 | 0;
  $40 = (i64toi32_i32$5 + 616 | 0) + 48 | 0;
  $41 = (i64toi32_i32$5 + 616 | 0) + 32 | 0;
  $42 = (i64toi32_i32$5 + 616 | 0) + 16 | 0;
  $8 = (i64toi32_i32$5 + 784 | 0) + 48 | 0;
  $10 = (i64toi32_i32$5 + 784 | 0) + 32 | 0;
  $11 = (i64toi32_i32$5 + 784 | 0) + 16 | 0;
  i64toi32_i32$4 = $110$hi;
  $43 = $110;
  i64toi32_i32$4 = $114$hi;
  $44 = $114;
  i64toi32_i32$4 = $109$hi;
  $45 = $109;
  i64toi32_i32$4 = $113$hi;
  $46 = $113;
  i64toi32_i32$4 = $108$hi;
  $47 = $108;
  i64toi32_i32$4 = $112$hi;
  $48 = $112;
  i64toi32_i32$4 = $111$hi;
  $49 = $111;
  i64toi32_i32$4 = $115$hi;
  $50 = $115;
  $51 = 1634760805;
  $52 = 857760878;
  $53 = 2036477234;
  $54 = 1797285236;
  $55 = 6;
  $56 = $4;
  $57 = $5;
  $58 = $6;
  $59 = $7;
  $60 = $4;
  $61 = $5;
  $62 = $6;
  $63 = $7;
  $64 = $4;
  $65 = $5;
  $66 = $6;
  $67 = $7;
  $68 = 1797285236;
  $69 = 2036477234;
  $70 = 857760878;
  $71 = 1634760805;
  $72 = 1797285236;
  $73 = 2036477234;
  $74 = 857760878;
  $75 = 1634760805;
  $76 = 1797285236;
  $77 = 1634760805;
  $78 = 857760878;
  $79 = 2036477234;
  label$1 : while (1) {
   HEAP32[$9 >> 2] = $79;
   HEAP32[($2 + 236 | 0) >> 2] = $4;
   HEAP32[($2 + 232 | 0) >> 2] = $5;
   HEAP32[($2 + 228 | 0) >> 2] = $6;
   HEAP32[($2 + 224 | 0) >> 2] = $7;
   HEAP32[($2 + 220 | 0) >> 2] = $56;
   HEAP32[($2 + 216 | 0) >> 2] = $57;
   HEAP32[($2 + 212 | 0) >> 2] = $58;
   HEAP32[($2 + 208 | 0) >> 2] = $59;
   HEAP32[($2 + 204 | 0) >> 2] = $60;
   HEAP32[($2 + 200 | 0) >> 2] = $61;
   HEAP32[($2 + 196 | 0) >> 2] = $62;
   HEAP32[($2 + 192 | 0) >> 2] = $63;
   HEAP32[($2 + 188 | 0) >> 2] = $64;
   HEAP32[($2 + 184 | 0) >> 2] = $65;
   HEAP32[($2 + 180 | 0) >> 2] = $66;
   HEAP32[($2 + 176 | 0) >> 2] = $67;
   HEAP32[($2 + 172 | 0) >> 2] = $54;
   HEAP32[($2 + 168 | 0) >> 2] = $53;
   HEAP32[($2 + 164 | 0) >> 2] = $52;
   HEAP32[($2 + 160 | 0) >> 2] = $51;
   HEAP32[($2 + 156 | 0) >> 2] = $68;
   HEAP32[($2 + 152 | 0) >> 2] = $69;
   HEAP32[($2 + 148 | 0) >> 2] = $70;
   HEAP32[($2 + 144 | 0) >> 2] = $71;
   HEAP32[($2 + 140 | 0) >> 2] = $72;
   HEAP32[($2 + 136 | 0) >> 2] = $73;
   HEAP32[($2 + 132 | 0) >> 2] = $74;
   HEAP32[($2 + 128 | 0) >> 2] = $75;
   HEAP32[($2 + 124 | 0) >> 2] = $76;
   HEAP32[($2 + 116 | 0) >> 2] = $78;
   HEAP32[($2 + 112 | 0) >> 2] = $77;
   $80 = memcpy($31 | 0, $2 + 48 | 0 | 0, 64 | 0) | 0;
   HEAP32[($2 + 364 | 0) >> 2] = $20;
   HEAP32[($2 + 360 | 0) >> 2] = $43;
   HEAP32[($2 + 356 | 0) >> 2] = $19;
   HEAP32[($2 + 352 | 0) >> 2] = $44;
   HEAP32[($2 + 348 | 0) >> 2] = $18;
   HEAP32[($2 + 344 | 0) >> 2] = $45;
   HEAP32[($2 + 340 | 0) >> 2] = $17;
   HEAP32[($2 + 336 | 0) >> 2] = $46;
   HEAP32[($2 + 332 | 0) >> 2] = $16;
   HEAP32[($2 + 328 | 0) >> 2] = $47;
   HEAP32[($2 + 324 | 0) >> 2] = $15;
   HEAP32[($2 + 320 | 0) >> 2] = $48;
   HEAP32[($2 + 316 | 0) >> 2] = $22;
   HEAP32[($2 + 312 | 0) >> 2] = $49;
   HEAP32[($2 + 308 | 0) >> 2] = $21;
   HEAP32[($2 + 304 | 0) >> 2] = $50;
   memcpy($2 + 528 | 0 | 0, $30 | 0, 64 | 0) | 0;
   $4 = ($2 + 912 | 0) + 8 | 0;
   i64toi32_i32$1 = $9;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $503 = i64toi32_i32$4;
   i64toi32_i32$4 = $4;
   HEAP32[i64toi32_i32$4 >> 2] = $503;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $2;
   i64toi32_i32$5 = HEAP32[($2 + 112 | 0) >> 2] | 0;
   i64toi32_i32$4 = HEAP32[($2 + 116 | 0) >> 2] | 0;
   $506 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 912 | 0) >> 2] = $506;
   HEAP32[(i64toi32_i32$5 + 916 | 0) >> 2] = i64toi32_i32$4;
   $5 = (i64toi32_i32$5 + 616 | 0) + 8 | 0;
   $18 = $30 + 8 | 0;
   i64toi32_i32$1 = $18;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $514 = i64toi32_i32$4;
   i64toi32_i32$4 = $5;
   HEAP32[i64toi32_i32$4 >> 2] = $514;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $30;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $517 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 616 | 0) >> 2] = $517;
   HEAP32[(i64toi32_i32$5 + 620 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap2__h0af304cc753529fe(i64toi32_i32$5 + 112 | 0 | 0, i64toi32_i32$5 + 912 | 0 | 0, i64toi32_i32$5 + 616 | 0 | 0);
   $47 = $29 + 8 | 0;
   i64toi32_i32$1 = $47;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $528 = i64toi32_i32$4;
   i64toi32_i32$4 = $4;
   HEAP32[i64toi32_i32$4 >> 2] = $528;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $29;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $531 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 912 | 0) >> 2] = $531;
   HEAP32[(i64toi32_i32$5 + 916 | 0) >> 2] = i64toi32_i32$4;
   $15 = $33 + 8 | 0;
   i64toi32_i32$1 = $15;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $536 = i64toi32_i32$4;
   i64toi32_i32$4 = $5;
   HEAP32[i64toi32_i32$4 >> 2] = $536;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $33;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $539 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 616 | 0) >> 2] = $539;
   HEAP32[(i64toi32_i32$5 + 620 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap2__h0af304cc753529fe($29 | 0, i64toi32_i32$5 + 912 | 0 | 0, i64toi32_i32$5 + 616 | 0 | 0);
   $48 = $28 + 8 | 0;
   i64toi32_i32$1 = $48;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $549 = i64toi32_i32$4;
   i64toi32_i32$4 = $4;
   HEAP32[i64toi32_i32$4 >> 2] = $549;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $28;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $552 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 912 | 0) >> 2] = $552;
   HEAP32[(i64toi32_i32$5 + 916 | 0) >> 2] = i64toi32_i32$4;
   $16 = $32 + 8 | 0;
   i64toi32_i32$1 = $16;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $557 = i64toi32_i32$4;
   i64toi32_i32$4 = $5;
   HEAP32[i64toi32_i32$4 >> 2] = $557;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $32;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $560 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 616 | 0) >> 2] = $560;
   HEAP32[(i64toi32_i32$5 + 620 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap2__h0af304cc753529fe($28 | 0, i64toi32_i32$5 + 912 | 0 | 0, i64toi32_i32$5 + 616 | 0 | 0);
   $49 = $27 + 8 | 0;
   i64toi32_i32$1 = $49;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $570 = i64toi32_i32$4;
   i64toi32_i32$4 = $4;
   HEAP32[i64toi32_i32$4 >> 2] = $570;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $27;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $573 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 912 | 0) >> 2] = $573;
   HEAP32[(i64toi32_i32$5 + 916 | 0) >> 2] = i64toi32_i32$4;
   $17 = $12 + 8 | 0;
   i64toi32_i32$1 = $17;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $578 = i64toi32_i32$4;
   i64toi32_i32$4 = $5;
   HEAP32[i64toi32_i32$4 >> 2] = $578;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $12;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $581 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 616 | 0) >> 2] = $581;
   HEAP32[(i64toi32_i32$5 + 620 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap2__h0af304cc753529fe($27 | 0, i64toi32_i32$5 + 912 | 0 | 0, i64toi32_i32$5 + 616 | 0 | 0);
   memcpy(i64toi32_i32$5 + 616 | 0 | 0, $26 | 0, 64 | 0) | 0;
   memcpy(i64toi32_i32$5 + 528 | 0 | 0, i64toi32_i32$5 + 112 | 0 | 0, 64 | 0) | 0;
   $6 = (i64toi32_i32$5 + 368 | 0) + 8 | 0;
   $19 = $26 + 8 | 0;
   i64toi32_i32$1 = $19;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $603 = i64toi32_i32$4;
   i64toi32_i32$4 = $6;
   HEAP32[i64toi32_i32$4 >> 2] = $603;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $26;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $606 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 368 | 0) >> 2] = $606;
   HEAP32[(i64toi32_i32$5 + 372 | 0) >> 2] = i64toi32_i32$4;
   $7 = (i64toi32_i32$5 + 432 | 0) + 8 | 0;
   i64toi32_i32$1 = $9;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $612 = i64toi32_i32$4;
   i64toi32_i32$4 = $7;
   HEAP32[i64toi32_i32$4 >> 2] = $612;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $2;
   i64toi32_i32$5 = HEAP32[($2 + 112 | 0) >> 2] | 0;
   i64toi32_i32$4 = HEAP32[($2 + 116 | 0) >> 2] | 0;
   $615 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 432 | 0) >> 2] = $615;
   HEAP32[(i64toi32_i32$5 + 436 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__omap2__ha0f66afdd187b7fb(i64toi32_i32$5 + 784 | 0 | 0, i64toi32_i32$5 + 368 | 0 | 0, i64toi32_i32$5 + 432 | 0 | 0);
   $21 = $42 + 8 | 0;
   i64toi32_i32$1 = $21;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $626 = i64toi32_i32$4;
   i64toi32_i32$4 = $6;
   HEAP32[i64toi32_i32$4 >> 2] = $626;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $42;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $629 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 368 | 0) >> 2] = $629;
   HEAP32[(i64toi32_i32$5 + 372 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $15;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $632 = i64toi32_i32$4;
   i64toi32_i32$4 = $7;
   HEAP32[i64toi32_i32$4 >> 2] = $632;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $33;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $635 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 432 | 0) >> 2] = $635;
   HEAP32[(i64toi32_i32$5 + 436 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__omap2__ha0f66afdd187b7fb($11 | 0, i64toi32_i32$5 + 368 | 0 | 0, i64toi32_i32$5 + 432 | 0 | 0);
   $22 = $41 + 8 | 0;
   i64toi32_i32$1 = $22;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $645 = i64toi32_i32$4;
   i64toi32_i32$4 = $6;
   HEAP32[i64toi32_i32$4 >> 2] = $645;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $41;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $648 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 368 | 0) >> 2] = $648;
   HEAP32[(i64toi32_i32$5 + 372 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $16;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $651 = i64toi32_i32$4;
   i64toi32_i32$4 = $7;
   HEAP32[i64toi32_i32$4 >> 2] = $651;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $32;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $654 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 432 | 0) >> 2] = $654;
   HEAP32[(i64toi32_i32$5 + 436 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__omap2__ha0f66afdd187b7fb($10 | 0, i64toi32_i32$5 + 368 | 0 | 0, i64toi32_i32$5 + 432 | 0 | 0);
   $43 = $40 + 8 | 0;
   i64toi32_i32$1 = $43;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $664 = i64toi32_i32$4;
   i64toi32_i32$4 = $6;
   HEAP32[i64toi32_i32$4 >> 2] = $664;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $40;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $667 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 368 | 0) >> 2] = $667;
   HEAP32[(i64toi32_i32$5 + 372 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $17;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $670 = i64toi32_i32$4;
   i64toi32_i32$4 = $7;
   HEAP32[i64toi32_i32$4 >> 2] = $670;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $12;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $673 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 432 | 0) >> 2] = $673;
   HEAP32[(i64toi32_i32$5 + 436 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__omap2__ha0f66afdd187b7fb($8 | 0, i64toi32_i32$5 + 368 | 0 | 0, i64toi32_i32$5 + 432 | 0 | 0);
   memcpy(i64toi32_i32$5 + 912 | 0 | 0, i64toi32_i32$5 + 784 | 0 | 0, 64 | 0) | 0;
   i64toi32_i32$1 = $4;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $686 = i64toi32_i32$4;
   i64toi32_i32$4 = $3;
   HEAP32[i64toi32_i32$4 >> 2] = $686;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $2;
   i64toi32_i32$5 = HEAP32[($2 + 912 | 0) >> 2] | 0;
   i64toi32_i32$4 = HEAP32[($2 + 916 | 0) >> 2] | 0;
   $689 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 528 | 0) >> 2] = $689;
   HEAP32[(i64toi32_i32$5 + 532 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap__hd102a368e6d0db5e(i64toi32_i32$5 + 784 | 0 | 0, i64toi32_i32$5 + 528 | 0 | 0);
   $81 = $38 + 8 | 0;
   i64toi32_i32$1 = $81;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $698 = i64toi32_i32$4;
   i64toi32_i32$4 = $3;
   HEAP32[i64toi32_i32$4 >> 2] = $698;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $38;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $701 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 528 | 0) >> 2] = $701;
   HEAP32[(i64toi32_i32$5 + 532 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap__hd102a368e6d0db5e($11 | 0, i64toi32_i32$5 + 528 | 0 | 0);
   $82 = $36 + 8 | 0;
   i64toi32_i32$1 = $82;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $709 = i64toi32_i32$4;
   i64toi32_i32$4 = $3;
   HEAP32[i64toi32_i32$4 >> 2] = $709;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $36;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $712 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 528 | 0) >> 2] = $712;
   HEAP32[(i64toi32_i32$5 + 532 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap__hd102a368e6d0db5e($10 | 0, i64toi32_i32$5 + 528 | 0 | 0);
   $83 = $34 + 8 | 0;
   i64toi32_i32$1 = $83;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $720 = i64toi32_i32$4;
   i64toi32_i32$4 = $3;
   HEAP32[i64toi32_i32$4 >> 2] = $720;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $34;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $723 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 528 | 0) >> 2] = $723;
   HEAP32[(i64toi32_i32$5 + 532 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap__hd102a368e6d0db5e($8 | 0, i64toi32_i32$5 + 528 | 0 | 0);
   memcpy(i64toi32_i32$5 + 848 | 0 | 0, i64toi32_i32$5 + 784 | 0 | 0, 64 | 0) | 0;
   $44 = memcpy($26 | 0, i64toi32_i32$5 + 848 | 0 | 0, 64 | 0) | 0;
   memcpy(i64toi32_i32$5 + 528 | 0 | 0, $44 | 0, 64 | 0) | 0;
   $20 = $80 + 8 | 0;
   i64toi32_i32$1 = $20;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $744 = i64toi32_i32$4;
   i64toi32_i32$4 = $4;
   HEAP32[i64toi32_i32$4 >> 2] = $744;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $80;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $747 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 912 | 0) >> 2] = $747;
   HEAP32[(i64toi32_i32$5 + 916 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $19;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $750 = i64toi32_i32$4;
   i64toi32_i32$4 = $5;
   HEAP32[i64toi32_i32$4 >> 2] = $750;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $44;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $753 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 616 | 0) >> 2] = $753;
   HEAP32[(i64toi32_i32$5 + 620 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap2__h0af304cc753529fe($80 | 0, i64toi32_i32$5 + 912 | 0 | 0, i64toi32_i32$5 + 616 | 0 | 0);
   $50 = $25 + 8 | 0;
   i64toi32_i32$1 = $50;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $763 = i64toi32_i32$4;
   i64toi32_i32$4 = $4;
   HEAP32[i64toi32_i32$4 >> 2] = $763;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $25;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $766 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 912 | 0) >> 2] = $766;
   HEAP32[(i64toi32_i32$5 + 916 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $15;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $769 = i64toi32_i32$4;
   i64toi32_i32$4 = $5;
   HEAP32[i64toi32_i32$4 >> 2] = $769;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $33;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $772 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 616 | 0) >> 2] = $772;
   HEAP32[(i64toi32_i32$5 + 620 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap2__h0af304cc753529fe($25 | 0, i64toi32_i32$5 + 912 | 0 | 0, i64toi32_i32$5 + 616 | 0 | 0);
   $51 = $24 + 8 | 0;
   i64toi32_i32$1 = $51;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $782 = i64toi32_i32$4;
   i64toi32_i32$4 = $4;
   HEAP32[i64toi32_i32$4 >> 2] = $782;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $24;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $785 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 912 | 0) >> 2] = $785;
   HEAP32[(i64toi32_i32$5 + 916 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $16;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $788 = i64toi32_i32$4;
   i64toi32_i32$4 = $5;
   HEAP32[i64toi32_i32$4 >> 2] = $788;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $32;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $791 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 616 | 0) >> 2] = $791;
   HEAP32[(i64toi32_i32$5 + 620 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap2__h0af304cc753529fe($24 | 0, i64toi32_i32$5 + 912 | 0 | 0, i64toi32_i32$5 + 616 | 0 | 0);
   $52 = $23 + 8 | 0;
   i64toi32_i32$1 = $52;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $801 = i64toi32_i32$4;
   i64toi32_i32$4 = $4;
   HEAP32[i64toi32_i32$4 >> 2] = $801;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $23;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $804 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 912 | 0) >> 2] = $804;
   HEAP32[(i64toi32_i32$5 + 916 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $17;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $807 = i64toi32_i32$4;
   i64toi32_i32$4 = $5;
   HEAP32[i64toi32_i32$4 >> 2] = $807;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $12;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $810 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 616 | 0) >> 2] = $810;
   HEAP32[(i64toi32_i32$5 + 620 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap2__h0af304cc753529fe($23 | 0, i64toi32_i32$5 + 912 | 0 | 0, i64toi32_i32$5 + 616 | 0 | 0);
   memcpy(i64toi32_i32$5 + 616 | 0 | 0, $30 | 0, 64 | 0) | 0;
   memcpy(i64toi32_i32$5 + 528 | 0 | 0, $80 | 0, 64 | 0) | 0;
   i64toi32_i32$1 = $18;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $826 = i64toi32_i32$4;
   i64toi32_i32$4 = $6;
   HEAP32[i64toi32_i32$4 >> 2] = $826;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $30;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $829 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 368 | 0) >> 2] = $829;
   HEAP32[(i64toi32_i32$5 + 372 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $20;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $832 = i64toi32_i32$4;
   i64toi32_i32$4 = $7;
   HEAP32[i64toi32_i32$4 >> 2] = $832;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $80;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $835 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 432 | 0) >> 2] = $835;
   HEAP32[(i64toi32_i32$5 + 436 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__omap2__ha0f66afdd187b7fb(i64toi32_i32$5 + 784 | 0 | 0, i64toi32_i32$5 + 368 | 0 | 0, i64toi32_i32$5 + 432 | 0 | 0);
   i64toi32_i32$1 = $21;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $844 = i64toi32_i32$4;
   i64toi32_i32$4 = $6;
   HEAP32[i64toi32_i32$4 >> 2] = $844;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $42;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $847 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 368 | 0) >> 2] = $847;
   HEAP32[(i64toi32_i32$5 + 372 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $15;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $850 = i64toi32_i32$4;
   i64toi32_i32$4 = $7;
   HEAP32[i64toi32_i32$4 >> 2] = $850;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $33;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $853 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 432 | 0) >> 2] = $853;
   HEAP32[(i64toi32_i32$5 + 436 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__omap2__ha0f66afdd187b7fb($11 | 0, i64toi32_i32$5 + 368 | 0 | 0, i64toi32_i32$5 + 432 | 0 | 0);
   i64toi32_i32$1 = $22;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $861 = i64toi32_i32$4;
   i64toi32_i32$4 = $6;
   HEAP32[i64toi32_i32$4 >> 2] = $861;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $41;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $864 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 368 | 0) >> 2] = $864;
   HEAP32[(i64toi32_i32$5 + 372 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $16;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $867 = i64toi32_i32$4;
   i64toi32_i32$4 = $7;
   HEAP32[i64toi32_i32$4 >> 2] = $867;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $32;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $870 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 432 | 0) >> 2] = $870;
   HEAP32[(i64toi32_i32$5 + 436 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__omap2__ha0f66afdd187b7fb($10 | 0, i64toi32_i32$5 + 368 | 0 | 0, i64toi32_i32$5 + 432 | 0 | 0);
   i64toi32_i32$1 = $43;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $878 = i64toi32_i32$4;
   i64toi32_i32$4 = $6;
   HEAP32[i64toi32_i32$4 >> 2] = $878;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $40;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $881 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 368 | 0) >> 2] = $881;
   HEAP32[(i64toi32_i32$5 + 372 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $17;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $884 = i64toi32_i32$4;
   i64toi32_i32$4 = $7;
   HEAP32[i64toi32_i32$4 >> 2] = $884;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $12;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $887 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 432 | 0) >> 2] = $887;
   HEAP32[(i64toi32_i32$5 + 436 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__omap2__ha0f66afdd187b7fb($8 | 0, i64toi32_i32$5 + 368 | 0 | 0, i64toi32_i32$5 + 432 | 0 | 0);
   memcpy(i64toi32_i32$5 + 912 | 0 | 0, i64toi32_i32$5 + 784 | 0 | 0, 64 | 0) | 0;
   i64toi32_i32$1 = $4;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $900 = i64toi32_i32$4;
   i64toi32_i32$4 = $3;
   HEAP32[i64toi32_i32$4 >> 2] = $900;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $2;
   i64toi32_i32$5 = HEAP32[($2 + 912 | 0) >> 2] | 0;
   i64toi32_i32$4 = HEAP32[($2 + 916 | 0) >> 2] | 0;
   $903 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 528 | 0) >> 2] = $903;
   HEAP32[(i64toi32_i32$5 + 532 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap__h8dc4284c5eb4ed5a(i64toi32_i32$5 + 784 | 0 | 0, i64toi32_i32$5 + 528 | 0 | 0);
   i64toi32_i32$1 = $81;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $910 = i64toi32_i32$4;
   i64toi32_i32$4 = $3;
   HEAP32[i64toi32_i32$4 >> 2] = $910;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $38;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $913 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 528 | 0) >> 2] = $913;
   HEAP32[(i64toi32_i32$5 + 532 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap__h8dc4284c5eb4ed5a($11 | 0, i64toi32_i32$5 + 528 | 0 | 0);
   i64toi32_i32$1 = $82;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $919 = i64toi32_i32$4;
   i64toi32_i32$4 = $3;
   HEAP32[i64toi32_i32$4 >> 2] = $919;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $36;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $922 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 528 | 0) >> 2] = $922;
   HEAP32[(i64toi32_i32$5 + 532 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap__h8dc4284c5eb4ed5a($10 | 0, i64toi32_i32$5 + 528 | 0 | 0);
   i64toi32_i32$1 = $83;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $928 = i64toi32_i32$4;
   i64toi32_i32$4 = $3;
   HEAP32[i64toi32_i32$4 >> 2] = $928;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $34;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $931 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 528 | 0) >> 2] = $931;
   HEAP32[(i64toi32_i32$5 + 532 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap__h8dc4284c5eb4ed5a($8 | 0, i64toi32_i32$5 + 528 | 0 | 0);
   memcpy(i64toi32_i32$5 + 848 | 0 | 0, i64toi32_i32$5 + 784 | 0 | 0, 64 | 0) | 0;
   $45 = memcpy($30 | 0, i64toi32_i32$5 + 848 | 0 | 0, 64 | 0) | 0;
   memcpy(i64toi32_i32$5 + 528 | 0 | 0, $45 | 0, 64 | 0) | 0;
   i64toi32_i32$1 = $9;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $950 = i64toi32_i32$4;
   i64toi32_i32$4 = $4;
   HEAP32[i64toi32_i32$4 >> 2] = $950;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $2;
   i64toi32_i32$5 = HEAP32[($2 + 112 | 0) >> 2] | 0;
   i64toi32_i32$4 = HEAP32[($2 + 116 | 0) >> 2] | 0;
   $953 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 912 | 0) >> 2] = $953;
   HEAP32[(i64toi32_i32$5 + 916 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $18;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $956 = i64toi32_i32$4;
   i64toi32_i32$4 = $5;
   HEAP32[i64toi32_i32$4 >> 2] = $956;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $45;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $959 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 616 | 0) >> 2] = $959;
   HEAP32[(i64toi32_i32$5 + 620 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap2__h0af304cc753529fe(i64toi32_i32$5 + 112 | 0 | 0, i64toi32_i32$5 + 912 | 0 | 0, i64toi32_i32$5 + 616 | 0 | 0);
   i64toi32_i32$1 = $47;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $968 = i64toi32_i32$4;
   i64toi32_i32$4 = $4;
   HEAP32[i64toi32_i32$4 >> 2] = $968;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $29;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $971 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 912 | 0) >> 2] = $971;
   HEAP32[(i64toi32_i32$5 + 916 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $15;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $974 = i64toi32_i32$4;
   i64toi32_i32$4 = $5;
   HEAP32[i64toi32_i32$4 >> 2] = $974;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $33;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $977 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 616 | 0) >> 2] = $977;
   HEAP32[(i64toi32_i32$5 + 620 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap2__h0af304cc753529fe($29 | 0, i64toi32_i32$5 + 912 | 0 | 0, i64toi32_i32$5 + 616 | 0 | 0);
   i64toi32_i32$1 = $48;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $985 = i64toi32_i32$4;
   i64toi32_i32$4 = $4;
   HEAP32[i64toi32_i32$4 >> 2] = $985;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $28;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $988 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 912 | 0) >> 2] = $988;
   HEAP32[(i64toi32_i32$5 + 916 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $16;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $991 = i64toi32_i32$4;
   i64toi32_i32$4 = $5;
   HEAP32[i64toi32_i32$4 >> 2] = $991;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $32;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $994 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 616 | 0) >> 2] = $994;
   HEAP32[(i64toi32_i32$5 + 620 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap2__h0af304cc753529fe($28 | 0, i64toi32_i32$5 + 912 | 0 | 0, i64toi32_i32$5 + 616 | 0 | 0);
   i64toi32_i32$1 = $49;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1002 = i64toi32_i32$4;
   i64toi32_i32$4 = $4;
   HEAP32[i64toi32_i32$4 >> 2] = $1002;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $27;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1005 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 912 | 0) >> 2] = $1005;
   HEAP32[(i64toi32_i32$5 + 916 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $17;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1008 = i64toi32_i32$4;
   i64toi32_i32$4 = $5;
   HEAP32[i64toi32_i32$4 >> 2] = $1008;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $12;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1011 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 616 | 0) >> 2] = $1011;
   HEAP32[(i64toi32_i32$5 + 620 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap2__h0af304cc753529fe($27 | 0, i64toi32_i32$5 + 912 | 0 | 0, i64toi32_i32$5 + 616 | 0 | 0);
   memcpy(i64toi32_i32$5 + 616 | 0 | 0, $44 | 0, 64 | 0) | 0;
   memcpy(i64toi32_i32$5 + 528 | 0 | 0, i64toi32_i32$5 + 112 | 0 | 0, 64 | 0) | 0;
   i64toi32_i32$1 = $19;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1028 = i64toi32_i32$4;
   i64toi32_i32$4 = $6;
   HEAP32[i64toi32_i32$4 >> 2] = $1028;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $44;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1031 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 368 | 0) >> 2] = $1031;
   HEAP32[(i64toi32_i32$5 + 372 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $9;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1034 = i64toi32_i32$4;
   i64toi32_i32$4 = $7;
   HEAP32[i64toi32_i32$4 >> 2] = $1034;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $2;
   i64toi32_i32$5 = HEAP32[($2 + 112 | 0) >> 2] | 0;
   i64toi32_i32$4 = HEAP32[($2 + 116 | 0) >> 2] | 0;
   $1037 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 432 | 0) >> 2] = $1037;
   HEAP32[(i64toi32_i32$5 + 436 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__omap2__ha0f66afdd187b7fb(i64toi32_i32$5 + 784 | 0 | 0, i64toi32_i32$5 + 368 | 0 | 0, i64toi32_i32$5 + 432 | 0 | 0);
   i64toi32_i32$1 = $21;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1046 = i64toi32_i32$4;
   i64toi32_i32$4 = $6;
   HEAP32[i64toi32_i32$4 >> 2] = $1046;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $42;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1049 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 368 | 0) >> 2] = $1049;
   HEAP32[(i64toi32_i32$5 + 372 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $15;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1052 = i64toi32_i32$4;
   i64toi32_i32$4 = $7;
   HEAP32[i64toi32_i32$4 >> 2] = $1052;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $33;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1055 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 432 | 0) >> 2] = $1055;
   HEAP32[(i64toi32_i32$5 + 436 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__omap2__ha0f66afdd187b7fb($11 | 0, i64toi32_i32$5 + 368 | 0 | 0, i64toi32_i32$5 + 432 | 0 | 0);
   i64toi32_i32$1 = $22;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1063 = i64toi32_i32$4;
   i64toi32_i32$4 = $6;
   HEAP32[i64toi32_i32$4 >> 2] = $1063;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $41;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1066 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 368 | 0) >> 2] = $1066;
   HEAP32[(i64toi32_i32$5 + 372 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $16;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1069 = i64toi32_i32$4;
   i64toi32_i32$4 = $7;
   HEAP32[i64toi32_i32$4 >> 2] = $1069;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $32;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1072 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 432 | 0) >> 2] = $1072;
   HEAP32[(i64toi32_i32$5 + 436 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__omap2__ha0f66afdd187b7fb($10 | 0, i64toi32_i32$5 + 368 | 0 | 0, i64toi32_i32$5 + 432 | 0 | 0);
   i64toi32_i32$1 = $43;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1080 = i64toi32_i32$4;
   i64toi32_i32$4 = $6;
   HEAP32[i64toi32_i32$4 >> 2] = $1080;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $40;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1083 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 368 | 0) >> 2] = $1083;
   HEAP32[(i64toi32_i32$5 + 372 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $17;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1086 = i64toi32_i32$4;
   i64toi32_i32$4 = $7;
   HEAP32[i64toi32_i32$4 >> 2] = $1086;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $12;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1089 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 432 | 0) >> 2] = $1089;
   HEAP32[(i64toi32_i32$5 + 436 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__omap2__ha0f66afdd187b7fb($8 | 0, i64toi32_i32$5 + 368 | 0 | 0, i64toi32_i32$5 + 432 | 0 | 0);
   memcpy(i64toi32_i32$5 + 912 | 0 | 0, i64toi32_i32$5 + 784 | 0 | 0, 64 | 0) | 0;
   i64toi32_i32$1 = $4;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1102 = i64toi32_i32$4;
   i64toi32_i32$4 = $3;
   HEAP32[i64toi32_i32$4 >> 2] = $1102;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $2;
   i64toi32_i32$5 = HEAP32[($2 + 912 | 0) >> 2] | 0;
   i64toi32_i32$4 = HEAP32[($2 + 916 | 0) >> 2] | 0;
   $1105 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 528 | 0) >> 2] = $1105;
   HEAP32[(i64toi32_i32$5 + 532 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap__h79b8a89a90129183(i64toi32_i32$5 + 784 | 0 | 0, i64toi32_i32$5 + 528 | 0 | 0);
   i64toi32_i32$1 = $81;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1112 = i64toi32_i32$4;
   i64toi32_i32$4 = $3;
   HEAP32[i64toi32_i32$4 >> 2] = $1112;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $38;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1115 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 528 | 0) >> 2] = $1115;
   HEAP32[(i64toi32_i32$5 + 532 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap__h79b8a89a90129183($11 | 0, i64toi32_i32$5 + 528 | 0 | 0);
   i64toi32_i32$1 = $82;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1121 = i64toi32_i32$4;
   i64toi32_i32$4 = $3;
   HEAP32[i64toi32_i32$4 >> 2] = $1121;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $36;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1124 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 528 | 0) >> 2] = $1124;
   HEAP32[(i64toi32_i32$5 + 532 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap__h79b8a89a90129183($10 | 0, i64toi32_i32$5 + 528 | 0 | 0);
   i64toi32_i32$1 = $83;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1130 = i64toi32_i32$4;
   i64toi32_i32$4 = $3;
   HEAP32[i64toi32_i32$4 >> 2] = $1130;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $34;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1133 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 528 | 0) >> 2] = $1133;
   HEAP32[(i64toi32_i32$5 + 532 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap__h79b8a89a90129183($8 | 0, i64toi32_i32$5 + 528 | 0 | 0);
   memcpy(i64toi32_i32$5 + 848 | 0 | 0, i64toi32_i32$5 + 784 | 0 | 0, 64 | 0) | 0;
   $46 = memcpy($44 | 0, i64toi32_i32$5 + 848 | 0 | 0, 64 | 0) | 0;
   memcpy(i64toi32_i32$5 + 528 | 0 | 0, $46 | 0, 64 | 0) | 0;
   i64toi32_i32$1 = $20;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1152 = i64toi32_i32$4;
   i64toi32_i32$4 = $4;
   HEAP32[i64toi32_i32$4 >> 2] = $1152;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $80;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1155 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 912 | 0) >> 2] = $1155;
   HEAP32[(i64toi32_i32$5 + 916 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $19;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1158 = i64toi32_i32$4;
   i64toi32_i32$4 = $5;
   HEAP32[i64toi32_i32$4 >> 2] = $1158;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $46;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1161 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 616 | 0) >> 2] = $1161;
   HEAP32[(i64toi32_i32$5 + 620 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap2__h0af304cc753529fe($80 | 0, i64toi32_i32$5 + 912 | 0 | 0, i64toi32_i32$5 + 616 | 0 | 0);
   i64toi32_i32$1 = $50;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1169 = i64toi32_i32$4;
   i64toi32_i32$4 = $4;
   HEAP32[i64toi32_i32$4 >> 2] = $1169;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $25;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1172 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 912 | 0) >> 2] = $1172;
   HEAP32[(i64toi32_i32$5 + 916 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $15;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1175 = i64toi32_i32$4;
   i64toi32_i32$4 = $5;
   HEAP32[i64toi32_i32$4 >> 2] = $1175;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $33;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1178 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 616 | 0) >> 2] = $1178;
   HEAP32[(i64toi32_i32$5 + 620 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap2__h0af304cc753529fe($25 | 0, i64toi32_i32$5 + 912 | 0 | 0, i64toi32_i32$5 + 616 | 0 | 0);
   i64toi32_i32$1 = $51;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1186 = i64toi32_i32$4;
   i64toi32_i32$4 = $4;
   HEAP32[i64toi32_i32$4 >> 2] = $1186;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $24;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1189 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 912 | 0) >> 2] = $1189;
   HEAP32[(i64toi32_i32$5 + 916 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $16;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1192 = i64toi32_i32$4;
   i64toi32_i32$4 = $5;
   HEAP32[i64toi32_i32$4 >> 2] = $1192;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $32;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1195 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 616 | 0) >> 2] = $1195;
   HEAP32[(i64toi32_i32$5 + 620 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap2__h0af304cc753529fe($24 | 0, i64toi32_i32$5 + 912 | 0 | 0, i64toi32_i32$5 + 616 | 0 | 0);
   i64toi32_i32$1 = $52;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1203 = i64toi32_i32$4;
   i64toi32_i32$4 = $4;
   HEAP32[i64toi32_i32$4 >> 2] = $1203;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $23;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1206 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 912 | 0) >> 2] = $1206;
   HEAP32[(i64toi32_i32$5 + 916 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $17;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1209 = i64toi32_i32$4;
   i64toi32_i32$4 = $5;
   HEAP32[i64toi32_i32$4 >> 2] = $1209;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $12;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1212 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 616 | 0) >> 2] = $1212;
   HEAP32[(i64toi32_i32$5 + 620 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap2__h0af304cc753529fe($23 | 0, i64toi32_i32$5 + 912 | 0 | 0, i64toi32_i32$5 + 616 | 0 | 0);
   memcpy(i64toi32_i32$5 + 848 | 0 | 0, $45 | 0, 64 | 0) | 0;
   memcpy(i64toi32_i32$5 + 912 | 0 | 0, $80 | 0, 64 | 0) | 0;
   i64toi32_i32$1 = $18;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1228 = i64toi32_i32$4;
   i64toi32_i32$4 = $6;
   HEAP32[i64toi32_i32$4 >> 2] = $1228;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $45;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1231 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 368 | 0) >> 2] = $1231;
   HEAP32[(i64toi32_i32$5 + 372 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $20;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1234 = i64toi32_i32$4;
   i64toi32_i32$4 = $7;
   HEAP32[i64toi32_i32$4 >> 2] = $1234;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $80;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1237 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 432 | 0) >> 2] = $1237;
   HEAP32[(i64toi32_i32$5 + 436 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__omap2__ha0f66afdd187b7fb(i64toi32_i32$5 + 784 | 0 | 0, i64toi32_i32$5 + 368 | 0 | 0, i64toi32_i32$5 + 432 | 0 | 0);
   $53 = $39 + 8 | 0;
   i64toi32_i32$1 = $53;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1248 = i64toi32_i32$4;
   i64toi32_i32$4 = $6;
   HEAP32[i64toi32_i32$4 >> 2] = $1248;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $39;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1251 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 368 | 0) >> 2] = $1251;
   HEAP32[(i64toi32_i32$5 + 372 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $81;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1254 = i64toi32_i32$4;
   i64toi32_i32$4 = $7;
   HEAP32[i64toi32_i32$4 >> 2] = $1254;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $38;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1257 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 432 | 0) >> 2] = $1257;
   HEAP32[(i64toi32_i32$5 + 436 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__omap2__ha0f66afdd187b7fb($11 | 0, i64toi32_i32$5 + 368 | 0 | 0, i64toi32_i32$5 + 432 | 0 | 0);
   $54 = $37 + 8 | 0;
   i64toi32_i32$1 = $54;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1267 = i64toi32_i32$4;
   i64toi32_i32$4 = $6;
   HEAP32[i64toi32_i32$4 >> 2] = $1267;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $37;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1270 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 368 | 0) >> 2] = $1270;
   HEAP32[(i64toi32_i32$5 + 372 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $82;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1273 = i64toi32_i32$4;
   i64toi32_i32$4 = $7;
   HEAP32[i64toi32_i32$4 >> 2] = $1273;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $36;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1276 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 432 | 0) >> 2] = $1276;
   HEAP32[(i64toi32_i32$5 + 436 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__omap2__ha0f66afdd187b7fb($10 | 0, i64toi32_i32$5 + 368 | 0 | 0, i64toi32_i32$5 + 432 | 0 | 0);
   $56 = $35 + 8 | 0;
   i64toi32_i32$1 = $56;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1286 = i64toi32_i32$4;
   i64toi32_i32$4 = $6;
   HEAP32[i64toi32_i32$4 >> 2] = $1286;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $35;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1289 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 368 | 0) >> 2] = $1289;
   HEAP32[(i64toi32_i32$5 + 372 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $83;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1292 = i64toi32_i32$4;
   i64toi32_i32$4 = $7;
   HEAP32[i64toi32_i32$4 >> 2] = $1292;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $34;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1295 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 432 | 0) >> 2] = $1295;
   HEAP32[(i64toi32_i32$5 + 436 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__omap2__ha0f66afdd187b7fb($8 | 0, i64toi32_i32$5 + 368 | 0 | 0, i64toi32_i32$5 + 432 | 0 | 0);
   memcpy(i64toi32_i32$5 + 528 | 0 | 0, i64toi32_i32$5 + 784 | 0 | 0, 64 | 0) | 0;
   i64toi32_i32$1 = $3;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1308 = i64toi32_i32$4;
   i64toi32_i32$4 = $4;
   HEAP32[i64toi32_i32$4 >> 2] = $1308;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $2;
   i64toi32_i32$5 = HEAP32[($2 + 528 | 0) >> 2] | 0;
   i64toi32_i32$4 = HEAP32[($2 + 532 | 0) >> 2] | 0;
   $1311 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 912 | 0) >> 2] = $1311;
   HEAP32[(i64toi32_i32$5 + 916 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap__hc6c47356357b6261(i64toi32_i32$5 + 784 | 0 | 0, i64toi32_i32$5 + 912 | 0 | 0);
   i64toi32_i32$1 = $15;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1318 = i64toi32_i32$4;
   i64toi32_i32$4 = $4;
   HEAP32[i64toi32_i32$4 >> 2] = $1318;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $33;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1321 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 912 | 0) >> 2] = $1321;
   HEAP32[(i64toi32_i32$5 + 916 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap__hc6c47356357b6261($11 | 0, i64toi32_i32$5 + 912 | 0 | 0);
   i64toi32_i32$1 = $16;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1327 = i64toi32_i32$4;
   i64toi32_i32$4 = $4;
   HEAP32[i64toi32_i32$4 >> 2] = $1327;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $32;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1330 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 912 | 0) >> 2] = $1330;
   HEAP32[(i64toi32_i32$5 + 916 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap__hc6c47356357b6261($10 | 0, i64toi32_i32$5 + 912 | 0 | 0);
   i64toi32_i32$1 = $17;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1336 = i64toi32_i32$4;
   i64toi32_i32$4 = $4;
   HEAP32[i64toi32_i32$4 >> 2] = $1336;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $12;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1339 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 912 | 0) >> 2] = $1339;
   HEAP32[(i64toi32_i32$5 + 916 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap__hc6c47356357b6261($8 | 0, i64toi32_i32$5 + 912 | 0 | 0);
   memcpy(i64toi32_i32$5 + 616 | 0 | 0, i64toi32_i32$5 + 784 | 0 | 0, 64 | 0) | 0;
   $44 = memcpy($45 | 0, i64toi32_i32$5 + 616 | 0 | 0, 64 | 0) | 0;
   $45 = HEAP32[$9 >> 2] | 0;
   $57 = HEAP32[(i64toi32_i32$5 + 112 | 0) >> 2] | 0;
   $58 = HEAP32[(i64toi32_i32$5 + 116 | 0) >> 2] | 0;
   $59 = HEAP32[(i64toi32_i32$5 + 124 | 0) >> 2] | 0;
   $60 = HEAP32[(i64toi32_i32$5 + 128 | 0) >> 2] | 0;
   $61 = HEAP32[(i64toi32_i32$5 + 132 | 0) >> 2] | 0;
   $62 = HEAP32[(i64toi32_i32$5 + 136 | 0) >> 2] | 0;
   $63 = HEAP32[(i64toi32_i32$5 + 140 | 0) >> 2] | 0;
   $64 = HEAP32[(i64toi32_i32$5 + 144 | 0) >> 2] | 0;
   $65 = HEAP32[(i64toi32_i32$5 + 148 | 0) >> 2] | 0;
   $66 = HEAP32[(i64toi32_i32$5 + 152 | 0) >> 2] | 0;
   $67 = HEAP32[(i64toi32_i32$5 + 156 | 0) >> 2] | 0;
   $68 = HEAP32[(i64toi32_i32$5 + 160 | 0) >> 2] | 0;
   $69 = HEAP32[(i64toi32_i32$5 + 164 | 0) >> 2] | 0;
   $70 = HEAP32[(i64toi32_i32$5 + 168 | 0) >> 2] | 0;
   $71 = HEAP32[(i64toi32_i32$5 + 172 | 0) >> 2] | 0;
   $72 = HEAP32[(i64toi32_i32$5 + 180 | 0) >> 2] | 0;
   $73 = HEAP32[(i64toi32_i32$5 + 184 | 0) >> 2] | 0;
   $74 = HEAP32[(i64toi32_i32$5 + 188 | 0) >> 2] | 0;
   $75 = HEAP32[(i64toi32_i32$5 + 176 | 0) >> 2] | 0;
   $76 = HEAP32[(i64toi32_i32$5 + 196 | 0) >> 2] | 0;
   $77 = HEAP32[(i64toi32_i32$5 + 200 | 0) >> 2] | 0;
   $78 = HEAP32[(i64toi32_i32$5 + 204 | 0) >> 2] | 0;
   $79 = HEAP32[(i64toi32_i32$5 + 192 | 0) >> 2] | 0;
   $84 = HEAP32[(i64toi32_i32$5 + 212 | 0) >> 2] | 0;
   $85 = HEAP32[(i64toi32_i32$5 + 216 | 0) >> 2] | 0;
   $86 = HEAP32[(i64toi32_i32$5 + 220 | 0) >> 2] | 0;
   $87 = HEAP32[(i64toi32_i32$5 + 208 | 0) >> 2] | 0;
   $88 = HEAP32[(i64toi32_i32$5 + 228 | 0) >> 2] | 0;
   $89 = HEAP32[(i64toi32_i32$5 + 232 | 0) >> 2] | 0;
   $90 = HEAP32[(i64toi32_i32$5 + 236 | 0) >> 2] | 0;
   $91 = HEAP32[(i64toi32_i32$5 + 224 | 0) >> 2] | 0;
   memcpy(i64toi32_i32$5 + 48 | 0 | 0, $80 | 0, 64 | 0) | 0;
   $92 = HEAP32[(i64toi32_i32$5 + 316 | 0) >> 2] | 0;
   $93 = HEAP32[(i64toi32_i32$5 + 304 | 0) >> 2] | 0;
   $94 = HEAP32[(i64toi32_i32$5 + 308 | 0) >> 2] | 0;
   $95 = HEAP32[(i64toi32_i32$5 + 312 | 0) >> 2] | 0;
   $96 = HEAP32[(i64toi32_i32$5 + 332 | 0) >> 2] | 0;
   $97 = HEAP32[(i64toi32_i32$5 + 320 | 0) >> 2] | 0;
   $98 = HEAP32[(i64toi32_i32$5 + 324 | 0) >> 2] | 0;
   $99 = HEAP32[(i64toi32_i32$5 + 328 | 0) >> 2] | 0;
   $100 = HEAP32[(i64toi32_i32$5 + 348 | 0) >> 2] | 0;
   $101 = HEAP32[(i64toi32_i32$5 + 336 | 0) >> 2] | 0;
   $102 = HEAP32[(i64toi32_i32$5 + 340 | 0) >> 2] | 0;
   $103 = HEAP32[(i64toi32_i32$5 + 344 | 0) >> 2] | 0;
   $104 = HEAP32[(i64toi32_i32$5 + 364 | 0) >> 2] | 0;
   $105 = HEAP32[(i64toi32_i32$5 + 352 | 0) >> 2] | 0;
   $106 = HEAP32[(i64toi32_i32$5 + 356 | 0) >> 2] | 0;
   $107 = HEAP32[(i64toi32_i32$5 + 360 | 0) >> 2] | 0;
   memcpy(i64toi32_i32$5 + 912 | 0 | 0, i64toi32_i32$5 + 48 | 0 | 0, 64 | 0) | 0;
   i64toi32_i32$1 = (i64toi32_i32$5 + 48 | 0) + 8 | 0;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1461 = i64toi32_i32$4;
   i64toi32_i32$4 = $3;
   HEAP32[i64toi32_i32$4 >> 2] = $1461;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $2;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 48 | 0) >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 52 | 0) >> 2] | 0;
   $1464 = i64toi32_i32$5;
   i64toi32_i32$5 = i64toi32_i32$1;
   HEAP32[(i64toi32_i32$5 + 528 | 0) >> 2] = $1464;
   HEAP32[(i64toi32_i32$5 + 532 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__omap__h69e9e38458647661(i64toi32_i32$5 + 784 | 0 | 0, i64toi32_i32$5 + 528 | 0 | 0);
   i64toi32_i32$1 = $81;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1471 = i64toi32_i32$4;
   i64toi32_i32$4 = $3;
   HEAP32[i64toi32_i32$4 >> 2] = $1471;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $38;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1474 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 528 | 0) >> 2] = $1474;
   HEAP32[(i64toi32_i32$5 + 532 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__omap__h69e9e38458647661($11 | 0, i64toi32_i32$5 + 528 | 0 | 0);
   i64toi32_i32$1 = $82;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1480 = i64toi32_i32$4;
   i64toi32_i32$4 = $3;
   HEAP32[i64toi32_i32$4 >> 2] = $1480;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $36;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1483 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 528 | 0) >> 2] = $1483;
   HEAP32[(i64toi32_i32$5 + 532 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__omap__h69e9e38458647661($10 | 0, i64toi32_i32$5 + 528 | 0 | 0);
   i64toi32_i32$1 = $83;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1489 = i64toi32_i32$4;
   i64toi32_i32$4 = $3;
   HEAP32[i64toi32_i32$4 >> 2] = $1489;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $34;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1492 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 528 | 0) >> 2] = $1492;
   HEAP32[(i64toi32_i32$5 + 532 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__omap__h69e9e38458647661($8 | 0, i64toi32_i32$5 + 528 | 0 | 0);
   memcpy(i64toi32_i32$5 + 848 | 0 | 0, i64toi32_i32$5 + 784 | 0 | 0, 64 | 0) | 0;
   memcpy(i64toi32_i32$5 + 528 | 0 | 0, i64toi32_i32$5 + 848 | 0 | 0, 64 | 0) | 0;
   HEAP32[$9 >> 2] = $45;
   HEAP32[(i64toi32_i32$5 + 236 | 0) >> 2] = $91;
   HEAP32[(i64toi32_i32$5 + 232 | 0) >> 2] = $90;
   HEAP32[(i64toi32_i32$5 + 228 | 0) >> 2] = $89;
   HEAP32[(i64toi32_i32$5 + 224 | 0) >> 2] = $88;
   HEAP32[(i64toi32_i32$5 + 220 | 0) >> 2] = $87;
   HEAP32[(i64toi32_i32$5 + 216 | 0) >> 2] = $86;
   HEAP32[(i64toi32_i32$5 + 212 | 0) >> 2] = $85;
   HEAP32[(i64toi32_i32$5 + 208 | 0) >> 2] = $84;
   HEAP32[(i64toi32_i32$5 + 204 | 0) >> 2] = $79;
   HEAP32[(i64toi32_i32$5 + 200 | 0) >> 2] = $78;
   HEAP32[(i64toi32_i32$5 + 196 | 0) >> 2] = $77;
   HEAP32[(i64toi32_i32$5 + 192 | 0) >> 2] = $76;
   HEAP32[(i64toi32_i32$5 + 188 | 0) >> 2] = $75;
   HEAP32[(i64toi32_i32$5 + 184 | 0) >> 2] = $74;
   HEAP32[(i64toi32_i32$5 + 180 | 0) >> 2] = $73;
   HEAP32[(i64toi32_i32$5 + 176 | 0) >> 2] = $72;
   HEAP32[(i64toi32_i32$5 + 172 | 0) >> 2] = $71;
   HEAP32[(i64toi32_i32$5 + 168 | 0) >> 2] = $70;
   HEAP32[(i64toi32_i32$5 + 164 | 0) >> 2] = $69;
   HEAP32[(i64toi32_i32$5 + 160 | 0) >> 2] = $68;
   HEAP32[(i64toi32_i32$5 + 156 | 0) >> 2] = $67;
   HEAP32[(i64toi32_i32$5 + 152 | 0) >> 2] = $66;
   HEAP32[(i64toi32_i32$5 + 148 | 0) >> 2] = $65;
   HEAP32[(i64toi32_i32$5 + 144 | 0) >> 2] = $64;
   HEAP32[(i64toi32_i32$5 + 140 | 0) >> 2] = $63;
   HEAP32[(i64toi32_i32$5 + 136 | 0) >> 2] = $62;
   HEAP32[(i64toi32_i32$5 + 132 | 0) >> 2] = $61;
   HEAP32[(i64toi32_i32$5 + 128 | 0) >> 2] = $60;
   HEAP32[(i64toi32_i32$5 + 124 | 0) >> 2] = $59;
   HEAP32[(i64toi32_i32$5 + 116 | 0) >> 2] = $58;
   HEAP32[(i64toi32_i32$5 + 112 | 0) >> 2] = $57;
   $80 = memcpy($80 | 0, i64toi32_i32$5 + 528 | 0 | 0, 64 | 0) | 0;
   HEAP32[(i64toi32_i32$5 + 364 | 0) >> 2] = $107;
   HEAP32[(i64toi32_i32$5 + 360 | 0) >> 2] = $106;
   HEAP32[(i64toi32_i32$5 + 356 | 0) >> 2] = $105;
   HEAP32[(i64toi32_i32$5 + 352 | 0) >> 2] = $104;
   HEAP32[(i64toi32_i32$5 + 348 | 0) >> 2] = $103;
   HEAP32[(i64toi32_i32$5 + 344 | 0) >> 2] = $102;
   HEAP32[(i64toi32_i32$5 + 340 | 0) >> 2] = $101;
   HEAP32[(i64toi32_i32$5 + 336 | 0) >> 2] = $100;
   HEAP32[(i64toi32_i32$5 + 332 | 0) >> 2] = $99;
   HEAP32[(i64toi32_i32$5 + 328 | 0) >> 2] = $98;
   HEAP32[(i64toi32_i32$5 + 324 | 0) >> 2] = $97;
   HEAP32[(i64toi32_i32$5 + 320 | 0) >> 2] = $96;
   HEAP32[(i64toi32_i32$5 + 316 | 0) >> 2] = $95;
   HEAP32[(i64toi32_i32$5 + 312 | 0) >> 2] = $94;
   HEAP32[(i64toi32_i32$5 + 308 | 0) >> 2] = $93;
   HEAP32[(i64toi32_i32$5 + 304 | 0) >> 2] = $92;
   memcpy(i64toi32_i32$5 + 528 | 0 | 0, $44 | 0, 64 | 0) | 0;
   i64toi32_i32$1 = $9;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1612 = i64toi32_i32$4;
   i64toi32_i32$4 = $4;
   HEAP32[i64toi32_i32$4 >> 2] = $1612;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $2;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 112 | 0) >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 116 | 0) >> 2] | 0;
   $1615 = i64toi32_i32$5;
   i64toi32_i32$5 = i64toi32_i32$1;
   HEAP32[(i64toi32_i32$5 + 912 | 0) >> 2] = $1615;
   HEAP32[(i64toi32_i32$5 + 916 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $18;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1618 = i64toi32_i32$4;
   i64toi32_i32$4 = $5;
   HEAP32[i64toi32_i32$4 >> 2] = $1618;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $44;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1621 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 616 | 0) >> 2] = $1621;
   HEAP32[(i64toi32_i32$5 + 620 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap2__h0af304cc753529fe(i64toi32_i32$5 + 112 | 0 | 0, i64toi32_i32$5 + 912 | 0 | 0, i64toi32_i32$5 + 616 | 0 | 0);
   i64toi32_i32$1 = $47;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1630 = i64toi32_i32$4;
   i64toi32_i32$4 = $4;
   HEAP32[i64toi32_i32$4 >> 2] = $1630;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $29;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1633 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 912 | 0) >> 2] = $1633;
   HEAP32[(i64toi32_i32$5 + 916 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $15;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1636 = i64toi32_i32$4;
   i64toi32_i32$4 = $5;
   HEAP32[i64toi32_i32$4 >> 2] = $1636;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $33;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1639 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 616 | 0) >> 2] = $1639;
   HEAP32[(i64toi32_i32$5 + 620 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap2__h0af304cc753529fe($29 | 0, i64toi32_i32$5 + 912 | 0 | 0, i64toi32_i32$5 + 616 | 0 | 0);
   i64toi32_i32$1 = $48;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1647 = i64toi32_i32$4;
   i64toi32_i32$4 = $4;
   HEAP32[i64toi32_i32$4 >> 2] = $1647;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $28;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1650 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 912 | 0) >> 2] = $1650;
   HEAP32[(i64toi32_i32$5 + 916 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $16;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1653 = i64toi32_i32$4;
   i64toi32_i32$4 = $5;
   HEAP32[i64toi32_i32$4 >> 2] = $1653;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $32;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1656 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 616 | 0) >> 2] = $1656;
   HEAP32[(i64toi32_i32$5 + 620 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap2__h0af304cc753529fe($28 | 0, i64toi32_i32$5 + 912 | 0 | 0, i64toi32_i32$5 + 616 | 0 | 0);
   i64toi32_i32$1 = $49;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1664 = i64toi32_i32$4;
   i64toi32_i32$4 = $4;
   HEAP32[i64toi32_i32$4 >> 2] = $1664;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $27;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1667 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 912 | 0) >> 2] = $1667;
   HEAP32[(i64toi32_i32$5 + 916 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $17;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1670 = i64toi32_i32$4;
   i64toi32_i32$4 = $5;
   HEAP32[i64toi32_i32$4 >> 2] = $1670;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $12;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1673 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 616 | 0) >> 2] = $1673;
   HEAP32[(i64toi32_i32$5 + 620 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap2__h0af304cc753529fe($27 | 0, i64toi32_i32$5 + 912 | 0 | 0, i64toi32_i32$5 + 616 | 0 | 0);
   memcpy(i64toi32_i32$5 + 616 | 0 | 0, $46 | 0, 64 | 0) | 0;
   memcpy(i64toi32_i32$5 + 528 | 0 | 0, i64toi32_i32$5 + 112 | 0 | 0, 64 | 0) | 0;
   i64toi32_i32$1 = $19;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1690 = i64toi32_i32$4;
   i64toi32_i32$4 = $6;
   HEAP32[i64toi32_i32$4 >> 2] = $1690;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $46;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1693 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 368 | 0) >> 2] = $1693;
   HEAP32[(i64toi32_i32$5 + 372 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $9;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1696 = i64toi32_i32$4;
   i64toi32_i32$4 = $7;
   HEAP32[i64toi32_i32$4 >> 2] = $1696;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $2;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 112 | 0) >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 116 | 0) >> 2] | 0;
   $1699 = i64toi32_i32$5;
   i64toi32_i32$5 = i64toi32_i32$1;
   HEAP32[(i64toi32_i32$5 + 432 | 0) >> 2] = $1699;
   HEAP32[(i64toi32_i32$5 + 436 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__omap2__ha0f66afdd187b7fb(i64toi32_i32$5 + 784 | 0 | 0, i64toi32_i32$5 + 368 | 0 | 0, i64toi32_i32$5 + 432 | 0 | 0);
   i64toi32_i32$1 = $21;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1708 = i64toi32_i32$4;
   i64toi32_i32$4 = $6;
   HEAP32[i64toi32_i32$4 >> 2] = $1708;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $42;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1711 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 368 | 0) >> 2] = $1711;
   HEAP32[(i64toi32_i32$5 + 372 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $15;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1714 = i64toi32_i32$4;
   i64toi32_i32$4 = $7;
   HEAP32[i64toi32_i32$4 >> 2] = $1714;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $33;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1717 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 432 | 0) >> 2] = $1717;
   HEAP32[(i64toi32_i32$5 + 436 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__omap2__ha0f66afdd187b7fb($11 | 0, i64toi32_i32$5 + 368 | 0 | 0, i64toi32_i32$5 + 432 | 0 | 0);
   i64toi32_i32$1 = $22;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1725 = i64toi32_i32$4;
   i64toi32_i32$4 = $6;
   HEAP32[i64toi32_i32$4 >> 2] = $1725;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $41;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1728 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 368 | 0) >> 2] = $1728;
   HEAP32[(i64toi32_i32$5 + 372 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $16;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1731 = i64toi32_i32$4;
   i64toi32_i32$4 = $7;
   HEAP32[i64toi32_i32$4 >> 2] = $1731;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $32;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1734 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 432 | 0) >> 2] = $1734;
   HEAP32[(i64toi32_i32$5 + 436 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__omap2__ha0f66afdd187b7fb($10 | 0, i64toi32_i32$5 + 368 | 0 | 0, i64toi32_i32$5 + 432 | 0 | 0);
   i64toi32_i32$1 = $43;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1742 = i64toi32_i32$4;
   i64toi32_i32$4 = $6;
   HEAP32[i64toi32_i32$4 >> 2] = $1742;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $40;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1745 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 368 | 0) >> 2] = $1745;
   HEAP32[(i64toi32_i32$5 + 372 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $17;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1748 = i64toi32_i32$4;
   i64toi32_i32$4 = $7;
   HEAP32[i64toi32_i32$4 >> 2] = $1748;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $12;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1751 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 432 | 0) >> 2] = $1751;
   HEAP32[(i64toi32_i32$5 + 436 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__omap2__ha0f66afdd187b7fb($8 | 0, i64toi32_i32$5 + 368 | 0 | 0, i64toi32_i32$5 + 432 | 0 | 0);
   memcpy(i64toi32_i32$5 + 912 | 0 | 0, i64toi32_i32$5 + 784 | 0 | 0, 64 | 0) | 0;
   i64toi32_i32$1 = $4;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1764 = i64toi32_i32$4;
   i64toi32_i32$4 = $3;
   HEAP32[i64toi32_i32$4 >> 2] = $1764;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $2;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 912 | 0) >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 916 | 0) >> 2] | 0;
   $1767 = i64toi32_i32$5;
   i64toi32_i32$5 = i64toi32_i32$1;
   HEAP32[(i64toi32_i32$5 + 528 | 0) >> 2] = $1767;
   HEAP32[(i64toi32_i32$5 + 532 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap__hd102a368e6d0db5e(i64toi32_i32$5 + 784 | 0 | 0, i64toi32_i32$5 + 528 | 0 | 0);
   i64toi32_i32$1 = $81;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1774 = i64toi32_i32$4;
   i64toi32_i32$4 = $3;
   HEAP32[i64toi32_i32$4 >> 2] = $1774;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $38;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1777 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 528 | 0) >> 2] = $1777;
   HEAP32[(i64toi32_i32$5 + 532 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap__hd102a368e6d0db5e($11 | 0, i64toi32_i32$5 + 528 | 0 | 0);
   i64toi32_i32$1 = $82;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1783 = i64toi32_i32$4;
   i64toi32_i32$4 = $3;
   HEAP32[i64toi32_i32$4 >> 2] = $1783;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $36;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1786 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 528 | 0) >> 2] = $1786;
   HEAP32[(i64toi32_i32$5 + 532 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap__hd102a368e6d0db5e($10 | 0, i64toi32_i32$5 + 528 | 0 | 0);
   i64toi32_i32$1 = $83;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1792 = i64toi32_i32$4;
   i64toi32_i32$4 = $3;
   HEAP32[i64toi32_i32$4 >> 2] = $1792;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $34;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1795 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 528 | 0) >> 2] = $1795;
   HEAP32[(i64toi32_i32$5 + 532 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap__hd102a368e6d0db5e($8 | 0, i64toi32_i32$5 + 528 | 0 | 0);
   memcpy(i64toi32_i32$5 + 848 | 0 | 0, i64toi32_i32$5 + 784 | 0 | 0, 64 | 0) | 0;
   $45 = memcpy($46 | 0, i64toi32_i32$5 + 848 | 0 | 0, 64 | 0) | 0;
   memcpy(i64toi32_i32$5 + 528 | 0 | 0, $45 | 0, 64 | 0) | 0;
   i64toi32_i32$1 = $20;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1814 = i64toi32_i32$4;
   i64toi32_i32$4 = $4;
   HEAP32[i64toi32_i32$4 >> 2] = $1814;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $80;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1817 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 912 | 0) >> 2] = $1817;
   HEAP32[(i64toi32_i32$5 + 916 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $19;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1820 = i64toi32_i32$4;
   i64toi32_i32$4 = $5;
   HEAP32[i64toi32_i32$4 >> 2] = $1820;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $45;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1823 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 616 | 0) >> 2] = $1823;
   HEAP32[(i64toi32_i32$5 + 620 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap2__h0af304cc753529fe($80 | 0, i64toi32_i32$5 + 912 | 0 | 0, i64toi32_i32$5 + 616 | 0 | 0);
   i64toi32_i32$1 = $50;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1831 = i64toi32_i32$4;
   i64toi32_i32$4 = $4;
   HEAP32[i64toi32_i32$4 >> 2] = $1831;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $25;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1834 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 912 | 0) >> 2] = $1834;
   HEAP32[(i64toi32_i32$5 + 916 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $15;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1837 = i64toi32_i32$4;
   i64toi32_i32$4 = $5;
   HEAP32[i64toi32_i32$4 >> 2] = $1837;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $33;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1840 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 616 | 0) >> 2] = $1840;
   HEAP32[(i64toi32_i32$5 + 620 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap2__h0af304cc753529fe($25 | 0, i64toi32_i32$5 + 912 | 0 | 0, i64toi32_i32$5 + 616 | 0 | 0);
   i64toi32_i32$1 = $51;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1848 = i64toi32_i32$4;
   i64toi32_i32$4 = $4;
   HEAP32[i64toi32_i32$4 >> 2] = $1848;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $24;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1851 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 912 | 0) >> 2] = $1851;
   HEAP32[(i64toi32_i32$5 + 916 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $16;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1854 = i64toi32_i32$4;
   i64toi32_i32$4 = $5;
   HEAP32[i64toi32_i32$4 >> 2] = $1854;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $32;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1857 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 616 | 0) >> 2] = $1857;
   HEAP32[(i64toi32_i32$5 + 620 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap2__h0af304cc753529fe($24 | 0, i64toi32_i32$5 + 912 | 0 | 0, i64toi32_i32$5 + 616 | 0 | 0);
   i64toi32_i32$1 = $52;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1865 = i64toi32_i32$4;
   i64toi32_i32$4 = $4;
   HEAP32[i64toi32_i32$4 >> 2] = $1865;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $23;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1868 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 912 | 0) >> 2] = $1868;
   HEAP32[(i64toi32_i32$5 + 916 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $17;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1871 = i64toi32_i32$4;
   i64toi32_i32$4 = $5;
   HEAP32[i64toi32_i32$4 >> 2] = $1871;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $12;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1874 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 616 | 0) >> 2] = $1874;
   HEAP32[(i64toi32_i32$5 + 620 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap2__h0af304cc753529fe($23 | 0, i64toi32_i32$5 + 912 | 0 | 0, i64toi32_i32$5 + 616 | 0 | 0);
   memcpy(i64toi32_i32$5 + 616 | 0 | 0, $44 | 0, 64 | 0) | 0;
   memcpy(i64toi32_i32$5 + 528 | 0 | 0, $80 | 0, 64 | 0) | 0;
   i64toi32_i32$1 = $18;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1890 = i64toi32_i32$4;
   i64toi32_i32$4 = $6;
   HEAP32[i64toi32_i32$4 >> 2] = $1890;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $44;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1893 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 368 | 0) >> 2] = $1893;
   HEAP32[(i64toi32_i32$5 + 372 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $20;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1896 = i64toi32_i32$4;
   i64toi32_i32$4 = $7;
   HEAP32[i64toi32_i32$4 >> 2] = $1896;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $80;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1899 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 432 | 0) >> 2] = $1899;
   HEAP32[(i64toi32_i32$5 + 436 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__omap2__ha0f66afdd187b7fb(i64toi32_i32$5 + 784 | 0 | 0, i64toi32_i32$5 + 368 | 0 | 0, i64toi32_i32$5 + 432 | 0 | 0);
   i64toi32_i32$1 = $21;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1908 = i64toi32_i32$4;
   i64toi32_i32$4 = $6;
   HEAP32[i64toi32_i32$4 >> 2] = $1908;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $42;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1911 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 368 | 0) >> 2] = $1911;
   HEAP32[(i64toi32_i32$5 + 372 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $15;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1914 = i64toi32_i32$4;
   i64toi32_i32$4 = $7;
   HEAP32[i64toi32_i32$4 >> 2] = $1914;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $33;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1917 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 432 | 0) >> 2] = $1917;
   HEAP32[(i64toi32_i32$5 + 436 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__omap2__ha0f66afdd187b7fb($11 | 0, i64toi32_i32$5 + 368 | 0 | 0, i64toi32_i32$5 + 432 | 0 | 0);
   i64toi32_i32$1 = $22;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1925 = i64toi32_i32$4;
   i64toi32_i32$4 = $6;
   HEAP32[i64toi32_i32$4 >> 2] = $1925;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $41;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1928 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 368 | 0) >> 2] = $1928;
   HEAP32[(i64toi32_i32$5 + 372 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $16;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1931 = i64toi32_i32$4;
   i64toi32_i32$4 = $7;
   HEAP32[i64toi32_i32$4 >> 2] = $1931;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $32;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1934 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 432 | 0) >> 2] = $1934;
   HEAP32[(i64toi32_i32$5 + 436 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__omap2__ha0f66afdd187b7fb($10 | 0, i64toi32_i32$5 + 368 | 0 | 0, i64toi32_i32$5 + 432 | 0 | 0);
   i64toi32_i32$1 = $43;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1942 = i64toi32_i32$4;
   i64toi32_i32$4 = $6;
   HEAP32[i64toi32_i32$4 >> 2] = $1942;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $40;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1945 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 368 | 0) >> 2] = $1945;
   HEAP32[(i64toi32_i32$5 + 372 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $17;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1948 = i64toi32_i32$4;
   i64toi32_i32$4 = $7;
   HEAP32[i64toi32_i32$4 >> 2] = $1948;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $12;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1951 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 432 | 0) >> 2] = $1951;
   HEAP32[(i64toi32_i32$5 + 436 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__omap2__ha0f66afdd187b7fb($8 | 0, i64toi32_i32$5 + 368 | 0 | 0, i64toi32_i32$5 + 432 | 0 | 0);
   memcpy(i64toi32_i32$5 + 912 | 0 | 0, i64toi32_i32$5 + 784 | 0 | 0, 64 | 0) | 0;
   i64toi32_i32$1 = $4;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1964 = i64toi32_i32$4;
   i64toi32_i32$4 = $3;
   HEAP32[i64toi32_i32$4 >> 2] = $1964;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $2;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 912 | 0) >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 916 | 0) >> 2] | 0;
   $1967 = i64toi32_i32$5;
   i64toi32_i32$5 = i64toi32_i32$1;
   HEAP32[(i64toi32_i32$5 + 528 | 0) >> 2] = $1967;
   HEAP32[(i64toi32_i32$5 + 532 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap__h8dc4284c5eb4ed5a(i64toi32_i32$5 + 784 | 0 | 0, i64toi32_i32$5 + 528 | 0 | 0);
   i64toi32_i32$1 = $81;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1974 = i64toi32_i32$4;
   i64toi32_i32$4 = $3;
   HEAP32[i64toi32_i32$4 >> 2] = $1974;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $38;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1977 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 528 | 0) >> 2] = $1977;
   HEAP32[(i64toi32_i32$5 + 532 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap__h8dc4284c5eb4ed5a($11 | 0, i64toi32_i32$5 + 528 | 0 | 0);
   i64toi32_i32$1 = $82;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1983 = i64toi32_i32$4;
   i64toi32_i32$4 = $3;
   HEAP32[i64toi32_i32$4 >> 2] = $1983;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $36;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1986 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 528 | 0) >> 2] = $1986;
   HEAP32[(i64toi32_i32$5 + 532 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap__h8dc4284c5eb4ed5a($10 | 0, i64toi32_i32$5 + 528 | 0 | 0);
   i64toi32_i32$1 = $83;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1992 = i64toi32_i32$4;
   i64toi32_i32$4 = $3;
   HEAP32[i64toi32_i32$4 >> 2] = $1992;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $34;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $1995 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 528 | 0) >> 2] = $1995;
   HEAP32[(i64toi32_i32$5 + 532 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap__h8dc4284c5eb4ed5a($8 | 0, i64toi32_i32$5 + 528 | 0 | 0);
   memcpy(i64toi32_i32$5 + 848 | 0 | 0, i64toi32_i32$5 + 784 | 0 | 0, 64 | 0) | 0;
   $44 = memcpy($44 | 0, i64toi32_i32$5 + 848 | 0 | 0, 64 | 0) | 0;
   memcpy(i64toi32_i32$5 + 528 | 0 | 0, $44 | 0, 64 | 0) | 0;
   i64toi32_i32$1 = $9;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2014 = i64toi32_i32$4;
   i64toi32_i32$4 = $4;
   HEAP32[i64toi32_i32$4 >> 2] = $2014;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $2;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 112 | 0) >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 116 | 0) >> 2] | 0;
   $2017 = i64toi32_i32$5;
   i64toi32_i32$5 = i64toi32_i32$1;
   HEAP32[(i64toi32_i32$5 + 912 | 0) >> 2] = $2017;
   HEAP32[(i64toi32_i32$5 + 916 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $18;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2020 = i64toi32_i32$4;
   i64toi32_i32$4 = $5;
   HEAP32[i64toi32_i32$4 >> 2] = $2020;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $44;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2023 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 616 | 0) >> 2] = $2023;
   HEAP32[(i64toi32_i32$5 + 620 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap2__h0af304cc753529fe(i64toi32_i32$5 + 112 | 0 | 0, i64toi32_i32$5 + 912 | 0 | 0, i64toi32_i32$5 + 616 | 0 | 0);
   i64toi32_i32$1 = $47;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2032 = i64toi32_i32$4;
   i64toi32_i32$4 = $4;
   HEAP32[i64toi32_i32$4 >> 2] = $2032;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $29;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2035 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 912 | 0) >> 2] = $2035;
   HEAP32[(i64toi32_i32$5 + 916 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $15;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2038 = i64toi32_i32$4;
   i64toi32_i32$4 = $5;
   HEAP32[i64toi32_i32$4 >> 2] = $2038;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $33;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2041 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 616 | 0) >> 2] = $2041;
   HEAP32[(i64toi32_i32$5 + 620 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap2__h0af304cc753529fe($29 | 0, i64toi32_i32$5 + 912 | 0 | 0, i64toi32_i32$5 + 616 | 0 | 0);
   i64toi32_i32$1 = $48;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2049 = i64toi32_i32$4;
   i64toi32_i32$4 = $4;
   HEAP32[i64toi32_i32$4 >> 2] = $2049;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $28;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2052 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 912 | 0) >> 2] = $2052;
   HEAP32[(i64toi32_i32$5 + 916 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $16;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2055 = i64toi32_i32$4;
   i64toi32_i32$4 = $5;
   HEAP32[i64toi32_i32$4 >> 2] = $2055;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $32;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2058 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 616 | 0) >> 2] = $2058;
   HEAP32[(i64toi32_i32$5 + 620 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap2__h0af304cc753529fe($28 | 0, i64toi32_i32$5 + 912 | 0 | 0, i64toi32_i32$5 + 616 | 0 | 0);
   i64toi32_i32$1 = $49;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2066 = i64toi32_i32$4;
   i64toi32_i32$4 = $4;
   HEAP32[i64toi32_i32$4 >> 2] = $2066;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $27;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2069 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 912 | 0) >> 2] = $2069;
   HEAP32[(i64toi32_i32$5 + 916 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $17;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2072 = i64toi32_i32$4;
   i64toi32_i32$4 = $5;
   HEAP32[i64toi32_i32$4 >> 2] = $2072;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $12;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2075 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 616 | 0) >> 2] = $2075;
   HEAP32[(i64toi32_i32$5 + 620 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap2__h0af304cc753529fe($27 | 0, i64toi32_i32$5 + 912 | 0 | 0, i64toi32_i32$5 + 616 | 0 | 0);
   memcpy(i64toi32_i32$5 + 616 | 0 | 0, $45 | 0, 64 | 0) | 0;
   memcpy(i64toi32_i32$5 + 528 | 0 | 0, i64toi32_i32$5 + 112 | 0 | 0, 64 | 0) | 0;
   i64toi32_i32$1 = $19;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2092 = i64toi32_i32$4;
   i64toi32_i32$4 = $6;
   HEAP32[i64toi32_i32$4 >> 2] = $2092;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $45;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2095 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 368 | 0) >> 2] = $2095;
   HEAP32[(i64toi32_i32$5 + 372 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $9;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2098 = i64toi32_i32$4;
   i64toi32_i32$4 = $7;
   HEAP32[i64toi32_i32$4 >> 2] = $2098;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $2;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 112 | 0) >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 116 | 0) >> 2] | 0;
   $2101 = i64toi32_i32$5;
   i64toi32_i32$5 = i64toi32_i32$1;
   HEAP32[(i64toi32_i32$5 + 432 | 0) >> 2] = $2101;
   HEAP32[(i64toi32_i32$5 + 436 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__omap2__ha0f66afdd187b7fb(i64toi32_i32$5 + 784 | 0 | 0, i64toi32_i32$5 + 368 | 0 | 0, i64toi32_i32$5 + 432 | 0 | 0);
   i64toi32_i32$1 = $21;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2110 = i64toi32_i32$4;
   i64toi32_i32$4 = $6;
   HEAP32[i64toi32_i32$4 >> 2] = $2110;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $42;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2113 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 368 | 0) >> 2] = $2113;
   HEAP32[(i64toi32_i32$5 + 372 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $15;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2116 = i64toi32_i32$4;
   i64toi32_i32$4 = $7;
   HEAP32[i64toi32_i32$4 >> 2] = $2116;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $33;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2119 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 432 | 0) >> 2] = $2119;
   HEAP32[(i64toi32_i32$5 + 436 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__omap2__ha0f66afdd187b7fb($11 | 0, i64toi32_i32$5 + 368 | 0 | 0, i64toi32_i32$5 + 432 | 0 | 0);
   i64toi32_i32$1 = $22;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2127 = i64toi32_i32$4;
   i64toi32_i32$4 = $6;
   HEAP32[i64toi32_i32$4 >> 2] = $2127;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $41;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2130 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 368 | 0) >> 2] = $2130;
   HEAP32[(i64toi32_i32$5 + 372 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $16;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2133 = i64toi32_i32$4;
   i64toi32_i32$4 = $7;
   HEAP32[i64toi32_i32$4 >> 2] = $2133;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $32;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2136 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 432 | 0) >> 2] = $2136;
   HEAP32[(i64toi32_i32$5 + 436 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__omap2__ha0f66afdd187b7fb($10 | 0, i64toi32_i32$5 + 368 | 0 | 0, i64toi32_i32$5 + 432 | 0 | 0);
   i64toi32_i32$1 = $43;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2144 = i64toi32_i32$4;
   i64toi32_i32$4 = $6;
   HEAP32[i64toi32_i32$4 >> 2] = $2144;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $40;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2147 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 368 | 0) >> 2] = $2147;
   HEAP32[(i64toi32_i32$5 + 372 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $17;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2150 = i64toi32_i32$4;
   i64toi32_i32$4 = $7;
   HEAP32[i64toi32_i32$4 >> 2] = $2150;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $12;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2153 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 432 | 0) >> 2] = $2153;
   HEAP32[(i64toi32_i32$5 + 436 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__omap2__ha0f66afdd187b7fb($8 | 0, i64toi32_i32$5 + 368 | 0 | 0, i64toi32_i32$5 + 432 | 0 | 0);
   memcpy(i64toi32_i32$5 + 912 | 0 | 0, i64toi32_i32$5 + 784 | 0 | 0, 64 | 0) | 0;
   i64toi32_i32$1 = $4;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2166 = i64toi32_i32$4;
   i64toi32_i32$4 = $3;
   HEAP32[i64toi32_i32$4 >> 2] = $2166;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $2;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 912 | 0) >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 916 | 0) >> 2] | 0;
   $2169 = i64toi32_i32$5;
   i64toi32_i32$5 = i64toi32_i32$1;
   HEAP32[(i64toi32_i32$5 + 528 | 0) >> 2] = $2169;
   HEAP32[(i64toi32_i32$5 + 532 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap__h79b8a89a90129183(i64toi32_i32$5 + 784 | 0 | 0, i64toi32_i32$5 + 528 | 0 | 0);
   i64toi32_i32$1 = $81;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2176 = i64toi32_i32$4;
   i64toi32_i32$4 = $3;
   HEAP32[i64toi32_i32$4 >> 2] = $2176;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $38;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2179 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 528 | 0) >> 2] = $2179;
   HEAP32[(i64toi32_i32$5 + 532 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap__h79b8a89a90129183($11 | 0, i64toi32_i32$5 + 528 | 0 | 0);
   i64toi32_i32$1 = $82;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2185 = i64toi32_i32$4;
   i64toi32_i32$4 = $3;
   HEAP32[i64toi32_i32$4 >> 2] = $2185;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $36;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2188 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 528 | 0) >> 2] = $2188;
   HEAP32[(i64toi32_i32$5 + 532 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap__h79b8a89a90129183($10 | 0, i64toi32_i32$5 + 528 | 0 | 0);
   i64toi32_i32$1 = $83;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2194 = i64toi32_i32$4;
   i64toi32_i32$4 = $3;
   HEAP32[i64toi32_i32$4 >> 2] = $2194;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $34;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2197 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 528 | 0) >> 2] = $2197;
   HEAP32[(i64toi32_i32$5 + 532 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap__h79b8a89a90129183($8 | 0, i64toi32_i32$5 + 528 | 0 | 0);
   memcpy(i64toi32_i32$5 + 848 | 0 | 0, i64toi32_i32$5 + 784 | 0 | 0, 64 | 0) | 0;
   $21 = memcpy($45 | 0, i64toi32_i32$5 + 848 | 0 | 0, 64 | 0) | 0;
   memcpy(i64toi32_i32$5 + 528 | 0 | 0, $21 | 0, 64 | 0) | 0;
   i64toi32_i32$1 = $20;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2216 = i64toi32_i32$4;
   i64toi32_i32$4 = $4;
   HEAP32[i64toi32_i32$4 >> 2] = $2216;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $80;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2219 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 912 | 0) >> 2] = $2219;
   HEAP32[(i64toi32_i32$5 + 916 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $19;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2222 = i64toi32_i32$4;
   i64toi32_i32$4 = $5;
   HEAP32[i64toi32_i32$4 >> 2] = $2222;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $21;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2225 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 616 | 0) >> 2] = $2225;
   HEAP32[(i64toi32_i32$5 + 620 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap2__h0af304cc753529fe($80 | 0, i64toi32_i32$5 + 912 | 0 | 0, i64toi32_i32$5 + 616 | 0 | 0);
   i64toi32_i32$1 = $50;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2233 = i64toi32_i32$4;
   i64toi32_i32$4 = $4;
   HEAP32[i64toi32_i32$4 >> 2] = $2233;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $25;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2236 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 912 | 0) >> 2] = $2236;
   HEAP32[(i64toi32_i32$5 + 916 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $15;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2239 = i64toi32_i32$4;
   i64toi32_i32$4 = $5;
   HEAP32[i64toi32_i32$4 >> 2] = $2239;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $33;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2242 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 616 | 0) >> 2] = $2242;
   HEAP32[(i64toi32_i32$5 + 620 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap2__h0af304cc753529fe($25 | 0, i64toi32_i32$5 + 912 | 0 | 0, i64toi32_i32$5 + 616 | 0 | 0);
   i64toi32_i32$1 = $51;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2250 = i64toi32_i32$4;
   i64toi32_i32$4 = $4;
   HEAP32[i64toi32_i32$4 >> 2] = $2250;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $24;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2253 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 912 | 0) >> 2] = $2253;
   HEAP32[(i64toi32_i32$5 + 916 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $16;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2256 = i64toi32_i32$4;
   i64toi32_i32$4 = $5;
   HEAP32[i64toi32_i32$4 >> 2] = $2256;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $32;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2259 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 616 | 0) >> 2] = $2259;
   HEAP32[(i64toi32_i32$5 + 620 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap2__h0af304cc753529fe($24 | 0, i64toi32_i32$5 + 912 | 0 | 0, i64toi32_i32$5 + 616 | 0 | 0);
   i64toi32_i32$1 = $52;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2267 = i64toi32_i32$4;
   i64toi32_i32$4 = $4;
   HEAP32[i64toi32_i32$4 >> 2] = $2267;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $23;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2270 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 912 | 0) >> 2] = $2270;
   HEAP32[(i64toi32_i32$5 + 916 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $17;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2273 = i64toi32_i32$4;
   i64toi32_i32$4 = $5;
   HEAP32[i64toi32_i32$4 >> 2] = $2273;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $12;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2276 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 616 | 0) >> 2] = $2276;
   HEAP32[(i64toi32_i32$5 + 620 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap2__h0af304cc753529fe($23 | 0, i64toi32_i32$5 + 912 | 0 | 0, i64toi32_i32$5 + 616 | 0 | 0);
   memcpy(i64toi32_i32$5 + 848 | 0 | 0, $44 | 0, 64 | 0) | 0;
   memcpy(i64toi32_i32$5 + 912 | 0 | 0, $80 | 0, 64 | 0) | 0;
   i64toi32_i32$1 = $18;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2292 = i64toi32_i32$4;
   i64toi32_i32$4 = $6;
   HEAP32[i64toi32_i32$4 >> 2] = $2292;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $44;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2295 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 368 | 0) >> 2] = $2295;
   HEAP32[(i64toi32_i32$5 + 372 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $20;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2298 = i64toi32_i32$4;
   i64toi32_i32$4 = $7;
   HEAP32[i64toi32_i32$4 >> 2] = $2298;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $80;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2301 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 432 | 0) >> 2] = $2301;
   HEAP32[(i64toi32_i32$5 + 436 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__omap2__ha0f66afdd187b7fb(i64toi32_i32$5 + 784 | 0 | 0, i64toi32_i32$5 + 368 | 0 | 0, i64toi32_i32$5 + 432 | 0 | 0);
   i64toi32_i32$1 = $53;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2310 = i64toi32_i32$4;
   i64toi32_i32$4 = $6;
   HEAP32[i64toi32_i32$4 >> 2] = $2310;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $39;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2313 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 368 | 0) >> 2] = $2313;
   HEAP32[(i64toi32_i32$5 + 372 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $81;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2316 = i64toi32_i32$4;
   i64toi32_i32$4 = $7;
   HEAP32[i64toi32_i32$4 >> 2] = $2316;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $38;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2319 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 432 | 0) >> 2] = $2319;
   HEAP32[(i64toi32_i32$5 + 436 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__omap2__ha0f66afdd187b7fb($11 | 0, i64toi32_i32$5 + 368 | 0 | 0, i64toi32_i32$5 + 432 | 0 | 0);
   i64toi32_i32$1 = $54;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2327 = i64toi32_i32$4;
   i64toi32_i32$4 = $6;
   HEAP32[i64toi32_i32$4 >> 2] = $2327;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $37;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2330 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 368 | 0) >> 2] = $2330;
   HEAP32[(i64toi32_i32$5 + 372 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $82;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2333 = i64toi32_i32$4;
   i64toi32_i32$4 = $7;
   HEAP32[i64toi32_i32$4 >> 2] = $2333;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $36;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2336 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 432 | 0) >> 2] = $2336;
   HEAP32[(i64toi32_i32$5 + 436 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__omap2__ha0f66afdd187b7fb($10 | 0, i64toi32_i32$5 + 368 | 0 | 0, i64toi32_i32$5 + 432 | 0 | 0);
   i64toi32_i32$1 = $56;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2344 = i64toi32_i32$4;
   i64toi32_i32$4 = $6;
   HEAP32[i64toi32_i32$4 >> 2] = $2344;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $35;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2347 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 368 | 0) >> 2] = $2347;
   HEAP32[(i64toi32_i32$5 + 372 | 0) >> 2] = i64toi32_i32$4;
   i64toi32_i32$1 = $83;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2350 = i64toi32_i32$4;
   i64toi32_i32$4 = $7;
   HEAP32[i64toi32_i32$4 >> 2] = $2350;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $34;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2353 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 432 | 0) >> 2] = $2353;
   HEAP32[(i64toi32_i32$5 + 436 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__omap2__ha0f66afdd187b7fb($8 | 0, i64toi32_i32$5 + 368 | 0 | 0, i64toi32_i32$5 + 432 | 0 | 0);
   memcpy(i64toi32_i32$5 + 528 | 0 | 0, i64toi32_i32$5 + 784 | 0 | 0, 64 | 0) | 0;
   i64toi32_i32$1 = $3;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2366 = i64toi32_i32$4;
   i64toi32_i32$4 = $4;
   HEAP32[i64toi32_i32$4 >> 2] = $2366;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $2;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 528 | 0) >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 532 | 0) >> 2] | 0;
   $2369 = i64toi32_i32$5;
   i64toi32_i32$5 = i64toi32_i32$1;
   HEAP32[(i64toi32_i32$5 + 912 | 0) >> 2] = $2369;
   HEAP32[(i64toi32_i32$5 + 916 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap__hc6c47356357b6261(i64toi32_i32$5 + 784 | 0 | 0, i64toi32_i32$5 + 912 | 0 | 0);
   i64toi32_i32$1 = $15;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2376 = i64toi32_i32$4;
   i64toi32_i32$4 = $4;
   HEAP32[i64toi32_i32$4 >> 2] = $2376;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $33;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2379 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 912 | 0) >> 2] = $2379;
   HEAP32[(i64toi32_i32$5 + 916 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap__hc6c47356357b6261($11 | 0, i64toi32_i32$5 + 912 | 0 | 0);
   i64toi32_i32$1 = $16;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2385 = i64toi32_i32$4;
   i64toi32_i32$4 = $4;
   HEAP32[i64toi32_i32$4 >> 2] = $2385;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $32;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2388 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 912 | 0) >> 2] = $2388;
   HEAP32[(i64toi32_i32$5 + 916 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap__hc6c47356357b6261($10 | 0, i64toi32_i32$5 + 912 | 0 | 0);
   i64toi32_i32$1 = $17;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2394 = i64toi32_i32$4;
   i64toi32_i32$4 = $4;
   HEAP32[i64toi32_i32$4 >> 2] = $2394;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $12;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2397 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 912 | 0) >> 2] = $2397;
   HEAP32[(i64toi32_i32$5 + 916 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__dmap__hc6c47356357b6261($8 | 0, i64toi32_i32$5 + 912 | 0 | 0);
   memcpy(i64toi32_i32$5 + 616 | 0 | 0, i64toi32_i32$5 + 784 | 0 | 0, 64 | 0) | 0;
   memcpy($44 | 0, i64toi32_i32$5 + 616 | 0 | 0, 64 | 0) | 0;
   $79 = HEAP32[$9 >> 2] | 0;
   $77 = HEAP32[(i64toi32_i32$5 + 112 | 0) >> 2] | 0;
   $78 = HEAP32[(i64toi32_i32$5 + 116 | 0) >> 2] | 0;
   $76 = HEAP32[(i64toi32_i32$5 + 124 | 0) >> 2] | 0;
   $75 = HEAP32[(i64toi32_i32$5 + 128 | 0) >> 2] | 0;
   $74 = HEAP32[(i64toi32_i32$5 + 132 | 0) >> 2] | 0;
   $73 = HEAP32[(i64toi32_i32$5 + 136 | 0) >> 2] | 0;
   $72 = HEAP32[(i64toi32_i32$5 + 140 | 0) >> 2] | 0;
   $71 = HEAP32[(i64toi32_i32$5 + 144 | 0) >> 2] | 0;
   $70 = HEAP32[(i64toi32_i32$5 + 148 | 0) >> 2] | 0;
   $69 = HEAP32[(i64toi32_i32$5 + 152 | 0) >> 2] | 0;
   $68 = HEAP32[(i64toi32_i32$5 + 156 | 0) >> 2] | 0;
   $51 = HEAP32[(i64toi32_i32$5 + 160 | 0) >> 2] | 0;
   $52 = HEAP32[(i64toi32_i32$5 + 164 | 0) >> 2] | 0;
   $53 = HEAP32[(i64toi32_i32$5 + 168 | 0) >> 2] | 0;
   $54 = HEAP32[(i64toi32_i32$5 + 172 | 0) >> 2] | 0;
   $66 = HEAP32[(i64toi32_i32$5 + 176 | 0) >> 2] | 0;
   $65 = HEAP32[(i64toi32_i32$5 + 180 | 0) >> 2] | 0;
   $64 = HEAP32[(i64toi32_i32$5 + 184 | 0) >> 2] | 0;
   $67 = HEAP32[(i64toi32_i32$5 + 188 | 0) >> 2] | 0;
   $62 = HEAP32[(i64toi32_i32$5 + 192 | 0) >> 2] | 0;
   $61 = HEAP32[(i64toi32_i32$5 + 196 | 0) >> 2] | 0;
   $60 = HEAP32[(i64toi32_i32$5 + 200 | 0) >> 2] | 0;
   $63 = HEAP32[(i64toi32_i32$5 + 204 | 0) >> 2] | 0;
   $58 = HEAP32[(i64toi32_i32$5 + 208 | 0) >> 2] | 0;
   $57 = HEAP32[(i64toi32_i32$5 + 212 | 0) >> 2] | 0;
   $56 = HEAP32[(i64toi32_i32$5 + 216 | 0) >> 2] | 0;
   $59 = HEAP32[(i64toi32_i32$5 + 220 | 0) >> 2] | 0;
   $6 = HEAP32[(i64toi32_i32$5 + 224 | 0) >> 2] | 0;
   $5 = HEAP32[(i64toi32_i32$5 + 228 | 0) >> 2] | 0;
   $4 = HEAP32[(i64toi32_i32$5 + 232 | 0) >> 2] | 0;
   $7 = HEAP32[(i64toi32_i32$5 + 236 | 0) >> 2] | 0;
   memcpy(i64toi32_i32$5 + 528 | 0 | 0, $80 | 0, 64 | 0) | 0;
   $43 = HEAP32[(i64toi32_i32$5 + 364 | 0) >> 2] | 0;
   $19 = HEAP32[(i64toi32_i32$5 + 360 | 0) >> 2] | 0;
   $44 = HEAP32[(i64toi32_i32$5 + 356 | 0) >> 2] | 0;
   $20 = HEAP32[(i64toi32_i32$5 + 352 | 0) >> 2] | 0;
   $45 = HEAP32[(i64toi32_i32$5 + 348 | 0) >> 2] | 0;
   $17 = HEAP32[(i64toi32_i32$5 + 344 | 0) >> 2] | 0;
   $46 = HEAP32[(i64toi32_i32$5 + 340 | 0) >> 2] | 0;
   $18 = HEAP32[(i64toi32_i32$5 + 336 | 0) >> 2] | 0;
   $47 = HEAP32[(i64toi32_i32$5 + 332 | 0) >> 2] | 0;
   $15 = HEAP32[(i64toi32_i32$5 + 328 | 0) >> 2] | 0;
   $48 = HEAP32[(i64toi32_i32$5 + 324 | 0) >> 2] | 0;
   $16 = HEAP32[(i64toi32_i32$5 + 320 | 0) >> 2] | 0;
   $49 = HEAP32[(i64toi32_i32$5 + 316 | 0) >> 2] | 0;
   $21 = HEAP32[(i64toi32_i32$5 + 312 | 0) >> 2] | 0;
   $50 = HEAP32[(i64toi32_i32$5 + 308 | 0) >> 2] | 0;
   $22 = HEAP32[(i64toi32_i32$5 + 304 | 0) >> 2] | 0;
   memcpy(i64toi32_i32$5 + 912 | 0 | 0, i64toi32_i32$5 + 528 | 0 | 0, 64 | 0) | 0;
   i64toi32_i32$1 = $3;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2517 = i64toi32_i32$4;
   i64toi32_i32$4 = $9;
   HEAP32[i64toi32_i32$4 >> 2] = $2517;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $2;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 528 | 0) >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 532 | 0) >> 2] | 0;
   $2520 = i64toi32_i32$5;
   i64toi32_i32$5 = i64toi32_i32$1;
   HEAP32[(i64toi32_i32$5 + 112 | 0) >> 2] = $2520;
   HEAP32[(i64toi32_i32$5 + 116 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__omap__h69e9e38458647661(i64toi32_i32$5 + 784 | 0 | 0, i64toi32_i32$5 + 112 | 0 | 0);
   i64toi32_i32$1 = $81;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2527 = i64toi32_i32$4;
   i64toi32_i32$4 = $9;
   HEAP32[i64toi32_i32$4 >> 2] = $2527;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $38;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2530 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 112 | 0) >> 2] = $2530;
   HEAP32[(i64toi32_i32$5 + 116 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__omap__h69e9e38458647661($11 | 0, i64toi32_i32$5 + 112 | 0 | 0);
   i64toi32_i32$1 = $82;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2536 = i64toi32_i32$4;
   i64toi32_i32$4 = $9;
   HEAP32[i64toi32_i32$4 >> 2] = $2536;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $36;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2539 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 112 | 0) >> 2] = $2539;
   HEAP32[(i64toi32_i32$5 + 116 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__omap__h69e9e38458647661($10 | 0, i64toi32_i32$5 + 112 | 0 | 0);
   i64toi32_i32$1 = $83;
   i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2545 = i64toi32_i32$4;
   i64toi32_i32$4 = $9;
   HEAP32[i64toi32_i32$4 >> 2] = $2545;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $34;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $2548 = i64toi32_i32$5;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 112 | 0) >> 2] = $2548;
   HEAP32[(i64toi32_i32$5 + 116 | 0) >> 2] = i64toi32_i32$4;
   ppv_lite86__generic__omap__h69e9e38458647661($8 | 0, i64toi32_i32$5 + 112 | 0 | 0);
   memcpy(i64toi32_i32$5 + 848 | 0 | 0, i64toi32_i32$5 + 784 | 0 | 0, 64 | 0) | 0;
   memcpy(i64toi32_i32$5 + 528 | 0 | 0, i64toi32_i32$5 + 848 | 0 | 0, 64 | 0) | 0;
   memcpy(i64toi32_i32$5 + 48 | 0 | 0, i64toi32_i32$5 + 528 | 0 | 0, 64 | 0) | 0;
   $55 = $55 + -1 | 0;
   if ($55) {
    continue label$1
   }
   break label$1;
  };
  i64toi32_i32$1 = $0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 32 | 0) >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] | 0;
  $108 = i64toi32_i32$4;
  $108$hi = i64toi32_i32$5;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 40 | 0) >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 44 | 0) >> 2] | 0;
  $109 = i64toi32_i32$5;
  $109$hi = i64toi32_i32$4;
  HEAP32[(($2 + 368 | 0) + 60 | 0) >> 2] = $54;
  HEAP32[(($2 + 368 | 0) + 56 | 0) >> 2] = $53;
  HEAP32[(($2 + 368 | 0) + 52 | 0) >> 2] = $52;
  HEAP32[(($2 + 368 | 0) + 44 | 0) >> 2] = $68;
  HEAP32[(($2 + 368 | 0) + 40 | 0) >> 2] = $69;
  HEAP32[(($2 + 368 | 0) + 36 | 0) >> 2] = $70;
  HEAP32[(($2 + 368 | 0) + 28 | 0) >> 2] = $72;
  HEAP32[(($2 + 368 | 0) + 24 | 0) >> 2] = $73;
  HEAP32[(($2 + 368 | 0) + 20 | 0) >> 2] = $74;
  HEAP32[($2 + 416 | 0) >> 2] = $51;
  HEAP32[($2 + 400 | 0) >> 2] = $71;
  HEAP32[($2 + 384 | 0) >> 2] = $75;
  HEAP32[($2 + 380 | 0) >> 2] = $76;
  HEAP32[($2 + 376 | 0) >> 2] = $79;
  HEAP32[($2 + 372 | 0) >> 2] = $78;
  HEAP32[($2 + 368 | 0) >> 2] = $77;
  HEAP32[(($2 + 432 | 0) + 60 | 0) >> 2] = $4;
  HEAP32[(($2 + 432 | 0) + 56 | 0) >> 2] = $5;
  HEAP32[(($2 + 432 | 0) + 52 | 0) >> 2] = $6;
  HEAP32[(($2 + 432 | 0) + 44 | 0) >> 2] = $56;
  HEAP32[(($2 + 432 | 0) + 40 | 0) >> 2] = $57;
  HEAP32[(($2 + 432 | 0) + 36 | 0) >> 2] = $58;
  HEAP32[(($2 + 432 | 0) + 28 | 0) >> 2] = $60;
  HEAP32[(($2 + 432 | 0) + 24 | 0) >> 2] = $61;
  HEAP32[(($2 + 432 | 0) + 20 | 0) >> 2] = $62;
  HEAP32[($2 + 480 | 0) >> 2] = $7;
  HEAP32[($2 + 464 | 0) >> 2] = $59;
  HEAP32[($2 + 448 | 0) >> 2] = $63;
  HEAP32[($2 + 444 | 0) >> 2] = $64;
  HEAP32[($2 + 440 | 0) >> 2] = $65;
  HEAP32[($2 + 436 | 0) >> 2] = $66;
  HEAP32[($2 + 432 | 0) >> 2] = $67;
  memcpy($2 + 784 | 0 | 0, $2 + 48 | 0 | 0, 64 | 0) | 0;
  HEAP32[(($2 + 848 | 0) + 60 | 0) >> 2] = $20;
  HEAP32[(($2 + 848 | 0) + 56 | 0) >> 2] = $43;
  HEAP32[(($2 + 848 | 0) + 52 | 0) >> 2] = $19;
  HEAP32[(($2 + 848 | 0) + 44 | 0) >> 2] = $18;
  HEAP32[(($2 + 848 | 0) + 40 | 0) >> 2] = $45;
  HEAP32[(($2 + 848 | 0) + 36 | 0) >> 2] = $17;
  HEAP32[(($2 + 848 | 0) + 28 | 0) >> 2] = $16;
  HEAP32[(($2 + 848 | 0) + 24 | 0) >> 2] = $47;
  HEAP32[(($2 + 848 | 0) + 20 | 0) >> 2] = $15;
  HEAP32[($2 + 896 | 0) >> 2] = $44;
  HEAP32[($2 + 880 | 0) >> 2] = $46;
  HEAP32[($2 + 864 | 0) >> 2] = $48;
  HEAP32[($2 + 860 | 0) >> 2] = $22;
  HEAP32[($2 + 856 | 0) >> 2] = $49;
  HEAP32[($2 + 852 | 0) >> 2] = $21;
  HEAP32[($2 + 848 | 0) >> 2] = $50;
  $33 = ($2 + 496 | 0) + 8 | 0;
  i64toi32_i32$1 = i64toi32_i32$1 + 8 | 0;
  i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $2735 = i64toi32_i32$4;
  i64toi32_i32$4 = $33;
  HEAP32[i64toi32_i32$4 >> 2] = $2735;
  HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
  i64toi32_i32$1 = $0;
  i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $2738 = i64toi32_i32$5;
  i64toi32_i32$5 = $2;
  HEAP32[(i64toi32_i32$5 + 496 | 0) >> 2] = $2738;
  HEAP32[(i64toi32_i32$5 + 500 | 0) >> 2] = i64toi32_i32$4;
  $9 = (i64toi32_i32$5 + 512 | 0) + 8 | 0;
  i64toi32_i32$1 = $13 + 8 | 0;
  i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $2745 = i64toi32_i32$4;
  i64toi32_i32$4 = $9;
  HEAP32[i64toi32_i32$4 >> 2] = $2745;
  HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
  i64toi32_i32$1 = $13;
  i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $2748 = i64toi32_i32$5;
  i64toi32_i32$5 = $2;
  HEAP32[(i64toi32_i32$5 + 512 | 0) >> 2] = $2748;
  HEAP32[(i64toi32_i32$5 + 516 | 0) >> 2] = i64toi32_i32$4;
  i64toi32_i32$4 = $109$hi;
  i64toi32_i32$5 = (i64toi32_i32$5 + 912 | 0) + 56 | 0;
  HEAP32[i64toi32_i32$5 >> 2] = $109;
  HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$4;
  i64toi32_i32$5 = ($2 + 912 | 0) + 40 | 0;
  HEAP32[i64toi32_i32$5 >> 2] = $109;
  HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$4;
  i64toi32_i32$5 = ($2 + 912 | 0) + 24 | 0;
  HEAP32[i64toi32_i32$5 >> 2] = $109;
  HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$4;
  i64toi32_i32$1 = $14 + 8 | 0;
  i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $2766 = i64toi32_i32$4;
  i64toi32_i32$4 = ($2 + 912 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$4 >> 2] = $2766;
  HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
  $2767 = $2;
  i64toi32_i32$5 = $108$hi;
  i64toi32_i32$1 = $108;
  i64toi32_i32$4 = 0;
  i64toi32_i32$3 = 3;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $110 = i64toi32_i32$0;
  $110$hi = i64toi32_i32$2;
  HEAP32[($2767 + 960 | 0) >> 2] = i64toi32_i32$0;
  $2773 = ($2 + 912 | 0) + 52 | 0;
  i64toi32_i32$5 = i64toi32_i32$0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $544 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   $544 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP32[$2773 >> 2] = $544;
  $2776 = $2;
  i64toi32_i32$1 = $108$hi;
  i64toi32_i32$2 = $108;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 2;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $110 = i64toi32_i32$4;
  $110$hi = i64toi32_i32$0;
  HEAP32[($2776 + 944 | 0) >> 2] = i64toi32_i32$4;
  $2782 = ($2 + 912 | 0) + 36 | 0;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $545 = i64toi32_i32$0 >>> i64toi32_i32$5 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$5 | 0;
   $545 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$5 | 0) | 0;
  }
  HEAP32[$2782 >> 2] = $545;
  $2785 = $2;
  i64toi32_i32$2 = $108$hi;
  i64toi32_i32$0 = $108;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 1;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $110 = i64toi32_i32$5;
  $110$hi = i64toi32_i32$4;
  HEAP32[($2785 + 928 | 0) >> 2] = i64toi32_i32$5;
  $2791 = ($2 + 912 | 0) + 20 | 0;
  i64toi32_i32$2 = i64toi32_i32$5;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$1 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $546 = i64toi32_i32$4 >>> i64toi32_i32$1 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$4 >>> i64toi32_i32$1 | 0;
   $546 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$1 | 0) | 0;
  }
  HEAP32[$2791 >> 2] = $546;
  i64toi32_i32$4 = $14;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
  $2796 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 912 | 0) >> 2] = $2796;
  HEAP32[($2 + 916 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $109$hi;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 120 | 0) >> 2] = $109;
  HEAP32[($2 + 124 | 0) >> 2] = i64toi32_i32$2;
  $2799 = $2;
  i64toi32_i32$2 = $108$hi;
  i64toi32_i32$4 = $108;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 4;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $108 = i64toi32_i32$1;
  $108$hi = i64toi32_i32$5;
  HEAP32[($2799 + 112 | 0) >> 2] = i64toi32_i32$1;
  $2803 = $2;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$4 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$0 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$4 = 0;
   $547 = i64toi32_i32$5 >>> i64toi32_i32$0 | 0;
  } else {
   i64toi32_i32$4 = i64toi32_i32$5 >>> i64toi32_i32$0 | 0;
   $547 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$0 | 0) | 0;
  }
  HEAP32[($2803 + 116 | 0) >> 2] = $547;
  $T_20as_20core__convert__Into_U____into__h22fa69910ba5cfda($14 | 0, $2 + 112 | 0 | 0);
  core__array___impl_20core__iter__traits__collect__IntoIterator_20for_20__5bT_3b_20N_5d___into_iter__h9f5650cb2f49c0d3($2 + 40 | 0 | 0, $2 + 432 | 0 | 0);
  core__iter__adapters__zip__Zip_A_2cB___new__hb3da0149c0b41f07($2 + 616 | 0 | 0, $2 + 368 | 0 | 0, ($2 + 368 | 0) + 64 | 0 | 0, HEAP32[($2 + 40 | 0) >> 2] | 0 | 0, HEAP32[($2 + 44 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 112 | 0) + 24 | 0) >> 2] = HEAP32[(($2 + 616 | 0) + 24 | 0) >> 2] | 0;
  i64toi32_i32$5 = ($2 + 616 | 0) + 16 | 0;
  i64toi32_i32$4 = HEAP32[i64toi32_i32$5 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
  $2837 = i64toi32_i32$4;
  i64toi32_i32$4 = ($2 + 112 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$4 >> 2] = $2837;
  HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$2;
  $32 = ($2 + 112 | 0) + 8 | 0;
  $6 = ($2 + 616 | 0) + 8 | 0;
  i64toi32_i32$5 = $6;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
  $2846 = i64toi32_i32$2;
  i64toi32_i32$2 = $32;
  HEAP32[i64toi32_i32$2 >> 2] = $2846;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$4;
  i64toi32_i32$5 = $2;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 616 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 620 | 0) >> 2] | 0;
  $2849 = i64toi32_i32$4;
  i64toi32_i32$4 = i64toi32_i32$5;
  HEAP32[(i64toi32_i32$5 + 112 | 0) >> 2] = $2849;
  HEAP32[(i64toi32_i32$5 + 116 | 0) >> 2] = i64toi32_i32$2;
  core__array___impl_20core__iter__traits__collect__IntoIterator_20for_20__5bT_3b_20N_5d___into_iter__h9f5650cb2f49c0d3(i64toi32_i32$5 + 32 | 0 | 0, i64toi32_i32$5 + 784 | 0 | 0);
  core__iter__adapters__zip__Zip_A_2cB___new__h67510e7a2d59e29c(i64toi32_i32$5 + 528 | 0 | 0, i64toi32_i32$5 + 112 | 0 | 0, HEAP32[(i64toi32_i32$5 + 32 | 0) >> 2] | 0 | 0, HEAP32[(i64toi32_i32$5 + 36 | 0) >> 2] | 0 | 0);
  memcpy(i64toi32_i32$5 + 112 | 0 | 0, i64toi32_i32$5 + 528 | 0 | 0, 48 | 0) | 0;
  core__array___impl_20core__iter__traits__collect__IntoIterator_20for_20__5bT_3b_20N_5d___into_iter__h9f5650cb2f49c0d3(i64toi32_i32$5 + 24 | 0 | 0, i64toi32_i32$5 + 848 | 0 | 0);
  core__iter__adapters__zip__Zip_A_2cB___new__h6418d1c24875134d(i64toi32_i32$5 + 616 | 0 | 0, i64toi32_i32$5 + 112 | 0 | 0, HEAP32[(i64toi32_i32$5 + 24 | 0) >> 2] | 0 | 0, HEAP32[(i64toi32_i32$5 + 28 | 0) >> 2] | 0 | 0);
  memcpy(i64toi32_i32$5 + 112 | 0 | 0, i64toi32_i32$5 + 616 | 0 | 0, 68 | 0) | 0;
  core__array___impl_20core__iter__traits__collect__IntoIterator_20for_20__5bT_3b_20N_5d___into_iter__h9f5650cb2f49c0d3(i64toi32_i32$5 + 16 | 0 | 0, i64toi32_i32$5 + 912 | 0 | 0);
  core__iter__adapters__zip__Zip_A_2cB___new__h6d61c6f7913ef8e9(i64toi32_i32$5 + 528 | 0 | 0, i64toi32_i32$5 + 112 | 0 | 0, HEAP32[(i64toi32_i32$5 + 16 | 0) >> 2] | 0 | 0, HEAP32[(i64toi32_i32$5 + 20 | 0) >> 2] | 0 | 0);
  memcpy(i64toi32_i32$5 + 112 | 0 | 0, i64toi32_i32$5 + 528 | 0 | 0, 88 | 0) | 0;
  label$2 : {
   label$3 : {
    $4 = HEAP32[(i64toi32_i32$5 + 188 | 0) >> 2] | 0;
    if ($4 >>> 0 >= (HEAP32[(i64toi32_i32$5 + 192 | 0) >> 2] | 0) >>> 0) {
     break label$3
    }
    $15 = ($2 + 112 | 0) + 68 | 0;
    $16 = ($2 + 112 | 0) + 48 | 0;
    $17 = ($2 + 112 | 0) + 28 | 0;
    $7 = 0;
    label$4 : while (1) {
     HEAP32[($2 + 188 | 0) >> 2] = $4 + 1 | 0;
     $10 = (HEAP32[($2 + 168 | 0) >> 2] | 0) + $4 | 0;
     $8 = (HEAP32[($2 + 148 | 0) >> 2] | 0) + $10 | 0;
     $3 = (HEAP32[($2 + 128 | 0) >> 2] | 0) + $8 | 0;
     $5 = $core__slice__iter__Iter_T__20as_20core__iter__traits__iterator__Iterator_____iterator_get_unchecked__h62b174a6566db0dc($2 + 112 | 0 | 0, $3 | 0) | 0;
     $3 = $core__slice__iter__Iter_T__20as_20core__iter__traits__iterator__Iterator_____iterator_get_unchecked__h62b174a6566db0dc($32 | 0, $3 | 0) | 0;
     $8 = $core__slice__iter__Iter_T__20as_20core__iter__traits__iterator__Iterator_____iterator_get_unchecked__h62b174a6566db0dc($17 | 0, $8 | 0) | 0;
     $10 = $core__slice__iter__Iter_T__20as_20core__iter__traits__iterator__Iterator_____iterator_get_unchecked__h62b174a6566db0dc($16 | 0, $10 | 0) | 0;
     $4 = $core__slice__iter__Iter_T__20as_20core__iter__traits__iterator__Iterator_____iterator_get_unchecked__h62b174a6566db0dc($15 | 0, $4 | 0) | 0;
     $11 = ($2 + 688 | 0) + 8 | 0;
     i64toi32_i32$5 = $3 + 8 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
     i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
     $2953 = i64toi32_i32$2;
     i64toi32_i32$2 = $11;
     HEAP32[i64toi32_i32$2 >> 2] = $2953;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$4;
     i64toi32_i32$5 = $3;
     i64toi32_i32$4 = HEAP32[i64toi32_i32$5 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
     $2956 = i64toi32_i32$4;
     i64toi32_i32$4 = $2;
     HEAP32[(i64toi32_i32$4 + 688 | 0) >> 2] = $2956;
     HEAP32[(i64toi32_i32$4 + 692 | 0) >> 2] = i64toi32_i32$2;
     $12 = (i64toi32_i32$4 + 704 | 0) + 8 | 0;
     i64toi32_i32$5 = $8 + 8 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
     i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
     $2963 = i64toi32_i32$2;
     i64toi32_i32$2 = $12;
     HEAP32[i64toi32_i32$2 >> 2] = $2963;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$4;
     i64toi32_i32$5 = $8;
     i64toi32_i32$4 = HEAP32[i64toi32_i32$5 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
     $2966 = i64toi32_i32$4;
     i64toi32_i32$4 = $2;
     HEAP32[(i64toi32_i32$4 + 704 | 0) >> 2] = $2966;
     HEAP32[(i64toi32_i32$4 + 708 | 0) >> 2] = i64toi32_i32$2;
     $8 = (i64toi32_i32$4 + 720 | 0) + 8 | 0;
     i64toi32_i32$5 = $10 + 8 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
     i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
     $2973 = i64toi32_i32$2;
     i64toi32_i32$2 = $8;
     HEAP32[i64toi32_i32$2 >> 2] = $2973;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$4;
     i64toi32_i32$5 = $10;
     i64toi32_i32$4 = HEAP32[i64toi32_i32$5 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
     $2976 = i64toi32_i32$4;
     i64toi32_i32$4 = $2;
     HEAP32[(i64toi32_i32$4 + 720 | 0) >> 2] = $2976;
     HEAP32[(i64toi32_i32$4 + 724 | 0) >> 2] = i64toi32_i32$2;
     $10 = (i64toi32_i32$4 + 736 | 0) + 8 | 0;
     i64toi32_i32$5 = $4 + 8 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
     i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
     $2983 = i64toi32_i32$2;
     i64toi32_i32$2 = $10;
     HEAP32[i64toi32_i32$2 >> 2] = $2983;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$4;
     i64toi32_i32$5 = $4;
     i64toi32_i32$4 = HEAP32[i64toi32_i32$5 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
     $2986 = i64toi32_i32$4;
     i64toi32_i32$4 = $2;
     HEAP32[(i64toi32_i32$4 + 736 | 0) >> 2] = $2986;
     HEAP32[(i64toi32_i32$4 + 740 | 0) >> 2] = i64toi32_i32$2;
     $4 = (i64toi32_i32$4 + 768 | 0) + 8 | 0;
     i64toi32_i32$5 = $5 + 8 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
     i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
     $2993 = i64toi32_i32$2;
     i64toi32_i32$2 = $4;
     HEAP32[i64toi32_i32$2 >> 2] = $2993;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$4;
     i64toi32_i32$5 = $5;
     i64toi32_i32$4 = HEAP32[i64toi32_i32$5 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
     $2996 = i64toi32_i32$4;
     i64toi32_i32$4 = $2;
     HEAP32[(i64toi32_i32$4 + 768 | 0) >> 2] = $2996;
     HEAP32[(i64toi32_i32$4 + 772 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$2 = 1797285236;
     HEAP32[(i64toi32_i32$4 + 624 | 0) >> 2] = 2036477234;
     HEAP32[(i64toi32_i32$4 + 628 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$2 = 857760878;
     HEAP32[(i64toi32_i32$4 + 616 | 0) >> 2] = 1634760805;
     HEAP32[(i64toi32_i32$4 + 620 | 0) >> 2] = i64toi32_i32$2;
     ppv_lite86__generic__dmap2__h0af304cc753529fe(i64toi32_i32$4 + 752 | 0 | 0, i64toi32_i32$4 + 768 | 0 | 0, i64toi32_i32$4 + 616 | 0 | 0);
     if (($7 | 0) == (256 | 0)) {
      break label$2
     }
     $3 = ($2 + 752 | 0) + 8 | 0;
     i64toi32_i32$5 = $3;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
     i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
     $3012 = i64toi32_i32$2;
     i64toi32_i32$2 = $6;
     HEAP32[i64toi32_i32$2 >> 2] = $3012;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$4;
     i64toi32_i32$5 = $2;
     i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 752 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 756 | 0) >> 2] | 0;
     $3015 = i64toi32_i32$4;
     i64toi32_i32$4 = i64toi32_i32$5;
     HEAP32[(i64toi32_i32$5 + 616 | 0) >> 2] = $3015;
     HEAP32[(i64toi32_i32$5 + 620 | 0) >> 2] = i64toi32_i32$2;
     ppv_lite86__generic__dmap__h395c045a41d385d9(i64toi32_i32$5 + 768 | 0 | 0, i64toi32_i32$5 + 616 | 0 | 0);
     $5 = $1 + $7 | 0;
     i64toi32_i32$5 = $4;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
     i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
     $3026 = i64toi32_i32$2;
     i64toi32_i32$2 = $5 + 8 | 0;
     $529 = $3026;
     HEAP8[i64toi32_i32$2 >> 0] = $529;
     HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $529 >>> 8 | 0;
     HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $529 >>> 16 | 0;
     HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $529 >>> 24 | 0;
     HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$4;
     HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$4 >>> 8 | 0;
     HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$4 >>> 16 | 0;
     HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$4 >>> 24 | 0;
     i64toi32_i32$5 = $2;
     i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 768 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 772 | 0) >> 2] | 0;
     $3029 = i64toi32_i32$4;
     i64toi32_i32$4 = $5;
     $530 = $3029;
     HEAP8[i64toi32_i32$4 >> 0] = $530;
     HEAP8[(i64toi32_i32$4 + 1 | 0) >> 0] = $530 >>> 8 | 0;
     HEAP8[(i64toi32_i32$4 + 2 | 0) >> 0] = $530 >>> 16 | 0;
     HEAP8[(i64toi32_i32$4 + 3 | 0) >> 0] = $530 >>> 24 | 0;
     HEAP8[(i64toi32_i32$4 + 4 | 0) >> 0] = i64toi32_i32$2;
     HEAP8[(i64toi32_i32$4 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
     HEAP8[(i64toi32_i32$4 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
     HEAP8[(i64toi32_i32$4 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
     i64toi32_i32$5 = $11;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
     i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
     $3032 = i64toi32_i32$2;
     i64toi32_i32$2 = $4;
     HEAP32[i64toi32_i32$2 >> 2] = $3032;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$4;
     i64toi32_i32$5 = $2;
     i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 688 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 692 | 0) >> 2] | 0;
     $3035 = i64toi32_i32$4;
     i64toi32_i32$4 = i64toi32_i32$5;
     HEAP32[(i64toi32_i32$5 + 768 | 0) >> 2] = $3035;
     HEAP32[(i64toi32_i32$5 + 772 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$5 = $33;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
     i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
     $3038 = i64toi32_i32$2;
     i64toi32_i32$2 = $6;
     HEAP32[i64toi32_i32$2 >> 2] = $3038;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$4;
     i64toi32_i32$5 = $2;
     i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 496 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 500 | 0) >> 2] | 0;
     $3041 = i64toi32_i32$4;
     i64toi32_i32$4 = i64toi32_i32$5;
     HEAP32[(i64toi32_i32$5 + 616 | 0) >> 2] = $3041;
     HEAP32[(i64toi32_i32$5 + 620 | 0) >> 2] = i64toi32_i32$2;
     ppv_lite86__generic__dmap2__h0af304cc753529fe(i64toi32_i32$5 + 752 | 0 | 0, i64toi32_i32$5 + 768 | 0 | 0, i64toi32_i32$5 + 616 | 0 | 0);
     i64toi32_i32$5 = $3;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
     i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
     $3050 = i64toi32_i32$2;
     i64toi32_i32$2 = $6;
     HEAP32[i64toi32_i32$2 >> 2] = $3050;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$4;
     i64toi32_i32$5 = $2;
     i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 752 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 756 | 0) >> 2] | 0;
     $3053 = i64toi32_i32$4;
     i64toi32_i32$4 = i64toi32_i32$5;
     HEAP32[(i64toi32_i32$5 + 616 | 0) >> 2] = $3053;
     HEAP32[(i64toi32_i32$5 + 620 | 0) >> 2] = i64toi32_i32$2;
     ppv_lite86__generic__dmap__h395c045a41d385d9(i64toi32_i32$5 + 768 | 0 | 0, i64toi32_i32$5 + 616 | 0 | 0);
     i64toi32_i32$5 = $4;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
     i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
     $3061 = i64toi32_i32$2;
     i64toi32_i32$2 = $5 + 24 | 0;
     $532 = $3061;
     HEAP8[i64toi32_i32$2 >> 0] = $532;
     HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $532 >>> 8 | 0;
     HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $532 >>> 16 | 0;
     HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $532 >>> 24 | 0;
     HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$4;
     HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$4 >>> 8 | 0;
     HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$4 >>> 16 | 0;
     HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$4 >>> 24 | 0;
     i64toi32_i32$5 = $2;
     i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 768 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 772 | 0) >> 2] | 0;
     $3065 = i64toi32_i32$4;
     i64toi32_i32$4 = $5 + 16 | 0;
     $533 = $3065;
     HEAP8[i64toi32_i32$4 >> 0] = $533;
     HEAP8[(i64toi32_i32$4 + 1 | 0) >> 0] = $533 >>> 8 | 0;
     HEAP8[(i64toi32_i32$4 + 2 | 0) >> 0] = $533 >>> 16 | 0;
     HEAP8[(i64toi32_i32$4 + 3 | 0) >> 0] = $533 >>> 24 | 0;
     HEAP8[(i64toi32_i32$4 + 4 | 0) >> 0] = i64toi32_i32$2;
     HEAP8[(i64toi32_i32$4 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
     HEAP8[(i64toi32_i32$4 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
     HEAP8[(i64toi32_i32$4 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
     i64toi32_i32$5 = $12;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
     i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
     $3068 = i64toi32_i32$2;
     i64toi32_i32$2 = $4;
     HEAP32[i64toi32_i32$2 >> 2] = $3068;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$4;
     i64toi32_i32$5 = $2;
     i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 704 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 708 | 0) >> 2] | 0;
     $3071 = i64toi32_i32$4;
     i64toi32_i32$4 = i64toi32_i32$5;
     HEAP32[(i64toi32_i32$5 + 768 | 0) >> 2] = $3071;
     HEAP32[(i64toi32_i32$5 + 772 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$5 = $9;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
     i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
     $3074 = i64toi32_i32$2;
     i64toi32_i32$2 = $6;
     HEAP32[i64toi32_i32$2 >> 2] = $3074;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$4;
     i64toi32_i32$5 = $2;
     i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 512 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 516 | 0) >> 2] | 0;
     $3077 = i64toi32_i32$4;
     i64toi32_i32$4 = i64toi32_i32$5;
     HEAP32[(i64toi32_i32$5 + 616 | 0) >> 2] = $3077;
     HEAP32[(i64toi32_i32$5 + 620 | 0) >> 2] = i64toi32_i32$2;
     ppv_lite86__generic__dmap2__h0af304cc753529fe(i64toi32_i32$5 + 752 | 0 | 0, i64toi32_i32$5 + 768 | 0 | 0, i64toi32_i32$5 + 616 | 0 | 0);
     i64toi32_i32$5 = $3;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
     i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
     $3086 = i64toi32_i32$2;
     i64toi32_i32$2 = $6;
     HEAP32[i64toi32_i32$2 >> 2] = $3086;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$4;
     i64toi32_i32$5 = $2;
     i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 752 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 756 | 0) >> 2] | 0;
     $3089 = i64toi32_i32$4;
     i64toi32_i32$4 = i64toi32_i32$5;
     HEAP32[(i64toi32_i32$5 + 616 | 0) >> 2] = $3089;
     HEAP32[(i64toi32_i32$5 + 620 | 0) >> 2] = i64toi32_i32$2;
     ppv_lite86__generic__dmap__h395c045a41d385d9(i64toi32_i32$5 + 768 | 0 | 0, i64toi32_i32$5 + 616 | 0 | 0);
     i64toi32_i32$5 = $4;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
     i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
     $3097 = i64toi32_i32$2;
     i64toi32_i32$2 = $5 + 40 | 0;
     $534 = $3097;
     HEAP8[i64toi32_i32$2 >> 0] = $534;
     HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $534 >>> 8 | 0;
     HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $534 >>> 16 | 0;
     HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $534 >>> 24 | 0;
     HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$4;
     HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$4 >>> 8 | 0;
     HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$4 >>> 16 | 0;
     HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$4 >>> 24 | 0;
     i64toi32_i32$5 = $2;
     i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 768 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 772 | 0) >> 2] | 0;
     $3101 = i64toi32_i32$4;
     i64toi32_i32$4 = $5 + 32 | 0;
     $535 = $3101;
     HEAP8[i64toi32_i32$4 >> 0] = $535;
     HEAP8[(i64toi32_i32$4 + 1 | 0) >> 0] = $535 >>> 8 | 0;
     HEAP8[(i64toi32_i32$4 + 2 | 0) >> 0] = $535 >>> 16 | 0;
     HEAP8[(i64toi32_i32$4 + 3 | 0) >> 0] = $535 >>> 24 | 0;
     HEAP8[(i64toi32_i32$4 + 4 | 0) >> 0] = i64toi32_i32$2;
     HEAP8[(i64toi32_i32$4 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
     HEAP8[(i64toi32_i32$4 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
     HEAP8[(i64toi32_i32$4 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
     i64toi32_i32$5 = $8;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
     i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
     $3104 = i64toi32_i32$2;
     i64toi32_i32$2 = $4;
     HEAP32[i64toi32_i32$2 >> 2] = $3104;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$4;
     i64toi32_i32$5 = $2;
     i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 720 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 724 | 0) >> 2] | 0;
     $3107 = i64toi32_i32$4;
     i64toi32_i32$4 = i64toi32_i32$5;
     HEAP32[(i64toi32_i32$5 + 768 | 0) >> 2] = $3107;
     HEAP32[(i64toi32_i32$5 + 772 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$5 = $10;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
     i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
     $3110 = i64toi32_i32$2;
     i64toi32_i32$2 = $6;
     HEAP32[i64toi32_i32$2 >> 2] = $3110;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$4;
     i64toi32_i32$5 = $2;
     i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 736 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 740 | 0) >> 2] | 0;
     $3113 = i64toi32_i32$4;
     i64toi32_i32$4 = i64toi32_i32$5;
     HEAP32[(i64toi32_i32$5 + 616 | 0) >> 2] = $3113;
     HEAP32[(i64toi32_i32$5 + 620 | 0) >> 2] = i64toi32_i32$2;
     ppv_lite86__generic__dmap2__h0af304cc753529fe(i64toi32_i32$5 + 752 | 0 | 0, i64toi32_i32$5 + 768 | 0 | 0, i64toi32_i32$5 + 616 | 0 | 0);
     i64toi32_i32$5 = $3;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
     i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
     $3122 = i64toi32_i32$2;
     i64toi32_i32$2 = $6;
     HEAP32[i64toi32_i32$2 >> 2] = $3122;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$4;
     i64toi32_i32$5 = $2;
     i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 752 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 756 | 0) >> 2] | 0;
     $3125 = i64toi32_i32$4;
     i64toi32_i32$4 = i64toi32_i32$5;
     HEAP32[(i64toi32_i32$5 + 616 | 0) >> 2] = $3125;
     HEAP32[(i64toi32_i32$5 + 620 | 0) >> 2] = i64toi32_i32$2;
     ppv_lite86__generic__dmap__h395c045a41d385d9(i64toi32_i32$5 + 768 | 0 | 0, i64toi32_i32$5 + 616 | 0 | 0);
     i64toi32_i32$5 = $4;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
     i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
     $3133 = i64toi32_i32$2;
     i64toi32_i32$2 = $5 + 56 | 0;
     $537 = $3133;
     HEAP8[i64toi32_i32$2 >> 0] = $537;
     HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $537 >>> 8 | 0;
     HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $537 >>> 16 | 0;
     HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $537 >>> 24 | 0;
     HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$4;
     HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$4 >>> 8 | 0;
     HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$4 >>> 16 | 0;
     HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$4 >>> 24 | 0;
     i64toi32_i32$5 = $2;
     i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 768 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 772 | 0) >> 2] | 0;
     $3137 = i64toi32_i32$4;
     i64toi32_i32$4 = $5 + 48 | 0;
     $538 = $3137;
     HEAP8[i64toi32_i32$4 >> 0] = $538;
     HEAP8[(i64toi32_i32$4 + 1 | 0) >> 0] = $538 >>> 8 | 0;
     HEAP8[(i64toi32_i32$4 + 2 | 0) >> 0] = $538 >>> 16 | 0;
     HEAP8[(i64toi32_i32$4 + 3 | 0) >> 0] = $538 >>> 24 | 0;
     HEAP8[(i64toi32_i32$4 + 4 | 0) >> 0] = i64toi32_i32$2;
     HEAP8[(i64toi32_i32$4 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
     HEAP8[(i64toi32_i32$4 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
     HEAP8[(i64toi32_i32$4 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
     $7 = $7 + 64 | 0;
     $4 = HEAP32[(i64toi32_i32$5 + 188 | 0) >> 2] | 0;
     if ($4 >>> 0 < (HEAP32[(i64toi32_i32$5 + 192 | 0) >> 2] | 0) >>> 0) {
      continue label$4
     }
     break label$4;
    };
   }
   $rand_chacha__chacha__Array64_T__20as_20core__convert__AsMut__5bT_5d____as_mut__h28c15f7aad85224d($2 + 8 | 0 | 0, $1 | 0);
   core__slice__iter___impl_20core__iter__traits__collect__IntoIterator_20for_20_mut_20_5bT_5d___into_iter__haf0161a4721f1f1a($2 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
   global$0 = $2 + 976 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1074728 | 0, 43 | 0, 1074712 | 0);
  abort();
 }
 
 function num_bigint__biguint__multiplication__mac3__hfe2ae9a5dc461c1a($0, $1, $2, $3, $4, $5) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  $5 = $5 | 0;
  var $6 = 0, i64toi32_i32$5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, $9 = 0, i64toi32_i32$2 = 0, $11 = 0, i64toi32_i32$4 = 0, i64toi32_i32$1 = 0, $10 = 0, $18$hi = 0, $15 = 0, $18 = 0, $8 = 0, $12 = 0, $7 = 0, $13 = 0, $14 = 0, $19 = 0, $19$hi = 0, $16 = 0, $98 = 0, $99 = 0, $100 = 0, $101 = 0, $102 = 0, $103 = 0, $104 = 0, $105 = 0, $106 = 0, $107 = 0, $181 = 0, $184 = 0, $184$hi = 0, $185$hi = 0, $187$hi = 0, $108 = 0, $189 = 0, $189$hi = 0, $212 = 0, $215 = 0, $215$hi = 0, $228 = 0, $631 = 0, $703 = 0, $711 = 0, $714 = 0, $719 = 0, $722 = 0, $733 = 0, $736 = 0, $741 = 0, $744 = 0, $826 = 0, $916 = 0, $923 = 0, $926 = 0, $931 = 0, $934 = 0, $960 = 0, $963$hi = 0, $1004 = 0, $1060 = 0, $1068 = 0, $1071 = 0, $1082 = 0, $1085 = 0, $1090 = 0, $1093 = 0, $1119 = 0, $1122$hi = 0, $1163 = 0, $1218 = 0, $1225 = 0, $1228 = 0, $1308 = 0, $1337 = 0, $1354 = 0, $1357 = 0, $1372 = 0, $1375 = 0, $1438 = 0, $1517 = 0, $1624 = 0, $1648 = 0, $1658 = 0, $1718 = 0, $1750 = 0, $1753$hi = 0, $1801 = 0, $1856 = 0, $17 = 0, $2022 = 0, $2172 = 0, $2175 = 0, $2180 = 0, $2183 = 0, $2262 = 0, $2346 = 0, $2373 = 0, $2375 = 0, $2437 = 0, $2524 = 0;
  $6 = global$0 - 384 | 0;
  global$0 = $6;
  label$1 : {
   label$2 : {
    if ($3 >>> 0 < $5 >>> 0) {
     break label$2
    }
    $7 = $3;
    $8 = $2;
    $3 = $5;
    $2 = $4;
    break label$1;
   }
   $7 = $5;
   $8 = $4;
  }
  label$3 : {
   label$4 : {
    label$5 : {
     label$6 : {
      label$7 : {
       label$8 : {
        label$9 : {
         label$10 : {
          label$11 : {
           label$12 : {
            label$13 : {
             if ($3 >>> 0 < 33 >>> 0) {
              break label$13
             }
             if ($3 >>> 0 < 257 >>> 0) {
              break label$9
             }
             $9 = ($7 >>> 0) / (3 >>> 0) | 0;
             $10 = $9 + 1 | 0;
             $5 = $3 >>> 0 > $10 >>> 0 ? $10 : $3;
             num_bigint__biguint__multiplication__bigint_from_slice__h8cdeba7959ca8cf0($6 + 40 | 0 | 0, $2 | 0, $5 | 0);
             $4 = $3 - $5 | 0;
             $11 = $4 >>> 0 > $10 >>> 0 ? $10 : $4;
             $4 = $11 + $5 | 0;
             if ($3 >>> 0 < $4 >>> 0) {
              break label$10
             }
             num_bigint__biguint__multiplication__bigint_from_slice__h8cdeba7959ca8cf0($6 + 56 | 0 | 0, $2 + ($5 << 2 | 0) | 0 | 0, $11 | 0);
             num_bigint__biguint__multiplication__bigint_from_slice__h8cdeba7959ca8cf0($6 + 72 | 0 | 0, $2 + ($4 << 2 | 0) | 0 | 0, $3 - $4 | 0 | 0);
             if ($7 >>> 0 <= $9 >>> 0) {
              break label$11
             }
             num_bigint__biguint__multiplication__bigint_from_slice__h8cdeba7959ca8cf0($6 + 88 | 0 | 0, $8 | 0, $10 | 0);
             $5 = $7 - $10 | 0;
             $4 = $5 >>> 0 > $10 >>> 0 ? $10 : $5;
             $5 = $4 + $10 | 0;
             if ($7 >>> 0 < $5 >>> 0) {
              break label$12
             }
             num_bigint__biguint__multiplication__bigint_from_slice__h8cdeba7959ca8cf0($6 + 104 | 0 | 0, $8 + ($10 << 2 | 0) | 0 | 0, $4 | 0);
             num_bigint__biguint__multiplication__bigint_from_slice__h8cdeba7959ca8cf0($6 + 120 | 0 | 0, $8 + ($5 << 2 | 0) | 0 | 0, $7 - $5 | 0 | 0);
             num_bigint__bigint__addition___impl_20core__ops__arith__Add__num_bigint__bigint__BigInt__20for_20_num_bigint__bigint__BigInt___add__h354544d3f4ae9625($6 + 136 | 0 | 0, $6 + 40 | 0 | 0, $6 + 72 | 0 | 0);
             num_bigint__bigint__addition___impl_20core__ops__arith__Add__num_bigint__bigint__BigInt__20for_20_num_bigint__bigint__BigInt___add__h354544d3f4ae9625($6 + 152 | 0 | 0, $6 + 88 | 0 | 0, $6 + 120 | 0 | 0);
             num_bigint__bigint__subtraction___impl_20core__ops__arith__Sub__num_bigint__bigint__BigInt__20for_20_num_bigint__bigint__BigInt___sub__h41405c4b9a5a6fac($6 + 168 | 0 | 0, $6 + 136 | 0 | 0, $6 + 56 | 0 | 0);
             num_bigint__bigint__subtraction___impl_20core__ops__arith__Sub__num_bigint__bigint__BigInt__20for_20_num_bigint__bigint__BigInt___sub__h41405c4b9a5a6fac($6 + 184 | 0 | 0, $6 + 152 | 0 | 0, $6 + 104 | 0 | 0);
             $5 = 1;
             $4 = 1;
             $3 = HEAPU8[($6 + 52 | 0) >> 0] | 0;
             if (($3 | 0) == (1 | 0)) {
              break label$5
             }
             $5 = 1;
             $4 = 1;
             switch (HEAPU8[($6 + 100 | 0) >> 0] | 0 | 0) {
             case 1:
              break label$5;
             case 2:
              break label$7;
             default:
              break label$8;
             };
            }
            if (!$3) {
             break label$4
            }
            $12 = $2 + ($3 << 2 | 0) | 0;
            $9 = $1 << 2 | 0;
            $13 = $7 << 2 | 0;
            $14 = $13 + 4 | 0;
            $11 = 0;
            $10 = $0;
            label$14 : {
             label$15 : {
              label$16 : while (1) {
               label$17 : {
                label$18 : {
                 label$19 : {
                  label$20 : {
                   if ($11 >>> 0 > $1 >>> 0) {
                    break label$20
                   }
                   $5 = HEAP32[$2 >> 2] | 0;
                   if (!$5) {
                    break label$17
                   }
                   $15 = $1 - $11 | 0;
                   if ($15 >>> 0 < $7 >>> 0) {
                    break label$19
                   }
                   label$21 : {
                    if ($7) {
                     break label$21
                    }
                    i64toi32_i32$0 = 0;
                    $18 = 0;
                    $18$hi = i64toi32_i32$0;
                    break label$18;
                   }
                   i64toi32_i32$0 = 0;
                   $19 = $5;
                   $19$hi = i64toi32_i32$0;
                   i64toi32_i32$0 = 0;
                   $18 = 0;
                   $18$hi = i64toi32_i32$0;
                   $3 = $7;
                   $5 = $10;
                   $4 = $8;
                   label$22 : while (1) {
                    $181 = $5;
                    i64toi32_i32$0 = $18$hi;
                    i64toi32_i32$2 = $5;
                    i64toi32_i32$0 = HEAP32[$5 >> 2] | 0;
                    i64toi32_i32$1 = 0;
                    $184 = i64toi32_i32$0;
                    $184$hi = i64toi32_i32$1;
                    i64toi32_i32$1 = $18$hi;
                    i64toi32_i32$2 = $18;
                    i64toi32_i32$0 = $184$hi;
                    i64toi32_i32$3 = $184;
                    i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
                    i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
                    if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
                     i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
                    }
                    $185$hi = i64toi32_i32$5;
                    i64toi32_i32$1 = $4;
                    i64toi32_i32$5 = HEAP32[$4 >> 2] | 0;
                    i64toi32_i32$2 = 0;
                    $187$hi = i64toi32_i32$2;
                    i64toi32_i32$2 = $19$hi;
                    i64toi32_i32$2 = $187$hi;
                    $108 = i64toi32_i32$5;
                    i64toi32_i32$5 = $19$hi;
                    i64toi32_i32$5 = __wasm_i64_mul($108 | 0, i64toi32_i32$2 | 0, $19 | 0, i64toi32_i32$5 | 0) | 0;
                    i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
                    $189 = i64toi32_i32$5;
                    $189$hi = i64toi32_i32$2;
                    i64toi32_i32$2 = $185$hi;
                    i64toi32_i32$1 = i64toi32_i32$4;
                    i64toi32_i32$5 = $189$hi;
                    i64toi32_i32$3 = $189;
                    i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
                    i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
                    if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
                     i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
                    }
                    $18 = i64toi32_i32$0;
                    $18$hi = i64toi32_i32$4;
                    HEAP32[$181 >> 2] = i64toi32_i32$0;
                    i64toi32_i32$2 = i64toi32_i32$0;
                    i64toi32_i32$1 = 0;
                    i64toi32_i32$3 = 32;
                    i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
                    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                     i64toi32_i32$1 = 0;
                     $98 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
                    } else {
                     i64toi32_i32$1 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
                     $98 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$5 | 0) | 0;
                    }
                    $18 = $98;
                    $18$hi = i64toi32_i32$1;
                    $5 = $5 + 4 | 0;
                    $4 = $4 + 4 | 0;
                    $3 = $3 + -1 | 0;
                    if ($3) {
                     continue label$22
                    }
                    break label$18;
                   };
                  }
                  core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($11 | 0, $1 | 0, 1082996 | 0);
                  abort();
                 }
                 core__panicking__panic__h2fd385a887c8bf13(1082620 | 0, 35 | 0, 1082732 | 0);
                 abort();
                }
                if (($15 | 0) == ($7 | 0)) {
                 break label$14
                }
                $5 = ($0 + ($11 << 2 | 0) | 0) + $13 | 0;
                $212 = $5;
                i64toi32_i32$1 = $18$hi;
                i64toi32_i32$4 = $5;
                i64toi32_i32$1 = HEAP32[$5 >> 2] | 0;
                i64toi32_i32$2 = 0;
                $215 = i64toi32_i32$1;
                $215$hi = i64toi32_i32$2;
                i64toi32_i32$2 = $18$hi;
                i64toi32_i32$4 = $18;
                i64toi32_i32$1 = $215$hi;
                i64toi32_i32$3 = $215;
                i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
                i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
                if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
                 i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
                }
                $18 = i64toi32_i32$5;
                $18$hi = i64toi32_i32$0;
                HEAP32[$212 >> 2] = i64toi32_i32$5;
                i64toi32_i32$2 = i64toi32_i32$5;
                i64toi32_i32$4 = 1;
                i64toi32_i32$3 = 0;
                i64toi32_i32$4 = i64toi32_i32$0 & i64toi32_i32$4 | 0;
                if (!(i64toi32_i32$5 & i64toi32_i32$3 | 0 | i64toi32_i32$4 | 0)) {
                 break label$17
                }
                $5 = $14;
                label$23 : while (1) {
                 if (($9 | 0) == ($5 | 0)) {
                  break label$15
                 }
                 $4 = $10 + $5 | 0;
                 $228 = $4;
                 i64toi32_i32$0 = $4;
                 i64toi32_i32$4 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                 i64toi32_i32$2 = 0;
                 i64toi32_i32$0 = i64toi32_i32$4;
                 i64toi32_i32$4 = 0;
                 i64toi32_i32$3 = 1;
                 i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
                 i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
                 if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
                  i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
                 }
                 $18 = i64toi32_i32$1;
                 $18$hi = i64toi32_i32$5;
                 HEAP32[$228 >> 2] = i64toi32_i32$1;
                 $5 = $5 + 4 | 0;
                 i64toi32_i32$2 = i64toi32_i32$1;
                 i64toi32_i32$0 = 1;
                 i64toi32_i32$3 = 0;
                 i64toi32_i32$0 = i64toi32_i32$5 & i64toi32_i32$0 | 0;
                 i64toi32_i32$5 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
                 i64toi32_i32$2 = 0;
                 i64toi32_i32$3 = 0;
                 if ((i64toi32_i32$5 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$2 | 0) | 0) {
                  continue label$23
                 }
                 break label$23;
                };
               }
               $11 = $11 + 1 | 0;
               $9 = $9 + -4 | 0;
               $10 = $10 + 4 | 0;
               $2 = $2 + 4 | 0;
               if (($2 | 0) != ($12 | 0)) {
                continue label$16
               }
               break label$4;
              };
             }
             HEAP32[($6 + 368 | 0) >> 2] = 1;
             HEAP32[($6 + 348 | 0) >> 2] = 0;
             HEAP32[($6 + 344 | 0) >> 2] = 1082816;
             i64toi32_i32$0 = $6;
             i64toi32_i32$5 = 0;
             HEAP32[($6 + 332 | 0) >> 2] = 1;
             HEAP32[($6 + 336 | 0) >> 2] = i64toi32_i32$5;
             HEAP32[($6 + 328 | 0) >> 2] = 1082860;
             core__panicking__assert_failed__hfac4c8f4dca80274(0 | 0, $6 + 368 | 0 | 0, 1082816 | 0, $6 + 328 | 0 | 0, 1082980 | 0);
             abort();
            }
            core__panicking__panic__h2fd385a887c8bf13(1082620 | 0, 35 | 0, 1082732 | 0);
            abort();
           }
           core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($5 | 0, $7 | 0, 1083076 | 0);
           abort();
          }
          core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($10 | 0, $7 | 0, 1083060 | 0);
          abort();
         }
         core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($4 | 0, $3 | 0, 1083044 | 0);
         abort();
        }
        label$24 : {
         label$25 : {
          $10 = $3 >>> 1 | 0;
          if ($7 >>> 0 < $10 >>> 0) {
           break label$25
          }
          $15 = $7 - $10 | 0;
          $12 = $3 - $10 | 0;
          $9 = ($15 + $12 | 0) + 1 | 0;
          alloc__raw_vec__RawVec_T_2cA___allocate_in__hb0817f92bbb8999a($6 | 0, $9 | 0, 1 | 0);
          HEAP32[($6 + 376 | 0) >> 2] = $9;
          $13 = HEAP32[($6 + 4 | 0) >> 2] | 0;
          HEAP32[($6 + 372 | 0) >> 2] = $13;
          $5 = HEAP32[$6 >> 2] | 0;
          HEAP32[($6 + 368 | 0) >> 2] = $5;
          $4 = $10 << 2 | 0;
          $14 = $2 + $4 | 0;
          $16 = $8 + $4 | 0;
          num_bigint__biguint__multiplication__mac3__hfe2ae9a5dc461c1a($5 | 0, $9 | 0, $14 | 0, $12 | 0, $16 | 0, $15 | 0);
          $11 = 0;
          if (!$9) {
           break label$24
          }
          $5 = $5 + ((($3 + $7 | 0) - ($10 << 1 | 0) | 0) << 2 | 0) | 0;
          $4 = $9;
          label$26 : while (1) {
           label$27 : {
            if (!(HEAP32[$5 >> 2] | 0)) {
             break label$27
            }
            $11 = $4;
            break label$24;
           }
           $4 = $4 + -1 | 0;
           HEAP32[($6 + 376 | 0) >> 2] = $4;
           $5 = $5 + -4 | 0;
           if ($4) {
            continue label$26
           }
           break label$24;
          };
         }
         core__panicking__panic__h2fd385a887c8bf13(1082620 | 0, 35 | 0, 1082748 | 0);
         abort();
        }
        label$28 : {
         if ($11 >>> 0 >= ($13 >>> 2 | 0) >>> 0) {
          break label$28
         }
         if ($13 >>> 0 <= $11 >>> 0) {
          break label$28
         }
         alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($6 + 368 | 0 | 0, $11 | 0);
        }
        label$29 : {
         label$30 : {
          label$31 : {
           if ($10 >>> 0 > $1 >>> 0) {
            break label$31
           }
           $7 = $0 + ($10 << 2 | 0) | 0;
           $13 = $1 - $10 | 0;
           $5 = HEAP32[($6 + 368 | 0) >> 2] | 0;
           $11 = HEAP32[($6 + 376 | 0) >> 2] | 0;
           num_bigint__biguint__addition__add2__h85496cf5b0a143eb($7 | 0, $13 | 0, $5 | 0, $11 | 0);
           $4 = $3 & -2 | 0;
           if ($4 >>> 0 > $1 >>> 0) {
            break label$30
           }
           num_bigint__biguint__addition__add2__h85496cf5b0a143eb($0 + ($4 << 2 | 0) | 0 | 0, $1 - $4 | 0 | 0, $5 | 0, $11 | 0);
           $4 = 0;
           HEAP32[($6 + 376 | 0) >> 2] = 0;
           label$32 : {
            label$33 : {
             if ($9) {
              break label$33
             }
             HEAP32[($6 + 376 | 0) >> 2] = 0;
             break label$32;
            }
            alloc__vec__Vec_T_2cA___extend_with__hc50aa39afa7f1d36($6 + 368 | 0 | 0, $9 | 0, 0 | 0);
            $4 = HEAP32[($6 + 376 | 0) >> 2] | 0;
            $5 = HEAP32[($6 + 368 | 0) >> 2] | 0;
           }
           num_bigint__biguint__multiplication__mac3__hfe2ae9a5dc461c1a($5 | 0, $4 | 0, $2 | 0, $10 | 0, $8 | 0, $10 | 0);
           $3 = 0;
           $11 = HEAP32[($6 + 368 | 0) >> 2] | 0;
           $5 = HEAP32[($6 + 376 | 0) >> 2] | 0;
           if (!$5) {
            break label$29
           }
           $4 = (($5 << 2 | 0) + $11 | 0) + -4 | 0;
           label$34 : while (1) {
            label$35 : {
             if (!(HEAP32[$4 >> 2] | 0)) {
              break label$35
             }
             $3 = $5;
             break label$29;
            }
            $5 = $5 + -1 | 0;
            HEAP32[($6 + 376 | 0) >> 2] = $5;
            $4 = $4 + -4 | 0;
            if ($5) {
             continue label$34
            }
            break label$29;
           };
          }
          core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($10 | 0, $1 | 0, 1083012 | 0);
          abort();
         }
         core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($4 | 0, $1 | 0, 1083028 | 0);
         abort();
        }
        label$36 : {
         $5 = HEAP32[($6 + 372 | 0) >> 2] | 0;
         if ($3 >>> 0 >= ($5 >>> 2 | 0) >>> 0) {
          break label$36
         }
         if ($5 >>> 0 <= $3 >>> 0) {
          break label$36
         }
         alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($6 + 368 | 0 | 0, $3 | 0);
         $3 = HEAP32[($6 + 376 | 0) >> 2] | 0;
         $11 = HEAP32[($6 + 368 | 0) >> 2] | 0;
        }
        num_bigint__biguint__addition__add2__h85496cf5b0a143eb($0 | 0, $1 | 0, $11 | 0, $3 | 0);
        num_bigint__biguint__addition__add2__h85496cf5b0a143eb($7 | 0, $13 | 0, HEAP32[($6 + 368 | 0) >> 2] | 0 | 0, HEAP32[($6 + 376 | 0) >> 2] | 0 | 0);
        num_bigint__biguint__multiplication__sub_sign__h115f34decb175430($6 + 328 | 0 | 0, $14 | 0, $12 | 0, $2 | 0, $10 | 0);
        $1 = $6 + 340 | 0;
        $12 = HEAP32[$1 >> 2] | 0;
        $4 = $6 + 336 | 0;
        $3 = HEAP32[$4 >> 2] | 0;
        $11 = HEAP32[($6 + 332 | 0) >> 2] | 0;
        $5 = HEAPU8[($6 + 328 | 0) >> 0] | 0;
        num_bigint__biguint__multiplication__sub_sign__h115f34decb175430($6 + 328 | 0 | 0, $16 | 0, $15 | 0, $8 | 0, $10 | 0);
        $10 = HEAP32[$4 >> 2] | 0;
        $2 = HEAP32[($6 + 332 | 0) >> 2] | 0;
        label$37 : {
         if (($5 | 0) == (1 | 0)) {
          break label$37
         }
         $4 = HEAP32[$1 >> 2] | 0;
         label$38 : {
          label$39 : {
           label$40 : {
            switch ((HEAPU8[($6 + 328 | 0) >> 0] | 0) & 3 | 0 | 0) {
            case 2:
             if ($5) {
              break label$39
             }
             break label$38;
            case 1:
             break label$37;
            default:
             break label$40;
            };
           }
           if ($5) {
            break label$38
           }
          }
          $5 = 0;
          HEAP32[($6 + 376 | 0) >> 2] = 0;
          label$42 : {
           label$43 : {
            if ($9) {
             break label$43
            }
            HEAP32[($6 + 376 | 0) >> 2] = 0;
            break label$42;
           }
           alloc__vec__Vec_T_2cA___extend_with__hc50aa39afa7f1d36($6 + 368 | 0 | 0, $9 | 0, 0 | 0);
           $5 = HEAP32[($6 + 376 | 0) >> 2] | 0;
          }
          num_bigint__biguint__multiplication__mac3__hfe2ae9a5dc461c1a(HEAP32[($6 + 368 | 0) >> 2] | 0 | 0, $5 | 0, $11 | 0, $12 | 0, $2 | 0, $4 | 0);
          $9 = 0;
          $1 = HEAP32[($6 + 368 | 0) >> 2] | 0;
          label$44 : {
           $5 = HEAP32[($6 + 376 | 0) >> 2] | 0;
           if (!$5) {
            break label$44
           }
           $4 = (($5 << 2 | 0) + $1 | 0) + -4 | 0;
           label$45 : while (1) {
            label$46 : {
             if (!(HEAP32[$4 >> 2] | 0)) {
              break label$46
             }
             $9 = $5;
             break label$44;
            }
            $5 = $5 + -1 | 0;
            HEAP32[($6 + 376 | 0) >> 2] = $5;
            $4 = $4 + -4 | 0;
            if ($5) {
             continue label$45
            }
            break label$45;
           };
          }
          label$47 : {
           $5 = HEAP32[($6 + 372 | 0) >> 2] | 0;
           if ($9 >>> 0 >= ($5 >>> 2 | 0) >>> 0) {
            break label$47
           }
           if ($5 >>> 0 <= $9 >>> 0) {
            break label$47
           }
           alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($6 + 368 | 0 | 0, $9 | 0);
           $9 = HEAP32[($6 + 376 | 0) >> 2] | 0;
           $1 = HEAP32[($6 + 368 | 0) >> 2] | 0;
          }
          num_bigint__biguint__subtraction__sub2__h0b2286b660c85b0d($7 | 0, $13 | 0, $1 | 0, $9 | 0);
          break label$37;
         }
         num_bigint__biguint__multiplication__mac3__hfe2ae9a5dc461c1a($7 | 0, $13 | 0, $11 | 0, $12 | 0, $2 | 0, $4 | 0);
        }
        label$48 : {
         if (!$10) {
          break label$48
         }
         $5 = $10 << 2 | 0;
         if (!$5) {
          break label$48
         }
         __rust_dealloc($2 | 0, $5 | 0, 4 | 0);
        }
        label$49 : {
         if (!$3) {
          break label$49
         }
         $5 = $3 << 2 | 0;
         if (!$5) {
          break label$49
         }
         __rust_dealloc($11 | 0, $5 | 0, 4 | 0);
        }
        $5 = HEAP32[($6 + 372 | 0) >> 2] | 0;
        if (!$5) {
         break label$4
        }
        $5 = $5 << 2 | 0;
        if (!$5) {
         break label$4
        }
        __rust_dealloc(HEAP32[($6 + 368 | 0) >> 2] | 0 | 0, $5 | 0, 4 | 0);
        break label$4;
       }
       $5 = 0;
       $4 = 0;
       if ($3) {
        break label$5
       }
       break label$6;
      }
      if ($3) {
       break label$6
      }
      $5 = 0;
      $4 = 0;
      break label$5;
     }
     $4 = 2;
     $5 = 0;
    }
    num_bigint__biguint__multiplication__mul3__h007c2e75506c6ce0($6 + 328 | 0 | 0, HEAP32[($6 + 40 | 0) >> 2] | 0 | 0, HEAP32[($6 + 48 | 0) >> 2] | 0 | 0, HEAP32[($6 + 88 | 0) >> 2] | 0 | 0, HEAP32[($6 + 96 | 0) >> 2] | 0 | 0);
    label$50 : {
     label$51 : {
      if ($5) {
       break label$51
      }
      $5 = HEAP32[($6 + 336 | 0) >> 2] | 0 ? $4 : 1;
      break label$50;
     }
     $3 = 0;
     HEAP32[($6 + 336 | 0) >> 2] = 0;
     $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend__T_2ccore__slice__iter__Iter_T_____spec_extend__h5cdab7a667860bc4($6 + 328 | 0 | 0, 1082816 | 0, 1082816 | 0);
     label$52 : {
      $5 = HEAP32[($6 + 336 | 0) >> 2] | 0;
      if (!$5) {
       break label$52
      }
      $4 = (($5 << 2 | 0) + (HEAP32[($6 + 328 | 0) >> 2] | 0) | 0) + -4 | 0;
      label$53 : while (1) {
       label$54 : {
        if (!(HEAP32[$4 >> 2] | 0)) {
         break label$54
        }
        $3 = $5;
        break label$52;
       }
       $5 = $5 + -1 | 0;
       HEAP32[($6 + 336 | 0) >> 2] = $5;
       $4 = $4 + -4 | 0;
       if ($5) {
        continue label$53
       }
       break label$53;
      };
     }
     $5 = 1;
     $4 = HEAP32[($6 + 332 | 0) >> 2] | 0;
     if ($4 >>> 0 <= $3 >>> 0) {
      break label$50
     }
     if ($3 >>> 0 >= ($4 >>> 2 | 0) >>> 0) {
      break label$50
     }
     alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($6 + 328 | 0 | 0, $3 | 0);
    }
    HEAP32[(($6 + 200 | 0) + 8 | 0) >> 2] = HEAP32[(($6 + 328 | 0) + 8 | 0) >> 2] | 0;
    HEAP8[($6 + 212 | 0) >> 0] = $5;
    i64toi32_i32$3 = $6;
    i64toi32_i32$5 = HEAP32[($6 + 328 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($6 + 332 | 0) >> 2] | 0;
    $631 = i64toi32_i32$5;
    i64toi32_i32$5 = $6;
    HEAP32[($6 + 200 | 0) >> 2] = $631;
    HEAP32[($6 + 204 | 0) >> 2] = i64toi32_i32$0;
    $5 = 1;
    $4 = 1;
    label$55 : {
     $3 = HEAPU8[($6 + 84 | 0) >> 0] | 0;
     if (($3 | 0) == (1 | 0)) {
      break label$55
     }
     $5 = 1;
     $4 = 1;
     label$56 : {
      label$57 : {
       switch (HEAPU8[($6 + 132 | 0) >> 0] | 0 | 0) {
       case 2:
        if ($3) {
         break label$56
        }
        $5 = 0;
        $4 = 0;
        break label$55;
       case 1:
        break label$55;
       default:
        break label$57;
       };
      }
      $5 = 0;
      $4 = 0;
      if ($3) {
       break label$55
      }
     }
     $4 = 2;
     $5 = 0;
    }
    num_bigint__biguint__multiplication__mul3__h007c2e75506c6ce0($6 + 328 | 0 | 0, HEAP32[($6 + 72 | 0) >> 2] | 0 | 0, HEAP32[($6 + 80 | 0) >> 2] | 0 | 0, HEAP32[($6 + 120 | 0) >> 2] | 0 | 0, HEAP32[($6 + 128 | 0) >> 2] | 0 | 0);
    label$59 : {
     label$60 : {
      if ($5) {
       break label$60
      }
      $4 = HEAP32[($6 + 336 | 0) >> 2] | 0 ? $4 : 1;
      break label$59;
     }
     $3 = 0;
     HEAP32[($6 + 336 | 0) >> 2] = 0;
     $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend__T_2ccore__slice__iter__Iter_T_____spec_extend__h5cdab7a667860bc4($6 + 328 | 0 | 0, 1082816 | 0, 1082816 | 0);
     label$61 : {
      $5 = HEAP32[($6 + 336 | 0) >> 2] | 0;
      if (!$5) {
       break label$61
      }
      $4 = (($5 << 2 | 0) + (HEAP32[($6 + 328 | 0) >> 2] | 0) | 0) + -4 | 0;
      label$62 : while (1) {
       label$63 : {
        if (!(HEAP32[$4 >> 2] | 0)) {
         break label$63
        }
        $3 = $5;
        break label$61;
       }
       $5 = $5 + -1 | 0;
       HEAP32[($6 + 336 | 0) >> 2] = $5;
       $4 = $4 + -4 | 0;
       if ($5) {
        continue label$62
       }
       break label$62;
      };
     }
     $4 = 1;
     $5 = HEAP32[($6 + 332 | 0) >> 2] | 0;
     if ($5 >>> 0 <= $3 >>> 0) {
      break label$59
     }
     if ($3 >>> 0 >= ($5 >>> 2 | 0) >>> 0) {
      break label$59
     }
     alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($6 + 328 | 0 | 0, $3 | 0);
    }
    $5 = ($6 + 328 | 0) + 8 | 0;
    HEAP32[(($6 + 216 | 0) + 8 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
    HEAP8[($6 + 228 | 0) >> 0] = $4;
    i64toi32_i32$3 = $6;
    i64toi32_i32$0 = HEAP32[($6 + 328 | 0) >> 2] | 0;
    i64toi32_i32$5 = HEAP32[($6 + 332 | 0) >> 2] | 0;
    $703 = i64toi32_i32$0;
    i64toi32_i32$0 = $6;
    HEAP32[($6 + 216 | 0) >> 2] = $703;
    HEAP32[($6 + 220 | 0) >> 2] = i64toi32_i32$5;
    $4 = ($6 + 368 | 0) + 8 | 0;
    i64toi32_i32$3 = ($6 + 136 | 0) + 8 | 0;
    i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $711 = i64toi32_i32$5;
    i64toi32_i32$5 = $4;
    HEAP32[i64toi32_i32$5 >> 2] = $711;
    HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$3 = $6;
    i64toi32_i32$0 = HEAP32[($6 + 136 | 0) >> 2] | 0;
    i64toi32_i32$5 = HEAP32[($6 + 140 | 0) >> 2] | 0;
    $714 = i64toi32_i32$0;
    i64toi32_i32$0 = $6;
    HEAP32[($6 + 368 | 0) >> 2] = $714;
    HEAP32[($6 + 372 | 0) >> 2] = i64toi32_i32$5;
    i64toi32_i32$3 = ($6 + 56 | 0) + 8 | 0;
    i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $719 = i64toi32_i32$5;
    i64toi32_i32$5 = $5;
    HEAP32[$5 >> 2] = $719;
    HEAP32[($5 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$3 = $6;
    i64toi32_i32$0 = HEAP32[($6 + 56 | 0) >> 2] | 0;
    i64toi32_i32$5 = HEAP32[($6 + 60 | 0) >> 2] | 0;
    $722 = i64toi32_i32$0;
    i64toi32_i32$0 = $6;
    HEAP32[($6 + 328 | 0) >> 2] = $722;
    HEAP32[($6 + 332 | 0) >> 2] = i64toi32_i32$5;
    num_bigint__bigint__addition___impl_20core__ops__arith__Add_20for_20num_bigint__bigint__BigInt___add__ha39524fef59942b1($6 + 312 | 0 | 0, $6 + 368 | 0 | 0, $6 + 328 | 0 | 0);
    i64toi32_i32$3 = ($6 + 152 | 0) + 8 | 0;
    i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $733 = i64toi32_i32$5;
    i64toi32_i32$5 = $4;
    HEAP32[i64toi32_i32$5 >> 2] = $733;
    HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$3 = $6;
    i64toi32_i32$0 = HEAP32[($6 + 152 | 0) >> 2] | 0;
    i64toi32_i32$5 = HEAP32[($6 + 156 | 0) >> 2] | 0;
    $736 = i64toi32_i32$0;
    i64toi32_i32$0 = $6;
    HEAP32[($6 + 368 | 0) >> 2] = $736;
    HEAP32[($6 + 372 | 0) >> 2] = i64toi32_i32$5;
    i64toi32_i32$3 = ($6 + 104 | 0) + 8 | 0;
    i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $741 = i64toi32_i32$5;
    i64toi32_i32$5 = $5;
    HEAP32[$5 >> 2] = $741;
    HEAP32[($5 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$3 = $6;
    i64toi32_i32$0 = HEAP32[($6 + 104 | 0) >> 2] | 0;
    i64toi32_i32$5 = HEAP32[($6 + 108 | 0) >> 2] | 0;
    $744 = i64toi32_i32$0;
    i64toi32_i32$0 = $6;
    HEAP32[($6 + 328 | 0) >> 2] = $744;
    HEAP32[($6 + 332 | 0) >> 2] = i64toi32_i32$5;
    num_bigint__bigint__addition___impl_20core__ops__arith__Add_20for_20num_bigint__bigint__BigInt___add__ha39524fef59942b1($6 + 352 | 0 | 0, $6 + 368 | 0 | 0, $6 + 328 | 0 | 0);
    $5 = 1;
    $11 = HEAP32[($6 + 320 | 0) >> 2] | 0;
    $9 = HEAP32[($6 + 312 | 0) >> 2] | 0;
    $4 = 1;
    label$64 : {
     $3 = HEAPU8[($6 + 324 | 0) >> 0] | 0;
     if (($3 | 0) == (1 | 0)) {
      break label$64
     }
     $5 = 1;
     $4 = 1;
     label$65 : {
      label$66 : {
       switch (HEAPU8[($6 + 364 | 0) >> 0] | 0 | 0) {
       case 2:
        if ($3) {
         break label$65
        }
        $5 = 0;
        $4 = 0;
        break label$64;
       case 1:
        break label$64;
       default:
        break label$66;
       };
      }
      $5 = 0;
      $4 = 0;
      if ($3) {
       break label$64
      }
     }
     $4 = 2;
     $5 = 0;
    }
    $3 = HEAP32[($6 + 316 | 0) >> 2] | 0;
    $2 = HEAP32[($6 + 352 | 0) >> 2] | 0;
    num_bigint__biguint__multiplication__mul3__h007c2e75506c6ce0($6 + 328 | 0 | 0, $9 | 0, $11 | 0, $2 | 0, HEAP32[($6 + 360 | 0) >> 2] | 0 | 0);
    label$68 : {
     label$69 : {
      if ($5) {
       break label$69
      }
      $5 = HEAP32[($6 + 336 | 0) >> 2] | 0 ? $4 : 1;
      break label$68;
     }
     $11 = 0;
     HEAP32[($6 + 336 | 0) >> 2] = 0;
     $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend__T_2ccore__slice__iter__Iter_T_____spec_extend__h5cdab7a667860bc4($6 + 328 | 0 | 0, 1082816 | 0, 1082816 | 0);
     label$70 : {
      $5 = HEAP32[($6 + 336 | 0) >> 2] | 0;
      if (!$5) {
       break label$70
      }
      $4 = (($5 << 2 | 0) + (HEAP32[($6 + 328 | 0) >> 2] | 0) | 0) + -4 | 0;
      label$71 : while (1) {
       label$72 : {
        if (!(HEAP32[$4 >> 2] | 0)) {
         break label$72
        }
        $11 = $5;
        break label$70;
       }
       $5 = $5 + -1 | 0;
       HEAP32[($6 + 336 | 0) >> 2] = $5;
       $4 = $4 + -4 | 0;
       if ($5) {
        continue label$71
       }
       break label$71;
      };
     }
     $5 = 1;
     $4 = HEAP32[($6 + 332 | 0) >> 2] | 0;
     if ($4 >>> 0 <= $11 >>> 0) {
      break label$68
     }
     if ($11 >>> 0 >= ($4 >>> 2 | 0) >>> 0) {
      break label$68
     }
     alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($6 + 328 | 0 | 0, $11 | 0);
    }
    HEAP32[(($6 + 232 | 0) + 8 | 0) >> 2] = HEAP32[(($6 + 328 | 0) + 8 | 0) >> 2] | 0;
    HEAP8[($6 + 244 | 0) >> 0] = $5;
    i64toi32_i32$3 = $6;
    i64toi32_i32$5 = HEAP32[($6 + 328 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($6 + 332 | 0) >> 2] | 0;
    $826 = i64toi32_i32$5;
    i64toi32_i32$5 = $6;
    HEAP32[($6 + 232 | 0) >> 2] = $826;
    HEAP32[($6 + 236 | 0) >> 2] = i64toi32_i32$0;
    label$73 : {
     if (!$3) {
      break label$73
     }
     $5 = $3 << 2 | 0;
     if (!$5) {
      break label$73
     }
     __rust_dealloc($9 | 0, $5 | 0, 4 | 0);
    }
    label$74 : {
     $5 = HEAP32[($6 + 356 | 0) >> 2] | 0;
     if (!$5) {
      break label$74
     }
     $5 = $5 << 2 | 0;
     if (!$5) {
      break label$74
     }
     __rust_dealloc($2 | 0, $5 | 0, 4 | 0);
    }
    $5 = 1;
    $4 = 1;
    label$75 : {
     $3 = HEAPU8[($6 + 180 | 0) >> 0] | 0;
     if (($3 | 0) == (1 | 0)) {
      break label$75
     }
     $5 = 1;
     $4 = 1;
     label$76 : {
      label$77 : {
       switch (HEAPU8[($6 + 196 | 0) >> 0] | 0 | 0) {
       case 2:
        if ($3) {
         break label$76
        }
        $5 = 0;
        $4 = 0;
        break label$75;
       case 1:
        break label$75;
       default:
        break label$77;
       };
      }
      $5 = 0;
      $4 = 0;
      if ($3) {
       break label$75
      }
     }
     $4 = 2;
     $5 = 0;
    }
    num_bigint__biguint__multiplication__mul3__h007c2e75506c6ce0($6 + 328 | 0 | 0, HEAP32[($6 + 168 | 0) >> 2] | 0 | 0, HEAP32[($6 + 176 | 0) >> 2] | 0 | 0, HEAP32[($6 + 184 | 0) >> 2] | 0 | 0, HEAP32[($6 + 192 | 0) >> 2] | 0 | 0);
    label$79 : {
     label$80 : {
      if ($5) {
       break label$80
      }
      $5 = HEAP32[($6 + 336 | 0) >> 2] | 0 ? $4 : 1;
      break label$79;
     }
     $3 = 0;
     HEAP32[($6 + 336 | 0) >> 2] = 0;
     $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend__T_2ccore__slice__iter__Iter_T_____spec_extend__h5cdab7a667860bc4($6 + 328 | 0 | 0, 1082816 | 0, 1082816 | 0);
     label$81 : {
      $5 = HEAP32[($6 + 336 | 0) >> 2] | 0;
      if (!$5) {
       break label$81
      }
      $4 = (($5 << 2 | 0) + (HEAP32[($6 + 328 | 0) >> 2] | 0) | 0) + -4 | 0;
      label$82 : while (1) {
       label$83 : {
        if (!(HEAP32[$4 >> 2] | 0)) {
         break label$83
        }
        $3 = $5;
        break label$81;
       }
       $5 = $5 + -1 | 0;
       HEAP32[($6 + 336 | 0) >> 2] = $5;
       $4 = $4 + -4 | 0;
       if ($5) {
        continue label$82
       }
       break label$82;
      };
     }
     $5 = 1;
     $4 = HEAP32[($6 + 332 | 0) >> 2] | 0;
     if ($4 >>> 0 <= $3 >>> 0) {
      break label$79
     }
     if ($3 >>> 0 >= ($4 >>> 2 | 0) >>> 0) {
      break label$79
     }
     alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($6 + 328 | 0 | 0, $3 | 0);
    }
    $3 = ($6 + 328 | 0) + 8 | 0;
    HEAP32[(($6 + 248 | 0) + 8 | 0) >> 2] = HEAP32[$3 >> 2] | 0;
    HEAP8[($6 + 260 | 0) >> 0] = $5;
    i64toi32_i32$3 = $6;
    i64toi32_i32$0 = HEAP32[($6 + 328 | 0) >> 2] | 0;
    i64toi32_i32$5 = HEAP32[($6 + 332 | 0) >> 2] | 0;
    $916 = i64toi32_i32$0;
    i64toi32_i32$0 = $6;
    HEAP32[($6 + 248 | 0) >> 2] = $916;
    HEAP32[($6 + 252 | 0) >> 2] = i64toi32_i32$5;
    i64toi32_i32$3 = ($6 + 168 | 0) + 8 | 0;
    i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $923 = i64toi32_i32$5;
    i64toi32_i32$5 = ($6 + 368 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$5 >> 2] = $923;
    HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$3 = $6;
    i64toi32_i32$0 = HEAP32[($6 + 168 | 0) >> 2] | 0;
    i64toi32_i32$5 = HEAP32[($6 + 172 | 0) >> 2] | 0;
    $926 = i64toi32_i32$0;
    i64toi32_i32$0 = $6;
    HEAP32[($6 + 368 | 0) >> 2] = $926;
    HEAP32[($6 + 372 | 0) >> 2] = i64toi32_i32$5;
    i64toi32_i32$3 = ($6 + 72 | 0) + 8 | 0;
    i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $931 = i64toi32_i32$5;
    i64toi32_i32$5 = $3;
    HEAP32[i64toi32_i32$5 >> 2] = $931;
    HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$3 = $6;
    i64toi32_i32$0 = HEAP32[($6 + 72 | 0) >> 2] | 0;
    i64toi32_i32$5 = HEAP32[($6 + 76 | 0) >> 2] | 0;
    $934 = i64toi32_i32$0;
    i64toi32_i32$0 = $6;
    HEAP32[($6 + 328 | 0) >> 2] = $934;
    HEAP32[($6 + 332 | 0) >> 2] = i64toi32_i32$5;
    num_bigint__bigint__addition___impl_20core__ops__arith__Add_20for_20num_bigint__bigint__BigInt___add__ha39524fef59942b1($6 + 352 | 0 | 0, $6 + 368 | 0 | 0, $6 + 328 | 0 | 0);
    $11 = HEAPU8[($6 + 364 | 0) >> 0] | 0;
    $9 = HEAP32[(($6 + 352 | 0) + 8 | 0) >> 2] | 0;
    HEAP32[$3 >> 2] = $9;
    i64toi32_i32$3 = $6;
    i64toi32_i32$5 = HEAP32[($6 + 352 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($6 + 356 | 0) >> 2] | 0;
    $19 = i64toi32_i32$5;
    $19$hi = i64toi32_i32$0;
    i64toi32_i32$5 = $6;
    HEAP32[($6 + 328 | 0) >> 2] = $19;
    HEAP32[($6 + 332 | 0) >> 2] = i64toi32_i32$0;
    label$84 : {
     if (!$9) {
      break label$84
     }
     $4 = $9 << 2 | 0;
     i64toi32_i32$0 = 0;
     $18 = 0;
     $18$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $19$hi;
     $2 = $19;
     $5 = $2;
     label$85 : while (1) {
      $960 = $5;
      i64toi32_i32$3 = $5;
      i64toi32_i32$0 = HEAP32[$5 >> 2] | 0;
      i64toi32_i32$5 = 0;
      i64toi32_i32$3 = i64toi32_i32$0;
      i64toi32_i32$0 = 0;
      i64toi32_i32$2 = 1;
      i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
       i64toi32_i32$0 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
       $99 = 0;
      } else {
       i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$5 << i64toi32_i32$4 | 0) | 0;
       $99 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
      }
      $963$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $18$hi;
      i64toi32_i32$0 = $963$hi;
      i64toi32_i32$5 = $99;
      i64toi32_i32$3 = $18$hi;
      i64toi32_i32$2 = $18;
      i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
      i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
      if (i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0) {
       i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
      }
      $18 = i64toi32_i32$4;
      $18$hi = i64toi32_i32$1;
      HEAP32[$960 >> 2] = i64toi32_i32$4;
      $5 = $5 + 4 | 0;
      i64toi32_i32$0 = i64toi32_i32$4;
      i64toi32_i32$5 = 0;
      i64toi32_i32$2 = 32;
      i64toi32_i32$3 = i64toi32_i32$2 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
       i64toi32_i32$5 = 0;
       $100 = i64toi32_i32$1 >>> i64toi32_i32$3 | 0;
      } else {
       i64toi32_i32$5 = i64toi32_i32$1 >>> i64toi32_i32$3 | 0;
       $100 = (((1 << i64toi32_i32$3 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$3 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$3 | 0) | 0;
      }
      $18 = $100;
      $18$hi = i64toi32_i32$5;
      $4 = $4 + -4 | 0;
      if ($4) {
       continue label$85
      }
      break label$85;
     };
     i64toi32_i32$5 = $18$hi;
     $5 = $18;
     if (!$5) {
      break label$84
     }
     label$86 : {
      if (($9 | 0) != (HEAP32[($6 + 332 | 0) >> 2] | 0 | 0)) {
       break label$86
      }
      alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h90c9768825cdae1b($6 + 328 | 0 | 0, $9 | 0, 1 | 0);
      $2 = HEAP32[($6 + 328 | 0) >> 2] | 0;
      $9 = HEAP32[($6 + 336 | 0) >> 2] | 0;
     }
     HEAP32[($2 + ($9 << 2 | 0) | 0) >> 2] = $5;
     HEAP32[($6 + 336 | 0) >> 2] = $9 + 1 | 0;
    }
    HEAP32[(($6 + 312 | 0) + 8 | 0) >> 2] = HEAP32[$3 >> 2] | 0;
    i64toi32_i32$1 = $6;
    i64toi32_i32$5 = HEAP32[($6 + 328 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($6 + 332 | 0) >> 2] | 0;
    $1004 = i64toi32_i32$5;
    i64toi32_i32$5 = $6;
    HEAP32[($6 + 312 | 0) >> 2] = $1004;
    HEAP32[($6 + 316 | 0) >> 2] = i64toi32_i32$0;
    label$87 : {
     label$88 : {
      if (($11 & 255 | 0 | 0) == (1 | 0)) {
       break label$88
      }
      $5 = HEAP32[($6 + 320 | 0) >> 2] | 0 ? $11 : 1;
      break label$87;
     }
     $3 = 0;
     HEAP32[($6 + 320 | 0) >> 2] = 0;
     $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend__T_2ccore__slice__iter__Iter_T_____spec_extend__h5cdab7a667860bc4($6 + 312 | 0 | 0, 1082816 | 0, 1082816 | 0);
     label$89 : {
      $5 = HEAP32[($6 + 320 | 0) >> 2] | 0;
      if (!$5) {
       break label$89
      }
      $4 = (($5 << 2 | 0) + (HEAP32[($6 + 312 | 0) >> 2] | 0) | 0) + -4 | 0;
      label$90 : while (1) {
       label$91 : {
        if (!(HEAP32[$4 >> 2] | 0)) {
         break label$91
        }
        $3 = $5;
        break label$89;
       }
       $5 = $5 + -1 | 0;
       HEAP32[($6 + 320 | 0) >> 2] = $5;
       $4 = $4 + -4 | 0;
       if ($5) {
        continue label$90
       }
       break label$90;
      };
     }
     $5 = 1;
     $4 = HEAP32[($6 + 316 | 0) >> 2] | 0;
     if ($4 >>> 0 <= $3 >>> 0) {
      break label$87
     }
     if ($3 >>> 0 >= ($4 >>> 2 | 0) >>> 0) {
      break label$87
     }
     alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($6 + 312 | 0 | 0, $3 | 0);
    }
    $4 = ($6 + 368 | 0) + 8 | 0;
    HEAP32[$4 >> 2] = HEAP32[(($6 + 312 | 0) + 8 | 0) >> 2] | 0;
    HEAP8[($6 + 380 | 0) >> 0] = $5;
    i64toi32_i32$1 = $6;
    i64toi32_i32$0 = HEAP32[($6 + 312 | 0) >> 2] | 0;
    i64toi32_i32$5 = HEAP32[($6 + 316 | 0) >> 2] | 0;
    $1060 = i64toi32_i32$0;
    i64toi32_i32$0 = $6;
    HEAP32[($6 + 368 | 0) >> 2] = $1060;
    HEAP32[($6 + 372 | 0) >> 2] = i64toi32_i32$5;
    $3 = ($6 + 328 | 0) + 8 | 0;
    i64toi32_i32$1 = ($6 + 40 | 0) + 8 | 0;
    i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
    $1068 = i64toi32_i32$5;
    i64toi32_i32$5 = $3;
    HEAP32[i64toi32_i32$5 >> 2] = $1068;
    HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$1 = $6;
    i64toi32_i32$0 = HEAP32[($6 + 40 | 0) >> 2] | 0;
    i64toi32_i32$5 = HEAP32[($6 + 44 | 0) >> 2] | 0;
    $1071 = i64toi32_i32$0;
    i64toi32_i32$0 = $6;
    HEAP32[($6 + 328 | 0) >> 2] = $1071;
    HEAP32[($6 + 332 | 0) >> 2] = i64toi32_i32$5;
    num_bigint__bigint__subtraction___impl_20core__ops__arith__Sub_20for_20num_bigint__bigint__BigInt___sub__h02bf2323746cfdb9($6 + 312 | 0 | 0, $6 + 368 | 0 | 0, $6 + 328 | 0 | 0);
    i64toi32_i32$1 = ($6 + 184 | 0) + 8 | 0;
    i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
    $1082 = i64toi32_i32$5;
    i64toi32_i32$5 = $4;
    HEAP32[i64toi32_i32$5 >> 2] = $1082;
    HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$1 = $6;
    i64toi32_i32$0 = HEAP32[($6 + 184 | 0) >> 2] | 0;
    i64toi32_i32$5 = HEAP32[($6 + 188 | 0) >> 2] | 0;
    $1085 = i64toi32_i32$0;
    i64toi32_i32$0 = $6;
    HEAP32[($6 + 368 | 0) >> 2] = $1085;
    HEAP32[($6 + 372 | 0) >> 2] = i64toi32_i32$5;
    i64toi32_i32$1 = ($6 + 120 | 0) + 8 | 0;
    i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
    $1090 = i64toi32_i32$5;
    i64toi32_i32$5 = $3;
    HEAP32[i64toi32_i32$5 >> 2] = $1090;
    HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$1 = $6;
    i64toi32_i32$0 = HEAP32[($6 + 120 | 0) >> 2] | 0;
    i64toi32_i32$5 = HEAP32[($6 + 124 | 0) >> 2] | 0;
    $1093 = i64toi32_i32$0;
    i64toi32_i32$0 = $6;
    HEAP32[($6 + 328 | 0) >> 2] = $1093;
    HEAP32[($6 + 332 | 0) >> 2] = i64toi32_i32$5;
    num_bigint__bigint__addition___impl_20core__ops__arith__Add_20for_20num_bigint__bigint__BigInt___add__ha39524fef59942b1($6 + 352 | 0 | 0, $6 + 368 | 0 | 0, $6 + 328 | 0 | 0);
    $11 = HEAPU8[($6 + 364 | 0) >> 0] | 0;
    $9 = HEAP32[(($6 + 352 | 0) + 8 | 0) >> 2] | 0;
    HEAP32[$3 >> 2] = $9;
    i64toi32_i32$1 = $6;
    i64toi32_i32$5 = HEAP32[($6 + 352 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($6 + 356 | 0) >> 2] | 0;
    $19 = i64toi32_i32$5;
    $19$hi = i64toi32_i32$0;
    i64toi32_i32$5 = $6;
    HEAP32[($6 + 328 | 0) >> 2] = $19;
    HEAP32[($6 + 332 | 0) >> 2] = i64toi32_i32$0;
    label$92 : {
     if (!$9) {
      break label$92
     }
     $4 = $9 << 2 | 0;
     i64toi32_i32$0 = 0;
     $18 = 0;
     $18$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $19$hi;
     $2 = $19;
     $5 = $2;
     label$93 : while (1) {
      $1119 = $5;
      i64toi32_i32$1 = $5;
      i64toi32_i32$0 = HEAP32[$5 >> 2] | 0;
      i64toi32_i32$5 = 0;
      i64toi32_i32$1 = i64toi32_i32$0;
      i64toi32_i32$0 = 0;
      i64toi32_i32$2 = 1;
      i64toi32_i32$3 = i64toi32_i32$2 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
       i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$3 | 0;
       $101 = 0;
      } else {
       i64toi32_i32$0 = ((1 << i64toi32_i32$3 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$3 | 0) | 0) | 0 | (i64toi32_i32$5 << i64toi32_i32$3 | 0) | 0;
       $101 = i64toi32_i32$1 << i64toi32_i32$3 | 0;
      }
      $1122$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $18$hi;
      i64toi32_i32$0 = $1122$hi;
      i64toi32_i32$5 = $101;
      i64toi32_i32$1 = $18$hi;
      i64toi32_i32$2 = $18;
      i64toi32_i32$3 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
      i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
      if (i64toi32_i32$3 >>> 0 < i64toi32_i32$2 >>> 0) {
       i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
      }
      $18 = i64toi32_i32$3;
      $18$hi = i64toi32_i32$4;
      HEAP32[$1119 >> 2] = i64toi32_i32$3;
      $5 = $5 + 4 | 0;
      i64toi32_i32$0 = i64toi32_i32$3;
      i64toi32_i32$5 = 0;
      i64toi32_i32$2 = 32;
      i64toi32_i32$1 = i64toi32_i32$2 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
       i64toi32_i32$5 = 0;
       $102 = i64toi32_i32$4 >>> i64toi32_i32$1 | 0;
      } else {
       i64toi32_i32$5 = i64toi32_i32$4 >>> i64toi32_i32$1 | 0;
       $102 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$1 | 0) | 0;
      }
      $18 = $102;
      $18$hi = i64toi32_i32$5;
      $4 = $4 + -4 | 0;
      if ($4) {
       continue label$93
      }
      break label$93;
     };
     i64toi32_i32$5 = $18$hi;
     $5 = $18;
     if (!$5) {
      break label$92
     }
     label$94 : {
      if (($9 | 0) != (HEAP32[($6 + 332 | 0) >> 2] | 0 | 0)) {
       break label$94
      }
      alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h90c9768825cdae1b($6 + 328 | 0 | 0, $9 | 0, 1 | 0);
      $2 = HEAP32[($6 + 328 | 0) >> 2] | 0;
      $9 = HEAP32[($6 + 336 | 0) >> 2] | 0;
     }
     HEAP32[($2 + ($9 << 2 | 0) | 0) >> 2] = $5;
     HEAP32[($6 + 336 | 0) >> 2] = $9 + 1 | 0;
    }
    HEAP32[(($6 + 296 | 0) + 8 | 0) >> 2] = HEAP32[$3 >> 2] | 0;
    i64toi32_i32$4 = $6;
    i64toi32_i32$5 = HEAP32[($6 + 328 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($6 + 332 | 0) >> 2] | 0;
    $1163 = i64toi32_i32$5;
    i64toi32_i32$5 = $6;
    HEAP32[($6 + 296 | 0) >> 2] = $1163;
    HEAP32[($6 + 300 | 0) >> 2] = i64toi32_i32$0;
    label$95 : {
     label$96 : {
      if (($11 & 255 | 0 | 0) == (1 | 0)) {
       break label$96
      }
      $5 = HEAP32[($6 + 304 | 0) >> 2] | 0 ? $11 : 1;
      break label$95;
     }
     $3 = 0;
     HEAP32[($6 + 304 | 0) >> 2] = 0;
     $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend__T_2ccore__slice__iter__Iter_T_____spec_extend__h5cdab7a667860bc4($6 + 296 | 0 | 0, 1082816 | 0, 1082816 | 0);
     label$97 : {
      $5 = HEAP32[($6 + 304 | 0) >> 2] | 0;
      if (!$5) {
       break label$97
      }
      $4 = (($5 << 2 | 0) + (HEAP32[($6 + 296 | 0) >> 2] | 0) | 0) + -4 | 0;
      label$98 : while (1) {
       label$99 : {
        if (!(HEAP32[$4 >> 2] | 0)) {
         break label$99
        }
        $3 = $5;
        break label$97;
       }
       $5 = $5 + -1 | 0;
       HEAP32[($6 + 304 | 0) >> 2] = $5;
       $4 = $4 + -4 | 0;
       if ($5) {
        continue label$98
       }
       break label$98;
      };
     }
     $5 = 1;
     $4 = HEAP32[($6 + 300 | 0) >> 2] | 0;
     if ($4 >>> 0 <= $3 >>> 0) {
      break label$95
     }
     if ($3 >>> 0 >= ($4 >>> 2 | 0) >>> 0) {
      break label$95
     }
     alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($6 + 296 | 0 | 0, $3 | 0);
    }
    HEAP32[(($6 + 368 | 0) + 8 | 0) >> 2] = HEAP32[(($6 + 296 | 0) + 8 | 0) >> 2] | 0;
    HEAP8[($6 + 380 | 0) >> 0] = $5;
    i64toi32_i32$4 = $6;
    i64toi32_i32$0 = HEAP32[($6 + 296 | 0) >> 2] | 0;
    i64toi32_i32$5 = HEAP32[($6 + 300 | 0) >> 2] | 0;
    $1218 = i64toi32_i32$0;
    i64toi32_i32$0 = $6;
    HEAP32[($6 + 368 | 0) >> 2] = $1218;
    HEAP32[($6 + 372 | 0) >> 2] = i64toi32_i32$5;
    i64toi32_i32$4 = ($6 + 88 | 0) + 8 | 0;
    i64toi32_i32$5 = HEAP32[i64toi32_i32$4 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
    $1225 = i64toi32_i32$5;
    i64toi32_i32$5 = ($6 + 328 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$5 >> 2] = $1225;
    HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$4 = $6;
    i64toi32_i32$0 = HEAP32[($6 + 88 | 0) >> 2] | 0;
    i64toi32_i32$5 = HEAP32[($6 + 92 | 0) >> 2] | 0;
    $1228 = i64toi32_i32$0;
    i64toi32_i32$0 = $6;
    HEAP32[($6 + 328 | 0) >> 2] = $1228;
    HEAP32[($6 + 332 | 0) >> 2] = i64toi32_i32$5;
    num_bigint__bigint__subtraction___impl_20core__ops__arith__Sub_20for_20num_bigint__bigint__BigInt___sub__h02bf2323746cfdb9($6 + 352 | 0 | 0, $6 + 368 | 0 | 0, $6 + 328 | 0 | 0);
    $5 = 1;
    $11 = HEAP32[($6 + 320 | 0) >> 2] | 0;
    $9 = HEAP32[($6 + 312 | 0) >> 2] | 0;
    $4 = 1;
    label$100 : {
     $3 = HEAPU8[($6 + 324 | 0) >> 0] | 0;
     if (($3 | 0) == (1 | 0)) {
      break label$100
     }
     $5 = 1;
     $4 = 1;
     label$101 : {
      label$102 : {
       switch (HEAPU8[($6 + 364 | 0) >> 0] | 0 | 0) {
       case 2:
        if ($3) {
         break label$101
        }
        $5 = 0;
        $4 = 0;
        break label$100;
       case 1:
        break label$100;
       default:
        break label$102;
       };
      }
      $5 = 0;
      $4 = 0;
      if ($3) {
       break label$100
      }
     }
     $4 = 2;
     $5 = 0;
    }
    $3 = HEAP32[($6 + 316 | 0) >> 2] | 0;
    $2 = HEAP32[($6 + 352 | 0) >> 2] | 0;
    num_bigint__biguint__multiplication__mul3__h007c2e75506c6ce0($6 + 328 | 0 | 0, $9 | 0, $11 | 0, $2 | 0, HEAP32[($6 + 360 | 0) >> 2] | 0 | 0);
    label$104 : {
     label$105 : {
      if ($5) {
       break label$105
      }
      $4 = HEAP32[($6 + 336 | 0) >> 2] | 0 ? $4 : 1;
      break label$104;
     }
     $11 = 0;
     HEAP32[($6 + 336 | 0) >> 2] = 0;
     $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend__T_2ccore__slice__iter__Iter_T_____spec_extend__h5cdab7a667860bc4($6 + 328 | 0 | 0, 1082816 | 0, 1082816 | 0);
     label$106 : {
      $5 = HEAP32[($6 + 336 | 0) >> 2] | 0;
      if (!$5) {
       break label$106
      }
      $4 = (($5 << 2 | 0) + (HEAP32[($6 + 328 | 0) >> 2] | 0) | 0) + -4 | 0;
      label$107 : while (1) {
       label$108 : {
        if (!(HEAP32[$4 >> 2] | 0)) {
         break label$108
        }
        $11 = $5;
        break label$106;
       }
       $5 = $5 + -1 | 0;
       HEAP32[($6 + 336 | 0) >> 2] = $5;
       $4 = $4 + -4 | 0;
       if ($5) {
        continue label$107
       }
       break label$107;
      };
     }
     $4 = 1;
     $5 = HEAP32[($6 + 332 | 0) >> 2] | 0;
     if ($5 >>> 0 <= $11 >>> 0) {
      break label$104
     }
     if ($11 >>> 0 >= ($5 >>> 2 | 0) >>> 0) {
      break label$104
     }
     alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($6 + 328 | 0 | 0, $11 | 0);
    }
    HEAP32[(($6 + 264 | 0) + 8 | 0) >> 2] = HEAP32[(($6 + 328 | 0) + 8 | 0) >> 2] | 0;
    i64toi32_i32$4 = $6;
    i64toi32_i32$5 = HEAP32[($6 + 328 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($6 + 332 | 0) >> 2] | 0;
    $1308 = i64toi32_i32$5;
    i64toi32_i32$5 = $6;
    HEAP32[($6 + 264 | 0) >> 2] = $1308;
    HEAP32[($6 + 268 | 0) >> 2] = i64toi32_i32$0;
    label$109 : {
     if (!$3) {
      break label$109
     }
     $5 = $3 << 2 | 0;
     if (!$5) {
      break label$109
     }
     __rust_dealloc($9 | 0, $5 | 0, 4 | 0);
    }
    label$110 : {
     $5 = HEAP32[($6 + 356 | 0) >> 2] | 0;
     if (!$5) {
      break label$110
     }
     $5 = $5 << 2 | 0;
     if (!$5) {
      break label$110
     }
     __rust_dealloc($2 | 0, $5 | 0, 4 | 0);
    }
    $5 = ($6 + 328 | 0) + 8 | 0;
    HEAP32[$5 >> 2] = HEAP32[(($6 + 264 | 0) + 8 | 0) >> 2] | 0;
    i64toi32_i32$4 = $6;
    i64toi32_i32$0 = HEAP32[($6 + 264 | 0) >> 2] | 0;
    i64toi32_i32$5 = HEAP32[($6 + 268 | 0) >> 2] | 0;
    $1337 = i64toi32_i32$0;
    i64toi32_i32$0 = $6;
    HEAP32[($6 + 328 | 0) >> 2] = $1337;
    HEAP32[($6 + 332 | 0) >> 2] = i64toi32_i32$5;
    HEAP8[($6 + 340 | 0) >> 0] = $4;
    num_bigint__bigint__subtraction___impl_20core__ops__arith__Sub__num_bigint__bigint__BigInt__20for_20num_bigint__bigint__BigInt___sub__h0804349f9fe4b776($6 + 368 | 0 | 0, $6 + 328 | 0 | 0, $6 + 232 | 0 | 0);
    num_bigint__bigint__division___impl_20core__ops__arith__Div_i32__20for_20num_bigint__bigint__BigInt___div__he39ea57e2d8da458($6 + 280 | 0 | 0, $6 + 368 | 0 | 0, 3 | 0);
    i64toi32_i32$4 = ($6 + 232 | 0) + 8 | 0;
    i64toi32_i32$5 = HEAP32[i64toi32_i32$4 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
    $1354 = i64toi32_i32$5;
    i64toi32_i32$5 = $5;
    HEAP32[$5 >> 2] = $1354;
    HEAP32[($5 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$4 = $6;
    i64toi32_i32$0 = HEAP32[($6 + 232 | 0) >> 2] | 0;
    i64toi32_i32$5 = HEAP32[($6 + 236 | 0) >> 2] | 0;
    $1357 = i64toi32_i32$0;
    i64toi32_i32$0 = $6;
    HEAP32[($6 + 328 | 0) >> 2] = $1357;
    HEAP32[($6 + 332 | 0) >> 2] = i64toi32_i32$5;
    num_bigint__bigint__subtraction___impl_20core__ops__arith__Sub__num_bigint__bigint__BigInt__20for_20num_bigint__bigint__BigInt___sub__h0804349f9fe4b776($6 + 368 | 0 | 0, $6 + 328 | 0 | 0, $6 + 248 | 0 | 0);
    num_bigint__bigint__division___impl_20core__ops__arith__Div_i32__20for_20num_bigint__bigint__BigInt___div__he39ea57e2d8da458($6 + 296 | 0 | 0, $6 + 368 | 0 | 0, 2 | 0);
    i64toi32_i32$4 = ($6 + 248 | 0) + 8 | 0;
    i64toi32_i32$5 = HEAP32[i64toi32_i32$4 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
    $1372 = i64toi32_i32$5;
    i64toi32_i32$5 = $5;
    HEAP32[$5 >> 2] = $1372;
    HEAP32[($5 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$4 = $6;
    i64toi32_i32$0 = HEAP32[($6 + 248 | 0) >> 2] | 0;
    i64toi32_i32$5 = HEAP32[($6 + 252 | 0) >> 2] | 0;
    $1375 = i64toi32_i32$0;
    i64toi32_i32$0 = $6;
    HEAP32[($6 + 328 | 0) >> 2] = $1375;
    HEAP32[($6 + 332 | 0) >> 2] = i64toi32_i32$5;
    num_bigint__bigint__subtraction___impl_20core__ops__arith__Sub__num_bigint__bigint__BigInt__20for_20num_bigint__bigint__BigInt___sub__h0804349f9fe4b776($6 + 312 | 0 | 0, $6 + 328 | 0 | 0, $6 + 200 | 0 | 0);
    $3 = HEAP32[($6 + 284 | 0) >> 2] | 0;
    $9 = HEAP32[($6 + 280 | 0) >> 2] | 0;
    label$111 : {
     label$112 : {
      label$113 : {
       label$114 : {
        label$115 : {
         label$116 : {
          label$117 : {
           label$118 : {
            $5 = HEAPU8[($6 + 292 | 0) >> 0] | 0;
            if (($5 | 0) != (1 | 0)) {
             break label$118
            }
            $4 = HEAPU8[($6 + 324 | 0) >> 0] | 0;
            $11 = HEAP32[($6 + 312 | 0) >> 2] | 0;
            $5 = HEAP32[($6 + 320 | 0) >> 2] | 0;
            alloc__raw_vec__RawVec_T_2cA___allocate_in__hb0817f92bbb8999a($6 + 32 | 0 | 0, $5 | 0, 0 | 0);
            HEAP32[($6 + 332 | 0) >> 2] = HEAP32[($6 + 36 | 0) >> 2] | 0;
            $2 = HEAP32[($6 + 32 | 0) >> 2] | 0;
            HEAP32[($6 + 328 | 0) >> 2] = $2;
            memcpy($2 | 0, $11 | 0, $5 << 2 | 0 | 0) | 0;
            HEAP8[($6 + 340 | 0) >> 0] = $4;
            HEAP32[($6 + 336 | 0) >> 2] = $5;
            break label$117;
           }
           $15 = HEAP32[($6 + 288 | 0) >> 2] | 0;
           label$119 : {
            label$120 : {
             label$121 : {
              label$122 : {
               $12 = HEAPU8[($6 + 324 | 0) >> 0] | 0;
               switch ($12 | 0) {
               case 2:
                break label$121;
               case 1:
                break label$122;
               default:
                break label$120;
               };
              }
              $4 = $6 + 293 | 0;
              $3 = 2;
              label$123 : {
               label$124 : {
                switch ($5 & 3 | 0 | 0) {
                case 1:
                 $3 = 1;
                 break label$123;
                case 2:
                 break label$124;
                default:
                 break label$123;
                };
               }
               $3 = 0;
              }
              HEAP32[(($6 + 328 | 0) + 8 | 0) >> 2] = HEAP32[(($6 + 280 | 0) + 8 | 0) >> 2] | 0;
              HEAP8[($6 + 343 | 0) >> 0] = HEAPU8[($4 + 2 | 0) >> 0] | 0;
              i64toi32_i32$4 = $6;
              i64toi32_i32$5 = HEAP32[($6 + 280 | 0) >> 2] | 0;
              i64toi32_i32$0 = HEAP32[($6 + 284 | 0) >> 2] | 0;
              $1438 = i64toi32_i32$5;
              i64toi32_i32$5 = $6;
              HEAP32[($6 + 328 | 0) >> 2] = $1438;
              HEAP32[($6 + 332 | 0) >> 2] = i64toi32_i32$0;
              HEAP8[($6 + 340 | 0) >> 0] = $3;
              $103 = HEAPU8[$4 >> 0] | 0 | ((HEAPU8[($4 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
              HEAP8[($6 + 341 | 0) >> 0] = $103;
              HEAP8[($6 + 342 | 0) >> 0] = $103 >>> 8 | 0;
              break label$111;
             }
             if ($5) {
              break label$119
             }
             break label$112;
            }
            if ($5) {
             break label$112
            }
           }
           label$126 : {
            label$127 : {
             label$128 : {
              $4 = HEAP32[($6 + 320 | 0) >> 2] | 0;
              $11 = $4 >>> 0 < $15 >>> 0 ? -1 : ($4 | 0) != ($15 | 0);
              if ($11) {
               break label$128
              }
              $13 = $9 + -4 | 0;
              $5 = $15 << 2 | 0;
              $4 = $4 << 2 | 0;
              $8 = (HEAP32[($6 + 312 | 0) >> 2] | 0) + -4 | 0;
              label$129 : while (1) {
               label$130 : {
                if ($4) {
                 break label$130
                }
                $11 = $5 ? -1 : 0;
                break label$128;
               }
               if (!$5) {
                break label$127
               }
               $11 = $8 + $4 | 0;
               $2 = $13 + $5 | 0;
               $5 = $5 + -4 | 0;
               $4 = $4 + -4 | 0;
               $11 = HEAP32[$11 >> 2] | 0;
               $2 = HEAP32[$2 >> 2] | 0;
               $11 = $11 >>> 0 < $2 >>> 0 ? -1 : ($11 | 0) != ($2 | 0);
               if (!$11) {
                continue label$129
               }
               break label$129;
              };
             }
             label$131 : {
              switch ($11 + 1 | 0 | 0) {
              case 1:
               break label$126;
              case 2:
               break label$127;
              default:
               break label$131;
              };
             }
             $4 = 2;
             $5 = 0;
             label$132 : {
              label$133 : {
               switch ($12 & 3 | 0 | 0) {
               case 1:
                $5 = 1;
                $4 = 1;
                break label$132;
               case 2:
                break label$133;
               default:
                break label$132;
               };
              }
              $5 = 0;
              $4 = 0;
             }
             $11 = ($6 + 328 | 0) + 8 | 0;
             HEAP32[$11 >> 2] = $15;
             HEAP32[($6 + 332 | 0) >> 2] = $3;
             HEAP32[($6 + 328 | 0) >> 2] = $9;
             num_bigint__biguint__subtraction___impl_20core__ops__arith__SubAssign__num_bigint__biguint__BigUint__20for_20num_bigint__biguint__BigUint___sub_assign__h4ea1a97f3b7bcde9($6 + 328 | 0 | 0, $6 + 312 | 0 | 0);
             HEAP32[(($6 + 368 | 0) + 8 | 0) >> 2] = HEAP32[$11 >> 2] | 0;
             i64toi32_i32$4 = $6;
             i64toi32_i32$0 = HEAP32[($6 + 328 | 0) >> 2] | 0;
             i64toi32_i32$5 = HEAP32[($6 + 332 | 0) >> 2] | 0;
             $1517 = i64toi32_i32$0;
             i64toi32_i32$0 = $6;
             HEAP32[($6 + 368 | 0) >> 2] = $1517;
             HEAP32[($6 + 372 | 0) >> 2] = i64toi32_i32$5;
             label$135 : {
              if ($5) {
               break label$135
              }
              $5 = HEAP32[($6 + 376 | 0) >> 2] | 0 ? $4 : 1;
              break label$113;
             }
             $3 = 0;
             HEAP32[($6 + 376 | 0) >> 2] = 0;
             $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend__T_2ccore__slice__iter__Iter_T_____spec_extend__h5cdab7a667860bc4($6 + 368 | 0 | 0, 1082816 | 0, 1082816 | 0);
             $5 = HEAP32[($6 + 376 | 0) >> 2] | 0;
             if (!$5) {
              break label$114
             }
             $4 = (($5 << 2 | 0) + (HEAP32[($6 + 368 | 0) >> 2] | 0) | 0) + -4 | 0;
             label$136 : while (1) {
              label$137 : {
               if (!(HEAP32[$4 >> 2] | 0)) {
                break label$137
               }
               $3 = $5;
               break label$114;
              }
              $5 = $5 + -1 | 0;
              HEAP32[($6 + 376 | 0) >> 2] = $5;
              $4 = $4 + -4 | 0;
              if ($5) {
               continue label$136
              }
              break label$114;
             };
            }
            HEAP32[($6 + 336 | 0) >> 2] = $15;
            HEAP32[($6 + 332 | 0) >> 2] = $3;
            HEAP32[($6 + 328 | 0) >> 2] = $9;
            num_bigint__biguint__subtraction___impl_20core__ops__arith__Sub_num_bigint__biguint__BigUint__20for_20_num_bigint__biguint__BigUint___sub__headfbdc5668069dd($6 + 368 | 0 | 0, $6 + 312 | 0 | 0, $6 + 328 | 0 | 0);
            label$138 : {
             if (($12 | 0) == (1 | 0)) {
              break label$138
             }
             $5 = HEAP32[($6 + 376 | 0) >> 2] | 0 ? $12 : 1;
             break label$115;
            }
            $3 = 0;
            HEAP32[($6 + 376 | 0) >> 2] = 0;
            $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend__T_2ccore__slice__iter__Iter_T_____spec_extend__h5cdab7a667860bc4($6 + 368 | 0 | 0, 1082816 | 0, 1082816 | 0);
            $5 = HEAP32[($6 + 376 | 0) >> 2] | 0;
            if (!$5) {
             break label$116
            }
            $4 = (($5 << 2 | 0) + (HEAP32[($6 + 368 | 0) >> 2] | 0) | 0) + -4 | 0;
            label$139 : while (1) {
             label$140 : {
              if (!(HEAP32[$4 >> 2] | 0)) {
               break label$140
              }
              $3 = $5;
              break label$116;
             }
             $5 = $5 + -1 | 0;
             HEAP32[($6 + 376 | 0) >> 2] = $5;
             $4 = $4 + -4 | 0;
             if ($5) {
              continue label$139
             }
             break label$116;
            };
           }
           i64toi32_i32$0 = $6;
           i64toi32_i32$5 = 0;
           HEAP32[($6 + 332 | 0) >> 2] = 0;
           HEAP32[($6 + 336 | 0) >> 2] = i64toi32_i32$5;
           HEAP8[($6 + 340 | 0) >> 0] = 1;
           HEAP32[($6 + 328 | 0) >> 2] = HEAP32[(0 + 1082808 | 0) >> 2] | 0;
          }
          if (!$3) {
           break label$111
          }
          $5 = $3 << 2 | 0;
          if (!$5) {
           break label$111
          }
          __rust_dealloc($9 | 0, $5 | 0, 4 | 0);
          break label$111;
         }
         $5 = 1;
         $4 = HEAP32[($6 + 372 | 0) >> 2] | 0;
         if ($4 >>> 0 <= $3 >>> 0) {
          break label$115
         }
         if ($3 >>> 0 >= ($4 >>> 2 | 0) >>> 0) {
          break label$115
         }
         alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($6 + 368 | 0 | 0, $3 | 0);
        }
        HEAP32[(($6 + 328 | 0) + 8 | 0) >> 2] = HEAP32[(($6 + 368 | 0) + 8 | 0) >> 2] | 0;
        HEAP8[($6 + 340 | 0) >> 0] = $5;
        i64toi32_i32$4 = $6;
        i64toi32_i32$5 = HEAP32[($6 + 368 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[($6 + 372 | 0) >> 2] | 0;
        $1624 = i64toi32_i32$5;
        i64toi32_i32$5 = $6;
        HEAP32[($6 + 328 | 0) >> 2] = $1624;
        HEAP32[($6 + 332 | 0) >> 2] = i64toi32_i32$0;
        break label$111;
       }
       $5 = 1;
       $4 = HEAP32[($6 + 372 | 0) >> 2] | 0;
       if ($4 >>> 0 <= $3 >>> 0) {
        break label$113
       }
       if ($3 >>> 0 >= ($4 >>> 2 | 0) >>> 0) {
        break label$113
       }
       alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($6 + 368 | 0 | 0, $3 | 0);
      }
      HEAP32[(($6 + 328 | 0) + 8 | 0) >> 2] = HEAP32[(($6 + 368 | 0) + 8 | 0) >> 2] | 0;
      HEAP8[($6 + 340 | 0) >> 0] = $5;
      i64toi32_i32$4 = $6;
      i64toi32_i32$0 = HEAP32[($6 + 368 | 0) >> 2] | 0;
      i64toi32_i32$5 = HEAP32[($6 + 372 | 0) >> 2] | 0;
      $1648 = i64toi32_i32$0;
      i64toi32_i32$0 = $6;
      HEAP32[($6 + 328 | 0) >> 2] = $1648;
      HEAP32[($6 + 332 | 0) >> 2] = i64toi32_i32$5;
      break label$111;
     }
     HEAP32[(($6 + 328 | 0) + 8 | 0) >> 2] = HEAP32[(($6 + 280 | 0) + 8 | 0) >> 2] | 0;
     i64toi32_i32$4 = $6;
     i64toi32_i32$5 = HEAP32[($6 + 280 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($6 + 284 | 0) >> 2] | 0;
     $1658 = i64toi32_i32$5;
     i64toi32_i32$5 = $6;
     HEAP32[($6 + 328 | 0) >> 2] = $1658;
     HEAP32[($6 + 332 | 0) >> 2] = i64toi32_i32$0;
     num_bigint__biguint__addition___impl_20core__ops__arith__Add__num_bigint__biguint__BigUint__20for_20num_bigint__biguint__BigUint___add__ha6a5672f04e3ed65($6 + 368 | 0 | 0, $6 + 328 | 0 | 0, $6 + 312 | 0 | 0);
     label$141 : {
      label$142 : {
       if (($12 | 0) == (1 | 0)) {
        break label$142
       }
       $5 = HEAP32[($6 + 376 | 0) >> 2] | 0 ? $12 : 1;
       break label$141;
      }
      $3 = 0;
      HEAP32[($6 + 376 | 0) >> 2] = 0;
      $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend__T_2ccore__slice__iter__Iter_T_____spec_extend__h5cdab7a667860bc4($6 + 368 | 0 | 0, 1082816 | 0, 1082816 | 0);
      label$143 : {
       $5 = HEAP32[($6 + 376 | 0) >> 2] | 0;
       if (!$5) {
        break label$143
       }
       $4 = (($5 << 2 | 0) + (HEAP32[($6 + 368 | 0) >> 2] | 0) | 0) + -4 | 0;
       label$144 : while (1) {
        label$145 : {
         if (!(HEAP32[$4 >> 2] | 0)) {
          break label$145
         }
         $3 = $5;
         break label$143;
        }
        $5 = $5 + -1 | 0;
        HEAP32[($6 + 376 | 0) >> 2] = $5;
        $4 = $4 + -4 | 0;
        if ($5) {
         continue label$144
        }
        break label$144;
       };
      }
      $5 = 1;
      $4 = HEAP32[($6 + 372 | 0) >> 2] | 0;
      if ($4 >>> 0 <= $3 >>> 0) {
       break label$141
      }
      if ($3 >>> 0 >= ($4 >>> 2 | 0) >>> 0) {
       break label$141
      }
      alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($6 + 368 | 0 | 0, $3 | 0);
     }
     HEAP32[(($6 + 328 | 0) + 8 | 0) >> 2] = HEAP32[(($6 + 368 | 0) + 8 | 0) >> 2] | 0;
     HEAP8[($6 + 340 | 0) >> 0] = $5;
     i64toi32_i32$4 = $6;
     i64toi32_i32$0 = HEAP32[($6 + 368 | 0) >> 2] | 0;
     i64toi32_i32$5 = HEAP32[($6 + 372 | 0) >> 2] | 0;
     $1718 = i64toi32_i32$0;
     i64toi32_i32$0 = $6;
     HEAP32[($6 + 328 | 0) >> 2] = $1718;
     HEAP32[($6 + 332 | 0) >> 2] = i64toi32_i32$5;
    }
    num_bigint__bigint__division___impl_20core__ops__arith__Div_i32__20for_20num_bigint__bigint__BigInt___div__he39ea57e2d8da458($6 + 368 | 0 | 0, $6 + 328 | 0 | 0, 2 | 0);
    $9 = HEAPU8[($6 + 228 | 0) >> 0] | 0;
    $2 = HEAP32[($6 + 216 | 0) >> 2] | 0;
    $3 = HEAP32[($6 + 224 | 0) >> 2] | 0;
    alloc__raw_vec__RawVec_T_2cA___allocate_in__hb0817f92bbb8999a($6 + 24 | 0 | 0, $3 | 0, 0 | 0);
    $11 = HEAP32[($6 + 28 | 0) >> 2] | 0;
    $5 = HEAP32[($6 + 24 | 0) >> 2] | 0;
    $4 = $3 << 2 | 0;
    $2 = memcpy($5 | 0, $2 | 0, $4 | 0) | 0;
    HEAP32[($6 + 336 | 0) >> 2] = $3;
    HEAP32[($6 + 332 | 0) >> 2] = $11;
    HEAP32[($6 + 328 | 0) >> 2] = $2;
    label$146 : {
     if (!$3) {
      break label$146
     }
     i64toi32_i32$5 = 0;
     $18 = 0;
     $18$hi = i64toi32_i32$5;
     label$147 : while (1) {
      $1750 = $5;
      i64toi32_i32$4 = $5;
      i64toi32_i32$5 = HEAP32[$5 >> 2] | 0;
      i64toi32_i32$0 = 0;
      i64toi32_i32$4 = i64toi32_i32$5;
      i64toi32_i32$5 = 0;
      i64toi32_i32$2 = 1;
      i64toi32_i32$1 = i64toi32_i32$2 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
       i64toi32_i32$5 = i64toi32_i32$4 << i64toi32_i32$1 | 0;
       $104 = 0;
      } else {
       i64toi32_i32$5 = ((1 << i64toi32_i32$1 | 0) - 1 | 0) & (i64toi32_i32$4 >>> (32 - i64toi32_i32$1 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$1 | 0) | 0;
       $104 = i64toi32_i32$4 << i64toi32_i32$1 | 0;
      }
      $1753$hi = i64toi32_i32$5;
      i64toi32_i32$5 = $18$hi;
      i64toi32_i32$5 = $1753$hi;
      i64toi32_i32$0 = $104;
      i64toi32_i32$4 = $18$hi;
      i64toi32_i32$2 = $18;
      i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
      i64toi32_i32$3 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
      if (i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0) {
       i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
      }
      $18 = i64toi32_i32$1;
      $18$hi = i64toi32_i32$3;
      HEAP32[$1750 >> 2] = i64toi32_i32$1;
      $5 = $5 + 4 | 0;
      i64toi32_i32$5 = i64toi32_i32$1;
      i64toi32_i32$0 = 0;
      i64toi32_i32$2 = 32;
      i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
       i64toi32_i32$0 = 0;
       $105 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
      } else {
       i64toi32_i32$0 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
       $105 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$4 | 0) | 0;
      }
      $18 = $105;
      $18$hi = i64toi32_i32$0;
      $4 = $4 + -4 | 0;
      if ($4) {
       continue label$147
      }
      break label$147;
     };
     i64toi32_i32$0 = $18$hi;
     $5 = $18;
     if (!$5) {
      break label$146
     }
     label$148 : {
      label$149 : {
       if (($3 | 0) == ($11 | 0)) {
        break label$149
       }
       $4 = HEAP32[($6 + 336 | 0) >> 2] | 0;
       break label$148;
      }
      label$150 : {
       if ((HEAP32[($6 + 332 | 0) >> 2] | 0 | 0) != ($3 | 0)) {
        break label$150
       }
       alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h90c9768825cdae1b($6 + 328 | 0 | 0, $3 | 0, 1 | 0);
      }
      $4 = HEAP32[($6 + 336 | 0) >> 2] | 0;
      $3 = $4;
     }
     HEAP32[((HEAP32[($6 + 328 | 0) >> 2] | 0) + ($3 << 2 | 0) | 0) >> 2] = $5;
     HEAP32[($6 + 336 | 0) >> 2] = $4 + 1 | 0;
    }
    HEAP32[(($6 + 352 | 0) + 8 | 0) >> 2] = HEAP32[(($6 + 328 | 0) + 8 | 0) >> 2] | 0;
    i64toi32_i32$3 = $6;
    i64toi32_i32$0 = HEAP32[($6 + 328 | 0) >> 2] | 0;
    i64toi32_i32$5 = HEAP32[($6 + 332 | 0) >> 2] | 0;
    $1801 = i64toi32_i32$0;
    i64toi32_i32$0 = $6;
    HEAP32[($6 + 352 | 0) >> 2] = $1801;
    HEAP32[($6 + 356 | 0) >> 2] = i64toi32_i32$5;
    label$151 : {
     label$152 : {
      if (($9 & 255 | 0 | 0) == (1 | 0)) {
       break label$152
      }
      $5 = HEAP32[($6 + 360 | 0) >> 2] | 0 ? $9 : 1;
      break label$151;
     }
     $3 = 0;
     HEAP32[($6 + 360 | 0) >> 2] = 0;
     $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend__T_2ccore__slice__iter__Iter_T_____spec_extend__h5cdab7a667860bc4($6 + 352 | 0 | 0, 1082816 | 0, 1082816 | 0);
     label$153 : {
      $5 = HEAP32[($6 + 360 | 0) >> 2] | 0;
      if (!$5) {
       break label$153
      }
      $4 = (($5 << 2 | 0) + (HEAP32[($6 + 352 | 0) >> 2] | 0) | 0) + -4 | 0;
      label$154 : while (1) {
       label$155 : {
        if (!(HEAP32[$4 >> 2] | 0)) {
         break label$155
        }
        $3 = $5;
        break label$153;
       }
       $5 = $5 + -1 | 0;
       HEAP32[($6 + 360 | 0) >> 2] = $5;
       $4 = $4 + -4 | 0;
       if ($5) {
        continue label$154
       }
       break label$154;
      };
     }
     $5 = 1;
     $4 = HEAP32[($6 + 356 | 0) >> 2] | 0;
     if ($4 >>> 0 <= $3 >>> 0) {
      break label$151
     }
     if ($3 >>> 0 >= ($4 >>> 2 | 0) >>> 0) {
      break label$151
     }
     alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($6 + 352 | 0 | 0, $3 | 0);
    }
    HEAP32[(($6 + 328 | 0) + 8 | 0) >> 2] = HEAP32[(($6 + 352 | 0) + 8 | 0) >> 2] | 0;
    HEAP8[($6 + 340 | 0) >> 0] = $5;
    i64toi32_i32$3 = $6;
    i64toi32_i32$5 = HEAP32[($6 + 352 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($6 + 356 | 0) >> 2] | 0;
    $1856 = i64toi32_i32$5;
    i64toi32_i32$5 = $6;
    HEAP32[($6 + 328 | 0) >> 2] = $1856;
    HEAP32[($6 + 332 | 0) >> 2] = i64toi32_i32$0;
    num_bigint__bigint__addition___impl_20core__ops__arith__Add_20for_20num_bigint__bigint__BigInt___add__ha39524fef59942b1($6 + 280 | 0 | 0, $6 + 368 | 0 | 0, $6 + 328 | 0 | 0);
    num_bigint__bigint__subtraction___impl_20core__ops__arith__Sub__num_bigint__bigint__BigInt__20for_20_num_bigint__bigint__BigInt___sub__h41405c4b9a5a6fac($6 + 328 | 0 | 0, $6 + 296 | 0 | 0, $6 + 216 | 0 | 0);
    $4 = HEAP32[($6 + 320 | 0) >> 2] | 0;
    $11 = HEAP32[($6 + 316 | 0) >> 2] | 0;
    i64toi32_i32$5 = $6;
    i64toi32_i32$0 = 0;
    HEAP32[($6 + 316 | 0) >> 2] = 0;
    HEAP32[($6 + 320 | 0) >> 2] = i64toi32_i32$0;
    $2 = HEAP32[($6 + 312 | 0) >> 2] | 0;
    $3 = HEAP32[(0 + 1082808 | 0) >> 2] | 0;
    HEAP32[($6 + 312 | 0) >> 2] = $3;
    $9 = HEAPU8[($6 + 324 | 0) >> 0] | 0;
    HEAP8[($6 + 324 | 0) >> 0] = 1;
    $5 = $6 + 325 | 0;
    label$156 : {
     label$157 : {
      $13 = HEAPU8[($6 + 340 | 0) >> 0] | 0;
      if (($13 | 0) != (1 | 0)) {
       break label$157
      }
      HEAP8[(($6 + 368 | 0) + 2 | 0) >> 0] = HEAPU8[($5 + 2 | 0) >> 0] | 0;
      HEAP16[($6 + 368 | 0) >> 1] = HEAPU8[$5 >> 0] | 0 | ((HEAPU8[($5 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
      break label$156;
     }
     label$158 : {
      label$159 : {
       label$160 : {
        label$161 : {
         label$162 : {
          label$163 : {
           label$164 : {
            label$165 : {
             switch ($9 | 0) {
             case 2:
              if ($13) {
               break label$164
              }
              break label$162;
             case 1:
              break label$163;
             default:
              break label$165;
             };
            }
            if ($13) {
             break label$162
            }
           }
           HEAP32[($6 + 376 | 0) >> 2] = $4;
           HEAP32[($6 + 372 | 0) >> 2] = $11;
           HEAP32[($6 + 368 | 0) >> 2] = $2;
           num_bigint__biguint__addition___impl_20core__ops__arith__Add__num_bigint__biguint__BigUint__20for_20num_bigint__biguint__BigUint___add__ha6a5672f04e3ed65($6 + 352 | 0 | 0, $6 + 368 | 0 | 0, $6 + 328 | 0 | 0);
           $4 = HEAP32[($6 + 360 | 0) >> 2] | 0;
           $9 = $4 ? $9 : 1;
           break label$158;
          }
          $4 = HEAP32[($6 + 328 | 0) >> 2] | 0;
          $15 = HEAP32[($6 + 336 | 0) >> 2] | 0;
          alloc__raw_vec__RawVec_T_2cA___allocate_in__hb0817f92bbb8999a($6 + 16 | 0 | 0, $15 | 0, 0 | 0);
          $8 = HEAP32[($6 + 20 | 0) >> 2] | 0;
          $14 = HEAP32[($6 + 16 | 0) >> 2] | 0;
          memcpy($14 | 0, $4 | 0, $15 << 2 | 0 | 0) | 0;
          $12 = $13;
          break label$161;
         }
         label$167 : {
          label$168 : {
           $15 = HEAP32[($6 + 336 | 0) >> 2] | 0;
           $8 = $4 >>> 0 < $15 >>> 0 ? -1 : ($4 | 0) != ($15 | 0);
           if ($8) {
            break label$168
           }
           $16 = (HEAP32[($6 + 328 | 0) >> 2] | 0) + -4 | 0;
           $15 = $15 << 2 | 0;
           $12 = $4 << 2 | 0;
           $17 = $2 + -4 | 0;
           label$169 : while (1) {
            label$170 : {
             if ($12) {
              break label$170
             }
             $8 = $15 ? -1 : 0;
             break label$168;
            }
            if (!$15) {
             break label$167
            }
            $8 = $17 + $12 | 0;
            $14 = $16 + $15 | 0;
            $15 = $15 + -4 | 0;
            $12 = $12 + -4 | 0;
            $8 = HEAP32[$8 >> 2] | 0;
            $14 = HEAP32[$14 >> 2] | 0;
            $8 = $8 >>> 0 < $14 >>> 0 ? -1 : ($8 | 0) != ($14 | 0);
            if (!$8) {
             continue label$169
            }
            break label$169;
           };
          }
          $12 = 1;
          $14 = $3;
          $15 = $8;
          label$171 : {
           switch ($15 + 1 | 0 | 0) {
           case 1:
            break label$161;
           case 2:
            break label$167;
           default:
            break label$171;
           };
          }
          HEAP32[($6 + 376 | 0) >> 2] = $4;
          HEAP32[($6 + 372 | 0) >> 2] = $11;
          HEAP32[($6 + 368 | 0) >> 2] = $2;
          num_bigint__biguint__subtraction___impl_20core__ops__arith__Sub_num_bigint__biguint__BigUint__20for_20_num_bigint__biguint__BigUint___sub__headfbdc5668069dd($6 + 352 | 0 | 0, $6 + 328 | 0 | 0, $6 + 368 | 0 | 0);
          $4 = HEAP32[($6 + 360 | 0) >> 2] | 0;
          $9 = $4 ? $13 : 1;
          break label$158;
         }
         $15 = ($6 + 368 | 0) + 8 | 0;
         HEAP32[$15 >> 2] = $4;
         HEAP32[($6 + 372 | 0) >> 2] = $11;
         HEAP32[($6 + 368 | 0) >> 2] = $2;
         num_bigint__biguint__subtraction___impl_20core__ops__arith__SubAssign__num_bigint__biguint__BigUint__20for_20num_bigint__biguint__BigUint___sub_assign__h4ea1a97f3b7bcde9($6 + 368 | 0 | 0, $6 + 328 | 0 | 0);
         HEAP32[(($6 + 352 | 0) + 8 | 0) >> 2] = HEAP32[$15 >> 2] | 0;
         i64toi32_i32$3 = $6;
         i64toi32_i32$0 = HEAP32[($6 + 368 | 0) >> 2] | 0;
         i64toi32_i32$5 = HEAP32[($6 + 372 | 0) >> 2] | 0;
         $2022 = i64toi32_i32$0;
         i64toi32_i32$0 = $6;
         HEAP32[($6 + 352 | 0) >> 2] = $2022;
         HEAP32[($6 + 356 | 0) >> 2] = i64toi32_i32$5;
         label$172 : {
          if (($9 | 0) == (1 | 0)) {
           break label$172
          }
          $4 = HEAP32[($6 + 360 | 0) >> 2] | 0;
          $9 = $4 ? $9 : 1;
          break label$159;
         }
         $4 = 0;
         HEAP32[($6 + 360 | 0) >> 2] = 0;
         $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend__T_2ccore__slice__iter__Iter_T_____spec_extend__h5cdab7a667860bc4($6 + 352 | 0 | 0, 1082816 | 0, 1082816 | 0);
         $9 = HEAP32[($6 + 360 | 0) >> 2] | 0;
         if (!$9) {
          break label$160
         }
         $11 = (($9 << 2 | 0) + (HEAP32[($6 + 352 | 0) >> 2] | 0) | 0) + -4 | 0;
         label$173 : while (1) {
          label$174 : {
           if (!(HEAP32[$11 >> 2] | 0)) {
            break label$174
           }
           $4 = $9;
           break label$160;
          }
          $9 = $9 + -1 | 0;
          HEAP32[($6 + 360 | 0) >> 2] = $9;
          $11 = $11 + -4 | 0;
          if ($9) {
           continue label$173
          }
          break label$160;
         };
        }
        label$175 : {
         if (!$11) {
          break label$175
         }
         $4 = $11 << 2 | 0;
         if (!$4) {
          break label$175
         }
         __rust_dealloc($2 | 0, $4 | 0, 4 | 0);
        }
        $2 = $14;
        $11 = $8;
        $4 = $15;
        $9 = $12;
        break label$156;
       }
       $9 = 1;
       $11 = HEAP32[($6 + 356 | 0) >> 2] | 0;
       if ($11 >>> 0 <= $4 >>> 0) {
        break label$159
       }
       if ($4 >>> 0 >= ($11 >>> 2 | 0) >>> 0) {
        break label$159
       }
       alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($6 + 352 | 0 | 0, $4 | 0);
       $4 = HEAP32[($6 + 360 | 0) >> 2] | 0;
      }
      $11 = HEAP32[($6 + 356 | 0) >> 2] | 0;
      $2 = HEAP32[($6 + 352 | 0) >> 2] | 0;
      break label$156;
     }
     $2 = HEAP32[($6 + 352 | 0) >> 2] | 0;
     $11 = HEAP32[($6 + 356 | 0) >> 2] | 0;
    }
    label$176 : {
     $15 = HEAP32[($6 + 316 | 0) >> 2] | 0;
     if (!$15) {
      break label$176
     }
     $15 = $15 << 2 | 0;
     if (!$15) {
      break label$176
     }
     __rust_dealloc(HEAP32[($6 + 312 | 0) >> 2] | 0 | 0, $15 | 0, 4 | 0);
    }
    $106 = HEAPU16[($6 + 368 | 0) >> 1] | 0;
    HEAP8[$5 >> 0] = $106;
    HEAP8[($5 + 1 | 0) >> 0] = $106 >>> 8 | 0;
    HEAP8[($5 + 2 | 0) >> 0] = HEAPU8[(($6 + 368 | 0) + 2 | 0) >> 0] | 0;
    HEAP8[($6 + 324 | 0) >> 0] = $9;
    HEAP32[($6 + 320 | 0) >> 2] = $4;
    HEAP32[($6 + 316 | 0) >> 2] = $11;
    HEAP32[($6 + 312 | 0) >> 2] = $2;
    label$177 : {
     $5 = HEAP32[($6 + 332 | 0) >> 2] | 0;
     if (!$5) {
      break label$177
     }
     $5 = $5 << 2 | 0;
     if (!$5) {
      break label$177
     }
     __rust_dealloc(HEAP32[($6 + 328 | 0) >> 2] | 0 | 0, $5 | 0, 4 | 0);
    }
    $5 = ($6 + 296 | 0) + 8 | 0;
    i64toi32_i32$3 = $5;
    i64toi32_i32$5 = HEAP32[$5 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($5 + 4 | 0) >> 2] | 0;
    $19 = i64toi32_i32$5;
    $19$hi = i64toi32_i32$0;
    i64toi32_i32$5 = ($6 + 352 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$5 >> 2] = $19;
    HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$3 = $6;
    i64toi32_i32$0 = HEAP32[($6 + 296 | 0) >> 2] | 0;
    i64toi32_i32$5 = HEAP32[($6 + 300 | 0) >> 2] | 0;
    $18 = i64toi32_i32$0;
    $18$hi = i64toi32_i32$5;
    HEAP32[($6 + 296 | 0) >> 2] = $3;
    i64toi32_i32$0 = $6;
    HEAP32[($6 + 352 | 0) >> 2] = $18;
    HEAP32[($6 + 356 | 0) >> 2] = i64toi32_i32$5;
    i64toi32_i32$0 = $6;
    i64toi32_i32$5 = 0;
    HEAP32[($6 + 300 | 0) >> 2] = 0;
    HEAP32[($6 + 304 | 0) >> 2] = i64toi32_i32$5;
    HEAP8[($6 + 308 | 0) >> 0] = 1;
    i64toi32_i32$5 = $19$hi;
    i64toi32_i32$0 = ($6 + 328 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $19;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$5;
    i64toi32_i32$5 = $18$hi;
    i64toi32_i32$0 = $6;
    HEAP32[($6 + 328 | 0) >> 2] = $18;
    HEAP32[($6 + 332 | 0) >> 2] = i64toi32_i32$5;
    num_bigint__bigint__subtraction___impl_20core__ops__arith__Sub__num_bigint__bigint__BigInt__20for_20num_bigint__bigint__BigInt___sub__h0804349f9fe4b776($6 + 368 | 0 | 0, $6 + 328 | 0 | 0, $6 + 280 | 0 | 0);
    label$178 : {
     $4 = HEAP32[($6 + 300 | 0) >> 2] | 0;
     if (!$4) {
      break label$178
     }
     $4 = $4 << 2 | 0;
     if (!$4) {
      break label$178
     }
     __rust_dealloc(HEAP32[($6 + 296 | 0) >> 2] | 0 | 0, $4 | 0, 4 | 0);
    }
    $4 = ($6 + 368 | 0) + 8 | 0;
    i64toi32_i32$3 = $4;
    i64toi32_i32$5 = HEAP32[$4 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($4 + 4 | 0) >> 2] | 0;
    $2172 = i64toi32_i32$5;
    i64toi32_i32$5 = $5;
    HEAP32[$5 >> 2] = $2172;
    HEAP32[($5 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$3 = $6;
    i64toi32_i32$0 = HEAP32[($6 + 368 | 0) >> 2] | 0;
    i64toi32_i32$5 = HEAP32[($6 + 372 | 0) >> 2] | 0;
    $2175 = i64toi32_i32$0;
    i64toi32_i32$0 = $6;
    HEAP32[($6 + 296 | 0) >> 2] = $2175;
    HEAP32[($6 + 300 | 0) >> 2] = i64toi32_i32$5;
    i64toi32_i32$3 = ($6 + 200 | 0) + 8 | 0;
    i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $2180 = i64toi32_i32$5;
    i64toi32_i32$5 = $4;
    HEAP32[i64toi32_i32$5 >> 2] = $2180;
    HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$3 = $6;
    i64toi32_i32$0 = HEAP32[($6 + 200 | 0) >> 2] | 0;
    i64toi32_i32$5 = HEAP32[($6 + 204 | 0) >> 2] | 0;
    $2183 = i64toi32_i32$0;
    i64toi32_i32$0 = $6;
    HEAP32[($6 + 368 | 0) >> 2] = $2183;
    HEAP32[($6 + 372 | 0) >> 2] = i64toi32_i32$5;
    $5 = HEAPU8[($6 + 308 | 0) >> 0] | 0;
    $4 = HEAP32[($6 + 296 | 0) >> 2] | 0;
    label$179 : {
     label$180 : {
      i64toi32_i32$3 = $6;
      i64toi32_i32$5 = HEAP32[($6 + 300 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($6 + 304 | 0) >> 2] | 0;
      $18 = i64toi32_i32$5;
      $18$hi = i64toi32_i32$0;
      i64toi32_i32$3 = i64toi32_i32$5;
      i64toi32_i32$5 = 1;
      i64toi32_i32$2 = 0;
      if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$3 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0) {
       break label$180
      }
      i64toi32_i32$3 = $18$hi;
      i64toi32_i32$0 = $6 + 336 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $18;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
      HEAP32[($6 + 332 | 0) >> 2] = $4;
      HEAP32[($6 + 328 | 0) >> 2] = 1;
      num_bigint__biguint__shift__biguint_shl2__h51620e0a9215508c($6 + 352 | 0 | 0, $6 + 328 | 0 | 0, $10 | 0, 0 | 0);
      break label$179;
     }
     i64toi32_i32$3 = $18$hi;
     i64toi32_i32$0 = $6;
     HEAP32[($6 + 356 | 0) >> 2] = $18;
     HEAP32[($6 + 360 | 0) >> 2] = i64toi32_i32$3;
     HEAP32[($6 + 352 | 0) >> 2] = $4;
    }
    label$181 : {
     label$182 : {
      if (($5 & 255 | 0 | 0) == (1 | 0)) {
       break label$182
      }
      $5 = HEAP32[($6 + 360 | 0) >> 2] | 0 ? $5 : 1;
      break label$181;
     }
     $9 = 0;
     HEAP32[($6 + 360 | 0) >> 2] = 0;
     $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend__T_2ccore__slice__iter__Iter_T_____spec_extend__h5cdab7a667860bc4($6 + 352 | 0 | 0, 1082816 | 0, 1082816 | 0);
     label$183 : {
      $5 = HEAP32[($6 + 360 | 0) >> 2] | 0;
      if (!$5) {
       break label$183
      }
      $4 = (($5 << 2 | 0) + (HEAP32[($6 + 352 | 0) >> 2] | 0) | 0) + -4 | 0;
      label$184 : while (1) {
       label$185 : {
        if (!(HEAP32[$4 >> 2] | 0)) {
         break label$185
        }
        $9 = $5;
        break label$183;
       }
       $5 = $5 + -1 | 0;
       HEAP32[($6 + 360 | 0) >> 2] = $5;
       $4 = $4 + -4 | 0;
       if ($5) {
        continue label$184
       }
       break label$184;
      };
     }
     $5 = 1;
     $4 = HEAP32[($6 + 356 | 0) >> 2] | 0;
     if ($4 >>> 0 <= $9 >>> 0) {
      break label$181
     }
     if ($9 >>> 0 >= ($4 >>> 2 | 0) >>> 0) {
      break label$181
     }
     alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($6 + 352 | 0 | 0, $9 | 0);
    }
    $9 = ($6 + 328 | 0) + 8 | 0;
    HEAP32[$9 >> 2] = HEAP32[(($6 + 352 | 0) + 8 | 0) >> 2] | 0;
    HEAP8[($6 + 340 | 0) >> 0] = $5;
    i64toi32_i32$2 = $6;
    i64toi32_i32$3 = HEAP32[($6 + 352 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($6 + 356 | 0) >> 2] | 0;
    $2262 = i64toi32_i32$3;
    i64toi32_i32$3 = $6;
    HEAP32[($6 + 328 | 0) >> 2] = $2262;
    HEAP32[($6 + 332 | 0) >> 2] = i64toi32_i32$0;
    num_bigint__bigint__addition___impl_20core__ops__arith__Add_20for_20num_bigint__bigint__BigInt___add__ha39524fef59942b1($6 + 352 | 0 | 0, $6 + 368 | 0 | 0, $6 + 328 | 0 | 0);
    $5 = HEAPU8[($6 + 324 | 0) >> 0] | 0;
    $4 = HEAP32[($6 + 312 | 0) >> 2] | 0;
    label$186 : {
     label$187 : {
      i64toi32_i32$2 = $6;
      i64toi32_i32$0 = HEAP32[($6 + 316 | 0) >> 2] | 0;
      i64toi32_i32$3 = HEAP32[($6 + 320 | 0) >> 2] | 0;
      $18 = i64toi32_i32$0;
      $18$hi = i64toi32_i32$3;
      i64toi32_i32$2 = i64toi32_i32$0;
      i64toi32_i32$0 = 1;
      i64toi32_i32$5 = 0;
      if (i64toi32_i32$3 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0 | 0) | 0) {
       break label$187
      }
      i64toi32_i32$2 = $18$hi;
      i64toi32_i32$3 = $9;
      HEAP32[i64toi32_i32$3 >> 2] = $18;
      HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
      HEAP32[($6 + 332 | 0) >> 2] = $4;
      HEAP32[($6 + 328 | 0) >> 2] = 1;
      num_bigint__biguint__shift__biguint_shl2__h51620e0a9215508c($6 + 368 | 0 | 0, $6 + 328 | 0 | 0, $10 << 1 | 0 | 0, 0 | 0);
      break label$186;
     }
     i64toi32_i32$2 = $18$hi;
     i64toi32_i32$3 = $6;
     HEAP32[($6 + 372 | 0) >> 2] = $18;
     HEAP32[($6 + 376 | 0) >> 2] = i64toi32_i32$2;
     HEAP32[($6 + 368 | 0) >> 2] = $4;
    }
    label$188 : {
     label$189 : {
      if (($5 & 255 | 0 | 0) == (1 | 0)) {
       break label$189
      }
      $5 = HEAP32[($6 + 376 | 0) >> 2] | 0 ? $5 : 1;
      break label$188;
     }
     $9 = 0;
     HEAP32[($6 + 376 | 0) >> 2] = 0;
     $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend__T_2ccore__slice__iter__Iter_T_____spec_extend__h5cdab7a667860bc4($6 + 368 | 0 | 0, 1082816 | 0, 1082816 | 0);
     label$190 : {
      $5 = HEAP32[($6 + 376 | 0) >> 2] | 0;
      if (!$5) {
       break label$190
      }
      $4 = (($5 << 2 | 0) + (HEAP32[($6 + 368 | 0) >> 2] | 0) | 0) + -4 | 0;
      label$191 : while (1) {
       label$192 : {
        if (!(HEAP32[$4 >> 2] | 0)) {
         break label$192
        }
        $9 = $5;
        break label$190;
       }
       $5 = $5 + -1 | 0;
       HEAP32[($6 + 376 | 0) >> 2] = $5;
       $4 = $4 + -4 | 0;
       if ($5) {
        continue label$191
       }
       break label$191;
      };
     }
     $5 = 1;
     $4 = HEAP32[($6 + 372 | 0) >> 2] | 0;
     if ($4 >>> 0 <= $9 >>> 0) {
      break label$188
     }
     if ($9 >>> 0 >= ($4 >>> 2 | 0) >>> 0) {
      break label$188
     }
     alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($6 + 368 | 0 | 0, $9 | 0);
    }
    HEAP32[(($6 + 328 | 0) + 8 | 0) >> 2] = HEAP32[(($6 + 368 | 0) + 8 | 0) >> 2] | 0;
    HEAP8[($6 + 340 | 0) >> 0] = $5;
    i64toi32_i32$5 = $6;
    i64toi32_i32$2 = HEAP32[($6 + 368 | 0) >> 2] | 0;
    i64toi32_i32$3 = HEAP32[($6 + 372 | 0) >> 2] | 0;
    $2346 = i64toi32_i32$2;
    i64toi32_i32$2 = $6;
    HEAP32[($6 + 328 | 0) >> 2] = $2346;
    HEAP32[($6 + 332 | 0) >> 2] = i64toi32_i32$3;
    num_bigint__bigint__addition___impl_20core__ops__arith__Add_20for_20num_bigint__bigint__BigInt___add__ha39524fef59942b1($6 + 368 | 0 | 0, $6 + 352 | 0 | 0, $6 + 328 | 0 | 0);
    $5 = HEAPU8[($6 + 292 | 0) >> 0] | 0;
    $4 = HEAP32[($6 + 280 | 0) >> 2] | 0;
    label$193 : {
     label$194 : {
      label$195 : {
       label$196 : {
        label$197 : {
         i64toi32_i32$5 = $6;
         i64toi32_i32$3 = HEAP32[($6 + 284 | 0) >> 2] | 0;
         i64toi32_i32$2 = HEAP32[($6 + 288 | 0) >> 2] | 0;
         $18 = i64toi32_i32$3;
         $18$hi = i64toi32_i32$2;
         i64toi32_i32$5 = i64toi32_i32$3;
         i64toi32_i32$3 = 1;
         i64toi32_i32$0 = 0;
         if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$5 >>> 0 < i64toi32_i32$0 >>> 0 | 0) | 0) {
          break label$197
         }
         i64toi32_i32$5 = 0;
         i64toi32_i32$2 = 0;
         i64toi32_i32$2 = __wasm_i64_mul($10 | 0, i64toi32_i32$5 | 0, 96 | 0, i64toi32_i32$2 | 0) | 0;
         i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
         $19 = i64toi32_i32$2;
         $19$hi = i64toi32_i32$5;
         i64toi32_i32$0 = i64toi32_i32$2;
         i64toi32_i32$2 = 32;
         i64toi32_i32$3 = 0;
         if (i64toi32_i32$5 >>> 0 > i64toi32_i32$2 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$0 >>> 0 >= i64toi32_i32$3 >>> 0 | 0) | 0) {
          break label$195
         }
         i64toi32_i32$0 = $18$hi;
         i64toi32_i32$5 = $6 + 336 | 0;
         HEAP32[i64toi32_i32$5 >> 2] = $18;
         HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
         HEAP32[($6 + 332 | 0) >> 2] = $4;
         HEAP32[($6 + 328 | 0) >> 2] = 1;
         $2373 = $6 + 352 | 0;
         $2375 = $6 + 328 | 0;
         i64toi32_i32$0 = $19$hi;
         i64toi32_i32$3 = $19;
         i64toi32_i32$5 = 0;
         i64toi32_i32$2 = 5;
         i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
          i64toi32_i32$5 = 0;
          $107 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
         } else {
          i64toi32_i32$5 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
          $107 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$4 | 0) | 0;
         }
         num_bigint__biguint__shift__biguint_shl2__h51620e0a9215508c($2373 | 0, $2375 | 0, $107 | 0, 0 | 0);
         break label$196;
        }
        i64toi32_i32$5 = $18$hi;
        i64toi32_i32$3 = $6;
        HEAP32[($6 + 356 | 0) >> 2] = $18;
        HEAP32[($6 + 360 | 0) >> 2] = i64toi32_i32$5;
        HEAP32[($6 + 352 | 0) >> 2] = $4;
       }
       label$198 : {
        if (($5 & 255 | 0 | 0) == (1 | 0)) {
         break label$198
        }
        $5 = HEAP32[($6 + 360 | 0) >> 2] | 0 ? $5 : 1;
        break label$193;
       }
       $9 = 0;
       HEAP32[($6 + 360 | 0) >> 2] = 0;
       $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend__T_2ccore__slice__iter__Iter_T_____spec_extend__h5cdab7a667860bc4($6 + 352 | 0 | 0, 1082816 | 0, 1082816 | 0);
       $5 = HEAP32[($6 + 360 | 0) >> 2] | 0;
       if (!$5) {
        break label$194
       }
       $4 = (($5 << 2 | 0) + (HEAP32[($6 + 352 | 0) >> 2] | 0) | 0) + -4 | 0;
       label$199 : while (1) {
        label$200 : {
         if (!(HEAP32[$4 >> 2] | 0)) {
          break label$200
         }
         $9 = $5;
         break label$194;
        }
        $5 = $5 + -1 | 0;
        HEAP32[($6 + 360 | 0) >> 2] = $5;
        $4 = $4 + -4 | 0;
        if ($5) {
         continue label$199
        }
        break label$194;
       };
      }
      core__option__expect_failed__h66afff61e82fdd86(1083242 | 0, 17 | 0, 1083260 | 0);
      abort();
     }
     $5 = 1;
     $4 = HEAP32[($6 + 356 | 0) >> 2] | 0;
     if ($4 >>> 0 <= $9 >>> 0) {
      break label$193
     }
     if ($9 >>> 0 >= ($4 >>> 2 | 0) >>> 0) {
      break label$193
     }
     alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($6 + 352 | 0 | 0, $9 | 0);
    }
    HEAP32[(($6 + 328 | 0) + 8 | 0) >> 2] = HEAP32[(($6 + 352 | 0) + 8 | 0) >> 2] | 0;
    HEAP8[($6 + 340 | 0) >> 0] = $5;
    i64toi32_i32$0 = $6;
    i64toi32_i32$5 = HEAP32[($6 + 352 | 0) >> 2] | 0;
    i64toi32_i32$3 = HEAP32[($6 + 356 | 0) >> 2] | 0;
    $2437 = i64toi32_i32$5;
    i64toi32_i32$5 = $6;
    HEAP32[($6 + 328 | 0) >> 2] = $2437;
    HEAP32[($6 + 332 | 0) >> 2] = i64toi32_i32$3;
    num_bigint__bigint__addition___impl_20core__ops__arith__Add_20for_20num_bigint__bigint__BigInt___add__ha39524fef59942b1($6 + 352 | 0 | 0, $6 + 368 | 0 | 0, $6 + 328 | 0 | 0);
    $5 = HEAPU8[($6 + 228 | 0) >> 0] | 0;
    $4 = HEAP32[($6 + 216 | 0) >> 2] | 0;
    label$201 : {
     label$202 : {
      label$203 : {
       label$204 : {
        label$205 : {
         i64toi32_i32$0 = $6;
         i64toi32_i32$3 = HEAP32[($6 + 220 | 0) >> 2] | 0;
         i64toi32_i32$5 = HEAP32[($6 + 224 | 0) >> 2] | 0;
         $18 = i64toi32_i32$3;
         $18$hi = i64toi32_i32$5;
         i64toi32_i32$0 = i64toi32_i32$3;
         i64toi32_i32$3 = 1;
         i64toi32_i32$2 = 0;
         if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0) {
          break label$205
         }
         if ($7 >>> 0 >= -1073741827 >>> 0) {
          break label$203
         }
         i64toi32_i32$0 = $18$hi;
         i64toi32_i32$5 = $6 + 336 | 0;
         HEAP32[i64toi32_i32$5 >> 2] = $18;
         HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
         HEAP32[($6 + 332 | 0) >> 2] = $4;
         HEAP32[($6 + 328 | 0) >> 2] = 1;
         num_bigint__biguint__shift__biguint_shl2__h51620e0a9215508c($6 + 368 | 0 | 0, $6 + 328 | 0 | 0, $10 << 2 | 0 | 0, 0 | 0);
         break label$204;
        }
        i64toi32_i32$0 = $18$hi;
        i64toi32_i32$5 = $6;
        HEAP32[($6 + 372 | 0) >> 2] = $18;
        HEAP32[($6 + 376 | 0) >> 2] = i64toi32_i32$0;
        HEAP32[($6 + 368 | 0) >> 2] = $4;
       }
       label$206 : {
        if (($5 & 255 | 0 | 0) == (1 | 0)) {
         break label$206
        }
        $5 = HEAP32[($6 + 376 | 0) >> 2] | 0 ? $5 : 1;
        break label$201;
       }
       $10 = 0;
       HEAP32[($6 + 376 | 0) >> 2] = 0;
       $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend__T_2ccore__slice__iter__Iter_T_____spec_extend__h5cdab7a667860bc4($6 + 368 | 0 | 0, 1082816 | 0, 1082816 | 0);
       $5 = HEAP32[($6 + 376 | 0) >> 2] | 0;
       if (!$5) {
        break label$202
       }
       $4 = (($5 << 2 | 0) + (HEAP32[($6 + 368 | 0) >> 2] | 0) | 0) + -4 | 0;
       label$207 : while (1) {
        label$208 : {
         if (!(HEAP32[$4 >> 2] | 0)) {
          break label$208
         }
         $10 = $5;
         break label$202;
        }
        $5 = $5 + -1 | 0;
        HEAP32[($6 + 376 | 0) >> 2] = $5;
        $4 = $4 + -4 | 0;
        if ($5) {
         continue label$207
        }
        break label$202;
       };
      }
      core__option__expect_failed__h66afff61e82fdd86(1083242 | 0, 17 | 0, 1083260 | 0);
      abort();
     }
     $5 = 1;
     $4 = HEAP32[($6 + 372 | 0) >> 2] | 0;
     if ($4 >>> 0 <= $10 >>> 0) {
      break label$201
     }
     if ($10 >>> 0 >= ($4 >>> 2 | 0) >>> 0) {
      break label$201
     }
     alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($6 + 368 | 0 | 0, $10 | 0);
    }
    HEAP32[(($6 + 328 | 0) + 8 | 0) >> 2] = HEAP32[(($6 + 368 | 0) + 8 | 0) >> 2] | 0;
    HEAP8[($6 + 340 | 0) >> 0] = $5;
    i64toi32_i32$2 = $6;
    i64toi32_i32$0 = HEAP32[($6 + 368 | 0) >> 2] | 0;
    i64toi32_i32$5 = HEAP32[($6 + 372 | 0) >> 2] | 0;
    $2524 = i64toi32_i32$0;
    i64toi32_i32$0 = $6;
    HEAP32[($6 + 328 | 0) >> 2] = $2524;
    HEAP32[($6 + 332 | 0) >> 2] = i64toi32_i32$5;
    num_bigint__bigint__addition___impl_20core__ops__arith__Add_20for_20num_bigint__bigint__BigInt___add__ha39524fef59942b1($6 + 368 | 0 | 0, $6 + 352 | 0 | 0, $6 + 328 | 0 | 0);
    $5 = 0;
    $4 = 0;
    label$209 : {
     switch (HEAPU8[($6 + 380 | 0) >> 0] | 0 | 0) {
     case 2:
      $10 = HEAP32[($6 + 368 | 0) >> 2] | 0;
      $4 = HEAP32[($6 + 376 | 0) >> 2] | 0;
      alloc__raw_vec__RawVec_T_2cA___allocate_in__hb0817f92bbb8999a($6 + 8 | 0 | 0, $4 | 0, 0 | 0);
      $5 = HEAP32[($6 + 12 | 0) >> 2] | 0;
      $3 = HEAP32[($6 + 8 | 0) >> 2] | 0;
      if (!(memcpy($3 | 0, $10 | 0, $4 << 2 | 0 | 0) | 0)) {
       break label$3
      }
      break;
     case 1:
      break label$209;
     default:
      break label$3;
     };
    }
    num_bigint__biguint__addition__add2__h85496cf5b0a143eb($0 | 0, $1 | 0, $3 | 0, $4 | 0);
    label$211 : {
     if (!$5) {
      break label$211
     }
     $5 = $5 << 2 | 0;
     if (!$5) {
      break label$211
     }
     __rust_dealloc($3 | 0, $5 | 0, 4 | 0);
    }
    $5 = HEAP32[($6 + 372 | 0) >> 2] | 0;
    if (!$5) {
     break label$4
    }
    $5 = $5 << 2 | 0;
    if (!$5) {
     break label$4
    }
    __rust_dealloc(HEAP32[($6 + 368 | 0) >> 2] | 0 | 0, $5 | 0, 4 | 0);
   }
   global$0 = $6 + 384 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1082764 | 0, 43 | 0, 1083092 | 0);
  abort();
 }
 
 function cardano_serialization_lib__tx_builder__TransactionBuilder__add_change_if_needed__h087f11a5756166a6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$4 = 0, $3 = 0, $44 = 0, $44$hi = 0, $24 = 0, $43$hi = 0, $43 = 0, $40 = 0, $45$hi = 0, $5 = 0, $28 = 0, $45 = 0, $36 = 0, $32 = 0, $4 = 0, $11 = 0, $20 = 0, $21 = 0, $35 = 0, $9 = 0, $22 = 0, $13 = 0, $33 = 0, $41 = 0, $6 = 0, $46$hi = 0, $186 = 0, $187 = 0, $188 = 0, $189 = 0, $190 = 0, $192 = 0, $193 = 0, $7 = 0, $8 = 0, $10 = 0, $14 = 0, $18 = 0, $19 = 0, $26 = 0, $27 = 0, $29 = 0, $31 = 0, $46 = 0, $12 = 0, $16 = 0, $25 = 0, $30 = 0, $34 = 0, $37 = 0, $38 = 0, $39 = 0, $42 = 0, $194 = 0, $195 = 0, $76 = 0, $84 = 0, $87 = 0, $98 = 0, $103 = 0, $109 = 0, $128 = 0, $135 = 0, $138 = 0, $191 = 0, $204 = 0, $224 = 0, $266 = 0, $273 = 0, $279 = 0, $15 = 0, $17 = 0, $23 = 0, $367 = 0, $389 = 0, $394 = 0, $417 = 0, $448 = 0, $455 = 0, $458 = 0, $480 = 0, $485 = 0, $511 = 0, $514 = 0, $517 = 0, $549 = 0, $554 = 0, $557 = 0, $571 = 0, $576 = 0, $579 = 0, $587 = 0, $614 = 0, $618 = 0, $629 = 0, $632 = 0, $635 = 0, $671 = 0, $678 = 0, $681 = 0, $690 = 0, $693 = 0, $696 = 0, $707 = 0, $742 = 0, $745 = 0, $748 = 0, $780 = 0, $784 = 0, $787 = 0, $795 = 0, $799 = 0, $802 = 0, $813 = 0, $832 = 0, $847 = 0, $873 = 0, $878 = 0, $893 = 0, $896 = 0, $907 = 0, $912 = 0, $919 = 0, $922 = 0, $931 = 0, $971 = 0, $975 = 0, $978 = 0, $1010 = 0, $1014 = 0, $1017 = 0, $1026 = 0, $1031 = 0, $1034 = 0, $1046 = 0, $1050 = 0, $1063 = 0, $1117 = 0, $1120 = 0, $1123 = 0, $1130 = 0, $1133 = 0, $1136 = 0, $1165 = 0, $1184 = 0, $1250 = 0, $1253 = 0, $1272 = 0, $1272$hi = 0, $1284$hi = 0, $1302 = 0, $1306 = 0, $1309 = 0, $1318 = 0, $1323 = 0, $1326 = 0, $1378 = 0, $1386 = 0, $1391 = 0, $1401 = 0, $1406 = 0, $1409 = 0, $1459 = 0, $1465 = 0, $1529 = 0, $1534 = 0, $1538 = 0, $1588 = 0, $1688 = 0, $1694 = 0, $1732 = 0, $1739 = 0, $1744 = 0, $1751$hi = 0, $1781 = 0, $1809 = 0, $1815 = 0, $1884 = 0, $1891 = 0, $1896 = 0, $1916 = 0, $1922 = 0, $1928 = 0, $2071$hi = 0, $2073 = 0, $2073$hi = 0, $2074$hi = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0, wasm2js_i32$2 = 0;
  $2 = global$0 - 928 | 0;
  global$0 = $2;
  i64toi32_i32$0 = 0;
  $43 = 1;
  $43$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           label$10 : {
            label$11 : {
             label$12 : {
              label$13 : {
               label$14 : {
                label$15 : {
                 label$16 : {
                  label$17 : {
                   label$18 : {
                    label$19 : {
                     label$20 : {
                      label$21 : {
                       label$22 : {
                        label$23 : {
                         label$24 : {
                          label$25 : {
                           label$26 : {
                            label$27 : {
                             label$28 : {
                              label$29 : {
                               label$30 : {
                                label$31 : {
                                 label$32 : {
                                  label$33 : {
                                   label$34 : {
                                    label$35 : {
                                     label$36 : {
                                      label$37 : {
                                       label$38 : {
                                        label$39 : {
                                         label$40 : {
                                          label$41 : {
                                           label$42 : {
                                            label$43 : {
                                             label$44 : {
                                              i64toi32_i32$2 = $0;
                                              i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 256 | 0) >> 2] | 0;
                                              i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 260 | 0) >> 2] | 0;
                                              i64toi32_i32$2 = i64toi32_i32$0;
                                              i64toi32_i32$0 = 0;
                                              i64toi32_i32$3 = 1;
                                              if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
                                               break label$44
                                              }
                                              cardano_serialization_lib__tx_builder__TransactionBuilder__min_fee__h0562480e064561ee($2 + 408 | 0 | 0, $0 | 0);
                                              if ((HEAP32[($2 + 408 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                                               break label$41
                                              }
                                              $3 = ($2 + 408 | 0) + 8 | 0;
                                              i64toi32_i32$3 = $3;
                                              i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                              i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                              $43 = i64toi32_i32$2;
                                              $43$hi = i64toi32_i32$1;
                                              cardano_serialization_lib__tx_builder__TransactionBuilder__get_total_input__hf80aba4988a4a524($2 + 408 | 0 | 0, $0 | 0);
                                              label$45 : {
                                               label$46 : {
                                                if ((HEAP32[($2 + 408 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                                                 break label$46
                                                }
                                                $4 = $2 + 432 | 0;
                                                i64toi32_i32$3 = $4;
                                                i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                                i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                                $76 = i64toi32_i32$1;
                                                i64toi32_i32$1 = ($2 + 80 | 0) + 16 | 0;
                                                HEAP32[i64toi32_i32$1 >> 2] = $76;
                                                HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
                                                $5 = ($2 + 408 | 0) + 16 | 0;
                                                i64toi32_i32$3 = $5;
                                                i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                                i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                                $84 = i64toi32_i32$2;
                                                i64toi32_i32$2 = ($2 + 80 | 0) + 8 | 0;
                                                HEAP32[i64toi32_i32$2 >> 2] = $84;
                                                HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
                                                i64toi32_i32$3 = $3;
                                                i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                                i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                                $87 = i64toi32_i32$1;
                                                i64toi32_i32$1 = $2;
                                                HEAP32[($2 + 80 | 0) >> 2] = $87;
                                                HEAP32[($2 + 84 | 0) >> 2] = i64toi32_i32$2;
                                                cardano_serialization_lib__tx_builder__TransactionBuilder__get_total_output__h93b375eebf85cbd8($2 + 408 | 0 | 0, $0 | 0);
                                                if ((HEAP32[($2 + 408 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                                                 break label$45
                                                }
                                                i64toi32_i32$3 = $4;
                                                i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                                i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                                $98 = i64toi32_i32$2;
                                                i64toi32_i32$2 = ($2 + 104 | 0) + 16 | 0;
                                                HEAP32[i64toi32_i32$2 >> 2] = $98;
                                                HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
                                                i64toi32_i32$3 = $5;
                                                i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                                i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                                $103 = i64toi32_i32$1;
                                                i64toi32_i32$1 = ($2 + 104 | 0) + 8 | 0;
                                                HEAP32[i64toi32_i32$1 >> 2] = $103;
                                                HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
                                                $3 = ($2 + 408 | 0) + 8 | 0;
                                                i64toi32_i32$3 = $3;
                                                i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                                i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                                $109 = i64toi32_i32$2;
                                                i64toi32_i32$2 = $2;
                                                HEAP32[($2 + 104 | 0) >> 2] = $109;
                                                HEAP32[($2 + 108 | 0) >> 2] = i64toi32_i32$1;
                                                HEAP32[($2 + 160 | 0) >> 2] = 0;
                                                i64toi32_i32$1 = $43$hi;
                                                i64toi32_i32$2 = $2;
                                                HEAP32[($2 + 152 | 0) >> 2] = $43;
                                                HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$1;
                                                cardano_serialization_lib__utils__Value__checked_add__h5184687782847801($2 + 408 | 0 | 0, $2 + 104 | 0 | 0, $2 + 152 | 0 | 0);
                                                if ((HEAP32[($2 + 408 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                                                 break label$43
                                                }
                                                i64toi32_i32$3 = ($2 + 408 | 0) + 24 | 0;
                                                i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                                i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                                $128 = i64toi32_i32$1;
                                                i64toi32_i32$1 = ($2 + 128 | 0) + 16 | 0;
                                                HEAP32[i64toi32_i32$1 >> 2] = $128;
                                                HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
                                                i64toi32_i32$3 = ($2 + 408 | 0) + 16 | 0;
                                                i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                                i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                                $135 = i64toi32_i32$2;
                                                i64toi32_i32$2 = ($2 + 128 | 0) + 8 | 0;
                                                HEAP32[i64toi32_i32$2 >> 2] = $135;
                                                HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
                                                i64toi32_i32$3 = $3;
                                                i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                                i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                                $138 = i64toi32_i32$1;
                                                i64toi32_i32$1 = $2;
                                                HEAP32[($2 + 128 | 0) >> 2] = $138;
                                                HEAP32[($2 + 132 | 0) >> 2] = i64toi32_i32$2;
                                                $3 = $cardano_serialization_lib__utils__Value_20as_20core__cmp__PartialOrd___partial_cmp__hb371960dec6e8a81($2 + 80 | 0 | 0, $2 + 128 | 0 | 0) | 0;
                                                if (($3 & 255 | 0 | 0) != (2 | 0)) {
                                                 break label$42
                                                }
                                                i64toi32_i32$2 = 0;
                                                $43 = 1;
                                                $43$hi = i64toi32_i32$2;
                                                i64toi32_i32$2 = 0;
                                                $44 = 0;
                                                $44$hi = i64toi32_i32$2;
                                                $0 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1065454 | 0, 45 | 0) | 0;
                                                break label$17;
                                               }
                                               $0 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($2 + 412 | 0) >> 2] | 0 | 0) | 0;
                                               break label$3;
                                              }
                                              $0 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($2 + 412 | 0) >> 2] | 0 | 0) | 0;
                                              if (!(HEAP32[($2 + 88 | 0) >> 2] | 0)) {
                                               break label$3
                                              }
                                              $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 92 | 0 | 0);
                                              break label$3;
                                             }
                                             $0 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1065230 | 0, 55 | 0) | 0;
                                             break label$2;
                                            }
                                            $0 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($2 + 412 | 0) >> 2] | 0 | 0) | 0;
                                            label$47 : {
                                             if (!(HEAP32[($2 + 112 | 0) >> 2] | 0)) {
                                              break label$47
                                             }
                                             $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 116 | 0 | 0);
                                            }
                                            if (!(HEAP32[($2 + 88 | 0) >> 2] | 0)) {
                                             break label$4
                                            }
                                            $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 92 | 0 | 0);
                                            break label$4;
                                           }
                                           label$48 : {
                                            switch ((($3 << 24 | 0) >> 24 | 0) + 1 | 0 | 0) {
                                            case 2:
                                             cardano_serialization_lib__utils__Value__checked_sub__hadecd14ba2ae4b3b($2 + 408 | 0 | 0, $2 + 80 | 0 | 0, $2 + 104 | 0 | 0);
                                             label$51 : {
                                              label$52 : {
                                               label$53 : {
                                                label$54 : {
                                                 if ((HEAP32[($2 + 408 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                                                  break label$54
                                                 }
                                                 i64toi32_i32$3 = $2 + 432 | 0;
                                                 i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                                 i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                                 $191 = i64toi32_i32$2;
                                                 i64toi32_i32$2 = ($2 + 176 | 0) + 16 | 0;
                                                 HEAP32[i64toi32_i32$2 >> 2] = $191;
                                                 HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
                                                 i64toi32_i32$3 = ($2 + 408 | 0) + 16 | 0;
                                                 i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                                 i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                                 $44 = i64toi32_i32$1;
                                                 $44$hi = i64toi32_i32$2;
                                                 i64toi32_i32$1 = ($2 + 176 | 0) + 8 | 0;
                                                 HEAP32[i64toi32_i32$1 >> 2] = $44;
                                                 HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
                                                 i64toi32_i32$3 = ($2 + 408 | 0) + 8 | 0;
                                                 i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                                 i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                                 $204 = i64toi32_i32$2;
                                                 i64toi32_i32$2 = $2;
                                                 HEAP32[($2 + 176 | 0) >> 2] = $204;
                                                 HEAP32[($2 + 180 | 0) >> 2] = i64toi32_i32$1;
                                                 label$55 : {
                                                  i64toi32_i32$1 = $44$hi;
                                                  if (($44 | 0) != (1 | 0)) {
                                                   break label$55
                                                  }
                                                  $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($2 + 408 | 0 | 4 | 0 | 0, ($2 + 176 | 0) + 12 | 0 | 0);
                                                  $3 = HEAP32[(($2 + 408 | 0) + 12 | 0) >> 2] | 0;
                                                  HEAP32[(($2 + 240 | 0) + 8 | 0) >> 2] = $3;
                                                  i64toi32_i32$3 = $2;
                                                  i64toi32_i32$1 = HEAP32[($2 + 412 | 0) >> 2] | 0;
                                                  i64toi32_i32$2 = HEAP32[($2 + 416 | 0) >> 2] | 0;
                                                  $224 = i64toi32_i32$1;
                                                  i64toi32_i32$1 = $2;
                                                  HEAP32[($2 + 240 | 0) >> 2] = $224;
                                                  HEAP32[($2 + 244 | 0) >> 2] = i64toi32_i32$2;
                                                  $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 240 | 0 | 0);
                                                  if ($3) {
                                                   break label$53
                                                  }
                                                 }
                                                 cardano_serialization_lib__utils__min_ada_required__hfea4b15a263723f5($2 + 408 | 0 | 0, $2 + 176 | 0 | 0, 0 | 0, $0 + 32 | 0 | 0);
                                                 if ((HEAP32[($2 + 408 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                                                  break label$52
                                                 }
                                                 i64toi32_i32$3 = $2;
                                                 i64toi32_i32$2 = HEAP32[($2 + 176 | 0) >> 2] | 0;
                                                 i64toi32_i32$1 = HEAP32[($2 + 180 | 0) >> 2] | 0;
                                                 $44 = i64toi32_i32$2;
                                                 $44$hi = i64toi32_i32$1;
                                                 i64toi32_i32$3 = $2 + 416 | 0;
                                                 i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                                 i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                                 $45 = i64toi32_i32$1;
                                                 $45$hi = i64toi32_i32$2;
                                                 i64toi32_i32$2 = $44$hi;
                                                 i64toi32_i32$3 = $44;
                                                 i64toi32_i32$1 = $45$hi;
                                                 i64toi32_i32$0 = $45;
                                                 if (i64toi32_i32$2 >>> 0 > i64toi32_i32$1 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$3 >>> 0 >= i64toi32_i32$0 >>> 0 | 0) | 0) {
                                                  break label$51
                                                 }
                                                 i64toi32_i32$2 = $0;
                                                 i64toi32_i32$3 = 0;
                                                 HEAP32[(i64toi32_i32$2 + 256 | 0) >> 2] = 1;
                                                 HEAP32[(i64toi32_i32$2 + 260 | 0) >> 2] = i64toi32_i32$3;
                                                 i64toi32_i32$3 = $44$hi;
                                                 i64toi32_i32$2 = i64toi32_i32$2 + 264 | 0;
                                                 HEAP32[i64toi32_i32$2 >> 2] = $44;
                                                 HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                                                 i64toi32_i32$3 = 0;
                                                 $44 = 0;
                                                 $44$hi = i64toi32_i32$3;
                                                 break label$20;
                                                }
                                                $0 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($2 + 412 | 0) >> 2] | 0 | 0) | 0;
                                                break label$5;
                                               }
                                               cardano_serialization_lib__utils__Value__checked_sub__hadecd14ba2ae4b3b($2 + 408 | 0 | 0, $2 + 80 | 0 | 0, $2 + 104 | 0 | 0);
                                               if ((HEAP32[($2 + 408 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                                                break label$7
                                               }
                                               i64toi32_i32$0 = $2 + 432 | 0;
                                               i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                               i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                               $266 = i64toi32_i32$3;
                                               i64toi32_i32$3 = ($2 + 200 | 0) + 16 | 0;
                                               HEAP32[i64toi32_i32$3 >> 2] = $266;
                                               HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                                               i64toi32_i32$0 = ($2 + 408 | 0) + 16 | 0;
                                               i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                               i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                               $273 = i64toi32_i32$2;
                                               i64toi32_i32$2 = ($2 + 200 | 0) + 8 | 0;
                                               HEAP32[i64toi32_i32$2 >> 2] = $273;
                                               HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                                               $3 = ($2 + 408 | 0) + 8 | 0;
                                               i64toi32_i32$0 = $3;
                                               i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                               i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                               $279 = i64toi32_i32$3;
                                               i64toi32_i32$3 = $2;
                                               HEAP32[($2 + 200 | 0) >> 2] = $279;
                                               HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$2;
                                               $6 = $0 + 32 | 0;
                                               cardano_serialization_lib__utils__min_pure_ada__had787b4590d9b7ca($2 + 408 | 0 | 0, $6 | 0, 0 | 0);
                                               if ((HEAP32[($2 + 408 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                                                break label$9
                                               }
                                               i64toi32_i32$0 = $3;
                                               i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                               i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                               $46 = i64toi32_i32$2;
                                               $46$hi = i64toi32_i32$3;
                                               label$56 : {
                                                label$57 : {
                                                 label$58 : {
                                                  label$59 : {
                                                   label$60 : {
                                                    label$61 : {
                                                     label$62 : {
                                                      label$63 : {
                                                       if ((HEAP32[($2 + 208 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                                                        break label$63
                                                       }
                                                       $7 = ($2 + 200 | 0) + 12 | 0;
                                                       $5 = ($2 + 240 | 0) + 8 | 0;
                                                       $8 = $2 + 480 | 0;
                                                       $9 = $2 + 728 | 0 | 4 | 0;
                                                       $10 = ($2 + 584 | 0) + 12 | 0;
                                                       $11 = $2 + 240 | 0 | 4 | 0;
                                                       $12 = ($2 + 728 | 0) + 12 | 0;
                                                       $3 = ($2 + 728 | 0) + 8 | 0;
                                                       $13 = ($2 + 640 | 0) + 12 | 0;
                                                       $14 = ($2 + 616 | 0) + 12 | 0;
                                                       $15 = ($2 + 848 | 0) + 12 | 0;
                                                       $16 = ($2 + 824 | 0) + 12 | 0;
                                                       $17 = $2 + 888 | 0 | 4 | 0;
                                                       $18 = ($2 + 824 | 0) + 8 | 0;
                                                       $4 = ($2 + 240 | 0) + 12 | 0;
                                                       $19 = ($2 + 616 | 0) + 8 | 0;
                                                       $20 = $2 + 484 | 0;
                                                       $21 = ($2 + 408 | 0) + 64 | 0;
                                                       $22 = ($2 + 384 | 0) + 12 | 0;
                                                       $23 = HEAP32[(0 + 1063772 | 0) >> 2] | 0;
                                                       label$64 : while (1) {
                                                        i64toi32_i32$2 = $2;
                                                        i64toi32_i32$3 = 0;
                                                        HEAP32[($2 + 412 | 0) >> 2] = 0;
                                                        HEAP32[($2 + 416 | 0) >> 2] = i64toi32_i32$3;
                                                        $24 = $cardano_serialization_lib__MultiAsset_20as_20core__cmp__PartialOrd___partial_cmp__h767e68b80e51259d($7 | 0, $2 + 408 | 0 | 0) | 0;
                                                        $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 408 | 0 | 0);
                                                        if (($24 & 255 | 0 | 0) != (1 | 0)) {
                                                         break label$63
                                                        }
                                                        $25 = HEAP32[($0 + 80 | 0) >> 2] | 0;
                                                        i64toi32_i32$2 = $2;
                                                        i64toi32_i32$3 = 0;
                                                        HEAP32[($2 + 372 | 0) >> 2] = 0;
                                                        HEAP32[($2 + 376 | 0) >> 2] = i64toi32_i32$3;
                                                        HEAP32[($2 + 368 | 0) >> 2] = $23;
                                                        $24 = 0;
                                                        HEAP32[($2 + 392 | 0) >> 2] = 0;
                                                        i64toi32_i32$0 = $2;
                                                        i64toi32_i32$3 = HEAP32[($2 + 200 | 0) >> 2] | 0;
                                                        i64toi32_i32$2 = HEAP32[($2 + 204 | 0) >> 2] | 0;
                                                        $367 = i64toi32_i32$3;
                                                        i64toi32_i32$3 = $2;
                                                        HEAP32[($2 + 384 | 0) >> 2] = $367;
                                                        HEAP32[($2 + 388 | 0) >> 2] = i64toi32_i32$2;
                                                        i64toi32_i32$3 = $2;
                                                        i64toi32_i32$2 = 0;
                                                        HEAP32[($2 + 412 | 0) >> 2] = 0;
                                                        HEAP32[($2 + 416 | 0) >> 2] = i64toi32_i32$2;
                                                        cardano_serialization_lib__utils__Value__set_multiasset__hcffccef3fc1cfd59($2 + 384 | 0 | 0, $2 + 408 | 0 | 0);
                                                        $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 408 | 0 | 0);
                                                        $cardano_serialization_lib__address__Address_20as_20core__clone__Clone___clone__h0eb465a6e349d507_2($2 + 240 | 0 | 0, $1 | 0);
                                                        i64toi32_i32$0 = $2;
                                                        i64toi32_i32$2 = HEAP32[($2 + 384 | 0) >> 2] | 0;
                                                        i64toi32_i32$3 = HEAP32[($2 + 388 | 0) >> 2] | 0;
                                                        $44 = i64toi32_i32$2;
                                                        $44$hi = i64toi32_i32$3;
                                                        label$65 : {
                                                         if ((HEAP32[($2 + 392 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                                                          break label$65
                                                         }
                                                         $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($9 | 0, $22 | 0);
                                                         $24 = 1;
                                                        }
                                                        HEAP32[($2 + 728 | 0) >> 2] = $24;
                                                        i64toi32_i32$0 = $2;
                                                        i64toi32_i32$3 = HEAP32[($2 + 728 | 0) >> 2] | 0;
                                                        i64toi32_i32$2 = HEAP32[($2 + 732 | 0) >> 2] | 0;
                                                        $389 = i64toi32_i32$3;
                                                        i64toi32_i32$3 = $8;
                                                        HEAP32[i64toi32_i32$3 >> 2] = $389;
                                                        HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                                                        $26 = i64toi32_i32$3 + 8 | 0;
                                                        i64toi32_i32$0 = $3;
                                                        i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                        i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                        $394 = i64toi32_i32$2;
                                                        i64toi32_i32$2 = $26;
                                                        HEAP32[i64toi32_i32$2 >> 2] = $394;
                                                        HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                                                        memcpy($2 + 408 | 0 | 0, $2 + 240 | 0 | 0, 64 | 0) | 0;
                                                        HEAP8[($2 + 496 | 0) >> 0] = 0;
                                                        i64toi32_i32$3 = $44$hi;
                                                        i64toi32_i32$2 = $2;
                                                        HEAP32[($2 + 472 | 0) >> 2] = $44;
                                                        HEAP32[($2 + 476 | 0) >> 2] = i64toi32_i32$3;
                                                        if ((HEAP32[($2 + 208 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                                                         break label$40
                                                        }
                                                        $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($11 | 0, $7 | 0);
                                                        $27 = $11 + 8 | 0;
                                                        HEAP32[(($2 + 568 | 0) + 8 | 0) >> 2] = HEAP32[$27 >> 2] | 0;
                                                        i64toi32_i32$0 = $11;
                                                        i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                        i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                        $417 = i64toi32_i32$3;
                                                        i64toi32_i32$3 = $2;
                                                        HEAP32[($2 + 568 | 0) >> 2] = $417;
                                                        HEAP32[($2 + 572 | 0) >> 2] = i64toi32_i32$2;
                                                        label$66 : {
                                                         label$67 : {
                                                          $24 = HEAP32[($2 + 572 | 0) >> 2] | 0;
                                                          if (!$24) {
                                                           break label$67
                                                          }
                                                          $28 = HEAP32[($2 + 568 | 0) >> 2] | 0;
                                                          alloc__collections__btree__navigate__full_range__hd4dadfd3315a2ab8($2 + 536 | 0 | 0, $28 | 0, $24 | 0, $28 | 0, $24 | 0);
                                                          $24 = HEAP32[($2 + 576 | 0) >> 2] | 0;
                                                          break label$66;
                                                         }
                                                         $24 = 0;
                                                         HEAP32[($2 + 552 | 0) >> 2] = 0;
                                                         HEAP32[($2 + 540 | 0) >> 2] = 0;
                                                        }
                                                        HEAP32[(($2 + 536 | 0) + 24 | 0) >> 2] = $24;
                                                        HEAP32[(($2 + 584 | 0) + 24 | 0) >> 2] = $24;
                                                        i64toi32_i32$0 = ($2 + 536 | 0) + 16 | 0;
                                                        i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                        i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                        $448 = i64toi32_i32$2;
                                                        i64toi32_i32$2 = ($2 + 584 | 0) + 16 | 0;
                                                        HEAP32[i64toi32_i32$2 >> 2] = $448;
                                                        HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                                                        i64toi32_i32$0 = ($2 + 536 | 0) + 8 | 0;
                                                        i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                        i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                        $455 = i64toi32_i32$3;
                                                        i64toi32_i32$3 = ($2 + 584 | 0) + 8 | 0;
                                                        HEAP32[i64toi32_i32$3 >> 2] = $455;
                                                        HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                                                        i64toi32_i32$0 = $2;
                                                        i64toi32_i32$2 = HEAP32[($2 + 536 | 0) >> 2] | 0;
                                                        i64toi32_i32$3 = HEAP32[($2 + 540 | 0) >> 2] | 0;
                                                        $458 = i64toi32_i32$2;
                                                        i64toi32_i32$2 = $2;
                                                        HEAP32[($2 + 584 | 0) >> 2] = $458;
                                                        HEAP32[($2 + 588 | 0) >> 2] = i64toi32_i32$3;
                                                        $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h03cc330b7b1e4522($2 + 72 | 0 | 0, $2 + 584 | 0 | 0);
                                                        label$68 : {
                                                         $24 = HEAP32[($2 + 72 | 0) >> 2] | 0;
                                                         if (!$24) {
                                                          break label$68
                                                         }
                                                         $29 = HEAP32[($2 + 76 | 0) >> 2] | 0;
                                                         label$69 : {
                                                          label$70 : while (1) {
                                                           i64toi32_i32$0 = $2;
                                                           i64toi32_i32$3 = HEAP32[($2 + 472 | 0) >> 2] | 0;
                                                           i64toi32_i32$2 = HEAP32[($2 + 476 | 0) >> 2] | 0;
                                                           $44 = i64toi32_i32$3;
                                                           $44$hi = i64toi32_i32$2;
                                                           $28 = 0;
                                                           label$71 : {
                                                            if ((HEAP32[($2 + 480 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                                                             break label$71
                                                            }
                                                            $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($11 | 0, $20 | 0);
                                                            $28 = 1;
                                                           }
                                                           HEAP32[($2 + 240 | 0) >> 2] = $28;
                                                           i64toi32_i32$0 = $2;
                                                           i64toi32_i32$2 = HEAP32[($2 + 240 | 0) >> 2] | 0;
                                                           i64toi32_i32$3 = HEAP32[($2 + 244 | 0) >> 2] | 0;
                                                           $480 = i64toi32_i32$2;
                                                           i64toi32_i32$2 = $19;
                                                           HEAP32[i64toi32_i32$2 >> 2] = $480;
                                                           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                                                           $30 = i64toi32_i32$2 + 8 | 0;
                                                           i64toi32_i32$0 = $5;
                                                           i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                           i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                           $485 = i64toi32_i32$3;
                                                           i64toi32_i32$3 = $30;
                                                           HEAP32[i64toi32_i32$3 >> 2] = $485;
                                                           HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                                                           i64toi32_i32$2 = $44$hi;
                                                           i64toi32_i32$3 = $2;
                                                           HEAP32[($2 + 616 | 0) >> 2] = $44;
                                                           HEAP32[($2 + 620 | 0) >> 2] = i64toi32_i32$2;
                                                           HEAP32[($2 + 648 | 0) >> 2] = 0;
                                                           i64toi32_i32$3 = $2;
                                                           i64toi32_i32$2 = 0;
                                                           HEAP32[($2 + 640 | 0) >> 2] = 0;
                                                           HEAP32[($2 + 644 | 0) >> 2] = i64toi32_i32$2;
                                                           i64toi32_i32$3 = $2;
                                                           i64toi32_i32$2 = 0;
                                                           HEAP32[($2 + 668 | 0) >> 2] = 0;
                                                           HEAP32[($2 + 672 | 0) >> 2] = i64toi32_i32$2;
                                                           alloc__collections__btree__map__BTreeMap_K_2cV___iter__ha89c9458aca0228d($2 + 728 | 0 | 0, $29 | 0);
                                                           $31 = ($2 + 240 | 0) + 24 | 0;
                                                           $32 = ($2 + 728 | 0) + 24 | 0;
                                                           HEAP32[$31 >> 2] = HEAP32[$32 >> 2] | 0;
                                                           $33 = ($2 + 240 | 0) + 16 | 0;
                                                           $28 = ($2 + 728 | 0) + 16 | 0;
                                                           i64toi32_i32$0 = $28;
                                                           i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                           i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                           $511 = i64toi32_i32$2;
                                                           i64toi32_i32$2 = $33;
                                                           HEAP32[i64toi32_i32$2 >> 2] = $511;
                                                           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                                                           i64toi32_i32$0 = $3;
                                                           i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                           i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                           $514 = i64toi32_i32$3;
                                                           i64toi32_i32$3 = $5;
                                                           HEAP32[i64toi32_i32$3 >> 2] = $514;
                                                           HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                                                           i64toi32_i32$0 = $2;
                                                           i64toi32_i32$2 = HEAP32[($2 + 728 | 0) >> 2] | 0;
                                                           i64toi32_i32$3 = HEAP32[($2 + 732 | 0) >> 2] | 0;
                                                           $517 = i64toi32_i32$2;
                                                           i64toi32_i32$2 = $2;
                                                           HEAP32[($2 + 240 | 0) >> 2] = $517;
                                                           HEAP32[($2 + 244 | 0) >> 2] = i64toi32_i32$3;
                                                           $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__h24704ec9214d4ac9($2 + 680 | 0 | 0, $2 + 240 | 0 | 0);
                                                           i64toi32_i32$2 = $2;
                                                           i64toi32_i32$3 = 0;
                                                           HEAP32[($2 + 700 | 0) >> 2] = 0;
                                                           HEAP32[($2 + 704 | 0) >> 2] = i64toi32_i32$3;
                                                           label$72 : {
                                                            label$73 : {
                                                             $34 = HEAP32[($2 + 688 | 0) >> 2] | 0;
                                                             if (!$34) {
                                                              break label$73
                                                             }
                                                             $35 = 0;
                                                             label$74 : while (1) {
                                                              cardano_serialization_lib__AssetNames__get__hc0d49e00b9a5fbf3($2 + 712 | 0 | 0, $2 + 680 | 0 | 0, $35 | 0);
                                                              $36 = alloc__collections__btree__map__BTreeMap_K_2cV___get__h825f34112f7eacbf($29 | 0, $2 + 712 | 0 | 0) | 0;
                                                              if (!$36) {
                                                               break label$39
                                                              }
                                                              i64toi32_i32$0 = $36;
                                                              i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                              i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                              $44 = i64toi32_i32$3;
                                                              $44$hi = i64toi32_i32$2;
                                                              $37 = $24 + 24 | 0;
                                                              $186 = $37;
                                                              HEAP32[$32 >> 2] = HEAPU8[$186 >> 0] | 0 | ((HEAPU8[($186 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($186 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($186 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                                              $38 = $24 + 16 | 0;
                                                              i64toi32_i32$0 = $38;
                                                              i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                                              i64toi32_i32$3 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                                              $549 = i64toi32_i32$2;
                                                              i64toi32_i32$2 = $28;
                                                              HEAP32[i64toi32_i32$2 >> 2] = $549;
                                                              HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                                                              $39 = $24 + 8 | 0;
                                                              i64toi32_i32$0 = $39;
                                                              i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                                              i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                                              $554 = i64toi32_i32$3;
                                                              i64toi32_i32$3 = $3;
                                                              HEAP32[i64toi32_i32$3 >> 2] = $554;
                                                              HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                                                              i64toi32_i32$0 = $24;
                                                              i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                                              i64toi32_i32$3 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                                              $557 = i64toi32_i32$2;
                                                              i64toi32_i32$2 = $2;
                                                              HEAP32[($2 + 728 | 0) >> 2] = $557;
                                                              HEAP32[($2 + 732 | 0) >> 2] = i64toi32_i32$3;
                                                              $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($2 + 240 | 0 | 0, $2 + 712 | 0 | 0);
                                                              $40 = $4 + 24 | 0;
                                                              $187 = HEAP32[$32 >> 2] | 0;
                                                              HEAP8[$40 >> 0] = $187;
                                                              HEAP8[($40 + 1 | 0) >> 0] = $187 >>> 8 | 0;
                                                              HEAP8[($40 + 2 | 0) >> 0] = $187 >>> 16 | 0;
                                                              HEAP8[($40 + 3 | 0) >> 0] = $187 >>> 24 | 0;
                                                              $41 = $4 + 16 | 0;
                                                              i64toi32_i32$0 = $28;
                                                              i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                              i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                              $571 = i64toi32_i32$3;
                                                              i64toi32_i32$3 = $41;
                                                              $188 = $571;
                                                              HEAP8[i64toi32_i32$3 >> 0] = $188;
                                                              HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $188 >>> 8 | 0;
                                                              HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $188 >>> 16 | 0;
                                                              HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $188 >>> 24 | 0;
                                                              HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$2;
                                                              HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
                                                              HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
                                                              HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
                                                              $42 = $4 + 8 | 0;
                                                              i64toi32_i32$0 = $3;
                                                              i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                              i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                              $576 = i64toi32_i32$2;
                                                              i64toi32_i32$2 = $42;
                                                              $189 = $576;
                                                              HEAP8[i64toi32_i32$2 >> 0] = $189;
                                                              HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $189 >>> 8 | 0;
                                                              HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $189 >>> 16 | 0;
                                                              HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $189 >>> 24 | 0;
                                                              HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$3;
                                                              HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
                                                              HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
                                                              HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
                                                              i64toi32_i32$0 = $2;
                                                              i64toi32_i32$3 = HEAP32[($2 + 728 | 0) >> 2] | 0;
                                                              i64toi32_i32$2 = HEAP32[($2 + 732 | 0) >> 2] | 0;
                                                              $579 = i64toi32_i32$3;
                                                              i64toi32_i32$3 = $4;
                                                              $190 = $579;
                                                              HEAP8[i64toi32_i32$3 >> 0] = $190;
                                                              HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $190 >>> 8 | 0;
                                                              HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $190 >>> 16 | 0;
                                                              HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $190 >>> 24 | 0;
                                                              HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$2;
                                                              HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
                                                              HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
                                                              HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
                                                              HEAP32[(($2 + 792 | 0) + 8 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
                                                              i64toi32_i32$0 = $2;
                                                              i64toi32_i32$2 = HEAP32[($2 + 240 | 0) >> 2] | 0;
                                                              i64toi32_i32$3 = HEAP32[($2 + 244 | 0) >> 2] | 0;
                                                              $587 = i64toi32_i32$2;
                                                              i64toi32_i32$2 = $2;
                                                              HEAP32[($2 + 792 | 0) >> 2] = $587;
                                                              HEAP32[($2 + 796 | 0) >> 2] = i64toi32_i32$3;
                                                              $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h3f0faaa5740c6934($2 + 808 | 0 | 0, $2 + 696 | 0 | 0);
                                                              $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($2 + 728 | 0 | 0, $2 + 792 | 0 | 0);
                                                              i64toi32_i32$3 = $44$hi;
                                                              alloc__collections__btree__map__BTreeMap_K_2cV___insert__hc7622c6487a4ba88($2 + 56 | 0 | 0, $2 + 808 | 0 | 0, $2 + 728 | 0 | 0, $44 | 0, i64toi32_i32$3 | 0);
                                                              i64toi32_i32$0 = $2;
                                                              i64toi32_i32$3 = HEAP32[($2 + 472 | 0) >> 2] | 0;
                                                              i64toi32_i32$2 = HEAP32[($2 + 476 | 0) >> 2] | 0;
                                                              $45 = i64toi32_i32$3;
                                                              $45$hi = i64toi32_i32$2;
                                                              $36 = 0;
                                                              label$75 : {
                                                               if ((HEAP32[($2 + 480 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                                                                break label$75
                                                               }
                                                               $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($9 | 0, $20 | 0);
                                                               $36 = 1;
                                                              }
                                                              HEAP32[($2 + 728 | 0) >> 2] = $36;
                                                              i64toi32_i32$0 = $2;
                                                              i64toi32_i32$2 = HEAP32[($2 + 728 | 0) >> 2] | 0;
                                                              i64toi32_i32$3 = HEAP32[($2 + 732 | 0) >> 2] | 0;
                                                              $614 = i64toi32_i32$2;
                                                              i64toi32_i32$2 = $18;
                                                              HEAP32[i64toi32_i32$2 >> 2] = $614;
                                                              HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                                                              i64toi32_i32$0 = $3;
                                                              i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                              i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                              $618 = i64toi32_i32$3;
                                                              i64toi32_i32$3 = $18 + 8 | 0;
                                                              HEAP32[i64toi32_i32$3 >> 2] = $618;
                                                              HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                                                              i64toi32_i32$2 = $45$hi;
                                                              i64toi32_i32$3 = $2;
                                                              HEAP32[($2 + 824 | 0) >> 2] = $45;
                                                              HEAP32[($2 + 828 | 0) >> 2] = i64toi32_i32$2;
                                                              HEAP32[($2 + 856 | 0) >> 2] = 0;
                                                              i64toi32_i32$3 = $2;
                                                              i64toi32_i32$2 = 0;
                                                              HEAP32[($2 + 848 | 0) >> 2] = 0;
                                                              HEAP32[($2 + 852 | 0) >> 2] = i64toi32_i32$2;
                                                              i64toi32_i32$3 = $2;
                                                              i64toi32_i32$2 = 0;
                                                              HEAP32[($2 + 876 | 0) >> 2] = 0;
                                                              HEAP32[($2 + 880 | 0) >> 2] = i64toi32_i32$2;
                                                              HEAP32[$32 >> 2] = HEAPU8[$40 >> 0] | 0 | ((HEAPU8[($40 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($40 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($40 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                                              i64toi32_i32$0 = $41;
                                                              i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                                              i64toi32_i32$3 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                                              $629 = i64toi32_i32$2;
                                                              i64toi32_i32$2 = $28;
                                                              HEAP32[i64toi32_i32$2 >> 2] = $629;
                                                              HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                                                              i64toi32_i32$0 = $42;
                                                              i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                                              i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                                              $632 = i64toi32_i32$3;
                                                              i64toi32_i32$3 = $3;
                                                              HEAP32[i64toi32_i32$3 >> 2] = $632;
                                                              HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                                                              i64toi32_i32$0 = $4;
                                                              i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                                              i64toi32_i32$3 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                                              $635 = i64toi32_i32$2;
                                                              i64toi32_i32$2 = $2;
                                                              HEAP32[($2 + 728 | 0) >> 2] = $635;
                                                              HEAP32[($2 + 732 | 0) >> 2] = i64toi32_i32$3;
                                                              $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h3f0faaa5740c6934($2 + 912 | 0 | 0, $2 + 808 | 0 | 0);
                                                              alloc__collections__btree__map__BTreeMap_K_2cV___insert__ha211f93f5765e42b($2 + 888 | 0 | 0, $2 + 872 | 0 | 0, $2 + 728 | 0 | 0, $2 + 912 | 0 | 0);
                                                              label$76 : {
                                                               if (!(HEAP32[($2 + 888 | 0) >> 2] | 0)) {
                                                                break label$76
                                                               }
                                                               $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h6c9f94f0f82ce2b5($17 | 0);
                                                              }
                                                              cardano_serialization_lib__utils__Value__set_multiasset__hcffccef3fc1cfd59($2 + 848 | 0 | 0, $2 + 872 | 0 | 0);
                                                              cardano_serialization_lib__utils__Value__checked_add__h5184687782847801($2 + 728 | 0 | 0, $2 + 824 | 0 | 0, $2 + 848 | 0 | 0);
                                                              if ((HEAP32[($2 + 728 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                                                               break label$38
                                                              }
                                                              $40 = ($2 + 888 | 0) + 16 | 0;
                                                              i64toi32_i32$0 = $3 + 16 | 0;
                                                              i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                              i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                              $671 = i64toi32_i32$3;
                                                              i64toi32_i32$3 = $40;
                                                              HEAP32[i64toi32_i32$3 >> 2] = $671;
                                                              HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                                                              $36 = ($2 + 888 | 0) + 8 | 0;
                                                              i64toi32_i32$0 = $3 + 8 | 0;
                                                              i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                              i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                              $678 = i64toi32_i32$2;
                                                              i64toi32_i32$2 = $36;
                                                              HEAP32[i64toi32_i32$2 >> 2] = $678;
                                                              HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                                                              i64toi32_i32$0 = $3;
                                                              i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                              i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                              $681 = i64toi32_i32$3;
                                                              i64toi32_i32$3 = $2;
                                                              HEAP32[($2 + 888 | 0) >> 2] = $681;
                                                              HEAP32[($2 + 892 | 0) >> 2] = i64toi32_i32$2;
                                                              label$77 : {
                                                               if (!(HEAP32[($2 + 832 | 0) >> 2] | 0)) {
                                                                break label$77
                                                               }
                                                               $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($16 | 0);
                                                              }
                                                              i64toi32_i32$0 = $40;
                                                              i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                              i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                              $690 = i64toi32_i32$2;
                                                              i64toi32_i32$2 = ($2 + 824 | 0) + 16 | 0;
                                                              HEAP32[i64toi32_i32$2 >> 2] = $690;
                                                              HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                                                              i64toi32_i32$0 = $36;
                                                              i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                              i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                              $693 = i64toi32_i32$3;
                                                              i64toi32_i32$3 = $18;
                                                              HEAP32[i64toi32_i32$3 >> 2] = $693;
                                                              HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                                                              i64toi32_i32$0 = $2;
                                                              i64toi32_i32$2 = HEAP32[($2 + 888 | 0) >> 2] | 0;
                                                              i64toi32_i32$3 = HEAP32[($2 + 892 | 0) >> 2] | 0;
                                                              $696 = i64toi32_i32$2;
                                                              i64toi32_i32$2 = $2;
                                                              HEAP32[($2 + 824 | 0) >> 2] = $696;
                                                              HEAP32[($2 + 828 | 0) >> 2] = i64toi32_i32$3;
                                                              cardano_serialization_lib__utils__min_ada_required__hfea4b15a263723f5($2 + 728 | 0 | 0, $2 + 848 | 0 | 0, 0 | 0, $6 | 0);
                                                              if ((HEAP32[($2 + 728 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                                                               break label$37
                                                              }
                                                              i64toi32_i32$0 = $2;
                                                              i64toi32_i32$3 = HEAP32[($2 + 736 | 0) >> 2] | 0;
                                                              i64toi32_i32$2 = HEAP32[($2 + 740 | 0) >> 2] | 0;
                                                              $707 = i64toi32_i32$3;
                                                              i64toi32_i32$3 = $2;
                                                              HEAP32[($2 + 824 | 0) >> 2] = $707;
                                                              HEAP32[($2 + 828 | 0) >> 2] = i64toi32_i32$2;
                                                              cardano_serialization_lib__utils__Value__to_bytes__h2820e7e1b4035910($2 + 728 | 0 | 0, $2 + 824 | 0 | 0);
                                                              $40 = HEAP32[($2 + 736 | 0) >> 2] | 0;
                                                              $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 872 | 0 | 0);
                                                              label$78 : {
                                                               if (!(HEAP32[($2 + 856 | 0) >> 2] | 0)) {
                                                                break label$78
                                                               }
                                                               $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($15 | 0);
                                                              }
                                                              label$79 : {
                                                               if (!(HEAP32[($2 + 832 | 0) >> 2] | 0)) {
                                                                break label$79
                                                               }
                                                               $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($16 | 0);
                                                              }
                                                              $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h6c9f94f0f82ce2b5($2 + 808 | 0 | 0);
                                                              $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 792 | 0 | 0);
                                                              $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 792 | 0 | 0);
                                                              $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 728 | 0 | 0);
                                                              $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 728 | 0 | 0);
                                                              label$80 : {
                                                               if ($40 >>> 0 <= $25 >>> 0) {
                                                                break label$80
                                                               }
                                                               $192 = $37;
                                                               HEAP32[$31 >> 2] = HEAPU8[$192 >> 0] | 0 | ((HEAPU8[($192 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($192 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($192 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                                               i64toi32_i32$0 = $38;
                                                               i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                                               i64toi32_i32$3 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                                               $742 = i64toi32_i32$2;
                                                               i64toi32_i32$2 = $33;
                                                               HEAP32[i64toi32_i32$2 >> 2] = $742;
                                                               HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                                                               i64toi32_i32$0 = $39;
                                                               i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                                               i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                                               $745 = i64toi32_i32$3;
                                                               i64toi32_i32$3 = $5;
                                                               HEAP32[i64toi32_i32$3 >> 2] = $745;
                                                               HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                                                               i64toi32_i32$0 = $24;
                                                               i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                                               i64toi32_i32$3 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                                               $748 = i64toi32_i32$2;
                                                               i64toi32_i32$2 = $2;
                                                               HEAP32[($2 + 240 | 0) >> 2] = $748;
                                                               HEAP32[($2 + 244 | 0) >> 2] = i64toi32_i32$3;
                                                               $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h3f0faaa5740c6934($2 + 888 | 0 | 0, $2 + 696 | 0 | 0);
                                                               alloc__collections__btree__map__BTreeMap_K_2cV___insert__ha211f93f5765e42b($2 + 728 | 0 | 0, $2 + 664 | 0 | 0, $2 + 240 | 0 | 0, $2 + 888 | 0 | 0);
                                                               label$81 : {
                                                                if (!(HEAP32[($2 + 728 | 0) >> 2] | 0)) {
                                                                 break label$81
                                                                }
                                                                $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h6c9f94f0f82ce2b5($9 | 0);
                                                               }
                                                               cardano_serialization_lib__utils__Value__set_multiasset__hcffccef3fc1cfd59($2 + 640 | 0 | 0, $2 + 664 | 0 | 0);
                                                               cardano_serialization_lib__utils__Value__checked_add__h5184687782847801($2 + 240 | 0 | 0, $21 | 0, $2 + 640 | 0 | 0);
                                                               if ((HEAP32[($2 + 240 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                                                                break label$72
                                                               }
                                                               i64toi32_i32$0 = $5 + 16 | 0;
                                                               i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                               i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                               $780 = i64toi32_i32$3;
                                                               i64toi32_i32$3 = $28;
                                                               HEAP32[i64toi32_i32$3 >> 2] = $780;
                                                               HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                                                               i64toi32_i32$0 = $5 + 8 | 0;
                                                               i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                               i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                               $784 = i64toi32_i32$2;
                                                               i64toi32_i32$2 = $3;
                                                               HEAP32[i64toi32_i32$2 >> 2] = $784;
                                                               HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                                                               i64toi32_i32$0 = $5;
                                                               i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                               i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                               $787 = i64toi32_i32$3;
                                                               i64toi32_i32$3 = $2;
                                                               HEAP32[($2 + 728 | 0) >> 2] = $787;
                                                               HEAP32[($2 + 732 | 0) >> 2] = i64toi32_i32$2;
                                                               label$82 : {
                                                                if (!(HEAP32[($2 + 480 | 0) >> 2] | 0)) {
                                                                 break label$82
                                                                }
                                                                $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($20 | 0);
                                                               }
                                                               i64toi32_i32$0 = $28;
                                                               i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                               i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                               $795 = i64toi32_i32$2;
                                                               i64toi32_i32$2 = $21 + 16 | 0;
                                                               HEAP32[i64toi32_i32$2 >> 2] = $795;
                                                               HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                                                               i64toi32_i32$0 = $3;
                                                               i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                               i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                               $799 = i64toi32_i32$3;
                                                               i64toi32_i32$3 = $21 + 8 | 0;
                                                               HEAP32[i64toi32_i32$3 >> 2] = $799;
                                                               HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                                                               i64toi32_i32$0 = $2;
                                                               i64toi32_i32$2 = HEAP32[($2 + 728 | 0) >> 2] | 0;
                                                               i64toi32_i32$3 = HEAP32[($2 + 732 | 0) >> 2] | 0;
                                                               $802 = i64toi32_i32$2;
                                                               i64toi32_i32$2 = $21;
                                                               HEAP32[i64toi32_i32$2 >> 2] = $802;
                                                               HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                                                               if ((HEAP32[($2 + 480 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                                                                break label$36
                                                               }
                                                               $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($11 | 0, $20 | 0);
                                                               HEAP32[$3 >> 2] = HEAP32[$27 >> 2] | 0;
                                                               i64toi32_i32$0 = $11;
                                                               i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                               i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                               $813 = i64toi32_i32$3;
                                                               i64toi32_i32$3 = $2;
                                                               HEAP32[($2 + 728 | 0) >> 2] = $813;
                                                               HEAP32[($2 + 732 | 0) >> 2] = i64toi32_i32$2;
                                                               label$83 : {
                                                                $40 = HEAP32[($2 + 376 | 0) >> 2] | 0;
                                                                if ((HEAP32[($2 + 372 | 0) >> 2] | 0 | 0) != ($40 | 0)) {
                                                                 break label$83
                                                                }
                                                                alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hb2d5108633ce5dd7($2 + 368 | 0 | 0, $40 | 0, 1 | 0);
                                                                $40 = HEAP32[($2 + 376 | 0) >> 2] | 0;
                                                               }
                                                               $40 = (HEAP32[($2 + 368 | 0) >> 2] | 0) + Math_imul($40, 12) | 0;
                                                               i64toi32_i32$0 = $2;
                                                               i64toi32_i32$2 = HEAP32[($2 + 728 | 0) >> 2] | 0;
                                                               i64toi32_i32$3 = HEAP32[($2 + 732 | 0) >> 2] | 0;
                                                               $832 = i64toi32_i32$2;
                                                               i64toi32_i32$2 = $40;
                                                               HEAP32[i64toi32_i32$2 >> 2] = $832;
                                                               HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                                                               HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = HEAP32[$3 >> 2] | 0;
                                                               HEAP32[($2 + 376 | 0) >> 2] = (HEAP32[($2 + 376 | 0) >> 2] | 0) + 1 | 0;
                                                               label$84 : {
                                                                if (!(HEAP32[($2 + 392 | 0) >> 2] | 0)) {
                                                                 break label$84
                                                                }
                                                                $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($22 | 0);
                                                               }
                                                               i64toi32_i32$0 = $2;
                                                               i64toi32_i32$3 = HEAP32[($2 + 240 | 0) >> 2] | 0;
                                                               i64toi32_i32$2 = HEAP32[($2 + 244 | 0) >> 2] | 0;
                                                               $847 = i64toi32_i32$3;
                                                               i64toi32_i32$3 = $22;
                                                               HEAP32[i64toi32_i32$3 >> 2] = $847;
                                                               HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                                                               HEAP32[(i64toi32_i32$3 + 8 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
                                                               $40 = 0;
                                                               HEAP32[($2 + 392 | 0) >> 2] = 0;
                                                               i64toi32_i32$3 = $2;
                                                               i64toi32_i32$2 = 0;
                                                               HEAP32[($2 + 384 | 0) >> 2] = 0;
                                                               HEAP32[($2 + 388 | 0) >> 2] = i64toi32_i32$2;
                                                               i64toi32_i32$3 = $2;
                                                               i64toi32_i32$2 = 0;
                                                               HEAP32[($2 + 244 | 0) >> 2] = 0;
                                                               HEAP32[($2 + 248 | 0) >> 2] = i64toi32_i32$2;
                                                               cardano_serialization_lib__utils__Value__set_multiasset__hcffccef3fc1cfd59($2 + 384 | 0 | 0, $2 + 240 | 0 | 0);
                                                               $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 240 | 0 | 0);
                                                               $cardano_serialization_lib__address__Address_20as_20core__clone__Clone___clone__h0eb465a6e349d507_2($2 + 240 | 0 | 0, $1 | 0);
                                                               i64toi32_i32$0 = $2;
                                                               i64toi32_i32$2 = HEAP32[($2 + 384 | 0) >> 2] | 0;
                                                               i64toi32_i32$3 = HEAP32[($2 + 388 | 0) >> 2] | 0;
                                                               $45 = i64toi32_i32$2;
                                                               $45$hi = i64toi32_i32$3;
                                                               $41 = 0;
                                                               label$85 : {
                                                                if ((HEAP32[($2 + 392 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                                                                 break label$85
                                                                }
                                                                $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($9 | 0, $22 | 0);
                                                                $41 = 1;
                                                               }
                                                               i64toi32_i32$0 = $3;
                                                               i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                               i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                               $873 = i64toi32_i32$3;
                                                               i64toi32_i32$3 = $36;
                                                               HEAP32[i64toi32_i32$3 >> 2] = $873;
                                                               HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                                                               HEAP32[($2 + 728 | 0) >> 2] = $41;
                                                               i64toi32_i32$0 = $2;
                                                               i64toi32_i32$2 = HEAP32[($2 + 728 | 0) >> 2] | 0;
                                                               i64toi32_i32$3 = HEAP32[($2 + 732 | 0) >> 2] | 0;
                                                               $878 = i64toi32_i32$2;
                                                               i64toi32_i32$2 = $2;
                                                               HEAP32[($2 + 888 | 0) >> 2] = $878;
                                                               HEAP32[($2 + 892 | 0) >> 2] = i64toi32_i32$3;
                                                               memcpy($2 + 728 | 0 | 0, $2 + 240 | 0 | 0, 64 | 0) | 0;
                                                               core__ptr__drop_in_place_cardano_serialization_lib__TransactionOutput___h632b3a99817e6ac5($2 + 408 | 0 | 0);
                                                               memcpy($2 + 408 | 0 | 0, $2 + 728 | 0 | 0, 64 | 0) | 0;
                                                               i64toi32_i32$0 = $36;
                                                               i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                               i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                               $893 = i64toi32_i32$3;
                                                               i64toi32_i32$3 = $26;
                                                               HEAP32[i64toi32_i32$3 >> 2] = $893;
                                                               HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                                                               i64toi32_i32$0 = $2;
                                                               i64toi32_i32$2 = HEAP32[($2 + 888 | 0) >> 2] | 0;
                                                               i64toi32_i32$3 = HEAP32[($2 + 892 | 0) >> 2] | 0;
                                                               $896 = i64toi32_i32$2;
                                                               i64toi32_i32$2 = $8;
                                                               HEAP32[i64toi32_i32$2 >> 2] = $896;
                                                               HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                                                               i64toi32_i32$3 = $45$hi;
                                                               i64toi32_i32$2 = $2;
                                                               HEAP32[($2 + 472 | 0) >> 2] = $45;
                                                               HEAP32[($2 + 476 | 0) >> 2] = i64toi32_i32$3;
                                                               HEAP8[($2 + 496 | 0) >> 0] = 0;
                                                               label$86 : {
                                                                if ((HEAP32[($2 + 480 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                                                                 break label$86
                                                                }
                                                                $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($11 | 0, $20 | 0);
                                                                $40 = 1;
                                                               }
                                                               i64toi32_i32$0 = $5;
                                                               i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                               i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                               $907 = i64toi32_i32$3;
                                                               i64toi32_i32$3 = $3;
                                                               HEAP32[i64toi32_i32$3 >> 2] = $907;
                                                               HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                                                               HEAP32[($2 + 240 | 0) >> 2] = $40;
                                                               i64toi32_i32$0 = $2;
                                                               i64toi32_i32$2 = HEAP32[($2 + 240 | 0) >> 2] | 0;
                                                               i64toi32_i32$3 = HEAP32[($2 + 244 | 0) >> 2] | 0;
                                                               $912 = i64toi32_i32$2;
                                                               i64toi32_i32$2 = $2;
                                                               HEAP32[($2 + 728 | 0) >> 2] = $912;
                                                               HEAP32[($2 + 732 | 0) >> 2] = i64toi32_i32$3;
                                                               label$87 : {
                                                                if (!(HEAP32[($2 + 624 | 0) >> 2] | 0)) {
                                                                 break label$87
                                                                }
                                                                $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($14 | 0);
                                                               }
                                                               i64toi32_i32$0 = $2;
                                                               i64toi32_i32$3 = HEAP32[($2 + 728 | 0) >> 2] | 0;
                                                               i64toi32_i32$2 = HEAP32[($2 + 732 | 0) >> 2] | 0;
                                                               $919 = i64toi32_i32$3;
                                                               i64toi32_i32$3 = $19;
                                                               HEAP32[i64toi32_i32$3 >> 2] = $919;
                                                               HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                                                               i64toi32_i32$0 = $3;
                                                               i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                               i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                               $922 = i64toi32_i32$2;
                                                               i64toi32_i32$2 = $30;
                                                               HEAP32[i64toi32_i32$2 >> 2] = $922;
                                                               HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                                                               i64toi32_i32$3 = $45$hi;
                                                               i64toi32_i32$2 = $2;
                                                               HEAP32[($2 + 616 | 0) >> 2] = $45;
                                                               HEAP32[($2 + 620 | 0) >> 2] = i64toi32_i32$3;
                                                               label$88 : {
                                                                if (!(HEAP32[($2 + 648 | 0) >> 2] | 0)) {
                                                                 break label$88
                                                                }
                                                                $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($13 | 0);
                                                               }
                                                               i64toi32_i32$0 = $2;
                                                               i64toi32_i32$3 = HEAP32[($2 + 240 | 0) >> 2] | 0;
                                                               i64toi32_i32$2 = HEAP32[($2 + 244 | 0) >> 2] | 0;
                                                               $931 = i64toi32_i32$3;
                                                               i64toi32_i32$3 = $13;
                                                               HEAP32[i64toi32_i32$3 >> 2] = $931;
                                                               HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                                                               HEAP32[(i64toi32_i32$3 + 8 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
                                                               HEAP32[($2 + 648 | 0) >> 2] = 0;
                                                               i64toi32_i32$3 = $2;
                                                               i64toi32_i32$2 = 0;
                                                               HEAP32[($2 + 640 | 0) >> 2] = 0;
                                                               HEAP32[($2 + 644 | 0) >> 2] = i64toi32_i32$2;
                                                               $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 664 | 0 | 0);
                                                               i64toi32_i32$3 = $2;
                                                               i64toi32_i32$2 = 0;
                                                               HEAP32[($2 + 668 | 0) >> 2] = 0;
                                                               HEAP32[($2 + 672 | 0) >> 2] = i64toi32_i32$2;
                                                               $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h6c9f94f0f82ce2b5($2 + 696 | 0 | 0);
                                                               i64toi32_i32$3 = $2;
                                                               i64toi32_i32$2 = 0;
                                                               HEAP32[($2 + 700 | 0) >> 2] = 0;
                                                               HEAP32[($2 + 704 | 0) >> 2] = i64toi32_i32$2;
                                                              }
                                                              $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($2 + 240 | 0 | 0, $2 + 712 | 0 | 0);
                                                              i64toi32_i32$2 = $44$hi;
                                                              alloc__collections__btree__map__BTreeMap_K_2cV___insert__hc7622c6487a4ba88($2 + 40 | 0 | 0, $2 + 696 | 0 | 0, $2 + 240 | 0 | 0, $44 | 0, i64toi32_i32$2 | 0);
                                                              $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 712 | 0 | 0);
                                                              $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 712 | 0 | 0);
                                                              $35 = $35 + 1 | 0;
                                                              if (($34 | 0) != ($35 | 0)) {
                                                               continue label$74
                                                              }
                                                              break label$74;
                                                             };
                                                            }
                                                            $193 = $24 + 24 | 0;
                                                            HEAP32[$31 >> 2] = HEAPU8[$193 >> 0] | 0 | ((HEAPU8[($193 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($193 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($193 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                                            i64toi32_i32$0 = $24 + 16 | 0;
                                                            i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                                            i64toi32_i32$3 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                                            $971 = i64toi32_i32$2;
                                                            i64toi32_i32$2 = $33;
                                                            HEAP32[i64toi32_i32$2 >> 2] = $971;
                                                            HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                                                            i64toi32_i32$0 = $24 + 8 | 0;
                                                            i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                                            i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                                            $975 = i64toi32_i32$3;
                                                            i64toi32_i32$3 = $5;
                                                            HEAP32[i64toi32_i32$3 >> 2] = $975;
                                                            HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                                                            i64toi32_i32$0 = $24;
                                                            i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                                            i64toi32_i32$3 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                                            $978 = i64toi32_i32$2;
                                                            i64toi32_i32$2 = $2;
                                                            HEAP32[($2 + 240 | 0) >> 2] = $978;
                                                            HEAP32[($2 + 244 | 0) >> 2] = i64toi32_i32$3;
                                                            $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h3f0faaa5740c6934($2 + 888 | 0 | 0, $2 + 696 | 0 | 0);
                                                            alloc__collections__btree__map__BTreeMap_K_2cV___insert__ha211f93f5765e42b($2 + 728 | 0 | 0, $2 + 664 | 0 | 0, $2 + 240 | 0 | 0, $2 + 888 | 0 | 0);
                                                            label$89 : {
                                                             if (!(HEAP32[($2 + 728 | 0) >> 2] | 0)) {
                                                              break label$89
                                                             }
                                                             $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h6c9f94f0f82ce2b5($9 | 0);
                                                            }
                                                            cardano_serialization_lib__utils__Value__set_multiasset__hcffccef3fc1cfd59($2 + 640 | 0 | 0, $2 + 664 | 0 | 0);
                                                            cardano_serialization_lib__utils__Value__checked_add__h5184687782847801($2 + 240 | 0 | 0, $21 | 0, $2 + 640 | 0 | 0);
                                                            if ((HEAP32[($2 + 240 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                                                             break label$34
                                                            }
                                                            i64toi32_i32$0 = $5 + 16 | 0;
                                                            i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                            i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                            $1010 = i64toi32_i32$3;
                                                            i64toi32_i32$3 = $28;
                                                            HEAP32[i64toi32_i32$3 >> 2] = $1010;
                                                            HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                                                            i64toi32_i32$0 = $5 + 8 | 0;
                                                            i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                            i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                            $1014 = i64toi32_i32$2;
                                                            i64toi32_i32$2 = $3;
                                                            HEAP32[i64toi32_i32$2 >> 2] = $1014;
                                                            HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                                                            i64toi32_i32$0 = $5;
                                                            i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                            i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                            $1017 = i64toi32_i32$3;
                                                            i64toi32_i32$3 = $2;
                                                            HEAP32[($2 + 728 | 0) >> 2] = $1017;
                                                            HEAP32[($2 + 732 | 0) >> 2] = i64toi32_i32$2;
                                                            label$90 : {
                                                             if (!(HEAP32[($2 + 480 | 0) >> 2] | 0)) {
                                                              break label$90
                                                             }
                                                             $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($20 | 0);
                                                            }
                                                            $32 = $21 + 16 | 0;
                                                            i64toi32_i32$0 = $28;
                                                            i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                            i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                            $1026 = i64toi32_i32$2;
                                                            i64toi32_i32$2 = $32;
                                                            HEAP32[i64toi32_i32$2 >> 2] = $1026;
                                                            HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                                                            $28 = $21 + 8 | 0;
                                                            i64toi32_i32$0 = $3;
                                                            i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                            i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                            $1031 = i64toi32_i32$3;
                                                            i64toi32_i32$3 = $28;
                                                            HEAP32[i64toi32_i32$3 >> 2] = $1031;
                                                            HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                                                            i64toi32_i32$0 = $2;
                                                            i64toi32_i32$2 = HEAP32[($2 + 728 | 0) >> 2] | 0;
                                                            i64toi32_i32$3 = HEAP32[($2 + 732 | 0) >> 2] | 0;
                                                            $1034 = i64toi32_i32$2;
                                                            i64toi32_i32$2 = $21;
                                                            HEAP32[i64toi32_i32$2 >> 2] = $1034;
                                                            HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                                                            i64toi32_i32$0 = $2;
                                                            i64toi32_i32$3 = HEAP32[($2 + 472 | 0) >> 2] | 0;
                                                            i64toi32_i32$2 = HEAP32[($2 + 476 | 0) >> 2] | 0;
                                                            $44 = i64toi32_i32$3;
                                                            $44$hi = i64toi32_i32$2;
                                                            $24 = 0;
                                                            label$91 : {
                                                             if ((HEAP32[($2 + 480 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                                                              break label$91
                                                             }
                                                             $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($11 | 0, $20 | 0);
                                                             $24 = 1;
                                                            }
                                                            HEAP32[($2 + 240 | 0) >> 2] = $24;
                                                            i64toi32_i32$0 = $2;
                                                            i64toi32_i32$2 = HEAP32[($2 + 240 | 0) >> 2] | 0;
                                                            i64toi32_i32$3 = HEAP32[($2 + 244 | 0) >> 2] | 0;
                                                            $1046 = i64toi32_i32$2;
                                                            i64toi32_i32$2 = $3;
                                                            HEAP32[i64toi32_i32$2 >> 2] = $1046;
                                                            HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                                                            i64toi32_i32$0 = $5;
                                                            i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                            i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                            $1050 = i64toi32_i32$3;
                                                            i64toi32_i32$3 = $3 + 8 | 0;
                                                            HEAP32[i64toi32_i32$3 >> 2] = $1050;
                                                            HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                                                            i64toi32_i32$2 = $44$hi;
                                                            i64toi32_i32$3 = $2;
                                                            HEAP32[($2 + 728 | 0) >> 2] = $44;
                                                            HEAP32[($2 + 732 | 0) >> 2] = i64toi32_i32$2;
                                                            cardano_serialization_lib__utils__min_ada_required__hfea4b15a263723f5($2 + 240 | 0 | 0, $2 + 640 | 0 | 0, 0 | 0, $6 | 0);
                                                            if ((HEAP32[($2 + 240 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                                                             break label$35
                                                            }
                                                            i64toi32_i32$0 = $2;
                                                            i64toi32_i32$2 = HEAP32[($2 + 248 | 0) >> 2] | 0;
                                                            i64toi32_i32$3 = HEAP32[($2 + 252 | 0) >> 2] | 0;
                                                            $1063 = i64toi32_i32$2;
                                                            i64toi32_i32$2 = $2;
                                                            HEAP32[($2 + 728 | 0) >> 2] = $1063;
                                                            HEAP32[($2 + 732 | 0) >> 2] = i64toi32_i32$3;
                                                            cardano_serialization_lib__utils__Value__to_bytes__h2820e7e1b4035910($2 + 240 | 0 | 0, $2 + 728 | 0 | 0);
                                                            $24 = HEAP32[($2 + 248 | 0) >> 2] | 0;
                                                            $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 240 | 0 | 0);
                                                            $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 240 | 0 | 0);
                                                            if ($24 >>> 0 > $25 >>> 0) {
                                                             break label$69
                                                            }
                                                            label$92 : {
                                                             if (!(HEAP32[($2 + 736 | 0) >> 2] | 0)) {
                                                              break label$92
                                                             }
                                                             $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($12 | 0);
                                                            }
                                                            $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h6c9f94f0f82ce2b5($2 + 696 | 0 | 0);
                                                            $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__he37b42ff2b07ed41($2 + 680 | 0 | 0);
                                                            $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h19d691521e7c48e6($2 + 680 | 0 | 0);
                                                            $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 664 | 0 | 0);
                                                            label$93 : {
                                                             if (!(HEAP32[($2 + 648 | 0) >> 2] | 0)) {
                                                              break label$93
                                                             }
                                                             $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($13 | 0);
                                                            }
                                                            label$94 : {
                                                             if (!(HEAP32[($2 + 624 | 0) >> 2] | 0)) {
                                                              break label$94
                                                             }
                                                             $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($14 | 0);
                                                            }
                                                            $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h03cc330b7b1e4522($2 + 32 | 0 | 0, $2 + 584 | 0 | 0);
                                                            $29 = HEAP32[($2 + 36 | 0) >> 2] | 0;
                                                            $24 = HEAP32[($2 + 32 | 0) >> 2] | 0;
                                                            if ($24) {
                                                             continue label$70
                                                            }
                                                            break label$68;
                                                           }
                                                           break label$70;
                                                          };
                                                          $3 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($2 + 244 | 0) >> 2] | 0 | 0) | 0;
                                                          $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 712 | 0 | 0);
                                                          $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 712 | 0 | 0);
                                                          break label$10;
                                                         }
                                                         i64toi32_i32$0 = ($2 + 616 | 0) + 16 | 0;
                                                         i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                         i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                         $1117 = i64toi32_i32$3;
                                                         i64toi32_i32$3 = $33;
                                                         HEAP32[i64toi32_i32$3 >> 2] = $1117;
                                                         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                                                         i64toi32_i32$0 = $19;
                                                         i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                         i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                         $1120 = i64toi32_i32$2;
                                                         i64toi32_i32$2 = $5;
                                                         HEAP32[i64toi32_i32$2 >> 2] = $1120;
                                                         HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                                                         i64toi32_i32$0 = $2;
                                                         i64toi32_i32$3 = HEAP32[($2 + 616 | 0) >> 2] | 0;
                                                         i64toi32_i32$2 = HEAP32[($2 + 620 | 0) >> 2] | 0;
                                                         $1123 = i64toi32_i32$3;
                                                         i64toi32_i32$3 = $2;
                                                         HEAP32[($2 + 240 | 0) >> 2] = $1123;
                                                         HEAP32[($2 + 244 | 0) >> 2] = i64toi32_i32$2;
                                                         label$95 : {
                                                          if (!(HEAP32[($2 + 480 | 0) >> 2] | 0)) {
                                                           break label$95
                                                          }
                                                          $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($20 | 0);
                                                         }
                                                         i64toi32_i32$0 = $2;
                                                         i64toi32_i32$2 = HEAP32[($2 + 240 | 0) >> 2] | 0;
                                                         i64toi32_i32$3 = HEAP32[($2 + 244 | 0) >> 2] | 0;
                                                         $1130 = i64toi32_i32$2;
                                                         i64toi32_i32$2 = $21;
                                                         HEAP32[i64toi32_i32$2 >> 2] = $1130;
                                                         HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                                                         i64toi32_i32$0 = $33;
                                                         i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                         i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                         $1133 = i64toi32_i32$3;
                                                         i64toi32_i32$3 = $32;
                                                         HEAP32[i64toi32_i32$3 >> 2] = $1133;
                                                         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                                                         i64toi32_i32$0 = $5;
                                                         i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                         i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                         $1136 = i64toi32_i32$2;
                                                         i64toi32_i32$2 = $28;
                                                         HEAP32[i64toi32_i32$2 >> 2] = $1136;
                                                         HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                                                         label$96 : {
                                                          if (!(HEAP32[($2 + 736 | 0) >> 2] | 0)) {
                                                           break label$96
                                                          }
                                                          $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($12 | 0);
                                                         }
                                                         $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h6c9f94f0f82ce2b5($2 + 696 | 0 | 0);
                                                         $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__he37b42ff2b07ed41($2 + 680 | 0 | 0);
                                                         $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h19d691521e7c48e6($2 + 680 | 0 | 0);
                                                         $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 664 | 0 | 0);
                                                         if (!(HEAP32[($2 + 648 | 0) >> 2] | 0)) {
                                                          break label$68
                                                         }
                                                         $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($13 | 0);
                                                        }
                                                        $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 568 | 0 | 0);
                                                        if ((HEAP32[($2 + 480 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                                                         break label$33
                                                        }
                                                        $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($11 | 0, $20 | 0);
                                                        HEAP32[$3 >> 2] = HEAP32[$27 >> 2] | 0;
                                                        i64toi32_i32$0 = $11;
                                                        i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                        i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                        $1165 = i64toi32_i32$3;
                                                        i64toi32_i32$3 = $2;
                                                        HEAP32[($2 + 728 | 0) >> 2] = $1165;
                                                        HEAP32[($2 + 732 | 0) >> 2] = i64toi32_i32$2;
                                                        label$97 : {
                                                         $24 = HEAP32[($2 + 376 | 0) >> 2] | 0;
                                                         if ((HEAP32[($2 + 372 | 0) >> 2] | 0 | 0) != ($24 | 0)) {
                                                          break label$97
                                                         }
                                                         alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hb2d5108633ce5dd7($2 + 368 | 0 | 0, $24 | 0, 1 | 0);
                                                         $24 = HEAP32[($2 + 376 | 0) >> 2] | 0;
                                                        }
                                                        $24 = (HEAP32[($2 + 368 | 0) >> 2] | 0) + Math_imul($24, 12) | 0;
                                                        i64toi32_i32$0 = $2;
                                                        i64toi32_i32$2 = HEAP32[($2 + 728 | 0) >> 2] | 0;
                                                        i64toi32_i32$3 = HEAP32[($2 + 732 | 0) >> 2] | 0;
                                                        $1184 = i64toi32_i32$2;
                                                        i64toi32_i32$2 = $24;
                                                        HEAP32[i64toi32_i32$2 >> 2] = $1184;
                                                        HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                                                        HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = HEAP32[$3 >> 2] | 0;
                                                        HEAP32[($2 + 376 | 0) >> 2] = (HEAP32[($2 + 376 | 0) >> 2] | 0) + 1 | 0;
                                                        $24 = HEAP32[($2 + 368 | 0) >> 2] | 0;
                                                        i64toi32_i32$0 = $2;
                                                        i64toi32_i32$3 = HEAP32[($2 + 372 | 0) >> 2] | 0;
                                                        i64toi32_i32$2 = HEAP32[($2 + 376 | 0) >> 2] | 0;
                                                        $44 = i64toi32_i32$3;
                                                        $44$hi = i64toi32_i32$2;
                                                        core__ptr__drop_in_place_cardano_serialization_lib__TransactionOutput___h632b3a99817e6ac5($2 + 408 | 0 | 0);
                                                        label$98 : {
                                                         if (!(HEAP32[($2 + 392 | 0) >> 2] | 0)) {
                                                          break label$98
                                                         }
                                                         $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($22 | 0);
                                                        }
                                                        HEAP32[($2 + 224 | 0) >> 2] = $24;
                                                        i64toi32_i32$2 = $44$hi;
                                                        i64toi32_i32$3 = $2;
                                                        HEAP32[($2 + 228 | 0) >> 2] = $44;
                                                        HEAP32[($2 + 232 | 0) >> 2] = i64toi32_i32$2;
                                                        i64toi32_i32$0 = $44;
                                                        i64toi32_i32$3 = 0;
                                                        i64toi32_i32$1 = 32;
                                                        i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
                                                        if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                                                         i64toi32_i32$3 = 0;
                                                         $194 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
                                                        } else {
                                                         i64toi32_i32$3 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
                                                         $194 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
                                                        }
                                                        $36 = $194;
                                                        label$99 : {
                                                         i64toi32_i32$3 = $44$hi;
                                                         i64toi32_i32$2 = $44;
                                                         i64toi32_i32$0 = 1;
                                                         i64toi32_i32$1 = 0;
                                                         if (i64toi32_i32$3 >>> 0 > i64toi32_i32$0 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$2 >>> 0 >= i64toi32_i32$1 >>> 0 | 0) | 0) {
                                                          break label$99
                                                         }
                                                         $0 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1065389 | 0, 32 | 0) | 0;
                                                         break label$11;
                                                        }
                                                        HEAP32[($2 + 592 | 0) >> 2] = 0;
                                                        i64toi32_i32$3 = $2;
                                                        i64toi32_i32$2 = 0;
                                                        HEAP32[($2 + 584 | 0) >> 2] = 0;
                                                        HEAP32[($2 + 588 | 0) >> 2] = i64toi32_i32$2;
                                                        label$100 : {
                                                         if (!$36) {
                                                          break label$100
                                                         }
                                                         $40 = Math_imul($36, 12);
                                                         $35 = $40;
                                                         $28 = $24;
                                                         label$101 : while (1) {
                                                          cardano_serialization_lib__utils__Value__set_multiasset__hcffccef3fc1cfd59($2 + 584 | 0 | 0, $28 | 0);
                                                          cardano_serialization_lib__utils__min_ada_required__hfea4b15a263723f5($2 + 408 | 0 | 0, $2 + 584 | 0 | 0, 0 | 0, $6 | 0);
                                                          if ((HEAP32[($2 + 408 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                                                           break label$62
                                                          }
                                                          i64toi32_i32$1 = $2;
                                                          i64toi32_i32$2 = HEAP32[($2 + 416 | 0) >> 2] | 0;
                                                          i64toi32_i32$3 = HEAP32[($2 + 420 | 0) >> 2] | 0;
                                                          $44 = i64toi32_i32$2;
                                                          $44$hi = i64toi32_i32$3;
                                                          i64toi32_i32$2 = $2;
                                                          HEAP32[($2 + 584 | 0) >> 2] = $44;
                                                          HEAP32[($2 + 588 | 0) >> 2] = i64toi32_i32$3;
                                                          $cardano_serialization_lib__address__Address_20as_20core__clone__Clone___clone__h0eb465a6e349d507_2($2 + 240 | 0 | 0, $1 | 0);
                                                          i64toi32_i32$1 = $2;
                                                          i64toi32_i32$3 = HEAP32[($2 + 584 | 0) >> 2] | 0;
                                                          i64toi32_i32$2 = HEAP32[($2 + 588 | 0) >> 2] | 0;
                                                          $45 = i64toi32_i32$3;
                                                          $45$hi = i64toi32_i32$2;
                                                          $32 = 0;
                                                          label$102 : {
                                                           if ((HEAP32[($2 + 592 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                                                            break label$102
                                                           }
                                                           $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($9 | 0, $10 | 0);
                                                           $32 = 1;
                                                          }
                                                          HEAP32[($2 + 728 | 0) >> 2] = $32;
                                                          i64toi32_i32$1 = $2;
                                                          i64toi32_i32$2 = HEAP32[($2 + 728 | 0) >> 2] | 0;
                                                          i64toi32_i32$3 = HEAP32[($2 + 732 | 0) >> 2] | 0;
                                                          $1250 = i64toi32_i32$2;
                                                          i64toi32_i32$2 = $8;
                                                          HEAP32[i64toi32_i32$2 >> 2] = $1250;
                                                          HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                                                          i64toi32_i32$1 = $3;
                                                          i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                                          i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                                          $1253 = i64toi32_i32$3;
                                                          i64toi32_i32$3 = $26;
                                                          HEAP32[i64toi32_i32$3 >> 2] = $1253;
                                                          HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                                                          memcpy($2 + 408 | 0 | 0, $2 + 240 | 0 | 0, 64 | 0) | 0;
                                                          HEAP8[($2 + 496 | 0) >> 0] = 0;
                                                          i64toi32_i32$2 = $45$hi;
                                                          i64toi32_i32$3 = $2;
                                                          HEAP32[($2 + 472 | 0) >> 2] = $45;
                                                          HEAP32[($2 + 476 | 0) >> 2] = i64toi32_i32$2;
                                                          cardano_serialization_lib__tx_builder__TransactionBuilder__fee_for_output__h1f6d4a08a7683cf9($2 + 240 | 0 | 0, $0 | 0, $2 + 408 | 0 | 0);
                                                          if ((HEAP32[($2 + 240 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                                                           break label$61
                                                          }
                                                          i64toi32_i32$2 = $43$hi;
                                                          i64toi32_i32$1 = $2;
                                                          i64toi32_i32$2 = HEAP32[($2 + 248 | 0) >> 2] | 0;
                                                          i64toi32_i32$3 = HEAP32[($2 + 252 | 0) >> 2] | 0;
                                                          $1272 = i64toi32_i32$2;
                                                          $1272$hi = i64toi32_i32$3;
                                                          i64toi32_i32$3 = $43$hi;
                                                          i64toi32_i32$1 = $43;
                                                          i64toi32_i32$2 = $1272$hi;
                                                          i64toi32_i32$0 = $1272;
                                                          i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
                                                          i64toi32_i32$5 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
                                                          if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
                                                           i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
                                                          }
                                                          $45 = i64toi32_i32$4;
                                                          $45$hi = i64toi32_i32$5;
                                                          i64toi32_i32$5 = $43$hi;
                                                          i64toi32_i32$5 = $45$hi;
                                                          i64toi32_i32$3 = i64toi32_i32$4;
                                                          i64toi32_i32$1 = $43$hi;
                                                          i64toi32_i32$0 = $43;
                                                          if (i64toi32_i32$5 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$3 >>> 0 < i64toi32_i32$0 >>> 0 | 0) | 0) {
                                                           break label$60
                                                          }
                                                          i64toi32_i32$3 = $44$hi;
                                                          i64toi32_i32$3 = $45$hi;
                                                          i64toi32_i32$3 = $44$hi;
                                                          i64toi32_i32$0 = $44;
                                                          i64toi32_i32$5 = $45$hi;
                                                          i64toi32_i32$1 = $45;
                                                          i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
                                                          i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
                                                          if (i64toi32_i32$2 >>> 0 < i64toi32_i32$1 >>> 0) {
                                                           i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
                                                          }
                                                          $43 = i64toi32_i32$2;
                                                          $43$hi = i64toi32_i32$4;
                                                          i64toi32_i32$4 = $44$hi;
                                                          i64toi32_i32$4 = $43$hi;
                                                          i64toi32_i32$3 = i64toi32_i32$2;
                                                          i64toi32_i32$0 = $44$hi;
                                                          i64toi32_i32$1 = $44;
                                                          if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0 | 0) | 0) {
                                                           break label$59
                                                          }
                                                          i64toi32_i32$1 = $2;
                                                          i64toi32_i32$3 = HEAP32[($2 + 200 | 0) >> 2] | 0;
                                                          i64toi32_i32$4 = HEAP32[($2 + 204 | 0) >> 2] | 0;
                                                          $1284$hi = i64toi32_i32$4;
                                                          i64toi32_i32$4 = $43$hi;
                                                          i64toi32_i32$4 = $1284$hi;
                                                          i64toi32_i32$1 = i64toi32_i32$3;
                                                          i64toi32_i32$3 = $43$hi;
                                                          i64toi32_i32$0 = $43;
                                                          if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$0 >>> 0 | 0) | 0) {
                                                           break label$58
                                                          }
                                                          cardano_serialization_lib__utils__Value__checked_sub__hadecd14ba2ae4b3b($2 + 240 | 0 | 0, $2 + 200 | 0 | 0, $2 + 584 | 0 | 0);
                                                          if ((HEAP32[($2 + 240 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                                                           break label$57
                                                          }
                                                          $32 = ($2 + 728 | 0) + 16 | 0;
                                                          i64toi32_i32$0 = $5 + 16 | 0;
                                                          i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                          i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                          $1302 = i64toi32_i32$1;
                                                          i64toi32_i32$1 = $32;
                                                          HEAP32[i64toi32_i32$1 >> 2] = $1302;
                                                          HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$4;
                                                          i64toi32_i32$0 = $5 + 8 | 0;
                                                          i64toi32_i32$4 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                          i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                          $1306 = i64toi32_i32$4;
                                                          i64toi32_i32$4 = $3;
                                                          HEAP32[i64toi32_i32$4 >> 2] = $1306;
                                                          HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$1;
                                                          i64toi32_i32$0 = $5;
                                                          i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                          i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                          $1309 = i64toi32_i32$1;
                                                          i64toi32_i32$1 = $2;
                                                          HEAP32[($2 + 728 | 0) >> 2] = $1309;
                                                          HEAP32[($2 + 732 | 0) >> 2] = i64toi32_i32$4;
                                                          label$103 : {
                                                           if (!(HEAP32[($2 + 208 | 0) >> 2] | 0)) {
                                                            break label$103
                                                           }
                                                           $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($7 | 0);
                                                          }
                                                          i64toi32_i32$0 = $32;
                                                          i64toi32_i32$4 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                          i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                          $1318 = i64toi32_i32$4;
                                                          i64toi32_i32$4 = ($2 + 200 | 0) + 16 | 0;
                                                          HEAP32[i64toi32_i32$4 >> 2] = $1318;
                                                          HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$1;
                                                          i64toi32_i32$0 = $3;
                                                          i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                          i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                          $1323 = i64toi32_i32$1;
                                                          i64toi32_i32$1 = ($2 + 200 | 0) + 8 | 0;
                                                          HEAP32[i64toi32_i32$1 >> 2] = $1323;
                                                          HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$4;
                                                          i64toi32_i32$0 = $2;
                                                          i64toi32_i32$4 = HEAP32[($2 + 728 | 0) >> 2] | 0;
                                                          i64toi32_i32$1 = HEAP32[($2 + 732 | 0) >> 2] | 0;
                                                          $1326 = i64toi32_i32$4;
                                                          i64toi32_i32$4 = $2;
                                                          HEAP32[($2 + 200 | 0) >> 2] = $1326;
                                                          HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$1;
                                                          cardano_serialization_lib__tx_builder__TransactionBuilder__add_output__h626cdf41f713b689($2 + 24 | 0 | 0, $0 | 0, $2 + 408 | 0 | 0);
                                                          if (HEAP32[($2 + 24 | 0) >> 2] | 0) {
                                                           break label$56
                                                          }
                                                          $28 = $28 + 12 | 0;
                                                          core__ptr__drop_in_place_cardano_serialization_lib__TransactionOutput___h632b3a99817e6ac5($2 + 408 | 0 | 0);
                                                          i64toi32_i32$1 = $45$hi;
                                                          $43 = $45;
                                                          $43$hi = i64toi32_i32$1;
                                                          $35 = $35 + -12 | 0;
                                                          if ($35) {
                                                           continue label$101
                                                          }
                                                          break label$101;
                                                         };
                                                         label$104 : {
                                                          if (!(HEAP32[($2 + 592 | 0) >> 2] | 0)) {
                                                           break label$104
                                                          }
                                                          $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($10 | 0);
                                                         }
                                                         label$105 : {
                                                          if (!$36) {
                                                           break label$105
                                                          }
                                                          label$106 : while (1) {
                                                           $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($24 | 0);
                                                           $24 = $24 + 12 | 0;
                                                           $40 = $40 + -12 | 0;
                                                           if ($40) {
                                                            continue label$106
                                                           }
                                                           break label$106;
                                                          };
                                                         }
                                                         i64toi32_i32$1 = $45$hi;
                                                         $43 = $45;
                                                         $43$hi = i64toi32_i32$1;
                                                        }
                                                        $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h2a00dda64f22da3c($2 + 224 | 0 | 0);
                                                        if ((HEAP32[($2 + 208 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                                                         continue label$64
                                                        }
                                                        break label$64;
                                                       };
                                                      }
                                                      HEAP32[($2 + 248 | 0) >> 2] = 0;
                                                      i64toi32_i32$1 = $43$hi;
                                                      i64toi32_i32$4 = $2;
                                                      HEAP32[($2 + 240 | 0) >> 2] = $43;
                                                      HEAP32[($2 + 244 | 0) >> 2] = i64toi32_i32$1;
                                                      cardano_serialization_lib__utils__Value__checked_sub__hadecd14ba2ae4b3b($2 + 408 | 0 | 0, $2 + 200 | 0 | 0, $2 + 240 | 0 | 0);
                                                      if ((HEAP32[($2 + 408 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                                                       break label$26
                                                      }
                                                      $3 = ($2 + 728 | 0) + 16 | 0;
                                                      i64toi32_i32$0 = $2 + 432 | 0;
                                                      i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                      i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                      $1378 = i64toi32_i32$1;
                                                      i64toi32_i32$1 = $3;
                                                      HEAP32[i64toi32_i32$1 >> 2] = $1378;
                                                      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$4;
                                                      $4 = ($2 + 728 | 0) + 8 | 0;
                                                      i64toi32_i32$0 = ($2 + 408 | 0) + 16 | 0;
                                                      i64toi32_i32$4 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                      i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                      $1386 = i64toi32_i32$4;
                                                      i64toi32_i32$4 = $4;
                                                      HEAP32[i64toi32_i32$4 >> 2] = $1386;
                                                      HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$1;
                                                      i64toi32_i32$0 = ($2 + 408 | 0) + 8 | 0;
                                                      i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                      i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                      $1391 = i64toi32_i32$1;
                                                      i64toi32_i32$1 = $2;
                                                      HEAP32[($2 + 728 | 0) >> 2] = $1391;
                                                      HEAP32[($2 + 732 | 0) >> 2] = i64toi32_i32$4;
                                                      label$107 : {
                                                       if (!(HEAP32[($2 + 208 | 0) >> 2] | 0)) {
                                                        break label$107
                                                       }
                                                       $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 212 | 0 | 0);
                                                      }
                                                      i64toi32_i32$0 = $3;
                                                      i64toi32_i32$4 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                      i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                      $1401 = i64toi32_i32$4;
                                                      i64toi32_i32$4 = ($2 + 200 | 0) + 16 | 0;
                                                      HEAP32[i64toi32_i32$4 >> 2] = $1401;
                                                      HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$1;
                                                      i64toi32_i32$0 = $4;
                                                      i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                      i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                      $1406 = i64toi32_i32$1;
                                                      i64toi32_i32$1 = ($2 + 200 | 0) + 8 | 0;
                                                      HEAP32[i64toi32_i32$1 >> 2] = $1406;
                                                      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$4;
                                                      i64toi32_i32$0 = $2;
                                                      i64toi32_i32$4 = HEAP32[($2 + 728 | 0) >> 2] | 0;
                                                      i64toi32_i32$1 = HEAP32[($2 + 732 | 0) >> 2] | 0;
                                                      $1409 = i64toi32_i32$4;
                                                      i64toi32_i32$4 = $2;
                                                      HEAP32[($2 + 200 | 0) >> 2] = $1409;
                                                      HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$1;
                                                      label$108 : {
                                                       if (!(HEAP32[($2 + 248 | 0) >> 2] | 0)) {
                                                        break label$108
                                                       }
                                                       $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 252 | 0 | 0);
                                                      }
                                                      i64toi32_i32$0 = $2;
                                                      i64toi32_i32$1 = HEAP32[($2 + 200 | 0) >> 2] | 0;
                                                      i64toi32_i32$4 = HEAP32[($2 + 204 | 0) >> 2] | 0;
                                                      $44 = i64toi32_i32$1;
                                                      $44$hi = i64toi32_i32$4;
                                                      i64toi32_i32$4 = $46$hi;
                                                      i64toi32_i32$4 = $44$hi;
                                                      i64toi32_i32$0 = i64toi32_i32$1;
                                                      i64toi32_i32$1 = $46$hi;
                                                      i64toi32_i32$3 = $46;
                                                      if (i64toi32_i32$4 >>> 0 > i64toi32_i32$1 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$0 >>> 0 > i64toi32_i32$3 >>> 0 | 0) | 0) {
                                                       break label$25
                                                      }
                                                      i64toi32_i32$0 = $43$hi;
                                                      $45 = $43;
                                                      $45$hi = i64toi32_i32$0;
                                                      break label$24;
                                                     }
                                                     $0 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($2 + 412 | 0) >> 2] | 0 | 0) | 0;
                                                     break label$27;
                                                    }
                                                    $0 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($2 + 244 | 0) >> 2] | 0 | 0) | 0;
                                                    break label$28;
                                                   }
                                                   $0 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1058732 | 0, 8 | 0) | 0 | 0) | 0;
                                                   break label$28;
                                                  }
                                                  $0 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1058732 | 0, 8 | 0) | 0 | 0) | 0;
                                                  break label$28;
                                                 }
                                                 $0 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1065320 | 0, 69 | 0) | 0;
                                                 break label$28;
                                                }
                                                $0 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($2 + 244 | 0) >> 2] | 0 | 0) | 0;
                                                break label$28;
                                               }
                                               $0 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($2 + 28 | 0) >> 2] | 0 | 0) | 0;
                                               break label$28;
                                              }
                                              $0 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($2 + 412 | 0) >> 2] | 0 | 0) | 0;
                                              break label$6;
                                             }
                                             $cardano_serialization_lib__address__Address_20as_20core__clone__Clone___clone__h0eb465a6e349d507_2($2 + 240 | 0 | 0, $1 | 0);
                                             i64toi32_i32$3 = $2;
                                             i64toi32_i32$0 = HEAP32[($2 + 176 | 0) >> 2] | 0;
                                             i64toi32_i32$4 = HEAP32[($2 + 180 | 0) >> 2] | 0;
                                             $44 = i64toi32_i32$0;
                                             $44$hi = i64toi32_i32$4;
                                             $3 = 0;
                                             label$109 : {
                                              if ((HEAP32[($2 + 184 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                                               break label$109
                                              }
                                              $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($2 + 728 | 0 | 4 | 0 | 0, $2 + 188 | 0 | 0);
                                              $3 = 1;
                                             }
                                             HEAP32[($2 + 728 | 0) >> 2] = $3;
                                             i64toi32_i32$3 = $2;
                                             i64toi32_i32$4 = HEAP32[($2 + 728 | 0) >> 2] | 0;
                                             i64toi32_i32$0 = HEAP32[($2 + 732 | 0) >> 2] | 0;
                                             $1459 = i64toi32_i32$4;
                                             i64toi32_i32$4 = $2 + 480 | 0;
                                             HEAP32[i64toi32_i32$4 >> 2] = $1459;
                                             HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$0;
                                             i64toi32_i32$3 = ($2 + 728 | 0) + 8 | 0;
                                             i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                             i64toi32_i32$4 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                             $1465 = i64toi32_i32$0;
                                             i64toi32_i32$0 = $2 + 488 | 0;
                                             HEAP32[i64toi32_i32$0 >> 2] = $1465;
                                             HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$4;
                                             memcpy($2 + 408 | 0 | 0, $2 + 240 | 0 | 0, 64 | 0) | 0;
                                             HEAP8[($2 + 496 | 0) >> 0] = 0;
                                             i64toi32_i32$4 = $44$hi;
                                             i64toi32_i32$0 = $2;
                                             HEAP32[($2 + 472 | 0) >> 2] = $44;
                                             HEAP32[($2 + 476 | 0) >> 2] = i64toi32_i32$4;
                                             cardano_serialization_lib__tx_builder__TransactionBuilder__fee_for_output__h1f6d4a08a7683cf9($2 + 584 | 0 | 0, $0 | 0, $2 + 408 | 0 | 0);
                                             if ((HEAP32[($2 + 584 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                                              break label$32
                                             }
                                             i64toi32_i32$3 = ($2 + 584 | 0) + 8 | 0;
                                             i64toi32_i32$4 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                             i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                             $44 = i64toi32_i32$4;
                                             $44$hi = i64toi32_i32$0;
                                             core__ptr__drop_in_place_cardano_serialization_lib__TransactionOutput___h632b3a99817e6ac5($2 + 408 | 0 | 0);
                                             i64toi32_i32$0 = $43$hi;
                                             i64toi32_i32$0 = $44$hi;
                                             i64toi32_i32$0 = $43$hi;
                                             i64toi32_i32$3 = $43;
                                             i64toi32_i32$4 = $44$hi;
                                             i64toi32_i32$1 = $44;
                                             i64toi32_i32$5 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
                                             i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
                                             if (i64toi32_i32$5 >>> 0 < i64toi32_i32$1 >>> 0) {
                                              i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
                                             }
                                             $44 = i64toi32_i32$5;
                                             $44$hi = i64toi32_i32$2;
                                             i64toi32_i32$2 = $43$hi;
                                             i64toi32_i32$2 = $44$hi;
                                             i64toi32_i32$0 = i64toi32_i32$5;
                                             i64toi32_i32$3 = $43$hi;
                                             i64toi32_i32$1 = $43;
                                             if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0 | 0) | 0) {
                                              break label$31
                                             }
                                             i64toi32_i32$0 = $45$hi;
                                             i64toi32_i32$0 = $44$hi;
                                             i64toi32_i32$0 = $45$hi;
                                             i64toi32_i32$1 = $45;
                                             i64toi32_i32$2 = $44$hi;
                                             i64toi32_i32$3 = $44;
                                             i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
                                             i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
                                             if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
                                              i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
                                             }
                                             $43 = i64toi32_i32$4;
                                             $43$hi = i64toi32_i32$5;
                                             i64toi32_i32$5 = $45$hi;
                                             i64toi32_i32$5 = $43$hi;
                                             i64toi32_i32$0 = i64toi32_i32$4;
                                             i64toi32_i32$1 = $45$hi;
                                             i64toi32_i32$3 = $45;
                                             if (i64toi32_i32$5 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0) {
                                              break label$30
                                             }
                                             i64toi32_i32$5 = $0;
                                             i64toi32_i32$0 = 0;
                                             HEAP32[(i64toi32_i32$5 + 256 | 0) >> 2] = 1;
                                             HEAP32[(i64toi32_i32$5 + 260 | 0) >> 2] = i64toi32_i32$0;
                                             label$110 : {
                                              i64toi32_i32$3 = $2;
                                              i64toi32_i32$0 = HEAP32[($2 + 176 | 0) >> 2] | 0;
                                              i64toi32_i32$5 = HEAP32[($2 + 180 | 0) >> 2] | 0;
                                              $45 = i64toi32_i32$0;
                                              $45$hi = i64toi32_i32$5;
                                              i64toi32_i32$5 = $43$hi;
                                              i64toi32_i32$5 = $45$hi;
                                              i64toi32_i32$3 = i64toi32_i32$0;
                                              i64toi32_i32$0 = $43$hi;
                                              i64toi32_i32$1 = $43;
                                              if (i64toi32_i32$5 >>> 0 > i64toi32_i32$0 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$3 >>> 0 >= i64toi32_i32$1 >>> 0 | 0) | 0) {
                                               break label$110
                                              }
                                              i64toi32_i32$3 = $45$hi;
                                              i64toi32_i32$5 = $0;
                                              HEAP32[(i64toi32_i32$5 + 264 | 0) >> 2] = $45;
                                              HEAP32[(i64toi32_i32$5 + 268 | 0) >> 2] = i64toi32_i32$3;
                                              i64toi32_i32$3 = 0;
                                              $44 = 0;
                                              $44$hi = i64toi32_i32$3;
                                              break label$20;
                                             }
                                             i64toi32_i32$3 = $44$hi;
                                             i64toi32_i32$5 = $0;
                                             HEAP32[(i64toi32_i32$5 + 264 | 0) >> 2] = $44;
                                             HEAP32[(i64toi32_i32$5 + 268 | 0) >> 2] = i64toi32_i32$3;
                                             $cardano_serialization_lib__address__Address_20as_20core__clone__Clone___clone__h0eb465a6e349d507_2($2 + 240 | 0 | 0, $1 | 0);
                                             HEAP32[($2 + 592 | 0) >> 2] = 0;
                                             i64toi32_i32$5 = $2;
                                             HEAP32[($2 + 584 | 0) >> 2] = $44;
                                             HEAP32[($2 + 588 | 0) >> 2] = i64toi32_i32$3;
                                             cardano_serialization_lib__utils__Value__checked_sub__hadecd14ba2ae4b3b($2 + 728 | 0 | 0, $2 + 176 | 0 | 0, $2 + 584 | 0 | 0);
                                             label$111 : {
                                              label$112 : {
                                               if ((HEAP32[($2 + 728 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                                                break label$112
                                               }
                                               i64toi32_i32$1 = $2 + 752 | 0;
                                               i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                               i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                               $1529 = i64toi32_i32$3;
                                               i64toi32_i32$3 = $2 + 488 | 0;
                                               HEAP32[i64toi32_i32$3 >> 2] = $1529;
                                               HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
                                               i64toi32_i32$1 = $2 + 744 | 0;
                                               i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                               i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                               $1534 = i64toi32_i32$5;
                                               i64toi32_i32$5 = $2 + 480 | 0;
                                               HEAP32[i64toi32_i32$5 >> 2] = $1534;
                                               HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$3;
                                               i64toi32_i32$1 = $2 + 736 | 0;
                                               i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                               i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                               $1538 = i64toi32_i32$3;
                                               i64toi32_i32$3 = $2;
                                               HEAP32[($2 + 472 | 0) >> 2] = $1538;
                                               HEAP32[($2 + 476 | 0) >> 2] = i64toi32_i32$5;
                                               memcpy($2 + 408 | 0 | 0, $2 + 240 | 0 | 0, 64 | 0) | 0;
                                               HEAP8[($2 + 496 | 0) >> 0] = 0;
                                               cardano_serialization_lib__tx_builder__TransactionBuilder__add_output__h626cdf41f713b689($2 + 8 | 0 | 0, $0 | 0, $2 + 408 | 0 | 0);
                                               if (HEAP32[($2 + 8 | 0) >> 2] | 0) {
                                                break label$111
                                               }
                                               core__ptr__drop_in_place_cardano_serialization_lib__TransactionOutput___h632b3a99817e6ac5($2 + 408 | 0 | 0);
                                               if (!(HEAP32[($2 + 592 | 0) >> 2] | 0)) {
                                                break label$21
                                               }
                                               $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 596 | 0 | 0);
                                               break label$21;
                                              }
                                              $0 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($2 + 732 | 0) >> 2] | 0 | 0) | 0;
                                              if ((HEAPU8[($2 + 240 | 0) >> 0] | 0) >>> 0 < 4 >>> 0) {
                                               break label$29
                                              }
                                              core__ptr__drop_in_place_cardano_serialization_lib__address__ByronAddress___he7d0684706668546($2 + 240 | 0 | 4 | 0 | 0);
                                              break label$29;
                                             }
                                             $0 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0) | 0;
                                             core__ptr__drop_in_place_cardano_serialization_lib__TransactionOutput___h632b3a99817e6ac5($2 + 408 | 0 | 0);
                                             break label$29;
                                            default:
                                             i64toi32_i32$5 = 0;
                                             $43 = 1;
                                             $43$hi = i64toi32_i32$5;
                                             i64toi32_i32$5 = 0;
                                             $44 = 0;
                                             $44$hi = i64toi32_i32$5;
                                             $0 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1065421 | 0, 33 | 0) | 0;
                                             break label$17;
                                            case 1:
                                             break label$48;
                                            };
                                           }
                                           cardano_serialization_lib__utils__Value__checked_sub__hadecd14ba2ae4b3b($2 + 408 | 0 | 0, $2 + 80 | 0 | 0, $2 + 104 | 0 | 0);
                                           label$113 : {
                                            if ((HEAP32[($2 + 408 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                                             break label$113
                                            }
                                            i64toi32_i32$1 = $2 + 432 | 0;
                                            i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                            i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                            $1588 = i64toi32_i32$5;
                                            i64toi32_i32$5 = ($2 + 240 | 0) + 16 | 0;
                                            HEAP32[i64toi32_i32$5 >> 2] = $1588;
                                            HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$3;
                                            i64toi32_i32$1 = ($2 + 408 | 0) + 16 | 0;
                                            i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                            i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                            $43 = i64toi32_i32$3;
                                            $43$hi = i64toi32_i32$5;
                                            i64toi32_i32$3 = ($2 + 240 | 0) + 8 | 0;
                                            HEAP32[i64toi32_i32$3 >> 2] = $43;
                                            HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
                                            i64toi32_i32$1 = ($2 + 408 | 0) + 8 | 0;
                                            i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                                            i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                                            $44 = i64toi32_i32$5;
                                            $44$hi = i64toi32_i32$3;
                                            i64toi32_i32$5 = $2;
                                            HEAP32[($2 + 240 | 0) >> 2] = $44;
                                            HEAP32[($2 + 244 | 0) >> 2] = i64toi32_i32$3;
                                            i64toi32_i32$5 = $0 + 264 | 0;
                                            HEAP32[i64toi32_i32$5 >> 2] = $44;
                                            HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$3;
                                            i64toi32_i32$5 = $0;
                                            i64toi32_i32$3 = 0;
                                            HEAP32[(i64toi32_i32$5 + 256 | 0) >> 2] = 1;
                                            HEAP32[(i64toi32_i32$5 + 260 | 0) >> 2] = i64toi32_i32$3;
                                            label$114 : {
                                             i64toi32_i32$3 = $43$hi;
                                             if (!$43) {
                                              break label$114
                                             }
                                             $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 252 | 0 | 0);
                                            }
                                            i64toi32_i32$3 = 0;
                                            $44 = 0;
                                            $44$hi = i64toi32_i32$3;
                                            i64toi32_i32$3 = 0;
                                            $43 = 0;
                                            $43$hi = i64toi32_i32$3;
                                            break label$17;
                                           }
                                           $0 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($2 + 412 | 0) >> 2] | 0 | 0) | 0;
                                           break label$5;
                                          }
                                          i64toi32_i32$3 = 0;
                                          $43 = 1;
                                          $43$hi = i64toi32_i32$3;
                                          i64toi32_i32$3 = 0;
                                          $44 = 0;
                                          $44$hi = i64toi32_i32$3;
                                          $0 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($2 + 412 | 0) >> 2] | 0 | 0) | 0;
                                          break label$1;
                                         }
                                         core__panicking__panic__h2fd385a887c8bf13(1063668 | 0, 43 | 0, 1065532 | 0);
                                         abort();
                                        }
                                        core__panicking__panic__h2fd385a887c8bf13(1063668 | 0, 43 | 0, 1065548 | 0);
                                        abort();
                                       }
                                       HEAP32[($2 + 888 | 0) >> 2] = HEAP32[($2 + 732 | 0) >> 2] | 0;
                                       core__result__unwrap_failed__h27f43d993c3864a1(1063711 | 0, 43 | 0, $2 + 888 | 0 | 0, 1063756 | 0, 1065500 | 0);
                                       abort();
                                      }
                                      HEAP32[($2 + 888 | 0) >> 2] = HEAP32[($2 + 732 | 0) >> 2] | 0;
                                      core__result__unwrap_failed__h27f43d993c3864a1(1063711 | 0, 43 | 0, $2 + 888 | 0 | 0, 1063756 | 0, 1065516 | 0);
                                      abort();
                                     }
                                     core__panicking__panic__h2fd385a887c8bf13(1063668 | 0, 43 | 0, 1065564 | 0);
                                     abort();
                                    }
                                    HEAP32[($2 + 888 | 0) >> 2] = HEAP32[($2 + 244 | 0) >> 2] | 0;
                                    core__result__unwrap_failed__h27f43d993c3864a1(1063711 | 0, 43 | 0, $2 + 888 | 0 | 0, 1063756 | 0, 1065580 | 0);
                                    abort();
                                   }
                                   $3 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($2 + 244 | 0) >> 2] | 0 | 0) | 0;
                                   break label$10;
                                  }
                                  core__panicking__panic__h2fd385a887c8bf13(1063668 | 0, 43 | 0, 1065596 | 0);
                                  abort();
                                 }
                                 $0 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($2 + 588 | 0) >> 2] | 0 | 0) | 0;
                                 core__ptr__drop_in_place_cardano_serialization_lib__TransactionOutput___h632b3a99817e6ac5($2 + 408 | 0 | 0);
                                 break label$6;
                                }
                                $0 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1058732 | 0, 8 | 0) | 0 | 0) | 0;
                                break label$6;
                               }
                               $0 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1058732 | 0, 8 | 0) | 0 | 0) | 0;
                               break label$6;
                              }
                              if (!(HEAP32[($2 + 592 | 0) >> 2] | 0)) {
                               break label$6
                              }
                              $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 596 | 0 | 0);
                              break label$6;
                             }
                             core__ptr__drop_in_place_cardano_serialization_lib__TransactionOutput___h632b3a99817e6ac5($2 + 408 | 0 | 0);
                            }
                            if (!(HEAP32[($2 + 592 | 0) >> 2] | 0)) {
                             break label$11
                            }
                            $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($10 | 0);
                            break label$11;
                           }
                           $0 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($2 + 412 | 0) >> 2] | 0 | 0) | 0;
                           if (!(HEAP32[($2 + 248 | 0) >> 2] | 0)) {
                            break label$8
                           }
                           $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 252 | 0 | 0);
                           break label$8;
                          }
                          label$115 : {
                           if (HEAPU8[($0 + 88 | 0) >> 0] | 0) {
                            break label$115
                           }
                           i64toi32_i32$5 = $0;
                           i64toi32_i32$3 = 0;
                           HEAP32[(i64toi32_i32$5 + 256 | 0) >> 2] = 1;
                           HEAP32[(i64toi32_i32$5 + 260 | 0) >> 2] = i64toi32_i32$3;
                           i64toi32_i32$3 = $43$hi;
                           i64toi32_i32$5 = i64toi32_i32$5 + 264 | 0;
                           HEAP32[i64toi32_i32$5 >> 2] = $43;
                           HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$3;
                           break label$23;
                          }
                          $cardano_serialization_lib__address__Address_20as_20core__clone__Clone___clone__h0eb465a6e349d507_2($2 + 408 | 0 | 0, $1 | 0);
                          i64toi32_i32$1 = $2;
                          i64toi32_i32$3 = HEAP32[($2 + 200 | 0) >> 2] | 0;
                          i64toi32_i32$5 = HEAP32[($2 + 204 | 0) >> 2] | 0;
                          $44 = i64toi32_i32$3;
                          $44$hi = i64toi32_i32$5;
                          $3 = 0;
                          label$116 : {
                           if ((HEAP32[($2 + 208 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                            break label$116
                           }
                           $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($2 + 728 | 0 | 4 | 0 | 0, $2 + 212 | 0 | 0);
                           $3 = 1;
                          }
                          HEAP32[($2 + 728 | 0) >> 2] = $3;
                          i64toi32_i32$1 = $2;
                          i64toi32_i32$5 = HEAP32[($2 + 728 | 0) >> 2] | 0;
                          i64toi32_i32$3 = HEAP32[($2 + 732 | 0) >> 2] | 0;
                          $1688 = i64toi32_i32$5;
                          i64toi32_i32$5 = $2 + 312 | 0;
                          HEAP32[i64toi32_i32$5 >> 2] = $1688;
                          HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$3;
                          i64toi32_i32$1 = ($2 + 728 | 0) + 8 | 0;
                          i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                          i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                          $1694 = i64toi32_i32$3;
                          i64toi32_i32$3 = $2 + 320 | 0;
                          HEAP32[i64toi32_i32$3 >> 2] = $1694;
                          HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
                          memcpy($2 + 240 | 0 | 0, $2 + 408 | 0 | 0, 64 | 0) | 0;
                          HEAP8[($2 + 328 | 0) >> 0] = 0;
                          i64toi32_i32$5 = $44$hi;
                          i64toi32_i32$3 = $2;
                          HEAP32[($2 + 304 | 0) >> 2] = $44;
                          HEAP32[($2 + 308 | 0) >> 2] = i64toi32_i32$5;
                          cardano_serialization_lib__tx_builder__TransactionBuilder__fee_for_output__h1f6d4a08a7683cf9($2 + 408 | 0 | 0, $0 | 0, $2 + 240 | 0 | 0);
                          label$117 : {
                           label$118 : {
                            label$119 : {
                             label$120 : {
                              if ((HEAP32[($2 + 408 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                               break label$120
                              }
                              i64toi32_i32$1 = ($2 + 408 | 0) + 8 | 0;
                              i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                              i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                              $44 = i64toi32_i32$5;
                              $44$hi = i64toi32_i32$3;
                              HEAP32[($2 + 736 | 0) >> 2] = 0;
                              i64toi32_i32$5 = $2;
                              HEAP32[($2 + 728 | 0) >> 2] = $44;
                              HEAP32[($2 + 732 | 0) >> 2] = i64toi32_i32$3;
                              cardano_serialization_lib__utils__Value__checked_sub__hadecd14ba2ae4b3b($2 + 408 | 0 | 0, $2 + 200 | 0 | 0, $2 + 728 | 0 | 0);
                              if ((HEAP32[($2 + 408 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                               break label$119
                              }
                              i64toi32_i32$1 = $2 + 432 | 0;
                              i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                              i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                              $1732 = i64toi32_i32$3;
                              i64toi32_i32$3 = ($2 + 584 | 0) + 16 | 0;
                              HEAP32[i64toi32_i32$3 >> 2] = $1732;
                              HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
                              i64toi32_i32$1 = ($2 + 408 | 0) + 16 | 0;
                              i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                              i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                              $1739 = i64toi32_i32$5;
                              i64toi32_i32$5 = ($2 + 584 | 0) + 8 | 0;
                              HEAP32[i64toi32_i32$5 >> 2] = $1739;
                              HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$3;
                              i64toi32_i32$1 = ($2 + 408 | 0) + 8 | 0;
                              i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                              i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                              $1744 = i64toi32_i32$3;
                              i64toi32_i32$3 = $2;
                              HEAP32[($2 + 584 | 0) >> 2] = $1744;
                              HEAP32[($2 + 588 | 0) >> 2] = i64toi32_i32$5;
                              label$121 : {
                               if (!(HEAP32[($2 + 736 | 0) >> 2] | 0)) {
                                break label$121
                               }
                               $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 740 | 0 | 0);
                              }
                              i64toi32_i32$1 = $2;
                              i64toi32_i32$5 = HEAP32[($2 + 584 | 0) >> 2] | 0;
                              i64toi32_i32$3 = HEAP32[($2 + 588 | 0) >> 2] | 0;
                              $1751$hi = i64toi32_i32$3;
                              i64toi32_i32$3 = $46$hi;
                              i64toi32_i32$3 = $1751$hi;
                              i64toi32_i32$1 = i64toi32_i32$5;
                              i64toi32_i32$5 = $46$hi;
                              i64toi32_i32$0 = $46;
                              if (i64toi32_i32$3 >>> 0 > i64toi32_i32$5 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$1 >>> 0 > i64toi32_i32$0 >>> 0 | 0) | 0) {
                               break label$118
                              }
                              i64toi32_i32$1 = $43$hi;
                              $45 = $43;
                              $45$hi = i64toi32_i32$1;
                              break label$117;
                             }
                             $0 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($2 + 412 | 0) >> 2] | 0 | 0) | 0;
                             break label$12;
                            }
                            $0 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($2 + 412 | 0) >> 2] | 0 | 0) | 0;
                            if (!(HEAP32[($2 + 736 | 0) >> 2] | 0)) {
                             break label$12
                            }
                            $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 740 | 0 | 0);
                            break label$12;
                           }
                           i64toi32_i32$1 = $43$hi;
                           i64toi32_i32$1 = $44$hi;
                           i64toi32_i32$1 = $43$hi;
                           i64toi32_i32$0 = $43;
                           i64toi32_i32$3 = $44$hi;
                           i64toi32_i32$5 = $44;
                           i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
                           i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
                           if (i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0) {
                            i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
                           }
                           $45 = i64toi32_i32$2;
                           $45$hi = i64toi32_i32$4;
                           i64toi32_i32$4 = $43$hi;
                           i64toi32_i32$4 = $45$hi;
                           i64toi32_i32$1 = i64toi32_i32$2;
                           i64toi32_i32$0 = $43$hi;
                           i64toi32_i32$5 = $43;
                           if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0 | 0) | 0) {
                            break label$19
                           }
                           label$122 : {
                            if (!(HEAP32[($2 + 208 | 0) >> 2] | 0)) {
                             break label$122
                            }
                            $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 212 | 0 | 0);
                           }
                           i64toi32_i32$5 = $2;
                           i64toi32_i32$1 = HEAP32[($2 + 408 | 0) >> 2] | 0;
                           i64toi32_i32$4 = HEAP32[($2 + 412 | 0) >> 2] | 0;
                           $1781 = i64toi32_i32$1;
                           i64toi32_i32$1 = ($2 + 200 | 0) + 12 | 0;
                           HEAP32[i64toi32_i32$1 >> 2] = $1781;
                           HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$4;
                           HEAP32[($2 + 220 | 0) >> 2] = HEAP32[(($2 + 408 | 0) + 8 | 0) >> 2] | 0;
                           HEAP32[($2 + 208 | 0) >> 2] = 0;
                           i64toi32_i32$1 = $2;
                           i64toi32_i32$4 = 0;
                           HEAP32[($2 + 200 | 0) >> 2] = 0;
                           HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$4;
                           $cardano_serialization_lib__address__Address_20as_20core__clone__Clone___clone__h0eb465a6e349d507_2($2 + 728 | 0 | 0, $1 | 0);
                           i64toi32_i32$5 = $2;
                           i64toi32_i32$4 = HEAP32[($2 + 584 | 0) >> 2] | 0;
                           i64toi32_i32$1 = HEAP32[($2 + 588 | 0) >> 2] | 0;
                           $43 = i64toi32_i32$4;
                           $43$hi = i64toi32_i32$1;
                           $1 = 0;
                           label$123 : {
                            if ((HEAP32[($2 + 592 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                             break label$123
                            }
                            $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($2 + 536 | 0 | 4 | 0 | 0, ($2 + 584 | 0) + 12 | 0 | 0);
                            $1 = 1;
                           }
                           HEAP32[($2 + 536 | 0) >> 2] = $1;
                           i64toi32_i32$5 = $2;
                           i64toi32_i32$1 = HEAP32[($2 + 536 | 0) >> 2] | 0;
                           i64toi32_i32$4 = HEAP32[($2 + 540 | 0) >> 2] | 0;
                           $1809 = i64toi32_i32$1;
                           i64toi32_i32$1 = $2 + 480 | 0;
                           HEAP32[i64toi32_i32$1 >> 2] = $1809;
                           HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$4;
                           i64toi32_i32$5 = ($2 + 536 | 0) + 8 | 0;
                           i64toi32_i32$4 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                           i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                           $1815 = i64toi32_i32$4;
                           i64toi32_i32$4 = $2 + 488 | 0;
                           HEAP32[i64toi32_i32$4 >> 2] = $1815;
                           HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$1;
                           memcpy($2 + 408 | 0 | 0, $2 + 728 | 0 | 0, 64 | 0) | 0;
                           HEAP8[($2 + 496 | 0) >> 0] = 0;
                           i64toi32_i32$1 = $43$hi;
                           i64toi32_i32$4 = $2;
                           HEAP32[($2 + 472 | 0) >> 2] = $43;
                           HEAP32[($2 + 476 | 0) >> 2] = i64toi32_i32$1;
                           cardano_serialization_lib__tx_builder__TransactionBuilder__add_output__h626cdf41f713b689($2 + 16 | 0 | 0, $0 | 0, $2 + 408 | 0 | 0);
                           if (HEAP32[($2 + 16 | 0) >> 2] | 0) {
                            break label$18
                           }
                           core__ptr__drop_in_place_cardano_serialization_lib__TransactionOutput___h632b3a99817e6ac5($2 + 408 | 0 | 0);
                          }
                          label$124 : {
                           if (!(HEAP32[($2 + 592 | 0) >> 2] | 0)) {
                            break label$124
                           }
                           $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 596 | 0 | 0);
                          }
                          core__ptr__drop_in_place_cardano_serialization_lib__TransactionOutput___h632b3a99817e6ac5($2 + 240 | 0 | 0);
                          i64toi32_i32$5 = $2;
                          i64toi32_i32$1 = HEAP32[($2 + 200 | 0) >> 2] | 0;
                          i64toi32_i32$4 = HEAP32[($2 + 204 | 0) >> 2] | 0;
                          $44 = i64toi32_i32$1;
                          $44$hi = i64toi32_i32$4;
                         }
                         i64toi32_i32$1 = $0;
                         i64toi32_i32$4 = 0;
                         HEAP32[(i64toi32_i32$1 + 256 | 0) >> 2] = 1;
                         HEAP32[(i64toi32_i32$1 + 260 | 0) >> 2] = i64toi32_i32$4;
                         i64toi32_i32$4 = $45$hi;
                         i64toi32_i32$1 = i64toi32_i32$1 + 264 | 0;
                         HEAP32[i64toi32_i32$1 >> 2] = $45;
                         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$4;
                         i64toi32_i32$4 = $44$hi;
                         i64toi32_i32$5 = $44;
                         i64toi32_i32$1 = 0;
                         i64toi32_i32$0 = 0;
                         if ((i64toi32_i32$5 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$4 | 0) != (i64toi32_i32$1 | 0) | 0) {
                          break label$23
                         }
                         $1 = HEAP32[($2 + 208 | 0) >> 2] | 0;
                         $3 = (wasm2js_i32$0 = !(HEAP32[($2 + 220 | 0) >> 2] | 0), wasm2js_i32$1 = 2, wasm2js_i32$2 = ($1 | 0) == (1 | 0), wasm2js_i32$2 ? wasm2js_i32$0 : wasm2js_i32$1);
                         if (($3 | 0) == (2 | 0)) {
                          break label$22
                         }
                         if ($3 & 1 | 0) {
                          break label$22
                         }
                        }
                        $1 = HEAP32[($0 + 424 | 0) >> 2] | 0;
                        if (!$1) {
                         break label$16
                        }
                        cardano_serialization_lib__utils__Value__checked_add__h5184687782847801($2 + 408 | 0 | 0, (($1 << 7 | 0) + (HEAP32[($0 + 416 | 0) >> 2] | 0) | 0) + -64 | 0 | 0, $2 + 200 | 0 | 0);
                        if ((HEAP32[($2 + 408 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                         break label$14
                        }
                        i64toi32_i32$0 = $2 + 432 | 0;
                        i64toi32_i32$5 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                        i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                        $1884 = i64toi32_i32$5;
                        i64toi32_i32$5 = ($2 + 240 | 0) + 16 | 0;
                        HEAP32[i64toi32_i32$5 >> 2] = $1884;
                        HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$4;
                        i64toi32_i32$0 = ($2 + 408 | 0) + 16 | 0;
                        i64toi32_i32$4 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                        i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                        $1891 = i64toi32_i32$4;
                        i64toi32_i32$4 = ($2 + 240 | 0) + 8 | 0;
                        HEAP32[i64toi32_i32$4 >> 2] = $1891;
                        HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
                        i64toi32_i32$0 = ($2 + 408 | 0) + 8 | 0;
                        i64toi32_i32$5 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                        i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                        $1896 = i64toi32_i32$5;
                        i64toi32_i32$5 = $2;
                        HEAP32[($2 + 240 | 0) >> 2] = $1896;
                        HEAP32[($2 + 244 | 0) >> 2] = i64toi32_i32$4;
                        $1 = HEAP32[($0 + 424 | 0) >> 2] | 0;
                        if (!$1) {
                         break label$15
                        }
                        $1 = ($1 << 7 | 0) + (HEAP32[($0 + 416 | 0) >> 2] | 0) | 0;
                        $0 = $1 + -64 | 0;
                        label$125 : {
                         if (!(HEAP32[($1 + -56 | 0) >> 2] | 0)) {
                          break label$125
                         }
                         $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($0 + 12 | 0 | 0);
                        }
                        i64toi32_i32$0 = $2;
                        i64toi32_i32$4 = HEAP32[($2 + 240 | 0) >> 2] | 0;
                        i64toi32_i32$5 = HEAP32[($2 + 244 | 0) >> 2] | 0;
                        $1916 = i64toi32_i32$4;
                        i64toi32_i32$4 = $0;
                        HEAP32[i64toi32_i32$4 >> 2] = $1916;
                        HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
                        i64toi32_i32$0 = ($2 + 240 | 0) + 16 | 0;
                        i64toi32_i32$5 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                        i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                        $1922 = i64toi32_i32$5;
                        i64toi32_i32$5 = $0 + 16 | 0;
                        HEAP32[i64toi32_i32$5 >> 2] = $1922;
                        HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$4;
                        i64toi32_i32$0 = ($2 + 240 | 0) + 8 | 0;
                        i64toi32_i32$4 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                        i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                        $1928 = i64toi32_i32$4;
                        i64toi32_i32$4 = $0 + 8 | 0;
                        HEAP32[i64toi32_i32$4 >> 2] = $1928;
                        HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
                        $1 = HEAP32[($2 + 208 | 0) >> 2] | 0;
                       }
                       if (!$1) {
                        break label$21
                       }
                       $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 212 | 0 | 0);
                      }
                      i64toi32_i32$5 = 0;
                      $44 = 256;
                      $44$hi = i64toi32_i32$5;
                     }
                     label$126 : {
                      if (!(HEAP32[($2 + 184 | 0) >> 2] | 0)) {
                       break label$126
                      }
                      $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 188 | 0 | 0);
                     }
                     i64toi32_i32$5 = 0;
                     $43 = 0;
                     $43$hi = i64toi32_i32$5;
                     $0 = 0;
                     break label$17;
                    }
                    $0 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1058732 | 0, 8 | 0) | 0 | 0) | 0;
                    break label$13;
                   }
                   $0 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($2 + 20 | 0) >> 2] | 0 | 0) | 0;
                   core__ptr__drop_in_place_cardano_serialization_lib__TransactionOutput___h632b3a99817e6ac5($2 + 408 | 0 | 0);
                   break label$13;
                  }
                  label$127 : {
                   if (!(HEAP32[($2 + 112 | 0) >> 2] | 0)) {
                    break label$127
                   }
                   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 116 | 0 | 0);
                  }
                  label$128 : {
                   if (!(HEAP32[($2 + 88 | 0) >> 2] | 0)) {
                    break label$128
                   }
                   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 92 | 0 | 0);
                  }
                  label$129 : {
                   if (!(HEAP32[($2 + 136 | 0) >> 2] | 0)) {
                    break label$129
                   }
                   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 140 | 0 | 0);
                  }
                  if (!(HEAP32[($2 + 160 | 0) >> 2] | 0)) {
                   break label$1
                  }
                  $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 164 | 0 | 0);
                  break label$1;
                 }
                 core__panicking__panic__h2fd385a887c8bf13(1063668 | 0, 43 | 0, 1065288 | 0);
                 abort();
                }
                core__panicking__panic__h2fd385a887c8bf13(1063668 | 0, 43 | 0, 1065304 | 0);
                abort();
               }
               $0 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($2 + 412 | 0) >> 2] | 0 | 0) | 0;
               break label$8;
              }
              if (!(HEAP32[($2 + 592 | 0) >> 2] | 0)) {
               break label$12
              }
              $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 596 | 0 | 0);
             }
             core__ptr__drop_in_place_cardano_serialization_lib__TransactionOutput___h632b3a99817e6ac5($2 + 240 | 0 | 0);
             break label$8;
            }
            label$130 : {
             if (!$36) {
              break label$130
             }
             $1 = Math_imul($36, 12);
             label$131 : while (1) {
              $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($24 | 0);
              $24 = $24 + 12 | 0;
              $1 = $1 + -12 | 0;
              if ($1) {
               continue label$131
              }
              break label$131;
             };
            }
            $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h2a00dda64f22da3c($2 + 224 | 0 | 0);
            break label$8;
           }
           $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h6c9f94f0f82ce2b5($2 + 696 | 0 | 0);
           $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__he37b42ff2b07ed41($2 + 680 | 0 | 0);
           $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h19d691521e7c48e6($2 + 680 | 0 | 0);
           $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 664 | 0 | 0);
           label$132 : {
            if (!(HEAP32[($2 + 648 | 0) >> 2] | 0)) {
             break label$132
            }
            $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($13 | 0);
           }
           label$133 : {
            if (!(HEAP32[($2 + 624 | 0) >> 2] | 0)) {
             break label$133
            }
            $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($14 | 0);
           }
           $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 568 | 0 | 0);
           core__ptr__drop_in_place_cardano_serialization_lib__TransactionOutput___h632b3a99817e6ac5($2 + 408 | 0 | 0);
           label$134 : {
            if (!(HEAP32[($2 + 392 | 0) >> 2] | 0)) {
             break label$134
            }
            $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($22 | 0);
           }
           label$135 : {
            $1 = HEAP32[($2 + 376 | 0) >> 2] | 0;
            if (!$1) {
             break label$135
            }
            $0 = HEAP32[($2 + 368 | 0) >> 2] | 0;
            $1 = Math_imul($1, 12);
            label$136 : while (1) {
             $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($0 | 0);
             $0 = $0 + 12 | 0;
             $1 = $1 + -12 | 0;
             if ($1) {
              continue label$136
             }
             break label$136;
            };
           }
           $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h2a00dda64f22da3c($2 + 368 | 0 | 0);
           $0 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($3 | 0) | 0;
           break label$8;
          }
          $0 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($2 + 412 | 0) >> 2] | 0 | 0) | 0;
         }
         if (!(HEAP32[($2 + 208 | 0) >> 2] | 0)) {
          break label$6
         }
         $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 212 | 0 | 0);
         break label$6;
        }
        $0 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($2 + 412 | 0) >> 2] | 0 | 0) | 0;
       }
       if (!(HEAP32[($2 + 184 | 0) >> 2] | 0)) {
        break label$5
       }
       $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 188 | 0 | 0);
      }
      label$137 : {
       if (!(HEAP32[($2 + 112 | 0) >> 2] | 0)) {
        break label$137
       }
       $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 116 | 0 | 0);
      }
      label$138 : {
       if (!(HEAP32[($2 + 88 | 0) >> 2] | 0)) {
        break label$138
       }
       $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 92 | 0 | 0);
      }
      if (!(HEAP32[($2 + 136 | 0) >> 2] | 0)) {
       break label$4
      }
      $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 140 | 0 | 0);
     }
     if (!(HEAP32[($2 + 160 | 0) >> 2] | 0)) {
      break label$3
     }
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 164 | 0 | 0);
    }
    i64toi32_i32$5 = 0;
    $43 = 1;
    $43$hi = i64toi32_i32$5;
   }
   i64toi32_i32$5 = 0;
   $44 = 0;
   $44$hi = i64toi32_i32$5;
  }
  global$0 = $2 + 928 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$0 = $0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$1 = 32;
  i64toi32_i32$3 = i64toi32_i32$1 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$0 << i64toi32_i32$3 | 0;
   $195 = 0;
  } else {
   i64toi32_i32$4 = ((1 << i64toi32_i32$3 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$3 | 0) | 0) | 0 | (i64toi32_i32$5 << i64toi32_i32$3 | 0) | 0;
   $195 = i64toi32_i32$0 << i64toi32_i32$3 | 0;
  }
  $2071$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $44$hi;
  i64toi32_i32$5 = $44;
  i64toi32_i32$0 = 0;
  i64toi32_i32$1 = 256;
  i64toi32_i32$0 = i64toi32_i32$4 & i64toi32_i32$0 | 0;
  $2073 = i64toi32_i32$5 & i64toi32_i32$1 | 0;
  $2073$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $2071$hi;
  i64toi32_i32$4 = $195;
  i64toi32_i32$5 = $2073$hi;
  i64toi32_i32$1 = $2073;
  i64toi32_i32$5 = i64toi32_i32$0 | i64toi32_i32$5 | 0;
  $2074$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $43$hi;
  i64toi32_i32$5 = $2074$hi;
  i64toi32_i32$0 = i64toi32_i32$4 | i64toi32_i32$1 | 0;
  i64toi32_i32$4 = $43$hi;
  i64toi32_i32$1 = $43;
  i64toi32_i32$4 = i64toi32_i32$5 | i64toi32_i32$4 | 0;
  i64toi32_i32$0 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$4;
  return i64toi32_i32$0 | 0;
 }
 
 function cryptoxide__hashing__blake2__reference__compress_b__h50335d8cd58c3d7d($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, i64toi32_i32$5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $31$hi = 0, $34$hi = 0, $24$hi = 0, $33$hi = 0, $23$hi = 0, $30$hi = 0, $37$hi = 0, $32$hi = 0, $41$hi = 0, $42$hi = 0, $31 = 0, $34 = 0, $30 = 0, $38$hi = 0, $37 = 0, $41 = 0, $32 = 0, $24 = 0, $33 = 0, $39$hi = 0, $40$hi = 0, $23 = 0, $43$hi = 0, $44$hi = 0, $45$hi = 0, $42 = 0, $46$hi = 0, $38 = 0, $47$hi = 0, $48$hi = 0, $13$hi = 0, $25$hi = 0, $7$hi = 0, $21$hi = 0, $15$hi = 0, $19$hi = 0, $39 = 0, $45 = 0, $6$hi = 0, $40 = 0, $43 = 0, $14$hi = 0, $44 = 0, $29$hi = 0, $46 = 0, $47 = 0, $22$hi = 0, $12$hi = 0, $48 = 0, $11$hi = 0, $26$hi = 0, $10$hi = 0, $18$hi = 0, $20$hi = 0, $25 = 0, $13 = 0, $19 = 0, $6 = 0, $15 = 0, $21 = 0, $7 = 0, $14 = 0, $29 = 0, $22 = 0, $12 = 0, $10 = 0, $11 = 0, $26 = 0, $18 = 0, $20 = 0, $9$hi = 0, $8$hi = 0, $16$hi = 0, $27$hi = 0, $35$hi = 0, $9 = 0, $8 = 0, $16 = 0, $17$hi = 0, $27 = 0, $35 = 0, $5 = 0, $17 = 0, $28 = 0, $28$hi = 0, $36 = 0, $36$hi = 0, $54 = 0, $60 = 0, $60$hi = 0, $63 = 0, $63$hi = 0, $70$hi = 0, $76 = 0, $76$hi = 0, $78$hi = 0, $622 = 0, $623 = 0, $92 = 0, $92$hi = 0, $95 = 0, $95$hi = 0, $102$hi = 0, $108 = 0, $108$hi = 0, $110$hi = 0, $625 = 0, $626 = 0, $627 = 0, $628 = 0, $140 = 0, $140$hi = 0, $141 = 0, $141$hi = 0, $144 = 0, $144$hi = 0, $151$hi = 0, $157 = 0, $157$hi = 0, $629 = 0, $630 = 0, $631 = 0, $632 = 0, $176 = 0, $176$hi = 0, $179 = 0, $179$hi = 0, $186$hi = 0, $192 = 0, $192$hi = 0, $193 = 0, $193$hi = 0, $196$hi = 0, $633 = 0, $634 = 0, $635 = 0, $227 = 0, $227$hi = 0, $228 = 0, $228$hi = 0, $636 = 0, $241$hi = 0, $248 = 0, $248$hi = 0, $637 = 0, $638 = 0, $279 = 0, $279$hi = 0, $280 = 0, $280$hi = 0, $283$hi = 0, $639 = 0, $294 = 0, $294$hi = 0, $641 = 0, $299 = 0, $299$hi = 0, $642 = 0, $318 = 0, $318$hi = 0, $323$hi = 0, $643 = 0, $334 = 0, $334$hi = 0, $644 = 0, $645 = 0, $646 = 0, $365 = 0, $365$hi = 0, $368 = 0, $368$hi = 0, $647 = 0, $648 = 0, $384 = 0, $384$hi = 0, $649 = 0, $650 = 0, $413 = 0, $413$hi = 0, $414 = 0, $414$hi = 0, $417$hi = 0, $651 = 0, $426 = 0, $426$hi = 0, $652 = 0, $431 = 0, $431$hi = 0, $653 = 0, $654 = 0, $450 = 0, $450$hi = 0, $453$hi = 0, $655 = 0, $462 = 0, $462$hi = 0, $656 = 0, $657 = 0, $658 = 0, $493 = 0, $493$hi = 0, $659 = 0, $660 = 0, $507$hi = 0, $512 = 0, $512$hi = 0, $661 = 0, $662 = 0, $663 = 0, $541 = 0, $541$hi = 0, $542 = 0, $542$hi = 0, $545$hi = 0, $664 = 0, $554 = 0, $554$hi = 0, $665 = 0, $559 = 0, $559$hi = 0, $666 = 0, $667 = 0, $668 = 0, $578 = 0, $578$hi = 0, $581$hi = 0, $671 = 0, $590 = 0, $590$hi = 0, $672 = 0, $673 = 0, $621 = 0, $621$hi = 0, $624 = 0, $624$hi = 0, $674 = 0, $640 = 0, $640$hi = 0, $675 = 0, $676 = 0, $669 = 0, $669$hi = 0, $670 = 0, $670$hi = 0, $673$hi = 0, $677 = 0, $682 = 0, $682$hi = 0, $678 = 0, $687 = 0, $687$hi = 0, $679 = 0, $680 = 0, $706 = 0, $706$hi = 0, $709$hi = 0, $681 = 0, $718 = 0, $718$hi = 0, $683 = 0, $684 = 0, $685 = 0, $749 = 0, $749$hi = 0, $752 = 0, $752$hi = 0, $686 = 0, $768 = 0, $768$hi = 0, $688 = 0, $689 = 0, $797 = 0, $797$hi = 0, $798 = 0, $798$hi = 0, $801$hi = 0, $690 = 0, $810 = 0, $810$hi = 0, $691 = 0, $815 = 0, $815$hi = 0, $692 = 0, $834 = 0, $834$hi = 0, $837$hi = 0, $693 = 0, $846 = 0, $846$hi = 0, $694 = 0, $695 = 0, $696 = 0, $877 = 0, $877$hi = 0, $880 = 0, $880$hi = 0, $697 = 0, $698 = 0, $896 = 0, $896$hi = 0, $699 = 0, $700 = 0, $701 = 0, $925 = 0, $925$hi = 0, $926 = 0, $926$hi = 0, $929$hi = 0, $702 = 0, $938 = 0, $938$hi = 0, $703 = 0, $943 = 0, $943$hi = 0, $704 = 0, $705 = 0, $962 = 0, $962$hi = 0, $965$hi = 0, $707 = 0, $974 = 0, $974$hi = 0, $708 = 0, $709 = 0, $710 = 0, $1005 = 0, $1005$hi = 0, $1008 = 0, $1008$hi = 0, $711 = 0, $712 = 0, $1024 = 0, $1024$hi = 0, $713 = 0, $714 = 0, $1053 = 0, $1053$hi = 0, $1054 = 0, $1054$hi = 0, $1057$hi = 0, $715 = 0, $1066 = 0, $1066$hi = 0, $716 = 0, $1071 = 0, $1071$hi = 0, $717 = 0, $719 = 0, $1090 = 0, $1090$hi = 0, $1093$hi = 0, $720 = 0, $1102 = 0, $1102$hi = 0, $721 = 0, $722 = 0, $1133 = 0, $1133$hi = 0, $1136 = 0, $1136$hi = 0, $723 = 0, $1152 = 0, $1152$hi = 0, $724 = 0, $725 = 0, $726 = 0, $1181 = 0, $1181$hi = 0, $1182 = 0, $1182$hi = 0, $1185$hi = 0, $727 = 0, $1194 = 0, $1194$hi = 0, $728 = 0, $1199 = 0, $1199$hi = 0, $729 = 0, $730 = 0, $731 = 0, $1218 = 0, $1218$hi = 0, $1221$hi = 0, $732 = 0, $1230 = 0, $1230$hi = 0, $733 = 0, $734 = 0, $1261 = 0, $1261$hi = 0, $1264 = 0, $1264$hi = 0, $735 = 0, $1280 = 0, $1280$hi = 0, $736 = 0, $737 = 0, $1309 = 0, $1309$hi = 0, $1310 = 0, $1310$hi = 0, $1313$hi = 0, $738 = 0, $1322 = 0, $1322$hi = 0, $739 = 0, $1327 = 0, $1327$hi = 0, $740 = 0, $741 = 0, $1346 = 0, $1346$hi = 0, $1349$hi = 0, $742 = 0, $1358 = 0, $1358$hi = 0, $743 = 0, $744 = 0, $745 = 0, $1389 = 0, $1389$hi = 0, $1392 = 0, $1392$hi = 0, $746 = 0, $1408 = 0, $1408$hi = 0, $747 = 0, $748 = 0, $1437 = 0, $1437$hi = 0, $1438 = 0, $1438$hi = 0, $1441$hi = 0, $750 = 0, $1450 = 0, $1450$hi = 0, $751 = 0, $1455 = 0, $1455$hi = 0, $753 = 0, $1474 = 0, $1474$hi = 0, $1477$hi = 0, $754 = 0, $1486 = 0, $1486$hi = 0, $755 = 0, $756 = 0, $757 = 0, $1517 = 0, $1517$hi = 0, $1520 = 0, $1520$hi = 0, $758 = 0, $759 = 0, $1536 = 0, $1536$hi = 0, $760 = 0, $761 = 0, $762 = 0, $1565 = 0, $1565$hi = 0, $1566 = 0, $1566$hi = 0, $1569$hi = 0, $763 = 0, $1578 = 0, $1578$hi = 0, $764 = 0, $1583 = 0, $1583$hi = 0, $765 = 0, $766 = 0, $1602 = 0, $1602$hi = 0, $1605$hi = 0, $767 = 0, $1614 = 0, $1614$hi = 0, $769 = 0, $770 = 0, $771 = 0, $1645 = 0, $1645$hi = 0, $1648 = 0, $1648$hi = 0, $772 = 0, $773 = 0, $1664 = 0, $1664$hi = 0, $774 = 0, $775 = 0, $1693 = 0, $1693$hi = 0, $1694 = 0, $1694$hi = 0, $1697$hi = 0, $776 = 0, $1706 = 0, $1706$hi = 0, $777 = 0, $1711 = 0, $1711$hi = 0, $778 = 0, $779 = 0, $1730 = 0, $1730$hi = 0, $1733$hi = 0, $780 = 0, $1742 = 0, $1742$hi = 0, $781 = 0, $782 = 0, $1773 = 0, $1773$hi = 0, $1776 = 0, $1776$hi = 0, $783 = 0, $1792 = 0, $1792$hi = 0, $784 = 0, $785 = 0, $786 = 0, $1821 = 0, $1821$hi = 0, $1822 = 0, $1822$hi = 0, $1825$hi = 0, $787 = 0, $1834 = 0, $1834$hi = 0, $788 = 0, $1839 = 0, $1839$hi = 0, $789 = 0, $790 = 0, $791 = 0, $1858 = 0, $1858$hi = 0, $1861$hi = 0, $792 = 0, $1870 = 0, $1870$hi = 0, $793 = 0, $794 = 0, $1901 = 0, $1901$hi = 0, $1904 = 0, $1904$hi = 0, $795 = 0, $1920 = 0, $1920$hi = 0, $796 = 0, $799 = 0, $1949 = 0, $1949$hi = 0, $1950 = 0, $1950$hi = 0, $1953$hi = 0, $800 = 0, $1962 = 0, $1962$hi = 0, $801 = 0, $1967 = 0, $1967$hi = 0, $802 = 0, $803 = 0, $1986 = 0, $1986$hi = 0, $1989$hi = 0, $804 = 0, $1998 = 0, $1998$hi = 0, $805 = 0, $806 = 0, $807 = 0, $2029 = 0, $2029$hi = 0, $808 = 0, $809 = 0, $2043$hi = 0, $2048 = 0, $2048$hi = 0, $811 = 0, $812 = 0, $813 = 0, $2077 = 0, $2077$hi = 0, $2078 = 0, $2078$hi = 0, $2081$hi = 0, $814 = 0, $2090 = 0, $2090$hi = 0, $816 = 0, $2095 = 0, $2095$hi = 0, $817 = 0, $818 = 0, $819 = 0, $2114 = 0, $2114$hi = 0, $2117$hi = 0, $820 = 0, $2126 = 0, $2126$hi = 0, $821 = 0, $822 = 0, $823 = 0, $2157 = 0, $2157$hi = 0, $2160 = 0, $2160$hi = 0, $824 = 0, $825 = 0, $2176 = 0, $2176$hi = 0, $826 = 0, $827 = 0, $2205 = 0, $2205$hi = 0, $2206 = 0, $2206$hi = 0, $2209$hi = 0, $828 = 0, $2218 = 0, $2218$hi = 0, $829 = 0, $2223 = 0, $2223$hi = 0, $830 = 0, $831 = 0, $2242 = 0, $2242$hi = 0, $2245$hi = 0, $832 = 0, $2254 = 0, $2254$hi = 0, $833 = 0, $835 = 0, $836 = 0, $2285 = 0, $2285$hi = 0, $837 = 0, $838 = 0, $2299$hi = 0, $2304 = 0, $2304$hi = 0, $839 = 0, $840 = 0, $841 = 0, $2333 = 0, $2333$hi = 0, $2336 = 0, $2336$hi = 0, $2348 = 0, $2348$hi = 0, $842 = 0, $843 = 0, $844 = 0, $2369 = 0, $2369$hi = 0, $2370 = 0, $2370$hi = 0, $2373$hi = 0, $845 = 0, $2382 = 0, $2382$hi = 0, $847 = 0, $848 = 0, $849 = 0, $2413 = 0, $2413$hi = 0, $2416 = 0, $2416$hi = 0, $850 = 0, $2432 = 0, $2432$hi = 0, $851 = 0, $852 = 0, $2461 = 0, $2461$hi = 0, $2462 = 0, $2462$hi = 0, $2465$hi = 0, $853 = 0, $2474 = 0, $2474$hi = 0, $854 = 0, $2479 = 0, $2479$hi = 0, $855 = 0, $856 = 0, $2498 = 0, $2498$hi = 0, $2501$hi = 0, $857 = 0, $2510 = 0, $2510$hi = 0, $858 = 0, $859 = 0, $2541 = 0, $2541$hi = 0, $2544 = 0, $2544$hi = 0, $860 = 0, $2560 = 0, $2560$hi = 0, $861 = 0, $862 = 0, $863 = 0, $2589 = 0, $2589$hi = 0, $2590 = 0, $2590$hi = 0, $2593$hi = 0, $864 = 0, $2602 = 0, $2602$hi = 0, $865 = 0, $2607 = 0, $2607$hi = 0, $866 = 0, $867 = 0, $868 = 0, $2626 = 0, $2626$hi = 0, $2629$hi = 0, $869 = 0, $2638 = 0, $2638$hi = 0, $870 = 0, $871 = 0, $872 = 0, $2669 = 0, $2669$hi = 0, $2672 = 0, $2672$hi = 0, $873 = 0, $2688 = 0, $2688$hi = 0, $874 = 0, $875 = 0, $2717 = 0, $2717$hi = 0, $2718 = 0, $2718$hi = 0, $2721$hi = 0, $876 = 0, $2730 = 0, $2730$hi = 0, $878 = 0, $2735 = 0, $2735$hi = 0, $879 = 0, $881 = 0, $2754 = 0, $2754$hi = 0, $2757$hi = 0, $882 = 0, $2766 = 0, $2766$hi = 0, $883 = 0, $884 = 0, $885 = 0, $2797 = 0, $2797$hi = 0, $2800 = 0, $2800$hi = 0, $886 = 0, $887 = 0, $2816 = 0, $2816$hi = 0, $888 = 0, $889 = 0, $2845 = 0, $2845$hi = 0, $2848 = 0, $2848$hi = 0, $890 = 0, $2860 = 0, $2860$hi = 0, $891 = 0, $2881 = 0, $2881$hi = 0, $2882 = 0, $2882$hi = 0, $2885$hi = 0, $892 = 0, $2894 = 0, $2894$hi = 0, $893 = 0, $894 = 0, $895 = 0, $897 = 0, $2925 = 0, $2925$hi = 0, $2928 = 0, $2928$hi = 0, $898 = 0, $899 = 0, $2944 = 0, $2944$hi = 0, $900 = 0, $901 = 0, $902 = 0, $2973 = 0, $2973$hi = 0, $2976$hi = 0, $903 = 0, $2985 = 0, $2985$hi = 0, $904 = 0, $2990 = 0, $2990$hi = 0, $905 = 0, $906 = 0, $3010 = 0, $3010$hi = 0, $3013$hi = 0, $907 = 0, $3022 = 0, $3022$hi = 0, $908 = 0, $909 = 0, $910 = 0, $3053 = 0, $3053$hi = 0, $3056 = 0, $3056$hi = 0, $3068 = 0, $3068$hi = 0, $911 = 0, $3073 = 0, $3073$hi = 0, $912 = 0, $3097 = 0, $3098 = 0, $3099 = 0, $3099$hi = 0, $913 = 0, $3108$hi = 0, $3110 = 0, $3114 = 0, $3114$hi = 0, $914 = 0, $3118 = 0, $3118$hi = 0, $3119 = 0, $3125 = 0, $3125$hi = 0, $3126$hi = 0, $3128 = 0, $3129 = 0, $3130 = 0, $3130$hi = 0, $3131 = 0, $3131$hi = 0, $915 = 0, $3138$hi = 0, $3142 = 0, $3142$hi = 0, $916 = 0, $917 = 0, $3157 = 0, $3157$hi = 0, $3158 = 0, $3158$hi = 0, $3161$hi = 0, $918 = 0, $3169 = 0, $3169$hi = 0, $919 = 0, $3191 = 0, $920 = 0, $3199 = 0, $3199$hi = 0, $921 = 0, $3203 = 0, $3203$hi = 0, $3204 = 0, $3205 = 0, $3208 = 0, $3208$hi = 0, $3213 = 0, $3217 = 0, $3217$hi = 0, $3221 = 0, $3221$hi = 0, $3222 = 0;
  $5 = global$0 - 128 | 0;
  global$0 = $5;
  label$1 : {
   if (($3 | 0) == (128 | 0)) {
    break label$1
   }
   core__panicking__panic__h2fd385a887c8bf13(1102976 | 0, 47 | 0, 1103024 | 0);
   abort();
  }
  $54 = $0;
  $3 = memcpy($5 | 0, $2 | 0, 128 | 0) | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
  $6 = i64toi32_i32$0;
  $6$hi = i64toi32_i32$1;
  $60 = i64toi32_i32$0;
  $60$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $7 = i64toi32_i32$1;
  $7$hi = i64toi32_i32$0;
  $63 = i64toi32_i32$1;
  $63$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$2 = $8;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $70$hi = i64toi32_i32$5;
  i64toi32_i32$0 = $3;
  i64toi32_i32$5 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$5;
  $10$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $70$hi;
  i64toi32_i32$0 = i64toi32_i32$4;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$3 = $10;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $63$hi;
  i64toi32_i32$2 = $63;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $76 = i64toi32_i32$5;
  $76$hi = i64toi32_i32$1;
  i64toi32_i32$4 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$4 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
  $78$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$2 = $78$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 1359893119;
  i64toi32_i32$3 = -1377402159;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $622 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($622 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $12 = i64toi32_i32$2;
  $12$hi = i64toi32_i32$4;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$2 = 1779033703;
  i64toi32_i32$3 = -205731576;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $13 = i64toi32_i32$0;
  $13$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $8$hi;
  i64toi32_i32$5 = $13$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $623 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($623 | 0, i64toi32_i32$1 | 0, 40 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $14 = i64toi32_i32$4;
  $14$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $76$hi;
  i64toi32_i32$5 = $76;
  i64toi32_i32$4 = $14$hi;
  i64toi32_i32$3 = $14;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $15 = i64toi32_i32$2;
  $15$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $60$hi;
  i64toi32_i32$1 = $60;
  i64toi32_i32$5 = $15$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $92 = i64toi32_i32$4;
  $92$hi = i64toi32_i32$2;
  i64toi32_i32$0 = $3;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] | 0;
  $11 = i64toi32_i32$2;
  $11$hi = i64toi32_i32$1;
  $95 = i64toi32_i32$2;
  $95$hi = i64toi32_i32$1;
  i64toi32_i32$0 = $0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 40 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 44 | 0) >> 2] | 0;
  $16 = i64toi32_i32$1;
  $16$hi = i64toi32_i32$2;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] | 0;
  $17 = i64toi32_i32$2;
  $17$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $16$hi;
  i64toi32_i32$0 = $16;
  i64toi32_i32$2 = $17$hi;
  i64toi32_i32$3 = $17;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $102$hi = i64toi32_i32$4;
  i64toi32_i32$1 = $3;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] | 0;
  $18 = i64toi32_i32$4;
  $18$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $102$hi;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$4 = $18$hi;
  i64toi32_i32$3 = $18;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $19 = i64toi32_i32$2;
  $19$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $95$hi;
  i64toi32_i32$0 = $95;
  i64toi32_i32$1 = $19$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $108 = i64toi32_i32$4;
  $108$hi = i64toi32_i32$2;
  i64toi32_i32$5 = $1;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$5 + 12 | 0) >> 2] | 0;
  $110$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $19$hi;
  i64toi32_i32$0 = $110$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $19$hi;
  i64toi32_i32$3 = $19;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = -1694144372;
  i64toi32_i32$3 = 725511199;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $625 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($625 | 0, i64toi32_i32$5 | 0, 32 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $19 = i64toi32_i32$0;
  $19$hi = i64toi32_i32$5;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = -1150833019;
  i64toi32_i32$3 = -2067093701;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $20 = i64toi32_i32$1;
  $20$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $16$hi;
  i64toi32_i32$4 = $20$hi;
  i64toi32_i32$5 = i64toi32_i32$1;
  i64toi32_i32$2 = $16$hi;
  i64toi32_i32$3 = $16;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $626 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($626 | 0, i64toi32_i32$2 | 0, 40 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $21 = i64toi32_i32$5;
  $21$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $108$hi;
  i64toi32_i32$4 = $108;
  i64toi32_i32$5 = $21$hi;
  i64toi32_i32$3 = $21;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $22 = i64toi32_i32$0;
  $22$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $19$hi;
  i64toi32_i32$1 = $22$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$4 = $19$hi;
  i64toi32_i32$3 = $19;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $627 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($627 | 0, i64toi32_i32$4 | 0, 48 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $23 = i64toi32_i32$2;
  $23$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $20$hi;
  i64toi32_i32$4 = $23$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$2 = $20$hi;
  i64toi32_i32$3 = $20;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $24 = i64toi32_i32$5;
  $24$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $21$hi;
  i64toi32_i32$0 = $24$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$1 = $21$hi;
  i64toi32_i32$3 = $21;
  i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
  $628 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($628 | 0, i64toi32_i32$1 | 0, 1 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $25 = i64toi32_i32$4;
  $25$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $92$hi;
  i64toi32_i32$0 = $92;
  i64toi32_i32$4 = $25$hi;
  i64toi32_i32$3 = $25;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $26 = i64toi32_i32$2;
  $26$hi = i64toi32_i32$5;
  i64toi32_i32$1 = $3;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 72 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 76 | 0) >> 2] | 0;
  $19 = i64toi32_i32$5;
  $19$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $26$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$5 = $19$hi;
  i64toi32_i32$3 = $19;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $140 = i64toi32_i32$4;
  $140$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $26$hi;
  $141 = $26;
  $141$hi = i64toi32_i32$2;
  i64toi32_i32$0 = $3;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 56 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 60 | 0) >> 2] | 0;
  $20 = i64toi32_i32$2;
  $20$hi = i64toi32_i32$1;
  $144 = i64toi32_i32$2;
  $144$hi = i64toi32_i32$1;
  i64toi32_i32$0 = $0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 56 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 60 | 0) >> 2] | 0;
  $27 = i64toi32_i32$1;
  $27$hi = i64toi32_i32$2;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] | 0;
  $28 = i64toi32_i32$2;
  $28$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $27$hi;
  i64toi32_i32$0 = $27;
  i64toi32_i32$2 = $28$hi;
  i64toi32_i32$3 = $28;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $151$hi = i64toi32_i32$4;
  i64toi32_i32$1 = $3;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 48 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 52 | 0) >> 2] | 0;
  $21 = i64toi32_i32$4;
  $21$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $151$hi;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$4 = $21$hi;
  i64toi32_i32$3 = $21;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $29 = i64toi32_i32$2;
  $29$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $144$hi;
  i64toi32_i32$0 = $144;
  i64toi32_i32$1 = $29$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $157 = i64toi32_i32$4;
  $157$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $29$hi;
  i64toi32_i32$5 = $29;
  i64toi32_i32$0 = 1541459225;
  i64toi32_i32$3 = 327033209;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $629 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($629 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $29 = i64toi32_i32$5;
  $29$hi = i64toi32_i32$0;
  i64toi32_i32$2 = i64toi32_i32$5;
  i64toi32_i32$5 = -1521486534;
  i64toi32_i32$3 = 1595750129;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $30 = i64toi32_i32$1;
  $30$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $27$hi;
  i64toi32_i32$4 = $30$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$2 = $27$hi;
  i64toi32_i32$3 = $27;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $630 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($630 | 0, i64toi32_i32$2 | 0, 40 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $31 = i64toi32_i32$0;
  $31$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $157$hi;
  i64toi32_i32$4 = $157;
  i64toi32_i32$0 = $31$hi;
  i64toi32_i32$3 = $31;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $32 = i64toi32_i32$5;
  $32$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $29$hi;
  i64toi32_i32$1 = $32$hi;
  i64toi32_i32$2 = i64toi32_i32$5;
  i64toi32_i32$4 = $29$hi;
  i64toi32_i32$3 = $29;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $631 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($631 | 0, i64toi32_i32$4 | 0, 48 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $33 = i64toi32_i32$2;
  $33$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $141$hi;
  i64toi32_i32$1 = $141;
  i64toi32_i32$2 = $33$hi;
  i64toi32_i32$3 = $33;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $632 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($632 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $34 = i64toi32_i32$1;
  $34$hi = i64toi32_i32$2;
  $176 = i64toi32_i32$1;
  $176$hi = i64toi32_i32$2;
  i64toi32_i32$4 = $3;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 40 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$4 + 44 | 0) >> 2] | 0;
  $26 = i64toi32_i32$2;
  $26$hi = i64toi32_i32$1;
  $179 = i64toi32_i32$2;
  $179$hi = i64toi32_i32$1;
  i64toi32_i32$4 = $0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$4 + 48 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 52 | 0) >> 2] | 0;
  $35 = i64toi32_i32$1;
  $35$hi = i64toi32_i32$2;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$4 + 20 | 0) >> 2] | 0;
  $36 = i64toi32_i32$2;
  $36$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $35$hi;
  i64toi32_i32$4 = $35;
  i64toi32_i32$2 = $36$hi;
  i64toi32_i32$3 = $36;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $186$hi = i64toi32_i32$5;
  i64toi32_i32$1 = $3;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 32 | 0) >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] | 0;
  $29 = i64toi32_i32$5;
  $29$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $186$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$5 = $29$hi;
  i64toi32_i32$3 = $29;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $37 = i64toi32_i32$2;
  $37$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $179$hi;
  i64toi32_i32$4 = $179;
  i64toi32_i32$1 = $37$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $192 = i64toi32_i32$5;
  $192$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $37$hi;
  $193 = $37;
  $193$hi = i64toi32_i32$2;
  i64toi32_i32$2 = 0;
  i64toi32_i32$0 = $4;
  i64toi32_i32$4 = -1;
  i64toi32_i32$3 = -1;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $196$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $193$hi;
  i64toi32_i32$2 = $193;
  i64toi32_i32$0 = $196$hi;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 528734635;
  i64toi32_i32$3 = -79577749;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $633 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($633 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $37 = i64toi32_i32$5;
  $37$hi = i64toi32_i32$2;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$5 = 1013904242;
  i64toi32_i32$3 = -23791573;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $38 = i64toi32_i32$4;
  $38$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $35$hi;
  i64toi32_i32$1 = $38$hi;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$0 = $35$hi;
  i64toi32_i32$3 = $35;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $634 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($634 | 0, i64toi32_i32$0 | 0, 40 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $39 = i64toi32_i32$2;
  $39$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $192$hi;
  i64toi32_i32$1 = $192;
  i64toi32_i32$2 = $39$hi;
  i64toi32_i32$3 = $39;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $40 = i64toi32_i32$5;
  $40$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $37$hi;
  i64toi32_i32$4 = $40$hi;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$1 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64(i64toi32_i32$5 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$1 | 0, 48 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $37 = i64toi32_i32$0;
  $37$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $38$hi;
  i64toi32_i32$1 = $37$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$0 = $38$hi;
  i64toi32_i32$3 = $38;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $38 = i64toi32_i32$2;
  $38$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $176$hi;
  i64toi32_i32$1 = $176;
  i64toi32_i32$4 = $38$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $41 = i64toi32_i32$0;
  $41$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $25$hi;
  i64toi32_i32$2 = $41$hi;
  i64toi32_i32$5 = i64toi32_i32$0;
  i64toi32_i32$1 = $25$hi;
  i64toi32_i32$3 = $25;
  i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
  $635 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($635 | 0, i64toi32_i32$1 | 0, 40 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $42 = i64toi32_i32$5;
  $42$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $140$hi;
  i64toi32_i32$2 = $140;
  i64toi32_i32$5 = $42$hi;
  i64toi32_i32$3 = $42;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $43 = i64toi32_i32$4;
  $43$hi = i64toi32_i32$0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 112 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 116 | 0) >> 2] | 0;
  $25 = i64toi32_i32$0;
  $25$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $43$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$0 = $25$hi;
  i64toi32_i32$3 = $25;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $227 = i64toi32_i32$5;
  $227$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $32$hi;
  $228 = $32;
  $228$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $15$hi;
  i64toi32_i32$4 = $12$hi;
  i64toi32_i32$4 = $15$hi;
  i64toi32_i32$2 = $15;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
  $636 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($636 | 0, i64toi32_i32$1 | 0, 48 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $15 = i64toi32_i32$2;
  $15$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $13$hi;
  i64toi32_i32$1 = $15$hi;
  i64toi32_i32$4 = i64toi32_i32$2;
  i64toi32_i32$2 = $13$hi;
  i64toi32_i32$3 = $13;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $44 = i64toi32_i32$0;
  $44$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $14$hi;
  i64toi32_i32$5 = $44$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$4 = $14$hi;
  i64toi32_i32$3 = $14;
  i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64(i64toi32_i32$0 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$4 | 0, 1 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $13 = i64toi32_i32$1;
  $13$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $228$hi;
  i64toi32_i32$5 = $228;
  i64toi32_i32$1 = $13$hi;
  i64toi32_i32$3 = $13;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $241$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $25$hi;
  i64toi32_i32$0 = $241$hi;
  i64toi32_i32$4 = i64toi32_i32$2;
  i64toi32_i32$5 = $25$hi;
  i64toi32_i32$3 = $25;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $14 = i64toi32_i32$1;
  $14$hi = i64toi32_i32$2;
  i64toi32_i32$0 = $3;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 120 | 0) >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 124 | 0) >> 2] | 0;
  $12 = i64toi32_i32$2;
  $12$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $14$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $248 = i64toi32_i32$5;
  $248$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $14$hi;
  i64toi32_i32$1 = $37$hi;
  i64toi32_i32$1 = $14$hi;
  i64toi32_i32$4 = $14;
  i64toi32_i32$0 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $637 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($637 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $14 = i64toi32_i32$4;
  $14$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $24$hi;
  i64toi32_i32$0 = $14$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$4 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $24 = i64toi32_i32$2;
  $24$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $13$hi;
  i64toi32_i32$5 = $24$hi;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$1 = $13$hi;
  i64toi32_i32$3 = $13;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64(i64toi32_i32$2 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$1 | 0, 40 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $13 = i64toi32_i32$0;
  $13$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $248$hi;
  i64toi32_i32$5 = $248;
  i64toi32_i32$0 = $13$hi;
  i64toi32_i32$3 = $13;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $32 = i64toi32_i32$4;
  $32$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $14$hi;
  i64toi32_i32$2 = $32$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$5 = $14$hi;
  i64toi32_i32$3 = $14;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64(i64toi32_i32$4 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$5 | 0, 48 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $37 = i64toi32_i32$1;
  $37$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $24$hi;
  i64toi32_i32$5 = $37$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$1 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $24 = i64toi32_i32$0;
  $24$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $13$hi;
  i64toi32_i32$4 = $24$hi;
  i64toi32_i32$5 = i64toi32_i32$0;
  i64toi32_i32$2 = $13$hi;
  i64toi32_i32$3 = $13;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $638 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($638 | 0, i64toi32_i32$2 | 0, 1 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $45 = i64toi32_i32$5;
  $45$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $227$hi;
  i64toi32_i32$4 = $227;
  i64toi32_i32$5 = $45$hi;
  i64toi32_i32$3 = $45;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $46 = i64toi32_i32$1;
  $46$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 80 | 0) >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$2 + 84 | 0) >> 2] | 0;
  $13 = i64toi32_i32$0;
  $13$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $46$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = $13$hi;
  i64toi32_i32$3 = $13;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $279 = i64toi32_i32$5;
  $279$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $46$hi;
  $280 = $46;
  $280$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $13$hi;
  i64toi32_i32$1 = $22$hi;
  i64toi32_i32$1 = $13$hi;
  i64toi32_i32$4 = $13;
  i64toi32_i32$2 = $22$hi;
  i64toi32_i32$3 = $22;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $283$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $38$hi;
  i64toi32_i32$5 = $39$hi;
  i64toi32_i32$5 = $38$hi;
  i64toi32_i32$1 = $38;
  i64toi32_i32$4 = $39$hi;
  i64toi32_i32$3 = $39;
  i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
  $639 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($639 | 0, i64toi32_i32$4 | 0, 1 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $22 = i64toi32_i32$1;
  $22$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $283$hi;
  i64toi32_i32$5 = i64toi32_i32$0;
  i64toi32_i32$1 = $22$hi;
  i64toi32_i32$3 = $22;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $38 = i64toi32_i32$2;
  $38$hi = i64toi32_i32$0;
  i64toi32_i32$4 = $3;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 88 | 0) >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 92 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  $14$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $38$hi;
  i64toi32_i32$4 = i64toi32_i32$2;
  i64toi32_i32$0 = $14$hi;
  i64toi32_i32$3 = $14;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $294 = i64toi32_i32$1;
  $294$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $38$hi;
  i64toi32_i32$2 = $15$hi;
  i64toi32_i32$2 = $38$hi;
  i64toi32_i32$5 = $38;
  i64toi32_i32$4 = $15$hi;
  i64toi32_i32$3 = $15;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  $641 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($641 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $15 = i64toi32_i32$5;
  $15$hi = i64toi32_i32$4;
  $299 = i64toi32_i32$5;
  $299$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $33$hi;
  i64toi32_i32$4 = $30$hi;
  i64toi32_i32$4 = $33$hi;
  i64toi32_i32$2 = $33;
  i64toi32_i32$5 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $30 = i64toi32_i32$0;
  $30$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $299$hi;
  i64toi32_i32$4 = $299;
  i64toi32_i32$2 = $30$hi;
  i64toi32_i32$3 = i64toi32_i32$0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $33 = i64toi32_i32$5;
  $33$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $22$hi;
  i64toi32_i32$0 = $33$hi;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$4 = $22$hi;
  i64toi32_i32$3 = $22;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64(i64toi32_i32$5 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$4 | 0, 40 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $38 = i64toi32_i32$1;
  $38$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $294$hi;
  i64toi32_i32$0 = $294;
  i64toi32_i32$1 = $38$hi;
  i64toi32_i32$3 = $38;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $39 = i64toi32_i32$2;
  $39$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $15$hi;
  i64toi32_i32$5 = $39$hi;
  i64toi32_i32$4 = i64toi32_i32$2;
  i64toi32_i32$0 = $15$hi;
  i64toi32_i32$3 = $15;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64(i64toi32_i32$2 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$0 | 0, 48 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $47 = i64toi32_i32$4;
  $47$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $280$hi;
  i64toi32_i32$5 = $280;
  i64toi32_i32$4 = $47$hi;
  i64toi32_i32$3 = $47;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $642 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($642 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $46 = i64toi32_i32$5;
  $46$hi = i64toi32_i32$4;
  $318 = i64toi32_i32$5;
  $318$hi = i64toi32_i32$4;
  i64toi32_i32$0 = $3;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 96 | 0) >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 100 | 0) >> 2] | 0;
  $15 = i64toi32_i32$4;
  $15$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $40$hi;
  i64toi32_i32$5 = $15$hi;
  i64toi32_i32$0 = i64toi32_i32$4;
  i64toi32_i32$4 = $40$hi;
  i64toi32_i32$3 = $40;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $323$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $30$hi;
  i64toi32_i32$2 = $31$hi;
  i64toi32_i32$2 = $30$hi;
  i64toi32_i32$5 = $30;
  i64toi32_i32$0 = $31$hi;
  i64toi32_i32$3 = $31;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $643 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($643 | 0, i64toi32_i32$0 | 0, 1 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $30 = i64toi32_i32$5;
  $30$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $323$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$5 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $31 = i64toi32_i32$4;
  $31$hi = i64toi32_i32$1;
  i64toi32_i32$0 = $3;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 104 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 108 | 0) >> 2] | 0;
  $22 = i64toi32_i32$1;
  $22$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $31$hi;
  i64toi32_i32$0 = i64toi32_i32$4;
  i64toi32_i32$1 = $22$hi;
  i64toi32_i32$3 = $22;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $334 = i64toi32_i32$5;
  $334$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$4 = $23$hi;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$2 = $31;
  i64toi32_i32$0 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
  $644 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($644 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $23 = i64toi32_i32$2;
  $23$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $44$hi;
  i64toi32_i32$0 = $23$hi;
  i64toi32_i32$4 = i64toi32_i32$2;
  i64toi32_i32$2 = $44$hi;
  i64toi32_i32$3 = $44;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $31 = i64toi32_i32$1;
  $31$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $30$hi;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$4 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
  $645 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($645 | 0, i64toi32_i32$4 | 0, 40 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $30 = i64toi32_i32$0;
  $30$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $334$hi;
  i64toi32_i32$5 = $334;
  i64toi32_i32$0 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $40 = i64toi32_i32$2;
  $40$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $23$hi;
  i64toi32_i32$1 = $40$hi;
  i64toi32_i32$4 = i64toi32_i32$2;
  i64toi32_i32$5 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64(i64toi32_i32$2 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$5 | 0, 48 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $23 = i64toi32_i32$4;
  $23$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$5 = $23$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$3 = $31;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $31 = i64toi32_i32$0;
  $31$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $318$hi;
  i64toi32_i32$5 = $318;
  i64toi32_i32$1 = $31$hi;
  i64toi32_i32$3 = i64toi32_i32$0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $44 = i64toi32_i32$4;
  $44$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $45$hi;
  i64toi32_i32$0 = $44$hi;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$5 = $45$hi;
  i64toi32_i32$3 = $45;
  i64toi32_i32$5 = i64toi32_i32$0 ^ i64toi32_i32$5 | 0;
  $646 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($646 | 0, i64toi32_i32$5 | 0, 40 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $45 = i64toi32_i32$2;
  $45$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $279$hi;
  i64toi32_i32$0 = $279;
  i64toi32_i32$2 = $45$hi;
  i64toi32_i32$3 = $45;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $48 = i64toi32_i32$1;
  $48$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$4 = $48$hi;
  i64toi32_i32$5 = i64toi32_i32$1;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $365 = i64toi32_i32$2;
  $365$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $39$hi;
  i64toi32_i32$1 = $29$hi;
  i64toi32_i32$1 = $39$hi;
  i64toi32_i32$4 = $39;
  i64toi32_i32$5 = $29$hi;
  i64toi32_i32$3 = $29;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $368 = i64toi32_i32$0;
  $368$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $43$hi;
  i64toi32_i32$2 = $34$hi;
  i64toi32_i32$2 = $43$hi;
  i64toi32_i32$1 = $43;
  i64toi32_i32$4 = $34$hi;
  i64toi32_i32$3 = $34;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  $647 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($647 | 0, i64toi32_i32$4 | 0, 48 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $34 = i64toi32_i32$1;
  $34$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $41$hi;
  i64toi32_i32$4 = $34$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$1 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $39 = i64toi32_i32$5;
  $39$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $42$hi;
  i64toi32_i32$0 = $39$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$2 = $42$hi;
  i64toi32_i32$3 = $42;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $648 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($648 | 0, i64toi32_i32$2 | 0, 1 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $41 = i64toi32_i32$4;
  $41$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $368$hi;
  i64toi32_i32$0 = $368;
  i64toi32_i32$4 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $42 = i64toi32_i32$1;
  $42$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $6$hi;
  i64toi32_i32$5 = $42$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$3 = $6;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $384 = i64toi32_i32$4;
  $384$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $42$hi;
  i64toi32_i32$1 = $23$hi;
  i64toi32_i32$1 = $42$hi;
  i64toi32_i32$5 = $42;
  i64toi32_i32$2 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $649 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($649 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $23 = i64toi32_i32$5;
  $23$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $24$hi;
  i64toi32_i32$2 = $23$hi;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$5 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $24 = i64toi32_i32$0;
  $24$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $41$hi;
  i64toi32_i32$4 = $24$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$1 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
  $650 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($650 | 0, i64toi32_i32$1 | 0, 40 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $41 = i64toi32_i32$2;
  $41$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $384$hi;
  i64toi32_i32$4 = $384;
  i64toi32_i32$2 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $42 = i64toi32_i32$5;
  $42$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $23$hi;
  i64toi32_i32$0 = $42$hi;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$4 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64(i64toi32_i32$5 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$4 | 0, 48 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $23 = i64toi32_i32$1;
  $23$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $24$hi;
  i64toi32_i32$4 = $23$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$1 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $24 = i64toi32_i32$2;
  $24$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $41$hi;
  i64toi32_i32$5 = $24$hi;
  i64toi32_i32$4 = i64toi32_i32$2;
  i64toi32_i32$0 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64(i64toi32_i32$2 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$0 | 0, 1 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $41 = i64toi32_i32$4;
  $41$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $365$hi;
  i64toi32_i32$5 = $365;
  i64toi32_i32$4 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $43 = i64toi32_i32$1;
  $43$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $15$hi;
  i64toi32_i32$2 = $43$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$5 = $15$hi;
  i64toi32_i32$3 = $15;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $413 = i64toi32_i32$4;
  $413$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $43$hi;
  $414 = $43;
  $414$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $32$hi;
  i64toi32_i32$1 = $22$hi;
  i64toi32_i32$1 = $32$hi;
  i64toi32_i32$2 = $32;
  i64toi32_i32$0 = $22$hi;
  i64toi32_i32$3 = $22;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $417$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$4 = $30$hi;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$1 = $31;
  i64toi32_i32$2 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $651 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($651 | 0, i64toi32_i32$2 | 0, 1 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $30 = i64toi32_i32$1;
  $30$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $417$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$1 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $31 = i64toi32_i32$0;
  $31$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $21$hi;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$4 = $21$hi;
  i64toi32_i32$3 = $21;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $426 = i64toi32_i32$1;
  $426$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $31$hi;
  i64toi32_i32$0 = $34$hi;
  i64toi32_i32$0 = $31$hi;
  i64toi32_i32$5 = $31;
  i64toi32_i32$2 = $34$hi;
  i64toi32_i32$3 = $34;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $652 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($652 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $31 = i64toi32_i32$5;
  $31$hi = i64toi32_i32$2;
  $431 = i64toi32_i32$5;
  $431$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $47$hi;
  i64toi32_i32$2 = $33$hi;
  i64toi32_i32$2 = $47$hi;
  i64toi32_i32$0 = $47;
  i64toi32_i32$5 = $33$hi;
  i64toi32_i32$3 = $33;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $32 = i64toi32_i32$4;
  $32$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $431$hi;
  i64toi32_i32$2 = $431;
  i64toi32_i32$0 = $32$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $33 = i64toi32_i32$5;
  $33$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $30$hi;
  i64toi32_i32$4 = $33$hi;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$2 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64(i64toi32_i32$5 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$2 | 0, 40 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $30 = i64toi32_i32$1;
  $30$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $426$hi;
  i64toi32_i32$4 = $426;
  i64toi32_i32$1 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $34 = i64toi32_i32$0;
  $34$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$5 = $34$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$3 = $31;
  i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
  $653 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($653 | 0, i64toi32_i32$4 | 0, 48 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $31 = i64toi32_i32$2;
  $31$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $414$hi;
  i64toi32_i32$5 = $414;
  i64toi32_i32$2 = $31$hi;
  i64toi32_i32$3 = $31;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $654 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($654 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $43 = i64toi32_i32$5;
  $43$hi = i64toi32_i32$2;
  $450 = i64toi32_i32$5;
  $450$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $40$hi;
  i64toi32_i32$2 = $19$hi;
  i64toi32_i32$2 = $40$hi;
  i64toi32_i32$4 = $40;
  i64toi32_i32$5 = $19$hi;
  i64toi32_i32$3 = $19;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $453$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $32$hi;
  i64toi32_i32$0 = $38$hi;
  i64toi32_i32$0 = $32$hi;
  i64toi32_i32$2 = $32;
  i64toi32_i32$4 = $38$hi;
  i64toi32_i32$3 = $38;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $655 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($655 | 0, i64toi32_i32$4 | 0, 1 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $32 = i64toi32_i32$2;
  $32$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $453$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$2 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $38 = i64toi32_i32$5;
  $38$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$1 = $38$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $462 = i64toi32_i32$2;
  $462$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $38$hi;
  i64toi32_i32$5 = $37$hi;
  i64toi32_i32$5 = $38$hi;
  i64toi32_i32$1 = $38;
  i64toi32_i32$4 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
  $656 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($656 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $37 = i64toi32_i32$1;
  $37$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $39$hi;
  i64toi32_i32$4 = $37$hi;
  i64toi32_i32$5 = i64toi32_i32$1;
  i64toi32_i32$1 = $39$hi;
  i64toi32_i32$3 = $39;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $38 = i64toi32_i32$0;
  $38$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $32$hi;
  i64toi32_i32$2 = $38$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$5 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $657 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($657 | 0, i64toi32_i32$5 | 0, 40 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $32 = i64toi32_i32$4;
  $32$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $462$hi;
  i64toi32_i32$2 = $462;
  i64toi32_i32$4 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $39 = i64toi32_i32$1;
  $39$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $37$hi;
  i64toi32_i32$0 = $39$hi;
  i64toi32_i32$5 = i64toi32_i32$1;
  i64toi32_i32$2 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $658 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($658 | 0, i64toi32_i32$2 | 0, 48 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $37 = i64toi32_i32$5;
  $37$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $38$hi;
  i64toi32_i32$2 = $37$hi;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$5 = $38$hi;
  i64toi32_i32$3 = $38;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $38 = i64toi32_i32$4;
  $38$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $450$hi;
  i64toi32_i32$2 = $450;
  i64toi32_i32$0 = $38$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $40 = i64toi32_i32$5;
  $40$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $41$hi;
  i64toi32_i32$4 = $40$hi;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$2 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64(i64toi32_i32$5 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$2 | 0, 40 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $41 = i64toi32_i32$1;
  $41$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $413$hi;
  i64toi32_i32$4 = $413;
  i64toi32_i32$1 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $47 = i64toi32_i32$0;
  $47$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $14$hi;
  i64toi32_i32$5 = $47$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$4 = $14$hi;
  i64toi32_i32$3 = $14;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $493 = i64toi32_i32$1;
  $493$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $48$hi;
  i64toi32_i32$0 = $46$hi;
  i64toi32_i32$0 = $48$hi;
  i64toi32_i32$5 = $48;
  i64toi32_i32$2 = $46$hi;
  i64toi32_i32$3 = $46;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $659 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($659 | 0, i64toi32_i32$2 | 0, 48 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $46 = i64toi32_i32$5;
  $46$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $44$hi;
  i64toi32_i32$2 = $46$hi;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$5 = $44$hi;
  i64toi32_i32$3 = $44;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $44 = i64toi32_i32$4;
  $44$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $45$hi;
  i64toi32_i32$1 = $44$hi;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$0 = $45$hi;
  i64toi32_i32$3 = $45;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $660 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($660 | 0, i64toi32_i32$0 | 0, 1 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $45 = i64toi32_i32$2;
  $45$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $26$hi;
  i64toi32_i32$0 = $45$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$2 = $26$hi;
  i64toi32_i32$3 = $26;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $507$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $34$hi;
  i64toi32_i32$4 = $507$hi;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$1 = $34$hi;
  i64toi32_i32$3 = $34;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $34 = i64toi32_i32$2;
  $34$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $11$hi;
  i64toi32_i32$5 = $34$hi;
  i64toi32_i32$4 = i64toi32_i32$2;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $512 = i64toi32_i32$1;
  $512$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $34$hi;
  i64toi32_i32$2 = $37$hi;
  i64toi32_i32$2 = $34$hi;
  i64toi32_i32$5 = $34;
  i64toi32_i32$4 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  $661 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($661 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $34 = i64toi32_i32$5;
  $34$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $24$hi;
  i64toi32_i32$4 = $34$hi;
  i64toi32_i32$2 = i64toi32_i32$5;
  i64toi32_i32$5 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $24 = i64toi32_i32$0;
  $24$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $45$hi;
  i64toi32_i32$1 = $24$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$2 = $45$hi;
  i64toi32_i32$3 = $45;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $662 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($662 | 0, i64toi32_i32$2 | 0, 40 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $37 = i64toi32_i32$4;
  $37$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $512$hi;
  i64toi32_i32$1 = $512;
  i64toi32_i32$4 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $45 = i64toi32_i32$5;
  $45$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $34$hi;
  i64toi32_i32$0 = $45$hi;
  i64toi32_i32$2 = i64toi32_i32$5;
  i64toi32_i32$1 = $34$hi;
  i64toi32_i32$3 = $34;
  i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
  $663 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($663 | 0, i64toi32_i32$1 | 0, 48 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $34 = i64toi32_i32$2;
  $34$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $24$hi;
  i64toi32_i32$1 = $34$hi;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$2 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $24 = i64toi32_i32$4;
  $24$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $37$hi;
  i64toi32_i32$5 = $24$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$0 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64(i64toi32_i32$4 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$0 | 0, 1 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $37 = i64toi32_i32$1;
  $37$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $493$hi;
  i64toi32_i32$5 = $493;
  i64toi32_i32$1 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $48 = i64toi32_i32$2;
  $48$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $6$hi;
  i64toi32_i32$4 = $48$hi;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$5 = $6$hi;
  i64toi32_i32$3 = $6;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $541 = i64toi32_i32$1;
  $541$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $48$hi;
  $542 = $48;
  $542$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $42$hi;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$2 = $42$hi;
  i64toi32_i32$4 = $42;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$3 = $10;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $545$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $38$hi;
  i64toi32_i32$1 = $32$hi;
  i64toi32_i32$1 = $38$hi;
  i64toi32_i32$2 = $38;
  i64toi32_i32$4 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $664 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($664 | 0, i64toi32_i32$4 | 0, 1 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $32 = i64toi32_i32$2;
  $32$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $545$hi;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$2 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $38 = i64toi32_i32$0;
  $38$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $18$hi;
  i64toi32_i32$5 = $38$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$1 = $18$hi;
  i64toi32_i32$3 = $18;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $554 = i64toi32_i32$2;
  $554$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $38$hi;
  i64toi32_i32$0 = $46$hi;
  i64toi32_i32$0 = $38$hi;
  i64toi32_i32$5 = $38;
  i64toi32_i32$4 = $46$hi;
  i64toi32_i32$3 = $46;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $665 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($665 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $38 = i64toi32_i32$5;
  $38$hi = i64toi32_i32$4;
  $559 = i64toi32_i32$5;
  $559$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$4 = $33$hi;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$0 = $31;
  i64toi32_i32$5 = $33$hi;
  i64toi32_i32$3 = $33;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $31 = i64toi32_i32$1;
  $31$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $559$hi;
  i64toi32_i32$4 = $559;
  i64toi32_i32$0 = $31$hi;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $33 = i64toi32_i32$5;
  $33$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $32$hi;
  i64toi32_i32$1 = $33$hi;
  i64toi32_i32$2 = i64toi32_i32$5;
  i64toi32_i32$4 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $666 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($666 | 0, i64toi32_i32$4 | 0, 40 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $32 = i64toi32_i32$2;
  $32$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $554$hi;
  i64toi32_i32$1 = $554;
  i64toi32_i32$2 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $42 = i64toi32_i32$0;
  $42$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $38$hi;
  i64toi32_i32$5 = $42$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$1 = $38$hi;
  i64toi32_i32$3 = $38;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $667 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($667 | 0, i64toi32_i32$1 | 0, 48 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $38 = i64toi32_i32$4;
  $38$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $542$hi;
  i64toi32_i32$5 = $542;
  i64toi32_i32$4 = $38$hi;
  i64toi32_i32$3 = $38;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $668 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($668 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $46 = i64toi32_i32$5;
  $46$hi = i64toi32_i32$4;
  $578 = i64toi32_i32$5;
  $578$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $39$hi;
  i64toi32_i32$4 = $14$hi;
  i64toi32_i32$4 = $39$hi;
  i64toi32_i32$1 = $39;
  i64toi32_i32$5 = $14$hi;
  i64toi32_i32$3 = $14;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $581$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $31$hi;
  i64toi32_i32$0 = $30$hi;
  i64toi32_i32$0 = $31$hi;
  i64toi32_i32$4 = $31;
  i64toi32_i32$1 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
  $671 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($671 | 0, i64toi32_i32$1 | 0, 1 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $30 = i64toi32_i32$4;
  $30$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $581$hi;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$4 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $31 = i64toi32_i32$5;
  $31$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $20$hi;
  i64toi32_i32$2 = $31$hi;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$0 = $20$hi;
  i64toi32_i32$3 = $20;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $590 = i64toi32_i32$4;
  $590$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$5 = $23$hi;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$2 = $31;
  i64toi32_i32$1 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $672 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($672 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $23 = i64toi32_i32$2;
  $23$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $44$hi;
  i64toi32_i32$1 = $23$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $44$hi;
  i64toi32_i32$3 = $44;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $31 = i64toi32_i32$0;
  $31$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $30$hi;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$5 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64(i64toi32_i32$0 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$5 | 0, 40 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $30 = i64toi32_i32$1;
  $30$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $590$hi;
  i64toi32_i32$4 = $590;
  i64toi32_i32$1 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $39 = i64toi32_i32$2;
  $39$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $23$hi;
  i64toi32_i32$0 = $39$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$4 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$2 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$4 | 0, 48 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $23 = i64toi32_i32$5;
  $23$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$4 = $23$hi;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$3 = $31;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $31 = i64toi32_i32$1;
  $31$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $578$hi;
  i64toi32_i32$4 = $578;
  i64toi32_i32$0 = $31$hi;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $44 = i64toi32_i32$5;
  $44$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $37$hi;
  i64toi32_i32$1 = $44$hi;
  i64toi32_i32$2 = i64toi32_i32$5;
  i64toi32_i32$4 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $673 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($673 | 0, i64toi32_i32$4 | 0, 40 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $37 = i64toi32_i32$2;
  $37$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $541$hi;
  i64toi32_i32$1 = $541;
  i64toi32_i32$2 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $48 = i64toi32_i32$0;
  $48$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $13$hi;
  i64toi32_i32$5 = $48$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$1 = $13$hi;
  i64toi32_i32$3 = $13;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $621 = i64toi32_i32$2;
  $621$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $42$hi;
  i64toi32_i32$0 = $15$hi;
  i64toi32_i32$0 = $42$hi;
  i64toi32_i32$5 = $42;
  i64toi32_i32$4 = $15$hi;
  i64toi32_i32$3 = $15;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $624 = i64toi32_i32$1;
  $624$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $47$hi;
  i64toi32_i32$2 = $43$hi;
  i64toi32_i32$2 = $47$hi;
  i64toi32_i32$0 = $47;
  i64toi32_i32$5 = $43$hi;
  i64toi32_i32$3 = $43;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $674 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($674 | 0, i64toi32_i32$5 | 0, 48 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $42 = i64toi32_i32$0;
  $42$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $40$hi;
  i64toi32_i32$5 = $42$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = $40$hi;
  i64toi32_i32$3 = $40;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $40 = i64toi32_i32$4;
  $40$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $41$hi;
  i64toi32_i32$1 = $40$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$2 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$4 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$2 | 0, 1 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $41 = i64toi32_i32$5;
  $41$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $624$hi;
  i64toi32_i32$1 = $624;
  i64toi32_i32$5 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $43 = i64toi32_i32$0;
  $43$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $10$hi;
  i64toi32_i32$4 = $43$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$1 = $10$hi;
  i64toi32_i32$3 = $10;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $640 = i64toi32_i32$5;
  $640$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $43$hi;
  i64toi32_i32$0 = $23$hi;
  i64toi32_i32$0 = $43$hi;
  i64toi32_i32$4 = $43;
  i64toi32_i32$2 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $675 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($675 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $23 = i64toi32_i32$4;
  $23$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $24$hi;
  i64toi32_i32$2 = $23$hi;
  i64toi32_i32$0 = i64toi32_i32$4;
  i64toi32_i32$4 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $24 = i64toi32_i32$1;
  $24$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $41$hi;
  i64toi32_i32$5 = $24$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $676 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($676 | 0, i64toi32_i32$0 | 0, 40 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $41 = i64toi32_i32$2;
  $41$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $640$hi;
  i64toi32_i32$5 = $640;
  i64toi32_i32$2 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $43 = i64toi32_i32$4;
  $43$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $23$hi;
  i64toi32_i32$1 = $43$hi;
  i64toi32_i32$0 = i64toi32_i32$4;
  i64toi32_i32$5 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64(i64toi32_i32$4 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$5 | 0, 48 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $23 = i64toi32_i32$0;
  $23$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $24$hi;
  i64toi32_i32$5 = $23$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$0 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $24 = i64toi32_i32$2;
  $24$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $41$hi;
  i64toi32_i32$4 = $24$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$1 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$2 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$1 | 0, 1 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $41 = i64toi32_i32$5;
  $41$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $621$hi;
  i64toi32_i32$4 = $621;
  i64toi32_i32$5 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $47 = i64toi32_i32$0;
  $47$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $25$hi;
  i64toi32_i32$2 = $47$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$4 = $25$hi;
  i64toi32_i32$3 = $25;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $669 = i64toi32_i32$5;
  $669$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $47$hi;
  $670 = $47;
  $670$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $45$hi;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$0 = $45$hi;
  i64toi32_i32$2 = $45;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $673$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$5 = $30$hi;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$0 = $31;
  i64toi32_i32$2 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  $677 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($677 | 0, i64toi32_i32$2 | 0, 1 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $30 = i64toi32_i32$0;
  $30$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $673$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$0 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $31 = i64toi32_i32$1;
  $31$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $22$hi;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$5 = $22$hi;
  i64toi32_i32$3 = $22;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $682 = i64toi32_i32$0;
  $682$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $31$hi;
  i64toi32_i32$1 = $42$hi;
  i64toi32_i32$1 = $31$hi;
  i64toi32_i32$4 = $31;
  i64toi32_i32$2 = $42$hi;
  i64toi32_i32$3 = $42;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $678 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($678 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $31 = i64toi32_i32$4;
  $31$hi = i64toi32_i32$2;
  $687 = i64toi32_i32$4;
  $687$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $38$hi;
  i64toi32_i32$2 = $33$hi;
  i64toi32_i32$2 = $38$hi;
  i64toi32_i32$1 = $38;
  i64toi32_i32$4 = $33$hi;
  i64toi32_i32$3 = $33;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $33 = i64toi32_i32$5;
  $33$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $687$hi;
  i64toi32_i32$2 = $687;
  i64toi32_i32$1 = $33$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $38 = i64toi32_i32$4;
  $38$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $30$hi;
  i64toi32_i32$5 = $38$hi;
  i64toi32_i32$0 = i64toi32_i32$4;
  i64toi32_i32$2 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64(i64toi32_i32$4 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$2 | 0, 40 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $30 = i64toi32_i32$0;
  $30$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $682$hi;
  i64toi32_i32$5 = $682;
  i64toi32_i32$0 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $42 = i64toi32_i32$1;
  $42$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$4 = $42$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$3 = $31;
  i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
  $679 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($679 | 0, i64toi32_i32$5 | 0, 48 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $31 = i64toi32_i32$2;
  $31$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $670$hi;
  i64toi32_i32$4 = $670;
  i64toi32_i32$2 = $31$hi;
  i64toi32_i32$3 = $31;
  i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  $680 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($680 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $45 = i64toi32_i32$4;
  $45$hi = i64toi32_i32$2;
  $706 = i64toi32_i32$4;
  $706$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $39$hi;
  i64toi32_i32$2 = $26$hi;
  i64toi32_i32$2 = $39$hi;
  i64toi32_i32$5 = $39;
  i64toi32_i32$4 = $26$hi;
  i64toi32_i32$3 = $26;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $709$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $33$hi;
  i64toi32_i32$1 = $32$hi;
  i64toi32_i32$1 = $33$hi;
  i64toi32_i32$2 = $33;
  i64toi32_i32$5 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
  $681 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($681 | 0, i64toi32_i32$5 | 0, 1 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $32 = i64toi32_i32$2;
  $32$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $709$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$2 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $33 = i64toi32_i32$4;
  $33$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $18$hi;
  i64toi32_i32$0 = $33$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$1 = $18$hi;
  i64toi32_i32$3 = $18;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $718 = i64toi32_i32$2;
  $718$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $33$hi;
  i64toi32_i32$4 = $34$hi;
  i64toi32_i32$4 = $33$hi;
  i64toi32_i32$0 = $33;
  i64toi32_i32$5 = $34$hi;
  i64toi32_i32$3 = $34;
  i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
  $683 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($683 | 0, i64toi32_i32$5 | 0, 32 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $33 = i64toi32_i32$0;
  $33$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $40$hi;
  i64toi32_i32$5 = $33$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$0 = $40$hi;
  i64toi32_i32$3 = $40;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $34 = i64toi32_i32$1;
  $34$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $32$hi;
  i64toi32_i32$2 = $34$hi;
  i64toi32_i32$5 = i64toi32_i32$1;
  i64toi32_i32$4 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  $684 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($684 | 0, i64toi32_i32$4 | 0, 40 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $32 = i64toi32_i32$5;
  $32$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $718$hi;
  i64toi32_i32$2 = $718;
  i64toi32_i32$5 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $39 = i64toi32_i32$0;
  $39$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $33$hi;
  i64toi32_i32$1 = $39$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$2 = $33$hi;
  i64toi32_i32$3 = $33;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $685 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($685 | 0, i64toi32_i32$2 | 0, 48 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $33 = i64toi32_i32$4;
  $33$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $34$hi;
  i64toi32_i32$2 = $33$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$4 = $34$hi;
  i64toi32_i32$3 = $34;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $34 = i64toi32_i32$5;
  $34$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $706$hi;
  i64toi32_i32$2 = $706;
  i64toi32_i32$1 = $34$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $40 = i64toi32_i32$4;
  $40$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $41$hi;
  i64toi32_i32$5 = $40$hi;
  i64toi32_i32$0 = i64toi32_i32$4;
  i64toi32_i32$2 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64(i64toi32_i32$4 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$2 | 0, 40 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $41 = i64toi32_i32$0;
  $41$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $669$hi;
  i64toi32_i32$5 = $669;
  i64toi32_i32$0 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $47 = i64toi32_i32$1;
  $47$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $20$hi;
  i64toi32_i32$4 = $47$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$5 = $20$hi;
  i64toi32_i32$3 = $20;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $749 = i64toi32_i32$0;
  $749$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $42$hi;
  i64toi32_i32$1 = $19$hi;
  i64toi32_i32$1 = $42$hi;
  i64toi32_i32$4 = $42;
  i64toi32_i32$2 = $19$hi;
  i64toi32_i32$3 = $19;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $752 = i64toi32_i32$5;
  $752$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $48$hi;
  i64toi32_i32$0 = $46$hi;
  i64toi32_i32$0 = $48$hi;
  i64toi32_i32$1 = $48;
  i64toi32_i32$4 = $46$hi;
  i64toi32_i32$3 = $46;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $686 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($686 | 0, i64toi32_i32$4 | 0, 48 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $42 = i64toi32_i32$1;
  $42$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $44$hi;
  i64toi32_i32$4 = $42$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$1 = $44$hi;
  i64toi32_i32$3 = $44;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $44 = i64toi32_i32$2;
  $44$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $37$hi;
  i64toi32_i32$5 = $44$hi;
  i64toi32_i32$4 = i64toi32_i32$2;
  i64toi32_i32$0 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64(i64toi32_i32$2 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$0 | 0, 1 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $37 = i64toi32_i32$4;
  $37$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $752$hi;
  i64toi32_i32$5 = $752;
  i64toi32_i32$4 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $46 = i64toi32_i32$1;
  $46$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $29$hi;
  i64toi32_i32$2 = $46$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$5 = $29$hi;
  i64toi32_i32$3 = $29;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $768 = i64toi32_i32$4;
  $768$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $46$hi;
  i64toi32_i32$1 = $33$hi;
  i64toi32_i32$1 = $46$hi;
  i64toi32_i32$2 = $46;
  i64toi32_i32$0 = $33$hi;
  i64toi32_i32$3 = $33;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $688 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($688 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $33 = i64toi32_i32$2;
  $33$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $24$hi;
  i64toi32_i32$0 = $33$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$2 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $24 = i64toi32_i32$5;
  $24$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $37$hi;
  i64toi32_i32$4 = $24$hi;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$1 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64(i64toi32_i32$5 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$1 | 0, 40 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $37 = i64toi32_i32$0;
  $37$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $768$hi;
  i64toi32_i32$4 = $768;
  i64toi32_i32$0 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $46 = i64toi32_i32$2;
  $46$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $33$hi;
  i64toi32_i32$5 = $46$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$4 = $33$hi;
  i64toi32_i32$3 = $33;
  i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64(i64toi32_i32$2 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$4 | 0, 48 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $33 = i64toi32_i32$1;
  $33$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $24$hi;
  i64toi32_i32$4 = $33$hi;
  i64toi32_i32$5 = i64toi32_i32$1;
  i64toi32_i32$1 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $24 = i64toi32_i32$0;
  $24$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $37$hi;
  i64toi32_i32$2 = $24$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$5 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $689 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($689 | 0, i64toi32_i32$5 | 0, 1 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $37 = i64toi32_i32$4;
  $37$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $749$hi;
  i64toi32_i32$2 = $749;
  i64toi32_i32$4 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $48 = i64toi32_i32$1;
  $48$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $19$hi;
  i64toi32_i32$0 = $48$hi;
  i64toi32_i32$5 = i64toi32_i32$1;
  i64toi32_i32$2 = $19$hi;
  i64toi32_i32$3 = $19;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $797 = i64toi32_i32$4;
  $797$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $48$hi;
  $798 = $48;
  $798$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $43$hi;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$1 = $43$hi;
  i64toi32_i32$0 = $43;
  i64toi32_i32$5 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $801$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $34$hi;
  i64toi32_i32$4 = $32$hi;
  i64toi32_i32$4 = $34$hi;
  i64toi32_i32$1 = $34;
  i64toi32_i32$0 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
  $690 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($690 | 0, i64toi32_i32$0 | 0, 1 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $32 = i64toi32_i32$1;
  $32$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $801$hi;
  i64toi32_i32$4 = i64toi32_i32$2;
  i64toi32_i32$1 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $34 = i64toi32_i32$5;
  $34$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $21$hi;
  i64toi32_i32$2 = $34$hi;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$4 = $21$hi;
  i64toi32_i32$3 = $21;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $810 = i64toi32_i32$1;
  $810$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $34$hi;
  i64toi32_i32$5 = $42$hi;
  i64toi32_i32$5 = $34$hi;
  i64toi32_i32$2 = $34;
  i64toi32_i32$0 = $42$hi;
  i64toi32_i32$3 = $42;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $691 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($691 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $34 = i64toi32_i32$2;
  $34$hi = i64toi32_i32$0;
  $815 = i64toi32_i32$2;
  $815$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $31$hi;
  i64toi32_i32$0 = $38$hi;
  i64toi32_i32$0 = $31$hi;
  i64toi32_i32$5 = $31;
  i64toi32_i32$2 = $38$hi;
  i64toi32_i32$3 = $38;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $31 = i64toi32_i32$4;
  $31$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $815$hi;
  i64toi32_i32$0 = $815;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $38 = i64toi32_i32$2;
  $38$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $32$hi;
  i64toi32_i32$4 = $38$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$0 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64(i64toi32_i32$2 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$0 | 0, 40 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $32 = i64toi32_i32$1;
  $32$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $810$hi;
  i64toi32_i32$4 = $810;
  i64toi32_i32$1 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $42 = i64toi32_i32$5;
  $42$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $34$hi;
  i64toi32_i32$2 = $42$hi;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$4 = $34$hi;
  i64toi32_i32$3 = $34;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64(i64toi32_i32$5 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$4 | 0, 48 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $34 = i64toi32_i32$0;
  $34$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $798$hi;
  i64toi32_i32$2 = $798;
  i64toi32_i32$0 = $34$hi;
  i64toi32_i32$3 = $34;
  i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
  $692 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($692 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $43 = i64toi32_i32$2;
  $43$hi = i64toi32_i32$0;
  $834 = i64toi32_i32$2;
  $834$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $39$hi;
  i64toi32_i32$0 = $20$hi;
  i64toi32_i32$0 = $39$hi;
  i64toi32_i32$4 = $39;
  i64toi32_i32$2 = $20$hi;
  i64toi32_i32$3 = $20;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $837$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$5 = $30$hi;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$0 = $31;
  i64toi32_i32$4 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
  $693 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($693 | 0, i64toi32_i32$4 | 0, 1 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $30 = i64toi32_i32$0;
  $30$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $837$hi;
  i64toi32_i32$5 = i64toi32_i32$1;
  i64toi32_i32$0 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $31 = i64toi32_i32$2;
  $31$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$1 = $31$hi;
  i64toi32_i32$4 = i64toi32_i32$2;
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $846 = i64toi32_i32$0;
  $846$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $31$hi;
  i64toi32_i32$2 = $23$hi;
  i64toi32_i32$2 = $31$hi;
  i64toi32_i32$1 = $31;
  i64toi32_i32$4 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  $694 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($694 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $23 = i64toi32_i32$1;
  $23$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $44$hi;
  i64toi32_i32$4 = $23$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$1 = $44$hi;
  i64toi32_i32$3 = $44;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $31 = i64toi32_i32$5;
  $31$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $30$hi;
  i64toi32_i32$0 = $31$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$2 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $695 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($695 | 0, i64toi32_i32$2 | 0, 40 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $30 = i64toi32_i32$4;
  $30$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $846$hi;
  i64toi32_i32$0 = $846;
  i64toi32_i32$4 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $39 = i64toi32_i32$1;
  $39$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $23$hi;
  i64toi32_i32$5 = $39$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $696 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($696 | 0, i64toi32_i32$0 | 0, 48 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $23 = i64toi32_i32$2;
  $23$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $31$hi;
  i64toi32_i32$0 = $23$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $31$hi;
  i64toi32_i32$3 = $31;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $31 = i64toi32_i32$4;
  $31$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $834$hi;
  i64toi32_i32$0 = $834;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $44 = i64toi32_i32$2;
  $44$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $37$hi;
  i64toi32_i32$4 = $44$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$0 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64(i64toi32_i32$2 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$0 | 0, 40 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $37 = i64toi32_i32$1;
  $37$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $797$hi;
  i64toi32_i32$4 = $797;
  i64toi32_i32$1 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $48 = i64toi32_i32$5;
  $48$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $18$hi;
  i64toi32_i32$2 = $48$hi;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$4 = $18$hi;
  i64toi32_i32$3 = $18;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $877 = i64toi32_i32$1;
  $877$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $42$hi;
  i64toi32_i32$5 = $11$hi;
  i64toi32_i32$5 = $42$hi;
  i64toi32_i32$2 = $42;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $880 = i64toi32_i32$4;
  $880$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $47$hi;
  i64toi32_i32$1 = $45$hi;
  i64toi32_i32$1 = $47$hi;
  i64toi32_i32$5 = $47;
  i64toi32_i32$2 = $45$hi;
  i64toi32_i32$3 = $45;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $697 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($697 | 0, i64toi32_i32$2 | 0, 48 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $42 = i64toi32_i32$5;
  $42$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $40$hi;
  i64toi32_i32$2 = $42$hi;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$5 = $40$hi;
  i64toi32_i32$3 = $40;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $40 = i64toi32_i32$0;
  $40$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $41$hi;
  i64toi32_i32$4 = $40$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$1 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
  $698 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($698 | 0, i64toi32_i32$1 | 0, 1 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $41 = i64toi32_i32$2;
  $41$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $880$hi;
  i64toi32_i32$4 = $880;
  i64toi32_i32$2 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $45 = i64toi32_i32$5;
  $45$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$0 = $45$hi;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $896 = i64toi32_i32$2;
  $896$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $45$hi;
  i64toi32_i32$5 = $23$hi;
  i64toi32_i32$5 = $45$hi;
  i64toi32_i32$0 = $45;
  i64toi32_i32$1 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $699 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($699 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $23 = i64toi32_i32$0;
  $23$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $24$hi;
  i64toi32_i32$1 = $23$hi;
  i64toi32_i32$5 = i64toi32_i32$0;
  i64toi32_i32$0 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $24 = i64toi32_i32$4;
  $24$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $41$hi;
  i64toi32_i32$2 = $24$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$5 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64(i64toi32_i32$4 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$5 | 0, 40 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $41 = i64toi32_i32$1;
  $41$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $896$hi;
  i64toi32_i32$2 = $896;
  i64toi32_i32$1 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $45 = i64toi32_i32$0;
  $45$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $23$hi;
  i64toi32_i32$4 = $45$hi;
  i64toi32_i32$5 = i64toi32_i32$0;
  i64toi32_i32$2 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $700 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($700 | 0, i64toi32_i32$2 | 0, 48 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $23 = i64toi32_i32$5;
  $23$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $24$hi;
  i64toi32_i32$2 = $23$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$5 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $24 = i64toi32_i32$1;
  $24$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $41$hi;
  i64toi32_i32$0 = $24$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$4 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $701 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($701 | 0, i64toi32_i32$4 | 0, 1 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $41 = i64toi32_i32$2;
  $41$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $877$hi;
  i64toi32_i32$0 = $877;
  i64toi32_i32$2 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $47 = i64toi32_i32$5;
  $47$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $21$hi;
  i64toi32_i32$1 = $47$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$0 = $21$hi;
  i64toi32_i32$3 = $21;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $925 = i64toi32_i32$2;
  $925$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $47$hi;
  $926 = $47;
  $926$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $46$hi;
  i64toi32_i32$5 = $14$hi;
  i64toi32_i32$5 = $46$hi;
  i64toi32_i32$1 = $46;
  i64toi32_i32$4 = $14$hi;
  i64toi32_i32$3 = $14;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $929$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $31$hi;
  i64toi32_i32$2 = $30$hi;
  i64toi32_i32$2 = $31$hi;
  i64toi32_i32$5 = $31;
  i64toi32_i32$1 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
  $702 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($702 | 0, i64toi32_i32$1 | 0, 1 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $30 = i64toi32_i32$5;
  $30$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $929$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$5 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $31 = i64toi32_i32$4;
  $31$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $25$hi;
  i64toi32_i32$0 = $31$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$2 = $25$hi;
  i64toi32_i32$3 = $25;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $938 = i64toi32_i32$5;
  $938$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$4 = $42$hi;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$0 = $31;
  i64toi32_i32$1 = $42$hi;
  i64toi32_i32$3 = $42;
  i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
  $703 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($703 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $31 = i64toi32_i32$0;
  $31$hi = i64toi32_i32$1;
  $943 = i64toi32_i32$0;
  $943$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $34$hi;
  i64toi32_i32$1 = $38$hi;
  i64toi32_i32$1 = $34$hi;
  i64toi32_i32$4 = $34;
  i64toi32_i32$0 = $38$hi;
  i64toi32_i32$3 = $38;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $34 = i64toi32_i32$2;
  $34$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $943$hi;
  i64toi32_i32$1 = $943;
  i64toi32_i32$4 = $34$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $38 = i64toi32_i32$0;
  $38$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $30$hi;
  i64toi32_i32$2 = $38$hi;
  i64toi32_i32$5 = i64toi32_i32$0;
  i64toi32_i32$1 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
  $704 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($704 | 0, i64toi32_i32$1 | 0, 40 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $30 = i64toi32_i32$5;
  $30$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $938$hi;
  i64toi32_i32$2 = $938;
  i64toi32_i32$5 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $42 = i64toi32_i32$4;
  $42$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $31$hi;
  i64toi32_i32$0 = $42$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$2 = $31$hi;
  i64toi32_i32$3 = $31;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64(i64toi32_i32$4 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$2 | 0, 48 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $31 = i64toi32_i32$1;
  $31$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $926$hi;
  i64toi32_i32$0 = $926;
  i64toi32_i32$1 = $31$hi;
  i64toi32_i32$3 = $31;
  i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
  $705 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($705 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $46 = i64toi32_i32$0;
  $46$hi = i64toi32_i32$1;
  $962 = i64toi32_i32$0;
  $962$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $39$hi;
  i64toi32_i32$1 = $22$hi;
  i64toi32_i32$1 = $39$hi;
  i64toi32_i32$2 = $39;
  i64toi32_i32$0 = $22$hi;
  i64toi32_i32$3 = $22;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $965$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $34$hi;
  i64toi32_i32$4 = $32$hi;
  i64toi32_i32$4 = $34$hi;
  i64toi32_i32$1 = $34;
  i64toi32_i32$2 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $707 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($707 | 0, i64toi32_i32$2 | 0, 1 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $32 = i64toi32_i32$1;
  $32$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $965$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$1 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $34 = i64toi32_i32$0;
  $34$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $15$hi;
  i64toi32_i32$5 = $34$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$4 = $15$hi;
  i64toi32_i32$3 = $15;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $974 = i64toi32_i32$1;
  $974$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $34$hi;
  i64toi32_i32$0 = $33$hi;
  i64toi32_i32$0 = $34$hi;
  i64toi32_i32$5 = $34;
  i64toi32_i32$2 = $33$hi;
  i64toi32_i32$3 = $33;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $708 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($708 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $33 = i64toi32_i32$5;
  $33$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $40$hi;
  i64toi32_i32$2 = $33$hi;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$5 = $40$hi;
  i64toi32_i32$3 = $40;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $34 = i64toi32_i32$4;
  $34$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $32$hi;
  i64toi32_i32$1 = $34$hi;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$0 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $709 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($709 | 0, i64toi32_i32$0 | 0, 40 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $32 = i64toi32_i32$2;
  $32$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $974$hi;
  i64toi32_i32$1 = $974;
  i64toi32_i32$2 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $39 = i64toi32_i32$5;
  $39$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $33$hi;
  i64toi32_i32$4 = $39$hi;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$1 = $33$hi;
  i64toi32_i32$3 = $33;
  i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64(i64toi32_i32$5 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$1 | 0, 48 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $33 = i64toi32_i32$0;
  $33$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $34$hi;
  i64toi32_i32$1 = $33$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$0 = $34$hi;
  i64toi32_i32$3 = $34;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $34 = i64toi32_i32$2;
  $34$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $962$hi;
  i64toi32_i32$1 = $962;
  i64toi32_i32$4 = $34$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $40 = i64toi32_i32$0;
  $40$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $41$hi;
  i64toi32_i32$2 = $40$hi;
  i64toi32_i32$5 = i64toi32_i32$0;
  i64toi32_i32$1 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
  $710 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($710 | 0, i64toi32_i32$1 | 0, 40 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $41 = i64toi32_i32$5;
  $41$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $925$hi;
  i64toi32_i32$2 = $925;
  i64toi32_i32$5 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $47 = i64toi32_i32$4;
  $47$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $19$hi;
  i64toi32_i32$0 = $47$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$2 = $19$hi;
  i64toi32_i32$3 = $19;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $1005 = i64toi32_i32$5;
  $1005$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $42$hi;
  i64toi32_i32$4 = $12$hi;
  i64toi32_i32$4 = $42$hi;
  i64toi32_i32$0 = $42;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $1008 = i64toi32_i32$2;
  $1008$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $48$hi;
  i64toi32_i32$5 = $43$hi;
  i64toi32_i32$5 = $48$hi;
  i64toi32_i32$4 = $48;
  i64toi32_i32$0 = $43$hi;
  i64toi32_i32$3 = $43;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $711 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($711 | 0, i64toi32_i32$0 | 0, 48 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $42 = i64toi32_i32$4;
  $42$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $44$hi;
  i64toi32_i32$0 = $42$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$4 = $44$hi;
  i64toi32_i32$3 = $44;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $43 = i64toi32_i32$1;
  $43$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $37$hi;
  i64toi32_i32$2 = $43$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$5 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $712 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($712 | 0, i64toi32_i32$5 | 0, 1 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $37 = i64toi32_i32$0;
  $37$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $1008$hi;
  i64toi32_i32$2 = $1008;
  i64toi32_i32$0 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $44 = i64toi32_i32$4;
  $44$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$1 = $44$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$2 = $6$hi;
  i64toi32_i32$3 = $6;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $1024 = i64toi32_i32$0;
  $1024$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $44$hi;
  i64toi32_i32$4 = $33$hi;
  i64toi32_i32$4 = $44$hi;
  i64toi32_i32$1 = $44;
  i64toi32_i32$5 = $33$hi;
  i64toi32_i32$3 = $33;
  i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
  $713 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($713 | 0, i64toi32_i32$5 | 0, 32 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $33 = i64toi32_i32$1;
  $33$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $24$hi;
  i64toi32_i32$5 = $33$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$1 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $24 = i64toi32_i32$2;
  $24$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $37$hi;
  i64toi32_i32$0 = $24$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$4 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$2 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$4 | 0, 40 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $37 = i64toi32_i32$5;
  $37$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $1024$hi;
  i64toi32_i32$0 = $1024;
  i64toi32_i32$5 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $44 = i64toi32_i32$1;
  $44$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $33$hi;
  i64toi32_i32$2 = $44$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$0 = $33$hi;
  i64toi32_i32$3 = $33;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $714 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($714 | 0, i64toi32_i32$0 | 0, 48 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $33 = i64toi32_i32$4;
  $33$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $24$hi;
  i64toi32_i32$0 = $33$hi;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$4 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $24 = i64toi32_i32$5;
  $24$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $37$hi;
  i64toi32_i32$1 = $24$hi;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$2 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64(i64toi32_i32$5 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$2 | 0, 1 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $37 = i64toi32_i32$0;
  $37$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $1005$hi;
  i64toi32_i32$1 = $1005;
  i64toi32_i32$0 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $48 = i64toi32_i32$4;
  $48$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$5 = $48$hi;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$1 = $10$hi;
  i64toi32_i32$3 = $10;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $1053 = i64toi32_i32$0;
  $1053$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $48$hi;
  $1054 = $48;
  $1054$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $45$hi;
  i64toi32_i32$4 = $26$hi;
  i64toi32_i32$4 = $45$hi;
  i64toi32_i32$5 = $45;
  i64toi32_i32$2 = $26$hi;
  i64toi32_i32$3 = $26;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $1057$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $34$hi;
  i64toi32_i32$0 = $32$hi;
  i64toi32_i32$0 = $34$hi;
  i64toi32_i32$4 = $34;
  i64toi32_i32$5 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$5 = i64toi32_i32$0 ^ i64toi32_i32$5 | 0;
  $715 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($715 | 0, i64toi32_i32$5 | 0, 1 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $32 = i64toi32_i32$4;
  $32$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $1057$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$4 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $34 = i64toi32_i32$2;
  $34$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $13$hi;
  i64toi32_i32$1 = $34$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$0 = $13$hi;
  i64toi32_i32$3 = $13;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $1066 = i64toi32_i32$4;
  $1066$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $34$hi;
  i64toi32_i32$2 = $42$hi;
  i64toi32_i32$2 = $34$hi;
  i64toi32_i32$1 = $34;
  i64toi32_i32$5 = $42$hi;
  i64toi32_i32$3 = $42;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $716 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($716 | 0, i64toi32_i32$5 | 0, 32 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $34 = i64toi32_i32$1;
  $34$hi = i64toi32_i32$5;
  $1071 = i64toi32_i32$1;
  $1071$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$5 = $38$hi;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$2 = $31;
  i64toi32_i32$1 = $38$hi;
  i64toi32_i32$3 = $38;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $31 = i64toi32_i32$0;
  $31$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $1071$hi;
  i64toi32_i32$5 = $1071;
  i64toi32_i32$2 = $31$hi;
  i64toi32_i32$3 = i64toi32_i32$0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $38 = i64toi32_i32$1;
  $38$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $32$hi;
  i64toi32_i32$0 = $38$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$5 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$5 = i64toi32_i32$0 ^ i64toi32_i32$5 | 0;
  $717 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($717 | 0, i64toi32_i32$5 | 0, 40 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $32 = i64toi32_i32$4;
  $32$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $1066$hi;
  i64toi32_i32$0 = $1066;
  i64toi32_i32$4 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $42 = i64toi32_i32$2;
  $42$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $34$hi;
  i64toi32_i32$1 = $42$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$0 = $34$hi;
  i64toi32_i32$3 = $34;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$2 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$0 | 0, 48 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $34 = i64toi32_i32$5;
  $34$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $1054$hi;
  i64toi32_i32$1 = $1054;
  i64toi32_i32$5 = $34$hi;
  i64toi32_i32$3 = $34;
  i64toi32_i32$5 = i64toi32_i32$0 ^ i64toi32_i32$5 | 0;
  $719 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($719 | 0, i64toi32_i32$5 | 0, 32 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $45 = i64toi32_i32$1;
  $45$hi = i64toi32_i32$5;
  $1090 = i64toi32_i32$1;
  $1090$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $39$hi;
  i64toi32_i32$5 = $29$hi;
  i64toi32_i32$5 = $39$hi;
  i64toi32_i32$0 = $39;
  i64toi32_i32$1 = $29$hi;
  i64toi32_i32$3 = $29;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $1093$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $31$hi;
  i64toi32_i32$2 = $30$hi;
  i64toi32_i32$2 = $31$hi;
  i64toi32_i32$5 = $31;
  i64toi32_i32$0 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $720 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($720 | 0, i64toi32_i32$0 | 0, 1 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $30 = i64toi32_i32$5;
  $30$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $1093$hi;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$5 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $31 = i64toi32_i32$1;
  $31$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $10$hi;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$3 = $10;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $1102 = i64toi32_i32$5;
  $1102$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $31$hi;
  i64toi32_i32$1 = $23$hi;
  i64toi32_i32$1 = $31$hi;
  i64toi32_i32$4 = $31;
  i64toi32_i32$0 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $721 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($721 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $23 = i64toi32_i32$4;
  $23$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $43$hi;
  i64toi32_i32$0 = $23$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$4 = $43$hi;
  i64toi32_i32$3 = $43;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $31 = i64toi32_i32$2;
  $31$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $30$hi;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$1 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64(i64toi32_i32$2 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$1 | 0, 40 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $30 = i64toi32_i32$0;
  $30$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $1102$hi;
  i64toi32_i32$5 = $1102;
  i64toi32_i32$0 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $39 = i64toi32_i32$4;
  $39$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $23$hi;
  i64toi32_i32$2 = $39$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$5 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64(i64toi32_i32$4 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$5 | 0, 48 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $23 = i64toi32_i32$1;
  $23$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$5 = $23$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$1 = $31$hi;
  i64toi32_i32$3 = $31;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $31 = i64toi32_i32$0;
  $31$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $1090$hi;
  i64toi32_i32$5 = $1090;
  i64toi32_i32$2 = $31$hi;
  i64toi32_i32$3 = i64toi32_i32$0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $43 = i64toi32_i32$1;
  $43$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $37$hi;
  i64toi32_i32$0 = $43$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$5 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$5 = i64toi32_i32$0 ^ i64toi32_i32$5 | 0;
  $722 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($722 | 0, i64toi32_i32$5 | 0, 40 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $37 = i64toi32_i32$4;
  $37$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $1053$hi;
  i64toi32_i32$0 = $1053;
  i64toi32_i32$4 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $48 = i64toi32_i32$2;
  $48$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $25$hi;
  i64toi32_i32$1 = $48$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$0 = $25$hi;
  i64toi32_i32$3 = $25;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $1133 = i64toi32_i32$4;
  $1133$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $42$hi;
  i64toi32_i32$2 = $26$hi;
  i64toi32_i32$2 = $42$hi;
  i64toi32_i32$1 = $42;
  i64toi32_i32$5 = $26$hi;
  i64toi32_i32$3 = $26;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $1136 = i64toi32_i32$0;
  $1136$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $47$hi;
  i64toi32_i32$4 = $46$hi;
  i64toi32_i32$4 = $47$hi;
  i64toi32_i32$2 = $47;
  i64toi32_i32$1 = $46$hi;
  i64toi32_i32$3 = $46;
  i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
  $723 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($723 | 0, i64toi32_i32$1 | 0, 48 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $42 = i64toi32_i32$2;
  $42$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $40$hi;
  i64toi32_i32$1 = $42$hi;
  i64toi32_i32$4 = i64toi32_i32$2;
  i64toi32_i32$2 = $40$hi;
  i64toi32_i32$3 = $40;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $40 = i64toi32_i32$5;
  $40$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $41$hi;
  i64toi32_i32$0 = $40$hi;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$4 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64(i64toi32_i32$5 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$4 | 0, 1 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $41 = i64toi32_i32$1;
  $41$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $1136$hi;
  i64toi32_i32$0 = $1136;
  i64toi32_i32$1 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $46 = i64toi32_i32$2;
  $46$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $20$hi;
  i64toi32_i32$5 = $46$hi;
  i64toi32_i32$4 = i64toi32_i32$2;
  i64toi32_i32$0 = $20$hi;
  i64toi32_i32$3 = $20;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $1152 = i64toi32_i32$1;
  $1152$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $46$hi;
  i64toi32_i32$2 = $23$hi;
  i64toi32_i32$2 = $46$hi;
  i64toi32_i32$5 = $46;
  i64toi32_i32$4 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  $724 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($724 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $23 = i64toi32_i32$5;
  $23$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $24$hi;
  i64toi32_i32$4 = $23$hi;
  i64toi32_i32$2 = i64toi32_i32$5;
  i64toi32_i32$5 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $24 = i64toi32_i32$0;
  $24$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $41$hi;
  i64toi32_i32$1 = $24$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$2 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $725 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($725 | 0, i64toi32_i32$2 | 0, 40 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $41 = i64toi32_i32$4;
  $41$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $1152$hi;
  i64toi32_i32$1 = $1152;
  i64toi32_i32$4 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $46 = i64toi32_i32$5;
  $46$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $23$hi;
  i64toi32_i32$0 = $46$hi;
  i64toi32_i32$2 = i64toi32_i32$5;
  i64toi32_i32$1 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
  $726 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($726 | 0, i64toi32_i32$1 | 0, 48 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $23 = i64toi32_i32$2;
  $23$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $24$hi;
  i64toi32_i32$1 = $23$hi;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$2 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $24 = i64toi32_i32$4;
  $24$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $41$hi;
  i64toi32_i32$5 = $24$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$0 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64(i64toi32_i32$4 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$0 | 0, 1 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $41 = i64toi32_i32$1;
  $41$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $1133$hi;
  i64toi32_i32$5 = $1133;
  i64toi32_i32$1 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $47 = i64toi32_i32$2;
  $47$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$4 = $47$hi;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $1181 = i64toi32_i32$1;
  $1181$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $47$hi;
  $1182 = $47;
  $1182$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $44$hi;
  i64toi32_i32$2 = $13$hi;
  i64toi32_i32$2 = $44$hi;
  i64toi32_i32$4 = $44;
  i64toi32_i32$0 = $13$hi;
  i64toi32_i32$3 = $13;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $1185$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $31$hi;
  i64toi32_i32$1 = $30$hi;
  i64toi32_i32$1 = $31$hi;
  i64toi32_i32$2 = $31;
  i64toi32_i32$4 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $727 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($727 | 0, i64toi32_i32$4 | 0, 1 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $30 = i64toi32_i32$2;
  $30$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $1185$hi;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$2 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $31 = i64toi32_i32$0;
  $31$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $12$hi;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $1194 = i64toi32_i32$2;
  $1194$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $31$hi;
  i64toi32_i32$0 = $42$hi;
  i64toi32_i32$0 = $31$hi;
  i64toi32_i32$5 = $31;
  i64toi32_i32$4 = $42$hi;
  i64toi32_i32$3 = $42;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $728 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($728 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $31 = i64toi32_i32$5;
  $31$hi = i64toi32_i32$4;
  $1199 = i64toi32_i32$5;
  $1199$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $34$hi;
  i64toi32_i32$4 = $38$hi;
  i64toi32_i32$4 = $34$hi;
  i64toi32_i32$0 = $34;
  i64toi32_i32$5 = $38$hi;
  i64toi32_i32$3 = $38;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $34 = i64toi32_i32$1;
  $34$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $1199$hi;
  i64toi32_i32$4 = $1199;
  i64toi32_i32$0 = $34$hi;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $38 = i64toi32_i32$5;
  $38$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $30$hi;
  i64toi32_i32$1 = $38$hi;
  i64toi32_i32$2 = i64toi32_i32$5;
  i64toi32_i32$4 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $729 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($729 | 0, i64toi32_i32$4 | 0, 40 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $30 = i64toi32_i32$2;
  $30$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $1194$hi;
  i64toi32_i32$1 = $1194;
  i64toi32_i32$2 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $42 = i64toi32_i32$0;
  $42$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$5 = $42$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$1 = $31$hi;
  i64toi32_i32$3 = $31;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $730 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($730 | 0, i64toi32_i32$1 | 0, 48 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $31 = i64toi32_i32$4;
  $31$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $1182$hi;
  i64toi32_i32$5 = $1182;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$3 = $31;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $731 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($731 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $44 = i64toi32_i32$5;
  $44$hi = i64toi32_i32$4;
  $1218 = i64toi32_i32$5;
  $1218$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $39$hi;
  i64toi32_i32$4 = $18$hi;
  i64toi32_i32$4 = $39$hi;
  i64toi32_i32$1 = $39;
  i64toi32_i32$5 = $18$hi;
  i64toi32_i32$3 = $18;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $1221$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $34$hi;
  i64toi32_i32$0 = $32$hi;
  i64toi32_i32$0 = $34$hi;
  i64toi32_i32$4 = $34;
  i64toi32_i32$1 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
  $732 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($732 | 0, i64toi32_i32$1 | 0, 1 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $32 = i64toi32_i32$4;
  $32$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $1221$hi;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$4 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $34 = i64toi32_i32$5;
  $34$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $29$hi;
  i64toi32_i32$2 = $34$hi;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$0 = $29$hi;
  i64toi32_i32$3 = $29;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $1230 = i64toi32_i32$4;
  $1230$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $34$hi;
  i64toi32_i32$5 = $33$hi;
  i64toi32_i32$5 = $34$hi;
  i64toi32_i32$2 = $34;
  i64toi32_i32$1 = $33$hi;
  i64toi32_i32$3 = $33;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $733 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($733 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $33 = i64toi32_i32$2;
  $33$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $40$hi;
  i64toi32_i32$1 = $33$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $40$hi;
  i64toi32_i32$3 = $40;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $34 = i64toi32_i32$0;
  $34$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $32$hi;
  i64toi32_i32$4 = $34$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$5 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64(i64toi32_i32$0 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$5 | 0, 40 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $32 = i64toi32_i32$1;
  $32$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $1230$hi;
  i64toi32_i32$4 = $1230;
  i64toi32_i32$1 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $39 = i64toi32_i32$2;
  $39$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $33$hi;
  i64toi32_i32$0 = $39$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$4 = $33$hi;
  i64toi32_i32$3 = $33;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$2 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$4 | 0, 48 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $33 = i64toi32_i32$5;
  $33$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $34$hi;
  i64toi32_i32$4 = $33$hi;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$5 = $34$hi;
  i64toi32_i32$3 = $34;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $34 = i64toi32_i32$1;
  $34$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $1218$hi;
  i64toi32_i32$4 = $1218;
  i64toi32_i32$0 = $34$hi;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $40 = i64toi32_i32$5;
  $40$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $41$hi;
  i64toi32_i32$1 = $40$hi;
  i64toi32_i32$2 = i64toi32_i32$5;
  i64toi32_i32$4 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $734 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($734 | 0, i64toi32_i32$4 | 0, 40 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $41 = i64toi32_i32$2;
  $41$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $1181$hi;
  i64toi32_i32$1 = $1181;
  i64toi32_i32$2 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $47 = i64toi32_i32$0;
  $47$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $18$hi;
  i64toi32_i32$5 = $47$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$1 = $18$hi;
  i64toi32_i32$3 = $18;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $1261 = i64toi32_i32$2;
  $1261$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $42$hi;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$0 = $42$hi;
  i64toi32_i32$5 = $42;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $1264 = i64toi32_i32$1;
  $1264$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $48$hi;
  i64toi32_i32$2 = $45$hi;
  i64toi32_i32$2 = $48$hi;
  i64toi32_i32$0 = $48;
  i64toi32_i32$5 = $45$hi;
  i64toi32_i32$3 = $45;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $735 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($735 | 0, i64toi32_i32$5 | 0, 48 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $42 = i64toi32_i32$0;
  $42$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $43$hi;
  i64toi32_i32$5 = $42$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = $43$hi;
  i64toi32_i32$3 = $43;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $43 = i64toi32_i32$4;
  $43$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $37$hi;
  i64toi32_i32$1 = $43$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$2 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$4 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$2 | 0, 1 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $37 = i64toi32_i32$5;
  $37$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $1264$hi;
  i64toi32_i32$1 = $1264;
  i64toi32_i32$5 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $45 = i64toi32_i32$0;
  $45$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $22$hi;
  i64toi32_i32$4 = $45$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$1 = $22$hi;
  i64toi32_i32$3 = $22;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $1280 = i64toi32_i32$5;
  $1280$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $45$hi;
  i64toi32_i32$0 = $33$hi;
  i64toi32_i32$0 = $45$hi;
  i64toi32_i32$4 = $45;
  i64toi32_i32$2 = $33$hi;
  i64toi32_i32$3 = $33;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $736 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($736 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $33 = i64toi32_i32$4;
  $33$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $24$hi;
  i64toi32_i32$2 = $33$hi;
  i64toi32_i32$0 = i64toi32_i32$4;
  i64toi32_i32$4 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $24 = i64toi32_i32$1;
  $24$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $37$hi;
  i64toi32_i32$5 = $24$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $737 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($737 | 0, i64toi32_i32$0 | 0, 40 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $37 = i64toi32_i32$2;
  $37$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $1280$hi;
  i64toi32_i32$5 = $1280;
  i64toi32_i32$2 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $45 = i64toi32_i32$4;
  $45$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $33$hi;
  i64toi32_i32$1 = $45$hi;
  i64toi32_i32$0 = i64toi32_i32$4;
  i64toi32_i32$5 = $33$hi;
  i64toi32_i32$3 = $33;
  i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64(i64toi32_i32$4 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$5 | 0, 48 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $33 = i64toi32_i32$0;
  $33$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $24$hi;
  i64toi32_i32$5 = $33$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$0 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $24 = i64toi32_i32$2;
  $24$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $37$hi;
  i64toi32_i32$4 = $24$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$1 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$2 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$1 | 0, 1 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $37 = i64toi32_i32$5;
  $37$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $1261$hi;
  i64toi32_i32$4 = $1261;
  i64toi32_i32$5 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $48 = i64toi32_i32$0;
  $48$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $15$hi;
  i64toi32_i32$2 = $48$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$4 = $15$hi;
  i64toi32_i32$3 = $15;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $1309 = i64toi32_i32$5;
  $1309$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $48$hi;
  $1310 = $48;
  $1310$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $46$hi;
  i64toi32_i32$0 = $14$hi;
  i64toi32_i32$0 = $46$hi;
  i64toi32_i32$2 = $46;
  i64toi32_i32$1 = $14$hi;
  i64toi32_i32$3 = $14;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $1313$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $34$hi;
  i64toi32_i32$5 = $32$hi;
  i64toi32_i32$5 = $34$hi;
  i64toi32_i32$0 = $34;
  i64toi32_i32$2 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  $738 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($738 | 0, i64toi32_i32$2 | 0, 1 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $32 = i64toi32_i32$0;
  $32$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $1313$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$0 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $34 = i64toi32_i32$1;
  $34$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $15$hi;
  i64toi32_i32$4 = $34$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$5 = $15$hi;
  i64toi32_i32$3 = $15;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $1322 = i64toi32_i32$0;
  $1322$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $34$hi;
  i64toi32_i32$1 = $42$hi;
  i64toi32_i32$1 = $34$hi;
  i64toi32_i32$4 = $34;
  i64toi32_i32$2 = $42$hi;
  i64toi32_i32$3 = $42;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $739 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($739 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $34 = i64toi32_i32$4;
  $34$hi = i64toi32_i32$2;
  $1327 = i64toi32_i32$4;
  $1327$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $31$hi;
  i64toi32_i32$2 = $38$hi;
  i64toi32_i32$2 = $31$hi;
  i64toi32_i32$1 = $31;
  i64toi32_i32$4 = $38$hi;
  i64toi32_i32$3 = $38;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $31 = i64toi32_i32$5;
  $31$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $1327$hi;
  i64toi32_i32$2 = $1327;
  i64toi32_i32$1 = $31$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $38 = i64toi32_i32$4;
  $38$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $32$hi;
  i64toi32_i32$5 = $38$hi;
  i64toi32_i32$0 = i64toi32_i32$4;
  i64toi32_i32$2 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64(i64toi32_i32$4 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$2 | 0, 40 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $32 = i64toi32_i32$0;
  $32$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $1322$hi;
  i64toi32_i32$5 = $1322;
  i64toi32_i32$0 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $42 = i64toi32_i32$1;
  $42$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $34$hi;
  i64toi32_i32$4 = $42$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$5 = $34$hi;
  i64toi32_i32$3 = $34;
  i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
  $740 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($740 | 0, i64toi32_i32$5 | 0, 48 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $34 = i64toi32_i32$2;
  $34$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $1310$hi;
  i64toi32_i32$4 = $1310;
  i64toi32_i32$2 = $34$hi;
  i64toi32_i32$3 = $34;
  i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  $741 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($741 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $46 = i64toi32_i32$4;
  $46$hi = i64toi32_i32$2;
  $1346 = i64toi32_i32$4;
  $1346$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $39$hi;
  i64toi32_i32$2 = $21$hi;
  i64toi32_i32$2 = $39$hi;
  i64toi32_i32$5 = $39;
  i64toi32_i32$4 = $21$hi;
  i64toi32_i32$3 = $21;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $1349$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $31$hi;
  i64toi32_i32$1 = $30$hi;
  i64toi32_i32$1 = $31$hi;
  i64toi32_i32$2 = $31;
  i64toi32_i32$5 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
  $742 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($742 | 0, i64toi32_i32$5 | 0, 1 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $30 = i64toi32_i32$2;
  $30$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $1349$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$2 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $31 = i64toi32_i32$4;
  $31$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$0 = $31$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$3 = $6;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $1358 = i64toi32_i32$2;
  $1358$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$4 = $23$hi;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$0 = $31;
  i64toi32_i32$5 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
  $743 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($743 | 0, i64toi32_i32$5 | 0, 32 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $23 = i64toi32_i32$0;
  $23$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $43$hi;
  i64toi32_i32$5 = $23$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$0 = $43$hi;
  i64toi32_i32$3 = $43;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $31 = i64toi32_i32$1;
  $31$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $30$hi;
  i64toi32_i32$2 = $31$hi;
  i64toi32_i32$5 = i64toi32_i32$1;
  i64toi32_i32$4 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  $744 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($744 | 0, i64toi32_i32$4 | 0, 40 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $30 = i64toi32_i32$5;
  $30$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $1358$hi;
  i64toi32_i32$2 = $1358;
  i64toi32_i32$5 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $39 = i64toi32_i32$0;
  $39$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $23$hi;
  i64toi32_i32$1 = $39$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$2 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $745 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($745 | 0, i64toi32_i32$2 | 0, 48 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $23 = i64toi32_i32$4;
  $23$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $31$hi;
  i64toi32_i32$2 = $23$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$3 = $31;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $31 = i64toi32_i32$5;
  $31$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $1346$hi;
  i64toi32_i32$2 = $1346;
  i64toi32_i32$1 = $31$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $43 = i64toi32_i32$4;
  $43$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $37$hi;
  i64toi32_i32$5 = $43$hi;
  i64toi32_i32$0 = i64toi32_i32$4;
  i64toi32_i32$2 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64(i64toi32_i32$4 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$2 | 0, 40 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $37 = i64toi32_i32$0;
  $37$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $1309$hi;
  i64toi32_i32$5 = $1309;
  i64toi32_i32$0 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $48 = i64toi32_i32$1;
  $48$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $29$hi;
  i64toi32_i32$4 = $48$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$5 = $29$hi;
  i64toi32_i32$3 = $29;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $1389 = i64toi32_i32$0;
  $1389$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $42$hi;
  i64toi32_i32$1 = $21$hi;
  i64toi32_i32$1 = $42$hi;
  i64toi32_i32$4 = $42;
  i64toi32_i32$2 = $21$hi;
  i64toi32_i32$3 = $21;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $1392 = i64toi32_i32$5;
  $1392$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $47$hi;
  i64toi32_i32$0 = $44$hi;
  i64toi32_i32$0 = $47$hi;
  i64toi32_i32$1 = $47;
  i64toi32_i32$4 = $44$hi;
  i64toi32_i32$3 = $44;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $746 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($746 | 0, i64toi32_i32$4 | 0, 48 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $42 = i64toi32_i32$1;
  $42$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $40$hi;
  i64toi32_i32$4 = $42$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$1 = $40$hi;
  i64toi32_i32$3 = $40;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $40 = i64toi32_i32$2;
  $40$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $41$hi;
  i64toi32_i32$5 = $40$hi;
  i64toi32_i32$4 = i64toi32_i32$2;
  i64toi32_i32$0 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64(i64toi32_i32$2 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$0 | 0, 1 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $41 = i64toi32_i32$4;
  $41$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $1392$hi;
  i64toi32_i32$5 = $1392;
  i64toi32_i32$4 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $44 = i64toi32_i32$1;
  $44$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $13$hi;
  i64toi32_i32$2 = $44$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$5 = $13$hi;
  i64toi32_i32$3 = $13;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $1408 = i64toi32_i32$4;
  $1408$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $44$hi;
  i64toi32_i32$1 = $23$hi;
  i64toi32_i32$1 = $44$hi;
  i64toi32_i32$2 = $44;
  i64toi32_i32$0 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $747 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($747 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $23 = i64toi32_i32$2;
  $23$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $24$hi;
  i64toi32_i32$0 = $23$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$2 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $24 = i64toi32_i32$5;
  $24$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $41$hi;
  i64toi32_i32$4 = $24$hi;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$1 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64(i64toi32_i32$5 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$1 | 0, 40 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $41 = i64toi32_i32$0;
  $41$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $1408$hi;
  i64toi32_i32$4 = $1408;
  i64toi32_i32$0 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $44 = i64toi32_i32$2;
  $44$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $23$hi;
  i64toi32_i32$5 = $44$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$4 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64(i64toi32_i32$2 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$4 | 0, 48 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $23 = i64toi32_i32$1;
  $23$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $24$hi;
  i64toi32_i32$4 = $23$hi;
  i64toi32_i32$5 = i64toi32_i32$1;
  i64toi32_i32$1 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $24 = i64toi32_i32$0;
  $24$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $41$hi;
  i64toi32_i32$2 = $24$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$5 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $748 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($748 | 0, i64toi32_i32$5 | 0, 1 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $41 = i64toi32_i32$4;
  $41$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $1389$hi;
  i64toi32_i32$2 = $1389;
  i64toi32_i32$4 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $47 = i64toi32_i32$1;
  $47$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $22$hi;
  i64toi32_i32$0 = $47$hi;
  i64toi32_i32$5 = i64toi32_i32$1;
  i64toi32_i32$2 = $22$hi;
  i64toi32_i32$3 = $22;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $1437 = i64toi32_i32$4;
  $1437$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $47$hi;
  $1438 = $47;
  $1438$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $45$hi;
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$1 = $45$hi;
  i64toi32_i32$0 = $45;
  i64toi32_i32$5 = $6$hi;
  i64toi32_i32$3 = $6;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $1441$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$4 = $30$hi;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$1 = $31;
  i64toi32_i32$0 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
  $750 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($750 | 0, i64toi32_i32$0 | 0, 1 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $30 = i64toi32_i32$1;
  $30$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $1441$hi;
  i64toi32_i32$4 = i64toi32_i32$2;
  i64toi32_i32$1 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $31 = i64toi32_i32$5;
  $31$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$2 = $31$hi;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $1450 = i64toi32_i32$1;
  $1450$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$5 = $42$hi;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$2 = $31;
  i64toi32_i32$0 = $42$hi;
  i64toi32_i32$3 = $42;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $751 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($751 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $31 = i64toi32_i32$2;
  $31$hi = i64toi32_i32$0;
  $1455 = i64toi32_i32$2;
  $1455$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $34$hi;
  i64toi32_i32$0 = $38$hi;
  i64toi32_i32$0 = $34$hi;
  i64toi32_i32$5 = $34;
  i64toi32_i32$2 = $38$hi;
  i64toi32_i32$3 = $38;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $34 = i64toi32_i32$4;
  $34$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $1455$hi;
  i64toi32_i32$0 = $1455;
  i64toi32_i32$5 = $34$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $38 = i64toi32_i32$2;
  $38$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $30$hi;
  i64toi32_i32$4 = $38$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$0 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64(i64toi32_i32$2 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$0 | 0, 40 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $30 = i64toi32_i32$1;
  $30$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $1450$hi;
  i64toi32_i32$4 = $1450;
  i64toi32_i32$1 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $42 = i64toi32_i32$5;
  $42$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $31$hi;
  i64toi32_i32$2 = $42$hi;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$3 = $31;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64(i64toi32_i32$5 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$4 | 0, 48 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $31 = i64toi32_i32$0;
  $31$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $1438$hi;
  i64toi32_i32$2 = $1438;
  i64toi32_i32$0 = $31$hi;
  i64toi32_i32$3 = $31;
  i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
  $753 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($753 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $45 = i64toi32_i32$2;
  $45$hi = i64toi32_i32$0;
  $1474 = i64toi32_i32$2;
  $1474$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $39$hi;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$0 = $39$hi;
  i64toi32_i32$4 = $39;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$3 = $10;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $1477$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $34$hi;
  i64toi32_i32$5 = $32$hi;
  i64toi32_i32$5 = $34$hi;
  i64toi32_i32$0 = $34;
  i64toi32_i32$4 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
  $754 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($754 | 0, i64toi32_i32$4 | 0, 1 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $32 = i64toi32_i32$0;
  $32$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $1477$hi;
  i64toi32_i32$5 = i64toi32_i32$1;
  i64toi32_i32$0 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $34 = i64toi32_i32$2;
  $34$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $14$hi;
  i64toi32_i32$1 = $34$hi;
  i64toi32_i32$4 = i64toi32_i32$2;
  i64toi32_i32$5 = $14$hi;
  i64toi32_i32$3 = $14;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $1486 = i64toi32_i32$0;
  $1486$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $34$hi;
  i64toi32_i32$2 = $33$hi;
  i64toi32_i32$2 = $34$hi;
  i64toi32_i32$1 = $34;
  i64toi32_i32$4 = $33$hi;
  i64toi32_i32$3 = $33;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  $755 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($755 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $33 = i64toi32_i32$1;
  $33$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $40$hi;
  i64toi32_i32$4 = $33$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$1 = $40$hi;
  i64toi32_i32$3 = $40;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $34 = i64toi32_i32$5;
  $34$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $32$hi;
  i64toi32_i32$0 = $34$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$2 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $756 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($756 | 0, i64toi32_i32$2 | 0, 40 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $32 = i64toi32_i32$4;
  $32$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $1486$hi;
  i64toi32_i32$0 = $1486;
  i64toi32_i32$4 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $39 = i64toi32_i32$1;
  $39$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $33$hi;
  i64toi32_i32$5 = $39$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = $33$hi;
  i64toi32_i32$3 = $33;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $757 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($757 | 0, i64toi32_i32$0 | 0, 48 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $33 = i64toi32_i32$2;
  $33$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $34$hi;
  i64toi32_i32$0 = $33$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $34$hi;
  i64toi32_i32$3 = $34;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $34 = i64toi32_i32$4;
  $34$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $1474$hi;
  i64toi32_i32$0 = $1474;
  i64toi32_i32$5 = $34$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $40 = i64toi32_i32$2;
  $40$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $41$hi;
  i64toi32_i32$4 = $40$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$0 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64(i64toi32_i32$2 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$0 | 0, 40 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $41 = i64toi32_i32$1;
  $41$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $1437$hi;
  i64toi32_i32$4 = $1437;
  i64toi32_i32$1 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $47 = i64toi32_i32$5;
  $47$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $15$hi;
  i64toi32_i32$2 = $47$hi;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$4 = $15$hi;
  i64toi32_i32$3 = $15;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $1517 = i64toi32_i32$1;
  $1517$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $42$hi;
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$5 = $42$hi;
  i64toi32_i32$2 = $42;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $1520 = i64toi32_i32$4;
  $1520$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $48$hi;
  i64toi32_i32$1 = $46$hi;
  i64toi32_i32$1 = $48$hi;
  i64toi32_i32$5 = $48;
  i64toi32_i32$2 = $46$hi;
  i64toi32_i32$3 = $46;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $758 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($758 | 0, i64toi32_i32$2 | 0, 48 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $42 = i64toi32_i32$5;
  $42$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $43$hi;
  i64toi32_i32$2 = $42$hi;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$5 = $43$hi;
  i64toi32_i32$3 = $43;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $43 = i64toi32_i32$0;
  $43$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $37$hi;
  i64toi32_i32$4 = $43$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$1 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
  $759 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($759 | 0, i64toi32_i32$1 | 0, 1 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $37 = i64toi32_i32$2;
  $37$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $1520$hi;
  i64toi32_i32$4 = $1520;
  i64toi32_i32$2 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $46 = i64toi32_i32$5;
  $46$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $19$hi;
  i64toi32_i32$0 = $46$hi;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$4 = $19$hi;
  i64toi32_i32$3 = $19;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $1536 = i64toi32_i32$2;
  $1536$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $46$hi;
  i64toi32_i32$5 = $33$hi;
  i64toi32_i32$5 = $46$hi;
  i64toi32_i32$0 = $46;
  i64toi32_i32$1 = $33$hi;
  i64toi32_i32$3 = $33;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $760 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($760 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $33 = i64toi32_i32$0;
  $33$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $24$hi;
  i64toi32_i32$1 = $33$hi;
  i64toi32_i32$5 = i64toi32_i32$0;
  i64toi32_i32$0 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $24 = i64toi32_i32$4;
  $24$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $37$hi;
  i64toi32_i32$2 = $24$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$5 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64(i64toi32_i32$4 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$5 | 0, 40 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $37 = i64toi32_i32$1;
  $37$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $1536$hi;
  i64toi32_i32$2 = $1536;
  i64toi32_i32$1 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $46 = i64toi32_i32$0;
  $46$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $33$hi;
  i64toi32_i32$4 = $46$hi;
  i64toi32_i32$5 = i64toi32_i32$0;
  i64toi32_i32$2 = $33$hi;
  i64toi32_i32$3 = $33;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $761 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($761 | 0, i64toi32_i32$2 | 0, 48 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $33 = i64toi32_i32$5;
  $33$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $24$hi;
  i64toi32_i32$2 = $33$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$5 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $24 = i64toi32_i32$1;
  $24$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $37$hi;
  i64toi32_i32$0 = $24$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$4 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $762 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($762 | 0, i64toi32_i32$4 | 0, 1 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $37 = i64toi32_i32$2;
  $37$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $1517$hi;
  i64toi32_i32$0 = $1517;
  i64toi32_i32$2 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $48 = i64toi32_i32$5;
  $48$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $26$hi;
  i64toi32_i32$1 = $48$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$0 = $26$hi;
  i64toi32_i32$3 = $26;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $1565 = i64toi32_i32$2;
  $1565$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $48$hi;
  $1566 = $48;
  $1566$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $44$hi;
  i64toi32_i32$5 = $20$hi;
  i64toi32_i32$5 = $44$hi;
  i64toi32_i32$1 = $44;
  i64toi32_i32$4 = $20$hi;
  i64toi32_i32$3 = $20;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $1569$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $34$hi;
  i64toi32_i32$2 = $32$hi;
  i64toi32_i32$2 = $34$hi;
  i64toi32_i32$5 = $34;
  i64toi32_i32$1 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
  $763 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($763 | 0, i64toi32_i32$1 | 0, 1 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $32 = i64toi32_i32$5;
  $32$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $1569$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$5 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $34 = i64toi32_i32$4;
  $34$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $26$hi;
  i64toi32_i32$0 = $34$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$2 = $26$hi;
  i64toi32_i32$3 = $26;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $1578 = i64toi32_i32$5;
  $1578$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $34$hi;
  i64toi32_i32$4 = $42$hi;
  i64toi32_i32$4 = $34$hi;
  i64toi32_i32$0 = $34;
  i64toi32_i32$1 = $42$hi;
  i64toi32_i32$3 = $42;
  i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
  $764 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($764 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $34 = i64toi32_i32$0;
  $34$hi = i64toi32_i32$1;
  $1583 = i64toi32_i32$0;
  $1583$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $31$hi;
  i64toi32_i32$1 = $38$hi;
  i64toi32_i32$1 = $31$hi;
  i64toi32_i32$4 = $31;
  i64toi32_i32$0 = $38$hi;
  i64toi32_i32$3 = $38;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $31 = i64toi32_i32$2;
  $31$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $1583$hi;
  i64toi32_i32$1 = $1583;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $38 = i64toi32_i32$0;
  $38$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $32$hi;
  i64toi32_i32$2 = $38$hi;
  i64toi32_i32$5 = i64toi32_i32$0;
  i64toi32_i32$1 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
  $765 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($765 | 0, i64toi32_i32$1 | 0, 40 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $32 = i64toi32_i32$5;
  $32$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $1578$hi;
  i64toi32_i32$2 = $1578;
  i64toi32_i32$5 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $42 = i64toi32_i32$4;
  $42$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $34$hi;
  i64toi32_i32$0 = $42$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$2 = $34$hi;
  i64toi32_i32$3 = $34;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64(i64toi32_i32$4 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$2 | 0, 48 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $34 = i64toi32_i32$1;
  $34$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $1566$hi;
  i64toi32_i32$0 = $1566;
  i64toi32_i32$1 = $34$hi;
  i64toi32_i32$3 = $34;
  i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
  $766 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($766 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $44 = i64toi32_i32$0;
  $44$hi = i64toi32_i32$1;
  $1602 = i64toi32_i32$0;
  $1602$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $39$hi;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$1 = $39$hi;
  i64toi32_i32$2 = $39;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $1605$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$4 = $30$hi;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$1 = $31;
  i64toi32_i32$2 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $767 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($767 | 0, i64toi32_i32$2 | 0, 1 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $30 = i64toi32_i32$1;
  $30$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $1605$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$1 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $31 = i64toi32_i32$0;
  $31$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $25$hi;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$4 = $25$hi;
  i64toi32_i32$3 = $25;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $1614 = i64toi32_i32$1;
  $1614$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $31$hi;
  i64toi32_i32$0 = $23$hi;
  i64toi32_i32$0 = $31$hi;
  i64toi32_i32$5 = $31;
  i64toi32_i32$2 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $769 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($769 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $23 = i64toi32_i32$5;
  $23$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $43$hi;
  i64toi32_i32$2 = $23$hi;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$5 = $43$hi;
  i64toi32_i32$3 = $43;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $31 = i64toi32_i32$4;
  $31$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $30$hi;
  i64toi32_i32$1 = $31$hi;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$0 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $770 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($770 | 0, i64toi32_i32$0 | 0, 40 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $30 = i64toi32_i32$2;
  $30$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $1614$hi;
  i64toi32_i32$1 = $1614;
  i64toi32_i32$2 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $39 = i64toi32_i32$5;
  $39$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $23$hi;
  i64toi32_i32$4 = $39$hi;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$1 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64(i64toi32_i32$5 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$1 | 0, 48 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $23 = i64toi32_i32$0;
  $23$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $31$hi;
  i64toi32_i32$1 = $23$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$0 = $31$hi;
  i64toi32_i32$3 = $31;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $31 = i64toi32_i32$2;
  $31$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $1602$hi;
  i64toi32_i32$1 = $1602;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $43 = i64toi32_i32$0;
  $43$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $37$hi;
  i64toi32_i32$2 = $43$hi;
  i64toi32_i32$5 = i64toi32_i32$0;
  i64toi32_i32$1 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
  $771 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($771 | 0, i64toi32_i32$1 | 0, 40 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $37 = i64toi32_i32$5;
  $37$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $1565$hi;
  i64toi32_i32$2 = $1565;
  i64toi32_i32$5 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $48 = i64toi32_i32$4;
  $48$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$0 = $48$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$3 = $10;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $1645 = i64toi32_i32$5;
  $1645$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $42$hi;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$4 = $42$hi;
  i64toi32_i32$0 = $42;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $1648 = i64toi32_i32$2;
  $1648$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $47$hi;
  i64toi32_i32$5 = $45$hi;
  i64toi32_i32$5 = $47$hi;
  i64toi32_i32$4 = $47;
  i64toi32_i32$0 = $45$hi;
  i64toi32_i32$3 = $45;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $772 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($772 | 0, i64toi32_i32$0 | 0, 48 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $42 = i64toi32_i32$4;
  $42$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $40$hi;
  i64toi32_i32$0 = $42$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$4 = $40$hi;
  i64toi32_i32$3 = $40;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $40 = i64toi32_i32$1;
  $40$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $41$hi;
  i64toi32_i32$2 = $40$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$5 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $773 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($773 | 0, i64toi32_i32$5 | 0, 1 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $41 = i64toi32_i32$0;
  $41$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $1648$hi;
  i64toi32_i32$2 = $1648;
  i64toi32_i32$0 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $45 = i64toi32_i32$4;
  $45$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$1 = $45$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $1664 = i64toi32_i32$0;
  $1664$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $45$hi;
  i64toi32_i32$4 = $23$hi;
  i64toi32_i32$4 = $45$hi;
  i64toi32_i32$1 = $45;
  i64toi32_i32$5 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
  $774 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($774 | 0, i64toi32_i32$5 | 0, 32 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $23 = i64toi32_i32$1;
  $23$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $24$hi;
  i64toi32_i32$5 = $23$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$1 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $24 = i64toi32_i32$2;
  $24$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $41$hi;
  i64toi32_i32$0 = $24$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$4 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$2 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$4 | 0, 40 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $41 = i64toi32_i32$5;
  $41$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $1664$hi;
  i64toi32_i32$0 = $1664;
  i64toi32_i32$5 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $45 = i64toi32_i32$1;
  $45$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $23$hi;
  i64toi32_i32$2 = $45$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$0 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $775 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($775 | 0, i64toi32_i32$0 | 0, 48 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $23 = i64toi32_i32$4;
  $23$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $24$hi;
  i64toi32_i32$0 = $23$hi;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$4 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $24 = i64toi32_i32$5;
  $24$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $41$hi;
  i64toi32_i32$1 = $24$hi;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$2 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64(i64toi32_i32$5 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$2 | 0, 1 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $41 = i64toi32_i32$0;
  $41$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $1645$hi;
  i64toi32_i32$1 = $1645;
  i64toi32_i32$0 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $47 = i64toi32_i32$4;
  $47$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $20$hi;
  i64toi32_i32$5 = $47$hi;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$1 = $20$hi;
  i64toi32_i32$3 = $20;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $1693 = i64toi32_i32$0;
  $1693$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $47$hi;
  $1694 = $47;
  $1694$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $46$hi;
  i64toi32_i32$4 = $29$hi;
  i64toi32_i32$4 = $46$hi;
  i64toi32_i32$5 = $46;
  i64toi32_i32$2 = $29$hi;
  i64toi32_i32$3 = $29;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $1697$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $31$hi;
  i64toi32_i32$0 = $30$hi;
  i64toi32_i32$0 = $31$hi;
  i64toi32_i32$4 = $31;
  i64toi32_i32$5 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$5 = i64toi32_i32$0 ^ i64toi32_i32$5 | 0;
  $776 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($776 | 0, i64toi32_i32$5 | 0, 1 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $30 = i64toi32_i32$4;
  $30$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $1697$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$4 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $31 = i64toi32_i32$2;
  $31$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $13$hi;
  i64toi32_i32$1 = $31$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$0 = $13$hi;
  i64toi32_i32$3 = $13;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $1706 = i64toi32_i32$4;
  $1706$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $31$hi;
  i64toi32_i32$2 = $42$hi;
  i64toi32_i32$2 = $31$hi;
  i64toi32_i32$1 = $31;
  i64toi32_i32$5 = $42$hi;
  i64toi32_i32$3 = $42;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $777 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($777 | 0, i64toi32_i32$5 | 0, 32 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $31 = i64toi32_i32$1;
  $31$hi = i64toi32_i32$5;
  $1711 = i64toi32_i32$1;
  $1711$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $34$hi;
  i64toi32_i32$5 = $38$hi;
  i64toi32_i32$5 = $34$hi;
  i64toi32_i32$2 = $34;
  i64toi32_i32$1 = $38$hi;
  i64toi32_i32$3 = $38;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $34 = i64toi32_i32$0;
  $34$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $1711$hi;
  i64toi32_i32$5 = $1711;
  i64toi32_i32$2 = $34$hi;
  i64toi32_i32$3 = i64toi32_i32$0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $38 = i64toi32_i32$1;
  $38$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $30$hi;
  i64toi32_i32$0 = $38$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$5 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$5 = i64toi32_i32$0 ^ i64toi32_i32$5 | 0;
  $778 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($778 | 0, i64toi32_i32$5 | 0, 40 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $30 = i64toi32_i32$4;
  $30$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $1706$hi;
  i64toi32_i32$0 = $1706;
  i64toi32_i32$4 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $42 = i64toi32_i32$2;
  $42$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $31$hi;
  i64toi32_i32$1 = $42$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$0 = $31$hi;
  i64toi32_i32$3 = $31;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$2 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$0 | 0, 48 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $31 = i64toi32_i32$5;
  $31$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $1694$hi;
  i64toi32_i32$1 = $1694;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$3 = $31;
  i64toi32_i32$5 = i64toi32_i32$0 ^ i64toi32_i32$5 | 0;
  $779 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($779 | 0, i64toi32_i32$5 | 0, 32 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $46 = i64toi32_i32$1;
  $46$hi = i64toi32_i32$5;
  $1730 = i64toi32_i32$1;
  $1730$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $39$hi;
  i64toi32_i32$5 = $25$hi;
  i64toi32_i32$5 = $39$hi;
  i64toi32_i32$0 = $39;
  i64toi32_i32$1 = $25$hi;
  i64toi32_i32$3 = $25;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $1733$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $34$hi;
  i64toi32_i32$2 = $32$hi;
  i64toi32_i32$2 = $34$hi;
  i64toi32_i32$5 = $34;
  i64toi32_i32$0 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $780 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($780 | 0, i64toi32_i32$0 | 0, 1 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $32 = i64toi32_i32$5;
  $32$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $1733$hi;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$5 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $34 = i64toi32_i32$1;
  $34$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $22$hi;
  i64toi32_i32$4 = $34$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$2 = $22$hi;
  i64toi32_i32$3 = $22;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $1742 = i64toi32_i32$5;
  $1742$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $34$hi;
  i64toi32_i32$1 = $33$hi;
  i64toi32_i32$1 = $34$hi;
  i64toi32_i32$4 = $34;
  i64toi32_i32$0 = $33$hi;
  i64toi32_i32$3 = $33;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $781 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($781 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $33 = i64toi32_i32$4;
  $33$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $40$hi;
  i64toi32_i32$0 = $33$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$4 = $40$hi;
  i64toi32_i32$3 = $40;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $34 = i64toi32_i32$2;
  $34$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $32$hi;
  i64toi32_i32$5 = $34$hi;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$1 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64(i64toi32_i32$2 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$1 | 0, 40 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $32 = i64toi32_i32$0;
  $32$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $1742$hi;
  i64toi32_i32$5 = $1742;
  i64toi32_i32$0 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $39 = i64toi32_i32$4;
  $39$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $33$hi;
  i64toi32_i32$2 = $39$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$5 = $33$hi;
  i64toi32_i32$3 = $33;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64(i64toi32_i32$4 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$5 | 0, 48 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $33 = i64toi32_i32$1;
  $33$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $34$hi;
  i64toi32_i32$5 = $33$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$1 = $34$hi;
  i64toi32_i32$3 = $34;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $34 = i64toi32_i32$0;
  $34$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $1730$hi;
  i64toi32_i32$5 = $1730;
  i64toi32_i32$2 = $34$hi;
  i64toi32_i32$3 = i64toi32_i32$0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $40 = i64toi32_i32$1;
  $40$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $41$hi;
  i64toi32_i32$0 = $40$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$5 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$5 = i64toi32_i32$0 ^ i64toi32_i32$5 | 0;
  $782 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($782 | 0, i64toi32_i32$5 | 0, 40 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $41 = i64toi32_i32$4;
  $41$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $1693$hi;
  i64toi32_i32$0 = $1693;
  i64toi32_i32$4 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $47 = i64toi32_i32$2;
  $47$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $22$hi;
  i64toi32_i32$1 = $47$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$0 = $22$hi;
  i64toi32_i32$3 = $22;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $1773 = i64toi32_i32$4;
  $1773$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $42$hi;
  i64toi32_i32$2 = $6$hi;
  i64toi32_i32$2 = $42$hi;
  i64toi32_i32$1 = $42;
  i64toi32_i32$5 = $6$hi;
  i64toi32_i32$3 = $6;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $1776 = i64toi32_i32$0;
  $1776$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $48$hi;
  i64toi32_i32$4 = $44$hi;
  i64toi32_i32$4 = $48$hi;
  i64toi32_i32$2 = $48;
  i64toi32_i32$1 = $44$hi;
  i64toi32_i32$3 = $44;
  i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
  $783 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($783 | 0, i64toi32_i32$1 | 0, 48 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $42 = i64toi32_i32$2;
  $42$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $43$hi;
  i64toi32_i32$1 = $42$hi;
  i64toi32_i32$4 = i64toi32_i32$2;
  i64toi32_i32$2 = $43$hi;
  i64toi32_i32$3 = $43;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $43 = i64toi32_i32$5;
  $43$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $37$hi;
  i64toi32_i32$0 = $43$hi;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$4 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64(i64toi32_i32$5 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$4 | 0, 1 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $37 = i64toi32_i32$1;
  $37$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $1776$hi;
  i64toi32_i32$0 = $1776;
  i64toi32_i32$1 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $44 = i64toi32_i32$2;
  $44$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $14$hi;
  i64toi32_i32$5 = $44$hi;
  i64toi32_i32$4 = i64toi32_i32$2;
  i64toi32_i32$0 = $14$hi;
  i64toi32_i32$3 = $14;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $1792 = i64toi32_i32$1;
  $1792$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $44$hi;
  i64toi32_i32$2 = $33$hi;
  i64toi32_i32$2 = $44$hi;
  i64toi32_i32$5 = $44;
  i64toi32_i32$4 = $33$hi;
  i64toi32_i32$3 = $33;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  $784 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($784 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $33 = i64toi32_i32$5;
  $33$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $24$hi;
  i64toi32_i32$4 = $33$hi;
  i64toi32_i32$2 = i64toi32_i32$5;
  i64toi32_i32$5 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $24 = i64toi32_i32$0;
  $24$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $37$hi;
  i64toi32_i32$1 = $24$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$2 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $785 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($785 | 0, i64toi32_i32$2 | 0, 40 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $37 = i64toi32_i32$4;
  $37$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $1792$hi;
  i64toi32_i32$1 = $1792;
  i64toi32_i32$4 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $44 = i64toi32_i32$5;
  $44$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $33$hi;
  i64toi32_i32$0 = $44$hi;
  i64toi32_i32$2 = i64toi32_i32$5;
  i64toi32_i32$1 = $33$hi;
  i64toi32_i32$3 = $33;
  i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
  $786 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($786 | 0, i64toi32_i32$1 | 0, 48 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $33 = i64toi32_i32$2;
  $33$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $24$hi;
  i64toi32_i32$1 = $33$hi;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$2 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $24 = i64toi32_i32$4;
  $24$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $37$hi;
  i64toi32_i32$5 = $24$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$0 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64(i64toi32_i32$4 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$0 | 0, 1 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $37 = i64toi32_i32$1;
  $37$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $1773$hi;
  i64toi32_i32$5 = $1773;
  i64toi32_i32$1 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $48 = i64toi32_i32$2;
  $48$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $14$hi;
  i64toi32_i32$4 = $48$hi;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$5 = $14$hi;
  i64toi32_i32$3 = $14;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $1821 = i64toi32_i32$1;
  $1821$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $48$hi;
  $1822 = $48;
  $1822$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $45$hi;
  i64toi32_i32$2 = $21$hi;
  i64toi32_i32$2 = $45$hi;
  i64toi32_i32$4 = $45;
  i64toi32_i32$0 = $21$hi;
  i64toi32_i32$3 = $21;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $1825$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $34$hi;
  i64toi32_i32$1 = $32$hi;
  i64toi32_i32$1 = $34$hi;
  i64toi32_i32$2 = $34;
  i64toi32_i32$4 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $787 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($787 | 0, i64toi32_i32$4 | 0, 1 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $32 = i64toi32_i32$2;
  $32$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $1825$hi;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$2 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $34 = i64toi32_i32$0;
  $34$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $11$hi;
  i64toi32_i32$5 = $34$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $1834 = i64toi32_i32$2;
  $1834$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $34$hi;
  i64toi32_i32$0 = $42$hi;
  i64toi32_i32$0 = $34$hi;
  i64toi32_i32$5 = $34;
  i64toi32_i32$4 = $42$hi;
  i64toi32_i32$3 = $42;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $788 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($788 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $34 = i64toi32_i32$5;
  $34$hi = i64toi32_i32$4;
  $1839 = i64toi32_i32$5;
  $1839$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$4 = $38$hi;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$0 = $31;
  i64toi32_i32$5 = $38$hi;
  i64toi32_i32$3 = $38;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $31 = i64toi32_i32$1;
  $31$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $1839$hi;
  i64toi32_i32$4 = $1839;
  i64toi32_i32$0 = $31$hi;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $38 = i64toi32_i32$5;
  $38$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $32$hi;
  i64toi32_i32$1 = $38$hi;
  i64toi32_i32$2 = i64toi32_i32$5;
  i64toi32_i32$4 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $789 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($789 | 0, i64toi32_i32$4 | 0, 40 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $32 = i64toi32_i32$2;
  $32$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $1834$hi;
  i64toi32_i32$1 = $1834;
  i64toi32_i32$2 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $42 = i64toi32_i32$0;
  $42$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $34$hi;
  i64toi32_i32$5 = $42$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$1 = $34$hi;
  i64toi32_i32$3 = $34;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $790 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($790 | 0, i64toi32_i32$1 | 0, 48 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $34 = i64toi32_i32$4;
  $34$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $1822$hi;
  i64toi32_i32$5 = $1822;
  i64toi32_i32$4 = $34$hi;
  i64toi32_i32$3 = $34;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $791 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($791 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $45 = i64toi32_i32$5;
  $45$hi = i64toi32_i32$4;
  $1858 = i64toi32_i32$5;
  $1858$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $39$hi;
  i64toi32_i32$4 = $19$hi;
  i64toi32_i32$4 = $39$hi;
  i64toi32_i32$1 = $39;
  i64toi32_i32$5 = $19$hi;
  i64toi32_i32$3 = $19;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $1861$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $31$hi;
  i64toi32_i32$0 = $30$hi;
  i64toi32_i32$0 = $31$hi;
  i64toi32_i32$4 = $31;
  i64toi32_i32$1 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
  $792 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($792 | 0, i64toi32_i32$1 | 0, 1 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $30 = i64toi32_i32$4;
  $30$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $1861$hi;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$4 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $31 = i64toi32_i32$5;
  $31$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $18$hi;
  i64toi32_i32$2 = $31$hi;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$0 = $18$hi;
  i64toi32_i32$3 = $18;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $1870 = i64toi32_i32$4;
  $1870$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$5 = $23$hi;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$2 = $31;
  i64toi32_i32$1 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $793 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($793 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $23 = i64toi32_i32$2;
  $23$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $43$hi;
  i64toi32_i32$1 = $23$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $43$hi;
  i64toi32_i32$3 = $43;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $31 = i64toi32_i32$0;
  $31$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $30$hi;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$5 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64(i64toi32_i32$0 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$5 | 0, 40 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $30 = i64toi32_i32$1;
  $30$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $1870$hi;
  i64toi32_i32$4 = $1870;
  i64toi32_i32$1 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $39 = i64toi32_i32$2;
  $39$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $23$hi;
  i64toi32_i32$0 = $39$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$4 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$2 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$4 | 0, 48 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $23 = i64toi32_i32$5;
  $23$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$4 = $23$hi;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$3 = $31;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $31 = i64toi32_i32$1;
  $31$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $1858$hi;
  i64toi32_i32$4 = $1858;
  i64toi32_i32$0 = $31$hi;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $43 = i64toi32_i32$5;
  $43$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $37$hi;
  i64toi32_i32$1 = $43$hi;
  i64toi32_i32$2 = i64toi32_i32$5;
  i64toi32_i32$4 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $794 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($794 | 0, i64toi32_i32$4 | 0, 40 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $37 = i64toi32_i32$2;
  $37$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $1821$hi;
  i64toi32_i32$1 = $1821;
  i64toi32_i32$2 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $48 = i64toi32_i32$0;
  $48$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $26$hi;
  i64toi32_i32$5 = $48$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$1 = $26$hi;
  i64toi32_i32$3 = $26;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $1901 = i64toi32_i32$2;
  $1901$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $42$hi;
  i64toi32_i32$0 = $20$hi;
  i64toi32_i32$0 = $42$hi;
  i64toi32_i32$5 = $42;
  i64toi32_i32$4 = $20$hi;
  i64toi32_i32$3 = $20;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $1904 = i64toi32_i32$1;
  $1904$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $47$hi;
  i64toi32_i32$2 = $46$hi;
  i64toi32_i32$2 = $47$hi;
  i64toi32_i32$0 = $47;
  i64toi32_i32$5 = $46$hi;
  i64toi32_i32$3 = $46;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $795 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($795 | 0, i64toi32_i32$5 | 0, 48 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $42 = i64toi32_i32$0;
  $42$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $40$hi;
  i64toi32_i32$5 = $42$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = $40$hi;
  i64toi32_i32$3 = $40;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $40 = i64toi32_i32$4;
  $40$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $41$hi;
  i64toi32_i32$1 = $40$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$2 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$4 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$2 | 0, 1 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $41 = i64toi32_i32$5;
  $41$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $1904$hi;
  i64toi32_i32$1 = $1904;
  i64toi32_i32$5 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $46 = i64toi32_i32$0;
  $46$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $25$hi;
  i64toi32_i32$4 = $46$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$1 = $25$hi;
  i64toi32_i32$3 = $25;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $1920 = i64toi32_i32$5;
  $1920$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $46$hi;
  i64toi32_i32$0 = $23$hi;
  i64toi32_i32$0 = $46$hi;
  i64toi32_i32$4 = $46;
  i64toi32_i32$2 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $796 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($796 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $23 = i64toi32_i32$4;
  $23$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $24$hi;
  i64toi32_i32$2 = $23$hi;
  i64toi32_i32$0 = i64toi32_i32$4;
  i64toi32_i32$4 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $24 = i64toi32_i32$1;
  $24$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $41$hi;
  i64toi32_i32$5 = $24$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $799 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($799 | 0, i64toi32_i32$0 | 0, 40 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $41 = i64toi32_i32$2;
  $41$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $1920$hi;
  i64toi32_i32$5 = $1920;
  i64toi32_i32$2 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $46 = i64toi32_i32$4;
  $46$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $23$hi;
  i64toi32_i32$1 = $46$hi;
  i64toi32_i32$0 = i64toi32_i32$4;
  i64toi32_i32$5 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64(i64toi32_i32$4 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$5 | 0, 48 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $23 = i64toi32_i32$0;
  $23$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $24$hi;
  i64toi32_i32$5 = $23$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$0 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $24 = i64toi32_i32$2;
  $24$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $41$hi;
  i64toi32_i32$4 = $24$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$1 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$2 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$1 | 0, 1 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $41 = i64toi32_i32$5;
  $41$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $1901$hi;
  i64toi32_i32$4 = $1901;
  i64toi32_i32$5 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $47 = i64toi32_i32$0;
  $47$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$2 = $47$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$4 = $10$hi;
  i64toi32_i32$3 = $10;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $1949 = i64toi32_i32$5;
  $1949$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $47$hi;
  $1950 = $47;
  $1950$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $44$hi;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$0 = $44$hi;
  i64toi32_i32$2 = $44;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $1953$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$5 = $30$hi;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$0 = $31;
  i64toi32_i32$2 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  $800 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($800 | 0, i64toi32_i32$2 | 0, 1 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $30 = i64toi32_i32$0;
  $30$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $1953$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$0 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $31 = i64toi32_i32$1;
  $31$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $19$hi;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$5 = $19$hi;
  i64toi32_i32$3 = $19;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $1962 = i64toi32_i32$0;
  $1962$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $31$hi;
  i64toi32_i32$1 = $42$hi;
  i64toi32_i32$1 = $31$hi;
  i64toi32_i32$4 = $31;
  i64toi32_i32$2 = $42$hi;
  i64toi32_i32$3 = $42;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $801 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($801 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $31 = i64toi32_i32$4;
  $31$hi = i64toi32_i32$2;
  $1967 = i64toi32_i32$4;
  $1967$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $34$hi;
  i64toi32_i32$2 = $38$hi;
  i64toi32_i32$2 = $34$hi;
  i64toi32_i32$1 = $34;
  i64toi32_i32$4 = $38$hi;
  i64toi32_i32$3 = $38;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $34 = i64toi32_i32$5;
  $34$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $1967$hi;
  i64toi32_i32$2 = $1967;
  i64toi32_i32$1 = $34$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $38 = i64toi32_i32$4;
  $38$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $30$hi;
  i64toi32_i32$5 = $38$hi;
  i64toi32_i32$0 = i64toi32_i32$4;
  i64toi32_i32$2 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64(i64toi32_i32$4 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$2 | 0, 40 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $30 = i64toi32_i32$0;
  $30$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $1962$hi;
  i64toi32_i32$5 = $1962;
  i64toi32_i32$0 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $42 = i64toi32_i32$1;
  $42$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$4 = $42$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$3 = $31;
  i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
  $802 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($802 | 0, i64toi32_i32$5 | 0, 48 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $31 = i64toi32_i32$2;
  $31$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $1950$hi;
  i64toi32_i32$4 = $1950;
  i64toi32_i32$2 = $31$hi;
  i64toi32_i32$3 = $31;
  i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  $803 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($803 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $44 = i64toi32_i32$4;
  $44$hi = i64toi32_i32$2;
  $1986 = i64toi32_i32$4;
  $1986$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $39$hi;
  i64toi32_i32$2 = $15$hi;
  i64toi32_i32$2 = $39$hi;
  i64toi32_i32$5 = $39;
  i64toi32_i32$4 = $15$hi;
  i64toi32_i32$3 = $15;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $1989$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $34$hi;
  i64toi32_i32$1 = $32$hi;
  i64toi32_i32$1 = $34$hi;
  i64toi32_i32$2 = $34;
  i64toi32_i32$5 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
  $804 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($804 | 0, i64toi32_i32$5 | 0, 1 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $32 = i64toi32_i32$2;
  $32$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $1989$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$2 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $34 = i64toi32_i32$4;
  $34$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$0 = $34$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $1998 = i64toi32_i32$2;
  $1998$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $34$hi;
  i64toi32_i32$4 = $33$hi;
  i64toi32_i32$4 = $34$hi;
  i64toi32_i32$0 = $34;
  i64toi32_i32$5 = $33$hi;
  i64toi32_i32$3 = $33;
  i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
  $805 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($805 | 0, i64toi32_i32$5 | 0, 32 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $33 = i64toi32_i32$0;
  $33$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $40$hi;
  i64toi32_i32$5 = $33$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$0 = $40$hi;
  i64toi32_i32$3 = $40;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $34 = i64toi32_i32$1;
  $34$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $32$hi;
  i64toi32_i32$2 = $34$hi;
  i64toi32_i32$5 = i64toi32_i32$1;
  i64toi32_i32$4 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  $806 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($806 | 0, i64toi32_i32$4 | 0, 40 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $32 = i64toi32_i32$5;
  $32$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $1998$hi;
  i64toi32_i32$2 = $1998;
  i64toi32_i32$5 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $39 = i64toi32_i32$0;
  $39$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $33$hi;
  i64toi32_i32$1 = $39$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$2 = $33$hi;
  i64toi32_i32$3 = $33;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $807 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($807 | 0, i64toi32_i32$2 | 0, 48 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $33 = i64toi32_i32$4;
  $33$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $34$hi;
  i64toi32_i32$2 = $33$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$4 = $34$hi;
  i64toi32_i32$3 = $34;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $34 = i64toi32_i32$5;
  $34$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $1986$hi;
  i64toi32_i32$2 = $1986;
  i64toi32_i32$1 = $34$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $40 = i64toi32_i32$4;
  $40$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $41$hi;
  i64toi32_i32$5 = $40$hi;
  i64toi32_i32$0 = i64toi32_i32$4;
  i64toi32_i32$2 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64(i64toi32_i32$4 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$2 | 0, 40 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $41 = i64toi32_i32$0;
  $41$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $1949$hi;
  i64toi32_i32$5 = $1949;
  i64toi32_i32$0 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $47 = i64toi32_i32$1;
  $47$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $21$hi;
  i64toi32_i32$4 = $47$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$5 = $21$hi;
  i64toi32_i32$3 = $21;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $2029 = i64toi32_i32$0;
  $2029$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $48$hi;
  i64toi32_i32$1 = $45$hi;
  i64toi32_i32$1 = $48$hi;
  i64toi32_i32$4 = $48;
  i64toi32_i32$2 = $45$hi;
  i64toi32_i32$3 = $45;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $808 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($808 | 0, i64toi32_i32$2 | 0, 48 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $45 = i64toi32_i32$4;
  $45$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $43$hi;
  i64toi32_i32$2 = $45$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$4 = $43$hi;
  i64toi32_i32$3 = $43;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $43 = i64toi32_i32$5;
  $43$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $37$hi;
  i64toi32_i32$0 = $43$hi;
  i64toi32_i32$2 = i64toi32_i32$5;
  i64toi32_i32$1 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
  $809 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($809 | 0, i64toi32_i32$1 | 0, 1 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $37 = i64toi32_i32$2;
  $37$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $18$hi;
  i64toi32_i32$1 = $37$hi;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$2 = $18$hi;
  i64toi32_i32$3 = $18;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $2043$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $42$hi;
  i64toi32_i32$5 = $2043$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$0 = $42$hi;
  i64toi32_i32$3 = $42;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $42 = i64toi32_i32$2;
  $42$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $13$hi;
  i64toi32_i32$4 = $42$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$1 = $13$hi;
  i64toi32_i32$3 = $13;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $2048 = i64toi32_i32$0;
  $2048$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $42$hi;
  i64toi32_i32$2 = $33$hi;
  i64toi32_i32$2 = $42$hi;
  i64toi32_i32$4 = $42;
  i64toi32_i32$5 = $33$hi;
  i64toi32_i32$3 = $33;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $811 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($811 | 0, i64toi32_i32$5 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $33 = i64toi32_i32$4;
  $33$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $24$hi;
  i64toi32_i32$5 = $33$hi;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$4 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $24 = i64toi32_i32$1;
  $24$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $37$hi;
  i64toi32_i32$0 = $24$hi;
  i64toi32_i32$5 = i64toi32_i32$1;
  i64toi32_i32$2 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $812 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($812 | 0, i64toi32_i32$2 | 0, 40 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $37 = i64toi32_i32$5;
  $37$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $2048$hi;
  i64toi32_i32$0 = $2048;
  i64toi32_i32$5 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $42 = i64toi32_i32$4;
  $42$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $33$hi;
  i64toi32_i32$1 = $42$hi;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$0 = $33$hi;
  i64toi32_i32$3 = $33;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $813 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($813 | 0, i64toi32_i32$0 | 0, 48 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $33 = i64toi32_i32$2;
  $33$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $24$hi;
  i64toi32_i32$0 = $33$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$2 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $24 = i64toi32_i32$5;
  $24$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $37$hi;
  i64toi32_i32$4 = $24$hi;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$1 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64(i64toi32_i32$5 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$1 | 0, 1 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $37 = i64toi32_i32$0;
  $37$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $2029$hi;
  i64toi32_i32$4 = $2029;
  i64toi32_i32$0 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $48 = i64toi32_i32$2;
  $48$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $12$hi;
  i64toi32_i32$5 = $48$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$4 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $2077 = i64toi32_i32$0;
  $2077$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $48$hi;
  $2078 = $48;
  $2078$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $46$hi;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$2 = $46$hi;
  i64toi32_i32$5 = $46;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $2081$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $34$hi;
  i64toi32_i32$0 = $32$hi;
  i64toi32_i32$0 = $34$hi;
  i64toi32_i32$2 = $34;
  i64toi32_i32$5 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$5 = i64toi32_i32$0 ^ i64toi32_i32$5 | 0;
  $814 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($814 | 0, i64toi32_i32$5 | 0, 1 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $32 = i64toi32_i32$2;
  $32$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $2081$hi;
  i64toi32_i32$0 = i64toi32_i32$4;
  i64toi32_i32$2 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $34 = i64toi32_i32$1;
  $34$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $29$hi;
  i64toi32_i32$4 = $34$hi;
  i64toi32_i32$5 = i64toi32_i32$1;
  i64toi32_i32$0 = $29$hi;
  i64toi32_i32$3 = $29;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $2090 = i64toi32_i32$2;
  $2090$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $34$hi;
  i64toi32_i32$1 = $45$hi;
  i64toi32_i32$1 = $34$hi;
  i64toi32_i32$4 = $34;
  i64toi32_i32$5 = $45$hi;
  i64toi32_i32$3 = $45;
  i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
  $816 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($816 | 0, i64toi32_i32$5 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $34 = i64toi32_i32$4;
  $34$hi = i64toi32_i32$5;
  $2095 = i64toi32_i32$4;
  $2095$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$5 = $38$hi;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$1 = $31;
  i64toi32_i32$4 = $38$hi;
  i64toi32_i32$3 = $38;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $31 = i64toi32_i32$0;
  $31$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $2095$hi;
  i64toi32_i32$5 = $2095;
  i64toi32_i32$1 = $31$hi;
  i64toi32_i32$3 = i64toi32_i32$0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $38 = i64toi32_i32$4;
  $38$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $32$hi;
  i64toi32_i32$0 = $38$hi;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$5 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$5 = i64toi32_i32$0 ^ i64toi32_i32$5 | 0;
  $817 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($817 | 0, i64toi32_i32$5 | 0, 40 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $32 = i64toi32_i32$2;
  $32$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $2090$hi;
  i64toi32_i32$0 = $2090;
  i64toi32_i32$2 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $45 = i64toi32_i32$1;
  $45$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $34$hi;
  i64toi32_i32$4 = $45$hi;
  i64toi32_i32$5 = i64toi32_i32$1;
  i64toi32_i32$0 = $34$hi;
  i64toi32_i32$3 = $34;
  i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
  $818 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($818 | 0, i64toi32_i32$0 | 0, 48 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $34 = i64toi32_i32$5;
  $34$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $2078$hi;
  i64toi32_i32$4 = $2078;
  i64toi32_i32$5 = $34$hi;
  i64toi32_i32$3 = $34;
  i64toi32_i32$5 = i64toi32_i32$0 ^ i64toi32_i32$5 | 0;
  $819 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($819 | 0, i64toi32_i32$5 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $46 = i64toi32_i32$4;
  $46$hi = i64toi32_i32$5;
  $2114 = i64toi32_i32$4;
  $2114$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $39$hi;
  i64toi32_i32$5 = $6$hi;
  i64toi32_i32$5 = $39$hi;
  i64toi32_i32$0 = $39;
  i64toi32_i32$4 = $6$hi;
  i64toi32_i32$3 = $6;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $2117$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $31$hi;
  i64toi32_i32$1 = $30$hi;
  i64toi32_i32$1 = $31$hi;
  i64toi32_i32$5 = $31;
  i64toi32_i32$0 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $820 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($820 | 0, i64toi32_i32$0 | 0, 1 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $30 = i64toi32_i32$5;
  $30$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $2117$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$5 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $31 = i64toi32_i32$4;
  $31$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $21$hi;
  i64toi32_i32$2 = $31$hi;
  i64toi32_i32$0 = i64toi32_i32$4;
  i64toi32_i32$1 = $21$hi;
  i64toi32_i32$3 = $21;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $2126 = i64toi32_i32$5;
  $2126$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$4 = $23$hi;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$2 = $31;
  i64toi32_i32$0 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
  $821 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($821 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $23 = i64toi32_i32$2;
  $23$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $43$hi;
  i64toi32_i32$0 = $23$hi;
  i64toi32_i32$4 = i64toi32_i32$2;
  i64toi32_i32$2 = $43$hi;
  i64toi32_i32$3 = $43;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $31 = i64toi32_i32$1;
  $31$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $30$hi;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$4 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
  $822 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($822 | 0, i64toi32_i32$4 | 0, 40 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $30 = i64toi32_i32$0;
  $30$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $2126$hi;
  i64toi32_i32$5 = $2126;
  i64toi32_i32$0 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $39 = i64toi32_i32$2;
  $39$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $23$hi;
  i64toi32_i32$1 = $39$hi;
  i64toi32_i32$4 = i64toi32_i32$2;
  i64toi32_i32$5 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64(i64toi32_i32$2 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$5 | 0, 48 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $23 = i64toi32_i32$4;
  $23$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$5 = $23$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$3 = $31;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $31 = i64toi32_i32$0;
  $31$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $2114$hi;
  i64toi32_i32$5 = $2114;
  i64toi32_i32$1 = $31$hi;
  i64toi32_i32$3 = i64toi32_i32$0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $43 = i64toi32_i32$4;
  $43$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $37$hi;
  i64toi32_i32$0 = $43$hi;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$5 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$5 = i64toi32_i32$0 ^ i64toi32_i32$5 | 0;
  $823 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($823 | 0, i64toi32_i32$5 | 0, 40 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $37 = i64toi32_i32$2;
  $37$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $2077$hi;
  i64toi32_i32$0 = $2077;
  i64toi32_i32$2 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $48 = i64toi32_i32$1;
  $48$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $15$hi;
  i64toi32_i32$4 = $48$hi;
  i64toi32_i32$5 = i64toi32_i32$1;
  i64toi32_i32$0 = $15$hi;
  i64toi32_i32$3 = $15;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $2157 = i64toi32_i32$2;
  $2157$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $45$hi;
  i64toi32_i32$1 = $25$hi;
  i64toi32_i32$1 = $45$hi;
  i64toi32_i32$4 = $45;
  i64toi32_i32$5 = $25$hi;
  i64toi32_i32$3 = $25;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $2160 = i64toi32_i32$0;
  $2160$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $47$hi;
  i64toi32_i32$2 = $44$hi;
  i64toi32_i32$2 = $47$hi;
  i64toi32_i32$1 = $47;
  i64toi32_i32$4 = $44$hi;
  i64toi32_i32$3 = $44;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  $824 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($824 | 0, i64toi32_i32$4 | 0, 48 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $44 = i64toi32_i32$1;
  $44$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $40$hi;
  i64toi32_i32$4 = $44$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$1 = $40$hi;
  i64toi32_i32$3 = $40;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $40 = i64toi32_i32$5;
  $40$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $41$hi;
  i64toi32_i32$0 = $40$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$2 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $825 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($825 | 0, i64toi32_i32$2 | 0, 1 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $41 = i64toi32_i32$4;
  $41$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $2160$hi;
  i64toi32_i32$0 = $2160;
  i64toi32_i32$4 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $45 = i64toi32_i32$1;
  $45$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $19$hi;
  i64toi32_i32$5 = $45$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = $19$hi;
  i64toi32_i32$3 = $19;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $2176 = i64toi32_i32$4;
  $2176$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $45$hi;
  i64toi32_i32$1 = $23$hi;
  i64toi32_i32$1 = $45$hi;
  i64toi32_i32$5 = $45;
  i64toi32_i32$2 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $826 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($826 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $23 = i64toi32_i32$5;
  $23$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $24$hi;
  i64toi32_i32$2 = $23$hi;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$5 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $24 = i64toi32_i32$0;
  $24$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $41$hi;
  i64toi32_i32$4 = $24$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$1 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
  $827 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($827 | 0, i64toi32_i32$1 | 0, 40 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $41 = i64toi32_i32$2;
  $41$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $2176$hi;
  i64toi32_i32$4 = $2176;
  i64toi32_i32$2 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $45 = i64toi32_i32$5;
  $45$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $23$hi;
  i64toi32_i32$0 = $45$hi;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$4 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64(i64toi32_i32$5 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$4 | 0, 48 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $23 = i64toi32_i32$1;
  $23$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $24$hi;
  i64toi32_i32$4 = $23$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$1 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $24 = i64toi32_i32$2;
  $24$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $41$hi;
  i64toi32_i32$5 = $24$hi;
  i64toi32_i32$4 = i64toi32_i32$2;
  i64toi32_i32$0 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64(i64toi32_i32$2 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$0 | 0, 1 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $41 = i64toi32_i32$4;
  $41$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $2157$hi;
  i64toi32_i32$5 = $2157;
  i64toi32_i32$4 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $47 = i64toi32_i32$1;
  $47$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $18$hi;
  i64toi32_i32$2 = $47$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$5 = $18$hi;
  i64toi32_i32$3 = $18;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $2205 = i64toi32_i32$4;
  $2205$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $47$hi;
  $2206 = $47;
  $2206$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $42$hi;
  i64toi32_i32$1 = $10$hi;
  i64toi32_i32$1 = $42$hi;
  i64toi32_i32$2 = $42;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$3 = $10;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $2209$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$4 = $30$hi;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$1 = $31;
  i64toi32_i32$2 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $828 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($828 | 0, i64toi32_i32$2 | 0, 1 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $30 = i64toi32_i32$1;
  $30$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $2209$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$1 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $31 = i64toi32_i32$0;
  $31$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $6$hi;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$4 = $6$hi;
  i64toi32_i32$3 = $6;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $2218 = i64toi32_i32$1;
  $2218$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $31$hi;
  i64toi32_i32$0 = $44$hi;
  i64toi32_i32$0 = $31$hi;
  i64toi32_i32$5 = $31;
  i64toi32_i32$2 = $44$hi;
  i64toi32_i32$3 = $44;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $829 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($829 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $31 = i64toi32_i32$5;
  $31$hi = i64toi32_i32$2;
  $2223 = i64toi32_i32$5;
  $2223$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $34$hi;
  i64toi32_i32$2 = $38$hi;
  i64toi32_i32$2 = $34$hi;
  i64toi32_i32$0 = $34;
  i64toi32_i32$5 = $38$hi;
  i64toi32_i32$3 = $38;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $34 = i64toi32_i32$4;
  $34$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $2223$hi;
  i64toi32_i32$2 = $2223;
  i64toi32_i32$0 = $34$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $38 = i64toi32_i32$5;
  $38$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $30$hi;
  i64toi32_i32$4 = $38$hi;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$2 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64(i64toi32_i32$5 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$2 | 0, 40 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $30 = i64toi32_i32$1;
  $30$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $2218$hi;
  i64toi32_i32$4 = $2218;
  i64toi32_i32$1 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $42 = i64toi32_i32$0;
  $42$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$5 = $42$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$3 = $31;
  i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
  $830 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($830 | 0, i64toi32_i32$4 | 0, 48 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $31 = i64toi32_i32$2;
  $31$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $2206$hi;
  i64toi32_i32$5 = $2206;
  i64toi32_i32$2 = $31$hi;
  i64toi32_i32$3 = $31;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $831 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($831 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $44 = i64toi32_i32$5;
  $44$hi = i64toi32_i32$2;
  $2242 = i64toi32_i32$5;
  $2242$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $39$hi;
  i64toi32_i32$2 = $14$hi;
  i64toi32_i32$2 = $39$hi;
  i64toi32_i32$4 = $39;
  i64toi32_i32$5 = $14$hi;
  i64toi32_i32$3 = $14;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $2245$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $34$hi;
  i64toi32_i32$0 = $32$hi;
  i64toi32_i32$0 = $34$hi;
  i64toi32_i32$2 = $34;
  i64toi32_i32$4 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $832 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($832 | 0, i64toi32_i32$4 | 0, 1 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $32 = i64toi32_i32$2;
  $32$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $2245$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$2 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $34 = i64toi32_i32$5;
  $34$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$1 = $34$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $2254 = i64toi32_i32$2;
  $2254$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $34$hi;
  i64toi32_i32$5 = $33$hi;
  i64toi32_i32$5 = $34$hi;
  i64toi32_i32$1 = $34;
  i64toi32_i32$4 = $33$hi;
  i64toi32_i32$3 = $33;
  i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
  $833 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($833 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $33 = i64toi32_i32$1;
  $33$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $40$hi;
  i64toi32_i32$4 = $33$hi;
  i64toi32_i32$5 = i64toi32_i32$1;
  i64toi32_i32$1 = $40$hi;
  i64toi32_i32$3 = $40;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $34 = i64toi32_i32$0;
  $34$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $32$hi;
  i64toi32_i32$2 = $34$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$5 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $835 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($835 | 0, i64toi32_i32$5 | 0, 40 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $32 = i64toi32_i32$4;
  $32$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $2254$hi;
  i64toi32_i32$2 = $2254;
  i64toi32_i32$4 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $39 = i64toi32_i32$1;
  $39$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $33$hi;
  i64toi32_i32$0 = $39$hi;
  i64toi32_i32$5 = i64toi32_i32$1;
  i64toi32_i32$2 = $33$hi;
  i64toi32_i32$3 = $33;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $836 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($836 | 0, i64toi32_i32$2 | 0, 48 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $33 = i64toi32_i32$5;
  $33$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $34$hi;
  i64toi32_i32$2 = $33$hi;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$5 = $34$hi;
  i64toi32_i32$3 = $34;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $34 = i64toi32_i32$4;
  $34$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $2242$hi;
  i64toi32_i32$2 = $2242;
  i64toi32_i32$0 = $34$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $40 = i64toi32_i32$5;
  $40$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $41$hi;
  i64toi32_i32$4 = $40$hi;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$2 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64(i64toi32_i32$5 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$2 | 0, 40 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $41 = i64toi32_i32$1;
  $41$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $2205$hi;
  i64toi32_i32$4 = $2205;
  i64toi32_i32$1 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $47 = i64toi32_i32$0;
  $47$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $13$hi;
  i64toi32_i32$5 = $47$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$4 = $13$hi;
  i64toi32_i32$3 = $13;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $2285 = i64toi32_i32$1;
  $2285$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $48$hi;
  i64toi32_i32$0 = $46$hi;
  i64toi32_i32$0 = $48$hi;
  i64toi32_i32$5 = $48;
  i64toi32_i32$2 = $46$hi;
  i64toi32_i32$3 = $46;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $837 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($837 | 0, i64toi32_i32$2 | 0, 48 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $46 = i64toi32_i32$5;
  $46$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $43$hi;
  i64toi32_i32$2 = $46$hi;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$5 = $43$hi;
  i64toi32_i32$3 = $43;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $43 = i64toi32_i32$4;
  $43$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $37$hi;
  i64toi32_i32$1 = $43$hi;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$0 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $838 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($838 | 0, i64toi32_i32$0 | 0, 1 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $37 = i64toi32_i32$2;
  $37$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $13$hi;
  i64toi32_i32$0 = $37$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$2 = $13$hi;
  i64toi32_i32$3 = $13;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $2299$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $42$hi;
  i64toi32_i32$4 = $2299$hi;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$1 = $42$hi;
  i64toi32_i32$3 = $42;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $42 = i64toi32_i32$2;
  $42$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $26$hi;
  i64toi32_i32$5 = $42$hi;
  i64toi32_i32$4 = i64toi32_i32$2;
  i64toi32_i32$0 = $26$hi;
  i64toi32_i32$3 = $26;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $2304 = i64toi32_i32$1;
  $2304$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $42$hi;
  i64toi32_i32$2 = $33$hi;
  i64toi32_i32$2 = $42$hi;
  i64toi32_i32$5 = $42;
  i64toi32_i32$4 = $33$hi;
  i64toi32_i32$3 = $33;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  $839 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($839 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $33 = i64toi32_i32$5;
  $33$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $24$hi;
  i64toi32_i32$4 = $33$hi;
  i64toi32_i32$2 = i64toi32_i32$5;
  i64toi32_i32$5 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $24 = i64toi32_i32$0;
  $24$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $37$hi;
  i64toi32_i32$1 = $24$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$2 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $840 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($840 | 0, i64toi32_i32$2 | 0, 40 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $37 = i64toi32_i32$4;
  $37$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $2304$hi;
  i64toi32_i32$1 = $2304;
  i64toi32_i32$4 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $42 = i64toi32_i32$5;
  $42$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $33$hi;
  i64toi32_i32$0 = $42$hi;
  i64toi32_i32$2 = i64toi32_i32$5;
  i64toi32_i32$1 = $33$hi;
  i64toi32_i32$3 = $33;
  i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
  $841 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($841 | 0, i64toi32_i32$1 | 0, 48 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $33 = i64toi32_i32$2;
  $33$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $24$hi;
  i64toi32_i32$1 = $33$hi;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$2 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $24 = i64toi32_i32$4;
  $24$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $37$hi;
  i64toi32_i32$5 = $24$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$0 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64(i64toi32_i32$4 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$0 | 0, 1 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $37 = i64toi32_i32$1;
  $37$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $2285$hi;
  i64toi32_i32$5 = $2285;
  i64toi32_i32$1 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $48 = i64toi32_i32$2;
  $48$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $18$hi;
  i64toi32_i32$4 = $48$hi;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$5 = $18$hi;
  i64toi32_i32$3 = $18;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $2333 = i64toi32_i32$1;
  $2333$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $39$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$2 = $39$hi;
  i64toi32_i32$4 = $39;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $2336 = i64toi32_i32$5;
  $2336$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $31$hi;
  i64toi32_i32$1 = $38$hi;
  i64toi32_i32$1 = $31$hi;
  i64toi32_i32$2 = $31;
  i64toi32_i32$4 = $38$hi;
  i64toi32_i32$3 = $38;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $31 = i64toi32_i32$0;
  $31$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $30$hi;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$2 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64(i64toi32_i32$0 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$2 | 0, 1 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $30 = i64toi32_i32$1;
  $30$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $2336$hi;
  i64toi32_i32$5 = $2336;
  i64toi32_i32$1 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $38 = i64toi32_i32$4;
  $38$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $29$hi;
  i64toi32_i32$0 = $38$hi;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$5 = $29$hi;
  i64toi32_i32$3 = $29;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $2348 = i64toi32_i32$1;
  $2348$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $38$hi;
  i64toi32_i32$4 = $23$hi;
  i64toi32_i32$4 = $38$hi;
  i64toi32_i32$0 = $38;
  i64toi32_i32$2 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $842 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($842 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $23 = i64toi32_i32$0;
  $23$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $43$hi;
  i64toi32_i32$2 = $23$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$0 = $43$hi;
  i64toi32_i32$3 = $43;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $38 = i64toi32_i32$5;
  $38$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $30$hi;
  i64toi32_i32$1 = $38$hi;
  i64toi32_i32$2 = i64toi32_i32$5;
  i64toi32_i32$4 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $843 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($843 | 0, i64toi32_i32$4 | 0, 40 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $30 = i64toi32_i32$2;
  $30$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $2348$hi;
  i64toi32_i32$1 = $2348;
  i64toi32_i32$2 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $39 = i64toi32_i32$0;
  $39$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $23$hi;
  i64toi32_i32$5 = $39$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$1 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $844 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($844 | 0, i64toi32_i32$1 | 0, 48 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $23 = i64toi32_i32$4;
  $23$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $38$hi;
  i64toi32_i32$1 = $23$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$4 = $38$hi;
  i64toi32_i32$3 = $38;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $38 = i64toi32_i32$2;
  $38$hi = i64toi32_i32$0;
  $2369 = i64toi32_i32$2;
  $2369$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $48$hi;
  $2370 = $48;
  $2370$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $45$hi;
  i64toi32_i32$0 = $22$hi;
  i64toi32_i32$0 = $45$hi;
  i64toi32_i32$1 = $45;
  i64toi32_i32$5 = $22$hi;
  i64toi32_i32$3 = $22;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $2373$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $34$hi;
  i64toi32_i32$2 = $32$hi;
  i64toi32_i32$2 = $34$hi;
  i64toi32_i32$0 = $34;
  i64toi32_i32$1 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
  $845 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($845 | 0, i64toi32_i32$1 | 0, 1 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $32 = i64toi32_i32$0;
  $32$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $2373$hi;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$0 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $34 = i64toi32_i32$5;
  $34$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $20$hi;
  i64toi32_i32$4 = $34$hi;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$2 = $20$hi;
  i64toi32_i32$3 = $20;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $2382 = i64toi32_i32$0;
  $2382$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $34$hi;
  i64toi32_i32$5 = $46$hi;
  i64toi32_i32$5 = $34$hi;
  i64toi32_i32$4 = $34;
  i64toi32_i32$1 = $46$hi;
  i64toi32_i32$3 = $46;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $847 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($847 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $34 = i64toi32_i32$4;
  $34$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $31$hi;
  i64toi32_i32$1 = $34$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$3 = $31;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $31 = i64toi32_i32$2;
  $31$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $32$hi;
  i64toi32_i32$0 = $31$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$5 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$5 = i64toi32_i32$0 ^ i64toi32_i32$5 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64(i64toi32_i32$2 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$5 | 0, 40 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $32 = i64toi32_i32$1;
  $32$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $2382$hi;
  i64toi32_i32$0 = $2382;
  i64toi32_i32$1 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $43 = i64toi32_i32$4;
  $43$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $34$hi;
  i64toi32_i32$2 = $43$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$0 = $34$hi;
  i64toi32_i32$3 = $34;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$4 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$0 | 0, 48 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $34 = i64toi32_i32$5;
  $34$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $2370$hi;
  i64toi32_i32$2 = $2370;
  i64toi32_i32$5 = $34$hi;
  i64toi32_i32$3 = $34;
  i64toi32_i32$5 = i64toi32_i32$0 ^ i64toi32_i32$5 | 0;
  $848 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($848 | 0, i64toi32_i32$5 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $45 = i64toi32_i32$2;
  $45$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $2369$hi;
  i64toi32_i32$0 = $2369;
  i64toi32_i32$2 = $45$hi;
  i64toi32_i32$3 = $45;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $46 = i64toi32_i32$1;
  $46$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $37$hi;
  i64toi32_i32$4 = $46$hi;
  i64toi32_i32$5 = i64toi32_i32$1;
  i64toi32_i32$0 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
  $849 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($849 | 0, i64toi32_i32$0 | 0, 40 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $37 = i64toi32_i32$5;
  $37$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $2333$hi;
  i64toi32_i32$4 = $2333;
  i64toi32_i32$5 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $48 = i64toi32_i32$2;
  $48$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$1 = $48$hi;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$4 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $2413 = i64toi32_i32$5;
  $2413$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $43$hi;
  i64toi32_i32$2 = $6$hi;
  i64toi32_i32$2 = $43$hi;
  i64toi32_i32$1 = $43;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$3 = $6;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $2416 = i64toi32_i32$4;
  $2416$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $47$hi;
  i64toi32_i32$5 = $44$hi;
  i64toi32_i32$5 = $47$hi;
  i64toi32_i32$2 = $47;
  i64toi32_i32$1 = $44$hi;
  i64toi32_i32$3 = $44;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $850 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($850 | 0, i64toi32_i32$1 | 0, 48 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $43 = i64toi32_i32$2;
  $43$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $40$hi;
  i64toi32_i32$1 = $43$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $40$hi;
  i64toi32_i32$3 = $40;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $40 = i64toi32_i32$0;
  $40$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $41$hi;
  i64toi32_i32$4 = $40$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$5 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64(i64toi32_i32$0 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$5 | 0, 1 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $41 = i64toi32_i32$1;
  $41$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $2416$hi;
  i64toi32_i32$4 = $2416;
  i64toi32_i32$1 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $44 = i64toi32_i32$2;
  $44$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $29$hi;
  i64toi32_i32$0 = $44$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$4 = $29$hi;
  i64toi32_i32$3 = $29;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $2432 = i64toi32_i32$1;
  $2432$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $44$hi;
  i64toi32_i32$2 = $23$hi;
  i64toi32_i32$2 = $44$hi;
  i64toi32_i32$0 = $44;
  i64toi32_i32$5 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $851 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($851 | 0, i64toi32_i32$5 | 0, 32 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $23 = i64toi32_i32$0;
  $23$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $24$hi;
  i64toi32_i32$5 = $23$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $24 = i64toi32_i32$4;
  $24$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $41$hi;
  i64toi32_i32$1 = $24$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$2 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$4 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$2 | 0, 40 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $41 = i64toi32_i32$5;
  $41$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $2432$hi;
  i64toi32_i32$1 = $2432;
  i64toi32_i32$5 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $44 = i64toi32_i32$0;
  $44$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $23$hi;
  i64toi32_i32$4 = $44$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$1 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
  $852 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($852 | 0, i64toi32_i32$1 | 0, 48 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $23 = i64toi32_i32$2;
  $23$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $24$hi;
  i64toi32_i32$1 = $23$hi;
  i64toi32_i32$4 = i64toi32_i32$2;
  i64toi32_i32$2 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $24 = i64toi32_i32$5;
  $24$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $41$hi;
  i64toi32_i32$0 = $24$hi;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$4 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64(i64toi32_i32$5 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$4 | 0, 1 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $41 = i64toi32_i32$1;
  $41$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $2413$hi;
  i64toi32_i32$0 = $2413;
  i64toi32_i32$1 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $47 = i64toi32_i32$2;
  $47$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $14$hi;
  i64toi32_i32$5 = $47$hi;
  i64toi32_i32$4 = i64toi32_i32$2;
  i64toi32_i32$0 = $14$hi;
  i64toi32_i32$3 = $14;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $2461 = i64toi32_i32$1;
  $2461$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $47$hi;
  $2462 = $47;
  $2462$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $42$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$2 = $42$hi;
  i64toi32_i32$5 = $42;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $2465$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $38$hi;
  i64toi32_i32$1 = $30$hi;
  i64toi32_i32$1 = $38$hi;
  i64toi32_i32$2 = $38;
  i64toi32_i32$5 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
  $853 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($853 | 0, i64toi32_i32$5 | 0, 1 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $30 = i64toi32_i32$2;
  $30$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $2465$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$2 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $38 = i64toi32_i32$4;
  $38$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $26$hi;
  i64toi32_i32$0 = $38$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$1 = $26$hi;
  i64toi32_i32$3 = $26;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $2474 = i64toi32_i32$2;
  $2474$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $38$hi;
  i64toi32_i32$4 = $43$hi;
  i64toi32_i32$4 = $38$hi;
  i64toi32_i32$0 = $38;
  i64toi32_i32$5 = $43$hi;
  i64toi32_i32$3 = $43;
  i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
  $854 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($854 | 0, i64toi32_i32$5 | 0, 32 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $38 = i64toi32_i32$0;
  $38$hi = i64toi32_i32$5;
  $2479 = i64toi32_i32$0;
  $2479$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $34$hi;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$5 = $34$hi;
  i64toi32_i32$4 = $34;
  i64toi32_i32$0 = $31$hi;
  i64toi32_i32$3 = $31;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $31 = i64toi32_i32$1;
  $31$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $2479$hi;
  i64toi32_i32$5 = $2479;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $34 = i64toi32_i32$0;
  $34$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $30$hi;
  i64toi32_i32$1 = $34$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$5 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
  $855 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($855 | 0, i64toi32_i32$5 | 0, 40 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $30 = i64toi32_i32$2;
  $30$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $2474$hi;
  i64toi32_i32$1 = $2474;
  i64toi32_i32$2 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $42 = i64toi32_i32$4;
  $42$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $38$hi;
  i64toi32_i32$0 = $42$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$1 = $38$hi;
  i64toi32_i32$3 = $38;
  i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$4 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$1 | 0, 48 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $38 = i64toi32_i32$5;
  $38$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $2462$hi;
  i64toi32_i32$0 = $2462;
  i64toi32_i32$5 = $38$hi;
  i64toi32_i32$3 = $38;
  i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
  $856 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($856 | 0, i64toi32_i32$5 | 0, 32 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $43 = i64toi32_i32$0;
  $43$hi = i64toi32_i32$5;
  $2498 = i64toi32_i32$0;
  $2498$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $39$hi;
  i64toi32_i32$5 = $20$hi;
  i64toi32_i32$5 = $39$hi;
  i64toi32_i32$1 = $39;
  i64toi32_i32$0 = $20$hi;
  i64toi32_i32$3 = $20;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $2501$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$4 = $32$hi;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$5 = $31;
  i64toi32_i32$1 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
  $857 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($857 | 0, i64toi32_i32$1 | 0, 1 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $31 = i64toi32_i32$5;
  $31$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $2501$hi;
  i64toi32_i32$4 = i64toi32_i32$2;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$3 = $31;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $32 = i64toi32_i32$0;
  $32$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $21$hi;
  i64toi32_i32$2 = $32$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$4 = $21$hi;
  i64toi32_i32$3 = $21;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $2510 = i64toi32_i32$5;
  $2510$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $32$hi;
  i64toi32_i32$0 = $33$hi;
  i64toi32_i32$0 = $32$hi;
  i64toi32_i32$2 = $32;
  i64toi32_i32$1 = $33$hi;
  i64toi32_i32$3 = $33;
  i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
  $858 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($858 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $32 = i64toi32_i32$2;
  $32$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $40$hi;
  i64toi32_i32$1 = $32$hi;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$2 = $40$hi;
  i64toi32_i32$3 = $40;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $33 = i64toi32_i32$4;
  $33$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$5 = $33$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$0 = $31$hi;
  i64toi32_i32$3 = $31;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64(i64toi32_i32$4 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$0 | 0, 40 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $31 = i64toi32_i32$1;
  $31$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $2510$hi;
  i64toi32_i32$5 = $2510;
  i64toi32_i32$1 = $31$hi;
  i64toi32_i32$3 = $31;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $39 = i64toi32_i32$2;
  $39$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $32$hi;
  i64toi32_i32$4 = $39$hi;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$5 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64(i64toi32_i32$2 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$5 | 0, 48 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $32 = i64toi32_i32$0;
  $32$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $33$hi;
  i64toi32_i32$5 = $32$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$0 = $33$hi;
  i64toi32_i32$3 = $33;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $33 = i64toi32_i32$1;
  $33$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $2498$hi;
  i64toi32_i32$5 = $2498;
  i64toi32_i32$4 = $33$hi;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $40 = i64toi32_i32$0;
  $40$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $41$hi;
  i64toi32_i32$1 = $40$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$5 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
  $859 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($859 | 0, i64toi32_i32$5 | 0, 40 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $41 = i64toi32_i32$2;
  $41$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $2461$hi;
  i64toi32_i32$1 = $2461;
  i64toi32_i32$2 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $47 = i64toi32_i32$4;
  $47$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$0 = $47$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$1 = $10$hi;
  i64toi32_i32$3 = $10;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $2541 = i64toi32_i32$2;
  $2541$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $42$hi;
  i64toi32_i32$4 = $22$hi;
  i64toi32_i32$4 = $42$hi;
  i64toi32_i32$0 = $42;
  i64toi32_i32$5 = $22$hi;
  i64toi32_i32$3 = $22;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $2544 = i64toi32_i32$1;
  $2544$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $48$hi;
  i64toi32_i32$2 = $45$hi;
  i64toi32_i32$2 = $48$hi;
  i64toi32_i32$4 = $48;
  i64toi32_i32$0 = $45$hi;
  i64toi32_i32$3 = $45;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $860 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($860 | 0, i64toi32_i32$0 | 0, 48 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $42 = i64toi32_i32$4;
  $42$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $46$hi;
  i64toi32_i32$0 = $42$hi;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$4 = $46$hi;
  i64toi32_i32$3 = $46;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $45 = i64toi32_i32$5;
  $45$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $37$hi;
  i64toi32_i32$1 = $45$hi;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$2 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64(i64toi32_i32$5 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$2 | 0, 1 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $37 = i64toi32_i32$0;
  $37$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $2544$hi;
  i64toi32_i32$1 = $2544;
  i64toi32_i32$0 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $46 = i64toi32_i32$4;
  $46$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$5 = $46$hi;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$1 = $10$hi;
  i64toi32_i32$3 = $10;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $2560 = i64toi32_i32$0;
  $2560$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $46$hi;
  i64toi32_i32$4 = $32$hi;
  i64toi32_i32$4 = $46$hi;
  i64toi32_i32$5 = $46;
  i64toi32_i32$2 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $861 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($861 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $32 = i64toi32_i32$5;
  $32$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $24$hi;
  i64toi32_i32$2 = $32$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$5 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $24 = i64toi32_i32$1;
  $24$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $37$hi;
  i64toi32_i32$0 = $24$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$4 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $862 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($862 | 0, i64toi32_i32$4 | 0, 40 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $37 = i64toi32_i32$2;
  $37$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $2560$hi;
  i64toi32_i32$0 = $2560;
  i64toi32_i32$2 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $46 = i64toi32_i32$5;
  $46$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $32$hi;
  i64toi32_i32$1 = $46$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$0 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $863 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($863 | 0, i64toi32_i32$0 | 0, 48 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $32 = i64toi32_i32$4;
  $32$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $24$hi;
  i64toi32_i32$0 = $32$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$4 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $24 = i64toi32_i32$2;
  $24$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $37$hi;
  i64toi32_i32$5 = $24$hi;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$1 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64(i64toi32_i32$2 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$1 | 0, 1 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $37 = i64toi32_i32$0;
  $37$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $2541$hi;
  i64toi32_i32$5 = $2541;
  i64toi32_i32$0 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $48 = i64toi32_i32$4;
  $48$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$2 = $48$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $2589 = i64toi32_i32$0;
  $2589$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $48$hi;
  $2590 = $48;
  $2590$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $44$hi;
  i64toi32_i32$4 = $19$hi;
  i64toi32_i32$4 = $44$hi;
  i64toi32_i32$2 = $44;
  i64toi32_i32$1 = $19$hi;
  i64toi32_i32$3 = $19;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $2593$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $33$hi;
  i64toi32_i32$0 = $31$hi;
  i64toi32_i32$0 = $33$hi;
  i64toi32_i32$4 = $33;
  i64toi32_i32$2 = $31$hi;
  i64toi32_i32$3 = $31;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $864 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($864 | 0, i64toi32_i32$2 | 0, 1 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $31 = i64toi32_i32$4;
  $31$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $2593$hi;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$3 = $31;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $33 = i64toi32_i32$1;
  $33$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $25$hi;
  i64toi32_i32$5 = $33$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = $25$hi;
  i64toi32_i32$3 = $25;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $2602 = i64toi32_i32$4;
  $2602$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $33$hi;
  i64toi32_i32$1 = $42$hi;
  i64toi32_i32$1 = $33$hi;
  i64toi32_i32$5 = $33;
  i64toi32_i32$2 = $42$hi;
  i64toi32_i32$3 = $42;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $865 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($865 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $33 = i64toi32_i32$5;
  $33$hi = i64toi32_i32$2;
  $2607 = i64toi32_i32$5;
  $2607$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $38$hi;
  i64toi32_i32$2 = $34$hi;
  i64toi32_i32$2 = $38$hi;
  i64toi32_i32$1 = $38;
  i64toi32_i32$5 = $34$hi;
  i64toi32_i32$3 = $34;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $34 = i64toi32_i32$0;
  $34$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $2607$hi;
  i64toi32_i32$2 = $2607;
  i64toi32_i32$1 = $34$hi;
  i64toi32_i32$3 = i64toi32_i32$0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $38 = i64toi32_i32$5;
  $38$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $31$hi;
  i64toi32_i32$0 = $38$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$2 = $31$hi;
  i64toi32_i32$3 = $31;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $866 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($866 | 0, i64toi32_i32$2 | 0, 40 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $31 = i64toi32_i32$4;
  $31$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $2602$hi;
  i64toi32_i32$0 = $2602;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$3 = $31;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $42 = i64toi32_i32$1;
  $42$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $33$hi;
  i64toi32_i32$5 = $42$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = $33$hi;
  i64toi32_i32$3 = $33;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $867 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($867 | 0, i64toi32_i32$0 | 0, 48 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $33 = i64toi32_i32$2;
  $33$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $2590$hi;
  i64toi32_i32$5 = $2590;
  i64toi32_i32$2 = $33$hi;
  i64toi32_i32$3 = $33;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $868 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($868 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $44 = i64toi32_i32$5;
  $44$hi = i64toi32_i32$2;
  $2626 = i64toi32_i32$5;
  $2626$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $39$hi;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$2 = $39$hi;
  i64toi32_i32$0 = $39;
  i64toi32_i32$5 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $2629$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $34$hi;
  i64toi32_i32$1 = $30$hi;
  i64toi32_i32$1 = $34$hi;
  i64toi32_i32$2 = $34;
  i64toi32_i32$0 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $869 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($869 | 0, i64toi32_i32$0 | 0, 1 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $30 = i64toi32_i32$2;
  $30$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $2629$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$2 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $34 = i64toi32_i32$5;
  $34$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $15$hi;
  i64toi32_i32$4 = $34$hi;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$1 = $15$hi;
  i64toi32_i32$3 = $15;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $2638 = i64toi32_i32$2;
  $2638$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $34$hi;
  i64toi32_i32$5 = $23$hi;
  i64toi32_i32$5 = $34$hi;
  i64toi32_i32$4 = $34;
  i64toi32_i32$0 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $870 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($870 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $23 = i64toi32_i32$4;
  $23$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $45$hi;
  i64toi32_i32$0 = $23$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$4 = $45$hi;
  i64toi32_i32$3 = $45;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $34 = i64toi32_i32$1;
  $34$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $30$hi;
  i64toi32_i32$2 = $34$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$5 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $871 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($871 | 0, i64toi32_i32$5 | 0, 40 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $30 = i64toi32_i32$0;
  $30$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $2638$hi;
  i64toi32_i32$2 = $2638;
  i64toi32_i32$0 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $39 = i64toi32_i32$4;
  $39$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $23$hi;
  i64toi32_i32$1 = $39$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$2 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$4 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$2 | 0, 48 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $23 = i64toi32_i32$5;
  $23$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $34$hi;
  i64toi32_i32$2 = $23$hi;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$5 = $34$hi;
  i64toi32_i32$3 = $34;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $34 = i64toi32_i32$0;
  $34$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $2626$hi;
  i64toi32_i32$2 = $2626;
  i64toi32_i32$1 = $34$hi;
  i64toi32_i32$3 = i64toi32_i32$0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $45 = i64toi32_i32$5;
  $45$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $37$hi;
  i64toi32_i32$0 = $45$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$2 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $872 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($872 | 0, i64toi32_i32$2 | 0, 40 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $37 = i64toi32_i32$4;
  $37$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $2589$hi;
  i64toi32_i32$0 = $2589;
  i64toi32_i32$4 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $48 = i64toi32_i32$1;
  $48$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $6$hi;
  i64toi32_i32$5 = $48$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$3 = $6;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $2669 = i64toi32_i32$4;
  $2669$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $42$hi;
  i64toi32_i32$1 = $18$hi;
  i64toi32_i32$1 = $42$hi;
  i64toi32_i32$5 = $42;
  i64toi32_i32$2 = $18$hi;
  i64toi32_i32$3 = $18;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $2672 = i64toi32_i32$0;
  $2672$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $47$hi;
  i64toi32_i32$4 = $43$hi;
  i64toi32_i32$4 = $47$hi;
  i64toi32_i32$1 = $47;
  i64toi32_i32$5 = $43$hi;
  i64toi32_i32$3 = $43;
  i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
  $873 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($873 | 0, i64toi32_i32$5 | 0, 48 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $42 = i64toi32_i32$1;
  $42$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $40$hi;
  i64toi32_i32$5 = $42$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$1 = $40$hi;
  i64toi32_i32$3 = $40;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $40 = i64toi32_i32$2;
  $40$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $41$hi;
  i64toi32_i32$0 = $40$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$4 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$2 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$4 | 0, 1 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $41 = i64toi32_i32$5;
  $41$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $2672$hi;
  i64toi32_i32$0 = $2672;
  i64toi32_i32$5 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $43 = i64toi32_i32$1;
  $43$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$2 = $43$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $2688 = i64toi32_i32$5;
  $2688$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $43$hi;
  i64toi32_i32$1 = $23$hi;
  i64toi32_i32$1 = $43$hi;
  i64toi32_i32$2 = $43;
  i64toi32_i32$4 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $874 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($874 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $23 = i64toi32_i32$2;
  $23$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $24$hi;
  i64toi32_i32$4 = $23$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$2 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $24 = i64toi32_i32$0;
  $24$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $41$hi;
  i64toi32_i32$5 = $24$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$1 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $875 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($875 | 0, i64toi32_i32$1 | 0, 40 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $41 = i64toi32_i32$4;
  $41$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $2688$hi;
  i64toi32_i32$5 = $2688;
  i64toi32_i32$4 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $43 = i64toi32_i32$2;
  $43$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $23$hi;
  i64toi32_i32$0 = $43$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$5 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$5 = i64toi32_i32$0 ^ i64toi32_i32$5 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64(i64toi32_i32$2 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$5 | 0, 48 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $23 = i64toi32_i32$1;
  $23$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $24$hi;
  i64toi32_i32$5 = $23$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$1 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $24 = i64toi32_i32$4;
  $24$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $41$hi;
  i64toi32_i32$2 = $24$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$0 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$4 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$0 | 0, 1 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $41 = i64toi32_i32$5;
  $41$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $2669$hi;
  i64toi32_i32$2 = $2669;
  i64toi32_i32$5 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $47 = i64toi32_i32$1;
  $47$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $19$hi;
  i64toi32_i32$4 = $47$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$2 = $19$hi;
  i64toi32_i32$3 = $19;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $2717 = i64toi32_i32$5;
  $2717$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $47$hi;
  $2718 = $47;
  $2718$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $46$hi;
  i64toi32_i32$1 = $21$hi;
  i64toi32_i32$1 = $46$hi;
  i64toi32_i32$4 = $46;
  i64toi32_i32$0 = $21$hi;
  i64toi32_i32$3 = $21;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $2721$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $34$hi;
  i64toi32_i32$5 = $30$hi;
  i64toi32_i32$5 = $34$hi;
  i64toi32_i32$1 = $34;
  i64toi32_i32$4 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
  $876 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($876 | 0, i64toi32_i32$4 | 0, 1 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $30 = i64toi32_i32$1;
  $30$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $2721$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$1 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $34 = i64toi32_i32$0;
  $34$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $20$hi;
  i64toi32_i32$2 = $34$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$5 = $20$hi;
  i64toi32_i32$3 = $20;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $2730 = i64toi32_i32$1;
  $2730$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $34$hi;
  i64toi32_i32$0 = $42$hi;
  i64toi32_i32$0 = $34$hi;
  i64toi32_i32$2 = $34;
  i64toi32_i32$4 = $42$hi;
  i64toi32_i32$3 = $42;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $878 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($878 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $34 = i64toi32_i32$2;
  $34$hi = i64toi32_i32$4;
  $2735 = i64toi32_i32$2;
  $2735$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $33$hi;
  i64toi32_i32$4 = $38$hi;
  i64toi32_i32$4 = $33$hi;
  i64toi32_i32$0 = $33;
  i64toi32_i32$2 = $38$hi;
  i64toi32_i32$3 = $38;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $33 = i64toi32_i32$5;
  $33$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $2735$hi;
  i64toi32_i32$4 = $2735;
  i64toi32_i32$0 = $33$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $38 = i64toi32_i32$2;
  $38$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $30$hi;
  i64toi32_i32$5 = $38$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$4 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64(i64toi32_i32$2 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$4 | 0, 40 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $30 = i64toi32_i32$1;
  $30$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $2730$hi;
  i64toi32_i32$5 = $2730;
  i64toi32_i32$1 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $42 = i64toi32_i32$0;
  $42$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $34$hi;
  i64toi32_i32$2 = $42$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$5 = $34$hi;
  i64toi32_i32$3 = $34;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $879 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($879 | 0, i64toi32_i32$5 | 0, 48 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $34 = i64toi32_i32$4;
  $34$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $2718$hi;
  i64toi32_i32$2 = $2718;
  i64toi32_i32$4 = $34$hi;
  i64toi32_i32$3 = $34;
  i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
  $881 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($881 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $46 = i64toi32_i32$2;
  $46$hi = i64toi32_i32$4;
  $2754 = i64toi32_i32$2;
  $2754$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $39$hi;
  i64toi32_i32$4 = $29$hi;
  i64toi32_i32$4 = $39$hi;
  i64toi32_i32$5 = $39;
  i64toi32_i32$2 = $29$hi;
  i64toi32_i32$3 = $29;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $2757$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $33$hi;
  i64toi32_i32$0 = $31$hi;
  i64toi32_i32$0 = $33$hi;
  i64toi32_i32$4 = $33;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$3 = $31;
  i64toi32_i32$5 = i64toi32_i32$0 ^ i64toi32_i32$5 | 0;
  $882 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($882 | 0, i64toi32_i32$5 | 0, 1 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $31 = i64toi32_i32$4;
  $31$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $2757$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$3 = $31;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $33 = i64toi32_i32$2;
  $33$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $26$hi;
  i64toi32_i32$1 = $33$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$0 = $26$hi;
  i64toi32_i32$3 = $26;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $2766 = i64toi32_i32$4;
  $2766$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $33$hi;
  i64toi32_i32$2 = $32$hi;
  i64toi32_i32$2 = $33$hi;
  i64toi32_i32$1 = $33;
  i64toi32_i32$5 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $883 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($883 | 0, i64toi32_i32$5 | 0, 32 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $32 = i64toi32_i32$1;
  $32$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $40$hi;
  i64toi32_i32$5 = $32$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$1 = $40$hi;
  i64toi32_i32$3 = $40;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $33 = i64toi32_i32$0;
  $33$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$4 = $33$hi;
  i64toi32_i32$5 = i64toi32_i32$0;
  i64toi32_i32$2 = $31$hi;
  i64toi32_i32$3 = $31;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $884 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($884 | 0, i64toi32_i32$2 | 0, 40 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $31 = i64toi32_i32$5;
  $31$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $2766$hi;
  i64toi32_i32$4 = $2766;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$3 = $31;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $39 = i64toi32_i32$1;
  $39$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $32$hi;
  i64toi32_i32$0 = $39$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$4 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $885 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($885 | 0, i64toi32_i32$4 | 0, 48 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $32 = i64toi32_i32$2;
  $32$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $33$hi;
  i64toi32_i32$4 = $32$hi;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$2 = $33$hi;
  i64toi32_i32$3 = $33;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $33 = i64toi32_i32$5;
  $33$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $2754$hi;
  i64toi32_i32$4 = $2754;
  i64toi32_i32$0 = $33$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $40 = i64toi32_i32$2;
  $40$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $41$hi;
  i64toi32_i32$5 = $40$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$4 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64(i64toi32_i32$2 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$4 | 0, 40 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $41 = i64toi32_i32$1;
  $41$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $2717$hi;
  i64toi32_i32$5 = $2717;
  i64toi32_i32$1 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $47 = i64toi32_i32$0;
  $47$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $25$hi;
  i64toi32_i32$2 = $47$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$5 = $25$hi;
  i64toi32_i32$3 = $25;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $2797 = i64toi32_i32$1;
  $2797$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $42$hi;
  i64toi32_i32$0 = $25$hi;
  i64toi32_i32$0 = $42$hi;
  i64toi32_i32$2 = $42;
  i64toi32_i32$4 = $25$hi;
  i64toi32_i32$3 = $25;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $2800 = i64toi32_i32$5;
  $2800$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $48$hi;
  i64toi32_i32$1 = $44$hi;
  i64toi32_i32$1 = $48$hi;
  i64toi32_i32$0 = $48;
  i64toi32_i32$2 = $44$hi;
  i64toi32_i32$3 = $44;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $886 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($886 | 0, i64toi32_i32$2 | 0, 48 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $25 = i64toi32_i32$0;
  $25$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $45$hi;
  i64toi32_i32$2 = $25$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$0 = $45$hi;
  i64toi32_i32$3 = $45;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $42 = i64toi32_i32$4;
  $42$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $37$hi;
  i64toi32_i32$5 = $42$hi;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$1 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $887 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($887 | 0, i64toi32_i32$1 | 0, 1 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $37 = i64toi32_i32$2;
  $37$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $2800$hi;
  i64toi32_i32$5 = $2800;
  i64toi32_i32$2 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $44 = i64toi32_i32$0;
  $44$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $12$hi;
  i64toi32_i32$4 = $44$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$5 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $2816 = i64toi32_i32$2;
  $2816$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $44$hi;
  i64toi32_i32$0 = $32$hi;
  i64toi32_i32$0 = $44$hi;
  i64toi32_i32$4 = $44;
  i64toi32_i32$1 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
  $888 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($888 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $32 = i64toi32_i32$4;
  $32$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $24$hi;
  i64toi32_i32$1 = $32$hi;
  i64toi32_i32$0 = i64toi32_i32$4;
  i64toi32_i32$4 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $24 = i64toi32_i32$5;
  $24$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $37$hi;
  i64toi32_i32$2 = $24$hi;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$0 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64(i64toi32_i32$5 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$0 | 0, 40 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $37 = i64toi32_i32$1;
  $37$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $2816$hi;
  i64toi32_i32$2 = $2816;
  i64toi32_i32$1 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $44 = i64toi32_i32$4;
  $44$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $32$hi;
  i64toi32_i32$5 = $44$hi;
  i64toi32_i32$0 = i64toi32_i32$4;
  i64toi32_i32$2 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64(i64toi32_i32$4 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$2 | 0, 48 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $32 = i64toi32_i32$0;
  $32$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $24$hi;
  i64toi32_i32$2 = $32$hi;
  i64toi32_i32$5 = i64toi32_i32$0;
  i64toi32_i32$0 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $24 = i64toi32_i32$1;
  $24$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $37$hi;
  i64toi32_i32$4 = $24$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$5 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
  $889 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($889 | 0, i64toi32_i32$5 | 0, 1 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $37 = i64toi32_i32$2;
  $37$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $2797$hi;
  i64toi32_i32$4 = $2797;
  i64toi32_i32$2 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $45 = i64toi32_i32$0;
  $45$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $13$hi;
  i64toi32_i32$1 = $45$hi;
  i64toi32_i32$5 = i64toi32_i32$0;
  i64toi32_i32$4 = $13$hi;
  i64toi32_i32$3 = $13;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $2845 = i64toi32_i32$2;
  $2845$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $39$hi;
  i64toi32_i32$0 = $15$hi;
  i64toi32_i32$0 = $39$hi;
  i64toi32_i32$1 = $39;
  i64toi32_i32$5 = $15$hi;
  i64toi32_i32$3 = $15;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $2848 = i64toi32_i32$4;
  $2848$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $34$hi;
  i64toi32_i32$2 = $38$hi;
  i64toi32_i32$2 = $34$hi;
  i64toi32_i32$0 = $34;
  i64toi32_i32$1 = $38$hi;
  i64toi32_i32$3 = $38;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $34 = i64toi32_i32$5;
  $34$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $30$hi;
  i64toi32_i32$4 = $34$hi;
  i64toi32_i32$2 = i64toi32_i32$5;
  i64toi32_i32$0 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
  $890 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($890 | 0, i64toi32_i32$0 | 0, 1 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $30 = i64toi32_i32$2;
  $30$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $2848$hi;
  i64toi32_i32$4 = $2848;
  i64toi32_i32$2 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $38 = i64toi32_i32$1;
  $38$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $22$hi;
  i64toi32_i32$5 = $38$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$4 = $22$hi;
  i64toi32_i32$3 = $22;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $2860 = i64toi32_i32$2;
  $2860$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $38$hi;
  i64toi32_i32$1 = $23$hi;
  i64toi32_i32$1 = $38$hi;
  i64toi32_i32$5 = $38;
  i64toi32_i32$0 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $891 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($891 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $23 = i64toi32_i32$5;
  $23$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $42$hi;
  i64toi32_i32$0 = $23$hi;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$5 = $42$hi;
  i64toi32_i32$3 = $42;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $38 = i64toi32_i32$4;
  $38$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $30$hi;
  i64toi32_i32$2 = $38$hi;
  i64toi32_i32$0 = i64toi32_i32$4;
  i64toi32_i32$1 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64(i64toi32_i32$4 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$1 | 0, 40 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $30 = i64toi32_i32$0;
  $30$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $2860$hi;
  i64toi32_i32$2 = $2860;
  i64toi32_i32$0 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $39 = i64toi32_i32$5;
  $39$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $23$hi;
  i64toi32_i32$4 = $39$hi;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$2 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64(i64toi32_i32$5 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$2 | 0, 48 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $23 = i64toi32_i32$1;
  $23$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $38$hi;
  i64toi32_i32$2 = $23$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$1 = $38$hi;
  i64toi32_i32$3 = $38;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $38 = i64toi32_i32$0;
  $38$hi = i64toi32_i32$5;
  $2881 = i64toi32_i32$0;
  $2881$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $45$hi;
  $2882 = $45;
  $2882$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $43$hi;
  i64toi32_i32$5 = $13$hi;
  i64toi32_i32$5 = $43$hi;
  i64toi32_i32$2 = $43;
  i64toi32_i32$4 = $13$hi;
  i64toi32_i32$3 = $13;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $2885$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $33$hi;
  i64toi32_i32$0 = $31$hi;
  i64toi32_i32$0 = $33$hi;
  i64toi32_i32$5 = $33;
  i64toi32_i32$2 = $31$hi;
  i64toi32_i32$3 = $31;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $892 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($892 | 0, i64toi32_i32$2 | 0, 1 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $13 = i64toi32_i32$5;
  $13$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $2885$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$5 = $13$hi;
  i64toi32_i32$3 = $13;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $31 = i64toi32_i32$4;
  $31$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $14$hi;
  i64toi32_i32$1 = $31$hi;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$0 = $14$hi;
  i64toi32_i32$3 = $14;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $2894 = i64toi32_i32$5;
  $2894$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$4 = $25$hi;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$1 = $31;
  i64toi32_i32$2 = $25$hi;
  i64toi32_i32$3 = $25;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $893 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($893 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $25 = i64toi32_i32$1;
  $25$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $34$hi;
  i64toi32_i32$2 = $25$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$1 = $34$hi;
  i64toi32_i32$3 = $34;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $31 = i64toi32_i32$0;
  $31$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $13$hi;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$4 = $13$hi;
  i64toi32_i32$3 = $13;
  i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
  $894 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($894 | 0, i64toi32_i32$4 | 0, 40 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $13 = i64toi32_i32$2;
  $13$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $2894$hi;
  i64toi32_i32$5 = $2894;
  i64toi32_i32$2 = $13$hi;
  i64toi32_i32$3 = $13;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $33 = i64toi32_i32$1;
  $33$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $25$hi;
  i64toi32_i32$0 = $33$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$5 = $25$hi;
  i64toi32_i32$3 = $25;
  i64toi32_i32$5 = i64toi32_i32$0 ^ i64toi32_i32$5 | 0;
  $895 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($895 | 0, i64toi32_i32$5 | 0, 48 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $25 = i64toi32_i32$4;
  $25$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $2882$hi;
  i64toi32_i32$0 = $2882;
  i64toi32_i32$4 = $25$hi;
  i64toi32_i32$3 = $25;
  i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
  $897 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($897 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $34 = i64toi32_i32$0;
  $34$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $2881$hi;
  i64toi32_i32$5 = $2881;
  i64toi32_i32$0 = $34$hi;
  i64toi32_i32$3 = $34;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $42 = i64toi32_i32$2;
  $42$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $37$hi;
  i64toi32_i32$1 = $42$hi;
  i64toi32_i32$4 = i64toi32_i32$2;
  i64toi32_i32$5 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64(i64toi32_i32$2 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$5 | 0, 40 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $37 = i64toi32_i32$4;
  $37$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $2845$hi;
  i64toi32_i32$1 = $2845;
  i64toi32_i32$4 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $43 = i64toi32_i32$0;
  $43$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$2 = $43$hi;
  i64toi32_i32$5 = i64toi32_i32$0;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $2925 = i64toi32_i32$4;
  $2925$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $33$hi;
  i64toi32_i32$0 = $29$hi;
  i64toi32_i32$0 = $33$hi;
  i64toi32_i32$2 = $33;
  i64toi32_i32$5 = $29$hi;
  i64toi32_i32$3 = $29;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $2928 = i64toi32_i32$1;
  $2928$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $47$hi;
  i64toi32_i32$4 = $46$hi;
  i64toi32_i32$4 = $47$hi;
  i64toi32_i32$0 = $47;
  i64toi32_i32$2 = $46$hi;
  i64toi32_i32$3 = $46;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $898 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($898 | 0, i64toi32_i32$2 | 0, 48 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $40$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$0 = $40$hi;
  i64toi32_i32$3 = $40;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $29 = i64toi32_i32$5;
  $29$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $41$hi;
  i64toi32_i32$1 = $29$hi;
  i64toi32_i32$2 = i64toi32_i32$5;
  i64toi32_i32$4 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $899 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($899 | 0, i64toi32_i32$4 | 0, 1 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $33 = i64toi32_i32$2;
  $33$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $2928$hi;
  i64toi32_i32$1 = $2928;
  i64toi32_i32$2 = $33$hi;
  i64toi32_i32$3 = $33;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $40 = i64toi32_i32$0;
  $40$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $6$hi;
  i64toi32_i32$5 = $40$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$3 = $6;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $2944 = i64toi32_i32$2;
  $2944$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $40$hi;
  i64toi32_i32$0 = $23$hi;
  i64toi32_i32$0 = $40$hi;
  i64toi32_i32$5 = $40;
  i64toi32_i32$4 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $900 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($900 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $6 = i64toi32_i32$5;
  $6$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $24$hi;
  i64toi32_i32$4 = $6$hi;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$5 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $23 = i64toi32_i32$1;
  $23$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $33$hi;
  i64toi32_i32$2 = $23$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$0 = $33$hi;
  i64toi32_i32$3 = $33;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $901 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($901 | 0, i64toi32_i32$0 | 0, 40 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $24 = i64toi32_i32$4;
  $24$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $2944$hi;
  i64toi32_i32$2 = $2944;
  i64toi32_i32$4 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $33 = i64toi32_i32$5;
  $33$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$1 = $33$hi;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$2 = $6$hi;
  i64toi32_i32$3 = $6;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64(i64toi32_i32$5 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$2 | 0, 48 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $6 = i64toi32_i32$0;
  $6$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $23$hi;
  i64toi32_i32$2 = $6$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$0 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $23 = i64toi32_i32$4;
  $23$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $24$hi;
  i64toi32_i32$5 = $23$hi;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$1 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $902 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($902 | 0, i64toi32_i32$1 | 0, 1 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $24 = i64toi32_i32$2;
  $24$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $2925$hi;
  i64toi32_i32$5 = $2925;
  i64toi32_i32$2 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $40 = i64toi32_i32$0;
  $40$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $15$hi;
  i64toi32_i32$4 = $40$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$5 = $15$hi;
  i64toi32_i32$3 = $15;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $2973 = i64toi32_i32$2;
  $2973$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $44$hi;
  i64toi32_i32$0 = $22$hi;
  i64toi32_i32$0 = $44$hi;
  i64toi32_i32$4 = $44;
  i64toi32_i32$1 = $22$hi;
  i64toi32_i32$3 = $22;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $2976$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $38$hi;
  i64toi32_i32$2 = $30$hi;
  i64toi32_i32$2 = $38$hi;
  i64toi32_i32$0 = $38;
  i64toi32_i32$4 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  $903 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($903 | 0, i64toi32_i32$4 | 0, 1 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $15 = i64toi32_i32$0;
  $15$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $2976$hi;
  i64toi32_i32$2 = i64toi32_i32$5;
  i64toi32_i32$0 = $15$hi;
  i64toi32_i32$3 = $15;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $22 = i64toi32_i32$1;
  $22$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $21$hi;
  i64toi32_i32$5 = $22$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$2 = $21$hi;
  i64toi32_i32$3 = $21;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $2985 = i64toi32_i32$0;
  $2985$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $22$hi;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$1 = $22$hi;
  i64toi32_i32$5 = $22;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $904 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($904 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $7 = i64toi32_i32$5;
  $7$hi = i64toi32_i32$4;
  $2990 = i64toi32_i32$5;
  $2990$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $25$hi;
  i64toi32_i32$4 = $31$hi;
  i64toi32_i32$4 = $25$hi;
  i64toi32_i32$1 = $25;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$3 = $31;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $21 = i64toi32_i32$2;
  $21$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $2990$hi;
  i64toi32_i32$4 = $2990;
  i64toi32_i32$1 = $21$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $25 = i64toi32_i32$5;
  $25$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $15$hi;
  i64toi32_i32$2 = $25$hi;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$4 = $15$hi;
  i64toi32_i32$3 = $15;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64(i64toi32_i32$5 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$4 | 0, 40 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $15 = i64toi32_i32$0;
  $15$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $2985$hi;
  i64toi32_i32$2 = $2985;
  i64toi32_i32$0 = $15$hi;
  i64toi32_i32$3 = $15;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $22 = i64toi32_i32$1;
  $22$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$5 = $22$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  $905 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($905 | 0, i64toi32_i32$2 | 0, 48 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $7 = i64toi32_i32$4;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $40$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$4 = $40$hi;
  i64toi32_i32$3 = $40;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  $906 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($906 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $30 = i64toi32_i32$5;
  $30$hi = i64toi32_i32$4;
  $3010 = i64toi32_i32$5;
  $3010$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $39$hi;
  i64toi32_i32$4 = $19$hi;
  i64toi32_i32$4 = $39$hi;
  i64toi32_i32$2 = $39;
  i64toi32_i32$5 = $19$hi;
  i64toi32_i32$3 = $19;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $3013$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $21$hi;
  i64toi32_i32$1 = $13$hi;
  i64toi32_i32$1 = $21$hi;
  i64toi32_i32$4 = $21;
  i64toi32_i32$2 = $13$hi;
  i64toi32_i32$3 = $13;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $907 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($907 | 0, i64toi32_i32$2 | 0, 1 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $19 = i64toi32_i32$4;
  $19$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $3013$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$4 = $19$hi;
  i64toi32_i32$3 = $19;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $21 = i64toi32_i32$5;
  $21$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$0 = $21$hi;
  i64toi32_i32$2 = i64toi32_i32$5;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $3022 = i64toi32_i32$4;
  $3022$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $21$hi;
  i64toi32_i32$5 = $32$hi;
  i64toi32_i32$5 = $21$hi;
  i64toi32_i32$0 = $21;
  i64toi32_i32$2 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  $908 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($908 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $21 = i64toi32_i32$0;
  $21$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $29$hi;
  i64toi32_i32$2 = $21$hi;
  i64toi32_i32$5 = i64toi32_i32$0;
  i64toi32_i32$0 = $29$hi;
  i64toi32_i32$3 = $29;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $29 = i64toi32_i32$1;
  $29$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $19$hi;
  i64toi32_i32$4 = $29$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$5 = $19$hi;
  i64toi32_i32$3 = $19;
  i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
  $909 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($909 | 0, i64toi32_i32$5 | 0, 40 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $19 = i64toi32_i32$2;
  $19$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $3022$hi;
  i64toi32_i32$4 = $3022;
  i64toi32_i32$2 = $19$hi;
  i64toi32_i32$3 = $19;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $12 = i64toi32_i32$0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $21$hi;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$5 = i64toi32_i32$0;
  i64toi32_i32$4 = $21$hi;
  i64toi32_i32$3 = $21;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $910 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($910 | 0, i64toi32_i32$4 | 0, 48 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $21 = i64toi32_i32$5;
  $21$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $29$hi;
  i64toi32_i32$4 = $21$hi;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$5 = $29$hi;
  i64toi32_i32$3 = $29;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $29 = i64toi32_i32$2;
  $29$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $3010$hi;
  i64toi32_i32$4 = $3010;
  i64toi32_i32$1 = $29$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $13 = i64toi32_i32$5;
  $13$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $24$hi;
  i64toi32_i32$2 = $13$hi;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$4 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64(i64toi32_i32$5 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$4 | 0, 40 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $24 = i64toi32_i32$0;
  $24$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $2973$hi;
  i64toi32_i32$2 = $2973;
  i64toi32_i32$0 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $31 = i64toi32_i32$1;
  $31$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  $3053 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  $3053$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$2 = $14$hi;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$5 = $12;
  i64toi32_i32$4 = $14$hi;
  i64toi32_i32$3 = $14;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $3056 = i64toi32_i32$0;
  $3056$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$1 = $25$hi;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$2 = $7;
  i64toi32_i32$5 = $25$hi;
  i64toi32_i32$3 = $25;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $7 = i64toi32_i32$4;
  $7$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $15$hi;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$2 = $15$hi;
  i64toi32_i32$3 = $15;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64(i64toi32_i32$4 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$2 | 0, 1 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $25 = i64toi32_i32$1;
  $25$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $3056$hi;
  i64toi32_i32$0 = $3056;
  i64toi32_i32$1 = $25$hi;
  i64toi32_i32$3 = $25;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $12 = i64toi32_i32$5;
  $12$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $20$hi;
  i64toi32_i32$4 = $12$hi;
  i64toi32_i32$2 = i64toi32_i32$5;
  i64toi32_i32$0 = $20$hi;
  i64toi32_i32$3 = $20;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $3068 = i64toi32_i32$1;
  $3068$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $12$hi;
  i64toi32_i32$5 = $6$hi;
  i64toi32_i32$5 = $12$hi;
  i64toi32_i32$4 = $12;
  i64toi32_i32$2 = $6$hi;
  i64toi32_i32$3 = $6;
  i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  $911 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($911 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $6 = i64toi32_i32$4;
  $6$hi = i64toi32_i32$2;
  $3073 = i64toi32_i32$4;
  $3073$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $43$hi;
  i64toi32_i32$2 = $34$hi;
  i64toi32_i32$2 = $43$hi;
  i64toi32_i32$5 = $43;
  i64toi32_i32$4 = $34$hi;
  i64toi32_i32$3 = $34;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  $912 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($912 | 0, i64toi32_i32$4 | 0, 48 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $20 = i64toi32_i32$5;
  $20$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $42$hi;
  i64toi32_i32$4 = $20$hi;
  i64toi32_i32$2 = i64toi32_i32$5;
  i64toi32_i32$5 = $42$hi;
  i64toi32_i32$3 = $42;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $12 = i64toi32_i32$0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $3073$hi;
  i64toi32_i32$4 = $3073;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$3 = i64toi32_i32$0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $14 = i64toi32_i32$5;
  $14$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $25$hi;
  i64toi32_i32$0 = $14$hi;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$4 = $25$hi;
  i64toi32_i32$3 = $25;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64(i64toi32_i32$5 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$4 | 0, 40 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $25 = i64toi32_i32$1;
  $25$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $3068$hi;
  i64toi32_i32$0 = $3068;
  i64toi32_i32$1 = $25$hi;
  i64toi32_i32$3 = $25;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $15 = i64toi32_i32$2;
  $15$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $6$hi;
  i64toi32_i32$5 = $15$hi;
  i64toi32_i32$4 = i64toi32_i32$2;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$3 = $6;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64(i64toi32_i32$2 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$0 | 0, 48 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $6 = i64toi32_i32$4;
  $6$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $14$hi;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$4 = $14$hi;
  i64toi32_i32$3 = $14;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $14 = i64toi32_i32$1;
  $14$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $3053$hi;
  i64toi32_i32$0 = $3053;
  i64toi32_i32$5 = $14$hi;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $3097 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $54;
  HEAP32[i64toi32_i32$0 >> 2] = $3097;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$5;
  $3098 = $0;
  i64toi32_i32$5 = $36$hi;
  $3099 = $36;
  $3099$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$5 = $30$hi;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$2 = $31;
  i64toi32_i32$0 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $913 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($913 | 0, i64toi32_i32$0 | 0, 48 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $9 = i64toi32_i32$2;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $13$hi;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $13$hi;
  i64toi32_i32$3 = $13;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $13 = i64toi32_i32$4;
  $13$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $3099$hi;
  i64toi32_i32$0 = $3099;
  i64toi32_i32$5 = $13$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
  $3108$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $15$hi;
  i64toi32_i32$5 = $3108$hi;
  i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  i64toi32_i32$0 = $15$hi;
  i64toi32_i32$3 = $15;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $3110 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $3098;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $3110;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $27$hi;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$5 = $9;
  i64toi32_i32$1 = $27$hi;
  i64toi32_i32$3 = $27;
  i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
  $3114 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $3114$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $14$hi;
  i64toi32_i32$1 = $25$hi;
  i64toi32_i32$1 = $14$hi;
  i64toi32_i32$0 = $14;
  i64toi32_i32$5 = $25$hi;
  i64toi32_i32$3 = $25;
  i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
  $914 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($914 | 0, i64toi32_i32$5 | 0, 1 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $3118 = i64toi32_i32$0;
  $3118$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $3114$hi;
  i64toi32_i32$1 = $3114;
  i64toi32_i32$0 = $3118$hi;
  i64toi32_i32$3 = $3118;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $3119 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $0;
  HEAP32[(i64toi32_i32$1 + 56 | 0) >> 2] = $3119;
  HEAP32[(i64toi32_i32$1 + 60 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $16$hi;
  i64toi32_i32$0 = $13$hi;
  i64toi32_i32$0 = $24$hi;
  i64toi32_i32$0 = $13$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$1 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$4 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$1 | 0, 1 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $3125 = i64toi32_i32$5;
  $3125$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $16$hi;
  i64toi32_i32$0 = $16;
  i64toi32_i32$5 = $3125$hi;
  i64toi32_i32$3 = $3125;
  i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
  $3126$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $6$hi;
  i64toi32_i32$5 = $3126$hi;
  i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$3 = $6;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $3128 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $0;
  HEAP32[(i64toi32_i32$1 + 40 | 0) >> 2] = $3128;
  HEAP32[(i64toi32_i32$1 + 44 | 0) >> 2] = i64toi32_i32$0;
  $3129 = i64toi32_i32$1;
  i64toi32_i32$0 = $28$hi;
  $3130 = $28;
  $3130$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  $3131 = $11;
  $3131$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $26$hi;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$0 = $37$hi;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$5 = $12;
  i64toi32_i32$1 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
  $915 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($915 | 0, i64toi32_i32$1 | 0, 1 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $6 = i64toi32_i32$5;
  $6$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $26$hi;
  i64toi32_i32$0 = $26;
  i64toi32_i32$5 = $6$hi;
  i64toi32_i32$3 = $6;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $3138$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $22$hi;
  i64toi32_i32$4 = $3138$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$0 = $22$hi;
  i64toi32_i32$3 = $22;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $26 = i64toi32_i32$5;
  $26$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $3131$hi;
  i64toi32_i32$4 = $3131;
  i64toi32_i32$1 = $26$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $3142 = i64toi32_i32$0;
  $3142$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $26$hi;
  i64toi32_i32$5 = $21$hi;
  i64toi32_i32$5 = $26$hi;
  i64toi32_i32$2 = $26;
  i64toi32_i32$4 = $21$hi;
  i64toi32_i32$3 = $21;
  i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
  $916 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($916 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $11 = i64toi32_i32$2;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $23$hi;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $21 = i64toi32_i32$1;
  $21$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$0 = $21$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$5 = $6$hi;
  i64toi32_i32$3 = $6;
  i64toi32_i32$5 = i64toi32_i32$0 ^ i64toi32_i32$5 | 0;
  $917 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($917 | 0, i64toi32_i32$5 | 0, 40 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $6 = i64toi32_i32$4;
  $6$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $3142$hi;
  i64toi32_i32$0 = $3142;
  i64toi32_i32$4 = $6$hi;
  i64toi32_i32$3 = $6;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $26 = i64toi32_i32$2;
  $26$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $3130$hi;
  i64toi32_i32$5 = $3130;
  i64toi32_i32$0 = $26$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $3157 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  $3157$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $18$hi;
  $3158 = $18;
  $3158$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $33$hi;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$0 = $33$hi;
  i64toi32_i32$1 = $33;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$3 = $10;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $3161$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $29$hi;
  i64toi32_i32$2 = $19$hi;
  i64toi32_i32$2 = $29$hi;
  i64toi32_i32$0 = $29;
  i64toi32_i32$1 = $19$hi;
  i64toi32_i32$3 = $19;
  i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
  $918 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($918 | 0, i64toi32_i32$1 | 0, 1 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $3161$hi;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$3 = $10;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $19 = i64toi32_i32$5;
  $19$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $3158$hi;
  i64toi32_i32$1 = $3158;
  i64toi32_i32$2 = $19$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $3169 = i64toi32_i32$0;
  $3169$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $19$hi;
  i64toi32_i32$5 = $20$hi;
  i64toi32_i32$5 = $19$hi;
  i64toi32_i32$4 = $19;
  i64toi32_i32$1 = $20$hi;
  i64toi32_i32$3 = $20;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $919 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($919 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $18 = i64toi32_i32$4;
  $18$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$1 = $18$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $7 = i64toi32_i32$2;
  $7$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$3 = $10;
  i64toi32_i32$5 = i64toi32_i32$0 ^ i64toi32_i32$5 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64(i64toi32_i32$2 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$5 | 0, 40 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $10 = i64toi32_i32$1;
  $10$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $3169$hi;
  i64toi32_i32$0 = $3169;
  i64toi32_i32$1 = $10$hi;
  i64toi32_i32$3 = $10;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $19 = i64toi32_i32$4;
  $19$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $18$hi;
  i64toi32_i32$2 = $19$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$0 = $18$hi;
  i64toi32_i32$3 = $18;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$4 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$0 | 0, 48 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $18 = i64toi32_i32$5;
  $18$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$0 = $18$hi;
  i64toi32_i32$2 = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $7 = i64toi32_i32$1;
  $7$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $3157$hi;
  i64toi32_i32$0 = $3157;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $3191 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $3129;
  HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = $3191;
  HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $35$hi;
  i64toi32_i32$2 = $26$hi;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$2 = $26$hi;
  i64toi32_i32$4 = $26;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $920 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($920 | 0, i64toi32_i32$0 | 0, 48 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $11 = i64toi32_i32$4;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $35$hi;
  i64toi32_i32$2 = $35;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $3199 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $3199$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$4 = $10$hi;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$3 = $10;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $921 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($921 | 0, i64toi32_i32$2 | 0, 1 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $3203 = i64toi32_i32$0;
  $3203$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $3199$hi;
  i64toi32_i32$4 = $3199;
  i64toi32_i32$0 = $3203$hi;
  i64toi32_i32$3 = $3203;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $3204 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = $0;
  HEAP32[(i64toi32_i32$4 + 48 | 0) >> 2] = $3204;
  HEAP32[(i64toi32_i32$4 + 52 | 0) >> 2] = i64toi32_i32$0;
  $3205 = i64toi32_i32$4;
  i64toi32_i32$0 = $19$hi;
  i64toi32_i32$0 = $17$hi;
  i64toi32_i32$0 = $19$hi;
  i64toi32_i32$2 = $19;
  i64toi32_i32$4 = $17$hi;
  i64toi32_i32$3 = $17;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $3208 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $3208$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$4 = $21$hi;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$0 = $11;
  i64toi32_i32$2 = $21$hi;
  i64toi32_i32$3 = $21;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $7 = i64toi32_i32$5;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $3208$hi;
  i64toi32_i32$4 = $3208;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $3213 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
  i64toi32_i32$4 = $3205;
  HEAP32[(i64toi32_i32$4 + 8 | 0) >> 2] = $3213;
  HEAP32[(i64toi32_i32$4 + 12 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $18$hi;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$0 = $18$hi;
  i64toi32_i32$1 = $18;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $3217 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $3217$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$4 = $6$hi;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$3 = $6;
  i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64(i64toi32_i32$5 ^ i64toi32_i32$3 | 0 | 0, i64toi32_i32$1 | 0, 1 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $3221 = i64toi32_i32$0;
  $3221$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $3217$hi;
  i64toi32_i32$4 = $3217;
  i64toi32_i32$0 = $3221$hi;
  i64toi32_i32$3 = $3221;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $3222 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = $0;
  HEAP32[(i64toi32_i32$4 + 32 | 0) >> 2] = $3222;
  HEAP32[(i64toi32_i32$4 + 36 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $3 + 128 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__TransactionWitnessSet___deserialize__h9deaf1b9ab40fbb6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, i64toi32_i32$5 = 0, i64toi32_i32$1 = 0, $7 = 0, $15 = 0, $17 = 0, $16 = 0, $6 = 0, $22 = 0, $5 = 0, $22$hi = 0, $23$hi = 0, $21$hi = 0, $13 = 0, $23 = 0, $21 = 0, $24 = 0, $24$hi = 0, $19 = 0, $18 = 0, $26 = 0, $26$hi = 0, $25 = 0, $25$hi = 0, $14 = 0, $3 = 0, $129 = 0, $130 = 0, $131 = 0, $132 = 0, $133 = 0, $134 = 0, $135 = 0, $136 = 0, $137 = 0, $138 = 0, $139 = 0, $140 = 0, $141 = 0, $142 = 0, $143 = 0, $144 = 0, $145 = 0, $146 = 0, $147 = 0, $148 = 0, $149 = 0, $150 = 0, $151 = 0, $152 = 0, $153 = 0, $154 = 0, $155 = 0, $156 = 0, $157 = 0, $158 = 0, $159 = 0, $160 = 0, $161 = 0, $162 = 0, $164 = 0, $165 = 0, $166 = 0, $167 = 0, $168 = 0, $169 = 0, $170 = 0, $171 = 0, $172 = 0, $173 = 0, $174 = 0, $175 = 0, $176 = 0, $177 = 0, $178 = 0, $179 = 0, $180 = 0, $181 = 0, $182 = 0, $183 = 0, $184 = 0, $185 = 0, $186 = 0, $187 = 0, $188 = 0, $189 = 0, $190 = 0, $192 = 0, $193 = 0, $194 = 0, $195 = 0, $196 = 0, $4 = 0, $8 = 0, $9 = 0, $10 = 0, $11 = 0, $12 = 0, $197 = 0, $198 = 0, $199 = 0, $20 = 0, $200 = 0, $201 = 0, $202 = 0, $203 = 0, $204 = 0, $205 = 0, $206 = 0, $207 = 0, $208 = 0, $209 = 0, $163 = 0, $191 = 0, $325 = 0, $332 = 0, $350 = 0, $354 = 0, $371 = 0, $376 = 0, $390 = 0, $393 = 0, $406 = 0, $411 = 0, $418 = 0, $425 = 0, $463 = 0, $582 = 0, $589 = 0, $607 = 0, $611 = 0, $626 = 0, $631 = 0, $645 = 0, $648 = 0, $656 = 0, $667 = 0, $672 = 0, $679 = 0, $686 = 0, $724 = 0, $786 = 0, $793 = 0, $811 = 0, $815 = 0, $832 = 0, $837 = 0, $851 = 0, $854 = 0, $867 = 0, $872 = 0, $879 = 0, $886 = 0, $924 = 0, $988 = 0, $995 = 0, $1013 = 0, $1017 = 0, $1034 = 0, $1039 = 0, $1053 = 0, $1056 = 0, $1069 = 0, $1074 = 0, $1081 = 0, $1088 = 0, $1126 = 0, $1190 = 0, $1197 = 0, $1215 = 0, $1219 = 0, $1236 = 0, $1241 = 0, $1255 = 0, $1258 = 0, $1271 = 0, $1276 = 0, $1283 = 0, $1290 = 0, $1328 = 0, $1392 = 0, $1399 = 0, $1417 = 0, $1421 = 0, $1438 = 0, $1443 = 0, $1457 = 0, $1460 = 0, $1473 = 0, $1478 = 0, $1485 = 0, $1492 = 0, $1530 = 0, $1926 = 0, $1962 = 0, $1964 = 0, $1965 = 0, $1965$hi = 0, $1967$hi = 0, $1968 = 0, $1975 = 0, $2008 = 0;
  $2 = global$0 - 384 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___map__h7c2a4e830d885a05($2 + 312 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2 + 328 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$0;
  $21$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 320 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 324 | 0) >> 2] | 0;
  $22 = i64toi32_i32$1;
  $22$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          i64toi32_i32$2 = $2;
          i64toi32_i32$0 = HEAP32[($2 + 312 | 0) >> 2] | 0;
          i64toi32_i32$1 = HEAP32[($2 + 316 | 0) >> 2] | 0;
          i64toi32_i32$2 = i64toi32_i32$0;
          i64toi32_i32$0 = 0;
          i64toi32_i32$3 = 1;
          if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
           break label$8
          }
          HEAP32[($2 + 24 | 0) >> 2] = 0;
          HEAP32[($2 + 40 | 0) >> 2] = 0;
          HEAP32[($2 + 56 | 0) >> 2] = 0;
          HEAP32[($2 + 72 | 0) >> 2] = 0;
          HEAP8[($2 + 100 | 0) >> 0] = 3;
          HEAP32[($2 + 104 | 0) >> 2] = 0;
          i64toi32_i32$2 = $21$hi;
          $3 = $21;
          label$9 : {
           i64toi32_i32$2 = $22$hi;
           i64toi32_i32$3 = $22;
           i64toi32_i32$1 = 0;
           i64toi32_i32$0 = 1;
           if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
            break label$9
           }
           i64toi32_i32$3 = 0;
           $23 = 0;
           $23$hi = i64toi32_i32$3;
           if (!$3) {
            break label$5
           }
          }
          $4 = $2 + 24 | 0 | 6 | 0;
          $5 = $2 + 154 | 0;
          $6 = ($2 + 144 | 0) + 9 | 0;
          $7 = ($2 + 312 | 0) + 9 | 0;
          $8 = $2 + 40 | 0 | 6 | 0;
          $9 = $2 + 56 | 0 | 6 | 0;
          $10 = $2 + 72 | 0 | 6 | 0;
          $11 = $2 + 88 | 0 | 6 | 0;
          $12 = $2 + 104 | 0 | 6 | 0;
          $13 = 8;
          $14 = ($2 + 144 | 0) + 8 | 0;
          i64toi32_i32$3 = 0;
          $24 = 0;
          $24$hi = i64toi32_i32$3;
          $15 = 1;
          i64toi32_i32$3 = 0;
          $23 = 0;
          $23$hi = i64toi32_i32$3;
          label$10 : while (1) {
           $16 = $15;
           std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 16 | 0 | 0, $1 | 0);
           label$11 : {
            if (HEAP32[($2 + 20 | 0) >> 2] | 0) {
             break label$11
            }
            $16 = 2;
            $6 = 0;
            $17 = 0;
            break label$4;
           }
           label$12 : {
            $15 = ($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[($2 + 16 | 0) >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0;
            if (!$15) {
             break label$12
            }
            $16 = 17;
            $17 = 0;
            $6 = 0;
            label$13 : {
             switch ($15 + -3 | 0 | 0) {
             case 4:
              label$15 : {
               i64toi32_i32$3 = $22$hi;
               i64toi32_i32$0 = $22;
               i64toi32_i32$2 = 0;
               i64toi32_i32$1 = 1;
               if ((i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$3 | 0) != (i64toi32_i32$2 | 0) | 0) {
                break label$15
               }
               $16 = 1;
               break label$4;
              }
              cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 312 | 0 | 0, $1 | 0);
              $1 = HEAPU8[($2 + 320 | 0) >> 0] | 0;
              label$16 : {
               i64toi32_i32$1 = $2;
               i64toi32_i32$0 = HEAP32[($2 + 312 | 0) >> 2] | 0;
               i64toi32_i32$3 = HEAP32[($2 + 316 | 0) >> 2] | 0;
               i64toi32_i32$1 = i64toi32_i32$0;
               i64toi32_i32$0 = 0;
               i64toi32_i32$2 = 1;
               if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) | 0) {
                break label$16
               }
               $16 = 5;
               if (($1 | 0) == (5 | 0)) {
                break label$5
               }
               break label$4;
              }
              $15 = HEAP32[($2 + 352 | 0) >> 2] | 0;
              HEAP32[(($2 + 144 | 0) + 8 | 0) >> 2] = $15;
              HEAP32[(($2 + 280 | 0) + 8 | 0) >> 2] = $15;
              i64toi32_i32$2 = $2 + 344 | 0;
              i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
              i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
              $22 = i64toi32_i32$1;
              $22$hi = i64toi32_i32$3;
              i64toi32_i32$1 = $2;
              HEAP32[($2 + 144 | 0) >> 2] = $22;
              HEAP32[($2 + 148 | 0) >> 2] = i64toi32_i32$3;
              i64toi32_i32$1 = $2;
              HEAP32[($2 + 280 | 0) >> 2] = $22;
              HEAP32[($2 + 284 | 0) >> 2] = i64toi32_i32$3;
              $13 = (HEAPU8[($2 + 321 | 0) >> 0] | 0 | ((HEAPU8[($2 + 322 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 323 | 0) >> 0] | 0) << 16 | 0) | 0) << 8 | 0 | $1 | 0;
              i64toi32_i32$2 = $2 + 336 | 0;
              i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
              i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
              $23 = i64toi32_i32$3;
              $23$hi = i64toi32_i32$1;
              i64toi32_i32$2 = ($2 + 312 | 0) + 16 | 0;
              i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
              i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
              $24 = i64toi32_i32$1;
              $24$hi = i64toi32_i32$3;
              $7 = HEAP32[($2 + 356 | 0) >> 2] | 0;
              $6 = HEAP32[($2 + 324 | 0) >> 2] | 0;
              $16 = 2;
              break label$4;
             case 0:
              break label$13;
             default:
              break label$4;
             };
            }
            cbor_event__de__Deserializer_R___text__h764f26557f652908($2 + 312 | 0 | 0, $1 | 0);
            label$17 : {
             if ((HEAP32[($2 + 312 | 0) >> 2] | 0 | 0) == (1 | 0)) {
              break label$17
             }
             HEAP32[($2 + 144 | 0) >> 2] = HEAP32[($2 + 316 | 0) >> 2] | 0;
             i64toi32_i32$2 = ($2 + 312 | 0) + 8 | 0;
             i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
             i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
             $163 = i64toi32_i32$3;
             i64toi32_i32$3 = $2;
             HEAP32[($2 + 148 | 0) >> 2] = $163;
             HEAP32[($2 + 152 | 0) >> 2] = i64toi32_i32$1;
             $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $2 + 144 | 0 | 0);
             $1 = $2 + 324 | 0;
             alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($1 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
             HEAP16[($2 + 236 | 0) >> 1] = HEAPU16[($2 + 318 | 0) >> 1] | 0;
             HEAP32[(($2 + 280 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 352 | 0) >> 2] | 0;
             HEAP32[($2 + 232 | 0) >> 2] = HEAPU16[($2 + 314 | 0) >> 1] | 0 | ((HEAPU16[($2 + 316 | 0) >> 1] | 0) << 16 | 0) | 0;
             i64toi32_i32$2 = $2 + 344 | 0;
             i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
             i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
             $191 = i64toi32_i32$1;
             i64toi32_i32$1 = $2;
             HEAP32[($2 + 280 | 0) >> 2] = $191;
             HEAP32[($2 + 284 | 0) >> 2] = i64toi32_i32$3;
             $6 = HEAP32[$1 >> 2] | 0;
             $16 = 16;
             i64toi32_i32$2 = ($2 + 312 | 0) + 16 | 0;
             i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
             i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
             $24 = i64toi32_i32$3;
             $24$hi = i64toi32_i32$1;
             i64toi32_i32$2 = $2 + 336 | 0;
             i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
             i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
             $23 = i64toi32_i32$1;
             $23$hi = i64toi32_i32$3;
             $7 = HEAP32[($2 + 356 | 0) >> 2] | 0;
             $15 = HEAPU8[($2 + 313 | 0) >> 0] | 0;
             $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 144 | 0 | 0);
             $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 144 | 0 | 0);
             $13 = 0;
             break label$4;
            }
            $1 = HEAP32[($2 + 352 | 0) >> 2] | 0;
            HEAP32[(($2 + 144 | 0) + 8 | 0) >> 2] = $1;
            HEAP32[(($2 + 280 | 0) + 8 | 0) >> 2] = $1;
            i64toi32_i32$2 = $2 + 344 | 0;
            i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
            i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
            $22 = i64toi32_i32$3;
            $22$hi = i64toi32_i32$1;
            i64toi32_i32$3 = $2;
            HEAP32[($2 + 144 | 0) >> 2] = $22;
            HEAP32[($2 + 148 | 0) >> 2] = i64toi32_i32$1;
            i64toi32_i32$3 = $2;
            HEAP32[($2 + 280 | 0) >> 2] = $22;
            HEAP32[($2 + 284 | 0) >> 2] = i64toi32_i32$1;
            $6 = HEAP32[($2 + 324 | 0) >> 2] | 0;
            $13 = HEAP32[(($2 + 312 | 0) + 8 | 0) >> 2] | 0;
            i64toi32_i32$2 = $2 + 336 | 0;
            i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
            i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
            $23 = i64toi32_i32$1;
            $23$hi = i64toi32_i32$3;
            i64toi32_i32$2 = $2 + 328 | 0;
            i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
            i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
            $24 = i64toi32_i32$3;
            $24$hi = i64toi32_i32$1;
            $7 = HEAP32[($2 + 356 | 0) >> 2] | 0;
            $16 = 2;
            break label$4;
           }
           cbor_event__de__Deserializer_R___unsigned_integer__h1ed99c0b7fe7eea1($2 + 312 | 0 | 0, $1 | 0);
           i64toi32_i32$2 = $2;
           i64toi32_i32$1 = HEAP32[($2 + 320 | 0) >> 2] | 0;
           i64toi32_i32$3 = HEAP32[($2 + 324 | 0) >> 2] | 0;
           $25 = i64toi32_i32$1;
           $25$hi = i64toi32_i32$3;
           label$18 : {
            label$19 : {
             label$20 : {
              label$21 : {
               label$22 : {
                label$23 : {
                 label$24 : {
                  label$25 : {
                   label$26 : {
                    label$27 : {
                     label$28 : {
                      label$29 : {
                       label$30 : {
                        label$31 : {
                         label$32 : {
                          label$33 : {
                           label$34 : {
                            label$35 : {
                             i64toi32_i32$2 = $2;
                             i64toi32_i32$3 = HEAP32[($2 + 312 | 0) >> 2] | 0;
                             i64toi32_i32$1 = HEAP32[($2 + 316 | 0) >> 2] | 0;
                             i64toi32_i32$2 = i64toi32_i32$3;
                             i64toi32_i32$3 = 0;
                             i64toi32_i32$0 = 1;
                             if ((i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) | 0) {
                              break label$35
                             }
                             $17 = 0;
                             label$36 : {
                              i64toi32_i32$2 = $25$hi;
                              i64toi32_i32$0 = $25;
                              i64toi32_i32$1 = 0;
                              i64toi32_i32$3 = 5;
                              if (i64toi32_i32$2 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$0 >>> 0 <= i64toi32_i32$3 >>> 0 | 0) | 0) {
                               break label$36
                              }
                              $16 = 16;
                              i64toi32_i32$0 = $25$hi;
                              $24 = $25;
                              $24$hi = i64toi32_i32$0;
                              break label$6;
                             }
                             i64toi32_i32$0 = $25$hi;
                             switch ($25 | 0) {
                             case 5:
                              break label$29;
                             case 4:
                              break label$30;
                             case 3:
                              break label$31;
                             case 2:
                              break label$32;
                             case 1:
                              break label$33;
                             default:
                              break label$34;
                             };
                            }
                            i64toi32_i32$3 = $2 + 352 | 0;
                            i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                            i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                            $22 = i64toi32_i32$0;
                            $22$hi = i64toi32_i32$2;
                            i64toi32_i32$0 = ($2 + 120 | 0) + 8 | 0;
                            HEAP32[i64toi32_i32$0 >> 2] = $22;
                            HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
                            HEAP32[(($2 + 280 | 0) + 8 | 0) >> 2] = $22;
                            i64toi32_i32$3 = $2 + 344 | 0;
                            i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                            i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                            $22 = i64toi32_i32$2;
                            $22$hi = i64toi32_i32$0;
                            i64toi32_i32$2 = $2;
                            HEAP32[($2 + 120 | 0) >> 2] = $22;
                            HEAP32[($2 + 124 | 0) >> 2] = i64toi32_i32$0;
                            i64toi32_i32$2 = $2;
                            HEAP32[($2 + 280 | 0) >> 2] = $22;
                            HEAP32[($2 + 284 | 0) >> 2] = i64toi32_i32$0;
                            i64toi32_i32$0 = $25$hi;
                            i64toi32_i32$3 = $25;
                            i64toi32_i32$2 = 0;
                            i64toi32_i32$1 = 32;
                            i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
                            if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                             i64toi32_i32$2 = 0;
                             $197 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
                            } else {
                             i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
                             $197 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$4 | 0) | 0;
                            }
                            $6 = $197;
                            i64toi32_i32$0 = $2 + 336 | 0;
                            i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                            i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                            $23 = i64toi32_i32$2;
                            $23$hi = i64toi32_i32$3;
                            i64toi32_i32$0 = $2 + 328 | 0;
                            i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                            i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                            $24 = i64toi32_i32$3;
                            $24$hi = i64toi32_i32$2;
                            i64toi32_i32$2 = $25$hi;
                            $13 = $25;
                            $16 = 2;
                            $17 = 0;
                            $7 = HEAP32[($2 + 132 | 0) >> 2] | 0;
                            break label$4;
                           }
                           if (!(HEAP32[($2 + 24 | 0) >> 2] | 0)) {
                            break label$24
                           }
                           $16 = 4;
                           i64toi32_i32$2 = 0;
                           $24 = 0;
                           $24$hi = i64toi32_i32$2;
                           break label$7;
                          }
                          if (!(HEAP32[($2 + 40 | 0) >> 2] | 0)) {
                           break label$25
                          }
                          $16 = 4;
                          i64toi32_i32$2 = 0;
                          $24 = 1;
                          $24$hi = i64toi32_i32$2;
                          break label$7;
                         }
                         if (!(HEAP32[($2 + 56 | 0) >> 2] | 0)) {
                          break label$26
                         }
                         $16 = 4;
                         i64toi32_i32$2 = 0;
                         $24 = 2;
                         $24$hi = i64toi32_i32$2;
                         break label$7;
                        }
                        if (!(HEAP32[($2 + 72 | 0) >> 2] | 0)) {
                         break label$27
                        }
                        $16 = 4;
                        i64toi32_i32$2 = 0;
                        $24 = 3;
                        $24$hi = i64toi32_i32$2;
                        break label$7;
                       }
                       if ((HEAPU8[($2 + 100 | 0) >> 0] | 0 | 0) == (3 | 0)) {
                        break label$28
                       }
                       $16 = 4;
                       i64toi32_i32$2 = 0;
                       $24 = 4;
                       $24$hi = i64toi32_i32$2;
                       break label$7;
                      }
                      label$37 : {
                       if (!(HEAP32[($2 + 104 | 0) >> 2] | 0)) {
                        break label$37
                       }
                       $16 = 4;
                       i64toi32_i32$2 = 0;
                       $24 = 5;
                       $24$hi = i64toi32_i32$2;
                       break label$7;
                      }
                      label$38 : {
                       label$39 : {
                        label$40 : {
                         i64toi32_i32$2 = $22$hi;
                         i64toi32_i32$0 = $22;
                         i64toi32_i32$3 = 0;
                         i64toi32_i32$1 = 1;
                         if ((i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | 0) {
                          break label$40
                         }
                         i64toi32_i32$0 = $23$hi;
                         i64toi32_i32$1 = $23;
                         i64toi32_i32$2 = 0;
                         i64toi32_i32$3 = 1;
                         i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
                         i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
                         if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
                          i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
                         }
                         $23 = i64toi32_i32$4;
                         $23$hi = i64toi32_i32$5;
                         i64toi32_i32$5 = $21$hi;
                         i64toi32_i32$5 = $23$hi;
                         i64toi32_i32$0 = i64toi32_i32$4;
                         i64toi32_i32$1 = $21$hi;
                         i64toi32_i32$3 = $21;
                         if (i64toi32_i32$5 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$0 >>> 0 <= i64toi32_i32$3 >>> 0 | 0) | 0) {
                          break label$40
                         }
                         i64toi32_i32$0 = 0;
                         $22 = 0;
                         $22$hi = i64toi32_i32$0;
                         $1 = 3;
                         $15 = 0;
                         break label$39;
                        }
                        $cardano_serialization_lib__plutus__Redeemers_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hbb30960977af731e($2 + 312 | 0 | 0, $1 | 0);
                        if ((HEAP32[($2 + 312 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                         break label$38
                        }
                        $17 = ($2 + 280 | 0) + 8 | 0;
                        i64toi32_i32$3 = $2 + 352 | 0;
                        i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                        i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                        $325 = i64toi32_i32$0;
                        i64toi32_i32$0 = $17;
                        HEAP32[i64toi32_i32$0 >> 2] = $325;
                        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$5;
                        $16 = ($2 + 280 | 0) + 16 | 0;
                        i64toi32_i32$3 = $2 + 360 | 0;
                        i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                        i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                        $332 = i64toi32_i32$5;
                        i64toi32_i32$5 = $16;
                        HEAP32[i64toi32_i32$5 >> 2] = $332;
                        HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
                        $13 = ($2 + 264 | 0) + 8 | 0;
                        HEAP32[$13 >> 2] = HEAP32[($2 + 380 | 0) >> 2] | 0;
                        HEAP32[($2 + 304 | 0) >> 2] = HEAPU8[$7 >> 0] | 0 | ((HEAPU8[($7 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($7 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($7 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                        $129 = $7 + 3 | 0;
                        $130 = HEAPU8[$129 >> 0] | 0 | ((HEAPU8[($129 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($129 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($129 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                        HEAP8[($2 + 307 | 0) >> 0] = $130;
                        HEAP8[($2 + 308 | 0) >> 0] = $130 >>> 8 | 0;
                        HEAP8[($2 + 309 | 0) >> 0] = $130 >>> 16 | 0;
                        HEAP8[($2 + 310 | 0) >> 0] = $130 >>> 24 | 0;
                        i64toi32_i32$3 = $2 + 344 | 0;
                        i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                        i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                        $350 = i64toi32_i32$0;
                        i64toi32_i32$0 = $2;
                        HEAP32[($2 + 280 | 0) >> 2] = $350;
                        HEAP32[($2 + 284 | 0) >> 2] = i64toi32_i32$5;
                        i64toi32_i32$3 = $2 + 372 | 0;
                        i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                        i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                        $354 = i64toi32_i32$5;
                        i64toi32_i32$5 = $2;
                        HEAP32[($2 + 264 | 0) >> 2] = $354;
                        HEAP32[($2 + 268 | 0) >> 2] = i64toi32_i32$0;
                        i64toi32_i32$3 = ($2 + 312 | 0) + 16 | 0;
                        i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                        i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                        $21 = i64toi32_i32$0;
                        $21$hi = i64toi32_i32$5;
                        i64toi32_i32$3 = $2 + 336 | 0;
                        i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                        i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                        $22 = i64toi32_i32$5;
                        $22$hi = i64toi32_i32$0;
                        $15 = HEAP32[($2 + 368 | 0) >> 2] | 0;
                        $1 = HEAPU8[($2 + 320 | 0) >> 0] | 0;
                        i64toi32_i32$3 = $17;
                        i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                        i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                        $371 = i64toi32_i32$0;
                        i64toi32_i32$0 = ($2 + 232 | 0) + 8 | 0;
                        HEAP32[i64toi32_i32$0 >> 2] = $371;
                        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$5;
                        i64toi32_i32$3 = $16;
                        i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                        i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                        $376 = i64toi32_i32$5;
                        i64toi32_i32$5 = ($2 + 232 | 0) + 16 | 0;
                        HEAP32[i64toi32_i32$5 >> 2] = $376;
                        HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
                        HEAP32[(($2 + 216 | 0) + 8 | 0) >> 2] = HEAP32[$13 >> 2] | 0;
                        $131 = HEAPU8[($2 + 307 | 0) >> 0] | 0 | ((HEAPU8[($2 + 308 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 309 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 310 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                        HEAP8[($2 + 259 | 0) >> 0] = $131;
                        HEAP8[($2 + 260 | 0) >> 0] = $131 >>> 8 | 0;
                        HEAP8[($2 + 261 | 0) >> 0] = $131 >>> 16 | 0;
                        HEAP8[($2 + 262 | 0) >> 0] = $131 >>> 24 | 0;
                        HEAP32[($2 + 256 | 0) >> 2] = HEAP32[($2 + 304 | 0) >> 2] | 0;
                        i64toi32_i32$3 = $2;
                        i64toi32_i32$0 = HEAP32[($2 + 280 | 0) >> 2] | 0;
                        i64toi32_i32$5 = HEAP32[($2 + 284 | 0) >> 2] | 0;
                        $390 = i64toi32_i32$0;
                        i64toi32_i32$0 = $2;
                        HEAP32[($2 + 232 | 0) >> 2] = $390;
                        HEAP32[($2 + 236 | 0) >> 2] = i64toi32_i32$5;
                        i64toi32_i32$3 = $2;
                        i64toi32_i32$5 = HEAP32[($2 + 264 | 0) >> 2] | 0;
                        i64toi32_i32$0 = HEAP32[($2 + 268 | 0) >> 2] | 0;
                        $393 = i64toi32_i32$5;
                        i64toi32_i32$5 = $2;
                        HEAP32[($2 + 216 | 0) >> 2] = $393;
                        HEAP32[($2 + 220 | 0) >> 2] = i64toi32_i32$0;
                       }
                       i64toi32_i32$0 = $22$hi;
                       i64toi32_i32$5 = ($2 + 312 | 0) + 16 | 0;
                       HEAP32[i64toi32_i32$5 >> 2] = $22;
                       HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
                       i64toi32_i32$0 = $21$hi;
                       i64toi32_i32$5 = ($2 + 312 | 0) + 8 | 0;
                       HEAP32[i64toi32_i32$5 >> 2] = $21;
                       HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
                       i64toi32_i32$3 = $2;
                       i64toi32_i32$0 = HEAP32[($2 + 232 | 0) >> 2] | 0;
                       i64toi32_i32$5 = HEAP32[($2 + 236 | 0) >> 2] | 0;
                       $406 = i64toi32_i32$0;
                       i64toi32_i32$0 = ($2 + 312 | 0) + 24 | 0;
                       HEAP32[i64toi32_i32$0 >> 2] = $406;
                       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$5;
                       i64toi32_i32$3 = $2;
                       i64toi32_i32$5 = HEAP32[($2 + 216 | 0) >> 2] | 0;
                       i64toi32_i32$0 = HEAP32[($2 + 220 | 0) >> 2] | 0;
                       $411 = i64toi32_i32$5;
                       i64toi32_i32$5 = ($2 + 312 | 0) + 52 | 0;
                       HEAP32[i64toi32_i32$5 >> 2] = $411;
                       HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
                       i64toi32_i32$3 = ($2 + 232 | 0) + 8 | 0;
                       i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                       i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                       $418 = i64toi32_i32$0;
                       i64toi32_i32$0 = ($2 + 312 | 0) + 32 | 0;
                       HEAP32[i64toi32_i32$0 >> 2] = $418;
                       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$5;
                       i64toi32_i32$3 = ($2 + 232 | 0) + 16 | 0;
                       i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                       i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                       $425 = i64toi32_i32$5;
                       i64toi32_i32$5 = ($2 + 312 | 0) + 40 | 0;
                       HEAP32[i64toi32_i32$5 >> 2] = $425;
                       HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
                       HEAP32[(($2 + 312 | 0) + 60 | 0) >> 2] = HEAP32[(($2 + 216 | 0) + 8 | 0) >> 2] | 0;
                       HEAP8[($2 + 312 | 0) >> 0] = $1;
                       $132 = HEAP32[($2 + 256 | 0) >> 2] | 0;
                       HEAP8[($2 + 313 | 0) >> 0] = $132;
                       HEAP8[($2 + 314 | 0) >> 0] = $132 >>> 8 | 0;
                       HEAP8[($2 + 315 | 0) >> 0] = $132 >>> 16 | 0;
                       HEAP8[($2 + 316 | 0) >> 0] = $132 >>> 24 | 0;
                       $133 = HEAPU8[($2 + 259 | 0) >> 0] | 0 | ((HEAPU8[($2 + 260 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 261 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 262 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                       HEAP8[($2 + 316 | 0) >> 0] = $133;
                       HEAP8[($2 + 317 | 0) >> 0] = $133 >>> 8 | 0;
                       HEAP8[($2 + 318 | 0) >> 0] = $133 >>> 16 | 0;
                       HEAP8[($2 + 319 | 0) >> 0] = $133 >>> 24 | 0;
                       HEAP32[($2 + 360 | 0) >> 2] = $15;
                       cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($14 | 0, $2 + 312 | 0 | 0, 1051726 | 0, 9 | 0);
                       HEAP32[(($2 + 280 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 192 | 0) >> 2] | 0;
                       $1 = ($2 + 136 | 0) + 4 | 0;
                       HEAP16[$1 >> 1] = HEAPU16[($5 + 4 | 0) >> 1] | 0;
                       i64toi32_i32$3 = ($2 + 144 | 0) + 40 | 0;
                       i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                       i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                       $463 = i64toi32_i32$0;
                       i64toi32_i32$0 = $2;
                       HEAP32[($2 + 280 | 0) >> 2] = $463;
                       HEAP32[($2 + 284 | 0) >> 2] = i64toi32_i32$5;
                       HEAP32[($2 + 136 | 0) >> 2] = HEAPU16[$5 >> 1] | 0 | ((HEAPU16[($5 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
                       $13 = HEAP32[(($2 + 144 | 0) + 16 | 0) >> 2] | 0;
                       $6 = HEAP32[($2 + 164 | 0) >> 2] | 0;
                       i64toi32_i32$3 = ($2 + 144 | 0) + 24 | 0;
                       i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                       i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                       $24 = i64toi32_i32$5;
                       $24$hi = i64toi32_i32$0;
                       i64toi32_i32$3 = ($2 + 144 | 0) + 32 | 0;
                       i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                       i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                       $23 = i64toi32_i32$0;
                       $23$hi = i64toi32_i32$5;
                       $5 = HEAP32[($2 + 212 | 0) >> 2] | 0;
                       i64toi32_i32$3 = ($2 + 144 | 0) + 60 | 0;
                       i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                       i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                       $26 = i64toi32_i32$5;
                       $26$hi = i64toi32_i32$0;
                       $17 = HEAP32[($2 + 200 | 0) >> 2] | 0;
                       $7 = HEAP32[(($2 + 144 | 0) + 52 | 0) >> 2] | 0;
                       $16 = HEAPU8[($2 + 152 | 0) >> 0] | 0;
                       $15 = HEAPU8[($2 + 153 | 0) >> 0] | 0;
                       HEAP16[(($2 + 232 | 0) + 4 | 0) >> 1] = HEAPU16[$1 >> 1] | 0;
                       HEAP32[($2 + 232 | 0) >> 2] = HEAP32[($2 + 136 | 0) >> 2] | 0;
                       break label$4;
                      }
                      HEAP32[($2 + 304 | 0) >> 2] = HEAPU8[$7 >> 0] | 0 | ((HEAPU8[($7 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($7 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($7 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                      $134 = $7 + 3 | 0;
                      $135 = HEAPU8[$134 >> 0] | 0 | ((HEAPU8[($134 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($134 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($134 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                      HEAP8[($2 + 307 | 0) >> 0] = $135;
                      HEAP8[($2 + 308 | 0) >> 0] = $135 >>> 8 | 0;
                      HEAP8[($2 + 309 | 0) >> 0] = $135 >>> 16 | 0;
                      HEAP8[($2 + 310 | 0) >> 0] = $135 >>> 24 | 0;
                      HEAP32[($2 + 256 | 0) >> 2] = HEAP32[($2 + 304 | 0) >> 2] | 0;
                      $136 = HEAPU8[($2 + 307 | 0) >> 0] | 0 | ((HEAPU8[($2 + 308 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 309 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 310 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                      HEAP8[($2 + 259 | 0) >> 0] = $136;
                      HEAP8[($2 + 260 | 0) >> 0] = $136 >>> 8 | 0;
                      HEAP8[($2 + 261 | 0) >> 0] = $136 >>> 16 | 0;
                      HEAP8[($2 + 262 | 0) >> 0] = $136 >>> 24 | 0;
                      $15 = HEAP32[($2 + 316 | 0) >> 2] | 0;
                      $17 = HEAPU8[($2 + 320 | 0) >> 0] | 0;
                      $137 = HEAP32[($2 + 256 | 0) >> 2] | 0;
                      HEAP8[$6 >> 0] = $137;
                      HEAP8[($6 + 1 | 0) >> 0] = $137 >>> 8 | 0;
                      HEAP8[($6 + 2 | 0) >> 0] = $137 >>> 16 | 0;
                      HEAP8[($6 + 3 | 0) >> 0] = $137 >>> 24 | 0;
                      $138 = $6 + 3 | 0;
                      $139 = HEAPU8[($2 + 259 | 0) >> 0] | 0 | ((HEAPU8[($2 + 260 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 261 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 262 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                      HEAP8[$138 >> 0] = $139;
                      HEAP8[($138 + 1 | 0) >> 0] = $139 >>> 8 | 0;
                      HEAP8[($138 + 2 | 0) >> 0] = $139 >>> 16 | 0;
                      HEAP8[($138 + 3 | 0) >> 0] = $139 >>> 24 | 0;
                      HEAP8[($2 + 152 | 0) >> 0] = $17;
                      HEAP32[($2 + 148 | 0) >> 2] = $15;
                      $18 = HEAPU8[($2 + 153 | 0) >> 0] | 0;
                      $19 = ($2 + 136 | 0) + 4 | 0;
                      HEAP16[$19 >> 1] = HEAPU16[($5 + 4 | 0) >> 1] | 0;
                      HEAP32[($2 + 136 | 0) >> 2] = HEAPU16[$5 >> 1] | 0 | ((HEAPU16[($5 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
                      core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__plutus__Redeemers____hd7679bbdd61edccb($2 + 104 | 0 | 0);
                      $198 = HEAP32[($2 + 136 | 0) >> 2] | 0;
                      HEAP16[$12 >> 1] = $198;
                      HEAP16[($12 + 2 | 0) >> 1] = $198 >>> 16 | 0;
                      HEAP16[($12 + 4 | 0) >> 1] = HEAPU16[$19 >> 1] | 0;
                      HEAP8[($2 + 109 | 0) >> 0] = $18;
                      HEAP8[($2 + 108 | 0) >> 0] = $17;
                      HEAP32[($2 + 104 | 0) >> 2] = $15;
                      break label$18;
                     }
                     label$41 : {
                      label$42 : {
                       i64toi32_i32$0 = $22$hi;
                       i64toi32_i32$3 = $22;
                       i64toi32_i32$5 = 0;
                       i64toi32_i32$1 = 1;
                       if ((i64toi32_i32$3 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$5 | 0) | 0) {
                        break label$42
                       }
                       i64toi32_i32$3 = $23$hi;
                       i64toi32_i32$1 = $23;
                       i64toi32_i32$0 = 0;
                       i64toi32_i32$5 = 1;
                       i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
                       i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
                       if (i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0) {
                        i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
                       }
                       $23 = i64toi32_i32$2;
                       $23$hi = i64toi32_i32$4;
                       i64toi32_i32$4 = $21$hi;
                       i64toi32_i32$4 = $23$hi;
                       i64toi32_i32$3 = i64toi32_i32$2;
                       i64toi32_i32$1 = $21$hi;
                       i64toi32_i32$5 = $21;
                       if (i64toi32_i32$4 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$3 >>> 0 <= i64toi32_i32$5 >>> 0 | 0) | 0) {
                        break label$42
                       }
                       i64toi32_i32$3 = 0;
                       $22 = 0;
                       $22$hi = i64toi32_i32$3;
                       $1 = 3;
                       $15 = 0;
                       break label$41;
                      }
                      $cardano_serialization_lib__plutus__PlutusList_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hfdf263ce80660b6e($2 + 312 | 0 | 0, $1 | 0);
                      if ((HEAP32[($2 + 312 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                       break label$23
                      }
                      $17 = ($2 + 280 | 0) + 8 | 0;
                      i64toi32_i32$5 = $2 + 352 | 0;
                      i64toi32_i32$3 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                      i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                      $582 = i64toi32_i32$3;
                      i64toi32_i32$3 = $17;
                      HEAP32[i64toi32_i32$3 >> 2] = $582;
                      HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$4;
                      $16 = ($2 + 280 | 0) + 16 | 0;
                      i64toi32_i32$5 = $2 + 360 | 0;
                      i64toi32_i32$4 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                      i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                      $589 = i64toi32_i32$4;
                      i64toi32_i32$4 = $16;
                      HEAP32[i64toi32_i32$4 >> 2] = $589;
                      HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$3;
                      $13 = ($2 + 264 | 0) + 8 | 0;
                      HEAP32[$13 >> 2] = HEAP32[($2 + 380 | 0) >> 2] | 0;
                      HEAP32[($2 + 304 | 0) >> 2] = HEAPU8[$7 >> 0] | 0 | ((HEAPU8[($7 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($7 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($7 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                      $140 = $7 + 3 | 0;
                      $141 = HEAPU8[$140 >> 0] | 0 | ((HEAPU8[($140 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($140 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($140 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                      HEAP8[($2 + 307 | 0) >> 0] = $141;
                      HEAP8[($2 + 308 | 0) >> 0] = $141 >>> 8 | 0;
                      HEAP8[($2 + 309 | 0) >> 0] = $141 >>> 16 | 0;
                      HEAP8[($2 + 310 | 0) >> 0] = $141 >>> 24 | 0;
                      i64toi32_i32$5 = $2 + 344 | 0;
                      i64toi32_i32$3 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                      i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                      $607 = i64toi32_i32$3;
                      i64toi32_i32$3 = $2;
                      HEAP32[($2 + 280 | 0) >> 2] = $607;
                      HEAP32[($2 + 284 | 0) >> 2] = i64toi32_i32$4;
                      i64toi32_i32$5 = $2 + 372 | 0;
                      i64toi32_i32$4 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                      i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                      $611 = i64toi32_i32$4;
                      i64toi32_i32$4 = $2;
                      HEAP32[($2 + 264 | 0) >> 2] = $611;
                      HEAP32[($2 + 268 | 0) >> 2] = i64toi32_i32$3;
                      i64toi32_i32$5 = $2 + 336 | 0;
                      i64toi32_i32$3 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                      i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                      $22 = i64toi32_i32$3;
                      $22$hi = i64toi32_i32$4;
                      $15 = HEAP32[($2 + 368 | 0) >> 2] | 0;
                      $1 = HEAPU8[($2 + 320 | 0) >> 0] | 0;
                      i64toi32_i32$5 = $2;
                      i64toi32_i32$4 = HEAP32[($2 + 328 | 0) >> 2] | 0;
                      i64toi32_i32$3 = HEAP32[($2 + 332 | 0) >> 2] | 0;
                      $21 = i64toi32_i32$4;
                      $21$hi = i64toi32_i32$3;
                      i64toi32_i32$5 = $17;
                      i64toi32_i32$3 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                      i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                      $626 = i64toi32_i32$3;
                      i64toi32_i32$3 = ($2 + 232 | 0) + 8 | 0;
                      HEAP32[i64toi32_i32$3 >> 2] = $626;
                      HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$4;
                      i64toi32_i32$5 = $16;
                      i64toi32_i32$4 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                      i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                      $631 = i64toi32_i32$4;
                      i64toi32_i32$4 = ($2 + 232 | 0) + 16 | 0;
                      HEAP32[i64toi32_i32$4 >> 2] = $631;
                      HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$3;
                      HEAP32[(($2 + 216 | 0) + 8 | 0) >> 2] = HEAP32[$13 >> 2] | 0;
                      $142 = HEAPU8[($2 + 307 | 0) >> 0] | 0 | ((HEAPU8[($2 + 308 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 309 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 310 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                      HEAP8[($2 + 259 | 0) >> 0] = $142;
                      HEAP8[($2 + 260 | 0) >> 0] = $142 >>> 8 | 0;
                      HEAP8[($2 + 261 | 0) >> 0] = $142 >>> 16 | 0;
                      HEAP8[($2 + 262 | 0) >> 0] = $142 >>> 24 | 0;
                      HEAP32[($2 + 256 | 0) >> 2] = HEAP32[($2 + 304 | 0) >> 2] | 0;
                      i64toi32_i32$5 = $2;
                      i64toi32_i32$3 = HEAP32[($2 + 280 | 0) >> 2] | 0;
                      i64toi32_i32$4 = HEAP32[($2 + 284 | 0) >> 2] | 0;
                      $645 = i64toi32_i32$3;
                      i64toi32_i32$3 = $2;
                      HEAP32[($2 + 232 | 0) >> 2] = $645;
                      HEAP32[($2 + 236 | 0) >> 2] = i64toi32_i32$4;
                      i64toi32_i32$5 = $2;
                      i64toi32_i32$4 = HEAP32[($2 + 264 | 0) >> 2] | 0;
                      i64toi32_i32$3 = HEAP32[($2 + 268 | 0) >> 2] | 0;
                      $648 = i64toi32_i32$4;
                      i64toi32_i32$4 = $2;
                      HEAP32[($2 + 216 | 0) >> 2] = $648;
                      HEAP32[($2 + 220 | 0) >> 2] = i64toi32_i32$3;
                      i64toi32_i32$3 = $21$hi;
                      $3 = $21;
                     }
                     i64toi32_i32$3 = $22$hi;
                     i64toi32_i32$4 = ($2 + 312 | 0) + 16 | 0;
                     HEAP32[i64toi32_i32$4 >> 2] = $22;
                     HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$3;
                     $656 = $2 + 324 | 0;
                     i64toi32_i32$3 = $21$hi;
                     i64toi32_i32$5 = $21;
                     i64toi32_i32$4 = 0;
                     i64toi32_i32$1 = 32;
                     i64toi32_i32$0 = i64toi32_i32$1 & 31 | 0;
                     if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                      i64toi32_i32$4 = 0;
                      $199 = i64toi32_i32$3 >>> i64toi32_i32$0 | 0;
                     } else {
                      i64toi32_i32$4 = i64toi32_i32$3 >>> i64toi32_i32$0 | 0;
                      $199 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$0 | 0) | 0;
                     }
                     HEAP32[$656 >> 2] = $199;
                     HEAP32[(($2 + 312 | 0) + 8 | 0) >> 2] = $3;
                     i64toi32_i32$3 = $2;
                     i64toi32_i32$4 = HEAP32[($2 + 232 | 0) >> 2] | 0;
                     i64toi32_i32$5 = HEAP32[($2 + 236 | 0) >> 2] | 0;
                     $667 = i64toi32_i32$4;
                     i64toi32_i32$4 = ($2 + 312 | 0) + 24 | 0;
                     HEAP32[i64toi32_i32$4 >> 2] = $667;
                     HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
                     i64toi32_i32$3 = $2;
                     i64toi32_i32$5 = HEAP32[($2 + 216 | 0) >> 2] | 0;
                     i64toi32_i32$4 = HEAP32[($2 + 220 | 0) >> 2] | 0;
                     $672 = i64toi32_i32$5;
                     i64toi32_i32$5 = ($2 + 312 | 0) + 52 | 0;
                     HEAP32[i64toi32_i32$5 >> 2] = $672;
                     HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$4;
                     i64toi32_i32$3 = ($2 + 232 | 0) + 8 | 0;
                     i64toi32_i32$4 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                     i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                     $679 = i64toi32_i32$4;
                     i64toi32_i32$4 = ($2 + 312 | 0) + 32 | 0;
                     HEAP32[i64toi32_i32$4 >> 2] = $679;
                     HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
                     i64toi32_i32$3 = ($2 + 232 | 0) + 16 | 0;
                     i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                     i64toi32_i32$4 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                     $686 = i64toi32_i32$5;
                     i64toi32_i32$5 = ($2 + 312 | 0) + 40 | 0;
                     HEAP32[i64toi32_i32$5 >> 2] = $686;
                     HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$4;
                     HEAP32[(($2 + 312 | 0) + 60 | 0) >> 2] = HEAP32[(($2 + 216 | 0) + 8 | 0) >> 2] | 0;
                     HEAP8[($2 + 312 | 0) >> 0] = $1;
                     $143 = HEAP32[($2 + 256 | 0) >> 2] | 0;
                     HEAP8[($2 + 313 | 0) >> 0] = $143;
                     HEAP8[($2 + 314 | 0) >> 0] = $143 >>> 8 | 0;
                     HEAP8[($2 + 315 | 0) >> 0] = $143 >>> 16 | 0;
                     HEAP8[($2 + 316 | 0) >> 0] = $143 >>> 24 | 0;
                     $144 = HEAPU8[($2 + 259 | 0) >> 0] | 0 | ((HEAPU8[($2 + 260 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 261 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 262 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                     HEAP8[($2 + 316 | 0) >> 0] = $144;
                     HEAP8[($2 + 317 | 0) >> 0] = $144 >>> 8 | 0;
                     HEAP8[($2 + 318 | 0) >> 0] = $144 >>> 16 | 0;
                     HEAP8[($2 + 319 | 0) >> 0] = $144 >>> 24 | 0;
                     HEAP32[($2 + 360 | 0) >> 2] = $15;
                     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($14 | 0, $2 + 312 | 0 | 0, 1051715 | 0, 11 | 0);
                     HEAP32[(($2 + 280 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 192 | 0) >> 2] | 0;
                     $1 = ($2 + 136 | 0) + 4 | 0;
                     HEAP16[$1 >> 1] = HEAPU16[($5 + 4 | 0) >> 1] | 0;
                     i64toi32_i32$3 = ($2 + 144 | 0) + 40 | 0;
                     i64toi32_i32$4 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                     i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                     $724 = i64toi32_i32$4;
                     i64toi32_i32$4 = $2;
                     HEAP32[($2 + 280 | 0) >> 2] = $724;
                     HEAP32[($2 + 284 | 0) >> 2] = i64toi32_i32$5;
                     HEAP32[($2 + 136 | 0) >> 2] = HEAPU16[$5 >> 1] | 0 | ((HEAPU16[($5 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
                     $6 = HEAP32[($2 + 164 | 0) >> 2] | 0;
                     i64toi32_i32$3 = ($2 + 144 | 0) + 24 | 0;
                     i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                     i64toi32_i32$4 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                     $24 = i64toi32_i32$5;
                     $24$hi = i64toi32_i32$4;
                     i64toi32_i32$3 = ($2 + 144 | 0) + 32 | 0;
                     i64toi32_i32$4 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                     i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                     $23 = i64toi32_i32$4;
                     $23$hi = i64toi32_i32$5;
                     $5 = HEAP32[($2 + 212 | 0) >> 2] | 0;
                     i64toi32_i32$3 = ($2 + 144 | 0) + 60 | 0;
                     i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                     i64toi32_i32$4 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                     $26 = i64toi32_i32$5;
                     $26$hi = i64toi32_i32$4;
                     $17 = HEAP32[($2 + 200 | 0) >> 2] | 0;
                     $7 = HEAP32[(($2 + 144 | 0) + 52 | 0) >> 2] | 0;
                     $16 = HEAPU8[($2 + 152 | 0) >> 0] | 0;
                     $15 = HEAPU8[($2 + 153 | 0) >> 0] | 0;
                     $13 = HEAP32[($2 + 160 | 0) >> 2] | 0;
                     HEAP16[(($2 + 232 | 0) + 4 | 0) >> 1] = HEAPU16[$1 >> 1] | 0;
                     HEAP32[($2 + 232 | 0) >> 2] = HEAP32[($2 + 136 | 0) >> 2] | 0;
                     break label$4;
                    }
                    label$43 : {
                     label$44 : {
                      i64toi32_i32$4 = $22$hi;
                      i64toi32_i32$3 = $22;
                      i64toi32_i32$5 = 0;
                      i64toi32_i32$1 = 1;
                      if ((i64toi32_i32$3 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$4 | 0) != (i64toi32_i32$5 | 0) | 0) {
                       break label$44
                      }
                      i64toi32_i32$3 = $23$hi;
                      i64toi32_i32$1 = $23;
                      i64toi32_i32$4 = 0;
                      i64toi32_i32$5 = 1;
                      i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
                      i64toi32_i32$2 = i64toi32_i32$3 + i64toi32_i32$4 | 0;
                      if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
                       i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
                      }
                      $23 = i64toi32_i32$0;
                      $23$hi = i64toi32_i32$2;
                      i64toi32_i32$2 = $21$hi;
                      i64toi32_i32$2 = $23$hi;
                      i64toi32_i32$3 = i64toi32_i32$0;
                      i64toi32_i32$1 = $21$hi;
                      i64toi32_i32$5 = $21;
                      if (i64toi32_i32$2 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$0 >>> 0 <= i64toi32_i32$5 >>> 0 | 0) | 0) {
                       break label$44
                      }
                      i64toi32_i32$3 = 0;
                      $22 = 0;
                      $22$hi = i64toi32_i32$3;
                      $1 = 0;
                      $15 = 3;
                      break label$43;
                     }
                     $cardano_serialization_lib__plutus__PlutusScripts_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h8b36940d74966a88($2 + 312 | 0 | 0, $1 | 0);
                     if ((HEAP32[($2 + 312 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                      break label$22
                     }
                     $17 = ($2 + 280 | 0) + 8 | 0;
                     i64toi32_i32$5 = $2 + 352 | 0;
                     i64toi32_i32$3 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                     i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                     $786 = i64toi32_i32$3;
                     i64toi32_i32$3 = $17;
                     HEAP32[i64toi32_i32$3 >> 2] = $786;
                     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                     $16 = ($2 + 280 | 0) + 16 | 0;
                     i64toi32_i32$5 = $2 + 360 | 0;
                     i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                     i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                     $793 = i64toi32_i32$2;
                     i64toi32_i32$2 = $16;
                     HEAP32[i64toi32_i32$2 >> 2] = $793;
                     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                     $13 = ($2 + 264 | 0) + 8 | 0;
                     HEAP32[$13 >> 2] = HEAP32[($2 + 380 | 0) >> 2] | 0;
                     HEAP32[($2 + 304 | 0) >> 2] = HEAPU8[$7 >> 0] | 0 | ((HEAPU8[($7 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($7 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($7 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                     $145 = $7 + 3 | 0;
                     $146 = HEAPU8[$145 >> 0] | 0 | ((HEAPU8[($145 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($145 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($145 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                     HEAP8[($2 + 307 | 0) >> 0] = $146;
                     HEAP8[($2 + 308 | 0) >> 0] = $146 >>> 8 | 0;
                     HEAP8[($2 + 309 | 0) >> 0] = $146 >>> 16 | 0;
                     HEAP8[($2 + 310 | 0) >> 0] = $146 >>> 24 | 0;
                     i64toi32_i32$5 = $2 + 344 | 0;
                     i64toi32_i32$3 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                     i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                     $811 = i64toi32_i32$3;
                     i64toi32_i32$3 = $2;
                     HEAP32[($2 + 280 | 0) >> 2] = $811;
                     HEAP32[($2 + 284 | 0) >> 2] = i64toi32_i32$2;
                     i64toi32_i32$5 = $2 + 372 | 0;
                     i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                     i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                     $815 = i64toi32_i32$2;
                     i64toi32_i32$2 = $2;
                     HEAP32[($2 + 264 | 0) >> 2] = $815;
                     HEAP32[($2 + 268 | 0) >> 2] = i64toi32_i32$3;
                     i64toi32_i32$5 = ($2 + 312 | 0) + 16 | 0;
                     i64toi32_i32$3 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                     i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                     $21 = i64toi32_i32$3;
                     $21$hi = i64toi32_i32$2;
                     i64toi32_i32$5 = $2 + 336 | 0;
                     i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                     i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                     $22 = i64toi32_i32$2;
                     $22$hi = i64toi32_i32$3;
                     $1 = HEAP32[($2 + 368 | 0) >> 2] | 0;
                     $15 = HEAPU8[($2 + 320 | 0) >> 0] | 0;
                     i64toi32_i32$5 = $17;
                     i64toi32_i32$3 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                     i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                     $832 = i64toi32_i32$3;
                     i64toi32_i32$3 = ($2 + 232 | 0) + 8 | 0;
                     HEAP32[i64toi32_i32$3 >> 2] = $832;
                     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                     i64toi32_i32$5 = $16;
                     i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                     i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                     $837 = i64toi32_i32$2;
                     i64toi32_i32$2 = ($2 + 232 | 0) + 16 | 0;
                     HEAP32[i64toi32_i32$2 >> 2] = $837;
                     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                     HEAP32[(($2 + 216 | 0) + 8 | 0) >> 2] = HEAP32[$13 >> 2] | 0;
                     $147 = HEAPU8[($2 + 307 | 0) >> 0] | 0 | ((HEAPU8[($2 + 308 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 309 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 310 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                     HEAP8[($2 + 259 | 0) >> 0] = $147;
                     HEAP8[($2 + 260 | 0) >> 0] = $147 >>> 8 | 0;
                     HEAP8[($2 + 261 | 0) >> 0] = $147 >>> 16 | 0;
                     HEAP8[($2 + 262 | 0) >> 0] = $147 >>> 24 | 0;
                     HEAP32[($2 + 256 | 0) >> 2] = HEAP32[($2 + 304 | 0) >> 2] | 0;
                     i64toi32_i32$5 = $2;
                     i64toi32_i32$3 = HEAP32[($2 + 280 | 0) >> 2] | 0;
                     i64toi32_i32$2 = HEAP32[($2 + 284 | 0) >> 2] | 0;
                     $851 = i64toi32_i32$3;
                     i64toi32_i32$3 = $2;
                     HEAP32[($2 + 232 | 0) >> 2] = $851;
                     HEAP32[($2 + 236 | 0) >> 2] = i64toi32_i32$2;
                     i64toi32_i32$5 = $2;
                     i64toi32_i32$2 = HEAP32[($2 + 264 | 0) >> 2] | 0;
                     i64toi32_i32$3 = HEAP32[($2 + 268 | 0) >> 2] | 0;
                     $854 = i64toi32_i32$2;
                     i64toi32_i32$2 = $2;
                     HEAP32[($2 + 216 | 0) >> 2] = $854;
                     HEAP32[($2 + 220 | 0) >> 2] = i64toi32_i32$3;
                    }
                    i64toi32_i32$3 = $22$hi;
                    i64toi32_i32$2 = ($2 + 312 | 0) + 16 | 0;
                    HEAP32[i64toi32_i32$2 >> 2] = $22;
                    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                    i64toi32_i32$3 = $21$hi;
                    i64toi32_i32$2 = ($2 + 312 | 0) + 8 | 0;
                    HEAP32[i64toi32_i32$2 >> 2] = $21;
                    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                    i64toi32_i32$5 = $2;
                    i64toi32_i32$3 = HEAP32[($2 + 232 | 0) >> 2] | 0;
                    i64toi32_i32$2 = HEAP32[($2 + 236 | 0) >> 2] | 0;
                    $867 = i64toi32_i32$3;
                    i64toi32_i32$3 = ($2 + 312 | 0) + 24 | 0;
                    HEAP32[i64toi32_i32$3 >> 2] = $867;
                    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                    i64toi32_i32$5 = $2;
                    i64toi32_i32$2 = HEAP32[($2 + 216 | 0) >> 2] | 0;
                    i64toi32_i32$3 = HEAP32[($2 + 220 | 0) >> 2] | 0;
                    $872 = i64toi32_i32$2;
                    i64toi32_i32$2 = ($2 + 312 | 0) + 52 | 0;
                    HEAP32[i64toi32_i32$2 >> 2] = $872;
                    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                    i64toi32_i32$5 = ($2 + 232 | 0) + 8 | 0;
                    i64toi32_i32$3 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                    i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                    $879 = i64toi32_i32$3;
                    i64toi32_i32$3 = ($2 + 312 | 0) + 32 | 0;
                    HEAP32[i64toi32_i32$3 >> 2] = $879;
                    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                    i64toi32_i32$5 = ($2 + 232 | 0) + 16 | 0;
                    i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                    i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                    $886 = i64toi32_i32$2;
                    i64toi32_i32$2 = ($2 + 312 | 0) + 40 | 0;
                    HEAP32[i64toi32_i32$2 >> 2] = $886;
                    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                    HEAP32[(($2 + 312 | 0) + 60 | 0) >> 2] = HEAP32[(($2 + 216 | 0) + 8 | 0) >> 2] | 0;
                    HEAP8[($2 + 312 | 0) >> 0] = $15;
                    $148 = HEAP32[($2 + 256 | 0) >> 2] | 0;
                    HEAP8[($2 + 313 | 0) >> 0] = $148;
                    HEAP8[($2 + 314 | 0) >> 0] = $148 >>> 8 | 0;
                    HEAP8[($2 + 315 | 0) >> 0] = $148 >>> 16 | 0;
                    HEAP8[($2 + 316 | 0) >> 0] = $148 >>> 24 | 0;
                    $149 = HEAPU8[($2 + 259 | 0) >> 0] | 0 | ((HEAPU8[($2 + 260 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 261 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 262 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                    HEAP8[($2 + 316 | 0) >> 0] = $149;
                    HEAP8[($2 + 317 | 0) >> 0] = $149 >>> 8 | 0;
                    HEAP8[($2 + 318 | 0) >> 0] = $149 >>> 16 | 0;
                    HEAP8[($2 + 319 | 0) >> 0] = $149 >>> 24 | 0;
                    HEAP32[($2 + 360 | 0) >> 2] = $1;
                    cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($14 | 0, $2 + 312 | 0 | 0, 1051701 | 0, 14 | 0);
                    HEAP32[(($2 + 280 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 192 | 0) >> 2] | 0;
                    $1 = ($2 + 136 | 0) + 4 | 0;
                    HEAP16[$1 >> 1] = HEAPU16[($5 + 4 | 0) >> 1] | 0;
                    i64toi32_i32$5 = ($2 + 144 | 0) + 40 | 0;
                    i64toi32_i32$3 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                    i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                    $924 = i64toi32_i32$3;
                    i64toi32_i32$3 = $2;
                    HEAP32[($2 + 280 | 0) >> 2] = $924;
                    HEAP32[($2 + 284 | 0) >> 2] = i64toi32_i32$2;
                    HEAP32[($2 + 136 | 0) >> 2] = HEAPU16[$5 >> 1] | 0 | ((HEAPU16[($5 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
                    $13 = HEAP32[(($2 + 144 | 0) + 16 | 0) >> 2] | 0;
                    $6 = HEAP32[($2 + 164 | 0) >> 2] | 0;
                    i64toi32_i32$5 = ($2 + 144 | 0) + 24 | 0;
                    i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                    i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                    $24 = i64toi32_i32$2;
                    $24$hi = i64toi32_i32$3;
                    i64toi32_i32$5 = ($2 + 144 | 0) + 32 | 0;
                    i64toi32_i32$3 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                    i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                    $23 = i64toi32_i32$3;
                    $23$hi = i64toi32_i32$2;
                    $5 = HEAP32[($2 + 212 | 0) >> 2] | 0;
                    i64toi32_i32$5 = ($2 + 144 | 0) + 60 | 0;
                    i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                    i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                    $26 = i64toi32_i32$2;
                    $26$hi = i64toi32_i32$3;
                    $17 = HEAP32[($2 + 200 | 0) >> 2] | 0;
                    $7 = HEAP32[(($2 + 144 | 0) + 52 | 0) >> 2] | 0;
                    $16 = HEAPU8[($2 + 152 | 0) >> 0] | 0;
                    $15 = HEAPU8[($2 + 153 | 0) >> 0] | 0;
                    HEAP16[(($2 + 232 | 0) + 4 | 0) >> 1] = HEAPU16[$1 >> 1] | 0;
                    HEAP32[($2 + 232 | 0) >> 2] = HEAP32[($2 + 136 | 0) >> 2] | 0;
                    break label$4;
                   }
                   label$45 : {
                    label$46 : {
                     i64toi32_i32$3 = $22$hi;
                     i64toi32_i32$5 = $22;
                     i64toi32_i32$2 = 0;
                     i64toi32_i32$1 = 1;
                     if ((i64toi32_i32$5 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$3 | 0) != (i64toi32_i32$2 | 0) | 0) {
                      break label$46
                     }
                     i64toi32_i32$5 = $23$hi;
                     i64toi32_i32$1 = $23;
                     i64toi32_i32$3 = 0;
                     i64toi32_i32$2 = 1;
                     i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
                     i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
                     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0) {
                      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
                     }
                     $23 = i64toi32_i32$4;
                     $23$hi = i64toi32_i32$0;
                     i64toi32_i32$0 = $21$hi;
                     i64toi32_i32$0 = $23$hi;
                     i64toi32_i32$5 = i64toi32_i32$4;
                     i64toi32_i32$1 = $21$hi;
                     i64toi32_i32$2 = $21;
                     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$4 >>> 0 <= i64toi32_i32$2 >>> 0 | 0) | 0) {
                      break label$46
                     }
                     i64toi32_i32$5 = 0;
                     $22 = 0;
                     $22$hi = i64toi32_i32$5;
                     $1 = 0;
                     $15 = 3;
                     break label$45;
                    }
                    $cardano_serialization_lib__crypto__BootstrapWitnesses_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h61c411bcc99e880f($2 + 312 | 0 | 0, $1 | 0);
                    if ((HEAP32[($2 + 312 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                     break label$21
                    }
                    $17 = ($2 + 280 | 0) + 8 | 0;
                    i64toi32_i32$2 = $2 + 352 | 0;
                    i64toi32_i32$5 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                    $988 = i64toi32_i32$5;
                    i64toi32_i32$5 = $17;
                    HEAP32[i64toi32_i32$5 >> 2] = $988;
                    HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
                    $16 = ($2 + 280 | 0) + 16 | 0;
                    i64toi32_i32$2 = $2 + 360 | 0;
                    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                    i64toi32_i32$5 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                    $995 = i64toi32_i32$0;
                    i64toi32_i32$0 = $16;
                    HEAP32[i64toi32_i32$0 >> 2] = $995;
                    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$5;
                    $13 = ($2 + 264 | 0) + 8 | 0;
                    HEAP32[$13 >> 2] = HEAP32[($2 + 380 | 0) >> 2] | 0;
                    HEAP32[($2 + 304 | 0) >> 2] = HEAPU8[$7 >> 0] | 0 | ((HEAPU8[($7 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($7 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($7 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                    $150 = $7 + 3 | 0;
                    $151 = HEAPU8[$150 >> 0] | 0 | ((HEAPU8[($150 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($150 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($150 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                    HEAP8[($2 + 307 | 0) >> 0] = $151;
                    HEAP8[($2 + 308 | 0) >> 0] = $151 >>> 8 | 0;
                    HEAP8[($2 + 309 | 0) >> 0] = $151 >>> 16 | 0;
                    HEAP8[($2 + 310 | 0) >> 0] = $151 >>> 24 | 0;
                    i64toi32_i32$2 = $2 + 344 | 0;
                    i64toi32_i32$5 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                    $1013 = i64toi32_i32$5;
                    i64toi32_i32$5 = $2;
                    HEAP32[($2 + 280 | 0) >> 2] = $1013;
                    HEAP32[($2 + 284 | 0) >> 2] = i64toi32_i32$0;
                    i64toi32_i32$2 = $2 + 372 | 0;
                    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                    i64toi32_i32$5 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                    $1017 = i64toi32_i32$0;
                    i64toi32_i32$0 = $2;
                    HEAP32[($2 + 264 | 0) >> 2] = $1017;
                    HEAP32[($2 + 268 | 0) >> 2] = i64toi32_i32$5;
                    i64toi32_i32$2 = ($2 + 312 | 0) + 16 | 0;
                    i64toi32_i32$5 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                    $21 = i64toi32_i32$5;
                    $21$hi = i64toi32_i32$0;
                    i64toi32_i32$2 = $2 + 336 | 0;
                    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                    i64toi32_i32$5 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                    $22 = i64toi32_i32$0;
                    $22$hi = i64toi32_i32$5;
                    $1 = HEAP32[($2 + 368 | 0) >> 2] | 0;
                    $15 = HEAPU8[($2 + 320 | 0) >> 0] | 0;
                    i64toi32_i32$2 = $17;
                    i64toi32_i32$5 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                    $1034 = i64toi32_i32$5;
                    i64toi32_i32$5 = ($2 + 232 | 0) + 8 | 0;
                    HEAP32[i64toi32_i32$5 >> 2] = $1034;
                    HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
                    i64toi32_i32$2 = $16;
                    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                    i64toi32_i32$5 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                    $1039 = i64toi32_i32$0;
                    i64toi32_i32$0 = ($2 + 232 | 0) + 16 | 0;
                    HEAP32[i64toi32_i32$0 >> 2] = $1039;
                    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$5;
                    HEAP32[(($2 + 216 | 0) + 8 | 0) >> 2] = HEAP32[$13 >> 2] | 0;
                    $152 = HEAPU8[($2 + 307 | 0) >> 0] | 0 | ((HEAPU8[($2 + 308 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 309 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 310 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                    HEAP8[($2 + 259 | 0) >> 0] = $152;
                    HEAP8[($2 + 260 | 0) >> 0] = $152 >>> 8 | 0;
                    HEAP8[($2 + 261 | 0) >> 0] = $152 >>> 16 | 0;
                    HEAP8[($2 + 262 | 0) >> 0] = $152 >>> 24 | 0;
                    HEAP32[($2 + 256 | 0) >> 2] = HEAP32[($2 + 304 | 0) >> 2] | 0;
                    i64toi32_i32$2 = $2;
                    i64toi32_i32$5 = HEAP32[($2 + 280 | 0) >> 2] | 0;
                    i64toi32_i32$0 = HEAP32[($2 + 284 | 0) >> 2] | 0;
                    $1053 = i64toi32_i32$5;
                    i64toi32_i32$5 = $2;
                    HEAP32[($2 + 232 | 0) >> 2] = $1053;
                    HEAP32[($2 + 236 | 0) >> 2] = i64toi32_i32$0;
                    i64toi32_i32$2 = $2;
                    i64toi32_i32$0 = HEAP32[($2 + 264 | 0) >> 2] | 0;
                    i64toi32_i32$5 = HEAP32[($2 + 268 | 0) >> 2] | 0;
                    $1056 = i64toi32_i32$0;
                    i64toi32_i32$0 = $2;
                    HEAP32[($2 + 216 | 0) >> 2] = $1056;
                    HEAP32[($2 + 220 | 0) >> 2] = i64toi32_i32$5;
                   }
                   i64toi32_i32$5 = $22$hi;
                   i64toi32_i32$0 = ($2 + 312 | 0) + 16 | 0;
                   HEAP32[i64toi32_i32$0 >> 2] = $22;
                   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$5;
                   i64toi32_i32$5 = $21$hi;
                   i64toi32_i32$0 = ($2 + 312 | 0) + 8 | 0;
                   HEAP32[i64toi32_i32$0 >> 2] = $21;
                   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$5;
                   i64toi32_i32$2 = $2;
                   i64toi32_i32$5 = HEAP32[($2 + 232 | 0) >> 2] | 0;
                   i64toi32_i32$0 = HEAP32[($2 + 236 | 0) >> 2] | 0;
                   $1069 = i64toi32_i32$5;
                   i64toi32_i32$5 = ($2 + 312 | 0) + 24 | 0;
                   HEAP32[i64toi32_i32$5 >> 2] = $1069;
                   HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
                   i64toi32_i32$2 = $2;
                   i64toi32_i32$0 = HEAP32[($2 + 216 | 0) >> 2] | 0;
                   i64toi32_i32$5 = HEAP32[($2 + 220 | 0) >> 2] | 0;
                   $1074 = i64toi32_i32$0;
                   i64toi32_i32$0 = ($2 + 312 | 0) + 52 | 0;
                   HEAP32[i64toi32_i32$0 >> 2] = $1074;
                   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$5;
                   i64toi32_i32$2 = ($2 + 232 | 0) + 8 | 0;
                   i64toi32_i32$5 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                   $1081 = i64toi32_i32$5;
                   i64toi32_i32$5 = ($2 + 312 | 0) + 32 | 0;
                   HEAP32[i64toi32_i32$5 >> 2] = $1081;
                   HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
                   i64toi32_i32$2 = ($2 + 232 | 0) + 16 | 0;
                   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                   i64toi32_i32$5 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                   $1088 = i64toi32_i32$0;
                   i64toi32_i32$0 = ($2 + 312 | 0) + 40 | 0;
                   HEAP32[i64toi32_i32$0 >> 2] = $1088;
                   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$5;
                   HEAP32[(($2 + 312 | 0) + 60 | 0) >> 2] = HEAP32[(($2 + 216 | 0) + 8 | 0) >> 2] | 0;
                   HEAP8[($2 + 312 | 0) >> 0] = $15;
                   $153 = HEAP32[($2 + 256 | 0) >> 2] | 0;
                   HEAP8[($2 + 313 | 0) >> 0] = $153;
                   HEAP8[($2 + 314 | 0) >> 0] = $153 >>> 8 | 0;
                   HEAP8[($2 + 315 | 0) >> 0] = $153 >>> 16 | 0;
                   HEAP8[($2 + 316 | 0) >> 0] = $153 >>> 24 | 0;
                   $154 = HEAPU8[($2 + 259 | 0) >> 0] | 0 | ((HEAPU8[($2 + 260 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 261 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 262 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                   HEAP8[($2 + 316 | 0) >> 0] = $154;
                   HEAP8[($2 + 317 | 0) >> 0] = $154 >>> 8 | 0;
                   HEAP8[($2 + 318 | 0) >> 0] = $154 >>> 16 | 0;
                   HEAP8[($2 + 319 | 0) >> 0] = $154 >>> 24 | 0;
                   HEAP32[($2 + 360 | 0) >> 2] = $1;
                   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($14 | 0, $2 + 312 | 0 | 0, 1051691 | 0, 10 | 0);
                   HEAP32[(($2 + 280 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 192 | 0) >> 2] | 0;
                   $1 = ($2 + 136 | 0) + 4 | 0;
                   HEAP16[$1 >> 1] = HEAPU16[($5 + 4 | 0) >> 1] | 0;
                   i64toi32_i32$2 = ($2 + 144 | 0) + 40 | 0;
                   i64toi32_i32$5 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                   $1126 = i64toi32_i32$5;
                   i64toi32_i32$5 = $2;
                   HEAP32[($2 + 280 | 0) >> 2] = $1126;
                   HEAP32[($2 + 284 | 0) >> 2] = i64toi32_i32$0;
                   HEAP32[($2 + 136 | 0) >> 2] = HEAPU16[$5 >> 1] | 0 | ((HEAPU16[($5 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
                   $13 = HEAP32[(($2 + 144 | 0) + 16 | 0) >> 2] | 0;
                   $6 = HEAP32[($2 + 164 | 0) >> 2] | 0;
                   i64toi32_i32$2 = ($2 + 144 | 0) + 24 | 0;
                   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                   i64toi32_i32$5 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                   $24 = i64toi32_i32$0;
                   $24$hi = i64toi32_i32$5;
                   i64toi32_i32$2 = ($2 + 144 | 0) + 32 | 0;
                   i64toi32_i32$5 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                   $23 = i64toi32_i32$5;
                   $23$hi = i64toi32_i32$0;
                   $5 = HEAP32[($2 + 212 | 0) >> 2] | 0;
                   i64toi32_i32$2 = ($2 + 144 | 0) + 60 | 0;
                   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                   i64toi32_i32$5 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                   $26 = i64toi32_i32$0;
                   $26$hi = i64toi32_i32$5;
                   $17 = HEAP32[($2 + 200 | 0) >> 2] | 0;
                   $7 = HEAP32[(($2 + 144 | 0) + 52 | 0) >> 2] | 0;
                   $16 = HEAPU8[($2 + 152 | 0) >> 0] | 0;
                   $15 = HEAPU8[($2 + 153 | 0) >> 0] | 0;
                   HEAP16[(($2 + 232 | 0) + 4 | 0) >> 1] = HEAPU16[$1 >> 1] | 0;
                   HEAP32[($2 + 232 | 0) >> 2] = HEAP32[($2 + 136 | 0) >> 2] | 0;
                   break label$4;
                  }
                  label$47 : {
                   label$48 : {
                    i64toi32_i32$5 = $22$hi;
                    i64toi32_i32$2 = $22;
                    i64toi32_i32$0 = 0;
                    i64toi32_i32$1 = 1;
                    if ((i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$5 | 0) != (i64toi32_i32$0 | 0) | 0) {
                     break label$48
                    }
                    i64toi32_i32$2 = $23$hi;
                    i64toi32_i32$1 = $23;
                    i64toi32_i32$5 = 0;
                    i64toi32_i32$0 = 1;
                    i64toi32_i32$3 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
                    i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
                    if (i64toi32_i32$3 >>> 0 < i64toi32_i32$0 >>> 0) {
                     i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
                    }
                    $23 = i64toi32_i32$3;
                    $23$hi = i64toi32_i32$4;
                    i64toi32_i32$4 = $21$hi;
                    i64toi32_i32$4 = $23$hi;
                    i64toi32_i32$2 = i64toi32_i32$3;
                    i64toi32_i32$1 = $21$hi;
                    i64toi32_i32$0 = $21;
                    if (i64toi32_i32$4 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$3 >>> 0 <= i64toi32_i32$0 >>> 0 | 0) | 0) {
                     break label$48
                    }
                    i64toi32_i32$2 = 0;
                    $22 = 0;
                    $22$hi = i64toi32_i32$2;
                    $1 = 0;
                    $15 = 3;
                    break label$47;
                   }
                   cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__NativeScripts___deserialize__h5fb973a07bcdbe01($2 + 312 | 0 | 0, $1 | 0);
                   if ((HEAP32[($2 + 312 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                    break label$20
                   }
                   $17 = ($2 + 280 | 0) + 8 | 0;
                   i64toi32_i32$0 = $2 + 352 | 0;
                   i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                   i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                   $1190 = i64toi32_i32$2;
                   i64toi32_i32$2 = $17;
                   HEAP32[i64toi32_i32$2 >> 2] = $1190;
                   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$4;
                   $16 = ($2 + 280 | 0) + 16 | 0;
                   i64toi32_i32$0 = $2 + 360 | 0;
                   i64toi32_i32$4 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                   $1197 = i64toi32_i32$4;
                   i64toi32_i32$4 = $16;
                   HEAP32[i64toi32_i32$4 >> 2] = $1197;
                   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$2;
                   $13 = ($2 + 264 | 0) + 8 | 0;
                   HEAP32[$13 >> 2] = HEAP32[($2 + 380 | 0) >> 2] | 0;
                   HEAP32[($2 + 304 | 0) >> 2] = HEAPU8[$7 >> 0] | 0 | ((HEAPU8[($7 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($7 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($7 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                   $155 = $7 + 3 | 0;
                   $156 = HEAPU8[$155 >> 0] | 0 | ((HEAPU8[($155 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($155 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($155 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                   HEAP8[($2 + 307 | 0) >> 0] = $156;
                   HEAP8[($2 + 308 | 0) >> 0] = $156 >>> 8 | 0;
                   HEAP8[($2 + 309 | 0) >> 0] = $156 >>> 16 | 0;
                   HEAP8[($2 + 310 | 0) >> 0] = $156 >>> 24 | 0;
                   i64toi32_i32$0 = $2 + 344 | 0;
                   i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                   i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                   $1215 = i64toi32_i32$2;
                   i64toi32_i32$2 = $2;
                   HEAP32[($2 + 280 | 0) >> 2] = $1215;
                   HEAP32[($2 + 284 | 0) >> 2] = i64toi32_i32$4;
                   i64toi32_i32$0 = $2 + 372 | 0;
                   i64toi32_i32$4 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                   $1219 = i64toi32_i32$4;
                   i64toi32_i32$4 = $2;
                   HEAP32[($2 + 264 | 0) >> 2] = $1219;
                   HEAP32[($2 + 268 | 0) >> 2] = i64toi32_i32$2;
                   i64toi32_i32$0 = ($2 + 312 | 0) + 16 | 0;
                   i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                   i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                   $21 = i64toi32_i32$2;
                   $21$hi = i64toi32_i32$4;
                   i64toi32_i32$0 = $2 + 336 | 0;
                   i64toi32_i32$4 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                   $22 = i64toi32_i32$4;
                   $22$hi = i64toi32_i32$2;
                   $1 = HEAP32[($2 + 368 | 0) >> 2] | 0;
                   $15 = HEAPU8[($2 + 320 | 0) >> 0] | 0;
                   i64toi32_i32$0 = $17;
                   i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                   i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                   $1236 = i64toi32_i32$2;
                   i64toi32_i32$2 = ($2 + 232 | 0) + 8 | 0;
                   HEAP32[i64toi32_i32$2 >> 2] = $1236;
                   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$4;
                   i64toi32_i32$0 = $16;
                   i64toi32_i32$4 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                   $1241 = i64toi32_i32$4;
                   i64toi32_i32$4 = ($2 + 232 | 0) + 16 | 0;
                   HEAP32[i64toi32_i32$4 >> 2] = $1241;
                   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$2;
                   HEAP32[(($2 + 216 | 0) + 8 | 0) >> 2] = HEAP32[$13 >> 2] | 0;
                   $157 = HEAPU8[($2 + 307 | 0) >> 0] | 0 | ((HEAPU8[($2 + 308 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 309 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 310 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                   HEAP8[($2 + 259 | 0) >> 0] = $157;
                   HEAP8[($2 + 260 | 0) >> 0] = $157 >>> 8 | 0;
                   HEAP8[($2 + 261 | 0) >> 0] = $157 >>> 16 | 0;
                   HEAP8[($2 + 262 | 0) >> 0] = $157 >>> 24 | 0;
                   HEAP32[($2 + 256 | 0) >> 2] = HEAP32[($2 + 304 | 0) >> 2] | 0;
                   i64toi32_i32$0 = $2;
                   i64toi32_i32$2 = HEAP32[($2 + 280 | 0) >> 2] | 0;
                   i64toi32_i32$4 = HEAP32[($2 + 284 | 0) >> 2] | 0;
                   $1255 = i64toi32_i32$2;
                   i64toi32_i32$2 = $2;
                   HEAP32[($2 + 232 | 0) >> 2] = $1255;
                   HEAP32[($2 + 236 | 0) >> 2] = i64toi32_i32$4;
                   i64toi32_i32$0 = $2;
                   i64toi32_i32$4 = HEAP32[($2 + 264 | 0) >> 2] | 0;
                   i64toi32_i32$2 = HEAP32[($2 + 268 | 0) >> 2] | 0;
                   $1258 = i64toi32_i32$4;
                   i64toi32_i32$4 = $2;
                   HEAP32[($2 + 216 | 0) >> 2] = $1258;
                   HEAP32[($2 + 220 | 0) >> 2] = i64toi32_i32$2;
                  }
                  i64toi32_i32$2 = $22$hi;
                  i64toi32_i32$4 = ($2 + 312 | 0) + 16 | 0;
                  HEAP32[i64toi32_i32$4 >> 2] = $22;
                  HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$2;
                  i64toi32_i32$2 = $21$hi;
                  i64toi32_i32$4 = ($2 + 312 | 0) + 8 | 0;
                  HEAP32[i64toi32_i32$4 >> 2] = $21;
                  HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$2;
                  i64toi32_i32$0 = $2;
                  i64toi32_i32$2 = HEAP32[($2 + 232 | 0) >> 2] | 0;
                  i64toi32_i32$4 = HEAP32[($2 + 236 | 0) >> 2] | 0;
                  $1271 = i64toi32_i32$2;
                  i64toi32_i32$2 = ($2 + 312 | 0) + 24 | 0;
                  HEAP32[i64toi32_i32$2 >> 2] = $1271;
                  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$4;
                  i64toi32_i32$0 = $2;
                  i64toi32_i32$4 = HEAP32[($2 + 216 | 0) >> 2] | 0;
                  i64toi32_i32$2 = HEAP32[($2 + 220 | 0) >> 2] | 0;
                  $1276 = i64toi32_i32$4;
                  i64toi32_i32$4 = ($2 + 312 | 0) + 52 | 0;
                  HEAP32[i64toi32_i32$4 >> 2] = $1276;
                  HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$2;
                  i64toi32_i32$0 = ($2 + 232 | 0) + 8 | 0;
                  i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                  i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                  $1283 = i64toi32_i32$2;
                  i64toi32_i32$2 = ($2 + 312 | 0) + 32 | 0;
                  HEAP32[i64toi32_i32$2 >> 2] = $1283;
                  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$4;
                  i64toi32_i32$0 = ($2 + 232 | 0) + 16 | 0;
                  i64toi32_i32$4 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                  $1290 = i64toi32_i32$4;
                  i64toi32_i32$4 = ($2 + 312 | 0) + 40 | 0;
                  HEAP32[i64toi32_i32$4 >> 2] = $1290;
                  HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$2;
                  HEAP32[(($2 + 312 | 0) + 60 | 0) >> 2] = HEAP32[(($2 + 216 | 0) + 8 | 0) >> 2] | 0;
                  HEAP8[($2 + 312 | 0) >> 0] = $15;
                  $158 = HEAP32[($2 + 256 | 0) >> 2] | 0;
                  HEAP8[($2 + 313 | 0) >> 0] = $158;
                  HEAP8[($2 + 314 | 0) >> 0] = $158 >>> 8 | 0;
                  HEAP8[($2 + 315 | 0) >> 0] = $158 >>> 16 | 0;
                  HEAP8[($2 + 316 | 0) >> 0] = $158 >>> 24 | 0;
                  $159 = HEAPU8[($2 + 259 | 0) >> 0] | 0 | ((HEAPU8[($2 + 260 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 261 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 262 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                  HEAP8[($2 + 316 | 0) >> 0] = $159;
                  HEAP8[($2 + 317 | 0) >> 0] = $159 >>> 8 | 0;
                  HEAP8[($2 + 318 | 0) >> 0] = $159 >>> 16 | 0;
                  HEAP8[($2 + 319 | 0) >> 0] = $159 >>> 24 | 0;
                  HEAP32[($2 + 360 | 0) >> 2] = $1;
                  cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($14 | 0, $2 + 312 | 0 | 0, 1051677 | 0, 14 | 0);
                  HEAP32[(($2 + 280 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 192 | 0) >> 2] | 0;
                  $1 = ($2 + 136 | 0) + 4 | 0;
                  HEAP16[$1 >> 1] = HEAPU16[($5 + 4 | 0) >> 1] | 0;
                  i64toi32_i32$0 = ($2 + 144 | 0) + 40 | 0;
                  i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                  i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                  $1328 = i64toi32_i32$2;
                  i64toi32_i32$2 = $2;
                  HEAP32[($2 + 280 | 0) >> 2] = $1328;
                  HEAP32[($2 + 284 | 0) >> 2] = i64toi32_i32$4;
                  HEAP32[($2 + 136 | 0) >> 2] = HEAPU16[$5 >> 1] | 0 | ((HEAPU16[($5 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
                  $13 = HEAP32[(($2 + 144 | 0) + 16 | 0) >> 2] | 0;
                  $6 = HEAP32[($2 + 164 | 0) >> 2] | 0;
                  i64toi32_i32$0 = ($2 + 144 | 0) + 24 | 0;
                  i64toi32_i32$4 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                  $24 = i64toi32_i32$4;
                  $24$hi = i64toi32_i32$2;
                  i64toi32_i32$0 = ($2 + 144 | 0) + 32 | 0;
                  i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                  i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                  $23 = i64toi32_i32$2;
                  $23$hi = i64toi32_i32$4;
                  $5 = HEAP32[($2 + 212 | 0) >> 2] | 0;
                  i64toi32_i32$0 = ($2 + 144 | 0) + 60 | 0;
                  i64toi32_i32$4 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                  $26 = i64toi32_i32$4;
                  $26$hi = i64toi32_i32$2;
                  $17 = HEAP32[($2 + 200 | 0) >> 2] | 0;
                  $7 = HEAP32[(($2 + 144 | 0) + 52 | 0) >> 2] | 0;
                  $16 = HEAPU8[($2 + 152 | 0) >> 0] | 0;
                  $15 = HEAPU8[($2 + 153 | 0) >> 0] | 0;
                  HEAP16[(($2 + 232 | 0) + 4 | 0) >> 1] = HEAPU16[$1 >> 1] | 0;
                  HEAP32[($2 + 232 | 0) >> 2] = HEAP32[($2 + 136 | 0) >> 2] | 0;
                  break label$4;
                 }
                 label$49 : {
                  label$50 : {
                   i64toi32_i32$2 = $22$hi;
                   i64toi32_i32$0 = $22;
                   i64toi32_i32$4 = 0;
                   i64toi32_i32$1 = 1;
                   if ((i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$4 | 0) | 0) {
                    break label$50
                   }
                   i64toi32_i32$0 = $23$hi;
                   i64toi32_i32$1 = $23;
                   i64toi32_i32$2 = 0;
                   i64toi32_i32$4 = 1;
                   i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
                   i64toi32_i32$3 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
                   if (i64toi32_i32$5 >>> 0 < i64toi32_i32$4 >>> 0) {
                    i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
                   }
                   $23 = i64toi32_i32$5;
                   $23$hi = i64toi32_i32$3;
                   i64toi32_i32$3 = $21$hi;
                   i64toi32_i32$3 = $23$hi;
                   i64toi32_i32$0 = i64toi32_i32$5;
                   i64toi32_i32$1 = $21$hi;
                   i64toi32_i32$4 = $21;
                   if (i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$0 >>> 0 <= i64toi32_i32$4 >>> 0 | 0) | 0) {
                    break label$50
                   }
                   i64toi32_i32$0 = 0;
                   $22 = 0;
                   $22$hi = i64toi32_i32$0;
                   $1 = 0;
                   $15 = 3;
                   break label$49;
                  }
                  $cardano_serialization_lib__crypto__Vkeywitnesses_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h427f277ac56c0c7f($2 + 312 | 0 | 0, $1 | 0);
                  if ((HEAP32[($2 + 312 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                   break label$19
                  }
                  $17 = ($2 + 280 | 0) + 8 | 0;
                  i64toi32_i32$4 = $2 + 352 | 0;
                  i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                  i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                  $1392 = i64toi32_i32$0;
                  i64toi32_i32$0 = $17;
                  HEAP32[i64toi32_i32$0 >> 2] = $1392;
                  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
                  $16 = ($2 + 280 | 0) + 16 | 0;
                  i64toi32_i32$4 = $2 + 360 | 0;
                  i64toi32_i32$3 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                  i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                  $1399 = i64toi32_i32$3;
                  i64toi32_i32$3 = $16;
                  HEAP32[i64toi32_i32$3 >> 2] = $1399;
                  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
                  $13 = ($2 + 264 | 0) + 8 | 0;
                  HEAP32[$13 >> 2] = HEAP32[($2 + 380 | 0) >> 2] | 0;
                  HEAP32[($2 + 304 | 0) >> 2] = HEAPU8[$7 >> 0] | 0 | ((HEAPU8[($7 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($7 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($7 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                  $160 = $7 + 3 | 0;
                  $161 = HEAPU8[$160 >> 0] | 0 | ((HEAPU8[($160 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($160 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($160 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                  HEAP8[($2 + 307 | 0) >> 0] = $161;
                  HEAP8[($2 + 308 | 0) >> 0] = $161 >>> 8 | 0;
                  HEAP8[($2 + 309 | 0) >> 0] = $161 >>> 16 | 0;
                  HEAP8[($2 + 310 | 0) >> 0] = $161 >>> 24 | 0;
                  i64toi32_i32$4 = $2 + 344 | 0;
                  i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                  i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                  $1417 = i64toi32_i32$0;
                  i64toi32_i32$0 = $2;
                  HEAP32[($2 + 280 | 0) >> 2] = $1417;
                  HEAP32[($2 + 284 | 0) >> 2] = i64toi32_i32$3;
                  i64toi32_i32$4 = $2 + 372 | 0;
                  i64toi32_i32$3 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                  i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                  $1421 = i64toi32_i32$3;
                  i64toi32_i32$3 = $2;
                  HEAP32[($2 + 264 | 0) >> 2] = $1421;
                  HEAP32[($2 + 268 | 0) >> 2] = i64toi32_i32$0;
                  i64toi32_i32$4 = ($2 + 312 | 0) + 16 | 0;
                  i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                  i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                  $21 = i64toi32_i32$0;
                  $21$hi = i64toi32_i32$3;
                  i64toi32_i32$4 = $2 + 336 | 0;
                  i64toi32_i32$3 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                  i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                  $22 = i64toi32_i32$3;
                  $22$hi = i64toi32_i32$0;
                  $1 = HEAP32[($2 + 368 | 0) >> 2] | 0;
                  $15 = HEAPU8[($2 + 320 | 0) >> 0] | 0;
                  i64toi32_i32$4 = $17;
                  i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                  i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                  $1438 = i64toi32_i32$0;
                  i64toi32_i32$0 = ($2 + 232 | 0) + 8 | 0;
                  HEAP32[i64toi32_i32$0 >> 2] = $1438;
                  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
                  i64toi32_i32$4 = $16;
                  i64toi32_i32$3 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                  i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                  $1443 = i64toi32_i32$3;
                  i64toi32_i32$3 = ($2 + 232 | 0) + 16 | 0;
                  HEAP32[i64toi32_i32$3 >> 2] = $1443;
                  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
                  HEAP32[(($2 + 216 | 0) + 8 | 0) >> 2] = HEAP32[$13 >> 2] | 0;
                  $162 = HEAPU8[($2 + 307 | 0) >> 0] | 0 | ((HEAPU8[($2 + 308 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 309 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 310 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                  HEAP8[($2 + 259 | 0) >> 0] = $162;
                  HEAP8[($2 + 260 | 0) >> 0] = $162 >>> 8 | 0;
                  HEAP8[($2 + 261 | 0) >> 0] = $162 >>> 16 | 0;
                  HEAP8[($2 + 262 | 0) >> 0] = $162 >>> 24 | 0;
                  HEAP32[($2 + 256 | 0) >> 2] = HEAP32[($2 + 304 | 0) >> 2] | 0;
                  i64toi32_i32$4 = $2;
                  i64toi32_i32$0 = HEAP32[($2 + 280 | 0) >> 2] | 0;
                  i64toi32_i32$3 = HEAP32[($2 + 284 | 0) >> 2] | 0;
                  $1457 = i64toi32_i32$0;
                  i64toi32_i32$0 = $2;
                  HEAP32[($2 + 232 | 0) >> 2] = $1457;
                  HEAP32[($2 + 236 | 0) >> 2] = i64toi32_i32$3;
                  i64toi32_i32$4 = $2;
                  i64toi32_i32$3 = HEAP32[($2 + 264 | 0) >> 2] | 0;
                  i64toi32_i32$0 = HEAP32[($2 + 268 | 0) >> 2] | 0;
                  $1460 = i64toi32_i32$3;
                  i64toi32_i32$3 = $2;
                  HEAP32[($2 + 216 | 0) >> 2] = $1460;
                  HEAP32[($2 + 220 | 0) >> 2] = i64toi32_i32$0;
                 }
                 i64toi32_i32$0 = $22$hi;
                 i64toi32_i32$3 = ($2 + 312 | 0) + 16 | 0;
                 HEAP32[i64toi32_i32$3 >> 2] = $22;
                 HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
                 i64toi32_i32$0 = $21$hi;
                 i64toi32_i32$3 = ($2 + 312 | 0) + 8 | 0;
                 HEAP32[i64toi32_i32$3 >> 2] = $21;
                 HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
                 i64toi32_i32$4 = $2;
                 i64toi32_i32$0 = HEAP32[($2 + 232 | 0) >> 2] | 0;
                 i64toi32_i32$3 = HEAP32[($2 + 236 | 0) >> 2] | 0;
                 $1473 = i64toi32_i32$0;
                 i64toi32_i32$0 = ($2 + 312 | 0) + 24 | 0;
                 HEAP32[i64toi32_i32$0 >> 2] = $1473;
                 HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
                 i64toi32_i32$4 = $2;
                 i64toi32_i32$3 = HEAP32[($2 + 216 | 0) >> 2] | 0;
                 i64toi32_i32$0 = HEAP32[($2 + 220 | 0) >> 2] | 0;
                 $1478 = i64toi32_i32$3;
                 i64toi32_i32$3 = ($2 + 312 | 0) + 52 | 0;
                 HEAP32[i64toi32_i32$3 >> 2] = $1478;
                 HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
                 i64toi32_i32$4 = ($2 + 232 | 0) + 8 | 0;
                 i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                 i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                 $1485 = i64toi32_i32$0;
                 i64toi32_i32$0 = ($2 + 312 | 0) + 32 | 0;
                 HEAP32[i64toi32_i32$0 >> 2] = $1485;
                 HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
                 i64toi32_i32$4 = ($2 + 232 | 0) + 16 | 0;
                 i64toi32_i32$3 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                 i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                 $1492 = i64toi32_i32$3;
                 i64toi32_i32$3 = ($2 + 312 | 0) + 40 | 0;
                 HEAP32[i64toi32_i32$3 >> 2] = $1492;
                 HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
                 HEAP32[(($2 + 312 | 0) + 60 | 0) >> 2] = HEAP32[(($2 + 216 | 0) + 8 | 0) >> 2] | 0;
                 HEAP8[($2 + 312 | 0) >> 0] = $15;
                 $164 = HEAP32[($2 + 256 | 0) >> 2] | 0;
                 HEAP8[($2 + 313 | 0) >> 0] = $164;
                 HEAP8[($2 + 314 | 0) >> 0] = $164 >>> 8 | 0;
                 HEAP8[($2 + 315 | 0) >> 0] = $164 >>> 16 | 0;
                 HEAP8[($2 + 316 | 0) >> 0] = $164 >>> 24 | 0;
                 $165 = HEAPU8[($2 + 259 | 0) >> 0] | 0 | ((HEAPU8[($2 + 260 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 261 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 262 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 HEAP8[($2 + 316 | 0) >> 0] = $165;
                 HEAP8[($2 + 317 | 0) >> 0] = $165 >>> 8 | 0;
                 HEAP8[($2 + 318 | 0) >> 0] = $165 >>> 16 | 0;
                 HEAP8[($2 + 319 | 0) >> 0] = $165 >>> 24 | 0;
                 HEAP32[($2 + 360 | 0) >> 2] = $1;
                 cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($14 | 0, $2 + 312 | 0 | 0, 1051672 | 0, 5 | 0);
                 HEAP32[(($2 + 280 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 192 | 0) >> 2] | 0;
                 $1 = ($2 + 136 | 0) + 4 | 0;
                 HEAP16[$1 >> 1] = HEAPU16[($5 + 4 | 0) >> 1] | 0;
                 i64toi32_i32$4 = ($2 + 144 | 0) + 40 | 0;
                 i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                 i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                 $1530 = i64toi32_i32$0;
                 i64toi32_i32$0 = $2;
                 HEAP32[($2 + 280 | 0) >> 2] = $1530;
                 HEAP32[($2 + 284 | 0) >> 2] = i64toi32_i32$3;
                 HEAP32[($2 + 136 | 0) >> 2] = HEAPU16[$5 >> 1] | 0 | ((HEAPU16[($5 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
                 $13 = HEAP32[(($2 + 144 | 0) + 16 | 0) >> 2] | 0;
                 $6 = HEAP32[($2 + 164 | 0) >> 2] | 0;
                 i64toi32_i32$4 = ($2 + 144 | 0) + 24 | 0;
                 i64toi32_i32$3 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                 i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                 $24 = i64toi32_i32$3;
                 $24$hi = i64toi32_i32$0;
                 i64toi32_i32$4 = ($2 + 144 | 0) + 32 | 0;
                 i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                 i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                 $23 = i64toi32_i32$0;
                 $23$hi = i64toi32_i32$3;
                 $5 = HEAP32[($2 + 212 | 0) >> 2] | 0;
                 i64toi32_i32$4 = ($2 + 144 | 0) + 60 | 0;
                 i64toi32_i32$3 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                 i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                 $26 = i64toi32_i32$3;
                 $26$hi = i64toi32_i32$0;
                 $17 = HEAP32[($2 + 200 | 0) >> 2] | 0;
                 $7 = HEAP32[(($2 + 144 | 0) + 52 | 0) >> 2] | 0;
                 $16 = HEAPU8[($2 + 152 | 0) >> 0] | 0;
                 $15 = HEAPU8[($2 + 153 | 0) >> 0] | 0;
                 HEAP16[(($2 + 232 | 0) + 4 | 0) >> 1] = HEAPU16[$1 >> 1] | 0;
                 HEAP32[($2 + 232 | 0) >> 2] = HEAP32[($2 + 136 | 0) >> 2] | 0;
                 break label$4;
                }
                HEAP32[($2 + 304 | 0) >> 2] = HEAPU8[$7 >> 0] | 0 | ((HEAPU8[($7 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($7 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($7 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                $166 = $7 + 3 | 0;
                $167 = HEAPU8[$166 >> 0] | 0 | ((HEAPU8[($166 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($166 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($166 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                HEAP8[($2 + 307 | 0) >> 0] = $167;
                HEAP8[($2 + 308 | 0) >> 0] = $167 >>> 8 | 0;
                HEAP8[($2 + 309 | 0) >> 0] = $167 >>> 16 | 0;
                HEAP8[($2 + 310 | 0) >> 0] = $167 >>> 24 | 0;
                HEAP32[($2 + 256 | 0) >> 2] = HEAP32[($2 + 304 | 0) >> 2] | 0;
                $168 = HEAPU8[($2 + 307 | 0) >> 0] | 0 | ((HEAPU8[($2 + 308 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 309 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 310 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                HEAP8[($2 + 259 | 0) >> 0] = $168;
                HEAP8[($2 + 260 | 0) >> 0] = $168 >>> 8 | 0;
                HEAP8[($2 + 261 | 0) >> 0] = $168 >>> 16 | 0;
                HEAP8[($2 + 262 | 0) >> 0] = $168 >>> 24 | 0;
                $15 = HEAPU8[($2 + 320 | 0) >> 0] | 0;
                HEAP8[($2 + 152 | 0) >> 0] = $15;
                $17 = HEAP32[($2 + 316 | 0) >> 2] | 0;
                HEAP32[($2 + 148 | 0) >> 2] = $17;
                $18 = HEAP32[($2 + 328 | 0) >> 2] | 0;
                $169 = HEAP32[($2 + 256 | 0) >> 2] | 0;
                HEAP8[$6 >> 0] = $169;
                HEAP8[($6 + 1 | 0) >> 0] = $169 >>> 8 | 0;
                HEAP8[($6 + 2 | 0) >> 0] = $169 >>> 16 | 0;
                HEAP8[($6 + 3 | 0) >> 0] = $169 >>> 24 | 0;
                $170 = $6 + 3 | 0;
                $171 = HEAPU8[($2 + 259 | 0) >> 0] | 0 | ((HEAPU8[($2 + 260 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 261 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 262 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                HEAP8[$170 >> 0] = $171;
                HEAP8[($170 + 1 | 0) >> 0] = $171 >>> 8 | 0;
                HEAP8[($170 + 2 | 0) >> 0] = $171 >>> 16 | 0;
                HEAP8[($170 + 3 | 0) >> 0] = $171 >>> 24 | 0;
                $19 = HEAPU8[($2 + 153 | 0) >> 0] | 0;
                $20 = ($2 + 136 | 0) + 4 | 0;
                HEAP16[$20 >> 1] = HEAPU16[($5 + 4 | 0) >> 1] | 0;
                HEAP32[($2 + 136 | 0) >> 2] = HEAPU16[$5 >> 1] | 0 | ((HEAPU16[($5 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
                core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__plutus__PlutusList____h410d2d25125e861e($2 + 88 | 0 | 0);
                $200 = HEAP32[($2 + 136 | 0) >> 2] | 0;
                HEAP16[$11 >> 1] = $200;
                HEAP16[($11 + 2 | 0) >> 1] = $200 >>> 16 | 0;
                HEAP16[($11 + 4 | 0) >> 1] = HEAPU16[$20 >> 1] | 0;
                HEAP8[($2 + 93 | 0) >> 0] = $19;
                HEAP8[($2 + 92 | 0) >> 0] = $15;
                HEAP32[($2 + 88 | 0) >> 2] = $17;
                HEAP32[($2 + 100 | 0) >> 2] = $18;
                break label$18;
               }
               HEAP32[($2 + 304 | 0) >> 2] = HEAPU8[$7 >> 0] | 0 | ((HEAPU8[($7 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($7 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($7 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
               $172 = $7 + 3 | 0;
               $173 = HEAPU8[$172 >> 0] | 0 | ((HEAPU8[($172 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($172 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($172 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
               HEAP8[($2 + 307 | 0) >> 0] = $173;
               HEAP8[($2 + 308 | 0) >> 0] = $173 >>> 8 | 0;
               HEAP8[($2 + 309 | 0) >> 0] = $173 >>> 16 | 0;
               HEAP8[($2 + 310 | 0) >> 0] = $173 >>> 24 | 0;
               HEAP32[($2 + 256 | 0) >> 2] = HEAP32[($2 + 304 | 0) >> 2] | 0;
               $174 = HEAPU8[($2 + 307 | 0) >> 0] | 0 | ((HEAPU8[($2 + 308 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 309 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 310 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
               HEAP8[($2 + 259 | 0) >> 0] = $174;
               HEAP8[($2 + 260 | 0) >> 0] = $174 >>> 8 | 0;
               HEAP8[($2 + 261 | 0) >> 0] = $174 >>> 16 | 0;
               HEAP8[($2 + 262 | 0) >> 0] = $174 >>> 24 | 0;
               $15 = HEAP32[($2 + 316 | 0) >> 2] | 0;
               $17 = HEAPU8[($2 + 320 | 0) >> 0] | 0;
               $175 = HEAP32[($2 + 256 | 0) >> 2] | 0;
               HEAP8[$6 >> 0] = $175;
               HEAP8[($6 + 1 | 0) >> 0] = $175 >>> 8 | 0;
               HEAP8[($6 + 2 | 0) >> 0] = $175 >>> 16 | 0;
               HEAP8[($6 + 3 | 0) >> 0] = $175 >>> 24 | 0;
               $176 = $6 + 3 | 0;
               $177 = HEAPU8[($2 + 259 | 0) >> 0] | 0 | ((HEAPU8[($2 + 260 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 261 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 262 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
               HEAP8[$176 >> 0] = $177;
               HEAP8[($176 + 1 | 0) >> 0] = $177 >>> 8 | 0;
               HEAP8[($176 + 2 | 0) >> 0] = $177 >>> 16 | 0;
               HEAP8[($176 + 3 | 0) >> 0] = $177 >>> 24 | 0;
               HEAP8[($2 + 152 | 0) >> 0] = $17;
               HEAP32[($2 + 148 | 0) >> 2] = $15;
               $18 = HEAPU8[($2 + 153 | 0) >> 0] | 0;
               $19 = ($2 + 136 | 0) + 4 | 0;
               HEAP16[$19 >> 1] = HEAPU16[($5 + 4 | 0) >> 1] | 0;
               HEAP32[($2 + 136 | 0) >> 2] = HEAPU16[$5 >> 1] | 0 | ((HEAPU16[($5 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
               core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__plutus__PlutusScripts____h6be1d55eac328b7f($2 + 72 | 0 | 0);
               $201 = HEAP32[($2 + 136 | 0) >> 2] | 0;
               HEAP16[$10 >> 1] = $201;
               HEAP16[($10 + 2 | 0) >> 1] = $201 >>> 16 | 0;
               HEAP16[($10 + 4 | 0) >> 1] = HEAPU16[$19 >> 1] | 0;
               HEAP8[($2 + 77 | 0) >> 0] = $18;
               HEAP8[($2 + 76 | 0) >> 0] = $17;
               HEAP32[($2 + 72 | 0) >> 2] = $15;
               break label$18;
              }
              HEAP32[($2 + 304 | 0) >> 2] = HEAPU8[$7 >> 0] | 0 | ((HEAPU8[($7 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($7 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($7 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              $178 = $7 + 3 | 0;
              $179 = HEAPU8[$178 >> 0] | 0 | ((HEAPU8[($178 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($178 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($178 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              HEAP8[($2 + 307 | 0) >> 0] = $179;
              HEAP8[($2 + 308 | 0) >> 0] = $179 >>> 8 | 0;
              HEAP8[($2 + 309 | 0) >> 0] = $179 >>> 16 | 0;
              HEAP8[($2 + 310 | 0) >> 0] = $179 >>> 24 | 0;
              HEAP32[($2 + 256 | 0) >> 2] = HEAP32[($2 + 304 | 0) >> 2] | 0;
              $180 = HEAPU8[($2 + 307 | 0) >> 0] | 0 | ((HEAPU8[($2 + 308 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 309 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 310 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              HEAP8[($2 + 259 | 0) >> 0] = $180;
              HEAP8[($2 + 260 | 0) >> 0] = $180 >>> 8 | 0;
              HEAP8[($2 + 261 | 0) >> 0] = $180 >>> 16 | 0;
              HEAP8[($2 + 262 | 0) >> 0] = $180 >>> 24 | 0;
              $15 = HEAP32[($2 + 316 | 0) >> 2] | 0;
              $17 = HEAPU8[($2 + 320 | 0) >> 0] | 0;
              $181 = HEAP32[($2 + 256 | 0) >> 2] | 0;
              HEAP8[$6 >> 0] = $181;
              HEAP8[($6 + 1 | 0) >> 0] = $181 >>> 8 | 0;
              HEAP8[($6 + 2 | 0) >> 0] = $181 >>> 16 | 0;
              HEAP8[($6 + 3 | 0) >> 0] = $181 >>> 24 | 0;
              $182 = $6 + 3 | 0;
              $183 = HEAPU8[($2 + 259 | 0) >> 0] | 0 | ((HEAPU8[($2 + 260 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 261 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 262 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              HEAP8[$182 >> 0] = $183;
              HEAP8[($182 + 1 | 0) >> 0] = $183 >>> 8 | 0;
              HEAP8[($182 + 2 | 0) >> 0] = $183 >>> 16 | 0;
              HEAP8[($182 + 3 | 0) >> 0] = $183 >>> 24 | 0;
              HEAP8[($2 + 152 | 0) >> 0] = $17;
              HEAP32[($2 + 148 | 0) >> 2] = $15;
              $18 = HEAPU8[($2 + 153 | 0) >> 0] | 0;
              $19 = ($2 + 136 | 0) + 4 | 0;
              HEAP16[$19 >> 1] = HEAPU16[($5 + 4 | 0) >> 1] | 0;
              HEAP32[($2 + 136 | 0) >> 2] = HEAPU16[$5 >> 1] | 0 | ((HEAPU16[($5 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
              core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__crypto__BootstrapWitnesses____h365708acbcf06e1e($2 + 56 | 0 | 0);
              $202 = HEAP32[($2 + 136 | 0) >> 2] | 0;
              HEAP16[$9 >> 1] = $202;
              HEAP16[($9 + 2 | 0) >> 1] = $202 >>> 16 | 0;
              HEAP16[($9 + 4 | 0) >> 1] = HEAPU16[$19 >> 1] | 0;
              HEAP8[($2 + 61 | 0) >> 0] = $18;
              HEAP8[($2 + 60 | 0) >> 0] = $17;
              HEAP32[($2 + 56 | 0) >> 2] = $15;
              break label$18;
             }
             HEAP32[($2 + 304 | 0) >> 2] = HEAPU8[$7 >> 0] | 0 | ((HEAPU8[($7 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($7 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($7 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             $184 = $7 + 3 | 0;
             $185 = HEAPU8[$184 >> 0] | 0 | ((HEAPU8[($184 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($184 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($184 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             HEAP8[($2 + 307 | 0) >> 0] = $185;
             HEAP8[($2 + 308 | 0) >> 0] = $185 >>> 8 | 0;
             HEAP8[($2 + 309 | 0) >> 0] = $185 >>> 16 | 0;
             HEAP8[($2 + 310 | 0) >> 0] = $185 >>> 24 | 0;
             HEAP32[($2 + 256 | 0) >> 2] = HEAP32[($2 + 304 | 0) >> 2] | 0;
             $186 = HEAPU8[($2 + 307 | 0) >> 0] | 0 | ((HEAPU8[($2 + 308 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 309 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 310 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             HEAP8[($2 + 259 | 0) >> 0] = $186;
             HEAP8[($2 + 260 | 0) >> 0] = $186 >>> 8 | 0;
             HEAP8[($2 + 261 | 0) >> 0] = $186 >>> 16 | 0;
             HEAP8[($2 + 262 | 0) >> 0] = $186 >>> 24 | 0;
             $15 = HEAP32[($2 + 316 | 0) >> 2] | 0;
             $17 = HEAPU8[($2 + 320 | 0) >> 0] | 0;
             $187 = HEAP32[($2 + 256 | 0) >> 2] | 0;
             HEAP8[$6 >> 0] = $187;
             HEAP8[($6 + 1 | 0) >> 0] = $187 >>> 8 | 0;
             HEAP8[($6 + 2 | 0) >> 0] = $187 >>> 16 | 0;
             HEAP8[($6 + 3 | 0) >> 0] = $187 >>> 24 | 0;
             $188 = $6 + 3 | 0;
             $189 = HEAPU8[($2 + 259 | 0) >> 0] | 0 | ((HEAPU8[($2 + 260 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 261 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 262 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             HEAP8[$188 >> 0] = $189;
             HEAP8[($188 + 1 | 0) >> 0] = $189 >>> 8 | 0;
             HEAP8[($188 + 2 | 0) >> 0] = $189 >>> 16 | 0;
             HEAP8[($188 + 3 | 0) >> 0] = $189 >>> 24 | 0;
             HEAP8[($2 + 152 | 0) >> 0] = $17;
             HEAP32[($2 + 148 | 0) >> 2] = $15;
             $18 = HEAPU8[($2 + 153 | 0) >> 0] | 0;
             $19 = ($2 + 136 | 0) + 4 | 0;
             HEAP16[$19 >> 1] = HEAPU16[($5 + 4 | 0) >> 1] | 0;
             HEAP32[($2 + 136 | 0) >> 2] = HEAPU16[$5 >> 1] | 0 | ((HEAPU16[($5 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
             core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__NativeScripts____hdd7d461255ec800a($2 + 40 | 0 | 0);
             $203 = HEAP32[($2 + 136 | 0) >> 2] | 0;
             HEAP16[$8 >> 1] = $203;
             HEAP16[($8 + 2 | 0) >> 1] = $203 >>> 16 | 0;
             HEAP16[($8 + 4 | 0) >> 1] = HEAPU16[$19 >> 1] | 0;
             HEAP8[($2 + 45 | 0) >> 0] = $18;
             HEAP8[($2 + 44 | 0) >> 0] = $17;
             HEAP32[($2 + 40 | 0) >> 2] = $15;
             break label$18;
            }
            HEAP32[($2 + 304 | 0) >> 2] = HEAPU8[$7 >> 0] | 0 | ((HEAPU8[($7 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($7 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($7 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            $190 = $7 + 3 | 0;
            $192 = HEAPU8[$190 >> 0] | 0 | ((HEAPU8[($190 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($190 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($190 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            HEAP8[($2 + 307 | 0) >> 0] = $192;
            HEAP8[($2 + 308 | 0) >> 0] = $192 >>> 8 | 0;
            HEAP8[($2 + 309 | 0) >> 0] = $192 >>> 16 | 0;
            HEAP8[($2 + 310 | 0) >> 0] = $192 >>> 24 | 0;
            HEAP32[($2 + 256 | 0) >> 2] = HEAP32[($2 + 304 | 0) >> 2] | 0;
            $193 = HEAPU8[($2 + 307 | 0) >> 0] | 0 | ((HEAPU8[($2 + 308 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 309 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 310 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            HEAP8[($2 + 259 | 0) >> 0] = $193;
            HEAP8[($2 + 260 | 0) >> 0] = $193 >>> 8 | 0;
            HEAP8[($2 + 261 | 0) >> 0] = $193 >>> 16 | 0;
            HEAP8[($2 + 262 | 0) >> 0] = $193 >>> 24 | 0;
            $15 = HEAP32[($2 + 316 | 0) >> 2] | 0;
            $17 = HEAPU8[($2 + 320 | 0) >> 0] | 0;
            $194 = HEAP32[($2 + 256 | 0) >> 2] | 0;
            HEAP8[$6 >> 0] = $194;
            HEAP8[($6 + 1 | 0) >> 0] = $194 >>> 8 | 0;
            HEAP8[($6 + 2 | 0) >> 0] = $194 >>> 16 | 0;
            HEAP8[($6 + 3 | 0) >> 0] = $194 >>> 24 | 0;
            $195 = $6 + 3 | 0;
            $196 = HEAPU8[($2 + 259 | 0) >> 0] | 0 | ((HEAPU8[($2 + 260 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 261 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 262 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            HEAP8[$195 >> 0] = $196;
            HEAP8[($195 + 1 | 0) >> 0] = $196 >>> 8 | 0;
            HEAP8[($195 + 2 | 0) >> 0] = $196 >>> 16 | 0;
            HEAP8[($195 + 3 | 0) >> 0] = $196 >>> 24 | 0;
            HEAP8[($2 + 152 | 0) >> 0] = $17;
            HEAP32[($2 + 148 | 0) >> 2] = $15;
            $18 = HEAPU8[($2 + 153 | 0) >> 0] | 0;
            $19 = ($2 + 136 | 0) + 4 | 0;
            HEAP16[$19 >> 1] = HEAPU16[($5 + 4 | 0) >> 1] | 0;
            HEAP32[($2 + 136 | 0) >> 2] = HEAPU16[$5 >> 1] | 0 | ((HEAPU16[($5 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
            HEAP8[($2 + 29 | 0) >> 0] = $18;
            HEAP8[($2 + 28 | 0) >> 0] = $17;
            HEAP32[($2 + 24 | 0) >> 2] = $15;
            $204 = HEAP32[($2 + 136 | 0) >> 2] | 0;
            HEAP16[$4 >> 1] = $204;
            HEAP16[($4 + 2 | 0) >> 1] = $204 >>> 16 | 0;
            HEAP16[($4 + 4 | 0) >> 1] = HEAPU16[$19 >> 1] | 0;
           }
           $15 = $16 + 1 | 0;
           i64toi32_i32$0 = $22$hi;
           i64toi32_i32$4 = $22;
           i64toi32_i32$3 = 0;
           i64toi32_i32$1 = 1;
           if ((i64toi32_i32$4 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$3 | 0) | 0) {
            continue label$10
           }
           if ($16 >>> 0 < $3 >>> 0) {
            continue label$10
           }
           break label$5;
          };
         }
         HEAP32[($2 + 288 | 0) >> 2] = HEAP32[($2 + 352 | 0) >> 2] | 0;
         i64toi32_i32$1 = $2 + 344 | 0;
         i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
         $23 = i64toi32_i32$4;
         $23$hi = i64toi32_i32$0;
         i64toi32_i32$4 = $2;
         HEAP32[($2 + 144 | 0) >> 2] = $23;
         HEAP32[($2 + 148 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$4 = $2;
         HEAP32[($2 + 280 | 0) >> 2] = $23;
         HEAP32[($2 + 284 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$0 = $22$hi;
         i64toi32_i32$1 = $22;
         i64toi32_i32$4 = 0;
         i64toi32_i32$3 = 32;
         i64toi32_i32$2 = i64toi32_i32$3 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
          i64toi32_i32$4 = 0;
          $205 = i64toi32_i32$0 >>> i64toi32_i32$2 | 0;
         } else {
          i64toi32_i32$4 = i64toi32_i32$0 >>> i64toi32_i32$2 | 0;
          $205 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$2 | 0) | 0;
         }
         $6 = $205;
         i64toi32_i32$0 = $2 + 336 | 0;
         i64toi32_i32$4 = HEAP32[i64toi32_i32$0 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
         $23 = i64toi32_i32$4;
         $23$hi = i64toi32_i32$1;
         $7 = HEAP32[($2 + 356 | 0) >> 2] | 0;
         i64toi32_i32$1 = $22$hi;
         $13 = $22;
         $16 = 2;
         $17 = 0;
         i64toi32_i32$1 = $21$hi;
         $24 = $21;
         $24$hi = i64toi32_i32$1;
         break label$2;
        }
       }
       $13 = 1;
       break label$4;
      }
      i64toi32_i32$1 = $22$hi;
      i64toi32_i32$0 = $22;
      i64toi32_i32$4 = 0;
      i64toi32_i32$3 = 1;
      if ((i64toi32_i32$0 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$4 | 0) | 0) {
       break label$3
      }
      i64toi32_i32$0 = $23$hi;
      i64toi32_i32$0 = $21$hi;
      i64toi32_i32$0 = $23$hi;
      i64toi32_i32$3 = $23;
      i64toi32_i32$1 = $21$hi;
      i64toi32_i32$4 = $21;
      if ((i64toi32_i32$3 | 0) == (i64toi32_i32$4 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
       break label$3
      }
      i64toi32_i32$3 = $21$hi;
      i64toi32_i32$4 = $21;
      i64toi32_i32$0 = 0;
      i64toi32_i32$1 = 32;
      i64toi32_i32$2 = i64toi32_i32$1 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
       i64toi32_i32$0 = 0;
       $206 = i64toi32_i32$3 >>> i64toi32_i32$2 | 0;
      } else {
       i64toi32_i32$0 = i64toi32_i32$3 >>> i64toi32_i32$2 | 0;
       $206 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$2 | 0) | 0;
      }
      $6 = $206;
      $16 = 3;
      $17 = 0;
      i64toi32_i32$0 = 0;
      $24 = 1;
      $24$hi = i64toi32_i32$0;
      $13 = $3;
     }
     core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__plutus__Redeemers____hd7679bbdd61edccb($2 + 104 | 0 | 0);
     core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__plutus__PlutusList____h410d2d25125e861e($2 + 88 | 0 | 0);
     core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__plutus__PlutusScripts____h6be1d55eac328b7f($2 + 72 | 0 | 0);
     core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__crypto__BootstrapWitnesses____h365708acbcf06e1e($2 + 56 | 0 | 0);
     core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__NativeScripts____hdd7d461255ec800a($2 + 40 | 0 | 0);
     if (!(HEAP32[($2 + 24 | 0) >> 2] | 0)) {
      break label$2
     }
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hdd0c057252922c46($2 + 24 | 0 | 0);
     break label$2;
    }
    $1 = $2 + 236 | 0;
    HEAP16[$1 >> 1] = HEAPU16[($2 + 34 | 0) >> 1] | 0;
    $15 = ($2 + 280 | 0) + 8 | 0;
    HEAP32[$15 >> 2] = HEAP32[(($2 + 72 | 0) + 8 | 0) >> 2] | 0;
    HEAP32[($2 + 232 | 0) >> 2] = HEAPU16[($2 + 30 | 0) >> 1] | 0 | ((HEAPU16[($2 + 32 | 0) >> 1] | 0) << 16 | 0) | 0;
    i64toi32_i32$3 = $2;
    i64toi32_i32$0 = HEAP32[($2 + 72 | 0) >> 2] | 0;
    i64toi32_i32$4 = HEAP32[($2 + 76 | 0) >> 2] | 0;
    $1926 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[($2 + 280 | 0) >> 2] = $1926;
    HEAP32[($2 + 284 | 0) >> 2] = i64toi32_i32$4;
    i64toi32_i32$3 = ($2 + 40 | 0) + 8 | 0;
    i64toi32_i32$4 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$0 = 0;
    $22 = i64toi32_i32$4;
    $22$hi = i64toi32_i32$0;
    i64toi32_i32$3 = $2;
    i64toi32_i32$0 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    i64toi32_i32$4 = HEAP32[($2 + 92 | 0) >> 2] | 0;
    $23 = i64toi32_i32$0;
    $23$hi = i64toi32_i32$4;
    i64toi32_i32$3 = $2;
    i64toi32_i32$4 = HEAP32[($2 + 96 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 100 | 0) >> 2] | 0;
    $21 = i64toi32_i32$4;
    $21$hi = i64toi32_i32$0;
    $17 = HEAP32[($2 + 104 | 0) >> 2] | 0;
    i64toi32_i32$3 = $2;
    i64toi32_i32$0 = HEAP32[($2 + 108 | 0) >> 2] | 0;
    i64toi32_i32$4 = HEAP32[($2 + 112 | 0) >> 2] | 0;
    $25 = i64toi32_i32$0;
    $25$hi = i64toi32_i32$4;
    i64toi32_i32$3 = $2;
    i64toi32_i32$4 = HEAP32[($2 + 40 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 44 | 0) >> 2] | 0;
    $24 = i64toi32_i32$4;
    $24$hi = i64toi32_i32$0;
    i64toi32_i32$3 = $2;
    i64toi32_i32$0 = HEAP32[($2 + 56 | 0) >> 2] | 0;
    i64toi32_i32$4 = 0;
    $26 = i64toi32_i32$0;
    $26$hi = i64toi32_i32$4;
    i64toi32_i32$3 = $2;
    i64toi32_i32$4 = HEAP32[($2 + 60 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 64 | 0) >> 2] | 0;
    $16 = HEAP32[($2 + 24 | 0) >> 2] | 0;
    HEAP16[($0 + 8 | 0) >> 1] = HEAPU16[($2 + 28 | 0) >> 1] | 0;
    HEAP32[($0 + 4 | 0) >> 2] = $16;
    $207 = HEAP32[($2 + 232 | 0) >> 2] | 0;
    HEAP16[($0 + 10 | 0) >> 1] = $207;
    HEAP16[($0 + 12 | 0) >> 1] = $207 >>> 16 | 0;
    HEAP16[($0 + 14 | 0) >> 1] = HEAPU16[$1 >> 1] | 0;
    $1962 = i64toi32_i32$4;
    i64toi32_i32$4 = $0 + 32 | 0;
    HEAP32[i64toi32_i32$4 >> 2] = $1962;
    HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$0;
    $1964 = $0 + 24 | 0;
    i64toi32_i32$0 = $22$hi;
    $1965 = $22;
    $1965$hi = i64toi32_i32$0;
    i64toi32_i32$0 = $26$hi;
    i64toi32_i32$3 = $26;
    i64toi32_i32$4 = 0;
    i64toi32_i32$1 = 32;
    i64toi32_i32$2 = i64toi32_i32$1 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
     i64toi32_i32$4 = i64toi32_i32$3 << i64toi32_i32$2 | 0;
     $208 = 0;
    } else {
     i64toi32_i32$4 = ((1 << i64toi32_i32$2 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$2 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$2 | 0) | 0;
     $208 = i64toi32_i32$3 << i64toi32_i32$2 | 0;
    }
    $1967$hi = i64toi32_i32$4;
    i64toi32_i32$4 = $1965$hi;
    i64toi32_i32$0 = $1965;
    i64toi32_i32$3 = $1967$hi;
    i64toi32_i32$1 = $208;
    i64toi32_i32$3 = i64toi32_i32$4 | i64toi32_i32$3 | 0;
    $1968 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
    i64toi32_i32$0 = $1964;
    HEAP32[i64toi32_i32$0 >> 2] = $1968;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
    i64toi32_i32$3 = $24$hi;
    i64toi32_i32$0 = $0 + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $24;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
    i64toi32_i32$4 = $2;
    i64toi32_i32$3 = HEAP32[($2 + 280 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 284 | 0) >> 2] | 0;
    $1975 = i64toi32_i32$3;
    i64toi32_i32$3 = $0 + 40 | 0;
    HEAP32[i64toi32_i32$3 >> 2] = $1975;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($0 + 48 | 0) >> 2] = HEAP32[$15 >> 2] | 0;
    i64toi32_i32$0 = $25$hi;
    i64toi32_i32$3 = $0 + 72 | 0;
    HEAP32[i64toi32_i32$3 >> 2] = $25;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($0 + 68 | 0) >> 2] = $17;
    i64toi32_i32$0 = $21$hi;
    i64toi32_i32$3 = $0 + 60 | 0;
    HEAP32[i64toi32_i32$3 >> 2] = $21;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = $23$hi;
    i64toi32_i32$3 = $0 + 52 | 0;
    HEAP32[i64toi32_i32$3 >> 2] = $23;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
    $1 = 0;
    break label$1;
   }
   i64toi32_i32$0 = $23$hi;
   i64toi32_i32$3 = $2 + 336 | 0;
   HEAP32[i64toi32_i32$3 >> 2] = $23;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $24$hi;
   i64toi32_i32$3 = $2 + 328 | 0;
   HEAP32[i64toi32_i32$3 >> 2] = $24;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($2 + 324 | 0) >> 2] = $6;
   HEAP32[(($2 + 312 | 0) + 8 | 0) >> 2] = $13;
   i64toi32_i32$4 = $2;
   i64toi32_i32$0 = HEAP32[($2 + 280 | 0) >> 2] | 0;
   i64toi32_i32$3 = HEAP32[($2 + 284 | 0) >> 2] | 0;
   $2008 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 344 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $2008;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$3 = $26$hi;
   i64toi32_i32$0 = $2 + 364 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $26;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
   HEAP32[($2 + 356 | 0) >> 2] = $7;
   HEAP32[($2 + 352 | 0) >> 2] = HEAP32[(($2 + 280 | 0) + 8 | 0) >> 2] | 0;
   HEAP8[($2 + 313 | 0) >> 0] = $15;
   HEAP8[($2 + 312 | 0) >> 0] = $16;
   $209 = HEAP32[($2 + 232 | 0) >> 2] | 0;
   HEAP16[($2 + 314 | 0) >> 1] = $209;
   HEAP16[($2 + 316 | 0) >> 1] = $209 >>> 16 | 0;
   HEAP32[($2 + 372 | 0) >> 2] = $5;
   HEAP32[($2 + 360 | 0) >> 2] = $17;
   HEAP16[($2 + 318 | 0) >> 1] = HEAPU16[($2 + 236 | 0) >> 1] | 0;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 312 | 0 | 0, 1051735 | 0, 21 | 0);
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 384 | 0;
 }
 
 function $cardano_serialization_lib__metadata__AuxiliaryData_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hca865c989495a465($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, i64toi32_i32$5 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $4 = 0, $21$hi = 0, $6 = 0, $21 = 0, $23$hi = 0, $9 = 0, $23 = 0, $11 = 0, $17 = 0, $5 = 0, $25 = 0, $25$hi = 0, $3 = 0, $22 = 0, $24 = 0, $22$hi = 0, $24$hi = 0, $18 = 0, $16 = 0, $7 = 0, $19 = 0, $12 = 0, $20 = 0, $92 = 0, $93 = 0, $94 = 0, $95 = 0, $96 = 0, $97 = 0, $98 = 0, $99 = 0, $100 = 0, $101 = 0, $102 = 0, $103 = 0, $104 = 0, $105 = 0, $106 = 0, $107 = 0, $108 = 0, $109 = 0, $110 = 0, $111 = 0, $112 = 0, $113 = 0, $114 = 0, $115 = 0, $116 = 0, $117 = 0, $118 = 0, $119 = 0, $120 = 0, $121 = 0, $122 = 0, $123 = 0, $124 = 0, $125 = 0, $126 = 0, $127 = 0, $128 = 0, $129 = 0, $130 = 0, $131 = 0, $132 = 0, $133 = 0, $134 = 0, $135 = 0, $136 = 0, $137 = 0, $138 = 0, $139 = 0, $8 = 0, $13 = 0, $14 = 0, $15 = 0, $10 = 0, $140 = 0, $141 = 0, $142 = 0, $143 = 0, $144 = 0, $145 = 0, $146 = 0, $147 = 0, $148 = 0, $149 = 0, $150 = 0, $151 = 0, $152 = 0, $153 = 0, $154 = 0, $166 = 0, $290 = 0, $308 = 0, $312 = 0, $337 = 0, $340 = 0, $348 = 0, $361 = 0, $370 = 0, $377 = 0, $529 = 0, $547 = 0, $551 = 0, $576 = 0, $579 = 0, $587 = 0, $600 = 0, $609 = 0, $616 = 0, $711 = 0, $720 = 0, $736 = 0, $755 = 0, $775 = 0, $782 = 0, $788 = 0, $912 = 0, $921 = 0, $937 = 0, $941 = 0, $26 = 0, $26$hi = 0, $972 = 0, $977 = 0, $1071 = 0, $1085 = 0, $1106 = 0, $1120 = 0, $1139 = 0, $1145 = 0, $1182 = 0, $1272 = 0, $1292 = 0, $1321 = 0, $1324 = 0, $1331 = 0, $1410 = 0, $1430 = 0, $1436 = 0, $1465 = 0, $1480 = 0, $1483 = 0, $1500 = 0, $1503 = 0, $1510 = 0;
  $2 = global$0 - 352 | 0;
  global$0 = $2;
  std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 16 | 0 | 0, $1 | 0);
  $3 = 0;
  i64toi32_i32$0 = 0;
  $21 = 0;
  $21$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     if (HEAP32[($2 + 20 | 0) >> 2] | 0) {
      break label$3
     }
     $4 = 0;
     $5 = 8;
     $6 = 2;
     break label$2;
    }
    $6 = 11;
    label$4 : {
     label$5 : {
      label$6 : {
       label$7 : {
        label$8 : {
         label$9 : {
          label$10 : {
           label$11 : {
            label$12 : {
             switch ((($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[($2 + 16 | 0) >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0) + -4 | 0 | 0) {
             case 2:
              cbor_event__de__Deserializer_R___tag__ha0ca0c99f1ceb558($2 + 280 | 0 | 0, $1 | 0);
              i64toi32_i32$2 = $2;
              i64toi32_i32$0 = HEAP32[($2 + 288 | 0) >> 2] | 0;
              i64toi32_i32$1 = HEAP32[($2 + 292 | 0) >> 2] | 0;
              $22 = i64toi32_i32$0;
              $22$hi = i64toi32_i32$1;
              label$15 : {
               label$16 : {
                i64toi32_i32$2 = $2;
                i64toi32_i32$1 = HEAP32[($2 + 280 | 0) >> 2] | 0;
                i64toi32_i32$0 = HEAP32[($2 + 284 | 0) >> 2] | 0;
                i64toi32_i32$2 = i64toi32_i32$1;
                i64toi32_i32$1 = 0;
                i64toi32_i32$3 = 1;
                if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
                 break label$16
                }
                i64toi32_i32$2 = 0;
                $21 = 259;
                $21$hi = i64toi32_i32$2;
                i64toi32_i32$2 = $22$hi;
                i64toi32_i32$3 = $22;
                i64toi32_i32$0 = 0;
                i64toi32_i32$1 = 259;
                if ((i64toi32_i32$3 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$0 | 0) | 0) {
                 break label$15
                }
                cbor_event__de__Deserializer_R___map__h7c2a4e830d885a05($2 + 280 | 0 | 0, $1 | 0);
                i64toi32_i32$1 = $2 + 296 | 0;
                i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                $21 = i64toi32_i32$3;
                $21$hi = i64toi32_i32$2;
                i64toi32_i32$1 = $2;
                i64toi32_i32$2 = HEAP32[($2 + 288 | 0) >> 2] | 0;
                i64toi32_i32$3 = HEAP32[($2 + 292 | 0) >> 2] | 0;
                $22 = i64toi32_i32$2;
                $22$hi = i64toi32_i32$3;
                i64toi32_i32$1 = $2;
                i64toi32_i32$3 = HEAP32[($2 + 280 | 0) >> 2] | 0;
                i64toi32_i32$2 = HEAP32[($2 + 284 | 0) >> 2] | 0;
                i64toi32_i32$1 = i64toi32_i32$3;
                i64toi32_i32$3 = 0;
                i64toi32_i32$0 = 1;
                if ((i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) | 0) {
                 break label$6
                }
                HEAP32[($2 + 196 | 0) >> 2] = 0;
                HEAP32[($2 + 24 | 0) >> 2] = 0;
                HEAP32[($2 + 56 | 0) >> 2] = 0;
                i64toi32_i32$1 = $21$hi;
                $7 = $21;
                label$17 : {
                 i64toi32_i32$1 = $22$hi;
                 i64toi32_i32$0 = $22;
                 i64toi32_i32$2 = 0;
                 i64toi32_i32$3 = 1;
                 if ((i64toi32_i32$0 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$2 | 0) | 0) {
                  break label$17
                 }
                 i64toi32_i32$0 = 0;
                 $23 = 0;
                 $23$hi = i64toi32_i32$0;
                 if (!$7) {
                  break label$9
                 }
                }
                $6 = 2;
                $8 = $2 + 176 | 0 | 2 | 0;
                $9 = $2 + 114 | 0;
                $10 = ($2 + 104 | 0) + 32 | 0;
                $11 = ($2 + 104 | 0) + 9 | 0;
                $12 = ($2 + 280 | 0) + 32 | 0;
                $13 = $2 + 24 | 0 | 6 | 0;
                $14 = $2 + 56 | 0 | 6 | 0;
                $5 = 8;
                $15 = ($2 + 104 | 0) + 8 | 0;
                $4 = ($2 + 280 | 0) + 9 | 0;
                $16 = $4 + 3 | 0;
                $17 = 1;
                i64toi32_i32$0 = 0;
                $23 = 0;
                $23$hi = i64toi32_i32$0;
                label$18 : while (1) {
                 $18 = $17;
                 std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 8 | 0 | 0, $1 | 0);
                 label$19 : {
                  if (HEAP32[($2 + 12 | 0) >> 2] | 0) {
                   break label$19
                  }
                  $4 = 0;
                  i64toi32_i32$0 = 0;
                  $21 = 0;
                  $21$hi = i64toi32_i32$0;
                  $3 = 0;
                  $6 = 2;
                  break label$7;
                 }
                 $3 = 0;
                 label$20 : {
                  $17 = ($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[($2 + 8 | 0) >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0;
                  if (!$17) {
                   break label$20
                  }
                  $6 = 17;
                  $4 = 0;
                  label$21 : {
                   switch ($17 + -3 | 0 | 0) {
                   case 4:
                    label$23 : {
                     i64toi32_i32$0 = $22$hi;
                     i64toi32_i32$3 = $22;
                     i64toi32_i32$1 = 0;
                     i64toi32_i32$2 = 1;
                     if ((i64toi32_i32$3 | 0) != (i64toi32_i32$2 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | 0) {
                      break label$23
                     }
                     $6 = 1;
                     break label$7;
                    }
                    cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 280 | 0 | 0, $1 | 0);
                    $1 = HEAPU8[($2 + 288 | 0) >> 0] | 0;
                    label$24 : {
                     i64toi32_i32$2 = $2;
                     i64toi32_i32$3 = HEAP32[($2 + 280 | 0) >> 2] | 0;
                     i64toi32_i32$0 = HEAP32[($2 + 284 | 0) >> 2] | 0;
                     i64toi32_i32$2 = i64toi32_i32$3;
                     i64toi32_i32$3 = 0;
                     i64toi32_i32$1 = 1;
                     if ((i64toi32_i32$2 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) | 0) {
                      break label$24
                     }
                     $6 = 5;
                     if (($1 | 0) == (5 | 0)) {
                      break label$9
                     }
                     break label$7;
                    }
                    $5 = (HEAPU8[($2 + 289 | 0) >> 0] | 0 | ((HEAPU8[($2 + 290 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 291 | 0) >> 0] | 0) << 16 | 0) | 0) << 8 | 0 | $1 | 0;
                    $11 = HEAP32[($2 + 320 | 0) >> 2] | 0;
                    i64toi32_i32$1 = $2 + 312 | 0;
                    i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                    i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                    $24 = i64toi32_i32$2;
                    $24$hi = i64toi32_i32$0;
                    i64toi32_i32$1 = $2 + 304 | 0;
                    i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                    i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                    $23 = i64toi32_i32$0;
                    $23$hi = i64toi32_i32$2;
                    i64toi32_i32$1 = ($2 + 280 | 0) + 16 | 0;
                    i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                    i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                    $21 = i64toi32_i32$2;
                    $21$hi = i64toi32_i32$0;
                    $9 = HEAP32[($2 + 324 | 0) >> 2] | 0;
                    $4 = HEAP32[($2 + 292 | 0) >> 2] | 0;
                    $6 = 2;
                    break label$7;
                   case 0:
                    break label$21;
                   default:
                    break label$7;
                   };
                  }
                  cbor_event__de__Deserializer_R___text__h764f26557f652908($2 + 280 | 0 | 0, $1 | 0);
                  label$25 : {
                   if ((HEAP32[($2 + 280 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                    break label$25
                   }
                   HEAP32[($2 + 104 | 0) >> 2] = HEAP32[($2 + 284 | 0) >> 2] | 0;
                   i64toi32_i32$1 = $2 + 288 | 0;
                   i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                   i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                   $166 = i64toi32_i32$0;
                   i64toi32_i32$0 = $2;
                   HEAP32[($2 + 108 | 0) >> 2] = $166;
                   HEAP32[($2 + 112 | 0) >> 2] = i64toi32_i32$2;
                   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 | 0, $2 + 104 | 0 | 0);
                   $1 = $2 + 292 | 0;
                   alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($1 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
                   HEAP16[($2 + 92 | 0) >> 1] = HEAPU16[($2 + 286 | 0) >> 1] | 0;
                   HEAP32[($2 + 88 | 0) >> 2] = HEAPU16[($2 + 282 | 0) >> 1] | 0 | ((HEAPU16[($2 + 284 | 0) >> 1] | 0) << 16 | 0) | 0;
                   $4 = HEAP32[$1 >> 2] | 0;
                   $6 = 16;
                   i64toi32_i32$1 = ($2 + 280 | 0) + 16 | 0;
                   i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                   i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                   $21 = i64toi32_i32$2;
                   $21$hi = i64toi32_i32$0;
                   i64toi32_i32$1 = $2 + 304 | 0;
                   i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                   i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                   $23 = i64toi32_i32$0;
                   $23$hi = i64toi32_i32$2;
                   i64toi32_i32$1 = $2 + 312 | 0;
                   i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                   i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                   $24 = i64toi32_i32$2;
                   $24$hi = i64toi32_i32$0;
                   $11 = HEAP32[($2 + 320 | 0) >> 2] | 0;
                   $9 = HEAP32[($2 + 324 | 0) >> 2] | 0;
                   $17 = HEAPU8[($2 + 281 | 0) >> 0] | 0;
                   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 104 | 0 | 0);
                   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 104 | 0 | 0);
                   $5 = 0;
                   break label$7;
                  }
                  $4 = HEAP32[($2 + 292 | 0) >> 2] | 0;
                  $5 = HEAP32[($2 + 288 | 0) >> 2] | 0;
                  $9 = HEAP32[($2 + 324 | 0) >> 2] | 0;
                  $11 = HEAP32[($2 + 320 | 0) >> 2] | 0;
                  i64toi32_i32$1 = $2 + 312 | 0;
                  i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                  $24 = i64toi32_i32$0;
                  $24$hi = i64toi32_i32$2;
                  i64toi32_i32$1 = $2 + 304 | 0;
                  i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                  $23 = i64toi32_i32$2;
                  $23$hi = i64toi32_i32$0;
                  i64toi32_i32$1 = $2 + 296 | 0;
                  i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                  $21 = i64toi32_i32$0;
                  $21$hi = i64toi32_i32$2;
                  $6 = 2;
                  break label$7;
                 }
                 cbor_event__de__Deserializer_R___unsigned_integer__h1ed99c0b7fe7eea1($2 + 280 | 0 | 0, $1 | 0);
                 i64toi32_i32$1 = $2;
                 i64toi32_i32$2 = HEAP32[($2 + 288 | 0) >> 2] | 0;
                 i64toi32_i32$0 = HEAP32[($2 + 292 | 0) >> 2] | 0;
                 $25 = i64toi32_i32$2;
                 $25$hi = i64toi32_i32$0;
                 label$26 : {
                  label$27 : {
                   label$28 : {
                    label$29 : {
                     label$30 : {
                      label$31 : {
                       label$32 : {
                        label$33 : {
                         label$34 : {
                          i64toi32_i32$1 = $2;
                          i64toi32_i32$0 = HEAP32[($2 + 280 | 0) >> 2] | 0;
                          i64toi32_i32$2 = HEAP32[($2 + 284 | 0) >> 2] | 0;
                          i64toi32_i32$1 = i64toi32_i32$0;
                          i64toi32_i32$0 = 0;
                          i64toi32_i32$3 = 1;
                          if ((i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) | 0) {
                           break label$34
                          }
                          label$35 : {
                           i64toi32_i32$1 = $25$hi;
                           i64toi32_i32$3 = $25;
                           i64toi32_i32$2 = 0;
                           i64toi32_i32$0 = 2;
                           if (i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$3 >>> 0 <= i64toi32_i32$0 >>> 0 | 0) | 0) {
                            break label$35
                           }
                           $6 = 16;
                           $4 = 0;
                           i64toi32_i32$3 = $25$hi;
                           $21 = $25;
                           $21$hi = i64toi32_i32$3;
                           break label$10;
                          }
                          i64toi32_i32$3 = $25$hi;
                          switch ($25 | 0) {
                          case 2:
                           break label$31;
                          case 1:
                           break label$32;
                          default:
                           break label$33;
                          };
                         }
                         i64toi32_i32$3 = $25$hi;
                         i64toi32_i32$0 = $25;
                         i64toi32_i32$1 = 0;
                         i64toi32_i32$2 = 32;
                         i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
                         if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                          i64toi32_i32$1 = 0;
                          $140 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
                         } else {
                          i64toi32_i32$1 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
                          $140 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
                         }
                         $4 = $140;
                         $9 = HEAP32[($2 + 324 | 0) >> 2] | 0;
                         $11 = HEAP32[($2 + 320 | 0) >> 2] | 0;
                         i64toi32_i32$3 = $2 + 312 | 0;
                         i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                         i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                         $24 = i64toi32_i32$1;
                         $24$hi = i64toi32_i32$0;
                         i64toi32_i32$3 = $2 + 304 | 0;
                         i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                         i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                         $23 = i64toi32_i32$0;
                         $23$hi = i64toi32_i32$1;
                         i64toi32_i32$3 = $2 + 296 | 0;
                         i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                         i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                         $21 = i64toi32_i32$1;
                         $21$hi = i64toi32_i32$0;
                         i64toi32_i32$0 = $25$hi;
                         $5 = $25;
                         break label$7;
                        }
                        if (!(HEAP32[($2 + 196 | 0) >> 2] | 0)) {
                         break label$29
                        }
                        $6 = 4;
                        $4 = 0;
                        i64toi32_i32$0 = 0;
                        $21 = 0;
                        $21$hi = i64toi32_i32$0;
                        break label$10;
                       }
                       if (!(HEAP32[($2 + 24 | 0) >> 2] | 0)) {
                        break label$30
                       }
                       $6 = 4;
                       $4 = 0;
                       i64toi32_i32$0 = 0;
                       $21 = 1;
                       $21$hi = i64toi32_i32$0;
                       break label$11;
                      }
                      label$36 : {
                       if (!(HEAP32[($2 + 56 | 0) >> 2] | 0)) {
                        break label$36
                       }
                       $6 = 4;
                       $4 = 0;
                       i64toi32_i32$0 = 0;
                       $21 = 2;
                       $21$hi = i64toi32_i32$0;
                       break label$11;
                      }
                      label$37 : {
                       label$38 : {
                        label$39 : {
                         i64toi32_i32$0 = $22$hi;
                         i64toi32_i32$3 = $22;
                         i64toi32_i32$1 = 0;
                         i64toi32_i32$2 = 1;
                         if ((i64toi32_i32$3 | 0) != (i64toi32_i32$2 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | 0) {
                          break label$39
                         }
                         i64toi32_i32$3 = $23$hi;
                         i64toi32_i32$2 = $23;
                         i64toi32_i32$0 = 0;
                         i64toi32_i32$1 = 1;
                         i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
                         i64toi32_i32$5 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
                         if (i64toi32_i32$4 >>> 0 < i64toi32_i32$1 >>> 0) {
                          i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
                         }
                         $23 = i64toi32_i32$4;
                         $23$hi = i64toi32_i32$5;
                         i64toi32_i32$5 = $21$hi;
                         i64toi32_i32$5 = $23$hi;
                         i64toi32_i32$3 = i64toi32_i32$4;
                         i64toi32_i32$2 = $21$hi;
                         i64toi32_i32$1 = $21;
                         if (i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$4 >>> 0 <= i64toi32_i32$1 >>> 0 | 0) | 0) {
                          break label$39
                         }
                         $1 = 0;
                         i64toi32_i32$3 = 0;
                         $23 = 0;
                         $23$hi = i64toi32_i32$3;
                         $17 = 3;
                         break label$38;
                        }
                        $cardano_serialization_lib__plutus__PlutusScripts_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h8b36940d74966a88($2 + 280 | 0 | 0, $1 | 0);
                        if ((HEAP32[($2 + 280 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                         break label$37
                        }
                        $6 = ($2 + 256 | 0) + 8 | 0;
                        i64toi32_i32$1 = $2 + 320 | 0;
                        i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                        i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                        $290 = i64toi32_i32$3;
                        i64toi32_i32$3 = $6;
                        HEAP32[i64toi32_i32$3 >> 2] = $290;
                        HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
                        $5 = ($2 + 240 | 0) + 8 | 0;
                        HEAP32[$5 >> 2] = HEAP32[($2 + 348 | 0) >> 2] | 0;
                        HEAP32[($2 + 272 | 0) >> 2] = HEAPU8[$4 >> 0] | 0 | ((HEAPU8[($4 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                        $92 = $4 + 3 | 0;
                        $93 = HEAPU8[$92 >> 0] | 0 | ((HEAPU8[($92 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($92 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($92 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                        HEAP8[($2 + 275 | 0) >> 0] = $93;
                        HEAP8[($2 + 276 | 0) >> 0] = $93 >>> 8 | 0;
                        HEAP8[($2 + 277 | 0) >> 0] = $93 >>> 16 | 0;
                        HEAP8[($2 + 278 | 0) >> 0] = $93 >>> 24 | 0;
                        i64toi32_i32$1 = $2 + 312 | 0;
                        i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                        i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                        $308 = i64toi32_i32$5;
                        i64toi32_i32$5 = $2;
                        HEAP32[($2 + 256 | 0) >> 2] = $308;
                        HEAP32[($2 + 260 | 0) >> 2] = i64toi32_i32$3;
                        i64toi32_i32$1 = $2 + 340 | 0;
                        i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                        i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                        $312 = i64toi32_i32$3;
                        i64toi32_i32$3 = $2;
                        HEAP32[($2 + 240 | 0) >> 2] = $312;
                        HEAP32[($2 + 244 | 0) >> 2] = i64toi32_i32$5;
                        i64toi32_i32$1 = $2 + 296 | 0;
                        i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                        i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                        $21 = i64toi32_i32$5;
                        $21$hi = i64toi32_i32$3;
                        i64toi32_i32$1 = $2 + 304 | 0;
                        i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                        i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                        $23 = i64toi32_i32$3;
                        $23$hi = i64toi32_i32$5;
                        i64toi32_i32$1 = $2 + 328 | 0;
                        i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                        i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                        $25 = i64toi32_i32$5;
                        $25$hi = i64toi32_i32$3;
                        $1 = HEAP32[($2 + 336 | 0) >> 2] | 0;
                        $17 = HEAPU8[($2 + 288 | 0) >> 0] | 0;
                        $94 = HEAPU8[($2 + 275 | 0) >> 0] | 0 | ((HEAPU8[($2 + 276 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 277 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 278 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                        HEAP8[($2 + 51 | 0) >> 0] = $94;
                        HEAP8[($2 + 52 | 0) >> 0] = $94 >>> 8 | 0;
                        HEAP8[($2 + 53 | 0) >> 0] = $94 >>> 16 | 0;
                        HEAP8[($2 + 54 | 0) >> 0] = $94 >>> 24 | 0;
                        HEAP32[($2 + 48 | 0) >> 2] = HEAP32[($2 + 272 | 0) >> 2] | 0;
                        i64toi32_i32$1 = $6;
                        i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                        i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                        $337 = i64toi32_i32$3;
                        i64toi32_i32$3 = ($2 + 88 | 0) + 8 | 0;
                        HEAP32[i64toi32_i32$3 >> 2] = $337;
                        HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
                        i64toi32_i32$1 = $2;
                        i64toi32_i32$5 = HEAP32[($2 + 256 | 0) >> 2] | 0;
                        i64toi32_i32$3 = HEAP32[($2 + 260 | 0) >> 2] | 0;
                        $340 = i64toi32_i32$5;
                        i64toi32_i32$5 = $2;
                        HEAP32[($2 + 88 | 0) >> 2] = $340;
                        HEAP32[($2 + 92 | 0) >> 2] = i64toi32_i32$3;
                        HEAP32[(($2 + 72 | 0) + 8 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
                        i64toi32_i32$1 = $2;
                        i64toi32_i32$3 = HEAP32[($2 + 240 | 0) >> 2] | 0;
                        i64toi32_i32$5 = HEAP32[($2 + 244 | 0) >> 2] | 0;
                        $348 = i64toi32_i32$3;
                        i64toi32_i32$3 = $2;
                        HEAP32[($2 + 72 | 0) >> 2] = $348;
                        HEAP32[($2 + 76 | 0) >> 2] = i64toi32_i32$5;
                       }
                       i64toi32_i32$5 = $23$hi;
                       i64toi32_i32$3 = ($2 + 280 | 0) + 16 | 0;
                       HEAP32[i64toi32_i32$3 >> 2] = $23;
                       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
                       i64toi32_i32$5 = $21$hi;
                       i64toi32_i32$3 = ($2 + 280 | 0) + 8 | 0;
                       HEAP32[i64toi32_i32$3 >> 2] = $21;
                       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
                       i64toi32_i32$1 = $2;
                       i64toi32_i32$5 = HEAP32[($2 + 88 | 0) >> 2] | 0;
                       i64toi32_i32$3 = HEAP32[($2 + 92 | 0) >> 2] | 0;
                       $361 = i64toi32_i32$5;
                       i64toi32_i32$5 = ($2 + 280 | 0) + 24 | 0;
                       HEAP32[i64toi32_i32$5 >> 2] = $361;
                       HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$3;
                       i64toi32_i32$3 = $25$hi;
                       i64toi32_i32$5 = ($2 + 280 | 0) + 40 | 0;
                       HEAP32[i64toi32_i32$5 >> 2] = $25;
                       HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$3;
                       i64toi32_i32$1 = $2;
                       i64toi32_i32$3 = HEAP32[($2 + 72 | 0) >> 2] | 0;
                       i64toi32_i32$5 = HEAP32[($2 + 76 | 0) >> 2] | 0;
                       $370 = i64toi32_i32$3;
                       i64toi32_i32$3 = ($2 + 280 | 0) + 52 | 0;
                       HEAP32[i64toi32_i32$3 >> 2] = $370;
                       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
                       i64toi32_i32$1 = ($2 + 88 | 0) + 8 | 0;
                       i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                       i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                       $377 = i64toi32_i32$5;
                       i64toi32_i32$5 = ($2 + 280 | 0) + 32 | 0;
                       HEAP32[i64toi32_i32$5 >> 2] = $377;
                       HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$3;
                       HEAP32[(($2 + 280 | 0) + 60 | 0) >> 2] = HEAP32[(($2 + 72 | 0) + 8 | 0) >> 2] | 0;
                       HEAP8[($2 + 280 | 0) >> 0] = $17;
                       $95 = HEAP32[($2 + 48 | 0) >> 2] | 0;
                       HEAP8[($2 + 281 | 0) >> 0] = $95;
                       HEAP8[($2 + 282 | 0) >> 0] = $95 >>> 8 | 0;
                       HEAP8[($2 + 283 | 0) >> 0] = $95 >>> 16 | 0;
                       HEAP8[($2 + 284 | 0) >> 0] = $95 >>> 24 | 0;
                       $96 = HEAPU8[($2 + 51 | 0) >> 0] | 0 | ((HEAPU8[($2 + 52 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 53 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 54 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                       HEAP8[($2 + 284 | 0) >> 0] = $96;
                       HEAP8[($2 + 285 | 0) >> 0] = $96 >>> 8 | 0;
                       HEAP8[($2 + 286 | 0) >> 0] = $96 >>> 16 | 0;
                       HEAP8[($2 + 287 | 0) >> 0] = $96 >>> 24 | 0;
                       HEAP32[($2 + 328 | 0) >> 2] = $1;
                       cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($15 | 0, $2 + 280 | 0 | 0, 1060086 | 0, 14 | 0);
                       $1 = ($2 + 40 | 0) + 4 | 0;
                       HEAP16[$1 >> 1] = HEAPU16[($9 + 4 | 0) >> 1] | 0;
                       HEAP32[($2 + 40 | 0) >> 2] = HEAPU16[$9 >> 1] | 0 | ((HEAPU16[($9 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
                       $5 = HEAP32[(($2 + 104 | 0) + 16 | 0) >> 2] | 0;
                       $4 = HEAP32[($2 + 124 | 0) >> 2] | 0;
                       i64toi32_i32$1 = ($2 + 104 | 0) + 24 | 0;
                       i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                       i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                       $21 = i64toi32_i32$3;
                       $21$hi = i64toi32_i32$5;
                       i64toi32_i32$1 = ($2 + 104 | 0) + 32 | 0;
                       i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                       i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                       $23 = i64toi32_i32$5;
                       $23$hi = i64toi32_i32$3;
                       i64toi32_i32$1 = ($2 + 104 | 0) + 40 | 0;
                       i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                       i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                       $24 = i64toi32_i32$3;
                       $24$hi = i64toi32_i32$5;
                       $11 = HEAP32[($2 + 152 | 0) >> 2] | 0;
                       $9 = HEAP32[(($2 + 104 | 0) + 52 | 0) >> 2] | 0;
                       $3 = HEAP32[($2 + 160 | 0) >> 2] | 0;
                       $18 = HEAP32[(($2 + 104 | 0) + 60 | 0) >> 2] | 0;
                       i64toi32_i32$1 = $2 + 168 | 0;
                       i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                       i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                       $25 = i64toi32_i32$5;
                       $25$hi = i64toi32_i32$3;
                       $6 = HEAPU8[($2 + 112 | 0) >> 0] | 0;
                       $17 = HEAPU8[($2 + 113 | 0) >> 0] | 0;
                       HEAP16[(($2 + 88 | 0) + 4 | 0) >> 1] = HEAPU16[$1 >> 1] | 0;
                       HEAP32[($2 + 88 | 0) >> 2] = HEAP32[($2 + 40 | 0) >> 2] | 0;
                       break label$7;
                      }
                      HEAP32[($2 + 272 | 0) >> 2] = HEAPU8[$4 >> 0] | 0 | ((HEAPU8[($4 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                      $97 = HEAPU8[$16 >> 0] | 0 | ((HEAPU8[($16 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($16 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($16 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                      HEAP8[($2 + 275 | 0) >> 0] = $97;
                      HEAP8[($2 + 276 | 0) >> 0] = $97 >>> 8 | 0;
                      HEAP8[($2 + 277 | 0) >> 0] = $97 >>> 16 | 0;
                      HEAP8[($2 + 278 | 0) >> 0] = $97 >>> 24 | 0;
                      HEAP32[($2 + 48 | 0) >> 2] = HEAP32[($2 + 272 | 0) >> 2] | 0;
                      $98 = HEAPU8[($2 + 275 | 0) >> 0] | 0 | ((HEAPU8[($2 + 276 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 277 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 278 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                      HEAP8[($2 + 51 | 0) >> 0] = $98;
                      HEAP8[($2 + 52 | 0) >> 0] = $98 >>> 8 | 0;
                      HEAP8[($2 + 53 | 0) >> 0] = $98 >>> 16 | 0;
                      HEAP8[($2 + 54 | 0) >> 0] = $98 >>> 24 | 0;
                      $17 = HEAP32[($2 + 284 | 0) >> 2] | 0;
                      $3 = HEAPU8[($2 + 288 | 0) >> 0] | 0;
                      $99 = HEAP32[($2 + 48 | 0) >> 2] | 0;
                      HEAP8[$11 >> 0] = $99;
                      HEAP8[($11 + 1 | 0) >> 0] = $99 >>> 8 | 0;
                      HEAP8[($11 + 2 | 0) >> 0] = $99 >>> 16 | 0;
                      HEAP8[($11 + 3 | 0) >> 0] = $99 >>> 24 | 0;
                      $100 = $11 + 3 | 0;
                      $101 = HEAPU8[($2 + 51 | 0) >> 0] | 0 | ((HEAPU8[($2 + 52 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 53 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 54 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                      HEAP8[$100 >> 0] = $101;
                      HEAP8[($100 + 1 | 0) >> 0] = $101 >>> 8 | 0;
                      HEAP8[($100 + 2 | 0) >> 0] = $101 >>> 16 | 0;
                      HEAP8[($100 + 3 | 0) >> 0] = $101 >>> 24 | 0;
                      HEAP8[($2 + 112 | 0) >> 0] = $3;
                      HEAP32[($2 + 108 | 0) >> 2] = $17;
                      $19 = HEAPU8[($2 + 113 | 0) >> 0] | 0;
                      $20 = ($2 + 40 | 0) + 4 | 0;
                      HEAP16[$20 >> 1] = HEAPU16[($9 + 4 | 0) >> 1] | 0;
                      HEAP32[($2 + 40 | 0) >> 2] = HEAPU16[$9 >> 1] | 0 | ((HEAPU16[($9 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
                      core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__plutus__PlutusScripts____h6be1d55eac328b7f_1($2 + 56 | 0 | 0);
                      $141 = HEAP32[($2 + 40 | 0) >> 2] | 0;
                      HEAP16[$14 >> 1] = $141;
                      HEAP16[($14 + 2 | 0) >> 1] = $141 >>> 16 | 0;
                      HEAP16[($14 + 4 | 0) >> 1] = HEAPU16[$20 >> 1] | 0;
                      HEAP8[($2 + 61 | 0) >> 0] = $19;
                      HEAP8[($2 + 60 | 0) >> 0] = $3;
                      HEAP32[($2 + 56 | 0) >> 2] = $17;
                      break label$26;
                     }
                     label$40 : {
                      label$41 : {
                       i64toi32_i32$3 = $22$hi;
                       i64toi32_i32$1 = $22;
                       i64toi32_i32$5 = 0;
                       i64toi32_i32$2 = 1;
                       if ((i64toi32_i32$1 | 0) != (i64toi32_i32$2 | 0) | (i64toi32_i32$3 | 0) != (i64toi32_i32$5 | 0) | 0) {
                        break label$41
                       }
                       i64toi32_i32$1 = $23$hi;
                       i64toi32_i32$2 = $23;
                       i64toi32_i32$3 = 0;
                       i64toi32_i32$5 = 1;
                       i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
                       i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
                       if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
                        i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
                       }
                       $23 = i64toi32_i32$0;
                       $23$hi = i64toi32_i32$4;
                       i64toi32_i32$4 = $21$hi;
                       i64toi32_i32$4 = $23$hi;
                       i64toi32_i32$1 = i64toi32_i32$0;
                       i64toi32_i32$2 = $21$hi;
                       i64toi32_i32$5 = $21;
                       if (i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$0 >>> 0 <= i64toi32_i32$5 >>> 0 | 0) | 0) {
                        break label$41
                       }
                       $1 = 0;
                       i64toi32_i32$1 = 0;
                       $23 = 0;
                       $23$hi = i64toi32_i32$1;
                       $17 = 3;
                       break label$40;
                      }
                      cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__NativeScripts___deserialize__h5fb973a07bcdbe01($2 + 280 | 0 | 0, $1 | 0);
                      if ((HEAP32[($2 + 280 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                       break label$28
                      }
                      $6 = ($2 + 256 | 0) + 8 | 0;
                      i64toi32_i32$5 = $2 + 320 | 0;
                      i64toi32_i32$1 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                      i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                      $529 = i64toi32_i32$1;
                      i64toi32_i32$1 = $6;
                      HEAP32[i64toi32_i32$1 >> 2] = $529;
                      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$4;
                      $5 = ($2 + 240 | 0) + 8 | 0;
                      HEAP32[$5 >> 2] = HEAP32[($2 + 348 | 0) >> 2] | 0;
                      HEAP32[($2 + 272 | 0) >> 2] = HEAPU8[$4 >> 0] | 0 | ((HEAPU8[($4 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                      $102 = $4 + 3 | 0;
                      $103 = HEAPU8[$102 >> 0] | 0 | ((HEAPU8[($102 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($102 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($102 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                      HEAP8[($2 + 275 | 0) >> 0] = $103;
                      HEAP8[($2 + 276 | 0) >> 0] = $103 >>> 8 | 0;
                      HEAP8[($2 + 277 | 0) >> 0] = $103 >>> 16 | 0;
                      HEAP8[($2 + 278 | 0) >> 0] = $103 >>> 24 | 0;
                      i64toi32_i32$5 = $2 + 312 | 0;
                      i64toi32_i32$4 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                      i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                      $547 = i64toi32_i32$4;
                      i64toi32_i32$4 = $2;
                      HEAP32[($2 + 256 | 0) >> 2] = $547;
                      HEAP32[($2 + 260 | 0) >> 2] = i64toi32_i32$1;
                      i64toi32_i32$5 = $2 + 340 | 0;
                      i64toi32_i32$1 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                      i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                      $551 = i64toi32_i32$1;
                      i64toi32_i32$1 = $2;
                      HEAP32[($2 + 240 | 0) >> 2] = $551;
                      HEAP32[($2 + 244 | 0) >> 2] = i64toi32_i32$4;
                      i64toi32_i32$5 = $2 + 296 | 0;
                      i64toi32_i32$4 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                      i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                      $21 = i64toi32_i32$4;
                      $21$hi = i64toi32_i32$1;
                      i64toi32_i32$5 = $2 + 304 | 0;
                      i64toi32_i32$1 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                      i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                      $23 = i64toi32_i32$1;
                      $23$hi = i64toi32_i32$4;
                      i64toi32_i32$5 = $2 + 328 | 0;
                      i64toi32_i32$4 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                      i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                      $25 = i64toi32_i32$4;
                      $25$hi = i64toi32_i32$1;
                      $1 = HEAP32[($2 + 336 | 0) >> 2] | 0;
                      $17 = HEAPU8[($2 + 288 | 0) >> 0] | 0;
                      $104 = HEAPU8[($2 + 275 | 0) >> 0] | 0 | ((HEAPU8[($2 + 276 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 277 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 278 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                      HEAP8[($2 + 51 | 0) >> 0] = $104;
                      HEAP8[($2 + 52 | 0) >> 0] = $104 >>> 8 | 0;
                      HEAP8[($2 + 53 | 0) >> 0] = $104 >>> 16 | 0;
                      HEAP8[($2 + 54 | 0) >> 0] = $104 >>> 24 | 0;
                      HEAP32[($2 + 48 | 0) >> 2] = HEAP32[($2 + 272 | 0) >> 2] | 0;
                      i64toi32_i32$5 = $6;
                      i64toi32_i32$1 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                      i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                      $576 = i64toi32_i32$1;
                      i64toi32_i32$1 = ($2 + 88 | 0) + 8 | 0;
                      HEAP32[i64toi32_i32$1 >> 2] = $576;
                      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$4;
                      i64toi32_i32$5 = $2;
                      i64toi32_i32$4 = HEAP32[($2 + 256 | 0) >> 2] | 0;
                      i64toi32_i32$1 = HEAP32[($2 + 260 | 0) >> 2] | 0;
                      $579 = i64toi32_i32$4;
                      i64toi32_i32$4 = $2;
                      HEAP32[($2 + 88 | 0) >> 2] = $579;
                      HEAP32[($2 + 92 | 0) >> 2] = i64toi32_i32$1;
                      HEAP32[(($2 + 72 | 0) + 8 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
                      i64toi32_i32$5 = $2;
                      i64toi32_i32$1 = HEAP32[($2 + 240 | 0) >> 2] | 0;
                      i64toi32_i32$4 = HEAP32[($2 + 244 | 0) >> 2] | 0;
                      $587 = i64toi32_i32$1;
                      i64toi32_i32$1 = $2;
                      HEAP32[($2 + 72 | 0) >> 2] = $587;
                      HEAP32[($2 + 76 | 0) >> 2] = i64toi32_i32$4;
                     }
                     i64toi32_i32$4 = $23$hi;
                     i64toi32_i32$1 = ($2 + 280 | 0) + 16 | 0;
                     HEAP32[i64toi32_i32$1 >> 2] = $23;
                     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$4;
                     i64toi32_i32$4 = $21$hi;
                     i64toi32_i32$1 = ($2 + 280 | 0) + 8 | 0;
                     HEAP32[i64toi32_i32$1 >> 2] = $21;
                     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$4;
                     i64toi32_i32$5 = $2;
                     i64toi32_i32$4 = HEAP32[($2 + 88 | 0) >> 2] | 0;
                     i64toi32_i32$1 = HEAP32[($2 + 92 | 0) >> 2] | 0;
                     $600 = i64toi32_i32$4;
                     i64toi32_i32$4 = ($2 + 280 | 0) + 24 | 0;
                     HEAP32[i64toi32_i32$4 >> 2] = $600;
                     HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$1;
                     i64toi32_i32$1 = $25$hi;
                     i64toi32_i32$4 = ($2 + 280 | 0) + 40 | 0;
                     HEAP32[i64toi32_i32$4 >> 2] = $25;
                     HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$1;
                     i64toi32_i32$5 = $2;
                     i64toi32_i32$1 = HEAP32[($2 + 72 | 0) >> 2] | 0;
                     i64toi32_i32$4 = HEAP32[($2 + 76 | 0) >> 2] | 0;
                     $609 = i64toi32_i32$1;
                     i64toi32_i32$1 = ($2 + 280 | 0) + 52 | 0;
                     HEAP32[i64toi32_i32$1 >> 2] = $609;
                     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$4;
                     i64toi32_i32$5 = ($2 + 88 | 0) + 8 | 0;
                     i64toi32_i32$4 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                     i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                     $616 = i64toi32_i32$4;
                     i64toi32_i32$4 = ($2 + 280 | 0) + 32 | 0;
                     HEAP32[i64toi32_i32$4 >> 2] = $616;
                     HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$1;
                     HEAP32[(($2 + 280 | 0) + 60 | 0) >> 2] = HEAP32[(($2 + 72 | 0) + 8 | 0) >> 2] | 0;
                     HEAP8[($2 + 280 | 0) >> 0] = $17;
                     $105 = HEAP32[($2 + 48 | 0) >> 2] | 0;
                     HEAP8[($2 + 281 | 0) >> 0] = $105;
                     HEAP8[($2 + 282 | 0) >> 0] = $105 >>> 8 | 0;
                     HEAP8[($2 + 283 | 0) >> 0] = $105 >>> 16 | 0;
                     HEAP8[($2 + 284 | 0) >> 0] = $105 >>> 24 | 0;
                     $106 = HEAPU8[($2 + 51 | 0) >> 0] | 0 | ((HEAPU8[($2 + 52 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 53 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 54 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                     HEAP8[($2 + 284 | 0) >> 0] = $106;
                     HEAP8[($2 + 285 | 0) >> 0] = $106 >>> 8 | 0;
                     HEAP8[($2 + 286 | 0) >> 0] = $106 >>> 16 | 0;
                     HEAP8[($2 + 287 | 0) >> 0] = $106 >>> 24 | 0;
                     HEAP32[($2 + 328 | 0) >> 2] = $1;
                     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($15 | 0, $2 + 280 | 0 | 0, 1060072 | 0, 14 | 0);
                     $1 = ($2 + 40 | 0) + 4 | 0;
                     HEAP16[$1 >> 1] = HEAPU16[($9 + 4 | 0) >> 1] | 0;
                     HEAP32[($2 + 40 | 0) >> 2] = HEAPU16[$9 >> 1] | 0 | ((HEAPU16[($9 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
                     $5 = HEAP32[(($2 + 104 | 0) + 16 | 0) >> 2] | 0;
                     $4 = HEAP32[($2 + 124 | 0) >> 2] | 0;
                     i64toi32_i32$5 = ($2 + 104 | 0) + 24 | 0;
                     i64toi32_i32$1 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                     i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                     $21 = i64toi32_i32$1;
                     $21$hi = i64toi32_i32$4;
                     i64toi32_i32$5 = ($2 + 104 | 0) + 32 | 0;
                     i64toi32_i32$4 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                     i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                     $23 = i64toi32_i32$4;
                     $23$hi = i64toi32_i32$1;
                     i64toi32_i32$5 = ($2 + 104 | 0) + 40 | 0;
                     i64toi32_i32$1 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                     i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                     $24 = i64toi32_i32$1;
                     $24$hi = i64toi32_i32$4;
                     $11 = HEAP32[($2 + 152 | 0) >> 2] | 0;
                     $9 = HEAP32[(($2 + 104 | 0) + 52 | 0) >> 2] | 0;
                     $3 = HEAP32[($2 + 160 | 0) >> 2] | 0;
                     $18 = HEAP32[(($2 + 104 | 0) + 60 | 0) >> 2] | 0;
                     i64toi32_i32$5 = $2 + 168 | 0;
                     i64toi32_i32$4 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                     i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                     $25 = i64toi32_i32$4;
                     $25$hi = i64toi32_i32$1;
                     $6 = HEAPU8[($2 + 112 | 0) >> 0] | 0;
                     $17 = HEAPU8[($2 + 113 | 0) >> 0] | 0;
                     HEAP16[(($2 + 88 | 0) + 4 | 0) >> 1] = HEAPU16[$1 >> 1] | 0;
                     HEAP32[($2 + 88 | 0) >> 2] = HEAP32[($2 + 40 | 0) >> 2] | 0;
                     break label$7;
                    }
                    label$42 : {
                     label$43 : {
                      i64toi32_i32$1 = $22$hi;
                      i64toi32_i32$5 = $22;
                      i64toi32_i32$4 = 0;
                      i64toi32_i32$2 = 1;
                      if ((i64toi32_i32$5 | 0) != (i64toi32_i32$2 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$4 | 0) | 0) {
                       break label$43
                      }
                      i64toi32_i32$5 = $23$hi;
                      i64toi32_i32$2 = $23;
                      i64toi32_i32$1 = 0;
                      i64toi32_i32$4 = 1;
                      i64toi32_i32$3 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
                      i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
                      if (i64toi32_i32$3 >>> 0 < i64toi32_i32$4 >>> 0) {
                       i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
                      }
                      $23 = i64toi32_i32$3;
                      $23$hi = i64toi32_i32$0;
                      i64toi32_i32$0 = $21$hi;
                      i64toi32_i32$0 = $23$hi;
                      i64toi32_i32$5 = i64toi32_i32$3;
                      i64toi32_i32$2 = $21$hi;
                      i64toi32_i32$4 = $21;
                      if (i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$5 >>> 0 <= i64toi32_i32$4 >>> 0 | 0) | 0) {
                       break label$43
                      }
                      $1 = 0;
                      i64toi32_i32$5 = 0;
                      $24 = 0;
                      $24$hi = i64toi32_i32$5;
                      $17 = 3;
                      break label$42;
                     }
                     $cardano_serialization_lib__metadata__GeneralTransactionMetadata_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h2cbfe28ae9769528($2 + 280 | 0 | 0, $1 | 0);
                     $3 = ($2 + 256 | 0) + 8 | 0;
                     i64toi32_i32$4 = $12 + 8 | 0;
                     i64toi32_i32$5 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                     i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                     $711 = i64toi32_i32$5;
                     i64toi32_i32$5 = $3;
                     HEAP32[i64toi32_i32$5 >> 2] = $711;
                     HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
                     HEAP32[($2 + 272 | 0) >> 2] = HEAPU8[$4 >> 0] | 0 | ((HEAPU8[($4 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                     $107 = HEAPU8[$16 >> 0] | 0 | ((HEAPU8[($16 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($16 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($16 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                     HEAP8[($2 + 275 | 0) >> 0] = $107;
                     HEAP8[($2 + 276 | 0) >> 0] = $107 >>> 8 | 0;
                     HEAP8[($2 + 277 | 0) >> 0] = $107 >>> 16 | 0;
                     HEAP8[($2 + 278 | 0) >> 0] = $107 >>> 24 | 0;
                     i64toi32_i32$4 = $12;
                     i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                     i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                     $720 = i64toi32_i32$0;
                     i64toi32_i32$0 = $2;
                     HEAP32[($2 + 256 | 0) >> 2] = $720;
                     HEAP32[($2 + 260 | 0) >> 2] = i64toi32_i32$5;
                     i64toi32_i32$4 = $2;
                     i64toi32_i32$5 = HEAP32[($2 + 304 | 0) >> 2] | 0;
                     i64toi32_i32$0 = HEAP32[($2 + 308 | 0) >> 2] | 0;
                     $24 = i64toi32_i32$5;
                     $24$hi = i64toi32_i32$0;
                     i64toi32_i32$4 = $2;
                     i64toi32_i32$0 = HEAP32[($2 + 296 | 0) >> 2] | 0;
                     i64toi32_i32$5 = HEAP32[($2 + 300 | 0) >> 2] | 0;
                     $25 = i64toi32_i32$0;
                     $25$hi = i64toi32_i32$5;
                     $17 = HEAPU8[($2 + 288 | 0) >> 0] | 0;
                     i64toi32_i32$4 = $2;
                     i64toi32_i32$5 = HEAP32[($2 + 280 | 0) >> 2] | 0;
                     i64toi32_i32$0 = HEAP32[($2 + 284 | 0) >> 2] | 0;
                     i64toi32_i32$4 = i64toi32_i32$5;
                     i64toi32_i32$5 = 0;
                     i64toi32_i32$2 = 1;
                     if ((i64toi32_i32$4 | 0) != (i64toi32_i32$2 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$5 | 0) | 0) {
                      break label$27
                     }
                     i64toi32_i32$2 = ($2 + 256 | 0) + 8 | 0;
                     i64toi32_i32$4 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                     $736 = i64toi32_i32$4;
                     i64toi32_i32$4 = ($2 + 88 | 0) + 8 | 0;
                     HEAP32[i64toi32_i32$4 >> 2] = $736;
                     HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$0;
                     HEAP32[(($2 + 72 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 348 | 0) >> 2] | 0;
                     i64toi32_i32$2 = $2;
                     i64toi32_i32$0 = HEAP32[($2 + 340 | 0) >> 2] | 0;
                     i64toi32_i32$4 = HEAP32[($2 + 344 | 0) >> 2] | 0;
                     $21 = i64toi32_i32$0;
                     $21$hi = i64toi32_i32$4;
                     i64toi32_i32$0 = $2;
                     HEAP32[($2 + 240 | 0) >> 2] = $21;
                     HEAP32[($2 + 244 | 0) >> 2] = i64toi32_i32$4;
                     HEAP32[($2 + 48 | 0) >> 2] = HEAP32[($2 + 272 | 0) >> 2] | 0;
                     $108 = HEAPU8[($2 + 275 | 0) >> 0] | 0 | ((HEAPU8[($2 + 276 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 277 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 278 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                     HEAP8[($2 + 51 | 0) >> 0] = $108;
                     HEAP8[($2 + 52 | 0) >> 0] = $108 >>> 8 | 0;
                     HEAP8[($2 + 53 | 0) >> 0] = $108 >>> 16 | 0;
                     HEAP8[($2 + 54 | 0) >> 0] = $108 >>> 24 | 0;
                     i64toi32_i32$2 = $2;
                     i64toi32_i32$4 = HEAP32[($2 + 256 | 0) >> 2] | 0;
                     i64toi32_i32$0 = HEAP32[($2 + 260 | 0) >> 2] | 0;
                     $755 = i64toi32_i32$4;
                     i64toi32_i32$4 = $2;
                     HEAP32[($2 + 88 | 0) >> 2] = $755;
                     HEAP32[($2 + 92 | 0) >> 2] = i64toi32_i32$0;
                     i64toi32_i32$0 = $21$hi;
                     i64toi32_i32$4 = $2;
                     HEAP32[($2 + 72 | 0) >> 2] = $21;
                     HEAP32[($2 + 76 | 0) >> 2] = i64toi32_i32$0;
                     $1 = HEAP32[($2 + 336 | 0) >> 2] | 0;
                     i64toi32_i32$2 = $2 + 328 | 0;
                     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                     i64toi32_i32$4 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                     $23 = i64toi32_i32$0;
                     $23$hi = i64toi32_i32$4;
                     i64toi32_i32$4 = $25$hi;
                     $21 = $25;
                     $21$hi = i64toi32_i32$4;
                    }
                    i64toi32_i32$4 = $24$hi;
                    i64toi32_i32$0 = $2 + 296 | 0;
                    HEAP32[i64toi32_i32$0 >> 2] = $24;
                    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$4;
                    i64toi32_i32$4 = $21$hi;
                    i64toi32_i32$0 = ($2 + 280 | 0) + 8 | 0;
                    HEAP32[i64toi32_i32$0 >> 2] = $21;
                    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$4;
                    i64toi32_i32$2 = $2;
                    i64toi32_i32$4 = HEAP32[($2 + 88 | 0) >> 2] | 0;
                    i64toi32_i32$0 = HEAP32[($2 + 92 | 0) >> 2] | 0;
                    $775 = i64toi32_i32$4;
                    i64toi32_i32$4 = $2 + 304 | 0;
                    HEAP32[i64toi32_i32$4 >> 2] = $775;
                    HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$0;
                    i64toi32_i32$0 = $23$hi;
                    i64toi32_i32$4 = $2 + 320 | 0;
                    HEAP32[i64toi32_i32$4 >> 2] = $23;
                    HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$0;
                    i64toi32_i32$2 = $2;
                    i64toi32_i32$0 = HEAP32[($2 + 72 | 0) >> 2] | 0;
                    i64toi32_i32$4 = HEAP32[($2 + 76 | 0) >> 2] | 0;
                    $782 = i64toi32_i32$0;
                    i64toi32_i32$0 = $2 + 332 | 0;
                    HEAP32[i64toi32_i32$0 >> 2] = $782;
                    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$4;
                    i64toi32_i32$2 = ($2 + 88 | 0) + 8 | 0;
                    i64toi32_i32$4 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                    $788 = i64toi32_i32$4;
                    i64toi32_i32$4 = $2 + 312 | 0;
                    HEAP32[i64toi32_i32$4 >> 2] = $788;
                    HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$0;
                    HEAP32[($2 + 340 | 0) >> 2] = HEAP32[(($2 + 72 | 0) + 8 | 0) >> 2] | 0;
                    HEAP8[($2 + 280 | 0) >> 0] = $17;
                    $109 = HEAP32[($2 + 48 | 0) >> 2] | 0;
                    HEAP8[($2 + 281 | 0) >> 0] = $109;
                    HEAP8[($2 + 282 | 0) >> 0] = $109 >>> 8 | 0;
                    HEAP8[($2 + 283 | 0) >> 0] = $109 >>> 16 | 0;
                    HEAP8[($2 + 284 | 0) >> 0] = $109 >>> 24 | 0;
                    $110 = HEAPU8[($2 + 51 | 0) >> 0] | 0 | ((HEAPU8[($2 + 52 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 53 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 54 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                    HEAP8[($2 + 284 | 0) >> 0] = $110;
                    HEAP8[($2 + 285 | 0) >> 0] = $110 >>> 8 | 0;
                    HEAP8[($2 + 286 | 0) >> 0] = $110 >>> 16 | 0;
                    HEAP8[($2 + 287 | 0) >> 0] = $110 >>> 24 | 0;
                    HEAP32[($2 + 328 | 0) >> 2] = $1;
                    cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($15 | 0, $2 + 280 | 0 | 0, 1060064 | 0, 8 | 0);
                    $1 = ($2 + 40 | 0) + 4 | 0;
                    HEAP16[$1 >> 1] = HEAPU16[($9 + 4 | 0) >> 1] | 0;
                    HEAP32[($2 + 40 | 0) >> 2] = HEAPU16[$9 >> 1] | 0 | ((HEAPU16[($9 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
                    $11 = HEAP32[($2 + 152 | 0) >> 2] | 0;
                    $3 = HEAP32[($2 + 160 | 0) >> 2] | 0;
                    i64toi32_i32$2 = $2 + 168 | 0;
                    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                    i64toi32_i32$4 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                    $25 = i64toi32_i32$0;
                    $25$hi = i64toi32_i32$4;
                    $6 = HEAPU8[($2 + 112 | 0) >> 0] | 0;
                    $17 = HEAPU8[($2 + 113 | 0) >> 0] | 0;
                    $5 = HEAP32[($2 + 120 | 0) >> 2] | 0;
                    $4 = HEAP32[($2 + 124 | 0) >> 2] | 0;
                    i64toi32_i32$2 = $2;
                    i64toi32_i32$4 = HEAP32[($2 + 128 | 0) >> 2] | 0;
                    i64toi32_i32$0 = HEAP32[($2 + 132 | 0) >> 2] | 0;
                    $21 = i64toi32_i32$4;
                    $21$hi = i64toi32_i32$0;
                    i64toi32_i32$2 = $2;
                    i64toi32_i32$0 = HEAP32[($2 + 136 | 0) >> 2] | 0;
                    i64toi32_i32$4 = HEAP32[($2 + 140 | 0) >> 2] | 0;
                    $23 = i64toi32_i32$0;
                    $23$hi = i64toi32_i32$4;
                    i64toi32_i32$2 = $2;
                    i64toi32_i32$4 = HEAP32[($2 + 144 | 0) >> 2] | 0;
                    i64toi32_i32$0 = HEAP32[($2 + 148 | 0) >> 2] | 0;
                    $24 = i64toi32_i32$4;
                    $24$hi = i64toi32_i32$0;
                    $9 = HEAP32[($2 + 156 | 0) >> 2] | 0;
                    $18 = HEAP32[($2 + 164 | 0) >> 2] | 0;
                    HEAP16[(($2 + 88 | 0) + 4 | 0) >> 1] = HEAPU16[$1 >> 1] | 0;
                    HEAP32[($2 + 88 | 0) >> 2] = HEAP32[($2 + 40 | 0) >> 2] | 0;
                    break label$7;
                   }
                   HEAP32[($2 + 272 | 0) >> 2] = HEAPU8[$4 >> 0] | 0 | ((HEAPU8[($4 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                   $111 = HEAPU8[$16 >> 0] | 0 | ((HEAPU8[($16 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($16 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($16 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                   HEAP8[($2 + 275 | 0) >> 0] = $111;
                   HEAP8[($2 + 276 | 0) >> 0] = $111 >>> 8 | 0;
                   HEAP8[($2 + 277 | 0) >> 0] = $111 >>> 16 | 0;
                   HEAP8[($2 + 278 | 0) >> 0] = $111 >>> 24 | 0;
                   HEAP32[($2 + 48 | 0) >> 2] = HEAP32[($2 + 272 | 0) >> 2] | 0;
                   $112 = HEAPU8[($2 + 275 | 0) >> 0] | 0 | ((HEAPU8[($2 + 276 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 277 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 278 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                   HEAP8[($2 + 51 | 0) >> 0] = $112;
                   HEAP8[($2 + 52 | 0) >> 0] = $112 >>> 8 | 0;
                   HEAP8[($2 + 53 | 0) >> 0] = $112 >>> 16 | 0;
                   HEAP8[($2 + 54 | 0) >> 0] = $112 >>> 24 | 0;
                   $17 = HEAP32[($2 + 284 | 0) >> 2] | 0;
                   $3 = HEAPU8[($2 + 288 | 0) >> 0] | 0;
                   $113 = HEAP32[($2 + 48 | 0) >> 2] | 0;
                   HEAP8[$11 >> 0] = $113;
                   HEAP8[($11 + 1 | 0) >> 0] = $113 >>> 8 | 0;
                   HEAP8[($11 + 2 | 0) >> 0] = $113 >>> 16 | 0;
                   HEAP8[($11 + 3 | 0) >> 0] = $113 >>> 24 | 0;
                   $114 = $11 + 3 | 0;
                   $115 = HEAPU8[($2 + 51 | 0) >> 0] | 0 | ((HEAPU8[($2 + 52 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 53 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 54 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                   HEAP8[$114 >> 0] = $115;
                   HEAP8[($114 + 1 | 0) >> 0] = $115 >>> 8 | 0;
                   HEAP8[($114 + 2 | 0) >> 0] = $115 >>> 16 | 0;
                   HEAP8[($114 + 3 | 0) >> 0] = $115 >>> 24 | 0;
                   HEAP8[($2 + 112 | 0) >> 0] = $3;
                   HEAP32[($2 + 108 | 0) >> 2] = $17;
                   $19 = HEAPU8[($2 + 113 | 0) >> 0] | 0;
                   $20 = ($2 + 40 | 0) + 4 | 0;
                   HEAP16[$20 >> 1] = HEAPU16[($9 + 4 | 0) >> 1] | 0;
                   HEAP32[($2 + 40 | 0) >> 2] = HEAPU16[$9 >> 1] | 0 | ((HEAPU16[($9 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
                   core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__NativeScripts____hdd7d461255ec800a_1($2 + 24 | 0 | 0);
                   $142 = HEAP32[($2 + 40 | 0) >> 2] | 0;
                   HEAP16[$13 >> 1] = $142;
                   HEAP16[($13 + 2 | 0) >> 1] = $142 >>> 16 | 0;
                   HEAP16[($13 + 4 | 0) >> 1] = HEAPU16[$20 >> 1] | 0;
                   HEAP8[($2 + 29 | 0) >> 0] = $19;
                   HEAP8[($2 + 28 | 0) >> 0] = $3;
                   HEAP32[($2 + 24 | 0) >> 2] = $17;
                   break label$26;
                  }
                  $19 = ($2 + 88 | 0) + 8 | 0;
                  i64toi32_i32$2 = $3;
                  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                  i64toi32_i32$4 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                  $912 = i64toi32_i32$0;
                  i64toi32_i32$0 = $19;
                  HEAP32[i64toi32_i32$0 >> 2] = $912;
                  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$4;
                  HEAP32[($2 + 48 | 0) >> 2] = HEAP32[($2 + 272 | 0) >> 2] | 0;
                  $116 = HEAPU8[($2 + 275 | 0) >> 0] | 0 | ((HEAPU8[($2 + 276 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 277 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 278 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                  HEAP8[($2 + 51 | 0) >> 0] = $116;
                  HEAP8[($2 + 52 | 0) >> 0] = $116 >>> 8 | 0;
                  HEAP8[($2 + 53 | 0) >> 0] = $116 >>> 16 | 0;
                  HEAP8[($2 + 54 | 0) >> 0] = $116 >>> 24 | 0;
                  i64toi32_i32$2 = $2;
                  i64toi32_i32$4 = HEAP32[($2 + 256 | 0) >> 2] | 0;
                  i64toi32_i32$0 = HEAP32[($2 + 260 | 0) >> 2] | 0;
                  $921 = i64toi32_i32$4;
                  i64toi32_i32$4 = $2;
                  HEAP32[($2 + 88 | 0) >> 2] = $921;
                  HEAP32[($2 + 92 | 0) >> 2] = i64toi32_i32$0;
                  $117 = HEAP32[($2 + 48 | 0) >> 2] | 0;
                  HEAP8[$11 >> 0] = $117;
                  HEAP8[($11 + 1 | 0) >> 0] = $117 >>> 8 | 0;
                  HEAP8[($11 + 2 | 0) >> 0] = $117 >>> 16 | 0;
                  HEAP8[($11 + 3 | 0) >> 0] = $117 >>> 24 | 0;
                  $118 = $11 + 3 | 0;
                  $119 = HEAPU8[($2 + 51 | 0) >> 0] | 0 | ((HEAPU8[($2 + 52 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 53 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 54 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                  HEAP8[$118 >> 0] = $119;
                  HEAP8[($118 + 1 | 0) >> 0] = $119 >>> 8 | 0;
                  HEAP8[($118 + 2 | 0) >> 0] = $119 >>> 16 | 0;
                  HEAP8[($118 + 3 | 0) >> 0] = $119 >>> 24 | 0;
                  HEAP8[($2 + 112 | 0) >> 0] = $17;
                  i64toi32_i32$0 = $24$hi;
                  i64toi32_i32$4 = $2;
                  HEAP32[($2 + 128 | 0) >> 2] = $24;
                  HEAP32[($2 + 132 | 0) >> 2] = i64toi32_i32$0;
                  i64toi32_i32$0 = $25$hi;
                  i64toi32_i32$4 = $2;
                  HEAP32[($2 + 120 | 0) >> 2] = $25;
                  HEAP32[($2 + 124 | 0) >> 2] = i64toi32_i32$0;
                  i64toi32_i32$2 = $2;
                  i64toi32_i32$0 = HEAP32[($2 + 88 | 0) >> 2] | 0;
                  i64toi32_i32$4 = HEAP32[($2 + 92 | 0) >> 2] | 0;
                  $937 = i64toi32_i32$0;
                  i64toi32_i32$0 = $10;
                  HEAP32[i64toi32_i32$0 >> 2] = $937;
                  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$4;
                  i64toi32_i32$2 = $19;
                  i64toi32_i32$4 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                  $941 = i64toi32_i32$4;
                  i64toi32_i32$4 = $10 + 8 | 0;
                  HEAP32[i64toi32_i32$4 >> 2] = $941;
                  HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$0;
                  $3 = HEAPU8[($2 + 113 | 0) >> 0] | 0;
                  $19 = ($2 + 40 | 0) + 4 | 0;
                  HEAP16[$19 >> 1] = HEAPU16[($9 + 4 | 0) >> 1] | 0;
                  HEAP32[($2 + 40 | 0) >> 2] = HEAPU16[$9 >> 1] | 0 | ((HEAPU16[($9 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
                  i64toi32_i32$2 = $2;
                  i64toi32_i32$0 = HEAP32[($2 + 136 | 0) >> 2] | 0;
                  i64toi32_i32$4 = HEAP32[($2 + 140 | 0) >> 2] | 0;
                  $26 = i64toi32_i32$0;
                  $26$hi = i64toi32_i32$4;
                  i64toi32_i32$2 = $2;
                  i64toi32_i32$4 = HEAP32[($2 + 144 | 0) >> 2] | 0;
                  i64toi32_i32$0 = HEAP32[($2 + 148 | 0) >> 2] | 0;
                  core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__metadata__GeneralTransactionMetadata____h37a091753d7f028f($2 + 176 | 0 | 0);
                  $143 = HEAP32[($2 + 40 | 0) >> 2] | 0;
                  HEAP16[$8 >> 1] = $143;
                  HEAP16[($8 + 2 | 0) >> 1] = $143 >>> 16 | 0;
                  HEAP16[($8 + 4 | 0) >> 1] = HEAPU16[$19 >> 1] | 0;
                  HEAP8[($2 + 177 | 0) >> 0] = $3;
                  HEAP8[($2 + 176 | 0) >> 0] = $17;
                  $972 = i64toi32_i32$4;
                  i64toi32_i32$4 = $2;
                  HEAP32[($2 + 208 | 0) >> 2] = $972;
                  HEAP32[($2 + 212 | 0) >> 2] = i64toi32_i32$0;
                  i64toi32_i32$0 = $26$hi;
                  i64toi32_i32$4 = $2;
                  HEAP32[($2 + 200 | 0) >> 2] = $26;
                  HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$0;
                  i64toi32_i32$0 = $24$hi;
                  i64toi32_i32$4 = $2;
                  HEAP32[($2 + 192 | 0) >> 2] = $24;
                  HEAP32[($2 + 196 | 0) >> 2] = i64toi32_i32$0;
                  $977 = $2;
                  i64toi32_i32$0 = $25$hi;
                  i64toi32_i32$2 = $25;
                  i64toi32_i32$4 = 0;
                  i64toi32_i32$5 = 32;
                  i64toi32_i32$1 = i64toi32_i32$5 & 31 | 0;
                  if (32 >>> 0 <= (i64toi32_i32$5 & 63 | 0) >>> 0) {
                   i64toi32_i32$4 = 0;
                   $144 = i64toi32_i32$0 >>> i64toi32_i32$1 | 0;
                  } else {
                   i64toi32_i32$4 = i64toi32_i32$0 >>> i64toi32_i32$1 | 0;
                   $144 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$1 | 0) | 0;
                  }
                  HEAP32[($977 + 188 | 0) >> 2] = $144;
                  i64toi32_i32$4 = $25$hi;
                  HEAP32[($2 + 184 | 0) >> 2] = $25;
                 }
                 $17 = $18 + 1 | 0;
                 i64toi32_i32$4 = $22$hi;
                 i64toi32_i32$0 = $22;
                 i64toi32_i32$2 = 0;
                 i64toi32_i32$5 = 1;
                 if ((i64toi32_i32$0 | 0) != (i64toi32_i32$5 | 0) | (i64toi32_i32$4 | 0) != (i64toi32_i32$2 | 0) | 0) {
                  continue label$18
                 }
                 if ($18 >>> 0 < $7 >>> 0) {
                  continue label$18
                 }
                 break label$9;
                };
               }
               i64toi32_i32$0 = $22$hi;
               i64toi32_i32$5 = $22;
               i64toi32_i32$4 = 0;
               i64toi32_i32$2 = 32;
               i64toi32_i32$1 = i64toi32_i32$2 & 31 | 0;
               if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                i64toi32_i32$4 = 0;
                $145 = i64toi32_i32$0 >>> i64toi32_i32$1 | 0;
               } else {
                i64toi32_i32$4 = i64toi32_i32$0 >>> i64toi32_i32$1 | 0;
                $145 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$1 | 0) | 0;
               }
               $4 = $145;
               $9 = HEAP32[($2 + 324 | 0) >> 2] | 0;
               $11 = HEAP32[($2 + 320 | 0) >> 2] | 0;
               i64toi32_i32$0 = $2 + 312 | 0;
               i64toi32_i32$4 = HEAP32[i64toi32_i32$0 >> 2] | 0;
               i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
               $24 = i64toi32_i32$4;
               $24$hi = i64toi32_i32$5;
               i64toi32_i32$0 = $2 + 304 | 0;
               i64toi32_i32$5 = HEAP32[i64toi32_i32$0 >> 2] | 0;
               i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
               $23 = i64toi32_i32$5;
               $23$hi = i64toi32_i32$4;
               i64toi32_i32$0 = $2 + 296 | 0;
               i64toi32_i32$4 = HEAP32[i64toi32_i32$0 >> 2] | 0;
               i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
               $21 = i64toi32_i32$4;
               $21$hi = i64toi32_i32$5;
               i64toi32_i32$5 = $22$hi;
               $5 = $22;
               break label$5;
              }
              alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($2 + 328 | 0 | 0, 1060100 | 0, 13 | 0);
              HEAP16[($2 + 92 | 0) >> 1] = HEAPU16[($2 + 286 | 0) >> 1] | 0;
              HEAP32[($2 + 88 | 0) >> 2] = HEAPU16[($2 + 282 | 0) >> 1] | 0 | ((HEAPU16[($2 + 284 | 0) >> 1] | 0) << 16 | 0) | 0;
              i64toi32_i32$5 = $22$hi;
              i64toi32_i32$0 = $22;
              i64toi32_i32$4 = 0;
              i64toi32_i32$2 = 32;
              i64toi32_i32$1 = i64toi32_i32$2 & 31 | 0;
              if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
               i64toi32_i32$4 = 0;
               $146 = i64toi32_i32$5 >>> i64toi32_i32$1 | 0;
              } else {
               i64toi32_i32$4 = i64toi32_i32$5 >>> i64toi32_i32$1 | 0;
               $146 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$1 | 0) | 0;
              }
              $4 = $146;
              i64toi32_i32$5 = $2 + 304 | 0;
              i64toi32_i32$4 = HEAP32[i64toi32_i32$5 >> 2] | 0;
              i64toi32_i32$0 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
              $23 = i64toi32_i32$4;
              $23$hi = i64toi32_i32$0;
              i64toi32_i32$5 = $2 + 312 | 0;
              i64toi32_i32$0 = HEAP32[i64toi32_i32$5 >> 2] | 0;
              i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
              $24 = i64toi32_i32$0;
              $24$hi = i64toi32_i32$4;
              $11 = HEAP32[($2 + 320 | 0) >> 2] | 0;
              $9 = HEAP32[($2 + 324 | 0) >> 2] | 0;
              $18 = HEAP32[($2 + 332 | 0) >> 2] | 0;
              i64toi32_i32$5 = $2 + 336 | 0;
              i64toi32_i32$4 = HEAP32[i64toi32_i32$5 >> 2] | 0;
              i64toi32_i32$0 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
              $25 = i64toi32_i32$4;
              $25$hi = i64toi32_i32$0;
              $17 = HEAPU8[($2 + 281 | 0) >> 0] | 0;
              $3 = HEAP32[($2 + 328 | 0) >> 2] | 0;
              i64toi32_i32$0 = $22$hi;
              $5 = $22;
              $6 = 15;
              break label$2;
             case 0:
              cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 280 | 0 | 0, $1 | 0);
              i64toi32_i32$5 = $2 + 296 | 0;
              i64toi32_i32$0 = HEAP32[i64toi32_i32$5 >> 2] | 0;
              i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
              $22 = i64toi32_i32$0;
              $22$hi = i64toi32_i32$4;
              i64toi32_i32$5 = $2;
              i64toi32_i32$4 = HEAP32[($2 + 288 | 0) >> 2] | 0;
              i64toi32_i32$0 = HEAP32[($2 + 292 | 0) >> 2] | 0;
              $25 = i64toi32_i32$4;
              $25$hi = i64toi32_i32$0;
              label$44 : {
               label$45 : {
                label$46 : {
                 i64toi32_i32$5 = $2;
                 i64toi32_i32$0 = HEAP32[($2 + 280 | 0) >> 2] | 0;
                 i64toi32_i32$4 = HEAP32[($2 + 284 | 0) >> 2] | 0;
                 i64toi32_i32$5 = i64toi32_i32$0;
                 i64toi32_i32$0 = 0;
                 i64toi32_i32$2 = 1;
                 if ((i64toi32_i32$5 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$4 | 0) == (i64toi32_i32$0 | 0) | 0) {
                  break label$46
                 }
                 label$47 : {
                  i64toi32_i32$5 = $25$hi;
                  i64toi32_i32$2 = $25;
                  i64toi32_i32$4 = 0;
                  i64toi32_i32$0 = 1;
                  if ((i64toi32_i32$2 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$5 | 0) != (i64toi32_i32$4 | 0) | 0) {
                   break label$47
                  }
                  i64toi32_i32$2 = $22$hi;
                  i64toi32_i32$0 = $22;
                  i64toi32_i32$5 = 0;
                  i64toi32_i32$4 = 2;
                  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$4 >>> 0 | 0) | 0) {
                   break label$45
                  }
                 }
                 $cardano_serialization_lib__metadata__GeneralTransactionMetadata_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h2cbfe28ae9769528($2 + 280 | 0 | 0, $1 | 0);
                 $6 = ($2 + 256 | 0) + 8 | 0;
                 $5 = ($2 + 280 | 0) + 40 | 0;
                 i64toi32_i32$4 = $5;
                 i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                 i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                 $1071 = i64toi32_i32$0;
                 i64toi32_i32$0 = $6;
                 HEAP32[i64toi32_i32$0 >> 2] = $1071;
                 HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
                 HEAP32[($2 + 272 | 0) >> 2] = HEAPU8[($2 + 289 | 0) >> 0] | 0 | ((HEAPU8[($2 + 290 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 291 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 292 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 $120 = ($2 + 280 | 0) + 12 | 0;
                 $121 = HEAPU8[$120 >> 0] | 0 | ((HEAPU8[($120 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($120 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($120 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 HEAP8[($2 + 275 | 0) >> 0] = $121;
                 HEAP8[($2 + 276 | 0) >> 0] = $121 >>> 8 | 0;
                 HEAP8[($2 + 277 | 0) >> 0] = $121 >>> 16 | 0;
                 HEAP8[($2 + 278 | 0) >> 0] = $121 >>> 24 | 0;
                 $18 = ($2 + 280 | 0) + 32 | 0;
                 i64toi32_i32$4 = $18;
                 i64toi32_i32$2 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                 i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                 $1085 = i64toi32_i32$2;
                 i64toi32_i32$2 = $2;
                 HEAP32[($2 + 256 | 0) >> 2] = $1085;
                 HEAP32[($2 + 260 | 0) >> 2] = i64toi32_i32$0;
                 $9 = ($2 + 280 | 0) + 24 | 0;
                 i64toi32_i32$4 = $9;
                 i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                 i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                 $21 = i64toi32_i32$0;
                 $21$hi = i64toi32_i32$2;
                 $11 = ($2 + 280 | 0) + 16 | 0;
                 i64toi32_i32$4 = $11;
                 i64toi32_i32$2 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                 i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                 $22 = i64toi32_i32$2;
                 $22$hi = i64toi32_i32$0;
                 $17 = HEAPU8[($2 + 288 | 0) >> 0] | 0;
                 label$48 : {
                  label$49 : {
                   label$50 : {
                    label$51 : {
                     label$52 : {
                      i64toi32_i32$4 = $2;
                      i64toi32_i32$0 = HEAP32[($2 + 280 | 0) >> 2] | 0;
                      i64toi32_i32$2 = HEAP32[($2 + 284 | 0) >> 2] | 0;
                      i64toi32_i32$4 = i64toi32_i32$0;
                      i64toi32_i32$0 = 0;
                      i64toi32_i32$5 = 1;
                      if ((i64toi32_i32$4 | 0) == (i64toi32_i32$5 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) | 0) {
                       break label$52
                      }
                      $5 = ($2 + 88 | 0) + 8 | 0;
                      i64toi32_i32$5 = $6;
                      i64toi32_i32$4 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                      i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                      $1106 = i64toi32_i32$4;
                      i64toi32_i32$4 = $5;
                      HEAP32[i64toi32_i32$4 >> 2] = $1106;
                      HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$2;
                      $122 = HEAPU8[($2 + 275 | 0) >> 0] | 0 | ((HEAPU8[($2 + 276 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 277 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 278 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                      HEAP8[($2 + 59 | 0) >> 0] = $122;
                      HEAP8[($2 + 60 | 0) >> 0] = $122 >>> 8 | 0;
                      HEAP8[($2 + 61 | 0) >> 0] = $122 >>> 16 | 0;
                      HEAP8[($2 + 62 | 0) >> 0] = $122 >>> 24 | 0;
                      HEAP32[($2 + 56 | 0) >> 2] = HEAP32[($2 + 272 | 0) >> 2] | 0;
                      $123 = ($2 + 104 | 0) + 12 | 0;
                      $124 = HEAPU8[($2 + 59 | 0) >> 0] | 0 | ((HEAPU8[($2 + 60 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 61 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 62 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                      HEAP8[$123 >> 0] = $124;
                      HEAP8[($123 + 1 | 0) >> 0] = $124 >>> 8 | 0;
                      HEAP8[($123 + 2 | 0) >> 0] = $124 >>> 16 | 0;
                      HEAP8[($123 + 3 | 0) >> 0] = $124 >>> 24 | 0;
                      i64toi32_i32$5 = $2;
                      i64toi32_i32$2 = HEAP32[($2 + 256 | 0) >> 2] | 0;
                      i64toi32_i32$4 = HEAP32[($2 + 260 | 0) >> 2] | 0;
                      $1120 = i64toi32_i32$2;
                      i64toi32_i32$2 = $2;
                      HEAP32[($2 + 88 | 0) >> 2] = $1120;
                      HEAP32[($2 + 92 | 0) >> 2] = i64toi32_i32$4;
                      HEAP8[($2 + 112 | 0) >> 0] = $17;
                      $125 = HEAP32[($2 + 56 | 0) >> 2] | 0;
                      HEAP8[($2 + 113 | 0) >> 0] = $125;
                      HEAP8[($2 + 114 | 0) >> 0] = $125 >>> 8 | 0;
                      HEAP8[($2 + 115 | 0) >> 0] = $125 >>> 16 | 0;
                      HEAP8[($2 + 116 | 0) >> 0] = $125 >>> 24 | 0;
                      i64toi32_i32$4 = $21$hi;
                      i64toi32_i32$2 = ($2 + 104 | 0) + 24 | 0;
                      HEAP32[i64toi32_i32$2 >> 2] = $21;
                      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$4;
                      i64toi32_i32$4 = $22$hi;
                      i64toi32_i32$2 = ($2 + 104 | 0) + 16 | 0;
                      HEAP32[i64toi32_i32$2 >> 2] = $22;
                      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$4;
                      $6 = ($2 + 104 | 0) + 40 | 0;
                      i64toi32_i32$5 = $5;
                      i64toi32_i32$4 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                      i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                      $1139 = i64toi32_i32$4;
                      i64toi32_i32$4 = $6;
                      HEAP32[i64toi32_i32$4 >> 2] = $1139;
                      HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$2;
                      $18 = ($2 + 104 | 0) + 32 | 0;
                      i64toi32_i32$5 = $2;
                      i64toi32_i32$2 = HEAP32[($2 + 88 | 0) >> 2] | 0;
                      i64toi32_i32$4 = HEAP32[($2 + 92 | 0) >> 2] | 0;
                      $1145 = i64toi32_i32$2;
                      i64toi32_i32$2 = $18;
                      HEAP32[i64toi32_i32$2 >> 2] = $1145;
                      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$4;
                      $5 = HEAPU8[($2 + 113 | 0) >> 0] | 0;
                      $9 = ($2 + 24 | 0) + 4 | 0;
                      $4 = ($2 + 104 | 0) + 14 | 0;
                      HEAP16[$9 >> 1] = HEAPU16[$4 >> 1] | 0;
                      HEAP32[($2 + 24 | 0) >> 2] = HEAPU16[($2 + 114 | 0) >> 1] | 0 | ((HEAPU16[($2 + 116 | 0) >> 1] | 0) << 16 | 0) | 0;
                      i64toi32_i32$5 = $6;
                      i64toi32_i32$4 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                      i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                      $23 = i64toi32_i32$4;
                      $23$hi = i64toi32_i32$2;
                      i64toi32_i32$5 = $18;
                      i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                      i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                      $24 = i64toi32_i32$2;
                      $24$hi = i64toi32_i32$4;
                      HEAP8[($2 + 177 | 0) >> 0] = $5;
                      HEAP8[($2 + 176 | 0) >> 0] = $17;
                      HEAP16[($2 + 182 | 0) >> 1] = HEAPU16[$9 >> 1] | 0;
                      $147 = HEAP32[($2 + 24 | 0) >> 2] | 0;
                      HEAP16[($2 + 178 | 0) >> 1] = $147;
                      HEAP16[($2 + 180 | 0) >> 1] = $147 >>> 16 | 0;
                      i64toi32_i32$2 = ($2 + 176 | 0) + 24 | 0;
                      HEAP32[i64toi32_i32$2 >> 2] = $24;
                      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$4;
                      i64toi32_i32$4 = $23$hi;
                      i64toi32_i32$2 = $2;
                      HEAP32[($2 + 208 | 0) >> 2] = $23;
                      HEAP32[($2 + 212 | 0) >> 2] = i64toi32_i32$4;
                      i64toi32_i32$4 = $21$hi;
                      i64toi32_i32$2 = $2;
                      HEAP32[($2 + 192 | 0) >> 2] = $21;
                      HEAP32[($2 + 196 | 0) >> 2] = i64toi32_i32$4;
                      $1182 = $2;
                      i64toi32_i32$4 = $22$hi;
                      i64toi32_i32$5 = $22;
                      i64toi32_i32$2 = 0;
                      i64toi32_i32$0 = 32;
                      i64toi32_i32$1 = i64toi32_i32$0 & 31 | 0;
                      if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
                       i64toi32_i32$2 = 0;
                       $148 = i64toi32_i32$4 >>> i64toi32_i32$1 | 0;
                      } else {
                       i64toi32_i32$2 = i64toi32_i32$4 >>> i64toi32_i32$1 | 0;
                       $148 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$1 | 0) | 0;
                      }
                      $9 = $148;
                      HEAP32[($1182 + 188 | 0) >> 2] = $9;
                      i64toi32_i32$2 = $22$hi;
                      $18 = $22;
                      HEAP32[($2 + 184 | 0) >> 2] = $22;
                      cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__NativeScripts___deserialize__h5fb973a07bcdbe01($2 + 280 | 0 | 0, $1 | 0);
                      if ((HEAP32[($2 + 280 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                       break label$51
                      }
                      $6 = HEAPU8[(($2 + 280 | 0) + 8 | 0) >> 0] | 0;
                      HEAP8[(($2 + 104 | 0) + 8 | 0) >> 0] = $6;
                      HEAP32[($2 + 272 | 0) >> 2] = HEAPU8[($2 + 289 | 0) >> 0] | 0 | ((HEAPU8[($2 + 290 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 291 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 292 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                      $126 = ($2 + 280 | 0) + 12 | 0;
                      $127 = HEAPU8[$126 >> 0] | 0 | ((HEAPU8[($126 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($126 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($126 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                      HEAP8[($2 + 275 | 0) >> 0] = $127;
                      HEAP8[($2 + 276 | 0) >> 0] = $127 >>> 8 | 0;
                      HEAP8[($2 + 277 | 0) >> 0] = $127 >>> 16 | 0;
                      HEAP8[($2 + 278 | 0) >> 0] = $127 >>> 24 | 0;
                      HEAP32[($2 + 24 | 0) >> 2] = HEAP32[($2 + 272 | 0) >> 2] | 0;
                      $128 = HEAPU8[($2 + 275 | 0) >> 0] | 0 | ((HEAPU8[($2 + 276 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 277 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 278 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                      HEAP8[($2 + 27 | 0) >> 0] = $128;
                      HEAP8[($2 + 28 | 0) >> 0] = $128 >>> 8 | 0;
                      HEAP8[($2 + 29 | 0) >> 0] = $128 >>> 16 | 0;
                      HEAP8[($2 + 30 | 0) >> 0] = $128 >>> 24 | 0;
                      $11 = HEAP32[($2 + 284 | 0) >> 2] | 0;
                      HEAP32[($2 + 108 | 0) >> 2] = $11;
                      $129 = ($2 + 104 | 0) + 12 | 0;
                      $130 = HEAPU8[($2 + 27 | 0) >> 0] | 0 | ((HEAPU8[($2 + 28 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 29 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 30 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                      HEAP8[$129 >> 0] = $130;
                      HEAP8[($129 + 1 | 0) >> 0] = $130 >>> 8 | 0;
                      HEAP8[($129 + 2 | 0) >> 0] = $130 >>> 16 | 0;
                      HEAP8[($129 + 3 | 0) >> 0] = $130 >>> 24 | 0;
                      $131 = HEAP32[($2 + 24 | 0) >> 2] | 0;
                      HEAP8[($2 + 113 | 0) >> 0] = $131;
                      HEAP8[($2 + 114 | 0) >> 0] = $131 >>> 8 | 0;
                      HEAP8[($2 + 115 | 0) >> 0] = $131 >>> 16 | 0;
                      HEAP8[($2 + 116 | 0) >> 0] = $131 >>> 24 | 0;
                      $3 = HEAPU8[($2 + 113 | 0) >> 0] | 0;
                      $7 = ($2 + 48 | 0) + 4 | 0;
                      HEAP16[$7 >> 1] = HEAPU16[$4 >> 1] | 0;
                      HEAP32[($2 + 48 | 0) >> 2] = HEAPU16[($2 + 114 | 0) >> 1] | 0 | ((HEAPU16[($2 + 116 | 0) >> 1] | 0) << 16 | 0) | 0;
                      HEAP8[($2 + 61 | 0) >> 0] = $3;
                      HEAP8[($2 + 60 | 0) >> 0] = $6;
                      HEAP32[($2 + 56 | 0) >> 2] = $11;
                      HEAP16[($2 + 66 | 0) >> 1] = HEAPU16[$7 >> 1] | 0;
                      $149 = HEAP32[($2 + 48 | 0) >> 2] | 0;
                      HEAP16[($2 + 62 | 0) >> 1] = $149;
                      HEAP16[($2 + 64 | 0) >> 1] = $149 >>> 16 | 0;
                      i64toi32_i32$2 = $25$hi;
                      i64toi32_i32$4 = $25;
                      i64toi32_i32$5 = 0;
                      i64toi32_i32$0 = 1;
                      if ((i64toi32_i32$4 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$5 | 0) | 0) {
                       break label$48
                      }
                      cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 280 | 0 | 0, $1 | 0);
                      $1 = HEAPU8[($2 + 288 | 0) >> 0] | 0;
                      i64toi32_i32$0 = $2;
                      i64toi32_i32$4 = HEAP32[($2 + 280 | 0) >> 2] | 0;
                      i64toi32_i32$2 = HEAP32[($2 + 284 | 0) >> 2] | 0;
                      i64toi32_i32$0 = i64toi32_i32$4;
                      i64toi32_i32$4 = 0;
                      i64toi32_i32$5 = 1;
                      if ((i64toi32_i32$0 | 0) == (i64toi32_i32$5 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$4 | 0) | 0) {
                       break label$50
                      }
                      $6 = 5;
                      if (($1 | 0) == (5 | 0)) {
                       break label$48
                      }
                      break label$49;
                     }
                     $1 = ($2 + 88 | 0) + 8 | 0;
                     i64toi32_i32$5 = $6;
                     i64toi32_i32$0 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                     i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                     $1272 = i64toi32_i32$0;
                     i64toi32_i32$0 = $1;
                     HEAP32[i64toi32_i32$0 >> 2] = $1272;
                     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
                     $6 = ($2 + 72 | 0) + 8 | 0;
                     HEAP32[$6 >> 2] = HEAP32[($2 + 348 | 0) >> 2] | 0;
                     i64toi32_i32$5 = $2;
                     i64toi32_i32$2 = HEAP32[($2 + 340 | 0) >> 2] | 0;
                     i64toi32_i32$0 = HEAP32[($2 + 344 | 0) >> 2] | 0;
                     $23 = i64toi32_i32$2;
                     $23$hi = i64toi32_i32$0;
                     i64toi32_i32$2 = $2;
                     HEAP32[($2 + 240 | 0) >> 2] = $23;
                     HEAP32[($2 + 244 | 0) >> 2] = i64toi32_i32$0;
                     HEAP32[($2 + 56 | 0) >> 2] = HEAP32[($2 + 272 | 0) >> 2] | 0;
                     $132 = HEAPU8[($2 + 275 | 0) >> 0] | 0 | ((HEAPU8[($2 + 276 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 277 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 278 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                     HEAP8[($2 + 59 | 0) >> 0] = $132;
                     HEAP8[($2 + 60 | 0) >> 0] = $132 >>> 8 | 0;
                     HEAP8[($2 + 61 | 0) >> 0] = $132 >>> 16 | 0;
                     HEAP8[($2 + 62 | 0) >> 0] = $132 >>> 24 | 0;
                     i64toi32_i32$5 = $2;
                     i64toi32_i32$0 = HEAP32[($2 + 256 | 0) >> 2] | 0;
                     i64toi32_i32$2 = HEAP32[($2 + 260 | 0) >> 2] | 0;
                     $1292 = i64toi32_i32$0;
                     i64toi32_i32$0 = $2;
                     HEAP32[($2 + 88 | 0) >> 2] = $1292;
                     HEAP32[($2 + 92 | 0) >> 2] = i64toi32_i32$2;
                     i64toi32_i32$2 = $23$hi;
                     i64toi32_i32$0 = $2;
                     HEAP32[($2 + 72 | 0) >> 2] = $23;
                     HEAP32[($2 + 76 | 0) >> 2] = i64toi32_i32$2;
                     $4 = HEAP32[(($2 + 280 | 0) + 56 | 0) >> 2] | 0;
                     i64toi32_i32$5 = ($2 + 280 | 0) + 48 | 0;
                     i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                     i64toi32_i32$0 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                     $23 = i64toi32_i32$2;
                     $23$hi = i64toi32_i32$0;
                     i64toi32_i32$0 = $21$hi;
                     i64toi32_i32$2 = $11;
                     HEAP32[i64toi32_i32$2 >> 2] = $21;
                     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
                     i64toi32_i32$0 = $22$hi;
                     i64toi32_i32$2 = ($2 + 280 | 0) + 8 | 0;
                     HEAP32[i64toi32_i32$2 >> 2] = $22;
                     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
                     i64toi32_i32$0 = $23$hi;
                     i64toi32_i32$2 = $5;
                     HEAP32[i64toi32_i32$2 >> 2] = $23;
                     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
                     HEAP8[($2 + 280 | 0) >> 0] = $17;
                     $133 = HEAP32[($2 + 56 | 0) >> 2] | 0;
                     HEAP8[($2 + 281 | 0) >> 0] = $133;
                     HEAP8[($2 + 282 | 0) >> 0] = $133 >>> 8 | 0;
                     HEAP8[($2 + 283 | 0) >> 0] = $133 >>> 16 | 0;
                     HEAP8[($2 + 284 | 0) >> 0] = $133 >>> 24 | 0;
                     $134 = HEAPU8[($2 + 59 | 0) >> 0] | 0 | ((HEAPU8[($2 + 60 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 61 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 62 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                     HEAP8[($2 + 284 | 0) >> 0] = $134;
                     HEAP8[($2 + 285 | 0) >> 0] = $134 >>> 8 | 0;
                     HEAP8[($2 + 286 | 0) >> 0] = $134 >>> 16 | 0;
                     HEAP8[($2 + 287 | 0) >> 0] = $134 >>> 24 | 0;
                     i64toi32_i32$5 = $2;
                     i64toi32_i32$0 = HEAP32[($2 + 88 | 0) >> 2] | 0;
                     i64toi32_i32$2 = HEAP32[($2 + 92 | 0) >> 2] | 0;
                     $1321 = i64toi32_i32$0;
                     i64toi32_i32$0 = $9;
                     HEAP32[i64toi32_i32$0 >> 2] = $1321;
                     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
                     i64toi32_i32$5 = $1;
                     i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                     i64toi32_i32$0 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                     $1324 = i64toi32_i32$2;
                     i64toi32_i32$2 = $18;
                     HEAP32[i64toi32_i32$2 >> 2] = $1324;
                     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
                     HEAP32[($2 + 328 | 0) >> 2] = $4;
                     i64toi32_i32$5 = $2;
                     i64toi32_i32$0 = HEAP32[($2 + 72 | 0) >> 2] | 0;
                     i64toi32_i32$2 = HEAP32[($2 + 76 | 0) >> 2] | 0;
                     $1331 = i64toi32_i32$0;
                     i64toi32_i32$0 = ($2 + 280 | 0) + 52 | 0;
                     HEAP32[i64toi32_i32$0 >> 2] = $1331;
                     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
                     HEAP32[(($2 + 280 | 0) + 60 | 0) >> 2] = HEAP32[$6 >> 2] | 0;
                     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e(($2 + 104 | 0) + 8 | 0 | 0, $2 + 280 | 0 | 0, 1060064 | 0, 8 | 0);
                     $1 = ($2 + 24 | 0) + 4 | 0;
                     HEAP16[$1 >> 1] = HEAPU16[($2 + 118 | 0) >> 1] | 0;
                     HEAP32[($2 + 24 | 0) >> 2] = HEAPU16[($2 + 114 | 0) >> 1] | 0 | ((HEAPU16[($2 + 116 | 0) >> 1] | 0) << 16 | 0) | 0;
                     $5 = HEAP32[(($2 + 104 | 0) + 16 | 0) >> 2] | 0;
                     $4 = HEAP32[($2 + 124 | 0) >> 2] | 0;
                     i64toi32_i32$5 = ($2 + 104 | 0) + 24 | 0;
                     i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                     i64toi32_i32$0 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                     $21 = i64toi32_i32$2;
                     $21$hi = i64toi32_i32$0;
                     i64toi32_i32$5 = ($2 + 104 | 0) + 32 | 0;
                     i64toi32_i32$0 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                     i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                     $23 = i64toi32_i32$0;
                     $23$hi = i64toi32_i32$2;
                     i64toi32_i32$5 = ($2 + 104 | 0) + 40 | 0;
                     i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                     i64toi32_i32$0 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                     $24 = i64toi32_i32$2;
                     $24$hi = i64toi32_i32$0;
                     $11 = HEAP32[(($2 + 104 | 0) + 48 | 0) >> 2] | 0;
                     $9 = HEAP32[(($2 + 104 | 0) + 52 | 0) >> 2] | 0;
                     $3 = HEAP32[(($2 + 104 | 0) + 56 | 0) >> 2] | 0;
                     $18 = HEAP32[(($2 + 104 | 0) + 60 | 0) >> 2] | 0;
                     i64toi32_i32$5 = $2 + 168 | 0;
                     i64toi32_i32$0 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                     i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                     $25 = i64toi32_i32$0;
                     $25$hi = i64toi32_i32$2;
                     $6 = HEAPU8[($2 + 112 | 0) >> 0] | 0;
                     $17 = HEAPU8[($2 + 113 | 0) >> 0] | 0;
                     HEAP16[(($2 + 88 | 0) + 4 | 0) >> 1] = HEAPU16[$1 >> 1] | 0;
                     HEAP32[($2 + 88 | 0) >> 2] = HEAP32[($2 + 24 | 0) >> 2] | 0;
                     break label$2;
                    }
                    $1 = ($2 + 256 | 0) + 8 | 0;
                    $17 = ($2 + 280 | 0) + 40 | 0;
                    i64toi32_i32$5 = $17;
                    i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                    i64toi32_i32$0 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                    $1410 = i64toi32_i32$2;
                    i64toi32_i32$2 = $1;
                    HEAP32[i64toi32_i32$2 >> 2] = $1410;
                    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
                    $6 = ($2 + 240 | 0) + 8 | 0;
                    HEAP32[$6 >> 2] = HEAP32[($2 + 348 | 0) >> 2] | 0;
                    HEAP32[($2 + 272 | 0) >> 2] = HEAPU8[($2 + 289 | 0) >> 0] | 0 | ((HEAPU8[($2 + 290 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 291 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 292 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                    $135 = $2 + 292 | 0;
                    $136 = HEAPU8[$135 >> 0] | 0 | ((HEAPU8[($135 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($135 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($135 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                    HEAP8[($2 + 275 | 0) >> 0] = $136;
                    HEAP8[($2 + 276 | 0) >> 0] = $136 >>> 8 | 0;
                    HEAP8[($2 + 277 | 0) >> 0] = $136 >>> 16 | 0;
                    HEAP8[($2 + 278 | 0) >> 0] = $136 >>> 24 | 0;
                    $5 = ($2 + 280 | 0) + 32 | 0;
                    i64toi32_i32$5 = $5;
                    i64toi32_i32$0 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                    i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                    $1430 = i64toi32_i32$0;
                    i64toi32_i32$0 = $2;
                    HEAP32[($2 + 256 | 0) >> 2] = $1430;
                    HEAP32[($2 + 260 | 0) >> 2] = i64toi32_i32$2;
                    $18 = ($2 + 280 | 0) + 60 | 0;
                    i64toi32_i32$5 = $18;
                    i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                    i64toi32_i32$0 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                    $1436 = i64toi32_i32$2;
                    i64toi32_i32$2 = $2;
                    HEAP32[($2 + 240 | 0) >> 2] = $1436;
                    HEAP32[($2 + 244 | 0) >> 2] = i64toi32_i32$0;
                    $9 = HEAP32[(($2 + 280 | 0) + 56 | 0) >> 2] | 0;
                    $11 = ($2 + 280 | 0) + 8 | 0;
                    $3 = HEAPU8[$11 >> 0] | 0;
                    i64toi32_i32$5 = ($2 + 280 | 0) + 48 | 0;
                    i64toi32_i32$0 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                    i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                    $21 = i64toi32_i32$0;
                    $21$hi = i64toi32_i32$2;
                    $7 = ($2 + 280 | 0) + 16 | 0;
                    i64toi32_i32$5 = $7;
                    i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                    i64toi32_i32$0 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                    $23 = i64toi32_i32$2;
                    $23$hi = i64toi32_i32$0;
                    $16 = ($2 + 280 | 0) + 24 | 0;
                    i64toi32_i32$5 = $16;
                    i64toi32_i32$0 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                    i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                    $25 = i64toi32_i32$0;
                    $25$hi = i64toi32_i32$2;
                    $12 = ($2 + 88 | 0) + 8 | 0;
                    i64toi32_i32$5 = $1;
                    i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                    i64toi32_i32$0 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                    $1465 = i64toi32_i32$2;
                    i64toi32_i32$2 = $12;
                    HEAP32[i64toi32_i32$2 >> 2] = $1465;
                    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
                    $1 = ($2 + 72 | 0) + 8 | 0;
                    HEAP32[$1 >> 2] = HEAP32[$6 >> 2] | 0;
                    HEAP32[($2 + 24 | 0) >> 2] = HEAP32[($2 + 272 | 0) >> 2] | 0;
                    $137 = HEAPU8[($2 + 275 | 0) >> 0] | 0 | ((HEAPU8[($2 + 276 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 277 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 278 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                    HEAP8[($2 + 27 | 0) >> 0] = $137;
                    HEAP8[($2 + 28 | 0) >> 0] = $137 >>> 8 | 0;
                    HEAP8[($2 + 29 | 0) >> 0] = $137 >>> 16 | 0;
                    HEAP8[($2 + 30 | 0) >> 0] = $137 >>> 24 | 0;
                    i64toi32_i32$5 = $2;
                    i64toi32_i32$0 = HEAP32[($2 + 256 | 0) >> 2] | 0;
                    i64toi32_i32$2 = HEAP32[($2 + 260 | 0) >> 2] | 0;
                    $1480 = i64toi32_i32$0;
                    i64toi32_i32$0 = $2;
                    HEAP32[($2 + 88 | 0) >> 2] = $1480;
                    HEAP32[($2 + 92 | 0) >> 2] = i64toi32_i32$2;
                    i64toi32_i32$5 = $2;
                    i64toi32_i32$2 = HEAP32[($2 + 240 | 0) >> 2] | 0;
                    i64toi32_i32$0 = HEAP32[($2 + 244 | 0) >> 2] | 0;
                    $1483 = i64toi32_i32$2;
                    i64toi32_i32$2 = $2;
                    HEAP32[($2 + 72 | 0) >> 2] = $1483;
                    HEAP32[($2 + 76 | 0) >> 2] = i64toi32_i32$0;
                    i64toi32_i32$0 = $25$hi;
                    i64toi32_i32$2 = $7;
                    HEAP32[i64toi32_i32$2 >> 2] = $25;
                    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
                    i64toi32_i32$0 = $23$hi;
                    i64toi32_i32$2 = $11;
                    HEAP32[i64toi32_i32$2 >> 2] = $23;
                    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
                    i64toi32_i32$0 = $21$hi;
                    i64toi32_i32$2 = $17;
                    HEAP32[i64toi32_i32$2 >> 2] = $21;
                    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
                    HEAP8[($2 + 280 | 0) >> 0] = $3;
                    $138 = HEAP32[($2 + 24 | 0) >> 2] | 0;
                    HEAP8[($2 + 281 | 0) >> 0] = $138;
                    HEAP8[($2 + 282 | 0) >> 0] = $138 >>> 8 | 0;
                    HEAP8[($2 + 283 | 0) >> 0] = $138 >>> 16 | 0;
                    HEAP8[($2 + 284 | 0) >> 0] = $138 >>> 24 | 0;
                    $139 = HEAPU8[($2 + 27 | 0) >> 0] | 0 | ((HEAPU8[($2 + 28 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 29 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 30 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                    HEAP8[($2 + 284 | 0) >> 0] = $139;
                    HEAP8[($2 + 285 | 0) >> 0] = $139 >>> 8 | 0;
                    HEAP8[($2 + 286 | 0) >> 0] = $139 >>> 16 | 0;
                    HEAP8[($2 + 287 | 0) >> 0] = $139 >>> 24 | 0;
                    i64toi32_i32$5 = $2;
                    i64toi32_i32$0 = HEAP32[($2 + 88 | 0) >> 2] | 0;
                    i64toi32_i32$2 = HEAP32[($2 + 92 | 0) >> 2] | 0;
                    $1500 = i64toi32_i32$0;
                    i64toi32_i32$0 = $16;
                    HEAP32[i64toi32_i32$0 >> 2] = $1500;
                    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
                    i64toi32_i32$5 = $12;
                    i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                    i64toi32_i32$0 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                    $1503 = i64toi32_i32$2;
                    i64toi32_i32$2 = $5;
                    HEAP32[i64toi32_i32$2 >> 2] = $1503;
                    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
                    HEAP32[($2 + 328 | 0) >> 2] = $9;
                    i64toi32_i32$5 = $2;
                    i64toi32_i32$0 = HEAP32[($2 + 72 | 0) >> 2] | 0;
                    i64toi32_i32$2 = HEAP32[($2 + 76 | 0) >> 2] | 0;
                    $1510 = i64toi32_i32$0;
                    i64toi32_i32$0 = ($2 + 280 | 0) + 52 | 0;
                    HEAP32[i64toi32_i32$0 >> 2] = $1510;
                    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
                    HEAP32[$18 >> 2] = HEAP32[$1 >> 2] | 0;
                    $1 = ($2 + 104 | 0) + 8 | 0;
                    cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $2 + 280 | 0 | 0, 1060072 | 0, 14 | 0);
                    $7 = ($2 + 48 | 0) + 4 | 0;
                    HEAP16[$7 >> 1] = HEAPU16[$4 >> 1] | 0;
                    HEAP32[($2 + 48 | 0) >> 2] = HEAPU16[($2 + 114 | 0) >> 1] | 0 | ((HEAPU16[($2 + 116 | 0) >> 1] | 0) << 16 | 0) | 0;
                    $6 = HEAPU8[$1 >> 0] | 0;
                    $5 = HEAP32[(($2 + 104 | 0) + 16 | 0) >> 2] | 0;
                    $4 = HEAP32[($2 + 124 | 0) >> 2] | 0;
                    i64toi32_i32$5 = ($2 + 104 | 0) + 24 | 0;
                    i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                    i64toi32_i32$0 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                    $21 = i64toi32_i32$2;
                    $21$hi = i64toi32_i32$0;
                    i64toi32_i32$5 = ($2 + 104 | 0) + 32 | 0;
                    i64toi32_i32$0 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                    i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                    $23 = i64toi32_i32$0;
                    $23$hi = i64toi32_i32$2;
                    i64toi32_i32$5 = ($2 + 104 | 0) + 40 | 0;
                    i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                    i64toi32_i32$0 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                    $24 = i64toi32_i32$2;
                    $24$hi = i64toi32_i32$0;
                    $11 = HEAP32[(($2 + 104 | 0) + 48 | 0) >> 2] | 0;
                    $9 = HEAP32[(($2 + 104 | 0) + 52 | 0) >> 2] | 0;
                    $3 = HEAP32[(($2 + 104 | 0) + 56 | 0) >> 2] | 0;
                    $18 = HEAP32[(($2 + 104 | 0) + 60 | 0) >> 2] | 0;
                    i64toi32_i32$5 = $2 + 168 | 0;
                    i64toi32_i32$0 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                    i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                    $25 = i64toi32_i32$0;
                    $25$hi = i64toi32_i32$2;
                    $17 = HEAPU8[($2 + 113 | 0) >> 0] | 0;
                    HEAP16[(($2 + 88 | 0) + 4 | 0) >> 1] = HEAPU16[$7 >> 1] | 0;
                    HEAP32[($2 + 88 | 0) >> 2] = HEAP32[($2 + 48 | 0) >> 2] | 0;
                    break label$44;
                   }
                   $5 = (HEAPU8[($2 + 289 | 0) >> 0] | 0 | ((HEAPU8[($2 + 290 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 291 | 0) >> 0] | 0) << 16 | 0) | 0) << 8 | 0 | $1 | 0;
                   $11 = HEAP32[($2 + 320 | 0) >> 2] | 0;
                   i64toi32_i32$5 = $2 + 312 | 0;
                   i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                   i64toi32_i32$0 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                   $24 = i64toi32_i32$2;
                   $24$hi = i64toi32_i32$0;
                   i64toi32_i32$5 = $2 + 304 | 0;
                   i64toi32_i32$0 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                   i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                   $23 = i64toi32_i32$0;
                   $23$hi = i64toi32_i32$2;
                   i64toi32_i32$5 = ($2 + 280 | 0) + 16 | 0;
                   i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                   i64toi32_i32$0 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                   $21 = i64toi32_i32$2;
                   $21$hi = i64toi32_i32$0;
                   $9 = HEAP32[($2 + 324 | 0) >> 2] | 0;
                   $4 = HEAP32[($2 + 292 | 0) >> 2] | 0;
                   $6 = 2;
                  }
                  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc3d6ec99c05cee40($2 + 56 | 0 | 0);
                  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h0f78886c344617d4($2 + 56 | 0 | 0);
                  $3 = 0;
                  break label$44;
                 }
                 $1 = $2 + 176 | 0 | 2 | 0;
                 HEAP16[(($2 + 88 | 0) + 4 | 0) >> 1] = HEAPU16[($1 + 4 | 0) >> 1] | 0;
                 HEAP32[($2 + 88 | 0) >> 2] = HEAPU16[$1 >> 1] | 0 | ((HEAPU16[($1 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
                 $6 = HEAP32[($2 + 60 | 0) >> 2] | 0;
                 $1 = HEAP32[($2 + 64 | 0) >> 2] | 0;
                 $4 = 0;
                 break label$8;
                }
                i64toi32_i32$0 = $25$hi;
                i64toi32_i32$5 = $25;
                i64toi32_i32$2 = 0;
                i64toi32_i32$4 = 32;
                i64toi32_i32$1 = i64toi32_i32$4 & 31 | 0;
                if (32 >>> 0 <= (i64toi32_i32$4 & 63 | 0) >>> 0) {
                 i64toi32_i32$2 = 0;
                 $150 = i64toi32_i32$0 >>> i64toi32_i32$1 | 0;
                } else {
                 i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$1 | 0;
                 $150 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$1 | 0) | 0;
                }
                $4 = $150;
                $9 = HEAP32[($2 + 324 | 0) >> 2] | 0;
                $11 = HEAP32[($2 + 320 | 0) >> 2] | 0;
                i64toi32_i32$0 = $2 + 312 | 0;
                i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                $24 = i64toi32_i32$2;
                $24$hi = i64toi32_i32$5;
                i64toi32_i32$0 = $2 + 304 | 0;
                i64toi32_i32$5 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                $23 = i64toi32_i32$5;
                $23$hi = i64toi32_i32$2;
                i64toi32_i32$2 = $25$hi;
                $5 = $25;
                i64toi32_i32$2 = $22$hi;
                $21 = $22;
                $21$hi = i64toi32_i32$2;
                break label$4;
               }
               i64toi32_i32$2 = $22$hi;
               $5 = $22;
               $6 = 3;
               $4 = 0;
               $3 = 0;
               break label$2;
              }
              $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__he275f3eb7df08493($2 + 176 | 0 | 0);
              if (!(HEAP32[($2 + 192 | 0) >> 2] | 0)) {
               break label$2
              }
              hashbrown__raw__RawTable_T_2cA___free_buckets__hfa29170569415d6b(($2 + 176 | 0) + 16 | 0 | 0);
              break label$2;
             case 1:
              break label$12;
             default:
              break label$2;
             };
            }
            $cardano_serialization_lib__metadata__GeneralTransactionMetadata_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h2cbfe28ae9769528($2 + 280 | 0 | 0, $1 | 0);
            $1 = ($2 + 280 | 0) + 8 | 0;
            label$53 : {
             i64toi32_i32$0 = $2;
             i64toi32_i32$2 = HEAP32[($2 + 280 | 0) >> 2] | 0;
             i64toi32_i32$5 = HEAP32[($2 + 284 | 0) >> 2] | 0;
             i64toi32_i32$0 = i64toi32_i32$2;
             i64toi32_i32$2 = 0;
             i64toi32_i32$4 = 1;
             if ((i64toi32_i32$0 | 0) == (i64toi32_i32$4 | 0) & (i64toi32_i32$5 | 0) == (i64toi32_i32$2 | 0) | 0) {
              break label$53
             }
             memcpy(($2 + 104 | 0) + 8 | 0 | 0, $1 | 0, 40 | 0) | 0;
             HEAP16[($2 + 92 | 0) >> 1] = HEAPU16[($2 + 118 | 0) >> 1] | 0;
             $1 = HEAPU16[($2 + 114 | 0) >> 1] | 0 | ((HEAPU16[($2 + 116 | 0) >> 1] | 0) << 16 | 0) | 0;
             HEAP32[($2 + 256 | 0) >> 2] = $1;
             HEAP32[($2 + 88 | 0) >> 2] = $1;
             $18 = HEAP32[($2 + 120 | 0) >> 2] | 0;
             $9 = HEAP32[($2 + 124 | 0) >> 2] | 0;
             i64toi32_i32$4 = $2 + 128 | 0;
             i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
             i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
             $21 = i64toi32_i32$0;
             $21$hi = i64toi32_i32$5;
             i64toi32_i32$4 = $2 + 136 | 0;
             i64toi32_i32$5 = HEAP32[i64toi32_i32$4 >> 2] | 0;
             i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
             $24 = i64toi32_i32$5;
             $24$hi = i64toi32_i32$0;
             i64toi32_i32$4 = ($2 + 104 | 0) + 40 | 0;
             i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
             i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
             $23 = i64toi32_i32$0;
             $23$hi = i64toi32_i32$5;
             $17 = HEAPU8[($2 + 112 | 0) >> 0] | 0;
             $5 = HEAPU8[($2 + 113 | 0) >> 0] | 0;
             $4 = 0;
             $11 = 0;
             break label$8;
            }
            memcpy($2 + 176 | 0 | 0, $1 | 0, 64 | 0) | 0;
            cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e(($2 + 104 | 0) + 8 | 0 | 0, $2 + 176 | 0 | 0, 1060064 | 0, 8 | 0);
            $1 = ($2 + 256 | 0) + 4 | 0;
            HEAP16[$1 >> 1] = HEAPU16[($2 + 118 | 0) >> 1] | 0;
            HEAP32[($2 + 256 | 0) >> 2] = HEAPU16[($2 + 114 | 0) >> 1] | 0 | ((HEAPU16[($2 + 116 | 0) >> 1] | 0) << 16 | 0) | 0;
            $5 = HEAP32[($2 + 120 | 0) >> 2] | 0;
            $4 = HEAP32[($2 + 124 | 0) >> 2] | 0;
            i64toi32_i32$4 = $2 + 128 | 0;
            i64toi32_i32$5 = HEAP32[i64toi32_i32$4 >> 2] | 0;
            i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
            $21 = i64toi32_i32$5;
            $21$hi = i64toi32_i32$0;
            i64toi32_i32$4 = $2 + 136 | 0;
            i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
            i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
            $23 = i64toi32_i32$0;
            $23$hi = i64toi32_i32$5;
            i64toi32_i32$4 = $2 + 144 | 0;
            i64toi32_i32$5 = HEAP32[i64toi32_i32$4 >> 2] | 0;
            i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
            $24 = i64toi32_i32$5;
            $24$hi = i64toi32_i32$0;
            $11 = HEAP32[($2 + 152 | 0) >> 2] | 0;
            $9 = HEAP32[($2 + 156 | 0) >> 2] | 0;
            $3 = HEAP32[($2 + 160 | 0) >> 2] | 0;
            $18 = HEAP32[($2 + 164 | 0) >> 2] | 0;
            i64toi32_i32$4 = ($2 + 104 | 0) + 64 | 0;
            i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
            i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
            $25 = i64toi32_i32$0;
            $25$hi = i64toi32_i32$5;
            $6 = HEAPU8[($2 + 112 | 0) >> 0] | 0;
            $17 = HEAPU8[($2 + 113 | 0) >> 0] | 0;
            HEAP16[(($2 + 88 | 0) + 4 | 0) >> 1] = HEAPU16[$1 >> 1] | 0;
            HEAP32[($2 + 88 | 0) >> 2] = HEAP32[($2 + 256 | 0) >> 2] | 0;
            break label$2;
           }
          }
          $5 = 1;
          $3 = 0;
          break label$7;
         }
         label$54 : {
          label$55 : {
           i64toi32_i32$5 = $22$hi;
           i64toi32_i32$4 = $22;
           i64toi32_i32$0 = 0;
           i64toi32_i32$2 = 1;
           if ((i64toi32_i32$4 | 0) != (i64toi32_i32$2 | 0) | (i64toi32_i32$5 | 0) != (i64toi32_i32$0 | 0) | 0) {
            break label$55
           }
           i64toi32_i32$4 = $23$hi;
           i64toi32_i32$4 = $21$hi;
           i64toi32_i32$4 = $23$hi;
           i64toi32_i32$2 = $23;
           i64toi32_i32$5 = $21$hi;
           i64toi32_i32$0 = $21;
           if ((i64toi32_i32$2 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$4 | 0) != (i64toi32_i32$5 | 0) | 0) {
            break label$54
           }
          }
          HEAP16[($2 + 92 | 0) >> 1] = HEAPU16[($2 + 182 | 0) >> 1] | 0;
          HEAP32[($2 + 88 | 0) >> 2] = HEAPU16[($2 + 178 | 0) >> 1] | 0 | ((HEAPU16[($2 + 180 | 0) >> 1] | 0) << 16 | 0) | 0;
          i64toi32_i32$0 = $2 + 208 | 0;
          i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
          i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
          $23 = i64toi32_i32$2;
          $23$hi = i64toi32_i32$4;
          $1 = HEAP32[($2 + 32 | 0) >> 2] | 0;
          $5 = HEAPU8[($2 + 177 | 0) >> 0] | 0;
          $17 = HEAPU8[($2 + 176 | 0) >> 0] | 0;
          $18 = HEAP32[($2 + 184 | 0) >> 2] | 0;
          $9 = HEAP32[($2 + 188 | 0) >> 2] | 0;
          i64toi32_i32$0 = $2;
          i64toi32_i32$4 = HEAP32[($2 + 192 | 0) >> 2] | 0;
          i64toi32_i32$2 = HEAP32[($2 + 196 | 0) >> 2] | 0;
          $21 = i64toi32_i32$4;
          $21$hi = i64toi32_i32$2;
          i64toi32_i32$0 = $2;
          i64toi32_i32$2 = HEAP32[($2 + 200 | 0) >> 2] | 0;
          i64toi32_i32$4 = HEAP32[($2 + 204 | 0) >> 2] | 0;
          $24 = i64toi32_i32$2;
          $24$hi = i64toi32_i32$4;
          $11 = HEAP32[($2 + 24 | 0) >> 2] | 0;
          $6 = HEAP32[($2 + 28 | 0) >> 2] | 0;
          $4 = HEAP32[($2 + 56 | 0) >> 2] | 0;
          i64toi32_i32$0 = $2;
          i64toi32_i32$4 = HEAP32[($2 + 60 | 0) >> 2] | 0;
          i64toi32_i32$2 = HEAP32[($2 + 64 | 0) >> 2] | 0;
          $25 = i64toi32_i32$4;
          $25$hi = i64toi32_i32$2;
          break label$8;
         }
         i64toi32_i32$2 = $21$hi;
         i64toi32_i32$0 = $21;
         i64toi32_i32$4 = 0;
         i64toi32_i32$5 = 32;
         i64toi32_i32$1 = i64toi32_i32$5 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$5 & 63 | 0) >>> 0) {
          i64toi32_i32$4 = 0;
          $151 = i64toi32_i32$2 >>> i64toi32_i32$1 | 0;
         } else {
          i64toi32_i32$4 = i64toi32_i32$2 >>> i64toi32_i32$1 | 0;
          $151 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$1 | 0) | 0;
         }
         $4 = $151;
         $6 = 3;
         $3 = 0;
         i64toi32_i32$4 = 0;
         $21 = 1;
         $21$hi = i64toi32_i32$4;
         $5 = $7;
         break label$7;
        }
        HEAP8[($0 + 9 | 0) >> 0] = $5;
        HEAP8[($0 + 8 | 0) >> 0] = $17;
        $152 = HEAP32[($2 + 88 | 0) >> 2] | 0;
        HEAP16[($0 + 10 | 0) >> 1] = $152;
        HEAP16[($0 + 12 | 0) >> 1] = $152 >>> 16 | 0;
        HEAP32[($0 + 20 | 0) >> 2] = $9;
        i64toi32_i32$4 = $25$hi;
        i64toi32_i32$0 = $0 + 64 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $25;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$4;
        HEAP32[($0 + 60 | 0) >> 2] = $4;
        HEAP32[($0 + 56 | 0) >> 2] = $1;
        HEAP32[($0 + 52 | 0) >> 2] = $6;
        HEAP32[($0 + 48 | 0) >> 2] = $11;
        i64toi32_i32$4 = $23$hi;
        i64toi32_i32$0 = $0 + 40 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $23;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$4;
        i64toi32_i32$4 = $24$hi;
        i64toi32_i32$0 = $0 + 32 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $24;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$4;
        i64toi32_i32$4 = $21$hi;
        i64toi32_i32$0 = $0 + 24 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $21;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$4;
        HEAP32[($0 + 16 | 0) >> 2] = $18;
        HEAP16[($0 + 14 | 0) >> 1] = HEAPU16[($2 + 92 | 0) >> 1] | 0;
        i64toi32_i32$4 = 0;
        $21 = 0;
        $21$hi = i64toi32_i32$4;
        break label$1;
       }
       core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__plutus__PlutusScripts____h6be1d55eac328b7f_1($2 + 56 | 0 | 0);
       core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__NativeScripts____hdd7d461255ec800a_1($2 + 24 | 0 | 0);
       core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__metadata__GeneralTransactionMetadata____h37a091753d7f028f($2 + 176 | 0 | 0);
       break label$2;
      }
      i64toi32_i32$4 = $22$hi;
      i64toi32_i32$2 = $22;
      i64toi32_i32$0 = 0;
      i64toi32_i32$5 = 32;
      i64toi32_i32$1 = i64toi32_i32$5 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$5 & 63 | 0) >>> 0) {
       i64toi32_i32$0 = 0;
       $153 = i64toi32_i32$4 >>> i64toi32_i32$1 | 0;
      } else {
       i64toi32_i32$0 = i64toi32_i32$4 >>> i64toi32_i32$1 | 0;
       $153 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$1 | 0) | 0;
      }
      $4 = $153;
      $9 = HEAP32[($2 + 324 | 0) >> 2] | 0;
      $11 = HEAP32[($2 + 320 | 0) >> 2] | 0;
      i64toi32_i32$4 = $2 + 312 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
      $24 = i64toi32_i32$0;
      $24$hi = i64toi32_i32$2;
      i64toi32_i32$4 = $2 + 304 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$4 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
      $23 = i64toi32_i32$2;
      $23$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $22$hi;
      $5 = $22;
     }
    }
    $6 = 2;
   }
   i64toi32_i32$0 = $25$hi;
   i64toi32_i32$2 = $2 + 336 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $25;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($2 + 332 | 0) >> 2] = $18;
   HEAP32[($2 + 324 | 0) >> 2] = $9;
   HEAP32[($2 + 320 | 0) >> 2] = $11;
   i64toi32_i32$0 = $24$hi;
   i64toi32_i32$2 = $2 + 312 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $24;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $23$hi;
   i64toi32_i32$2 = $2 + 304 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $23;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $21$hi;
   i64toi32_i32$2 = $2 + 296 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $21;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($2 + 292 | 0) >> 2] = $4;
   HEAP32[(($2 + 280 | 0) + 8 | 0) >> 2] = $5;
   HEAP8[($2 + 281 | 0) >> 0] = $17;
   HEAP8[($2 + 280 | 0) >> 0] = $6;
   $154 = HEAP32[($2 + 88 | 0) >> 2] | 0;
   HEAP16[($2 + 282 | 0) >> 1] = $154;
   HEAP16[($2 + 284 | 0) >> 1] = $154 >>> 16 | 0;
   HEAP32[($2 + 328 | 0) >> 2] = $3;
   HEAP16[($2 + 286 | 0) >> 1] = HEAPU16[($2 + 92 | 0) >> 1] | 0;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 280 | 0 | 0, 1060100 | 0, 13 | 0);
   i64toi32_i32$0 = 0;
   $21 = 1;
   $21$hi = i64toi32_i32$0;
  }
  i64toi32_i32$0 = $21$hi;
  i64toi32_i32$2 = $0;
  HEAP32[i64toi32_i32$2 >> 2] = $21;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 352 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__HeaderBody___deserialize_as_embedded_group__h626cfdd4be8109d9($0, $1, $2, $2$hi, $3, $3$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, $8 = 0, $6 = 0, $26 = 0, $7 = 0, $26$hi = 0, $27 = 0, $28 = 0, $10 = 0, $16 = 0, $15 = 0, $5 = 0, $12 = 0, $11 = 0, $27$hi = 0, $14 = 0, $13 = 0, $28$hi = 0, $17 = 0, i64toi32_i32$2 = 0, $25 = 0, $134 = 0, $135 = 0, $136 = 0, $137 = 0, $138 = 0, $139 = 0, $140 = 0, $141 = 0, $142 = 0, $143 = 0, $144 = 0, $145 = 0, $146 = 0, $147 = 0, $148 = 0, $149 = 0, $150 = 0, $151 = 0, $152 = 0, $153 = 0, $154 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $9 = 0, $155 = 0, $156 = 0, $157 = 0, $158 = 0, $159 = 0, $160 = 0, $161 = 0, $162 = 0, $163 = 0, $164 = 0, $165 = 0, $166 = 0, $167 = 0, $168 = 0, $169 = 0, $170 = 0, $171 = 0, $172 = 0, $173 = 0, $174 = 0, $175 = 0, $176 = 0, $177 = 0, $178 = 0, $179 = 0, $180 = 0, $181 = 0, $182 = 0, $183 = 0, $184 = 0, $185 = 0, $186 = 0, $187 = 0, $215 = 0, $222 = 0, $234 = 0, $239 = 0, $334 = 0, $337 = 0, $423 = 0, $453 = 0, $461 = 0, $464 = 0, $470 = 0, $479 = 0, $484 = 0, $489 = 0, $494 = 0, $497 = 0, $517 = 0, $524 = 0, $527 = 0, $535 = 0, $544 = 0, $549 = 0, $554 = 0, $559 = 0, $562 = 0, $575 = 0, $582 = 0, $585 = 0, $596 = 0, $600 = 0, $603 = 0, $631 = 0, $638 = 0, $641 = 0, $648 = 0, $657 = 0, $662 = 0, $667 = 0, $672 = 0, $675 = 0, $744 = 0, $750 = 0, $756 = 0, $760 = 0, $766 = 0, $772 = 0, $776 = 0, $782 = 0, $788 = 0, $794 = 0, $801 = 0, $807 = 0, $813 = 0, $817 = 0, $823 = 0, $829 = 0, $835 = 0, $839 = 0, $845 = 0, $850 = 0, $858 = 0, $892 = 0, $920 = 0, $926 = 0, $930 = 0, $940 = 0, $993 = 0, $1000 = 0, $1013 = 0, $1019 = 0, $1030 = 0, $1067 = 0, $1083 = 0, $1086 = 0, $1090 = 0, $1099 = 0, $1118 = 0, $1125 = 0, $1138 = 0, $1144 = 0, $1155 = 0, $1188 = 0, $1203 = 0, $1206 = 0, $1210 = 0, $1219 = 0, $1326 = 0, $1333 = 0, $1346 = 0, $1352 = 0, $1363 = 0, $1396 = 0, $1411 = 0, $1414 = 0, $1418 = 0, $1427 = 0;
  $4 = global$0 - 864 | 0;
  global$0 = $4;
  $T_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hf422f9333a8bbafa($4 + 752 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ((HEAP32[($4 + 752 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      $5 = HEAP32[($4 + 756 | 0) >> 2] | 0;
      $cardano_serialization_lib__utils__BigNum_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h29637bb571dceb02($4 + 752 | 0 | 0, $1 | 0);
      i64toi32_i32$2 = $4;
      i64toi32_i32$0 = HEAP32[($4 + 760 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($4 + 764 | 0) >> 2] | 0;
      $26 = i64toi32_i32$0;
      $26$hi = i64toi32_i32$1;
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           label$10 : {
            label$11 : {
             label$12 : {
              label$13 : {
               i64toi32_i32$2 = $4;
               i64toi32_i32$1 = HEAP32[($4 + 752 | 0) >> 2] | 0;
               i64toi32_i32$0 = HEAP32[($4 + 756 | 0) >> 2] | 0;
               i64toi32_i32$2 = i64toi32_i32$1;
               i64toi32_i32$1 = 0;
               i64toi32_i32$3 = 1;
               if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
                break label$13
               }
               std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($4 + 8 | 0 | 0, $1 | 0);
               label$14 : {
                label$15 : {
                 if (!(HEAP32[($4 + 12 | 0) >> 2] | 0)) {
                  break label$15
                 }
                 label$16 : {
                  label$17 : {
                   label$18 : {
                    label$19 : {
                     if ((($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[($4 + 8 | 0) >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) != (7 | 0)) {
                      break label$19
                     }
                     cbor_event__de__Deserializer_R___special__h10e912d855f56298($4 + 752 | 0 | 0, $1 | 0);
                     $6 = HEAPU8[($4 + 760 | 0) >> 0] | 0;
                     i64toi32_i32$3 = $4;
                     i64toi32_i32$2 = HEAP32[($4 + 752 | 0) >> 2] | 0;
                     i64toi32_i32$0 = HEAP32[($4 + 756 | 0) >> 2] | 0;
                     i64toi32_i32$3 = i64toi32_i32$2;
                     i64toi32_i32$2 = 0;
                     i64toi32_i32$1 = 1;
                     if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) | 0) {
                      break label$18
                     }
                     $7 = 6;
                     $8 = 0;
                     if (($6 & 255 | 0 | 0) == (1 | 0)) {
                      break label$17
                     }
                     break label$14;
                    }
                    $cardano_serialization_lib__crypto__BlockHash_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h8933d5e4c20cf015($4 + 752 | 0 | 0, $1 | 0);
                    $8 = 1;
                    label$20 : {
                     if ((HEAPU8[($4 + 752 | 0) >> 0] | 0 | 0) == (1 | 0)) {
                      break label$20
                     }
                     $9 = ($4 + 640 | 0) + 4 | 0;
                     HEAP16[$9 >> 1] = HEAPU8[($4 + 757 | 0) >> 0] | 0 | ((HEAPU8[($4 + 758 | 0) >> 0] | 0) << 8 | 0) | 0;
                     HEAP32[($4 + 640 | 0) >> 2] = HEAPU8[($4 + 753 | 0) >> 0] | 0 | ((HEAPU8[($4 + 754 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 755 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 756 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                     $6 = HEAPU8[($4 + 760 | 0) >> 0] | 0;
                     $7 = HEAPU8[($4 + 761 | 0) >> 0] | 0;
                     $10 = HEAPU8[($4 + 762 | 0) >> 0] | 0;
                     $11 = HEAPU8[($4 + 763 | 0) >> 0] | 0;
                     $12 = HEAPU8[($4 + 764 | 0) >> 0] | 0;
                     $13 = HEAPU8[($4 + 765 | 0) >> 0] | 0;
                     $14 = HEAPU8[($4 + 766 | 0) >> 0] | 0;
                     $15 = HEAPU8[($4 + 767 | 0) >> 0] | 0;
                     $16 = HEAPU8[($4 + 768 | 0) >> 0] | 0;
                     $17 = HEAPU8[($4 + 769 | 0) >> 0] | 0;
                     $18 = HEAPU8[($4 + 770 | 0) >> 0] | 0;
                     $19 = HEAPU8[($4 + 771 | 0) >> 0] | 0;
                     $20 = HEAPU8[($4 + 772 | 0) >> 0] | 0;
                     $21 = HEAPU8[($4 + 773 | 0) >> 0] | 0;
                     $22 = HEAPU8[($4 + 774 | 0) >> 0] | 0;
                     $23 = HEAPU8[($4 + 775 | 0) >> 0] | 0;
                     $24 = HEAPU8[($4 + 776 | 0) >> 0] | 0;
                     i64toi32_i32$1 = $4 + 777 | 0;
                     i64toi32_i32$3 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                     $27 = i64toi32_i32$3;
                     $27$hi = i64toi32_i32$0;
                     $25 = HEAPU8[($4 + 759 | 0) >> 0] | 0;
                     HEAP16[(($4 + 56 | 0) + 4 | 0) >> 1] = HEAPU16[$9 >> 1] | 0;
                     HEAP32[($4 + 56 | 0) >> 2] = HEAP32[($4 + 640 | 0) >> 2] | 0;
                     break label$16;
                    }
                    $1 = HEAPU8[($4 + 776 | 0) >> 0] | 0;
                    $5 = HEAPU8[($4 + 775 | 0) >> 0] | 0;
                    $10 = HEAPU8[($4 + 774 | 0) >> 0] | 0;
                    $11 = HEAPU8[($4 + 773 | 0) >> 0] | 0;
                    $12 = HEAPU8[($4 + 772 | 0) >> 0] | 0;
                    $13 = HEAPU8[($4 + 771 | 0) >> 0] | 0;
                    $14 = HEAPU8[($4 + 770 | 0) >> 0] | 0;
                    $15 = HEAPU8[($4 + 769 | 0) >> 0] | 0;
                    $6 = HEAPU8[($4 + 768 | 0) >> 0] | 0;
                    $16 = HEAPU8[($4 + 767 | 0) >> 0] | 0;
                    $17 = HEAPU8[(($4 + 752 | 0) + 14 | 0) >> 0] | 0;
                    $18 = HEAPU8[($4 + 765 | 0) >> 0] | 0;
                    $19 = HEAPU8[($4 + 764 | 0) >> 0] | 0;
                    $20 = HEAPU8[($4 + 763 | 0) >> 0] | 0;
                    $21 = HEAPU8[($4 + 762 | 0) >> 0] | 0;
                    $22 = HEAPU8[($4 + 761 | 0) >> 0] | 0;
                    $7 = HEAPU8[(($4 + 752 | 0) + 8 | 0) >> 0] | 0;
                    i64toi32_i32$1 = $4 + 777 | 0;
                    i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                    i64toi32_i32$3 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                    $26 = i64toi32_i32$0;
                    $26$hi = i64toi32_i32$3;
                    $23 = HEAPU8[($4 + 785 | 0) >> 0] | 0;
                    $8 = ($4 + 536 | 0) + 14 | 0;
                    i64toi32_i32$1 = $4 + 800 | 0;
                    i64toi32_i32$3 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                    $215 = i64toi32_i32$3;
                    i64toi32_i32$3 = $8;
                    $155 = $215;
                    HEAP16[i64toi32_i32$3 >> 1] = $155;
                    HEAP16[(i64toi32_i32$3 + 2 | 0) >> 1] = $155 >>> 16 | 0;
                    HEAP16[(i64toi32_i32$3 + 4 | 0) >> 1] = i64toi32_i32$0;
                    HEAP16[(i64toi32_i32$3 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
                    $24 = ($4 + 536 | 0) + 8 | 0;
                    i64toi32_i32$1 = $4 + 794 | 0;
                    i64toi32_i32$0 = HEAPU16[i64toi32_i32$1 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
                    i64toi32_i32$3 = HEAPU16[(i64toi32_i32$1 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
                    $222 = i64toi32_i32$0;
                    i64toi32_i32$0 = $24;
                    HEAP32[i64toi32_i32$0 >> 2] = $222;
                    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
                    $25 = HEAP32[($4 + 820 | 0) >> 2] | 0;
                    HEAP32[(($4 + 216 | 0) + 8 | 0) >> 2] = $25;
                    i64toi32_i32$1 = i64toi32_i32$0;
                    i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                    i64toi32_i32$0 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                    $234 = i64toi32_i32$3;
                    i64toi32_i32$3 = ($4 + 320 | 0) + 8 | 0;
                    HEAP32[i64toi32_i32$3 >> 2] = $234;
                    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
                    i64toi32_i32$1 = $8;
                    i64toi32_i32$0 = HEAPU16[i64toi32_i32$1 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
                    i64toi32_i32$3 = HEAPU16[(i64toi32_i32$1 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
                    $239 = i64toi32_i32$0;
                    i64toi32_i32$0 = ($4 + 320 | 0) + 14 | 0;
                    $156 = $239;
                    HEAP16[i64toi32_i32$0 >> 1] = $156;
                    HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $156 >>> 16 | 0;
                    HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$3;
                    HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$3 >>> 16 | 0;
                    i64toi32_i32$1 = $4 + 786 | 0;
                    i64toi32_i32$3 = HEAPU16[i64toi32_i32$1 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
                    i64toi32_i32$0 = HEAPU16[(i64toi32_i32$1 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
                    $27 = i64toi32_i32$3;
                    $27$hi = i64toi32_i32$0;
                    i64toi32_i32$3 = $4;
                    HEAP32[($4 + 536 | 0) >> 2] = $27;
                    HEAP32[($4 + 540 | 0) >> 2] = i64toi32_i32$0;
                    i64toi32_i32$1 = $4 + 812 | 0;
                    i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                    i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                    $28 = i64toi32_i32$0;
                    $28$hi = i64toi32_i32$3;
                    i64toi32_i32$0 = $4;
                    HEAP32[($4 + 216 | 0) >> 2] = $28;
                    HEAP32[($4 + 220 | 0) >> 2] = i64toi32_i32$3;
                    i64toi32_i32$3 = $27$hi;
                    i64toi32_i32$0 = $4;
                    HEAP32[($4 + 320 | 0) >> 2] = $27;
                    HEAP32[($4 + 324 | 0) >> 2] = i64toi32_i32$3;
                    $8 = HEAP32[($4 + 808 | 0) >> 2] | 0;
                    HEAP32[(($4 + 168 | 0) + 8 | 0) >> 2] = $25;
                    i64toi32_i32$3 = $28$hi;
                    i64toi32_i32$0 = $4;
                    HEAP32[($4 + 168 | 0) >> 2] = $28;
                    HEAP32[($4 + 172 | 0) >> 2] = i64toi32_i32$3;
                    HEAP8[($4 + 96 | 0) >> 0] = $23;
                    i64toi32_i32$3 = $26$hi;
                    i64toi32_i32$0 = $4;
                    HEAP32[($4 + 88 | 0) >> 2] = $26;
                    HEAP32[($4 + 92 | 0) >> 2] = i64toi32_i32$3;
                    break label$14;
                   }
                   i64toi32_i32$1 = $4 + 784 | 0;
                   i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                   i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                   $28 = i64toi32_i32$3;
                   $28$hi = i64toi32_i32$0;
                   i64toi32_i32$3 = ($4 + 536 | 0) + 8 | 0;
                   HEAP32[i64toi32_i32$3 >> 2] = $28;
                   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
                   i64toi32_i32$1 = $4 + 792 | 0;
                   i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                   i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                   $26 = i64toi32_i32$0;
                   $26$hi = i64toi32_i32$3;
                   i64toi32_i32$0 = ($4 + 536 | 0) + 16 | 0;
                   HEAP32[i64toi32_i32$0 >> 2] = $26;
                   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
                   i64toi32_i32$1 = $4 + 776 | 0;
                   i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                   i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                   $27 = i64toi32_i32$3;
                   $27$hi = i64toi32_i32$0;
                   i64toi32_i32$3 = $4;
                   HEAP32[($4 + 536 | 0) >> 2] = $27;
                   HEAP32[($4 + 540 | 0) >> 2] = i64toi32_i32$0;
                   $8 = ($4 + 752 | 0) + 16 | 0;
                   $1 = HEAPU8[$8 >> 0] | 0;
                   $7 = HEAPU8[($4 + 771 | 0) >> 0] | 0;
                   $5 = HEAPU8[($4 + 767 | 0) >> 0] | 0;
                   $10 = HEAPU8[($4 + 766 | 0) >> 0] | 0;
                   $11 = HEAPU8[($4 + 765 | 0) >> 0] | 0;
                   $12 = HEAPU8[($4 + 764 | 0) >> 0] | 0;
                   $13 = HEAPU8[($4 + 763 | 0) >> 0] | 0;
                   $14 = HEAPU8[($4 + 762 | 0) >> 0] | 0;
                   $15 = HEAPU8[($4 + 761 | 0) >> 0] | 0;
                   $16 = HEAP32[($4 + 772 | 0) >> 2] | 0;
                   $17 = HEAPU8[($4 + 769 | 0) >> 0] | 0 | ((HEAPU8[($4 + 770 | 0) >> 0] | 0) << 8 | 0) | 0;
                   i64toi32_i32$0 = $26$hi;
                   i64toi32_i32$3 = $8;
                   HEAP32[i64toi32_i32$3 >> 2] = $26;
                   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
                   i64toi32_i32$0 = $28$hi;
                   i64toi32_i32$3 = ($4 + 752 | 0) + 8 | 0;
                   HEAP32[i64toi32_i32$3 >> 2] = $28;
                   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
                   i64toi32_i32$0 = $27$hi;
                   i64toi32_i32$3 = $4;
                   HEAP32[($4 + 752 | 0) >> 2] = $27;
                   HEAP32[($4 + 756 | 0) >> 2] = i64toi32_i32$0;
                   HEAP8[($4 + 90 | 0) >> 0] = $7;
                   HEAP16[($4 + 88 | 0) >> 1] = $17;
                   HEAP8[($4 + 95 | 0) >> 0] = $27;
                   HEAP8[($4 + 96 | 0) >> 0] = $27 >>> 8 | 0;
                   HEAP8[($4 + 91 | 0) >> 0] = $16;
                   HEAP8[($4 + 92 | 0) >> 0] = $16 >>> 8 | 0;
                   HEAP8[($4 + 93 | 0) >> 0] = $16 >>> 16 | 0;
                   HEAP8[($4 + 94 | 0) >> 0] = $16 >>> 24 | 0;
                   i64toi32_i32$0 = $26$hi;
                   i64toi32_i32$3 = $4 + 334 | 0;
                   HEAP16[i64toi32_i32$3 >> 1] = $26;
                   HEAP16[(i64toi32_i32$3 + 2 | 0) >> 1] = $26 >>> 16 | 0;
                   HEAP16[(i64toi32_i32$3 + 4 | 0) >> 1] = i64toi32_i32$0;
                   HEAP16[(i64toi32_i32$3 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
                   i64toi32_i32$1 = $4 + 762 | 0;
                   i64toi32_i32$0 = HEAPU16[i64toi32_i32$1 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
                   i64toi32_i32$3 = HEAPU16[(i64toi32_i32$1 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
                   $334 = i64toi32_i32$0;
                   i64toi32_i32$0 = ($4 + 320 | 0) + 8 | 0;
                   HEAP32[i64toi32_i32$0 >> 2] = $334;
                   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
                   i64toi32_i32$1 = $4;
                   i64toi32_i32$3 = HEAPU16[($4 + 754 | 0) >> 1] | 0 | ((HEAPU16[($4 + 756 | 0) >> 1] | 0) << 16 | 0) | 0;
                   i64toi32_i32$0 = HEAPU16[($4 + 758 | 0) >> 1] | 0 | ((HEAPU16[($4 + 760 | 0) >> 1] | 0) << 16 | 0) | 0;
                   $337 = i64toi32_i32$3;
                   i64toi32_i32$3 = $4;
                   HEAP32[($4 + 320 | 0) >> 2] = $337;
                   HEAP32[($4 + 324 | 0) >> 2] = i64toi32_i32$0;
                   $7 = 2;
                   $8 = 0;
                   break label$14;
                  }
                 }
                 HEAP8[(($4 + 424 | 0) + 24 | 0) >> 0] = $23;
                 HEAP8[($4 + 447 | 0) >> 0] = $22;
                 HEAP8[($4 + 446 | 0) >> 0] = $21;
                 HEAP8[($4 + 445 | 0) >> 0] = $20;
                 HEAP8[($4 + 444 | 0) >> 0] = $19;
                 HEAP8[($4 + 443 | 0) >> 0] = $18;
                 HEAP8[($4 + 442 | 0) >> 0] = $17;
                 HEAP8[(($4 + 424 | 0) + 17 | 0) >> 0] = $16;
                 HEAP8[(($4 + 424 | 0) + 16 | 0) >> 0] = $15;
                 $15 = ($4 + 424 | 0) + 15 | 0;
                 HEAP8[$15 >> 0] = $14;
                 HEAP8[(($4 + 424 | 0) + 14 | 0) >> 0] = $13;
                 HEAP8[($4 + 437 | 0) >> 0] = $12;
                 HEAP8[($4 + 436 | 0) >> 0] = $11;
                 HEAP8[(($4 + 424 | 0) + 11 | 0) >> 0] = $10;
                 HEAP8[($4 + 434 | 0) >> 0] = $7;
                 $7 = $4 + 433 | 0;
                 HEAP8[$7 >> 0] = $6;
                 $6 = ($4 + 424 | 0) + 8 | 0;
                 HEAP8[$6 >> 0] = $25;
                 $157 = HEAP32[($4 + 56 | 0) >> 2] | 0;
                 HEAP16[($4 + 426 | 0) >> 1] = $157;
                 HEAP16[($4 + 428 | 0) >> 1] = $157 >>> 16 | 0;
                 i64toi32_i32$0 = $27$hi;
                 i64toi32_i32$3 = $4;
                 HEAP8[($4 + 89 | 0) >> 0] = $27;
                 HEAP8[($4 + 90 | 0) >> 0] = $27 >>> 8 | 0;
                 HEAP8[($4 + 91 | 0) >> 0] = $27 >>> 16 | 0;
                 HEAP8[($4 + 92 | 0) >> 0] = $27 >>> 24 | 0;
                 HEAP8[($4 + 93 | 0) >> 0] = i64toi32_i32$0;
                 HEAP8[($4 + 94 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                 HEAP8[($4 + 95 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
                 HEAP8[($4 + 96 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
                 HEAP8[($4 + 88 | 0) >> 0] = $24;
                 HEAP16[($4 + 430 | 0) >> 1] = HEAPU16[($4 + 60 | 0) >> 1] | 0;
                 HEAP8[($4 + 425 | 0) >> 0] = $8;
                 HEAP8[(($4 + 424 | 0) + 33 | 0) >> 0] = HEAPU8[(($4 + 88 | 0) + 8 | 0) >> 0] | 0;
                 i64toi32_i32$1 = $4;
                 i64toi32_i32$0 = HEAP32[($4 + 88 | 0) >> 2] | 0;
                 i64toi32_i32$3 = HEAP32[($4 + 92 | 0) >> 2] | 0;
                 $423 = i64toi32_i32$0;
                 i64toi32_i32$0 = ($4 + 424 | 0) + 25 | 0;
                 $134 = $423;
                 HEAP8[i64toi32_i32$0 >> 0] = $134;
                 HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $134 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $134 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $134 >>> 24 | 0;
                 HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$3;
                 HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
                 memcpy($4 + 648 | 0 | 0, $4 + 424 | 0 | 1 | 0 | 0, 33 | 0) | 0;
                 memcpy($4 + 16 | 0 | 0, $4 + 648 | 0 | 0, 33 | 0) | 0;
                 $cardano_serialization_lib__crypto__Vkey_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h00a02b49be066c8c($4 + 752 | 0 | 0, $1 | 0);
                 if ((HEAPU8[($4 + 752 | 0) >> 0] | 0 | 0) == (1 | 0)) {
                  break label$12
                 }
                 $158 = ($4 + 752 | 0) + 15 | 0;
                 $159 = HEAPU8[$158 >> 0] | 0 | ((HEAPU8[($158 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
                 HEAP8[$15 >> 0] = $159;
                 HEAP8[($15 + 1 | 0) >> 0] = $159 >>> 8 | 0;
                 $8 = ($4 + 648 | 0) + 16 | 0;
                 i64toi32_i32$1 = ($4 + 752 | 0) + 17 | 0;
                 i64toi32_i32$3 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 $453 = i64toi32_i32$3;
                 i64toi32_i32$3 = $8;
                 HEAP32[i64toi32_i32$3 >> 2] = $453;
                 HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
                 $6 = ($4 + 648 | 0) + 24 | 0;
                 i64toi32_i32$1 = ($4 + 752 | 0) + 25 | 0;
                 i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 i64toi32_i32$3 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 $461 = i64toi32_i32$0;
                 i64toi32_i32$0 = $6;
                 HEAP32[i64toi32_i32$0 >> 2] = $461;
                 HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
                 i64toi32_i32$1 = $4;
                 i64toi32_i32$3 = HEAPU8[($4 + 759 | 0) >> 0] | 0 | ((HEAPU8[($4 + 760 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 761 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 762 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 i64toi32_i32$0 = HEAPU8[($4 + 763 | 0) >> 0] | 0 | ((HEAPU8[($4 + 764 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 765 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 766 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 $464 = i64toi32_i32$3;
                 i64toi32_i32$3 = $4;
                 $135 = $464;
                 HEAP8[($4 + 431 | 0) >> 0] = $135;
                 HEAP8[($4 + 432 | 0) >> 0] = $135 >>> 8 | 0;
                 HEAP8[($4 + 433 | 0) >> 0] = $135 >>> 16 | 0;
                 HEAP8[($4 + 434 | 0) >> 0] = $135 >>> 24 | 0;
                 HEAP8[($4 + 435 | 0) >> 0] = i64toi32_i32$0;
                 HEAP8[($4 + 436 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                 HEAP8[($4 + 437 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
                 HEAP8[($4 + 438 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
                 $10 = ($4 + 648 | 0) + 8 | 0;
                 i64toi32_i32$1 = $7;
                 i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 i64toi32_i32$3 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 $470 = i64toi32_i32$0;
                 i64toi32_i32$0 = $10;
                 HEAP32[i64toi32_i32$0 >> 2] = $470;
                 HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
                 $160 = HEAPU8[($4 + 757 | 0) >> 0] | 0 | ((HEAPU8[($4 + 758 | 0) >> 0] | 0) << 8 | 0) | 0;
                 HEAP8[($4 + 429 | 0) >> 0] = $160;
                 HEAP8[($4 + 430 | 0) >> 0] = $160 >>> 8 | 0;
                 $136 = HEAPU8[($4 + 753 | 0) >> 0] | 0 | ((HEAPU8[($4 + 754 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 755 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 756 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 HEAP8[($4 + 425 | 0) >> 0] = $136;
                 HEAP8[($4 + 426 | 0) >> 0] = $136 >>> 8 | 0;
                 HEAP8[($4 + 427 | 0) >> 0] = $136 >>> 16 | 0;
                 HEAP8[($4 + 428 | 0) >> 0] = $136 >>> 24 | 0;
                 i64toi32_i32$1 = $4;
                 i64toi32_i32$3 = HEAPU8[($4 + 425 | 0) >> 0] | 0 | ((HEAPU8[($4 + 426 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 427 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 428 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 i64toi32_i32$0 = HEAPU8[($4 + 429 | 0) >> 0] | 0 | ((HEAPU8[($4 + 430 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 431 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 432 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 $479 = i64toi32_i32$3;
                 i64toi32_i32$3 = $4;
                 HEAP32[($4 + 648 | 0) >> 2] = $479;
                 HEAP32[($4 + 652 | 0) >> 2] = i64toi32_i32$0;
                 i64toi32_i32$1 = $6;
                 i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                 i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                 $484 = i64toi32_i32$0;
                 i64toi32_i32$0 = ($4 + 56 | 0) + 24 | 0;
                 HEAP32[i64toi32_i32$0 >> 2] = $484;
                 HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
                 i64toi32_i32$1 = $8;
                 i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                 i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                 $489 = i64toi32_i32$3;
                 i64toi32_i32$3 = ($4 + 56 | 0) + 16 | 0;
                 HEAP32[i64toi32_i32$3 >> 2] = $489;
                 HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
                 i64toi32_i32$1 = $10;
                 i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                 i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                 $494 = i64toi32_i32$0;
                 i64toi32_i32$0 = ($4 + 56 | 0) + 8 | 0;
                 HEAP32[i64toi32_i32$0 >> 2] = $494;
                 HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
                 i64toi32_i32$1 = $4;
                 i64toi32_i32$3 = HEAP32[($4 + 648 | 0) >> 2] | 0;
                 i64toi32_i32$0 = HEAP32[($4 + 652 | 0) >> 2] | 0;
                 $497 = i64toi32_i32$3;
                 i64toi32_i32$3 = $4;
                 HEAP32[($4 + 56 | 0) >> 2] = $497;
                 HEAP32[($4 + 60 | 0) >> 2] = i64toi32_i32$0;
                 $cardano_serialization_lib__crypto__VRFVKey_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hde8d95c2ad05bde9($4 + 752 | 0 | 0, $1 | 0);
                 if ((HEAPU8[($4 + 752 | 0) >> 0] | 0 | 0) == (1 | 0)) {
                  break label$11
                 }
                 $161 = ($4 + 752 | 0) + 15 | 0;
                 $162 = ($4 + 424 | 0) + 15 | 0;
                 $163 = HEAPU8[$161 >> 0] | 0 | ((HEAPU8[($161 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
                 HEAP8[$162 >> 0] = $163;
                 HEAP8[($162 + 1 | 0) >> 0] = $163 >>> 8 | 0;
                 $8 = ($4 + 648 | 0) + 16 | 0;
                 i64toi32_i32$1 = $4 + 769 | 0;
                 i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 i64toi32_i32$3 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 $517 = i64toi32_i32$0;
                 i64toi32_i32$0 = $8;
                 HEAP32[i64toi32_i32$0 >> 2] = $517;
                 HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
                 $6 = ($4 + 648 | 0) + 24 | 0;
                 i64toi32_i32$1 = $4 + 777 | 0;
                 i64toi32_i32$3 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 $524 = i64toi32_i32$3;
                 i64toi32_i32$3 = $6;
                 HEAP32[i64toi32_i32$3 >> 2] = $524;
                 HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
                 i64toi32_i32$1 = $4;
                 i64toi32_i32$0 = HEAPU8[($4 + 759 | 0) >> 0] | 0 | ((HEAPU8[($4 + 760 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 761 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 762 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 i64toi32_i32$3 = HEAPU8[($4 + 763 | 0) >> 0] | 0 | ((HEAPU8[($4 + 764 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 765 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 766 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 $527 = i64toi32_i32$0;
                 i64toi32_i32$0 = $4;
                 $137 = $527;
                 HEAP8[($4 + 431 | 0) >> 0] = $137;
                 HEAP8[($4 + 432 | 0) >> 0] = $137 >>> 8 | 0;
                 HEAP8[($4 + 433 | 0) >> 0] = $137 >>> 16 | 0;
                 HEAP8[($4 + 434 | 0) >> 0] = $137 >>> 24 | 0;
                 HEAP8[($4 + 435 | 0) >> 0] = i64toi32_i32$3;
                 HEAP8[($4 + 436 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
                 HEAP8[($4 + 437 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
                 HEAP8[($4 + 438 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
                 $7 = ($4 + 648 | 0) + 8 | 0;
                 i64toi32_i32$1 = ($4 + 424 | 0) + 9 | 0;
                 i64toi32_i32$3 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 $535 = i64toi32_i32$3;
                 i64toi32_i32$3 = $7;
                 HEAP32[i64toi32_i32$3 >> 2] = $535;
                 HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
                 $164 = HEAPU8[($4 + 757 | 0) >> 0] | 0 | ((HEAPU8[($4 + 758 | 0) >> 0] | 0) << 8 | 0) | 0;
                 HEAP8[($4 + 429 | 0) >> 0] = $164;
                 HEAP8[($4 + 430 | 0) >> 0] = $164 >>> 8 | 0;
                 $138 = HEAPU8[($4 + 753 | 0) >> 0] | 0 | ((HEAPU8[($4 + 754 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 755 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 756 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 HEAP8[($4 + 425 | 0) >> 0] = $138;
                 HEAP8[($4 + 426 | 0) >> 0] = $138 >>> 8 | 0;
                 HEAP8[($4 + 427 | 0) >> 0] = $138 >>> 16 | 0;
                 HEAP8[($4 + 428 | 0) >> 0] = $138 >>> 24 | 0;
                 i64toi32_i32$1 = $4;
                 i64toi32_i32$0 = HEAPU8[($4 + 425 | 0) >> 0] | 0 | ((HEAPU8[($4 + 426 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 427 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 428 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 i64toi32_i32$3 = HEAPU8[($4 + 429 | 0) >> 0] | 0 | ((HEAPU8[($4 + 430 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 431 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 432 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 $544 = i64toi32_i32$0;
                 i64toi32_i32$0 = $4;
                 HEAP32[($4 + 648 | 0) >> 2] = $544;
                 HEAP32[($4 + 652 | 0) >> 2] = i64toi32_i32$3;
                 i64toi32_i32$1 = $6;
                 i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                 i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                 $549 = i64toi32_i32$3;
                 i64toi32_i32$3 = ($4 + 88 | 0) + 24 | 0;
                 HEAP32[i64toi32_i32$3 >> 2] = $549;
                 HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
                 i64toi32_i32$1 = $8;
                 i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                 i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                 $554 = i64toi32_i32$0;
                 i64toi32_i32$0 = ($4 + 88 | 0) + 16 | 0;
                 HEAP32[i64toi32_i32$0 >> 2] = $554;
                 HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
                 i64toi32_i32$1 = $7;
                 i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                 i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                 $559 = i64toi32_i32$3;
                 i64toi32_i32$3 = ($4 + 88 | 0) + 8 | 0;
                 HEAP32[i64toi32_i32$3 >> 2] = $559;
                 HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
                 i64toi32_i32$1 = $4;
                 i64toi32_i32$0 = HEAP32[($4 + 648 | 0) >> 2] | 0;
                 i64toi32_i32$3 = HEAP32[($4 + 652 | 0) >> 2] | 0;
                 $562 = i64toi32_i32$0;
                 i64toi32_i32$0 = $4;
                 HEAP32[($4 + 88 | 0) >> 2] = $562;
                 HEAP32[($4 + 92 | 0) >> 2] = i64toi32_i32$3;
                 $cardano_serialization_lib__crypto__VRFCert_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__ha63b72084ea6ce59($4 + 752 | 0 | 0, $1 | 0);
                 if ((HEAP32[($4 + 752 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                  break label$10
                 }
                 $8 = $4 + 764 | 0;
                 i64toi32_i32$1 = $8;
                 i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                 i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                 $575 = i64toi32_i32$3;
                 i64toi32_i32$3 = ($4 + 120 | 0) + 8 | 0;
                 HEAP32[i64toi32_i32$3 >> 2] = $575;
                 HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
                 $6 = $4 + 772 | 0;
                 i64toi32_i32$1 = $6;
                 i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                 i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                 $582 = i64toi32_i32$0;
                 i64toi32_i32$0 = ($4 + 120 | 0) + 16 | 0;
                 HEAP32[i64toi32_i32$0 >> 2] = $582;
                 HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
                 i64toi32_i32$1 = $4;
                 i64toi32_i32$3 = HEAP32[($4 + 756 | 0) >> 2] | 0;
                 i64toi32_i32$0 = HEAP32[($4 + 760 | 0) >> 2] | 0;
                 $585 = i64toi32_i32$3;
                 i64toi32_i32$3 = $4;
                 HEAP32[($4 + 120 | 0) >> 2] = $585;
                 HEAP32[($4 + 124 | 0) >> 2] = i64toi32_i32$0;
                 $cardano_serialization_lib__crypto__VRFCert_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__ha63b72084ea6ce59($4 + 752 | 0 | 0, $1 | 0);
                 if ((HEAP32[($4 + 752 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                  break label$9
                 }
                 i64toi32_i32$1 = $8;
                 i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                 i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                 $596 = i64toi32_i32$0;
                 i64toi32_i32$0 = ($4 + 144 | 0) + 8 | 0;
                 HEAP32[i64toi32_i32$0 >> 2] = $596;
                 HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
                 i64toi32_i32$1 = $6;
                 i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                 i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                 $600 = i64toi32_i32$3;
                 i64toi32_i32$3 = $4 + 160 | 0;
                 HEAP32[i64toi32_i32$3 >> 2] = $600;
                 HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
                 i64toi32_i32$1 = $4;
                 i64toi32_i32$0 = HEAP32[($4 + 756 | 0) >> 2] | 0;
                 i64toi32_i32$3 = HEAP32[($4 + 760 | 0) >> 2] | 0;
                 $603 = i64toi32_i32$0;
                 i64toi32_i32$0 = $4;
                 HEAP32[($4 + 144 | 0) >> 2] = $603;
                 HEAP32[($4 + 148 | 0) >> 2] = i64toi32_i32$3;
                 $T_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hf422f9333a8bbafa($4 + 752 | 0 | 0, $1 | 0);
                 if ((HEAP32[($4 + 752 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                  break label$8
                 }
                 $8 = HEAP32[($4 + 756 | 0) >> 2] | 0;
                 $cardano_serialization_lib__crypto__BlockHash_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h8933d5e4c20cf015($4 + 752 | 0 | 0, $1 | 0);
                 if ((HEAPU8[($4 + 752 | 0) >> 0] | 0 | 0) == (1 | 0)) {
                  break label$7
                 }
                 $165 = ($4 + 752 | 0) + 15 | 0;
                 $166 = ($4 + 424 | 0) + 15 | 0;
                 $167 = HEAPU8[$165 >> 0] | 0 | ((HEAPU8[($165 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
                 HEAP8[$166 >> 0] = $167;
                 HEAP8[($166 + 1 | 0) >> 0] = $167 >>> 8 | 0;
                 $6 = ($4 + 648 | 0) + 16 | 0;
                 i64toi32_i32$1 = $4 + 769 | 0;
                 i64toi32_i32$3 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 $631 = i64toi32_i32$3;
                 i64toi32_i32$3 = $6;
                 HEAP32[i64toi32_i32$3 >> 2] = $631;
                 HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
                 $7 = ($4 + 648 | 0) + 24 | 0;
                 i64toi32_i32$1 = $4 + 777 | 0;
                 i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 i64toi32_i32$3 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 $638 = i64toi32_i32$0;
                 i64toi32_i32$0 = $7;
                 HEAP32[i64toi32_i32$0 >> 2] = $638;
                 HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
                 i64toi32_i32$1 = $4;
                 i64toi32_i32$3 = HEAPU8[($4 + 759 | 0) >> 0] | 0 | ((HEAPU8[($4 + 760 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 761 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 762 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 i64toi32_i32$0 = HEAPU8[($4 + 763 | 0) >> 0] | 0 | ((HEAPU8[($4 + 764 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 765 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 766 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 $641 = i64toi32_i32$3;
                 i64toi32_i32$3 = $4;
                 $139 = $641;
                 HEAP8[($4 + 431 | 0) >> 0] = $139;
                 HEAP8[($4 + 432 | 0) >> 0] = $139 >>> 8 | 0;
                 HEAP8[($4 + 433 | 0) >> 0] = $139 >>> 16 | 0;
                 HEAP8[($4 + 434 | 0) >> 0] = $139 >>> 24 | 0;
                 HEAP8[($4 + 435 | 0) >> 0] = i64toi32_i32$0;
                 HEAP8[($4 + 436 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                 HEAP8[($4 + 437 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
                 HEAP8[($4 + 438 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
                 $10 = ($4 + 648 | 0) + 8 | 0;
                 i64toi32_i32$1 = $4 + 433 | 0;
                 i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 i64toi32_i32$3 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 $648 = i64toi32_i32$0;
                 i64toi32_i32$0 = $10;
                 HEAP32[i64toi32_i32$0 >> 2] = $648;
                 HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
                 $168 = HEAPU8[($4 + 757 | 0) >> 0] | 0 | ((HEAPU8[($4 + 758 | 0) >> 0] | 0) << 8 | 0) | 0;
                 HEAP8[($4 + 429 | 0) >> 0] = $168;
                 HEAP8[($4 + 430 | 0) >> 0] = $168 >>> 8 | 0;
                 $140 = HEAPU8[($4 + 753 | 0) >> 0] | 0 | ((HEAPU8[($4 + 754 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 755 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 756 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 HEAP8[($4 + 425 | 0) >> 0] = $140;
                 HEAP8[($4 + 426 | 0) >> 0] = $140 >>> 8 | 0;
                 HEAP8[($4 + 427 | 0) >> 0] = $140 >>> 16 | 0;
                 HEAP8[($4 + 428 | 0) >> 0] = $140 >>> 24 | 0;
                 i64toi32_i32$1 = $4;
                 i64toi32_i32$3 = HEAPU8[($4 + 425 | 0) >> 0] | 0 | ((HEAPU8[($4 + 426 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 427 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 428 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 i64toi32_i32$0 = HEAPU8[($4 + 429 | 0) >> 0] | 0 | ((HEAPU8[($4 + 430 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 431 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 432 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 $657 = i64toi32_i32$3;
                 i64toi32_i32$3 = $4;
                 HEAP32[($4 + 648 | 0) >> 2] = $657;
                 HEAP32[($4 + 652 | 0) >> 2] = i64toi32_i32$0;
                 i64toi32_i32$1 = $7;
                 i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                 i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                 $662 = i64toi32_i32$0;
                 i64toi32_i32$0 = ($4 + 168 | 0) + 24 | 0;
                 HEAP32[i64toi32_i32$0 >> 2] = $662;
                 HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
                 i64toi32_i32$1 = $6;
                 i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                 i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                 $667 = i64toi32_i32$3;
                 i64toi32_i32$3 = ($4 + 168 | 0) + 16 | 0;
                 HEAP32[i64toi32_i32$3 >> 2] = $667;
                 HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
                 i64toi32_i32$1 = $10;
                 i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                 i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                 $672 = i64toi32_i32$0;
                 i64toi32_i32$0 = ($4 + 168 | 0) + 8 | 0;
                 HEAP32[i64toi32_i32$0 >> 2] = $672;
                 HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
                 i64toi32_i32$1 = $4;
                 i64toi32_i32$3 = HEAP32[($4 + 648 | 0) >> 2] | 0;
                 i64toi32_i32$0 = HEAP32[($4 + 652 | 0) >> 2] | 0;
                 $675 = i64toi32_i32$3;
                 i64toi32_i32$3 = $4;
                 HEAP32[($4 + 168 | 0) >> 2] = $675;
                 HEAP32[($4 + 172 | 0) >> 2] = i64toi32_i32$0;
                 i64toi32_i32$0 = $26$hi;
                 i64toi32_i32$3 = i64toi32_i32$0;
                 cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__OperationalCert___deserialize_as_embedded_group__h5685b082c2c28803($4 + 752 | 0 | 0, $1 | 0, $26 | 0, i64toi32_i32$0 | 0, $26 | 0, i64toi32_i32$0 | 0);
                 if ((HEAP32[($4 + 752 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                  break label$6
                 }
                 $6 = $4 + 752 | 0 | 4 | 0;
                 memcpy($4 + 648 | 0 | 0, $6 | 0, 104 | 0) | 0;
                 memcpy($4 + 536 | 0 | 0, $4 + 648 | 0 | 0, 104 | 0) | 0;
                 memcpy($4 + 320 | 0 | 0, memcpy($4 + 424 | 0 | 4 | 0 | 0, $4 + 536 | 0 | 0, 104 | 0) | 0 | 0, 104 | 0) | 0;
                 memcpy($4 + 216 | 0 | 0, $4 + 320 | 0 | 0, 104 | 0) | 0;
                 i64toi32_i32$3 = $26$hi;
                 i64toi32_i32$0 = i64toi32_i32$3;
                 cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__ProtocolVersion___deserialize_as_embedded_group__h2c31b2815aa7e5c5($4 + 752 | 0 | 0, $1 | 0, $26 | 0, i64toi32_i32$0 | 0, $26 | 0, i64toi32_i32$0 | 0);
                 if ((HEAP32[($4 + 752 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                  break label$5
                 }
                 i64toi32_i32$1 = $4;
                 i64toi32_i32$0 = HEAP32[($4 + 756 | 0) >> 2] | 0;
                 i64toi32_i32$3 = HEAP32[($4 + 760 | 0) >> 2] | 0;
                 $27 = i64toi32_i32$0;
                 $27$hi = i64toi32_i32$3;
                 memcpy($0 + 184 | 0 | 0, $4 + 16 | 0 | 0, 33 | 0) | 0;
                 memcpy($0 + 72 | 0 | 0, $4 + 216 | 0 | 0, 104 | 0) | 0;
                 HEAP32[($0 + 16 | 0) >> 2] = $5;
                 i64toi32_i32$3 = $26$hi;
                 i64toi32_i32$0 = $0;
                 HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $26;
                 HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$3;
                 i64toi32_i32$3 = $27$hi;
                 i64toi32_i32$0 = i64toi32_i32$0 + 176 | 0;
                 HEAP32[i64toi32_i32$0 >> 2] = $27;
                 HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
                 HEAP32[($0 + 68 | 0) >> 2] = $8;
                 i64toi32_i32$1 = $4;
                 i64toi32_i32$3 = HEAP32[($4 + 120 | 0) >> 2] | 0;
                 i64toi32_i32$0 = HEAP32[($4 + 124 | 0) >> 2] | 0;
                 $744 = i64toi32_i32$3;
                 i64toi32_i32$3 = $0 + 20 | 0;
                 HEAP32[i64toi32_i32$3 >> 2] = $744;
                 HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
                 i64toi32_i32$1 = ($4 + 120 | 0) + 8 | 0;
                 i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                 i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                 $750 = i64toi32_i32$0;
                 i64toi32_i32$0 = $0 + 28 | 0;
                 HEAP32[i64toi32_i32$0 >> 2] = $750;
                 HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
                 i64toi32_i32$1 = ($4 + 120 | 0) + 16 | 0;
                 i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                 i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                 $756 = i64toi32_i32$3;
                 i64toi32_i32$3 = $0 + 36 | 0;
                 HEAP32[i64toi32_i32$3 >> 2] = $756;
                 HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
                 i64toi32_i32$1 = $4;
                 i64toi32_i32$0 = HEAP32[($4 + 144 | 0) >> 2] | 0;
                 i64toi32_i32$3 = HEAP32[($4 + 148 | 0) >> 2] | 0;
                 $760 = i64toi32_i32$0;
                 i64toi32_i32$0 = $0 + 44 | 0;
                 HEAP32[i64toi32_i32$0 >> 2] = $760;
                 HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
                 i64toi32_i32$1 = ($4 + 144 | 0) + 8 | 0;
                 i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                 i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                 $766 = i64toi32_i32$3;
                 i64toi32_i32$3 = $0 + 52 | 0;
                 HEAP32[i64toi32_i32$3 >> 2] = $766;
                 HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
                 i64toi32_i32$1 = ($4 + 144 | 0) + 16 | 0;
                 i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                 i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                 $772 = i64toi32_i32$0;
                 i64toi32_i32$0 = $0 + 60 | 0;
                 HEAP32[i64toi32_i32$0 >> 2] = $772;
                 HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
                 i64toi32_i32$1 = $4;
                 i64toi32_i32$3 = HEAP32[($4 + 56 | 0) >> 2] | 0;
                 i64toi32_i32$0 = HEAP32[($4 + 60 | 0) >> 2] | 0;
                 $776 = i64toi32_i32$3;
                 i64toi32_i32$3 = $0 + 217 | 0;
                 $141 = $776;
                 HEAP8[i64toi32_i32$3 >> 0] = $141;
                 HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $141 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $141 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $141 >>> 24 | 0;
                 HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$0;
                 HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
                 i64toi32_i32$1 = ($4 + 56 | 0) + 8 | 0;
                 i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                 i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                 $782 = i64toi32_i32$0;
                 i64toi32_i32$0 = $0 + 225 | 0;
                 $142 = $782;
                 HEAP8[i64toi32_i32$0 >> 0] = $142;
                 HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $142 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $142 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $142 >>> 24 | 0;
                 HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$3;
                 HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
                 i64toi32_i32$1 = ($4 + 56 | 0) + 16 | 0;
                 i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                 i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                 $788 = i64toi32_i32$3;
                 i64toi32_i32$3 = $0 + 233 | 0;
                 $143 = $788;
                 HEAP8[i64toi32_i32$3 >> 0] = $143;
                 HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $143 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $143 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $143 >>> 24 | 0;
                 HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$0;
                 HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
                 i64toi32_i32$1 = ($4 + 56 | 0) + 24 | 0;
                 i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                 i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                 $794 = i64toi32_i32$0;
                 i64toi32_i32$0 = $0 + 241 | 0;
                 $144 = $794;
                 HEAP8[i64toi32_i32$0 >> 0] = $144;
                 HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $144 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $144 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $144 >>> 24 | 0;
                 HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$3;
                 HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
                 i64toi32_i32$0 = $0;
                 i64toi32_i32$3 = 0;
                 HEAP32[i64toi32_i32$0 >> 2] = 0;
                 HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
                 i64toi32_i32$1 = ($4 + 88 | 0) + 24 | 0;
                 i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                 i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                 $801 = i64toi32_i32$3;
                 i64toi32_i32$3 = $0 + 273 | 0;
                 $145 = $801;
                 HEAP8[i64toi32_i32$3 >> 0] = $145;
                 HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $145 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $145 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $145 >>> 24 | 0;
                 HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$0;
                 HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
                 i64toi32_i32$1 = ($4 + 88 | 0) + 16 | 0;
                 i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                 i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                 $807 = i64toi32_i32$0;
                 i64toi32_i32$0 = $0 + 265 | 0;
                 $146 = $807;
                 HEAP8[i64toi32_i32$0 >> 0] = $146;
                 HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $146 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $146 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $146 >>> 24 | 0;
                 HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$3;
                 HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
                 i64toi32_i32$1 = ($4 + 88 | 0) + 8 | 0;
                 i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                 i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                 $813 = i64toi32_i32$3;
                 i64toi32_i32$3 = $0 + 257 | 0;
                 $147 = $813;
                 HEAP8[i64toi32_i32$3 >> 0] = $147;
                 HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $147 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $147 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $147 >>> 24 | 0;
                 HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$0;
                 HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
                 i64toi32_i32$1 = $4;
                 i64toi32_i32$0 = HEAP32[($4 + 88 | 0) >> 2] | 0;
                 i64toi32_i32$3 = HEAP32[($4 + 92 | 0) >> 2] | 0;
                 $817 = i64toi32_i32$0;
                 i64toi32_i32$0 = $0 + 249 | 0;
                 $148 = $817;
                 HEAP8[i64toi32_i32$0 >> 0] = $148;
                 HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $148 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $148 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $148 >>> 24 | 0;
                 HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$3;
                 HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
                 i64toi32_i32$1 = ($4 + 168 | 0) + 24 | 0;
                 i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                 i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                 $823 = i64toi32_i32$3;
                 i64toi32_i32$3 = $0 + 305 | 0;
                 $149 = $823;
                 HEAP8[i64toi32_i32$3 >> 0] = $149;
                 HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $149 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $149 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $149 >>> 24 | 0;
                 HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$0;
                 HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
                 i64toi32_i32$1 = ($4 + 168 | 0) + 16 | 0;
                 i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                 i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                 $829 = i64toi32_i32$0;
                 i64toi32_i32$0 = $0 + 297 | 0;
                 $150 = $829;
                 HEAP8[i64toi32_i32$0 >> 0] = $150;
                 HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $150 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $150 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $150 >>> 24 | 0;
                 HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$3;
                 HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
                 i64toi32_i32$1 = ($4 + 168 | 0) + 8 | 0;
                 i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                 i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                 $835 = i64toi32_i32$3;
                 i64toi32_i32$3 = $0 + 289 | 0;
                 $151 = $835;
                 HEAP8[i64toi32_i32$3 >> 0] = $151;
                 HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $151 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $151 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $151 >>> 24 | 0;
                 HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$0;
                 HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
                 i64toi32_i32$1 = $4;
                 i64toi32_i32$0 = HEAP32[($4 + 168 | 0) >> 2] | 0;
                 i64toi32_i32$3 = HEAP32[($4 + 172 | 0) >> 2] | 0;
                 $839 = i64toi32_i32$0;
                 i64toi32_i32$0 = $0 + 281 | 0;
                 $152 = $839;
                 HEAP8[i64toi32_i32$0 >> 0] = $152;
                 HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $152 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $152 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $152 >>> 24 | 0;
                 HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$3;
                 HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
                 break label$1;
                }
                $6 = 8;
                i64toi32_i32$1 = $4 + 762 | 0;
                i64toi32_i32$3 = HEAPU16[i64toi32_i32$1 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
                i64toi32_i32$0 = HEAPU16[(i64toi32_i32$1 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
                $845 = i64toi32_i32$3;
                i64toi32_i32$3 = ($4 + 320 | 0) + 8 | 0;
                HEAP32[i64toi32_i32$3 >> 2] = $845;
                HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
                i64toi32_i32$1 = $4 + 768 | 0;
                i64toi32_i32$0 = HEAPU16[i64toi32_i32$1 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
                i64toi32_i32$3 = HEAPU16[(i64toi32_i32$1 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
                $850 = i64toi32_i32$0;
                i64toi32_i32$0 = $4 + 334 | 0;
                $169 = $850;
                HEAP16[i64toi32_i32$0 >> 1] = $169;
                HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $169 >>> 16 | 0;
                HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$3;
                HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$3 >>> 16 | 0;
                $1 = 0;
                HEAP8[($4 + 90 | 0) >> 0] = 0;
                HEAP16[($4 + 88 | 0) >> 1] = 0;
                $170 = HEAPU16[($4 + 752 | 0) >> 1] | 0;
                HEAP8[($4 + 95 | 0) >> 0] = $170;
                HEAP8[($4 + 96 | 0) >> 0] = $170 >>> 8 | 0;
                i64toi32_i32$1 = $4;
                i64toi32_i32$3 = HEAPU16[($4 + 754 | 0) >> 1] | 0 | ((HEAPU16[($4 + 756 | 0) >> 1] | 0) << 16 | 0) | 0;
                i64toi32_i32$0 = HEAPU16[($4 + 758 | 0) >> 1] | 0 | ((HEAPU16[($4 + 760 | 0) >> 1] | 0) << 16 | 0) | 0;
                $858 = i64toi32_i32$3;
                i64toi32_i32$3 = $4;
                HEAP32[($4 + 320 | 0) >> 2] = $858;
                HEAP32[($4 + 324 | 0) >> 2] = i64toi32_i32$0;
                $7 = 2;
                $5 = 0;
                $10 = 0;
                $11 = 0;
                $12 = 0;
                $8 = 0;
               }
               HEAP8[($4 + 768 | 0) >> 0] = $1;
               HEAP8[($4 + 767 | 0) >> 0] = $5;
               HEAP8[(($4 + 752 | 0) + 14 | 0) >> 0] = $10;
               HEAP8[($4 + 765 | 0) >> 0] = $11;
               HEAP8[($4 + 764 | 0) >> 0] = $12;
               HEAP8[($4 + 763 | 0) >> 0] = $13;
               HEAP8[($4 + 762 | 0) >> 0] = $14;
               HEAP8[(($4 + 752 | 0) + 9 | 0) >> 0] = $15;
               HEAP8[(($4 + 752 | 0) + 8 | 0) >> 0] = $6;
               i64toi32_i32$1 = $4;
               i64toi32_i32$0 = HEAP32[($4 + 88 | 0) >> 2] | 0;
               i64toi32_i32$3 = HEAP32[($4 + 92 | 0) >> 2] | 0;
               $892 = i64toi32_i32$0;
               i64toi32_i32$0 = $4 + 769 | 0;
               $153 = $892;
               HEAP8[i64toi32_i32$0 >> 0] = $153;
               HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $153 >>> 8 | 0;
               HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $153 >>> 16 | 0;
               HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $153 >>> 24 | 0;
               HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$3;
               HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
               HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
               HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
               HEAP8[($4 + 777 | 0) >> 0] = HEAPU8[(($4 + 88 | 0) + 8 | 0) >> 0] | 0;
               HEAP8[($4 + 759 | 0) >> 0] = $16;
               HEAP8[($4 + 758 | 0) >> 0] = $17;
               HEAP8[($4 + 757 | 0) >> 0] = $18;
               HEAP8[($4 + 756 | 0) >> 0] = $19;
               HEAP8[($4 + 755 | 0) >> 0] = $20;
               HEAP8[($4 + 754 | 0) >> 0] = $21;
               HEAP8[($4 + 753 | 0) >> 0] = $22;
               HEAP8[($4 + 752 | 0) >> 0] = $7;
               i64toi32_i32$1 = ($4 + 320 | 0) + 14 | 0;
               i64toi32_i32$3 = HEAPU16[i64toi32_i32$1 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
               i64toi32_i32$0 = HEAPU16[(i64toi32_i32$1 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
               $920 = i64toi32_i32$3;
               i64toi32_i32$3 = $4 + 792 | 0;
               $154 = $920;
               HEAP8[i64toi32_i32$3 >> 0] = $154;
               HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $154 >>> 8 | 0;
               HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $154 >>> 16 | 0;
               HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $154 >>> 24 | 0;
               HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$0;
               HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
               HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
               HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
               i64toi32_i32$1 = ($4 + 320 | 0) + 8 | 0;
               i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
               i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
               $926 = i64toi32_i32$0;
               i64toi32_i32$0 = $4 + 786 | 0;
               $171 = $926;
               HEAP16[i64toi32_i32$0 >> 1] = $171;
               HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $171 >>> 16 | 0;
               HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$3;
               HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$3 >>> 16 | 0;
               i64toi32_i32$1 = $4;
               i64toi32_i32$3 = HEAP32[($4 + 320 | 0) >> 2] | 0;
               i64toi32_i32$0 = HEAP32[($4 + 324 | 0) >> 2] | 0;
               $930 = i64toi32_i32$3;
               i64toi32_i32$3 = $4 + 778 | 0;
               $172 = $930;
               HEAP16[i64toi32_i32$3 >> 1] = $172;
               HEAP16[(i64toi32_i32$3 + 2 | 0) >> 1] = $172 >>> 16 | 0;
               HEAP16[(i64toi32_i32$3 + 4 | 0) >> 1] = i64toi32_i32$0;
               HEAP16[(i64toi32_i32$3 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
               HEAP32[($4 + 812 | 0) >> 2] = HEAP32[(($4 + 168 | 0) + 8 | 0) >> 2] | 0;
               i64toi32_i32$1 = $4;
               i64toi32_i32$0 = HEAP32[($4 + 168 | 0) >> 2] | 0;
               i64toi32_i32$3 = HEAP32[($4 + 172 | 0) >> 2] | 0;
               $940 = i64toi32_i32$0;
               i64toi32_i32$0 = $4 + 804 | 0;
               HEAP32[i64toi32_i32$0 >> 2] = $940;
               HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
               HEAP32[($4 + 800 | 0) >> 2] = $8;
               $1 = ($4 + 424 | 0) + 8 | 0;
               cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 752 | 0 | 0, 1052887 | 0, 9 | 0);
               memcpy($0 + 8 | 0 | 0, memcpy($4 + 655 | 0 | 0, $1 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
               i64toi32_i32$0 = $0;
               i64toi32_i32$3 = 0;
               HEAP32[i64toi32_i32$0 >> 2] = 1;
               HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
               break label$1;
              }
              memcpy($4 + 648 | 0 | 0, ($4 + 752 | 0) + 16 | 0 | 0, 56 | 0) | 0;
              i64toi32_i32$3 = $26$hi;
              i64toi32_i32$0 = $4;
              HEAP32[($4 + 752 | 0) >> 2] = $26;
              HEAP32[($4 + 756 | 0) >> 2] = i64toi32_i32$3;
              memcpy(($4 + 752 | 0) + 8 | 0 | 0, $4 + 648 | 0 | 0, 56 | 0) | 0;
              cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e(($4 + 424 | 0) + 8 | 0 | 0, $4 + 752 | 0 | 0, 1051822 | 0, 4 | 0);
              i64toi32_i32$1 = $4;
              i64toi32_i32$3 = HEAP32[($4 + 432 | 0) >> 2] | 0;
              i64toi32_i32$0 = HEAP32[($4 + 436 | 0) >> 2] | 0;
              $26 = i64toi32_i32$3;
              $26$hi = i64toi32_i32$0;
              memcpy($0 + 16 | 0 | 0, ($4 + 424 | 0) + 16 | 0 | 0, 56 | 0) | 0;
              i64toi32_i32$3 = $0;
              i64toi32_i32$0 = 0;
              HEAP32[i64toi32_i32$3 >> 2] = 1;
              HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
              i64toi32_i32$0 = $26$hi;
              HEAP32[(i64toi32_i32$3 + 8 | 0) >> 2] = $26;
              HEAP32[(i64toi32_i32$3 + 12 | 0) >> 2] = i64toi32_i32$0;
              break label$1;
             }
             $1 = ($4 + 536 | 0) + 14 | 0;
             i64toi32_i32$1 = $4 + 800 | 0;
             i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             i64toi32_i32$3 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             $993 = i64toi32_i32$0;
             i64toi32_i32$0 = $1;
             $173 = $993;
             HEAP16[i64toi32_i32$0 >> 1] = $173;
             HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $173 >>> 16 | 0;
             HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$3;
             HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$3 >>> 16 | 0;
             $8 = ($4 + 536 | 0) + 8 | 0;
             i64toi32_i32$1 = $4 + 794 | 0;
             i64toi32_i32$3 = HEAPU16[i64toi32_i32$1 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
             i64toi32_i32$0 = HEAPU16[(i64toi32_i32$1 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
             $1000 = i64toi32_i32$3;
             i64toi32_i32$3 = $8;
             HEAP32[i64toi32_i32$3 >> 2] = $1000;
             HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
             $5 = ($4 + 216 | 0) + 8 | 0;
             HEAP32[$5 >> 2] = HEAP32[($4 + 820 | 0) >> 2] | 0;
             $7 = ($4 + 320 | 0) + 14 | 0;
             i64toi32_i32$1 = $1;
             i64toi32_i32$0 = HEAPU16[i64toi32_i32$1 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
             i64toi32_i32$3 = HEAPU16[(i64toi32_i32$1 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
             $1013 = i64toi32_i32$0;
             i64toi32_i32$0 = $7;
             $174 = $1013;
             HEAP16[i64toi32_i32$0 >> 1] = $174;
             HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $174 >>> 16 | 0;
             HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$3;
             HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$3 >>> 16 | 0;
             $1 = ($4 + 320 | 0) + 8 | 0;
             i64toi32_i32$1 = $8;
             i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
             i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
             $1019 = i64toi32_i32$3;
             i64toi32_i32$3 = $1;
             HEAP32[i64toi32_i32$3 >> 2] = $1019;
             HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
             $8 = $4 + 786 | 0;
             i64toi32_i32$1 = $8;
             i64toi32_i32$0 = HEAPU16[i64toi32_i32$1 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
             i64toi32_i32$3 = HEAPU16[(i64toi32_i32$1 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
             $26 = i64toi32_i32$0;
             $26$hi = i64toi32_i32$3;
             i64toi32_i32$0 = $4;
             HEAP32[($4 + 536 | 0) >> 2] = $26;
             HEAP32[($4 + 540 | 0) >> 2] = i64toi32_i32$3;
             $10 = $4 + 812 | 0;
             i64toi32_i32$1 = $10;
             i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
             i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
             $1030 = i64toi32_i32$3;
             i64toi32_i32$3 = $4;
             HEAP32[($4 + 216 | 0) >> 2] = $1030;
             HEAP32[($4 + 220 | 0) >> 2] = i64toi32_i32$0;
             i64toi32_i32$0 = $26$hi;
             i64toi32_i32$3 = $4;
             HEAP32[($4 + 320 | 0) >> 2] = $26;
             HEAP32[($4 + 324 | 0) >> 2] = i64toi32_i32$0;
             $11 = HEAP32[($4 + 808 | 0) >> 2] | 0;
             $12 = ($4 + 752 | 0) + 8 | 0;
             i64toi32_i32$1 = $12;
             i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
             i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
             $26 = i64toi32_i32$0;
             $26$hi = i64toi32_i32$3;
             $13 = ($4 + 752 | 0) + 16 | 0;
             i64toi32_i32$1 = $13;
             i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
             i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
             $27 = i64toi32_i32$3;
             $27$hi = i64toi32_i32$0;
             $14 = HEAPU8[(($4 + 752 | 0) + 24 | 0) >> 0] | 0;
             $15 = ($4 + 752 | 0) + 25 | 0;
             i64toi32_i32$1 = $15;
             i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             i64toi32_i32$3 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             $28 = i64toi32_i32$0;
             $28$hi = i64toi32_i32$3;
             $16 = HEAPU8[(($4 + 752 | 0) + 33 | 0) >> 0] | 0;
             $17 = ($4 + 168 | 0) + 8 | 0;
             HEAP32[$17 >> 2] = HEAP32[$5 >> 2] | 0;
             i64toi32_i32$1 = $4;
             i64toi32_i32$3 = HEAP32[($4 + 216 | 0) >> 2] | 0;
             i64toi32_i32$0 = HEAP32[($4 + 220 | 0) >> 2] | 0;
             $1067 = i64toi32_i32$3;
             i64toi32_i32$3 = $4;
             HEAP32[($4 + 168 | 0) >> 2] = $1067;
             HEAP32[($4 + 172 | 0) >> 2] = i64toi32_i32$0;
             HEAP8[$15 >> 0] = $16;
             i64toi32_i32$0 = $28$hi;
             i64toi32_i32$3 = ($4 + 752 | 0) + 17 | 0;
             HEAP8[i64toi32_i32$3 >> 0] = $28;
             HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $28 >>> 8 | 0;
             HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $28 >>> 16 | 0;
             HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $28 >>> 24 | 0;
             HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$0;
             HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
             HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
             HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
             HEAP8[$13 >> 0] = $14;
             i64toi32_i32$0 = $27$hi;
             i64toi32_i32$3 = $12;
             HEAP32[i64toi32_i32$3 >> 2] = $27;
             HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
             i64toi32_i32$0 = $26$hi;
             i64toi32_i32$3 = $4;
             HEAP32[($4 + 752 | 0) >> 2] = $26;
             HEAP32[($4 + 756 | 0) >> 2] = i64toi32_i32$0;
             i64toi32_i32$1 = $7;
             i64toi32_i32$0 = HEAPU16[i64toi32_i32$1 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
             i64toi32_i32$3 = HEAPU16[(i64toi32_i32$1 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
             $1083 = i64toi32_i32$0;
             i64toi32_i32$0 = $4 + 792 | 0;
             $175 = $1083;
             HEAP16[i64toi32_i32$0 >> 1] = $175;
             HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $175 >>> 16 | 0;
             HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$3;
             HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$3 >>> 16 | 0;
             i64toi32_i32$1 = $1;
             i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
             i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
             $1086 = i64toi32_i32$3;
             i64toi32_i32$3 = $8;
             $176 = $1086;
             HEAP16[i64toi32_i32$3 >> 1] = $176;
             HEAP16[(i64toi32_i32$3 + 2 | 0) >> 1] = $176 >>> 16 | 0;
             HEAP16[(i64toi32_i32$3 + 4 | 0) >> 1] = i64toi32_i32$0;
             HEAP16[(i64toi32_i32$3 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
             i64toi32_i32$1 = $4;
             i64toi32_i32$0 = HEAP32[($4 + 320 | 0) >> 2] | 0;
             i64toi32_i32$3 = HEAP32[($4 + 324 | 0) >> 2] | 0;
             $1090 = i64toi32_i32$0;
             i64toi32_i32$0 = $4 + 778 | 0;
             $177 = $1090;
             HEAP16[i64toi32_i32$0 >> 1] = $177;
             HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $177 >>> 16 | 0;
             HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$3;
             HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$3 >>> 16 | 0;
             HEAP32[($4 + 800 | 0) >> 2] = $11;
             HEAP32[$10 >> 2] = HEAP32[$17 >> 2] | 0;
             i64toi32_i32$1 = $4;
             i64toi32_i32$3 = HEAP32[($4 + 168 | 0) >> 2] | 0;
             i64toi32_i32$0 = HEAP32[($4 + 172 | 0) >> 2] | 0;
             $1099 = i64toi32_i32$3;
             i64toi32_i32$3 = $4 + 804 | 0;
             HEAP32[i64toi32_i32$3 >> 2] = $1099;
             HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
             cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($6 | 0, $4 + 752 | 0 | 0, 1052896 | 0, 11 | 0);
             memcpy($0 + 8 | 0 | 0, memcpy($4 + 648 | 0 | 7 | 0 | 0, $6 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
             i64toi32_i32$3 = $0;
             i64toi32_i32$0 = 0;
             HEAP32[i64toi32_i32$3 >> 2] = 1;
             HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
             break label$1;
            }
            $1 = ($4 + 536 | 0) + 14 | 0;
            i64toi32_i32$1 = $4 + 800 | 0;
            i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            i64toi32_i32$3 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            $1118 = i64toi32_i32$0;
            i64toi32_i32$0 = $1;
            $178 = $1118;
            HEAP16[i64toi32_i32$0 >> 1] = $178;
            HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $178 >>> 16 | 0;
            HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$3;
            HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$3 >>> 16 | 0;
            $8 = ($4 + 536 | 0) + 8 | 0;
            i64toi32_i32$1 = $4 + 794 | 0;
            i64toi32_i32$3 = HEAPU16[i64toi32_i32$1 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
            i64toi32_i32$0 = HEAPU16[(i64toi32_i32$1 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
            $1125 = i64toi32_i32$3;
            i64toi32_i32$3 = $8;
            HEAP32[i64toi32_i32$3 >> 2] = $1125;
            HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
            $5 = ($4 + 216 | 0) + 8 | 0;
            HEAP32[$5 >> 2] = HEAP32[($4 + 820 | 0) >> 2] | 0;
            $6 = ($4 + 320 | 0) + 14 | 0;
            i64toi32_i32$1 = $1;
            i64toi32_i32$0 = HEAPU16[i64toi32_i32$1 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
            i64toi32_i32$3 = HEAPU16[(i64toi32_i32$1 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
            $1138 = i64toi32_i32$0;
            i64toi32_i32$0 = $6;
            $179 = $1138;
            HEAP16[i64toi32_i32$0 >> 1] = $179;
            HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $179 >>> 16 | 0;
            HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$3;
            HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$3 >>> 16 | 0;
            $1 = ($4 + 320 | 0) + 8 | 0;
            i64toi32_i32$1 = $8;
            i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
            i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
            $1144 = i64toi32_i32$3;
            i64toi32_i32$3 = $1;
            HEAP32[i64toi32_i32$3 >> 2] = $1144;
            HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
            $8 = $4 + 786 | 0;
            i64toi32_i32$1 = $8;
            i64toi32_i32$0 = HEAPU16[i64toi32_i32$1 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
            i64toi32_i32$3 = HEAPU16[(i64toi32_i32$1 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
            $26 = i64toi32_i32$0;
            $26$hi = i64toi32_i32$3;
            i64toi32_i32$0 = $4;
            HEAP32[($4 + 536 | 0) >> 2] = $26;
            HEAP32[($4 + 540 | 0) >> 2] = i64toi32_i32$3;
            $7 = $4 + 812 | 0;
            i64toi32_i32$1 = $7;
            i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
            i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
            $1155 = i64toi32_i32$3;
            i64toi32_i32$3 = $4;
            HEAP32[($4 + 216 | 0) >> 2] = $1155;
            HEAP32[($4 + 220 | 0) >> 2] = i64toi32_i32$0;
            i64toi32_i32$0 = $26$hi;
            i64toi32_i32$3 = $4;
            HEAP32[($4 + 320 | 0) >> 2] = $26;
            HEAP32[($4 + 324 | 0) >> 2] = i64toi32_i32$0;
            $10 = HEAP32[($4 + 808 | 0) >> 2] | 0;
            $11 = ($4 + 752 | 0) + 8 | 0;
            i64toi32_i32$1 = $11;
            i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
            i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
            $26 = i64toi32_i32$0;
            $26$hi = i64toi32_i32$3;
            $12 = $4 + 768 | 0;
            i64toi32_i32$1 = $12;
            i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
            i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
            $27 = i64toi32_i32$3;
            $27$hi = i64toi32_i32$0;
            $13 = HEAPU8[($4 + 776 | 0) >> 0] | 0;
            $14 = $4 + 777 | 0;
            i64toi32_i32$1 = $14;
            i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            i64toi32_i32$3 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            $28 = i64toi32_i32$0;
            $28$hi = i64toi32_i32$3;
            $15 = HEAPU8[($4 + 785 | 0) >> 0] | 0;
            $16 = ($4 + 168 | 0) + 8 | 0;
            HEAP32[$16 >> 2] = HEAP32[$5 >> 2] | 0;
            i64toi32_i32$1 = $4;
            i64toi32_i32$3 = HEAP32[($4 + 216 | 0) >> 2] | 0;
            i64toi32_i32$0 = HEAP32[($4 + 220 | 0) >> 2] | 0;
            $1188 = i64toi32_i32$3;
            i64toi32_i32$3 = $4;
            HEAP32[($4 + 168 | 0) >> 2] = $1188;
            HEAP32[($4 + 172 | 0) >> 2] = i64toi32_i32$0;
            HEAP8[$14 >> 0] = $15;
            i64toi32_i32$0 = $28$hi;
            i64toi32_i32$3 = $4 + 769 | 0;
            HEAP8[i64toi32_i32$3 >> 0] = $28;
            HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $28 >>> 8 | 0;
            HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $28 >>> 16 | 0;
            HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $28 >>> 24 | 0;
            HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$0;
            HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
            HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
            HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
            HEAP8[$12 >> 0] = $13;
            i64toi32_i32$0 = $27$hi;
            i64toi32_i32$3 = $11;
            HEAP32[i64toi32_i32$3 >> 2] = $27;
            HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
            i64toi32_i32$0 = $26$hi;
            i64toi32_i32$3 = $4;
            HEAP32[($4 + 752 | 0) >> 2] = $26;
            HEAP32[($4 + 756 | 0) >> 2] = i64toi32_i32$0;
            i64toi32_i32$1 = $6;
            i64toi32_i32$0 = HEAPU16[i64toi32_i32$1 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
            i64toi32_i32$3 = HEAPU16[(i64toi32_i32$1 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
            $1203 = i64toi32_i32$0;
            i64toi32_i32$0 = $4 + 792 | 0;
            $180 = $1203;
            HEAP16[i64toi32_i32$0 >> 1] = $180;
            HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $180 >>> 16 | 0;
            HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$3;
            HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$3 >>> 16 | 0;
            i64toi32_i32$1 = $1;
            i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
            i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
            $1206 = i64toi32_i32$3;
            i64toi32_i32$3 = $8;
            $181 = $1206;
            HEAP16[i64toi32_i32$3 >> 1] = $181;
            HEAP16[(i64toi32_i32$3 + 2 | 0) >> 1] = $181 >>> 16 | 0;
            HEAP16[(i64toi32_i32$3 + 4 | 0) >> 1] = i64toi32_i32$0;
            HEAP16[(i64toi32_i32$3 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
            i64toi32_i32$1 = $4;
            i64toi32_i32$0 = HEAP32[($4 + 320 | 0) >> 2] | 0;
            i64toi32_i32$3 = HEAP32[($4 + 324 | 0) >> 2] | 0;
            $1210 = i64toi32_i32$0;
            i64toi32_i32$0 = $4 + 778 | 0;
            $182 = $1210;
            HEAP16[i64toi32_i32$0 >> 1] = $182;
            HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $182 >>> 16 | 0;
            HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$3;
            HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$3 >>> 16 | 0;
            HEAP32[($4 + 800 | 0) >> 2] = $10;
            HEAP32[$7 >> 2] = HEAP32[$16 >> 2] | 0;
            i64toi32_i32$1 = $4;
            i64toi32_i32$3 = HEAP32[($4 + 168 | 0) >> 2] | 0;
            i64toi32_i32$0 = HEAP32[($4 + 172 | 0) >> 2] | 0;
            $1219 = i64toi32_i32$3;
            i64toi32_i32$3 = $4 + 804 | 0;
            HEAP32[i64toi32_i32$3 >> 2] = $1219;
            HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
            $1 = ($4 + 424 | 0) + 8 | 0;
            cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 752 | 0 | 0, 1052907 | 0, 8 | 0);
            memcpy($0 + 8 | 0 | 0, memcpy($4 + 648 | 0 | 7 | 0 | 0, $1 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
            i64toi32_i32$3 = $0;
            i64toi32_i32$0 = 0;
            HEAP32[i64toi32_i32$3 >> 2] = 1;
            HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
            break label$1;
           }
           memcpy($4 + 752 | 0 | 0, memcpy($4 + 536 | 0 | 4 | 0 | 0, memcpy($4 + 648 | 0 | 4 | 0 | 0, ($4 + 752 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
           $1 = ($4 + 424 | 0) + 8 | 0;
           cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 752 | 0 | 0, 1052915 | 0, 9 | 0);
           memcpy($0 + 8 | 0 | 0, memcpy($4 + 320 | 0 | 4 | 0 | 0, $1 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
           i64toi32_i32$3 = $0;
           i64toi32_i32$0 = 0;
           HEAP32[i64toi32_i32$3 >> 2] = 1;
           HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
           break label$1;
          }
          memcpy($4 + 752 | 0 | 0, memcpy($4 + 536 | 0 | 4 | 0 | 0, memcpy($4 + 648 | 0 | 4 | 0 | 0, ($4 + 752 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
          $1 = ($4 + 424 | 0) + 8 | 0;
          cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 752 | 0 | 0, 1052924 | 0, 10 | 0);
          memcpy($0 + 8 | 0 | 0, memcpy($4 + 320 | 0 | 4 | 0 | 0, $1 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
          i64toi32_i32$3 = $0;
          i64toi32_i32$0 = 0;
          HEAP32[i64toi32_i32$3 >> 2] = 1;
          HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
          break label$2;
         }
         memcpy($4 + 648 | 0 | 0, ($4 + 752 | 0) + 8 | 0 | 0, 64 | 0) | 0;
         memcpy($4 + 536 | 0 | 0, $4 + 648 | 0 | 0, 64 | 0) | 0;
         memcpy($4 + 752 | 0 | 0, $4 + 536 | 0 | 0, 64 | 0) | 0;
         $1 = ($4 + 424 | 0) + 8 | 0;
         cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 752 | 0 | 0, 1052934 | 0, 15 | 0);
         memcpy($0 + 8 | 0 | 0, $1 | 0, 64 | 0) | 0;
         i64toi32_i32$3 = $0;
         i64toi32_i32$0 = 0;
         HEAP32[i64toi32_i32$3 >> 2] = 1;
         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
         break label$3;
        }
        $1 = ($4 + 536 | 0) + 14 | 0;
        i64toi32_i32$1 = $4 + 800 | 0;
        i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$3 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $1326 = i64toi32_i32$0;
        i64toi32_i32$0 = $1;
        $183 = $1326;
        HEAP16[i64toi32_i32$0 >> 1] = $183;
        HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $183 >>> 16 | 0;
        HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$3;
        HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$3 >>> 16 | 0;
        $8 = ($4 + 536 | 0) + 8 | 0;
        i64toi32_i32$1 = $4 + 794 | 0;
        i64toi32_i32$3 = HEAPU16[i64toi32_i32$1 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
        i64toi32_i32$0 = HEAPU16[(i64toi32_i32$1 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
        $1333 = i64toi32_i32$3;
        i64toi32_i32$3 = $8;
        HEAP32[i64toi32_i32$3 >> 2] = $1333;
        HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
        $5 = ($4 + 216 | 0) + 8 | 0;
        HEAP32[$5 >> 2] = HEAP32[($4 + 820 | 0) >> 2] | 0;
        $6 = ($4 + 320 | 0) + 14 | 0;
        i64toi32_i32$1 = $1;
        i64toi32_i32$0 = HEAPU16[i64toi32_i32$1 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
        i64toi32_i32$3 = HEAPU16[(i64toi32_i32$1 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
        $1346 = i64toi32_i32$0;
        i64toi32_i32$0 = $6;
        $184 = $1346;
        HEAP16[i64toi32_i32$0 >> 1] = $184;
        HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $184 >>> 16 | 0;
        HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$3;
        HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$3 >>> 16 | 0;
        $1 = ($4 + 320 | 0) + 8 | 0;
        i64toi32_i32$1 = $8;
        i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
        $1352 = i64toi32_i32$3;
        i64toi32_i32$3 = $1;
        HEAP32[i64toi32_i32$3 >> 2] = $1352;
        HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
        $8 = $4 + 786 | 0;
        i64toi32_i32$1 = $8;
        i64toi32_i32$0 = HEAPU16[i64toi32_i32$1 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
        i64toi32_i32$3 = HEAPU16[(i64toi32_i32$1 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
        $26 = i64toi32_i32$0;
        $26$hi = i64toi32_i32$3;
        i64toi32_i32$0 = $4;
        HEAP32[($4 + 536 | 0) >> 2] = $26;
        HEAP32[($4 + 540 | 0) >> 2] = i64toi32_i32$3;
        $7 = $4 + 812 | 0;
        i64toi32_i32$1 = $7;
        i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
        $1363 = i64toi32_i32$3;
        i64toi32_i32$3 = $4;
        HEAP32[($4 + 216 | 0) >> 2] = $1363;
        HEAP32[($4 + 220 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$0 = $26$hi;
        i64toi32_i32$3 = $4;
        HEAP32[($4 + 320 | 0) >> 2] = $26;
        HEAP32[($4 + 324 | 0) >> 2] = i64toi32_i32$0;
        $10 = HEAP32[($4 + 808 | 0) >> 2] | 0;
        $11 = ($4 + 752 | 0) + 8 | 0;
        i64toi32_i32$1 = $11;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
        $26 = i64toi32_i32$0;
        $26$hi = i64toi32_i32$3;
        $12 = $4 + 768 | 0;
        i64toi32_i32$1 = $12;
        i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
        $27 = i64toi32_i32$3;
        $27$hi = i64toi32_i32$0;
        $13 = HEAPU8[($4 + 776 | 0) >> 0] | 0;
        $14 = $4 + 777 | 0;
        i64toi32_i32$1 = $14;
        i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$3 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $28 = i64toi32_i32$0;
        $28$hi = i64toi32_i32$3;
        $15 = HEAPU8[($4 + 785 | 0) >> 0] | 0;
        $16 = ($4 + 200 | 0) + 8 | 0;
        HEAP32[$16 >> 2] = HEAP32[$5 >> 2] | 0;
        i64toi32_i32$1 = $4;
        i64toi32_i32$3 = HEAP32[($4 + 216 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[($4 + 220 | 0) >> 2] | 0;
        $1396 = i64toi32_i32$3;
        i64toi32_i32$3 = $4;
        HEAP32[($4 + 200 | 0) >> 2] = $1396;
        HEAP32[($4 + 204 | 0) >> 2] = i64toi32_i32$0;
        HEAP8[$14 >> 0] = $15;
        i64toi32_i32$0 = $28$hi;
        i64toi32_i32$3 = $4 + 769 | 0;
        HEAP8[i64toi32_i32$3 >> 0] = $28;
        HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $28 >>> 8 | 0;
        HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $28 >>> 16 | 0;
        HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $28 >>> 24 | 0;
        HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$0;
        HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
        HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
        HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
        HEAP8[$12 >> 0] = $13;
        i64toi32_i32$0 = $27$hi;
        i64toi32_i32$3 = $11;
        HEAP32[i64toi32_i32$3 >> 2] = $27;
        HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$0 = $26$hi;
        i64toi32_i32$3 = $4;
        HEAP32[($4 + 752 | 0) >> 2] = $26;
        HEAP32[($4 + 756 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$1 = $6;
        i64toi32_i32$0 = HEAPU16[i64toi32_i32$1 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
        i64toi32_i32$3 = HEAPU16[(i64toi32_i32$1 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
        $1411 = i64toi32_i32$0;
        i64toi32_i32$0 = $4 + 792 | 0;
        $185 = $1411;
        HEAP16[i64toi32_i32$0 >> 1] = $185;
        HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $185 >>> 16 | 0;
        HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$3;
        HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$3 >>> 16 | 0;
        i64toi32_i32$1 = $1;
        i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
        $1414 = i64toi32_i32$3;
        i64toi32_i32$3 = $8;
        $186 = $1414;
        HEAP16[i64toi32_i32$3 >> 1] = $186;
        HEAP16[(i64toi32_i32$3 + 2 | 0) >> 1] = $186 >>> 16 | 0;
        HEAP16[(i64toi32_i32$3 + 4 | 0) >> 1] = i64toi32_i32$0;
        HEAP16[(i64toi32_i32$3 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
        i64toi32_i32$1 = $4;
        i64toi32_i32$0 = HEAP32[($4 + 320 | 0) >> 2] | 0;
        i64toi32_i32$3 = HEAP32[($4 + 324 | 0) >> 2] | 0;
        $1418 = i64toi32_i32$0;
        i64toi32_i32$0 = $4 + 778 | 0;
        $187 = $1418;
        HEAP16[i64toi32_i32$0 >> 1] = $187;
        HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $187 >>> 16 | 0;
        HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$3;
        HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$3 >>> 16 | 0;
        HEAP32[($4 + 800 | 0) >> 2] = $10;
        HEAP32[$7 >> 2] = HEAP32[$16 >> 2] | 0;
        i64toi32_i32$1 = $4;
        i64toi32_i32$3 = HEAP32[($4 + 200 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[($4 + 204 | 0) >> 2] | 0;
        $1427 = i64toi32_i32$3;
        i64toi32_i32$3 = $4 + 804 | 0;
        HEAP32[i64toi32_i32$3 >> 2] = $1427;
        HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
        $1 = ($4 + 424 | 0) + 8 | 0;
        cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 752 | 0 | 0, 1052949 | 0, 15 | 0);
        memcpy($0 + 8 | 0 | 0, memcpy($4 + 648 | 0 | 7 | 0 | 0, $1 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
        i64toi32_i32$3 = $0;
        i64toi32_i32$0 = 0;
        HEAP32[i64toi32_i32$3 >> 2] = 1;
        HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
        break label$3;
       }
       memcpy($4 + 752 | 0 | 0, memcpy(($4 + 536 | 0) + 4 | 0 | 0, memcpy(($4 + 648 | 0) + 4 | 0 | 0, ($4 + 752 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
       $1 = ($4 + 424 | 0) + 8 | 0;
       cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 752 | 0 | 0, 1052964 | 0, 16 | 0);
       memcpy($0 + 8 | 0 | 0, memcpy(($4 + 320 | 0) + 4 | 0 | 0, $1 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
       i64toi32_i32$3 = $0;
       i64toi32_i32$0 = 0;
       HEAP32[i64toi32_i32$3 >> 2] = 1;
       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
       break label$3;
      }
      $1 = HEAP32[(($4 + 752 | 0) + 8 | 0) >> 2] | 0;
      memcpy($4 + 648 | 0 | 0, ($4 + 752 | 0) + 12 | 0 | 0, 60 | 0) | 0;
      HEAP32[($4 + 752 | 0) >> 2] = $1;
      memcpy($6 | 0, $4 + 648 | 0 | 0, 60 | 0) | 0;
      $1 = ($4 + 424 | 0) + 8 | 0;
      cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 752 | 0 | 0, 1052381 | 0, 16 | 0);
      $1 = HEAP32[$1 >> 2] | 0;
      memcpy($4 + 536 | 0 | 0, ($4 + 424 | 0) + 12 | 0 | 0, 60 | 0) | 0;
      HEAP32[($0 + 8 | 0) >> 2] = $1;
      memcpy($0 + 12 | 0 | 0, $4 + 536 | 0 | 0, 60 | 0) | 0;
      i64toi32_i32$3 = $0;
      i64toi32_i32$0 = 0;
      HEAP32[i64toi32_i32$3 >> 2] = 1;
      HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
      break label$3;
     }
     memcpy($4 + 648 | 0 | 0, ($4 + 752 | 0) + 8 | 0 | 0, 64 | 0) | 0;
     memcpy($4 + 536 | 0 | 0, $4 + 648 | 0 | 0, 64 | 0) | 0;
     memcpy($4 + 752 | 0 | 0, $4 + 536 | 0 | 0, 64 | 0) | 0;
     $1 = ($4 + 424 | 0) + 8 | 0;
     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 752 | 0 | 0, 1052875 | 0, 12 | 0);
     memcpy($0 + 8 | 0 | 0, $1 | 0, 64 | 0) | 0;
     i64toi32_i32$3 = $0;
     i64toi32_i32$0 = 0;
     HEAP32[i64toi32_i32$3 >> 2] = 1;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
     break label$1;
    }
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($4 + 144 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($4 + 144 | 0 | 0);
    $0 = $4 + 156 | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($4 + 120 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($4 + 120 | 0 | 0);
   $0 = $4 + 132 | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
  }
  global$0 = $4 + 864 | 0;
 }
 
 function core__num__flt2dec__strategy__dragon__format_shortest__he1c6aa82e117523b($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $10 = 0, i64toi32_i32$1 = 0, $4 = 0, i64toi32_i32$4 = 0, i64toi32_i32$2 = 0, i64toi32_i32$5 = 0, $6 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, $9 = 0, $32$hi = 0, $14 = 0, $12 = 0, $32 = 0, $13 = 0, $7 = 0, $30 = 0, $15 = 0, $31 = 0, $28 = 0, $29 = 0, $8 = 0, $33 = 0, $34 = 0, $5 = 0, $23 = 0, $33$hi = 0, $34$hi = 0, $16 = 0, $20 = 0, $25 = 0, i64toi32_i32$6 = 0, $35$hi = 0, $63 = 0, $64 = 0, $65 = 0, $66 = 0, $67 = 0, $11 = 0, $68 = 0, $69 = 0, $70 = 0, $71 = 0, $72 = 0, $22 = 0, $26 = 0, $27 = 0, $73 = 0, $75 = 0, $76 = 0, $35 = 0, $59$hi = 0, $74 = 0, $74$hi = 0, $77$hi = 0, $329 = 0, $77 = 0, $332$hi = 0, $370 = 0, $78 = 0, $373$hi = 0, $410 = 0, $79 = 0, $413$hi = 0, $17 = 0, $18 = 0, $19 = 0, $21 = 0, $24 = 0, $962 = 0, $80 = 0, $965$hi = 0, $999 = 0, $81 = 0, $1002$hi = 0, $1036 = 0, $82 = 0, $1039$hi = 0;
  $4 = global$0 - 1344 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           label$10 : {
            label$11 : {
             label$12 : {
              label$13 : {
               label$14 : {
                label$15 : {
                 label$16 : {
                  label$17 : {
                   label$18 : {
                    label$19 : {
                     label$20 : {
                      label$21 : {
                       label$22 : {
                        label$23 : {
                         label$24 : {
                          label$25 : {
                           label$26 : {
                            label$27 : {
                             label$28 : {
                              label$29 : {
                               label$30 : {
                                label$31 : {
                                 label$32 : {
                                  label$33 : {
                                   label$34 : {
                                    label$35 : {
                                     label$36 : {
                                      label$37 : {
                                       label$38 : {
                                        i64toi32_i32$2 = $1;
                                        i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
                                        i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
                                        $32 = i64toi32_i32$0;
                                        $32$hi = i64toi32_i32$1;
                                        if (!(i64toi32_i32$0 | i64toi32_i32$1 | 0)) {
                                         break label$38
                                        }
                                        i64toi32_i32$2 = $1;
                                        i64toi32_i32$1 = HEAP32[($1 + 8 | 0) >> 2] | 0;
                                        i64toi32_i32$0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
                                        $33 = i64toi32_i32$1;
                                        $33$hi = i64toi32_i32$0;
                                        if (!(i64toi32_i32$1 | i64toi32_i32$0 | 0)) {
                                         break label$37
                                        }
                                        i64toi32_i32$2 = $1;
                                        i64toi32_i32$0 = HEAP32[($1 + 16 | 0) >> 2] | 0;
                                        i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
                                        $34 = i64toi32_i32$0;
                                        $34$hi = i64toi32_i32$1;
                                        if (!(i64toi32_i32$0 | i64toi32_i32$1 | 0)) {
                                         break label$36
                                        }
                                        i64toi32_i32$1 = $32$hi;
                                        i64toi32_i32$1 = $34$hi;
                                        i64toi32_i32$1 = $32$hi;
                                        i64toi32_i32$2 = $32;
                                        i64toi32_i32$0 = $34$hi;
                                        i64toi32_i32$3 = $34;
                                        i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
                                        i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
                                        if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
                                         i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
                                        }
                                        $35 = i64toi32_i32$4;
                                        $35$hi = i64toi32_i32$5;
                                        i64toi32_i32$5 = $32$hi;
                                        i64toi32_i32$5 = $35$hi;
                                        i64toi32_i32$1 = i64toi32_i32$4;
                                        i64toi32_i32$2 = $32$hi;
                                        i64toi32_i32$3 = $32;
                                        if (i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0) {
                                         break label$35
                                        }
                                        i64toi32_i32$1 = $32$hi;
                                        i64toi32_i32$1 = $33$hi;
                                        i64toi32_i32$1 = $32$hi;
                                        i64toi32_i32$3 = $32;
                                        i64toi32_i32$5 = $33$hi;
                                        i64toi32_i32$2 = $33;
                                        i64toi32_i32$0 = i64toi32_i32$3 - i64toi32_i32$2 | 0;
                                        i64toi32_i32$6 = i64toi32_i32$3 >>> 0 < i64toi32_i32$2 >>> 0;
                                        i64toi32_i32$4 = i64toi32_i32$6 + i64toi32_i32$5 | 0;
                                        i64toi32_i32$4 = i64toi32_i32$1 - i64toi32_i32$4 | 0;
                                        $59$hi = i64toi32_i32$4;
                                        i64toi32_i32$4 = i64toi32_i32$1;
                                        i64toi32_i32$4 = $59$hi;
                                        i64toi32_i32$1 = i64toi32_i32$0;
                                        i64toi32_i32$3 = $32$hi;
                                        i64toi32_i32$2 = $32;
                                        if (i64toi32_i32$4 >>> 0 > i64toi32_i32$3 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$1 >>> 0 > i64toi32_i32$2 >>> 0 | 0) | 0) {
                                         break label$34
                                        }
                                        if ($3 >>> 0 < 17 >>> 0) {
                                         break label$30
                                        }
                                        $5 = HEAP8[($1 + 26 | 0) >> 0] | 0;
                                        $6 = HEAPU16[($1 + 24 | 0) >> 1] | 0;
                                        $1 = 0;
                                        memset($4 + 1176 | 0 | 0, 0 | 0, 160 | 0) | 0;
                                        i64toi32_i32$1 = 0;
                                        i64toi32_i32$2 = $6;
                                        i64toi32_i32$4 = 0;
                                        i64toi32_i32$3 = 48;
                                        i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
                                        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                                         i64toi32_i32$4 = i64toi32_i32$2 << i64toi32_i32$5 | 0;
                                         $63 = 0;
                                        } else {
                                         i64toi32_i32$4 = ((1 << i64toi32_i32$5 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$5 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$5 | 0) | 0;
                                         $63 = i64toi32_i32$2 << i64toi32_i32$5 | 0;
                                        }
                                        i64toi32_i32$1 = $63;
                                        i64toi32_i32$2 = 0;
                                        i64toi32_i32$3 = 48;
                                        i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
                                        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                                         i64toi32_i32$2 = i64toi32_i32$4 >> 31 | 0;
                                         $64 = i64toi32_i32$4 >> i64toi32_i32$5 | 0;
                                        } else {
                                         i64toi32_i32$2 = i64toi32_i32$4 >> i64toi32_i32$5 | 0;
                                         $64 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$5 | 0) | 0;
                                        }
                                        $74 = $64;
                                        $74$hi = i64toi32_i32$2;
                                        i64toi32_i32$2 = $35$hi;
                                        i64toi32_i32$4 = $35;
                                        i64toi32_i32$1 = -1;
                                        i64toi32_i32$3 = -1;
                                        i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
                                        i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
                                        if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
                                         i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
                                        }
                                        i64toi32_i32$4 = i64toi32_i32$5;
                                        i64toi32_i32$3 = Math_clz32(i64toi32_i32$0);
                                        i64toi32_i32$2 = 0;
                                        if ((i64toi32_i32$3 | 0) == (32 | 0)) {
                                         $65 = Math_clz32(i64toi32_i32$4) + 32 | 0
                                        } else {
                                         $65 = i64toi32_i32$3
                                        }
                                        $77$hi = i64toi32_i32$2;
                                        i64toi32_i32$2 = $74$hi;
                                        i64toi32_i32$4 = $74;
                                        i64toi32_i32$0 = $77$hi;
                                        i64toi32_i32$3 = $65;
                                        i64toi32_i32$1 = i64toi32_i32$4 - i64toi32_i32$3 | 0;
                                        i64toi32_i32$6 = i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0;
                                        i64toi32_i32$5 = i64toi32_i32$6 + i64toi32_i32$0 | 0;
                                        i64toi32_i32$5 = i64toi32_i32$2 - i64toi32_i32$5 | 0;
                                        i64toi32_i32$4 = 0;
                                        i64toi32_i32$4 = __wasm_i64_mul(i64toi32_i32$1 | 0, i64toi32_i32$5 | 0, 1292913986 | 0, i64toi32_i32$4 | 0) | 0;
                                        i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
                                        i64toi32_i32$2 = i64toi32_i32$4;
                                        i64toi32_i32$4 = 19;
                                        i64toi32_i32$3 = 1142116480;
                                        i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
                                        i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
                                        if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
                                         i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
                                        }
                                        i64toi32_i32$5 = i64toi32_i32$0;
                                        i64toi32_i32$2 = 0;
                                        i64toi32_i32$3 = 32;
                                        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
                                        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                                         i64toi32_i32$2 = 0;
                                         $66 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
                                        } else {
                                         i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
                                         $66 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$4 | 0) | 0;
                                        }
                                        $7 = $66;
                                        $8 = ($7 << 16 | 0) >> 16 | 0;
                                        $9 = ($6 << 16 | 0) >> 16 | 0;
                                        $10 = $4 + 1176 | 0;
                                        label$39 : while (1) {
                                         if (($1 | 0) == (40 | 0)) {
                                          break label$33
                                         }
                                         i64toi32_i32$2 = $32$hi;
                                         HEAP32[$10 >> 2] = $32;
                                         $10 = $10 + 4 | 0;
                                         $1 = $1 + 1 | 0;
                                         i64toi32_i32$1 = $32;
                                         i64toi32_i32$5 = 0;
                                         i64toi32_i32$3 = 32;
                                         i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
                                         if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                                          i64toi32_i32$5 = 0;
                                          $67 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
                                         } else {
                                          i64toi32_i32$5 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
                                          $67 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
                                         }
                                         $32 = $67;
                                         $32$hi = i64toi32_i32$5;
                                         if (!!($32 | i64toi32_i32$5 | 0)) {
                                          continue label$39
                                         }
                                         break label$39;
                                        };
                                        $11 = memcpy($4 | 4 | 0 | 0, $4 + 1176 | 0 | 0, 160 | 0) | 0;
                                        HEAP32[$4 >> 2] = $1;
                                        $1 = 0;
                                        memset($4 + 1176 | 0 | 0, 0 | 0, 160 | 0) | 0;
                                        $10 = $4 + 1176 | 0;
                                        label$40 : while (1) {
                                         if (($1 | 0) == (40 | 0)) {
                                          break label$32
                                         }
                                         i64toi32_i32$5 = $33$hi;
                                         HEAP32[$10 >> 2] = $33;
                                         $10 = $10 + 4 | 0;
                                         $1 = $1 + 1 | 0;
                                         i64toi32_i32$2 = $33;
                                         i64toi32_i32$1 = 0;
                                         i64toi32_i32$3 = 32;
                                         i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
                                         if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                                          i64toi32_i32$1 = 0;
                                          $68 = i64toi32_i32$5 >>> i64toi32_i32$4 | 0;
                                         } else {
                                          i64toi32_i32$1 = i64toi32_i32$5 >>> i64toi32_i32$4 | 0;
                                          $68 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
                                         }
                                         $33 = $68;
                                         $33$hi = i64toi32_i32$1;
                                         if (!!($33 | i64toi32_i32$1 | 0)) {
                                          continue label$40
                                         }
                                         break label$40;
                                        };
                                        memcpy($4 + 168 | 0 | 4 | 0 | 0, $4 + 1176 | 0 | 0, 160 | 0) | 0;
                                        HEAP32[($4 + 168 | 0) >> 2] = $1;
                                        $1 = 0;
                                        memset($4 + 1176 | 0 | 0, 0 | 0, 160 | 0) | 0;
                                        $10 = $4 + 1176 | 0;
                                        label$41 : while (1) {
                                         if (($1 | 0) == (40 | 0)) {
                                          break label$31
                                         }
                                         i64toi32_i32$1 = $34$hi;
                                         HEAP32[$10 >> 2] = $34;
                                         $10 = $10 + 4 | 0;
                                         $1 = $1 + 1 | 0;
                                         i64toi32_i32$5 = $34;
                                         i64toi32_i32$2 = 0;
                                         i64toi32_i32$3 = 32;
                                         i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
                                         if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                                          i64toi32_i32$2 = 0;
                                          $69 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
                                         } else {
                                          i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
                                          $69 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$4 | 0) | 0;
                                         }
                                         $34 = $69;
                                         $34$hi = i64toi32_i32$2;
                                         if (!!($34 | i64toi32_i32$2 | 0)) {
                                          continue label$41
                                         }
                                         break label$41;
                                        };
                                        memcpy($4 + 336 | 0 | 4 | 0 | 0, $4 + 1176 | 0 | 0, 160 | 0) | 0;
                                        HEAP32[($4 + 336 | 0) >> 2] = $1;
                                        memset($4 + 512 | 0 | 0, 0 | 0, 156 | 0) | 0;
                                        i64toi32_i32$5 = $4;
                                        i64toi32_i32$2 = 1;
                                        HEAP32[($4 + 504 | 0) >> 2] = 1;
                                        HEAP32[($4 + 508 | 0) >> 2] = i64toi32_i32$2;
                                        label$42 : {
                                         label$43 : {
                                          if (($9 | 0) < (0 | 0)) {
                                           break label$43
                                          }
                                          core__num__bignum__Big32x40__mul_pow2__haaaae198d66328c2($4 | 0, $6 | 0) | 0;
                                          core__num__bignum__Big32x40__mul_pow2__haaaae198d66328c2($4 + 168 | 0 | 0, $6 | 0) | 0;
                                          core__num__bignum__Big32x40__mul_pow2__haaaae198d66328c2($4 + 336 | 0 | 0, $6 | 0) | 0;
                                          break label$42;
                                         }
                                         core__num__bignum__Big32x40__mul_pow2__haaaae198d66328c2($4 + 504 | 0 | 0, ((0 - $9 | 0) << 16 | 0) >> 16 | 0 | 0) | 0;
                                        }
                                        label$44 : {
                                         label$45 : {
                                          if (($8 | 0) > (-1 | 0)) {
                                           break label$45
                                          }
                                          $1 = ((0 - $8 | 0) << 16 | 0) >> 16 | 0;
                                          core__num__flt2dec__strategy__dragon__mul_pow10__hb4209e899a74326f($4 | 0, $1 | 0) | 0;
                                          core__num__flt2dec__strategy__dragon__mul_pow10__hb4209e899a74326f($4 + 168 | 0 | 0, $1 | 0) | 0;
                                          core__num__flt2dec__strategy__dragon__mul_pow10__hb4209e899a74326f($4 + 336 | 0 | 0, $1 | 0) | 0;
                                          break label$44;
                                         }
                                         core__num__flt2dec__strategy__dragon__mul_pow10__hb4209e899a74326f($4 + 504 | 0 | 0, $7 & 65535 | 0 | 0) | 0;
                                        }
                                        $12 = HEAP32[$4 >> 2] | 0;
                                        memcpy($4 + 1176 | 0 | 4 | 0 | 0, $11 | 0, 160 | 0) | 0;
                                        HEAP32[($4 + 1176 | 0) >> 2] = $12;
                                        label$46 : {
                                         label$47 : {
                                          label$48 : {
                                           $13 = HEAP32[($4 + 336 | 0) >> 2] | 0;
                                           $14 = $12 >>> 0 > $13 >>> 0 ? $12 : $13;
                                           if ($14 >>> 0 > 40 >>> 0) {
                                            break label$48
                                           }
                                           if ($14) {
                                            break label$47
                                           }
                                           $14 = 0;
                                           break label$46;
                                          }
                                          core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($14 | 0, 40 | 0, 1153020 | 0);
                                          abort();
                                         }
                                         $1 = $4 + 1176 | 0 | 4 | 0;
                                         $10 = $4 + 336 | 0 | 4 | 0;
                                         $9 = 0;
                                         $7 = $14;
                                         label$49 : while (1) {
                                          $15 = HEAP32[$1 >> 2] | 0;
                                          $6 = $15 + (HEAP32[$10 >> 2] | 0) | 0;
                                          $9 = $6 + ($9 & 1 | 0) | 0;
                                          HEAP32[$1 >> 2] = $9;
                                          $9 = $6 >>> 0 < $15 >>> 0 | $9 >>> 0 < $6 >>> 0 | 0;
                                          $1 = $1 + 4 | 0;
                                          $10 = $10 + 4 | 0;
                                          $7 = $7 + -1 | 0;
                                          if ($7) {
                                           continue label$49
                                          }
                                          break label$49;
                                         };
                                         if (!$9) {
                                          break label$46
                                         }
                                         if ($14 >>> 0 > 39 >>> 0) {
                                          break label$29
                                         }
                                         HEAP32[((($4 + 1176 | 0) + ($14 << 2 | 0) | 0) + 4 | 0) >> 2] = 1;
                                         $14 = $14 + 1 | 0;
                                        }
                                        HEAP32[($4 + 1176 | 0) >> 2] = $14;
                                        $9 = HEAP32[($4 + 504 | 0) >> 2] | 0;
                                        $1 = $9 >>> 0 > $14 >>> 0 ? $9 : $14;
                                        if ($1 >>> 0 >= 41 >>> 0) {
                                         break label$28
                                        }
                                        $1 = $1 << 2 | 0;
                                        label$50 : {
                                         label$51 : while (1) {
                                          label$52 : {
                                           if ($1) {
                                            break label$52
                                           }
                                           $10 = $1 ? -1 : 0;
                                           break label$50;
                                          }
                                          $10 = ($4 + 1176 | 0) + $1 | 0;
                                          $6 = ($4 + 504 | 0) + $1 | 0;
                                          $1 = $1 + -4 | 0;
                                          $6 = HEAP32[$6 >> 2] | 0;
                                          $10 = HEAP32[$10 >> 2] | 0;
                                          $10 = $6 >>> 0 < $10 >>> 0 ? -1 : ($6 | 0) != ($10 | 0);
                                          if (!$10) {
                                           continue label$51
                                          }
                                          break label$51;
                                         };
                                        }
                                        label$53 : {
                                         label$54 : {
                                          if (($10 | 0) < ($5 | 0)) {
                                           break label$54
                                          }
                                          if ($12 >>> 0 >= 41 >>> 0) {
                                           break label$27
                                          }
                                          label$55 : {
                                           label$56 : {
                                            if ($12) {
                                             break label$56
                                            }
                                            $12 = 0;
                                            break label$55;
                                           }
                                           $10 = $12 << 2 | 0;
                                           $6 = ($4 + $10 | 0) + 4 | 0;
                                           $1 = $4 | 4 | 0;
                                           i64toi32_i32$2 = 0;
                                           $32 = 0;
                                           $32$hi = i64toi32_i32$2;
                                           label$57 : while (1) {
                                            $329 = $1;
                                            i64toi32_i32$1 = $1;
                                            i64toi32_i32$2 = HEAP32[$1 >> 2] | 0;
                                            i64toi32_i32$5 = 0;
                                            $77 = i64toi32_i32$2;
                                            i64toi32_i32$2 = 0;
                                            i64toi32_i32$2 = __wasm_i64_mul($77 | 0, i64toi32_i32$5 | 0, 10 | 0, i64toi32_i32$2 | 0) | 0;
                                            i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
                                            $332$hi = i64toi32_i32$5;
                                            i64toi32_i32$5 = $32$hi;
                                            i64toi32_i32$5 = $332$hi;
                                            i64toi32_i32$1 = i64toi32_i32$2;
                                            i64toi32_i32$2 = $32$hi;
                                            i64toi32_i32$3 = $32;
                                            i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
                                            i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
                                            if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
                                             i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
                                            }
                                            $32 = i64toi32_i32$4;
                                            $32$hi = i64toi32_i32$0;
                                            HEAP32[$329 >> 2] = i64toi32_i32$4;
                                            $1 = $1 + 4 | 0;
                                            i64toi32_i32$5 = i64toi32_i32$4;
                                            i64toi32_i32$1 = 0;
                                            i64toi32_i32$3 = 32;
                                            i64toi32_i32$2 = i64toi32_i32$3 & 31 | 0;
                                            if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                                             i64toi32_i32$1 = 0;
                                             $70 = i64toi32_i32$0 >>> i64toi32_i32$2 | 0;
                                            } else {
                                             i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$2 | 0;
                                             $70 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$2 | 0) | 0;
                                            }
                                            $32 = $70;
                                            $32$hi = i64toi32_i32$1;
                                            $10 = $10 + -4 | 0;
                                            if ($10) {
                                             continue label$57
                                            }
                                            break label$57;
                                           };
                                           i64toi32_i32$1 = $32$hi;
                                           $1 = $32;
                                           if (!$1) {
                                            break label$55
                                           }
                                           if ($12 >>> 0 > 39 >>> 0) {
                                            break label$26
                                           }
                                           HEAP32[$6 >> 2] = $1;
                                           $12 = $12 + 1 | 0;
                                          }
                                          HEAP32[$4 >> 2] = $12;
                                          $6 = HEAP32[($4 + 168 | 0) >> 2] | 0;
                                          if ($6 >>> 0 >= 41 >>> 0) {
                                           break label$25
                                          }
                                          label$58 : {
                                           label$59 : {
                                            if ($6) {
                                             break label$59
                                            }
                                            $6 = 0;
                                            break label$58;
                                           }
                                           $10 = $6 << 2 | 0;
                                           $7 = (($4 + 168 | 0) + $10 | 0) + 4 | 0;
                                           $1 = $4 + 168 | 0 | 4 | 0;
                                           i64toi32_i32$1 = 0;
                                           $32 = 0;
                                           $32$hi = i64toi32_i32$1;
                                           label$60 : while (1) {
                                            $370 = $1;
                                            i64toi32_i32$0 = $1;
                                            i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
                                            i64toi32_i32$5 = 0;
                                            $78 = i64toi32_i32$1;
                                            i64toi32_i32$1 = 0;
                                            i64toi32_i32$1 = __wasm_i64_mul($78 | 0, i64toi32_i32$5 | 0, 10 | 0, i64toi32_i32$1 | 0) | 0;
                                            i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
                                            $373$hi = i64toi32_i32$5;
                                            i64toi32_i32$5 = $32$hi;
                                            i64toi32_i32$5 = $373$hi;
                                            i64toi32_i32$0 = i64toi32_i32$1;
                                            i64toi32_i32$1 = $32$hi;
                                            i64toi32_i32$3 = $32;
                                            i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
                                            i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
                                            if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
                                             i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
                                            }
                                            $32 = i64toi32_i32$2;
                                            $32$hi = i64toi32_i32$4;
                                            HEAP32[$370 >> 2] = i64toi32_i32$2;
                                            $1 = $1 + 4 | 0;
                                            i64toi32_i32$5 = i64toi32_i32$2;
                                            i64toi32_i32$0 = 0;
                                            i64toi32_i32$3 = 32;
                                            i64toi32_i32$1 = i64toi32_i32$3 & 31 | 0;
                                            if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                                             i64toi32_i32$0 = 0;
                                             $71 = i64toi32_i32$4 >>> i64toi32_i32$1 | 0;
                                            } else {
                                             i64toi32_i32$0 = i64toi32_i32$4 >>> i64toi32_i32$1 | 0;
                                             $71 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$1 | 0) | 0;
                                            }
                                            $32 = $71;
                                            $32$hi = i64toi32_i32$0;
                                            $10 = $10 + -4 | 0;
                                            if ($10) {
                                             continue label$60
                                            }
                                            break label$60;
                                           };
                                           i64toi32_i32$0 = $32$hi;
                                           $1 = $32;
                                           if (!$1) {
                                            break label$58
                                           }
                                           if ($6 >>> 0 > 39 >>> 0) {
                                            break label$24
                                           }
                                           HEAP32[$7 >> 2] = $1;
                                           $6 = $6 + 1 | 0;
                                          }
                                          HEAP32[($4 + 168 | 0) >> 2] = $6;
                                          if ($13 >>> 0 >= 41 >>> 0) {
                                           break label$23
                                          }
                                          label$61 : {
                                           if ($13) {
                                            break label$61
                                           }
                                           HEAP32[($4 + 336 | 0) >> 2] = 0;
                                           break label$53;
                                          }
                                          $10 = $13 << 2 | 0;
                                          $6 = (($4 + 336 | 0) + $10 | 0) + 4 | 0;
                                          $1 = $4 + 336 | 0 | 4 | 0;
                                          i64toi32_i32$0 = 0;
                                          $32 = 0;
                                          $32$hi = i64toi32_i32$0;
                                          label$62 : while (1) {
                                           $410 = $1;
                                           i64toi32_i32$4 = $1;
                                           i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
                                           i64toi32_i32$5 = 0;
                                           $79 = i64toi32_i32$0;
                                           i64toi32_i32$0 = 0;
                                           i64toi32_i32$0 = __wasm_i64_mul($79 | 0, i64toi32_i32$5 | 0, 10 | 0, i64toi32_i32$0 | 0) | 0;
                                           i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
                                           $413$hi = i64toi32_i32$5;
                                           i64toi32_i32$5 = $32$hi;
                                           i64toi32_i32$5 = $413$hi;
                                           i64toi32_i32$4 = i64toi32_i32$0;
                                           i64toi32_i32$0 = $32$hi;
                                           i64toi32_i32$3 = $32;
                                           i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
                                           i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
                                           if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
                                            i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
                                           }
                                           $32 = i64toi32_i32$1;
                                           $32$hi = i64toi32_i32$2;
                                           HEAP32[$410 >> 2] = i64toi32_i32$1;
                                           $1 = $1 + 4 | 0;
                                           i64toi32_i32$5 = i64toi32_i32$1;
                                           i64toi32_i32$4 = 0;
                                           i64toi32_i32$3 = 32;
                                           i64toi32_i32$0 = i64toi32_i32$3 & 31 | 0;
                                           if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                                            i64toi32_i32$4 = 0;
                                            $72 = i64toi32_i32$2 >>> i64toi32_i32$0 | 0;
                                           } else {
                                            i64toi32_i32$4 = i64toi32_i32$2 >>> i64toi32_i32$0 | 0;
                                            $72 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$0 | 0) | 0;
                                           }
                                           $32 = $72;
                                           $32$hi = i64toi32_i32$4;
                                           $10 = $10 + -4 | 0;
                                           if ($10) {
                                            continue label$62
                                           }
                                           break label$62;
                                          };
                                          label$63 : {
                                           i64toi32_i32$4 = $32$hi;
                                           $1 = $32;
                                           if (!$1) {
                                            break label$63
                                           }
                                           if ($13 >>> 0 > 39 >>> 0) {
                                            break label$22
                                           }
                                           HEAP32[$6 >> 2] = $1;
                                           $13 = $13 + 1 | 0;
                                          }
                                          HEAP32[($4 + 336 | 0) >> 2] = $13;
                                          break label$53;
                                         }
                                         $8 = $8 + 1 | 0;
                                        }
                                        $16 = $4 + 504 | 0 | 4 | 0;
                                        $17 = memcpy($4 + 672 | 0 | 4 | 0 | 0, $16 | 0, 160 | 0) | 0;
                                        HEAP32[($4 + 672 | 0) >> 2] = $9;
                                        core__num__bignum__Big32x40__mul_pow2__haaaae198d66328c2($4 + 672 | 0 | 0, 1 | 0) | 0;
                                        $1 = HEAP32[($4 + 504 | 0) >> 2] | 0;
                                        $18 = memcpy($4 + 840 | 0 | 4 | 0 | 0, $16 | 0, 160 | 0) | 0;
                                        HEAP32[($4 + 840 | 0) >> 2] = $1;
                                        core__num__bignum__Big32x40__mul_pow2__haaaae198d66328c2($4 + 840 | 0 | 0, 2 | 0) | 0;
                                        $1 = HEAP32[($4 + 504 | 0) >> 2] | 0;
                                        $19 = memcpy($4 + 1008 | 0 | 4 | 0 | 0, $16 | 0, 160 | 0) | 0;
                                        HEAP32[($4 + 1008 | 0) >> 2] = $1;
                                        core__num__bignum__Big32x40__mul_pow2__haaaae198d66328c2($4 + 1008 | 0 | 0, 3 | 0) | 0;
                                        label$64 : {
                                         label$65 : {
                                          $14 = HEAP32[$4 >> 2] | 0;
                                          $20 = HEAP32[($4 + 1008 | 0) >> 2] | 0;
                                          $12 = $14 >>> 0 > $20 >>> 0 ? $14 : $20;
                                          if ($12 >>> 0 > 40 >>> 0) {
                                           break label$65
                                          }
                                          $21 = $4 + 1176 | 0 | 4 | 0;
                                          $22 = $4 + 336 | 0 | 4 | 0;
                                          $23 = $4 | 4 | 0;
                                          $24 = $4 + 168 | 0 | 4 | 0;
                                          $25 = HEAP32[($4 + 504 | 0) >> 2] | 0;
                                          $26 = HEAP32[($4 + 672 | 0) >> 2] | 0;
                                          $27 = HEAP32[($4 + 840 | 0) >> 2] | 0;
                                          $28 = 0;
                                          label$66 : while (1) {
                                           $29 = $28;
                                           $1 = $12 << 2 | 0;
                                           label$67 : {
                                            label$68 : while (1) {
                                             label$69 : {
                                              if ($1) {
                                               break label$69
                                              }
                                              $10 = $1 ? -1 : 0;
                                              break label$67;
                                             }
                                             $10 = ($4 + 1008 | 0) + $1 | 0;
                                             $6 = $4 + $1 | 0;
                                             $1 = $1 + -4 | 0;
                                             $6 = HEAP32[$6 >> 2] | 0;
                                             $10 = HEAP32[$10 >> 2] | 0;
                                             $10 = $6 >>> 0 < $10 >>> 0 ? -1 : ($6 | 0) != ($10 | 0);
                                             if (!$10) {
                                              continue label$68
                                             }
                                             break label$68;
                                            };
                                           }
                                           $30 = 0;
                                           label$70 : {
                                            if (($10 & 255 | 0) >>> 0 > 1 >>> 0) {
                                             break label$70
                                            }
                                            label$71 : {
                                             if (!$12) {
                                              break label$71
                                             }
                                             $9 = 1;
                                             $1 = $23;
                                             $10 = $19;
                                             $7 = $12;
                                             label$72 : while (1) {
                                              $15 = HEAP32[$1 >> 2] | 0;
                                              $6 = $15 + ((HEAP32[$10 >> 2] | 0) ^ -1 | 0) | 0;
                                              $9 = $6 + ($9 & 1 | 0) | 0;
                                              HEAP32[$1 >> 2] = $9;
                                              $9 = $6 >>> 0 < $15 >>> 0 | $9 >>> 0 < $6 >>> 0 | 0;
                                              $1 = $1 + 4 | 0;
                                              $10 = $10 + 4 | 0;
                                              $7 = $7 + -1 | 0;
                                              if ($7) {
                                               continue label$72
                                              }
                                              break label$72;
                                             };
                                             if (!$9) {
                                              break label$21
                                             }
                                            }
                                            HEAP32[$4 >> 2] = $12;
                                            $30 = 8;
                                            $14 = $12;
                                           }
                                           $12 = $14 >>> 0 > $27 >>> 0 ? $14 : $27;
                                           if ($12 >>> 0 >= 41 >>> 0) {
                                            break label$20
                                           }
                                           $1 = $12 << 2 | 0;
                                           label$73 : {
                                            label$74 : while (1) {
                                             label$75 : {
                                              if ($1) {
                                               break label$75
                                              }
                                              $10 = $1 ? -1 : 0;
                                              break label$73;
                                             }
                                             $10 = ($4 + 840 | 0) + $1 | 0;
                                             $6 = $4 + $1 | 0;
                                             $1 = $1 + -4 | 0;
                                             $6 = HEAP32[$6 >> 2] | 0;
                                             $10 = HEAP32[$10 >> 2] | 0;
                                             $10 = $6 >>> 0 < $10 >>> 0 ? -1 : ($6 | 0) != ($10 | 0);
                                             if (!$10) {
                                              continue label$74
                                             }
                                             break label$74;
                                            };
                                           }
                                           label$76 : {
                                            label$77 : {
                                             if (($10 & 255 | 0) >>> 0 <= 1 >>> 0) {
                                              break label$77
                                             }
                                             $12 = $14;
                                             break label$76;
                                            }
                                            label$78 : {
                                             if (!$12) {
                                              break label$78
                                             }
                                             $9 = 1;
                                             $1 = $23;
                                             $10 = $18;
                                             $7 = $12;
                                             label$79 : while (1) {
                                              $15 = HEAP32[$1 >> 2] | 0;
                                              $6 = $15 + ((HEAP32[$10 >> 2] | 0) ^ -1 | 0) | 0;
                                              $9 = $6 + ($9 & 1 | 0) | 0;
                                              HEAP32[$1 >> 2] = $9;
                                              $9 = $6 >>> 0 < $15 >>> 0 | $9 >>> 0 < $6 >>> 0 | 0;
                                              $1 = $1 + 4 | 0;
                                              $10 = $10 + 4 | 0;
                                              $7 = $7 + -1 | 0;
                                              if ($7) {
                                               continue label$79
                                              }
                                              break label$79;
                                             };
                                             if (!$9) {
                                              break label$19
                                             }
                                            }
                                            HEAP32[$4 >> 2] = $12;
                                            $30 = $30 | 4 | 0;
                                           }
                                           $13 = $12 >>> 0 > $26 >>> 0 ? $12 : $26;
                                           if ($13 >>> 0 >= 41 >>> 0) {
                                            break label$18
                                           }
                                           $1 = $13 << 2 | 0;
                                           label$80 : {
                                            label$81 : while (1) {
                                             label$82 : {
                                              if ($1) {
                                               break label$82
                                              }
                                              $10 = $1 ? -1 : 0;
                                              break label$80;
                                             }
                                             $10 = ($4 + 672 | 0) + $1 | 0;
                                             $6 = $4 + $1 | 0;
                                             $1 = $1 + -4 | 0;
                                             $6 = HEAP32[$6 >> 2] | 0;
                                             $10 = HEAP32[$10 >> 2] | 0;
                                             $10 = $6 >>> 0 < $10 >>> 0 ? -1 : ($6 | 0) != ($10 | 0);
                                             if (!$10) {
                                              continue label$81
                                             }
                                             break label$81;
                                            };
                                           }
                                           label$83 : {
                                            label$84 : {
                                             if (($10 & 255 | 0) >>> 0 <= 1 >>> 0) {
                                              break label$84
                                             }
                                             $13 = $12;
                                             break label$83;
                                            }
                                            label$85 : {
                                             if (!$13) {
                                              break label$85
                                             }
                                             $9 = 1;
                                             $1 = $23;
                                             $10 = $17;
                                             $7 = $13;
                                             label$86 : while (1) {
                                              $15 = HEAP32[$1 >> 2] | 0;
                                              $6 = $15 + ((HEAP32[$10 >> 2] | 0) ^ -1 | 0) | 0;
                                              $9 = $6 + ($9 & 1 | 0) | 0;
                                              HEAP32[$1 >> 2] = $9;
                                              $9 = $6 >>> 0 < $15 >>> 0 | $9 >>> 0 < $6 >>> 0 | 0;
                                              $1 = $1 + 4 | 0;
                                              $10 = $10 + 4 | 0;
                                              $7 = $7 + -1 | 0;
                                              if ($7) {
                                               continue label$86
                                              }
                                              break label$86;
                                             };
                                             if (!$9) {
                                              break label$17
                                             }
                                            }
                                            HEAP32[$4 >> 2] = $13;
                                            $30 = $30 + 2 | 0;
                                           }
                                           $14 = $13 >>> 0 > $25 >>> 0 ? $13 : $25;
                                           if ($14 >>> 0 >= 41 >>> 0) {
                                            break label$16
                                           }
                                           $1 = $14 << 2 | 0;
                                           label$87 : {
                                            label$88 : while (1) {
                                             label$89 : {
                                              if ($1) {
                                               break label$89
                                              }
                                              $10 = $1 ? -1 : 0;
                                              break label$87;
                                             }
                                             $10 = ($4 + 504 | 0) + $1 | 0;
                                             $6 = $4 + $1 | 0;
                                             $1 = $1 + -4 | 0;
                                             $6 = HEAP32[$6 >> 2] | 0;
                                             $10 = HEAP32[$10 >> 2] | 0;
                                             $10 = $6 >>> 0 < $10 >>> 0 ? -1 : ($6 | 0) != ($10 | 0);
                                             if (!$10) {
                                              continue label$88
                                             }
                                             break label$88;
                                            };
                                           }
                                           label$90 : {
                                            label$91 : {
                                             if (($10 & 255 | 0) >>> 0 <= 1 >>> 0) {
                                              break label$91
                                             }
                                             $14 = $13;
                                             break label$90;
                                            }
                                            label$92 : {
                                             if (!$14) {
                                              break label$92
                                             }
                                             $9 = 1;
                                             $1 = $23;
                                             $10 = $16;
                                             $7 = $14;
                                             label$93 : while (1) {
                                              $15 = HEAP32[$1 >> 2] | 0;
                                              $6 = $15 + ((HEAP32[$10 >> 2] | 0) ^ -1 | 0) | 0;
                                              $9 = $6 + ($9 & 1 | 0) | 0;
                                              HEAP32[$1 >> 2] = $9;
                                              $9 = $6 >>> 0 < $15 >>> 0 | $9 >>> 0 < $6 >>> 0 | 0;
                                              $1 = $1 + 4 | 0;
                                              $10 = $10 + 4 | 0;
                                              $7 = $7 + -1 | 0;
                                              if ($7) {
                                               continue label$93
                                              }
                                              break label$93;
                                             };
                                             if (!$9) {
                                              break label$15
                                             }
                                            }
                                            HEAP32[$4 >> 2] = $14;
                                            $30 = $30 + 1 | 0;
                                           }
                                           if (($29 | 0) == ($3 | 0)) {
                                            break label$11
                                           }
                                           HEAP8[($2 + $29 | 0) >> 0] = $30 + 48 | 0;
                                           $30 = HEAP32[($4 + 168 | 0) >> 2] | 0;
                                           $1 = $14 >>> 0 > $30 >>> 0 ? $14 : $30;
                                           if ($1 >>> 0 >= 41 >>> 0) {
                                            break label$14
                                           }
                                           $28 = $29 + 1 | 0;
                                           $1 = $1 << 2 | 0;
                                           label$94 : {
                                            label$95 : while (1) {
                                             label$96 : {
                                              if ($1) {
                                               break label$96
                                              }
                                              $12 = $1 ? -1 : 0;
                                              break label$94;
                                             }
                                             $10 = ($4 + 168 | 0) + $1 | 0;
                                             $6 = $4 + $1 | 0;
                                             $1 = $1 + -4 | 0;
                                             $6 = HEAP32[$6 >> 2] | 0;
                                             $10 = HEAP32[$10 >> 2] | 0;
                                             $12 = $6 >>> 0 < $10 >>> 0 ? -1 : ($6 | 0) != ($10 | 0);
                                             if (!$12) {
                                              continue label$95
                                             }
                                             break label$95;
                                            };
                                           }
                                           $1 = memcpy($21 | 0, $11 | 0, 160 | 0) | 0;
                                           HEAP32[($4 + 1176 | 0) >> 2] = $14;
                                           label$97 : {
                                            label$98 : {
                                             label$99 : {
                                              $31 = HEAP32[($4 + 336 | 0) >> 2] | 0;
                                              $13 = $14 >>> 0 > $31 >>> 0 ? $14 : $31;
                                              if ($13 >>> 0 > 40 >>> 0) {
                                               break label$99
                                              }
                                              if ($13) {
                                               break label$98
                                              }
                                              $13 = 0;
                                              break label$97;
                                             }
                                             core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($13 | 0, 40 | 0, 1153020 | 0);
                                             abort();
                                            }
                                            $9 = 0;
                                            $10 = $22;
                                            $7 = $13;
                                            label$100 : while (1) {
                                             $15 = HEAP32[$1 >> 2] | 0;
                                             $6 = $15 + (HEAP32[$10 >> 2] | 0) | 0;
                                             $9 = $6 + ($9 & 1 | 0) | 0;
                                             HEAP32[$1 >> 2] = $9;
                                             $9 = $6 >>> 0 < $15 >>> 0 | $9 >>> 0 < $6 >>> 0 | 0;
                                             $1 = $1 + 4 | 0;
                                             $10 = $10 + 4 | 0;
                                             $7 = $7 + -1 | 0;
                                             if ($7) {
                                              continue label$100
                                             }
                                             break label$100;
                                            };
                                            if (!$9) {
                                             break label$97
                                            }
                                            if ($13 >>> 0 > 39 >>> 0) {
                                             break label$13
                                            }
                                            HEAP32[((($4 + 1176 | 0) + ($13 << 2 | 0) | 0) + 4 | 0) >> 2] = 1;
                                            $13 = $13 + 1 | 0;
                                           }
                                           HEAP32[($4 + 1176 | 0) >> 2] = $13;
                                           $1 = $25 >>> 0 > $13 >>> 0 ? $25 : $13;
                                           if ($1 >>> 0 >= 41 >>> 0) {
                                            break label$12
                                           }
                                           $1 = $1 << 2 | 0;
                                           label$101 : {
                                            label$102 : while (1) {
                                             label$103 : {
                                              if ($1) {
                                               break label$103
                                              }
                                              $10 = $1 ? -1 : 0;
                                              break label$101;
                                             }
                                             $10 = ($4 + 1176 | 0) + $1 | 0;
                                             $6 = ($4 + 504 | 0) + $1 | 0;
                                             $1 = $1 + -4 | 0;
                                             $6 = HEAP32[$6 >> 2] | 0;
                                             $10 = HEAP32[$10 >> 2] | 0;
                                             $10 = $6 >>> 0 < $10 >>> 0 ? -1 : ($6 | 0) != ($10 | 0);
                                             if (!$10) {
                                              continue label$102
                                             }
                                             break label$102;
                                            };
                                           }
                                           if (($12 | 0) < ($5 | 0)) {
                                            break label$64
                                           }
                                           if (($10 | 0) < ($5 | 0)) {
                                            break label$64
                                           }
                                           if ($14 >>> 0 >= 41 >>> 0) {
                                            break label$10
                                           }
                                           label$104 : {
                                            label$105 : {
                                             if ($14) {
                                              break label$105
                                             }
                                             $14 = 0;
                                             break label$104;
                                            }
                                            $10 = $14 << 2 | 0;
                                            $6 = ($4 + $10 | 0) + 4 | 0;
                                            i64toi32_i32$4 = 0;
                                            $32 = 0;
                                            $32$hi = i64toi32_i32$4;
                                            $1 = $23;
                                            label$106 : while (1) {
                                             $962 = $1;
                                             i64toi32_i32$2 = $1;
                                             i64toi32_i32$4 = HEAP32[$1 >> 2] | 0;
                                             i64toi32_i32$5 = 0;
                                             $80 = i64toi32_i32$4;
                                             i64toi32_i32$4 = 0;
                                             i64toi32_i32$4 = __wasm_i64_mul($80 | 0, i64toi32_i32$5 | 0, 10 | 0, i64toi32_i32$4 | 0) | 0;
                                             i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
                                             $965$hi = i64toi32_i32$5;
                                             i64toi32_i32$5 = $32$hi;
                                             i64toi32_i32$5 = $965$hi;
                                             i64toi32_i32$2 = i64toi32_i32$4;
                                             i64toi32_i32$4 = $32$hi;
                                             i64toi32_i32$3 = $32;
                                             i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
                                             i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
                                             if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
                                              i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
                                             }
                                             $32 = i64toi32_i32$0;
                                             $32$hi = i64toi32_i32$1;
                                             HEAP32[$962 >> 2] = i64toi32_i32$0;
                                             $1 = $1 + 4 | 0;
                                             i64toi32_i32$5 = i64toi32_i32$0;
                                             i64toi32_i32$2 = 0;
                                             i64toi32_i32$3 = 32;
                                             i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
                                             if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                                              i64toi32_i32$2 = 0;
                                              $73 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
                                             } else {
                                              i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
                                              $73 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$4 | 0) | 0;
                                             }
                                             $32 = $73;
                                             $32$hi = i64toi32_i32$2;
                                             $10 = $10 + -4 | 0;
                                             if ($10) {
                                              continue label$106
                                             }
                                             break label$106;
                                            };
                                            i64toi32_i32$2 = $32$hi;
                                            $1 = $32;
                                            if (!$1) {
                                             break label$104
                                            }
                                            if ($14 >>> 0 > 39 >>> 0) {
                                             break label$9
                                            }
                                            HEAP32[$6 >> 2] = $1;
                                            $14 = $14 + 1 | 0;
                                           }
                                           HEAP32[$4 >> 2] = $14;
                                           if ($30 >>> 0 >= 41 >>> 0) {
                                            break label$8
                                           }
                                           label$107 : {
                                            label$108 : {
                                             if ($30) {
                                              break label$108
                                             }
                                             $30 = 0;
                                             break label$107;
                                            }
                                            $10 = $30 << 2 | 0;
                                            $6 = (($4 + 168 | 0) + $10 | 0) + 4 | 0;
                                            i64toi32_i32$2 = 0;
                                            $32 = 0;
                                            $32$hi = i64toi32_i32$2;
                                            $1 = $24;
                                            label$109 : while (1) {
                                             $999 = $1;
                                             i64toi32_i32$1 = $1;
                                             i64toi32_i32$2 = HEAP32[$1 >> 2] | 0;
                                             i64toi32_i32$5 = 0;
                                             $81 = i64toi32_i32$2;
                                             i64toi32_i32$2 = 0;
                                             i64toi32_i32$2 = __wasm_i64_mul($81 | 0, i64toi32_i32$5 | 0, 10 | 0, i64toi32_i32$2 | 0) | 0;
                                             i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
                                             $1002$hi = i64toi32_i32$5;
                                             i64toi32_i32$5 = $32$hi;
                                             i64toi32_i32$5 = $1002$hi;
                                             i64toi32_i32$1 = i64toi32_i32$2;
                                             i64toi32_i32$2 = $32$hi;
                                             i64toi32_i32$3 = $32;
                                             i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
                                             i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
                                             if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
                                              i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
                                             }
                                             $32 = i64toi32_i32$4;
                                             $32$hi = i64toi32_i32$0;
                                             HEAP32[$999 >> 2] = i64toi32_i32$4;
                                             $1 = $1 + 4 | 0;
                                             i64toi32_i32$5 = i64toi32_i32$4;
                                             i64toi32_i32$1 = 0;
                                             i64toi32_i32$3 = 32;
                                             i64toi32_i32$2 = i64toi32_i32$3 & 31 | 0;
                                             if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                                              i64toi32_i32$1 = 0;
                                              $75 = i64toi32_i32$0 >>> i64toi32_i32$2 | 0;
                                             } else {
                                              i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$2 | 0;
                                              $75 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$2 | 0) | 0;
                                             }
                                             $32 = $75;
                                             $32$hi = i64toi32_i32$1;
                                             $10 = $10 + -4 | 0;
                                             if ($10) {
                                              continue label$109
                                             }
                                             break label$109;
                                            };
                                            i64toi32_i32$1 = $32$hi;
                                            $1 = $32;
                                            if (!$1) {
                                             break label$107
                                            }
                                            if ($30 >>> 0 > 39 >>> 0) {
                                             break label$7
                                            }
                                            HEAP32[$6 >> 2] = $1;
                                            $30 = $30 + 1 | 0;
                                           }
                                           HEAP32[($4 + 168 | 0) >> 2] = $30;
                                           if ($31 >>> 0 >= 41 >>> 0) {
                                            break label$6
                                           }
                                           label$110 : {
                                            label$111 : {
                                             if ($31) {
                                              break label$111
                                             }
                                             $31 = 0;
                                             break label$110;
                                            }
                                            $10 = $31 << 2 | 0;
                                            $6 = (($4 + 336 | 0) + $10 | 0) + 4 | 0;
                                            i64toi32_i32$1 = 0;
                                            $32 = 0;
                                            $32$hi = i64toi32_i32$1;
                                            $1 = $22;
                                            label$112 : while (1) {
                                             $1036 = $1;
                                             i64toi32_i32$0 = $1;
                                             i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
                                             i64toi32_i32$5 = 0;
                                             $82 = i64toi32_i32$1;
                                             i64toi32_i32$1 = 0;
                                             i64toi32_i32$1 = __wasm_i64_mul($82 | 0, i64toi32_i32$5 | 0, 10 | 0, i64toi32_i32$1 | 0) | 0;
                                             i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
                                             $1039$hi = i64toi32_i32$5;
                                             i64toi32_i32$5 = $32$hi;
                                             i64toi32_i32$5 = $1039$hi;
                                             i64toi32_i32$0 = i64toi32_i32$1;
                                             i64toi32_i32$1 = $32$hi;
                                             i64toi32_i32$3 = $32;
                                             i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
                                             i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
                                             if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
                                              i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
                                             }
                                             $32 = i64toi32_i32$2;
                                             $32$hi = i64toi32_i32$4;
                                             HEAP32[$1036 >> 2] = i64toi32_i32$2;
                                             $1 = $1 + 4 | 0;
                                             i64toi32_i32$5 = i64toi32_i32$2;
                                             i64toi32_i32$0 = 0;
                                             i64toi32_i32$3 = 32;
                                             i64toi32_i32$1 = i64toi32_i32$3 & 31 | 0;
                                             if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                                              i64toi32_i32$0 = 0;
                                              $76 = i64toi32_i32$4 >>> i64toi32_i32$1 | 0;
                                             } else {
                                              i64toi32_i32$0 = i64toi32_i32$4 >>> i64toi32_i32$1 | 0;
                                              $76 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$1 | 0) | 0;
                                             }
                                             $32 = $76;
                                             $32$hi = i64toi32_i32$0;
                                             $10 = $10 + -4 | 0;
                                             if ($10) {
                                              continue label$112
                                             }
                                             break label$112;
                                            };
                                            i64toi32_i32$0 = $32$hi;
                                            $1 = $32;
                                            if (!$1) {
                                             break label$110
                                            }
                                            if ($31 >>> 0 > 39 >>> 0) {
                                             break label$5
                                            }
                                            HEAP32[$6 >> 2] = $1;
                                            $31 = $31 + 1 | 0;
                                           }
                                           HEAP32[($4 + 336 | 0) >> 2] = $31;
                                           $12 = $14 >>> 0 > $20 >>> 0 ? $14 : $20;
                                           if ($12 >>> 0 <= 40 >>> 0) {
                                            continue label$66
                                           }
                                           break label$66;
                                          };
                                         }
                                         core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($12 | 0, 40 | 0, 1153020 | 0);
                                         abort();
                                        }
                                        label$113 : {
                                         if (($10 | 0) >= ($5 | 0)) {
                                          break label$113
                                         }
                                         label$114 : {
                                          if (($12 | 0) >= ($5 | 0)) {
                                           break label$114
                                          }
                                          core__num__bignum__Big32x40__mul_pow2__haaaae198d66328c2($4 | 0, 1 | 0) | 0;
                                          $1 = HEAP32[$4 >> 2] | 0;
                                          $10 = HEAP32[($4 + 504 | 0) >> 2] | 0;
                                          $1 = $1 >>> 0 > $10 >>> 0 ? $1 : $10;
                                          if ($1 >>> 0 >= 41 >>> 0) {
                                           break label$4
                                          }
                                          $1 = $1 << 2 | 0;
                                          label$115 : {
                                           label$116 : while (1) {
                                            label$117 : {
                                             if ($1) {
                                              break label$117
                                             }
                                             $10 = $1 ? -1 : 0;
                                             break label$115;
                                            }
                                            $10 = ($4 + 504 | 0) + $1 | 0;
                                            $6 = $4 + $1 | 0;
                                            $1 = $1 + -4 | 0;
                                            $6 = HEAP32[$6 >> 2] | 0;
                                            $10 = HEAP32[$10 >> 2] | 0;
                                            $10 = $6 >>> 0 < $10 >>> 0 ? -1 : ($6 | 0) != ($10 | 0);
                                            if (!$10) {
                                             continue label$116
                                            }
                                            break label$116;
                                           };
                                          }
                                          if (($10 & 255 | 0) >>> 0 > 1 >>> 0) {
                                           break label$113
                                          }
                                         }
                                         if ($29 >>> 0 >= $3 >>> 0) {
                                          break label$3
                                         }
                                         $7 = $2 + $28 | 0;
                                         $10 = -1;
                                         $1 = $29;
                                         label$118 : {
                                          label$119 : while (1) {
                                           if (($1 | 0) == (-1 | 0)) {
                                            break label$118
                                           }
                                           $10 = $10 + 1 | 0;
                                           $6 = $2 + $1 | 0;
                                           $9 = $1 + -1 | 0;
                                           $1 = $9;
                                           if ((HEAPU8[$6 >> 0] | 0 | 0) == (57 | 0)) {
                                            continue label$119
                                           }
                                           break label$119;
                                          };
                                          $6 = $2 + $9 | 0;
                                          $1 = $6 + 1 | 0;
                                          HEAP8[$1 >> 0] = (HEAPU8[$1 >> 0] | 0) + 1 | 0;
                                          if ($29 >>> 0 < ($9 + 2 | 0) >>> 0) {
                                           break label$113
                                          }
                                          memset($6 + 2 | 0 | 0, 48 | 0, $10 | 0) | 0;
                                          break label$113;
                                         }
                                         HEAP8[$2 >> 0] = 49;
                                         label$120 : {
                                          if (!$29) {
                                           break label$120
                                          }
                                          memset($2 + 1 | 0 | 0, 48 | 0, $29 | 0) | 0;
                                         }
                                         if ($28 >>> 0 >= $3 >>> 0) {
                                          break label$2
                                         }
                                         HEAP8[$7 >> 0] = 48;
                                         $8 = $8 + 1 | 0;
                                         $28 = $29 + 2 | 0;
                                        }
                                        if ($28 >>> 0 > $3 >>> 0) {
                                         break label$1
                                        }
                                        HEAP16[($0 + 8 | 0) >> 1] = $8;
                                        HEAP32[($0 + 4 | 0) >> 2] = $28;
                                        HEAP32[$0 >> 2] = $2;
                                        global$0 = $4 + 1344 | 0;
                                        return;
                                       }
                                       core__panicking__panic__h2fd385a887c8bf13(1146679 | 0, 28 | 0, 1146708 | 0);
                                       abort();
                                      }
                                      core__panicking__panic__h2fd385a887c8bf13(1146724 | 0, 29 | 0, 1146756 | 0);
                                      abort();
                                     }
                                     core__panicking__panic__h2fd385a887c8bf13(1146772 | 0, 28 | 0, 1146800 | 0);
                                     abort();
                                    }
                                    core__panicking__panic__h2fd385a887c8bf13(1146816 | 0, 54 | 0, 1146872 | 0);
                                    abort();
                                   }
                                   core__panicking__panic__h2fd385a887c8bf13(1146888 | 0, 55 | 0, 1146944 | 0);
                                   abort();
                                  }
                                  core__panicking__panic_bounds_check__h808b524af17640b1(40 | 0, 40 | 0, 1153020 | 0);
                                  abort();
                                 }
                                 core__panicking__panic_bounds_check__h808b524af17640b1(40 | 0, 40 | 0, 1153020 | 0);
                                 abort();
                                }
                                core__panicking__panic_bounds_check__h808b524af17640b1(40 | 0, 40 | 0, 1153020 | 0);
                                abort();
                               }
                               core__panicking__panic__h2fd385a887c8bf13(1146960 | 0, 45 | 0, 1147008 | 0);
                               abort();
                              }
                              core__panicking__panic_bounds_check__h808b524af17640b1($14 | 0, 40 | 0, 1153020 | 0);
                              abort();
                             }
                             core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($1 | 0, 40 | 0, 1153020 | 0);
                             abort();
                            }
                            core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($12 | 0, 40 | 0, 1153020 | 0);
                            abort();
                           }
                           core__panicking__panic_bounds_check__h808b524af17640b1($12 | 0, 40 | 0, 1153020 | 0);
                           abort();
                          }
                          core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($6 | 0, 40 | 0, 1153020 | 0);
                          abort();
                         }
                         core__panicking__panic_bounds_check__h808b524af17640b1($6 | 0, 40 | 0, 1153020 | 0);
                         abort();
                        }
                        core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($13 | 0, 40 | 0, 1153020 | 0);
                        abort();
                       }
                       core__panicking__panic_bounds_check__h808b524af17640b1($13 | 0, 40 | 0, 1153020 | 0);
                       abort();
                      }
                      core__panicking__panic__h2fd385a887c8bf13(1153036 | 0, 26 | 0, 1153020 | 0);
                      abort();
                     }
                     core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($12 | 0, 40 | 0, 1153020 | 0);
                     abort();
                    }
                    core__panicking__panic__h2fd385a887c8bf13(1153036 | 0, 26 | 0, 1153020 | 0);
                    abort();
                   }
                   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($13 | 0, 40 | 0, 1153020 | 0);
                   abort();
                  }
                  core__panicking__panic__h2fd385a887c8bf13(1153036 | 0, 26 | 0, 1153020 | 0);
                  abort();
                 }
                 core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($14 | 0, 40 | 0, 1153020 | 0);
                 abort();
                }
                core__panicking__panic__h2fd385a887c8bf13(1153036 | 0, 26 | 0, 1153020 | 0);
                abort();
               }
               core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($1 | 0, 40 | 0, 1153020 | 0);
               abort();
              }
              core__panicking__panic_bounds_check__h808b524af17640b1($13 | 0, 40 | 0, 1153020 | 0);
              abort();
             }
             core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($1 | 0, 40 | 0, 1153020 | 0);
             abort();
            }
            core__panicking__panic_bounds_check__h808b524af17640b1($3 | 0, $3 | 0, 1147024 | 0);
            abort();
           }
           core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($14 | 0, 40 | 0, 1153020 | 0);
           abort();
          }
          core__panicking__panic_bounds_check__h808b524af17640b1($14 | 0, 40 | 0, 1153020 | 0);
          abort();
         }
         core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($30 | 0, 40 | 0, 1153020 | 0);
         abort();
        }
        core__panicking__panic_bounds_check__h808b524af17640b1($30 | 0, 40 | 0, 1153020 | 0);
        abort();
       }
       core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($31 | 0, 40 | 0, 1153020 | 0);
       abort();
      }
      core__panicking__panic_bounds_check__h808b524af17640b1($31 | 0, 40 | 0, 1153020 | 0);
      abort();
     }
     core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($1 | 0, 40 | 0, 1153020 | 0);
     abort();
    }
    core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($28 | 0, $3 | 0, 1147040 | 0);
    abort();
   }
   core__panicking__panic_bounds_check__h808b524af17640b1($28 | 0, $3 | 0, 1147056 | 0);
   abort();
  }
  core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($28 | 0, $3 | 0, 1147072 | 0);
  abort();
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__Block___deserialize__hff84de1840b80cac($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, $3 = 0, $9 = 0, $7 = 0, $5 = 0, $9$hi = 0, $11 = 0, i64toi32_i32$4 = 0, $11$hi = 0, $6 = 0, $4 = 0, $10 = 0, $10$hi = 0, $99 = 0, $100 = 0, $101 = 0, $102 = 0, $103 = 0, $104 = 0, $105 = 0, $106 = 0, $107 = 0, $108 = 0, $109 = 0, $110 = 0, $111 = 0, $112 = 0, $113 = 0, $114 = 0, $115 = 0, $116 = 0, $117 = 0, $118 = 0, $119 = 0, $120 = 0, $121 = 0, $122 = 0, $123 = 0, $124 = 0, $125 = 0, $126 = 0, $128 = 0, $129 = 0, $130 = 0, $131 = 0, $133 = 0, $134 = 0, $135 = 0, $136 = 0, $138 = 0, $139 = 0, $140 = 0, $141 = 0, $143 = 0, $144 = 0, $145 = 0, $146 = 0, $8 = 0, $147 = 0, $148 = 0, $149 = 0, $61 = 0, $69 = 0, $90 = 0, $93 = 0, $127 = 0, $132 = 0, $137 = 0, $142 = 0, $267 = 0, $274 = 0, $290 = 0, $293 = 0, $310 = 0, $315 = 0, $324 = 0, $351 = 0, $358 = 0, $378 = 0, $383 = 0, $426 = 0, $432 = 0, $449 = 0, $453 = 0, $494 = 0, $505 = 0, $524 = 0, $531 = 0, $536 = 0, $633 = 0, $639 = 0, $656 = 0, $660 = 0, $679 = 0, $684 = 0, $689 = 0, $715 = 0, $722 = 0, $740 = 0, $743 = 0, $760 = 0, $765 = 0, $777 = 0, $780 = 0, $785 = 0, $791 = 0, $795 = 0, $802 = 0, $808 = 0, $812 = 0, $829 = 0, $836 = 0, $843 = 0, $847 = 0, $877 = 0, $883 = 0, $901 = 0, $906 = 0, $1016 = 0, $1016$hi = 0, $1019 = 0, $1019$hi = 0, $1023$hi = 0, $1025$hi = 0, $1027$hi = 0, $1030 = 0, $1030$hi = 0, $1055 = 0, $1062 = 0, $1071 = 0, $1096 = 0, $1115 = 0, $1118 = 0, $1142 = 0, $1146 = 0, $1150 = 0, $1176 = 0, $1180 = 0, $1186 = 0, $1192 = 0;
  $2 = global$0 - 1888 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 1200 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = ($2 + 1200 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $9 = i64toi32_i32$0;
  $9$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 1208 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 1212 | 0) >> 2] | 0;
  $10 = i64toi32_i32$1;
  $10$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           label$10 : {
            label$11 : {
             i64toi32_i32$2 = $2;
             i64toi32_i32$0 = HEAP32[($2 + 1200 | 0) >> 2] | 0;
             i64toi32_i32$1 = HEAP32[($2 + 1204 | 0) >> 2] | 0;
             i64toi32_i32$2 = i64toi32_i32$0;
             i64toi32_i32$0 = 0;
             i64toi32_i32$3 = 1;
             if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
              break label$11
             }
             label$12 : {
              i64toi32_i32$2 = $10$hi;
              i64toi32_i32$3 = $10;
              i64toi32_i32$1 = 0;
              i64toi32_i32$0 = 1;
              if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
               break label$12
              }
              i64toi32_i32$3 = $9$hi;
              i64toi32_i32$0 = $9;
              i64toi32_i32$2 = 0;
              i64toi32_i32$1 = 5;
              if (i64toi32_i32$3 >>> 0 > i64toi32_i32$2 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$0 >>> 0 >= i64toi32_i32$1 >>> 0 | 0) | 0) {
               break label$12
              }
              $1 = 3;
              $3 = 0;
              i64toi32_i32$0 = 0;
              $11 = 0;
              $11$hi = i64toi32_i32$0;
              break label$2;
             }
             cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__Header___deserialize__hdf156fa217230f38($2 + 1200 | 0 | 0, $1 | 0);
             $3 = ($2 + 1200 | 0) + 8 | 0;
             label$13 : {
              i64toi32_i32$1 = $2;
              i64toi32_i32$0 = HEAP32[($2 + 1200 | 0) >> 2] | 0;
              i64toi32_i32$3 = HEAP32[($2 + 1204 | 0) >> 2] | 0;
              i64toi32_i32$1 = i64toi32_i32$0;
              i64toi32_i32$0 = 0;
              i64toi32_i32$2 = 1;
              if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) | 0) {
               break label$13
              }
              memcpy($2 + 1560 | 0 | 0, $3 | 0, 328 | 0) | 0;
              memcpy(($2 + 720 | 0) + 8 | 0 | 0, memcpy(($2 + 8 | 0) + 8 | 0 | 0, $2 + 1560 | 0 | 0, 328 | 0) | 0 | 0, 328 | 0) | 0;
              $3 = ($2 + 1088 | 0) + 8 | 0;
              i64toi32_i32$2 = ($2 + 720 | 0) + 40 | 0;
              i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
              i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
              $61 = i64toi32_i32$1;
              i64toi32_i32$1 = $3;
              HEAP32[i64toi32_i32$1 >> 2] = $61;
              HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
              $4 = ($2 + 1088 | 0) + 16 | 0;
              i64toi32_i32$2 = ($2 + 720 | 0) + 48 | 0;
              i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
              i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
              $69 = i64toi32_i32$3;
              i64toi32_i32$3 = $4;
              HEAP32[i64toi32_i32$3 >> 2] = $69;
              HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
              $5 = ($2 + 1128 | 0) + 8 | 0;
              HEAP32[$5 >> 2] = HEAP32[(($2 + 720 | 0) + 68 | 0) >> 2] | 0;
              HEAP32[($2 + 1176 | 0) >> 2] = HEAPU8[($2 + 729 | 0) >> 0] | 0 | ((HEAPU8[($2 + 730 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 731 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 732 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              $99 = ($2 + 720 | 0) + 12 | 0;
              $100 = HEAPU8[$99 >> 0] | 0 | ((HEAPU8[($99 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($99 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($99 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              HEAP8[($2 + 1179 | 0) >> 0] = $100;
              HEAP8[($2 + 1180 | 0) >> 0] = $100 >>> 8 | 0;
              HEAP8[($2 + 1181 | 0) >> 0] = $100 >>> 16 | 0;
              HEAP8[($2 + 1182 | 0) >> 0] = $100 >>> 24 | 0;
              i64toi32_i32$2 = ($2 + 720 | 0) + 32 | 0;
              i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
              i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
              $90 = i64toi32_i32$1;
              i64toi32_i32$1 = $2;
              HEAP32[($2 + 1088 | 0) >> 2] = $90;
              HEAP32[($2 + 1092 | 0) >> 2] = i64toi32_i32$3;
              i64toi32_i32$2 = $2;
              i64toi32_i32$3 = HEAP32[($2 + 780 | 0) >> 2] | 0;
              i64toi32_i32$1 = HEAP32[($2 + 784 | 0) >> 2] | 0;
              $93 = i64toi32_i32$3;
              i64toi32_i32$3 = $2;
              HEAP32[($2 + 1128 | 0) >> 2] = $93;
              HEAP32[($2 + 1132 | 0) >> 2] = i64toi32_i32$1;
              i64toi32_i32$2 = ($2 + 720 | 0) + 16 | 0;
              i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
              i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
              $9 = i64toi32_i32$1;
              $9$hi = i64toi32_i32$3;
              $6 = HEAP32[(($2 + 720 | 0) + 56 | 0) >> 2] | 0;
              i64toi32_i32$2 = ($2 + 720 | 0) + 24 | 0;
              i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
              i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
              $11 = i64toi32_i32$3;
              $11$hi = i64toi32_i32$1;
              $7 = HEAPU8[($2 + 728 | 0) >> 0] | 0;
              memcpy(($2 + 392 | 0) + 64 | 0 | 0, $2 + 792 | 0 | 0, 264 | 0) | 0;
              i64toi32_i32$3 = ($2 + 392 | 0) + 16 | 0;
              HEAP32[i64toi32_i32$3 >> 2] = $11;
              HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
              HEAP32[(($2 + 392 | 0) + 48 | 0) >> 2] = $6;
              $6 = ($2 + 392 | 0) + 24 | 0;
              i64toi32_i32$2 = $2;
              i64toi32_i32$1 = HEAP32[($2 + 1088 | 0) >> 2] | 0;
              i64toi32_i32$3 = HEAP32[($2 + 1092 | 0) >> 2] | 0;
              $127 = i64toi32_i32$1;
              i64toi32_i32$1 = $6;
              HEAP32[i64toi32_i32$1 >> 2] = $127;
              HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
              i64toi32_i32$2 = $3;
              i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
              i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
              $132 = i64toi32_i32$3;
              i64toi32_i32$3 = ($2 + 392 | 0) + 32 | 0;
              HEAP32[i64toi32_i32$3 >> 2] = $132;
              HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
              i64toi32_i32$2 = $4;
              i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
              i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
              $137 = i64toi32_i32$1;
              i64toi32_i32$1 = ($2 + 392 | 0) + 40 | 0;
              HEAP32[i64toi32_i32$1 >> 2] = $137;
              HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
              $4 = $2 + 444 | 0;
              i64toi32_i32$2 = $2;
              i64toi32_i32$3 = HEAP32[($2 + 1128 | 0) >> 2] | 0;
              i64toi32_i32$1 = HEAP32[($2 + 1132 | 0) >> 2] | 0;
              $142 = i64toi32_i32$3;
              i64toi32_i32$3 = $4;
              HEAP32[i64toi32_i32$3 >> 2] = $142;
              HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
              HEAP32[(($2 + 392 | 0) + 60 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
              HEAP8[($2 + 392 | 0) >> 0] = $7;
              i64toi32_i32$1 = $9$hi;
              i64toi32_i32$3 = $2;
              HEAP32[($2 + 400 | 0) >> 2] = $9;
              HEAP32[($2 + 404 | 0) >> 2] = i64toi32_i32$1;
              $101 = HEAP32[($2 + 1176 | 0) >> 2] | 0;
              HEAP8[($2 + 393 | 0) >> 0] = $101;
              HEAP8[($2 + 394 | 0) >> 0] = $101 >>> 8 | 0;
              HEAP8[($2 + 395 | 0) >> 0] = $101 >>> 16 | 0;
              HEAP8[($2 + 396 | 0) >> 0] = $101 >>> 24 | 0;
              $102 = HEAPU8[($2 + 1179 | 0) >> 0] | 0 | ((HEAPU8[($2 + 1180 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 1181 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 1182 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              HEAP8[($2 + 396 | 0) >> 0] = $102;
              HEAP8[($2 + 397 | 0) >> 0] = $102 >>> 8 | 0;
              HEAP8[($2 + 398 | 0) >> 0] = $102 >>> 16 | 0;
              HEAP8[($2 + 399 | 0) >> 0] = $102 >>> 24 | 0;
              cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__TransactionBodies___deserialize__h44087f0dae966260($2 + 1200 | 0 | 0, $1 | 0);
              label$14 : {
               label$15 : {
                label$16 : {
                 if ((HEAP32[($2 + 1200 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                  break label$16
                 }
                 $3 = HEAP32[(($2 + 1200 | 0) + 12 | 0) >> 2] | 0;
                 HEAP32[(($2 + 1560 | 0) + 12 | 0) >> 2] = $3;
                 i64toi32_i32$2 = $2;
                 i64toi32_i32$1 = HEAP32[($2 + 1204 | 0) >> 2] | 0;
                 i64toi32_i32$3 = HEAP32[($2 + 1208 | 0) >> 2] | 0;
                 $9 = i64toi32_i32$1;
                 $9$hi = i64toi32_i32$3;
                 i64toi32_i32$1 = $2;
                 HEAP32[($2 + 1564 | 0) >> 2] = $9;
                 HEAP32[($2 + 1568 | 0) >> 2] = i64toi32_i32$3;
                 HEAP8[($2 + 1091 | 0) >> 0] = $3;
                 HEAP8[($2 + 1092 | 0) >> 0] = $3 >>> 8 | 0;
                 HEAP8[($2 + 1093 | 0) >> 0] = $3 >>> 16 | 0;
                 HEAP8[($2 + 1094 | 0) >> 0] = $3 >>> 24 | 0;
                 HEAP32[($2 + 1088 | 0) >> 2] = HEAPU8[($2 + 1569 | 0) >> 0] | 0 | ((HEAPU8[($2 + 1570 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 1571 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 1572 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 HEAP32[($2 + 1056 | 0) >> 2] = $9;
                 $3 = ($2 + 1560 | 0) + 8 | 0;
                 HEAP8[($2 + 1060 | 0) >> 0] = HEAPU8[$3 >> 0] | 0;
                 $103 = ($2 + 1056 | 0) + 8 | 0;
                 $104 = HEAPU8[($2 + 1091 | 0) >> 0] | 0 | ((HEAPU8[($2 + 1092 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 1093 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 1094 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 HEAP8[$103 >> 0] = $104;
                 HEAP8[($103 + 1 | 0) >> 0] = $104 >>> 8 | 0;
                 HEAP8[($103 + 2 | 0) >> 0] = $104 >>> 16 | 0;
                 HEAP8[($103 + 3 | 0) >> 0] = $104 >>> 24 | 0;
                 $105 = HEAP32[($2 + 1088 | 0) >> 2] | 0;
                 HEAP8[($2 + 1061 | 0) >> 0] = $105;
                 HEAP8[($2 + 1062 | 0) >> 0] = $105 >>> 8 | 0;
                 HEAP8[($2 + 1063 | 0) >> 0] = $105 >>> 16 | 0;
                 HEAP8[($2 + 1064 | 0) >> 0] = $105 >>> 24 | 0;
                 cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__TransactionWitnessSets___deserialize__hdc8da232218df49c($2 + 1200 | 0 | 0, $1 | 0);
                 if ((HEAP32[($2 + 1200 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                  break label$15
                 }
                 $5 = ($2 + 1560 | 0) + 12 | 0;
                 $7 = HEAP32[(($2 + 1200 | 0) + 12 | 0) >> 2] | 0;
                 HEAP32[$5 >> 2] = $7;
                 i64toi32_i32$2 = $2;
                 i64toi32_i32$3 = HEAP32[($2 + 1204 | 0) >> 2] | 0;
                 i64toi32_i32$1 = HEAP32[($2 + 1208 | 0) >> 2] | 0;
                 $9 = i64toi32_i32$3;
                 $9$hi = i64toi32_i32$1;
                 i64toi32_i32$3 = $2;
                 HEAP32[($2 + 1564 | 0) >> 2] = $9;
                 HEAP32[($2 + 1568 | 0) >> 2] = i64toi32_i32$1;
                 HEAP8[($2 + 1091 | 0) >> 0] = $7;
                 HEAP8[($2 + 1092 | 0) >> 0] = $7 >>> 8 | 0;
                 HEAP8[($2 + 1093 | 0) >> 0] = $7 >>> 16 | 0;
                 HEAP8[($2 + 1094 | 0) >> 0] = $7 >>> 24 | 0;
                 HEAP32[($2 + 1088 | 0) >> 2] = HEAPU8[($2 + 1569 | 0) >> 0] | 0 | ((HEAPU8[($2 + 1570 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 1571 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 1572 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 HEAP32[($2 + 1072 | 0) >> 2] = $9;
                 HEAP8[($2 + 1076 | 0) >> 0] = HEAPU8[$3 >> 0] | 0;
                 $106 = ($2 + 1072 | 0) + 8 | 0;
                 $107 = HEAPU8[($2 + 1091 | 0) >> 0] | 0 | ((HEAPU8[($2 + 1092 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 1093 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 1094 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 HEAP8[$106 >> 0] = $107;
                 HEAP8[($106 + 1 | 0) >> 0] = $107 >>> 8 | 0;
                 HEAP8[($106 + 2 | 0) >> 0] = $107 >>> 16 | 0;
                 HEAP8[($106 + 3 | 0) >> 0] = $107 >>> 24 | 0;
                 $108 = HEAP32[($2 + 1088 | 0) >> 2] | 0;
                 HEAP8[($2 + 1077 | 0) >> 0] = $108;
                 HEAP8[($2 + 1078 | 0) >> 0] = $108 >>> 8 | 0;
                 HEAP8[($2 + 1079 | 0) >> 0] = $108 >>> 16 | 0;
                 HEAP8[($2 + 1080 | 0) >> 0] = $108 >>> 24 | 0;
                 cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__AuxiliaryDataSet___deserialize__h00174ab6053c7df7($2 + 1200 | 0 | 0, $1 | 0);
                 $3 = ($2 + 1200 | 0) + 8 | 0;
                 i64toi32_i32$2 = $2;
                 i64toi32_i32$1 = HEAP32[($2 + 1200 | 0) >> 2] | 0;
                 i64toi32_i32$3 = HEAP32[($2 + 1204 | 0) >> 2] | 0;
                 i64toi32_i32$2 = i64toi32_i32$1;
                 i64toi32_i32$1 = 0;
                 i64toi32_i32$0 = 1;
                 if ((i64toi32_i32$2 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$3 | 0) != (i64toi32_i32$1 | 0) | 0) {
                  break label$14
                 }
                 memcpy($2 + 8 | 0 | 0, $3 | 0, 64 | 0) | 0;
                 memcpy($2 + 1200 | 0 | 0, memcpy(($2 + 720 | 0) + 8 | 0 | 0, $2 + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
                 cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e(($2 + 1560 | 0) + 8 | 0 | 0, $2 + 1200 | 0 | 0, 1052720 | 0, 18 | 0);
                 $4 = ($2 + 1128 | 0) + 8 | 0;
                 i64toi32_i32$0 = $2 + 1600 | 0;
                 i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                 i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                 $267 = i64toi32_i32$2;
                 i64toi32_i32$2 = $4;
                 HEAP32[i64toi32_i32$2 >> 2] = $267;
                 HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                 $6 = ($2 + 1128 | 0) + 16 | 0;
                 i64toi32_i32$0 = $2 + 1608 | 0;
                 i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                 i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                 $274 = i64toi32_i32$3;
                 i64toi32_i32$3 = $6;
                 HEAP32[i64toi32_i32$3 >> 2] = $274;
                 HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                 HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 1628 | 0) >> 2] | 0;
                 HEAP32[($2 + 1176 | 0) >> 2] = HEAPU8[($2 + 1569 | 0) >> 0] | 0 | ((HEAPU8[($2 + 1570 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 1571 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 1572 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 $109 = HEAPU8[$5 >> 0] | 0 | ((HEAPU8[($5 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($5 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($5 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 HEAP8[($2 + 1179 | 0) >> 0] = $109;
                 HEAP8[($2 + 1180 | 0) >> 0] = $109 >>> 8 | 0;
                 HEAP8[($2 + 1181 | 0) >> 0] = $109 >>> 16 | 0;
                 HEAP8[($2 + 1182 | 0) >> 0] = $109 >>> 24 | 0;
                 i64toi32_i32$0 = $2 + 1592 | 0;
                 i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                 i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                 $290 = i64toi32_i32$2;
                 i64toi32_i32$2 = $2;
                 HEAP32[($2 + 1128 | 0) >> 2] = $290;
                 HEAP32[($2 + 1132 | 0) >> 2] = i64toi32_i32$3;
                 i64toi32_i32$0 = $2;
                 i64toi32_i32$3 = HEAP32[($2 + 1620 | 0) >> 2] | 0;
                 i64toi32_i32$2 = HEAP32[($2 + 1624 | 0) >> 2] | 0;
                 $293 = i64toi32_i32$3;
                 i64toi32_i32$3 = $2;
                 HEAP32[($2 + 8 | 0) >> 2] = $293;
                 HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$2;
                 i64toi32_i32$0 = ($2 + 1560 | 0) + 16 | 0;
                 i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                 i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                 $9 = i64toi32_i32$2;
                 $9$hi = i64toi32_i32$3;
                 i64toi32_i32$0 = $2 + 1584 | 0;
                 i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                 i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                 $11 = i64toi32_i32$3;
                 $11$hi = i64toi32_i32$2;
                 $3 = HEAP32[($2 + 1616 | 0) >> 2] | 0;
                 $1 = HEAPU8[($2 + 1568 | 0) >> 0] | 0;
                 i64toi32_i32$0 = $4;
                 i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                 i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                 $310 = i64toi32_i32$2;
                 i64toi32_i32$2 = ($2 + 368 | 0) + 8 | 0;
                 HEAP32[i64toi32_i32$2 >> 2] = $310;
                 HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                 i64toi32_i32$0 = $6;
                 i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                 i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                 $315 = i64toi32_i32$3;
                 i64toi32_i32$3 = ($2 + 368 | 0) + 16 | 0;
                 HEAP32[i64toi32_i32$3 >> 2] = $315;
                 HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                 $110 = HEAPU8[($2 + 1179 | 0) >> 0] | 0 | ((HEAPU8[($2 + 1180 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 1181 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 1182 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 HEAP8[($2 + 1195 | 0) >> 0] = $110;
                 HEAP8[($2 + 1196 | 0) >> 0] = $110 >>> 8 | 0;
                 HEAP8[($2 + 1197 | 0) >> 0] = $110 >>> 16 | 0;
                 HEAP8[($2 + 1198 | 0) >> 0] = $110 >>> 24 | 0;
                 HEAP32[($2 + 1192 | 0) >> 2] = HEAP32[($2 + 1176 | 0) >> 2] | 0;
                 i64toi32_i32$0 = $2;
                 i64toi32_i32$2 = HEAP32[($2 + 1128 | 0) >> 2] | 0;
                 i64toi32_i32$3 = HEAP32[($2 + 1132 | 0) >> 2] | 0;
                 $324 = i64toi32_i32$2;
                 i64toi32_i32$2 = $2;
                 HEAP32[($2 + 368 | 0) >> 2] = $324;
                 HEAP32[($2 + 372 | 0) >> 2] = i64toi32_i32$3;
                 break label$6;
                }
                memcpy($2 + 1200 | 0 | 0, memcpy(($2 + 720 | 0) + 8 | 0 | 0, memcpy($2 + 8 | 0 | 4 | 0 | 0, ($2 + 1200 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
                $1 = ($2 + 1560 | 0) + 8 | 0;
                cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $2 + 1200 | 0 | 0, 1052678 | 0, 18 | 0);
                i64toi32_i32$0 = ($2 + 1560 | 0) + 40 | 0;
                i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                $351 = i64toi32_i32$3;
                i64toi32_i32$3 = ($2 + 368 | 0) + 8 | 0;
                HEAP32[i64toi32_i32$3 >> 2] = $351;
                HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                i64toi32_i32$0 = ($2 + 1560 | 0) + 48 | 0;
                i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                $358 = i64toi32_i32$2;
                i64toi32_i32$2 = ($2 + 368 | 0) + 16 | 0;
                HEAP32[i64toi32_i32$2 >> 2] = $358;
                HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 1560 | 0) + 68 | 0) >> 2] | 0;
                HEAP32[($2 + 1088 | 0) >> 2] = HEAPU8[($2 + 1569 | 0) >> 0] | 0 | ((HEAPU8[($2 + 1570 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 1571 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 1572 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                $111 = ($2 + 1560 | 0) + 12 | 0;
                $112 = HEAPU8[$111 >> 0] | 0 | ((HEAPU8[($111 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($111 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($111 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                HEAP8[($2 + 1091 | 0) >> 0] = $112;
                HEAP8[($2 + 1092 | 0) >> 0] = $112 >>> 8 | 0;
                HEAP8[($2 + 1093 | 0) >> 0] = $112 >>> 16 | 0;
                HEAP8[($2 + 1094 | 0) >> 0] = $112 >>> 24 | 0;
                i64toi32_i32$0 = ($2 + 1560 | 0) + 32 | 0;
                i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                $378 = i64toi32_i32$3;
                i64toi32_i32$3 = $2;
                HEAP32[($2 + 368 | 0) >> 2] = $378;
                HEAP32[($2 + 372 | 0) >> 2] = i64toi32_i32$2;
                i64toi32_i32$0 = ($2 + 1560 | 0) + 60 | 0;
                i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                $383 = i64toi32_i32$2;
                i64toi32_i32$2 = $2;
                HEAP32[($2 + 8 | 0) >> 2] = $383;
                HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$3;
                $1 = HEAPU8[$1 >> 0] | 0;
                i64toi32_i32$0 = ($2 + 1560 | 0) + 16 | 0;
                i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                $9 = i64toi32_i32$3;
                $9$hi = i64toi32_i32$2;
                i64toi32_i32$0 = ($2 + 1560 | 0) + 24 | 0;
                i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                $11 = i64toi32_i32$2;
                $11$hi = i64toi32_i32$3;
                $3 = HEAP32[(($2 + 1560 | 0) + 56 | 0) >> 2] | 0;
                $113 = HEAPU8[($2 + 1091 | 0) >> 0] | 0 | ((HEAPU8[($2 + 1092 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 1093 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 1094 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                HEAP8[($2 + 1195 | 0) >> 0] = $113;
                HEAP8[($2 + 1196 | 0) >> 0] = $113 >>> 8 | 0;
                HEAP8[($2 + 1197 | 0) >> 0] = $113 >>> 16 | 0;
                HEAP8[($2 + 1198 | 0) >> 0] = $113 >>> 24 | 0;
                HEAP32[($2 + 1192 | 0) >> 2] = HEAP32[($2 + 1088 | 0) >> 2] | 0;
                break label$3;
               }
               memcpy($2 + 1200 | 0 | 0, memcpy(($2 + 720 | 0) + 8 | 0 | 0, memcpy($2 + 8 | 0 | 4 | 0 | 0, ($2 + 1200 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
               cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($3 | 0, $2 + 1200 | 0 | 0, 1052696 | 0, 24 | 0);
               i64toi32_i32$0 = $2 + 1600 | 0;
               i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
               i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
               $426 = i64toi32_i32$3;
               i64toi32_i32$3 = ($2 + 368 | 0) + 8 | 0;
               HEAP32[i64toi32_i32$3 >> 2] = $426;
               HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
               i64toi32_i32$0 = $2 + 1608 | 0;
               i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
               i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
               $432 = i64toi32_i32$2;
               i64toi32_i32$2 = ($2 + 368 | 0) + 16 | 0;
               HEAP32[i64toi32_i32$2 >> 2] = $432;
               HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
               HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 1628 | 0) >> 2] | 0;
               HEAP32[($2 + 1088 | 0) >> 2] = HEAPU8[($2 + 1569 | 0) >> 0] | 0 | ((HEAPU8[($2 + 1570 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 1571 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 1572 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
               $114 = $2 + 1572 | 0;
               $115 = HEAPU8[$114 >> 0] | 0 | ((HEAPU8[($114 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($114 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($114 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
               HEAP8[($2 + 1091 | 0) >> 0] = $115;
               HEAP8[($2 + 1092 | 0) >> 0] = $115 >>> 8 | 0;
               HEAP8[($2 + 1093 | 0) >> 0] = $115 >>> 16 | 0;
               HEAP8[($2 + 1094 | 0) >> 0] = $115 >>> 24 | 0;
               i64toi32_i32$0 = $2 + 1592 | 0;
               i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
               i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
               $449 = i64toi32_i32$3;
               i64toi32_i32$3 = $2;
               HEAP32[($2 + 368 | 0) >> 2] = $449;
               HEAP32[($2 + 372 | 0) >> 2] = i64toi32_i32$2;
               i64toi32_i32$0 = $2 + 1620 | 0;
               i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
               i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
               $453 = i64toi32_i32$2;
               i64toi32_i32$2 = $2;
               HEAP32[($2 + 8 | 0) >> 2] = $453;
               HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$3;
               $1 = HEAPU8[$3 >> 0] | 0;
               i64toi32_i32$0 = ($2 + 1560 | 0) + 16 | 0;
               i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
               i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
               $9 = i64toi32_i32$3;
               $9$hi = i64toi32_i32$2;
               i64toi32_i32$0 = ($2 + 1560 | 0) + 24 | 0;
               i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
               i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
               $11 = i64toi32_i32$2;
               $11$hi = i64toi32_i32$3;
               $3 = HEAP32[($2 + 1616 | 0) >> 2] | 0;
               $116 = HEAPU8[($2 + 1091 | 0) >> 0] | 0 | ((HEAPU8[($2 + 1092 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 1093 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 1094 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
               HEAP8[($2 + 1195 | 0) >> 0] = $116;
               HEAP8[($2 + 1196 | 0) >> 0] = $116 >>> 8 | 0;
               HEAP8[($2 + 1197 | 0) >> 0] = $116 >>> 16 | 0;
               HEAP8[($2 + 1198 | 0) >> 0] = $116 >>> 24 | 0;
               HEAP32[($2 + 1192 | 0) >> 2] = HEAP32[($2 + 1088 | 0) >> 2] | 0;
               break label$4;
              }
              memcpy($2 + 8 | 0 | 0, $3 | 0, 40 | 0) | 0;
              $7 = memcpy(($2 + 1560 | 0) + 8 | 0 | 0, memcpy(($2 + 720 | 0) + 8 | 0 | 0, $2 + 8 | 0 | 0, 40 | 0) | 0 | 0, 40 | 0) | 0;
              $3 = ($2 + 1128 | 0) + 8 | 0;
              i64toi32_i32$0 = ($2 + 1560 | 0) + 40 | 0;
              i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
              i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
              $494 = i64toi32_i32$3;
              i64toi32_i32$3 = $3;
              HEAP32[i64toi32_i32$3 >> 2] = $494;
              HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
              $117 = HEAPU8[$5 >> 0] | 0 | ((HEAPU8[($5 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($5 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($5 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              HEAP8[($2 + 1179 | 0) >> 0] = $117;
              HEAP8[($2 + 1180 | 0) >> 0] = $117 >>> 8 | 0;
              HEAP8[($2 + 1181 | 0) >> 0] = $117 >>> 16 | 0;
              HEAP8[($2 + 1182 | 0) >> 0] = $117 >>> 24 | 0;
              HEAP32[($2 + 1176 | 0) >> 2] = HEAPU8[($2 + 1569 | 0) >> 0] | 0 | ((HEAPU8[($2 + 1570 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 1571 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 1572 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              i64toi32_i32$0 = ($2 + 1560 | 0) + 32 | 0;
              i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
              i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
              $505 = i64toi32_i32$2;
              i64toi32_i32$2 = $2;
              HEAP32[($2 + 1128 | 0) >> 2] = $505;
              HEAP32[($2 + 1132 | 0) >> 2] = i64toi32_i32$3;
              HEAP8[($2 + 1088 | 0) >> 0] = HEAPU8[($2 + 1568 | 0) >> 0] | 0;
              $118 = HEAP32[($2 + 1176 | 0) >> 2] | 0;
              HEAP8[($2 + 1089 | 0) >> 0] = $118;
              HEAP8[($2 + 1090 | 0) >> 0] = $118 >>> 8 | 0;
              HEAP8[($2 + 1091 | 0) >> 0] = $118 >>> 16 | 0;
              HEAP8[($2 + 1092 | 0) >> 0] = $118 >>> 24 | 0;
              $119 = HEAPU8[($2 + 1179 | 0) >> 0] | 0 | ((HEAPU8[($2 + 1180 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 1181 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 1182 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              HEAP8[($2 + 1092 | 0) >> 0] = $119;
              HEAP8[($2 + 1093 | 0) >> 0] = $119 >>> 8 | 0;
              HEAP8[($2 + 1094 | 0) >> 0] = $119 >>> 16 | 0;
              HEAP8[($2 + 1095 | 0) >> 0] = $119 >>> 24 | 0;
              $5 = ($2 + 1560 | 0) + 16 | 0;
              i64toi32_i32$0 = $5;
              i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
              i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
              $9 = i64toi32_i32$3;
              $9$hi = i64toi32_i32$2;
              i64toi32_i32$0 = ($2 + 1560 | 0) + 24 | 0;
              i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
              i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
              $524 = i64toi32_i32$2;
              i64toi32_i32$2 = $2;
              HEAP32[($2 + 1104 | 0) >> 2] = $524;
              HEAP32[($2 + 1108 | 0) >> 2] = i64toi32_i32$3;
              i64toi32_i32$3 = $9$hi;
              i64toi32_i32$2 = $2;
              HEAP32[($2 + 1096 | 0) >> 2] = $9;
              HEAP32[($2 + 1100 | 0) >> 2] = i64toi32_i32$3;
              i64toi32_i32$0 = $3;
              i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
              i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
              $531 = i64toi32_i32$3;
              i64toi32_i32$3 = ($2 + 1088 | 0) + 32 | 0;
              HEAP32[i64toi32_i32$3 >> 2] = $531;
              HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
              i64toi32_i32$0 = $2;
              i64toi32_i32$2 = HEAP32[($2 + 1128 | 0) >> 2] | 0;
              i64toi32_i32$3 = HEAP32[($2 + 1132 | 0) >> 2] | 0;
              $536 = i64toi32_i32$2;
              i64toi32_i32$2 = ($2 + 1088 | 0) + 24 | 0;
              HEAP32[i64toi32_i32$2 >> 2] = $536;
              HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
              i64toi32_i32$2 = $2;
              i64toi32_i32$3 = 0;
              HEAP32[($2 + 372 | 0) >> 2] = 0;
              HEAP32[($2 + 376 | 0) >> 2] = i64toi32_i32$3;
              $3 = 0;
              HEAP32[($2 + 368 | 0) >> 2] = HEAP32[(0 + 1050220 | 0) >> 2] | 0;
              cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 1200 | 0 | 0, $1 | 0);
              i64toi32_i32$0 = ($2 + 1200 | 0) + 16 | 0;
              i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
              i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
              $11 = i64toi32_i32$3;
              $11$hi = i64toi32_i32$2;
              i64toi32_i32$0 = $2;
              i64toi32_i32$2 = HEAP32[($2 + 1208 | 0) >> 2] | 0;
              i64toi32_i32$3 = HEAP32[($2 + 1212 | 0) >> 2] | 0;
              $9 = i64toi32_i32$2;
              $9$hi = i64toi32_i32$3;
              label$17 : {
               i64toi32_i32$0 = $2;
               i64toi32_i32$3 = HEAP32[($2 + 1200 | 0) >> 2] | 0;
               i64toi32_i32$2 = HEAP32[($2 + 1204 | 0) >> 2] | 0;
               i64toi32_i32$0 = i64toi32_i32$3;
               i64toi32_i32$3 = 0;
               i64toi32_i32$1 = 1;
               if ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) | 0) {
                break label$17
               }
               i64toi32_i32$0 = $11$hi;
               $7 = $11;
               label$18 : {
                i64toi32_i32$0 = $9$hi;
                i64toi32_i32$1 = $9;
                i64toi32_i32$2 = 0;
                i64toi32_i32$3 = 1;
                if ((i64toi32_i32$1 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$2 | 0) | 0) {
                 break label$18
                }
                if (!$7) {
                 break label$8
                }
               }
               label$19 : {
                label$20 : while (1) {
                 std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 | 0, $1 | 0);
                 $5 = 2;
                 $3 = 0;
                 label$21 : {
                  if (HEAP32[($2 + 4 | 0) >> 2] | 0) {
                   break label$21
                  }
                  i64toi32_i32$1 = 0;
                  $11 = 0;
                  $11$hi = i64toi32_i32$1;
                  i64toi32_i32$1 = 0;
                  $9 = 8;
                  $9$hi = i64toi32_i32$1;
                  break label$9;
                 }
                 label$22 : {
                  if ((($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[$2 >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) == (7 | 0)) {
                   break label$22
                  }
                  $T_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hf422f9333a8bbafa($2 + 1200 | 0 | 0, $1 | 0);
                  if ((HEAP32[($2 + 1200 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                   break label$19
                  }
                  $5 = HEAP32[($2 + 1204 | 0) >> 2] | 0;
                  label$23 : {
                   $3 = HEAP32[($2 + 376 | 0) >> 2] | 0;
                   if (($3 | 0) != (HEAP32[($2 + 372 | 0) >> 2] | 0 | 0)) {
                    break label$23
                   }
                   alloc__vec__Vec_T_2cA___reserve__hd6ffa03575bd5508($2 + 368 | 0 | 0, 1 | 0);
                   $3 = HEAP32[($2 + 376 | 0) >> 2] | 0;
                  }
                  HEAP32[((HEAP32[($2 + 368 | 0) >> 2] | 0) + ($3 << 2 | 0) | 0) >> 2] = $5;
                  $3 = (HEAP32[($2 + 376 | 0) >> 2] | 0) + 1 | 0;
                  HEAP32[($2 + 376 | 0) >> 2] = $3;
                  i64toi32_i32$1 = $9$hi;
                  i64toi32_i32$3 = $9;
                  i64toi32_i32$0 = 0;
                  i64toi32_i32$2 = 1;
                  if ((i64toi32_i32$3 | 0) != (i64toi32_i32$2 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$0 | 0) | 0) {
                   continue label$20
                  }
                  if ($3 >>> 0 < $7 >>> 0) {
                   continue label$20
                  }
                  break label$8;
                 }
                 break label$20;
                };
                cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 1200 | 0 | 0, $1 | 0);
                i64toi32_i32$2 = ($2 + 1200 | 0) + 16 | 0;
                i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                $11 = i64toi32_i32$3;
                $11$hi = i64toi32_i32$1;
                i64toi32_i32$2 = $2;
                i64toi32_i32$1 = HEAP32[($2 + 1208 | 0) >> 2] | 0;
                i64toi32_i32$3 = HEAP32[($2 + 1212 | 0) >> 2] | 0;
                $9 = i64toi32_i32$1;
                $9$hi = i64toi32_i32$3;
                i64toi32_i32$2 = $2;
                i64toi32_i32$3 = HEAP32[($2 + 1200 | 0) >> 2] | 0;
                i64toi32_i32$1 = HEAP32[($2 + 1204 | 0) >> 2] | 0;
                i64toi32_i32$2 = i64toi32_i32$3;
                i64toi32_i32$3 = 0;
                i64toi32_i32$0 = 1;
                if ((i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) | 0) {
                 break label$10
                }
                i64toi32_i32$2 = $11$hi;
                i64toi32_i32$1 = $2 + 1136 | 0;
                HEAP32[i64toi32_i32$1 >> 2] = $11;
                HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
                i64toi32_i32$2 = $9$hi;
                i64toi32_i32$1 = $2;
                HEAP32[($2 + 1128 | 0) >> 2] = $9;
                HEAP32[($2 + 1132 | 0) >> 2] = i64toi32_i32$2;
                if (($9 & 255 | 0 | 0) == (5 | 0)) {
                 break label$8
                }
                HEAP32[($2 + 1200 | 0) >> 2] = 0;
                core__panicking__assert_failed__h96d8431cc974b591(0 | 0, $2 + 1128 | 0 | 0, 1050312 | 0, $2 + 1200 | 0 | 0, 1052740 | 0);
                abort();
               }
               i64toi32_i32$0 = $2 + 1240 | 0;
               i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
               i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
               $633 = i64toi32_i32$2;
               i64toi32_i32$2 = ($2 + 1560 | 0) + 8 | 0;
               HEAP32[i64toi32_i32$2 >> 2] = $633;
               HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
               i64toi32_i32$0 = $2 + 1248 | 0;
               i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
               i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
               $639 = i64toi32_i32$1;
               i64toi32_i32$1 = ($2 + 1560 | 0) + 16 | 0;
               HEAP32[i64toi32_i32$1 >> 2] = $639;
               HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
               HEAP32[(($2 + 1176 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 1268 | 0) >> 2] | 0;
               HEAP32[($2 + 1192 | 0) >> 2] = HEAPU8[($2 + 1209 | 0) >> 0] | 0 | ((HEAPU8[($2 + 1210 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 1211 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 1212 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
               $120 = $2 + 1212 | 0;
               $121 = HEAPU8[$120 >> 0] | 0 | ((HEAPU8[($120 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($120 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($120 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
               HEAP8[($2 + 1195 | 0) >> 0] = $121;
               HEAP8[($2 + 1196 | 0) >> 0] = $121 >>> 8 | 0;
               HEAP8[($2 + 1197 | 0) >> 0] = $121 >>> 16 | 0;
               HEAP8[($2 + 1198 | 0) >> 0] = $121 >>> 24 | 0;
               i64toi32_i32$0 = $2 + 1232 | 0;
               i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
               i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
               $656 = i64toi32_i32$2;
               i64toi32_i32$2 = $2;
               HEAP32[($2 + 1560 | 0) >> 2] = $656;
               HEAP32[($2 + 1564 | 0) >> 2] = i64toi32_i32$1;
               i64toi32_i32$0 = $2 + 1260 | 0;
               i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
               i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
               $660 = i64toi32_i32$1;
               i64toi32_i32$1 = $2;
               HEAP32[($2 + 1176 | 0) >> 2] = $660;
               HEAP32[($2 + 1180 | 0) >> 2] = i64toi32_i32$2;
               $5 = HEAPU8[(($2 + 1200 | 0) + 8 | 0) >> 0] | 0;
               i64toi32_i32$0 = ($2 + 1200 | 0) + 16 | 0;
               i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
               i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
               $9 = i64toi32_i32$2;
               $9$hi = i64toi32_i32$1;
               i64toi32_i32$0 = $2 + 1224 | 0;
               i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
               i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
               $11 = i64toi32_i32$1;
               $11$hi = i64toi32_i32$2;
               $3 = HEAP32[($2 + 1256 | 0) >> 2] | 0;
               break label$9;
              }
              i64toi32_i32$0 = ($2 + 1200 | 0) + 32 | 0;
              i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
              i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
              $679 = i64toi32_i32$2;
              i64toi32_i32$2 = $7;
              HEAP32[i64toi32_i32$2 >> 2] = $679;
              HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
              i64toi32_i32$0 = ($2 + 1200 | 0) + 40 | 0;
              i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
              i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
              $684 = i64toi32_i32$1;
              i64toi32_i32$1 = $5;
              HEAP32[i64toi32_i32$1 >> 2] = $684;
              HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
              i64toi32_i32$0 = ($2 + 1200 | 0) + 24 | 0;
              i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
              i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
              $689 = i64toi32_i32$2;
              i64toi32_i32$2 = $2;
              HEAP32[($2 + 1560 | 0) >> 2] = $689;
              HEAP32[($2 + 1564 | 0) >> 2] = i64toi32_i32$1;
              $5 = 2;
              break label$9;
             }
             memcpy($2 + 1560 | 0 | 0, $3 | 0, 64 | 0) | 0;
             $4 = memcpy(($2 + 8 | 0) + 8 | 0 | 0, $2 + 1560 | 0 | 0, 64 | 0) | 0;
             memcpy($2 + 1200 | 0 | 0, $4 | 0, 64 | 0) | 0;
             cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e(($2 + 720 | 0) + 8 | 0 | 0, $2 + 1200 | 0 | 0, 1052672 | 0, 6 | 0);
             $5 = ($2 + 1088 | 0) + 8 | 0;
             i64toi32_i32$0 = $2 + 760 | 0;
             i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
             i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
             $715 = i64toi32_i32$1;
             i64toi32_i32$1 = $5;
             HEAP32[i64toi32_i32$1 >> 2] = $715;
             HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
             $6 = ($2 + 1088 | 0) + 16 | 0;
             i64toi32_i32$0 = $2 + 768 | 0;
             i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
             i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
             $722 = i64toi32_i32$2;
             i64toi32_i32$2 = $6;
             HEAP32[i64toi32_i32$2 >> 2] = $722;
             HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
             $7 = ($2 + 1128 | 0) + 8 | 0;
             HEAP32[$7 >> 2] = HEAP32[($2 + 788 | 0) >> 2] | 0;
             HEAP32[($2 + 1176 | 0) >> 2] = HEAPU8[($2 + 729 | 0) >> 0] | 0 | ((HEAPU8[($2 + 730 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 731 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 732 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             $122 = $2 + 732 | 0;
             $123 = HEAPU8[$122 >> 0] | 0 | ((HEAPU8[($122 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($122 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($122 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             HEAP8[($2 + 1179 | 0) >> 0] = $123;
             HEAP8[($2 + 1180 | 0) >> 0] = $123 >>> 8 | 0;
             HEAP8[($2 + 1181 | 0) >> 0] = $123 >>> 16 | 0;
             HEAP8[($2 + 1182 | 0) >> 0] = $123 >>> 24 | 0;
             i64toi32_i32$0 = $2 + 752 | 0;
             i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
             i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
             $740 = i64toi32_i32$1;
             i64toi32_i32$1 = $2;
             HEAP32[($2 + 1088 | 0) >> 2] = $740;
             HEAP32[($2 + 1092 | 0) >> 2] = i64toi32_i32$2;
             i64toi32_i32$0 = $2;
             i64toi32_i32$2 = HEAP32[($2 + 780 | 0) >> 2] | 0;
             i64toi32_i32$1 = HEAP32[($2 + 784 | 0) >> 2] | 0;
             $743 = i64toi32_i32$2;
             i64toi32_i32$2 = $2;
             HEAP32[($2 + 1128 | 0) >> 2] = $743;
             HEAP32[($2 + 1132 | 0) >> 2] = i64toi32_i32$1;
             i64toi32_i32$0 = ($2 + 720 | 0) + 16 | 0;
             i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
             i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
             $9 = i64toi32_i32$1;
             $9$hi = i64toi32_i32$2;
             i64toi32_i32$0 = $2 + 744 | 0;
             i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
             i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
             $11 = i64toi32_i32$2;
             $11$hi = i64toi32_i32$1;
             $3 = HEAP32[($2 + 776 | 0) >> 2] | 0;
             $1 = HEAPU8[($2 + 728 | 0) >> 0] | 0;
             i64toi32_i32$0 = $5;
             i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
             i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
             $760 = i64toi32_i32$1;
             i64toi32_i32$1 = ($2 + 368 | 0) + 8 | 0;
             HEAP32[i64toi32_i32$1 >> 2] = $760;
             HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
             i64toi32_i32$0 = $6;
             i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
             i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
             $765 = i64toi32_i32$2;
             i64toi32_i32$2 = ($2 + 368 | 0) + 16 | 0;
             HEAP32[i64toi32_i32$2 >> 2] = $765;
             HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
             HEAP32[$4 >> 2] = HEAP32[$7 >> 2] | 0;
             $124 = HEAPU8[($2 + 1179 | 0) >> 0] | 0 | ((HEAPU8[($2 + 1180 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 1181 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 1182 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             HEAP8[($2 + 1195 | 0) >> 0] = $124;
             HEAP8[($2 + 1196 | 0) >> 0] = $124 >>> 8 | 0;
             HEAP8[($2 + 1197 | 0) >> 0] = $124 >>> 16 | 0;
             HEAP8[($2 + 1198 | 0) >> 0] = $124 >>> 24 | 0;
             HEAP32[($2 + 1192 | 0) >> 2] = HEAP32[($2 + 1176 | 0) >> 2] | 0;
             i64toi32_i32$0 = $2;
             i64toi32_i32$1 = HEAP32[($2 + 1088 | 0) >> 2] | 0;
             i64toi32_i32$2 = HEAP32[($2 + 1092 | 0) >> 2] | 0;
             $777 = i64toi32_i32$1;
             i64toi32_i32$1 = $2;
             HEAP32[($2 + 368 | 0) >> 2] = $777;
             HEAP32[($2 + 372 | 0) >> 2] = i64toi32_i32$2;
             i64toi32_i32$0 = $2;
             i64toi32_i32$2 = HEAP32[($2 + 1128 | 0) >> 2] | 0;
             i64toi32_i32$1 = HEAP32[($2 + 1132 | 0) >> 2] | 0;
             $780 = i64toi32_i32$2;
             i64toi32_i32$2 = $2;
             HEAP32[($2 + 8 | 0) >> 2] = $780;
             HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
             break label$2;
            }
            i64toi32_i32$0 = $2 + 1232 | 0;
            i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
            i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
            $785 = i64toi32_i32$1;
            i64toi32_i32$1 = $2 + 376 | 0;
            HEAP32[i64toi32_i32$1 >> 2] = $785;
            HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
            i64toi32_i32$0 = $2 + 1240 | 0;
            i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
            i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
            $791 = i64toi32_i32$2;
            i64toi32_i32$2 = ($2 + 368 | 0) + 16 | 0;
            HEAP32[i64toi32_i32$2 >> 2] = $791;
            HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
            i64toi32_i32$0 = $2 + 1224 | 0;
            i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
            i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
            $795 = i64toi32_i32$1;
            i64toi32_i32$1 = $2;
            HEAP32[($2 + 368 | 0) >> 2] = $795;
            HEAP32[($2 + 372 | 0) >> 2] = i64toi32_i32$2;
            $1 = 2;
            $3 = 0;
            i64toi32_i32$2 = $9$hi;
            $11 = $9;
            $11$hi = i64toi32_i32$2;
            i64toi32_i32$2 = $10$hi;
            $9 = $10;
            $9$hi = i64toi32_i32$2;
            break label$2;
           }
           i64toi32_i32$0 = $2 + 1232 | 0;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $802 = i64toi32_i32$2;
           i64toi32_i32$2 = $2 + 1568 | 0;
           HEAP32[i64toi32_i32$2 >> 2] = $802;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
           i64toi32_i32$0 = $2 + 1240 | 0;
           i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $808 = i64toi32_i32$1;
           i64toi32_i32$1 = ($2 + 1560 | 0) + 16 | 0;
           HEAP32[i64toi32_i32$1 >> 2] = $808;
           HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
           i64toi32_i32$0 = $2 + 1224 | 0;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $812 = i64toi32_i32$2;
           i64toi32_i32$2 = $2;
           HEAP32[($2 + 1560 | 0) >> 2] = $812;
           HEAP32[($2 + 1564 | 0) >> 2] = i64toi32_i32$1;
          }
          $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h19f76bdb6b4883ef($2 + 368 | 0 | 0);
          $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h970b13f6299e0f2d($2 + 368 | 0 | 0);
          i64toi32_i32$1 = $11$hi;
          i64toi32_i32$2 = ($2 + 1200 | 0) + 16 | 0;
          HEAP32[i64toi32_i32$2 >> 2] = $11;
          HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
          i64toi32_i32$1 = $9$hi;
          i64toi32_i32$2 = ($2 + 1200 | 0) + 8 | 0;
          HEAP32[i64toi32_i32$2 >> 2] = $9;
          HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
          i64toi32_i32$0 = $2;
          i64toi32_i32$1 = HEAP32[($2 + 1560 | 0) >> 2] | 0;
          i64toi32_i32$2 = HEAP32[($2 + 1564 | 0) >> 2] | 0;
          $829 = i64toi32_i32$1;
          i64toi32_i32$1 = ($2 + 1200 | 0) + 24 | 0;
          HEAP32[i64toi32_i32$1 >> 2] = $829;
          HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
          i64toi32_i32$0 = ($2 + 1560 | 0) + 8 | 0;
          i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
          $836 = i64toi32_i32$2;
          i64toi32_i32$2 = ($2 + 1200 | 0) + 32 | 0;
          HEAP32[i64toi32_i32$2 >> 2] = $836;
          HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
          i64toi32_i32$0 = ($2 + 1560 | 0) + 16 | 0;
          i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
          i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
          $843 = i64toi32_i32$1;
          i64toi32_i32$1 = ($2 + 1200 | 0) + 40 | 0;
          HEAP32[i64toi32_i32$1 >> 2] = $843;
          HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
          i64toi32_i32$0 = $2;
          i64toi32_i32$2 = HEAP32[($2 + 1176 | 0) >> 2] | 0;
          i64toi32_i32$1 = HEAP32[($2 + 1180 | 0) >> 2] | 0;
          $847 = i64toi32_i32$2;
          i64toi32_i32$2 = $2 + 1252 | 0;
          HEAP32[i64toi32_i32$2 >> 2] = $847;
          HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
          HEAP32[(($2 + 1200 | 0) + 60 | 0) >> 2] = HEAP32[(($2 + 1176 | 0) + 8 | 0) >> 2] | 0;
          HEAP8[($2 + 1200 | 0) >> 0] = $5;
          $125 = HEAP32[($2 + 1192 | 0) >> 2] | 0;
          HEAP8[($2 + 1201 | 0) >> 0] = $125;
          HEAP8[($2 + 1202 | 0) >> 0] = $125 >>> 8 | 0;
          HEAP8[($2 + 1203 | 0) >> 0] = $125 >>> 16 | 0;
          HEAP8[($2 + 1204 | 0) >> 0] = $125 >>> 24 | 0;
          $126 = HEAPU8[($2 + 1195 | 0) >> 0] | 0 | ((HEAPU8[($2 + 1196 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 1197 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 1198 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          HEAP8[($2 + 1204 | 0) >> 0] = $126;
          HEAP8[($2 + 1205 | 0) >> 0] = $126 >>> 8 | 0;
          HEAP8[($2 + 1206 | 0) >> 0] = $126 >>> 16 | 0;
          HEAP8[($2 + 1207 | 0) >> 0] = $126 >>> 24 | 0;
          HEAP32[($2 + 1248 | 0) >> 2] = $3;
          $1 = ($2 + 720 | 0) + 8 | 0;
          cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $2 + 1200 | 0 | 0, 1052756 | 0, 20 | 0);
          i64toi32_i32$0 = ($2 + 720 | 0) + 40 | 0;
          i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
          i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
          $877 = i64toi32_i32$1;
          i64toi32_i32$1 = ($2 + 368 | 0) + 8 | 0;
          HEAP32[i64toi32_i32$1 >> 2] = $877;
          HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
          i64toi32_i32$0 = $2 + 768 | 0;
          i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
          $883 = i64toi32_i32$2;
          i64toi32_i32$2 = ($2 + 368 | 0) + 16 | 0;
          HEAP32[i64toi32_i32$2 >> 2] = $883;
          HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
          HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 788 | 0) >> 2] | 0;
          HEAP32[($2 + 1168 | 0) >> 2] = HEAPU8[($2 + 729 | 0) >> 0] | 0 | ((HEAPU8[($2 + 730 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 731 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 732 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          $128 = $2 + 732 | 0;
          $129 = HEAPU8[$128 >> 0] | 0 | ((HEAPU8[($128 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($128 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($128 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          HEAP8[($2 + 1171 | 0) >> 0] = $129;
          HEAP8[($2 + 1172 | 0) >> 0] = $129 >>> 8 | 0;
          HEAP8[($2 + 1173 | 0) >> 0] = $129 >>> 16 | 0;
          HEAP8[($2 + 1174 | 0) >> 0] = $129 >>> 24 | 0;
          i64toi32_i32$0 = ($2 + 720 | 0) + 32 | 0;
          i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
          i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
          $901 = i64toi32_i32$1;
          i64toi32_i32$1 = $2;
          HEAP32[($2 + 368 | 0) >> 2] = $901;
          HEAP32[($2 + 372 | 0) >> 2] = i64toi32_i32$2;
          i64toi32_i32$0 = ($2 + 720 | 0) + 60 | 0;
          i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
          $906 = i64toi32_i32$2;
          i64toi32_i32$2 = $2;
          HEAP32[($2 + 8 | 0) >> 2] = $906;
          HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
          $1 = HEAPU8[$1 >> 0] | 0;
          i64toi32_i32$0 = ($2 + 720 | 0) + 16 | 0;
          i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
          i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
          $9 = i64toi32_i32$1;
          $9$hi = i64toi32_i32$2;
          i64toi32_i32$0 = ($2 + 720 | 0) + 24 | 0;
          i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
          $11 = i64toi32_i32$2;
          $11$hi = i64toi32_i32$1;
          $3 = HEAP32[($2 + 776 | 0) >> 2] | 0;
          $130 = HEAPU8[($2 + 1171 | 0) >> 0] | 0 | ((HEAPU8[($2 + 1172 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 1173 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 1174 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          HEAP8[($2 + 1195 | 0) >> 0] = $130;
          HEAP8[($2 + 1196 | 0) >> 0] = $130 >>> 8 | 0;
          HEAP8[($2 + 1197 | 0) >> 0] = $130 >>> 16 | 0;
          HEAP8[($2 + 1198 | 0) >> 0] = $130 >>> 24 | 0;
          HEAP32[($2 + 1192 | 0) >> 2] = HEAP32[($2 + 1168 | 0) >> 2] | 0;
          break label$7;
         }
         $5 = HEAPU8[($2 + 372 | 0) >> 0] | 0;
         HEAP8[(($2 + 720 | 0) + 8 | 0) >> 0] = $5;
         HEAP32[($2 + 1192 | 0) >> 2] = HEAPU8[($2 + 373 | 0) >> 0] | 0 | ((HEAPU8[($2 + 374 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 375 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 376 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $3 = ($2 + 368 | 0) + 8 | 0;
         $131 = HEAPU8[$3 >> 0] | 0 | ((HEAPU8[($3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[($2 + 1195 | 0) >> 0] = $131;
         HEAP8[($2 + 1196 | 0) >> 0] = $131 >>> 8 | 0;
         HEAP8[($2 + 1197 | 0) >> 0] = $131 >>> 16 | 0;
         HEAP8[($2 + 1198 | 0) >> 0] = $131 >>> 24 | 0;
         $7 = ($2 + 720 | 0) + 12 | 0;
         $133 = HEAPU8[($2 + 1195 | 0) >> 0] | 0 | ((HEAPU8[($2 + 1196 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 1197 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 1198 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[$7 >> 0] = $133;
         HEAP8[($7 + 1 | 0) >> 0] = $133 >>> 8 | 0;
         HEAP8[($7 + 2 | 0) >> 0] = $133 >>> 16 | 0;
         HEAP8[($7 + 3 | 0) >> 0] = $133 >>> 24 | 0;
         $8 = HEAP32[($2 + 368 | 0) >> 2] | 0;
         HEAP32[($2 + 724 | 0) >> 2] = $8;
         $134 = HEAP32[($2 + 1192 | 0) >> 2] | 0;
         HEAP8[($2 + 729 | 0) >> 0] = $134;
         HEAP8[($2 + 730 | 0) >> 0] = $134 >>> 8 | 0;
         HEAP8[($2 + 731 | 0) >> 0] = $134 >>> 16 | 0;
         HEAP8[($2 + 732 | 0) >> 0] = $134 >>> 24 | 0;
         $135 = HEAPU8[$7 >> 0] | 0 | ((HEAPU8[($7 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($7 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($7 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[($2 + 1171 | 0) >> 0] = $135;
         HEAP8[($2 + 1172 | 0) >> 0] = $135 >>> 8 | 0;
         HEAP8[($2 + 1173 | 0) >> 0] = $135 >>> 16 | 0;
         HEAP8[($2 + 1174 | 0) >> 0] = $135 >>> 24 | 0;
         HEAP32[($2 + 1168 | 0) >> 2] = HEAPU8[($2 + 729 | 0) >> 0] | 0 | ((HEAPU8[($2 + 730 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 731 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 732 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[($2 + 1156 | 0) >> 0] = $5;
         HEAP32[($2 + 1152 | 0) >> 2] = $8;
         $5 = ($2 + 1152 | 0) + 8 | 0;
         $136 = HEAPU8[($2 + 1171 | 0) >> 0] | 0 | ((HEAPU8[($2 + 1172 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 1173 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 1174 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[$5 >> 0] = $136;
         HEAP8[($5 + 1 | 0) >> 0] = $136 >>> 8 | 0;
         HEAP8[($5 + 2 | 0) >> 0] = $136 >>> 16 | 0;
         HEAP8[($5 + 3 | 0) >> 0] = $136 >>> 24 | 0;
         $138 = HEAP32[($2 + 1168 | 0) >> 2] | 0;
         HEAP8[($2 + 1157 | 0) >> 0] = $138;
         HEAP8[($2 + 1158 | 0) >> 0] = $138 >>> 8 | 0;
         HEAP8[($2 + 1159 | 0) >> 0] = $138 >>> 16 | 0;
         HEAP8[($2 + 1160 | 0) >> 0] = $138 >>> 24 | 0;
         i64toi32_i32$1 = $10$hi;
         i64toi32_i32$0 = $10;
         i64toi32_i32$2 = 0;
         i64toi32_i32$3 = 1;
         if ((i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) | 0) {
          break label$5
         }
         cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 1200 | 0 | 0, $1 | 0);
         $7 = HEAPU8[($2 + 1208 | 0) >> 0] | 0;
         label$24 : {
          label$25 : {
           i64toi32_i32$3 = $2;
           i64toi32_i32$0 = HEAP32[($2 + 1200 | 0) >> 2] | 0;
           i64toi32_i32$1 = HEAP32[($2 + 1204 | 0) >> 2] | 0;
           i64toi32_i32$3 = i64toi32_i32$0;
           i64toi32_i32$0 = 0;
           i64toi32_i32$2 = 1;
           if ((i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
            break label$25
           }
           $1 = 5;
           if (($7 & 255 | 0 | 0) == (5 | 0)) {
            break label$5
           }
           break label$24;
          }
          i64toi32_i32$2 = $2 + 1232 | 0;
          i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
          $9 = i64toi32_i32$3;
          $9$hi = i64toi32_i32$1;
          i64toi32_i32$3 = ($2 + 8 | 0) + 8 | 0;
          HEAP32[i64toi32_i32$3 >> 2] = $9;
          HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
          i64toi32_i32$2 = $2 + 1240 | 0;
          i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
          i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
          $10 = i64toi32_i32$1;
          $10$hi = i64toi32_i32$3;
          i64toi32_i32$1 = ($2 + 8 | 0) + 16 | 0;
          HEAP32[i64toi32_i32$1 >> 2] = $10;
          HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
          i64toi32_i32$3 = $9$hi;
          i64toi32_i32$1 = ($2 + 368 | 0) + 8 | 0;
          HEAP32[i64toi32_i32$1 >> 2] = $9;
          HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
          i64toi32_i32$3 = $10$hi;
          i64toi32_i32$1 = ($2 + 368 | 0) + 16 | 0;
          HEAP32[i64toi32_i32$1 >> 2] = $10;
          HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
          i64toi32_i32$2 = $2 + 1224 | 0;
          i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
          $9 = i64toi32_i32$3;
          $9$hi = i64toi32_i32$1;
          i64toi32_i32$3 = $2;
          HEAP32[($2 + 8 | 0) >> 2] = $9;
          HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
          i64toi32_i32$3 = $2;
          HEAP32[($2 + 368 | 0) >> 2] = $9;
          HEAP32[($2 + 372 | 0) >> 2] = i64toi32_i32$1;
          i64toi32_i32$2 = $2;
          i64toi32_i32$1 = HEAPU8[($2 + 1209 | 0) >> 0] | 0 | ((HEAPU8[($2 + 1210 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 1211 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 1212 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          i64toi32_i32$3 = 0;
          $1016 = i64toi32_i32$1;
          $1016$hi = i64toi32_i32$3;
          i64toi32_i32$2 = $2 + 1213 | 0;
          i64toi32_i32$3 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
          i64toi32_i32$1 = 0;
          $1019 = i64toi32_i32$3;
          $1019$hi = i64toi32_i32$1;
          i64toi32_i32$2 = $2 + 1215 | 0;
          i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
          i64toi32_i32$3 = 0;
          i64toi32_i32$2 = i64toi32_i32$1;
          i64toi32_i32$1 = 0;
          i64toi32_i32$0 = 16;
          i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
          if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
           i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
           $147 = 0;
          } else {
           i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$4 | 0) | 0;
           $147 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
          }
          $1023$hi = i64toi32_i32$1;
          i64toi32_i32$1 = $1019$hi;
          i64toi32_i32$3 = $1019;
          i64toi32_i32$2 = $1023$hi;
          i64toi32_i32$0 = $147;
          i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
          i64toi32_i32$1 = i64toi32_i32$3 | i64toi32_i32$0 | 0;
          i64toi32_i32$3 = 0;
          i64toi32_i32$0 = 32;
          i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
          if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
           i64toi32_i32$3 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
           $148 = 0;
          } else {
           i64toi32_i32$3 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
           $148 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
          }
          $1025$hi = i64toi32_i32$3;
          i64toi32_i32$3 = $1016$hi;
          i64toi32_i32$2 = $1016;
          i64toi32_i32$1 = $1025$hi;
          i64toi32_i32$0 = $148;
          i64toi32_i32$1 = i64toi32_i32$3 | i64toi32_i32$1 | 0;
          i64toi32_i32$3 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
          i64toi32_i32$2 = 0;
          i64toi32_i32$0 = 8;
          i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
          if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
           i64toi32_i32$2 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
           $149 = 0;
          } else {
           i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
           $149 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
          }
          $1027$hi = i64toi32_i32$2;
          i64toi32_i32$2 = 0;
          i64toi32_i32$1 = $7;
          i64toi32_i32$3 = 0;
          i64toi32_i32$0 = 255;
          i64toi32_i32$3 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
          $1030 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
          $1030$hi = i64toi32_i32$3;
          i64toi32_i32$3 = $1027$hi;
          i64toi32_i32$2 = $149;
          i64toi32_i32$1 = $1030$hi;
          i64toi32_i32$0 = $1030;
          i64toi32_i32$1 = i64toi32_i32$3 | i64toi32_i32$1 | 0;
          $9 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
          $9$hi = i64toi32_i32$1;
          i64toi32_i32$3 = ($2 + 1200 | 0) + 16 | 0;
          i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
          i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
          $11 = i64toi32_i32$1;
          $11$hi = i64toi32_i32$2;
          $1 = 2;
         }
         $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h19f76bdb6b4883ef($2 + 1152 | 0 | 0);
         $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h970b13f6299e0f2d($2 + 1152 | 0 | 0);
         $3 = 0;
        }
        $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__h65524c00492b1305($2 + 1088 | 0 | 0);
        if (!(HEAP32[($2 + 1104 | 0) >> 2] | 0)) {
         break label$6
        }
        hashbrown__raw__RawTable_T_2cA___free_buckets__h03139504252f0030(($2 + 1088 | 0) + 16 | 0 | 0);
       }
       $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h50c1f6d5a01d91ba($2 + 1072 | 0 | 0);
       $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h0a3e4540c50cd990($2 + 1072 | 0 | 0);
       break label$4;
      }
      i64toi32_i32$3 = $6 + 8 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $1055 = i64toi32_i32$2;
      i64toi32_i32$2 = $3;
      HEAP32[i64toi32_i32$2 >> 2] = $1055;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      $1 = ($2 + 368 | 0) + 16 | 0;
      i64toi32_i32$3 = $6 + 16 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $1062 = i64toi32_i32$1;
      i64toi32_i32$1 = $1;
      HEAP32[i64toi32_i32$1 >> 2] = $1062;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
      $7 = $2 + 392 | 0 | 1 | 0;
      HEAP32[($2 + 1192 | 0) >> 2] = HEAPU8[$7 >> 0] | 0 | ((HEAPU8[($7 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($7 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($7 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$3 = $6;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $1071 = i64toi32_i32$2;
      i64toi32_i32$2 = $2;
      HEAP32[($2 + 368 | 0) >> 2] = $1071;
      HEAP32[($2 + 372 | 0) >> 2] = i64toi32_i32$1;
      $139 = $7 + 3 | 0;
      $140 = HEAPU8[$139 >> 0] | 0 | ((HEAPU8[($139 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($139 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($139 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[($2 + 1195 | 0) >> 0] = $140;
      HEAP8[($2 + 1196 | 0) >> 0] = $140 >>> 8 | 0;
      HEAP8[($2 + 1197 | 0) >> 0] = $140 >>> 16 | 0;
      HEAP8[($2 + 1198 | 0) >> 0] = $140 >>> 24 | 0;
      $6 = HEAP32[($2 + 440 | 0) >> 2] | 0;
      i64toi32_i32$3 = $2;
      i64toi32_i32$1 = HEAP32[($2 + 400 | 0) >> 2] | 0;
      i64toi32_i32$2 = HEAP32[($2 + 404 | 0) >> 2] | 0;
      $9 = i64toi32_i32$1;
      $9$hi = i64toi32_i32$2;
      i64toi32_i32$3 = $2;
      i64toi32_i32$2 = HEAP32[($2 + 408 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($2 + 412 | 0) >> 2] | 0;
      $10 = i64toi32_i32$2;
      $10$hi = i64toi32_i32$1;
      $7 = HEAPU8[($2 + 392 | 0) >> 0] | 0;
      memcpy($2 + 1200 | 0 | 0, $4 | 0, 276 | 0) | 0;
      HEAP32[($2 + 1524 | 0) >> 2] = HEAP32[(($2 + 1056 | 0) + 8 | 0) >> 2] | 0;
      i64toi32_i32$3 = $2;
      i64toi32_i32$1 = HEAP32[($2 + 1056 | 0) >> 2] | 0;
      i64toi32_i32$2 = HEAP32[($2 + 1060 | 0) >> 2] | 0;
      $1096 = i64toi32_i32$1;
      i64toi32_i32$1 = $2;
      HEAP32[($2 + 1516 | 0) >> 2] = $1096;
      HEAP32[($2 + 1520 | 0) >> 2] = i64toi32_i32$2;
      memcpy(($2 + 1200 | 0) + 276 | 0 | 0, $2 + 1088 | 0 | 0, 40 | 0) | 0;
      HEAP32[($2 + 1548 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
      HEAP32[($2 + 1536 | 0) >> 2] = HEAP32[(($2 + 1072 | 0) + 8 | 0) >> 2] | 0;
      i64toi32_i32$3 = $2;
      i64toi32_i32$2 = HEAP32[($2 + 1152 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($2 + 1156 | 0) >> 2] | 0;
      $1115 = i64toi32_i32$2;
      i64toi32_i32$2 = $2;
      HEAP32[($2 + 1540 | 0) >> 2] = $1115;
      HEAP32[($2 + 1544 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$3 = $2;
      i64toi32_i32$1 = HEAP32[($2 + 1072 | 0) >> 2] | 0;
      i64toi32_i32$2 = HEAP32[($2 + 1076 | 0) >> 2] | 0;
      $1118 = i64toi32_i32$1;
      i64toi32_i32$1 = $2;
      HEAP32[($2 + 1528 | 0) >> 2] = $1118;
      HEAP32[($2 + 1532 | 0) >> 2] = i64toi32_i32$2;
      memcpy($2 + 8 | 0 | 0, $2 + 1200 | 0 | 0, 356 | 0) | 0;
      HEAP8[($0 + 8 | 0) >> 0] = $7;
      $141 = HEAP32[($2 + 1192 | 0) >> 2] | 0;
      HEAP8[($0 + 9 | 0) >> 0] = $141;
      HEAP8[($0 + 10 | 0) >> 0] = $141 >>> 8 | 0;
      HEAP8[($0 + 11 | 0) >> 0] = $141 >>> 16 | 0;
      HEAP8[($0 + 12 | 0) >> 0] = $141 >>> 24 | 0;
      $143 = $0 + 12 | 0;
      $144 = HEAPU8[($2 + 1195 | 0) >> 0] | 0 | ((HEAPU8[($2 + 1196 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 1197 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 1198 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[$143 >> 0] = $144;
      HEAP8[($143 + 1 | 0) >> 0] = $144 >>> 8 | 0;
      HEAP8[($143 + 2 | 0) >> 0] = $144 >>> 16 | 0;
      HEAP8[($143 + 3 | 0) >> 0] = $144 >>> 24 | 0;
      i64toi32_i32$2 = $10$hi;
      i64toi32_i32$1 = $0 + 24 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $10;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$2 = $9$hi;
      i64toi32_i32$1 = $0 + 16 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $9;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$3 = $2;
      i64toi32_i32$2 = HEAP32[($2 + 368 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($2 + 372 | 0) >> 2] | 0;
      $1142 = i64toi32_i32$2;
      i64toi32_i32$2 = $0 + 32 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $1142;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$3 = $3;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $1146 = i64toi32_i32$1;
      i64toi32_i32$1 = $0 + 40 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $1146;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$3 = $1;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $1150 = i64toi32_i32$2;
      i64toi32_i32$2 = $0 + 48 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $1150;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($0 + 56 | 0) >> 2] = $6;
      memcpy($0 + 60 | 0 | 0, $2 + 8 | 0 | 0, 356 | 0) | 0;
      i64toi32_i32$1 = 0;
      $9 = 0;
      $9$hi = i64toi32_i32$1;
      break label$1;
     }
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h86cdf7dca21c8b48($2 + 1056 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h7ca18c2b7d174864($2 + 1056 | 0 | 0);
    }
    core__ptr__drop_in_place_cardano_serialization_lib__Header___h8385b81bf98ec4f1($2 + 392 | 0 | 0);
   }
   i64toi32_i32$1 = $11$hi;
   i64toi32_i32$2 = ($2 + 1200 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $11;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $9$hi;
   i64toi32_i32$2 = ($2 + 1200 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $9;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$3 = $2;
   i64toi32_i32$1 = HEAP32[($2 + 368 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($2 + 372 | 0) >> 2] | 0;
   $1176 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 1224 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $1176;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$3 = $2;
   i64toi32_i32$2 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $1180 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 1252 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $1180;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$3 = ($2 + 368 | 0) + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $1186 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 1232 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $1186;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$3 = ($2 + 368 | 0) + 16 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $1192 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 1240 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $1192;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($2 + 1260 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
   HEAP8[($2 + 1200 | 0) >> 0] = $1;
   $145 = HEAP32[($2 + 1192 | 0) >> 2] | 0;
   HEAP8[($2 + 1201 | 0) >> 0] = $145;
   HEAP8[($2 + 1202 | 0) >> 0] = $145 >>> 8 | 0;
   HEAP8[($2 + 1203 | 0) >> 0] = $145 >>> 16 | 0;
   HEAP8[($2 + 1204 | 0) >> 0] = $145 >>> 24 | 0;
   $146 = HEAPU8[($2 + 1195 | 0) >> 0] | 0 | ((HEAPU8[($2 + 1196 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 1197 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 1198 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[($2 + 1204 | 0) >> 0] = $146;
   HEAP8[($2 + 1205 | 0) >> 0] = $146 >>> 8 | 0;
   HEAP8[($2 + 1206 | 0) >> 0] = $146 >>> 16 | 0;
   HEAP8[($2 + 1207 | 0) >> 0] = $146 >>> 24 | 0;
   HEAP32[($2 + 1248 | 0) >> 2] = $3;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 1200 | 0 | 0, 1052776 | 0, 5 | 0);
   i64toi32_i32$1 = 0;
   $9 = 1;
   $9$hi = i64toi32_i32$1;
  }
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$2 = $0;
  HEAP32[i64toi32_i32$2 >> 2] = $9;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $2 + 1888 | 0;
 }
 
 function cardano_serialization_lib__tx_builder__fake_full_tx__h790258922a10b915($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $4 = 0, $8 = 0, $13 = 0, $9 = 0, $14 = 0, $15 = 0, $13$hi = 0, $14$hi = 0, $15$hi = 0, $5 = 0, $6 = 0, $7 = 0, $52 = 0, $53 = 0, $54 = 0, $55 = 0, $56 = 0, $57 = 0, $58 = 0, $59 = 0, $60 = 0, $61 = 0, $63 = 0, $64 = 0, $65 = 0, $66 = 0, $67 = 0, $68 = 0, $69 = 0, $12 = 0, $10 = 0, $11 = 0, $70 = 0, $71 = 0, $62 = 0, $73 = 0, $146 = 0, $153 = 0, $156 = 0, $323 = 0, $330 = 0, $333 = 0, $503 = 0, $510 = 0, $513 = 0, $660 = 0, $666 = 0, $672 = 0, $740 = 0, $747 = 0, $750 = 0, $761 = 0, $833 = 0, $902 = 0, $920 = 0, $16 = 0, $16$hi = 0, $17 = 0, $17$hi = 0, $959 = 0, $1019 = 0, $1022 = 0, $1042 = 0, $1046 = 0;
  $3 = global$0 - 752 | 0;
  global$0 = $3;
  cardano_serialization_lib__crypto__Bip32PrivateKey__from_bytes__hdfbc703a3728d81d($3 + 352 | 0 | 0, 1063880 | 0, 96 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ((HEAPU8[($3 + 352 | 0) >> 0] | 0 | 0) == (1 | 0)) {
        break label$5
       }
       $3 = memcpy($3 | 0, $3 + 352 | 0 | 1 | 0 | 0, 96 | 0) | 0;
       i64toi32_i32$1 = ($3 + 352 | 0) + 24 | 0;
       i64toi32_i32$0 = 0;
       HEAP32[i64toi32_i32$1 >> 2] = 0;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$1 = ($3 + 352 | 0) + 16 | 0;
       i64toi32_i32$0 = 0;
       HEAP32[i64toi32_i32$1 >> 2] = 0;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$1 = ($3 + 352 | 0) + 8 | 0;
       i64toi32_i32$0 = 0;
       HEAP32[i64toi32_i32$1 >> 2] = 0;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$1 = $3;
       i64toi32_i32$0 = 0;
       HEAP32[($3 + 352 | 0) >> 2] = 0;
       HEAP32[($3 + 356 | 0) >> 2] = i64toi32_i32$0;
       core__slice___impl_20_5bT_5d___clone_from_slice__h1742dfbd5d5d9efd($3 + 352 | 0 | 0, 32 | 0, 1064008 | 0, 32 | 0);
       $4 = HEAPU8[($3 + 383 | 0) >> 0] | 0;
       HEAP8[(($3 + 688 | 0) + 24 | 0) >> 0] = $4;
       i64toi32_i32$2 = $3 + 375 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $13 = i64toi32_i32$0;
       $13$hi = i64toi32_i32$1;
       i64toi32_i32$0 = ($3 + 688 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $13;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $3 + 367 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $62 = i64toi32_i32$1;
       i64toi32_i32$1 = ($3 + 96 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $62;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$0 = $13$hi;
       i64toi32_i32$1 = ($3 + 96 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $13;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       HEAP8[(($3 + 96 | 0) + 24 | 0) >> 0] = $4;
       i64toi32_i32$2 = $3;
       i64toi32_i32$0 = HEAPU8[($3 + 359 | 0) >> 0] | 0 | ((HEAPU8[($3 + 360 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 361 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 362 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[($3 + 363 | 0) >> 0] | 0 | ((HEAPU8[($3 + 364 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 365 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 366 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $73 = i64toi32_i32$0;
       i64toi32_i32$0 = $3;
       HEAP32[($3 + 96 | 0) >> 2] = $73;
       HEAP32[($3 + 100 | 0) >> 2] = i64toi32_i32$1;
       $5 = HEAPU8[($3 + 355 | 0) >> 0] | 0 | ((HEAPU8[($3 + 356 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 357 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 358 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $6 = HEAPU8[($3 + 353 | 0) >> 0] | 0 | ((HEAPU8[($3 + 354 | 0) >> 0] | 0) << 8 | 0) | 0;
       $7 = HEAPU8[($3 + 352 | 0) >> 0] | 0;
       $4 = __rust_alloc(64 | 0, 1 | 0) | 0;
       if (!$4) {
        break label$4
       }
       i64toi32_i32$0 = $4;
       i64toi32_i32$1 = 175741228;
       $52 = 59960750;
       HEAP8[(i64toi32_i32$0 + 56 | 0) >> 0] = $52;
       HEAP8[(i64toi32_i32$0 + 57 | 0) >> 0] = $52 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 58 | 0) >> 0] = $52 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 59 | 0) >> 0] = $52 >>> 24 | 0;
       HEAP8[(i64toi32_i32$0 + 60 | 0) >> 0] = i64toi32_i32$1;
       HEAP8[(i64toi32_i32$0 + 61 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 62 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 63 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
       i64toi32_i32$1 = -1029128756;
       $53 = -71145731;
       HEAP8[(i64toi32_i32$0 + 48 | 0) >> 0] = $53;
       HEAP8[(i64toi32_i32$0 + 49 | 0) >> 0] = $53 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 50 | 0) >> 0] = $53 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 51 | 0) >> 0] = $53 >>> 24 | 0;
       HEAP8[(i64toi32_i32$0 + 52 | 0) >> 0] = i64toi32_i32$1;
       HEAP8[(i64toi32_i32$0 + 53 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 54 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 55 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
       i64toi32_i32$1 = 661092983;
       $54 = 759769112;
       HEAP8[(i64toi32_i32$0 + 40 | 0) >> 0] = $54;
       HEAP8[(i64toi32_i32$0 + 41 | 0) >> 0] = $54 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 42 | 0) >> 0] = $54 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 43 | 0) >> 0] = $54 >>> 24 | 0;
       HEAP8[(i64toi32_i32$0 + 44 | 0) >> 0] = i64toi32_i32$1;
       HEAP8[(i64toi32_i32$0 + 45 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 46 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 47 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
       i64toi32_i32$1 = 1434195817;
       $55 = -580368946;
       HEAP8[(i64toi32_i32$0 + 32 | 0) >> 0] = $55;
       HEAP8[(i64toi32_i32$0 + 33 | 0) >> 0] = $55 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 34 | 0) >> 0] = $55 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 35 | 0) >> 0] = $55 >>> 24 | 0;
       HEAP8[(i64toi32_i32$0 + 36 | 0) >> 0] = i64toi32_i32$1;
       HEAP8[(i64toi32_i32$0 + 37 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 38 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 39 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
       i64toi32_i32$1 = 1843144904;
       $56 = -1818271257;
       HEAP8[(i64toi32_i32$0 + 24 | 0) >> 0] = $56;
       HEAP8[(i64toi32_i32$0 + 25 | 0) >> 0] = $56 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 26 | 0) >> 0] = $56 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 27 | 0) >> 0] = $56 >>> 24 | 0;
       HEAP8[(i64toi32_i32$0 + 28 | 0) >> 0] = i64toi32_i32$1;
       HEAP8[(i64toi32_i32$0 + 29 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 30 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 31 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
       i64toi32_i32$1 = -1974710224;
       $57 = 1529083714;
       HEAP8[(i64toi32_i32$0 + 16 | 0) >> 0] = $57;
       HEAP8[(i64toi32_i32$0 + 17 | 0) >> 0] = $57 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 18 | 0) >> 0] = $57 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 19 | 0) >> 0] = $57 >>> 24 | 0;
       HEAP8[(i64toi32_i32$0 + 20 | 0) >> 0] = i64toi32_i32$1;
       HEAP8[(i64toi32_i32$0 + 21 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 22 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 23 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
       i64toi32_i32$1 = 1043598773;
       $58 = -997015194;
       HEAP8[(i64toi32_i32$0 + 8 | 0) >> 0] = $58;
       HEAP8[(i64toi32_i32$0 + 9 | 0) >> 0] = $58 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 10 | 0) >> 0] = $58 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 11 | 0) >> 0] = $58 >>> 24 | 0;
       HEAP8[(i64toi32_i32$0 + 12 | 0) >> 0] = i64toi32_i32$1;
       HEAP8[(i64toi32_i32$0 + 13 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 14 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 15 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
       i64toi32_i32$1 = 1576867739;
       $59 = -744884188;
       HEAP8[i64toi32_i32$0 >> 0] = $59;
       HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $59 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $59 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $59 >>> 24 | 0;
       HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
       HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
       alloc__slice__hack__into_vec__h7c95d082cf6730ee($3 + 688 | 0 | 0, i64toi32_i32$0 | 0, 64 | 0);
       cardano_serialization_lib__crypto__Ed25519Signature__from_bytes__hf5afe24ffdbd3318($3 + 352 | 0 | 0, $3 + 688 | 0 | 0);
       if ((HEAPU8[($3 + 352 | 0) >> 0] | 0 | 0) == (1 | 0)) {
        break label$3
       }
       memcpy($3 + 128 | 0 | 0, $3 + 352 | 0 | 1 | 0 | 0, 64 | 0) | 0;
       cardano_serialization_lib__tx_builder__tx_inputs_builder___impl_20core__convert__From__cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__20for_20alloc__collections__btree__set__BTreeSet_cardano_serialization_lib__crypto__Ed25519KeyHash____from__h041f14c26c6e4091($3 + 224 | 0 | 0, $1 + 96 | 0 | 0);
       cardano_serialization_lib__tx_builder__tx_inputs_builder___impl_20core__convert__From__cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__20for_20alloc__collections__btree__set__BTreeSet_cardano_serialization_lib__crypto__Ed25519KeyHash____from__h041f14c26c6e4091($3 + 256 | 0 | 0, $1 + 176 | 0 | 0);
       label$6 : {
        label$7 : {
         $8 = HEAP32[($3 + 260 | 0) >> 2] | 0;
         if (!$8) {
          break label$7
         }
         $4 = HEAP32[($3 + 264 | 0) >> 2] | 0;
         $9 = HEAP32[($3 + 256 | 0) >> 2] | 0;
         alloc__collections__btree__navigate__full_range__h55a07d6b3102a73e($3 + 304 | 0 | 0, $9 | 0, $8 | 0, $9 | 0, $8 | 0);
         break label$6;
        }
        $4 = 0;
        HEAP32[($3 + 320 | 0) >> 2] = 0;
        HEAP32[($3 + 308 | 0) >> 2] = 0;
       }
       HEAP32[(($3 + 304 | 0) + 24 | 0) >> 2] = $4;
       HEAP32[(($3 + 624 | 0) + 24 | 0) >> 2] = $4;
       i64toi32_i32$2 = ($3 + 304 | 0) + 16 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $146 = i64toi32_i32$1;
       i64toi32_i32$1 = ($3 + 624 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $146;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = ($3 + 304 | 0) + 8 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $153 = i64toi32_i32$0;
       i64toi32_i32$0 = ($3 + 624 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $153;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $3;
       i64toi32_i32$1 = HEAP32[($3 + 304 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[($3 + 308 | 0) >> 2] | 0;
       $156 = i64toi32_i32$1;
       i64toi32_i32$1 = $3;
       HEAP32[($3 + 624 | 0) >> 2] = $156;
       HEAP32[($3 + 628 | 0) >> 2] = i64toi32_i32$0;
       $alloc__collections__btree__map__IntoIter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h8343c8d1ae260056($3 + 352 | 0 | 0, $3 + 624 | 0 | 0);
       label$8 : {
        if ((HEAPU8[($3 + 352 | 0) >> 0] | 0 | 0) != (1 | 0)) {
         break label$8
        }
        $60 = $3 + 377 | 0;
        $4 = HEAPU8[$60 >> 0] | 0 | ((HEAPU8[($60 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($60 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($60 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP32[(($3 + 688 | 0) + 24 | 0) >> 2] = $4;
        i64toi32_i32$2 = $3 + 369 | 0;
        i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $13 = i64toi32_i32$0;
        $13$hi = i64toi32_i32$1;
        i64toi32_i32$0 = ($3 + 688 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $13;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$2 = $3 + 361 | 0;
        i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $14 = i64toi32_i32$1;
        $14$hi = i64toi32_i32$0;
        i64toi32_i32$1 = ($3 + 688 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $14;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = $3;
        i64toi32_i32$0 = HEAPU8[($3 + 353 | 0) >> 0] | 0 | ((HEAPU8[($3 + 354 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 355 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 356 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$1 = HEAPU8[($3 + 357 | 0) >> 0] | 0 | ((HEAPU8[($3 + 358 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 359 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 360 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $15 = i64toi32_i32$0;
        $15$hi = i64toi32_i32$1;
        i64toi32_i32$0 = $3;
        HEAP32[($3 + 688 | 0) >> 2] = $15;
        HEAP32[($3 + 692 | 0) >> 2] = i64toi32_i32$1;
        HEAP32[(($3 + 352 | 0) + 24 | 0) >> 2] = $4;
        i64toi32_i32$1 = $13$hi;
        i64toi32_i32$0 = ($3 + 352 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $13;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$1 = $14$hi;
        i64toi32_i32$0 = ($3 + 352 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $14;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$1 = $15$hi;
        i64toi32_i32$0 = $3;
        HEAP32[($3 + 352 | 0) >> 2] = $15;
        HEAP32[($3 + 356 | 0) >> 2] = i64toi32_i32$1;
        alloc__collections__btree__map__BTreeMap_K_2cV___insert__h5d8c7a7452747b0f($3 + 224 | 0 | 0, $3 + 352 | 0 | 0) | 0;
        $alloc__collections__btree__map__IntoIter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h8343c8d1ae260056($3 + 352 | 0 | 0, $3 + 624 | 0 | 0);
        if ((HEAPU8[($3 + 352 | 0) >> 0] | 0 | 0) != (1 | 0)) {
         break label$8
        }
        $4 = $3 + 352 | 0 | 1 | 0;
        label$9 : while (1) {
         $61 = $4 + 24 | 0;
         $8 = HEAPU8[$61 >> 0] | 0 | ((HEAPU8[($61 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($61 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($61 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP32[(($3 + 688 | 0) + 24 | 0) >> 2] = $8;
         i64toi32_i32$2 = $4 + 16 | 0;
         i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $13 = i64toi32_i32$1;
         $13$hi = i64toi32_i32$0;
         i64toi32_i32$1 = ($3 + 688 | 0) + 16 | 0;
         HEAP32[i64toi32_i32$1 >> 2] = $13;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$2 = $4 + 8 | 0;
         i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $14 = i64toi32_i32$0;
         $14$hi = i64toi32_i32$1;
         i64toi32_i32$0 = ($3 + 688 | 0) + 8 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $14;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$2 = $4;
         i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $15 = i64toi32_i32$1;
         $15$hi = i64toi32_i32$0;
         i64toi32_i32$1 = $3;
         HEAP32[($3 + 688 | 0) >> 2] = $15;
         HEAP32[($3 + 692 | 0) >> 2] = i64toi32_i32$0;
         HEAP32[(($3 + 352 | 0) + 24 | 0) >> 2] = $8;
         i64toi32_i32$0 = $13$hi;
         i64toi32_i32$1 = ($3 + 352 | 0) + 16 | 0;
         HEAP32[i64toi32_i32$1 >> 2] = $13;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$0 = $14$hi;
         i64toi32_i32$1 = ($3 + 352 | 0) + 8 | 0;
         HEAP32[i64toi32_i32$1 >> 2] = $14;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$0 = $15$hi;
         i64toi32_i32$1 = $3;
         HEAP32[($3 + 352 | 0) >> 2] = $15;
         HEAP32[($3 + 356 | 0) >> 2] = i64toi32_i32$0;
         alloc__collections__btree__map__BTreeMap_K_2cV___insert__h5d8c7a7452747b0f($3 + 224 | 0 | 0, $3 + 352 | 0 | 0) | 0;
         $alloc__collections__btree__map__IntoIter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h8343c8d1ae260056($3 + 352 | 0 | 0, $3 + 624 | 0 | 0);
         if ((HEAPU8[($3 + 352 | 0) >> 0] | 0 | 0) == (1 | 0)) {
          continue label$9
         }
         break label$9;
        };
       }
       label$10 : {
        $4 = HEAP32[($3 + 628 | 0) >> 2] | 0;
        if (!$4) {
         break label$10
        }
        $8 = HEAP32[($3 + 624 | 0) >> 2] | 0;
        $9 = HEAP32[($3 + 632 | 0) >> 2] | 0;
        HEAP32[($3 + 364 | 0) >> 2] = HEAP32[($3 + 648 | 0) >> 2] | 0;
        HEAP32[($3 + 360 | 0) >> 2] = $9;
        HEAP32[($3 + 356 | 0) >> 2] = $4;
        HEAP32[($3 + 352 | 0) >> 2] = $8;
        $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__hbd56bd5c906359e6($3 + 352 | 0 | 0);
       }
       cardano_serialization_lib___impl_20core__convert__From__cardano_serialization_lib__Ed25519KeyHashes__20for_20alloc__collections__btree__set__BTreeSet_cardano_serialization_lib__crypto__Ed25519KeyHash____from__h2943ba4850cd87e8($3 + 256 | 0 | 0, $1 + 468 | 0 | 0);
       label$11 : {
        label$12 : {
         $8 = HEAP32[($3 + 260 | 0) >> 2] | 0;
         if (!$8) {
          break label$12
         }
         $4 = HEAP32[($3 + 264 | 0) >> 2] | 0;
         $9 = HEAP32[($3 + 256 | 0) >> 2] | 0;
         alloc__collections__btree__navigate__full_range__h55a07d6b3102a73e($3 + 304 | 0 | 0, $9 | 0, $8 | 0, $9 | 0, $8 | 0);
         break label$11;
        }
        $4 = 0;
        HEAP32[($3 + 320 | 0) >> 2] = 0;
        HEAP32[($3 + 308 | 0) >> 2] = 0;
       }
       HEAP32[(($3 + 304 | 0) + 24 | 0) >> 2] = $4;
       HEAP32[(($3 + 624 | 0) + 24 | 0) >> 2] = $4;
       i64toi32_i32$2 = ($3 + 304 | 0) + 16 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $323 = i64toi32_i32$0;
       i64toi32_i32$0 = ($3 + 624 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $323;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = ($3 + 304 | 0) + 8 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $330 = i64toi32_i32$1;
       i64toi32_i32$1 = ($3 + 624 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $330;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = $3;
       i64toi32_i32$0 = HEAP32[($3 + 304 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($3 + 308 | 0) >> 2] | 0;
       $333 = i64toi32_i32$0;
       i64toi32_i32$0 = $3;
       HEAP32[($3 + 624 | 0) >> 2] = $333;
       HEAP32[($3 + 628 | 0) >> 2] = i64toi32_i32$1;
       $alloc__collections__btree__map__IntoIter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h8343c8d1ae260056($3 + 352 | 0 | 0, $3 + 624 | 0 | 0);
       label$13 : {
        if ((HEAPU8[($3 + 352 | 0) >> 0] | 0 | 0) != (1 | 0)) {
         break label$13
        }
        $63 = $3 + 377 | 0;
        $4 = HEAPU8[$63 >> 0] | 0 | ((HEAPU8[($63 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($63 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($63 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP32[(($3 + 688 | 0) + 24 | 0) >> 2] = $4;
        i64toi32_i32$2 = $3 + 369 | 0;
        i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $13 = i64toi32_i32$1;
        $13$hi = i64toi32_i32$0;
        i64toi32_i32$1 = ($3 + 688 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $13;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = $3 + 361 | 0;
        i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $14 = i64toi32_i32$0;
        $14$hi = i64toi32_i32$1;
        i64toi32_i32$0 = ($3 + 688 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $14;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$2 = $3;
        i64toi32_i32$1 = HEAPU8[($3 + 353 | 0) >> 0] | 0 | ((HEAPU8[($3 + 354 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 355 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 356 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$0 = HEAPU8[($3 + 357 | 0) >> 0] | 0 | ((HEAPU8[($3 + 358 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 359 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 360 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $15 = i64toi32_i32$1;
        $15$hi = i64toi32_i32$0;
        i64toi32_i32$1 = $3;
        HEAP32[($3 + 688 | 0) >> 2] = $15;
        HEAP32[($3 + 692 | 0) >> 2] = i64toi32_i32$0;
        HEAP32[(($3 + 352 | 0) + 24 | 0) >> 2] = $4;
        i64toi32_i32$0 = $13$hi;
        i64toi32_i32$1 = ($3 + 352 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $13;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$0 = $14$hi;
        i64toi32_i32$1 = ($3 + 352 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $14;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$0 = $15$hi;
        i64toi32_i32$1 = $3;
        HEAP32[($3 + 352 | 0) >> 2] = $15;
        HEAP32[($3 + 356 | 0) >> 2] = i64toi32_i32$0;
        alloc__collections__btree__map__BTreeMap_K_2cV___insert__h5d8c7a7452747b0f($3 + 224 | 0 | 0, $3 + 352 | 0 | 0) | 0;
        $alloc__collections__btree__map__IntoIter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h8343c8d1ae260056($3 + 352 | 0 | 0, $3 + 624 | 0 | 0);
        if ((HEAPU8[($3 + 352 | 0) >> 0] | 0 | 0) != (1 | 0)) {
         break label$13
        }
        $4 = $3 + 352 | 0 | 1 | 0;
        label$14 : while (1) {
         $64 = $4 + 24 | 0;
         $8 = HEAPU8[$64 >> 0] | 0 | ((HEAPU8[($64 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($64 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($64 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP32[(($3 + 688 | 0) + 24 | 0) >> 2] = $8;
         i64toi32_i32$2 = $4 + 16 | 0;
         i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $13 = i64toi32_i32$0;
         $13$hi = i64toi32_i32$1;
         i64toi32_i32$0 = ($3 + 688 | 0) + 16 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $13;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$2 = $4 + 8 | 0;
         i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $14 = i64toi32_i32$1;
         $14$hi = i64toi32_i32$0;
         i64toi32_i32$1 = ($3 + 688 | 0) + 8 | 0;
         HEAP32[i64toi32_i32$1 >> 2] = $14;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$2 = $4;
         i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $15 = i64toi32_i32$0;
         $15$hi = i64toi32_i32$1;
         i64toi32_i32$0 = $3;
         HEAP32[($3 + 688 | 0) >> 2] = $15;
         HEAP32[($3 + 692 | 0) >> 2] = i64toi32_i32$1;
         HEAP32[(($3 + 352 | 0) + 24 | 0) >> 2] = $8;
         i64toi32_i32$1 = $13$hi;
         i64toi32_i32$0 = ($3 + 352 | 0) + 16 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $13;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$1 = $14$hi;
         i64toi32_i32$0 = ($3 + 352 | 0) + 8 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $14;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$1 = $15$hi;
         i64toi32_i32$0 = $3;
         HEAP32[($3 + 352 | 0) >> 2] = $15;
         HEAP32[($3 + 356 | 0) >> 2] = i64toi32_i32$1;
         alloc__collections__btree__map__BTreeMap_K_2cV___insert__h5d8c7a7452747b0f($3 + 224 | 0 | 0, $3 + 352 | 0 | 0) | 0;
         $alloc__collections__btree__map__IntoIter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h8343c8d1ae260056($3 + 352 | 0 | 0, $3 + 624 | 0 | 0);
         if ((HEAPU8[($3 + 352 | 0) >> 0] | 0 | 0) == (1 | 0)) {
          continue label$14
         }
         break label$14;
        };
       }
       label$15 : {
        $4 = HEAP32[($3 + 628 | 0) >> 2] | 0;
        if (!$4) {
         break label$15
        }
        $8 = HEAP32[($3 + 624 | 0) >> 2] | 0;
        $9 = HEAP32[($3 + 632 | 0) >> 2] | 0;
        HEAP32[($3 + 364 | 0) >> 2] = HEAP32[($3 + 648 | 0) >> 2] | 0;
        HEAP32[($3 + 360 | 0) >> 2] = $9;
        HEAP32[($3 + 356 | 0) >> 2] = $4;
        HEAP32[($3 + 352 | 0) >> 2] = $8;
        $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__hbd56bd5c906359e6($3 + 352 | 0 | 0);
       }
       label$16 : {
        if (!(HEAP32[($1 + 456 | 0) >> 2] | 0)) {
         break label$16
        }
        cardano_serialization_lib___impl_20core__convert__From__cardano_serialization_lib__NativeScripts__20for_20alloc__collections__btree__set__BTreeSet_cardano_serialization_lib__crypto__Ed25519KeyHash____from__h8d3ffd91703d691f($3 + 256 | 0 | 0, $1 + 456 | 0 | 0);
        label$17 : {
         label$18 : {
          $8 = HEAP32[($3 + 260 | 0) >> 2] | 0;
          if (!$8) {
           break label$18
          }
          $4 = HEAP32[($3 + 264 | 0) >> 2] | 0;
          $9 = HEAP32[($3 + 256 | 0) >> 2] | 0;
          alloc__collections__btree__navigate__full_range__h55a07d6b3102a73e($3 + 304 | 0 | 0, $9 | 0, $8 | 0, $9 | 0, $8 | 0);
          break label$17;
         }
         $4 = 0;
         HEAP32[($3 + 320 | 0) >> 2] = 0;
         HEAP32[($3 + 308 | 0) >> 2] = 0;
        }
        HEAP32[(($3 + 304 | 0) + 24 | 0) >> 2] = $4;
        HEAP32[(($3 + 624 | 0) + 24 | 0) >> 2] = $4;
        i64toi32_i32$2 = ($3 + 304 | 0) + 16 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $503 = i64toi32_i32$1;
        i64toi32_i32$1 = ($3 + 624 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $503;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = ($3 + 304 | 0) + 8 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $510 = i64toi32_i32$0;
        i64toi32_i32$0 = ($3 + 624 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $510;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$2 = $3;
        i64toi32_i32$1 = HEAP32[($3 + 304 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[($3 + 308 | 0) >> 2] | 0;
        $513 = i64toi32_i32$1;
        i64toi32_i32$1 = $3;
        HEAP32[($3 + 624 | 0) >> 2] = $513;
        HEAP32[($3 + 628 | 0) >> 2] = i64toi32_i32$0;
        $alloc__collections__btree__map__IntoIter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h8343c8d1ae260056($3 + 352 | 0 | 0, $3 + 624 | 0 | 0);
        label$19 : {
         if ((HEAPU8[($3 + 352 | 0) >> 0] | 0 | 0) != (1 | 0)) {
          break label$19
         }
         $65 = $3 + 377 | 0;
         $4 = HEAPU8[$65 >> 0] | 0 | ((HEAPU8[($65 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($65 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($65 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP32[(($3 + 688 | 0) + 24 | 0) >> 2] = $4;
         i64toi32_i32$2 = $3 + 369 | 0;
         i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $13 = i64toi32_i32$0;
         $13$hi = i64toi32_i32$1;
         i64toi32_i32$0 = ($3 + 688 | 0) + 16 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $13;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$2 = $3 + 361 | 0;
         i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $14 = i64toi32_i32$1;
         $14$hi = i64toi32_i32$0;
         i64toi32_i32$1 = ($3 + 688 | 0) + 8 | 0;
         HEAP32[i64toi32_i32$1 >> 2] = $14;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$2 = $3;
         i64toi32_i32$0 = HEAPU8[($3 + 353 | 0) >> 0] | 0 | ((HEAPU8[($3 + 354 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 355 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 356 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$1 = HEAPU8[($3 + 357 | 0) >> 0] | 0 | ((HEAPU8[($3 + 358 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 359 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 360 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $15 = i64toi32_i32$0;
         $15$hi = i64toi32_i32$1;
         i64toi32_i32$0 = $3;
         HEAP32[($3 + 688 | 0) >> 2] = $15;
         HEAP32[($3 + 692 | 0) >> 2] = i64toi32_i32$1;
         HEAP32[(($3 + 352 | 0) + 24 | 0) >> 2] = $4;
         i64toi32_i32$1 = $13$hi;
         i64toi32_i32$0 = ($3 + 352 | 0) + 16 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $13;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$1 = $14$hi;
         i64toi32_i32$0 = ($3 + 352 | 0) + 8 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $14;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$1 = $15$hi;
         i64toi32_i32$0 = $3;
         HEAP32[($3 + 352 | 0) >> 2] = $15;
         HEAP32[($3 + 356 | 0) >> 2] = i64toi32_i32$1;
         alloc__collections__btree__map__BTreeMap_K_2cV___insert__h5d8c7a7452747b0f($3 + 224 | 0 | 0, $3 + 352 | 0 | 0) | 0;
         $alloc__collections__btree__map__IntoIter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h8343c8d1ae260056($3 + 352 | 0 | 0, $3 + 624 | 0 | 0);
         if ((HEAPU8[($3 + 352 | 0) >> 0] | 0 | 0) != (1 | 0)) {
          break label$19
         }
         $4 = $3 + 352 | 0 | 1 | 0;
         label$20 : while (1) {
          $66 = $4 + 24 | 0;
          $8 = HEAPU8[$66 >> 0] | 0 | ((HEAPU8[($66 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($66 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($66 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          HEAP32[(($3 + 688 | 0) + 24 | 0) >> 2] = $8;
          i64toi32_i32$2 = $4 + 16 | 0;
          i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          $13 = i64toi32_i32$1;
          $13$hi = i64toi32_i32$0;
          i64toi32_i32$1 = ($3 + 688 | 0) + 16 | 0;
          HEAP32[i64toi32_i32$1 >> 2] = $13;
          HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
          i64toi32_i32$2 = $4 + 8 | 0;
          i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          $14 = i64toi32_i32$0;
          $14$hi = i64toi32_i32$1;
          i64toi32_i32$0 = ($3 + 688 | 0) + 8 | 0;
          HEAP32[i64toi32_i32$0 >> 2] = $14;
          HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
          i64toi32_i32$2 = $4;
          i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          $15 = i64toi32_i32$1;
          $15$hi = i64toi32_i32$0;
          i64toi32_i32$1 = $3;
          HEAP32[($3 + 688 | 0) >> 2] = $15;
          HEAP32[($3 + 692 | 0) >> 2] = i64toi32_i32$0;
          HEAP32[(($3 + 352 | 0) + 24 | 0) >> 2] = $8;
          i64toi32_i32$0 = $13$hi;
          i64toi32_i32$1 = ($3 + 352 | 0) + 16 | 0;
          HEAP32[i64toi32_i32$1 >> 2] = $13;
          HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
          i64toi32_i32$0 = $14$hi;
          i64toi32_i32$1 = ($3 + 352 | 0) + 8 | 0;
          HEAP32[i64toi32_i32$1 >> 2] = $14;
          HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
          i64toi32_i32$0 = $15$hi;
          i64toi32_i32$1 = $3;
          HEAP32[($3 + 352 | 0) >> 2] = $15;
          HEAP32[($3 + 356 | 0) >> 2] = i64toi32_i32$0;
          alloc__collections__btree__map__BTreeMap_K_2cV___insert__h5d8c7a7452747b0f($3 + 224 | 0 | 0, $3 + 352 | 0 | 0) | 0;
          $alloc__collections__btree__map__IntoIter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h8343c8d1ae260056($3 + 352 | 0 | 0, $3 + 624 | 0 | 0);
          if ((HEAPU8[($3 + 352 | 0) >> 0] | 0 | 0) == (1 | 0)) {
           continue label$20
          }
          break label$20;
         };
        }
        $4 = HEAP32[($3 + 628 | 0) >> 2] | 0;
        if (!$4) {
         break label$16
        }
        $8 = HEAP32[($3 + 624 | 0) >> 2] | 0;
        $9 = HEAP32[($3 + 632 | 0) >> 2] | 0;
        HEAP32[($3 + 364 | 0) >> 2] = HEAP32[($3 + 648 | 0) >> 2] | 0;
        HEAP32[($3 + 360 | 0) >> 2] = $9;
        HEAP32[($3 + 356 | 0) >> 2] = $4;
        HEAP32[($3 + 352 | 0) >> 2] = $8;
        $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__hbd56bd5c906359e6($3 + 352 | 0 | 0);
       }
       $8 = HEAP32[($3 + 232 | 0) >> 2] | 0;
       $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h04a6b671c790649f($3 + 224 | 0 | 0);
       $10 = 0;
       label$21 : {
        label$22 : {
         if ($8) {
          break label$22
         }
         $11 = 0;
         break label$21;
        }
        i64toi32_i32$1 = $3;
        i64toi32_i32$0 = 0;
        HEAP32[($3 + 692 | 0) >> 2] = 0;
        HEAP32[($3 + 696 | 0) >> 2] = i64toi32_i32$0;
        HEAP32[($3 + 688 | 0) >> 2] = HEAP32[(0 + 1066212 | 0) >> 2] | 0;
        $4 = $3 + 352 | 0 | 7 | 0;
        $9 = $3 + 384 | 0;
        label$23 : while (1) {
         i64toi32_i32$2 = $3;
         i64toi32_i32$0 = HEAP32[($3 + 96 | 0) >> 2] | 0;
         i64toi32_i32$1 = HEAP32[($3 + 100 | 0) >> 2] | 0;
         $660 = i64toi32_i32$0;
         i64toi32_i32$0 = $4;
         $67 = $660;
         HEAP8[i64toi32_i32$0 >> 0] = $67;
         HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $67 >>> 8 | 0;
         HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $67 >>> 16 | 0;
         HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $67 >>> 24 | 0;
         HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
         HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
         HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
         HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
         i64toi32_i32$2 = ($3 + 96 | 0) + 8 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $666 = i64toi32_i32$1;
         i64toi32_i32$1 = $4 + 8 | 0;
         $68 = $666;
         HEAP8[i64toi32_i32$1 >> 0] = $68;
         HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $68 >>> 8 | 0;
         HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $68 >>> 16 | 0;
         HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $68 >>> 24 | 0;
         HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
         HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
         HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
         HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
         i64toi32_i32$2 = ($3 + 96 | 0) + 16 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $672 = i64toi32_i32$0;
         i64toi32_i32$0 = $4 + 16 | 0;
         $69 = $672;
         HEAP8[i64toi32_i32$0 >> 0] = $69;
         HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $69 >>> 8 | 0;
         HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $69 >>> 16 | 0;
         HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $69 >>> 24 | 0;
         HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
         HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
         HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
         HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
         HEAP8[($4 + 24 | 0) >> 0] = HEAPU8[(($3 + 96 | 0) + 24 | 0) >> 0] | 0;
         HEAP8[($3 + 355 | 0) >> 0] = $5;
         HEAP8[($3 + 356 | 0) >> 0] = $5 >>> 8 | 0;
         HEAP8[($3 + 357 | 0) >> 0] = $5 >>> 16 | 0;
         HEAP8[($3 + 358 | 0) >> 0] = $5 >>> 24 | 0;
         HEAP8[($3 + 353 | 0) >> 0] = $6;
         HEAP8[($3 + 354 | 0) >> 0] = $6 >>> 8 | 0;
         HEAP8[($3 + 352 | 0) >> 0] = $7;
         memcpy($9 | 0, $3 + 128 | 0 | 0, 64 | 0) | 0;
         cardano_serialization_lib__crypto__Vkeywitnesses__add__he21d7a30d5c7de68($3 + 688 | 0 | 0, $3 + 352 | 0 | 0);
         $8 = $8 + -1 | 0;
         if ($8) {
          continue label$23
         }
         break label$23;
        };
        i64toi32_i32$2 = $3;
        i64toi32_i32$1 = HEAP32[($3 + 692 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[($3 + 696 | 0) >> 2] | 0;
        $14 = i64toi32_i32$1;
        $14$hi = i64toi32_i32$0;
        $11 = HEAP32[($3 + 688 | 0) >> 2] | 0;
       }
       $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__hf5a9da539450c63e($3 + 192 | 0 | 0, $1 + 148 | 0 | 0);
       label$24 : {
        $12 = HEAP32[($3 + 200 | 0) >> 2] | 0;
        if ($12) {
         break label$24
        }
        break label$1;
       }
       i64toi32_i32$1 = $3;
       i64toi32_i32$0 = 0;
       HEAP32[($3 + 212 | 0) >> 2] = 0;
       HEAP32[($3 + 216 | 0) >> 2] = i64toi32_i32$0;
       $4 = 0;
       HEAP32[($3 + 208 | 0) >> 2] = HEAP32[(0 + 1066220 | 0) >> 2] | 0;
       label$25 : {
        label$26 : {
         $8 = HEAP32[($3 + 196 | 0) >> 2] | 0;
         if (!$8) {
          break label$26
         }
         $4 = HEAP32[($3 + 192 | 0) >> 2] | 0;
         alloc__collections__btree__navigate__full_range__h1f8644a2089cd237($3 + 224 | 0 | 0, $4 | 0, $8 | 0, $4 | 0, $8 | 0);
         $4 = $12;
         break label$25;
        }
        HEAP32[($3 + 240 | 0) >> 2] = 0;
        HEAP32[($3 + 228 | 0) >> 2] = 0;
       }
       HEAP32[(($3 + 224 | 0) + 24 | 0) >> 2] = $4;
       HEAP32[(($3 + 256 | 0) + 24 | 0) >> 2] = $4;
       i64toi32_i32$2 = ($3 + 224 | 0) + 16 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $740 = i64toi32_i32$0;
       i64toi32_i32$0 = ($3 + 256 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $740;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = ($3 + 224 | 0) + 8 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $747 = i64toi32_i32$1;
       i64toi32_i32$1 = ($3 + 256 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $747;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = $3;
       i64toi32_i32$0 = HEAP32[($3 + 224 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($3 + 228 | 0) >> 2] | 0;
       $750 = i64toi32_i32$0;
       i64toi32_i32$0 = $3;
       HEAP32[($3 + 256 | 0) >> 2] = $750;
       HEAP32[($3 + 260 | 0) >> 2] = i64toi32_i32$1;
       $alloc__collections__btree__map__IntoIter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__hfe05475557963367($3 + 352 | 0 | 0, $3 + 256 | 0 | 0);
       $4 = HEAP32[($3 + 352 | 0) >> 2] | 0;
       if (!$4) {
        break label$2
       }
       i64toi32_i32$2 = $3;
       i64toi32_i32$1 = HEAP32[($3 + 356 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[($3 + 360 | 0) >> 2] | 0;
       $761 = i64toi32_i32$1;
       i64toi32_i32$1 = $3;
       HEAP32[($3 + 292 | 0) >> 2] = $761;
       HEAP32[($3 + 296 | 0) >> 2] = i64toi32_i32$0;
       HEAP32[($3 + 288 | 0) >> 2] = $4;
       i64toi32_i32$1 = ($3 + 304 | 0) + 24 | 0;
       i64toi32_i32$0 = 0;
       HEAP32[i64toi32_i32$1 >> 2] = 0;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$1 = ($3 + 304 | 0) + 16 | 0;
       i64toi32_i32$0 = 0;
       HEAP32[i64toi32_i32$1 >> 2] = 0;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$1 = ($3 + 304 | 0) + 8 | 0;
       i64toi32_i32$0 = 0;
       HEAP32[i64toi32_i32$1 >> 2] = 0;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$1 = $3;
       i64toi32_i32$0 = 0;
       HEAP32[($3 + 304 | 0) >> 2] = 0;
       HEAP32[($3 + 308 | 0) >> 2] = i64toi32_i32$0;
       $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($3 + 336 | 0 | 0, $3 + 288 | 0 | 0);
       cardano_serialization_lib__address__ByronAddress__from_bytes__h9704f398e56b45f1($3 + 688 | 0 | 0, $3 + 336 | 0 | 0);
       label$27 : {
        if ((HEAP32[($3 + 688 | 0) >> 2] | 0 | 0) == (1 | 0)) {
         break label$27
        }
        $4 = $3 + 364 | 0;
        $5 = $3 + 688 | 0 | 4 | 0;
        $6 = $3 + 328 | 0;
        $7 = $3 + 320 | 0;
        $9 = $3 + 312 | 0;
        label$28 : while (1) {
         memcpy($3 + 624 | 0 | 0, $5 | 0, 52 | 0) | 0;
         cardano_serialization_lib__utils__make_icarus_bootstrap_witness__h3e3e2f5db19a8349($3 + 352 | 0 | 0, $3 + 304 | 0 | 0, $3 + 624 | 0 | 0, $3 | 0);
         cardano_serialization_lib__crypto__BootstrapWitnesses__add__h053adaa5938ec849($3 + 208 | 0 | 0, $3 + 352 | 0 | 0);
         $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 352 | 0 | 0);
         $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 352 | 0 | 0);
         $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($4 | 0);
         $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($4 | 0);
         core__ptr__drop_in_place_cardano_serialization_lib__address__ByronAddress___he7d0684706668546($3 + 624 | 0 | 0);
         $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 288 | 0 | 0);
         $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 288 | 0 | 0);
         $alloc__collections__btree__map__IntoIter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__hfe05475557963367($3 + 352 | 0 | 0, $3 + 256 | 0 | 0);
         $8 = HEAP32[($3 + 352 | 0) >> 2] | 0;
         if (!$8) {
          break label$2
         }
         i64toi32_i32$2 = $3;
         i64toi32_i32$0 = HEAP32[($3 + 356 | 0) >> 2] | 0;
         i64toi32_i32$1 = HEAP32[($3 + 360 | 0) >> 2] | 0;
         $833 = i64toi32_i32$0;
         i64toi32_i32$0 = $3;
         HEAP32[($3 + 292 | 0) >> 2] = $833;
         HEAP32[($3 + 296 | 0) >> 2] = i64toi32_i32$1;
         HEAP32[($3 + 288 | 0) >> 2] = $8;
         i64toi32_i32$0 = $6;
         i64toi32_i32$1 = 0;
         HEAP32[i64toi32_i32$0 >> 2] = 0;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$0 = $7;
         i64toi32_i32$1 = 0;
         HEAP32[i64toi32_i32$0 >> 2] = 0;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$0 = $9;
         i64toi32_i32$1 = 0;
         HEAP32[i64toi32_i32$0 >> 2] = 0;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$0 = $3;
         i64toi32_i32$1 = 0;
         HEAP32[($3 + 304 | 0) >> 2] = 0;
         HEAP32[($3 + 308 | 0) >> 2] = i64toi32_i32$1;
         $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($3 + 336 | 0 | 0, $3 + 288 | 0 | 0);
         cardano_serialization_lib__address__ByronAddress__from_bytes__h9704f398e56b45f1($3 + 688 | 0 | 0, $3 + 336 | 0 | 0);
         if ((HEAP32[($3 + 688 | 0) >> 2] | 0 | 0) != (1 | 0)) {
          continue label$28
         }
         break label$28;
        };
       }
       HEAP32[($3 + 336 | 0) >> 2] = HEAP32[($3 + 692 | 0) >> 2] | 0;
       core__result__unwrap_failed__h27f43d993c3864a1(1063711 | 0, 43 | 0, $3 + 336 | 0 | 0, 1063756 | 0, 1064040 | 0);
       abort();
      }
      HEAP32[$3 >> 2] = HEAP32[($3 + 356 | 0) >> 2] | 0;
      core__result__unwrap_failed__h27f43d993c3864a1(1063711 | 0, 43 | 0, $3 | 0, 1063756 | 0, 1063976 | 0);
      abort();
     }
     $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
     alloc__alloc__handle_alloc_error__he269d8f1bff90960(64 | 0, 1 | 0);
     abort();
    }
    HEAP32[($3 + 688 | 0) >> 2] = HEAP32[($3 + 356 | 0) >> 2] | 0;
    core__result__unwrap_failed__h27f43d993c3864a1(1063711 | 0, 43 | 0, $3 + 688 | 0 | 0, 1063756 | 0, 1063992 | 0);
    abort();
   }
   label$29 : {
    $4 = HEAP32[($3 + 260 | 0) >> 2] | 0;
    if (!$4) {
     break label$29
    }
    $8 = HEAP32[($3 + 256 | 0) >> 2] | 0;
    $5 = HEAP32[($3 + 264 | 0) >> 2] | 0;
    HEAP32[($3 + 364 | 0) >> 2] = HEAP32[($3 + 280 | 0) >> 2] | 0;
    HEAP32[($3 + 360 | 0) >> 2] = $5;
    HEAP32[($3 + 356 | 0) >> 2] = $4;
    HEAP32[($3 + 352 | 0) >> 2] = $8;
    $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__hdb3d805366b8acdd($3 + 352 | 0 | 0);
   }
   $10 = HEAP32[($3 + 208 | 0) >> 2] | 0;
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[($3 + 212 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($3 + 216 | 0) >> 2] | 0;
   $15 = i64toi32_i32$1;
   $15$hi = i64toi32_i32$0;
  }
  cardano_serialization_lib__tx_builder__TransactionBuilder__get_combined_plutus_scripts__he342d6c2d4187ac3($3 + 624 | 0 | 0, $1 | 0);
  label$30 : {
   label$31 : {
    if (HEAP32[($3 + 624 | 0) >> 2] | 0) {
     break label$31
    }
    $5 = 3;
    $6 = 0;
    $7 = 0;
    break label$30;
   }
   HEAP32[(($3 + 688 | 0) + 8 | 0) >> 2] = HEAP32[(($3 + 624 | 0) + 8 | 0) >> 2] | 0;
   i64toi32_i32$2 = $3;
   i64toi32_i32$0 = HEAP32[($3 + 624 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($3 + 628 | 0) >> 2] | 0;
   $902 = i64toi32_i32$0;
   i64toi32_i32$0 = $3;
   HEAP32[($3 + 688 | 0) >> 2] = $902;
   HEAP32[($3 + 692 | 0) >> 2] = i64toi32_i32$1;
   cardano_serialization_lib__tx_builder__tx_inputs_builder__PlutusWitnesses__collect__h298b5e0ce4f6a5da($3 + 352 | 0 | 0, $3 + 688 | 0 | 0);
   HEAP32[(($3 + 304 | 0) + 8 | 0) >> 2] = HEAP32[($3 + 372 | 0) >> 2] | 0;
   HEAP8[($3 + 258 | 0) >> 0] = HEAPU8[($3 + 379 | 0) >> 0] | 0;
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[($3 + 364 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($3 + 368 | 0) >> 2] | 0;
   $920 = i64toi32_i32$1;
   i64toi32_i32$1 = $3;
   HEAP32[($3 + 304 | 0) >> 2] = $920;
   HEAP32[($3 + 308 | 0) >> 2] = i64toi32_i32$0;
   $70 = $3 + 377 | 0;
   HEAP16[($3 + 256 | 0) >> 1] = HEAPU8[$70 >> 0] | 0 | ((HEAPU8[($70 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
   $5 = HEAPU8[($3 + 376 | 0) >> 0] | 0;
   i64toi32_i32$2 = $3 + 384 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $16 = i64toi32_i32$0;
   $16$hi = i64toi32_i32$1;
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[($3 + 356 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($3 + 360 | 0) >> 2] | 0;
   $17 = i64toi32_i32$1;
   $17$hi = i64toi32_i32$0;
   $6 = HEAP32[($3 + 352 | 0) >> 2] | 0;
   $7 = HEAP32[($3 + 380 | 0) >> 2] | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h1bbffe174ae872d8($3 + 688 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h9b1d3bb47b46eeb8($3 + 688 | 0 | 0);
  }
  $4 = ($3 + 336 | 0) + 8 | 0;
  HEAP32[$4 >> 2] = HEAP32[(($3 + 304 | 0) + 8 | 0) >> 2] | 0;
  $8 = ($3 + 288 | 0) + 2 | 0;
  HEAP8[$8 >> 0] = HEAPU8[(($3 + 256 | 0) + 2 | 0) >> 0] | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[($3 + 304 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($3 + 308 | 0) >> 2] | 0;
  $959 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[($3 + 336 | 0) >> 2] = $959;
  HEAP32[($3 + 340 | 0) >> 2] = i64toi32_i32$1;
  HEAP16[($3 + 288 | 0) >> 1] = HEAPU16[($3 + 256 | 0) >> 1] | 0;
  cardano_serialization_lib__tx_builder__TransactionBuilder__get_combined_native_scripts__hf14076d78c87659b($3 + 224 | 0 | 0, $1 | 0);
  memcpy($3 + 352 | 0 | 0, $2 | 0, 272 | 0) | 0;
  i64toi32_i32$1 = 0;
  $13 = 0;
  $13$hi = i64toi32_i32$1;
  label$32 : {
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 328 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 332 | 0) >> 2] | 0;
   i64toi32_i32$2 = i64toi32_i32$1;
   i64toi32_i32$1 = 0;
   if ((i64toi32_i32$2 | 0) != (1 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | 0) {
    break label$32
   }
   label$33 : {
    label$34 : {
     if (HEAP32[($1 + 356 | 0) >> 2] | 0) {
      break label$34
     }
     HEAP32[($3 + 644 | 0) >> 2] = 0;
     break label$33;
    }
    $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h44c6d4679ef9fae6($3 + 624 | 0 | 0, $1 + 336 | 0 | 0);
   }
   $9 = $1 + 388 | 0;
   label$35 : {
    label$36 : {
     $2 = HEAP32[($1 + 376 | 0) >> 2] | 0;
     if ($2) {
      break label$36
     }
     HEAP32[($3 + 256 | 0) >> 2] = 0;
     break label$35;
    }
    alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($3 + 256 | 0 | 0, $2 | 0, HEAP32[($1 + 384 | 0) >> 2] | 0 | 0);
   }
   label$37 : {
    label$38 : {
     if (HEAP32[$9 >> 2] | 0) {
      break label$38
     }
     HEAP32[($3 + 304 | 0) >> 2] = 0;
     break label$37;
    }
    $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hc722e22117ee5940($3 + 304 | 0 | 0, $9 | 0);
   }
   memcpy($3 + 688 | 0 | 0, $3 + 624 | 0 | 0, 40 | 0) | 0;
   HEAP32[($3 + 736 | 0) >> 2] = HEAP32[(($3 + 256 | 0) + 8 | 0) >> 2] | 0;
   HEAP32[($3 + 748 | 0) >> 2] = HEAP32[(($3 + 304 | 0) + 8 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($3 + 256 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($3 + 260 | 0) >> 2] | 0;
   $1019 = i64toi32_i32$2;
   i64toi32_i32$2 = $3;
   HEAP32[($3 + 728 | 0) >> 2] = $1019;
   HEAP32[($3 + 732 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = HEAP32[($3 + 304 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($3 + 308 | 0) >> 2] | 0;
   $1022 = i64toi32_i32$0;
   i64toi32_i32$0 = $3;
   HEAP32[($3 + 740 | 0) >> 2] = $1022;
   HEAP32[($3 + 744 | 0) >> 2] = i64toi32_i32$2;
   memcpy($3 + 624 | 0 | 0, $3 + 688 | 0 | 0, 64 | 0) | 0;
   i64toi32_i32$2 = 0;
   $13 = 1;
   $13$hi = i64toi32_i32$2;
  }
  memcpy($0 + 8 | 0 | 0, $3 + 352 | 0 | 0, 272 | 0) | 0;
  HEAP32[($0 + 372 | 0) >> 2] = HEAP32[(($3 + 224 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[($3 + 224 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($3 + 228 | 0) >> 2] | 0;
  $1042 = i64toi32_i32$2;
  i64toi32_i32$2 = $0 + 364 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $1042;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[($3 + 336 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[($3 + 340 | 0) >> 2] | 0;
  $1046 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 400 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $1046;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  HEAP32[($0 + 408 | 0) >> 2] = HEAP32[$4 >> 2] | 0;
  memcpy($0 + 288 | 0 | 0, $3 + 624 | 0 | 0, 64 | 0) | 0;
  HEAP8[($0 + 412 | 0) >> 0] = $5;
  i64toi32_i32$2 = $17$hi;
  i64toi32_i32$0 = $0 + 392 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $17;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  HEAP32[($0 + 388 | 0) >> 2] = $6;
  i64toi32_i32$2 = $15$hi;
  i64toi32_i32$0 = $0 + 380 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $15;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  HEAP32[($0 + 376 | 0) >> 2] = $10;
  i64toi32_i32$2 = $14$hi;
  i64toi32_i32$0 = $0 + 356 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $14;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  HEAP32[($0 + 352 | 0) >> 2] = $11;
  i64toi32_i32$2 = $13$hi;
  i64toi32_i32$0 = $0 + 280 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $13;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  $71 = HEAPU16[($3 + 288 | 0) >> 1] | 0;
  HEAP8[($0 + 413 | 0) >> 0] = $71;
  HEAP8[($0 + 414 | 0) >> 0] = $71 >>> 8 | 0;
  HEAP8[($0 + 415 | 0) >> 0] = HEAPU8[$8 >> 0] | 0;
  HEAP8[($0 + 428 | 0) >> 0] = 1;
  i64toi32_i32$2 = $16$hi;
  i64toi32_i32$0 = $0 + 420 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $16;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  HEAP32[($0 + 416 | 0) >> 2] = $7;
  HEAP32[$0 >> 2] = 0;
  label$39 : {
   if ($12) {
    break label$39
   }
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__hb1ec706811634e79($3 + 192 | 0 | 0);
  }
  $ed25519_bip32__key__XPrv_20as_20core__ops__drop__Drop___drop__h041b586f91562314($3 | 0);
  global$0 = $3 + 752 | 0;
 }
 
 function core__num__flt2dec__strategy__dragon__format_exact__h268bf58f3472e2c0($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $6 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$4 = 0, $5 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, $9 = 0, $29$hi = 0, $10 = 0, $7 = 0, $15 = 0, $29 = 0, $12 = 0, $14 = 0, $11 = 0, $13 = 0, $26 = 0, $30$hi = 0, $8 = 0, $28 = 0, $30 = 0, $25 = 0, $27 = 0, i64toi32_i32$6 = 0, $20 = 0, $31$hi = 0, $31 = 0, $24 = 0, $66 = 0, $67 = 0, $68 = 0, $69 = 0, $70 = 0, $71 = 0, $72 = 0, $73 = 0, $21 = 0, $22 = 0, $23 = 0, $74 = 0, $75 = 0, $49$hi = 0, $54$hi = 0, $65 = 0, $65$hi = 0, $68$hi = 0, $162 = 0, $164$hi = 0, $166 = 0, $166$hi = 0, $173 = 0, $173$hi = 0, $206 = 0, $208$hi = 0, $210 = 0, $210$hi = 0, $219 = 0, $219$hi = 0, $341 = 0, $76 = 0, $344$hi = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $788 = 0, $77 = 0, $791$hi = 0, $827 = 0, $78 = 0, $830$hi = 0;
  $5 = global$0 - 848 | 0;
  global$0 = $5;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           label$10 : {
            label$11 : {
             label$12 : {
              label$13 : {
               label$14 : {
                label$15 : {
                 label$16 : {
                  label$17 : {
                   label$18 : {
                    label$19 : {
                     label$20 : {
                      label$21 : {
                       label$22 : {
                        label$23 : {
                         label$24 : {
                          label$25 : {
                           label$26 : {
                            label$27 : {
                             label$28 : {
                              label$29 : {
                               label$30 : {
                                label$31 : {
                                 label$32 : {
                                  i64toi32_i32$2 = $1;
                                  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
                                  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
                                  $29 = i64toi32_i32$0;
                                  $29$hi = i64toi32_i32$1;
                                  if (!(i64toi32_i32$0 | i64toi32_i32$1 | 0)) {
                                   break label$32
                                  }
                                  i64toi32_i32$2 = $1;
                                  i64toi32_i32$1 = HEAP32[($1 + 8 | 0) >> 2] | 0;
                                  i64toi32_i32$0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
                                  $30 = i64toi32_i32$1;
                                  $30$hi = i64toi32_i32$0;
                                  if (!(i64toi32_i32$1 | i64toi32_i32$0 | 0)) {
                                   break label$31
                                  }
                                  i64toi32_i32$2 = $1;
                                  i64toi32_i32$0 = HEAP32[($1 + 16 | 0) >> 2] | 0;
                                  i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
                                  $31 = i64toi32_i32$0;
                                  $31$hi = i64toi32_i32$1;
                                  if (!(i64toi32_i32$0 | i64toi32_i32$1 | 0)) {
                                   break label$30
                                  }
                                  i64toi32_i32$1 = $29$hi;
                                  i64toi32_i32$1 = $31$hi;
                                  i64toi32_i32$1 = $29$hi;
                                  i64toi32_i32$2 = $29;
                                  i64toi32_i32$0 = $31$hi;
                                  i64toi32_i32$3 = $31;
                                  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
                                  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
                                  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
                                   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
                                  }
                                  $49$hi = i64toi32_i32$5;
                                  i64toi32_i32$5 = $29$hi;
                                  i64toi32_i32$5 = $49$hi;
                                  i64toi32_i32$1 = i64toi32_i32$4;
                                  i64toi32_i32$2 = $29$hi;
                                  i64toi32_i32$3 = $29;
                                  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0) {
                                   break label$29
                                  }
                                  i64toi32_i32$1 = $29$hi;
                                  i64toi32_i32$1 = $30$hi;
                                  i64toi32_i32$1 = $29$hi;
                                  i64toi32_i32$3 = $29;
                                  i64toi32_i32$5 = $30$hi;
                                  i64toi32_i32$2 = $30;
                                  i64toi32_i32$0 = i64toi32_i32$3 - i64toi32_i32$2 | 0;
                                  i64toi32_i32$6 = i64toi32_i32$3 >>> 0 < i64toi32_i32$2 >>> 0;
                                  i64toi32_i32$4 = i64toi32_i32$6 + i64toi32_i32$5 | 0;
                                  i64toi32_i32$4 = i64toi32_i32$1 - i64toi32_i32$4 | 0;
                                  $54$hi = i64toi32_i32$4;
                                  i64toi32_i32$4 = i64toi32_i32$1;
                                  i64toi32_i32$4 = $54$hi;
                                  i64toi32_i32$1 = i64toi32_i32$0;
                                  i64toi32_i32$3 = $29$hi;
                                  i64toi32_i32$2 = $29;
                                  if (i64toi32_i32$4 >>> 0 > i64toi32_i32$3 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$1 >>> 0 > i64toi32_i32$2 >>> 0 | 0) | 0) {
                                   break label$27
                                  }
                                  $6 = HEAPU16[($1 + 24 | 0) >> 1] | 0;
                                  $1 = 0;
                                  memset($5 + 680 | 0 | 0, 0 | 0, 160 | 0) | 0;
                                  i64toi32_i32$1 = 0;
                                  i64toi32_i32$2 = $6;
                                  i64toi32_i32$4 = 0;
                                  i64toi32_i32$3 = 48;
                                  i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
                                  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                                   i64toi32_i32$4 = i64toi32_i32$2 << i64toi32_i32$5 | 0;
                                   $66 = 0;
                                  } else {
                                   i64toi32_i32$4 = ((1 << i64toi32_i32$5 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$5 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$5 | 0) | 0;
                                   $66 = i64toi32_i32$2 << i64toi32_i32$5 | 0;
                                  }
                                  i64toi32_i32$1 = $66;
                                  i64toi32_i32$2 = 0;
                                  i64toi32_i32$3 = 48;
                                  i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
                                  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                                   i64toi32_i32$2 = i64toi32_i32$4 >> 31 | 0;
                                   $67 = i64toi32_i32$4 >> i64toi32_i32$5 | 0;
                                  } else {
                                   i64toi32_i32$2 = i64toi32_i32$4 >> i64toi32_i32$5 | 0;
                                   $67 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$5 | 0) | 0;
                                  }
                                  $65 = $67;
                                  $65$hi = i64toi32_i32$2;
                                  i64toi32_i32$2 = $29$hi;
                                  i64toi32_i32$4 = $29;
                                  i64toi32_i32$1 = -1;
                                  i64toi32_i32$3 = -1;
                                  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
                                  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
                                  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
                                   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
                                  }
                                  i64toi32_i32$4 = i64toi32_i32$5;
                                  i64toi32_i32$3 = Math_clz32(i64toi32_i32$0);
                                  i64toi32_i32$2 = 0;
                                  if ((i64toi32_i32$3 | 0) == (32 | 0)) {
                                   $68 = Math_clz32(i64toi32_i32$4) + 32 | 0
                                  } else {
                                   $68 = i64toi32_i32$3
                                  }
                                  $68$hi = i64toi32_i32$2;
                                  i64toi32_i32$2 = $65$hi;
                                  i64toi32_i32$4 = $65;
                                  i64toi32_i32$0 = $68$hi;
                                  i64toi32_i32$3 = $68;
                                  i64toi32_i32$1 = i64toi32_i32$4 - i64toi32_i32$3 | 0;
                                  i64toi32_i32$6 = i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0;
                                  i64toi32_i32$5 = i64toi32_i32$6 + i64toi32_i32$0 | 0;
                                  i64toi32_i32$5 = i64toi32_i32$2 - i64toi32_i32$5 | 0;
                                  i64toi32_i32$4 = 0;
                                  i64toi32_i32$4 = __wasm_i64_mul(i64toi32_i32$1 | 0, i64toi32_i32$5 | 0, 1292913986 | 0, i64toi32_i32$4 | 0) | 0;
                                  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
                                  i64toi32_i32$2 = i64toi32_i32$4;
                                  i64toi32_i32$4 = 19;
                                  i64toi32_i32$3 = 1142116480;
                                  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
                                  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
                                  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
                                   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
                                  }
                                  i64toi32_i32$5 = i64toi32_i32$0;
                                  i64toi32_i32$2 = 0;
                                  i64toi32_i32$3 = 32;
                                  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
                                  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                                   i64toi32_i32$2 = 0;
                                   $69 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
                                  } else {
                                   i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
                                   $69 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$4 | 0) | 0;
                                  }
                                  $7 = $69;
                                  $8 = ($7 << 16 | 0) >> 16 | 0;
                                  $9 = ($6 << 16 | 0) >> 16 | 0;
                                  $10 = $5 + 680 | 0;
                                  label$33 : while (1) {
                                   if (($1 | 0) == (40 | 0)) {
                                    break label$28
                                   }
                                   i64toi32_i32$2 = $29$hi;
                                   HEAP32[$10 >> 2] = $29;
                                   $10 = $10 + 4 | 0;
                                   $1 = $1 + 1 | 0;
                                   i64toi32_i32$1 = $29;
                                   i64toi32_i32$5 = 0;
                                   i64toi32_i32$3 = 32;
                                   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
                                   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                                    i64toi32_i32$5 = 0;
                                    $70 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
                                   } else {
                                    i64toi32_i32$5 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
                                    $70 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
                                   }
                                   $29 = $70;
                                   $29$hi = i64toi32_i32$5;
                                   if (!!($29 | i64toi32_i32$5 | 0)) {
                                    continue label$33
                                   }
                                   break label$33;
                                  };
                                  memcpy($5 + 8 | 0 | 4 | 0 | 0, $5 + 680 | 0 | 0, 160 | 0) | 0;
                                  HEAP32[($5 + 8 | 0) >> 2] = $1;
                                  memset($5 + 184 | 0 | 0, 0 | 0, 156 | 0) | 0;
                                  i64toi32_i32$1 = $5;
                                  i64toi32_i32$5 = 1;
                                  HEAP32[(i64toi32_i32$1 + 176 | 0) >> 2] = 1;
                                  HEAP32[(i64toi32_i32$1 + 180 | 0) >> 2] = i64toi32_i32$5;
                                  label$34 : {
                                   label$35 : {
                                    if (($9 | 0) < (0 | 0)) {
                                     break label$35
                                    }
                                    core__num__bignum__Big32x40__mul_pow2__haaaae198d66328c2($5 + 8 | 0 | 0, $6 | 0) | 0;
                                    break label$34;
                                   }
                                   core__num__bignum__Big32x40__mul_pow2__haaaae198d66328c2($5 + 176 | 0 | 0, ((0 - $9 | 0) << 16 | 0) >> 16 | 0 | 0) | 0;
                                  }
                                  label$36 : {
                                   label$37 : {
                                    if (($8 | 0) > (-1 | 0)) {
                                     break label$37
                                    }
                                    core__num__flt2dec__strategy__dragon__mul_pow10__hb4209e899a74326f($5 + 8 | 0 | 0, ((0 - $8 | 0) << 16 | 0) >> 16 | 0 | 0) | 0;
                                    break label$36;
                                   }
                                   core__num__flt2dec__strategy__dragon__mul_pow10__hb4209e899a74326f($5 + 176 | 0 | 0, $7 & 65535 | 0 | 0) | 0;
                                  }
                                  $11 = HEAP32[($5 + 176 | 0) >> 2] | 0;
                                  $12 = $5 + 176 | 0 | 4 | 0;
                                  memcpy($5 + 680 | 0 | 4 | 0 | 0, $12 | 0, 160 | 0) | 0;
                                  HEAP32[($5 + 680 | 0) >> 2] = $11;
                                  $6 = $3;
                                  label$38 : {
                                   if ($6 >>> 0 < 10 >>> 0) {
                                    break label$38
                                   }
                                   label$39 : {
                                    label$40 : {
                                     if ($11 >>> 0 <= 40 >>> 0) {
                                      break label$40
                                     }
                                     $1 = $11;
                                     break label$39;
                                    }
                                    $6 = $3;
                                    $1 = $11;
                                    label$41 : while (1) {
                                     label$42 : {
                                      if (!$1) {
                                       break label$42
                                      }
                                      $1 = $1 << 2 | 0;
                                      i64toi32_i32$5 = 0;
                                      $29 = 0;
                                      $29$hi = i64toi32_i32$5;
                                      label$43 : while (1) {
                                       $10 = ($5 + 680 | 0) + $1 | 0;
                                       $162 = $10;
                                       i64toi32_i32$5 = $29$hi;
                                       i64toi32_i32$2 = $29;
                                       i64toi32_i32$1 = 0;
                                       i64toi32_i32$3 = 32;
                                       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
                                       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                                        i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
                                        $71 = 0;
                                       } else {
                                        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$5 << i64toi32_i32$4 | 0) | 0;
                                        $71 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
                                       }
                                       $164$hi = i64toi32_i32$1;
                                       i64toi32_i32$5 = $10;
                                       i64toi32_i32$1 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                                       i64toi32_i32$2 = 0;
                                       $166 = i64toi32_i32$1;
                                       $166$hi = i64toi32_i32$2;
                                       i64toi32_i32$2 = $164$hi;
                                       i64toi32_i32$5 = $71;
                                       i64toi32_i32$1 = $166$hi;
                                       i64toi32_i32$3 = $166;
                                       i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
                                       $29 = i64toi32_i32$5 | i64toi32_i32$3 | 0;
                                       $29$hi = i64toi32_i32$1;
                                       i64toi32_i32$5 = 0;
                                       i64toi32_i32$5 = __wasm_i64_udiv($29 | 0, i64toi32_i32$1 | 0, 1e9 | 0, i64toi32_i32$5 | 0) | 0;
                                       i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
                                       $30 = i64toi32_i32$5;
                                       $30$hi = i64toi32_i32$1;
                                       HEAP32[$162 >> 2] = i64toi32_i32$5;
                                       i64toi32_i32$1 = $29$hi;
                                       i64toi32_i32$1 = $30$hi;
                                       i64toi32_i32$5 = 0;
                                       i64toi32_i32$5 = __wasm_i64_mul($30 | 0, i64toi32_i32$1 | 0, 1e9 | 0, i64toi32_i32$5 | 0) | 0;
                                       i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
                                       $173 = i64toi32_i32$5;
                                       $173$hi = i64toi32_i32$1;
                                       i64toi32_i32$1 = $29$hi;
                                       i64toi32_i32$2 = $29;
                                       i64toi32_i32$5 = $173$hi;
                                       i64toi32_i32$3 = $173;
                                       i64toi32_i32$4 = i64toi32_i32$2 - i64toi32_i32$3 | 0;
                                       i64toi32_i32$6 = i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0;
                                       i64toi32_i32$0 = i64toi32_i32$6 + i64toi32_i32$5 | 0;
                                       i64toi32_i32$0 = i64toi32_i32$1 - i64toi32_i32$0 | 0;
                                       $29 = i64toi32_i32$4;
                                       $29$hi = i64toi32_i32$0;
                                       $1 = $1 + -4 | 0;
                                       if ($1) {
                                        continue label$43
                                       }
                                       break label$43;
                                      };
                                     }
                                     $6 = $6 + -9 | 0;
                                     if ($6 >>> 0 <= 9 >>> 0) {
                                      break label$38
                                     }
                                     $1 = HEAP32[($5 + 680 | 0) >> 2] | 0;
                                     if ($1 >>> 0 < 41 >>> 0) {
                                      continue label$41
                                     }
                                     break label$41;
                                    };
                                   }
                                   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($1 | 0, 40 | 0, 1153020 | 0);
                                   abort();
                                  }
                                  label$44 : {
                                   label$45 : {
                                    label$46 : {
                                     $10 = HEAP32[(($6 << 2 | 0) + 1146376 | 0) >> 2] | 0;
                                     if (!$10) {
                                      break label$46
                                     }
                                     $1 = HEAP32[($5 + 680 | 0) >> 2] | 0;
                                     if ($1 >>> 0 >= 41 >>> 0) {
                                      break label$26
                                     }
                                     if ($1) {
                                      break label$45
                                     }
                                     $1 = 0;
                                     break label$44;
                                    }
                                    core__panicking__panic__h2fd385a887c8bf13(1153091 | 0, 27 | 0, 1153020 | 0);
                                    abort();
                                   }
                                   $1 = $1 << 2 | 0;
                                   i64toi32_i32$0 = 0;
                                   $29 = $10;
                                   $29$hi = i64toi32_i32$0;
                                   i64toi32_i32$0 = 0;
                                   $30 = 0;
                                   $30$hi = i64toi32_i32$0;
                                   label$47 : while (1) {
                                    $10 = ($5 + 680 | 0) + $1 | 0;
                                    $206 = $10;
                                    i64toi32_i32$0 = $30$hi;
                                    i64toi32_i32$1 = $30;
                                    i64toi32_i32$2 = 0;
                                    i64toi32_i32$3 = 32;
                                    i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
                                    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                                     i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$5 | 0;
                                     $72 = 0;
                                    } else {
                                     i64toi32_i32$2 = ((1 << i64toi32_i32$5 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$5 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$5 | 0) | 0;
                                     $72 = i64toi32_i32$1 << i64toi32_i32$5 | 0;
                                    }
                                    $208$hi = i64toi32_i32$2;
                                    i64toi32_i32$0 = $10;
                                    i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                    i64toi32_i32$1 = 0;
                                    $210 = i64toi32_i32$2;
                                    $210$hi = i64toi32_i32$1;
                                    i64toi32_i32$1 = $208$hi;
                                    i64toi32_i32$0 = $72;
                                    i64toi32_i32$2 = $210$hi;
                                    i64toi32_i32$3 = $210;
                                    i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
                                    $30 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
                                    $30$hi = i64toi32_i32$2;
                                    i64toi32_i32$2 = $29$hi;
                                    i64toi32_i32$2 = $30$hi;
                                    i64toi32_i32$0 = $29$hi;
                                    i64toi32_i32$0 = __wasm_i64_udiv($30 | 0, i64toi32_i32$2 | 0, $29 | 0, i64toi32_i32$0 | 0) | 0;
                                    i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
                                    $31 = i64toi32_i32$0;
                                    $31$hi = i64toi32_i32$2;
                                    HEAP32[$206 >> 2] = i64toi32_i32$0;
                                    i64toi32_i32$2 = $30$hi;
                                    i64toi32_i32$2 = $31$hi;
                                    i64toi32_i32$2 = $29$hi;
                                    i64toi32_i32$2 = $31$hi;
                                    i64toi32_i32$0 = $29$hi;
                                    i64toi32_i32$0 = __wasm_i64_mul($31 | 0, i64toi32_i32$2 | 0, $29 | 0, i64toi32_i32$0 | 0) | 0;
                                    i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
                                    $219 = i64toi32_i32$0;
                                    $219$hi = i64toi32_i32$2;
                                    i64toi32_i32$2 = $30$hi;
                                    i64toi32_i32$1 = $30;
                                    i64toi32_i32$0 = $219$hi;
                                    i64toi32_i32$3 = $219;
                                    i64toi32_i32$5 = i64toi32_i32$1 - i64toi32_i32$3 | 0;
                                    i64toi32_i32$6 = i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0;
                                    i64toi32_i32$4 = i64toi32_i32$6 + i64toi32_i32$0 | 0;
                                    i64toi32_i32$4 = i64toi32_i32$2 - i64toi32_i32$4 | 0;
                                    $30 = i64toi32_i32$5;
                                    $30$hi = i64toi32_i32$4;
                                    $1 = $1 + -4 | 0;
                                    if ($1) {
                                     continue label$47
                                    }
                                    break label$47;
                                   };
                                   $1 = HEAP32[($5 + 680 | 0) >> 2] | 0;
                                  }
                                  label$48 : {
                                   label$49 : {
                                    label$50 : {
                                     $13 = HEAP32[($5 + 8 | 0) >> 2] | 0;
                                     $14 = $1 >>> 0 > $13 >>> 0 ? $1 : $13;
                                     if ($14 >>> 0 > 40 >>> 0) {
                                      break label$50
                                     }
                                     if ($14) {
                                      break label$49
                                     }
                                     $14 = 0;
                                     break label$48;
                                    }
                                    core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($14 | 0, 40 | 0, 1153020 | 0);
                                    abort();
                                   }
                                   $1 = $5 + 680 | 0 | 4 | 0;
                                   $10 = $5 + 8 | 0 | 4 | 0;
                                   $9 = 0;
                                   $7 = $14;
                                   label$51 : while (1) {
                                    $15 = HEAP32[$1 >> 2] | 0;
                                    $6 = $15 + (HEAP32[$10 >> 2] | 0) | 0;
                                    $9 = $6 + ($9 & 1 | 0) | 0;
                                    HEAP32[$1 >> 2] = $9;
                                    $9 = $6 >>> 0 < $15 >>> 0 | $9 >>> 0 < $6 >>> 0 | 0;
                                    $1 = $1 + 4 | 0;
                                    $10 = $10 + 4 | 0;
                                    $7 = $7 + -1 | 0;
                                    if ($7) {
                                     continue label$51
                                    }
                                    break label$51;
                                   };
                                   if (!$9) {
                                    break label$48
                                   }
                                   if ($14 >>> 0 > 39 >>> 0) {
                                    break label$25
                                   }
                                   HEAP32[((($5 + 680 | 0) + ($14 << 2 | 0) | 0) + 4 | 0) >> 2] = 1;
                                   $14 = $14 + 1 | 0;
                                  }
                                  HEAP32[($5 + 680 | 0) >> 2] = $14;
                                  $1 = $14 >>> 0 > $11 >>> 0 ? $14 : $11;
                                  if ($1 >>> 0 >= 41 >>> 0) {
                                   break label$24
                                  }
                                  $10 = $5 + 176 | 0 | 4 | 0;
                                  $1 = $1 << 2 | 0;
                                  label$52 : {
                                   label$53 : while (1) {
                                    label$54 : {
                                     if ($1) {
                                      break label$54
                                     }
                                     $6 = $1 ? -1 : 0;
                                     break label$52;
                                    }
                                    $6 = ($5 + 176 | 0) + $1 | 0;
                                    $9 = ($5 + 680 | 0) + $1 | 0;
                                    $1 = $1 + -4 | 0;
                                    $9 = HEAP32[$9 >> 2] | 0;
                                    $6 = HEAP32[$6 >> 2] | 0;
                                    $6 = $9 >>> 0 < $6 >>> 0 ? -1 : ($9 | 0) != ($6 | 0);
                                    if (!$6) {
                                     continue label$53
                                    }
                                    break label$53;
                                   };
                                  }
                                  label$55 : {
                                   label$56 : {
                                    if (($6 & 255 | 0) >>> 0 < 2 >>> 0) {
                                     break label$56
                                    }
                                    if ($13 >>> 0 >= 41 >>> 0) {
                                     break label$23
                                    }
                                    label$57 : {
                                     if ($13) {
                                      break label$57
                                     }
                                     HEAP32[($5 + 8 | 0) >> 2] = 0;
                                     break label$55;
                                    }
                                    $6 = $13 << 2 | 0;
                                    $9 = (($5 + 8 | 0) + $6 | 0) + 4 | 0;
                                    $1 = $5 + 8 | 0 | 4 | 0;
                                    i64toi32_i32$4 = 0;
                                    $29 = 0;
                                    $29$hi = i64toi32_i32$4;
                                    label$58 : while (1) {
                                     $341 = $1;
                                     i64toi32_i32$2 = $1;
                                     i64toi32_i32$4 = HEAP32[$1 >> 2] | 0;
                                     i64toi32_i32$1 = 0;
                                     $76 = i64toi32_i32$4;
                                     i64toi32_i32$4 = 0;
                                     i64toi32_i32$4 = __wasm_i64_mul($76 | 0, i64toi32_i32$1 | 0, 10 | 0, i64toi32_i32$4 | 0) | 0;
                                     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
                                     $344$hi = i64toi32_i32$1;
                                     i64toi32_i32$1 = $29$hi;
                                     i64toi32_i32$1 = $344$hi;
                                     i64toi32_i32$2 = i64toi32_i32$4;
                                     i64toi32_i32$4 = $29$hi;
                                     i64toi32_i32$3 = $29;
                                     i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
                                     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
                                     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
                                      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
                                     }
                                     $29 = i64toi32_i32$0;
                                     $29$hi = i64toi32_i32$5;
                                     HEAP32[$341 >> 2] = i64toi32_i32$0;
                                     $1 = $1 + 4 | 0;
                                     i64toi32_i32$1 = i64toi32_i32$0;
                                     i64toi32_i32$2 = 0;
                                     i64toi32_i32$3 = 32;
                                     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
                                     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                                      i64toi32_i32$2 = 0;
                                      $73 = i64toi32_i32$5 >>> i64toi32_i32$4 | 0;
                                     } else {
                                      i64toi32_i32$2 = i64toi32_i32$5 >>> i64toi32_i32$4 | 0;
                                      $73 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
                                     }
                                     $29 = $73;
                                     $29$hi = i64toi32_i32$2;
                                     $6 = $6 + -4 | 0;
                                     if ($6) {
                                      continue label$58
                                     }
                                     break label$58;
                                    };
                                    label$59 : {
                                     i64toi32_i32$2 = $29$hi;
                                     $1 = $29;
                                     if (!$1) {
                                      break label$59
                                     }
                                     if ($13 >>> 0 > 39 >>> 0) {
                                      break label$22
                                     }
                                     HEAP32[$9 >> 2] = $1;
                                     $13 = $13 + 1 | 0;
                                    }
                                    HEAP32[($5 + 8 | 0) >> 2] = $13;
                                    break label$55;
                                   }
                                   $8 = $8 + 1 | 0;
                                  }
                                  $15 = 1;
                                  label$60 : {
                                   label$61 : {
                                    $1 = ($8 << 16 | 0) >> 16 | 0;
                                    $6 = ($4 << 16 | 0) >> 16 | 0;
                                    if (($1 | 0) >= ($6 | 0)) {
                                     break label$61
                                    }
                                    $7 = 0;
                                    break label$60;
                                   }
                                   label$62 : {
                                    $7 = ($1 - $6 | 0) >>> 0 < $3 >>> 0 ? (($8 - $4 | 0) << 16 | 0) >> 16 | 0 : $3;
                                    if ($7) {
                                     break label$62
                                    }
                                    $7 = 0;
                                    break label$60;
                                   }
                                   $16 = memcpy($5 + 344 | 0 | 4 | 0 | 0, $12 | 0, 160 | 0) | 0;
                                   HEAP32[($5 + 344 | 0) >> 2] = $11;
                                   core__num__bignum__Big32x40__mul_pow2__haaaae198d66328c2($5 + 344 | 0 | 0, 1 | 0) | 0;
                                   $1 = HEAP32[($5 + 176 | 0) >> 2] | 0;
                                   $17 = memcpy($5 + 512 | 0 | 4 | 0 | 0, $12 | 0, 160 | 0) | 0;
                                   HEAP32[($5 + 512 | 0) >> 2] = $1;
                                   core__num__bignum__Big32x40__mul_pow2__haaaae198d66328c2($5 + 512 | 0 | 0, 2 | 0) | 0;
                                   $1 = HEAP32[($5 + 176 | 0) >> 2] | 0;
                                   $18 = memcpy($5 + 680 | 0 | 4 | 0 | 0, $12 | 0, 160 | 0) | 0;
                                   HEAP32[($5 + 680 | 0) >> 2] = $1;
                                   core__num__bignum__Big32x40__mul_pow2__haaaae198d66328c2($5 + 680 | 0 | 0, 3 | 0) | 0;
                                   $19 = $5 + 176 | 0 | 4 | 0;
                                   $20 = $5 + 8 | 0 | 4 | 0;
                                   $12 = HEAP32[($5 + 8 | 0) >> 2] | 0;
                                   $11 = HEAP32[($5 + 176 | 0) >> 2] | 0;
                                   $21 = HEAP32[($5 + 344 | 0) >> 2] | 0;
                                   $22 = HEAP32[($5 + 512 | 0) >> 2] | 0;
                                   $23 = HEAP32[($5 + 680 | 0) >> 2] | 0;
                                   $24 = 0;
                                   label$63 : while (1) {
                                    $25 = $24;
                                    if ($12 >>> 0 >= 41 >>> 0) {
                                     break label$21
                                    }
                                    $24 = $25 + 1 | 0;
                                    $1 = $12 << 2 | 0;
                                    $6 = $20;
                                    label$64 : while (1) {
                                     if (!$1) {
                                      break label$4
                                     }
                                     $1 = $1 + -4 | 0;
                                     $9 = HEAP32[$6 >> 2] | 0;
                                     $6 = $6 + 4 | 0;
                                     if (!$9) {
                                      continue label$64
                                     }
                                     break label$64;
                                    };
                                    $26 = $12 >>> 0 > $23 >>> 0 ? $12 : $23;
                                    if ($26 >>> 0 >= 41 >>> 0) {
                                     break label$20
                                    }
                                    $1 = $26 << 2 | 0;
                                    label$65 : {
                                     label$66 : while (1) {
                                      label$67 : {
                                       if ($1) {
                                        break label$67
                                       }
                                       $6 = $1 ? -1 : 0;
                                       break label$65;
                                      }
                                      $6 = ($5 + 680 | 0) + $1 | 0;
                                      $9 = ($5 + 8 | 0) + $1 | 0;
                                      $1 = $1 + -4 | 0;
                                      $9 = HEAP32[$9 >> 2] | 0;
                                      $6 = HEAP32[$6 >> 2] | 0;
                                      $6 = $9 >>> 0 < $6 >>> 0 ? -1 : ($9 | 0) != ($6 | 0);
                                      if (!$6) {
                                       continue label$66
                                      }
                                      break label$66;
                                     };
                                    }
                                    $27 = 0;
                                    label$68 : {
                                     if (($6 & 255 | 0) >>> 0 >= 2 >>> 0) {
                                      break label$68
                                     }
                                     label$69 : {
                                      if (!$26) {
                                       break label$69
                                      }
                                      $15 = 1;
                                      $1 = $20;
                                      $6 = $18;
                                      $14 = $26;
                                      label$70 : while (1) {
                                       $13 = HEAP32[$1 >> 2] | 0;
                                       $9 = $13 + ((HEAP32[$6 >> 2] | 0) ^ -1 | 0) | 0;
                                       $15 = $9 + ($15 & 1 | 0) | 0;
                                       HEAP32[$1 >> 2] = $15;
                                       $15 = $9 >>> 0 < $13 >>> 0 | $15 >>> 0 < $9 >>> 0 | 0;
                                       $1 = $1 + 4 | 0;
                                       $6 = $6 + 4 | 0;
                                       $14 = $14 + -1 | 0;
                                       if ($14) {
                                        continue label$70
                                       }
                                       break label$70;
                                      };
                                      if (!$15) {
                                       break label$19
                                      }
                                     }
                                     HEAP32[($5 + 8 | 0) >> 2] = $26;
                                     $27 = 8;
                                     $12 = $26;
                                    }
                                    $26 = $12 >>> 0 > $22 >>> 0 ? $12 : $22;
                                    if ($26 >>> 0 >= 41 >>> 0) {
                                     break label$18
                                    }
                                    $1 = $26 << 2 | 0;
                                    label$71 : {
                                     label$72 : while (1) {
                                      label$73 : {
                                       if ($1) {
                                        break label$73
                                       }
                                       $6 = $1 ? -1 : 0;
                                       break label$71;
                                      }
                                      $6 = ($5 + 512 | 0) + $1 | 0;
                                      $9 = ($5 + 8 | 0) + $1 | 0;
                                      $1 = $1 + -4 | 0;
                                      $9 = HEAP32[$9 >> 2] | 0;
                                      $6 = HEAP32[$6 >> 2] | 0;
                                      $6 = $9 >>> 0 < $6 >>> 0 ? -1 : ($9 | 0) != ($6 | 0);
                                      if (!$6) {
                                       continue label$72
                                      }
                                      break label$72;
                                     };
                                    }
                                    label$74 : {
                                     label$75 : {
                                      if (($6 & 255 | 0) >>> 0 <= 1 >>> 0) {
                                       break label$75
                                      }
                                      $26 = $12;
                                      break label$74;
                                     }
                                     label$76 : {
                                      if (!$26) {
                                       break label$76
                                      }
                                      $15 = 1;
                                      $1 = $20;
                                      $6 = $17;
                                      $14 = $26;
                                      label$77 : while (1) {
                                       $13 = HEAP32[$1 >> 2] | 0;
                                       $9 = $13 + ((HEAP32[$6 >> 2] | 0) ^ -1 | 0) | 0;
                                       $15 = $9 + ($15 & 1 | 0) | 0;
                                       HEAP32[$1 >> 2] = $15;
                                       $15 = $9 >>> 0 < $13 >>> 0 | $15 >>> 0 < $9 >>> 0 | 0;
                                       $1 = $1 + 4 | 0;
                                       $6 = $6 + 4 | 0;
                                       $14 = $14 + -1 | 0;
                                       if ($14) {
                                        continue label$77
                                       }
                                       break label$77;
                                      };
                                      if (!$15) {
                                       break label$17
                                      }
                                     }
                                     HEAP32[($5 + 8 | 0) >> 2] = $26;
                                     $27 = $27 | 4 | 0;
                                    }
                                    $28 = $26 >>> 0 > $21 >>> 0 ? $26 : $21;
                                    if ($28 >>> 0 >= 41 >>> 0) {
                                     break label$16
                                    }
                                    $1 = $28 << 2 | 0;
                                    label$78 : {
                                     label$79 : while (1) {
                                      label$80 : {
                                       if ($1) {
                                        break label$80
                                       }
                                       $6 = $1 ? -1 : 0;
                                       break label$78;
                                      }
                                      $6 = ($5 + 344 | 0) + $1 | 0;
                                      $9 = ($5 + 8 | 0) + $1 | 0;
                                      $1 = $1 + -4 | 0;
                                      $9 = HEAP32[$9 >> 2] | 0;
                                      $6 = HEAP32[$6 >> 2] | 0;
                                      $6 = $9 >>> 0 < $6 >>> 0 ? -1 : ($9 | 0) != ($6 | 0);
                                      if (!$6) {
                                       continue label$79
                                      }
                                      break label$79;
                                     };
                                    }
                                    label$81 : {
                                     label$82 : {
                                      if (($6 & 255 | 0) >>> 0 <= 1 >>> 0) {
                                       break label$82
                                      }
                                      $28 = $26;
                                      break label$81;
                                     }
                                     label$83 : {
                                      if (!$28) {
                                       break label$83
                                      }
                                      $15 = 1;
                                      $1 = $20;
                                      $6 = $16;
                                      $14 = $28;
                                      label$84 : while (1) {
                                       $13 = HEAP32[$1 >> 2] | 0;
                                       $9 = $13 + ((HEAP32[$6 >> 2] | 0) ^ -1 | 0) | 0;
                                       $15 = $9 + ($15 & 1 | 0) | 0;
                                       HEAP32[$1 >> 2] = $15;
                                       $15 = $9 >>> 0 < $13 >>> 0 | $15 >>> 0 < $9 >>> 0 | 0;
                                       $1 = $1 + 4 | 0;
                                       $6 = $6 + 4 | 0;
                                       $14 = $14 + -1 | 0;
                                       if ($14) {
                                        continue label$84
                                       }
                                       break label$84;
                                      };
                                      if (!$15) {
                                       break label$15
                                      }
                                     }
                                     HEAP32[($5 + 8 | 0) >> 2] = $28;
                                     $27 = $27 + 2 | 0;
                                    }
                                    $12 = $28 >>> 0 > $11 >>> 0 ? $28 : $11;
                                    if ($12 >>> 0 >= 41 >>> 0) {
                                     break label$14
                                    }
                                    $1 = $12 << 2 | 0;
                                    label$85 : {
                                     label$86 : while (1) {
                                      label$87 : {
                                       if ($1) {
                                        break label$87
                                       }
                                       $6 = $1 ? -1 : 0;
                                       break label$85;
                                      }
                                      $6 = ($5 + 176 | 0) + $1 | 0;
                                      $9 = ($5 + 8 | 0) + $1 | 0;
                                      $1 = $1 + -4 | 0;
                                      $9 = HEAP32[$9 >> 2] | 0;
                                      $6 = HEAP32[$6 >> 2] | 0;
                                      $6 = $9 >>> 0 < $6 >>> 0 ? -1 : ($9 | 0) != ($6 | 0);
                                      if (!$6) {
                                       continue label$86
                                      }
                                      break label$86;
                                     };
                                    }
                                    label$88 : {
                                     label$89 : {
                                      if (($6 & 255 | 0) >>> 0 <= 1 >>> 0) {
                                       break label$89
                                      }
                                      $12 = $28;
                                      break label$88;
                                     }
                                     label$90 : {
                                      if (!$12) {
                                       break label$90
                                      }
                                      $15 = 1;
                                      $1 = $20;
                                      $6 = $19;
                                      $14 = $12;
                                      label$91 : while (1) {
                                       $13 = HEAP32[$1 >> 2] | 0;
                                       $9 = $13 + ((HEAP32[$6 >> 2] | 0) ^ -1 | 0) | 0;
                                       $15 = $9 + ($15 & 1 | 0) | 0;
                                       HEAP32[$1 >> 2] = $15;
                                       $15 = $9 >>> 0 < $13 >>> 0 | $15 >>> 0 < $9 >>> 0 | 0;
                                       $1 = $1 + 4 | 0;
                                       $6 = $6 + 4 | 0;
                                       $14 = $14 + -1 | 0;
                                       if ($14) {
                                        continue label$91
                                       }
                                       break label$91;
                                      };
                                      if (!$15) {
                                       break label$13
                                      }
                                     }
                                     HEAP32[($5 + 8 | 0) >> 2] = $12;
                                     $27 = $27 + 1 | 0;
                                    }
                                    if (($25 | 0) == ($3 | 0)) {
                                     break label$10
                                    }
                                    HEAP8[($2 + $25 | 0) >> 0] = $27 + 48 | 0;
                                    if ($12 >>> 0 >= 41 >>> 0) {
                                     break label$12
                                    }
                                    label$92 : {
                                     label$93 : {
                                      if ($12) {
                                       break label$93
                                      }
                                      $12 = 0;
                                      break label$92;
                                     }
                                     $6 = $12 << 2 | 0;
                                     $9 = (($5 + 8 | 0) + $6 | 0) + 4 | 0;
                                     i64toi32_i32$2 = 0;
                                     $29 = 0;
                                     $29$hi = i64toi32_i32$2;
                                     $1 = $20;
                                     label$94 : while (1) {
                                      $788 = $1;
                                      i64toi32_i32$5 = $1;
                                      i64toi32_i32$2 = HEAP32[$1 >> 2] | 0;
                                      i64toi32_i32$1 = 0;
                                      $77 = i64toi32_i32$2;
                                      i64toi32_i32$2 = 0;
                                      i64toi32_i32$2 = __wasm_i64_mul($77 | 0, i64toi32_i32$1 | 0, 10 | 0, i64toi32_i32$2 | 0) | 0;
                                      i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
                                      $791$hi = i64toi32_i32$1;
                                      i64toi32_i32$1 = $29$hi;
                                      i64toi32_i32$1 = $791$hi;
                                      i64toi32_i32$5 = i64toi32_i32$2;
                                      i64toi32_i32$2 = $29$hi;
                                      i64toi32_i32$3 = $29;
                                      i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
                                      i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
                                      if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
                                       i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
                                      }
                                      $29 = i64toi32_i32$4;
                                      $29$hi = i64toi32_i32$0;
                                      HEAP32[$788 >> 2] = i64toi32_i32$4;
                                      $1 = $1 + 4 | 0;
                                      i64toi32_i32$1 = i64toi32_i32$4;
                                      i64toi32_i32$5 = 0;
                                      i64toi32_i32$3 = 32;
                                      i64toi32_i32$2 = i64toi32_i32$3 & 31 | 0;
                                      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                                       i64toi32_i32$5 = 0;
                                       $74 = i64toi32_i32$0 >>> i64toi32_i32$2 | 0;
                                      } else {
                                       i64toi32_i32$5 = i64toi32_i32$0 >>> i64toi32_i32$2 | 0;
                                       $74 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$2 | 0) | 0;
                                      }
                                      $29 = $74;
                                      $29$hi = i64toi32_i32$5;
                                      $6 = $6 + -4 | 0;
                                      if ($6) {
                                       continue label$94
                                      }
                                      break label$94;
                                     };
                                     i64toi32_i32$5 = $29$hi;
                                     $1 = $29;
                                     if (!$1) {
                                      break label$92
                                     }
                                     if ($12 >>> 0 > 39 >>> 0) {
                                      break label$11
                                     }
                                     HEAP32[$9 >> 2] = $1;
                                     $12 = $12 + 1 | 0;
                                    }
                                    HEAP32[($5 + 8 | 0) >> 2] = $12;
                                    if (($24 | 0) != ($7 | 0)) {
                                     continue label$63
                                    }
                                    break label$63;
                                   };
                                   $15 = 0;
                                  }
                                  if ($11 >>> 0 >= 41 >>> 0) {
                                   break label$9
                                  }
                                  label$95 : {
                                   label$96 : {
                                    if ($11) {
                                     break label$96
                                    }
                                    $11 = 0;
                                    break label$95;
                                   }
                                   $1 = $11 << 2 | 0;
                                   $6 = (($5 + 176 | 0) + $1 | 0) + 4 | 0;
                                   i64toi32_i32$5 = 0;
                                   $29 = 0;
                                   $29$hi = i64toi32_i32$5;
                                   label$97 : while (1) {
                                    $827 = $10;
                                    i64toi32_i32$0 = $10;
                                    i64toi32_i32$5 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                    i64toi32_i32$1 = 0;
                                    $78 = i64toi32_i32$5;
                                    i64toi32_i32$5 = 0;
                                    i64toi32_i32$5 = __wasm_i64_mul($78 | 0, i64toi32_i32$1 | 0, 5 | 0, i64toi32_i32$5 | 0) | 0;
                                    i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
                                    $830$hi = i64toi32_i32$1;
                                    i64toi32_i32$1 = $29$hi;
                                    i64toi32_i32$1 = $830$hi;
                                    i64toi32_i32$0 = i64toi32_i32$5;
                                    i64toi32_i32$5 = $29$hi;
                                    i64toi32_i32$3 = $29;
                                    i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
                                    i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
                                    if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
                                     i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
                                    }
                                    $29 = i64toi32_i32$2;
                                    $29$hi = i64toi32_i32$4;
                                    HEAP32[$827 >> 2] = i64toi32_i32$2;
                                    $10 = $10 + 4 | 0;
                                    i64toi32_i32$1 = i64toi32_i32$2;
                                    i64toi32_i32$0 = 0;
                                    i64toi32_i32$3 = 32;
                                    i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
                                    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                                     i64toi32_i32$0 = 0;
                                     $75 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
                                    } else {
                                     i64toi32_i32$0 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
                                     $75 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$5 | 0) | 0;
                                    }
                                    $29 = $75;
                                    $29$hi = i64toi32_i32$0;
                                    $1 = $1 + -4 | 0;
                                    if ($1) {
                                     continue label$97
                                    }
                                    break label$97;
                                   };
                                   i64toi32_i32$0 = $29$hi;
                                   $1 = $29;
                                   if (!$1) {
                                    break label$95
                                   }
                                   if ($11 >>> 0 > 39 >>> 0) {
                                    break label$8
                                   }
                                   HEAP32[$6 >> 2] = $1;
                                   $11 = $11 + 1 | 0;
                                  }
                                  HEAP32[($5 + 176 | 0) >> 2] = $11;
                                  $1 = HEAP32[($5 + 8 | 0) >> 2] | 0;
                                  $1 = $1 >>> 0 > $11 >>> 0 ? $1 : $11;
                                  if ($1 >>> 0 >= 41 >>> 0) {
                                   break label$7
                                  }
                                  $1 = $1 << 2 | 0;
                                  label$98 : {
                                   label$99 : {
                                    label$100 : {
                                     label$101 : while (1) {
                                      if (!$1) {
                                       break label$100
                                      }
                                      $10 = ($5 + 176 | 0) + $1 | 0;
                                      $6 = ($5 + 8 | 0) + $1 | 0;
                                      $1 = $1 + -4 | 0;
                                      $6 = HEAP32[$6 >> 2] | 0;
                                      $10 = HEAP32[$10 >> 2] | 0;
                                      $10 = $6 >>> 0 < $10 >>> 0 ? -1 : ($6 | 0) != ($10 | 0);
                                      if (!$10) {
                                       continue label$101
                                      }
                                      break label$101;
                                     };
                                     if (($10 & 255 | 0 | 0) == (1 | 0)) {
                                      break label$99
                                     }
                                     break label$98;
                                    }
                                    if ($1) {
                                     break label$98
                                    }
                                    if ($15) {
                                     break label$99
                                    }
                                    $1 = $7 + -1 | 0;
                                    if ($1 >>> 0 >= $3 >>> 0) {
                                     break label$6
                                    }
                                    if (!((HEAPU8[($2 + $1 | 0) >> 0] | 0) & 1 | 0)) {
                                     break label$98
                                    }
                                   }
                                   if ($7 >>> 0 > $3 >>> 0) {
                                    break label$5
                                   }
                                   $11 = $2 + $7 | 0;
                                   $1 = 0;
                                   $10 = $2;
                                   label$102 : {
                                    label$103 : while (1) {
                                     if (($7 | 0) == ($1 | 0)) {
                                      break label$102
                                     }
                                     $1 = $1 + 1 | 0;
                                     $6 = $10 + $7 | 0;
                                     $9 = $10 + -1 | 0;
                                     $10 = $9;
                                     if ((HEAPU8[($6 + -1 | 0) >> 0] | 0 | 0) == (57 | 0)) {
                                      continue label$103
                                     }
                                     break label$103;
                                    };
                                    $10 = $9 + $7 | 0;
                                    HEAP8[$10 >> 0] = (HEAPU8[$10 >> 0] | 0) + 1 | 0;
                                    if ($7 >>> 0 <= (($7 - $1 | 0) + 1 | 0) >>> 0) {
                                     break label$98
                                    }
                                    memset($10 + 1 | 0 | 0, 48 | 0, $1 + -1 | 0 | 0) | 0;
                                    break label$98;
                                   }
                                   $1 = 49;
                                   label$104 : {
                                    if ($15) {
                                     break label$104
                                    }
                                    HEAP8[$2 >> 0] = 49;
                                    $1 = 48;
                                    if (($7 | 0) == (1 | 0)) {
                                     break label$104
                                    }
                                    $1 = 48;
                                    memset($2 + 1 | 0 | 0, 48 | 0, $7 + -1 | 0 | 0) | 0;
                                   }
                                   $8 = (($8 << 16 | 0) + 65536 | 0) >> 16 | 0;
                                   if (($8 | 0) <= (($4 << 16 | 0) >> 16 | 0 | 0)) {
                                    break label$98
                                   }
                                   if ($7 >>> 0 >= $3 >>> 0) {
                                    break label$98
                                   }
                                   HEAP8[$11 >> 0] = $1;
                                   $7 = $7 + 1 | 0;
                                  }
                                  if ($7 >>> 0 <= $3 >>> 0) {
                                   break label$3
                                  }
                                  core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($7 | 0, $3 | 0, 1147232 | 0);
                                  abort();
                                 }
                                 core__panicking__panic__h2fd385a887c8bf13(1146679 | 0, 28 | 0, 1147088 | 0);
                                 abort();
                                }
                                core__panicking__panic__h2fd385a887c8bf13(1146724 | 0, 29 | 0, 1147104 | 0);
                                abort();
                               }
                               core__panicking__panic__h2fd385a887c8bf13(1146772 | 0, 28 | 0, 1147120 | 0);
                               abort();
                              }
                              core__panicking__panic__h2fd385a887c8bf13(1146816 | 0, 54 | 0, 1147136 | 0);
                              abort();
                             }
                             core__panicking__panic_bounds_check__h808b524af17640b1(40 | 0, 40 | 0, 1153020 | 0);
                             abort();
                            }
                            core__panicking__panic__h2fd385a887c8bf13(1146888 | 0, 55 | 0, 1147152 | 0);
                            abort();
                           }
                           core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($1 | 0, 40 | 0, 1153020 | 0);
                           abort();
                          }
                          core__panicking__panic_bounds_check__h808b524af17640b1($14 | 0, 40 | 0, 1153020 | 0);
                          abort();
                         }
                         core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($1 | 0, 40 | 0, 1153020 | 0);
                         abort();
                        }
                        core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($13 | 0, 40 | 0, 1153020 | 0);
                        abort();
                       }
                       core__panicking__panic_bounds_check__h808b524af17640b1($13 | 0, 40 | 0, 1153020 | 0);
                       abort();
                      }
                      core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($12 | 0, 40 | 0, 1153020 | 0);
                      abort();
                     }
                     core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($26 | 0, 40 | 0, 1153020 | 0);
                     abort();
                    }
                    core__panicking__panic__h2fd385a887c8bf13(1153036 | 0, 26 | 0, 1153020 | 0);
                    abort();
                   }
                   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($26 | 0, 40 | 0, 1153020 | 0);
                   abort();
                  }
                  core__panicking__panic__h2fd385a887c8bf13(1153036 | 0, 26 | 0, 1153020 | 0);
                  abort();
                 }
                 core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($28 | 0, 40 | 0, 1153020 | 0);
                 abort();
                }
                core__panicking__panic__h2fd385a887c8bf13(1153036 | 0, 26 | 0, 1153020 | 0);
                abort();
               }
               core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($12 | 0, 40 | 0, 1153020 | 0);
               abort();
              }
              core__panicking__panic__h2fd385a887c8bf13(1153036 | 0, 26 | 0, 1153020 | 0);
              abort();
             }
             core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($12 | 0, 40 | 0, 1153020 | 0);
             abort();
            }
            core__panicking__panic_bounds_check__h808b524af17640b1($12 | 0, 40 | 0, 1153020 | 0);
            abort();
           }
           core__panicking__panic_bounds_check__h808b524af17640b1($3 | 0, $3 | 0, 1147184 | 0);
           abort();
          }
          core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($11 | 0, 40 | 0, 1153020 | 0);
          abort();
         }
         core__panicking__panic_bounds_check__h808b524af17640b1($11 | 0, 40 | 0, 1153020 | 0);
         abort();
        }
        core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($1 | 0, 40 | 0, 1153020 | 0);
        abort();
       }
       core__panicking__panic_bounds_check__h808b524af17640b1($1 | 0, $3 | 0, 1147200 | 0);
       abort();
      }
      core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($7 | 0, $3 | 0, 1147216 | 0);
      abort();
     }
     if ($7 >>> 0 < $25 >>> 0) {
      break label$2
     }
     if ($7 >>> 0 > $3 >>> 0) {
      break label$1
     }
     if (($7 | 0) == ($25 | 0)) {
      break label$3
     }
     memset($2 + $25 | 0 | 0, 48 | 0, $7 - $25 | 0 | 0) | 0;
    }
    HEAP16[($0 + 8 | 0) >> 1] = $8;
    HEAP32[($0 + 4 | 0) >> 2] = $7;
    HEAP32[$0 >> 2] = $2;
    global$0 = $5 + 848 | 0;
    return;
   }
   core__slice__index__slice_index_order_fail__h71e247dec3f266ff($25 | 0, $7 | 0, 1147168 | 0);
   abort();
  }
  core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($7 | 0, $3 | 0, 1147168 | 0);
  abort();
 }
 
 function dlmalloc__dlmalloc__Dlmalloc_A___malloc__h817d0bdbe748994d($0) {
  $0 = $0 | 0;
  var $2 = 0, $4 = 0, $3 = 0, $7 = 0, $6 = 0, $8 = 0, $5 = 0, $9 = 0, i64toi32_i32$1 = 0, $1 = 0, $11 = 0, $15 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $12 = 0, $16 = 0, $10 = 0, $13 = 0, $14 = 0, $147 = 0, $271 = 0, $17 = 0, $17$hi = 0, $697 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   label$2 : {
    label$3 : {
     if ($0 >>> 0 < 245 >>> 0) {
      break label$3
     }
     $2 = 0;
     $3 = dlmalloc__dlmalloc__Chunk__to_mem__he3242996ca597cec(0 | 0) | 0;
     $3 = ((((($3 - (dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2($3 | 0, 8 | 0) | 0) | 0) - (dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2(20 | 0, 8 | 0) | 0) | 0) - (dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2(16 | 0, 8 | 0) | 0) | 0) + -65544 | 0) & -9 | 0) + -3 | 0;
     $4 = 0 - ((dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2(16 | 0, 8 | 0) | 0) << 2 | 0) | 0;
     if (($4 >>> 0 > $3 >>> 0 ? $3 : $4) >>> 0 <= $0 >>> 0) {
      break label$1
     }
     $3 = dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2($0 + 4 | 0 | 0, 8 | 0) | 0;
     if (!(HEAP32[(0 + 1177888 | 0) >> 2] | 0)) {
      break label$2
     }
     $5 = 0;
     label$4 : {
      $0 = $3 >>> 8 | 0;
      if (!$0) {
       break label$4
      }
      $5 = 31;
      if ($3 >>> 0 > 16777215 >>> 0) {
       break label$4
      }
      $0 = Math_clz32($0);
      $5 = ((($3 >>> ((6 - $0 | 0) & 31 | 0) | 0) & 1 | 0) - ($0 << 1 | 0) | 0) + 62 | 0;
     }
     $2 = 0 - $3 | 0;
     label$5 : {
      label$6 : {
       label$7 : {
        $0 = HEAP32[(($5 << 2 | 0) + 1178156 | 0) >> 2] | 0;
        if (!$0) {
         break label$7
        }
        $6 = $3 << ((dlmalloc__dlmalloc__leftshift_for_tree_index__hd82124830437cc05($5 | 0) | 0) & 31 | 0) | 0;
        $7 = 0;
        $4 = 0;
        label$8 : while (1) {
         label$9 : {
          $8 = dlmalloc__dlmalloc__Chunk__size__hbcf51483386243e4(dlmalloc__dlmalloc__TreeChunk__chunk__h93f52b5b19dc8e79($0 | 0) | 0 | 0) | 0;
          if ($8 >>> 0 < $3 >>> 0) {
           break label$9
          }
          $8 = $8 - $3 | 0;
          if ($8 >>> 0 >= $2 >>> 0) {
           break label$9
          }
          $2 = $8;
          $4 = $0;
          if ($2) {
           break label$9
          }
          $2 = 0;
          $4 = $0;
          break label$6;
         }
         $8 = HEAP32[($0 + 20 | 0) >> 2] | 0;
         $0 = HEAP32[(($0 + (($6 >>> 29 | 0) & 4 | 0) | 0) + 16 | 0) >> 2] | 0;
         $7 = $8 ? (($8 | 0) != ($0 | 0) ? $8 : $7) : $7;
         $6 = $6 << 1 | 0;
         if ($0) {
          continue label$8
         }
         break label$8;
        };
        label$10 : {
         if (!$7) {
          break label$10
         }
         $0 = $7;
         break label$6;
        }
        if ($4) {
         break label$5
        }
       }
       $4 = 0;
       $0 = (dlmalloc__dlmalloc__left_bits__hea1a8ecbc54c753a(1 << ($5 & 31 | 0) | 0 | 0) | 0) & (HEAP32[(0 + 1177888 | 0) >> 2] | 0) | 0;
       if (!$0) {
        break label$2
       }
       $0 = HEAP32[(((__wasm_ctz_i32(dlmalloc__dlmalloc__least_bit__hdec43f25959d8304($0 | 0) | 0 | 0) | 0) << 2 | 0) + 1178156 | 0) >> 2] | 0;
       if (!$0) {
        break label$2
       }
      }
      label$11 : while (1) {
       $7 = dlmalloc__dlmalloc__Chunk__size__hbcf51483386243e4(dlmalloc__dlmalloc__TreeChunk__chunk__h93f52b5b19dc8e79($0 | 0) | 0 | 0) | 0;
       $147 = $7 >>> 0 >= $3 >>> 0;
       $7 = $7 - $3 | 0;
       $6 = $147 & $7 >>> 0 < $2 >>> 0 | 0;
       $4 = $6 ? $0 : $4;
       $2 = $6 ? $7 : $2;
       $0 = dlmalloc__dlmalloc__TreeChunk__leftmost_child__h0e0ff04b08669a58($0 | 0) | 0;
       if ($0) {
        continue label$11
       }
       break label$11;
      };
      if (!$4) {
       break label$2
      }
     }
     label$12 : {
      $0 = HEAP32[(0 + 1178284 | 0) >> 2] | 0;
      if ($0 >>> 0 < $3 >>> 0) {
       break label$12
      }
      if ($2 >>> 0 >= ($0 - $3 | 0) >>> 0) {
       break label$2
      }
     }
     $0 = dlmalloc__dlmalloc__TreeChunk__chunk__h93f52b5b19dc8e79($4 | 0) | 0;
     $7 = dlmalloc__dlmalloc__Chunk__plus_offset__h7aa5253a4344ed9a($0 | 0, $3 | 0) | 0;
     dlmalloc__dlmalloc__Dlmalloc_A___unlink_large_chunk__h107571aa99375aaf($4 | 0);
     label$13 : {
      label$14 : {
       if ($2 >>> 0 < (dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2(16 | 0, 8 | 0) | 0) >>> 0) {
        break label$14
       }
       dlmalloc__dlmalloc__Chunk__set_size_and_pinuse_of_inuse_chunk__hf4d697bb61df28bc($0 | 0, $3 | 0);
       dlmalloc__dlmalloc__Chunk__set_size_and_pinuse_of_free_chunk__hbc4027d35960d532($7 | 0, $2 | 0);
       label$15 : {
        if ($2 >>> 0 < 256 >>> 0) {
         break label$15
        }
        dlmalloc__dlmalloc__Dlmalloc_A___insert_large_chunk__h524840f32df7e3d2($7 | 0, $2 | 0);
        break label$13;
       }
       $4 = $2 >>> 3 | 0;
       $2 = ($4 << 3 | 0) + 1177892 | 0;
       label$16 : {
        label$17 : {
         $6 = HEAP32[(0 + 1177884 | 0) >> 2] | 0;
         $4 = 1 << $4 | 0;
         if (!($6 & $4 | 0)) {
          break label$17
         }
         $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
         break label$16;
        }
        HEAP32[(0 + 1177884 | 0) >> 2] = $6 | $4 | 0;
        $4 = $2;
       }
       HEAP32[($2 + 8 | 0) >> 2] = $7;
       HEAP32[($4 + 12 | 0) >> 2] = $7;
       HEAP32[($7 + 12 | 0) >> 2] = $2;
       HEAP32[($7 + 8 | 0) >> 2] = $4;
       break label$13;
      }
      dlmalloc__dlmalloc__Chunk__set_inuse_and_pinuse__hd70cd9b459f591b2($0 | 0, $2 + $3 | 0 | 0);
     }
     $2 = dlmalloc__dlmalloc__Chunk__to_mem__he3242996ca597cec($0 | 0) | 0;
     if (!$2) {
      break label$2
     }
     break label$1;
    }
    $3 = dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2((((dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2(16 | 0, 8 | 0) | 0) + -5 | 0) >>> 0 > $0 >>> 0 ? 16 : $0 + 4 | 0) | 0, 8 | 0) | 0;
    label$18 : {
     label$19 : {
      label$20 : {
       label$21 : {
        label$22 : {
         label$23 : {
          label$24 : {
           $7 = HEAP32[(0 + 1177884 | 0) >> 2] | 0;
           $2 = $3 >>> 3 | 0;
           $4 = $2 & 31 | 0;
           $0 = $7 >>> $4 | 0;
           if ($0 & 3 | 0) {
            break label$24
           }
           if ($3 >>> 0 <= (HEAP32[(0 + 1178284 | 0) >> 2] | 0) >>> 0) {
            break label$2
           }
           if ($0) {
            break label$23
           }
           $0 = HEAP32[(0 + 1177888 | 0) >> 2] | 0;
           if (!$0) {
            break label$2
           }
           $4 = HEAP32[(((__wasm_ctz_i32(dlmalloc__dlmalloc__least_bit__hdec43f25959d8304($0 | 0) | 0 | 0) | 0) << 2 | 0) + 1178156 | 0) >> 2] | 0;
           $2 = (dlmalloc__dlmalloc__Chunk__size__hbcf51483386243e4(dlmalloc__dlmalloc__TreeChunk__chunk__h93f52b5b19dc8e79($4 | 0) | 0 | 0) | 0) - $3 | 0;
           label$25 : {
            $0 = dlmalloc__dlmalloc__TreeChunk__leftmost_child__h0e0ff04b08669a58($4 | 0) | 0;
            if (!$0) {
             break label$25
            }
            label$26 : while (1) {
             $7 = (dlmalloc__dlmalloc__Chunk__size__hbcf51483386243e4(dlmalloc__dlmalloc__TreeChunk__chunk__h93f52b5b19dc8e79($0 | 0) | 0 | 0) | 0) - $3 | 0;
             $271 = $7;
             $7 = $7 >>> 0 < $2 >>> 0;
             $2 = $7 ? $271 : $2;
             $4 = $7 ? $0 : $4;
             $0 = dlmalloc__dlmalloc__TreeChunk__leftmost_child__h0e0ff04b08669a58($0 | 0) | 0;
             if ($0) {
              continue label$26
             }
             break label$26;
            };
           }
           $0 = dlmalloc__dlmalloc__TreeChunk__chunk__h93f52b5b19dc8e79($4 | 0) | 0;
           $7 = dlmalloc__dlmalloc__Chunk__plus_offset__h7aa5253a4344ed9a($0 | 0, $3 | 0) | 0;
           dlmalloc__dlmalloc__Dlmalloc_A___unlink_large_chunk__h107571aa99375aaf($4 | 0);
           if ($2 >>> 0 < (dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2(16 | 0, 8 | 0) | 0) >>> 0) {
            break label$19
           }
           $7 = dlmalloc__dlmalloc__TreeChunk__chunk__h93f52b5b19dc8e79($7 | 0) | 0;
           dlmalloc__dlmalloc__Chunk__set_size_and_pinuse_of_inuse_chunk__hf4d697bb61df28bc($0 | 0, $3 | 0);
           dlmalloc__dlmalloc__Chunk__set_size_and_pinuse_of_free_chunk__hbc4027d35960d532($7 | 0, $2 | 0);
           $4 = HEAP32[(0 + 1178284 | 0) >> 2] | 0;
           if (!$4) {
            break label$20
           }
           $8 = $4 >>> 3 | 0;
           $6 = ($8 << 3 | 0) + 1177892 | 0;
           $4 = HEAP32[(0 + 1178292 | 0) >> 2] | 0;
           $5 = HEAP32[(0 + 1177884 | 0) >> 2] | 0;
           $8 = 1 << ($8 & 31 | 0) | 0;
           if (!($5 & $8 | 0)) {
            break label$22
           }
           $8 = HEAP32[($6 + 8 | 0) >> 2] | 0;
           break label$21;
          }
          label$27 : {
           label$28 : {
            $3 = (($0 ^ -1 | 0) & 1 | 0) + $2 | 0;
            $4 = $3 << 3 | 0;
            $0 = HEAP32[($4 + 1177900 | 0) >> 2] | 0;
            $2 = HEAP32[($0 + 8 | 0) >> 2] | 0;
            $4 = $4 + 1177892 | 0;
            if (($2 | 0) == ($4 | 0)) {
             break label$28
            }
            HEAP32[($2 + 12 | 0) >> 2] = $4;
            HEAP32[($4 + 8 | 0) >> 2] = $2;
            break label$27;
           }
           (wasm2js_i32$0 = 0, wasm2js_i32$1 = $7 & (__wasm_rotl_i32(-2 | 0, $3 | 0) | 0) | 0), HEAP32[(wasm2js_i32$0 + 1177884 | 0) >> 2] = wasm2js_i32$1;
          }
          dlmalloc__dlmalloc__Chunk__set_inuse_and_pinuse__hd70cd9b459f591b2($0 | 0, $3 << 3 | 0 | 0);
          $2 = dlmalloc__dlmalloc__Chunk__to_mem__he3242996ca597cec($0 | 0) | 0;
          break label$1;
         }
         label$29 : {
          label$30 : {
           $2 = __wasm_ctz_i32(dlmalloc__dlmalloc__least_bit__hdec43f25959d8304((dlmalloc__dlmalloc__left_bits__hea1a8ecbc54c753a(1 << $4 | 0 | 0) | 0) & ($0 << $4 | 0) | 0 | 0) | 0 | 0) | 0;
           $7 = $2 << 3 | 0;
           $0 = HEAP32[($7 + 1177900 | 0) >> 2] | 0;
           $4 = HEAP32[($0 + 8 | 0) >> 2] | 0;
           $7 = $7 + 1177892 | 0;
           if (($4 | 0) == ($7 | 0)) {
            break label$30
           }
           HEAP32[($4 + 12 | 0) >> 2] = $7;
           HEAP32[($7 + 8 | 0) >> 2] = $4;
           break label$29;
          }
          (wasm2js_i32$0 = 0, wasm2js_i32$1 = (HEAP32[(0 + 1177884 | 0) >> 2] | 0) & (__wasm_rotl_i32(-2 | 0, $2 | 0) | 0) | 0), HEAP32[(wasm2js_i32$0 + 1177884 | 0) >> 2] = wasm2js_i32$1;
         }
         dlmalloc__dlmalloc__Chunk__set_size_and_pinuse_of_inuse_chunk__hf4d697bb61df28bc($0 | 0, $3 | 0);
         $4 = dlmalloc__dlmalloc__Chunk__plus_offset__h7aa5253a4344ed9a($0 | 0, $3 | 0) | 0;
         $7 = ($2 << 3 | 0) - $3 | 0;
         dlmalloc__dlmalloc__Chunk__set_size_and_pinuse_of_free_chunk__hbc4027d35960d532($4 | 0, $7 | 0);
         label$31 : {
          $3 = HEAP32[(0 + 1178284 | 0) >> 2] | 0;
          if (!$3) {
           break label$31
          }
          $6 = $3 >>> 3 | 0;
          $2 = ($6 << 3 | 0) + 1177892 | 0;
          $3 = HEAP32[(0 + 1178292 | 0) >> 2] | 0;
          label$32 : {
           label$33 : {
            $8 = HEAP32[(0 + 1177884 | 0) >> 2] | 0;
            $6 = 1 << ($6 & 31 | 0) | 0;
            if (!($8 & $6 | 0)) {
             break label$33
            }
            $6 = HEAP32[($2 + 8 | 0) >> 2] | 0;
            break label$32;
           }
           HEAP32[(0 + 1177884 | 0) >> 2] = $8 | $6 | 0;
           $6 = $2;
          }
          HEAP32[($2 + 8 | 0) >> 2] = $3;
          HEAP32[($6 + 12 | 0) >> 2] = $3;
          HEAP32[($3 + 12 | 0) >> 2] = $2;
          HEAP32[($3 + 8 | 0) >> 2] = $6;
         }
         HEAP32[(0 + 1178292 | 0) >> 2] = $4;
         HEAP32[(0 + 1178284 | 0) >> 2] = $7;
         $2 = dlmalloc__dlmalloc__Chunk__to_mem__he3242996ca597cec($0 | 0) | 0;
         break label$1;
        }
        HEAP32[(0 + 1177884 | 0) >> 2] = $5 | $8 | 0;
        $8 = $6;
       }
       HEAP32[($6 + 8 | 0) >> 2] = $4;
       HEAP32[($8 + 12 | 0) >> 2] = $4;
       HEAP32[($4 + 12 | 0) >> 2] = $6;
       HEAP32[($4 + 8 | 0) >> 2] = $8;
      }
      HEAP32[(0 + 1178292 | 0) >> 2] = $7;
      HEAP32[(0 + 1178284 | 0) >> 2] = $2;
      break label$18;
     }
     dlmalloc__dlmalloc__Chunk__set_inuse_and_pinuse__hd70cd9b459f591b2($0 | 0, $2 + $3 | 0 | 0);
    }
    $2 = dlmalloc__dlmalloc__Chunk__to_mem__he3242996ca597cec($0 | 0) | 0;
    if ($2) {
     break label$1
    }
   }
   label$34 : {
    label$35 : {
     label$36 : {
      label$37 : {
       label$38 : {
        label$39 : {
         label$40 : {
          label$41 : {
           label$42 : {
            $2 = HEAP32[(0 + 1178284 | 0) >> 2] | 0;
            if ($2 >>> 0 >= $3 >>> 0) {
             break label$42
            }
            $0 = HEAP32[(0 + 1178288 | 0) >> 2] | 0;
            if ($0 >>> 0 > $3 >>> 0) {
             break label$38
            }
            $2 = 0;
            $0 = dlmalloc__dlmalloc__Chunk__to_mem__he3242996ca597cec(0 | 0) | 0;
            $dlmalloc__sys__System_20as_20dlmalloc__Allocator___alloc__h1d32aef92d923b70($1 | 0, 1177884 | 0, dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2((((($3 - $0 | 0) + (dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2($0 | 0, 8 | 0) | 0) | 0) + (dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2(20 | 0, 8 | 0) | 0) | 0) + (dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2(16 | 0, 8 | 0) | 0) | 0) + 8 | 0 | 0, 65536 | 0) | 0 | 0);
            $6 = HEAP32[$1 >> 2] | 0;
            if (!$6) {
             break label$1
            }
            $9 = HEAP32[($1 + 8 | 0) >> 2] | 0;
            $8 = HEAP32[($1 + 4 | 0) >> 2] | 0;
            $0 = (HEAP32[(0 + 1178300 | 0) >> 2] | 0) + $8 | 0;
            HEAP32[(0 + 1178300 | 0) >> 2] = $0;
            $2 = HEAP32[(0 + 1178304 | 0) >> 2] | 0;
            HEAP32[(0 + 1178304 | 0) >> 2] = $2 >>> 0 > $0 >>> 0 ? $2 : $0;
            if (!(HEAP32[(0 + 1178296 | 0) >> 2] | 0)) {
             break label$41
            }
            $0 = 1178308;
            label$43 : while (1) {
             if (($6 | 0) == (dlmalloc__dlmalloc__Segment__top__hf63c2d8a250d607b($0 | 0) | 0 | 0)) {
              break label$40
             }
             $0 = HEAP32[($0 + 8 | 0) >> 2] | 0;
             if ($0) {
              continue label$43
             }
             break label$39;
            };
           }
           $0 = HEAP32[(0 + 1178292 | 0) >> 2] | 0;
           label$44 : {
            $2 = $2 - $3 | 0;
            if ($2 >>> 0 >= (dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2(16 | 0, 8 | 0) | 0) >>> 0) {
             break label$44
            }
            HEAP32[(0 + 1178292 | 0) >> 2] = 0;
            $3 = HEAP32[(0 + 1178284 | 0) >> 2] | 0;
            HEAP32[(0 + 1178284 | 0) >> 2] = 0;
            dlmalloc__dlmalloc__Chunk__set_inuse_and_pinuse__hd70cd9b459f591b2($0 | 0, $3 | 0);
            $2 = dlmalloc__dlmalloc__Chunk__to_mem__he3242996ca597cec($0 | 0) | 0;
            break label$1;
           }
           $4 = dlmalloc__dlmalloc__Chunk__plus_offset__h7aa5253a4344ed9a($0 | 0, $3 | 0) | 0;
           HEAP32[(0 + 1178284 | 0) >> 2] = $2;
           HEAP32[(0 + 1178292 | 0) >> 2] = $4;
           dlmalloc__dlmalloc__Chunk__set_size_and_pinuse_of_free_chunk__hbc4027d35960d532($4 | 0, $2 | 0);
           dlmalloc__dlmalloc__Chunk__set_size_and_pinuse_of_inuse_chunk__hf4d697bb61df28bc($0 | 0, $3 | 0);
           $2 = dlmalloc__dlmalloc__Chunk__to_mem__he3242996ca597cec($0 | 0) | 0;
           break label$1;
          }
          label$45 : {
           label$46 : {
            $0 = HEAP32[(0 + 1178328 | 0) >> 2] | 0;
            if (!$0) {
             break label$46
            }
            if ($6 >>> 0 >= $0 >>> 0) {
             break label$45
            }
           }
           HEAP32[(0 + 1178328 | 0) >> 2] = $6;
          }
          HEAP32[(0 + 1178332 | 0) >> 2] = 4095;
          HEAP32[(0 + 1178320 | 0) >> 2] = $9;
          HEAP32[(0 + 1178312 | 0) >> 2] = $8;
          HEAP32[(0 + 1178308 | 0) >> 2] = $6;
          HEAP32[(0 + 1177904 | 0) >> 2] = 1177892;
          HEAP32[(0 + 1177912 | 0) >> 2] = 1177900;
          HEAP32[(0 + 1177900 | 0) >> 2] = 1177892;
          HEAP32[(0 + 1177920 | 0) >> 2] = 1177908;
          HEAP32[(0 + 1177908 | 0) >> 2] = 1177900;
          HEAP32[(0 + 1177928 | 0) >> 2] = 1177916;
          HEAP32[(0 + 1177916 | 0) >> 2] = 1177908;
          HEAP32[(0 + 1177936 | 0) >> 2] = 1177924;
          HEAP32[(0 + 1177924 | 0) >> 2] = 1177916;
          HEAP32[(0 + 1177944 | 0) >> 2] = 1177932;
          HEAP32[(0 + 1177932 | 0) >> 2] = 1177924;
          HEAP32[(0 + 1177952 | 0) >> 2] = 1177940;
          HEAP32[(0 + 1177940 | 0) >> 2] = 1177932;
          HEAP32[(0 + 1177960 | 0) >> 2] = 1177948;
          HEAP32[(0 + 1177948 | 0) >> 2] = 1177940;
          HEAP32[(0 + 1177968 | 0) >> 2] = 1177956;
          HEAP32[(0 + 1177956 | 0) >> 2] = 1177948;
          HEAP32[(0 + 1177964 | 0) >> 2] = 1177956;
          HEAP32[(0 + 1177976 | 0) >> 2] = 1177964;
          HEAP32[(0 + 1177972 | 0) >> 2] = 1177964;
          HEAP32[(0 + 1177984 | 0) >> 2] = 1177972;
          HEAP32[(0 + 1177980 | 0) >> 2] = 1177972;
          HEAP32[(0 + 1177992 | 0) >> 2] = 1177980;
          HEAP32[(0 + 1177988 | 0) >> 2] = 1177980;
          HEAP32[(0 + 1178e3 | 0) >> 2] = 1177988;
          HEAP32[(0 + 1177996 | 0) >> 2] = 1177988;
          HEAP32[(0 + 1178008 | 0) >> 2] = 1177996;
          HEAP32[(0 + 1178004 | 0) >> 2] = 1177996;
          HEAP32[(0 + 1178016 | 0) >> 2] = 1178004;
          HEAP32[(0 + 1178012 | 0) >> 2] = 1178004;
          HEAP32[(0 + 1178024 | 0) >> 2] = 1178012;
          HEAP32[(0 + 1178020 | 0) >> 2] = 1178012;
          HEAP32[(0 + 1178032 | 0) >> 2] = 1178020;
          HEAP32[(0 + 1178040 | 0) >> 2] = 1178028;
          HEAP32[(0 + 1178028 | 0) >> 2] = 1178020;
          HEAP32[(0 + 1178048 | 0) >> 2] = 1178036;
          HEAP32[(0 + 1178036 | 0) >> 2] = 1178028;
          HEAP32[(0 + 1178056 | 0) >> 2] = 1178044;
          HEAP32[(0 + 1178044 | 0) >> 2] = 1178036;
          HEAP32[(0 + 1178064 | 0) >> 2] = 1178052;
          HEAP32[(0 + 1178052 | 0) >> 2] = 1178044;
          HEAP32[(0 + 1178072 | 0) >> 2] = 1178060;
          HEAP32[(0 + 1178060 | 0) >> 2] = 1178052;
          HEAP32[(0 + 1178080 | 0) >> 2] = 1178068;
          HEAP32[(0 + 1178068 | 0) >> 2] = 1178060;
          HEAP32[(0 + 1178088 | 0) >> 2] = 1178076;
          HEAP32[(0 + 1178076 | 0) >> 2] = 1178068;
          HEAP32[(0 + 1178096 | 0) >> 2] = 1178084;
          HEAP32[(0 + 1178084 | 0) >> 2] = 1178076;
          HEAP32[(0 + 1178104 | 0) >> 2] = 1178092;
          HEAP32[(0 + 1178092 | 0) >> 2] = 1178084;
          HEAP32[(0 + 1178112 | 0) >> 2] = 1178100;
          HEAP32[(0 + 1178100 | 0) >> 2] = 1178092;
          HEAP32[(0 + 1178120 | 0) >> 2] = 1178108;
          HEAP32[(0 + 1178108 | 0) >> 2] = 1178100;
          HEAP32[(0 + 1178128 | 0) >> 2] = 1178116;
          HEAP32[(0 + 1178116 | 0) >> 2] = 1178108;
          HEAP32[(0 + 1178136 | 0) >> 2] = 1178124;
          HEAP32[(0 + 1178124 | 0) >> 2] = 1178116;
          HEAP32[(0 + 1178144 | 0) >> 2] = 1178132;
          HEAP32[(0 + 1178132 | 0) >> 2] = 1178124;
          HEAP32[(0 + 1178152 | 0) >> 2] = 1178140;
          HEAP32[(0 + 1178140 | 0) >> 2] = 1178132;
          HEAP32[(0 + 1178148 | 0) >> 2] = 1178140;
          $2 = dlmalloc__dlmalloc__Chunk__to_mem__he3242996ca597cec(0 | 0) | 0;
          $4 = dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2($2 | 0, 8 | 0) | 0;
          $7 = dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2(20 | 0, 8 | 0) | 0;
          $5 = dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2(16 | 0, 8 | 0) | 0;
          $0 = dlmalloc__dlmalloc__Chunk__to_mem__he3242996ca597cec($6 | 0) | 0;
          $9 = (dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2($0 | 0, 8 | 0) | 0) - $0 | 0;
          $0 = dlmalloc__dlmalloc__Chunk__plus_offset__h7aa5253a4344ed9a($6 | 0, $9 | 0) | 0;
          $2 = (((($8 + $2 | 0) - $4 | 0) - $7 | 0) - $5 | 0) - $9 | 0;
          HEAP32[(0 + 1178288 | 0) >> 2] = $2;
          HEAP32[(0 + 1178296 | 0) >> 2] = $0;
          HEAP32[($0 + 4 | 0) >> 2] = $2 | 1 | 0;
          $4 = dlmalloc__dlmalloc__Chunk__to_mem__he3242996ca597cec(0 | 0) | 0;
          $7 = dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2($4 | 0, 8 | 0) | 0;
          $6 = dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2(20 | 0, 8 | 0) | 0;
          $8 = dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2(16 | 0, 8 | 0) | 0;
          (wasm2js_i32$0 = dlmalloc__dlmalloc__Chunk__plus_offset__h7aa5253a4344ed9a($0 | 0, $2 | 0) | 0, wasm2js_i32$1 = $8 + ($6 + ($7 - $4 | 0) | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
          HEAP32[(0 + 1178324 | 0) >> 2] = 2097152;
          break label$34;
         }
         if (dlmalloc__dlmalloc__Segment__is_extern__hebd3849795a5a7f4($0 | 0) | 0) {
          break label$39
         }
         if ((dlmalloc__dlmalloc__Segment__sys_flags__hb172c8f042b0bb42($0 | 0) | 0 | 0) != ($9 | 0)) {
          break label$39
         }
         if (dlmalloc__dlmalloc__Segment__holds__h401eff113aa2fd65($0 | 0, HEAP32[(0 + 1178296 | 0) >> 2] | 0 | 0) | 0) {
          break label$37
         }
        }
        $0 = HEAP32[(0 + 1178328 | 0) >> 2] | 0;
        HEAP32[(0 + 1178328 | 0) >> 2] = $6 >>> 0 > $0 >>> 0 ? $0 : $6;
        $2 = $6 + $8 | 0;
        $0 = 1178308;
        label$47 : {
         label$48 : {
          label$49 : {
           label$50 : while (1) {
            if ((HEAP32[$0 >> 2] | 0 | 0) == ($2 | 0)) {
             break label$49
            }
            $0 = HEAP32[($0 + 8 | 0) >> 2] | 0;
            if ($0) {
             continue label$50
            }
            break label$48;
           };
          }
          if (dlmalloc__dlmalloc__Segment__is_extern__hebd3849795a5a7f4($0 | 0) | 0) {
           break label$48
          }
          if ((dlmalloc__dlmalloc__Segment__sys_flags__hb172c8f042b0bb42($0 | 0) | 0 | 0) == ($9 | 0)) {
           break label$47
          }
         }
         $4 = HEAP32[(0 + 1178296 | 0) >> 2] | 0;
         $0 = 1178308;
         label$51 : {
          label$52 : while (1) {
           label$53 : {
            if ((HEAP32[$0 >> 2] | 0) >>> 0 > $4 >>> 0) {
             break label$53
            }
            if ((dlmalloc__dlmalloc__Segment__top__hf63c2d8a250d607b($0 | 0) | 0) >>> 0 > $4 >>> 0) {
             break label$51
            }
           }
           $0 = HEAP32[($0 + 8 | 0) >> 2] | 0;
           if ($0) {
            continue label$52
           }
           break label$52;
          };
          $0 = 0;
         }
         $7 = dlmalloc__dlmalloc__Segment__top__hf63c2d8a250d607b($0 | 0) | 0;
         $10 = dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2(20 | 0, 8 | 0) | 0;
         $0 = ($7 - $10 | 0) + -23 | 0;
         $2 = dlmalloc__dlmalloc__Chunk__to_mem__he3242996ca597cec($0 | 0) | 0;
         $0 = $0 + ((dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2($2 | 0, 8 | 0) | 0) - $2 | 0) | 0;
         $5 = $0 >>> 0 < ($4 + (dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2(16 | 0, 8 | 0) | 0) | 0) >>> 0 ? $4 : $0;
         $2 = dlmalloc__dlmalloc__Chunk__to_mem__he3242996ca597cec($5 | 0) | 0;
         $0 = dlmalloc__dlmalloc__Chunk__plus_offset__h7aa5253a4344ed9a($5 | 0, $10 | 0) | 0;
         $11 = dlmalloc__dlmalloc__Chunk__to_mem__he3242996ca597cec(0 | 0) | 0;
         $12 = dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2($11 | 0, 8 | 0) | 0;
         $13 = dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2(20 | 0, 8 | 0) | 0;
         $14 = dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2(16 | 0, 8 | 0) | 0;
         $15 = dlmalloc__dlmalloc__Chunk__to_mem__he3242996ca597cec($6 | 0) | 0;
         $16 = (dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2($15 | 0, 8 | 0) | 0) - $15 | 0;
         $15 = dlmalloc__dlmalloc__Chunk__plus_offset__h7aa5253a4344ed9a($6 | 0, $16 | 0) | 0;
         $11 = (((($8 + $11 | 0) - $12 | 0) - $13 | 0) - $14 | 0) - $16 | 0;
         HEAP32[(0 + 1178288 | 0) >> 2] = $11;
         HEAP32[(0 + 1178296 | 0) >> 2] = $15;
         HEAP32[($15 + 4 | 0) >> 2] = $11 | 1 | 0;
         $12 = dlmalloc__dlmalloc__Chunk__to_mem__he3242996ca597cec(0 | 0) | 0;
         $13 = dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2($12 | 0, 8 | 0) | 0;
         $14 = dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2(20 | 0, 8 | 0) | 0;
         $16 = dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2(16 | 0, 8 | 0) | 0;
         (wasm2js_i32$0 = dlmalloc__dlmalloc__Chunk__plus_offset__h7aa5253a4344ed9a($15 | 0, $11 | 0) | 0, wasm2js_i32$1 = $16 + ($14 + ($13 - $12 | 0) | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
         HEAP32[(0 + 1178324 | 0) >> 2] = 2097152;
         dlmalloc__dlmalloc__Chunk__set_size_and_pinuse_of_inuse_chunk__hf4d697bb61df28bc($5 | 0, $10 | 0);
         i64toi32_i32$2 = 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1178308 | 0) >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1178312 | 0) >> 2] | 0;
         $17 = i64toi32_i32$0;
         $17$hi = i64toi32_i32$1;
         i64toi32_i32$2 = 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1178316 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1178320 | 0) >> 2] | 0;
         $697 = i64toi32_i32$1;
         i64toi32_i32$1 = $2 + 8 | 0;
         HEAP32[i64toi32_i32$1 >> 2] = $697;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$0 = $17$hi;
         i64toi32_i32$1 = $2;
         HEAP32[$2 >> 2] = $17;
         HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$0;
         HEAP32[(0 + 1178320 | 0) >> 2] = $9;
         HEAP32[(0 + 1178312 | 0) >> 2] = $8;
         HEAP32[(0 + 1178308 | 0) >> 2] = $6;
         HEAP32[(0 + 1178316 | 0) >> 2] = $2;
         label$54 : while (1) {
          $2 = dlmalloc__dlmalloc__Chunk__plus_offset__h7aa5253a4344ed9a($0 | 0, 4 | 0) | 0;
          (wasm2js_i32$0 = $0, wasm2js_i32$1 = dlmalloc__dlmalloc__Chunk__fencepost_head__hd9702b75b47fe031() | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
          $0 = $2;
          if ($7 >>> 0 > ($0 + 4 | 0) >>> 0) {
           continue label$54
          }
          break label$54;
         };
         if (($5 | 0) == ($4 | 0)) {
          break label$34
         }
         $0 = $5 - $4 | 0;
         dlmalloc__dlmalloc__Chunk__set_free_with_pinuse__hb6fcf1321e8edd9b($4 | 0, $0 | 0, dlmalloc__dlmalloc__Chunk__plus_offset__h7aa5253a4344ed9a($4 | 0, $0 | 0) | 0 | 0);
         label$55 : {
          if ($0 >>> 0 < 256 >>> 0) {
           break label$55
          }
          dlmalloc__dlmalloc__Dlmalloc_A___insert_large_chunk__h524840f32df7e3d2($4 | 0, $0 | 0);
          break label$34;
         }
         $2 = $0 >>> 3 | 0;
         $0 = ($2 << 3 | 0) + 1177892 | 0;
         label$56 : {
          label$57 : {
           $7 = HEAP32[(0 + 1177884 | 0) >> 2] | 0;
           $2 = 1 << $2 | 0;
           if (!($7 & $2 | 0)) {
            break label$57
           }
           $2 = HEAP32[($0 + 8 | 0) >> 2] | 0;
           break label$56;
          }
          HEAP32[(0 + 1177884 | 0) >> 2] = $7 | $2 | 0;
          $2 = $0;
         }
         HEAP32[($0 + 8 | 0) >> 2] = $4;
         HEAP32[($2 + 12 | 0) >> 2] = $4;
         HEAP32[($4 + 12 | 0) >> 2] = $0;
         HEAP32[($4 + 8 | 0) >> 2] = $2;
         break label$34;
        }
        $7 = HEAP32[$0 >> 2] | 0;
        HEAP32[$0 >> 2] = $6;
        HEAP32[($0 + 4 | 0) >> 2] = (HEAP32[($0 + 4 | 0) >> 2] | 0) + $8 | 0;
        $0 = dlmalloc__dlmalloc__Chunk__to_mem__he3242996ca597cec($6 | 0) | 0;
        $2 = dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2($0 | 0, 8 | 0) | 0;
        $8 = dlmalloc__dlmalloc__Chunk__to_mem__he3242996ca597cec($7 | 0) | 0;
        $5 = dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2($8 | 0, 8 | 0) | 0;
        $2 = $6 + ($2 - $0 | 0) | 0;
        $4 = dlmalloc__dlmalloc__Chunk__plus_offset__h7aa5253a4344ed9a($2 | 0, $3 | 0) | 0;
        dlmalloc__dlmalloc__Chunk__set_size_and_pinuse_of_inuse_chunk__hf4d697bb61df28bc($2 | 0, $3 | 0);
        $0 = $7 + ($5 - $8 | 0) | 0;
        $3 = ($0 - $2 | 0) - $3 | 0;
        if ((HEAP32[(0 + 1178296 | 0) >> 2] | 0 | 0) == ($0 | 0)) {
         break label$36
        }
        if ((HEAP32[(0 + 1178292 | 0) >> 2] | 0 | 0) == ($0 | 0)) {
         break label$35
        }
        label$58 : {
         if (dlmalloc__dlmalloc__Chunk__inuse__h180ffa176be4dba6($0 | 0) | 0) {
          break label$58
         }
         label$59 : {
          label$60 : {
           $7 = dlmalloc__dlmalloc__Chunk__size__hbcf51483386243e4($0 | 0) | 0;
           if ($7 >>> 0 < 256 >>> 0) {
            break label$60
           }
           dlmalloc__dlmalloc__Dlmalloc_A___unlink_large_chunk__h107571aa99375aaf($0 | 0);
           break label$59;
          }
          label$61 : {
           $6 = HEAP32[($0 + 12 | 0) >> 2] | 0;
           $8 = HEAP32[($0 + 8 | 0) >> 2] | 0;
           if (($6 | 0) == ($8 | 0)) {
            break label$61
           }
           HEAP32[($8 + 12 | 0) >> 2] = $6;
           HEAP32[($6 + 8 | 0) >> 2] = $8;
           break label$59;
          }
          (wasm2js_i32$0 = 0, wasm2js_i32$1 = (HEAP32[(0 + 1177884 | 0) >> 2] | 0) & (__wasm_rotl_i32(-2 | 0, $7 >>> 3 | 0 | 0) | 0) | 0), HEAP32[(wasm2js_i32$0 + 1177884 | 0) >> 2] = wasm2js_i32$1;
         }
         $3 = $7 + $3 | 0;
         $0 = dlmalloc__dlmalloc__Chunk__plus_offset__h7aa5253a4344ed9a($0 | 0, $7 | 0) | 0;
        }
        dlmalloc__dlmalloc__Chunk__set_free_with_pinuse__hb6fcf1321e8edd9b($4 | 0, $3 | 0, $0 | 0);
        label$62 : {
         if ($3 >>> 0 < 256 >>> 0) {
          break label$62
         }
         dlmalloc__dlmalloc__Dlmalloc_A___insert_large_chunk__h524840f32df7e3d2($4 | 0, $3 | 0);
         $2 = dlmalloc__dlmalloc__Chunk__to_mem__he3242996ca597cec($2 | 0) | 0;
         break label$1;
        }
        $3 = $3 >>> 3 | 0;
        $0 = ($3 << 3 | 0) + 1177892 | 0;
        label$63 : {
         label$64 : {
          $7 = HEAP32[(0 + 1177884 | 0) >> 2] | 0;
          $3 = 1 << $3 | 0;
          if (!($7 & $3 | 0)) {
           break label$64
          }
          $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
          break label$63;
         }
         HEAP32[(0 + 1177884 | 0) >> 2] = $7 | $3 | 0;
         $3 = $0;
        }
        HEAP32[($0 + 8 | 0) >> 2] = $4;
        HEAP32[($3 + 12 | 0) >> 2] = $4;
        HEAP32[($4 + 12 | 0) >> 2] = $0;
        HEAP32[($4 + 8 | 0) >> 2] = $3;
        $2 = dlmalloc__dlmalloc__Chunk__to_mem__he3242996ca597cec($2 | 0) | 0;
        break label$1;
       }
       $2 = $0 - $3 | 0;
       HEAP32[(0 + 1178288 | 0) >> 2] = $2;
       $0 = HEAP32[(0 + 1178296 | 0) >> 2] | 0;
       $4 = dlmalloc__dlmalloc__Chunk__plus_offset__h7aa5253a4344ed9a($0 | 0, $3 | 0) | 0;
       HEAP32[(0 + 1178296 | 0) >> 2] = $4;
       HEAP32[($4 + 4 | 0) >> 2] = $2 | 1 | 0;
       dlmalloc__dlmalloc__Chunk__set_size_and_pinuse_of_inuse_chunk__hf4d697bb61df28bc($0 | 0, $3 | 0);
       $2 = dlmalloc__dlmalloc__Chunk__to_mem__he3242996ca597cec($0 | 0) | 0;
       break label$1;
      }
      HEAP32[($0 + 4 | 0) >> 2] = (HEAP32[($0 + 4 | 0) >> 2] | 0) + $8 | 0;
      $2 = HEAP32[(0 + 1178288 | 0) >> 2] | 0;
      $0 = HEAP32[(0 + 1178296 | 0) >> 2] | 0;
      $4 = dlmalloc__dlmalloc__Chunk__to_mem__he3242996ca597cec($0 | 0) | 0;
      $4 = (dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2($4 | 0, 8 | 0) | 0) - $4 | 0;
      $0 = dlmalloc__dlmalloc__Chunk__plus_offset__h7aa5253a4344ed9a($0 | 0, $4 | 0) | 0;
      $2 = ($2 + $8 | 0) - $4 | 0;
      HEAP32[(0 + 1178288 | 0) >> 2] = $2;
      HEAP32[(0 + 1178296 | 0) >> 2] = $0;
      HEAP32[($0 + 4 | 0) >> 2] = $2 | 1 | 0;
      $4 = dlmalloc__dlmalloc__Chunk__to_mem__he3242996ca597cec(0 | 0) | 0;
      $7 = dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2($4 | 0, 8 | 0) | 0;
      $6 = dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2(20 | 0, 8 | 0) | 0;
      $8 = dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2(16 | 0, 8 | 0) | 0;
      (wasm2js_i32$0 = dlmalloc__dlmalloc__Chunk__plus_offset__h7aa5253a4344ed9a($0 | 0, $2 | 0) | 0, wasm2js_i32$1 = $8 + ($6 + ($7 - $4 | 0) | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
      HEAP32[(0 + 1178324 | 0) >> 2] = 2097152;
      break label$34;
     }
     HEAP32[(0 + 1178296 | 0) >> 2] = $4;
     $0 = (HEAP32[(0 + 1178288 | 0) >> 2] | 0) + $3 | 0;
     HEAP32[(0 + 1178288 | 0) >> 2] = $0;
     HEAP32[($4 + 4 | 0) >> 2] = $0 | 1 | 0;
     $2 = dlmalloc__dlmalloc__Chunk__to_mem__he3242996ca597cec($2 | 0) | 0;
     break label$1;
    }
    HEAP32[(0 + 1178292 | 0) >> 2] = $4;
    $0 = (HEAP32[(0 + 1178284 | 0) >> 2] | 0) + $3 | 0;
    HEAP32[(0 + 1178284 | 0) >> 2] = $0;
    dlmalloc__dlmalloc__Chunk__set_size_and_pinuse_of_free_chunk__hbc4027d35960d532($4 | 0, $0 | 0);
    $2 = dlmalloc__dlmalloc__Chunk__to_mem__he3242996ca597cec($2 | 0) | 0;
    break label$1;
   }
   $2 = 0;
   $0 = HEAP32[(0 + 1178288 | 0) >> 2] | 0;
   if ($0 >>> 0 <= $3 >>> 0) {
    break label$1
   }
   $2 = $0 - $3 | 0;
   HEAP32[(0 + 1178288 | 0) >> 2] = $2;
   $0 = HEAP32[(0 + 1178296 | 0) >> 2] | 0;
   $4 = dlmalloc__dlmalloc__Chunk__plus_offset__h7aa5253a4344ed9a($0 | 0, $3 | 0) | 0;
   HEAP32[(0 + 1178296 | 0) >> 2] = $4;
   HEAP32[($4 + 4 | 0) >> 2] = $2 | 1 | 0;
   dlmalloc__dlmalloc__Chunk__set_size_and_pinuse_of_inuse_chunk__hf4d697bb61df28bc($0 | 0, $3 | 0);
   $2 = dlmalloc__dlmalloc__Chunk__to_mem__he3242996ca597cec($0 | 0) | 0;
  }
  global$0 = $1 + 16 | 0;
  return $2 | 0;
 }
 
 function cardano_serialization_lib__metadata__encode_json_value_to_metadatum__h64667ed57b92baeb($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $4 = 0, $5 = 0, $6 = 0, $8 = 0, $7 = 0, $12 = 0, $10 = 0, $13 = 0, $13$hi = 0, $14 = 0, $14$hi = 0, $9 = 0, $11 = 0, $43 = 0, $69 = 0, $74 = 0, $80 = 0, $83 = 0, $140 = 0, $172 = 0, $177 = 0, $230 = 0, $324 = 0, $329 = 0, $364 = 0, $369 = 0, $438 = 0, $442 = 0, $454 = 0, $467 = 0, $482 = 0, $510 = 0, $528 = 0, $535 = 0, $538 = 0, $568 = 0, $575 = 0, $582 = 0, $585 = 0, $594 = 0, $624 = 0, $627 = 0, $636 = 0, $652 = 0, $657 = 0, $660 = 0;
  $3 = global$0 - 512 | 0;
  global$0 = $3;
  $4 = HEAPU8[$1 >> 0] | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           label$10 : {
            label$11 : {
             label$12 : {
              label$13 : {
               label$14 : {
                label$15 : {
                 label$16 : {
                  label$17 : {
                   label$18 : {
                    label$19 : {
                     label$20 : {
                      label$21 : {
                       label$22 : {
                        label$23 : {
                         if (($2 & 255 | 0) >>> 0 > 1 >>> 0) {
                          break label$23
                         }
                         switch ($4 | 0) {
                         case 5:
                          break label$17;
                         case 4:
                          break label$18;
                         case 3:
                          break label$19;
                         case 2:
                          break label$20;
                         case 1:
                          break label$21;
                         default:
                          break label$22;
                         };
                        }
                        label$24 : {
                         label$25 : {
                          if (($4 | 0) != (5 | 0)) {
                           break label$25
                          }
                          $4 = $1 + 4 | 0;
                          if ((alloc__collections__btree__map__BTreeMap_K_2cV___len__h9902d4fb7515c681($4 | 0) | 0 | 0) == (1 | 0)) {
                           break label$24
                          }
                         }
                         $4 = 1;
                         $2 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1059312 | 0, 50 | 0) | 0;
                         HEAP32[$0 >> 2] = 1;
                         HEAP32[($0 + 4 | 0) >> 2] = $2;
                         break label$3;
                        }
                        HEAP32[(($3 + 456 | 0) + 8 | 0) >> 2] = HEAP32[($4 + 8 | 0) >> 2] | 0;
                        i64toi32_i32$2 = $4;
                        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                        $43 = i64toi32_i32$0;
                        i64toi32_i32$0 = $3;
                        HEAP32[($3 + 456 | 0) >> 2] = $43;
                        HEAP32[($3 + 460 | 0) >> 2] = i64toi32_i32$1;
                        $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__iter__traits__collect__IntoIterator___into_iter__h78aadcd9a0523691($3 + 360 | 0 | 0, $3 + 456 | 0 | 0);
                        $alloc__collections__btree__map__IntoIter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h7fa673cac2ce5cb9($3 + 456 | 0 | 0, $3 + 360 | 0 | 0);
                        if ((HEAPU8[($3 + 472 | 0) >> 0] | 0 | 0) == (6 | 0)) {
                         break label$11
                        }
                        memcpy($3 + 408 | 0 | 0, $3 + 456 | 0 | 0, 40 | 0) | 0;
                        HEAP32[(($3 + 144 | 0) + 8 | 0) >> 2] = HEAP32[(($3 + 408 | 0) + 8 | 0) >> 2] | 0;
                        i64toi32_i32$2 = $3;
                        i64toi32_i32$1 = HEAP32[($3 + 408 | 0) >> 2] | 0;
                        i64toi32_i32$0 = HEAP32[($3 + 412 | 0) >> 2] | 0;
                        $69 = i64toi32_i32$1;
                        i64toi32_i32$1 = $3;
                        HEAP32[($3 + 144 | 0) >> 2] = $69;
                        HEAP32[($3 + 148 | 0) >> 2] = i64toi32_i32$0;
                        i64toi32_i32$2 = $3 + 440 | 0;
                        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                        $74 = i64toi32_i32$0;
                        i64toi32_i32$0 = $3 + 192 | 0;
                        HEAP32[i64toi32_i32$0 >> 2] = $74;
                        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
                        i64toi32_i32$2 = $3 + 432 | 0;
                        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                        $80 = i64toi32_i32$1;
                        i64toi32_i32$1 = ($3 + 176 | 0) + 8 | 0;
                        HEAP32[i64toi32_i32$1 >> 2] = $80;
                        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                        i64toi32_i32$2 = $3;
                        i64toi32_i32$0 = HEAP32[($3 + 424 | 0) >> 2] | 0;
                        i64toi32_i32$1 = HEAP32[($3 + 428 | 0) >> 2] | 0;
                        $83 = i64toi32_i32$0;
                        i64toi32_i32$0 = $3;
                        HEAP32[($3 + 176 | 0) >> 2] = $83;
                        HEAP32[($3 + 180 | 0) >> 2] = i64toi32_i32$1;
                        label$26 : {
                         $4 = HEAP32[($3 + 364 | 0) >> 2] | 0;
                         if (!$4) {
                          break label$26
                         }
                         $5 = HEAP32[($3 + 360 | 0) >> 2] | 0;
                         $6 = HEAP32[($3 + 368 | 0) >> 2] | 0;
                         HEAP32[($3 + 468 | 0) >> 2] = HEAP32[($3 + 384 | 0) >> 2] | 0;
                         HEAP32[($3 + 464 | 0) >> 2] = $6;
                         HEAP32[($3 + 460 | 0) >> 2] = $4;
                         HEAP32[($3 + 456 | 0) >> 2] = $5;
                         $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__hdfdbc3776b972463($3 + 456 | 0 | 0);
                        }
                        $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 80 | 0 | 0, $3 + 144 | 0 | 0);
                        label$27 : {
                         label$28 : {
                          label$29 : {
                           label$30 : {
                            label$31 : {
                             $4 = HEAP32[($3 + 80 | 0) >> 2] | 0;
                             $5 = HEAP32[($3 + 84 | 0) >> 2] | 0;
                             if (core__slice__cmp___impl_20core__cmp__PartialEq__5bB_5d__20for_20_5bA_5d___eq__hc3de93b036fcc30b($4 | 0, $5 | 0, 1059380 | 0, 3 | 0) | 0) {
                              break label$31
                             }
                             if (core__slice__cmp___impl_20core__cmp__PartialEq__5bB_5d__20for_20_5bA_5d___eq__hc3de93b036fcc30b($4 | 0, $5 | 0, 1059383 | 0, 6 | 0) | 0) {
                              break label$30
                             }
                             if (core__slice__cmp___impl_20core__cmp__PartialEq__5bB_5d__20for_20_5bA_5d___eq__hc3de93b036fcc30b($4 | 0, $5 | 0, 1059389 | 0, 5 | 0) | 0) {
                              break label$29
                             }
                             if (core__slice__cmp___impl_20core__cmp__PartialEq__5bB_5d__20for_20_5bA_5d___eq__hc3de93b036fcc30b($4 | 0, $5 | 0, 1059434 | 0, 4 | 0) | 0) {
                              break label$28
                             }
                             if (core__slice__cmp___impl_20core__cmp__PartialEq__5bB_5d__20for_20_5bA_5d___eq__hc3de93b036fcc30b($4 | 0, $5 | 0, 1059438 | 0, 3 | 0) | 0) {
                              break label$27
                             }
                             HEAP32[($3 + 316 | 0) >> 2] = $5;
                             HEAP32[($3 + 312 | 0) >> 2] = $4;
                             core__fmt__ArgumentV1__new__hbd2b9e6635c55d43($3 + 72 | 0 | 0, $3 + 312 | 0 | 0, 1 | 0);
                             HEAP32[($3 + 476 | 0) >> 2] = 1;
                             i64toi32_i32$0 = $3;
                             i64toi32_i32$1 = 0;
                             HEAP32[($3 + 460 | 0) >> 2] = 2;
                             HEAP32[($3 + 464 | 0) >> 2] = i64toi32_i32$1;
                             HEAP32[($3 + 456 | 0) >> 2] = 1059476;
                             i64toi32_i32$2 = $3;
                             i64toi32_i32$1 = HEAP32[($3 + 72 | 0) >> 2] | 0;
                             i64toi32_i32$0 = HEAP32[($3 + 76 | 0) >> 2] | 0;
                             $140 = i64toi32_i32$1;
                             i64toi32_i32$1 = $3;
                             HEAP32[($3 + 360 | 0) >> 2] = $140;
                             HEAP32[($3 + 364 | 0) >> 2] = i64toi32_i32$0;
                             HEAP32[($3 + 472 | 0) >> 2] = $3 + 360 | 0;
                             alloc__fmt__format__h6e9e003a52c07309($3 + 408 | 0 | 0, $3 + 456 | 0 | 0);
                             $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 64 | 0 | 0, $3 + 408 | 0 | 0);
                             $2 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($3 + 64 | 0) >> 2] | 0 | 0, HEAP32[($3 + 68 | 0) >> 2] | 0 | 0) | 0;
                             HEAP32[$0 >> 2] = 1;
                             HEAP32[($0 + 4 | 0) >> 2] = $2;
                             $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 408 | 0 | 0);
                             $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 408 | 0 | 0);
                             break label$5;
                            }
                            label$32 : {
                             if ((HEAPU8[($3 + 176 | 0) >> 0] | 0 | 0) != (2 | 0)) {
                              break label$32
                             }
                             i64toi32_i32$2 = $3 + 192 | 0;
                             i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                             i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                             $172 = i64toi32_i32$0;
                             i64toi32_i32$0 = ($3 + 456 | 0) + 8 | 0;
                             HEAP32[i64toi32_i32$0 >> 2] = $172;
                             HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
                             i64toi32_i32$2 = ($3 + 176 | 0) + 8 | 0;
                             i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                             i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                             $177 = i64toi32_i32$1;
                             i64toi32_i32$1 = $3;
                             HEAP32[($3 + 456 | 0) >> 2] = $177;
                             HEAP32[($3 + 460 | 0) >> 2] = i64toi32_i32$0;
                             cardano_serialization_lib__metadata__encode_json_value_to_metadatum__encode_number__h31f9bcd9af2979cd($0 | 0, $3 + 456 | 0 | 0);
                             break label$5;
                            }
                            $2 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1059579 | 0, 23 | 0) | 0;
                            HEAP32[$0 >> 2] = 1;
                            HEAP32[($0 + 4 | 0) >> 2] = $2;
                            break label$5;
                           }
                           serde_json__value__Value__as_str__h7324103a5967f3bf($3 + 24 | 0 | 0, $3 + 176 | 0 | 0);
                           label$33 : {
                            $4 = HEAP32[($3 + 24 | 0) >> 2] | 0;
                            if (!$4) {
                             break label$33
                            }
                            alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($3 + 456 | 0 | 0, $4 | 0, HEAP32[($3 + 28 | 0) >> 2] | 0 | 0);
                            cardano_serialization_lib__metadata__encode_json_value_to_metadatum__encode_string__had75d0cd3a140bd6($0 | 0, $3 + 456 | 0 | 0, $2 | 0);
                            break label$5;
                           }
                           $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1059579 | 0, 23 | 0) | 0 | 0) | 0;
                           HEAP32[$0 >> 2] = 1;
                           HEAP32[($0 + 4 | 0) >> 2] = $1;
                           break label$6;
                          }
                          serde_json__value__Value__as_str__h7324103a5967f3bf($3 + 32 | 0 | 0, $3 + 176 | 0 | 0);
                          $2 = HEAP32[($3 + 32 | 0) >> 2] | 0;
                          if (!$2) {
                           break label$12
                          }
                          $alloc__vec__Vec_u8__20as_20hex__FromHex___from_hex__h4bc81c912cf347f6($3 + 456 | 0 | 0, $2 | 0, HEAP32[($3 + 36 | 0) >> 2] | 0 | 0);
                          label$34 : {
                           if ((HEAP32[($3 + 456 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                            break label$34
                           }
                           HEAP32[($3 + 416 | 0) >> 2] = HEAP32[($3 + 468 | 0) >> 2] | 0;
                           i64toi32_i32$2 = $3;
                           i64toi32_i32$0 = HEAP32[($3 + 460 | 0) >> 2] | 0;
                           i64toi32_i32$1 = HEAP32[($3 + 464 | 0) >> 2] | 0;
                           $230 = i64toi32_i32$0;
                           i64toi32_i32$0 = $3;
                           HEAP32[($3 + 408 | 0) >> 2] = $230;
                           HEAP32[($3 + 412 | 0) >> 2] = i64toi32_i32$1;
                           cardano_serialization_lib__metadata__TransactionMetadatum__new_bytes__h341a06dfb4f1da88($0 | 0, $3 + 408 | 0 | 0);
                           break label$5;
                          }
                          $2 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1059394 | 0, 40 | 0) | 0;
                          HEAP32[$0 >> 2] = 1;
                          HEAP32[($0 + 4 | 0) >> 2] = $2;
                          break label$5;
                         }
                         label$35 : {
                          $4 = serde_json__value__Value__as_array__h2104f0d2dc692458($3 + 176 | 0 | 0) | 0;
                          if (!$4) {
                           break label$35
                          }
                          $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__ha732c788391a1960($3 + 456 | 0 | 0, $4 | 0);
                          cardano_serialization_lib__metadata__encode_json_value_to_metadatum__encode_array__hdc5d0ec20300a896($0 | 0, $3 + 456 | 0 | 0, $2 | 0);
                          break label$5;
                         }
                         $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1059579 | 0, 23 | 0) | 0 | 0) | 0;
                         HEAP32[$0 >> 2] = 1;
                         HEAP32[($0 + 4 | 0) >> 2] = $1;
                         break label$6;
                        }
                        std__thread__local__LocalKey_T___with__h4cd07b14a44a727e($3 + 48 | 0 | 0, 1060968 | 0);
                        i64toi32_i32$2 = $3;
                        i64toi32_i32$1 = HEAP32[($3 + 48 | 0) >> 2] | 0;
                        i64toi32_i32$0 = HEAP32[($3 + 52 | 0) >> 2] | 0;
                        $13 = i64toi32_i32$1;
                        $13$hi = i64toi32_i32$0;
                        i64toi32_i32$2 = $3;
                        i64toi32_i32$0 = HEAP32[($3 + 56 | 0) >> 2] | 0;
                        i64toi32_i32$1 = HEAP32[($3 + 60 | 0) >> 2] | 0;
                        $14 = i64toi32_i32$0;
                        $14$hi = i64toi32_i32$1;
                        $4 = hashbrown__raw__generic__Group__static_empty__hc5a7932fe1bdb1f1() | 0;
                        i64toi32_i32$0 = $3 + 296 | 0;
                        i64toi32_i32$1 = 0;
                        HEAP32[i64toi32_i32$0 >> 2] = 0;
                        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
                        HEAP32[($3 + 292 | 0) >> 2] = $4;
                        HEAP32[($3 + 288 | 0) >> 2] = 0;
                        i64toi32_i32$0 = $3;
                        i64toi32_i32$1 = 0;
                        HEAP32[($3 + 304 | 0) >> 2] = 0;
                        HEAP32[($3 + 308 | 0) >> 2] = i64toi32_i32$1;
                        i64toi32_i32$1 = $14$hi;
                        i64toi32_i32$0 = $3;
                        HEAP32[($3 + 280 | 0) >> 2] = $14;
                        HEAP32[($3 + 284 | 0) >> 2] = i64toi32_i32$1;
                        i64toi32_i32$1 = $13$hi;
                        i64toi32_i32$0 = $3;
                        HEAP32[($3 + 272 | 0) >> 2] = $13;
                        HEAP32[($3 + 276 | 0) >> 2] = i64toi32_i32$1;
                        $4 = serde_json__value__Value__as_array__h2104f0d2dc692458($3 + 176 | 0 | 0) | 0;
                        if (!$4) {
                         break label$8
                        }
                        $_alloc__vec__Vec_T_2cA__20as_20core__iter__traits__collect__IntoIterator___into_iter__h770da9f254a2d1a7($3 + 40 | 0 | 0, $4 | 0);
                        $4 = HEAP32[($3 + 40 | 0) >> 2] | 0;
                        $7 = HEAP32[($3 + 44 | 0) >> 2] | 0;
                        if (($4 | 0) == ($7 | 0)) {
                         break label$9
                        }
                        $8 = ($3 + 456 | 0) + 8 | 0;
                        $9 = ($3 + 104 | 0) + 8 | 0;
                        $10 = $3 + 104 | 0 | 4 | 0;
                        $11 = ($3 + 408 | 0) + 8 | 0;
                        $12 = $3 + 408 | 0 | 4 | 0;
                        label$36 : while (1) {
                         $5 = serde_json__value__Value__as_object__hc4bb3712d47c3f95($4 | 0) | 0;
                         if (!$5) {
                          break label$13
                         }
                         $6 = alloc__collections__btree__map__BTreeMap_K_2cV___get__h1f6710d7f87d2e37($5 | 0, 1059441 | 0, 1 | 0) | 0;
                         if (!$6) {
                          break label$14
                         }
                         $5 = alloc__collections__btree__map__BTreeMap_K_2cV___get__h1f6710d7f87d2e37($5 | 0, 1059442 | 0, 1 | 0) | 0;
                         if (!$5) {
                          break label$15
                         }
                         label$37 : {
                          label$38 : {
                           switch (HEAPU8[$6 >> 0] | 0 | 0) {
                           default:
                            HEAP8[($3 + 408 | 0) >> 0] = 0;
                            break label$37;
                           case 1:
                            HEAP8[($3 + 408 | 0) >> 0] = 1;
                            HEAP8[($3 + 409 | 0) >> 0] = HEAPU8[($6 + 1 | 0) >> 0] | 0;
                            break label$37;
                           case 2:
                            i64toi32_i32$2 = $6;
                            i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
                            i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
                            $324 = i64toi32_i32$1;
                            i64toi32_i32$1 = $11;
                            HEAP32[i64toi32_i32$1 >> 2] = $324;
                            HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                            i64toi32_i32$2 = i64toi32_i32$2 + 16 | 0;
                            i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                            i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                            $329 = i64toi32_i32$0;
                            i64toi32_i32$0 = $11 + 8 | 0;
                            HEAP32[i64toi32_i32$0 >> 2] = $329;
                            HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
                            HEAP8[($3 + 408 | 0) >> 0] = 2;
                            break label$37;
                           case 3:
                            $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($12 | 0, $6 + 4 | 0 | 0);
                            HEAP8[($3 + 408 | 0) >> 0] = 3;
                            break label$37;
                           case 4:
                            $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__ha732c788391a1960($12 | 0, $6 + 4 | 0 | 0);
                            HEAP8[($3 + 408 | 0) >> 0] = 4;
                            break label$37;
                           case 5:
                            break label$38;
                           };
                          }
                          $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__hf249498970160004($12 | 0, $6 + 4 | 0 | 0);
                          HEAP8[($3 + 408 | 0) >> 0] = 5;
                         }
                         cardano_serialization_lib__metadata__encode_json_value_to_metadatum__h64667ed57b92baeb($3 + 456 | 0 | 0, $3 + 408 | 0 | 0, $2 | 0);
                         if ((HEAP32[($3 + 456 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                          break label$16
                         }
                         memcpy($3 + 312 | 0 | 0, $8 | 0, 48 | 0) | 0;
                         label$44 : {
                          label$45 : {
                           switch (HEAPU8[$5 >> 0] | 0 | 0) {
                           default:
                            HEAP8[($3 + 104 | 0) >> 0] = 0;
                            break label$44;
                           case 1:
                            HEAP8[($3 + 104 | 0) >> 0] = 1;
                            HEAP8[($3 + 105 | 0) >> 0] = HEAPU8[($5 + 1 | 0) >> 0] | 0;
                            break label$44;
                           case 2:
                            i64toi32_i32$2 = $5;
                            i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
                            i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
                            $364 = i64toi32_i32$1;
                            i64toi32_i32$1 = $9;
                            HEAP32[i64toi32_i32$1 >> 2] = $364;
                            HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                            i64toi32_i32$2 = i64toi32_i32$2 + 16 | 0;
                            i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                            i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                            $369 = i64toi32_i32$0;
                            i64toi32_i32$0 = $9 + 8 | 0;
                            HEAP32[i64toi32_i32$0 >> 2] = $369;
                            HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
                            HEAP8[($3 + 104 | 0) >> 0] = 2;
                            break label$44;
                           case 3:
                            $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($10 | 0, $5 + 4 | 0 | 0);
                            HEAP8[($3 + 104 | 0) >> 0] = 3;
                            break label$44;
                           case 4:
                            $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__ha732c788391a1960($10 | 0, $5 + 4 | 0 | 0);
                            HEAP8[($3 + 104 | 0) >> 0] = 4;
                            break label$44;
                           case 5:
                            break label$45;
                           };
                          }
                          $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__hf249498970160004($10 | 0, $5 + 4 | 0 | 0);
                          HEAP8[($3 + 104 | 0) >> 0] = 5;
                         }
                         cardano_serialization_lib__metadata__encode_json_value_to_metadatum__h64667ed57b92baeb($3 + 456 | 0 | 0, $3 + 104 | 0 | 0, $2 | 0);
                         label$51 : {
                          if ((HEAP32[($3 + 456 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                           break label$51
                          }
                          $4 = $4 + 24 | 0;
                          memcpy($3 + 408 | 0 | 0, $8 | 0, 48 | 0) | 0;
                          cardano_serialization_lib__metadata__MetadataMap__insert__hd93cf89dc2674a42($3 + 360 | 0 | 0, $3 + 272 | 0 | 0, $3 + 312 | 0 | 0, $3 + 408 | 0 | 0);
                          label$52 : {
                           if ((HEAP32[($3 + 360 | 0) >> 2] | 0 | 0) == (5 | 0)) {
                            break label$52
                           }
                           core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatum___headd2d1b596252cc($3 + 360 | 0 | 0);
                          }
                          core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatum___headd2d1b596252cc($3 + 408 | 0 | 0);
                          core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatum___headd2d1b596252cc($3 + 312 | 0 | 0);
                          if (($7 | 0) != ($4 | 0)) {
                           continue label$36
                          }
                          break label$9;
                         }
                         break label$36;
                        };
                        $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($3 + 460 | 0) >> 2] | 0 | 0) | 0;
                        HEAP32[$0 >> 2] = 1;
                        HEAP32[($0 + 4 | 0) >> 2] = $1;
                        core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatum___headd2d1b596252cc($3 + 312 | 0 | 0);
                        break label$7;
                       }
                       $4 = 1;
                       $2 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1059521 | 0, 28 | 0) | 0;
                       HEAP32[$0 >> 2] = 1;
                       HEAP32[($0 + 4 | 0) >> 2] = $2;
                       break label$3;
                      }
                      $4 = 1;
                      $2 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1059492 | 0, 29 | 0) | 0;
                      HEAP32[$0 >> 2] = 1;
                      HEAP32[($0 + 4 | 0) >> 2] = $2;
                      break label$3;
                     }
                     i64toi32_i32$2 = $1 + 16 | 0;
                     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                     $438 = i64toi32_i32$1;
                     i64toi32_i32$1 = ($3 + 456 | 0) + 8 | 0;
                     HEAP32[i64toi32_i32$1 >> 2] = $438;
                     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                     i64toi32_i32$2 = $1 + 8 | 0;
                     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                     $442 = i64toi32_i32$0;
                     i64toi32_i32$0 = $3;
                     HEAP32[($3 + 456 | 0) >> 2] = $442;
                     HEAP32[($3 + 460 | 0) >> 2] = i64toi32_i32$1;
                     cardano_serialization_lib__metadata__encode_json_value_to_metadatum__encode_number__h31f9bcd9af2979cd($0 | 0, $3 + 456 | 0 | 0);
                     $4 = 1;
                     break label$3;
                    }
                    HEAP32[($3 + 464 | 0) >> 2] = HEAP32[($1 + 12 | 0) >> 2] | 0;
                    i64toi32_i32$2 = $1 + 4 | 0;
                    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                    $454 = i64toi32_i32$1;
                    i64toi32_i32$1 = $3;
                    HEAP32[($3 + 456 | 0) >> 2] = $454;
                    HEAP32[($3 + 460 | 0) >> 2] = i64toi32_i32$0;
                    cardano_serialization_lib__metadata__encode_json_value_to_metadatum__encode_string__had75d0cd3a140bd6($0 | 0, $3 + 456 | 0 | 0, $2 | 0);
                    $0 = 0;
                    $4 = 1;
                    $2 = 1;
                    break label$2;
                   }
                   HEAP32[($3 + 464 | 0) >> 2] = HEAP32[($1 + 12 | 0) >> 2] | 0;
                   i64toi32_i32$2 = $1 + 4 | 0;
                   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                   $467 = i64toi32_i32$0;
                   i64toi32_i32$0 = $3;
                   HEAP32[($3 + 456 | 0) >> 2] = $467;
                   HEAP32[($3 + 460 | 0) >> 2] = i64toi32_i32$1;
                   cardano_serialization_lib__metadata__encode_json_value_to_metadatum__encode_array__hdc5d0ec20300a896($0 | 0, $3 + 456 | 0 | 0, $2 | 0);
                   $0 = 1;
                   $4 = 0;
                   $2 = 1;
                   break label$2;
                  }
                  $4 = ($3 + 88 | 0) + 8 | 0;
                  HEAP32[$4 >> 2] = HEAP32[($1 + 12 | 0) >> 2] | 0;
                  i64toi32_i32$2 = $1 + 4 | 0;
                  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                  $482 = i64toi32_i32$1;
                  i64toi32_i32$1 = $3;
                  HEAP32[($3 + 88 | 0) >> 2] = $482;
                  HEAP32[($3 + 92 | 0) >> 2] = i64toi32_i32$0;
                  std__thread__local__LocalKey_T___with__h4cd07b14a44a727e($3 + 8 | 0 | 0, 1060968 | 0);
                  i64toi32_i32$2 = $3;
                  i64toi32_i32$0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
                  i64toi32_i32$1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
                  $13 = i64toi32_i32$0;
                  $13$hi = i64toi32_i32$1;
                  i64toi32_i32$2 = $3;
                  i64toi32_i32$1 = HEAP32[($3 + 16 | 0) >> 2] | 0;
                  i64toi32_i32$0 = HEAP32[($3 + 20 | 0) >> 2] | 0;
                  $14 = i64toi32_i32$1;
                  $14$hi = i64toi32_i32$0;
                  $5 = hashbrown__raw__generic__Group__static_empty__hc5a7932fe1bdb1f1() | 0;
                  i64toi32_i32$1 = ($3 + 104 | 0) + 24 | 0;
                  i64toi32_i32$0 = 0;
                  HEAP32[i64toi32_i32$1 >> 2] = 0;
                  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                  HEAP32[($3 + 124 | 0) >> 2] = $5;
                  HEAP32[($3 + 120 | 0) >> 2] = 0;
                  i64toi32_i32$1 = $3;
                  i64toi32_i32$0 = 0;
                  HEAP32[($3 + 136 | 0) >> 2] = 0;
                  HEAP32[($3 + 140 | 0) >> 2] = i64toi32_i32$0;
                  i64toi32_i32$0 = $14$hi;
                  i64toi32_i32$1 = $3;
                  HEAP32[($3 + 112 | 0) >> 2] = $14;
                  HEAP32[($3 + 116 | 0) >> 2] = i64toi32_i32$0;
                  i64toi32_i32$0 = $13$hi;
                  i64toi32_i32$1 = $3;
                  HEAP32[($3 + 104 | 0) >> 2] = $13;
                  HEAP32[($3 + 108 | 0) >> 2] = i64toi32_i32$0;
                  $7 = ($3 + 456 | 0) + 8 | 0;
                  HEAP32[$7 >> 2] = HEAP32[$4 >> 2] | 0;
                  i64toi32_i32$2 = $3;
                  i64toi32_i32$0 = HEAP32[($3 + 88 | 0) >> 2] | 0;
                  i64toi32_i32$1 = HEAP32[($3 + 92 | 0) >> 2] | 0;
                  $510 = i64toi32_i32$0;
                  i64toi32_i32$0 = $3;
                  HEAP32[($3 + 456 | 0) >> 2] = $510;
                  HEAP32[($3 + 460 | 0) >> 2] = i64toi32_i32$1;
                  $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__iter__traits__collect__IntoIterator___into_iter__h78aadcd9a0523691($3 + 144 | 0 | 0, $3 + 456 | 0 | 0);
                  HEAP32[(($3 + 176 | 0) + 24 | 0) >> 2] = HEAP32[(($3 + 144 | 0) + 24 | 0) >> 2] | 0;
                  i64toi32_i32$2 = ($3 + 144 | 0) + 16 | 0;
                  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                  $528 = i64toi32_i32$1;
                  i64toi32_i32$1 = ($3 + 176 | 0) + 16 | 0;
                  HEAP32[i64toi32_i32$1 >> 2] = $528;
                  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                  i64toi32_i32$2 = ($3 + 144 | 0) + 8 | 0;
                  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                  $535 = i64toi32_i32$0;
                  i64toi32_i32$0 = ($3 + 176 | 0) + 8 | 0;
                  HEAP32[i64toi32_i32$0 >> 2] = $535;
                  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
                  i64toi32_i32$2 = $3;
                  i64toi32_i32$1 = HEAP32[($3 + 144 | 0) >> 2] | 0;
                  i64toi32_i32$0 = HEAP32[($3 + 148 | 0) >> 2] | 0;
                  $538 = i64toi32_i32$1;
                  i64toi32_i32$1 = $3;
                  HEAP32[($3 + 176 | 0) >> 2] = $538;
                  HEAP32[($3 + 180 | 0) >> 2] = i64toi32_i32$0;
                  $alloc__collections__btree__map__IntoIter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h7fa673cac2ce5cb9($3 + 456 | 0 | 0, $3 + 176 | 0 | 0);
                  if ((HEAPU8[($3 + 472 | 0) >> 0] | 0 | 0) == (6 | 0)) {
                   break label$10
                  }
                  $4 = ($3 + 272 | 0) + 16 | 0;
                  $10 = ($2 & 255 | 0 | 0) == (1 | 0);
                  label$53 : while (1) {
                   memcpy($3 + 272 | 0 | 0, $3 + 456 | 0 | 0, 40 | 0) | 0;
                   $12 = ($3 + 208 | 0) + 8 | 0;
                   $8 = ($3 + 272 | 0) + 8 | 0;
                   HEAP32[$12 >> 2] = HEAP32[$8 >> 2] | 0;
                   i64toi32_i32$2 = $3;
                   i64toi32_i32$0 = HEAP32[($3 + 272 | 0) >> 2] | 0;
                   i64toi32_i32$1 = HEAP32[($3 + 276 | 0) >> 2] | 0;
                   $568 = i64toi32_i32$0;
                   i64toi32_i32$0 = $3;
                   HEAP32[($3 + 208 | 0) >> 2] = $568;
                   HEAP32[($3 + 212 | 0) >> 2] = i64toi32_i32$1;
                   $5 = ($3 + 224 | 0) + 16 | 0;
                   i64toi32_i32$2 = $4 + 16 | 0;
                   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                   $575 = i64toi32_i32$1;
                   i64toi32_i32$1 = $5;
                   HEAP32[i64toi32_i32$1 >> 2] = $575;
                   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                   $6 = ($3 + 224 | 0) + 8 | 0;
                   i64toi32_i32$2 = $4 + 8 | 0;
                   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                   $582 = i64toi32_i32$0;
                   i64toi32_i32$0 = $6;
                   HEAP32[i64toi32_i32$0 >> 2] = $582;
                   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
                   i64toi32_i32$2 = $4;
                   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                   $585 = i64toi32_i32$1;
                   i64toi32_i32$1 = $3;
                   HEAP32[($3 + 224 | 0) >> 2] = $585;
                   HEAP32[($3 + 228 | 0) >> 2] = i64toi32_i32$0;
                   label$54 : {
                    label$55 : {
                     label$56 : {
                      label$57 : {
                       label$58 : {
                        label$59 : {
                         label$60 : {
                          label$61 : {
                           label$62 : {
                            label$63 : {
                             if ($10) {
                              break label$63
                             }
                             HEAP32[(($3 + 408 | 0) + 8 | 0) >> 2] = HEAP32[$8 >> 2] | 0;
                             i64toi32_i32$2 = $3;
                             i64toi32_i32$0 = HEAP32[($3 + 272 | 0) >> 2] | 0;
                             i64toi32_i32$1 = HEAP32[($3 + 276 | 0) >> 2] | 0;
                             $594 = i64toi32_i32$0;
                             i64toi32_i32$0 = $3;
                             HEAP32[($3 + 408 | 0) >> 2] = $594;
                             HEAP32[($3 + 412 | 0) >> 2] = i64toi32_i32$1;
                             cardano_serialization_lib__metadata__TransactionMetadatum__new_text__hc705d7de2d476a57($3 + 456 | 0 | 0, $3 + 408 | 0 | 0);
                             if ((HEAP32[($3 + 456 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                              break label$57
                             }
                             memcpy($3 + 312 | 0 | 0, $7 | 0, 48 | 0) | 0;
                             break label$62;
                            }
                            $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 | 0, $3 + 208 | 0 | 0);
                            core__num___impl_20core__str__traits__FromStr_20for_20i128___from_str__hcd24f923cb24d499($3 + 408 | 0 | 0, HEAP32[$3 >> 2] | 0 | 0, HEAP32[($3 + 4 | 0) >> 2] | 0 | 0);
                            label$64 : {
                             if ((HEAPU8[($3 + 408 | 0) >> 0] | 0 | 0) == (1 | 0)) {
                              break label$64
                             }
                             i64toi32_i32$2 = ($3 + 408 | 0) + 16 | 0;
                             i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                             i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                             $624 = i64toi32_i32$1;
                             i64toi32_i32$1 = ($3 + 312 | 0) + 16 | 0;
                             HEAP32[i64toi32_i32$1 >> 2] = $624;
                             HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                             i64toi32_i32$2 = $3;
                             i64toi32_i32$0 = HEAP32[($3 + 416 | 0) >> 2] | 0;
                             i64toi32_i32$1 = HEAP32[($3 + 420 | 0) >> 2] | 0;
                             $627 = i64toi32_i32$0;
                             i64toi32_i32$0 = $3;
                             HEAP32[($3 + 320 | 0) >> 2] = $627;
                             HEAP32[($3 + 324 | 0) >> 2] = i64toi32_i32$1;
                             HEAP32[($3 + 312 | 0) >> 2] = 2;
                             $8 = 1;
                             break label$61;
                            }
                            HEAP32[(($3 + 360 | 0) + 8 | 0) >> 2] = HEAP32[$12 >> 2] | 0;
                            i64toi32_i32$2 = $3;
                            i64toi32_i32$1 = HEAP32[($3 + 208 | 0) >> 2] | 0;
                            i64toi32_i32$0 = HEAP32[($3 + 212 | 0) >> 2] | 0;
                            $636 = i64toi32_i32$1;
                            i64toi32_i32$1 = $3;
                            HEAP32[($3 + 360 | 0) >> 2] = $636;
                            HEAP32[($3 + 364 | 0) >> 2] = i64toi32_i32$0;
                            cardano_serialization_lib__metadata__encode_json_value_to_metadatum__encode_string__had75d0cd3a140bd6($3 + 456 | 0 | 0, $3 + 360 | 0 | 0, 1 | 0);
                            if ((HEAP32[($3 + 456 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                             break label$60
                            }
                            memcpy($3 + 312 | 0 | 0, $7 | 0, 48 | 0) | 0;
                           }
                           $8 = 0;
                          }
                          i64toi32_i32$2 = $5;
                          i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                          i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                          $652 = i64toi32_i32$0;
                          i64toi32_i32$0 = ($3 + 248 | 0) + 16 | 0;
                          HEAP32[i64toi32_i32$0 >> 2] = $652;
                          HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
                          i64toi32_i32$2 = $6;
                          i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                          i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                          $657 = i64toi32_i32$1;
                          i64toi32_i32$1 = ($3 + 248 | 0) + 8 | 0;
                          HEAP32[i64toi32_i32$1 >> 2] = $657;
                          HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                          i64toi32_i32$2 = $3;
                          i64toi32_i32$0 = HEAP32[($3 + 224 | 0) >> 2] | 0;
                          i64toi32_i32$1 = HEAP32[($3 + 228 | 0) >> 2] | 0;
                          $660 = i64toi32_i32$0;
                          i64toi32_i32$0 = $3;
                          HEAP32[($3 + 248 | 0) >> 2] = $660;
                          HEAP32[($3 + 252 | 0) >> 2] = i64toi32_i32$1;
                          cardano_serialization_lib__metadata__encode_json_value_to_metadatum__h64667ed57b92baeb($3 + 456 | 0 | 0, $3 + 248 | 0 | 0, $2 | 0);
                          if ((HEAP32[($3 + 456 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                           break label$59
                          }
                          memcpy($3 + 408 | 0 | 0, $7 | 0, 48 | 0) | 0;
                          cardano_serialization_lib__metadata__MetadataMap__insert__hd93cf89dc2674a42($3 + 360 | 0 | 0, $3 + 104 | 0 | 0, $3 + 312 | 0 | 0, $3 + 408 | 0 | 0);
                          label$65 : {
                           if ((HEAP32[($3 + 360 | 0) >> 2] | 0 | 0) == (5 | 0)) {
                            break label$65
                           }
                           core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatum___headd2d1b596252cc($3 + 360 | 0 | 0);
                          }
                          core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatum___headd2d1b596252cc($3 + 408 | 0 | 0);
                          core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatum___headd2d1b596252cc($3 + 312 | 0 | 0);
                          if ($8) {
                           break label$58
                          }
                          break label$54;
                         }
                         $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($3 + 460 | 0) >> 2] | 0 | 0) | 0;
                         HEAP32[$0 >> 2] = 1;
                         HEAP32[($0 + 4 | 0) >> 2] = $1;
                         break label$56;
                        }
                        $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($3 + 460 | 0) >> 2] | 0 | 0) | 0;
                        HEAP32[$0 >> 2] = 1;
                        HEAP32[($0 + 4 | 0) >> 2] = $1;
                        core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatum___headd2d1b596252cc($3 + 312 | 0 | 0);
                        if (!$8) {
                         break label$55
                        }
                        $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 208 | 0 | 0);
                        $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 208 | 0 | 0);
                        break label$55;
                       }
                       $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 208 | 0 | 0);
                       $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 208 | 0 | 0);
                       break label$54;
                      }
                      $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($3 + 460 | 0) >> 2] | 0 | 0) | 0;
                      HEAP32[$0 >> 2] = 1;
                      HEAP32[($0 + 4 | 0) >> 2] = $1;
                     }
                     core__ptr__drop_in_place_serde_json__value__Value___h0088decf7dc316c7_1($3 + 224 | 0 | 0);
                    }
                    label$66 : {
                     $1 = HEAP32[($3 + 180 | 0) >> 2] | 0;
                     if (!$1) {
                      break label$66
                     }
                     $0 = HEAP32[($3 + 176 | 0) >> 2] | 0;
                     $2 = HEAP32[($3 + 184 | 0) >> 2] | 0;
                     HEAP32[($3 + 468 | 0) >> 2] = HEAP32[($3 + 200 | 0) >> 2] | 0;
                     HEAP32[($3 + 464 | 0) >> 2] = $2;
                     HEAP32[($3 + 460 | 0) >> 2] = $1;
                     HEAP32[($3 + 456 | 0) >> 2] = $0;
                     $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__hdfdbc3776b972463($3 + 456 | 0 | 0);
                    }
                    $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__hd17c55afb95953fd($3 + 104 | 0 | 0);
                    if (!(HEAP32[($3 + 120 | 0) >> 2] | 0)) {
                     break label$1
                    }
                    hashbrown__raw__RawTable_T_2cA___free_buckets__hf5781ccef5282b02($3 + 120 | 0 | 0);
                    break label$1;
                   }
                   $alloc__collections__btree__map__IntoIter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h7fa673cac2ce5cb9($3 + 456 | 0 | 0, $3 + 176 | 0 | 0);
                   if ((HEAPU8[($3 + 472 | 0) >> 0] | 0 | 0) != (6 | 0)) {
                    continue label$53
                   }
                   break label$10;
                  };
                 }
                 $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($3 + 460 | 0) >> 2] | 0 | 0) | 0;
                 HEAP32[$0 >> 2] = 1;
                 HEAP32[($0 + 4 | 0) >> 2] = $1;
                 break label$7;
                }
                $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1059602 | 0, 100 | 0) | 0 | 0) | 0;
                HEAP32[$0 >> 2] = 1;
                HEAP32[($0 + 4 | 0) >> 2] = $1;
                break label$7;
               }
               $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1059602 | 0, 100 | 0) | 0 | 0) | 0;
               HEAP32[$0 >> 2] = 1;
               HEAP32[($0 + 4 | 0) >> 2] = $1;
               break label$7;
              }
              $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1059602 | 0, 100 | 0) | 0 | 0) | 0;
              HEAP32[$0 >> 2] = 1;
              HEAP32[($0 + 4 | 0) >> 2] = $1;
              break label$7;
             }
             $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1059579 | 0, 23 | 0) | 0 | 0) | 0;
             HEAP32[$0 >> 2] = 1;
             HEAP32[($0 + 4 | 0) >> 2] = $1;
             break label$6;
            }
            core__panicking__panic__h2fd385a887c8bf13(1059116 | 0, 43 | 0, 1059364 | 0);
            abort();
           }
           label$67 : {
            $2 = HEAP32[($3 + 180 | 0) >> 2] | 0;
            if (!$2) {
             break label$67
            }
            $4 = HEAP32[($3 + 176 | 0) >> 2] | 0;
            $5 = HEAP32[($3 + 184 | 0) >> 2] | 0;
            HEAP32[($3 + 468 | 0) >> 2] = HEAP32[($3 + 200 | 0) >> 2] | 0;
            HEAP32[($3 + 464 | 0) >> 2] = $5;
            HEAP32[($3 + 460 | 0) >> 2] = $2;
            HEAP32[($3 + 456 | 0) >> 2] = $4;
            $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__hdfdbc3776b972463($3 + 456 | 0 | 0);
           }
           $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__hdeea20968268d729($3 + 408 | 0 | 0, $3 + 104 | 0 | 0);
           memcpy($3 + 460 | 0 | 0, $3 + 408 | 0 | 0, 40 | 0) | 0;
           memcpy($0 + 12 | 0 | 0, $3 + 456 | 0 | 0, 44 | 0) | 0;
           $2 = 0;
           HEAP32[$0 >> 2] = 0;
           HEAP32[($0 + 8 | 0) >> 2] = 0;
           $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__hd17c55afb95953fd($3 + 104 | 0 | 0);
           if (!(HEAP32[($3 + 120 | 0) >> 2] | 0)) {
            break label$4
           }
           hashbrown__raw__RawTable_T_2cA___free_buckets__hf5781ccef5282b02($3 + 120 | 0 | 0);
           break label$4;
          }
          $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__hdeea20968268d729($3 + 408 | 0 | 0, $3 + 272 | 0 | 0);
          memcpy($3 + 460 | 0 | 0, $3 + 408 | 0 | 0, 40 | 0) | 0;
          memcpy($0 + 12 | 0 | 0, $3 + 456 | 0 | 0, 44 | 0) | 0;
          HEAP32[$0 >> 2] = 0;
          HEAP32[($0 + 8 | 0) >> 2] = 0;
          $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__hd17c55afb95953fd($3 + 272 | 0 | 0);
          if (!(HEAP32[($3 + 288 | 0) >> 2] | 0)) {
           break label$5
          }
          hashbrown__raw__RawTable_T_2cA___free_buckets__hf5781ccef5282b02($3 + 288 | 0 | 0);
          break label$5;
         }
         $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1059579 | 0, 23 | 0) | 0 | 0) | 0;
         HEAP32[$0 >> 2] = 1;
         HEAP32[($0 + 4 | 0) >> 2] = $1;
        }
        $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__hd17c55afb95953fd($3 + 272 | 0 | 0);
        if (!(HEAP32[($3 + 288 | 0) >> 2] | 0)) {
         break label$6
        }
        hashbrown__raw__RawTable_T_2cA___free_buckets__hf5781ccef5282b02($3 + 288 | 0 | 0);
       }
       core__ptr__drop_in_place_serde_json__value__Value___h0088decf7dc316c7_1($3 + 176 | 0 | 0);
       $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 144 | 0 | 0);
       $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 144 | 0 | 0);
       break label$1;
      }
      label$68 : {
       if ((HEAPU8[($3 + 176 | 0) >> 0] | 0 | 0) == (2 | 0)) {
        break label$68
       }
       core__ptr__drop_in_place_serde_json__value__Value___h0088decf7dc316c7_1($3 + 176 | 0 | 0);
      }
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 144 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 144 | 0 | 0);
      $2 = 0;
     }
     $4 = 1;
     $0 = 1;
     break label$2;
    }
    $0 = 1;
    $2 = 1;
   }
   label$69 : {
    switch ((HEAPU8[$1 >> 0] | 0) + -3 | 0 | 0) {
    case 2:
     if (!$2) {
      break label$1
     }
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h0198cfc402357e50($1 + 4 | 0 | 0);
     break label$1;
    case 1:
     if (!$4) {
      break label$1
     }
     $1 = $1 + 4 | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h2d454d4f9b2e44f3($1 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h55384607e9cf45ad($1 | 0);
     break label$1;
    case 0:
     break label$69;
    default:
     break label$1;
    };
   }
   if (!$0) {
    break label$1
   }
   $1 = $1 + 4 | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  }
  global$0 = $3 + 512 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__PoolParams___deserialize_as_embedded_group__he3f2f174b1ace167($0, $1, $2, $2$hi, $3, $3$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $12 = 0, $7 = 0, $9 = 0, $11 = 0, $12$hi = 0, $5 = 0, $8 = 0, $10 = 0, $6 = 0, $13 = 0, $13$hi = 0, $84 = 0, $85 = 0, $86 = 0, $87 = 0, $88 = 0, $89 = 0, $90 = 0, $91 = 0, $93 = 0, $94 = 0, $96 = 0, $97 = 0, $98 = 0, $99 = 0, $100 = 0, $101 = 0, $102 = 0, $103 = 0, $104 = 0, $105 = 0, $106 = 0, $107 = 0, $109 = 0, $110 = 0, $111 = 0, $112 = 0, $114 = 0, $115 = 0, $116 = 0, $14 = 0, $14$hi = 0, $15 = 0, $15$hi = 0, $117 = 0, $119 = 0, $120 = 0, $122 = 0, $123 = 0, $124 = 0, $125 = 0, $50 = 0, $71 = 0, $76 = 0, $79 = 0, $92 = 0, $95 = 0, $108 = 0, $113 = 0, $118 = 0, $121 = 0, $164 = 0, $172 = 0, $178 = 0, $184 = 0, $192 = 0, $198 = 0, $204 = 0, $207 = 0, $213 = 0, $219 = 0, $225 = 0, $228 = 0, $233 = 0, $238 = 0, $243 = 0, $246 = 0, $262 = 0, $276 = 0, $319 = 0, $333 = 0, $361 = 0, $373 = 0, $389 = 0, $405 = 0, $440 = 0, $445 = 0, $462 = 0, $468 = 0, $474 = 0, $478 = 0, $482 = 0, $488 = 0, $494 = 0, $499 = 0, $503 = 0, $525 = 0, $543 = 0, $549 = 0, $553 = 0, $567 = 0, $581 = 0, $619 = 0, $623 = 0, $635 = 0, $651 = 0, $721 = 0, $735 = 0, $755 = 0;
  $4 = global$0 - 576 | 0;
  global$0 = $4;
  $cardano_serialization_lib__crypto__Ed25519KeyHash_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h495effbb534e290f($4 + 504 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           if ((HEAPU8[($4 + 504 | 0) >> 0] | 0 | 0) == (1 | 0)) {
            break label$9
           }
           $5 = ($4 + 288 | 0) + 9 | 0;
           $6 = ($4 + 504 | 0) + 9 | 0;
           i64toi32_i32$2 = $6;
           i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $12 = i64toi32_i32$0;
           $12$hi = i64toi32_i32$1;
           i64toi32_i32$0 = $5;
           HEAP8[i64toi32_i32$0 >> 0] = $12;
           HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $12 >>> 8 | 0;
           HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $12 >>> 16 | 0;
           HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $12 >>> 24 | 0;
           HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
           HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
           HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
           HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
           $7 = ($4 + 112 | 0) + 24 | 0;
           $8 = $4 + 529 | 0;
           HEAP32[$7 >> 2] = HEAPU8[$8 >> 0] | 0 | ((HEAPU8[($8 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($8 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($8 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $9 = ($4 + 112 | 0) + 16 | 0;
           $10 = $4 + 521 | 0;
           i64toi32_i32$2 = $10;
           i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $50 = i64toi32_i32$1;
           i64toi32_i32$1 = $9;
           HEAP32[i64toi32_i32$1 >> 2] = $50;
           HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
           $11 = ($4 + 112 | 0) + 8 | 0;
           i64toi32_i32$0 = $12$hi;
           i64toi32_i32$1 = $11;
           HEAP32[i64toi32_i32$1 >> 2] = $12;
           HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
           i64toi32_i32$2 = $4;
           i64toi32_i32$0 = HEAPU8[($4 + 505 | 0) >> 0] | 0 | ((HEAPU8[($4 + 506 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 507 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 508 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$1 = HEAPU8[($4 + 509 | 0) >> 0] | 0 | ((HEAPU8[($4 + 510 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 511 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 512 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $12 = i64toi32_i32$0;
           $12$hi = i64toi32_i32$1;
           i64toi32_i32$0 = $4;
           HEAP8[($4 + 289 | 0) >> 0] = $12;
           HEAP8[($4 + 290 | 0) >> 0] = $12 >>> 8 | 0;
           HEAP8[($4 + 291 | 0) >> 0] = $12 >>> 16 | 0;
           HEAP8[($4 + 292 | 0) >> 0] = $12 >>> 24 | 0;
           HEAP8[($4 + 293 | 0) >> 0] = i64toi32_i32$1;
           HEAP8[($4 + 294 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
           HEAP8[($4 + 295 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
           HEAP8[($4 + 296 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
           i64toi32_i32$0 = $4;
           HEAP32[($4 + 112 | 0) >> 2] = $12;
           HEAP32[($4 + 116 | 0) >> 2] = i64toi32_i32$1;
           HEAP32[(($4 + 16 | 0) + 24 | 0) >> 2] = HEAP32[$7 >> 2] | 0;
           i64toi32_i32$2 = $9;
           i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
           $71 = i64toi32_i32$1;
           i64toi32_i32$1 = ($4 + 16 | 0) + 16 | 0;
           HEAP32[i64toi32_i32$1 >> 2] = $71;
           HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
           i64toi32_i32$2 = $11;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
           $76 = i64toi32_i32$0;
           i64toi32_i32$0 = ($4 + 16 | 0) + 8 | 0;
           HEAP32[i64toi32_i32$0 >> 2] = $76;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
           i64toi32_i32$2 = $4;
           i64toi32_i32$1 = HEAP32[($4 + 112 | 0) >> 2] | 0;
           i64toi32_i32$0 = HEAP32[($4 + 116 | 0) >> 2] | 0;
           $79 = i64toi32_i32$1;
           i64toi32_i32$1 = $4;
           HEAP32[($4 + 16 | 0) >> 2] = $79;
           HEAP32[($4 + 20 | 0) >> 2] = i64toi32_i32$0;
           $cardano_serialization_lib__crypto__VRFKeyHash_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h95fa546888d9bbe4($4 + 504 | 0 | 0, $1 | 0);
           if ((HEAPU8[($4 + 504 | 0) >> 0] | 0 | 0) == (1 | 0)) {
            break label$8
           }
           i64toi32_i32$2 = $6;
           i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $12 = i64toi32_i32$0;
           $12$hi = i64toi32_i32$1;
           i64toi32_i32$0 = $5;
           HEAP8[i64toi32_i32$0 >> 0] = $12;
           HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $12 >>> 8 | 0;
           HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $12 >>> 16 | 0;
           HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $12 >>> 24 | 0;
           HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
           HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
           HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
           HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
           i64toi32_i32$2 = $8;
           i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $92 = i64toi32_i32$1;
           i64toi32_i32$1 = $7;
           HEAP32[i64toi32_i32$1 >> 2] = $92;
           HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
           i64toi32_i32$2 = $10;
           i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $95 = i64toi32_i32$0;
           i64toi32_i32$0 = $9;
           HEAP32[i64toi32_i32$0 >> 2] = $95;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
           i64toi32_i32$1 = $12$hi;
           i64toi32_i32$0 = $11;
           HEAP32[i64toi32_i32$0 >> 2] = $12;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
           i64toi32_i32$2 = $4;
           i64toi32_i32$1 = HEAPU8[($4 + 505 | 0) >> 0] | 0 | ((HEAPU8[($4 + 506 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 507 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 508 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$0 = HEAPU8[($4 + 509 | 0) >> 0] | 0 | ((HEAPU8[($4 + 510 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 511 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 512 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $12 = i64toi32_i32$1;
           $12$hi = i64toi32_i32$0;
           i64toi32_i32$1 = $4;
           HEAP8[($4 + 289 | 0) >> 0] = $12;
           HEAP8[($4 + 290 | 0) >> 0] = $12 >>> 8 | 0;
           HEAP8[($4 + 291 | 0) >> 0] = $12 >>> 16 | 0;
           HEAP8[($4 + 292 | 0) >> 0] = $12 >>> 24 | 0;
           HEAP8[($4 + 293 | 0) >> 0] = i64toi32_i32$0;
           HEAP8[($4 + 294 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
           HEAP8[($4 + 295 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
           HEAP8[($4 + 296 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
           i64toi32_i32$1 = $4;
           HEAP32[($4 + 112 | 0) >> 2] = $12;
           HEAP32[($4 + 116 | 0) >> 2] = i64toi32_i32$0;
           i64toi32_i32$2 = $7;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
           $108 = i64toi32_i32$0;
           i64toi32_i32$0 = ($4 + 48 | 0) + 24 | 0;
           HEAP32[i64toi32_i32$0 >> 2] = $108;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
           i64toi32_i32$2 = $9;
           i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
           $113 = i64toi32_i32$1;
           i64toi32_i32$1 = ($4 + 48 | 0) + 16 | 0;
           HEAP32[i64toi32_i32$1 >> 2] = $113;
           HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
           i64toi32_i32$2 = $11;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
           $118 = i64toi32_i32$0;
           i64toi32_i32$0 = ($4 + 48 | 0) + 8 | 0;
           HEAP32[i64toi32_i32$0 >> 2] = $118;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
           i64toi32_i32$2 = $4;
           i64toi32_i32$1 = HEAP32[($4 + 112 | 0) >> 2] | 0;
           i64toi32_i32$0 = HEAP32[($4 + 116 | 0) >> 2] | 0;
           $121 = i64toi32_i32$1;
           i64toi32_i32$1 = $4;
           HEAP32[($4 + 48 | 0) >> 2] = $121;
           HEAP32[($4 + 52 | 0) >> 2] = i64toi32_i32$0;
           $cardano_serialization_lib__utils__BigNum_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h29637bb571dceb02($4 + 504 | 0 | 0, $1 | 0);
           i64toi32_i32$2 = $4;
           i64toi32_i32$0 = HEAP32[($4 + 512 | 0) >> 2] | 0;
           i64toi32_i32$1 = HEAP32[($4 + 516 | 0) >> 2] | 0;
           $12 = i64toi32_i32$0;
           $12$hi = i64toi32_i32$1;
           i64toi32_i32$2 = $4;
           i64toi32_i32$1 = HEAP32[($4 + 504 | 0) >> 2] | 0;
           i64toi32_i32$0 = HEAP32[($4 + 508 | 0) >> 2] | 0;
           i64toi32_i32$2 = i64toi32_i32$1;
           i64toi32_i32$1 = 0;
           i64toi32_i32$3 = 1;
           if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
            break label$7
           }
           $cardano_serialization_lib__utils__BigNum_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h29637bb571dceb02($4 + 504 | 0 | 0, $1 | 0);
           i64toi32_i32$3 = $4;
           i64toi32_i32$2 = HEAP32[($4 + 512 | 0) >> 2] | 0;
           i64toi32_i32$0 = HEAP32[($4 + 516 | 0) >> 2] | 0;
           $13 = i64toi32_i32$2;
           $13$hi = i64toi32_i32$0;
           i64toi32_i32$3 = $4;
           i64toi32_i32$0 = HEAP32[($4 + 504 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($4 + 508 | 0) >> 2] | 0;
           i64toi32_i32$3 = i64toi32_i32$0;
           i64toi32_i32$0 = 0;
           i64toi32_i32$1 = 1;
           if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) | 0) {
            break label$6
           }
           cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__UnitInterval___deserialize__h50a71b45bc03a6b4($4 + 504 | 0 | 0, $1 | 0);
           $7 = ($4 + 504 | 0) + 16 | 0;
           i64toi32_i32$1 = $7;
           i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $14 = i64toi32_i32$3;
           $14$hi = i64toi32_i32$2;
           i64toi32_i32$1 = $4;
           i64toi32_i32$2 = HEAP32[($4 + 512 | 0) >> 2] | 0;
           i64toi32_i32$3 = HEAP32[($4 + 516 | 0) >> 2] | 0;
           $15 = i64toi32_i32$2;
           $15$hi = i64toi32_i32$3;
           i64toi32_i32$1 = $4;
           i64toi32_i32$3 = HEAP32[($4 + 504 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($4 + 508 | 0) >> 2] | 0;
           i64toi32_i32$1 = i64toi32_i32$3;
           i64toi32_i32$3 = 0;
           i64toi32_i32$0 = 1;
           if ((i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) | 0) {
            break label$5
           }
           $cardano_serialization_lib__address__RewardAddress_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h7ae223ac4e980662($4 + 504 | 0 | 0, $1 | 0);
           if ((HEAPU8[($4 + 504 | 0) >> 0] | 0 | 0) == (1 | 0)) {
            break label$4
           }
           $7 = ($4 + 408 | 0) + 22 | 0;
           i64toi32_i32$0 = ($4 + 504 | 0) + 23 | 0;
           i64toi32_i32$1 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $164 = i64toi32_i32$1;
           i64toi32_i32$1 = $7;
           $117 = $164;
           HEAP16[i64toi32_i32$1 >> 1] = $117;
           HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $117 >>> 16 | 0;
           HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = i64toi32_i32$2;
           HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$2 >>> 16 | 0;
           $9 = ($4 + 408 | 0) + 16 | 0;
           i64toi32_i32$0 = ($4 + 504 | 0) + 17 | 0;
           i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $172 = i64toi32_i32$2;
           i64toi32_i32$2 = $9;
           HEAP32[i64toi32_i32$2 >> 2] = $172;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
           $11 = ($4 + 184 | 0) + 16 | 0;
           i64toi32_i32$0 = i64toi32_i32$2;
           i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $178 = i64toi32_i32$1;
           i64toi32_i32$1 = $11;
           HEAP32[i64toi32_i32$1 >> 2] = $178;
           HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
           $9 = ($4 + 184 | 0) + 22 | 0;
           i64toi32_i32$0 = $7;
           i64toi32_i32$2 = HEAPU16[i64toi32_i32$0 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$0 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
           i64toi32_i32$1 = HEAPU16[(i64toi32_i32$0 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$0 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
           $184 = i64toi32_i32$2;
           i64toi32_i32$2 = $9;
           $119 = $184;
           HEAP16[i64toi32_i32$2 >> 1] = $119;
           HEAP16[(i64toi32_i32$2 + 2 | 0) >> 1] = $119 >>> 16 | 0;
           HEAP16[(i64toi32_i32$2 + 4 | 0) >> 1] = i64toi32_i32$1;
           HEAP16[(i64toi32_i32$2 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
           $7 = ($4 + 288 | 0) + 9 | 0;
           i64toi32_i32$0 = ($4 + 504 | 0) + 9 | 0;
           i64toi32_i32$1 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $192 = i64toi32_i32$1;
           i64toi32_i32$1 = $7;
           $84 = $192;
           HEAP8[i64toi32_i32$1 >> 0] = $84;
           HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $84 >>> 8 | 0;
           HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $84 >>> 16 | 0;
           HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $84 >>> 24 | 0;
           HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$2;
           HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
           HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
           HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
           $5 = ($4 + 288 | 0) + 17 | 0;
           i64toi32_i32$0 = $11;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $198 = i64toi32_i32$2;
           i64toi32_i32$2 = $5;
           $85 = $198;
           HEAP8[i64toi32_i32$2 >> 0] = $85;
           HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $85 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $85 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $85 >>> 24 | 0;
           HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$1;
           HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
           $11 = ($4 + 288 | 0) + 23 | 0;
           i64toi32_i32$0 = $9;
           i64toi32_i32$1 = HEAPU16[i64toi32_i32$0 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$0 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
           i64toi32_i32$2 = HEAPU16[(i64toi32_i32$0 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$0 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
           $204 = i64toi32_i32$1;
           i64toi32_i32$1 = $11;
           $86 = $204;
           HEAP8[i64toi32_i32$1 >> 0] = $86;
           HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $86 >>> 8 | 0;
           HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $86 >>> 16 | 0;
           HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $86 >>> 24 | 0;
           HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$2;
           HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
           HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
           HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
           i64toi32_i32$0 = $4;
           i64toi32_i32$2 = HEAPU8[($4 + 505 | 0) >> 0] | 0 | ((HEAPU8[($4 + 506 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 507 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 508 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$1 = HEAPU8[($4 + 509 | 0) >> 0] | 0 | ((HEAPU8[($4 + 510 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 511 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 512 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $207 = i64toi32_i32$2;
           i64toi32_i32$2 = $4;
           $87 = $207;
           HEAP8[($4 + 289 | 0) >> 0] = $87;
           HEAP8[($4 + 290 | 0) >> 0] = $87 >>> 8 | 0;
           HEAP8[($4 + 291 | 0) >> 0] = $87 >>> 16 | 0;
           HEAP8[($4 + 292 | 0) >> 0] = $87 >>> 24 | 0;
           HEAP8[($4 + 293 | 0) >> 0] = i64toi32_i32$1;
           HEAP8[($4 + 294 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
           HEAP8[($4 + 295 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
           HEAP8[($4 + 296 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
           $9 = ($4 + 112 | 0) + 22 | 0;
           i64toi32_i32$0 = $11;
           i64toi32_i32$1 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $213 = i64toi32_i32$1;
           i64toi32_i32$1 = $9;
           $120 = $213;
           HEAP16[i64toi32_i32$1 >> 1] = $120;
           HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $120 >>> 16 | 0;
           HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = i64toi32_i32$2;
           HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$2 >>> 16 | 0;
           $11 = ($4 + 112 | 0) + 16 | 0;
           i64toi32_i32$0 = $5;
           i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $219 = i64toi32_i32$2;
           i64toi32_i32$2 = $11;
           HEAP32[i64toi32_i32$2 >> 2] = $219;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
           $5 = ($4 + 112 | 0) + 8 | 0;
           i64toi32_i32$0 = $7;
           i64toi32_i32$1 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $225 = i64toi32_i32$1;
           i64toi32_i32$1 = $5;
           HEAP32[i64toi32_i32$1 >> 2] = $225;
           HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
           i64toi32_i32$0 = $4;
           i64toi32_i32$2 = HEAPU8[($4 + 289 | 0) >> 0] | 0 | ((HEAPU8[($4 + 290 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 291 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 292 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$1 = HEAPU8[($4 + 293 | 0) >> 0] | 0 | ((HEAPU8[($4 + 294 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 295 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 296 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $228 = i64toi32_i32$2;
           i64toi32_i32$2 = $4;
           HEAP32[($4 + 112 | 0) >> 2] = $228;
           HEAP32[($4 + 116 | 0) >> 2] = i64toi32_i32$1;
           i64toi32_i32$0 = $9;
           i64toi32_i32$1 = HEAPU16[i64toi32_i32$0 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$0 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
           i64toi32_i32$2 = HEAPU16[(i64toi32_i32$0 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$0 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
           $233 = i64toi32_i32$1;
           i64toi32_i32$1 = ($4 + 80 | 0) + 22 | 0;
           $122 = $233;
           HEAP16[i64toi32_i32$1 >> 1] = $122;
           HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $122 >>> 16 | 0;
           HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = i64toi32_i32$2;
           HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$2 >>> 16 | 0;
           i64toi32_i32$0 = $11;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $238 = i64toi32_i32$2;
           i64toi32_i32$2 = ($4 + 80 | 0) + 16 | 0;
           HEAP32[i64toi32_i32$2 >> 2] = $238;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
           i64toi32_i32$0 = $5;
           i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $243 = i64toi32_i32$1;
           i64toi32_i32$1 = ($4 + 80 | 0) + 8 | 0;
           HEAP32[i64toi32_i32$1 >> 2] = $243;
           HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
           i64toi32_i32$0 = $4;
           i64toi32_i32$2 = HEAP32[($4 + 112 | 0) >> 2] | 0;
           i64toi32_i32$1 = HEAP32[($4 + 116 | 0) >> 2] | 0;
           $246 = i64toi32_i32$2;
           i64toi32_i32$2 = $4;
           HEAP32[($4 + 80 | 0) >> 2] = $246;
           HEAP32[($4 + 84 | 0) >> 2] = i64toi32_i32$1;
           cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__Ed25519KeyHashes___deserialize__hae609f6be80519f0($4 + 504 | 0 | 0, $1 | 0);
           if ((HEAP32[($4 + 504 | 0) >> 2] | 0 | 0) == (1 | 0)) {
            break label$3
           }
           $7 = $4 + 516 | 0;
           HEAP32[(($4 + 256 | 0) + 8 | 0) >> 2] = HEAP32[$7 >> 2] | 0;
           i64toi32_i32$0 = $4;
           i64toi32_i32$1 = HEAP32[($4 + 508 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($4 + 512 | 0) >> 2] | 0;
           $262 = i64toi32_i32$1;
           i64toi32_i32$1 = $4;
           HEAP32[($4 + 256 | 0) >> 2] = $262;
           HEAP32[($4 + 260 | 0) >> 2] = i64toi32_i32$2;
           cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__Relays___deserialize__h9918765c1fb6ecbf($4 + 504 | 0 | 0, $1 | 0);
           label$10 : {
            label$11 : {
             label$12 : {
              if ((HEAP32[($4 + 504 | 0) >> 2] | 0 | 0) == (1 | 0)) {
               break label$12
              }
              $9 = 8;
              HEAP32[(($4 + 272 | 0) + 8 | 0) >> 2] = HEAP32[$7 >> 2] | 0;
              i64toi32_i32$0 = $4;
              i64toi32_i32$2 = HEAP32[($4 + 508 | 0) >> 2] | 0;
              i64toi32_i32$1 = HEAP32[($4 + 512 | 0) >> 2] | 0;
              $276 = i64toi32_i32$2;
              i64toi32_i32$2 = $4;
              HEAP32[($4 + 272 | 0) >> 2] = $276;
              HEAP32[($4 + 276 | 0) >> 2] = i64toi32_i32$1;
              std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($4 + 8 | 0 | 0, $1 | 0);
              if (!(HEAP32[($4 + 12 | 0) >> 2] | 0)) {
               break label$11
              }
              label$13 : {
               label$14 : {
                label$15 : {
                 label$16 : {
                  label$17 : {
                   if ((($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[($4 + 8 | 0) >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) != (7 | 0)) {
                    break label$17
                   }
                   cbor_event__de__Deserializer_R___special__h10e912d855f56298($4 + 504 | 0 | 0, $1 | 0);
                   $9 = HEAPU8[($4 + 512 | 0) >> 0] | 0;
                   i64toi32_i32$0 = $4;
                   i64toi32_i32$1 = HEAP32[($4 + 504 | 0) >> 2] | 0;
                   i64toi32_i32$2 = HEAP32[($4 + 508 | 0) >> 2] | 0;
                   i64toi32_i32$0 = i64toi32_i32$1;
                   i64toi32_i32$1 = 0;
                   i64toi32_i32$3 = 1;
                   if ((i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$1 | 0) | 0) {
                    break label$13
                   }
                   $1 = 0;
                   if (($9 & 255 | 0 | 0) != (1 | 0)) {
                    break label$14
                   }
                   break label$16;
                  }
                  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__PoolMetadata___deserialize__hc2aeb10cf56b6b31($4 + 504 | 0 | 0, $1 | 0);
                  if ((HEAP32[($4 + 504 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                   break label$15
                  }
                  $8 = ($4 + 492 | 0) + 2 | 0;
                  HEAP8[$8 >> 0] = HEAPU8[($4 + 523 | 0) >> 0] | 0;
                  $10 = ($4 + 184 | 0) + 8 | 0;
                  i64toi32_i32$3 = $4 + 544 | 0;
                  i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                  $319 = i64toi32_i32$0;
                  i64toi32_i32$0 = $10;
                  HEAP32[i64toi32_i32$0 >> 2] = $319;
                  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
                  HEAP32[($4 + 496 | 0) >> 2] = HEAPU8[($4 + 513 | 0) >> 0] | 0 | ((HEAPU8[($4 + 514 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 515 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 516 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                  HEAP16[($4 + 492 | 0) >> 1] = HEAPU8[($4 + 521 | 0) >> 0] | 0 | ((HEAPU8[($4 + 522 | 0) >> 0] | 0) << 8 | 0) | 0;
                  $88 = $4 + 516 | 0;
                  $89 = HEAPU8[$88 >> 0] | 0 | ((HEAPU8[($88 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($88 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($88 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                  HEAP8[($4 + 499 | 0) >> 0] = $89;
                  HEAP8[($4 + 500 | 0) >> 0] = $89 >>> 8 | 0;
                  HEAP8[($4 + 501 | 0) >> 0] = $89 >>> 16 | 0;
                  HEAP8[($4 + 502 | 0) >> 0] = $89 >>> 24 | 0;
                  i64toi32_i32$3 = $4 + 536 | 0;
                  i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                  i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                  $333 = i64toi32_i32$2;
                  i64toi32_i32$2 = $4;
                  HEAP32[($4 + 184 | 0) >> 2] = $333;
                  HEAP32[($4 + 188 | 0) >> 2] = i64toi32_i32$0;
                  $5 = HEAPU8[(($4 + 504 | 0) + 8 | 0) >> 0] | 0;
                  $6 = HEAPU8[($4 + 520 | 0) >> 0] | 0;
                  $7 = HEAP32[($4 + 524 | 0) >> 2] | 0;
                  $9 = HEAP32[($4 + 528 | 0) >> 2] | 0;
                  $11 = HEAP32[($4 + 532 | 0) >> 2] | 0;
                  $1 = HEAP32[($4 + 508 | 0) >> 2] | 0;
                  HEAP8[(($4 + 480 | 0) + 2 | 0) >> 0] = HEAPU8[$8 >> 0] | 0;
                  i64toi32_i32$3 = $10;
                  i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                  $361 = i64toi32_i32$0;
                  i64toi32_i32$0 = ($4 + 112 | 0) + 8 | 0;
                  HEAP32[i64toi32_i32$0 >> 2] = $361;
                  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
                  $90 = HEAPU8[($4 + 499 | 0) >> 0] | 0 | ((HEAPU8[($4 + 500 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 501 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 502 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                  HEAP8[($4 + 487 | 0) >> 0] = $90;
                  HEAP8[($4 + 488 | 0) >> 0] = $90 >>> 8 | 0;
                  HEAP8[($4 + 489 | 0) >> 0] = $90 >>> 16 | 0;
                  HEAP8[($4 + 490 | 0) >> 0] = $90 >>> 24 | 0;
                  HEAP32[($4 + 484 | 0) >> 2] = HEAP32[($4 + 496 | 0) >> 2] | 0;
                  HEAP16[($4 + 480 | 0) >> 1] = HEAPU16[($4 + 492 | 0) >> 1] | 0;
                  i64toi32_i32$3 = $4;
                  i64toi32_i32$2 = HEAP32[($4 + 184 | 0) >> 2] | 0;
                  i64toi32_i32$0 = HEAP32[($4 + 188 | 0) >> 2] | 0;
                  $373 = i64toi32_i32$2;
                  i64toi32_i32$2 = $4;
                  HEAP32[($4 + 112 | 0) >> 2] = $373;
                  HEAP32[($4 + 116 | 0) >> 2] = i64toi32_i32$0;
                 }
                 $8 = ($4 + 396 | 0) + 2 | 0;
                 HEAP8[$8 >> 0] = HEAPU8[(($4 + 480 | 0) + 2 | 0) >> 0] | 0;
                 $10 = ($4 + 376 | 0) + 8 | 0;
                 i64toi32_i32$3 = ($4 + 112 | 0) + 8 | 0;
                 i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                 i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                 $389 = i64toi32_i32$0;
                 i64toi32_i32$0 = $10;
                 HEAP32[i64toi32_i32$0 >> 2] = $389;
                 HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
                 HEAP8[(($4 + 288 | 0) + 8 | 0) >> 0] = $5;
                 $91 = HEAPU8[($4 + 487 | 0) >> 0] | 0 | ((HEAPU8[($4 + 488 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 489 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 490 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 HEAP8[($4 + 403 | 0) >> 0] = $91;
                 HEAP8[($4 + 404 | 0) >> 0] = $91 >>> 8 | 0;
                 HEAP8[($4 + 405 | 0) >> 0] = $91 >>> 16 | 0;
                 HEAP8[($4 + 406 | 0) >> 0] = $91 >>> 24 | 0;
                 HEAP32[($4 + 400 | 0) >> 2] = HEAP32[($4 + 484 | 0) >> 2] | 0;
                 HEAP16[($4 + 396 | 0) >> 1] = HEAPU16[($4 + 480 | 0) >> 1] | 0;
                 i64toi32_i32$3 = $4;
                 i64toi32_i32$2 = HEAP32[($4 + 112 | 0) >> 2] | 0;
                 i64toi32_i32$0 = HEAP32[($4 + 116 | 0) >> 2] | 0;
                 $405 = i64toi32_i32$2;
                 i64toi32_i32$2 = $4;
                 HEAP32[($4 + 376 | 0) >> 2] = $405;
                 HEAP32[($4 + 380 | 0) >> 2] = i64toi32_i32$0;
                 HEAP32[($4 + 292 | 0) >> 2] = $1;
                 $93 = $4 + 300 | 0;
                 $94 = HEAPU8[($4 + 403 | 0) >> 0] | 0 | ((HEAPU8[($4 + 404 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 405 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 406 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 HEAP8[$93 >> 0] = $94;
                 HEAP8[($93 + 1 | 0) >> 0] = $94 >>> 8 | 0;
                 HEAP8[($93 + 2 | 0) >> 0] = $94 >>> 16 | 0;
                 HEAP8[($93 + 3 | 0) >> 0] = $94 >>> 24 | 0;
                 $96 = HEAP32[($4 + 400 | 0) >> 2] | 0;
                 HEAP8[($4 + 297 | 0) >> 0] = $96;
                 HEAP8[($4 + 298 | 0) >> 0] = $96 >>> 8 | 0;
                 HEAP8[($4 + 299 | 0) >> 0] = $96 >>> 16 | 0;
                 HEAP8[($4 + 300 | 0) >> 0] = $96 >>> 24 | 0;
                 HEAP8[(($4 + 288 | 0) + 16 | 0) >> 0] = $6;
                 HEAP8[($4 + 307 | 0) >> 0] = HEAPU8[$8 >> 0] | 0;
                 $123 = HEAPU16[($4 + 396 | 0) >> 1] | 0;
                 HEAP8[($4 + 305 | 0) >> 0] = $123;
                 HEAP8[($4 + 306 | 0) >> 0] = $123 >>> 8 | 0;
                 HEAP32[($4 + 316 | 0) >> 2] = $11;
                 HEAP32[(($4 + 288 | 0) + 24 | 0) >> 2] = $9;
                 HEAP32[($4 + 308 | 0) >> 2] = $7;
                 i64toi32_i32$3 = $10;
                 i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                 i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                 $440 = i64toi32_i32$0;
                 i64toi32_i32$0 = ($4 + 288 | 0) + 40 | 0;
                 HEAP32[i64toi32_i32$0 >> 2] = $440;
                 HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
                 i64toi32_i32$3 = $4;
                 i64toi32_i32$2 = HEAP32[($4 + 376 | 0) >> 2] | 0;
                 i64toi32_i32$0 = HEAP32[($4 + 380 | 0) >> 2] | 0;
                 $445 = i64toi32_i32$2;
                 i64toi32_i32$2 = ($4 + 288 | 0) + 32 | 0;
                 HEAP32[i64toi32_i32$2 >> 2] = $445;
                 HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
                 memcpy($4 + 408 | 0 | 0, $4 + 288 | 0 | 4 | 0 | 0, 44 | 0) | 0;
                 memcpy($0 + 64 | 0 | 0, $4 + 408 | 0 | 0, 44 | 0) | 0;
                 i64toi32_i32$3 = ($4 + 48 | 0) + 24 | 0;
                 i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                 i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                 $462 = i64toi32_i32$0;
                 i64toi32_i32$0 = $0 + 160 | 0;
                 $97 = $462;
                 HEAP8[i64toi32_i32$0 >> 0] = $97;
                 HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $97 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $97 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $97 >>> 24 | 0;
                 HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$2;
                 HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
                 i64toi32_i32$3 = ($4 + 48 | 0) + 16 | 0;
                 i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                 i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                 $468 = i64toi32_i32$2;
                 i64toi32_i32$2 = $0 + 152 | 0;
                 $98 = $468;
                 HEAP8[i64toi32_i32$2 >> 0] = $98;
                 HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $98 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $98 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $98 >>> 24 | 0;
                 HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$0;
                 HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
                 i64toi32_i32$3 = ($4 + 48 | 0) + 8 | 0;
                 i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                 i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                 $474 = i64toi32_i32$0;
                 i64toi32_i32$0 = $0 + 144 | 0;
                 $99 = $474;
                 HEAP8[i64toi32_i32$0 >> 0] = $99;
                 HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $99 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $99 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $99 >>> 24 | 0;
                 HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$2;
                 HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
                 i64toi32_i32$3 = $4;
                 i64toi32_i32$2 = HEAP32[($4 + 48 | 0) >> 2] | 0;
                 i64toi32_i32$0 = HEAP32[($4 + 52 | 0) >> 2] | 0;
                 $478 = i64toi32_i32$2;
                 i64toi32_i32$2 = $0 + 136 | 0;
                 $100 = $478;
                 HEAP8[i64toi32_i32$2 >> 0] = $100;
                 HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $100 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $100 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $100 >>> 24 | 0;
                 HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$0;
                 HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
                 i64toi32_i32$3 = $4;
                 i64toi32_i32$0 = HEAP32[($4 + 80 | 0) >> 2] | 0;
                 i64toi32_i32$2 = HEAP32[($4 + 84 | 0) >> 2] | 0;
                 $482 = i64toi32_i32$0;
                 i64toi32_i32$0 = $0 + 168 | 0;
                 $101 = $482;
                 HEAP8[i64toi32_i32$0 >> 0] = $101;
                 HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $101 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $101 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $101 >>> 24 | 0;
                 HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$2;
                 HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
                 i64toi32_i32$3 = ($4 + 80 | 0) + 8 | 0;
                 i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                 i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                 $488 = i64toi32_i32$2;
                 i64toi32_i32$2 = $0 + 176 | 0;
                 $102 = $488;
                 HEAP8[i64toi32_i32$2 >> 0] = $102;
                 HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $102 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $102 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $102 >>> 24 | 0;
                 HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$0;
                 HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
                 i64toi32_i32$3 = ($4 + 80 | 0) + 16 | 0;
                 i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                 i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                 $494 = i64toi32_i32$0;
                 i64toi32_i32$0 = $0 + 184 | 0;
                 $103 = $494;
                 HEAP8[i64toi32_i32$0 >> 0] = $103;
                 HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $103 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $103 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $103 >>> 24 | 0;
                 HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$2;
                 HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
                 i64toi32_i32$3 = $4 + 102 | 0;
                 i64toi32_i32$2 = HEAPU16[i64toi32_i32$3 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$3 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
                 i64toi32_i32$0 = HEAPU16[(i64toi32_i32$3 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$3 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
                 $499 = i64toi32_i32$2;
                 i64toi32_i32$2 = $0 + 190 | 0;
                 $104 = $499;
                 HEAP8[i64toi32_i32$2 >> 0] = $104;
                 HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $104 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $104 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $104 >>> 24 | 0;
                 HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$0;
                 HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
                 i64toi32_i32$3 = $4;
                 i64toi32_i32$0 = HEAP32[($4 + 256 | 0) >> 2] | 0;
                 i64toi32_i32$2 = HEAP32[($4 + 260 | 0) >> 2] | 0;
                 $503 = i64toi32_i32$0;
                 i64toi32_i32$0 = $0 + 40 | 0;
                 HEAP32[i64toi32_i32$0 >> 2] = $503;
                 HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
                 HEAP32[($0 + 48 | 0) >> 2] = HEAP32[(($4 + 256 | 0) + 8 | 0) >> 2] | 0;
                 i64toi32_i32$2 = $14$hi;
                 i64toi32_i32$0 = $0 + 32 | 0;
                 HEAP32[i64toi32_i32$0 >> 2] = $14;
                 HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
                 i64toi32_i32$2 = $15$hi;
                 i64toi32_i32$0 = $0 + 24 | 0;
                 HEAP32[i64toi32_i32$0 >> 2] = $15;
                 HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
                 i64toi32_i32$2 = $13$hi;
                 i64toi32_i32$0 = $0 + 16 | 0;
                 HEAP32[i64toi32_i32$0 >> 2] = $13;
                 HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
                 i64toi32_i32$2 = $12$hi;
                 i64toi32_i32$0 = $0;
                 HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $12;
                 HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
                 i64toi32_i32$2 = 0;
                 HEAP32[i64toi32_i32$0 >> 2] = 0;
                 HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
                 i64toi32_i32$3 = $4;
                 i64toi32_i32$2 = HEAP32[($4 + 272 | 0) >> 2] | 0;
                 i64toi32_i32$0 = HEAP32[($4 + 276 | 0) >> 2] | 0;
                 $525 = i64toi32_i32$2;
                 i64toi32_i32$2 = $0 + 52 | 0;
                 HEAP32[i64toi32_i32$2 >> 2] = $525;
                 HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
                 HEAP32[($0 + 60 | 0) >> 2] = HEAP32[(($4 + 272 | 0) + 8 | 0) >> 2] | 0;
                 $105 = $0 + 132 | 0;
                 $106 = HEAP32[(($4 + 16 | 0) + 24 | 0) >> 2] | 0;
                 HEAP8[$105 >> 0] = $106;
                 HEAP8[($105 + 1 | 0) >> 0] = $106 >>> 8 | 0;
                 HEAP8[($105 + 2 | 0) >> 0] = $106 >>> 16 | 0;
                 HEAP8[($105 + 3 | 0) >> 0] = $106 >>> 24 | 0;
                 i64toi32_i32$3 = ($4 + 16 | 0) + 16 | 0;
                 i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                 i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                 $543 = i64toi32_i32$0;
                 i64toi32_i32$0 = $0 + 124 | 0;
                 $107 = $543;
                 HEAP8[i64toi32_i32$0 >> 0] = $107;
                 HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $107 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $107 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $107 >>> 24 | 0;
                 HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$2;
                 HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
                 i64toi32_i32$3 = ($4 + 16 | 0) + 8 | 0;
                 i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                 i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                 $549 = i64toi32_i32$2;
                 i64toi32_i32$2 = $0 + 116 | 0;
                 $109 = $549;
                 HEAP8[i64toi32_i32$2 >> 0] = $109;
                 HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $109 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $109 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $109 >>> 24 | 0;
                 HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$0;
                 HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
                 i64toi32_i32$3 = $4;
                 i64toi32_i32$0 = HEAP32[($4 + 16 | 0) >> 2] | 0;
                 i64toi32_i32$2 = HEAP32[($4 + 20 | 0) >> 2] | 0;
                 $553 = i64toi32_i32$0;
                 i64toi32_i32$0 = $0 + 108 | 0;
                 $110 = $553;
                 HEAP8[i64toi32_i32$0 >> 0] = $110;
                 HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $110 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $110 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $110 >>> 24 | 0;
                 HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$2;
                 HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
                 break label$1;
                }
                $8 = ($4 + 492 | 0) + 2 | 0;
                HEAP8[$8 >> 0] = HEAPU8[($4 + 523 | 0) >> 0] | 0;
                $10 = ($4 + 184 | 0) + 8 | 0;
                i64toi32_i32$3 = $4 + 544 | 0;
                i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                $567 = i64toi32_i32$2;
                i64toi32_i32$2 = $10;
                HEAP32[i64toi32_i32$2 >> 2] = $567;
                HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
                HEAP32[($4 + 496 | 0) >> 2] = HEAPU8[($4 + 513 | 0) >> 0] | 0 | ((HEAPU8[($4 + 514 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 515 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 516 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                HEAP16[($4 + 492 | 0) >> 1] = HEAPU8[($4 + 521 | 0) >> 0] | 0 | ((HEAPU8[($4 + 522 | 0) >> 0] | 0) << 8 | 0) | 0;
                $111 = $4 + 516 | 0;
                $112 = HEAPU8[$111 >> 0] | 0 | ((HEAPU8[($111 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($111 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($111 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                HEAP8[($4 + 499 | 0) >> 0] = $112;
                HEAP8[($4 + 500 | 0) >> 0] = $112 >>> 8 | 0;
                HEAP8[($4 + 501 | 0) >> 0] = $112 >>> 16 | 0;
                HEAP8[($4 + 502 | 0) >> 0] = $112 >>> 24 | 0;
                i64toi32_i32$3 = $4 + 536 | 0;
                i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                $581 = i64toi32_i32$0;
                i64toi32_i32$0 = $4;
                HEAP32[($4 + 184 | 0) >> 2] = $581;
                HEAP32[($4 + 188 | 0) >> 2] = i64toi32_i32$2;
                $7 = HEAPU8[(($4 + 504 | 0) + 8 | 0) >> 0] | 0;
                $9 = HEAPU8[($4 + 520 | 0) >> 0] | 0;
                $11 = HEAP32[($4 + 524 | 0) >> 2] | 0;
                $5 = HEAP32[($4 + 528 | 0) >> 2] | 0;
                $6 = HEAP32[($4 + 532 | 0) >> 2] | 0;
                $1 = HEAP32[($4 + 560 | 0) >> 2] | 0;
                i64toi32_i32$3 = $4 + 552 | 0;
                i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                $12 = i64toi32_i32$2;
                $12$hi = i64toi32_i32$0;
                HEAP32[(($4 + 360 | 0) + 8 | 0) >> 2] = HEAP32[($4 + 572 | 0) >> 2] | 0;
                HEAP8[(($4 + 396 | 0) + 2 | 0) >> 0] = HEAPU8[$8 >> 0] | 0;
                i64toi32_i32$3 = $10;
                i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                $619 = i64toi32_i32$0;
                i64toi32_i32$0 = ($4 + 376 | 0) + 8 | 0;
                HEAP32[i64toi32_i32$0 >> 2] = $619;
                HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
                i64toi32_i32$3 = $4 + 564 | 0;
                i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                $623 = i64toi32_i32$2;
                i64toi32_i32$2 = $4;
                HEAP32[($4 + 360 | 0) >> 2] = $623;
                HEAP32[($4 + 364 | 0) >> 2] = i64toi32_i32$0;
                $114 = HEAPU8[($4 + 499 | 0) >> 0] | 0 | ((HEAPU8[($4 + 500 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 501 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 502 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                HEAP8[($4 + 403 | 0) >> 0] = $114;
                HEAP8[($4 + 404 | 0) >> 0] = $114 >>> 8 | 0;
                HEAP8[($4 + 405 | 0) >> 0] = $114 >>> 16 | 0;
                HEAP8[($4 + 406 | 0) >> 0] = $114 >>> 24 | 0;
                HEAP32[($4 + 400 | 0) >> 2] = HEAP32[($4 + 496 | 0) >> 2] | 0;
                HEAP16[($4 + 396 | 0) >> 1] = HEAPU16[($4 + 492 | 0) >> 1] | 0;
                i64toi32_i32$3 = $4;
                i64toi32_i32$0 = HEAP32[($4 + 184 | 0) >> 2] | 0;
                i64toi32_i32$2 = HEAP32[($4 + 188 | 0) >> 2] | 0;
                $635 = i64toi32_i32$0;
                i64toi32_i32$0 = $4;
                HEAP32[($4 + 376 | 0) >> 2] = $635;
                HEAP32[($4 + 380 | 0) >> 2] = i64toi32_i32$2;
                break label$10;
               }
               $7 = 6;
               break label$10;
              }
              $7 = 2;
              $1 = HEAPU8[($4 + 515 | 0) >> 0] | 0;
              HEAP8[(($4 + 496 | 0) + 2 | 0) >> 0] = $1;
              HEAP8[(($4 + 396 | 0) + 2 | 0) >> 0] = $1;
              i64toi32_i32$3 = $4 + 536 | 0;
              i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
              i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
              $651 = i64toi32_i32$2;
              i64toi32_i32$2 = $4 + 384 | 0;
              HEAP32[i64toi32_i32$2 >> 2] = $651;
              HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
              i64toi32_i32$3 = $4 + 528 | 0;
              i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
              i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
              $12 = i64toi32_i32$0;
              $12$hi = i64toi32_i32$2;
              i64toi32_i32$0 = $4;
              HEAP32[($4 + 184 | 0) >> 2] = $12;
              HEAP32[($4 + 188 | 0) >> 2] = i64toi32_i32$2;
              HEAP16[($4 + 396 | 0) >> 1] = HEAPU8[($4 + 513 | 0) >> 0] | 0 | ((HEAPU8[($4 + 514 | 0) >> 0] | 0) << 8 | 0) | 0;
              i64toi32_i32$0 = $4;
              HEAP32[($4 + 376 | 0) >> 2] = $12;
              HEAP32[($4 + 380 | 0) >> 2] = i64toi32_i32$2;
              $5 = HEAP32[($4 + 520 | 0) >> 2] | 0;
              i64toi32_i32$3 = $4 + 544 | 0;
              i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
              i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
              $12 = i64toi32_i32$2;
              $12$hi = i64toi32_i32$0;
              $11 = HEAP32[($4 + 516 | 0) >> 2] | 0;
              $6 = HEAP32[($4 + 524 | 0) >> 2] | 0;
              $1 = 0;
              break label$10;
             }
             memcpy($4 + 504 | 0 | 0, memcpy($4 + 184 | 0 | 4 | 0 | 0, memcpy($4 + 408 | 0 | 4 | 0 | 0, ($4 + 504 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
             $1 = ($4 + 288 | 0) + 8 | 0;
             cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 504 | 0 | 0, 1050960 | 0, 6 | 0);
             memcpy($0 + 8 | 0 | 0, memcpy($4 + 112 | 0 | 4 | 0 | 0, $1 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
             i64toi32_i32$2 = $0;
             i64toi32_i32$0 = 0;
             HEAP32[i64toi32_i32$2 >> 2] = 1;
             HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
             break label$2;
            }
            $11 = 0;
            $7 = 2;
            $5 = 0;
            $1 = 0;
           }
           HEAP8[(($4 + 504 | 0) + 8 | 0) >> 0] = $9;
           $124 = $4 + 513 | 0;
           $125 = HEAPU16[($4 + 396 | 0) >> 1] | 0;
           HEAP8[$124 >> 0] = $125;
           HEAP8[($124 + 1 | 0) >> 0] = $125 >>> 8 | 0;
           HEAP32[($4 + 524 | 0) >> 2] = $6;
           HEAP32[($4 + 520 | 0) >> 2] = $5;
           HEAP32[($4 + 516 | 0) >> 2] = $11;
           i64toi32_i32$3 = $4;
           i64toi32_i32$0 = HEAP32[($4 + 376 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($4 + 380 | 0) >> 2] | 0;
           $721 = i64toi32_i32$0;
           i64toi32_i32$0 = $4 + 528 | 0;
           HEAP32[i64toi32_i32$0 >> 2] = $721;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
           i64toi32_i32$2 = $12$hi;
           i64toi32_i32$0 = $4 + 544 | 0;
           HEAP32[i64toi32_i32$0 >> 2] = $12;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
           HEAP8[($4 + 515 | 0) >> 0] = HEAPU8[($4 + 398 | 0) >> 0] | 0;
           i64toi32_i32$3 = ($4 + 376 | 0) + 8 | 0;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
           $735 = i64toi32_i32$2;
           i64toi32_i32$2 = $4 + 536 | 0;
           HEAP32[i64toi32_i32$2 >> 2] = $735;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
           HEAP8[($4 + 504 | 0) >> 0] = $7;
           $115 = HEAP32[($4 + 400 | 0) >> 2] | 0;
           HEAP8[($4 + 505 | 0) >> 0] = $115;
           HEAP8[($4 + 506 | 0) >> 0] = $115 >>> 8 | 0;
           HEAP8[($4 + 507 | 0) >> 0] = $115 >>> 16 | 0;
           HEAP8[($4 + 508 | 0) >> 0] = $115 >>> 24 | 0;
           $116 = HEAPU8[($4 + 403 | 0) >> 0] | 0 | ((HEAPU8[($4 + 404 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 405 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 406 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($4 + 508 | 0) >> 0] = $116;
           HEAP8[($4 + 509 | 0) >> 0] = $116 >>> 8 | 0;
           HEAP8[($4 + 510 | 0) >> 0] = $116 >>> 16 | 0;
           HEAP8[($4 + 511 | 0) >> 0] = $116 >>> 24 | 0;
           HEAP32[($4 + 552 | 0) >> 2] = $1;
           HEAP32[($4 + 564 | 0) >> 2] = HEAP32[(($4 + 360 | 0) + 8 | 0) >> 2] | 0;
           i64toi32_i32$3 = $4;
           i64toi32_i32$0 = HEAP32[($4 + 360 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($4 + 364 | 0) >> 2] | 0;
           $755 = i64toi32_i32$0;
           i64toi32_i32$0 = $4 + 556 | 0;
           HEAP32[i64toi32_i32$0 >> 2] = $755;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
           $1 = ($4 + 288 | 0) + 8 | 0;
           cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 504 | 0 | 0, 1050966 | 0, 13 | 0);
           memcpy($0 + 8 | 0 | 0, memcpy($4 + 412 | 0 | 0, $1 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
           i64toi32_i32$0 = $0;
           i64toi32_i32$2 = 0;
           HEAP32[i64toi32_i32$0 >> 2] = 1;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
           $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hb600accf9d1c2a17($4 + 272 | 0 | 0);
           $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h96b3170d440e3692($4 + 272 | 0 | 0);
           break label$2;
          }
          memcpy($4 + 504 | 0 | 0, memcpy($4 + 184 | 0 | 7 | 0 | 0, memcpy($4 + 408 | 0 | 7 | 0 | 0, ($4 + 504 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
          $1 = ($4 + 288 | 0) + 8 | 0;
          cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 504 | 0 | 0, 1050900 | 0, 8 | 0);
          memcpy($0 + 8 | 0 | 0, memcpy($4 + 112 | 0 | 7 | 0 | 0, $1 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
          i64toi32_i32$0 = $0;
          i64toi32_i32$2 = 0;
          HEAP32[i64toi32_i32$0 >> 2] = 1;
          HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
          break label$1;
         }
         memcpy($4 + 504 | 0 | 0, memcpy($4 + 184 | 0 | 7 | 0 | 0, memcpy($4 + 408 | 0 | 7 | 0 | 0, ($4 + 504 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
         $1 = ($4 + 288 | 0) + 8 | 0;
         cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 504 | 0 | 0, 1050908 | 0, 11 | 0);
         memcpy($0 + 8 | 0 | 0, memcpy($4 + 112 | 0 | 7 | 0 | 0, $1 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
         i64toi32_i32$0 = $0;
         i64toi32_i32$2 = 0;
         HEAP32[i64toi32_i32$0 >> 2] = 1;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
         break label$1;
        }
        memcpy($4 + 408 | 0 | 0, ($4 + 504 | 0) + 16 | 0 | 0, 56 | 0) | 0;
        memcpy($4 + 184 | 0 | 0, $4 + 408 | 0 | 0, 56 | 0) | 0;
        i64toi32_i32$2 = $12$hi;
        i64toi32_i32$0 = $4;
        HEAP32[($4 + 504 | 0) >> 2] = $12;
        HEAP32[($4 + 508 | 0) >> 2] = i64toi32_i32$2;
        memcpy(($4 + 504 | 0) + 8 | 0 | 0, $4 + 184 | 0 | 0, 56 | 0) | 0;
        cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e(($4 + 288 | 0) + 8 | 0 | 0, $4 + 504 | 0 | 0, 1050919 | 0, 6 | 0);
        i64toi32_i32$3 = $4;
        i64toi32_i32$2 = HEAP32[($4 + 296 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[($4 + 300 | 0) >> 2] | 0;
        $12 = i64toi32_i32$2;
        $12$hi = i64toi32_i32$0;
        memcpy($0 + 16 | 0 | 0, ($4 + 288 | 0) + 16 | 0 | 0, 56 | 0) | 0;
        i64toi32_i32$2 = $0;
        i64toi32_i32$0 = 0;
        HEAP32[i64toi32_i32$2 >> 2] = 1;
        HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$0 = $12$hi;
        HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $12;
        HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$0;
        break label$1;
       }
       memcpy($4 + 408 | 0 | 0, ($4 + 504 | 0) + 16 | 0 | 0, 56 | 0) | 0;
       memcpy($4 + 184 | 0 | 0, $4 + 408 | 0 | 0, 56 | 0) | 0;
       i64toi32_i32$0 = $13$hi;
       i64toi32_i32$2 = $4;
       HEAP32[($4 + 504 | 0) >> 2] = $13;
       HEAP32[($4 + 508 | 0) >> 2] = i64toi32_i32$0;
       memcpy(($4 + 504 | 0) + 8 | 0 | 0, $4 + 184 | 0 | 0, 56 | 0) | 0;
       cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e(($4 + 288 | 0) + 8 | 0 | 0, $4 + 504 | 0 | 0, 1050925 | 0, 4 | 0);
       i64toi32_i32$3 = $4;
       i64toi32_i32$0 = HEAP32[($4 + 296 | 0) >> 2] | 0;
       i64toi32_i32$2 = HEAP32[($4 + 300 | 0) >> 2] | 0;
       $12 = i64toi32_i32$0;
       $12$hi = i64toi32_i32$2;
       memcpy($0 + 16 | 0 | 0, ($4 + 288 | 0) + 16 | 0 | 0, 56 | 0) | 0;
       i64toi32_i32$0 = $0;
       i64toi32_i32$2 = 0;
       HEAP32[i64toi32_i32$0 >> 2] = 1;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$2 = $12$hi;
       HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $12;
       HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
       break label$1;
      }
      memcpy($4 + 408 | 0 | 0, ($4 + 504 | 0) + 24 | 0 | 0, 48 | 0) | 0;
      i64toi32_i32$2 = $14$hi;
      i64toi32_i32$0 = ($4 + 504 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $14;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$2 = $15$hi;
      i64toi32_i32$0 = $4;
      HEAP32[($4 + 504 | 0) >> 2] = $15;
      HEAP32[($4 + 508 | 0) >> 2] = i64toi32_i32$2;
      memcpy($7 | 0, $4 + 408 | 0 | 0, 48 | 0) | 0;
      cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e(($4 + 288 | 0) + 8 | 0 | 0, $4 + 504 | 0 | 0, 1050929 | 0, 6 | 0);
      i64toi32_i32$3 = ($4 + 288 | 0) + 16 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $12 = i64toi32_i32$2;
      $12$hi = i64toi32_i32$0;
      i64toi32_i32$3 = $4;
      i64toi32_i32$0 = HEAP32[($4 + 296 | 0) >> 2] | 0;
      i64toi32_i32$2 = HEAP32[($4 + 300 | 0) >> 2] | 0;
      $13 = i64toi32_i32$0;
      $13$hi = i64toi32_i32$2;
      memcpy($0 + 24 | 0 | 0, ($4 + 288 | 0) + 24 | 0 | 0, 48 | 0) | 0;
      i64toi32_i32$2 = $12$hi;
      i64toi32_i32$0 = $0 + 16 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $12;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$2 = $13$hi;
      i64toi32_i32$0 = $0;
      HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $13;
      HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$2 = 0;
      HEAP32[i64toi32_i32$0 >> 2] = 1;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
      break label$1;
     }
     memcpy($4 + 504 | 0 | 0, memcpy($4 + 184 | 0 | 7 | 0 | 0, memcpy($4 + 408 | 0 | 7 | 0 | 0, ($4 + 504 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
     $1 = ($4 + 288 | 0) + 8 | 0;
     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 504 | 0 | 0, 1050935 | 0, 14 | 0);
     memcpy($0 + 8 | 0 | 0, memcpy($4 + 112 | 0 | 7 | 0 | 0, $1 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
     i64toi32_i32$0 = $0;
     i64toi32_i32$2 = 0;
     HEAP32[i64toi32_i32$0 >> 2] = 1;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
     break label$1;
    }
    memcpy($4 + 504 | 0 | 0, memcpy($4 + 184 | 0 | 4 | 0 | 0, memcpy($4 + 408 | 0 | 4 | 0 | 0, ($4 + 504 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
    $1 = ($4 + 288 | 0) + 8 | 0;
    cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 504 | 0 | 0, 1050949 | 0, 11 | 0);
    memcpy($0 + 8 | 0 | 0, memcpy($4 + 112 | 0 | 4 | 0 | 0, $1 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
    i64toi32_i32$0 = $0;
    i64toi32_i32$2 = 0;
    HEAP32[i64toi32_i32$0 >> 2] = 1;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    break label$1;
   }
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h72de9eab2f0e4669($4 + 256 | 0 | 0);
  }
  global$0 = $4 + 576 | 0;
 }
 
 function cryptoxide__chacha20__ChaCha_____update__h0ad25fc73ef018e9($0) {
  $0 = $0 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $1 = 0, $11 = 0, $10 = 0, $7 = 0, $14 = 0, $6 = 0, $8 = 0, $2 = 0, $12 = 0, $13 = 0, $15 = 0, $16 = 0, $17 = 0, $19 = 0, $19$hi = 0, $3 = 0, $9 = 0, $18 = 0, $4 = 0, $5 = 0, $34 = 0, $39 = 0, $44 = 0, $49 = 0, $52 = 0, $55 = 0, $58 = 0, $61 = 0, $79 = 0, $82 = 0, $90 = 0, $93 = 0, $103 = 0, $106 = 0, $109 = 0, $112 = 0, $120 = 0, $122 = 0, $124 = 0, $126 = 0, $138 = 0, $141 = 0, $147 = 0, $150 = 0, $159 = 0, $162 = 0, $164 = 0, $166 = 0, $178 = 0, $181 = 0, $191 = 0, $194 = 0, $197 = 0, $200 = 0, $208 = 0, $211 = 0, $214 = 0, $217 = 0, $225 = 0, $227 = 0, $229 = 0, $231 = 0, $240 = 0, $243 = 0, $246 = 0, $249 = 0, $258 = 0, $261 = 0, $263 = 0, $265 = 0, $274 = 0, $277 = 0, $285 = 0, $288 = 0, $291 = 0, $294 = 0, $302 = 0, $305 = 0, $308 = 0, $311 = 0, $319 = 0, $321 = 0, $323 = 0, $325 = 0, $334 = 0, $337 = 0, $340 = 0, $343 = 0, $352 = 0, $355 = 0, $357 = 0, $359 = 0, $368 = 0, $371 = 0, $379 = 0, $382 = 0, $385 = 0, $388 = 0, $396 = 0, $399 = 0, $402 = 0, $405 = 0, $413 = 0, $415 = 0, $417 = 0, $419 = 0, $428 = 0, $431 = 0, $434 = 0, $437 = 0, $446 = 0, $449 = 0, $451 = 0, $453 = 0, $462 = 0, $465 = 0, $478 = 0, $485 = 0, $501 = 0, $504 = 0, $507 = 0, $510 = 0, $518 = 0, $521 = 0, $524 = 0, $527 = 0, $535 = 0, $537 = 0, $539 = 0, $541 = 0, $550 = 0, $553 = 0, $556 = 0, $559 = 0, $568 = 0, $571 = 0, $573 = 0, $575 = 0, $584 = 0, $587 = 0, $595 = 0, $598 = 0, $601 = 0, $604 = 0, $612 = 0, $615 = 0, $618 = 0, $621 = 0, $629 = 0, $631 = 0, $633 = 0, $635 = 0, $644 = 0, $647 = 0, $650 = 0, $653 = 0, $662 = 0, $665 = 0, $667 = 0, $669 = 0, $678 = 0, $681 = 0, $689 = 0, $692 = 0, $695 = 0, $698 = 0, $706 = 0, $709 = 0, $712 = 0, $715 = 0, $723 = 0, $725 = 0, $727 = 0, $729 = 0, $738 = 0, $741 = 0, $744 = 0, $747 = 0, $756 = 0, $759 = 0, $761 = 0, $763 = 0, $772 = 0, $775 = 0, $783 = 0, $786 = 0, $789 = 0, $792 = 0, $800 = 0, $803 = 0, $806 = 0, $809 = 0, $817 = 0, $819 = 0, $821 = 0, $823 = 0, $832 = 0, $835 = 0, $838 = 0, $841 = 0, $850 = 0, $853 = 0, $855 = 0, $857 = 0, $866 = 0, $869 = 0, $882 = 0, $889 = 0, $916 = 0, $919 = 0, $926 = 0, $929 = 0, $938 = 0, $941 = 0, $945 = 0, $948 = 0, $957 = 0, $960 = 0, $964 = 0, $967 = 0, $976 = 0, $979 = 0, $984 = 0, $987 = 0, $20 = 0, $20$hi = 0, $21 = 0, $21$hi = 0, $22 = 0, $22$hi = 0, $23 = 0, $23$hi = 0, $24 = 0, $24$hi = 0, $25 = 0, $25$hi = 0, $1009 = 0, $1030 = 0, $1033 = 0;
  $1 = global$0 - 208 | 0;
  global$0 = $1;
  $2 = $1 + 8 | 0;
  i64toi32_i32$2 = $0 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $34 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $34;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $0 + 24 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $39 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 24 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $39;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $0 + 40 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $44 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 40 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $44;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $0 + 56 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $49 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 56 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $49;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $52 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[i64toi32_i32$0 >> 2] = $52;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $55 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $55;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
  $58 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] = $58;
  HEAP32[(i64toi32_i32$0 + 36 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] | 0;
  $61 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[(i64toi32_i32$1 + 48 | 0) >> 2] = $61;
  HEAP32[(i64toi32_i32$1 + 52 | 0) >> 2] = i64toi32_i32$0;
  $3 = i64toi32_i32$2 + 48 | 0;
  $4 = i64toi32_i32$2 + 32 | 0;
  $5 = i64toi32_i32$2 + 16 | 0;
  $6 = i64toi32_i32$1 + 48 | 0;
  $7 = i64toi32_i32$1 + 32 | 0;
  $8 = i64toi32_i32$1 + 16 | 0;
  $9 = 10;
  label$1 : while (1) {
   $10 = ($1 + 128 | 0) + 8 | 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $79 = i64toi32_i32$0;
   i64toi32_i32$0 = $10;
   HEAP32[i64toi32_i32$0 >> 2] = $79;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $82 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$1 + 128 | 0) >> 2] = $82;
   HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] = i64toi32_i32$0;
   $11 = (i64toi32_i32$1 + 144 | 0) + 8 | 0;
   $12 = $8 + 8 | 0;
   i64toi32_i32$2 = $12;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $90 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $90;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $8;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $93 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $93;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__arith__Add___add__h93056800a76fa877(i64toi32_i32$1 | 0, i64toi32_i32$1 + 128 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   $13 = $6 + 8 | 0;
   i64toi32_i32$2 = $13;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $103 = i64toi32_i32$0;
   i64toi32_i32$0 = $10;
   HEAP32[i64toi32_i32$0 >> 2] = $103;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $6;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $106 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 128 | 0) >> 2] = $106;
   HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $109 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $109;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $112 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $112;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__bit__BitXor___bitxor__h496945338e6fc19a(i64toi32_i32$1 + 64 | 0 | 0, i64toi32_i32$1 + 128 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   i64toi32_i32$2 = 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102028 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102032 | 0) >> 2] | 0;
   $120 = i64toi32_i32$0;
   i64toi32_i32$0 = $10;
   HEAP32[i64toi32_i32$0 >> 2] = $120;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102020 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102024 | 0) >> 2] | 0;
   $122 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 128 | 0) >> 2] = $122;
   HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102044 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102048 | 0) >> 2] | 0;
   $124 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $124;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102036 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102040 | 0) >> 2] | 0;
   $126 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $126;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__arith__Sub___sub__h31fa90f2b2d1e09f(i64toi32_i32$1 + 80 | 0 | 0, i64toi32_i32$1 + 128 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   $14 = (i64toi32_i32$1 + 64 | 0) + 8 | 0;
   i64toi32_i32$2 = $14;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $138 = i64toi32_i32$0;
   i64toi32_i32$0 = $10;
   HEAP32[i64toi32_i32$0 >> 2] = $138;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
   $141 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$1 + 128 | 0) >> 2] = $141;
   HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] = i64toi32_i32$0;
   $15 = (i64toi32_i32$1 + 80 | 0) + 8 | 0;
   i64toi32_i32$2 = $15;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $147 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $147;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 80 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 84 | 0) >> 2] | 0;
   $150 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $150;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__bit__Shr___shr__ha0ba11d1f3a547e4(i64toi32_i32$1 + 96 | 0 | 0, i64toi32_i32$1 + 128 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   i64toi32_i32$2 = $14;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $159 = i64toi32_i32$0;
   i64toi32_i32$0 = $10;
   HEAP32[i64toi32_i32$0 >> 2] = $159;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
   $162 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$1 + 128 | 0) >> 2] = $162;
   HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102044 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102048 | 0) >> 2] | 0;
   $164 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $164;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102036 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102040 | 0) >> 2] | 0;
   $166 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $166;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__bit__Shl___shl__h81233ff1fb0a7e8f(i64toi32_i32$1 + 112 | 0 | 0, i64toi32_i32$1 + 128 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   $16 = (i64toi32_i32$1 + 96 | 0) + 8 | 0;
   i64toi32_i32$2 = $16;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $178 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $178;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 100 | 0) >> 2] | 0;
   $181 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $181;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__bit__BitXor___bitxor__h496945338e6fc19a($6 | 0, i64toi32_i32$1 + 112 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   $17 = $7 + 8 | 0;
   i64toi32_i32$2 = $17;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $191 = i64toi32_i32$0;
   i64toi32_i32$0 = $10;
   HEAP32[i64toi32_i32$0 >> 2] = $191;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $7;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $194 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 128 | 0) >> 2] = $194;
   HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $13;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $197 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $197;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $6;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $200 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $200;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__arith__Add___add__h93056800a76fa877($7 | 0, i64toi32_i32$1 + 128 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   i64toi32_i32$2 = $12;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $208 = i64toi32_i32$0;
   i64toi32_i32$0 = $10;
   HEAP32[i64toi32_i32$0 >> 2] = $208;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $8;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $211 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 128 | 0) >> 2] = $211;
   HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $17;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $214 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $214;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $7;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $217 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $217;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__bit__BitXor___bitxor__h496945338e6fc19a(i64toi32_i32$1 + 64 | 0 | 0, i64toi32_i32$1 + 128 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   i64toi32_i32$2 = 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102028 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102032 | 0) >> 2] | 0;
   $225 = i64toi32_i32$0;
   i64toi32_i32$0 = $10;
   HEAP32[i64toi32_i32$0 >> 2] = $225;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102020 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102024 | 0) >> 2] | 0;
   $227 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 128 | 0) >> 2] = $227;
   HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102060 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102064 | 0) >> 2] | 0;
   $229 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $229;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102052 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102056 | 0) >> 2] | 0;
   $231 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $231;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__arith__Sub___sub__h31fa90f2b2d1e09f(i64toi32_i32$1 + 80 | 0 | 0, i64toi32_i32$1 + 128 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   i64toi32_i32$2 = $14;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $240 = i64toi32_i32$0;
   i64toi32_i32$0 = $10;
   HEAP32[i64toi32_i32$0 >> 2] = $240;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
   $243 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$1 + 128 | 0) >> 2] = $243;
   HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $15;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $246 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $246;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 80 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 84 | 0) >> 2] | 0;
   $249 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $249;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__bit__Shr___shr__ha0ba11d1f3a547e4(i64toi32_i32$1 + 96 | 0 | 0, i64toi32_i32$1 + 128 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   i64toi32_i32$2 = $14;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $258 = i64toi32_i32$0;
   i64toi32_i32$0 = $10;
   HEAP32[i64toi32_i32$0 >> 2] = $258;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
   $261 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$1 + 128 | 0) >> 2] = $261;
   HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102060 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102064 | 0) >> 2] | 0;
   $263 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $263;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102052 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102056 | 0) >> 2] | 0;
   $265 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $265;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__bit__Shl___shl__h81233ff1fb0a7e8f(i64toi32_i32$1 + 112 | 0 | 0, i64toi32_i32$1 + 128 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   i64toi32_i32$2 = $16;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $274 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $274;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 100 | 0) >> 2] | 0;
   $277 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $277;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__bit__BitXor___bitxor__h496945338e6fc19a($8 | 0, i64toi32_i32$1 + 112 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $285 = i64toi32_i32$0;
   i64toi32_i32$0 = $10;
   HEAP32[i64toi32_i32$0 >> 2] = $285;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $288 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$1 + 128 | 0) >> 2] = $288;
   HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $12;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $291 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $291;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $8;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $294 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $294;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__arith__Add___add__h93056800a76fa877(i64toi32_i32$1 | 0, i64toi32_i32$1 + 128 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   i64toi32_i32$2 = $13;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $302 = i64toi32_i32$0;
   i64toi32_i32$0 = $10;
   HEAP32[i64toi32_i32$0 >> 2] = $302;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $6;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $305 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 128 | 0) >> 2] = $305;
   HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $308 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $308;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $311 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $311;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__bit__BitXor___bitxor__h496945338e6fc19a(i64toi32_i32$1 + 64 | 0 | 0, i64toi32_i32$1 + 128 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   i64toi32_i32$2 = 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102028 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102032 | 0) >> 2] | 0;
   $319 = i64toi32_i32$0;
   i64toi32_i32$0 = $10;
   HEAP32[i64toi32_i32$0 >> 2] = $319;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102020 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102024 | 0) >> 2] | 0;
   $321 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 128 | 0) >> 2] = $321;
   HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102076 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102080 | 0) >> 2] | 0;
   $323 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $323;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102068 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102072 | 0) >> 2] | 0;
   $325 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $325;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__arith__Sub___sub__h31fa90f2b2d1e09f(i64toi32_i32$1 + 80 | 0 | 0, i64toi32_i32$1 + 128 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   i64toi32_i32$2 = $14;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $334 = i64toi32_i32$0;
   i64toi32_i32$0 = $10;
   HEAP32[i64toi32_i32$0 >> 2] = $334;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
   $337 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$1 + 128 | 0) >> 2] = $337;
   HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $15;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $340 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $340;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 80 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 84 | 0) >> 2] | 0;
   $343 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $343;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__bit__Shr___shr__ha0ba11d1f3a547e4(i64toi32_i32$1 + 96 | 0 | 0, i64toi32_i32$1 + 128 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   i64toi32_i32$2 = $14;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $352 = i64toi32_i32$0;
   i64toi32_i32$0 = $10;
   HEAP32[i64toi32_i32$0 >> 2] = $352;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
   $355 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$1 + 128 | 0) >> 2] = $355;
   HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102076 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102080 | 0) >> 2] | 0;
   $357 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $357;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102068 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102072 | 0) >> 2] | 0;
   $359 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $359;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__bit__Shl___shl__h81233ff1fb0a7e8f(i64toi32_i32$1 + 112 | 0 | 0, i64toi32_i32$1 + 128 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   i64toi32_i32$2 = $16;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $368 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $368;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 100 | 0) >> 2] | 0;
   $371 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $371;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__bit__BitXor___bitxor__h496945338e6fc19a($6 | 0, i64toi32_i32$1 + 112 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   i64toi32_i32$2 = $17;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $379 = i64toi32_i32$0;
   i64toi32_i32$0 = $10;
   HEAP32[i64toi32_i32$0 >> 2] = $379;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $7;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $382 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 128 | 0) >> 2] = $382;
   HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $13;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $385 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $385;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $6;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $388 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $388;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__arith__Add___add__h93056800a76fa877($7 | 0, i64toi32_i32$1 + 128 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   i64toi32_i32$2 = $12;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $396 = i64toi32_i32$0;
   i64toi32_i32$0 = $10;
   HEAP32[i64toi32_i32$0 >> 2] = $396;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $8;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $399 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 128 | 0) >> 2] = $399;
   HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $17;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $402 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $402;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $7;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $405 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $405;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__bit__BitXor___bitxor__h496945338e6fc19a(i64toi32_i32$1 + 64 | 0 | 0, i64toi32_i32$1 + 128 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   i64toi32_i32$2 = 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102028 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102032 | 0) >> 2] | 0;
   $413 = i64toi32_i32$0;
   i64toi32_i32$0 = $10;
   HEAP32[i64toi32_i32$0 >> 2] = $413;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102020 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102024 | 0) >> 2] | 0;
   $415 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 128 | 0) >> 2] = $415;
   HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102092 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102096 | 0) >> 2] | 0;
   $417 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $417;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102084 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102088 | 0) >> 2] | 0;
   $419 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $419;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__arith__Sub___sub__h31fa90f2b2d1e09f(i64toi32_i32$1 + 80 | 0 | 0, i64toi32_i32$1 + 128 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   i64toi32_i32$2 = $14;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $428 = i64toi32_i32$0;
   i64toi32_i32$0 = $10;
   HEAP32[i64toi32_i32$0 >> 2] = $428;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
   $431 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$1 + 128 | 0) >> 2] = $431;
   HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $15;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $434 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $434;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 80 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 84 | 0) >> 2] | 0;
   $437 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $437;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__bit__Shr___shr__ha0ba11d1f3a547e4(i64toi32_i32$1 + 96 | 0 | 0, i64toi32_i32$1 + 128 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   i64toi32_i32$2 = $14;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $446 = i64toi32_i32$0;
   i64toi32_i32$0 = $10;
   HEAP32[i64toi32_i32$0 >> 2] = $446;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
   $449 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$1 + 128 | 0) >> 2] = $449;
   HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102092 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102096 | 0) >> 2] | 0;
   $451 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $451;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102084 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102088 | 0) >> 2] | 0;
   $453 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $453;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__bit__Shl___shl__h81233ff1fb0a7e8f(i64toi32_i32$1 + 112 | 0 | 0, i64toi32_i32$1 + 128 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   i64toi32_i32$2 = $16;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $462 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $462;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 100 | 0) >> 2] | 0;
   $465 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $465;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__bit__BitXor___bitxor__h496945338e6fc19a($8 | 0, i64toi32_i32$1 + 112 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   $18 = HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] | 0;
   HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] | 0;
   i64toi32_i32$2 = i64toi32_i32$1;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] | 0;
   $478 = i64toi32_i32$0;
   i64toi32_i32$0 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = $478;
   HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = $18;
   i64toi32_i32$2 = i64toi32_i32$0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$0 + 36 | 0) >> 2] | 0;
   $19 = i64toi32_i32$1;
   $19$hi = i64toi32_i32$0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] | 0;
   $485 = i64toi32_i32$0;
   i64toi32_i32$0 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] = $485;
   HEAP32[(i64toi32_i32$0 + 36 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $19$hi;
   HEAP32[(i64toi32_i32$0 + 40 | 0) >> 2] = $19;
   HEAP32[(i64toi32_i32$0 + 44 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = i64toi32_i32$0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 52 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$0 + 56 | 0) >> 2] | 0;
   $19 = i64toi32_i32$1;
   $19$hi = i64toi32_i32$0;
   HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] | 0;
   $18 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$1 + 56 | 0) >> 2] = $19;
   HEAP32[(i64toi32_i32$1 + 60 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[(i64toi32_i32$1 + 48 | 0) >> 2] = $18;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $501 = i64toi32_i32$0;
   i64toi32_i32$0 = $10;
   HEAP32[i64toi32_i32$0 >> 2] = $501;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $504 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$1 + 128 | 0) >> 2] = $504;
   HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $12;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $507 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $507;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $8;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $510 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $510;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__arith__Add___add__h93056800a76fa877(i64toi32_i32$1 | 0, i64toi32_i32$1 + 128 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   i64toi32_i32$2 = $13;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $518 = i64toi32_i32$0;
   i64toi32_i32$0 = $10;
   HEAP32[i64toi32_i32$0 >> 2] = $518;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $6;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $521 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 128 | 0) >> 2] = $521;
   HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $524 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $524;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $527 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $527;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__bit__BitXor___bitxor__h496945338e6fc19a(i64toi32_i32$1 + 64 | 0 | 0, i64toi32_i32$1 + 128 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   i64toi32_i32$2 = 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102028 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102032 | 0) >> 2] | 0;
   $535 = i64toi32_i32$0;
   i64toi32_i32$0 = $10;
   HEAP32[i64toi32_i32$0 >> 2] = $535;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102020 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102024 | 0) >> 2] | 0;
   $537 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 128 | 0) >> 2] = $537;
   HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102044 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102048 | 0) >> 2] | 0;
   $539 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $539;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102036 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102040 | 0) >> 2] | 0;
   $541 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $541;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__arith__Sub___sub__h31fa90f2b2d1e09f(i64toi32_i32$1 + 80 | 0 | 0, i64toi32_i32$1 + 128 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   i64toi32_i32$2 = $14;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $550 = i64toi32_i32$0;
   i64toi32_i32$0 = $10;
   HEAP32[i64toi32_i32$0 >> 2] = $550;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
   $553 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$1 + 128 | 0) >> 2] = $553;
   HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $15;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $556 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $556;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 80 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 84 | 0) >> 2] | 0;
   $559 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $559;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__bit__Shr___shr__ha0ba11d1f3a547e4(i64toi32_i32$1 + 96 | 0 | 0, i64toi32_i32$1 + 128 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   i64toi32_i32$2 = $14;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $568 = i64toi32_i32$0;
   i64toi32_i32$0 = $10;
   HEAP32[i64toi32_i32$0 >> 2] = $568;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
   $571 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$1 + 128 | 0) >> 2] = $571;
   HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102044 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102048 | 0) >> 2] | 0;
   $573 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $573;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102036 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102040 | 0) >> 2] | 0;
   $575 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $575;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__bit__Shl___shl__h81233ff1fb0a7e8f(i64toi32_i32$1 + 112 | 0 | 0, i64toi32_i32$1 + 128 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   i64toi32_i32$2 = $16;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $584 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $584;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 100 | 0) >> 2] | 0;
   $587 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $587;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__bit__BitXor___bitxor__h496945338e6fc19a($6 | 0, i64toi32_i32$1 + 112 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   i64toi32_i32$2 = $17;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $595 = i64toi32_i32$0;
   i64toi32_i32$0 = $10;
   HEAP32[i64toi32_i32$0 >> 2] = $595;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $7;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $598 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 128 | 0) >> 2] = $598;
   HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $13;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $601 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $601;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $6;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $604 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $604;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__arith__Add___add__h93056800a76fa877($7 | 0, i64toi32_i32$1 + 128 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   i64toi32_i32$2 = $12;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $612 = i64toi32_i32$0;
   i64toi32_i32$0 = $10;
   HEAP32[i64toi32_i32$0 >> 2] = $612;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $8;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $615 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 128 | 0) >> 2] = $615;
   HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $17;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $618 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $618;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $7;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $621 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $621;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__bit__BitXor___bitxor__h496945338e6fc19a(i64toi32_i32$1 + 64 | 0 | 0, i64toi32_i32$1 + 128 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   i64toi32_i32$2 = 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102028 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102032 | 0) >> 2] | 0;
   $629 = i64toi32_i32$0;
   i64toi32_i32$0 = $10;
   HEAP32[i64toi32_i32$0 >> 2] = $629;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102020 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102024 | 0) >> 2] | 0;
   $631 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 128 | 0) >> 2] = $631;
   HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102060 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102064 | 0) >> 2] | 0;
   $633 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $633;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102052 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102056 | 0) >> 2] | 0;
   $635 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $635;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__arith__Sub___sub__h31fa90f2b2d1e09f(i64toi32_i32$1 + 80 | 0 | 0, i64toi32_i32$1 + 128 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   i64toi32_i32$2 = $14;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $644 = i64toi32_i32$0;
   i64toi32_i32$0 = $10;
   HEAP32[i64toi32_i32$0 >> 2] = $644;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
   $647 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$1 + 128 | 0) >> 2] = $647;
   HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $15;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $650 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $650;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 80 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 84 | 0) >> 2] | 0;
   $653 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $653;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__bit__Shr___shr__ha0ba11d1f3a547e4(i64toi32_i32$1 + 96 | 0 | 0, i64toi32_i32$1 + 128 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   i64toi32_i32$2 = $14;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $662 = i64toi32_i32$0;
   i64toi32_i32$0 = $10;
   HEAP32[i64toi32_i32$0 >> 2] = $662;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
   $665 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$1 + 128 | 0) >> 2] = $665;
   HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102060 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102064 | 0) >> 2] | 0;
   $667 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $667;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102052 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102056 | 0) >> 2] | 0;
   $669 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $669;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__bit__Shl___shl__h81233ff1fb0a7e8f(i64toi32_i32$1 + 112 | 0 | 0, i64toi32_i32$1 + 128 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   i64toi32_i32$2 = $16;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $678 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $678;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 100 | 0) >> 2] | 0;
   $681 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $681;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__bit__BitXor___bitxor__h496945338e6fc19a($8 | 0, i64toi32_i32$1 + 112 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $689 = i64toi32_i32$0;
   i64toi32_i32$0 = $10;
   HEAP32[i64toi32_i32$0 >> 2] = $689;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $692 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$1 + 128 | 0) >> 2] = $692;
   HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $12;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $695 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $695;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $8;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $698 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $698;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__arith__Add___add__h93056800a76fa877(i64toi32_i32$1 | 0, i64toi32_i32$1 + 128 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   i64toi32_i32$2 = $13;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $706 = i64toi32_i32$0;
   i64toi32_i32$0 = $10;
   HEAP32[i64toi32_i32$0 >> 2] = $706;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $6;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $709 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 128 | 0) >> 2] = $709;
   HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $712 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $712;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $715 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $715;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__bit__BitXor___bitxor__h496945338e6fc19a(i64toi32_i32$1 + 64 | 0 | 0, i64toi32_i32$1 + 128 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   i64toi32_i32$2 = 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102028 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102032 | 0) >> 2] | 0;
   $723 = i64toi32_i32$0;
   i64toi32_i32$0 = $10;
   HEAP32[i64toi32_i32$0 >> 2] = $723;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102020 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102024 | 0) >> 2] | 0;
   $725 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 128 | 0) >> 2] = $725;
   HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102076 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102080 | 0) >> 2] | 0;
   $727 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $727;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102068 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102072 | 0) >> 2] | 0;
   $729 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $729;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__arith__Sub___sub__h31fa90f2b2d1e09f(i64toi32_i32$1 + 80 | 0 | 0, i64toi32_i32$1 + 128 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   i64toi32_i32$2 = $14;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $738 = i64toi32_i32$0;
   i64toi32_i32$0 = $10;
   HEAP32[i64toi32_i32$0 >> 2] = $738;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
   $741 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$1 + 128 | 0) >> 2] = $741;
   HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $15;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $744 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $744;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 80 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 84 | 0) >> 2] | 0;
   $747 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $747;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__bit__Shr___shr__ha0ba11d1f3a547e4(i64toi32_i32$1 + 96 | 0 | 0, i64toi32_i32$1 + 128 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   i64toi32_i32$2 = $14;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $756 = i64toi32_i32$0;
   i64toi32_i32$0 = $10;
   HEAP32[i64toi32_i32$0 >> 2] = $756;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
   $759 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$1 + 128 | 0) >> 2] = $759;
   HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102076 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102080 | 0) >> 2] | 0;
   $761 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $761;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102068 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102072 | 0) >> 2] | 0;
   $763 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $763;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__bit__Shl___shl__h81233ff1fb0a7e8f(i64toi32_i32$1 + 112 | 0 | 0, i64toi32_i32$1 + 128 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   i64toi32_i32$2 = $16;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $772 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $772;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 100 | 0) >> 2] | 0;
   $775 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $775;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__bit__BitXor___bitxor__h496945338e6fc19a($6 | 0, i64toi32_i32$1 + 112 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   i64toi32_i32$2 = $17;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $783 = i64toi32_i32$0;
   i64toi32_i32$0 = $10;
   HEAP32[i64toi32_i32$0 >> 2] = $783;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $7;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $786 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 128 | 0) >> 2] = $786;
   HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $13;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $789 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $789;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $6;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $792 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $792;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__arith__Add___add__h93056800a76fa877($7 | 0, i64toi32_i32$1 + 128 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   i64toi32_i32$2 = $12;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $800 = i64toi32_i32$0;
   i64toi32_i32$0 = $10;
   HEAP32[i64toi32_i32$0 >> 2] = $800;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $8;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $803 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 128 | 0) >> 2] = $803;
   HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $17;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $806 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $806;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $7;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $809 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $809;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__bit__BitXor___bitxor__h496945338e6fc19a(i64toi32_i32$1 + 64 | 0 | 0, i64toi32_i32$1 + 128 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   i64toi32_i32$2 = 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102028 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102032 | 0) >> 2] | 0;
   $817 = i64toi32_i32$0;
   i64toi32_i32$0 = $10;
   HEAP32[i64toi32_i32$0 >> 2] = $817;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102020 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102024 | 0) >> 2] | 0;
   $819 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 128 | 0) >> 2] = $819;
   HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102092 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102096 | 0) >> 2] | 0;
   $821 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $821;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102084 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102088 | 0) >> 2] | 0;
   $823 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $823;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__arith__Sub___sub__h31fa90f2b2d1e09f(i64toi32_i32$1 + 80 | 0 | 0, i64toi32_i32$1 + 128 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   i64toi32_i32$2 = $14;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $832 = i64toi32_i32$0;
   i64toi32_i32$0 = $10;
   HEAP32[i64toi32_i32$0 >> 2] = $832;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
   $835 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$1 + 128 | 0) >> 2] = $835;
   HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $15;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $838 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $838;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 80 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 84 | 0) >> 2] | 0;
   $841 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $841;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__bit__Shr___shr__ha0ba11d1f3a547e4(i64toi32_i32$1 + 96 | 0 | 0, i64toi32_i32$1 + 128 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   i64toi32_i32$2 = $14;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $850 = i64toi32_i32$0;
   i64toi32_i32$0 = $10;
   HEAP32[i64toi32_i32$0 >> 2] = $850;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
   $853 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$1 + 128 | 0) >> 2] = $853;
   HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102092 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102096 | 0) >> 2] | 0;
   $855 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $855;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1102084 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1102088 | 0) >> 2] | 0;
   $857 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $857;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__bit__Shl___shl__h81233ff1fb0a7e8f(i64toi32_i32$1 + 112 | 0 | 0, i64toi32_i32$1 + 128 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   i64toi32_i32$2 = $16;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $866 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $866;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 100 | 0) >> 2] | 0;
   $869 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $869;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $cryptoxide__simd__fake__u32x4_20as_20core__ops__bit__BitXor___bitxor__h496945338e6fc19a($8 | 0, i64toi32_i32$1 + 112 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 0);
   $11 = HEAP32[(i64toi32_i32$1 + 48 | 0) >> 2] | 0;
   HEAP32[(i64toi32_i32$1 + 48 | 0) >> 2] = HEAP32[(i64toi32_i32$1 + 52 | 0) >> 2] | 0;
   i64toi32_i32$2 = i64toi32_i32$1;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 56 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$1 + 60 | 0) >> 2] | 0;
   $882 = i64toi32_i32$0;
   i64toi32_i32$0 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$0 + 52 | 0) >> 2] = $882;
   HEAP32[(i64toi32_i32$0 + 56 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[(i64toi32_i32$0 + 60 | 0) >> 2] = $11;
   i64toi32_i32$2 = i64toi32_i32$0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$0 + 36 | 0) >> 2] | 0;
   $19 = i64toi32_i32$1;
   $19$hi = i64toi32_i32$0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] | 0;
   $889 = i64toi32_i32$0;
   i64toi32_i32$0 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] = $889;
   HEAP32[(i64toi32_i32$0 + 36 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $19$hi;
   HEAP32[(i64toi32_i32$0 + 40 | 0) >> 2] = $19;
   HEAP32[(i64toi32_i32$0 + 44 | 0) >> 2] = i64toi32_i32$1;
   $11 = HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] | 0;
   HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] | 0;
   $10 = HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] | 0;
   HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] | 0;
   HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = $10;
   HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = $11;
   $9 = $9 + -1 | 0;
   if ($9) {
    continue label$1
   }
   break label$1;
  };
  $11 = ($1 + 128 | 0) + 8 | 0;
  $14 = $1 + 8 | 0;
  i64toi32_i32$2 = $14;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $916 = i64toi32_i32$1;
  i64toi32_i32$1 = $11;
  HEAP32[i64toi32_i32$1 >> 2] = $916;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $919 = i64toi32_i32$0;
  i64toi32_i32$0 = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$0 + 128 | 0) >> 2] = $919;
  HEAP32[(i64toi32_i32$0 + 132 | 0) >> 2] = i64toi32_i32$1;
  $10 = (i64toi32_i32$0 + 144 | 0) + 8 | 0;
  i64toi32_i32$2 = $0 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $926 = i64toi32_i32$1;
  i64toi32_i32$1 = $10;
  HEAP32[i64toi32_i32$1 >> 2] = $926;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $929 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[(i64toi32_i32$0 + 144 | 0) >> 2] = $929;
  HEAP32[(i64toi32_i32$0 + 148 | 0) >> 2] = i64toi32_i32$1;
  $cryptoxide__simd__fake__u32x4_20as_20core__ops__arith__Add___add__h93056800a76fa877(i64toi32_i32$0 | 0, i64toi32_i32$0 + 128 | 0 | 0, i64toi32_i32$0 + 144 | 0 | 0);
  i64toi32_i32$2 = $8 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $938 = i64toi32_i32$1;
  i64toi32_i32$1 = $11;
  HEAP32[i64toi32_i32$1 >> 2] = $938;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $8;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $941 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[(i64toi32_i32$0 + 128 | 0) >> 2] = $941;
  HEAP32[(i64toi32_i32$0 + 132 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $5 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $945 = i64toi32_i32$1;
  i64toi32_i32$1 = $10;
  HEAP32[i64toi32_i32$1 >> 2] = $945;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $948 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[(i64toi32_i32$0 + 144 | 0) >> 2] = $948;
  HEAP32[(i64toi32_i32$0 + 148 | 0) >> 2] = i64toi32_i32$1;
  $cryptoxide__simd__fake__u32x4_20as_20core__ops__arith__Add___add__h93056800a76fa877($8 | 0, i64toi32_i32$0 + 128 | 0 | 0, i64toi32_i32$0 + 144 | 0 | 0);
  i64toi32_i32$2 = $7 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $957 = i64toi32_i32$1;
  i64toi32_i32$1 = $11;
  HEAP32[i64toi32_i32$1 >> 2] = $957;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $7;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $960 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[(i64toi32_i32$0 + 128 | 0) >> 2] = $960;
  HEAP32[(i64toi32_i32$0 + 132 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $4 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $964 = i64toi32_i32$1;
  i64toi32_i32$1 = $10;
  HEAP32[i64toi32_i32$1 >> 2] = $964;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $967 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[(i64toi32_i32$0 + 144 | 0) >> 2] = $967;
  HEAP32[(i64toi32_i32$0 + 148 | 0) >> 2] = i64toi32_i32$1;
  $cryptoxide__simd__fake__u32x4_20as_20core__ops__arith__Add___add__h93056800a76fa877($7 | 0, i64toi32_i32$0 + 128 | 0 | 0, i64toi32_i32$0 + 144 | 0 | 0);
  i64toi32_i32$2 = $6 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $976 = i64toi32_i32$1;
  i64toi32_i32$1 = $11;
  HEAP32[i64toi32_i32$1 >> 2] = $976;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $6;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $979 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[(i64toi32_i32$0 + 128 | 0) >> 2] = $979;
  HEAP32[(i64toi32_i32$0 + 132 | 0) >> 2] = i64toi32_i32$1;
  $7 = $3 + 8 | 0;
  i64toi32_i32$2 = $7;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $984 = i64toi32_i32$1;
  i64toi32_i32$1 = $10;
  HEAP32[i64toi32_i32$1 >> 2] = $984;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $987 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[(i64toi32_i32$0 + 144 | 0) >> 2] = $987;
  HEAP32[(i64toi32_i32$0 + 148 | 0) >> 2] = i64toi32_i32$1;
  $cryptoxide__simd__fake__u32x4_20as_20core__ops__arith__Add___add__h93056800a76fa877($6 | 0, i64toi32_i32$0 + 128 | 0 | 0, i64toi32_i32$0 + 144 | 0 | 0);
  i64toi32_i32$2 = $14;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$1;
  $19$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $20 = i64toi32_i32$0;
  $20$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  $21$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $22 = i64toi32_i32$0;
  $22$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
  $23 = i64toi32_i32$1;
  $23$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  $24$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] | 0;
  $25 = i64toi32_i32$1;
  $25$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
  $1009 = i64toi32_i32$0;
  i64toi32_i32$0 = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$0 + 200 | 0) >> 2] = $1009;
  HEAP32[(i64toi32_i32$0 + 204 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $25$hi;
  HEAP32[(i64toi32_i32$0 + 192 | 0) >> 2] = $25;
  HEAP32[(i64toi32_i32$0 + 196 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $24$hi;
  HEAP32[(i64toi32_i32$0 + 184 | 0) >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 188 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $23$hi;
  HEAP32[(i64toi32_i32$0 + 176 | 0) >> 2] = $23;
  HEAP32[(i64toi32_i32$0 + 180 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $22$hi;
  HEAP32[(i64toi32_i32$0 + 168 | 0) >> 2] = $22;
  HEAP32[(i64toi32_i32$0 + 172 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $21$hi;
  HEAP32[(i64toi32_i32$0 + 160 | 0) >> 2] = $21;
  HEAP32[(i64toi32_i32$0 + 164 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $19$hi;
  HEAP32[(i64toi32_i32$0 + 152 | 0) >> 2] = $19;
  HEAP32[(i64toi32_i32$0 + 156 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $20$hi;
  HEAP32[(i64toi32_i32$0 + 144 | 0) >> 2] = $20;
  HEAP32[(i64toi32_i32$0 + 148 | 0) >> 2] = i64toi32_i32$1;
  cryptoxide__cryptoutil__write_u32v_le__h0de82ea513fa1e39($0 + 68 | 0 | 0, 64 | 0, i64toi32_i32$0 + 144 | 0 | 0, 16 | 0);
  i64toi32_i32$2 = $7;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $1030 = i64toi32_i32$1;
  i64toi32_i32$1 = $11;
  HEAP32[i64toi32_i32$1 >> 2] = $1030;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $1033 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[(i64toi32_i32$0 + 128 | 0) >> 2] = $1033;
  HEAP32[(i64toi32_i32$0 + 132 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  HEAP32[(i64toi32_i32$0 + 152 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 156 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  HEAP32[(i64toi32_i32$0 + 144 | 0) >> 2] = 1;
  HEAP32[(i64toi32_i32$0 + 148 | 0) >> 2] = i64toi32_i32$1;
  $cryptoxide__simd__fake__u32x4_20as_20core__ops__arith__Add___add__h93056800a76fa877(i64toi32_i32$2 | 0, i64toi32_i32$0 + 128 | 0 | 0, i64toi32_i32$0 + 144 | 0 | 0);
  HEAP32[($0 + 64 | 0) >> 2] = 0;
  global$0 = i64toi32_i32$0 + 208 | 0;
 }
 
 function cardano_serialization_lib__utils__encode_template_to_native_script__h6be814cfb3fcf4a8($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $4 = 0, $6 = 0, $5 = 0, $7 = 0, $49 = 0, $50 = 0, $51 = 0, $52 = 0, $53 = 0, $54 = 0, $55 = 0, $56 = 0, $57 = 0, $58 = 0, $59 = 0, $60 = 0, $61 = 0, $62 = 0, $63 = 0, $64 = 0, $65 = 0, $66 = 0, $67 = 0, $68 = 0, $69 = 0, $70 = 0, $71 = 0, $72 = 0, $73 = 0, $74 = 0, $8 = 0, $220 = 0, $226 = 0, $232 = 0, $235 = 0, $294 = 0, $300 = 0, $306 = 0, $309 = 0, $399 = 0, $405 = 0, $411 = 0, $414 = 0, $446 = 0, $468 = 0, $487 = 0, $530 = 0, $587 = 0, $592 = 0, $597 = 0, $600 = 0, $610 = 0, $614 = 0, $618 = 0, $682 = 0, $695 = 0, $703 = 0, $715 = 0, $753 = 0, $756 = 0, $760 = 0, $765 = 0, $769 = 0, $805 = 0, $808 = 0, $812 = 0, $817 = 0, $821 = 0;
  $3 = global$0 - 352 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           label$10 : {
            label$11 : {
             label$12 : {
              label$13 : {
               label$14 : {
                label$15 : {
                 label$16 : {
                  label$17 : {
                   label$18 : {
                    label$19 : {
                     label$20 : {
                      label$21 : {
                       label$22 : {
                        label$23 : {
                         label$24 : {
                          label$25 : {
                           label$26 : {
                            label$27 : {
                             label$28 : {
                              label$29 : {
                               label$30 : {
                                label$31 : {
                                 switch ((HEAPU8[$1 >> 0] | 0) + -3 | 0 | 0) {
                                 case 0:
                                  $4 = $1 + 4 | 0;
                                  HEAP32[($3 + 108 | 0) >> 2] = $4;
                                  i64toi32_i32$0 = hashbrown__map__make_hash__hea8f199bb15af0f7($2 | 0, $4 | 0) | 0;
                                  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
                                  $8 = i64toi32_i32$0;
                                  $5 = i64toi32_i32$0;
                                  $6 = (HEAP32[($2 + 16 | 0) >> 2] | 0) & i64toi32_i32$0 | 0;
                                  $49 = (HEAP32[($2 + 20 | 0) >> 2] | 0) + $6 | 0;
                                  $1 = HEAPU8[$49 >> 0] | 0 | ((HEAPU8[($49 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($49 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($49 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                  HEAP32[($3 + 248 | 0) >> 2] = 0;
                                  HEAP32[($3 + 252 | 0) >> 2] = $1;
                                  HEAP32[($3 + 244 | 0) >> 2] = $6;
                                  HEAP32[($3 + 240 | 0) >> 2] = $2 + 16 | 0;
                                  $2 = i64toi32_i32$0 >>> 25 | 0;
                                  HEAP8[($3 + 260 | 0) >> 0] = $2;
                                  $1 = $1 ^ Math_imul($2, 16843009) | 0;
                                  HEAP32[($3 + 256 | 0) >> 2] = (($1 ^ -1 | 0) & ($1 + -16843009 | 0) | 0) & -2139062144 | 0;
                                  $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($3 + 72 | 0 | 0, $3 + 240 | 0 | 0);
                                  if (!(HEAP32[($3 + 72 | 0) >> 2] | 0)) {
                                   break label$25
                                  }
                                  $1 = (HEAP32[((HEAP32[($3 + 240 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) + Math_imul(0 - (HEAP32[($3 + 76 | 0) >> 2] | 0) | 0, 24) | 0;
                                  $2 = $T_20as_20core__borrow__Borrow_T____borrow__h9271299964c542f1($1 + -24 | 0 | 0) | 0;
                                  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 64 | 0 | 0, $4 | 0);
                                  $5 = HEAP32[($3 + 68 | 0) >> 2] | 0;
                                  $6 = HEAP32[($3 + 64 | 0) >> 2] | 0;
                                  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 56 | 0 | 0, $2 | 0);
                                  label$34 : {
                                   if (core__slice__cmp___impl_20core__cmp__PartialEq__5bB_5d__20for_20_5bA_5d___eq__hc3de93b036fcc30b($6 | 0, $5 | 0, HEAP32[($3 + 56 | 0) >> 2] | 0 | 0, HEAP32[($3 + 60 | 0) >> 2] | 0 | 0) | 0) {
                                    break label$34
                                   }
                                   label$35 : while (1) {
                                    $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($3 + 48 | 0 | 0, $3 + 240 | 0 | 0);
                                    if (!(HEAP32[($3 + 48 | 0) >> 2] | 0)) {
                                     break label$25
                                    }
                                    $6 = HEAP32[((HEAP32[($3 + 240 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0;
                                    $7 = 0 - (HEAP32[($3 + 52 | 0) >> 2] | 0) | 0;
                                    $1 = $T_20as_20core__borrow__Borrow_T____borrow__h9271299964c542f1(($6 + Math_imul($7, 24) | 0) + -24 | 0 | 0) | 0;
                                    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 40 | 0 | 0, $4 | 0);
                                    $2 = HEAP32[($3 + 44 | 0) >> 2] | 0;
                                    $5 = HEAP32[($3 + 40 | 0) >> 2] | 0;
                                    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 32 | 0 | 0, $1 | 0);
                                    if (!(core__slice__cmp___impl_20core__cmp__PartialEq__5bB_5d__20for_20_5bA_5d___eq__hc3de93b036fcc30b($5 | 0, $2 | 0, HEAP32[($3 + 32 | 0) >> 2] | 0 | 0, HEAP32[($3 + 36 | 0) >> 2] | 0 | 0) | 0)) {
                                     continue label$35
                                    }
                                    break label$35;
                                   };
                                   $1 = $6 + Math_imul($7, 24) | 0;
                                  }
                                  $alloc__vec__Vec_u8__20as_20hex__FromHex___from_hex__hb06fe9f77c382902($3 + 112 | 0 | 0, $1 + -12 | 0 | 0);
                                  $1 = HEAP32[($3 + 116 | 0) >> 2] | 0;
                                  if ((HEAP32[($3 + 112 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                                   break label$23
                                  }
                                  HEAP32[($3 + 316 | 0) >> 2] = HEAP32[($3 + 120 | 0) >> 2] | 0;
                                  HEAP32[($3 + 312 | 0) >> 2] = $1;
                                  i64toi32_i32$0 = $3;
                                  i64toi32_i32$1 = 0;
                                  HEAP32[($3 + 180 | 0) >> 2] = 0;
                                  HEAP32[($3 + 184 | 0) >> 2] = i64toi32_i32$1;
                                  HEAP32[($3 + 176 | 0) >> 2] = HEAP32[(0 + 1057668 | 0) >> 2] | 0;
                                  core__fmt__Formatter__new__he219faf25326051b($3 + 240 | 0 | 0, $3 + 176 | 0 | 0, 1057336 | 0);
                                  if (!($hex__error__FromHexError_20as_20core__fmt__Display___fmt__haa62d686bf8e55c9($3 + 312 | 0 | 0, $3 + 240 | 0 | 0) | 0)) {
                                   break label$24
                                  }
                                  core__result__unwrap_failed__h27f43d993c3864a1(1057360 | 0, 55 | 0, $3 + 344 | 0 | 0, 1057552 | 0, 1057492 | 0);
                                  abort();
                                 case 2:
                                  $1 = $1 + 4 | 0;
                                  if (alloc__collections__btree__map__BTreeMap_K_2cV___get__h1f6710d7f87d2e37($1 | 0, 1058117 | 0, 3 | 0) | 0) {
                                   break label$30
                                  }
                                  if (alloc__collections__btree__map__BTreeMap_K_2cV___get__h1f6710d7f87d2e37($1 | 0, 1058156 | 0, 3 | 0) | 0) {
                                   break label$29
                                  }
                                  if (alloc__collections__btree__map__BTreeMap_K_2cV___get__h1f6710d7f87d2e37($1 | 0, 1058196 | 0, 4 | 0) | 0) {
                                   break label$28
                                  }
                                  if (alloc__collections__btree__map__BTreeMap_K_2cV___get__h1f6710d7f87d2e37($1 | 0, 1058368 | 0, 11 | 0) | 0) {
                                   break label$27
                                  }
                                  if (alloc__collections__btree__map__BTreeMap_K_2cV___get__h1f6710d7f87d2e37($1 | 0, 1058491 | 0, 12 | 0) | 0) {
                                   break label$26
                                  }
                                  break;
                                 default:
                                  break label$31;
                                 };
                                }
                                $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1058617 | 0, 23 | 0) | 0;
                                HEAP32[$0 >> 2] = 1;
                                HEAP32[($0 + 4 | 0) >> 2] = $1;
                                break label$1;
                               }
                               i64toi32_i32$0 = $3;
                               i64toi32_i32$1 = 0;
                               HEAP32[($3 + 316 | 0) >> 2] = 0;
                               HEAP32[($3 + 320 | 0) >> 2] = i64toi32_i32$1;
                               $6 = HEAP32[(0 + 1050204 | 0) >> 2] | 0;
                               HEAP32[($3 + 312 | 0) >> 2] = $6;
                               $1 = alloc__collections__btree__map__BTreeMap_K_2cV___get__h1f6710d7f87d2e37($1 | 0, 1058117 | 0, 3 | 0) | 0;
                               if (!$1) {
                                break label$22
                               }
                               label$36 : {
                                label$37 : {
                                 if ((HEAPU8[$1 >> 0] | 0 | 0) != (4 | 0)) {
                                  break label$37
                                 }
                                 $_alloc__vec__Vec_T_2cA__20as_20core__iter__traits__collect__IntoIterator___into_iter__h770da9f254a2d1a7($3 + 96 | 0 | 0, $1 + 4 | 0 | 0);
                                 $4 = HEAP32[($3 + 96 | 0) >> 2] | 0;
                                 $5 = HEAP32[($3 + 100 | 0) >> 2] | 0;
                                 if (($4 | 0) != ($5 | 0)) {
                                  break label$36
                                 }
                                 $1 = 0;
                                 break label$3;
                                }
                                $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1058136 | 0, 20 | 0) | 0;
                                HEAP32[$0 >> 2] = 1;
                                HEAP32[($0 + 4 | 0) >> 2] = $1;
                                break label$2;
                               }
                               $1 = ($3 + 240 | 0) + 8 | 0;
                               label$38 : {
                                label$39 : while (1) {
                                 cardano_serialization_lib__utils__encode_template_to_native_script__h6be814cfb3fcf4a8($3 + 240 | 0 | 0, $4 | 0, $2 | 0);
                                 if ((HEAP32[($3 + 240 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                                  break label$38
                                 }
                                 i64toi32_i32$2 = $1 + 24 | 0;
                                 i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                 i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                 $220 = i64toi32_i32$1;
                                 i64toi32_i32$1 = ($3 + 112 | 0) + 24 | 0;
                                 HEAP32[i64toi32_i32$1 >> 2] = $220;
                                 HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                                 i64toi32_i32$2 = $1 + 16 | 0;
                                 i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                 i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                 $226 = i64toi32_i32$0;
                                 i64toi32_i32$0 = ($3 + 112 | 0) + 16 | 0;
                                 HEAP32[i64toi32_i32$0 >> 2] = $226;
                                 HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
                                 i64toi32_i32$2 = $1 + 8 | 0;
                                 i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                 i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                 $232 = i64toi32_i32$1;
                                 i64toi32_i32$1 = ($3 + 112 | 0) + 8 | 0;
                                 HEAP32[i64toi32_i32$1 >> 2] = $232;
                                 HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                                 i64toi32_i32$2 = $1;
                                 i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
                                 i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
                                 $235 = i64toi32_i32$0;
                                 i64toi32_i32$0 = $3;
                                 HEAP32[($3 + 112 | 0) >> 2] = $235;
                                 HEAP32[($3 + 116 | 0) >> 2] = i64toi32_i32$1;
                                 cardano_serialization_lib__NativeScripts__add__h12de25bf2c37f302($3 + 312 | 0 | 0, $3 + 112 | 0 | 0);
                                 core__ptr__drop_in_place_cardano_serialization_lib__NativeScript___h75320cd41c3d4d05($3 + 112 | 0 | 0);
                                 $4 = $4 + 24 | 0;
                                 if (($5 | 0) == ($4 | 0)) {
                                  break label$4
                                 }
                                 continue label$39;
                                };
                               }
                               $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($3 + 244 | 0) >> 2] | 0 | 0) | 0;
                               HEAP32[$0 >> 2] = 1;
                               HEAP32[($0 + 4 | 0) >> 2] = $1;
                               break label$2;
                              }
                              i64toi32_i32$0 = $3;
                              i64toi32_i32$1 = 0;
                              HEAP32[($3 + 316 | 0) >> 2] = 0;
                              HEAP32[($3 + 320 | 0) >> 2] = i64toi32_i32$1;
                              $6 = HEAP32[(0 + 1050204 | 0) >> 2] | 0;
                              HEAP32[($3 + 312 | 0) >> 2] = $6;
                              $1 = alloc__collections__btree__map__BTreeMap_K_2cV___get__h1f6710d7f87d2e37($1 | 0, 1058156 | 0, 3 | 0) | 0;
                              if (!$1) {
                               break label$21
                              }
                              label$40 : {
                               label$41 : {
                                if ((HEAPU8[$1 >> 0] | 0 | 0) != (4 | 0)) {
                                 break label$41
                                }
                                $_alloc__vec__Vec_T_2cA__20as_20core__iter__traits__collect__IntoIterator___into_iter__h770da9f254a2d1a7($3 + 88 | 0 | 0, $1 + 4 | 0 | 0);
                                $4 = HEAP32[($3 + 88 | 0) >> 2] | 0;
                                $5 = HEAP32[($3 + 92 | 0) >> 2] | 0;
                                if (($4 | 0) != ($5 | 0)) {
                                 break label$40
                                }
                                $1 = 0;
                                break label$6;
                               }
                               $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1058176 | 0, 20 | 0) | 0;
                               HEAP32[$0 >> 2] = 1;
                               HEAP32[($0 + 4 | 0) >> 2] = $1;
                               break label$5;
                              }
                              $1 = ($3 + 240 | 0) + 8 | 0;
                              label$42 : {
                               label$43 : while (1) {
                                cardano_serialization_lib__utils__encode_template_to_native_script__h6be814cfb3fcf4a8($3 + 240 | 0 | 0, $4 | 0, $2 | 0);
                                if ((HEAP32[($3 + 240 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                                 break label$42
                                }
                                i64toi32_i32$2 = $1 + 24 | 0;
                                i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                $294 = i64toi32_i32$1;
                                i64toi32_i32$1 = ($3 + 112 | 0) + 24 | 0;
                                HEAP32[i64toi32_i32$1 >> 2] = $294;
                                HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                                i64toi32_i32$2 = $1 + 16 | 0;
                                i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                $300 = i64toi32_i32$0;
                                i64toi32_i32$0 = ($3 + 112 | 0) + 16 | 0;
                                HEAP32[i64toi32_i32$0 >> 2] = $300;
                                HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
                                i64toi32_i32$2 = $1 + 8 | 0;
                                i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                $306 = i64toi32_i32$1;
                                i64toi32_i32$1 = ($3 + 112 | 0) + 8 | 0;
                                HEAP32[i64toi32_i32$1 >> 2] = $306;
                                HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                                i64toi32_i32$2 = $1;
                                i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
                                i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
                                $309 = i64toi32_i32$0;
                                i64toi32_i32$0 = $3;
                                HEAP32[($3 + 112 | 0) >> 2] = $309;
                                HEAP32[($3 + 116 | 0) >> 2] = i64toi32_i32$1;
                                cardano_serialization_lib__NativeScripts__add__h12de25bf2c37f302($3 + 312 | 0 | 0, $3 + 112 | 0 | 0);
                                core__ptr__drop_in_place_cardano_serialization_lib__NativeScript___h75320cd41c3d4d05($3 + 112 | 0 | 0);
                                $4 = $4 + 24 | 0;
                                if (($5 | 0) == ($4 | 0)) {
                                 break label$7
                                }
                                continue label$43;
                               };
                              }
                              $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($3 + 244 | 0) >> 2] | 0 | 0) | 0;
                              HEAP32[$0 >> 2] = 1;
                              HEAP32[($0 + 4 | 0) >> 2] = $1;
                              break label$5;
                             }
                             $1 = alloc__collections__btree__map__BTreeMap_K_2cV___get__h1f6710d7f87d2e37($1 | 0, 1058196 | 0, 4 | 0) | 0;
                             if (!$1) {
                              break label$20
                             }
                             if ((HEAPU8[$1 >> 0] | 0 | 0) != (5 | 0)) {
                              break label$19
                             }
                             label$44 : {
                              label$45 : {
                               $1 = $1 + 4 | 0;
                               if (!(alloc__collections__btree__map__BTreeMap_K_2cV___get__h1f6710d7f87d2e37($1 | 0, 1058238 | 0, 8 | 0) | 0)) {
                                break label$45
                               }
                               if (alloc__collections__btree__map__BTreeMap_K_2cV___get__h1f6710d7f87d2e37($1 | 0, 1058246 | 0, 4 | 0) | 0) {
                                break label$44
                               }
                              }
                              $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1058333 | 0, 35 | 0) | 0;
                              HEAP32[$0 >> 2] = 1;
                              HEAP32[($0 + 4 | 0) >> 2] = $1;
                              break label$1;
                             }
                             $4 = alloc__collections__btree__map__BTreeMap_K_2cV___get__h1f6710d7f87d2e37($1 | 0, 1058238 | 0, 8 | 0) | 0;
                             if (!$4) {
                              break label$18
                             }
                             if ((HEAPU8[$4 >> 0] | 0 | 0) != (2 | 0)) {
                              break label$17
                             }
                             i64toi32_i32$2 = $4;
                             i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
                             i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
                             if (!!(i64toi32_i32$1 | i64toi32_i32$0 | 0)) {
                              break label$15
                             }
                             $6 = HEAP32[($4 + 16 | 0) >> 2] | 0;
                             i64toi32_i32$1 = $3;
                             i64toi32_i32$0 = 0;
                             HEAP32[($3 + 316 | 0) >> 2] = 0;
                             HEAP32[($3 + 320 | 0) >> 2] = i64toi32_i32$0;
                             $7 = HEAP32[(0 + 1050204 | 0) >> 2] | 0;
                             HEAP32[($3 + 312 | 0) >> 2] = $7;
                             $1 = alloc__collections__btree__map__BTreeMap_K_2cV___get__h1f6710d7f87d2e37($1 | 0, 1058246 | 0, 4 | 0) | 0;
                             if (!$1) {
                              break label$16
                             }
                             label$46 : {
                              label$47 : {
                               if ((HEAPU8[$1 >> 0] | 0 | 0) != (4 | 0)) {
                                break label$47
                               }
                               $_alloc__vec__Vec_T_2cA__20as_20core__iter__traits__collect__IntoIterator___into_iter__h770da9f254a2d1a7($3 + 80 | 0 | 0, $1 + 4 | 0 | 0);
                               $4 = HEAP32[($3 + 80 | 0) >> 2] | 0;
                               $5 = HEAP32[($3 + 84 | 0) >> 2] | 0;
                               if (($4 | 0) != ($5 | 0)) {
                                break label$46
                               }
                               $2 = 0;
                               break label$9;
                              }
                              $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1058312 | 0, 21 | 0) | 0;
                              HEAP32[$0 >> 2] = 1;
                              HEAP32[($0 + 4 | 0) >> 2] = $1;
                              break label$8;
                             }
                             $1 = ($3 + 240 | 0) + 8 | 0;
                             label$48 : {
                              label$49 : while (1) {
                               cardano_serialization_lib__utils__encode_template_to_native_script__h6be814cfb3fcf4a8($3 + 240 | 0 | 0, $4 | 0, $2 | 0);
                               if ((HEAP32[($3 + 240 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                                break label$48
                               }
                               i64toi32_i32$2 = $1 + 24 | 0;
                               i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                               i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                               $399 = i64toi32_i32$0;
                               i64toi32_i32$0 = ($3 + 112 | 0) + 24 | 0;
                               HEAP32[i64toi32_i32$0 >> 2] = $399;
                               HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
                               i64toi32_i32$2 = $1 + 16 | 0;
                               i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                               i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                               $405 = i64toi32_i32$1;
                               i64toi32_i32$1 = ($3 + 112 | 0) + 16 | 0;
                               HEAP32[i64toi32_i32$1 >> 2] = $405;
                               HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                               i64toi32_i32$2 = $1 + 8 | 0;
                               i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                               i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                               $411 = i64toi32_i32$0;
                               i64toi32_i32$0 = ($3 + 112 | 0) + 8 | 0;
                               HEAP32[i64toi32_i32$0 >> 2] = $411;
                               HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
                               i64toi32_i32$2 = $1;
                               i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
                               i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
                               $414 = i64toi32_i32$1;
                               i64toi32_i32$1 = $3;
                               HEAP32[($3 + 112 | 0) >> 2] = $414;
                               HEAP32[($3 + 116 | 0) >> 2] = i64toi32_i32$0;
                               cardano_serialization_lib__NativeScripts__add__h12de25bf2c37f302($3 + 312 | 0 | 0, $3 + 112 | 0 | 0);
                               core__ptr__drop_in_place_cardano_serialization_lib__NativeScript___h75320cd41c3d4d05($3 + 112 | 0 | 0);
                               $4 = $4 + 24 | 0;
                               if (($5 | 0) == ($4 | 0)) {
                                break label$10
                               }
                               continue label$49;
                              };
                             }
                             $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($3 + 244 | 0) >> 2] | 0 | 0) | 0;
                             HEAP32[$0 >> 2] = 1;
                             HEAP32[($0 + 4 | 0) >> 2] = $1;
                             break label$8;
                            }
                            $1 = alloc__collections__btree__map__BTreeMap_K_2cV___get__h1f6710d7f87d2e37($1 | 0, 1058368 | 0, 11 | 0) | 0;
                            if (!$1) {
                             break label$14
                            }
                            if ((HEAPU8[$1 >> 0] | 0 | 0) != (2 | 0)) {
                             break label$13
                            }
                            label$50 : {
                             i64toi32_i32$2 = $1;
                             i64toi32_i32$0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
                             i64toi32_i32$1 = HEAP32[($1 + 12 | 0) >> 2] | 0;
                             if (!!(i64toi32_i32$0 | i64toi32_i32$1 | 0)) {
                              break label$50
                             }
                             i64toi32_i32$2 = $1;
                             i64toi32_i32$1 = HEAP32[($1 + 16 | 0) >> 2] | 0;
                             i64toi32_i32$0 = HEAP32[($1 + 20 | 0) >> 2] | 0;
                             $446 = i64toi32_i32$1;
                             i64toi32_i32$1 = $0 + 16 | 0;
                             HEAP32[i64toi32_i32$1 >> 2] = $446;
                             HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                             HEAP8[($0 + 8 | 0) >> 0] = 4;
                             HEAP32[$0 >> 2] = 0;
                             break label$1;
                            }
                            $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1058429 | 0, 62 | 0) | 0;
                            HEAP32[$0 >> 2] = 1;
                            HEAP32[($0 + 4 | 0) >> 2] = $1;
                            break label$1;
                           }
                           $1 = alloc__collections__btree__map__BTreeMap_K_2cV___get__h1f6710d7f87d2e37($1 | 0, 1058491 | 0, 12 | 0) | 0;
                           if (!$1) {
                            break label$12
                           }
                           if ((HEAPU8[$1 >> 0] | 0 | 0) != (2 | 0)) {
                            break label$11
                           }
                           label$51 : {
                            i64toi32_i32$2 = $1;
                            i64toi32_i32$0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
                            i64toi32_i32$1 = HEAP32[($1 + 12 | 0) >> 2] | 0;
                            if (!!(i64toi32_i32$0 | i64toi32_i32$1 | 0)) {
                             break label$51
                            }
                            i64toi32_i32$2 = $1;
                            i64toi32_i32$1 = HEAP32[($1 + 16 | 0) >> 2] | 0;
                            i64toi32_i32$0 = HEAP32[($1 + 20 | 0) >> 2] | 0;
                            $468 = i64toi32_i32$1;
                            i64toi32_i32$1 = $0 + 16 | 0;
                            HEAP32[i64toi32_i32$1 >> 2] = $468;
                            HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                            HEAP8[($0 + 8 | 0) >> 0] = 5;
                            HEAP32[$0 >> 2] = 0;
                            break label$1;
                           }
                           $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1058554 | 0, 63 | 0) | 0;
                           HEAP32[$0 >> 2] = 1;
                           HEAP32[($0 + 4 | 0) >> 2] = $1;
                           break label$1;
                          }
                          core__fmt__ArgumentV1__new__h3d5a6d2b66a66ab8($3 + 8 | 0 | 0, $3 + 108 | 0 | 0, 16 | 0);
                          HEAP32[(($3 + 240 | 0) + 20 | 0) >> 2] = 1;
                          i64toi32_i32$1 = $3;
                          i64toi32_i32$0 = 0;
                          HEAP32[($3 + 244 | 0) >> 2] = 2;
                          HEAP32[($3 + 248 | 0) >> 2] = i64toi32_i32$0;
                          HEAP32[($3 + 240 | 0) >> 2] = 1058660;
                          i64toi32_i32$2 = $3;
                          i64toi32_i32$0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
                          i64toi32_i32$1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
                          $487 = i64toi32_i32$0;
                          i64toi32_i32$0 = $3;
                          HEAP32[($3 + 176 | 0) >> 2] = $487;
                          HEAP32[($3 + 180 | 0) >> 2] = i64toi32_i32$1;
                          HEAP32[($3 + 256 | 0) >> 2] = $3 + 176 | 0;
                          alloc__fmt__format__h6e9e003a52c07309($3 + 112 | 0 | 0, $3 + 240 | 0 | 0);
                          $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 | 0, $3 + 112 | 0 | 0);
                          $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[$3 >> 2] | 0 | 0, HEAP32[($3 + 4 | 0) >> 2] | 0 | 0) | 0;
                          HEAP32[$0 >> 2] = 1;
                          HEAP32[($0 + 4 | 0) >> 2] = $1;
                          $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 112 | 0 | 0);
                          $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 112 | 0 | 0);
                          break label$1;
                         }
                         $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 16 | 0 | 0, $3 + 176 | 0 | 0);
                         $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($3 + 16 | 0) >> 2] | 0 | 0, HEAP32[($3 + 20 | 0) >> 2] | 0 | 0) | 0;
                         $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 176 | 0 | 0);
                         $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 176 | 0 | 0);
                         $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($1 | 0) | 0;
                         HEAP32[$0 >> 2] = 1;
                         HEAP32[($0 + 4 | 0) >> 2] = $1;
                         break label$1;
                        }
                        i64toi32_i32$2 = $3;
                        i64toi32_i32$1 = HEAP32[($3 + 120 | 0) >> 2] | 0;
                        i64toi32_i32$0 = HEAP32[($3 + 124 | 0) >> 2] | 0;
                        $530 = i64toi32_i32$1;
                        i64toi32_i32$1 = $3;
                        HEAP32[($3 + 332 | 0) >> 2] = $530;
                        HEAP32[($3 + 336 | 0) >> 2] = i64toi32_i32$0;
                        HEAP32[($3 + 328 | 0) >> 2] = $1;
                        $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 24 | 0 | 0, $3 + 328 | 0 | 0);
                        cardano_serialization_lib__crypto__Bip32PublicKey__from_bytes__h9e2151b5ecc26a5e($3 + 240 | 0 | 0, HEAP32[($3 + 24 | 0) >> 2] | 0 | 0, HEAP32[($3 + 28 | 0) >> 2] | 0 | 0);
                        label$52 : {
                         if ((HEAPU8[($3 + 240 | 0) >> 0] | 0 | 0) == (1 | 0)) {
                          break label$52
                         }
                         HEAP8[($3 + 114 | 0) >> 0] = HEAPU8[($3 + 243 | 0) >> 0] | 0;
                         HEAP16[($3 + 112 | 0) >> 1] = HEAPU8[($3 + 241 | 0) >> 0] | 0 | ((HEAPU8[($3 + 242 | 0) >> 0] | 0) << 8 | 0) | 0;
                         $2 = HEAP32[($3 + 244 | 0) >> 2] | 0;
                         $1 = ($3 + 240 | 0) + 8 | 0;
                         memcpy($3 + 176 | 0 | 0, $1 | 0, 57 | 0) | 0;
                         memcpy($3 + 112 | 0 | 7 | 0 | 0, $3 + 176 | 0 | 0, 57 | 0) | 0;
                         HEAP8[($3 + 115 | 0) >> 0] = $2;
                         HEAP8[($3 + 116 | 0) >> 0] = $2 >>> 8 | 0;
                         HEAP8[($3 + 117 | 0) >> 0] = $2 >>> 16 | 0;
                         HEAP8[($3 + 118 | 0) >> 0] = $2 >>> 24 | 0;
                         $2 = ($3 + 240 | 0) + 24 | 0;
                         i64toi32_i32$1 = $2;
                         i64toi32_i32$0 = 0;
                         HEAP32[i64toi32_i32$1 >> 2] = 0;
                         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                         $4 = ($3 + 240 | 0) + 16 | 0;
                         i64toi32_i32$1 = $4;
                         i64toi32_i32$0 = 0;
                         HEAP32[i64toi32_i32$1 >> 2] = 0;
                         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                         i64toi32_i32$1 = $1;
                         i64toi32_i32$0 = 0;
                         HEAP32[i64toi32_i32$1 >> 2] = 0;
                         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                         i64toi32_i32$1 = $3;
                         i64toi32_i32$0 = 0;
                         HEAP32[($3 + 240 | 0) >> 2] = 0;
                         HEAP32[($3 + 244 | 0) >> 2] = i64toi32_i32$0;
                         ed25519_bip32__key__XPub__get_without_chaincode__h1b3f335862724d9d($3 + 112 | 0 | 0, $3 + 240 | 0 | 0);
                         i64toi32_i32$2 = $2;
                         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                         $587 = i64toi32_i32$0;
                         i64toi32_i32$0 = ($3 + 176 | 0) + 24 | 0;
                         HEAP32[i64toi32_i32$0 >> 2] = $587;
                         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
                         i64toi32_i32$2 = $4;
                         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                         $592 = i64toi32_i32$1;
                         i64toi32_i32$1 = ($3 + 176 | 0) + 16 | 0;
                         HEAP32[i64toi32_i32$1 >> 2] = $592;
                         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                         i64toi32_i32$2 = $1;
                         i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
                         i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
                         $597 = i64toi32_i32$0;
                         i64toi32_i32$0 = ($3 + 176 | 0) + 8 | 0;
                         HEAP32[i64toi32_i32$0 >> 2] = $597;
                         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
                         i64toi32_i32$2 = $3;
                         i64toi32_i32$1 = HEAP32[($3 + 240 | 0) >> 2] | 0;
                         i64toi32_i32$0 = HEAP32[($3 + 244 | 0) >> 2] | 0;
                         $600 = i64toi32_i32$1;
                         i64toi32_i32$1 = $3;
                         HEAP32[($3 + 176 | 0) >> 2] = $600;
                         HEAP32[($3 + 180 | 0) >> 2] = i64toi32_i32$0;
                         cardano_serialization_lib__crypto__PublicKey__hash__hc5c76cad9b10a59a($3 + 240 | 0 | 0, $3 + 176 | 0 | 0);
                         HEAP8[($0 + 8 | 0) >> 0] = 0;
                         HEAP32[$0 >> 2] = 0;
                         i64toi32_i32$2 = $3;
                         i64toi32_i32$0 = HEAPU8[($3 + 240 | 0) >> 0] | 0 | ((HEAPU8[($3 + 241 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 242 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 243 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                         i64toi32_i32$1 = HEAPU8[($3 + 244 | 0) >> 0] | 0 | ((HEAPU8[($3 + 245 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 246 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 247 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                         $610 = i64toi32_i32$0;
                         i64toi32_i32$0 = $0;
                         $50 = $610;
                         HEAP8[(i64toi32_i32$0 + 9 | 0) >> 0] = $50;
                         HEAP8[(i64toi32_i32$0 + 10 | 0) >> 0] = $50 >>> 8 | 0;
                         HEAP8[(i64toi32_i32$0 + 11 | 0) >> 0] = $50 >>> 16 | 0;
                         HEAP8[(i64toi32_i32$0 + 12 | 0) >> 0] = $50 >>> 24 | 0;
                         HEAP8[(i64toi32_i32$0 + 13 | 0) >> 0] = i64toi32_i32$1;
                         HEAP8[(i64toi32_i32$0 + 14 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
                         HEAP8[(i64toi32_i32$0 + 15 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
                         HEAP8[(i64toi32_i32$0 + 16 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
                         i64toi32_i32$2 = $1;
                         i64toi32_i32$1 = HEAPU8[$1 >> 0] | 0 | ((HEAPU8[($1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                         i64toi32_i32$0 = HEAPU8[($1 + 4 | 0) >> 0] | 0 | ((HEAPU8[($1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                         $614 = i64toi32_i32$1;
                         i64toi32_i32$1 = $0 + 17 | 0;
                         $51 = $614;
                         HEAP8[i64toi32_i32$1 >> 0] = $51;
                         HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $51 >>> 8 | 0;
                         HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $51 >>> 16 | 0;
                         HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $51 >>> 24 | 0;
                         HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
                         HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                         HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
                         HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
                         i64toi32_i32$2 = $4;
                         i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                         i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                         $618 = i64toi32_i32$0;
                         i64toi32_i32$0 = $0 + 25 | 0;
                         $52 = $618;
                         HEAP8[i64toi32_i32$0 >> 0] = $52;
                         HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $52 >>> 8 | 0;
                         HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $52 >>> 16 | 0;
                         HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $52 >>> 24 | 0;
                         HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
                         HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
                         HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
                         HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
                         $53 = $0 + 33 | 0;
                         $54 = HEAPU8[$2 >> 0] | 0 | ((HEAPU8[($2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                         HEAP8[$53 >> 0] = $54;
                         HEAP8[($53 + 1 | 0) >> 0] = $54 >>> 8 | 0;
                         HEAP8[($53 + 2 | 0) >> 0] = $54 >>> 16 | 0;
                         HEAP8[($53 + 3 | 0) >> 0] = $54 >>> 24 | 0;
                         $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 328 | 0 | 0);
                         $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 328 | 0 | 0);
                         break label$1;
                        }
                        $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($3 + 244 | 0) >> 2] | 0 | 0) | 0;
                        HEAP32[$0 >> 2] = 1;
                        HEAP32[($0 + 4 | 0) >> 2] = $1;
                        $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 328 | 0 | 0);
                        $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 328 | 0 | 0);
                        break label$1;
                       }
                       core__panicking__panic__h2fd385a887c8bf13(1057508 | 0, 43 | 0, 1058120 | 0);
                       abort();
                      }
                      core__panicking__panic__h2fd385a887c8bf13(1057508 | 0, 43 | 0, 1058160 | 0);
                      abort();
                     }
                     core__panicking__panic__h2fd385a887c8bf13(1057508 | 0, 43 | 0, 1058200 | 0);
                     abort();
                    }
                    $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1058216 | 0, 22 | 0) | 0;
                    HEAP32[$0 >> 2] = 1;
                    HEAP32[($0 + 4 | 0) >> 2] = $1;
                    break label$1;
                   }
                   core__panicking__panic__h2fd385a887c8bf13(1057508 | 0, 43 | 0, 1058252 | 0);
                   abort();
                  }
                  $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1058268 | 0, 27 | 0) | 0;
                  HEAP32[$0 >> 2] = 1;
                  HEAP32[($0 + 4 | 0) >> 2] = $1;
                  break label$1;
                 }
                 core__panicking__panic__h2fd385a887c8bf13(1057508 | 0, 43 | 0, 1058296 | 0);
                 abort();
                }
                $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1058268 | 0, 27 | 0) | 0;
                HEAP32[$0 >> 2] = 1;
                HEAP32[($0 + 4 | 0) >> 2] = $1;
                break label$1;
               }
               core__panicking__panic__h2fd385a887c8bf13(1057508 | 0, 43 | 0, 1058380 | 0);
               abort();
              }
              $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1058396 | 0, 33 | 0) | 0;
              HEAP32[$0 >> 2] = 1;
              HEAP32[($0 + 4 | 0) >> 2] = $1;
              break label$1;
             }
             core__panicking__panic__h2fd385a887c8bf13(1057508 | 0, 43 | 0, 1058504 | 0);
             abort();
            }
            $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1058520 | 0, 34 | 0) | 0;
            HEAP32[$0 >> 2] = 1;
            HEAP32[($0 + 4 | 0) >> 2] = $1;
            break label$1;
           }
           $2 = HEAP32[($3 + 320 | 0) >> 2] | 0;
           $7 = HEAP32[($3 + 312 | 0) >> 2] | 0;
          }
          $1 = $3 + 328 | 0 | 4 | 0;
          alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($1 | 0, $7 | 0, $2 | 0);
          HEAP32[($3 + 328 | 0) >> 2] = $6;
          alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($3 + 176 | 0 | 4 | 0 | 0, HEAP32[($3 + 332 | 0) >> 2] | 0 | 0, HEAP32[($3 + 340 | 0) >> 2] | 0 | 0);
          i64toi32_i32$2 = ($3 + 176 | 0) + 8 | 0;
          i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
          $682 = i64toi32_i32$1;
          i64toi32_i32$1 = $3 + 251 | 0;
          $55 = $682;
          HEAP8[i64toi32_i32$1 >> 0] = $55;
          HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $55 >>> 8 | 0;
          HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $55 >>> 16 | 0;
          HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $55 >>> 24 | 0;
          HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
          HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
          HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
          HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
          $2 = ($3 + 112 | 0) + 15 | 0;
          $56 = ($3 + 240 | 0) + 15 | 0;
          $57 = HEAPU8[$56 >> 0] | 0 | ((HEAPU8[($56 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($56 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($56 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          HEAP8[$2 >> 0] = $57;
          HEAP8[($2 + 1 | 0) >> 0] = $57 >>> 8 | 0;
          HEAP8[($2 + 2 | 0) >> 0] = $57 >>> 16 | 0;
          HEAP8[($2 + 3 | 0) >> 0] = $57 >>> 24 | 0;
          HEAP32[($3 + 176 | 0) >> 2] = $6;
          i64toi32_i32$2 = $3;
          i64toi32_i32$0 = HEAP32[($3 + 176 | 0) >> 2] | 0;
          i64toi32_i32$1 = HEAP32[($3 + 180 | 0) >> 2] | 0;
          $695 = i64toi32_i32$0;
          i64toi32_i32$0 = $3;
          $58 = $695;
          HEAP8[($3 + 243 | 0) >> 0] = $58;
          HEAP8[($3 + 244 | 0) >> 0] = $58 >>> 8 | 0;
          HEAP8[($3 + 245 | 0) >> 0] = $58 >>> 16 | 0;
          HEAP8[($3 + 246 | 0) >> 0] = $58 >>> 24 | 0;
          HEAP8[($3 + 247 | 0) >> 0] = i64toi32_i32$1;
          HEAP8[($3 + 248 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
          HEAP8[($3 + 249 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
          HEAP8[($3 + 250 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
          $4 = ($3 + 112 | 0) + 8 | 0;
          i64toi32_i32$2 = ($3 + 240 | 0) + 8 | 0;
          i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          $703 = i64toi32_i32$1;
          i64toi32_i32$1 = $4;
          HEAP32[i64toi32_i32$1 >> 2] = $703;
          HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
          i64toi32_i32$2 = $3;
          i64toi32_i32$0 = HEAPU8[($3 + 240 | 0) >> 0] | 0 | ((HEAPU8[($3 + 241 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 242 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 243 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          i64toi32_i32$1 = HEAPU8[($3 + 244 | 0) >> 0] | 0 | ((HEAPU8[($3 + 245 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 246 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 247 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          $8 = i64toi32_i32$0;
          i64toi32_i32$0 = $3;
          HEAP32[($3 + 112 | 0) >> 2] = $8;
          HEAP32[($3 + 116 | 0) >> 2] = i64toi32_i32$1;
          HEAP8[($0 + 8 | 0) >> 0] = 3;
          i64toi32_i32$0 = $0;
          $59 = $8;
          HEAP8[(i64toi32_i32$0 + 9 | 0) >> 0] = $59;
          HEAP8[(i64toi32_i32$0 + 10 | 0) >> 0] = $59 >>> 8 | 0;
          HEAP8[(i64toi32_i32$0 + 11 | 0) >> 0] = $59 >>> 16 | 0;
          HEAP8[(i64toi32_i32$0 + 12 | 0) >> 0] = $59 >>> 24 | 0;
          HEAP8[(i64toi32_i32$0 + 13 | 0) >> 0] = i64toi32_i32$1;
          HEAP8[(i64toi32_i32$0 + 14 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
          HEAP8[(i64toi32_i32$0 + 15 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
          HEAP8[(i64toi32_i32$0 + 16 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
          i64toi32_i32$2 = $4;
          i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
          $715 = i64toi32_i32$1;
          i64toi32_i32$1 = $0 + 17 | 0;
          $60 = $715;
          HEAP8[i64toi32_i32$1 >> 0] = $60;
          HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $60 >>> 8 | 0;
          HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $60 >>> 16 | 0;
          HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $60 >>> 24 | 0;
          HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
          HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
          HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
          HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
          $61 = $0 + 24 | 0;
          $62 = HEAPU8[$2 >> 0] | 0 | ((HEAPU8[($2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          HEAP8[$61 >> 0] = $62;
          HEAP8[($61 + 1 | 0) >> 0] = $62 >>> 8 | 0;
          HEAP8[($61 + 2 | 0) >> 0] = $62 >>> 16 | 0;
          HEAP8[($61 + 3 | 0) >> 0] = $62 >>> 24 | 0;
          HEAP32[$0 >> 2] = 0;
          $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc3d6ec99c05cee40($3 + 312 | 0 | 0);
          $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h0f78886c344617d4($3 + 312 | 0 | 0);
          $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc3d6ec99c05cee40($1 | 0);
          $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h0f78886c344617d4($1 | 0);
          break label$1;
         }
         $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc3d6ec99c05cee40($3 + 312 | 0 | 0);
         $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h0f78886c344617d4($3 + 312 | 0 | 0);
         break label$1;
        }
        $1 = HEAP32[($3 + 320 | 0) >> 2] | 0;
        $6 = HEAP32[($3 + 312 | 0) >> 2] | 0;
       }
       alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($3 + 328 | 0 | 0, $6 | 0, $1 | 0);
       alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($3 + 176 | 0 | 0, HEAP32[($3 + 328 | 0) >> 2] | 0 | 0, HEAP32[($3 + 336 | 0) >> 2] | 0 | 0);
       $63 = $3 + 251 | 0;
       $64 = HEAP32[(($3 + 176 | 0) + 8 | 0) >> 2] | 0;
       HEAP8[$63 >> 0] = $64;
       HEAP8[($63 + 1 | 0) >> 0] = $64 >>> 8 | 0;
       HEAP8[($63 + 2 | 0) >> 0] = $64 >>> 16 | 0;
       HEAP8[($63 + 3 | 0) >> 0] = $64 >>> 24 | 0;
       i64toi32_i32$2 = $3;
       i64toi32_i32$0 = HEAP32[($3 + 176 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($3 + 180 | 0) >> 2] | 0;
       $753 = i64toi32_i32$0;
       i64toi32_i32$0 = $3;
       $65 = $753;
       HEAP8[($3 + 243 | 0) >> 0] = $65;
       HEAP8[($3 + 244 | 0) >> 0] = $65 >>> 8 | 0;
       HEAP8[($3 + 245 | 0) >> 0] = $65 >>> 16 | 0;
       HEAP8[($3 + 246 | 0) >> 0] = $65 >>> 24 | 0;
       HEAP8[($3 + 247 | 0) >> 0] = i64toi32_i32$1;
       HEAP8[($3 + 248 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
       HEAP8[($3 + 249 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
       HEAP8[($3 + 250 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
       i64toi32_i32$2 = $3;
       i64toi32_i32$1 = HEAPU8[($3 + 240 | 0) >> 0] | 0 | ((HEAPU8[($3 + 241 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 242 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 243 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[($3 + 244 | 0) >> 0] | 0 | ((HEAPU8[($3 + 245 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 246 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 247 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $756 = i64toi32_i32$1;
       i64toi32_i32$1 = $3;
       HEAP32[($3 + 112 | 0) >> 2] = $756;
       HEAP32[($3 + 116 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = $3 + 247 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $760 = i64toi32_i32$0;
       i64toi32_i32$0 = $3;
       $66 = $760;
       HEAP8[($3 + 119 | 0) >> 0] = $66;
       HEAP8[($3 + 120 | 0) >> 0] = $66 >>> 8 | 0;
       HEAP8[($3 + 121 | 0) >> 0] = $66 >>> 16 | 0;
       HEAP8[($3 + 122 | 0) >> 0] = $66 >>> 24 | 0;
       HEAP8[($3 + 123 | 0) >> 0] = i64toi32_i32$1;
       HEAP8[($3 + 124 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
       HEAP8[($3 + 125 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
       HEAP8[($3 + 126 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
       HEAP8[($0 + 8 | 0) >> 0] = 2;
       i64toi32_i32$2 = $3;
       i64toi32_i32$1 = HEAP32[($3 + 112 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[($3 + 116 | 0) >> 2] | 0;
       $765 = i64toi32_i32$1;
       i64toi32_i32$1 = $0;
       $67 = $765;
       HEAP8[(i64toi32_i32$1 + 9 | 0) >> 0] = $67;
       HEAP8[(i64toi32_i32$1 + 10 | 0) >> 0] = $67 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 11 | 0) >> 0] = $67 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 12 | 0) >> 0] = $67 >>> 24 | 0;
       HEAP8[(i64toi32_i32$1 + 13 | 0) >> 0] = i64toi32_i32$0;
       HEAP8[(i64toi32_i32$1 + 14 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 15 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 16 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
       i64toi32_i32$2 = $3;
       i64toi32_i32$0 = HEAPU8[($3 + 119 | 0) >> 0] | 0 | ((HEAPU8[($3 + 120 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 121 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 122 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[($3 + 123 | 0) >> 0] | 0 | ((HEAPU8[($3 + 124 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 125 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 126 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $769 = i64toi32_i32$0;
       i64toi32_i32$0 = $0 + 16 | 0;
       $68 = $769;
       HEAP8[i64toi32_i32$0 >> 0] = $68;
       HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $68 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $68 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $68 >>> 24 | 0;
       HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
       HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
       HEAP32[$0 >> 2] = 0;
       $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc3d6ec99c05cee40($3 + 312 | 0 | 0);
       $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h0f78886c344617d4($3 + 312 | 0 | 0);
       $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc3d6ec99c05cee40($3 + 328 | 0 | 0);
       $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h0f78886c344617d4($3 + 328 | 0 | 0);
       break label$1;
      }
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc3d6ec99c05cee40($3 + 312 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h0f78886c344617d4($3 + 312 | 0 | 0);
      break label$1;
     }
     $1 = HEAP32[($3 + 320 | 0) >> 2] | 0;
     $6 = HEAP32[($3 + 312 | 0) >> 2] | 0;
    }
    alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($3 + 328 | 0 | 0, $6 | 0, $1 | 0);
    alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($3 + 176 | 0 | 0, HEAP32[($3 + 328 | 0) >> 2] | 0 | 0, HEAP32[($3 + 336 | 0) >> 2] | 0 | 0);
    $69 = $3 + 251 | 0;
    $70 = HEAP32[(($3 + 176 | 0) + 8 | 0) >> 2] | 0;
    HEAP8[$69 >> 0] = $70;
    HEAP8[($69 + 1 | 0) >> 0] = $70 >>> 8 | 0;
    HEAP8[($69 + 2 | 0) >> 0] = $70 >>> 16 | 0;
    HEAP8[($69 + 3 | 0) >> 0] = $70 >>> 24 | 0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAP32[($3 + 176 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($3 + 180 | 0) >> 2] | 0;
    $805 = i64toi32_i32$1;
    i64toi32_i32$1 = $3;
    $71 = $805;
    HEAP8[($3 + 243 | 0) >> 0] = $71;
    HEAP8[($3 + 244 | 0) >> 0] = $71 >>> 8 | 0;
    HEAP8[($3 + 245 | 0) >> 0] = $71 >>> 16 | 0;
    HEAP8[($3 + 246 | 0) >> 0] = $71 >>> 24 | 0;
    HEAP8[($3 + 247 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[($3 + 248 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[($3 + 249 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[($3 + 250 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAPU8[($3 + 240 | 0) >> 0] | 0 | ((HEAPU8[($3 + 241 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 242 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 243 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[($3 + 244 | 0) >> 0] | 0 | ((HEAPU8[($3 + 245 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 246 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 247 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $808 = i64toi32_i32$0;
    i64toi32_i32$0 = $3;
    HEAP32[($3 + 112 | 0) >> 2] = $808;
    HEAP32[($3 + 116 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $3 + 247 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $812 = i64toi32_i32$1;
    i64toi32_i32$1 = $3;
    $72 = $812;
    HEAP8[($3 + 119 | 0) >> 0] = $72;
    HEAP8[($3 + 120 | 0) >> 0] = $72 >>> 8 | 0;
    HEAP8[($3 + 121 | 0) >> 0] = $72 >>> 16 | 0;
    HEAP8[($3 + 122 | 0) >> 0] = $72 >>> 24 | 0;
    HEAP8[($3 + 123 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[($3 + 124 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[($3 + 125 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[($3 + 126 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    HEAP8[($0 + 8 | 0) >> 0] = 1;
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAP32[($3 + 112 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($3 + 116 | 0) >> 2] | 0;
    $817 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    $73 = $817;
    HEAP8[(i64toi32_i32$0 + 9 | 0) >> 0] = $73;
    HEAP8[(i64toi32_i32$0 + 10 | 0) >> 0] = $73 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 11 | 0) >> 0] = $73 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 12 | 0) >> 0] = $73 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 13 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 14 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 15 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 16 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAPU8[($3 + 119 | 0) >> 0] | 0 | ((HEAPU8[($3 + 120 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 121 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 122 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[($3 + 123 | 0) >> 0] | 0 | ((HEAPU8[($3 + 124 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 125 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 126 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $821 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 16 | 0;
    $74 = $821;
    HEAP8[i64toi32_i32$1 >> 0] = $74;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $74 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $74 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $74 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    HEAP32[$0 >> 2] = 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc3d6ec99c05cee40($3 + 312 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h0f78886c344617d4($3 + 312 | 0 | 0);
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc3d6ec99c05cee40($3 + 328 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h0f78886c344617d4($3 + 328 | 0 | 0);
    break label$1;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc3d6ec99c05cee40($3 + 312 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h0f78886c344617d4($3 + 312 | 0 | 0);
  }
  global$0 = $3 + 352 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__ProtocolParamUpdate___serialize__h38e4d9be5dcfac79($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$4 = 0, i64toi32_i32$0 = 0, $3 = 0, i64toi32_i32$3 = 0, i64toi32_i32$2 = 0, i64toi32_i32$5 = 0, i64toi32_i32$1 = 0, $4 = 0, $5 = 0, $9 = 0, $10 = 0, $12 = 0, $12$hi = 0, $14 = 0, $14$hi = 0, $15$hi = 0, $17 = 0, $17$hi = 0, $18$hi = 0, $20 = 0, $20$hi = 0, $21$hi = 0, $23 = 0, $23$hi = 0, $24$hi = 0, $26 = 0, $26$hi = 0, $27$hi = 0, $29 = 0, $29$hi = 0, $30$hi = 0, $32 = 0, $32$hi = 0, $33$hi = 0, $35 = 0, $35$hi = 0, $36$hi = 0, $38 = 0, $38$hi = 0, $39$hi = 0, $41 = 0, $41$hi = 0, $42$hi = 0, $44 = 0, $44$hi = 0, $45$hi = 0, $47 = 0, $47$hi = 0, $48$hi = 0, $52$hi = 0, $53$hi = 0, $55 = 0, $55$hi = 0, $56$hi = 0, $60$hi = 0, $61$hi = 0, $63 = 0, $63$hi = 0, $64$hi = 0, $66 = 0, $66$hi = 0, $67$hi = 0, $69 = 0, $69$hi = 0, $70$hi = 0, $72 = 0, $72$hi = 0, $73$hi = 0, $75 = 0, $75$hi = 0, $76$hi = 0, $78 = 0, $78$hi = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  $9 = $3;
  $10 = $2;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $12 = i64toi32_i32$0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$1;
  $14$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$2 = $12;
  i64toi32_i32$1 = $14$hi;
  i64toi32_i32$3 = $14;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $15$hi = i64toi32_i32$5;
  i64toi32_i32$0 = $1;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 280 | 0) >> 2] | 0;
  i64toi32_i32$2 = 0;
  $17 = i64toi32_i32$5;
  $17$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $15$hi;
  i64toi32_i32$0 = i64toi32_i32$4;
  i64toi32_i32$5 = $17$hi;
  i64toi32_i32$3 = $17;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $18$hi = i64toi32_i32$4;
  i64toi32_i32$2 = $1;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$2 + 288 | 0) >> 2] | 0;
  i64toi32_i32$0 = 0;
  $20 = i64toi32_i32$4;
  $20$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $18$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$4 = $20$hi;
  i64toi32_i32$3 = $20;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $21$hi = i64toi32_i32$1;
  i64toi32_i32$0 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 296 | 0) >> 2] | 0;
  i64toi32_i32$2 = 0;
  $23 = i64toi32_i32$1;
  $23$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $21$hi;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$1 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $24$hi = i64toi32_i32$5;
  i64toi32_i32$2 = $1;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
  $26 = i64toi32_i32$5;
  $26$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $24$hi;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$5 = $26$hi;
  i64toi32_i32$3 = $26;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $27$hi = i64toi32_i32$4;
  i64toi32_i32$0 = $1;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 48 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 52 | 0) >> 2] | 0;
  $29 = i64toi32_i32$4;
  $29$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $27$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$4 = $29$hi;
  i64toi32_i32$3 = $29;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $30$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 304 | 0) >> 2] | 0;
  i64toi32_i32$0 = 0;
  $32 = i64toi32_i32$1;
  $32$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $30$hi;
  i64toi32_i32$2 = i64toi32_i32$5;
  i64toi32_i32$1 = $32$hi;
  i64toi32_i32$3 = $32;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $33$hi = i64toi32_i32$5;
  i64toi32_i32$0 = $1;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 312 | 0) >> 2] | 0;
  i64toi32_i32$2 = 0;
  $35 = i64toi32_i32$5;
  $35$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $33$hi;
  i64toi32_i32$0 = i64toi32_i32$4;
  i64toi32_i32$5 = $35$hi;
  i64toi32_i32$3 = $35;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $36$hi = i64toi32_i32$4;
  i64toi32_i32$2 = $1;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
  $38 = i64toi32_i32$4;
  $38$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $36$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$4 = $38$hi;
  i64toi32_i32$3 = $38;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $39$hi = i64toi32_i32$1;
  i64toi32_i32$0 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 88 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 92 | 0) >> 2] | 0;
  $41 = i64toi32_i32$1;
  $41$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $39$hi;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$1 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $42$hi = i64toi32_i32$5;
  i64toi32_i32$2 = $1;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$2 + 112 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 116 | 0) >> 2] | 0;
  $44 = i64toi32_i32$5;
  $44$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $42$hi;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$5 = $44$hi;
  i64toi32_i32$3 = $44;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $45$hi = i64toi32_i32$4;
  i64toi32_i32$0 = $1;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 136 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 140 | 0) >> 2] | 0;
  $47 = i64toi32_i32$4;
  $47$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $45$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$4 = $47$hi;
  i64toi32_i32$3 = $47;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $48$hi = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  $52$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $48$hi;
  i64toi32_i32$2 = i64toi32_i32$5;
  i64toi32_i32$0 = $52$hi;
  i64toi32_i32$3 = (HEAPU8[($1 + 372 | 0) >> 0] | 0 | 0) != (2 | 0);
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $53$hi = i64toi32_i32$5;
  i64toi32_i32$1 = $1;
  i64toi32_i32$5 = HEAP32[($1 + 160 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[($1 + 164 | 0) >> 2] | 0;
  $55 = i64toi32_i32$5;
  $55$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $53$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$5 = $55$hi;
  i64toi32_i32$3 = $55;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $56$hi = i64toi32_i32$4;
  i64toi32_i32$4 = 0;
  $60$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $56$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$1 = $60$hi;
  i64toi32_i32$3 = (HEAP32[($1 + 320 | 0) >> 2] | 0 | 0) != (0 | 0);
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $61$hi = i64toi32_i32$0;
  i64toi32_i32$4 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 176 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 180 | 0) >> 2] | 0;
  $63 = i64toi32_i32$0;
  $63$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $61$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$0 = $63$hi;
  i64toi32_i32$3 = $63;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $64$hi = i64toi32_i32$5;
  i64toi32_i32$2 = $1;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$2 + 332 | 0) >> 2] | 0;
  i64toi32_i32$4 = 0;
  $66 = i64toi32_i32$5;
  $66$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $64$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$5 = $66$hi;
  i64toi32_i32$3 = $66;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $67$hi = i64toi32_i32$1;
  i64toi32_i32$4 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$4 + 192 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 196 | 0) >> 2] | 0;
  $69 = i64toi32_i32$1;
  $69$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $67$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$1 = $69$hi;
  i64toi32_i32$3 = $69;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $70$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 232 | 0) >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$2 + 236 | 0) >> 2] | 0;
  $72 = i64toi32_i32$0;
  $72$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $70$hi;
  i64toi32_i32$2 = i64toi32_i32$5;
  i64toi32_i32$0 = $72$hi;
  i64toi32_i32$3 = $72;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $73$hi = i64toi32_i32$5;
  i64toi32_i32$4 = $1;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 256 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 260 | 0) >> 2] | 0;
  $75 = i64toi32_i32$5;
  $75$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $73$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$5 = $75$hi;
  i64toi32_i32$3 = $75;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $76$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 348 | 0) >> 2] | 0;
  i64toi32_i32$4 = 0;
  $78 = i64toi32_i32$1;
  $78$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $76$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$1 = $78$hi;
  i64toi32_i32$3 = $78;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($9 | 0, $10 | 0, 5 | 0, i64toi32_i32$5 | 0, i64toi32_i32$0 | 0);
  $4 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           label$10 : {
            label$11 : {
             label$12 : {
              label$13 : {
               label$14 : {
                label$15 : {
                 label$16 : {
                  label$17 : {
                   label$18 : {
                    label$19 : {
                     label$20 : {
                      label$21 : {
                       label$22 : {
                        label$23 : {
                         label$24 : {
                          label$25 : {
                           label$26 : {
                            label$27 : {
                             label$28 : {
                              label$29 : {
                               label$30 : {
                                label$31 : {
                                 label$32 : {
                                  label$33 : {
                                   label$34 : {
                                    label$35 : {
                                     label$36 : {
                                      label$37 : {
                                       label$38 : {
                                        label$39 : {
                                         label$40 : {
                                          label$41 : {
                                           label$42 : {
                                            label$43 : {
                                             label$44 : {
                                              label$45 : {
                                               label$46 : {
                                                label$47 : {
                                                 label$48 : {
                                                  label$49 : {
                                                   label$50 : {
                                                    if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                     break label$50
                                                    }
                                                    label$51 : {
                                                     i64toi32_i32$4 = $1;
                                                     i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
                                                     i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
                                                     i64toi32_i32$4 = i64toi32_i32$0;
                                                     i64toi32_i32$0 = 0;
                                                     i64toi32_i32$3 = 1;
                                                     if ((i64toi32_i32$4 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$0 | 0) | 0) {
                                                      break label$51
                                                     }
                                                     i64toi32_i32$4 = 0;
                                                     cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 0 | 0, i64toi32_i32$4 | 0);
                                                     $4 = 1;
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$49
                                                     }
                                                     i64toi32_i32$3 = $1;
                                                     i64toi32_i32$4 = HEAP32[(i64toi32_i32$3 + 8 | 0) >> 2] | 0;
                                                     i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 12 | 0) >> 2] | 0;
                                                     cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, i64toi32_i32$4 | 0, i64toi32_i32$2 | 0);
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$48
                                                     }
                                                    }
                                                    label$52 : {
                                                     i64toi32_i32$3 = $1;
                                                     i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 16 | 0) >> 2] | 0;
                                                     i64toi32_i32$4 = HEAP32[(i64toi32_i32$3 + 20 | 0) >> 2] | 0;
                                                     i64toi32_i32$3 = i64toi32_i32$2;
                                                     i64toi32_i32$2 = 0;
                                                     i64toi32_i32$0 = 1;
                                                     if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$4 | 0) != (i64toi32_i32$2 | 0) | 0) {
                                                      break label$52
                                                     }
                                                     i64toi32_i32$3 = 0;
                                                     cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 1 | 0, i64toi32_i32$3 | 0);
                                                     $4 = 1;
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$47
                                                     }
                                                     i64toi32_i32$0 = $1 + 24 | 0;
                                                     i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                     i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                     cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, i64toi32_i32$3 | 0, i64toi32_i32$4 | 0);
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$46
                                                     }
                                                    }
                                                    label$53 : {
                                                     if ((HEAP32[($1 + 280 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                                                      break label$53
                                                     }
                                                     i64toi32_i32$4 = 0;
                                                     cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 2 | 0, i64toi32_i32$4 | 0);
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$45
                                                     }
                                                     i64toi32_i32$0 = $1 + 284 | 0;
                                                     i64toi32_i32$4 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                     i64toi32_i32$3 = 0;
                                                     cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, i64toi32_i32$4 | 0, i64toi32_i32$3 | 0);
                                                     $4 = 1;
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$44
                                                     }
                                                    }
                                                    label$54 : {
                                                     if ((HEAP32[($1 + 288 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                                                      break label$54
                                                     }
                                                     i64toi32_i32$3 = 0;
                                                     cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 3 | 0, i64toi32_i32$3 | 0);
                                                     $4 = 1;
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$43
                                                     }
                                                     i64toi32_i32$0 = $1 + 292 | 0;
                                                     i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                     i64toi32_i32$4 = 0;
                                                     cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, i64toi32_i32$3 | 0, i64toi32_i32$4 | 0);
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$42
                                                     }
                                                    }
                                                    label$55 : {
                                                     if ((HEAP32[($1 + 296 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                                                      break label$55
                                                     }
                                                     i64toi32_i32$4 = 0;
                                                     cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 4 | 0, i64toi32_i32$4 | 0);
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$41
                                                     }
                                                     i64toi32_i32$0 = $1 + 300 | 0;
                                                     i64toi32_i32$4 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                     i64toi32_i32$3 = 0;
                                                     cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, i64toi32_i32$4 | 0, i64toi32_i32$3 | 0);
                                                     $4 = 1;
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$40
                                                     }
                                                    }
                                                    label$56 : {
                                                     i64toi32_i32$0 = $1;
                                                     i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] | 0;
                                                     i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 36 | 0) >> 2] | 0;
                                                     i64toi32_i32$0 = i64toi32_i32$3;
                                                     i64toi32_i32$3 = 0;
                                                     i64toi32_i32$2 = 1;
                                                     if ((i64toi32_i32$0 | 0) != (i64toi32_i32$2 | 0) | (i64toi32_i32$4 | 0) != (i64toi32_i32$3 | 0) | 0) {
                                                      break label$56
                                                     }
                                                     i64toi32_i32$0 = 0;
                                                     cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 5 | 0, i64toi32_i32$0 | 0);
                                                     $4 = 1;
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$39
                                                     }
                                                     i64toi32_i32$2 = $1 + 40 | 0;
                                                     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                                     i64toi32_i32$4 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                                     cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, i64toi32_i32$0 | 0, i64toi32_i32$4 | 0);
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$38
                                                     }
                                                    }
                                                    label$57 : {
                                                     i64toi32_i32$2 = $1;
                                                     i64toi32_i32$4 = HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] | 0;
                                                     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] | 0;
                                                     i64toi32_i32$2 = i64toi32_i32$4;
                                                     i64toi32_i32$4 = 0;
                                                     i64toi32_i32$3 = 1;
                                                     if ((i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$4 | 0) | 0) {
                                                      break label$57
                                                     }
                                                     i64toi32_i32$2 = 0;
                                                     cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 6 | 0, i64toi32_i32$2 | 0);
                                                     $4 = 1;
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$37
                                                     }
                                                     i64toi32_i32$3 = $1 + 56 | 0;
                                                     i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                                     i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                                     cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, i64toi32_i32$2 | 0, i64toi32_i32$0 | 0);
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$36
                                                     }
                                                    }
                                                    label$58 : {
                                                     if ((HEAP32[($1 + 304 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                                                      break label$58
                                                     }
                                                     i64toi32_i32$0 = 0;
                                                     cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 7 | 0, i64toi32_i32$0 | 0);
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$35
                                                     }
                                                     i64toi32_i32$3 = $1 + 308 | 0;
                                                     i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                                     i64toi32_i32$2 = 0;
                                                     cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, i64toi32_i32$0 | 0, i64toi32_i32$2 | 0);
                                                     $4 = 1;
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$34
                                                     }
                                                    }
                                                    label$59 : {
                                                     if ((HEAP32[($1 + 312 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                                                      break label$59
                                                     }
                                                     i64toi32_i32$2 = 0;
                                                     cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 8 | 0, i64toi32_i32$2 | 0);
                                                     $4 = 1;
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$33
                                                     }
                                                     i64toi32_i32$3 = $1 + 316 | 0;
                                                     i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                                     i64toi32_i32$0 = 0;
                                                     cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, i64toi32_i32$2 | 0, i64toi32_i32$0 | 0);
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$32
                                                     }
                                                    }
                                                    label$60 : {
                                                     i64toi32_i32$3 = $1;
                                                     i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 64 | 0) >> 2] | 0;
                                                     i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 68 | 0) >> 2] | 0;
                                                     i64toi32_i32$3 = i64toi32_i32$0;
                                                     i64toi32_i32$0 = 0;
                                                     i64toi32_i32$4 = 1;
                                                     if ((i64toi32_i32$3 | 0) != (i64toi32_i32$4 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$0 | 0) | 0) {
                                                      break label$60
                                                     }
                                                     i64toi32_i32$3 = 0;
                                                     cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 9 | 0, i64toi32_i32$3 | 0);
                                                     $4 = 1;
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$31
                                                     }
                                                     cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__UnitInterval___serialize__h073d853696277759($3 | 0, $1 + 72 | 0 | 0, $2 | 0);
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$30
                                                     }
                                                    }
                                                    label$61 : {
                                                     i64toi32_i32$4 = $1;
                                                     i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 88 | 0) >> 2] | 0;
                                                     i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 92 | 0) >> 2] | 0;
                                                     i64toi32_i32$4 = i64toi32_i32$3;
                                                     i64toi32_i32$3 = 0;
                                                     i64toi32_i32$0 = 1;
                                                     if ((i64toi32_i32$4 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | 0) {
                                                      break label$61
                                                     }
                                                     i64toi32_i32$4 = 0;
                                                     cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 10 | 0, i64toi32_i32$4 | 0);
                                                     $4 = 1;
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$29
                                                     }
                                                     cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__UnitInterval___serialize__h073d853696277759($3 | 0, $1 + 96 | 0 | 0, $2 | 0);
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$28
                                                     }
                                                    }
                                                    label$62 : {
                                                     i64toi32_i32$0 = $1;
                                                     i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 112 | 0) >> 2] | 0;
                                                     i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 116 | 0) >> 2] | 0;
                                                     i64toi32_i32$0 = i64toi32_i32$4;
                                                     i64toi32_i32$4 = 0;
                                                     i64toi32_i32$3 = 1;
                                                     if ((i64toi32_i32$0 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$4 | 0) | 0) {
                                                      break label$62
                                                     }
                                                     i64toi32_i32$0 = 0;
                                                     cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 11 | 0, i64toi32_i32$0 | 0);
                                                     $4 = 1;
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$27
                                                     }
                                                     cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__UnitInterval___serialize__h073d853696277759($3 | 0, $1 + 120 | 0 | 0, $2 | 0);
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$26
                                                     }
                                                    }
                                                    label$63 : {
                                                     i64toi32_i32$3 = $1;
                                                     i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 136 | 0) >> 2] | 0;
                                                     i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 140 | 0) >> 2] | 0;
                                                     i64toi32_i32$3 = i64toi32_i32$0;
                                                     i64toi32_i32$0 = 0;
                                                     i64toi32_i32$4 = 1;
                                                     if ((i64toi32_i32$3 | 0) != (i64toi32_i32$4 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$0 | 0) | 0) {
                                                      break label$63
                                                     }
                                                     i64toi32_i32$3 = 0;
                                                     cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 12 | 0, i64toi32_i32$3 | 0);
                                                     $4 = 1;
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$25
                                                     }
                                                     cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__UnitInterval___serialize__h073d853696277759($3 | 0, $1 + 144 | 0 | 0, $2 | 0);
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$24
                                                     }
                                                    }
                                                    label$64 : {
                                                     $5 = $1 + 372 | 0;
                                                     if ((HEAPU8[$5 >> 0] | 0 | 0) == (2 | 0)) {
                                                      break label$64
                                                     }
                                                     i64toi32_i32$3 = 0;
                                                     cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 13 | 0, i64toi32_i32$3 | 0);
                                                     $4 = 1;
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$23
                                                     }
                                                     $cardano_serialization_lib__crypto__Nonce_20as_20cbor_event__se__Serialize___serialize__hd28efbdff8e194e3($3 | 0, $5 | 0, $2 | 0);
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$22
                                                     }
                                                    }
                                                    label$65 : {
                                                     $5 = $1 + 320 | 0;
                                                     if (!(HEAP32[$5 >> 2] | 0)) {
                                                      break label$65
                                                     }
                                                     i64toi32_i32$3 = 0;
                                                     cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 14 | 0, i64toi32_i32$3 | 0);
                                                     $4 = 1;
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$21
                                                     }
                                                     cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__ProtocolVersions___serialize__h93b9b5b740a5eb75($3 | 0, $5 | 0, $2 | 0);
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$20
                                                     }
                                                    }
                                                    label$66 : {
                                                     i64toi32_i32$4 = $1;
                                                     i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 160 | 0) >> 2] | 0;
                                                     i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 164 | 0) >> 2] | 0;
                                                     i64toi32_i32$4 = i64toi32_i32$3;
                                                     i64toi32_i32$3 = 0;
                                                     i64toi32_i32$0 = 1;
                                                     if ((i64toi32_i32$4 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | 0) {
                                                      break label$66
                                                     }
                                                     i64toi32_i32$4 = 0;
                                                     cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 16 | 0, i64toi32_i32$4 | 0);
                                                     $4 = 1;
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$19
                                                     }
                                                     i64toi32_i32$0 = $1 + 168 | 0;
                                                     i64toi32_i32$4 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                                     i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                                     cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, i64toi32_i32$4 | 0, i64toi32_i32$2 | 0);
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$18
                                                     }
                                                    }
                                                    label$67 : {
                                                     i64toi32_i32$0 = $1;
                                                     i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 176 | 0) >> 2] | 0;
                                                     i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 180 | 0) >> 2] | 0;
                                                     i64toi32_i32$0 = i64toi32_i32$2;
                                                     i64toi32_i32$2 = 0;
                                                     i64toi32_i32$3 = 1;
                                                     if ((i64toi32_i32$0 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$4 | 0) != (i64toi32_i32$2 | 0) | 0) {
                                                      break label$67
                                                     }
                                                     i64toi32_i32$0 = 0;
                                                     cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 17 | 0, i64toi32_i32$0 | 0);
                                                     $4 = 1;
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$17
                                                     }
                                                     i64toi32_i32$3 = $1 + 184 | 0;
                                                     i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                                     i64toi32_i32$4 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                                     cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, i64toi32_i32$0 | 0, i64toi32_i32$4 | 0);
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$16
                                                     }
                                                    }
                                                    label$68 : {
                                                     if ((HEAP32[($1 + 332 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                                                      break label$68
                                                     }
                                                     i64toi32_i32$4 = 0;
                                                     cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 18 | 0, i64toi32_i32$4 | 0);
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$15
                                                     }
                                                     $cardano_serialization_lib__plutus__Costmdls_20as_20cbor_event__se__Serialize___serialize__h651d2db00a62edc7($3 | 0, $1 + 336 | 0 | 0, $2 | 0);
                                                     $4 = 1;
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$14
                                                     }
                                                    }
                                                    label$69 : {
                                                     i64toi32_i32$3 = $1;
                                                     i64toi32_i32$4 = HEAP32[(i64toi32_i32$3 + 192 | 0) >> 2] | 0;
                                                     i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 196 | 0) >> 2] | 0;
                                                     i64toi32_i32$3 = i64toi32_i32$4;
                                                     i64toi32_i32$4 = 0;
                                                     i64toi32_i32$2 = 1;
                                                     if ((i64toi32_i32$3 | 0) != (i64toi32_i32$2 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$4 | 0) | 0) {
                                                      break label$69
                                                     }
                                                     i64toi32_i32$3 = 0;
                                                     cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 19 | 0, i64toi32_i32$3 | 0);
                                                     $4 = 1;
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$13
                                                     }
                                                     $cardano_serialization_lib__plutus__ExUnitPrices_20as_20cbor_event__se__Serialize___serialize__h10c0ac919a9d373a($3 | 0, $1 + 200 | 0 | 0, $2 | 0);
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$12
                                                     }
                                                    }
                                                    label$70 : {
                                                     i64toi32_i32$2 = $1;
                                                     i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 232 | 0) >> 2] | 0;
                                                     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 236 | 0) >> 2] | 0;
                                                     i64toi32_i32$2 = i64toi32_i32$3;
                                                     i64toi32_i32$3 = 0;
                                                     i64toi32_i32$4 = 1;
                                                     if ((i64toi32_i32$2 | 0) != (i64toi32_i32$4 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$3 | 0) | 0) {
                                                      break label$70
                                                     }
                                                     i64toi32_i32$2 = 0;
                                                     cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 20 | 0, i64toi32_i32$2 | 0);
                                                     $4 = 1;
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$11
                                                     }
                                                     $cardano_serialization_lib__plutus__ExUnits_20as_20cbor_event__se__Serialize___serialize__h495dce506fba6361($3 | 0, $1 + 240 | 0 | 0, $2 | 0);
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$10
                                                     }
                                                    }
                                                    label$71 : {
                                                     i64toi32_i32$4 = $1;
                                                     i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 256 | 0) >> 2] | 0;
                                                     i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 260 | 0) >> 2] | 0;
                                                     i64toi32_i32$4 = i64toi32_i32$2;
                                                     i64toi32_i32$2 = 0;
                                                     i64toi32_i32$3 = 1;
                                                     if ((i64toi32_i32$4 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$2 | 0) | 0) {
                                                      break label$71
                                                     }
                                                     i64toi32_i32$4 = 0;
                                                     cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 21 | 0, i64toi32_i32$4 | 0);
                                                     $4 = 1;
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$9
                                                     }
                                                     $cardano_serialization_lib__plutus__ExUnits_20as_20cbor_event__se__Serialize___serialize__h495dce506fba6361($3 | 0, $1 + 264 | 0 | 0, $2 | 0);
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$8
                                                     }
                                                    }
                                                    label$72 : {
                                                     if ((HEAP32[($1 + 348 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                                                      break label$72
                                                     }
                                                     i64toi32_i32$4 = 0;
                                                     cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 22 | 0, i64toi32_i32$4 | 0);
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$7
                                                     }
                                                     i64toi32_i32$3 = $1 + 352 | 0;
                                                     i64toi32_i32$4 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                                     i64toi32_i32$0 = 0;
                                                     cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, i64toi32_i32$4 | 0, i64toi32_i32$0 | 0);
                                                     $4 = 1;
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$6
                                                     }
                                                    }
                                                    label$73 : {
                                                     if ((HEAP32[($1 + 356 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                                                      break label$73
                                                     }
                                                     i64toi32_i32$0 = 0;
                                                     cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 23 | 0, i64toi32_i32$0 | 0);
                                                     $4 = 1;
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$5
                                                     }
                                                     i64toi32_i32$3 = $1 + 360 | 0;
                                                     i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                                     i64toi32_i32$4 = 0;
                                                     cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, i64toi32_i32$0 | 0, i64toi32_i32$4 | 0);
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$4
                                                     }
                                                    }
                                                    label$74 : {
                                                     if ((HEAP32[($1 + 364 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                                                      break label$74
                                                     }
                                                     i64toi32_i32$4 = 0;
                                                     cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 24 | 0, i64toi32_i32$4 | 0);
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$3
                                                     }
                                                     i64toi32_i32$3 = $1 + 368 | 0;
                                                     i64toi32_i32$4 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                                     i64toi32_i32$0 = 0;
                                                     cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, i64toi32_i32$4 | 0, i64toi32_i32$0 | 0);
                                                     $4 = 1;
                                                     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                                      break label$2
                                                     }
                                                    }
                                                    HEAP32[($0 + 4 | 0) >> 2] = $2;
                                                    $4 = 0;
                                                    break label$1;
                                                   }
                                                   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                                                   break label$1;
                                                  }
                                                  memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                                                  break label$1;
                                                 }
                                                 memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                                                 $4 = 1;
                                                 break label$1;
                                                }
                                                memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                                                break label$1;
                                               }
                                               memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                                               $4 = 1;
                                               break label$1;
                                              }
                                              memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                                              $4 = 1;
                                              break label$1;
                                             }
                                             memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                                             break label$1;
                                            }
                                            memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                                            break label$1;
                                           }
                                           memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                                           $4 = 1;
                                           break label$1;
                                          }
                                          memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                                          $4 = 1;
                                          break label$1;
                                         }
                                         memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                                         break label$1;
                                        }
                                        memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                                        break label$1;
                                       }
                                       memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                                       $4 = 1;
                                       break label$1;
                                      }
                                      memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                                      break label$1;
                                     }
                                     memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                                     $4 = 1;
                                     break label$1;
                                    }
                                    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                                    $4 = 1;
                                    break label$1;
                                   }
                                   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                                   break label$1;
                                  }
                                  memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                                  break label$1;
                                 }
                                 memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                                 $4 = 1;
                                 break label$1;
                                }
                                memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                                break label$1;
                               }
                               memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                               $4 = 1;
                               break label$1;
                              }
                              memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                              break label$1;
                             }
                             memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                             $4 = 1;
                             break label$1;
                            }
                            memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                            break label$1;
                           }
                           memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                           $4 = 1;
                           break label$1;
                          }
                          memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                          break label$1;
                         }
                         memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                         $4 = 1;
                         break label$1;
                        }
                        memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                        break label$1;
                       }
                       memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                       $4 = 1;
                       break label$1;
                      }
                      memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                      break label$1;
                     }
                     memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                     $4 = 1;
                     break label$1;
                    }
                    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                    break label$1;
                   }
                   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                   $4 = 1;
                   break label$1;
                  }
                  memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                  break label$1;
                 }
                 memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                 $4 = 1;
                 break label$1;
                }
                memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                $4 = 1;
                break label$1;
               }
               memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
               break label$1;
              }
              memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
              break label$1;
             }
             memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
             $4 = 1;
             break label$1;
            }
            memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
            break label$1;
           }
           memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
           $4 = 1;
           break label$1;
          }
          memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
          break label$1;
         }
         memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
         $4 = 1;
         break label$1;
        }
        memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
        $4 = 1;
        break label$1;
       }
       memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
       break label$1;
      }
      memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
      break label$1;
     }
     memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
     $4 = 1;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    $4 = 1;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
  }
  HEAP32[$0 >> 2] = $4;
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__address__Address__from_bytes_impl__h0b2b4c3a1f339e7a($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$4 = 0, $3 = 0, $5 = 0, $4 = 0, $15 = 0, $16 = 0, $17 = 0, $15$hi = 0, $18 = 0, $18$hi = 0, $16$hi = 0, $17$hi = 0, $6 = 0, $19 = 0, $9 = 0, $10 = 0, $8 = 0, $13 = 0, $19$hi = 0, $20 = 0, $114 = 0, $115 = 0, $116 = 0, $117 = 0, $20$hi = 0, $21 = 0, $21$hi = 0, $22 = 0, $22$hi = 0, $11 = 0, $12 = 0, $7 = 0, $118 = 0, $119 = 0, $120 = 0, $121 = 0, $122 = 0, $123 = 0, $124 = 0, $125 = 0, $126 = 0, $127 = 0, $128 = 0, $129 = 0, $130 = 0, $131 = 0, $132 = 0, $133 = 0, $134 = 0, $135 = 0, $136 = 0, $137 = 0, $138 = 0, $139 = 0, $140 = 0, $141 = 0, $142 = 0, $143 = 0, $144 = 0, $145 = 0, $146 = 0, $147 = 0, $148 = 0, $149 = 0, $150 = 0, $151 = 0, $152 = 0, $153 = 0, $154 = 0, $155 = 0, $156 = 0, $158 = 0, $159 = 0, $161 = 0, $162 = 0, $163 = 0, $164 = 0, $165 = 0, $166 = 0, $167 = 0, $168 = 0, $169 = 0, $170 = 0, $171 = 0, $172 = 0, $61 = 0, $65 = 0, $68 = 0, $68$hi = 0, $71 = 0, $71$hi = 0, $75$hi = 0, $77$hi = 0, $157 = 0, $157$hi = 0, $160 = 0, $160$hi = 0, $164$hi = 0, $166$hi = 0, $201 = 0, $205 = 0, $213 = 0, $213$hi = 0, $216 = 0, $216$hi = 0, $220$hi = 0, $222$hi = 0, $257 = 0, $261 = 0, $323 = 0, $327 = 0, $339 = 0, $339$hi = 0, $342 = 0, $342$hi = 0, $346$hi = 0, $348$hi = 0, $373 = 0, $377 = 0, $389 = 0, $389$hi = 0, $393 = 0, $393$hi = 0, $397$hi = 0, $399$hi = 0, $460 = 0, $461 = 0, $461$hi = 0, $462 = 0, $462$hi = 0, $464$hi = 0, $466$hi = 0, $470 = 0, $481 = 0, $487 = 0, $23 = 0, $23$hi = 0, $555 = 0, $559 = 0, $560 = 0, $560$hi = 0, $561 = 0, $561$hi = 0, $563$hi = 0, $565$hi = 0, $580 = 0, $583 = 0, $585 = 0, $589 = 0, $621 = 0, $625 = 0, $649 = 0, $653 = 0, $665 = 0, $665$hi = 0, $668 = 0, $668$hi = 0, $672$hi = 0, $674$hi = 0, $14 = 0, $707 = 0, $711 = 0, $736 = 0, $740 = 0;
  $3 = global$0 - 144 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           label$10 : {
            label$11 : {
             label$12 : {
              label$13 : {
               label$14 : {
                label$15 : {
                 label$16 : {
                  label$17 : {
                   label$18 : {
                    label$19 : {
                     label$20 : {
                      if (!$2) {
                       break label$20
                      }
                      $4 = HEAPU8[$1 >> 0] | 0;
                      $5 = 0;
                      $6 = 0;
                      label$21 : {
                       if (!0) {
                        break label$21
                       }
                       break label$2;
                      }
                      $7 = $4 & 15 | 0;
                      switch ($4 >>> 4 | 0 | 0) {
                      case 4:
                      case 5:
                       break label$16;
                      case 6:
                      case 7:
                       break label$17;
                      case 14:
                      case 15:
                       break label$18;
                      case 8:
                       break label$19;
                      case 9:
                      case 10:
                      case 11:
                      case 12:
                      case 13:
                       break label$2;
                      default:
                       break label$15;
                      };
                     }
                     core__panicking__panic_bounds_check__h808b524af17640b1(0 | 0, 0 | 0, 1070412 | 0);
                     abort();
                    }
                    alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($3 + 16 | 0 | 0, $2 | 0, 0 | 0);
                    HEAP32[($3 + 60 | 0) >> 2] = HEAP32[($3 + 20 | 0) >> 2] | 0;
                    $4 = HEAP32[($3 + 16 | 0) >> 2] | 0;
                    HEAP32[($3 + 56 | 0) >> 2] = $4;
                    memcpy($4 | 0, $1 | 0, $2 | 0) | 0;
                    HEAP32[($3 + 64 | 0) >> 2] = $2;
                    cardano_serialization_lib__address__ByronAddress__from_bytes__h9704f398e56b45f1($3 + 80 | 0 | 0, $3 + 56 | 0 | 0);
                    label$22 : {
                     if ((HEAP32[($3 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                      break label$22
                     }
                     i64toi32_i32$2 = $3;
                     i64toi32_i32$0 = HEAPU16[(i64toi32_i32$2 + 114 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 116 | 0) >> 1] | 0) << 16 | 0) | 0;
                     i64toi32_i32$1 = HEAPU16[(i64toi32_i32$2 + 118 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 120 | 0) >> 1] | 0) << 16 | 0) | 0;
                     $61 = i64toi32_i32$0;
                     i64toi32_i32$0 = i64toi32_i32$2;
                     HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] = $61;
                     HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] = i64toi32_i32$1;
                     i64toi32_i32$2 = i64toi32_i32$2 + 120 | 0;
                     i64toi32_i32$1 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
                     i64toi32_i32$0 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
                     $65 = i64toi32_i32$1;
                     i64toi32_i32$1 = $3;
                     $118 = $65;
                     HEAP16[(i64toi32_i32$1 + 46 | 0) >> 1] = $118;
                     HEAP16[(i64toi32_i32$1 + 48 | 0) >> 1] = $118 >>> 16 | 0;
                     HEAP16[(i64toi32_i32$1 + 50 | 0) >> 1] = i64toi32_i32$0;
                     HEAP16[(i64toi32_i32$1 + 52 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
                     i64toi32_i32$2 = i64toi32_i32$1 + 104 | 0;
                     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                     i64toi32_i32$1 = 0;
                     $68 = i64toi32_i32$0;
                     $68$hi = i64toi32_i32$1;
                     i64toi32_i32$2 = $3 + 108 | 0;
                     i64toi32_i32$1 = HEAPU16[i64toi32_i32$2 >> 1] | 0;
                     i64toi32_i32$0 = 0;
                     $71 = i64toi32_i32$1;
                     $71$hi = i64toi32_i32$0;
                     i64toi32_i32$2 = $3 + 110 | 0;
                     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
                     i64toi32_i32$1 = 0;
                     i64toi32_i32$2 = i64toi32_i32$0;
                     i64toi32_i32$0 = 0;
                     i64toi32_i32$3 = 16;
                     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
                     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                      i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
                      $119 = 0;
                     } else {
                      i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
                      $119 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
                     }
                     $75$hi = i64toi32_i32$0;
                     i64toi32_i32$0 = $71$hi;
                     i64toi32_i32$1 = $71;
                     i64toi32_i32$2 = $75$hi;
                     i64toi32_i32$3 = $119;
                     i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
                     i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
                     i64toi32_i32$1 = 0;
                     i64toi32_i32$3 = 32;
                     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
                     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                      i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
                      $120 = 0;
                     } else {
                      i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
                      $120 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
                     }
                     $77$hi = i64toi32_i32$1;
                     i64toi32_i32$1 = $68$hi;
                     i64toi32_i32$2 = $68;
                     i64toi32_i32$0 = $77$hi;
                     i64toi32_i32$3 = $120;
                     i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
                     $15 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
                     $15$hi = i64toi32_i32$0;
                     $8 = HEAPU8[($3 + 112 | 0) >> 0] | 0;
                     i64toi32_i32$1 = $3 + 96 | 0;
                     i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                     i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                     $16 = i64toi32_i32$0;
                     $16$hi = i64toi32_i32$2;
                     i64toi32_i32$1 = $3 + 88 | 0;
                     i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                     i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                     $17 = i64toi32_i32$2;
                     $17$hi = i64toi32_i32$0;
                     $4 = HEAP32[($3 + 128 | 0) >> 2] | 0;
                     i64toi32_i32$1 = $3 + 132 | 0;
                     i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                     i64toi32_i32$2 = 0;
                     $18 = i64toi32_i32$0;
                     $18$hi = i64toi32_i32$2;
                     $2 = HEAPU8[($3 + 113 | 0) >> 0] | 0;
                     $1 = HEAPU8[($3 + 111 | 0) >> 0] | 0;
                     $5 = HEAP32[($3 + 84 | 0) >> 2] | 0;
                     $9 = 4;
                     break label$14;
                    }
                    $4 = HEAP32[($3 + 84 | 0) >> 2] | 0;
                    wasm_bindgen____wbindgen_string_get__h2745c23336ae3bc7($3 + 8 | 0 | 0, $4 | 0);
                    label$23 : {
                     label$24 : {
                      $1 = HEAP32[($3 + 8 | 0) >> 2] | 0;
                      if (!$1) {
                       break label$24
                      }
                      $2 = HEAP32[($3 + 12 | 0) >> 2] | 0;
                      HEAP32[($3 + 64 | 0) >> 2] = $2;
                      HEAP32[($3 + 60 | 0) >> 2] = $2;
                      HEAP32[($3 + 56 | 0) >> 2] = $1;
                      alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($3 | 0, $3 + 56 | 0 | 0);
                      $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($3 + 56 | 0 | 0, HEAP32[$3 >> 2] | 0 | 0, HEAP32[($3 + 4 | 0) >> 2] | 0 | 0);
                      $1 = HEAP32[($3 + 56 | 0) >> 2] | 0;
                      if (!$1) {
                       break label$24
                      }
                      i64toi32_i32$1 = $3 + 64 | 0;
                      i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                      i64toi32_i32$0 = 0;
                      i64toi32_i32$1 = i64toi32_i32$2;
                      i64toi32_i32$2 = 0;
                      i64toi32_i32$3 = 32;
                      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
                      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                       i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
                       $121 = 0;
                      } else {
                       i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
                       $121 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
                      }
                      $15 = $121;
                      $15$hi = i64toi32_i32$2;
                      i64toi32_i32$0 = $3;
                      i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 60 | 0) >> 2] | 0;
                      i64toi32_i32$1 = 0;
                      $17 = i64toi32_i32$2;
                      $17$hi = i64toi32_i32$1;
                      break label$23;
                     }
                     $1 = HEAP32[(0 + 1070048 | 0) >> 2] | 0;
                     i64toi32_i32$1 = 0;
                     $15 = 0;
                     $15$hi = i64toi32_i32$1;
                     i64toi32_i32$1 = 0;
                     $17 = 0;
                     $17$hi = i64toi32_i32$1;
                    }
                    i64toi32_i32$1 = 0;
                    i64toi32_i32$0 = $1;
                    i64toi32_i32$2 = 0;
                    i64toi32_i32$3 = 32;
                    i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
                    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                     i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
                     $122 = 0;
                    } else {
                     i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
                     $122 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
                    }
                    $18 = $122;
                    $18$hi = i64toi32_i32$2;
                    label$25 : {
                     if ($4 >>> 0 < 36 >>> 0) {
                      break label$25
                     }
                     wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($4 | 0);
                    }
                    i64toi32_i32$2 = $17$hi;
                    i64toi32_i32$2 = $15$hi;
                    i64toi32_i32$2 = $17$hi;
                    i64toi32_i32$1 = $17;
                    i64toi32_i32$0 = $15$hi;
                    i64toi32_i32$3 = $15;
                    i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
                    $16 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
                    $16$hi = i64toi32_i32$0;
                    i64toi32_i32$0 = $18$hi;
                    i64toi32_i32$2 = $18;
                    i64toi32_i32$1 = 0;
                    i64toi32_i32$3 = 18;
                    i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
                    $18 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
                    $18$hi = i64toi32_i32$1;
                    break label$4;
                   }
                   label$26 : {
                    label$27 : {
                     if ($2 >>> 0 < 29 >>> 0) {
                      break label$27
                     }
                     if (($2 | 0) == (29 | 0)) {
                      break label$26
                     }
                     break label$5;
                    }
                    i64toi32_i32$1 = 0;
                    i64toi32_i32$0 = $2;
                    i64toi32_i32$2 = 0;
                    i64toi32_i32$3 = 32;
                    i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
                    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                     i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
                     $123 = 0;
                    } else {
                     i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
                     $123 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
                    }
                    i64toi32_i32$1 = $123;
                    i64toi32_i32$0 = 0;
                    i64toi32_i32$3 = 8;
                    i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
                    $18 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
                    $18$hi = i64toi32_i32$0;
                    break label$6;
                   }
                   i64toi32_i32$2 = $1;
                   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 22 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 23 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 24 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 25 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                   i64toi32_i32$1 = 0;
                   $157 = i64toi32_i32$0;
                   $157$hi = i64toi32_i32$1;
                   i64toi32_i32$2 = i64toi32_i32$2 + 26 | 0;
                   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
                   i64toi32_i32$0 = 0;
                   $160 = i64toi32_i32$1;
                   $160$hi = i64toi32_i32$0;
                   i64toi32_i32$2 = $1 + 28 | 0;
                   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
                   i64toi32_i32$1 = 0;
                   i64toi32_i32$2 = i64toi32_i32$0;
                   i64toi32_i32$0 = 0;
                   i64toi32_i32$3 = 16;
                   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
                   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                    i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
                    $124 = 0;
                   } else {
                    i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
                    $124 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
                   }
                   $164$hi = i64toi32_i32$0;
                   i64toi32_i32$0 = $160$hi;
                   i64toi32_i32$1 = $160;
                   i64toi32_i32$2 = $164$hi;
                   i64toi32_i32$3 = $124;
                   i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
                   i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
                   i64toi32_i32$1 = 0;
                   i64toi32_i32$3 = 32;
                   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
                   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                    i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
                    $125 = 0;
                   } else {
                    i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
                    $125 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
                   }
                   $166$hi = i64toi32_i32$1;
                   i64toi32_i32$1 = $157$hi;
                   i64toi32_i32$2 = $157;
                   i64toi32_i32$0 = $166$hi;
                   i64toi32_i32$3 = $125;
                   i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
                   $15 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
                   $15$hi = i64toi32_i32$0;
                   i64toi32_i32$1 = $1;
                   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 14 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 15 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 16 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 17 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                   i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 18 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 19 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 20 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 21 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                   $16 = i64toi32_i32$0;
                   $16$hi = i64toi32_i32$2;
                   i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 8 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 9 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 10 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 11 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 12 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 13 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                   $17 = i64toi32_i32$2;
                   $17$hi = i64toi32_i32$0;
                   $5 = HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                   $6 = HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0;
                   label$28 : {
                    label$29 : {
                     if ($4 & 16 | 0) {
                      break label$29
                     }
                     i64toi32_i32$0 = $16$hi;
                     i64toi32_i32$2 = $3;
                     HEAP8[(i64toi32_i32$2 + 93 | 0) >> 0] = $16;
                     HEAP8[(i64toi32_i32$2 + 94 | 0) >> 0] = $16 >>> 8 | 0;
                     HEAP8[(i64toi32_i32$2 + 95 | 0) >> 0] = $16 >>> 16 | 0;
                     HEAP8[(i64toi32_i32$2 + 96 | 0) >> 0] = $16 >>> 24 | 0;
                     HEAP8[(i64toi32_i32$2 + 97 | 0) >> 0] = i64toi32_i32$0;
                     HEAP8[(i64toi32_i32$2 + 98 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                     HEAP8[(i64toi32_i32$2 + 99 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
                     HEAP8[(i64toi32_i32$2 + 100 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
                     i64toi32_i32$0 = $17$hi;
                     HEAP8[(i64toi32_i32$2 + 85 | 0) >> 0] = $17;
                     HEAP8[(i64toi32_i32$2 + 86 | 0) >> 0] = $17 >>> 8 | 0;
                     HEAP8[(i64toi32_i32$2 + 87 | 0) >> 0] = $17 >>> 16 | 0;
                     HEAP8[(i64toi32_i32$2 + 88 | 0) >> 0] = $17 >>> 24 | 0;
                     HEAP8[(i64toi32_i32$2 + 89 | 0) >> 0] = i64toi32_i32$0;
                     HEAP8[(i64toi32_i32$2 + 90 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                     HEAP8[(i64toi32_i32$2 + 91 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
                     HEAP8[(i64toi32_i32$2 + 92 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
                     HEAP8[(i64toi32_i32$2 + 81 | 0) >> 0] = $5;
                     HEAP8[(i64toi32_i32$2 + 82 | 0) >> 0] = $5 >>> 8 | 0;
                     HEAP8[(i64toi32_i32$2 + 83 | 0) >> 0] = $5 >>> 16 | 0;
                     HEAP8[(i64toi32_i32$2 + 84 | 0) >> 0] = $5 >>> 24 | 0;
                     HEAP8[(i64toi32_i32$2 + 80 | 0) >> 0] = $6;
                     $4 = i64toi32_i32$2 + 101 | 0;
                     $10 = 0;
                     break label$28;
                    }
                    i64toi32_i32$0 = $16$hi;
                    i64toi32_i32$2 = $3;
                    HEAP8[(i64toi32_i32$2 + 93 | 0) >> 0] = $16;
                    HEAP8[(i64toi32_i32$2 + 94 | 0) >> 0] = $16 >>> 8 | 0;
                    HEAP8[(i64toi32_i32$2 + 95 | 0) >> 0] = $16 >>> 16 | 0;
                    HEAP8[(i64toi32_i32$2 + 96 | 0) >> 0] = $16 >>> 24 | 0;
                    HEAP8[(i64toi32_i32$2 + 97 | 0) >> 0] = i64toi32_i32$0;
                    HEAP8[(i64toi32_i32$2 + 98 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                    HEAP8[(i64toi32_i32$2 + 99 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
                    HEAP8[(i64toi32_i32$2 + 100 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
                    i64toi32_i32$0 = $17$hi;
                    HEAP8[(i64toi32_i32$2 + 85 | 0) >> 0] = $17;
                    HEAP8[(i64toi32_i32$2 + 86 | 0) >> 0] = $17 >>> 8 | 0;
                    HEAP8[(i64toi32_i32$2 + 87 | 0) >> 0] = $17 >>> 16 | 0;
                    HEAP8[(i64toi32_i32$2 + 88 | 0) >> 0] = $17 >>> 24 | 0;
                    HEAP8[(i64toi32_i32$2 + 89 | 0) >> 0] = i64toi32_i32$0;
                    HEAP8[(i64toi32_i32$2 + 90 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                    HEAP8[(i64toi32_i32$2 + 91 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
                    HEAP8[(i64toi32_i32$2 + 92 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
                    HEAP8[(i64toi32_i32$2 + 81 | 0) >> 0] = $5;
                    HEAP8[(i64toi32_i32$2 + 82 | 0) >> 0] = $5 >>> 8 | 0;
                    HEAP8[(i64toi32_i32$2 + 83 | 0) >> 0] = $5 >>> 16 | 0;
                    HEAP8[(i64toi32_i32$2 + 84 | 0) >> 0] = $5 >>> 24 | 0;
                    HEAP8[(i64toi32_i32$2 + 80 | 0) >> 0] = $6;
                    $4 = i64toi32_i32$2 + 101 | 0;
                    $10 = 1;
                   }
                   i64toi32_i32$0 = $15$hi;
                   HEAP8[$4 >> 0] = $15;
                   HEAP8[($4 + 1 | 0) >> 0] = $15 >>> 8 | 0;
                   HEAP8[($4 + 2 | 0) >> 0] = $15 >>> 16 | 0;
                   HEAP8[($4 + 3 | 0) >> 0] = $15 >>> 24 | 0;
                   $201 = $4 + 6 | 0;
                   i64toi32_i32$1 = $15;
                   i64toi32_i32$2 = 0;
                   i64toi32_i32$3 = 48;
                   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
                   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                    i64toi32_i32$2 = 0;
                    $126 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
                   } else {
                    i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
                    $126 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
                   }
                   HEAP8[$201 >> 0] = $126;
                   $205 = $4 + 4 | 0;
                   i64toi32_i32$2 = $15$hi;
                   i64toi32_i32$0 = $15;
                   i64toi32_i32$1 = 0;
                   i64toi32_i32$3 = 32;
                   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
                   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                    i64toi32_i32$1 = 0;
                    $127 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
                   } else {
                    i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
                    $127 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
                   }
                   $128 = $205;
                   $129 = $127;
                   HEAP8[$128 >> 0] = $129;
                   HEAP8[($128 + 1 | 0) >> 0] = $129 >>> 8 | 0;
                   $9 = 3;
                   break label$14;
                  }
                  if ($2 >>> 0 < 29 >>> 0) {
                   break label$13
                  }
                  if (($2 | 0) != (29 | 0)) {
                   break label$5
                  }
                  i64toi32_i32$2 = $1;
                  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 22 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 23 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 24 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 25 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                  i64toi32_i32$0 = 0;
                  $213 = i64toi32_i32$1;
                  $213$hi = i64toi32_i32$0;
                  i64toi32_i32$2 = i64toi32_i32$2 + 26 | 0;
                  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
                  i64toi32_i32$1 = 0;
                  $216 = i64toi32_i32$0;
                  $216$hi = i64toi32_i32$1;
                  i64toi32_i32$2 = $1 + 28 | 0;
                  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
                  i64toi32_i32$0 = 0;
                  i64toi32_i32$2 = i64toi32_i32$1;
                  i64toi32_i32$1 = 0;
                  i64toi32_i32$3 = 16;
                  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
                  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                   i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
                   $130 = 0;
                  } else {
                   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
                   $130 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
                  }
                  $220$hi = i64toi32_i32$1;
                  i64toi32_i32$1 = $216$hi;
                  i64toi32_i32$0 = $216;
                  i64toi32_i32$2 = $220$hi;
                  i64toi32_i32$3 = $130;
                  i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
                  i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
                  i64toi32_i32$0 = 0;
                  i64toi32_i32$3 = 32;
                  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
                  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                   i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
                   $131 = 0;
                  } else {
                   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
                   $131 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
                  }
                  $222$hi = i64toi32_i32$0;
                  i64toi32_i32$0 = $213$hi;
                  i64toi32_i32$2 = $213;
                  i64toi32_i32$1 = $222$hi;
                  i64toi32_i32$3 = $131;
                  i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
                  $15 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
                  $15$hi = i64toi32_i32$1;
                  i64toi32_i32$0 = $1;
                  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 14 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 15 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 16 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 17 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                  i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 18 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 19 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 20 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 21 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                  $16 = i64toi32_i32$1;
                  $16$hi = i64toi32_i32$2;
                  i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 8 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 9 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 10 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 11 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 12 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 13 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                  $17 = i64toi32_i32$2;
                  $17$hi = i64toi32_i32$1;
                  $5 = HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                  $6 = HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0;
                  label$30 : {
                   label$31 : {
                    if ($4 & 16 | 0) {
                     break label$31
                    }
                    i64toi32_i32$1 = $16$hi;
                    i64toi32_i32$2 = $3;
                    HEAP8[(i64toi32_i32$2 + 93 | 0) >> 0] = $16;
                    HEAP8[(i64toi32_i32$2 + 94 | 0) >> 0] = $16 >>> 8 | 0;
                    HEAP8[(i64toi32_i32$2 + 95 | 0) >> 0] = $16 >>> 16 | 0;
                    HEAP8[(i64toi32_i32$2 + 96 | 0) >> 0] = $16 >>> 24 | 0;
                    HEAP8[(i64toi32_i32$2 + 97 | 0) >> 0] = i64toi32_i32$1;
                    HEAP8[(i64toi32_i32$2 + 98 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
                    HEAP8[(i64toi32_i32$2 + 99 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
                    HEAP8[(i64toi32_i32$2 + 100 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
                    i64toi32_i32$1 = $17$hi;
                    HEAP8[(i64toi32_i32$2 + 85 | 0) >> 0] = $17;
                    HEAP8[(i64toi32_i32$2 + 86 | 0) >> 0] = $17 >>> 8 | 0;
                    HEAP8[(i64toi32_i32$2 + 87 | 0) >> 0] = $17 >>> 16 | 0;
                    HEAP8[(i64toi32_i32$2 + 88 | 0) >> 0] = $17 >>> 24 | 0;
                    HEAP8[(i64toi32_i32$2 + 89 | 0) >> 0] = i64toi32_i32$1;
                    HEAP8[(i64toi32_i32$2 + 90 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
                    HEAP8[(i64toi32_i32$2 + 91 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
                    HEAP8[(i64toi32_i32$2 + 92 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
                    HEAP8[(i64toi32_i32$2 + 81 | 0) >> 0] = $5;
                    HEAP8[(i64toi32_i32$2 + 82 | 0) >> 0] = $5 >>> 8 | 0;
                    HEAP8[(i64toi32_i32$2 + 83 | 0) >> 0] = $5 >>> 16 | 0;
                    HEAP8[(i64toi32_i32$2 + 84 | 0) >> 0] = $5 >>> 24 | 0;
                    HEAP8[(i64toi32_i32$2 + 80 | 0) >> 0] = $6;
                    $4 = i64toi32_i32$2 + 101 | 0;
                    $10 = 0;
                    break label$30;
                   }
                   i64toi32_i32$1 = $16$hi;
                   i64toi32_i32$2 = $3;
                   HEAP8[(i64toi32_i32$2 + 93 | 0) >> 0] = $16;
                   HEAP8[(i64toi32_i32$2 + 94 | 0) >> 0] = $16 >>> 8 | 0;
                   HEAP8[(i64toi32_i32$2 + 95 | 0) >> 0] = $16 >>> 16 | 0;
                   HEAP8[(i64toi32_i32$2 + 96 | 0) >> 0] = $16 >>> 24 | 0;
                   HEAP8[(i64toi32_i32$2 + 97 | 0) >> 0] = i64toi32_i32$1;
                   HEAP8[(i64toi32_i32$2 + 98 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
                   HEAP8[(i64toi32_i32$2 + 99 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
                   HEAP8[(i64toi32_i32$2 + 100 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
                   i64toi32_i32$1 = $17$hi;
                   HEAP8[(i64toi32_i32$2 + 85 | 0) >> 0] = $17;
                   HEAP8[(i64toi32_i32$2 + 86 | 0) >> 0] = $17 >>> 8 | 0;
                   HEAP8[(i64toi32_i32$2 + 87 | 0) >> 0] = $17 >>> 16 | 0;
                   HEAP8[(i64toi32_i32$2 + 88 | 0) >> 0] = $17 >>> 24 | 0;
                   HEAP8[(i64toi32_i32$2 + 89 | 0) >> 0] = i64toi32_i32$1;
                   HEAP8[(i64toi32_i32$2 + 90 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
                   HEAP8[(i64toi32_i32$2 + 91 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
                   HEAP8[(i64toi32_i32$2 + 92 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
                   HEAP8[(i64toi32_i32$2 + 81 | 0) >> 0] = $5;
                   HEAP8[(i64toi32_i32$2 + 82 | 0) >> 0] = $5 >>> 8 | 0;
                   HEAP8[(i64toi32_i32$2 + 83 | 0) >> 0] = $5 >>> 16 | 0;
                   HEAP8[(i64toi32_i32$2 + 84 | 0) >> 0] = $5 >>> 24 | 0;
                   HEAP8[(i64toi32_i32$2 + 80 | 0) >> 0] = $6;
                   $4 = i64toi32_i32$2 + 101 | 0;
                   $10 = 1;
                  }
                  i64toi32_i32$1 = $15$hi;
                  HEAP8[$4 >> 0] = $15;
                  HEAP8[($4 + 1 | 0) >> 0] = $15 >>> 8 | 0;
                  HEAP8[($4 + 2 | 0) >> 0] = $15 >>> 16 | 0;
                  HEAP8[($4 + 3 | 0) >> 0] = $15 >>> 24 | 0;
                  $257 = $4 + 6 | 0;
                  i64toi32_i32$0 = $15;
                  i64toi32_i32$2 = 0;
                  i64toi32_i32$3 = 48;
                  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
                  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                   i64toi32_i32$2 = 0;
                   $132 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
                  } else {
                   i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
                   $132 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
                  }
                  HEAP8[$257 >> 0] = $132;
                  $261 = $4 + 4 | 0;
                  i64toi32_i32$2 = $15$hi;
                  i64toi32_i32$1 = $15;
                  i64toi32_i32$0 = 0;
                  i64toi32_i32$3 = 32;
                  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
                  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                   i64toi32_i32$0 = 0;
                   $133 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
                  } else {
                   i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
                   $133 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
                  }
                  $134 = $261;
                  $135 = $133;
                  HEAP8[$134 >> 0] = $135;
                  HEAP8[($134 + 1 | 0) >> 0] = $135 >>> 8 | 0;
                  $9 = 2;
                  break label$14;
                 }
                 if ($2 >>> 0 < 32 >>> 0) {
                  break label$12
                 }
                 i64toi32_i32$2 = $1 + 26 | 0;
                 i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
                 i64toi32_i32$1 = 0;
                 $19 = i64toi32_i32$0;
                 $19$hi = i64toi32_i32$1;
                 i64toi32_i32$2 = $1 + 28 | 0;
                 i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
                 i64toi32_i32$0 = 0;
                 $20 = i64toi32_i32$1;
                 $20$hi = i64toi32_i32$0;
                 i64toi32_i32$2 = $1;
                 i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 14 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 15 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 16 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 17 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 18 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 19 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 20 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 21 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 $18 = i64toi32_i32$0;
                 $18$hi = i64toi32_i32$1;
                 i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 9 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 10 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 11 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 12 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 13 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 $21 = i64toi32_i32$1;
                 $21$hi = i64toi32_i32$0;
                 $6 = HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 $8 = HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0;
                 i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 22 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 23 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 24 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 25 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 i64toi32_i32$1 = 0;
                 $22 = i64toi32_i32$0;
                 $22$hi = i64toi32_i32$1;
                 cardano_serialization_lib__address__variable_nat_decode__heeba208d8c3d5da7($3 + 56 | 0 | 0, i64toi32_i32$2 + 29 | 0 | 0, $2 + -29 | 0 | 0);
                 alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($3 + 128 | 0 | 0, 1070428 | 0, 20 | 0);
                 HEAP8[($3 + 80 | 0) >> 0] = 18;
                 label$32 : {
                  label$33 : {
                   i64toi32_i32$2 = $3;
                   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
                   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
                   i64toi32_i32$2 = i64toi32_i32$1;
                   i64toi32_i32$1 = 0;
                   i64toi32_i32$3 = 1;
                   if ((i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | 0) {
                    break label$33
                   }
                   $5 = HEAP32[($3 + 72 | 0) >> 2] | 0;
                   i64toi32_i32$3 = $3;
                   i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 64 | 0) >> 2] | 0;
                   i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 68 | 0) >> 2] | 0;
                   $17 = i64toi32_i32$2;
                   $17$hi = i64toi32_i32$0;
                   core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9_2(i64toi32_i32$3 + 80 | 0 | 0);
                   $5 = $5 + 29 | 0;
                   if ($5 >>> 0 > $2 >>> 0) {
                    break label$11
                   }
                   cardano_serialization_lib__address__variable_nat_decode__heeba208d8c3d5da7($3 + 56 | 0 | 0, $1 + $5 | 0 | 0, $2 - $5 | 0 | 0);
                   alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($3 + 128 | 0 | 0, 1070464 | 0, 24 | 0);
                   HEAP8[($3 + 80 | 0) >> 0] = 18;
                   i64toi32_i32$3 = $3;
                   i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 56 | 0) >> 2] | 0;
                   i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 60 | 0) >> 2] | 0;
                   i64toi32_i32$3 = i64toi32_i32$0;
                   i64toi32_i32$0 = 0;
                   i64toi32_i32$1 = 1;
                   if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) | 0) {
                    break label$32
                   }
                   i64toi32_i32$1 = $3 + 114 | 0;
                   i64toi32_i32$3 = HEAPU16[i64toi32_i32$1 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
                   i64toi32_i32$2 = HEAPU16[(i64toi32_i32$1 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
                   $323 = i64toi32_i32$3;
                   i64toi32_i32$3 = $3;
                   HEAP32[(i64toi32_i32$3 + 24 | 0) >> 2] = $323;
                   HEAP32[(i64toi32_i32$3 + 28 | 0) >> 2] = i64toi32_i32$2;
                   i64toi32_i32$1 = i64toi32_i32$3 + 120 | 0;
                   i64toi32_i32$2 = HEAPU16[i64toi32_i32$1 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
                   i64toi32_i32$3 = HEAPU16[(i64toi32_i32$1 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
                   $327 = i64toi32_i32$2;
                   i64toi32_i32$2 = $3;
                   $136 = $327;
                   HEAP16[(i64toi32_i32$2 + 30 | 0) >> 1] = $136;
                   HEAP16[(i64toi32_i32$2 + 32 | 0) >> 1] = $136 >>> 16 | 0;
                   HEAP16[(i64toi32_i32$2 + 34 | 0) >> 1] = i64toi32_i32$3;
                   HEAP16[(i64toi32_i32$2 + 36 | 0) >> 1] = i64toi32_i32$3 >>> 16 | 0;
                   $5 = HEAP32[(i64toi32_i32$2 + 80 | 0) >> 2] | 0;
                   $11 = $5 >>> 24 | 0;
                   $12 = $5 >>> 16 | 0;
                   $4 = $5 >>> 8 | 0;
                   i64toi32_i32$1 = (i64toi32_i32$2 + 80 | 0) + 24 | 0;
                   i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                   i64toi32_i32$2 = 0;
                   $339 = i64toi32_i32$3;
                   $339$hi = i64toi32_i32$2;
                   i64toi32_i32$1 = $3 + 108 | 0;
                   i64toi32_i32$2 = HEAPU16[i64toi32_i32$1 >> 1] | 0;
                   i64toi32_i32$3 = 0;
                   $342 = i64toi32_i32$2;
                   $342$hi = i64toi32_i32$3;
                   i64toi32_i32$1 = $3 + 110 | 0;
                   i64toi32_i32$3 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
                   i64toi32_i32$2 = 0;
                   i64toi32_i32$1 = i64toi32_i32$3;
                   i64toi32_i32$3 = 0;
                   i64toi32_i32$0 = 16;
                   i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
                   if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
                    i64toi32_i32$3 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
                    $137 = 0;
                   } else {
                    i64toi32_i32$3 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
                    $137 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
                   }
                   $346$hi = i64toi32_i32$3;
                   i64toi32_i32$3 = $342$hi;
                   i64toi32_i32$2 = $342;
                   i64toi32_i32$1 = $346$hi;
                   i64toi32_i32$0 = $137;
                   i64toi32_i32$1 = i64toi32_i32$3 | i64toi32_i32$1 | 0;
                   i64toi32_i32$3 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
                   i64toi32_i32$2 = 0;
                   i64toi32_i32$0 = 32;
                   i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
                   if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
                    i64toi32_i32$2 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
                    $138 = 0;
                   } else {
                    i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
                    $138 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
                   }
                   $348$hi = i64toi32_i32$2;
                   i64toi32_i32$2 = $339$hi;
                   i64toi32_i32$1 = $339;
                   i64toi32_i32$3 = $348$hi;
                   i64toi32_i32$0 = $138;
                   i64toi32_i32$3 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
                   $15 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
                   $15$hi = i64toi32_i32$3;
                   $13 = HEAPU8[($3 + 113 | 0) >> 0] | 0;
                   $10 = HEAPU8[($3 + 112 | 0) >> 0] | 0;
                   $9 = HEAPU8[($3 + 111 | 0) >> 0] | 0;
                   i64toi32_i32$2 = ($3 + 80 | 0) + 16 | 0;
                   i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                   $16 = i64toi32_i32$3;
                   $16$hi = i64toi32_i32$1;
                   i64toi32_i32$2 = ($3 + 80 | 0) + 8 | 0;
                   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                   i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                   $18 = i64toi32_i32$1;
                   $18$hi = i64toi32_i32$3;
                   i64toi32_i32$2 = $3 + 132 | 0;
                   i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                   $17 = i64toi32_i32$3;
                   $17$hi = i64toi32_i32$1;
                   break label$7;
                  }
                  i64toi32_i32$2 = $3 + 114 | 0;
                  i64toi32_i32$1 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
                  i64toi32_i32$3 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
                  $373 = i64toi32_i32$1;
                  i64toi32_i32$1 = $3;
                  HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = $373;
                  HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = i64toi32_i32$3;
                  i64toi32_i32$2 = i64toi32_i32$1 + 120 | 0;
                  i64toi32_i32$3 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
                  i64toi32_i32$1 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
                  $377 = i64toi32_i32$3;
                  i64toi32_i32$3 = $3;
                  $139 = $377;
                  HEAP16[(i64toi32_i32$3 + 30 | 0) >> 1] = $139;
                  HEAP16[(i64toi32_i32$3 + 32 | 0) >> 1] = $139 >>> 16 | 0;
                  HEAP16[(i64toi32_i32$3 + 34 | 0) >> 1] = i64toi32_i32$1;
                  HEAP16[(i64toi32_i32$3 + 36 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
                  $5 = HEAP32[(i64toi32_i32$3 + 80 | 0) >> 2] | 0;
                  $11 = $5 >>> 24 | 0;
                  $12 = $5 >>> 16 | 0;
                  $4 = $5 >>> 8 | 0;
                  i64toi32_i32$2 = (i64toi32_i32$3 + 80 | 0) + 24 | 0;
                  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                  i64toi32_i32$3 = 0;
                  $389 = i64toi32_i32$1;
                  $389$hi = i64toi32_i32$3;
                  i64toi32_i32$2 = ($3 + 80 | 0) + 28 | 0;
                  i64toi32_i32$3 = HEAPU16[i64toi32_i32$2 >> 1] | 0;
                  i64toi32_i32$1 = 0;
                  $393 = i64toi32_i32$3;
                  $393$hi = i64toi32_i32$1;
                  i64toi32_i32$2 = $3 + 110 | 0;
                  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
                  i64toi32_i32$3 = 0;
                  i64toi32_i32$2 = i64toi32_i32$1;
                  i64toi32_i32$1 = 0;
                  i64toi32_i32$0 = 16;
                  i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
                  if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
                   i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
                   $140 = 0;
                  } else {
                   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$4 | 0) | 0;
                   $140 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
                  }
                  $397$hi = i64toi32_i32$1;
                  i64toi32_i32$1 = $393$hi;
                  i64toi32_i32$3 = $393;
                  i64toi32_i32$2 = $397$hi;
                  i64toi32_i32$0 = $140;
                  i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
                  i64toi32_i32$1 = i64toi32_i32$3 | i64toi32_i32$0 | 0;
                  i64toi32_i32$3 = 0;
                  i64toi32_i32$0 = 32;
                  i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
                  if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
                   i64toi32_i32$3 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
                   $141 = 0;
                  } else {
                   i64toi32_i32$3 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
                   $141 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
                  }
                  $399$hi = i64toi32_i32$3;
                  i64toi32_i32$3 = $389$hi;
                  i64toi32_i32$2 = $389;
                  i64toi32_i32$1 = $399$hi;
                  i64toi32_i32$0 = $141;
                  i64toi32_i32$1 = i64toi32_i32$3 | i64toi32_i32$1 | 0;
                  $15 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
                  $15$hi = i64toi32_i32$1;
                  $13 = HEAPU8[($3 + 113 | 0) >> 0] | 0;
                  $10 = HEAPU8[($3 + 112 | 0) >> 0] | 0;
                  $9 = HEAPU8[($3 + 111 | 0) >> 0] | 0;
                  i64toi32_i32$3 = ($3 + 80 | 0) + 16 | 0;
                  i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                  $16 = i64toi32_i32$1;
                  $16$hi = i64toi32_i32$2;
                  i64toi32_i32$3 = ($3 + 80 | 0) + 8 | 0;
                  i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                  i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                  $18 = i64toi32_i32$2;
                  $18$hi = i64toi32_i32$1;
                  i64toi32_i32$3 = $3 + 132 | 0;
                  i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                  $17 = i64toi32_i32$1;
                  $17$hi = i64toi32_i32$2;
                  break label$7;
                 }
                 $13 = HEAP32[($3 + 72 | 0) >> 2] | 0;
                 i64toi32_i32$3 = $3;
                 i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 64 | 0) >> 2] | 0;
                 i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 68 | 0) >> 2] | 0;
                 $16 = i64toi32_i32$2;
                 $16$hi = i64toi32_i32$1;
                 core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9_2(i64toi32_i32$3 + 80 | 0 | 0);
                 $5 = $13 + $5 | 0;
                 if ($5 >>> 0 > $2 >>> 0) {
                  break label$10
                 }
                 cardano_serialization_lib__address__variable_nat_decode__heeba208d8c3d5da7($3 + 56 | 0 | 0, $1 + $5 | 0 | 0, $2 - $5 | 0 | 0);
                 alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($3 + 128 | 0 | 0, 1070504 | 0, 26 | 0);
                 HEAP8[($3 + 80 | 0) >> 0] = 18;
                 i64toi32_i32$3 = $3;
                 i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 56 | 0) >> 2] | 0;
                 i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 60 | 0) >> 2] | 0;
                 i64toi32_i32$3 = i64toi32_i32$1;
                 i64toi32_i32$1 = 0;
                 i64toi32_i32$0 = 1;
                 if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
                  break label$9
                 }
                 $1 = HEAP32[($3 + 72 | 0) >> 2] | 0;
                 i64toi32_i32$0 = $3;
                 i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 64 | 0) >> 2] | 0;
                 i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 68 | 0) >> 2] | 0;
                 $15 = i64toi32_i32$3;
                 $15$hi = i64toi32_i32$2;
                 core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9_2(i64toi32_i32$0 + 80 | 0 | 0);
                 if (($1 + $5 | 0) >>> 0 < $2 >>> 0) {
                  break label$5
                 }
                 $460 = $3;
                 i64toi32_i32$2 = $22$hi;
                 $461 = $22;
                 $461$hi = i64toi32_i32$2;
                 i64toi32_i32$2 = $19$hi;
                 $462 = $19;
                 $462$hi = i64toi32_i32$2;
                 i64toi32_i32$2 = $20$hi;
                 i64toi32_i32$0 = $20;
                 i64toi32_i32$3 = 0;
                 i64toi32_i32$1 = 16;
                 i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
                 if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                  i64toi32_i32$3 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
                  $142 = 0;
                 } else {
                  i64toi32_i32$3 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
                  $142 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
                 }
                 $464$hi = i64toi32_i32$3;
                 i64toi32_i32$3 = $462$hi;
                 i64toi32_i32$2 = $462;
                 i64toi32_i32$0 = $464$hi;
                 i64toi32_i32$1 = $142;
                 i64toi32_i32$0 = i64toi32_i32$3 | i64toi32_i32$0 | 0;
                 i64toi32_i32$3 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
                 i64toi32_i32$2 = 0;
                 i64toi32_i32$1 = 32;
                 i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
                 if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                  i64toi32_i32$2 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
                  $143 = 0;
                 } else {
                  i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
                  $143 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
                 }
                 $466$hi = i64toi32_i32$2;
                 i64toi32_i32$2 = $461$hi;
                 i64toi32_i32$0 = $461;
                 i64toi32_i32$3 = $466$hi;
                 i64toi32_i32$1 = $143;
                 i64toi32_i32$3 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
                 $19 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
                 $19$hi = i64toi32_i32$3;
                 $114 = $460;
                 HEAP8[($114 + 101 | 0) >> 0] = $19;
                 HEAP8[($114 + 102 | 0) >> 0] = $19 >>> 8 | 0;
                 HEAP8[($114 + 103 | 0) >> 0] = $19 >>> 16 | 0;
                 HEAP8[($114 + 104 | 0) >> 0] = $19 >>> 24 | 0;
                 $470 = $3 + 105 | 0;
                 i64toi32_i32$2 = $19;
                 i64toi32_i32$0 = 0;
                 i64toi32_i32$1 = 32;
                 i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
                 if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                  i64toi32_i32$0 = 0;
                  $144 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
                 } else {
                  i64toi32_i32$0 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
                  $144 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
                 }
                 $145 = $470;
                 $146 = $144;
                 HEAP8[$145 >> 0] = $146;
                 HEAP8[($145 + 1 | 0) >> 0] = $146 >>> 8 | 0;
                 i64toi32_i32$0 = $21$hi;
                 i64toi32_i32$2 = $3;
                 $115 = $21;
                 HEAP8[(i64toi32_i32$2 + 85 | 0) >> 0] = $115;
                 HEAP8[(i64toi32_i32$2 + 86 | 0) >> 0] = $115 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$2 + 87 | 0) >> 0] = $115 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$2 + 88 | 0) >> 0] = $115 >>> 24 | 0;
                 HEAP8[(i64toi32_i32$2 + 89 | 0) >> 0] = i64toi32_i32$0;
                 HEAP8[(i64toi32_i32$2 + 90 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$2 + 91 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$2 + 92 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
                 HEAP8[(i64toi32_i32$2 + 81 | 0) >> 0] = $6;
                 HEAP8[(i64toi32_i32$2 + 82 | 0) >> 0] = $6 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$2 + 83 | 0) >> 0] = $6 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$2 + 84 | 0) >> 0] = $6 >>> 24 | 0;
                 HEAP8[(i64toi32_i32$2 + 80 | 0) >> 0] = $8;
                 i64toi32_i32$3 = i64toi32_i32$2;
                 i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 80 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 81 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 82 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 83 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 i64toi32_i32$2 = HEAPU8[(i64toi32_i32$2 + 84 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 85 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 86 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 87 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 $481 = i64toi32_i32$0;
                 i64toi32_i32$0 = i64toi32_i32$3;
                 HEAP32[(i64toi32_i32$0 + 40 | 0) >> 2] = $481;
                 HEAP32[(i64toi32_i32$0 + 44 | 0) >> 2] = i64toi32_i32$2;
                 i64toi32_i32$2 = $18$hi;
                 HEAP8[(i64toi32_i32$0 + 93 | 0) >> 0] = $18;
                 HEAP8[(i64toi32_i32$0 + 94 | 0) >> 0] = $18 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$0 + 95 | 0) >> 0] = $18 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$0 + 96 | 0) >> 0] = $18 >>> 24 | 0;
                 HEAP8[(i64toi32_i32$0 + 97 | 0) >> 0] = i64toi32_i32$2;
                 HEAP8[(i64toi32_i32$0 + 98 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$0 + 99 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$0 + 100 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
                 i64toi32_i32$3 = i64toi32_i32$0 + 86 | 0;
                 i64toi32_i32$2 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 i64toi32_i32$0 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 $487 = i64toi32_i32$2;
                 i64toi32_i32$2 = $3;
                 $147 = $487;
                 HEAP16[(i64toi32_i32$2 + 46 | 0) >> 1] = $147;
                 HEAP16[(i64toi32_i32$2 + 48 | 0) >> 1] = $147 >>> 16 | 0;
                 HEAP16[(i64toi32_i32$2 + 50 | 0) >> 1] = i64toi32_i32$0;
                 HEAP16[(i64toi32_i32$2 + 52 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
                 $9 = 1;
                 $2 = ($4 >>> 4 | 0) & 1 | 0;
                 i64toi32_i32$0 = $15$hi;
                 i64toi32_i32$3 = $15;
                 i64toi32_i32$2 = 0;
                 i64toi32_i32$1 = 56;
                 i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
                 if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                  i64toi32_i32$2 = 0;
                  $148 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
                 } else {
                  i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
                  $148 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$4 | 0) | 0;
                 }
                 $1 = $148;
                 i64toi32_i32$2 = $18$hi;
                 i64toi32_i32$0 = $18;
                 i64toi32_i32$3 = 0;
                 i64toi32_i32$1 = 8;
                 i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
                 if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                  i64toi32_i32$3 = 0;
                  $149 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
                 } else {
                  i64toi32_i32$3 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
                  $149 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
                 }
                 $4 = $149;
                 i64toi32_i32$3 = $19$hi;
                 i64toi32_i32$2 = $19;
                 i64toi32_i32$0 = 16776960;
                 i64toi32_i32$1 = 0;
                 i64toi32_i32$0 = i64toi32_i32$3 & i64toi32_i32$0 | 0;
                 i64toi32_i32$3 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
                 i64toi32_i32$2 = 0;
                 i64toi32_i32$1 = 40;
                 i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
                 if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                  i64toi32_i32$2 = 0;
                  $150 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
                 } else {
                  i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
                  $150 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$4 | 0) | 0;
                 }
                 $13 = $150;
                 i64toi32_i32$0 = $3;
                 i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 98 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 99 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 100 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 101 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 i64toi32_i32$3 = HEAPU8[(i64toi32_i32$0 + 102 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 103 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 104 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 105 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 $18 = i64toi32_i32$2;
                 $18$hi = i64toi32_i32$3;
                 $8 = $7;
                 break label$14;
                }
                if ($2 >>> 0 < 57 >>> 0) {
                 break label$8
                }
                if (($2 | 0) != (57 | 0)) {
                 break label$5
                }
                i64toi32_i32$0 = $1 + 26 | 0;
                i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
                i64toi32_i32$2 = 0;
                $15 = i64toi32_i32$3;
                $15$hi = i64toi32_i32$2;
                i64toi32_i32$0 = $1 + 28 | 0;
                i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0;
                i64toi32_i32$3 = 0;
                $19 = i64toi32_i32$2;
                $19$hi = i64toi32_i32$3;
                i64toi32_i32$0 = $1 + 54 | 0;
                i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
                i64toi32_i32$2 = 0;
                $20 = i64toi32_i32$3;
                $20$hi = i64toi32_i32$2;
                $8 = HEAPU8[($1 + 29 | 0) >> 0] | 0;
                i64toi32_i32$0 = $1;
                i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 14 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 15 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 16 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 17 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                i64toi32_i32$3 = HEAPU8[(i64toi32_i32$0 + 18 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 19 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 20 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 21 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                $16 = i64toi32_i32$2;
                $16$hi = i64toi32_i32$3;
                i64toi32_i32$3 = HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 8 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 9 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 10 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 11 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 12 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 13 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                $17 = i64toi32_i32$3;
                $17$hi = i64toi32_i32$2;
                $5 = HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                $6 = HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0;
                i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 22 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 23 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 24 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 25 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                i64toi32_i32$3 = 0;
                $21 = i64toi32_i32$2;
                $21$hi = i64toi32_i32$3;
                i64toi32_i32$3 = HEAPU8[(i64toi32_i32$0 + 50 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 51 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 52 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 53 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                i64toi32_i32$2 = 0;
                $22 = i64toi32_i32$3;
                $22$hi = i64toi32_i32$2;
                i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 42 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 43 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 44 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 45 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                i64toi32_i32$3 = HEAPU8[(i64toi32_i32$0 + 46 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 47 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 48 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 49 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                $18 = i64toi32_i32$2;
                $18$hi = i64toi32_i32$3;
                $2 = HEAPU8[(i64toi32_i32$0 + 30 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 31 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 32 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 33 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                i64toi32_i32$3 = HEAPU8[(i64toi32_i32$0 + 34 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 35 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 36 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 37 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 38 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 39 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 40 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 41 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                $23 = i64toi32_i32$3;
                $23$hi = i64toi32_i32$2;
                i64toi32_i32$0 = i64toi32_i32$0 + 56 | 0;
                i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0;
                i64toi32_i32$3 = 0;
                HEAP8[($3 + 107 | 0) >> 0] = i64toi32_i32$2;
                i64toi32_i32$3 = $20$hi;
                $151 = $3 + 105 | 0;
                HEAP8[$151 >> 0] = $20;
                HEAP8[($151 + 1 | 0) >> 0] = $20 >>> 8 | 0;
                i64toi32_i32$3 = $23$hi;
                i64toi32_i32$2 = $3;
                $116 = $23;
                HEAP8[(i64toi32_i32$2 + 85 | 0) >> 0] = $116;
                HEAP8[(i64toi32_i32$2 + 86 | 0) >> 0] = $116 >>> 8 | 0;
                HEAP8[(i64toi32_i32$2 + 87 | 0) >> 0] = $116 >>> 16 | 0;
                HEAP8[(i64toi32_i32$2 + 88 | 0) >> 0] = $116 >>> 24 | 0;
                HEAP8[(i64toi32_i32$2 + 89 | 0) >> 0] = i64toi32_i32$3;
                HEAP8[(i64toi32_i32$2 + 90 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
                HEAP8[(i64toi32_i32$2 + 91 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
                HEAP8[(i64toi32_i32$2 + 92 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
                HEAP8[(i64toi32_i32$2 + 81 | 0) >> 0] = $2;
                HEAP8[(i64toi32_i32$2 + 82 | 0) >> 0] = $2 >>> 8 | 0;
                HEAP8[(i64toi32_i32$2 + 83 | 0) >> 0] = $2 >>> 16 | 0;
                HEAP8[(i64toi32_i32$2 + 84 | 0) >> 0] = $2 >>> 24 | 0;
                i64toi32_i32$3 = $18$hi;
                HEAP8[(i64toi32_i32$2 + 93 | 0) >> 0] = $18;
                HEAP8[(i64toi32_i32$2 + 94 | 0) >> 0] = $18 >>> 8 | 0;
                HEAP8[(i64toi32_i32$2 + 95 | 0) >> 0] = $18 >>> 16 | 0;
                HEAP8[(i64toi32_i32$2 + 96 | 0) >> 0] = $18 >>> 24 | 0;
                HEAP8[(i64toi32_i32$2 + 97 | 0) >> 0] = i64toi32_i32$3;
                HEAP8[(i64toi32_i32$2 + 98 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
                HEAP8[(i64toi32_i32$2 + 99 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
                HEAP8[(i64toi32_i32$2 + 100 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
                i64toi32_i32$3 = $22$hi;
                $117 = $22;
                HEAP8[(i64toi32_i32$2 + 101 | 0) >> 0] = $117;
                HEAP8[(i64toi32_i32$2 + 102 | 0) >> 0] = $117 >>> 8 | 0;
                HEAP8[(i64toi32_i32$2 + 103 | 0) >> 0] = $117 >>> 16 | 0;
                HEAP8[(i64toi32_i32$2 + 104 | 0) >> 0] = $117 >>> 24 | 0;
                i64toi32_i32$0 = i64toi32_i32$2;
                i64toi32_i32$3 = HEAPU8[(i64toi32_i32$2 + 82 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 83 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 84 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 85 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                i64toi32_i32$2 = HEAPU8[(i64toi32_i32$2 + 86 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 87 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 88 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 89 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                $555 = i64toi32_i32$3;
                i64toi32_i32$3 = i64toi32_i32$0;
                HEAP32[(i64toi32_i32$0 + 40 | 0) >> 2] = $555;
                HEAP32[(i64toi32_i32$0 + 44 | 0) >> 2] = i64toi32_i32$2;
                i64toi32_i32$0 = i64toi32_i32$0 + 88 | 0;
                i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                i64toi32_i32$3 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                $559 = i64toi32_i32$2;
                i64toi32_i32$2 = $3;
                $152 = $559;
                HEAP16[(i64toi32_i32$2 + 46 | 0) >> 1] = $152;
                HEAP16[(i64toi32_i32$2 + 48 | 0) >> 1] = $152 >>> 16 | 0;
                HEAP16[(i64toi32_i32$2 + 50 | 0) >> 1] = i64toi32_i32$3;
                HEAP16[(i64toi32_i32$2 + 52 | 0) >> 1] = i64toi32_i32$3 >>> 16 | 0;
                i64toi32_i32$3 = $21$hi;
                $560 = $21;
                $560$hi = i64toi32_i32$3;
                i64toi32_i32$3 = $15$hi;
                $561 = $15;
                $561$hi = i64toi32_i32$3;
                i64toi32_i32$3 = $19$hi;
                i64toi32_i32$0 = $19;
                i64toi32_i32$2 = 0;
                i64toi32_i32$1 = 16;
                i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
                if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                 i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
                 $153 = 0;
                } else {
                 i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$4 | 0) | 0;
                 $153 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
                }
                $563$hi = i64toi32_i32$2;
                i64toi32_i32$2 = $561$hi;
                i64toi32_i32$3 = $561;
                i64toi32_i32$0 = $563$hi;
                i64toi32_i32$1 = $153;
                i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
                i64toi32_i32$2 = i64toi32_i32$3 | i64toi32_i32$1 | 0;
                i64toi32_i32$3 = 0;
                i64toi32_i32$1 = 32;
                i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
                if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                 i64toi32_i32$3 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
                 $154 = 0;
                } else {
                 i64toi32_i32$3 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
                 $154 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
                }
                $565$hi = i64toi32_i32$3;
                i64toi32_i32$3 = $560$hi;
                i64toi32_i32$0 = $560;
                i64toi32_i32$2 = $565$hi;
                i64toi32_i32$1 = $154;
                i64toi32_i32$2 = i64toi32_i32$3 | i64toi32_i32$2 | 0;
                $15 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
                $15$hi = i64toi32_i32$2;
                $1 = ($4 >>> 5 | 0) & 1 | 0;
                $10 = ($4 >>> 4 | 0) & 1 | 0;
                i64toi32_i32$2 = $18$hi;
                i64toi32_i32$3 = $18;
                i64toi32_i32$0 = 0;
                i64toi32_i32$1 = 24;
                i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
                if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                 i64toi32_i32$0 = 0;
                 $155 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
                } else {
                 i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
                 $155 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$4 | 0) | 0;
                }
                $4 = $155;
                i64toi32_i32$2 = $3;
                i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 100 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 101 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 102 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 103 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                i64toi32_i32$3 = HEAPU8[(i64toi32_i32$2 + 104 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 105 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 106 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 107 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                $18 = i64toi32_i32$0;
                $18$hi = i64toi32_i32$3;
                $9 = 0;
               }
               i64toi32_i32$2 = $3;
               i64toi32_i32$3 = HEAPU16[(i64toi32_i32$2 + 46 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 48 | 0) >> 1] | 0) << 16 | 0) | 0;
               i64toi32_i32$0 = HEAPU16[(i64toi32_i32$2 + 50 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 52 | 0) >> 1] | 0) << 16 | 0) | 0;
               $580 = i64toi32_i32$3;
               i64toi32_i32$3 = i64toi32_i32$2;
               $156 = $580;
               HEAP16[(i64toi32_i32$2 + 30 | 0) >> 1] = $156;
               HEAP16[(i64toi32_i32$2 + 32 | 0) >> 1] = $156 >>> 16 | 0;
               HEAP16[(i64toi32_i32$2 + 34 | 0) >> 1] = i64toi32_i32$0;
               HEAP16[(i64toi32_i32$2 + 36 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
               i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
               i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] | 0;
               $583 = i64toi32_i32$0;
               i64toi32_i32$0 = i64toi32_i32$2;
               HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] = $583;
               HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] = i64toi32_i32$3;
               $585 = $0 + 38 | 0;
               i64toi32_i32$3 = $15$hi;
               i64toi32_i32$2 = $15;
               i64toi32_i32$0 = 0;
               i64toi32_i32$1 = 48;
               i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
               if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                i64toi32_i32$0 = 0;
                $158 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
               } else {
                i64toi32_i32$0 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
                $158 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
               }
               HEAP8[$585 >> 0] = $158;
               $589 = $0 + 36 | 0;
               i64toi32_i32$0 = $15$hi;
               i64toi32_i32$3 = $15;
               i64toi32_i32$2 = 0;
               i64toi32_i32$1 = 32;
               i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
               if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                i64toi32_i32$2 = 0;
                $159 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
               } else {
                i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
                $159 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$4 | 0) | 0;
               }
               HEAP16[$589 >> 1] = $159;
               i64toi32_i32$2 = $15$hi;
               HEAP32[($0 + 32 | 0) >> 2] = $15;
               HEAP8[($0 + 41 | 0) >> 0] = $2;
               HEAP8[($0 + 40 | 0) >> 0] = $8;
               HEAP8[($0 + 39 | 0) >> 0] = $1;
               i64toi32_i32$2 = $16$hi;
               i64toi32_i32$3 = $0 + 24 | 0;
               HEAP32[i64toi32_i32$3 >> 2] = $16;
               HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
               i64toi32_i32$2 = $17$hi;
               i64toi32_i32$3 = $0 + 16 | 0;
               HEAP32[i64toi32_i32$3 >> 2] = $17;
               HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
               HEAP32[($0 + 12 | 0) >> 2] = $5;
               HEAP8[($0 + 11 | 0) >> 0] = $6;
               HEAP8[($0 + 10 | 0) >> 0] = $10;
               HEAP8[($0 + 9 | 0) >> 0] = $7;
               HEAP8[($0 + 8 | 0) >> 0] = $9;
               i64toi32_i32$0 = $3;
               i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] | 0;
               i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] | 0;
               $621 = i64toi32_i32$2;
               i64toi32_i32$2 = $0;
               $161 = $621;
               HEAP16[(i64toi32_i32$2 + 42 | 0) >> 1] = $161;
               HEAP16[(i64toi32_i32$2 + 44 | 0) >> 1] = $161 >>> 16 | 0;
               HEAP16[(i64toi32_i32$2 + 46 | 0) >> 1] = i64toi32_i32$3;
               HEAP16[(i64toi32_i32$2 + 48 | 0) >> 1] = i64toi32_i32$3 >>> 16 | 0;
               i64toi32_i32$3 = HEAPU16[(i64toi32_i32$0 + 30 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$0 + 32 | 0) >> 1] | 0) << 16 | 0) | 0;
               i64toi32_i32$2 = HEAPU16[(i64toi32_i32$0 + 34 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$0 + 36 | 0) >> 1] | 0) << 16 | 0) | 0;
               $625 = i64toi32_i32$3;
               i64toi32_i32$3 = $0 + 48 | 0;
               $162 = $625;
               HEAP16[i64toi32_i32$3 >> 1] = $162;
               HEAP16[(i64toi32_i32$3 + 2 | 0) >> 1] = $162 >>> 16 | 0;
               HEAP16[(i64toi32_i32$3 + 4 | 0) >> 1] = i64toi32_i32$2;
               HEAP16[(i64toi32_i32$3 + 6 | 0) >> 1] = i64toi32_i32$2 >>> 16 | 0;
               HEAP32[($0 + 68 | 0) >> 2] = $13;
               i64toi32_i32$2 = $18$hi;
               i64toi32_i32$3 = $0;
               HEAP32[(i64toi32_i32$3 + 60 | 0) >> 2] = $18;
               HEAP32[(i64toi32_i32$3 + 64 | 0) >> 2] = i64toi32_i32$2;
               HEAP32[(i64toi32_i32$3 + 56 | 0) >> 2] = $4;
               i64toi32_i32$2 = 0;
               $15 = 0;
               $15$hi = i64toi32_i32$2;
               break label$1;
              }
              i64toi32_i32$2 = 0;
              i64toi32_i32$0 = $2;
              i64toi32_i32$3 = 0;
              i64toi32_i32$1 = 32;
              i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
              if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
               i64toi32_i32$3 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
               $163 = 0;
              } else {
               i64toi32_i32$3 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
               $163 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
              }
              i64toi32_i32$2 = $163;
              i64toi32_i32$0 = 0;
              i64toi32_i32$1 = 8;
              i64toi32_i32$0 = i64toi32_i32$3 | i64toi32_i32$0 | 0;
              $18 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
              $18$hi = i64toi32_i32$0;
              break label$6;
             }
             i64toi32_i32$0 = 0;
             $16 = 32;
             $16$hi = i64toi32_i32$0;
             i64toi32_i32$0 = 0;
             i64toi32_i32$3 = $2;
             i64toi32_i32$2 = 0;
             i64toi32_i32$1 = 32;
             i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
             if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
              i64toi32_i32$2 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
              $164 = 0;
             } else {
              i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
              $164 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
             }
             i64toi32_i32$0 = $164;
             i64toi32_i32$3 = 0;
             i64toi32_i32$1 = 8;
             i64toi32_i32$3 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
             $18 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
             $18$hi = i64toi32_i32$3;
             break label$4;
            }
            core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($5 | 0, $2 | 0, 1070448 | 0);
            abort();
           }
           core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($5 | 0, $2 | 0, 1070488 | 0);
           abort();
          }
          i64toi32_i32$2 = $3 + 114 | 0;
          i64toi32_i32$3 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
          i64toi32_i32$0 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
          $649 = i64toi32_i32$3;
          i64toi32_i32$3 = $3;
          HEAP32[(i64toi32_i32$3 + 24 | 0) >> 2] = $649;
          HEAP32[(i64toi32_i32$3 + 28 | 0) >> 2] = i64toi32_i32$0;
          i64toi32_i32$2 = i64toi32_i32$3 + 120 | 0;
          i64toi32_i32$0 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
          i64toi32_i32$3 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
          $653 = i64toi32_i32$0;
          i64toi32_i32$0 = $3;
          $165 = $653;
          HEAP16[(i64toi32_i32$0 + 30 | 0) >> 1] = $165;
          HEAP16[(i64toi32_i32$0 + 32 | 0) >> 1] = $165 >>> 16 | 0;
          HEAP16[(i64toi32_i32$0 + 34 | 0) >> 1] = i64toi32_i32$3;
          HEAP16[(i64toi32_i32$0 + 36 | 0) >> 1] = i64toi32_i32$3 >>> 16 | 0;
          $5 = HEAP32[(i64toi32_i32$0 + 80 | 0) >> 2] | 0;
          $11 = $5 >>> 24 | 0;
          $12 = $5 >>> 16 | 0;
          $4 = $5 >>> 8 | 0;
          i64toi32_i32$2 = (i64toi32_i32$0 + 80 | 0) + 24 | 0;
          i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
          i64toi32_i32$0 = 0;
          $665 = i64toi32_i32$3;
          $665$hi = i64toi32_i32$0;
          i64toi32_i32$2 = $3 + 108 | 0;
          i64toi32_i32$0 = HEAPU16[i64toi32_i32$2 >> 1] | 0;
          i64toi32_i32$3 = 0;
          $668 = i64toi32_i32$0;
          $668$hi = i64toi32_i32$3;
          i64toi32_i32$2 = $3 + 110 | 0;
          i64toi32_i32$3 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
          i64toi32_i32$0 = 0;
          i64toi32_i32$2 = i64toi32_i32$3;
          i64toi32_i32$3 = 0;
          i64toi32_i32$1 = 16;
          i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
          if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
           i64toi32_i32$3 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
           $166 = 0;
          } else {
           i64toi32_i32$3 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
           $166 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
          }
          $672$hi = i64toi32_i32$3;
          i64toi32_i32$3 = $668$hi;
          i64toi32_i32$0 = $668;
          i64toi32_i32$2 = $672$hi;
          i64toi32_i32$1 = $166;
          i64toi32_i32$2 = i64toi32_i32$3 | i64toi32_i32$2 | 0;
          i64toi32_i32$3 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
          i64toi32_i32$0 = 0;
          i64toi32_i32$1 = 32;
          i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
          if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
           i64toi32_i32$0 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
           $167 = 0;
          } else {
           i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
           $167 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
          }
          $674$hi = i64toi32_i32$0;
          i64toi32_i32$0 = $665$hi;
          i64toi32_i32$2 = $665;
          i64toi32_i32$3 = $674$hi;
          i64toi32_i32$1 = $167;
          i64toi32_i32$3 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
          $15 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
          $15$hi = i64toi32_i32$3;
          $13 = HEAPU8[($3 + 113 | 0) >> 0] | 0;
          $10 = HEAPU8[($3 + 112 | 0) >> 0] | 0;
          $9 = HEAPU8[($3 + 111 | 0) >> 0] | 0;
          i64toi32_i32$0 = ($3 + 80 | 0) + 16 | 0;
          i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
          i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
          $16 = i64toi32_i32$3;
          $16$hi = i64toi32_i32$2;
          i64toi32_i32$0 = ($3 + 80 | 0) + 8 | 0;
          i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
          i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
          $18 = i64toi32_i32$2;
          $18$hi = i64toi32_i32$3;
          i64toi32_i32$0 = $3 + 132 | 0;
          i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
          i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
          $17 = i64toi32_i32$3;
          $17$hi = i64toi32_i32$2;
          break label$7;
         }
         i64toi32_i32$2 = 0;
         i64toi32_i32$0 = $2;
         i64toi32_i32$3 = 0;
         i64toi32_i32$1 = 32;
         i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
          i64toi32_i32$3 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
          $168 = 0;
         } else {
          i64toi32_i32$3 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
          $168 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
         }
         i64toi32_i32$2 = $168;
         i64toi32_i32$0 = 0;
         i64toi32_i32$1 = 8;
         i64toi32_i32$0 = i64toi32_i32$3 | i64toi32_i32$0 | 0;
         $18 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
         $18$hi = i64toi32_i32$0;
         $5 = 2;
         i64toi32_i32$0 = 0;
         $16 = 57;
         $16$hi = i64toi32_i32$0;
         break label$3;
        }
        $14 = HEAP32[($3 + 84 | 0) >> 2] | 0;
        $6 = HEAP32[($3 + 128 | 0) >> 2] | 0;
        $8 = HEAP32[($3 + 140 | 0) >> 2] | 0;
        break label$2;
       }
       $5 = 2;
       i64toi32_i32$0 = 0;
       $16 = 29;
       $16$hi = i64toi32_i32$0;
       break label$3;
      }
      $5 = 2;
      i64toi32_i32$0 = 0;
      $18 = 17;
      $18$hi = i64toi32_i32$0;
      i64toi32_i32$0 = 0;
      $16 = 0;
      $16$hi = i64toi32_i32$0;
      break label$3;
     }
     $5 = 2;
    }
    $6 = 0;
   }
   $707 = $3 + 110 | 0;
   i64toi32_i32$0 = $15$hi;
   i64toi32_i32$3 = $15;
   i64toi32_i32$2 = 0;
   i64toi32_i32$1 = 48;
   i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
    i64toi32_i32$2 = 0;
    $169 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   } else {
    i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
    $169 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$4 | 0) | 0;
   }
   HEAP8[$707 >> 0] = $169;
   $711 = $3 + 108 | 0;
   i64toi32_i32$2 = $15$hi;
   i64toi32_i32$0 = $15;
   i64toi32_i32$3 = 0;
   i64toi32_i32$1 = 32;
   i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
    i64toi32_i32$3 = 0;
    $170 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   } else {
    i64toi32_i32$3 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
    $170 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
   }
   HEAP16[$711 >> 1] = $170;
   i64toi32_i32$3 = $15$hi;
   HEAP32[($3 + 104 | 0) >> 2] = $15;
   HEAP8[($3 + 113 | 0) >> 0] = $13;
   HEAP8[($3 + 112 | 0) >> 0] = $10;
   HEAP8[($3 + 111 | 0) >> 0] = $9;
   i64toi32_i32$3 = $16$hi;
   i64toi32_i32$0 = $3 + 96 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $16;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$3 = $18$hi;
   i64toi32_i32$0 = ($3 + 80 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $18;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$2 = $3;
   i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
   $736 = i64toi32_i32$3;
   i64toi32_i32$3 = i64toi32_i32$2 + 114 | 0;
   $171 = $736;
   HEAP16[i64toi32_i32$3 >> 1] = $171;
   HEAP16[(i64toi32_i32$3 + 2 | 0) >> 1] = $171 >>> 16 | 0;
   HEAP16[(i64toi32_i32$3 + 4 | 0) >> 1] = i64toi32_i32$0;
   HEAP16[(i64toi32_i32$3 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
   i64toi32_i32$0 = HEAPU16[(i64toi32_i32$2 + 30 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 32 | 0) >> 1] | 0) << 16 | 0) | 0;
   i64toi32_i32$3 = HEAPU16[(i64toi32_i32$2 + 34 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 36 | 0) >> 1] | 0) << 16 | 0) | 0;
   $740 = i64toi32_i32$0;
   i64toi32_i32$0 = i64toi32_i32$2 + 120 | 0;
   $172 = $740;
   HEAP16[i64toi32_i32$0 >> 1] = $172;
   HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $172 >>> 16 | 0;
   HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$3;
   HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$3 >>> 16 | 0;
   i64toi32_i32$3 = $17$hi;
   i64toi32_i32$0 = i64toi32_i32$2 + 132 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $17;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
   HEAP32[(i64toi32_i32$2 + 84 | 0) >> 2] = $14;
   HEAP8[(i64toi32_i32$2 + 83 | 0) >> 0] = $11;
   HEAP8[(i64toi32_i32$2 + 82 | 0) >> 0] = $12;
   HEAP8[(i64toi32_i32$2 + 81 | 0) >> 0] = $4;
   HEAP8[(i64toi32_i32$2 + 80 | 0) >> 0] = $5;
   HEAP32[(i64toi32_i32$2 + 140 | 0) >> 2] = $8;
   HEAP32[(i64toi32_i32$2 + 128 | 0) >> 2] = $6;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, i64toi32_i32$2 + 80 | 0 | 0, 1070404 | 0, 7 | 0);
   i64toi32_i32$3 = 0;
   $15 = 1;
   $15$hi = i64toi32_i32$3;
  }
  i64toi32_i32$3 = $15$hi;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $15;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
  global$0 = $3 + 144 | 0;
 }
 
 function cardano_serialization_lib__metadata__decode_metadatum_to_json_value__h971c762f0ec03432($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, $11$hi = 0, $11 = 0, $5 = 0, $4 = 0, $12 = 0, $12$hi = 0, $6 = 0, $9 = 0, $55 = 0, $56 = 0, $57 = 0, $7 = 0, $10 = 0, $58 = 0, $59 = 0, $60 = 0, $13 = 0, $65 = 0, $72 = 0, $75 = 0, $84 = 0, $84$hi = 0, $86$hi = 0, $88 = 0, $89$hi = 0, $182 = 0, $226 = 0, $8 = 0, $300 = 0, $300$hi = 0, $302$hi = 0, $304 = 0, $305$hi = 0, $416 = 0, $13$hi = 0, $456 = 0, $492 = 0, $551 = 0, $558 = 0, $561 = 0, $574 = 0, $583 = 0, $586 = 0, $594 = 0, $598 = 0, $602 = 0, $616 = 0, $621 = 0, $626 = 0, $629 = 0, $652 = 0;
  $3 = global$0 - 304 | 0;
  global$0 = $3;
  HEAP8[($3 + 63 | 0) >> 0] = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           label$10 : {
            label$11 : {
             label$12 : {
              label$13 : {
               label$14 : {
                label$15 : {
                 switch (HEAP32[$1 >> 2] | 0 | 0) {
                 case 3:
                  $1 = $1 + 4 | 0;
                  switch ($2 & 255 | 0 | 0) {
                  case 2:
                   break label$13;
                  case 1:
                   break label$14;
                  default:
                   break label$8;
                  };
                 case 1:
                  break label$10;
                 case 2:
                  break label$11;
                 case 4:
                  break label$15;
                 default:
                  break label$9;
                 };
                }
                $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($3 + 160 | 0 | 0, $1 + 4 | 0 | 0);
                serde_json__value__from___impl_20core__convert__From_alloc__string__String__20for_20serde_json__value__Value___from__h17ccd46b161e8e23($3 + 64 | 0 | 0, $3 + 160 | 0 | 0);
                $4 = 1059383;
                $5 = 6;
                break label$2;
               }
               $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 40 | 0 | 0, $1 | 0);
               cardano_serialization_lib__metadata__bytes_to_hex_string__hd72671f689198069($3 + 208 | 0 | 0, HEAP32[($3 + 40 | 0) >> 2] | 0 | 0, HEAP32[($3 + 44 | 0) >> 2] | 0 | 0);
               serde_json__value__from___impl_20core__convert__From_alloc__string__String__20for_20serde_json__value__Value___from__h17ccd46b161e8e23($3 + 160 | 0 | 0, $3 + 208 | 0 | 0);
               break label$12;
              }
              $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 48 | 0 | 0, $1 | 0);
              hex__encode_to_iter__h3b9b5dcb85c2c5cd($3 + 208 | 0 | 0, 1067368 | 0, HEAP32[($3 + 48 | 0) >> 2] | 0 | 0, HEAP32[($3 + 52 | 0) >> 2] | 0 | 0);
              serde_json__value__from___impl_20core__convert__From_alloc__string__String__20for_20serde_json__value__Value___from__h17ccd46b161e8e23($3 + 160 | 0 | 0, $3 + 208 | 0 | 0);
             }
             i64toi32_i32$2 = ($3 + 160 | 0) + 16 | 0;
             i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
             i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
             $65 = i64toi32_i32$0;
             i64toi32_i32$0 = ($3 + 64 | 0) + 16 | 0;
             HEAP32[i64toi32_i32$0 >> 2] = $65;
             HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
             i64toi32_i32$2 = ($3 + 160 | 0) + 8 | 0;
             i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
             i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
             $72 = i64toi32_i32$1;
             i64toi32_i32$1 = ($3 + 64 | 0) + 8 | 0;
             HEAP32[i64toi32_i32$1 >> 2] = $72;
             HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
             i64toi32_i32$2 = $3;
             i64toi32_i32$0 = HEAP32[($3 + 160 | 0) >> 2] | 0;
             i64toi32_i32$1 = HEAP32[($3 + 164 | 0) >> 2] | 0;
             $75 = i64toi32_i32$0;
             i64toi32_i32$0 = $3;
             HEAP32[($3 + 64 | 0) >> 2] = $75;
             HEAP32[($3 + 68 | 0) >> 2] = i64toi32_i32$1;
             $4 = 1059389;
             $5 = 5;
             break label$2;
            }
            i64toi32_i32$2 = $1 + 8 | 0;
            i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
            i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
            $11 = i64toi32_i32$1;
            $11$hi = i64toi32_i32$0;
            label$17 : {
             label$18 : {
              label$19 : {
               i64toi32_i32$2 = $1 + 16 | 0;
               i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
               i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
               $12 = i64toi32_i32$0;
               $12$hi = i64toi32_i32$1;
               i64toi32_i32$2 = i64toi32_i32$0;
               i64toi32_i32$0 = -1;
               i64toi32_i32$3 = -1;
               if ((i64toi32_i32$1 | 0) > (i64toi32_i32$0 | 0)) {
                $55 = 1
               } else {
                if ((i64toi32_i32$1 | 0) >= (i64toi32_i32$0 | 0)) {
                 if (i64toi32_i32$2 >>> 0 <= i64toi32_i32$3 >>> 0) {
                  $56 = 0
                 } else {
                  $56 = 1
                 }
                 $57 = $56;
                } else {
                 $57 = 0
                }
                $55 = $57;
               }
               if ($55) {
                break label$19
               }
               i64toi32_i32$2 = $12$hi;
               $84 = $12;
               $84$hi = i64toi32_i32$2;
               i64toi32_i32$2 = $11$hi;
               i64toi32_i32$3 = $11;
               i64toi32_i32$1 = -2147483648;
               i64toi32_i32$0 = 0;
               i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
               i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
               if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
                i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
               }
               $86$hi = i64toi32_i32$5;
               i64toi32_i32$5 = $11$hi;
               i64toi32_i32$5 = $86$hi;
               i64toi32_i32$2 = i64toi32_i32$4;
               i64toi32_i32$3 = $11$hi;
               i64toi32_i32$0 = $11;
               $88 = i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$0 >>> 0 | 0) | 0;
               i64toi32_i32$2 = 0;
               $89$hi = i64toi32_i32$2;
               i64toi32_i32$2 = $84$hi;
               i64toi32_i32$0 = $84;
               i64toi32_i32$5 = $89$hi;
               i64toi32_i32$3 = $88;
               i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
               i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
               if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
                i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
               }
               if (!(i64toi32_i32$1 | i64toi32_i32$4 | 0)) {
                break label$18
               }
               i64toi32_i32$0 = $3;
               i64toi32_i32$4 = 0;
               HEAP32[($3 + 260 | 0) >> 2] = 0;
               HEAP32[($3 + 264 | 0) >> 2] = i64toi32_i32$4;
               HEAP32[($3 + 256 | 0) >> 2] = HEAP32[(0 + 1059260 | 0) >> 2] | 0;
               core__fmt__Formatter__new__he219faf25326051b($3 + 160 | 0 | 0, $3 + 256 | 0 | 0, 1058944 | 0);
               if (!($core__num__error__TryFromIntError_20as_20core__fmt__Display___fmt__h0b3586d20b4066db($3 + 296 | 0 | 0, $3 + 160 | 0 | 0) | 0)) {
                break label$17
               }
               core__result__unwrap_failed__h27f43d993c3864a1(1058968 | 0, 55 | 0, $3 + 296 | 0 | 0, 1059160 | 0, 1059100 | 0);
               abort();
              }
              label$20 : {
               i64toi32_i32$4 = $12$hi;
               if (!($12 | i64toi32_i32$4 | 0)) {
                break label$20
               }
               i64toi32_i32$0 = $3;
               i64toi32_i32$4 = 0;
               HEAP32[($3 + 260 | 0) >> 2] = 0;
               HEAP32[($3 + 264 | 0) >> 2] = i64toi32_i32$4;
               HEAP32[($3 + 256 | 0) >> 2] = HEAP32[(0 + 1059260 | 0) >> 2] | 0;
               core__fmt__Formatter__new__he219faf25326051b($3 + 160 | 0 | 0, $3 + 256 | 0 | 0, 1058944 | 0);
               if ($core__num__error__TryFromIntError_20as_20core__fmt__Display___fmt__h0b3586d20b4066db($3 + 296 | 0 | 0, $3 + 160 | 0 | 0) | 0) {
                break label$7
               }
               $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 24 | 0 | 0, $3 + 256 | 0 | 0);
               $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($3 + 24 | 0) >> 2] | 0 | 0, HEAP32[($3 + 28 | 0) >> 2] | 0 | 0) | 0;
               $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 256 | 0 | 0);
               $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 256 | 0 | 0);
               break label$3;
              }
              i64toi32_i32$4 = $11$hi;
              serde_json__value__from___impl_20core__convert__From_u64__20for_20serde_json__value__Value___from__h063d95b839f3c127($3 + 208 | 0 | 0, $11 | 0, i64toi32_i32$4 | 0);
              break label$4;
             }
             i64toi32_i32$4 = $11$hi;
             serde_json__value__from___impl_20core__convert__From_i64__20for_20serde_json__value__Value___from__hddac0ae92fa83545($3 + 208 | 0 | 0, $11 | 0, i64toi32_i32$4 | 0);
             break label$4;
            }
            $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 32 | 0 | 0, $3 + 256 | 0 | 0);
            $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($3 + 32 | 0) >> 2] | 0 | 0, HEAP32[($3 + 36 | 0) >> 2] | 0 | 0) | 0;
            $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 256 | 0 | 0);
            $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 256 | 0 | 0);
            break label$3;
           }
           $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
           $1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
           HEAP32[($3 + 208 | 0) >> 2] = $1;
           HEAP32[($3 + 212 | 0) >> 2] = $1 + Math_imul($2, 48) | 0;
           HEAP32[($3 + 216 | 0) >> 2] = $3 + 63 | 0;
           core__iter__adapters__process_results__h7123a39a50c5e464($3 + 160 | 0 | 0, $3 + 208 | 0 | 0);
           $1 = HEAP32[($3 + 164 | 0) >> 2] | 0;
           label$21 : {
            if ((HEAP32[($3 + 160 | 0) >> 2] | 0 | 0) == (1 | 0)) {
             break label$21
            }
            HEAP32[($3 + 256 | 0) >> 2] = $1;
            i64toi32_i32$2 = $3 + 168 | 0;
            i64toi32_i32$4 = HEAP32[i64toi32_i32$2 >> 2] | 0;
            i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
            $182 = i64toi32_i32$4;
            i64toi32_i32$4 = $3;
            HEAP32[($3 + 260 | 0) >> 2] = $182;
            HEAP32[($3 + 264 | 0) >> 2] = i64toi32_i32$0;
            serde_json__value__from___impl_20core__convert__From_alloc__vec__Vec_T___20for_20serde_json__value__Value___from__h2b11e91c39ca0ab7($3 + 64 | 0 | 0, $3 + 256 | 0 | 0);
            $4 = 1059434;
            $5 = 4;
            break label$2;
           }
           $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($1 | 0) | 0;
           HEAP32[$0 >> 2] = 1;
           HEAP32[($0 + 4 | 0) >> 2] = $1;
           break label$1;
          }
          if (($2 & 255 | 0) >>> 0 < 2 >>> 0) {
           break label$6
          }
          label$22 : {
           label$23 : {
            $2 = HEAP32[($1 + 40 | 0) >> 2] | 0;
            if ($2) {
             break label$23
            }
            $4 = 0;
            break label$22;
           }
           $4 = HEAP32[($2 + 100 | 0) >> 2] | 0;
          }
          HEAP32[($3 + 168 | 0) >> 2] = HEAP32[($1 + 36 | 0) >> 2] | 0;
          HEAP32[($3 + 164 | 0) >> 2] = $2;
          HEAP32[($3 + 160 | 0) >> 2] = $4;
          HEAP32[($3 + 172 | 0) >> 2] = $3 + 63 | 0;
          core__iter__adapters__process_results__hc60f8edd7805cc59($3 + 208 | 0 | 0, $3 + 160 | 0 | 0);
          $1 = HEAP32[($3 + 212 | 0) >> 2] | 0;
          label$24 : {
           if ((HEAP32[($3 + 208 | 0) >> 2] | 0 | 0) == (1 | 0)) {
            break label$24
           }
           HEAP32[($3 + 256 | 0) >> 2] = $1;
           i64toi32_i32$2 = $3 + 216 | 0;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
           i64toi32_i32$4 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
           $226 = i64toi32_i32$0;
           i64toi32_i32$0 = $3;
           HEAP32[($3 + 260 | 0) >> 2] = $226;
           HEAP32[($3 + 264 | 0) >> 2] = i64toi32_i32$4;
           serde_json__value__from___impl_20core__convert__From_alloc__vec__Vec_T___20for_20serde_json__value__Value___from__h2b11e91c39ca0ab7($3 + 64 | 0 | 0, $3 + 256 | 0 | 0);
           break label$5;
          }
          $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($1 | 0) | 0;
          HEAP32[$0 >> 2] = 1;
          HEAP32[($0 + 4 | 0) >> 2] = $1;
          break label$1;
         }
         $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1059702 | 0, 45 | 0) | 0 | 0) | 0;
         HEAP32[$0 >> 2] = 1;
         HEAP32[($0 + 4 | 0) >> 2] = $1;
         break label$1;
        }
        core__result__unwrap_failed__h27f43d993c3864a1(1058968 | 0, 55 | 0, $3 + 296 | 0 | 0, 1059160 | 0, 1059100 | 0);
        abort();
       }
       alloc__collections__btree__map__BTreeMap_K_2cV___new__h241ee1a6e88d54c0($3 + 88 | 0 | 0);
       label$25 : {
        label$26 : {
         label$27 : {
          label$28 : {
           label$29 : {
            label$30 : {
             label$31 : {
              label$32 : {
               $6 = HEAP32[($1 + 40 | 0) >> 2] | 0;
               if (!$6) {
                break label$32
               }
               $1 = HEAP32[($6 + 100 | 0) >> 2] | 0;
               if (($1 | 0) == ($6 | 0)) {
                break label$32
               }
               if (!$1) {
                break label$32
               }
               $2 = ($3 + 160 | 0) + 8 | 0;
               $7 = $3 + 160 | 0 | 4 | 0;
               $8 = ($3 + 208 | 0) + 4 | 0;
               $9 = HEAP32[(0 + 1059260 | 0) >> 2] | 0;
               $10 = $3 + 144 | 0 | 4 | 0;
               label$33 : while (1) {
                $4 = HEAP32[($1 + 100 | 0) >> 2] | 0;
                $5 = HEAPU8[($3 + 63 | 0) >> 0] | 0;
                label$34 : {
                 label$35 : {
                  label$36 : {
                   label$37 : {
                    label$38 : {
                     label$39 : {
                      label$40 : {
                       switch (HEAP32[$1 >> 2] | 0 | 0) {
                       case 3:
                        if ($5 & 255 | 0) {
                         break label$39
                        }
                        break label$27;
                       case 0:
                        break label$36;
                       case 1:
                        break label$37;
                       case 2:
                        break label$38;
                       case 4:
                        break label$40;
                       default:
                        break label$27;
                       };
                      }
                      $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($10 | 0, $1 + 4 | 0 | 0);
                      break label$34;
                     }
                     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 16 | 0 | 0, $1 + 4 | 0 | 0);
                     cardano_serialization_lib__metadata__bytes_to_hex_string__hd72671f689198069($10 | 0, HEAP32[($3 + 16 | 0) >> 2] | 0 | 0, HEAP32[($3 + 20 | 0) >> 2] | 0 | 0);
                     break label$34;
                    }
                    if (!($5 & 255 | 0)) {
                     break label$27
                    }
                    i64toi32_i32$2 = $1;
                    i64toi32_i32$4 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
                    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
                    $11 = i64toi32_i32$4;
                    $11$hi = i64toi32_i32$0;
                    label$42 : {
                     label$43 : {
                      label$44 : {
                       i64toi32_i32$2 = i64toi32_i32$2 + 16 | 0;
                       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                       i64toi32_i32$4 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                       $12 = i64toi32_i32$0;
                       $12$hi = i64toi32_i32$4;
                       i64toi32_i32$2 = i64toi32_i32$0;
                       i64toi32_i32$0 = -1;
                       i64toi32_i32$3 = -1;
                       if ((i64toi32_i32$4 | 0) > (i64toi32_i32$0 | 0)) {
                        $58 = 1
                       } else {
                        if ((i64toi32_i32$4 | 0) >= (i64toi32_i32$0 | 0)) {
                         if (i64toi32_i32$2 >>> 0 <= i64toi32_i32$3 >>> 0) {
                          $59 = 0
                         } else {
                          $59 = 1
                         }
                         $60 = $59;
                        } else {
                         $60 = 0
                        }
                        $58 = $60;
                       }
                       if ($58) {
                        break label$44
                       }
                       i64toi32_i32$2 = $12$hi;
                       $300 = $12;
                       $300$hi = i64toi32_i32$2;
                       i64toi32_i32$2 = $11$hi;
                       i64toi32_i32$3 = $11;
                       i64toi32_i32$4 = -2147483648;
                       i64toi32_i32$0 = 0;
                       i64toi32_i32$5 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
                       i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
                       if (i64toi32_i32$5 >>> 0 < i64toi32_i32$0 >>> 0) {
                        i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
                       }
                       $302$hi = i64toi32_i32$1;
                       i64toi32_i32$1 = $11$hi;
                       i64toi32_i32$1 = $302$hi;
                       i64toi32_i32$2 = i64toi32_i32$5;
                       i64toi32_i32$3 = $11$hi;
                       i64toi32_i32$0 = $11;
                       $304 = i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$0 >>> 0 | 0) | 0;
                       i64toi32_i32$2 = 0;
                       $305$hi = i64toi32_i32$2;
                       i64toi32_i32$2 = $300$hi;
                       i64toi32_i32$0 = $300;
                       i64toi32_i32$1 = $305$hi;
                       i64toi32_i32$3 = $304;
                       i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
                       i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
                       if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
                        i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
                       }
                       i64toi32_i32$2 = i64toi32_i32$4;
                       i64toi32_i32$0 = 0;
                       i64toi32_i32$3 = 0;
                       if ((i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$5 | 0) != (i64toi32_i32$0 | 0) | 0) {
                        break label$42
                       }
                       i64toi32_i32$5 = $3;
                       i64toi32_i32$2 = 0;
                       HEAP32[($3 + 212 | 0) >> 2] = 0;
                       HEAP32[($3 + 216 | 0) >> 2] = i64toi32_i32$2;
                       HEAP32[($3 + 208 | 0) >> 2] = $9;
                       i64toi32_i32$2 = $11$hi;
                       i64toi32_i32$5 = $3;
                       HEAP32[($3 + 256 | 0) >> 2] = $11;
                       HEAP32[($3 + 260 | 0) >> 2] = i64toi32_i32$2;
                       core__fmt__Formatter__new__he219faf25326051b($3 + 160 | 0 | 0, $3 + 208 | 0 | 0, 1058944 | 0);
                       if (!(core__fmt__num__imp___impl_20core__fmt__Display_20for_20i64___fmt__h555ee0b859ae0d36($3 + 256 | 0 | 0, $3 + 160 | 0 | 0) | 0)) {
                        break label$43
                       }
                       core__result__unwrap_failed__h27f43d993c3864a1(1058968 | 0, 55 | 0, $3 + 296 | 0 | 0, 1059160 | 0, 1059100 | 0);
                       abort();
                      }
                      i64toi32_i32$2 = $12$hi;
                      i64toi32_i32$3 = $12;
                      i64toi32_i32$5 = 0;
                      i64toi32_i32$0 = 0;
                      if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$5 | 0) | 0) {
                       break label$42
                      }
                      i64toi32_i32$2 = $3;
                      i64toi32_i32$3 = 0;
                      HEAP32[($3 + 212 | 0) >> 2] = 0;
                      HEAP32[($3 + 216 | 0) >> 2] = i64toi32_i32$3;
                      HEAP32[($3 + 208 | 0) >> 2] = $9;
                      i64toi32_i32$3 = $11$hi;
                      i64toi32_i32$2 = $3;
                      HEAP32[($3 + 256 | 0) >> 2] = $11;
                      HEAP32[($3 + 260 | 0) >> 2] = i64toi32_i32$3;
                      core__fmt__Formatter__new__he219faf25326051b($3 + 160 | 0 | 0, $3 + 208 | 0 | 0, 1058944 | 0);
                      if (core__fmt__num__imp___impl_20core__fmt__Display_20for_20u64___fmt__h6488d819d41312fb($3 + 256 | 0 | 0, $3 + 160 | 0 | 0) | 0) {
                       break label$29
                      }
                     }
                     i64toi32_i32$0 = $3;
                     i64toi32_i32$3 = HEAP32[($3 + 212 | 0) >> 2] | 0;
                     i64toi32_i32$2 = HEAP32[($3 + 216 | 0) >> 2] | 0;
                     $11 = i64toi32_i32$3;
                     $11$hi = i64toi32_i32$2;
                     $5 = HEAP32[($3 + 208 | 0) >> 2] | 0;
                     if (!$5) {
                      break label$42
                     }
                     i64toi32_i32$2 = $11$hi;
                     i64toi32_i32$3 = $3;
                     HEAP32[($3 + 152 | 0) >> 2] = $11;
                     HEAP32[($3 + 156 | 0) >> 2] = i64toi32_i32$2;
                     HEAP32[($3 + 148 | 0) >> 2] = $5;
                     break label$34;
                    }
                    i64toi32_i32$3 = $3;
                    i64toi32_i32$2 = 0;
                    HEAP32[($3 + 212 | 0) >> 2] = 0;
                    HEAP32[($3 + 216 | 0) >> 2] = i64toi32_i32$2;
                    HEAP32[($3 + 208 | 0) >> 2] = $9;
                    core__fmt__Formatter__new__he219faf25326051b($3 + 160 | 0 | 0, $3 + 208 | 0 | 0, 1058944 | 0);
                    if ($core__num__error__TryFromIntError_20as_20core__fmt__Display___fmt__h0b3586d20b4066db($3 + 296 | 0 | 0, $3 + 160 | 0 | 0) | 0) {
                     break label$28
                    }
                    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $3 + 208 | 0 | 0);
                    $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($3 + 8 | 0) >> 2] | 0 | 0, HEAP32[($3 + 12 | 0) >> 2] | 0 | 0) | 0;
                    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 208 | 0 | 0);
                    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 208 | 0 | 0);
                    break label$26;
                   }
                   if (($5 & 255 | 0 | 0) != (2 | 0)) {
                    break label$27
                   }
                   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hf69db734dd831996($7 | 0, $1 + 4 | 0 | 0);
                   HEAP32[($3 + 160 | 0) >> 2] = 1;
                   cardano_serialization_lib__metadata__decode_metadatum_to_json_str__h637f31ff22f16dc5($3 + 144 | 0 | 0, $3 + 160 | 0 | 0, 2 | 0);
                   core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatum___headd2d1b596252cc($3 + 160 | 0 | 0);
                   break label$35;
                  }
                  if (($5 & 255 | 0 | 0) != (2 | 0)) {
                   break label$27
                  }
                  $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__hdeea20968268d729($3 + 256 | 0 | 0, $1 + 8 | 0 | 0);
                  memcpy($8 | 0, $3 + 256 | 0 | 0, 40 | 0) | 0;
                  HEAP32[($3 + 160 | 0) >> 2] = 0;
                  memcpy($7 | 0, $3 + 208 | 0 | 0, 44 | 0) | 0;
                  cardano_serialization_lib__metadata__decode_metadatum_to_json_str__h637f31ff22f16dc5($3 + 144 | 0 | 0, $3 + 160 | 0 | 0, 2 | 0);
                  core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatum___headd2d1b596252cc($3 + 160 | 0 | 0);
                 }
                 if ((HEAP32[($3 + 144 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                  break label$31
                 }
                }
                i64toi32_i32$0 = $3;
                i64toi32_i32$2 = HEAP32[($3 + 152 | 0) >> 2] | 0;
                i64toi32_i32$3 = HEAP32[($3 + 156 | 0) >> 2] | 0;
                $416 = i64toi32_i32$2;
                i64toi32_i32$2 = $3;
                HEAP32[($3 + 132 | 0) >> 2] = $416;
                HEAP32[($3 + 136 | 0) >> 2] = i64toi32_i32$3;
                HEAP32[($3 + 128 | 0) >> 2] = HEAP32[($3 + 148 | 0) >> 2] | 0;
                cardano_serialization_lib__metadata__decode_metadatum_to_json_value__h971c762f0ec03432($3 + 160 | 0 | 0, $1 + 48 | 0 | 0, HEAPU8[($3 + 63 | 0) >> 0] | 0 | 0);
                if ((HEAP32[($3 + 160 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                 break label$30
                }
                i64toi32_i32$0 = $2 + 16 | 0;
                i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                $11 = i64toi32_i32$3;
                $11$hi = i64toi32_i32$2;
                i64toi32_i32$3 = ($3 + 208 | 0) + 16 | 0;
                HEAP32[i64toi32_i32$3 >> 2] = $11;
                HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                i64toi32_i32$0 = $2 + 8 | 0;
                i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                $12 = i64toi32_i32$2;
                $12$hi = i64toi32_i32$3;
                i64toi32_i32$2 = ($3 + 208 | 0) + 8 | 0;
                HEAP32[i64toi32_i32$2 >> 2] = $12;
                HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                i64toi32_i32$0 = $2;
                i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                $13 = i64toi32_i32$3;
                $13$hi = i64toi32_i32$2;
                i64toi32_i32$3 = $3;
                HEAP32[($3 + 208 | 0) >> 2] = $13;
                HEAP32[($3 + 212 | 0) >> 2] = i64toi32_i32$2;
                HEAP32[(($3 + 256 | 0) + 8 | 0) >> 2] = HEAP32[(($3 + 128 | 0) + 8 | 0) >> 2] | 0;
                i64toi32_i32$0 = $3;
                i64toi32_i32$2 = HEAP32[($3 + 128 | 0) >> 2] | 0;
                i64toi32_i32$3 = HEAP32[($3 + 132 | 0) >> 2] | 0;
                $456 = i64toi32_i32$2;
                i64toi32_i32$2 = $3;
                HEAP32[($3 + 256 | 0) >> 2] = $456;
                HEAP32[($3 + 260 | 0) >> 2] = i64toi32_i32$3;
                i64toi32_i32$3 = $11$hi;
                i64toi32_i32$2 = ($3 + 160 | 0) + 16 | 0;
                HEAP32[i64toi32_i32$2 >> 2] = $11;
                HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                i64toi32_i32$3 = $12$hi;
                i64toi32_i32$2 = $2;
                HEAP32[i64toi32_i32$2 >> 2] = $12;
                HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                i64toi32_i32$3 = $13$hi;
                i64toi32_i32$2 = $3;
                HEAP32[($3 + 160 | 0) >> 2] = $13;
                HEAP32[($3 + 164 | 0) >> 2] = i64toi32_i32$3;
                alloc__collections__btree__map__BTreeMap_K_2cV___insert__h676f968c46c3ef24($3 + 104 | 0 | 0, $3 + 88 | 0 | 0, $3 + 256 | 0 | 0, $3 + 160 | 0 | 0);
                label$45 : {
                 if ((HEAPU8[($3 + 104 | 0) >> 0] | 0 | 0) == (6 | 0)) {
                  break label$45
                 }
                 core__ptr__drop_in_place_serde_json__value__Value___h0088decf7dc316c7_1($3 + 104 | 0 | 0);
                }
                if (($4 | 0) == ($6 | 0)) {
                 break label$32
                }
                $1 = $4;
                if ($1) {
                 continue label$33
                }
                break label$33;
               };
              }
              HEAP32[(($3 + 160 | 0) + 8 | 0) >> 2] = HEAP32[(($3 + 88 | 0) + 8 | 0) >> 2] | 0;
              i64toi32_i32$0 = $3;
              i64toi32_i32$3 = HEAP32[($3 + 88 | 0) >> 2] | 0;
              i64toi32_i32$2 = HEAP32[($3 + 92 | 0) >> 2] | 0;
              $492 = i64toi32_i32$3;
              i64toi32_i32$3 = $3;
              HEAP32[($3 + 160 | 0) >> 2] = $492;
              HEAP32[($3 + 164 | 0) >> 2] = i64toi32_i32$2;
              serde_json__value__from___impl_20core__convert__From_serde_json__map__Map_alloc__string__String_2cserde_json__value__Value___20for_20serde_json__value__Value___from__hd445317c7fcd41f3($3 + 64 | 0 | 0, $3 + 160 | 0 | 0);
              break label$5;
             }
             $1 = HEAP32[($3 + 148 | 0) >> 2] | 0;
             break label$26;
            }
            $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($3 + 164 | 0) >> 2] | 0 | 0) | 0;
            HEAP32[$0 >> 2] = 1;
            HEAP32[($0 + 4 | 0) >> 2] = $1;
            $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 128 | 0 | 0);
            $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 128 | 0 | 0);
            break label$25;
           }
           core__result__unwrap_failed__h27f43d993c3864a1(1058968 | 0, 55 | 0, $3 + 296 | 0 | 0, 1059160 | 0, 1059100 | 0);
           abort();
          }
          core__result__unwrap_failed__h27f43d993c3864a1(1058968 | 0, 55 | 0, $3 + 296 | 0 | 0, 1059160 | 0, 1059100 | 0);
          abort();
         }
         HEAP32[($3 + 180 | 0) >> 2] = 1;
         i64toi32_i32$3 = $3;
         i64toi32_i32$2 = 0;
         HEAP32[($3 + 164 | 0) >> 2] = 2;
         HEAP32[($3 + 168 | 0) >> 2] = i64toi32_i32$2;
         HEAP32[($3 + 160 | 0) >> 2] = 1059800;
         HEAP32[($3 + 260 | 0) >> 2] = 63;
         HEAP32[($3 + 256 | 0) >> 2] = $1;
         HEAP32[($3 + 176 | 0) >> 2] = $3 + 256 | 0;
         alloc__fmt__format__h6e9e003a52c07309($3 + 208 | 0 | 0, $3 + 160 | 0 | 0);
         $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 | 0, $3 + 208 | 0 | 0);
         $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[$3 >> 2] | 0 | 0, HEAP32[($3 + 4 | 0) >> 2] | 0 | 0) | 0;
         $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 208 | 0 | 0);
         $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 208 | 0 | 0);
        }
        $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($1 | 0) | 0;
        HEAP32[$0 >> 2] = 1;
        HEAP32[($0 + 4 | 0) >> 2] = $1;
       }
       $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h0198cfc402357e50($3 + 88 | 0 | 0);
       break label$1;
      }
      $4 = 1059438;
      $5 = 3;
      break label$2;
     }
     i64toi32_i32$0 = ($3 + 208 | 0) + 16 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $551 = i64toi32_i32$2;
     i64toi32_i32$2 = ($3 + 64 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $551;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$0 = ($3 + 208 | 0) + 8 | 0;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $558 = i64toi32_i32$3;
     i64toi32_i32$3 = ($3 + 64 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $558;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$0 = $3;
     i64toi32_i32$2 = HEAP32[($3 + 208 | 0) >> 2] | 0;
     i64toi32_i32$3 = HEAP32[($3 + 212 | 0) >> 2] | 0;
     $561 = i64toi32_i32$2;
     i64toi32_i32$2 = $3;
     HEAP32[($3 + 64 | 0) >> 2] = $561;
     HEAP32[($3 + 68 | 0) >> 2] = i64toi32_i32$3;
     $4 = 1059380;
     $5 = 3;
     break label$2;
    }
    $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($1 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    break label$1;
   }
   $1 = ($3 + 256 | 0) + 16 | 0;
   i64toi32_i32$0 = ($3 + 64 | 0) + 16 | 0;
   i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $574 = i64toi32_i32$3;
   i64toi32_i32$3 = $1;
   HEAP32[i64toi32_i32$3 >> 2] = $574;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
   $2 = ($3 + 256 | 0) + 8 | 0;
   $6 = ($3 + 64 | 0) + 8 | 0;
   i64toi32_i32$0 = $6;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $583 = i64toi32_i32$2;
   i64toi32_i32$2 = $2;
   HEAP32[i64toi32_i32$2 >> 2] = $583;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$0 = $3;
   i64toi32_i32$3 = HEAP32[($3 + 64 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($3 + 68 | 0) >> 2] | 0;
   $586 = i64toi32_i32$3;
   i64toi32_i32$3 = $3;
   HEAP32[($3 + 256 | 0) >> 2] = $586;
   HEAP32[($3 + 260 | 0) >> 2] = i64toi32_i32$2;
   label$46 : {
    if ((HEAPU8[($3 + 63 | 0) >> 0] | 0) >>> 0 > 1 >>> 0) {
     break label$46
    }
    HEAP32[$0 >> 2] = 0;
    i64toi32_i32$0 = $3;
    i64toi32_i32$2 = HEAP32[($3 + 256 | 0) >> 2] | 0;
    i64toi32_i32$3 = HEAP32[($3 + 260 | 0) >> 2] | 0;
    $594 = i64toi32_i32$2;
    i64toi32_i32$2 = $0 + 8 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $594;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
    i64toi32_i32$0 = $1;
    i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
    $598 = i64toi32_i32$3;
    i64toi32_i32$3 = $0 + 24 | 0;
    HEAP32[i64toi32_i32$3 >> 2] = $598;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$0 = $2;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
    $602 = i64toi32_i32$2;
    i64toi32_i32$2 = $0 + 16 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $602;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
    break label$1;
   }
   alloc__collections__btree__map__BTreeMap_K_2cV___new__h241ee1a6e88d54c0($3 + 144 | 0 | 0);
   alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($3 + 64 | 0 | 0, $4 | 0, $5 | 0);
   HEAP32[(($3 + 104 | 0) + 8 | 0) >> 2] = HEAP32[$6 >> 2] | 0;
   i64toi32_i32$0 = $3;
   i64toi32_i32$3 = HEAP32[($3 + 64 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($3 + 68 | 0) >> 2] | 0;
   $616 = i64toi32_i32$3;
   i64toi32_i32$3 = $3;
   HEAP32[($3 + 104 | 0) >> 2] = $616;
   HEAP32[($3 + 108 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = $1;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $621 = i64toi32_i32$2;
   i64toi32_i32$2 = ($3 + 160 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $621;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$0 = $2;
   i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $626 = i64toi32_i32$3;
   i64toi32_i32$3 = ($3 + 160 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$3 >> 2] = $626;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = $3;
   i64toi32_i32$2 = HEAP32[($3 + 256 | 0) >> 2] | 0;
   i64toi32_i32$3 = HEAP32[($3 + 260 | 0) >> 2] | 0;
   $629 = i64toi32_i32$2;
   i64toi32_i32$2 = $3;
   HEAP32[($3 + 160 | 0) >> 2] = $629;
   HEAP32[($3 + 164 | 0) >> 2] = i64toi32_i32$3;
   alloc__collections__btree__map__BTreeMap_K_2cV___insert__h676f968c46c3ef24($3 + 208 | 0 | 0, $3 + 144 | 0 | 0, $3 + 104 | 0 | 0, $3 + 160 | 0 | 0);
   label$47 : {
    if ((HEAPU8[($3 + 208 | 0) >> 0] | 0 | 0) == (6 | 0)) {
     break label$47
    }
    core__ptr__drop_in_place_serde_json__value__Value___h0088decf7dc316c7_1($3 + 208 | 0 | 0);
   }
   HEAP32[(($3 + 160 | 0) + 8 | 0) >> 2] = HEAP32[(($3 + 144 | 0) + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = $3;
   i64toi32_i32$3 = HEAP32[($3 + 144 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($3 + 148 | 0) >> 2] | 0;
   $652 = i64toi32_i32$3;
   i64toi32_i32$3 = $3;
   HEAP32[($3 + 160 | 0) >> 2] = $652;
   HEAP32[($3 + 164 | 0) >> 2] = i64toi32_i32$2;
   serde_json__value__from___impl_20core__convert__From_serde_json__map__Map_alloc__string__String_2cserde_json__value__Value___20for_20serde_json__value__Value___from__hd445317c7fcd41f3($0 + 8 | 0 | 0, $3 + 160 | 0 | 0);
   HEAP32[$0 >> 2] = 0;
  }
  global$0 = $3 + 304 | 0;
 }
 
 function $cardano_serialization_lib__crypto__Vkeywitness_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h37c9c40e98008804($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, $3 = 0, $9 = 0, $26 = 0, i64toi32_i32$4 = 0, $7 = 0, $5 = 0, $4 = 0, $26$hi = 0, $8 = 0, $19 = 0, $17 = 0, $27 = 0, $27$hi = 0, $28 = 0, $10 = 0, $13 = 0, $28$hi = 0, $14 = 0, $21 = 0, $12 = 0, $16 = 0, $18 = 0, $46 = 0, $24 = 0, $24$hi = 0, $25 = 0, $25$hi = 0, $47 = 0, $48 = 0, $49 = 0, $50 = 0, $51 = 0, $15 = 0, $52 = 0, $53 = 0, $54 = 0, $55 = 0, $56 = 0, $58 = 0, $59 = 0, $60 = 0, $61 = 0, $62 = 0, $63 = 0, $65 = 0, $66 = 0, $67 = 0, $68 = 0, $69 = 0, $70 = 0, $71 = 0, $72 = 0, $74 = 0, $75 = 0, $76 = 0, $77 = 0, $78 = 0, $79 = 0, $80 = 0, $81 = 0, $82 = 0, $83 = 0, $84 = 0, $85 = 0, $86 = 0, $87 = 0, $88 = 0, $89 = 0, $90 = 0, $91 = 0, $92 = 0, $93 = 0, $94 = 0, $95 = 0, $96 = 0, $97 = 0, $98 = 0, $99 = 0, $6 = 0, $23 = 0, $100 = 0, $101 = 0, $102 = 0, $103 = 0, $104 = 0, $105 = 0, $106 = 0, $57 = 0, $64 = 0, $73 = 0, $11 = 0, $20 = 0, $22 = 0, $517 = 0, $616 = 0, $655 = 0, $698 = 0;
  $2 = global$0 - 400 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 224 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2 + 240 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  $24$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 232 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 236 | 0) >> 2] | 0;
  $25 = i64toi32_i32$1;
  $25$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 224 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 228 | 0) >> 2] | 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
         break label$6
        }
        $cardano_serialization_lib__crypto__Vkey_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h00a02b49be066c8c($2 + 224 | 0 | 0, $1 | 0);
        label$7 : {
         if ((HEAPU8[($2 + 224 | 0) >> 0] | 0 | 0) == (1 | 0)) {
          break label$7
         }
         $3 = ($2 + 80 | 0) + 9 | 0;
         $4 = ($2 + 224 | 0) + 9 | 0;
         i64toi32_i32$3 = $4;
         i64toi32_i32$2 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$1 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $57 = i64toi32_i32$2;
         i64toi32_i32$2 = $3;
         $47 = $57;
         HEAP8[i64toi32_i32$2 >> 0] = $47;
         HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $47 >>> 8 | 0;
         HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $47 >>> 16 | 0;
         HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $47 >>> 24 | 0;
         HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$1;
         HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
         HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
         HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
         i64toi32_i32$3 = ($2 + 224 | 0) + 25 | 0;
         i64toi32_i32$1 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$2 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $64 = i64toi32_i32$1;
         i64toi32_i32$1 = ($2 + 80 | 0) + 25 | 0;
         $48 = $64;
         HEAP8[i64toi32_i32$1 >> 0] = $48;
         HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $48 >>> 8 | 0;
         HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $48 >>> 16 | 0;
         HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $48 >>> 24 | 0;
         HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$2;
         HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
         HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
         HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
         $5 = ($2 + 80 | 0) + 17 | 0;
         $6 = ($2 + 224 | 0) + 17 | 0;
         i64toi32_i32$3 = $6;
         i64toi32_i32$2 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$1 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $73 = i64toi32_i32$2;
         i64toi32_i32$2 = $5;
         $49 = $73;
         HEAP8[i64toi32_i32$2 >> 0] = $49;
         HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $49 >>> 8 | 0;
         HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $49 >>> 16 | 0;
         HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $49 >>> 24 | 0;
         HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$1;
         HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
         HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
         HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
         i64toi32_i32$3 = $2;
         i64toi32_i32$1 = HEAPU8[($2 + 225 | 0) >> 0] | 0 | ((HEAPU8[($2 + 226 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 227 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 228 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$2 = HEAPU8[($2 + 229 | 0) >> 0] | 0 | ((HEAPU8[($2 + 230 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 231 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 232 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $26 = i64toi32_i32$1;
         $26$hi = i64toi32_i32$2;
         i64toi32_i32$1 = $2;
         HEAP8[($2 + 81 | 0) >> 0] = $26;
         HEAP8[($2 + 82 | 0) >> 0] = $26 >>> 8 | 0;
         HEAP8[($2 + 83 | 0) >> 0] = $26 >>> 16 | 0;
         HEAP8[($2 + 84 | 0) >> 0] = $26 >>> 24 | 0;
         HEAP8[($2 + 85 | 0) >> 0] = i64toi32_i32$2;
         HEAP8[($2 + 86 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
         HEAP8[($2 + 87 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
         HEAP8[($2 + 88 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
         HEAP32[($2 + 24 | 0) >> 2] = $26;
         $50 = HEAPU8[($2 + 84 | 0) >> 0] | 0 | ((HEAPU8[($2 + 85 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 86 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 87 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[($2 + 27 | 0) >> 0] = $50;
         HEAP8[($2 + 28 | 0) >> 0] = $50 >>> 8 | 0;
         HEAP8[($2 + 29 | 0) >> 0] = $50 >>> 16 | 0;
         HEAP8[($2 + 30 | 0) >> 0] = $50 >>> 24 | 0;
         $7 = ($2 + 80 | 0) + 8 | 0;
         $8 = HEAPU8[$7 >> 0] | 0;
         $9 = ($2 + 80 | 0) + 12 | 0;
         $51 = HEAPU8[$9 >> 0] | 0 | ((HEAPU8[($9 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($9 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($9 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[($2 + 59 | 0) >> 0] = $51;
         HEAP8[($2 + 60 | 0) >> 0] = $51 >>> 8 | 0;
         HEAP8[($2 + 61 | 0) >> 0] = $51 >>> 16 | 0;
         HEAP8[($2 + 62 | 0) >> 0] = $51 >>> 24 | 0;
         HEAP32[($2 + 56 | 0) >> 2] = HEAPU8[$3 >> 0] | 0 | ((HEAPU8[($3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $10 = ($2 + 80 | 0) + 32 | 0;
         $11 = HEAPU8[$10 >> 0] | 0;
         $12 = ($2 + 80 | 0) + 28 | 0;
         $13 = HEAP32[$12 >> 2] | 0;
         $14 = ($2 + 80 | 0) + 24 | 0;
         $15 = HEAP32[$14 >> 2] | 0;
         $16 = ($2 + 80 | 0) + 20 | 0;
         $17 = HEAP32[$16 >> 2] | 0;
         $18 = ($2 + 80 | 0) + 16 | 0;
         $19 = HEAPU8[$18 >> 0] | 0;
         $20 = HEAPU8[$5 >> 0] | 0 | ((HEAPU8[($5 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
         $21 = ($2 + 80 | 0) + 19 | 0;
         $22 = HEAPU8[$21 >> 0] | 0;
         $52 = HEAPU8[($2 + 59 | 0) >> 0] | 0 | ((HEAPU8[($2 + 60 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 61 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 62 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[($2 + 19 | 0) >> 0] = $52;
         HEAP8[($2 + 20 | 0) >> 0] = $52 >>> 8 | 0;
         HEAP8[($2 + 21 | 0) >> 0] = $52 >>> 16 | 0;
         HEAP8[($2 + 22 | 0) >> 0] = $52 >>> 24 | 0;
         HEAP32[($2 + 16 | 0) >> 2] = HEAP32[($2 + 56 | 0) >> 2] | 0;
         $cardano_serialization_lib__crypto__Ed25519Signature_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h6385501ae0da5a4b($2 + 224 | 0 | 0, $1 | 0);
         if ((HEAPU8[($2 + 224 | 0) >> 0] | 0 | 0) == (1 | 0)) {
          break label$5
         }
         $23 = $2 + 224 | 0 | 1 | 0;
         memcpy($2 + 328 | 0 | 0, $23 | 0, 64 | 0) | 0;
         memcpy($2 + 80 | 0 | 1 | 0 | 0, memcpy($2 + 152 | 0 | 1 | 0 | 0, $2 + 328 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
         HEAP32[($2 + 48 | 0) >> 2] = HEAPU8[($2 + 81 | 0) >> 0] | 0 | ((HEAPU8[($2 + 82 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 83 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 84 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $53 = HEAPU8[($2 + 84 | 0) >> 0] | 0 | ((HEAPU8[($2 + 85 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 86 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 87 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[($2 + 51 | 0) >> 0] = $53;
         HEAP8[($2 + 52 | 0) >> 0] = $53 >>> 8 | 0;
         HEAP8[($2 + 53 | 0) >> 0] = $53 >>> 16 | 0;
         HEAP8[($2 + 54 | 0) >> 0] = $53 >>> 24 | 0;
         HEAP32[($2 + 72 | 0) >> 2] = HEAPU8[$3 >> 0] | 0 | ((HEAPU8[($3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $54 = HEAPU8[$9 >> 0] | 0 | ((HEAPU8[($9 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($9 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($9 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[($2 + 75 | 0) >> 0] = $54;
         HEAP8[($2 + 76 | 0) >> 0] = $54 >>> 8 | 0;
         HEAP8[($2 + 77 | 0) >> 0] = $54 >>> 16 | 0;
         HEAP8[($2 + 78 | 0) >> 0] = $54 >>> 24 | 0;
         $9 = HEAPU8[$7 >> 0] | 0;
         $18 = HEAPU8[$18 >> 0] | 0;
         $16 = HEAP32[$16 >> 2] | 0;
         $7 = HEAP32[$14 >> 2] | 0;
         $12 = HEAP32[$12 >> 2] | 0;
         i64toi32_i32$3 = $10;
         i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $26 = i64toi32_i32$2;
         $26$hi = i64toi32_i32$1;
         i64toi32_i32$3 = ($2 + 80 | 0) + 40 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $27 = i64toi32_i32$1;
         $27$hi = i64toi32_i32$2;
         i64toi32_i32$3 = ($2 + 80 | 0) + 48 | 0;
         i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $28 = i64toi32_i32$2;
         $28$hi = i64toi32_i32$1;
         $10 = HEAP32[(($2 + 80 | 0) + 56 | 0) >> 2] | 0;
         $3 = HEAPU8[$5 >> 0] | 0 | ((HEAPU8[($5 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
         $5 = HEAPU8[$21 >> 0] | 0;
         $14 = HEAPU8[(($2 + 80 | 0) + 64 | 0) >> 0] | 0;
         HEAP8[(($2 + 56 | 0) + 4 | 0) >> 0] = $14;
         $21 = ($2 + 32 | 0) + 4 | 0;
         HEAP8[$21 >> 0] = $14;
         HEAP32[($2 + 40 | 0) >> 2] = HEAP32[($2 + 72 | 0) >> 2] | 0;
         $55 = HEAPU8[($2 + 75 | 0) >> 0] | 0 | ((HEAPU8[($2 + 76 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 77 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 78 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[($2 + 43 | 0) >> 0] = $55;
         HEAP8[($2 + 44 | 0) >> 0] = $55 >>> 8 | 0;
         HEAP8[($2 + 45 | 0) >> 0] = $55 >>> 16 | 0;
         HEAP8[($2 + 46 | 0) >> 0] = $55 >>> 24 | 0;
         HEAP32[($2 + 32 | 0) >> 2] = HEAP32[(($2 + 80 | 0) + 60 | 0) >> 2] | 0;
         $56 = HEAPU8[($2 + 27 | 0) >> 0] | 0 | ((HEAPU8[($2 + 28 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 29 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 30 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[($2 + 228 | 0) >> 0] = $56;
         HEAP8[($2 + 229 | 0) >> 0] = $56 >>> 8 | 0;
         HEAP8[($2 + 230 | 0) >> 0] = $56 >>> 16 | 0;
         HEAP8[($2 + 231 | 0) >> 0] = $56 >>> 24 | 0;
         $58 = HEAP32[($2 + 24 | 0) >> 2] | 0;
         HEAP8[($2 + 225 | 0) >> 0] = $58;
         HEAP8[($2 + 226 | 0) >> 0] = $58 >>> 8 | 0;
         HEAP8[($2 + 227 | 0) >> 0] = $58 >>> 16 | 0;
         HEAP8[($2 + 228 | 0) >> 0] = $58 >>> 24 | 0;
         $59 = HEAP32[($2 + 16 | 0) >> 2] | 0;
         HEAP8[$4 >> 0] = $59;
         HEAP8[($4 + 1 | 0) >> 0] = $59 >>> 8 | 0;
         HEAP8[($4 + 2 | 0) >> 0] = $59 >>> 16 | 0;
         HEAP8[($4 + 3 | 0) >> 0] = $59 >>> 24 | 0;
         $60 = ($2 + 224 | 0) + 12 | 0;
         $61 = HEAPU8[($2 + 19 | 0) >> 0] | 0 | ((HEAPU8[($2 + 20 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 21 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 22 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[$60 >> 0] = $61;
         HEAP8[($60 + 1 | 0) >> 0] = $61 >>> 8 | 0;
         HEAP8[($60 + 2 | 0) >> 0] = $61 >>> 16 | 0;
         HEAP8[($60 + 3 | 0) >> 0] = $61 >>> 24 | 0;
         $62 = $2 + 257 | 0;
         $63 = HEAP32[($2 + 48 | 0) >> 2] | 0;
         HEAP8[$62 >> 0] = $63;
         HEAP8[($62 + 1 | 0) >> 0] = $63 >>> 8 | 0;
         HEAP8[($62 + 2 | 0) >> 0] = $63 >>> 16 | 0;
         HEAP8[($62 + 3 | 0) >> 0] = $63 >>> 24 | 0;
         $65 = $2 + 260 | 0;
         $66 = HEAPU8[($2 + 51 | 0) >> 0] | 0 | ((HEAPU8[($2 + 52 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 53 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 54 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[$65 >> 0] = $66;
         HEAP8[($65 + 1 | 0) >> 0] = $66 >>> 8 | 0;
         HEAP8[($65 + 2 | 0) >> 0] = $66 >>> 16 | 0;
         HEAP8[($65 + 3 | 0) >> 0] = $66 >>> 24 | 0;
         $67 = $2 + 265 | 0;
         $68 = HEAP32[($2 + 40 | 0) >> 2] | 0;
         HEAP8[$67 >> 0] = $68;
         HEAP8[($67 + 1 | 0) >> 0] = $68 >>> 8 | 0;
         HEAP8[($67 + 2 | 0) >> 0] = $68 >>> 16 | 0;
         HEAP8[($67 + 3 | 0) >> 0] = $68 >>> 24 | 0;
         $69 = $2 + 268 | 0;
         $70 = HEAPU8[($2 + 43 | 0) >> 0] | 0 | ((HEAPU8[($2 + 44 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 45 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 46 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[$69 >> 0] = $70;
         HEAP8[($69 + 1 | 0) >> 0] = $70 >>> 8 | 0;
         HEAP8[($69 + 2 | 0) >> 0] = $70 >>> 16 | 0;
         HEAP8[($69 + 3 | 0) >> 0] = $70 >>> 24 | 0;
         HEAP8[($2 + 320 | 0) >> 0] = HEAPU8[$21 >> 0] | 0;
         HEAP32[($2 + 316 | 0) >> 2] = HEAP32[($2 + 32 | 0) >> 2] | 0;
         HEAP8[($2 + 275 | 0) >> 0] = $5;
         $100 = $2 + 273 | 0;
         HEAP8[$100 >> 0] = $3;
         HEAP8[($100 + 1 | 0) >> 0] = $3 >>> 8 | 0;
         $3 = $20 | ($22 << 16 | 0) | 0;
         HEAP8[(($2 + 224 | 0) + 19 | 0) >> 0] = $3 >>> 16 | 0;
         HEAP8[$6 >> 0] = $3;
         HEAP8[($6 + 1 | 0) >> 0] = $3 >>> 8 | 0;
         HEAP32[($2 + 312 | 0) >> 2] = $10;
         i64toi32_i32$2 = $2 + 304 | 0;
         HEAP32[i64toi32_i32$2 >> 2] = $28;
         HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$1 = $27$hi;
         i64toi32_i32$2 = $2 + 296 | 0;
         HEAP32[i64toi32_i32$2 >> 2] = $27;
         HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$1 = $26$hi;
         i64toi32_i32$2 = ($2 + 224 | 0) + 64 | 0;
         HEAP32[i64toi32_i32$2 >> 2] = $26;
         HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
         $10 = ($2 + 224 | 0) + 60 | 0;
         HEAP32[$10 >> 2] = $12;
         HEAP32[(($2 + 224 | 0) + 56 | 0) >> 2] = $7;
         HEAP32[($2 + 276 | 0) >> 2] = $16;
         HEAP8[(($2 + 224 | 0) + 48 | 0) >> 0] = $18;
         HEAP8[(($2 + 224 | 0) + 40 | 0) >> 0] = $9;
         HEAP8[(($2 + 224 | 0) + 32 | 0) >> 0] = $11;
         HEAP32[(($2 + 224 | 0) + 28 | 0) >> 2] = $13;
         HEAP32[(($2 + 224 | 0) + 24 | 0) >> 2] = $15;
         HEAP32[(($2 + 224 | 0) + 20 | 0) >> 2] = $17;
         HEAP8[(($2 + 224 | 0) + 16 | 0) >> 0] = $19;
         $5 = ($2 + 224 | 0) + 8 | 0;
         HEAP8[$5 >> 0] = $8;
         $9 = 0;
         HEAP8[($2 + 224 | 0) >> 0] = 0;
         i64toi32_i32$1 = 0;
         $26 = 1;
         $26$hi = i64toi32_i32$1;
         label$8 : {
          label$9 : {
           label$10 : {
            label$11 : {
             label$12 : {
              i64toi32_i32$1 = $25$hi;
              i64toi32_i32$3 = $25;
              i64toi32_i32$2 = 0;
              i64toi32_i32$0 = 1;
              if ((i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) | 0) {
               break label$12
              }
              cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 152 | 0 | 0, $1 | 0);
              $19 = HEAPU8[($2 + 160 | 0) >> 0] | 0;
              i64toi32_i32$0 = $2;
              i64toi32_i32$3 = HEAP32[($2 + 152 | 0) >> 2] | 0;
              i64toi32_i32$1 = HEAP32[($2 + 156 | 0) >> 2] | 0;
              i64toi32_i32$0 = i64toi32_i32$3;
              i64toi32_i32$3 = 0;
              i64toi32_i32$2 = 1;
              if ((i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) | 0) {
               break label$10
              }
              $8 = 5;
              if (($19 & 255 | 0 | 0) == (5 | 0)) {
               break label$9
              }
              break label$11;
             }
             i64toi32_i32$0 = 0;
             $27 = 2;
             $27$hi = i64toi32_i32$0;
             i64toi32_i32$0 = $24$hi;
             i64toi32_i32$2 = $24;
             i64toi32_i32$1 = 0;
             i64toi32_i32$3 = 2;
             if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
              break label$8
             }
             $8 = 2;
             $19 = 13;
             $17 = 1066228;
             i64toi32_i32$2 = $24$hi;
             $28 = $24;
             $28$hi = i64toi32_i32$2;
            }
            break label$4;
           }
           $3 = HEAPU8[($2 + 161 | 0) >> 0] | 0 | ((HEAPU8[($2 + 162 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 163 | 0) >> 0] | 0) << 16 | 0) | 0;
           $13 = HEAP32[($2 + 172 | 0) >> 2] | 0;
           $9 = HEAP32[(($2 + 152 | 0) + 16 | 0) >> 2] | 0;
           i64toi32_i32$3 = $2 + 192 | 0;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
           $28 = i64toi32_i32$2;
           $28$hi = i64toi32_i32$0;
           i64toi32_i32$3 = $2 + 184 | 0;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
           $26 = i64toi32_i32$0;
           $26$hi = i64toi32_i32$2;
           i64toi32_i32$3 = $2 + 176 | 0;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
           $27 = i64toi32_i32$2;
           $27$hi = i64toi32_i32$0;
           $17 = HEAP32[($2 + 164 | 0) >> 2] | 0;
           $8 = 2;
           break label$4;
          }
          $9 = (HEAPU8[($2 + 224 | 0) >> 0] | 0 | 0) == (1 | 0);
          $3 = HEAPU8[($2 + 241 | 0) >> 0] | 0 | ((HEAPU8[($2 + 242 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 243 | 0) >> 0] | 0) << 16 | 0) | 0;
          $7 = HEAP32[($2 + 280 | 0) >> 2] | 0;
          $13 = HEAP32[($2 + 252 | 0) >> 2] | 0;
          $15 = HEAP32[($2 + 248 | 0) >> 2] | 0;
          $17 = HEAP32[($2 + 244 | 0) >> 2] | 0;
          $19 = HEAPU8[($2 + 240 | 0) >> 0] | 0;
          $8 = HEAPU8[($2 + 232 | 0) >> 0] | 0;
         }
         $46 = $23;
         HEAP32[($2 + 152 | 0) >> 2] = HEAPU8[$46 >> 0] | 0 | ((HEAPU8[($46 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($46 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($46 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP32[($2 + 8 | 0) >> 2] = HEAPU8[$4 >> 0] | 0 | ((HEAPU8[($4 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $71 = $46 + 3 | 0;
         $72 = HEAPU8[$71 >> 0] | 0 | ((HEAPU8[($71 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($71 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($71 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[($2 + 155 | 0) >> 0] = $72;
         HEAP8[($2 + 156 | 0) >> 0] = $72 >>> 8 | 0;
         HEAP8[($2 + 157 | 0) >> 0] = $72 >>> 16 | 0;
         HEAP8[($2 + 158 | 0) >> 0] = $72 >>> 24 | 0;
         $74 = $4 + 3 | 0;
         $75 = HEAPU8[$74 >> 0] | 0 | ((HEAPU8[($74 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($74 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($74 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[($2 + 11 | 0) >> 0] = $75;
         HEAP8[($2 + 12 | 0) >> 0] = $75 >>> 8 | 0;
         HEAP8[($2 + 13 | 0) >> 0] = $75 >>> 16 | 0;
         HEAP8[($2 + 14 | 0) >> 0] = $75 >>> 24 | 0;
         i64toi32_i32$3 = $2;
         i64toi32_i32$0 = HEAP32[($2 + 256 | 0) >> 2] | 0;
         i64toi32_i32$2 = HEAP32[($2 + 260 | 0) >> 2] | 0;
         $27 = i64toi32_i32$0;
         $27$hi = i64toi32_i32$2;
         i64toi32_i32$3 = $2;
         i64toi32_i32$2 = HEAP32[($2 + 264 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($2 + 268 | 0) >> 2] | 0;
         $26 = i64toi32_i32$2;
         $26$hi = i64toi32_i32$0;
         i64toi32_i32$3 = $2;
         i64toi32_i32$0 = HEAP32[($2 + 272 | 0) >> 2] | 0;
         i64toi32_i32$2 = HEAP32[($2 + 276 | 0) >> 2] | 0;
         $28 = i64toi32_i32$0;
         $28$hi = i64toi32_i32$2;
         memcpy($2 + 328 | 0 | 0, $10 | 0, 44 | 0) | 0;
         label$13 : {
          if (!$9) {
           break label$13
          }
          $9 = $15;
          break label$2;
         }
         $76 = HEAP32[($2 + 152 | 0) >> 2] | 0;
         HEAP8[($0 + 1 | 0) >> 0] = $76;
         HEAP8[($0 + 2 | 0) >> 0] = $76 >>> 8 | 0;
         HEAP8[($0 + 3 | 0) >> 0] = $76 >>> 16 | 0;
         HEAP8[($0 + 4 | 0) >> 0] = $76 >>> 24 | 0;
         HEAP8[($0 + 19 | 0) >> 0] = $3 >>> 16 | 0;
         $101 = $0 + 17 | 0;
         HEAP8[$101 >> 0] = $3;
         HEAP8[($101 + 1 | 0) >> 0] = $3 >>> 8 | 0;
         $77 = $0 + 4 | 0;
         $78 = HEAPU8[($2 + 155 | 0) >> 0] | 0 | ((HEAPU8[($2 + 156 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 157 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 158 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[$77 >> 0] = $78;
         HEAP8[($77 + 1 | 0) >> 0] = $78 >>> 8 | 0;
         HEAP8[($77 + 2 | 0) >> 0] = $78 >>> 16 | 0;
         HEAP8[($77 + 3 | 0) >> 0] = $78 >>> 24 | 0;
         HEAP8[($0 + 8 | 0) >> 0] = $8;
         $79 = $0 + 9 | 0;
         $80 = HEAP32[($2 + 8 | 0) >> 2] | 0;
         HEAP8[$79 >> 0] = $80;
         HEAP8[($79 + 1 | 0) >> 0] = $80 >>> 8 | 0;
         HEAP8[($79 + 2 | 0) >> 0] = $80 >>> 16 | 0;
         HEAP8[($79 + 3 | 0) >> 0] = $80 >>> 24 | 0;
         $81 = $0 + 12 | 0;
         $82 = HEAPU8[($2 + 11 | 0) >> 0] | 0 | ((HEAPU8[($2 + 12 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 13 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 14 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[$81 >> 0] = $82;
         HEAP8[($81 + 1 | 0) >> 0] = $82 >>> 8 | 0;
         HEAP8[($81 + 2 | 0) >> 0] = $82 >>> 16 | 0;
         HEAP8[($81 + 3 | 0) >> 0] = $82 >>> 24 | 0;
         $83 = $0 + 56 | 0;
         HEAP8[$83 >> 0] = $7;
         HEAP8[($83 + 1 | 0) >> 0] = $7 >>> 8 | 0;
         HEAP8[($83 + 2 | 0) >> 0] = $7 >>> 16 | 0;
         HEAP8[($83 + 3 | 0) >> 0] = $7 >>> 24 | 0;
         i64toi32_i32$2 = $28$hi;
         i64toi32_i32$0 = $0 + 48 | 0;
         $84 = $28;
         HEAP8[i64toi32_i32$0 >> 0] = $84;
         HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $84 >>> 8 | 0;
         HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $84 >>> 16 | 0;
         HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $84 >>> 24 | 0;
         HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$2;
         HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
         HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
         HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
         i64toi32_i32$2 = $26$hi;
         i64toi32_i32$0 = $0 + 40 | 0;
         HEAP8[i64toi32_i32$0 >> 0] = $26;
         HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $26 >>> 8 | 0;
         HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $26 >>> 16 | 0;
         HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $26 >>> 24 | 0;
         HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$2;
         HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
         HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
         HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
         i64toi32_i32$2 = $27$hi;
         i64toi32_i32$0 = $0 + 32 | 0;
         $85 = $27;
         HEAP8[i64toi32_i32$0 >> 0] = $85;
         HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $85 >>> 8 | 0;
         HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $85 >>> 16 | 0;
         HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $85 >>> 24 | 0;
         HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$2;
         HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
         HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
         HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
         $86 = $0 + 28 | 0;
         $87 = $13;
         HEAP8[$86 >> 0] = $87;
         HEAP8[($86 + 1 | 0) >> 0] = $87 >>> 8 | 0;
         HEAP8[($86 + 2 | 0) >> 0] = $87 >>> 16 | 0;
         HEAP8[($86 + 3 | 0) >> 0] = $87 >>> 24 | 0;
         $88 = $0 + 24 | 0;
         $89 = $15;
         HEAP8[$88 >> 0] = $89;
         HEAP8[($88 + 1 | 0) >> 0] = $89 >>> 8 | 0;
         HEAP8[($88 + 2 | 0) >> 0] = $89 >>> 16 | 0;
         HEAP8[($88 + 3 | 0) >> 0] = $89 >>> 24 | 0;
         $90 = $0 + 20 | 0;
         $91 = $17;
         HEAP8[$90 >> 0] = $91;
         HEAP8[($90 + 1 | 0) >> 0] = $91 >>> 8 | 0;
         HEAP8[($90 + 2 | 0) >> 0] = $91 >>> 16 | 0;
         HEAP8[($90 + 3 | 0) >> 0] = $91 >>> 24 | 0;
         HEAP8[($0 + 16 | 0) >> 0] = $19;
         memcpy($0 + 60 | 0 | 0, $2 + 328 | 0 | 0, 37 | 0) | 0;
         $3 = 0;
         break label$1;
        }
        memcpy($2 + 224 | 0 | 0, memcpy(($2 + 152 | 0) + 8 | 0 | 0, memcpy($2 + 328 | 0 | 7 | 0 | 0, ($2 + 224 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
        $3 = ($2 + 80 | 0) + 8 | 0;
        cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($3 | 0, $2 + 224 | 0 | 0, 1066228 | 0, 4 | 0);
        HEAP32[(($2 + 328 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 148 | 0) >> 2] | 0;
        $92 = $2 + 89 | 0;
        HEAP32[($2 + 56 | 0) >> 2] = HEAPU8[$92 >> 0] | 0 | ((HEAPU8[($92 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($92 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($92 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $93 = $2 + 92 | 0;
        $94 = HEAPU8[$93 >> 0] | 0 | ((HEAPU8[($93 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($93 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($93 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 59 | 0) >> 0] = $94;
        HEAP8[($2 + 60 | 0) >> 0] = $94 >>> 8 | 0;
        HEAP8[($2 + 61 | 0) >> 0] = $94 >>> 16 | 0;
        HEAP8[($2 + 62 | 0) >> 0] = $94 >>> 24 | 0;
        i64toi32_i32$3 = $2 + 140 | 0;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $517 = i64toi32_i32$2;
        i64toi32_i32$2 = $2;
        HEAP32[($2 + 328 | 0) >> 2] = $517;
        HEAP32[($2 + 332 | 0) >> 2] = i64toi32_i32$0;
        $8 = HEAPU8[$3 >> 0] | 0;
        $19 = HEAPU8[(($2 + 80 | 0) + 16 | 0) >> 0] | 0;
        $17 = HEAP32[($2 + 100 | 0) >> 2] | 0;
        $9 = HEAP32[($2 + 104 | 0) >> 2] | 0;
        $13 = HEAP32[($2 + 108 | 0) >> 2] | 0;
        i64toi32_i32$3 = $2 + 112 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $27 = i64toi32_i32$0;
        $27$hi = i64toi32_i32$2;
        i64toi32_i32$3 = $2 + 120 | 0;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $26 = i64toi32_i32$2;
        $26$hi = i64toi32_i32$0;
        i64toi32_i32$3 = $2 + 128 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $28 = i64toi32_i32$0;
        $28$hi = i64toi32_i32$2;
        $7 = HEAP32[($2 + 136 | 0) >> 2] | 0;
        $102 = $2 + 97 | 0;
        $3 = HEAPU8[$102 >> 0] | 0 | ((HEAPU8[($102 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
        $1 = HEAPU8[($2 + 99 | 0) >> 0] | 0;
        $95 = HEAPU8[($2 + 59 | 0) >> 0] | 0 | ((HEAPU8[($2 + 60 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 61 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 62 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 11 | 0) >> 0] = $95;
        HEAP8[($2 + 12 | 0) >> 0] = $95 >>> 8 | 0;
        HEAP8[($2 + 13 | 0) >> 0] = $95 >>> 16 | 0;
        HEAP8[($2 + 14 | 0) >> 0] = $95 >>> 24 | 0;
        HEAP32[($2 + 8 | 0) >> 2] = HEAP32[($2 + 56 | 0) >> 2] | 0;
        $3 = $3 | ($1 << 16 | 0) | 0;
        break label$2;
       }
       i64toi32_i32$2 = $25$hi;
       i64toi32_i32$3 = $25;
       i64toi32_i32$0 = 0;
       i64toi32_i32$1 = 32;
       i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = 0;
        $103 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
        $103 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$4 | 0) | 0;
       }
       $17 = $103;
       i64toi32_i32$0 = $24$hi;
       i64toi32_i32$2 = $24;
       i64toi32_i32$3 = 0;
       i64toi32_i32$1 = 32;
       i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
        i64toi32_i32$3 = 0;
        $104 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$3 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
        $104 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
       }
       $13 = $104;
       i64toi32_i32$3 = $25$hi;
       i64toi32_i32$0 = $25;
       i64toi32_i32$2 = 0;
       i64toi32_i32$1 = 8;
       i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = 0;
        $105 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$2 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
        $105 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
       }
       $3 = $105;
       i64toi32_i32$3 = $2 + 264 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $28 = i64toi32_i32$2;
       $28$hi = i64toi32_i32$0;
       i64toi32_i32$3 = $2 + 256 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $26 = i64toi32_i32$0;
       $26$hi = i64toi32_i32$2;
       i64toi32_i32$3 = $2 + 248 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $27 = i64toi32_i32$2;
       $27$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $24$hi;
       $9 = $24;
       i64toi32_i32$0 = $25$hi;
       $19 = $25;
       $8 = 2;
       break label$3;
      }
      memcpy($2 + 224 | 0 | 0, memcpy(($2 + 152 | 0) + 8 | 0 | 0, memcpy($2 + 328 | 0 | 7 | 0 | 0, ($2 + 224 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
      cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($7 | 0, $2 + 224 | 0 | 0, 1066232 | 0, 9 | 0);
      $1 = ($2 + 56 | 0) + 8 | 0;
      HEAP32[$1 >> 2] = HEAP32[($2 + 148 | 0) >> 2] | 0;
      HEAP32[($2 + 72 | 0) >> 2] = HEAPU8[$3 >> 0] | 0 | ((HEAPU8[($3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $96 = HEAPU8[$9 >> 0] | 0 | ((HEAPU8[($9 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($9 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($9 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[($2 + 75 | 0) >> 0] = $96;
      HEAP8[($2 + 76 | 0) >> 0] = $96 >>> 8 | 0;
      HEAP8[($2 + 77 | 0) >> 0] = $96 >>> 16 | 0;
      HEAP8[($2 + 78 | 0) >> 0] = $96 >>> 24 | 0;
      i64toi32_i32$3 = $2 + 140 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $616 = i64toi32_i32$0;
      i64toi32_i32$0 = $2;
      HEAP32[($2 + 56 | 0) >> 2] = $616;
      HEAP32[($2 + 60 | 0) >> 2] = i64toi32_i32$2;
      $8 = HEAPU8[$7 >> 0] | 0;
      $19 = HEAPU8[$18 >> 0] | 0;
      $17 = HEAP32[$16 >> 2] | 0;
      $9 = HEAP32[$14 >> 2] | 0;
      $13 = HEAP32[$12 >> 2] | 0;
      i64toi32_i32$3 = $10;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $27 = i64toi32_i32$2;
      $27$hi = i64toi32_i32$0;
      i64toi32_i32$3 = $2 + 120 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $26 = i64toi32_i32$0;
      $26$hi = i64toi32_i32$2;
      i64toi32_i32$3 = $2 + 128 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $28 = i64toi32_i32$2;
      $28$hi = i64toi32_i32$0;
      $7 = HEAP32[($2 + 136 | 0) >> 2] | 0;
      $3 = HEAPU8[$5 >> 0] | 0 | ((HEAPU8[($5 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
      $5 = HEAPU8[$21 >> 0] | 0;
      HEAP32[(($2 + 328 | 0) + 8 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
      $97 = HEAPU8[($2 + 75 | 0) >> 0] | 0 | ((HEAPU8[($2 + 76 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 77 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 78 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[($2 + 11 | 0) >> 0] = $97;
      HEAP8[($2 + 12 | 0) >> 0] = $97 >>> 8 | 0;
      HEAP8[($2 + 13 | 0) >> 0] = $97 >>> 16 | 0;
      HEAP8[($2 + 14 | 0) >> 0] = $97 >>> 24 | 0;
      HEAP32[($2 + 8 | 0) >> 2] = HEAP32[($2 + 72 | 0) >> 2] | 0;
      i64toi32_i32$3 = $2;
      i64toi32_i32$0 = HEAP32[($2 + 56 | 0) >> 2] | 0;
      i64toi32_i32$2 = HEAP32[($2 + 60 | 0) >> 2] | 0;
      $655 = i64toi32_i32$0;
      i64toi32_i32$0 = $2;
      HEAP32[($2 + 328 | 0) >> 2] = $655;
      HEAP32[($2 + 332 | 0) >> 2] = i64toi32_i32$2;
      $3 = $3 | ($5 << 16 | 0) | 0;
      break label$2;
     }
     if (!(HEAPU8[($2 + 224 | 0) >> 0] | 0)) {
      break label$3
     }
     core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9_1($5 | 0);
    }
    $7 = 0;
   }
   HEAP8[(($2 + 224 | 0) + 11 | 0) >> 0] = $3 >>> 16 | 0;
   $106 = $2 + 233 | 0;
   HEAP8[$106 >> 0] = $3;
   HEAP8[($106 + 1 | 0) >> 0] = $3 >>> 8 | 0;
   i64toi32_i32$2 = $28$hi;
   i64toi32_i32$0 = $2 + 264 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $28;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$2 = $26$hi;
   i64toi32_i32$0 = $2 + 256 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $26;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$2 = $27$hi;
   i64toi32_i32$0 = $2 + 248 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $27;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   HEAP32[($2 + 244 | 0) >> 2] = $13;
   HEAP32[(($2 + 224 | 0) + 16 | 0) >> 2] = $9;
   HEAP32[($2 + 236 | 0) >> 2] = $17;
   HEAP8[(($2 + 224 | 0) + 8 | 0) >> 0] = $19;
   i64toi32_i32$3 = $2;
   i64toi32_i32$2 = HEAP32[($2 + 328 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 332 | 0) >> 2] | 0;
   $698 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 276 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $698;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($2 + 284 | 0) >> 2] = HEAP32[(($2 + 328 | 0) + 8 | 0) >> 2] | 0;
   HEAP8[($2 + 224 | 0) >> 0] = $8;
   $98 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   HEAP8[($2 + 225 | 0) >> 0] = $98;
   HEAP8[($2 + 226 | 0) >> 0] = $98 >>> 8 | 0;
   HEAP8[($2 + 227 | 0) >> 0] = $98 >>> 16 | 0;
   HEAP8[($2 + 228 | 0) >> 0] = $98 >>> 24 | 0;
   $99 = HEAPU8[($2 + 11 | 0) >> 0] | 0 | ((HEAPU8[($2 + 12 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 13 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 14 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[($2 + 228 | 0) >> 0] = $99;
   HEAP8[($2 + 229 | 0) >> 0] = $99 >>> 8 | 0;
   HEAP8[($2 + 230 | 0) >> 0] = $99 >>> 16 | 0;
   HEAP8[($2 + 231 | 0) >> 0] = $99 >>> 24 | 0;
   HEAP32[($2 + 272 | 0) >> 2] = $7;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 224 | 0 | 0, 1066241 | 0, 11 | 0);
   $3 = 1;
  }
  HEAP8[$0 >> 0] = $3;
  global$0 = $2 + 400 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__SingleHostAddr___deserialize_as_embedded_group__ha772ae07f05d383e($0, $1, $2, $2$hi, $3, $3$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$4 = 0, $5 = 0, $10 = 0, $10$hi = 0, $6 = 0, $8 = 0, $11 = 0, $11$hi = 0, $9 = 0, $12 = 0, $12$hi = 0, $7 = 0, $13 = 0, $13$hi = 0, $55 = 0, $56 = 0, $57 = 0, $58 = 0, $59 = 0, $60 = 0, $61 = 0, $62 = 0, $63 = 0, $64 = 0, $65 = 0, $66 = 0, $67 = 0, $68 = 0, $69 = 0, $70 = 0, $71 = 0, $72 = 0, $73 = 0, $111 = 0, $111$hi = 0, $115$hi = 0, $117$hi = 0, $120 = 0, $120$hi = 0, $121 = 0, $121$hi = 0, $124$hi = 0, $236 = 0, $263 = 0, $263$hi = 0, $267$hi = 0, $269$hi = 0, $272 = 0, $272$hi = 0, $273 = 0, $273$hi = 0, $276$hi = 0, $315 = 0, $430 = 0, $438 = 0, $511 = 0, $532 = 0, $544 = 0, $547 = 0, $565 = 0, $569 = 0, $599 = 0, $616 = 0;
  $4 = global$0 - 320 | 0;
  global$0 = $4;
  cbor_event__de__Deserializer_R___unsigned_integer__h1ed99c0b7fe7eea1($4 + 248 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[($4 + 256 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($4 + 260 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           label$10 : {
            label$11 : {
             label$12 : {
              label$13 : {
               label$14 : {
                label$15 : {
                 label$16 : {
                  label$17 : {
                   i64toi32_i32$2 = $4;
                   i64toi32_i32$1 = HEAP32[($4 + 248 | 0) >> 2] | 0;
                   i64toi32_i32$0 = HEAP32[($4 + 252 | 0) >> 2] | 0;
                   i64toi32_i32$2 = i64toi32_i32$1;
                   i64toi32_i32$1 = 0;
                   i64toi32_i32$3 = 1;
                   if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
                    break label$17
                   }
                   i64toi32_i32$2 = $10$hi;
                   if (!($10 | i64toi32_i32$2 | 0)) {
                    break label$15
                   }
                   $5 = 8;
                   $6 = 1;
                   i64toi32_i32$2 = 0;
                   $11 = 0;
                   $11$hi = i64toi32_i32$2;
                   $7 = 1;
                   break label$16;
                  }
                  i64toi32_i32$2 = $10$hi;
                  i64toi32_i32$3 = $10;
                  i64toi32_i32$0 = 0;
                  i64toi32_i32$1 = 32;
                  i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
                  if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                   i64toi32_i32$0 = 0;
                   $65 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
                  } else {
                   i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
                   $65 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$4 | 0) | 0;
                  }
                  $8 = $65;
                  i64toi32_i32$2 = $4 + 288 | 0;
                  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                  i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                  $12 = i64toi32_i32$0;
                  $12$hi = i64toi32_i32$3;
                  i64toi32_i32$2 = $4 + 280 | 0;
                  i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                  $11 = i64toi32_i32$3;
                  $11$hi = i64toi32_i32$0;
                  $9 = HEAP32[($4 + 276 | 0) >> 2] | 0;
                  $6 = HEAP32[($4 + 272 | 0) >> 2] | 0;
                  i64toi32_i32$0 = $10$hi;
                  $7 = $10;
                  $5 = 2;
                  i64toi32_i32$2 = $4 + 264 | 0;
                  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                  i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                  $10 = i64toi32_i32$0;
                  $10$hi = i64toi32_i32$3;
                 }
                 i64toi32_i32$3 = $12$hi;
                 i64toi32_i32$0 = $4 + 288 | 0;
                 HEAP32[i64toi32_i32$0 >> 2] = $12;
                 HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
                 i64toi32_i32$3 = $11$hi;
                 i64toi32_i32$0 = $4 + 280 | 0;
                 HEAP32[i64toi32_i32$0 >> 2] = $11;
                 HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
                 HEAP32[($4 + 276 | 0) >> 2] = $9;
                 HEAP32[($4 + 272 | 0) >> 2] = $6;
                 i64toi32_i32$3 = $10$hi;
                 i64toi32_i32$0 = $4 + 264 | 0;
                 HEAP32[i64toi32_i32$0 >> 2] = $10;
                 HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
                 HEAP32[($4 + 260 | 0) >> 2] = $8;
                 HEAP32[(($4 + 248 | 0) + 8 | 0) >> 2] = $7;
                 HEAP32[($4 + 296 | 0) >> 2] = 0;
                 HEAP8[($4 + 248 | 0) >> 0] = $5;
                 cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($4 + 136 | 0 | 0, $4 + 248 | 0 | 0, 1050766 | 0, 7 | 0);
                 $5 = HEAPU8[($4 + 136 | 0) >> 0] | 0;
                 if (($5 | 0) != (19 | 0)) {
                  break label$14
                 }
                }
                std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($4 + 24 | 0 | 0, $1 | 0);
                label$18 : {
                 if (HEAP32[($4 + 28 | 0) >> 2] | 0) {
                  break label$18
                 }
                 i64toi32_i32$3 = 0;
                 $10 = 0;
                 $10$hi = i64toi32_i32$3;
                 i64toi32_i32$3 = 0;
                 $11 = 8;
                 $11$hi = i64toi32_i32$3;
                 $1 = 2;
                 break label$9;
                }
                label$19 : {
                 label$20 : {
                  if ((($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[($4 + 24 | 0) >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) != (7 | 0)) {
                   break label$20
                  }
                  cbor_event__de__Deserializer_R___special__h10e912d855f56298($4 + 64 | 0 | 0, $1 | 0);
                  $5 = HEAPU8[($4 + 72 | 0) >> 0] | 0;
                  i64toi32_i32$2 = $4;
                  i64toi32_i32$3 = HEAP32[($4 + 64 | 0) >> 2] | 0;
                  i64toi32_i32$0 = HEAP32[($4 + 68 | 0) >> 2] | 0;
                  i64toi32_i32$2 = i64toi32_i32$3;
                  i64toi32_i32$3 = 0;
                  i64toi32_i32$1 = 1;
                  if ((i64toi32_i32$2 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) | 0) {
                   break label$19
                  }
                  if (($5 & 255 | 0 | 0) == (1 | 0)) {
                   break label$13
                  }
                  $1 = 6;
                  break label$9;
                 }
                 $u16_20as_20cbor_event__de__Deserialize___deserialize__h16dd941998750727($4 + 64 | 0 | 0, $1 | 0);
                 $6 = 1;
                 if ((HEAPU16[($4 + 64 | 0) >> 1] | 0 | 0) == (1 | 0)) {
                  break label$11
                 }
                 $9 = HEAPU16[($4 + 66 | 0) >> 1] | 0;
                 break label$12;
                }
                i64toi32_i32$1 = $4;
                i64toi32_i32$2 = HEAPU8[($4 + 73 | 0) >> 0] | 0 | ((HEAPU8[($4 + 74 | 0) >> 0] | 0) << 8 | 0) | 0;
                i64toi32_i32$0 = 0;
                $111 = i64toi32_i32$2;
                $111$hi = i64toi32_i32$0;
                i64toi32_i32$1 = $4 + 75 | 0;
                i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
                i64toi32_i32$2 = 0;
                i64toi32_i32$1 = i64toi32_i32$0;
                i64toi32_i32$0 = 0;
                i64toi32_i32$3 = 16;
                i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
                if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                 i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
                 $66 = 0;
                } else {
                 i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
                 $66 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
                }
                $115$hi = i64toi32_i32$0;
                i64toi32_i32$0 = $111$hi;
                i64toi32_i32$2 = $111;
                i64toi32_i32$1 = $115$hi;
                i64toi32_i32$3 = $66;
                i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
                i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
                i64toi32_i32$2 = 0;
                i64toi32_i32$3 = 8;
                i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
                if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                 i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
                 $67 = 0;
                } else {
                 i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
                 $67 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
                }
                $117$hi = i64toi32_i32$2;
                i64toi32_i32$2 = 0;
                i64toi32_i32$1 = $5;
                i64toi32_i32$0 = 0;
                i64toi32_i32$3 = 255;
                i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
                $120 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
                $120$hi = i64toi32_i32$0;
                i64toi32_i32$0 = $117$hi;
                i64toi32_i32$2 = $67;
                i64toi32_i32$1 = $120$hi;
                i64toi32_i32$3 = $120;
                i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
                $121 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
                $121$hi = i64toi32_i32$1;
                i64toi32_i32$0 = $4;
                i64toi32_i32$1 = HEAP32[($4 + 76 | 0) >> 2] | 0;
                i64toi32_i32$2 = 0;
                i64toi32_i32$0 = i64toi32_i32$1;
                i64toi32_i32$1 = 0;
                i64toi32_i32$3 = 32;
                i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
                if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                 i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
                 $68 = 0;
                } else {
                 i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
                 $68 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
                }
                $124$hi = i64toi32_i32$1;
                i64toi32_i32$1 = $121$hi;
                i64toi32_i32$2 = $121;
                i64toi32_i32$0 = $124$hi;
                i64toi32_i32$3 = $68;
                i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
                $11 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
                $11$hi = i64toi32_i32$0;
                i64toi32_i32$1 = $4 + 104 | 0;
                i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                $13 = i64toi32_i32$0;
                $13$hi = i64toi32_i32$2;
                i64toi32_i32$1 = $4 + 96 | 0;
                i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                $12 = i64toi32_i32$2;
                $12$hi = i64toi32_i32$0;
                $6 = HEAP32[($4 + 92 | 0) >> 2] | 0;
                $5 = HEAP32[($4 + 88 | 0) >> 2] | 0;
                i64toi32_i32$1 = $4 + 80 | 0;
                i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                $10 = i64toi32_i32$0;
                $10$hi = i64toi32_i32$2;
                break label$10;
               }
               memcpy($4 + 64 | 0 | 0, $4 + 136 | 0 | 1 | 0 | 0, 63 | 0) | 0;
               HEAP8[($0 + 8 | 0) >> 0] = $5;
               memcpy($0 + 9 | 0 | 0, $4 + 64 | 0 | 0, 63 | 0) | 0;
               HEAP16[$0 >> 1] = 1;
               break label$1;
              }
              $6 = 0;
             }
             std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($4 + 16 | 0 | 0, $1 | 0);
             $5 = 0;
             label$21 : {
              label$22 : {
               if (HEAP32[($4 + 20 | 0) >> 2] | 0) {
                break label$22
               }
               i64toi32_i32$2 = 0;
               $10 = 0;
               $10$hi = i64toi32_i32$2;
               i64toi32_i32$2 = 0;
               $11 = 8;
               $11$hi = i64toi32_i32$2;
               $9 = 2;
               break label$21;
              }
              label$23 : {
               label$24 : {
                label$25 : {
                 label$26 : {
                  if ((($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[($4 + 16 | 0) >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) != (7 | 0)) {
                   break label$26
                  }
                  cbor_event__de__Deserializer_R___special__h10e912d855f56298($4 + 248 | 0 | 0, $1 | 0);
                  $8 = HEAPU8[($4 + 256 | 0) >> 0] | 0;
                  i64toi32_i32$1 = $4;
                  i64toi32_i32$2 = HEAP32[($4 + 248 | 0) >> 2] | 0;
                  i64toi32_i32$0 = HEAP32[($4 + 252 | 0) >> 2] | 0;
                  i64toi32_i32$1 = i64toi32_i32$2;
                  i64toi32_i32$2 = 0;
                  i64toi32_i32$3 = 1;
                  if ((i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) | 0) {
                   break label$23
                  }
                  $5 = 0;
                  if (($8 & 255 | 0 | 0) == (1 | 0)) {
                   break label$25
                  }
                  $9 = 6;
                  break label$21;
                 }
                 cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__Ipv4___deserialize__he9338b7b9f2de34e($4 + 248 | 0 | 0, $1 | 0);
                 $5 = 1;
                 if ((HEAPU8[($4 + 248 | 0) >> 0] | 0 | 0) == (1 | 0)) {
                  break label$24
                 }
                 $7 = HEAPU8[($4 + 249 | 0) >> 0] | 0 | ((HEAPU8[($4 + 250 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 251 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 252 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                }
                HEAP16[($4 + 138 | 0) >> 1] = $7;
                HEAP16[($4 + 140 | 0) >> 1] = $7 >>> 16 | 0;
                HEAP8[($4 + 137 | 0) >> 0] = $5;
                HEAP32[($4 + 32 | 0) >> 2] = HEAPU8[($4 + 137 | 0) >> 0] | 0 | ((HEAPU8[($4 + 138 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 139 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 140 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                HEAP8[($4 + 36 | 0) >> 0] = HEAPU8[($4 + 141 | 0) >> 0] | 0;
                std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($4 + 8 | 0 | 0, $1 | 0);
                if (!(HEAP32[($4 + 12 | 0) >> 2] | 0)) {
                 break label$4
                }
                if ((($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[($4 + 8 | 0) >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) != (7 | 0)) {
                 break label$8
                }
                cbor_event__de__Deserializer_R___special__h10e912d855f56298($4 + 248 | 0 | 0, $1 | 0);
                $5 = HEAPU8[($4 + 256 | 0) >> 0] | 0;
                i64toi32_i32$3 = $4;
                i64toi32_i32$1 = HEAP32[($4 + 248 | 0) >> 2] | 0;
                i64toi32_i32$0 = HEAP32[($4 + 252 | 0) >> 2] | 0;
                i64toi32_i32$3 = i64toi32_i32$1;
                i64toi32_i32$1 = 0;
                i64toi32_i32$2 = 1;
                if ((i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
                 break label$7
                }
                $1 = 0;
                if (($5 & 255 | 0 | 0) == (1 | 0)) {
                 break label$6
                }
                $5 = 6;
                break label$2;
               }
               HEAP32[(($4 + 40 | 0) + 8 | 0) >> 2] = HEAP32[($4 + 316 | 0) >> 2] | 0;
               $55 = $4 + 257 | 0;
               HEAP32[($4 + 208 | 0) >> 2] = HEAPU8[$55 >> 0] | 0 | ((HEAPU8[($55 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($55 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($55 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
               $56 = $4 + 260 | 0;
               $57 = HEAPU8[$56 >> 0] | 0 | ((HEAPU8[($56 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($56 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($56 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
               HEAP8[($4 + 211 | 0) >> 0] = $57;
               HEAP8[($4 + 212 | 0) >> 0] = $57 >>> 8 | 0;
               HEAP8[($4 + 213 | 0) >> 0] = $57 >>> 16 | 0;
               HEAP8[($4 + 214 | 0) >> 0] = $57 >>> 24 | 0;
               i64toi32_i32$2 = $4 + 308 | 0;
               i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
               i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
               $236 = i64toi32_i32$3;
               i64toi32_i32$3 = $4;
               HEAP32[($4 + 40 | 0) >> 2] = $236;
               HEAP32[($4 + 44 | 0) >> 2] = i64toi32_i32$0;
               $9 = HEAPU8[(($4 + 248 | 0) + 8 | 0) >> 0] | 0;
               i64toi32_i32$2 = $4 + 264 | 0;
               i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
               i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
               $11 = i64toi32_i32$0;
               $11$hi = i64toi32_i32$3;
               i64toi32_i32$2 = $4 + 272 | 0;
               i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
               i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
               $10 = i64toi32_i32$3;
               $10$hi = i64toi32_i32$0;
               $1 = HEAP32[($4 + 280 | 0) >> 2] | 0;
               $6 = HEAP32[($4 + 284 | 0) >> 2] | 0;
               i64toi32_i32$2 = $4 + 288 | 0;
               i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
               i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
               $12 = i64toi32_i32$0;
               $12$hi = i64toi32_i32$3;
               i64toi32_i32$2 = $4 + 296 | 0;
               i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
               i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
               $13 = i64toi32_i32$3;
               $13$hi = i64toi32_i32$0;
               $5 = HEAP32[($4 + 304 | 0) >> 2] | 0;
               break label$21;
              }
              i64toi32_i32$2 = $4;
              i64toi32_i32$0 = HEAPU8[($4 + 257 | 0) >> 0] | 0 | ((HEAPU8[($4 + 258 | 0) >> 0] | 0) << 8 | 0) | 0;
              i64toi32_i32$3 = 0;
              $263 = i64toi32_i32$0;
              $263$hi = i64toi32_i32$3;
              i64toi32_i32$2 = $4 + 259 | 0;
              i64toi32_i32$3 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
              i64toi32_i32$0 = 0;
              i64toi32_i32$2 = i64toi32_i32$3;
              i64toi32_i32$3 = 0;
              i64toi32_i32$1 = 16;
              i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
              if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
               i64toi32_i32$3 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
               $69 = 0;
              } else {
               i64toi32_i32$3 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
               $69 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
              }
              $267$hi = i64toi32_i32$3;
              i64toi32_i32$3 = $263$hi;
              i64toi32_i32$0 = $263;
              i64toi32_i32$2 = $267$hi;
              i64toi32_i32$1 = $69;
              i64toi32_i32$2 = i64toi32_i32$3 | i64toi32_i32$2 | 0;
              i64toi32_i32$3 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
              i64toi32_i32$0 = 0;
              i64toi32_i32$1 = 8;
              i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
              if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
               i64toi32_i32$0 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
               $70 = 0;
              } else {
               i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
               $70 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
              }
              $269$hi = i64toi32_i32$0;
              i64toi32_i32$0 = 0;
              i64toi32_i32$2 = $8;
              i64toi32_i32$3 = 0;
              i64toi32_i32$1 = 255;
              i64toi32_i32$3 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
              $272 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
              $272$hi = i64toi32_i32$3;
              i64toi32_i32$3 = $269$hi;
              i64toi32_i32$0 = $70;
              i64toi32_i32$2 = $272$hi;
              i64toi32_i32$1 = $272;
              i64toi32_i32$2 = i64toi32_i32$3 | i64toi32_i32$2 | 0;
              $273 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
              $273$hi = i64toi32_i32$2;
              i64toi32_i32$3 = $4;
              i64toi32_i32$2 = HEAP32[($4 + 260 | 0) >> 2] | 0;
              i64toi32_i32$0 = 0;
              i64toi32_i32$3 = i64toi32_i32$2;
              i64toi32_i32$2 = 0;
              i64toi32_i32$1 = 32;
              i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
              if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
               i64toi32_i32$2 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
               $71 = 0;
              } else {
               i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
               $71 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
              }
              $276$hi = i64toi32_i32$2;
              i64toi32_i32$2 = $273$hi;
              i64toi32_i32$0 = $273;
              i64toi32_i32$3 = $276$hi;
              i64toi32_i32$1 = $71;
              i64toi32_i32$3 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
              $11 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
              $11$hi = i64toi32_i32$3;
              i64toi32_i32$2 = $4 + 288 | 0;
              i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
              i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
              $13 = i64toi32_i32$3;
              $13$hi = i64toi32_i32$0;
              i64toi32_i32$2 = $4 + 280 | 0;
              i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
              i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
              $12 = i64toi32_i32$0;
              $12$hi = i64toi32_i32$3;
              $6 = HEAP32[($4 + 276 | 0) >> 2] | 0;
              $1 = HEAP32[($4 + 272 | 0) >> 2] | 0;
              i64toi32_i32$2 = $4 + 264 | 0;
              i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
              i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
              $10 = i64toi32_i32$3;
              $10$hi = i64toi32_i32$0;
              $9 = 2;
             }
             i64toi32_i32$0 = $13$hi;
             i64toi32_i32$3 = $4 + 288 | 0;
             HEAP32[i64toi32_i32$3 >> 2] = $13;
             HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
             i64toi32_i32$0 = $12$hi;
             i64toi32_i32$3 = $4 + 280 | 0;
             HEAP32[i64toi32_i32$3 >> 2] = $12;
             HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
             HEAP32[($4 + 276 | 0) >> 2] = $6;
             HEAP32[($4 + 272 | 0) >> 2] = $1;
             i64toi32_i32$0 = $10$hi;
             i64toi32_i32$3 = $4 + 264 | 0;
             HEAP32[i64toi32_i32$3 >> 2] = $10;
             HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
             i64toi32_i32$0 = $11$hi;
             i64toi32_i32$3 = ($4 + 248 | 0) + 8 | 0;
             HEAP32[i64toi32_i32$3 >> 2] = $11;
             HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
             i64toi32_i32$2 = $4;
             i64toi32_i32$0 = HEAP32[($4 + 40 | 0) >> 2] | 0;
             i64toi32_i32$3 = HEAP32[($4 + 44 | 0) >> 2] | 0;
             $315 = i64toi32_i32$0;
             i64toi32_i32$0 = $4 + 300 | 0;
             HEAP32[i64toi32_i32$0 >> 2] = $315;
             HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
             HEAP32[($4 + 308 | 0) >> 2] = HEAP32[(($4 + 40 | 0) + 8 | 0) >> 2] | 0;
             HEAP8[($4 + 248 | 0) >> 0] = $9;
             $58 = HEAP32[($4 + 208 | 0) >> 2] | 0;
             HEAP8[($4 + 249 | 0) >> 0] = $58;
             HEAP8[($4 + 250 | 0) >> 0] = $58 >>> 8 | 0;
             HEAP8[($4 + 251 | 0) >> 0] = $58 >>> 16 | 0;
             HEAP8[($4 + 252 | 0) >> 0] = $58 >>> 24 | 0;
             $59 = HEAPU8[($4 + 211 | 0) >> 0] | 0 | ((HEAPU8[($4 + 212 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 213 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 214 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             HEAP8[($4 + 252 | 0) >> 0] = $59;
             HEAP8[($4 + 253 | 0) >> 0] = $59 >>> 8 | 0;
             HEAP8[($4 + 254 | 0) >> 0] = $59 >>> 16 | 0;
             HEAP8[($4 + 255 | 0) >> 0] = $59 >>> 24 | 0;
             HEAP32[($4 + 296 | 0) >> 2] = $5;
             $1 = ($4 + 136 | 0) + 8 | 0;
             cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 248 | 0 | 0, 1051426 | 0, 4 | 0);
             memcpy($0 + 8 | 0 | 0, memcpy($4 + 66 | 0 | 0, $1 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
             HEAP16[$0 >> 1] = 1;
             break label$1;
            }
            i64toi32_i32$2 = $4 + 104 | 0;
            i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
            i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
            $13 = i64toi32_i32$3;
            $13$hi = i64toi32_i32$0;
            i64toi32_i32$2 = $4 + 96 | 0;
            i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
            i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
            $12 = i64toi32_i32$0;
            $12$hi = i64toi32_i32$3;
            $6 = HEAP32[($4 + 92 | 0) >> 2] | 0;
            $5 = HEAP32[($4 + 88 | 0) >> 2] | 0;
            i64toi32_i32$2 = $4 + 80 | 0;
            i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
            i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
            $10 = i64toi32_i32$3;
            $10$hi = i64toi32_i32$0;
            i64toi32_i32$2 = $4 + 72 | 0;
            i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
            i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
            $11 = i64toi32_i32$0;
            $11$hi = i64toi32_i32$3;
           }
           $1 = 2;
          }
          i64toi32_i32$3 = $13$hi;
          i64toi32_i32$0 = $4 + 104 | 0;
          HEAP32[i64toi32_i32$0 >> 2] = $13;
          HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
          i64toi32_i32$3 = $12$hi;
          i64toi32_i32$0 = $4 + 96 | 0;
          HEAP32[i64toi32_i32$0 >> 2] = $12;
          HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
          HEAP32[($4 + 92 | 0) >> 2] = $6;
          HEAP32[($4 + 88 | 0) >> 2] = $5;
          i64toi32_i32$3 = $10$hi;
          i64toi32_i32$0 = $4 + 80 | 0;
          HEAP32[i64toi32_i32$0 >> 2] = $10;
          HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
          i64toi32_i32$3 = $11$hi;
          i64toi32_i32$0 = ($4 + 64 | 0) + 8 | 0;
          HEAP32[i64toi32_i32$0 >> 2] = $11;
          HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
          HEAP32[($4 + 112 | 0) >> 2] = 0;
          HEAP8[($4 + 64 | 0) >> 0] = $1;
          $1 = ($4 + 248 | 0) + 8 | 0;
          cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 64 | 0 | 0, 1051422 | 0, 4 | 0);
          memcpy($0 + 8 | 0 | 0, memcpy($4 + 138 | 0 | 0, $1 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
          HEAP16[$0 >> 1] = 1;
          break label$1;
         }
         cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__Ipv6___deserialize__hca2aa2a334ab12c8($4 + 248 | 0 | 0, $1 | 0);
         $1 = 1;
         label$27 : {
          if ((HEAPU8[($4 + 248 | 0) >> 0] | 0 | 0) == (1 | 0)) {
           break label$27
          }
          HEAP16[($4 + 244 | 0) >> 1] = HEAPU8[($4 + 253 | 0) >> 0] | 0 | ((HEAPU8[($4 + 254 | 0) >> 0] | 0) << 8 | 0) | 0;
          HEAP32[($4 + 240 | 0) >> 2] = HEAPU8[($4 + 249 | 0) >> 0] | 0 | ((HEAPU8[($4 + 250 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 251 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 252 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          $5 = HEAPU8[($4 + 256 | 0) >> 0] | 0;
          i64toi32_i32$2 = $4 + 257 | 0;
          i64toi32_i32$3 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          $10 = i64toi32_i32$3;
          $10$hi = i64toi32_i32$0;
          $8 = HEAPU8[($4 + 255 | 0) >> 0] | 0;
          break label$5;
         }
         HEAP32[(($4 + 208 | 0) + 8 | 0) >> 2] = HEAP32[($4 + 316 | 0) >> 2] | 0;
         i64toi32_i32$2 = $4 + 308 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $430 = i64toi32_i32$0;
         i64toi32_i32$0 = $4;
         HEAP32[($4 + 208 | 0) >> 2] = $430;
         HEAP32[($4 + 212 | 0) >> 2] = i64toi32_i32$3;
         HEAP8[($4 + 232 | 0) >> 0] = HEAPU8[($4 + 265 | 0) >> 0] | 0;
         i64toi32_i32$2 = $4 + 257 | 0;
         i64toi32_i32$3 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $438 = i64toi32_i32$3;
         i64toi32_i32$3 = $4;
         HEAP32[($4 + 224 | 0) >> 2] = $438;
         HEAP32[($4 + 228 | 0) >> 2] = i64toi32_i32$0;
         $1 = HEAP32[($4 + 304 | 0) >> 2] | 0;
         i64toi32_i32$2 = $4 + 296 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $12 = i64toi32_i32$0;
         $12$hi = i64toi32_i32$3;
         i64toi32_i32$2 = $4 + 288 | 0;
         i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $11 = i64toi32_i32$3;
         $11$hi = i64toi32_i32$0;
         $7 = HEAP32[($4 + 284 | 0) >> 2] | 0;
         $8 = HEAP32[($4 + 280 | 0) >> 2] | 0;
         i64toi32_i32$2 = $4 + 272 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $10 = i64toi32_i32$0;
         $10$hi = i64toi32_i32$3;
         $9 = HEAP32[($4 + 268 | 0) >> 2] | 0;
         $6 = HEAPU16[($4 + 266 | 0) >> 1] | 0;
         $5 = HEAPU8[(($4 + 248 | 0) + 8 | 0) >> 0] | 0;
         break label$2;
        }
        $1 = HEAPU8[($4 + 257 | 0) >> 0] | 0 | ((HEAPU8[($4 + 258 | 0) >> 0] | 0) << 8 | 0) | 0;
        HEAP8[($4 + 232 | 0) >> 0] = $1;
        HEAP8[($4 + 231 | 0) >> 0] = $5;
        $6 = ($1 | ((HEAPU8[($4 + 259 | 0) >> 0] | 0) << 16 | 0) | 0) >>> 8 | 0;
        i64toi32_i32$2 = $4 + 288 | 0;
        i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $12 = i64toi32_i32$3;
        $12$hi = i64toi32_i32$0;
        i64toi32_i32$2 = $4 + 280 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $11 = i64toi32_i32$0;
        $11$hi = i64toi32_i32$3;
        $7 = HEAP32[($4 + 276 | 0) >> 2] | 0;
        $8 = HEAP32[($4 + 272 | 0) >> 2] | 0;
        i64toi32_i32$2 = ($4 + 248 | 0) + 16 | 0;
        i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $10 = i64toi32_i32$3;
        $10$hi = i64toi32_i32$0;
        $9 = HEAP32[($4 + 260 | 0) >> 2] | 0;
        $5 = 2;
        break label$3;
       }
      }
      HEAP8[(($4 + 136 | 0) + 8 | 0) >> 0] = $8;
      i64toi32_i32$0 = $10$hi;
      i64toi32_i32$3 = $4;
      HEAP8[($4 + 225 | 0) >> 0] = $10;
      HEAP8[($4 + 226 | 0) >> 0] = $10 >>> 8 | 0;
      HEAP8[($4 + 227 | 0) >> 0] = $10 >>> 16 | 0;
      HEAP8[($4 + 228 | 0) >> 0] = $10 >>> 24 | 0;
      HEAP8[($4 + 229 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[($4 + 230 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[($4 + 231 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[($4 + 232 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      HEAP8[($4 + 224 | 0) >> 0] = $5;
      $5 = ($4 + 64 | 0) + 8 | 0;
      i64toi32_i32$2 = $4;
      i64toi32_i32$0 = HEAP32[($4 + 224 | 0) >> 2] | 0;
      i64toi32_i32$3 = HEAP32[($4 + 228 | 0) >> 2] | 0;
      $511 = i64toi32_i32$0;
      i64toi32_i32$0 = $5;
      HEAP32[i64toi32_i32$0 >> 2] = $511;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
      $8 = ($4 + 64 | 0) + 16 | 0;
      HEAP8[$8 >> 0] = HEAPU8[(($4 + 224 | 0) + 8 | 0) >> 0] | 0;
      HEAP8[($4 + 137 | 0) >> 0] = $1;
      $72 = HEAP32[($4 + 240 | 0) >> 2] | 0;
      HEAP16[($4 + 138 | 0) >> 1] = $72;
      HEAP16[($4 + 140 | 0) >> 1] = $72 >>> 16 | 0;
      HEAP16[($4 + 142 | 0) >> 1] = HEAPU16[(($4 + 240 | 0) + 4 | 0) >> 1] | 0;
      i64toi32_i32$2 = $4;
      i64toi32_i32$3 = HEAPU8[($4 + 137 | 0) >> 0] | 0 | ((HEAPU8[($4 + 138 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 139 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 140 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[($4 + 141 | 0) >> 0] | 0 | ((HEAPU8[($4 + 142 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 143 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 144 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $532 = i64toi32_i32$3;
      i64toi32_i32$3 = $4;
      HEAP32[($4 + 64 | 0) >> 2] = $532;
      HEAP32[($4 + 68 | 0) >> 2] = i64toi32_i32$0;
      $1 = ($4 + 40 | 0) + 16 | 0;
      HEAP8[$1 >> 0] = HEAPU8[$8 >> 0] | 0;
      $8 = ($4 + 40 | 0) + 8 | 0;
      i64toi32_i32$2 = $5;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $544 = i64toi32_i32$0;
      i64toi32_i32$0 = $8;
      HEAP32[i64toi32_i32$0 >> 2] = $544;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
      i64toi32_i32$2 = $4;
      i64toi32_i32$3 = HEAP32[($4 + 64 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($4 + 68 | 0) >> 2] | 0;
      $547 = i64toi32_i32$3;
      i64toi32_i32$3 = $4;
      HEAP32[($4 + 40 | 0) >> 2] = $547;
      HEAP32[($4 + 44 | 0) >> 2] = i64toi32_i32$0;
      HEAP16[($0 + 4 | 0) >> 1] = $9;
      HEAP16[($0 + 2 | 0) >> 1] = $6;
      HEAP8[($0 + 10 | 0) >> 0] = HEAPU8[($4 + 36 | 0) >> 0] | 0;
      $60 = $0 + 6 | 0;
      $61 = HEAP32[($4 + 32 | 0) >> 2] | 0;
      HEAP8[$60 >> 0] = $61;
      HEAP8[($60 + 1 | 0) >> 0] = $61 >>> 8 | 0;
      HEAP8[($60 + 2 | 0) >> 0] = $61 >>> 16 | 0;
      HEAP8[($60 + 3 | 0) >> 0] = $61 >>> 24 | 0;
      HEAP16[$0 >> 1] = 0;
      i64toi32_i32$2 = $4;
      i64toi32_i32$0 = HEAP32[($4 + 40 | 0) >> 2] | 0;
      i64toi32_i32$3 = HEAP32[($4 + 44 | 0) >> 2] | 0;
      $565 = i64toi32_i32$0;
      i64toi32_i32$0 = $0 + 11 | 0;
      $62 = $565;
      HEAP8[i64toi32_i32$0 >> 0] = $62;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $62 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $62 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $62 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$3;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
      i64toi32_i32$2 = $8;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $569 = i64toi32_i32$3;
      i64toi32_i32$3 = $0 + 19 | 0;
      $63 = $569;
      HEAP8[i64toi32_i32$3 >> 0] = $63;
      HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $63 >>> 8 | 0;
      HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $63 >>> 16 | 0;
      HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $63 >>> 24 | 0;
      HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      HEAP8[($0 + 27 | 0) >> 0] = HEAPU8[$1 >> 0] | 0;
      break label$1;
     }
     $73 = 8;
     HEAP8[($4 + 231 | 0) >> 0] = $73;
     HEAP8[($4 + 232 | 0) >> 0] = $73 >>> 8 | 0;
     $5 = 2;
     $6 = 0;
     i64toi32_i32$0 = 0;
     $10 = 0;
     $10$hi = i64toi32_i32$0;
     $9 = 0;
    }
    $1 = 0;
   }
   i64toi32_i32$0 = $12$hi;
   i64toi32_i32$3 = $4 + 288 | 0;
   HEAP32[i64toi32_i32$3 >> 2] = $12;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $11$hi;
   i64toi32_i32$3 = $4 + 280 | 0;
   HEAP32[i64toi32_i32$3 >> 2] = $11;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($4 + 276 | 0) >> 2] = $7;
   HEAP32[($4 + 272 | 0) >> 2] = $8;
   i64toi32_i32$0 = $10$hi;
   i64toi32_i32$3 = $4 + 264 | 0;
   HEAP32[i64toi32_i32$3 >> 2] = $10;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($4 + 260 | 0) >> 2] = $9;
   HEAP16[($4 + 258 | 0) >> 1] = $6;
   i64toi32_i32$2 = $4;
   i64toi32_i32$0 = HEAP32[($4 + 208 | 0) >> 2] | 0;
   i64toi32_i32$3 = HEAP32[($4 + 212 | 0) >> 2] | 0;
   $599 = i64toi32_i32$0;
   i64toi32_i32$0 = $4 + 300 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $599;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
   HEAP8[($4 + 257 | 0) >> 0] = HEAPU8[(($4 + 224 | 0) + 8 | 0) >> 0] | 0;
   HEAP32[($4 + 308 | 0) >> 2] = HEAP32[(($4 + 208 | 0) + 8 | 0) >> 2] | 0;
   HEAP8[($4 + 248 | 0) >> 0] = $5;
   i64toi32_i32$2 = $4;
   i64toi32_i32$3 = HEAP32[($4 + 224 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($4 + 228 | 0) >> 2] | 0;
   $616 = i64toi32_i32$3;
   i64toi32_i32$3 = $4;
   $64 = $616;
   HEAP8[($4 + 249 | 0) >> 0] = $64;
   HEAP8[($4 + 250 | 0) >> 0] = $64 >>> 8 | 0;
   HEAP8[($4 + 251 | 0) >> 0] = $64 >>> 16 | 0;
   HEAP8[($4 + 252 | 0) >> 0] = $64 >>> 24 | 0;
   HEAP8[($4 + 253 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[($4 + 254 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[($4 + 255 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[($4 + 256 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   HEAP32[($4 + 296 | 0) >> 2] = $1;
   $1 = ($4 + 136 | 0) + 8 | 0;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 248 | 0 | 0, 1051430 | 0, 4 | 0);
   memcpy($0 + 8 | 0 | 0, memcpy($4 + 64 | 0 | 7 | 0 | 0, $1 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   HEAP16[$0 >> 1] = 1;
  }
  global$0 = $4 + 320 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__Transaction___deserialize_as_embedded_group__hf38a6fe2a34e8cd2($0, $1, $2, $2$hi, $3, $3$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $12 = 0, $5 = 0, $12$hi = 0, $10$hi = 0, $11 = 0, $11$hi = 0, $10 = 0, $13 = 0, $13$hi = 0, $14 = 0, $14$hi = 0, $15 = 0, $15$hi = 0, $6 = 0, $8 = 0, $7 = 0, $9 = 0, $16 = 0, $16$hi = 0, $17 = 0, $17$hi = 0, $69 = 0, $70 = 0, $71 = 0, $72 = 0, $73 = 0, $74 = 0, $75 = 0, $76 = 0, $77 = 0, $78 = 0, $79 = 0, $18 = 0, $18$hi = 0, $80 = 0, $81 = 0, $82 = 0, $83 = 0, $156 = 0, $195 = 0, $243 = 0, $245 = 0, $245$hi = 0, $248 = 0, $248$hi = 0, $252$hi = 0, $254$hi = 0, $320$hi = 0, $322$hi = 0, $323 = 0, $323$hi = 0, $325 = 0, $325$hi = 0, $329$hi = 0, $331$hi = 0, $364 = 0, $377 = 0, $380 = 0, $19 = 0, $19$hi = 0, $20 = 0, $20$hi = 0, $559$hi = 0, $562 = 0, $562$hi = 0, $563 = 0, $563$hi = 0, $565 = 0, $565$hi = 0, $569$hi = 0, $571$hi = 0, $612 = 0;
  $4 = global$0 - 1920 | 0;
  global$0 = $4;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__TransactionBody___deserialize__h3099fdd842acebc9($4 + 1208 | 0 | 0, $1 | 0);
  $5 = ($4 + 1208 | 0) + 8 | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        i64toi32_i32$2 = $4;
        i64toi32_i32$0 = HEAP32[($4 + 1208 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($4 + 1212 | 0) >> 2] | 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
         break label$6
        }
        memcpy($4 + 1632 | 0 | 0, $5 | 0, 272 | 0) | 0;
        memcpy($4 + 840 | 0 | 0, $4 + 1632 | 0 | 0, 272 | 0) | 0;
        memcpy($4 + 288 | 0 | 0, memcpy(($4 + 560 | 0) + 8 | 0 | 0, $4 + 840 | 0 | 0, 272 | 0) | 0 | 0, 272 | 0) | 0;
        memcpy($4 + 16 | 0 | 0, $4 + 288 | 0 | 0, 272 | 0) | 0;
        cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__TransactionWitnessSet___deserialize__h9deaf1b9ab40fbb6($4 + 1208 | 0 | 0, $1 | 0);
        label$7 : {
         label$8 : {
          label$9 : {
           label$10 : {
            label$11 : {
             label$12 : {
              label$13 : {
               label$14 : {
                if ((HEAP32[($4 + 1208 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                 break label$14
                }
                memcpy($4 + 1632 | 0 | 0, $4 + 1208 | 0 | 4 | 0 | 0, 76 | 0) | 0;
                memcpy($4 + 840 | 0 | 0, $4 + 1632 | 0 | 0, 76 | 0) | 0;
                memcpy($4 + 288 | 0 | 0, memcpy($4 + 560 | 0 | 4 | 0 | 0, $4 + 840 | 0 | 0, 76 | 0) | 0 | 0, 76 | 0) | 0;
                memcpy($4 + 1112 | 0 | 0, $4 + 288 | 0 | 0, 76 | 0) | 0;
                i64toi32_i32$2 = 0;
                $10 = 0;
                $10$hi = i64toi32_i32$2;
                i64toi32_i32$1 = $4;
                i64toi32_i32$2 = 0;
                HEAP32[($4 + 840 | 0) >> 2] = 0;
                HEAP32[($4 + 844 | 0) >> 2] = i64toi32_i32$2;
                std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($4 + 8 | 0 | 0, $1 | 0);
                $5 = 2;
                $6 = 0;
                label$15 : {
                 if (HEAP32[($4 + 12 | 0) >> 2] | 0) {
                  break label$15
                 }
                 i64toi32_i32$2 = 0;
                 $11 = 8;
                 $11$hi = i64toi32_i32$2;
                 break label$10;
                }
                label$16 : {
                 label$17 : {
                  if ((($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[($4 + 8 | 0) >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) == (7 | 0)) {
                   break label$17
                  }
                  $cardano_serialization_lib__metadata__AuxiliaryData_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hca865c989495a465($4 + 560 | 0 | 0, $1 | 0);
                  i64toi32_i32$3 = ($4 + 560 | 0) + 64 | 0;
                  i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                  i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                  $10 = i64toi32_i32$2;
                  $10$hi = i64toi32_i32$1;
                  $5 = ($4 + 560 | 0) + 56 | 0;
                  i64toi32_i32$3 = $5;
                  i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                  $11 = i64toi32_i32$1;
                  $11$hi = i64toi32_i32$2;
                  i64toi32_i32$3 = ($4 + 560 | 0) + 48 | 0;
                  i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                  i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                  $12 = i64toi32_i32$2;
                  $12$hi = i64toi32_i32$1;
                  $6 = ($4 + 560 | 0) + 40 | 0;
                  i64toi32_i32$3 = $6;
                  i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                  $13 = i64toi32_i32$1;
                  $13$hi = i64toi32_i32$2;
                  $7 = ($4 + 560 | 0) + 32 | 0;
                  i64toi32_i32$3 = $7;
                  i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                  i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                  $14 = i64toi32_i32$2;
                  $14$hi = i64toi32_i32$1;
                  $8 = ($4 + 560 | 0) + 24 | 0;
                  i64toi32_i32$3 = $8;
                  i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                  $15 = i64toi32_i32$1;
                  $15$hi = i64toi32_i32$2;
                  $9 = ($4 + 560 | 0) + 16 | 0;
                  i64toi32_i32$3 = $9;
                  i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                  i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                  $16 = i64toi32_i32$2;
                  $16$hi = i64toi32_i32$1;
                  i64toi32_i32$3 = $4;
                  i64toi32_i32$1 = HEAP32[($4 + 568 | 0) >> 2] | 0;
                  i64toi32_i32$2 = HEAP32[($4 + 572 | 0) >> 2] | 0;
                  $17 = i64toi32_i32$1;
                  $17$hi = i64toi32_i32$2;
                  i64toi32_i32$3 = $4;
                  i64toi32_i32$2 = HEAP32[($4 + 560 | 0) >> 2] | 0;
                  i64toi32_i32$1 = HEAP32[($4 + 564 | 0) >> 2] | 0;
                  i64toi32_i32$3 = i64toi32_i32$2;
                  i64toi32_i32$2 = 0;
                  i64toi32_i32$0 = 1;
                  if ((i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) | 0) {
                   break label$16
                  }
                  i64toi32_i32$3 = $11$hi;
                  i64toi32_i32$1 = ($4 + 1208 | 0) + 64 | 0;
                  HEAP32[i64toi32_i32$1 >> 2] = $11;
                  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
                  i64toi32_i32$3 = $12$hi;
                  i64toi32_i32$1 = ($4 + 1208 | 0) + 56 | 0;
                  HEAP32[i64toi32_i32$1 >> 2] = $12;
                  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
                  $5 = $4 + 1912 | 0;
                  HEAP32[$5 >> 2] = HEAP32[($4 + 1276 | 0) >> 2] | 0;
                  i64toi32_i32$0 = $4;
                  i64toi32_i32$3 = HEAP32[($4 + 1268 | 0) >> 2] | 0;
                  i64toi32_i32$1 = HEAP32[($4 + 1272 | 0) >> 2] | 0;
                  $156 = i64toi32_i32$3;
                  i64toi32_i32$3 = $4;
                  HEAP32[($4 + 1904 | 0) >> 2] = $156;
                  HEAP32[($4 + 1908 | 0) >> 2] = i64toi32_i32$1;
                  core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__metadata__AuxiliaryData____ha98f6c5d89b7a772($4 + 840 | 0 | 0);
                  i64toi32_i32$1 = $12$hi;
                  HEAP32[(($4 + 840 | 0) + 48 | 0) >> 2] = $12;
                  i64toi32_i32$1 = $13$hi;
                  i64toi32_i32$3 = ($4 + 840 | 0) + 40 | 0;
                  HEAP32[i64toi32_i32$3 >> 2] = $13;
                  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
                  i64toi32_i32$1 = $14$hi;
                  i64toi32_i32$3 = ($4 + 840 | 0) + 32 | 0;
                  HEAP32[i64toi32_i32$3 >> 2] = $14;
                  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
                  i64toi32_i32$1 = $15$hi;
                  i64toi32_i32$3 = ($4 + 840 | 0) + 24 | 0;
                  HEAP32[i64toi32_i32$3 >> 2] = $15;
                  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
                  i64toi32_i32$1 = $16$hi;
                  i64toi32_i32$3 = ($4 + 840 | 0) + 16 | 0;
                  HEAP32[i64toi32_i32$3 >> 2] = $16;
                  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
                  i64toi32_i32$1 = $10$hi;
                  i64toi32_i32$3 = ($4 + 840 | 0) + 64 | 0;
                  HEAP32[i64toi32_i32$3 >> 2] = $10;
                  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
                  HEAP32[($4 + 900 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
                  i64toi32_i32$1 = 0;
                  HEAP8[($4 + 847 | 0) >> 0] = 0;
                  i64toi32_i32$1 = 0;
                  $70 = 0;
                  HEAP8[($4 + 845 | 0) >> 0] = $70;
                  HEAP8[($4 + 846 | 0) >> 0] = $70 >>> 8 | 0;
                  i64toi32_i32$1 = 0;
                  $69 = 0;
                  HEAP8[($4 + 841 | 0) >> 0] = $69;
                  HEAP8[($4 + 842 | 0) >> 0] = $69 >>> 8 | 0;
                  HEAP8[($4 + 843 | 0) >> 0] = $69 >>> 16 | 0;
                  HEAP8[($4 + 844 | 0) >> 0] = $69 >>> 24 | 0;
                  i64toi32_i32$1 = $17$hi;
                  i64toi32_i32$3 = $4;
                  HEAP32[($4 + 848 | 0) >> 2] = $17;
                  HEAP32[($4 + 852 | 0) >> 2] = i64toi32_i32$1;
                  $7 = 1;
                  HEAP8[($4 + 840 | 0) >> 0] = 1;
                  i64toi32_i32$0 = $4;
                  i64toi32_i32$1 = HEAP32[($4 + 1904 | 0) >> 2] | 0;
                  i64toi32_i32$3 = HEAP32[($4 + 1908 | 0) >> 2] | 0;
                  $195 = i64toi32_i32$1;
                  i64toi32_i32$1 = $4;
                  HEAP32[($4 + 892 | 0) >> 2] = $195;
                  HEAP32[($4 + 896 | 0) >> 2] = i64toi32_i32$3;
                  $8 = 0;
                  break label$12;
                 }
                 cbor_event__de__Deserializer_R___special__h10e912d855f56298($4 + 1208 | 0 | 0, $1 | 0);
                 $7 = HEAPU8[($4 + 1217 | 0) >> 0] | 0;
                 $9 = HEAPU8[($4 + 1216 | 0) >> 0] | 0;
                 i64toi32_i32$0 = $4;
                 i64toi32_i32$3 = HEAP32[($4 + 1208 | 0) >> 2] | 0;
                 i64toi32_i32$1 = HEAP32[($4 + 1212 | 0) >> 2] | 0;
                 i64toi32_i32$0 = i64toi32_i32$3;
                 i64toi32_i32$3 = 0;
                 i64toi32_i32$2 = 1;
                 if ((i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) | 0) {
                  break label$11
                 }
                 $8 = 1;
                 $5 = 7;
                 switch ($9 | 0) {
                 case 0:
                  break label$12;
                 case 1:
                  break label$13;
                 default:
                  break label$10;
                 };
                }
                i64toi32_i32$0 = $10$hi;
                i64toi32_i32$1 = $5;
                HEAP32[i64toi32_i32$1 >> 2] = $10;
                HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                i64toi32_i32$0 = $12$hi;
                i64toi32_i32$1 = $6;
                HEAP32[i64toi32_i32$1 >> 2] = $12;
                HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                i64toi32_i32$0 = $13$hi;
                i64toi32_i32$1 = $7;
                HEAP32[i64toi32_i32$1 >> 2] = $13;
                HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                i64toi32_i32$0 = $14$hi;
                i64toi32_i32$1 = $8;
                HEAP32[i64toi32_i32$1 >> 2] = $14;
                HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                i64toi32_i32$0 = $15$hi;
                i64toi32_i32$1 = $9;
                HEAP32[i64toi32_i32$1 >> 2] = $15;
                HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                i64toi32_i32$0 = $16$hi;
                i64toi32_i32$1 = ($4 + 560 | 0) + 8 | 0;
                HEAP32[i64toi32_i32$1 >> 2] = $16;
                HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                i64toi32_i32$0 = $11$hi;
                i64toi32_i32$1 = $4;
                HEAP32[($4 + 608 | 0) >> 2] = $11;
                HEAP32[($4 + 612 | 0) >> 2] = i64toi32_i32$0;
                i64toi32_i32$0 = $17$hi;
                i64toi32_i32$1 = $4;
                HEAP32[($4 + 560 | 0) >> 2] = $17;
                HEAP32[($4 + 564 | 0) >> 2] = i64toi32_i32$0;
                cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e(($4 + 1208 | 0) + 8 | 0 | 0, $4 + 560 | 0 | 0, 1050286 | 0, 14 | 0);
                $1 = HEAP32[($4 + 1276 | 0) >> 2] | 0;
                HEAP32[(($4 + 1904 | 0) + 8 | 0) >> 2] = $1;
                HEAP32[(($4 + 1192 | 0) + 8 | 0) >> 2] = $1;
                i64toi32_i32$2 = $4;
                i64toi32_i32$0 = HEAP32[($4 + 1268 | 0) >> 2] | 0;
                i64toi32_i32$1 = HEAP32[($4 + 1272 | 0) >> 2] | 0;
                $243 = i64toi32_i32$0;
                i64toi32_i32$0 = $4;
                HEAP32[($4 + 1192 | 0) >> 2] = $243;
                HEAP32[($4 + 1196 | 0) >> 2] = i64toi32_i32$1;
                i64toi32_i32$2 = $4;
                i64toi32_i32$1 = HEAPU8[($4 + 1217 | 0) >> 0] | 0 | ((HEAPU8[($4 + 1218 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 1219 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 1220 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                i64toi32_i32$0 = 0;
                $245 = i64toi32_i32$1;
                $245$hi = i64toi32_i32$0;
                i64toi32_i32$2 = $4 + 1221 | 0;
                i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
                i64toi32_i32$1 = 0;
                $248 = i64toi32_i32$0;
                $248$hi = i64toi32_i32$1;
                i64toi32_i32$2 = $4 + 1223 | 0;
                i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
                i64toi32_i32$0 = 0;
                i64toi32_i32$2 = i64toi32_i32$1;
                i64toi32_i32$1 = 0;
                i64toi32_i32$3 = 16;
                i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
                if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                 i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
                 $71 = 0;
                } else {
                 i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
                 $71 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
                }
                $252$hi = i64toi32_i32$1;
                i64toi32_i32$1 = $248$hi;
                i64toi32_i32$0 = $248;
                i64toi32_i32$2 = $252$hi;
                i64toi32_i32$3 = $71;
                i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
                i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
                i64toi32_i32$0 = 0;
                i64toi32_i32$3 = 32;
                i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
                if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                 i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
                 $72 = 0;
                } else {
                 i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
                 $72 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
                }
                $254$hi = i64toi32_i32$0;
                i64toi32_i32$0 = $245$hi;
                i64toi32_i32$2 = $245;
                i64toi32_i32$1 = $254$hi;
                i64toi32_i32$3 = $72;
                i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
                $12 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
                $12$hi = i64toi32_i32$1;
                i64toi32_i32$0 = ($4 + 1208 | 0) + 16 | 0;
                i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                $11 = i64toi32_i32$1;
                $11$hi = i64toi32_i32$2;
                i64toi32_i32$0 = ($4 + 1208 | 0) + 24 | 0;
                i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                $10 = i64toi32_i32$2;
                $10$hi = i64toi32_i32$1;
                i64toi32_i32$0 = ($4 + 1208 | 0) + 32 | 0;
                i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                $13 = i64toi32_i32$1;
                $13$hi = i64toi32_i32$2;
                i64toi32_i32$0 = ($4 + 1208 | 0) + 40 | 0;
                i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                $14 = i64toi32_i32$2;
                $14$hi = i64toi32_i32$1;
                i64toi32_i32$0 = ($4 + 1208 | 0) + 48 | 0;
                i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                $15 = i64toi32_i32$1;
                $15$hi = i64toi32_i32$2;
                $6 = HEAP32[(($4 + 1208 | 0) + 56 | 0) >> 2] | 0;
                $5 = HEAPU8[($4 + 1216 | 0) >> 0] | 0;
                break label$10;
               }
               memcpy($4 + 1208 | 0 | 0, memcpy(($4 + 840 | 0) + 4 | 0 | 0, memcpy(($4 + 1632 | 0) + 4 | 0 | 0, ($4 + 1208 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
               $1 = ($4 + 560 | 0) + 8 | 0;
               cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 1208 | 0 | 0, 1050275 | 0, 11 | 0);
               memcpy($0 + 8 | 0 | 0, memcpy(($4 + 288 | 0) + 4 | 0 | 0, $1 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
               i64toi32_i32$1 = $0;
               i64toi32_i32$2 = 0;
               HEAP32[i64toi32_i32$1 >> 2] = 1;
               HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
               break label$2;
              }
              $8 = 0;
              $7 = 1;
             }
             if (!$8) {
              break label$8
             }
             std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($4 | 0, $1 | 0);
             $5 = 0;
             i64toi32_i32$2 = 0;
             $10 = 2;
             $10$hi = i64toi32_i32$2;
             i64toi32_i32$2 = 0;
             $12 = 0;
             $12$hi = i64toi32_i32$2;
             if (HEAP32[($4 + 4 | 0) >> 2] | 0) {
              break label$9
             }
             i64toi32_i32$2 = 0;
             $13 = 8;
             $13$hi = i64toi32_i32$2;
             i64toi32_i32$2 = 0;
             $16 = 0;
             $16$hi = i64toi32_i32$2;
             break label$4;
            }
            i64toi32_i32$2 = 0;
            i64toi32_i32$0 = $7;
            i64toi32_i32$1 = 0;
            i64toi32_i32$3 = 255;
            i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
            i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
            i64toi32_i32$0 = 0;
            i64toi32_i32$3 = 8;
            i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
            if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
             i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
             $73 = 0;
            } else {
             i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
             $73 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
            }
            $320$hi = i64toi32_i32$0;
            i64toi32_i32$0 = 0;
            $322$hi = i64toi32_i32$0;
            i64toi32_i32$0 = $320$hi;
            i64toi32_i32$1 = $73;
            i64toi32_i32$2 = $322$hi;
            i64toi32_i32$3 = $9;
            i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
            $323 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
            $323$hi = i64toi32_i32$2;
            i64toi32_i32$0 = $4;
            i64toi32_i32$2 = HEAPU16[($4 + 1218 | 0) >> 1] | 0 | ((HEAPU16[($4 + 1220 | 0) >> 1] | 0) << 16 | 0) | 0;
            i64toi32_i32$1 = 0;
            $325 = i64toi32_i32$2;
            $325$hi = i64toi32_i32$1;
            i64toi32_i32$0 = $4 + 1222 | 0;
            i64toi32_i32$1 = HEAPU16[i64toi32_i32$0 >> 1] | 0;
            i64toi32_i32$2 = 0;
            i64toi32_i32$0 = i64toi32_i32$1;
            i64toi32_i32$1 = 0;
            i64toi32_i32$3 = 32;
            i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
            if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
             i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
             $74 = 0;
            } else {
             i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
             $74 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
            }
            $329$hi = i64toi32_i32$1;
            i64toi32_i32$1 = $325$hi;
            i64toi32_i32$2 = $325;
            i64toi32_i32$0 = $329$hi;
            i64toi32_i32$3 = $74;
            i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
            i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
            i64toi32_i32$2 = 0;
            i64toi32_i32$3 = 16;
            i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
            if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
             i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
             $75 = 0;
            } else {
             i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
             $75 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
            }
            $331$hi = i64toi32_i32$2;
            i64toi32_i32$2 = $323$hi;
            i64toi32_i32$0 = $323;
            i64toi32_i32$1 = $331$hi;
            i64toi32_i32$3 = $75;
            i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
            $11 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
            $11$hi = i64toi32_i32$1;
            i64toi32_i32$2 = $4 + 1248 | 0;
            i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
            i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
            $15 = i64toi32_i32$1;
            $15$hi = i64toi32_i32$0;
            i64toi32_i32$2 = $4 + 1240 | 0;
            i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
            i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
            $14 = i64toi32_i32$0;
            $14$hi = i64toi32_i32$1;
            i64toi32_i32$2 = $4 + 1232 | 0;
            i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
            i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
            $13 = i64toi32_i32$1;
            $13$hi = i64toi32_i32$0;
            i64toi32_i32$2 = $4 + 1224 | 0;
            i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
            i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
            $10 = i64toi32_i32$0;
            $10$hi = i64toi32_i32$1;
           }
           i64toi32_i32$1 = $15$hi;
           i64toi32_i32$0 = $4 + 1248 | 0;
           HEAP32[i64toi32_i32$0 >> 2] = $15;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
           i64toi32_i32$1 = $14$hi;
           i64toi32_i32$0 = $4 + 1240 | 0;
           HEAP32[i64toi32_i32$0 >> 2] = $14;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
           i64toi32_i32$1 = $13$hi;
           i64toi32_i32$0 = $4 + 1232 | 0;
           HEAP32[i64toi32_i32$0 >> 2] = $13;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
           i64toi32_i32$1 = $10$hi;
           i64toi32_i32$0 = $4 + 1224 | 0;
           HEAP32[i64toi32_i32$0 >> 2] = $10;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
           i64toi32_i32$1 = $11$hi;
           i64toi32_i32$0 = ($4 + 1208 | 0) + 8 | 0;
           HEAP32[i64toi32_i32$0 >> 2] = $11;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
           i64toi32_i32$2 = $4;
           i64toi32_i32$1 = HEAP32[($4 + 1192 | 0) >> 2] | 0;
           i64toi32_i32$0 = HEAP32[($4 + 1196 | 0) >> 2] | 0;
           $364 = i64toi32_i32$1;
           i64toi32_i32$1 = $4 + 1260 | 0;
           HEAP32[i64toi32_i32$1 >> 2] = $364;
           HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
           HEAP32[($4 + 1268 | 0) >> 2] = HEAP32[(($4 + 1192 | 0) + 8 | 0) >> 2] | 0;
           HEAP32[($4 + 1256 | 0) >> 2] = $6;
           HEAP8[($4 + 1208 | 0) >> 0] = $5;
           i64toi32_i32$0 = $12$hi;
           HEAP8[($4 + 1209 | 0) >> 0] = $12;
           HEAP8[($4 + 1210 | 0) >> 0] = $12 >>> 8 | 0;
           HEAP8[($4 + 1211 | 0) >> 0] = $12 >>> 16 | 0;
           HEAP8[($4 + 1212 | 0) >> 0] = $12 >>> 24 | 0;
           $377 = $4;
           i64toi32_i32$2 = $12;
           i64toi32_i32$1 = 0;
           i64toi32_i32$3 = 48;
           i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
           if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
            i64toi32_i32$1 = 0;
            $76 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
           } else {
            i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
            $76 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
           }
           HEAP8[($377 + 1215 | 0) >> 0] = $76;
           $380 = $4;
           i64toi32_i32$1 = $12$hi;
           i64toi32_i32$0 = $12;
           i64toi32_i32$2 = 0;
           i64toi32_i32$3 = 32;
           i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
           if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
            i64toi32_i32$2 = 0;
            $77 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
           } else {
            i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
            $77 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
           }
           $78 = $380;
           $79 = $77;
           HEAP8[($78 + 1213 | 0) >> 0] = $79;
           HEAP8[($78 + 1214 | 0) >> 0] = $79 >>> 8 | 0;
           $1 = ($4 + 1632 | 0) + 8 | 0;
           cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 1208 | 0 | 0, 1050300 | 0, 8 | 0);
           memcpy($0 + 8 | 0 | 0, memcpy($4 + 294 | 0 | 0, $1 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
           i64toi32_i32$0 = $0;
           i64toi32_i32$2 = 0;
           HEAP32[i64toi32_i32$0 >> 2] = 1;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
           break label$3;
          }
          label$18 : {
           label$19 : {
            if ((($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[$4 >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) != (7 | 0)) {
             break label$19
            }
            cbor_event__de__Deserializer_R___special__h10e912d855f56298($4 + 560 | 0 | 0, $1 | 0);
            $6 = HEAPU8[($4 + 568 | 0) >> 0] | 0;
            i64toi32_i32$1 = $4;
            i64toi32_i32$2 = HEAP32[($4 + 560 | 0) >> 2] | 0;
            i64toi32_i32$0 = HEAP32[($4 + 564 | 0) >> 2] | 0;
            i64toi32_i32$1 = i64toi32_i32$2;
            i64toi32_i32$2 = 0;
            i64toi32_i32$3 = 1;
            if ((i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) | 0) {
             break label$5
            }
            i64toi32_i32$1 = 0;
            $10 = 6;
            $10$hi = i64toi32_i32$1;
            i64toi32_i32$1 = 0;
            $12 = 0;
            $12$hi = i64toi32_i32$1;
            if (($6 & 255 | 0 | 0) == (1 | 0)) {
             break label$18
            }
            break label$4;
           }
           $cardano_serialization_lib__metadata__AuxiliaryData_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hca865c989495a465($4 + 560 | 0 | 0, $1 | 0);
           i64toi32_i32$1 = 0;
           $12 = 1;
           $12$hi = i64toi32_i32$1;
           i64toi32_i32$3 = $4 + 608 | 0;
           i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
           $11 = i64toi32_i32$1;
           $11$hi = i64toi32_i32$0;
           i64toi32_i32$3 = $4 + 600 | 0;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
           $14 = i64toi32_i32$0;
           $14$hi = i64toi32_i32$1;
           i64toi32_i32$3 = $4 + 592 | 0;
           i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
           $15 = i64toi32_i32$1;
           $15$hi = i64toi32_i32$0;
           i64toi32_i32$3 = $4 + 584 | 0;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
           $16 = i64toi32_i32$0;
           $16$hi = i64toi32_i32$1;
           i64toi32_i32$3 = $4 + 576 | 0;
           i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
           $13 = i64toi32_i32$1;
           $13$hi = i64toi32_i32$0;
           i64toi32_i32$3 = $4;
           i64toi32_i32$0 = HEAP32[($4 + 568 | 0) >> 2] | 0;
           i64toi32_i32$1 = HEAP32[($4 + 572 | 0) >> 2] | 0;
           $18 = i64toi32_i32$0;
           $18$hi = i64toi32_i32$1;
           i64toi32_i32$3 = $4;
           i64toi32_i32$1 = HEAP32[($4 + 560 | 0) >> 2] | 0;
           i64toi32_i32$0 = HEAP32[($4 + 564 | 0) >> 2] | 0;
           i64toi32_i32$3 = i64toi32_i32$1;
           i64toi32_i32$1 = 0;
           i64toi32_i32$2 = 1;
           if ((i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
            break label$7
           }
           i64toi32_i32$3 = $11$hi;
           i64toi32_i32$2 = $11;
           i64toi32_i32$0 = 0;
           i64toi32_i32$1 = 32;
           i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
           if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
            i64toi32_i32$0 = 0;
            $80 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
           } else {
            i64toi32_i32$0 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
            $80 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
           }
           $8 = $80;
           i64toi32_i32$3 = $4 + 624 | 0;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
           $19 = i64toi32_i32$0;
           $19$hi = i64toi32_i32$2;
           i64toi32_i32$3 = $4 + 616 | 0;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
           $20 = i64toi32_i32$2;
           $20$hi = i64toi32_i32$0;
           i64toi32_i32$0 = $11$hi;
           $9 = $11;
          }
          i64toi32_i32$0 = $19$hi;
          i64toi32_i32$2 = ($4 + 1208 | 0) + 72 | 0;
          HEAP32[i64toi32_i32$2 >> 2] = $19;
          HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
          i64toi32_i32$0 = $20$hi;
          i64toi32_i32$2 = $4 + 1272 | 0;
          HEAP32[i64toi32_i32$2 >> 2] = $20;
          HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
          HEAP32[($4 + 1264 | 0) >> 2] = $9;
          i64toi32_i32$0 = $14$hi;
          i64toi32_i32$2 = $4 + 1256 | 0;
          HEAP32[i64toi32_i32$2 >> 2] = $14;
          HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
          i64toi32_i32$0 = $15$hi;
          i64toi32_i32$2 = $4 + 1248 | 0;
          HEAP32[i64toi32_i32$2 >> 2] = $15;
          HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
          i64toi32_i32$0 = $16$hi;
          i64toi32_i32$2 = $4 + 1240 | 0;
          HEAP32[i64toi32_i32$2 >> 2] = $16;
          HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
          i64toi32_i32$0 = $13$hi;
          i64toi32_i32$2 = $4 + 1232 | 0;
          HEAP32[i64toi32_i32$2 >> 2] = $13;
          HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
          i64toi32_i32$0 = $18$hi;
          i64toi32_i32$2 = $4 + 1224 | 0;
          HEAP32[i64toi32_i32$2 >> 2] = $18;
          HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
          HEAP32[($4 + 1268 | 0) >> 2] = $8;
          i64toi32_i32$0 = $12$hi;
          i64toi32_i32$2 = $4;
          HEAP32[($4 + 1216 | 0) >> 2] = $12;
          HEAP32[($4 + 1220 | 0) >> 2] = i64toi32_i32$0;
          memcpy($4 + 1632 | 0 | 0, $4 + 1216 | 0 | 0, 72 | 0) | 0;
          core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__metadata__AuxiliaryData____ha98f6c5d89b7a772($4 + 840 | 0 | 0);
          memcpy($4 + 840 | 0 | 0, $4 + 1632 | 0 | 0, 72 | 0) | 0;
         }
         memcpy($4 + 1208 | 0 | 0, $4 + 16 | 0 | 0, 272 | 0) | 0;
         memcpy($4 + 1552 | 0 | 0, $4 + 1112 | 0 | 0, 76 | 0) | 0;
         memcpy(($4 + 1208 | 0) + 272 | 0 | 0, $4 + 840 | 0 | 0, 72 | 0) | 0;
         memcpy($0 + 8 | 0 | 0, $4 + 1208 | 0 | 0, 420 | 0) | 0;
         i64toi32_i32$2 = $0;
         i64toi32_i32$0 = 0;
         HEAP32[i64toi32_i32$2 >> 2] = 0;
         HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
         HEAP8[(i64toi32_i32$2 + 428 | 0) >> 0] = $7;
         break label$1;
        }
        i64toi32_i32$0 = $18$hi;
        i64toi32_i32$3 = $18;
        i64toi32_i32$2 = 0;
        i64toi32_i32$1 = 255;
        i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
        $10 = i64toi32_i32$3 & i64toi32_i32$1 | 0;
        $10$hi = i64toi32_i32$2;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = i64toi32_i32$3;
        i64toi32_i32$3 = -1;
        i64toi32_i32$1 = -256;
        i64toi32_i32$3 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
        $12 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
        $12$hi = i64toi32_i32$3;
        $1 = HEAP32[($4 + 620 | 0) >> 2] | 0;
        $5 = HEAP32[($4 + 616 | 0) >> 2] | 0;
        i64toi32_i32$2 = $4 + 624 | 0;
        i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $17 = i64toi32_i32$3;
        $17$hi = i64toi32_i32$0;
        break label$4;
       }
       memcpy($4 + 1632 | 0 | 0, $5 | 0, 64 | 0) | 0;
       memcpy($4 + 840 | 0 | 0, $4 + 1632 | 0 | 0, 64 | 0) | 0;
       memcpy($4 + 1208 | 0 | 0, $4 + 840 | 0 | 0, 64 | 0) | 0;
       $1 = ($4 + 560 | 0) + 8 | 0;
       cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 1208 | 0 | 0, 1050271 | 0, 4 | 0);
       memcpy($4 + 288 | 0 | 0, $1 | 0, 64 | 0) | 0;
       memcpy($0 + 8 | 0 | 0, $4 + 288 | 0 | 0, 64 | 0) | 0;
       i64toi32_i32$3 = $0;
       i64toi32_i32$0 = 0;
       HEAP32[i64toi32_i32$3 >> 2] = 1;
       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
       break label$1;
      }
      i64toi32_i32$2 = $4;
      i64toi32_i32$0 = HEAPU8[($4 + 569 | 0) >> 0] | 0;
      i64toi32_i32$3 = 0;
      i64toi32_i32$2 = i64toi32_i32$0;
      i64toi32_i32$0 = 0;
      i64toi32_i32$1 = 8;
      i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
       i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       $81 = 0;
      } else {
       i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$4 | 0) | 0;
       $81 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
      }
      $559$hi = i64toi32_i32$0;
      i64toi32_i32$0 = 0;
      i64toi32_i32$3 = $6;
      i64toi32_i32$2 = 0;
      i64toi32_i32$1 = 255;
      i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
      $562 = i64toi32_i32$3 & i64toi32_i32$1 | 0;
      $562$hi = i64toi32_i32$2;
      i64toi32_i32$2 = $559$hi;
      i64toi32_i32$0 = $81;
      i64toi32_i32$3 = $562$hi;
      i64toi32_i32$1 = $562;
      i64toi32_i32$3 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
      $563 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
      $563$hi = i64toi32_i32$3;
      i64toi32_i32$2 = $4;
      i64toi32_i32$3 = HEAPU16[($4 + 570 | 0) >> 1] | 0 | ((HEAPU16[($4 + 572 | 0) >> 1] | 0) << 16 | 0) | 0;
      i64toi32_i32$0 = 0;
      $565 = i64toi32_i32$3;
      $565$hi = i64toi32_i32$0;
      i64toi32_i32$2 = $4 + 574 | 0;
      i64toi32_i32$0 = HEAPU16[i64toi32_i32$2 >> 1] | 0;
      i64toi32_i32$3 = 0;
      i64toi32_i32$2 = i64toi32_i32$0;
      i64toi32_i32$0 = 0;
      i64toi32_i32$1 = 32;
      i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
       i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       $82 = 0;
      } else {
       i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$4 | 0) | 0;
       $82 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
      }
      $569$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $565$hi;
      i64toi32_i32$3 = $565;
      i64toi32_i32$2 = $569$hi;
      i64toi32_i32$1 = $82;
      i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
      i64toi32_i32$0 = i64toi32_i32$3 | i64toi32_i32$1 | 0;
      i64toi32_i32$3 = 0;
      i64toi32_i32$1 = 16;
      i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
       i64toi32_i32$3 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       $83 = 0;
      } else {
       i64toi32_i32$3 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
       $83 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
      }
      $571$hi = i64toi32_i32$3;
      i64toi32_i32$3 = $563$hi;
      i64toi32_i32$2 = $563;
      i64toi32_i32$0 = $571$hi;
      i64toi32_i32$1 = $83;
      i64toi32_i32$0 = i64toi32_i32$3 | i64toi32_i32$0 | 0;
      $13 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
      $13$hi = i64toi32_i32$0;
      i64toi32_i32$3 = $4 + 600 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $11 = i64toi32_i32$0;
      $11$hi = i64toi32_i32$2;
      i64toi32_i32$3 = $4 + 592 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $14 = i64toi32_i32$2;
      $14$hi = i64toi32_i32$0;
      i64toi32_i32$3 = $4 + 584 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $15 = i64toi32_i32$0;
      $15$hi = i64toi32_i32$2;
      i64toi32_i32$3 = $4 + 576 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $16 = i64toi32_i32$2;
      $16$hi = i64toi32_i32$0;
     }
     i64toi32_i32$0 = $17$hi;
     i64toi32_i32$2 = $4 + 616 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $17;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($4 + 612 | 0) >> 2] = $1;
     i64toi32_i32$0 = $11$hi;
     i64toi32_i32$2 = $4 + 600 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $11;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$0 = $14$hi;
     i64toi32_i32$2 = $4 + 592 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $14;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$0 = $15$hi;
     i64toi32_i32$2 = $4 + 584 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $15;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$0 = $16$hi;
     i64toi32_i32$2 = $4 + 576 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $16;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$0 = $13$hi;
     i64toi32_i32$2 = ($4 + 560 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $13;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($4 + 608 | 0) >> 2] = $5;
     i64toi32_i32$0 = $10$hi;
     i64toi32_i32$0 = $12$hi;
     i64toi32_i32$0 = $10$hi;
     i64toi32_i32$3 = $10;
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$1 = $12;
     i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
     $612 = i64toi32_i32$3 | i64toi32_i32$1 | 0;
     i64toi32_i32$3 = $4;
     HEAP32[($4 + 560 | 0) >> 2] = $612;
     HEAP32[($4 + 564 | 0) >> 2] = i64toi32_i32$2;
     $1 = ($4 + 1208 | 0) + 8 | 0;
     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 560 | 0 | 0, 1050286 | 0, 14 | 0);
     memcpy($4 + 1632 | 0 | 0, $1 | 0, 64 | 0) | 0;
     memcpy($0 + 8 | 0 | 0, $4 + 1632 | 0 | 0, 64 | 0) | 0;
     i64toi32_i32$3 = $0;
     i64toi32_i32$2 = 0;
     HEAP32[i64toi32_i32$3 >> 2] = 1;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
    }
    core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__metadata__AuxiliaryData____ha98f6c5d89b7a772($4 + 840 | 0 | 0);
    core__ptr__drop_in_place_cardano_serialization_lib__TransactionWitnessSet___h7d278d9502f6471a_1($4 + 1112 | 0 | 0);
   }
   core__ptr__drop_in_place_cardano_serialization_lib__TransactionBody___h9274013021a1d568_1($4 + 16 | 0 | 0);
  }
  global$0 = $4 + 1920 | 0;
 }
 
 function $cardano_serialization_lib__metadata__MetadataMap_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h8f4b3182d8f5ec31($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $3 = 0, $20 = 0, $13 = 0, $17 = 0, $20$hi = 0, $21 = 0, $10 = 0, $14 = 0, $21$hi = 0, $16 = 0, $22 = 0, $11 = 0, $15 = 0, $18 = 0, $22$hi = 0, $19 = 0, $72 = 0, $4 = 0, $73 = 0, $74 = 0, $75 = 0, $76 = 0, $77 = 0, $78 = 0, $79 = 0, $80 = 0, $81 = 0, $82 = 0, $83 = 0, $84 = 0, $85 = 0, $86 = 0, $87 = 0, $88 = 0, $89 = 0, $90 = 0, $91 = 0, $92 = 0, $8 = 0, $9 = 0, $5 = 0, $6 = 0, $7 = 0, $12 = 0, $110 = 0, $118 = 0, $127 = 0, $142 = 0, $150 = 0, $154 = 0, $166 = 0, $169 = 0, $178 = 0, $193 = 0, $199 = 0, $208 = 0, $249 = 0, $256 = 0, $259 = 0, $268 = 0, $286 = 0, $289 = 0, $307 = 0, $313 = 0, $322 = 0, $360 = 0, $364 = 0, $368 = 0, $392 = 0, $399 = 0, $402 = 0, $411 = 0, $426 = 0, $432 = 0, $437 = 0, $442 = 0, $448 = 0, $452 = 0, $464 = 0, $468 = 0, $474 = 0, $480 = 0, $542 = 0, $546 = 0, $573 = 0, $577 = 0;
  $2 = global$0 - 496 | 0;
  global$0 = $2;
  std__thread__local__LocalKey_T___with__h4cd07b14a44a727e($2 + 16 | 0 | 0, 1060968 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $20 = i64toi32_i32$0;
  $20$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  $21$hi = i64toi32_i32$0;
  $3 = hashbrown__raw__generic__Group__static_empty__hc5a7932fe1bdb1f1() | 0;
  i64toi32_i32$1 = ($2 + 32 | 0) + 24 | 0;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 52 | 0) >> 2] = $3;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 64 | 0) >> 2] = 0;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $21$hi;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 40 | 0) >> 2] = $21;
  HEAP32[($2 + 44 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $20$hi;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $20;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$0;
  $4 = 0;
  HEAP32[($2 + 48 | 0) >> 2] = 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 76 | 0) >> 2] = 0;
  HEAP32[($2 + 80 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 72 | 0) >> 2] = HEAP32[(0 + 1059252 | 0) >> 2] | 0;
  cbor_event__de__Deserializer_R___map__h7c2a4e830d885a05($2 + 344 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = ($2 + 344 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $20 = i64toi32_i32$0;
  $20$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 352 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 356 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  $21$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 344 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 348 | 0) >> 2] | 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
         break label$6
        }
        i64toi32_i32$2 = $20$hi;
        $5 = $20;
        label$7 : {
         i64toi32_i32$2 = $21$hi;
         i64toi32_i32$3 = $21;
         i64toi32_i32$1 = 0;
         i64toi32_i32$0 = 1;
         if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
          break label$7
         }
         if (!$5) {
          break label$3
         }
        }
        $6 = ($2 + 344 | 0) + 8 | 0;
        $7 = ($2 + 264 | 0) + 8 | 0;
        $8 = $2 + 344 | 0 | 4 | 0;
        $9 = $2 + 264 | 0 | 4 | 0;
        $10 = $2 + 376 | 0;
        $11 = $2 + 288 | 0;
        $12 = $2 + 264 | 0 | 1 | 0;
        $13 = $2 + 353 | 0;
        $14 = $13 + 3 | 0;
        $4 = 0;
        $15 = 2;
        label$8 : {
         label$9 : while (1) {
          std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 8 | 0 | 0, $1 | 0);
          label$10 : {
           if (HEAP32[($2 + 12 | 0) >> 2] | 0) {
            break label$10
           }
           i64toi32_i32$3 = 0;
           $21 = 8;
           $21$hi = i64toi32_i32$3;
           i64toi32_i32$3 = 0;
           $20 = 0;
           $20$hi = i64toi32_i32$3;
           break label$4;
          }
          label$11 : {
           label$12 : {
            label$13 : {
             label$14 : {
              label$15 : {
               label$16 : {
                label$17 : {
                 label$18 : {
                  label$19 : {
                   if ((($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[($2 + 8 | 0) >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) == (7 | 0)) {
                    break label$19
                   }
                   $cardano_serialization_lib__metadata__TransactionMetadatum_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hc82759b9ba0db2d8($2 + 344 | 0 | 0, $1 | 0);
                   $3 = ($2 + 448 | 0) + 8 | 0;
                   $16 = $10 + 8 | 0;
                   i64toi32_i32$0 = $16;
                   i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                   i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                   $110 = i64toi32_i32$3;
                   i64toi32_i32$3 = $3;
                   HEAP32[i64toi32_i32$3 >> 2] = $110;
                   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                   $17 = ($2 + 448 | 0) + 16 | 0;
                   $18 = $10 + 16 | 0;
                   i64toi32_i32$0 = $18;
                   i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                   i64toi32_i32$3 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                   $118 = i64toi32_i32$2;
                   i64toi32_i32$2 = $17;
                   HEAP32[i64toi32_i32$2 >> 2] = $118;
                   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                   HEAP32[($2 + 416 | 0) >> 2] = HEAPU8[$13 >> 0] | 0 | ((HEAPU8[($13 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($13 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($13 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                   $73 = HEAPU8[$14 >> 0] | 0 | ((HEAPU8[($14 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($14 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($14 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                   HEAP8[($2 + 419 | 0) >> 0] = $73;
                   HEAP8[($2 + 420 | 0) >> 0] = $73 >>> 8 | 0;
                   HEAP8[($2 + 421 | 0) >> 0] = $73 >>> 16 | 0;
                   HEAP8[($2 + 422 | 0) >> 0] = $73 >>> 24 | 0;
                   i64toi32_i32$0 = $10;
                   i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                   i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                   $127 = i64toi32_i32$3;
                   i64toi32_i32$3 = $2;
                   HEAP32[($2 + 448 | 0) >> 2] = $127;
                   HEAP32[($2 + 452 | 0) >> 2] = i64toi32_i32$2;
                   i64toi32_i32$0 = $2;
                   i64toi32_i32$2 = HEAP32[($2 + 368 | 0) >> 2] | 0;
                   i64toi32_i32$3 = HEAP32[($2 + 372 | 0) >> 2] | 0;
                   $20 = i64toi32_i32$2;
                   $20$hi = i64toi32_i32$3;
                   i64toi32_i32$0 = $2;
                   i64toi32_i32$3 = HEAP32[($2 + 360 | 0) >> 2] | 0;
                   i64toi32_i32$2 = HEAP32[($2 + 364 | 0) >> 2] | 0;
                   $22 = i64toi32_i32$3;
                   $22$hi = i64toi32_i32$2;
                   $19 = HEAPU8[($2 + 352 | 0) >> 0] | 0;
                   i64toi32_i32$0 = $2;
                   i64toi32_i32$2 = HEAP32[($2 + 344 | 0) >> 2] | 0;
                   i64toi32_i32$3 = HEAP32[($2 + 348 | 0) >> 2] | 0;
                   i64toi32_i32$0 = i64toi32_i32$2;
                   i64toi32_i32$2 = 0;
                   i64toi32_i32$1 = 1;
                   if ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) | 0) {
                    break label$18
                   }
                   $72 = $12;
                   $74 = HEAP32[($2 + 416 | 0) >> 2] | 0;
                   HEAP8[$72 >> 0] = $74;
                   HEAP8[($72 + 1 | 0) >> 0] = $74 >>> 8 | 0;
                   HEAP8[($72 + 2 | 0) >> 0] = $74 >>> 16 | 0;
                   HEAP8[($72 + 3 | 0) >> 0] = $74 >>> 24 | 0;
                   i64toi32_i32$1 = $2;
                   i64toi32_i32$0 = HEAP32[($2 + 448 | 0) >> 2] | 0;
                   i64toi32_i32$3 = HEAP32[($2 + 452 | 0) >> 2] | 0;
                   $142 = i64toi32_i32$0;
                   i64toi32_i32$0 = $11;
                   $75 = $142;
                   HEAP8[i64toi32_i32$0 >> 0] = $75;
                   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $75 >>> 8 | 0;
                   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $75 >>> 16 | 0;
                   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $75 >>> 24 | 0;
                   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$3;
                   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
                   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
                   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
                   $76 = $72 + 3 | 0;
                   $77 = HEAPU8[($2 + 419 | 0) >> 0] | 0 | ((HEAPU8[($2 + 420 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 421 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 422 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                   HEAP8[$76 >> 0] = $77;
                   HEAP8[($76 + 1 | 0) >> 0] = $77 >>> 8 | 0;
                   HEAP8[($76 + 2 | 0) >> 0] = $77 >>> 16 | 0;
                   HEAP8[($76 + 3 | 0) >> 0] = $77 >>> 24 | 0;
                   i64toi32_i32$1 = $3;
                   i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                   i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                   $150 = i64toi32_i32$3;
                   i64toi32_i32$3 = $11 + 8 | 0;
                   $78 = $150;
                   HEAP8[i64toi32_i32$3 >> 0] = $78;
                   HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $78 >>> 8 | 0;
                   HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $78 >>> 16 | 0;
                   HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $78 >>> 24 | 0;
                   HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$0;
                   HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                   HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
                   HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
                   i64toi32_i32$1 = $17;
                   i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                   i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                   $154 = i64toi32_i32$0;
                   i64toi32_i32$0 = $11 + 16 | 0;
                   $79 = $154;
                   HEAP8[i64toi32_i32$0 >> 0] = $79;
                   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $79 >>> 8 | 0;
                   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $79 >>> 16 | 0;
                   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $79 >>> 24 | 0;
                   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$3;
                   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
                   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
                   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
                   HEAP8[($2 + 264 | 0) >> 0] = $19;
                   i64toi32_i32$3 = $20$hi;
                   i64toi32_i32$0 = $2;
                   HEAP32[($2 + 280 | 0) >> 2] = $20;
                   HEAP32[($2 + 284 | 0) >> 2] = i64toi32_i32$3;
                   i64toi32_i32$3 = $22$hi;
                   i64toi32_i32$0 = $2;
                   HEAP32[($2 + 272 | 0) >> 2] = $22;
                   HEAP32[($2 + 276 | 0) >> 2] = i64toi32_i32$3;
                   $cardano_serialization_lib__metadata__TransactionMetadatum_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hc82759b9ba0db2d8($2 + 344 | 0 | 0, $1 | 0);
                   i64toi32_i32$1 = $16;
                   i64toi32_i32$3 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                   $166 = i64toi32_i32$3;
                   i64toi32_i32$3 = $3;
                   HEAP32[i64toi32_i32$3 >> 2] = $166;
                   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
                   i64toi32_i32$1 = $18;
                   i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                   i64toi32_i32$3 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                   $169 = i64toi32_i32$0;
                   i64toi32_i32$0 = $17;
                   HEAP32[i64toi32_i32$0 >> 2] = $169;
                   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
                   HEAP32[($2 + 416 | 0) >> 2] = HEAPU8[$13 >> 0] | 0 | ((HEAPU8[($13 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($13 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($13 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                   $80 = HEAPU8[$14 >> 0] | 0 | ((HEAPU8[($14 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($14 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($14 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                   HEAP8[($2 + 419 | 0) >> 0] = $80;
                   HEAP8[($2 + 420 | 0) >> 0] = $80 >>> 8 | 0;
                   HEAP8[($2 + 421 | 0) >> 0] = $80 >>> 16 | 0;
                   HEAP8[($2 + 422 | 0) >> 0] = $80 >>> 24 | 0;
                   i64toi32_i32$1 = $10;
                   i64toi32_i32$3 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                   $178 = i64toi32_i32$3;
                   i64toi32_i32$3 = $2;
                   HEAP32[($2 + 448 | 0) >> 2] = $178;
                   HEAP32[($2 + 452 | 0) >> 2] = i64toi32_i32$0;
                   i64toi32_i32$1 = $2;
                   i64toi32_i32$0 = HEAP32[($2 + 368 | 0) >> 2] | 0;
                   i64toi32_i32$3 = HEAP32[($2 + 372 | 0) >> 2] | 0;
                   $20 = i64toi32_i32$0;
                   $20$hi = i64toi32_i32$3;
                   i64toi32_i32$1 = $2;
                   i64toi32_i32$3 = HEAP32[($2 + 360 | 0) >> 2] | 0;
                   i64toi32_i32$0 = HEAP32[($2 + 364 | 0) >> 2] | 0;
                   $22 = i64toi32_i32$3;
                   $22$hi = i64toi32_i32$0;
                   $19 = HEAPU8[($2 + 352 | 0) >> 0] | 0;
                   i64toi32_i32$1 = $2;
                   i64toi32_i32$0 = HEAP32[($2 + 344 | 0) >> 2] | 0;
                   i64toi32_i32$3 = HEAP32[($2 + 348 | 0) >> 2] | 0;
                   i64toi32_i32$1 = i64toi32_i32$0;
                   i64toi32_i32$0 = 0;
                   i64toi32_i32$2 = 1;
                   if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) | 0) {
                    break label$11
                   }
                   $16 = ($2 + 312 | 0) + 8 | 0;
                   i64toi32_i32$2 = $3;
                   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                   i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                   $193 = i64toi32_i32$1;
                   i64toi32_i32$1 = $16;
                   HEAP32[i64toi32_i32$1 >> 2] = $193;
                   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
                   $3 = ($2 + 312 | 0) + 16 | 0;
                   i64toi32_i32$2 = $17;
                   i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                   $199 = i64toi32_i32$3;
                   i64toi32_i32$3 = $3;
                   HEAP32[i64toi32_i32$3 >> 2] = $199;
                   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
                   HEAP32[($2 + 336 | 0) >> 2] = HEAP32[($2 + 416 | 0) >> 2] | 0;
                   $81 = HEAPU8[($2 + 419 | 0) >> 0] | 0 | ((HEAPU8[($2 + 420 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 421 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 422 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                   HEAP8[($2 + 339 | 0) >> 0] = $81;
                   HEAP8[($2 + 340 | 0) >> 0] = $81 >>> 8 | 0;
                   HEAP8[($2 + 341 | 0) >> 0] = $81 >>> 16 | 0;
                   HEAP8[($2 + 342 | 0) >> 0] = $81 >>> 24 | 0;
                   i64toi32_i32$2 = $2;
                   i64toi32_i32$1 = HEAP32[($2 + 448 | 0) >> 2] | 0;
                   i64toi32_i32$3 = HEAP32[($2 + 452 | 0) >> 2] | 0;
                   $208 = i64toi32_i32$1;
                   i64toi32_i32$1 = $2;
                   HEAP32[($2 + 312 | 0) >> 2] = $208;
                   HEAP32[($2 + 316 | 0) >> 2] = i64toi32_i32$3;
                   switch (HEAP32[($2 + 264 | 0) >> 2] | 0 | 0) {
                   case 4:
                    break label$13;
                   case 3:
                    break label$14;
                   case 2:
                    break label$15;
                   case 1:
                    break label$16;
                   default:
                    break label$17;
                   };
                  }
                  cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 344 | 0 | 0, $1 | 0);
                  i64toi32_i32$2 = ($2 + 344 | 0) + 16 | 0;
                  i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                  $20 = i64toi32_i32$3;
                  $20$hi = i64toi32_i32$1;
                  i64toi32_i32$2 = $2;
                  i64toi32_i32$1 = HEAP32[($2 + 352 | 0) >> 2] | 0;
                  i64toi32_i32$3 = HEAP32[($2 + 356 | 0) >> 2] | 0;
                  $21 = i64toi32_i32$1;
                  $21$hi = i64toi32_i32$3;
                  i64toi32_i32$2 = $2;
                  i64toi32_i32$3 = HEAP32[($2 + 344 | 0) >> 2] | 0;
                  i64toi32_i32$1 = HEAP32[($2 + 348 | 0) >> 2] | 0;
                  i64toi32_i32$2 = i64toi32_i32$3;
                  i64toi32_i32$3 = 0;
                  i64toi32_i32$0 = 1;
                  if ((i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) | 0) {
                   break label$5
                  }
                  i64toi32_i32$2 = $20$hi;
                  i64toi32_i32$1 = $2 + 272 | 0;
                  HEAP32[i64toi32_i32$1 >> 2] = $20;
                  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
                  i64toi32_i32$2 = $21$hi;
                  i64toi32_i32$1 = $2;
                  HEAP32[($2 + 264 | 0) >> 2] = $21;
                  HEAP32[($2 + 268 | 0) >> 2] = i64toi32_i32$2;
                  if (($21 & 255 | 0 | 0) == (5 | 0)) {
                   break label$3
                  }
                  HEAP32[($2 + 344 | 0) >> 2] = 0;
                  core__panicking__assert_failed__h96d8431cc974b591(0 | 0, $2 + 264 | 0 | 0, 1059816 | 0, $2 + 344 | 0 | 0, 1059832 | 0);
                  abort();
                 }
                 HEAP32[(($2 + 216 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 412 | 0) >> 2] | 0;
                 i64toi32_i32$0 = ($2 + 448 | 0) + 8 | 0;
                 i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                 i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                 $249 = i64toi32_i32$2;
                 i64toi32_i32$2 = ($2 + 232 | 0) + 8 | 0;
                 HEAP32[i64toi32_i32$2 >> 2] = $249;
                 HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
                 i64toi32_i32$0 = ($2 + 448 | 0) + 16 | 0;
                 i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                 i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                 $256 = i64toi32_i32$1;
                 i64toi32_i32$1 = ($2 + 232 | 0) + 16 | 0;
                 HEAP32[i64toi32_i32$1 >> 2] = $256;
                 HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
                 i64toi32_i32$0 = $2;
                 i64toi32_i32$2 = HEAP32[($2 + 404 | 0) >> 2] | 0;
                 i64toi32_i32$1 = HEAP32[($2 + 408 | 0) >> 2] | 0;
                 $259 = i64toi32_i32$2;
                 i64toi32_i32$2 = $2;
                 HEAP32[($2 + 216 | 0) >> 2] = $259;
                 HEAP32[($2 + 220 | 0) >> 2] = i64toi32_i32$1;
                 HEAP32[($2 + 256 | 0) >> 2] = HEAP32[($2 + 416 | 0) >> 2] | 0;
                 $82 = HEAPU8[($2 + 419 | 0) >> 0] | 0 | ((HEAPU8[($2 + 420 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 421 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 422 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 HEAP8[($2 + 259 | 0) >> 0] = $82;
                 HEAP8[($2 + 260 | 0) >> 0] = $82 >>> 8 | 0;
                 HEAP8[($2 + 261 | 0) >> 0] = $82 >>> 16 | 0;
                 HEAP8[($2 + 262 | 0) >> 0] = $82 >>> 24 | 0;
                 i64toi32_i32$0 = $2;
                 i64toi32_i32$1 = HEAP32[($2 + 448 | 0) >> 2] | 0;
                 i64toi32_i32$2 = HEAP32[($2 + 452 | 0) >> 2] | 0;
                 $268 = i64toi32_i32$1;
                 i64toi32_i32$1 = $2;
                 HEAP32[($2 + 232 | 0) >> 2] = $268;
                 HEAP32[($2 + 236 | 0) >> 2] = i64toi32_i32$2;
                 $4 = HEAP32[($2 + 400 | 0) >> 2] | 0;
                 i64toi32_i32$2 = $22$hi;
                 $21 = $22;
                 $21$hi = i64toi32_i32$2;
                 $15 = $19;
                 break label$8;
                }
                $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__hdeea20968268d729($6 | 0, $7 | 0);
                HEAP32[($2 + 344 | 0) >> 2] = 0;
                break label$12;
               }
               $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hf69db734dd831996($8 | 0, $9 | 0);
               HEAP32[($2 + 344 | 0) >> 2] = 1;
               break label$12;
              }
              i64toi32_i32$0 = ($2 + 264 | 0) + 16 | 0;
              i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
              i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
              $286 = i64toi32_i32$2;
              i64toi32_i32$2 = ($2 + 344 | 0) + 16 | 0;
              HEAP32[i64toi32_i32$2 >> 2] = $286;
              HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
              i64toi32_i32$0 = $2;
              i64toi32_i32$1 = HEAP32[($2 + 272 | 0) >> 2] | 0;
              i64toi32_i32$2 = HEAP32[($2 + 276 | 0) >> 2] | 0;
              $289 = i64toi32_i32$1;
              i64toi32_i32$1 = $2;
              HEAP32[($2 + 352 | 0) >> 2] = $289;
              HEAP32[($2 + 356 | 0) >> 2] = i64toi32_i32$2;
              HEAP32[($2 + 344 | 0) >> 2] = 2;
              break label$12;
             }
             $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($8 | 0, $9 | 0);
             HEAP32[($2 + 344 | 0) >> 2] = 3;
             break label$12;
            }
            $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($8 | 0, $9 | 0);
            HEAP32[($2 + 344 | 0) >> 2] = 4;
           }
           memcpy($2 + 448 | 0 | 0, $2 + 344 | 0 | 0, 48 | 0) | 0;
           $18 = ($2 + 416 | 0) + 8 | 0;
           i64toi32_i32$0 = $16;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $307 = i64toi32_i32$2;
           i64toi32_i32$2 = $18;
           HEAP32[i64toi32_i32$2 >> 2] = $307;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
           $16 = ($2 + 416 | 0) + 16 | 0;
           i64toi32_i32$0 = $3;
           i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $313 = i64toi32_i32$1;
           i64toi32_i32$1 = $16;
           HEAP32[i64toi32_i32$1 >> 2] = $313;
           HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
           HEAP32[($2 + 440 | 0) >> 2] = HEAP32[($2 + 336 | 0) >> 2] | 0;
           $83 = HEAPU8[($2 + 339 | 0) >> 0] | 0 | ((HEAPU8[($2 + 340 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 341 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 342 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 443 | 0) >> 0] = $83;
           HEAP8[($2 + 444 | 0) >> 0] = $83 >>> 8 | 0;
           HEAP8[($2 + 445 | 0) >> 0] = $83 >>> 16 | 0;
           HEAP8[($2 + 446 | 0) >> 0] = $83 >>> 24 | 0;
           i64toi32_i32$0 = $2;
           i64toi32_i32$2 = HEAP32[($2 + 312 | 0) >> 2] | 0;
           i64toi32_i32$1 = HEAP32[($2 + 316 | 0) >> 2] | 0;
           $322 = i64toi32_i32$2;
           i64toi32_i32$2 = $2;
           HEAP32[($2 + 416 | 0) >> 2] = $322;
           HEAP32[($2 + 420 | 0) >> 2] = i64toi32_i32$1;
           label$20 : {
            $17 = HEAP32[($2 + 80 | 0) >> 2] | 0;
            if ((HEAP32[($2 + 76 | 0) >> 2] | 0 | 0) != ($17 | 0)) {
             break label$20
            }
            alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h4ecdd36a3fcffeb7($2 + 72 | 0 | 0, $17 | 0, 1 | 0);
            $17 = HEAP32[($2 + 80 | 0) >> 2] | 0;
           }
           $3 = memcpy((HEAP32[($2 + 72 | 0) >> 2] | 0) + Math_imul($17, 96) | 0 | 0, $2 + 448 | 0 | 0, 48 | 0) | 0;
           HEAP8[($3 + 48 | 0) >> 0] = $19;
           i64toi32_i32$1 = $20$hi;
           i64toi32_i32$2 = $3 + 64 | 0;
           HEAP8[i64toi32_i32$2 >> 0] = $20;
           HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $20 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $20 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $20 >>> 24 | 0;
           HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$1;
           HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
           i64toi32_i32$1 = $22$hi;
           i64toi32_i32$2 = $3 + 56 | 0;
           HEAP8[i64toi32_i32$2 >> 0] = $22;
           HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $22 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $22 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $22 >>> 24 | 0;
           HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$1;
           HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
           $84 = HEAP32[($2 + 440 | 0) >> 2] | 0;
           HEAP8[($3 + 49 | 0) >> 0] = $84;
           HEAP8[($3 + 50 | 0) >> 0] = $84 >>> 8 | 0;
           HEAP8[($3 + 51 | 0) >> 0] = $84 >>> 16 | 0;
           HEAP8[($3 + 52 | 0) >> 0] = $84 >>> 24 | 0;
           $85 = $3 + 52 | 0;
           $86 = HEAPU8[($2 + 443 | 0) >> 0] | 0 | ((HEAPU8[($2 + 444 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 445 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 446 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[$85 >> 0] = $86;
           HEAP8[($85 + 1 | 0) >> 0] = $86 >>> 8 | 0;
           HEAP8[($85 + 2 | 0) >> 0] = $86 >>> 16 | 0;
           HEAP8[($85 + 3 | 0) >> 0] = $86 >>> 24 | 0;
           i64toi32_i32$0 = $2;
           i64toi32_i32$1 = HEAP32[($2 + 416 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($2 + 420 | 0) >> 2] | 0;
           $360 = i64toi32_i32$1;
           i64toi32_i32$1 = $3 + 72 | 0;
           $87 = $360;
           HEAP8[i64toi32_i32$1 >> 0] = $87;
           HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $87 >>> 8 | 0;
           HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $87 >>> 16 | 0;
           HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $87 >>> 24 | 0;
           HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$2;
           HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
           HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
           HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
           i64toi32_i32$0 = $18;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $364 = i64toi32_i32$2;
           i64toi32_i32$2 = $3 + 80 | 0;
           $88 = $364;
           HEAP8[i64toi32_i32$2 >> 0] = $88;
           HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $88 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $88 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $88 >>> 24 | 0;
           HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$1;
           HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
           i64toi32_i32$0 = $16;
           i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $368 = i64toi32_i32$1;
           i64toi32_i32$1 = $3 + 88 | 0;
           $89 = $368;
           HEAP8[i64toi32_i32$1 >> 0] = $89;
           HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $89 >>> 8 | 0;
           HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $89 >>> 16 | 0;
           HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $89 >>> 24 | 0;
           HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$2;
           HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
           HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
           HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
           HEAP32[($2 + 80 | 0) >> 2] = $17 + 1 | 0;
           core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatum___headd2d1b596252cc($2 + 264 | 0 | 0);
           i64toi32_i32$2 = $21$hi;
           i64toi32_i32$0 = $21;
           i64toi32_i32$1 = 0;
           i64toi32_i32$3 = 1;
           if ((i64toi32_i32$0 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
            continue label$9
           }
           if ((HEAP32[($2 + 80 | 0) >> 2] | 0) >>> 0 < $5 >>> 0) {
            continue label$9
           }
           break label$3;
          }
          break label$9;
         };
         HEAP32[(($2 + 216 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 412 | 0) >> 2] | 0;
         i64toi32_i32$3 = ($2 + 448 | 0) + 8 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $392 = i64toi32_i32$0;
         i64toi32_i32$0 = ($2 + 232 | 0) + 8 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $392;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
         i64toi32_i32$3 = ($2 + 448 | 0) + 16 | 0;
         i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $399 = i64toi32_i32$2;
         i64toi32_i32$2 = ($2 + 232 | 0) + 16 | 0;
         HEAP32[i64toi32_i32$2 >> 2] = $399;
         HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$3 = $2;
         i64toi32_i32$0 = HEAP32[($2 + 404 | 0) >> 2] | 0;
         i64toi32_i32$2 = HEAP32[($2 + 408 | 0) >> 2] | 0;
         $402 = i64toi32_i32$0;
         i64toi32_i32$0 = $2;
         HEAP32[($2 + 216 | 0) >> 2] = $402;
         HEAP32[($2 + 220 | 0) >> 2] = i64toi32_i32$2;
         HEAP32[($2 + 256 | 0) >> 2] = HEAP32[($2 + 416 | 0) >> 2] | 0;
         $90 = HEAPU8[($2 + 419 | 0) >> 0] | 0 | ((HEAPU8[($2 + 420 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 421 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 422 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[($2 + 259 | 0) >> 0] = $90;
         HEAP8[($2 + 260 | 0) >> 0] = $90 >>> 8 | 0;
         HEAP8[($2 + 261 | 0) >> 0] = $90 >>> 16 | 0;
         HEAP8[($2 + 262 | 0) >> 0] = $90 >>> 24 | 0;
         i64toi32_i32$3 = $2;
         i64toi32_i32$2 = HEAP32[($2 + 448 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($2 + 452 | 0) >> 2] | 0;
         $411 = i64toi32_i32$2;
         i64toi32_i32$2 = $2;
         HEAP32[($2 + 232 | 0) >> 2] = $411;
         HEAP32[($2 + 236 | 0) >> 2] = i64toi32_i32$0;
         $4 = HEAP32[($2 + 400 | 0) >> 2] | 0;
         core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatum___headd2d1b596252cc($2 + 264 | 0 | 0);
         i64toi32_i32$0 = $22$hi;
         $21 = $22;
         $21$hi = i64toi32_i32$0;
         $15 = $19;
        }
        if (($15 & 255 | 0 | 0) != (19 | 0)) {
         break label$4
        }
        break label$3;
       }
       i64toi32_i32$3 = $2 + 376 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $426 = i64toi32_i32$0;
       i64toi32_i32$0 = $2 + 240 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $426;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$3 = $2 + 384 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $432 = i64toi32_i32$2;
       i64toi32_i32$2 = ($2 + 232 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $432;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$3 = ($2 + 344 | 0) + 24 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $437 = i64toi32_i32$0;
       i64toi32_i32$0 = $2;
       HEAP32[($2 + 232 | 0) >> 2] = $437;
       HEAP32[($2 + 236 | 0) >> 2] = i64toi32_i32$2;
       $15 = 2;
       break label$4;
      }
      i64toi32_i32$3 = $2 + 376 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $442 = i64toi32_i32$2;
      i64toi32_i32$2 = $2 + 240 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $442;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$3 = $2 + 384 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $448 = i64toi32_i32$0;
      i64toi32_i32$0 = ($2 + 232 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $448;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$3 = $2 + 368 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $452 = i64toi32_i32$2;
      i64toi32_i32$2 = $2;
      HEAP32[($2 + 232 | 0) >> 2] = $452;
      HEAP32[($2 + 236 | 0) >> 2] = i64toi32_i32$0;
     }
     i64toi32_i32$0 = $20$hi;
     i64toi32_i32$2 = ($2 + 344 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $20;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$0 = $21$hi;
     i64toi32_i32$2 = ($2 + 344 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $21;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$3 = $2;
     i64toi32_i32$0 = HEAP32[($2 + 232 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[($2 + 236 | 0) >> 2] | 0;
     $464 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 368 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $464;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$3 = $2;
     i64toi32_i32$2 = HEAP32[($2 + 216 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 220 | 0) >> 2] | 0;
     $468 = i64toi32_i32$2;
     i64toi32_i32$2 = $2 + 396 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $468;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$3 = ($2 + 232 | 0) + 8 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $474 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 376 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $474;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$3 = ($2 + 232 | 0) + 16 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $480 = i64toi32_i32$2;
     i64toi32_i32$2 = $2 + 384 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $480;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($2 + 404 | 0) >> 2] = HEAP32[(($2 + 216 | 0) + 8 | 0) >> 2] | 0;
     HEAP8[($2 + 344 | 0) >> 0] = $15;
     $91 = HEAP32[($2 + 256 | 0) >> 2] | 0;
     HEAP8[($2 + 345 | 0) >> 0] = $91;
     HEAP8[($2 + 346 | 0) >> 0] = $91 >>> 8 | 0;
     HEAP8[($2 + 347 | 0) >> 0] = $91 >>> 16 | 0;
     HEAP8[($2 + 348 | 0) >> 0] = $91 >>> 24 | 0;
     $92 = HEAPU8[($2 + 259 | 0) >> 0] | 0 | ((HEAPU8[($2 + 260 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 261 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 262 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($2 + 348 | 0) >> 0] = $92;
     HEAP8[($2 + 349 | 0) >> 0] = $92 >>> 8 | 0;
     HEAP8[($2 + 350 | 0) >> 0] = $92 >>> 16 | 0;
     HEAP8[($2 + 351 | 0) >> 0] = $92 >>> 24 | 0;
     HEAP32[($2 + 392 | 0) >> 2] = $4;
     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($2 + 152 | 0 | 0, $2 + 344 | 0 | 0, 1059848 | 0, 11 | 0);
     $3 = HEAPU8[($2 + 152 | 0) >> 0] | 0;
     if (($3 | 0) != (19 | 0)) {
      break label$2
     }
    }
    label$21 : {
     $3 = HEAP32[($2 + 80 | 0) >> 2] | 0;
     if (!$3) {
      break label$21
     }
     $1 = HEAP32[($2 + 72 | 0) >> 2] | 0;
     $17 = $1 + Math_imul($3, 96) | 0;
     $3 = $1 + 56 | 0;
     $11 = ($2 + 344 | 0) + 8 | 0;
     $10 = $2 + 344 | 0 | 4 | 0;
     $13 = $2 + 360 | 0;
     label$22 : while (1) {
      label$23 : {
       label$24 : {
        label$25 : {
         label$26 : {
          label$27 : {
           label$28 : {
            $1 = $3 + -56 | 0;
            switch (HEAP32[$1 >> 2] | 0 | 0) {
            case 4:
             break label$24;
            case 3:
             break label$25;
            case 2:
             break label$26;
            case 1:
             break label$27;
            default:
             break label$28;
            };
           }
           $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__hdeea20968268d729($11 | 0, $3 + -48 | 0 | 0);
           HEAP32[($2 + 344 | 0) >> 2] = 0;
           break label$23;
          }
          $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hf69db734dd831996($10 | 0, $3 + -52 | 0 | 0);
          HEAP32[($2 + 344 | 0) >> 2] = 1;
          break label$23;
         }
         $14 = $3 + -48 | 0;
         i64toi32_i32$3 = $14 + 8 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $542 = i64toi32_i32$0;
         i64toi32_i32$0 = $13;
         HEAP32[i64toi32_i32$0 >> 2] = $542;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
         HEAP32[($2 + 344 | 0) >> 2] = 2;
         i64toi32_i32$3 = $14;
         i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $546 = i64toi32_i32$2;
         i64toi32_i32$2 = $2;
         HEAP32[($2 + 352 | 0) >> 2] = $546;
         HEAP32[($2 + 356 | 0) >> 2] = i64toi32_i32$0;
         break label$23;
        }
        $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($10 | 0, $3 + -52 | 0 | 0);
        HEAP32[($2 + 344 | 0) >> 2] = 3;
        break label$23;
       }
       $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($10 | 0, $3 + -52 | 0 | 0);
       HEAP32[($2 + 344 | 0) >> 2] = 4;
      }
      memcpy($2 + 88 | 0 | 0, $2 + 344 | 0 | 0, 48 | 0) | 0;
      label$29 : {
       label$30 : {
        switch (HEAP32[($1 + 48 | 0) >> 2] | 0 | 0) {
        default:
         $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__hdeea20968268d729($11 | 0, $3 | 0);
         HEAP32[($2 + 344 | 0) >> 2] = 0;
         break label$29;
        case 1:
         $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hf69db734dd831996($10 | 0, $3 + -4 | 0 | 0);
         HEAP32[($2 + 344 | 0) >> 2] = 1;
         break label$29;
        case 2:
         i64toi32_i32$3 = $3 + 8 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $573 = i64toi32_i32$0;
         i64toi32_i32$0 = $13;
         HEAP32[i64toi32_i32$0 >> 2] = $573;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
         HEAP32[($2 + 344 | 0) >> 2] = 2;
         i64toi32_i32$3 = $3;
         i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $577 = i64toi32_i32$2;
         i64toi32_i32$2 = $2;
         HEAP32[($2 + 352 | 0) >> 2] = $577;
         HEAP32[($2 + 356 | 0) >> 2] = i64toi32_i32$0;
         break label$29;
        case 3:
         $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($10 | 0, $3 + -4 | 0 | 0);
         HEAP32[($2 + 344 | 0) >> 2] = 3;
         break label$29;
        case 4:
         break label$30;
        };
       }
       $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($10 | 0, $3 + -4 | 0 | 0);
       HEAP32[($2 + 344 | 0) >> 2] = 4;
      }
      memcpy($2 + 152 | 0 | 0, $2 + 344 | 0 | 0, 48 | 0) | 0;
      linked_hash_map__LinkedHashMap_K_2cV_2cS___insert__heab3194aa02f42f0($2 + 344 | 0 | 0, $2 + 32 | 0 | 0, $2 + 88 | 0 | 0, $2 + 152 | 0 | 0);
      label$35 : {
       if ((HEAP32[($2 + 344 | 0) >> 2] | 0 | 0) == (5 | 0)) {
        break label$35
       }
       core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatum___headd2d1b596252cc($2 + 344 | 0 | 0);
      }
      $3 = $3 + 96 | 0;
      if (($1 + 96 | 0 | 0) != ($17 | 0)) {
       continue label$22
      }
      break label$22;
     };
    }
    memcpy($0 + 8 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
    i64toi32_i32$2 = $0;
    i64toi32_i32$0 = 0;
    HEAP32[i64toi32_i32$2 >> 2] = 0;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hb0dac7347f907b29($2 + 72 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h20290d2630d8c740($2 + 72 | 0 | 0);
    break label$1;
   }
   memcpy($2 + 88 | 0 | 0, $2 + 152 | 0 | 1 | 0 | 0, 63 | 0) | 0;
   HEAP8[($0 + 8 | 0) >> 0] = $3;
   memcpy($0 + 9 | 0 | 0, $2 + 88 | 0 | 0, 63 | 0) | 0;
   i64toi32_i32$2 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[i64toi32_i32$2 >> 2] = 1;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hb0dac7347f907b29($2 + 72 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h20290d2630d8c740($2 + 72 | 0 | 0);
   $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__hd17c55afb95953fd($2 + 32 | 0 | 0);
   if (!(HEAP32[($2 + 48 | 0) >> 2] | 0)) {
    break label$1
   }
   hashbrown__raw__RawTable_T_2cA___free_buckets__hf5781ccef5282b02(($2 + 32 | 0) + 16 | 0 | 0);
  }
  global$0 = $2 + 496 | 0;
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h965baa5031061a2e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $35 = 0, $35$hi = 0, $36 = 0, $36$hi = 0, $37 = 0, $37$hi = 0, $22 = 0, $23 = 0, $18 = 0, $38 = 0, $38$hi = 0, $4 = 0, $7 = 0, $15 = 0, $24 = 0, $25 = 0, $26 = 0, $27 = 0, $41$hi = 0, $32 = 0, $11 = 0, $16 = 0, $17 = 0, $20 = 0, $21 = 0, $99 = 0, $41 = 0, $100 = 0, $101 = 0, $102 = 0, $5 = 0, $19 = 0, $42$hi = 0, $33 = 0, $6 = 0, $9 = 0, $12 = 0, $13 = 0, $103 = 0, $104 = 0, $42 = 0, $105 = 0, $106 = 0, $107 = 0, $34 = 0, $108 = 0, $109 = 0, $3 = 0, $8 = 0, $10 = 0, $14 = 0, $94 = 0, $94$hi = 0, $98$hi = 0, $117 = 0, $117$hi = 0, $121$hi = 0, $147 = 0, $191 = 0, $198 = 0, $202 = 0, $209 = 0, $216 = 0, $223 = 0, $227 = 0, $28 = 0, $29 = 0, $30 = 0, $39 = 0, $39$hi = 0, $40 = 0, $40$hi = 0, $31 = 0, $285 = 0, $290 = 0, $295 = 0, $299 = 0, $318 = 0, $323 = 0, $328 = 0, $333 = 0, $338 = 0, $348 = 0, $351 = 0, $354 = 0, $405 = 0, $443 = 0, $447 = 0, $451 = 0, $484 = 0, $503 = 0, $527 = 0, $535 = 0, $543 = 0, $551 = 0, $559 = 0, $562 = 0, $565 = 0, $636 = 0, $640 = 0, $644 = 0, $654 = 0;
  $2 = global$0 - 288 | 0;
  global$0 = $2;
  $3 = HEAP32[$1 >> 2] | 0;
  $4 = 0;
  $5 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__hdfd3d0146c04aec1($2 + 8 | 0 | 0, $5 | 0, 0 | 0);
  $6 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  $7 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[($0 + 4 | 0) >> 2] = $7;
  HEAP32[$0 >> 2] = $6;
  label$1 : {
   if (!$7) {
    break label$1
   }
   $8 = Math_imul($5, 200);
   $9 = $2 + 232 | 0 | 6 | 0;
   $10 = $2 + 104 | 0 | 4 | 0;
   $11 = $2 + 116 | 0;
   $12 = ($2 + 104 | 0) + 32 | 0;
   $13 = ($2 + 104 | 0) + 8 | 0;
   $14 = $2 + 117 | 0;
   label$2 : while (1) {
    if (($8 | 0) == ($4 | 0)) {
     break label$1
    }
    $7 = $7 + -1 | 0;
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           label$10 : {
            label$11 : {
             label$12 : {
              $1 = $3 + $4 | 0;
              switch (HEAPU8[$1 >> 0] | 0 | 0) {
              case 2:
               break label$10;
              case 1:
               break label$11;
              case 6:
               break label$6;
              case 5:
               break label$7;
              case 4:
               break label$8;
              case 3:
               break label$9;
              default:
               break label$12;
              };
             }
             i64toi32_i32$2 = $1 + 24 | 0;
             i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
             i64toi32_i32$1 = 0;
             $94 = i64toi32_i32$0;
             $94$hi = i64toi32_i32$1;
             i64toi32_i32$2 = $1 + 28 | 0;
             i64toi32_i32$1 = HEAPU16[i64toi32_i32$2 >> 1] | 0;
             i64toi32_i32$0 = 0;
             i64toi32_i32$2 = i64toi32_i32$1;
             i64toi32_i32$1 = 0;
             i64toi32_i32$3 = 32;
             i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
             if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
              i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
              $103 = 0;
             } else {
              i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
              $103 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
             }
             $98$hi = i64toi32_i32$1;
             i64toi32_i32$1 = $94$hi;
             i64toi32_i32$0 = $94;
             i64toi32_i32$2 = $98$hi;
             i64toi32_i32$3 = $103;
             i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
             $35 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
             $35$hi = i64toi32_i32$2;
             $15 = HEAP32[($1 + 4 | 0) >> 2] | 0;
             i64toi32_i32$1 = $1 + 8 | 0;
             i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
             i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
             $36 = i64toi32_i32$2;
             $36$hi = i64toi32_i32$0;
             i64toi32_i32$1 = $1 + 16 | 0;
             i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
             i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
             $37 = i64toi32_i32$0;
             $37$hi = i64toi32_i32$2;
             $16 = HEAPU16[($1 + 2 | 0) >> 1] | 0;
             $17 = HEAPU8[($1 + 1 | 0) >> 0] | 0;
             $18 = 0;
             break label$3;
            }
            i64toi32_i32$1 = $1 + 24 | 0;
            i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
            i64toi32_i32$0 = 0;
            $117 = i64toi32_i32$2;
            $117$hi = i64toi32_i32$0;
            i64toi32_i32$1 = $1 + 28 | 0;
            i64toi32_i32$0 = HEAPU16[i64toi32_i32$1 >> 1] | 0;
            i64toi32_i32$2 = 0;
            i64toi32_i32$1 = i64toi32_i32$0;
            i64toi32_i32$0 = 0;
            i64toi32_i32$3 = 32;
            i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
            if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
             i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
             $104 = 0;
            } else {
             i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
             $104 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
            }
            $121$hi = i64toi32_i32$0;
            i64toi32_i32$0 = $117$hi;
            i64toi32_i32$2 = $117;
            i64toi32_i32$1 = $121$hi;
            i64toi32_i32$3 = $104;
            i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
            $35 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
            $35$hi = i64toi32_i32$1;
            $15 = HEAP32[($1 + 4 | 0) >> 2] | 0;
            i64toi32_i32$0 = $1 + 8 | 0;
            i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
            i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
            $36 = i64toi32_i32$1;
            $36$hi = i64toi32_i32$2;
            i64toi32_i32$0 = $1 + 16 | 0;
            i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
            i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
            $37 = i64toi32_i32$2;
            $37$hi = i64toi32_i32$1;
            $16 = HEAPU16[($1 + 2 | 0) >> 1] | 0;
            $18 = 1;
            $17 = HEAPU8[($1 + 1 | 0) >> 0] | 0;
            break label$3;
           }
           HEAP32[(($2 + 88 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 48 | 0) >> 2] | 0;
           i64toi32_i32$0 = $1 + 40 | 0;
           i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $147 = i64toi32_i32$1;
           i64toi32_i32$1 = $2;
           HEAP32[(i64toi32_i32$1 + 88 | 0) >> 2] = $147;
           HEAP32[(i64toi32_i32$1 + 92 | 0) >> 2] = i64toi32_i32$2;
           $19 = HEAPU8[($1 + 57 | 0) >> 0] | 0;
           $20 = HEAPU8[($1 + 56 | 0) >> 0] | 0;
           $21 = HEAP32[($1 + 52 | 0) >> 2] | 0;
           i64toi32_i32$0 = $1 + 32 | 0;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $38 = i64toi32_i32$2;
           $38$hi = i64toi32_i32$1;
           i64toi32_i32$0 = $1 + 24 | 0;
           i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $35 = i64toi32_i32$1;
           $35$hi = i64toi32_i32$2;
           $15 = HEAP32[($1 + 4 | 0) >> 2] | 0;
           i64toi32_i32$0 = $1 + 8 | 0;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $36 = i64toi32_i32$2;
           $36$hi = i64toi32_i32$1;
           i64toi32_i32$0 = $1 + 16 | 0;
           i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $37 = i64toi32_i32$1;
           $37$hi = i64toi32_i32$2;
           $18 = 2;
           $16 = HEAPU16[($1 + 2 | 0) >> 1] | 0;
           $17 = HEAPU8[($1 + 1 | 0) >> 0] | 0;
           break label$3;
          }
          $22 = ($2 + 152 | 0) + 24 | 0;
          $99 = $1 + 132 | 0;
          HEAP32[$22 >> 2] = HEAPU8[$99 >> 0] | 0 | ((HEAPU8[($99 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($99 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($99 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          $23 = ($2 + 152 | 0) + 16 | 0;
          i64toi32_i32$0 = $1 + 124 | 0;
          i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          $191 = i64toi32_i32$2;
          i64toi32_i32$2 = $23;
          HEAP32[i64toi32_i32$2 >> 2] = $191;
          HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
          $24 = ($2 + 152 | 0) + 8 | 0;
          i64toi32_i32$0 = $1 + 116 | 0;
          i64toi32_i32$1 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          $198 = i64toi32_i32$1;
          i64toi32_i32$1 = $24;
          HEAP32[i64toi32_i32$1 >> 2] = $198;
          HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
          i64toi32_i32$0 = $1 + 108 | 0;
          i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          $202 = i64toi32_i32$2;
          i64toi32_i32$2 = $2;
          HEAP32[(i64toi32_i32$2 + 152 | 0) >> 2] = $202;
          HEAP32[(i64toi32_i32$2 + 156 | 0) >> 2] = i64toi32_i32$1;
          $25 = (i64toi32_i32$2 + 184 | 0) + 24 | 0;
          i64toi32_i32$0 = $1 + 160 | 0;
          i64toi32_i32$1 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          $209 = i64toi32_i32$1;
          i64toi32_i32$1 = $25;
          HEAP32[i64toi32_i32$1 >> 2] = $209;
          HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
          $26 = ($2 + 184 | 0) + 16 | 0;
          i64toi32_i32$0 = $1 + 152 | 0;
          i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          $216 = i64toi32_i32$2;
          i64toi32_i32$2 = $26;
          HEAP32[i64toi32_i32$2 >> 2] = $216;
          HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
          $27 = ($2 + 184 | 0) + 8 | 0;
          i64toi32_i32$0 = $1 + 144 | 0;
          i64toi32_i32$1 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          $223 = i64toi32_i32$1;
          i64toi32_i32$1 = $27;
          HEAP32[i64toi32_i32$1 >> 2] = $223;
          HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
          i64toi32_i32$0 = $1 + 136 | 0;
          i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          $227 = i64toi32_i32$2;
          i64toi32_i32$2 = $2;
          HEAP32[(i64toi32_i32$2 + 184 | 0) >> 2] = $227;
          HEAP32[(i64toi32_i32$2 + 188 | 0) >> 2] = i64toi32_i32$1;
          i64toi32_i32$0 = $1 + 8 | 0;
          i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
          i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
          $36 = i64toi32_i32$1;
          $36$hi = i64toi32_i32$2;
          i64toi32_i32$0 = $1 + 16 | 0;
          i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
          $37 = i64toi32_i32$2;
          $37$hi = i64toi32_i32$1;
          i64toi32_i32$0 = $1 + 24 | 0;
          i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
          i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
          $35 = i64toi32_i32$1;
          $35$hi = i64toi32_i32$2;
          i64toi32_i32$0 = $1 + 32 | 0;
          i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
          $38 = i64toi32_i32$2;
          $38$hi = i64toi32_i32$1;
          $28 = HEAPU8[($1 + 168 | 0) >> 0] | 0;
          $29 = HEAPU8[($1 + 169 | 0) >> 0] | 0;
          $30 = HEAPU16[($1 + 170 | 0) >> 1] | 0;
          i64toi32_i32$0 = $1 + 184 | 0;
          i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
          i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
          $39 = i64toi32_i32$1;
          $39$hi = i64toi32_i32$2;
          i64toi32_i32$0 = $1 + 176 | 0;
          i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
          $40 = i64toi32_i32$2;
          $40$hi = i64toi32_i32$1;
          $31 = HEAP32[($1 + 172 | 0) >> 2] | 0;
          i64toi32_i32$0 = $1 + 192 | 0;
          i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
          i64toi32_i32$2 = 0;
          $41 = i64toi32_i32$1;
          $41$hi = i64toi32_i32$2;
          i64toi32_i32$0 = $1 + 196 | 0;
          i64toi32_i32$2 = HEAPU16[i64toi32_i32$0 >> 1] | 0;
          i64toi32_i32$1 = 0;
          $42 = i64toi32_i32$2;
          $42$hi = i64toi32_i32$1;
          $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h25db889dc58a550d($2 + 216 | 0 | 0, $1 + 40 | 0 | 0);
          $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h3d33b90cd2011dc4($2 + 232 | 0 | 0, $1 + 52 | 0 | 0);
          i64toi32_i32$0 = i64toi32_i32$2;
          i64toi32_i32$2 = 0;
          i64toi32_i32$3 = 32;
          i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
          if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
           i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
           $105 = 0;
          } else {
           i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
           $105 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
          }
          $42 = $105;
          $42$hi = i64toi32_i32$2;
          label$13 : {
           label$14 : {
            $32 = $1 + 64 | 0;
            if (HEAP32[$32 >> 2] | 0) {
             break label$14
            }
            $33 = 0;
            break label$13;
           }
           $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($2 + 104 | 0 | 0, $32 | 0);
           i64toi32_i32$1 = $1 + 100 | 0;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $285 = i64toi32_i32$2;
           i64toi32_i32$2 = $11 + 24 | 0;
           HEAP32[i64toi32_i32$2 >> 2] = $285;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
           i64toi32_i32$1 = $1 + 92 | 0;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $290 = i64toi32_i32$0;
           i64toi32_i32$0 = $11 + 16 | 0;
           HEAP32[i64toi32_i32$0 >> 2] = $290;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
           i64toi32_i32$1 = $1 + 84 | 0;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $295 = i64toi32_i32$2;
           i64toi32_i32$2 = $11 + 8 | 0;
           HEAP32[i64toi32_i32$2 >> 2] = $295;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
           i64toi32_i32$1 = $1 + 76 | 0;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $299 = i64toi32_i32$0;
           i64toi32_i32$0 = $11;
           HEAP32[i64toi32_i32$0 >> 2] = $299;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
           $33 = HEAP32[($2 + 104 | 0) >> 2] | 0;
           memcpy($2 + 248 | 0 | 0, $10 | 0, 40 | 0) | 0;
          }
          i64toi32_i32$2 = $41$hi;
          i64toi32_i32$2 = $42$hi;
          i64toi32_i32$2 = $41$hi;
          i64toi32_i32$1 = $41;
          i64toi32_i32$0 = $42$hi;
          i64toi32_i32$3 = $42;
          i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
          $41 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
          $41$hi = i64toi32_i32$0;
          HEAP32[(($2 + 48 | 0) + 24 | 0) >> 2] = HEAP32[$22 >> 2] | 0;
          i64toi32_i32$2 = $23;
          i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
          $318 = i64toi32_i32$0;
          i64toi32_i32$0 = ($2 + 48 | 0) + 16 | 0;
          HEAP32[i64toi32_i32$0 >> 2] = $318;
          HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
          i64toi32_i32$2 = $24;
          i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
          $323 = i64toi32_i32$1;
          i64toi32_i32$1 = ($2 + 48 | 0) + 8 | 0;
          HEAP32[i64toi32_i32$1 >> 2] = $323;
          HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
          i64toi32_i32$2 = $27;
          i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
          $328 = i64toi32_i32$0;
          i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
          HEAP32[i64toi32_i32$0 >> 2] = $328;
          HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
          i64toi32_i32$2 = $26;
          i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
          $333 = i64toi32_i32$1;
          i64toi32_i32$1 = ($2 + 16 | 0) + 16 | 0;
          HEAP32[i64toi32_i32$1 >> 2] = $333;
          HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
          i64toi32_i32$2 = $25;
          i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
          $338 = i64toi32_i32$0;
          i64toi32_i32$0 = ($2 + 16 | 0) + 24 | 0;
          HEAP32[i64toi32_i32$0 >> 2] = $338;
          HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
          HEAP32[(($2 + 88 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 216 | 0) + 8 | 0) >> 2] | 0;
          i64toi32_i32$2 = $2;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 152 | 0) >> 2] | 0;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 156 | 0) >> 2] | 0;
          $348 = i64toi32_i32$1;
          i64toi32_i32$1 = i64toi32_i32$2;
          HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = $348;
          HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = i64toi32_i32$0;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 184 | 0) >> 2] | 0;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 188 | 0) >> 2] | 0;
          $351 = i64toi32_i32$0;
          i64toi32_i32$0 = i64toi32_i32$2;
          HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] = $351;
          HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] = i64toi32_i32$1;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 216 | 0) >> 2] | 0;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 220 | 0) >> 2] | 0;
          $354 = i64toi32_i32$1;
          i64toi32_i32$1 = i64toi32_i32$2;
          HEAP32[(i64toi32_i32$2 + 88 | 0) >> 2] = $354;
          HEAP32[(i64toi32_i32$2 + 92 | 0) >> 2] = i64toi32_i32$0;
          $106 = $9 + 4 | 0;
          HEAP16[((i64toi32_i32$2 + 80 | 0) + 4 | 0) >> 1] = HEAPU8[$106 >> 0] | 0 | ((HEAPU8[($106 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
          $100 = $9;
          HEAP32[(i64toi32_i32$2 + 80 | 0) >> 2] = HEAPU8[$100 >> 0] | 0 | ((HEAPU8[($100 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($100 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($100 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          $19 = HEAPU8[(i64toi32_i32$2 + 237 | 0) >> 0] | 0;
          $20 = HEAPU8[(i64toi32_i32$2 + 236 | 0) >> 0] | 0;
          $21 = HEAP32[(i64toi32_i32$2 + 232 | 0) >> 2] | 0;
          memcpy(i64toi32_i32$2 + 104 | 0 | 0, i64toi32_i32$2 + 248 | 0 | 0, 40 | 0) | 0;
          $18 = 3;
          break label$5;
         }
         $18 = 4;
         $15 = HEAP32[($1 + 4 | 0) >> 2] | 0;
         i64toi32_i32$2 = $1 + 32 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = 0;
         $38 = i64toi32_i32$0;
         $38$hi = i64toi32_i32$1;
         i64toi32_i32$2 = $1 + 24 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $35 = i64toi32_i32$1;
         $35$hi = i64toi32_i32$0;
         i64toi32_i32$2 = $1 + 16 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $37 = i64toi32_i32$0;
         $37$hi = i64toi32_i32$1;
         i64toi32_i32$2 = $1 + 8 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $36 = i64toi32_i32$1;
         $36$hi = i64toi32_i32$0;
         break label$4;
        }
        HEAP32[(($2 + 88 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 48 | 0) >> 2] | 0;
        $107 = $1 + 62 | 0;
        HEAP16[(($2 + 80 | 0) + 4 | 0) >> 1] = HEAPU8[$107 >> 0] | 0 | ((HEAPU8[($107 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
        i64toi32_i32$2 = $1 + 40 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $405 = i64toi32_i32$0;
        i64toi32_i32$0 = $2;
        HEAP32[(i64toi32_i32$0 + 88 | 0) >> 2] = $405;
        HEAP32[(i64toi32_i32$0 + 92 | 0) >> 2] = i64toi32_i32$1;
        $101 = $1 + 58 | 0;
        HEAP32[(i64toi32_i32$0 + 80 | 0) >> 2] = HEAPU8[$101 >> 0] | 0 | ((HEAPU8[($101 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($101 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($101 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$2 = $1 + 32 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $38 = i64toi32_i32$1;
        $38$hi = i64toi32_i32$0;
        i64toi32_i32$2 = $1 + 24 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $35 = i64toi32_i32$0;
        $35$hi = i64toi32_i32$1;
        i64toi32_i32$2 = $1 + 16 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $37 = i64toi32_i32$1;
        $37$hi = i64toi32_i32$0;
        i64toi32_i32$2 = $1 + 8 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $36 = i64toi32_i32$0;
        $36$hi = i64toi32_i32$1;
        $15 = HEAP32[($1 + 4 | 0) >> 2] | 0;
        $16 = HEAPU16[($1 + 2 | 0) >> 1] | 0;
        $17 = HEAPU8[($1 + 1 | 0) >> 0] | 0;
        $21 = HEAP32[($1 + 52 | 0) >> 2] | 0;
        $20 = HEAPU8[($1 + 56 | 0) >> 0] | 0;
        $19 = HEAPU8[($1 + 57 | 0) >> 0] | 0;
        i64toi32_i32$2 = $1 + 81 | 0;
        i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $443 = i64toi32_i32$1;
        i64toi32_i32$1 = $14;
        $102 = $443;
        HEAP8[i64toi32_i32$1 >> 0] = $102;
        HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $102 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $102 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $102 >>> 24 | 0;
        HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
        HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
        i64toi32_i32$2 = $1 + 76 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $447 = i64toi32_i32$0;
        i64toi32_i32$0 = $13;
        HEAP32[i64toi32_i32$0 >> 2] = $447;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$2 = $1 + 68 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $451 = i64toi32_i32$1;
        i64toi32_i32$1 = $2;
        HEAP32[(i64toi32_i32$1 + 104 | 0) >> 2] = $451;
        HEAP32[(i64toi32_i32$1 + 108 | 0) >> 2] = i64toi32_i32$0;
        $33 = HEAP32[($1 + 64 | 0) >> 2] | 0;
        $18 = 5;
        break label$3;
       }
       $20 = HEAPU8[($1 + 56 | 0) >> 0] | 0;
       label$15 : {
        label$16 : {
         i64toi32_i32$2 = $1 + 8 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         i64toi32_i32$2 = i64toi32_i32$0;
         i64toi32_i32$0 = 0;
         i64toi32_i32$3 = 1;
         if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
          break label$16
         }
         i64toi32_i32$3 = $1 + 16 | 0;
         i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $37 = i64toi32_i32$2;
         $37$hi = i64toi32_i32$1;
         i64toi32_i32$1 = 0;
         $36 = 0;
         $36$hi = i64toi32_i32$1;
         break label$15;
        }
        $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h7490700a7eed2994($13 | 0, $1 + 16 | 0 | 0);
        i64toi32_i32$1 = 0;
        $36 = 1;
        $36$hi = i64toi32_i32$1;
        $21 = HEAP32[($2 + 148 | 0) >> 2] | 0;
        i64toi32_i32$3 = $2;
        i64toi32_i32$1 = HEAP32[($2 + 128 | 0) >> 2] | 0;
        i64toi32_i32$2 = HEAP32[($2 + 132 | 0) >> 2] | 0;
        $38 = i64toi32_i32$1;
        $38$hi = i64toi32_i32$2;
        i64toi32_i32$3 = $2;
        i64toi32_i32$2 = HEAP32[($2 + 120 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 124 | 0) >> 2] | 0;
        $35 = i64toi32_i32$2;
        $35$hi = i64toi32_i32$1;
        i64toi32_i32$3 = $2;
        i64toi32_i32$1 = HEAP32[($2 + 112 | 0) >> 2] | 0;
        i64toi32_i32$2 = HEAP32[($2 + 116 | 0) >> 2] | 0;
        $37 = i64toi32_i32$1;
        $37$hi = i64toi32_i32$2;
       }
       HEAP32[(($2 + 88 | 0) + 8 | 0) >> 2] = HEAP32[($12 + 8 | 0) >> 2] | 0;
       i64toi32_i32$3 = $12;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $484 = i64toi32_i32$2;
       i64toi32_i32$2 = $2;
       HEAP32[(i64toi32_i32$2 + 88 | 0) >> 2] = $484;
       HEAP32[(i64toi32_i32$2 + 92 | 0) >> 2] = i64toi32_i32$1;
       $18 = 6;
      }
     }
    }
    $22 = ($2 + 232 | 0) + 8 | 0;
    HEAP32[$22 >> 2] = HEAP32[(($2 + 88 | 0) + 8 | 0) >> 2] | 0;
    $23 = ($2 + 216 | 0) + 4 | 0;
    HEAP16[$23 >> 1] = HEAPU16[(($2 + 80 | 0) + 4 | 0) >> 1] | 0;
    i64toi32_i32$3 = $2;
    i64toi32_i32$1 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($2 + 92 | 0) >> 2] | 0;
    $503 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[(i64toi32_i32$1 + 232 | 0) >> 2] = $503;
    HEAP32[(i64toi32_i32$1 + 236 | 0) >> 2] = i64toi32_i32$2;
    HEAP32[(i64toi32_i32$1 + 216 | 0) >> 2] = HEAP32[(i64toi32_i32$1 + 80 | 0) >> 2] | 0;
    memcpy(i64toi32_i32$1 + 248 | 0 | 0, i64toi32_i32$1 + 104 | 0 | 0, 40 | 0) | 0;
    $24 = (i64toi32_i32$1 + 152 | 0) + 24 | 0;
    HEAP32[$24 >> 2] = HEAP32[((i64toi32_i32$1 + 48 | 0) + 24 | 0) >> 2] | 0;
    $25 = (i64toi32_i32$1 + 152 | 0) + 16 | 0;
    i64toi32_i32$3 = (i64toi32_i32$1 + 48 | 0) + 16 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $527 = i64toi32_i32$2;
    i64toi32_i32$2 = $25;
    HEAP32[i64toi32_i32$2 >> 2] = $527;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
    $26 = ($2 + 152 | 0) + 8 | 0;
    i64toi32_i32$3 = ($2 + 48 | 0) + 8 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $535 = i64toi32_i32$1;
    i64toi32_i32$1 = $26;
    HEAP32[i64toi32_i32$1 >> 2] = $535;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
    $27 = ($2 + 184 | 0) + 8 | 0;
    i64toi32_i32$3 = ($2 + 16 | 0) + 8 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $543 = i64toi32_i32$2;
    i64toi32_i32$2 = $27;
    HEAP32[i64toi32_i32$2 >> 2] = $543;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
    $32 = ($2 + 184 | 0) + 16 | 0;
    i64toi32_i32$3 = ($2 + 16 | 0) + 16 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $551 = i64toi32_i32$1;
    i64toi32_i32$1 = $32;
    HEAP32[i64toi32_i32$1 >> 2] = $551;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
    $34 = ($2 + 184 | 0) + 24 | 0;
    i64toi32_i32$3 = ($2 + 16 | 0) + 24 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $559 = i64toi32_i32$2;
    i64toi32_i32$2 = $34;
    HEAP32[i64toi32_i32$2 >> 2] = $559;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$3 = $2;
    i64toi32_i32$1 = HEAP32[($2 + 48 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($2 + 52 | 0) >> 2] | 0;
    $562 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[(i64toi32_i32$1 + 152 | 0) >> 2] = $562;
    HEAP32[(i64toi32_i32$1 + 156 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$3 = i64toi32_i32$1;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] | 0;
    $565 = i64toi32_i32$2;
    i64toi32_i32$2 = $2;
    HEAP32[(i64toi32_i32$2 + 184 | 0) >> 2] = $565;
    HEAP32[(i64toi32_i32$2 + 188 | 0) >> 2] = i64toi32_i32$1;
    $1 = $6 + $4 | 0;
    i64toi32_i32$1 = $38$hi;
    i64toi32_i32$2 = $1 + 32 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $38;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $35$hi;
    i64toi32_i32$2 = $1 + 24 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $35;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $37$hi;
    i64toi32_i32$2 = $1 + 16 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $37;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $36$hi;
    i64toi32_i32$2 = $1 + 8 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $36;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($1 + 4 | 0) >> 2] = $15;
    HEAP16[($1 + 2 | 0) >> 1] = $16;
    HEAP8[($1 + 1 | 0) >> 0] = $17;
    HEAP8[$1 >> 0] = $18;
    $22 = HEAP32[$22 >> 2] | 0;
    i64toi32_i32$3 = $2;
    i64toi32_i32$1 = HEAP32[($2 + 232 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($2 + 236 | 0) >> 2] | 0;
    $35 = i64toi32_i32$1;
    $35$hi = i64toi32_i32$2;
    HEAP8[($1 + 57 | 0) >> 0] = $19;
    HEAP8[($1 + 56 | 0) >> 0] = $20;
    HEAP32[($1 + 52 | 0) >> 2] = $21;
    i64toi32_i32$1 = $1 + 40 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $35;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
    HEAP32[($1 + 48 | 0) >> 2] = $22;
    $22 = HEAPU16[$23 >> 1] | 0;
    $23 = HEAP32[($2 + 216 | 0) >> 2] | 0;
    HEAP32[($1 + 64 | 0) >> 2] = $33;
    $108 = $1 + 58 | 0;
    HEAP16[$108 >> 1] = $23;
    HEAP16[($108 + 2 | 0) >> 1] = $23 >>> 16 | 0;
    HEAP16[($1 + 62 | 0) >> 1] = $22;
    memcpy($1 + 68 | 0 | 0, $2 + 248 | 0 | 0, 40 | 0) | 0;
    HEAP32[($1 + 132 | 0) >> 2] = HEAP32[$24 >> 2] | 0;
    i64toi32_i32$3 = $25;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $636 = i64toi32_i32$2;
    i64toi32_i32$2 = $1 + 124 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $636;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$3 = $26;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $640 = i64toi32_i32$1;
    i64toi32_i32$1 = $1 + 116 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $640;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$3 = $2;
    i64toi32_i32$2 = HEAP32[($2 + 152 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 156 | 0) >> 2] | 0;
    $644 = i64toi32_i32$2;
    i64toi32_i32$2 = $1 + 108 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $644;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$3 = $34;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $35 = i64toi32_i32$1;
    $35$hi = i64toi32_i32$2;
    i64toi32_i32$3 = $32;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $36 = i64toi32_i32$2;
    $36$hi = i64toi32_i32$1;
    i64toi32_i32$3 = $27;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $37 = i64toi32_i32$1;
    $37$hi = i64toi32_i32$2;
    i64toi32_i32$3 = $2;
    i64toi32_i32$2 = HEAP32[($2 + 184 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 188 | 0) >> 2] | 0;
    $38 = i64toi32_i32$2;
    $38$hi = i64toi32_i32$1;
    $654 = $1 + 196 | 0;
    i64toi32_i32$1 = $41$hi;
    i64toi32_i32$3 = $41;
    i64toi32_i32$2 = 0;
    i64toi32_i32$0 = 32;
    i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
     i64toi32_i32$2 = 0;
     $109 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
    } else {
     i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
     $109 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$4 | 0) | 0;
    }
    HEAP16[$654 >> 1] = $109;
    i64toi32_i32$2 = $41$hi;
    HEAP32[($1 + 192 | 0) >> 2] = $41;
    i64toi32_i32$2 = $38$hi;
    i64toi32_i32$3 = $1 + 136 | 0;
    HEAP32[i64toi32_i32$3 >> 2] = $38;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $37$hi;
    i64toi32_i32$3 = $1 + 144 | 0;
    HEAP32[i64toi32_i32$3 >> 2] = $37;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $36$hi;
    i64toi32_i32$3 = $1 + 152 | 0;
    HEAP32[i64toi32_i32$3 >> 2] = $36;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $35$hi;
    i64toi32_i32$3 = $1 + 160 | 0;
    HEAP32[i64toi32_i32$3 >> 2] = $35;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $39$hi;
    i64toi32_i32$3 = $1 + 184 | 0;
    HEAP32[i64toi32_i32$3 >> 2] = $39;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $40$hi;
    i64toi32_i32$3 = $1 + 176 | 0;
    HEAP32[i64toi32_i32$3 >> 2] = $40;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
    HEAP32[($1 + 172 | 0) >> 2] = $31;
    HEAP16[($1 + 170 | 0) >> 1] = $30;
    HEAP8[($1 + 169 | 0) >> 0] = $29;
    HEAP8[($1 + 168 | 0) >> 0] = $28;
    $4 = $4 + 200 | 0;
    if ($7) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 8 | 0) >> 2] = $5;
  global$0 = $2 + 288 | 0;
 }
 
 function core__num__flt2dec__strategy__grisu__format_shortest_opt__h11bf281506e98a2a($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, i64toi32_i32$0 = 0, $12$hi = 0, $14$hi = 0, $12 = 0, i64toi32_i32$6 = 0, $14 = 0, $13$hi = 0, $5 = 0, $15$hi = 0, $6 = 0, $13 = 0, $17$hi = 0, $15 = 0, $19$hi = 0, $25$hi = 0, $23$hi = 0, $17 = 0, $21$hi = 0, $4 = 0, $19 = 0, $16$hi = 0, $25 = 0, $35$hi = 0, $16 = 0, $23 = 0, $21 = 0, $30$hi = 0, $9 = 0, $35 = 0, $36$hi = 0, $30 = 0, $7 = 0, $18$hi = 0, $26$hi = 0, $32$hi = 0, $33$hi = 0, $34$hi = 0, $24$hi = 0, $27$hi = 0, $28$hi = 0, $29$hi = 0, $11 = 0, $36 = 0, $18 = 0, $22$hi = 0, $26 = 0, $32 = 0, $33 = 0, $34 = 0, $186 = 0, $187 = 0, $188 = 0, $189 = 0, $190 = 0, $191 = 0, $192 = 0, $193 = 0, $194 = 0, $196 = 0, $20 = 0, $20$hi = 0, $197 = 0, $198 = 0, $22 = 0, $199 = 0, $202 = 0, $24 = 0, $203 = 0, $204 = 0, $205 = 0, $206 = 0, $207 = 0, $27 = 0, $208 = 0, $28 = 0, $209 = 0, $29 = 0, $210 = 0, $211 = 0, $213 = 0, $31$hi = 0, $214 = 0, $215 = 0, $216 = 0, $217 = 0, $218 = 0, $8 = 0, $10 = 0, $220 = 0, $221 = 0, $222 = 0, $74 = 0, $83 = 0, $84 = 0, $86$hi = 0, $95 = 0, $96 = 0, $98$hi = 0, $107 = 0, $108 = 0, $110$hi = 0, $119 = 0, $120 = 0, $122$hi = 0, $129 = 0, $131$hi = 0, $146 = 0, $154 = 0, $165 = 0, $185 = 0, $185$hi = 0, $195 = 0, $195$hi = 0, $200 = 0, $200$hi = 0, $201 = 0, $201$hi = 0, $212 = 0, $212$hi = 0, $216$hi = 0, $217$hi = 0, $219 = 0, $219$hi = 0, $235 = 0, $235$hi = 0, $244 = 0, $244$hi = 0, $250$hi = 0, $251$hi = 0, $256 = 0, $256$hi = 0, $270 = 0, $270$hi = 0, $271 = 0, $271$hi = 0, $274$hi = 0, $31 = 0, $280 = 0, $280$hi = 0, $287 = 0, $287$hi = 0, $296 = 0, $296$hi = 0, $298 = 0, $298$hi = 0, $302$hi = 0, $303$hi = 0, $305 = 0, $305$hi = 0, $363 = 0, $363$hi = 0, $366$hi = 0, $368$hi = 0, $370$hi = 0, $389 = 0, $389$hi = 0, $396$hi = 0, $426 = 0, $459$hi = 0, $477 = 0, $477$hi = 0, $480$hi = 0, $496 = 0, $496$hi = 0, $499$hi = 0, $556 = 0, $556$hi = 0, $558$hi = 0, $578$hi = 0, $583$hi = 0, $585 = 0, $585$hi = 0, $588$hi = 0, $594$hi = 0, $595 = 0, $595$hi = 0, $596$hi = 0, $598$hi = 0, $600$hi = 0, $602 = 0, $602$hi = 0, $608$hi = 0, $613$hi = 0, $615$hi = 0, $617 = 0, $617$hi = 0, $621$hi = 0, $622 = 0, $622$hi = 0, $623$hi = 0, $625$hi = 0, $627$hi = 0, $629$hi = 0, $640$hi = 0, $682 = 0, $682$hi = 0, $685$hi = 0, $689 = 0, $689$hi = 0, $691$hi = 0, $716 = 0, $716$hi = 0, $719$hi = 0, $722$hi = 0, $725 = 0, $725$hi = 0, $727$hi = 0, $729$hi = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       i64toi32_i32$2 = $1;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $12 = i64toi32_i32$0;
       $12$hi = i64toi32_i32$1;
       if (!(i64toi32_i32$0 | i64toi32_i32$1 | 0)) {
        break label$5
       }
       label$6 : {
        i64toi32_i32$2 = $1;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
        $13 = i64toi32_i32$1;
        $13$hi = i64toi32_i32$0;
        if (!(i64toi32_i32$1 | i64toi32_i32$0 | 0)) {
         break label$6
        }
        label$7 : {
         i64toi32_i32$2 = $1;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
         $14 = i64toi32_i32$0;
         $14$hi = i64toi32_i32$1;
         if (!(i64toi32_i32$0 | i64toi32_i32$1 | 0)) {
          break label$7
         }
         label$8 : {
          i64toi32_i32$1 = $12$hi;
          i64toi32_i32$1 = $14$hi;
          i64toi32_i32$1 = $12$hi;
          i64toi32_i32$2 = $12;
          i64toi32_i32$0 = $14$hi;
          i64toi32_i32$3 = $14;
          i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
          i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
          if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
           i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
          }
          $14 = i64toi32_i32$4;
          $14$hi = i64toi32_i32$5;
          i64toi32_i32$5 = $12$hi;
          i64toi32_i32$5 = $14$hi;
          i64toi32_i32$1 = i64toi32_i32$4;
          i64toi32_i32$2 = $12$hi;
          i64toi32_i32$3 = $12;
          if (i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0) {
           break label$8
          }
          label$9 : {
           i64toi32_i32$1 = $12$hi;
           i64toi32_i32$1 = $13$hi;
           i64toi32_i32$1 = $12$hi;
           i64toi32_i32$3 = $12;
           i64toi32_i32$5 = $13$hi;
           i64toi32_i32$2 = $13;
           i64toi32_i32$0 = i64toi32_i32$3 - i64toi32_i32$2 | 0;
           i64toi32_i32$6 = i64toi32_i32$3 >>> 0 < i64toi32_i32$2 >>> 0;
           i64toi32_i32$4 = i64toi32_i32$6 + i64toi32_i32$5 | 0;
           i64toi32_i32$4 = i64toi32_i32$1 - i64toi32_i32$4 | 0;
           $15 = i64toi32_i32$0;
           $15$hi = i64toi32_i32$4;
           i64toi32_i32$4 = i64toi32_i32$1;
           i64toi32_i32$4 = $15$hi;
           i64toi32_i32$1 = i64toi32_i32$0;
           i64toi32_i32$3 = $12$hi;
           i64toi32_i32$2 = $12;
           if (i64toi32_i32$4 >>> 0 > i64toi32_i32$3 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$1 >>> 0 > i64toi32_i32$2 >>> 0 | 0) | 0) {
            break label$9
           }
           label$10 : {
            if ($3 >>> 0 < 17 >>> 0) {
             break label$10
            }
            label$11 : {
             label$12 : {
              label$13 : {
               label$14 : {
                label$15 : {
                 i64toi32_i32$1 = $14$hi;
                 i64toi32_i32$2 = $14;
                 i64toi32_i32$4 = 536870911;
                 i64toi32_i32$3 = -1;
                 if (i64toi32_i32$1 >>> 0 > i64toi32_i32$4 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$4 | 0) & i64toi32_i32$2 >>> 0 > i64toi32_i32$3 >>> 0 | 0) | 0) {
                  break label$15
                 }
                 $1 = HEAPU16[($1 + 24 | 0) >> 1] | 0;
                 HEAP16[($4 + 8 | 0) >> 1] = $1;
                 i64toi32_i32$2 = $15$hi;
                 i64toi32_i32$1 = $4;
                 HEAP32[i64toi32_i32$1 >> 2] = $15;
                 HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
                 $74 = $1;
                 i64toi32_i32$2 = $14$hi;
                 i64toi32_i32$3 = $14;
                 i64toi32_i32$1 = 1;
                 i64toi32_i32$4 = 0;
                 $5 = i64toi32_i32$2 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$3 >>> 0 < i64toi32_i32$4 >>> 0 | 0) | 0;
                 $6 = $5 ? $1 + -32 | 0 : $1;
                 $83 = $6 + -16 | 0;
                 $84 = $6;
                 i64toi32_i32$3 = i64toi32_i32$2;
                 i64toi32_i32$4 = $14;
                 i64toi32_i32$2 = 0;
                 i64toi32_i32$1 = 32;
                 i64toi32_i32$5 = i64toi32_i32$1 & 31 | 0;
                 if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                  i64toi32_i32$2 = i64toi32_i32$4 << i64toi32_i32$5 | 0;
                  $186 = 0;
                 } else {
                  i64toi32_i32$2 = ((1 << i64toi32_i32$5 | 0) - 1 | 0) & (i64toi32_i32$4 >>> (32 - i64toi32_i32$5 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$5 | 0) | 0;
                  $186 = i64toi32_i32$4 << i64toi32_i32$5 | 0;
                 }
                 $86$hi = i64toi32_i32$2;
                 i64toi32_i32$2 = $14$hi;
                 i64toi32_i32$5 = $5;
                 i64toi32_i32$2 = $86$hi;
                 i64toi32_i32$4 = $14$hi;
                 i64toi32_i32$1 = i64toi32_i32$5 ? $186 : $14;
                 i64toi32_i32$3 = i64toi32_i32$5 ? i64toi32_i32$2 : i64toi32_i32$4;
                 $14 = i64toi32_i32$1;
                 $14$hi = i64toi32_i32$3;
                 i64toi32_i32$5 = i64toi32_i32$1;
                 i64toi32_i32$1 = 65536;
                 i64toi32_i32$2 = 0;
                 $5 = i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0;
                 $6 = $5 ? $83 : $84;
                 $95 = $6 + -8 | 0;
                 $96 = $6;
                 i64toi32_i32$5 = i64toi32_i32$3;
                 i64toi32_i32$5 = i64toi32_i32$3;
                 i64toi32_i32$2 = $14;
                 i64toi32_i32$3 = 0;
                 i64toi32_i32$1 = 16;
                 i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
                 if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                  i64toi32_i32$3 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
                  $187 = 0;
                 } else {
                  i64toi32_i32$3 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$5 << i64toi32_i32$4 | 0) | 0;
                  $187 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
                 }
                 $98$hi = i64toi32_i32$3;
                 i64toi32_i32$3 = $14$hi;
                 i64toi32_i32$4 = $5;
                 i64toi32_i32$3 = $98$hi;
                 i64toi32_i32$2 = $14$hi;
                 i64toi32_i32$1 = i64toi32_i32$4 ? $187 : $14;
                 i64toi32_i32$5 = i64toi32_i32$4 ? i64toi32_i32$3 : i64toi32_i32$2;
                 $14 = i64toi32_i32$1;
                 $14$hi = i64toi32_i32$5;
                 i64toi32_i32$4 = i64toi32_i32$1;
                 i64toi32_i32$1 = 16777216;
                 i64toi32_i32$3 = 0;
                 $5 = i64toi32_i32$5 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
                 $6 = $5 ? $95 : $96;
                 $107 = $6 + -4 | 0;
                 $108 = $6;
                 i64toi32_i32$4 = i64toi32_i32$5;
                 i64toi32_i32$4 = i64toi32_i32$5;
                 i64toi32_i32$3 = $14;
                 i64toi32_i32$5 = 0;
                 i64toi32_i32$1 = 8;
                 i64toi32_i32$2 = i64toi32_i32$1 & 31 | 0;
                 if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                  i64toi32_i32$5 = i64toi32_i32$3 << i64toi32_i32$2 | 0;
                  $188 = 0;
                 } else {
                  i64toi32_i32$5 = ((1 << i64toi32_i32$2 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$2 | 0) | 0) | 0 | (i64toi32_i32$4 << i64toi32_i32$2 | 0) | 0;
                  $188 = i64toi32_i32$3 << i64toi32_i32$2 | 0;
                 }
                 $110$hi = i64toi32_i32$5;
                 i64toi32_i32$5 = $14$hi;
                 i64toi32_i32$2 = $5;
                 i64toi32_i32$5 = $110$hi;
                 i64toi32_i32$3 = $14$hi;
                 i64toi32_i32$1 = i64toi32_i32$2 ? $188 : $14;
                 i64toi32_i32$4 = i64toi32_i32$2 ? i64toi32_i32$5 : i64toi32_i32$3;
                 $14 = i64toi32_i32$1;
                 $14$hi = i64toi32_i32$4;
                 i64toi32_i32$2 = i64toi32_i32$1;
                 i64toi32_i32$1 = 268435456;
                 i64toi32_i32$5 = 0;
                 $5 = i64toi32_i32$4 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0 | 0) | 0;
                 $6 = $5 ? $107 : $108;
                 $119 = $6 + -2 | 0;
                 $120 = $6;
                 i64toi32_i32$2 = i64toi32_i32$4;
                 i64toi32_i32$5 = $14;
                 i64toi32_i32$4 = 0;
                 i64toi32_i32$1 = 4;
                 i64toi32_i32$3 = i64toi32_i32$1 & 31 | 0;
                 if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                  i64toi32_i32$4 = i64toi32_i32$5 << i64toi32_i32$3 | 0;
                  $189 = 0;
                 } else {
                  i64toi32_i32$4 = ((1 << i64toi32_i32$3 | 0) - 1 | 0) & (i64toi32_i32$5 >>> (32 - i64toi32_i32$3 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$3 | 0) | 0;
                  $189 = i64toi32_i32$5 << i64toi32_i32$3 | 0;
                 }
                 $122$hi = i64toi32_i32$4;
                 i64toi32_i32$4 = $14$hi;
                 i64toi32_i32$3 = $5;
                 i64toi32_i32$4 = $122$hi;
                 i64toi32_i32$5 = $14$hi;
                 i64toi32_i32$1 = i64toi32_i32$3 ? $189 : $14;
                 i64toi32_i32$2 = i64toi32_i32$3 ? i64toi32_i32$4 : i64toi32_i32$5;
                 $14 = i64toi32_i32$1;
                 $14$hi = i64toi32_i32$2;
                 i64toi32_i32$3 = i64toi32_i32$1;
                 i64toi32_i32$1 = 1073741824;
                 i64toi32_i32$4 = 0;
                 $5 = i64toi32_i32$2 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$3 >>> 0 < i64toi32_i32$4 >>> 0 | 0) | 0;
                 $129 = $5 ? $119 : $120;
                 i64toi32_i32$3 = i64toi32_i32$2;
                 i64toi32_i32$4 = $14;
                 i64toi32_i32$2 = 0;
                 i64toi32_i32$1 = 2;
                 i64toi32_i32$5 = i64toi32_i32$1 & 31 | 0;
                 if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                  i64toi32_i32$2 = i64toi32_i32$4 << i64toi32_i32$5 | 0;
                  $190 = 0;
                 } else {
                  i64toi32_i32$2 = ((1 << i64toi32_i32$5 | 0) - 1 | 0) & (i64toi32_i32$4 >>> (32 - i64toi32_i32$5 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$5 | 0) | 0;
                  $190 = i64toi32_i32$4 << i64toi32_i32$5 | 0;
                 }
                 $131$hi = i64toi32_i32$2;
                 i64toi32_i32$2 = $14$hi;
                 i64toi32_i32$5 = $5;
                 i64toi32_i32$2 = $131$hi;
                 i64toi32_i32$4 = $14$hi;
                 i64toi32_i32$1 = i64toi32_i32$5 ? $190 : $14;
                 i64toi32_i32$3 = i64toi32_i32$5 ? i64toi32_i32$2 : i64toi32_i32$4;
                 $16 = i64toi32_i32$1;
                 $16$hi = i64toi32_i32$3;
                 i64toi32_i32$5 = i64toi32_i32$1;
                 i64toi32_i32$1 = 0;
                 i64toi32_i32$2 = 63;
                 i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
                 if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                  i64toi32_i32$1 = i64toi32_i32$3 >> 31 | 0;
                  $191 = i64toi32_i32$3 >> i64toi32_i32$4 | 0;
                 } else {
                  i64toi32_i32$1 = i64toi32_i32$3 >> i64toi32_i32$4 | 0;
                  $191 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$4 | 0) | 0;
                 }
                 $5 = $129 + ($191 ^ -1 | 0) | 0;
                 $6 = (($74 - $5 | 0) << 16 | 0) >> 16 | 0;
                 if (($6 | 0) < (0 | 0)) {
                  break label$11
                 }
                 $146 = $4;
                 i64toi32_i32$1 = 0;
                 i64toi32_i32$3 = $6;
                 i64toi32_i32$5 = 0;
                 i64toi32_i32$2 = 63;
                 i64toi32_i32$5 = i64toi32_i32$1 & i64toi32_i32$5 | 0;
                 $17 = i64toi32_i32$3 & i64toi32_i32$2 | 0;
                 $17$hi = i64toi32_i32$5;
                 i64toi32_i32$5 = -1;
                 i64toi32_i32$1 = -1;
                 i64toi32_i32$3 = $17$hi;
                 i64toi32_i32$2 = $17;
                 i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
                 if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                  i64toi32_i32$3 = 0;
                  $192 = i64toi32_i32$5 >>> i64toi32_i32$4 | 0;
                 } else {
                  i64toi32_i32$3 = i64toi32_i32$5 >>> i64toi32_i32$4 | 0;
                  $192 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
                 }
                 $14 = $192;
                 $14$hi = i64toi32_i32$3;
                 i64toi32_i32$3 = $15$hi;
                 i64toi32_i32$3 = $14$hi;
                 i64toi32_i32$5 = $14;
                 i64toi32_i32$1 = $15$hi;
                 i64toi32_i32$2 = $15;
                 i64toi32_i32$1 = i64toi32_i32$3 & i64toi32_i32$1 | 0;
                 $154 = i64toi32_i32$5 & i64toi32_i32$2 | 0;
                 i64toi32_i32$5 = $146;
                 HEAP32[(i64toi32_i32$5 + 16 | 0) >> 2] = $154;
                 HEAP32[(i64toi32_i32$5 + 20 | 0) >> 2] = i64toi32_i32$1;
                 i64toi32_i32$1 = $15$hi;
                 i64toi32_i32$1 = i64toi32_i32$3;
                 i64toi32_i32$1 = $15$hi;
                 i64toi32_i32$3 = i64toi32_i32$2;
                 i64toi32_i32$5 = $14$hi;
                 i64toi32_i32$2 = $14;
                 if (i64toi32_i32$1 >>> 0 > i64toi32_i32$5 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$3 >>> 0 > i64toi32_i32$2 >>> 0 | 0) | 0) {
                  break label$12
                 }
                 HEAP16[($4 + 8 | 0) >> 1] = $1;
                 i64toi32_i32$3 = $12$hi;
                 i64toi32_i32$1 = $4;
                 HEAP32[i64toi32_i32$1 >> 2] = $12;
                 HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
                 i64toi32_i32$3 = $14$hi;
                 i64toi32_i32$3 = $12$hi;
                 i64toi32_i32$3 = $14$hi;
                 i64toi32_i32$2 = $14;
                 i64toi32_i32$1 = $12$hi;
                 i64toi32_i32$5 = $12;
                 i64toi32_i32$1 = i64toi32_i32$3 & i64toi32_i32$1 | 0;
                 $165 = i64toi32_i32$2 & i64toi32_i32$5 | 0;
                 i64toi32_i32$2 = $4;
                 HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] = $165;
                 HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] = i64toi32_i32$1;
                 i64toi32_i32$1 = $12$hi;
                 i64toi32_i32$1 = i64toi32_i32$3;
                 i64toi32_i32$1 = $12$hi;
                 i64toi32_i32$3 = i64toi32_i32$5;
                 i64toi32_i32$2 = $14$hi;
                 i64toi32_i32$5 = $14;
                 if (i64toi32_i32$1 >>> 0 > i64toi32_i32$2 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$3 >>> 0 > i64toi32_i32$5 >>> 0 | 0) | 0) {
                  break label$13
                 }
                 $1 = (Math_imul(((-96 - $5 | 0) << 16 | 0) >> 16 | 0, 80) + 86960 | 0 | 0) / (2126 | 0) | 0;
                 if ($1 >>> 0 >= 81 >>> 0) {
                  break label$14
                 }
                 $1 = $1 << 4 | 0;
                 i64toi32_i32$5 = $1 + 1147248 | 0;
                 i64toi32_i32$3 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                 i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                 $14 = i64toi32_i32$3;
                 $14$hi = i64toi32_i32$1;
                 i64toi32_i32$5 = i64toi32_i32$3;
                 i64toi32_i32$3 = 0;
                 i64toi32_i32$2 = -1;
                 i64toi32_i32$3 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
                 $13 = i64toi32_i32$5 & i64toi32_i32$2 | 0;
                 $13$hi = i64toi32_i32$3;
                 $185 = $13;
                 $185$hi = i64toi32_i32$3;
                 i64toi32_i32$3 = $12$hi;
                 i64toi32_i32$3 = $17$hi;
                 i64toi32_i32$3 = $12$hi;
                 i64toi32_i32$1 = $12;
                 i64toi32_i32$5 = $17$hi;
                 i64toi32_i32$2 = $17;
                 i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
                 if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                  i64toi32_i32$5 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
                  $193 = 0;
                 } else {
                  i64toi32_i32$5 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$4 | 0) | 0;
                  $193 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
                 }
                 $12 = $193;
                 $12$hi = i64toi32_i32$5;
                 i64toi32_i32$3 = $12;
                 i64toi32_i32$1 = 0;
                 i64toi32_i32$2 = 32;
                 i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
                 if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                  i64toi32_i32$1 = 0;
                  $194 = i64toi32_i32$5 >>> i64toi32_i32$4 | 0;
                 } else {
                  i64toi32_i32$1 = i64toi32_i32$5 >>> i64toi32_i32$4 | 0;
                  $194 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$4 | 0) | 0;
                 }
                 $18 = $194;
                 $18$hi = i64toi32_i32$1;
                 i64toi32_i32$1 = $185$hi;
                 i64toi32_i32$3 = $18$hi;
                 i64toi32_i32$3 = __wasm_i64_mul($185 | 0, i64toi32_i32$1 | 0, $18 | 0, i64toi32_i32$3 | 0) | 0;
                 i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
                 $19 = i64toi32_i32$3;
                 $19$hi = i64toi32_i32$1;
                 i64toi32_i32$5 = i64toi32_i32$3;
                 i64toi32_i32$3 = 0;
                 i64toi32_i32$2 = 32;
                 i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
                 if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                  i64toi32_i32$3 = 0;
                  $196 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
                 } else {
                  i64toi32_i32$3 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
                  $196 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$4 | 0) | 0;
                 }
                 $20 = $196;
                 $20$hi = i64toi32_i32$3;
                 $195 = $20;
                 $195$hi = i64toi32_i32$3;
                 i64toi32_i32$3 = $14$hi;
                 i64toi32_i32$1 = $14;
                 i64toi32_i32$5 = 0;
                 i64toi32_i32$2 = 32;
                 i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
                 if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                  i64toi32_i32$5 = 0;
                  $197 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
                 } else {
                  i64toi32_i32$5 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
                  $197 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
                 }
                 $21 = $197;
                 $21$hi = i64toi32_i32$5;
                 i64toi32_i32$5 = $18$hi;
                 i64toi32_i32$5 = $21$hi;
                 i64toi32_i32$1 = $18$hi;
                 i64toi32_i32$1 = __wasm_i64_mul($21 | 0, i64toi32_i32$5 | 0, $18 | 0, i64toi32_i32$1 | 0) | 0;
                 i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
                 $200 = i64toi32_i32$1;
                 $200$hi = i64toi32_i32$5;
                 i64toi32_i32$5 = $195$hi;
                 i64toi32_i32$3 = $195;
                 i64toi32_i32$1 = $200$hi;
                 i64toi32_i32$2 = $200;
                 i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
                 i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
                 if (i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0) {
                  i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
                 }
                 $201 = i64toi32_i32$4;
                 $201$hi = i64toi32_i32$0;
                 i64toi32_i32$0 = $21$hi;
                 i64toi32_i32$0 = $12$hi;
                 i64toi32_i32$5 = $12;
                 i64toi32_i32$3 = 0;
                 i64toi32_i32$2 = -1;
                 i64toi32_i32$3 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
                 $12 = i64toi32_i32$5 & i64toi32_i32$2 | 0;
                 $12$hi = i64toi32_i32$3;
                 i64toi32_i32$3 = $21$hi;
                 i64toi32_i32$5 = $12$hi;
                 i64toi32_i32$5 = __wasm_i64_mul($21 | 0, i64toi32_i32$3 | 0, $12 | 0, i64toi32_i32$5 | 0) | 0;
                 i64toi32_i32$3 = i64toi32_i32$HIGH_BITS;
                 $14 = i64toi32_i32$5;
                 $14$hi = i64toi32_i32$3;
                 i64toi32_i32$0 = i64toi32_i32$5;
                 i64toi32_i32$5 = 0;
                 i64toi32_i32$2 = 32;
                 i64toi32_i32$1 = i64toi32_i32$2 & 31 | 0;
                 if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                  i64toi32_i32$5 = 0;
                  $198 = i64toi32_i32$3 >>> i64toi32_i32$1 | 0;
                 } else {
                  i64toi32_i32$5 = i64toi32_i32$3 >>> i64toi32_i32$1 | 0;
                  $198 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$1 | 0) | 0;
                 }
                 $22 = $198;
                 $22$hi = i64toi32_i32$5;
                 i64toi32_i32$5 = $201$hi;
                 i64toi32_i32$3 = $201;
                 i64toi32_i32$0 = $22$hi;
                 i64toi32_i32$2 = $22;
                 i64toi32_i32$1 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
                 i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
                 if (i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0) {
                  i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
                 }
                 $23 = i64toi32_i32$1;
                 $23$hi = i64toi32_i32$4;
                 i64toi32_i32$4 = $19$hi;
                 i64toi32_i32$5 = $19;
                 i64toi32_i32$3 = 0;
                 i64toi32_i32$2 = -1;
                 i64toi32_i32$3 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
                 $212 = i64toi32_i32$5 & i64toi32_i32$2 | 0;
                 $212$hi = i64toi32_i32$3;
                 i64toi32_i32$3 = $13$hi;
                 i64toi32_i32$3 = $12$hi;
                 i64toi32_i32$3 = $13$hi;
                 i64toi32_i32$5 = $12$hi;
                 i64toi32_i32$5 = __wasm_i64_mul($13 | 0, i64toi32_i32$3 | 0, $12 | 0, i64toi32_i32$5 | 0) | 0;
                 i64toi32_i32$3 = i64toi32_i32$HIGH_BITS;
                 i64toi32_i32$4 = i64toi32_i32$5;
                 i64toi32_i32$5 = 0;
                 i64toi32_i32$2 = 32;
                 i64toi32_i32$0 = i64toi32_i32$2 & 31 | 0;
                 if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                  i64toi32_i32$5 = 0;
                  $199 = i64toi32_i32$3 >>> i64toi32_i32$0 | 0;
                 } else {
                  i64toi32_i32$5 = i64toi32_i32$3 >>> i64toi32_i32$0 | 0;
                  $199 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$0 | 0) | 0;
                 }
                 $216$hi = i64toi32_i32$5;
                 i64toi32_i32$5 = $212$hi;
                 i64toi32_i32$3 = $212;
                 i64toi32_i32$4 = $216$hi;
                 i64toi32_i32$2 = $199;
                 i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
                 i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
                 if (i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0) {
                  i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
                 }
                 $217$hi = i64toi32_i32$1;
                 i64toi32_i32$1 = $14$hi;
                 i64toi32_i32$5 = $14;
                 i64toi32_i32$3 = 0;
                 i64toi32_i32$2 = -1;
                 i64toi32_i32$3 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
                 $219 = i64toi32_i32$5 & i64toi32_i32$2 | 0;
                 $219$hi = i64toi32_i32$3;
                 i64toi32_i32$3 = $217$hi;
                 i64toi32_i32$1 = i64toi32_i32$0;
                 i64toi32_i32$5 = $219$hi;
                 i64toi32_i32$2 = $219;
                 i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
                 i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
                 if (i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0) {
                  i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
                 }
                 i64toi32_i32$3 = i64toi32_i32$4;
                 i64toi32_i32$1 = 0;
                 i64toi32_i32$2 = -2147483648;
                 i64toi32_i32$5 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
                 i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
                 if (i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0) {
                  i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
                 }
                 i64toi32_i32$0 = i64toi32_i32$5;
                 i64toi32_i32$3 = 0;
                 i64toi32_i32$2 = 32;
                 i64toi32_i32$1 = i64toi32_i32$2 & 31 | 0;
                 if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                  i64toi32_i32$3 = 0;
                  $202 = i64toi32_i32$4 >>> i64toi32_i32$1 | 0;
                 } else {
                  i64toi32_i32$3 = i64toi32_i32$4 >>> i64toi32_i32$1 | 0;
                  $202 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$1 | 0) | 0;
                 }
                 $24 = $202;
                 $24$hi = i64toi32_i32$3;
                 i64toi32_i32$3 = 0;
                 $14 = (0 - ((HEAPU16[($1 + 1147256 | 0) >> 1] | 0) + $5 | 0) | 0) & 63 | 0;
                 $14$hi = i64toi32_i32$3;
                 i64toi32_i32$3 = 0;
                 i64toi32_i32$4 = 1;
                 i64toi32_i32$0 = $14$hi;
                 i64toi32_i32$2 = $14;
                 i64toi32_i32$1 = i64toi32_i32$2 & 31 | 0;
                 if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                  i64toi32_i32$0 = i64toi32_i32$4 << i64toi32_i32$1 | 0;
                  $203 = 0;
                 } else {
                  i64toi32_i32$0 = ((1 << i64toi32_i32$1 | 0) - 1 | 0) & (i64toi32_i32$4 >>> (32 - i64toi32_i32$1 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$1 | 0) | 0;
                  $203 = i64toi32_i32$4 << i64toi32_i32$1 | 0;
                 }
                 $25 = $203;
                 $25$hi = i64toi32_i32$0;
                 i64toi32_i32$3 = $25;
                 i64toi32_i32$4 = -1;
                 i64toi32_i32$2 = -1;
                 i64toi32_i32$1 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
                 i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
                 if (i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0) {
                  i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
                 }
                 $19 = i64toi32_i32$1;
                 $19$hi = i64toi32_i32$5;
                 i64toi32_i32$5 = $13$hi;
                 $235 = $13;
                 $235$hi = i64toi32_i32$5;
                 i64toi32_i32$5 = $15$hi;
                 i64toi32_i32$5 = $17$hi;
                 i64toi32_i32$5 = $15$hi;
                 i64toi32_i32$0 = $15;
                 i64toi32_i32$3 = $17$hi;
                 i64toi32_i32$2 = $17;
                 i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
                 if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                  i64toi32_i32$3 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
                  $204 = 0;
                 } else {
                  i64toi32_i32$3 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$5 << i64toi32_i32$4 | 0) | 0;
                  $204 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
                 }
                 $12 = $204;
                 $12$hi = i64toi32_i32$3;
                 i64toi32_i32$5 = $12;
                 i64toi32_i32$0 = 0;
                 i64toi32_i32$2 = 32;
                 i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
                 if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                  i64toi32_i32$0 = 0;
                  $205 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
                 } else {
                  i64toi32_i32$0 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
                  $205 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$4 | 0) | 0;
                 }
                 $26 = $205;
                 $26$hi = i64toi32_i32$0;
                 i64toi32_i32$0 = $235$hi;
                 i64toi32_i32$5 = $26$hi;
                 i64toi32_i32$5 = __wasm_i64_mul($235 | 0, i64toi32_i32$0 | 0, $26 | 0, i64toi32_i32$5 | 0) | 0;
                 i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
                 $15 = i64toi32_i32$5;
                 $15$hi = i64toi32_i32$0;
                 i64toi32_i32$3 = i64toi32_i32$5;
                 i64toi32_i32$5 = 0;
                 i64toi32_i32$2 = -1;
                 i64toi32_i32$5 = i64toi32_i32$0 & i64toi32_i32$5 | 0;
                 $244 = i64toi32_i32$3 & i64toi32_i32$2 | 0;
                 $244$hi = i64toi32_i32$5;
                 i64toi32_i32$5 = $13$hi;
                 i64toi32_i32$5 = $12$hi;
                 i64toi32_i32$0 = $12;
                 i64toi32_i32$3 = 0;
                 i64toi32_i32$2 = -1;
                 i64toi32_i32$3 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
                 $12 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
                 $12$hi = i64toi32_i32$3;
                 i64toi32_i32$3 = $13$hi;
                 i64toi32_i32$0 = $12$hi;
                 i64toi32_i32$0 = __wasm_i64_mul($13 | 0, i64toi32_i32$3 | 0, $12 | 0, i64toi32_i32$0 | 0) | 0;
                 i64toi32_i32$3 = i64toi32_i32$HIGH_BITS;
                 i64toi32_i32$5 = i64toi32_i32$0;
                 i64toi32_i32$0 = 0;
                 i64toi32_i32$2 = 32;
                 i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
                 if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                  i64toi32_i32$0 = 0;
                  $206 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
                 } else {
                  i64toi32_i32$0 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
                  $206 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$4 | 0) | 0;
                 }
                 $250$hi = i64toi32_i32$0;
                 i64toi32_i32$0 = $244$hi;
                 i64toi32_i32$3 = $244;
                 i64toi32_i32$5 = $250$hi;
                 i64toi32_i32$2 = $206;
                 i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
                 i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
                 if (i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0) {
                  i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
                 }
                 $251$hi = i64toi32_i32$1;
                 i64toi32_i32$1 = $21$hi;
                 i64toi32_i32$1 = $12$hi;
                 i64toi32_i32$1 = $21$hi;
                 i64toi32_i32$3 = $12$hi;
                 i64toi32_i32$3 = __wasm_i64_mul($21 | 0, i64toi32_i32$1 | 0, $12 | 0, i64toi32_i32$3 | 0) | 0;
                 i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
                 $12 = i64toi32_i32$3;
                 $12$hi = i64toi32_i32$1;
                 i64toi32_i32$0 = i64toi32_i32$3;
                 i64toi32_i32$3 = 0;
                 i64toi32_i32$2 = -1;
                 i64toi32_i32$3 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
                 $256 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
                 $256$hi = i64toi32_i32$3;
                 i64toi32_i32$3 = $251$hi;
                 i64toi32_i32$1 = i64toi32_i32$4;
                 i64toi32_i32$0 = $256$hi;
                 i64toi32_i32$2 = $256;
                 i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
                 i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
                 if (i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0) {
                  i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
                 }
                 i64toi32_i32$3 = i64toi32_i32$5;
                 i64toi32_i32$1 = 0;
                 i64toi32_i32$2 = -2147483648;
                 i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
                 i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
                 if (i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0) {
                  i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
                 }
                 i64toi32_i32$4 = i64toi32_i32$0;
                 i64toi32_i32$3 = 0;
                 i64toi32_i32$2 = 32;
                 i64toi32_i32$1 = i64toi32_i32$2 & 31 | 0;
                 if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                  i64toi32_i32$3 = 0;
                  $207 = i64toi32_i32$5 >>> i64toi32_i32$1 | 0;
                 } else {
                  i64toi32_i32$3 = i64toi32_i32$5 >>> i64toi32_i32$1 | 0;
                  $207 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$1 | 0) | 0;
                 }
                 $27 = $207;
                 $27$hi = i64toi32_i32$3;
                 i64toi32_i32$3 = $21$hi;
                 i64toi32_i32$3 = $26$hi;
                 i64toi32_i32$3 = $21$hi;
                 i64toi32_i32$4 = $26$hi;
                 i64toi32_i32$4 = __wasm_i64_mul($21 | 0, i64toi32_i32$3 | 0, $26 | 0, i64toi32_i32$4 | 0) | 0;
                 i64toi32_i32$3 = i64toi32_i32$HIGH_BITS;
                 $17 = i64toi32_i32$4;
                 $17$hi = i64toi32_i32$3;
                 i64toi32_i32$3 = $12$hi;
                 i64toi32_i32$5 = $12;
                 i64toi32_i32$4 = 0;
                 i64toi32_i32$2 = 32;
                 i64toi32_i32$1 = i64toi32_i32$2 & 31 | 0;
                 if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                  i64toi32_i32$4 = 0;
                  $208 = i64toi32_i32$3 >>> i64toi32_i32$1 | 0;
                 } else {
                  i64toi32_i32$4 = i64toi32_i32$3 >>> i64toi32_i32$1 | 0;
                  $208 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$1 | 0) | 0;
                 }
                 $28 = $208;
                 $28$hi = i64toi32_i32$4;
                 i64toi32_i32$4 = $15$hi;
                 i64toi32_i32$3 = $15;
                 i64toi32_i32$5 = 0;
                 i64toi32_i32$2 = 32;
                 i64toi32_i32$1 = i64toi32_i32$2 & 31 | 0;
                 if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                  i64toi32_i32$5 = 0;
                  $209 = i64toi32_i32$4 >>> i64toi32_i32$1 | 0;
                 } else {
                  i64toi32_i32$5 = i64toi32_i32$4 >>> i64toi32_i32$1 | 0;
                  $209 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$1 | 0) | 0;
                 }
                 $29 = $209;
                 $29$hi = i64toi32_i32$5;
                 $1 = HEAPU16[($1 + 1147258 | 0) >> 1] | 0;
                 label$16 : {
                  label$17 : {
                   label$18 : {
                    label$19 : {
                     i64toi32_i32$5 = $21$hi;
                     $270 = $21;
                     $270$hi = i64toi32_i32$5;
                     i64toi32_i32$5 = $16$hi;
                     $271 = $16;
                     $271$hi = i64toi32_i32$5;
                     i64toi32_i32$4 = $16;
                     i64toi32_i32$3 = -1;
                     i64toi32_i32$2 = -1;
                     i64toi32_i32$3 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
                     i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
                     i64toi32_i32$4 = 0;
                     i64toi32_i32$2 = 63;
                     i64toi32_i32$1 = i64toi32_i32$2 & 31 | 0;
                     if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                      i64toi32_i32$4 = 0;
                      $210 = i64toi32_i32$3 >>> i64toi32_i32$1 | 0;
                     } else {
                      i64toi32_i32$4 = i64toi32_i32$3 >>> i64toi32_i32$1 | 0;
                      $210 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$1 | 0) | 0;
                     }
                     $274$hi = i64toi32_i32$4;
                     i64toi32_i32$4 = $271$hi;
                     i64toi32_i32$3 = $271;
                     i64toi32_i32$5 = $274$hi;
                     i64toi32_i32$2 = $210;
                     i64toi32_i32$1 = i64toi32_i32$2 & 31 | 0;
                     if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                      i64toi32_i32$5 = i64toi32_i32$3 << i64toi32_i32$1 | 0;
                      $211 = 0;
                     } else {
                      i64toi32_i32$5 = ((1 << i64toi32_i32$1 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$1 | 0) | 0) | 0 | (i64toi32_i32$4 << i64toi32_i32$1 | 0) | 0;
                      $211 = i64toi32_i32$3 << i64toi32_i32$1 | 0;
                     }
                     $12 = $211;
                     $12$hi = i64toi32_i32$5;
                     i64toi32_i32$4 = $12;
                     i64toi32_i32$3 = 0;
                     i64toi32_i32$2 = 32;
                     i64toi32_i32$1 = i64toi32_i32$2 & 31 | 0;
                     if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                      i64toi32_i32$3 = 0;
                      $213 = i64toi32_i32$5 >>> i64toi32_i32$1 | 0;
                     } else {
                      i64toi32_i32$3 = i64toi32_i32$5 >>> i64toi32_i32$1 | 0;
                      $213 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$1 | 0) | 0;
                     }
                     $30 = $213;
                     $30$hi = i64toi32_i32$3;
                     i64toi32_i32$3 = $270$hi;
                     i64toi32_i32$4 = $30$hi;
                     i64toi32_i32$4 = __wasm_i64_mul($270 | 0, i64toi32_i32$3 | 0, $30 | 0, i64toi32_i32$4 | 0) | 0;
                     i64toi32_i32$3 = i64toi32_i32$HIGH_BITS;
                     $31 = i64toi32_i32$4;
                     $31$hi = i64toi32_i32$3;
                     $280 = i64toi32_i32$4;
                     $280$hi = i64toi32_i32$3;
                     i64toi32_i32$3 = $13$hi;
                     i64toi32_i32$3 = $30$hi;
                     i64toi32_i32$3 = $13$hi;
                     i64toi32_i32$4 = $30$hi;
                     i64toi32_i32$4 = __wasm_i64_mul($13 | 0, i64toi32_i32$3 | 0, $30 | 0, i64toi32_i32$4 | 0) | 0;
                     i64toi32_i32$3 = i64toi32_i32$HIGH_BITS;
                     $15 = i64toi32_i32$4;
                     $15$hi = i64toi32_i32$3;
                     i64toi32_i32$5 = i64toi32_i32$4;
                     i64toi32_i32$4 = 0;
                     i64toi32_i32$2 = 32;
                     i64toi32_i32$1 = i64toi32_i32$2 & 31 | 0;
                     if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                      i64toi32_i32$4 = 0;
                      $214 = i64toi32_i32$3 >>> i64toi32_i32$1 | 0;
                     } else {
                      i64toi32_i32$4 = i64toi32_i32$3 >>> i64toi32_i32$1 | 0;
                      $214 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$1 | 0) | 0;
                     }
                     $32 = $214;
                     $32$hi = i64toi32_i32$4;
                     i64toi32_i32$4 = $280$hi;
                     i64toi32_i32$3 = $280;
                     i64toi32_i32$5 = $32$hi;
                     i64toi32_i32$2 = $32;
                     i64toi32_i32$1 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
                     i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
                     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0) {
                      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
                     }
                     $287 = i64toi32_i32$1;
                     $287$hi = i64toi32_i32$0;
                     i64toi32_i32$0 = $21$hi;
                     i64toi32_i32$0 = $12$hi;
                     i64toi32_i32$4 = $12;
                     i64toi32_i32$3 = 0;
                     i64toi32_i32$2 = -1;
                     i64toi32_i32$3 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
                     $12 = i64toi32_i32$4 & i64toi32_i32$2 | 0;
                     $12$hi = i64toi32_i32$3;
                     i64toi32_i32$3 = $21$hi;
                     i64toi32_i32$4 = $12$hi;
                     i64toi32_i32$4 = __wasm_i64_mul($21 | 0, i64toi32_i32$3 | 0, $12 | 0, i64toi32_i32$4 | 0) | 0;
                     i64toi32_i32$3 = i64toi32_i32$HIGH_BITS;
                     $16 = i64toi32_i32$4;
                     $16$hi = i64toi32_i32$3;
                     i64toi32_i32$0 = i64toi32_i32$4;
                     i64toi32_i32$4 = 0;
                     i64toi32_i32$2 = 32;
                     i64toi32_i32$5 = i64toi32_i32$2 & 31 | 0;
                     if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                      i64toi32_i32$4 = 0;
                      $215 = i64toi32_i32$3 >>> i64toi32_i32$5 | 0;
                     } else {
                      i64toi32_i32$4 = i64toi32_i32$3 >>> i64toi32_i32$5 | 0;
                      $215 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$5 | 0) | 0;
                     }
                     $33 = $215;
                     $33$hi = i64toi32_i32$4;
                     i64toi32_i32$4 = $287$hi;
                     i64toi32_i32$3 = $287;
                     i64toi32_i32$0 = $33$hi;
                     i64toi32_i32$2 = $33;
                     i64toi32_i32$5 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
                     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
                     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0) {
                      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
                     }
                     $296 = i64toi32_i32$5;
                     $296$hi = i64toi32_i32$1;
                     i64toi32_i32$1 = $15$hi;
                     i64toi32_i32$4 = $15;
                     i64toi32_i32$3 = 0;
                     i64toi32_i32$2 = -1;
                     i64toi32_i32$3 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
                     $298 = i64toi32_i32$4 & i64toi32_i32$2 | 0;
                     $298$hi = i64toi32_i32$3;
                     i64toi32_i32$3 = $13$hi;
                     i64toi32_i32$3 = $12$hi;
                     i64toi32_i32$3 = $13$hi;
                     i64toi32_i32$4 = $12$hi;
                     i64toi32_i32$4 = __wasm_i64_mul($13 | 0, i64toi32_i32$3 | 0, $12 | 0, i64toi32_i32$4 | 0) | 0;
                     i64toi32_i32$3 = i64toi32_i32$HIGH_BITS;
                     i64toi32_i32$1 = i64toi32_i32$4;
                     i64toi32_i32$4 = 0;
                     i64toi32_i32$2 = 32;
                     i64toi32_i32$0 = i64toi32_i32$2 & 31 | 0;
                     if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                      i64toi32_i32$4 = 0;
                      $216 = i64toi32_i32$3 >>> i64toi32_i32$0 | 0;
                     } else {
                      i64toi32_i32$4 = i64toi32_i32$3 >>> i64toi32_i32$0 | 0;
                      $216 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$0 | 0) | 0;
                     }
                     $302$hi = i64toi32_i32$4;
                     i64toi32_i32$4 = $298$hi;
                     i64toi32_i32$3 = $298;
                     i64toi32_i32$1 = $302$hi;
                     i64toi32_i32$2 = $216;
                     i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
                     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
                     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0) {
                      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
                     }
                     $303$hi = i64toi32_i32$5;
                     i64toi32_i32$5 = $16$hi;
                     i64toi32_i32$4 = $16;
                     i64toi32_i32$3 = 0;
                     i64toi32_i32$2 = -1;
                     i64toi32_i32$3 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
                     $305 = i64toi32_i32$4 & i64toi32_i32$2 | 0;
                     $305$hi = i64toi32_i32$3;
                     i64toi32_i32$3 = $303$hi;
                     i64toi32_i32$5 = i64toi32_i32$0;
                     i64toi32_i32$4 = $305$hi;
                     i64toi32_i32$2 = $305;
                     i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
                     i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$4 | 0;
                     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0) {
                      i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
                     }
                     i64toi32_i32$3 = i64toi32_i32$1;
                     i64toi32_i32$5 = 0;
                     i64toi32_i32$2 = -2147483648;
                     i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
                     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
                     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0) {
                      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
                     }
                     i64toi32_i32$0 = i64toi32_i32$4;
                     i64toi32_i32$3 = 0;
                     i64toi32_i32$2 = 32;
                     i64toi32_i32$5 = i64toi32_i32$2 & 31 | 0;
                     if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                      i64toi32_i32$3 = 0;
                      $217 = i64toi32_i32$1 >>> i64toi32_i32$5 | 0;
                     } else {
                      i64toi32_i32$3 = i64toi32_i32$1 >>> i64toi32_i32$5 | 0;
                      $217 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$5 | 0) | 0;
                     }
                     $34 = $217;
                     $34$hi = i64toi32_i32$3;
                     i64toi32_i32$3 = $296$hi;
                     i64toi32_i32$1 = $296;
                     i64toi32_i32$0 = $34$hi;
                     i64toi32_i32$2 = $34;
                     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
                     i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
                     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0) {
                      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
                     }
                     i64toi32_i32$3 = i64toi32_i32$5;
                     i64toi32_i32$1 = 0;
                     i64toi32_i32$2 = 1;
                     i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
                     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
                     if (i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0) {
                      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
                     }
                     $35 = i64toi32_i32$0;
                     $35$hi = i64toi32_i32$5;
                     i64toi32_i32$5 = $14$hi;
                     i64toi32_i32$5 = $35$hi;
                     i64toi32_i32$4 = i64toi32_i32$0;
                     i64toi32_i32$3 = $14$hi;
                     i64toi32_i32$2 = $14;
                     i64toi32_i32$1 = i64toi32_i32$2 & 31 | 0;
                     if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                      i64toi32_i32$3 = 0;
                      $218 = i64toi32_i32$5 >>> i64toi32_i32$1 | 0;
                     } else {
                      i64toi32_i32$3 = i64toi32_i32$5 >>> i64toi32_i32$1 | 0;
                      $218 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$1 | 0) | 0;
                     }
                     $6 = $218;
                     if ($6 >>> 0 < 1e4 >>> 0) {
                      break label$19
                     }
                     if ($6 >>> 0 < 1e6 >>> 0) {
                      break label$18
                     }
                     if ($6 >>> 0 < 1e8 >>> 0) {
                      break label$17
                     }
                     $5 = $6 >>> 0 < 1e9 >>> 0;
                     $7 = $5 ? 8 : 9;
                     $5 = $5 ? 1e8 : 1e9;
                     break label$16;
                    }
                    label$20 : {
                     if ($6 >>> 0 < 100 >>> 0) {
                      break label$20
                     }
                     $5 = $6 >>> 0 < 1e3 >>> 0;
                     $7 = $5 ? 2 : 3;
                     $5 = $5 ? 100 : 1e3;
                     break label$16;
                    }
                    $5 = $6 >>> 0 < 10 >>> 0 ? 1 : 10;
                    $7 = $6 >>> 0 > 9 >>> 0;
                    break label$16;
                   }
                   $5 = $6 >>> 0 < 1e5 >>> 0;
                   $7 = $5 ? 4 : 5;
                   $5 = $5 ? 1e4 : 1e5;
                   break label$16;
                  }
                  $5 = $6 >>> 0 < 1e7 >>> 0;
                  $7 = $5 ? 6 : 7;
                  $5 = $5 ? 1e6 : 1e7;
                 }
                 i64toi32_i32$3 = $23$hi;
                 i64toi32_i32$3 = $24$hi;
                 i64toi32_i32$3 = $23$hi;
                 i64toi32_i32$5 = $23;
                 i64toi32_i32$4 = $24$hi;
                 i64toi32_i32$2 = $24;
                 i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
                 i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$4 | 0;
                 if (i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0) {
                  i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
                 }
                 $23 = i64toi32_i32$1;
                 $23$hi = i64toi32_i32$0;
                 i64toi32_i32$0 = $35$hi;
                 i64toi32_i32$0 = $19$hi;
                 i64toi32_i32$0 = $35$hi;
                 i64toi32_i32$3 = $35;
                 i64toi32_i32$5 = $19$hi;
                 i64toi32_i32$2 = $19;
                 i64toi32_i32$5 = i64toi32_i32$0 & i64toi32_i32$5 | 0;
                 $12 = i64toi32_i32$3 & i64toi32_i32$2 | 0;
                 $12$hi = i64toi32_i32$5;
                 $8 = ($7 - $1 | 0) + 1 | 0;
                 i64toi32_i32$5 = i64toi32_i32$0;
                 $363 = i64toi32_i32$3;
                 $363$hi = i64toi32_i32$5;
                 i64toi32_i32$5 = $17$hi;
                 i64toi32_i32$5 = $29$hi;
                 i64toi32_i32$5 = $17$hi;
                 i64toi32_i32$0 = $17;
                 i64toi32_i32$3 = $29$hi;
                 i64toi32_i32$2 = $29;
                 i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
                 i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
                 if (i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0) {
                  i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
                 }
                 $366$hi = i64toi32_i32$1;
                 i64toi32_i32$1 = $28$hi;
                 i64toi32_i32$1 = $366$hi;
                 i64toi32_i32$5 = i64toi32_i32$4;
                 i64toi32_i32$0 = $28$hi;
                 i64toi32_i32$2 = $28;
                 i64toi32_i32$3 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
                 i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
                 if (i64toi32_i32$3 >>> 0 < i64toi32_i32$2 >>> 0) {
                  i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
                 }
                 $368$hi = i64toi32_i32$4;
                 i64toi32_i32$4 = $27$hi;
                 i64toi32_i32$4 = $368$hi;
                 i64toi32_i32$1 = i64toi32_i32$3;
                 i64toi32_i32$5 = $27$hi;
                 i64toi32_i32$2 = $27;
                 i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
                 i64toi32_i32$3 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
                 if (i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0) {
                  i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
                 }
                 $370$hi = i64toi32_i32$3;
                 i64toi32_i32$3 = $363$hi;
                 i64toi32_i32$4 = $363;
                 i64toi32_i32$1 = $370$hi;
                 i64toi32_i32$2 = i64toi32_i32$0;
                 i64toi32_i32$5 = i64toi32_i32$4 - i64toi32_i32$2 | 0;
                 i64toi32_i32$6 = i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0;
                 i64toi32_i32$0 = i64toi32_i32$6 + i64toi32_i32$1 | 0;
                 i64toi32_i32$0 = i64toi32_i32$3 - i64toi32_i32$0 | 0;
                 i64toi32_i32$3 = i64toi32_i32$5;
                 i64toi32_i32$4 = 0;
                 i64toi32_i32$2 = 1;
                 i64toi32_i32$1 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
                 i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
                 if (i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0) {
                  i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
                 }
                 $16 = i64toi32_i32$1;
                 $16$hi = i64toi32_i32$5;
                 i64toi32_i32$5 = $19$hi;
                 i64toi32_i32$5 = $16$hi;
                 i64toi32_i32$0 = i64toi32_i32$1;
                 i64toi32_i32$3 = $19$hi;
                 i64toi32_i32$2 = $19;
                 i64toi32_i32$3 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
                 $15 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
                 $15$hi = i64toi32_i32$3;
                 $1 = 0;
                 label$21 : while (1) {
                  $9 = ($6 >>> 0) / ($5 >>> 0) | 0;
                  label$22 : {
                   label$23 : {
                    label$24 : {
                     label$25 : {
                      if (($3 | 0) == ($1 | 0)) {
                       break label$25
                      }
                      $10 = $2 + $1 | 0;
                      $11 = $9 + 48 | 0;
                      HEAP8[$10 >> 0] = $11;
                      i64toi32_i32$3 = $16$hi;
                      $389 = $16;
                      $389$hi = i64toi32_i32$3;
                      $6 = $6 - Math_imul($9, $5) | 0;
                      i64toi32_i32$3 = 0;
                      $396$hi = i64toi32_i32$3;
                      i64toi32_i32$3 = $14$hi;
                      i64toi32_i32$3 = $396$hi;
                      i64toi32_i32$5 = $6;
                      i64toi32_i32$0 = $14$hi;
                      i64toi32_i32$2 = $14;
                      i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
                      if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                       i64toi32_i32$0 = i64toi32_i32$5 << i64toi32_i32$4 | 0;
                       $220 = 0;
                      } else {
                       i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$5 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$4 | 0) | 0;
                       $220 = i64toi32_i32$5 << i64toi32_i32$4 | 0;
                      }
                      $17 = $220;
                      $17$hi = i64toi32_i32$0;
                      i64toi32_i32$0 = $12$hi;
                      i64toi32_i32$0 = $17$hi;
                      i64toi32_i32$3 = $17;
                      i64toi32_i32$5 = $12$hi;
                      i64toi32_i32$2 = $12;
                      i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
                      i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
                      if (i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0) {
                       i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
                      }
                      $13 = i64toi32_i32$4;
                      $13$hi = i64toi32_i32$1;
                      i64toi32_i32$1 = $389$hi;
                      i64toi32_i32$0 = $389;
                      i64toi32_i32$3 = $13$hi;
                      i64toi32_i32$2 = i64toi32_i32$4;
                      if (i64toi32_i32$1 >>> 0 > i64toi32_i32$3 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$0 >>> 0 > i64toi32_i32$2 >>> 0 | 0) | 0) {
                       break label$4
                      }
                      if (($7 | 0) != ($1 | 0)) {
                       break label$22
                      }
                      $9 = $1 >>> 0 < $3 >>> 0 ? $3 : $1 + 1 | 0;
                      $6 = $9 + -1 | 0;
                      i64toi32_i32$0 = 0;
                      $13 = 1;
                      $13$hi = i64toi32_i32$0;
                      label$26 : while (1) {
                       i64toi32_i32$0 = $13$hi;
                       $16 = $13;
                       $16$hi = i64toi32_i32$0;
                       i64toi32_i32$0 = $15$hi;
                       $17 = $15;
                       $17$hi = i64toi32_i32$0;
                       if (($6 | 0) == ($1 | 0)) {
                        break label$24
                       }
                       i64toi32_i32$0 = $16$hi;
                       i64toi32_i32$1 = 0;
                       i64toi32_i32$1 = __wasm_i64_mul($16 | 0, i64toi32_i32$0 | 0, 10 | 0, i64toi32_i32$1 | 0) | 0;
                       i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
                       $13 = i64toi32_i32$1;
                       $13$hi = i64toi32_i32$0;
                       $426 = ($2 + $1 | 0) + 1 | 0;
                       i64toi32_i32$0 = $12$hi;
                       i64toi32_i32$1 = 0;
                       i64toi32_i32$1 = __wasm_i64_mul($12 | 0, i64toi32_i32$0 | 0, 10 | 0, i64toi32_i32$1 | 0) | 0;
                       i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
                       $12 = i64toi32_i32$1;
                       $12$hi = i64toi32_i32$0;
                       i64toi32_i32$0 = $14$hi;
                       i64toi32_i32$0 = $12$hi;
                       i64toi32_i32$2 = i64toi32_i32$1;
                       i64toi32_i32$1 = $14$hi;
                       i64toi32_i32$3 = $14;
                       i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
                       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                        i64toi32_i32$1 = 0;
                        $221 = i64toi32_i32$0 >>> i64toi32_i32$5 | 0;
                       } else {
                        i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$5 | 0;
                        $221 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$5 | 0) | 0;
                       }
                       $5 = $221 + 48 | 0;
                       HEAP8[$426 >> 0] = $5;
                       $1 = $1 + 1 | 0;
                       i64toi32_i32$1 = $17$hi;
                       i64toi32_i32$2 = 0;
                       i64toi32_i32$2 = __wasm_i64_mul($17 | 0, i64toi32_i32$1 | 0, 10 | 0, i64toi32_i32$2 | 0) | 0;
                       i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
                       $15 = i64toi32_i32$2;
                       $15$hi = i64toi32_i32$1;
                       i64toi32_i32$1 = $12$hi;
                       i64toi32_i32$1 = $19$hi;
                       i64toi32_i32$1 = $12$hi;
                       i64toi32_i32$0 = $12;
                       i64toi32_i32$2 = $19$hi;
                       i64toi32_i32$3 = $19;
                       i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
                       $12 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
                       $12$hi = i64toi32_i32$2;
                       i64toi32_i32$2 = $15$hi;
                       i64toi32_i32$1 = $15;
                       i64toi32_i32$0 = $12$hi;
                       i64toi32_i32$3 = $12;
                       if (i64toi32_i32$2 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$1 >>> 0 <= i64toi32_i32$3 >>> 0 | 0) | 0) {
                        continue label$26
                       }
                       break label$26;
                      };
                      $9 = $1 + 1 | 0;
                      if ($1 >>> 0 >= $3 >>> 0) {
                       break label$23
                      }
                      i64toi32_i32$1 = $15$hi;
                      i64toi32_i32$1 = $12$hi;
                      i64toi32_i32$1 = $15$hi;
                      i64toi32_i32$3 = $15;
                      i64toi32_i32$2 = $12$hi;
                      i64toi32_i32$0 = $12;
                      i64toi32_i32$5 = i64toi32_i32$3 - i64toi32_i32$0 | 0;
                      i64toi32_i32$6 = i64toi32_i32$3 >>> 0 < i64toi32_i32$0 >>> 0;
                      i64toi32_i32$4 = i64toi32_i32$6 + i64toi32_i32$2 | 0;
                      i64toi32_i32$4 = i64toi32_i32$1 - i64toi32_i32$4 | 0;
                      $14 = i64toi32_i32$5;
                      $14$hi = i64toi32_i32$4;
                      i64toi32_i32$4 = $25$hi;
                      i64toi32_i32$4 = $14$hi;
                      i64toi32_i32$1 = i64toi32_i32$5;
                      i64toi32_i32$3 = $25$hi;
                      i64toi32_i32$0 = $25;
                      $6 = i64toi32_i32$4 >>> 0 > i64toi32_i32$3 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$1 >>> 0 >= i64toi32_i32$0 >>> 0 | 0) | 0;
                      i64toi32_i32$1 = $13$hi;
                      i64toi32_i32$1 = $35$hi;
                      i64toi32_i32$1 = $23$hi;
                      i64toi32_i32$1 = $35$hi;
                      i64toi32_i32$0 = $35;
                      i64toi32_i32$4 = $23$hi;
                      i64toi32_i32$3 = $23;
                      i64toi32_i32$2 = i64toi32_i32$0 - i64toi32_i32$3 | 0;
                      i64toi32_i32$6 = i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0;
                      i64toi32_i32$5 = i64toi32_i32$6 + i64toi32_i32$4 | 0;
                      i64toi32_i32$5 = i64toi32_i32$1 - i64toi32_i32$5 | 0;
                      $459$hi = i64toi32_i32$5;
                      i64toi32_i32$5 = $13$hi;
                      i64toi32_i32$0 = $459$hi;
                      i64toi32_i32$0 = __wasm_i64_mul($13 | 0, i64toi32_i32$5 | 0, i64toi32_i32$2 | 0, i64toi32_i32$0 | 0) | 0;
                      i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
                      $19 = i64toi32_i32$0;
                      $19$hi = i64toi32_i32$5;
                      i64toi32_i32$5 = $13$hi;
                      i64toi32_i32$5 = $19$hi;
                      i64toi32_i32$1 = i64toi32_i32$0;
                      i64toi32_i32$0 = $13$hi;
                      i64toi32_i32$3 = $13;
                      i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
                      i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
                      if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
                       i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
                      }
                      $23 = i64toi32_i32$4;
                      $23$hi = i64toi32_i32$2;
                      i64toi32_i32$2 = $14$hi;
                      i64toi32_i32$2 = $25$hi;
                      i64toi32_i32$2 = $14$hi;
                      i64toi32_i32$5 = $14;
                      i64toi32_i32$1 = $25$hi;
                      i64toi32_i32$3 = $25;
                      if (i64toi32_i32$2 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0) {
                       break label$3
                      }
                      i64toi32_i32$5 = $19$hi;
                      i64toi32_i32$5 = $13$hi;
                      i64toi32_i32$5 = $19$hi;
                      i64toi32_i32$3 = $19;
                      i64toi32_i32$2 = $13$hi;
                      i64toi32_i32$1 = $13;
                      i64toi32_i32$0 = i64toi32_i32$3 - i64toi32_i32$1 | 0;
                      i64toi32_i32$6 = i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0;
                      i64toi32_i32$4 = i64toi32_i32$6 + i64toi32_i32$2 | 0;
                      i64toi32_i32$4 = i64toi32_i32$5 - i64toi32_i32$4 | 0;
                      $19 = i64toi32_i32$0;
                      $19$hi = i64toi32_i32$4;
                      i64toi32_i32$4 = $12$hi;
                      i64toi32_i32$4 = $19$hi;
                      i64toi32_i32$5 = i64toi32_i32$0;
                      i64toi32_i32$3 = $12$hi;
                      i64toi32_i32$1 = $12;
                      if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$5 >>> 0 <= i64toi32_i32$1 >>> 0 | 0) | 0) {
                       break label$3
                      }
                      $1 = $2 + $1 | 0;
                      i64toi32_i32$5 = $17$hi;
                      i64toi32_i32$4 = 0;
                      i64toi32_i32$4 = __wasm_i64_mul($17 | 0, i64toi32_i32$5 | 0, 10 | 0, i64toi32_i32$4 | 0) | 0;
                      i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
                      $477 = i64toi32_i32$4;
                      $477$hi = i64toi32_i32$5;
                      i64toi32_i32$5 = $25$hi;
                      i64toi32_i32$5 = $12$hi;
                      i64toi32_i32$5 = $25$hi;
                      i64toi32_i32$1 = $25;
                      i64toi32_i32$4 = $12$hi;
                      i64toi32_i32$3 = $12;
                      i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
                      i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
                      if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
                       i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
                      }
                      $480$hi = i64toi32_i32$0;
                      i64toi32_i32$0 = $477$hi;
                      i64toi32_i32$5 = $477;
                      i64toi32_i32$1 = $480$hi;
                      i64toi32_i32$3 = i64toi32_i32$2;
                      i64toi32_i32$4 = i64toi32_i32$5 - i64toi32_i32$3 | 0;
                      i64toi32_i32$6 = i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0;
                      i64toi32_i32$2 = i64toi32_i32$6 + i64toi32_i32$1 | 0;
                      i64toi32_i32$2 = i64toi32_i32$0 - i64toi32_i32$2 | 0;
                      $21 = i64toi32_i32$4;
                      $21$hi = i64toi32_i32$2;
                      i64toi32_i32$2 = $25$hi;
                      i64toi32_i32$2 = $19$hi;
                      i64toi32_i32$2 = $25$hi;
                      i64toi32_i32$0 = $25;
                      i64toi32_i32$5 = $19$hi;
                      i64toi32_i32$3 = $19;
                      i64toi32_i32$1 = i64toi32_i32$0 - i64toi32_i32$3 | 0;
                      i64toi32_i32$6 = i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0;
                      i64toi32_i32$4 = i64toi32_i32$6 + i64toi32_i32$5 | 0;
                      i64toi32_i32$4 = i64toi32_i32$2 - i64toi32_i32$4 | 0;
                      $35 = i64toi32_i32$1;
                      $35$hi = i64toi32_i32$4;
                      i64toi32_i32$4 = i64toi32_i32$5;
                      i64toi32_i32$4 = $12$hi;
                      i64toi32_i32$4 = i64toi32_i32$5;
                      i64toi32_i32$2 = i64toi32_i32$3;
                      i64toi32_i32$0 = $12$hi;
                      i64toi32_i32$3 = $12;
                      i64toi32_i32$5 = i64toi32_i32$2 - i64toi32_i32$3 | 0;
                      i64toi32_i32$6 = i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0;
                      i64toi32_i32$1 = i64toi32_i32$6 + i64toi32_i32$0 | 0;
                      i64toi32_i32$1 = i64toi32_i32$4 - i64toi32_i32$1 | 0;
                      $30 = i64toi32_i32$5;
                      $30$hi = i64toi32_i32$1;
                      i64toi32_i32$1 = 0;
                      $14 = 0;
                      $14$hi = i64toi32_i32$1;
                      label$27 : while (1) {
                       label$28 : {
                        i64toi32_i32$1 = $12$hi;
                        i64toi32_i32$1 = $25$hi;
                        i64toi32_i32$1 = $12$hi;
                        i64toi32_i32$4 = $12;
                        i64toi32_i32$2 = $25$hi;
                        i64toi32_i32$3 = $25;
                        i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
                        i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
                        if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
                         i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
                        }
                        $13 = i64toi32_i32$0;
                        $13$hi = i64toi32_i32$5;
                        i64toi32_i32$5 = $19$hi;
                        i64toi32_i32$5 = $13$hi;
                        i64toi32_i32$1 = i64toi32_i32$0;
                        i64toi32_i32$4 = $19$hi;
                        i64toi32_i32$3 = $19;
                        if (i64toi32_i32$5 >>> 0 < i64toi32_i32$4 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$4 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0) {
                         break label$28
                        }
                        i64toi32_i32$1 = $30$hi;
                        i64toi32_i32$1 = $14$hi;
                        i64toi32_i32$1 = $30$hi;
                        i64toi32_i32$3 = $30;
                        i64toi32_i32$5 = $14$hi;
                        i64toi32_i32$4 = $14;
                        i64toi32_i32$2 = i64toi32_i32$3 + i64toi32_i32$4 | 0;
                        i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
                        if (i64toi32_i32$2 >>> 0 < i64toi32_i32$4 >>> 0) {
                         i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
                        }
                        $496 = i64toi32_i32$2;
                        $496$hi = i64toi32_i32$0;
                        i64toi32_i32$0 = $35$hi;
                        i64toi32_i32$0 = $12$hi;
                        i64toi32_i32$0 = $35$hi;
                        i64toi32_i32$1 = $35;
                        i64toi32_i32$3 = $12$hi;
                        i64toi32_i32$4 = $12;
                        i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
                        i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
                        if (i64toi32_i32$5 >>> 0 < i64toi32_i32$4 >>> 0) {
                         i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
                        }
                        $499$hi = i64toi32_i32$2;
                        i64toi32_i32$2 = $496$hi;
                        i64toi32_i32$0 = $496;
                        i64toi32_i32$1 = $499$hi;
                        i64toi32_i32$4 = i64toi32_i32$5;
                        if (i64toi32_i32$2 >>> 0 > i64toi32_i32$1 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$0 >>> 0 >= i64toi32_i32$5 >>> 0 | 0) | 0) {
                         break label$28
                        }
                        $6 = 1;
                        break label$3;
                       }
                       $5 = $5 + -1 | 0;
                       HEAP8[$1 >> 0] = $5;
                       i64toi32_i32$0 = $21$hi;
                       i64toi32_i32$0 = $14$hi;
                       i64toi32_i32$0 = $21$hi;
                       i64toi32_i32$4 = $21;
                       i64toi32_i32$2 = $14$hi;
                       i64toi32_i32$1 = $14;
                       i64toi32_i32$3 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
                       i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
                       if (i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0) {
                        i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
                       }
                       $17 = i64toi32_i32$3;
                       $17$hi = i64toi32_i32$5;
                       i64toi32_i32$5 = $25$hi;
                       i64toi32_i32$5 = $17$hi;
                       i64toi32_i32$0 = i64toi32_i32$3;
                       i64toi32_i32$4 = $25$hi;
                       i64toi32_i32$1 = $25;
                       $6 = i64toi32_i32$5 >>> 0 > i64toi32_i32$4 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$4 | 0) & i64toi32_i32$3 >>> 0 >= i64toi32_i32$1 >>> 0 | 0) | 0;
                       i64toi32_i32$0 = $13$hi;
                       i64toi32_i32$0 = $19$hi;
                       i64toi32_i32$0 = $13$hi;
                       i64toi32_i32$1 = $13;
                       i64toi32_i32$5 = $19$hi;
                       i64toi32_i32$4 = $19;
                       if (i64toi32_i32$0 >>> 0 > i64toi32_i32$5 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$1 >>> 0 >= i64toi32_i32$4 >>> 0 | 0) | 0) {
                        break label$2
                       }
                       i64toi32_i32$1 = $14$hi;
                       i64toi32_i32$1 = $25$hi;
                       i64toi32_i32$1 = $14$hi;
                       i64toi32_i32$4 = $14;
                       i64toi32_i32$0 = $25$hi;
                       i64toi32_i32$5 = $25;
                       i64toi32_i32$2 = i64toi32_i32$4 - i64toi32_i32$5 | 0;
                       i64toi32_i32$6 = i64toi32_i32$4 >>> 0 < i64toi32_i32$5 >>> 0;
                       i64toi32_i32$3 = i64toi32_i32$6 + i64toi32_i32$0 | 0;
                       i64toi32_i32$3 = i64toi32_i32$1 - i64toi32_i32$3 | 0;
                       $14 = i64toi32_i32$2;
                       $14$hi = i64toi32_i32$3;
                       i64toi32_i32$3 = $13$hi;
                       $12 = $13;
                       $12$hi = i64toi32_i32$3;
                       i64toi32_i32$3 = $17$hi;
                       i64toi32_i32$3 = i64toi32_i32$0;
                       i64toi32_i32$3 = $17$hi;
                       i64toi32_i32$1 = $17;
                       i64toi32_i32$4 = i64toi32_i32$0;
                       if (i64toi32_i32$3 >>> 0 > i64toi32_i32$4 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$4 | 0) & i64toi32_i32$1 >>> 0 >= i64toi32_i32$5 >>> 0 | 0) | 0) {
                        continue label$27
                       }
                       break label$2;
                      };
                     }
                     core__panicking__panic_bounds_check__h808b524af17640b1($3 | 0, $3 | 0, 1148812 | 0);
                     abort();
                    }
                    core__panicking__panic_bounds_check__h808b524af17640b1($9 | 0, $3 | 0, 1148844 | 0);
                    abort();
                   }
                   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($9 | 0, $3 | 0, 1148860 | 0);
                   abort();
                  }
                  $1 = $1 + 1 | 0;
                  $9 = $5 >>> 0 < 10 >>> 0;
                  $5 = ($5 >>> 0) / (10 >>> 0) | 0;
                  if (!$9) {
                   continue label$21
                  }
                  break label$21;
                 };
                 core__panicking__panic__h2fd385a887c8bf13(1148784 | 0, 25 | 0, 1148768 | 0);
                 abort();
                }
                core__panicking__panic__h2fd385a887c8bf13(1148704 | 0, 45 | 0, 1148752 | 0);
                abort();
               }
               core__panicking__panic_bounds_check__h808b524af17640b1($1 | 0, 81 | 0, 1148592 | 0);
               abort();
              }
              HEAP32[($4 + 24 | 0) >> 2] = 0;
              core__panicking__assert_failed__h6f270dd8420cd02c($4 + 16 | 0 | 0, $4 | 0, $4 + 24 | 0 | 0);
              abort();
             }
             HEAP32[($4 + 24 | 0) >> 2] = 0;
             core__panicking__assert_failed__h6f270dd8420cd02c($4 + 16 | 0 | 0, $4 | 0, $4 + 24 | 0 | 0);
             abort();
            }
            core__panicking__panic__h2fd385a887c8bf13(1146240 | 0, 29 | 0, 1146304 | 0);
            abort();
           }
           core__panicking__panic__h2fd385a887c8bf13(1146960 | 0, 45 | 0, 1148688 | 0);
           abort();
          }
          core__panicking__panic__h2fd385a887c8bf13(1146888 | 0, 55 | 0, 1148672 | 0);
          abort();
         }
         core__panicking__panic__h2fd385a887c8bf13(1146816 | 0, 54 | 0, 1148656 | 0);
         abort();
        }
        core__panicking__panic__h2fd385a887c8bf13(1146772 | 0, 28 | 0, 1148640 | 0);
        abort();
       }
       core__panicking__panic__h2fd385a887c8bf13(1146724 | 0, 29 | 0, 1148624 | 0);
       abort();
      }
      core__panicking__panic__h2fd385a887c8bf13(1146679 | 0, 28 | 0, 1148608 | 0);
      abort();
     }
     $6 = $1 + 1 | 0;
     label$29 : {
      label$30 : {
       label$31 : {
        if ($1 >>> 0 >= $3 >>> 0) {
         break label$31
        }
        i64toi32_i32$1 = $16$hi;
        i64toi32_i32$1 = $13$hi;
        i64toi32_i32$1 = $16$hi;
        i64toi32_i32$5 = $16;
        i64toi32_i32$3 = $13$hi;
        i64toi32_i32$4 = $13;
        i64toi32_i32$0 = i64toi32_i32$5 - i64toi32_i32$4 | 0;
        i64toi32_i32$6 = i64toi32_i32$5 >>> 0 < i64toi32_i32$4 >>> 0;
        i64toi32_i32$2 = i64toi32_i32$6 + i64toi32_i32$3 | 0;
        i64toi32_i32$2 = i64toi32_i32$1 - i64toi32_i32$2 | 0;
        $25 = i64toi32_i32$0;
        $25$hi = i64toi32_i32$2;
        $556 = i64toi32_i32$0;
        $556$hi = i64toi32_i32$2;
        i64toi32_i32$2 = 0;
        $558$hi = i64toi32_i32$2;
        i64toi32_i32$2 = $14$hi;
        i64toi32_i32$2 = $558$hi;
        i64toi32_i32$1 = $5;
        i64toi32_i32$5 = $14$hi;
        i64toi32_i32$4 = $14;
        i64toi32_i32$3 = i64toi32_i32$4 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$4 & 63 | 0) >>> 0) {
         i64toi32_i32$5 = i64toi32_i32$1 << i64toi32_i32$3 | 0;
         $222 = 0;
        } else {
         i64toi32_i32$5 = ((1 << i64toi32_i32$3 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$3 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$3 | 0) | 0;
         $222 = i64toi32_i32$1 << i64toi32_i32$3 | 0;
        }
        $14 = $222;
        $14$hi = i64toi32_i32$5;
        i64toi32_i32$5 = $556$hi;
        i64toi32_i32$2 = $556;
        i64toi32_i32$1 = $14$hi;
        i64toi32_i32$4 = $14;
        $1 = i64toi32_i32$5 >>> 0 > i64toi32_i32$1 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$2 >>> 0 >= i64toi32_i32$4 >>> 0 | 0) | 0;
        i64toi32_i32$2 = $35$hi;
        i64toi32_i32$2 = $23$hi;
        i64toi32_i32$2 = $35$hi;
        i64toi32_i32$4 = $35;
        i64toi32_i32$5 = $23$hi;
        i64toi32_i32$1 = $23;
        i64toi32_i32$3 = i64toi32_i32$4 - i64toi32_i32$1 | 0;
        i64toi32_i32$6 = i64toi32_i32$4 >>> 0 < i64toi32_i32$1 >>> 0;
        i64toi32_i32$0 = i64toi32_i32$6 + i64toi32_i32$5 | 0;
        i64toi32_i32$0 = i64toi32_i32$2 - i64toi32_i32$0 | 0;
        $15 = i64toi32_i32$3;
        $15$hi = i64toi32_i32$0;
        i64toi32_i32$2 = i64toi32_i32$3;
        i64toi32_i32$4 = 0;
        i64toi32_i32$1 = 1;
        i64toi32_i32$5 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
        i64toi32_i32$3 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
        if (i64toi32_i32$5 >>> 0 < i64toi32_i32$1 >>> 0) {
         i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
        }
        $36 = i64toi32_i32$5;
        $36$hi = i64toi32_i32$3;
        i64toi32_i32$3 = $15$hi;
        i64toi32_i32$0 = $15;
        i64toi32_i32$2 = -1;
        i64toi32_i32$1 = -1;
        i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
        i64toi32_i32$5 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
        if (i64toi32_i32$4 >>> 0 < i64toi32_i32$1 >>> 0) {
         i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
        }
        $19 = i64toi32_i32$4;
        $19$hi = i64toi32_i32$5;
        i64toi32_i32$5 = $13$hi;
        i64toi32_i32$5 = $19$hi;
        i64toi32_i32$3 = i64toi32_i32$4;
        i64toi32_i32$0 = $13$hi;
        i64toi32_i32$1 = $13;
        if (i64toi32_i32$5 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$3 >>> 0 <= i64toi32_i32$1 >>> 0 | 0) | 0) {
         break label$30
        }
        i64toi32_i32$3 = $25$hi;
        i64toi32_i32$3 = $14$hi;
        i64toi32_i32$3 = $25$hi;
        i64toi32_i32$1 = $25;
        i64toi32_i32$5 = $14$hi;
        i64toi32_i32$0 = $14;
        if (i64toi32_i32$3 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$0 >>> 0 | 0) | 0) {
         break label$30
        }
        i64toi32_i32$1 = $33$hi;
        i64toi32_i32$1 = $32$hi;
        i64toi32_i32$1 = $33$hi;
        i64toi32_i32$0 = $33;
        i64toi32_i32$3 = $32$hi;
        i64toi32_i32$5 = $32;
        i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
        i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
        if (i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0) {
         i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
        }
        $578$hi = i64toi32_i32$4;
        i64toi32_i32$4 = $34$hi;
        i64toi32_i32$4 = $578$hi;
        i64toi32_i32$1 = i64toi32_i32$2;
        i64toi32_i32$0 = $34$hi;
        i64toi32_i32$5 = $34;
        i64toi32_i32$3 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
        i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
        if (i64toi32_i32$3 >>> 0 < i64toi32_i32$5 >>> 0) {
         i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
        }
        $15 = i64toi32_i32$3;
        $15$hi = i64toi32_i32$2;
        i64toi32_i32$2 = $31$hi;
        i64toi32_i32$2 = $15$hi;
        i64toi32_i32$4 = i64toi32_i32$3;
        i64toi32_i32$1 = $31$hi;
        i64toi32_i32$5 = $31;
        i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
        i64toi32_i32$3 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
        if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
         i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
        }
        $583$hi = i64toi32_i32$3;
        i64toi32_i32$3 = $23$hi;
        i64toi32_i32$3 = $583$hi;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$4 = $23$hi;
        i64toi32_i32$5 = $23;
        i64toi32_i32$1 = i64toi32_i32$2 - i64toi32_i32$5 | 0;
        i64toi32_i32$6 = i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0;
        i64toi32_i32$0 = i64toi32_i32$6 + i64toi32_i32$4 | 0;
        i64toi32_i32$0 = i64toi32_i32$3 - i64toi32_i32$0 | 0;
        $585 = i64toi32_i32$1;
        $585$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $17$hi;
        i64toi32_i32$0 = $12$hi;
        i64toi32_i32$0 = $17$hi;
        i64toi32_i32$3 = $17;
        i64toi32_i32$2 = $12$hi;
        i64toi32_i32$5 = $12;
        i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
        i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
        if (i64toi32_i32$4 >>> 0 < i64toi32_i32$5 >>> 0) {
         i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
        }
        $588$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $585$hi;
        i64toi32_i32$0 = $585;
        i64toi32_i32$3 = $588$hi;
        i64toi32_i32$5 = i64toi32_i32$4;
        i64toi32_i32$2 = i64toi32_i32$0 - i64toi32_i32$5 | 0;
        i64toi32_i32$6 = i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0;
        i64toi32_i32$4 = i64toi32_i32$6 + i64toi32_i32$3 | 0;
        i64toi32_i32$4 = i64toi32_i32$1 - i64toi32_i32$4 | 0;
        $23 = i64toi32_i32$2;
        $23$hi = i64toi32_i32$4;
        i64toi32_i32$4 = $15$hi;
        i64toi32_i32$4 = $21$hi;
        i64toi32_i32$4 = $30$hi;
        i64toi32_i32$4 = $26$hi;
        i64toi32_i32$4 = $30$hi;
        i64toi32_i32$1 = $30;
        i64toi32_i32$0 = $26$hi;
        i64toi32_i32$5 = $26;
        i64toi32_i32$3 = i64toi32_i32$1 - i64toi32_i32$5 | 0;
        i64toi32_i32$6 = i64toi32_i32$1 >>> 0 < i64toi32_i32$5 >>> 0;
        i64toi32_i32$2 = i64toi32_i32$6 + i64toi32_i32$0 | 0;
        i64toi32_i32$2 = i64toi32_i32$4 - i64toi32_i32$2 | 0;
        $594$hi = i64toi32_i32$2;
        i64toi32_i32$2 = $21$hi;
        i64toi32_i32$1 = $594$hi;
        i64toi32_i32$1 = __wasm_i64_mul($21 | 0, i64toi32_i32$2 | 0, i64toi32_i32$3 | 0, i64toi32_i32$1 | 0) | 0;
        i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
        $595 = i64toi32_i32$1;
        $595$hi = i64toi32_i32$2;
        i64toi32_i32$2 = $15$hi;
        i64toi32_i32$4 = $15;
        i64toi32_i32$1 = $595$hi;
        i64toi32_i32$5 = $595;
        i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
        i64toi32_i32$3 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
        if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
         i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
        }
        $596$hi = i64toi32_i32$3;
        i64toi32_i32$3 = $28$hi;
        i64toi32_i32$3 = $596$hi;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$4 = $28$hi;
        i64toi32_i32$5 = $28;
        i64toi32_i32$1 = i64toi32_i32$2 - i64toi32_i32$5 | 0;
        i64toi32_i32$6 = i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0;
        i64toi32_i32$0 = i64toi32_i32$6 + i64toi32_i32$4 | 0;
        i64toi32_i32$0 = i64toi32_i32$3 - i64toi32_i32$0 | 0;
        $598$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $29$hi;
        i64toi32_i32$0 = $598$hi;
        i64toi32_i32$3 = i64toi32_i32$1;
        i64toi32_i32$2 = $29$hi;
        i64toi32_i32$5 = $29;
        i64toi32_i32$4 = i64toi32_i32$3 - i64toi32_i32$5 | 0;
        i64toi32_i32$6 = i64toi32_i32$3 >>> 0 < i64toi32_i32$5 >>> 0;
        i64toi32_i32$1 = i64toi32_i32$6 + i64toi32_i32$2 | 0;
        i64toi32_i32$1 = i64toi32_i32$0 - i64toi32_i32$1 | 0;
        $600$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $27$hi;
        i64toi32_i32$1 = $600$hi;
        i64toi32_i32$0 = i64toi32_i32$4;
        i64toi32_i32$3 = $27$hi;
        i64toi32_i32$5 = $27;
        i64toi32_i32$2 = i64toi32_i32$4 - i64toi32_i32$5 | 0;
        i64toi32_i32$6 = i64toi32_i32$4 >>> 0 < i64toi32_i32$5 >>> 0;
        i64toi32_i32$4 = i64toi32_i32$6 + i64toi32_i32$3 | 0;
        i64toi32_i32$4 = i64toi32_i32$1 - i64toi32_i32$4 | 0;
        $602 = i64toi32_i32$2;
        $602$hi = i64toi32_i32$4;
        i64toi32_i32$4 = $12$hi;
        i64toi32_i32$4 = $14$hi;
        i64toi32_i32$4 = $12$hi;
        i64toi32_i32$1 = $12;
        i64toi32_i32$0 = $14$hi;
        i64toi32_i32$5 = $14;
        i64toi32_i32$3 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
        i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
        if (i64toi32_i32$3 >>> 0 < i64toi32_i32$5 >>> 0) {
         i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
        }
        $12 = i64toi32_i32$3;
        $12$hi = i64toi32_i32$2;
        i64toi32_i32$2 = $17$hi;
        i64toi32_i32$2 = $12$hi;
        i64toi32_i32$4 = i64toi32_i32$3;
        i64toi32_i32$1 = $17$hi;
        i64toi32_i32$5 = $17;
        i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
        i64toi32_i32$3 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
        if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
         i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
        }
        $608$hi = i64toi32_i32$3;
        i64toi32_i32$3 = $602$hi;
        i64toi32_i32$2 = $602;
        i64toi32_i32$4 = $608$hi;
        i64toi32_i32$5 = i64toi32_i32$0;
        i64toi32_i32$1 = i64toi32_i32$2 - i64toi32_i32$5 | 0;
        i64toi32_i32$6 = i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0;
        i64toi32_i32$0 = i64toi32_i32$6 + i64toi32_i32$4 | 0;
        i64toi32_i32$0 = i64toi32_i32$3 - i64toi32_i32$0 | 0;
        i64toi32_i32$3 = i64toi32_i32$1;
        i64toi32_i32$2 = 0;
        i64toi32_i32$5 = 2;
        i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
        i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
        if (i64toi32_i32$4 >>> 0 < i64toi32_i32$5 >>> 0) {
         i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
        }
        $35 = i64toi32_i32$4;
        $35$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $12$hi;
        i64toi32_i32$1 = $20$hi;
        i64toi32_i32$1 = $12$hi;
        i64toi32_i32$0 = $12;
        i64toi32_i32$3 = $20$hi;
        i64toi32_i32$5 = $20;
        i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
        i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
        if (i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0) {
         i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
        }
        $613$hi = i64toi32_i32$4;
        i64toi32_i32$4 = $22$hi;
        i64toi32_i32$4 = $613$hi;
        i64toi32_i32$1 = i64toi32_i32$2;
        i64toi32_i32$0 = $22$hi;
        i64toi32_i32$5 = $22;
        i64toi32_i32$3 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
        i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
        if (i64toi32_i32$3 >>> 0 < i64toi32_i32$5 >>> 0) {
         i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
        }
        $615$hi = i64toi32_i32$2;
        i64toi32_i32$2 = $24$hi;
        i64toi32_i32$2 = $615$hi;
        i64toi32_i32$4 = i64toi32_i32$3;
        i64toi32_i32$1 = $24$hi;
        i64toi32_i32$5 = $24;
        i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
        i64toi32_i32$3 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
        if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
         i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
        }
        $617 = i64toi32_i32$0;
        $617$hi = i64toi32_i32$3;
        i64toi32_i32$3 = $21$hi;
        i64toi32_i32$3 = $18$hi;
        i64toi32_i32$3 = $30$hi;
        i64toi32_i32$3 = $18$hi;
        i64toi32_i32$2 = $18;
        i64toi32_i32$4 = $30$hi;
        i64toi32_i32$5 = $30;
        i64toi32_i32$1 = i64toi32_i32$2 - i64toi32_i32$5 | 0;
        i64toi32_i32$6 = i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0;
        i64toi32_i32$0 = i64toi32_i32$6 + i64toi32_i32$4 | 0;
        i64toi32_i32$0 = i64toi32_i32$3 - i64toi32_i32$0 | 0;
        $621$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $21$hi;
        i64toi32_i32$2 = $621$hi;
        i64toi32_i32$2 = __wasm_i64_mul($21 | 0, i64toi32_i32$0 | 0, i64toi32_i32$1 | 0, i64toi32_i32$2 | 0) | 0;
        i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
        $622 = i64toi32_i32$2;
        $622$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $617$hi;
        i64toi32_i32$3 = $617;
        i64toi32_i32$2 = $622$hi;
        i64toi32_i32$5 = $622;
        i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
        i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
        if (i64toi32_i32$4 >>> 0 < i64toi32_i32$5 >>> 0) {
         i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
        }
        $623$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $32$hi;
        i64toi32_i32$1 = $623$hi;
        i64toi32_i32$0 = i64toi32_i32$4;
        i64toi32_i32$3 = $32$hi;
        i64toi32_i32$5 = $32;
        i64toi32_i32$2 = i64toi32_i32$4 - i64toi32_i32$5 | 0;
        i64toi32_i32$6 = i64toi32_i32$4 >>> 0 < i64toi32_i32$5 >>> 0;
        i64toi32_i32$4 = i64toi32_i32$6 + i64toi32_i32$3 | 0;
        i64toi32_i32$4 = i64toi32_i32$1 - i64toi32_i32$4 | 0;
        $625$hi = i64toi32_i32$4;
        i64toi32_i32$4 = $33$hi;
        i64toi32_i32$4 = $625$hi;
        i64toi32_i32$1 = i64toi32_i32$2;
        i64toi32_i32$0 = $33$hi;
        i64toi32_i32$5 = $33;
        i64toi32_i32$3 = i64toi32_i32$1 - i64toi32_i32$5 | 0;
        i64toi32_i32$6 = i64toi32_i32$1 >>> 0 < i64toi32_i32$5 >>> 0;
        i64toi32_i32$2 = i64toi32_i32$6 + i64toi32_i32$0 | 0;
        i64toi32_i32$2 = i64toi32_i32$4 - i64toi32_i32$2 | 0;
        $627$hi = i64toi32_i32$2;
        i64toi32_i32$2 = $34$hi;
        i64toi32_i32$2 = $627$hi;
        i64toi32_i32$4 = i64toi32_i32$3;
        i64toi32_i32$1 = $34$hi;
        i64toi32_i32$5 = $34;
        i64toi32_i32$0 = i64toi32_i32$3 - i64toi32_i32$5 | 0;
        i64toi32_i32$6 = i64toi32_i32$3 >>> 0 < i64toi32_i32$5 >>> 0;
        i64toi32_i32$3 = i64toi32_i32$6 + i64toi32_i32$1 | 0;
        i64toi32_i32$3 = i64toi32_i32$2 - i64toi32_i32$3 | 0;
        $629$hi = i64toi32_i32$3;
        i64toi32_i32$3 = $17$hi;
        i64toi32_i32$3 = $629$hi;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$4 = $17$hi;
        i64toi32_i32$5 = $17;
        i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
        i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$4 | 0;
        if (i64toi32_i32$1 >>> 0 < i64toi32_i32$5 >>> 0) {
         i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
        }
        $17 = i64toi32_i32$1;
        $17$hi = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        $12 = 0;
        $12$hi = i64toi32_i32$0;
        label$32 : while (1) {
         label$33 : {
          i64toi32_i32$0 = $13$hi;
          i64toi32_i32$0 = $14$hi;
          i64toi32_i32$0 = $13$hi;
          i64toi32_i32$3 = $13;
          i64toi32_i32$2 = $14$hi;
          i64toi32_i32$5 = $14;
          i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
          i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
          if (i64toi32_i32$4 >>> 0 < i64toi32_i32$5 >>> 0) {
           i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
          }
          $15 = i64toi32_i32$4;
          $15$hi = i64toi32_i32$1;
          i64toi32_i32$1 = $19$hi;
          i64toi32_i32$1 = $15$hi;
          i64toi32_i32$0 = i64toi32_i32$4;
          i64toi32_i32$3 = $19$hi;
          i64toi32_i32$5 = $19;
          if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$4 >>> 0 < i64toi32_i32$5 >>> 0 | 0) | 0) {
           break label$33
          }
          i64toi32_i32$0 = $23$hi;
          i64toi32_i32$0 = $12$hi;
          i64toi32_i32$0 = $23$hi;
          i64toi32_i32$5 = $23;
          i64toi32_i32$1 = $12$hi;
          i64toi32_i32$3 = $12;
          i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
          i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
          if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
           i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
          }
          $640$hi = i64toi32_i32$4;
          i64toi32_i32$4 = $17$hi;
          i64toi32_i32$4 = $640$hi;
          i64toi32_i32$0 = i64toi32_i32$2;
          i64toi32_i32$5 = $17$hi;
          i64toi32_i32$3 = $17;
          if (i64toi32_i32$4 >>> 0 > i64toi32_i32$5 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$2 >>> 0 >= i64toi32_i32$3 >>> 0 | 0) | 0) {
           break label$33
          }
          $1 = 1;
          break label$30;
         }
         $11 = $11 + -1 | 0;
         HEAP8[$10 >> 0] = $11;
         i64toi32_i32$0 = $35$hi;
         i64toi32_i32$0 = $12$hi;
         i64toi32_i32$0 = $35$hi;
         i64toi32_i32$3 = $35;
         i64toi32_i32$4 = $12$hi;
         i64toi32_i32$5 = $12;
         i64toi32_i32$1 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
         i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
         if (i64toi32_i32$1 >>> 0 < i64toi32_i32$5 >>> 0) {
          i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
         }
         $25 = i64toi32_i32$1;
         $25$hi = i64toi32_i32$2;
         i64toi32_i32$2 = $14$hi;
         i64toi32_i32$2 = $25$hi;
         i64toi32_i32$0 = i64toi32_i32$1;
         i64toi32_i32$3 = $14$hi;
         i64toi32_i32$5 = $14;
         $1 = i64toi32_i32$2 >>> 0 > i64toi32_i32$3 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$1 >>> 0 >= i64toi32_i32$5 >>> 0 | 0) | 0;
         i64toi32_i32$0 = $15$hi;
         i64toi32_i32$0 = $19$hi;
         i64toi32_i32$0 = $15$hi;
         i64toi32_i32$5 = $15;
         i64toi32_i32$2 = $19$hi;
         i64toi32_i32$3 = $19;
         if (i64toi32_i32$0 >>> 0 > i64toi32_i32$2 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$5 >>> 0 >= i64toi32_i32$3 >>> 0 | 0) | 0) {
          break label$29
         }
         i64toi32_i32$5 = $17$hi;
         i64toi32_i32$5 = $14$hi;
         i64toi32_i32$5 = $17$hi;
         i64toi32_i32$3 = $17;
         i64toi32_i32$0 = $14$hi;
         i64toi32_i32$2 = $14;
         i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
         i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
         if (i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0) {
          i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
         }
         $17 = i64toi32_i32$4;
         $17$hi = i64toi32_i32$1;
         i64toi32_i32$1 = $12$hi;
         i64toi32_i32$1 = $14$hi;
         i64toi32_i32$1 = $12$hi;
         i64toi32_i32$5 = $12;
         i64toi32_i32$3 = $14$hi;
         i64toi32_i32$2 = $14;
         i64toi32_i32$0 = i64toi32_i32$5 - i64toi32_i32$2 | 0;
         i64toi32_i32$6 = i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0;
         i64toi32_i32$4 = i64toi32_i32$6 + i64toi32_i32$3 | 0;
         i64toi32_i32$4 = i64toi32_i32$1 - i64toi32_i32$4 | 0;
         $12 = i64toi32_i32$0;
         $12$hi = i64toi32_i32$4;
         i64toi32_i32$4 = $15$hi;
         $13 = $15;
         $13$hi = i64toi32_i32$4;
         i64toi32_i32$4 = $25$hi;
         i64toi32_i32$4 = i64toi32_i32$3;
         i64toi32_i32$4 = $25$hi;
         i64toi32_i32$1 = $25;
         i64toi32_i32$5 = i64toi32_i32$3;
         if (i64toi32_i32$4 >>> 0 > i64toi32_i32$3 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$1 >>> 0 >= i64toi32_i32$2 >>> 0 | 0) | 0) {
          continue label$32
         }
         break label$29;
        };
       }
       core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($6 | 0, $3 | 0, 1148828 | 0);
       abort();
      }
      i64toi32_i32$1 = $13$hi;
      $15 = $13;
      $15$hi = i64toi32_i32$1;
     }
     label$34 : {
      label$35 : {
       label$36 : {
        i64toi32_i32$1 = $36$hi;
        i64toi32_i32$1 = $15$hi;
        i64toi32_i32$1 = $36$hi;
        i64toi32_i32$2 = $36;
        i64toi32_i32$4 = $15$hi;
        i64toi32_i32$5 = $15;
        if (i64toi32_i32$1 >>> 0 < i64toi32_i32$4 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$4 | 0) & i64toi32_i32$2 >>> 0 <= i64toi32_i32$5 >>> 0 | 0) | 0) {
         break label$36
        }
        if (!$1) {
         break label$36
        }
        i64toi32_i32$2 = $15$hi;
        i64toi32_i32$2 = $14$hi;
        i64toi32_i32$2 = $15$hi;
        i64toi32_i32$5 = $15;
        i64toi32_i32$1 = $14$hi;
        i64toi32_i32$4 = $14;
        i64toi32_i32$3 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
        i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
        if (i64toi32_i32$3 >>> 0 < i64toi32_i32$4 >>> 0) {
         i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
        }
        $12 = i64toi32_i32$3;
        $12$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $36$hi;
        i64toi32_i32$0 = $12$hi;
        i64toi32_i32$2 = i64toi32_i32$3;
        i64toi32_i32$5 = $36$hi;
        i64toi32_i32$4 = $36;
        if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$3 >>> 0 < i64toi32_i32$4 >>> 0 | 0) | 0) {
         break label$35
        }
        i64toi32_i32$2 = $36$hi;
        i64toi32_i32$2 = $15$hi;
        i64toi32_i32$2 = $36$hi;
        i64toi32_i32$4 = $36;
        i64toi32_i32$0 = $15$hi;
        i64toi32_i32$5 = $15;
        i64toi32_i32$1 = i64toi32_i32$4 - i64toi32_i32$5 | 0;
        i64toi32_i32$6 = i64toi32_i32$4 >>> 0 < i64toi32_i32$5 >>> 0;
        i64toi32_i32$3 = i64toi32_i32$6 + i64toi32_i32$0 | 0;
        i64toi32_i32$3 = i64toi32_i32$2 - i64toi32_i32$3 | 0;
        $682 = i64toi32_i32$1;
        $682$hi = i64toi32_i32$3;
        i64toi32_i32$3 = $12$hi;
        i64toi32_i32$3 = i64toi32_i32$2;
        i64toi32_i32$3 = $12$hi;
        i64toi32_i32$2 = $12;
        i64toi32_i32$4 = $36$hi;
        i64toi32_i32$5 = $36;
        i64toi32_i32$0 = i64toi32_i32$2 - i64toi32_i32$5 | 0;
        i64toi32_i32$6 = i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0;
        i64toi32_i32$1 = i64toi32_i32$6 + i64toi32_i32$4 | 0;
        i64toi32_i32$1 = i64toi32_i32$3 - i64toi32_i32$1 | 0;
        $685$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $682$hi;
        i64toi32_i32$3 = $682;
        i64toi32_i32$2 = $685$hi;
        i64toi32_i32$5 = i64toi32_i32$0;
        if (i64toi32_i32$1 >>> 0 > i64toi32_i32$2 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$3 >>> 0 >= i64toi32_i32$5 >>> 0 | 0) | 0) {
         break label$35
        }
       }
       label$37 : {
        i64toi32_i32$3 = $15$hi;
        i64toi32_i32$5 = $15;
        i64toi32_i32$1 = 0;
        i64toi32_i32$2 = 2;
        if (i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0) {
         break label$37
        }
        i64toi32_i32$5 = $15$hi;
        $689 = $15;
        $689$hi = i64toi32_i32$5;
        i64toi32_i32$5 = $16$hi;
        i64toi32_i32$2 = $16;
        i64toi32_i32$3 = -1;
        i64toi32_i32$1 = -4;
        i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
        i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
        if (i64toi32_i32$4 >>> 0 < i64toi32_i32$1 >>> 0) {
         i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
        }
        $691$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $689$hi;
        i64toi32_i32$5 = $689;
        i64toi32_i32$2 = $691$hi;
        i64toi32_i32$1 = i64toi32_i32$4;
        if (i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$5 >>> 0 <= i64toi32_i32$1 >>> 0 | 0) | 0) {
         break label$34
        }
       }
       HEAP32[$0 >> 2] = 0;
       break label$1;
      }
      HEAP32[$0 >> 2] = 0;
      break label$1;
     }
     HEAP32[($0 + 4 | 0) >> 2] = $6;
     HEAP32[$0 >> 2] = $2;
     HEAP16[($0 + 8 | 0) >> 1] = $8;
     break label$1;
    }
    i64toi32_i32$5 = $12$hi;
    $13 = $12;
    $13$hi = i64toi32_i32$5;
   }
   label$38 : {
    label$39 : {
     label$40 : {
      i64toi32_i32$5 = $23$hi;
      i64toi32_i32$5 = $13$hi;
      i64toi32_i32$5 = $23$hi;
      i64toi32_i32$1 = $23;
      i64toi32_i32$0 = $13$hi;
      i64toi32_i32$2 = $13;
      if (i64toi32_i32$5 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$1 >>> 0 <= i64toi32_i32$2 >>> 0 | 0) | 0) {
       break label$40
      }
      if (!$6) {
       break label$40
      }
      i64toi32_i32$1 = $13$hi;
      i64toi32_i32$1 = $25$hi;
      i64toi32_i32$1 = $13$hi;
      i64toi32_i32$2 = $13;
      i64toi32_i32$5 = $25$hi;
      i64toi32_i32$0 = $25;
      i64toi32_i32$3 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
      i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
      if (i64toi32_i32$3 >>> 0 < i64toi32_i32$0 >>> 0) {
       i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
      }
      $12 = i64toi32_i32$3;
      $12$hi = i64toi32_i32$4;
      i64toi32_i32$4 = $23$hi;
      i64toi32_i32$4 = $12$hi;
      i64toi32_i32$1 = i64toi32_i32$3;
      i64toi32_i32$2 = $23$hi;
      i64toi32_i32$0 = $23;
      if (i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$3 >>> 0 < i64toi32_i32$0 >>> 0 | 0) | 0) {
       break label$39
      }
      i64toi32_i32$1 = $23$hi;
      i64toi32_i32$1 = $13$hi;
      i64toi32_i32$1 = $23$hi;
      i64toi32_i32$0 = $23;
      i64toi32_i32$4 = $13$hi;
      i64toi32_i32$2 = $13;
      i64toi32_i32$5 = i64toi32_i32$0 - i64toi32_i32$2 | 0;
      i64toi32_i32$6 = i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0;
      i64toi32_i32$3 = i64toi32_i32$6 + i64toi32_i32$4 | 0;
      i64toi32_i32$3 = i64toi32_i32$1 - i64toi32_i32$3 | 0;
      $716 = i64toi32_i32$5;
      $716$hi = i64toi32_i32$3;
      i64toi32_i32$3 = $12$hi;
      i64toi32_i32$3 = i64toi32_i32$1;
      i64toi32_i32$3 = $12$hi;
      i64toi32_i32$1 = $12;
      i64toi32_i32$0 = $23$hi;
      i64toi32_i32$2 = $23;
      i64toi32_i32$4 = i64toi32_i32$1 - i64toi32_i32$2 | 0;
      i64toi32_i32$6 = i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0;
      i64toi32_i32$5 = i64toi32_i32$6 + i64toi32_i32$0 | 0;
      i64toi32_i32$5 = i64toi32_i32$3 - i64toi32_i32$5 | 0;
      $719$hi = i64toi32_i32$5;
      i64toi32_i32$5 = $716$hi;
      i64toi32_i32$3 = $716;
      i64toi32_i32$1 = $719$hi;
      i64toi32_i32$2 = i64toi32_i32$4;
      if (i64toi32_i32$5 >>> 0 > i64toi32_i32$1 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$3 >>> 0 >= i64toi32_i32$2 >>> 0 | 0) | 0) {
       break label$39
      }
     }
     label$41 : {
      i64toi32_i32$3 = $16$hi;
      i64toi32_i32$5 = 0;
      i64toi32_i32$5 = __wasm_i64_mul($16 | 0, i64toi32_i32$3 | 0, 20 | 0, i64toi32_i32$5 | 0) | 0;
      i64toi32_i32$3 = i64toi32_i32$HIGH_BITS;
      $722$hi = i64toi32_i32$3;
      i64toi32_i32$3 = $13$hi;
      i64toi32_i32$3 = $722$hi;
      i64toi32_i32$2 = i64toi32_i32$5;
      i64toi32_i32$5 = $13$hi;
      i64toi32_i32$1 = $13;
      if (i64toi32_i32$3 >>> 0 > i64toi32_i32$5 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$2 >>> 0 > i64toi32_i32$1 >>> 0 | 0) | 0) {
       break label$41
      }
      i64toi32_i32$2 = $13$hi;
      $725 = $13;
      $725$hi = i64toi32_i32$2;
      i64toi32_i32$2 = $16$hi;
      i64toi32_i32$3 = -1;
      i64toi32_i32$3 = __wasm_i64_mul($16 | 0, i64toi32_i32$2 | 0, -40 | 0, i64toi32_i32$3 | 0) | 0;
      i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
      $727$hi = i64toi32_i32$2;
      i64toi32_i32$2 = $15$hi;
      i64toi32_i32$2 = $727$hi;
      i64toi32_i32$1 = i64toi32_i32$3;
      i64toi32_i32$3 = $15$hi;
      i64toi32_i32$5 = $15;
      i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
      i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
      if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
       i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
      }
      $729$hi = i64toi32_i32$4;
      i64toi32_i32$4 = $725$hi;
      i64toi32_i32$2 = $725;
      i64toi32_i32$1 = $729$hi;
      i64toi32_i32$5 = i64toi32_i32$0;
      if (i64toi32_i32$4 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$2 >>> 0 <= i64toi32_i32$5 >>> 0 | 0) | 0) {
       break label$38
      }
     }
     HEAP32[$0 >> 2] = 0;
     break label$1;
    }
    HEAP32[$0 >> 2] = 0;
    break label$1;
   }
   HEAP32[($0 + 4 | 0) >> 2] = $9;
   HEAP32[$0 >> 2] = $2;
   HEAP16[($0 + 8 | 0) >> 1] = $8;
  }
  global$0 = $4 + 48 | 0;
 }
 
 function cardano_serialization_lib__utils__read_bounded_bytes__hab7fd43ad4917069($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$5 = 0, i64toi32_i32$1 = 0, i64toi32_i32$4 = 0, $2 = 0, i64toi32_i32$0 = 0, $5 = 0, i64toi32_i32$3 = 0, $3 = 0, i64toi32_i32$2 = 0, $5$hi = 0, $6 = 0, $6$hi = 0, $7 = 0, $8 = 0, $4 = 0, $7$hi = 0, $8$hi = 0, $63 = 0, $64 = 0, $65 = 0, $66 = 0, $67 = 0, $68 = 0, $69 = 0, $70 = 0, $71 = 0, $72 = 0, $73 = 0, $74 = 0, $9 = 0, $9$hi = 0, $54 = 0, $59 = 0, $79 = 0, $81$hi = 0, $86$hi = 0, $117 = 0, $167 = 0, $173 = 0, $176 = 0, $184 = 0, $190 = 0, $212 = 0, $217 = 0, $223 = 0, $281 = 0, $283$hi = 0, $286$hi = 0, $323 = 0, $330 = 0, $344 = 0, $350 = 0, $354 = 0, $358 = 0, $372 = 0, $378 = 0, $387 = 0, $390 = 0, $395 = 0, $400 = 0, $410 = 0, $420 = 0, $426 = 0, $430 = 0, $434 = 0, $438 = 0, $454 = 0, $460 = 0, $474 = 0, $479 = 0, $485 = 0, $594 = 0, $600 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 32 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         if (!(HEAP32[($2 + 36 | 0) >> 2] | 0)) {
          break label$7
         }
         $3 = ($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[($2 + 32 | 0) >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0;
         if (($3 | 0) != (2 | 0)) {
          break label$6
         }
         cbor_event__de__Deserializer_R___cbor_len__h852681e444aca076($2 + 96 | 0 | 0, $1 | 0);
         i64toi32_i32$2 = $2;
         i64toi32_i32$0 = HEAP32[($2 + 104 | 0) >> 2] | 0;
         i64toi32_i32$1 = HEAP32[($2 + 108 | 0) >> 2] | 0;
         $5 = i64toi32_i32$0;
         $5$hi = i64toi32_i32$1;
         i64toi32_i32$2 = $2;
         i64toi32_i32$1 = HEAP32[($2 + 96 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($2 + 100 | 0) >> 2] | 0;
         i64toi32_i32$2 = i64toi32_i32$1;
         i64toi32_i32$1 = 0;
         i64toi32_i32$3 = 1;
         if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
          break label$5
         }
         label$8 : {
          i64toi32_i32$2 = $5$hi;
          i64toi32_i32$2 = $5$hi;
          if (!$5) {
           break label$8
          }
          cbor_event__de__Deserializer_R___bytes__hc697ccccfa39fd82($2 + 96 | 0 | 0, $1 | 0);
          if ((HEAP32[($2 + 96 | 0) >> 2] | 0 | 0) == (1 | 0)) {
           break label$4
          }
          $3 = ($2 + 56 | 0) + 8 | 0;
          $1 = HEAP32[(($2 + 96 | 0) + 12 | 0) >> 2] | 0;
          HEAP32[$3 >> 2] = $1;
          i64toi32_i32$3 = $2;
          i64toi32_i32$2 = HEAP32[($2 + 100 | 0) >> 2] | 0;
          i64toi32_i32$0 = HEAP32[($2 + 104 | 0) >> 2] | 0;
          $54 = i64toi32_i32$2;
          i64toi32_i32$2 = $2;
          HEAP32[($2 + 56 | 0) >> 2] = $54;
          HEAP32[($2 + 60 | 0) >> 2] = i64toi32_i32$0;
          label$9 : {
           if ($1 >>> 0 > 64 >>> 0) {
            break label$9
           }
           i64toi32_i32$3 = $2;
           i64toi32_i32$0 = HEAP32[($2 + 56 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($2 + 60 | 0) >> 2] | 0;
           $59 = i64toi32_i32$0;
           i64toi32_i32$0 = $0;
           HEAP32[($0 + 4 | 0) >> 2] = $59;
           HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$2;
           HEAP32[$0 >> 2] = 0;
           HEAP32[($0 + 12 | 0) >> 2] = HEAP32[$3 >> 2] | 0;
           break label$1;
          }
          HEAP32[$0 >> 2] = 1;
          HEAP32[($0 + 56 | 0) >> 2] = 0;
          HEAP32[($0 + 20 | 0) >> 2] = $1;
          i64toi32_i32$0 = $0 + 12 | 0;
          i64toi32_i32$2 = 64;
          HEAP32[i64toi32_i32$0 >> 2] = 0;
          HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
          HEAP8[($0 + 8 | 0) >> 0] = 12;
          $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 56 | 0 | 0);
          $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 56 | 0 | 0);
          break label$1;
         }
         $79 = $1;
         i64toi32_i32$3 = $1;
         i64toi32_i32$2 = HEAP32[$1 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
         $81$hi = i64toi32_i32$0;
         i64toi32_i32$0 = 0;
         $86$hi = i64toi32_i32$0;
         i64toi32_i32$0 = $81$hi;
         i64toi32_i32$3 = i64toi32_i32$2;
         i64toi32_i32$2 = $86$hi;
         i64toi32_i32$1 = (HEAP32[($2 + 120 | 0) >> 2] | 0) + 1 | 0;
         i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
         i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
         if (i64toi32_i32$4 >>> 0 < i64toi32_i32$1 >>> 0) {
          i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
         }
         i64toi32_i32$3 = $79;
         HEAP32[i64toi32_i32$3 >> 2] = i64toi32_i32$4;
         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
         i64toi32_i32$3 = $2;
         i64toi32_i32$5 = 0;
         HEAP32[($2 + 60 | 0) >> 2] = 0;
         HEAP32[($2 + 64 | 0) >> 2] = i64toi32_i32$5;
         HEAP32[($2 + 56 | 0) >> 2] = HEAP32[(0 + 1057668 | 0) >> 2] | 0;
         std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 24 | 0 | 0, $1 | 0);
         label$10 : {
          label$11 : {
           label$12 : {
            label$13 : {
             if (!(HEAP32[($2 + 28 | 0) >> 2] | 0)) {
              break label$13
             }
             $3 = HEAP32[($2 + 24 | 0) >> 2] | 0;
             label$14 : while (1) {
              label$15 : {
               if ((($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[$3 >> 0] | 0 | 0) | 0) & 255 | 0 | 0) != (7 | 0)) {
                break label$15
               }
               cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 96 | 0 | 0, $1 | 0);
               $1 = HEAPU8[($2 + 104 | 0) >> 0] | 0;
               i64toi32_i32$0 = $2;
               i64toi32_i32$5 = HEAP32[($2 + 96 | 0) >> 2] | 0;
               i64toi32_i32$3 = HEAP32[($2 + 100 | 0) >> 2] | 0;
               i64toi32_i32$0 = i64toi32_i32$5;
               i64toi32_i32$5 = 0;
               i64toi32_i32$1 = 1;
               if ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$5 | 0) | 0) {
                break label$11
               }
               if (($1 & 255 | 0 | 0) != (5 | 0)) {
                break label$10
               }
               i64toi32_i32$1 = $2;
               i64toi32_i32$0 = HEAP32[($2 + 56 | 0) >> 2] | 0;
               i64toi32_i32$3 = HEAP32[($2 + 60 | 0) >> 2] | 0;
               $117 = i64toi32_i32$0;
               i64toi32_i32$0 = $0;
               HEAP32[($0 + 4 | 0) >> 2] = $117;
               HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$3;
               HEAP32[$0 >> 2] = 0;
               HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($2 + 64 | 0) >> 2] | 0;
               break label$1;
              }
              std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 16 | 0 | 0, $1 | 0);
              if (!(HEAP32[($2 + 20 | 0) >> 2] | 0)) {
               break label$3
              }
              label$16 : {
               label$17 : {
                label$18 : {
                 $3 = ($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[($2 + 16 | 0) >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0;
                 if (($3 | 0) != (2 | 0)) {
                  break label$18
                 }
                 cbor_event__de__Deserializer_R___cbor_len__h852681e444aca076($2 + 96 | 0 | 0, $1 | 0);
                 $3 = HEAP32[($2 + 120 | 0) >> 2] | 0;
                 i64toi32_i32$1 = $2;
                 i64toi32_i32$3 = HEAP32[($2 + 112 | 0) >> 2] | 0;
                 i64toi32_i32$0 = HEAP32[($2 + 116 | 0) >> 2] | 0;
                 $6 = i64toi32_i32$3;
                 $6$hi = i64toi32_i32$0;
                 i64toi32_i32$1 = $2;
                 i64toi32_i32$0 = HEAP32[($2 + 104 | 0) >> 2] | 0;
                 i64toi32_i32$3 = HEAP32[($2 + 108 | 0) >> 2] | 0;
                 $5 = i64toi32_i32$0;
                 $5$hi = i64toi32_i32$3;
                 i64toi32_i32$1 = $2;
                 i64toi32_i32$3 = HEAP32[($2 + 96 | 0) >> 2] | 0;
                 i64toi32_i32$0 = HEAP32[($2 + 100 | 0) >> 2] | 0;
                 i64toi32_i32$1 = i64toi32_i32$3;
                 i64toi32_i32$3 = 0;
                 i64toi32_i32$5 = 1;
                 if ((i64toi32_i32$1 | 0) == (i64toi32_i32$5 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) | 0) {
                  break label$17
                 }
                 i64toi32_i32$1 = $5$hi;
                 if ($5) {
                  break label$16
                 }
                 alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($2 + 96 | 0 | 4 | 0 | 0, 1057813 | 0, 62 | 0);
                 i64toi32_i32$5 = ($2 + 96 | 0) + 8 | 0;
                 i64toi32_i32$1 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                 i64toi32_i32$0 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                 $5 = i64toi32_i32$1;
                 $5$hi = i64toi32_i32$0;
                 i64toi32_i32$1 = $2 + 87 | 0;
                 HEAP8[i64toi32_i32$1 >> 0] = $5;
                 HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $5 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $5 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $5 >>> 24 | 0;
                 HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
                 HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
                 HEAP8[($2 + 96 | 0) >> 0] = 18;
                 i64toi32_i32$5 = ($2 + 96 | 0) + 24 | 0;
                 i64toi32_i32$0 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                 i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                 $167 = i64toi32_i32$0;
                 i64toi32_i32$0 = $0 + 40 | 0;
                 HEAP32[i64toi32_i32$0 >> 2] = $167;
                 HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
                 i64toi32_i32$5 = ($2 + 96 | 0) + 32 | 0;
                 i64toi32_i32$1 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                 i64toi32_i32$0 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                 $173 = i64toi32_i32$1;
                 i64toi32_i32$1 = $0 + 48 | 0;
                 HEAP32[i64toi32_i32$1 >> 2] = $173;
                 HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                 i64toi32_i32$5 = $2;
                 i64toi32_i32$0 = HEAP32[(i64toi32_i32$5 + 96 | 0) >> 2] | 0;
                 i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 100 | 0) >> 2] | 0;
                 $176 = i64toi32_i32$0;
                 i64toi32_i32$0 = i64toi32_i32$5;
                 $63 = $176;
                 HEAP8[(i64toi32_i32$5 + 79 | 0) >> 0] = $63;
                 HEAP8[(i64toi32_i32$5 + 80 | 0) >> 0] = $63 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$5 + 81 | 0) >> 0] = $63 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$5 + 82 | 0) >> 0] = $63 >>> 24 | 0;
                 HEAP8[(i64toi32_i32$5 + 83 | 0) >> 0] = i64toi32_i32$1;
                 HEAP8[(i64toi32_i32$5 + 84 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$5 + 85 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$5 + 86 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
                 i64toi32_i32$5 = i64toi32_i32$5 + 112 | 0;
                 i64toi32_i32$1 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                 i64toi32_i32$0 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                 $6 = i64toi32_i32$1;
                 $6$hi = i64toi32_i32$0;
                 HEAP8[($0 + 8 | 0) >> 0] = 2;
                 i64toi32_i32$5 = $2;
                 i64toi32_i32$0 = HEAPU8[(i64toi32_i32$5 + 72 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$5 + 73 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$5 + 74 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$5 + 75 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 i64toi32_i32$1 = HEAPU8[(i64toi32_i32$5 + 76 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$5 + 77 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$5 + 78 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$5 + 79 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 $184 = i64toi32_i32$0;
                 i64toi32_i32$0 = $0;
                 $64 = $184;
                 HEAP8[($0 + 9 | 0) >> 0] = $64;
                 HEAP8[($0 + 10 | 0) >> 0] = $64 >>> 8 | 0;
                 HEAP8[($0 + 11 | 0) >> 0] = $64 >>> 16 | 0;
                 HEAP8[($0 + 12 | 0) >> 0] = $64 >>> 24 | 0;
                 HEAP8[($0 + 13 | 0) >> 0] = i64toi32_i32$1;
                 HEAP8[($0 + 14 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
                 HEAP8[($0 + 15 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
                 HEAP8[($0 + 16 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
                 i64toi32_i32$5 = (i64toi32_i32$5 + 72 | 0) + 8 | 0;
                 i64toi32_i32$1 = HEAPU8[i64toi32_i32$5 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$5 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$5 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$5 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 i64toi32_i32$0 = HEAPU8[(i64toi32_i32$5 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$5 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$5 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$5 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                 $190 = i64toi32_i32$1;
                 i64toi32_i32$1 = $0 + 17 | 0;
                 $65 = $190;
                 HEAP8[i64toi32_i32$1 >> 0] = $65;
                 HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $65 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $65 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $65 >>> 24 | 0;
                 HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
                 HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
                 i64toi32_i32$0 = $5$hi;
                 i64toi32_i32$1 = $0 + 24 | 0;
                 HEAP8[i64toi32_i32$1 >> 0] = $5;
                 HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $5 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $5 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $5 >>> 24 | 0;
                 HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
                 HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                 HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
                 HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
                 HEAP32[($0 + 56 | 0) >> 2] = 0;
                 i64toi32_i32$0 = $6$hi;
                 i64toi32_i32$1 = $0 + 32 | 0;
                 HEAP32[i64toi32_i32$1 >> 2] = $6;
                 HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                 HEAP32[$0 >> 2] = 1;
                 break label$2;
                }
                i64toi32_i32$5 = ($2 + 144 | 0) + 8 | 0;
                i64toi32_i32$0 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                $5 = i64toi32_i32$0;
                $5$hi = i64toi32_i32$1;
                i64toi32_i32$0 = $2 + 111 | 0;
                HEAP8[i64toi32_i32$0 >> 0] = $5;
                HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $5 >>> 8 | 0;
                HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $5 >>> 16 | 0;
                HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $5 >>> 24 | 0;
                HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
                HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
                HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
                HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
                HEAP8[($2 + 146 | 0) >> 0] = $3;
                HEAP16[($2 + 144 | 0) >> 1] = 521;
                i64toi32_i32$5 = $2;
                i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 144 | 0) >> 2] | 0;
                i64toi32_i32$0 = HEAP32[(i64toi32_i32$5 + 148 | 0) >> 2] | 0;
                $212 = i64toi32_i32$1;
                i64toi32_i32$1 = i64toi32_i32$5;
                $66 = $212;
                HEAP8[(i64toi32_i32$5 + 103 | 0) >> 0] = $66;
                HEAP8[(i64toi32_i32$5 + 104 | 0) >> 0] = $66 >>> 8 | 0;
                HEAP8[(i64toi32_i32$5 + 105 | 0) >> 0] = $66 >>> 16 | 0;
                HEAP8[(i64toi32_i32$5 + 106 | 0) >> 0] = $66 >>> 24 | 0;
                HEAP8[(i64toi32_i32$5 + 107 | 0) >> 0] = i64toi32_i32$0;
                HEAP8[(i64toi32_i32$5 + 108 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                HEAP8[(i64toi32_i32$5 + 109 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
                HEAP8[(i64toi32_i32$5 + 110 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
                HEAP8[($0 + 8 | 0) >> 0] = 2;
                i64toi32_i32$0 = HEAPU8[(i64toi32_i32$5 + 96 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$5 + 97 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$5 + 98 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$5 + 99 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                i64toi32_i32$1 = HEAPU8[(i64toi32_i32$5 + 100 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$5 + 101 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$5 + 102 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$5 + 103 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                $217 = i64toi32_i32$0;
                i64toi32_i32$0 = $0;
                $67 = $217;
                HEAP8[($0 + 9 | 0) >> 0] = $67;
                HEAP8[($0 + 10 | 0) >> 0] = $67 >>> 8 | 0;
                HEAP8[($0 + 11 | 0) >> 0] = $67 >>> 16 | 0;
                HEAP8[($0 + 12 | 0) >> 0] = $67 >>> 24 | 0;
                HEAP8[($0 + 13 | 0) >> 0] = i64toi32_i32$1;
                HEAP8[($0 + 14 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
                HEAP8[($0 + 15 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
                HEAP8[($0 + 16 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
                i64toi32_i32$5 = (i64toi32_i32$5 + 96 | 0) + 8 | 0;
                i64toi32_i32$1 = HEAPU8[i64toi32_i32$5 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$5 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$5 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$5 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                i64toi32_i32$0 = HEAPU8[(i64toi32_i32$5 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$5 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$5 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$5 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                $223 = i64toi32_i32$1;
                i64toi32_i32$1 = $0 + 17 | 0;
                $68 = $223;
                HEAP8[i64toi32_i32$1 >> 0] = $68;
                HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $68 >>> 8 | 0;
                HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $68 >>> 16 | 0;
                HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $68 >>> 24 | 0;
                HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
                HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
                HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
                i64toi32_i32$0 = $5$hi;
                i64toi32_i32$1 = $0 + 24 | 0;
                HEAP8[i64toi32_i32$1 >> 0] = $5;
                HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $5 >>> 8 | 0;
                HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $5 >>> 16 | 0;
                HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $5 >>> 24 | 0;
                HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
                HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
                HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
                HEAP32[($0 + 56 | 0) >> 2] = 0;
                HEAP32[$0 >> 2] = 1;
                break label$2;
               }
               i64toi32_i32$5 = ($2 + 96 | 0) + 40 | 0;
               i64toi32_i32$0 = HEAP32[i64toi32_i32$5 >> 2] | 0;
               i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
               $7 = i64toi32_i32$0;
               $7$hi = i64toi32_i32$1;
               i64toi32_i32$0 = ($2 + 72 | 0) + 8 | 0;
               HEAP32[i64toi32_i32$0 >> 2] = $7;
               HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
               i64toi32_i32$5 = ($2 + 96 | 0) + 32 | 0;
               i64toi32_i32$1 = HEAP32[i64toi32_i32$5 >> 2] | 0;
               i64toi32_i32$0 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
               $8 = i64toi32_i32$1;
               $8$hi = i64toi32_i32$0;
               i64toi32_i32$1 = $2;
               HEAP32[(i64toi32_i32$1 + 72 | 0) >> 2] = $8;
               HEAP32[(i64toi32_i32$1 + 76 | 0) >> 2] = i64toi32_i32$0;
               $1 = HEAP32[(i64toi32_i32$1 + 124 | 0) >> 2] | 0;
               HEAP32[($0 + 56 | 0) >> 2] = 0;
               HEAP8[($0 + 8 | 0) >> 0] = 2;
               i64toi32_i32$0 = $5$hi;
               i64toi32_i32$1 = $0 + 16 | 0;
               HEAP32[i64toi32_i32$1 >> 2] = $5;
               HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
               i64toi32_i32$0 = $6$hi;
               i64toi32_i32$1 = $0 + 24 | 0;
               HEAP32[i64toi32_i32$1 >> 2] = $6;
               HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
               HEAP32[($0 + 36 | 0) >> 2] = $1;
               HEAP32[($0 + 32 | 0) >> 2] = $3;
               i64toi32_i32$0 = $8$hi;
               i64toi32_i32$1 = $0 + 40 | 0;
               HEAP32[i64toi32_i32$1 >> 2] = $8;
               HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
               i64toi32_i32$0 = $7$hi;
               i64toi32_i32$1 = $0 + 48 | 0;
               HEAP32[i64toi32_i32$1 >> 2] = $7;
               HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
               HEAP32[$0 >> 2] = 1;
               break label$2;
              }
              label$19 : {
               if ($3 >>> 0 < 65 >>> 0) {
                break label$19
               }
               HEAP32[$0 >> 2] = 1;
               HEAP32[($0 + 56 | 0) >> 2] = 0;
               HEAP32[($0 + 20 | 0) >> 2] = $3;
               i64toi32_i32$1 = $0 + 12 | 0;
               i64toi32_i32$0 = 64;
               HEAP32[i64toi32_i32$1 >> 2] = 0;
               HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
               HEAP8[($0 + 8 | 0) >> 0] = 12;
               break label$2;
              }
              $281 = $1;
              i64toi32_i32$5 = $1;
              i64toi32_i32$0 = HEAP32[i64toi32_i32$5 >> 2] | 0;
              i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
              $283$hi = i64toi32_i32$1;
              i64toi32_i32$1 = 0;
              $286$hi = i64toi32_i32$1;
              i64toi32_i32$1 = $283$hi;
              i64toi32_i32$5 = i64toi32_i32$0;
              i64toi32_i32$0 = $286$hi;
              i64toi32_i32$3 = $3 + 1 | 0;
              i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
              i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
              if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
               i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
              }
              i64toi32_i32$5 = $281;
              HEAP32[i64toi32_i32$5 >> 2] = i64toi32_i32$2;
              HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$4;
              HEAP32[($2 + 104 | 0) >> 2] = $1;
              i64toi32_i32$4 = $6$hi;
              i64toi32_i32$5 = $2;
              HEAP32[(i64toi32_i32$5 + 96 | 0) >> 2] = $6;
              HEAP32[(i64toi32_i32$5 + 100 | 0) >> 2] = i64toi32_i32$4;
              std__io__read_to_end_with_reservation__hb7238e9014e3486e(i64toi32_i32$5 + 72 | 0 | 0, i64toi32_i32$5 + 96 | 0 | 0, i64toi32_i32$5 + 56 | 0 | 0);
              if ((HEAP32[(i64toi32_i32$5 + 72 | 0) >> 2] | 0 | 0) == (1 | 0)) {
               break label$12
              }
              std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 8 | 0 | 0, $1 | 0);
              $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
              if (HEAP32[($2 + 12 | 0) >> 2] | 0) {
               continue label$14
              }
              break label$14;
             };
            }
            $1 = HEAPU8[(($2 + 144 | 0) + 2 | 0) >> 0] | 0;
            HEAP8[(($2 + 40 | 0) + 2 | 0) >> 0] = $1;
            $3 = ($2 + 72 | 0) + 8 | 0;
            i64toi32_i32$1 = ($2 + 96 | 0) + 8 | 0;
            i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
            i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
            $323 = i64toi32_i32$4;
            i64toi32_i32$4 = $3;
            HEAP32[i64toi32_i32$4 >> 2] = $323;
            HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
            $4 = HEAPU8[($2 + 144 | 0) >> 0] | 0 | ((HEAPU8[($2 + 145 | 0) >> 0] | 0) << 8 | 0) | 0;
            HEAP16[($2 + 40 | 0) >> 1] = $4;
            i64toi32_i32$1 = $2;
            i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 96 | 0) >> 2] | 0;
            i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 100 | 0) >> 2] | 0;
            $330 = i64toi32_i32$5;
            i64toi32_i32$5 = i64toi32_i32$1;
            HEAP32[(i64toi32_i32$5 + 72 | 0) >> 2] = $330;
            HEAP32[(i64toi32_i32$5 + 76 | 0) >> 2] = i64toi32_i32$4;
            HEAP32[($0 + 56 | 0) >> 2] = 0;
            HEAP8[($0 + 8 | 0) >> 0] = 2;
            HEAP8[(i64toi32_i32$5 + 145 | 0) >> 0] = $4;
            HEAP8[(i64toi32_i32$5 + 146 | 0) >> 0] = $4 >>> 8 | 0;
            HEAP8[(i64toi32_i32$5 + 144 | 0) >> 0] = 8;
            HEAP8[(i64toi32_i32$5 + 147 | 0) >> 0] = $1;
            i64toi32_i32$4 = 0;
            HEAP32[(i64toi32_i32$5 + 148 | 0) >> 2] = 0;
            HEAP32[(i64toi32_i32$5 + 152 | 0) >> 2] = i64toi32_i32$4;
            i64toi32_i32$1 = i64toi32_i32$5;
            i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 144 | 0) >> 2] | 0;
            i64toi32_i32$5 = HEAP32[(i64toi32_i32$5 + 148 | 0) >> 2] | 0;
            $344 = i64toi32_i32$4;
            i64toi32_i32$4 = $0 + 16 | 0;
            HEAP32[i64toi32_i32$4 >> 2] = $344;
            HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
            i64toi32_i32$1 = (i64toi32_i32$1 + 144 | 0) + 8 | 0;
            i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
            i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
            $350 = i64toi32_i32$5;
            i64toi32_i32$5 = $0 + 24 | 0;
            HEAP32[i64toi32_i32$5 >> 2] = $350;
            HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$4;
            i64toi32_i32$1 = $2;
            i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 72 | 0) >> 2] | 0;
            i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 76 | 0) >> 2] | 0;
            $354 = i64toi32_i32$4;
            i64toi32_i32$4 = $0 + 40 | 0;
            HEAP32[i64toi32_i32$4 >> 2] = $354;
            HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
            i64toi32_i32$1 = $3;
            i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
            i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
            $358 = i64toi32_i32$5;
            i64toi32_i32$5 = $0 + 48 | 0;
            HEAP32[i64toi32_i32$5 >> 2] = $358;
            HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$4;
            HEAP32[$0 >> 2] = 1;
            break label$2;
           }
           i64toi32_i32$1 = $2;
           i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 76 | 0) >> 2] | 0;
           i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 80 | 0) >> 2] | 0;
           $5 = i64toi32_i32$4;
           $5$hi = i64toi32_i32$5;
           HEAP32[($0 + 56 | 0) >> 2] = 0;
           HEAP8[($0 + 8 | 0) >> 0] = 2;
           i64toi32_i32$4 = i64toi32_i32$1;
           HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = $5;
           HEAP32[(i64toi32_i32$1 + 152 | 0) >> 2] = i64toi32_i32$5;
           HEAP8[(i64toi32_i32$1 + 144 | 0) >> 0] = 16;
           i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] | 0;
           i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] | 0;
           $372 = i64toi32_i32$5;
           i64toi32_i32$5 = $0 + 16 | 0;
           HEAP32[i64toi32_i32$5 >> 2] = $372;
           HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$4;
           i64toi32_i32$1 = (i64toi32_i32$1 + 144 | 0) + 8 | 0;
           i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $378 = i64toi32_i32$4;
           i64toi32_i32$4 = $0 + 24 | 0;
           HEAP32[i64toi32_i32$4 >> 2] = $378;
           HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
           HEAP32[$0 >> 2] = 1;
           break label$2;
          }
          $3 = ($2 + 72 | 0) + 8 | 0;
          i64toi32_i32$1 = ($2 + 96 | 0) + 40 | 0;
          i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
          i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
          $387 = i64toi32_i32$5;
          i64toi32_i32$5 = $3;
          HEAP32[i64toi32_i32$5 >> 2] = $387;
          HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$4;
          i64toi32_i32$1 = $2;
          i64toi32_i32$4 = HEAPU8[(i64toi32_i32$1 + 105 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 106 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 107 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 108 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          i64toi32_i32$5 = HEAPU8[(i64toi32_i32$1 + 109 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 110 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 111 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 112 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          $390 = i64toi32_i32$4;
          i64toi32_i32$4 = i64toi32_i32$1;
          HEAP32[(i64toi32_i32$1 + 40 | 0) >> 2] = $390;
          HEAP32[(i64toi32_i32$1 + 44 | 0) >> 2] = i64toi32_i32$5;
          i64toi32_i32$1 = (i64toi32_i32$1 + 96 | 0) + 16 | 0;
          i64toi32_i32$5 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          i64toi32_i32$4 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          $395 = i64toi32_i32$5;
          i64toi32_i32$5 = $2;
          $69 = $395;
          HEAP8[(i64toi32_i32$5 + 47 | 0) >> 0] = $69;
          HEAP8[(i64toi32_i32$5 + 48 | 0) >> 0] = $69 >>> 8 | 0;
          HEAP8[(i64toi32_i32$5 + 49 | 0) >> 0] = $69 >>> 16 | 0;
          HEAP8[(i64toi32_i32$5 + 50 | 0) >> 0] = $69 >>> 24 | 0;
          HEAP8[(i64toi32_i32$5 + 51 | 0) >> 0] = i64toi32_i32$4;
          HEAP8[(i64toi32_i32$5 + 52 | 0) >> 0] = i64toi32_i32$4 >>> 8 | 0;
          HEAP8[(i64toi32_i32$5 + 53 | 0) >> 0] = i64toi32_i32$4 >>> 16 | 0;
          HEAP8[(i64toi32_i32$5 + 54 | 0) >> 0] = i64toi32_i32$4 >>> 24 | 0;
          i64toi32_i32$1 = (i64toi32_i32$5 + 96 | 0) + 32 | 0;
          i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
          i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
          $400 = i64toi32_i32$4;
          i64toi32_i32$4 = $2;
          HEAP32[($2 + 72 | 0) >> 2] = $400;
          HEAP32[($2 + 76 | 0) >> 2] = i64toi32_i32$5;
          i64toi32_i32$1 = ($2 + 96 | 0) + 24 | 0;
          i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
          i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
          $5 = i64toi32_i32$5;
          $5$hi = i64toi32_i32$4;
          $4 = ($2 + 144 | 0) + 8 | 0;
          i64toi32_i32$1 = $2;
          i64toi32_i32$4 = HEAPU8[(i64toi32_i32$1 + 47 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 48 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 49 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 50 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          i64toi32_i32$5 = HEAPU8[(i64toi32_i32$1 + 51 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 52 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 53 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 54 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          $410 = i64toi32_i32$4;
          i64toi32_i32$4 = $4;
          $70 = $410;
          HEAP8[i64toi32_i32$4 >> 0] = $70;
          HEAP8[(i64toi32_i32$4 + 1 | 0) >> 0] = $70 >>> 8 | 0;
          HEAP8[(i64toi32_i32$4 + 2 | 0) >> 0] = $70 >>> 16 | 0;
          HEAP8[(i64toi32_i32$4 + 3 | 0) >> 0] = $70 >>> 24 | 0;
          HEAP8[(i64toi32_i32$4 + 4 | 0) >> 0] = i64toi32_i32$5;
          HEAP8[(i64toi32_i32$4 + 5 | 0) >> 0] = i64toi32_i32$5 >>> 8 | 0;
          HEAP8[(i64toi32_i32$4 + 6 | 0) >> 0] = i64toi32_i32$5 >>> 16 | 0;
          HEAP8[(i64toi32_i32$4 + 7 | 0) >> 0] = i64toi32_i32$5 >>> 24 | 0;
          HEAP32[($0 + 56 | 0) >> 2] = 0;
          HEAP8[($0 + 8 | 0) >> 0] = 2;
          i64toi32_i32$5 = $5$hi;
          i64toi32_i32$4 = $0 + 32 | 0;
          HEAP32[i64toi32_i32$4 >> 2] = $5;
          HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
          i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 40 | 0) >> 2] | 0;
          i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 44 | 0) >> 2] | 0;
          $420 = i64toi32_i32$5;
          i64toi32_i32$5 = i64toi32_i32$1;
          $71 = $420;
          HEAP8[(i64toi32_i32$5 + 145 | 0) >> 0] = $71;
          HEAP8[(i64toi32_i32$5 + 146 | 0) >> 0] = $71 >>> 8 | 0;
          HEAP8[(i64toi32_i32$5 + 147 | 0) >> 0] = $71 >>> 16 | 0;
          HEAP8[(i64toi32_i32$5 + 148 | 0) >> 0] = $71 >>> 24 | 0;
          HEAP8[(i64toi32_i32$5 + 149 | 0) >> 0] = i64toi32_i32$4;
          HEAP8[(i64toi32_i32$5 + 150 | 0) >> 0] = i64toi32_i32$4 >>> 8 | 0;
          HEAP8[(i64toi32_i32$5 + 151 | 0) >> 0] = i64toi32_i32$4 >>> 16 | 0;
          HEAP8[(i64toi32_i32$5 + 152 | 0) >> 0] = i64toi32_i32$4 >>> 24 | 0;
          HEAP8[(i64toi32_i32$5 + 144 | 0) >> 0] = $1;
          i64toi32_i32$1 = i64toi32_i32$5;
          i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 144 | 0) >> 2] | 0;
          i64toi32_i32$5 = HEAP32[(i64toi32_i32$5 + 148 | 0) >> 2] | 0;
          $426 = i64toi32_i32$4;
          i64toi32_i32$4 = $0 + 16 | 0;
          HEAP32[i64toi32_i32$4 >> 2] = $426;
          HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
          i64toi32_i32$1 = $4;
          i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
          i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
          $430 = i64toi32_i32$5;
          i64toi32_i32$5 = $0 + 24 | 0;
          HEAP32[i64toi32_i32$5 >> 2] = $430;
          HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$4;
          i64toi32_i32$1 = $2;
          i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 72 | 0) >> 2] | 0;
          i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 76 | 0) >> 2] | 0;
          $434 = i64toi32_i32$4;
          i64toi32_i32$4 = $0 + 40 | 0;
          HEAP32[i64toi32_i32$4 >> 2] = $434;
          HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
          i64toi32_i32$1 = $3;
          i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
          i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
          $438 = i64toi32_i32$5;
          i64toi32_i32$5 = $0 + 48 | 0;
          HEAP32[i64toi32_i32$5 >> 2] = $438;
          HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$4;
          HEAP32[$0 >> 2] = 1;
          break label$2;
         }
         HEAP32[$0 >> 2] = 1;
         HEAP32[($0 + 56 | 0) >> 2] = 0;
         HEAP8[($0 + 8 | 0) >> 0] = 5;
         break label$2;
        }
        HEAP32[($0 + 56 | 0) >> 2] = 0;
        HEAP8[($2 + 144 | 0) >> 0] = 8;
        HEAP8[($0 + 8 | 0) >> 0] = 2;
        i64toi32_i32$5 = $2;
        i64toi32_i32$4 = 0;
        HEAP32[(i64toi32_i32$5 + 148 | 0) >> 2] = 0;
        HEAP32[(i64toi32_i32$5 + 152 | 0) >> 2] = i64toi32_i32$4;
        i64toi32_i32$1 = i64toi32_i32$5;
        i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 144 | 0) >> 2] | 0;
        i64toi32_i32$5 = HEAP32[(i64toi32_i32$5 + 148 | 0) >> 2] | 0;
        $454 = i64toi32_i32$4;
        i64toi32_i32$4 = $0 + 16 | 0;
        HEAP32[i64toi32_i32$4 >> 2] = $454;
        HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
        i64toi32_i32$1 = (i64toi32_i32$1 + 144 | 0) + 8 | 0;
        i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
        i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
        $460 = i64toi32_i32$5;
        i64toi32_i32$5 = $0 + 24 | 0;
        HEAP32[i64toi32_i32$5 >> 2] = $460;
        HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$4;
        HEAP32[$0 >> 2] = 1;
        break label$1;
       }
       i64toi32_i32$1 = ($2 + 144 | 0) + 8 | 0;
       i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $5 = i64toi32_i32$4;
       $5$hi = i64toi32_i32$5;
       i64toi32_i32$4 = $2 + 111 | 0;
       HEAP8[i64toi32_i32$4 >> 0] = $5;
       HEAP8[(i64toi32_i32$4 + 1 | 0) >> 0] = $5 >>> 8 | 0;
       HEAP8[(i64toi32_i32$4 + 2 | 0) >> 0] = $5 >>> 16 | 0;
       HEAP8[(i64toi32_i32$4 + 3 | 0) >> 0] = $5 >>> 24 | 0;
       HEAP8[(i64toi32_i32$4 + 4 | 0) >> 0] = i64toi32_i32$5;
       HEAP8[(i64toi32_i32$4 + 5 | 0) >> 0] = i64toi32_i32$5 >>> 8 | 0;
       HEAP8[(i64toi32_i32$4 + 6 | 0) >> 0] = i64toi32_i32$5 >>> 16 | 0;
       HEAP8[(i64toi32_i32$4 + 7 | 0) >> 0] = i64toi32_i32$5 >>> 24 | 0;
       HEAP8[($2 + 146 | 0) >> 0] = $3;
       HEAP16[($2 + 144 | 0) >> 1] = 521;
       i64toi32_i32$1 = $2;
       i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] | 0;
       i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] | 0;
       $474 = i64toi32_i32$5;
       i64toi32_i32$5 = i64toi32_i32$1;
       $72 = $474;
       HEAP8[(i64toi32_i32$5 + 103 | 0) >> 0] = $72;
       HEAP8[(i64toi32_i32$5 + 104 | 0) >> 0] = $72 >>> 8 | 0;
       HEAP8[(i64toi32_i32$5 + 105 | 0) >> 0] = $72 >>> 16 | 0;
       HEAP8[(i64toi32_i32$5 + 106 | 0) >> 0] = $72 >>> 24 | 0;
       HEAP8[(i64toi32_i32$5 + 107 | 0) >> 0] = i64toi32_i32$4;
       HEAP8[(i64toi32_i32$5 + 108 | 0) >> 0] = i64toi32_i32$4 >>> 8 | 0;
       HEAP8[(i64toi32_i32$5 + 109 | 0) >> 0] = i64toi32_i32$4 >>> 16 | 0;
       HEAP8[(i64toi32_i32$5 + 110 | 0) >> 0] = i64toi32_i32$4 >>> 24 | 0;
       HEAP8[($0 + 8 | 0) >> 0] = 2;
       i64toi32_i32$1 = i64toi32_i32$5;
       i64toi32_i32$4 = HEAPU8[(i64toi32_i32$5 + 96 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$5 + 97 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$5 + 98 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$5 + 99 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$5 = HEAPU8[(i64toi32_i32$5 + 100 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$5 + 101 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$5 + 102 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$5 + 103 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $479 = i64toi32_i32$4;
       i64toi32_i32$4 = $0;
       $73 = $479;
       HEAP8[(i64toi32_i32$4 + 9 | 0) >> 0] = $73;
       HEAP8[(i64toi32_i32$4 + 10 | 0) >> 0] = $73 >>> 8 | 0;
       HEAP8[(i64toi32_i32$4 + 11 | 0) >> 0] = $73 >>> 16 | 0;
       HEAP8[(i64toi32_i32$4 + 12 | 0) >> 0] = $73 >>> 24 | 0;
       HEAP8[(i64toi32_i32$4 + 13 | 0) >> 0] = i64toi32_i32$5;
       HEAP8[(i64toi32_i32$4 + 14 | 0) >> 0] = i64toi32_i32$5 >>> 8 | 0;
       HEAP8[(i64toi32_i32$4 + 15 | 0) >> 0] = i64toi32_i32$5 >>> 16 | 0;
       HEAP8[(i64toi32_i32$4 + 16 | 0) >> 0] = i64toi32_i32$5 >>> 24 | 0;
       i64toi32_i32$1 = (i64toi32_i32$1 + 96 | 0) + 8 | 0;
       i64toi32_i32$5 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$4 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $485 = i64toi32_i32$5;
       i64toi32_i32$5 = $0 + 17 | 0;
       $74 = $485;
       HEAP8[i64toi32_i32$5 >> 0] = $74;
       HEAP8[(i64toi32_i32$5 + 1 | 0) >> 0] = $74 >>> 8 | 0;
       HEAP8[(i64toi32_i32$5 + 2 | 0) >> 0] = $74 >>> 16 | 0;
       HEAP8[(i64toi32_i32$5 + 3 | 0) >> 0] = $74 >>> 24 | 0;
       HEAP8[(i64toi32_i32$5 + 4 | 0) >> 0] = i64toi32_i32$4;
       HEAP8[(i64toi32_i32$5 + 5 | 0) >> 0] = i64toi32_i32$4 >>> 8 | 0;
       HEAP8[(i64toi32_i32$5 + 6 | 0) >> 0] = i64toi32_i32$4 >>> 16 | 0;
       HEAP8[(i64toi32_i32$5 + 7 | 0) >> 0] = i64toi32_i32$4 >>> 24 | 0;
       i64toi32_i32$4 = $5$hi;
       i64toi32_i32$5 = $0 + 24 | 0;
       HEAP8[i64toi32_i32$5 >> 0] = $5;
       HEAP8[(i64toi32_i32$5 + 1 | 0) >> 0] = $5 >>> 8 | 0;
       HEAP8[(i64toi32_i32$5 + 2 | 0) >> 0] = $5 >>> 16 | 0;
       HEAP8[(i64toi32_i32$5 + 3 | 0) >> 0] = $5 >>> 24 | 0;
       HEAP8[(i64toi32_i32$5 + 4 | 0) >> 0] = i64toi32_i32$4;
       HEAP8[(i64toi32_i32$5 + 5 | 0) >> 0] = i64toi32_i32$4 >>> 8 | 0;
       HEAP8[(i64toi32_i32$5 + 6 | 0) >> 0] = i64toi32_i32$4 >>> 16 | 0;
       HEAP8[(i64toi32_i32$5 + 7 | 0) >> 0] = i64toi32_i32$4 >>> 24 | 0;
       HEAP32[($0 + 56 | 0) >> 2] = 0;
       HEAP32[$0 >> 2] = 1;
       break label$1;
      }
      i64toi32_i32$1 = ($2 + 96 | 0) + 40 | 0;
      i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $6 = i64toi32_i32$4;
      $6$hi = i64toi32_i32$5;
      i64toi32_i32$4 = ($2 + 72 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$4 >> 2] = $6;
      HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
      i64toi32_i32$1 = ($2 + 96 | 0) + 32 | 0;
      i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $7 = i64toi32_i32$5;
      $7$hi = i64toi32_i32$4;
      i64toi32_i32$5 = $2;
      HEAP32[(i64toi32_i32$5 + 72 | 0) >> 2] = $7;
      HEAP32[(i64toi32_i32$5 + 76 | 0) >> 2] = i64toi32_i32$4;
      i64toi32_i32$1 = (i64toi32_i32$5 + 96 | 0) + 24 | 0;
      i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $8 = i64toi32_i32$4;
      $8$hi = i64toi32_i32$5;
      i64toi32_i32$1 = ($2 + 96 | 0) + 16 | 0;
      i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $9 = i64toi32_i32$5;
      $9$hi = i64toi32_i32$4;
      HEAP32[($0 + 56 | 0) >> 2] = 0;
      HEAP8[($0 + 8 | 0) >> 0] = 2;
      i64toi32_i32$4 = $5$hi;
      i64toi32_i32$5 = $0 + 16 | 0;
      HEAP32[i64toi32_i32$5 >> 2] = $5;
      HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$4;
      i64toi32_i32$4 = $9$hi;
      i64toi32_i32$5 = $0 + 24 | 0;
      HEAP32[i64toi32_i32$5 >> 2] = $9;
      HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$4;
      i64toi32_i32$4 = $8$hi;
      i64toi32_i32$5 = $0 + 32 | 0;
      HEAP32[i64toi32_i32$5 >> 2] = $8;
      HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$4;
      i64toi32_i32$4 = $7$hi;
      i64toi32_i32$5 = $0 + 40 | 0;
      HEAP32[i64toi32_i32$5 >> 2] = $7;
      HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$4;
      i64toi32_i32$4 = $6$hi;
      i64toi32_i32$5 = $0 + 48 | 0;
      HEAP32[i64toi32_i32$5 >> 2] = $6;
      HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$4;
      HEAP32[$0 >> 2] = 1;
      break label$1;
     }
     i64toi32_i32$1 = ($2 + 96 | 0) + 16 | 0;
     i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $5 = i64toi32_i32$4;
     $5$hi = i64toi32_i32$5;
     i64toi32_i32$4 = $2 + 84 | 0;
     HEAP32[i64toi32_i32$4 >> 2] = $5;
     HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
     i64toi32_i32$1 = ($2 + 96 | 0) + 40 | 0;
     i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $6 = i64toi32_i32$5;
     $6$hi = i64toi32_i32$4;
     i64toi32_i32$5 = ($2 + 40 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$5 >> 2] = $6;
     HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$4;
     i64toi32_i32$1 = ($2 + 96 | 0) + 8 | 0;
     i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $7 = i64toi32_i32$4;
     $7$hi = i64toi32_i32$5;
     i64toi32_i32$4 = $2;
     HEAP32[(i64toi32_i32$4 + 76 | 0) >> 2] = $7;
     HEAP32[(i64toi32_i32$4 + 80 | 0) >> 2] = i64toi32_i32$5;
     i64toi32_i32$1 = (i64toi32_i32$4 + 96 | 0) + 32 | 0;
     i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $8 = i64toi32_i32$5;
     $8$hi = i64toi32_i32$4;
     i64toi32_i32$5 = $2;
     HEAP32[(i64toi32_i32$5 + 40 | 0) >> 2] = $8;
     HEAP32[(i64toi32_i32$5 + 44 | 0) >> 2] = i64toi32_i32$4;
     i64toi32_i32$1 = (i64toi32_i32$5 + 96 | 0) + 24 | 0;
     i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $9 = i64toi32_i32$4;
     $9$hi = i64toi32_i32$5;
     HEAP8[($0 + 8 | 0) >> 0] = 2;
     HEAP32[($0 + 56 | 0) >> 2] = 0;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$4 = $0 + 16 | 0;
     HEAP32[i64toi32_i32$4 >> 2] = $7;
     HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
     i64toi32_i32$5 = $5$hi;
     i64toi32_i32$4 = $0 + 24 | 0;
     HEAP32[i64toi32_i32$4 >> 2] = $5;
     HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
     i64toi32_i32$5 = $9$hi;
     i64toi32_i32$4 = $0 + 32 | 0;
     HEAP32[i64toi32_i32$4 >> 2] = $9;
     HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
     i64toi32_i32$5 = $8$hi;
     i64toi32_i32$4 = $0 + 40 | 0;
     HEAP32[i64toi32_i32$4 >> 2] = $8;
     HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$4 = $0 + 48 | 0;
     HEAP32[i64toi32_i32$4 >> 2] = $6;
     HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
     HEAP32[$0 >> 2] = 1;
     break label$1;
    }
    HEAP32[($0 + 56 | 0) >> 2] = 0;
    HEAP8[($2 + 144 | 0) >> 0] = 8;
    HEAP8[($0 + 8 | 0) >> 0] = 2;
    i64toi32_i32$4 = $2;
    i64toi32_i32$5 = 0;
    HEAP32[(i64toi32_i32$4 + 148 | 0) >> 2] = 0;
    HEAP32[(i64toi32_i32$4 + 152 | 0) >> 2] = i64toi32_i32$5;
    i64toi32_i32$1 = i64toi32_i32$4;
    i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] | 0;
    i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] | 0;
    $594 = i64toi32_i32$5;
    i64toi32_i32$5 = $0 + 16 | 0;
    HEAP32[i64toi32_i32$5 >> 2] = $594;
    HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$4;
    i64toi32_i32$1 = (i64toi32_i32$1 + 144 | 0) + 8 | 0;
    i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
    i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
    $600 = i64toi32_i32$4;
    i64toi32_i32$4 = $0 + 24 | 0;
    HEAP32[i64toi32_i32$4 >> 2] = $600;
    HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
    HEAP32[$0 >> 2] = 1;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 56 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 56 | 0 | 0);
  }
  global$0 = $2 + 160 | 0;
 }
 
 function num_bigint__biguint__convert__to_radix_le__h73e11ba14c242b2c($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $5 = 0, $6 = 0, i64toi32_i32$0 = 0, $4 = 0, i64toi32_i32$4 = 0, $3 = 0, $8 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, $7 = 0, $9 = 0, $10 = 0, i64toi32_i32$6 = 0, $17 = 0.0, $14$hi = 0, $14 = 0, $11 = 0, $12 = 0, $15$hi = 0, $497$hi = 0, $45 = 0, $46 = 0, $47 = 0, $13 = 0, $15 = 0, $16 = 0, $32$hi = 0, $43$hi = 0, $83 = 0, $85 = 0, $91 = 0, $188$hi = 0, $199$hi = 0, $254 = 0, $256 = 0, $262 = 0, $475 = 0, $478$hi = 0, $489$hi = 0, $501 = 0, $501$hi = 0, $503 = 0, $504$hi = 0;
  $3 = global$0 - 64 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     if (!$4) {
      break label$3
     }
     label$4 : {
      if ((__wasm_popcnt_i32($2 | 0) | 0 | 0) == (1 | 0)) {
       break label$4
      }
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          if (($2 | 0) != (10 | 0)) {
           break label$8
          }
          $5 = 0;
          label$9 : {
           i64toi32_i32$0 = 0;
           i64toi32_i32$2 = $4;
           i64toi32_i32$1 = 0;
           i64toi32_i32$3 = 5;
           i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
           if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
            i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
            $45 = 0;
           } else {
            i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
            $45 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
           }
           $32$hi = i64toi32_i32$1;
           $6 = $4 << 2 | 0;
           $1 = HEAP32[$1 >> 2] | 0;
           i64toi32_i32$1 = 0;
           $43$hi = i64toi32_i32$1;
           i64toi32_i32$1 = $32$hi;
           i64toi32_i32$0 = $45;
           i64toi32_i32$2 = $43$hi;
           i64toi32_i32$3 = Math_clz32(HEAP32[(($6 + $1 | 0) + -4 | 0) >> 2] | 0);
           i64toi32_i32$4 = i64toi32_i32$0 - i64toi32_i32$3 | 0;
           i64toi32_i32$6 = i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0;
           i64toi32_i32$5 = i64toi32_i32$6 + i64toi32_i32$2 | 0;
           i64toi32_i32$5 = i64toi32_i32$1 - i64toi32_i32$5 | 0;
           i64toi32_i32$0 = i64toi32_i32$4;
           i64toi32_i32$1 = 0;
           $17 = Math_ceil((+(i64toi32_i32$0 >>> 0) + 4294967296.0 * +(i64toi32_i32$5 >>> 0)) / 3.321928094887362);
           if ($17 > -1.0 ^ 1 | 0) {
            break label$9
           }
           $5 = 0;
           if ($17 < 4294967296.0 ^ 1 | 0) {
            break label$9
           }
           $5 = ~~$17 >>> 0;
          }
          alloc__raw_vec__RawVec_T_2cA___allocate_in__h7079698aee95f1e4($3 + 24 | 0 | 0, $5 | 0, 0 | 0);
          i64toi32_i32$1 = $3;
          i64toi32_i32$5 = HEAP32[($3 + 24 | 0) >> 2] | 0;
          i64toi32_i32$0 = HEAP32[($3 + 28 | 0) >> 2] | 0;
          $14 = i64toi32_i32$5;
          $14$hi = i64toi32_i32$0;
          HEAP32[($0 + 8 | 0) >> 2] = 0;
          i64toi32_i32$5 = $0;
          HEAP32[$0 >> 2] = $14;
          HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$0;
          alloc__raw_vec__RawVec_T_2cA___allocate_in__hb0817f92bbb8999a($3 + 16 | 0 | 0, $4 | 0, 0 | 0);
          $2 = HEAP32[($3 + 20 | 0) >> 2] | 0;
          $7 = HEAP32[($3 + 16 | 0) >> 2] | 0;
          memcpy($7 | 0, $1 | 0, $6 | 0) | 0;
          if ($4 >>> 0 <= 1 >>> 0) {
           break label$6
          }
          label$10 : while (1) {
           $1 = $4 << 2 | 0;
           $5 = 0;
           label$11 : while (1) {
            $6 = ($7 + $1 | 0) + -4 | 0;
            $83 = $6;
            $85 = $5 << 16 | 0;
            $5 = HEAP32[$6 >> 2] | 0;
            $6 = $85 | ($5 >>> 16 | 0) | 0;
            $91 = $6;
            $6 = ($6 >>> 0) / (1e4 >>> 0) | 0;
            $5 = ($91 - Math_imul($6, 1e4) | 0) << 16 | 0 | ($5 & 65535 | 0) | 0;
            $8 = ($5 >>> 0) / (1e4 >>> 0) | 0;
            HEAP32[$83 >> 2] = $8 | ($6 << 16 | 0) | 0;
            $5 = $5 - Math_imul($8, 1e4) | 0;
            $1 = $1 + -4 | 0;
            if ($1) {
             continue label$11
            }
            break label$11;
           };
           HEAP32[($3 + 52 | 0) >> 2] = $2;
           HEAP32[($3 + 56 | 0) >> 2] = $4;
           HEAP32[($3 + 48 | 0) >> 2] = $7;
           $1 = ($7 + ($4 << 2 | 0) | 0) + -4 | 0;
           label$12 : {
            label$13 : while (1) {
             label$14 : {
              if (!(HEAP32[$1 >> 2] | 0)) {
               break label$14
              }
              $6 = $4;
              break label$12;
             }
             $6 = 0;
             if (!$4) {
              break label$12
             }
             $4 = $4 + -1 | 0;
             HEAP32[($3 + 56 | 0) >> 2] = $4;
             $1 = $1 + -4 | 0;
             if ($4) {
              continue label$13
             }
             break label$13;
            };
           }
           label$15 : {
            label$16 : {
             if ($6 >>> 0 >= ($2 >>> 2 | 0) >>> 0) {
              break label$16
             }
             if ($2 >>> 0 <= $6 >>> 0) {
              break label$16
             }
             alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($3 + 48 | 0 | 0, $6 | 0);
             $2 = HEAP32[($3 + 52 | 0) >> 2] | 0;
             $7 = HEAP32[($3 + 48 | 0) >> 2] | 0;
             $4 = HEAP32[($3 + 56 | 0) >> 2] | 0;
             break label$15;
            }
            $4 = $6;
           }
           $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
           $6 = 4;
           label$17 : while (1) {
            $8 = ($5 >>> 0) / (10 >>> 0) | 0;
            $5 = $5 - Math_imul($8, 10) | 0;
            label$18 : {
             if (($1 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
              break label$18
             }
             alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hcd3bd1a8d7e51f52($0 | 0, $1 | 0, 1 | 0);
             $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
            }
            HEAP8[((HEAP32[$0 >> 2] | 0) + $1 | 0) >> 0] = $5;
            $1 = $1 + 1 | 0;
            HEAP32[($0 + 8 | 0) >> 2] = $1;
            $5 = $8;
            $6 = $6 + -1 | 0;
            if ($6) {
             continue label$17
            }
            break label$17;
           };
           if ($4 >>> 0 <= 1 >>> 0) {
            break label$7
           }
           continue label$10;
          };
         }
         $5 = 0;
         label$19 : {
          i64toi32_i32$0 = 0;
          i64toi32_i32$1 = $4;
          i64toi32_i32$5 = 0;
          i64toi32_i32$3 = 5;
          i64toi32_i32$2 = i64toi32_i32$3 & 31 | 0;
          if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
           i64toi32_i32$5 = i64toi32_i32$1 << i64toi32_i32$2 | 0;
           $46 = 0;
          } else {
           i64toi32_i32$5 = ((1 << i64toi32_i32$2 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$2 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$2 | 0) | 0;
           $46 = i64toi32_i32$1 << i64toi32_i32$2 | 0;
          }
          $188$hi = i64toi32_i32$5;
          $6 = $4 << 2 | 0;
          $1 = HEAP32[$1 >> 2] | 0;
          i64toi32_i32$5 = 0;
          $199$hi = i64toi32_i32$5;
          i64toi32_i32$5 = $188$hi;
          i64toi32_i32$0 = $46;
          i64toi32_i32$1 = $199$hi;
          i64toi32_i32$3 = Math_clz32(HEAP32[(($6 + $1 | 0) + -4 | 0) >> 2] | 0);
          i64toi32_i32$2 = i64toi32_i32$0 - i64toi32_i32$3 | 0;
          i64toi32_i32$6 = i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0;
          i64toi32_i32$4 = i64toi32_i32$6 + i64toi32_i32$1 | 0;
          i64toi32_i32$4 = i64toi32_i32$5 - i64toi32_i32$4 | 0;
          i64toi32_i32$0 = i64toi32_i32$2;
          i64toi32_i32$5 = 0;
          $17 = Math_ceil((+(i64toi32_i32$0 >>> 0) + 4294967296.0 * +(i64toi32_i32$4 >>> 0)) / +log2(+(+($2 >>> 0))));
          if ($17 > -1.0 ^ 1 | 0) {
           break label$19
          }
          $5 = 0;
          if ($17 < 4294967296.0 ^ 1 | 0) {
           break label$19
          }
          $5 = ~~$17 >>> 0;
         }
         alloc__raw_vec__RawVec_T_2cA___allocate_in__h7079698aee95f1e4($3 + 40 | 0 | 0, $5 | 0, 0 | 0);
         i64toi32_i32$5 = $3;
         i64toi32_i32$4 = HEAP32[($3 + 40 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($3 + 44 | 0) >> 2] | 0;
         $14 = i64toi32_i32$4;
         $14$hi = i64toi32_i32$0;
         HEAP32[($0 + 8 | 0) >> 2] = 0;
         i64toi32_i32$4 = $0;
         HEAP32[$0 >> 2] = $14;
         HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$0;
         alloc__raw_vec__RawVec_T_2cA___allocate_in__hb0817f92bbb8999a($3 + 32 | 0 | 0, $4 | 0, 0 | 0);
         $9 = HEAP32[($3 + 36 | 0) >> 2] | 0;
         $10 = HEAP32[($3 + 32 | 0) >> 2] | 0;
         memcpy($10 | 0, $1 | 0, $6 | 0) | 0;
         label$20 : {
          label$21 : {
           label$22 : {
            label$23 : {
             if ($2 >>> 0 >= 257 >>> 0) {
              break label$23
             }
             if ($4 >>> 0 <= 1 >>> 0) {
              break label$21
             }
             $5 = $2 << 3 | 0;
             $11 = HEAP32[($5 + 1078512 | 0) >> 2] | 0;
             $5 = HEAPU16[($5 + 1078508 | 0) >> 1] | 0;
             label$24 : while (1) {
              label$25 : {
               label$26 : {
                if (!$5) {
                 break label$26
                }
                $6 = $4 << 2 | 0;
                $1 = 0;
                label$27 : while (1) {
                 $8 = ($10 + $6 | 0) + -4 | 0;
                 $254 = $8;
                 $256 = $1 << 16 | 0;
                 $1 = HEAP32[$8 >> 2] | 0;
                 $8 = $256 | ($1 >>> 16 | 0) | 0;
                 $262 = $8;
                 $8 = ($8 >>> 0) / ($5 >>> 0) | 0;
                 $1 = ($262 - Math_imul($8, $5) | 0) << 16 | 0 | ($1 & 65535 | 0) | 0;
                 $7 = ($1 >>> 0) / ($5 >>> 0) | 0;
                 HEAP32[$254 >> 2] = $7 | ($8 << 16 | 0) | 0;
                 $1 = $1 - Math_imul($7, $5) | 0;
                 $6 = $6 + -4 | 0;
                 if ($6) {
                  continue label$27
                 }
                 break label$27;
                };
                HEAP32[($3 + 52 | 0) >> 2] = $9;
                HEAP32[($3 + 56 | 0) >> 2] = $4;
                HEAP32[($3 + 48 | 0) >> 2] = $10;
                $6 = ($10 + ($4 << 2 | 0) | 0) + -4 | 0;
                label$28 : while (1) {
                 label$29 : {
                  if (!(HEAP32[$6 >> 2] | 0)) {
                   break label$29
                  }
                  $8 = $4;
                  break label$25;
                 }
                 $8 = 0;
                 if (!$4) {
                  break label$25
                 }
                 $4 = $4 + -1 | 0;
                 HEAP32[($3 + 56 | 0) >> 2] = $4;
                 $6 = $6 + -4 | 0;
                 if ($4) {
                  continue label$28
                 }
                 break label$25;
                };
               }
               core__panicking__panic__h2fd385a887c8bf13(1077952 | 0, 25 | 0, 1077936 | 0);
               abort();
              }
              label$30 : {
               label$31 : {
                if ($8 >>> 0 >= ($9 >>> 2 | 0) >>> 0) {
                 break label$31
                }
                if ($9 >>> 0 <= $8 >>> 0) {
                 break label$31
                }
                alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($3 + 48 | 0 | 0, $8 | 0);
                $9 = HEAP32[($3 + 52 | 0) >> 2] | 0;
                $10 = HEAP32[($3 + 48 | 0) >> 2] | 0;
                $4 = HEAP32[($3 + 56 | 0) >> 2] | 0;
                break label$30;
               }
               $4 = $8;
              }
              label$32 : {
               if (!$11) {
                break label$32
               }
               label$33 : {
                if (!$2) {
                 break label$33
                }
                $6 = HEAP32[($0 + 8 | 0) >> 2] | 0;
                $8 = $11;
                label$34 : while (1) {
                 $7 = ($1 >>> 0) / ($2 >>> 0) | 0;
                 $1 = $1 - Math_imul($7, $2) | 0;
                 label$35 : {
                  if (($6 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
                   break label$35
                  }
                  alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hcd3bd1a8d7e51f52($0 | 0, $6 | 0, 1 | 0);
                  $6 = HEAP32[($0 + 8 | 0) >> 2] | 0;
                 }
                 HEAP8[((HEAP32[$0 >> 2] | 0) + $6 | 0) >> 0] = $1;
                 $6 = $6 + 1 | 0;
                 HEAP32[($0 + 8 | 0) >> 2] = $6;
                 $1 = $7;
                 $8 = $8 + -1 | 0;
                 if (!$8) {
                  break label$32
                 }
                 continue label$34;
                };
               }
               core__panicking__panic__h2fd385a887c8bf13(1077984 | 0, 57 | 0, 1078364 | 0);
               abort();
              }
              if ($4 >>> 0 <= 1 >>> 0) {
               break label$22
              }
              continue label$24;
             };
            }
            core__panicking__panic_bounds_check__h808b524af17640b1($2 | 0, 257 | 0, 1078492 | 0);
            abort();
           }
           if (!$4) {
            break label$20
           }
          }
          label$36 : {
           label$37 : {
            $1 = HEAP32[$10 >> 2] | 0;
            if (!$1) {
             break label$37
            }
            if (!$2) {
             break label$36
            }
            $5 = HEAP32[($0 + 8 | 0) >> 2] | 0;
            label$38 : while (1) {
             $6 = ($1 >>> 0) / ($2 >>> 0) | 0;
             $4 = $1 - Math_imul($6, $2) | 0;
             label$39 : {
              if (($5 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
               break label$39
              }
              alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hcd3bd1a8d7e51f52($0 | 0, $5 | 0, 1 | 0);
              $5 = HEAP32[($0 + 8 | 0) >> 2] | 0;
             }
             HEAP8[((HEAP32[$0 >> 2] | 0) + $5 | 0) >> 0] = $4;
             $5 = $5 + 1 | 0;
             HEAP32[($0 + 8 | 0) >> 2] = $5;
             $4 = $1 >>> 0 < $2 >>> 0;
             $1 = $6;
             if (!$4) {
              continue label$38
             }
             break label$38;
            };
           }
           if (!$9) {
            break label$2
           }
           $0 = $9 << 2 | 0;
           if (!$0) {
            break label$2
           }
           __rust_dealloc($10 | 0, $0 | 0, 4 | 0);
           break label$2;
          }
          core__panicking__panic__h2fd385a887c8bf13(1077984 | 0, 57 | 0, 1078396 | 0);
          abort();
         }
         core__panicking__panic_bounds_check__h808b524af17640b1(0 | 0, 0 | 0, 1078380 | 0);
         abort();
        }
        if (!$4) {
         break label$5
        }
       }
       label$40 : {
        $1 = HEAP32[$7 >> 2] | 0;
        if (!$1) {
         break label$40
        }
        $5 = HEAP32[($0 + 8 | 0) >> 2] | 0;
        label$41 : while (1) {
         $6 = ($1 >>> 0) / (10 >>> 0) | 0;
         $4 = $1 - Math_imul($6, 10) | 0;
         label$42 : {
          if (($5 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
           break label$42
          }
          alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hcd3bd1a8d7e51f52($0 | 0, $5 | 0, 1 | 0);
          $5 = HEAP32[($0 + 8 | 0) >> 2] | 0;
         }
         HEAP8[((HEAP32[$0 >> 2] | 0) + $5 | 0) >> 0] = $4;
         $5 = $5 + 1 | 0;
         HEAP32[($0 + 8 | 0) >> 2] = $5;
         $4 = $1 >>> 0 > 9 >>> 0;
         $1 = $6;
         if ($4) {
          continue label$41
         }
         break label$41;
        };
       }
       if (!$2) {
        break label$2
       }
       $0 = $2 << 2 | 0;
       if (!$0) {
        break label$2
       }
       __rust_dealloc($7 | 0, $0 | 0, 4 | 0);
       break label$2;
      }
      core__panicking__panic_bounds_check__h808b524af17640b1(0 | 0, 0 | 0, 1078380 | 0);
      abort();
     }
     label$43 : {
      $8 = 31 - Math_clz32($2) | 0;
      if (!$8) {
       break label$43
      }
      label$44 : {
       $2 = $8 & 255 | 0;
       if ((32 >>> 0) % ($2 >>> 0) | 0) {
        break label$44
       }
       num_bigint__biguint__convert__to_bitwise_digits_le__hadd655177eaec017($0 | 0, $1 | 0, $8 | 0);
       break label$2;
      }
      $5 = 0;
      $475 = $3 + 8 | 0;
      i64toi32_i32$0 = 0;
      i64toi32_i32$5 = $4;
      i64toi32_i32$4 = 0;
      i64toi32_i32$3 = 5;
      i64toi32_i32$1 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$4 = i64toi32_i32$5 << i64toi32_i32$1 | 0;
       $47 = 0;
      } else {
       i64toi32_i32$4 = ((1 << i64toi32_i32$1 | 0) - 1 | 0) & (i64toi32_i32$5 >>> (32 - i64toi32_i32$1 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$1 | 0) | 0;
       $47 = i64toi32_i32$5 << i64toi32_i32$1 | 0;
      }
      $478$hi = i64toi32_i32$4;
      $12 = HEAP32[$1 >> 2] | 0;
      $13 = $12 + ($4 << 2 | 0) | 0;
      i64toi32_i32$4 = 0;
      $489$hi = i64toi32_i32$4;
      i64toi32_i32$4 = $478$hi;
      i64toi32_i32$0 = $47;
      i64toi32_i32$5 = $489$hi;
      i64toi32_i32$3 = Math_clz32(HEAP32[($13 + -4 | 0) >> 2] | 0);
      i64toi32_i32$1 = i64toi32_i32$0 - i64toi32_i32$3 | 0;
      i64toi32_i32$6 = i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0;
      i64toi32_i32$2 = i64toi32_i32$6 + i64toi32_i32$5 | 0;
      i64toi32_i32$2 = i64toi32_i32$4 - i64toi32_i32$2 | 0;
      $14 = i64toi32_i32$1;
      $14$hi = i64toi32_i32$2;
      i64toi32_i32$2 = 0;
      i64toi32_i32$4 = $8;
      i64toi32_i32$0 = 0;
      i64toi32_i32$3 = 255;
      i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
      $15 = $8 & i64toi32_i32$3 | 0;
      $15$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $14$hi;
      i64toi32_i32$4 = $15$hi;
      i64toi32_i32$4 = __wasm_i64_udiv(i64toi32_i32$1 | 0, i64toi32_i32$0 | 0, $15 | 0, i64toi32_i32$4 | 0) | 0;
      i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
      $16 = i64toi32_i32$4;
      $497$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $14$hi;
      i64toi32_i32$0 = $497$hi;
      i64toi32_i32$0 = $15$hi;
      i64toi32_i32$0 = $497$hi;
      i64toi32_i32$4 = $15$hi;
      i64toi32_i32$4 = __wasm_i64_mul($16 | 0, i64toi32_i32$0 | 0, $15 | 0, i64toi32_i32$4 | 0) | 0;
      i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
      $501 = i64toi32_i32$4;
      $501$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $14$hi;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$4 = $501$hi;
      i64toi32_i32$3 = $501;
      i64toi32_i32$5 = i64toi32_i32$2 - i64toi32_i32$3 | 0;
      i64toi32_i32$6 = i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0;
      i64toi32_i32$1 = i64toi32_i32$6 + i64toi32_i32$4 | 0;
      i64toi32_i32$1 = i64toi32_i32$0 - i64toi32_i32$1 | 0;
      i64toi32_i32$0 = i64toi32_i32$5;
      i64toi32_i32$2 = 0;
      i64toi32_i32$3 = 0;
      $503 = (i64toi32_i32$0 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$2 | 0) | 0;
      i64toi32_i32$0 = 0;
      $504$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $497$hi;
      i64toi32_i32$3 = $16;
      i64toi32_i32$1 = $504$hi;
      i64toi32_i32$2 = $503;
      i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
      i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
      if (i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0) {
       i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
      }
      $14 = i64toi32_i32$4;
      $14$hi = i64toi32_i32$5;
      i64toi32_i32$0 = i64toi32_i32$4;
      i64toi32_i32$3 = 1;
      i64toi32_i32$2 = 0;
      alloc__raw_vec__RawVec_T_2cA___allocate_in__h7079698aee95f1e4($475 | 0, (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0 ? i64toi32_i32$0 : -1) | 0, 0 | 0);
      $7 = HEAP32[($3 + 8 | 0) >> 2] | 0;
      $1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
      HEAP32[($0 + 8 | 0) >> 2] = 0;
      HEAP32[($0 + 4 | 0) >> 2] = $1;
      HEAP32[$0 >> 2] = $7;
      $11 = $8 & 31 | 0;
      $10 = (-1 << $11 | 0) ^ -1 | 0;
      $6 = 0;
      $1 = 0;
      label$45 : while (1) {
       $9 = $12;
       $12 = $9 + 4 | 0;
       $6 = (HEAP32[$9 >> 2] | 0) << ($1 & 31 | 0) | 0 | $6 | 0;
       label$46 : {
        label$47 : {
         $1 = $1 + 32 | 0;
         if (($1 & 255 | 0) >>> 0 >= $2 >>> 0) {
          break label$47
         }
         break label$46;
        }
        label$48 : while (1) {
         $4 = $6 & $10 | 0;
         label$49 : {
          if (($5 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
           break label$49
          }
          label$50 : {
           if (($5 | 0) != ($5 | 0)) {
            break label$50
           }
           alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hcd3bd1a8d7e51f52($0 | 0, $5 | 0, 1 | 0);
           $5 = HEAP32[($0 + 8 | 0) >> 2] | 0;
          }
          $7 = HEAP32[$0 >> 2] | 0;
         }
         HEAP8[($7 + $5 | 0) >> 0] = $4;
         $5 = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
         HEAP32[($0 + 8 | 0) >> 2] = $5;
         label$51 : {
          label$52 : {
           if (($1 & 255 | 0) >>> 0 >= 33 >>> 0) {
            break label$52
           }
           $6 = $6 >>> $11 | 0;
           break label$51;
          }
          $6 = (HEAP32[$9 >> 2] | 0) >>> (($8 - $1 | 0) & 31 | 0) | 0;
         }
         $1 = $1 - $8 | 0;
         if (($1 & 255 | 0) >>> 0 >= $2 >>> 0) {
          continue label$48
         }
         break label$48;
        };
       }
       if (($12 | 0) != ($13 | 0)) {
        continue label$45
       }
       break label$45;
      };
      label$53 : {
       label$54 : {
        if (!($1 & 255 | 0)) {
         break label$54
        }
        label$55 : {
         if (($5 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
          break label$55
         }
         if (($5 | 0) != ($5 | 0)) {
          break label$55
         }
         alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hcd3bd1a8d7e51f52($0 | 0, $5 | 0, 1 | 0);
         $5 = HEAP32[($0 + 8 | 0) >> 2] | 0;
        }
        $1 = HEAP32[$0 >> 2] | 0;
        HEAP8[($1 + $5 | 0) >> 0] = $6;
        $5 = $5 + 1 | 0;
        HEAP32[($0 + 8 | 0) >> 2] = $5;
        break label$53;
       }
       $1 = HEAP32[$0 >> 2] | 0;
      }
      if (!$5) {
       break label$2
      }
      $5 = $5 + -1 | 0;
      label$56 : while (1) {
       if (HEAPU8[($1 + $5 | 0) >> 0] | 0) {
        break label$2
       }
       HEAP32[($0 + 8 | 0) >> 2] = $5;
       $5 = $5 + -1 | 0;
       if (($5 | 0) == (-1 | 0)) {
        break label$2
       }
       continue label$56;
      };
     }
     core__panicking__panic__h2fd385a887c8bf13(1077984 | 0, 57 | 0, 1078412 | 0);
     abort();
    }
    $5 = __rust_alloc(1 | 0, 1 | 0) | 0;
    if (!$5) {
     break label$1
    }
    i64toi32_i32$5 = $0;
    i64toi32_i32$0 = 1;
    HEAP32[($0 + 4 | 0) >> 2] = 1;
    HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[$0 >> 2] = $5;
    HEAP8[$5 >> 0] = 0;
   }
   global$0 = $3 + 64 | 0;
   return;
  }
  alloc__alloc__handle_alloc_error__he269d8f1bff90960(1 | 0, 1 | 0);
  abort();
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__NativeScriptEnum___deserialize__hb97d8419517d870c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $7 = 0, $7$hi = 0, i64toi32_i32$4 = 0, $3 = 0, $9 = 0, $9$hi = 0, $8 = 0, $8$hi = 0, $5 = 0, $48 = 0, $49 = 0, $50 = 0, $51 = 0, $52 = 0, $4 = 0, $53 = 0, $54 = 0, $55 = 0, $56 = 0, $57 = 0, $58 = 0, $80 = 0, $87 = 0, $100 = 0, $100$hi = 0, $104$hi = 0, $118 = 0, $125 = 0, $129 = 0, $141 = 0, $352 = 0, $352$hi = 0, $355 = 0, $355$hi = 0, $359$hi = 0, $361$hi = 0, $363$hi = 0, $366 = 0, $366$hi = 0, $383 = 0, $462 = 0, $475 = 0, $479 = 0, $6 = 0, $515 = 0, $519 = 0, $525 = 0, $555 = 0, $560 = 0, $565 = 0, $570 = 0, $575 = 0;
  $2 = global$0 - 224 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 152 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 160 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 164 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           label$10 : {
            label$11 : {
             label$12 : {
              label$13 : {
               label$14 : {
                label$15 : {
                 label$16 : {
                  label$17 : {
                   label$18 : {
                    label$19 : {
                     label$20 : {
                      i64toi32_i32$2 = $2;
                      i64toi32_i32$1 = HEAP32[($2 + 152 | 0) >> 2] | 0;
                      i64toi32_i32$0 = HEAP32[($2 + 156 | 0) >> 2] | 0;
                      i64toi32_i32$2 = i64toi32_i32$1;
                      i64toi32_i32$1 = 0;
                      i64toi32_i32$3 = 1;
                      if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
                       break label$20
                      }
                      i64toi32_i32$0 = $2;
                      i64toi32_i32$2 = 0;
                      HEAP32[($2 + 152 | 0) >> 2] = 2;
                      HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$2;
                      i64toi32_i32$0 = $2;
                      i64toi32_i32$2 = 0;
                      HEAP32[($2 + 160 | 0) >> 2] = 0;
                      HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$2;
                      $std__io__cursor__Cursor_T__20as_20std__io__Seek___seek__h4fe82da83d4d5304($2 + 8 | 0 | 0, $1 | 0, $2 + 152 | 0 | 0);
                      label$21 : {
                       if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                        break label$21
                       }
                       $3 = ($2 + 8 | 0) + 8 | 0;
                       i64toi32_i32$3 = $3;
                       i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                       i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                       $8 = i64toi32_i32$2;
                       $8$hi = i64toi32_i32$0;
                       i64toi32_i32$0 = $7$hi;
                       i64toi32_i32$2 = i64toi32_i32$0;
                       cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__ScriptPubkey___deserialize_as_embedded_group__h27483ec3516d4650($2 + 152 | 0 | 0, $1 | 0, $7 | 0, i64toi32_i32$2 | 0, $7 | 0, i64toi32_i32$2 | 0);
                       label$22 : {
                        if ((HEAPU8[($2 + 152 | 0) >> 0] | 0 | 0) != (1 | 0)) {
                         break label$22
                        }
                        $3 = memcpy($3 | 0, memcpy($2 + 80 | 0 | 7 | 0 | 0, ($2 + 152 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
                        HEAP8[($2 + 8 | 0) >> 0] = 1;
                        i64toi32_i32$0 = $2;
                        i64toi32_i32$2 = 0;
                        HEAP32[($2 + 152 | 0) >> 2] = 0;
                        HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$2;
                        i64toi32_i32$2 = $8$hi;
                        i64toi32_i32$0 = $2;
                        HEAP32[($2 + 160 | 0) >> 2] = $8;
                        HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$2;
                        $std__io__cursor__Cursor_T__20as_20std__io__Seek___seek__h4fe82da83d4d5304($2 + 80 | 0 | 0, $1 | 0, $2 + 152 | 0 | 0);
                        if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                         break label$19
                        }
                        if (HEAPU8[($2 + 8 | 0) >> 0] | 0) {
                         break label$18
                        }
                        break label$17;
                       }
                       $48 = ($2 + 152 | 0) + 25 | 0;
                       $49 = ($2 + 8 | 0) + 25 | 0;
                       $50 = HEAPU8[$48 >> 0] | 0 | ((HEAPU8[($48 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($48 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($48 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                       HEAP8[$49 >> 0] = $50;
                       HEAP8[($49 + 1 | 0) >> 0] = $50 >>> 8 | 0;
                       HEAP8[($49 + 2 | 0) >> 0] = $50 >>> 16 | 0;
                       HEAP8[($49 + 3 | 0) >> 0] = $50 >>> 24 | 0;
                       i64toi32_i32$3 = ($2 + 152 | 0) + 17 | 0;
                       i64toi32_i32$2 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                       $80 = i64toi32_i32$2;
                       i64toi32_i32$2 = ($2 + 8 | 0) + 17 | 0;
                       $51 = $80;
                       HEAP8[i64toi32_i32$2 >> 0] = $51;
                       HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $51 >>> 8 | 0;
                       HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $51 >>> 16 | 0;
                       HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $51 >>> 24 | 0;
                       HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$0;
                       HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                       HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
                       HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
                       i64toi32_i32$3 = ($2 + 152 | 0) + 9 | 0;
                       i64toi32_i32$0 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                       i64toi32_i32$2 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                       $87 = i64toi32_i32$0;
                       i64toi32_i32$0 = ($2 + 8 | 0) + 9 | 0;
                       $52 = $87;
                       HEAP8[i64toi32_i32$0 >> 0] = $52;
                       HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $52 >>> 8 | 0;
                       HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $52 >>> 16 | 0;
                       HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $52 >>> 24 | 0;
                       HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$2;
                       HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
                       HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
                       HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
                       i64toi32_i32$3 = $2;
                       i64toi32_i32$2 = HEAPU8[($2 + 153 | 0) >> 0] | 0 | ((HEAPU8[($2 + 154 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 155 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 156 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                       i64toi32_i32$0 = HEAPU8[($2 + 157 | 0) >> 0] | 0 | ((HEAPU8[($2 + 158 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 159 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 160 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                       $7 = i64toi32_i32$2;
                       $7$hi = i64toi32_i32$0;
                       i64toi32_i32$2 = $2;
                       HEAP8[($2 + 9 | 0) >> 0] = $7;
                       HEAP8[($2 + 10 | 0) >> 0] = $7 >>> 8 | 0;
                       HEAP8[($2 + 11 | 0) >> 0] = $7 >>> 16 | 0;
                       HEAP8[($2 + 12 | 0) >> 0] = $7 >>> 24 | 0;
                       HEAP8[($2 + 13 | 0) >> 0] = i64toi32_i32$0;
                       HEAP8[($2 + 14 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
                       HEAP8[($2 + 15 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
                       HEAP8[($2 + 16 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
                       HEAP8[($2 + 6 | 0) >> 0] = HEAPU8[($2 + 11 | 0) >> 0] | 0;
                       HEAP16[($2 + 4 | 0) >> 1] = $7;
                       i64toi32_i32$3 = $2 + 32 | 0;
                       i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                       i64toi32_i32$2 = 0;
                       $100 = i64toi32_i32$0;
                       $100$hi = i64toi32_i32$2;
                       i64toi32_i32$3 = $2 + 36 | 0;
                       i64toi32_i32$2 = HEAPU8[i64toi32_i32$3 >> 0] | 0;
                       i64toi32_i32$0 = 0;
                       i64toi32_i32$3 = i64toi32_i32$2;
                       i64toi32_i32$2 = 0;
                       i64toi32_i32$1 = 32;
                       i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
                       if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                        i64toi32_i32$2 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
                        $53 = 0;
                       } else {
                        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
                        $53 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
                       }
                       $104$hi = i64toi32_i32$2;
                       i64toi32_i32$2 = $100$hi;
                       i64toi32_i32$0 = $100;
                       i64toi32_i32$3 = $104$hi;
                       i64toi32_i32$1 = $53;
                       i64toi32_i32$3 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
                       $7 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
                       $7$hi = i64toi32_i32$3;
                       $4 = HEAP32[($2 + 28 | 0) >> 2] | 0;
                       i64toi32_i32$2 = $3;
                       i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                       $9 = i64toi32_i32$3;
                       $9$hi = i64toi32_i32$0;
                       $5 = HEAP32[($2 + 24 | 0) >> 2] | 0;
                       $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
                       $3 = 0;
                       break label$9;
                      }
                      i64toi32_i32$2 = $2;
                      i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
                      i64toi32_i32$3 = HEAP32[($2 + 16 | 0) >> 2] | 0;
                      $118 = i64toi32_i32$0;
                      i64toi32_i32$0 = $2;
                      HEAP32[($2 + 152 | 0) >> 2] = $118;
                      HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$3;
                      core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 152 | 0 | 0, 1050188 | 0, 1051840 | 0);
                      abort();
                     }
                     i64toi32_i32$2 = $2 + 192 | 0;
                     i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                     $125 = i64toi32_i32$3;
                     i64toi32_i32$3 = $2 + 88 | 0;
                     HEAP32[i64toi32_i32$3 >> 2] = $125;
                     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
                     i64toi32_i32$2 = $2 + 184 | 0;
                     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                     i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                     $129 = i64toi32_i32$0;
                     i64toi32_i32$0 = $2;
                     HEAP32[($2 + 80 | 0) >> 2] = $129;
                     HEAP32[($2 + 84 | 0) >> 2] = i64toi32_i32$3;
                     $5 = HEAP32[($2 + 172 | 0) >> 2] | 0;
                     $3 = HEAP32[($2 + 168 | 0) >> 2] | 0;
                     i64toi32_i32$2 = $2 + 176 | 0;
                     i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                     $9 = i64toi32_i32$3;
                     $9$hi = i64toi32_i32$0;
                     break label$16;
                    }
                    i64toi32_i32$2 = $2;
                    i64toi32_i32$0 = HEAP32[($2 + 84 | 0) >> 2] | 0;
                    i64toi32_i32$3 = HEAP32[($2 + 88 | 0) >> 2] | 0;
                    $141 = i64toi32_i32$0;
                    i64toi32_i32$0 = $2;
                    HEAP32[($2 + 152 | 0) >> 2] = $141;
                    HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$3;
                    core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 152 | 0 | 0, 1050188 | 0, 1051856 | 0);
                    abort();
                   }
                   core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9($3 | 0);
                  }
                  i64toi32_i32$3 = $7$hi;
                  i64toi32_i32$0 = i64toi32_i32$3;
                  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__ScriptAll___deserialize_as_embedded_group__hbafeb78d3b233e94($2 + 152 | 0 | 0, $1 | 0, $7 | 0, i64toi32_i32$3 | 0, $7 | 0, i64toi32_i32$3 | 0);
                  $3 = 1;
                  if ((HEAP32[($2 + 152 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                   break label$10
                  }
                  memcpy(($2 + 8 | 0) + 8 | 0 | 0, memcpy($2 + 80 | 0 | 4 | 0 | 0, ($2 + 152 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
                  HEAP32[($2 + 8 | 0) >> 2] = 1;
                  i64toi32_i32$3 = $2;
                  i64toi32_i32$0 = 0;
                  HEAP32[($2 + 152 | 0) >> 2] = 0;
                  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
                  i64toi32_i32$0 = $8$hi;
                  i64toi32_i32$3 = $2;
                  HEAP32[($2 + 160 | 0) >> 2] = $8;
                  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$0;
                  $std__io__cursor__Cursor_T__20as_20std__io__Seek___seek__h4fe82da83d4d5304($2 + 80 | 0 | 0, $1 | 0, $2 + 152 | 0 | 0);
                  if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                   break label$5
                  }
                  core__ptr__drop_in_place_core__result__Result_cardano_serialization_lib__ScriptAll_2ccardano_serialization_lib__error__DeserializeError____hbd880b968031b052($2 + 8 | 0 | 0);
                  i64toi32_i32$0 = $7$hi;
                  i64toi32_i32$3 = i64toi32_i32$0;
                  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__ScriptAny___deserialize_as_embedded_group__h33b811880b7eeaff($2 + 152 | 0 | 0, $1 | 0, $7 | 0, i64toi32_i32$3 | 0, $7 | 0, i64toi32_i32$3 | 0);
                  if ((HEAP32[($2 + 152 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                   break label$11
                  }
                  memcpy(($2 + 8 | 0) + 8 | 0 | 0, memcpy($2 + 80 | 0 | 4 | 0 | 0, ($2 + 152 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
                  HEAP32[($2 + 8 | 0) >> 2] = 1;
                  i64toi32_i32$0 = $2;
                  i64toi32_i32$3 = 0;
                  HEAP32[($2 + 152 | 0) >> 2] = 0;
                  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$3;
                  i64toi32_i32$3 = $8$hi;
                  i64toi32_i32$0 = $2;
                  HEAP32[($2 + 160 | 0) >> 2] = $8;
                  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$3;
                  $std__io__cursor__Cursor_T__20as_20std__io__Seek___seek__h4fe82da83d4d5304($2 + 80 | 0 | 0, $1 | 0, $2 + 152 | 0 | 0);
                  if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                   break label$4
                  }
                  core__ptr__drop_in_place_core__result__Result_cardano_serialization_lib__ScriptAny_2ccardano_serialization_lib__error__DeserializeError____h226dd032529da919($2 + 8 | 0 | 0);
                  i64toi32_i32$3 = $7$hi;
                  i64toi32_i32$0 = i64toi32_i32$3;
                  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__ScriptNOfK___deserialize_as_embedded_group__hcd662792aa1dcf35($2 + 152 | 0 | 0, $1 | 0, $7 | 0, i64toi32_i32$3 | 0, $7 | 0, i64toi32_i32$3 | 0);
                  if ((HEAP32[($2 + 152 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                   break label$12
                  }
                  memcpy(($2 + 8 | 0) + 8 | 0 | 0, memcpy($2 + 80 | 0 | 4 | 0 | 0, ($2 + 152 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
                  HEAP32[($2 + 8 | 0) >> 2] = 1;
                  i64toi32_i32$3 = $2;
                  i64toi32_i32$0 = 0;
                  HEAP32[($2 + 152 | 0) >> 2] = 0;
                  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
                  i64toi32_i32$0 = $8$hi;
                  i64toi32_i32$3 = $2;
                  HEAP32[($2 + 160 | 0) >> 2] = $8;
                  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$0;
                  $std__io__cursor__Cursor_T__20as_20std__io__Seek___seek__h4fe82da83d4d5304($2 + 80 | 0 | 0, $1 | 0, $2 + 152 | 0 | 0);
                  if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                   break label$3
                  }
                  core__ptr__drop_in_place_core__result__Result_cardano_serialization_lib__ScriptNOfK_2ccardano_serialization_lib__error__DeserializeError____h17201b751208cb38($2 + 8 | 0 | 0);
                  i64toi32_i32$0 = $7$hi;
                  i64toi32_i32$3 = i64toi32_i32$0;
                  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__TimelockStart___deserialize_as_embedded_group__h4f29e66be5595f76($2 + 152 | 0 | 0, $1 | 0, $7 | 0, i64toi32_i32$3 | 0, $7 | 0, i64toi32_i32$3 | 0);
                  i64toi32_i32$2 = $2;
                  i64toi32_i32$3 = HEAP32[($2 + 160 | 0) >> 2] | 0;
                  i64toi32_i32$0 = HEAP32[($2 + 164 | 0) >> 2] | 0;
                  $9 = i64toi32_i32$3;
                  $9$hi = i64toi32_i32$0;
                  i64toi32_i32$2 = $2;
                  i64toi32_i32$0 = HEAP32[($2 + 152 | 0) >> 2] | 0;
                  i64toi32_i32$3 = HEAP32[($2 + 156 | 0) >> 2] | 0;
                  i64toi32_i32$2 = i64toi32_i32$0;
                  i64toi32_i32$0 = 0;
                  i64toi32_i32$1 = 1;
                  if ((i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | 0) {
                   break label$13
                  }
                  memcpy($2 + 80 | 0 | 0, ($2 + 152 | 0) + 16 | 0 | 0, 56 | 0) | 0;
                  memcpy(($2 + 8 | 0) + 16 | 0 | 0, $2 + 80 | 0 | 0, 56 | 0) | 0;
                  i64toi32_i32$2 = $9$hi;
                  i64toi32_i32$3 = $2;
                  HEAP32[($2 + 16 | 0) >> 2] = $9;
                  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$2;
                  i64toi32_i32$3 = $2;
                  i64toi32_i32$2 = 0;
                  HEAP32[($2 + 8 | 0) >> 2] = 1;
                  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$2;
                  i64toi32_i32$3 = $2;
                  i64toi32_i32$2 = 0;
                  HEAP32[($2 + 152 | 0) >> 2] = 0;
                  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$2;
                  i64toi32_i32$2 = $8$hi;
                  i64toi32_i32$3 = $2;
                  HEAP32[($2 + 160 | 0) >> 2] = $8;
                  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$2;
                  $std__io__cursor__Cursor_T__20as_20std__io__Seek___seek__h4fe82da83d4d5304($2 + 80 | 0 | 0, $1 | 0, $2 + 152 | 0 | 0);
                  if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                   break label$2
                  }
                  core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9($2 + 16 | 0 | 0);
                  i64toi32_i32$2 = $7$hi;
                  i64toi32_i32$3 = i64toi32_i32$2;
                  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__TimelockExpiry___deserialize_as_embedded_group__h31f31ef9c6de3fe5($2 + 152 | 0 | 0, $1 | 0, $7 | 0, i64toi32_i32$3 | 0, $7 | 0, i64toi32_i32$3 | 0);
                  i64toi32_i32$1 = $2;
                  i64toi32_i32$3 = HEAP32[($2 + 160 | 0) >> 2] | 0;
                  i64toi32_i32$2 = HEAP32[($2 + 164 | 0) >> 2] | 0;
                  $9 = i64toi32_i32$3;
                  $9$hi = i64toi32_i32$2;
                  i64toi32_i32$1 = $2;
                  i64toi32_i32$2 = HEAP32[($2 + 152 | 0) >> 2] | 0;
                  i64toi32_i32$3 = HEAP32[($2 + 156 | 0) >> 2] | 0;
                  i64toi32_i32$1 = i64toi32_i32$2;
                  i64toi32_i32$2 = 0;
                  i64toi32_i32$0 = 1;
                  if ((i64toi32_i32$1 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$3 | 0) != (i64toi32_i32$2 | 0) | 0) {
                   break label$14
                  }
                  memcpy($2 + 80 | 0 | 0, ($2 + 152 | 0) + 16 | 0 | 0, 56 | 0) | 0;
                  memcpy(($2 + 8 | 0) + 16 | 0 | 0, $2 + 80 | 0 | 0, 56 | 0) | 0;
                  i64toi32_i32$1 = $9$hi;
                  i64toi32_i32$3 = $2;
                  HEAP32[($2 + 16 | 0) >> 2] = $9;
                  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$1;
                  i64toi32_i32$3 = $2;
                  i64toi32_i32$1 = 0;
                  HEAP32[($2 + 8 | 0) >> 2] = 1;
                  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
                  i64toi32_i32$3 = $2;
                  i64toi32_i32$1 = 0;
                  HEAP32[($2 + 152 | 0) >> 2] = 0;
                  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$1;
                  i64toi32_i32$1 = $8$hi;
                  i64toi32_i32$3 = $2;
                  HEAP32[($2 + 160 | 0) >> 2] = $8;
                  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
                  $std__io__cursor__Cursor_T__20as_20std__io__Seek___seek__h4fe82da83d4d5304($2 + 80 | 0 | 0, $1 | 0, $2 + 152 | 0 | 0);
                  if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                   break label$1
                  }
                  core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9($2 + 16 | 0 | 0);
                  i64toi32_i32$1 = $7$hi;
                  i64toi32_i32$0 = $7;
                  i64toi32_i32$3 = 0;
                  i64toi32_i32$2 = 1;
                  if ((i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) | 0) {
                   break label$8
                  }
                  cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 152 | 0 | 0, $1 | 0);
                  $3 = HEAPU8[($2 + 160 | 0) >> 0] | 0;
                  label$23 : {
                   i64toi32_i32$2 = $2;
                   i64toi32_i32$0 = HEAP32[($2 + 152 | 0) >> 2] | 0;
                   i64toi32_i32$1 = HEAP32[($2 + 156 | 0) >> 2] | 0;
                   i64toi32_i32$2 = i64toi32_i32$0;
                   i64toi32_i32$0 = 0;
                   i64toi32_i32$3 = 1;
                   if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
                    break label$23
                   }
                   $1 = 5;
                   if (($3 & 255 | 0 | 0) == (5 | 0)) {
                    break label$8
                   }
                   break label$15;
                  }
                  i64toi32_i32$3 = $2 + 192 | 0;
                  i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                  i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                  $7 = i64toi32_i32$2;
                  $7$hi = i64toi32_i32$1;
                  i64toi32_i32$2 = ($2 + 8 | 0) + 8 | 0;
                  HEAP32[i64toi32_i32$2 >> 2] = $7;
                  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
                  i64toi32_i32$2 = ($2 + 80 | 0) + 8 | 0;
                  HEAP32[i64toi32_i32$2 >> 2] = $7;
                  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
                  i64toi32_i32$3 = $2 + 184 | 0;
                  i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                  $7 = i64toi32_i32$1;
                  $7$hi = i64toi32_i32$2;
                  i64toi32_i32$1 = $2;
                  HEAP32[($2 + 8 | 0) >> 2] = $7;
                  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$2;
                  i64toi32_i32$1 = $2;
                  HEAP32[($2 + 80 | 0) >> 2] = $7;
                  HEAP32[($2 + 84 | 0) >> 2] = i64toi32_i32$2;
                  i64toi32_i32$3 = $2;
                  i64toi32_i32$2 = HEAPU8[($2 + 161 | 0) >> 0] | 0 | ((HEAPU8[($2 + 162 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 163 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 164 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                  i64toi32_i32$1 = 0;
                  $352 = i64toi32_i32$2;
                  $352$hi = i64toi32_i32$1;
                  i64toi32_i32$3 = $2 + 165 | 0;
                  i64toi32_i32$1 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
                  i64toi32_i32$2 = 0;
                  $355 = i64toi32_i32$1;
                  $355$hi = i64toi32_i32$2;
                  i64toi32_i32$3 = $2 + 167 | 0;
                  i64toi32_i32$2 = HEAPU8[i64toi32_i32$3 >> 0] | 0;
                  i64toi32_i32$1 = 0;
                  i64toi32_i32$3 = i64toi32_i32$2;
                  i64toi32_i32$2 = 0;
                  i64toi32_i32$0 = 16;
                  i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
                  if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
                   i64toi32_i32$2 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
                   $54 = 0;
                  } else {
                   i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
                   $54 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
                  }
                  $359$hi = i64toi32_i32$2;
                  i64toi32_i32$2 = $355$hi;
                  i64toi32_i32$1 = $355;
                  i64toi32_i32$3 = $359$hi;
                  i64toi32_i32$0 = $54;
                  i64toi32_i32$3 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
                  i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
                  i64toi32_i32$1 = 0;
                  i64toi32_i32$0 = 32;
                  i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
                  if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
                   i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
                   $55 = 0;
                  } else {
                   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$4 | 0) | 0;
                   $55 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
                  }
                  $361$hi = i64toi32_i32$1;
                  i64toi32_i32$1 = $352$hi;
                  i64toi32_i32$3 = $352;
                  i64toi32_i32$2 = $361$hi;
                  i64toi32_i32$0 = $55;
                  i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
                  i64toi32_i32$1 = i64toi32_i32$3 | i64toi32_i32$0 | 0;
                  i64toi32_i32$3 = 0;
                  i64toi32_i32$0 = 8;
                  i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
                  if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
                   i64toi32_i32$3 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
                   $56 = 0;
                  } else {
                   i64toi32_i32$3 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
                   $56 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
                  }
                  $363$hi = i64toi32_i32$3;
                  i64toi32_i32$3 = 0;
                  i64toi32_i32$2 = $3;
                  i64toi32_i32$1 = 0;
                  i64toi32_i32$0 = 255;
                  i64toi32_i32$1 = i64toi32_i32$3 & i64toi32_i32$1 | 0;
                  $366 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
                  $366$hi = i64toi32_i32$1;
                  i64toi32_i32$1 = $363$hi;
                  i64toi32_i32$3 = $56;
                  i64toi32_i32$2 = $366$hi;
                  i64toi32_i32$0 = $366;
                  i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
                  $7 = i64toi32_i32$3 | i64toi32_i32$0 | 0;
                  $7$hi = i64toi32_i32$2;
                  $5 = HEAP32[($2 + 172 | 0) >> 2] | 0;
                  $3 = HEAP32[($2 + 168 | 0) >> 2] | 0;
                  i64toi32_i32$1 = $2 + 176 | 0;
                  i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                  i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                  $9 = i64toi32_i32$2;
                  $9$hi = i64toi32_i32$3;
                 }
                 $1 = 2;
                }
                $4 = 0;
                break label$7;
               }
               $3 = 5;
               break label$9;
              }
              $3 = 4;
              break label$9;
             }
             i64toi32_i32$1 = ($2 + 152 | 0) + 12 | 0;
             i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
             i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
             $383 = i64toi32_i32$3;
             i64toi32_i32$3 = ($2 + 8 | 0) + 12 | 0;
             HEAP32[i64toi32_i32$3 >> 2] = $383;
             HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
             i64toi32_i32$1 = $2;
             i64toi32_i32$2 = HEAP32[($2 + 156 | 0) >> 2] | 0;
             i64toi32_i32$3 = HEAP32[($2 + 160 | 0) >> 2] | 0;
             $7 = i64toi32_i32$2;
             $7$hi = i64toi32_i32$3;
             i64toi32_i32$2 = $2;
             HEAP32[($2 + 12 | 0) >> 2] = $7;
             HEAP32[($2 + 16 | 0) >> 2] = i64toi32_i32$3;
             $5 = HEAP32[($2 + 24 | 0) >> 2] | 0;
             i64toi32_i32$1 = $2 + 16 | 0;
             i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
             i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
             $9 = i64toi32_i32$3;
             $9$hi = i64toi32_i32$2;
             i64toi32_i32$2 = $7$hi;
             $1 = $7;
             $3 = 3;
             break label$9;
            }
            HEAP32[(($2 + 8 | 0) + 12 | 0) >> 2] = HEAP32[(($2 + 152 | 0) + 12 | 0) >> 2] | 0;
            i64toi32_i32$1 = $2;
            i64toi32_i32$2 = HEAP32[($2 + 156 | 0) >> 2] | 0;
            i64toi32_i32$3 = HEAP32[($2 + 160 | 0) >> 2] | 0;
            $7 = i64toi32_i32$2;
            $7$hi = i64toi32_i32$3;
            i64toi32_i32$2 = $2;
            HEAP32[($2 + 12 | 0) >> 2] = $7;
            HEAP32[($2 + 16 | 0) >> 2] = i64toi32_i32$3;
            i64toi32_i32$1 = $2 + 16 | 0;
            i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
            i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
            $9 = i64toi32_i32$3;
            $9$hi = i64toi32_i32$2;
            i64toi32_i32$2 = $7$hi;
            $1 = $7;
            $3 = 2;
            break label$9;
           }
           HEAP32[(($2 + 8 | 0) + 12 | 0) >> 2] = HEAP32[(($2 + 152 | 0) + 12 | 0) >> 2] | 0;
           i64toi32_i32$1 = $2;
           i64toi32_i32$2 = HEAP32[($2 + 156 | 0) >> 2] | 0;
           i64toi32_i32$3 = HEAP32[($2 + 160 | 0) >> 2] | 0;
           $7 = i64toi32_i32$2;
           $7$hi = i64toi32_i32$3;
           i64toi32_i32$2 = $2;
           HEAP32[($2 + 12 | 0) >> 2] = $7;
           HEAP32[($2 + 16 | 0) >> 2] = i64toi32_i32$3;
           i64toi32_i32$1 = $2 + 16 | 0;
           i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $9 = i64toi32_i32$3;
           $9$hi = i64toi32_i32$2;
           i64toi32_i32$2 = $7$hi;
           $1 = $7;
          }
          HEAP8[($0 + 8 | 0) >> 0] = $3;
          $57 = HEAPU16[($2 + 4 | 0) >> 1] | 0;
          HEAP8[($0 + 9 | 0) >> 0] = $57;
          HEAP8[($0 + 10 | 0) >> 0] = $57 >>> 8 | 0;
          HEAP32[($0 + 28 | 0) >> 2] = $4;
          HEAP32[($0 + 12 | 0) >> 2] = $1;
          i64toi32_i32$2 = $7$hi;
          i64toi32_i32$3 = $0 + 32 | 0;
          HEAP32[i64toi32_i32$3 >> 2] = $7;
          HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
          HEAP32[($0 + 24 | 0) >> 2] = $5;
          i64toi32_i32$2 = $9$hi;
          i64toi32_i32$3 = $0 + 16 | 0;
          HEAP32[i64toi32_i32$3 >> 2] = $9;
          HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
          HEAP8[($0 + 11 | 0) >> 0] = HEAPU8[($2 + 6 | 0) >> 0] | 0;
          i64toi32_i32$2 = 0;
          $7 = 0;
          $7$hi = i64toi32_i32$2;
          break label$6;
         }
         alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($2 + 200 | 0 | 0, 1051952 | 0, 16 | 0);
         HEAP8[($2 + 6 | 0) >> 0] = HEAPU8[($2 + 155 | 0) >> 0] | 0;
         i64toi32_i32$1 = $2 + 192 | 0;
         i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
         $462 = i64toi32_i32$2;
         i64toi32_i32$2 = ($2 + 80 | 0) + 8 | 0;
         HEAP32[i64toi32_i32$2 >> 2] = $462;
         HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
         HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 212 | 0) >> 2] | 0;
         HEAP16[($2 + 4 | 0) >> 1] = HEAPU8[($2 + 153 | 0) >> 0] | 0 | ((HEAPU8[($2 + 154 | 0) >> 0] | 0) << 8 | 0) | 0;
         i64toi32_i32$1 = $2 + 184 | 0;
         i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
         $475 = i64toi32_i32$3;
         i64toi32_i32$3 = $2;
         HEAP32[($2 + 80 | 0) >> 2] = $475;
         HEAP32[($2 + 84 | 0) >> 2] = i64toi32_i32$2;
         i64toi32_i32$1 = $2 + 204 | 0;
         i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
         $479 = i64toi32_i32$2;
         i64toi32_i32$2 = $2;
         HEAP32[($2 + 8 | 0) >> 2] = $479;
         HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$3;
         i64toi32_i32$1 = ($2 + 152 | 0) + 8 | 0;
         i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
         $7 = i64toi32_i32$3;
         $7$hi = i64toi32_i32$2;
         $3 = HEAP32[(($2 + 152 | 0) + 16 | 0) >> 2] | 0;
         $5 = HEAP32[($2 + 172 | 0) >> 2] | 0;
         i64toi32_i32$1 = $2 + 176 | 0;
         i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
         $9 = i64toi32_i32$2;
         $9$hi = i64toi32_i32$3;
         $6 = HEAP32[($2 + 156 | 0) >> 2] | 0;
         $4 = HEAP32[($2 + 200 | 0) >> 2] | 0;
         $1 = 11;
        }
        i64toi32_i32$3 = $9$hi;
        i64toi32_i32$2 = $2 + 176 | 0;
        HEAP32[i64toi32_i32$2 >> 2] = $9;
        HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
        HEAP32[($2 + 172 | 0) >> 2] = $5;
        HEAP32[(($2 + 152 | 0) + 16 | 0) >> 2] = $3;
        i64toi32_i32$3 = $7$hi;
        i64toi32_i32$2 = ($2 + 152 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$2 >> 2] = $7;
        HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
        i64toi32_i32$1 = $2;
        i64toi32_i32$3 = HEAP32[($2 + 80 | 0) >> 2] | 0;
        i64toi32_i32$2 = HEAP32[($2 + 84 | 0) >> 2] | 0;
        $515 = i64toi32_i32$3;
        i64toi32_i32$3 = $2 + 184 | 0;
        HEAP32[i64toi32_i32$3 >> 2] = $515;
        HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
        i64toi32_i32$1 = $2;
        i64toi32_i32$2 = HEAP32[($2 + 8 | 0) >> 2] | 0;
        i64toi32_i32$3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
        $519 = i64toi32_i32$2;
        i64toi32_i32$2 = $2 + 204 | 0;
        HEAP32[i64toi32_i32$2 >> 2] = $519;
        HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
        i64toi32_i32$1 = ($2 + 80 | 0) + 8 | 0;
        i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
        $525 = i64toi32_i32$3;
        i64toi32_i32$3 = $2 + 192 | 0;
        HEAP32[i64toi32_i32$3 >> 2] = $525;
        HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
        HEAP32[($2 + 212 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
        HEAP8[($2 + 152 | 0) >> 0] = $1;
        $58 = HEAPU16[($2 + 4 | 0) >> 1] | 0;
        HEAP8[($2 + 153 | 0) >> 0] = $58;
        HEAP8[($2 + 154 | 0) >> 0] = $58 >>> 8 | 0;
        HEAP32[($2 + 156 | 0) >> 2] = $6;
        HEAP32[($2 + 200 | 0) >> 2] = $4;
        HEAP8[($2 + 155 | 0) >> 0] = HEAPU8[($2 + 6 | 0) >> 0] | 0;
        cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 152 | 0 | 0, 1051952 | 0, 16 | 0);
        i64toi32_i32$2 = 0;
        $7 = 1;
        $7$hi = i64toi32_i32$2;
       }
       i64toi32_i32$2 = $7$hi;
       i64toi32_i32$3 = $0;
       HEAP32[i64toi32_i32$3 >> 2] = $7;
       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
       global$0 = $2 + 224 | 0;
       return;
      }
      i64toi32_i32$1 = $2;
      i64toi32_i32$2 = HEAP32[($2 + 84 | 0) >> 2] | 0;
      i64toi32_i32$3 = HEAP32[($2 + 88 | 0) >> 2] | 0;
      $555 = i64toi32_i32$2;
      i64toi32_i32$2 = $2;
      HEAP32[($2 + 152 | 0) >> 2] = $555;
      HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$3;
      core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 152 | 0 | 0, 1050188 | 0, 1051872 | 0);
      abort();
     }
     i64toi32_i32$1 = $2;
     i64toi32_i32$3 = HEAP32[($2 + 84 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[($2 + 88 | 0) >> 2] | 0;
     $560 = i64toi32_i32$3;
     i64toi32_i32$3 = $2;
     HEAP32[($2 + 152 | 0) >> 2] = $560;
     HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$2;
     core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 152 | 0 | 0, 1050188 | 0, 1051888 | 0);
     abort();
    }
    i64toi32_i32$1 = $2;
    i64toi32_i32$2 = HEAP32[($2 + 84 | 0) >> 2] | 0;
    i64toi32_i32$3 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    $565 = i64toi32_i32$2;
    i64toi32_i32$2 = $2;
    HEAP32[($2 + 152 | 0) >> 2] = $565;
    HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$3;
    core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 152 | 0 | 0, 1050188 | 0, 1051904 | 0);
    abort();
   }
   i64toi32_i32$1 = $2;
   i64toi32_i32$3 = HEAP32[($2 + 84 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($2 + 88 | 0) >> 2] | 0;
   $570 = i64toi32_i32$3;
   i64toi32_i32$3 = $2;
   HEAP32[($2 + 152 | 0) >> 2] = $570;
   HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$2;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 152 | 0 | 0, 1050188 | 0, 1051920 | 0);
   abort();
  }
  i64toi32_i32$1 = $2;
  i64toi32_i32$2 = HEAP32[($2 + 84 | 0) >> 2] | 0;
  i64toi32_i32$3 = HEAP32[($2 + 88 | 0) >> 2] | 0;
  $575 = i64toi32_i32$2;
  i64toi32_i32$2 = $2;
  HEAP32[($2 + 152 | 0) >> 2] = $575;
  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$3;
  core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 152 | 0 | 0, 1050188 | 0, 1051936 | 0);
  abort();
 }
 
 function $cardano_serialization_lib__utils__TransactionUnspentOutput_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h529cf0452d59832b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $12 = 0, i64toi32_i32$4 = 0, $12$hi = 0, $3 = 0, $7 = 0, $13 = 0, $13$hi = 0, $14 = 0, $14$hi = 0, $4 = 0, $9 = 0, $8 = 0, $69 = 0, $70 = 0, $71 = 0, $72 = 0, $5 = 0, $73 = 0, $74 = 0, $17 = 0, $17$hi = 0, $18 = 0, $18$hi = 0, $19 = 0, $19$hi = 0, $10 = 0, $75 = 0, $76 = 0, $77 = 0, $78 = 0, $79 = 0, $80 = 0, $81 = 0, $82 = 0, $83 = 0, $84 = 0, $85 = 0, $86 = 0, $87 = 0, $88 = 0, $89 = 0, $90 = 0, $91 = 0, $92 = 0, $93 = 0, $94 = 0, $11 = 0, $95 = 0, $96 = 0, $97 = 0, $15 = 0, $15$hi = 0, $16 = 0, $16$hi = 0, $6 = 0, $129 = 0, $150 = 0, $153 = 0, $183 = 0, $198 = 0, $201 = 0, $222 = 0, $227 = 0, $235 = 0, $323 = 0, $323$hi = 0, $326 = 0, $326$hi = 0, $330$hi = 0, $332$hi = 0, $334$hi = 0, $337 = 0, $337$hi = 0, $354 = 0, $358 = 0, $386 = 0, $403 = 0, $407 = 0, $453 = 0, $472 = 0, $475 = 0, $497 = 0, $509 = 0, $512 = 0, $519 = 0, $527 = 0, $564 = 0, $571 = 0, $591 = 0, $595 = 0, $601 = 0;
  $2 = global$0 - 768 | 0;
  global$0 = $2;
  std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 8 | 0 | 0, $1 | 0);
  $3 = 2;
  $4 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     if (HEAP32[($2 + 12 | 0) >> 2] | 0) {
      break label$3
     }
     i64toi32_i32$0 = 0;
     $12 = 8;
     $12$hi = i64toi32_i32$0;
     i64toi32_i32$0 = 0;
     $13 = 0;
     $13$hi = i64toi32_i32$0;
     break label$2;
    }
    label$4 : {
     label$5 : {
      label$6 : {
       label$7 : {
        label$8 : {
         if ((($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[($2 + 8 | 0) >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) != (4 | 0)) {
          break label$8
         }
         cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 464 | 0 | 0, $1 | 0);
         i64toi32_i32$2 = $2 + 480 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $13 = i64toi32_i32$0;
         $13$hi = i64toi32_i32$1;
         i64toi32_i32$2 = $2;
         i64toi32_i32$1 = HEAP32[($2 + 472 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($2 + 476 | 0) >> 2] | 0;
         $12 = i64toi32_i32$1;
         $12$hi = i64toi32_i32$0;
         i64toi32_i32$2 = $2;
         i64toi32_i32$0 = HEAP32[($2 + 464 | 0) >> 2] | 0;
         i64toi32_i32$1 = HEAP32[($2 + 468 | 0) >> 2] | 0;
         i64toi32_i32$2 = i64toi32_i32$0;
         i64toi32_i32$0 = 0;
         i64toi32_i32$3 = 1;
         if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
          break label$7
         }
         cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__TransactionInput___deserialize__h84b981706980e1e2($2 + 464 | 0 | 0, $1 | 0);
         if ((HEAP32[($2 + 464 | 0) >> 2] | 0 | 0) == (1 | 0)) {
          break label$6
         }
         memcpy($2 + 328 | 0 | 0, $2 + 464 | 0 | 4 | 0 | 0, 36 | 0) | 0;
         memcpy($2 + 640 | 0 | 4 | 0 | 0, memcpy($2 + 192 | 0 | 4 | 0 | 0, $2 + 328 | 0 | 0, 36 | 0) | 0 | 0, 36 | 0) | 0;
         $70 = ($2 + 640 | 0) + 12 | 0;
         $71 = HEAPU8[$70 >> 0] | 0 | ((HEAPU8[($70 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($70 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($70 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[($2 + 51 | 0) >> 0] = $71;
         HEAP8[($2 + 52 | 0) >> 0] = $71 >>> 8 | 0;
         HEAP8[($2 + 53 | 0) >> 0] = $71 >>> 16 | 0;
         HEAP8[($2 + 54 | 0) >> 0] = $71 >>> 24 | 0;
         HEAP32[($2 + 48 | 0) >> 2] = HEAPU8[($2 + 649 | 0) >> 0] | 0 | ((HEAPU8[($2 + 650 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 651 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 652 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP32[($2 + 40 | 0) >> 2] = HEAP32[($2 + 48 | 0) >> 2] | 0;
         $72 = HEAPU8[($2 + 51 | 0) >> 0] | 0 | ((HEAPU8[($2 + 52 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 53 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 54 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[($2 + 43 | 0) >> 0] = $72;
         HEAP8[($2 + 44 | 0) >> 0] = $72 >>> 8 | 0;
         HEAP8[($2 + 45 | 0) >> 0] = $72 >>> 16 | 0;
         HEAP8[($2 + 46 | 0) >> 0] = $72 >>> 24 | 0;
         $5 = HEAPU8[(($2 + 640 | 0) + 8 | 0) >> 0] | 0;
         i64toi32_i32$3 = ($2 + 640 | 0) + 16 | 0;
         i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $14 = i64toi32_i32$2;
         $14$hi = i64toi32_i32$1;
         i64toi32_i32$3 = ($2 + 640 | 0) + 24 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $15 = i64toi32_i32$1;
         $15$hi = i64toi32_i32$2;
         i64toi32_i32$3 = ($2 + 640 | 0) + 32 | 0;
         i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $16 = i64toi32_i32$2;
         $16$hi = i64toi32_i32$1;
         $6 = HEAP32[($2 + 644 | 0) >> 2] | 0;
         cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__TransactionOutput___deserialize__haabae074445f3776($2 + 464 | 0 | 0, $1 | 0);
         $7 = ($2 + 464 | 0) + 8 | 0;
         i64toi32_i32$3 = $2;
         i64toi32_i32$1 = HEAP32[($2 + 464 | 0) >> 2] | 0;
         i64toi32_i32$2 = HEAP32[($2 + 468 | 0) >> 2] | 0;
         i64toi32_i32$3 = i64toi32_i32$1;
         i64toi32_i32$1 = 0;
         i64toi32_i32$0 = 1;
         if ((i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$1 | 0) | 0) {
          break label$5
         }
         memcpy($2 + 640 | 0 | 0, $7 | 0, 128 | 0) | 0;
         memcpy(($2 + 192 | 0) + 8 | 0 | 0, memcpy(($2 + 328 | 0) + 8 | 0 | 0, $2 + 640 | 0 | 0, 128 | 0) | 0 | 0, 128 | 0) | 0;
         $8 = ($2 + 168 | 0) + 8 | 0;
         i64toi32_i32$0 = ($2 + 192 | 0) + 48 | 0;
         i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
         $129 = i64toi32_i32$3;
         i64toi32_i32$3 = $8;
         HEAP32[i64toi32_i32$3 >> 2] = $129;
         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
         $9 = ($2 + 152 | 0) + 8 | 0;
         HEAP32[$9 >> 2] = HEAP32[(($2 + 192 | 0) + 68 | 0) >> 2] | 0;
         HEAP32[($2 + 184 | 0) >> 2] = HEAPU8[($2 + 201 | 0) >> 0] | 0 | ((HEAPU8[($2 + 202 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 203 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 204 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $73 = ($2 + 192 | 0) + 12 | 0;
         $74 = HEAPU8[$73 >> 0] | 0 | ((HEAPU8[($73 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($73 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($73 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[($2 + 187 | 0) >> 0] = $74;
         HEAP8[($2 + 188 | 0) >> 0] = $74 >>> 8 | 0;
         HEAP8[($2 + 189 | 0) >> 0] = $74 >>> 16 | 0;
         HEAP8[($2 + 190 | 0) >> 0] = $74 >>> 24 | 0;
         i64toi32_i32$0 = ($2 + 192 | 0) + 40 | 0;
         i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
         $150 = i64toi32_i32$2;
         i64toi32_i32$2 = $2;
         HEAP32[($2 + 168 | 0) >> 2] = $150;
         HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$3;
         i64toi32_i32$0 = $2;
         i64toi32_i32$3 = HEAP32[($2 + 252 | 0) >> 2] | 0;
         i64toi32_i32$2 = HEAP32[($2 + 256 | 0) >> 2] | 0;
         $153 = i64toi32_i32$3;
         i64toi32_i32$3 = $2;
         HEAP32[($2 + 152 | 0) >> 2] = $153;
         HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$2;
         i64toi32_i32$0 = ($2 + 192 | 0) + 16 | 0;
         i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
         $17 = i64toi32_i32$2;
         $17$hi = i64toi32_i32$3;
         i64toi32_i32$0 = ($2 + 192 | 0) + 24 | 0;
         i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
         $18 = i64toi32_i32$3;
         $18$hi = i64toi32_i32$2;
         i64toi32_i32$0 = ($2 + 192 | 0) + 32 | 0;
         i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
         $19 = i64toi32_i32$2;
         $19$hi = i64toi32_i32$3;
         $10 = HEAP32[(($2 + 192 | 0) + 56 | 0) >> 2] | 0;
         $3 = HEAPU8[($2 + 200 | 0) >> 0] | 0;
         memcpy($2 + 48 | 0 | 0, ($2 + 192 | 0) + 72 | 0 | 0, 64 | 0) | 0;
         $11 = ($2 + 128 | 0) + 8 | 0;
         i64toi32_i32$0 = $8;
         i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
         $183 = i64toi32_i32$3;
         i64toi32_i32$3 = $11;
         HEAP32[i64toi32_i32$3 >> 2] = $183;
         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
         $8 = ($2 + 112 | 0) + 8 | 0;
         HEAP32[$8 >> 2] = HEAP32[$9 >> 2] | 0;
         HEAP32[($2 + 144 | 0) >> 2] = HEAP32[($2 + 184 | 0) >> 2] | 0;
         $75 = HEAPU8[($2 + 187 | 0) >> 0] | 0 | ((HEAPU8[($2 + 188 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 189 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 190 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[($2 + 147 | 0) >> 0] = $75;
         HEAP8[($2 + 148 | 0) >> 0] = $75 >>> 8 | 0;
         HEAP8[($2 + 149 | 0) >> 0] = $75 >>> 16 | 0;
         HEAP8[($2 + 150 | 0) >> 0] = $75 >>> 24 | 0;
         i64toi32_i32$0 = $2;
         i64toi32_i32$2 = HEAP32[($2 + 168 | 0) >> 2] | 0;
         i64toi32_i32$3 = HEAP32[($2 + 172 | 0) >> 2] | 0;
         $198 = i64toi32_i32$2;
         i64toi32_i32$2 = $2;
         HEAP32[($2 + 128 | 0) >> 2] = $198;
         HEAP32[($2 + 132 | 0) >> 2] = i64toi32_i32$3;
         i64toi32_i32$0 = $2;
         i64toi32_i32$3 = HEAP32[($2 + 152 | 0) >> 2] | 0;
         i64toi32_i32$2 = HEAP32[($2 + 156 | 0) >> 2] | 0;
         $201 = i64toi32_i32$3;
         i64toi32_i32$3 = $2;
         HEAP32[($2 + 112 | 0) >> 2] = $201;
         HEAP32[($2 + 116 | 0) >> 2] = i64toi32_i32$2;
         $76 = $2 + 608 | 0;
         $77 = HEAPU8[($2 + 43 | 0) >> 0] | 0 | ((HEAPU8[($2 + 44 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 45 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 46 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[$76 >> 0] = $77;
         HEAP8[($76 + 1 | 0) >> 0] = $77 >>> 8 | 0;
         HEAP8[($76 + 2 | 0) >> 0] = $77 >>> 16 | 0;
         HEAP8[($76 + 3 | 0) >> 0] = $77 >>> 24 | 0;
         $78 = HEAP32[($2 + 40 | 0) >> 2] | 0;
         HEAP8[($2 + 605 | 0) >> 0] = $78;
         HEAP8[($2 + 606 | 0) >> 0] = $78 >>> 8 | 0;
         HEAP8[($2 + 607 | 0) >> 0] = $78 >>> 16 | 0;
         HEAP8[($2 + 608 | 0) >> 0] = $78 >>> 24 | 0;
         $79 = ($2 + 464 | 0) + 12 | 0;
         $80 = HEAPU8[($2 + 147 | 0) >> 0] | 0 | ((HEAPU8[($2 + 148 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 149 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 150 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[$79 >> 0] = $80;
         HEAP8[($79 + 1 | 0) >> 0] = $80 >>> 8 | 0;
         HEAP8[($79 + 2 | 0) >> 0] = $80 >>> 16 | 0;
         HEAP8[($79 + 3 | 0) >> 0] = $80 >>> 24 | 0;
         $81 = HEAP32[($2 + 144 | 0) >> 2] | 0;
         HEAP8[($2 + 473 | 0) >> 0] = $81;
         HEAP8[($2 + 474 | 0) >> 0] = $81 >>> 8 | 0;
         HEAP8[($2 + 475 | 0) >> 0] = $81 >>> 16 | 0;
         HEAP8[($2 + 476 | 0) >> 0] = $81 >>> 24 | 0;
         $9 = ($2 + 464 | 0) + 40 | 0;
         i64toi32_i32$0 = $2;
         i64toi32_i32$2 = HEAP32[($2 + 128 | 0) >> 2] | 0;
         i64toi32_i32$3 = HEAP32[($2 + 132 | 0) >> 2] | 0;
         $222 = i64toi32_i32$2;
         i64toi32_i32$2 = $9;
         HEAP32[i64toi32_i32$2 >> 2] = $222;
         HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
         i64toi32_i32$0 = $11;
         i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
         $227 = i64toi32_i32$3;
         i64toi32_i32$3 = ($2 + 464 | 0) + 48 | 0;
         HEAP32[i64toi32_i32$3 >> 2] = $227;
         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
         HEAP32[(($2 + 464 | 0) + 68 | 0) >> 2] = HEAP32[$8 >> 2] | 0;
         i64toi32_i32$0 = $2;
         i64toi32_i32$2 = HEAP32[($2 + 112 | 0) >> 2] | 0;
         i64toi32_i32$3 = HEAP32[($2 + 116 | 0) >> 2] | 0;
         $235 = i64toi32_i32$2;
         i64toi32_i32$2 = $2;
         HEAP32[($2 + 524 | 0) >> 2] = $235;
         HEAP32[($2 + 528 | 0) >> 2] = i64toi32_i32$3;
         memcpy(($2 + 464 | 0) + 72 | 0 | 0, $2 + 48 | 0 | 0, 64 | 0) | 0;
         i64toi32_i32$3 = $16$hi;
         i64toi32_i32$2 = $2 + 628 | 0;
         HEAP32[i64toi32_i32$2 >> 2] = $16;
         HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
         i64toi32_i32$3 = $15$hi;
         i64toi32_i32$2 = $2 + 620 | 0;
         HEAP32[i64toi32_i32$2 >> 2] = $15;
         HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
         i64toi32_i32$3 = $14$hi;
         i64toi32_i32$2 = $2 + 612 | 0;
         HEAP32[i64toi32_i32$2 >> 2] = $14;
         HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
         HEAP32[($2 + 600 | 0) >> 2] = $6;
         HEAP32[(($2 + 464 | 0) + 56 | 0) >> 2] = $10;
         i64toi32_i32$3 = $19$hi;
         i64toi32_i32$2 = ($2 + 464 | 0) + 32 | 0;
         HEAP32[i64toi32_i32$2 >> 2] = $19;
         HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
         i64toi32_i32$3 = $18$hi;
         i64toi32_i32$2 = ($2 + 464 | 0) + 24 | 0;
         HEAP32[i64toi32_i32$2 >> 2] = $18;
         HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
         i64toi32_i32$3 = $17$hi;
         i64toi32_i32$2 = ($2 + 464 | 0) + 16 | 0;
         HEAP32[i64toi32_i32$2 >> 2] = $17;
         HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
         HEAP8[($2 + 604 | 0) >> 0] = $5;
         HEAP8[($2 + 472 | 0) >> 0] = $3;
         i64toi32_i32$2 = $2;
         i64toi32_i32$3 = 0;
         HEAP32[($2 + 464 | 0) >> 2] = 0;
         HEAP32[($2 + 468 | 0) >> 2] = i64toi32_i32$3;
         label$9 : {
          label$10 : {
           label$11 : {
            label$12 : {
             label$13 : {
              i64toi32_i32$3 = $12$hi;
              i64toi32_i32$0 = $12;
              i64toi32_i32$2 = 0;
              i64toi32_i32$1 = 1;
              if ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) | 0) {
               break label$13
              }
              cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 328 | 0 | 0, $1 | 0);
              $1 = HEAPU8[($2 + 336 | 0) >> 0] | 0;
              i64toi32_i32$1 = $2;
              i64toi32_i32$0 = HEAP32[($2 + 328 | 0) >> 2] | 0;
              i64toi32_i32$3 = HEAP32[($2 + 332 | 0) >> 2] | 0;
              i64toi32_i32$1 = i64toi32_i32$0;
              i64toi32_i32$0 = 0;
              i64toi32_i32$2 = 1;
              if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) | 0) {
               break label$12
              }
              $3 = 5;
              if (($1 & 255 | 0 | 0) != (5 | 0)) {
               break label$11
              }
              i64toi32_i32$2 = $2;
              i64toi32_i32$1 = HEAP32[($2 + 464 | 0) >> 2] | 0;
              i64toi32_i32$3 = HEAP32[($2 + 468 | 0) >> 2] | 0;
              i64toi32_i32$2 = i64toi32_i32$1;
              i64toi32_i32$1 = 0;
              i64toi32_i32$0 = 1;
              $1 = (i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) | 0;
              $10 = HEAP32[($2 + 520 | 0) >> 2] | 0;
              i64toi32_i32$0 = $2;
              i64toi32_i32$2 = HEAP32[($2 + 496 | 0) >> 2] | 0;
              i64toi32_i32$3 = HEAP32[($2 + 500 | 0) >> 2] | 0;
              $19 = i64toi32_i32$2;
              $19$hi = i64toi32_i32$3;
              i64toi32_i32$0 = $2;
              i64toi32_i32$3 = HEAP32[($2 + 488 | 0) >> 2] | 0;
              i64toi32_i32$2 = HEAP32[($2 + 492 | 0) >> 2] | 0;
              $18 = i64toi32_i32$3;
              $18$hi = i64toi32_i32$2;
              i64toi32_i32$0 = $2;
              i64toi32_i32$2 = HEAP32[($2 + 480 | 0) >> 2] | 0;
              i64toi32_i32$3 = HEAP32[($2 + 484 | 0) >> 2] | 0;
              $17 = i64toi32_i32$2;
              $17$hi = i64toi32_i32$3;
              $3 = HEAPU8[($2 + 472 | 0) >> 0] | 0;
              break label$4;
             }
             i64toi32_i32$3 = 0;
             $14 = 2;
             $14$hi = i64toi32_i32$3;
             $1 = 0;
             i64toi32_i32$3 = $13$hi;
             i64toi32_i32$0 = $13;
             i64toi32_i32$2 = 0;
             i64toi32_i32$1 = 2;
             if ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) | 0) {
              break label$4
             }
             $3 = 3;
             i64toi32_i32$0 = $13$hi;
             $12 = $13;
             $12$hi = i64toi32_i32$0;
             i64toi32_i32$0 = 0;
             $13 = 1;
             $13$hi = i64toi32_i32$0;
             break label$10;
            }
            i64toi32_i32$1 = $2 + 368 | 0;
            i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
            i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
            $12 = i64toi32_i32$0;
            $12$hi = i64toi32_i32$3;
            i64toi32_i32$0 = ($2 + 192 | 0) + 8 | 0;
            HEAP32[i64toi32_i32$0 >> 2] = $12;
            HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
            i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
            HEAP32[i64toi32_i32$0 >> 2] = $12;
            HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
            i64toi32_i32$1 = $2 + 360 | 0;
            i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
            i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
            $12 = i64toi32_i32$3;
            $12$hi = i64toi32_i32$0;
            i64toi32_i32$3 = $2;
            HEAP32[($2 + 192 | 0) >> 2] = $12;
            HEAP32[($2 + 196 | 0) >> 2] = i64toi32_i32$0;
            i64toi32_i32$3 = $2;
            HEAP32[($2 + 16 | 0) >> 2] = $12;
            HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
            i64toi32_i32$1 = $2;
            i64toi32_i32$0 = HEAPU8[($2 + 337 | 0) >> 0] | 0 | ((HEAPU8[($2 + 338 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 339 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 340 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            i64toi32_i32$3 = 0;
            $323 = i64toi32_i32$0;
            $323$hi = i64toi32_i32$3;
            i64toi32_i32$1 = $2 + 341 | 0;
            i64toi32_i32$3 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
            i64toi32_i32$0 = 0;
            $326 = i64toi32_i32$3;
            $326$hi = i64toi32_i32$0;
            i64toi32_i32$1 = $2 + 343 | 0;
            i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
            i64toi32_i32$3 = 0;
            i64toi32_i32$1 = i64toi32_i32$0;
            i64toi32_i32$0 = 0;
            i64toi32_i32$2 = 16;
            i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
            if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
             i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
             $95 = 0;
            } else {
             i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$4 | 0) | 0;
             $95 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
            }
            $330$hi = i64toi32_i32$0;
            i64toi32_i32$0 = $326$hi;
            i64toi32_i32$3 = $326;
            i64toi32_i32$1 = $330$hi;
            i64toi32_i32$2 = $95;
            i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
            i64toi32_i32$0 = i64toi32_i32$3 | i64toi32_i32$2 | 0;
            i64toi32_i32$3 = 0;
            i64toi32_i32$2 = 32;
            i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
            if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
             i64toi32_i32$3 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
             $96 = 0;
            } else {
             i64toi32_i32$3 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
             $96 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
            }
            $332$hi = i64toi32_i32$3;
            i64toi32_i32$3 = $323$hi;
            i64toi32_i32$1 = $323;
            i64toi32_i32$0 = $332$hi;
            i64toi32_i32$2 = $96;
            i64toi32_i32$0 = i64toi32_i32$3 | i64toi32_i32$0 | 0;
            i64toi32_i32$3 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
            i64toi32_i32$1 = 0;
            i64toi32_i32$2 = 8;
            i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
            if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
             i64toi32_i32$1 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
             $97 = 0;
            } else {
             i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
             $97 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
            }
            $334$hi = i64toi32_i32$1;
            i64toi32_i32$1 = 0;
            i64toi32_i32$0 = $1;
            i64toi32_i32$3 = 0;
            i64toi32_i32$2 = 255;
            i64toi32_i32$3 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
            $337 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
            $337$hi = i64toi32_i32$3;
            i64toi32_i32$3 = $334$hi;
            i64toi32_i32$1 = $97;
            i64toi32_i32$0 = $337$hi;
            i64toi32_i32$2 = $337;
            i64toi32_i32$0 = i64toi32_i32$3 | i64toi32_i32$0 | 0;
            $12 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
            $12$hi = i64toi32_i32$0;
            i64toi32_i32$3 = $2 + 352 | 0;
            i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
            i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
            $14 = i64toi32_i32$0;
            $14$hi = i64toi32_i32$1;
            i64toi32_i32$3 = $2 + 344 | 0;
            i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
            i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
            $13 = i64toi32_i32$1;
            $13$hi = i64toi32_i32$0;
            $3 = 2;
           }
           i64toi32_i32$3 = $2;
           i64toi32_i32$0 = HEAP32[($2 + 464 | 0) >> 2] | 0;
           i64toi32_i32$1 = HEAP32[($2 + 468 | 0) >> 2] | 0;
           i64toi32_i32$3 = i64toi32_i32$0;
           i64toi32_i32$0 = 0;
           i64toi32_i32$2 = 0;
           if ((i64toi32_i32$3 | 0) != (i64toi32_i32$2 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$0 | 0) | 0) {
            break label$9
           }
          }
          core__ptr__drop_in_place_cardano_serialization_lib__utils__TransactionUnspentOutput___h3ebb7f0562e4e672($7 | 0);
          break label$2;
         }
         core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9_4($7 | 0);
         break label$2;
        }
        $3 = 11;
        break label$2;
       }
       i64toi32_i32$2 = $2 + 504 | 0;
       i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $354 = i64toi32_i32$3;
       i64toi32_i32$3 = $2 + 24 | 0;
       HEAP32[i64toi32_i32$3 >> 2] = $354;
       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $2 + 496 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $358 = i64toi32_i32$1;
       i64toi32_i32$1 = $2;
       HEAP32[($2 + 16 | 0) >> 2] = $358;
       HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$3;
       i64toi32_i32$2 = $2 + 488 | 0;
       i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $14 = i64toi32_i32$3;
       $14$hi = i64toi32_i32$1;
       break label$2;
      }
      memcpy($2 + 464 | 0 | 0, memcpy(($2 + 192 | 0) + 8 | 0 | 0, memcpy($2 + 332 | 0 | 0, ($2 + 464 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
      $1 = ($2 + 640 | 0) + 8 | 0;
      cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $2 + 464 | 0 | 0, 1057684 | 0, 5 | 0);
      i64toi32_i32$2 = $2 + 688 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $386 = i64toi32_i32$1;
      i64toi32_i32$1 = ($2 + 16 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $386;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
      HEAP32[(($2 + 328 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 708 | 0) >> 2] | 0;
      HEAP32[($2 + 48 | 0) >> 2] = HEAPU8[($2 + 649 | 0) >> 0] | 0 | ((HEAPU8[($2 + 650 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 651 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 652 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $82 = $2 + 652 | 0;
      $83 = HEAPU8[$82 >> 0] | 0 | ((HEAPU8[($82 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($82 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($82 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[($2 + 51 | 0) >> 0] = $83;
      HEAP8[($2 + 52 | 0) >> 0] = $83 >>> 8 | 0;
      HEAP8[($2 + 53 | 0) >> 0] = $83 >>> 16 | 0;
      HEAP8[($2 + 54 | 0) >> 0] = $83 >>> 24 | 0;
      i64toi32_i32$2 = $2 + 680 | 0;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $403 = i64toi32_i32$3;
      i64toi32_i32$3 = $2;
      HEAP32[($2 + 16 | 0) >> 2] = $403;
      HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $2 + 700 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $407 = i64toi32_i32$1;
      i64toi32_i32$1 = $2;
      HEAP32[($2 + 328 | 0) >> 2] = $407;
      HEAP32[($2 + 332 | 0) >> 2] = i64toi32_i32$3;
      $3 = HEAPU8[$1 >> 0] | 0;
      i64toi32_i32$2 = $2 + 656 | 0;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $12 = i64toi32_i32$3;
      $12$hi = i64toi32_i32$1;
      i64toi32_i32$2 = $2 + 664 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $13 = i64toi32_i32$1;
      $13$hi = i64toi32_i32$3;
      i64toi32_i32$2 = $2 + 672 | 0;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $14 = i64toi32_i32$3;
      $14$hi = i64toi32_i32$1;
      $4 = HEAP32[($2 + 696 | 0) >> 2] | 0;
      $84 = HEAPU8[($2 + 51 | 0) >> 0] | 0 | ((HEAPU8[($2 + 52 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 53 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 54 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[($2 + 35 | 0) >> 0] = $84;
      HEAP8[($2 + 36 | 0) >> 0] = $84 >>> 8 | 0;
      HEAP8[($2 + 37 | 0) >> 0] = $84 >>> 16 | 0;
      HEAP8[($2 + 38 | 0) >> 0] = $84 >>> 24 | 0;
      HEAP32[($2 + 32 | 0) >> 2] = HEAP32[($2 + 48 | 0) >> 2] | 0;
      break label$2;
     }
     memcpy($2 + 640 | 0 | 0, $7 | 0, 64 | 0) | 0;
     $1 = memcpy(($2 + 328 | 0) + 8 | 0 | 0, $2 + 640 | 0 | 0, 64 | 0) | 0;
     memcpy($2 + 464 | 0 | 0, $1 | 0, 64 | 0) | 0;
     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e(($2 + 192 | 0) + 8 | 0 | 0, $2 + 464 | 0 | 0, 1057689 | 0, 6 | 0);
     $7 = ($2 + 168 | 0) + 8 | 0;
     i64toi32_i32$2 = $2 + 240 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $453 = i64toi32_i32$1;
     i64toi32_i32$1 = $7;
     HEAP32[i64toi32_i32$1 >> 2] = $453;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
     $5 = ($2 + 152 | 0) + 8 | 0;
     HEAP32[$5 >> 2] = HEAP32[($2 + 260 | 0) >> 2] | 0;
     HEAP32[($2 + 184 | 0) >> 2] = HEAPU8[($2 + 201 | 0) >> 0] | 0 | ((HEAPU8[($2 + 202 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 203 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 204 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $85 = ($2 + 192 | 0) + 12 | 0;
     $86 = HEAPU8[$85 >> 0] | 0 | ((HEAPU8[($85 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($85 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($85 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($2 + 187 | 0) >> 0] = $86;
     HEAP8[($2 + 188 | 0) >> 0] = $86 >>> 8 | 0;
     HEAP8[($2 + 189 | 0) >> 0] = $86 >>> 16 | 0;
     HEAP8[($2 + 190 | 0) >> 0] = $86 >>> 24 | 0;
     i64toi32_i32$2 = $2 + 232 | 0;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $472 = i64toi32_i32$3;
     i64toi32_i32$3 = $2;
     HEAP32[($2 + 168 | 0) >> 2] = $472;
     HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAP32[($2 + 252 | 0) >> 2] | 0;
     i64toi32_i32$3 = HEAP32[($2 + 256 | 0) >> 2] | 0;
     $475 = i64toi32_i32$1;
     i64toi32_i32$1 = $2;
     HEAP32[($2 + 152 | 0) >> 2] = $475;
     HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$2 = ($2 + 192 | 0) + 16 | 0;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $12 = i64toi32_i32$3;
     $12$hi = i64toi32_i32$1;
     i64toi32_i32$2 = ($2 + 192 | 0) + 24 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $13 = i64toi32_i32$1;
     $13$hi = i64toi32_i32$3;
     i64toi32_i32$2 = ($2 + 192 | 0) + 32 | 0;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $14 = i64toi32_i32$3;
     $14$hi = i64toi32_i32$1;
     $4 = HEAP32[($2 + 248 | 0) >> 2] | 0;
     $3 = HEAPU8[($2 + 200 | 0) >> 0] | 0;
     i64toi32_i32$2 = $7;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $497 = i64toi32_i32$1;
     i64toi32_i32$1 = ($2 + 16 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $497;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
     HEAP32[$1 >> 2] = HEAP32[$5 >> 2] | 0;
     $87 = HEAPU8[($2 + 187 | 0) >> 0] | 0 | ((HEAPU8[($2 + 188 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 189 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 190 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($2 + 35 | 0) >> 0] = $87;
     HEAP8[($2 + 36 | 0) >> 0] = $87 >>> 8 | 0;
     HEAP8[($2 + 37 | 0) >> 0] = $87 >>> 16 | 0;
     HEAP8[($2 + 38 | 0) >> 0] = $87 >>> 24 | 0;
     HEAP32[($2 + 32 | 0) >> 2] = HEAP32[($2 + 184 | 0) >> 2] | 0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$3 = HEAP32[($2 + 168 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 172 | 0) >> 2] | 0;
     $509 = i64toi32_i32$3;
     i64toi32_i32$3 = $2;
     HEAP32[($2 + 16 | 0) >> 2] = $509;
     HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAP32[($2 + 152 | 0) >> 2] | 0;
     i64toi32_i32$3 = HEAP32[($2 + 156 | 0) >> 2] | 0;
     $512 = i64toi32_i32$1;
     i64toi32_i32$1 = $2;
     HEAP32[($2 + 328 | 0) >> 2] = $512;
     HEAP32[($2 + 332 | 0) >> 2] = i64toi32_i32$3;
     break label$2;
    }
    $7 = ($2 + 16 | 0) + 8 | 0;
    i64toi32_i32$2 = $9 + 8 | 0;
    i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $519 = i64toi32_i32$3;
    i64toi32_i32$3 = $7;
    HEAP32[i64toi32_i32$3 >> 2] = $519;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
    $4 = $2 + 473 | 0;
    $69 = $4;
    HEAP32[($2 + 32 | 0) >> 2] = HEAPU8[$69 >> 0] | 0 | ((HEAPU8[($69 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($69 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($69 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$2 = $9;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $527 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 16 | 0) >> 2] = $527;
    HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$3;
    $88 = $69 + 3 | 0;
    $89 = HEAPU8[$88 >> 0] | 0 | ((HEAPU8[($88 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($88 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($88 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    HEAP8[($2 + 35 | 0) >> 0] = $89;
    HEAP8[($2 + 36 | 0) >> 0] = $89 >>> 8 | 0;
    HEAP8[($2 + 37 | 0) >> 0] = $89 >>> 16 | 0;
    HEAP8[($2 + 38 | 0) >> 0] = $89 >>> 24 | 0;
    memcpy($2 + 328 | 0 | 0, $2 + 524 | 0 | 0, 116 | 0) | 0;
    label$14 : {
     if (!$1) {
      break label$14
     }
     i64toi32_i32$3 = $19$hi;
     $14 = $19;
     $14$hi = i64toi32_i32$3;
     i64toi32_i32$3 = $18$hi;
     $13 = $18;
     $13$hi = i64toi32_i32$3;
     i64toi32_i32$3 = $17$hi;
     $12 = $17;
     $12$hi = i64toi32_i32$3;
     $4 = $10;
     break label$2;
    }
    HEAP8[($0 + 8 | 0) >> 0] = $3;
    $90 = HEAP32[($2 + 32 | 0) >> 2] | 0;
    HEAP8[($0 + 9 | 0) >> 0] = $90;
    HEAP8[($0 + 10 | 0) >> 0] = $90 >>> 8 | 0;
    HEAP8[($0 + 11 | 0) >> 0] = $90 >>> 16 | 0;
    HEAP8[($0 + 12 | 0) >> 0] = $90 >>> 24 | 0;
    $91 = $0 + 12 | 0;
    $92 = HEAPU8[($2 + 35 | 0) >> 0] | 0 | ((HEAPU8[($2 + 36 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 37 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 38 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    HEAP8[$91 >> 0] = $92;
    HEAP8[($91 + 1 | 0) >> 0] = $92 >>> 8 | 0;
    HEAP8[($91 + 2 | 0) >> 0] = $92 >>> 16 | 0;
    HEAP8[($91 + 3 | 0) >> 0] = $92 >>> 24 | 0;
    i64toi32_i32$3 = $19$hi;
    i64toi32_i32$1 = $0 + 32 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $19;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
    i64toi32_i32$3 = $18$hi;
    i64toi32_i32$1 = $0 + 24 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $18;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
    i64toi32_i32$3 = $17$hi;
    i64toi32_i32$1 = $0 + 16 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $17;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
    i64toi32_i32$2 = $2;
    i64toi32_i32$3 = HEAP32[($2 + 16 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
    $564 = i64toi32_i32$3;
    i64toi32_i32$3 = $0 + 40 | 0;
    HEAP32[i64toi32_i32$3 >> 2] = $564;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($0 + 56 | 0) >> 2] = $10;
    i64toi32_i32$2 = $7;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $571 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 48 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $571;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
    memcpy($0 + 60 | 0 | 0, $2 + 328 | 0 | 0, 116 | 0) | 0;
    i64toi32_i32$3 = 0;
    $12 = 0;
    $12$hi = i64toi32_i32$3;
    break label$1;
   }
   i64toi32_i32$3 = $14$hi;
   i64toi32_i32$1 = ($2 + 464 | 0) + 24 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $14;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$3 = $13$hi;
   i64toi32_i32$1 = $2 + 480 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $13;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$3 = $12$hi;
   i64toi32_i32$1 = ($2 + 464 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $12;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$2 = $2;
   i64toi32_i32$3 = HEAP32[($2 + 16 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   $591 = i64toi32_i32$3;
   i64toi32_i32$3 = $2 + 496 | 0;
   HEAP32[i64toi32_i32$3 >> 2] = $591;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = HEAP32[($2 + 328 | 0) >> 2] | 0;
   i64toi32_i32$3 = HEAP32[($2 + 332 | 0) >> 2] | 0;
   $595 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 516 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $595;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
   i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $601 = i64toi32_i32$3;
   i64toi32_i32$3 = $2 + 504 | 0;
   HEAP32[i64toi32_i32$3 >> 2] = $601;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($2 + 524 | 0) >> 2] = HEAP32[(($2 + 328 | 0) + 8 | 0) >> 2] | 0;
   HEAP8[($2 + 464 | 0) >> 0] = $3;
   $93 = HEAP32[($2 + 32 | 0) >> 2] | 0;
   HEAP8[($2 + 465 | 0) >> 0] = $93;
   HEAP8[($2 + 466 | 0) >> 0] = $93 >>> 8 | 0;
   HEAP8[($2 + 467 | 0) >> 0] = $93 >>> 16 | 0;
   HEAP8[($2 + 468 | 0) >> 0] = $93 >>> 24 | 0;
   $94 = HEAPU8[($2 + 35 | 0) >> 0] | 0 | ((HEAPU8[($2 + 36 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 37 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 38 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[($2 + 468 | 0) >> 0] = $94;
   HEAP8[($2 + 469 | 0) >> 0] = $94 >>> 8 | 0;
   HEAP8[($2 + 470 | 0) >> 0] = $94 >>> 16 | 0;
   HEAP8[($2 + 471 | 0) >> 0] = $94 >>> 24 | 0;
   HEAP32[($2 + 512 | 0) >> 2] = $4;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 464 | 0 | 0, 1057695 | 0, 24 | 0);
   i64toi32_i32$1 = 0;
   $12 = 1;
   $12$hi = i64toi32_i32$1;
  }
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$3 = $0;
  HEAP32[i64toi32_i32$3 >> 2] = $12;
  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $2 + 768 | 0;
 }
 
 function $cardano_serialization_lib__address__RewardAddress_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h7ae223ac4e980662($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, $7 = 0, $8 = 0, $10 = 0, $16 = 0, $3 = 0, $4 = 0, $5 = 0, $11 = 0, $6 = 0, $9 = 0, $15 = 0, $17 = 0, $40 = 0, $41 = 0, $42 = 0, $43 = 0, $44 = 0, $45 = 0, $46 = 0, $47 = 0, $48 = 0, $49 = 0, $50 = 0, $51 = 0, $52 = 0, $12 = 0, $13 = 0, $14 = 0, $53 = 0, $54 = 0, $55 = 0, $56 = 0, $57 = 0, $58 = 0, $59 = 0, $60 = 0, $61 = 0, $62 = 0, $63 = 0, $64 = 0, $65 = 0, $66 = 0, $67 = 0, $68 = 0, $69 = 0, $70 = 0, $71 = 0, $72 = 0, $18 = 0, $18$hi = 0, $114 = 0, $134 = 0, $137 = 0, $261 = 0, $267 = 0, $277 = 0, $432 = 0, $450 = 0, $469 = 0, $472 = 0, $502 = 0, $517 = 0, $525 = 0, $605 = 0, $609 = 0, $619 = 0;
  $2 = global$0 - 256 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___bytes__hc697ccccfa39fd82($2 + 184 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ((HEAP32[($2 + 184 | 0) >> 2] | 0 | 0) == (1 | 0)) {
        break label$5
       }
       $1 = $2 + 198 | 0;
       HEAP16[($2 + 106 | 0) >> 1] = HEAPU16[$1 >> 1] | 0;
       HEAP32[($2 + 96 | 0) >> 2] = HEAP32[($2 + 188 | 0) >> 2] | 0;
       $52 = HEAPU16[($2 + 194 | 0) >> 1] | 0 | ((HEAPU16[($2 + 196 | 0) >> 1] | 0) << 16 | 0) | 0;
       HEAP16[($2 + 102 | 0) >> 1] = $52;
       HEAP16[($2 + 104 | 0) >> 1] = $52 >>> 16 | 0;
       HEAP16[($2 + 100 | 0) >> 1] = HEAPU16[(($2 + 184 | 0) + 8 | 0) >> 1] | 0;
       $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $2 + 96 | 0 | 0);
       cardano_serialization_lib__address__Address__from_bytes_impl__h0b2b4c3a1f339e7a($2 + 184 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
       $3 = ($2 + 176 | 0) + 4 | 0;
       HEAP16[$3 >> 1] = HEAPU16[$1 >> 1] | 0;
       $4 = ($2 + 168 | 0) + 4 | 0;
       HEAP16[$4 >> 1] = HEAPU16[($2 + 206 | 0) >> 1] | 0;
       $5 = ($2 + 160 | 0) + 4 | 0;
       HEAP16[$5 >> 1] = HEAPU16[($2 + 214 | 0) >> 1] | 0;
       HEAP32[($2 + 176 | 0) >> 2] = HEAPU16[($2 + 194 | 0) >> 1] | 0 | ((HEAPU16[($2 + 196 | 0) >> 1] | 0) << 16 | 0) | 0;
       HEAP32[($2 + 168 | 0) >> 2] = HEAPU16[($2 + 202 | 0) >> 1] | 0 | ((HEAPU16[($2 + 204 | 0) >> 1] | 0) << 16 | 0) | 0;
       HEAP32[($2 + 160 | 0) >> 2] = HEAPU16[($2 + 210 | 0) >> 1] | 0 | ((HEAPU16[($2 + 212 | 0) >> 1] | 0) << 16 | 0) | 0;
       $6 = HEAPU8[(($2 + 184 | 0) + 16 | 0) >> 0] | 0;
       $7 = HEAPU8[($2 + 208 | 0) >> 0] | 0;
       $8 = HEAPU8[($2 + 193 | 0) >> 0] | 0;
       $1 = HEAPU8[($2 + 192 | 0) >> 0] | 0;
       $9 = HEAPU8[($2 + 201 | 0) >> 0] | 0;
       $10 = HEAPU8[($2 + 209 | 0) >> 0] | 0;
       i64toi32_i32$2 = $2;
       i64toi32_i32$0 = HEAP32[($2 + 184 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($2 + 188 | 0) >> 2] | 0;
       $18 = i64toi32_i32$0;
       $18$hi = i64toi32_i32$1;
       $11 = ($2 + 152 | 0) + 4 | 0;
       HEAP8[$11 >> 0] = HEAPU8[($2 + 222 | 0) >> 0] | 0;
       $12 = ($2 + 128 | 0) + 8 | 0;
       i64toi32_i32$2 = $2 + 231 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $114 = i64toi32_i32$1;
       i64toi32_i32$1 = $12;
       HEAP32[i64toi32_i32$1 >> 2] = $114;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       $13 = ($2 + 128 | 0) + 16 | 0;
       HEAP8[$13 >> 0] = HEAPU8[($2 + 239 | 0) >> 0] | 0;
       $14 = ($2 + 112 | 0) + 8 | 0;
       HEAP32[$14 >> 2] = HEAP32[($2 + 252 | 0) >> 2] | 0;
       HEAP32[($2 + 152 | 0) >> 2] = HEAPU16[($2 + 218 | 0) >> 1] | 0 | ((HEAPU16[($2 + 220 | 0) >> 1] | 0) << 16 | 0) | 0;
       i64toi32_i32$2 = $2;
       i64toi32_i32$0 = HEAPU8[($2 + 223 | 0) >> 0] | 0 | ((HEAPU8[($2 + 224 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 225 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 226 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[($2 + 227 | 0) >> 0] | 0 | ((HEAPU8[($2 + 228 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 229 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 230 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $134 = i64toi32_i32$0;
       i64toi32_i32$0 = $2;
       HEAP32[($2 + 128 | 0) >> 2] = $134;
       HEAP32[($2 + 132 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $2;
       i64toi32_i32$1 = HEAP32[($2 + 244 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[($2 + 248 | 0) >> 2] | 0;
       $137 = i64toi32_i32$1;
       i64toi32_i32$1 = $2;
       HEAP32[($2 + 112 | 0) >> 2] = $137;
       HEAP32[($2 + 116 | 0) >> 2] = i64toi32_i32$0;
       $15 = HEAPU8[($2 + 216 | 0) >> 0] | 0;
       $16 = HEAP32[($2 + 240 | 0) >> 2] | 0;
       $17 = HEAPU8[($2 + 217 | 0) >> 0] | 0;
       i64toi32_i32$0 = $18$hi;
       i64toi32_i32$2 = $18;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 1;
       if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
        break label$4
       }
       label$6 : {
        label$7 : {
         if (($1 & 255 | 0 | 0) != (3 | 0)) {
          break label$7
         }
         HEAP16[(($2 + 88 | 0) + 4 | 0) >> 1] = HEAPU16[(($2 + 176 | 0) + 4 | 0) >> 1] | 0;
         HEAP16[(($2 + 80 | 0) + 4 | 0) >> 1] = HEAPU16[(($2 + 168 | 0) + 4 | 0) >> 1] | 0;
         HEAP16[(($2 + 72 | 0) + 4 | 0) >> 1] = HEAPU16[(($2 + 160 | 0) + 4 | 0) >> 1] | 0;
         HEAP8[(($2 + 64 | 0) + 4 | 0) >> 0] = HEAPU8[(($2 + 152 | 0) + 4 | 0) >> 0] | 0;
         HEAP32[($2 + 88 | 0) >> 2] = HEAP32[($2 + 176 | 0) >> 2] | 0;
         HEAP32[($2 + 80 | 0) >> 2] = HEAP32[($2 + 168 | 0) >> 2] | 0;
         HEAP32[($2 + 72 | 0) >> 2] = HEAP32[($2 + 160 | 0) >> 2] | 0;
         HEAP32[($2 + 64 | 0) >> 2] = HEAP32[($2 + 152 | 0) >> 2] | 0;
         $5 = $9;
         $11 = $6;
         break label$6;
        }
        HEAP8[($2 + 193 | 0) >> 0] = $9;
        HEAP8[(($2 + 184 | 0) + 8 | 0) >> 0] = $6;
        $53 = $2 + 194 | 0;
        $54 = HEAP32[($2 + 168 | 0) >> 2] | 0;
        HEAP16[$53 >> 1] = $54;
        HEAP16[($53 + 2 | 0) >> 1] = $54 >>> 16 | 0;
        HEAP8[($2 + 201 | 0) >> 0] = $10;
        HEAP8[(($2 + 184 | 0) + 16 | 0) >> 0] = $7;
        $55 = $2 + 202 | 0;
        $56 = HEAP32[($2 + 160 | 0) >> 2] | 0;
        HEAP16[$55 >> 1] = $56;
        HEAP16[($55 + 2 | 0) >> 1] = $56 >>> 16 | 0;
        HEAP16[($2 + 198 | 0) >> 1] = HEAPU16[(($2 + 168 | 0) + 4 | 0) >> 1] | 0;
        HEAP16[($2 + 206 | 0) >> 1] = HEAPU16[(($2 + 160 | 0) + 4 | 0) >> 1] | 0;
        HEAP8[($2 + 185 | 0) >> 0] = $8;
        HEAP8[($2 + 184 | 0) >> 0] = $1;
        $57 = HEAP32[($2 + 176 | 0) >> 2] | 0;
        HEAP16[($2 + 186 | 0) >> 1] = $57;
        HEAP16[($2 + 188 | 0) >> 1] = $57 >>> 16 | 0;
        HEAP16[($2 + 190 | 0) >> 1] = HEAPU16[(($2 + 176 | 0) + 4 | 0) >> 1] | 0;
        HEAP8[($2 + 209 | 0) >> 0] = $17;
        HEAP8[($2 + 208 | 0) >> 0] = $15;
        HEAP32[($2 + 232 | 0) >> 2] = $16;
        $58 = $2 + 210 | 0;
        $59 = HEAP32[($2 + 152 | 0) >> 2] | 0;
        HEAP16[$58 >> 1] = $59;
        HEAP16[($58 + 2 | 0) >> 1] = $59 >>> 16 | 0;
        HEAP8[($2 + 214 | 0) >> 0] = HEAPU8[(($2 + 152 | 0) + 4 | 0) >> 0] | 0;
        i64toi32_i32$3 = $2;
        i64toi32_i32$2 = HEAP32[($2 + 128 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[($2 + 132 | 0) >> 2] | 0;
        $261 = i64toi32_i32$2;
        i64toi32_i32$2 = $2 + 215 | 0;
        $40 = $261;
        HEAP8[i64toi32_i32$2 >> 0] = $40;
        HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $40 >>> 8 | 0;
        HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $40 >>> 16 | 0;
        HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $40 >>> 24 | 0;
        HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$0;
        HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
        HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
        HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
        i64toi32_i32$3 = ($2 + 128 | 0) + 8 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $267 = i64toi32_i32$0;
        i64toi32_i32$0 = $2 + 223 | 0;
        $41 = $267;
        HEAP8[i64toi32_i32$0 >> 0] = $41;
        HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $41 >>> 8 | 0;
        HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $41 >>> 16 | 0;
        HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $41 >>> 24 | 0;
        HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$2;
        HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
        HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
        HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
        HEAP8[($2 + 231 | 0) >> 0] = HEAPU8[(($2 + 128 | 0) + 16 | 0) >> 0] | 0;
        i64toi32_i32$3 = $2;
        i64toi32_i32$2 = HEAP32[($2 + 112 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[($2 + 116 | 0) >> 2] | 0;
        $277 = i64toi32_i32$2;
        i64toi32_i32$2 = $2 + 236 | 0;
        HEAP32[i64toi32_i32$2 >> 2] = $277;
        HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
        HEAP32[($2 + 244 | 0) >> 2] = HEAP32[(($2 + 112 | 0) + 8 | 0) >> 2] | 0;
        $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 | 0, $2 + 96 | 0 | 0);
        if (!(HEAP32[($2 + 4 | 0) >> 2] | 0)) {
         break label$3
        }
        $5 = HEAPU8[(HEAP32[$2 >> 2] | 0) >> 0] | 0;
        label$8 : {
         if (($1 & 255 | 0) >>> 0 < 4 >>> 0) {
          break label$8
         }
         core__ptr__drop_in_place_cardano_serialization_lib__legacy_address__address__ExtendedAddr___h2c1a18aefeee766f($2 + 184 | 0 | 4 | 0 | 0);
        }
        $11 = 0;
       }
       $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 96 | 0 | 0);
       $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 96 | 0 | 0);
       label$9 : {
        if (($1 & 255 | 0 | 0) == (3 | 0)) {
         break label$9
        }
        $16 = 0;
        $3 = $15;
        $4 = $17;
        $9 = $10;
        $6 = $7;
        $8 = $5;
        $1 = $11;
        break label$2;
       }
       HEAP8[($0 + 1 | 0) >> 0] = $8;
       $42 = $0 + 2 | 0;
       $43 = HEAP32[($2 + 88 | 0) >> 2] | 0;
       HEAP8[$42 >> 0] = $43;
       HEAP8[($42 + 1 | 0) >> 0] = $43 >>> 8 | 0;
       HEAP8[($42 + 2 | 0) >> 0] = $43 >>> 16 | 0;
       HEAP8[($42 + 3 | 0) >> 0] = $43 >>> 24 | 0;
       HEAP8[($0 + 9 | 0) >> 0] = $5;
       HEAP8[($0 + 8 | 0) >> 0] = $11;
       $44 = $0 + 10 | 0;
       $45 = HEAP32[($2 + 80 | 0) >> 2] | 0;
       HEAP8[$44 >> 0] = $45;
       HEAP8[($44 + 1 | 0) >> 0] = $45 >>> 8 | 0;
       HEAP8[($44 + 2 | 0) >> 0] = $45 >>> 16 | 0;
       HEAP8[($44 + 3 | 0) >> 0] = $45 >>> 24 | 0;
       HEAP8[($0 + 17 | 0) >> 0] = $10;
       HEAP8[($0 + 16 | 0) >> 0] = $7;
       $46 = $0 + 18 | 0;
       $47 = HEAP32[($2 + 72 | 0) >> 2] | 0;
       HEAP8[$46 >> 0] = $47;
       HEAP8[($46 + 1 | 0) >> 0] = $47 >>> 8 | 0;
       HEAP8[($46 + 2 | 0) >> 0] = $47 >>> 16 | 0;
       HEAP8[($46 + 3 | 0) >> 0] = $47 >>> 24 | 0;
       HEAP8[($0 + 24 | 0) >> 0] = $15;
       HEAP8[($0 + 25 | 0) >> 0] = $17;
       $60 = $0 + 6 | 0;
       $61 = HEAPU16[(($2 + 88 | 0) + 4 | 0) >> 1] | 0;
       HEAP8[$60 >> 0] = $61;
       HEAP8[($60 + 1 | 0) >> 0] = $61 >>> 8 | 0;
       $62 = $0 + 14 | 0;
       $63 = HEAPU16[(($2 + 80 | 0) + 4 | 0) >> 1] | 0;
       HEAP8[$62 >> 0] = $63;
       HEAP8[($62 + 1 | 0) >> 0] = $63 >>> 8 | 0;
       $64 = $0 + 22 | 0;
       $65 = HEAPU16[(($2 + 72 | 0) + 4 | 0) >> 1] | 0;
       HEAP8[$64 >> 0] = $65;
       HEAP8[($64 + 1 | 0) >> 0] = $65 >>> 8 | 0;
       HEAP8[($0 + 30 | 0) >> 0] = HEAPU8[(($2 + 64 | 0) + 4 | 0) >> 0] | 0;
       $48 = $0 + 26 | 0;
       $49 = HEAP32[($2 + 64 | 0) >> 2] | 0;
       HEAP8[$48 >> 0] = $49;
       HEAP8[($48 + 1 | 0) >> 0] = $49 >>> 8 | 0;
       HEAP8[($48 + 2 | 0) >> 0] = $49 >>> 16 | 0;
       HEAP8[($48 + 3 | 0) >> 0] = $49 >>> 24 | 0;
       $1 = 0;
       break label$1;
      }
      $1 = ($2 + 112 | 0) + 4 | 0;
      HEAP16[$1 >> 1] = HEAPU16[($2 + 198 | 0) >> 1] | 0;
      $8 = ($2 + 16 | 0) + 4 | 0;
      HEAP16[$8 >> 1] = HEAPU16[($2 + 206 | 0) >> 1] | 0;
      $16 = ($2 + 176 | 0) + 4 | 0;
      HEAP8[$16 >> 0] = HEAPU8[($2 + 214 | 0) >> 0] | 0;
      HEAP32[($2 + 112 | 0) >> 2] = HEAPU16[($2 + 194 | 0) >> 1] | 0 | ((HEAPU16[($2 + 196 | 0) >> 1] | 0) << 16 | 0) | 0;
      HEAP32[($2 + 16 | 0) >> 2] = HEAPU16[($2 + 202 | 0) >> 1] | 0 | ((HEAPU16[($2 + 204 | 0) >> 1] | 0) << 16 | 0) | 0;
      HEAP32[($2 + 176 | 0) >> 2] = HEAPU16[($2 + 210 | 0) >> 1] | 0 | ((HEAPU16[($2 + 212 | 0) >> 1] | 0) << 16 | 0) | 0;
      $6 = HEAPU8[(($2 + 184 | 0) + 8 | 0) >> 0] | 0;
      $3 = HEAPU8[(($2 + 184 | 0) + 16 | 0) >> 0] | 0;
      $15 = HEAPU8[($2 + 208 | 0) >> 0] | 0;
      $9 = HEAPU8[($2 + 193 | 0) >> 0] | 0;
      $4 = HEAPU8[($2 + 201 | 0) >> 0] | 0;
      $17 = HEAPU8[($2 + 209 | 0) >> 0] | 0;
      $7 = ($2 + 128 | 0) + 16 | 0;
      HEAP8[$7 >> 0] = HEAPU8[($2 + 231 | 0) >> 0] | 0;
      $10 = ($2 + 128 | 0) + 8 | 0;
      i64toi32_i32$3 = $2 + 223 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$2 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $432 = i64toi32_i32$0;
      i64toi32_i32$0 = $10;
      HEAP32[i64toi32_i32$0 >> 2] = $432;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
      HEAP16[(($2 + 72 | 0) + 4 | 0) >> 1] = HEAPU16[$1 >> 1] | 0;
      HEAP16[(($2 + 64 | 0) + 4 | 0) >> 1] = HEAPU16[$8 >> 1] | 0;
      HEAP8[(($2 + 56 | 0) + 4 | 0) >> 0] = HEAPU8[$16 >> 0] | 0;
      i64toi32_i32$3 = $2;
      i64toi32_i32$2 = HEAPU8[($2 + 215 | 0) >> 0] | 0 | ((HEAPU8[($2 + 216 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 217 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 218 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[($2 + 219 | 0) >> 0] | 0 | ((HEAPU8[($2 + 220 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 221 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 222 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $450 = i64toi32_i32$2;
      i64toi32_i32$2 = $2;
      HEAP32[($2 + 128 | 0) >> 2] = $450;
      HEAP32[($2 + 132 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[($2 + 72 | 0) >> 2] = HEAP32[($2 + 112 | 0) >> 2] | 0;
      HEAP32[($2 + 64 | 0) >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
      HEAP32[($2 + 56 | 0) >> 2] = HEAP32[($2 + 176 | 0) >> 2] | 0;
      HEAP8[(($2 + 32 | 0) + 16 | 0) >> 0] = HEAPU8[$7 >> 0] | 0;
      i64toi32_i32$3 = $10;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $469 = i64toi32_i32$0;
      i64toi32_i32$0 = ($2 + 32 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $469;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$3 = $2;
      i64toi32_i32$2 = HEAP32[($2 + 128 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($2 + 132 | 0) >> 2] | 0;
      $472 = i64toi32_i32$2;
      i64toi32_i32$2 = $2;
      HEAP32[($2 + 32 | 0) >> 2] = $472;
      HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$0;
      $1 = 2;
      $16 = 0;
      break label$2;
     }
     HEAP16[(($2 + 80 | 0) + 4 | 0) >> 1] = HEAPU16[$3 >> 1] | 0;
     HEAP16[(($2 + 72 | 0) + 4 | 0) >> 1] = HEAPU16[$4 >> 1] | 0;
     HEAP16[(($2 + 64 | 0) + 4 | 0) >> 1] = HEAPU16[$5 >> 1] | 0;
     HEAP8[(($2 + 56 | 0) + 4 | 0) >> 0] = HEAPU8[$11 >> 0] | 0;
     HEAP8[(($2 + 32 | 0) + 16 | 0) >> 0] = HEAPU8[$13 >> 0] | 0;
     i64toi32_i32$3 = $12;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $502 = i64toi32_i32$0;
     i64toi32_i32$0 = ($2 + 32 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $502;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
     HEAP32[($2 + 80 | 0) >> 2] = HEAP32[($2 + 176 | 0) >> 2] | 0;
     HEAP32[($2 + 72 | 0) >> 2] = HEAP32[($2 + 168 | 0) >> 2] | 0;
     HEAP32[($2 + 64 | 0) >> 2] = HEAP32[($2 + 160 | 0) >> 2] | 0;
     HEAP32[($2 + 56 | 0) >> 2] = HEAP32[($2 + 152 | 0) >> 2] | 0;
     i64toi32_i32$3 = $2;
     i64toi32_i32$2 = HEAP32[($2 + 128 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 132 | 0) >> 2] | 0;
     $517 = i64toi32_i32$2;
     i64toi32_i32$2 = $2;
     HEAP32[($2 + 32 | 0) >> 2] = $517;
     HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] = HEAP32[$14 >> 2] | 0;
     i64toi32_i32$3 = $2;
     i64toi32_i32$0 = HEAP32[($2 + 112 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[($2 + 116 | 0) >> 2] | 0;
     $525 = i64toi32_i32$0;
     i64toi32_i32$0 = $2;
     HEAP32[($2 + 16 | 0) >> 2] = $525;
     HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$2;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 96 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 96 | 0 | 0);
     $3 = $7;
     $4 = $10;
     break label$2;
    }
    core__panicking__panic_bounds_check__h808b524af17640b1(0 | 0, 0 | 0, 1070096 | 0);
    abort();
   }
   HEAP8[($2 + 193 | 0) >> 0] = $9;
   HEAP8[(($2 + 184 | 0) + 8 | 0) >> 0] = $6;
   $66 = $2 + 194 | 0;
   $67 = HEAP32[($2 + 72 | 0) >> 2] | 0;
   HEAP16[$66 >> 1] = $67;
   HEAP16[($66 + 2 | 0) >> 1] = $67 >>> 16 | 0;
   HEAP8[($2 + 201 | 0) >> 0] = $4;
   HEAP8[(($2 + 184 | 0) + 16 | 0) >> 0] = $3;
   $68 = $2 + 202 | 0;
   $69 = HEAP32[($2 + 64 | 0) >> 2] | 0;
   HEAP16[$68 >> 1] = $69;
   HEAP16[($68 + 2 | 0) >> 1] = $69 >>> 16 | 0;
   HEAP16[($2 + 198 | 0) >> 1] = HEAPU16[(($2 + 72 | 0) + 4 | 0) >> 1] | 0;
   HEAP16[($2 + 206 | 0) >> 1] = HEAPU16[(($2 + 64 | 0) + 4 | 0) >> 1] | 0;
   HEAP8[($2 + 185 | 0) >> 0] = $8;
   HEAP8[($2 + 184 | 0) >> 0] = $1;
   $70 = HEAP32[($2 + 80 | 0) >> 2] | 0;
   HEAP16[($2 + 186 | 0) >> 1] = $70;
   HEAP16[($2 + 188 | 0) >> 1] = $70 >>> 16 | 0;
   HEAP16[($2 + 190 | 0) >> 1] = HEAPU16[(($2 + 80 | 0) + 4 | 0) >> 1] | 0;
   HEAP8[($2 + 209 | 0) >> 0] = $17;
   HEAP8[($2 + 208 | 0) >> 0] = $15;
   $71 = $2 + 210 | 0;
   $72 = HEAP32[($2 + 56 | 0) >> 2] | 0;
   HEAP16[$71 >> 1] = $72;
   HEAP16[($71 + 2 | 0) >> 1] = $72 >>> 16 | 0;
   HEAP8[($2 + 214 | 0) >> 0] = HEAPU8[(($2 + 56 | 0) + 4 | 0) >> 0] | 0;
   HEAP8[($2 + 231 | 0) >> 0] = HEAPU8[(($2 + 32 | 0) + 16 | 0) >> 0] | 0;
   i64toi32_i32$3 = ($2 + 32 | 0) + 8 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $605 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 223 | 0;
   $50 = $605;
   HEAP8[i64toi32_i32$2 >> 0] = $50;
   HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $50 >>> 8 | 0;
   HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $50 >>> 16 | 0;
   HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $50 >>> 24 | 0;
   HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$3 = $2;
   i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($2 + 36 | 0) >> 2] | 0;
   $609 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 215 | 0;
   $51 = $609;
   HEAP8[i64toi32_i32$0 >> 0] = $51;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $51 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $51 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $51 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$2;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
   HEAP32[($2 + 244 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
   i64toi32_i32$3 = $2;
   i64toi32_i32$2 = HEAP32[($2 + 16 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   $619 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 236 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $619;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($2 + 232 | 0) >> 2] = $16;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 184 | 0 | 0, 1070112 | 0, 13 | 0);
   $1 = 1;
  }
  HEAP8[$0 >> 0] = $1;
  global$0 = $2 + 256 | 0;
 }
 
 function $cardano_serialization_lib__utils__BigInt_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hebb3828b833490eb($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$2 = 0, $4 = 0, $11$hi = 0, $11 = 0, $3 = 0, $10 = 0, $10$hi = 0, $5 = 0, $6 = 0, i64toi32_i32$4 = 0, $8 = 0, $7 = 0, $12 = 0, i64toi32_i32$6 = 0, $12$hi = 0, $56 = 0, $58 = 0, $59 = 0, $60 = 0, $61 = 0, $62 = 0, $64 = 0, $65 = 0, $66 = 0, $68 = 0, $69 = 0, $70 = 0, $71 = 0, $72 = 0, $9 = 0, $73 = 0, $74 = 0, $75 = 0, $76 = 0, $77 = 0, $78 = 0, $79 = 0, $42 = 0, $57 = 0, $63 = 0, $67 = 0, $149 = 0, $210 = 0, $211$hi = 0, $212$hi = 0, $235 = 0, $235$hi = 0, $237$hi = 0, $239 = 0, $239$hi = 0, $275 = 0, $275$hi = 0, $277$hi = 0, $279 = 0, $279$hi = 0, $292 = 0, $298 = 0, $307 = 0, $311 = 0, $380 = 0, $386 = 0, $390 = 0, $412 = 0, $418 = 0, $428 = 0, $432 = 0, $502 = 0, $506 = 0, $512 = 0, $518 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 16 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     if (HEAP32[($2 + 20 | 0) >> 2] | 0) {
      break label$3
     }
     $3 = 0;
     i64toi32_i32$0 = 0;
     $10 = 0;
     $10$hi = i64toi32_i32$0;
     $4 = 0;
     $5 = 0;
     $6 = 2;
     $7 = 0;
     $8 = 8;
     break label$2;
    }
    $5 = 0;
    $6 = 11;
    $7 = 0;
    label$4 : {
     label$5 : {
      label$6 : {
       label$7 : {
        label$8 : {
         label$9 : {
          label$10 : {
           label$11 : {
            label$12 : {
             label$13 : {
              label$14 : {
               switch (($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[($2 + 16 | 0) >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) {
               case 6:
                cbor_event__de__Deserializer_R___tag__ha0ca0c99f1ceb558($2 + 88 | 0 | 0, $1 | 0);
                i64toi32_i32$2 = $2;
                i64toi32_i32$0 = HEAP32[($2 + 96 | 0) >> 2] | 0;
                i64toi32_i32$1 = HEAP32[($2 + 100 | 0) >> 2] | 0;
                $11 = i64toi32_i32$0;
                $11$hi = i64toi32_i32$1;
                label$17 : {
                 label$18 : {
                  label$19 : {
                   label$20 : {
                    label$21 : {
                     i64toi32_i32$2 = $2;
                     i64toi32_i32$1 = HEAP32[($2 + 88 | 0) >> 2] | 0;
                     i64toi32_i32$0 = HEAP32[($2 + 92 | 0) >> 2] | 0;
                     i64toi32_i32$2 = i64toi32_i32$1;
                     i64toi32_i32$1 = 0;
                     i64toi32_i32$3 = 1;
                     if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
                      break label$21
                     }
                     cardano_serialization_lib__utils__read_bounded_bytes__hab7fd43ad4917069($2 + 88 | 0 | 0, $1 | 0);
                     if ((HEAP32[($2 + 88 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                      break label$9
                     }
                     i64toi32_i32$3 = $2;
                     i64toi32_i32$2 = HEAP32[($2 + 92 | 0) >> 2] | 0;
                     i64toi32_i32$0 = HEAP32[($2 + 96 | 0) >> 2] | 0;
                     $42 = i64toi32_i32$2;
                     i64toi32_i32$2 = $2;
                     HEAP32[($2 + 48 | 0) >> 2] = $42;
                     HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$0;
                     HEAP32[($2 + 56 | 0) >> 2] = HEAP32[($2 + 100 | 0) >> 2] | 0;
                     i64toi32_i32$0 = $11$hi;
                     i64toi32_i32$3 = $11;
                     i64toi32_i32$2 = -1;
                     i64toi32_i32$1 = -2;
                     i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
                     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
                     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$1 >>> 0) {
                      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
                     }
                     $10 = i64toi32_i32$4;
                     $10$hi = i64toi32_i32$5;
                     i64toi32_i32$0 = $10;
                     i64toi32_i32$3 = 0;
                     i64toi32_i32$1 = 1;
                     if (i64toi32_i32$5 >>> 0 > i64toi32_i32$3 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$0 >>> 0 > i64toi32_i32$1 >>> 0 | 0) | 0) {
                      break label$20
                     }
                     i64toi32_i32$0 = $10$hi;
                     switch ($10 | 0) {
                     case 1:
                      break label$18;
                     default:
                      break label$19;
                     };
                    }
                    i64toi32_i32$1 = $2 + 120 | 0;
                    i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                    i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                    $57 = i64toi32_i32$0;
                    i64toi32_i32$0 = $2 + 32 | 0;
                    HEAP32[i64toi32_i32$0 >> 2] = $57;
                    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$5;
                    i64toi32_i32$1 = $2 + 128 | 0;
                    i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                    i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                    $63 = i64toi32_i32$5;
                    i64toi32_i32$5 = ($2 + 24 | 0) + 16 | 0;
                    HEAP32[i64toi32_i32$5 >> 2] = $63;
                    HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
                    i64toi32_i32$1 = $2 + 112 | 0;
                    i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                    i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                    $67 = i64toi32_i32$0;
                    i64toi32_i32$0 = $2;
                    HEAP32[($2 + 24 | 0) >> 2] = $67;
                    HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$5;
                    i64toi32_i32$5 = $11$hi;
                    i64toi32_i32$1 = $11;
                    i64toi32_i32$0 = 0;
                    i64toi32_i32$3 = 32;
                    i64toi32_i32$2 = i64toi32_i32$3 & 31 | 0;
                    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                     i64toi32_i32$0 = 0;
                     $56 = i64toi32_i32$5 >>> i64toi32_i32$2 | 0;
                    } else {
                     i64toi32_i32$0 = i64toi32_i32$5 >>> i64toi32_i32$2 | 0;
                     $56 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$2 | 0) | 0;
                    }
                    $3 = $56;
                    i64toi32_i32$0 = $11$hi;
                    i64toi32_i32$5 = $11;
                    i64toi32_i32$1 = 0;
                    i64toi32_i32$3 = 8;
                    i64toi32_i32$2 = i64toi32_i32$3 & 31 | 0;
                    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                     i64toi32_i32$1 = 0;
                     $58 = i64toi32_i32$0 >>> i64toi32_i32$2 | 0;
                    } else {
                     i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$2 | 0;
                     $58 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$2 | 0) | 0;
                    }
                    $4 = $58;
                    i64toi32_i32$0 = ($2 + 88 | 0) + 16 | 0;
                    i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                    i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                    $10 = i64toi32_i32$1;
                    $10$hi = i64toi32_i32$5;
                    i64toi32_i32$5 = $11$hi;
                    $8 = $11;
                    break label$5;
                   }
                   i64toi32_i32$5 = $11$hi;
                   i64toi32_i32$0 = $11;
                   i64toi32_i32$1 = 0;
                   i64toi32_i32$3 = 32;
                   i64toi32_i32$2 = i64toi32_i32$3 & 31 | 0;
                   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                    i64toi32_i32$1 = 0;
                    $59 = i64toi32_i32$5 >>> i64toi32_i32$2 | 0;
                   } else {
                    i64toi32_i32$1 = i64toi32_i32$5 >>> i64toi32_i32$2 | 0;
                    $59 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$2 | 0) | 0;
                   }
                   $3 = $59;
                   i64toi32_i32$1 = $11$hi;
                   i64toi32_i32$5 = $11;
                   i64toi32_i32$0 = 0;
                   i64toi32_i32$3 = 8;
                   i64toi32_i32$2 = i64toi32_i32$3 & 31 | 0;
                   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                    i64toi32_i32$0 = 0;
                    $60 = i64toi32_i32$1 >>> i64toi32_i32$2 | 0;
                   } else {
                    i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$2 | 0;
                    $60 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$2 | 0) | 0;
                   }
                   $4 = $60;
                   i64toi32_i32$0 = $11$hi;
                   $8 = $11;
                   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 48 | 0 | 0);
                   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 48 | 0 | 0);
                   $5 = 0;
                   $6 = 15;
                   i64toi32_i32$0 = 0;
                   $10 = 2;
                   $10$hi = i64toi32_i32$0;
                   break label$4;
                  }
                  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 | 0, $2 + 48 | 0 | 0);
                  num_bigint__bigint__BigInt__from_bytes_be__h2ccfcd4424e804e6($2 + 88 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
                  $1 = HEAPU8[($2 + 101 | 0) >> 0] | 0 | ((HEAPU8[($2 + 102 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 103 | 0) >> 0] | 0) << 16 | 0) | 0;
                  $3 = HEAPU8[($2 + 100 | 0) >> 0] | 0;
                  $4 = HEAP32[($2 + 96 | 0) >> 2] | 0;
                  $5 = HEAP32[($2 + 92 | 0) >> 2] | 0;
                  $6 = HEAP32[($2 + 88 | 0) >> 2] | 0;
                  break label$17;
                 }
                 $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $2 + 48 | 0 | 0);
                 num_bigint__bigint__BigInt__from_bytes_be__h2ccfcd4424e804e6($2 + 24 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
                 i64toi32_i32$5 = $2;
                 i64toi32_i32$0 = 0;
                 HEAP32[($2 + 68 | 0) >> 2] = 0;
                 HEAP32[($2 + 72 | 0) >> 2] = i64toi32_i32$0;
                 HEAP32[($2 + 64 | 0) >> 2] = HEAP32[(0 + 1057660 | 0) >> 2] | 0;
                 alloc__vec__Vec_T_2cA___reserve__hd6ffa03575bd5508($2 + 64 | 0 | 0, 1 | 0);
                 $3 = 2;
                 HEAP8[($2 + 100 | 0) >> 0] = 2;
                 $4 = ($2 + 64 | 0) + 8 | 0;
                 HEAP32[((HEAP32[($2 + 64 | 0) >> 2] | 0) + ((HEAP32[$4 >> 2] | 0) << 2 | 0) | 0) >> 2] = 1;
                 HEAP32[(($2 + 88 | 0) + 8 | 0) >> 2] = (HEAP32[$4 >> 2] | 0) + 1 | 0;
                 i64toi32_i32$1 = $2;
                 i64toi32_i32$0 = HEAP32[($2 + 64 | 0) >> 2] | 0;
                 i64toi32_i32$5 = HEAP32[($2 + 68 | 0) >> 2] | 0;
                 $149 = i64toi32_i32$0;
                 i64toi32_i32$0 = $2;
                 HEAP32[($2 + 88 | 0) >> 2] = $149;
                 HEAP32[($2 + 92 | 0) >> 2] = i64toi32_i32$5;
                 num_bigint__bigint__addition___impl_20core__ops__arith__Add__num_bigint__bigint__BigInt__20for_20_num_bigint__bigint__BigInt___add__h354544d3f4ae9625_1($2 + 64 | 0 | 0, $2 + 24 | 0 | 0, $2 + 88 | 0 | 0);
                 $4 = HEAPU8[($2 + 76 | 0) >> 0] | 0;
                 if (($4 | 0) == (3 | 0)) {
                  break label$8
                 }
                 $1 = (HEAPU8[($2 + 79 | 0) >> 0] | 0) << 16 | 0;
                 $5 = HEAPU8[($2 + 77 | 0) >> 0] | 0 | ((HEAPU8[($2 + 78 | 0) >> 0] | 0) << 8 | 0) | 0;
                 label$22 : {
                  label$23 : {
                   switch ($4 & 3 | 0 | 0) {
                   case 1:
                    $3 = 1;
                    break label$22;
                   case 2:
                    break label$23;
                   default:
                    break label$22;
                   };
                  }
                  $3 = 0;
                 }
                 $1 = $5 | $1 | 0;
                 $4 = HEAP32[($2 + 72 | 0) >> 2] | 0;
                 $5 = HEAP32[($2 + 68 | 0) >> 2] | 0;
                 $6 = HEAP32[($2 + 64 | 0) >> 2] | 0;
                 $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h19f76bdb6b4883ef($2 + 88 | 0 | 0);
                 $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h970b13f6299e0f2d($2 + 88 | 0 | 0);
                 $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h19f76bdb6b4883ef($2 + 24 | 0 | 0);
                 $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h970b13f6299e0f2d($2 + 24 | 0 | 0);
                }
                $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 48 | 0 | 0);
                $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 48 | 0 | 0);
                break label$6;
               case 1:
                cardano_serialization_lib__utils__read_nint__h6af092dfd2bc47da($2 + 88 | 0 | 0, $1 | 0);
                i64toi32_i32$1 = ($2 + 88 | 0) + 16 | 0;
                i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                $11 = i64toi32_i32$5;
                $11$hi = i64toi32_i32$0;
                i64toi32_i32$1 = $2;
                i64toi32_i32$0 = HEAP32[($2 + 96 | 0) >> 2] | 0;
                i64toi32_i32$5 = HEAP32[($2 + 100 | 0) >> 2] | 0;
                $10 = i64toi32_i32$0;
                $10$hi = i64toi32_i32$5;
                label$25 : {
                 i64toi32_i32$1 = $2;
                 i64toi32_i32$5 = HEAP32[($2 + 88 | 0) >> 2] | 0;
                 i64toi32_i32$0 = HEAP32[($2 + 92 | 0) >> 2] | 0;
                 i64toi32_i32$1 = i64toi32_i32$5;
                 i64toi32_i32$5 = 0;
                 i64toi32_i32$3 = 1;
                 if ((i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$5 | 0) | 0) {
                  break label$25
                 }
                 label$26 : {
                  i64toi32_i32$1 = $11$hi;
                  i64toi32_i32$3 = $11;
                  i64toi32_i32$0 = -1;
                  i64toi32_i32$5 = -1;
                  if ((i64toi32_i32$1 | 0) > (i64toi32_i32$0 | 0)) {
                   $61 = 1
                  } else {
                   if ((i64toi32_i32$1 | 0) >= (i64toi32_i32$0 | 0)) {
                    if (i64toi32_i32$3 >>> 0 <= i64toi32_i32$5 >>> 0) {
                     $62 = 0
                    } else {
                     $62 = 1
                    }
                    $64 = $62;
                   } else {
                    $64 = 0
                   }
                   $61 = $64;
                  }
                  if ($61) {
                   break label$26
                  }
                  $1 = 0;
                  HEAP32[($2 + 88 | 0) >> 2] = HEAP32[(0 + 1057660 | 0) >> 2] | 0;
                  i64toi32_i32$1 = $2;
                  i64toi32_i32$3 = 0;
                  HEAP32[($2 + 92 | 0) >> 2] = 0;
                  HEAP32[($2 + 96 | 0) >> 2] = i64toi32_i32$3;
                  i64toi32_i32$3 = $10$hi;
                  i64toi32_i32$3 = 0;
                  i64toi32_i32$5 = 0;
                  i64toi32_i32$1 = $10$hi;
                  i64toi32_i32$0 = $10;
                  i64toi32_i32$2 = i64toi32_i32$5 - i64toi32_i32$0 | 0;
                  i64toi32_i32$6 = i64toi32_i32$5 >>> 0 < i64toi32_i32$0 >>> 0;
                  i64toi32_i32$4 = i64toi32_i32$6 + i64toi32_i32$1 | 0;
                  i64toi32_i32$4 = i64toi32_i32$3 - i64toi32_i32$4 | 0;
                  $12 = i64toi32_i32$2;
                  $12$hi = i64toi32_i32$4;
                  i64toi32_i32$4 = $11$hi;
                  i64toi32_i32$4 = i64toi32_i32$1;
                  i64toi32_i32$4 = i64toi32_i32$1;
                  i64toi32_i32$3 = i64toi32_i32$0;
                  i64toi32_i32$5 = 0;
                  i64toi32_i32$0 = 0;
                  $210 = (i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$5 | 0) | 0;
                  i64toi32_i32$3 = 0;
                  $211$hi = i64toi32_i32$3;
                  i64toi32_i32$3 = $11$hi;
                  i64toi32_i32$0 = $11;
                  i64toi32_i32$4 = $211$hi;
                  i64toi32_i32$5 = $210;
                  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
                  i64toi32_i32$2 = i64toi32_i32$3 + i64toi32_i32$4 | 0;
                  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$5 >>> 0) {
                   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
                  }
                  $212$hi = i64toi32_i32$2;
                  i64toi32_i32$2 = 0;
                  i64toi32_i32$3 = 0;
                  i64toi32_i32$0 = $212$hi;
                  i64toi32_i32$5 = i64toi32_i32$1;
                  i64toi32_i32$4 = i64toi32_i32$3 - i64toi32_i32$1 | 0;
                  i64toi32_i32$6 = i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0;
                  i64toi32_i32$1 = i64toi32_i32$6 + i64toi32_i32$0 | 0;
                  i64toi32_i32$1 = i64toi32_i32$2 - i64toi32_i32$1 | 0;
                  $11 = i64toi32_i32$4;
                  $11$hi = i64toi32_i32$1;
                  $4 = 0;
                  label$27 : while (1) {
                   i64toi32_i32$1 = $12$hi;
                   $3 = $12;
                   label$28 : {
                    if (($4 | 0) != ($1 | 0)) {
                     break label$28
                    }
                    alloc__vec__Vec_T_2cA___reserve__hd6ffa03575bd5508($2 + 88 | 0 | 0, 1 | 0);
                    $4 = HEAP32[($2 + 96 | 0) >> 2] | 0;
                   }
                   HEAP32[((HEAP32[($2 + 88 | 0) >> 2] | 0) + ($4 << 2 | 0) | 0) >> 2] = $3;
                   $4 = (HEAP32[($2 + 96 | 0) >> 2] | 0) + 1 | 0;
                   HEAP32[($2 + 96 | 0) >> 2] = $4;
                   i64toi32_i32$1 = $12$hi;
                   i64toi32_i32$2 = $12;
                   i64toi32_i32$3 = 0;
                   i64toi32_i32$5 = 32;
                   i64toi32_i32$0 = i64toi32_i32$5 & 31 | 0;
                   if (32 >>> 0 <= (i64toi32_i32$5 & 63 | 0) >>> 0) {
                    i64toi32_i32$3 = 0;
                    $65 = i64toi32_i32$1 >>> i64toi32_i32$0 | 0;
                   } else {
                    i64toi32_i32$3 = i64toi32_i32$1 >>> i64toi32_i32$0 | 0;
                    $65 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$0 | 0) | 0;
                   }
                   $235 = $65;
                   $235$hi = i64toi32_i32$3;
                   i64toi32_i32$3 = $11$hi;
                   i64toi32_i32$1 = $11;
                   i64toi32_i32$2 = 0;
                   i64toi32_i32$5 = 32;
                   i64toi32_i32$0 = i64toi32_i32$5 & 31 | 0;
                   if (32 >>> 0 <= (i64toi32_i32$5 & 63 | 0) >>> 0) {
                    i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$0 | 0;
                    $66 = 0;
                   } else {
                    i64toi32_i32$2 = ((1 << i64toi32_i32$0 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$0 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$0 | 0) | 0;
                    $66 = i64toi32_i32$1 << i64toi32_i32$0 | 0;
                   }
                   $237$hi = i64toi32_i32$2;
                   i64toi32_i32$2 = $235$hi;
                   i64toi32_i32$3 = $235;
                   i64toi32_i32$1 = $237$hi;
                   i64toi32_i32$5 = $66;
                   i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
                   $12 = i64toi32_i32$3 | i64toi32_i32$5 | 0;
                   $12$hi = i64toi32_i32$1;
                   $239 = $12;
                   $239$hi = i64toi32_i32$1;
                   i64toi32_i32$1 = $11$hi;
                   i64toi32_i32$2 = $11;
                   i64toi32_i32$3 = 0;
                   i64toi32_i32$5 = 32;
                   i64toi32_i32$0 = i64toi32_i32$5 & 31 | 0;
                   if (32 >>> 0 <= (i64toi32_i32$5 & 63 | 0) >>> 0) {
                    i64toi32_i32$3 = 0;
                    $68 = i64toi32_i32$1 >>> i64toi32_i32$0 | 0;
                   } else {
                    i64toi32_i32$3 = i64toi32_i32$1 >>> i64toi32_i32$0 | 0;
                    $68 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$0 | 0) | 0;
                   }
                   $11 = $68;
                   $11$hi = i64toi32_i32$3;
                   i64toi32_i32$3 = $239$hi;
                   i64toi32_i32$1 = $239;
                   i64toi32_i32$2 = $11$hi;
                   i64toi32_i32$5 = $11;
                   i64toi32_i32$2 = i64toi32_i32$3 | i64toi32_i32$2 | 0;
                   if (!(i64toi32_i32$1 | i64toi32_i32$5 | 0 | i64toi32_i32$2 | 0)) {
                    break label$11
                   }
                   $1 = HEAP32[($2 + 92 | 0) >> 2] | 0;
                   continue label$27;
                  };
                 }
                 i64toi32_i32$2 = $10$hi;
                 i64toi32_i32$2 = $11$hi;
                 i64toi32_i32$2 = $10$hi;
                 i64toi32_i32$3 = $10;
                 i64toi32_i32$1 = $11$hi;
                 i64toi32_i32$5 = $11;
                 i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
                 i64toi32_i32$2 = i64toi32_i32$3 | i64toi32_i32$5 | 0;
                 i64toi32_i32$3 = 0;
                 i64toi32_i32$5 = 0;
                 if ((i64toi32_i32$2 | 0) == (i64toi32_i32$5 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) | 0) {
                  break label$7
                 }
                 i64toi32_i32$1 = $2;
                 i64toi32_i32$2 = 0;
                 HEAP32[($2 + 92 | 0) >> 2] = 0;
                 HEAP32[($2 + 96 | 0) >> 2] = i64toi32_i32$2;
                 $1 = 0;
                 HEAP32[($2 + 88 | 0) >> 2] = HEAP32[(0 + 1057660 | 0) >> 2] | 0;
                 $4 = 0;
                 label$29 : while (1) {
                  i64toi32_i32$2 = $10$hi;
                  $3 = $10;
                  label$30 : {
                   if (($4 | 0) != ($1 | 0)) {
                    break label$30
                   }
                   alloc__vec__Vec_T_2cA___reserve__hd6ffa03575bd5508($2 + 88 | 0 | 0, 1 | 0);
                   $4 = HEAP32[($2 + 96 | 0) >> 2] | 0;
                  }
                  HEAP32[((HEAP32[($2 + 88 | 0) >> 2] | 0) + ($4 << 2 | 0) | 0) >> 2] = $3;
                  $4 = (HEAP32[($2 + 96 | 0) >> 2] | 0) + 1 | 0;
                  HEAP32[($2 + 96 | 0) >> 2] = $4;
                  i64toi32_i32$2 = $10$hi;
                  i64toi32_i32$5 = $10;
                  i64toi32_i32$1 = 0;
                  i64toi32_i32$3 = 32;
                  i64toi32_i32$0 = i64toi32_i32$3 & 31 | 0;
                  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                   i64toi32_i32$1 = 0;
                   $69 = i64toi32_i32$2 >>> i64toi32_i32$0 | 0;
                  } else {
                   i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$0 | 0;
                   $69 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$0 | 0) | 0;
                  }
                  $275 = $69;
                  $275$hi = i64toi32_i32$1;
                  i64toi32_i32$1 = $11$hi;
                  i64toi32_i32$2 = $11;
                  i64toi32_i32$5 = 0;
                  i64toi32_i32$3 = 32;
                  i64toi32_i32$0 = i64toi32_i32$3 & 31 | 0;
                  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                   i64toi32_i32$5 = i64toi32_i32$2 << i64toi32_i32$0 | 0;
                   $70 = 0;
                  } else {
                   i64toi32_i32$5 = ((1 << i64toi32_i32$0 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$0 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$0 | 0) | 0;
                   $70 = i64toi32_i32$2 << i64toi32_i32$0 | 0;
                  }
                  $277$hi = i64toi32_i32$5;
                  i64toi32_i32$5 = $275$hi;
                  i64toi32_i32$1 = $275;
                  i64toi32_i32$2 = $277$hi;
                  i64toi32_i32$3 = $70;
                  i64toi32_i32$2 = i64toi32_i32$5 | i64toi32_i32$2 | 0;
                  $10 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
                  $10$hi = i64toi32_i32$2;
                  $279 = $10;
                  $279$hi = i64toi32_i32$2;
                  i64toi32_i32$2 = $11$hi;
                  i64toi32_i32$5 = $11;
                  i64toi32_i32$1 = 0;
                  i64toi32_i32$3 = 32;
                  i64toi32_i32$0 = i64toi32_i32$3 & 31 | 0;
                  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                   i64toi32_i32$1 = 0;
                   $71 = i64toi32_i32$2 >>> i64toi32_i32$0 | 0;
                  } else {
                   i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$0 | 0;
                   $71 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$0 | 0) | 0;
                  }
                  $11 = $71;
                  $11$hi = i64toi32_i32$1;
                  i64toi32_i32$1 = $279$hi;
                  i64toi32_i32$2 = $279;
                  i64toi32_i32$5 = $11$hi;
                  i64toi32_i32$3 = $11;
                  i64toi32_i32$5 = i64toi32_i32$1 | i64toi32_i32$5 | 0;
                  if (!(i64toi32_i32$2 | i64toi32_i32$3 | 0 | i64toi32_i32$5 | 0)) {
                   break label$13
                  }
                  $1 = HEAP32[($2 + 92 | 0) >> 2] | 0;
                  continue label$29;
                 };
                }
                i64toi32_i32$1 = $2 + 128 | 0;
                i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                $292 = i64toi32_i32$5;
                i64toi32_i32$5 = ($2 + 24 | 0) + 8 | 0;
                HEAP32[i64toi32_i32$5 >> 2] = $292;
                HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$2;
                i64toi32_i32$1 = $2 + 136 | 0;
                i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                $298 = i64toi32_i32$2;
                i64toi32_i32$2 = ($2 + 24 | 0) + 16 | 0;
                HEAP32[i64toi32_i32$2 >> 2] = $298;
                HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$5;
                HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 156 | 0) >> 2] | 0;
                i64toi32_i32$1 = $2;
                i64toi32_i32$5 = HEAP32[($2 + 148 | 0) >> 2] | 0;
                i64toi32_i32$2 = HEAP32[($2 + 152 | 0) >> 2] | 0;
                $307 = i64toi32_i32$5;
                i64toi32_i32$5 = $2;
                HEAP32[($2 + 64 | 0) >> 2] = $307;
                HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$2;
                i64toi32_i32$1 = $2 + 120 | 0;
                i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                $311 = i64toi32_i32$2;
                i64toi32_i32$2 = $2;
                HEAP32[($2 + 24 | 0) >> 2] = $311;
                HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$5;
                i64toi32_i32$5 = $10$hi;
                $6 = $10;
                $5 = $10 & -256 | 0;
                i64toi32_i32$1 = $10;
                i64toi32_i32$2 = 0;
                i64toi32_i32$3 = 32;
                i64toi32_i32$0 = i64toi32_i32$3 & 31 | 0;
                if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                 i64toi32_i32$2 = 0;
                 $72 = i64toi32_i32$5 >>> i64toi32_i32$0 | 0;
                } else {
                 i64toi32_i32$2 = i64toi32_i32$5 >>> i64toi32_i32$0 | 0;
                 $72 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$0 | 0) | 0;
                }
                $9 = $72;
                i64toi32_i32$2 = $11$hi;
                i64toi32_i32$5 = $11;
                i64toi32_i32$1 = 0;
                i64toi32_i32$3 = 32;
                i64toi32_i32$0 = i64toi32_i32$3 & 31 | 0;
                if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                 i64toi32_i32$1 = 0;
                 $73 = i64toi32_i32$2 >>> i64toi32_i32$0 | 0;
                } else {
                 i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$0 | 0;
                 $73 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$0 | 0) | 0;
                }
                $3 = $73;
                i64toi32_i32$1 = $11$hi;
                i64toi32_i32$2 = $11;
                i64toi32_i32$5 = 0;
                i64toi32_i32$3 = 8;
                i64toi32_i32$0 = i64toi32_i32$3 & 31 | 0;
                if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                 i64toi32_i32$5 = 0;
                 $74 = i64toi32_i32$1 >>> i64toi32_i32$0 | 0;
                } else {
                 i64toi32_i32$5 = i64toi32_i32$1 >>> i64toi32_i32$0 | 0;
                 $74 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$0 | 0) | 0;
                }
                $4 = $74;
                i64toi32_i32$1 = $2 + 112 | 0;
                i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                $10 = i64toi32_i32$5;
                $10$hi = i64toi32_i32$2;
                $7 = HEAP32[($2 + 144 | 0) >> 2] | 0;
                i64toi32_i32$2 = $11$hi;
                $8 = $11;
                break label$2;
               case 0:
                break label$14;
               default:
                break label$2;
               };
              }
              cbor_event__de__Deserializer_R___unsigned_integer__h1ed99c0b7fe7eea1($2 + 88 | 0 | 0, $1 | 0);
              i64toi32_i32$1 = $2;
              i64toi32_i32$2 = HEAP32[($2 + 96 | 0) >> 2] | 0;
              i64toi32_i32$5 = HEAP32[($2 + 100 | 0) >> 2] | 0;
              $11 = i64toi32_i32$2;
              $11$hi = i64toi32_i32$5;
              i64toi32_i32$1 = $2;
              i64toi32_i32$5 = HEAP32[($2 + 88 | 0) >> 2] | 0;
              i64toi32_i32$2 = HEAP32[($2 + 92 | 0) >> 2] | 0;
              i64toi32_i32$1 = i64toi32_i32$5;
              i64toi32_i32$5 = 0;
              i64toi32_i32$3 = 1;
              if ((i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$5 | 0) | 0) {
               break label$12
              }
              i64toi32_i32$1 = $11$hi;
              i64toi32_i32$3 = $11;
              i64toi32_i32$2 = 0;
              i64toi32_i32$5 = 0;
              if ((i64toi32_i32$3 | 0) == (i64toi32_i32$5 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) | 0) {
               break label$7
              }
              i64toi32_i32$1 = $2;
              i64toi32_i32$3 = 0;
              HEAP32[($2 + 92 | 0) >> 2] = 0;
              HEAP32[($2 + 96 | 0) >> 2] = i64toi32_i32$3;
              $1 = 0;
              HEAP32[($2 + 88 | 0) >> 2] = HEAP32[(0 + 1057660 | 0) >> 2] | 0;
              $4 = 0;
              label$31 : while (1) {
               i64toi32_i32$3 = $11$hi;
               $3 = $11;
               label$32 : {
                if (($4 | 0) != ($1 | 0)) {
                 break label$32
                }
                alloc__vec__Vec_T_2cA___reserve__hd6ffa03575bd5508($2 + 88 | 0 | 0, 1 | 0);
                $4 = HEAP32[($2 + 96 | 0) >> 2] | 0;
               }
               HEAP32[((HEAP32[($2 + 88 | 0) >> 2] | 0) + ($4 << 2 | 0) | 0) >> 2] = $3;
               $4 = (HEAP32[($2 + 96 | 0) >> 2] | 0) + 1 | 0;
               HEAP32[($2 + 96 | 0) >> 2] = $4;
               i64toi32_i32$3 = $11$hi;
               i64toi32_i32$5 = $11;
               i64toi32_i32$1 = 0;
               i64toi32_i32$2 = 32;
               i64toi32_i32$0 = i64toi32_i32$2 & 31 | 0;
               if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                i64toi32_i32$1 = 0;
                $75 = i64toi32_i32$3 >>> i64toi32_i32$0 | 0;
               } else {
                i64toi32_i32$1 = i64toi32_i32$3 >>> i64toi32_i32$0 | 0;
                $75 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$0 | 0) | 0;
               }
               $11 = $75;
               $11$hi = i64toi32_i32$1;
               if (!($11 | i64toi32_i32$1 | 0)) {
                break label$13
               }
               $1 = HEAP32[($2 + 92 | 0) >> 2] | 0;
               continue label$31;
              };
             }
             $5 = HEAP32[($2 + 92 | 0) >> 2] | 0;
             $6 = HEAP32[($2 + 88 | 0) >> 2] | 0;
             $3 = 2;
             break label$10;
            }
            i64toi32_i32$3 = $2 + 120 | 0;
            i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
            i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
            $380 = i64toi32_i32$1;
            i64toi32_i32$1 = $2 + 32 | 0;
            HEAP32[i64toi32_i32$1 >> 2] = $380;
            HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$5;
            i64toi32_i32$3 = $2 + 128 | 0;
            i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
            i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
            $386 = i64toi32_i32$5;
            i64toi32_i32$5 = ($2 + 24 | 0) + 16 | 0;
            HEAP32[i64toi32_i32$5 >> 2] = $386;
            HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$1;
            i64toi32_i32$3 = $2 + 112 | 0;
            i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
            i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
            $390 = i64toi32_i32$1;
            i64toi32_i32$1 = $2;
            HEAP32[($2 + 24 | 0) >> 2] = $390;
            HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$5;
            i64toi32_i32$5 = $11$hi;
            i64toi32_i32$3 = $11;
            i64toi32_i32$1 = 0;
            i64toi32_i32$2 = 32;
            i64toi32_i32$0 = i64toi32_i32$2 & 31 | 0;
            if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
             i64toi32_i32$1 = 0;
             $76 = i64toi32_i32$5 >>> i64toi32_i32$0 | 0;
            } else {
             i64toi32_i32$1 = i64toi32_i32$5 >>> i64toi32_i32$0 | 0;
             $76 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$0 | 0) | 0;
            }
            $3 = $76;
            i64toi32_i32$1 = $11$hi;
            i64toi32_i32$5 = $11;
            i64toi32_i32$3 = 0;
            i64toi32_i32$2 = 8;
            i64toi32_i32$0 = i64toi32_i32$2 & 31 | 0;
            if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
             i64toi32_i32$3 = 0;
             $77 = i64toi32_i32$1 >>> i64toi32_i32$0 | 0;
            } else {
             i64toi32_i32$3 = i64toi32_i32$1 >>> i64toi32_i32$0 | 0;
             $77 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$0 | 0) | 0;
            }
            $4 = $77;
            i64toi32_i32$1 = ($2 + 88 | 0) + 16 | 0;
            i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
            i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
            $10 = i64toi32_i32$3;
            $10$hi = i64toi32_i32$5;
            i64toi32_i32$5 = $11$hi;
            $8 = $11;
            break label$5;
           }
           $5 = HEAP32[($2 + 92 | 0) >> 2] | 0;
           $6 = HEAP32[($2 + 88 | 0) >> 2] | 0;
           $3 = 0;
          }
          break label$6;
         }
         i64toi32_i32$1 = $2 + 128 | 0;
         i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
         $412 = i64toi32_i32$5;
         i64toi32_i32$5 = ($2 + 24 | 0) + 8 | 0;
         HEAP32[i64toi32_i32$5 >> 2] = $412;
         HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$3;
         i64toi32_i32$1 = $2 + 136 | 0;
         i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
         i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
         $418 = i64toi32_i32$3;
         i64toi32_i32$3 = ($2 + 24 | 0) + 16 | 0;
         HEAP32[i64toi32_i32$3 >> 2] = $418;
         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
         HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 156 | 0) >> 2] | 0;
         i64toi32_i32$1 = $2 + 120 | 0;
         i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
         $428 = i64toi32_i32$5;
         i64toi32_i32$5 = $2;
         HEAP32[($2 + 24 | 0) >> 2] = $428;
         HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$3;
         i64toi32_i32$1 = $2 + 148 | 0;
         i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
         i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
         $432 = i64toi32_i32$3;
         i64toi32_i32$3 = $2;
         HEAP32[($2 + 64 | 0) >> 2] = $432;
         HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$5;
         $6 = HEAP32[(($2 + 88 | 0) + 8 | 0) >> 2] | 0;
         $5 = $6 & -256 | 0;
         $78 = $2 + 105 | 0;
         $4 = HEAPU8[$78 >> 0] | 0 | ((HEAPU8[($78 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 107 | 0) >> 0] | 0) << 16 | 0) | 0;
         i64toi32_i32$1 = $2 + 112 | 0;
         i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
         $10 = i64toi32_i32$5;
         $10$hi = i64toi32_i32$3;
         $3 = HEAP32[($2 + 108 | 0) >> 2] | 0;
         $8 = HEAPU8[(($2 + 88 | 0) + 16 | 0) >> 0] | 0;
         $9 = HEAP32[($2 + 100 | 0) >> 2] | 0;
         $7 = HEAP32[($2 + 144 | 0) >> 2] | 0;
         break label$2;
        }
        core__panicking__panic__h2fd385a887c8bf13(1057508 | 0, 43 | 0, 1057908 | 0);
        abort();
       }
       $5 = 0;
       $6 = HEAP32[(0 + 1057660 | 0) >> 2] | 0;
       $3 = 1;
       $4 = 0;
      }
      HEAP8[($0 + 17 | 0) >> 0] = $1;
      HEAP8[($0 + 18 | 0) >> 0] = $1 >>> 8 | 0;
      HEAP32[($0 + 4 | 0) >> 2] = $6;
      HEAP8[($0 + 19 | 0) >> 0] = $1 >>> 16 | 0;
      HEAP8[($0 + 16 | 0) >> 0] = $3;
      HEAP32[($0 + 12 | 0) >> 2] = $4;
      HEAP32[($0 + 8 | 0) >> 2] = $5;
      $4 = 0;
      break label$1;
     }
     $5 = 0;
     $6 = 2;
    }
    $7 = 0;
   }
   HEAP8[($2 + 99 | 0) >> 0] = $4 >>> 16 | 0;
   $79 = $2 + 97 | 0;
   HEAP8[$79 >> 0] = $4;
   HEAP8[($79 + 1 | 0) >> 0] = $4 >>> 8 | 0;
   i64toi32_i32$3 = $10$hi;
   i64toi32_i32$5 = ($2 + 88 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$5 >> 2] = $10;
   HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$3;
   HEAP32[($2 + 100 | 0) >> 2] = $3;
   HEAP8[(($2 + 88 | 0) + 8 | 0) >> 0] = $8;
   i64toi32_i32$1 = $2;
   i64toi32_i32$3 = HEAP32[($2 + 24 | 0) >> 2] | 0;
   i64toi32_i32$5 = HEAP32[($2 + 28 | 0) >> 2] | 0;
   $502 = i64toi32_i32$3;
   i64toi32_i32$3 = $2 + 112 | 0;
   HEAP32[i64toi32_i32$3 >> 2] = $502;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = $2;
   i64toi32_i32$5 = HEAP32[($2 + 64 | 0) >> 2] | 0;
   i64toi32_i32$3 = HEAP32[($2 + 68 | 0) >> 2] | 0;
   $506 = i64toi32_i32$5;
   i64toi32_i32$5 = $2 + 140 | 0;
   HEAP32[i64toi32_i32$5 >> 2] = $506;
   HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$1 = ($2 + 24 | 0) + 8 | 0;
   i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $512 = i64toi32_i32$3;
   i64toi32_i32$3 = $2 + 120 | 0;
   HEAP32[i64toi32_i32$3 >> 2] = $512;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$1 = ($2 + 24 | 0) + 16 | 0;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $518 = i64toi32_i32$5;
   i64toi32_i32$5 = $2 + 128 | 0;
   HEAP32[i64toi32_i32$5 >> 2] = $518;
   HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$3;
   HEAP32[($2 + 148 | 0) >> 2] = HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] | 0;
   HEAP32[($2 + 92 | 0) >> 2] = $9;
   HEAP32[($2 + 136 | 0) >> 2] = $7;
   HEAP32[($2 + 88 | 0) >> 2] = $6 & 255 | 0 | ($5 & -256 | 0) | 0;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 88 | 0 | 0, 1057924 | 0, 6 | 0);
   $4 = 1;
  }
  HEAP32[$0 >> 2] = $4;
  global$0 = $2 + 160 | 0;
 }
 
 function cardano_serialization_lib__emip3__encrypt_with_password__hdf5b83dbb9fd714f($0, $1, $2, $3, $4, $5, $6, $7, $8) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  $5 = $5 | 0;
  $6 = $6 | 0;
  $7 = $7 | 0;
  $8 = $8 | 0;
  var $9 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $10 = 0, i64toi32_i32$4 = 0, $10$hi = 0, i64toi32_i32$3 = 0, $24 = 0, $45 = 0, $97 = 0, $220 = 0, $245 = 0, $292 = 0, $370 = 0, $451 = 0;
  $9 = global$0 - 800 | 0;
  global$0 = $9;
  $alloc__vec__Vec_u8__20as_20hex__FromHex___from_hex__h4bc81c912cf347f6($9 + 568 | 0 | 0, $1 | 0, $2 | 0);
  $1 = HEAP32[($9 + 572 | 0) >> 2] | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           label$10 : {
            label$11 : {
             label$12 : {
              if ((HEAP32[($9 + 568 | 0) >> 2] | 0 | 0) != (1 | 0)) {
               break label$12
              }
              HEAP32[($9 + 556 | 0) >> 2] = HEAP32[($9 + 576 | 0) >> 2] | 0;
              HEAP32[($9 + 552 | 0) >> 2] = $1;
              i64toi32_i32$1 = $9;
              i64toi32_i32$0 = 0;
              HEAP32[($9 + 540 | 0) >> 2] = 0;
              HEAP32[($9 + 544 | 0) >> 2] = i64toi32_i32$0;
              HEAP32[($9 + 536 | 0) >> 2] = HEAP32[(0 + 1069072 | 0) >> 2] | 0;
              core__fmt__Formatter__new__he219faf25326051b($9 + 280 | 0 | 0, $9 + 536 | 0 | 0, 1068692 | 0);
              if (!($hex__error__FromHexError_20as_20core__fmt__Display___fmt__haa62d686bf8e55c9($9 + 552 | 0 | 0, $9 + 280 | 0 | 0) | 0)) {
               break label$11
              }
              core__result__unwrap_failed__h27f43d993c3864a1(1068716 | 0, 55 | 0, $9 + 264 | 0 | 0, 1068980 | 0, 1068848 | 0);
              abort();
             }
             i64toi32_i32$2 = $9;
             i64toi32_i32$0 = HEAP32[($9 + 576 | 0) >> 2] | 0;
             i64toi32_i32$1 = HEAP32[($9 + 580 | 0) >> 2] | 0;
             $45 = i64toi32_i32$0;
             i64toi32_i32$0 = $9;
             HEAP32[($9 + 204 | 0) >> 2] = $45;
             HEAP32[($9 + 208 | 0) >> 2] = i64toi32_i32$1;
             HEAP32[($9 + 200 | 0) >> 2] = $1;
             $alloc__vec__Vec_u8__20as_20hex__FromHex___from_hex__h4bc81c912cf347f6($9 + 568 | 0 | 0, $3 | 0, $4 | 0);
             $1 = HEAP32[($9 + 572 | 0) >> 2] | 0;
             if ((HEAP32[($9 + 568 | 0) >> 2] | 0 | 0) != (1 | 0)) {
              break label$10
             }
             HEAP32[($9 + 556 | 0) >> 2] = HEAP32[($9 + 576 | 0) >> 2] | 0;
             HEAP32[($9 + 552 | 0) >> 2] = $1;
             i64toi32_i32$0 = $9;
             i64toi32_i32$1 = 0;
             HEAP32[($9 + 540 | 0) >> 2] = 0;
             HEAP32[($9 + 544 | 0) >> 2] = i64toi32_i32$1;
             HEAP32[($9 + 536 | 0) >> 2] = HEAP32[(0 + 1069072 | 0) >> 2] | 0;
             core__fmt__Formatter__new__he219faf25326051b($9 + 280 | 0 | 0, $9 + 536 | 0 | 0, 1068692 | 0);
             if (!($hex__error__FromHexError_20as_20core__fmt__Display___fmt__haa62d686bf8e55c9($9 + 552 | 0 | 0, $9 + 280 | 0 | 0) | 0)) {
              break label$9
             }
             core__result__unwrap_failed__h27f43d993c3864a1(1068716 | 0, 55 | 0, $9 + 264 | 0 | 0, 1068980 | 0, 1068848 | 0);
             abort();
            }
            $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($9 + 8 | 0 | 0, $9 + 536 | 0 | 0);
            $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($9 + 8 | 0) >> 2] | 0 | 0, HEAP32[($9 + 12 | 0) >> 2] | 0 | 0) | 0;
            $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($9 + 536 | 0 | 0);
            $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($9 + 536 | 0 | 0);
            $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($1 | 0) | 0;
            HEAP32[$0 >> 2] = 1;
            HEAP32[($0 + 4 | 0) >> 2] = $1;
            break label$1;
           }
           i64toi32_i32$2 = $9;
           i64toi32_i32$1 = HEAP32[($9 + 576 | 0) >> 2] | 0;
           i64toi32_i32$0 = HEAP32[($9 + 580 | 0) >> 2] | 0;
           $97 = i64toi32_i32$1;
           i64toi32_i32$1 = $9;
           HEAP32[($9 + 220 | 0) >> 2] = $97;
           HEAP32[($9 + 224 | 0) >> 2] = i64toi32_i32$0;
           HEAP32[($9 + 216 | 0) >> 2] = $1;
           $alloc__vec__Vec_u8__20as_20hex__FromHex___from_hex__h4bc81c912cf347f6($9 + 568 | 0 | 0, $5 | 0, $6 | 0);
           $1 = HEAP32[($9 + 572 | 0) >> 2] | 0;
           if ((HEAP32[($9 + 568 | 0) >> 2] | 0 | 0) != (1 | 0)) {
            break label$8
           }
           HEAP32[($9 + 556 | 0) >> 2] = HEAP32[($9 + 576 | 0) >> 2] | 0;
           HEAP32[($9 + 552 | 0) >> 2] = $1;
           i64toi32_i32$1 = $9;
           i64toi32_i32$0 = 0;
           HEAP32[($9 + 540 | 0) >> 2] = 0;
           HEAP32[($9 + 544 | 0) >> 2] = i64toi32_i32$0;
           HEAP32[($9 + 536 | 0) >> 2] = HEAP32[(0 + 1069072 | 0) >> 2] | 0;
           core__fmt__Formatter__new__he219faf25326051b($9 + 280 | 0 | 0, $9 + 536 | 0 | 0, 1068692 | 0);
           if (!($hex__error__FromHexError_20as_20core__fmt__Display___fmt__haa62d686bf8e55c9($9 + 552 | 0 | 0, $9 + 280 | 0 | 0) | 0)) {
            break label$7
           }
           core__result__unwrap_failed__h27f43d993c3864a1(1068716 | 0, 55 | 0, $9 + 264 | 0 | 0, 1068980 | 0, 1068848 | 0);
           abort();
          }
          $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($9 + 16 | 0 | 0, $9 + 536 | 0 | 0);
          $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($9 + 16 | 0) >> 2] | 0 | 0, HEAP32[($9 + 20 | 0) >> 2] | 0 | 0) | 0;
          $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($9 + 536 | 0 | 0);
          $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($9 + 536 | 0 | 0);
          $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($1 | 0) | 0;
          HEAP32[$0 >> 2] = 1;
          HEAP32[($0 + 4 | 0) >> 2] = $1;
          break label$2;
         }
         i64toi32_i32$2 = $9;
         i64toi32_i32$0 = HEAP32[($9 + 576 | 0) >> 2] | 0;
         i64toi32_i32$1 = HEAP32[($9 + 580 | 0) >> 2] | 0;
         $10 = i64toi32_i32$0;
         $10$hi = i64toi32_i32$1;
         i64toi32_i32$0 = $9;
         HEAP32[($9 + 236 | 0) >> 2] = $10;
         HEAP32[($9 + 240 | 0) >> 2] = i64toi32_i32$1;
         HEAP32[($9 + 232 | 0) >> 2] = $1;
         $alloc__vec__Vec_u8__20as_20hex__FromHex___from_hex__h4bc81c912cf347f6($9 + 568 | 0 | 0, $7 | 0, $8 | 0);
         $1 = HEAP32[($9 + 572 | 0) >> 2] | 0;
         if ((HEAP32[($9 + 568 | 0) >> 2] | 0 | 0) != (1 | 0)) {
          break label$5
         }
         HEAP32[($9 + 556 | 0) >> 2] = HEAP32[($9 + 576 | 0) >> 2] | 0;
         HEAP32[($9 + 552 | 0) >> 2] = $1;
         i64toi32_i32$0 = $9;
         i64toi32_i32$1 = 0;
         HEAP32[($9 + 540 | 0) >> 2] = 0;
         HEAP32[($9 + 544 | 0) >> 2] = i64toi32_i32$1;
         HEAP32[($9 + 536 | 0) >> 2] = HEAP32[(0 + 1069072 | 0) >> 2] | 0;
         core__fmt__Formatter__new__he219faf25326051b($9 + 280 | 0 | 0, $9 + 536 | 0 | 0, 1068692 | 0);
         if (!($hex__error__FromHexError_20as_20core__fmt__Display___fmt__haa62d686bf8e55c9($9 + 552 | 0 | 0, $9 + 280 | 0 | 0) | 0)) {
          break label$6
         }
         core__result__unwrap_failed__h27f43d993c3864a1(1068716 | 0, 55 | 0, $9 + 264 | 0 | 0, 1068980 | 0, 1068848 | 0);
         abort();
        }
        $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($9 + 24 | 0 | 0, $9 + 536 | 0 | 0);
        $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($9 + 24 | 0) >> 2] | 0 | 0, HEAP32[($9 + 28 | 0) >> 2] | 0 | 0) | 0;
        $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($9 + 536 | 0 | 0);
        $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($9 + 536 | 0 | 0);
        $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($1 | 0) | 0;
        HEAP32[$0 >> 2] = 1;
        HEAP32[($0 + 4 | 0) >> 2] = $1;
        break label$3;
       }
       $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($9 + 32 | 0 | 0, $9 + 536 | 0 | 0);
       $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($9 + 32 | 0) >> 2] | 0 | 0, HEAP32[($9 + 36 | 0) >> 2] | 0 | 0) | 0;
       $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($9 + 536 | 0 | 0);
       $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($9 + 536 | 0 | 0);
       $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($1 | 0) | 0;
       HEAP32[$0 >> 2] = 1;
       HEAP32[($0 + 4 | 0) >> 2] = $1;
       break label$4;
      }
      i64toi32_i32$2 = $9;
      i64toi32_i32$1 = HEAP32[($9 + 576 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($9 + 580 | 0) >> 2] | 0;
      $220 = i64toi32_i32$1;
      i64toi32_i32$1 = $9;
      HEAP32[($9 + 252 | 0) >> 2] = $220;
      HEAP32[($9 + 256 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[($9 + 248 | 0) >> 2] = $1;
      label$13 : {
       label$14 : {
        $1 = HEAP32[($9 + 224 | 0) >> 2] | 0;
        if (($1 | 0) == (32 | 0)) {
         break label$14
        }
        HEAP32[($9 + 552 | 0) >> 2] = $1;
        core__fmt__ArgumentV1__new__h5702524f4c8ddc75($9 + 192 | 0 | 0, 1069580 | 0, 46 | 0);
        i64toi32_i32$2 = $9;
        i64toi32_i32$0 = HEAP32[($9 + 192 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($9 + 196 | 0) >> 2] | 0;
        $10 = i64toi32_i32$0;
        $10$hi = i64toi32_i32$1;
        core__fmt__ArgumentV1__new__h5702524f4c8ddc75($9 + 184 | 0 | 0, $9 + 552 | 0 | 0, 46 | 0);
        HEAP32[($9 + 300 | 0) >> 2] = 2;
        i64toi32_i32$0 = $9;
        HEAP32[($9 + 568 | 0) >> 2] = $10;
        HEAP32[($9 + 572 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$0 = $9;
        i64toi32_i32$1 = 0;
        HEAP32[($9 + 284 | 0) >> 2] = 3;
        HEAP32[($9 + 288 | 0) >> 2] = i64toi32_i32$1;
        HEAP32[($9 + 280 | 0) >> 2] = 1069556;
        i64toi32_i32$2 = $9;
        i64toi32_i32$1 = HEAP32[($9 + 184 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[($9 + 188 | 0) >> 2] | 0;
        $245 = i64toi32_i32$1;
        i64toi32_i32$1 = $9;
        HEAP32[($9 + 576 | 0) >> 2] = $245;
        HEAP32[($9 + 580 | 0) >> 2] = i64toi32_i32$0;
        HEAP32[($9 + 296 | 0) >> 2] = $9 + 568 | 0;
        alloc__fmt__format__h6e9e003a52c07309($9 + 536 | 0 | 0, $9 + 280 | 0 | 0);
        $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($9 + 176 | 0 | 0, $9 + 536 | 0 | 0);
        $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($9 + 176 | 0) >> 2] | 0 | 0, HEAP32[($9 + 180 | 0) >> 2] | 0 | 0) | 0;
        HEAP32[$0 >> 2] = 1;
        HEAP32[($0 + 4 | 0) >> 2] = $1;
        $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($9 + 536 | 0 | 0);
        $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($9 + 536 | 0 | 0);
        break label$13;
       }
       label$15 : {
        i64toi32_i32$0 = $10$hi;
        i64toi32_i32$2 = $10;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 32;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$1 = 0;
         $24 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
        } else {
         i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
         $24 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
        }
        $1 = $24;
        if (($1 | 0) == (12 | 0)) {
         break label$15
        }
        HEAP32[($9 + 552 | 0) >> 2] = $1;
        core__fmt__ArgumentV1__new__h5702524f4c8ddc75($9 + 168 | 0 | 0, 1069628 | 0, 46 | 0);
        i64toi32_i32$0 = $9;
        i64toi32_i32$1 = HEAP32[($9 + 168 | 0) >> 2] | 0;
        i64toi32_i32$2 = HEAP32[($9 + 172 | 0) >> 2] | 0;
        $10 = i64toi32_i32$1;
        $10$hi = i64toi32_i32$2;
        core__fmt__ArgumentV1__new__h5702524f4c8ddc75($9 + 160 | 0 | 0, $9 + 552 | 0 | 0, 46 | 0);
        HEAP32[($9 + 300 | 0) >> 2] = 2;
        i64toi32_i32$1 = $9;
        HEAP32[($9 + 568 | 0) >> 2] = $10;
        HEAP32[($9 + 572 | 0) >> 2] = i64toi32_i32$2;
        i64toi32_i32$1 = $9;
        i64toi32_i32$2 = 0;
        HEAP32[($9 + 284 | 0) >> 2] = 3;
        HEAP32[($9 + 288 | 0) >> 2] = i64toi32_i32$2;
        HEAP32[($9 + 280 | 0) >> 2] = 1069604;
        i64toi32_i32$0 = $9;
        i64toi32_i32$2 = HEAP32[($9 + 160 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($9 + 164 | 0) >> 2] | 0;
        $292 = i64toi32_i32$2;
        i64toi32_i32$2 = $9;
        HEAP32[($9 + 576 | 0) >> 2] = $292;
        HEAP32[($9 + 580 | 0) >> 2] = i64toi32_i32$1;
        HEAP32[($9 + 296 | 0) >> 2] = $9 + 568 | 0;
        alloc__fmt__format__h6e9e003a52c07309($9 + 536 | 0 | 0, $9 + 280 | 0 | 0);
        $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($9 + 152 | 0 | 0, $9 + 536 | 0 | 0);
        $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($9 + 152 | 0) >> 2] | 0 | 0, HEAP32[($9 + 156 | 0) >> 2] | 0 | 0) | 0;
        HEAP32[$0 >> 2] = 1;
        HEAP32[($0 + 4 | 0) >> 2] = $1;
        $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($9 + 536 | 0 | 0);
        $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($9 + 536 | 0 | 0);
        break label$13;
       }
       label$16 : {
        if (!(HEAP32[($9 + 208 | 0) >> 2] | 0)) {
         break label$16
        }
        cryptoxide__sha2__Sha512__new__h57eb1a61fae5dfc3($9 + 568 | 0 | 0);
        $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($9 + 144 | 0 | 0, $9 + 200 | 0 | 0);
        cryptoxide__hmac__Hmac_D___new__h10c18a5661f5ecf6($9 + 280 | 0 | 0, $9 + 568 | 0 | 0, HEAP32[($9 + 144 | 0) >> 2] | 0 | 0, HEAP32[($9 + 148 | 0) >> 2] | 0 | 0);
        core__iter__adapters__take__Take_I___new__h57f06669aa0e5753($9 + 136 | 0 | 0, 0 | 0, 32 | 0);
        $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter__SpecFromIter_T_2cI____from_iter__hd9e424f0851c7545($9 + 568 | 0 | 0, HEAP32[($9 + 136 | 0) >> 2] | 0 | 0, HEAPU8[($9 + 140 | 0) >> 0] | 0 | 0);
        $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($9 + 128 | 0 | 0, $9 + 216 | 0 | 0);
        $1 = HEAP32[($9 + 132 | 0) >> 2] | 0;
        $2 = HEAP32[($9 + 128 | 0) >> 2] | 0;
        $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__DerefMut___deref_mut__h1882e042320a120c($9 + 120 | 0 | 0, $9 + 568 | 0 | 0);
        cryptoxide__pbkdf2__pbkdf2__h6d76e9b9cb3d73c2($9 + 280 | 0 | 0, $2 | 0, $1 | 0, 19162 | 0, HEAP32[($9 + 120 | 0) >> 2] | 0 | 0, HEAP32[($9 + 124 | 0) >> 2] | 0 | 0);
        HEAP32[(($9 + 264 | 0) + 8 | 0) >> 2] = HEAP32[(($9 + 568 | 0) + 8 | 0) >> 2] | 0;
        i64toi32_i32$0 = $9;
        i64toi32_i32$1 = HEAP32[($9 + 568 | 0) >> 2] | 0;
        i64toi32_i32$2 = HEAP32[($9 + 572 | 0) >> 2] | 0;
        $370 = i64toi32_i32$1;
        i64toi32_i32$1 = $9;
        HEAP32[($9 + 264 | 0) >> 2] = $370;
        HEAP32[($9 + 268 | 0) >> 2] = i64toi32_i32$2;
        $1 = $9 + 504 | 0;
        $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
        $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
        $1 = $9 + 516 | 0;
        $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
        $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
        i64toi32_i32$1 = ($9 + 536 | 0) + 8 | 0;
        i64toi32_i32$2 = 0;
        HEAP32[i64toi32_i32$1 >> 2] = 0;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
        i64toi32_i32$1 = $9;
        i64toi32_i32$2 = 0;
        HEAP32[($9 + 536 | 0) >> 2] = 0;
        HEAP32[($9 + 540 | 0) >> 2] = i64toi32_i32$2;
        core__iter__adapters__take__Take_I___new__h57f06669aa0e5753($9 + 112 | 0 | 0, 0 | 0, HEAP32[($9 + 256 | 0) >> 2] | 0 | 0);
        $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter__SpecFromIter_T_2cI____from_iter__hd9e424f0851c7545($9 + 552 | 0 | 0, HEAP32[($9 + 112 | 0) >> 2] | 0 | 0, HEAPU8[($9 + 116 | 0) >> 0] | 0 | 0);
        $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($9 + 104 | 0 | 0, $9 + 264 | 0 | 0);
        $1 = HEAP32[($9 + 108 | 0) >> 2] | 0;
        $2 = HEAP32[($9 + 104 | 0) >> 2] | 0;
        $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($9 + 96 | 0 | 0, $9 + 232 | 0 | 0);
        cryptoxide__chacha20poly1305__Context_____new__h0cc47d548a2f122a($9 + 568 | 0 | 0, $2 | 0, $1 | 0, HEAP32[($9 + 96 | 0) >> 2] | 0 | 0, HEAP32[($9 + 100 | 0) >> 2] | 0 | 0);
        $cryptoxide__poly1305__Poly1305_20as_20cryptoxide__mac__Mac___input__h2055bc09e473001f($9 + 716 | 0 | 0, 1069056 | 0, 0 | 0);
        memcpy($9 + 280 | 0 | 0, $9 + 568 | 0 | 0, 232 | 0) | 0;
        HEAP8[($9 + 512 | 0) >> 0] = 0;
        $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($9 + 88 | 0 | 0, $9 + 248 | 0 | 0);
        $1 = HEAP32[($9 + 92 | 0) >> 2] | 0;
        $2 = HEAP32[($9 + 88 | 0) >> 2] | 0;
        $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__DerefMut___deref_mut__h1882e042320a120c($9 + 80 | 0 | 0, $9 + 552 | 0 | 0);
        cryptoxide__chacha20poly1305__ChaChaPoly1305_____encrypt__h30e753aa5f862ba3($9 + 280 | 0 | 0, $2 | 0, $1 | 0, HEAP32[($9 + 80 | 0) >> 2] | 0 | 0, HEAP32[($9 + 84 | 0) >> 2] | 0 | 0, $9 + 536 | 0 | 0, 16 | 0);
        alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($9 + 72 | 0 | 0, (HEAP32[($9 + 256 | 0) >> 2] | 0) + 60 | 0 | 0, 0 | 0);
        HEAP32[($9 + 288 | 0) >> 2] = 0;
        i64toi32_i32$0 = $9;
        i64toi32_i32$2 = HEAP32[($9 + 72 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($9 + 76 | 0) >> 2] | 0;
        $451 = i64toi32_i32$2;
        i64toi32_i32$2 = $9;
        HEAP32[($9 + 280 | 0) >> 2] = $451;
        HEAP32[($9 + 284 | 0) >> 2] = i64toi32_i32$1;
        $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($9 + 64 | 0 | 0, $9 + 216 | 0 | 0);
        alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($9 + 280 | 0 | 0, HEAP32[($9 + 64 | 0) >> 2] | 0 | 0, HEAP32[($9 + 68 | 0) >> 2] | 0 | 0);
        $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($9 + 56 | 0 | 0, $9 + 232 | 0 | 0);
        alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($9 + 280 | 0 | 0, HEAP32[($9 + 56 | 0) >> 2] | 0 | 0, HEAP32[($9 + 60 | 0) >> 2] | 0 | 0);
        alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($9 + 280 | 0 | 0, $9 + 536 | 0 | 0, 16 | 0);
        $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($9 + 48 | 0 | 0, $9 + 552 | 0 | 0);
        alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($9 + 280 | 0 | 0, HEAP32[($9 + 48 | 0) >> 2] | 0 | 0, HEAP32[($9 + 52 | 0) >> 2] | 0 | 0);
        $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($9 + 40 | 0 | 0, $9 + 280 | 0 | 0);
        hex__encode_to_iter__h3b9b5dcb85c2c5cd($0 + 4 | 0 | 0, 1067368 | 0, HEAP32[($9 + 40 | 0) >> 2] | 0 | 0, HEAP32[($9 + 44 | 0) >> 2] | 0 | 0);
        HEAP32[$0 >> 2] = 0;
        $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($9 + 280 | 0 | 0);
        $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($9 + 280 | 0 | 0);
        $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($9 + 552 | 0 | 0);
        $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($9 + 552 | 0 | 0);
        $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($9 + 264 | 0 | 0);
        $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($9 + 264 | 0 | 0);
        $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($9 + 248 | 0 | 0);
        $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($9 + 248 | 0 | 0);
        $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($9 + 232 | 0 | 0);
        $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($9 + 232 | 0 | 0);
        $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($9 + 216 | 0 | 0);
        $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($9 + 216 | 0 | 0);
        $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($9 + 200 | 0 | 0);
        $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($9 + 200 | 0 | 0);
        break label$1;
       }
       $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1069644 | 0, 24 | 0) | 0;
       HEAP32[$0 >> 2] = 1;
       HEAP32[($0 + 4 | 0) >> 2] = $1;
      }
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($9 + 248 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($9 + 248 | 0 | 0);
     }
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($9 + 232 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($9 + 232 | 0 | 0);
    }
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($9 + 216 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($9 + 216 | 0 | 0);
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($9 + 200 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($9 + 200 | 0 | 0);
  }
  global$0 = $9 + 800 | 0;
 }
 
 function $cardano_serialization_lib__address__StakeCredential_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__ha21a31a5230d4f02($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $7 = 0, $8 = 0, $5 = 0, $6 = 0, $9 = 0, $19 = 0, $19$hi = 0, $13 = 0, $18 = 0, $18$hi = 0, $3 = 0, $20 = 0, $20$hi = 0, $12 = 0, $4 = 0, $21 = 0, $21$hi = 0, $10 = 0, $11 = 0, $34 = 0, $35 = 0, $36 = 0, $37 = 0, $38 = 0, $39 = 0, $40 = 0, $41 = 0, $42 = 0, $43 = 0, $44 = 0, $45 = 0, $46 = 0, $47 = 0, $48 = 0, $49 = 0, $50 = 0, $51 = 0, $52 = 0, $53 = 0, $54 = 0, $55 = 0, $56 = 0, $57 = 0, $58 = 0, $14 = 0, $15 = 0, $59 = 0, $16 = 0, $17 = 0, $60 = 0, $61 = 0, $62 = 0, $63 = 0, $64 = 0, $65 = 0, $66 = 0, $67 = 0, $68 = 0, $69 = 0, $70 = 0, $71 = 0, $72 = 0, $73 = 0, $74 = 0, $75 = 0, $246 = 0, $368 = 0, $483 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 32 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2 + 48 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  $18$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 40 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 44 | 0) >> 2] | 0;
  $19 = i64toi32_i32$1;
  $19$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
         break label$6
        }
        $3 = 2;
        $4 = 0;
        label$7 : {
         i64toi32_i32$2 = $19$hi;
         $5 = $19;
         if (($5 | 0) != (1 | 0)) {
          break label$7
         }
         i64toi32_i32$2 = $18$hi;
         i64toi32_i32$3 = $18;
         i64toi32_i32$1 = 0;
         i64toi32_i32$0 = 2;
         if ((i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$1 | 0) | 0) {
          break label$7
         }
         $5 = 13;
         $6 = 1070056;
         $7 = 10;
         i64toi32_i32$3 = 0;
         $20 = 2;
         $20$hi = i64toi32_i32$3;
         $1 = 0;
         break label$3;
        }
        cbor_event__de__Deserializer_R___unsigned_integer__h1ed99c0b7fe7eea1($2 + 32 | 0 | 0, $1 | 0);
        i64toi32_i32$0 = $2;
        i64toi32_i32$3 = HEAP32[($2 + 40 | 0) >> 2] | 0;
        i64toi32_i32$2 = HEAP32[($2 + 44 | 0) >> 2] | 0;
        $21 = i64toi32_i32$3;
        $21$hi = i64toi32_i32$2;
        label$8 : {
         label$9 : {
          label$10 : {
           label$11 : {
            i64toi32_i32$0 = $2;
            i64toi32_i32$2 = HEAP32[($2 + 32 | 0) >> 2] | 0;
            i64toi32_i32$3 = HEAP32[($2 + 36 | 0) >> 2] | 0;
            i64toi32_i32$0 = i64toi32_i32$2;
            i64toi32_i32$2 = 0;
            i64toi32_i32$1 = 1;
            if ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) | 0) {
             break label$11
            }
            i64toi32_i32$0 = $21$hi;
            $7 = $21;
            i64toi32_i32$1 = $7;
            i64toi32_i32$3 = 0;
            i64toi32_i32$2 = 1;
            if (i64toi32_i32$0 >>> 0 > i64toi32_i32$3 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$1 >>> 0 > i64toi32_i32$2 >>> 0 | 0) | 0) {
             break label$10
            }
            switch ($7 | 0) {
            case 1:
             break label$9;
            default:
             break label$8;
            };
           }
           i64toi32_i32$1 = $21$hi;
           i64toi32_i32$2 = $21;
           i64toi32_i32$0 = 0;
           i64toi32_i32$3 = 32;
           i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
           if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
            i64toi32_i32$0 = 0;
            $55 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
           } else {
            i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
            $55 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
           }
           $6 = $55;
           i64toi32_i32$0 = $21$hi;
           i64toi32_i32$1 = $21;
           i64toi32_i32$2 = 0;
           i64toi32_i32$3 = 24;
           i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
           if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
            i64toi32_i32$2 = 0;
            $56 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
           } else {
            i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
            $56 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
           }
           $1 = $56;
           i64toi32_i32$2 = $21$hi;
           i64toi32_i32$0 = $21;
           i64toi32_i32$1 = 0;
           i64toi32_i32$3 = 8;
           i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
           if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
            i64toi32_i32$1 = 0;
            $57 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
           } else {
            i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
            $57 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
           }
           $8 = $57;
           $9 = HEAP32[($2 + 52 | 0) >> 2] | 0;
           $7 = HEAP32[($2 + 48 | 0) >> 2] | 0;
           i64toi32_i32$2 = $2 + 72 | 0;
           i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
           $18 = i64toi32_i32$1;
           $18$hi = i64toi32_i32$0;
           i64toi32_i32$2 = $2 + 64 | 0;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
           $19 = i64toi32_i32$0;
           $19$hi = i64toi32_i32$1;
           i64toi32_i32$2 = $2 + 56 | 0;
           i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
           $20 = i64toi32_i32$1;
           $20$hi = i64toi32_i32$0;
           i64toi32_i32$0 = $21$hi;
           $5 = $21;
           break label$3;
          }
          i64toi32_i32$0 = $21$hi;
          i64toi32_i32$2 = $21;
          i64toi32_i32$1 = 0;
          i64toi32_i32$3 = 32;
          i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
          if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
           i64toi32_i32$1 = 0;
           $58 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
          } else {
           i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
           $58 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
          }
          $9 = $58;
          $3 = 8;
          $8 = 0;
          $5 = 1;
          i64toi32_i32$1 = 0;
          $20 = 1;
          $20$hi = i64toi32_i32$1;
          i64toi32_i32$1 = 0;
          $19 = 0;
          $19$hi = i64toi32_i32$1;
          $1 = 0;
          $4 = 0;
          break label$3;
         }
         $cardano_serialization_lib__crypto__ScriptHash_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h589000d40634e72d($2 + 32 | 0 | 0, $1 | 0);
         $7 = 1;
         if ((HEAPU8[($2 + 32 | 0) >> 0] | 0 | 0) == (1 | 0)) {
          break label$5
         }
         HEAP16[($2 + 24 | 0) >> 1] = HEAPU8[($2 + 37 | 0) >> 0] | 0 | ((HEAPU8[($2 + 38 | 0) >> 0] | 0) << 8 | 0) | 0;
         HEAP32[($2 + 20 | 0) >> 2] = HEAPU8[($2 + 33 | 0) >> 0] | 0 | ((HEAPU8[($2 + 34 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 35 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 36 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $6 = HEAPU16[(($2 + 32 | 0) + 16 | 0) >> 1] | 0 | ((HEAPU8[($2 + 50 | 0) >> 0] | 0) << 16 | 0) | 0;
         $10 = $6 >>> 16 | 0;
         $11 = HEAPU8[($2 + 40 | 0) >> 0] | 0;
         $34 = $2 + 41 | 0;
         $8 = HEAPU8[$34 >> 0] | 0 | ((HEAPU8[($34 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($34 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($34 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $9 = HEAPU8[($2 + 45 | 0) >> 0] | 0;
         $12 = HEAPU8[($2 + 46 | 0) >> 0] | 0;
         $13 = HEAPU8[($2 + 47 | 0) >> 0] | 0;
         $35 = $2 + 51 | 0;
         $14 = HEAPU8[$35 >> 0] | 0 | ((HEAPU8[($35 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($35 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($35 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $36 = $2 + 55 | 0;
         $15 = HEAPU8[$36 >> 0] | 0 | ((HEAPU8[($36 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($36 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($36 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $59 = $2 + 59 | 0;
         $16 = HEAPU8[$59 >> 0] | 0 | ((HEAPU8[($59 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
         $17 = HEAPU8[($2 + 39 | 0) >> 0] | 0;
         break label$4;
        }
        $cardano_serialization_lib__crypto__Ed25519KeyHash_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h495effbb534e290f($2 + 32 | 0 | 0, $1 | 0);
        label$12 : {
         if ((HEAPU8[($2 + 32 | 0) >> 0] | 0 | 0) == (1 | 0)) {
          break label$12
         }
         HEAP16[($2 + 24 | 0) >> 1] = HEAPU8[($2 + 37 | 0) >> 0] | 0 | ((HEAPU8[($2 + 38 | 0) >> 0] | 0) << 8 | 0) | 0;
         HEAP32[($2 + 20 | 0) >> 2] = HEAPU8[($2 + 33 | 0) >> 0] | 0 | ((HEAPU8[($2 + 34 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 35 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 36 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $6 = HEAPU16[(($2 + 32 | 0) + 16 | 0) >> 1] | 0 | ((HEAPU8[($2 + 50 | 0) >> 0] | 0) << 16 | 0) | 0;
         $10 = $6 >>> 16 | 0;
         $11 = HEAPU8[($2 + 40 | 0) >> 0] | 0;
         $37 = $2 + 41 | 0;
         $8 = HEAPU8[$37 >> 0] | 0 | ((HEAPU8[($37 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($37 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($37 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $9 = HEAPU8[($2 + 45 | 0) >> 0] | 0;
         $12 = HEAPU8[($2 + 46 | 0) >> 0] | 0;
         $13 = HEAPU8[($2 + 47 | 0) >> 0] | 0;
         $38 = $2 + 51 | 0;
         $14 = HEAPU8[$38 >> 0] | 0 | ((HEAPU8[($38 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($38 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($38 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $39 = $2 + 55 | 0;
         $15 = HEAPU8[$39 >> 0] | 0 | ((HEAPU8[($39 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($39 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($39 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $60 = $2 + 59 | 0;
         $16 = HEAPU8[$60 >> 0] | 0 | ((HEAPU8[($60 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
         $17 = HEAPU8[($2 + 39 | 0) >> 0] | 0;
         $7 = 0;
         break label$4;
        }
        $5 = $2 + 30 | 0;
        HEAP8[$5 >> 0] = HEAPU8[($2 + 63 | 0) >> 0] | 0;
        $61 = $2 + 61 | 0;
        HEAP16[($2 + 28 | 0) >> 1] = HEAPU8[$61 >> 0] | 0 | ((HEAPU8[($61 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
        $10 = HEAPU8[($2 + 47 | 0) >> 0] | 0;
        $11 = HEAPU8[($2 + 46 | 0) >> 0] | 0;
        $3 = HEAPU8[(($2 + 32 | 0) + 8 | 0) >> 0] | 0;
        i64toi32_i32$0 = $2 + 64 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
        $20 = i64toi32_i32$1;
        $20$hi = i64toi32_i32$2;
        i64toi32_i32$0 = $2 + 72 | 0;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
        $19 = i64toi32_i32$2;
        $19$hi = i64toi32_i32$1;
        i64toi32_i32$0 = $2 + 80 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
        $18 = i64toi32_i32$1;
        $18$hi = i64toi32_i32$2;
        $4 = HEAP32[($2 + 88 | 0) >> 2] | 0;
        $6 = HEAPU16[(($2 + 32 | 0) + 16 | 0) >> 1] | 0;
        $8 = HEAPU8[($2 + 50 | 0) >> 0] | 0;
        $9 = HEAPU8[($2 + 45 | 0) >> 0] | 0;
        $40 = $2 + 41 | 0;
        $12 = HEAPU8[$40 >> 0] | 0 | ((HEAPU8[($40 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($40 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($40 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $62 = $2 + 59 | 0;
        $13 = HEAPU8[$62 >> 0] | 0 | ((HEAPU8[($62 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
        $41 = $2 + 51 | 0;
        $1 = HEAPU8[$41 >> 0] | 0 | ((HEAPU8[($41 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($41 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($41 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $42 = $2 + 55 | 0;
        $7 = HEAPU8[$42 >> 0] | 0 | ((HEAPU8[($42 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($42 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($42 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP32[($2 + 8 | 0) >> 2] = HEAP32[($2 + 100 | 0) >> 2] | 0;
        i64toi32_i32$0 = $2 + 92 | 0;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
        $246 = i64toi32_i32$2;
        i64toi32_i32$2 = $2;
        HEAP32[$2 >> 2] = $246;
        HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$1;
        HEAP8[($2 + 108 | 0) >> 0] = $7;
        HEAP32[($2 + 104 | 0) >> 2] = $1;
        HEAP8[($2 + 35 | 0) >> 0] = $13;
        HEAP8[($2 + 36 | 0) >> 0] = $13 >>> 8 | 0;
        HEAP8[($2 + 34 | 0) >> 0] = $7 >>> 24 | 0;
        HEAP16[($2 + 32 | 0) >> 1] = $7 >>> 8 | 0;
        HEAP8[($2 + 39 | 0) >> 0] = HEAPU8[$5 >> 0] | 0;
        $63 = HEAPU16[($2 + 28 | 0) >> 1] | 0;
        HEAP8[($2 + 37 | 0) >> 0] = $63;
        HEAP8[($2 + 38 | 0) >> 0] = $63 >>> 8 | 0;
        HEAP32[($2 + 12 | 0) >> 2] = $12;
        HEAP8[($2 + 16 | 0) >> 0] = $9;
        $5 = $6 | ($8 << 16 | 0) | 0;
        $8 = $5 >>> 8 | 0;
        $6 = HEAPU8[($2 + 105 | 0) >> 0] | 0 | ((HEAPU8[($2 + 106 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 107 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 108 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $7 = HEAP32[($2 + 32 | 0) >> 2] | 0;
        $9 = HEAP32[($2 + 36 | 0) >> 2] | 0;
        break label$3;
       }
       i64toi32_i32$1 = $19$hi;
       i64toi32_i32$0 = $19;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = 0;
        $64 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
        $64 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
       }
       $6 = $64;
       i64toi32_i32$2 = $19$hi;
       i64toi32_i32$1 = $19;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 24;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = 0;
        $65 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
        $65 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
       }
       $1 = $65;
       i64toi32_i32$0 = $19$hi;
       i64toi32_i32$2 = $19;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 8;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = 0;
        $66 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
        $66 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
       }
       $8 = $66;
       i64toi32_i32$1 = $18$hi;
       i64toi32_i32$0 = $18;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = 0;
        $67 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
        $67 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
       }
       $9 = $67;
       i64toi32_i32$1 = $2 + 56 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $20 = i64toi32_i32$2;
       $20$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $18$hi;
       $7 = $18;
       i64toi32_i32$0 = $19$hi;
       $5 = $19;
       $3 = 2;
       $4 = 0;
       i64toi32_i32$1 = $2 + 72 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $18 = i64toi32_i32$0;
       $18$hi = i64toi32_i32$2;
       i64toi32_i32$1 = $2 + 64 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $19 = i64toi32_i32$2;
       $19$hi = i64toi32_i32$0;
       break label$3;
      }
      $6 = $2 + 30 | 0;
      HEAP8[$6 >> 0] = HEAPU8[($2 + 63 | 0) >> 0] | 0;
      $68 = $2 + 61 | 0;
      HEAP16[($2 + 28 | 0) >> 1] = HEAPU8[$68 >> 0] | 0 | ((HEAPU8[($68 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
      $10 = HEAPU8[($2 + 47 | 0) >> 0] | 0;
      $11 = HEAPU8[($2 + 46 | 0) >> 0] | 0;
      $3 = HEAPU8[(($2 + 32 | 0) + 8 | 0) >> 0] | 0;
      i64toi32_i32$1 = $2 + 64 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $20 = i64toi32_i32$0;
      $20$hi = i64toi32_i32$2;
      i64toi32_i32$1 = $2 + 72 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $19 = i64toi32_i32$2;
      $19$hi = i64toi32_i32$0;
      i64toi32_i32$1 = $2 + 80 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $18 = i64toi32_i32$0;
      $18$hi = i64toi32_i32$2;
      $4 = HEAP32[($2 + 88 | 0) >> 2] | 0;
      $8 = HEAPU8[($2 + 45 | 0) >> 0] | 0;
      $43 = $2 + 41 | 0;
      $9 = HEAPU8[$43 >> 0] | 0 | ((HEAPU8[($43 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($43 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($43 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $69 = $2 + 59 | 0;
      $12 = HEAPU8[$69 >> 0] | 0 | ((HEAPU8[($69 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
      $44 = $2 + 55 | 0;
      $1 = HEAPU8[$44 >> 0] | 0 | ((HEAPU8[($44 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($44 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($44 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $7 = HEAPU16[(($2 + 32 | 0) + 16 | 0) >> 1] | 0;
      $5 = HEAPU8[($2 + 50 | 0) >> 0] | 0;
      $45 = $2 + 51 | 0;
      $13 = HEAPU8[$45 >> 0] | 0 | ((HEAPU8[($45 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($45 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($45 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP32[($2 + 8 | 0) >> 2] = HEAP32[($2 + 100 | 0) >> 2] | 0;
      i64toi32_i32$1 = $2 + 92 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $368 = i64toi32_i32$2;
      i64toi32_i32$2 = $2;
      HEAP32[$2 >> 2] = $368;
      HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$0;
      HEAP8[($2 + 35 | 0) >> 0] = $13;
      HEAP8[($2 + 36 | 0) >> 0] = $13 >>> 8 | 0;
      HEAP8[($2 + 37 | 0) >> 0] = $13 >>> 16 | 0;
      HEAP8[($2 + 38 | 0) >> 0] = $13 >>> 24 | 0;
      HEAP8[($2 + 34 | 0) >> 0] = $5;
      HEAP16[($2 + 32 | 0) >> 1] = $7;
      HEAP8[($2 + 39 | 0) >> 0] = $1;
      HEAP8[($2 + 107 | 0) >> 0] = $12;
      HEAP8[($2 + 108 | 0) >> 0] = $12 >>> 8 | 0;
      HEAP8[($2 + 106 | 0) >> 0] = $1 >>> 24 | 0;
      HEAP16[($2 + 104 | 0) >> 1] = $1 >>> 8 | 0;
      HEAP8[($2 + 111 | 0) >> 0] = HEAPU8[$6 >> 0] | 0;
      $70 = HEAPU16[($2 + 28 | 0) >> 1] | 0;
      HEAP8[($2 + 109 | 0) >> 0] = $70;
      HEAP8[($2 + 110 | 0) >> 0] = $70 >>> 8 | 0;
      HEAP32[($2 + 12 | 0) >> 2] = $9;
      HEAP8[($2 + 16 | 0) >> 0] = $8;
      $5 = $7 | ($5 << 16 | 0) | 0;
      $8 = HEAPU8[($2 + 33 | 0) >> 0] | 0 | ((HEAPU8[($2 + 34 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 35 | 0) >> 0] | 0) << 16 | 0) | 0;
      $1 = $8 >>> 16 | 0;
      $6 = HEAP32[($2 + 36 | 0) >> 2] | 0;
      $7 = HEAP32[($2 + 104 | 0) >> 2] | 0;
      $9 = HEAP32[($2 + 108 | 0) >> 2] | 0;
      break label$3;
     }
     if ($5) {
      break label$2
     }
     cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 32 | 0 | 0, $1 | 0);
     $5 = HEAPU8[($2 + 40 | 0) >> 0] | 0;
     label$13 : {
      i64toi32_i32$1 = $2;
      i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
      i64toi32_i32$2 = HEAP32[($2 + 36 | 0) >> 2] | 0;
      i64toi32_i32$1 = i64toi32_i32$0;
      i64toi32_i32$0 = 0;
      i64toi32_i32$3 = 1;
      if ((i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) | 0) {
       break label$13
      }
      $3 = 5;
      if (($5 & 255 | 0 | 0) == (5 | 0)) {
       break label$2
      }
      $1 = 0;
      $4 = 0;
      break label$3;
     }
     $8 = HEAPU8[($2 + 41 | 0) >> 0] | 0 | ((HEAPU8[($2 + 42 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 43 | 0) >> 0] | 0) << 16 | 0) | 0;
     $1 = $8 >>> 16 | 0;
     $9 = HEAP32[($2 + 52 | 0) >> 2] | 0;
     $7 = HEAP32[(($2 + 32 | 0) + 16 | 0) >> 2] | 0;
     i64toi32_i32$3 = $2 + 72 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $18 = i64toi32_i32$1;
     $18$hi = i64toi32_i32$2;
     i64toi32_i32$3 = $2 + 64 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $19 = i64toi32_i32$2;
     $19$hi = i64toi32_i32$1;
     i64toi32_i32$3 = $2 + 56 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $20 = i64toi32_i32$1;
     $20$hi = i64toi32_i32$2;
     $6 = HEAP32[($2 + 44 | 0) >> 2] | 0;
    }
    HEAP8[($2 + 43 | 0) >> 0] = $1;
    $71 = $2 + 41 | 0;
    HEAP8[$71 >> 0] = $8;
    HEAP8[($71 + 1 | 0) >> 0] = $8 >>> 8 | 0;
    i64toi32_i32$2 = $18$hi;
    i64toi32_i32$1 = $2 + 72 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $18;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $19$hi;
    i64toi32_i32$1 = $2 + 64 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $19;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $20$hi;
    i64toi32_i32$1 = $2 + 56 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $20;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
    HEAP32[($2 + 52 | 0) >> 2] = $9;
    HEAP32[($2 + 48 | 0) >> 2] = $7;
    HEAP32[($2 + 44 | 0) >> 2] = $6;
    HEAP8[(($2 + 32 | 0) + 8 | 0) >> 0] = $5;
    i64toi32_i32$3 = $2;
    i64toi32_i32$2 = HEAP32[$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
    $483 = i64toi32_i32$2;
    i64toi32_i32$2 = $2 + 84 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $483;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($2 + 92 | 0) >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
    HEAP8[($2 + 32 | 0) >> 0] = $3;
    $46 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    HEAP8[($2 + 33 | 0) >> 0] = $46;
    HEAP8[($2 + 34 | 0) >> 0] = $46 >>> 8 | 0;
    HEAP8[($2 + 35 | 0) >> 0] = $46 >>> 16 | 0;
    HEAP8[($2 + 36 | 0) >> 0] = $46 >>> 24 | 0;
    HEAP32[($2 + 80 | 0) >> 2] = $4;
    HEAP8[($2 + 39 | 0) >> 0] = $10;
    HEAP8[($2 + 38 | 0) >> 0] = $11;
    HEAP8[($2 + 37 | 0) >> 0] = HEAPU8[($2 + 16 | 0) >> 0] | 0;
    cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 32 | 0 | 0, 1070066 | 0, 15 | 0);
    $1 = 1;
    break label$1;
   }
   $1 = HEAPU16[(($2 + 20 | 0) + 4 | 0) >> 1] | 0;
   HEAP16[(($2 + 32 | 0) + 4 | 0) >> 1] = $1;
   $3 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   HEAP32[($2 + 32 | 0) >> 2] = $3;
   HEAP8[($2 + 13 | 0) >> 0] = $8;
   HEAP8[($2 + 14 | 0) >> 0] = $8 >>> 8 | 0;
   HEAP8[($2 + 15 | 0) >> 0] = $8 >>> 16 | 0;
   HEAP8[($2 + 16 | 0) >> 0] = $8 >>> 24 | 0;
   HEAP8[($2 + 12 | 0) >> 0] = $11;
   HEAP8[($0 + 19 | 0) >> 0] = $10;
   $72 = $0 + 17 | 0;
   HEAP8[$72 >> 0] = $6;
   HEAP8[($72 + 1 | 0) >> 0] = $6 >>> 8 | 0;
   HEAP8[($0 + 1 | 0) >> 0] = $7;
   $47 = $0 + 2 | 0;
   $48 = $3;
   HEAP8[$47 >> 0] = $48;
   HEAP8[($47 + 1 | 0) >> 0] = $48 >>> 8 | 0;
   HEAP8[($47 + 2 | 0) >> 0] = $48 >>> 16 | 0;
   HEAP8[($47 + 3 | 0) >> 0] = $48 >>> 24 | 0;
   $73 = $0 + 6 | 0;
   HEAP8[$73 >> 0] = $1;
   HEAP8[($73 + 1 | 0) >> 0] = $1 >>> 8 | 0;
   HEAP8[($0 + 8 | 0) >> 0] = $17;
   $49 = $0 + 9 | 0;
   $50 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   HEAP8[$49 >> 0] = $50;
   HEAP8[($49 + 1 | 0) >> 0] = $50 >>> 8 | 0;
   HEAP8[($49 + 2 | 0) >> 0] = $50 >>> 16 | 0;
   HEAP8[($49 + 3 | 0) >> 0] = $50 >>> 24 | 0;
   HEAP8[($0 + 13 | 0) >> 0] = HEAPU8[(($2 + 12 | 0) + 4 | 0) >> 0] | 0;
   $74 = $0 + 28 | 0;
   $75 = $16;
   HEAP8[$74 >> 0] = $75;
   HEAP8[($74 + 1 | 0) >> 0] = $75 >>> 8 | 0;
   $51 = $0 + 24 | 0;
   $52 = $15;
   HEAP8[$51 >> 0] = $52;
   HEAP8[($51 + 1 | 0) >> 0] = $52 >>> 8 | 0;
   HEAP8[($51 + 2 | 0) >> 0] = $52 >>> 16 | 0;
   HEAP8[($51 + 3 | 0) >> 0] = $52 >>> 24 | 0;
   $53 = $0 + 20 | 0;
   $54 = $14;
   HEAP8[$53 >> 0] = $54;
   HEAP8[($53 + 1 | 0) >> 0] = $54 >>> 8 | 0;
   HEAP8[($53 + 2 | 0) >> 0] = $54 >>> 16 | 0;
   HEAP8[($53 + 3 | 0) >> 0] = $54 >>> 24 | 0;
   HEAP8[($0 + 16 | 0) >> 0] = $13;
   HEAP8[($0 + 15 | 0) >> 0] = $12;
   HEAP8[($0 + 14 | 0) >> 0] = $9;
   $1 = 0;
  }
  HEAP8[$0 >> 0] = $1;
  global$0 = $2 + 112 | 0;
 }
 
 function $cardano_serialization_lib__utils__BigInt_20as_20cbor_event__se__Serialize___serialize__hd7ec7393d73149ff($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $5 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $4 = 0, $7 = 0, i64toi32_i32$2 = 0, $9 = 0, $8 = 0, $9$hi = 0, $28 = 0, i64toi32_i32$5 = 0, $29 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $36 = 0, $6 = 0, $166 = 0, $169 = 0, $191 = 0, $204 = 0, $207 = 0, $346 = 0, $366 = 0, $396 = 0, $488 = 0, $489 = 0;
  $3 = global$0 - 224 | 0;
  global$0 = $3;
  $4 = HEAPU8[($1 + 12 | 0) >> 0] | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h7a0ed8a251b429e6($3 + 64 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[($3 + 64 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($3 + 68 | 0) >> 2] | 0;
  $9 = i64toi32_i32$0;
  $9$hi = i64toi32_i32$1;
  HEAP32[($3 + 200 | 0) >> 2] = 2;
  i64toi32_i32$0 = $3;
  HEAP32[($3 + 192 | 0) >> 2] = $9;
  HEAP32[($3 + 196 | 0) >> 2] = i64toi32_i32$1;
  $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__h699867d552ef4144($3 + 104 | 0 | 4 | 0 | 0, $3 + 192 | 0 | 0);
  $5 = HEAP32[($3 + 116 | 0) >> 2] | 0;
  HEAP32[($3 + 80 | 0) >> 2] = $5;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[($3 + 108 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($3 + 112 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[($3 + 72 | 0) >> 2] = $36;
  HEAP32[($3 + 76 | 0) >> 2] = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           label$10 : {
            label$11 : {
             switch ($5 | 0) {
             default:
              label$14 : {
               if ($4 & 255 | 0) {
                break label$14
               }
               $4 = __rust_alloc(16 | 0, 8 | 0) | 0;
               if (!$4) {
                break label$10
               }
               i64toi32_i32$1 = $4;
               i64toi32_i32$0 = 0;
               HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = 1;
               HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
               i64toi32_i32$0 = 0;
               HEAP32[i64toi32_i32$1 >> 2] = 0;
               HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
               i64toi32_i32$1 = $3;
               i64toi32_i32$0 = 2;
               HEAP32[($3 + 108 | 0) >> 2] = 2;
               HEAP32[($3 + 112 | 0) >> 2] = i64toi32_i32$0;
               HEAP32[($3 + 104 | 0) >> 2] = $4;
               label$15 : {
                if (($5 | 0) == (2 | 0)) {
                 break label$15
                }
                $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hbadab170a9e9861d($3 + 104 | 0 | 0);
                break label$14;
               }
               $5 = memcmp(HEAP32[($3 + 72 | 0) >> 2] | 0 | 0, $4 | 0, 16 | 0) | 0;
               $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hbadab170a9e9861d($3 + 104 | 0 | 0);
               if (!$5) {
                break label$8
               }
              }
              $6 = HEAPU8[($1 + 12 | 0) >> 0] | 0;
              label$16 : {
               label$17 : {
                if (alloc__vec__Vec_T_2cA___is_empty__h144b76bbfc7433d3($1 | 0) | 0) {
                 break label$17
                }
                num_bigint__biguint__convert__to_bitwise_digits_le__hadd655177eaec017($3 + 192 | 0 | 0, $1 | 0, 8 | 0);
                break label$16;
               }
               $5 = __rust_alloc(1 | 0, 1 | 0) | 0;
               if (!$5) {
                break label$9
               }
               HEAP8[$5 >> 0] = 0;
               alloc__slice__hack__into_vec__h7c95d082cf6730ee($3 + 192 | 0 | 0, $5 | 0, 1 | 0);
              }
              $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__DerefMut___deref_mut__h1882e042320a120c($3 + 56 | 0 | 0, $3 + 192 | 0 | 0);
              label$18 : {
               $4 = HEAP32[($3 + 60 | 0) >> 2] | 0;
               $7 = $4 >>> 1 | 0;
               if (!$7) {
                break label$18
               }
               $5 = HEAP32[($3 + 56 | 0) >> 2] | 0;
               $4 = ($4 + $5 | 0) + -1 | 0;
               label$19 : while (1) {
                $8 = HEAPU8[$5 >> 0] | 0;
                HEAP8[$5 >> 0] = HEAPU8[$4 >> 0] | 0;
                HEAP8[$4 >> 0] = $8;
                $5 = $5 + 1 | 0;
                $4 = $4 + -1 | 0;
                $7 = $7 + -1 | 0;
                if ($7) {
                 continue label$19
                }
                break label$19;
               };
              }
              $5 = HEAP32[(($3 + 192 | 0) + 8 | 0) >> 2] | 0;
              $28 = $3 + 115 | 0;
              HEAP8[$28 >> 0] = $5;
              HEAP8[($28 + 1 | 0) >> 0] = $5 >>> 8 | 0;
              HEAP8[($28 + 2 | 0) >> 0] = $5 >>> 16 | 0;
              HEAP8[($28 + 3 | 0) >> 0] = $5 >>> 24 | 0;
              i64toi32_i32$2 = $3;
              i64toi32_i32$0 = HEAP32[($3 + 192 | 0) >> 2] | 0;
              i64toi32_i32$1 = HEAP32[($3 + 196 | 0) >> 2] | 0;
              $9 = i64toi32_i32$0;
              $9$hi = i64toi32_i32$1;
              i64toi32_i32$0 = $3;
              HEAP8[($3 + 107 | 0) >> 0] = $9;
              HEAP8[($3 + 108 | 0) >> 0] = $9 >>> 8 | 0;
              HEAP8[($3 + 109 | 0) >> 0] = $9 >>> 16 | 0;
              HEAP8[($3 + 110 | 0) >> 0] = $9 >>> 24 | 0;
              HEAP8[($3 + 111 | 0) >> 0] = i64toi32_i32$1;
              HEAP8[($3 + 112 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
              HEAP8[($3 + 113 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
              HEAP8[($3 + 114 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
              HEAP32[(($3 + 88 | 0) + 8 | 0) >> 2] = $5;
              i64toi32_i32$0 = $3;
              HEAP32[($3 + 88 | 0) >> 2] = $9;
              HEAP32[($3 + 92 | 0) >> 2] = i64toi32_i32$1;
              label$20 : {
               label$21 : {
                label$22 : {
                 label$23 : {
                  label$24 : {
                   if ($6 & 255 | 0) {
                    break label$24
                   }
                   i64toi32_i32$1 = 0;
                   cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 + 104 | 0 | 0, $2 | 0, 6 | 0, 3 | 0, i64toi32_i32$1 | 0);
                   if ((HEAP32[($3 + 104 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                    break label$20
                   }
                   $4 = HEAPU8[($1 + 12 | 0) >> 0] | 0;
                   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hd36b5d149e6fd98b($3 + 104 | 0 | 0, $1 | 0);
                   $5 = 2;
                   switch ($4 | 0) {
                   case 2:
                    break label$22;
                   case 1:
                    break label$23;
                   default:
                    break label$21;
                   };
                  }
                  i64toi32_i32$1 = 0;
                  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 + 104 | 0 | 0, $2 | 0, 6 | 0, 2 | 0, i64toi32_i32$1 | 0);
                  label$25 : {
                   if ((HEAP32[($3 + 104 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                    break label$25
                   }
                   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 48 | 0 | 0, $3 + 88 | 0 | 0);
                   cardano_serialization_lib__utils__write_bounded_bytes__h9cfd6d74fa4c49a9($0 | 0, $2 | 0, HEAP32[($3 + 48 | 0) >> 2] | 0 | 0, HEAP32[($3 + 52 | 0) >> 2] | 0 | 0);
                   break label$3;
                  }
                  memcpy($0 + 8 | 0 | 0, ($3 + 104 | 0) + 8 | 0 | 0, 40 | 0) | 0;
                  break label$4;
                 }
                 $5 = 1;
                 break label$21;
                }
                $5 = 0;
               }
               HEAP8[($3 + 116 | 0) >> 0] = $5;
               $5 = ($3 + 104 | 0) + 8 | 0;
               i64toi32_i32$2 = $5;
               i64toi32_i32$1 = HEAP32[$5 >> 2] | 0;
               i64toi32_i32$0 = HEAP32[($5 + 4 | 0) >> 2] | 0;
               $166 = i64toi32_i32$1;
               i64toi32_i32$1 = ($3 + 160 | 0) + 8 | 0;
               HEAP32[i64toi32_i32$1 >> 2] = $166;
               HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
               i64toi32_i32$2 = $3;
               i64toi32_i32$0 = HEAP32[($3 + 104 | 0) >> 2] | 0;
               i64toi32_i32$1 = HEAP32[($3 + 108 | 0) >> 2] | 0;
               $169 = i64toi32_i32$0;
               i64toi32_i32$0 = $3;
               HEAP32[($3 + 160 | 0) >> 2] = $169;
               HEAP32[($3 + 164 | 0) >> 2] = i64toi32_i32$1;
               i64toi32_i32$0 = $3;
               i64toi32_i32$1 = 0;
               HEAP32[($3 + 108 | 0) >> 2] = 0;
               HEAP32[($3 + 112 | 0) >> 2] = i64toi32_i32$1;
               $8 = HEAP32[(0 + 1057660 | 0) >> 2] | 0;
               HEAP32[($3 + 104 | 0) >> 2] = $8;
               alloc__vec__Vec_T_2cA___reserve__hd6ffa03575bd5508($3 + 104 | 0 | 0, 1 | 0);
               HEAP8[($3 + 188 | 0) >> 0] = 2;
               HEAP32[((HEAP32[($3 + 104 | 0) >> 2] | 0) + ((HEAP32[$5 >> 2] | 0) << 2 | 0) | 0) >> 2] = 1;
               HEAP32[(($3 + 176 | 0) + 8 | 0) >> 2] = (HEAP32[$5 >> 2] | 0) + 1 | 0;
               i64toi32_i32$2 = $3;
               i64toi32_i32$1 = HEAP32[($3 + 104 | 0) >> 2] | 0;
               i64toi32_i32$0 = HEAP32[($3 + 108 | 0) >> 2] | 0;
               $191 = i64toi32_i32$1;
               i64toi32_i32$1 = $3;
               HEAP32[($3 + 176 | 0) >> 2] = $191;
               HEAP32[($3 + 180 | 0) >> 2] = i64toi32_i32$0;
               label$26 : {
                label$27 : {
                 label$28 : {
                  label$29 : {
                   $4 = HEAPU8[($3 + 172 | 0) >> 0] | 0;
                   switch ($4 | 0) {
                   case 2:
                    break label$27;
                   case 1:
                    break label$29;
                   default:
                    break label$28;
                   };
                  }
                  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hd36b5d149e6fd98b($3 + 104 | 0 | 0, $3 + 176 | 0 | 0);
                  HEAP8[($3 + 116 | 0) >> 0] = 0;
                  i64toi32_i32$2 = $5;
                  i64toi32_i32$0 = HEAP32[$5 >> 2] | 0;
                  i64toi32_i32$1 = HEAP32[($5 + 4 | 0) >> 2] | 0;
                  $204 = i64toi32_i32$0;
                  i64toi32_i32$0 = ($3 + 192 | 0) + 8 | 0;
                  HEAP32[i64toi32_i32$0 >> 2] = $204;
                  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
                  i64toi32_i32$2 = $3;
                  i64toi32_i32$1 = HEAP32[($3 + 104 | 0) >> 2] | 0;
                  i64toi32_i32$0 = HEAP32[($3 + 108 | 0) >> 2] | 0;
                  $207 = i64toi32_i32$1;
                  i64toi32_i32$1 = $3;
                  HEAP32[($3 + 192 | 0) >> 2] = $207;
                  HEAP32[($3 + 196 | 0) >> 2] = i64toi32_i32$0;
                  break label$26;
                 }
                 label$30 : {
                  label$31 : {
                   if ((HEAP32[($3 + 168 | 0) >> 2] | 0) >>> 0 >= (HEAP32[($3 + 184 | 0) >> 2] | 0) >>> 0) {
                    break label$31
                   }
                   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hd36b5d149e6fd98b($3 + 104 | 0 | 0, $3 + 176 | 0 | 0);
                   num_bigint__biguint__addition___impl_20core__ops__arith__Add__num_bigint__biguint__BigUint__20for_20num_bigint__biguint__BigUint___add__ha6a5672f04e3ed65($3 + 208 | 0 | 0, $3 + 104 | 0 | 0, $3 + 160 | 0 | 0);
                   break label$30;
                  }
                  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hd36b5d149e6fd98b($3 + 104 | 0 | 0, $3 + 160 | 0 | 0);
                  num_bigint__biguint__addition___impl_20core__ops__arith__Add__num_bigint__biguint__BigUint__20for_20num_bigint__biguint__BigUint___add__ha6a5672f04e3ed65($3 + 208 | 0 | 0, $3 + 104 | 0 | 0, $3 + 176 | 0 | 0);
                 }
                 num_bigint__bigint__BigInt__from_biguint__hc8c58ec5989a4432($3 + 192 | 0 | 0, $4 | 0, $3 + 208 | 0 | 0);
                 break label$26;
                }
                $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h7a0ed8a251b429e6($3 + 40 | 0 | 0, $3 + 160 | 0 | 0);
                $1 = HEAP32[($3 + 40 | 0) >> 2] | 0;
                $5 = HEAP32[($3 + 44 | 0) >> 2] | 0;
                $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h7a0ed8a251b429e6($3 + 32 | 0 | 0, $3 + 176 | 0 | 0);
                label$32 : {
                 $4 = HEAP32[($3 + 36 | 0) >> 2] | 0;
                 $7 = $5 >>> 0 < $4 >>> 0 ? -1 : ($5 | 0) != ($4 | 0);
                 if ($7) {
                  break label$32
                 }
                 $7 = HEAP32[($3 + 32 | 0) >> 2] | 0;
                 core__iter__adapters__rev__Rev_T___new__h91ca0d56df8c38ae($3 + 24 | 0 | 0, $1 | 0, $1 + ($5 << 2 | 0) | 0 | 0);
                 $5 = HEAP32[($3 + 28 | 0) >> 2] | 0;
                 $1 = HEAP32[($3 + 24 | 0) >> 2] | 0;
                 core__iter__adapters__rev__Rev_T___new__h91ca0d56df8c38ae($3 + 16 | 0 | 0, $7 | 0, $7 + ($4 << 2 | 0) | 0 | 0);
                 $7 = core__iter__traits__iterator__Iterator__cmp__he292810785df7a3c($1 | 0, $5 | 0, HEAP32[($3 + 16 | 0) >> 2] | 0 | 0, HEAP32[($3 + 20 | 0) >> 2] | 0 | 0) | 0;
                }
                label$33 : {
                 switch ((($7 << 24 | 0) >> 24 | 0) + 1 | 0 | 0) {
                 default:
                  $5 = 2;
                  label$36 : {
                   label$37 : {
                    switch (HEAPU8[($3 + 172 | 0) >> 0] | 0 | 0) {
                    case 1:
                     $5 = 1;
                     break label$36;
                    case 2:
                     break label$37;
                    default:
                     break label$36;
                    };
                   }
                   $5 = 0;
                  }
                  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hd36b5d149e6fd98b($3 + 104 | 0 | 0, $3 + 176 | 0 | 0);
                  num_bigint__biguint__subtraction___impl_20core__ops__arith__Sub__num_bigint__biguint__BigUint__20for_20num_bigint__biguint__BigUint___sub__hac2d36d0edc5bcae($3 + 208 | 0 | 0, $3 + 104 | 0 | 0, $3 + 160 | 0 | 0);
                  num_bigint__bigint__BigInt__from_biguint__hc8c58ec5989a4432($3 + 192 | 0 | 0, $5 | 0, $3 + 208 | 0 | 0);
                  break label$26;
                 case 1:
                  i64toi32_i32$1 = $3;
                  i64toi32_i32$0 = 0;
                  HEAP32[($3 + 196 | 0) >> 2] = 0;
                  HEAP32[($3 + 200 | 0) >> 2] = i64toi32_i32$0;
                  HEAP32[($3 + 192 | 0) >> 2] = $8;
                  HEAP8[($3 + 204 | 0) >> 0] = 1;
                  break label$26;
                 case 2:
                  break label$33;
                 };
                }
                $5 = HEAPU8[($3 + 172 | 0) >> 0] | 0;
                $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hd36b5d149e6fd98b($3 + 104 | 0 | 0, $3 + 160 | 0 | 0);
                num_bigint__biguint__subtraction___impl_20core__ops__arith__Sub__num_bigint__biguint__BigUint__20for_20num_bigint__biguint__BigUint___sub__hac2d36d0edc5bcae($3 + 208 | 0 | 0, $3 + 104 | 0 | 0, $3 + 176 | 0 | 0);
                num_bigint__bigint__BigInt__from_biguint__hc8c58ec5989a4432($3 + 192 | 0 | 0, $5 | 0, $3 + 208 | 0 | 0);
               }
               $4 = ($3 + 208 | 0) + 8 | 0;
               HEAP32[$4 >> 2] = HEAP32[(($3 + 192 | 0) + 8 | 0) >> 2] | 0;
               $7 = $3 + 158 | 0;
               HEAP8[$7 >> 0] = HEAPU8[(($3 + 192 | 0) + 15 | 0) >> 0] | 0;
               i64toi32_i32$2 = $3;
               i64toi32_i32$0 = HEAP32[($3 + 192 | 0) >> 2] | 0;
               i64toi32_i32$1 = HEAP32[($3 + 196 | 0) >> 2] | 0;
               $346 = i64toi32_i32$0;
               i64toi32_i32$0 = $3;
               HEAP32[($3 + 208 | 0) >> 2] = $346;
               HEAP32[($3 + 212 | 0) >> 2] = i64toi32_i32$1;
               HEAP16[($3 + 156 | 0) >> 1] = HEAPU8[($3 + 205 | 0) >> 0] | 0 | ((HEAPU8[($3 + 206 | 0) >> 0] | 0) << 8 | 0) | 0;
               $5 = HEAPU8[($3 + 204 | 0) >> 0] | 0;
               if (($5 | 0) == (3 | 0)) {
                break label$7
               }
               HEAP32[(($3 + 104 | 0) + 8 | 0) >> 2] = HEAP32[$4 >> 2] | 0;
               HEAP8[(($3 + 104 | 0) + 15 | 0) >> 0] = HEAPU8[$7 >> 0] | 0;
               i64toi32_i32$2 = $3;
               i64toi32_i32$1 = HEAP32[($3 + 208 | 0) >> 2] | 0;
               i64toi32_i32$0 = HEAP32[($3 + 212 | 0) >> 2] | 0;
               $366 = i64toi32_i32$1;
               i64toi32_i32$1 = $3;
               HEAP32[($3 + 104 | 0) >> 2] = $366;
               HEAP32[($3 + 108 | 0) >> 2] = i64toi32_i32$0;
               HEAP8[($3 + 116 | 0) >> 0] = $5;
               $29 = HEAPU16[($3 + 156 | 0) >> 1] | 0;
               HEAP8[($3 + 117 | 0) >> 0] = $29;
               HEAP8[($3 + 118 | 0) >> 0] = $29 >>> 8 | 0;
               label$39 : {
                label$40 : {
                 label$41 : {
                  label$42 : {
                   switch ($5 | 0) {
                   default:
                    HEAP32[($3 + 192 | 0) >> 2] = 0;
                    break label$41;
                   case 1:
                    break label$40;
                   case 2:
                    break label$42;
                   };
                  }
                  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hd36b5d149e6fd98b($3 + 192 | 0 | 0, $3 + 104 | 0 | 0);
                  $5 = $3 + 104 | 0;
                  if (HEAP32[($3 + 192 | 0) >> 2] | 0) {
                   break label$39
                  }
                 }
                 core__panicking__panic__h2fd385a887c8bf13(1057508 | 0, 43 | 0, 1057892 | 0);
                 abort();
                }
                i64toi32_i32$1 = $3;
                i64toi32_i32$0 = 0;
                HEAP32[($3 + 196 | 0) >> 2] = 0;
                HEAP32[($3 + 200 | 0) >> 2] = i64toi32_i32$0;
                HEAP32[($3 + 192 | 0) >> 2] = $8;
                $5 = $3 + 104 | 0;
               }
               HEAP32[(($3 + 208 | 0) + 8 | 0) >> 2] = HEAP32[(($3 + 192 | 0) + 8 | 0) >> 2] | 0;
               i64toi32_i32$2 = $3;
               i64toi32_i32$0 = HEAP32[($3 + 192 | 0) >> 2] | 0;
               i64toi32_i32$1 = HEAP32[($3 + 196 | 0) >> 2] | 0;
               $396 = i64toi32_i32$0;
               i64toi32_i32$0 = $3;
               HEAP32[($3 + 208 | 0) >> 2] = $396;
               HEAP32[($3 + 212 | 0) >> 2] = i64toi32_i32$1;
               $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h19f76bdb6b4883ef($5 | 0);
               $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h970b13f6299e0f2d($3 + 104 | 0 | 0);
               $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h19f76bdb6b4883ef($3 + 176 | 0 | 0);
               $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h970b13f6299e0f2d($3 + 176 | 0 | 0);
               $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h19f76bdb6b4883ef($3 + 160 | 0 | 0);
               $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h970b13f6299e0f2d($3 + 160 | 0 | 0);
               label$44 : {
                label$45 : {
                 if (alloc__vec__Vec_T_2cA___is_empty__h144b76bbfc7433d3($3 + 208 | 0 | 0) | 0) {
                  break label$45
                 }
                 num_bigint__biguint__convert__to_bitwise_digits_le__hadd655177eaec017($3 + 104 | 0 | 0, $3 + 208 | 0 | 0, 8 | 0);
                 break label$44;
                }
                $5 = __rust_alloc(1 | 0, 1 | 0) | 0;
                if (!$5) {
                 break label$6
                }
                HEAP8[$5 >> 0] = 0;
                alloc__slice__hack__into_vec__h7c95d082cf6730ee($3 + 104 | 0 | 0, $5 | 0, 1 | 0);
               }
               $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__DerefMut___deref_mut__h1882e042320a120c($3 + 8 | 0 | 0, $3 + 104 | 0 | 0);
               label$46 : {
                $4 = HEAP32[($3 + 12 | 0) >> 2] | 0;
                $7 = $4 >>> 1 | 0;
                if (!$7) {
                 break label$46
                }
                $5 = HEAP32[($3 + 8 | 0) >> 2] | 0;
                $4 = ($4 + $5 | 0) + -1 | 0;
                label$47 : while (1) {
                 $8 = HEAPU8[$5 >> 0] | 0;
                 HEAP8[$5 >> 0] = HEAPU8[$4 >> 0] | 0;
                 HEAP8[$4 >> 0] = $8;
                 $5 = $5 + 1 | 0;
                 $4 = $4 + -1 | 0;
                 $7 = $7 + -1 | 0;
                 if ($7) {
                  continue label$47
                 }
                 break label$47;
                };
               }
               $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 | 0, $3 + 104 | 0 | 0);
               cardano_serialization_lib__utils__write_bounded_bytes__h9cfd6d74fa4c49a9($0 | 0, $2 | 0, HEAP32[$3 >> 2] | 0 | 0, HEAP32[($3 + 4 | 0) >> 2] | 0 | 0);
               $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h19f76bdb6b4883ef($3 + 208 | 0 | 0);
               $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h970b13f6299e0f2d($3 + 208 | 0 | 0);
               $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 104 | 0 | 0);
               $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 104 | 0 | 0);
               break label$3;
              }
              memcpy($0 + 8 | 0 | 0, ($3 + 104 | 0) + 8 | 0 | 0, 40 | 0) | 0;
              break label$4;
             case 0:
              i64toi32_i32$1 = 0;
              cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($0 | 0, $2 | 0, 0 | 0, 0 | 0, i64toi32_i32$1 | 0);
              break label$2;
             case 1:
              break label$11;
             };
            }
            i64toi32_i32$2 = HEAP32[($3 + 72 | 0) >> 2] | 0;
            i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
            i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
            $9 = i64toi32_i32$1;
            $9$hi = i64toi32_i32$0;
            if (!($4 & 255 | 0)) {
             break label$5
            }
            i64toi32_i32$0 = $9$hi;
            cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($0 | 0, $2 | 0, 0 | 0, $9 | 0, i64toi32_i32$0 | 0);
            break label$2;
           }
           $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
           alloc__alloc__handle_alloc_error__he269d8f1bff90960(16 | 0, 8 | 0);
           abort();
          }
          $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
          alloc__alloc__handle_alloc_error__he269d8f1bff90960(1 | 0, 1 | 0);
          abort();
         }
         i64toi32_i32$0 = -1;
         cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($0 | 0, $2 | 0, 1 | 0, -1 | 0, i64toi32_i32$0 | 0);
         break label$2;
        }
        core__panicking__panic__h2fd385a887c8bf13(1057508 | 0, 43 | 0, 1057876 | 0);
        abort();
       }
       $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
       alloc__alloc__handle_alloc_error__he269d8f1bff90960(1 | 0, 1 | 0);
       abort();
      }
      $488 = $0;
      $489 = $2;
      i64toi32_i32$0 = $9$hi;
      i64toi32_i32$2 = $9;
      i64toi32_i32$1 = -1;
      i64toi32_i32$3 = -1;
      i64toi32_i32$4 = $9 + i64toi32_i32$3 | 0;
      i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
      if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
       i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
      }
      cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($488 | 0, $489 | 0, 1 | 0, i64toi32_i32$4 | 0, i64toi32_i32$5 | 0);
      break label$2;
     }
     HEAP32[$0 >> 2] = 1;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 88 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 88 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hbadab170a9e9861d($3 + 72 | 0 | 0);
     break label$1;
    }
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 88 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 88 | 0 | 0);
   }
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hbadab170a9e9861d($3 + 72 | 0 | 0);
  }
  global$0 = $3 + 224 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__CertificateEnum___deserialize_as_embedded_group__ha6eb74d19a708487($0, $1, $2, $2$hi, $3, $3$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  var $4 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $5 = 0, $8 = 0, $8$hi = 0, $6 = 0, $7 = 0, $50 = 0, $51 = 0, $52 = 0, $53 = 0, $54 = 0, $55 = 0, $56 = 0, $57 = 0, $58 = 0, $59 = 0, $60 = 0, $61 = 0, $62 = 0, $63 = 0, $64 = 0, $65 = 0, $66 = 0, $67 = 0, $68 = 0, $69 = 0, $70 = 0, $9 = 0, $10 = 0, $11 = 0, $9$hi = 0, $10$hi = 0, $11$hi = 0, $373 = 0, $380 = 0, $387 = 0, $392 = 0, $397 = 0, $400 = 0, $405 = 0, $409 = 0, $415 = 0, $419 = 0, $426 = 0, $433 = 0, $440 = 0, $445 = 0, $450 = 0, $453 = 0, $458 = 0, $462 = 0, $468 = 0, $472 = 0, $475 = 0, $480 = 0, $485 = 0, $490 = 0, $495 = 0, $500 = 0, $505 = 0, $510 = 0;
  $4 = global$0 - 592 | 0;
  global$0 = $4;
  i64toi32_i32$1 = $4;
  i64toi32_i32$0 = 0;
  HEAP32[($4 + 392 | 0) >> 2] = 2;
  HEAP32[($4 + 396 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$1 = $4;
  i64toi32_i32$0 = 0;
  HEAP32[($4 + 400 | 0) >> 2] = 0;
  HEAP32[($4 + 404 | 0) >> 2] = i64toi32_i32$0;
  $std__io__cursor__Cursor_T__20as_20std__io__Seek___seek__h4fe82da83d4d5304($4 | 0, $1 | 0, $4 + 392 | 0 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           if ((HEAP32[$4 >> 2] | 0 | 0) == (1 | 0)) {
            break label$9
           }
           $5 = $4 + 8 | 0;
           i64toi32_i32$2 = $5;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
           $8 = i64toi32_i32$0;
           $8$hi = i64toi32_i32$1;
           i64toi32_i32$0 = i64toi32_i32$1;
           cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__StakeRegistration___deserialize_as_embedded_group__h584ad4f96a0a79b8($4 + 392 | 0 | 0, $1 | 0, $8 | 0, i64toi32_i32$1 | 0, $8 | 0, i64toi32_i32$1 | 0);
           label$10 : {
            if ((HEAPU8[($4 + 392 | 0) >> 0] | 0 | 0) != (1 | 0)) {
             break label$10
            }
            $6 = memcpy($4 + 200 | 0 | 7 | 0 | 0, ($4 + 392 | 0) + 8 | 0 | 0, 64 | 0) | 0;
            $5 = memcpy($5 | 0, $6 | 0, 64 | 0) | 0;
            HEAP8[$4 >> 0] = 1;
            i64toi32_i32$1 = $4;
            i64toi32_i32$0 = 0;
            HEAP32[($4 + 392 | 0) >> 2] = 0;
            HEAP32[($4 + 396 | 0) >> 2] = i64toi32_i32$0;
            i64toi32_i32$0 = $8$hi;
            i64toi32_i32$1 = $4;
            HEAP32[($4 + 400 | 0) >> 2] = $8;
            HEAP32[($4 + 404 | 0) >> 2] = i64toi32_i32$0;
            $std__io__cursor__Cursor_T__20as_20std__io__Seek___seek__h4fe82da83d4d5304($4 + 200 | 0 | 0, $1 | 0, $4 + 392 | 0 | 0);
            if ((HEAP32[($4 + 200 | 0) >> 2] | 0 | 0) == (1 | 0)) {
             break label$8
            }
            core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9($5 | 0);
            i64toi32_i32$0 = $8$hi;
            i64toi32_i32$1 = i64toi32_i32$0;
            cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__StakeDeregistration___deserialize_as_embedded_group__h26da61dcbe3232ba($4 + 392 | 0 | 0, $1 | 0, $8 | 0, i64toi32_i32$1 | 0, $8 | 0, i64toi32_i32$1 | 0);
            label$11 : {
             if ((HEAPU8[($4 + 392 | 0) >> 0] | 0 | 0) != (1 | 0)) {
              break label$11
             }
             $6 = memcpy($6 | 0, ($4 + 392 | 0) + 8 | 0 | 0, 64 | 0) | 0;
             $5 = memcpy($4 + 8 | 0 | 0, $6 | 0, 64 | 0) | 0;
             HEAP8[$4 >> 0] = 1;
             i64toi32_i32$0 = $4;
             i64toi32_i32$1 = 0;
             HEAP32[($4 + 392 | 0) >> 2] = 0;
             HEAP32[($4 + 396 | 0) >> 2] = i64toi32_i32$1;
             i64toi32_i32$1 = $8$hi;
             i64toi32_i32$0 = $4;
             HEAP32[($4 + 400 | 0) >> 2] = $8;
             HEAP32[($4 + 404 | 0) >> 2] = i64toi32_i32$1;
             $std__io__cursor__Cursor_T__20as_20std__io__Seek___seek__h4fe82da83d4d5304($4 + 200 | 0 | 0, $1 | 0, $4 + 392 | 0 | 0);
             if ((HEAP32[($4 + 200 | 0) >> 2] | 0 | 0) == (1 | 0)) {
              break label$7
             }
             core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9($5 | 0);
             i64toi32_i32$1 = $8$hi;
             i64toi32_i32$0 = i64toi32_i32$1;
             cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__StakeDelegation___deserialize_as_embedded_group__he2a305551fe9e1ea($4 + 392 | 0 | 0, $1 | 0, $8 | 0, i64toi32_i32$1 | 0, $8 | 0, i64toi32_i32$1 | 0);
             label$12 : {
              if ((HEAPU8[($4 + 392 | 0) >> 0] | 0 | 0) != (1 | 0)) {
               break label$12
              }
              $5 = ($4 + 392 | 0) + 8 | 0;
              $6 = memcpy($4 + 8 | 0 | 0, memcpy($6 | 0, $5 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
              HEAP8[$4 >> 0] = 1;
              i64toi32_i32$1 = $4;
              i64toi32_i32$0 = 0;
              HEAP32[($4 + 392 | 0) >> 2] = 0;
              HEAP32[($4 + 396 | 0) >> 2] = i64toi32_i32$0;
              i64toi32_i32$0 = $8$hi;
              i64toi32_i32$1 = $4;
              HEAP32[($4 + 400 | 0) >> 2] = $8;
              HEAP32[($4 + 404 | 0) >> 2] = i64toi32_i32$0;
              $std__io__cursor__Cursor_T__20as_20std__io__Seek___seek__h4fe82da83d4d5304($4 + 200 | 0 | 0, $1 | 0, $4 + 392 | 0 | 0);
              if ((HEAP32[($4 + 200 | 0) >> 2] | 0 | 0) == (1 | 0)) {
               break label$6
              }
              core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9($6 | 0);
              i64toi32_i32$0 = $8$hi;
              i64toi32_i32$1 = i64toi32_i32$0;
              cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__PoolRegistration___deserialize_as_embedded_group__h417fb115ca31b437($4 + 392 | 0 | 0, $1 | 0, $8 | 0, i64toi32_i32$1 | 0, $8 | 0, i64toi32_i32$1 | 0);
              label$13 : {
               i64toi32_i32$2 = $4;
               i64toi32_i32$1 = HEAP32[($4 + 392 | 0) >> 2] | 0;
               i64toi32_i32$0 = HEAP32[($4 + 396 | 0) >> 2] | 0;
               i64toi32_i32$2 = i64toi32_i32$1;
               i64toi32_i32$1 = 0;
               i64toi32_i32$3 = 1;
               if ((i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | 0) {
                break label$13
               }
               memcpy($4 + 200 | 0 | 0, $5 | 0, 64 | 0) | 0;
               memcpy($4 + 8 | 0 | 0, $4 + 200 | 0 | 0, 64 | 0) | 0;
               i64toi32_i32$0 = $4;
               i64toi32_i32$2 = 0;
               HEAP32[$4 >> 2] = 1;
               HEAP32[($4 + 4 | 0) >> 2] = i64toi32_i32$2;
               i64toi32_i32$0 = $4;
               i64toi32_i32$2 = 0;
               HEAP32[($4 + 392 | 0) >> 2] = 0;
               HEAP32[($4 + 396 | 0) >> 2] = i64toi32_i32$2;
               i64toi32_i32$2 = $8$hi;
               i64toi32_i32$0 = $4;
               HEAP32[($4 + 400 | 0) >> 2] = $8;
               HEAP32[($4 + 404 | 0) >> 2] = i64toi32_i32$2;
               $std__io__cursor__Cursor_T__20as_20std__io__Seek___seek__h4fe82da83d4d5304($4 + 200 | 0 | 0, $1 | 0, $4 + 392 | 0 | 0);
               if ((HEAP32[($4 + 200 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                break label$5
               }
               core__ptr__drop_in_place_core__result__Result_cardano_serialization_lib__PoolRegistration_2ccardano_serialization_lib__error__DeserializeError____hd0bde1a1981b77c0($4 | 0);
               i64toi32_i32$2 = $8$hi;
               i64toi32_i32$0 = i64toi32_i32$2;
               cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__PoolRetirement___deserialize_as_embedded_group__h069038c66944b4a7($4 + 392 | 0 | 0, $1 | 0, $8 | 0, i64toi32_i32$2 | 0, $8 | 0, i64toi32_i32$2 | 0);
               label$14 : {
                if ((HEAP32[($4 + 392 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                 break label$14
                }
                $5 = memcpy($4 + 8 | 0 | 0, memcpy($4 + 200 | 0 | 4 | 0 | 0, ($4 + 392 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
                HEAP32[$4 >> 2] = 1;
                i64toi32_i32$2 = $4;
                i64toi32_i32$0 = 0;
                HEAP32[($4 + 392 | 0) >> 2] = 0;
                HEAP32[($4 + 396 | 0) >> 2] = i64toi32_i32$0;
                i64toi32_i32$0 = $8$hi;
                i64toi32_i32$2 = $4;
                HEAP32[($4 + 400 | 0) >> 2] = $8;
                HEAP32[($4 + 404 | 0) >> 2] = i64toi32_i32$0;
                $std__io__cursor__Cursor_T__20as_20std__io__Seek___seek__h4fe82da83d4d5304($4 + 200 | 0 | 0, $1 | 0, $4 + 392 | 0 | 0);
                if ((HEAP32[($4 + 200 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                 break label$4
                }
                core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9($5 | 0);
                i64toi32_i32$0 = $8$hi;
                i64toi32_i32$2 = i64toi32_i32$0;
                cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__GenesisKeyDelegation___deserialize_as_embedded_group__h009fd03835fe23c0($4 + 392 | 0 | 0, $1 | 0, $8 | 0, i64toi32_i32$2 | 0, $8 | 0, i64toi32_i32$2 | 0);
                label$15 : {
                 if ((HEAPU8[($4 + 392 | 0) >> 0] | 0 | 0) != (1 | 0)) {
                  break label$15
                 }
                 $5 = ($4 + 392 | 0) + 8 | 0;
                 $6 = memcpy($4 + 8 | 0 | 0, memcpy($4 + 207 | 0 | 0, $5 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
                 HEAP8[$4 >> 0] = 1;
                 i64toi32_i32$0 = $4;
                 i64toi32_i32$2 = 0;
                 HEAP32[($4 + 392 | 0) >> 2] = 0;
                 HEAP32[($4 + 396 | 0) >> 2] = i64toi32_i32$2;
                 i64toi32_i32$2 = $8$hi;
                 i64toi32_i32$0 = $4;
                 HEAP32[($4 + 400 | 0) >> 2] = $8;
                 HEAP32[($4 + 404 | 0) >> 2] = i64toi32_i32$2;
                 $std__io__cursor__Cursor_T__20as_20std__io__Seek___seek__h4fe82da83d4d5304($4 + 200 | 0 | 0, $1 | 0, $4 + 392 | 0 | 0);
                 if ((HEAP32[($4 + 200 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                  break label$3
                 }
                 core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9($6 | 0);
                 i64toi32_i32$2 = $8$hi;
                 i64toi32_i32$0 = i64toi32_i32$2;
                 cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__MoveInstantaneousRewardsCert___deserialize_as_embedded_group__ha238bf99690081e0($4 + 392 | 0 | 0, $1 | 0, $8 | 0, i64toi32_i32$2 | 0, $8 | 0, i64toi32_i32$2 | 0);
                 label$16 : {
                  i64toi32_i32$3 = $4;
                  i64toi32_i32$0 = HEAP32[($4 + 392 | 0) >> 2] | 0;
                  i64toi32_i32$2 = HEAP32[($4 + 396 | 0) >> 2] | 0;
                  i64toi32_i32$3 = i64toi32_i32$0;
                  i64toi32_i32$0 = 0;
                  i64toi32_i32$1 = 1;
                  if ((i64toi32_i32$3 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$0 | 0) | 0) {
                   break label$16
                  }
                  memcpy($4 + 200 | 0 | 0, $5 | 0, 64 | 0) | 0;
                  memcpy($4 + 8 | 0 | 0, $4 + 200 | 0 | 0, 64 | 0) | 0;
                  i64toi32_i32$2 = $4;
                  i64toi32_i32$3 = 0;
                  HEAP32[$4 >> 2] = 1;
                  HEAP32[($4 + 4 | 0) >> 2] = i64toi32_i32$3;
                  i64toi32_i32$2 = $4;
                  i64toi32_i32$3 = 0;
                  HEAP32[($4 + 392 | 0) >> 2] = 0;
                  HEAP32[($4 + 396 | 0) >> 2] = i64toi32_i32$3;
                  i64toi32_i32$3 = $8$hi;
                  i64toi32_i32$2 = $4;
                  HEAP32[($4 + 400 | 0) >> 2] = $8;
                  HEAP32[($4 + 404 | 0) >> 2] = i64toi32_i32$3;
                  $std__io__cursor__Cursor_T__20as_20std__io__Seek___seek__h4fe82da83d4d5304($4 + 200 | 0 | 0, $1 | 0, $4 + 392 | 0 | 0);
                  if ((HEAP32[($4 + 200 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                   break label$2
                  }
                  core__ptr__drop_in_place_core__result__Result_cardano_serialization_lib__MoveInstantaneousRewardsCert_2ccardano_serialization_lib__error__DeserializeError____h3f599aafe2c15b13($4 | 0);
                  alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($4 + 440 | 0 | 0, 1051130 | 0, 15 | 0);
                  HEAP8[($4 + 392 | 0) >> 0] = 11;
                  memcpy($0 + 8 | 0 | 0, $4 + 392 | 0 | 0, 64 | 0) | 0;
                  i64toi32_i32$2 = $0;
                  i64toi32_i32$3 = 0;
                  HEAP32[i64toi32_i32$2 >> 2] = 1;
                  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                  break label$1;
                 }
                 memcpy($4 + 200 | 0 | 0, $5 | 0, 56 | 0) | 0;
                 memcpy($4 + 399 | 0 | 0, memcpy($4 + 8 | 0 | 0, $4 + 200 | 0 | 0, 56 | 0) | 0 | 0, 56 | 0) | 0;
                 HEAP8[($0 + 8 | 0) >> 0] = 6;
                 memcpy($0 + 9 | 0 | 0, $4 + 392 | 0 | 0, 63 | 0) | 0;
                 i64toi32_i32$2 = $0;
                 i64toi32_i32$3 = 0;
                 HEAP32[i64toi32_i32$2 >> 2] = 0;
                 HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                 break label$1;
                }
                memcpy($4 + 200 | 0 | 0, $4 + 392 | 0 | 1 | 0 | 0, 88 | 0) | 0;
                $1 = memcpy($4 | 1 | 0 | 0, $4 + 200 | 0 | 0, 88 | 0) | 0;
                HEAP8[($0 + 8 | 0) >> 0] = 5;
                HEAP8[$4 >> 0] = 0;
                memcpy($0 + 9 | 0 | 0, $1 | 0, 88 | 0) | 0;
                i64toi32_i32$2 = $0;
                i64toi32_i32$3 = 0;
                HEAP32[i64toi32_i32$2 >> 2] = 0;
                HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
                break label$1;
               }
               i64toi32_i32$1 = ($4 + 392 | 0) + 12 | 0;
               i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
               i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
               $8 = i64toi32_i32$3;
               $8$hi = i64toi32_i32$2;
               i64toi32_i32$3 = $4 + 12 | 0;
               HEAP32[i64toi32_i32$3 >> 2] = $8;
               HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
               i64toi32_i32$1 = ($4 + 392 | 0) + 20 | 0;
               i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
               i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
               $9 = i64toi32_i32$2;
               $9$hi = i64toi32_i32$3;
               i64toi32_i32$2 = $4 + 20 | 0;
               HEAP32[i64toi32_i32$2 >> 2] = $9;
               HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
               i64toi32_i32$1 = ($4 + 392 | 0) + 28 | 0;
               i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
               i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
               $10 = i64toi32_i32$3;
               $10$hi = i64toi32_i32$2;
               i64toi32_i32$3 = $4 + 28 | 0;
               HEAP32[i64toi32_i32$3 >> 2] = $10;
               HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
               i64toi32_i32$1 = $4;
               i64toi32_i32$2 = HEAP32[($4 + 396 | 0) >> 2] | 0;
               i64toi32_i32$3 = HEAP32[($4 + 400 | 0) >> 2] | 0;
               $11 = i64toi32_i32$2;
               $11$hi = i64toi32_i32$3;
               i64toi32_i32$2 = $4;
               HEAP32[($4 + 4 | 0) >> 2] = $11;
               HEAP32[($4 + 8 | 0) >> 2] = i64toi32_i32$3;
               i64toi32_i32$3 = $10$hi;
               i64toi32_i32$2 = $4 + 419 | 0;
               $50 = $10;
               HEAP8[i64toi32_i32$2 >> 0] = $50;
               HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $50 >>> 8 | 0;
               HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $50 >>> 16 | 0;
               HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $50 >>> 24 | 0;
               HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$3;
               HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
               HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
               HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
               i64toi32_i32$3 = $9$hi;
               i64toi32_i32$2 = $4 + 411 | 0;
               $51 = $9;
               HEAP8[i64toi32_i32$2 >> 0] = $51;
               HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $51 >>> 8 | 0;
               HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $51 >>> 16 | 0;
               HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $51 >>> 24 | 0;
               HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$3;
               HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
               HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
               HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
               i64toi32_i32$3 = $8$hi;
               i64toi32_i32$2 = $4 + 403 | 0;
               HEAP8[i64toi32_i32$2 >> 0] = $8;
               HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $8 >>> 8 | 0;
               HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $8 >>> 16 | 0;
               HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $8 >>> 24 | 0;
               HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$3;
               HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
               HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
               HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
               HEAP8[($0 + 8 | 0) >> 0] = 4;
               i64toi32_i32$3 = $11$hi;
               i64toi32_i32$2 = $4;
               $52 = $11;
               HEAP8[($4 + 395 | 0) >> 0] = $52;
               HEAP8[($4 + 396 | 0) >> 0] = $52 >>> 8 | 0;
               HEAP8[($4 + 397 | 0) >> 0] = $52 >>> 16 | 0;
               HEAP8[($4 + 398 | 0) >> 0] = $52 >>> 24 | 0;
               HEAP8[($4 + 399 | 0) >> 0] = i64toi32_i32$3;
               HEAP8[($4 + 400 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
               HEAP8[($4 + 401 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
               HEAP8[($4 + 402 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
               memcpy($0 + 9 | 0 | 0, $4 + 392 | 0 | 0, 35 | 0) | 0;
               i64toi32_i32$2 = $0;
               i64toi32_i32$3 = 0;
               HEAP32[i64toi32_i32$2 >> 2] = 0;
               HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
               break label$1;
              }
              memcpy($4 + 200 | 0 | 0, $5 | 0, 192 | 0) | 0;
              memcpy($4 + 399 | 0 | 0, memcpy($4 + 8 | 0 | 0, $4 + 200 | 0 | 0, 192 | 0) | 0 | 0, 192 | 0) | 0;
              HEAP8[($0 + 8 | 0) >> 0] = 3;
              memcpy($0 + 9 | 0 | 0, $4 + 392 | 0 | 0, 199 | 0) | 0;
              i64toi32_i32$2 = $0;
              i64toi32_i32$3 = 0;
              HEAP32[i64toi32_i32$2 >> 2] = 0;
              HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
              break label$1;
             }
             memcpy($4 + 200 | 0 | 0, $4 + 392 | 0 | 1 | 0 | 0, 57 | 0) | 0;
             $1 = memcpy($4 | 1 | 0 | 0, $4 + 200 | 0 | 0, 57 | 0) | 0;
             HEAP8[($0 + 8 | 0) >> 0] = 2;
             HEAP8[$4 >> 0] = 0;
             memcpy($0 + 9 | 0 | 0, $1 | 0, 57 | 0) | 0;
             i64toi32_i32$2 = $0;
             i64toi32_i32$3 = 0;
             HEAP32[i64toi32_i32$2 >> 2] = 0;
             HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
             break label$1;
            }
            $1 = $4 + 221 | 0;
            i64toi32_i32$1 = ($4 + 392 | 0) + 22 | 0;
            i64toi32_i32$3 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            $373 = i64toi32_i32$3;
            i64toi32_i32$3 = $1;
            $53 = $373;
            HEAP8[i64toi32_i32$3 >> 0] = $53;
            HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $53 >>> 8 | 0;
            HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $53 >>> 16 | 0;
            HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $53 >>> 24 | 0;
            HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$2;
            HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
            HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
            HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
            $5 = $4 + 216 | 0;
            i64toi32_i32$1 = ($4 + 392 | 0) + 17 | 0;
            i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            i64toi32_i32$3 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            $380 = i64toi32_i32$2;
            i64toi32_i32$2 = $5;
            HEAP32[i64toi32_i32$2 >> 2] = $380;
            HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
            $6 = $4 + 9 | 0;
            i64toi32_i32$1 = ($4 + 392 | 0) + 9 | 0;
            i64toi32_i32$3 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            $387 = i64toi32_i32$3;
            i64toi32_i32$3 = $6;
            $54 = $387;
            HEAP8[i64toi32_i32$3 >> 0] = $54;
            HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $54 >>> 8 | 0;
            HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $54 >>> 16 | 0;
            HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $54 >>> 24 | 0;
            HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$2;
            HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
            HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
            HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
            $7 = $4 + 17 | 0;
            i64toi32_i32$1 = $5;
            i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
            i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
            $392 = i64toi32_i32$2;
            i64toi32_i32$2 = $7;
            $55 = $392;
            HEAP8[i64toi32_i32$2 >> 0] = $55;
            HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $55 >>> 8 | 0;
            HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $55 >>> 16 | 0;
            HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $55 >>> 24 | 0;
            HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$3;
            HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
            HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
            HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
            $5 = $4 + 22 | 0;
            i64toi32_i32$1 = $1;
            i64toi32_i32$3 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            $397 = i64toi32_i32$3;
            i64toi32_i32$3 = $5;
            $56 = $397;
            HEAP8[i64toi32_i32$3 >> 0] = $56;
            HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $56 >>> 8 | 0;
            HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $56 >>> 16 | 0;
            HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $56 >>> 24 | 0;
            HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$2;
            HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
            HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
            HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
            i64toi32_i32$1 = $4;
            i64toi32_i32$2 = HEAPU8[($4 + 393 | 0) >> 0] | 0 | ((HEAPU8[($4 + 394 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 395 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 396 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            i64toi32_i32$3 = HEAPU8[($4 + 397 | 0) >> 0] | 0 | ((HEAPU8[($4 + 398 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 399 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 400 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            $400 = i64toi32_i32$2;
            i64toi32_i32$2 = $4;
            $57 = $400;
            HEAP8[($4 + 1 | 0) >> 0] = $57;
            HEAP8[($4 + 2 | 0) >> 0] = $57 >>> 8 | 0;
            HEAP8[($4 + 3 | 0) >> 0] = $57 >>> 16 | 0;
            HEAP8[($4 + 4 | 0) >> 0] = $57 >>> 24 | 0;
            HEAP8[($4 + 5 | 0) >> 0] = i64toi32_i32$3;
            HEAP8[($4 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
            HEAP8[($4 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
            HEAP8[($4 + 8 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
            HEAP8[($0 + 8 | 0) >> 0] = 1;
            i64toi32_i32$1 = $7;
            i64toi32_i32$3 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            $405 = i64toi32_i32$3;
            i64toi32_i32$3 = $0 + 25 | 0;
            $58 = $405;
            HEAP8[i64toi32_i32$3 >> 0] = $58;
            HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $58 >>> 8 | 0;
            HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $58 >>> 16 | 0;
            HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $58 >>> 24 | 0;
            HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$2;
            HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
            HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
            HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
            i64toi32_i32$1 = $5;
            i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            i64toi32_i32$3 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            $409 = i64toi32_i32$2;
            i64toi32_i32$2 = $0 + 30 | 0;
            $59 = $409;
            HEAP8[i64toi32_i32$2 >> 0] = $59;
            HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $59 >>> 8 | 0;
            HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $59 >>> 16 | 0;
            HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $59 >>> 24 | 0;
            HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$3;
            HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
            HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
            HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
            i64toi32_i32$2 = $0;
            i64toi32_i32$3 = 0;
            HEAP32[i64toi32_i32$2 >> 2] = 0;
            HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
            HEAP8[$4 >> 0] = 0;
            i64toi32_i32$1 = $4;
            i64toi32_i32$3 = HEAPU8[($4 + 1 | 0) >> 0] | 0 | ((HEAPU8[($4 + 2 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 3 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 4 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            i64toi32_i32$2 = HEAPU8[($4 + 5 | 0) >> 0] | 0 | ((HEAPU8[($4 + 6 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 7 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 8 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            $415 = i64toi32_i32$3;
            i64toi32_i32$3 = $0 + 9 | 0;
            $60 = $415;
            HEAP8[i64toi32_i32$3 >> 0] = $60;
            HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $60 >>> 8 | 0;
            HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $60 >>> 16 | 0;
            HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $60 >>> 24 | 0;
            HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$2;
            HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
            HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
            HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
            i64toi32_i32$1 = $6;
            i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            i64toi32_i32$3 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            $419 = i64toi32_i32$2;
            i64toi32_i32$2 = $0 + 17 | 0;
            $61 = $419;
            HEAP8[i64toi32_i32$2 >> 0] = $61;
            HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $61 >>> 8 | 0;
            HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $61 >>> 16 | 0;
            HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $61 >>> 24 | 0;
            HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$3;
            HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
            HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
            HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
            break label$1;
           }
           $1 = $4 + 221 | 0;
           i64toi32_i32$1 = ($4 + 392 | 0) + 22 | 0;
           i64toi32_i32$3 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $426 = i64toi32_i32$3;
           i64toi32_i32$3 = $1;
           $62 = $426;
           HEAP8[i64toi32_i32$3 >> 0] = $62;
           HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $62 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $62 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $62 >>> 24 | 0;
           HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$2;
           HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
           $5 = $4 + 216 | 0;
           i64toi32_i32$1 = ($4 + 392 | 0) + 17 | 0;
           i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$3 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $433 = i64toi32_i32$2;
           i64toi32_i32$2 = $5;
           HEAP32[i64toi32_i32$2 >> 2] = $433;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
           $6 = $4 + 9 | 0;
           i64toi32_i32$1 = ($4 + 392 | 0) + 9 | 0;
           i64toi32_i32$3 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $440 = i64toi32_i32$3;
           i64toi32_i32$3 = $6;
           $63 = $440;
           HEAP8[i64toi32_i32$3 >> 0] = $63;
           HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $63 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $63 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $63 >>> 24 | 0;
           HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$2;
           HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
           $7 = $4 + 17 | 0;
           i64toi32_i32$1 = $5;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $445 = i64toi32_i32$2;
           i64toi32_i32$2 = $7;
           $64 = $445;
           HEAP8[i64toi32_i32$2 >> 0] = $64;
           HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $64 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $64 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $64 >>> 24 | 0;
           HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$3;
           HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
           $5 = $4 + 22 | 0;
           i64toi32_i32$1 = $1;
           i64toi32_i32$3 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $450 = i64toi32_i32$3;
           i64toi32_i32$3 = $5;
           $65 = $450;
           HEAP8[i64toi32_i32$3 >> 0] = $65;
           HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $65 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $65 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $65 >>> 24 | 0;
           HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$2;
           HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
           i64toi32_i32$1 = $4;
           i64toi32_i32$2 = HEAPU8[($4 + 393 | 0) >> 0] | 0 | ((HEAPU8[($4 + 394 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 395 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 396 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$3 = HEAPU8[($4 + 397 | 0) >> 0] | 0 | ((HEAPU8[($4 + 398 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 399 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 400 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $453 = i64toi32_i32$2;
           i64toi32_i32$2 = $4;
           $66 = $453;
           HEAP8[($4 + 1 | 0) >> 0] = $66;
           HEAP8[($4 + 2 | 0) >> 0] = $66 >>> 8 | 0;
           HEAP8[($4 + 3 | 0) >> 0] = $66 >>> 16 | 0;
           HEAP8[($4 + 4 | 0) >> 0] = $66 >>> 24 | 0;
           HEAP8[($4 + 5 | 0) >> 0] = i64toi32_i32$3;
           HEAP8[($4 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
           HEAP8[($4 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
           HEAP8[($4 + 8 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
           HEAP8[($0 + 8 | 0) >> 0] = 0;
           i64toi32_i32$1 = $7;
           i64toi32_i32$3 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $458 = i64toi32_i32$3;
           i64toi32_i32$3 = $0 + 25 | 0;
           $67 = $458;
           HEAP8[i64toi32_i32$3 >> 0] = $67;
           HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $67 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $67 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $67 >>> 24 | 0;
           HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$2;
           HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
           i64toi32_i32$1 = $5;
           i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$3 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $462 = i64toi32_i32$2;
           i64toi32_i32$2 = $0 + 30 | 0;
           $68 = $462;
           HEAP8[i64toi32_i32$2 >> 0] = $68;
           HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $68 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $68 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $68 >>> 24 | 0;
           HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$3;
           HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
           i64toi32_i32$2 = $0;
           i64toi32_i32$3 = 0;
           HEAP32[i64toi32_i32$2 >> 2] = 0;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
           HEAP8[$4 >> 0] = 0;
           i64toi32_i32$1 = $4;
           i64toi32_i32$3 = HEAPU8[($4 + 1 | 0) >> 0] | 0 | ((HEAPU8[($4 + 2 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 3 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 4 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$2 = HEAPU8[($4 + 5 | 0) >> 0] | 0 | ((HEAPU8[($4 + 6 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 7 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 8 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $468 = i64toi32_i32$3;
           i64toi32_i32$3 = $0 + 9 | 0;
           $69 = $468;
           HEAP8[i64toi32_i32$3 >> 0] = $69;
           HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $69 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $69 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $69 >>> 24 | 0;
           HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$2;
           HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
           i64toi32_i32$1 = $6;
           i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$3 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $472 = i64toi32_i32$2;
           i64toi32_i32$2 = $0 + 17 | 0;
           $70 = $472;
           HEAP8[i64toi32_i32$2 >> 0] = $70;
           HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $70 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $70 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $70 >>> 24 | 0;
           HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$3;
           HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
           break label$1;
          }
          i64toi32_i32$1 = $4;
          i64toi32_i32$3 = HEAP32[($4 + 4 | 0) >> 2] | 0;
          i64toi32_i32$2 = HEAP32[($4 + 8 | 0) >> 2] | 0;
          $475 = i64toi32_i32$3;
          i64toi32_i32$3 = $4;
          HEAP32[($4 + 392 | 0) >> 2] = $475;
          HEAP32[($4 + 396 | 0) >> 2] = i64toi32_i32$2;
          core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $4 + 392 | 0 | 0, 1050188 | 0, 1051148 | 0);
          abort();
         }
         i64toi32_i32$1 = $4;
         i64toi32_i32$2 = HEAP32[($4 + 204 | 0) >> 2] | 0;
         i64toi32_i32$3 = HEAP32[($4 + 208 | 0) >> 2] | 0;
         $480 = i64toi32_i32$2;
         i64toi32_i32$2 = $4;
         HEAP32[($4 + 392 | 0) >> 2] = $480;
         HEAP32[($4 + 396 | 0) >> 2] = i64toi32_i32$3;
         core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $4 + 392 | 0 | 0, 1050188 | 0, 1051164 | 0);
         abort();
        }
        i64toi32_i32$1 = $4;
        i64toi32_i32$3 = HEAP32[($4 + 204 | 0) >> 2] | 0;
        i64toi32_i32$2 = HEAP32[($4 + 208 | 0) >> 2] | 0;
        $485 = i64toi32_i32$3;
        i64toi32_i32$3 = $4;
        HEAP32[($4 + 392 | 0) >> 2] = $485;
        HEAP32[($4 + 396 | 0) >> 2] = i64toi32_i32$2;
        core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $4 + 392 | 0 | 0, 1050188 | 0, 1051180 | 0);
        abort();
       }
       i64toi32_i32$1 = $4;
       i64toi32_i32$2 = HEAP32[($4 + 204 | 0) >> 2] | 0;
       i64toi32_i32$3 = HEAP32[($4 + 208 | 0) >> 2] | 0;
       $490 = i64toi32_i32$2;
       i64toi32_i32$2 = $4;
       HEAP32[($4 + 392 | 0) >> 2] = $490;
       HEAP32[($4 + 396 | 0) >> 2] = i64toi32_i32$3;
       core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $4 + 392 | 0 | 0, 1050188 | 0, 1051196 | 0);
       abort();
      }
      i64toi32_i32$1 = $4;
      i64toi32_i32$3 = HEAP32[($4 + 204 | 0) >> 2] | 0;
      i64toi32_i32$2 = HEAP32[($4 + 208 | 0) >> 2] | 0;
      $495 = i64toi32_i32$3;
      i64toi32_i32$3 = $4;
      HEAP32[($4 + 392 | 0) >> 2] = $495;
      HEAP32[($4 + 396 | 0) >> 2] = i64toi32_i32$2;
      core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $4 + 392 | 0 | 0, 1050188 | 0, 1051212 | 0);
      abort();
     }
     i64toi32_i32$1 = $4;
     i64toi32_i32$2 = HEAP32[($4 + 204 | 0) >> 2] | 0;
     i64toi32_i32$3 = HEAP32[($4 + 208 | 0) >> 2] | 0;
     $500 = i64toi32_i32$2;
     i64toi32_i32$2 = $4;
     HEAP32[($4 + 392 | 0) >> 2] = $500;
     HEAP32[($4 + 396 | 0) >> 2] = i64toi32_i32$3;
     core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $4 + 392 | 0 | 0, 1050188 | 0, 1051228 | 0);
     abort();
    }
    i64toi32_i32$1 = $4;
    i64toi32_i32$3 = HEAP32[($4 + 204 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($4 + 208 | 0) >> 2] | 0;
    $505 = i64toi32_i32$3;
    i64toi32_i32$3 = $4;
    HEAP32[($4 + 392 | 0) >> 2] = $505;
    HEAP32[($4 + 396 | 0) >> 2] = i64toi32_i32$2;
    core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $4 + 392 | 0 | 0, 1050188 | 0, 1051244 | 0);
    abort();
   }
   i64toi32_i32$1 = $4;
   i64toi32_i32$2 = HEAP32[($4 + 204 | 0) >> 2] | 0;
   i64toi32_i32$3 = HEAP32[($4 + 208 | 0) >> 2] | 0;
   $510 = i64toi32_i32$2;
   i64toi32_i32$2 = $4;
   HEAP32[($4 + 392 | 0) >> 2] = $510;
   HEAP32[($4 + 396 | 0) >> 2] = i64toi32_i32$3;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $4 + 392 | 0 | 0, 1050188 | 0, 1051260 | 0);
   abort();
  }
  global$0 = $4 + 592 | 0;
 }
 
 function $_mut_20serde_json__de__Deserializer_R__20as_20serde__de__Deserializer___deserialize_any__hd0def79dc4acfc54($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, i64toi32_i32$2 = 0, $4 = 0, $7 = 0, $8 = 0, $5 = 0, $6 = 0, $116 = 0, $119 = 0, $148 = 0, $155 = 0, $162 = 0, $165 = 0, $180 = 0, $187 = 0, $192 = 0, $235 = 0, $242 = 0, $245 = 0, $263 = 0, $267 = 0, $271 = 0, $329 = 0, $335 = 0, $339 = 0, $427 = 0, $430 = 0, $488 = 0, $494 = 0, $500 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 144 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     if ($3 >>> 0 >= $4 >>> 0) {
      break label$3
     }
     $5 = HEAP32[$1 >> 2] | 0;
     $6 = 1;
     label$4 : {
      label$5 : while (1) {
       $7 = HEAPU8[($5 + $3 | 0) >> 0] | 0;
       $8 = $7 + -9 | 0;
       if ($8 >>> 0 > 23 >>> 0) {
        break label$4
       }
       if (!((1 << $8 | 0) & 8388627 | 0)) {
        break label$4
       }
       $3 = $3 + 1 | 0;
       HEAP32[($1 + 8 | 0) >> 2] = $3;
       $6 = $3 >>> 0 < $4 >>> 0;
       if (($4 | 0) != ($3 | 0)) {
        continue label$5
       }
       break label$5;
      };
      $7 = 0;
      $3 = $4;
     }
     if ($6 & 1 | 0) {
      break label$2
     }
    }
    HEAP32[($2 + 80 | 0) >> 2] = 5;
    $3 = serde_json__de__Deserializer_R___peek_error__hf8794e102c1db2df($1 | 0, $2 + 80 | 0 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    HEAP32[($0 + 4 | 0) >> 2] = $3;
    break label$1;
   }
   label$6 : {
    label$7 : {
     label$8 : {
      label$9 : {
       label$10 : {
        label$11 : {
         label$12 : {
          label$13 : {
           label$14 : {
            label$15 : {
             label$16 : {
              label$17 : {
               label$18 : {
                label$19 : {
                 label$20 : {
                  if (($7 | 0) > (101 | 0)) {
                   break label$20
                  }
                  if (($7 | 0) == (34 | 0)) {
                   break label$16
                  }
                  if (($7 | 0) == (45 | 0)) {
                   break label$15
                  }
                  if (($7 | 0) != (91 | 0)) {
                   break label$19
                  }
                  $4 = (HEAPU8[($1 + 24 | 0) >> 0] | 0) + -1 | 0;
                  HEAP8[($1 + 24 | 0) >> 0] = $4;
                  if ($4 & 255 | 0) {
                   break label$17
                  }
                  HEAP32[($2 + 80 | 0) >> 2] = 21;
                  $3 = serde_json__de__Deserializer_R___peek_error__hf8794e102c1db2df($1 | 0, $2 + 80 | 0 | 0) | 0;
                  HEAP32[$0 >> 2] = 1;
                  HEAP32[($0 + 4 | 0) >> 2] = $3;
                  break label$1;
                 }
                 label$21 : {
                  if (($7 | 0) > (115 | 0)) {
                   break label$21
                  }
                  if (($7 | 0) == (102 | 0)) {
                   break label$14
                  }
                  if (($7 | 0) != (110 | 0)) {
                   break label$19
                  }
                  HEAP32[($1 + 8 | 0) >> 2] = $3 + 1 | 0;
                  $3 = serde_json__de__Deserializer_R___parse_ident__h2a4ea507f5458eed($1 | 0, 1087263 | 0, 3 | 0) | 0;
                  if ($3) {
                   break label$12
                  }
                  HEAP32[($2 + 16 | 0) >> 2] = 0;
                  HEAP8[($2 + 24 | 0) >> 0] = 0;
                  break label$6;
                 }
                 if (($7 | 0) == (116 | 0)) {
                  break label$13
                 }
                 if (($7 | 0) == (123 | 0)) {
                  break label$18
                 }
                }
                label$22 : {
                 if ((($7 + -48 | 0) & 255 | 0) >>> 0 < 10 >>> 0) {
                  break label$22
                 }
                 HEAP32[($2 + 80 | 0) >> 2] = 10;
                 (wasm2js_i32$0 = $2, wasm2js_i32$1 = serde_json__de__Deserializer_R___peek_error__hf8794e102c1db2df($1 | 0, $2 + 80 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 20 | 0) >> 2] = wasm2js_i32$1;
                 HEAP32[($2 + 16 | 0) >> 2] = 1;
                 break label$6;
                }
                serde_json__de__Deserializer_R___parse_integer__ha3f9b36c71394728($2 + 80 | 0 | 0, $1 | 0, 1 | 0);
                if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                 break label$11
                }
                i64toi32_i32$2 = $2 + 96 | 0;
                i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                $116 = i64toi32_i32$0;
                i64toi32_i32$0 = $2 + 56 | 0;
                HEAP32[i64toi32_i32$0 >> 2] = $116;
                HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
                i64toi32_i32$2 = $2;
                i64toi32_i32$1 = HEAP32[($2 + 88 | 0) >> 2] | 0;
                i64toi32_i32$0 = HEAP32[($2 + 92 | 0) >> 2] | 0;
                $119 = i64toi32_i32$1;
                i64toi32_i32$1 = $2;
                HEAP32[($2 + 48 | 0) >> 2] = $119;
                HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$0;
                serde_json__de__ParserNumber__visit__h941b1739d7b710bc($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
                break label$6;
               }
               $4 = (HEAPU8[($1 + 24 | 0) >> 0] | 0) + -1 | 0;
               HEAP8[($1 + 24 | 0) >> 0] = $4;
               if (!($4 & 255 | 0)) {
                break label$7
               }
               HEAP32[($1 + 8 | 0) >> 2] = $3 + 1 | 0;
               $serde_json__value__de___impl_20serde__de__Deserialize_20for_20serde_json__value__Value___deserialize__ValueVisitor_20as_20serde__de__Visitor___visit_map__hb4fe0106a753aa87($2 + 48 | 0 | 0, $1 | 0, 1 | 0);
               HEAP8[($1 + 24 | 0) >> 0] = (HEAPU8[($1 + 24 | 0) >> 0] | 0) + 1 | 0;
               i64toi32_i32$2 = ($2 + 48 | 0) + 24 | 0;
               i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
               i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
               $148 = i64toi32_i32$0;
               i64toi32_i32$0 = ($2 + 80 | 0) + 24 | 0;
               HEAP32[i64toi32_i32$0 >> 2] = $148;
               HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
               i64toi32_i32$2 = ($2 + 48 | 0) + 16 | 0;
               i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
               i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
               $155 = i64toi32_i32$1;
               i64toi32_i32$1 = ($2 + 80 | 0) + 16 | 0;
               HEAP32[i64toi32_i32$1 >> 2] = $155;
               HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
               i64toi32_i32$2 = ($2 + 48 | 0) + 8 | 0;
               i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
               i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
               $162 = i64toi32_i32$0;
               i64toi32_i32$0 = ($2 + 80 | 0) + 8 | 0;
               HEAP32[i64toi32_i32$0 >> 2] = $162;
               HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
               i64toi32_i32$2 = $2;
               i64toi32_i32$1 = HEAP32[($2 + 48 | 0) >> 2] | 0;
               i64toi32_i32$0 = HEAP32[($2 + 52 | 0) >> 2] | 0;
               $165 = i64toi32_i32$1;
               i64toi32_i32$1 = $2;
               HEAP32[($2 + 80 | 0) >> 2] = $165;
               HEAP32[($2 + 84 | 0) >> 2] = i64toi32_i32$0;
               $3 = serde_json__de__Deserializer_R___end_map__h445abe9350b38011($1 | 0) | 0;
               HEAP32[($2 + 112 | 0) >> 2] = $3;
               label$23 : {
                if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                 break label$23
                }
                label$24 : {
                 if ($3) {
                  break label$24
                 }
                 i64toi32_i32$2 = ($2 + 80 | 0) + 24 | 0;
                 i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                 i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                 $180 = i64toi32_i32$0;
                 i64toi32_i32$0 = ($2 + 16 | 0) + 24 | 0;
                 HEAP32[i64toi32_i32$0 >> 2] = $180;
                 HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
                 i64toi32_i32$2 = ($2 + 80 | 0) + 16 | 0;
                 i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                 i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                 $187 = i64toi32_i32$1;
                 i64toi32_i32$1 = ($2 + 16 | 0) + 16 | 0;
                 HEAP32[i64toi32_i32$1 >> 2] = $187;
                 HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                 HEAP32[($2 + 16 | 0) >> 2] = 0;
                 i64toi32_i32$2 = $2 + 88 | 0;
                 i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                 i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                 $192 = i64toi32_i32$0;
                 i64toi32_i32$0 = $2;
                 HEAP32[($2 + 24 | 0) >> 2] = $192;
                 HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$1;
                 break label$6;
                }
                HEAP32[($2 + 16 | 0) >> 2] = 1;
                HEAP32[($2 + 20 | 0) >> 2] = $3;
                core__ptr__drop_in_place_serde_json__value__Value___hb5131c85f9c77304($2 + 88 | 0 | 0);
                break label$6;
               }
               HEAP32[($2 + 20 | 0) >> 2] = HEAP32[($2 + 84 | 0) >> 2] | 0;
               HEAP32[($2 + 16 | 0) >> 2] = 1;
               if (!$3) {
                break label$6
               }
               core__ptr__drop_in_place_serde_json__error__Error___h2dc4889d765400ee($2 + 112 | 0 | 0);
               break label$6;
              }
              HEAP32[($1 + 8 | 0) >> 2] = $3 + 1 | 0;
              HEAP8[($2 + 124 | 0) >> 0] = 1;
              HEAP32[($2 + 120 | 0) >> 2] = $1;
              i64toi32_i32$0 = $2;
              i64toi32_i32$1 = 0;
              HEAP32[($2 + 132 | 0) >> 2] = 0;
              HEAP32[($2 + 136 | 0) >> 2] = i64toi32_i32$1;
              $3 = 0;
              $5 = HEAP32[(0 + 1084772 | 0) >> 2] | 0;
              HEAP32[($2 + 128 | 0) >> 2] = $5;
              $serde_json__de__SeqAccess_R__20as_20serde__de__SeqAccess___next_element_seed__h08dfb38d563d34fa($2 + 80 | 0 | 0, $2 + 120 | 0 | 0);
              label$25 : {
               label$26 : {
                label$27 : {
                 if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                  break label$27
                 }
                 $4 = ($2 + 80 | 0) + 8 | 0;
                 $3 = 0;
                 label$28 : while (1) {
                  if ((HEAPU8[($2 + 88 | 0) >> 0] | 0 | 0) == (6 | 0)) {
                   break label$26
                  }
                  $7 = ($2 + 48 | 0) + 16 | 0;
                  i64toi32_i32$2 = $4 + 16 | 0;
                  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                  $235 = i64toi32_i32$1;
                  i64toi32_i32$1 = $7;
                  HEAP32[i64toi32_i32$1 >> 2] = $235;
                  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                  $6 = ($2 + 48 | 0) + 8 | 0;
                  i64toi32_i32$2 = $4 + 8 | 0;
                  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                  $242 = i64toi32_i32$0;
                  i64toi32_i32$0 = $6;
                  HEAP32[i64toi32_i32$0 >> 2] = $242;
                  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
                  i64toi32_i32$2 = $4;
                  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                  $245 = i64toi32_i32$1;
                  i64toi32_i32$1 = $2;
                  HEAP32[($2 + 48 | 0) >> 2] = $245;
                  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$0;
                  label$29 : {
                   if ((HEAP32[($2 + 132 | 0) >> 2] | 0 | 0) != ($3 | 0)) {
                    break label$29
                   }
                   alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hf485cf9a98f32d97($2 + 128 | 0 | 0, $3 | 0, 1 | 0);
                   $5 = HEAP32[($2 + 128 | 0) >> 2] | 0;
                   $3 = HEAP32[($2 + 136 | 0) >> 2] | 0;
                  }
                  $8 = $5 + Math_imul($3, 24) | 0;
                  i64toi32_i32$2 = $2;
                  i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
                  i64toi32_i32$1 = HEAP32[($2 + 52 | 0) >> 2] | 0;
                  $263 = i64toi32_i32$0;
                  i64toi32_i32$0 = $8;
                  HEAP32[i64toi32_i32$0 >> 2] = $263;
                  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
                  i64toi32_i32$2 = $7;
                  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                  $267 = i64toi32_i32$1;
                  i64toi32_i32$1 = $8 + 16 | 0;
                  HEAP32[i64toi32_i32$1 >> 2] = $267;
                  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                  i64toi32_i32$2 = $6;
                  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                  $271 = i64toi32_i32$0;
                  i64toi32_i32$0 = $8 + 8 | 0;
                  HEAP32[i64toi32_i32$0 >> 2] = $271;
                  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
                  $3 = $3 + 1 | 0;
                  HEAP32[($2 + 136 | 0) >> 2] = $3;
                  $serde_json__de__SeqAccess_R__20as_20serde__de__SeqAccess___next_element_seed__h08dfb38d563d34fa($2 + 80 | 0 | 0, $2 + 120 | 0 | 0);
                  if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                   continue label$28
                  }
                  break label$28;
                 };
                 $3 = HEAP32[($2 + 132 | 0) >> 2] | 0;
                }
                $7 = HEAP32[($2 + 84 | 0) >> 2] | 0;
                $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h2d454d4f9b2e44f3($2 + 128 | 0 | 0);
                label$30 : {
                 if (!$3) {
                  break label$30
                 }
                 $3 = Math_imul($3, 24);
                 if (!$3) {
                  break label$30
                 }
                 __rust_dealloc($5 | 0, $3 | 0, 8 | 0);
                }
                $8 = 1;
                break label$25;
               }
               $6 = HEAP32[($2 + 132 | 0) >> 2] | 0;
               $8 = 0;
              }
              HEAP8[($1 + 24 | 0) >> 0] = (HEAPU8[($1 + 24 | 0) >> 0] | 0) + 1 | 0;
              $4 = serde_json__de__Deserializer_R___end_seq__hdf0197abf68bf866($1 | 0) | 0;
              HEAP32[($2 + 100 | 0) >> 2] = $3;
              HEAP32[($2 + 96 | 0) >> 2] = $6;
              HEAP32[($2 + 92 | 0) >> 2] = $5;
              $3 = $2 + 88 | 0;
              HEAP8[$3 >> 0] = 4;
              HEAP32[($2 + 112 | 0) >> 2] = $4;
              HEAP32[($2 + 84 | 0) >> 2] = $7;
              HEAP32[($2 + 80 | 0) >> 2] = $8;
              label$31 : {
               if ($8) {
                break label$31
               }
               label$32 : {
                if ($4) {
                 break label$32
                }
                i64toi32_i32$2 = $3 + 16 | 0;
                i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                $329 = i64toi32_i32$1;
                i64toi32_i32$1 = $2 + 40 | 0;
                HEAP32[i64toi32_i32$1 >> 2] = $329;
                HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                i64toi32_i32$2 = $3 + 8 | 0;
                i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                $335 = i64toi32_i32$0;
                i64toi32_i32$0 = ($2 + 16 | 0) + 16 | 0;
                HEAP32[i64toi32_i32$0 >> 2] = $335;
                HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
                HEAP32[($2 + 16 | 0) >> 2] = 0;
                i64toi32_i32$2 = $3;
                i64toi32_i32$1 = HEAP32[$3 >> 2] | 0;
                i64toi32_i32$0 = HEAP32[($3 + 4 | 0) >> 2] | 0;
                $339 = i64toi32_i32$1;
                i64toi32_i32$1 = $2;
                HEAP32[($2 + 24 | 0) >> 2] = $339;
                HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$0;
                break label$6;
               }
               HEAP32[($2 + 16 | 0) >> 2] = 1;
               HEAP32[($2 + 20 | 0) >> 2] = $4;
               core__ptr__drop_in_place_serde_json__value__Value___hb5131c85f9c77304($3 | 0);
               break label$6;
              }
              HEAP32[($2 + 16 | 0) >> 2] = 1;
              HEAP32[($2 + 20 | 0) >> 2] = $7;
              if (!$4) {
               break label$6
              }
              core__ptr__drop_in_place_serde_json__error__Error___h2dc4889d765400ee($2 + 112 | 0 | 0);
              break label$6;
             }
             HEAP32[($1 + 20 | 0) >> 2] = 0;
             HEAP32[($1 + 8 | 0) >> 2] = $3 + 1 | 0;
             $serde_json__read__StrRead_20as_20serde_json__read__Read___parse_str__h09f2a2399a6a37b5($2 + 80 | 0 | 0, $1 | 0, $1 + 12 | 0 | 0);
             if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
              break label$10
             }
             $3 = HEAP32[(($2 + 80 | 0) + 12 | 0) >> 2] | 0;
             $4 = HEAP32[($2 + 88 | 0) >> 2] | 0;
             label$33 : {
              if (HEAP32[($2 + 84 | 0) >> 2] | 0) {
               break label$33
              }
              alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, $3 | 0, 0 | 0);
              $8 = HEAP32[($2 + 4 | 0) >> 2] | 0;
              $4 = memcpy(HEAP32[$2 >> 2] | 0 | 0, $4 | 0, $3 | 0) | 0;
              HEAP32[($2 + 36 | 0) >> 2] = $3;
              HEAP32[($2 + 32 | 0) >> 2] = $8;
              HEAP32[($2 + 28 | 0) >> 2] = $4;
              HEAP8[($2 + 24 | 0) >> 0] = 3;
              HEAP32[($2 + 16 | 0) >> 2] = 0;
              break label$6;
             }
             alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 + 8 | 0 | 0, $3 | 0, 0 | 0);
             $8 = HEAP32[($2 + 12 | 0) >> 2] | 0;
             $4 = memcpy(HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, $4 | 0, $3 | 0) | 0;
             HEAP32[($2 + 36 | 0) >> 2] = $3;
             HEAP32[($2 + 32 | 0) >> 2] = $8;
             HEAP32[($2 + 28 | 0) >> 2] = $4;
             HEAP8[($2 + 24 | 0) >> 0] = 3;
             HEAP32[($2 + 16 | 0) >> 2] = 0;
             break label$6;
            }
            HEAP32[($1 + 8 | 0) >> 2] = $3 + 1 | 0;
            serde_json__de__Deserializer_R___parse_integer__ha3f9b36c71394728($2 + 80 | 0 | 0, $1 | 0, 0 | 0);
            label$34 : {
             if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
              break label$34
             }
             i64toi32_i32$2 = $2 + 96 | 0;
             i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
             i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
             $427 = i64toi32_i32$0;
             i64toi32_i32$0 = $2 + 56 | 0;
             HEAP32[i64toi32_i32$0 >> 2] = $427;
             HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
             i64toi32_i32$2 = $2;
             i64toi32_i32$1 = HEAP32[($2 + 88 | 0) >> 2] | 0;
             i64toi32_i32$0 = HEAP32[($2 + 92 | 0) >> 2] | 0;
             $430 = i64toi32_i32$1;
             i64toi32_i32$1 = $2;
             HEAP32[($2 + 48 | 0) >> 2] = $430;
             HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$0;
             serde_json__de__ParserNumber__visit__h941b1739d7b710bc($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
             break label$6;
            }
            HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($2 + 84 | 0) >> 2] | 0;
            HEAP32[$0 >> 2] = 1;
            break label$1;
           }
           HEAP32[($1 + 8 | 0) >> 2] = $3 + 1 | 0;
           $3 = serde_json__de__Deserializer_R___parse_ident__h2a4ea507f5458eed($1 | 0, 1087256 | 0, 4 | 0) | 0;
           if (!$3) {
            break label$8
           }
           HEAP32[$0 >> 2] = 1;
           HEAP32[($0 + 4 | 0) >> 2] = $3;
           break label$1;
          }
          HEAP32[($1 + 8 | 0) >> 2] = $3 + 1 | 0;
          $3 = serde_json__de__Deserializer_R___parse_ident__h2a4ea507f5458eed($1 | 0, 1087260 | 0, 3 | 0) | 0;
          if (!$3) {
           break label$9
          }
          HEAP32[$0 >> 2] = 1;
          HEAP32[($0 + 4 | 0) >> 2] = $3;
          break label$1;
         }
         HEAP32[$0 >> 2] = 1;
         HEAP32[($0 + 4 | 0) >> 2] = $3;
         break label$1;
        }
        HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($2 + 84 | 0) >> 2] | 0;
        HEAP32[$0 >> 2] = 1;
        break label$1;
       }
       HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($2 + 84 | 0) >> 2] | 0;
       HEAP32[$0 >> 2] = 1;
       break label$1;
      }
      HEAP16[($2 + 24 | 0) >> 1] = 257;
      HEAP32[($2 + 16 | 0) >> 2] = 0;
      break label$6;
     }
     HEAP16[($2 + 24 | 0) >> 1] = 1;
     HEAP32[($2 + 16 | 0) >> 2] = 0;
     break label$6;
    }
    HEAP32[($2 + 80 | 0) >> 2] = 21;
    $3 = serde_json__de__Deserializer_R___peek_error__hf8794e102c1db2df($1 | 0, $2 + 80 | 0 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    HEAP32[($0 + 4 | 0) >> 2] = $3;
    break label$1;
   }
   $3 = 1;
   label$35 : {
    label$36 : {
     if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$36
     }
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[($2 + 24 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 28 | 0) >> 2] | 0;
     $488 = i64toi32_i32$0;
     i64toi32_i32$0 = $0 + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $488;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = ($2 + 16 | 0) + 24 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $494 = i64toi32_i32$1;
     i64toi32_i32$1 = $0 + 24 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $494;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = ($2 + 16 | 0) + 16 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $500 = i64toi32_i32$0;
     i64toi32_i32$0 = $0 + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $500;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     $3 = 0;
     break label$35;
    }
    (wasm2js_i32$0 = $0, wasm2js_i32$1 = serde_json__error__Error__fix_position__hf643fce3239fdaa8(HEAP32[($2 + 20 | 0) >> 2] | 0 | 0, $1 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
   }
   HEAP32[$0 >> 2] = $3;
  }
  global$0 = $2 + 144 | 0;
 }
 
 function $cardano_serialization_lib__plutus__Redeemer_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h50e886ac76690234($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$2 = 0, $2 = 0, i64toi32_i32$1 = 0, $4 = 0, $7 = 0, $7$hi = 0, i64toi32_i32$4 = 0, $6 = 0, $8 = 0, $6$hi = 0, $8$hi = 0, $10 = 0, $9 = 0, $9$hi = 0, $10$hi = 0, $3 = 0, $11 = 0, $11$hi = 0, $5 = 0, $63 = 0, $64 = 0, $65 = 0, $12 = 0, $13 = 0, $86 = 0, $99 = 0, $105 = 0, $165 = 0, $172 = 0, $177 = 0, $229 = 0, $229$hi = 0, $232 = 0, $232$hi = 0, $236$hi = 0, $238$hi = 0, $240$hi = 0, $243 = 0, $243$hi = 0, $281 = 0, $287 = 0, $291 = 0, $12$hi = 0, $13$hi = 0, $14 = 0, $14$hi = 0, $370 = 0, $376 = 0, $380 = 0, $404 = 0, $410 = 0, $414 = 0, $465 = 0, $473 = 0, $506 = 0, $518 = 0, $524 = 0, $529 = 0, $529$hi = 0, $531 = 0, $531$hi = 0, $532 = 0;
  $2 = global$0 - 432 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 360 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = ($2 + 360 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $6 = i64toi32_i32$0;
  $6$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 368 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 372 | 0) >> 2] | 0;
  $7 = i64toi32_i32$1;
  $7$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 360 | 0) >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 364 | 0) >> 2] | 0;
         i64toi32_i32$2 = i64toi32_i32$0;
         i64toi32_i32$0 = 0;
         i64toi32_i32$3 = 1;
         if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
          break label$7
         }
         label$8 : {
          i64toi32_i32$2 = $7$hi;
          i64toi32_i32$3 = $7;
          i64toi32_i32$1 = 0;
          i64toi32_i32$0 = 1;
          if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
           break label$8
          }
          i64toi32_i32$3 = $6$hi;
          i64toi32_i32$0 = $6;
          i64toi32_i32$2 = 0;
          i64toi32_i32$1 = 4;
          if (i64toi32_i32$3 >>> 0 > i64toi32_i32$2 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$0 >>> 0 >= i64toi32_i32$1 >>> 0 | 0) | 0) {
           break label$8
          }
          $3 = 0;
          i64toi32_i32$0 = 0;
          $8 = 3;
          $8$hi = i64toi32_i32$0;
          i64toi32_i32$0 = 0;
          $9 = 0;
          $9$hi = i64toi32_i32$0;
          i64toi32_i32$0 = $6$hi;
          $7 = $6;
          $7$hi = i64toi32_i32$0;
          i64toi32_i32$0 = 0;
          $10 = 0;
          $10$hi = i64toi32_i32$0;
          break label$6;
         }
         $cardano_serialization_lib__plutus__RedeemerTagKind_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h284028eaa4294bff($2 + 360 | 0 | 0, $1 | 0);
         label$9 : {
          label$10 : {
           label$11 : {
            if ((HEAPU8[($2 + 360 | 0) >> 0] | 0 | 0) == (1 | 0)) {
             break label$11
            }
            $3 = HEAPU8[($2 + 361 | 0) >> 0] | 0;
            $cardano_serialization_lib__utils__BigNum_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h29637bb571dceb02($2 + 360 | 0 | 0, $1 | 0);
            i64toi32_i32$1 = $2;
            i64toi32_i32$0 = HEAP32[($2 + 368 | 0) >> 2] | 0;
            i64toi32_i32$3 = HEAP32[($2 + 372 | 0) >> 2] | 0;
            $6 = i64toi32_i32$0;
            $6$hi = i64toi32_i32$3;
            i64toi32_i32$1 = $2;
            i64toi32_i32$3 = HEAP32[($2 + 360 | 0) >> 2] | 0;
            i64toi32_i32$0 = HEAP32[($2 + 364 | 0) >> 2] | 0;
            i64toi32_i32$1 = i64toi32_i32$3;
            i64toi32_i32$3 = 0;
            i64toi32_i32$2 = 1;
            if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) | 0) {
             break label$5
            }
            $cardano_serialization_lib__plutus__PlutusData_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__haa2b047fc7012f29($2 + 360 | 0 | 0, $1 | 0);
            $4 = ($2 + 360 | 0) + 8 | 0;
            i64toi32_i32$2 = $2;
            i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 360 | 0) >> 2] | 0;
            i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 364 | 0) >> 2] | 0;
            i64toi32_i32$2 = i64toi32_i32$1;
            i64toi32_i32$1 = 0;
            i64toi32_i32$3 = 1;
            if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
             break label$4
            }
            memcpy($2 + 288 | 0 | 0, $4 | 0, 48 | 0) | 0;
            memcpy($2 + 8 | 0 | 0, memcpy(($2 + 72 | 0) + 8 | 0 | 0, $2 + 288 | 0 | 0, 48 | 0) | 0 | 0, 48 | 0) | 0;
            i64toi32_i32$3 = $2 + 48 | 0;
            i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
            i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
            $8 = i64toi32_i32$2;
            $8$hi = i64toi32_i32$0;
            i64toi32_i32$2 = ($2 + 144 | 0) + 16 | 0;
            HEAP32[i64toi32_i32$2 >> 2] = $8;
            HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
            $4 = ($2 + 216 | 0) + 16 | 0;
            i64toi32_i32$3 = $2 + 24 | 0;
            i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
            i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
            $86 = i64toi32_i32$0;
            i64toi32_i32$0 = $4;
            HEAP32[i64toi32_i32$0 >> 2] = $86;
            HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
            i64toi32_i32$3 = $2 + 16 | 0;
            i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
            i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
            $10 = i64toi32_i32$2;
            $10$hi = i64toi32_i32$0;
            i64toi32_i32$2 = ($2 + 216 | 0) + 8 | 0;
            HEAP32[i64toi32_i32$2 >> 2] = $10;
            HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
            i64toi32_i32$3 = $2 + 32 | 0;
            i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
            i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
            $99 = i64toi32_i32$0;
            i64toi32_i32$0 = ($2 + 216 | 0) + 24 | 0;
            HEAP32[i64toi32_i32$0 >> 2] = $99;
            HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
            i64toi32_i32$3 = $2 + 40 | 0;
            i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
            i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
            $105 = i64toi32_i32$2;
            i64toi32_i32$2 = ($2 + 216 | 0) + 32 | 0;
            HEAP32[i64toi32_i32$2 >> 2] = $105;
            HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
            i64toi32_i32$0 = $8$hi;
            i64toi32_i32$2 = ($2 + 216 | 0) + 40 | 0;
            HEAP32[i64toi32_i32$2 >> 2] = $8;
            HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
            i64toi32_i32$3 = $2;
            i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 8 | 0) >> 2] | 0;
            i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 12 | 0) >> 2] | 0;
            $11 = i64toi32_i32$0;
            $11$hi = i64toi32_i32$2;
            i64toi32_i32$0 = i64toi32_i32$3;
            HEAP32[(i64toi32_i32$0 + 216 | 0) >> 2] = $11;
            HEAP32[(i64toi32_i32$0 + 220 | 0) >> 2] = i64toi32_i32$2;
            $cardano_serialization_lib__plutus__ExUnits_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h32fa18bd273d182d(i64toi32_i32$0 + 360 | 0 | 0, $1 | 0);
            $5 = (i64toi32_i32$0 + 360 | 0) + 16 | 0;
            i64toi32_i32$3 = $5;
            i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
            i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
            $8 = i64toi32_i32$2;
            $8$hi = i64toi32_i32$0;
            i64toi32_i32$3 = $2;
            i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 368 | 0) >> 2] | 0;
            i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 372 | 0) >> 2] | 0;
            $9 = i64toi32_i32$0;
            $9$hi = i64toi32_i32$2;
            label$12 : {
             label$13 : {
              label$14 : {
               i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 360 | 0) >> 2] | 0;
               i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 364 | 0) >> 2] | 0;
               i64toi32_i32$3 = i64toi32_i32$2;
               i64toi32_i32$2 = 0;
               i64toi32_i32$1 = 1;
               if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) | 0) {
                break label$14
               }
               i64toi32_i32$3 = $7$hi;
               i64toi32_i32$1 = $7;
               i64toi32_i32$0 = 0;
               i64toi32_i32$2 = 1;
               if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) | 0) {
                break label$9
               }
               cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 360 | 0 | 0, $1 | 0);
               $1 = HEAPU8[($2 + 368 | 0) >> 0] | 0;
               i64toi32_i32$2 = $2;
               i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 360 | 0) >> 2] | 0;
               i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 364 | 0) >> 2] | 0;
               i64toi32_i32$2 = i64toi32_i32$1;
               i64toi32_i32$1 = 0;
               i64toi32_i32$0 = 1;
               if ((i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) | 0) {
                break label$13
               }
               if (($1 & 255 | 0 | 0) == (5 | 0)) {
                break label$10
               }
               i64toi32_i32$2 = 0;
               $8 = 5;
               $8$hi = i64toi32_i32$2;
               break label$12;
              }
              $4 = memcpy($2 | 0, ($2 + 360 | 0) + 24 | 0 | 0, 48 | 0) | 0;
              i64toi32_i32$2 = $8$hi;
              i64toi32_i32$3 = ($4 + 360 | 0) + 8 | 0;
              HEAP32[i64toi32_i32$3 >> 2] = $8;
              HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
              i64toi32_i32$2 = $9$hi;
              i64toi32_i32$3 = $4;
              HEAP32[(i64toi32_i32$3 + 360 | 0) >> 2] = $9;
              HEAP32[(i64toi32_i32$3 + 364 | 0) >> 2] = i64toi32_i32$2;
              memcpy($5 | 0, i64toi32_i32$3 | 0, 48 | 0) | 0;
              cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e((i64toi32_i32$3 + 72 | 0) + 8 | 0 | 0, i64toi32_i32$3 + 360 | 0 | 0, 1071218 | 0, 8 | 0);
              i64toi32_i32$0 = (i64toi32_i32$3 + 72 | 0) + 40 | 0;
              i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
              i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
              $165 = i64toi32_i32$2;
              i64toi32_i32$2 = ($4 + 288 | 0) + 8 | 0;
              HEAP32[i64toi32_i32$2 >> 2] = $165;
              HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
              i64toi32_i32$0 = ($4 + 72 | 0) + 48 | 0;
              i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
              i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
              $172 = i64toi32_i32$3;
              i64toi32_i32$3 = ($4 + 288 | 0) + 16 | 0;
              HEAP32[i64toi32_i32$3 >> 2] = $172;
              HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
              i64toi32_i32$0 = ($4 + 72 | 0) + 32 | 0;
              i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
              i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
              $177 = i64toi32_i32$2;
              i64toi32_i32$2 = $4;
              HEAP32[(i64toi32_i32$2 + 288 | 0) >> 2] = $177;
              HEAP32[(i64toi32_i32$2 + 292 | 0) >> 2] = i64toi32_i32$3;
              i64toi32_i32$0 = i64toi32_i32$2;
              i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 80 | 0) >> 2] | 0;
              i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 84 | 0) >> 2] | 0;
              $8 = i64toi32_i32$3;
              $8$hi = i64toi32_i32$2;
              i64toi32_i32$0 = i64toi32_i32$3;
              i64toi32_i32$3 = -1;
              i64toi32_i32$1 = -256;
              i64toi32_i32$3 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
              $10 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
              $10$hi = i64toi32_i32$3;
              i64toi32_i32$2 = ($4 + 72 | 0) + 16 | 0;
              i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
              i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
              $7 = i64toi32_i32$3;
              $7$hi = i64toi32_i32$0;
              i64toi32_i32$2 = ($4 + 72 | 0) + 24 | 0;
              i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
              i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
              $9 = i64toi32_i32$0;
              $9$hi = i64toi32_i32$3;
              $3 = HEAP32[($4 + 128 | 0) >> 2] | 0;
              $1 = HEAP32[($4 + 132 | 0) >> 2] | 0;
              i64toi32_i32$2 = $4 + 136 | 0;
              i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
              i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
              $6 = i64toi32_i32$3;
              $6$hi = i64toi32_i32$0;
              break label$3;
             }
             i64toi32_i32$2 = $2 + 392 | 0;
             i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
             i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
             $7 = i64toi32_i32$0;
             $7$hi = i64toi32_i32$3;
             i64toi32_i32$0 = ($2 + 72 | 0) + 8 | 0;
             HEAP32[i64toi32_i32$0 >> 2] = $7;
             HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
             i64toi32_i32$2 = $2 + 400 | 0;
             i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
             i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
             $6 = i64toi32_i32$3;
             $6$hi = i64toi32_i32$0;
             i64toi32_i32$3 = ($2 + 72 | 0) + 16 | 0;
             HEAP32[i64toi32_i32$3 >> 2] = $6;
             HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
             i64toi32_i32$0 = $7$hi;
             i64toi32_i32$3 = ($2 + 288 | 0) + 8 | 0;
             HEAP32[i64toi32_i32$3 >> 2] = $7;
             HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
             i64toi32_i32$0 = $6$hi;
             i64toi32_i32$3 = ($2 + 288 | 0) + 16 | 0;
             HEAP32[i64toi32_i32$3 >> 2] = $6;
             HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
             i64toi32_i32$2 = $2 + 384 | 0;
             i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
             i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
             $7 = i64toi32_i32$0;
             $7$hi = i64toi32_i32$3;
             i64toi32_i32$0 = $2;
             HEAP32[(i64toi32_i32$0 + 72 | 0) >> 2] = $7;
             HEAP32[(i64toi32_i32$0 + 76 | 0) >> 2] = i64toi32_i32$3;
             HEAP32[(i64toi32_i32$0 + 288 | 0) >> 2] = $7;
             HEAP32[(i64toi32_i32$0 + 292 | 0) >> 2] = i64toi32_i32$3;
             i64toi32_i32$2 = i64toi32_i32$0;
             i64toi32_i32$3 = HEAPU8[(i64toi32_i32$0 + 369 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 370 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 371 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 372 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             i64toi32_i32$0 = 0;
             $229 = i64toi32_i32$3;
             $229$hi = i64toi32_i32$0;
             i64toi32_i32$2 = i64toi32_i32$2 + 373 | 0;
             i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
             i64toi32_i32$3 = 0;
             $232 = i64toi32_i32$0;
             $232$hi = i64toi32_i32$3;
             i64toi32_i32$2 = $2 + 375 | 0;
             i64toi32_i32$3 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
             i64toi32_i32$0 = 0;
             i64toi32_i32$2 = i64toi32_i32$3;
             i64toi32_i32$3 = 0;
             i64toi32_i32$1 = 16;
             i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
             if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
              i64toi32_i32$3 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
              $63 = 0;
             } else {
              i64toi32_i32$3 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
              $63 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
             }
             $236$hi = i64toi32_i32$3;
             i64toi32_i32$3 = $232$hi;
             i64toi32_i32$0 = $232;
             i64toi32_i32$2 = $236$hi;
             i64toi32_i32$1 = $63;
             i64toi32_i32$2 = i64toi32_i32$3 | i64toi32_i32$2 | 0;
             i64toi32_i32$3 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
             i64toi32_i32$0 = 0;
             i64toi32_i32$1 = 32;
             i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
             if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
              i64toi32_i32$0 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
              $64 = 0;
             } else {
              i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
              $64 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
             }
             $238$hi = i64toi32_i32$0;
             i64toi32_i32$0 = $229$hi;
             i64toi32_i32$2 = $229;
             i64toi32_i32$3 = $238$hi;
             i64toi32_i32$1 = $64;
             i64toi32_i32$3 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
             i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
             i64toi32_i32$2 = 0;
             i64toi32_i32$1 = 8;
             i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
             if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
              i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
              $65 = 0;
             } else {
              i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$4 | 0) | 0;
              $65 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
             }
             $240$hi = i64toi32_i32$2;
             i64toi32_i32$2 = 0;
             i64toi32_i32$3 = $1;
             i64toi32_i32$0 = 0;
             i64toi32_i32$1 = 255;
             i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
             $243 = i64toi32_i32$3 & i64toi32_i32$1 | 0;
             $243$hi = i64toi32_i32$0;
             i64toi32_i32$0 = $240$hi;
             i64toi32_i32$2 = $65;
             i64toi32_i32$3 = $243$hi;
             i64toi32_i32$1 = $243;
             i64toi32_i32$3 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
             $7 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
             $7$hi = i64toi32_i32$3;
             i64toi32_i32$0 = ($2 + 360 | 0) + 16 | 0;
             i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
             i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
             $9 = i64toi32_i32$3;
             $9$hi = i64toi32_i32$2;
             i64toi32_i32$2 = 0;
             $8 = 2;
             $8$hi = i64toi32_i32$2;
            }
            $3 = 0;
            i64toi32_i32$2 = 0;
            $10 = 0;
            $10$hi = i64toi32_i32$2;
            break label$3;
           }
           memcpy($2 + 360 | 0 | 0, memcpy(($2 + 72 | 0) + 8 | 0 | 0, memcpy(($2 + 144 | 0) + 6 | 0 | 0, memcpy(($2 + 216 | 0) + 6 | 0 | 0, memcpy(($2 + 288 | 0) + 6 | 0 | 0, ($2 + 360 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
           $1 = $2 + 8 | 0;
           cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $2 + 360 | 0 | 0, 1071206 | 0, 3 | 0);
           i64toi32_i32$0 = $2 + 40 | 0;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $281 = i64toi32_i32$2;
           i64toi32_i32$2 = ($2 + 288 | 0) + 8 | 0;
           HEAP32[i64toi32_i32$2 >> 2] = $281;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
           i64toi32_i32$0 = $2 + 48 | 0;
           i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $287 = i64toi32_i32$3;
           i64toi32_i32$3 = ($2 + 288 | 0) + 16 | 0;
           HEAP32[i64toi32_i32$3 >> 2] = $287;
           HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
           i64toi32_i32$0 = $2 + 32 | 0;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $291 = i64toi32_i32$2;
           i64toi32_i32$2 = $2;
           HEAP32[(i64toi32_i32$2 + 288 | 0) >> 2] = $291;
           HEAP32[(i64toi32_i32$2 + 292 | 0) >> 2] = i64toi32_i32$3;
           i64toi32_i32$0 = $1;
           i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $8 = i64toi32_i32$3;
           $8$hi = i64toi32_i32$2;
           i64toi32_i32$0 = i64toi32_i32$3;
           i64toi32_i32$3 = -1;
           i64toi32_i32$1 = -256;
           i64toi32_i32$3 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
           $10 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
           $10$hi = i64toi32_i32$3;
           i64toi32_i32$2 = $2 + 16 | 0;
           i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
           $7 = i64toi32_i32$3;
           $7$hi = i64toi32_i32$0;
           i64toi32_i32$2 = $2 + 24 | 0;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
           i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
           $9 = i64toi32_i32$0;
           $9$hi = i64toi32_i32$3;
           $3 = HEAP32[($2 + 56 | 0) >> 2] | 0;
           $1 = HEAP32[($2 + 60 | 0) >> 2] | 0;
           i64toi32_i32$2 = $2 + 64 | 0;
           i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
           $6 = i64toi32_i32$3;
           $6$hi = i64toi32_i32$0;
           break label$2;
          }
          i64toi32_i32$2 = $2;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 224 | 0) >> 2] | 0;
          i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 228 | 0) >> 2] | 0;
          $10 = i64toi32_i32$0;
          $10$hi = i64toi32_i32$3;
          i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 216 | 0) >> 2] | 0;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 220 | 0) >> 2] | 0;
          $11 = i64toi32_i32$3;
          $11$hi = i64toi32_i32$0;
         }
         i64toi32_i32$2 = $4 + 16 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $7 = i64toi32_i32$0;
         $7$hi = i64toi32_i32$3;
         i64toi32_i32$0 = ($2 + 288 | 0) + 16 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $7;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
         i64toi32_i32$2 = $4 + 8 | 0;
         i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $12 = i64toi32_i32$3;
         $12$hi = i64toi32_i32$0;
         i64toi32_i32$3 = ($2 + 288 | 0) + 8 | 0;
         HEAP32[i64toi32_i32$3 >> 2] = $12;
         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$2 = $4;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $13 = i64toi32_i32$0;
         $13$hi = i64toi32_i32$3;
         i64toi32_i32$0 = $2;
         HEAP32[(i64toi32_i32$0 + 288 | 0) >> 2] = $13;
         HEAP32[(i64toi32_i32$0 + 292 | 0) >> 2] = i64toi32_i32$3;
         i64toi32_i32$2 = (i64toi32_i32$0 + 216 | 0) + 40 | 0;
         i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $14 = i64toi32_i32$3;
         $14$hi = i64toi32_i32$0;
         i64toi32_i32$0 = $10$hi;
         i64toi32_i32$3 = $0 + 24 | 0;
         HEAP32[i64toi32_i32$3 >> 2] = $10;
         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$0 = $11$hi;
         i64toi32_i32$3 = $0 + 16 | 0;
         HEAP32[i64toi32_i32$3 >> 2] = $11;
         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$0 = $6$hi;
         i64toi32_i32$3 = $0;
         HEAP32[(i64toi32_i32$3 + 8 | 0) >> 2] = $6;
         HEAP32[(i64toi32_i32$3 + 12 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$0 = $13$hi;
         i64toi32_i32$3 = i64toi32_i32$3 + 32 | 0;
         HEAP32[i64toi32_i32$3 >> 2] = $13;
         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$0 = $12$hi;
         i64toi32_i32$3 = $0 + 40 | 0;
         HEAP32[i64toi32_i32$3 >> 2] = $12;
         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$0 = $7$hi;
         i64toi32_i32$3 = $0 + 48 | 0;
         HEAP32[i64toi32_i32$3 >> 2] = $7;
         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
         HEAP8[($0 + 80 | 0) >> 0] = $3;
         i64toi32_i32$0 = $8$hi;
         i64toi32_i32$3 = $0 + 72 | 0;
         HEAP32[i64toi32_i32$3 >> 2] = $8;
         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$0 = $9$hi;
         i64toi32_i32$3 = $0 + 64 | 0;
         HEAP32[i64toi32_i32$3 >> 2] = $9;
         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$0 = $14$hi;
         i64toi32_i32$3 = $0 + 56 | 0;
         HEAP32[i64toi32_i32$3 >> 2] = $14;
         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$0 = 0;
         $7 = 0;
         $7$hi = i64toi32_i32$0;
         break label$1;
        }
        i64toi32_i32$2 = $2 + 392 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $370 = i64toi32_i32$0;
        i64toi32_i32$0 = $2 + 296 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $370;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
        i64toi32_i32$2 = $2 + 400 | 0;
        i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $376 = i64toi32_i32$3;
        i64toi32_i32$3 = ($2 + 288 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$3 >> 2] = $376;
        HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = $2 + 384 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $380 = i64toi32_i32$0;
        i64toi32_i32$0 = $2;
        HEAP32[(i64toi32_i32$0 + 288 | 0) >> 2] = $380;
        HEAP32[(i64toi32_i32$0 + 292 | 0) >> 2] = i64toi32_i32$3;
        $3 = 0;
        i64toi32_i32$3 = 0;
        $8 = 2;
        $8$hi = i64toi32_i32$3;
        i64toi32_i32$3 = 0;
        $10 = 0;
        $10$hi = i64toi32_i32$3;
        i64toi32_i32$3 = $6$hi;
        $9 = $6;
        $9$hi = i64toi32_i32$3;
       }
       break label$2;
      }
      $4 = memcpy($2 | 0, ($2 + 360 | 0) + 16 | 0 | 0, 56 | 0) | 0;
      i64toi32_i32$3 = $6$hi;
      i64toi32_i32$0 = $4;
      HEAP32[(i64toi32_i32$0 + 360 | 0) >> 2] = $6;
      HEAP32[(i64toi32_i32$0 + 364 | 0) >> 2] = i64toi32_i32$3;
      memcpy((i64toi32_i32$0 + 360 | 0) + 8 | 0 | 0, i64toi32_i32$0 | 0, 56 | 0) | 0;
      cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e((i64toi32_i32$0 + 72 | 0) + 8 | 0 | 0, i64toi32_i32$0 + 360 | 0 | 0, 1071209 | 0, 5 | 0);
      i64toi32_i32$2 = i64toi32_i32$0 + 112 | 0;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $404 = i64toi32_i32$3;
      i64toi32_i32$3 = ($4 + 288 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$3 >> 2] = $404;
      HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $4 + 120 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $410 = i64toi32_i32$0;
      i64toi32_i32$0 = ($4 + 288 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $410;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
      i64toi32_i32$2 = $4 + 104 | 0;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $414 = i64toi32_i32$3;
      i64toi32_i32$3 = $4;
      HEAP32[(i64toi32_i32$3 + 288 | 0) >> 2] = $414;
      HEAP32[(i64toi32_i32$3 + 292 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = i64toi32_i32$3;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 80 | 0) >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$3 + 84 | 0) >> 2] | 0;
      $8 = i64toi32_i32$0;
      $8$hi = i64toi32_i32$3;
      i64toi32_i32$2 = i64toi32_i32$0;
      i64toi32_i32$0 = -1;
      i64toi32_i32$1 = -256;
      i64toi32_i32$0 = i64toi32_i32$3 & i64toi32_i32$0 | 0;
      $10 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
      $10$hi = i64toi32_i32$0;
      i64toi32_i32$3 = ($4 + 72 | 0) + 16 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $7 = i64toi32_i32$0;
      $7$hi = i64toi32_i32$2;
      i64toi32_i32$3 = $4 + 96 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $9 = i64toi32_i32$2;
      $9$hi = i64toi32_i32$0;
      $3 = HEAP32[(($4 + 72 | 0) + 56 | 0) >> 2] | 0;
      $1 = HEAP32[($4 + 132 | 0) >> 2] | 0;
      i64toi32_i32$3 = $4 + 136 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $6 = i64toi32_i32$0;
      $6$hi = i64toi32_i32$2;
      break label$2;
     }
     memcpy($2 + 288 | 0 | 0, $4 | 0, 64 | 0) | 0;
     memcpy($2 + 360 | 0 | 0, memcpy(($2 + 72 | 0) + 8 | 0 | 0, $2 + 288 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($2 + 8 | 0 | 0, $2 + 360 | 0 | 0, 1071214 | 0, 4 | 0);
     i64toi32_i32$3 = $2 + 48 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $7 = i64toi32_i32$2;
     $7$hi = i64toi32_i32$0;
     i64toi32_i32$2 = ($2 + 144 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $7;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$3 = $2 + 40 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $465 = i64toi32_i32$0;
     i64toi32_i32$0 = ($2 + 288 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $465;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$0 = ($2 + 288 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $7;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$3 = $2 + 32 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $473 = i64toi32_i32$2;
     i64toi32_i32$2 = $2;
     HEAP32[(i64toi32_i32$2 + 288 | 0) >> 2] = $473;
     HEAP32[(i64toi32_i32$2 + 292 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$3 = i64toi32_i32$2;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 8 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 12 | 0) >> 2] | 0;
     $8 = i64toi32_i32$0;
     $8$hi = i64toi32_i32$2;
     i64toi32_i32$3 = i64toi32_i32$0;
     i64toi32_i32$0 = -1;
     i64toi32_i32$1 = -256;
     i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
     $10 = i64toi32_i32$3 & i64toi32_i32$1 | 0;
     $10$hi = i64toi32_i32$0;
     i64toi32_i32$2 = $2 + 16 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $7 = i64toi32_i32$0;
     $7$hi = i64toi32_i32$3;
     i64toi32_i32$2 = $2 + 24 | 0;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $9 = i64toi32_i32$3;
     $9$hi = i64toi32_i32$0;
     $3 = HEAP32[($2 + 56 | 0) >> 2] | 0;
     $1 = HEAP32[($2 + 60 | 0) >> 2] | 0;
     i64toi32_i32$2 = $2 + 64 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $6 = i64toi32_i32$0;
     $6$hi = i64toi32_i32$3;
     break label$2;
    }
    core__ptr__drop_in_place_cardano_serialization_lib__plutus__PlutusData___hfab843e66e0f9428_1($2 + 216 | 0 | 0);
   }
   i64toi32_i32$3 = $9$hi;
   i64toi32_i32$0 = ($2 + 360 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $9;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$3 = $7$hi;
   i64toi32_i32$0 = ($2 + 360 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $7;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$2 = $2;
   i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 288 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 292 | 0) >> 2] | 0;
   $506 = i64toi32_i32$3;
   i64toi32_i32$3 = i64toi32_i32$2 + 384 | 0;
   HEAP32[i64toi32_i32$3 >> 2] = $506;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $6$hi;
   i64toi32_i32$3 = i64toi32_i32$2 + 416 | 0;
   HEAP32[i64toi32_i32$3 >> 2] = $6;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[(i64toi32_i32$2 + 412 | 0) >> 2] = $1;
   i64toi32_i32$2 = (i64toi32_i32$2 + 288 | 0) + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $518 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 392 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $518;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$2 = ($2 + 288 | 0) + 16 | 0;
   i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $524 = i64toi32_i32$3;
   i64toi32_i32$3 = $2 + 400 | 0;
   HEAP32[i64toi32_i32$3 >> 2] = $524;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($2 + 408 | 0) >> 2] = $3;
   i64toi32_i32$0 = $8$hi;
   i64toi32_i32$2 = $8;
   i64toi32_i32$3 = 0;
   i64toi32_i32$1 = 255;
   i64toi32_i32$3 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
   $529 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
   $529$hi = i64toi32_i32$3;
   i64toi32_i32$3 = $10$hi;
   i64toi32_i32$0 = $10;
   i64toi32_i32$2 = -1;
   i64toi32_i32$1 = -256;
   i64toi32_i32$2 = i64toi32_i32$3 & i64toi32_i32$2 | 0;
   $531 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
   $531$hi = i64toi32_i32$2;
   i64toi32_i32$2 = $529$hi;
   i64toi32_i32$3 = $529;
   i64toi32_i32$0 = $531$hi;
   i64toi32_i32$1 = $531;
   i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
   $532 = i64toi32_i32$3 | i64toi32_i32$1 | 0;
   i64toi32_i32$3 = $2;
   HEAP32[(i64toi32_i32$3 + 360 | 0) >> 2] = $532;
   HEAP32[(i64toi32_i32$3 + 364 | 0) >> 2] = i64toi32_i32$0;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, i64toi32_i32$3 + 360 | 0 | 0, 1071226 | 0, 8 | 0);
   i64toi32_i32$0 = 0;
   $7 = 1;
   $7$hi = i64toi32_i32$0;
  }
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$3 = $0;
  HEAP32[i64toi32_i32$3 >> 2] = $7;
  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 432 | 0;
 }
 
 function cryptoxide__curve25519__scalar__scalar64__barrett_reduce256__heefb042b74f1284c($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$4 = 0, $3 = 0, $4$hi = 0, $4 = 0, $6$hi = 0, $5$hi = 0, $6 = 0, $7$hi = 0, $11$hi = 0, $7 = 0, $5 = 0, $14$hi = 0, $8 = 0, $8$hi = 0, $11 = 0, $14 = 0, $15$hi = 0, $12$hi = 0, i64toi32_i32$6 = 0, $15 = 0, $9$hi = 0, $12 = 0, $9 = 0, $10$hi = 0, $13$hi = 0, $10 = 0, $13 = 0, $16$hi = 0, $353 = 0, $355 = 0, $356 = 0, $357 = 0, $358 = 0, $359 = 0, $360 = 0, $361 = 0, $362 = 0, $363 = 0, $365 = 0, $367 = 0, $368 = 0, $369 = 0, $371 = 0, $372 = 0, $373 = 0, $375 = 0, $376 = 0, $377 = 0, $379 = 0, $380 = 0, $381 = 0, $382 = 0, $384 = 0, $385 = 0, $386 = 0, $387 = 0, $388 = 0, $389 = 0, $391 = 0, $392 = 0, $393 = 0, $395 = 0, $396 = 0, $398 = 0, $399 = 0, $400 = 0, $401 = 0, $88 = 0, $93 = 0, $93$hi = 0, $97 = 0, $97$hi = 0, $101 = 0, $101$hi = 0, $103 = 0, $103$hi = 0, $108 = 0, $108$hi = 0, $112 = 0, $112$hi = 0, $116 = 0, $116$hi = 0, $120 = 0, $120$hi = 0, $122 = 0, $122$hi = 0, $127 = 0, $127$hi = 0, $131 = 0, $131$hi = 0, $135 = 0, $135$hi = 0, $16 = 0, $138 = 0, $138$hi = 0, $142 = 0, $142$hi = 0, $146 = 0, $146$hi = 0, $147$hi = 0, $150 = 0, $151$hi = 0, $152$hi = 0, $156 = 0, $156$hi = 0, $157$hi = 0, $160 = 0, $161$hi = 0, $162$hi = 0, $166 = 0, $166$hi = 0, $167$hi = 0, $170 = 0, $171$hi = 0, $173$hi = 0, $174 = 0, $174$hi = 0, $177 = 0, $177$hi = 0, $181 = 0, $181$hi = 0, $185 = 0, $185$hi = 0, $186$hi = 0, $189 = 0, $190$hi = 0, $191$hi = 0, $195 = 0, $195$hi = 0, $196$hi = 0, $199 = 0, $200$hi = 0, $201$hi = 0, $205 = 0, $205$hi = 0, $206$hi = 0, $209 = 0, $210$hi = 0, $211$hi = 0, $215 = 0, $215$hi = 0, $216$hi = 0, $219 = 0, $220$hi = 0, $221$hi = 0, $224 = 0, $225$hi = 0, $227$hi = 0, $228 = 0, $228$hi = 0, $232 = 0, $232$hi = 0, $235 = 0, $235$hi = 0, $239 = 0, $244 = 0, $244$hi = 0, $248 = 0, $248$hi = 0, $250 = 0, $250$hi = 0, $252 = 0, $252$hi = 0, $256 = 0, $256$hi = 0, $260 = 0, $260$hi = 0, $261$hi = 0, $264 = 0, $265$hi = 0, $266$hi = 0, $270 = 0, $270$hi = 0, $271$hi = 0, $274 = 0, $275$hi = 0, $276$hi = 0, $280 = 0, $280$hi = 0, $281$hi = 0, $284 = 0, $285$hi = 0, $286$hi = 0, $289 = 0, $290$hi = 0, $292$hi = 0, $293 = 0, $293$hi = 0, $297 = 0, $297$hi = 0, $300 = 0, $300$hi = 0, $307 = 0, $312 = 0, $312$hi = 0, $314 = 0, $314$hi = 0, $316 = 0, $316$hi = 0, $320 = 0, $320$hi = 0, $324 = 0, $324$hi = 0, $325$hi = 0, $328 = 0, $329$hi = 0, $330$hi = 0, $334 = 0, $334$hi = 0, $335$hi = 0, $338 = 0, $339$hi = 0, $340$hi = 0, $343 = 0, $344$hi = 0, $346$hi = 0, $347 = 0, $347$hi = 0, $351 = 0, $351$hi = 0, $354 = 0, $354$hi = 0, $364 = 0, $366 = 0, $366$hi = 0, $370 = 0, $370$hi = 0, $374 = 0, $374$hi = 0, $375$hi = 0, $378 = 0, $379$hi = 0, $380$hi = 0, $383 = 0, $384$hi = 0, $386$hi = 0, $390 = 0, $390$hi = 0, $394 = 0, $394$hi = 0, $397 = 0, $397$hi = 0, $406 = 0, $410 = 0, $410$hi = 0, $411 = 0, $411$hi = 0, $415 = 0, $415$hi = 0, $418 = 0, $419$hi = 0, $421$hi = 0, $423 = 0, $423$hi = 0, $424$hi = 0, $402 = 0, $440 = 0, $442 = 0, $442$hi = 0, $446 = 0, $446$hi = 0, $450$hi = 0, $453 = 0, $454 = 0, $454$hi = 0, $456$hi = 0, $457 = 0, $457$hi = 0, $459 = 0, $459$hi = 0, $465$hi = 0, $469 = 0, $469$hi = 0, $473 = 0, $473$hi = 0, $476$hi = 0, $480$hi = 0, $483 = 0, $484 = 0, $484$hi = 0, $486$hi = 0, $487 = 0, $487$hi = 0, $492 = 0, $492$hi = 0, $494 = 0, $494$hi = 0, $496 = 0, $496$hi = 0, $498$hi = 0, $502 = 0, $502$hi = 0, $503$hi = 0, $506 = 0, $507$hi = 0, $508$hi = 0, $512 = 0, $512$hi = 0, $513$hi = 0, $516 = 0, $517$hi = 0, $519$hi = 0, $520 = 0, $520$hi = 0, $524 = 0, $524$hi = 0, $527 = 0, $527$hi = 0, $531$hi = 0, $534 = 0, $535 = 0, $535$hi = 0, $537$hi = 0, $538 = 0, $538$hi = 0, $543 = 0, $543$hi = 0, $547 = 0, $547$hi = 0, $549 = 0, $549$hi = 0, $551 = 0, $551$hi = 0, $555 = 0, $555$hi = 0, $559 = 0, $559$hi = 0, $560$hi = 0, $563 = 0, $564$hi = 0, $565$hi = 0, $568 = 0, $569$hi = 0, $570$hi = 0, $574 = 0, $574$hi = 0, $575$hi = 0, $578 = 0, $579$hi = 0, $581$hi = 0, $582 = 0, $582$hi = 0, $585 = 0, $585$hi = 0, $589$hi = 0, $592 = 0, $593 = 0, $593$hi = 0, $595$hi = 0, $596 = 0, $596$hi = 0, $598 = 0, $598$hi = 0, $600$hi = 0, $601$hi = 0, $603 = 0, $603$hi = 0, $604$hi = 0, $606 = 0, $606$hi = 0, $607 = 0, $607$hi = 0, $609 = 0, $609$hi = 0, $613 = 0, $613$hi = 0, $617 = 0, $617$hi = 0, $618$hi = 0, $621 = 0, $622$hi = 0, $623$hi = 0, $627 = 0, $627$hi = 0, $628$hi = 0, $631 = 0, $632$hi = 0, $633$hi = 0, $636 = 0, $637$hi = 0, $639$hi = 0, $640 = 0, $640$hi = 0, $642$hi = 0, $646$hi = 0;
  $3 = global$0 - 576 | 0;
  global$0 = $3;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$1;
  i64toi32_i32$0 = 0;
  i64toi32_i32$2 = 10282403;
  i64toi32_i32$3 = 0;
  __multi3($3 + 192 | 0 | 0, $4 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$0 | 0, 170660635 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$3 | 0);
  i64toi32_i32$0 = $1;
  i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $5 = i64toi32_i32$3;
  $5$hi = i64toi32_i32$2;
  i64toi32_i32$3 = 0;
  i64toi32_i32$0 = 16777215;
  i64toi32_i32$1 = 0;
  __multi3($3 + 272 | 0 | 0, $5 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$3 | 0, -1 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$1 | 0);
  i64toi32_i32$3 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 20 | 0) >> 2] | 0;
  $6 = i64toi32_i32$1;
  $6$hi = i64toi32_i32$0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 2186504;
  i64toi32_i32$2 = 0;
  __multi3($3 + 304 | 0 | 0, $6 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$1 | 0, 1663674349 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$2 | 0);
  i64toi32_i32$1 = $1;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] | 0;
  $7 = i64toi32_i32$2;
  $7$hi = i64toi32_i32$3;
  i64toi32_i32$2 = 0;
  i64toi32_i32$1 = 16777215;
  i64toi32_i32$0 = 0;
  __multi3($3 + 368 | 0 | 0, $7 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$2 | 0, -1367802 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$0 | 0);
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$0 = 0;
  i64toi32_i32$2 = 10282403;
  i64toi32_i32$3 = 0;
  __multi3($3 + 416 | 0 | 0, $8 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$0 | 0, 170660635 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$3 | 0);
  i64toi32_i32$3 = $5$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$0 = 15;
  i64toi32_i32$1 = 0;
  __multi3($3 + 288 | 0 | 0, $5 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$2 | 0, -1 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$1 | 0);
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$2 = 16777215;
  i64toi32_i32$3 = 0;
  __multi3($3 + 384 | 0 | 0, $7 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$0 | 0, -1 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$3 | 0);
  i64toi32_i32$3 = $4$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$0 = 2186504;
  i64toi32_i32$1 = 0;
  __multi3($3 + 208 | 0 | 0, $4 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$2 | 0, 1663674349 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$1 | 0);
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$2 = 16777215;
  i64toi32_i32$3 = 0;
  __multi3($3 + 320 | 0 | 0, $6 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$0 | 0, -1367802 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$3 | 0);
  i64toi32_i32$3 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$0 = 15;
  i64toi32_i32$1 = 0;
  __multi3($3 + 400 | 0 | 0, $7 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$2 | 0, -1 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$1 | 0);
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$2 = 2186504;
  i64toi32_i32$3 = 0;
  __multi3($3 + 432 | 0 | 0, $8 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$0 | 0, 1663674349 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$3 | 0);
  i64toi32_i32$3 = $4$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$0 = 16777215;
  i64toi32_i32$1 = 0;
  __multi3($3 + 224 | 0 | 0, $4 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$2 | 0, -1367802 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$1 | 0);
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$2 = 16777215;
  i64toi32_i32$3 = 0;
  __multi3($3 + 336 | 0 | 0, $6 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$0 | 0, -1 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$3 | 0);
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$2 = 0;
  i64toi32_i32$0 = 15;
  i64toi32_i32$1 = 0;
  __multi3($3 + 352 | 0 | 0, $6 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$2 | 0, -1 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$1 | 0);
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$2 = 16777215;
  i64toi32_i32$3 = 0;
  __multi3($3 + 448 | 0 | 0, $8 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$0 | 0, -1367802 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$3 | 0);
  i64toi32_i32$3 = $4$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$0 = 16777215;
  i64toi32_i32$1 = 0;
  __multi3($3 + 240 | 0 | 0, $4 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$2 | 0, -1 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$1 | 0);
  i64toi32_i32$1 = i64toi32_i32$3;
  i64toi32_i32$0 = 0;
  i64toi32_i32$2 = 15;
  i64toi32_i32$3 = 0;
  __multi3($3 + 256 | 0 | 0, $4 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$0 | 0, -1 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$3 | 0);
  i64toi32_i32$3 = $8$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$0 = 16777215;
  i64toi32_i32$1 = 0;
  __multi3($3 + 464 | 0 | 0, $8 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$2 | 0, -1 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$1 | 0);
  i64toi32_i32$1 = i64toi32_i32$3;
  i64toi32_i32$0 = 0;
  i64toi32_i32$2 = 15;
  i64toi32_i32$3 = 0;
  __multi3($3 + 480 | 0 | 0, $8 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$0 | 0, -1 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$3 | 0);
  $88 = $3 + 176 | 0;
  i64toi32_i32$0 = $3;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 336 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 340 | 0) >> 2] | 0;
  $9 = i64toi32_i32$3;
  $9$hi = i64toi32_i32$2;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 224 | 0) >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 228 | 0) >> 2] | 0;
  $93 = i64toi32_i32$2;
  $93$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $9$hi;
  i64toi32_i32$0 = $9;
  i64toi32_i32$2 = $93$hi;
  i64toi32_i32$1 = $93;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  i64toi32_i32$5 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $6 = i64toi32_i32$4;
  $6$hi = i64toi32_i32$5;
  i64toi32_i32$3 = $3;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 400 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 404 | 0) >> 2] | 0;
  $97 = i64toi32_i32$5;
  $97$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$5 = $97$hi;
  i64toi32_i32$1 = $97;
  i64toi32_i32$2 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $7 = i64toi32_i32$2;
  $7$hi = i64toi32_i32$4;
  i64toi32_i32$0 = $3;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 432 | 0) >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 436 | 0) >> 2] | 0;
  $101 = i64toi32_i32$4;
  $101$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $7$hi;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$4 = $101$hi;
  i64toi32_i32$1 = $101;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  i64toi32_i32$2 = i64toi32_i32$3 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $5 = i64toi32_i32$5;
  $5$hi = i64toi32_i32$2;
  $103 = i64toi32_i32$5;
  $103$hi = i64toi32_i32$2;
  i64toi32_i32$3 = $3;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 288 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 292 | 0) >> 2] | 0;
  $10 = i64toi32_i32$2;
  $10$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 208 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 212 | 0) >> 2] | 0;
  $108 = i64toi32_i32$0;
  $108$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$3 = $10;
  i64toi32_i32$0 = $108$hi;
  i64toi32_i32$1 = $108;
  i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $4 = i64toi32_i32$4;
  $4$hi = i64toi32_i32$5;
  i64toi32_i32$2 = $3;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$2 + 320 | 0) >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 324 | 0) >> 2] | 0;
  $112 = i64toi32_i32$5;
  $112$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $4$hi;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$5 = $112$hi;
  i64toi32_i32$1 = $112;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$4;
  i64toi32_i32$3 = $3;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$3 + 384 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 388 | 0) >> 2] | 0;
  $116 = i64toi32_i32$4;
  $116$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$0;
  i64toi32_i32$4 = $116$hi;
  i64toi32_i32$1 = $116;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $11 = i64toi32_i32$5;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 416 | 0) >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 420 | 0) >> 2] | 0;
  $120 = i64toi32_i32$0;
  $120$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $11$hi;
  i64toi32_i32$2 = i64toi32_i32$5;
  i64toi32_i32$0 = $120$hi;
  i64toi32_i32$1 = $120;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  i64toi32_i32$5 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $12 = i64toi32_i32$4;
  $12$hi = i64toi32_i32$5;
  $122 = i64toi32_i32$4;
  $122$hi = i64toi32_i32$5;
  i64toi32_i32$3 = $3;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 272 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 276 | 0) >> 2] | 0;
  $13 = i64toi32_i32$5;
  $13$hi = i64toi32_i32$2;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 192 | 0) >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 196 | 0) >> 2] | 0;
  $127 = i64toi32_i32$2;
  $127$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $13$hi;
  i64toi32_i32$3 = $13;
  i64toi32_i32$2 = $127$hi;
  i64toi32_i32$1 = $127;
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $14 = i64toi32_i32$0;
  $14$hi = i64toi32_i32$4;
  i64toi32_i32$5 = $3;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 304 | 0) >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 308 | 0) >> 2] | 0;
  $131 = i64toi32_i32$4;
  $131$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $14$hi;
  i64toi32_i32$5 = i64toi32_i32$0;
  i64toi32_i32$4 = $131$hi;
  i64toi32_i32$1 = $131;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $15 = i64toi32_i32$2;
  $15$hi = i64toi32_i32$0;
  i64toi32_i32$3 = $3;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 368 | 0) >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 372 | 0) >> 2] | 0;
  $135 = i64toi32_i32$0;
  $135$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $15$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$0 = $135$hi;
  i64toi32_i32$1 = $135;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $16 = i64toi32_i32$4;
  $16$hi = i64toi32_i32$2;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$3 = 0;
  i64toi32_i32$1 = 56;
  i64toi32_i32$0 = i64toi32_i32$1 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
   i64toi32_i32$3 = 0;
   $353 = i64toi32_i32$2 >>> i64toi32_i32$0 | 0;
  } else {
   i64toi32_i32$3 = i64toi32_i32$2 >>> i64toi32_i32$0 | 0;
   $353 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$0 | 0) | 0;
  }
  $138 = $353;
  $138$hi = i64toi32_i32$3;
  i64toi32_i32$2 = ($3 + 272 | 0) + 8 | 0;
  i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $142 = i64toi32_i32$3;
  $142$hi = i64toi32_i32$5;
  i64toi32_i32$2 = ($3 + 192 | 0) + 8 | 0;
  i64toi32_i32$5 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $146 = i64toi32_i32$5;
  $146$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $142$hi;
  i64toi32_i32$2 = $142;
  i64toi32_i32$5 = $146$hi;
  i64toi32_i32$1 = $146;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $147$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $14$hi;
  i64toi32_i32$4 = $13$hi;
  i64toi32_i32$4 = $14$hi;
  i64toi32_i32$3 = $14;
  i64toi32_i32$2 = $13$hi;
  i64toi32_i32$1 = $13;
  $150 = i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0 | 0) | 0;
  i64toi32_i32$3 = 0;
  $151$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $147$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$4 = $151$hi;
  i64toi32_i32$2 = $150;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $152$hi = i64toi32_i32$0;
  i64toi32_i32$3 = ($3 + 304 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
  $156 = i64toi32_i32$0;
  $156$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $152$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$0 = $156$hi;
  i64toi32_i32$2 = $156;
  i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $157$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $15$hi;
  i64toi32_i32$5 = $14$hi;
  i64toi32_i32$5 = $15$hi;
  i64toi32_i32$1 = $15;
  i64toi32_i32$3 = $14$hi;
  i64toi32_i32$2 = $14;
  $160 = i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0;
  i64toi32_i32$1 = 0;
  $161$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $157$hi;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$5 = $161$hi;
  i64toi32_i32$3 = $160;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $162$hi = i64toi32_i32$4;
  i64toi32_i32$1 = ($3 + 368 | 0) + 8 | 0;
  i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $166 = i64toi32_i32$4;
  $166$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $162$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$4 = $166$hi;
  i64toi32_i32$3 = $166;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $167$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $16$hi;
  i64toi32_i32$0 = $15$hi;
  i64toi32_i32$0 = $16$hi;
  i64toi32_i32$2 = $16;
  i64toi32_i32$1 = $15$hi;
  i64toi32_i32$3 = $15;
  $170 = i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
  i64toi32_i32$2 = 0;
  $171$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $167$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$0 = $171$hi;
  i64toi32_i32$1 = $170;
  i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$3 = 0;
  i64toi32_i32$1 = 8;
  i64toi32_i32$0 = i64toi32_i32$1 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$2 << i64toi32_i32$0 | 0;
   $355 = 0;
  } else {
   i64toi32_i32$3 = ((1 << i64toi32_i32$0 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$0 | 0) | 0) | 0 | (i64toi32_i32$5 << i64toi32_i32$0 | 0) | 0;
   $355 = i64toi32_i32$2 << i64toi32_i32$0 | 0;
  }
  $173$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $138$hi;
  i64toi32_i32$5 = $138;
  i64toi32_i32$2 = $173$hi;
  i64toi32_i32$1 = $355;
  i64toi32_i32$2 = i64toi32_i32$3 | i64toi32_i32$2 | 0;
  $174 = i64toi32_i32$5 | i64toi32_i32$1 | 0;
  $174$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $122$hi;
  i64toi32_i32$3 = $122;
  i64toi32_i32$5 = $174$hi;
  i64toi32_i32$1 = $174;
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $14 = i64toi32_i32$0;
  $14$hi = i64toi32_i32$4;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$3 = 0;
  i64toi32_i32$1 = 56;
  i64toi32_i32$5 = i64toi32_i32$1 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
   i64toi32_i32$3 = 0;
   $356 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
  } else {
   i64toi32_i32$3 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
   $356 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$5 | 0) | 0;
  }
  $177 = $356;
  $177$hi = i64toi32_i32$3;
  i64toi32_i32$4 = ($3 + 288 | 0) + 8 | 0;
  i64toi32_i32$3 = HEAP32[i64toi32_i32$4 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
  $181 = i64toi32_i32$3;
  $181$hi = i64toi32_i32$2;
  i64toi32_i32$4 = ($3 + 208 | 0) + 8 | 0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$4 >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
  $185 = i64toi32_i32$2;
  $185$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $181$hi;
  i64toi32_i32$4 = $181;
  i64toi32_i32$2 = $185$hi;
  i64toi32_i32$1 = $185;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $186$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $4$hi;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$0 = $4$hi;
  i64toi32_i32$3 = $4;
  i64toi32_i32$4 = $10$hi;
  i64toi32_i32$1 = $10;
  $189 = i64toi32_i32$0 >>> 0 < i64toi32_i32$4 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$4 | 0) & i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0 | 0) | 0;
  i64toi32_i32$3 = 0;
  $190$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $186$hi;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$0 = $190$hi;
  i64toi32_i32$4 = $189;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  i64toi32_i32$5 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$4 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $191$hi = i64toi32_i32$5;
  i64toi32_i32$3 = ($3 + 320 | 0) + 8 | 0;
  i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
  $195 = i64toi32_i32$5;
  $195$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $191$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$5 = $195$hi;
  i64toi32_i32$4 = $195;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$4 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $196$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$1 = $8;
  i64toi32_i32$3 = $4$hi;
  i64toi32_i32$4 = $4;
  $199 = i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$4 >>> 0 | 0) | 0;
  i64toi32_i32$1 = 0;
  $200$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $196$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$2 = $200$hi;
  i64toi32_i32$3 = $199;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $201$hi = i64toi32_i32$0;
  i64toi32_i32$1 = ($3 + 384 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $205 = i64toi32_i32$0;
  $205$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $201$hi;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$0 = $205$hi;
  i64toi32_i32$3 = $205;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $206$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $11$hi;
  i64toi32_i32$5 = $8$hi;
  i64toi32_i32$5 = $11$hi;
  i64toi32_i32$4 = $11;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$3 = $8;
  $209 = i64toi32_i32$5 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
  i64toi32_i32$4 = 0;
  $210$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $206$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$5 = $210$hi;
  i64toi32_i32$1 = $209;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $211$hi = i64toi32_i32$2;
  i64toi32_i32$4 = ($3 + 416 | 0) + 8 | 0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$4 >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
  $215 = i64toi32_i32$2;
  $215$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $211$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$2 = $215$hi;
  i64toi32_i32$1 = $215;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $216$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$1 = $11;
  $219 = i64toi32_i32$0 >>> 0 < i64toi32_i32$4 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$4 | 0) & i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0 | 0) | 0;
  i64toi32_i32$3 = 0;
  $220$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $216$hi;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$0 = $220$hi;
  i64toi32_i32$4 = $219;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  i64toi32_i32$5 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$4 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $221$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $14$hi;
  i64toi32_i32$5 = $12$hi;
  i64toi32_i32$5 = $14$hi;
  i64toi32_i32$3 = $14;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$4 = $12;
  $224 = i64toi32_i32$5 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$3 >>> 0 < i64toi32_i32$4 >>> 0 | 0) | 0;
  i64toi32_i32$3 = 0;
  $225$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $221$hi;
  i64toi32_i32$4 = i64toi32_i32$2;
  i64toi32_i32$5 = $225$hi;
  i64toi32_i32$1 = $224;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  i64toi32_i32$2 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  i64toi32_i32$3 = i64toi32_i32$0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$1 = 8;
  i64toi32_i32$5 = i64toi32_i32$1 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$3 << i64toi32_i32$5 | 0;
   $357 = 0;
  } else {
   i64toi32_i32$4 = ((1 << i64toi32_i32$5 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$5 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$5 | 0) | 0;
   $357 = i64toi32_i32$3 << i64toi32_i32$5 | 0;
  }
  $227$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $177$hi;
  i64toi32_i32$2 = $177;
  i64toi32_i32$3 = $227$hi;
  i64toi32_i32$1 = $357;
  i64toi32_i32$3 = i64toi32_i32$4 | i64toi32_i32$3 | 0;
  $228 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
  $228$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $103$hi;
  i64toi32_i32$4 = $103;
  i64toi32_i32$2 = $228$hi;
  i64toi32_i32$1 = $228;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $4 = i64toi32_i32$5;
  $4$hi = i64toi32_i32$0;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$4 = 0;
  i64toi32_i32$1 = 16;
  i64toi32_i32$2 = i64toi32_i32$1 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$3 << i64toi32_i32$2 | 0;
   $358 = 0;
  } else {
   i64toi32_i32$4 = ((1 << i64toi32_i32$2 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$2 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$2 | 0) | 0;
   $358 = i64toi32_i32$3 << i64toi32_i32$2 | 0;
  }
  i64toi32_i32$0 = $358;
  i64toi32_i32$3 = 16777215;
  i64toi32_i32$1 = -65536;
  i64toi32_i32$3 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
  $232 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
  $232$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $14$hi;
  i64toi32_i32$4 = $14;
  i64toi32_i32$0 = 0;
  i64toi32_i32$1 = 40;
  i64toi32_i32$2 = i64toi32_i32$1 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $359 = i64toi32_i32$3 >>> i64toi32_i32$2 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$3 >>> i64toi32_i32$2 | 0;
   $359 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$2 | 0) | 0;
  }
  i64toi32_i32$3 = $359;
  i64toi32_i32$4 = 0;
  i64toi32_i32$1 = 65535;
  i64toi32_i32$4 = i64toi32_i32$0 & i64toi32_i32$4 | 0;
  $235 = i64toi32_i32$3 & i64toi32_i32$1 | 0;
  $235$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $232$hi;
  i64toi32_i32$0 = $232;
  i64toi32_i32$3 = $235$hi;
  i64toi32_i32$1 = $235;
  i64toi32_i32$3 = i64toi32_i32$4 | i64toi32_i32$3 | 0;
  $8 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
  $8$hi = i64toi32_i32$3;
  i64toi32_i32$0 = 0;
  i64toi32_i32$4 = 1205018;
  i64toi32_i32$1 = 0;
  __multi3($88 | 0, $8 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$0 | 0, 1559614445 | 0, i64toi32_i32$4 | 0, 0 | 0, i64toi32_i32$1 | 0);
  $239 = $3 + 128 | 0;
  i64toi32_i32$0 = $3;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 352 | 0) >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 356 | 0) >> 2] | 0;
  $14 = i64toi32_i32$1;
  $14$hi = i64toi32_i32$4;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 240 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 244 | 0) >> 2] | 0;
  $244 = i64toi32_i32$4;
  $244$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $14$hi;
  i64toi32_i32$0 = $14;
  i64toi32_i32$4 = $244$hi;
  i64toi32_i32$3 = $244;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $11 = i64toi32_i32$2;
  $11$hi = i64toi32_i32$5;
  i64toi32_i32$1 = $3;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 448 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 452 | 0) >> 2] | 0;
  $248 = i64toi32_i32$5;
  $248$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$5 = $248$hi;
  i64toi32_i32$3 = $248;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $12 = i64toi32_i32$4;
  $12$hi = i64toi32_i32$2;
  $250 = i64toi32_i32$4;
  $250$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$0 = $4;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $360 = i64toi32_i32$2 >>> i64toi32_i32$5 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$5 | 0;
   $360 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$5 | 0) | 0;
  }
  $252 = $360;
  $252$hi = i64toi32_i32$1;
  i64toi32_i32$2 = ($3 + 336 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $256 = i64toi32_i32$1;
  $256$hi = i64toi32_i32$0;
  i64toi32_i32$2 = ($3 + 224 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $260 = i64toi32_i32$0;
  $260$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $256$hi;
  i64toi32_i32$2 = $256;
  i64toi32_i32$0 = $260$hi;
  i64toi32_i32$3 = $260;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $261$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $6$hi;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$4 = $6$hi;
  i64toi32_i32$1 = $6;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$3 = $9;
  $264 = i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
  i64toi32_i32$1 = 0;
  $265$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $261$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$4 = $265$hi;
  i64toi32_i32$2 = $264;
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $266$hi = i64toi32_i32$5;
  i64toi32_i32$1 = ($3 + 400 | 0) + 8 | 0;
  i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $270 = i64toi32_i32$5;
  $270$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $266$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$5 = $270$hi;
  i64toi32_i32$2 = $270;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $271$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$2 = $6;
  $274 = i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$3 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0;
  i64toi32_i32$3 = 0;
  $275$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $271$hi;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$0 = $275$hi;
  i64toi32_i32$1 = $274;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $276$hi = i64toi32_i32$4;
  i64toi32_i32$3 = ($3 + 432 | 0) + 8 | 0;
  i64toi32_i32$4 = HEAP32[i64toi32_i32$3 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
  $280 = i64toi32_i32$4;
  $280$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $276$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$4 = $280$hi;
  i64toi32_i32$1 = $280;
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $281$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $5$hi;
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$5 = $5$hi;
  i64toi32_i32$2 = $5;
  i64toi32_i32$3 = $7$hi;
  i64toi32_i32$1 = $7;
  $284 = i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$1 >>> 0 | 0) | 0;
  i64toi32_i32$2 = 0;
  $285$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $281$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$5 = $285$hi;
  i64toi32_i32$3 = $284;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $286$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $4$hi;
  i64toi32_i32$0 = $5$hi;
  i64toi32_i32$0 = $4$hi;
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = $5$hi;
  i64toi32_i32$3 = $5;
  $289 = i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
  i64toi32_i32$2 = 0;
  $290$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $286$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$0 = $290$hi;
  i64toi32_i32$1 = $289;
  i64toi32_i32$5 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  i64toi32_i32$2 = i64toi32_i32$5;
  i64toi32_i32$3 = 0;
  i64toi32_i32$1 = 8;
  i64toi32_i32$0 = i64toi32_i32$1 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$2 << i64toi32_i32$0 | 0;
   $361 = 0;
  } else {
   i64toi32_i32$3 = ((1 << i64toi32_i32$0 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$0 | 0) | 0) | 0 | (i64toi32_i32$4 << i64toi32_i32$0 | 0) | 0;
   $361 = i64toi32_i32$2 << i64toi32_i32$0 | 0;
  }
  $292$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $252$hi;
  i64toi32_i32$4 = $252;
  i64toi32_i32$2 = $292$hi;
  i64toi32_i32$1 = $361;
  i64toi32_i32$2 = i64toi32_i32$3 | i64toi32_i32$2 | 0;
  $293 = i64toi32_i32$4 | i64toi32_i32$1 | 0;
  $293$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $250$hi;
  i64toi32_i32$3 = $250;
  i64toi32_i32$4 = $293$hi;
  i64toi32_i32$1 = $293;
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $6 = i64toi32_i32$0;
  $6$hi = i64toi32_i32$5;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$3 = 0;
  i64toi32_i32$1 = 16;
  i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $362 = 0;
  } else {
   i64toi32_i32$3 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$5 << i64toi32_i32$4 | 0) | 0;
   $362 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  i64toi32_i32$5 = $362;
  i64toi32_i32$2 = 16777215;
  i64toi32_i32$1 = -65536;
  i64toi32_i32$2 = i64toi32_i32$3 & i64toi32_i32$2 | 0;
  $297 = i64toi32_i32$5 & i64toi32_i32$1 | 0;
  $297$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$3 = $4;
  i64toi32_i32$5 = 0;
  i64toi32_i32$1 = 40;
  i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
   i64toi32_i32$5 = 0;
   $363 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$5 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   $363 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$4 | 0) | 0;
  }
  i64toi32_i32$2 = $363;
  i64toi32_i32$3 = 0;
  i64toi32_i32$1 = 65535;
  i64toi32_i32$3 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
  $300 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
  $300$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $297$hi;
  i64toi32_i32$5 = $297;
  i64toi32_i32$2 = $300$hi;
  i64toi32_i32$1 = $300;
  i64toi32_i32$2 = i64toi32_i32$3 | i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$5 | i64toi32_i32$1 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 1205018;
  i64toi32_i32$1 = 0;
  __multi3($239 | 0, $7 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$5 | 0, 1559614445 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$1 | 0);
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$3 = 0;
  i64toi32_i32$5 = 16375458;
  i64toi32_i32$2 = 0;
  __multi3($3 + 160 | 0 | 0, $8 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$3 | 0, -140716456 | 0, i64toi32_i32$5 | 0, 0 | 0, i64toi32_i32$2 | 0);
  $307 = $3 + 80 | 0;
  i64toi32_i32$3 = $3;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 464 | 0) >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 468 | 0) >> 2] | 0;
  $15 = i64toi32_i32$2;
  $15$hi = i64toi32_i32$5;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 256 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 260 | 0) >> 2] | 0;
  $312 = i64toi32_i32$5;
  $312$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $15$hi;
  i64toi32_i32$3 = $15;
  i64toi32_i32$5 = $312$hi;
  i64toi32_i32$1 = $312;
  i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $5 = i64toi32_i32$4;
  $5$hi = i64toi32_i32$0;
  $314 = i64toi32_i32$4;
  $314$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$2 = $6;
  i64toi32_i32$3 = 0;
  i64toi32_i32$1 = 56;
  i64toi32_i32$5 = i64toi32_i32$1 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
   i64toi32_i32$3 = 0;
   $365 = i64toi32_i32$0 >>> i64toi32_i32$5 | 0;
  } else {
   i64toi32_i32$3 = i64toi32_i32$0 >>> i64toi32_i32$5 | 0;
   $365 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$5 | 0) | 0;
  }
  $316 = $365;
  $316$hi = i64toi32_i32$3;
  i64toi32_i32$0 = ($3 + 352 | 0) + 8 | 0;
  i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $320 = i64toi32_i32$3;
  $320$hi = i64toi32_i32$2;
  i64toi32_i32$0 = ($3 + 240 | 0) + 8 | 0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $324 = i64toi32_i32$2;
  $324$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $320$hi;
  i64toi32_i32$0 = $320;
  i64toi32_i32$2 = $324$hi;
  i64toi32_i32$1 = $324;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $325$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$4 = $14$hi;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$0 = $14$hi;
  i64toi32_i32$1 = $14;
  $328 = i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0 | 0) | 0;
  i64toi32_i32$3 = 0;
  $329$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $325$hi;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$4 = $329$hi;
  i64toi32_i32$0 = $328;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  i64toi32_i32$5 = i64toi32_i32$3 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $330$hi = i64toi32_i32$5;
  i64toi32_i32$3 = ($3 + 448 | 0) + 8 | 0;
  i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
  $334 = i64toi32_i32$5;
  $334$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $330$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$5 = $334$hi;
  i64toi32_i32$0 = $334;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $335$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$1 = $12;
  i64toi32_i32$3 = $11$hi;
  i64toi32_i32$0 = $11;
  $338 = i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$0 >>> 0 | 0) | 0;
  i64toi32_i32$1 = 0;
  $339$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $335$hi;
  i64toi32_i32$0 = i64toi32_i32$4;
  i64toi32_i32$2 = $339$hi;
  i64toi32_i32$3 = $338;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $340$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $6$hi;
  i64toi32_i32$4 = $12$hi;
  i64toi32_i32$4 = $6$hi;
  i64toi32_i32$1 = $6;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$3 = $12;
  $343 = i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
  i64toi32_i32$1 = 0;
  $344$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $340$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$4 = $344$hi;
  i64toi32_i32$0 = $343;
  i64toi32_i32$2 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$3 = 0;
  i64toi32_i32$0 = 8;
  i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
   $367 = 0;
  } else {
   i64toi32_i32$3 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$5 << i64toi32_i32$4 | 0) | 0;
   $367 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
  }
  $346$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $316$hi;
  i64toi32_i32$5 = $316;
  i64toi32_i32$1 = $346$hi;
  i64toi32_i32$0 = $367;
  i64toi32_i32$1 = i64toi32_i32$3 | i64toi32_i32$1 | 0;
  $347 = i64toi32_i32$5 | i64toi32_i32$0 | 0;
  $347$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $314$hi;
  i64toi32_i32$3 = $314;
  i64toi32_i32$5 = $347$hi;
  i64toi32_i32$0 = $347;
  i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $4 = i64toi32_i32$4;
  $4$hi = i64toi32_i32$2;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$3 = 0;
  i64toi32_i32$0 = 16;
  i64toi32_i32$5 = i64toi32_i32$0 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$1 << i64toi32_i32$5 | 0;
   $368 = 0;
  } else {
   i64toi32_i32$3 = ((1 << i64toi32_i32$5 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$5 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$5 | 0) | 0;
   $368 = i64toi32_i32$1 << i64toi32_i32$5 | 0;
  }
  i64toi32_i32$2 = $368;
  i64toi32_i32$1 = 16777215;
  i64toi32_i32$0 = -65536;
  i64toi32_i32$1 = i64toi32_i32$3 & i64toi32_i32$1 | 0;
  $351 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
  $351$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$3 = $6;
  i64toi32_i32$2 = 0;
  i64toi32_i32$0 = 40;
  i64toi32_i32$5 = i64toi32_i32$0 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $369 = i64toi32_i32$1 >>> i64toi32_i32$5 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$5 | 0;
   $369 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$5 | 0) | 0;
  }
  i64toi32_i32$1 = $369;
  i64toi32_i32$3 = 0;
  i64toi32_i32$0 = 65535;
  i64toi32_i32$3 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
  $354 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
  $354$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $351$hi;
  i64toi32_i32$2 = $351;
  i64toi32_i32$1 = $354$hi;
  i64toi32_i32$0 = $354;
  i64toi32_i32$1 = i64toi32_i32$3 | i64toi32_i32$1 | 0;
  $6 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
  $6$hi = i64toi32_i32$1;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 1205018;
  i64toi32_i32$0 = 0;
  __multi3($307 | 0, $6 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$2 | 0, 1559614445 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$0 | 0);
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$3 = 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$1 = 0;
  __multi3($3 + 144 | 0 | 0, $8 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$3 | 0, 5342 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$1 | 0);
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 16375458;
  i64toi32_i32$0 = 0;
  __multi3($3 + 112 | 0 | 0, $7 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$2 | 0, -140716456 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$0 | 0);
  $364 = $3 + 32 | 0;
  i64toi32_i32$0 = $4$hi;
  i64toi32_i32$2 = $4;
  i64toi32_i32$3 = 0;
  i64toi32_i32$1 = 56;
  i64toi32_i32$5 = i64toi32_i32$1 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
   i64toi32_i32$3 = 0;
   $371 = i64toi32_i32$0 >>> i64toi32_i32$5 | 0;
  } else {
   i64toi32_i32$3 = i64toi32_i32$0 >>> i64toi32_i32$5 | 0;
   $371 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$5 | 0) | 0;
  }
  $366 = $371;
  $366$hi = i64toi32_i32$3;
  i64toi32_i32$0 = ($3 + 464 | 0) + 8 | 0;
  i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $370 = i64toi32_i32$3;
  $370$hi = i64toi32_i32$2;
  i64toi32_i32$0 = ($3 + 256 | 0) + 8 | 0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $374 = i64toi32_i32$2;
  $374$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $370$hi;
  i64toi32_i32$0 = $370;
  i64toi32_i32$2 = $374$hi;
  i64toi32_i32$1 = $374;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $375$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $5$hi;
  i64toi32_i32$4 = $15$hi;
  i64toi32_i32$4 = $5$hi;
  i64toi32_i32$3 = $5;
  i64toi32_i32$0 = $15$hi;
  i64toi32_i32$1 = $15;
  $378 = i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0 | 0) | 0;
  i64toi32_i32$3 = 0;
  $379$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $375$hi;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$4 = $379$hi;
  i64toi32_i32$0 = $378;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  i64toi32_i32$5 = i64toi32_i32$3 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $380$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $4$hi;
  i64toi32_i32$5 = $5$hi;
  i64toi32_i32$5 = $4$hi;
  i64toi32_i32$3 = $4;
  i64toi32_i32$1 = $5$hi;
  i64toi32_i32$0 = $5;
  $383 = i64toi32_i32$5 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$3 >>> 0 < i64toi32_i32$0 >>> 0 | 0) | 0;
  i64toi32_i32$3 = 0;
  $384$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $380$hi;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$5 = $384$hi;
  i64toi32_i32$1 = $383;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  i64toi32_i32$2 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$0 = 0;
  i64toi32_i32$1 = 8;
  i64toi32_i32$5 = i64toi32_i32$1 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$3 << i64toi32_i32$5 | 0;
   $372 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$5 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$5 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$5 | 0) | 0;
   $372 = i64toi32_i32$3 << i64toi32_i32$5 | 0;
  }
  $386$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $366$hi;
  i64toi32_i32$2 = $366;
  i64toi32_i32$3 = $386$hi;
  i64toi32_i32$1 = $372;
  i64toi32_i32$3 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $11 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
  $11$hi = i64toi32_i32$3;
  i64toi32_i32$0 = $3;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 480 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 484 | 0) >> 2] | 0;
  $390 = i64toi32_i32$3;
  $390$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$0 = $11;
  i64toi32_i32$3 = $390$hi;
  i64toi32_i32$1 = $390;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $5 = i64toi32_i32$5;
  $5$hi = i64toi32_i32$4;
  i64toi32_i32$2 = i64toi32_i32$5;
  i64toi32_i32$0 = 0;
  i64toi32_i32$1 = 16;
  i64toi32_i32$3 = i64toi32_i32$1 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$3 | 0;
   $373 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$3 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$3 | 0) | 0) | 0 | (i64toi32_i32$4 << i64toi32_i32$3 | 0) | 0;
   $373 = i64toi32_i32$2 << i64toi32_i32$3 | 0;
  }
  i64toi32_i32$4 = $373;
  i64toi32_i32$2 = 16777215;
  i64toi32_i32$1 = -65536;
  i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
  $394 = i64toi32_i32$4 & i64toi32_i32$1 | 0;
  $394$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$0 = $4;
  i64toi32_i32$4 = 0;
  i64toi32_i32$1 = 40;
  i64toi32_i32$3 = i64toi32_i32$1 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
   i64toi32_i32$4 = 0;
   $375 = i64toi32_i32$2 >>> i64toi32_i32$3 | 0;
  } else {
   i64toi32_i32$4 = i64toi32_i32$2 >>> i64toi32_i32$3 | 0;
   $375 = (((1 << i64toi32_i32$3 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$3 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$3 | 0) | 0;
  }
  i64toi32_i32$2 = $375;
  i64toi32_i32$0 = 0;
  i64toi32_i32$1 = 65535;
  i64toi32_i32$0 = i64toi32_i32$4 & i64toi32_i32$0 | 0;
  $397 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
  $397$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $394$hi;
  i64toi32_i32$4 = $394;
  i64toi32_i32$2 = $397$hi;
  i64toi32_i32$1 = $397;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  $4 = i64toi32_i32$4 | i64toi32_i32$1 | 0;
  $4$hi = i64toi32_i32$2;
  i64toi32_i32$4 = 0;
  i64toi32_i32$0 = 1205018;
  i64toi32_i32$1 = 0;
  __multi3($364 | 0, $4 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$4 | 0, 1559614445 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$1 | 0);
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$4 = 16375458;
  i64toi32_i32$2 = 0;
  __multi3($3 + 64 | 0 | 0, $6 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$0 | 0, -140716456 | 0, i64toi32_i32$4 | 0, 0 | 0, i64toi32_i32$2 | 0);
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$1 = 0;
  __multi3($3 + 96 | 0 | 0, $7 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$4 | 0, 5342 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$1 | 0);
  $406 = $3;
  i64toi32_i32$1 = $5$hi;
  i64toi32_i32$4 = $5;
  i64toi32_i32$0 = 0;
  i64toi32_i32$2 = 40;
  i64toi32_i32$3 = i64toi32_i32$2 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $376 = i64toi32_i32$1 >>> i64toi32_i32$3 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$3 | 0;
   $376 = (((1 << i64toi32_i32$3 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$3 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$3 | 0) | 0;
  }
  $7 = $376;
  $7$hi = i64toi32_i32$0;
  i64toi32_i32$1 = $7;
  i64toi32_i32$4 = 0;
  i64toi32_i32$2 = 65535;
  i64toi32_i32$4 = i64toi32_i32$0 & i64toi32_i32$4 | 0;
  $410 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
  $410$hi = i64toi32_i32$4;
  i64toi32_i32$4 = i64toi32_i32$0;
  $411 = i64toi32_i32$1;
  $411$hi = i64toi32_i32$0;
  i64toi32_i32$0 = ($3 + 480 | 0) + 8 | 0;
  i64toi32_i32$4 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $415 = i64toi32_i32$4;
  $415$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $5$hi;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$1 = $5$hi;
  i64toi32_i32$0 = $5;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$2 = $11;
  $418 = i64toi32_i32$1 >>> 0 < i64toi32_i32$4 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$4 | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0;
  i64toi32_i32$0 = 0;
  $419$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $415$hi;
  i64toi32_i32$2 = $415;
  i64toi32_i32$1 = $419$hi;
  i64toi32_i32$4 = $418;
  i64toi32_i32$3 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$3 >>> 0 < i64toi32_i32$4 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  i64toi32_i32$0 = i64toi32_i32$3;
  i64toi32_i32$2 = 0;
  i64toi32_i32$4 = 24;
  i64toi32_i32$1 = i64toi32_i32$4 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$4 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$1 | 0;
   $377 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$1 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$1 | 0) | 0) | 0 | (i64toi32_i32$5 << i64toi32_i32$1 | 0) | 0;
   $377 = i64toi32_i32$0 << i64toi32_i32$1 | 0;
  }
  $421$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $411$hi;
  i64toi32_i32$5 = $411;
  i64toi32_i32$0 = $421$hi;
  i64toi32_i32$4 = $377;
  i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
  i64toi32_i32$2 = i64toi32_i32$5 | i64toi32_i32$4 | 0;
  i64toi32_i32$5 = 536870911;
  i64toi32_i32$4 = -65536;
  i64toi32_i32$5 = i64toi32_i32$0 & i64toi32_i32$5 | 0;
  $423 = i64toi32_i32$2 & i64toi32_i32$4 | 0;
  $423$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $410$hi;
  i64toi32_i32$0 = $410;
  i64toi32_i32$2 = $423$hi;
  i64toi32_i32$4 = $423;
  i64toi32_i32$2 = i64toi32_i32$5 | i64toi32_i32$2 | 0;
  $424$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$2 = $424$hi;
  $402 = i64toi32_i32$0 | i64toi32_i32$4 | 0;
  i64toi32_i32$0 = $4$hi;
  i64toi32_i32$5 = 1205018;
  i64toi32_i32$4 = 0;
  __multi3($406 | 0, $402 | 0, i64toi32_i32$2 | 0, $4 | 0, i64toi32_i32$0 | 0, 1559614445 | 0, i64toi32_i32$5 | 0, 0 | 0, i64toi32_i32$4 | 0);
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$0 = 16375458;
  i64toi32_i32$2 = 0;
  __multi3($3 + 16 | 0 | 0, $4 | 0, i64toi32_i32$4 | 0, 0 | 0, i64toi32_i32$5 | 0, -140716456 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$2 | 0);
  i64toi32_i32$2 = $6$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$4 = 0;
  __multi3($3 + 48 | 0 | 0, $6 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$0 | 0, 5342 | 0, i64toi32_i32$5 | 0, 0 | 0, i64toi32_i32$4 | 0);
  i64toi32_i32$0 = $2;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 36 | 0) >> 2] | 0;
  $12 = i64toi32_i32$4;
  $12$hi = i64toi32_i32$5;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] | 0;
  $11 = i64toi32_i32$5;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] | 0;
  $5 = i64toi32_i32$4;
  $5$hi = i64toi32_i32$5;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] | 0;
  $6 = i64toi32_i32$5;
  $6$hi = i64toi32_i32$4;
  $440 = $3;
  i64toi32_i32$4 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $442 = i64toi32_i32$4;
  $442$hi = i64toi32_i32$5;
  i64toi32_i32$0 = $3;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 176 | 0) >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 180 | 0) >> 2] | 0;
  $7 = i64toi32_i32$5;
  $7$hi = i64toi32_i32$4;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$5 = 16777215;
  i64toi32_i32$2 = -1;
  i64toi32_i32$5 = i64toi32_i32$4 & i64toi32_i32$5 | 0;
  $446 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
  $446$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $442$hi;
  i64toi32_i32$4 = $442;
  i64toi32_i32$0 = $446$hi;
  i64toi32_i32$2 = $446;
  i64toi32_i32$1 = i64toi32_i32$4 - i64toi32_i32$2 | 0;
  i64toi32_i32$6 = i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0;
  i64toi32_i32$3 = i64toi32_i32$6 + i64toi32_i32$0 | 0;
  i64toi32_i32$3 = i64toi32_i32$5 - i64toi32_i32$3 | 0;
  $4 = i64toi32_i32$1;
  $4$hi = i64toi32_i32$3;
  i64toi32_i32$5 = i64toi32_i32$1;
  i64toi32_i32$4 = 0;
  i64toi32_i32$2 = 7;
  i64toi32_i32$0 = i64toi32_i32$2 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
   i64toi32_i32$4 = 0;
   $379 = i64toi32_i32$3 >>> i64toi32_i32$0 | 0;
  } else {
   i64toi32_i32$4 = i64toi32_i32$3 >>> i64toi32_i32$0 | 0;
   $379 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$0 | 0) | 0;
  }
  i64toi32_i32$3 = $379;
  i64toi32_i32$5 = 16777216;
  i64toi32_i32$2 = 0;
  i64toi32_i32$5 = i64toi32_i32$4 & i64toi32_i32$5 | 0;
  $450$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $4$hi;
  i64toi32_i32$5 = $450$hi;
  i64toi32_i32$4 = i64toi32_i32$3 & i64toi32_i32$2 | 0;
  i64toi32_i32$3 = $4$hi;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  i64toi32_i32$4 = $440;
  HEAP32[(i64toi32_i32$4 + 536 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$4 + 540 | 0) >> 2] = i64toi32_i32$1;
  $453 = $3;
  i64toi32_i32$1 = $6$hi;
  $454 = $6;
  $454$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $4$hi;
  i64toi32_i32$5 = $4;
  i64toi32_i32$4 = 0;
  i64toi32_i32$2 = 63;
  i64toi32_i32$3 = i64toi32_i32$2 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$1 >> 31 | 0;
   $380 = i64toi32_i32$1 >> i64toi32_i32$3 | 0;
  } else {
   i64toi32_i32$4 = i64toi32_i32$1 >> i64toi32_i32$3 | 0;
   $380 = (((1 << i64toi32_i32$3 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$3 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$3 | 0) | 0;
  }
  $456$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $454$hi;
  i64toi32_i32$1 = $454;
  i64toi32_i32$5 = $456$hi;
  i64toi32_i32$2 = $380;
  i64toi32_i32$3 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$3 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $457 = i64toi32_i32$3;
  $457$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$4 = $7;
  i64toi32_i32$1 = 0;
  i64toi32_i32$2 = 56;
  i64toi32_i32$5 = i64toi32_i32$2 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $381 = i64toi32_i32$0 >>> i64toi32_i32$5 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$5 | 0;
   $381 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$5 | 0) | 0;
  }
  $459 = $381;
  $459$hi = i64toi32_i32$1;
  i64toi32_i32$0 = ($3 + 176 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$1;
  $14$hi = i64toi32_i32$4;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  i64toi32_i32$2 = 8;
  i64toi32_i32$5 = i64toi32_i32$2 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$5 | 0;
   $382 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$5 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$5 | 0) | 0) | 0 | (i64toi32_i32$4 << i64toi32_i32$5 | 0) | 0;
   $382 = i64toi32_i32$0 << i64toi32_i32$5 | 0;
  }
  $465$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $459$hi;
  i64toi32_i32$4 = $459;
  i64toi32_i32$0 = $465$hi;
  i64toi32_i32$2 = $382;
  i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
  $15 = i64toi32_i32$4 | i64toi32_i32$2 | 0;
  $15$hi = i64toi32_i32$0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 160 | 0) >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 164 | 0) >> 2] | 0;
  $469 = i64toi32_i32$0;
  $469$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $15$hi;
  i64toi32_i32$1 = $15;
  i64toi32_i32$0 = $469$hi;
  i64toi32_i32$2 = $469;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$3 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
  }
  $4 = i64toi32_i32$5;
  $4$hi = i64toi32_i32$3;
  i64toi32_i32$4 = $3;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 128 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$4 + 132 | 0) >> 2] | 0;
  $473 = i64toi32_i32$3;
  $473$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $4$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$3 = $473$hi;
  i64toi32_i32$2 = $473;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $6 = i64toi32_i32$0;
  $6$hi = i64toi32_i32$5;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$4 = 16777215;
  i64toi32_i32$2 = -1;
  i64toi32_i32$4 = i64toi32_i32$5 & i64toi32_i32$4 | 0;
  $476$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $457$hi;
  i64toi32_i32$5 = $457;
  i64toi32_i32$1 = $476$hi;
  i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
  i64toi32_i32$3 = i64toi32_i32$5 - i64toi32_i32$2 | 0;
  i64toi32_i32$6 = i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0;
  i64toi32_i32$0 = i64toi32_i32$6 + i64toi32_i32$1 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 - i64toi32_i32$0 | 0;
  $7 = i64toi32_i32$3;
  $7$hi = i64toi32_i32$0;
  i64toi32_i32$4 = i64toi32_i32$3;
  i64toi32_i32$5 = 0;
  i64toi32_i32$2 = 7;
  i64toi32_i32$1 = i64toi32_i32$2 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
   i64toi32_i32$5 = 0;
   $384 = i64toi32_i32$0 >>> i64toi32_i32$1 | 0;
  } else {
   i64toi32_i32$5 = i64toi32_i32$0 >>> i64toi32_i32$1 | 0;
   $384 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$1 | 0) | 0;
  }
  i64toi32_i32$0 = $384;
  i64toi32_i32$4 = 16777216;
  i64toi32_i32$2 = 0;
  i64toi32_i32$4 = i64toi32_i32$5 & i64toi32_i32$4 | 0;
  $480$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$4 = $480$hi;
  i64toi32_i32$5 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = $7;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
  i64toi32_i32$3 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
  }
  i64toi32_i32$5 = $453;
  HEAP32[(i64toi32_i32$5 + 544 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$5 + 548 | 0) >> 2] = i64toi32_i32$3;
  $483 = $3;
  i64toi32_i32$3 = $5$hi;
  $484 = $5;
  $484$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $7$hi;
  i64toi32_i32$4 = $7;
  i64toi32_i32$5 = 0;
  i64toi32_i32$2 = 63;
  i64toi32_i32$0 = i64toi32_i32$2 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$3 >> 31 | 0;
   $385 = i64toi32_i32$3 >> i64toi32_i32$0 | 0;
  } else {
   i64toi32_i32$5 = i64toi32_i32$3 >> i64toi32_i32$0 | 0;
   $385 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$0 | 0) | 0;
  }
  $486$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $484$hi;
  i64toi32_i32$3 = $484;
  i64toi32_i32$4 = $486$hi;
  i64toi32_i32$2 = $385;
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $487 = i64toi32_i32$0;
  $487$hi = i64toi32_i32$1;
  i64toi32_i32$5 = $3;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 112 | 0) >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 116 | 0) >> 2] | 0;
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$3;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 144 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 148 | 0) >> 2] | 0;
  $492 = i64toi32_i32$3;
  $492$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$5 = $9;
  i64toi32_i32$3 = $492$hi;
  i64toi32_i32$2 = $492;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $7 = i64toi32_i32$4;
  $7$hi = i64toi32_i32$0;
  $494 = i64toi32_i32$4;
  $494$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$1 = $6;
  i64toi32_i32$5 = 0;
  i64toi32_i32$2 = 56;
  i64toi32_i32$3 = i64toi32_i32$2 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
   i64toi32_i32$5 = 0;
   $386 = i64toi32_i32$0 >>> i64toi32_i32$3 | 0;
  } else {
   i64toi32_i32$5 = i64toi32_i32$0 >>> i64toi32_i32$3 | 0;
   $386 = (((1 << i64toi32_i32$3 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$3 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$3 | 0) | 0;
  }
  $496 = $386;
  $496$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $14$hi;
  i64toi32_i32$0 = $14;
  i64toi32_i32$1 = 0;
  i64toi32_i32$2 = 56;
  i64toi32_i32$3 = i64toi32_i32$2 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $387 = i64toi32_i32$5 >>> i64toi32_i32$3 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$5 >>> i64toi32_i32$3 | 0;
   $387 = (((1 << i64toi32_i32$3 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$3 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$3 | 0) | 0;
  }
  $498$hi = i64toi32_i32$1;
  i64toi32_i32$5 = ($3 + 160 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$5 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
  $502 = i64toi32_i32$1;
  $502$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $498$hi;
  i64toi32_i32$5 = $387;
  i64toi32_i32$1 = $502$hi;
  i64toi32_i32$2 = $502;
  i64toi32_i32$3 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$3 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $503$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $4$hi;
  i64toi32_i32$4 = $15$hi;
  i64toi32_i32$4 = $4$hi;
  i64toi32_i32$0 = $4;
  i64toi32_i32$5 = $15$hi;
  i64toi32_i32$2 = $15;
  $506 = i64toi32_i32$4 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0;
  i64toi32_i32$0 = 0;
  $507$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $503$hi;
  i64toi32_i32$2 = i64toi32_i32$3;
  i64toi32_i32$4 = $507$hi;
  i64toi32_i32$5 = $506;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  i64toi32_i32$3 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
  }
  $508$hi = i64toi32_i32$3;
  i64toi32_i32$0 = ($3 + 128 | 0) + 8 | 0;
  i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $512 = i64toi32_i32$3;
  $512$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $508$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$3 = $512$hi;
  i64toi32_i32$5 = $512;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $513$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$1 = $4$hi;
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$2 = $6;
  i64toi32_i32$0 = $4$hi;
  i64toi32_i32$5 = $4;
  $516 = i64toi32_i32$1 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0 | 0) | 0;
  i64toi32_i32$2 = 0;
  $517$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $513$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$1 = $517$hi;
  i64toi32_i32$0 = $516;
  i64toi32_i32$3 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$3 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  i64toi32_i32$2 = i64toi32_i32$3;
  i64toi32_i32$5 = 0;
  i64toi32_i32$0 = 8;
  i64toi32_i32$1 = i64toi32_i32$0 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$2 << i64toi32_i32$1 | 0;
   $388 = 0;
  } else {
   i64toi32_i32$5 = ((1 << i64toi32_i32$1 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$1 | 0) | 0) | 0 | (i64toi32_i32$4 << i64toi32_i32$1 | 0) | 0;
   $388 = i64toi32_i32$2 << i64toi32_i32$1 | 0;
  }
  $519$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $496$hi;
  i64toi32_i32$4 = $496;
  i64toi32_i32$2 = $519$hi;
  i64toi32_i32$0 = $388;
  i64toi32_i32$2 = i64toi32_i32$5 | i64toi32_i32$2 | 0;
  $520 = i64toi32_i32$4 | i64toi32_i32$0 | 0;
  $520$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $494$hi;
  i64toi32_i32$5 = $494;
  i64toi32_i32$4 = $520$hi;
  i64toi32_i32$0 = $520;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  i64toi32_i32$3 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
  }
  $4 = i64toi32_i32$1;
  $4$hi = i64toi32_i32$3;
  i64toi32_i32$2 = $3;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 80 | 0) >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$2 + 84 | 0) >> 2] | 0;
  $524 = i64toi32_i32$3;
  $524$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $4$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$3 = $524$hi;
  i64toi32_i32$0 = $524;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $6 = i64toi32_i32$4;
  $6$hi = i64toi32_i32$1;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$2 = 16777215;
  i64toi32_i32$0 = -1;
  i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
  $527 = i64toi32_i32$5 & i64toi32_i32$0 | 0;
  $527$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $487$hi;
  i64toi32_i32$1 = $487;
  i64toi32_i32$5 = $527$hi;
  i64toi32_i32$0 = $527;
  i64toi32_i32$3 = i64toi32_i32$1 - i64toi32_i32$0 | 0;
  i64toi32_i32$6 = i64toi32_i32$1 >>> 0 < i64toi32_i32$0 >>> 0;
  i64toi32_i32$4 = i64toi32_i32$6 + i64toi32_i32$5 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 - i64toi32_i32$4 | 0;
  $5 = i64toi32_i32$3;
  $5$hi = i64toi32_i32$4;
  i64toi32_i32$2 = i64toi32_i32$3;
  i64toi32_i32$1 = 0;
  i64toi32_i32$0 = 7;
  i64toi32_i32$5 = i64toi32_i32$0 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $389 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
   $389 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$5 | 0) | 0;
  }
  i64toi32_i32$4 = $389;
  i64toi32_i32$2 = 16777216;
  i64toi32_i32$0 = 0;
  i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
  $531$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $5$hi;
  i64toi32_i32$2 = $531$hi;
  i64toi32_i32$1 = i64toi32_i32$4 & i64toi32_i32$0 | 0;
  i64toi32_i32$4 = $5$hi;
  i64toi32_i32$0 = $5;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  i64toi32_i32$3 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
  }
  i64toi32_i32$1 = $483;
  HEAP32[(i64toi32_i32$1 + 552 | 0) >> 2] = i64toi32_i32$5;
  HEAP32[(i64toi32_i32$1 + 556 | 0) >> 2] = i64toi32_i32$3;
  $534 = $3;
  i64toi32_i32$3 = $11$hi;
  $535 = $11;
  $535$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $5$hi;
  i64toi32_i32$2 = $5;
  i64toi32_i32$1 = 0;
  i64toi32_i32$0 = 63;
  i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$3 >> 31 | 0;
   $391 = i64toi32_i32$3 >> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$3 >> i64toi32_i32$4 | 0;
   $391 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  $537$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $535$hi;
  i64toi32_i32$3 = $535;
  i64toi32_i32$2 = $537$hi;
  i64toi32_i32$0 = $391;
  i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $538 = i64toi32_i32$4;
  $538$hi = i64toi32_i32$5;
  i64toi32_i32$1 = $3;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] | 0;
  $14 = i64toi32_i32$5;
  $14$hi = i64toi32_i32$3;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 96 | 0) >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 100 | 0) >> 2] | 0;
  $543 = i64toi32_i32$3;
  $543$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $14$hi;
  i64toi32_i32$1 = $14;
  i64toi32_i32$3 = $543$hi;
  i64toi32_i32$0 = $543;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $5 = i64toi32_i32$2;
  $5$hi = i64toi32_i32$4;
  i64toi32_i32$5 = $3;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 36 | 0) >> 2] | 0;
  $547 = i64toi32_i32$4;
  $547$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $5$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$4 = $547$hi;
  i64toi32_i32$0 = $547;
  i64toi32_i32$3 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$3 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $11 = i64toi32_i32$3;
  $11$hi = i64toi32_i32$2;
  $549 = i64toi32_i32$3;
  $549$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $6$hi;
  i64toi32_i32$1 = $6;
  i64toi32_i32$5 = 0;
  i64toi32_i32$0 = 56;
  i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
   i64toi32_i32$5 = 0;
   $392 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$5 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   $392 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
  }
  $551 = $392;
  $551$hi = i64toi32_i32$5;
  i64toi32_i32$2 = ($3 + 112 | 0) + 8 | 0;
  i64toi32_i32$5 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $555 = i64toi32_i32$5;
  $555$hi = i64toi32_i32$1;
  i64toi32_i32$2 = ($3 + 144 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $559 = i64toi32_i32$1;
  $559$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $555$hi;
  i64toi32_i32$2 = $555;
  i64toi32_i32$1 = $559$hi;
  i64toi32_i32$0 = $559;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  i64toi32_i32$3 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
  }
  $560$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $7$hi;
  i64toi32_i32$3 = $9$hi;
  i64toi32_i32$3 = $7$hi;
  i64toi32_i32$5 = $7;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$0 = $9;
  $563 = i64toi32_i32$3 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$5 >>> 0 < i64toi32_i32$0 >>> 0 | 0) | 0;
  i64toi32_i32$5 = 0;
  $564$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $560$hi;
  i64toi32_i32$0 = i64toi32_i32$4;
  i64toi32_i32$3 = $564$hi;
  i64toi32_i32$2 = $563;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $565$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $4$hi;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$4 = $4$hi;
  i64toi32_i32$5 = $4;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = $7;
  $568 = i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0;
  i64toi32_i32$5 = 0;
  $569$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $565$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$4 = $569$hi;
  i64toi32_i32$0 = $568;
  i64toi32_i32$3 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$3 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $570$hi = i64toi32_i32$1;
  i64toi32_i32$5 = ($3 + 80 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$5 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
  $574 = i64toi32_i32$1;
  $574$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $570$hi;
  i64toi32_i32$5 = i64toi32_i32$3;
  i64toi32_i32$1 = $574$hi;
  i64toi32_i32$0 = $574;
  i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
  i64toi32_i32$3 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
  }
  $575$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $6$hi;
  i64toi32_i32$3 = $4$hi;
  i64toi32_i32$3 = $6$hi;
  i64toi32_i32$2 = $6;
  i64toi32_i32$5 = $4$hi;
  i64toi32_i32$0 = $4;
  $578 = i64toi32_i32$3 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$0 >>> 0 | 0) | 0;
  i64toi32_i32$2 = 0;
  $579$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $575$hi;
  i64toi32_i32$0 = i64toi32_i32$4;
  i64toi32_i32$3 = $579$hi;
  i64toi32_i32$5 = $578;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = 0;
  i64toi32_i32$5 = 8;
  i64toi32_i32$3 = i64toi32_i32$5 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$5 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$3 | 0;
   $393 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$3 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$3 | 0) | 0) | 0 | (i64toi32_i32$4 << i64toi32_i32$3 | 0) | 0;
   $393 = i64toi32_i32$2 << i64toi32_i32$3 | 0;
  }
  $581$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $551$hi;
  i64toi32_i32$4 = $551;
  i64toi32_i32$2 = $581$hi;
  i64toi32_i32$5 = $393;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  $582 = i64toi32_i32$4 | i64toi32_i32$5 | 0;
  $582$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $549$hi;
  i64toi32_i32$0 = $549;
  i64toi32_i32$4 = $582$hi;
  i64toi32_i32$5 = $582;
  i64toi32_i32$3 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$3 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $4 = i64toi32_i32$3;
  $4$hi = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$3;
  i64toi32_i32$0 = 16777215;
  i64toi32_i32$5 = -1;
  i64toi32_i32$0 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
  $585 = i64toi32_i32$2 & i64toi32_i32$5 | 0;
  $585$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $538$hi;
  i64toi32_i32$1 = $538;
  i64toi32_i32$2 = $585$hi;
  i64toi32_i32$5 = $585;
  i64toi32_i32$4 = i64toi32_i32$1 - i64toi32_i32$5 | 0;
  i64toi32_i32$6 = i64toi32_i32$1 >>> 0 < i64toi32_i32$5 >>> 0;
  i64toi32_i32$3 = i64toi32_i32$6 + i64toi32_i32$2 | 0;
  i64toi32_i32$3 = i64toi32_i32$0 - i64toi32_i32$3 | 0;
  $6 = i64toi32_i32$4;
  $6$hi = i64toi32_i32$3;
  i64toi32_i32$0 = i64toi32_i32$4;
  i64toi32_i32$1 = 0;
  i64toi32_i32$5 = 7;
  i64toi32_i32$2 = i64toi32_i32$5 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$5 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $395 = i64toi32_i32$3 >>> i64toi32_i32$2 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$3 >>> i64toi32_i32$2 | 0;
   $395 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$2 | 0) | 0;
  }
  i64toi32_i32$3 = $395;
  i64toi32_i32$0 = 16777216;
  i64toi32_i32$5 = 0;
  i64toi32_i32$0 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
  $589$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$0 = $589$hi;
  i64toi32_i32$1 = i64toi32_i32$3 & i64toi32_i32$5 | 0;
  i64toi32_i32$3 = $6$hi;
  i64toi32_i32$5 = $6;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  i64toi32_i32$1 = $534;
  HEAP32[(i64toi32_i32$1 + 560 | 0) >> 2] = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$1 + 564 | 0) >> 2] = i64toi32_i32$4;
  $592 = $3;
  i64toi32_i32$4 = $12$hi;
  $593 = $12;
  $593$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $6$hi;
  i64toi32_i32$0 = $6;
  i64toi32_i32$1 = 0;
  i64toi32_i32$5 = 63;
  i64toi32_i32$3 = i64toi32_i32$5 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$5 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$4 >> 31 | 0;
   $396 = i64toi32_i32$4 >> i64toi32_i32$3 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$4 >> i64toi32_i32$3 | 0;
   $396 = (((1 << i64toi32_i32$3 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$3 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$3 | 0) | 0;
  }
  $595$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $593$hi;
  i64toi32_i32$4 = $593;
  i64toi32_i32$0 = $595$hi;
  i64toi32_i32$5 = $396;
  i64toi32_i32$3 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$3 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $596 = i64toi32_i32$3;
  $596$hi = i64toi32_i32$2;
  i64toi32_i32$1 = $3;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 48 | 0) >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 52 | 0) >> 2] | 0;
  $598 = i64toi32_i32$2;
  $598$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$1 = $8;
  i64toi32_i32$2 = 0;
  i64toi32_i32$5 = 28;
  i64toi32_i32$0 = i64toi32_i32$5 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$5 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$0 | 0;
   $398 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$0 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$0 | 0) | 0) | 0 | (i64toi32_i32$4 << i64toi32_i32$0 | 0) | 0;
   $398 = i64toi32_i32$1 << i64toi32_i32$0 | 0;
  }
  $600$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $598$hi;
  i64toi32_i32$4 = $598;
  i64toi32_i32$1 = $600$hi;
  i64toi32_i32$5 = $398;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  i64toi32_i32$3 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
  }
  $601$hi = i64toi32_i32$3;
  i64toi32_i32$2 = $3;
  i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $603 = i64toi32_i32$3;
  $603$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $601$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$3 = $603$hi;
  i64toi32_i32$5 = $603;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $604$hi = i64toi32_i32$0;
  i64toi32_i32$4 = $3;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 16 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 20 | 0) >> 2] | 0;
  $606 = i64toi32_i32$0;
  $606$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $604$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$0 = $606$hi;
  i64toi32_i32$5 = $606;
  i64toi32_i32$3 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$3 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $607 = i64toi32_i32$3;
  $607$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $4$hi;
  i64toi32_i32$2 = $4;
  i64toi32_i32$4 = 0;
  i64toi32_i32$5 = 56;
  i64toi32_i32$0 = i64toi32_i32$5 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$5 & 63 | 0) >>> 0) {
   i64toi32_i32$4 = 0;
   $399 = i64toi32_i32$1 >>> i64toi32_i32$0 | 0;
  } else {
   i64toi32_i32$4 = i64toi32_i32$1 >>> i64toi32_i32$0 | 0;
   $399 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$0 | 0) | 0;
  }
  $609 = $399;
  $609$hi = i64toi32_i32$4;
  i64toi32_i32$1 = ($3 + 64 | 0) + 8 | 0;
  i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $613 = i64toi32_i32$4;
  $613$hi = i64toi32_i32$2;
  i64toi32_i32$1 = ($3 + 96 | 0) + 8 | 0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $617 = i64toi32_i32$2;
  $617$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $613$hi;
  i64toi32_i32$1 = $613;
  i64toi32_i32$2 = $617$hi;
  i64toi32_i32$5 = $617;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  i64toi32_i32$3 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
  }
  $618$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $5$hi;
  i64toi32_i32$3 = $14$hi;
  i64toi32_i32$3 = $5$hi;
  i64toi32_i32$4 = $5;
  i64toi32_i32$1 = $14$hi;
  i64toi32_i32$5 = $14;
  $621 = i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$4 >>> 0 < i64toi32_i32$5 >>> 0 | 0) | 0;
  i64toi32_i32$4 = 0;
  $622$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $618$hi;
  i64toi32_i32$5 = i64toi32_i32$0;
  i64toi32_i32$3 = $622$hi;
  i64toi32_i32$1 = $621;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $623$hi = i64toi32_i32$0;
  i64toi32_i32$4 = ($3 + 32 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
  $627 = i64toi32_i32$0;
  $627$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $623$hi;
  i64toi32_i32$4 = i64toi32_i32$2;
  i64toi32_i32$0 = $627$hi;
  i64toi32_i32$1 = $627;
  i64toi32_i32$3 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $628$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$2 = $5$hi;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$5 = $11;
  i64toi32_i32$4 = $5$hi;
  i64toi32_i32$1 = $5;
  $631 = i64toi32_i32$2 >>> 0 < i64toi32_i32$4 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$4 | 0) & i64toi32_i32$5 >>> 0 < i64toi32_i32$1 >>> 0 | 0) | 0;
  i64toi32_i32$5 = 0;
  $632$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $628$hi;
  i64toi32_i32$1 = i64toi32_i32$3;
  i64toi32_i32$2 = $632$hi;
  i64toi32_i32$4 = $631;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  i64toi32_i32$3 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$4 >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
  }
  $633$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $4$hi;
  i64toi32_i32$3 = $11$hi;
  i64toi32_i32$3 = $4$hi;
  i64toi32_i32$5 = $4;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$4 = $11;
  $636 = i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$5 >>> 0 < i64toi32_i32$4 >>> 0 | 0) | 0;
  i64toi32_i32$5 = 0;
  $637$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $633$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$3 = $637$hi;
  i64toi32_i32$1 = $636;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$4 = 0;
  i64toi32_i32$1 = 8;
  i64toi32_i32$3 = i64toi32_i32$1 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$5 << i64toi32_i32$3 | 0;
   $400 = 0;
  } else {
   i64toi32_i32$4 = ((1 << i64toi32_i32$3 | 0) - 1 | 0) & (i64toi32_i32$5 >>> (32 - i64toi32_i32$3 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$3 | 0) | 0;
   $400 = i64toi32_i32$5 << i64toi32_i32$3 | 0;
  }
  $639$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $609$hi;
  i64toi32_i32$0 = $609;
  i64toi32_i32$5 = $639$hi;
  i64toi32_i32$1 = $400;
  i64toi32_i32$5 = i64toi32_i32$4 | i64toi32_i32$5 | 0;
  $640 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
  $640$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $607$hi;
  i64toi32_i32$4 = $607;
  i64toi32_i32$0 = $640$hi;
  i64toi32_i32$1 = $640;
  i64toi32_i32$3 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  i64toi32_i32$5 = i64toi32_i32$3;
  i64toi32_i32$4 = 255;
  i64toi32_i32$1 = -1;
  i64toi32_i32$4 = i64toi32_i32$2 & i64toi32_i32$4 | 0;
  $642$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $596$hi;
  i64toi32_i32$2 = $596;
  i64toi32_i32$5 = $642$hi;
  i64toi32_i32$1 = i64toi32_i32$3 & i64toi32_i32$1 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 - i64toi32_i32$1 | 0;
  i64toi32_i32$6 = i64toi32_i32$2 >>> 0 < i64toi32_i32$1 >>> 0;
  i64toi32_i32$3 = i64toi32_i32$6 + i64toi32_i32$5 | 0;
  i64toi32_i32$3 = i64toi32_i32$4 - i64toi32_i32$3 | 0;
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$3;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$1 = 23;
  i64toi32_i32$5 = i64toi32_i32$1 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $401 = i64toi32_i32$3 >>> i64toi32_i32$5 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$3 >>> i64toi32_i32$5 | 0;
   $401 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$5 | 0) | 0;
  }
  i64toi32_i32$3 = $401;
  i64toi32_i32$4 = 256;
  i64toi32_i32$1 = 0;
  i64toi32_i32$4 = i64toi32_i32$2 & i64toi32_i32$4 | 0;
  $646$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $4$hi;
  i64toi32_i32$4 = $646$hi;
  i64toi32_i32$2 = i64toi32_i32$3 & i64toi32_i32$1 | 0;
  i64toi32_i32$3 = $4$hi;
  i64toi32_i32$1 = $4;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  i64toi32_i32$2 = $592;
  HEAP32[(i64toi32_i32$2 + 568 | 0) >> 2] = i64toi32_i32$5;
  HEAP32[(i64toi32_i32$2 + 572 | 0) >> 2] = i64toi32_i32$0;
  cryptoxide__curve25519__scalar__scalar64__reduce256__he9e2203f350907b0($3 + 496 | 0 | 0, $3 + 536 | 0 | 0);
  cryptoxide__curve25519__scalar__scalar64__reduce256__he9e2203f350907b0($0 | 0, $3 + 496 | 0 | 0);
  global$0 = $3 + 576 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__ProposedProtocolParameterUpdates___deserialize__heb1e36bac95b3b52($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $22 = 0, $22$hi = 0, $13 = 0, $23 = 0, $23$hi = 0, i64toi32_i32$4 = 0, $9 = 0, $16 = 0, $77 = 0, $19 = 0, $20 = 0, $78 = 0, $79 = 0, $80 = 0, $81 = 0, $82 = 0, $83 = 0, $84 = 0, $85 = 0, $86 = 0, $87 = 0, $88 = 0, $89 = 0, $90 = 0, $91 = 0, $92 = 0, $93 = 0, $94 = 0, $95 = 0, $96 = 0, $97 = 0, $98 = 0, $99 = 0, $100 = 0, $101 = 0, $102 = 0, $103 = 0, $104 = 0, $7 = 0, $12 = 0, $24 = 0, $4 = 0, $8 = 0, $11 = 0, $17 = 0, $24$hi = 0, $27 = 0, $27$hi = 0, $21 = 0, $105 = 0, $106 = 0, $5 = 0, $6 = 0, $10 = 0, $14 = 0, $15 = 0, $18 = 0, $25 = 0, $25$hi = 0, $26 = 0, $26$hi = 0, $148 = 0, $155 = 0, $168 = 0, $171 = 0, $192 = 0, $198 = 0, $213 = 0, $216 = 0, $217 = 0, $218 = 0, $218$hi = 0, $220$hi = 0, $223 = 0, $257 = 0, $261 = 0, $265 = 0, $270 = 0, $327 = 0, $332 = 0, $349 = 0, $353 = 0, $375 = 0, $382 = 0, $398 = 0, $401 = 0, $416 = 0, $422 = 0, $432 = 0, $446 = 0, $452 = 0, $457 = 0, $462 = 0, $468 = 0, $472 = 0, $484 = 0, $488 = 0, $495 = 0, $501 = 0;
  $2 = global$0 - 1520 | 0;
  global$0 = $2;
  std__thread__local__LocalKey_T___with__h4cd07b14a44a727e($2 + 16 | 0 | 0, 1060968 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $22 = i64toi32_i32$0;
  $22$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $23 = i64toi32_i32$1;
  $23$hi = i64toi32_i32$0;
  $3 = hashbrown__raw__generic__Group__static_empty__hc5a7932fe1bdb1f1() | 0;
  i64toi32_i32$1 = ($2 + 32 | 0) + 24 | 0;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 52 | 0) >> 2] = $3;
  $3 = 0;
  HEAP32[($2 + 48 | 0) >> 2] = 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 64 | 0) >> 2] = 0;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $23$hi;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 40 | 0) >> 2] = $23;
  HEAP32[($2 + 44 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $22$hi;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $22;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$0;
  cbor_event__de__Deserializer_R___map__h7c2a4e830d885a05($2 + 664 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = ($2 + 664 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $22 = i64toi32_i32$0;
  $22$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 672 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 676 | 0) >> 2] | 0;
  $23 = i64toi32_i32$1;
  $23$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 664 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 668 | 0) >> 2] | 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
         break label$6
        }
        i64toi32_i32$2 = $22$hi;
        $4 = $22;
        label$7 : {
         i64toi32_i32$2 = $23$hi;
         i64toi32_i32$3 = $23;
         i64toi32_i32$1 = 0;
         i64toi32_i32$0 = 1;
         if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
          break label$7
         }
         if (!$4) {
          break label$3
         }
        }
        $5 = $2 + 728 | 0;
        $6 = $2 + 716 | 0;
        $7 = $2 + 688 | 0;
        $8 = $2 + 664 | 0 | 1 | 0;
        $9 = ($2 + 1488 | 0) + 8 | 0;
        $10 = $2 + 736 | 0;
        $11 = $2 + 724 | 0;
        $12 = $2 + 696 | 0;
        $13 = $2 + 673 | 0;
        $14 = $2 + 692 | 0;
        $15 = $2 + 1515 | 0;
        label$8 : {
         label$9 : {
          label$10 : {
           label$11 : {
            label$12 : while (1) {
             std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 8 | 0 | 0, $1 | 0);
             $3 = 0;
             $16 = 2;
             label$13 : {
              if (HEAP32[($2 + 12 | 0) >> 2] | 0) {
               break label$13
              }
              i64toi32_i32$3 = 0;
              $23 = 8;
              $23$hi = i64toi32_i32$3;
              i64toi32_i32$3 = 0;
              $22 = 0;
              $22$hi = i64toi32_i32$3;
              break label$4;
             }
             label$14 : {
              if ((($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[($2 + 8 | 0) >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) == (7 | 0)) {
               break label$14
              }
              $cardano_serialization_lib__crypto__GenesisHash_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h220401e78fc09fba($2 + 664 | 0 | 0, $1 | 0);
              if ((HEAPU8[($2 + 664 | 0) >> 0] | 0 | 0) == (1 | 0)) {
               break label$11
              }
              HEAP32[($2 + 1080 | 0) >> 2] = HEAPU8[$13 >> 0] | 0 | ((HEAPU8[($13 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($13 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($13 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              $3 = $13 + 3 | 0;
              $79 = HEAPU8[$3 >> 0] | 0 | ((HEAPU8[($3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              HEAP8[($2 + 1083 | 0) >> 0] = $79;
              HEAP8[($2 + 1084 | 0) >> 0] = $79 >>> 8 | 0;
              HEAP8[($2 + 1085 | 0) >> 0] = $79 >>> 16 | 0;
              HEAP8[($2 + 1086 | 0) >> 0] = $79 >>> 24 | 0;
              $77 = $8;
              HEAP32[($2 + 256 | 0) >> 2] = HEAPU8[$77 >> 0] | 0 | ((HEAPU8[($77 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($77 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($77 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              $17 = $77 + 3 | 0;
              $80 = $17;
              $81 = HEAPU8[$80 >> 0] | 0 | ((HEAPU8[($80 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($80 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($80 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              HEAP8[($2 + 259 | 0) >> 0] = $81;
              HEAP8[($2 + 260 | 0) >> 0] = $81 >>> 8 | 0;
              HEAP8[($2 + 261 | 0) >> 0] = $81 >>> 16 | 0;
              HEAP8[($2 + 262 | 0) >> 0] = $81 >>> 24 | 0;
              HEAP32[($2 + 248 | 0) >> 2] = HEAP32[($2 + 1080 | 0) >> 2] | 0;
              $82 = HEAPU8[($2 + 1083 | 0) >> 0] | 0 | ((HEAPU8[($2 + 1084 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 1085 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 1086 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              HEAP8[($2 + 251 | 0) >> 0] = $82;
              HEAP8[($2 + 252 | 0) >> 0] = $82 >>> 8 | 0;
              HEAP8[($2 + 253 | 0) >> 0] = $82 >>> 16 | 0;
              HEAP8[($2 + 254 | 0) >> 0] = $82 >>> 24 | 0;
              i64toi32_i32$0 = $14;
              i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0;
              i64toi32_i32$2 = 0;
              $24 = i64toi32_i32$3;
              $24$hi = i64toi32_i32$2;
              $18 = HEAPU8[($2 + 672 | 0) >> 0] | 0;
              i64toi32_i32$0 = $2;
              i64toi32_i32$2 = HEAP32[($2 + 680 | 0) >> 2] | 0;
              i64toi32_i32$3 = HEAP32[($2 + 684 | 0) >> 2] | 0;
              $25 = i64toi32_i32$2;
              $25$hi = i64toi32_i32$3;
              i64toi32_i32$0 = $2;
              i64toi32_i32$3 = HEAP32[($2 + 688 | 0) >> 2] | 0;
              i64toi32_i32$2 = 0;
              $26 = i64toi32_i32$3;
              $26$hi = i64toi32_i32$2;
              cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__ProtocolParamUpdate___deserialize__hcf5b8de9802712c3($2 + 664 | 0 | 0, $1 | 0);
              $19 = ($2 + 1080 | 0) + 8 | 0;
              i64toi32_i32$0 = $12 + 8 | 0;
              i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              i64toi32_i32$3 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              $148 = i64toi32_i32$2;
              i64toi32_i32$2 = $19;
              HEAP32[i64toi32_i32$2 >> 2] = $148;
              HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
              $20 = ($2 + 1080 | 0) + 16 | 0;
              i64toi32_i32$0 = $12 + 16 | 0;
              i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              $155 = i64toi32_i32$3;
              i64toi32_i32$3 = $20;
              HEAP32[i64toi32_i32$3 >> 2] = $155;
              HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
              HEAP32[$9 >> 2] = HEAP32[($11 + 8 | 0) >> 2] | 0;
              HEAP32[($2 + 656 | 0) >> 2] = HEAPU8[$13 >> 0] | 0 | ((HEAPU8[($13 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($13 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($13 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              $83 = HEAPU8[$3 >> 0] | 0 | ((HEAPU8[($3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              HEAP8[($2 + 659 | 0) >> 0] = $83;
              HEAP8[($2 + 660 | 0) >> 0] = $83 >>> 8 | 0;
              HEAP8[($2 + 661 | 0) >> 0] = $83 >>> 16 | 0;
              HEAP8[($2 + 662 | 0) >> 0] = $83 >>> 24 | 0;
              i64toi32_i32$0 = $12;
              i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              i64toi32_i32$3 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              $168 = i64toi32_i32$2;
              i64toi32_i32$2 = $2;
              HEAP32[($2 + 1080 | 0) >> 2] = $168;
              HEAP32[($2 + 1084 | 0) >> 2] = i64toi32_i32$3;
              i64toi32_i32$0 = $11;
              i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
              i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
              $171 = i64toi32_i32$3;
              i64toi32_i32$3 = $2;
              HEAP32[($2 + 1488 | 0) >> 2] = $171;
              HEAP32[($2 + 1492 | 0) >> 2] = i64toi32_i32$2;
              $3 = HEAP32[($2 + 720 | 0) >> 2] | 0;
              i64toi32_i32$0 = $2;
              i64toi32_i32$2 = HEAP32[($2 + 688 | 0) >> 2] | 0;
              i64toi32_i32$3 = HEAP32[($2 + 692 | 0) >> 2] | 0;
              $22 = i64toi32_i32$2;
              $22$hi = i64toi32_i32$3;
              i64toi32_i32$0 = $2;
              i64toi32_i32$3 = HEAP32[($2 + 680 | 0) >> 2] | 0;
              i64toi32_i32$2 = HEAP32[($2 + 684 | 0) >> 2] | 0;
              $27 = i64toi32_i32$3;
              $27$hi = i64toi32_i32$2;
              $16 = HEAPU8[($2 + 672 | 0) >> 0] | 0;
              i64toi32_i32$0 = $2;
              i64toi32_i32$2 = HEAP32[($2 + 664 | 0) >> 2] | 0;
              i64toi32_i32$3 = HEAP32[($2 + 668 | 0) >> 2] | 0;
              i64toi32_i32$0 = i64toi32_i32$2;
              i64toi32_i32$2 = 0;
              i64toi32_i32$1 = 1;
              if ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) | 0) {
               break label$10
              }
              memcpy($2 + 264 | 0 | 0, $10 | 0, 344 | 0) | 0;
              $21 = ($2 + 624 | 0) + 8 | 0;
              i64toi32_i32$1 = $19;
              i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
              i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
              $192 = i64toi32_i32$0;
              i64toi32_i32$0 = $21;
              HEAP32[i64toi32_i32$0 >> 2] = $192;
              HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
              $19 = ($2 + 624 | 0) + 16 | 0;
              i64toi32_i32$1 = $20;
              i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
              i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
              $198 = i64toi32_i32$3;
              i64toi32_i32$3 = $19;
              HEAP32[i64toi32_i32$3 >> 2] = $198;
              HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
              $20 = ($2 + 608 | 0) + 8 | 0;
              HEAP32[$20 >> 2] = HEAP32[$9 >> 2] | 0;
              HEAP32[($2 + 648 | 0) >> 2] = HEAP32[($2 + 656 | 0) >> 2] | 0;
              $84 = HEAPU8[($2 + 659 | 0) >> 0] | 0 | ((HEAPU8[($2 + 660 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 661 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 662 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              HEAP8[($2 + 651 | 0) >> 0] = $84;
              HEAP8[($2 + 652 | 0) >> 0] = $84 >>> 8 | 0;
              HEAP8[($2 + 653 | 0) >> 0] = $84 >>> 16 | 0;
              HEAP8[($2 + 654 | 0) >> 0] = $84 >>> 24 | 0;
              i64toi32_i32$1 = $2;
              i64toi32_i32$0 = HEAP32[($2 + 1080 | 0) >> 2] | 0;
              i64toi32_i32$3 = HEAP32[($2 + 1084 | 0) >> 2] | 0;
              $213 = i64toi32_i32$0;
              i64toi32_i32$0 = $2;
              HEAP32[($2 + 624 | 0) >> 2] = $213;
              HEAP32[($2 + 628 | 0) >> 2] = i64toi32_i32$3;
              i64toi32_i32$1 = $2;
              i64toi32_i32$3 = HEAP32[($2 + 1488 | 0) >> 2] | 0;
              i64toi32_i32$0 = HEAP32[($2 + 1492 | 0) >> 2] | 0;
              $216 = i64toi32_i32$3;
              i64toi32_i32$3 = $2;
              HEAP32[($2 + 608 | 0) >> 2] = $216;
              HEAP32[($2 + 612 | 0) >> 2] = i64toi32_i32$0;
              $217 = $2;
              i64toi32_i32$0 = $26$hi;
              $218 = $26;
              $218$hi = i64toi32_i32$0;
              i64toi32_i32$0 = $24$hi;
              i64toi32_i32$1 = $24;
              i64toi32_i32$3 = 0;
              i64toi32_i32$2 = 32;
              i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
              if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
               i64toi32_i32$3 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
               $105 = 0;
              } else {
               i64toi32_i32$3 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
               $105 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
              }
              $220$hi = i64toi32_i32$3;
              i64toi32_i32$3 = $218$hi;
              i64toi32_i32$0 = $218;
              i64toi32_i32$1 = $220$hi;
              i64toi32_i32$2 = $105;
              i64toi32_i32$1 = i64toi32_i32$3 | i64toi32_i32$1 | 0;
              $24 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
              $24$hi = i64toi32_i32$1;
              $85 = $217;
              $78 = $24;
              HEAP8[($85 + 1511 | 0) >> 0] = $78;
              HEAP8[($85 + 1512 | 0) >> 0] = $78 >>> 8 | 0;
              HEAP8[($85 + 1513 | 0) >> 0] = $78 >>> 16 | 0;
              HEAP8[($85 + 1514 | 0) >> 0] = $78 >>> 24 | 0;
              $223 = $15;
              i64toi32_i32$3 = $78;
              i64toi32_i32$0 = 0;
              i64toi32_i32$2 = 32;
              i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
              if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
               i64toi32_i32$0 = 0;
               $106 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
              } else {
               i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
               $106 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$4 | 0) | 0;
              }
              HEAP8[$223 >> 0] = $106;
              HEAP8[($2 + 1495 | 0) >> 0] = $18;
              $86 = HEAPU8[($2 + 259 | 0) >> 0] | 0 | ((HEAPU8[($2 + 260 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 261 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 262 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              HEAP8[($2 + 1491 | 0) >> 0] = $86;
              HEAP8[($2 + 1492 | 0) >> 0] = $86 >>> 8 | 0;
              HEAP8[($2 + 1493 | 0) >> 0] = $86 >>> 16 | 0;
              HEAP8[($2 + 1494 | 0) >> 0] = $86 >>> 24 | 0;
              HEAP32[($2 + 1488 | 0) >> 2] = HEAP32[($2 + 256 | 0) >> 2] | 0;
              $87 = HEAP32[($2 + 248 | 0) >> 2] | 0;
              HEAP8[$9 >> 0] = $87;
              HEAP8[($9 + 1 | 0) >> 0] = $87 >>> 8 | 0;
              HEAP8[($9 + 2 | 0) >> 0] = $87 >>> 16 | 0;
              HEAP8[($9 + 3 | 0) >> 0] = $87 >>> 24 | 0;
              $88 = $9 + 3 | 0;
              $89 = HEAPU8[($2 + 251 | 0) >> 0] | 0 | ((HEAPU8[($2 + 252 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 253 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 254 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              HEAP8[$88 >> 0] = $89;
              HEAP8[($88 + 1 | 0) >> 0] = $89 >>> 8 | 0;
              HEAP8[($88 + 2 | 0) >> 0] = $89 >>> 16 | 0;
              HEAP8[($88 + 3 | 0) >> 0] = $89 >>> 24 | 0;
              i64toi32_i32$0 = $25$hi;
              i64toi32_i32$3 = $2;
              $90 = $25;
              HEAP8[($2 + 1503 | 0) >> 0] = $90;
              HEAP8[($2 + 1504 | 0) >> 0] = $90 >>> 8 | 0;
              HEAP8[($2 + 1505 | 0) >> 0] = $90 >>> 16 | 0;
              HEAP8[($2 + 1506 | 0) >> 0] = $90 >>> 24 | 0;
              HEAP8[($2 + 1507 | 0) >> 0] = i64toi32_i32$0;
              HEAP8[($2 + 1508 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
              HEAP8[($2 + 1509 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
              HEAP8[($2 + 1510 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
              HEAP8[($2 + 664 | 0) >> 0] = $16;
              $91 = $8;
              $92 = HEAP32[($2 + 648 | 0) >> 2] | 0;
              HEAP8[$91 >> 0] = $92;
              HEAP8[($91 + 1 | 0) >> 0] = $92 >>> 8 | 0;
              HEAP8[($91 + 2 | 0) >> 0] = $92 >>> 16 | 0;
              HEAP8[($91 + 3 | 0) >> 0] = $92 >>> 24 | 0;
              $93 = $17;
              $94 = HEAPU8[($2 + 651 | 0) >> 0] | 0 | ((HEAPU8[($2 + 652 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 653 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 654 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              HEAP8[$93 >> 0] = $94;
              HEAP8[($93 + 1 | 0) >> 0] = $94 >>> 8 | 0;
              HEAP8[($93 + 2 | 0) >> 0] = $94 >>> 16 | 0;
              HEAP8[($93 + 3 | 0) >> 0] = $94 >>> 24 | 0;
              i64toi32_i32$0 = $22$hi;
              i64toi32_i32$3 = $2;
              HEAP32[($2 + 680 | 0) >> 2] = $22;
              HEAP32[($2 + 684 | 0) >> 2] = i64toi32_i32$0;
              i64toi32_i32$0 = $27$hi;
              i64toi32_i32$3 = $2;
              HEAP32[($2 + 672 | 0) >> 2] = $27;
              HEAP32[($2 + 676 | 0) >> 2] = i64toi32_i32$0;
              i64toi32_i32$1 = $2;
              i64toi32_i32$0 = HEAP32[($2 + 624 | 0) >> 2] | 0;
              i64toi32_i32$3 = HEAP32[($2 + 628 | 0) >> 2] | 0;
              $257 = i64toi32_i32$0;
              i64toi32_i32$0 = $7;
              $95 = $257;
              HEAP8[i64toi32_i32$0 >> 0] = $95;
              HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $95 >>> 8 | 0;
              HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $95 >>> 16 | 0;
              HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $95 >>> 24 | 0;
              HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$3;
              HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
              HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
              HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
              i64toi32_i32$1 = $21;
              i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
              i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
              $261 = i64toi32_i32$3;
              i64toi32_i32$3 = $7 + 8 | 0;
              $96 = $261;
              HEAP8[i64toi32_i32$3 >> 0] = $96;
              HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $96 >>> 8 | 0;
              HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $96 >>> 16 | 0;
              HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $96 >>> 24 | 0;
              HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$0;
              HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
              HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
              HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
              i64toi32_i32$1 = $19;
              i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
              i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
              $265 = i64toi32_i32$0;
              i64toi32_i32$0 = $7 + 16 | 0;
              $97 = $265;
              HEAP8[i64toi32_i32$0 >> 0] = $97;
              HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $97 >>> 8 | 0;
              HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $97 >>> 16 | 0;
              HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $97 >>> 24 | 0;
              HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$3;
              HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
              HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
              HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
              HEAP32[($2 + 712 | 0) >> 2] = $3;
              i64toi32_i32$1 = $2;
              i64toi32_i32$3 = HEAP32[($2 + 608 | 0) >> 2] | 0;
              i64toi32_i32$0 = HEAP32[($2 + 612 | 0) >> 2] | 0;
              $270 = i64toi32_i32$3;
              i64toi32_i32$3 = $6;
              HEAP32[i64toi32_i32$3 >> 2] = $270;
              HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
              HEAP32[(i64toi32_i32$3 + 8 | 0) >> 2] = HEAP32[$20 >> 2] | 0;
              memcpy($5 | 0, $2 + 264 | 0 | 0, 344 | 0) | 0;
              linked_hash_map__LinkedHashMap_K_2cV_2cS___insert__hfa80207d641c294d($2 + 1080 | 0 | 0, $2 + 32 | 0 | 0, $2 + 1488 | 0 | 0, $2 + 664 | 0 | 0);
              i64toi32_i32$1 = $2;
              i64toi32_i32$0 = HEAP32[($2 + 1080 | 0) >> 2] | 0;
              i64toi32_i32$3 = HEAP32[($2 + 1084 | 0) >> 2] | 0;
              i64toi32_i32$1 = i64toi32_i32$0;
              i64toi32_i32$0 = 0;
              i64toi32_i32$2 = 2;
              if ((i64toi32_i32$1 | 0) != (i64toi32_i32$2 | 0) | (i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | 0) {
               break label$9
              }
              i64toi32_i32$1 = $23$hi;
              i64toi32_i32$2 = $23;
              i64toi32_i32$3 = 0;
              i64toi32_i32$0 = 1;
              if ((i64toi32_i32$2 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$3 | 0) | 0) {
               continue label$12
              }
              if ((HEAP32[($2 + 60 | 0) >> 2] | 0) >>> 0 < $4 >>> 0) {
               continue label$12
              }
              break label$3;
             }
             break label$12;
            };
            cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 664 | 0 | 0, $1 | 0);
            i64toi32_i32$0 = ($2 + 664 | 0) + 16 | 0;
            i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
            i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
            $22 = i64toi32_i32$2;
            $22$hi = i64toi32_i32$1;
            i64toi32_i32$0 = $2;
            i64toi32_i32$1 = HEAP32[($2 + 672 | 0) >> 2] | 0;
            i64toi32_i32$2 = HEAP32[($2 + 676 | 0) >> 2] | 0;
            $23 = i64toi32_i32$1;
            $23$hi = i64toi32_i32$2;
            i64toi32_i32$0 = $2;
            i64toi32_i32$2 = HEAP32[($2 + 664 | 0) >> 2] | 0;
            i64toi32_i32$1 = HEAP32[($2 + 668 | 0) >> 2] | 0;
            i64toi32_i32$0 = i64toi32_i32$2;
            i64toi32_i32$2 = 0;
            i64toi32_i32$3 = 1;
            if ((i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) | 0) {
             break label$5
            }
            i64toi32_i32$0 = $22$hi;
            i64toi32_i32$1 = $2 + 272 | 0;
            HEAP32[i64toi32_i32$1 >> 2] = $22;
            HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
            i64toi32_i32$0 = $23$hi;
            i64toi32_i32$1 = $2;
            HEAP32[($2 + 264 | 0) >> 2] = $23;
            HEAP32[($2 + 268 | 0) >> 2] = i64toi32_i32$0;
            if (($23 & 255 | 0 | 0) == (5 | 0)) {
             break label$3
            }
            HEAP32[($2 + 664 | 0) >> 2] = 0;
            core__panicking__assert_failed__h96d8431cc974b591(0 | 0, $2 + 264 | 0 | 0, 1050312 | 0, $2 + 664 | 0 | 0, 1052100 | 0);
            abort();
           }
           i64toi32_i32$3 = $2 + 704 | 0;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
           $327 = i64toi32_i32$0;
           i64toi32_i32$0 = ($2 + 216 | 0) + 8 | 0;
           HEAP32[i64toi32_i32$0 >> 2] = $327;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
           i64toi32_i32$3 = $2 + 712 | 0;
           i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
           $332 = i64toi32_i32$1;
           i64toi32_i32$1 = $2 + 232 | 0;
           HEAP32[i64toi32_i32$1 >> 2] = $332;
           HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
           HEAP32[(($2 + 200 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 732 | 0) >> 2] | 0;
           HEAP32[($2 + 1080 | 0) >> 2] = HEAPU8[$13 >> 0] | 0 | ((HEAPU8[($13 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($13 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($13 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $98 = $13 + 3 | 0;
           $99 = HEAPU8[$98 >> 0] | 0 | ((HEAPU8[($98 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($98 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($98 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 1083 | 0) >> 0] = $99;
           HEAP8[($2 + 1084 | 0) >> 0] = $99 >>> 8 | 0;
           HEAP8[($2 + 1085 | 0) >> 0] = $99 >>> 16 | 0;
           HEAP8[($2 + 1086 | 0) >> 0] = $99 >>> 24 | 0;
           i64toi32_i32$3 = $2 + 696 | 0;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
           $349 = i64toi32_i32$0;
           i64toi32_i32$0 = $2;
           HEAP32[($2 + 216 | 0) >> 2] = $349;
           HEAP32[($2 + 220 | 0) >> 2] = i64toi32_i32$1;
           i64toi32_i32$3 = $2 + 724 | 0;
           i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
           $353 = i64toi32_i32$1;
           i64toi32_i32$1 = $2;
           HEAP32[($2 + 200 | 0) >> 2] = $353;
           HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$0;
           $3 = HEAP32[($2 + 720 | 0) >> 2] | 0;
           $16 = HEAPU8[($2 + 672 | 0) >> 0] | 0;
           i64toi32_i32$3 = $2;
           i64toi32_i32$0 = HEAP32[($2 + 680 | 0) >> 2] | 0;
           i64toi32_i32$1 = HEAP32[($2 + 684 | 0) >> 2] | 0;
           $23 = i64toi32_i32$0;
           $23$hi = i64toi32_i32$1;
           i64toi32_i32$3 = $2;
           i64toi32_i32$1 = HEAP32[($2 + 688 | 0) >> 2] | 0;
           i64toi32_i32$0 = HEAP32[($2 + 692 | 0) >> 2] | 0;
           $22 = i64toi32_i32$1;
           $22$hi = i64toi32_i32$0;
           $100 = HEAPU8[($2 + 1083 | 0) >> 0] | 0 | ((HEAPU8[($2 + 1084 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 1085 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 1086 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 243 | 0) >> 0] = $100;
           HEAP8[($2 + 244 | 0) >> 0] = $100 >>> 8 | 0;
           HEAP8[($2 + 245 | 0) >> 0] = $100 >>> 16 | 0;
           HEAP8[($2 + 246 | 0) >> 0] = $100 >>> 24 | 0;
           HEAP32[($2 + 240 | 0) >> 2] = HEAP32[($2 + 1080 | 0) >> 2] | 0;
           break label$8;
          }
          i64toi32_i32$3 = ($2 + 1080 | 0) + 8 | 0;
          i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
          $375 = i64toi32_i32$0;
          i64toi32_i32$0 = ($2 + 216 | 0) + 8 | 0;
          HEAP32[i64toi32_i32$0 >> 2] = $375;
          HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
          i64toi32_i32$3 = ($2 + 1080 | 0) + 16 | 0;
          i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
          $382 = i64toi32_i32$1;
          i64toi32_i32$1 = ($2 + 216 | 0) + 16 | 0;
          HEAP32[i64toi32_i32$1 >> 2] = $382;
          HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
          HEAP32[(($2 + 200 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 1488 | 0) + 8 | 0) >> 2] | 0;
          HEAP32[($2 + 240 | 0) >> 2] = HEAP32[($2 + 656 | 0) >> 2] | 0;
          $101 = HEAPU8[($2 + 659 | 0) >> 0] | 0 | ((HEAPU8[($2 + 660 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 661 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 662 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          HEAP8[($2 + 243 | 0) >> 0] = $101;
          HEAP8[($2 + 244 | 0) >> 0] = $101 >>> 8 | 0;
          HEAP8[($2 + 245 | 0) >> 0] = $101 >>> 16 | 0;
          HEAP8[($2 + 246 | 0) >> 0] = $101 >>> 24 | 0;
          i64toi32_i32$3 = $2;
          i64toi32_i32$0 = HEAP32[($2 + 1080 | 0) >> 2] | 0;
          i64toi32_i32$1 = HEAP32[($2 + 1084 | 0) >> 2] | 0;
          $398 = i64toi32_i32$0;
          i64toi32_i32$0 = $2;
          HEAP32[($2 + 216 | 0) >> 2] = $398;
          HEAP32[($2 + 220 | 0) >> 2] = i64toi32_i32$1;
          i64toi32_i32$3 = $2;
          i64toi32_i32$1 = HEAP32[($2 + 1488 | 0) >> 2] | 0;
          i64toi32_i32$0 = HEAP32[($2 + 1492 | 0) >> 2] | 0;
          $401 = i64toi32_i32$1;
          i64toi32_i32$1 = $2;
          HEAP32[($2 + 200 | 0) >> 2] = $401;
          HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$0;
          i64toi32_i32$0 = $27$hi;
          $23 = $27;
          $23$hi = i64toi32_i32$0;
          break label$8;
         }
         core__ptr__drop_in_place_cardano_serialization_lib__ProtocolParamUpdate___h92eeb91cabd2847d($2 + 1080 | 0 | 0);
         alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($2 + 676 | 0 | 0, 1051628 | 0, 33 | 0);
         $3 = 0;
         $1 = ($2 + 664 | 0) + 8 | 0;
         HEAP32[$1 >> 2] = 0;
         i64toi32_i32$3 = $2 + 696 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $416 = i64toi32_i32$0;
         i64toi32_i32$0 = ($2 + 216 | 0) + 8 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $416;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$3 = $2 + 704 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $422 = i64toi32_i32$1;
         i64toi32_i32$1 = ($2 + 216 | 0) + 16 | 0;
         HEAP32[i64toi32_i32$1 >> 2] = $422;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
         HEAP32[($2 + 240 | 0) >> 2] = HEAPU8[($2 + 665 | 0) >> 0] | 0 | ((HEAPU8[($2 + 666 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 667 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 668 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $102 = HEAPU8[($2 + 668 | 0) >> 0] | 0 | ((HEAPU8[($2 + 669 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 670 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 671 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[($2 + 243 | 0) >> 0] = $102;
         HEAP8[($2 + 244 | 0) >> 0] = $102 >>> 8 | 0;
         HEAP8[($2 + 245 | 0) >> 0] = $102 >>> 16 | 0;
         HEAP8[($2 + 246 | 0) >> 0] = $102 >>> 24 | 0;
         i64toi32_i32$3 = $2 + 688 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $432 = i64toi32_i32$0;
         i64toi32_i32$0 = $2;
         HEAP32[($2 + 216 | 0) >> 2] = $432;
         HEAP32[($2 + 220 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$3 = ($2 + 664 | 0) + 16 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $22 = i64toi32_i32$1;
         $22$hi = i64toi32_i32$0;
         i64toi32_i32$3 = $1;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $23 = i64toi32_i32$0;
         $23$hi = i64toi32_i32$1;
         $16 = 4;
        }
        if (($16 & 255 | 0 | 0) != (19 | 0)) {
         break label$4
        }
        break label$3;
       }
       i64toi32_i32$3 = $2 + 696 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $446 = i64toi32_i32$1;
       i64toi32_i32$1 = $2 + 224 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $446;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$3 = $2 + 704 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $452 = i64toi32_i32$0;
       i64toi32_i32$0 = ($2 + 216 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $452;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$3 = ($2 + 664 | 0) + 24 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $457 = i64toi32_i32$1;
       i64toi32_i32$1 = $2;
       HEAP32[($2 + 216 | 0) >> 2] = $457;
       HEAP32[($2 + 220 | 0) >> 2] = i64toi32_i32$0;
       $16 = 2;
       break label$4;
      }
      i64toi32_i32$3 = $2 + 696 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $462 = i64toi32_i32$0;
      i64toi32_i32$0 = $2 + 224 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $462;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$3 = $2 + 704 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $468 = i64toi32_i32$1;
      i64toi32_i32$1 = ($2 + 216 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $468;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$3 = $2 + 688 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $472 = i64toi32_i32$0;
      i64toi32_i32$0 = $2;
      HEAP32[($2 + 216 | 0) >> 2] = $472;
      HEAP32[($2 + 220 | 0) >> 2] = i64toi32_i32$1;
     }
     i64toi32_i32$1 = $22$hi;
     i64toi32_i32$0 = ($2 + 664 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $22;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $23$hi;
     i64toi32_i32$0 = ($2 + 664 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $23;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$3 = $2;
     i64toi32_i32$1 = HEAP32[($2 + 216 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 220 | 0) >> 2] | 0;
     $484 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 688 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $484;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$3 = $2;
     i64toi32_i32$0 = HEAP32[($2 + 200 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 204 | 0) >> 2] | 0;
     $488 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 716 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $488;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$3 = ($2 + 216 | 0) + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $495 = i64toi32_i32$1;
     i64toi32_i32$1 = ($2 + 664 | 0) + 32 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $495;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$3 = ($2 + 216 | 0) + 16 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $501 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 704 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $501;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($2 + 724 | 0) >> 2] = HEAP32[(($2 + 200 | 0) + 8 | 0) >> 2] | 0;
     HEAP8[($2 + 664 | 0) >> 0] = $16;
     $103 = HEAP32[($2 + 240 | 0) >> 2] | 0;
     HEAP8[($2 + 665 | 0) >> 0] = $103;
     HEAP8[($2 + 666 | 0) >> 0] = $103 >>> 8 | 0;
     HEAP8[($2 + 667 | 0) >> 0] = $103 >>> 16 | 0;
     HEAP8[($2 + 668 | 0) >> 0] = $103 >>> 24 | 0;
     $104 = HEAPU8[($2 + 243 | 0) >> 0] | 0 | ((HEAPU8[($2 + 244 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 245 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 246 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($2 + 668 | 0) >> 0] = $104;
     HEAP8[($2 + 669 | 0) >> 0] = $104 >>> 8 | 0;
     HEAP8[($2 + 670 | 0) >> 0] = $104 >>> 16 | 0;
     HEAP8[($2 + 671 | 0) >> 0] = $104 >>> 24 | 0;
     HEAP32[($2 + 712 | 0) >> 2] = $3;
     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($2 + 136 | 0 | 0, $2 + 664 | 0 | 0, 1052116 | 0, 32 | 0);
     $1 = HEAPU8[($2 + 136 | 0) >> 0] | 0;
     if (($1 | 0) != (19 | 0)) {
      break label$2
     }
    }
    memcpy($0 + 8 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
    i64toi32_i32$1 = 0;
    $22 = 0;
    $22$hi = i64toi32_i32$1;
    break label$1;
   }
   memcpy($2 + 73 | 0 | 0, $2 + 136 | 0 | 1 | 0 | 0, 63 | 0) | 0;
   HEAP8[($0 + 8 | 0) >> 0] = $1;
   memcpy($0 + 9 | 0 | 0, $2 + 73 | 0 | 0, 63 | 0) | 0;
   $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__h88c250e8947434a9($2 + 32 | 0 | 0);
   label$15 : {
    if (!(HEAP32[($2 + 48 | 0) >> 2] | 0)) {
     break label$15
    }
    hashbrown__raw__RawTable_T_2cA___free_buckets__ha5e2f3faac433f39(($2 + 32 | 0) + 16 | 0 | 0);
   }
   i64toi32_i32$1 = 0;
   $22 = 1;
   $22$hi = i64toi32_i32$1;
  }
  i64toi32_i32$1 = $22$hi;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $22;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $2 + 1520 | 0;
 }
 
 function $cardano_serialization_lib__Certificate_20as_20core__clone__Clone___clone__h097b7190e8dc0410($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, $2 = 0, i64toi32_i32$4 = 0, $5 = 0, $6 = 0, $3 = 0, $15 = 0, $15$hi = 0, $16 = 0, $16$hi = 0, $14 = 0, $14$hi = 0, $4 = 0, $8 = 0, $9 = 0, $7 = 0, $17 = 0, $17$hi = 0, $20$hi = 0, $75 = 0, $20 = 0, $76 = 0, $77 = 0, $78 = 0, $79 = 0, $21$hi = 0, $81 = 0, $82 = 0, $21 = 0, $83 = 0, $84 = 0, $85 = 0, $86 = 0, $87 = 0, $29 = 0, $29$hi = 0, $33$hi = 0, $51 = 0, $51$hi = 0, $55$hi = 0, $80 = 0, $123 = 0, $130 = 0, $134 = 0, $141 = 0, $148 = 0, $155 = 0, $159 = 0, $10 = 0, $11 = 0, $12 = 0, $18 = 0, $18$hi = 0, $19 = 0, $19$hi = 0, $13 = 0, $217 = 0, $222 = 0, $227 = 0, $231 = 0, $252 = 0, $257 = 0, $261 = 0, $265 = 0, $269 = 0, $279 = 0, $282 = 0, $285 = 0, $335 = 0, $373 = 0, $379 = 0, $383 = 0, $421 = 0, $447 = 0, $482 = 0, $517 = 0, $523 = 0, $527 = 0, $531 = 0, $536 = 0, $541 = 0, $546 = 0;
  $2 = global$0 - 272 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      switch (HEAPU8[$1 >> 0] | 0 | 0) {
      default:
       i64toi32_i32$2 = $1 + 24 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = 0;
       $29 = i64toi32_i32$0;
       $29$hi = i64toi32_i32$1;
       i64toi32_i32$2 = $1 + 28 | 0;
       i64toi32_i32$1 = HEAPU16[i64toi32_i32$2 >> 1] | 0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$2 = i64toi32_i32$1;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $81 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
        $81 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       $33$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $29$hi;
       i64toi32_i32$0 = $29;
       i64toi32_i32$2 = $33$hi;
       i64toi32_i32$3 = $81;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
       $14 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
       $14$hi = i64toi32_i32$2;
       $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
       i64toi32_i32$1 = $1 + 8 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $15 = i64toi32_i32$2;
       $15$hi = i64toi32_i32$0;
       i64toi32_i32$1 = $1 + 16 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $16 = i64toi32_i32$0;
       $16$hi = i64toi32_i32$2;
       $4 = HEAPU16[($1 + 2 | 0) >> 1] | 0;
       $5 = HEAPU8[($1 + 1 | 0) >> 0] | 0;
       $6 = 0;
       break label$1;
      case 1:
       i64toi32_i32$1 = $1 + 24 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$0 = 0;
       $51 = i64toi32_i32$2;
       $51$hi = i64toi32_i32$0;
       i64toi32_i32$1 = $1 + 28 | 0;
       i64toi32_i32$0 = HEAPU16[i64toi32_i32$1 >> 1] | 0;
       i64toi32_i32$2 = 0;
       i64toi32_i32$1 = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        $82 = 0;
       } else {
        i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
        $82 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       }
       $55$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $51$hi;
       i64toi32_i32$2 = $51;
       i64toi32_i32$1 = $55$hi;
       i64toi32_i32$3 = $82;
       i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
       $14 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       $14$hi = i64toi32_i32$1;
       $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
       i64toi32_i32$0 = $1 + 8 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
       $15 = i64toi32_i32$1;
       $15$hi = i64toi32_i32$2;
       i64toi32_i32$0 = $1 + 16 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
       $16 = i64toi32_i32$2;
       $16$hi = i64toi32_i32$1;
       $4 = HEAPU16[($1 + 2 | 0) >> 1] | 0;
       $5 = HEAPU8[($1 + 1 | 0) >> 0] | 0;
       $6 = 1;
       break label$1;
      case 2:
       HEAP32[(($2 + 72 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 48 | 0) >> 2] | 0;
       i64toi32_i32$0 = $1 + 40 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
       $80 = i64toi32_i32$1;
       i64toi32_i32$1 = $2;
       HEAP32[(i64toi32_i32$1 + 72 | 0) >> 2] = $80;
       HEAP32[(i64toi32_i32$1 + 76 | 0) >> 2] = i64toi32_i32$2;
       $7 = HEAPU8[($1 + 57 | 0) >> 0] | 0;
       $8 = HEAPU8[($1 + 56 | 0) >> 0] | 0;
       $9 = HEAP32[($1 + 52 | 0) >> 2] | 0;
       i64toi32_i32$0 = $1 + 32 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
       $17 = i64toi32_i32$2;
       $17$hi = i64toi32_i32$1;
       i64toi32_i32$0 = $1 + 24 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
       $14 = i64toi32_i32$1;
       $14$hi = i64toi32_i32$2;
       $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
       i64toi32_i32$0 = $1 + 8 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
       $15 = i64toi32_i32$2;
       $15$hi = i64toi32_i32$1;
       i64toi32_i32$0 = $1 + 16 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
       $16 = i64toi32_i32$1;
       $16$hi = i64toi32_i32$2;
       $6 = 2;
       $4 = HEAPU16[($1 + 2 | 0) >> 1] | 0;
       $5 = HEAPU8[($1 + 1 | 0) >> 0] | 0;
       break label$1;
      case 3:
       $5 = ($2 + 136 | 0) + 24 | 0;
       $75 = $1 + 132 | 0;
       HEAP32[$5 >> 2] = HEAPU8[$75 >> 0] | 0 | ((HEAPU8[($75 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($75 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($75 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $3 = ($2 + 136 | 0) + 16 | 0;
       i64toi32_i32$0 = $1 + 124 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $123 = i64toi32_i32$2;
       i64toi32_i32$2 = $3;
       HEAP32[i64toi32_i32$2 >> 2] = $123;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       $4 = ($2 + 136 | 0) + 8 | 0;
       i64toi32_i32$0 = $1 + 116 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $130 = i64toi32_i32$1;
       i64toi32_i32$1 = $4;
       HEAP32[i64toi32_i32$1 >> 2] = $130;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$0 = $1 + 108 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $134 = i64toi32_i32$2;
       i64toi32_i32$2 = $2;
       HEAP32[(i64toi32_i32$2 + 136 | 0) >> 2] = $134;
       HEAP32[(i64toi32_i32$2 + 140 | 0) >> 2] = i64toi32_i32$1;
       $6 = (i64toi32_i32$2 + 168 | 0) + 24 | 0;
       i64toi32_i32$0 = $1 + 160 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $141 = i64toi32_i32$1;
       i64toi32_i32$1 = $6;
       HEAP32[i64toi32_i32$1 >> 2] = $141;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
       $7 = ($2 + 168 | 0) + 16 | 0;
       i64toi32_i32$0 = $1 + 152 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $148 = i64toi32_i32$2;
       i64toi32_i32$2 = $7;
       HEAP32[i64toi32_i32$2 >> 2] = $148;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       $8 = ($2 + 168 | 0) + 8 | 0;
       i64toi32_i32$0 = $1 + 144 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $155 = i64toi32_i32$1;
       i64toi32_i32$1 = $8;
       HEAP32[i64toi32_i32$1 >> 2] = $155;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$0 = $1 + 136 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $159 = i64toi32_i32$2;
       i64toi32_i32$2 = $2;
       HEAP32[(i64toi32_i32$2 + 168 | 0) >> 2] = $159;
       HEAP32[(i64toi32_i32$2 + 172 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$0 = $1 + 8 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
       $15 = i64toi32_i32$1;
       $15$hi = i64toi32_i32$2;
       i64toi32_i32$0 = $1 + 16 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
       $16 = i64toi32_i32$2;
       $16$hi = i64toi32_i32$1;
       i64toi32_i32$0 = $1 + 24 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
       $14 = i64toi32_i32$1;
       $14$hi = i64toi32_i32$2;
       i64toi32_i32$0 = $1 + 32 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
       $17 = i64toi32_i32$2;
       $17$hi = i64toi32_i32$1;
       $10 = HEAPU8[($1 + 168 | 0) >> 0] | 0;
       $11 = HEAPU8[($1 + 169 | 0) >> 0] | 0;
       $12 = HEAPU16[($1 + 170 | 0) >> 1] | 0;
       i64toi32_i32$0 = $1 + 184 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
       $18 = i64toi32_i32$1;
       $18$hi = i64toi32_i32$2;
       i64toi32_i32$0 = $1 + 176 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
       $19 = i64toi32_i32$2;
       $19$hi = i64toi32_i32$1;
       $13 = HEAP32[($1 + 172 | 0) >> 2] | 0;
       i64toi32_i32$0 = $1 + 192 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
       i64toi32_i32$2 = 0;
       $20 = i64toi32_i32$1;
       $20$hi = i64toi32_i32$2;
       i64toi32_i32$0 = $1 + 196 | 0;
       i64toi32_i32$2 = HEAPU16[i64toi32_i32$0 >> 1] | 0;
       i64toi32_i32$1 = 0;
       $21 = i64toi32_i32$2;
       $21$hi = i64toi32_i32$1;
       $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h25db889dc58a550d($2 + 200 | 0 | 0, $1 + 40 | 0 | 0);
       $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h3d33b90cd2011dc4($2 + 216 | 0 | 0, $1 + 52 | 0 | 0);
       i64toi32_i32$0 = i64toi32_i32$2;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $83 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $83 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       $21 = $83;
       $21$hi = i64toi32_i32$2;
       label$11 : {
        label$12 : {
         $9 = $1 + 64 | 0;
         if (HEAP32[$9 >> 2] | 0) {
          break label$12
         }
         $1 = 0;
         break label$11;
        }
        $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($2 + 88 | 0 | 0, $9 | 0);
        i64toi32_i32$1 = $1 + 100 | 0;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
        $217 = i64toi32_i32$2;
        i64toi32_i32$2 = $2 + 124 | 0;
        HEAP32[i64toi32_i32$2 >> 2] = $217;
        HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$1 = $1 + 92 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
        $222 = i64toi32_i32$0;
        i64toi32_i32$0 = $2 + 116 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $222;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
        i64toi32_i32$1 = $1 + 84 | 0;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
        $227 = i64toi32_i32$2;
        i64toi32_i32$2 = $2 + 108 | 0;
        HEAP32[i64toi32_i32$2 >> 2] = $227;
        HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$1 = $1 + 76 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
        $231 = i64toi32_i32$0;
        i64toi32_i32$0 = $2;
        HEAP32[(i64toi32_i32$0 + 100 | 0) >> 2] = $231;
        HEAP32[(i64toi32_i32$0 + 104 | 0) >> 2] = i64toi32_i32$2;
        $1 = HEAP32[(i64toi32_i32$0 + 88 | 0) >> 2] | 0;
        memcpy(i64toi32_i32$0 + 232 | 0 | 0, i64toi32_i32$0 + 88 | 0 | 4 | 0 | 0, 40 | 0) | 0;
       }
       i64toi32_i32$2 = $20$hi;
       i64toi32_i32$2 = $21$hi;
       i64toi32_i32$2 = $20$hi;
       i64toi32_i32$1 = $20;
       i64toi32_i32$0 = $21$hi;
       i64toi32_i32$3 = $21;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
       $20 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       $20$hi = i64toi32_i32$0;
       HEAP32[(($2 + 32 | 0) + 24 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
       i64toi32_i32$2 = $3;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $252 = i64toi32_i32$0;
       i64toi32_i32$0 = ($2 + 32 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $252;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $4;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $257 = i64toi32_i32$1;
       i64toi32_i32$1 = ($2 + 32 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $257;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = $8;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $261 = i64toi32_i32$0;
       i64toi32_i32$0 = $2 + 8 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $261;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $7;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $265 = i64toi32_i32$1;
       i64toi32_i32$1 = $2 + 16 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $265;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = $6;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $269 = i64toi32_i32$0;
       i64toi32_i32$0 = $2 + 24 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $269;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       HEAP32[(($2 + 72 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 200 | 0) + 8 | 0) >> 2] | 0;
       i64toi32_i32$2 = $2;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 136 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 140 | 0) >> 2] | 0;
       $279 = i64toi32_i32$1;
       i64toi32_i32$1 = i64toi32_i32$2;
       HEAP32[(i64toi32_i32$1 + 32 | 0) >> 2] = $279;
       HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = i64toi32_i32$1;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 168 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$1 + 172 | 0) >> 2] | 0;
       $282 = i64toi32_i32$0;
       i64toi32_i32$0 = i64toi32_i32$2;
       HEAP32[i64toi32_i32$0 >> 2] = $282;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = i64toi32_i32$0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 200 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$0 + 204 | 0) >> 2] | 0;
       $285 = i64toi32_i32$1;
       i64toi32_i32$1 = i64toi32_i32$2;
       HEAP32[(i64toi32_i32$1 + 72 | 0) >> 2] = $285;
       HEAP32[(i64toi32_i32$1 + 76 | 0) >> 2] = i64toi32_i32$0;
       HEAP16[(i64toi32_i32$1 + 68 | 0) >> 1] = HEAPU16[(i64toi32_i32$1 + 226 | 0) >> 1] | 0;
       HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] = HEAPU16[(i64toi32_i32$1 + 222 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 224 | 0) >> 1] | 0) << 16 | 0) | 0;
       $7 = HEAPU8[(i64toi32_i32$1 + 221 | 0) >> 0] | 0;
       $8 = HEAPU8[(i64toi32_i32$1 + 220 | 0) >> 0] | 0;
       $9 = HEAP32[(i64toi32_i32$1 + 216 | 0) >> 2] | 0;
       memcpy(i64toi32_i32$1 + 88 | 0 | 0, i64toi32_i32$1 + 232 | 0 | 0, 40 | 0) | 0;
       $6 = 3;
       break label$3;
      case 4:
       $6 = 4;
       $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
       i64toi32_i32$2 = $1 + 32 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = 0;
       $17 = i64toi32_i32$0;
       $17$hi = i64toi32_i32$1;
       i64toi32_i32$2 = $1 + 24 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $14 = i64toi32_i32$1;
       $14$hi = i64toi32_i32$0;
       i64toi32_i32$2 = $1 + 16 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $16 = i64toi32_i32$0;
       $16$hi = i64toi32_i32$1;
       i64toi32_i32$2 = $1 + 8 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $15 = i64toi32_i32$1;
       $15$hi = i64toi32_i32$0;
       break label$2;
      case 5:
       HEAP32[(($2 + 72 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 48 | 0) >> 2] | 0;
       $84 = $1 + 62 | 0;
       HEAP16[(($2 + 64 | 0) + 4 | 0) >> 1] = HEAPU8[$84 >> 0] | 0 | ((HEAPU8[($84 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
       i64toi32_i32$2 = $1 + 40 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $335 = i64toi32_i32$0;
       i64toi32_i32$0 = $2;
       HEAP32[(i64toi32_i32$0 + 72 | 0) >> 2] = $335;
       HEAP32[(i64toi32_i32$0 + 76 | 0) >> 2] = i64toi32_i32$1;
       $76 = $1 + 58 | 0;
       HEAP32[(i64toi32_i32$0 + 64 | 0) >> 2] = HEAPU8[$76 >> 0] | 0 | ((HEAPU8[($76 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($76 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($76 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = $1 + 32 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $17 = i64toi32_i32$1;
       $17$hi = i64toi32_i32$0;
       i64toi32_i32$2 = $1 + 24 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $14 = i64toi32_i32$0;
       $14$hi = i64toi32_i32$1;
       i64toi32_i32$2 = $1 + 16 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $16 = i64toi32_i32$1;
       $16$hi = i64toi32_i32$0;
       i64toi32_i32$2 = $1 + 8 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $15 = i64toi32_i32$0;
       $15$hi = i64toi32_i32$1;
       $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
       $4 = HEAPU16[($1 + 2 | 0) >> 1] | 0;
       $9 = HEAP32[($1 + 52 | 0) >> 2] | 0;
       $8 = HEAPU8[($1 + 56 | 0) >> 0] | 0;
       $7 = HEAPU8[($1 + 57 | 0) >> 0] | 0;
       $5 = HEAPU8[($1 + 1 | 0) >> 0] | 0;
       i64toi32_i32$2 = $1 + 81 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $373 = i64toi32_i32$1;
       i64toi32_i32$1 = $2 + 101 | 0;
       $77 = $373;
       HEAP8[i64toi32_i32$1 >> 0] = $77;
       HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $77 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $77 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $77 >>> 24 | 0;
       HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
       HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
       i64toi32_i32$2 = $1 + 76 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $379 = i64toi32_i32$0;
       i64toi32_i32$0 = ($2 + 88 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $379;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $1 + 68 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $383 = i64toi32_i32$1;
       i64toi32_i32$1 = $2;
       HEAP32[(i64toi32_i32$1 + 88 | 0) >> 2] = $383;
       HEAP32[(i64toi32_i32$1 + 92 | 0) >> 2] = i64toi32_i32$0;
       $1 = HEAP32[($1 + 64 | 0) >> 2] | 0;
       $6 = 5;
       break label$1;
      case 6:
       break label$4;
      };
     }
     $5 = $1 + 16 | 0;
     $8 = HEAPU8[($1 + 56 | 0) >> 0] | 0;
     i64toi32_i32$0 = 0;
     $15 = 1;
     $15$hi = i64toi32_i32$0;
     label$13 : {
      label$14 : {
       i64toi32_i32$2 = $1 + 8 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       i64toi32_i32$2 = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 1;
       if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
        break label$14
       }
       i64toi32_i32$3 = $5;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $16 = i64toi32_i32$2;
       $16$hi = i64toi32_i32$1;
       i64toi32_i32$1 = 0;
       $15 = 0;
       $15$hi = i64toi32_i32$1;
       break label$13;
      }
      $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h7490700a7eed2994(($2 + 88 | 0) + 8 | 0 | 0, $5 | 0);
      i64toi32_i32$3 = $2 + 112 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $17 = i64toi32_i32$1;
      $17$hi = i64toi32_i32$2;
      i64toi32_i32$3 = ($2 + 88 | 0) + 16 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $14 = i64toi32_i32$2;
      $14$hi = i64toi32_i32$1;
      $9 = HEAP32[($2 + 132 | 0) >> 2] | 0;
      i64toi32_i32$3 = $2;
      i64toi32_i32$1 = HEAP32[($2 + 96 | 0) >> 2] | 0;
      i64toi32_i32$2 = HEAP32[($2 + 100 | 0) >> 2] | 0;
      $16 = i64toi32_i32$1;
      $16$hi = i64toi32_i32$2;
     }
     HEAP32[($2 + 80 | 0) >> 2] = HEAP32[($2 + 128 | 0) >> 2] | 0;
     i64toi32_i32$3 = $2 + 120 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $421 = i64toi32_i32$2;
     i64toi32_i32$2 = $2;
     HEAP32[(i64toi32_i32$2 + 72 | 0) >> 2] = $421;
     HEAP32[(i64toi32_i32$2 + 76 | 0) >> 2] = i64toi32_i32$1;
     $6 = 6;
    }
   }
  }
  HEAP8[($0 + 1 | 0) >> 0] = $5;
  HEAP8[$0 >> 0] = $6;
  i64toi32_i32$1 = $17$hi;
  i64toi32_i32$2 = $0 + 32 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $17;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $14$hi;
  i64toi32_i32$2 = $0 + 24 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $14;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $16$hi;
  i64toi32_i32$2 = $0 + 16 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $16;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $15$hi;
  i64toi32_i32$2 = $0 + 8 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $15;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($0 + 4 | 0) >> 2] = $3;
  HEAP16[($0 + 2 | 0) >> 1] = $4;
  i64toi32_i32$3 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 72 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[($2 + 76 | 0) >> 2] | 0;
  $447 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 40 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $447;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  HEAP8[($0 + 57 | 0) >> 0] = $7;
  HEAP8[($0 + 56 | 0) >> 0] = $8;
  HEAP32[($0 + 52 | 0) >> 2] = $9;
  $78 = $0 + 58 | 0;
  $79 = HEAP32[($2 + 64 | 0) >> 2] | 0;
  HEAP8[$78 >> 0] = $79;
  HEAP8[($78 + 1 | 0) >> 0] = $79 >>> 8 | 0;
  HEAP8[($78 + 2 | 0) >> 0] = $79 >>> 16 | 0;
  HEAP8[($78 + 3 | 0) >> 0] = $79 >>> 24 | 0;
  HEAP32[($0 + 48 | 0) >> 2] = HEAP32[(($2 + 72 | 0) + 8 | 0) >> 2] | 0;
  $85 = $0 + 62 | 0;
  $86 = HEAPU16[(($2 + 64 | 0) + 4 | 0) >> 1] | 0;
  HEAP8[$85 >> 0] = $86;
  HEAP8[($85 + 1 | 0) >> 0] = $86 >>> 8 | 0;
  HEAP32[($0 + 64 | 0) >> 2] = $1;
  memcpy($0 + 68 | 0 | 0, $2 + 88 | 0 | 0, 40 | 0) | 0;
  $482 = $0 + 196 | 0;
  i64toi32_i32$2 = $20$hi;
  i64toi32_i32$3 = $20;
  i64toi32_i32$1 = 0;
  i64toi32_i32$0 = 32;
  i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $87 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   $87 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP16[$482 >> 1] = $87;
  i64toi32_i32$1 = $20$hi;
  HEAP32[($0 + 192 | 0) >> 2] = $20;
  i64toi32_i32$1 = $18$hi;
  i64toi32_i32$3 = $0 + 184 | 0;
  HEAP32[i64toi32_i32$3 >> 2] = $18;
  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $19$hi;
  i64toi32_i32$3 = $0 + 176 | 0;
  HEAP32[i64toi32_i32$3 >> 2] = $19;
  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($0 + 172 | 0) >> 2] = $13;
  HEAP16[($0 + 170 | 0) >> 1] = $12;
  HEAP8[($0 + 169 | 0) >> 0] = $11;
  HEAP8[($0 + 168 | 0) >> 0] = $10;
  HEAP32[($0 + 132 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 24 | 0) >> 2] | 0;
  i64toi32_i32$2 = ($2 + 32 | 0) + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $517 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 124 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $517;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
  i64toi32_i32$2 = ($2 + 32 | 0) + 8 | 0;
  i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $523 = i64toi32_i32$3;
  i64toi32_i32$3 = $0 + 116 | 0;
  HEAP32[i64toi32_i32$3 >> 2] = $523;
  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
  $527 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 108 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $527;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
  i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $531 = i64toi32_i32$3;
  i64toi32_i32$3 = $0 + 136 | 0;
  HEAP32[i64toi32_i32$3 >> 2] = $531;
  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $536 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 144 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $536;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
  i64toi32_i32$2 = $2 + 16 | 0;
  i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $541 = i64toi32_i32$3;
  i64toi32_i32$3 = $0 + 152 | 0;
  HEAP32[i64toi32_i32$3 >> 2] = $541;
  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2 + 24 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $546 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 160 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $546;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
  global$0 = $2 + 272 | 0;
 }
 
 function $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__clone_subtree__h1f9e2acc901ac417($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $18 = 0, $14 = 0, $15 = 0, $5 = 0, $10 = 0, $16 = 0, $21 = 0, $7 = 0, $9 = 0, $20 = 0, $11 = 0, $23 = 0, $12 = 0, $6 = 0, $8 = 0, $13 = 0, $17 = 0, $19 = 0, $22 = 0, $92 = 0, $93 = 0, $94 = 0, $95 = 0, $97 = 0, $98 = 0, $99 = 0, $101 = 0, $102 = 0, $103 = 0, $104 = 0, $105 = 0, $26 = 0, $26$hi = 0, $106 = 0, $24 = 0, $25 = 0, $51 = 0, $58 = 0, $65 = 0, $69 = 0, $82 = 0, $89 = 0, $96 = 0, $100 = 0, $120 = 0, $126 = 0, $132 = 0, $138 = 0, $143 = 0, $146 = 0, $158 = 0, $162 = 0, $166 = 0, $181 = 0, $185 = 0, $192 = 0, $196 = 0, $205 = 0, $209 = 0, $213 = 0, $218 = 0, $222 = 0, $226 = 0, $231 = 0, $235 = 0, $239 = 0, $324 = 0, $331 = 0, $338 = 0, $342 = 0, $355 = 0, $362 = 0, $366 = 0, $370 = 0, $390 = 0, $396 = 0, $402 = 0, $408 = 0, $413 = 0, $416 = 0, $432 = 0, $438 = 0, $442 = 0, $460 = 0, $464 = 0, $468 = 0, $472 = 0, $477 = 0, $481 = 0, $488 = 0, $492 = 0, $496 = 0, $500 = 0, $505 = 0, $511 = 0, $517 = 0, $554 = 0;
  $3 = global$0 - 288 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     if ($1) {
      break label$3
     }
     $4 = alloc__boxed__Box_T_2cA___new_uninit_in__h1d1537549f7a0074() | 0;
     HEAP16[($4 + 1458 | 0) >> 1] = 0;
     HEAP32[($4 + 1056 | 0) >> 2] = 0;
     $5 = 0;
     label$4 : {
      if (!(HEAPU16[($2 + 1458 | 0) >> 1] | 0)) {
       break label$4
      }
      $6 = $3 + 24 | 0 | 4 | 0;
      $7 = 0;
      $8 = $3 + 26 | 0;
      $9 = 0;
      $5 = 0;
      label$5 : while (1) {
       $10 = ($3 + 88 | 0) + 24 | 0;
       $1 = $2 + $7 | 0;
       i64toi32_i32$2 = $1 + 1088 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $51 = i64toi32_i32$0;
       i64toi32_i32$0 = $10;
       HEAP32[i64toi32_i32$0 >> 2] = $51;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       $11 = ($3 + 88 | 0) + 16 | 0;
       i64toi32_i32$2 = $1 + 1080 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $58 = i64toi32_i32$1;
       i64toi32_i32$1 = $11;
       HEAP32[i64toi32_i32$1 >> 2] = $58;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       $12 = ($3 + 88 | 0) + 8 | 0;
       i64toi32_i32$2 = $1 + 1072 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $65 = i64toi32_i32$0;
       i64toi32_i32$0 = $12;
       HEAP32[i64toi32_i32$0 >> 2] = $65;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $1 + 1064 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $69 = i64toi32_i32$1;
       i64toi32_i32$1 = $3;
       HEAP32[(i64toi32_i32$1 + 88 | 0) >> 2] = $69;
       HEAP32[(i64toi32_i32$1 + 92 | 0) >> 2] = i64toi32_i32$0;
       $13 = HEAP32[($1 + 1060 | 0) >> 2] | 0;
       $14 = (i64toi32_i32$1 + 192 | 0) + 24 | 0;
       $1 = $2 + $9 | 0;
       i64toi32_i32$2 = $1 + 52 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $82 = i64toi32_i32$0;
       i64toi32_i32$0 = $14;
       HEAP32[i64toi32_i32$0 >> 2] = $82;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       $15 = ($3 + 192 | 0) + 16 | 0;
       i64toi32_i32$2 = $1 + 44 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $89 = i64toi32_i32$1;
       i64toi32_i32$1 = $15;
       HEAP32[i64toi32_i32$1 >> 2] = $89;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       $16 = ($3 + 192 | 0) + 8 | 0;
       i64toi32_i32$2 = $1 + 36 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $96 = i64toi32_i32$0;
       i64toi32_i32$0 = $16;
       HEAP32[i64toi32_i32$0 >> 2] = $96;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $1 + 28 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $100 = i64toi32_i32$1;
       i64toi32_i32$1 = $3;
       HEAP32[(i64toi32_i32$1 + 192 | 0) >> 2] = $100;
       HEAP32[(i64toi32_i32$1 + 196 | 0) >> 2] = i64toi32_i32$0;
       $17 = HEAP32[($1 + 24 | 0) >> 2] | 0;
       i64toi32_i32$2 = $1;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $26 = i64toi32_i32$0;
       $26$hi = i64toi32_i32$1;
       $18 = 0;
       label$6 : {
        if ((HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
         break label$6
        }
        $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($6 | 0, $1 + 12 | 0 | 0);
        $18 = 1;
       }
       $19 = ($3 + 56 | 0) + 8 | 0;
       i64toi32_i32$2 = ($3 + 24 | 0) + 8 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $120 = i64toi32_i32$1;
       i64toi32_i32$1 = $19;
       HEAP32[i64toi32_i32$1 >> 2] = $120;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       $20 = ($3 + 152 | 0) + 8 | 0;
       i64toi32_i32$2 = $16;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $126 = i64toi32_i32$0;
       i64toi32_i32$0 = $20;
       HEAP32[i64toi32_i32$0 >> 2] = $126;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       $21 = ($3 + 152 | 0) + 16 | 0;
       i64toi32_i32$2 = $15;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $132 = i64toi32_i32$1;
       i64toi32_i32$1 = $21;
       HEAP32[i64toi32_i32$1 >> 2] = $132;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       $22 = ($3 + 152 | 0) + 24 | 0;
       i64toi32_i32$2 = $14;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $138 = i64toi32_i32$0;
       i64toi32_i32$0 = $22;
       HEAP32[i64toi32_i32$0 >> 2] = $138;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       HEAP32[($3 + 24 | 0) >> 2] = $18;
       i64toi32_i32$2 = $3;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
       $143 = i64toi32_i32$1;
       i64toi32_i32$1 = i64toi32_i32$2;
       HEAP32[(i64toi32_i32$1 + 56 | 0) >> 2] = $143;
       HEAP32[(i64toi32_i32$1 + 60 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = i64toi32_i32$1;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 192 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$1 + 196 | 0) >> 2] | 0;
       $146 = i64toi32_i32$0;
       i64toi32_i32$0 = i64toi32_i32$2;
       HEAP32[(i64toi32_i32$0 + 152 | 0) >> 2] = $146;
       HEAP32[(i64toi32_i32$0 + 156 | 0) >> 2] = i64toi32_i32$1;
       $23 = 0;
       label$7 : {
        if ((HEAPU8[($1 + 64 | 0) >> 0] | 0 | 0) != (1 | 0)) {
         break label$7
        }
        $92 = $1 + 89 | 0;
        HEAP32[$14 >> 2] = HEAPU8[$92 >> 0] | 0 | ((HEAPU8[($92 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($92 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($92 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$2 = $1 + 81 | 0;
        i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $158 = i64toi32_i32$1;
        i64toi32_i32$1 = $15;
        HEAP32[i64toi32_i32$1 >> 2] = $158;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = $1 + 73 | 0;
        i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $162 = i64toi32_i32$0;
        i64toi32_i32$0 = $16;
        HEAP32[i64toi32_i32$0 >> 2] = $162;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$2 = $1 + 65 | 0;
        i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $166 = i64toi32_i32$1;
        i64toi32_i32$1 = $3;
        HEAP32[(i64toi32_i32$1 + 192 | 0) >> 2] = $166;
        HEAP32[(i64toi32_i32$1 + 196 | 0) >> 2] = i64toi32_i32$0;
        $23 = 1;
       }
       $18 = HEAPU16[($4 + 1458 | 0) >> 1] | 0;
       if ($18 >>> 0 >= 11 >>> 0) {
        break label$1
       }
       HEAP16[($4 + 1458 | 0) >> 1] = $18 + 1 | 0;
       $1 = $4 + Math_imul($18, 36) | 0;
       i64toi32_i32$2 = $12;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $181 = i64toi32_i32$0;
       i64toi32_i32$0 = $1 + 1072 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $181;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $3;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 88 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 92 | 0) >> 2] | 0;
       $185 = i64toi32_i32$1;
       i64toi32_i32$1 = $1 + 1064 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $185;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       HEAP32[($1 + 1060 | 0) >> 2] = $13;
       i64toi32_i32$2 = $11;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $192 = i64toi32_i32$0;
       i64toi32_i32$0 = $1 + 1080 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $192;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $10;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $196 = i64toi32_i32$1;
       i64toi32_i32$1 = $1 + 1088 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $196;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       $1 = $4 + Math_imul($18, 96) | 0;
       HEAP32[($1 + 24 | 0) >> 2] = $17;
       i64toi32_i32$2 = $3;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 152 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 156 | 0) >> 2] | 0;
       $205 = i64toi32_i32$0;
       i64toi32_i32$0 = $1;
       HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = $205;
       HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $19;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $209 = i64toi32_i32$1;
       i64toi32_i32$1 = $1 + 16 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $209;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = $22;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $213 = i64toi32_i32$0;
       i64toi32_i32$0 = $1 + 52 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $213;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$1 = $26$hi;
       i64toi32_i32$0 = $1;
       HEAP32[i64toi32_i32$0 >> 2] = $26;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $3;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
       $218 = i64toi32_i32$1;
       i64toi32_i32$1 = $1;
       HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $218;
       HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = $20;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $222 = i64toi32_i32$0;
       i64toi32_i32$0 = $1 + 36 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $222;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $21;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $226 = i64toi32_i32$1;
       i64toi32_i32$1 = $1 + 44 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $226;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       HEAP8[($1 + 64 | 0) >> 0] = $23;
       i64toi32_i32$2 = $3;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 192 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 196 | 0) >> 2] | 0;
       $231 = i64toi32_i32$0;
       i64toi32_i32$0 = $1;
       $93 = $231;
       HEAP8[(i64toi32_i32$0 + 65 | 0) >> 0] = $93;
       HEAP8[(i64toi32_i32$0 + 66 | 0) >> 0] = $93 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 67 | 0) >> 0] = $93 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 68 | 0) >> 0] = $93 >>> 24 | 0;
       HEAP8[(i64toi32_i32$0 + 69 | 0) >> 0] = i64toi32_i32$1;
       HEAP8[(i64toi32_i32$0 + 70 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 71 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 72 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
       i64toi32_i32$2 = $16;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $235 = i64toi32_i32$1;
       i64toi32_i32$1 = $1 + 73 | 0;
       $94 = $235;
       HEAP8[i64toi32_i32$1 >> 0] = $94;
       HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $94 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $94 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $94 >>> 24 | 0;
       HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
       HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
       i64toi32_i32$2 = $15;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $239 = i64toi32_i32$0;
       i64toi32_i32$0 = $1 + 81 | 0;
       $95 = $239;
       HEAP8[i64toi32_i32$0 >> 0] = $95;
       HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $95 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $95 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $95 >>> 24 | 0;
       HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
       HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
       $97 = $1 + 89 | 0;
       $98 = HEAP32[$14 >> 2] | 0;
       HEAP8[$97 >> 0] = $98;
       HEAP8[($97 + 1 | 0) >> 0] = $98 >>> 8 | 0;
       HEAP8[($97 + 2 | 0) >> 0] = $98 >>> 16 | 0;
       HEAP8[($97 + 3 | 0) >> 0] = $98 >>> 24 | 0;
       $106 = HEAPU8[($3 + 24 | 0) >> 0] | 0 | ((HEAPU8[($3 + 25 | 0) >> 0] | 0) << 8 | 0) | 0;
       HEAP8[($1 + 93 | 0) >> 0] = $106;
       HEAP8[($1 + 94 | 0) >> 0] = $106 >>> 8 | 0;
       HEAP8[($1 + 95 | 0) >> 0] = HEAPU8[$8 >> 0] | 0;
       $7 = $7 + 36 | 0;
       $9 = $9 + 96 | 0;
       $5 = $5 + 1 | 0;
       if ($5 >>> 0 < (HEAPU16[($2 + 1458 | 0) >> 1] | 0) >>> 0) {
        continue label$5
       }
       break label$5;
      };
     }
     HEAP32[($0 + 8 | 0) >> 2] = $5;
     HEAP32[($0 + 4 | 0) >> 2] = $4;
     HEAP32[$0 >> 2] = 0;
     break label$2;
    }
    $24 = $1 + -1 | 0;
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__clone_subtree__h1f9e2acc901ac417($3 | 0, $24 | 0, HEAP32[($2 + 1464 | 0) >> 2] | 0 | 0);
    label$8 : {
     label$9 : {
      $4 = HEAP32[($3 + 4 | 0) >> 2] | 0;
      if (!$4) {
       break label$9
      }
      $18 = (HEAP32[$3 >> 2] | 0) + 1 | 0;
      break label$8;
     }
     $4 = alloc__boxed__Box_T_2cA___new_uninit_in__h1d1537549f7a0074() | 0;
     HEAP16[($4 + 1458 | 0) >> 1] = 0;
     HEAP32[($4 + 1056 | 0) >> 2] = 0;
     $18 = 1;
    }
    $1 = alloc__boxed__Box_T_2cA___new_uninit_in__h3c49993511c7b2e3() | 0;
    HEAP32[($1 + 1464 | 0) >> 2] = $4;
    $16 = 0;
    HEAP16[($1 + 1458 | 0) >> 1] = 0;
    HEAP32[($1 + 1056 | 0) >> 2] = 0;
    HEAP16[($4 + 1456 | 0) >> 1] = 0;
    HEAP32[($4 + 1056 | 0) >> 2] = $1;
    HEAP32[($3 + 4 | 0) >> 2] = $1;
    HEAP32[$3 >> 2] = $18;
    HEAP32[($3 + 20 | 0) >> 2] = $1;
    HEAP32[($3 + 16 | 0) >> 2] = $18;
    label$10 : {
     if (!(HEAPU16[($2 + 1458 | 0) >> 1] | 0)) {
      break label$10
     }
     $18 = ($3 + 192 | 0) + 65 | 0;
     $14 = ($3 + 192 | 0) + 28 | 0;
     $15 = ($3 + 192 | 0) + 8 | 0;
     $4 = $3 + 152 | 0 | 4 | 0;
     $7 = 1468;
     $11 = HEAP32[($3 + 8 | 0) >> 2] | 0;
     $9 = 0;
     $23 = 0;
     label$11 : while (1) {
      $12 = ($3 + 24 | 0) + 24 | 0;
      $1 = $2 + $16 | 0;
      i64toi32_i32$2 = $1 + 1088 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $324 = i64toi32_i32$1;
      i64toi32_i32$1 = $12;
      HEAP32[i64toi32_i32$1 >> 2] = $324;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      $13 = ($3 + 24 | 0) + 16 | 0;
      i64toi32_i32$2 = $1 + 1080 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $331 = i64toi32_i32$0;
      i64toi32_i32$0 = $13;
      HEAP32[i64toi32_i32$0 >> 2] = $331;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      $17 = ($3 + 24 | 0) + 8 | 0;
      i64toi32_i32$2 = $1 + 1072 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $338 = i64toi32_i32$1;
      i64toi32_i32$1 = $17;
      HEAP32[i64toi32_i32$1 >> 2] = $338;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $1 + 1064 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $342 = i64toi32_i32$0;
      i64toi32_i32$0 = $3;
      HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = $342;
      HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = i64toi32_i32$1;
      $19 = HEAP32[($1 + 1060 | 0) >> 2] | 0;
      $20 = (i64toi32_i32$0 + 192 | 0) + 24 | 0;
      $1 = $2 + $9 | 0;
      i64toi32_i32$2 = $1 + 52 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $355 = i64toi32_i32$1;
      i64toi32_i32$1 = $20;
      HEAP32[i64toi32_i32$1 >> 2] = $355;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      $21 = ($3 + 192 | 0) + 16 | 0;
      i64toi32_i32$2 = $1 + 44 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $362 = i64toi32_i32$0;
      i64toi32_i32$0 = $21;
      HEAP32[i64toi32_i32$0 >> 2] = $362;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $1 + 36 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $366 = i64toi32_i32$1;
      i64toi32_i32$1 = $15;
      HEAP32[i64toi32_i32$1 >> 2] = $366;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $1 + 28 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $370 = i64toi32_i32$0;
      i64toi32_i32$0 = $3;
      HEAP32[(i64toi32_i32$0 + 192 | 0) >> 2] = $370;
      HEAP32[(i64toi32_i32$0 + 196 | 0) >> 2] = i64toi32_i32$1;
      $22 = HEAP32[($1 + 24 | 0) >> 2] | 0;
      i64toi32_i32$2 = $1;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $26 = i64toi32_i32$1;
      $26$hi = i64toi32_i32$0;
      $5 = 0;
      $10 = 0;
      label$12 : {
       if ((HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
        break label$12
       }
       $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($4 | 0, $1 + 12 | 0 | 0);
       $10 = 1;
      }
      $8 = ($3 + 120 | 0) + 8 | 0;
      i64toi32_i32$2 = ($3 + 152 | 0) + 8 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $390 = i64toi32_i32$0;
      i64toi32_i32$0 = $8;
      HEAP32[i64toi32_i32$0 >> 2] = $390;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      $6 = ($3 + 88 | 0) + 8 | 0;
      i64toi32_i32$2 = $15;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $396 = i64toi32_i32$1;
      i64toi32_i32$1 = $6;
      HEAP32[i64toi32_i32$1 >> 2] = $396;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      $25 = ($3 + 88 | 0) + 16 | 0;
      i64toi32_i32$2 = $21;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $402 = i64toi32_i32$0;
      i64toi32_i32$0 = $25;
      HEAP32[i64toi32_i32$0 >> 2] = $402;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      $21 = ($3 + 88 | 0) + 24 | 0;
      i64toi32_i32$2 = $20;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $408 = i64toi32_i32$1;
      i64toi32_i32$1 = $21;
      HEAP32[i64toi32_i32$1 >> 2] = $408;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[($3 + 152 | 0) >> 2] = $10;
      i64toi32_i32$2 = $3;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 152 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 156 | 0) >> 2] | 0;
      $413 = i64toi32_i32$0;
      i64toi32_i32$0 = i64toi32_i32$2;
      HEAP32[(i64toi32_i32$0 + 120 | 0) >> 2] = $413;
      HEAP32[(i64toi32_i32$0 + 124 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = i64toi32_i32$0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 192 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$0 + 196 | 0) >> 2] | 0;
      $416 = i64toi32_i32$1;
      i64toi32_i32$1 = i64toi32_i32$2;
      HEAP32[(i64toi32_i32$1 + 88 | 0) >> 2] = $416;
      HEAP32[(i64toi32_i32$1 + 92 | 0) >> 2] = i64toi32_i32$0;
      label$13 : {
       if ((HEAPU8[($1 + 64 | 0) >> 0] | 0 | 0) != (1 | 0)) {
        break label$13
       }
       $99 = $1 + 89 | 0;
       HEAP32[(($3 + 56 | 0) + 24 | 0) >> 2] = HEAPU8[$99 >> 0] | 0 | ((HEAPU8[($99 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($99 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($99 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = $1 + 81 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $432 = i64toi32_i32$0;
       i64toi32_i32$0 = ($3 + 56 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $432;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $1 + 73 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $438 = i64toi32_i32$1;
       i64toi32_i32$1 = ($3 + 56 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $438;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = $1 + 65 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $442 = i64toi32_i32$0;
       i64toi32_i32$0 = $3;
       HEAP32[(i64toi32_i32$0 + 56 | 0) >> 2] = $442;
       HEAP32[(i64toi32_i32$0 + 60 | 0) >> 2] = i64toi32_i32$1;
       $5 = 1;
      }
      $23 = $23 + 1 | 0;
      $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__clone_subtree__h1f9e2acc901ac417($3 + 136 | 0 | 0, $24 | 0, HEAP32[($2 + $7 | 0) >> 2] | 0 | 0);
      $20 = HEAP32[($3 + 144 | 0) >> 2] | 0;
      $1 = HEAP32[($3 + 140 | 0) >> 2] | 0;
      $10 = HEAP32[($3 + 136 | 0) >> 2] | 0;
      i64toi32_i32$2 = $3;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
      $460 = i64toi32_i32$1;
      i64toi32_i32$1 = $4;
      HEAP32[i64toi32_i32$1 >> 2] = $460;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $17;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $464 = i64toi32_i32$0;
      i64toi32_i32$0 = $4 + 8 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $464;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $13;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $468 = i64toi32_i32$1;
      i64toi32_i32$1 = $4 + 16 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $468;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $12;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $472 = i64toi32_i32$0;
      i64toi32_i32$0 = $4 + 24 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $472;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($3 + 152 | 0) >> 2] = $19;
      i64toi32_i32$2 = $3;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 120 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 124 | 0) >> 2] | 0;
      $477 = i64toi32_i32$1;
      i64toi32_i32$1 = $15;
      HEAP32[i64toi32_i32$1 >> 2] = $477;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $8;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $481 = i64toi32_i32$0;
      i64toi32_i32$0 = $15 + 8 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $481;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$1 = $26$hi;
      i64toi32_i32$0 = $3;
      HEAP32[(i64toi32_i32$0 + 192 | 0) >> 2] = $26;
      HEAP32[(i64toi32_i32$0 + 196 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[(i64toi32_i32$0 + 216 | 0) >> 2] = $22;
      i64toi32_i32$2 = i64toi32_i32$0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 88 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$0 + 92 | 0) >> 2] | 0;
      $488 = i64toi32_i32$1;
      i64toi32_i32$1 = $14;
      HEAP32[i64toi32_i32$1 >> 2] = $488;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $6;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $492 = i64toi32_i32$0;
      i64toi32_i32$0 = $14 + 8 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $492;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $25;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $496 = i64toi32_i32$1;
      i64toi32_i32$1 = $14 + 16 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $496;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $21;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $500 = i64toi32_i32$0;
      i64toi32_i32$0 = $14 + 24 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $500;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      HEAP8[($3 + 256 | 0) >> 0] = $5;
      i64toi32_i32$2 = $3;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
      $505 = i64toi32_i32$1;
      i64toi32_i32$1 = $18;
      $101 = $505;
      HEAP8[i64toi32_i32$1 >> 0] = $101;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $101 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $101 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $101 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      i64toi32_i32$2 = (i64toi32_i32$2 + 56 | 0) + 8 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $511 = i64toi32_i32$0;
      i64toi32_i32$0 = $18 + 8 | 0;
      $102 = $511;
      HEAP8[i64toi32_i32$0 >> 0] = $102;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $102 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $102 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $102 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      i64toi32_i32$2 = ($3 + 56 | 0) + 16 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $517 = i64toi32_i32$1;
      i64toi32_i32$1 = $18 + 16 | 0;
      $103 = $517;
      HEAP8[i64toi32_i32$1 >> 0] = $103;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $103 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $103 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $103 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      $104 = $18 + 24 | 0;
      $105 = HEAP32[(($3 + 56 | 0) + 24 | 0) >> 2] | 0;
      HEAP8[$104 >> 0] = $105;
      HEAP8[($104 + 1 | 0) >> 0] = $105 >>> 8 | 0;
      HEAP8[($104 + 2 | 0) >> 0] = $105 >>> 16 | 0;
      HEAP8[($104 + 3 | 0) >> 0] = $105 >>> 24 | 0;
      label$14 : {
       if ($1) {
        break label$14
       }
       $10 = 0;
       $1 = alloc__boxed__Box_T_2cA___new_uninit_in__h1d1537549f7a0074() | 0;
       HEAP16[($1 + 1458 | 0) >> 1] = 0;
       HEAP32[($1 + 1056 | 0) >> 2] = 0;
      }
      alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal___push__h1a08f428e14b4c52($3 + 16 | 0 | 0, $3 + 152 | 0 | 0, $3 + 192 | 0 | 0, $10 | 0, $1 | 0);
      $7 = $7 + 4 | 0;
      $16 = $16 + 36 | 0;
      $9 = $9 + 96 | 0;
      $11 = ($20 + $11 | 0) + 1 | 0;
      if ($23 >>> 0 < (HEAPU16[($2 + 1458 | 0) >> 1] | 0) >>> 0) {
       continue label$11
      }
      break label$11;
     };
     HEAP32[($3 + 8 | 0) >> 2] = $11;
    }
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $554 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[i64toi32_i32$0 >> 2] = $554;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
   }
   global$0 = $3 + 288 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1048619 | 0, 32 | 0, 1048744 | 0);
  abort();
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__TransactionBody___serialize__h766748b3e983f577($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$5 = 0, i64toi32_i32$1 = 0, i64toi32_i32$4 = 0, $4 = 0, $5 = 0, $9 = 0, $10 = 0, $14$hi = 0, $18$hi = 0, $19$hi = 0, $24$hi = 0, $25$hi = 0, $30$hi = 0, $31$hi = 0, $33 = 0, $33$hi = 0, $34$hi = 0, $36 = 0, $36$hi = 0, $37$hi = 0, $39 = 0, $39$hi = 0, $40$hi = 0, $42 = 0, $42$hi = 0, $43$hi = 0, $47$hi = 0, $48$hi = 0, $52$hi = 0, $53$hi = 0, $57$hi = 0, $172 = 0, $177 = 0, $183 = 0, $187 = 0, $238 = 0, $243 = 0, $249 = 0, $253 = 0;
  $3 = global$0 - 80 | 0;
  global$0 = $3;
  $9 = $3;
  $10 = $2;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 1;
  i64toi32_i32$4 = (i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$0 = i64toi32_i32$4 ? 4 : 3;
  i64toi32_i32$3 = i64toi32_i32$4 ? i64toi32_i32$2 : i64toi32_i32$1;
  $14$hi = i64toi32_i32$3;
  i64toi32_i32$3 = 0;
  $18$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $14$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$0 = $18$hi;
  i64toi32_i32$2 = (HEAP32[($1 + 152 | 0) >> 2] | 0 | 0) != (0 | 0);
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  i64toi32_i32$5 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $19$hi = i64toi32_i32$5;
  i64toi32_i32$5 = 0;
  $24$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $19$hi;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$4 = $24$hi;
  i64toi32_i32$2 = (HEAP32[($1 + 44 | 0) >> 2] | 0 | 0) != (0 | 0);
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $25$hi = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  $30$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $25$hi;
  i64toi32_i32$5 = i64toi32_i32$0;
  i64toi32_i32$3 = $30$hi;
  i64toi32_i32$2 = (HEAP32[($1 + 84 | 0) >> 2] | 0 | 0) != (0 | 0);
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $31$hi = i64toi32_i32$0;
  i64toi32_i32$1 = $1;
  i64toi32_i32$0 = HEAPU8[($1 + 204 | 0) >> 0] | 0;
  i64toi32_i32$5 = 0;
  $33 = i64toi32_i32$0;
  $33$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $31$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$0 = $33$hi;
  i64toi32_i32$2 = $33;
  i64toi32_i32$3 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$3 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $34$hi = i64toi32_i32$4;
  i64toi32_i32$5 = $1;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 112 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 116 | 0) >> 2] | 0;
  $36 = i64toi32_i32$4;
  $36$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $34$hi;
  i64toi32_i32$5 = i64toi32_i32$3;
  i64toi32_i32$4 = $36$hi;
  i64toi32_i32$2 = $36;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
  i64toi32_i32$3 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
  }
  $37$hi = i64toi32_i32$3;
  i64toi32_i32$1 = $1;
  i64toi32_i32$3 = HEAP32[($1 + 164 | 0) >> 2] | 0;
  i64toi32_i32$5 = 0;
  $39 = i64toi32_i32$3;
  $39$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $37$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$3 = $39$hi;
  i64toi32_i32$2 = $39;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $40$hi = i64toi32_i32$0;
  i64toi32_i32$5 = $1;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$5 + 237 | 0) >> 0] | 0;
  i64toi32_i32$1 = 0;
  $42 = i64toi32_i32$0;
  $42$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $40$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$0 = $42$hi;
  i64toi32_i32$2 = $42;
  i64toi32_i32$3 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$3 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $43$hi = i64toi32_i32$4;
  i64toi32_i32$4 = 0;
  $47$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $43$hi;
  i64toi32_i32$1 = i64toi32_i32$3;
  i64toi32_i32$5 = $47$hi;
  i64toi32_i32$2 = (HEAP32[($1 + 180 | 0) >> 2] | 0 | 0) != (0 | 0);
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
  i64toi32_i32$3 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
  }
  $48$hi = i64toi32_i32$3;
  i64toi32_i32$3 = 0;
  $52$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $48$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$1 = $52$hi;
  i64toi32_i32$2 = (HEAP32[($1 + 192 | 0) >> 2] | 0 | 0) != (0 | 0);
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $53$hi = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  $57$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $53$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$4 = $57$hi;
  i64toi32_i32$2 = (HEAPU8[($1 + 270 | 0) >> 0] | 0 | 0) != (2 | 0);
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($9 | 0, $10 | 0, 5 | 0, i64toi32_i32$1 | 0, i64toi32_i32$5 | 0);
  $4 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           label$10 : {
            label$11 : {
             label$12 : {
              label$13 : {
               label$14 : {
                label$15 : {
                 label$16 : {
                  label$17 : {
                   label$18 : {
                    label$19 : {
                     label$20 : {
                      label$21 : {
                       label$22 : {
                        label$23 : {
                         label$24 : {
                          label$25 : {
                           label$26 : {
                            label$27 : {
                             label$28 : {
                              label$29 : {
                               label$30 : {
                                if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                 break label$30
                                }
                                i64toi32_i32$5 = 0;
                                cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 0 | 0, i64toi32_i32$5 | 0);
                                if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                 break label$29
                                }
                                cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__TransactionInputs___serialize__h5d5370eb2688b5ac($3 | 0, $1 + 128 | 0 | 0, $2 | 0);
                                $4 = 1;
                                if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                 break label$28
                                }
                                i64toi32_i32$5 = 0;
                                cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 1 | 0, i64toi32_i32$5 | 0);
                                if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                 break label$27
                                }
                                cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__TransactionOutputs___serialize__he3bf8aa07ee2fe6d($3 | 0, $1 + 140 | 0 | 0, $2 | 0);
                                $4 = 1;
                                if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                 break label$26
                                }
                                i64toi32_i32$5 = 0;
                                cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 2 | 0, i64toi32_i32$5 | 0);
                                if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                 break label$25
                                }
                                i64toi32_i32$0 = $1;
                                i64toi32_i32$5 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                                i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                                cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, i64toi32_i32$5 | 0, i64toi32_i32$3 | 0);
                                $4 = 1;
                                if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                 break label$24
                                }
                                label$31 : {
                                 i64toi32_i32$0 = $1;
                                 i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] | 0;
                                 i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] | 0;
                                 i64toi32_i32$0 = i64toi32_i32$3;
                                 i64toi32_i32$3 = 0;
                                 i64toi32_i32$2 = 1;
                                 if ((i64toi32_i32$0 | 0) != (i64toi32_i32$2 | 0) | (i64toi32_i32$5 | 0) != (i64toi32_i32$3 | 0) | 0) {
                                  break label$31
                                 }
                                 i64toi32_i32$0 = 0;
                                 cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 3 | 0, i64toi32_i32$0 | 0);
                                 $4 = 1;
                                 if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                  break label$23
                                 }
                                 i64toi32_i32$2 = $1 + 16 | 0;
                                 i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                                 i64toi32_i32$5 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                                 cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, i64toi32_i32$0 | 0, i64toi32_i32$5 | 0);
                                 if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                  break label$22
                                 }
                                }
                                label$32 : {
                                 $5 = $1 + 152 | 0;
                                 if (!(HEAP32[$5 >> 2] | 0)) {
                                  break label$32
                                 }
                                 i64toi32_i32$5 = 0;
                                 cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 4 | 0, i64toi32_i32$5 | 0);
                                 $4 = 1;
                                 if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                  break label$21
                                 }
                                 cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__Certificates___serialize__h4f1f9d7f05159b8e($3 | 0, $5 | 0, $2 | 0);
                                 if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                  break label$20
                                 }
                                }
                                label$33 : {
                                 if (!(HEAP32[($1 + 44 | 0) >> 2] | 0)) {
                                  break label$33
                                 }
                                 i64toi32_i32$5 = 0;
                                 cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 5 | 0, i64toi32_i32$5 | 0);
                                 $4 = 1;
                                 if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                  break label$19
                                 }
                                 cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__Withdrawals___serialize__h776d4a70d67f4de1($3 | 0, $1 + 24 | 0 | 0, $2 | 0);
                                 if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                  break label$18
                                 }
                                }
                                label$34 : {
                                 if (!(HEAP32[($1 + 84 | 0) >> 2] | 0)) {
                                  break label$34
                                 }
                                 i64toi32_i32$5 = 0;
                                 cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 6 | 0, i64toi32_i32$5 | 0);
                                 $4 = 1;
                                 if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                  break label$17
                                 }
                                 cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__Update___serialize__h3b16321a799d449a($3 | 0, $1 + 64 | 0 | 0, $2 | 0);
                                 if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                  break label$16
                                 }
                                }
                                label$35 : {
                                 if (!(HEAPU8[($1 + 204 | 0) >> 0] | 0)) {
                                  break label$35
                                 }
                                 i64toi32_i32$5 = 0;
                                 cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 7 | 0, i64toi32_i32$5 | 0);
                                 $4 = 1;
                                 if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                  break label$15
                                 }
                                 i64toi32_i32$2 = $1 + 229 | 0;
                                 i64toi32_i32$5 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                 i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                 $172 = i64toi32_i32$5;
                                 i64toi32_i32$5 = $3 + 72 | 0;
                                 HEAP32[i64toi32_i32$5 >> 2] = $172;
                                 HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
                                 i64toi32_i32$2 = $1 + 221 | 0;
                                 i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                 i64toi32_i32$5 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                 $177 = i64toi32_i32$0;
                                 i64toi32_i32$0 = $3 + 64 | 0;
                                 HEAP32[i64toi32_i32$0 >> 2] = $177;
                                 HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$5;
                                 i64toi32_i32$2 = $1 + 213 | 0;
                                 i64toi32_i32$5 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                 i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                 $183 = i64toi32_i32$5;
                                 i64toi32_i32$5 = ($3 + 48 | 0) + 8 | 0;
                                 HEAP32[i64toi32_i32$5 >> 2] = $183;
                                 HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
                                 i64toi32_i32$2 = $1 + 205 | 0;
                                 i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                 i64toi32_i32$5 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                 $187 = i64toi32_i32$0;
                                 i64toi32_i32$0 = $3;
                                 HEAP32[($3 + 48 | 0) >> 2] = $187;
                                 HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$5;
                                 cbor_event__se__Serializer_W___write_bytes__h85f4434ac9a8a060($3 | 0, $2 | 0, $3 + 48 | 0 | 0);
                                 if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                  break label$14
                                 }
                                }
                                label$36 : {
                                 i64toi32_i32$2 = $1;
                                 i64toi32_i32$5 = HEAP32[(i64toi32_i32$2 + 112 | 0) >> 2] | 0;
                                 i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 116 | 0) >> 2] | 0;
                                 i64toi32_i32$2 = i64toi32_i32$5;
                                 i64toi32_i32$5 = 0;
                                 i64toi32_i32$3 = 1;
                                 if ((i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$5 | 0) | 0) {
                                  break label$36
                                 }
                                 i64toi32_i32$2 = 0;
                                 cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 8 | 0, i64toi32_i32$2 | 0);
                                 $4 = 1;
                                 if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                  break label$13
                                 }
                                 i64toi32_i32$3 = $1 + 120 | 0;
                                 i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                                 i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                                 cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, i64toi32_i32$2 | 0, i64toi32_i32$0 | 0);
                                 if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                  break label$12
                                 }
                                }
                                label$37 : {
                                 if ((HEAP32[($1 + 164 | 0) >> 2] | 0 | 0) != (1 | 0)) {
                                  break label$37
                                 }
                                 i64toi32_i32$0 = 0;
                                 cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 9 | 0, i64toi32_i32$0 | 0);
                                 if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                  break label$11
                                 }
                                 cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__Mint___serialize__h19eae2b7c2c53b1d($3 | 0, $1 + 168 | 0 | 0, $2 | 0);
                                 $4 = 1;
                                 if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                  break label$10
                                 }
                                }
                                label$38 : {
                                 if (!(HEAPU8[($1 + 237 | 0) >> 0] | 0)) {
                                  break label$38
                                 }
                                 i64toi32_i32$0 = 0;
                                 cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 11 | 0, i64toi32_i32$0 | 0);
                                 $4 = 1;
                                 if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                  break label$9
                                 }
                                 i64toi32_i32$3 = $1 + 262 | 0;
                                 i64toi32_i32$0 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                 i64toi32_i32$2 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                 $238 = i64toi32_i32$0;
                                 i64toi32_i32$0 = $3 + 72 | 0;
                                 HEAP32[i64toi32_i32$0 >> 2] = $238;
                                 HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
                                 i64toi32_i32$3 = $1 + 254 | 0;
                                 i64toi32_i32$2 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                 i64toi32_i32$0 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                 $243 = i64toi32_i32$2;
                                 i64toi32_i32$2 = $3 + 64 | 0;
                                 HEAP32[i64toi32_i32$2 >> 2] = $243;
                                 HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
                                 i64toi32_i32$3 = $1 + 246 | 0;
                                 i64toi32_i32$0 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                 i64toi32_i32$2 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                 $249 = i64toi32_i32$0;
                                 i64toi32_i32$0 = ($3 + 48 | 0) + 8 | 0;
                                 HEAP32[i64toi32_i32$0 >> 2] = $249;
                                 HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
                                 i64toi32_i32$3 = $1 + 238 | 0;
                                 i64toi32_i32$2 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                 i64toi32_i32$0 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                                 $253 = i64toi32_i32$2;
                                 i64toi32_i32$2 = $3;
                                 HEAP32[($3 + 48 | 0) >> 2] = $253;
                                 HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$0;
                                 cbor_event__se__Serializer_W___write_bytes__h85f4434ac9a8a060($3 | 0, $2 | 0, $3 + 48 | 0 | 0);
                                 if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                  break label$8
                                 }
                                }
                                label$39 : {
                                 $5 = $1 + 180 | 0;
                                 if (!(HEAP32[$5 >> 2] | 0)) {
                                  break label$39
                                 }
                                 i64toi32_i32$0 = 0;
                                 cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 13 | 0, i64toi32_i32$0 | 0);
                                 $4 = 1;
                                 if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                  break label$7
                                 }
                                 cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__TransactionInputs___serialize__h5d5370eb2688b5ac($3 | 0, $5 | 0, $2 | 0);
                                 if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                  break label$6
                                 }
                                }
                                label$40 : {
                                 $5 = $1 + 192 | 0;
                                 if (!(HEAP32[$5 >> 2] | 0)) {
                                  break label$40
                                 }
                                 i64toi32_i32$0 = 0;
                                 cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 14 | 0, i64toi32_i32$0 | 0);
                                 $4 = 1;
                                 if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                  break label$5
                                 }
                                 cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__Ed25519KeyHashes___serialize__h8832695f5a55a024($3 | 0, $5 | 0, $2 | 0);
                                 if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                  break label$4
                                 }
                                }
                                label$41 : {
                                 $1 = $1 + 270 | 0;
                                 if ((HEAPU8[$1 >> 0] | 0 | 0) == (2 | 0)) {
                                  break label$41
                                 }
                                 i64toi32_i32$0 = 0;
                                 cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 15 | 0, i64toi32_i32$0 | 0);
                                 $4 = 1;
                                 if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                  break label$3
                                 }
                                 cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__NetworkId___serialize__h73892ae14f8b751c($3 | 0, $1 | 0, $2 | 0);
                                 if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                                  break label$2
                                 }
                                }
                                HEAP32[($0 + 4 | 0) >> 2] = $2;
                                $4 = 0;
                                break label$1;
                               }
                               memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                               break label$1;
                              }
                              memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                              $4 = 1;
                              break label$1;
                             }
                             memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                             break label$1;
                            }
                            memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                            $4 = 1;
                            break label$1;
                           }
                           memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                           break label$1;
                          }
                          memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                          $4 = 1;
                          break label$1;
                         }
                         memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                         break label$1;
                        }
                        memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                        break label$1;
                       }
                       memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                       $4 = 1;
                       break label$1;
                      }
                      memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                      break label$1;
                     }
                     memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                     $4 = 1;
                     break label$1;
                    }
                    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                    break label$1;
                   }
                   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                   $4 = 1;
                   break label$1;
                  }
                  memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                  break label$1;
                 }
                 memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                 $4 = 1;
                 break label$1;
                }
                memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
                break label$1;
               }
               memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
               $4 = 1;
               break label$1;
              }
              memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
              break label$1;
             }
             memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
             $4 = 1;
             break label$1;
            }
            memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
            $4 = 1;
            break label$1;
           }
           memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
           break label$1;
          }
          memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
          break label$1;
         }
         memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
         $4 = 1;
         break label$1;
        }
        memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
        break label$1;
       }
       memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
       $4 = 1;
       break label$1;
      }
      memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
      break label$1;
     }
     memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
     $4 = 1;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $4 = 1;
  }
  HEAP32[$0 >> 2] = $4;
  global$0 = $3 + 80 | 0;
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h81140d58f8f9ef39($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $2 = 0, $13 = 0, $12 = 0, $3 = 0, $6 = 0, $97 = 0, $98 = 0, $99 = 0, $100 = 0, $4 = 0, $9 = 0, $34 = 0, $34$hi = 0, $35 = 0, $35$hi = 0, $36 = 0, $36$hi = 0, $5 = 0, $10 = 0, $11 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $25 = 0, $26 = 0, $27 = 0, $28 = 0, $29 = 0, $30 = 0, $31 = 0, $32 = 0, $33 = 0, $101 = 0, $102 = 0, $103 = 0, $104 = 0, $7 = 0, $8 = 0, $126 = 0, $139 = 0, $149 = 0, $152 = 0, $155 = 0, $169 = 0, $173 = 0, $177 = 0, $181 = 0, $37 = 0, $37$hi = 0, $38 = 0, $38$hi = 0, $207 = 0, $213 = 0, $219 = 0, $223 = 0, $270 = 0, $273 = 0, $276 = 0, $299 = 0, $307 = 0, $315 = 0, $321 = 0, $327 = 0, $335 = 0, $338 = 0, $341 = 0, $344 = 0, $352 = 0, $360 = 0, $368 = 0, $376 = 0, $395 = 0, $398 = 0, $401 = 0, $404 = 0, $428 = 0, $432 = 0, $464 = 0, $472 = 0, $480 = 0, $484 = 0, $488 = 0, $496 = 0, $504 = 0, $511 = 0, $515 = 0, $519 = 0, $523 = 0, $530 = 0, $534 = 0, $538 = 0, $542 = 0;
  $2 = global$0 - 512 | 0;
  global$0 = $2;
  $3 = HEAP32[$1 >> 2] | 0;
  $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h0b609c68c6c57291($2 | 0, $4 | 0, 0 | 0);
  $5 = HEAP32[$2 >> 2] | 0;
  $6 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $6;
  HEAP32[$0 >> 2] = $5;
  label$1 : {
   if (!$6) {
    break label$1
   }
   $7 = Math_imul($4, 272);
   $8 = $2 + 384 | 0 | 4 | 0;
   $9 = ($2 + 464 | 0) + 24 | 0;
   $10 = ($2 + 352 | 0) + 16 | 0;
   $11 = ($2 + 352 | 0) + 8 | 0;
   $12 = 0;
   $13 = $3;
   label$2 : while (1) {
    if (($7 | 0) == ($12 | 0)) {
     break label$1
    }
    $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hfe677107e1954f8f($2 + 216 | 0 | 0, $13 + 128 | 0 | 0);
    $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h699bb0f3db607312($2 + 232 | 0 | 0, $13 + 140 | 0 | 0);
    i64toi32_i32$2 = $13;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
    $34 = i64toi32_i32$0;
    $34$hi = i64toi32_i32$1;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
    $35 = i64toi32_i32$1;
    $35$hi = i64toi32_i32$0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $36 = i64toi32_i32$0;
    $36$hi = i64toi32_i32$1;
    label$3 : {
     label$4 : {
      if (HEAP32[(i64toi32_i32$2 + 152 | 0) >> 2] | 0) {
       break label$4
      }
      HEAP32[($2 + 248 | 0) >> 2] = 0;
      break label$3;
     }
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h965baa5031061a2e($2 + 248 | 0 | 0, ($3 + $12 | 0) + 152 | 0 | 0);
    }
    label$5 : {
     label$6 : {
      if (HEAP32[($13 + 44 | 0) >> 2] | 0) {
       break label$6
      }
      HEAP32[($2 + 284 | 0) >> 2] = 0;
      break label$5;
     }
     $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h8cac34049618832f($2 + 264 | 0 | 0, ($3 + $12 | 0) + 24 | 0 | 0);
    }
    $14 = 0;
    $15 = 0;
    label$7 : {
     if (!(HEAP32[($13 + 84 | 0) >> 2] | 0)) {
      break label$7
     }
     $1 = $3 + $12 | 0;
     $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h847b9d84e24adaa5($2 + 464 | 0 | 0, $1 + 64 | 0 | 0);
     i64toi32_i32$2 = ($2 + 464 | 0) + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $126 = i64toi32_i32$1;
     i64toi32_i32$1 = ($2 + 328 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $126;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[(($2 + 328 | 0) + 16 | 0) >> 2] = HEAP32[(($2 + 464 | 0) + 16 | 0) >> 2] | 0;
     i64toi32_i32$2 = $9 + 8 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $139 = i64toi32_i32$0;
     i64toi32_i32$0 = ($2 + 304 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $139;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($2 + 504 | 0) >> 2] = HEAP32[($1 + 104 | 0) >> 2] | 0;
     i64toi32_i32$2 = $9 + 16 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $149 = i64toi32_i32$1;
     i64toi32_i32$1 = ($2 + 304 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $149;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 464 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 468 | 0) >> 2] | 0;
     $152 = i64toi32_i32$0;
     i64toi32_i32$0 = i64toi32_i32$2;
     HEAP32[(i64toi32_i32$0 + 328 | 0) >> 2] = $152;
     HEAP32[(i64toi32_i32$0 + 332 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $9;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $155 = i64toi32_i32$1;
     i64toi32_i32$1 = $2;
     HEAP32[(i64toi32_i32$1 + 304 | 0) >> 2] = $155;
     HEAP32[(i64toi32_i32$1 + 308 | 0) >> 2] = i64toi32_i32$0;
     $15 = HEAP32[(i64toi32_i32$1 + 484 | 0) >> 2] | 0;
    }
    label$8 : {
     if ((HEAPU8[($13 + 204 | 0) >> 0] | 0 | 0) != (1 | 0)) {
      break label$8
     }
     $1 = $3 + $12 | 0;
     i64toi32_i32$2 = $1 + 229 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $169 = i64toi32_i32$0;
     i64toi32_i32$0 = ($2 + 352 | 0) + 24 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $169;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $1 + 221 | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $173 = i64toi32_i32$1;
     i64toi32_i32$1 = $10;
     HEAP32[i64toi32_i32$1 >> 2] = $173;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $1 + 213 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $177 = i64toi32_i32$0;
     i64toi32_i32$0 = $11;
     HEAP32[i64toi32_i32$0 >> 2] = $177;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $1 + 205 | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $181 = i64toi32_i32$1;
     i64toi32_i32$1 = $2;
     HEAP32[(i64toi32_i32$1 + 352 | 0) >> 2] = $181;
     HEAP32[(i64toi32_i32$1 + 356 | 0) >> 2] = i64toi32_i32$0;
     $14 = 1;
    }
    i64toi32_i32$2 = $13;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 120 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 124 | 0) >> 2] | 0;
    $37 = i64toi32_i32$0;
    $37$hi = i64toi32_i32$1;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 112 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 116 | 0) >> 2] | 0;
    $38 = i64toi32_i32$1;
    $38$hi = i64toi32_i32$0;
    $16 = 0;
    $1 = 0;
    label$9 : {
     if ((HEAP32[(i64toi32_i32$2 + 164 | 0) >> 2] | 0 | 0) != (1 | 0)) {
      break label$9
     }
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h3d696390b8f8d3c9($8 | 0, ($3 + $12 | 0) + 168 | 0 | 0);
     $1 = 1;
    }
    HEAP32[($2 + 384 | 0) >> 2] = $1;
    label$10 : {
     if ((HEAPU8[($13 + 237 | 0) >> 0] | 0 | 0) != (1 | 0)) {
      break label$10
     }
     $1 = $3 + $12 | 0;
     i64toi32_i32$2 = $1 + 262 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $207 = i64toi32_i32$0;
     i64toi32_i32$0 = ($2 + 400 | 0) + 24 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $207;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $1 + 254 | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $213 = i64toi32_i32$1;
     i64toi32_i32$1 = ($2 + 400 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $213;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $1 + 246 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $219 = i64toi32_i32$0;
     i64toi32_i32$0 = ($2 + 400 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $219;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $1 + 238 | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $223 = i64toi32_i32$1;
     i64toi32_i32$1 = $2;
     HEAP32[(i64toi32_i32$1 + 400 | 0) >> 2] = $223;
     HEAP32[(i64toi32_i32$1 + 404 | 0) >> 2] = i64toi32_i32$0;
     $16 = 1;
    }
    label$11 : {
     label$12 : {
      if (HEAP32[($13 + 180 | 0) >> 2] | 0) {
       break label$12
      }
      HEAP32[($2 + 432 | 0) >> 2] = 0;
      break label$11;
     }
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hfe677107e1954f8f($2 + 432 | 0 | 0, ($3 + $12 | 0) + 180 | 0 | 0);
    }
    $6 = $6 + -1 | 0;
    label$13 : {
     label$14 : {
      if (HEAP32[($13 + 192 | 0) >> 2] | 0) {
       break label$14
      }
      HEAP32[($2 + 448 | 0) >> 2] = 0;
      break label$13;
     }
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h25db889dc58a550d($2 + 448 | 0 | 0, ($3 + $12 | 0) + 192 | 0 | 0);
    }
    $17 = ($2 + 152 | 0) + 8 | 0;
    HEAP32[$17 >> 2] = HEAP32[(($2 + 216 | 0) + 8 | 0) >> 2] | 0;
    $18 = ($2 + 136 | 0) + 8 | 0;
    HEAP32[$18 >> 2] = HEAP32[(($2 + 232 | 0) + 8 | 0) >> 2] | 0;
    $19 = ($2 + 120 | 0) + 8 | 0;
    HEAP32[$19 >> 2] = HEAP32[(($2 + 248 | 0) + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 216 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 220 | 0) >> 2] | 0;
    $270 = i64toi32_i32$0;
    i64toi32_i32$0 = i64toi32_i32$2;
    HEAP32[(i64toi32_i32$2 + 152 | 0) >> 2] = $270;
    HEAP32[(i64toi32_i32$2 + 156 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 232 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 236 | 0) >> 2] | 0;
    $273 = i64toi32_i32$1;
    i64toi32_i32$1 = i64toi32_i32$2;
    HEAP32[(i64toi32_i32$2 + 136 | 0) >> 2] = $273;
    HEAP32[(i64toi32_i32$2 + 140 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 248 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 252 | 0) >> 2] | 0;
    $276 = i64toi32_i32$0;
    i64toi32_i32$0 = i64toi32_i32$2;
    HEAP32[(i64toi32_i32$2 + 120 | 0) >> 2] = $276;
    HEAP32[(i64toi32_i32$2 + 124 | 0) >> 2] = i64toi32_i32$1;
    $20 = HEAPU8[($13 + 270 | 0) >> 0] | 0;
    memcpy(i64toi32_i32$2 + 464 | 0 | 0, i64toi32_i32$2 + 264 | 0 | 0, 40 | 0) | 0;
    $21 = (i64toi32_i32$2 + 192 | 0) + 16 | 0;
    HEAP32[$21 >> 2] = HEAP32[((i64toi32_i32$2 + 328 | 0) + 16 | 0) >> 2] | 0;
    $22 = (i64toi32_i32$2 + 192 | 0) + 8 | 0;
    i64toi32_i32$2 = (i64toi32_i32$2 + 328 | 0) + 8 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $299 = i64toi32_i32$1;
    i64toi32_i32$1 = $22;
    HEAP32[i64toi32_i32$1 >> 2] = $299;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    $23 = ($2 + 168 | 0) + 8 | 0;
    i64toi32_i32$2 = ($2 + 304 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $307 = i64toi32_i32$0;
    i64toi32_i32$0 = $23;
    HEAP32[i64toi32_i32$0 >> 2] = $307;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    $24 = ($2 + 168 | 0) + 16 | 0;
    i64toi32_i32$2 = ($2 + 304 | 0) + 16 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $315 = i64toi32_i32$1;
    i64toi32_i32$1 = $24;
    HEAP32[i64toi32_i32$1 >> 2] = $315;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    $25 = ($2 + 40 | 0) + 8 | 0;
    i64toi32_i32$2 = $11;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $321 = i64toi32_i32$0;
    i64toi32_i32$0 = $25;
    HEAP32[i64toi32_i32$0 >> 2] = $321;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    $26 = ($2 + 40 | 0) + 16 | 0;
    i64toi32_i32$2 = $10;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $327 = i64toi32_i32$1;
    i64toi32_i32$1 = $26;
    HEAP32[i64toi32_i32$1 >> 2] = $327;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    $27 = ($2 + 40 | 0) + 24 | 0;
    i64toi32_i32$2 = ($2 + 352 | 0) + 24 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $335 = i64toi32_i32$0;
    i64toi32_i32$0 = $27;
    HEAP32[i64toi32_i32$0 >> 2] = $335;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 328 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 332 | 0) >> 2] | 0;
    $338 = i64toi32_i32$1;
    i64toi32_i32$1 = i64toi32_i32$2;
    HEAP32[(i64toi32_i32$2 + 192 | 0) >> 2] = $338;
    HEAP32[(i64toi32_i32$2 + 196 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 304 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 308 | 0) >> 2] | 0;
    $341 = i64toi32_i32$0;
    i64toi32_i32$0 = i64toi32_i32$2;
    HEAP32[(i64toi32_i32$2 + 168 | 0) >> 2] = $341;
    HEAP32[(i64toi32_i32$2 + 172 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 352 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 356 | 0) >> 2] | 0;
    $344 = i64toi32_i32$1;
    i64toi32_i32$1 = i64toi32_i32$2;
    HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] = $344;
    HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] = i64toi32_i32$0;
    $28 = (i64toi32_i32$2 + 104 | 0) + 8 | 0;
    i64toi32_i32$2 = (i64toi32_i32$2 + 384 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $352 = i64toi32_i32$0;
    i64toi32_i32$0 = $28;
    HEAP32[i64toi32_i32$0 >> 2] = $352;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    $29 = ($2 + 8 | 0) + 8 | 0;
    i64toi32_i32$2 = ($2 + 400 | 0) + 8 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $360 = i64toi32_i32$1;
    i64toi32_i32$1 = $29;
    HEAP32[i64toi32_i32$1 >> 2] = $360;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    $30 = ($2 + 8 | 0) + 16 | 0;
    i64toi32_i32$2 = ($2 + 400 | 0) + 16 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $368 = i64toi32_i32$0;
    i64toi32_i32$0 = $30;
    HEAP32[i64toi32_i32$0 >> 2] = $368;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    $31 = ($2 + 8 | 0) + 24 | 0;
    i64toi32_i32$2 = ($2 + 400 | 0) + 24 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $376 = i64toi32_i32$1;
    i64toi32_i32$1 = $31;
    HEAP32[i64toi32_i32$1 >> 2] = $376;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    $32 = ($2 + 88 | 0) + 8 | 0;
    HEAP32[$32 >> 2] = HEAP32[(($2 + 432 | 0) + 8 | 0) >> 2] | 0;
    $33 = ($2 + 72 | 0) + 8 | 0;
    HEAP32[$33 >> 2] = HEAP32[(($2 + 448 | 0) + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 384 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 388 | 0) >> 2] | 0;
    $395 = i64toi32_i32$0;
    i64toi32_i32$0 = i64toi32_i32$2;
    HEAP32[(i64toi32_i32$2 + 104 | 0) >> 2] = $395;
    HEAP32[(i64toi32_i32$2 + 108 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 400 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 404 | 0) >> 2] | 0;
    $398 = i64toi32_i32$1;
    i64toi32_i32$1 = i64toi32_i32$2;
    HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $398;
    HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 432 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 436 | 0) >> 2] | 0;
    $401 = i64toi32_i32$0;
    i64toi32_i32$0 = i64toi32_i32$2;
    HEAP32[(i64toi32_i32$2 + 88 | 0) >> 2] = $401;
    HEAP32[(i64toi32_i32$2 + 92 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 448 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 452 | 0) >> 2] | 0;
    $404 = i64toi32_i32$1;
    i64toi32_i32$1 = i64toi32_i32$2;
    HEAP32[(i64toi32_i32$2 + 72 | 0) >> 2] = $404;
    HEAP32[(i64toi32_i32$2 + 76 | 0) >> 2] = i64toi32_i32$0;
    $1 = $5 + $12 | 0;
    i64toi32_i32$0 = $34$hi;
    i64toi32_i32$1 = $1 + 16 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $34;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = $35$hi;
    i64toi32_i32$1 = $1 + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $35;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = $36$hi;
    i64toi32_i32$1 = $1;
    HEAP32[i64toi32_i32$1 >> 2] = $36;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    memcpy(i64toi32_i32$1 + 24 | 0 | 0, i64toi32_i32$2 + 464 | 0 | 0, 40 | 0) | 0;
    HEAP32[(i64toi32_i32$1 + 80 | 0) >> 2] = HEAP32[$21 >> 2] | 0;
    i64toi32_i32$2 = $22;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $428 = i64toi32_i32$0;
    i64toi32_i32$0 = $1 + 72 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $428;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 192 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 196 | 0) >> 2] | 0;
    $432 = i64toi32_i32$1;
    i64toi32_i32$1 = $1 + 64 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $432;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($1 + 84 | 0) >> 2] = $15;
    i64toi32_i32$2 = $23;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $34 = i64toi32_i32$0;
    $34$hi = i64toi32_i32$1;
    i64toi32_i32$2 = $24;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $35 = i64toi32_i32$1;
    $35$hi = i64toi32_i32$0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 168 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 172 | 0) >> 2] | 0;
    $36 = i64toi32_i32$0;
    $36$hi = i64toi32_i32$1;
    i64toi32_i32$1 = $37$hi;
    i64toi32_i32$0 = $1 + 120 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $37;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $38$hi;
    i64toi32_i32$0 = $1 + 112 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $38;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $35$hi;
    i64toi32_i32$0 = $1 + 104 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $35;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $34$hi;
    i64toi32_i32$0 = $1 + 96 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $34;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $36$hi;
    i64toi32_i32$0 = $1 + 88 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $36;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($1 + 136 | 0) >> 2] = HEAP32[$17 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 152 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 156 | 0) >> 2] | 0;
    $464 = i64toi32_i32$1;
    i64toi32_i32$1 = $1 + 128 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $464;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($1 + 148 | 0) >> 2] = HEAP32[$18 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 136 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 140 | 0) >> 2] | 0;
    $472 = i64toi32_i32$0;
    i64toi32_i32$0 = $1 + 140 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $472;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($1 + 160 | 0) >> 2] = HEAP32[$19 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 120 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 124 | 0) >> 2] | 0;
    $480 = i64toi32_i32$1;
    i64toi32_i32$1 = $1 + 152 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $480;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $28;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $484 = i64toi32_i32$0;
    i64toi32_i32$0 = $1 + 172 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $484;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 104 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 108 | 0) >> 2] | 0;
    $488 = i64toi32_i32$1;
    i64toi32_i32$1 = $1 + 164 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $488;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($1 + 188 | 0) >> 2] = HEAP32[$32 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 88 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 92 | 0) >> 2] | 0;
    $496 = i64toi32_i32$0;
    i64toi32_i32$0 = $1 + 180 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $496;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($1 + 200 | 0) >> 2] = HEAP32[$33 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 72 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 76 | 0) >> 2] | 0;
    $504 = i64toi32_i32$1;
    i64toi32_i32$1 = $1 + 192 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $504;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    HEAP8[($1 + 204 | 0) >> 0] = $14;
    i64toi32_i32$2 = $27;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $511 = i64toi32_i32$0;
    i64toi32_i32$0 = $1 + 229 | 0;
    $97 = $511;
    HEAP8[i64toi32_i32$0 >> 0] = $97;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $97 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $97 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $97 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$2 = $26;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $515 = i64toi32_i32$1;
    i64toi32_i32$1 = $1 + 221 | 0;
    $98 = $515;
    HEAP8[i64toi32_i32$1 >> 0] = $98;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $98 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $98 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $98 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$2 = $25;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $519 = i64toi32_i32$0;
    i64toi32_i32$0 = $1 + 213 | 0;
    $99 = $519;
    HEAP8[i64toi32_i32$0 >> 0] = $99;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $99 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $99 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $99 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] | 0;
    $523 = i64toi32_i32$1;
    i64toi32_i32$1 = $1 + 205 | 0;
    $100 = $523;
    HEAP8[i64toi32_i32$1 >> 0] = $100;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $100 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $100 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $100 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    HEAP8[($1 + 237 | 0) >> 0] = $16;
    i64toi32_i32$2 = $31;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $530 = i64toi32_i32$0;
    i64toi32_i32$0 = $1 + 262 | 0;
    $101 = $530;
    HEAP16[i64toi32_i32$0 >> 1] = $101;
    HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $101 >>> 16 | 0;
    HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$1;
    HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
    i64toi32_i32$2 = $30;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $534 = i64toi32_i32$1;
    i64toi32_i32$1 = $1 + 254 | 0;
    $102 = $534;
    HEAP16[i64toi32_i32$1 >> 1] = $102;
    HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $102 >>> 16 | 0;
    HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = i64toi32_i32$0;
    HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
    i64toi32_i32$2 = $29;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $538 = i64toi32_i32$0;
    i64toi32_i32$0 = $1 + 246 | 0;
    $103 = $538;
    HEAP16[i64toi32_i32$0 >> 1] = $103;
    HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $103 >>> 16 | 0;
    HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$1;
    HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
    $542 = i64toi32_i32$1;
    i64toi32_i32$1 = $1 + 238 | 0;
    $104 = $542;
    HEAP16[i64toi32_i32$1 >> 1] = $104;
    HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $104 >>> 16 | 0;
    HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = i64toi32_i32$0;
    HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[($1 + 270 | 0) >> 0] = ($20 | 0) == (2 | 0) ? 2 : ($20 | 0) != (0 | 0);
    $12 = $12 + 272 | 0;
    $13 = $13 + 272 | 0;
    if ($6) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 8 | 0) >> 2] = $4;
  global$0 = $2 + 512 | 0;
 }
 
 function cryptoxide__curve25519__scalar__scalar64__muladd__h77e24dce4fa4fc8b($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, i64toi32_i32$5 = 0, $4 = 0, $6$hi = 0, $5$hi = 0, $8$hi = 0, $9$hi = 0, $11$hi = 0, $7$hi = 0, $8 = 0, $5 = 0, $6 = 0, $10$hi = 0, $13$hi = 0, $12$hi = 0, $15$hi = 0, $9 = 0, $11 = 0, $16$hi = 0, $7 = 0, $10 = 0, $12 = 0, $13 = 0, $15 = 0, $18$hi = 0, $14$hi = 0, $19$hi = 0, $16 = 0, $14 = 0, $18 = 0, $19 = 0, $22$hi = 0, $20$hi = 0, $23$hi = 0, $17$hi = 0, $21$hi = 0, $325 = 0, $326 = 0, $327 = 0, $329 = 0, $17 = 0, $20 = 0, $330 = 0, $331 = 0, $21 = 0, $22 = 0, $23 = 0, $333 = 0, $334 = 0, $335 = 0, $336 = 0, $337 = 0, $339 = 0, $340 = 0, $341 = 0, $343 = 0, $344 = 0, $345 = 0, $346 = 0, $347 = 0, $349 = 0, $350 = 0, $351 = 0, $353 = 0, $354 = 0, $355 = 0, $356 = 0, $357 = 0, $359 = 0, $360 = 0, $361 = 0, $39 = 0, $52 = 0, $55 = 0, $55$hi = 0, $57 = 0, $57$hi = 0, $62$hi = 0, $63 = 0, $63$hi = 0, $67 = 0, $67$hi = 0, $70 = 0, $87 = 0, $92 = 0, $92$hi = 0, $94 = 0, $94$hi = 0, $96 = 0, $96$hi = 0, $100 = 0, $100$hi = 0, $103 = 0, $104$hi = 0, $105$hi = 0, $109 = 0, $109$hi = 0, $110$hi = 0, $113 = 0, $114$hi = 0, $116$hi = 0, $117 = 0, $117$hi = 0, $121 = 0, $121$hi = 0, $124 = 0, $145 = 0, $150 = 0, $150$hi = 0, $154 = 0, $154$hi = 0, $158 = 0, $158$hi = 0, $160 = 0, $160$hi = 0, $162 = 0, $162$hi = 0, $166 = 0, $166$hi = 0, $170 = 0, $170$hi = 0, $171$hi = 0, $174 = 0, $175$hi = 0, $176$hi = 0, $179 = 0, $180$hi = 0, $181$hi = 0, $185 = 0, $185$hi = 0, $186$hi = 0, $189 = 0, $190$hi = 0, $192$hi = 0, $193 = 0, $193$hi = 0, $196 = 0, $221 = 0, $226 = 0, $226$hi = 0, $230 = 0, $230$hi = 0, $234 = 0, $234$hi = 0, $238 = 0, $238$hi = 0, $240 = 0, $240$hi = 0, $242 = 0, $242$hi = 0, $246 = 0, $246$hi = 0, $250 = 0, $250$hi = 0, $251$hi = 0, $254 = 0, $255$hi = 0, $256$hi = 0, $260 = 0, $260$hi = 0, $261$hi = 0, $264 = 0, $265$hi = 0, $266$hi = 0, $270 = 0, $270$hi = 0, $271$hi = 0, $274 = 0, $275$hi = 0, $276$hi = 0, $279 = 0, $280$hi = 0, $282$hi = 0, $283 = 0, $283$hi = 0, $303 = 0, $308 = 0, $308$hi = 0, $312 = 0, $312$hi = 0, $316 = 0, $316$hi = 0, $318 = 0, $318$hi = 0, $320 = 0, $320$hi = 0, $324 = 0, $324$hi = 0, $328 = 0, $328$hi = 0, $329$hi = 0, $332 = 0, $333$hi = 0, $334$hi = 0, $338 = 0, $338$hi = 0, $339$hi = 0, $342 = 0, $343$hi = 0, $344$hi = 0, $348 = 0, $348$hi = 0, $349$hi = 0, $352 = 0, $353$hi = 0, $354$hi = 0, $358 = 0, $358$hi = 0, $359$hi = 0, $362 = 0, $363$hi = 0, $364$hi = 0, $367 = 0, $368$hi = 0, $370$hi = 0, $371 = 0, $371$hi = 0, $375 = 0, $375$hi = 0, $378 = 0, $378$hi = 0, $379 = 0, $392 = 0, $397 = 0, $397$hi = 0, $401 = 0, $401$hi = 0, $403 = 0, $403$hi = 0, $405 = 0, $405$hi = 0, $409 = 0, $409$hi = 0, $413 = 0, $413$hi = 0, $414$hi = 0, $417 = 0, $418$hi = 0, $419$hi = 0, $423 = 0, $423$hi = 0, $424$hi = 0, $427 = 0, $428$hi = 0, $429$hi = 0, $433 = 0, $433$hi = 0, $434$hi = 0, $437 = 0, $438$hi = 0, $439$hi = 0, $442 = 0, $443$hi = 0, $445$hi = 0, $446 = 0, $446$hi = 0, $450 = 0, $450$hi = 0, $453 = 0, $453$hi = 0, $454 = 0, $463 = 0, $468 = 0, $468$hi = 0, $470 = 0, $470$hi = 0, $472 = 0, $472$hi = 0, $476 = 0, $476$hi = 0, $480 = 0, $480$hi = 0, $481$hi = 0, $484 = 0, $485$hi = 0, $486$hi = 0, $490 = 0, $490$hi = 0, $491$hi = 0, $494 = 0, $495$hi = 0, $496$hi = 0, $499 = 0, $500$hi = 0, $502$hi = 0, $503 = 0, $503$hi = 0, $507 = 0, $507$hi = 0, $510 = 0, $510$hi = 0, $511 = 0, $516 = 0, $518 = 0, $518$hi = 0, $522 = 0, $522$hi = 0, $526 = 0, $526$hi = 0, $527$hi = 0, $530 = 0, $531$hi = 0, $532$hi = 0, $535 = 0, $536$hi = 0, $538$hi = 0, $542 = 0, $542$hi = 0, $546 = 0, $546$hi = 0, $549 = 0, $549$hi = 0, $550 = 0, $551 = 0, $555 = 0, $555$hi = 0, $556 = 0, $556$hi = 0, $560 = 0, $560$hi = 0, $563 = 0, $564$hi = 0, $566$hi = 0, $568 = 0, $568$hi = 0, $569 = 0, $592 = 0, $594 = 0, $594$hi = 0, $596 = 0, $596$hi = 0, $600 = 0, $603 = 0, $603$hi = 0, $605$hi = 0, $609 = 0, $612 = 0, $612$hi = 0, $614$hi = 0, $618 = 0, $621 = 0, $621$hi = 0, $623$hi = 0, $627 = 0, $630 = 0, $630$hi = 0, $632$hi = 0;
  $4 = global$0 - 528 | 0;
  global$0 = $4;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $6 = i64toi32_i32$1;
  $6$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $5$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$2 = $6$hi;
  i64toi32_i32$3 = 0;
  __multi3($4 + 8 | 0 | 0, $5 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$1 | 0, $6 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$3 | 0);
  i64toi32_i32$1 = $4;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] | 0;
  $7 = i64toi32_i32$3;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$1 = i64toi32_i32$3;
  i64toi32_i32$3 = 16777215;
  i64toi32_i32$0 = -1;
  i64toi32_i32$3 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
  $39 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
  i64toi32_i32$1 = $4;
  HEAP32[(i64toi32_i32$1 + 488 | 0) >> 2] = $39;
  HEAP32[(i64toi32_i32$1 + 492 | 0) >> 2] = i64toi32_i32$3;
  i64toi32_i32$2 = $2;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $8 = i64toi32_i32$3;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$3 = 0;
  i64toi32_i32$2 = $6$hi;
  i64toi32_i32$0 = 0;
  __multi3($4 + 24 | 0 | 0, $8 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$3 | 0, $6 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$0 | 0);
  i64toi32_i32$3 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 12 | 0) >> 2] | 0;
  $9 = i64toi32_i32$0;
  $9$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $5$hi;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = $5$hi;
  i64toi32_i32$1 = 0;
  __multi3($4 + 88 | 0 | 0, $9 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$0 | 0, $5 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$1 | 0);
  $52 = $4;
  i64toi32_i32$0 = $4;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] | 0;
  $10 = i64toi32_i32$1;
  $10$hi = i64toi32_i32$3;
  $55 = i64toi32_i32$1;
  $55$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $7$hi;
  i64toi32_i32$0 = $7;
  i64toi32_i32$1 = 0;
  i64toi32_i32$2 = 56;
  i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $325 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
   $325 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
  }
  $57 = $325;
  $57$hi = i64toi32_i32$1;
  i64toi32_i32$3 = ($4 + 8 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  i64toi32_i32$2 = 8;
  i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
   $326 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $326 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
  }
  $62$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $57$hi;
  i64toi32_i32$0 = $57;
  i64toi32_i32$3 = $62$hi;
  i64toi32_i32$2 = $326;
  i64toi32_i32$3 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  $63 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  $63$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $55$hi;
  i64toi32_i32$1 = $55;
  i64toi32_i32$0 = $63$hi;
  i64toi32_i32$2 = $63;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$5 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $11 = i64toi32_i32$4;
  $11$hi = i64toi32_i32$5;
  i64toi32_i32$3 = $4;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 88 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 92 | 0) >> 2] | 0;
  $67 = i64toi32_i32$5;
  $67$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$5 = $67$hi;
  i64toi32_i32$2 = $67;
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $12 = i64toi32_i32$0;
  $12$hi = i64toi32_i32$4;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$3 = 16777215;
  i64toi32_i32$2 = -1;
  i64toi32_i32$3 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
  $70 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
  i64toi32_i32$1 = $52;
  HEAP32[(i64toi32_i32$1 + 496 | 0) >> 2] = $70;
  HEAP32[(i64toi32_i32$1 + 500 | 0) >> 2] = i64toi32_i32$3;
  i64toi32_i32$4 = $2;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$4 + 20 | 0) >> 2] | 0;
  $7 = i64toi32_i32$3;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = 0;
  i64toi32_i32$4 = $6$hi;
  i64toi32_i32$2 = 0;
  __multi3($4 + 40 | 0 | 0, $7 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$3 | 0, $6 | 0, i64toi32_i32$4 | 0, 0 | 0, i64toi32_i32$2 | 0);
  i64toi32_i32$3 = $1;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 16 | 0) >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$3 + 20 | 0) >> 2] | 0;
  $13 = i64toi32_i32$2;
  $13$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $5$hi;
  i64toi32_i32$4 = $13$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = $5$hi;
  i64toi32_i32$1 = 0;
  __multi3($4 + 104 | 0 | 0, $13 | 0, i64toi32_i32$4 | 0, 0 | 0, i64toi32_i32$2 | 0, $5 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$1 | 0);
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$3 = 0;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$4 = 0;
  __multi3($4 + 200 | 0 | 0, $9 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$3 | 0, $8 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$4 | 0);
  $87 = $4;
  i64toi32_i32$3 = $4;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$3 + 40 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 44 | 0) >> 2] | 0;
  $14 = i64toi32_i32$4;
  $14$hi = i64toi32_i32$2;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 200 | 0) >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$3 + 204 | 0) >> 2] | 0;
  $92 = i64toi32_i32$2;
  $92$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $14$hi;
  i64toi32_i32$3 = $14;
  i64toi32_i32$2 = $92$hi;
  i64toi32_i32$1 = $92;
  i64toi32_i32$5 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $15 = i64toi32_i32$5;
  $15$hi = i64toi32_i32$0;
  $94 = i64toi32_i32$5;
  $94$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$4 = $12;
  i64toi32_i32$3 = 0;
  i64toi32_i32$1 = 56;
  i64toi32_i32$2 = i64toi32_i32$1 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
   i64toi32_i32$3 = 0;
   $327 = i64toi32_i32$0 >>> i64toi32_i32$2 | 0;
  } else {
   i64toi32_i32$3 = i64toi32_i32$0 >>> i64toi32_i32$2 | 0;
   $327 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$2 | 0) | 0;
  }
  $96 = $327;
  $96$hi = i64toi32_i32$3;
  i64toi32_i32$0 = ($4 + 24 | 0) + 8 | 0;
  i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $100 = i64toi32_i32$3;
  $100$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$4 = $10$hi;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$0 = $11;
  i64toi32_i32$3 = $10$hi;
  i64toi32_i32$1 = $10;
  $103 = i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0 | 0) | 0;
  i64toi32_i32$0 = 0;
  $104$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $100$hi;
  i64toi32_i32$1 = $100;
  i64toi32_i32$4 = $104$hi;
  i64toi32_i32$3 = $103;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $105$hi = i64toi32_i32$5;
  i64toi32_i32$0 = ($4 + 88 | 0) + 8 | 0;
  i64toi32_i32$5 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $109 = i64toi32_i32$5;
  $109$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $105$hi;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$5 = $109$hi;
  i64toi32_i32$3 = $109;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $110$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$1 = $12;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$3 = $11;
  $113 = i64toi32_i32$2 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
  i64toi32_i32$1 = 0;
  $114$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $110$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$2 = $114$hi;
  i64toi32_i32$0 = $113;
  i64toi32_i32$5 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$3 = 0;
  i64toi32_i32$0 = 8;
  i64toi32_i32$2 = i64toi32_i32$0 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$1 << i64toi32_i32$2 | 0;
   $329 = 0;
  } else {
   i64toi32_i32$3 = ((1 << i64toi32_i32$2 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$2 | 0) | 0) | 0 | (i64toi32_i32$4 << i64toi32_i32$2 | 0) | 0;
   $329 = i64toi32_i32$1 << i64toi32_i32$2 | 0;
  }
  $116$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $96$hi;
  i64toi32_i32$4 = $96;
  i64toi32_i32$1 = $116$hi;
  i64toi32_i32$0 = $329;
  i64toi32_i32$1 = i64toi32_i32$3 | i64toi32_i32$1 | 0;
  $117 = i64toi32_i32$4 | i64toi32_i32$0 | 0;
  $117$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $94$hi;
  i64toi32_i32$3 = $94;
  i64toi32_i32$4 = $117$hi;
  i64toi32_i32$0 = $117;
  i64toi32_i32$2 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $10 = i64toi32_i32$2;
  $10$hi = i64toi32_i32$5;
  i64toi32_i32$1 = $4;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 104 | 0) >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 108 | 0) >> 2] | 0;
  $121 = i64toi32_i32$5;
  $121$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $10$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$5 = $121$hi;
  i64toi32_i32$0 = $121;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  i64toi32_i32$2 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $16 = i64toi32_i32$4;
  $16$hi = i64toi32_i32$2;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$1 = 16777215;
  i64toi32_i32$0 = -1;
  i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
  $124 = i64toi32_i32$3 & i64toi32_i32$0 | 0;
  i64toi32_i32$3 = $87;
  HEAP32[(i64toi32_i32$3 + 504 | 0) >> 2] = $124;
  HEAP32[(i64toi32_i32$3 + 508 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $6$hi;
  i64toi32_i32$3 = $11$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$2 = $6$hi;
  i64toi32_i32$0 = 0;
  __multi3($4 + 56 | 0 | 0, $11 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$1 | 0, $6 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$0 | 0);
  i64toi32_i32$1 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] | 0;
  $12 = i64toi32_i32$0;
  $12$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $5$hi;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$1 = $5$hi;
  i64toi32_i32$3 = 0;
  __multi3($4 + 120 | 0 | 0, $12 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$0 | 0, $5 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$3 | 0);
  i64toi32_i32$3 = $7$hi;
  i64toi32_i32$3 = $9$hi;
  i64toi32_i32$3 = $7$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$2 = 0;
  __multi3($4 + 248 | 0 | 0, $7 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$1 | 0, $9 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$2 | 0);
  i64toi32_i32$2 = $13$hi;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$2 = $13$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$3 = 0;
  __multi3($4 + 184 | 0 | 0, $13 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$0 | 0, $8 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$3 | 0);
  $145 = $4;
  i64toi32_i32$0 = $4;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 184 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 188 | 0) >> 2] | 0;
  $17 = i64toi32_i32$3;
  $17$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 248 | 0) >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 252 | 0) >> 2] | 0;
  $150 = i64toi32_i32$1;
  $150$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $17$hi;
  i64toi32_i32$0 = $17;
  i64toi32_i32$1 = $150$hi;
  i64toi32_i32$2 = $150;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $18 = i64toi32_i32$5;
  $18$hi = i64toi32_i32$4;
  i64toi32_i32$3 = $4;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$3 + 56 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 60 | 0) >> 2] | 0;
  $154 = i64toi32_i32$4;
  $154$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $18$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$4 = $154$hi;
  i64toi32_i32$2 = $154;
  i64toi32_i32$1 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $19 = i64toi32_i32$1;
  $19$hi = i64toi32_i32$5;
  i64toi32_i32$0 = $4;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 120 | 0) >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 124 | 0) >> 2] | 0;
  $158 = i64toi32_i32$5;
  $158$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $19$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$5 = $158$hi;
  i64toi32_i32$2 = $158;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$1 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $20 = i64toi32_i32$4;
  $20$hi = i64toi32_i32$1;
  $160 = i64toi32_i32$4;
  $160$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $16$hi;
  i64toi32_i32$3 = $16;
  i64toi32_i32$0 = 0;
  i64toi32_i32$2 = 56;
  i64toi32_i32$5 = i64toi32_i32$2 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $330 = i64toi32_i32$1 >>> i64toi32_i32$5 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$5 | 0;
   $330 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$5 | 0) | 0;
  }
  $162 = $330;
  $162$hi = i64toi32_i32$0;
  i64toi32_i32$1 = ($4 + 40 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $166 = i64toi32_i32$0;
  $166$hi = i64toi32_i32$3;
  i64toi32_i32$1 = ($4 + 200 | 0) + 8 | 0;
  i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $170 = i64toi32_i32$3;
  $170$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $166$hi;
  i64toi32_i32$1 = $166;
  i64toi32_i32$3 = $170$hi;
  i64toi32_i32$2 = $170;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $171$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $15$hi;
  i64toi32_i32$4 = $14$hi;
  i64toi32_i32$4 = $15$hi;
  i64toi32_i32$0 = $15;
  i64toi32_i32$1 = $14$hi;
  i64toi32_i32$2 = $14;
  $174 = i64toi32_i32$4 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0;
  i64toi32_i32$0 = 0;
  $175$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $171$hi;
  i64toi32_i32$2 = i64toi32_i32$5;
  i64toi32_i32$4 = $175$hi;
  i64toi32_i32$1 = $174;
  i64toi32_i32$3 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $176$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$5 = $15$hi;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$0 = $10;
  i64toi32_i32$2 = $15$hi;
  i64toi32_i32$1 = $15;
  $179 = i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0 | 0) | 0;
  i64toi32_i32$0 = 0;
  $180$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $176$hi;
  i64toi32_i32$1 = i64toi32_i32$3;
  i64toi32_i32$5 = $180$hi;
  i64toi32_i32$2 = $179;
  i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
  i64toi32_i32$3 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
  }
  $181$hi = i64toi32_i32$3;
  i64toi32_i32$0 = ($4 + 104 | 0) + 8 | 0;
  i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $185 = i64toi32_i32$3;
  $185$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $181$hi;
  i64toi32_i32$0 = i64toi32_i32$4;
  i64toi32_i32$3 = $185$hi;
  i64toi32_i32$2 = $185;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $186$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $16$hi;
  i64toi32_i32$4 = $10$hi;
  i64toi32_i32$4 = $16$hi;
  i64toi32_i32$1 = $16;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = $10;
  $189 = i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0;
  i64toi32_i32$1 = 0;
  $190$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $186$hi;
  i64toi32_i32$2 = i64toi32_i32$5;
  i64toi32_i32$4 = $190$hi;
  i64toi32_i32$0 = $189;
  i64toi32_i32$3 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$3 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  i64toi32_i32$1 = i64toi32_i32$3;
  i64toi32_i32$2 = 0;
  i64toi32_i32$0 = 8;
  i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
   $331 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$5 << i64toi32_i32$4 | 0) | 0;
   $331 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
  }
  $192$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $162$hi;
  i64toi32_i32$5 = $162;
  i64toi32_i32$1 = $192$hi;
  i64toi32_i32$0 = $331;
  i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
  $193 = i64toi32_i32$5 | i64toi32_i32$0 | 0;
  $193$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $160$hi;
  i64toi32_i32$2 = $160;
  i64toi32_i32$5 = $193$hi;
  i64toi32_i32$0 = $193;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  i64toi32_i32$3 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
  }
  $10 = i64toi32_i32$4;
  $10$hi = i64toi32_i32$3;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$2 = 16777215;
  i64toi32_i32$0 = -1;
  i64toi32_i32$2 = i64toi32_i32$3 & i64toi32_i32$2 | 0;
  $196 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
  i64toi32_i32$1 = $145;
  HEAP32[(i64toi32_i32$1 + 512 | 0) >> 2] = $196;
  HEAP32[(i64toi32_i32$1 + 516 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$3 = $2;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 36 | 0) >> 2] | 0;
  $15 = i64toi32_i32$2;
  $15$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$1 = $15$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = $6$hi;
  i64toi32_i32$0 = 0;
  __multi3($4 + 72 | 0 | 0, $15 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$2 | 0, $6 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$0 | 0);
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
  $6 = i64toi32_i32$0;
  $6$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $5$hi;
  i64toi32_i32$3 = $6$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$2 = $5$hi;
  i64toi32_i32$1 = 0;
  __multi3($4 + 136 | 0 | 0, $6 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$0 | 0, $5 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$1 | 0);
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$3 = 0;
  __multi3($4 + 168 | 0 | 0, $12 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$2 | 0, $8 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$3 | 0);
  i64toi32_i32$3 = $11$hi;
  i64toi32_i32$3 = $9$hi;
  i64toi32_i32$3 = $11$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$1 = 0;
  __multi3($4 + 232 | 0 | 0, $11 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$0 | 0, $9 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$1 | 0);
  i64toi32_i32$1 = $13$hi;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$1 = $13$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$3 = 0;
  __multi3($4 + 296 | 0 | 0, $13 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$2 | 0, $7 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$3 | 0);
  $221 = $4;
  i64toi32_i32$2 = $4;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 232 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 236 | 0) >> 2] | 0;
  $21 = i64toi32_i32$3;
  $21$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 296 | 0) >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 300 | 0) >> 2] | 0;
  $226 = i64toi32_i32$0;
  $226$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $21$hi;
  i64toi32_i32$2 = $21;
  i64toi32_i32$0 = $226$hi;
  i64toi32_i32$1 = $226;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $16 = i64toi32_i32$5;
  $16$hi = i64toi32_i32$4;
  i64toi32_i32$3 = $4;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$3 + 168 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 172 | 0) >> 2] | 0;
  $230 = i64toi32_i32$4;
  $230$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $16$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$4 = $230$hi;
  i64toi32_i32$1 = $230;
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $14 = i64toi32_i32$0;
  $14$hi = i64toi32_i32$5;
  i64toi32_i32$2 = $4;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$2 + 72 | 0) >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 76 | 0) >> 2] | 0;
  $234 = i64toi32_i32$5;
  $234$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $14$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$5 = $234$hi;
  i64toi32_i32$1 = $234;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $22 = i64toi32_i32$4;
  $22$hi = i64toi32_i32$0;
  i64toi32_i32$3 = $4;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 136 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 140 | 0) >> 2] | 0;
  $238 = i64toi32_i32$0;
  $238$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $22$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$0 = $238$hi;
  i64toi32_i32$1 = $238;
  i64toi32_i32$5 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $23 = i64toi32_i32$5;
  $23$hi = i64toi32_i32$4;
  $240 = i64toi32_i32$5;
  $240$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $10$hi;
  i64toi32_i32$2 = $10;
  i64toi32_i32$3 = 0;
  i64toi32_i32$1 = 56;
  i64toi32_i32$0 = i64toi32_i32$1 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
   i64toi32_i32$3 = 0;
   $333 = i64toi32_i32$4 >>> i64toi32_i32$0 | 0;
  } else {
   i64toi32_i32$3 = i64toi32_i32$4 >>> i64toi32_i32$0 | 0;
   $333 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$0 | 0) | 0;
  }
  $242 = $333;
  $242$hi = i64toi32_i32$3;
  i64toi32_i32$4 = ($4 + 184 | 0) + 8 | 0;
  i64toi32_i32$3 = HEAP32[i64toi32_i32$4 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
  $246 = i64toi32_i32$3;
  $246$hi = i64toi32_i32$2;
  i64toi32_i32$4 = ($4 + 248 | 0) + 8 | 0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$4 >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
  $250 = i64toi32_i32$2;
  $250$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $246$hi;
  i64toi32_i32$4 = $246;
  i64toi32_i32$2 = $250$hi;
  i64toi32_i32$1 = $250;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  i64toi32_i32$5 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $251$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $18$hi;
  i64toi32_i32$5 = $17$hi;
  i64toi32_i32$5 = $18$hi;
  i64toi32_i32$3 = $18;
  i64toi32_i32$4 = $17$hi;
  i64toi32_i32$1 = $17;
  $254 = i64toi32_i32$5 >>> 0 < i64toi32_i32$4 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$4 | 0) & i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0 | 0) | 0;
  i64toi32_i32$3 = 0;
  $255$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $251$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$5 = $255$hi;
  i64toi32_i32$4 = $254;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$4 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $256$hi = i64toi32_i32$0;
  i64toi32_i32$3 = ($4 + 56 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
  $260 = i64toi32_i32$0;
  $260$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $256$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$0 = $260$hi;
  i64toi32_i32$4 = $260;
  i64toi32_i32$5 = i64toi32_i32$3 + i64toi32_i32$4 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$4 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $261$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $19$hi;
  i64toi32_i32$2 = $18$hi;
  i64toi32_i32$2 = $19$hi;
  i64toi32_i32$1 = $19;
  i64toi32_i32$3 = $18$hi;
  i64toi32_i32$4 = $18;
  $264 = i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$4 >>> 0 | 0) | 0;
  i64toi32_i32$1 = 0;
  $265$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $261$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$2 = $265$hi;
  i64toi32_i32$3 = $264;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $266$hi = i64toi32_i32$5;
  i64toi32_i32$1 = ($4 + 120 | 0) + 8 | 0;
  i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $270 = i64toi32_i32$5;
  $270$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $266$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$5 = $270$hi;
  i64toi32_i32$3 = $270;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $271$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $20$hi;
  i64toi32_i32$0 = $19$hi;
  i64toi32_i32$0 = $20$hi;
  i64toi32_i32$4 = $20;
  i64toi32_i32$1 = $19$hi;
  i64toi32_i32$3 = $19;
  $274 = i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
  i64toi32_i32$4 = 0;
  $275$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $271$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$0 = $275$hi;
  i64toi32_i32$1 = $274;
  i64toi32_i32$5 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $276$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$2 = $20$hi;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$4 = $10;
  i64toi32_i32$3 = $20$hi;
  i64toi32_i32$1 = $20;
  $279 = i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$4 >>> 0 < i64toi32_i32$1 >>> 0 | 0) | 0;
  i64toi32_i32$4 = 0;
  $280$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $276$hi;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$2 = $280$hi;
  i64toi32_i32$3 = $279;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 8;
  i64toi32_i32$2 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$4 << i64toi32_i32$2 | 0;
   $334 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$2 | 0) - 1 | 0) & (i64toi32_i32$4 >>> (32 - i64toi32_i32$2 | 0) | 0) | 0 | (i64toi32_i32$5 << i64toi32_i32$2 | 0) | 0;
   $334 = i64toi32_i32$4 << i64toi32_i32$2 | 0;
  }
  $282$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $242$hi;
  i64toi32_i32$5 = $242;
  i64toi32_i32$4 = $282$hi;
  i64toi32_i32$3 = $334;
  i64toi32_i32$4 = i64toi32_i32$1 | i64toi32_i32$4 | 0;
  $283 = i64toi32_i32$5 | i64toi32_i32$3 | 0;
  $283$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $240$hi;
  i64toi32_i32$1 = $240;
  i64toi32_i32$5 = $283$hi;
  i64toi32_i32$3 = $283;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $5 = i64toi32_i32$2;
  $5$hi = i64toi32_i32$0;
  i64toi32_i32$4 = i64toi32_i32$2;
  i64toi32_i32$1 = 255;
  i64toi32_i32$3 = -1;
  i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
  i64toi32_i32$4 = $221;
  HEAP32[(i64toi32_i32$4 + 520 | 0) >> 2] = i64toi32_i32$2 & i64toi32_i32$3 | 0;
  HEAP32[(i64toi32_i32$4 + 524 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$3 = 0;
  __multi3($4 + 152 | 0 | 0, $6 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$4 | 0, $8 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$3 | 0);
  i64toi32_i32$3 = $15$hi;
  i64toi32_i32$3 = $9$hi;
  i64toi32_i32$3 = $15$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$1 = 0;
  __multi3($4 + 216 | 0 | 0, $15 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$0 | 0, $9 | 0, i64toi32_i32$4 | 0, 0 | 0, i64toi32_i32$1 | 0);
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$1 = $13$hi;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$0 = $13$hi;
  i64toi32_i32$3 = 0;
  __multi3($4 + 328 | 0 | 0, $11 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$4 | 0, $13 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$3 | 0);
  i64toi32_i32$3 = $12$hi;
  i64toi32_i32$3 = $7$hi;
  i64toi32_i32$3 = $12$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$1 = 0;
  __multi3($4 + 280 | 0 | 0, $12 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$0 | 0, $7 | 0, i64toi32_i32$4 | 0, 0 | 0, i64toi32_i32$1 | 0);
  $303 = $4;
  i64toi32_i32$0 = $4;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 280 | 0) >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 284 | 0) >> 2] | 0;
  $19 = i64toi32_i32$1;
  $19$hi = i64toi32_i32$4;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 328 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 332 | 0) >> 2] | 0;
  $308 = i64toi32_i32$4;
  $308$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $19$hi;
  i64toi32_i32$0 = $19;
  i64toi32_i32$4 = $308$hi;
  i64toi32_i32$3 = $308;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $9 = i64toi32_i32$5;
  $9$hi = i64toi32_i32$2;
  i64toi32_i32$1 = $4;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 216 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 220 | 0) >> 2] | 0;
  $312 = i64toi32_i32$2;
  $312$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$2 = $312$hi;
  i64toi32_i32$3 = $312;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $10 = i64toi32_i32$4;
  $10$hi = i64toi32_i32$5;
  i64toi32_i32$0 = $4;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 152 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 156 | 0) >> 2] | 0;
  $316 = i64toi32_i32$5;
  $316$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $10$hi;
  i64toi32_i32$0 = i64toi32_i32$4;
  i64toi32_i32$5 = $316$hi;
  i64toi32_i32$3 = $316;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $18 = i64toi32_i32$2;
  $18$hi = i64toi32_i32$4;
  $318 = i64toi32_i32$2;
  $318$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $5$hi;
  i64toi32_i32$1 = $5;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $335 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
   $335 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$5 | 0) | 0;
  }
  $320 = $335;
  $320$hi = i64toi32_i32$0;
  i64toi32_i32$4 = ($4 + 232 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
  $324 = i64toi32_i32$0;
  $324$hi = i64toi32_i32$1;
  i64toi32_i32$4 = ($4 + 296 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$4 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
  $328 = i64toi32_i32$1;
  $328$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $324$hi;
  i64toi32_i32$4 = $324;
  i64toi32_i32$1 = $328$hi;
  i64toi32_i32$3 = $328;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $329$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $16$hi;
  i64toi32_i32$2 = $21$hi;
  i64toi32_i32$2 = $16$hi;
  i64toi32_i32$0 = $16;
  i64toi32_i32$4 = $21$hi;
  i64toi32_i32$3 = $21;
  $332 = i64toi32_i32$2 >>> 0 < i64toi32_i32$4 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$4 | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
  i64toi32_i32$0 = 0;
  $333$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $329$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$2 = $333$hi;
  i64toi32_i32$4 = $332;
  i64toi32_i32$1 = i64toi32_i32$3 + i64toi32_i32$4 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$4 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $334$hi = i64toi32_i32$5;
  i64toi32_i32$0 = ($4 + 168 | 0) + 8 | 0;
  i64toi32_i32$5 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $338 = i64toi32_i32$5;
  $338$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $334$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$5 = $338$hi;
  i64toi32_i32$4 = $338;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  i64toi32_i32$1 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$4 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $339$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $14$hi;
  i64toi32_i32$1 = $16$hi;
  i64toi32_i32$1 = $14$hi;
  i64toi32_i32$3 = $14;
  i64toi32_i32$0 = $16$hi;
  i64toi32_i32$4 = $16;
  $342 = i64toi32_i32$1 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$3 >>> 0 < i64toi32_i32$4 >>> 0 | 0) | 0;
  i64toi32_i32$3 = 0;
  $343$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $339$hi;
  i64toi32_i32$4 = i64toi32_i32$2;
  i64toi32_i32$1 = $343$hi;
  i64toi32_i32$0 = $342;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  i64toi32_i32$2 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $344$hi = i64toi32_i32$2;
  i64toi32_i32$3 = ($4 + 72 | 0) + 8 | 0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
  $348 = i64toi32_i32$2;
  $348$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $344$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$2 = $348$hi;
  i64toi32_i32$0 = $348;
  i64toi32_i32$1 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $349$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $22$hi;
  i64toi32_i32$5 = $14$hi;
  i64toi32_i32$5 = $22$hi;
  i64toi32_i32$4 = $22;
  i64toi32_i32$3 = $14$hi;
  i64toi32_i32$0 = $14;
  $352 = i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0 | 0) | 0;
  i64toi32_i32$4 = 0;
  $353$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $349$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$5 = $353$hi;
  i64toi32_i32$3 = $352;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $354$hi = i64toi32_i32$1;
  i64toi32_i32$4 = ($4 + 136 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$4 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
  $358 = i64toi32_i32$1;
  $358$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $354$hi;
  i64toi32_i32$4 = i64toi32_i32$2;
  i64toi32_i32$1 = $358$hi;
  i64toi32_i32$3 = $358;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $359$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $23$hi;
  i64toi32_i32$2 = $22$hi;
  i64toi32_i32$2 = $23$hi;
  i64toi32_i32$0 = $23;
  i64toi32_i32$4 = $22$hi;
  i64toi32_i32$3 = $22;
  $362 = i64toi32_i32$2 >>> 0 < i64toi32_i32$4 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$4 | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
  i64toi32_i32$0 = 0;
  $363$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $359$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$2 = $363$hi;
  i64toi32_i32$4 = $362;
  i64toi32_i32$1 = i64toi32_i32$3 + i64toi32_i32$4 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$4 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $364$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $5$hi;
  i64toi32_i32$5 = $23$hi;
  i64toi32_i32$5 = $5$hi;
  i64toi32_i32$0 = $5;
  i64toi32_i32$3 = $23$hi;
  i64toi32_i32$4 = $23;
  $367 = i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$4 >>> 0 | 0) | 0;
  i64toi32_i32$0 = 0;
  $368$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $364$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$5 = $368$hi;
  i64toi32_i32$3 = $367;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$4 = 0;
  i64toi32_i32$3 = 8;
  i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$0 << i64toi32_i32$5 | 0;
   $336 = 0;
  } else {
   i64toi32_i32$4 = ((1 << i64toi32_i32$5 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$5 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$5 | 0) | 0;
   $336 = i64toi32_i32$0 << i64toi32_i32$5 | 0;
  }
  $370$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $320$hi;
  i64toi32_i32$1 = $320;
  i64toi32_i32$0 = $370$hi;
  i64toi32_i32$3 = $336;
  i64toi32_i32$0 = i64toi32_i32$4 | i64toi32_i32$0 | 0;
  $371 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  $371$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $318$hi;
  i64toi32_i32$4 = $318;
  i64toi32_i32$1 = $371$hi;
  i64toi32_i32$3 = $371;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $8 = i64toi32_i32$5;
  $8$hi = i64toi32_i32$2;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$4 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$1 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$0 << i64toi32_i32$1 | 0;
   $337 = 0;
  } else {
   i64toi32_i32$4 = ((1 << i64toi32_i32$1 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$1 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$1 | 0) | 0;
   $337 = i64toi32_i32$0 << i64toi32_i32$1 | 0;
  }
  i64toi32_i32$2 = $337;
  i64toi32_i32$0 = 16777215;
  i64toi32_i32$3 = 0;
  i64toi32_i32$0 = i64toi32_i32$4 & i64toi32_i32$0 | 0;
  $375 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
  $375$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $5$hi;
  i64toi32_i32$4 = $5;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 24;
  i64toi32_i32$1 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $339 = i64toi32_i32$0 >>> i64toi32_i32$1 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$1 | 0;
   $339 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$1 | 0) | 0;
  }
  i64toi32_i32$0 = $339;
  i64toi32_i32$4 = 0;
  i64toi32_i32$3 = -1;
  i64toi32_i32$4 = i64toi32_i32$2 & i64toi32_i32$4 | 0;
  $378 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
  $378$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $375$hi;
  i64toi32_i32$2 = $375;
  i64toi32_i32$0 = $378$hi;
  i64toi32_i32$3 = $378;
  i64toi32_i32$0 = i64toi32_i32$4 | i64toi32_i32$0 | 0;
  $379 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $303;
  HEAP32[(i64toi32_i32$2 + 448 | 0) >> 2] = $379;
  HEAP32[(i64toi32_i32$2 + 452 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$3 = 0;
  __multi3($4 + 264 | 0 | 0, $6 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$2 | 0, $7 | 0, i64toi32_i32$4 | 0, 0 | 0, i64toi32_i32$3 | 0);
  i64toi32_i32$3 = $15$hi;
  i64toi32_i32$3 = $13$hi;
  i64toi32_i32$3 = $15$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$2 = $13$hi;
  i64toi32_i32$0 = 0;
  __multi3($4 + 312 | 0 | 0, $15 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$4 | 0, $13 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$0 | 0);
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$3 = 0;
  __multi3($4 + 360 | 0 | 0, $12 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$2 | 0, $11 | 0, i64toi32_i32$4 | 0, 0 | 0, i64toi32_i32$3 | 0);
  $392 = $4;
  i64toi32_i32$2 = $4;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 312 | 0) >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$2 + 316 | 0) >> 2] | 0;
  $16 = i64toi32_i32$3;
  $16$hi = i64toi32_i32$4;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$2 + 360 | 0) >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 364 | 0) >> 2] | 0;
  $397 = i64toi32_i32$4;
  $397$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $16$hi;
  i64toi32_i32$2 = $16;
  i64toi32_i32$4 = $397$hi;
  i64toi32_i32$0 = $397;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  i64toi32_i32$5 = i64toi32_i32$3 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $7 = i64toi32_i32$1;
  $7$hi = i64toi32_i32$5;
  i64toi32_i32$3 = $4;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 264 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 268 | 0) >> 2] | 0;
  $401 = i64toi32_i32$5;
  $401$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$5 = $401$hi;
  i64toi32_i32$0 = $401;
  i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $13 = i64toi32_i32$4;
  $13$hi = i64toi32_i32$1;
  $403 = i64toi32_i32$4;
  $403$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$2 = $8;
  i64toi32_i32$3 = 0;
  i64toi32_i32$0 = 56;
  i64toi32_i32$5 = i64toi32_i32$0 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
   i64toi32_i32$3 = 0;
   $340 = i64toi32_i32$1 >>> i64toi32_i32$5 | 0;
  } else {
   i64toi32_i32$3 = i64toi32_i32$1 >>> i64toi32_i32$5 | 0;
   $340 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$5 | 0) | 0;
  }
  $405 = $340;
  $405$hi = i64toi32_i32$3;
  i64toi32_i32$1 = ($4 + 280 | 0) + 8 | 0;
  i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $409 = i64toi32_i32$3;
  $409$hi = i64toi32_i32$2;
  i64toi32_i32$1 = ($4 + 328 | 0) + 8 | 0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $413 = i64toi32_i32$2;
  $413$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $409$hi;
  i64toi32_i32$1 = $409;
  i64toi32_i32$2 = $413$hi;
  i64toi32_i32$0 = $413;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $414$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$4 = $19$hi;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$1 = $19$hi;
  i64toi32_i32$0 = $19;
  $417 = i64toi32_i32$4 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$3 >>> 0 < i64toi32_i32$0 >>> 0 | 0) | 0;
  i64toi32_i32$3 = 0;
  $418$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $414$hi;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$4 = $418$hi;
  i64toi32_i32$1 = $417;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  i64toi32_i32$5 = i64toi32_i32$3 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $419$hi = i64toi32_i32$5;
  i64toi32_i32$3 = ($4 + 216 | 0) + 8 | 0;
  i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
  $423 = i64toi32_i32$5;
  $423$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $419$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$5 = $423$hi;
  i64toi32_i32$1 = $423;
  i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $424$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$0 = $10;
  i64toi32_i32$3 = $9$hi;
  i64toi32_i32$1 = $9;
  $427 = i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0 | 0) | 0;
  i64toi32_i32$0 = 0;
  $428$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $424$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$2 = $428$hi;
  i64toi32_i32$3 = $427;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $429$hi = i64toi32_i32$4;
  i64toi32_i32$0 = ($4 + 152 | 0) + 8 | 0;
  i64toi32_i32$4 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $433 = i64toi32_i32$4;
  $433$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $429$hi;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$4 = $433$hi;
  i64toi32_i32$3 = $433;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $434$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $18$hi;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$5 = $18$hi;
  i64toi32_i32$1 = $18;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$3 = $10;
  $437 = i64toi32_i32$5 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
  i64toi32_i32$1 = 0;
  $438$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $434$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$5 = $438$hi;
  i64toi32_i32$0 = $437;
  i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $439$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$2 = $18$hi;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$1 = $8;
  i64toi32_i32$3 = $18$hi;
  i64toi32_i32$0 = $18;
  $442 = i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$0 >>> 0 | 0) | 0;
  i64toi32_i32$1 = 0;
  $443$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $439$hi;
  i64toi32_i32$0 = i64toi32_i32$4;
  i64toi32_i32$2 = $443$hi;
  i64toi32_i32$3 = $442;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 8;
  i64toi32_i32$2 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$2 | 0;
   $341 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$2 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$2 | 0) | 0) | 0 | (i64toi32_i32$4 << i64toi32_i32$2 | 0) | 0;
   $341 = i64toi32_i32$1 << i64toi32_i32$2 | 0;
  }
  $445$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $405$hi;
  i64toi32_i32$4 = $405;
  i64toi32_i32$1 = $445$hi;
  i64toi32_i32$3 = $341;
  i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
  $446 = i64toi32_i32$4 | i64toi32_i32$3 | 0;
  $446$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $403$hi;
  i64toi32_i32$0 = $403;
  i64toi32_i32$4 = $446$hi;
  i64toi32_i32$3 = $446;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $5 = i64toi32_i32$2;
  $5$hi = i64toi32_i32$5;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
   $343 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$5 << i64toi32_i32$4 | 0) | 0;
   $343 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
  }
  i64toi32_i32$5 = $343;
  i64toi32_i32$1 = 16777215;
  i64toi32_i32$3 = 0;
  i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
  $450 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
  $450$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = $8;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 24;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$5 = 0;
   $344 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$5 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   $344 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
  }
  i64toi32_i32$1 = $344;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = -1;
  i64toi32_i32$0 = i64toi32_i32$5 & i64toi32_i32$0 | 0;
  $453 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
  $453$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $450$hi;
  i64toi32_i32$5 = $450;
  i64toi32_i32$1 = $453$hi;
  i64toi32_i32$3 = $453;
  i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
  $454 = i64toi32_i32$5 | i64toi32_i32$3 | 0;
  i64toi32_i32$5 = $392;
  HEAP32[(i64toi32_i32$5 + 456 | 0) >> 2] = $454;
  HEAP32[(i64toi32_i32$5 + 460 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$3 = 0;
  __multi3($4 + 344 | 0 | 0, $6 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$5 | 0, $11 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$3 | 0);
  i64toi32_i32$3 = $15$hi;
  i64toi32_i32$3 = $12$hi;
  i64toi32_i32$3 = $15$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$5 = $12$hi;
  i64toi32_i32$1 = 0;
  __multi3($4 + 376 | 0 | 0, $15 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$0 | 0, $12 | 0, i64toi32_i32$5 | 0, 0 | 0, i64toi32_i32$1 | 0);
  $463 = $4;
  i64toi32_i32$0 = $4;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 344 | 0) >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 348 | 0) >> 2] | 0;
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$5;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 376 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 380 | 0) >> 2] | 0;
  $468 = i64toi32_i32$5;
  $468$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$0 = $11;
  i64toi32_i32$5 = $468$hi;
  i64toi32_i32$3 = $468;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $9 = i64toi32_i32$4;
  $9$hi = i64toi32_i32$2;
  $470 = i64toi32_i32$4;
  $470$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $5$hi;
  i64toi32_i32$1 = $5;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $345 = i64toi32_i32$2 >>> i64toi32_i32$5 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$5 | 0;
   $345 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$5 | 0) | 0;
  }
  $472 = $345;
  $472$hi = i64toi32_i32$0;
  i64toi32_i32$2 = ($4 + 312 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $476 = i64toi32_i32$0;
  $476$hi = i64toi32_i32$1;
  i64toi32_i32$2 = ($4 + 360 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $480 = i64toi32_i32$1;
  $480$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $476$hi;
  i64toi32_i32$2 = $476;
  i64toi32_i32$1 = $480$hi;
  i64toi32_i32$3 = $480;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $481$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$4 = $16$hi;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$0 = $7;
  i64toi32_i32$2 = $16$hi;
  i64toi32_i32$3 = $16;
  $484 = i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
  i64toi32_i32$0 = 0;
  $485$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $481$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$4 = $485$hi;
  i64toi32_i32$2 = $484;
  i64toi32_i32$1 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $486$hi = i64toi32_i32$5;
  i64toi32_i32$0 = ($4 + 264 | 0) + 8 | 0;
  i64toi32_i32$5 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $490 = i64toi32_i32$5;
  $490$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $486$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$5 = $490$hi;
  i64toi32_i32$2 = $490;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$1 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $491$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $13$hi;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$1 = $13$hi;
  i64toi32_i32$3 = $13;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = $7;
  $494 = i64toi32_i32$1 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$3 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0;
  i64toi32_i32$3 = 0;
  $495$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $491$hi;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$1 = $495$hi;
  i64toi32_i32$0 = $494;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $496$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $5$hi;
  i64toi32_i32$4 = $13$hi;
  i64toi32_i32$4 = $5$hi;
  i64toi32_i32$3 = $5;
  i64toi32_i32$2 = $13$hi;
  i64toi32_i32$0 = $13;
  $499 = i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$3 >>> 0 < i64toi32_i32$0 >>> 0 | 0) | 0;
  i64toi32_i32$3 = 0;
  $500$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $496$hi;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$4 = $500$hi;
  i64toi32_i32$2 = $499;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  i64toi32_i32$5 = i64toi32_i32$3 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$0 = 0;
  i64toi32_i32$2 = 8;
  i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
   $346 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$5 << i64toi32_i32$4 | 0) | 0;
   $346 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
  }
  $502$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $472$hi;
  i64toi32_i32$5 = $472;
  i64toi32_i32$3 = $502$hi;
  i64toi32_i32$2 = $346;
  i64toi32_i32$3 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $503 = i64toi32_i32$5 | i64toi32_i32$2 | 0;
  $503$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $470$hi;
  i64toi32_i32$0 = $470;
  i64toi32_i32$5 = $503$hi;
  i64toi32_i32$2 = $503;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  i64toi32_i32$1 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $8 = i64toi32_i32$4;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$0 = 0;
  i64toi32_i32$2 = 32;
  i64toi32_i32$5 = i64toi32_i32$2 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$3 << i64toi32_i32$5 | 0;
   $347 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$5 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$5 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$5 | 0) | 0;
   $347 = i64toi32_i32$3 << i64toi32_i32$5 | 0;
  }
  i64toi32_i32$1 = $347;
  i64toi32_i32$3 = 16777215;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
  $507 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
  $507$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $5$hi;
  i64toi32_i32$0 = $5;
  i64toi32_i32$1 = 0;
  i64toi32_i32$2 = 24;
  i64toi32_i32$5 = i64toi32_i32$2 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $349 = i64toi32_i32$3 >>> i64toi32_i32$5 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$3 >>> i64toi32_i32$5 | 0;
   $349 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$5 | 0) | 0;
  }
  i64toi32_i32$3 = $349;
  i64toi32_i32$0 = 0;
  i64toi32_i32$2 = -1;
  i64toi32_i32$0 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
  $510 = i64toi32_i32$3 & i64toi32_i32$2 | 0;
  $510$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $507$hi;
  i64toi32_i32$1 = $507;
  i64toi32_i32$3 = $510$hi;
  i64toi32_i32$2 = $510;
  i64toi32_i32$3 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $511 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
  i64toi32_i32$1 = $463;
  HEAP32[(i64toi32_i32$1 + 464 | 0) >> 2] = $511;
  HEAP32[(i64toi32_i32$1 + 468 | 0) >> 2] = i64toi32_i32$3;
  i64toi32_i32$3 = $6$hi;
  i64toi32_i32$3 = $15$hi;
  i64toi32_i32$3 = $6$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$0 = $15$hi;
  i64toi32_i32$2 = 0;
  __multi3($4 + 392 | 0 | 0, $6 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$1 | 0, $15 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$2 | 0);
  $516 = $4;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$1 = $8;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $350 = i64toi32_i32$2 >>> i64toi32_i32$5 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$5 | 0;
   $350 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$5 | 0) | 0;
  }
  $518 = $350;
  $518$hi = i64toi32_i32$0;
  i64toi32_i32$2 = ($4 + 344 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $522 = i64toi32_i32$0;
  $522$hi = i64toi32_i32$1;
  i64toi32_i32$2 = ($4 + 376 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $526 = i64toi32_i32$1;
  $526$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $522$hi;
  i64toi32_i32$2 = $522;
  i64toi32_i32$1 = $526$hi;
  i64toi32_i32$3 = $526;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $527$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$0 = $9;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$3 = $11;
  $530 = i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
  i64toi32_i32$0 = 0;
  $531$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $527$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$4 = $531$hi;
  i64toi32_i32$2 = $530;
  i64toi32_i32$1 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $532$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $8$hi;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$5 = $8$hi;
  i64toi32_i32$0 = $8;
  i64toi32_i32$3 = $9$hi;
  i64toi32_i32$2 = $9;
  $535 = i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0;
  i64toi32_i32$0 = 0;
  $536$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $532$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$5 = $536$hi;
  i64toi32_i32$3 = $535;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  i64toi32_i32$0 = i64toi32_i32$4;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 8;
  i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$5 | 0;
   $351 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$5 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$5 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$5 | 0) | 0;
   $351 = i64toi32_i32$0 << i64toi32_i32$5 | 0;
  }
  $538$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $518$hi;
  i64toi32_i32$1 = $518;
  i64toi32_i32$0 = $538$hi;
  i64toi32_i32$3 = $351;
  i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
  $6 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  $6$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 392 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 396 | 0) >> 2] | 0;
  $542 = i64toi32_i32$0;
  $542$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$2 = $6;
  i64toi32_i32$0 = $542$hi;
  i64toi32_i32$3 = $542;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $5 = i64toi32_i32$5;
  $5$hi = i64toi32_i32$4;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$0 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$0 | 0;
   $353 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$0 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$0 | 0) | 0) | 0 | (i64toi32_i32$4 << i64toi32_i32$0 | 0) | 0;
   $353 = i64toi32_i32$1 << i64toi32_i32$0 | 0;
  }
  i64toi32_i32$4 = $353;
  i64toi32_i32$1 = 16777215;
  i64toi32_i32$3 = 0;
  i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
  $546 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
  $546$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$2 = $8;
  i64toi32_i32$4 = 0;
  i64toi32_i32$3 = 24;
  i64toi32_i32$0 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$4 = 0;
   $354 = i64toi32_i32$1 >>> i64toi32_i32$0 | 0;
  } else {
   i64toi32_i32$4 = i64toi32_i32$1 >>> i64toi32_i32$0 | 0;
   $354 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$0 | 0) | 0;
  }
  i64toi32_i32$1 = $354;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = -1;
  i64toi32_i32$2 = i64toi32_i32$4 & i64toi32_i32$2 | 0;
  $549 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
  $549$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $546$hi;
  i64toi32_i32$4 = $546;
  i64toi32_i32$1 = $549$hi;
  i64toi32_i32$3 = $549;
  i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
  $550 = i64toi32_i32$4 | i64toi32_i32$3 | 0;
  i64toi32_i32$4 = $516;
  HEAP32[(i64toi32_i32$4 + 472 | 0) >> 2] = $550;
  HEAP32[(i64toi32_i32$4 + 476 | 0) >> 2] = i64toi32_i32$1;
  $551 = $4;
  i64toi32_i32$1 = $5$hi;
  i64toi32_i32$2 = $5;
  i64toi32_i32$4 = 0;
  i64toi32_i32$3 = 24;
  i64toi32_i32$0 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$4 = 0;
   $355 = i64toi32_i32$1 >>> i64toi32_i32$0 | 0;
  } else {
   i64toi32_i32$4 = i64toi32_i32$1 >>> i64toi32_i32$0 | 0;
   $355 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$0 | 0) | 0;
  }
  $8 = $355;
  $8$hi = i64toi32_i32$4;
  i64toi32_i32$1 = $8;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = -1;
  i64toi32_i32$2 = i64toi32_i32$4 & i64toi32_i32$2 | 0;
  $555 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
  $555$hi = i64toi32_i32$2;
  i64toi32_i32$2 = i64toi32_i32$4;
  $556 = i64toi32_i32$1;
  $556$hi = i64toi32_i32$2;
  i64toi32_i32$4 = ($4 + 392 | 0) + 8 | 0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$4 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
  $560 = i64toi32_i32$2;
  $560$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $5$hi;
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$1 = $5$hi;
  i64toi32_i32$4 = $5;
  i64toi32_i32$2 = $6$hi;
  i64toi32_i32$3 = $6;
  $563 = i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
  i64toi32_i32$4 = 0;
  $564$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $560$hi;
  i64toi32_i32$3 = $560;
  i64toi32_i32$1 = $564$hi;
  i64toi32_i32$2 = $563;
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$3 = 0;
  i64toi32_i32$2 = 40;
  i64toi32_i32$1 = i64toi32_i32$2 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$4 << i64toi32_i32$1 | 0;
   $356 = 0;
  } else {
   i64toi32_i32$3 = ((1 << i64toi32_i32$1 | 0) - 1 | 0) & (i64toi32_i32$4 >>> (32 - i64toi32_i32$1 | 0) | 0) | 0 | (i64toi32_i32$5 << i64toi32_i32$1 | 0) | 0;
   $356 = i64toi32_i32$4 << i64toi32_i32$1 | 0;
  }
  $566$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $556$hi;
  i64toi32_i32$5 = $556;
  i64toi32_i32$4 = $566$hi;
  i64toi32_i32$2 = $356;
  i64toi32_i32$4 = i64toi32_i32$3 | i64toi32_i32$4 | 0;
  i64toi32_i32$3 = i64toi32_i32$5 | i64toi32_i32$2 | 0;
  i64toi32_i32$5 = -1;
  i64toi32_i32$2 = 0;
  i64toi32_i32$5 = i64toi32_i32$4 & i64toi32_i32$5 | 0;
  $568 = i64toi32_i32$3 & i64toi32_i32$2 | 0;
  $568$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $555$hi;
  i64toi32_i32$4 = $555;
  i64toi32_i32$3 = $568$hi;
  i64toi32_i32$2 = $568;
  i64toi32_i32$3 = i64toi32_i32$5 | i64toi32_i32$3 | 0;
  $569 = i64toi32_i32$4 | i64toi32_i32$2 | 0;
  i64toi32_i32$4 = $551;
  HEAP32[(i64toi32_i32$4 + 480 | 0) >> 2] = $569;
  HEAP32[(i64toi32_i32$4 + 484 | 0) >> 2] = i64toi32_i32$3;
  cryptoxide__curve25519__scalar__scalar64__barrett_reduce256__heefb042b74f1284c($4 + 408 | 0 | 0, $4 + 448 | 0 | 0, $4 + 488 | 0 | 0);
  i64toi32_i32$5 = $3;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 32 | 0) >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 36 | 0) >> 2] | 0;
  $5 = i64toi32_i32$3;
  $5$hi = i64toi32_i32$4;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 24 | 0) >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 28 | 0) >> 2] | 0;
  $6 = i64toi32_i32$4;
  $6$hi = i64toi32_i32$3;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 16 | 0) >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 20 | 0) >> 2] | 0;
  $8 = i64toi32_i32$3;
  $8$hi = i64toi32_i32$4;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 8 | 0) >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 12 | 0) >> 2] | 0;
  $9 = i64toi32_i32$4;
  $9$hi = i64toi32_i32$3;
  i64toi32_i32$5 = $4;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 440 | 0) >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 444 | 0) >> 2] | 0;
  $7 = i64toi32_i32$3;
  $7$hi = i64toi32_i32$4;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 432 | 0) >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 436 | 0) >> 2] | 0;
  $13 = i64toi32_i32$4;
  $13$hi = i64toi32_i32$3;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 424 | 0) >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 428 | 0) >> 2] | 0;
  $11 = i64toi32_i32$3;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 416 | 0) >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 420 | 0) >> 2] | 0;
  $12 = i64toi32_i32$4;
  $12$hi = i64toi32_i32$3;
  $592 = i64toi32_i32$5;
  i64toi32_i32$5 = $3;
  i64toi32_i32$3 = HEAP32[i64toi32_i32$5 >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
  $594 = i64toi32_i32$3;
  $594$hi = i64toi32_i32$4;
  i64toi32_i32$5 = $4;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 408 | 0) >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 412 | 0) >> 2] | 0;
  $596 = i64toi32_i32$4;
  $596$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $594$hi;
  i64toi32_i32$5 = $594;
  i64toi32_i32$4 = $596$hi;
  i64toi32_i32$2 = $596;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $15 = i64toi32_i32$1;
  $15$hi = i64toi32_i32$0;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$5 = 16777215;
  i64toi32_i32$2 = -1;
  i64toi32_i32$5 = i64toi32_i32$0 & i64toi32_i32$5 | 0;
  i64toi32_i32$3 = $592;
  HEAP32[(i64toi32_i32$3 + 488 | 0) >> 2] = i64toi32_i32$1 & i64toi32_i32$2 | 0;
  HEAP32[(i64toi32_i32$3 + 492 | 0) >> 2] = i64toi32_i32$5;
  $600 = $4;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$5 = $12$hi;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$0 = $9;
  i64toi32_i32$3 = $12$hi;
  i64toi32_i32$2 = $12;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $603 = i64toi32_i32$4;
  $603$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $15$hi;
  i64toi32_i32$5 = $15;
  i64toi32_i32$0 = 0;
  i64toi32_i32$2 = 56;
  i64toi32_i32$3 = i64toi32_i32$2 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $357 = i64toi32_i32$1 >>> i64toi32_i32$3 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$3 | 0;
   $357 = (((1 << i64toi32_i32$3 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$3 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$3 | 0) | 0;
  }
  $605$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $603$hi;
  i64toi32_i32$1 = $603;
  i64toi32_i32$5 = $605$hi;
  i64toi32_i32$2 = $357;
  i64toi32_i32$3 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$3 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $9 = i64toi32_i32$3;
  $9$hi = i64toi32_i32$4;
  i64toi32_i32$0 = i64toi32_i32$3;
  i64toi32_i32$1 = 16777215;
  i64toi32_i32$2 = -1;
  i64toi32_i32$1 = i64toi32_i32$4 & i64toi32_i32$1 | 0;
  i64toi32_i32$0 = $600;
  HEAP32[(i64toi32_i32$0 + 496 | 0) >> 2] = i64toi32_i32$3 & i64toi32_i32$2 | 0;
  HEAP32[(i64toi32_i32$0 + 500 | 0) >> 2] = i64toi32_i32$1;
  $609 = $4;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$4 = $8;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$2 = $11;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  i64toi32_i32$3 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
  }
  $612 = i64toi32_i32$5;
  $612$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $9$hi;
  i64toi32_i32$1 = $9;
  i64toi32_i32$4 = 0;
  i64toi32_i32$2 = 56;
  i64toi32_i32$0 = i64toi32_i32$2 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
   i64toi32_i32$4 = 0;
   $359 = i64toi32_i32$3 >>> i64toi32_i32$0 | 0;
  } else {
   i64toi32_i32$4 = i64toi32_i32$3 >>> i64toi32_i32$0 | 0;
   $359 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$0 | 0) | 0;
  }
  $614$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $612$hi;
  i64toi32_i32$3 = $612;
  i64toi32_i32$1 = $614$hi;
  i64toi32_i32$2 = $359;
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$5;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$3 = 16777215;
  i64toi32_i32$2 = -1;
  i64toi32_i32$3 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
  i64toi32_i32$4 = $609;
  HEAP32[(i64toi32_i32$4 + 504 | 0) >> 2] = i64toi32_i32$0 & i64toi32_i32$2 | 0;
  HEAP32[(i64toi32_i32$4 + 508 | 0) >> 2] = i64toi32_i32$3;
  $618 = $4;
  i64toi32_i32$3 = $6$hi;
  i64toi32_i32$3 = $13$hi;
  i64toi32_i32$3 = $6$hi;
  i64toi32_i32$5 = $6;
  i64toi32_i32$4 = $13$hi;
  i64toi32_i32$2 = $13;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $621 = i64toi32_i32$1;
  $621$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$5 = 0;
  i64toi32_i32$2 = 56;
  i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
   i64toi32_i32$5 = 0;
   $360 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$5 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $360 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$4 | 0) | 0;
  }
  $623$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $621$hi;
  i64toi32_i32$0 = $621;
  i64toi32_i32$3 = $623$hi;
  i64toi32_i32$2 = $360;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $6 = i64toi32_i32$4;
  $6$hi = i64toi32_i32$1;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$0 = 16777215;
  i64toi32_i32$2 = -1;
  i64toi32_i32$0 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
  i64toi32_i32$5 = $618;
  HEAP32[(i64toi32_i32$5 + 512 | 0) >> 2] = i64toi32_i32$4 & i64toi32_i32$2 | 0;
  HEAP32[(i64toi32_i32$5 + 516 | 0) >> 2] = i64toi32_i32$0;
  $627 = $4;
  i64toi32_i32$0 = $5$hi;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$0 = $5$hi;
  i64toi32_i32$1 = $5;
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$2 = $7;
  i64toi32_i32$3 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$3 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $630 = i64toi32_i32$3;
  $630$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $6$hi;
  i64toi32_i32$0 = $6;
  i64toi32_i32$1 = 0;
  i64toi32_i32$2 = 56;
  i64toi32_i32$5 = i64toi32_i32$2 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $361 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
   $361 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$5 | 0) | 0;
  }
  $632$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $630$hi;
  i64toi32_i32$4 = $630;
  i64toi32_i32$0 = $632$hi;
  i64toi32_i32$2 = $361;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  i64toi32_i32$3 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
  }
  i64toi32_i32$4 = $627;
  HEAP32[(i64toi32_i32$4 + 520 | 0) >> 2] = i64toi32_i32$5;
  HEAP32[(i64toi32_i32$4 + 524 | 0) >> 2] = i64toi32_i32$3;
  cryptoxide__curve25519__scalar__scalar64__reduce256__he9e2203f350907b0($0 | 0, $4 + 488 | 0 | 0);
  global$0 = $4 + 528 | 0;
 }
 
 function $cardano_serialization_lib__TransactionOutput_20as_20core__clone__Clone___clone__h6884f0c4818d1aeb($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $2 = 0, $27 = 0, $27$hi = 0, $28 = 0, $28$hi = 0, $22$hi = 0, $22 = 0, $24 = 0, $24$hi = 0, $8 = 0, $29$hi = 0, $25 = 0, $25$hi = 0, $29 = 0, $4 = 0, $5 = 0, $17 = 0, $118 = 0, $23 = 0, $23$hi = 0, $7 = 0, $119 = 0, $120 = 0, $121 = 0, $122 = 0, $123 = 0, $124 = 0, $125 = 0, $126 = 0, $127 = 0, $128 = 0, $129 = 0, $3 = 0, $6 = 0, $30 = 0, $30$hi = 0, $9 = 0, $12 = 0, $14 = 0, $15 = 0, $16 = 0, $20 = 0, $21 = 0, $26 = 0, $130 = 0, $131 = 0, $132 = 0, $133 = 0, $134 = 0, $135 = 0, $10 = 0, $136 = 0, $11 = 0, $137 = 0, $138 = 0, $13 = 0, $139 = 0, $140 = 0, $141 = 0, $142 = 0, $143 = 0, $144 = 0, $145 = 0, $146 = 0, $147 = 0, $148 = 0, $149 = 0, $150 = 0, $151 = 0, $152 = 0, $153 = 0, $154 = 0, $18 = 0, $19 = 0, $155 = 0, $156 = 0, $157 = 0, $158 = 0, $160 = 0, $161 = 0, $21$hi = 0, $46 = 0, $26$hi = 0, $77 = 0, $103 = 0, $103$hi = 0, $104 = 0, $104$hi = 0, $106$hi = 0, $108$hi = 0, $110 = 0, $110$hi = 0, $111 = 0, $111$hi = 0, $113$hi = 0, $115$hi = 0, $159 = 0, $165 = 0, $165$hi = 0, $168 = 0, $168$hi = 0, $172$hi = 0, $174$hi = 0, $181$hi = 0, $183 = 0, $183$hi = 0, $186 = 0, $186$hi = 0, $190$hi = 0, $232 = 0, $235 = 0, $235$hi = 0, $238 = 0, $238$hi = 0, $242$hi = 0, $244$hi = 0, $267 = 0, $270 = 0, $270$hi = 0, $273 = 0, $273$hi = 0, $277$hi = 0, $279$hi = 0, $295 = 0, $299 = 0, $302 = 0, $302$hi = 0, $306$hi = 0, $391 = 0, $396 = 0, $404 = 0, $409 = 0, $413 = 0, $417 = 0, $425 = 0, $429 = 0, $476 = 0, $476$hi = 0, $477 = 0, $485 = 0, $488$hi = 0, $490$hi = 0, $491 = 0, $493 = 0, $495$hi = 0, $498 = 0, $498$hi = 0, $499 = 0, $505 = 0, $509 = 0, $513 = 0, $517 = 0, $523 = 0, $529 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      switch (HEAPU8[$1 >> 0] | 0 | 0) {
      default:
       $3 = HEAPU8[($1 + 1 | 0) >> 0] | 0;
       i64toi32_i32$2 = $1 + 3 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $21 = i64toi32_i32$0;
       $21$hi = i64toi32_i32$1;
       i64toi32_i32$0 = $2;
       HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = $21;
       HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $1 + 8 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $46 = i64toi32_i32$1;
       i64toi32_i32$1 = $2;
       $118 = $46;
       HEAP8[(i64toi32_i32$1 + 29 | 0) >> 0] = $118;
       HEAP8[(i64toi32_i32$1 + 30 | 0) >> 0] = $118 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 31 | 0) >> 0] = $118 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 32 | 0) >> 0] = $118 >>> 24 | 0;
       HEAP8[(i64toi32_i32$1 + 33 | 0) >> 0] = i64toi32_i32$0;
       HEAP8[(i64toi32_i32$1 + 34 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 35 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 36 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
       $4 = HEAP32[($1 + 20 | 0) >> 2] | 0;
       $5 = HEAP32[($1 + 16 | 0) >> 2] | 0;
       $6 = HEAPU8[($1 + 2 | 0) >> 0] | 0;
       i64toi32_i32$2 = $1 + 24 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = 0;
       $22 = i64toi32_i32$0;
       $22$hi = i64toi32_i32$1;
       i64toi32_i32$2 = $1 + 28 | 0;
       i64toi32_i32$1 = HEAPU16[i64toi32_i32$2 >> 1] | 0;
       i64toi32_i32$0 = 0;
       $23 = i64toi32_i32$1;
       $23$hi = i64toi32_i32$0;
       i64toi32_i32$2 = $1 + 30 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
       i64toi32_i32$1 = 0;
       $24 = i64toi32_i32$0;
       $24$hi = i64toi32_i32$1;
       $7 = HEAPU8[($2 + 25 | 0) >> 0] | 0 | ((HEAPU8[($2 + 26 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 27 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 28 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = $2;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 29 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 30 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 31 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 32 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 33 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 34 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 35 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 36 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $25 = i64toi32_i32$1;
       $25$hi = i64toi32_i32$0;
       i64toi32_i32$2 = $1 + 32 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $26 = i64toi32_i32$0;
       $26$hi = i64toi32_i32$1;
       i64toi32_i32$0 = $2;
       HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = $26;
       HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $1 + 37 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $77 = i64toi32_i32$1;
       i64toi32_i32$1 = $2;
       $119 = $77;
       HEAP8[(i64toi32_i32$1 + 29 | 0) >> 0] = $119;
       HEAP8[(i64toi32_i32$1 + 30 | 0) >> 0] = $119 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 31 | 0) >> 0] = $119 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 32 | 0) >> 0] = $119 >>> 24 | 0;
       HEAP8[(i64toi32_i32$1 + 33 | 0) >> 0] = i64toi32_i32$0;
       HEAP8[(i64toi32_i32$1 + 34 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 35 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 36 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
       i64toi32_i32$2 = $1 + 45 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $27 = i64toi32_i32$0;
       $27$hi = i64toi32_i32$1;
       $8 = HEAPU8[($1 + 31 | 0) >> 0] | 0;
       i64toi32_i32$2 = $1 + 53 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = 0;
       $28 = i64toi32_i32$1;
       $28$hi = i64toi32_i32$0;
       i64toi32_i32$2 = $1 + 57 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
       i64toi32_i32$1 = 0;
       $29 = i64toi32_i32$0;
       $29$hi = i64toi32_i32$1;
       i64toi32_i32$2 = $1 + 59 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
       i64toi32_i32$0 = 0;
       $30 = i64toi32_i32$1;
       $30$hi = i64toi32_i32$0;
       $9 = HEAPU8[($2 + 25 | 0) >> 0] | 0;
       HEAP8[(($2 + 60 | 0) + 2 | 0) >> 0] = HEAPU8[($2 + 28 | 0) >> 0] | 0;
       HEAP16[($2 + 60 | 0) >> 1] = HEAPU16[($2 + 26 | 0) >> 1] | 0;
       i64toi32_i32$0 = $22$hi;
       $103 = $22;
       $103$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $23$hi;
       $104 = $23;
       $104$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $24$hi;
       i64toi32_i32$2 = $24;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $130 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
        $130 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       $106$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $104$hi;
       i64toi32_i32$0 = $104;
       i64toi32_i32$2 = $106$hi;
       i64toi32_i32$3 = $130;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
       i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        $131 = 0;
       } else {
        i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
        $131 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       }
       $108$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $103$hi;
       i64toi32_i32$2 = $103;
       i64toi32_i32$1 = $108$hi;
       i64toi32_i32$3 = $131;
       i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
       $22 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       $22$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $28$hi;
       $110 = $28;
       $110$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $29$hi;
       $111 = $29;
       $111$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $30$hi;
       i64toi32_i32$0 = $30;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $132 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $132 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       $113$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $111$hi;
       i64toi32_i32$1 = $111;
       i64toi32_i32$0 = $113$hi;
       i64toi32_i32$3 = $132;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $133 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
        $133 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       $115$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $110$hi;
       i64toi32_i32$0 = $110;
       i64toi32_i32$2 = $115$hi;
       i64toi32_i32$3 = $133;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
       $24 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
       $24$hi = i64toi32_i32$2;
       i64toi32_i32$1 = $24;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 24;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = 0;
        $134 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
        $134 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
       }
       $23 = $134;
       $23$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $24$hi;
       i64toi32_i32$2 = $24;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = 0;
        $135 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
        $135 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
       }
       $10 = $135;
       i64toi32_i32$1 = $24$hi;
       i64toi32_i32$0 = $24;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 8;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = 0;
        $136 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
        $136 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
       }
       $11 = $136;
       i64toi32_i32$1 = $2;
       i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 29 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 30 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 31 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 32 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 33 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 34 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 35 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 36 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $30 = i64toi32_i32$2;
       $30$hi = i64toi32_i32$0;
       i64toi32_i32$1 = i64toi32_i32$2;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = 0;
        $137 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
        $137 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
       }
       $24 = $137;
       $24$hi = i64toi32_i32$2;
       i64toi32_i32$2 = 0;
       i64toi32_i32$0 = ($8 | 0) == (1 | 0);
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 56;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $138 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
        $138 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       $29 = $138;
       $29$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $21$hi;
       $12 = $21;
       i64toi32_i32$1 = $28$hi;
       $13 = $28;
       i64toi32_i32$1 = $26$hi;
       $14 = $26;
       i64toi32_i32$1 = $27$hi;
       i64toi32_i32$2 = $27;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 56;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = 0;
        $139 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
        $139 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
       }
       $15 = $139;
       i64toi32_i32$0 = $30$hi;
       $16 = $30;
       $17 = 0;
       break label$1;
      case 1:
       $14 = HEAPU8[($1 + 32 | 0) >> 0] | 0;
       i64toi32_i32$1 = $1 + 34 | 0;
       i64toi32_i32$0 = HEAPU16[i64toi32_i32$1 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
       i64toi32_i32$2 = HEAPU16[(i64toi32_i32$1 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
       $27 = i64toi32_i32$0;
       $27$hi = i64toi32_i32$2;
       i64toi32_i32$0 = $2;
       HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = $27;
       HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = i64toi32_i32$2;
       HEAP8[(i64toi32_i32$0 + 62 | 0) >> 0] = HEAPU8[(i64toi32_i32$0 + 26 | 0) >> 0] | 0;
       i64toi32_i32$1 = $1 + 39 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $159 = i64toi32_i32$2;
       i64toi32_i32$2 = $2;
       $120 = $159;
       HEAP8[(i64toi32_i32$2 + 29 | 0) >> 0] = $120;
       HEAP8[(i64toi32_i32$2 + 30 | 0) >> 0] = $120 >>> 8 | 0;
       HEAP8[(i64toi32_i32$2 + 31 | 0) >> 0] = $120 >>> 16 | 0;
       HEAP8[(i64toi32_i32$2 + 32 | 0) >> 0] = $120 >>> 24 | 0;
       HEAP8[(i64toi32_i32$2 + 33 | 0) >> 0] = i64toi32_i32$0;
       HEAP8[(i64toi32_i32$2 + 34 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
       HEAP8[(i64toi32_i32$2 + 35 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
       HEAP8[(i64toi32_i32$2 + 36 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
       i64toi32_i32$0 = $27$hi;
       HEAP16[(i64toi32_i32$2 + 60 | 0) >> 1] = $27;
       i64toi32_i32$1 = $1 + 55 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = 0;
       $25 = i64toi32_i32$0;
       $25$hi = i64toi32_i32$2;
       $165 = i64toi32_i32$0;
       $165$hi = i64toi32_i32$2;
       i64toi32_i32$1 = $1 + 59 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
       i64toi32_i32$0 = 0;
       $168 = i64toi32_i32$2;
       $168$hi = i64toi32_i32$0;
       i64toi32_i32$1 = $1 + 61 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
       i64toi32_i32$2 = 0;
       i64toi32_i32$1 = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        $140 = 0;
       } else {
        i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
        $140 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       }
       $172$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $168$hi;
       i64toi32_i32$2 = $168;
       i64toi32_i32$1 = $172$hi;
       i64toi32_i32$3 = $140;
       i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $141 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $141 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       $174$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $165$hi;
       i64toi32_i32$1 = $165;
       i64toi32_i32$0 = $174$hi;
       i64toi32_i32$3 = $141;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 8;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = 0;
        $142 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
        $142 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
       }
       $23 = $142;
       $23$hi = i64toi32_i32$1;
       i64toi32_i32$0 = $1 + 47 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $28 = i64toi32_i32$1;
       $28$hi = i64toi32_i32$2;
       i64toi32_i32$0 = i64toi32_i32$1;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $143 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
        $143 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       $181$hi = i64toi32_i32$1;
       i64toi32_i32$2 = $2;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 35 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 36 | 0) >> 0] | 0) << 8 | 0) | 0;
       i64toi32_i32$0 = 0;
       $183 = i64toi32_i32$1;
       $183$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $181$hi;
       i64toi32_i32$2 = $143;
       i64toi32_i32$1 = $183$hi;
       i64toi32_i32$3 = $183;
       i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
       $27 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       $27$hi = i64toi32_i32$1;
       i64toi32_i32$0 = $2;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 29 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 30 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 31 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 32 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = 0;
       $186 = i64toi32_i32$1;
       $186$hi = i64toi32_i32$2;
       i64toi32_i32$0 = i64toi32_i32$0 + 33 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$0 = i64toi32_i32$2;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $144 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $144 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       $190$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $186$hi;
       i64toi32_i32$1 = $186;
       i64toi32_i32$0 = $190$hi;
       i64toi32_i32$3 = $144;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
       $24 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       $24$hi = i64toi32_i32$0;
       $9 = HEAPU8[($1 + 33 | 0) >> 0] | 0;
       $16 = HEAPU8[($2 + 27 | 0) >> 0] | 0 | ((HEAPU8[($2 + 28 | 0) >> 0] | 0) << 8 | 0) | 0;
       i64toi32_i32$2 = $1 + 24 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $22 = i64toi32_i32$0;
       $22$hi = i64toi32_i32$1;
       i64toi32_i32$2 = i64toi32_i32$0;
       i64toi32_i32$0 = -16777216;
       i64toi32_i32$3 = 0;
       i64toi32_i32$0 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
       $29 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
       $29$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $25$hi;
       $10 = $25;
       i64toi32_i32$0 = $28$hi;
       i64toi32_i32$1 = $28;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 48;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = 0;
        $145 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
        $145 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
       }
       $13 = $145;
       i64toi32_i32$2 = $28$hi;
       i64toi32_i32$0 = $28;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 56;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = 0;
        $146 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
        $146 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
       }
       $11 = $146;
       i64toi32_i32$1 = $28$hi;
       i64toi32_i32$2 = $28;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 40;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = 0;
        $147 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
        $147 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
       }
       $15 = $147;
       $4 = HEAP32[($1 + 20 | 0) >> 2] | 0;
       $5 = HEAP32[($1 + 16 | 0) >> 2] | 0;
       i64toi32_i32$1 = $1 + 8 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $25 = i64toi32_i32$0;
       $25$hi = i64toi32_i32$2;
       $17 = 1;
       break label$3;
      case 2:
       $3 = HEAPU8[($1 + 1 | 0) >> 0] | 0;
       i64toi32_i32$1 = $1 + 3 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $27 = i64toi32_i32$2;
       $27$hi = i64toi32_i32$0;
       i64toi32_i32$2 = $2;
       HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] = $27;
       HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$1 = $1 + 8 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $232 = i64toi32_i32$0;
       i64toi32_i32$0 = $2;
       $121 = $232;
       HEAP8[(i64toi32_i32$0 + 29 | 0) >> 0] = $121;
       HEAP8[(i64toi32_i32$0 + 30 | 0) >> 0] = $121 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 31 | 0) >> 0] = $121 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 32 | 0) >> 0] = $121 >>> 24 | 0;
       HEAP8[(i64toi32_i32$0 + 33 | 0) >> 0] = i64toi32_i32$2;
       HEAP8[(i64toi32_i32$0 + 34 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 35 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 36 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
       i64toi32_i32$1 = $1 + 24 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$0 = 0;
       $235 = i64toi32_i32$2;
       $235$hi = i64toi32_i32$0;
       i64toi32_i32$1 = $1 + 28 | 0;
       i64toi32_i32$0 = HEAPU16[i64toi32_i32$1 >> 1] | 0;
       i64toi32_i32$2 = 0;
       $238 = i64toi32_i32$0;
       $238$hi = i64toi32_i32$2;
       i64toi32_i32$1 = $1 + 30 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$1 = i64toi32_i32$2;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        $148 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
        $148 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       }
       $242$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $238$hi;
       i64toi32_i32$0 = $238;
       i64toi32_i32$1 = $242$hi;
       i64toi32_i32$3 = $148;
       i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
       i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $149 = 0;
       } else {
        i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $149 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       $244$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $235$hi;
       i64toi32_i32$1 = $235;
       i64toi32_i32$2 = $244$hi;
       i64toi32_i32$3 = $149;
       i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
       $22 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       $22$hi = i64toi32_i32$2;
       $4 = HEAP32[($1 + 20 | 0) >> 2] | 0;
       $5 = HEAP32[($1 + 16 | 0) >> 2] | 0;
       $17 = 2;
       $6 = HEAPU8[($1 + 2 | 0) >> 0] | 0;
       i64toi32_i32$2 = $27$hi;
       $12 = $27;
       break label$2;
      case 3:
       $17 = 3;
       $3 = HEAPU8[($1 + 1 | 0) >> 0] | 0;
       i64toi32_i32$0 = $1 + 3 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $27 = i64toi32_i32$2;
       $27$hi = i64toi32_i32$1;
       i64toi32_i32$2 = $2;
       HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] = $27;
       HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$0 = $1 + 8 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $267 = i64toi32_i32$1;
       i64toi32_i32$1 = $2;
       $122 = $267;
       HEAP8[(i64toi32_i32$1 + 29 | 0) >> 0] = $122;
       HEAP8[(i64toi32_i32$1 + 30 | 0) >> 0] = $122 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 31 | 0) >> 0] = $122 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 32 | 0) >> 0] = $122 >>> 24 | 0;
       HEAP8[(i64toi32_i32$1 + 33 | 0) >> 0] = i64toi32_i32$2;
       HEAP8[(i64toi32_i32$1 + 34 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 35 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 36 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
       i64toi32_i32$0 = $1 + 24 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
       i64toi32_i32$1 = 0;
       $270 = i64toi32_i32$2;
       $270$hi = i64toi32_i32$1;
       i64toi32_i32$0 = $1 + 28 | 0;
       i64toi32_i32$1 = HEAPU16[i64toi32_i32$0 >> 1] | 0;
       i64toi32_i32$2 = 0;
       $273 = i64toi32_i32$1;
       $273$hi = i64toi32_i32$2;
       i64toi32_i32$0 = $1 + 30 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$0 = i64toi32_i32$2;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $150 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $150 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       $277$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $273$hi;
       i64toi32_i32$1 = $273;
       i64toi32_i32$0 = $277$hi;
       i64toi32_i32$3 = $150;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $151 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
        $151 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       $279$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $270$hi;
       i64toi32_i32$0 = $270;
       i64toi32_i32$2 = $279$hi;
       i64toi32_i32$3 = $151;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
       $22 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
       $22$hi = i64toi32_i32$2;
       $4 = HEAP32[($1 + 20 | 0) >> 2] | 0;
       $5 = HEAP32[($1 + 16 | 0) >> 2] | 0;
       $6 = HEAPU8[($1 + 2 | 0) >> 0] | 0;
       i64toi32_i32$2 = $27$hi;
       $12 = $27;
       break label$2;
      case 4:
       break label$4;
      };
     }
     i64toi32_i32$1 = $1 + 29 | 0;
     i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $295 = i64toi32_i32$2;
     i64toi32_i32$2 = $2;
     $123 = $295;
     HEAP8[(i64toi32_i32$2 + 29 | 0) >> 0] = $123;
     HEAP8[(i64toi32_i32$2 + 30 | 0) >> 0] = $123 >>> 8 | 0;
     HEAP8[(i64toi32_i32$2 + 31 | 0) >> 0] = $123 >>> 16 | 0;
     HEAP8[(i64toi32_i32$2 + 32 | 0) >> 0] = $123 >>> 24 | 0;
     HEAP8[(i64toi32_i32$2 + 33 | 0) >> 0] = i64toi32_i32$0;
     HEAP8[(i64toi32_i32$2 + 34 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
     HEAP8[(i64toi32_i32$2 + 35 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
     HEAP8[(i64toi32_i32$2 + 36 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
     i64toi32_i32$1 = $1 + 24 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $299 = i64toi32_i32$0;
     i64toi32_i32$0 = $2;
     HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = $299;
     HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$1 = $1 + 49 | 0;
     i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
     i64toi32_i32$0 = 0;
     $302 = i64toi32_i32$2;
     $302$hi = i64toi32_i32$0;
     i64toi32_i32$1 = $1 + 51 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
     i64toi32_i32$2 = 0;
     i64toi32_i32$1 = i64toi32_i32$0;
     i64toi32_i32$0 = 0;
     i64toi32_i32$3 = 16;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
      $152 = 0;
     } else {
      i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
      $152 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
     }
     $306$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $302$hi;
     i64toi32_i32$2 = $302;
     i64toi32_i32$1 = $306$hi;
     i64toi32_i32$3 = $152;
     i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
     i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
     i64toi32_i32$2 = 0;
     i64toi32_i32$3 = 32;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
      $153 = 0;
     } else {
      i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
      $153 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
     }
     $27 = $153;
     $27$hi = i64toi32_i32$2;
     i64toi32_i32$1 = $1 + 45 | 0;
     i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = 0;
     $22 = i64toi32_i32$2;
     $22$hi = i64toi32_i32$0;
     i64toi32_i32$1 = $1 + 37 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $28 = i64toi32_i32$0;
     $28$hi = i64toi32_i32$2;
     $17 = 4;
     label$9 : {
      label$10 : {
       $8 = $1 + 4 | 0;
       if (HEAP32[$8 >> 2] | 0) {
        break label$10
       }
       $7 = 0;
       break label$9;
      }
      $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($2 + 8 | 0 | 0, $8 | 0);
      i64toi32_i32$1 = $2;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] | 0;
      $25 = i64toi32_i32$2;
      $25$hi = i64toi32_i32$0;
      $7 = HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] | 0;
     }
     i64toi32_i32$0 = $22$hi;
     i64toi32_i32$0 = $27$hi;
     i64toi32_i32$0 = $22$hi;
     i64toi32_i32$1 = $22;
     i64toi32_i32$2 = $27$hi;
     i64toi32_i32$3 = $27;
     i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
     $27 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
     $27$hi = i64toi32_i32$2;
     HEAP8[($2 + 62 | 0) >> 0] = HEAPU8[($2 + 36 | 0) >> 0] | 0;
     HEAP16[($2 + 60 | 0) >> 1] = HEAPU16[($2 + 34 | 0) >> 1] | 0;
     i64toi32_i32$2 = $28$hi;
     i64toi32_i32$0 = $28;
     i64toi32_i32$1 = 0;
     i64toi32_i32$3 = 16;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$1 = 0;
      $154 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
     } else {
      i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
      $154 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
     }
     $24 = $154;
     $24$hi = i64toi32_i32$1;
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
     $22 = i64toi32_i32$1;
     $22$hi = i64toi32_i32$0;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$1 = -16777216;
     i64toi32_i32$3 = 0;
     i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
     $29 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     $29$hi = i64toi32_i32$1;
     $4 = HEAP32[($1 + 20 | 0) >> 2] | 0;
     $5 = HEAP32[($1 + 16 | 0) >> 2] | 0;
     $15 = HEAPU8[($1 + 52 | 0) >> 0] | 0;
     $14 = HEAPU8[($2 + 32 | 0) >> 0] | 0;
     $9 = HEAPU8[($2 + 33 | 0) >> 0] | 0;
     i64toi32_i32$1 = $28$hi;
     $16 = $28;
    }
    break label$1;
   }
   $7 = HEAPU8[($2 + 25 | 0) >> 0] | 0 | ((HEAPU8[($2 + 26 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 27 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 28 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = $2;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 29 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 30 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 31 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 32 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 33 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 34 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 35 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 36 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $25 = i64toi32_i32$1;
   $25$hi = i64toi32_i32$2;
   i64toi32_i32$2 = 0;
   $29 = 0;
   $29$hi = i64toi32_i32$2;
  }
  HEAP8[(($2 + 4 | 0) + 2 | 0) >> 0] = HEAPU8[(($2 + 60 | 0) + 2 | 0) >> 0] | 0;
  HEAP16[($2 + 4 | 0) >> 1] = HEAPU16[($2 + 60 | 0) >> 1] | 0;
  i64toi32_i32$0 = $1;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 64 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 68 | 0) >> 2] | 0;
  $28 = i64toi32_i32$2;
  $28$hi = i64toi32_i32$1;
  $8 = 0;
  $18 = 0;
  label$11 : {
   if ((HEAP32[(i64toi32_i32$0 + 72 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$11
   }
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($2 + 24 | 0 | 4 | 0 | 0, $1 + 76 | 0 | 0);
   $18 = 1;
  }
  $19 = ($2 + 8 | 0) + 8 | 0;
  $20 = ($2 + 24 | 0) + 8 | 0;
  i64toi32_i32$0 = $20;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $391 = i64toi32_i32$1;
  i64toi32_i32$1 = $19;
  HEAP32[i64toi32_i32$1 >> 2] = $391;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  HEAP32[($2 + 24 | 0) >> 2] = $18;
  i64toi32_i32$0 = $2;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] | 0;
  $396 = i64toi32_i32$2;
  i64toi32_i32$2 = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $396;
  HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$1;
  label$12 : {
   if ((HEAPU8[($1 + 88 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$12
   }
   i64toi32_i32$0 = $1 + 113 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $404 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 48 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $404;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = $1 + 105 | 0;
   i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $409 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 40 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $409;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$0 = $1 + 97 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $413 = i64toi32_i32$1;
   i64toi32_i32$1 = $20;
   HEAP32[i64toi32_i32$1 >> 2] = $413;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = $1 + 89 | 0;
   i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $417 = i64toi32_i32$2;
   i64toi32_i32$2 = $2;
   HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] = $417;
   HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] = i64toi32_i32$1;
   $8 = 1;
  }
  HEAP8[($0 + 1 | 0) >> 0] = $3;
  HEAP8[$0 >> 0] = $17;
  i64toi32_i32$1 = $28$hi;
  i64toi32_i32$2 = $0;
  HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] = $28;
  HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] = i64toi32_i32$1;
  $425 = i64toi32_i32$2 + 51 | 0;
  i64toi32_i32$1 = $27$hi;
  i64toi32_i32$0 = $27;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 48;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $155 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   $155 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[$425 >> 0] = $155;
  $429 = $0 + 49 | 0;
  i64toi32_i32$2 = $27$hi;
  i64toi32_i32$1 = $27;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $156 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   $156 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
  }
  $157 = $429;
  $158 = $156;
  HEAP8[$157 >> 0] = $158;
  HEAP8[($157 + 1 | 0) >> 0] = $158 >>> 8 | 0;
  i64toi32_i32$0 = $27$hi;
  $124 = $0 + 45 | 0;
  HEAP8[$124 >> 0] = $27;
  HEAP8[($124 + 1 | 0) >> 0] = $27 >>> 8 | 0;
  HEAP8[($124 + 2 | 0) >> 0] = $27 >>> 16 | 0;
  HEAP8[($124 + 3 | 0) >> 0] = $27 >>> 24 | 0;
  HEAP8[($0 + 33 | 0) >> 0] = $9;
  HEAP8[($0 + 32 | 0) >> 0] = $14;
  i64toi32_i32$0 = $25$hi;
  i64toi32_i32$1 = $0 + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $25;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($0 + 4 | 0) >> 2] = $7;
  HEAP8[($0 + 3 | 0) >> 0] = $12;
  HEAP8[($0 + 2 | 0) >> 0] = $6;
  HEAP16[($0 + 34 | 0) >> 1] = HEAPU16[($2 + 4 | 0) >> 1] | 0;
  i64toi32_i32$0 = $23$hi;
  i64toi32_i32$1 = $0 + 56 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $23;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP8[($0 + 55 | 0) >> 0] = $10;
  HEAP8[($0 + 54 | 0) >> 0] = $11;
  HEAP8[($0 + 53 | 0) >> 0] = $13;
  HEAP8[($0 + 52 | 0) >> 0] = $15;
  i64toi32_i32$0 = $29$hi;
  i64toi32_i32$0 = $22$hi;
  i64toi32_i32$2 = $22;
  i64toi32_i32$1 = 16777215;
  i64toi32_i32$3 = -1;
  i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
  $476 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
  $476$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $29$hi;
  i64toi32_i32$0 = $29;
  i64toi32_i32$2 = $476$hi;
  i64toi32_i32$3 = $476;
  i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
  $477 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $0 + 24 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $477;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  HEAP8[($0 + 36 | 0) >> 0] = HEAPU8[(($2 + 4 | 0) + 2 | 0) >> 0] | 0;
  $485 = $0 + 16 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$1 = $4;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
   $160 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
   $160 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
  }
  $488$hi = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  $490$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $488$hi;
  i64toi32_i32$2 = $160;
  i64toi32_i32$1 = $490$hi;
  i64toi32_i32$3 = $5;
  i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
  $491 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $485;
  HEAP32[i64toi32_i32$2 >> 2] = $491;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
  $493 = $0 + 37 | 0;
  i64toi32_i32$1 = $24$hi;
  i64toi32_i32$0 = $24;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 16;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   $161 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $161 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
  }
  $495$hi = i64toi32_i32$2;
  i64toi32_i32$2 = 0;
  i64toi32_i32$1 = $16;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 65535;
  i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
  $498 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
  $498$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $495$hi;
  i64toi32_i32$2 = $161;
  i64toi32_i32$1 = $498$hi;
  i64toi32_i32$3 = $498;
  i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
  $499 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $493;
  $125 = $499;
  HEAP8[i64toi32_i32$2 >> 0] = $125;
  HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $125 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $125 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $125 >>> 24 | 0;
  HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  HEAP8[($0 + 88 | 0) >> 0] = $8;
  i64toi32_i32$0 = $19;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $505 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 80 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $505;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$0 = $2;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] | 0;
  $509 = i64toi32_i32$2;
  i64toi32_i32$2 = $0 + 72 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $509;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] | 0;
  $513 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 89 | 0;
  $126 = $513;
  HEAP8[i64toi32_i32$1 >> 0] = $126;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $126 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $126 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $126 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$2;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
  i64toi32_i32$0 = $20;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $517 = i64toi32_i32$2;
  i64toi32_i32$2 = $0 + 97 | 0;
  $127 = $517;
  HEAP8[i64toi32_i32$2 >> 0] = $127;
  HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $127 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $127 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $127 >>> 24 | 0;
  HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$0 = ($2 + 24 | 0) + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $523 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 105 | 0;
  $128 = $523;
  HEAP8[i64toi32_i32$1 >> 0] = $128;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $128 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $128 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $128 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$2;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
  i64toi32_i32$0 = ($2 + 24 | 0) + 24 | 0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $529 = i64toi32_i32$2;
  i64toi32_i32$2 = $0 + 113 | 0;
  $129 = $529;
  HEAP8[i64toi32_i32$2 >> 0] = $129;
  HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $129 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $129 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $129 >>> 24 | 0;
  HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  global$0 = $2 + 64 | 0;
 }
 
 function $cardano_serialization_lib__TransactionOutput_20as_20core__clone__Clone___clone__h6884f0c4818d1aeb_1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $2 = 0, $27 = 0, $27$hi = 0, $28 = 0, $28$hi = 0, $22$hi = 0, $22 = 0, $24 = 0, $24$hi = 0, $8 = 0, $29$hi = 0, $25 = 0, $25$hi = 0, $29 = 0, $4 = 0, $5 = 0, $17 = 0, $118 = 0, $23 = 0, $23$hi = 0, $7 = 0, $119 = 0, $120 = 0, $121 = 0, $122 = 0, $123 = 0, $124 = 0, $125 = 0, $126 = 0, $127 = 0, $128 = 0, $129 = 0, $3 = 0, $6 = 0, $30 = 0, $30$hi = 0, $9 = 0, $12 = 0, $14 = 0, $15 = 0, $16 = 0, $20 = 0, $21 = 0, $26 = 0, $130 = 0, $131 = 0, $132 = 0, $133 = 0, $134 = 0, $135 = 0, $10 = 0, $136 = 0, $11 = 0, $137 = 0, $138 = 0, $13 = 0, $139 = 0, $140 = 0, $141 = 0, $142 = 0, $143 = 0, $144 = 0, $145 = 0, $146 = 0, $147 = 0, $148 = 0, $149 = 0, $150 = 0, $151 = 0, $152 = 0, $153 = 0, $154 = 0, $18 = 0, $19 = 0, $155 = 0, $156 = 0, $157 = 0, $158 = 0, $160 = 0, $161 = 0, $21$hi = 0, $46 = 0, $26$hi = 0, $77 = 0, $103 = 0, $103$hi = 0, $104 = 0, $104$hi = 0, $106$hi = 0, $108$hi = 0, $110 = 0, $110$hi = 0, $111 = 0, $111$hi = 0, $113$hi = 0, $115$hi = 0, $159 = 0, $165 = 0, $165$hi = 0, $168 = 0, $168$hi = 0, $172$hi = 0, $174$hi = 0, $181$hi = 0, $183 = 0, $183$hi = 0, $186 = 0, $186$hi = 0, $190$hi = 0, $232 = 0, $235 = 0, $235$hi = 0, $238 = 0, $238$hi = 0, $242$hi = 0, $244$hi = 0, $267 = 0, $270 = 0, $270$hi = 0, $273 = 0, $273$hi = 0, $277$hi = 0, $279$hi = 0, $295 = 0, $299 = 0, $302 = 0, $302$hi = 0, $306$hi = 0, $391 = 0, $396 = 0, $404 = 0, $409 = 0, $413 = 0, $417 = 0, $425 = 0, $429 = 0, $476 = 0, $476$hi = 0, $477 = 0, $485 = 0, $488$hi = 0, $490$hi = 0, $491 = 0, $493 = 0, $495$hi = 0, $498 = 0, $498$hi = 0, $499 = 0, $505 = 0, $509 = 0, $513 = 0, $517 = 0, $523 = 0, $529 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      switch (HEAPU8[$1 >> 0] | 0 | 0) {
      default:
       $3 = HEAPU8[($1 + 1 | 0) >> 0] | 0;
       i64toi32_i32$2 = $1 + 3 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $21 = i64toi32_i32$0;
       $21$hi = i64toi32_i32$1;
       i64toi32_i32$0 = $2;
       HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = $21;
       HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $1 + 8 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $46 = i64toi32_i32$1;
       i64toi32_i32$1 = $2;
       $118 = $46;
       HEAP8[(i64toi32_i32$1 + 29 | 0) >> 0] = $118;
       HEAP8[(i64toi32_i32$1 + 30 | 0) >> 0] = $118 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 31 | 0) >> 0] = $118 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 32 | 0) >> 0] = $118 >>> 24 | 0;
       HEAP8[(i64toi32_i32$1 + 33 | 0) >> 0] = i64toi32_i32$0;
       HEAP8[(i64toi32_i32$1 + 34 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 35 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 36 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
       $4 = HEAP32[($1 + 20 | 0) >> 2] | 0;
       $5 = HEAP32[($1 + 16 | 0) >> 2] | 0;
       $6 = HEAPU8[($1 + 2 | 0) >> 0] | 0;
       i64toi32_i32$2 = $1 + 24 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = 0;
       $22 = i64toi32_i32$0;
       $22$hi = i64toi32_i32$1;
       i64toi32_i32$2 = $1 + 28 | 0;
       i64toi32_i32$1 = HEAPU16[i64toi32_i32$2 >> 1] | 0;
       i64toi32_i32$0 = 0;
       $23 = i64toi32_i32$1;
       $23$hi = i64toi32_i32$0;
       i64toi32_i32$2 = $1 + 30 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
       i64toi32_i32$1 = 0;
       $24 = i64toi32_i32$0;
       $24$hi = i64toi32_i32$1;
       $7 = HEAPU8[($2 + 25 | 0) >> 0] | 0 | ((HEAPU8[($2 + 26 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 27 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 28 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = $2;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 29 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 30 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 31 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 32 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 33 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 34 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 35 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 36 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $25 = i64toi32_i32$1;
       $25$hi = i64toi32_i32$0;
       i64toi32_i32$2 = $1 + 32 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $26 = i64toi32_i32$0;
       $26$hi = i64toi32_i32$1;
       i64toi32_i32$0 = $2;
       HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = $26;
       HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $1 + 37 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $77 = i64toi32_i32$1;
       i64toi32_i32$1 = $2;
       $119 = $77;
       HEAP8[(i64toi32_i32$1 + 29 | 0) >> 0] = $119;
       HEAP8[(i64toi32_i32$1 + 30 | 0) >> 0] = $119 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 31 | 0) >> 0] = $119 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 32 | 0) >> 0] = $119 >>> 24 | 0;
       HEAP8[(i64toi32_i32$1 + 33 | 0) >> 0] = i64toi32_i32$0;
       HEAP8[(i64toi32_i32$1 + 34 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 35 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 36 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
       i64toi32_i32$2 = $1 + 45 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $27 = i64toi32_i32$0;
       $27$hi = i64toi32_i32$1;
       $8 = HEAPU8[($1 + 31 | 0) >> 0] | 0;
       i64toi32_i32$2 = $1 + 53 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = 0;
       $28 = i64toi32_i32$1;
       $28$hi = i64toi32_i32$0;
       i64toi32_i32$2 = $1 + 57 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
       i64toi32_i32$1 = 0;
       $29 = i64toi32_i32$0;
       $29$hi = i64toi32_i32$1;
       i64toi32_i32$2 = $1 + 59 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
       i64toi32_i32$0 = 0;
       $30 = i64toi32_i32$1;
       $30$hi = i64toi32_i32$0;
       $9 = HEAPU8[($2 + 25 | 0) >> 0] | 0;
       HEAP8[(($2 + 60 | 0) + 2 | 0) >> 0] = HEAPU8[($2 + 28 | 0) >> 0] | 0;
       HEAP16[($2 + 60 | 0) >> 1] = HEAPU16[($2 + 26 | 0) >> 1] | 0;
       i64toi32_i32$0 = $22$hi;
       $103 = $22;
       $103$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $23$hi;
       $104 = $23;
       $104$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $24$hi;
       i64toi32_i32$2 = $24;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $130 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
        $130 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       $106$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $104$hi;
       i64toi32_i32$0 = $104;
       i64toi32_i32$2 = $106$hi;
       i64toi32_i32$3 = $130;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
       i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        $131 = 0;
       } else {
        i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
        $131 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       }
       $108$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $103$hi;
       i64toi32_i32$2 = $103;
       i64toi32_i32$1 = $108$hi;
       i64toi32_i32$3 = $131;
       i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
       $22 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       $22$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $28$hi;
       $110 = $28;
       $110$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $29$hi;
       $111 = $29;
       $111$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $30$hi;
       i64toi32_i32$0 = $30;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $132 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $132 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       $113$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $111$hi;
       i64toi32_i32$1 = $111;
       i64toi32_i32$0 = $113$hi;
       i64toi32_i32$3 = $132;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $133 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
        $133 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       $115$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $110$hi;
       i64toi32_i32$0 = $110;
       i64toi32_i32$2 = $115$hi;
       i64toi32_i32$3 = $133;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
       $24 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
       $24$hi = i64toi32_i32$2;
       i64toi32_i32$1 = $24;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 24;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = 0;
        $134 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
        $134 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
       }
       $23 = $134;
       $23$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $24$hi;
       i64toi32_i32$2 = $24;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = 0;
        $135 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
        $135 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
       }
       $10 = $135;
       i64toi32_i32$1 = $24$hi;
       i64toi32_i32$0 = $24;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 8;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = 0;
        $136 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
        $136 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
       }
       $11 = $136;
       i64toi32_i32$1 = $2;
       i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 29 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 30 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 31 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 32 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 33 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 34 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 35 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 36 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $30 = i64toi32_i32$2;
       $30$hi = i64toi32_i32$0;
       i64toi32_i32$1 = i64toi32_i32$2;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = 0;
        $137 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
        $137 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
       }
       $24 = $137;
       $24$hi = i64toi32_i32$2;
       i64toi32_i32$2 = 0;
       i64toi32_i32$0 = ($8 | 0) == (1 | 0);
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 56;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $138 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
        $138 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       $29 = $138;
       $29$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $21$hi;
       $12 = $21;
       i64toi32_i32$1 = $28$hi;
       $13 = $28;
       i64toi32_i32$1 = $26$hi;
       $14 = $26;
       i64toi32_i32$1 = $27$hi;
       i64toi32_i32$2 = $27;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 56;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = 0;
        $139 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
        $139 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
       }
       $15 = $139;
       i64toi32_i32$0 = $30$hi;
       $16 = $30;
       $17 = 0;
       break label$1;
      case 1:
       $14 = HEAPU8[($1 + 32 | 0) >> 0] | 0;
       i64toi32_i32$1 = $1 + 34 | 0;
       i64toi32_i32$0 = HEAPU16[i64toi32_i32$1 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
       i64toi32_i32$2 = HEAPU16[(i64toi32_i32$1 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
       $27 = i64toi32_i32$0;
       $27$hi = i64toi32_i32$2;
       i64toi32_i32$0 = $2;
       HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = $27;
       HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = i64toi32_i32$2;
       HEAP8[(i64toi32_i32$0 + 62 | 0) >> 0] = HEAPU8[(i64toi32_i32$0 + 26 | 0) >> 0] | 0;
       i64toi32_i32$1 = $1 + 39 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $159 = i64toi32_i32$2;
       i64toi32_i32$2 = $2;
       $120 = $159;
       HEAP8[(i64toi32_i32$2 + 29 | 0) >> 0] = $120;
       HEAP8[(i64toi32_i32$2 + 30 | 0) >> 0] = $120 >>> 8 | 0;
       HEAP8[(i64toi32_i32$2 + 31 | 0) >> 0] = $120 >>> 16 | 0;
       HEAP8[(i64toi32_i32$2 + 32 | 0) >> 0] = $120 >>> 24 | 0;
       HEAP8[(i64toi32_i32$2 + 33 | 0) >> 0] = i64toi32_i32$0;
       HEAP8[(i64toi32_i32$2 + 34 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
       HEAP8[(i64toi32_i32$2 + 35 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
       HEAP8[(i64toi32_i32$2 + 36 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
       i64toi32_i32$0 = $27$hi;
       HEAP16[(i64toi32_i32$2 + 60 | 0) >> 1] = $27;
       i64toi32_i32$1 = $1 + 55 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = 0;
       $25 = i64toi32_i32$0;
       $25$hi = i64toi32_i32$2;
       $165 = i64toi32_i32$0;
       $165$hi = i64toi32_i32$2;
       i64toi32_i32$1 = $1 + 59 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
       i64toi32_i32$0 = 0;
       $168 = i64toi32_i32$2;
       $168$hi = i64toi32_i32$0;
       i64toi32_i32$1 = $1 + 61 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
       i64toi32_i32$2 = 0;
       i64toi32_i32$1 = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        $140 = 0;
       } else {
        i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
        $140 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       }
       $172$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $168$hi;
       i64toi32_i32$2 = $168;
       i64toi32_i32$1 = $172$hi;
       i64toi32_i32$3 = $140;
       i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $141 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $141 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       $174$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $165$hi;
       i64toi32_i32$1 = $165;
       i64toi32_i32$0 = $174$hi;
       i64toi32_i32$3 = $141;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 8;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = 0;
        $142 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
        $142 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
       }
       $23 = $142;
       $23$hi = i64toi32_i32$1;
       i64toi32_i32$0 = $1 + 47 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $28 = i64toi32_i32$1;
       $28$hi = i64toi32_i32$2;
       i64toi32_i32$0 = i64toi32_i32$1;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $143 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
        $143 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       $181$hi = i64toi32_i32$1;
       i64toi32_i32$2 = $2;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 35 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 36 | 0) >> 0] | 0) << 8 | 0) | 0;
       i64toi32_i32$0 = 0;
       $183 = i64toi32_i32$1;
       $183$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $181$hi;
       i64toi32_i32$2 = $143;
       i64toi32_i32$1 = $183$hi;
       i64toi32_i32$3 = $183;
       i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
       $27 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       $27$hi = i64toi32_i32$1;
       i64toi32_i32$0 = $2;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 29 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 30 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 31 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 32 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = 0;
       $186 = i64toi32_i32$1;
       $186$hi = i64toi32_i32$2;
       i64toi32_i32$0 = i64toi32_i32$0 + 33 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$0 = i64toi32_i32$2;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $144 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $144 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       $190$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $186$hi;
       i64toi32_i32$1 = $186;
       i64toi32_i32$0 = $190$hi;
       i64toi32_i32$3 = $144;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
       $24 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       $24$hi = i64toi32_i32$0;
       $9 = HEAPU8[($1 + 33 | 0) >> 0] | 0;
       $16 = HEAPU8[($2 + 27 | 0) >> 0] | 0 | ((HEAPU8[($2 + 28 | 0) >> 0] | 0) << 8 | 0) | 0;
       i64toi32_i32$2 = $1 + 24 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $22 = i64toi32_i32$0;
       $22$hi = i64toi32_i32$1;
       i64toi32_i32$2 = i64toi32_i32$0;
       i64toi32_i32$0 = -16777216;
       i64toi32_i32$3 = 0;
       i64toi32_i32$0 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
       $29 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
       $29$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $25$hi;
       $10 = $25;
       i64toi32_i32$0 = $28$hi;
       i64toi32_i32$1 = $28;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 48;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = 0;
        $145 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
        $145 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
       }
       $13 = $145;
       i64toi32_i32$2 = $28$hi;
       i64toi32_i32$0 = $28;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 56;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = 0;
        $146 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
        $146 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
       }
       $11 = $146;
       i64toi32_i32$1 = $28$hi;
       i64toi32_i32$2 = $28;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 40;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = 0;
        $147 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
        $147 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
       }
       $15 = $147;
       $4 = HEAP32[($1 + 20 | 0) >> 2] | 0;
       $5 = HEAP32[($1 + 16 | 0) >> 2] | 0;
       i64toi32_i32$1 = $1 + 8 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $25 = i64toi32_i32$0;
       $25$hi = i64toi32_i32$2;
       $17 = 1;
       break label$3;
      case 2:
       $3 = HEAPU8[($1 + 1 | 0) >> 0] | 0;
       i64toi32_i32$1 = $1 + 3 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $27 = i64toi32_i32$2;
       $27$hi = i64toi32_i32$0;
       i64toi32_i32$2 = $2;
       HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] = $27;
       HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$1 = $1 + 8 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $232 = i64toi32_i32$0;
       i64toi32_i32$0 = $2;
       $121 = $232;
       HEAP8[(i64toi32_i32$0 + 29 | 0) >> 0] = $121;
       HEAP8[(i64toi32_i32$0 + 30 | 0) >> 0] = $121 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 31 | 0) >> 0] = $121 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 32 | 0) >> 0] = $121 >>> 24 | 0;
       HEAP8[(i64toi32_i32$0 + 33 | 0) >> 0] = i64toi32_i32$2;
       HEAP8[(i64toi32_i32$0 + 34 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 35 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 36 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
       i64toi32_i32$1 = $1 + 24 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$0 = 0;
       $235 = i64toi32_i32$2;
       $235$hi = i64toi32_i32$0;
       i64toi32_i32$1 = $1 + 28 | 0;
       i64toi32_i32$0 = HEAPU16[i64toi32_i32$1 >> 1] | 0;
       i64toi32_i32$2 = 0;
       $238 = i64toi32_i32$0;
       $238$hi = i64toi32_i32$2;
       i64toi32_i32$1 = $1 + 30 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$1 = i64toi32_i32$2;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        $148 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
        $148 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       }
       $242$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $238$hi;
       i64toi32_i32$0 = $238;
       i64toi32_i32$1 = $242$hi;
       i64toi32_i32$3 = $148;
       i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
       i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $149 = 0;
       } else {
        i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $149 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       $244$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $235$hi;
       i64toi32_i32$1 = $235;
       i64toi32_i32$2 = $244$hi;
       i64toi32_i32$3 = $149;
       i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
       $22 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       $22$hi = i64toi32_i32$2;
       $4 = HEAP32[($1 + 20 | 0) >> 2] | 0;
       $5 = HEAP32[($1 + 16 | 0) >> 2] | 0;
       $17 = 2;
       $6 = HEAPU8[($1 + 2 | 0) >> 0] | 0;
       i64toi32_i32$2 = $27$hi;
       $12 = $27;
       break label$2;
      case 3:
       $17 = 3;
       $3 = HEAPU8[($1 + 1 | 0) >> 0] | 0;
       i64toi32_i32$0 = $1 + 3 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $27 = i64toi32_i32$2;
       $27$hi = i64toi32_i32$1;
       i64toi32_i32$2 = $2;
       HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] = $27;
       HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$0 = $1 + 8 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $267 = i64toi32_i32$1;
       i64toi32_i32$1 = $2;
       $122 = $267;
       HEAP8[(i64toi32_i32$1 + 29 | 0) >> 0] = $122;
       HEAP8[(i64toi32_i32$1 + 30 | 0) >> 0] = $122 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 31 | 0) >> 0] = $122 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 32 | 0) >> 0] = $122 >>> 24 | 0;
       HEAP8[(i64toi32_i32$1 + 33 | 0) >> 0] = i64toi32_i32$2;
       HEAP8[(i64toi32_i32$1 + 34 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 35 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 36 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
       i64toi32_i32$0 = $1 + 24 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
       i64toi32_i32$1 = 0;
       $270 = i64toi32_i32$2;
       $270$hi = i64toi32_i32$1;
       i64toi32_i32$0 = $1 + 28 | 0;
       i64toi32_i32$1 = HEAPU16[i64toi32_i32$0 >> 1] | 0;
       i64toi32_i32$2 = 0;
       $273 = i64toi32_i32$1;
       $273$hi = i64toi32_i32$2;
       i64toi32_i32$0 = $1 + 30 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$0 = i64toi32_i32$2;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $150 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $150 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       $277$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $273$hi;
       i64toi32_i32$1 = $273;
       i64toi32_i32$0 = $277$hi;
       i64toi32_i32$3 = $150;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $151 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
        $151 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       $279$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $270$hi;
       i64toi32_i32$0 = $270;
       i64toi32_i32$2 = $279$hi;
       i64toi32_i32$3 = $151;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
       $22 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
       $22$hi = i64toi32_i32$2;
       $4 = HEAP32[($1 + 20 | 0) >> 2] | 0;
       $5 = HEAP32[($1 + 16 | 0) >> 2] | 0;
       $6 = HEAPU8[($1 + 2 | 0) >> 0] | 0;
       i64toi32_i32$2 = $27$hi;
       $12 = $27;
       break label$2;
      case 4:
       break label$4;
      };
     }
     i64toi32_i32$1 = $1 + 29 | 0;
     i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $295 = i64toi32_i32$2;
     i64toi32_i32$2 = $2;
     $123 = $295;
     HEAP8[(i64toi32_i32$2 + 29 | 0) >> 0] = $123;
     HEAP8[(i64toi32_i32$2 + 30 | 0) >> 0] = $123 >>> 8 | 0;
     HEAP8[(i64toi32_i32$2 + 31 | 0) >> 0] = $123 >>> 16 | 0;
     HEAP8[(i64toi32_i32$2 + 32 | 0) >> 0] = $123 >>> 24 | 0;
     HEAP8[(i64toi32_i32$2 + 33 | 0) >> 0] = i64toi32_i32$0;
     HEAP8[(i64toi32_i32$2 + 34 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
     HEAP8[(i64toi32_i32$2 + 35 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
     HEAP8[(i64toi32_i32$2 + 36 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
     i64toi32_i32$1 = $1 + 24 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $299 = i64toi32_i32$0;
     i64toi32_i32$0 = $2;
     HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = $299;
     HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$1 = $1 + 49 | 0;
     i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
     i64toi32_i32$0 = 0;
     $302 = i64toi32_i32$2;
     $302$hi = i64toi32_i32$0;
     i64toi32_i32$1 = $1 + 51 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
     i64toi32_i32$2 = 0;
     i64toi32_i32$1 = i64toi32_i32$0;
     i64toi32_i32$0 = 0;
     i64toi32_i32$3 = 16;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
      $152 = 0;
     } else {
      i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
      $152 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
     }
     $306$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $302$hi;
     i64toi32_i32$2 = $302;
     i64toi32_i32$1 = $306$hi;
     i64toi32_i32$3 = $152;
     i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
     i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
     i64toi32_i32$2 = 0;
     i64toi32_i32$3 = 32;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
      $153 = 0;
     } else {
      i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
      $153 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
     }
     $27 = $153;
     $27$hi = i64toi32_i32$2;
     i64toi32_i32$1 = $1 + 45 | 0;
     i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = 0;
     $22 = i64toi32_i32$2;
     $22$hi = i64toi32_i32$0;
     i64toi32_i32$1 = $1 + 37 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $28 = i64toi32_i32$0;
     $28$hi = i64toi32_i32$2;
     $17 = 4;
     label$9 : {
      label$10 : {
       $8 = $1 + 4 | 0;
       if (HEAP32[$8 >> 2] | 0) {
        break label$10
       }
       $7 = 0;
       break label$9;
      }
      $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($2 + 8 | 0 | 0, $8 | 0);
      i64toi32_i32$1 = $2;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] | 0;
      $25 = i64toi32_i32$2;
      $25$hi = i64toi32_i32$0;
      $7 = HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] | 0;
     }
     i64toi32_i32$0 = $22$hi;
     i64toi32_i32$0 = $27$hi;
     i64toi32_i32$0 = $22$hi;
     i64toi32_i32$1 = $22;
     i64toi32_i32$2 = $27$hi;
     i64toi32_i32$3 = $27;
     i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
     $27 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
     $27$hi = i64toi32_i32$2;
     HEAP8[($2 + 62 | 0) >> 0] = HEAPU8[($2 + 36 | 0) >> 0] | 0;
     HEAP16[($2 + 60 | 0) >> 1] = HEAPU16[($2 + 34 | 0) >> 1] | 0;
     i64toi32_i32$2 = $28$hi;
     i64toi32_i32$0 = $28;
     i64toi32_i32$1 = 0;
     i64toi32_i32$3 = 16;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$1 = 0;
      $154 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
     } else {
      i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
      $154 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
     }
     $24 = $154;
     $24$hi = i64toi32_i32$1;
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
     $22 = i64toi32_i32$1;
     $22$hi = i64toi32_i32$0;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$1 = -16777216;
     i64toi32_i32$3 = 0;
     i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
     $29 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     $29$hi = i64toi32_i32$1;
     $4 = HEAP32[($1 + 20 | 0) >> 2] | 0;
     $5 = HEAP32[($1 + 16 | 0) >> 2] | 0;
     $15 = HEAPU8[($1 + 52 | 0) >> 0] | 0;
     $14 = HEAPU8[($2 + 32 | 0) >> 0] | 0;
     $9 = HEAPU8[($2 + 33 | 0) >> 0] | 0;
     i64toi32_i32$1 = $28$hi;
     $16 = $28;
    }
    break label$1;
   }
   $7 = HEAPU8[($2 + 25 | 0) >> 0] | 0 | ((HEAPU8[($2 + 26 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 27 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 28 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = $2;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 29 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 30 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 31 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 32 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 33 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 34 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 35 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 36 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $25 = i64toi32_i32$1;
   $25$hi = i64toi32_i32$2;
   i64toi32_i32$2 = 0;
   $29 = 0;
   $29$hi = i64toi32_i32$2;
  }
  HEAP8[(($2 + 4 | 0) + 2 | 0) >> 0] = HEAPU8[(($2 + 60 | 0) + 2 | 0) >> 0] | 0;
  HEAP16[($2 + 4 | 0) >> 1] = HEAPU16[($2 + 60 | 0) >> 1] | 0;
  i64toi32_i32$0 = $1;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 64 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 68 | 0) >> 2] | 0;
  $28 = i64toi32_i32$2;
  $28$hi = i64toi32_i32$1;
  $8 = 0;
  $18 = 0;
  label$11 : {
   if ((HEAP32[(i64toi32_i32$0 + 72 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$11
   }
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($2 + 24 | 0 | 4 | 0 | 0, $1 + 76 | 0 | 0);
   $18 = 1;
  }
  $19 = ($2 + 8 | 0) + 8 | 0;
  $20 = ($2 + 24 | 0) + 8 | 0;
  i64toi32_i32$0 = $20;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $391 = i64toi32_i32$1;
  i64toi32_i32$1 = $19;
  HEAP32[i64toi32_i32$1 >> 2] = $391;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  HEAP32[($2 + 24 | 0) >> 2] = $18;
  i64toi32_i32$0 = $2;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] | 0;
  $396 = i64toi32_i32$2;
  i64toi32_i32$2 = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $396;
  HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$1;
  label$12 : {
   if ((HEAPU8[($1 + 88 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$12
   }
   i64toi32_i32$0 = $1 + 113 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $404 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 48 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $404;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = $1 + 105 | 0;
   i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $409 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 40 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $409;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$0 = $1 + 97 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $413 = i64toi32_i32$1;
   i64toi32_i32$1 = $20;
   HEAP32[i64toi32_i32$1 >> 2] = $413;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = $1 + 89 | 0;
   i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $417 = i64toi32_i32$2;
   i64toi32_i32$2 = $2;
   HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] = $417;
   HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] = i64toi32_i32$1;
   $8 = 1;
  }
  HEAP8[($0 + 1 | 0) >> 0] = $3;
  HEAP8[$0 >> 0] = $17;
  i64toi32_i32$1 = $28$hi;
  i64toi32_i32$2 = $0;
  HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] = $28;
  HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] = i64toi32_i32$1;
  $425 = i64toi32_i32$2 + 51 | 0;
  i64toi32_i32$1 = $27$hi;
  i64toi32_i32$0 = $27;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 48;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $155 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   $155 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[$425 >> 0] = $155;
  $429 = $0 + 49 | 0;
  i64toi32_i32$2 = $27$hi;
  i64toi32_i32$1 = $27;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $156 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   $156 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
  }
  $157 = $429;
  $158 = $156;
  HEAP8[$157 >> 0] = $158;
  HEAP8[($157 + 1 | 0) >> 0] = $158 >>> 8 | 0;
  i64toi32_i32$0 = $27$hi;
  $124 = $0 + 45 | 0;
  HEAP8[$124 >> 0] = $27;
  HEAP8[($124 + 1 | 0) >> 0] = $27 >>> 8 | 0;
  HEAP8[($124 + 2 | 0) >> 0] = $27 >>> 16 | 0;
  HEAP8[($124 + 3 | 0) >> 0] = $27 >>> 24 | 0;
  HEAP8[($0 + 33 | 0) >> 0] = $9;
  HEAP8[($0 + 32 | 0) >> 0] = $14;
  i64toi32_i32$0 = $25$hi;
  i64toi32_i32$1 = $0 + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $25;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($0 + 4 | 0) >> 2] = $7;
  HEAP8[($0 + 3 | 0) >> 0] = $12;
  HEAP8[($0 + 2 | 0) >> 0] = $6;
  HEAP16[($0 + 34 | 0) >> 1] = HEAPU16[($2 + 4 | 0) >> 1] | 0;
  i64toi32_i32$0 = $23$hi;
  i64toi32_i32$1 = $0 + 56 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $23;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP8[($0 + 55 | 0) >> 0] = $10;
  HEAP8[($0 + 54 | 0) >> 0] = $11;
  HEAP8[($0 + 53 | 0) >> 0] = $13;
  HEAP8[($0 + 52 | 0) >> 0] = $15;
  i64toi32_i32$0 = $29$hi;
  i64toi32_i32$0 = $22$hi;
  i64toi32_i32$2 = $22;
  i64toi32_i32$1 = 16777215;
  i64toi32_i32$3 = -1;
  i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
  $476 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
  $476$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $29$hi;
  i64toi32_i32$0 = $29;
  i64toi32_i32$2 = $476$hi;
  i64toi32_i32$3 = $476;
  i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
  $477 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $0 + 24 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $477;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  HEAP8[($0 + 36 | 0) >> 0] = HEAPU8[(($2 + 4 | 0) + 2 | 0) >> 0] | 0;
  $485 = $0 + 16 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$1 = $4;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
   $160 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
   $160 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
  }
  $488$hi = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  $490$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $488$hi;
  i64toi32_i32$2 = $160;
  i64toi32_i32$1 = $490$hi;
  i64toi32_i32$3 = $5;
  i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
  $491 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $485;
  HEAP32[i64toi32_i32$2 >> 2] = $491;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
  $493 = $0 + 37 | 0;
  i64toi32_i32$1 = $24$hi;
  i64toi32_i32$0 = $24;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 16;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   $161 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $161 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
  }
  $495$hi = i64toi32_i32$2;
  i64toi32_i32$2 = 0;
  i64toi32_i32$1 = $16;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 65535;
  i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
  $498 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
  $498$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $495$hi;
  i64toi32_i32$2 = $161;
  i64toi32_i32$1 = $498$hi;
  i64toi32_i32$3 = $498;
  i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
  $499 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $493;
  $125 = $499;
  HEAP8[i64toi32_i32$2 >> 0] = $125;
  HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $125 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $125 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $125 >>> 24 | 0;
  HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  HEAP8[($0 + 88 | 0) >> 0] = $8;
  i64toi32_i32$0 = $19;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $505 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 80 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $505;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$0 = $2;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] | 0;
  $509 = i64toi32_i32$2;
  i64toi32_i32$2 = $0 + 72 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $509;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] | 0;
  $513 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 89 | 0;
  $126 = $513;
  HEAP8[i64toi32_i32$1 >> 0] = $126;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $126 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $126 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $126 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$2;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
  i64toi32_i32$0 = $20;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $517 = i64toi32_i32$2;
  i64toi32_i32$2 = $0 + 97 | 0;
  $127 = $517;
  HEAP8[i64toi32_i32$2 >> 0] = $127;
  HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $127 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $127 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $127 >>> 24 | 0;
  HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$0 = ($2 + 24 | 0) + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $523 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 105 | 0;
  $128 = $523;
  HEAP8[i64toi32_i32$1 >> 0] = $128;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $128 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $128 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $128 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$2;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
  i64toi32_i32$0 = ($2 + 24 | 0) + 24 | 0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $529 = i64toi32_i32$2;
  i64toi32_i32$2 = $0 + 113 | 0;
  $129 = $529;
  HEAP8[i64toi32_i32$2 >> 0] = $129;
  HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $129 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $129 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $129 >>> 24 | 0;
  HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  global$0 = $2 + 64 | 0;
 }
 
 function $cardano_serialization_lib__error__DeserializeError_20as_20core__fmt__Display___fmt__h10cc598fcad2b670($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $3$hi = 0, $33 = 0, $58 = 0, $223 = 0, $230 = 0, $298 = 0, $337 = 0, $367 = 0, $392 = 0;
  $2 = global$0 - 144 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if (HEAP32[($0 + 48 | 0) >> 2] | 0) {
       break label$4
      }
      HEAP32[($2 + 140 | 0) >> 2] = 0;
      HEAP32[($2 + 136 | 0) >> 2] = 1061336;
      i64toi32_i32$1 = $2;
      i64toi32_i32$0 = 0;
      HEAP32[($2 + 124 | 0) >> 2] = 1;
      HEAP32[($2 + 128 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[($2 + 120 | 0) >> 2] = 1061684;
      if (!(core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 120 | 0 | 0) | 0)) {
       break label$3
      }
      break label$2;
     }
     HEAP32[($2 + 116 | 0) >> 2] = $0 + 48 | 0;
     core__fmt__ArgumentV1__new__h3d5a6d2b66a66ab8($2 + 72 | 0 | 0, $2 + 116 | 0 | 0, 16 | 0);
     HEAP32[($2 + 140 | 0) >> 2] = 1;
     i64toi32_i32$1 = $2;
     i64toi32_i32$0 = 0;
     HEAP32[($2 + 124 | 0) >> 2] = 2;
     HEAP32[($2 + 128 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($2 + 120 | 0) >> 2] = 1061648;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[($2 + 72 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 76 | 0) >> 2] | 0;
     $33 = i64toi32_i32$0;
     i64toi32_i32$0 = $2;
     HEAP32[($2 + 88 | 0) >> 2] = $33;
     HEAP32[($2 + 92 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($2 + 136 | 0) >> 2] = $2 + 88 | 0;
     if (core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 120 | 0 | 0) | 0) {
      break label$2
     }
    }
    label$5 : {
     switch (HEAPU8[$0 >> 0] | 0 | 0) {
     default:
      HEAP32[($2 + 116 | 0) >> 2] = $0 + 1 | 0;
      core__fmt__ArgumentV1__new__h55f06327b351e3f1($2 | 0, $2 + 116 | 0 | 0, 90 | 0);
      HEAP32[($2 + 140 | 0) >> 2] = 1;
      HEAP32[($2 + 132 | 0) >> 2] = 1;
      HEAP32[($2 + 128 | 0) >> 2] = 1062440;
      HEAP32[($2 + 124 | 0) >> 2] = 1;
      HEAP32[($2 + 120 | 0) >> 2] = 1062432;
      i64toi32_i32$2 = $2;
      i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
      $58 = i64toi32_i32$1;
      i64toi32_i32$1 = $2;
      HEAP32[($2 + 88 | 0) >> 2] = $58;
      HEAP32[($2 + 92 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[($2 + 136 | 0) >> 2] = $2 + 88 | 0;
      $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 120 | 0 | 0) | 0;
      break label$1;
     case 1:
      HEAP32[($2 + 140 | 0) >> 2] = 0;
      HEAP32[($2 + 136 | 0) >> 2] = 1061336;
      i64toi32_i32$1 = $2;
      i64toi32_i32$0 = 0;
      HEAP32[($2 + 124 | 0) >> 2] = 1;
      HEAP32[($2 + 128 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[($2 + 120 | 0) >> 2] = 1062388;
      $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 120 | 0 | 0) | 0;
      break label$1;
     case 2:
      $0 = $cbor_event__error__Error_20as_20core__fmt__Display___fmt__h53a4f5e6c5d2b7ba($0 + 8 | 0 | 0, $1 | 0) | 0;
      break label$1;
     case 4:
      HEAP32[($2 + 116 | 0) >> 2] = $0 + 8 | 0;
      HEAP32[($2 + 140 | 0) >> 2] = 1;
      i64toi32_i32$1 = $2;
      i64toi32_i32$0 = 0;
      HEAP32[($2 + 124 | 0) >> 2] = 1;
      HEAP32[($2 + 128 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[($2 + 120 | 0) >> 2] = 1062256;
      HEAP32[($2 + 92 | 0) >> 2] = 91;
      HEAP32[($2 + 136 | 0) >> 2] = $2 + 88 | 0;
      HEAP32[($2 + 88 | 0) >> 2] = $2 + 116 | 0;
      $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 120 | 0 | 0) | 0;
      break label$1;
     case 5:
      HEAP32[($2 + 140 | 0) >> 2] = 0;
      HEAP32[($2 + 136 | 0) >> 2] = 1061336;
      i64toi32_i32$1 = $2;
      i64toi32_i32$0 = 0;
      HEAP32[($2 + 124 | 0) >> 2] = 1;
      HEAP32[($2 + 128 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[($2 + 120 | 0) >> 2] = 1062232;
      $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 120 | 0 | 0) | 0;
      break label$1;
     case 6:
      HEAP32[($2 + 140 | 0) >> 2] = 0;
      HEAP32[($2 + 136 | 0) >> 2] = 1061336;
      i64toi32_i32$1 = $2;
      i64toi32_i32$0 = 0;
      HEAP32[($2 + 124 | 0) >> 2] = 1;
      HEAP32[($2 + 128 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[($2 + 120 | 0) >> 2] = 1062196;
      $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 120 | 0 | 0) | 0;
      break label$1;
     case 7:
      HEAP32[($2 + 140 | 0) >> 2] = 0;
      HEAP32[($2 + 136 | 0) >> 2] = 1061336;
      i64toi32_i32$1 = $2;
      i64toi32_i32$0 = 0;
      HEAP32[($2 + 124 | 0) >> 2] = 1;
      HEAP32[($2 + 128 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[($2 + 120 | 0) >> 2] = 1062156;
      $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 120 | 0 | 0) | 0;
      break label$1;
     case 8:
      HEAP32[($2 + 112 | 0) >> 2] = $0 + 8 | 0;
      HEAP32[($2 + 116 | 0) >> 2] = $0 + 24 | 0;
      HEAP32[($2 + 140 | 0) >> 2] = 2;
      HEAP32[($2 + 100 | 0) >> 2] = 91;
      i64toi32_i32$1 = $2;
      i64toi32_i32$0 = 0;
      HEAP32[($2 + 124 | 0) >> 2] = 2;
      HEAP32[($2 + 128 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[($2 + 120 | 0) >> 2] = 1062108;
      HEAP32[($2 + 92 | 0) >> 2] = 91;
      HEAP32[($2 + 136 | 0) >> 2] = $2 + 88 | 0;
      HEAP32[($2 + 96 | 0) >> 2] = $2 + 112 | 0;
      HEAP32[($2 + 88 | 0) >> 2] = $2 + 116 | 0;
      $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 120 | 0 | 0) | 0;
      break label$1;
     case 9:
      HEAP32[($2 + 116 | 0) >> 2] = $0 + 8 | 0;
      HEAP32[($2 + 140 | 0) >> 2] = 1;
      i64toi32_i32$1 = $2;
      i64toi32_i32$0 = 0;
      HEAP32[($2 + 124 | 0) >> 2] = 2;
      HEAP32[($2 + 128 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[($2 + 120 | 0) >> 2] = 1062064;
      HEAP32[($2 + 92 | 0) >> 2] = 91;
      HEAP32[($2 + 136 | 0) >> 2] = $2 + 88 | 0;
      HEAP32[($2 + 88 | 0) >> 2] = $2 + 116 | 0;
      $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 120 | 0 | 0) | 0;
      break label$1;
     case 10:
      HEAP32[($2 + 116 | 0) >> 2] = $0 + 4 | 0;
      HEAP32[($2 + 140 | 0) >> 2] = 1;
      i64toi32_i32$1 = $2;
      i64toi32_i32$0 = 0;
      HEAP32[($2 + 124 | 0) >> 2] = 1;
      HEAP32[($2 + 128 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[($2 + 120 | 0) >> 2] = 1062028;
      HEAP32[($2 + 92 | 0) >> 2] = 92;
      HEAP32[($2 + 136 | 0) >> 2] = $2 + 88 | 0;
      HEAP32[($2 + 88 | 0) >> 2] = $2 + 116 | 0;
      $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 120 | 0 | 0) | 0;
      break label$1;
     case 11:
      HEAP32[($2 + 140 | 0) >> 2] = 0;
      HEAP32[($2 + 136 | 0) >> 2] = 1061336;
      i64toi32_i32$1 = $2;
      i64toi32_i32$0 = 0;
      HEAP32[($2 + 124 | 0) >> 2] = 1;
      HEAP32[($2 + 128 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[($2 + 120 | 0) >> 2] = 1062004;
      $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 120 | 0 | 0) | 0;
      break label$1;
     case 12:
      HEAP32[($2 + 84 | 0) >> 2] = $0 + 4 | 0;
      HEAP32[($2 + 112 | 0) >> 2] = $0 + 8 | 0;
      HEAP32[($2 + 116 | 0) >> 2] = $0 + 12 | 0;
      core__fmt__ArgumentV1__new__ha12055661e6add2a($2 + 40 | 0 | 0, $2 + 116 | 0 | 0, 88 | 0);
      i64toi32_i32$2 = $2;
      i64toi32_i32$0 = HEAP32[($2 + 40 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($2 + 44 | 0) >> 2] | 0;
      $3 = i64toi32_i32$0;
      $3$hi = i64toi32_i32$1;
      core__fmt__ArgumentV1__new__ha12055661e6add2a($2 + 32 | 0 | 0, $2 + 84 | 0 | 0, 88 | 0);
      i64toi32_i32$2 = $2;
      i64toi32_i32$1 = HEAP32[($2 + 32 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($2 + 36 | 0) >> 2] | 0;
      core__fmt__ArgumentV1__new__ha12055661e6add2a($2 + 24 | 0 | 0, $2 + 112 | 0 | 0, 88 | 0);
      HEAP32[($2 + 108 | 0) >> 2] = 3;
      $223 = i64toi32_i32$1;
      i64toi32_i32$1 = $2;
      HEAP32[($2 + 128 | 0) >> 2] = $223;
      HEAP32[($2 + 132 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$0 = $3$hi;
      i64toi32_i32$1 = $2;
      HEAP32[($2 + 120 | 0) >> 2] = $3;
      HEAP32[($2 + 124 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$1 = $2;
      i64toi32_i32$0 = 0;
      HEAP32[($2 + 92 | 0) >> 2] = 3;
      HEAP32[($2 + 96 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[($2 + 88 | 0) >> 2] = 1061960;
      i64toi32_i32$2 = $2;
      i64toi32_i32$0 = HEAP32[($2 + 24 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($2 + 28 | 0) >> 2] | 0;
      $230 = i64toi32_i32$0;
      i64toi32_i32$0 = $2;
      HEAP32[($2 + 136 | 0) >> 2] = $230;
      HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($2 + 104 | 0) >> 2] = $2 + 120 | 0;
      $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 88 | 0 | 0) | 0;
      break label$1;
     case 13:
      HEAP32[($2 + 116 | 0) >> 2] = $0 + 1 | 0;
      HEAP32[($2 + 140 | 0) >> 2] = 1;
      i64toi32_i32$0 = $2;
      i64toi32_i32$1 = 0;
      HEAP32[($2 + 124 | 0) >> 2] = 1;
      HEAP32[($2 + 128 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($2 + 120 | 0) >> 2] = 1061912;
      HEAP32[($2 + 92 | 0) >> 2] = 93;
      HEAP32[($2 + 136 | 0) >> 2] = $2 + 88 | 0;
      HEAP32[($2 + 88 | 0) >> 2] = $2 + 116 | 0;
      $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 120 | 0 | 0) | 0;
      break label$1;
     case 14:
      HEAP32[($2 + 116 | 0) >> 2] = $0 + 4 | 0;
      HEAP32[($2 + 140 | 0) >> 2] = 1;
      i64toi32_i32$0 = $2;
      i64toi32_i32$1 = 0;
      HEAP32[($2 + 124 | 0) >> 2] = 1;
      HEAP32[($2 + 128 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($2 + 120 | 0) >> 2] = 1061880;
      HEAP32[($2 + 92 | 0) >> 2] = 94;
      HEAP32[($2 + 136 | 0) >> 2] = $2 + 88 | 0;
      HEAP32[($2 + 88 | 0) >> 2] = $2 + 116 | 0;
      $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 120 | 0 | 0) | 0;
      break label$1;
     case 15:
      HEAP32[($2 + 112 | 0) >> 2] = $0 + 8 | 0;
      HEAP32[($2 + 116 | 0) >> 2] = $0 + 16 | 0;
      core__fmt__ArgumentV1__new__h67b517e324fc8963($2 + 56 | 0 | 0, $2 + 116 | 0 | 0, 87 | 0);
      i64toi32_i32$2 = $2;
      i64toi32_i32$1 = HEAP32[($2 + 56 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($2 + 60 | 0) >> 2] | 0;
      $3 = i64toi32_i32$1;
      $3$hi = i64toi32_i32$0;
      core__fmt__ArgumentV1__new__h67b517e324fc8963($2 + 48 | 0 | 0, $2 + 112 | 0 | 0, 87 | 0);
      HEAP32[($2 + 140 | 0) >> 2] = 2;
      i64toi32_i32$1 = $2;
      HEAP32[($2 + 88 | 0) >> 2] = $3;
      HEAP32[($2 + 92 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$1 = $2;
      i64toi32_i32$0 = 0;
      HEAP32[($2 + 124 | 0) >> 2] = 2;
      HEAP32[($2 + 128 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[($2 + 120 | 0) >> 2] = 1061844;
      i64toi32_i32$2 = $2;
      i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($2 + 52 | 0) >> 2] | 0;
      $298 = i64toi32_i32$0;
      i64toi32_i32$0 = $2;
      HEAP32[($2 + 96 | 0) >> 2] = $298;
      HEAP32[($2 + 100 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($2 + 136 | 0) >> 2] = $2 + 88 | 0;
      $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 120 | 0 | 0) | 0;
      break label$1;
     case 16:
      HEAP32[($2 + 116 | 0) >> 2] = $0 + 8 | 0;
      HEAP32[($2 + 140 | 0) >> 2] = 1;
      i64toi32_i32$0 = $2;
      i64toi32_i32$1 = 0;
      HEAP32[($2 + 124 | 0) >> 2] = 1;
      HEAP32[($2 + 128 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($2 + 120 | 0) >> 2] = 1061812;
      HEAP32[($2 + 92 | 0) >> 2] = 91;
      HEAP32[($2 + 136 | 0) >> 2] = $2 + 88 | 0;
      HEAP32[($2 + 88 | 0) >> 2] = $2 + 116 | 0;
      $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 120 | 0 | 0) | 0;
      break label$1;
     case 17:
      HEAP32[($2 + 116 | 0) >> 2] = $0 + 1 | 0;
      core__fmt__ArgumentV1__new__h25164bba1e78c05a($2 + 64 | 0 | 0, $2 + 116 | 0 | 0, 95 | 0);
      HEAP32[($2 + 140 | 0) >> 2] = 1;
      i64toi32_i32$0 = $2;
      i64toi32_i32$1 = 0;
      HEAP32[($2 + 124 | 0) >> 2] = 1;
      HEAP32[($2 + 128 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($2 + 120 | 0) >> 2] = 1061780;
      i64toi32_i32$2 = $2;
      i64toi32_i32$1 = HEAP32[($2 + 64 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($2 + 68 | 0) >> 2] | 0;
      $337 = i64toi32_i32$1;
      i64toi32_i32$1 = $2;
      HEAP32[($2 + 88 | 0) >> 2] = $337;
      HEAP32[($2 + 92 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[($2 + 136 | 0) >> 2] = $2 + 88 | 0;
      $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 120 | 0 | 0) | 0;
      break label$1;
     case 18:
      HEAP32[($2 + 140 | 0) >> 2] = 0;
      HEAP32[($2 + 136 | 0) >> 2] = 1061336;
      i64toi32_i32$1 = $2;
      i64toi32_i32$0 = 0;
      HEAP32[($2 + 124 | 0) >> 2] = 1;
      HEAP32[($2 + 128 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[($2 + 120 | 0) >> 2] = 1061736;
      $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 120 | 0 | 0) | 0;
      break label$1;
     case 3:
      break label$5;
     };
    }
    HEAP32[($2 + 112 | 0) >> 2] = $0 + 8 | 0;
    core__fmt__ArgumentV1__new__h67b517e324fc8963($2 + 16 | 0 | 0, $2 + 112 | 0 | 0, 87 | 0);
    HEAP32[($2 + 140 | 0) >> 2] = 1;
    i64toi32_i32$1 = $2;
    i64toi32_i32$0 = 0;
    HEAP32[($2 + 124 | 0) >> 2] = 1;
    HEAP32[($2 + 128 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($2 + 120 | 0) >> 2] = 1062296;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
    $367 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[($2 + 88 | 0) >> 2] = $367;
    HEAP32[($2 + 92 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($2 + 136 | 0) >> 2] = $2 + 88 | 0;
    if (core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 120 | 0 | 0) | 0) {
     break label$2
    }
    label$24 : {
     i64toi32_i32$2 = $0 + 16 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$1 = 0;
     if ((i64toi32_i32$2 | 0) != (1 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | 0) {
      break label$24
     }
     HEAP32[($2 + 116 | 0) >> 2] = $0 + 24 | 0;
     core__fmt__ArgumentV1__new__h67b517e324fc8963($2 + 8 | 0 | 0, $2 + 116 | 0 | 0, 87 | 0);
     HEAP32[($2 + 140 | 0) >> 2] = 1;
     i64toi32_i32$0 = $2;
     i64toi32_i32$2 = 0;
     HEAP32[($2 + 124 | 0) >> 2] = 1;
     HEAP32[($2 + 128 | 0) >> 2] = i64toi32_i32$2;
     HEAP32[($2 + 120 | 0) >> 2] = 1062316;
     i64toi32_i32$2 = HEAP32[($2 + 8 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
     $392 = i64toi32_i32$2;
     i64toi32_i32$2 = $2;
     HEAP32[($2 + 88 | 0) >> 2] = $392;
     HEAP32[($2 + 92 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($2 + 136 | 0) >> 2] = $2 + 88 | 0;
     if (core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 120 | 0 | 0) | 0) {
      break label$2
     }
    }
    $0 = 0;
    break label$1;
   }
   $T_20as_20core__convert__From_T____from__h05b3d0c185eed756();
   $0 = 1;
  }
  global$0 = $2 + 144 | 0;
  return $0 | 0;
 }
 
 function core__option__Option__T___cloned__h621eb297880b0347($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $2 = 0, $27 = 0, $27$hi = 0, $28 = 0, $28$hi = 0, $22$hi = 0, $22 = 0, $24 = 0, $24$hi = 0, $8 = 0, $29$hi = 0, $25 = 0, $25$hi = 0, $29 = 0, $20 = 0, $4 = 0, $17 = 0, $18 = 0, $19 = 0, $122 = 0, $23 = 0, $23$hi = 0, $6 = 0, $7 = 0, $123 = 0, $124 = 0, $125 = 0, $126 = 0, $127 = 0, $128 = 0, $129 = 0, $130 = 0, $131 = 0, $132 = 0, $3 = 0, $5 = 0, $30 = 0, $30$hi = 0, $9 = 0, $12 = 0, $14 = 0, $15 = 0, $16 = 0, $21 = 0, $26 = 0, $133 = 0, $134 = 0, $135 = 0, $136 = 0, $137 = 0, $138 = 0, $10 = 0, $139 = 0, $11 = 0, $140 = 0, $141 = 0, $13 = 0, $142 = 0, $143 = 0, $144 = 0, $145 = 0, $146 = 0, $147 = 0, $148 = 0, $149 = 0, $150 = 0, $151 = 0, $152 = 0, $153 = 0, $154 = 0, $155 = 0, $156 = 0, $158 = 0, $159 = 0, $160 = 0, $161 = 0, $162 = 0, $164 = 0, $165 = 0, $21$hi = 0, $48 = 0, $26$hi = 0, $76 = 0, $102 = 0, $102$hi = 0, $103 = 0, $103$hi = 0, $105$hi = 0, $107$hi = 0, $109 = 0, $109$hi = 0, $110 = 0, $110$hi = 0, $112$hi = 0, $114$hi = 0, $157 = 0, $163 = 0, $163$hi = 0, $166 = 0, $166$hi = 0, $170$hi = 0, $172$hi = 0, $179$hi = 0, $181 = 0, $181$hi = 0, $184 = 0, $184$hi = 0, $188$hi = 0, $227 = 0, $229 = 0, $229$hi = 0, $232 = 0, $232$hi = 0, $236$hi = 0, $238$hi = 0, $258 = 0, $260 = 0, $260$hi = 0, $263 = 0, $263$hi = 0, $267$hi = 0, $269$hi = 0, $281 = 0, $285 = 0, $288 = 0, $288$hi = 0, $292$hi = 0, $377 = 0, $382 = 0, $390 = 0, $395 = 0, $399 = 0, $403 = 0, $406 = 0, $418 = 0, $424 = 0, $432 = 0, $440 = 0, $446 = 0, $454 = 0, $454$hi = 0, $455 = 0, $456 = 0, $459$hi = 0, $461$hi = 0, $462 = 0, $476 = 0, $480 = 0, $500 = 0, $502$hi = 0, $505 = 0, $505$hi = 0, $506 = 0, $517 = 0, $521 = 0, $525 = 0, $528 = 0;
  $2 = global$0 - 96 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if ($1) {
     break label$2
    }
    HEAP32[($0 + 72 | 0) >> 2] = 2;
    break label$1;
   }
   label$3 : {
    label$4 : {
     label$5 : {
      label$6 : {
       switch (HEAPU8[$1 >> 0] | 0 | 0) {
       default:
        $3 = HEAPU8[($1 + 1 | 0) >> 0] | 0;
        i64toi32_i32$2 = $1 + 3 | 0;
        i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $21 = i64toi32_i32$0;
        $21$hi = i64toi32_i32$1;
        i64toi32_i32$0 = $2;
        HEAP32[(i64toi32_i32$0 + 64 | 0) >> 2] = $21;
        HEAP32[(i64toi32_i32$0 + 68 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$2 = $1 + 8 | 0;
        i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $48 = i64toi32_i32$1;
        i64toi32_i32$1 = $2;
        $122 = $48;
        HEAP8[(i64toi32_i32$1 + 69 | 0) >> 0] = $122;
        HEAP8[(i64toi32_i32$1 + 70 | 0) >> 0] = $122 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 71 | 0) >> 0] = $122 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 72 | 0) >> 0] = $122 >>> 24 | 0;
        HEAP8[(i64toi32_i32$1 + 73 | 0) >> 0] = i64toi32_i32$0;
        HEAP8[(i64toi32_i32$1 + 74 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 75 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 76 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
        $4 = HEAP32[($1 + 20 | 0) >> 2] | 0;
        $5 = HEAPU8[($1 + 2 | 0) >> 0] | 0;
        i64toi32_i32$2 = $1 + 28 | 0;
        i64toi32_i32$0 = HEAPU16[i64toi32_i32$2 >> 1] | 0;
        i64toi32_i32$1 = 0;
        $22 = i64toi32_i32$0;
        $22$hi = i64toi32_i32$1;
        i64toi32_i32$2 = $1 + 30 | 0;
        i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
        i64toi32_i32$0 = 0;
        $23 = i64toi32_i32$1;
        $23$hi = i64toi32_i32$0;
        $6 = HEAP32[($1 + 16 | 0) >> 2] | 0;
        i64toi32_i32$2 = $1;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
        i64toi32_i32$1 = 0;
        $24 = i64toi32_i32$0;
        $24$hi = i64toi32_i32$1;
        $7 = HEAPU8[($2 + 65 | 0) >> 0] | 0 | ((HEAPU8[($2 + 66 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 67 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 68 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 69 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 70 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 71 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 72 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 73 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 74 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 75 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 76 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $25 = i64toi32_i32$1;
        $25$hi = i64toi32_i32$0;
        i64toi32_i32$2 = $1;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
        $26 = i64toi32_i32$0;
        $26$hi = i64toi32_i32$1;
        i64toi32_i32$0 = $2;
        HEAP32[(i64toi32_i32$0 + 64 | 0) >> 2] = $26;
        HEAP32[(i64toi32_i32$0 + 68 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$2 = i64toi32_i32$2 + 37 | 0;
        i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $76 = i64toi32_i32$1;
        i64toi32_i32$1 = $2;
        $123 = $76;
        HEAP8[(i64toi32_i32$1 + 69 | 0) >> 0] = $123;
        HEAP8[(i64toi32_i32$1 + 70 | 0) >> 0] = $123 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 71 | 0) >> 0] = $123 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 72 | 0) >> 0] = $123 >>> 24 | 0;
        HEAP8[(i64toi32_i32$1 + 73 | 0) >> 0] = i64toi32_i32$0;
        HEAP8[(i64toi32_i32$1 + 74 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 75 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 76 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
        i64toi32_i32$2 = $1 + 45 | 0;
        i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $27 = i64toi32_i32$0;
        $27$hi = i64toi32_i32$1;
        $8 = HEAPU8[($1 + 31 | 0) >> 0] | 0;
        i64toi32_i32$2 = $1 + 53 | 0;
        i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$0 = 0;
        $28 = i64toi32_i32$1;
        $28$hi = i64toi32_i32$0;
        i64toi32_i32$2 = $1 + 57 | 0;
        i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
        i64toi32_i32$1 = 0;
        $29 = i64toi32_i32$0;
        $29$hi = i64toi32_i32$1;
        i64toi32_i32$2 = $1 + 59 | 0;
        i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
        i64toi32_i32$0 = 0;
        $30 = i64toi32_i32$1;
        $30$hi = i64toi32_i32$0;
        $9 = HEAPU8[($2 + 65 | 0) >> 0] | 0;
        HEAP8[(($2 + 48 | 0) + 2 | 0) >> 0] = HEAPU8[($2 + 68 | 0) >> 0] | 0;
        HEAP16[($2 + 48 | 0) >> 1] = HEAPU16[($2 + 66 | 0) >> 1] | 0;
        i64toi32_i32$0 = $24$hi;
        $102 = $24;
        $102$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $22$hi;
        $103 = $22;
        $103$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $23$hi;
        i64toi32_i32$2 = $23;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 16;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
         $133 = 0;
        } else {
         i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
         $133 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        }
        $105$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $103$hi;
        i64toi32_i32$0 = $103;
        i64toi32_i32$2 = $105$hi;
        i64toi32_i32$3 = $133;
        i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
        i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 32;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
         $134 = 0;
        } else {
         i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
         $134 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        }
        $107$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $102$hi;
        i64toi32_i32$2 = $102;
        i64toi32_i32$1 = $107$hi;
        i64toi32_i32$3 = $134;
        i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
        $22 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
        $22$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $28$hi;
        $109 = $28;
        $109$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $29$hi;
        $110 = $29;
        $110$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $30$hi;
        i64toi32_i32$0 = $30;
        i64toi32_i32$2 = 0;
        i64toi32_i32$3 = 16;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
         $135 = 0;
        } else {
         i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
         $135 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        }
        $112$hi = i64toi32_i32$2;
        i64toi32_i32$2 = $110$hi;
        i64toi32_i32$1 = $110;
        i64toi32_i32$0 = $112$hi;
        i64toi32_i32$3 = $135;
        i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
        i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 32;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
         $136 = 0;
        } else {
         i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
         $136 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        }
        $114$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $109$hi;
        i64toi32_i32$0 = $109;
        i64toi32_i32$2 = $114$hi;
        i64toi32_i32$3 = $136;
        i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
        $24 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
        $24$hi = i64toi32_i32$2;
        i64toi32_i32$1 = $24;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 24;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$0 = 0;
         $137 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
        } else {
         i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
         $137 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
        }
        $23 = $137;
        $23$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $24$hi;
        i64toi32_i32$2 = $24;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 16;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$1 = 0;
         $138 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
        } else {
         i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
         $138 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
        }
        $10 = $138;
        i64toi32_i32$1 = $24$hi;
        i64toi32_i32$0 = $24;
        i64toi32_i32$2 = 0;
        i64toi32_i32$3 = 8;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$2 = 0;
         $139 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
        } else {
         i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
         $139 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
        }
        $11 = $139;
        i64toi32_i32$1 = $2;
        i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 69 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 70 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 71 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 72 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 73 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 74 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 75 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 76 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $30 = i64toi32_i32$2;
        $30$hi = i64toi32_i32$0;
        i64toi32_i32$1 = i64toi32_i32$2;
        i64toi32_i32$2 = 0;
        i64toi32_i32$3 = 16;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$2 = 0;
         $140 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
        } else {
         i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
         $140 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
        }
        $24 = $140;
        $24$hi = i64toi32_i32$2;
        i64toi32_i32$2 = 0;
        i64toi32_i32$0 = ($8 | 0) == (1 | 0);
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 56;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
         $141 = 0;
        } else {
         i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
         $141 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        }
        $29 = $141;
        $29$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $21$hi;
        $12 = $21;
        i64toi32_i32$1 = $28$hi;
        $13 = $28;
        i64toi32_i32$1 = $27$hi;
        i64toi32_i32$2 = $27;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 56;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$0 = 0;
         $142 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
        } else {
         i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
         $142 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
        }
        $14 = $142;
        i64toi32_i32$0 = $26$hi;
        $15 = $26;
        i64toi32_i32$0 = $30$hi;
        $16 = $30;
        $17 = 0;
        break label$3;
       case 1:
        $15 = HEAPU8[($1 + 32 | 0) >> 0] | 0;
        i64toi32_i32$1 = $1 + 34 | 0;
        i64toi32_i32$0 = HEAPU16[i64toi32_i32$1 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
        i64toi32_i32$2 = HEAPU16[(i64toi32_i32$1 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
        $27 = i64toi32_i32$0;
        $27$hi = i64toi32_i32$2;
        i64toi32_i32$0 = $2;
        HEAP32[(i64toi32_i32$0 + 64 | 0) >> 2] = $27;
        HEAP32[(i64toi32_i32$0 + 68 | 0) >> 2] = i64toi32_i32$2;
        HEAP8[(i64toi32_i32$0 + 50 | 0) >> 0] = HEAPU8[(i64toi32_i32$0 + 66 | 0) >> 0] | 0;
        i64toi32_i32$1 = $1 + 39 | 0;
        i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $157 = i64toi32_i32$2;
        i64toi32_i32$2 = $2;
        $124 = $157;
        HEAP8[(i64toi32_i32$2 + 69 | 0) >> 0] = $124;
        HEAP8[(i64toi32_i32$2 + 70 | 0) >> 0] = $124 >>> 8 | 0;
        HEAP8[(i64toi32_i32$2 + 71 | 0) >> 0] = $124 >>> 16 | 0;
        HEAP8[(i64toi32_i32$2 + 72 | 0) >> 0] = $124 >>> 24 | 0;
        HEAP8[(i64toi32_i32$2 + 73 | 0) >> 0] = i64toi32_i32$0;
        HEAP8[(i64toi32_i32$2 + 74 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
        HEAP8[(i64toi32_i32$2 + 75 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
        HEAP8[(i64toi32_i32$2 + 76 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
        i64toi32_i32$0 = $27$hi;
        HEAP16[(i64toi32_i32$2 + 48 | 0) >> 1] = $27;
        i64toi32_i32$1 = $1 + 55 | 0;
        i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$2 = 0;
        $25 = i64toi32_i32$0;
        $25$hi = i64toi32_i32$2;
        $163 = i64toi32_i32$0;
        $163$hi = i64toi32_i32$2;
        i64toi32_i32$1 = $1 + 59 | 0;
        i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
        i64toi32_i32$0 = 0;
        $166 = i64toi32_i32$2;
        $166$hi = i64toi32_i32$0;
        i64toi32_i32$1 = $1 + 61 | 0;
        i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
        i64toi32_i32$2 = 0;
        i64toi32_i32$1 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 16;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
         $143 = 0;
        } else {
         i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
         $143 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        }
        $170$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $166$hi;
        i64toi32_i32$2 = $166;
        i64toi32_i32$1 = $170$hi;
        i64toi32_i32$3 = $143;
        i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
        i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
        i64toi32_i32$2 = 0;
        i64toi32_i32$3 = 32;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
         $144 = 0;
        } else {
         i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
         $144 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        }
        $172$hi = i64toi32_i32$2;
        i64toi32_i32$2 = $163$hi;
        i64toi32_i32$1 = $163;
        i64toi32_i32$0 = $172$hi;
        i64toi32_i32$3 = $144;
        i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
        i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 8;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$1 = 0;
         $145 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
        } else {
         i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
         $145 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
        }
        $23 = $145;
        $23$hi = i64toi32_i32$1;
        i64toi32_i32$0 = $1 + 47 | 0;
        i64toi32_i32$1 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $28 = i64toi32_i32$1;
        $28$hi = i64toi32_i32$2;
        i64toi32_i32$0 = i64toi32_i32$1;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 16;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
         $146 = 0;
        } else {
         i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
         $146 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        }
        $179$hi = i64toi32_i32$1;
        i64toi32_i32$2 = $2;
        i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 75 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 76 | 0) >> 0] | 0) << 8 | 0) | 0;
        i64toi32_i32$0 = 0;
        $181 = i64toi32_i32$1;
        $181$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $179$hi;
        i64toi32_i32$2 = $146;
        i64toi32_i32$1 = $181$hi;
        i64toi32_i32$3 = $181;
        i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
        $27 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
        $27$hi = i64toi32_i32$1;
        i64toi32_i32$0 = $2;
        i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 69 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 70 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 71 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 72 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$2 = 0;
        $184 = i64toi32_i32$1;
        $184$hi = i64toi32_i32$2;
        i64toi32_i32$0 = i64toi32_i32$0 + 73 | 0;
        i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
        i64toi32_i32$1 = 0;
        i64toi32_i32$0 = i64toi32_i32$2;
        i64toi32_i32$2 = 0;
        i64toi32_i32$3 = 32;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
         $147 = 0;
        } else {
         i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
         $147 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        }
        $188$hi = i64toi32_i32$2;
        i64toi32_i32$2 = $184$hi;
        i64toi32_i32$1 = $184;
        i64toi32_i32$0 = $188$hi;
        i64toi32_i32$3 = $147;
        i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
        $24 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
        $24$hi = i64toi32_i32$0;
        $9 = HEAPU8[($1 + 33 | 0) >> 0] | 0;
        $16 = HEAPU8[($2 + 67 | 0) >> 0] | 0 | ((HEAPU8[($2 + 68 | 0) >> 0] | 0) << 8 | 0) | 0;
        i64toi32_i32$2 = $1;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
        $22 = i64toi32_i32$0;
        $22$hi = i64toi32_i32$1;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = -16777216;
        i64toi32_i32$3 = 0;
        i64toi32_i32$0 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
        $29 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
        $29$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $25$hi;
        $10 = $25;
        i64toi32_i32$0 = $28$hi;
        i64toi32_i32$1 = $28;
        i64toi32_i32$2 = 0;
        i64toi32_i32$3 = 48;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$2 = 0;
         $148 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
        } else {
         i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
         $148 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
        }
        $13 = $148;
        i64toi32_i32$2 = $28$hi;
        i64toi32_i32$0 = $28;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 56;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$1 = 0;
         $149 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
        } else {
         i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
         $149 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
        }
        $11 = $149;
        i64toi32_i32$1 = $28$hi;
        i64toi32_i32$2 = $28;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 40;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$0 = 0;
         $150 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
        } else {
         i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
         $150 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
        }
        $14 = $150;
        $4 = HEAP32[($1 + 20 | 0) >> 2] | 0;
        $6 = HEAP32[($1 + 16 | 0) >> 2] | 0;
        i64toi32_i32$1 = $1;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] | 0;
        $25 = i64toi32_i32$0;
        $25$hi = i64toi32_i32$2;
        $17 = 1;
        break label$5;
       case 2:
        $3 = HEAPU8[($1 + 1 | 0) >> 0] | 0;
        i64toi32_i32$1 = $1 + 3 | 0;
        i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $27 = i64toi32_i32$2;
        $27$hi = i64toi32_i32$0;
        i64toi32_i32$2 = $2;
        HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] = $27;
        HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$1 = $1 + 8 | 0;
        i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $227 = i64toi32_i32$0;
        i64toi32_i32$0 = $2;
        $125 = $227;
        HEAP8[(i64toi32_i32$0 + 69 | 0) >> 0] = $125;
        HEAP8[(i64toi32_i32$0 + 70 | 0) >> 0] = $125 >>> 8 | 0;
        HEAP8[(i64toi32_i32$0 + 71 | 0) >> 0] = $125 >>> 16 | 0;
        HEAP8[(i64toi32_i32$0 + 72 | 0) >> 0] = $125 >>> 24 | 0;
        HEAP8[(i64toi32_i32$0 + 73 | 0) >> 0] = i64toi32_i32$2;
        HEAP8[(i64toi32_i32$0 + 74 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
        HEAP8[(i64toi32_i32$0 + 75 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
        HEAP8[(i64toi32_i32$0 + 76 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
        i64toi32_i32$1 = $1;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] | 0;
        i64toi32_i32$0 = 0;
        $229 = i64toi32_i32$2;
        $229$hi = i64toi32_i32$0;
        i64toi32_i32$1 = i64toi32_i32$1 + 28 | 0;
        i64toi32_i32$0 = HEAPU16[i64toi32_i32$1 >> 1] | 0;
        i64toi32_i32$2 = 0;
        $232 = i64toi32_i32$0;
        $232$hi = i64toi32_i32$2;
        i64toi32_i32$1 = $1 + 30 | 0;
        i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$1 = i64toi32_i32$2;
        i64toi32_i32$2 = 0;
        i64toi32_i32$3 = 16;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
         $151 = 0;
        } else {
         i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
         $151 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        }
        $236$hi = i64toi32_i32$2;
        i64toi32_i32$2 = $232$hi;
        i64toi32_i32$0 = $232;
        i64toi32_i32$1 = $236$hi;
        i64toi32_i32$3 = $151;
        i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
        i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 32;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
         $152 = 0;
        } else {
         i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
         $152 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        }
        $238$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $229$hi;
        i64toi32_i32$1 = $229;
        i64toi32_i32$2 = $238$hi;
        i64toi32_i32$3 = $152;
        i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
        $22 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
        $22$hi = i64toi32_i32$2;
        $4 = HEAP32[($1 + 20 | 0) >> 2] | 0;
        $17 = 2;
        $5 = HEAPU8[($1 + 2 | 0) >> 0] | 0;
        i64toi32_i32$2 = $27$hi;
        $12 = $27;
        break label$4;
       case 3:
        $17 = 3;
        $3 = HEAPU8[($1 + 1 | 0) >> 0] | 0;
        i64toi32_i32$0 = $1 + 3 | 0;
        i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $27 = i64toi32_i32$2;
        $27$hi = i64toi32_i32$1;
        i64toi32_i32$2 = $2;
        HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] = $27;
        HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$0 = $1 + 8 | 0;
        i64toi32_i32$1 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $258 = i64toi32_i32$1;
        i64toi32_i32$1 = $2;
        $126 = $258;
        HEAP8[(i64toi32_i32$1 + 69 | 0) >> 0] = $126;
        HEAP8[(i64toi32_i32$1 + 70 | 0) >> 0] = $126 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 71 | 0) >> 0] = $126 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 72 | 0) >> 0] = $126 >>> 24 | 0;
        HEAP8[(i64toi32_i32$1 + 73 | 0) >> 0] = i64toi32_i32$2;
        HEAP8[(i64toi32_i32$1 + 74 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 75 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 76 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
        i64toi32_i32$0 = $1;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] | 0;
        i64toi32_i32$1 = 0;
        $260 = i64toi32_i32$2;
        $260$hi = i64toi32_i32$1;
        i64toi32_i32$0 = i64toi32_i32$0 + 28 | 0;
        i64toi32_i32$1 = HEAPU16[i64toi32_i32$0 >> 1] | 0;
        i64toi32_i32$2 = 0;
        $263 = i64toi32_i32$1;
        $263$hi = i64toi32_i32$2;
        i64toi32_i32$0 = $1 + 30 | 0;
        i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0;
        i64toi32_i32$1 = 0;
        i64toi32_i32$0 = i64toi32_i32$2;
        i64toi32_i32$2 = 0;
        i64toi32_i32$3 = 16;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
         $153 = 0;
        } else {
         i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
         $153 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        }
        $267$hi = i64toi32_i32$2;
        i64toi32_i32$2 = $263$hi;
        i64toi32_i32$1 = $263;
        i64toi32_i32$0 = $267$hi;
        i64toi32_i32$3 = $153;
        i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
        i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 32;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
         $154 = 0;
        } else {
         i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
         $154 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        }
        $269$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $260$hi;
        i64toi32_i32$0 = $260;
        i64toi32_i32$2 = $269$hi;
        i64toi32_i32$3 = $154;
        i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
        $22 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
        $22$hi = i64toi32_i32$2;
        $4 = HEAP32[($1 + 20 | 0) >> 2] | 0;
        $5 = HEAPU8[($1 + 2 | 0) >> 0] | 0;
        i64toi32_i32$2 = $27$hi;
        $12 = $27;
        break label$4;
       case 4:
        break label$6;
       };
      }
      i64toi32_i32$1 = $1;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] | 0;
      $281 = i64toi32_i32$2;
      i64toi32_i32$2 = $2;
      HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] = $281;
      HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$1 = i64toi32_i32$1 + 29 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $285 = i64toi32_i32$0;
      i64toi32_i32$0 = $2;
      $127 = $285;
      HEAP8[(i64toi32_i32$0 + 69 | 0) >> 0] = $127;
      HEAP8[(i64toi32_i32$0 + 70 | 0) >> 0] = $127 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 71 | 0) >> 0] = $127 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 72 | 0) >> 0] = $127 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 73 | 0) >> 0] = i64toi32_i32$2;
      HEAP8[(i64toi32_i32$0 + 74 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 75 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 76 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
      i64toi32_i32$1 = $1 + 49 | 0;
      i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
      i64toi32_i32$0 = 0;
      $288 = i64toi32_i32$2;
      $288$hi = i64toi32_i32$0;
      i64toi32_i32$1 = $1 + 51 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
      i64toi32_i32$2 = 0;
      i64toi32_i32$1 = i64toi32_i32$0;
      i64toi32_i32$0 = 0;
      i64toi32_i32$3 = 16;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       $155 = 0;
      } else {
       i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
       $155 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
      }
      $292$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $288$hi;
      i64toi32_i32$2 = $288;
      i64toi32_i32$1 = $292$hi;
      i64toi32_i32$3 = $155;
      i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
      i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
      i64toi32_i32$2 = 0;
      i64toi32_i32$3 = 32;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       $156 = 0;
      } else {
       i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
       $156 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
      }
      $27 = $156;
      $27$hi = i64toi32_i32$2;
      i64toi32_i32$1 = $1 + 45 | 0;
      i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = 0;
      $22 = i64toi32_i32$2;
      $22$hi = i64toi32_i32$0;
      i64toi32_i32$1 = $1 + 37 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $28 = i64toi32_i32$0;
      $28$hi = i64toi32_i32$2;
      $17 = 4;
      label$11 : {
       label$12 : {
        $8 = $1 + 4 | 0;
        if (HEAP32[$8 >> 2] | 0) {
         break label$12
        }
        $7 = 0;
        break label$11;
       }
       $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($2 + 8 | 0 | 0, $8 | 0);
       i64toi32_i32$1 = $2;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] | 0;
       $25 = i64toi32_i32$2;
       $25$hi = i64toi32_i32$0;
       $7 = HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] | 0;
      }
      i64toi32_i32$0 = $22$hi;
      i64toi32_i32$0 = $27$hi;
      i64toi32_i32$0 = $22$hi;
      i64toi32_i32$1 = $22;
      i64toi32_i32$2 = $27$hi;
      i64toi32_i32$3 = $27;
      i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
      $27 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
      $27$hi = i64toi32_i32$2;
      HEAP8[($2 + 50 | 0) >> 0] = HEAPU8[($2 + 76 | 0) >> 0] | 0;
      HEAP16[($2 + 48 | 0) >> 1] = HEAPU16[($2 + 74 | 0) >> 1] | 0;
      i64toi32_i32$2 = $28$hi;
      i64toi32_i32$0 = $28;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 16;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$1 = 0;
       $158 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
      } else {
       i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
       $158 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
      }
      $24 = $158;
      $24$hi = i64toi32_i32$1;
      i64toi32_i32$2 = $2;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
      $22 = i64toi32_i32$1;
      $22$hi = i64toi32_i32$0;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$1 = -16777216;
      i64toi32_i32$3 = 0;
      i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
      $29 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
      $29$hi = i64toi32_i32$1;
      $4 = HEAP32[($1 + 20 | 0) >> 2] | 0;
      $6 = HEAP32[($1 + 16 | 0) >> 2] | 0;
      $14 = HEAPU8[($1 + 52 | 0) >> 0] | 0;
      $15 = HEAPU8[($2 + 72 | 0) >> 0] | 0;
      $9 = HEAPU8[($2 + 73 | 0) >> 0] | 0;
      i64toi32_i32$1 = $28$hi;
      $16 = $28;
     }
     break label$3;
    }
    $6 = HEAP32[($1 + 16 | 0) >> 2] | 0;
    $7 = HEAPU8[($2 + 65 | 0) >> 0] | 0 | ((HEAPU8[($2 + 66 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 67 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 68 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = $2;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 69 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 70 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 71 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 72 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 73 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 74 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 75 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 76 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $25 = i64toi32_i32$1;
    $25$hi = i64toi32_i32$2;
    i64toi32_i32$2 = 0;
    $29 = 0;
    $29$hi = i64toi32_i32$2;
   }
   HEAP8[(($2 + 44 | 0) + 2 | 0) >> 0] = HEAPU8[(($2 + 48 | 0) + 2 | 0) >> 0] | 0;
   HEAP16[($2 + 44 | 0) >> 1] = HEAPU16[($2 + 48 | 0) >> 1] | 0;
   i64toi32_i32$0 = $1;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 64 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 68 | 0) >> 2] | 0;
   $28 = i64toi32_i32$2;
   $28$hi = i64toi32_i32$1;
   $8 = 0;
   $18 = 0;
   label$13 : {
    if ((HEAP32[(i64toi32_i32$0 + 72 | 0) >> 2] | 0 | 0) != (1 | 0)) {
     break label$13
    }
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($2 + 64 | 0 | 4 | 0 | 0, $1 + 76 | 0 | 0);
    $18 = 1;
   }
   $19 = ($2 + 48 | 0) + 8 | 0;
   $20 = ($2 + 64 | 0) + 8 | 0;
   i64toi32_i32$0 = $20;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $377 = i64toi32_i32$1;
   i64toi32_i32$1 = $19;
   HEAP32[i64toi32_i32$1 >> 2] = $377;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
   HEAP32[($2 + 64 | 0) >> 2] = $18;
   i64toi32_i32$0 = $2;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 64 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 68 | 0) >> 2] | 0;
   $382 = i64toi32_i32$2;
   i64toi32_i32$2 = i64toi32_i32$0;
   HEAP32[(i64toi32_i32$0 + 48 | 0) >> 2] = $382;
   HEAP32[(i64toi32_i32$0 + 52 | 0) >> 2] = i64toi32_i32$1;
   label$14 : {
    if ((HEAPU8[($1 + 88 | 0) >> 0] | 0 | 0) != (1 | 0)) {
     break label$14
    }
    i64toi32_i32$0 = $1 + 113 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $390 = i64toi32_i32$1;
    i64toi32_i32$1 = $2 + 88 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $390;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$0 = $1 + 105 | 0;
    i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $395 = i64toi32_i32$2;
    i64toi32_i32$2 = $2 + 80 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $395;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$0 = $1 + 97 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $399 = i64toi32_i32$1;
    i64toi32_i32$1 = $20;
    HEAP32[i64toi32_i32$1 >> 2] = $399;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$0 = $1 + 89 | 0;
    i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $403 = i64toi32_i32$2;
    i64toi32_i32$2 = $2;
    HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] = $403;
    HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] = i64toi32_i32$1;
    $8 = 1;
   }
   i64toi32_i32$0 = $2;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 48 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 52 | 0) >> 2] | 0;
   $406 = i64toi32_i32$1;
   i64toi32_i32$1 = $0;
   HEAP32[(i64toi32_i32$1 + 72 | 0) >> 2] = $406;
   HEAP32[(i64toi32_i32$1 + 76 | 0) >> 2] = i64toi32_i32$2;
   $1 = (i64toi32_i32$0 + 40 | 0) + 2 | 0;
   HEAP8[$1 >> 0] = HEAPU8[((i64toi32_i32$0 + 44 | 0) + 2 | 0) >> 0] | 0;
   i64toi32_i32$0 = $19;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $418 = i64toi32_i32$2;
   i64toi32_i32$2 = $0 + 80 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $418;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   $18 = ($2 + 8 | 0) + 8 | 0;
   i64toi32_i32$0 = $20;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $424 = i64toi32_i32$1;
   i64toi32_i32$1 = $18;
   HEAP32[i64toi32_i32$1 >> 2] = $424;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
   $20 = ($2 + 8 | 0) + 16 | 0;
   i64toi32_i32$0 = ($2 + 64 | 0) + 16 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $432 = i64toi32_i32$2;
   i64toi32_i32$2 = $20;
   HEAP32[i64toi32_i32$2 >> 2] = $432;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   $19 = ($2 + 8 | 0) + 24 | 0;
   i64toi32_i32$0 = ($2 + 64 | 0) + 24 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $440 = i64toi32_i32$1;
   i64toi32_i32$1 = $19;
   HEAP32[i64toi32_i32$1 >> 2] = $440;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
   HEAP16[($2 + 40 | 0) >> 1] = HEAPU16[($2 + 44 | 0) >> 1] | 0;
   i64toi32_i32$0 = $2;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 64 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 68 | 0) >> 2] | 0;
   $446 = i64toi32_i32$2;
   i64toi32_i32$2 = i64toi32_i32$0;
   HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $446;
   HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
   HEAP8[($0 + 33 | 0) >> 0] = $9;
   HEAP8[($0 + 32 | 0) >> 0] = $15;
   i64toi32_i32$1 = $29$hi;
   i64toi32_i32$1 = $22$hi;
   i64toi32_i32$0 = $22;
   i64toi32_i32$2 = 16777215;
   i64toi32_i32$3 = -1;
   i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
   $454 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
   $454$hi = i64toi32_i32$2;
   i64toi32_i32$2 = $29$hi;
   i64toi32_i32$1 = $29;
   i64toi32_i32$0 = $454$hi;
   i64toi32_i32$3 = $454;
   i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
   $455 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
   i64toi32_i32$1 = $0;
   HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = $455;
   HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = i64toi32_i32$0;
   $456 = i64toi32_i32$1;
   i64toi32_i32$0 = 0;
   i64toi32_i32$2 = $4;
   i64toi32_i32$1 = 0;
   i64toi32_i32$3 = 32;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
    $159 = 0;
   } else {
    i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
    $159 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   }
   $459$hi = i64toi32_i32$1;
   i64toi32_i32$1 = 0;
   $461$hi = i64toi32_i32$1;
   i64toi32_i32$1 = $459$hi;
   i64toi32_i32$0 = $159;
   i64toi32_i32$2 = $461$hi;
   i64toi32_i32$3 = $6;
   i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
   $462 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
   i64toi32_i32$0 = $456;
   HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $462;
   HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$2 = $25$hi;
   i64toi32_i32$0 = $0;
   HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $25;
   HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $7;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $12;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $5;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $3;
   HEAP8[i64toi32_i32$0 >> 0] = $17;
   $476 = i64toi32_i32$0 + 51 | 0;
   i64toi32_i32$2 = $27$hi;
   i64toi32_i32$1 = $27;
   i64toi32_i32$0 = 0;
   i64toi32_i32$3 = 48;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$0 = 0;
    $160 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   } else {
    i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
    $160 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
   }
   HEAP8[$476 >> 0] = $160;
   $480 = $0 + 49 | 0;
   i64toi32_i32$0 = $27$hi;
   i64toi32_i32$2 = $27;
   i64toi32_i32$1 = 0;
   i64toi32_i32$3 = 32;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$1 = 0;
    $161 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   } else {
    i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
    $161 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
   }
   $162 = $480;
   $164 = $161;
   HEAP8[$162 >> 0] = $164;
   HEAP8[($162 + 1 | 0) >> 0] = $164 >>> 8 | 0;
   i64toi32_i32$1 = $27$hi;
   HEAP8[($0 + 45 | 0) >> 0] = $27;
   HEAP8[($0 + 46 | 0) >> 0] = $27 >>> 8 | 0;
   HEAP8[($0 + 47 | 0) >> 0] = $27 >>> 16 | 0;
   HEAP8[($0 + 48 | 0) >> 0] = $27 >>> 24 | 0;
   HEAP8[($0 + 88 | 0) >> 0] = $8;
   i64toi32_i32$1 = $28$hi;
   i64toi32_i32$2 = $0;
   HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] = $28;
   HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $23$hi;
   HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] = $23;
   HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$2 + 55 | 0) >> 0] = $10;
   HEAP8[(i64toi32_i32$2 + 54 | 0) >> 0] = $11;
   HEAP8[(i64toi32_i32$2 + 53 | 0) >> 0] = $13;
   HEAP8[(i64toi32_i32$2 + 52 | 0) >> 0] = $14;
   $500 = i64toi32_i32$2;
   i64toi32_i32$1 = $24$hi;
   i64toi32_i32$0 = $24;
   i64toi32_i32$2 = 0;
   i64toi32_i32$3 = 16;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
    $165 = 0;
   } else {
    i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
    $165 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   }
   $502$hi = i64toi32_i32$2;
   i64toi32_i32$2 = 0;
   i64toi32_i32$1 = $16;
   i64toi32_i32$0 = 0;
   i64toi32_i32$3 = 65535;
   i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
   $505 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
   $505$hi = i64toi32_i32$0;
   i64toi32_i32$0 = $502$hi;
   i64toi32_i32$2 = $165;
   i64toi32_i32$1 = $505$hi;
   i64toi32_i32$3 = $505;
   i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
   $506 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
   i64toi32_i32$2 = $500;
   $128 = $506;
   HEAP8[(i64toi32_i32$2 + 37 | 0) >> 0] = $128;
   HEAP8[(i64toi32_i32$2 + 38 | 0) >> 0] = $128 >>> 8 | 0;
   HEAP8[(i64toi32_i32$2 + 39 | 0) >> 0] = $128 >>> 16 | 0;
   HEAP8[(i64toi32_i32$2 + 40 | 0) >> 0] = $128 >>> 24 | 0;
   HEAP8[(i64toi32_i32$2 + 41 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$2 + 42 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$2 + 43 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$2 + 44 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   HEAP16[($0 + 34 | 0) >> 1] = HEAPU16[($2 + 40 | 0) >> 1] | 0;
   HEAP8[($0 + 36 | 0) >> 0] = HEAPU8[$1 >> 0] | 0;
   i64toi32_i32$0 = $19;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $517 = i64toi32_i32$1;
   i64toi32_i32$1 = $0 + 113 | 0;
   $129 = $517;
   HEAP8[i64toi32_i32$1 >> 0] = $129;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $129 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $129 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $129 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$2;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
   i64toi32_i32$0 = $20;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $521 = i64toi32_i32$2;
   i64toi32_i32$2 = $0 + 105 | 0;
   $130 = $521;
   HEAP8[i64toi32_i32$2 >> 0] = $130;
   HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $130 >>> 8 | 0;
   HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $130 >>> 16 | 0;
   HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $130 >>> 24 | 0;
   HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$0 = $18;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $525 = i64toi32_i32$1;
   i64toi32_i32$1 = $0 + 97 | 0;
   $131 = $525;
   HEAP8[i64toi32_i32$1 >> 0] = $131;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $131 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $131 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $131 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$2;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
   i64toi32_i32$0 = $2;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] | 0;
   $528 = i64toi32_i32$2;
   i64toi32_i32$2 = $0;
   $132 = $528;
   HEAP8[(i64toi32_i32$2 + 89 | 0) >> 0] = $132;
   HEAP8[(i64toi32_i32$2 + 90 | 0) >> 0] = $132 >>> 8 | 0;
   HEAP8[(i64toi32_i32$2 + 91 | 0) >> 0] = $132 >>> 16 | 0;
   HEAP8[(i64toi32_i32$2 + 92 | 0) >> 0] = $132 >>> 24 | 0;
   HEAP8[(i64toi32_i32$2 + 93 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$2 + 94 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$2 + 95 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$2 + 96 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  }
  global$0 = $2 + 96 | 0;
 }
 
 function $cardano_serialization_lib__crypto__BootstrapWitness_20as_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup___deserialize_as_embedded_group__h518be7fb64963f77($0, $1, $2, $2$hi, $3, $3$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $8 = 0, $5 = 0, $7 = 0, $6 = 0, $10 = 0, $16 = 0, $11 = 0, $9 = 0, $12 = 0, $64 = 0, $65 = 0, $66 = 0, $67 = 0, $69 = 0, $70 = 0, $71 = 0, $13 = 0, $72 = 0, $14 = 0, $74 = 0, $75 = 0, $77 = 0, $78 = 0, $79 = 0, $80 = 0, $81 = 0, $82 = 0, $16$hi = 0, $15 = 0, $40 = 0, $47 = 0, $63 = 0, $68 = 0, $73 = 0, $76 = 0, $152 = 0, $161 = 0, $191 = 0, $200 = 0, $205 = 0, $210 = 0, $216 = 0, $219 = 0, $234 = 0, $237 = 0, $252 = 0, $260 = 0, $268 = 0, $280 = 0, $294 = 0, $300 = 0, $306 = 0, $309 = 0, $322 = 0, $325 = 0, $328 = 0, $331 = 0, $415 = 0, $423 = 0, $431 = 0, $445 = 0, $462 = 0, $468 = 0, $474 = 0, $477 = 0, $490 = 0, $493 = 0, $496 = 0, $499 = 0;
  $4 = global$0 - 560 | 0;
  global$0 = $4;
  $cardano_serialization_lib__crypto__Vkey_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h00a02b49be066c8c($4 + 360 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ((HEAPU8[($4 + 360 | 0) >> 0] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      i64toi32_i32$2 = ($4 + 360 | 0) + 9 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $16 = i64toi32_i32$0;
      $16$hi = i64toi32_i32$1;
      i64toi32_i32$0 = ($4 + 176 | 0) + 9 | 0;
      HEAP8[i64toi32_i32$0 >> 0] = $16;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $16 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $16 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $16 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      $5 = ($4 + 104 | 0) + 24 | 0;
      i64toi32_i32$2 = $4 + 385 | 0;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $40 = i64toi32_i32$1;
      i64toi32_i32$1 = $5;
      HEAP32[i64toi32_i32$1 >> 2] = $40;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      $6 = ($4 + 104 | 0) + 16 | 0;
      i64toi32_i32$2 = $4 + 377 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $47 = i64toi32_i32$0;
      i64toi32_i32$0 = $6;
      HEAP32[i64toi32_i32$0 >> 2] = $47;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      $7 = ($4 + 104 | 0) + 8 | 0;
      i64toi32_i32$1 = $16$hi;
      i64toi32_i32$0 = $7;
      HEAP32[i64toi32_i32$0 >> 2] = $16;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $4;
      i64toi32_i32$1 = HEAPU8[($4 + 361 | 0) >> 0] | 0 | ((HEAPU8[($4 + 362 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 363 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 364 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[($4 + 365 | 0) >> 0] | 0 | ((HEAPU8[($4 + 366 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 367 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 368 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $16 = i64toi32_i32$1;
      $16$hi = i64toi32_i32$0;
      i64toi32_i32$1 = $4;
      HEAP8[($4 + 177 | 0) >> 0] = $16;
      HEAP8[($4 + 178 | 0) >> 0] = $16 >>> 8 | 0;
      HEAP8[($4 + 179 | 0) >> 0] = $16 >>> 16 | 0;
      HEAP8[($4 + 180 | 0) >> 0] = $16 >>> 24 | 0;
      HEAP8[($4 + 181 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[($4 + 182 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[($4 + 183 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[($4 + 184 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      i64toi32_i32$1 = $4;
      HEAP32[($4 + 104 | 0) >> 2] = $16;
      HEAP32[($4 + 108 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $5;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $63 = i64toi32_i32$0;
      i64toi32_i32$0 = ($4 + 8 | 0) + 24 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $63;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $6;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $68 = i64toi32_i32$1;
      i64toi32_i32$1 = ($4 + 8 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $68;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $7;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $73 = i64toi32_i32$0;
      i64toi32_i32$0 = ($4 + 8 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $73;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $4;
      i64toi32_i32$1 = HEAP32[($4 + 104 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($4 + 108 | 0) >> 2] | 0;
      $76 = i64toi32_i32$1;
      i64toi32_i32$1 = $4;
      HEAP32[($4 + 8 | 0) >> 2] = $76;
      HEAP32[($4 + 12 | 0) >> 2] = i64toi32_i32$0;
      $cardano_serialization_lib__crypto__Ed25519Signature_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h6385501ae0da5a4b($4 + 360 | 0 | 0, $1 | 0);
      if ((HEAPU8[($4 + 360 | 0) >> 0] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      memcpy($4 + 480 | 0 | 0, $4 + 360 | 0 | 1 | 0 | 0, 64 | 0) | 0;
      memcpy($4 + 248 | 0 | 0, $4 + 480 | 0 | 0, 64 | 0) | 0;
      memcpy($4 + 104 | 0 | 0, memcpy($4 + 176 | 0 | 1 | 0 | 0, $4 + 248 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
      memcpy($4 + 40 | 0 | 0, $4 + 104 | 0 | 0, 64 | 0) | 0;
      cbor_event__de__Deserializer_R___bytes__hc697ccccfa39fd82($4 + 480 | 0 | 0, $1 | 0);
      if ((HEAP32[($4 + 480 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$2
      }
      HEAP32[($4 + 552 | 0) >> 2] = HEAPU8[($4 + 489 | 0) >> 0] | 0 | ((HEAPU8[($4 + 490 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 491 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 492 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $8 = ($4 + 480 | 0) + 12 | 0;
      $64 = HEAPU8[$8 >> 0] | 0 | ((HEAPU8[($8 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($8 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($8 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[($4 + 555 | 0) >> 0] = $64;
      HEAP8[($4 + 556 | 0) >> 0] = $64 >>> 8 | 0;
      HEAP8[($4 + 557 | 0) >> 0] = $64 >>> 16 | 0;
      HEAP8[($4 + 558 | 0) >> 0] = $64 >>> 24 | 0;
      $5 = ($4 + 360 | 0) + 12 | 0;
      $65 = HEAPU8[($4 + 555 | 0) >> 0] | 0 | ((HEAPU8[($4 + 556 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 557 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 558 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[$5 >> 0] = $65;
      HEAP8[($5 + 1 | 0) >> 0] = $65 >>> 8 | 0;
      HEAP8[($5 + 2 | 0) >> 0] = $65 >>> 16 | 0;
      HEAP8[($5 + 3 | 0) >> 0] = $65 >>> 24 | 0;
      $6 = ($4 + 360 | 0) + 8 | 0;
      $9 = ($4 + 480 | 0) + 8 | 0;
      HEAP8[$6 >> 0] = HEAPU8[$9 >> 0] | 0;
      $66 = HEAP32[($4 + 552 | 0) >> 2] | 0;
      HEAP8[($4 + 369 | 0) >> 0] = $66;
      HEAP8[($4 + 370 | 0) >> 0] = $66 >>> 8 | 0;
      HEAP8[($4 + 371 | 0) >> 0] = $66 >>> 16 | 0;
      HEAP8[($4 + 372 | 0) >> 0] = $66 >>> 24 | 0;
      HEAP32[($4 + 364 | 0) >> 2] = HEAP32[($4 + 484 | 0) >> 2] | 0;
      $7 = ($4 + 176 | 0) + 8 | 0;
      HEAP32[$7 >> 2] = HEAP32[$5 >> 2] | 0;
      i64toi32_i32$2 = $4;
      i64toi32_i32$0 = HEAP32[($4 + 364 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($4 + 368 | 0) >> 2] | 0;
      $152 = i64toi32_i32$0;
      i64toi32_i32$0 = $4;
      HEAP32[($4 + 176 | 0) >> 2] = $152;
      HEAP32[($4 + 180 | 0) >> 2] = i64toi32_i32$1;
      $10 = ($4 + 320 | 0) + 8 | 0;
      HEAP32[$10 >> 2] = HEAP32[$7 >> 2] | 0;
      i64toi32_i32$2 = $4;
      i64toi32_i32$1 = HEAP32[($4 + 176 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($4 + 180 | 0) >> 2] | 0;
      $161 = i64toi32_i32$1;
      i64toi32_i32$1 = $4;
      HEAP32[($4 + 320 | 0) >> 2] = $161;
      HEAP32[($4 + 324 | 0) >> 2] = i64toi32_i32$0;
      cbor_event__de__Deserializer_R___bytes__hc697ccccfa39fd82($4 + 480 | 0 | 0, $1 | 0);
      label$5 : {
       if ((HEAP32[($4 + 480 | 0) >> 2] | 0 | 0) == (1 | 0)) {
        break label$5
       }
       HEAP32[($4 + 552 | 0) >> 2] = HEAPU8[($4 + 489 | 0) >> 0] | 0 | ((HEAPU8[($4 + 490 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 491 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 492 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $67 = HEAPU8[$8 >> 0] | 0 | ((HEAPU8[($8 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($8 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($8 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       HEAP8[($4 + 555 | 0) >> 0] = $67;
       HEAP8[($4 + 556 | 0) >> 0] = $67 >>> 8 | 0;
       HEAP8[($4 + 557 | 0) >> 0] = $67 >>> 16 | 0;
       HEAP8[($4 + 558 | 0) >> 0] = $67 >>> 24 | 0;
       $69 = HEAPU8[($4 + 555 | 0) >> 0] | 0 | ((HEAPU8[($4 + 556 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 557 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 558 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       HEAP8[$5 >> 0] = $69;
       HEAP8[($5 + 1 | 0) >> 0] = $69 >>> 8 | 0;
       HEAP8[($5 + 2 | 0) >> 0] = $69 >>> 16 | 0;
       HEAP8[($5 + 3 | 0) >> 0] = $69 >>> 24 | 0;
       HEAP8[$6 >> 0] = HEAPU8[$9 >> 0] | 0;
       $70 = HEAP32[($4 + 552 | 0) >> 2] | 0;
       HEAP8[($4 + 369 | 0) >> 0] = $70;
       HEAP8[($4 + 370 | 0) >> 0] = $70 >>> 8 | 0;
       HEAP8[($4 + 371 | 0) >> 0] = $70 >>> 16 | 0;
       HEAP8[($4 + 372 | 0) >> 0] = $70 >>> 24 | 0;
       HEAP32[($4 + 364 | 0) >> 2] = HEAP32[($4 + 484 | 0) >> 2] | 0;
       HEAP32[$7 >> 2] = HEAP32[$5 >> 2] | 0;
       i64toi32_i32$2 = $4;
       i64toi32_i32$0 = HEAP32[($4 + 364 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($4 + 368 | 0) >> 2] | 0;
       $191 = i64toi32_i32$0;
       i64toi32_i32$0 = $4;
       HEAP32[($4 + 176 | 0) >> 2] = $191;
       HEAP32[($4 + 180 | 0) >> 2] = i64toi32_i32$1;
       $1 = ($4 + 336 | 0) + 8 | 0;
       HEAP32[$1 >> 2] = HEAP32[$7 >> 2] | 0;
       i64toi32_i32$2 = $4;
       i64toi32_i32$1 = HEAP32[($4 + 176 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[($4 + 180 | 0) >> 2] | 0;
       $200 = i64toi32_i32$1;
       i64toi32_i32$1 = $4;
       HEAP32[($4 + 336 | 0) >> 2] = $200;
       HEAP32[($4 + 340 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = $4 + 32 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $205 = i64toi32_i32$0;
       i64toi32_i32$0 = $4 + 408 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $205;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $4 + 24 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $210 = i64toi32_i32$1;
       i64toi32_i32$1 = $4 + 400 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $210;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = ($4 + 8 | 0) + 8 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $216 = i64toi32_i32$0;
       i64toi32_i32$0 = $4 + 392 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $216;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $4;
       i64toi32_i32$1 = HEAP32[($4 + 8 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[($4 + 12 | 0) >> 2] | 0;
       $219 = i64toi32_i32$1;
       i64toi32_i32$1 = $4;
       HEAP32[($4 + 384 | 0) >> 2] = $219;
       HEAP32[($4 + 388 | 0) >> 2] = i64toi32_i32$0;
       memcpy($4 + 416 | 0 | 0, $4 + 40 | 0 | 0, 64 | 0) | 0;
       HEAP32[$6 >> 2] = HEAP32[$10 >> 2] | 0;
       HEAP32[($4 + 380 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
       i64toi32_i32$2 = $4;
       i64toi32_i32$0 = HEAP32[($4 + 320 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($4 + 324 | 0) >> 2] | 0;
       $234 = i64toi32_i32$0;
       i64toi32_i32$0 = $4;
       HEAP32[($4 + 360 | 0) >> 2] = $234;
       HEAP32[($4 + 364 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $4;
       i64toi32_i32$1 = HEAP32[($4 + 336 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[($4 + 340 | 0) >> 2] | 0;
       $237 = i64toi32_i32$1;
       i64toi32_i32$1 = $4;
       HEAP32[($4 + 372 | 0) >> 2] = $237;
       HEAP32[($4 + 376 | 0) >> 2] = i64toi32_i32$0;
       memcpy($0 + 4 | 0 | 0, $4 + 360 | 0 | 0, 120 | 0) | 0;
       HEAP32[$0 >> 2] = 0;
       break label$1;
      }
      $1 = ($4 + 248 | 0) + 8 | 0;
      $5 = ($4 + 480 | 0) + 24 | 0;
      i64toi32_i32$2 = $5;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $252 = i64toi32_i32$0;
      i64toi32_i32$0 = $1;
      HEAP32[i64toi32_i32$0 >> 2] = $252;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      $7 = ($4 + 248 | 0) + 16 | 0;
      $10 = $4 + 512 | 0;
      i64toi32_i32$2 = $10;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $260 = i64toi32_i32$1;
      i64toi32_i32$1 = $7;
      HEAP32[i64toi32_i32$1 >> 2] = $260;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      $11 = ($4 + 248 | 0) + 24 | 0;
      $12 = $4 + 520 | 0;
      i64toi32_i32$2 = $12;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $268 = i64toi32_i32$0;
      i64toi32_i32$0 = $11;
      HEAP32[i64toi32_i32$0 >> 2] = $268;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($4 + 552 | 0) >> 2] = HEAPU8[($4 + 489 | 0) >> 0] | 0 | ((HEAPU8[($4 + 490 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 491 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 492 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $71 = HEAPU8[$8 >> 0] | 0 | ((HEAPU8[($8 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($8 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($8 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[($4 + 555 | 0) >> 0] = $71;
      HEAP8[($4 + 556 | 0) >> 0] = $71 >>> 8 | 0;
      HEAP8[($4 + 557 | 0) >> 0] = $71 >>> 16 | 0;
      HEAP8[($4 + 558 | 0) >> 0] = $71 >>> 24 | 0;
      $13 = ($4 + 480 | 0) + 16 | 0;
      i64toi32_i32$2 = $13;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $280 = i64toi32_i32$1;
      i64toi32_i32$1 = $4;
      HEAP32[($4 + 248 | 0) >> 2] = $280;
      HEAP32[($4 + 252 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[($4 + 352 | 0) >> 2] = HEAP32[($4 + 552 | 0) >> 2] | 0;
      $72 = HEAPU8[($4 + 555 | 0) >> 0] | 0 | ((HEAPU8[($4 + 556 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 557 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 558 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[($4 + 355 | 0) >> 0] = $72;
      HEAP8[($4 + 356 | 0) >> 0] = $72 >>> 8 | 0;
      HEAP8[($4 + 357 | 0) >> 0] = $72 >>> 16 | 0;
      HEAP8[($4 + 358 | 0) >> 0] = $72 >>> 24 | 0;
      $14 = HEAPU8[$9 >> 0] | 0;
      $15 = ($4 + 104 | 0) + 24 | 0;
      i64toi32_i32$2 = $11;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $294 = i64toi32_i32$0;
      i64toi32_i32$0 = $15;
      HEAP32[i64toi32_i32$0 >> 2] = $294;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      $11 = ($4 + 104 | 0) + 16 | 0;
      i64toi32_i32$2 = $7;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $300 = i64toi32_i32$1;
      i64toi32_i32$1 = $11;
      HEAP32[i64toi32_i32$1 >> 2] = $300;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      $7 = ($4 + 104 | 0) + 8 | 0;
      i64toi32_i32$2 = $1;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $306 = i64toi32_i32$0;
      i64toi32_i32$0 = $7;
      HEAP32[i64toi32_i32$0 >> 2] = $306;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $4;
      i64toi32_i32$1 = HEAP32[($4 + 248 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($4 + 252 | 0) >> 2] | 0;
      $309 = i64toi32_i32$1;
      i64toi32_i32$1 = $4;
      HEAP32[($4 + 104 | 0) >> 2] = $309;
      HEAP32[($4 + 108 | 0) >> 2] = i64toi32_i32$0;
      HEAP8[$9 >> 0] = $14;
      HEAP8[($4 + 480 | 0) >> 0] = 2;
      $74 = $4 + 489 | 0;
      $75 = HEAP32[($4 + 352 | 0) >> 2] | 0;
      HEAP8[$74 >> 0] = $75;
      HEAP8[($74 + 1 | 0) >> 0] = $75 >>> 8 | 0;
      HEAP8[($74 + 2 | 0) >> 0] = $75 >>> 16 | 0;
      HEAP8[($74 + 3 | 0) >> 0] = $75 >>> 24 | 0;
      $77 = HEAPU8[($4 + 355 | 0) >> 0] | 0 | ((HEAPU8[($4 + 356 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 357 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 358 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[$8 >> 0] = $77;
      HEAP8[($8 + 1 | 0) >> 0] = $77 >>> 8 | 0;
      HEAP8[($8 + 2 | 0) >> 0] = $77 >>> 16 | 0;
      HEAP8[($8 + 3 | 0) >> 0] = $77 >>> 24 | 0;
      i64toi32_i32$2 = $4;
      i64toi32_i32$0 = HEAP32[($4 + 104 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($4 + 108 | 0) >> 2] | 0;
      $322 = i64toi32_i32$0;
      i64toi32_i32$0 = $13;
      HEAP32[i64toi32_i32$0 >> 2] = $322;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $7;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $325 = i64toi32_i32$1;
      i64toi32_i32$1 = $5;
      HEAP32[i64toi32_i32$1 >> 2] = $325;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $11;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $328 = i64toi32_i32$0;
      i64toi32_i32$0 = $10;
      HEAP32[i64toi32_i32$0 >> 2] = $328;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $15;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $331 = i64toi32_i32$1;
      i64toi32_i32$1 = $12;
      HEAP32[i64toi32_i32$1 >> 2] = $331;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[($4 + 528 | 0) >> 2] = 0;
      cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($6 | 0, $4 + 480 | 0 | 0, 1066343 | 0, 10 | 0);
      memcpy($0 + 8 | 0 | 0, memcpy($4 + 176 | 0 | 4 | 0 | 0, $6 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
      HEAP32[$0 >> 2] = 1;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($4 + 320 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($4 + 320 | 0 | 0);
      break label$1;
     }
     memcpy($4 + 360 | 0 | 0, memcpy($4 + 248 | 0 | 7 | 0 | 0, memcpy($4 + 480 | 0 | 7 | 0 | 0, ($4 + 360 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
     $1 = ($4 + 176 | 0) + 8 | 0;
     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 360 | 0 | 0, 1066228 | 0, 4 | 0);
     memcpy($0 + 8 | 0 | 0, memcpy($4 + 104 | 0 | 7 | 0 | 0, $1 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
     HEAP32[$0 >> 2] = 1;
     break label$1;
    }
    memcpy($4 + 360 | 0 | 0, memcpy(($4 + 248 | 0) + 7 | 0 | 0, memcpy($4 + 480 | 0 | 7 | 0 | 0, ($4 + 360 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
    $1 = ($4 + 176 | 0) + 8 | 0;
    cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 360 | 0 | 0, 1066232 | 0, 9 | 0);
    memcpy($0 + 8 | 0 | 0, memcpy(($4 + 104 | 0) + 7 | 0 | 0, $1 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    break label$1;
   }
   $1 = ($4 + 248 | 0) + 8 | 0;
   $5 = ($4 + 480 | 0) + 24 | 0;
   i64toi32_i32$2 = $5;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $415 = i64toi32_i32$0;
   i64toi32_i32$0 = $1;
   HEAP32[i64toi32_i32$0 >> 2] = $415;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   $6 = ($4 + 248 | 0) + 16 | 0;
   $7 = $4 + 512 | 0;
   i64toi32_i32$2 = $7;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $423 = i64toi32_i32$1;
   i64toi32_i32$1 = $6;
   HEAP32[i64toi32_i32$1 >> 2] = $423;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   $8 = ($4 + 248 | 0) + 24 | 0;
   $9 = $4 + 520 | 0;
   i64toi32_i32$2 = $9;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $431 = i64toi32_i32$0;
   i64toi32_i32$0 = $8;
   HEAP32[i64toi32_i32$0 >> 2] = $431;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($4 + 552 | 0) >> 2] = HEAPU8[($4 + 489 | 0) >> 0] | 0 | ((HEAPU8[($4 + 490 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 491 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 492 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $10 = $4 + 492 | 0;
   $78 = HEAPU8[$10 >> 0] | 0 | ((HEAPU8[($10 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($10 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($10 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[($4 + 555 | 0) >> 0] = $78;
   HEAP8[($4 + 556 | 0) >> 0] = $78 >>> 8 | 0;
   HEAP8[($4 + 557 | 0) >> 0] = $78 >>> 16 | 0;
   HEAP8[($4 + 558 | 0) >> 0] = $78 >>> 24 | 0;
   $11 = ($4 + 480 | 0) + 16 | 0;
   i64toi32_i32$2 = $11;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $445 = i64toi32_i32$1;
   i64toi32_i32$1 = $4;
   HEAP32[($4 + 248 | 0) >> 2] = $445;
   HEAP32[($4 + 252 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($4 + 336 | 0) >> 2] = HEAP32[($4 + 552 | 0) >> 2] | 0;
   $79 = HEAPU8[($4 + 555 | 0) >> 0] | 0 | ((HEAPU8[($4 + 556 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 557 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 558 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[($4 + 339 | 0) >> 0] = $79;
   HEAP8[($4 + 340 | 0) >> 0] = $79 >>> 8 | 0;
   HEAP8[($4 + 341 | 0) >> 0] = $79 >>> 16 | 0;
   HEAP8[($4 + 342 | 0) >> 0] = $79 >>> 24 | 0;
   $12 = ($4 + 480 | 0) + 8 | 0;
   $13 = HEAPU8[$12 >> 0] | 0;
   $14 = ($4 + 104 | 0) + 24 | 0;
   i64toi32_i32$2 = $8;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $462 = i64toi32_i32$0;
   i64toi32_i32$0 = $14;
   HEAP32[i64toi32_i32$0 >> 2] = $462;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   $8 = ($4 + 104 | 0) + 16 | 0;
   i64toi32_i32$2 = $6;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $468 = i64toi32_i32$1;
   i64toi32_i32$1 = $8;
   HEAP32[i64toi32_i32$1 >> 2] = $468;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   $6 = ($4 + 104 | 0) + 8 | 0;
   i64toi32_i32$2 = $1;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $474 = i64toi32_i32$0;
   i64toi32_i32$0 = $6;
   HEAP32[i64toi32_i32$0 >> 2] = $474;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $4;
   i64toi32_i32$1 = HEAP32[($4 + 248 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($4 + 252 | 0) >> 2] | 0;
   $477 = i64toi32_i32$1;
   i64toi32_i32$1 = $4;
   HEAP32[($4 + 104 | 0) >> 2] = $477;
   HEAP32[($4 + 108 | 0) >> 2] = i64toi32_i32$0;
   HEAP8[$12 >> 0] = $13;
   HEAP8[($4 + 480 | 0) >> 0] = 2;
   $80 = $4 + 489 | 0;
   $81 = HEAP32[($4 + 336 | 0) >> 2] | 0;
   HEAP8[$80 >> 0] = $81;
   HEAP8[($80 + 1 | 0) >> 0] = $81 >>> 8 | 0;
   HEAP8[($80 + 2 | 0) >> 0] = $81 >>> 16 | 0;
   HEAP8[($80 + 3 | 0) >> 0] = $81 >>> 24 | 0;
   $82 = HEAPU8[($4 + 339 | 0) >> 0] | 0 | ((HEAPU8[($4 + 340 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 341 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 342 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[$10 >> 0] = $82;
   HEAP8[($10 + 1 | 0) >> 0] = $82 >>> 8 | 0;
   HEAP8[($10 + 2 | 0) >> 0] = $82 >>> 16 | 0;
   HEAP8[($10 + 3 | 0) >> 0] = $82 >>> 24 | 0;
   i64toi32_i32$2 = $4;
   i64toi32_i32$0 = HEAP32[($4 + 104 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($4 + 108 | 0) >> 2] | 0;
   $490 = i64toi32_i32$0;
   i64toi32_i32$0 = $11;
   HEAP32[i64toi32_i32$0 >> 2] = $490;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $6;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $493 = i64toi32_i32$1;
   i64toi32_i32$1 = $5;
   HEAP32[i64toi32_i32$1 >> 2] = $493;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $8;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $496 = i64toi32_i32$0;
   i64toi32_i32$0 = $7;
   HEAP32[i64toi32_i32$0 >> 2] = $496;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $14;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $499 = i64toi32_i32$1;
   i64toi32_i32$1 = $9;
   HEAP32[i64toi32_i32$1 >> 2] = $499;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($4 + 528 | 0) >> 2] = 0;
   $1 = ($4 + 360 | 0) + 8 | 0;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 480 | 0 | 0, 1066333 | 0, 10 | 0);
   memcpy($0 + 8 | 0 | 0, memcpy($4 + 176 | 0 | 4 | 0 | 0, $1 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $4 + 560 | 0;
 }
 
 function alloc__slice__merge_sort__h8a7406e55f001b08($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $11 = 0, $3 = 0, $15 = 0, $13 = 0, $12 = 0, $9 = 0, $14 = 0, $8 = 0, $17 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $10 = 0, $16 = 0, $4 = 0, $5 = 0, $6 = 0, $7 = 0, $230 = 0, $237 = 0, $245 = 0;
  $3 = global$0 - 128 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     if ($1 >>> 0 < 21 >>> 0) {
      break label$3
     }
     alloc__raw_vec__RawVec_T_2cA___allocate_in__h94b8afe7a3e1d5bb($3 + 72 | 0 | 0, $1 >>> 1 | 0 | 0, 0 | 0);
     HEAP32[($3 + 88 | 0) >> 2] = 0;
     HEAP32[($3 + 84 | 0) >> 2] = HEAP32[($3 + 76 | 0) >> 2] | 0;
     $4 = HEAP32[($3 + 72 | 0) >> 2] | 0;
     HEAP32[($3 + 80 | 0) >> 2] = $4;
     i64toi32_i32$1 = $3;
     i64toi32_i32$0 = 0;
     HEAP32[($3 + 100 | 0) >> 2] = 0;
     HEAP32[($3 + 104 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($3 + 96 | 0) >> 2] = HEAP32[(0 + 1069064 | 0) >> 2] | 0;
     $5 = $0 + -12 | 0;
     $6 = $0 + -24 | 0;
     $7 = $0 + -36 | 0;
     $8 = $1;
     label$4 : while (1) {
      $9 = $8;
      $8 = 0;
      $10 = 1;
      label$5 : {
       $11 = $9 + -1 | 0;
       if (!$11) {
        break label$5
       }
       label$6 : {
        $12 = $0 + Math_imul($11, 12) | 0;
        $11 = HEAP32[($12 + 8 | 0) >> 2] | 0;
        $13 = $9 + -2 | 0;
        $14 = $0 + Math_imul($13, 12) | 0;
        $15 = HEAP32[($14 + 8 | 0) >> 2] | 0;
        $11 = $11 >>> 0 < $15 >>> 0 ? -1 : ($11 | 0) != ($15 | 0);
        if ($11) {
         break label$6
        }
        $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 64 | 0 | 0, $12 | 0);
        $11 = HEAP32[($3 + 68 | 0) >> 2] | 0;
        $15 = HEAP32[($3 + 64 | 0) >> 2] | 0;
        $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 56 | 0 | 0, $14 | 0);
        $11 = core__slice__cmp___impl_20core__cmp__Ord_20for_20_5bT_5d___cmp__h1f2092e0ba2f27ea($15 | 0, $11 | 0, HEAP32[($3 + 56 | 0) >> 2] | 0 | 0, HEAP32[($3 + 60 | 0) >> 2] | 0 | 0) | 0;
       }
       label$7 : {
        label$8 : {
         label$9 : {
          label$10 : {
           label$11 : {
            label$12 : {
             label$13 : {
              label$14 : {
               if (($11 & 255 | 0 | 0) == (255 | 0)) {
                break label$14
               }
               $14 = $9 + -2 | 0;
               $11 = $7 + Math_imul($9, 12) | 0;
               $8 = 0;
               $15 = 0;
               label$15 : while (1) {
                label$16 : {
                 if (($14 | 0) != ($15 | 0)) {
                  break label$16
                 }
                 $10 = $9;
                 break label$5;
                }
                label$17 : {
                 $13 = HEAP32[($11 + 20 | 0) >> 2] | 0;
                 $12 = HEAP32[($11 + 8 | 0) >> 2] | 0;
                 $13 = $13 >>> 0 < $12 >>> 0 ? -1 : ($13 | 0) != ($12 | 0);
                 if ($13) {
                  break label$17
                 }
                 $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 48 | 0 | 0, $11 + 12 | 0 | 0);
                 $13 = HEAP32[($3 + 52 | 0) >> 2] | 0;
                 $12 = HEAP32[($3 + 48 | 0) >> 2] | 0;
                 $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 40 | 0 | 0, $11 | 0);
                 $13 = core__slice__cmp___impl_20core__cmp__Ord_20for_20_5bT_5d___cmp__h1f2092e0ba2f27ea($12 | 0, $13 | 0, HEAP32[($3 + 40 | 0) >> 2] | 0 | 0, HEAP32[($3 + 44 | 0) >> 2] | 0 | 0) | 0;
                }
                $11 = $11 + -12 | 0;
                $15 = $15 + 1 | 0;
                if (($13 & 255 | 0 | 0) != (255 | 0)) {
                 continue label$15
                }
                break label$15;
               };
               $10 = $15 + 1 | 0;
               $15 = ($15 ^ -1 | 0) + $9 | 0;
               break label$13;
              }
              $16 = Math_imul($9, 12);
              $12 = $6 + $16 | 0;
              $17 = 2;
              label$18 : {
               label$19 : while (1) {
                $8 = $17;
                $11 = $12;
                $15 = $13;
                if (!$15) {
                 break label$18
                }
                $13 = $15 + -1 | 0;
                label$20 : {
                 $12 = $0 + Math_imul($15, 12) | 0;
                 $14 = HEAP32[($12 + 8 | 0) >> 2] | 0;
                 $17 = HEAP32[($12 + -4 | 0) >> 2] | 0;
                 $14 = $14 >>> 0 < $17 >>> 0 ? -1 : ($14 | 0) != ($17 | 0);
                 if ($14) {
                  break label$20
                 }
                 $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 32 | 0 | 0, $12 | 0);
                 $12 = HEAP32[($3 + 36 | 0) >> 2] | 0;
                 $14 = HEAP32[($3 + 32 | 0) >> 2] | 0;
                 $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 24 | 0 | 0, $0 + Math_imul($13, 12) | 0 | 0);
                 $14 = core__slice__cmp___impl_20core__cmp__Ord_20for_20_5bT_5d___cmp__h1f2092e0ba2f27ea($14 | 0, $12 | 0, HEAP32[($3 + 24 | 0) >> 2] | 0 | 0, HEAP32[($3 + 28 | 0) >> 2] | 0 | 0) | 0;
                }
                $12 = $11 + -12 | 0;
                $17 = $8 + 1 | 0;
                if (($14 & 255 | 0 | 0) == (255 | 0)) {
                 continue label$19
                }
                break label$19;
               };
              }
              if ($9 >>> 0 < $15 >>> 0) {
               break label$12
              }
              if ($9 >>> 0 > $1 >>> 0) {
               break label$11
              }
              $10 = $9 - $15 | 0;
              if (!($10 >>> 1 | 0)) {
               break label$13
              }
              $12 = $8 >>> 1 | 0;
              $13 = $5 + $16 | 0;
              label$21 : while (1) {
               $14 = ($3 + 112 | 0) + 8 | 0;
               $17 = $11 + 8 | 0;
               HEAP32[$14 >> 2] = HEAP32[$17 >> 2] | 0;
               i64toi32_i32$0 = HEAP32[$11 >> 2] | 0;
               i64toi32_i32$1 = HEAP32[($11 + 4 | 0) >> 2] | 0;
               $230 = i64toi32_i32$0;
               i64toi32_i32$0 = $3;
               HEAP32[($3 + 112 | 0) >> 2] = $230;
               HEAP32[($3 + 116 | 0) >> 2] = i64toi32_i32$1;
               $8 = $13 + 8 | 0;
               $16 = HEAP32[$8 >> 2] | 0;
               i64toi32_i32$1 = HEAP32[$13 >> 2] | 0;
               i64toi32_i32$0 = HEAP32[($13 + 4 | 0) >> 2] | 0;
               $237 = i64toi32_i32$1;
               i64toi32_i32$1 = $11;
               HEAP32[$11 >> 2] = $237;
               HEAP32[($11 + 4 | 0) >> 2] = i64toi32_i32$0;
               HEAP32[$17 >> 2] = $16;
               HEAP32[$8 >> 2] = HEAP32[$14 >> 2] | 0;
               i64toi32_i32$0 = HEAP32[($3 + 112 | 0) >> 2] | 0;
               i64toi32_i32$1 = HEAP32[($3 + 116 | 0) >> 2] | 0;
               $245 = i64toi32_i32$0;
               i64toi32_i32$0 = $13;
               HEAP32[$13 >> 2] = $245;
               HEAP32[($13 + 4 | 0) >> 2] = i64toi32_i32$1;
               $13 = $13 + -12 | 0;
               $11 = $11 + 12 | 0;
               $12 = $12 + -1 | 0;
               if ($12) {
                continue label$21
               }
               break label$21;
              };
             }
             if (!$15) {
              break label$7
             }
             if ($10 >>> 0 > 9 >>> 0) {
              break label$7
             }
             $11 = 1 - $15 | 0;
             $13 = $5 + Math_imul($15, 12) | 0;
             label$22 : while (1) {
              $8 = $15 + -1 | 0;
              if ($9 >>> 0 < $8 >>> 0) {
               break label$10
              }
              if ($9 >>> 0 > $1 >>> 0) {
               break label$9
              }
              $12 = $9 + $11 | 0;
              alloc__slice__insert_head__h35027323f3cb1415($13 | 0, $12 | 0, $3 | 0);
              if (!$11) {
               break label$8
              }
              $11 = $11 + 1 | 0;
              $13 = $13 + -12 | 0;
              $15 = $8;
              if ($12 >>> 0 < 10 >>> 0) {
               continue label$22
              }
              break label$8;
             };
            }
            core__slice__index__slice_index_order_fail__h71e247dec3f266ff($15 | 0, $9 | 0, 1069172 | 0);
            abort();
           }
           core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($9 | 0, $1 | 0, 1069172 | 0);
           abort();
          }
          core__slice__index__slice_index_order_fail__h71e247dec3f266ff($15 + -1 | 0 | 0, $9 | 0, 1069188 | 0);
          abort();
         }
         core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($9 | 0, $1 | 0, 1069188 | 0);
         abort();
        }
        $10 = $9 - $8 | 0;
        break label$5;
       }
       $8 = $15;
      }
      label$23 : {
       $11 = HEAP32[($3 + 104 | 0) >> 2] | 0;
       if ((HEAP32[($3 + 100 | 0) >> 2] | 0 | 0) != ($11 | 0)) {
        break label$23
       }
       alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hf5a91d7c63e29e55($3 + 96 | 0 | 0, $11 | 0, 1 | 0);
       $11 = HEAP32[($3 + 104 | 0) >> 2] | 0;
      }
      $11 = (HEAP32[($3 + 96 | 0) >> 2] | 0) + ($11 << 3 | 0) | 0;
      HEAP32[($11 + 4 | 0) >> 2] = $10;
      HEAP32[$11 >> 2] = $8;
      $11 = (HEAP32[($3 + 104 | 0) >> 2] | 0) + 1 | 0;
      HEAP32[($3 + 104 | 0) >> 2] = $11;
      label$24 : {
       if ($11 >>> 0 < 2 >>> 0) {
        break label$24
       }
       label$25 : {
        label$26 : {
         label$27 : {
          label$28 : {
           label$29 : while (1) {
            label$30 : {
             label$31 : {
              label$32 : {
               label$33 : {
                $9 = HEAP32[($3 + 96 | 0) >> 2] | 0;
                $15 = $9 + (($11 + -1 | 0) << 3 | 0) | 0;
                if (!(HEAP32[$15 >> 2] | 0)) {
                 break label$33
                }
                $17 = ($11 << 3 | 0) + $9 | 0;
                $14 = HEAP32[($17 + -12 | 0) >> 2] | 0;
                $13 = HEAP32[($15 + 4 | 0) >> 2] | 0;
                if ($14 >>> 0 <= $13 >>> 0) {
                 break label$33
                }
                if ($11 >>> 0 < 3 >>> 0) {
                 break label$24
                }
                $15 = $11 + -3 | 0;
                $12 = HEAP32[(($9 + ($15 << 3 | 0) | 0) + 4 | 0) >> 2] | 0;
                if ($12 >>> 0 <= ($13 + $14 | 0) >>> 0) {
                 break label$32
                }
                if ($11 >>> 0 < 4 >>> 0) {
                 break label$24
                }
                if ((HEAP32[($17 + -28 | 0) >> 2] | 0) >>> 0 <= ($12 + $14 | 0) >>> 0) {
                 break label$32
                }
                break label$24;
               }
               if ($11 >>> 0 < 3 >>> 0) {
                break label$31
               }
               $13 = HEAP32[($15 + 4 | 0) >> 2] | 0;
               $15 = $11 + -3 | 0;
               $12 = HEAP32[(($9 + ($15 << 3 | 0) | 0) + 4 | 0) >> 2] | 0;
              }
              if ($12 >>> 0 < $13 >>> 0) {
               break label$30
              }
             }
             $15 = $11 + -2 | 0;
            }
            label$34 : {
             $13 = $15 + 1 | 0;
             if ($11 >>> 0 <= $13 >>> 0) {
              break label$34
             }
             if ($11 >>> 0 <= $15 >>> 0) {
              break label$28
             }
             $14 = $15 << 3 | 0;
             $11 = $9 + $14 | 0;
             $17 = HEAP32[($11 + 4 | 0) >> 2] | 0;
             $12 = $17 + (HEAP32[$11 >> 2] | 0) | 0;
             $9 = $9 + ($13 << 3 | 0) | 0;
             $11 = HEAP32[$9 >> 2] | 0;
             if ($12 >>> 0 < $11 >>> 0) {
              break label$27
             }
             if ($12 >>> 0 > $1 >>> 0) {
              break label$26
             }
             $9 = HEAP32[($9 + 4 | 0) >> 2] | 0;
             alloc__slice__merge__h6719d5d3dea70774($0 + Math_imul($11, 12) | 0 | 0, $12 - $11 | 0 | 0, $9 | 0, $4 | 0, $3 | 0);
             $12 = HEAP32[($3 + 104 | 0) >> 2] | 0;
             if ($12 >>> 0 <= $15 >>> 0) {
              break label$25
             }
             $15 = (HEAP32[($3 + 96 | 0) >> 2] | 0) + $14 | 0;
             HEAP32[($15 + 4 | 0) >> 2] = $17 + $9 | 0;
             HEAP32[$15 >> 2] = $11;
             alloc__vec__Vec_T_2cA___remove__hf0ee37bb0b07dbd1($3 + 16 | 0 | 0, $3 + 96 | 0 | 0, $13 | 0);
             $11 = HEAP32[($3 + 104 | 0) >> 2] | 0;
             if ($11 >>> 0 > 1 >>> 0) {
              continue label$29
             }
             break label$24;
            }
            break label$29;
           };
           core__panicking__panic_bounds_check__h808b524af17640b1($13 | 0, $11 | 0, 1069204 | 0);
           abort();
          }
          core__panicking__panic_bounds_check__h808b524af17640b1($15 | 0, $11 | 0, 1069220 | 0);
          abort();
         }
         core__slice__index__slice_index_order_fail__h71e247dec3f266ff($11 | 0, $12 | 0, 1069236 | 0);
         abort();
        }
        core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($12 | 0, $1 | 0, 1069236 | 0);
        abort();
       }
       core__panicking__panic_bounds_check__h808b524af17640b1($15 | 0, $12 | 0, 1069252 | 0);
       abort();
      }
      if ($8) {
       continue label$4
      }
      break label$4;
     };
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h28ea22ae705f999b($3 + 96 | 0 | 0);
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h5af1c14f46bf1edb($3 + 80 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hd4ac14c513c9516d($3 + 80 | 0 | 0);
     break label$2;
    }
    if ($1 >>> 0 < 2 >>> 0) {
     break label$2
    }
    core__iter__adapters__rev__Rev_T___new__h11ed92efd1d68010($3 + 8 | 0 | 0, 0 | 0, $1 + -1 | 0 | 0);
    $12 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    $13 = HEAP32[($3 + 12 | 0) >> 2] | 0;
    if ($12 >>> 0 >= $13 >>> 0) {
     break label$2
    }
    $11 = ($1 - $13 | 0) + 1 | 0;
    $15 = (Math_imul($13, 12) + $0 | 0) + -12 | 0;
    label$35 : while (1) {
     $9 = $13 + -1 | 0;
     if ($9 >>> 0 > $1 >>> 0) {
      break label$1
     }
     alloc__slice__insert_head__h35027323f3cb1415($15 | 0, $11 | 0, $3 | 0);
     $11 = $11 + 1 | 0;
     $15 = $15 + -12 | 0;
     $13 = $9;
     if ($12 >>> 0 < $9 >>> 0) {
      continue label$35
     }
     break label$35;
    };
   }
   global$0 = $3 + 128 | 0;
   return;
  }
  core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($13 + -1 | 0 | 0, $1 | 0, 1069156 | 0);
  abort();
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__Certificates___deserialize__hd24284feaee200d9($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, $11 = 0, $12 = 0, $17 = 0, $19 = 0, $7 = 0, $13 = 0, $3 = 0, $17$hi = 0, $19$hi = 0, $10 = 0, $14 = 0, $70 = 0, $71 = 0, $72 = 0, $73 = 0, $74 = 0, $76 = 0, $77 = 0, $78 = 0, $79 = 0, $80 = 0, $81 = 0, $83 = 0, $84 = 0, $85 = 0, $86 = 0, $87 = 0, $88 = 0, $18 = 0, $18$hi = 0, $4 = 0, $6 = 0, $8 = 0, $15 = 0, $16 = 0, $5 = 0, $9 = 0, $75 = 0, $82 = 0, $98 = 0, $101 = 0, $122 = 0, $128 = 0, $143 = 0, $146 = 0, $158 = 0, $164 = 0, $167 = 0, $176 = 0, $188 = 0, $194 = 0, $197 = 0, $206 = 0, $241 = 0, $245 = 0, $249 = 0, $256 = 0, $308 = 0, $316 = 0, $333 = 0, $336 = 0, $348 = 0, $354 = 0, $357 = 0, $366 = 0, $377 = 0, $382 = 0, $385 = 0, $393 = 0, $401 = 0, $407 = 0, $411 = 0, $417 = 0, $423 = 0, $427 = 0, $439 = 0, $443 = 0, $449 = 0, $455 = 0, $482 = 0;
  $2 = global$0 - 736 | 0;
  global$0 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 12 | 0) >> 2] = 0;
  HEAP32[($2 + 16 | 0) >> 2] = i64toi32_i32$0;
  $3 = 0;
  HEAP32[($2 + 8 | 0) >> 2] = HEAP32[(0 + 1050204 | 0) >> 2] | 0;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 528 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = ($2 + 528 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $17 = i64toi32_i32$0;
  $17$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 536 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 540 | 0) >> 2] | 0;
  $18 = i64toi32_i32$1;
  $18$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 528 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 532 | 0) >> 2] | 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
         break label$6
        }
        i64toi32_i32$2 = $17$hi;
        $4 = $17;
        label$7 : {
         i64toi32_i32$2 = $18$hi;
         i64toi32_i32$3 = $18;
         i64toi32_i32$1 = 0;
         i64toi32_i32$0 = 1;
         if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
          break label$7
         }
         if (!$4) {
          break label$3
         }
        }
        $5 = $2 + 600 | 0;
        $6 = ($2 + 528 | 0) + 60 | 0;
        $7 = ($2 + 528 | 0) + 32 | 0;
        $8 = $2 + 537 | 0;
        $9 = $8 + 3 | 0;
        label$8 : {
         label$9 : while (1) {
          std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 | 0, $1 | 0);
          $3 = 0;
          $10 = 2;
          label$10 : {
           if (HEAP32[($2 + 4 | 0) >> 2] | 0) {
            break label$10
           }
           i64toi32_i32$3 = 0;
           $19 = 8;
           $19$hi = i64toi32_i32$3;
           i64toi32_i32$3 = 0;
           $17 = 0;
           $17$hi = i64toi32_i32$3;
           break label$4;
          }
          label$11 : {
           if ((($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[$2 >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) == (7 | 0)) {
            break label$11
           }
           cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__CertificateEnum___deserialize__h3059f65111c7091a($2 + 528 | 0 | 0, $1 | 0);
           $11 = ($2 + 496 | 0) + 8 | 0;
           i64toi32_i32$0 = $7 + 8 | 0;
           i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $75 = i64toi32_i32$3;
           i64toi32_i32$3 = $11;
           HEAP32[i64toi32_i32$3 >> 2] = $75;
           HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
           $12 = ($2 + 496 | 0) + 16 | 0;
           i64toi32_i32$0 = $7 + 16 | 0;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $82 = i64toi32_i32$2;
           i64toi32_i32$2 = $12;
           HEAP32[i64toi32_i32$2 >> 2] = $82;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
           $13 = ($2 + 480 | 0) + 8 | 0;
           HEAP32[$13 >> 2] = HEAP32[($6 + 8 | 0) >> 2] | 0;
           $70 = $8;
           HEAP32[($2 + 520 | 0) >> 2] = HEAPU8[$70 >> 0] | 0 | ((HEAPU8[($70 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($70 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($70 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $71 = $9;
           $72 = HEAPU8[$71 >> 0] | 0 | ((HEAPU8[($71 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($71 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($71 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 523 | 0) >> 0] = $72;
           HEAP8[($2 + 524 | 0) >> 0] = $72 >>> 8 | 0;
           HEAP8[($2 + 525 | 0) >> 0] = $72 >>> 16 | 0;
           HEAP8[($2 + 526 | 0) >> 0] = $72 >>> 24 | 0;
           i64toi32_i32$0 = $7;
           i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $98 = i64toi32_i32$3;
           i64toi32_i32$3 = $2;
           HEAP32[($2 + 496 | 0) >> 2] = $98;
           HEAP32[($2 + 500 | 0) >> 2] = i64toi32_i32$2;
           i64toi32_i32$0 = $6;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $101 = i64toi32_i32$2;
           i64toi32_i32$2 = $2;
           HEAP32[($2 + 480 | 0) >> 2] = $101;
           HEAP32[($2 + 484 | 0) >> 2] = i64toi32_i32$3;
           $3 = HEAP32[($2 + 584 | 0) >> 2] | 0;
           i64toi32_i32$0 = $2;
           i64toi32_i32$3 = HEAP32[($2 + 552 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($2 + 556 | 0) >> 2] | 0;
           $17 = i64toi32_i32$3;
           $17$hi = i64toi32_i32$2;
           i64toi32_i32$0 = $2;
           i64toi32_i32$2 = HEAP32[($2 + 544 | 0) >> 2] | 0;
           i64toi32_i32$3 = HEAP32[($2 + 548 | 0) >> 2] | 0;
           $19 = i64toi32_i32$2;
           $19$hi = i64toi32_i32$3;
           $10 = HEAPU8[($2 + 536 | 0) >> 0] | 0;
           i64toi32_i32$0 = $2;
           i64toi32_i32$3 = HEAP32[($2 + 528 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($2 + 532 | 0) >> 2] | 0;
           i64toi32_i32$0 = i64toi32_i32$3;
           i64toi32_i32$3 = 0;
           i64toi32_i32$1 = 1;
           if ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) | 0) {
            break label$8
           }
           memcpy($2 + 200 | 0 | 0, $5 | 0, 136 | 0) | 0;
           $14 = ($2 + 448 | 0) + 8 | 0;
           i64toi32_i32$1 = $11;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $122 = i64toi32_i32$0;
           i64toi32_i32$0 = $14;
           HEAP32[i64toi32_i32$0 >> 2] = $122;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
           $11 = ($2 + 448 | 0) + 16 | 0;
           i64toi32_i32$1 = $12;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $128 = i64toi32_i32$2;
           i64toi32_i32$2 = $11;
           HEAP32[i64toi32_i32$2 >> 2] = $128;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
           $12 = ($2 + 432 | 0) + 8 | 0;
           HEAP32[$12 >> 2] = HEAP32[$13 >> 2] | 0;
           $73 = HEAPU8[($2 + 523 | 0) >> 0] | 0 | ((HEAPU8[($2 + 524 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 525 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 526 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 475 | 0) >> 0] = $73;
           HEAP8[($2 + 476 | 0) >> 0] = $73 >>> 8 | 0;
           HEAP8[($2 + 477 | 0) >> 0] = $73 >>> 16 | 0;
           HEAP8[($2 + 478 | 0) >> 0] = $73 >>> 24 | 0;
           HEAP32[($2 + 472 | 0) >> 2] = HEAP32[($2 + 520 | 0) >> 2] | 0;
           i64toi32_i32$1 = $2;
           i64toi32_i32$0 = HEAP32[($2 + 496 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($2 + 500 | 0) >> 2] | 0;
           $143 = i64toi32_i32$0;
           i64toi32_i32$0 = $2;
           HEAP32[($2 + 448 | 0) >> 2] = $143;
           HEAP32[($2 + 452 | 0) >> 2] = i64toi32_i32$2;
           i64toi32_i32$1 = $2;
           i64toi32_i32$2 = HEAP32[($2 + 480 | 0) >> 2] | 0;
           i64toi32_i32$0 = HEAP32[($2 + 484 | 0) >> 2] | 0;
           $146 = i64toi32_i32$2;
           i64toi32_i32$2 = $2;
           HEAP32[($2 + 432 | 0) >> 2] = $146;
           HEAP32[($2 + 436 | 0) >> 2] = i64toi32_i32$0;
           $74 = HEAPU8[($2 + 475 | 0) >> 0] | 0 | ((HEAPU8[($2 + 476 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 477 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 478 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 427 | 0) >> 0] = $74;
           HEAP8[($2 + 428 | 0) >> 0] = $74 >>> 8 | 0;
           HEAP8[($2 + 429 | 0) >> 0] = $74 >>> 16 | 0;
           HEAP8[($2 + 430 | 0) >> 0] = $74 >>> 24 | 0;
           HEAP32[($2 + 424 | 0) >> 2] = HEAP32[($2 + 472 | 0) >> 2] | 0;
           $13 = ($2 + 400 | 0) + 16 | 0;
           i64toi32_i32$1 = $11;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $158 = i64toi32_i32$0;
           i64toi32_i32$0 = $13;
           HEAP32[i64toi32_i32$0 >> 2] = $158;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
           $11 = ($2 + 400 | 0) + 8 | 0;
           i64toi32_i32$1 = $14;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $164 = i64toi32_i32$2;
           i64toi32_i32$2 = $11;
           HEAP32[i64toi32_i32$2 >> 2] = $164;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
           i64toi32_i32$1 = $2;
           i64toi32_i32$0 = HEAP32[($2 + 448 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($2 + 452 | 0) >> 2] | 0;
           $167 = i64toi32_i32$0;
           i64toi32_i32$0 = $2;
           HEAP32[($2 + 400 | 0) >> 2] = $167;
           HEAP32[($2 + 404 | 0) >> 2] = i64toi32_i32$2;
           $14 = ($2 + 384 | 0) + 8 | 0;
           HEAP32[$14 >> 2] = HEAP32[$12 >> 2] | 0;
           i64toi32_i32$1 = $2;
           i64toi32_i32$2 = HEAP32[($2 + 432 | 0) >> 2] | 0;
           i64toi32_i32$0 = HEAP32[($2 + 436 | 0) >> 2] | 0;
           $176 = i64toi32_i32$2;
           i64toi32_i32$2 = $2;
           HEAP32[($2 + 384 | 0) >> 2] = $176;
           HEAP32[($2 + 388 | 0) >> 2] = i64toi32_i32$0;
           $76 = HEAPU8[($2 + 427 | 0) >> 0] | 0 | ((HEAPU8[($2 + 428 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 429 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 430 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 379 | 0) >> 0] = $76;
           HEAP8[($2 + 380 | 0) >> 0] = $76 >>> 8 | 0;
           HEAP8[($2 + 381 | 0) >> 0] = $76 >>> 16 | 0;
           HEAP8[($2 + 382 | 0) >> 0] = $76 >>> 24 | 0;
           HEAP32[($2 + 376 | 0) >> 2] = HEAP32[($2 + 424 | 0) >> 2] | 0;
           $15 = ($2 + 352 | 0) + 16 | 0;
           i64toi32_i32$1 = $13;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $188 = i64toi32_i32$0;
           i64toi32_i32$0 = $15;
           HEAP32[i64toi32_i32$0 >> 2] = $188;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
           $13 = ($2 + 352 | 0) + 8 | 0;
           i64toi32_i32$1 = $11;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $194 = i64toi32_i32$2;
           i64toi32_i32$2 = $13;
           HEAP32[i64toi32_i32$2 >> 2] = $194;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
           i64toi32_i32$1 = $2;
           i64toi32_i32$0 = HEAP32[($2 + 400 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($2 + 404 | 0) >> 2] | 0;
           $197 = i64toi32_i32$0;
           i64toi32_i32$0 = $2;
           HEAP32[($2 + 352 | 0) >> 2] = $197;
           HEAP32[($2 + 356 | 0) >> 2] = i64toi32_i32$2;
           $16 = ($2 + 336 | 0) + 8 | 0;
           HEAP32[$16 >> 2] = HEAP32[$14 >> 2] | 0;
           i64toi32_i32$1 = $2;
           i64toi32_i32$2 = HEAP32[($2 + 384 | 0) >> 2] | 0;
           i64toi32_i32$0 = HEAP32[($2 + 388 | 0) >> 2] | 0;
           $206 = i64toi32_i32$2;
           i64toi32_i32$2 = $2;
           HEAP32[($2 + 336 | 0) >> 2] = $206;
           HEAP32[($2 + 340 | 0) >> 2] = i64toi32_i32$0;
           label$12 : {
            $12 = HEAP32[($2 + 16 | 0) >> 2] | 0;
            if ((HEAP32[($2 + 12 | 0) >> 2] | 0 | 0) != ($12 | 0)) {
             break label$12
            }
            alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h55956fe02300486e($2 + 8 | 0 | 0, $12 | 0, 1 | 0);
            $12 = HEAP32[($2 + 16 | 0) >> 2] | 0;
           }
           $11 = (HEAP32[($2 + 8 | 0) >> 2] | 0) + Math_imul($12, 200) | 0;
           HEAP8[$11 >> 0] = $10;
           $77 = HEAP32[($2 + 376 | 0) >> 2] | 0;
           HEAP8[($11 + 1 | 0) >> 0] = $77;
           HEAP8[($11 + 2 | 0) >> 0] = $77 >>> 8 | 0;
           HEAP8[($11 + 3 | 0) >> 0] = $77 >>> 16 | 0;
           HEAP8[($11 + 4 | 0) >> 0] = $77 >>> 24 | 0;
           $78 = $11 + 4 | 0;
           $79 = HEAPU8[($2 + 379 | 0) >> 0] | 0 | ((HEAPU8[($2 + 380 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 381 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 382 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[$78 >> 0] = $79;
           HEAP8[($78 + 1 | 0) >> 0] = $79 >>> 8 | 0;
           HEAP8[($78 + 2 | 0) >> 0] = $79 >>> 16 | 0;
           HEAP8[($78 + 3 | 0) >> 0] = $79 >>> 24 | 0;
           i64toi32_i32$0 = $17$hi;
           i64toi32_i32$2 = $11 + 16 | 0;
           HEAP8[i64toi32_i32$2 >> 0] = $17;
           HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $17 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $17 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $17 >>> 24 | 0;
           HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$0;
           HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
           i64toi32_i32$0 = $19$hi;
           i64toi32_i32$2 = $11 + 8 | 0;
           HEAP8[i64toi32_i32$2 >> 0] = $19;
           HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $19 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $19 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $19 >>> 24 | 0;
           HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$0;
           HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
           i64toi32_i32$1 = $2;
           i64toi32_i32$0 = HEAP32[($2 + 352 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($2 + 356 | 0) >> 2] | 0;
           $241 = i64toi32_i32$0;
           i64toi32_i32$0 = $11 + 24 | 0;
           $80 = $241;
           HEAP8[i64toi32_i32$0 >> 0] = $80;
           HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $80 >>> 8 | 0;
           HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $80 >>> 16 | 0;
           HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $80 >>> 24 | 0;
           HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$2;
           HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
           HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
           HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
           i64toi32_i32$1 = $13;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $245 = i64toi32_i32$2;
           i64toi32_i32$2 = $11 + 32 | 0;
           $81 = $245;
           HEAP8[i64toi32_i32$2 >> 0] = $81;
           HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $81 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $81 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $81 >>> 24 | 0;
           HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$0;
           HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
           i64toi32_i32$1 = $15;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $249 = i64toi32_i32$0;
           i64toi32_i32$0 = $11 + 40 | 0;
           $83 = $249;
           HEAP8[i64toi32_i32$0 >> 0] = $83;
           HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $83 >>> 8 | 0;
           HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $83 >>> 16 | 0;
           HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $83 >>> 24 | 0;
           HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$2;
           HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
           HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
           HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
           HEAP32[($11 + 48 | 0) >> 2] = $3;
           i64toi32_i32$1 = $2;
           i64toi32_i32$2 = HEAP32[($2 + 336 | 0) >> 2] | 0;
           i64toi32_i32$0 = HEAP32[($2 + 340 | 0) >> 2] | 0;
           $256 = i64toi32_i32$2;
           i64toi32_i32$2 = $11 + 52 | 0;
           HEAP32[i64toi32_i32$2 >> 2] = $256;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
           HEAP32[($11 + 60 | 0) >> 2] = HEAP32[$16 >> 2] | 0;
           memcpy($11 + 64 | 0 | 0, $2 + 200 | 0 | 0, 136 | 0) | 0;
           $11 = $12 + 1 | 0;
           HEAP32[($2 + 16 | 0) >> 2] = $11;
           i64toi32_i32$0 = $18$hi;
           i64toi32_i32$1 = $18;
           i64toi32_i32$2 = 0;
           i64toi32_i32$3 = 1;
           if ((i64toi32_i32$1 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$2 | 0) | 0) {
            continue label$9
           }
           if ($11 >>> 0 < $4 >>> 0) {
            continue label$9
           }
           break label$3;
          }
          break label$9;
         };
         cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 528 | 0 | 0, $1 | 0);
         i64toi32_i32$3 = ($2 + 528 | 0) + 16 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $17 = i64toi32_i32$1;
         $17$hi = i64toi32_i32$0;
         i64toi32_i32$3 = $2;
         i64toi32_i32$0 = HEAP32[($2 + 536 | 0) >> 2] | 0;
         i64toi32_i32$1 = HEAP32[($2 + 540 | 0) >> 2] | 0;
         $19 = i64toi32_i32$0;
         $19$hi = i64toi32_i32$1;
         i64toi32_i32$3 = $2;
         i64toi32_i32$1 = HEAP32[($2 + 528 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($2 + 532 | 0) >> 2] | 0;
         i64toi32_i32$3 = i64toi32_i32$1;
         i64toi32_i32$1 = 0;
         i64toi32_i32$2 = 1;
         if ((i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
          break label$5
         }
         i64toi32_i32$3 = $17$hi;
         i64toi32_i32$0 = $2 + 504 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $17;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
         i64toi32_i32$3 = $19$hi;
         i64toi32_i32$0 = $2;
         HEAP32[($2 + 496 | 0) >> 2] = $19;
         HEAP32[($2 + 500 | 0) >> 2] = i64toi32_i32$3;
         if (($19 & 255 | 0 | 0) == (5 | 0)) {
          break label$3
         }
         HEAP32[($2 + 528 | 0) >> 2] = 0;
         core__panicking__assert_failed__h96d8431cc974b591(0 | 0, $2 + 496 | 0 | 0, 1050312 | 0, $2 + 528 | 0 | 0, 1050420 | 0);
         abort();
        }
        $11 = ($2 + 448 | 0) + 8 | 0;
        i64toi32_i32$2 = ($2 + 496 | 0) + 8 | 0;
        i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $308 = i64toi32_i32$3;
        i64toi32_i32$3 = $11;
        HEAP32[i64toi32_i32$3 >> 2] = $308;
        HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
        $7 = ($2 + 448 | 0) + 16 | 0;
        i64toi32_i32$2 = ($2 + 496 | 0) + 16 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $316 = i64toi32_i32$0;
        i64toi32_i32$0 = $7;
        HEAP32[i64toi32_i32$0 >> 2] = $316;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
        $1 = ($2 + 432 | 0) + 8 | 0;
        HEAP32[$1 >> 2] = HEAP32[(($2 + 480 | 0) + 8 | 0) >> 2] | 0;
        HEAP32[($2 + 472 | 0) >> 2] = HEAP32[($2 + 520 | 0) >> 2] | 0;
        $84 = HEAPU8[($2 + 523 | 0) >> 0] | 0 | ((HEAPU8[($2 + 524 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 525 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 526 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 475 | 0) >> 0] = $84;
        HEAP8[($2 + 476 | 0) >> 0] = $84 >>> 8 | 0;
        HEAP8[($2 + 477 | 0) >> 0] = $84 >>> 16 | 0;
        HEAP8[($2 + 478 | 0) >> 0] = $84 >>> 24 | 0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$3 = HEAP32[($2 + 496 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[($2 + 500 | 0) >> 2] | 0;
        $333 = i64toi32_i32$3;
        i64toi32_i32$3 = $2;
        HEAP32[($2 + 448 | 0) >> 2] = $333;
        HEAP32[($2 + 452 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 480 | 0) >> 2] | 0;
        i64toi32_i32$3 = HEAP32[($2 + 484 | 0) >> 2] | 0;
        $336 = i64toi32_i32$0;
        i64toi32_i32$0 = $2;
        HEAP32[($2 + 432 | 0) >> 2] = $336;
        HEAP32[($2 + 436 | 0) >> 2] = i64toi32_i32$3;
        $85 = HEAPU8[($2 + 475 | 0) >> 0] | 0 | ((HEAPU8[($2 + 476 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 477 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 478 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 427 | 0) >> 0] = $85;
        HEAP8[($2 + 428 | 0) >> 0] = $85 >>> 8 | 0;
        HEAP8[($2 + 429 | 0) >> 0] = $85 >>> 16 | 0;
        HEAP8[($2 + 430 | 0) >> 0] = $85 >>> 24 | 0;
        HEAP32[($2 + 424 | 0) >> 2] = HEAP32[($2 + 472 | 0) >> 2] | 0;
        $12 = ($2 + 400 | 0) + 16 | 0;
        i64toi32_i32$2 = $7;
        i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $348 = i64toi32_i32$3;
        i64toi32_i32$3 = $12;
        HEAP32[i64toi32_i32$3 >> 2] = $348;
        HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
        $7 = ($2 + 400 | 0) + 8 | 0;
        i64toi32_i32$2 = $11;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $354 = i64toi32_i32$0;
        i64toi32_i32$0 = $7;
        HEAP32[i64toi32_i32$0 >> 2] = $354;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
        i64toi32_i32$2 = $2;
        i64toi32_i32$3 = HEAP32[($2 + 448 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[($2 + 452 | 0) >> 2] | 0;
        $357 = i64toi32_i32$3;
        i64toi32_i32$3 = $2;
        HEAP32[($2 + 400 | 0) >> 2] = $357;
        HEAP32[($2 + 404 | 0) >> 2] = i64toi32_i32$0;
        $11 = ($2 + 384 | 0) + 8 | 0;
        HEAP32[$11 >> 2] = HEAP32[$1 >> 2] | 0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 432 | 0) >> 2] | 0;
        i64toi32_i32$3 = HEAP32[($2 + 436 | 0) >> 2] | 0;
        $366 = i64toi32_i32$0;
        i64toi32_i32$0 = $2;
        HEAP32[($2 + 384 | 0) >> 2] = $366;
        HEAP32[($2 + 388 | 0) >> 2] = i64toi32_i32$3;
        $86 = HEAPU8[($2 + 427 | 0) >> 0] | 0 | ((HEAPU8[($2 + 428 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 429 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 430 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 195 | 0) >> 0] = $86;
        HEAP8[($2 + 196 | 0) >> 0] = $86 >>> 8 | 0;
        HEAP8[($2 + 197 | 0) >> 0] = $86 >>> 16 | 0;
        HEAP8[($2 + 198 | 0) >> 0] = $86 >>> 24 | 0;
        HEAP32[($2 + 192 | 0) >> 2] = HEAP32[($2 + 424 | 0) >> 2] | 0;
        i64toi32_i32$2 = $12;
        i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $377 = i64toi32_i32$3;
        i64toi32_i32$3 = ($2 + 168 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$3 >> 2] = $377;
        HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = $7;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $382 = i64toi32_i32$0;
        i64toi32_i32$0 = ($2 + 168 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $382;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
        i64toi32_i32$2 = $2;
        i64toi32_i32$3 = HEAP32[($2 + 400 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[($2 + 404 | 0) >> 2] | 0;
        $385 = i64toi32_i32$3;
        i64toi32_i32$3 = $2;
        HEAP32[($2 + 168 | 0) >> 2] = $385;
        HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$0;
        HEAP32[(($2 + 152 | 0) + 8 | 0) >> 2] = HEAP32[$11 >> 2] | 0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 384 | 0) >> 2] | 0;
        i64toi32_i32$3 = HEAP32[($2 + 388 | 0) >> 2] | 0;
        $393 = i64toi32_i32$0;
        i64toi32_i32$0 = $2;
        HEAP32[($2 + 152 | 0) >> 2] = $393;
        HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$3;
        if (($10 & 255 | 0 | 0) != (19 | 0)) {
         break label$4
        }
        break label$3;
       }
       i64toi32_i32$2 = $2 + 560 | 0;
       i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $401 = i64toi32_i32$3;
       i64toi32_i32$3 = $2 + 176 | 0;
       HEAP32[i64toi32_i32$3 >> 2] = $401;
       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = $2 + 568 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $407 = i64toi32_i32$0;
       i64toi32_i32$0 = ($2 + 168 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $407;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
       i64toi32_i32$2 = $2 + 552 | 0;
       i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $411 = i64toi32_i32$3;
       i64toi32_i32$3 = $2;
       HEAP32[($2 + 168 | 0) >> 2] = $411;
       HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$0;
       $10 = 2;
       i64toi32_i32$0 = $18$hi;
       $19 = $18;
       $19$hi = i64toi32_i32$0;
       break label$4;
      }
      i64toi32_i32$2 = $2 + 560 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $417 = i64toi32_i32$0;
      i64toi32_i32$0 = $2 + 176 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $417;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
      i64toi32_i32$2 = $2 + 568 | 0;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $423 = i64toi32_i32$3;
      i64toi32_i32$3 = ($2 + 168 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$3 >> 2] = $423;
      HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $2 + 552 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $427 = i64toi32_i32$0;
      i64toi32_i32$0 = $2;
      HEAP32[($2 + 168 | 0) >> 2] = $427;
      HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$3;
     }
     i64toi32_i32$3 = $17$hi;
     i64toi32_i32$0 = ($2 + 528 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $17;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$3 = $19$hi;
     i64toi32_i32$0 = ($2 + 528 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $19;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$2 = $2;
     i64toi32_i32$3 = HEAP32[($2 + 168 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 172 | 0) >> 2] | 0;
     $439 = i64toi32_i32$3;
     i64toi32_i32$3 = $2 + 552 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $439;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[($2 + 152 | 0) >> 2] | 0;
     i64toi32_i32$3 = HEAP32[($2 + 156 | 0) >> 2] | 0;
     $443 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 580 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $443;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$2 = ($2 + 168 | 0) + 8 | 0;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $449 = i64toi32_i32$3;
     i64toi32_i32$3 = $2 + 560 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $449;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = ($2 + 168 | 0) + 16 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $455 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 568 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $455;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
     HEAP32[($2 + 588 | 0) >> 2] = HEAP32[(($2 + 152 | 0) + 8 | 0) >> 2] | 0;
     HEAP8[($2 + 528 | 0) >> 0] = $10;
     $87 = HEAP32[($2 + 192 | 0) >> 2] | 0;
     HEAP8[($2 + 529 | 0) >> 0] = $87;
     HEAP8[($2 + 530 | 0) >> 0] = $87 >>> 8 | 0;
     HEAP8[($2 + 531 | 0) >> 0] = $87 >>> 16 | 0;
     HEAP8[($2 + 532 | 0) >> 0] = $87 >>> 24 | 0;
     $88 = HEAPU8[($2 + 195 | 0) >> 0] | 0 | ((HEAPU8[($2 + 196 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 197 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 198 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($2 + 532 | 0) >> 0] = $88;
     HEAP8[($2 + 533 | 0) >> 0] = $88 >>> 8 | 0;
     HEAP8[($2 + 534 | 0) >> 0] = $88 >>> 16 | 0;
     HEAP8[($2 + 535 | 0) >> 0] = $88 >>> 24 | 0;
     HEAP32[($2 + 576 | 0) >> 2] = $3;
     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($2 + 88 | 0 | 0, $2 + 528 | 0 | 0, 1050436 | 0, 12 | 0);
     $3 = HEAPU8[($2 + 88 | 0) >> 0] | 0;
     if (($3 | 0) != (19 | 0)) {
      break label$2
     }
    }
    i64toi32_i32$2 = $2;
    i64toi32_i32$3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $482 = i64toi32_i32$3;
    i64toi32_i32$3 = $0;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = $482;
    HEAP32[(i64toi32_i32$3 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[(i64toi32_i32$3 + 12 | 0) >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
    $11 = 0;
    break label$1;
   }
   $11 = 1;
   memcpy($2 + 25 | 0 | 0, $2 + 88 | 0 | 1 | 0 | 0, 63 | 0) | 0;
   HEAP8[($0 + 8 | 0) >> 0] = $3;
   memcpy($0 + 9 | 0 | 0, $2 + 25 | 0 | 0, 63 | 0) | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h07097b699c9c8f63($2 + 8 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__ha1b43c51acf8124f($2 + 8 | 0 | 0);
  }
  HEAP32[$0 >> 2] = $11;
  global$0 = $2 + 736 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__MIRToStakeCredentials___deserialize__h4513cde789c99a1f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $18 = 0, $3 = 0, $18$hi = 0, $20 = 0, $20$hi = 0, $19 = 0, $19$hi = 0, $16 = 0, $21$hi = 0, $5 = 0, $17 = 0, $21 = 0, $69 = 0, $70 = 0, $71 = 0, $72 = 0, $73 = 0, $74 = 0, $75 = 0, $76 = 0, $77 = 0, $78 = 0, $4 = 0, $7 = 0, $6 = 0, $79 = 0, $80 = 0, $81 = 0, $82 = 0, $83 = 0, $84 = 0, $85 = 0, $86 = 0, $87 = 0, $88 = 0, $89 = 0, $90 = 0, $91 = 0, $92 = 0, $8 = 0, $9 = 0, $10 = 0, $11 = 0, $12 = 0, $13 = 0, $14 = 0, $15 = 0, $128 = 0, $144 = 0, $149 = 0, $154 = 0, $211 = 0, $216 = 0, $226 = 0, $230 = 0, $232 = 0, $232$hi = 0, $235 = 0, $235$hi = 0, $239$hi = 0, $241$hi = 0, $259 = 0, $264 = 0, $273 = 0, $277 = 0, $279 = 0, $279$hi = 0, $281$hi = 0, $314 = 0, $334 = 0, $340 = 0, $345 = 0, $355 = 0, $361 = 0, $365 = 0, $393 = 0, $397 = 0, $403 = 0, $409 = 0, $422 = 0, $425 = 0, $22 = 0, $22$hi = 0, $23 = 0, $23$hi = 0;
  $2 = global$0 - 288 | 0;
  global$0 = $2;
  std__thread__local__LocalKey_T___with__h4cd07b14a44a727e($2 + 48 | 0 | 0, 1060968 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  $18$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 56 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 60 | 0) >> 2] | 0;
  $19 = i64toi32_i32$1;
  $19$hi = i64toi32_i32$0;
  $3 = hashbrown__raw__generic__Group__static_empty__hc5a7932fe1bdb1f1() | 0;
  $4 = ($2 + 88 | 0) + 24 | 0;
  i64toi32_i32$1 = $4;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 108 | 0) >> 2] = $3;
  $5 = 0;
  HEAP32[($2 + 104 | 0) >> 2] = 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 120 | 0) >> 2] = 0;
  HEAP32[($2 + 124 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $19$hi;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 96 | 0) >> 2] = $19;
  HEAP32[($2 + 100 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $18$hi;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 88 | 0) >> 2] = $18;
  HEAP32[($2 + 92 | 0) >> 2] = i64toi32_i32$0;
  cbor_event__de__Deserializer_R___map__h7c2a4e830d885a05($2 + 176 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = ($2 + 176 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $20 = i64toi32_i32$0;
  $20$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 184 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 188 | 0) >> 2] | 0;
  $18 = i64toi32_i32$1;
  $18$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 176 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 180 | 0) >> 2] | 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
         break label$6
        }
        i64toi32_i32$2 = $20$hi;
        $6 = $20;
        label$7 : {
         i64toi32_i32$2 = $18$hi;
         i64toi32_i32$3 = $18;
         i64toi32_i32$1 = 0;
         i64toi32_i32$0 = 1;
         if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
          break label$7
         }
         if (!$6) {
          break label$2
         }
        }
        $7 = $2 + 144 | 0 | 1 | 0;
        $8 = $2 + 171 | 0;
        $9 = $2 + 204 | 0;
        $10 = $2 + 158 | 0;
        $11 = $2 + 191 | 0;
        $12 = $2 + 156 | 0;
        $13 = $2 + 189 | 0;
        $3 = $2 + 176 | 0 | 1 | 0;
        $14 = $3 + 3 | 0;
        $15 = ($2 + 176 | 0) + 16 | 0;
        $16 = 8;
        label$8 : {
         label$9 : {
          label$10 : {
           label$11 : while (1) {
            std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 40 | 0 | 0, $1 | 0);
            $17 = 2;
            $5 = 0;
            label$12 : {
             if (HEAP32[($2 + 44 | 0) >> 2] | 0) {
              break label$12
             }
             i64toi32_i32$3 = 0;
             $20 = 0;
             $20$hi = i64toi32_i32$3;
             $3 = 0;
             break label$4;
            }
            label$13 : {
             if ((($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[($2 + 40 | 0) >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) == (7 | 0)) {
              break label$13
             }
             $cardano_serialization_lib__address__StakeCredential_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__ha21a31a5230d4f02($2 + 176 | 0 | 0, $1 | 0);
             if ((HEAPU8[($2 + 176 | 0) >> 0] | 0 | 0) == (1 | 0)) {
              break label$10
             }
             i64toi32_i32$0 = $9;
             i64toi32_i32$3 = HEAPU16[i64toi32_i32$0 >> 1] | 0;
             i64toi32_i32$2 = 0;
             $79 = $8;
             HEAP8[$79 >> 0] = i64toi32_i32$3;
             HEAP8[($79 + 1 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
             i64toi32_i32$0 = $11;
             i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0;
             i64toi32_i32$3 = 0;
             HEAP8[$10 >> 0] = i64toi32_i32$2;
             i64toi32_i32$0 = $13;
             i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
             i64toi32_i32$2 = 0;
             HEAP16[$12 >> 1] = i64toi32_i32$3;
             HEAP32[($2 + 144 | 0) >> 2] = HEAPU8[$3 >> 0] | 0 | ((HEAPU8[($3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             $69 = $14;
             $70 = HEAPU8[$69 >> 0] | 0 | ((HEAPU8[($69 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($69 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($69 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             HEAP8[($2 + 147 | 0) >> 0] = $70;
             HEAP8[($2 + 148 | 0) >> 0] = $70 >>> 8 | 0;
             HEAP8[($2 + 149 | 0) >> 0] = $70 >>> 16 | 0;
             HEAP8[($2 + 150 | 0) >> 0] = $70 >>> 24 | 0;
             i64toi32_i32$0 = $2;
             i64toi32_i32$2 = HEAP32[($2 + 200 | 0) >> 2] | 0;
             i64toi32_i32$3 = 0;
             HEAP8[($2 + 167 | 0) >> 0] = i64toi32_i32$2;
             HEAP8[($2 + 168 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
             HEAP8[($2 + 169 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
             HEAP8[($2 + 170 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
             i64toi32_i32$0 = $2;
             i64toi32_i32$3 = HEAPU8[($2 + 185 | 0) >> 0] | 0 | ((HEAPU8[($2 + 186 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 187 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 188 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             i64toi32_i32$2 = 0;
             HEAP32[($2 + 152 | 0) >> 2] = i64toi32_i32$3;
             i64toi32_i32$0 = $2;
             i64toi32_i32$2 = HEAP32[($2 + 192 | 0) >> 2] | 0;
             i64toi32_i32$3 = HEAP32[($2 + 196 | 0) >> 2] | 0;
             $128 = i64toi32_i32$2;
             i64toi32_i32$2 = $2;
             $71 = $128;
             HEAP8[($2 + 159 | 0) >> 0] = $71;
             HEAP8[($2 + 160 | 0) >> 0] = $71 >>> 8 | 0;
             HEAP8[($2 + 161 | 0) >> 0] = $71 >>> 16 | 0;
             HEAP8[($2 + 162 | 0) >> 0] = $71 >>> 24 | 0;
             HEAP8[($2 + 163 | 0) >> 0] = i64toi32_i32$3;
             HEAP8[($2 + 164 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
             HEAP8[($2 + 165 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
             HEAP8[($2 + 166 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
             HEAP8[($2 + 151 | 0) >> 0] = HEAPU8[($2 + 184 | 0) >> 0] | 0;
             $cardano_serialization_lib__utils__Int_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h5b6b41ff800f0b26($2 + 176 | 0 | 0, $1 | 0);
             i64toi32_i32$0 = $15;
             i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
             i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
             $19 = i64toi32_i32$3;
             $19$hi = i64toi32_i32$2;
             i64toi32_i32$0 = $2;
             i64toi32_i32$2 = HEAP32[($2 + 184 | 0) >> 2] | 0;
             i64toi32_i32$3 = HEAP32[($2 + 188 | 0) >> 2] | 0;
             $21 = i64toi32_i32$2;
             $21$hi = i64toi32_i32$3;
             i64toi32_i32$0 = $2;
             i64toi32_i32$3 = HEAP32[($2 + 176 | 0) >> 2] | 0;
             i64toi32_i32$2 = HEAP32[($2 + 180 | 0) >> 2] | 0;
             i64toi32_i32$0 = i64toi32_i32$3;
             i64toi32_i32$3 = 0;
             i64toi32_i32$1 = 1;
             if ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) | 0) {
              break label$9
             }
             i64toi32_i32$1 = $7;
             i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             $144 = i64toi32_i32$0;
             i64toi32_i32$0 = $3;
             $72 = $144;
             HEAP8[i64toi32_i32$0 >> 0] = $72;
             HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $72 >>> 8 | 0;
             HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $72 >>> 16 | 0;
             HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $72 >>> 24 | 0;
             HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$2;
             HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
             HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
             HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
             i64toi32_i32$1 = i64toi32_i32$1 + 8 | 0;
             i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             $149 = i64toi32_i32$2;
             i64toi32_i32$2 = $3 + 8 | 0;
             $73 = $149;
             HEAP8[i64toi32_i32$2 >> 0] = $73;
             HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $73 >>> 8 | 0;
             HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $73 >>> 16 | 0;
             HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $73 >>> 24 | 0;
             HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$0;
             HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
             HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
             HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
             i64toi32_i32$1 = $7 + 16 | 0;
             i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             $154 = i64toi32_i32$0;
             i64toi32_i32$0 = $3 + 16 | 0;
             $74 = $154;
             HEAP8[i64toi32_i32$0 >> 0] = $74;
             HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $74 >>> 8 | 0;
             HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $74 >>> 16 | 0;
             HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $74 >>> 24 | 0;
             HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$2;
             HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
             HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
             HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
             $75 = $7 + 24 | 0;
             $76 = $3 + 24 | 0;
             $77 = HEAPU8[$75 >> 0] | 0 | ((HEAPU8[($75 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($75 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($75 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             HEAP8[$76 >> 0] = $77;
             HEAP8[($76 + 1 | 0) >> 0] = $77 >>> 8 | 0;
             HEAP8[($76 + 2 | 0) >> 0] = $77 >>> 16 | 0;
             HEAP8[($76 + 3 | 0) >> 0] = $77 >>> 24 | 0;
             HEAP8[($2 + 176 | 0) >> 0] = HEAPU8[($2 + 144 | 0) >> 0] | 0;
             i64toi32_i32$2 = $21$hi;
             i64toi32_i32$2 = $19$hi;
             i64toi32_i32$2 = $21$hi;
             i64toi32_i32$0 = $19$hi;
             linked_hash_map__LinkedHashMap_K_2cV_2cS___insert__h3e59fdce083c9794($2 + 16 | 0 | 0, $2 + 88 | 0 | 0, $2 + 176 | 0 | 0, $21 | 0, i64toi32_i32$2 | 0, $19 | 0, i64toi32_i32$0 | 0);
             i64toi32_i32$1 = $2;
             i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
             i64toi32_i32$2 = HEAP32[($2 + 20 | 0) >> 2] | 0;
             i64toi32_i32$1 = i64toi32_i32$0;
             i64toi32_i32$0 = 0;
             i64toi32_i32$3 = 1;
             if ((i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) | 0) {
              break label$8
             }
             i64toi32_i32$1 = $18$hi;
             i64toi32_i32$3 = $18;
             i64toi32_i32$2 = 0;
             i64toi32_i32$0 = 1;
             if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$2 | 0) | 0) {
              continue label$11
             }
             if ((HEAP32[($2 + 116 | 0) >> 2] | 0) >>> 0 < $6 >>> 0) {
              continue label$11
             }
             break label$2;
            }
            break label$11;
           };
           cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 176 | 0 | 0, $1 | 0);
           i64toi32_i32$0 = ($2 + 176 | 0) + 16 | 0;
           i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $20 = i64toi32_i32$3;
           $20$hi = i64toi32_i32$1;
           i64toi32_i32$0 = $2;
           i64toi32_i32$1 = HEAP32[($2 + 184 | 0) >> 2] | 0;
           i64toi32_i32$3 = HEAP32[($2 + 188 | 0) >> 2] | 0;
           $18 = i64toi32_i32$1;
           $18$hi = i64toi32_i32$3;
           i64toi32_i32$0 = $2;
           i64toi32_i32$3 = HEAP32[($2 + 176 | 0) >> 2] | 0;
           i64toi32_i32$1 = HEAP32[($2 + 180 | 0) >> 2] | 0;
           i64toi32_i32$0 = i64toi32_i32$3;
           i64toi32_i32$3 = 0;
           i64toi32_i32$2 = 1;
           if ((i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) | 0) {
            break label$5
           }
           i64toi32_i32$0 = $20$hi;
           i64toi32_i32$1 = $2 + 136 | 0;
           HEAP32[i64toi32_i32$1 >> 2] = $20;
           HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
           i64toi32_i32$0 = $18$hi;
           i64toi32_i32$1 = $2;
           HEAP32[($2 + 128 | 0) >> 2] = $18;
           HEAP32[($2 + 132 | 0) >> 2] = i64toi32_i32$0;
           if (($18 & 255 | 0 | 0) == (5 | 0)) {
            break label$2
           }
           HEAP32[($2 + 176 | 0) >> 2] = 0;
           core__panicking__assert_failed__h96d8431cc974b591(0 | 0, $2 + 128 | 0 | 0, 1050312 | 0, $2 + 176 | 0 | 0, 1051308 | 0);
           abort();
          }
          i64toi32_i32$2 = $2 + 216 | 0;
          i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
          $211 = i64toi32_i32$0;
          i64toi32_i32$0 = ($2 + 64 | 0) + 8 | 0;
          HEAP32[i64toi32_i32$0 >> 2] = $211;
          HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
          i64toi32_i32$2 = $2 + 224 | 0;
          i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
          $216 = i64toi32_i32$1;
          i64toi32_i32$1 = $2 + 80 | 0;
          HEAP32[i64toi32_i32$1 >> 2] = $216;
          HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
          HEAP32[(($2 + 128 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 244 | 0) >> 2] | 0;
          i64toi32_i32$2 = $2 + 208 | 0;
          i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
          $226 = i64toi32_i32$0;
          i64toi32_i32$0 = $2;
          HEAP32[($2 + 64 | 0) >> 2] = $226;
          HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$1;
          i64toi32_i32$2 = $2 + 236 | 0;
          i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
          $230 = i64toi32_i32$1;
          i64toi32_i32$1 = $2;
          HEAP32[($2 + 128 | 0) >> 2] = $230;
          HEAP32[($2 + 132 | 0) >> 2] = i64toi32_i32$0;
          i64toi32_i32$2 = $2;
          i64toi32_i32$0 = HEAPU8[($2 + 185 | 0) >> 0] | 0 | ((HEAPU8[($2 + 186 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 187 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 188 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          i64toi32_i32$1 = 0;
          $232 = i64toi32_i32$0;
          $232$hi = i64toi32_i32$1;
          i64toi32_i32$2 = $2 + 189 | 0;
          i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
          i64toi32_i32$0 = 0;
          $235 = i64toi32_i32$1;
          $235$hi = i64toi32_i32$0;
          i64toi32_i32$2 = $2 + 191 | 0;
          i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
          i64toi32_i32$1 = 0;
          i64toi32_i32$2 = i64toi32_i32$0;
          i64toi32_i32$0 = 0;
          i64toi32_i32$3 = 16;
          i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
          if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
           i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
           $80 = 0;
          } else {
           i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
           $80 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
          }
          $239$hi = i64toi32_i32$0;
          i64toi32_i32$0 = $235$hi;
          i64toi32_i32$1 = $235;
          i64toi32_i32$2 = $239$hi;
          i64toi32_i32$3 = $80;
          i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
          i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
          i64toi32_i32$1 = 0;
          i64toi32_i32$3 = 32;
          i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
          if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
           i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
           $81 = 0;
          } else {
           i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
           $81 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
          }
          $241$hi = i64toi32_i32$1;
          i64toi32_i32$1 = $232$hi;
          i64toi32_i32$2 = $232;
          i64toi32_i32$0 = $241$hi;
          i64toi32_i32$3 = $81;
          i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
          $18 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
          $18$hi = i64toi32_i32$0;
          $5 = HEAP32[($2 + 232 | 0) >> 2] | 0;
          i64toi32_i32$1 = $2;
          i64toi32_i32$0 = HEAP32[($2 + 200 | 0) >> 2] | 0;
          i64toi32_i32$2 = HEAP32[($2 + 204 | 0) >> 2] | 0;
          $20 = i64toi32_i32$0;
          $20$hi = i64toi32_i32$2;
          $3 = HEAP32[($2 + 196 | 0) >> 2] | 0;
          $16 = HEAP32[($2 + 192 | 0) >> 2] | 0;
          $17 = HEAPU8[($2 + 184 | 0) >> 0] | 0;
          break label$3;
         }
         i64toi32_i32$1 = $2 + 216 | 0;
         i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
         $259 = i64toi32_i32$2;
         i64toi32_i32$2 = ($2 + 64 | 0) + 8 | 0;
         HEAP32[i64toi32_i32$2 >> 2] = $259;
         HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$1 = $2 + 224 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
         $264 = i64toi32_i32$0;
         i64toi32_i32$0 = $2 + 80 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $264;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
         HEAP32[(($2 + 128 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 244 | 0) >> 2] | 0;
         i64toi32_i32$1 = $2;
         i64toi32_i32$2 = HEAP32[($2 + 236 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($2 + 240 | 0) >> 2] | 0;
         $273 = i64toi32_i32$2;
         i64toi32_i32$2 = $2;
         HEAP32[($2 + 128 | 0) >> 2] = $273;
         HEAP32[($2 + 132 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$1 = $2 + 208 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
         $277 = i64toi32_i32$0;
         i64toi32_i32$0 = $2;
         HEAP32[($2 + 64 | 0) >> 2] = $277;
         HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$2;
         i64toi32_i32$2 = $21$hi;
         i64toi32_i32$1 = $21;
         i64toi32_i32$0 = 0;
         i64toi32_i32$3 = 8;
         i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
          i64toi32_i32$0 = 0;
          $82 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
         } else {
          i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
          $82 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
         }
         $279 = $82;
         $279$hi = i64toi32_i32$0;
         i64toi32_i32$0 = $19$hi;
         i64toi32_i32$2 = $19;
         i64toi32_i32$1 = 0;
         i64toi32_i32$3 = 56;
         i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
          i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
          $83 = 0;
         } else {
          i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
          $83 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
         }
         $281$hi = i64toi32_i32$1;
         i64toi32_i32$1 = $279$hi;
         i64toi32_i32$0 = $279;
         i64toi32_i32$2 = $281$hi;
         i64toi32_i32$3 = $83;
         i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
         $18 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
         $18$hi = i64toi32_i32$2;
         i64toi32_i32$2 = $19$hi;
         i64toi32_i32$1 = $19;
         i64toi32_i32$0 = 0;
         i64toi32_i32$3 = 32;
         i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
          i64toi32_i32$0 = 0;
          $84 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
         } else {
          i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
          $84 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
         }
         $3 = $84;
         i64toi32_i32$2 = $2 + 200 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $20 = i64toi32_i32$0;
         $20$hi = i64toi32_i32$1;
         $5 = HEAP32[($2 + 232 | 0) >> 2] | 0;
         i64toi32_i32$1 = $21$hi;
         $17 = $21;
         i64toi32_i32$1 = $19$hi;
         $16 = $19;
         break label$3;
        }
        cardano_serialization_lib__address__StakeCredential__to_bytes__h1e8f5a9dedbab360($2 + 176 | 0 | 0, $2 + 144 | 0 | 0);
        hex__encode__ha65497b593c9e23a($2 + 64 | 0 | 0, $2 + 176 | 0 | 0);
        core__fmt__ArgumentV1__new__h56a0e5bff2bd9085($2 + 8 | 0 | 0, $2 + 64 | 0 | 0, 2 | 0);
        HEAP32[($2 + 196 | 0) >> 2] = 1;
        i64toi32_i32$0 = $2;
        i64toi32_i32$1 = 0;
        HEAP32[($2 + 180 | 0) >> 2] = 2;
        HEAP32[($2 + 184 | 0) >> 2] = i64toi32_i32$1;
        HEAP32[($2 + 176 | 0) >> 2] = 1051348;
        i64toi32_i32$2 = $2;
        i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
        $314 = i64toi32_i32$1;
        i64toi32_i32$1 = $2;
        HEAP32[($2 + 248 | 0) >> 2] = $314;
        HEAP32[($2 + 252 | 0) >> 2] = i64toi32_i32$0;
        HEAP32[($2 + 192 | 0) >> 2] = $2 + 248 | 0;
        alloc__fmt__format__h6e9e003a52c07309($2 + 128 | 0 | 0, $2 + 176 | 0 | 0);
        $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 64 | 0 | 0);
        $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 64 | 0 | 0);
        $3 = HEAP32[($2 + 128 | 0) >> 2] | 0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 132 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 136 | 0) >> 2] | 0;
        $20 = i64toi32_i32$0;
        $20$hi = i64toi32_i32$1;
        $17 = 4;
        $16 = 0;
        $5 = 0;
        break label$3;
       }
       i64toi32_i32$2 = $2 + 208 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $334 = i64toi32_i32$1;
       i64toi32_i32$1 = $2 + 72 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $334;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = $2 + 216 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $340 = i64toi32_i32$0;
       i64toi32_i32$0 = ($2 + 64 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $340;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = ($2 + 176 | 0) + 24 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $345 = i64toi32_i32$1;
       i64toi32_i32$1 = $2;
       HEAP32[($2 + 64 | 0) >> 2] = $345;
       HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$0 = $18$hi;
       i64toi32_i32$2 = $18;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = 0;
        $85 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
        $85 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
       }
       $3 = $85;
       i64toi32_i32$1 = $18$hi;
       $16 = $18;
       $17 = 2;
       break label$4;
      }
      i64toi32_i32$0 = $2 + 208 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
      $355 = i64toi32_i32$1;
      i64toi32_i32$1 = $2 + 72 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $355;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$0 = $2 + 216 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
      $361 = i64toi32_i32$2;
      i64toi32_i32$2 = ($2 + 64 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $361;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$0 = $2 + 200 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
      $365 = i64toi32_i32$1;
      i64toi32_i32$1 = $2;
      HEAP32[($2 + 64 | 0) >> 2] = $365;
      HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$2 = $18$hi;
      i64toi32_i32$0 = $18;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 32;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$1 = 0;
       $86 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
      } else {
       i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
       $86 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
      }
      $3 = $86;
      i64toi32_i32$1 = $18$hi;
      $16 = $18;
     }
    }
    $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__hddd2979ebb13db27($2 + 88 | 0 | 0);
    label$14 : {
     if (!(HEAP32[($2 + 104 | 0) >> 2] | 0)) {
      break label$14
     }
     hashbrown__raw__RawTable_T_2cA___free_buckets__h78477753a901af0e(($2 + 88 | 0) + 16 | 0 | 0);
    }
    i64toi32_i32$1 = $20$hi;
    i64toi32_i32$0 = ($2 + 176 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $20;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($2 + 188 | 0) >> 2] = $3;
    HEAP32[(($2 + 176 | 0) + 8 | 0) >> 2] = $16;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[($2 + 64 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 68 | 0) >> 2] | 0;
    $393 = i64toi32_i32$1;
    i64toi32_i32$1 = $2 + 200 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $393;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[($2 + 128 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 132 | 0) >> 2] | 0;
    $397 = i64toi32_i32$0;
    i64toi32_i32$0 = $2 + 228 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $397;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = ($2 + 64 | 0) + 8 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $403 = i64toi32_i32$1;
    i64toi32_i32$1 = $2 + 208 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $403;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = ($2 + 64 | 0) + 16 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $409 = i64toi32_i32$0;
    i64toi32_i32$0 = $2 + 216 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $409;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($2 + 236 | 0) >> 2] = HEAP32[(($2 + 128 | 0) + 8 | 0) >> 2] | 0;
    HEAP8[($2 + 176 | 0) >> 0] = $17;
    HEAP32[($2 + 224 | 0) >> 2] = $5;
    i64toi32_i32$1 = $18$hi;
    HEAP8[($2 + 177 | 0) >> 0] = $18;
    HEAP8[($2 + 178 | 0) >> 0] = $18 >>> 8 | 0;
    HEAP8[($2 + 179 | 0) >> 0] = $18 >>> 16 | 0;
    HEAP8[($2 + 180 | 0) >> 0] = $18 >>> 24 | 0;
    $422 = $2;
    i64toi32_i32$2 = $18;
    i64toi32_i32$0 = 0;
    i64toi32_i32$3 = 48;
    i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$0 = 0;
     $87 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
    } else {
     i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
     $87 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
    }
    HEAP8[($422 + 183 | 0) >> 0] = $87;
    $425 = $2;
    i64toi32_i32$0 = $18$hi;
    i64toi32_i32$1 = $18;
    i64toi32_i32$2 = 0;
    i64toi32_i32$3 = 32;
    i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$2 = 0;
     $88 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
    } else {
     i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
     $88 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
    }
    $89 = $425;
    $90 = $88;
    HEAP8[($89 + 181 | 0) >> 0] = $90;
    HEAP8[($89 + 182 | 0) >> 0] = $90 >>> 8 | 0;
    cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 176 | 0 | 0, 1051364 | 0, 21 | 0);
    i64toi32_i32$2 = 0;
    $18 = 1;
    $18$hi = i64toi32_i32$2;
    break label$1;
   }
   i64toi32_i32$0 = $4 + 8 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $18 = i64toi32_i32$2;
   $18$hi = i64toi32_i32$1;
   i64toi32_i32$2 = ($2 + 64 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $18;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$0 = $4;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $19 = i64toi32_i32$1;
   $19$hi = i64toi32_i32$2;
   i64toi32_i32$1 = $2;
   HEAP32[($2 + 64 | 0) >> 2] = $19;
   HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$2;
   $3 = HEAPU8[($2 + 88 | 0) >> 0] | 0;
   i64toi32_i32$0 = $2;
   i64toi32_i32$2 = HEAP32[($2 + 96 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 100 | 0) >> 2] | 0;
   $21 = i64toi32_i32$2;
   $21$hi = i64toi32_i32$1;
   i64toi32_i32$0 = $2;
   i64toi32_i32$1 = HEAP32[($2 + 104 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($2 + 108 | 0) >> 2] | 0;
   $20 = i64toi32_i32$1;
   $20$hi = i64toi32_i32$2;
   i64toi32_i32$0 = $2;
   i64toi32_i32$2 = HEAPU8[($2 + 89 | 0) >> 0] | 0 | ((HEAPU8[($2 + 90 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 91 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 92 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = 0;
   $22 = i64toi32_i32$2;
   $22$hi = i64toi32_i32$1;
   i64toi32_i32$0 = $2;
   i64toi32_i32$1 = HEAPU8[($2 + 93 | 0) >> 0] | 0 | ((HEAPU8[($2 + 94 | 0) >> 0] | 0) << 8 | 0) | 0;
   i64toi32_i32$2 = 0;
   $23 = i64toi32_i32$1;
   $23$hi = i64toi32_i32$2;
   i64toi32_i32$0 = $2;
   i64toi32_i32$2 = HEAPU8[($2 + 95 | 0) >> 0] | 0;
   i64toi32_i32$1 = 0;
   HEAP8[($0 + 15 | 0) >> 0] = i64toi32_i32$2;
   i64toi32_i32$1 = $23$hi;
   $91 = $0 + 13 | 0;
   $92 = $23;
   HEAP8[$91 >> 0] = $92;
   HEAP8[($91 + 1 | 0) >> 0] = $92 >>> 8 | 0;
   i64toi32_i32$1 = $22$hi;
   $78 = $22;
   HEAP8[($0 + 9 | 0) >> 0] = $78;
   HEAP8[($0 + 10 | 0) >> 0] = $78 >>> 8 | 0;
   HEAP8[($0 + 11 | 0) >> 0] = $78 >>> 16 | 0;
   HEAP8[($0 + 12 | 0) >> 0] = $78 >>> 24 | 0;
   i64toi32_i32$1 = $20$hi;
   i64toi32_i32$2 = $0 + 24 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $20;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $21$hi;
   i64toi32_i32$2 = $0 + 16 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $21;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP8[($0 + 8 | 0) >> 0] = $3;
   i64toi32_i32$1 = $19$hi;
   i64toi32_i32$2 = $0 + 32 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $19;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $18$hi;
   i64toi32_i32$2 = $0 + 40 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $18;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = 0;
   $18 = 0;
   $18$hi = i64toi32_i32$1;
  }
  i64toi32_i32$1 = $18$hi;
  i64toi32_i32$2 = $0;
  HEAP32[i64toi32_i32$2 >> 2] = $18;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $2 + 288 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__AuxiliaryDataSet___deserialize__h00174ab6053c7df7($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $18 = 0, $18$hi = 0, $19 = 0, $19$hi = 0, $3 = 0, $12 = 0, $14 = 0, $15 = 0, $61 = 0, $62 = 0, $63 = 0, $64 = 0, $65 = 0, $66 = 0, $67 = 0, $68 = 0, $69 = 0, $70 = 0, $71 = 0, $72 = 0, $73 = 0, $74 = 0, $75 = 0, $76 = 0, $77 = 0, $6 = 0, $9 = 0, $4 = 0, $8 = 0, $10 = 0, $16 = 0, $20 = 0, $20$hi = 0, $17 = 0, $5 = 0, $7 = 0, $11 = 0, $13 = 0, $103 = 0, $110 = 0, $126 = 0, $129 = 0, $146 = 0, $152 = 0, $167 = 0, $170 = 0, $186 = 0, $190 = 0, $194 = 0, $199 = 0, $254 = 0, $260 = 0, $277 = 0, $281 = 0, $302 = 0, $309 = 0, $325 = 0, $328 = 0, $341 = 0, $347 = 0, $357 = 0, $371 = 0, $377 = 0, $382 = 0, $387 = 0, $393 = 0, $397 = 0, $409 = 0, $413 = 0, $419 = 0, $425 = 0;
  $2 = global$0 - 448 | 0;
  global$0 = $2;
  std__thread__local__LocalKey_T___with__h4cd07b14a44a727e($2 + 8 | 0 | 0, 1060968 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  $18$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $19 = i64toi32_i32$1;
  $19$hi = i64toi32_i32$0;
  $3 = hashbrown__raw__generic__Group__static_empty__hc5a7932fe1bdb1f1() | 0;
  i64toi32_i32$1 = ($2 + 24 | 0) + 24 | 0;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 44 | 0) >> 2] = $3;
  $3 = 0;
  HEAP32[($2 + 40 | 0) >> 2] = 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 56 | 0) >> 2] = 0;
  HEAP32[($2 + 60 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $19$hi;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $19;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $18$hi;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $18;
  HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$0;
  cbor_event__de__Deserializer_R___map__h7c2a4e830d885a05($2 + 312 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = ($2 + 312 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  $18$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 320 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 324 | 0) >> 2] | 0;
  $19 = i64toi32_i32$1;
  $19$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 312 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 316 | 0) >> 2] | 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
         break label$6
        }
        i64toi32_i32$2 = $18$hi;
        $4 = $18;
        label$7 : {
         i64toi32_i32$2 = $19$hi;
         i64toi32_i32$3 = $19;
         i64toi32_i32$1 = 0;
         i64toi32_i32$0 = 1;
         if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
          break label$7
         }
         if (!$4) {
          break label$3
         }
        }
        $5 = $2 + 436 | 0;
        $6 = $2 + 408 | 0;
        $7 = $2 + 384 | 0 | 1 | 0;
        $8 = $2 + 372 | 0;
        $9 = $2 + 344 | 0;
        $10 = $2 + 321 | 0;
        $11 = $10 + 3 | 0;
        label$8 : {
         label$9 : {
          label$10 : {
           label$11 : {
            label$12 : while (1) {
             std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 | 0, $1 | 0);
             $3 = 0;
             $12 = 2;
             label$13 : {
              if (HEAP32[($2 + 4 | 0) >> 2] | 0) {
               break label$13
              }
              i64toi32_i32$3 = 0;
              $19 = 8;
              $19$hi = i64toi32_i32$3;
              i64toi32_i32$3 = 0;
              $18 = 0;
              $18$hi = i64toi32_i32$3;
              break label$4;
             }
             label$14 : {
              if ((($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[$2 >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) == (7 | 0)) {
               break label$14
              }
              $T_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hf422f9333a8bbafa($2 + 312 | 0 | 0, $1 | 0);
              if ((HEAP32[($2 + 312 | 0) >> 2] | 0 | 0) == (1 | 0)) {
               break label$11
              }
              $13 = HEAP32[($2 + 316 | 0) >> 2] | 0;
              $cardano_serialization_lib__metadata__AuxiliaryData_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hca865c989495a465($2 + 312 | 0 | 0, $1 | 0);
              $14 = ($2 + 384 | 0) + 8 | 0;
              i64toi32_i32$0 = $9 + 8 | 0;
              i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              $103 = i64toi32_i32$3;
              i64toi32_i32$3 = $14;
              HEAP32[i64toi32_i32$3 >> 2] = $103;
              HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
              $15 = ($2 + 384 | 0) + 16 | 0;
              i64toi32_i32$0 = $9 + 16 | 0;
              i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              i64toi32_i32$3 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              $110 = i64toi32_i32$2;
              i64toi32_i32$2 = $15;
              HEAP32[i64toi32_i32$2 >> 2] = $110;
              HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
              $16 = ($2 + 288 | 0) + 8 | 0;
              HEAP32[$16 >> 2] = HEAP32[($8 + 8 | 0) >> 2] | 0;
              $62 = $10;
              HEAP32[($2 + 304 | 0) >> 2] = HEAPU8[$62 >> 0] | 0 | ((HEAPU8[($62 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($62 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($62 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              $63 = $11;
              $64 = HEAPU8[$63 >> 0] | 0 | ((HEAPU8[($63 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($63 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($63 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              HEAP8[($2 + 307 | 0) >> 0] = $64;
              HEAP8[($2 + 308 | 0) >> 0] = $64 >>> 8 | 0;
              HEAP8[($2 + 309 | 0) >> 0] = $64 >>> 16 | 0;
              HEAP8[($2 + 310 | 0) >> 0] = $64 >>> 24 | 0;
              i64toi32_i32$0 = $9;
              i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              $126 = i64toi32_i32$3;
              i64toi32_i32$3 = $2;
              HEAP32[($2 + 384 | 0) >> 2] = $126;
              HEAP32[($2 + 388 | 0) >> 2] = i64toi32_i32$2;
              i64toi32_i32$0 = $8;
              i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
              i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
              $129 = i64toi32_i32$2;
              i64toi32_i32$2 = $2;
              HEAP32[($2 + 288 | 0) >> 2] = $129;
              HEAP32[($2 + 292 | 0) >> 2] = i64toi32_i32$3;
              $12 = HEAPU8[($2 + 320 | 0) >> 0] | 0;
              i64toi32_i32$0 = $2;
              i64toi32_i32$3 = HEAP32[($2 + 328 | 0) >> 2] | 0;
              i64toi32_i32$2 = HEAP32[($2 + 332 | 0) >> 2] | 0;
              $20 = i64toi32_i32$3;
              $20$hi = i64toi32_i32$2;
              i64toi32_i32$0 = $2;
              i64toi32_i32$2 = HEAP32[($2 + 336 | 0) >> 2] | 0;
              i64toi32_i32$3 = HEAP32[($2 + 340 | 0) >> 2] | 0;
              $18 = i64toi32_i32$2;
              $18$hi = i64toi32_i32$3;
              $3 = HEAP32[($2 + 368 | 0) >> 2] | 0;
              i64toi32_i32$0 = $2;
              i64toi32_i32$3 = HEAP32[($2 + 312 | 0) >> 2] | 0;
              i64toi32_i32$2 = HEAP32[($2 + 316 | 0) >> 2] | 0;
              i64toi32_i32$0 = i64toi32_i32$3;
              i64toi32_i32$3 = 0;
              i64toi32_i32$1 = 1;
              if ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) | 0) {
               break label$10
              }
              $17 = ($2 + 256 | 0) + 8 | 0;
              i64toi32_i32$1 = $14;
              i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
              i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
              $146 = i64toi32_i32$0;
              i64toi32_i32$0 = $17;
              HEAP32[i64toi32_i32$0 >> 2] = $146;
              HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
              $14 = ($2 + 256 | 0) + 16 | 0;
              i64toi32_i32$1 = $15;
              i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
              i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
              $152 = i64toi32_i32$2;
              i64toi32_i32$2 = $14;
              HEAP32[i64toi32_i32$2 >> 2] = $152;
              HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
              $15 = ($2 + 240 | 0) + 8 | 0;
              HEAP32[$15 >> 2] = HEAP32[$16 >> 2] | 0;
              $65 = HEAPU8[($2 + 307 | 0) >> 0] | 0 | ((HEAPU8[($2 + 308 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 309 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 310 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              HEAP8[($2 + 283 | 0) >> 0] = $65;
              HEAP8[($2 + 284 | 0) >> 0] = $65 >>> 8 | 0;
              HEAP8[($2 + 285 | 0) >> 0] = $65 >>> 16 | 0;
              HEAP8[($2 + 286 | 0) >> 0] = $65 >>> 24 | 0;
              HEAP32[($2 + 280 | 0) >> 2] = HEAP32[($2 + 304 | 0) >> 2] | 0;
              i64toi32_i32$1 = $2;
              i64toi32_i32$0 = HEAP32[($2 + 384 | 0) >> 2] | 0;
              i64toi32_i32$2 = HEAP32[($2 + 388 | 0) >> 2] | 0;
              $167 = i64toi32_i32$0;
              i64toi32_i32$0 = $2;
              HEAP32[($2 + 256 | 0) >> 2] = $167;
              HEAP32[($2 + 260 | 0) >> 2] = i64toi32_i32$2;
              i64toi32_i32$1 = $2;
              i64toi32_i32$2 = HEAP32[($2 + 288 | 0) >> 2] | 0;
              i64toi32_i32$0 = HEAP32[($2 + 292 | 0) >> 2] | 0;
              $170 = i64toi32_i32$2;
              i64toi32_i32$2 = $2;
              HEAP32[($2 + 240 | 0) >> 2] = $170;
              HEAP32[($2 + 244 | 0) >> 2] = i64toi32_i32$0;
              HEAP8[($2 + 384 | 0) >> 0] = $12;
              $61 = $7;
              $66 = HEAP32[($2 + 280 | 0) >> 2] | 0;
              HEAP8[$61 >> 0] = $66;
              HEAP8[($61 + 1 | 0) >> 0] = $66 >>> 8 | 0;
              HEAP8[($61 + 2 | 0) >> 0] = $66 >>> 16 | 0;
              HEAP8[($61 + 3 | 0) >> 0] = $66 >>> 24 | 0;
              $67 = $61 + 3 | 0;
              $68 = HEAPU8[($2 + 283 | 0) >> 0] | 0 | ((HEAPU8[($2 + 284 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 285 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 286 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              HEAP8[$67 >> 0] = $68;
              HEAP8[($67 + 1 | 0) >> 0] = $68 >>> 8 | 0;
              HEAP8[($67 + 2 | 0) >> 0] = $68 >>> 16 | 0;
              HEAP8[($67 + 3 | 0) >> 0] = $68 >>> 24 | 0;
              i64toi32_i32$0 = $18$hi;
              i64toi32_i32$2 = $2;
              HEAP32[($2 + 400 | 0) >> 2] = $18;
              HEAP32[($2 + 404 | 0) >> 2] = i64toi32_i32$0;
              i64toi32_i32$0 = $20$hi;
              i64toi32_i32$2 = $2;
              HEAP32[($2 + 392 | 0) >> 2] = $20;
              HEAP32[($2 + 396 | 0) >> 2] = i64toi32_i32$0;
              i64toi32_i32$1 = $2;
              i64toi32_i32$0 = HEAP32[($2 + 256 | 0) >> 2] | 0;
              i64toi32_i32$2 = HEAP32[($2 + 260 | 0) >> 2] | 0;
              $186 = i64toi32_i32$0;
              i64toi32_i32$0 = $6;
              $69 = $186;
              HEAP8[i64toi32_i32$0 >> 0] = $69;
              HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $69 >>> 8 | 0;
              HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $69 >>> 16 | 0;
              HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $69 >>> 24 | 0;
              HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$2;
              HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
              HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
              HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
              i64toi32_i32$1 = $17;
              i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
              i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
              $190 = i64toi32_i32$2;
              i64toi32_i32$2 = $6 + 8 | 0;
              $70 = $190;
              HEAP8[i64toi32_i32$2 >> 0] = $70;
              HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $70 >>> 8 | 0;
              HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $70 >>> 16 | 0;
              HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $70 >>> 24 | 0;
              HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$0;
              HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
              HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
              HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
              i64toi32_i32$1 = $14;
              i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
              i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
              $194 = i64toi32_i32$0;
              i64toi32_i32$0 = $6 + 16 | 0;
              $71 = $194;
              HEAP8[i64toi32_i32$0 >> 0] = $71;
              HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $71 >>> 8 | 0;
              HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $71 >>> 16 | 0;
              HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $71 >>> 24 | 0;
              HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$2;
              HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
              HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
              HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
              HEAP32[($2 + 432 | 0) >> 2] = $3;
              i64toi32_i32$1 = $2;
              i64toi32_i32$2 = HEAP32[($2 + 240 | 0) >> 2] | 0;
              i64toi32_i32$0 = HEAP32[($2 + 244 | 0) >> 2] | 0;
              $199 = i64toi32_i32$2;
              i64toi32_i32$2 = $5;
              HEAP32[i64toi32_i32$2 >> 2] = $199;
              HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
              HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = HEAP32[$15 >> 2] | 0;
              linked_hash_map__LinkedHashMap_K_2cV_2cS___insert__h37110d4804766b2f($2 + 312 | 0 | 0, $2 + 24 | 0 | 0, $13 | 0, $2 + 384 | 0 | 0);
              i64toi32_i32$1 = $2;
              i64toi32_i32$0 = HEAP32[($2 + 312 | 0) >> 2] | 0;
              i64toi32_i32$2 = HEAP32[($2 + 316 | 0) >> 2] | 0;
              $18 = i64toi32_i32$0;
              $18$hi = i64toi32_i32$2;
              core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__metadata__AuxiliaryData____ha98f6c5d89b7a772($2 + 312 | 0 | 0);
              i64toi32_i32$1 = i64toi32_i32$0;
              i64toi32_i32$0 = 0;
              i64toi32_i32$3 = 1;
              if ((i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) | 0) {
               break label$9
              }
              i64toi32_i32$1 = $19$hi;
              i64toi32_i32$3 = $19;
              i64toi32_i32$2 = 0;
              i64toi32_i32$0 = 1;
              if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$2 | 0) | 0) {
               continue label$12
              }
              if ((HEAP32[($2 + 52 | 0) >> 2] | 0) >>> 0 < $4 >>> 0) {
               continue label$12
              }
              break label$3;
             }
             break label$12;
            };
            cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 312 | 0 | 0, $1 | 0);
            i64toi32_i32$0 = ($2 + 312 | 0) + 16 | 0;
            i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
            i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
            $18 = i64toi32_i32$3;
            $18$hi = i64toi32_i32$1;
            i64toi32_i32$0 = $2;
            i64toi32_i32$1 = HEAP32[($2 + 320 | 0) >> 2] | 0;
            i64toi32_i32$3 = HEAP32[($2 + 324 | 0) >> 2] | 0;
            $19 = i64toi32_i32$1;
            $19$hi = i64toi32_i32$3;
            i64toi32_i32$0 = $2;
            i64toi32_i32$3 = HEAP32[($2 + 312 | 0) >> 2] | 0;
            i64toi32_i32$1 = HEAP32[($2 + 316 | 0) >> 2] | 0;
            i64toi32_i32$0 = i64toi32_i32$3;
            i64toi32_i32$3 = 0;
            i64toi32_i32$2 = 1;
            if ((i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) | 0) {
             break label$5
            }
            i64toi32_i32$0 = $18$hi;
            i64toi32_i32$1 = $2 + 264 | 0;
            HEAP32[i64toi32_i32$1 >> 2] = $18;
            HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
            i64toi32_i32$0 = $19$hi;
            i64toi32_i32$1 = $2;
            HEAP32[($2 + 256 | 0) >> 2] = $19;
            HEAP32[($2 + 260 | 0) >> 2] = i64toi32_i32$0;
            if (($19 & 255 | 0 | 0) == (5 | 0)) {
             break label$3
            }
            HEAP32[($2 + 312 | 0) >> 2] = 0;
            core__panicking__assert_failed__h96d8431cc974b591(0 | 0, $2 + 256 | 0 | 0, 1050312 | 0, $2 + 312 | 0 | 0, 1052640 | 0);
            abort();
           }
           i64toi32_i32$2 = $2 + 352 | 0;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
           $254 = i64toi32_i32$0;
           i64toi32_i32$0 = ($2 + 208 | 0) + 8 | 0;
           HEAP32[i64toi32_i32$0 >> 2] = $254;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
           i64toi32_i32$2 = $2 + 360 | 0;
           i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
           $260 = i64toi32_i32$1;
           i64toi32_i32$1 = ($2 + 208 | 0) + 16 | 0;
           HEAP32[i64toi32_i32$1 >> 2] = $260;
           HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
           HEAP32[(($2 + 192 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 380 | 0) >> 2] | 0;
           HEAP32[($2 + 232 | 0) >> 2] = HEAPU8[($2 + 321 | 0) >> 0] | 0 | ((HEAPU8[($2 + 322 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 323 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 324 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $72 = $2 + 324 | 0;
           $73 = HEAPU8[$72 >> 0] | 0 | ((HEAPU8[($72 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($72 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($72 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 235 | 0) >> 0] = $73;
           HEAP8[($2 + 236 | 0) >> 0] = $73 >>> 8 | 0;
           HEAP8[($2 + 237 | 0) >> 0] = $73 >>> 16 | 0;
           HEAP8[($2 + 238 | 0) >> 0] = $73 >>> 24 | 0;
           i64toi32_i32$2 = $2 + 344 | 0;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
           $277 = i64toi32_i32$0;
           i64toi32_i32$0 = $2;
           HEAP32[($2 + 208 | 0) >> 2] = $277;
           HEAP32[($2 + 212 | 0) >> 2] = i64toi32_i32$1;
           i64toi32_i32$2 = $2 + 372 | 0;
           i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
           $281 = i64toi32_i32$1;
           i64toi32_i32$1 = $2;
           HEAP32[($2 + 192 | 0) >> 2] = $281;
           HEAP32[($2 + 196 | 0) >> 2] = i64toi32_i32$0;
           $12 = HEAPU8[(($2 + 312 | 0) + 8 | 0) >> 0] | 0;
           i64toi32_i32$2 = ($2 + 312 | 0) + 16 | 0;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
           $19 = i64toi32_i32$0;
           $19$hi = i64toi32_i32$1;
           i64toi32_i32$2 = $2 + 336 | 0;
           i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
           $18 = i64toi32_i32$1;
           $18$hi = i64toi32_i32$0;
           $3 = HEAP32[($2 + 368 | 0) >> 2] | 0;
           break label$8;
          }
          i64toi32_i32$2 = ($2 + 384 | 0) + 8 | 0;
          i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
          $302 = i64toi32_i32$0;
          i64toi32_i32$0 = ($2 + 208 | 0) + 8 | 0;
          HEAP32[i64toi32_i32$0 >> 2] = $302;
          HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
          i64toi32_i32$2 = ($2 + 384 | 0) + 16 | 0;
          i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
          $309 = i64toi32_i32$1;
          i64toi32_i32$1 = ($2 + 208 | 0) + 16 | 0;
          HEAP32[i64toi32_i32$1 >> 2] = $309;
          HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
          HEAP32[(($2 + 192 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 288 | 0) + 8 | 0) >> 2] | 0;
          $74 = HEAPU8[($2 + 307 | 0) >> 0] | 0 | ((HEAPU8[($2 + 308 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 309 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 310 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          HEAP8[($2 + 235 | 0) >> 0] = $74;
          HEAP8[($2 + 236 | 0) >> 0] = $74 >>> 8 | 0;
          HEAP8[($2 + 237 | 0) >> 0] = $74 >>> 16 | 0;
          HEAP8[($2 + 238 | 0) >> 0] = $74 >>> 24 | 0;
          HEAP32[($2 + 232 | 0) >> 2] = HEAP32[($2 + 304 | 0) >> 2] | 0;
          i64toi32_i32$2 = $2;
          i64toi32_i32$0 = HEAP32[($2 + 384 | 0) >> 2] | 0;
          i64toi32_i32$1 = HEAP32[($2 + 388 | 0) >> 2] | 0;
          $325 = i64toi32_i32$0;
          i64toi32_i32$0 = $2;
          HEAP32[($2 + 208 | 0) >> 2] = $325;
          HEAP32[($2 + 212 | 0) >> 2] = i64toi32_i32$1;
          i64toi32_i32$2 = $2;
          i64toi32_i32$1 = HEAP32[($2 + 288 | 0) >> 2] | 0;
          i64toi32_i32$0 = HEAP32[($2 + 292 | 0) >> 2] | 0;
          $328 = i64toi32_i32$1;
          i64toi32_i32$1 = $2;
          HEAP32[($2 + 192 | 0) >> 2] = $328;
          HEAP32[($2 + 196 | 0) >> 2] = i64toi32_i32$0;
          i64toi32_i32$0 = $20$hi;
          $19 = $20;
          $19$hi = i64toi32_i32$0;
          break label$8;
         }
         alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($2 + 324 | 0 | 0, 1051628 | 0, 33 | 0);
         $3 = 0;
         $1 = ($2 + 312 | 0) + 8 | 0;
         HEAP32[$1 >> 2] = 0;
         i64toi32_i32$2 = $2 + 344 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $341 = i64toi32_i32$0;
         i64toi32_i32$0 = ($2 + 208 | 0) + 8 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $341;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$2 = $2 + 352 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $347 = i64toi32_i32$1;
         i64toi32_i32$1 = ($2 + 208 | 0) + 16 | 0;
         HEAP32[i64toi32_i32$1 >> 2] = $347;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
         HEAP32[($2 + 232 | 0) >> 2] = HEAPU8[($2 + 313 | 0) >> 0] | 0 | ((HEAPU8[($2 + 314 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 315 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 316 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $75 = HEAPU8[($2 + 316 | 0) >> 0] | 0 | ((HEAPU8[($2 + 317 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 318 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 319 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[($2 + 235 | 0) >> 0] = $75;
         HEAP8[($2 + 236 | 0) >> 0] = $75 >>> 8 | 0;
         HEAP8[($2 + 237 | 0) >> 0] = $75 >>> 16 | 0;
         HEAP8[($2 + 238 | 0) >> 0] = $75 >>> 24 | 0;
         i64toi32_i32$2 = $2 + 336 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $357 = i64toi32_i32$0;
         i64toi32_i32$0 = $2;
         HEAP32[($2 + 208 | 0) >> 2] = $357;
         HEAP32[($2 + 212 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$2 = ($2 + 312 | 0) + 16 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $18 = i64toi32_i32$1;
         $18$hi = i64toi32_i32$0;
         i64toi32_i32$2 = $1;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $19 = i64toi32_i32$0;
         $19$hi = i64toi32_i32$1;
         $12 = 4;
        }
        if (($12 & 255 | 0 | 0) != (19 | 0)) {
         break label$4
        }
        break label$3;
       }
       i64toi32_i32$2 = $2 + 344 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $371 = i64toi32_i32$1;
       i64toi32_i32$1 = $2 + 216 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $371;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = $2 + 352 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $377 = i64toi32_i32$0;
       i64toi32_i32$0 = ($2 + 208 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $377;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = ($2 + 312 | 0) + 24 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $382 = i64toi32_i32$1;
       i64toi32_i32$1 = $2;
       HEAP32[($2 + 208 | 0) >> 2] = $382;
       HEAP32[($2 + 212 | 0) >> 2] = i64toi32_i32$0;
       $12 = 2;
       break label$4;
      }
      i64toi32_i32$2 = $2 + 344 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $387 = i64toi32_i32$0;
      i64toi32_i32$0 = $2 + 216 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $387;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $2 + 352 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $393 = i64toi32_i32$1;
      i64toi32_i32$1 = ($2 + 208 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $393;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $2 + 336 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $397 = i64toi32_i32$0;
      i64toi32_i32$0 = $2;
      HEAP32[($2 + 208 | 0) >> 2] = $397;
      HEAP32[($2 + 212 | 0) >> 2] = i64toi32_i32$1;
     }
     i64toi32_i32$1 = $18$hi;
     i64toi32_i32$0 = ($2 + 312 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $18;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $19$hi;
     i64toi32_i32$0 = ($2 + 312 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $19;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAP32[($2 + 208 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 212 | 0) >> 2] | 0;
     $409 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 336 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $409;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[($2 + 192 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 196 | 0) >> 2] | 0;
     $413 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 364 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $413;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = ($2 + 208 | 0) + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $419 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 344 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $419;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = ($2 + 208 | 0) + 16 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $425 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 352 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $425;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($2 + 372 | 0) >> 2] = HEAP32[(($2 + 192 | 0) + 8 | 0) >> 2] | 0;
     HEAP8[($2 + 312 | 0) >> 0] = $12;
     $76 = HEAP32[($2 + 232 | 0) >> 2] | 0;
     HEAP8[($2 + 313 | 0) >> 0] = $76;
     HEAP8[($2 + 314 | 0) >> 0] = $76 >>> 8 | 0;
     HEAP8[($2 + 315 | 0) >> 0] = $76 >>> 16 | 0;
     HEAP8[($2 + 316 | 0) >> 0] = $76 >>> 24 | 0;
     $77 = HEAPU8[($2 + 235 | 0) >> 0] | 0 | ((HEAPU8[($2 + 236 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 237 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 238 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($2 + 316 | 0) >> 0] = $77;
     HEAP8[($2 + 317 | 0) >> 0] = $77 >>> 8 | 0;
     HEAP8[($2 + 318 | 0) >> 0] = $77 >>> 16 | 0;
     HEAP8[($2 + 319 | 0) >> 0] = $77 >>> 24 | 0;
     HEAP32[($2 + 360 | 0) >> 2] = $3;
     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($2 + 128 | 0 | 0, $2 + 312 | 0 | 0, 1052656 | 0, 16 | 0);
     $1 = HEAPU8[($2 + 128 | 0) >> 0] | 0;
     if (($1 | 0) != (19 | 0)) {
      break label$2
     }
    }
    memcpy($0 + 8 | 0 | 0, $2 + 24 | 0 | 0, 40 | 0) | 0;
    i64toi32_i32$1 = 0;
    $18 = 0;
    $18$hi = i64toi32_i32$1;
    break label$1;
   }
   memcpy($2 + 65 | 0 | 0, $2 + 128 | 0 | 1 | 0 | 0, 63 | 0) | 0;
   HEAP8[($0 + 8 | 0) >> 0] = $1;
   memcpy($0 + 9 | 0 | 0, $2 + 65 | 0 | 0, 63 | 0) | 0;
   $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__h65524c00492b1305($2 + 24 | 0 | 0);
   label$15 : {
    if (!(HEAP32[($2 + 40 | 0) >> 2] | 0)) {
     break label$15
    }
    hashbrown__raw__RawTable_T_2cA___free_buckets__h03139504252f0030(($2 + 24 | 0) + 16 | 0 | 0);
   }
   i64toi32_i32$1 = 0;
   $18 = 1;
   $18$hi = i64toi32_i32$1;
  }
  i64toi32_i32$1 = $18$hi;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $2 + 448 | 0;
 }
 
 function $cardano_serialization_lib__crypto__VRFCert_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__ha63b72084ea6ce59($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $5 = 0, $7 = 0, $9 = 0, i64toi32_i32$4 = 0, $4 = 0, $3 = 0, $10 = 0, $13 = 0, $13$hi = 0, $14 = 0, $14$hi = 0, $15 = 0, $15$hi = 0, $12 = 0, $12$hi = 0, $8 = 0, $6 = 0, $11 = 0, $30 = 0, $31 = 0, $32 = 0, $33 = 0, $117 = 0, $143 = 0, $332 = 0, $358 = 0, $447 = 0;
  $2 = global$0 - 192 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 56 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 64 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 68 | 0) >> 2] | 0;
  $12 = i64toi32_i32$0;
  $12$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        i64toi32_i32$2 = $2;
        i64toi32_i32$1 = HEAP32[($2 + 56 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[($2 + 60 | 0) >> 2] | 0;
        i64toi32_i32$2 = i64toi32_i32$1;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
         break label$6
        }
        cbor_event__de__Deserializer_R___bytes__hc697ccccfa39fd82($2 + 128 | 0 | 0, $1 | 0);
        if ((HEAP32[($2 + 128 | 0) >> 2] | 0 | 0) == (1 | 0)) {
         break label$5
        }
        $3 = HEAPU8[($2 + 137 | 0) >> 0] | 0 | ((HEAPU8[($2 + 138 | 0) >> 0] | 0) << 8 | 0) | 0;
        HEAP8[($2 + 29 | 0) >> 0] = $3;
        HEAP8[($2 + 30 | 0) >> 0] = $3 >>> 8 | 0;
        $4 = HEAP32[($2 + 132 | 0) >> 2] | 0;
        HEAP32[($2 + 24 | 0) >> 2] = $4;
        $5 = ($2 + 128 | 0) + 11 | 0;
        $6 = HEAPU8[$5 >> 0] | 0;
        HEAP8[($2 + 31 | 0) >> 0] = $6;
        $7 = ($2 + 128 | 0) + 12 | 0;
        $8 = HEAP32[$7 >> 2] | 0;
        HEAP32[($2 + 32 | 0) >> 2] = $8;
        $9 = ($2 + 128 | 0) + 8 | 0;
        $10 = HEAPU8[$9 >> 0] | 0;
        HEAP8[($2 + 28 | 0) >> 0] = $10;
        cbor_event__de__Deserializer_R___bytes__hc697ccccfa39fd82($2 + 128 | 0 | 0, $1 | 0);
        label$7 : {
         label$8 : {
          label$9 : {
           label$10 : {
            if ((HEAP32[($2 + 128 | 0) >> 2] | 0 | 0) == (1 | 0)) {
             break label$10
            }
            $30 = HEAPU8[($2 + 137 | 0) >> 0] | 0 | ((HEAPU8[($2 + 138 | 0) >> 0] | 0) << 8 | 0) | 0;
            HEAP8[($2 + 45 | 0) >> 0] = $30;
            HEAP8[($2 + 46 | 0) >> 0] = $30 >>> 8 | 0;
            $11 = HEAP32[($2 + 132 | 0) >> 2] | 0;
            HEAP32[($2 + 40 | 0) >> 2] = $11;
            HEAP8[($2 + 47 | 0) >> 0] = HEAPU8[$5 >> 0] | 0;
            $5 = HEAP32[$7 >> 2] | 0;
            HEAP32[($2 + 48 | 0) >> 2] = $5;
            HEAP8[($2 + 44 | 0) >> 0] = HEAPU8[$9 >> 0] | 0;
            $9 = 80;
            if (($5 | 0) != (80 | 0)) {
             break label$9
            }
            i64toi32_i32$2 = $12$hi;
            i64toi32_i32$3 = $12;
            i64toi32_i32$0 = 0;
            i64toi32_i32$1 = 1;
            if ((i64toi32_i32$3 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$0 | 0) | 0) {
             break label$8
            }
            $1 = $3 | ($6 << 16 | 0) | 0;
            $5 = $11 >>> 8 | 0;
            break label$7;
           }
           i64toi32_i32$1 = $9;
           i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $12 = i64toi32_i32$3;
           $12$hi = i64toi32_i32$2;
           $1 = ($2 + 128 | 0) + 16 | 0;
           i64toi32_i32$1 = $1;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $13 = i64toi32_i32$2;
           $13$hi = i64toi32_i32$3;
           $5 = ($2 + 128 | 0) + 24 | 0;
           i64toi32_i32$1 = $5;
           i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $14 = i64toi32_i32$3;
           $14$hi = i64toi32_i32$2;
           $7 = ($2 + 128 | 0) + 32 | 0;
           i64toi32_i32$1 = $7;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $15 = i64toi32_i32$2;
           $15$hi = i64toi32_i32$3;
           $4 = ($2 + 128 | 0) + 40 | 0;
           i64toi32_i32$1 = $4;
           i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $117 = i64toi32_i32$3;
           i64toi32_i32$3 = i64toi32_i32$1;
           HEAP32[i64toi32_i32$3 >> 2] = $117;
           HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
           i64toi32_i32$2 = $15$hi;
           i64toi32_i32$3 = $7;
           HEAP32[i64toi32_i32$3 >> 2] = $15;
           HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
           i64toi32_i32$2 = $14$hi;
           i64toi32_i32$3 = $5;
           HEAP32[i64toi32_i32$3 >> 2] = $14;
           HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
           i64toi32_i32$2 = $13$hi;
           i64toi32_i32$3 = $1;
           HEAP32[i64toi32_i32$3 >> 2] = $13;
           HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
           i64toi32_i32$2 = $12$hi;
           i64toi32_i32$3 = $9;
           HEAP32[i64toi32_i32$3 >> 2] = $12;
           HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
           HEAP32[($2 + 176 | 0) >> 2] = 0;
           HEAP8[($2 + 128 | 0) >> 0] = 2;
           $5 = ($2 + 56 | 0) + 8 | 0;
           cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($5 | 0, $2 + 128 | 0 | 0, 1066446 | 0, 5 | 0);
           HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 124 | 0) >> 2] | 0;
           i64toi32_i32$1 = $2 + 116 | 0;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $143 = i64toi32_i32$2;
           i64toi32_i32$2 = $2;
           HEAP32[($2 + 8 | 0) >> 2] = $143;
           HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$3;
           $9 = HEAPU8[($2 + 73 | 0) >> 0] | 0 | ((HEAPU8[($2 + 74 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 75 | 0) >> 0] | 0) << 16 | 0) | 0;
           $1 = HEAPU8[($2 + 65 | 0) >> 0] | 0 | ((HEAPU8[($2 + 66 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(($2 + 56 | 0) + 11 | 0) >> 0] | 0) << 16 | 0) | 0;
           $7 = HEAPU8[$5 >> 0] | 0;
           $4 = HEAP32[(($2 + 56 | 0) + 12 | 0) >> 2] | 0;
           $5 = HEAPU8[(($2 + 56 | 0) + 16 | 0) >> 0] | 0;
           $10 = HEAP32[($2 + 76 | 0) >> 2] | 0;
           $3 = HEAP32[(($2 + 56 | 0) + 24 | 0) >> 2] | 0;
           $6 = HEAP32[($2 + 84 | 0) >> 2] | 0;
           i64toi32_i32$1 = ($2 + 56 | 0) + 32 | 0;
           i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $13 = i64toi32_i32$3;
           $13$hi = i64toi32_i32$2;
           i64toi32_i32$1 = ($2 + 56 | 0) + 40 | 0;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $14 = i64toi32_i32$2;
           $14$hi = i64toi32_i32$3;
           i64toi32_i32$1 = $2 + 104 | 0;
           i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $15 = i64toi32_i32$3;
           $15$hi = i64toi32_i32$2;
           $8 = HEAP32[($2 + 112 | 0) >> 2] | 0;
           break label$3;
          }
          i64toi32_i32$2 = 0;
          $15 = $5;
          $15$hi = i64toi32_i32$2;
          $7 = 2;
          $5 = 13;
          $10 = 1066451;
          $3 = 12;
          i64toi32_i32$2 = 0;
          $13 = 80;
          $13$hi = i64toi32_i32$2;
          i64toi32_i32$2 = 0;
          $14 = 1;
          $14$hi = i64toi32_i32$2;
          break label$4;
         }
         cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 56 | 0 | 0, $1 | 0);
         $5 = HEAPU8[($2 + 64 | 0) >> 0] | 0;
         label$11 : {
          label$12 : {
           i64toi32_i32$1 = $2;
           i64toi32_i32$2 = HEAP32[($2 + 56 | 0) >> 2] | 0;
           i64toi32_i32$3 = HEAP32[($2 + 60 | 0) >> 2] | 0;
           i64toi32_i32$1 = i64toi32_i32$2;
           i64toi32_i32$2 = 0;
           i64toi32_i32$0 = 1;
           if ((i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) | 0) {
            break label$12
           }
           $7 = 5;
           if (($5 & 255 | 0 | 0) == (5 | 0)) {
            break label$11
           }
           break label$4;
          }
          $9 = HEAPU8[($2 + 65 | 0) >> 0] | 0 | ((HEAPU8[($2 + 66 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 67 | 0) >> 0] | 0) << 16 | 0) | 0;
          $6 = HEAP32[($2 + 76 | 0) >> 2] | 0;
          $3 = HEAP32[(($2 + 56 | 0) + 16 | 0) >> 2] | 0;
          i64toi32_i32$0 = $2 + 96 | 0;
          i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
          i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
          $15 = i64toi32_i32$1;
          $15$hi = i64toi32_i32$3;
          i64toi32_i32$0 = $2 + 88 | 0;
          i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
          $14 = i64toi32_i32$3;
          $14$hi = i64toi32_i32$1;
          i64toi32_i32$0 = $2 + 80 | 0;
          i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
          i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
          $13 = i64toi32_i32$1;
          $13$hi = i64toi32_i32$3;
          $10 = HEAP32[($2 + 68 | 0) >> 2] | 0;
          $7 = 2;
          break label$4;
         }
         $5 = HEAPU8[($2 + 41 | 0) >> 0] | 0 | ((HEAPU8[($2 + 42 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 43 | 0) >> 0] | 0) << 16 | 0) | 0;
         $1 = HEAPU8[($2 + 29 | 0) >> 0] | 0 | ((HEAPU8[($2 + 30 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 31 | 0) >> 0] | 0) << 16 | 0) | 0;
         $9 = HEAP32[($2 + 48 | 0) >> 2] | 0;
         $11 = HEAPU8[($2 + 40 | 0) >> 0] | 0;
         $8 = HEAP32[($2 + 32 | 0) >> 2] | 0;
         $10 = HEAPU8[($2 + 28 | 0) >> 0] | 0;
         $4 = HEAP32[($2 + 24 | 0) >> 2] | 0;
        }
        $7 = HEAP32[($2 + 44 | 0) >> 2] | 0;
        HEAP8[($0 + 19 | 0) >> 0] = $5 >>> 16 | 0;
        HEAP8[($0 + 17 | 0) >> 0] = $5;
        HEAP8[($0 + 18 | 0) >> 0] = $5 >>> 8 | 0;
        HEAP8[($0 + 11 | 0) >> 0] = $1 >>> 16 | 0;
        HEAP8[($0 + 9 | 0) >> 0] = $1;
        HEAP8[($0 + 10 | 0) >> 0] = $1 >>> 8 | 0;
        HEAP32[($0 + 24 | 0) >> 2] = $9;
        HEAP32[($0 + 20 | 0) >> 2] = $7;
        HEAP8[($0 + 16 | 0) >> 0] = $11;
        HEAP32[($0 + 12 | 0) >> 2] = $8;
        HEAP8[($0 + 8 | 0) >> 0] = $10;
        HEAP32[($0 + 4 | 0) >> 2] = $4;
        $1 = 0;
        break label$1;
       }
       i64toi32_i32$3 = $12$hi;
       i64toi32_i32$0 = $12;
       i64toi32_i32$1 = 0;
       i64toi32_i32$2 = 32;
       i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = 0;
        $31 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$1 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
        $31 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
       }
       $10 = $31;
       i64toi32_i32$1 = $12$hi;
       i64toi32_i32$3 = $12;
       i64toi32_i32$0 = 0;
       i64toi32_i32$2 = 8;
       i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = 0;
        $32 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
        $32 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$4 | 0) | 0;
       }
       $9 = $32;
       $6 = HEAP32[($2 + 76 | 0) >> 2] | 0;
       $3 = HEAP32[($2 + 72 | 0) >> 2] | 0;
       i64toi32_i32$1 = $2 + 96 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $15 = i64toi32_i32$0;
       $15$hi = i64toi32_i32$3;
       i64toi32_i32$1 = $2 + 88 | 0;
       i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $14 = i64toi32_i32$3;
       $14$hi = i64toi32_i32$0;
       i64toi32_i32$1 = $2 + 80 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $13 = i64toi32_i32$0;
       $13$hi = i64toi32_i32$3;
       i64toi32_i32$3 = $12$hi;
       $5 = $12;
       $7 = 2;
       $8 = 0;
       break label$2;
      }
      $1 = ($2 + 128 | 0) + 8 | 0;
      i64toi32_i32$1 = $1;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $12 = i64toi32_i32$3;
      $12$hi = i64toi32_i32$0;
      $9 = ($2 + 128 | 0) + 16 | 0;
      i64toi32_i32$1 = $9;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $13 = i64toi32_i32$0;
      $13$hi = i64toi32_i32$3;
      $5 = ($2 + 128 | 0) + 24 | 0;
      i64toi32_i32$1 = $5;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $14 = i64toi32_i32$3;
      $14$hi = i64toi32_i32$0;
      $7 = ($2 + 128 | 0) + 32 | 0;
      i64toi32_i32$1 = $7;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $15 = i64toi32_i32$0;
      $15$hi = i64toi32_i32$3;
      $4 = ($2 + 128 | 0) + 40 | 0;
      i64toi32_i32$1 = $4;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $332 = i64toi32_i32$3;
      i64toi32_i32$3 = i64toi32_i32$1;
      HEAP32[i64toi32_i32$3 >> 2] = $332;
      HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$0 = $15$hi;
      i64toi32_i32$3 = $7;
      HEAP32[i64toi32_i32$3 >> 2] = $15;
      HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$0 = $14$hi;
      i64toi32_i32$3 = $5;
      HEAP32[i64toi32_i32$3 >> 2] = $14;
      HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$0 = $13$hi;
      i64toi32_i32$3 = $9;
      HEAP32[i64toi32_i32$3 >> 2] = $13;
      HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$0 = $12$hi;
      i64toi32_i32$3 = $1;
      HEAP32[i64toi32_i32$3 >> 2] = $12;
      HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[($2 + 176 | 0) >> 2] = 0;
      HEAP8[($2 + 128 | 0) >> 0] = 2;
      $5 = ($2 + 56 | 0) + 8 | 0;
      cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($5 | 0, $2 + 128 | 0 | 0, 1066440 | 0, 6 | 0);
      HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 124 | 0) >> 2] | 0;
      i64toi32_i32$1 = $2 + 116 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $358 = i64toi32_i32$0;
      i64toi32_i32$0 = $2;
      HEAP32[($2 + 8 | 0) >> 2] = $358;
      HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$3;
      $9 = HEAPU8[($2 + 73 | 0) >> 0] | 0 | ((HEAPU8[($2 + 74 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 75 | 0) >> 0] | 0) << 16 | 0) | 0;
      $1 = HEAPU8[($2 + 65 | 0) >> 0] | 0 | ((HEAPU8[($2 + 66 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 67 | 0) >> 0] | 0) << 16 | 0) | 0;
      $7 = HEAPU8[$5 >> 0] | 0;
      $4 = HEAP32[($2 + 68 | 0) >> 2] | 0;
      $5 = HEAPU8[(($2 + 56 | 0) + 16 | 0) >> 0] | 0;
      $10 = HEAP32[($2 + 76 | 0) >> 2] | 0;
      $3 = HEAP32[(($2 + 56 | 0) + 24 | 0) >> 2] | 0;
      $6 = HEAP32[($2 + 84 | 0) >> 2] | 0;
      i64toi32_i32$1 = ($2 + 56 | 0) + 32 | 0;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $13 = i64toi32_i32$3;
      $13$hi = i64toi32_i32$0;
      i64toi32_i32$1 = ($2 + 56 | 0) + 40 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $14 = i64toi32_i32$0;
      $14$hi = i64toi32_i32$3;
      i64toi32_i32$1 = $2 + 104 | 0;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $15 = i64toi32_i32$3;
      $15$hi = i64toi32_i32$0;
      $8 = HEAP32[($2 + 112 | 0) >> 2] | 0;
      break label$2;
     }
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 40 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 40 | 0 | 0);
     $8 = 0;
    }
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 24 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 24 | 0 | 0);
   }
   HEAP8[($2 + 67 | 0) >> 0] = $9 >>> 16 | 0;
   $33 = $2 + 65 | 0;
   HEAP8[$33 >> 0] = $9;
   HEAP8[($33 + 1 | 0) >> 0] = $9 >>> 8 | 0;
   i64toi32_i32$0 = $15$hi;
   i64toi32_i32$3 = $2 + 96 | 0;
   HEAP32[i64toi32_i32$3 >> 2] = $15;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $14$hi;
   i64toi32_i32$3 = $2 + 88 | 0;
   HEAP32[i64toi32_i32$3 >> 2] = $14;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $13$hi;
   i64toi32_i32$3 = $2 + 80 | 0;
   HEAP32[i64toi32_i32$3 >> 2] = $13;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($2 + 76 | 0) >> 2] = $6;
   HEAP32[(($2 + 56 | 0) + 16 | 0) >> 2] = $3;
   HEAP32[($2 + 68 | 0) >> 2] = $10;
   HEAP8[(($2 + 56 | 0) + 8 | 0) >> 0] = $5;
   i64toi32_i32$1 = $2;
   i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $447 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 108 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $447;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
   HEAP32[($2 + 116 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
   HEAP32[($2 + 104 | 0) >> 2] = $8;
   HEAP32[($2 + 60 | 0) >> 2] = $4;
   HEAP8[($2 + 56 | 0) >> 0] = $7;
   HEAP8[($2 + 57 | 0) >> 0] = $1;
   HEAP8[($2 + 58 | 0) >> 0] = $1 >>> 8 | 0;
   HEAP8[($2 + 59 | 0) >> 0] = $1 >>> 16 | 0;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 56 | 0 | 0, 1066463 | 0, 7 | 0);
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 192 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__Withdrawals___deserialize__h7582bde99e83c579($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $19 = 0, $19$hi = 0, $20 = 0, $20$hi = 0, $3 = 0, $21 = 0, $21$hi = 0, $5 = 0, $95 = 0, $96 = 0, $97 = 0, $98 = 0, $99 = 0, $27 = 0, $27$hi = 0, $4 = 0, $7 = 0, $100 = 0, $101 = 0, $102 = 0, $103 = 0, $104 = 0, $105 = 0, $106 = 0, $107 = 0, $108 = 0, $109 = 0, $110 = 0, $111 = 0, $112 = 0, $113 = 0, $114 = 0, $115 = 0, $116 = 0, $117 = 0, $118 = 0, $6 = 0, $8 = 0, $9 = 0, $10 = 0, $11 = 0, $12 = 0, $13 = 0, $14 = 0, $15 = 0, $22 = 0, $22$hi = 0, $23 = 0, $23$hi = 0, $16 = 0, $17 = 0, $18 = 0, $24 = 0, $24$hi = 0, $25 = 0, $25$hi = 0, $26 = 0, $26$hi = 0, $152 = 0, $153 = 0, $153$hi = 0, $154 = 0, $154$hi = 0, $156$hi = 0, $158$hi = 0, $161 = 0, $164 = 0, $167 = 0, $168 = 0, $168$hi = 0, $169 = 0, $169$hi = 0, $171$hi = 0, $173$hi = 0, $176 = 0, $179 = 0, $238 = 0, $244 = 0, $253 = 0, $257 = 0, $283 = 0, $289 = 0, $293 = 0, $295 = 0, $295$hi = 0, $297 = 0, $297$hi = 0, $300$hi = 0, $302$hi = 0, $315 = 0, $320 = 0, $330 = 0, $334 = 0, $336 = 0, $336$hi = 0, $339 = 0, $339$hi = 0, $343$hi = 0, $345$hi = 0, $363 = 0, $369 = 0, $374 = 0, $379 = 0, $385 = 0, $389 = 0, $401 = 0, $405 = 0, $411 = 0, $417 = 0, $430 = 0, $433 = 0;
  $2 = global$0 - 368 | 0;
  global$0 = $2;
  std__thread__local__LocalKey_T___with__h4cd07b14a44a727e($2 + 24 | 0 | 0, 1060968 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $19 = i64toi32_i32$0;
  $19$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
  $20 = i64toi32_i32$1;
  $20$hi = i64toi32_i32$0;
  $3 = hashbrown__raw__generic__Group__static_empty__hc5a7932fe1bdb1f1() | 0;
  i64toi32_i32$1 = (i64toi32_i32$2 + 40 | 0) + 24 | 0;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] = $3;
  $3 = 0;
  HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] = 0;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$0 = 0;
  HEAP32[(i64toi32_i32$2 + 72 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$2 + 76 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $20$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = $20;
  HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $19$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] = $19;
  HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] = i64toi32_i32$0;
  cbor_event__de__Deserializer_R___map__h7c2a4e830d885a05(i64toi32_i32$2 + 288 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = (i64toi32_i32$2 + 288 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$0;
  $21$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 296 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 300 | 0) >> 2] | 0;
  $20 = i64toi32_i32$1;
  $20$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 288 | 0) >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 292 | 0) >> 2] | 0;
         i64toi32_i32$2 = i64toi32_i32$0;
         i64toi32_i32$0 = 0;
         i64toi32_i32$3 = 1;
         if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
          break label$7
         }
         i64toi32_i32$2 = $21$hi;
         $4 = $21;
         label$8 : {
          i64toi32_i32$2 = $20$hi;
          i64toi32_i32$3 = $20;
          i64toi32_i32$1 = 0;
          i64toi32_i32$0 = 1;
          if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
           break label$8
          }
          if (!$4) {
           break label$3
          }
         }
         $5 = 2;
         $6 = $2 + 288 | 0 | 2 | 0;
         $7 = $2 + 288 | 0 | 3 | 0;
         $8 = $2 + 301 | 0;
         $9 = $2 + 303 | 0;
         $10 = $2 + 316 | 0;
         $11 = $2 + 318 | 0;
         $12 = $2 + 317 | 0;
         $13 = $2 + 315 | 0;
         $14 = $2 + 302 | 0;
         $15 = $2 + 300 | 0;
         label$9 : {
          label$10 : {
           label$11 : {
            label$12 : {
             label$13 : while (1) {
              std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 16 | 0 | 0, $1 | 0);
              $3 = 0;
              label$14 : {
               if (HEAP32[($2 + 20 | 0) >> 2] | 0) {
                break label$14
               }
               i64toi32_i32$3 = 0;
               $20 = 8;
               $20$hi = i64toi32_i32$3;
               i64toi32_i32$3 = 0;
               $21 = 0;
               $21$hi = i64toi32_i32$3;
               break label$5;
              }
              label$15 : {
               if ((($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[($2 + 16 | 0) >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) == (7 | 0)) {
                break label$15
               }
               $cardano_serialization_lib__address__RewardAddress_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h7ae223ac4e980662($2 + 288 | 0 | 0, $1 | 0);
               if ((HEAPU8[($2 + 288 | 0) >> 0] | 0 | 0) == (1 | 0)) {
                break label$10
               }
               $3 = ($2 + 264 | 0) + 4 | 0;
               HEAP8[$3 >> 0] = HEAPU8[($7 + 4 | 0) >> 0] | 0;
               $96 = $7;
               HEAP32[($2 + 264 | 0) >> 2] = HEAPU8[$96 >> 0] | 0 | ((HEAPU8[($96 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($96 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($96 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
               i64toi32_i32$0 = $8;
               i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
               i64toi32_i32$2 = 0;
               $21 = i64toi32_i32$3;
               $21$hi = i64toi32_i32$2;
               i64toi32_i32$0 = $9;
               i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0;
               i64toi32_i32$3 = 0;
               $22 = i64toi32_i32$2;
               $22$hi = i64toi32_i32$3;
               i64toi32_i32$0 = $10;
               i64toi32_i32$3 = HEAPU16[i64toi32_i32$0 >> 1] | 0;
               i64toi32_i32$2 = 0;
               $19 = i64toi32_i32$3;
               $19$hi = i64toi32_i32$2;
               i64toi32_i32$0 = $11;
               i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0;
               i64toi32_i32$3 = 0;
               $23 = i64toi32_i32$2;
               $23$hi = i64toi32_i32$3;
               $16 = HEAPU8[($2 + 290 | 0) >> 0] | 0;
               $17 = HEAPU8[($2 + 289 | 0) >> 0] | 0;
               $18 = HEAPU8[($2 + 296 | 0) >> 0] | 0;
               i64toi32_i32$0 = $2;
               i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 304 | 0) >> 2] | 0;
               i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 308 | 0) >> 2] | 0;
               $24 = i64toi32_i32$3;
               $24$hi = i64toi32_i32$2;
               i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 297 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 298 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 299 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 300 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
               i64toi32_i32$3 = 0;
               $25 = i64toi32_i32$2;
               $25$hi = i64toi32_i32$3;
               i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 312 | 0) >> 2] | 0;
               i64toi32_i32$2 = 0;
               $26 = i64toi32_i32$3;
               $26$hi = i64toi32_i32$2;
               $cardano_serialization_lib__utils__BigNum_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h29637bb571dceb02(i64toi32_i32$0 + 288 | 0 | 0, $1 | 0);
               i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 296 | 0) >> 2] | 0;
               i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 300 | 0) >> 2] | 0;
               $27 = i64toi32_i32$2;
               $27$hi = i64toi32_i32$3;
               i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 288 | 0) >> 2] | 0;
               i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 292 | 0) >> 2] | 0;
               i64toi32_i32$0 = i64toi32_i32$3;
               i64toi32_i32$3 = 0;
               i64toi32_i32$1 = 1;
               if ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) | 0) {
                break label$12
               }
               $95 = $6;
               $97 = HEAP32[($2 + 264 | 0) >> 2] | 0;
               HEAP8[$95 >> 0] = $97;
               HEAP8[($95 + 1 | 0) >> 0] = $97 >>> 8 | 0;
               HEAP8[($95 + 2 | 0) >> 0] = $97 >>> 16 | 0;
               HEAP8[($95 + 3 | 0) >> 0] = $97 >>> 24 | 0;
               HEAP8[($95 + 4 | 0) >> 0] = HEAPU8[$3 >> 0] | 0;
               $152 = $2;
               i64toi32_i32$0 = $26$hi;
               $153 = $26;
               $153$hi = i64toi32_i32$0;
               i64toi32_i32$0 = $19$hi;
               $154 = $19;
               $154$hi = i64toi32_i32$0;
               i64toi32_i32$0 = $23$hi;
               i64toi32_i32$1 = $23;
               i64toi32_i32$2 = 0;
               i64toi32_i32$3 = 16;
               i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
               if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
                $100 = 0;
               } else {
                i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
                $100 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
               }
               $156$hi = i64toi32_i32$2;
               i64toi32_i32$2 = $154$hi;
               i64toi32_i32$0 = $154;
               i64toi32_i32$1 = $156$hi;
               i64toi32_i32$3 = $100;
               i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
               i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
               i64toi32_i32$0 = 0;
               i64toi32_i32$3 = 32;
               i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
               if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
                $101 = 0;
               } else {
                i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
                $101 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
               }
               $158$hi = i64toi32_i32$0;
               i64toi32_i32$0 = $153$hi;
               i64toi32_i32$1 = $153;
               i64toi32_i32$2 = $158$hi;
               i64toi32_i32$3 = $101;
               i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
               $19 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
               $19$hi = i64toi32_i32$2;
               $98 = $152;
               HEAP8[($98 + 311 | 0) >> 0] = $19;
               HEAP8[($98 + 312 | 0) >> 0] = $19 >>> 8 | 0;
               HEAP8[($98 + 313 | 0) >> 0] = $19 >>> 16 | 0;
               HEAP8[($98 + 314 | 0) >> 0] = $19 >>> 24 | 0;
               $161 = $12;
               i64toi32_i32$0 = $19;
               i64toi32_i32$1 = 0;
               i64toi32_i32$3 = 48;
               i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
               if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                i64toi32_i32$1 = 0;
                $102 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
               } else {
                i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
                $102 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
               }
               HEAP8[$161 >> 0] = $102;
               $164 = $13;
               i64toi32_i32$1 = $19$hi;
               i64toi32_i32$2 = $19;
               i64toi32_i32$0 = 0;
               i64toi32_i32$3 = 32;
               i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
               if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                i64toi32_i32$0 = 0;
                $103 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
               } else {
                i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
                $103 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
               }
               $104 = $164;
               $105 = $103;
               HEAP8[$104 >> 0] = $105;
               HEAP8[($104 + 1 | 0) >> 0] = $105 >>> 8 | 0;
               $167 = $2;
               i64toi32_i32$0 = $25$hi;
               $168 = $25;
               $168$hi = i64toi32_i32$0;
               i64toi32_i32$0 = $21$hi;
               $169 = $21;
               $169$hi = i64toi32_i32$0;
               i64toi32_i32$0 = $22$hi;
               i64toi32_i32$1 = $22;
               i64toi32_i32$2 = 0;
               i64toi32_i32$3 = 16;
               i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
               if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
                $106 = 0;
               } else {
                i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
                $106 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
               }
               $171$hi = i64toi32_i32$2;
               i64toi32_i32$2 = $169$hi;
               i64toi32_i32$0 = $169;
               i64toi32_i32$1 = $171$hi;
               i64toi32_i32$3 = $106;
               i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
               i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
               i64toi32_i32$0 = 0;
               i64toi32_i32$3 = 32;
               i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
               if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
                $107 = 0;
               } else {
                i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
                $107 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
               }
               $173$hi = i64toi32_i32$0;
               i64toi32_i32$0 = $168$hi;
               i64toi32_i32$1 = $168;
               i64toi32_i32$2 = $173$hi;
               i64toi32_i32$3 = $107;
               i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
               $19 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
               $19$hi = i64toi32_i32$2;
               HEAP32[($167 + 296 | 0) >> 2] = $19;
               $176 = $14;
               i64toi32_i32$0 = $19;
               i64toi32_i32$1 = 0;
               i64toi32_i32$3 = 48;
               i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
               if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                i64toi32_i32$1 = 0;
                $108 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
               } else {
                i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
                $108 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
               }
               HEAP8[$176 >> 0] = $108;
               $179 = $15;
               i64toi32_i32$1 = $19$hi;
               i64toi32_i32$2 = $19;
               i64toi32_i32$0 = 0;
               i64toi32_i32$3 = 32;
               i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
               if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                i64toi32_i32$0 = 0;
                $109 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
               } else {
                i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
                $109 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
               }
               HEAP16[$179 >> 1] = $109;
               i64toi32_i32$0 = $24$hi;
               i64toi32_i32$2 = $2;
               $99 = $24;
               HEAP8[(i64toi32_i32$2 + 303 | 0) >> 0] = $99;
               HEAP8[(i64toi32_i32$2 + 304 | 0) >> 0] = $99 >>> 8 | 0;
               HEAP8[(i64toi32_i32$2 + 305 | 0) >> 0] = $99 >>> 16 | 0;
               HEAP8[(i64toi32_i32$2 + 306 | 0) >> 0] = $99 >>> 24 | 0;
               HEAP8[(i64toi32_i32$2 + 307 | 0) >> 0] = i64toi32_i32$0;
               HEAP8[(i64toi32_i32$2 + 308 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
               HEAP8[(i64toi32_i32$2 + 309 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
               HEAP8[(i64toi32_i32$2 + 310 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
               HEAP8[(i64toi32_i32$2 + 295 | 0) >> 0] = $18;
               HEAP8[(i64toi32_i32$2 + 288 | 0) >> 0] = $17;
               HEAP8[(i64toi32_i32$2 + 289 | 0) >> 0] = ($16 & 255 | 0 | 0) == (1 | 0);
               i64toi32_i32$0 = $27$hi;
               linked_hash_map__LinkedHashMap_K_2cV_2cS___insert__h654f744b7b23f305(i64toi32_i32$2 | 0, i64toi32_i32$2 + 40 | 0 | 0, i64toi32_i32$2 + 288 | 0 | 0, $27 | 0, i64toi32_i32$0 | 0);
               i64toi32_i32$1 = i64toi32_i32$2;
               i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
               i64toi32_i32$2 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
               i64toi32_i32$1 = i64toi32_i32$0;
               i64toi32_i32$0 = 0;
               i64toi32_i32$3 = 1;
               if ((i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) | 0) {
                break label$11
               }
               i64toi32_i32$1 = $20$hi;
               i64toi32_i32$3 = $20;
               i64toi32_i32$2 = 0;
               i64toi32_i32$0 = 1;
               if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$2 | 0) | 0) {
                continue label$13
               }
               if ((HEAP32[($2 + 68 | 0) >> 2] | 0) >>> 0 < $4 >>> 0) {
                continue label$13
               }
               break label$3;
              }
              break label$13;
             };
             cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 288 | 0 | 0, $1 | 0);
             i64toi32_i32$0 = ($2 + 288 | 0) + 16 | 0;
             i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
             i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
             $21 = i64toi32_i32$3;
             $21$hi = i64toi32_i32$1;
             i64toi32_i32$0 = $2;
             i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 296 | 0) >> 2] | 0;
             i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 300 | 0) >> 2] | 0;
             $20 = i64toi32_i32$1;
             $20$hi = i64toi32_i32$3;
             i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 288 | 0) >> 2] | 0;
             i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 292 | 0) >> 2] | 0;
             i64toi32_i32$0 = i64toi32_i32$3;
             i64toi32_i32$3 = 0;
             i64toi32_i32$2 = 1;
             if ((i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) | 0) {
              break label$6
             }
             i64toi32_i32$0 = $21$hi;
             i64toi32_i32$1 = $2 + 256 | 0;
             HEAP32[i64toi32_i32$1 >> 2] = $21;
             HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
             i64toi32_i32$0 = $20$hi;
             i64toi32_i32$1 = $2;
             HEAP32[(i64toi32_i32$1 + 248 | 0) >> 2] = $20;
             HEAP32[(i64toi32_i32$1 + 252 | 0) >> 2] = i64toi32_i32$0;
             if (($20 & 255 | 0 | 0) == (5 | 0)) {
              break label$3
             }
             HEAP32[($2 + 288 | 0) >> 2] = 0;
             core__panicking__assert_failed__h96d8431cc974b591(0 | 0, $2 + 248 | 0 | 0, 1050312 | 0, $2 + 288 | 0 | 0, 1051612 | 0);
             abort();
            }
            i64toi32_i32$2 = $2 + 328 | 0;
            i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
            i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
            $238 = i64toi32_i32$0;
            i64toi32_i32$0 = ($2 + 224 | 0) + 8 | 0;
            HEAP32[i64toi32_i32$0 >> 2] = $238;
            HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
            i64toi32_i32$2 = $2 + 336 | 0;
            i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
            i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
            $244 = i64toi32_i32$1;
            i64toi32_i32$1 = ($2 + 224 | 0) + 16 | 0;
            HEAP32[i64toi32_i32$1 >> 2] = $244;
            HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
            HEAP32[(($2 + 208 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 356 | 0) >> 2] | 0;
            i64toi32_i32$2 = $2;
            i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 348 | 0) >> 2] | 0;
            i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 352 | 0) >> 2] | 0;
            $253 = i64toi32_i32$0;
            i64toi32_i32$0 = i64toi32_i32$2;
            HEAP32[(i64toi32_i32$2 + 208 | 0) >> 2] = $253;
            HEAP32[(i64toi32_i32$2 + 212 | 0) >> 2] = i64toi32_i32$1;
            i64toi32_i32$2 = i64toi32_i32$2 + 320 | 0;
            i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
            i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
            $257 = i64toi32_i32$1;
            i64toi32_i32$1 = $2;
            HEAP32[(i64toi32_i32$1 + 224 | 0) >> 2] = $257;
            HEAP32[(i64toi32_i32$1 + 228 | 0) >> 2] = i64toi32_i32$0;
            i64toi32_i32$0 = $27$hi;
            i64toi32_i32$2 = $27;
            i64toi32_i32$1 = 0;
            i64toi32_i32$3 = 8;
            i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
            if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
             i64toi32_i32$1 = 0;
             $110 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
            } else {
             i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
             $110 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
            }
            $19 = $110;
            $19$hi = i64toi32_i32$1;
            i64toi32_i32$0 = $2 + 312 | 0;
            i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
            i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
            $21 = i64toi32_i32$1;
            $21$hi = i64toi32_i32$2;
            i64toi32_i32$0 = ($2 + 288 | 0) + 16 | 0;
            i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
            i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
            $20 = i64toi32_i32$2;
            $20$hi = i64toi32_i32$1;
            $3 = HEAP32[($2 + 344 | 0) >> 2] | 0;
            i64toi32_i32$1 = $27$hi;
            $5 = $27;
            break label$9;
           }
           alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($2 + 300 | 0 | 0, 1051628 | 0, 33 | 0);
           $3 = 0;
           $1 = ($2 + 288 | 0) + 8 | 0;
           HEAP32[$1 >> 2] = 0;
           i64toi32_i32$0 = $2 + 320 | 0;
           i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $283 = i64toi32_i32$1;
           i64toi32_i32$1 = ($2 + 224 | 0) + 8 | 0;
           HEAP32[i64toi32_i32$1 >> 2] = $283;
           HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
           i64toi32_i32$0 = $2 + 328 | 0;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $289 = i64toi32_i32$2;
           i64toi32_i32$2 = ($2 + 224 | 0) + 16 | 0;
           HEAP32[i64toi32_i32$2 >> 2] = $289;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
           i64toi32_i32$0 = $2 + 312 | 0;
           i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $293 = i64toi32_i32$1;
           i64toi32_i32$1 = $2;
           HEAP32[(i64toi32_i32$1 + 224 | 0) >> 2] = $293;
           HEAP32[(i64toi32_i32$1 + 228 | 0) >> 2] = i64toi32_i32$2;
           i64toi32_i32$0 = i64toi32_i32$1;
           i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 289 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 290 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 291 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 292 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$1 = 0;
           $295 = i64toi32_i32$2;
           $295$hi = i64toi32_i32$1;
           i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 293 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 294 | 0) >> 0] | 0) << 8 | 0) | 0;
           i64toi32_i32$2 = 0;
           $297 = i64toi32_i32$1;
           $297$hi = i64toi32_i32$2;
           i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 295 | 0) >> 0] | 0;
           i64toi32_i32$1 = 0;
           i64toi32_i32$0 = i64toi32_i32$2;
           i64toi32_i32$2 = 0;
           i64toi32_i32$3 = 16;
           i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
           if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
            i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
            $111 = 0;
           } else {
            i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
            $111 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
           }
           $300$hi = i64toi32_i32$2;
           i64toi32_i32$2 = $297$hi;
           i64toi32_i32$1 = $297;
           i64toi32_i32$0 = $300$hi;
           i64toi32_i32$3 = $111;
           i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
           i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
           i64toi32_i32$1 = 0;
           i64toi32_i32$3 = 32;
           i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
           if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
            i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
            $112 = 0;
           } else {
            i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
            $112 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
           }
           $302$hi = i64toi32_i32$1;
           i64toi32_i32$1 = $295$hi;
           i64toi32_i32$0 = $295;
           i64toi32_i32$2 = $302$hi;
           i64toi32_i32$3 = $112;
           i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
           $19 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
           $19$hi = i64toi32_i32$2;
           i64toi32_i32$1 = ($2 + 288 | 0) + 16 | 0;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $21 = i64toi32_i32$2;
           $21$hi = i64toi32_i32$0;
           i64toi32_i32$1 = $1;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $20 = i64toi32_i32$0;
           $20$hi = i64toi32_i32$2;
           $5 = 4;
           break label$4;
          }
          i64toi32_i32$1 = $2 + 328 | 0;
          i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
          $315 = i64toi32_i32$2;
          i64toi32_i32$2 = ($2 + 224 | 0) + 8 | 0;
          HEAP32[i64toi32_i32$2 >> 2] = $315;
          HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
          i64toi32_i32$1 = $2 + 336 | 0;
          i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
          i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
          $320 = i64toi32_i32$0;
          i64toi32_i32$0 = $2 + 240 | 0;
          HEAP32[i64toi32_i32$0 >> 2] = $320;
          HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
          HEAP32[(($2 + 208 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 356 | 0) >> 2] | 0;
          i64toi32_i32$1 = $2 + 320 | 0;
          i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
          $330 = i64toi32_i32$2;
          i64toi32_i32$2 = $2;
          HEAP32[(i64toi32_i32$2 + 224 | 0) >> 2] = $330;
          HEAP32[(i64toi32_i32$2 + 228 | 0) >> 2] = i64toi32_i32$0;
          i64toi32_i32$1 = i64toi32_i32$2 + 348 | 0;
          i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
          i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
          $334 = i64toi32_i32$0;
          i64toi32_i32$0 = $2;
          HEAP32[(i64toi32_i32$0 + 208 | 0) >> 2] = $334;
          HEAP32[(i64toi32_i32$0 + 212 | 0) >> 2] = i64toi32_i32$2;
          i64toi32_i32$1 = i64toi32_i32$0;
          i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 297 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 298 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 299 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 300 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          i64toi32_i32$0 = 0;
          $336 = i64toi32_i32$2;
          $336$hi = i64toi32_i32$0;
          i64toi32_i32$1 = i64toi32_i32$1 + 301 | 0;
          i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
          i64toi32_i32$2 = 0;
          $339 = i64toi32_i32$0;
          $339$hi = i64toi32_i32$2;
          i64toi32_i32$1 = $2 + 303 | 0;
          i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
          i64toi32_i32$0 = 0;
          i64toi32_i32$1 = i64toi32_i32$2;
          i64toi32_i32$2 = 0;
          i64toi32_i32$3 = 16;
          i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
          if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
           i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
           $113 = 0;
          } else {
           i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
           $113 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
          }
          $343$hi = i64toi32_i32$2;
          i64toi32_i32$2 = $339$hi;
          i64toi32_i32$0 = $339;
          i64toi32_i32$1 = $343$hi;
          i64toi32_i32$3 = $113;
          i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
          i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
          i64toi32_i32$0 = 0;
          i64toi32_i32$3 = 32;
          i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
          if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
           i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
           $114 = 0;
          } else {
           i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
           $114 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
          }
          $345$hi = i64toi32_i32$0;
          i64toi32_i32$0 = $336$hi;
          i64toi32_i32$1 = $336;
          i64toi32_i32$2 = $345$hi;
          i64toi32_i32$3 = $114;
          i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
          $19 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
          $19$hi = i64toi32_i32$2;
          $3 = HEAP32[($2 + 344 | 0) >> 2] | 0;
          i64toi32_i32$0 = $2;
          i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 312 | 0) >> 2] | 0;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 316 | 0) >> 2] | 0;
          $21 = i64toi32_i32$2;
          $21$hi = i64toi32_i32$1;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 304 | 0) >> 2] | 0;
          i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 308 | 0) >> 2] | 0;
          $20 = i64toi32_i32$1;
          $20$hi = i64toi32_i32$2;
          $5 = HEAPU8[(i64toi32_i32$0 + 296 | 0) >> 0] | 0;
         }
         if (($5 & 255 | 0 | 0) != (19 | 0)) {
          break label$4
         }
         break label$3;
        }
        i64toi32_i32$0 = $2 + 320 | 0;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
        $363 = i64toi32_i32$2;
        i64toi32_i32$2 = $2 + 232 | 0;
        HEAP32[i64toi32_i32$2 >> 2] = $363;
        HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$0 = $2 + 328 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
        $369 = i64toi32_i32$1;
        i64toi32_i32$1 = ($2 + 224 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $369;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
        i64toi32_i32$0 = ($2 + 288 | 0) + 24 | 0;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
        $374 = i64toi32_i32$2;
        i64toi32_i32$2 = $2;
        HEAP32[(i64toi32_i32$2 + 224 | 0) >> 2] = $374;
        HEAP32[(i64toi32_i32$2 + 228 | 0) >> 2] = i64toi32_i32$1;
        $5 = 2;
        break label$5;
       }
       i64toi32_i32$0 = $2 + 320 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
       $379 = i64toi32_i32$1;
       i64toi32_i32$1 = $2 + 232 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $379;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$0 = $2 + 328 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
       $385 = i64toi32_i32$2;
       i64toi32_i32$2 = ($2 + 224 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $385;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$0 = $2 + 312 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
       $389 = i64toi32_i32$1;
       i64toi32_i32$1 = $2;
       HEAP32[(i64toi32_i32$1 + 224 | 0) >> 2] = $389;
       HEAP32[(i64toi32_i32$1 + 228 | 0) >> 2] = i64toi32_i32$2;
      }
     }
     i64toi32_i32$2 = $21$hi;
     i64toi32_i32$1 = ($2 + 288 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $21;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$2 = $20$hi;
     i64toi32_i32$1 = ($2 + 288 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $20;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$0 = $2;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 224 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 228 | 0) >> 2] | 0;
     $401 = i64toi32_i32$2;
     i64toi32_i32$2 = i64toi32_i32$0 + 312 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $401;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 208 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 212 | 0) >> 2] | 0;
     $405 = i64toi32_i32$1;
     i64toi32_i32$1 = i64toi32_i32$0 + 340 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $405;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$0 = (i64toi32_i32$0 + 224 | 0) + 8 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $411 = i64toi32_i32$2;
     i64toi32_i32$2 = $2 + 320 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $411;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$0 = ($2 + 224 | 0) + 16 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $417 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 328 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $417;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
     HEAP32[($2 + 348 | 0) >> 2] = HEAP32[(($2 + 208 | 0) + 8 | 0) >> 2] | 0;
     HEAP8[($2 + 288 | 0) >> 0] = $5;
     HEAP32[($2 + 336 | 0) >> 2] = $3;
     i64toi32_i32$2 = $19$hi;
     HEAP8[($2 + 289 | 0) >> 0] = $19;
     HEAP8[($2 + 290 | 0) >> 0] = $19 >>> 8 | 0;
     HEAP8[($2 + 291 | 0) >> 0] = $19 >>> 16 | 0;
     HEAP8[($2 + 292 | 0) >> 0] = $19 >>> 24 | 0;
     $430 = $2;
     i64toi32_i32$0 = $19;
     i64toi32_i32$1 = 0;
     i64toi32_i32$3 = 48;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$1 = 0;
      $115 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
     } else {
      i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
      $115 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
     }
     HEAP8[($430 + 295 | 0) >> 0] = $115;
     $433 = $2;
     i64toi32_i32$1 = $19$hi;
     i64toi32_i32$2 = $19;
     i64toi32_i32$0 = 0;
     i64toi32_i32$3 = 32;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$0 = 0;
      $116 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
     } else {
      i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
      $116 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
     }
     $117 = $433;
     $118 = $116;
     HEAP8[($117 + 293 | 0) >> 0] = $118;
     HEAP8[($117 + 294 | 0) >> 0] = $118 >>> 8 | 0;
     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($2 + 144 | 0 | 0, $2 + 288 | 0 | 0, 1051661 | 0, 11 | 0);
     $1 = HEAPU8[($2 + 144 | 0) >> 0] | 0;
     if (($1 | 0) != (19 | 0)) {
      break label$2
     }
    }
    memcpy($0 + 8 | 0 | 0, $2 + 40 | 0 | 0, 40 | 0) | 0;
    i64toi32_i32$0 = 0;
    $19 = 0;
    $19$hi = i64toi32_i32$0;
    break label$1;
   }
   memcpy($2 + 81 | 0 | 0, $2 + 144 | 0 | 1 | 0 | 0, 63 | 0) | 0;
   HEAP8[($0 + 8 | 0) >> 0] = $1;
   memcpy($0 + 9 | 0 | 0, $2 + 81 | 0 | 0, 63 | 0) | 0;
   $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__h16511d8898c4755a($2 + 40 | 0 | 0);
   label$16 : {
    if (!(HEAP32[($2 + 56 | 0) >> 2] | 0)) {
     break label$16
    }
    hashbrown__raw__RawTable_T_2cA___free_buckets__h04a09610ca2977a1(($2 + 40 | 0) + 16 | 0 | 0);
   }
   i64toi32_i32$0 = 0;
   $19 = 1;
   $19$hi = i64toi32_i32$0;
  }
  i64toi32_i32$0 = $19$hi;
  i64toi32_i32$2 = $0;
  HEAP32[i64toi32_i32$2 >> 2] = $19;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 368 | 0;
 }
 
 function cardano_serialization_lib__tx_builder__TransactionBuilder__set_certs__h6392865994434751($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $5 = 0, $14 = 0, $12 = 0, $15 = 0, $4 = 0, $3 = 0, $8 = 0, $11 = 0, $59 = 0, $60 = 0, $61 = 0, $62 = 0, $63 = 0, $64 = 0, $65 = 0, $66 = 0, $67 = 0, $68 = 0, $69 = 0, $70 = 0, $71 = 0, $72 = 0, $73 = 0, $74 = 0, $75 = 0, $76 = 0, $77 = 0, $78 = 0, $80 = 0, $81 = 0, $82 = 0, $84 = 0, $85 = 0, $13 = 0, $33 = 0, $6 = 0, $7 = 0, $9 = 0, $10 = 0, $79 = 0, $83 = 0, $87 = 0, $102 = 0, $106 = 0, $110 = 0, $142 = 0, $148 = 0, $151 = 0, $181 = 0, $188 = 0, $191 = 0, $203 = 0, $207 = 0, $211 = 0, $235 = 0, $241 = 0, $244 = 0, $264 = 0, $271 = 0, $274 = 0, $286 = 0, $290 = 0, $294 = 0, $318 = 0, $324 = 0, $327 = 0, $345 = 0, $352 = 0, $356 = 0, $368 = 0, $372 = 0, $376 = 0, $400 = 0, $406 = 0, $409 = 0, $429 = 0, $433 = 0, $436 = 0;
  $2 = global$0 - 336 | 0;
  global$0 = $2;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h965baa5031061a2e($2 + 112 | 0 | 0, $1 | 0);
  core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__Certificates____h3bab90286ab8bbb4_1($0 + 428 | 0 | 0);
  $3 = ($2 + 112 | 0) + 8 | 0;
  HEAP32[($0 + 436 | 0) >> 2] = HEAP32[$3 >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 112 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 116 | 0) >> 2] | 0;
  $33 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 428 | 0) >> 2] = $33;
  HEAP32[(i64toi32_i32$0 + 432 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
        if (!$4) {
         break label$6
        }
        $5 = HEAP32[$1 >> 2] | 0;
        $6 = $5 + Math_imul($4, 200) | 0;
        $7 = $0 + 136 | 0;
        $8 = $2 + 212 | 0;
        $9 = ($2 + 112 | 0) + 32 | 0;
        $10 = HEAP32[(0 + 1050212 | 0) >> 2] | 0;
        $11 = $2 + 80 | 0 | 1 | 0;
        $12 = $2 + 112 | 0 | 1 | 0;
        $4 = ($2 + 112 | 0) + 24 | 0;
        $13 = ($2 + 112 | 0) + 16 | 0;
        label$7 : while (1) {
         i64toi32_i32$0 = $2;
         i64toi32_i32$1 = 0;
         HEAP32[($2 + 36 | 0) >> 2] = 0;
         HEAP32[($2 + 40 | 0) >> 2] = i64toi32_i32$1;
         HEAP32[($2 + 32 | 0) >> 2] = $10;
         label$8 : {
          label$9 : {
           label$10 : {
            switch (HEAPU8[$5 >> 0] | 0 | 0) {
            case 1:
             if ((HEAPU8[($5 + 1 | 0) >> 0] | 0 | 0) == (1 | 0)) {
              break label$5
             }
             $59 = $5 + 26 | 0;
             HEAP32[$4 >> 2] = HEAPU8[$59 >> 0] | 0 | ((HEAPU8[($59 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($59 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($59 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             i64toi32_i32$2 = $5 + 18 | 0;
             i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             $79 = i64toi32_i32$1;
             i64toi32_i32$1 = $13;
             HEAP32[i64toi32_i32$1 >> 2] = $79;
             HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
             i64toi32_i32$2 = $5 + 10 | 0;
             i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             $83 = i64toi32_i32$0;
             i64toi32_i32$0 = $3;
             HEAP32[i64toi32_i32$0 >> 2] = $83;
             HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
             i64toi32_i32$2 = $5 + 2 | 0;
             i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             $87 = i64toi32_i32$1;
             i64toi32_i32$1 = $2;
             HEAP32[($2 + 112 | 0) >> 2] = $87;
             HEAP32[($2 + 116 | 0) >> 2] = i64toi32_i32$0;
             cardano_serialization_lib__Ed25519KeyHashes__add__h0c425be96292307f($2 + 32 | 0 | 0, $2 + 112 | 0 | 0);
             break label$9;
            case 2:
             if ((HEAPU8[($5 + 1 | 0) >> 0] | 0 | 0) == (1 | 0)) {
              break label$4
             }
             $60 = $5 + 26 | 0;
             HEAP32[$4 >> 2] = HEAPU8[$60 >> 0] | 0 | ((HEAPU8[($60 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($60 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($60 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             i64toi32_i32$2 = $5 + 18 | 0;
             i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             $102 = i64toi32_i32$0;
             i64toi32_i32$0 = $13;
             HEAP32[i64toi32_i32$0 >> 2] = $102;
             HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
             i64toi32_i32$2 = $5 + 10 | 0;
             i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             $106 = i64toi32_i32$1;
             i64toi32_i32$1 = $3;
             HEAP32[i64toi32_i32$1 >> 2] = $106;
             HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
             i64toi32_i32$2 = $5 + 2 | 0;
             i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             $110 = i64toi32_i32$0;
             i64toi32_i32$0 = $2;
             HEAP32[($2 + 112 | 0) >> 2] = $110;
             HEAP32[($2 + 116 | 0) >> 2] = i64toi32_i32$1;
             cardano_serialization_lib__Ed25519KeyHashes__add__h0c425be96292307f($2 + 32 | 0 | 0, $2 + 112 | 0 | 0);
             break label$9;
            case 3:
             $14 = $5 + 8 | 0;
             cardano_serialization_lib__PoolRegistration__pool_params__h9c7664cd9d439b4e($2 + 112 | 0 | 0, $14 | 0);
             $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h25db889dc58a550d($2 + 304 | 0 | 0, $9 | 0);
             label$15 : {
              $1 = HEAP32[($2 + 312 | 0) >> 2] | 0;
              if (!$1) {
               break label$15
              }
              $0 = HEAP32[($2 + 304 | 0) >> 2] | 0;
              $1 = Math_imul($1, 28);
              label$16 : while (1) {
               $61 = $0 + 24 | 0;
               HEAP32[(($2 + 80 | 0) + 24 | 0) >> 2] = HEAPU8[$61 >> 0] | 0 | ((HEAPU8[($61 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($61 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($61 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
               i64toi32_i32$2 = $0 + 16 | 0;
               i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
               i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
               $142 = i64toi32_i32$1;
               i64toi32_i32$1 = ($2 + 80 | 0) + 16 | 0;
               HEAP32[i64toi32_i32$1 >> 2] = $142;
               HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
               i64toi32_i32$2 = $0 + 8 | 0;
               i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
               i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
               $148 = i64toi32_i32$0;
               i64toi32_i32$0 = ($2 + 80 | 0) + 8 | 0;
               HEAP32[i64toi32_i32$0 >> 2] = $148;
               HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
               i64toi32_i32$2 = $0;
               i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
               i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
               $151 = i64toi32_i32$1;
               i64toi32_i32$1 = $2;
               HEAP32[($2 + 80 | 0) >> 2] = $151;
               HEAP32[($2 + 84 | 0) >> 2] = i64toi32_i32$0;
               $0 = i64toi32_i32$2 + 28 | 0;
               cardano_serialization_lib__Ed25519KeyHashes__add__h0c425be96292307f($2 + 32 | 0 | 0, $2 + 80 | 0 | 0);
               $1 = $1 + -28 | 0;
               if ($1) {
                continue label$16
               }
               break label$16;
              };
             }
             $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h72de9eab2f0e4669($2 + 304 | 0 | 0);
             core__ptr__drop_in_place_cardano_serialization_lib__PoolParams___hacdf270b44917812($2 + 112 | 0 | 0);
             cardano_serialization_lib__PoolRegistration__pool_params__h9c7664cd9d439b4e($2 + 112 | 0 | 0, $14 | 0);
             $1 = ($2 + 304 | 0) + 24 | 0;
             $62 = $8 + 24 | 0;
             HEAP32[$1 >> 2] = HEAPU8[$62 >> 0] | 0 | ((HEAPU8[($62 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($62 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($62 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             $14 = ($2 + 304 | 0) + 16 | 0;
             i64toi32_i32$2 = $8 + 16 | 0;
             i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             $181 = i64toi32_i32$0;
             i64toi32_i32$0 = $14;
             HEAP32[i64toi32_i32$0 >> 2] = $181;
             HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
             $15 = ($2 + 304 | 0) + 8 | 0;
             i64toi32_i32$2 = $8 + 8 | 0;
             i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             $188 = i64toi32_i32$1;
             i64toi32_i32$1 = $15;
             HEAP32[i64toi32_i32$1 >> 2] = $188;
             HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
             i64toi32_i32$2 = $8;
             i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             $191 = i64toi32_i32$0;
             i64toi32_i32$0 = $2;
             HEAP32[($2 + 304 | 0) >> 2] = $191;
             HEAP32[($2 + 308 | 0) >> 2] = i64toi32_i32$1;
             alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 + 8 | 0 | 0, 28 | 0, 0 | 0);
             HEAP32[($2 + 52 | 0) >> 2] = HEAP32[($2 + 12 | 0) >> 2] | 0;
             $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
             HEAP32[($2 + 48 | 0) >> 2] = $0;
             i64toi32_i32$2 = $2;
             i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 304 | 0) >> 2] | 0;
             i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 308 | 0) >> 2] | 0;
             $203 = i64toi32_i32$1;
             i64toi32_i32$1 = $0;
             $63 = $203;
             HEAP8[i64toi32_i32$1 >> 0] = $63;
             HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $63 >>> 8 | 0;
             HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $63 >>> 16 | 0;
             HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $63 >>> 24 | 0;
             HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
             HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
             HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
             HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
             i64toi32_i32$2 = $15;
             i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
             i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
             $207 = i64toi32_i32$0;
             i64toi32_i32$0 = $0 + 8 | 0;
             $64 = $207;
             HEAP8[i64toi32_i32$0 >> 0] = $64;
             HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $64 >>> 8 | 0;
             HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $64 >>> 16 | 0;
             HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $64 >>> 24 | 0;
             HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
             HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
             HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
             HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
             i64toi32_i32$2 = $14;
             i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
             i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
             $211 = i64toi32_i32$1;
             i64toi32_i32$1 = $0 + 16 | 0;
             $65 = $211;
             HEAP8[i64toi32_i32$1 >> 0] = $65;
             HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $65 >>> 8 | 0;
             HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $65 >>> 16 | 0;
             HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $65 >>> 24 | 0;
             HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
             HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
             HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
             HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
             $66 = $0 + 24 | 0;
             $67 = HEAP32[$1 >> 2] | 0;
             HEAP8[$66 >> 0] = $67;
             HEAP8[($66 + 1 | 0) >> 0] = $67 >>> 8 | 0;
             HEAP8[($66 + 2 | 0) >> 0] = $67 >>> 16 | 0;
             HEAP8[($66 + 3 | 0) >> 0] = $67 >>> 24 | 0;
             HEAP32[($2 + 56 | 0) >> 2] = 28;
             cardano_serialization_lib__crypto__Ed25519KeyHash__from_bytes__hd3490b826cff55ec($2 + 80 | 0 | 0, $2 + 48 | 0 | 0);
             if ((HEAPU8[($2 + 80 | 0) >> 0] | 0 | 0) == (1 | 0)) {
              break label$1
             }
             $68 = $11 + 24 | 0;
             HEAP32[(($2 + 48 | 0) + 24 | 0) >> 2] = HEAPU8[$68 >> 0] | 0 | ((HEAPU8[($68 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($68 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($68 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             i64toi32_i32$2 = $11 + 16 | 0;
             i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             $235 = i64toi32_i32$0;
             i64toi32_i32$0 = ($2 + 48 | 0) + 16 | 0;
             HEAP32[i64toi32_i32$0 >> 2] = $235;
             HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
             i64toi32_i32$2 = $11 + 8 | 0;
             i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             $241 = i64toi32_i32$1;
             i64toi32_i32$1 = ($2 + 48 | 0) + 8 | 0;
             HEAP32[i64toi32_i32$1 >> 2] = $241;
             HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
             i64toi32_i32$2 = $11;
             i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             $244 = i64toi32_i32$0;
             i64toi32_i32$0 = $2;
             HEAP32[($2 + 48 | 0) >> 2] = $244;
             HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
             cardano_serialization_lib__Ed25519KeyHashes__add__h0c425be96292307f($2 + 32 | 0 | 0, $2 + 48 | 0 | 0);
             core__ptr__drop_in_place_cardano_serialization_lib__PoolParams___hacdf270b44917812($2 + 112 | 0 | 0);
             break label$9;
            case 4:
             $1 = ($2 + 80 | 0) + 24 | 0;
             $69 = $5 + 32 | 0;
             HEAP32[$1 >> 2] = HEAPU8[$69 >> 0] | 0 | ((HEAPU8[($69 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($69 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($69 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             $14 = ($2 + 80 | 0) + 16 | 0;
             i64toi32_i32$2 = $5 + 24 | 0;
             i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             $264 = i64toi32_i32$1;
             i64toi32_i32$1 = $14;
             HEAP32[i64toi32_i32$1 >> 2] = $264;
             HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
             $15 = ($2 + 80 | 0) + 8 | 0;
             i64toi32_i32$2 = $5 + 16 | 0;
             i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             $271 = i64toi32_i32$0;
             i64toi32_i32$0 = $15;
             HEAP32[i64toi32_i32$0 >> 2] = $271;
             HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
             i64toi32_i32$2 = $5;
             i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 9 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 10 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 11 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 12 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 13 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 14 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 15 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             $274 = i64toi32_i32$1;
             i64toi32_i32$1 = $2;
             HEAP32[($2 + 80 | 0) >> 2] = $274;
             HEAP32[($2 + 84 | 0) >> 2] = i64toi32_i32$0;
             alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 + 16 | 0 | 0, 28 | 0, 0 | 0);
             HEAP32[($2 + 308 | 0) >> 2] = HEAP32[($2 + 20 | 0) >> 2] | 0;
             $0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
             HEAP32[($2 + 304 | 0) >> 2] = $0;
             i64toi32_i32$2 = $2;
             i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 80 | 0) >> 2] | 0;
             i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 84 | 0) >> 2] | 0;
             $286 = i64toi32_i32$0;
             i64toi32_i32$0 = $0;
             $70 = $286;
             HEAP8[i64toi32_i32$0 >> 0] = $70;
             HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $70 >>> 8 | 0;
             HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $70 >>> 16 | 0;
             HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $70 >>> 24 | 0;
             HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
             HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
             HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
             HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
             i64toi32_i32$2 = $15;
             i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
             i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
             $290 = i64toi32_i32$1;
             i64toi32_i32$1 = $0 + 8 | 0;
             $71 = $290;
             HEAP8[i64toi32_i32$1 >> 0] = $71;
             HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $71 >>> 8 | 0;
             HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $71 >>> 16 | 0;
             HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $71 >>> 24 | 0;
             HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
             HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
             HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
             HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
             i64toi32_i32$2 = $14;
             i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
             i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
             $294 = i64toi32_i32$0;
             i64toi32_i32$0 = $0 + 16 | 0;
             $72 = $294;
             HEAP8[i64toi32_i32$0 >> 0] = $72;
             HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $72 >>> 8 | 0;
             HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $72 >>> 16 | 0;
             HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $72 >>> 24 | 0;
             HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
             HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
             HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
             HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
             $73 = $0 + 24 | 0;
             $74 = HEAP32[$1 >> 2] | 0;
             HEAP8[$73 >> 0] = $74;
             HEAP8[($73 + 1 | 0) >> 0] = $74 >>> 8 | 0;
             HEAP8[($73 + 2 | 0) >> 0] = $74 >>> 16 | 0;
             HEAP8[($73 + 3 | 0) >> 0] = $74 >>> 24 | 0;
             HEAP32[($2 + 312 | 0) >> 2] = 28;
             cardano_serialization_lib__crypto__Ed25519KeyHash__from_bytes__hd3490b826cff55ec($2 + 112 | 0 | 0, $2 + 304 | 0 | 0);
             if ((HEAPU8[($2 + 112 | 0) >> 0] | 0 | 0) == (1 | 0)) {
              break label$3
             }
             $75 = $12 + 24 | 0;
             HEAP32[(($2 + 304 | 0) + 24 | 0) >> 2] = HEAPU8[$75 >> 0] | 0 | ((HEAPU8[($75 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($75 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($75 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             i64toi32_i32$2 = $12 + 16 | 0;
             i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             $318 = i64toi32_i32$1;
             i64toi32_i32$1 = ($2 + 304 | 0) + 16 | 0;
             HEAP32[i64toi32_i32$1 >> 2] = $318;
             HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
             i64toi32_i32$2 = $12 + 8 | 0;
             i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             $324 = i64toi32_i32$0;
             i64toi32_i32$0 = ($2 + 304 | 0) + 8 | 0;
             HEAP32[i64toi32_i32$0 >> 2] = $324;
             HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
             i64toi32_i32$2 = $12;
             i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             $327 = i64toi32_i32$1;
             i64toi32_i32$1 = $2;
             HEAP32[(i64toi32_i32$1 + 304 | 0) >> 2] = $327;
             HEAP32[(i64toi32_i32$1 + 308 | 0) >> 2] = i64toi32_i32$0;
             cardano_serialization_lib__Ed25519KeyHashes__add__h0c425be96292307f(i64toi32_i32$1 + 32 | 0 | 0, i64toi32_i32$1 + 304 | 0 | 0);
             break label$9;
            case 5:
             break label$10;
            default:
             break label$8;
            };
           }
           $1 = ($2 + 80 | 0) + 24 | 0;
           $76 = $5 + 53 | 0;
           HEAP32[$1 >> 2] = HEAPU8[$76 >> 0] | 0 | ((HEAPU8[($76 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($76 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($76 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $14 = ($2 + 80 | 0) + 16 | 0;
           i64toi32_i32$2 = $5 + 45 | 0;
           i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $345 = i64toi32_i32$0;
           i64toi32_i32$0 = $14;
           HEAP32[i64toi32_i32$0 >> 2] = $345;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
           $15 = ($2 + 80 | 0) + 8 | 0;
           i64toi32_i32$2 = $5 + 37 | 0;
           i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $352 = i64toi32_i32$1;
           i64toi32_i32$1 = $15;
           HEAP32[i64toi32_i32$1 >> 2] = $352;
           HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
           i64toi32_i32$2 = $5 + 29 | 0;
           i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $356 = i64toi32_i32$0;
           i64toi32_i32$0 = $2;
           HEAP32[(i64toi32_i32$0 + 80 | 0) >> 2] = $356;
           HEAP32[(i64toi32_i32$0 + 84 | 0) >> 2] = i64toi32_i32$1;
           alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9(i64toi32_i32$0 + 24 | 0 | 0, 28 | 0, 0 | 0);
           HEAP32[(i64toi32_i32$0 + 308 | 0) >> 2] = HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] | 0;
           $0 = HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] | 0;
           HEAP32[(i64toi32_i32$0 + 304 | 0) >> 2] = $0;
           i64toi32_i32$2 = i64toi32_i32$0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 80 | 0) >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 84 | 0) >> 2] | 0;
           $368 = i64toi32_i32$1;
           i64toi32_i32$1 = $0;
           $77 = $368;
           HEAP8[i64toi32_i32$1 >> 0] = $77;
           HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $77 >>> 8 | 0;
           HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $77 >>> 16 | 0;
           HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $77 >>> 24 | 0;
           HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
           HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
           HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
           HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
           i64toi32_i32$2 = $15;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
           $372 = i64toi32_i32$0;
           i64toi32_i32$0 = $0 + 8 | 0;
           $78 = $372;
           HEAP8[i64toi32_i32$0 >> 0] = $78;
           HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $78 >>> 8 | 0;
           HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $78 >>> 16 | 0;
           HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $78 >>> 24 | 0;
           HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
           HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
           HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
           HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
           i64toi32_i32$2 = $14;
           i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
           $376 = i64toi32_i32$1;
           i64toi32_i32$1 = $0 + 16 | 0;
           $80 = $376;
           HEAP8[i64toi32_i32$1 >> 0] = $80;
           HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $80 >>> 8 | 0;
           HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $80 >>> 16 | 0;
           HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $80 >>> 24 | 0;
           HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
           HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
           HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
           HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
           $81 = $0 + 24 | 0;
           $82 = HEAP32[$1 >> 2] | 0;
           HEAP8[$81 >> 0] = $82;
           HEAP8[($81 + 1 | 0) >> 0] = $82 >>> 8 | 0;
           HEAP8[($81 + 2 | 0) >> 0] = $82 >>> 16 | 0;
           HEAP8[($81 + 3 | 0) >> 0] = $82 >>> 24 | 0;
           HEAP32[($2 + 312 | 0) >> 2] = 28;
           cardano_serialization_lib__crypto__Ed25519KeyHash__from_bytes__hd3490b826cff55ec($2 + 112 | 0 | 0, $2 + 304 | 0 | 0);
           if ((HEAPU8[($2 + 112 | 0) >> 0] | 0 | 0) == (1 | 0)) {
            break label$2
           }
           $84 = $12 + 24 | 0;
           HEAP32[(($2 + 304 | 0) + 24 | 0) >> 2] = HEAPU8[$84 >> 0] | 0 | ((HEAPU8[($84 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($84 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($84 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$2 = $12 + 16 | 0;
           i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $400 = i64toi32_i32$0;
           i64toi32_i32$0 = ($2 + 304 | 0) + 16 | 0;
           HEAP32[i64toi32_i32$0 >> 2] = $400;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
           i64toi32_i32$2 = $12 + 8 | 0;
           i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $406 = i64toi32_i32$1;
           i64toi32_i32$1 = ($2 + 304 | 0) + 8 | 0;
           HEAP32[i64toi32_i32$1 >> 2] = $406;
           HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
           i64toi32_i32$2 = $12;
           i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $409 = i64toi32_i32$0;
           i64toi32_i32$0 = $2;
           HEAP32[(i64toi32_i32$0 + 304 | 0) >> 2] = $409;
           HEAP32[(i64toi32_i32$0 + 308 | 0) >> 2] = i64toi32_i32$1;
           cardano_serialization_lib__Ed25519KeyHashes__add__h0c425be96292307f(i64toi32_i32$0 + 32 | 0 | 0, i64toi32_i32$0 + 304 | 0 | 0);
          }
          $1 = HEAP32[($2 + 40 | 0) >> 2] | 0;
          if (!$1) {
           break label$8
          }
          $0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
          $1 = Math_imul($1, 28);
          label$17 : while (1) {
           $85 = $0 + 24 | 0;
           HEAP32[$4 >> 2] = HEAPU8[$85 >> 0] | 0 | ((HEAPU8[($85 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($85 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($85 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$2 = $0 + 16 | 0;
           i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $429 = i64toi32_i32$1;
           i64toi32_i32$1 = $13;
           HEAP32[i64toi32_i32$1 >> 2] = $429;
           HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
           i64toi32_i32$2 = $0 + 8 | 0;
           i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $433 = i64toi32_i32$0;
           i64toi32_i32$0 = $3;
           HEAP32[i64toi32_i32$0 >> 2] = $433;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
           i64toi32_i32$2 = $0;
           i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $436 = i64toi32_i32$1;
           i64toi32_i32$1 = $2;
           HEAP32[(i64toi32_i32$1 + 112 | 0) >> 2] = $436;
           HEAP32[(i64toi32_i32$1 + 116 | 0) >> 2] = i64toi32_i32$0;
           alloc__collections__btree__map__BTreeMap_K_2cV___insert__h5d8c7a7452747b0f($7 | 0, i64toi32_i32$1 + 112 | 0 | 0) | 0;
           $0 = i64toi32_i32$2 + 28 | 0;
           $1 = $1 + -28 | 0;
           if ($1) {
            continue label$17
           }
           break label$17;
          };
         }
         $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h72de9eab2f0e4669($2 + 32 | 0 | 0);
         $5 = $5 + 200 | 0;
         if (($5 | 0) != ($6 | 0)) {
          continue label$7
         }
         break label$7;
        };
       }
       global$0 = $2 + 336 | 0;
       return;
      }
      core__panicking__panic__h2fd385a887c8bf13(1063668 | 0, 43 | 0, 1063864 | 0);
      abort();
     }
     core__panicking__panic__h2fd385a887c8bf13(1063668 | 0, 43 | 0, 1063848 | 0);
     abort();
    }
    HEAP32[($2 + 304 | 0) >> 2] = HEAP32[($2 + 116 | 0) >> 2] | 0;
    core__result__unwrap_failed__h27f43d993c3864a1(1063711 | 0, 43 | 0, $2 + 304 | 0 | 0, 1063756 | 0, 1063816 | 0);
    abort();
   }
   HEAP32[($2 + 304 | 0) >> 2] = HEAP32[($2 + 116 | 0) >> 2] | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1063711 | 0, 43 | 0, $2 + 304 | 0 | 0, 1063756 | 0, 1063800 | 0);
   abort();
  }
  HEAP32[($2 + 48 | 0) >> 2] = HEAP32[($2 + 84 | 0) >> 2] | 0;
  core__result__unwrap_failed__h27f43d993c3864a1(1063711 | 0, 43 | 0, $2 + 48 | 0 | 0, 1063756 | 0, 1063832 | 0);
  abort();
 }
 
 function num_bigint__bigint__subtraction___impl_20core__ops__arith__Sub_20for_20num_bigint__bigint__BigInt___sub__h02bf2323746cfdb9($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, i64toi32_i32$2 = 0, $6 = 0, $7 = 0, $5 = 0, $11 = 0, $8 = 0, $31 = 0, $21 = 0, $26 = 0, $9 = 0, $10 = 0, $104 = 0, $128 = 0, $138 = 0, $150 = 0, $213 = 0, $223 = 0, $235 = 0, $293 = 0, $316 = 0, $343 = 0, $353 = 0, $366 = 0, $390 = 0, $451 = 0;
  $3 = global$0 - 64 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    $4 = HEAPU8[($2 + 12 | 0) >> 0] | 0;
    if (($4 | 0) != (1 | 0)) {
     break label$2
    }
    i64toi32_i32$2 = $1;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $21 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[i64toi32_i32$0 >> 2] = $21;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $26 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $26;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    $0 = $0 << 2 | 0;
    if (!$0) {
     break label$1
    }
    __rust_dealloc(HEAP32[$2 >> 2] | 0 | 0, $0 | 0, 4 | 0);
    break label$1;
   }
   label$3 : {
    label$4 : {
     label$5 : {
      label$6 : {
       label$7 : {
        label$8 : {
         label$9 : {
          label$10 : {
           label$11 : {
            label$12 : {
             label$13 : {
              label$14 : {
               label$15 : {
                $5 = HEAPU8[($1 + 12 | 0) >> 0] | 0;
                switch ($5 | 0) {
                case 2:
                 break label$14;
                case 1:
                 break label$15;
                default:
                 break label$13;
                };
               }
               $6 = $2 + 13 | 0;
               $7 = 2;
               label$16 : {
                switch ($4 & 3 | 0 | 0) {
                case 1:
                 break label$11;
                case 2:
                 break label$16;
                default:
                 break label$10;
                };
               }
               $7 = 0;
               break label$10;
              }
              if ($4) {
               break label$12
              }
              break label$3;
             }
             if ($4) {
              break label$3
             }
            }
            $8 = HEAP32[$2 >> 2] | 0;
            label$17 : {
             $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
             $6 = HEAP32[($2 + 8 | 0) >> 2] | 0;
             $7 = $4 >>> 0 < $6 >>> 0 ? -1 : ($4 | 0) != ($6 | 0);
             if ($7) {
              break label$17
             }
             $9 = $8 + -4 | 0;
             $6 = $6 << 2 | 0;
             $4 = $4 << 2 | 0;
             $10 = (HEAP32[$1 >> 2] | 0) + -4 | 0;
             label$18 : while (1) {
              label$19 : {
               if ($4) {
                break label$19
               }
               $7 = $6 ? -1 : 0;
               break label$17;
              }
              if (!$6) {
               break label$7
              }
              $7 = $10 + $4 | 0;
              $11 = $9 + $6 | 0;
              $6 = $6 + -4 | 0;
              $4 = $4 + -4 | 0;
              $7 = HEAP32[$7 >> 2] | 0;
              $11 = HEAP32[$11 >> 2] | 0;
              $7 = $7 >>> 0 < $11 >>> 0 ? -1 : ($7 | 0) != ($11 | 0);
              if (!$7) {
               continue label$18
              }
              break label$18;
             };
            }
            switch ($7 + 1 | 0 | 0) {
            case 2:
             break label$7;
            case 1:
             break label$8;
            default:
             break label$9;
            };
           }
           $7 = 1;
          }
          HEAP8[($0 + 12 | 0) >> 0] = $7;
          i64toi32_i32$2 = $2;
          i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
          i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
          $104 = i64toi32_i32$0;
          i64toi32_i32$0 = $0;
          HEAP32[i64toi32_i32$0 >> 2] = $104;
          HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
          $31 = HEAPU8[$6 >> 0] | 0 | ((HEAPU8[($6 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
          HEAP8[(i64toi32_i32$0 + 13 | 0) >> 0] = $31;
          HEAP8[(i64toi32_i32$0 + 14 | 0) >> 0] = $31 >>> 8 | 0;
          HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
          HEAP8[(i64toi32_i32$0 + 15 | 0) >> 0] = HEAPU8[($6 + 2 | 0) >> 0] | 0;
          break label$4;
         }
         $4 = 0;
         $6 = 2;
         label$20 : {
          label$21 : {
           switch ($5 & 3 | 0 | 0) {
           case 1:
            $4 = 1;
            $6 = 1;
            break label$20;
           case 2:
            break label$21;
           default:
            break label$20;
           };
          }
          $4 = 0;
          $6 = 0;
         }
         HEAP32[(($3 + 32 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
         i64toi32_i32$2 = $1;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $128 = i64toi32_i32$1;
         i64toi32_i32$1 = $3;
         HEAP32[($3 + 32 | 0) >> 2] = $128;
         HEAP32[($3 + 36 | 0) >> 2] = i64toi32_i32$0;
         $1 = ($3 + 48 | 0) + 8 | 0;
         HEAP32[$1 >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
         i64toi32_i32$2 = $2;
         i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
         $138 = i64toi32_i32$0;
         i64toi32_i32$0 = $3;
         HEAP32[($3 + 48 | 0) >> 2] = $138;
         HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$1;
         num_bigint__biguint__subtraction___impl_20core__ops__arith__SubAssign__num_bigint__biguint__BigUint__20for_20num_bigint__biguint__BigUint___sub_assign__h4ea1a97f3b7bcde9($3 + 48 | 0 | 0, $3 + 32 | 0 | 0);
         HEAP32[(($3 + 16 | 0) + 8 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
         i64toi32_i32$2 = $3;
         i64toi32_i32$1 = HEAP32[($3 + 48 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($3 + 52 | 0) >> 2] | 0;
         $150 = i64toi32_i32$1;
         i64toi32_i32$1 = $3;
         HEAP32[($3 + 16 | 0) >> 2] = $150;
         HEAP32[($3 + 20 | 0) >> 2] = i64toi32_i32$0;
         label$23 : {
          $2 = HEAP32[($3 + 36 | 0) >> 2] | 0;
          if (!$2) {
           break label$23
          }
          $2 = $2 << 2 | 0;
          if (!$2) {
           break label$23
          }
          __rust_dealloc(HEAP32[($3 + 32 | 0) >> 2] | 0 | 0, $2 | 0, 4 | 0);
         }
         label$24 : {
          if ($4) {
           break label$24
          }
          $2 = HEAP32[($3 + 24 | 0) >> 2] | 0 ? $6 : 1;
          break label$5;
         }
         $4 = 0;
         HEAP32[($3 + 24 | 0) >> 2] = 0;
         $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend__T_2ccore__slice__iter__Iter_T_____spec_extend__h5cdab7a667860bc4($3 + 16 | 0 | 0, 1082816 | 0, 1082816 | 0);
         $2 = HEAP32[($3 + 24 | 0) >> 2] | 0;
         if (!$2) {
          break label$6
         }
         $1 = (($2 << 2 | 0) + (HEAP32[($3 + 16 | 0) >> 2] | 0) | 0) + -4 | 0;
         label$25 : while (1) {
          label$26 : {
           if (!(HEAP32[$1 >> 2] | 0)) {
            break label$26
           }
           $4 = $2;
           break label$6;
          }
          $2 = $2 + -1 | 0;
          HEAP32[($3 + 24 | 0) >> 2] = $2;
          $1 = $1 + -4 | 0;
          if ($2) {
           continue label$25
          }
          break label$6;
         };
        }
        i64toi32_i32$1 = $0;
        i64toi32_i32$0 = 0;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = 0;
        HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
        HEAP8[(i64toi32_i32$1 + 12 | 0) >> 0] = 1;
        HEAP32[i64toi32_i32$1 >> 2] = HEAP32[(0 + 1082808 | 0) >> 2] | 0;
        $2 = HEAP32[($2 + 4 | 0) >> 2] | 0;
        if (!$2) {
         break label$4
        }
        $2 = $2 << 2 | 0;
        if (!$2) {
         break label$4
        }
        __rust_dealloc($8 | 0, $2 | 0, 4 | 0);
        break label$4;
       }
       HEAP32[(($3 + 32 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
       i64toi32_i32$2 = $2;
       i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
       $213 = i64toi32_i32$0;
       i64toi32_i32$0 = $3;
       HEAP32[($3 + 32 | 0) >> 2] = $213;
       HEAP32[($3 + 36 | 0) >> 2] = i64toi32_i32$1;
       $2 = ($3 + 48 | 0) + 8 | 0;
       HEAP32[$2 >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
       i64toi32_i32$2 = $1;
       i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
       $223 = i64toi32_i32$1;
       i64toi32_i32$1 = $3;
       HEAP32[($3 + 48 | 0) >> 2] = $223;
       HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$0;
       num_bigint__biguint__subtraction___impl_20core__ops__arith__SubAssign__num_bigint__biguint__BigUint__20for_20num_bigint__biguint__BigUint___sub_assign__h4ea1a97f3b7bcde9($3 + 48 | 0 | 0, $3 + 32 | 0 | 0);
       HEAP32[(($3 + 16 | 0) + 8 | 0) >> 2] = HEAP32[$2 >> 2] | 0;
       i64toi32_i32$2 = $3;
       i64toi32_i32$0 = HEAP32[($3 + 48 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($3 + 52 | 0) >> 2] | 0;
       $235 = i64toi32_i32$0;
       i64toi32_i32$0 = $3;
       HEAP32[($3 + 16 | 0) >> 2] = $235;
       HEAP32[($3 + 20 | 0) >> 2] = i64toi32_i32$1;
       label$27 : {
        $2 = HEAP32[($3 + 36 | 0) >> 2] | 0;
        if (!$2) {
         break label$27
        }
        $2 = $2 << 2 | 0;
        if (!$2) {
         break label$27
        }
        __rust_dealloc(HEAP32[($3 + 32 | 0) >> 2] | 0 | 0, $2 | 0, 4 | 0);
       }
       label$28 : {
        label$29 : {
         if (($5 | 0) == (1 | 0)) {
          break label$29
         }
         $2 = HEAP32[($3 + 24 | 0) >> 2] | 0 ? $5 : 1;
         break label$28;
        }
        $4 = 0;
        HEAP32[($3 + 24 | 0) >> 2] = 0;
        $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend__T_2ccore__slice__iter__Iter_T_____spec_extend__h5cdab7a667860bc4($3 + 16 | 0 | 0, 1082816 | 0, 1082816 | 0);
        label$30 : {
         $2 = HEAP32[($3 + 24 | 0) >> 2] | 0;
         if (!$2) {
          break label$30
         }
         $1 = (($2 << 2 | 0) + (HEAP32[($3 + 16 | 0) >> 2] | 0) | 0) + -4 | 0;
         label$31 : while (1) {
          label$32 : {
           if (!(HEAP32[$1 >> 2] | 0)) {
            break label$32
           }
           $4 = $2;
           break label$30;
          }
          $2 = $2 + -1 | 0;
          HEAP32[($3 + 24 | 0) >> 2] = $2;
          $1 = $1 + -4 | 0;
          if ($2) {
           continue label$31
          }
          break label$31;
         };
        }
        $2 = 1;
        $1 = HEAP32[($3 + 20 | 0) >> 2] | 0;
        if ($1 >>> 0 <= $4 >>> 0) {
         break label$28
        }
        if ($4 >>> 0 >= ($1 >>> 2 | 0) >>> 0) {
         break label$28
        }
        alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($3 + 16 | 0 | 0, $4 | 0);
       }
       HEAP8[($0 + 12 | 0) >> 0] = $2;
       i64toi32_i32$2 = $3;
       i64toi32_i32$1 = HEAP32[($3 + 16 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[($3 + 20 | 0) >> 2] | 0;
       $293 = i64toi32_i32$1;
       i64toi32_i32$1 = $0;
       HEAP32[i64toi32_i32$1 >> 2] = $293;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($3 + 16 | 0) + 8 | 0) >> 2] | 0;
       break label$1;
      }
      $2 = 1;
      $1 = HEAP32[($3 + 20 | 0) >> 2] | 0;
      if ($1 >>> 0 <= $4 >>> 0) {
       break label$5
      }
      if ($4 >>> 0 >= ($1 >>> 2 | 0) >>> 0) {
       break label$5
      }
      alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($3 + 16 | 0 | 0, $4 | 0);
     }
     HEAP8[($0 + 12 | 0) >> 0] = $2;
     i64toi32_i32$2 = $3;
     i64toi32_i32$0 = HEAP32[($3 + 16 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($3 + 20 | 0) >> 2] | 0;
     $316 = i64toi32_i32$0;
     i64toi32_i32$0 = $0;
     HEAP32[i64toi32_i32$0 >> 2] = $316;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[(($3 + 16 | 0) + 8 | 0) >> 2] | 0;
     break label$1;
    }
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$2) {
     break label$1
    }
    $2 = $2 << 2 | 0;
    if (!$2) {
     break label$1
    }
    __rust_dealloc(HEAP32[$1 >> 2] | 0 | 0, $2 | 0, 4 | 0);
    break label$1;
   }
   $4 = $1 + 8 | 0;
   HEAP32[(($3 + 16 | 0) + 8 | 0) >> 2] = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   $343 = i64toi32_i32$1;
   i64toi32_i32$1 = $3;
   HEAP32[($3 + 16 | 0) >> 2] = $343;
   HEAP32[($3 + 20 | 0) >> 2] = i64toi32_i32$0;
   $6 = $2 + 8 | 0;
   HEAP32[(($3 + 32 | 0) + 8 | 0) >> 2] = HEAP32[$6 >> 2] | 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $353 = i64toi32_i32$0;
   i64toi32_i32$0 = $3;
   HEAP32[($3 + 32 | 0) >> 2] = $353;
   HEAP32[($3 + 36 | 0) >> 2] = i64toi32_i32$1;
   label$33 : {
    label$34 : {
     if ((HEAP32[($3 + 20 | 0) >> 2] | 0) >>> 0 < (HEAP32[($3 + 36 | 0) >> 2] | 0) >>> 0) {
      break label$34
     }
     HEAP32[(($3 + 48 | 0) + 8 | 0) >> 2] = HEAP32[$4 >> 2] | 0;
     i64toi32_i32$2 = $1;
     i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $366 = i64toi32_i32$1;
     i64toi32_i32$1 = $3;
     HEAP32[($3 + 48 | 0) >> 2] = $366;
     HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$0;
     num_bigint__biguint__addition___impl_20core__ops__arith__Add__num_bigint__biguint__BigUint__20for_20num_bigint__biguint__BigUint___add__ha6a5672f04e3ed65($3 | 0, $3 + 48 | 0 | 0, $3 + 32 | 0 | 0);
     $2 = HEAP32[($3 + 36 | 0) >> 2] | 0;
     if (!$2) {
      break label$33
     }
     $2 = $2 << 2 | 0;
     if (!$2) {
      break label$33
     }
     __rust_dealloc(HEAP32[($3 + 32 | 0) >> 2] | 0 | 0, $2 | 0, 4 | 0);
     break label$33;
    }
    HEAP32[(($3 + 48 | 0) + 8 | 0) >> 2] = HEAP32[$6 >> 2] | 0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
    $390 = i64toi32_i32$0;
    i64toi32_i32$0 = $3;
    HEAP32[($3 + 48 | 0) >> 2] = $390;
    HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$1;
    num_bigint__biguint__addition___impl_20core__ops__arith__Add__num_bigint__biguint__BigUint__20for_20num_bigint__biguint__BigUint___add__ha6a5672f04e3ed65($3 | 0, $3 + 48 | 0 | 0, $3 + 16 | 0 | 0);
    $2 = HEAP32[($3 + 20 | 0) >> 2] | 0;
    if (!$2) {
     break label$33
    }
    $2 = $2 << 2 | 0;
    if (!$2) {
     break label$33
    }
    __rust_dealloc(HEAP32[($3 + 16 | 0) >> 2] | 0 | 0, $2 | 0, 4 | 0);
   }
   label$35 : {
    label$36 : {
     if (($5 | 0) == (1 | 0)) {
      break label$36
     }
     $2 = HEAP32[($3 + 8 | 0) >> 2] | 0 ? $5 : 1;
     break label$35;
    }
    $4 = 0;
    HEAP32[($3 + 8 | 0) >> 2] = 0;
    $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend__T_2ccore__slice__iter__Iter_T_____spec_extend__h5cdab7a667860bc4($3 | 0, 1082816 | 0, 1082816 | 0);
    label$37 : {
     $2 = HEAP32[($3 + 8 | 0) >> 2] | 0;
     if (!$2) {
      break label$37
     }
     $1 = (($2 << 2 | 0) + (HEAP32[$3 >> 2] | 0) | 0) + -4 | 0;
     label$38 : while (1) {
      label$39 : {
       if (!(HEAP32[$1 >> 2] | 0)) {
        break label$39
       }
       $4 = $2;
       break label$37;
      }
      $2 = $2 + -1 | 0;
      HEAP32[($3 + 8 | 0) >> 2] = $2;
      $1 = $1 + -4 | 0;
      if ($2) {
       continue label$38
      }
      break label$38;
     };
    }
    $2 = 1;
    $1 = HEAP32[($3 + 4 | 0) >> 2] | 0;
    if ($1 >>> 0 <= $4 >>> 0) {
     break label$35
    }
    if ($4 >>> 0 >= ($1 >>> 2 | 0) >>> 0) {
     break label$35
    }
    alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($3 | 0, $4 | 0);
   }
   HEAP8[($0 + 12 | 0) >> 0] = $2;
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[$3 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($3 + 4 | 0) >> 2] | 0;
   $451 = i64toi32_i32$1;
   i64toi32_i32$1 = $0;
   HEAP32[i64toi32_i32$1 >> 2] = $451;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[($3 + 8 | 0) >> 2] | 0;
  }
  global$0 = $3 + 64 | 0;
 }
 
 function $cardano_serialization_lib__plutus__PlutusMap_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h76a53e332887551d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, i64toi32_i32$2 = 0, $12 = 0, $11 = 0, $16 = 0, $16$hi = 0, $17 = 0, $17$hi = 0, $13 = 0, $18 = 0, $18$hi = 0, $63 = 0, $64 = 0, $6 = 0, $14 = 0, $65 = 0, $66 = 0, $67 = 0, $68 = 0, $69 = 0, $70 = 0, $71 = 0, $72 = 0, $73 = 0, $74 = 0, $75 = 0, $76 = 0, $77 = 0, $78 = 0, $80 = 0, $81 = 0, $82 = 0, $83 = 0, $84 = 0, $85 = 0, $86 = 0, $88 = 0, $89 = 0, $90 = 0, $4 = 0, $7 = 0, $9 = 0, $3 = 0, $10 = 0, $15 = 0, $5 = 0, $8 = 0, $79 = 0, $87 = 0, $96 = 0, $111 = 0, $119 = 0, $123 = 0, $135 = 0, $138 = 0, $147 = 0, $162 = 0, $168 = 0, $177 = 0, $191 = 0, $195 = 0, $199 = 0, $263 = 0, $270 = 0, $273 = 0, $282 = 0, $300 = 0, $306 = 0, $316 = 0, $335 = 0, $342 = 0, $345 = 0, $354 = 0, $363 = 0, $369 = 0, $373 = 0, $378 = 0, $384 = 0, $388 = 0, $405 = 0, $409 = 0, $415 = 0, $421 = 0, $448 = 0;
  $2 = global$0 - 448 | 0;
  global$0 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 12 | 0) >> 2] = 0;
  HEAP32[($2 + 16 | 0) >> 2] = i64toi32_i32$0;
  cbor_event__de__Deserializer_R___map__h7c2a4e830d885a05($2 + 280 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = ($2 + 280 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $16 = i64toi32_i32$0;
  $16$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 288 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 292 | 0) >> 2] | 0;
  $17 = i64toi32_i32$1;
  $17$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          i64toi32_i32$2 = $2;
          i64toi32_i32$0 = HEAP32[($2 + 280 | 0) >> 2] | 0;
          i64toi32_i32$1 = HEAP32[($2 + 284 | 0) >> 2] | 0;
          i64toi32_i32$2 = i64toi32_i32$0;
          i64toi32_i32$0 = 0;
          i64toi32_i32$3 = 1;
          if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
           break label$8
          }
          i64toi32_i32$2 = $16$hi;
          $3 = $16;
          label$9 : {
           i64toi32_i32$2 = $17$hi;
           i64toi32_i32$3 = $17;
           i64toi32_i32$1 = 0;
           i64toi32_i32$0 = 1;
           if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
            break label$9
           }
           if (!$3) {
            break label$3
           }
          }
          $4 = ($2 + 280 | 0) + 24 | 0;
          $5 = $2 + 280 | 0 | 1 | 0;
          $6 = $2 + 312 | 0;
          $7 = ($2 + 200 | 0) + 24 | 0;
          $8 = $2 + 200 | 0 | 1 | 0;
          $9 = $2 + 289 | 0;
          $10 = $9 + 3 | 0;
          label$10 : {
           label$11 : {
            label$12 : {
             label$13 : while (1) {
              std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 | 0, $1 | 0);
              $11 = 0;
              $12 = 2;
              label$14 : {
               if (HEAP32[($2 + 4 | 0) >> 2] | 0) {
                break label$14
               }
               i64toi32_i32$3 = 0;
               $17 = 8;
               $17$hi = i64toi32_i32$3;
               i64toi32_i32$3 = 0;
               $16 = 0;
               $16$hi = i64toi32_i32$3;
               break label$4;
              }
              label$15 : {
               if ((($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[$2 >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) == (7 | 0)) {
                break label$15
               }
               $cardano_serialization_lib__plutus__PlutusData_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__haa2b047fc7012f29($2 + 280 | 0 | 0, $1 | 0);
               $11 = ($2 + 400 | 0) + 8 | 0;
               $13 = $6 + 8 | 0;
               i64toi32_i32$0 = $13;
               i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
               i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
               $79 = i64toi32_i32$3;
               i64toi32_i32$3 = $11;
               HEAP32[i64toi32_i32$3 >> 2] = $79;
               HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
               $14 = ($2 + 400 | 0) + 16 | 0;
               $15 = $6 + 16 | 0;
               i64toi32_i32$0 = $15;
               i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
               i64toi32_i32$3 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
               $87 = i64toi32_i32$2;
               i64toi32_i32$2 = $14;
               HEAP32[i64toi32_i32$2 >> 2] = $87;
               HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
               $65 = $9;
               HEAP32[($2 + 352 | 0) >> 2] = HEAPU8[$65 >> 0] | 0 | ((HEAPU8[($65 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($65 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($65 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
               $66 = $10;
               $67 = HEAPU8[$66 >> 0] | 0 | ((HEAPU8[($66 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($66 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($66 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
               HEAP8[($2 + 355 | 0) >> 0] = $67;
               HEAP8[($2 + 356 | 0) >> 0] = $67 >>> 8 | 0;
               HEAP8[($2 + 357 | 0) >> 0] = $67 >>> 16 | 0;
               HEAP8[($2 + 358 | 0) >> 0] = $67 >>> 24 | 0;
               i64toi32_i32$0 = $6;
               i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
               i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
               $96 = i64toi32_i32$3;
               i64toi32_i32$3 = $2;
               HEAP32[($2 + 400 | 0) >> 2] = $96;
               HEAP32[($2 + 404 | 0) >> 2] = i64toi32_i32$2;
               i64toi32_i32$0 = $2;
               i64toi32_i32$2 = HEAP32[($2 + 304 | 0) >> 2] | 0;
               i64toi32_i32$3 = HEAP32[($2 + 308 | 0) >> 2] | 0;
               $16 = i64toi32_i32$2;
               $16$hi = i64toi32_i32$3;
               i64toi32_i32$0 = $2;
               i64toi32_i32$3 = HEAP32[($2 + 296 | 0) >> 2] | 0;
               i64toi32_i32$2 = HEAP32[($2 + 300 | 0) >> 2] | 0;
               $18 = i64toi32_i32$3;
               $18$hi = i64toi32_i32$2;
               $12 = HEAPU8[($2 + 288 | 0) >> 0] | 0;
               i64toi32_i32$0 = $2;
               i64toi32_i32$2 = HEAP32[($2 + 280 | 0) >> 2] | 0;
               i64toi32_i32$3 = HEAP32[($2 + 284 | 0) >> 2] | 0;
               i64toi32_i32$0 = i64toi32_i32$2;
               i64toi32_i32$2 = 0;
               i64toi32_i32$1 = 1;
               if ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) | 0) {
                break label$10
               }
               $63 = $8;
               $68 = HEAP32[($2 + 352 | 0) >> 2] | 0;
               HEAP8[$63 >> 0] = $68;
               HEAP8[($63 + 1 | 0) >> 0] = $68 >>> 8 | 0;
               HEAP8[($63 + 2 | 0) >> 0] = $68 >>> 16 | 0;
               HEAP8[($63 + 3 | 0) >> 0] = $68 >>> 24 | 0;
               i64toi32_i32$1 = $2;
               i64toi32_i32$0 = HEAP32[($2 + 400 | 0) >> 2] | 0;
               i64toi32_i32$3 = HEAP32[($2 + 404 | 0) >> 2] | 0;
               $111 = i64toi32_i32$0;
               i64toi32_i32$0 = $7;
               $69 = $111;
               HEAP8[i64toi32_i32$0 >> 0] = $69;
               HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $69 >>> 8 | 0;
               HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $69 >>> 16 | 0;
               HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $69 >>> 24 | 0;
               HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$3;
               HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
               HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
               HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
               $70 = $63 + 3 | 0;
               $71 = HEAPU8[($2 + 355 | 0) >> 0] | 0 | ((HEAPU8[($2 + 356 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 357 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 358 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
               HEAP8[$70 >> 0] = $71;
               HEAP8[($70 + 1 | 0) >> 0] = $71 >>> 8 | 0;
               HEAP8[($70 + 2 | 0) >> 0] = $71 >>> 16 | 0;
               HEAP8[($70 + 3 | 0) >> 0] = $71 >>> 24 | 0;
               i64toi32_i32$1 = $11;
               i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
               i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
               $119 = i64toi32_i32$3;
               i64toi32_i32$3 = $7 + 8 | 0;
               $72 = $119;
               HEAP8[i64toi32_i32$3 >> 0] = $72;
               HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $72 >>> 8 | 0;
               HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $72 >>> 16 | 0;
               HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $72 >>> 24 | 0;
               HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$0;
               HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
               HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
               HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
               i64toi32_i32$1 = $14;
               i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
               i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
               $123 = i64toi32_i32$0;
               i64toi32_i32$0 = $7 + 16 | 0;
               $73 = $123;
               HEAP8[i64toi32_i32$0 >> 0] = $73;
               HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $73 >>> 8 | 0;
               HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $73 >>> 16 | 0;
               HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $73 >>> 24 | 0;
               HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$3;
               HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
               HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
               HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
               HEAP8[($2 + 200 | 0) >> 0] = $12;
               i64toi32_i32$3 = $16$hi;
               i64toi32_i32$0 = $2;
               HEAP32[($2 + 216 | 0) >> 2] = $16;
               HEAP32[($2 + 220 | 0) >> 2] = i64toi32_i32$3;
               i64toi32_i32$3 = $18$hi;
               i64toi32_i32$0 = $2;
               HEAP32[($2 + 208 | 0) >> 2] = $18;
               HEAP32[($2 + 212 | 0) >> 2] = i64toi32_i32$3;
               $cardano_serialization_lib__plutus__PlutusData_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__haa2b047fc7012f29($2 + 280 | 0 | 0, $1 | 0);
               i64toi32_i32$1 = $13;
               i64toi32_i32$3 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
               i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
               $135 = i64toi32_i32$3;
               i64toi32_i32$3 = $11;
               HEAP32[i64toi32_i32$3 >> 2] = $135;
               HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
               i64toi32_i32$1 = $15;
               i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
               i64toi32_i32$3 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
               $138 = i64toi32_i32$0;
               i64toi32_i32$0 = $14;
               HEAP32[i64toi32_i32$0 >> 2] = $138;
               HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
               $74 = $9;
               HEAP32[($2 + 352 | 0) >> 2] = HEAPU8[$74 >> 0] | 0 | ((HEAPU8[($74 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($74 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($74 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
               $75 = $10;
               $76 = HEAPU8[$75 >> 0] | 0 | ((HEAPU8[($75 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($75 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($75 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
               HEAP8[($2 + 355 | 0) >> 0] = $76;
               HEAP8[($2 + 356 | 0) >> 0] = $76 >>> 8 | 0;
               HEAP8[($2 + 357 | 0) >> 0] = $76 >>> 16 | 0;
               HEAP8[($2 + 358 | 0) >> 0] = $76 >>> 24 | 0;
               i64toi32_i32$1 = $6;
               i64toi32_i32$3 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
               i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
               $147 = i64toi32_i32$3;
               i64toi32_i32$3 = $2;
               HEAP32[($2 + 400 | 0) >> 2] = $147;
               HEAP32[($2 + 404 | 0) >> 2] = i64toi32_i32$0;
               i64toi32_i32$1 = $2;
               i64toi32_i32$0 = HEAP32[($2 + 304 | 0) >> 2] | 0;
               i64toi32_i32$3 = HEAP32[($2 + 308 | 0) >> 2] | 0;
               $16 = i64toi32_i32$0;
               $16$hi = i64toi32_i32$3;
               i64toi32_i32$1 = $2;
               i64toi32_i32$3 = HEAP32[($2 + 296 | 0) >> 2] | 0;
               i64toi32_i32$0 = HEAP32[($2 + 300 | 0) >> 2] | 0;
               $18 = i64toi32_i32$3;
               $18$hi = i64toi32_i32$0;
               $12 = HEAPU8[($2 + 288 | 0) >> 0] | 0;
               i64toi32_i32$1 = $2;
               i64toi32_i32$0 = HEAP32[($2 + 280 | 0) >> 2] | 0;
               i64toi32_i32$3 = HEAP32[($2 + 284 | 0) >> 2] | 0;
               i64toi32_i32$1 = i64toi32_i32$0;
               i64toi32_i32$0 = 0;
               i64toi32_i32$2 = 1;
               if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) | 0) {
                break label$12
               }
               $13 = ($2 + 248 | 0) + 8 | 0;
               i64toi32_i32$2 = $11;
               i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
               i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
               $162 = i64toi32_i32$1;
               i64toi32_i32$1 = $13;
               HEAP32[i64toi32_i32$1 >> 2] = $162;
               HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
               $11 = ($2 + 248 | 0) + 16 | 0;
               i64toi32_i32$2 = $14;
               i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
               i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
               $168 = i64toi32_i32$3;
               i64toi32_i32$3 = $11;
               HEAP32[i64toi32_i32$3 >> 2] = $168;
               HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
               HEAP32[($2 + 272 | 0) >> 2] = HEAP32[($2 + 352 | 0) >> 2] | 0;
               $77 = HEAPU8[($2 + 355 | 0) >> 0] | 0 | ((HEAPU8[($2 + 356 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 357 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 358 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
               HEAP8[($2 + 275 | 0) >> 0] = $77;
               HEAP8[($2 + 276 | 0) >> 0] = $77 >>> 8 | 0;
               HEAP8[($2 + 277 | 0) >> 0] = $77 >>> 16 | 0;
               HEAP8[($2 + 278 | 0) >> 0] = $77 >>> 24 | 0;
               i64toi32_i32$2 = $2;
               i64toi32_i32$1 = HEAP32[($2 + 400 | 0) >> 2] | 0;
               i64toi32_i32$3 = HEAP32[($2 + 404 | 0) >> 2] | 0;
               $177 = i64toi32_i32$1;
               i64toi32_i32$1 = $2;
               HEAP32[($2 + 248 | 0) >> 2] = $177;
               HEAP32[($2 + 252 | 0) >> 2] = i64toi32_i32$3;
               $cardano_serialization_lib__plutus__PlutusData_20as_20core__clone__Clone___clone__h63d1a98cc18f4609_2($2 + 400 | 0 | 0, $2 + 200 | 0 | 0);
               $64 = $5;
               $78 = HEAP32[($2 + 272 | 0) >> 2] | 0;
               HEAP8[$64 >> 0] = $78;
               HEAP8[($64 + 1 | 0) >> 0] = $78 >>> 8 | 0;
               HEAP8[($64 + 2 | 0) >> 0] = $78 >>> 16 | 0;
               HEAP8[($64 + 3 | 0) >> 0] = $78 >>> 24 | 0;
               $80 = $64 + 3 | 0;
               $81 = HEAPU8[($2 + 275 | 0) >> 0] | 0 | ((HEAPU8[($2 + 276 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 277 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 278 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
               HEAP8[$80 >> 0] = $81;
               HEAP8[($80 + 1 | 0) >> 0] = $81 >>> 8 | 0;
               HEAP8[($80 + 2 | 0) >> 0] = $81 >>> 16 | 0;
               HEAP8[($80 + 3 | 0) >> 0] = $81 >>> 24 | 0;
               i64toi32_i32$2 = $2;
               i64toi32_i32$3 = HEAP32[($2 + 248 | 0) >> 2] | 0;
               i64toi32_i32$1 = HEAP32[($2 + 252 | 0) >> 2] | 0;
               $191 = i64toi32_i32$3;
               i64toi32_i32$3 = $4;
               $82 = $191;
               HEAP8[i64toi32_i32$3 >> 0] = $82;
               HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $82 >>> 8 | 0;
               HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $82 >>> 16 | 0;
               HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $82 >>> 24 | 0;
               HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$1;
               HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
               HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
               HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
               i64toi32_i32$2 = $13;
               i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
               i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
               $195 = i64toi32_i32$1;
               i64toi32_i32$1 = $4 + 8 | 0;
               $83 = $195;
               HEAP8[i64toi32_i32$1 >> 0] = $83;
               HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $83 >>> 8 | 0;
               HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $83 >>> 16 | 0;
               HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $83 >>> 24 | 0;
               HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$3;
               HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
               HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
               HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
               i64toi32_i32$2 = $11;
               i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
               i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
               $199 = i64toi32_i32$3;
               i64toi32_i32$3 = $4 + 16 | 0;
               $84 = $199;
               HEAP8[i64toi32_i32$3 >> 0] = $84;
               HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $84 >>> 8 | 0;
               HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $84 >>> 16 | 0;
               HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $84 >>> 24 | 0;
               HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$1;
               HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
               HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
               HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
               HEAP8[($2 + 280 | 0) >> 0] = $12;
               i64toi32_i32$1 = $16$hi;
               i64toi32_i32$3 = $2;
               HEAP32[($2 + 296 | 0) >> 2] = $16;
               HEAP32[($2 + 300 | 0) >> 2] = i64toi32_i32$1;
               i64toi32_i32$1 = $18$hi;
               i64toi32_i32$3 = $2;
               HEAP32[($2 + 288 | 0) >> 2] = $18;
               HEAP32[($2 + 292 | 0) >> 2] = i64toi32_i32$1;
               alloc__collections__btree__map__BTreeMap_K_2cV___insert__hb14f14f8e669d8cf($2 + 352 | 0 | 0, $2 + 8 | 0 | 0, $2 + 400 | 0 | 0, $2 + 280 | 0 | 0);
               if ((HEAP32[($2 + 352 | 0) >> 2] | 0 | 0) != (5 | 0)) {
                break label$11
               }
               core__ptr__drop_in_place_cardano_serialization_lib__plutus__PlutusData___hfab843e66e0f9428_1($2 + 200 | 0 | 0);
               i64toi32_i32$1 = $17$hi;
               i64toi32_i32$2 = $17;
               i64toi32_i32$3 = 0;
               i64toi32_i32$0 = 1;
               if ((i64toi32_i32$2 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$3 | 0) | 0) {
                continue label$13
               }
               if ((HEAP32[($2 + 16 | 0) >> 2] | 0) >>> 0 < $3 >>> 0) {
                continue label$13
               }
               break label$3;
              }
              break label$13;
             };
             cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 280 | 0 | 0, $1 | 0);
             i64toi32_i32$0 = ($2 + 280 | 0) + 16 | 0;
             i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
             i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
             $16 = i64toi32_i32$2;
             $16$hi = i64toi32_i32$1;
             i64toi32_i32$0 = $2;
             i64toi32_i32$1 = HEAP32[($2 + 288 | 0) >> 2] | 0;
             i64toi32_i32$2 = HEAP32[($2 + 292 | 0) >> 2] | 0;
             $17 = i64toi32_i32$1;
             $17$hi = i64toi32_i32$2;
             i64toi32_i32$0 = $2;
             i64toi32_i32$2 = HEAP32[($2 + 280 | 0) >> 2] | 0;
             i64toi32_i32$1 = HEAP32[($2 + 284 | 0) >> 2] | 0;
             i64toi32_i32$0 = i64toi32_i32$2;
             i64toi32_i32$2 = 0;
             i64toi32_i32$3 = 1;
             if ((i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) | 0) {
              break label$7
             }
             i64toi32_i32$0 = $16$hi;
             i64toi32_i32$1 = $2 + 360 | 0;
             HEAP32[i64toi32_i32$1 >> 2] = $16;
             HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
             i64toi32_i32$0 = $17$hi;
             i64toi32_i32$1 = $2;
             HEAP32[($2 + 352 | 0) >> 2] = $17;
             HEAP32[($2 + 356 | 0) >> 2] = i64toi32_i32$0;
             if (($17 & 255 | 0 | 0) == (5 | 0)) {
              break label$3
             }
             HEAP32[($2 + 280 | 0) >> 2] = 0;
             core__panicking__assert_failed__h96d8431cc974b591(0 | 0, $2 + 352 | 0 | 0, 1070752 | 0, $2 + 280 | 0 | 0, 1070976 | 0);
             abort();
            }
            HEAP32[(($2 + 152 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 348 | 0) >> 2] | 0;
            i64toi32_i32$3 = ($2 + 400 | 0) + 8 | 0;
            i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
            i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
            $263 = i64toi32_i32$0;
            i64toi32_i32$0 = ($2 + 168 | 0) + 8 | 0;
            HEAP32[i64toi32_i32$0 >> 2] = $263;
            HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
            i64toi32_i32$3 = ($2 + 400 | 0) + 16 | 0;
            i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
            i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
            $270 = i64toi32_i32$1;
            i64toi32_i32$1 = ($2 + 168 | 0) + 16 | 0;
            HEAP32[i64toi32_i32$1 >> 2] = $270;
            HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
            i64toi32_i32$3 = $2;
            i64toi32_i32$0 = HEAP32[($2 + 340 | 0) >> 2] | 0;
            i64toi32_i32$1 = HEAP32[($2 + 344 | 0) >> 2] | 0;
            $273 = i64toi32_i32$0;
            i64toi32_i32$0 = $2;
            HEAP32[($2 + 152 | 0) >> 2] = $273;
            HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$1;
            HEAP32[($2 + 192 | 0) >> 2] = HEAP32[($2 + 352 | 0) >> 2] | 0;
            $85 = HEAPU8[($2 + 355 | 0) >> 0] | 0 | ((HEAPU8[($2 + 356 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 357 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 358 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            HEAP8[($2 + 195 | 0) >> 0] = $85;
            HEAP8[($2 + 196 | 0) >> 0] = $85 >>> 8 | 0;
            HEAP8[($2 + 197 | 0) >> 0] = $85 >>> 16 | 0;
            HEAP8[($2 + 198 | 0) >> 0] = $85 >>> 24 | 0;
            i64toi32_i32$3 = $2;
            i64toi32_i32$1 = HEAP32[($2 + 400 | 0) >> 2] | 0;
            i64toi32_i32$0 = HEAP32[($2 + 404 | 0) >> 2] | 0;
            $282 = i64toi32_i32$1;
            i64toi32_i32$1 = $2;
            HEAP32[($2 + 168 | 0) >> 2] = $282;
            HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$0;
            $11 = HEAP32[($2 + 336 | 0) >> 2] | 0;
            i64toi32_i32$0 = $18$hi;
            $17 = $18;
            $17$hi = i64toi32_i32$0;
            break label$6;
           }
           core__ptr__drop_in_place_cardano_serialization_lib__plutus__PlutusData___hfab843e66e0f9428_1($2 + 352 | 0 | 0);
           alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($2 + 292 | 0 | 0, 1070880 | 0, 33 | 0);
           $11 = 0;
           $12 = ($2 + 280 | 0) + 8 | 0;
           HEAP32[$12 >> 2] = 0;
           i64toi32_i32$3 = $2 + 312 | 0;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
           $300 = i64toi32_i32$0;
           i64toi32_i32$0 = ($2 + 168 | 0) + 8 | 0;
           HEAP32[i64toi32_i32$0 >> 2] = $300;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
           i64toi32_i32$3 = $2 + 320 | 0;
           i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
           $306 = i64toi32_i32$1;
           i64toi32_i32$1 = ($2 + 168 | 0) + 16 | 0;
           HEAP32[i64toi32_i32$1 >> 2] = $306;
           HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
           HEAP32[($2 + 192 | 0) >> 2] = HEAPU8[($2 + 281 | 0) >> 0] | 0 | ((HEAPU8[($2 + 282 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 283 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 284 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $86 = HEAPU8[($2 + 284 | 0) >> 0] | 0 | ((HEAPU8[($2 + 285 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 286 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 287 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 195 | 0) >> 0] = $86;
           HEAP8[($2 + 196 | 0) >> 0] = $86 >>> 8 | 0;
           HEAP8[($2 + 197 | 0) >> 0] = $86 >>> 16 | 0;
           HEAP8[($2 + 198 | 0) >> 0] = $86 >>> 24 | 0;
           i64toi32_i32$3 = $2 + 304 | 0;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
           $316 = i64toi32_i32$0;
           i64toi32_i32$0 = $2;
           HEAP32[($2 + 168 | 0) >> 2] = $316;
           HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$1;
           i64toi32_i32$3 = ($2 + 280 | 0) + 16 | 0;
           i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
           $16 = i64toi32_i32$1;
           $16$hi = i64toi32_i32$0;
           i64toi32_i32$3 = $12;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
           $17 = i64toi32_i32$0;
           $17$hi = i64toi32_i32$1;
           $12 = 4;
           break label$6;
          }
          HEAP32[(($2 + 152 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 348 | 0) >> 2] | 0;
          i64toi32_i32$3 = ($2 + 400 | 0) + 8 | 0;
          i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
          $335 = i64toi32_i32$1;
          i64toi32_i32$1 = ($2 + 168 | 0) + 8 | 0;
          HEAP32[i64toi32_i32$1 >> 2] = $335;
          HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
          i64toi32_i32$3 = ($2 + 400 | 0) + 16 | 0;
          i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
          $342 = i64toi32_i32$0;
          i64toi32_i32$0 = ($2 + 168 | 0) + 16 | 0;
          HEAP32[i64toi32_i32$0 >> 2] = $342;
          HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
          i64toi32_i32$3 = $2;
          i64toi32_i32$1 = HEAP32[($2 + 340 | 0) >> 2] | 0;
          i64toi32_i32$0 = HEAP32[($2 + 344 | 0) >> 2] | 0;
          $345 = i64toi32_i32$1;
          i64toi32_i32$1 = $2;
          HEAP32[($2 + 152 | 0) >> 2] = $345;
          HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
          HEAP32[($2 + 192 | 0) >> 2] = HEAP32[($2 + 352 | 0) >> 2] | 0;
          $88 = HEAPU8[($2 + 355 | 0) >> 0] | 0 | ((HEAPU8[($2 + 356 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 357 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 358 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          HEAP8[($2 + 195 | 0) >> 0] = $88;
          HEAP8[($2 + 196 | 0) >> 0] = $88 >>> 8 | 0;
          HEAP8[($2 + 197 | 0) >> 0] = $88 >>> 16 | 0;
          HEAP8[($2 + 198 | 0) >> 0] = $88 >>> 24 | 0;
          i64toi32_i32$3 = $2;
          i64toi32_i32$0 = HEAP32[($2 + 400 | 0) >> 2] | 0;
          i64toi32_i32$1 = HEAP32[($2 + 404 | 0) >> 2] | 0;
          $354 = i64toi32_i32$0;
          i64toi32_i32$0 = $2;
          HEAP32[($2 + 168 | 0) >> 2] = $354;
          HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$1;
          $11 = HEAP32[($2 + 336 | 0) >> 2] | 0;
          i64toi32_i32$1 = $18$hi;
          $17 = $18;
          $17$hi = i64toi32_i32$1;
          break label$5;
         }
         i64toi32_i32$3 = $2 + 312 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $363 = i64toi32_i32$1;
         i64toi32_i32$1 = $2 + 176 | 0;
         HEAP32[i64toi32_i32$1 >> 2] = $363;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$3 = $2 + 320 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $369 = i64toi32_i32$0;
         i64toi32_i32$0 = ($2 + 168 | 0) + 16 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $369;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$3 = $2 + 304 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $373 = i64toi32_i32$1;
         i64toi32_i32$1 = $2;
         HEAP32[($2 + 168 | 0) >> 2] = $373;
         HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$0;
         $11 = 0;
         $12 = 2;
         break label$4;
        }
        i64toi32_i32$3 = $2 + 312 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $378 = i64toi32_i32$0;
        i64toi32_i32$0 = $2 + 176 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $378;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$3 = $2 + 320 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $384 = i64toi32_i32$1;
        i64toi32_i32$1 = ($2 + 168 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $384;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$3 = $2 + 304 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $388 = i64toi32_i32$0;
        i64toi32_i32$0 = $2;
        HEAP32[($2 + 168 | 0) >> 2] = $388;
        HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$1;
        break label$4;
       }
       core__ptr__drop_in_place_cardano_serialization_lib__plutus__PlutusData___hfab843e66e0f9428_1($2 + 200 | 0 | 0);
      }
      if (($12 & 255 | 0 | 0) == (19 | 0)) {
       break label$3
      }
     }
     i64toi32_i32$1 = $16$hi;
     i64toi32_i32$0 = ($2 + 280 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $16;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $17$hi;
     i64toi32_i32$0 = ($2 + 280 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $17;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$3 = $2;
     i64toi32_i32$1 = HEAP32[($2 + 168 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 172 | 0) >> 2] | 0;
     $405 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 304 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $405;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$3 = $2;
     i64toi32_i32$0 = HEAP32[($2 + 152 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 156 | 0) >> 2] | 0;
     $409 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 332 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $409;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$3 = ($2 + 168 | 0) + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $415 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 312 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $415;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$3 = ($2 + 168 | 0) + 16 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $421 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 320 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $421;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($2 + 340 | 0) >> 2] = HEAP32[(($2 + 152 | 0) + 8 | 0) >> 2] | 0;
     HEAP8[($2 + 280 | 0) >> 0] = $12;
     $89 = HEAP32[($2 + 192 | 0) >> 2] | 0;
     HEAP8[($2 + 281 | 0) >> 0] = $89;
     HEAP8[($2 + 282 | 0) >> 0] = $89 >>> 8 | 0;
     HEAP8[($2 + 283 | 0) >> 0] = $89 >>> 16 | 0;
     HEAP8[($2 + 284 | 0) >> 0] = $89 >>> 24 | 0;
     $90 = HEAPU8[($2 + 195 | 0) >> 0] | 0 | ((HEAPU8[($2 + 196 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 197 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 198 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($2 + 284 | 0) >> 0] = $90;
     HEAP8[($2 + 285 | 0) >> 0] = $90 >>> 8 | 0;
     HEAP8[($2 + 286 | 0) >> 0] = $90 >>> 16 | 0;
     HEAP8[($2 + 287 | 0) >> 0] = $90 >>> 24 | 0;
     HEAP32[($2 + 328 | 0) >> 2] = $11;
     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($2 + 88 | 0 | 0, $2 + 280 | 0 | 0, 1070992 | 0, 9 | 0);
     $1 = HEAPU8[($2 + 88 | 0) >> 0] | 0;
     if (($1 | 0) != (19 | 0)) {
      break label$2
     }
    }
    i64toi32_i32$3 = $2;
    i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $448 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $448;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
    $12 = 0;
    break label$1;
   }
   $12 = 1;
   memcpy($2 + 25 | 0 | 0, $2 + 88 | 0 | 1 | 0 | 0, 63 | 0) | 0;
   HEAP8[($0 + 8 | 0) >> 0] = $1;
   memcpy($0 + 9 | 0 | 0, $2 + 25 | 0 | 0, 63 | 0) | 0;
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h50a5c5eb0f530455($2 + 8 | 0 | 0);
  }
  HEAP32[$0 >> 2] = $12;
  global$0 = $2 + 448 | 0;
 }
 
 function $cardano_serialization_lib__utils__Value_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hfd20dfadce0ab65b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, $8 = 0, $8$hi = 0, $10 = 0, $10$hi = 0, $7 = 0, $4 = 0, $7$hi = 0, $5 = 0, $6 = 0, $12 = 0, $12$hi = 0, $3 = 0, $11 = 0, $9 = 0, $9$hi = 0, $11$hi = 0, $51 = 0, $52 = 0, $53 = 0, $54 = 0, $55 = 0, $56 = 0, $57 = 0, $58 = 0, $59 = 0, $158 = 0, $167 = 0, $171 = 0, $213 = 0, $222 = 0, $226 = 0, $238 = 0, $242 = 0, $275 = 0, $285 = 0, $288 = 0, $337 = 0, $347 = 0, $351 = 0, $389 = 0, $393 = 0, $399 = 0, $408 = 0, $410$hi = 0, $413 = 0, $413$hi = 0, $414 = 0, $427 = 0, $429$hi = 0, $431 = 0, $431$hi = 0, $432 = 0;
  $2 = global$0 - 320 | 0;
  global$0 = $2;
  std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 8 | 0 | 0, $1 | 0);
  i64toi32_i32$0 = 0;
  $7 = 0;
  $7$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if (HEAP32[($2 + 12 | 0) >> 2] | 0) {
       break label$4
      }
      $3 = 0;
      $4 = 8;
      $5 = 2;
      i64toi32_i32$0 = 0;
      $8 = 0;
      $8$hi = i64toi32_i32$0;
      $6 = 0;
      break label$3;
     }
     $5 = 11;
     $3 = 0;
     label$5 : {
      label$6 : {
       label$7 : {
        label$8 : {
         label$9 : {
          label$10 : {
           switch (($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[($2 + 8 | 0) >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) {
           case 4:
            cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 248 | 0 | 0, $1 | 0);
            i64toi32_i32$2 = $2 + 264 | 0;
            i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
            i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
            $8 = i64toi32_i32$0;
            $8$hi = i64toi32_i32$1;
            i64toi32_i32$2 = $2;
            i64toi32_i32$1 = HEAP32[($2 + 256 | 0) >> 2] | 0;
            i64toi32_i32$0 = HEAP32[($2 + 260 | 0) >> 2] | 0;
            $9 = i64toi32_i32$1;
            $9$hi = i64toi32_i32$0;
            i64toi32_i32$2 = $2;
            i64toi32_i32$0 = HEAP32[($2 + 248 | 0) >> 2] | 0;
            i64toi32_i32$1 = HEAP32[($2 + 252 | 0) >> 2] | 0;
            i64toi32_i32$2 = i64toi32_i32$0;
            i64toi32_i32$0 = 0;
            i64toi32_i32$3 = 1;
            if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
             break label$7
            }
            $cardano_serialization_lib__utils__BigNum_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h29637bb571dceb02($2 + 248 | 0 | 0, $1 | 0);
            i64toi32_i32$3 = $2;
            i64toi32_i32$2 = HEAP32[($2 + 256 | 0) >> 2] | 0;
            i64toi32_i32$1 = HEAP32[($2 + 260 | 0) >> 2] | 0;
            $10 = i64toi32_i32$2;
            $10$hi = i64toi32_i32$1;
            i64toi32_i32$3 = $2;
            i64toi32_i32$1 = HEAP32[($2 + 248 | 0) >> 2] | 0;
            i64toi32_i32$2 = HEAP32[($2 + 252 | 0) >> 2] | 0;
            i64toi32_i32$3 = i64toi32_i32$1;
            i64toi32_i32$1 = 0;
            i64toi32_i32$0 = 1;
            if ((i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$1 | 0) | 0) {
             break label$6
            }
            cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__MultiAsset___deserialize__h0ad8d9aa7509b889($2 + 248 | 0 | 0, $1 | 0);
            if ((HEAP32[($2 + 248 | 0) >> 2] | 0 | 0) == (1 | 0)) {
             break label$5
            }
            HEAP32[(($2 + 32 | 0) + 12 | 0) >> 2] = HEAP32[(($2 + 248 | 0) + 12 | 0) >> 2] | 0;
            i64toi32_i32$0 = $2;
            i64toi32_i32$3 = HEAP32[($2 + 252 | 0) >> 2] | 0;
            i64toi32_i32$2 = HEAP32[($2 + 256 | 0) >> 2] | 0;
            $7 = i64toi32_i32$3;
            $7$hi = i64toi32_i32$2;
            i64toi32_i32$3 = $2;
            HEAP32[($2 + 36 | 0) >> 2] = $7;
            HEAP32[($2 + 40 | 0) >> 2] = i64toi32_i32$2;
            i64toi32_i32$0 = $2 + 40 | 0;
            i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
            i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
            $11 = i64toi32_i32$2;
            $11$hi = i64toi32_i32$3;
            i64toi32_i32$2 = $2 + 272 | 0;
            HEAP32[i64toi32_i32$2 >> 2] = $11;
            HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
            HEAP32[($2 + 264 | 0) >> 2] = 1;
            i64toi32_i32$3 = $7$hi;
            $6 = $7;
            HEAP32[($2 + 268 | 0) >> 2] = $7;
            i64toi32_i32$3 = $10$hi;
            i64toi32_i32$2 = $2;
            HEAP32[($2 + 256 | 0) >> 2] = $10;
            HEAP32[($2 + 260 | 0) >> 2] = i64toi32_i32$3;
            i64toi32_i32$2 = $2;
            i64toi32_i32$3 = 0;
            HEAP32[($2 + 248 | 0) >> 2] = 0;
            HEAP32[($2 + 252 | 0) >> 2] = i64toi32_i32$3;
            label$12 : {
             label$13 : {
              label$14 : {
               label$15 : {
                label$16 : {
                 label$17 : {
                  i64toi32_i32$3 = $9$hi;
                  i64toi32_i32$0 = $9;
                  i64toi32_i32$2 = 0;
                  i64toi32_i32$1 = 1;
                  if ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) | 0) {
                   break label$17
                  }
                  cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 104 | 0 | 0, $1 | 0);
                  $1 = HEAPU8[($2 + 112 | 0) >> 0] | 0;
                  i64toi32_i32$1 = $2;
                  i64toi32_i32$0 = HEAP32[($2 + 104 | 0) >> 2] | 0;
                  i64toi32_i32$3 = HEAP32[($2 + 108 | 0) >> 2] | 0;
                  i64toi32_i32$1 = i64toi32_i32$0;
                  i64toi32_i32$0 = 0;
                  i64toi32_i32$2 = 1;
                  if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) | 0) {
                   break label$16
                  }
                  $5 = 5;
                  if (($1 | 0) == (5 | 0)) {
                   break label$9
                  }
                  break label$15;
                 }
                 i64toi32_i32$1 = 0;
                 $12 = 2;
                 $12$hi = i64toi32_i32$1;
                 label$18 : {
                  i64toi32_i32$1 = $8$hi;
                  i64toi32_i32$2 = $8;
                  i64toi32_i32$3 = 0;
                  i64toi32_i32$0 = 2;
                  if ((i64toi32_i32$2 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$3 | 0) | 0) {
                   break label$18
                  }
                  $1 = 0;
                  $4 = 1;
                  break label$8;
                 }
                 i64toi32_i32$2 = $8$hi;
                 i64toi32_i32$0 = $8;
                 i64toi32_i32$1 = 0;
                 i64toi32_i32$3 = 32;
                 i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
                 if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                  i64toi32_i32$1 = 0;
                  $51 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
                 } else {
                  i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
                  $51 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
                 }
                 $6 = $51;
                 i64toi32_i32$1 = $8$hi;
                 $4 = $8;
                 i64toi32_i32$1 = 0;
                 $8 = 1;
                 $8$hi = i64toi32_i32$1;
                 $5 = 3;
                 break label$14;
                }
                i64toi32_i32$2 = $2 + 144 | 0;
                i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                $8 = i64toi32_i32$1;
                $8$hi = i64toi32_i32$0;
                i64toi32_i32$1 = ($2 + 32 | 0) + 8 | 0;
                HEAP32[i64toi32_i32$1 >> 2] = $8;
                HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                i64toi32_i32$1 = ($2 + 176 | 0) + 8 | 0;
                HEAP32[i64toi32_i32$1 >> 2] = $8;
                HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                i64toi32_i32$2 = $2 + 136 | 0;
                i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                $8 = i64toi32_i32$0;
                $8$hi = i64toi32_i32$1;
                i64toi32_i32$0 = $2;
                HEAP32[($2 + 32 | 0) >> 2] = $8;
                HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
                i64toi32_i32$0 = $2;
                HEAP32[($2 + 176 | 0) >> 2] = $8;
                HEAP32[($2 + 180 | 0) >> 2] = i64toi32_i32$1;
                $4 = (HEAPU8[($2 + 113 | 0) >> 0] | 0 | ((HEAPU8[($2 + 114 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 115 | 0) >> 0] | 0) << 16 | 0) | 0) << 8 | 0 | $1 | 0;
                i64toi32_i32$2 = $2 + 128 | 0;
                i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                $12 = i64toi32_i32$1;
                $12$hi = i64toi32_i32$0;
                i64toi32_i32$2 = ($2 + 104 | 0) + 16 | 0;
                i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                $8 = i64toi32_i32$0;
                $8$hi = i64toi32_i32$1;
                $6 = HEAP32[($2 + 116 | 0) >> 2] | 0;
                $5 = 2;
               }
               i64toi32_i32$2 = $2;
               i64toi32_i32$1 = HEAP32[($2 + 248 | 0) >> 2] | 0;
               i64toi32_i32$0 = HEAP32[($2 + 252 | 0) >> 2] | 0;
               i64toi32_i32$2 = i64toi32_i32$1;
               i64toi32_i32$1 = 0;
               i64toi32_i32$3 = 0;
               if ((i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | 0) {
                break label$13
               }
              }
              if (!(HEAP32[($2 + 264 | 0) >> 2] | 0)) {
               break label$12
              }
              $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 268 | 0 | 0);
              break label$12;
             }
             core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9_4($2 + 256 | 0 | 0);
            }
            i64toi32_i32$2 = 0;
            $7 = 0;
            $7$hi = i64toi32_i32$2;
            break label$3;
           case 0:
            break label$10;
           default:
            break label$3;
           };
          }
          $cardano_serialization_lib__utils__BigNum_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h29637bb571dceb02($2 + 248 | 0 | 0, $1 | 0);
          i64toi32_i32$3 = $2;
          i64toi32_i32$2 = HEAP32[($2 + 256 | 0) >> 2] | 0;
          i64toi32_i32$0 = HEAP32[($2 + 260 | 0) >> 2] | 0;
          $10 = i64toi32_i32$2;
          $10$hi = i64toi32_i32$0;
          label$19 : {
           i64toi32_i32$3 = $2;
           i64toi32_i32$0 = HEAP32[($2 + 248 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($2 + 252 | 0) >> 2] | 0;
           i64toi32_i32$3 = i64toi32_i32$0;
           i64toi32_i32$0 = 0;
           i64toi32_i32$1 = 1;
           if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) | 0) {
            break label$19
           }
           i64toi32_i32$3 = $10$hi;
           i64toi32_i32$1 = $10;
           i64toi32_i32$2 = 0;
           i64toi32_i32$0 = 8;
           i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
           if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
            i64toi32_i32$2 = 0;
            $52 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
           } else {
            i64toi32_i32$2 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
            $52 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
           }
           $7 = $52;
           $7$hi = i64toi32_i32$2;
           $4 = 0;
           break label$2;
          }
          i64toi32_i32$3 = $2 + 296 | 0;
          i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
          $158 = i64toi32_i32$2;
          i64toi32_i32$2 = ($2 + 176 | 0) + 8 | 0;
          HEAP32[i64toi32_i32$2 >> 2] = $158;
          HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
          HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 316 | 0) >> 2] | 0;
          i64toi32_i32$3 = $2;
          i64toi32_i32$1 = HEAP32[($2 + 308 | 0) >> 2] | 0;
          i64toi32_i32$2 = HEAP32[($2 + 312 | 0) >> 2] | 0;
          $167 = i64toi32_i32$1;
          i64toi32_i32$1 = $2;
          HEAP32[($2 + 16 | 0) >> 2] = $167;
          HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$2;
          i64toi32_i32$3 = $2 + 288 | 0;
          i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
          $171 = i64toi32_i32$2;
          i64toi32_i32$2 = $2;
          HEAP32[($2 + 176 | 0) >> 2] = $171;
          HEAP32[($2 + 180 | 0) >> 2] = i64toi32_i32$1;
          i64toi32_i32$1 = $10$hi;
          i64toi32_i32$3 = $10;
          i64toi32_i32$2 = 0;
          i64toi32_i32$0 = 8;
          i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
          if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
           i64toi32_i32$2 = 0;
           $53 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
          } else {
           i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
           $53 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$4 | 0) | 0;
          }
          $7 = $53;
          $7$hi = i64toi32_i32$2;
          i64toi32_i32$1 = $2 + 280 | 0;
          i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
          i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
          $12 = i64toi32_i32$2;
          $12$hi = i64toi32_i32$3;
          i64toi32_i32$1 = $2 + 272 | 0;
          i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
          i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
          $8 = i64toi32_i32$3;
          $8$hi = i64toi32_i32$2;
          $6 = HEAP32[($2 + 268 | 0) >> 2] | 0;
          $4 = HEAP32[($2 + 264 | 0) >> 2] | 0;
          $3 = HEAP32[($2 + 304 | 0) >> 2] | 0;
          i64toi32_i32$2 = $10$hi;
          $5 = $10;
          break label$3;
         }
         i64toi32_i32$1 = $2;
         i64toi32_i32$2 = HEAP32[($2 + 248 | 0) >> 2] | 0;
         i64toi32_i32$3 = HEAP32[($2 + 252 | 0) >> 2] | 0;
         i64toi32_i32$1 = i64toi32_i32$2;
         i64toi32_i32$2 = 0;
         i64toi32_i32$0 = 1;
         $1 = (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) | 0;
         $3 = HEAP32[($2 + 304 | 0) >> 2] | 0;
         i64toi32_i32$0 = $2 + 280 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
         $12 = i64toi32_i32$1;
         $12$hi = i64toi32_i32$3;
         i64toi32_i32$0 = $2;
         i64toi32_i32$3 = HEAP32[($2 + 272 | 0) >> 2] | 0;
         i64toi32_i32$1 = HEAP32[($2 + 276 | 0) >> 2] | 0;
         $11 = i64toi32_i32$3;
         $11$hi = i64toi32_i32$1;
         $6 = HEAP32[($2 + 268 | 0) >> 2] | 0;
         $4 = HEAP32[($2 + 264 | 0) >> 2] | 0;
         i64toi32_i32$0 = $2;
         i64toi32_i32$1 = HEAP32[($2 + 256 | 0) >> 2] | 0;
         i64toi32_i32$3 = HEAP32[($2 + 260 | 0) >> 2] | 0;
         $10 = i64toi32_i32$1;
         $10$hi = i64toi32_i32$3;
        }
        i64toi32_i32$0 = $2 + 296 | 0;
        i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
        $213 = i64toi32_i32$3;
        i64toi32_i32$3 = ($2 + 176 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$3 >> 2] = $213;
        HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
        HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 316 | 0) >> 2] | 0;
        i64toi32_i32$0 = $2;
        i64toi32_i32$1 = HEAP32[($2 + 308 | 0) >> 2] | 0;
        i64toi32_i32$3 = HEAP32[($2 + 312 | 0) >> 2] | 0;
        $222 = i64toi32_i32$1;
        i64toi32_i32$1 = $2;
        HEAP32[($2 + 16 | 0) >> 2] = $222;
        HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$3;
        i64toi32_i32$0 = $2 + 288 | 0;
        i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
        $226 = i64toi32_i32$3;
        i64toi32_i32$3 = $2;
        HEAP32[($2 + 176 | 0) >> 2] = $226;
        HEAP32[($2 + 180 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$1 = $10$hi;
        i64toi32_i32$0 = $10;
        i64toi32_i32$3 = 0;
        i64toi32_i32$2 = 8;
        i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
         i64toi32_i32$3 = 0;
         $54 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
        } else {
         i64toi32_i32$3 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
         $54 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
        }
        $7 = $54;
        $7$hi = i64toi32_i32$3;
        if (!$1) {
         break label$2
        }
        i64toi32_i32$3 = $10$hi;
        $5 = $10;
        i64toi32_i32$3 = $11$hi;
        $8 = $11;
        $8$hi = i64toi32_i32$3;
        break label$3;
       }
       i64toi32_i32$1 = $2 + 288 | 0;
       i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $238 = i64toi32_i32$3;
       i64toi32_i32$3 = $2 + 184 | 0;
       HEAP32[i64toi32_i32$3 >> 2] = $238;
       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$1 = $2 + 280 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $242 = i64toi32_i32$0;
       i64toi32_i32$0 = $2;
       HEAP32[($2 + 176 | 0) >> 2] = $242;
       HEAP32[($2 + 180 | 0) >> 2] = i64toi32_i32$3;
       i64toi32_i32$3 = $9$hi;
       i64toi32_i32$1 = $9;
       i64toi32_i32$0 = 0;
       i64toi32_i32$2 = 32;
       i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = 0;
        $55 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$0 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
        $55 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
       }
       $6 = $55;
       i64toi32_i32$3 = $2 + 272 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $12 = i64toi32_i32$0;
       $12$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $9$hi;
       $4 = $9;
       $5 = 2;
       break label$3;
      }
      memcpy($2 + 32 | 0 | 0, ($2 + 248 | 0) + 16 | 0 | 0, 56 | 0) | 0;
      i64toi32_i32$1 = $10$hi;
      i64toi32_i32$0 = $2;
      HEAP32[($2 + 248 | 0) >> 2] = $10;
      HEAP32[($2 + 252 | 0) >> 2] = i64toi32_i32$1;
      memcpy(($2 + 248 | 0) + 8 | 0 | 0, $2 + 32 | 0 | 0, 56 | 0) | 0;
      cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e(($2 + 104 | 0) + 8 | 0 | 0, $2 + 248 | 0 | 0, 1057790 | 0, 4 | 0);
      i64toi32_i32$3 = $2 + 152 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $275 = i64toi32_i32$1;
      i64toi32_i32$1 = ($2 + 176 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $275;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 172 | 0) >> 2] | 0;
      i64toi32_i32$3 = $2 + 144 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $285 = i64toi32_i32$0;
      i64toi32_i32$0 = $2;
      HEAP32[($2 + 176 | 0) >> 2] = $285;
      HEAP32[($2 + 180 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$3 = $2;
      i64toi32_i32$1 = HEAP32[($2 + 164 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($2 + 168 | 0) >> 2] | 0;
      $288 = i64toi32_i32$1;
      i64toi32_i32$1 = $2;
      HEAP32[($2 + 16 | 0) >> 2] = $288;
      HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$3 = $2;
      i64toi32_i32$0 = HEAP32[($2 + 112 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($2 + 116 | 0) >> 2] | 0;
      $10 = i64toi32_i32$0;
      $10$hi = i64toi32_i32$1;
      i64toi32_i32$3 = i64toi32_i32$0;
      i64toi32_i32$0 = 0;
      i64toi32_i32$2 = 8;
      i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
       i64toi32_i32$0 = 0;
       $56 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
      } else {
       i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
       $56 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$4 | 0) | 0;
      }
      $7 = $56;
      $7$hi = i64toi32_i32$0;
      $4 = HEAP32[(($2 + 104 | 0) + 16 | 0) >> 2] | 0;
      $6 = HEAP32[($2 + 124 | 0) >> 2] | 0;
      i64toi32_i32$1 = $2 + 128 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $8 = i64toi32_i32$0;
      $8$hi = i64toi32_i32$3;
      i64toi32_i32$1 = $2 + 136 | 0;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $12 = i64toi32_i32$3;
      $12$hi = i64toi32_i32$0;
      $3 = HEAP32[(($2 + 104 | 0) + 56 | 0) >> 2] | 0;
      i64toi32_i32$0 = $10$hi;
      $5 = $10;
      break label$3;
     }
     memcpy($2 + 248 | 0 | 0, memcpy(($2 + 104 | 0) + 8 | 0 | 0, memcpy($2 + 176 | 0 | 4 | 0 | 0, ($2 + 248 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
     $1 = ($2 + 32 | 0) + 8 | 0;
     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $2 + 248 | 0 | 0, 1057794 | 0, 10 | 0);
     i64toi32_i32$1 = $2 + 80 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $337 = i64toi32_i32$0;
     i64toi32_i32$0 = ($2 + 176 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $337;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
     HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 100 | 0) >> 2] | 0;
     i64toi32_i32$1 = $2 + 72 | 0;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $347 = i64toi32_i32$3;
     i64toi32_i32$3 = $2;
     HEAP32[($2 + 176 | 0) >> 2] = $347;
     HEAP32[($2 + 180 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$1 = $2 + 92 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $351 = i64toi32_i32$0;
     i64toi32_i32$0 = $2;
     HEAP32[($2 + 16 | 0) >> 2] = $351;
     HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$1 = $1;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $10 = i64toi32_i32$3;
     $10$hi = i64toi32_i32$0;
     i64toi32_i32$1 = i64toi32_i32$3;
     i64toi32_i32$3 = 0;
     i64toi32_i32$2 = 8;
     i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
      i64toi32_i32$3 = 0;
      $57 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
     } else {
      i64toi32_i32$3 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
      $57 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
     }
     $7 = $57;
     $7$hi = i64toi32_i32$3;
     $4 = HEAP32[($2 + 48 | 0) >> 2] | 0;
     $6 = HEAP32[($2 + 52 | 0) >> 2] | 0;
     i64toi32_i32$0 = $2 + 56 | 0;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $8 = i64toi32_i32$3;
     $8$hi = i64toi32_i32$1;
     i64toi32_i32$0 = $2 + 64 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $12 = i64toi32_i32$1;
     $12$hi = i64toi32_i32$3;
     $3 = HEAP32[($2 + 88 | 0) >> 2] | 0;
     i64toi32_i32$3 = $10$hi;
     $5 = $10;
    }
    i64toi32_i32$3 = $12$hi;
    i64toi32_i32$1 = $2 + 272 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $12;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
    i64toi32_i32$3 = $8$hi;
    i64toi32_i32$1 = $2 + 264 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $8;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
    HEAP32[($2 + 260 | 0) >> 2] = $6;
    HEAP32[(($2 + 248 | 0) + 8 | 0) >> 2] = $4;
    i64toi32_i32$0 = $2;
    i64toi32_i32$3 = HEAP32[($2 + 176 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 180 | 0) >> 2] | 0;
    $389 = i64toi32_i32$3;
    i64toi32_i32$3 = $2 + 280 | 0;
    HEAP32[i64toi32_i32$3 >> 2] = $389;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$0 = $2;
    i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
    i64toi32_i32$3 = HEAP32[($2 + 20 | 0) >> 2] | 0;
    $393 = i64toi32_i32$1;
    i64toi32_i32$1 = $2 + 300 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $393;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
    i64toi32_i32$0 = ($2 + 176 | 0) + 8 | 0;
    i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
    $399 = i64toi32_i32$3;
    i64toi32_i32$3 = $2 + 288 | 0;
    HEAP32[i64toi32_i32$3 >> 2] = $399;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($2 + 308 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
    HEAP32[($2 + 296 | 0) >> 2] = $3;
    $408 = $2;
    i64toi32_i32$1 = $7$hi;
    i64toi32_i32$0 = $7;
    i64toi32_i32$3 = 0;
    i64toi32_i32$2 = 8;
    i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
     i64toi32_i32$3 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
     $58 = 0;
    } else {
     i64toi32_i32$3 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
     $58 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
    }
    $410$hi = i64toi32_i32$3;
    i64toi32_i32$3 = 0;
    i64toi32_i32$1 = $5;
    i64toi32_i32$0 = 0;
    i64toi32_i32$2 = 255;
    i64toi32_i32$0 = i64toi32_i32$3 & i64toi32_i32$0 | 0;
    $413 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
    $413$hi = i64toi32_i32$0;
    i64toi32_i32$0 = $410$hi;
    i64toi32_i32$3 = $58;
    i64toi32_i32$1 = $413$hi;
    i64toi32_i32$2 = $413;
    i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
    $414 = i64toi32_i32$3 | i64toi32_i32$2 | 0;
    i64toi32_i32$3 = $408;
    HEAP32[(i64toi32_i32$3 + 248 | 0) >> 2] = $414;
    HEAP32[(i64toi32_i32$3 + 252 | 0) >> 2] = i64toi32_i32$1;
    cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 248 | 0 | 0, 1057804 | 0, 5 | 0);
    i64toi32_i32$1 = 0;
    $8 = 1;
    $8$hi = i64toi32_i32$1;
    break label$1;
   }
   HEAP32[($0 + 20 | 0) >> 2] = $6;
   i64toi32_i32$1 = $11$hi;
   i64toi32_i32$3 = $0 + 24 | 0;
   HEAP32[i64toi32_i32$3 >> 2] = $11;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($0 + 16 | 0) >> 2] = $4;
   $427 = $0;
   i64toi32_i32$1 = $7$hi;
   i64toi32_i32$0 = $7;
   i64toi32_i32$3 = 0;
   i64toi32_i32$2 = 8;
   i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
    i64toi32_i32$3 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
    $59 = 0;
   } else {
    i64toi32_i32$3 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
    $59 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   }
   $429$hi = i64toi32_i32$3;
   i64toi32_i32$3 = $10$hi;
   i64toi32_i32$1 = $10;
   i64toi32_i32$0 = 0;
   i64toi32_i32$2 = 255;
   i64toi32_i32$0 = i64toi32_i32$3 & i64toi32_i32$0 | 0;
   $431 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
   $431$hi = i64toi32_i32$0;
   i64toi32_i32$0 = $429$hi;
   i64toi32_i32$3 = $59;
   i64toi32_i32$1 = $431$hi;
   i64toi32_i32$2 = $431;
   i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
   $432 = i64toi32_i32$3 | i64toi32_i32$2 | 0;
   i64toi32_i32$3 = $427;
   HEAP32[(i64toi32_i32$3 + 8 | 0) >> 2] = $432;
   HEAP32[(i64toi32_i32$3 + 12 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = 0;
   $8 = 0;
   $8$hi = i64toi32_i32$1;
  }
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$3 = $0;
  HEAP32[i64toi32_i32$3 >> 2] = $8;
  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $2 + 320 | 0;
 }
 
 function alloc__slice__merge_sort__haa2cda52d62906c4($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $4 = 0, $10 = 0, $9 = 0, $13 = 0, $3 = 0, $11 = 0, $12 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $8 = 0, i64toi32_i32$3 = 0, $14 = 0, $16 = 0, $19$hi = 0, $19 = 0, $15 = 0, $20 = 0, $20$hi = 0, $5 = 0, $17 = 0, $35 = 0, $6 = 0, $7 = 0, $79 = 0, $79$hi = 0, $18 = 0;
  $3 = global$0 - 64 | 0;
  global$0 = $3;
  HEAP32[($3 + 28 | 0) >> 2] = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     if ($1 >>> 0 < 21 >>> 0) {
      break label$3
     }
     $4 = 0;
     alloc__raw_vec__RawVec_T_2cA___allocate_in__h5dada854c892eb3e($3 + 16 | 0 | 0, $1 >>> 1 | 0 | 0, 0 | 0);
     HEAP32[($3 + 40 | 0) >> 2] = 0;
     i64toi32_i32$2 = $3;
     i64toi32_i32$0 = HEAP32[($3 + 16 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($3 + 20 | 0) >> 2] | 0;
     $35 = i64toi32_i32$0;
     i64toi32_i32$0 = $3;
     HEAP32[($3 + 32 | 0) >> 2] = $35;
     HEAP32[($3 + 36 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$0 = $3;
     i64toi32_i32$1 = 0;
     HEAP32[($3 + 52 | 0) >> 2] = 0;
     HEAP32[($3 + 56 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($3 + 48 | 0) >> 2] = HEAP32[(0 + 1069064 | 0) >> 2] | 0;
     $5 = $0 + -4 | 0;
     $6 = $0 + -8 | 0;
     $7 = $0 + -12 | 0;
     $8 = $1;
     label$4 : while (1) {
      label$5 : {
       label$6 : {
        $9 = $8;
        $10 = $9 + -1 | 0;
        if ($10) {
         break label$6
        }
        $8 = 0;
        $9 = 1;
        break label$5;
       }
       label$7 : {
        label$8 : {
         label$9 : {
          label$10 : {
           label$11 : {
            label$12 : {
             label$13 : {
              label$14 : {
               label$15 : {
                label$16 : {
                 label$17 : {
                  label$18 : {
                   $11 = HEAP32[(HEAP32[($2 + 4 | 0) >> 2] | 0) >> 2] | 0;
                   $12 = HEAP32[($11 + 8 | 0) >> 2] | 0;
                   $10 = HEAP32[($0 + ($10 << 2 | 0) | 0) >> 2] | 0;
                   if ($12 >>> 0 <= $10 >>> 0) {
                    break label$18
                   }
                   $8 = $9 + -2 | 0;
                   $13 = HEAP32[($0 + ($8 << 2 | 0) | 0) >> 2] | 0;
                   if ($12 >>> 0 <= $13 >>> 0) {
                    break label$17
                   }
                   label$19 : {
                    label$20 : {
                     $14 = HEAP32[$11 >> 2] | 0;
                     i64toi32_i32$2 = $14 + Math_imul($10, 168) | 0;
                     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
                     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
                     $79 = i64toi32_i32$1;
                     $79$hi = i64toi32_i32$0;
                     i64toi32_i32$2 = $14 + Math_imul($13, 168) | 0;
                     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
                     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
                     $19 = i64toi32_i32$0;
                     $19$hi = i64toi32_i32$1;
                     i64toi32_i32$1 = $79$hi;
                     i64toi32_i32$2 = $79;
                     i64toi32_i32$0 = $19$hi;
                     i64toi32_i32$3 = $19;
                     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0) {
                      break label$20
                     }
                     $15 = $9 + -2 | 0;
                     $11 = $7 + ($9 << 2 | 0) | 0;
                     $8 = 0;
                     $10 = 0;
                     label$21 : while (1) {
                      if (($15 | 0) == ($10 | 0)) {
                       break label$5
                      }
                      if ($12 >>> 0 <= $13 >>> 0) {
                       break label$12
                      }
                      $13 = HEAP32[$11 >> 2] | 0;
                      if ($12 >>> 0 <= $13 >>> 0) {
                       break label$11
                      }
                      $11 = $11 + -4 | 0;
                      $10 = $10 + 1 | 0;
                      i64toi32_i32$2 = $19$hi;
                      i64toi32_i32$3 = $14 + Math_imul($13, 168) | 0;
                      i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 64 | 0) >> 2] | 0;
                      i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 68 | 0) >> 2] | 0;
                      $20 = i64toi32_i32$2;
                      $20$hi = i64toi32_i32$1;
                      i64toi32_i32$1 = $19$hi;
                      i64toi32_i32$3 = $19;
                      i64toi32_i32$2 = $20$hi;
                      i64toi32_i32$0 = $20;
                      $16 = i64toi32_i32$1 >>> 0 > i64toi32_i32$2 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$3 >>> 0 >= i64toi32_i32$0 >>> 0 | 0) | 0;
                      i64toi32_i32$3 = i64toi32_i32$2;
                      i64toi32_i32$3 = i64toi32_i32$2;
                      $19 = i64toi32_i32$0;
                      $19$hi = i64toi32_i32$2;
                      if ($16) {
                       continue label$21
                      }
                      break label$21;
                     };
                     $16 = $10 + 1 | 0;
                     $11 = ($10 ^ -1 | 0) + $9 | 0;
                     break label$19;
                    }
                    $16 = 2;
                    $15 = $6 + ($9 << 2 | 0) | 0;
                    label$22 : {
                     label$23 : while (1) {
                      $17 = $16;
                      $10 = $15;
                      $11 = $8;
                      if (!$11) {
                       break label$22
                      }
                      if ($12 >>> 0 <= $13 >>> 0) {
                       break label$16
                      }
                      $8 = $11 + -1 | 0;
                      $13 = HEAP32[($0 + ($8 << 2 | 0) | 0) >> 2] | 0;
                      if ($12 >>> 0 <= $13 >>> 0) {
                       break label$15
                      }
                      $15 = $10 + -4 | 0;
                      $16 = $17 + 1 | 0;
                      i64toi32_i32$3 = $19$hi;
                      i64toi32_i32$0 = $14 + Math_imul($13, 168) | 0;
                      i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 64 | 0) >> 2] | 0;
                      i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 68 | 0) >> 2] | 0;
                      $20 = i64toi32_i32$3;
                      $20$hi = i64toi32_i32$1;
                      i64toi32_i32$1 = $19$hi;
                      i64toi32_i32$0 = $19;
                      i64toi32_i32$3 = $20$hi;
                      i64toi32_i32$2 = $20;
                      $18 = i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0;
                      i64toi32_i32$0 = i64toi32_i32$3;
                      $19 = i64toi32_i32$2;
                      $19$hi = i64toi32_i32$0;
                      if ($18) {
                       continue label$23
                      }
                      break label$23;
                     };
                    }
                    if ($9 >>> 0 < $11 >>> 0) {
                     break label$14
                    }
                    if ($9 >>> 0 > $1 >>> 0) {
                     break label$13
                    }
                    $16 = $9 - $11 | 0;
                    if (!($16 >>> 1 | 0)) {
                     break label$19
                    }
                    $12 = $17 >>> 1 | 0;
                    $13 = $5 + ($9 << 2 | 0) | 0;
                    label$24 : while (1) {
                     $14 = HEAP32[$10 >> 2] | 0;
                     HEAP32[$10 >> 2] = HEAP32[$13 >> 2] | 0;
                     HEAP32[$13 >> 2] = $14;
                     $10 = $10 + 4 | 0;
                     $13 = $13 + -4 | 0;
                     $12 = $12 + -1 | 0;
                     if ($12) {
                      continue label$24
                     }
                     break label$24;
                    };
                   }
                   if (!$11) {
                    break label$7
                   }
                   if ($16 >>> 0 > 9 >>> 0) {
                    break label$7
                   }
                   $4 = 1 - $11 | 0;
                   $10 = $5 + ($11 << 2 | 0) | 0;
                   label$25 : while (1) {
                    $8 = $11 + -1 | 0;
                    if ($9 >>> 0 < $8 >>> 0) {
                     break label$10
                    }
                    if ($9 >>> 0 > $1 >>> 0) {
                     break label$9
                    }
                    $13 = $9 + $4 | 0;
                    alloc__slice__insert_head__hb4e62620269819c6($10 | 0, $13 | 0, $3 + 28 | 0 | 0);
                    if (!$4) {
                     break label$8
                    }
                    $4 = $4 + 1 | 0;
                    $10 = $10 + -4 | 0;
                    $11 = $8;
                    if ($13 >>> 0 < 10 >>> 0) {
                     continue label$25
                    }
                    break label$8;
                   };
                  }
                  core__panicking__panic_bounds_check__h808b524af17640b1($10 | 0, $12 | 0, 1069460 | 0);
                  abort();
                 }
                 core__panicking__panic_bounds_check__h808b524af17640b1($13 | 0, $12 | 0, 1069460 | 0);
                 abort();
                }
                core__panicking__panic_bounds_check__h808b524af17640b1($13 | 0, $12 | 0, 1069460 | 0);
                abort();
               }
               core__panicking__panic_bounds_check__h808b524af17640b1($13 | 0, $12 | 0, 1069460 | 0);
               abort();
              }
              core__slice__index__slice_index_order_fail__h71e247dec3f266ff($11 | 0, $9 | 0, 1069172 | 0);
              abort();
             }
             core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($9 | 0, $1 | 0, 1069172 | 0);
             abort();
            }
            core__panicking__panic_bounds_check__h808b524af17640b1($13 | 0, $12 | 0, 1069460 | 0);
            abort();
           }
           core__panicking__panic_bounds_check__h808b524af17640b1($13 | 0, $12 | 0, 1069460 | 0);
           abort();
          }
          core__slice__index__slice_index_order_fail__h71e247dec3f266ff($11 + -1 | 0 | 0, $9 | 0, 1069188 | 0);
          abort();
         }
         core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($9 | 0, $1 | 0, 1069188 | 0);
         abort();
        }
        $9 = $9 - $8 | 0;
        $4 = HEAP32[($3 + 56 | 0) >> 2] | 0;
        break label$5;
       }
       $8 = $11;
       $9 = $16;
      }
      label$26 : {
       if ((HEAP32[($3 + 52 | 0) >> 2] | 0 | 0) != ($4 | 0)) {
        break label$26
       }
       alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hf5a91d7c63e29e55($3 + 48 | 0 | 0, $4 | 0, 1 | 0);
       $4 = HEAP32[($3 + 56 | 0) >> 2] | 0;
      }
      $4 = (HEAP32[($3 + 48 | 0) >> 2] | 0) + ($4 << 3 | 0) | 0;
      HEAP32[($4 + 4 | 0) >> 2] = $9;
      HEAP32[$4 >> 2] = $8;
      $4 = (HEAP32[($3 + 56 | 0) >> 2] | 0) + 1 | 0;
      HEAP32[($3 + 56 | 0) >> 2] = $4;
      label$27 : {
       if ($4 >>> 0 < 2 >>> 0) {
        break label$27
       }
       label$28 : {
        label$29 : {
         label$30 : {
          label$31 : {
           label$32 : while (1) {
            label$33 : {
             label$34 : {
              label$35 : {
               label$36 : {
                $13 = HEAP32[($3 + 48 | 0) >> 2] | 0;
                $10 = $13 + (($4 + -1 | 0) << 3 | 0) | 0;
                if (!(HEAP32[$10 >> 2] | 0)) {
                 break label$36
                }
                $14 = ($4 << 3 | 0) + $13 | 0;
                $12 = HEAP32[($14 + -12 | 0) >> 2] | 0;
                $9 = HEAP32[($10 + 4 | 0) >> 2] | 0;
                if ($12 >>> 0 <= $9 >>> 0) {
                 break label$36
                }
                label$37 : {
                 if ($4 >>> 0 >= 3 >>> 0) {
                  break label$37
                 }
                 $4 = 2;
                 break label$27;
                }
                $10 = $4 + -3 | 0;
                $11 = HEAP32[(($13 + ($10 << 3 | 0) | 0) + 4 | 0) >> 2] | 0;
                if ($11 >>> 0 <= ($9 + $12 | 0) >>> 0) {
                 break label$35
                }
                label$38 : {
                 if ($4 >>> 0 >= 4 >>> 0) {
                  break label$38
                 }
                 $4 = 3;
                 break label$27;
                }
                if ((HEAP32[($14 + -28 | 0) >> 2] | 0) >>> 0 > ($11 + $12 | 0) >>> 0) {
                 break label$27
                }
                break label$35;
               }
               if ($4 >>> 0 < 3 >>> 0) {
                break label$34
               }
               $9 = HEAP32[($10 + 4 | 0) >> 2] | 0;
               $10 = $4 + -3 | 0;
               $11 = HEAP32[(($13 + ($10 << 3 | 0) | 0) + 4 | 0) >> 2] | 0;
              }
              if ($11 >>> 0 < $9 >>> 0) {
               break label$33
              }
             }
             $10 = $4 + -2 | 0;
            }
            label$39 : {
             $9 = $10 + 1 | 0;
             if ($4 >>> 0 <= $9 >>> 0) {
              break label$39
             }
             if ($4 >>> 0 <= $10 >>> 0) {
              break label$31
             }
             $12 = $10 << 3 | 0;
             $4 = $13 + $12 | 0;
             $14 = HEAP32[($4 + 4 | 0) >> 2] | 0;
             $11 = $14 + (HEAP32[$4 >> 2] | 0) | 0;
             $13 = $13 + ($9 << 3 | 0) | 0;
             $4 = HEAP32[$13 >> 2] | 0;
             if ($11 >>> 0 < $4 >>> 0) {
              break label$30
             }
             if ($11 >>> 0 > $1 >>> 0) {
              break label$29
             }
             $13 = HEAP32[($13 + 4 | 0) >> 2] | 0;
             alloc__slice__merge__ha85d6751bbeddfda($0 + ($4 << 2 | 0) | 0 | 0, $11 - $4 | 0 | 0, $13 | 0, HEAP32[($3 + 32 | 0) >> 2] | 0 | 0, $3 + 28 | 0 | 0);
             $11 = HEAP32[($3 + 56 | 0) >> 2] | 0;
             if ($11 >>> 0 <= $10 >>> 0) {
              break label$28
             }
             $10 = (HEAP32[($3 + 48 | 0) >> 2] | 0) + $12 | 0;
             HEAP32[($10 + 4 | 0) >> 2] = $14 + $13 | 0;
             HEAP32[$10 >> 2] = $4;
             alloc__vec__Vec_T_2cA___remove__hf0ee37bb0b07dbd1($3 + 8 | 0 | 0, $3 + 48 | 0 | 0, $9 | 0);
             $4 = HEAP32[($3 + 56 | 0) >> 2] | 0;
             if ($4 >>> 0 > 1 >>> 0) {
              continue label$32
             }
             break label$27;
            }
            break label$32;
           };
           core__panicking__panic_bounds_check__h808b524af17640b1($9 | 0, $4 | 0, 1069204 | 0);
           abort();
          }
          core__panicking__panic_bounds_check__h808b524af17640b1($10 | 0, $4 | 0, 1069220 | 0);
          abort();
         }
         core__slice__index__slice_index_order_fail__h71e247dec3f266ff($4 | 0, $11 | 0, 1069236 | 0);
         abort();
        }
        core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($11 | 0, $1 | 0, 1069236 | 0);
        abort();
       }
       core__panicking__panic_bounds_check__h808b524af17640b1($10 | 0, $11 | 0, 1069252 | 0);
       abort();
      }
      if ($8) {
       continue label$4
      }
      break label$4;
     };
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h28ea22ae705f999b($3 + 48 | 0 | 0);
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hb513c626355ab1b6($3 + 32 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h515a508dccfbb69c($3 + 32 | 0 | 0);
     break label$2;
    }
    if ($1 >>> 0 < 2 >>> 0) {
     break label$2
    }
    core__iter__adapters__rev__Rev_T___new__h11ed92efd1d68010($3 | 0, 0 | 0, $1 + -1 | 0 | 0);
    $11 = HEAP32[$3 >> 2] | 0;
    $9 = HEAP32[($3 + 4 | 0) >> 2] | 0;
    if ($11 >>> 0 >= $9 >>> 0) {
     break label$2
    }
    $4 = ($1 - $9 | 0) + 1 | 0;
    $10 = (($9 << 2 | 0) + $0 | 0) + -4 | 0;
    label$40 : while (1) {
     $13 = $9 + -1 | 0;
     if ($13 >>> 0 > $1 >>> 0) {
      break label$1
     }
     alloc__slice__insert_head__hb4e62620269819c6($10 | 0, $4 | 0, $3 + 28 | 0 | 0);
     $4 = $4 + 1 | 0;
     $10 = $10 + -4 | 0;
     $9 = $13;
     if ($11 >>> 0 < $9 >>> 0) {
      continue label$40
     }
     break label$40;
    };
   }
   global$0 = $3 + 64 | 0;
   return;
  }
  core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($9 + -1 | 0 | 0, $1 | 0, 1069156 | 0);
  abort();
 }
 
 function alloc__slice__merge_sort__hb2cc5bc1726bb0e1($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $4 = 0, $10 = 0, $9 = 0, $13 = 0, $3 = 0, $11 = 0, $12 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $8 = 0, i64toi32_i32$3 = 0, $14 = 0, $16 = 0, $19$hi = 0, $19 = 0, $15 = 0, $20 = 0, $20$hi = 0, $5 = 0, $17 = 0, $35 = 0, $6 = 0, $7 = 0, $79 = 0, $79$hi = 0, $18 = 0;
  $3 = global$0 - 64 | 0;
  global$0 = $3;
  HEAP32[($3 + 28 | 0) >> 2] = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     if ($1 >>> 0 < 21 >>> 0) {
      break label$3
     }
     $4 = 0;
     alloc__raw_vec__RawVec_T_2cA___allocate_in__h5dada854c892eb3e($3 + 16 | 0 | 0, $1 >>> 1 | 0 | 0, 0 | 0);
     HEAP32[($3 + 40 | 0) >> 2] = 0;
     i64toi32_i32$2 = $3;
     i64toi32_i32$0 = HEAP32[($3 + 16 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($3 + 20 | 0) >> 2] | 0;
     $35 = i64toi32_i32$0;
     i64toi32_i32$0 = $3;
     HEAP32[($3 + 32 | 0) >> 2] = $35;
     HEAP32[($3 + 36 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$0 = $3;
     i64toi32_i32$1 = 0;
     HEAP32[($3 + 52 | 0) >> 2] = 0;
     HEAP32[($3 + 56 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($3 + 48 | 0) >> 2] = HEAP32[(0 + 1069064 | 0) >> 2] | 0;
     $5 = $0 + -4 | 0;
     $6 = $0 + -8 | 0;
     $7 = $0 + -12 | 0;
     $8 = $1;
     label$4 : while (1) {
      label$5 : {
       label$6 : {
        $9 = $8;
        $10 = $9 + -1 | 0;
        if ($10) {
         break label$6
        }
        $8 = 0;
        $9 = 1;
        break label$5;
       }
       label$7 : {
        label$8 : {
         label$9 : {
          label$10 : {
           label$11 : {
            label$12 : {
             label$13 : {
              label$14 : {
               label$15 : {
                label$16 : {
                 label$17 : {
                  label$18 : {
                   $11 = HEAP32[(HEAP32[($2 + 4 | 0) >> 2] | 0) >> 2] | 0;
                   $12 = HEAP32[($11 + 8 | 0) >> 2] | 0;
                   $10 = HEAP32[($0 + ($10 << 2 | 0) | 0) >> 2] | 0;
                   if ($12 >>> 0 <= $10 >>> 0) {
                    break label$18
                   }
                   $8 = $9 + -2 | 0;
                   $13 = HEAP32[($0 + ($8 << 2 | 0) | 0) >> 2] | 0;
                   if ($12 >>> 0 <= $13 >>> 0) {
                    break label$17
                   }
                   label$19 : {
                    label$20 : {
                     $14 = HEAP32[$11 >> 2] | 0;
                     i64toi32_i32$2 = $14 + Math_imul($10, 168) | 0;
                     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
                     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
                     $79 = i64toi32_i32$1;
                     $79$hi = i64toi32_i32$0;
                     i64toi32_i32$2 = $14 + Math_imul($13, 168) | 0;
                     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
                     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
                     $19 = i64toi32_i32$0;
                     $19$hi = i64toi32_i32$1;
                     i64toi32_i32$1 = $79$hi;
                     i64toi32_i32$2 = $79;
                     i64toi32_i32$0 = $19$hi;
                     i64toi32_i32$3 = $19;
                     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0) {
                      break label$20
                     }
                     $15 = $9 + -2 | 0;
                     $11 = $7 + ($9 << 2 | 0) | 0;
                     $8 = 0;
                     $10 = 0;
                     label$21 : while (1) {
                      if (($15 | 0) == ($10 | 0)) {
                       break label$5
                      }
                      if ($12 >>> 0 <= $13 >>> 0) {
                       break label$12
                      }
                      $13 = HEAP32[$11 >> 2] | 0;
                      if ($12 >>> 0 <= $13 >>> 0) {
                       break label$11
                      }
                      $11 = $11 + -4 | 0;
                      $10 = $10 + 1 | 0;
                      i64toi32_i32$2 = $19$hi;
                      i64toi32_i32$3 = $14 + Math_imul($13, 168) | 0;
                      i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 64 | 0) >> 2] | 0;
                      i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 68 | 0) >> 2] | 0;
                      $20 = i64toi32_i32$2;
                      $20$hi = i64toi32_i32$1;
                      i64toi32_i32$1 = $19$hi;
                      i64toi32_i32$3 = $19;
                      i64toi32_i32$2 = $20$hi;
                      i64toi32_i32$0 = $20;
                      $16 = i64toi32_i32$1 >>> 0 > i64toi32_i32$2 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$3 >>> 0 >= i64toi32_i32$0 >>> 0 | 0) | 0;
                      i64toi32_i32$3 = i64toi32_i32$2;
                      i64toi32_i32$3 = i64toi32_i32$2;
                      $19 = i64toi32_i32$0;
                      $19$hi = i64toi32_i32$2;
                      if ($16) {
                       continue label$21
                      }
                      break label$21;
                     };
                     $16 = $10 + 1 | 0;
                     $11 = ($10 ^ -1 | 0) + $9 | 0;
                     break label$19;
                    }
                    $16 = 2;
                    $15 = $6 + ($9 << 2 | 0) | 0;
                    label$22 : {
                     label$23 : while (1) {
                      $17 = $16;
                      $10 = $15;
                      $11 = $8;
                      if (!$11) {
                       break label$22
                      }
                      if ($12 >>> 0 <= $13 >>> 0) {
                       break label$16
                      }
                      $8 = $11 + -1 | 0;
                      $13 = HEAP32[($0 + ($8 << 2 | 0) | 0) >> 2] | 0;
                      if ($12 >>> 0 <= $13 >>> 0) {
                       break label$15
                      }
                      $15 = $10 + -4 | 0;
                      $16 = $17 + 1 | 0;
                      i64toi32_i32$3 = $19$hi;
                      i64toi32_i32$0 = $14 + Math_imul($13, 168) | 0;
                      i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 64 | 0) >> 2] | 0;
                      i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 68 | 0) >> 2] | 0;
                      $20 = i64toi32_i32$3;
                      $20$hi = i64toi32_i32$1;
                      i64toi32_i32$1 = $19$hi;
                      i64toi32_i32$0 = $19;
                      i64toi32_i32$3 = $20$hi;
                      i64toi32_i32$2 = $20;
                      $18 = i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0;
                      i64toi32_i32$0 = i64toi32_i32$3;
                      $19 = i64toi32_i32$2;
                      $19$hi = i64toi32_i32$0;
                      if ($18) {
                       continue label$23
                      }
                      break label$23;
                     };
                    }
                    if ($9 >>> 0 < $11 >>> 0) {
                     break label$14
                    }
                    if ($9 >>> 0 > $1 >>> 0) {
                     break label$13
                    }
                    $16 = $9 - $11 | 0;
                    if (!($16 >>> 1 | 0)) {
                     break label$19
                    }
                    $12 = $17 >>> 1 | 0;
                    $13 = $5 + ($9 << 2 | 0) | 0;
                    label$24 : while (1) {
                     $14 = HEAP32[$10 >> 2] | 0;
                     HEAP32[$10 >> 2] = HEAP32[$13 >> 2] | 0;
                     HEAP32[$13 >> 2] = $14;
                     $10 = $10 + 4 | 0;
                     $13 = $13 + -4 | 0;
                     $12 = $12 + -1 | 0;
                     if ($12) {
                      continue label$24
                     }
                     break label$24;
                    };
                   }
                   if (!$11) {
                    break label$7
                   }
                   if ($16 >>> 0 > 9 >>> 0) {
                    break label$7
                   }
                   $4 = 1 - $11 | 0;
                   $10 = $5 + ($11 << 2 | 0) | 0;
                   label$25 : while (1) {
                    $8 = $11 + -1 | 0;
                    if ($9 >>> 0 < $8 >>> 0) {
                     break label$10
                    }
                    if ($9 >>> 0 > $1 >>> 0) {
                     break label$9
                    }
                    $13 = $9 + $4 | 0;
                    alloc__slice__insert_head__hce84fe93513e7ded($10 | 0, $13 | 0, $3 + 28 | 0 | 0);
                    if (!$4) {
                     break label$8
                    }
                    $4 = $4 + 1 | 0;
                    $10 = $10 + -4 | 0;
                    $11 = $8;
                    if ($13 >>> 0 < 10 >>> 0) {
                     continue label$25
                    }
                    break label$8;
                   };
                  }
                  core__panicking__panic_bounds_check__h808b524af17640b1($10 | 0, $12 | 0, 1069460 | 0);
                  abort();
                 }
                 core__panicking__panic_bounds_check__h808b524af17640b1($13 | 0, $12 | 0, 1069460 | 0);
                 abort();
                }
                core__panicking__panic_bounds_check__h808b524af17640b1($13 | 0, $12 | 0, 1069460 | 0);
                abort();
               }
               core__panicking__panic_bounds_check__h808b524af17640b1($13 | 0, $12 | 0, 1069460 | 0);
               abort();
              }
              core__slice__index__slice_index_order_fail__h71e247dec3f266ff($11 | 0, $9 | 0, 1069172 | 0);
              abort();
             }
             core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($9 | 0, $1 | 0, 1069172 | 0);
             abort();
            }
            core__panicking__panic_bounds_check__h808b524af17640b1($13 | 0, $12 | 0, 1069460 | 0);
            abort();
           }
           core__panicking__panic_bounds_check__h808b524af17640b1($13 | 0, $12 | 0, 1069460 | 0);
           abort();
          }
          core__slice__index__slice_index_order_fail__h71e247dec3f266ff($11 + -1 | 0 | 0, $9 | 0, 1069188 | 0);
          abort();
         }
         core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($9 | 0, $1 | 0, 1069188 | 0);
         abort();
        }
        $9 = $9 - $8 | 0;
        $4 = HEAP32[($3 + 56 | 0) >> 2] | 0;
        break label$5;
       }
       $8 = $11;
       $9 = $16;
      }
      label$26 : {
       if ((HEAP32[($3 + 52 | 0) >> 2] | 0 | 0) != ($4 | 0)) {
        break label$26
       }
       alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hf5a91d7c63e29e55($3 + 48 | 0 | 0, $4 | 0, 1 | 0);
       $4 = HEAP32[($3 + 56 | 0) >> 2] | 0;
      }
      $4 = (HEAP32[($3 + 48 | 0) >> 2] | 0) + ($4 << 3 | 0) | 0;
      HEAP32[($4 + 4 | 0) >> 2] = $9;
      HEAP32[$4 >> 2] = $8;
      $4 = (HEAP32[($3 + 56 | 0) >> 2] | 0) + 1 | 0;
      HEAP32[($3 + 56 | 0) >> 2] = $4;
      label$27 : {
       if ($4 >>> 0 < 2 >>> 0) {
        break label$27
       }
       label$28 : {
        label$29 : {
         label$30 : {
          label$31 : {
           label$32 : while (1) {
            label$33 : {
             label$34 : {
              label$35 : {
               label$36 : {
                $13 = HEAP32[($3 + 48 | 0) >> 2] | 0;
                $10 = $13 + (($4 + -1 | 0) << 3 | 0) | 0;
                if (!(HEAP32[$10 >> 2] | 0)) {
                 break label$36
                }
                $14 = ($4 << 3 | 0) + $13 | 0;
                $12 = HEAP32[($14 + -12 | 0) >> 2] | 0;
                $9 = HEAP32[($10 + 4 | 0) >> 2] | 0;
                if ($12 >>> 0 <= $9 >>> 0) {
                 break label$36
                }
                label$37 : {
                 if ($4 >>> 0 >= 3 >>> 0) {
                  break label$37
                 }
                 $4 = 2;
                 break label$27;
                }
                $10 = $4 + -3 | 0;
                $11 = HEAP32[(($13 + ($10 << 3 | 0) | 0) + 4 | 0) >> 2] | 0;
                if ($11 >>> 0 <= ($9 + $12 | 0) >>> 0) {
                 break label$35
                }
                label$38 : {
                 if ($4 >>> 0 >= 4 >>> 0) {
                  break label$38
                 }
                 $4 = 3;
                 break label$27;
                }
                if ((HEAP32[($14 + -28 | 0) >> 2] | 0) >>> 0 > ($11 + $12 | 0) >>> 0) {
                 break label$27
                }
                break label$35;
               }
               if ($4 >>> 0 < 3 >>> 0) {
                break label$34
               }
               $9 = HEAP32[($10 + 4 | 0) >> 2] | 0;
               $10 = $4 + -3 | 0;
               $11 = HEAP32[(($13 + ($10 << 3 | 0) | 0) + 4 | 0) >> 2] | 0;
              }
              if ($11 >>> 0 < $9 >>> 0) {
               break label$33
              }
             }
             $10 = $4 + -2 | 0;
            }
            label$39 : {
             $9 = $10 + 1 | 0;
             if ($4 >>> 0 <= $9 >>> 0) {
              break label$39
             }
             if ($4 >>> 0 <= $10 >>> 0) {
              break label$31
             }
             $12 = $10 << 3 | 0;
             $4 = $13 + $12 | 0;
             $14 = HEAP32[($4 + 4 | 0) >> 2] | 0;
             $11 = $14 + (HEAP32[$4 >> 2] | 0) | 0;
             $13 = $13 + ($9 << 3 | 0) | 0;
             $4 = HEAP32[$13 >> 2] | 0;
             if ($11 >>> 0 < $4 >>> 0) {
              break label$30
             }
             if ($11 >>> 0 > $1 >>> 0) {
              break label$29
             }
             $13 = HEAP32[($13 + 4 | 0) >> 2] | 0;
             alloc__slice__merge__h05ffb6395880504a($0 + ($4 << 2 | 0) | 0 | 0, $11 - $4 | 0 | 0, $13 | 0, HEAP32[($3 + 32 | 0) >> 2] | 0 | 0, $3 + 28 | 0 | 0);
             $11 = HEAP32[($3 + 56 | 0) >> 2] | 0;
             if ($11 >>> 0 <= $10 >>> 0) {
              break label$28
             }
             $10 = (HEAP32[($3 + 48 | 0) >> 2] | 0) + $12 | 0;
             HEAP32[($10 + 4 | 0) >> 2] = $14 + $13 | 0;
             HEAP32[$10 >> 2] = $4;
             alloc__vec__Vec_T_2cA___remove__hf0ee37bb0b07dbd1($3 + 8 | 0 | 0, $3 + 48 | 0 | 0, $9 | 0);
             $4 = HEAP32[($3 + 56 | 0) >> 2] | 0;
             if ($4 >>> 0 > 1 >>> 0) {
              continue label$32
             }
             break label$27;
            }
            break label$32;
           };
           core__panicking__panic_bounds_check__h808b524af17640b1($9 | 0, $4 | 0, 1069204 | 0);
           abort();
          }
          core__panicking__panic_bounds_check__h808b524af17640b1($10 | 0, $4 | 0, 1069220 | 0);
          abort();
         }
         core__slice__index__slice_index_order_fail__h71e247dec3f266ff($4 | 0, $11 | 0, 1069236 | 0);
         abort();
        }
        core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($11 | 0, $1 | 0, 1069236 | 0);
        abort();
       }
       core__panicking__panic_bounds_check__h808b524af17640b1($10 | 0, $11 | 0, 1069252 | 0);
       abort();
      }
      if ($8) {
       continue label$4
      }
      break label$4;
     };
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h28ea22ae705f999b($3 + 48 | 0 | 0);
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hb513c626355ab1b6($3 + 32 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h515a508dccfbb69c($3 + 32 | 0 | 0);
     break label$2;
    }
    if ($1 >>> 0 < 2 >>> 0) {
     break label$2
    }
    core__iter__adapters__rev__Rev_T___new__h11ed92efd1d68010($3 | 0, 0 | 0, $1 + -1 | 0 | 0);
    $11 = HEAP32[$3 >> 2] | 0;
    $9 = HEAP32[($3 + 4 | 0) >> 2] | 0;
    if ($11 >>> 0 >= $9 >>> 0) {
     break label$2
    }
    $4 = ($1 - $9 | 0) + 1 | 0;
    $10 = (($9 << 2 | 0) + $0 | 0) + -4 | 0;
    label$40 : while (1) {
     $13 = $9 + -1 | 0;
     if ($13 >>> 0 > $1 >>> 0) {
      break label$1
     }
     alloc__slice__insert_head__hce84fe93513e7ded($10 | 0, $4 | 0, $3 + 28 | 0 | 0);
     $4 = $4 + 1 | 0;
     $10 = $10 + -4 | 0;
     $9 = $13;
     if ($11 >>> 0 < $9 >>> 0) {
      continue label$40
     }
     break label$40;
    };
   }
   global$0 = $3 + 64 | 0;
   return;
  }
  core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($9 + -1 | 0 | 0, $1 | 0, 1069156 | 0);
  abort();
 }
 
 function $cardano_serialization_lib__plutus__ConstrPlutusData_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h5b3b55e53d3f2947($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$4 = 0, $5 = 0, $5$hi = 0, $8 = 0, $8$hi = 0, $6 = 0, $6$hi = 0, i64toi32_i32$5 = 0, $3 = 0, $7 = 0, $7$hi = 0, $4 = 0, $9 = 0, $56 = 0, $57 = 0, $58 = 0, $59 = 0, $65 = 0, $70 = 0, $80 = 0, $84 = 0, $101 = 0, $116 = 0, $122 = 0, $126 = 0, $147 = 0, $9$hi = 0, $208 = 0, $208$hi = 0, $211 = 0, $211$hi = 0, $215$hi = 0, $217$hi = 0, $219$hi = 0, $222 = 0, $222$hi = 0, $293 = 0, $299 = 0, $308 = 0, $312 = 0, $350 = 0, $356 = 0, $366 = 0, $370 = 0, $396 = 0, $400 = 0, $406 = 0, $412 = 0, $423 = 0, $423$hi = 0, $425 = 0, $425$hi = 0, $426 = 0;
  $2 = global$0 - 352 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___tag__ha0ca0c99f1ceb558($2 + 280 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 288 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 292 | 0) >> 2] | 0;
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 280 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 284 | 0) >> 2] | 0;
        i64toi32_i32$2 = i64toi32_i32$1;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
         break label$6
        }
        label$7 : {
         label$8 : {
          label$9 : {
           label$10 : {
            label$11 : {
             i64toi32_i32$2 = $5$hi;
             i64toi32_i32$3 = $5;
             i64toi32_i32$0 = 0;
             i64toi32_i32$1 = 102;
             if ((i64toi32_i32$3 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$0 | 0) | 0) {
              break label$11
             }
             cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 280 | 0 | 0, $1 | 0);
             i64toi32_i32$1 = ($2 + 280 | 0) + 16 | 0;
             i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
             i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
             $6 = i64toi32_i32$3;
             $6$hi = i64toi32_i32$2;
             i64toi32_i32$1 = $2;
             i64toi32_i32$2 = HEAP32[($2 + 288 | 0) >> 2] | 0;
             i64toi32_i32$3 = HEAP32[($2 + 292 | 0) >> 2] | 0;
             $5 = i64toi32_i32$2;
             $5$hi = i64toi32_i32$3;
             i64toi32_i32$1 = $2;
             i64toi32_i32$3 = HEAP32[($2 + 280 | 0) >> 2] | 0;
             i64toi32_i32$2 = HEAP32[($2 + 284 | 0) >> 2] | 0;
             i64toi32_i32$1 = i64toi32_i32$3;
             i64toi32_i32$3 = 0;
             i64toi32_i32$0 = 1;
             if ((i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) | 0) {
              break label$10
             }
             $3 = 0;
             i64toi32_i32$1 = 0;
             $7 = 0;
             $7$hi = i64toi32_i32$1;
             i64toi32_i32$1 = $5$hi;
             i64toi32_i32$0 = $5;
             i64toi32_i32$2 = 0;
             i64toi32_i32$3 = 1;
             if ((i64toi32_i32$0 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$2 | 0) | 0) {
              break label$9
             }
             i64toi32_i32$0 = 0;
             $8 = 3;
             $8$hi = i64toi32_i32$0;
             i64toi32_i32$0 = $6$hi;
             i64toi32_i32$3 = $6;
             i64toi32_i32$1 = 0;
             i64toi32_i32$2 = 2;
             if (i64toi32_i32$0 >>> 0 > i64toi32_i32$1 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$3 >>> 0 >= i64toi32_i32$2 >>> 0 | 0) | 0) {
              break label$9
             }
             i64toi32_i32$3 = $6$hi;
             $5 = $6;
             $5$hi = i64toi32_i32$3;
             i64toi32_i32$3 = 0;
             $6 = 0;
             $6$hi = i64toi32_i32$3;
             break label$2;
            }
            label$12 : {
             i64toi32_i32$3 = $5$hi;
             i64toi32_i32$2 = $5;
             i64toi32_i32$0 = -1;
             i64toi32_i32$1 = -121;
             i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
             i64toi32_i32$5 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
             if (i64toi32_i32$4 >>> 0 < i64toi32_i32$1 >>> 0) {
              i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
             }
             $8 = i64toi32_i32$4;
             $8$hi = i64toi32_i32$5;
             i64toi32_i32$5 = $8$hi;
             i64toi32_i32$5 = $8$hi;
             i64toi32_i32$3 = i64toi32_i32$4;
             i64toi32_i32$2 = 0;
             i64toi32_i32$1 = 7;
             if ($8$hi >>> 0 < i64toi32_i32$2 >>> 0 | (($8$hi | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0 | 0) | 0) {
              break label$12
             }
             i64toi32_i32$3 = $5$hi;
             i64toi32_i32$1 = $5;
             i64toi32_i32$5 = -1;
             i64toi32_i32$2 = -1280;
             i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
             i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
             if (i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0) {
              i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
             }
             i64toi32_i32$3 = i64toi32_i32$0;
             i64toi32_i32$1 = 0;
             i64toi32_i32$2 = 120;
             if (i64toi32_i32$4 >>> 0 > i64toi32_i32$1 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$0 >>> 0 > i64toi32_i32$2 >>> 0 | 0) | 0) {
              break label$7
             }
             i64toi32_i32$3 = $5$hi;
             i64toi32_i32$2 = $5;
             i64toi32_i32$4 = -1;
             i64toi32_i32$1 = -1273;
             i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
             i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$4 | 0;
             if (i64toi32_i32$5 >>> 0 < i64toi32_i32$1 >>> 0) {
              i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
             }
             $8 = i64toi32_i32$5;
             $8$hi = i64toi32_i32$0;
            }
            $cardano_serialization_lib__plutus__PlutusList_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hfdf263ce80660b6e($2 + 280 | 0 | 0, $1 | 0);
            label$13 : {
             if ((HEAP32[($2 + 280 | 0) >> 2] | 0 | 0) == (1 | 0)) {
              break label$13
             }
             i64toi32_i32$3 = $2 + 292 | 0;
             i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
             i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
             $5 = i64toi32_i32$0;
             $5$hi = i64toi32_i32$2;
             i64toi32_i32$3 = $2;
             i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 284 | 0) >> 2] | 0;
             i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 288 | 0) >> 2] | 0;
             $6 = i64toi32_i32$2;
             $6$hi = i64toi32_i32$0;
             break label$8;
            }
            i64toi32_i32$3 = $2 + 320 | 0;
            i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
            i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
            $65 = i64toi32_i32$0;
            i64toi32_i32$0 = ($2 + 208 | 0) + 8 | 0;
            HEAP32[i64toi32_i32$0 >> 2] = $65;
            HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
            i64toi32_i32$3 = $2 + 328 | 0;
            i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
            i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
            $70 = i64toi32_i32$2;
            i64toi32_i32$2 = $2 + 224 | 0;
            HEAP32[i64toi32_i32$2 >> 2] = $70;
            HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
            HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 348 | 0) >> 2] | 0;
            i64toi32_i32$3 = $2 + 312 | 0;
            i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
            i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
            $80 = i64toi32_i32$0;
            i64toi32_i32$0 = $2;
            HEAP32[(i64toi32_i32$0 + 208 | 0) >> 2] = $80;
            HEAP32[(i64toi32_i32$0 + 212 | 0) >> 2] = i64toi32_i32$2;
            i64toi32_i32$3 = i64toi32_i32$0 + 340 | 0;
            i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
            i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
            $84 = i64toi32_i32$2;
            i64toi32_i32$2 = $2;
            HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $84;
            HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$0;
            i64toi32_i32$3 = i64toi32_i32$2 + 304 | 0;
            i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
            i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
            $6 = i64toi32_i32$0;
            $6$hi = i64toi32_i32$2;
            $3 = HEAP32[($2 + 336 | 0) >> 2] | 0;
            $1 = HEAP32[($2 + 300 | 0) >> 2] | 0;
            $4 = HEAP32[(($2 + 280 | 0) + 8 | 0) >> 2] | 0;
            i64toi32_i32$3 = $2 + 292 | 0;
            i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
            i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
            $101 = i64toi32_i32$2;
            i64toi32_i32$2 = $2;
            HEAP32[(i64toi32_i32$2 + 284 | 0) >> 2] = $101;
            HEAP32[(i64toi32_i32$2 + 288 | 0) >> 2] = i64toi32_i32$0;
            HEAP32[(i64toi32_i32$2 + 280 | 0) >> 2] = $4;
            HEAP32[(i64toi32_i32$2 + 292 | 0) >> 2] = $1;
            i64toi32_i32$3 = i64toi32_i32$2;
            i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 280 | 0) >> 2] | 0;
            i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 284 | 0) >> 2] | 0;
            $8 = i64toi32_i32$0;
            $8$hi = i64toi32_i32$2;
            i64toi32_i32$3 = i64toi32_i32$0;
            i64toi32_i32$0 = -1;
            i64toi32_i32$1 = -256;
            i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
            $7 = i64toi32_i32$3 & i64toi32_i32$1 | 0;
            $7$hi = i64toi32_i32$0;
            i64toi32_i32$2 = $2;
            i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 288 | 0) >> 2] | 0;
            i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 292 | 0) >> 2] | 0;
            $5 = i64toi32_i32$0;
            $5$hi = i64toi32_i32$3;
            break label$2;
           }
           i64toi32_i32$2 = $2 + 312 | 0;
           i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
           $116 = i64toi32_i32$3;
           i64toi32_i32$3 = $2 + 216 | 0;
           HEAP32[i64toi32_i32$3 >> 2] = $116;
           HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
           i64toi32_i32$2 = $2 + 320 | 0;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
           i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
           $122 = i64toi32_i32$0;
           i64toi32_i32$0 = ($2 + 208 | 0) + 16 | 0;
           HEAP32[i64toi32_i32$0 >> 2] = $122;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
           i64toi32_i32$2 = $2 + 304 | 0;
           i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
           $126 = i64toi32_i32$3;
           i64toi32_i32$3 = $2;
           HEAP32[(i64toi32_i32$3 + 208 | 0) >> 2] = $126;
           HEAP32[(i64toi32_i32$3 + 212 | 0) >> 2] = i64toi32_i32$0;
           break label$3;
          }
          $cardano_serialization_lib__utils__BigNum_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h29637bb571dceb02($2 + 280 | 0 | 0, $1 | 0);
          i64toi32_i32$2 = $2;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 288 | 0) >> 2] | 0;
          i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 292 | 0) >> 2] | 0;
          $8 = i64toi32_i32$0;
          $8$hi = i64toi32_i32$3;
          i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 280 | 0) >> 2] | 0;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 284 | 0) >> 2] | 0;
          i64toi32_i32$2 = i64toi32_i32$3;
          i64toi32_i32$3 = 0;
          i64toi32_i32$1 = 1;
          if ((i64toi32_i32$2 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) | 0) {
           break label$5
          }
          $cardano_serialization_lib__plutus__PlutusList_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hfdf263ce80660b6e($2 + 280 | 0 | 0, $1 | 0);
          if ((HEAP32[($2 + 280 | 0) >> 2] | 0 | 0) == (1 | 0)) {
           break label$4
          }
          i64toi32_i32$1 = ($2 + 280 | 0) + 12 | 0;
          i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
          $147 = i64toi32_i32$2;
          i64toi32_i32$2 = ($2 + 64 | 0) + 12 | 0;
          HEAP32[i64toi32_i32$2 >> 2] = $147;
          HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
          i64toi32_i32$1 = $2;
          i64toi32_i32$0 = HEAP32[($2 + 284 | 0) >> 2] | 0;
          i64toi32_i32$2 = HEAP32[($2 + 288 | 0) >> 2] | 0;
          $6 = i64toi32_i32$0;
          $6$hi = i64toi32_i32$2;
          i64toi32_i32$0 = $2;
          HEAP32[(i64toi32_i32$0 + 68 | 0) >> 2] = $6;
          HEAP32[(i64toi32_i32$0 + 72 | 0) >> 2] = i64toi32_i32$2;
          $4 = $6;
          HEAP32[(i64toi32_i32$0 + 48 | 0) >> 2] = $6;
          i64toi32_i32$1 = i64toi32_i32$0 + 72 | 0;
          i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
          $9 = i64toi32_i32$2;
          $9$hi = i64toi32_i32$0;
          i64toi32_i32$2 = $2;
          HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = $9;
          HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] = i64toi32_i32$0;
          HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] = HEAP32[(i64toi32_i32$2 + 80 | 0) >> 2] | 0;
          label$14 : {
           i64toi32_i32$0 = $5$hi;
           i64toi32_i32$1 = $5;
           i64toi32_i32$2 = 0;
           i64toi32_i32$3 = 1;
           if ((i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) | 0) {
            break label$14
           }
           cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 280 | 0 | 0, $1 | 0);
           $1 = HEAPU8[($2 + 288 | 0) >> 0] | 0;
           label$15 : {
            label$16 : {
             i64toi32_i32$3 = $2;
             i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 280 | 0) >> 2] | 0;
             i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 284 | 0) >> 2] | 0;
             i64toi32_i32$3 = i64toi32_i32$1;
             i64toi32_i32$1 = 0;
             i64toi32_i32$2 = 1;
             if ((i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
              break label$16
             }
             if (($1 & 255 | 0 | 0) == (5 | 0)) {
              break label$14
             }
             i64toi32_i32$3 = 0;
             $8 = 5;
             $8$hi = i64toi32_i32$3;
             break label$15;
            }
            i64toi32_i32$2 = $2 + 312 | 0;
            i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
            i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
            $5 = i64toi32_i32$3;
            $5$hi = i64toi32_i32$0;
            i64toi32_i32$3 = ($2 + 64 | 0) + 8 | 0;
            HEAP32[i64toi32_i32$3 >> 2] = $5;
            HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
            i64toi32_i32$2 = $2 + 320 | 0;
            i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
            i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
            $8 = i64toi32_i32$0;
            $8$hi = i64toi32_i32$3;
            i64toi32_i32$0 = ($2 + 64 | 0) + 16 | 0;
            HEAP32[i64toi32_i32$0 >> 2] = $8;
            HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
            i64toi32_i32$3 = $5$hi;
            i64toi32_i32$0 = ($2 + 208 | 0) + 8 | 0;
            HEAP32[i64toi32_i32$0 >> 2] = $5;
            HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
            i64toi32_i32$3 = $8$hi;
            i64toi32_i32$0 = ($2 + 208 | 0) + 16 | 0;
            HEAP32[i64toi32_i32$0 >> 2] = $8;
            HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
            i64toi32_i32$2 = $2 + 304 | 0;
            i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
            i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
            $5 = i64toi32_i32$3;
            $5$hi = i64toi32_i32$0;
            i64toi32_i32$3 = $2;
            HEAP32[(i64toi32_i32$3 + 64 | 0) >> 2] = $5;
            HEAP32[(i64toi32_i32$3 + 68 | 0) >> 2] = i64toi32_i32$0;
            HEAP32[(i64toi32_i32$3 + 208 | 0) >> 2] = $5;
            HEAP32[(i64toi32_i32$3 + 212 | 0) >> 2] = i64toi32_i32$0;
            i64toi32_i32$2 = i64toi32_i32$3;
            i64toi32_i32$0 = HEAPU8[(i64toi32_i32$3 + 289 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 290 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 291 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 292 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            i64toi32_i32$3 = 0;
            $208 = i64toi32_i32$0;
            $208$hi = i64toi32_i32$3;
            i64toi32_i32$2 = i64toi32_i32$2 + 293 | 0;
            i64toi32_i32$3 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
            i64toi32_i32$0 = 0;
            $211 = i64toi32_i32$3;
            $211$hi = i64toi32_i32$0;
            i64toi32_i32$2 = $2 + 295 | 0;
            i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
            i64toi32_i32$3 = 0;
            i64toi32_i32$2 = i64toi32_i32$0;
            i64toi32_i32$0 = 0;
            i64toi32_i32$1 = 16;
            i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
            if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
             i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
             $56 = 0;
            } else {
             i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$4 | 0) | 0;
             $56 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
            }
            $215$hi = i64toi32_i32$0;
            i64toi32_i32$0 = $211$hi;
            i64toi32_i32$3 = $211;
            i64toi32_i32$2 = $215$hi;
            i64toi32_i32$1 = $56;
            i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
            i64toi32_i32$0 = i64toi32_i32$3 | i64toi32_i32$1 | 0;
            i64toi32_i32$3 = 0;
            i64toi32_i32$1 = 32;
            i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
            if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
             i64toi32_i32$3 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
             $57 = 0;
            } else {
             i64toi32_i32$3 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
             $57 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
            }
            $217$hi = i64toi32_i32$3;
            i64toi32_i32$3 = $208$hi;
            i64toi32_i32$2 = $208;
            i64toi32_i32$0 = $217$hi;
            i64toi32_i32$1 = $57;
            i64toi32_i32$0 = i64toi32_i32$3 | i64toi32_i32$0 | 0;
            i64toi32_i32$3 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
            i64toi32_i32$2 = 0;
            i64toi32_i32$1 = 8;
            i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
            if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
             i64toi32_i32$2 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
             $58 = 0;
            } else {
             i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
             $58 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
            }
            $219$hi = i64toi32_i32$2;
            i64toi32_i32$2 = 0;
            i64toi32_i32$0 = $1;
            i64toi32_i32$3 = 0;
            i64toi32_i32$1 = 255;
            i64toi32_i32$3 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
            $222 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
            $222$hi = i64toi32_i32$3;
            i64toi32_i32$3 = $219$hi;
            i64toi32_i32$2 = $58;
            i64toi32_i32$0 = $222$hi;
            i64toi32_i32$1 = $222;
            i64toi32_i32$0 = i64toi32_i32$3 | i64toi32_i32$0 | 0;
            $5 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
            $5$hi = i64toi32_i32$0;
            i64toi32_i32$3 = ($2 + 280 | 0) + 16 | 0;
            i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
            i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
            $6 = i64toi32_i32$0;
            $6$hi = i64toi32_i32$2;
            i64toi32_i32$2 = 0;
            $8 = 2;
            $8$hi = i64toi32_i32$2;
           }
           label$17 : {
            i64toi32_i32$2 = $9$hi;
            i64toi32_i32$3 = $9;
            i64toi32_i32$0 = 0;
            i64toi32_i32$1 = 32;
            i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
            if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
             i64toi32_i32$0 = 0;
             $59 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
            } else {
             i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
             $59 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$4 | 0) | 0;
            }
            $1 = $59;
            if (!$1) {
             break label$17
            }
            $1 = Math_imul($1, 48);
            label$18 : while (1) {
             core__ptr__drop_in_place_cardano_serialization_lib__plutus__PlutusData___hfab843e66e0f9428_2($4 | 0);
             $4 = $4 + 48 | 0;
             $1 = $1 + -48 | 0;
             if ($1) {
              continue label$18
             }
             break label$18;
            };
           }
           $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h36e817e704f6f25e($2 + 48 | 0 | 0);
           break label$2;
          }
          i64toi32_i32$2 = $2;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
          i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
          $5 = i64toi32_i32$0;
          $5$hi = i64toi32_i32$3;
          i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] | 0;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] | 0;
          $6 = i64toi32_i32$3;
          $6$hi = i64toi32_i32$0;
         }
         i64toi32_i32$0 = $8$hi;
         i64toi32_i32$3 = $0;
         HEAP32[(i64toi32_i32$3 + 8 | 0) >> 2] = $8;
         HEAP32[(i64toi32_i32$3 + 12 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$0 = $5$hi;
         i64toi32_i32$3 = i64toi32_i32$3 + 24 | 0;
         HEAP32[i64toi32_i32$3 >> 2] = $5;
         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$0 = $6$hi;
         i64toi32_i32$3 = $0 + 16 | 0;
         HEAP32[i64toi32_i32$3 >> 2] = $6;
         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$0 = 0;
         $5 = 0;
         $5$hi = i64toi32_i32$0;
         break label$1;
        }
        $3 = 0;
        i64toi32_i32$0 = 0;
        $8 = 15;
        $8$hi = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        $7 = 0;
        $7$hi = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        $6 = 102;
        $6$hi = i64toi32_i32$0;
        break label$2;
       }
       i64toi32_i32$2 = $2 + 312 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $8 = i64toi32_i32$0;
       $8$hi = i64toi32_i32$3;
       i64toi32_i32$0 = ($2 + 24 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $8;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
       i64toi32_i32$2 = $2 + 320 | 0;
       i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $6 = i64toi32_i32$3;
       $6$hi = i64toi32_i32$0;
       i64toi32_i32$3 = ($2 + 24 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$3 >> 2] = $6;
       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$0 = $8$hi;
       i64toi32_i32$3 = ($2 + 208 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$3 >> 2] = $8;
       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$0 = $6$hi;
       i64toi32_i32$3 = ($2 + 208 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$3 >> 2] = $6;
       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = $2 + 304 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $8 = i64toi32_i32$0;
       $8$hi = i64toi32_i32$3;
       i64toi32_i32$0 = $2;
       HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = $8;
       HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = i64toi32_i32$3;
       HEAP32[(i64toi32_i32$0 + 208 | 0) >> 2] = $8;
       HEAP32[(i64toi32_i32$0 + 212 | 0) >> 2] = i64toi32_i32$3;
       i64toi32_i32$2 = (i64toi32_i32$0 + 280 | 0) + 16 | 0;
       i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $6 = i64toi32_i32$3;
       $6$hi = i64toi32_i32$0;
       break label$3;
      }
      i64toi32_i32$2 = $2 + 320 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $293 = i64toi32_i32$0;
      i64toi32_i32$0 = ($2 + 208 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $293;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
      i64toi32_i32$2 = $2 + 328 | 0;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $299 = i64toi32_i32$3;
      i64toi32_i32$3 = ($2 + 208 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$3 >> 2] = $299;
      HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 348 | 0) >> 2] | 0;
      i64toi32_i32$2 = $2;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 340 | 0) >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 344 | 0) >> 2] | 0;
      $308 = i64toi32_i32$0;
      i64toi32_i32$0 = i64toi32_i32$2;
      HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $308;
      HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$3;
      i64toi32_i32$2 = i64toi32_i32$0 + 312 | 0;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $312 = i64toi32_i32$3;
      i64toi32_i32$3 = $2;
      HEAP32[(i64toi32_i32$3 + 208 | 0) >> 2] = $312;
      HEAP32[(i64toi32_i32$3 + 212 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$0 = $8$hi;
      i64toi32_i32$2 = $8;
      i64toi32_i32$3 = -1;
      i64toi32_i32$1 = -256;
      i64toi32_i32$3 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
      $7 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
      $7$hi = i64toi32_i32$3;
      i64toi32_i32$0 = $2 + 304 | 0;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
      $6 = i64toi32_i32$3;
      $6$hi = i64toi32_i32$2;
      i64toi32_i32$0 = ($2 + 280 | 0) + 16 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
      $5 = i64toi32_i32$2;
      $5$hi = i64toi32_i32$3;
      $3 = HEAP32[($2 + 336 | 0) >> 2] | 0;
      break label$2;
     }
     memcpy($2 + 280 | 0 | 0, memcpy($2 + 136 | 0 | 4 | 0 | 0, memcpy($2 + 208 | 0 | 4 | 0 | 0, ($2 + 280 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
     $1 = ($2 + 64 | 0) + 8 | 0;
     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $2 + 280 | 0 | 0, 1070813 | 0, 5 | 0);
     i64toi32_i32$0 = $2 + 104 | 0;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $350 = i64toi32_i32$3;
     i64toi32_i32$3 = ($2 + 208 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $350;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$0 = $2 + 112 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $356 = i64toi32_i32$2;
     i64toi32_i32$2 = ($2 + 208 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $356;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
     HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 132 | 0) >> 2] | 0;
     i64toi32_i32$0 = $2 + 96 | 0;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $366 = i64toi32_i32$3;
     i64toi32_i32$3 = $2;
     HEAP32[(i64toi32_i32$3 + 208 | 0) >> 2] = $366;
     HEAP32[(i64toi32_i32$3 + 212 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$0 = i64toi32_i32$3 + 124 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $370 = i64toi32_i32$2;
     i64toi32_i32$2 = $2;
     HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $370;
     HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$0 = $1;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $8 = i64toi32_i32$3;
     $8$hi = i64toi32_i32$2;
     i64toi32_i32$0 = i64toi32_i32$3;
     i64toi32_i32$3 = -1;
     i64toi32_i32$1 = -256;
     i64toi32_i32$3 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     $7 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
     $7$hi = i64toi32_i32$3;
     i64toi32_i32$2 = ($2 + 64 | 0) + 16 | 0;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $5 = i64toi32_i32$3;
     $5$hi = i64toi32_i32$0;
     i64toi32_i32$2 = $2 + 88 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $6 = i64toi32_i32$0;
     $6$hi = i64toi32_i32$3;
     $3 = HEAP32[($2 + 120 | 0) >> 2] | 0;
     break label$2;
    }
    $3 = 0;
    i64toi32_i32$3 = 0;
    $8 = 2;
    $8$hi = i64toi32_i32$3;
    i64toi32_i32$3 = 0;
    $7 = 0;
    $7$hi = i64toi32_i32$3;
   }
   i64toi32_i32$3 = $6$hi;
   i64toi32_i32$0 = ($2 + 280 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $6;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$3 = $5$hi;
   i64toi32_i32$0 = ($2 + 280 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $5;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$2 = $2;
   i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 208 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 212 | 0) >> 2] | 0;
   $396 = i64toi32_i32$3;
   i64toi32_i32$3 = i64toi32_i32$2 + 304 | 0;
   HEAP32[i64toi32_i32$3 >> 2] = $396;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
   $400 = i64toi32_i32$0;
   i64toi32_i32$0 = i64toi32_i32$2 + 332 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $400;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$2 = (i64toi32_i32$2 + 208 | 0) + 8 | 0;
   i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $406 = i64toi32_i32$3;
   i64toi32_i32$3 = $2 + 312 | 0;
   HEAP32[i64toi32_i32$3 >> 2] = $406;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = ($2 + 208 | 0) + 16 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $412 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 320 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $412;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
   HEAP32[($2 + 340 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
   HEAP32[($2 + 328 | 0) >> 2] = $3;
   i64toi32_i32$3 = $8$hi;
   i64toi32_i32$2 = $8;
   i64toi32_i32$0 = 0;
   i64toi32_i32$1 = 255;
   i64toi32_i32$0 = i64toi32_i32$3 & i64toi32_i32$0 | 0;
   $423 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
   $423$hi = i64toi32_i32$0;
   i64toi32_i32$0 = $7$hi;
   i64toi32_i32$3 = $7;
   i64toi32_i32$2 = -1;
   i64toi32_i32$1 = -256;
   i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
   $425 = i64toi32_i32$3 & i64toi32_i32$1 | 0;
   $425$hi = i64toi32_i32$2;
   i64toi32_i32$2 = $423$hi;
   i64toi32_i32$0 = $423;
   i64toi32_i32$3 = $425$hi;
   i64toi32_i32$1 = $425;
   i64toi32_i32$3 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
   $426 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
   i64toi32_i32$0 = $2;
   HEAP32[(i64toi32_i32$0 + 280 | 0) >> 2] = $426;
   HEAP32[(i64toi32_i32$0 + 284 | 0) >> 2] = i64toi32_i32$3;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, i64toi32_i32$0 + 280 | 0 | 0, 1070818 | 0, 16 | 0);
   i64toi32_i32$3 = 0;
   $5 = 1;
   $5$hi = i64toi32_i32$3;
  }
  i64toi32_i32$3 = $5$hi;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $5;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
  global$0 = $2 + 352 | 0;
 }
 
 function serde_json__read__parse_escape__h175788f180e5a403($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $5 = 0, $5$hi = 0, $4 = 0, $14 = 0, $15 = 0, $6 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $20 = 0, $6$hi = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           label$10 : {
            label$11 : {
             label$12 : {
              i64toi32_i32$0 = serde_json__read__next_or_eof__h08ccb81e81cc75b2($0 | 0) | 0;
              i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
              $5 = i64toi32_i32$0;
              $5$hi = i64toi32_i32$1;
              $3 = i64toi32_i32$0;
              if (i64toi32_i32$0 & 1 | 0) {
               break label$12
              }
              label$13 : {
               $3 = ($3 >>> 8 | 0) & 255 | 0;
               if (($3 | 0) > (109 | 0)) {
                break label$13
               }
               label$14 : {
                if (($3 | 0) > (97 | 0)) {
                 break label$14
                }
                if (($3 | 0) == (34 | 0)) {
                 break label$11
                }
                if (($3 | 0) == (47 | 0)) {
                 break label$9
                }
                if (($3 | 0) == (92 | 0)) {
                 break label$10
                }
                break label$2;
               }
               switch ($3 + -98 | 0 | 0) {
               case 4:
                break label$7;
               case 0:
                break label$8;
               default:
                break label$2;
               };
              }
              switch ($3 + -110 | 0 | 0) {
              case 7:
               break label$3;
              case 6:
               break label$4;
              case 4:
               break label$5;
              case 0:
               break label$6;
              default:
               break label$2;
              };
             }
             i64toi32_i32$1 = $5$hi;
             i64toi32_i32$2 = $5;
             i64toi32_i32$0 = 0;
             i64toi32_i32$3 = 32;
             i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
             if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
              i64toi32_i32$0 = 0;
              $14 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
             } else {
              i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
              $14 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
             }
             $1 = $14;
             break label$1;
            }
            label$15 : {
             $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
             if ((HEAP32[($1 + 4 | 0) >> 2] | 0 | 0) != ($0 | 0)) {
              break label$15
             }
             alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__he90fb3a4f4cd283b($1 | 0, $0 | 0, 1 | 0);
             $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
            }
            HEAP8[((HEAP32[$1 >> 2] | 0) + $0 | 0) >> 0] = 34;
            HEAP32[($1 + 8 | 0) >> 2] = (HEAP32[($1 + 8 | 0) >> 2] | 0) + 1 | 0;
            $1 = 0;
            break label$1;
           }
           label$16 : {
            $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
            if ((HEAP32[($1 + 4 | 0) >> 2] | 0 | 0) != ($0 | 0)) {
             break label$16
            }
            alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__he90fb3a4f4cd283b($1 | 0, $0 | 0, 1 | 0);
            $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
           }
           HEAP8[((HEAP32[$1 >> 2] | 0) + $0 | 0) >> 0] = 92;
           HEAP32[($1 + 8 | 0) >> 2] = (HEAP32[($1 + 8 | 0) >> 2] | 0) + 1 | 0;
           $1 = 0;
           break label$1;
          }
          label$17 : {
           $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
           if ((HEAP32[($1 + 4 | 0) >> 2] | 0 | 0) != ($0 | 0)) {
            break label$17
           }
           alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__he90fb3a4f4cd283b($1 | 0, $0 | 0, 1 | 0);
           $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
          }
          HEAP8[((HEAP32[$1 >> 2] | 0) + $0 | 0) >> 0] = 47;
          HEAP32[($1 + 8 | 0) >> 2] = (HEAP32[($1 + 8 | 0) >> 2] | 0) + 1 | 0;
          $1 = 0;
          break label$1;
         }
         label$18 : {
          $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
          if ((HEAP32[($1 + 4 | 0) >> 2] | 0 | 0) != ($0 | 0)) {
           break label$18
          }
          alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__he90fb3a4f4cd283b($1 | 0, $0 | 0, 1 | 0);
          $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
         }
         HEAP8[((HEAP32[$1 >> 2] | 0) + $0 | 0) >> 0] = 8;
         HEAP32[($1 + 8 | 0) >> 2] = (HEAP32[($1 + 8 | 0) >> 2] | 0) + 1 | 0;
         $1 = 0;
         break label$1;
        }
        label$19 : {
         $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
         if ((HEAP32[($1 + 4 | 0) >> 2] | 0 | 0) != ($0 | 0)) {
          break label$19
         }
         alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__he90fb3a4f4cd283b($1 | 0, $0 | 0, 1 | 0);
         $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
        }
        HEAP8[((HEAP32[$1 >> 2] | 0) + $0 | 0) >> 0] = 12;
        HEAP32[($1 + 8 | 0) >> 2] = (HEAP32[($1 + 8 | 0) >> 2] | 0) + 1 | 0;
        $1 = 0;
        break label$1;
       }
       label$20 : {
        $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
        if ((HEAP32[($1 + 4 | 0) >> 2] | 0 | 0) != ($0 | 0)) {
         break label$20
        }
        alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__he90fb3a4f4cd283b($1 | 0, $0 | 0, 1 | 0);
        $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
       }
       HEAP8[((HEAP32[$1 >> 2] | 0) + $0 | 0) >> 0] = 10;
       HEAP32[($1 + 8 | 0) >> 2] = (HEAP32[($1 + 8 | 0) >> 2] | 0) + 1 | 0;
       $1 = 0;
       break label$1;
      }
      label$21 : {
       $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
       if ((HEAP32[($1 + 4 | 0) >> 2] | 0 | 0) != ($0 | 0)) {
        break label$21
       }
       alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__he90fb3a4f4cd283b($1 | 0, $0 | 0, 1 | 0);
       $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
      }
      HEAP8[((HEAP32[$1 >> 2] | 0) + $0 | 0) >> 0] = 13;
      HEAP32[($1 + 8 | 0) >> 2] = (HEAP32[($1 + 8 | 0) >> 2] | 0) + 1 | 0;
      $1 = 0;
      break label$1;
     }
     label$22 : {
      $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
      if ((HEAP32[($1 + 4 | 0) >> 2] | 0 | 0) != ($0 | 0)) {
       break label$22
      }
      alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__he90fb3a4f4cd283b($1 | 0, $0 | 0, 1 | 0);
      $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     }
     HEAP8[((HEAP32[$1 >> 2] | 0) + $0 | 0) >> 0] = 9;
     HEAP32[($1 + 8 | 0) >> 2] = (HEAP32[($1 + 8 | 0) >> 2] | 0) + 1 | 0;
     $1 = 0;
     break label$1;
    }
    label$23 : {
     label$24 : {
      label$25 : {
       label$26 : {
        label$27 : {
         label$28 : {
          label$29 : {
           label$30 : {
            label$31 : {
             i64toi32_i32$0 = $serde_json__read__SliceRead_20as_20serde_json__read__Read___decode_hex_escape__h3856e4104f33707e($0 | 0) | 0;
             i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
             $5 = i64toi32_i32$0;
             $5$hi = i64toi32_i32$2;
             i64toi32_i32$1 = i64toi32_i32$0;
             i64toi32_i32$0 = 0;
             i64toi32_i32$3 = 65535;
             i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
             i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
             i64toi32_i32$1 = 0;
             i64toi32_i32$3 = 0;
             if ((i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | 0) {
              break label$31
             }
             label$32 : {
              label$33 : {
               label$34 : {
                label$35 : {
                 i64toi32_i32$2 = $5$hi;
                 i64toi32_i32$3 = $5;
                 i64toi32_i32$0 = 0;
                 i64toi32_i32$1 = 16;
                 i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
                 if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
                  i64toi32_i32$0 = 0;
                  $15 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
                 } else {
                  i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
                  $15 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$4 | 0) | 0;
                 }
                 $6 = $15;
                 $6$hi = i64toi32_i32$0;
                 $3 = $6;
                 $4 = $3 & 64512 | 0;
                 if (($4 | 0) == (55296 | 0)) {
                  break label$35
                 }
                 if (($4 | 0) != (56320 | 0)) {
                  break label$34
                 }
                 serde_json__read__SliceRead__position_of_index__ha8a2610e8c8fa0b4($2 + 24 | 0 | 0, $0 | 0, HEAP32[($0 + 8 | 0) >> 2] | 0 | 0);
                 $1 = HEAP32[($2 + 28 | 0) >> 2] | 0;
                 $0 = HEAP32[($2 + 24 | 0) >> 2] | 0;
                 HEAP32[($2 + 64 | 0) >> 2] = 17;
                 $1 = serde_json__error__Error__syntax__h11c9d7f40fe522f9($2 + 64 | 0 | 0, $0 | 0, $1 | 0) | 0;
                 break label$1;
                }
                i64toi32_i32$0 = serde_json__read__next_or_eof__h08ccb81e81cc75b2($0 | 0) | 0;
                i64toi32_i32$3 = i64toi32_i32$HIGH_BITS;
                $5 = i64toi32_i32$0;
                $5$hi = i64toi32_i32$3;
                if (i64toi32_i32$0 & 1 | 0) {
                 break label$30
                }
                i64toi32_i32$3 = $5$hi;
                i64toi32_i32$2 = $5;
                i64toi32_i32$0 = 0;
                i64toi32_i32$1 = 65280;
                i64toi32_i32$0 = i64toi32_i32$3 & i64toi32_i32$0 | 0;
                i64toi32_i32$3 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
                i64toi32_i32$2 = 0;
                i64toi32_i32$1 = 23552;
                if ((i64toi32_i32$3 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$2 | 0) | 0) {
                 break label$29
                }
                i64toi32_i32$3 = serde_json__read__next_or_eof__h08ccb81e81cc75b2($0 | 0) | 0;
                i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
                $5 = i64toi32_i32$3;
                $5$hi = i64toi32_i32$0;
                i64toi32_i32$1 = i64toi32_i32$3;
                i64toi32_i32$3 = 0;
                i64toi32_i32$2 = 1;
                i64toi32_i32$3 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
                if (!!(i64toi32_i32$1 & i64toi32_i32$2 | 0 | i64toi32_i32$3 | 0)) {
                 break label$28
                }
                i64toi32_i32$3 = $5$hi;
                i64toi32_i32$0 = $5;
                i64toi32_i32$1 = 0;
                i64toi32_i32$2 = 65280;
                i64toi32_i32$1 = i64toi32_i32$3 & i64toi32_i32$1 | 0;
                i64toi32_i32$3 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
                i64toi32_i32$0 = 0;
                i64toi32_i32$2 = 29952;
                if ((i64toi32_i32$3 | 0) != (i64toi32_i32$2 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$0 | 0) | 0) {
                 break label$27
                }
                i64toi32_i32$3 = $serde_json__read__SliceRead_20as_20serde_json__read__Read___decode_hex_escape__h3856e4104f33707e($0 | 0) | 0;
                i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
                $5 = i64toi32_i32$3;
                $5$hi = i64toi32_i32$1;
                i64toi32_i32$2 = i64toi32_i32$3;
                i64toi32_i32$3 = 0;
                i64toi32_i32$0 = 65535;
                i64toi32_i32$3 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
                if (!!(i64toi32_i32$2 & i64toi32_i32$0 | 0 | i64toi32_i32$3 | 0)) {
                 break label$26
                }
                i64toi32_i32$3 = $5$hi;
                i64toi32_i32$1 = $5;
                i64toi32_i32$2 = 0;
                i64toi32_i32$0 = 16;
                i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
                if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
                 i64toi32_i32$2 = 0;
                 $16 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
                } else {
                 i64toi32_i32$2 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
                 $16 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
                }
                $4 = $16;
                if (($4 & 64512 | 0 | 0) != (56320 | 0)) {
                 break label$25
                }
                label$36 : {
                 $4 = (($3 + 10240 | 0) & 65535 | 0) << 10 | 0 | (($4 + 9216 | 0) & 65535 | 0) | 0;
                 $3 = $4 + 65536 | 0;
                 if (($3 | 0) == (1114112 | 0)) {
                  break label$36
                 }
                 if ($4 >>> 0 > 1048575 >>> 0) {
                  break label$36
                 }
                 if (($3 & 134215680 | 0 | 0) != (55296 | 0)) {
                  break label$33
                 }
                }
                serde_json__read__SliceRead__position_of_index__ha8a2610e8c8fa0b4($2 + 32 | 0 | 0, $0 | 0, HEAP32[($0 + 8 | 0) >> 2] | 0 | 0);
                $1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
                $0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
                HEAP32[($2 + 64 | 0) >> 2] = 14;
                $1 = serde_json__error__Error__syntax__h11c9d7f40fe522f9($2 + 64 | 0 | 0, $0 | 0, $1 | 0) | 0;
                break label$1;
               }
               if (($3 & 63488 | 0 | 0) == (55296 | 0)) {
                break label$32
               }
               HEAP32[($2 + 64 | 0) >> 2] = 0;
               $0 = $3 & 65535 | 0;
               if ($0 >>> 0 < 128 >>> 0) {
                break label$24
               }
               label$37 : {
                if ($0 >>> 0 >= 2048 >>> 0) {
                 break label$37
                }
                HEAP8[($2 + 65 | 0) >> 0] = $3 & 63 | 0 | 128 | 0;
                i64toi32_i32$2 = $5$hi;
                HEAP8[($2 + 64 | 0) >> 0] = $5 >>> 22 | 0 | 192 | 0;
                $3 = 2;
                $0 = $2 + 64 | 0;
                break label$23;
               }
               HEAP8[($2 + 64 | 0) >> 0] = $0 >>> 12 | 0 | 224 | 0;
               HEAP8[($2 + 66 | 0) >> 0] = $3 & 63 | 0 | 128 | 0;
               i64toi32_i32$2 = $5$hi;
               HEAP8[($2 + 65 | 0) >> 0] = ($5 >>> 22 | 0) & 63 | 0 | 128 | 0;
               $3 = 3;
               $0 = $2 + 64 | 0;
               break label$23;
              }
              HEAP8[($2 + 67 | 0) >> 0] = $3 & 63 | 0 | 128 | 0;
              HEAP8[($2 + 64 | 0) >> 0] = $3 >>> 18 | 0 | 240 | 0;
              HEAP8[($2 + 66 | 0) >> 0] = ($3 >>> 6 | 0) & 63 | 0 | 128 | 0;
              HEAP8[($2 + 65 | 0) >> 0] = ($3 >>> 12 | 0) & 63 | 0 | 128 | 0;
              $3 = 4;
              $0 = $2 + 64 | 0;
              break label$23;
             }
             serde_json__read__SliceRead__position_of_index__ha8a2610e8c8fa0b4($2 + 16 | 0 | 0, $0 | 0, HEAP32[($0 + 8 | 0) >> 2] | 0 | 0);
             $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
             $0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
             HEAP32[($2 + 64 | 0) >> 2] = 14;
             $1 = serde_json__error__Error__syntax__h11c9d7f40fe522f9($2 + 64 | 0 | 0, $0 | 0, $1 | 0) | 0;
             break label$1;
            }
            i64toi32_i32$2 = $5$hi;
            i64toi32_i32$3 = $5;
            i64toi32_i32$1 = 0;
            i64toi32_i32$0 = 32;
            i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
            if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
             i64toi32_i32$1 = 0;
             $17 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
            } else {
             i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
             $17 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$4 | 0) | 0;
            }
            $1 = $17;
            break label$1;
           }
           i64toi32_i32$1 = $5$hi;
           i64toi32_i32$2 = $5;
           i64toi32_i32$3 = 0;
           i64toi32_i32$0 = 32;
           i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
           if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
            i64toi32_i32$3 = 0;
            $18 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
           } else {
            i64toi32_i32$3 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
            $18 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
           }
           $1 = $18;
           break label$1;
          }
          serde_json__read__SliceRead__position_of_index__ha8a2610e8c8fa0b4($2 + 56 | 0 | 0, $0 | 0, HEAP32[($0 + 8 | 0) >> 2] | 0 | 0);
          $1 = HEAP32[($2 + 60 | 0) >> 2] | 0;
          $0 = HEAP32[($2 + 56 | 0) >> 2] | 0;
          HEAP32[($2 + 64 | 0) >> 2] = 20;
          $1 = serde_json__error__Error__syntax__h11c9d7f40fe522f9($2 + 64 | 0 | 0, $0 | 0, $1 | 0) | 0;
          break label$1;
         }
         i64toi32_i32$3 = $5$hi;
         i64toi32_i32$1 = $5;
         i64toi32_i32$2 = 0;
         i64toi32_i32$0 = 32;
         i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
          i64toi32_i32$2 = 0;
          $19 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
         } else {
          i64toi32_i32$2 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
          $19 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
         }
         $1 = $19;
         break label$1;
        }
        serde_json__read__SliceRead__position_of_index__ha8a2610e8c8fa0b4($2 + 48 | 0 | 0, $0 | 0, HEAP32[($0 + 8 | 0) >> 2] | 0 | 0);
        $1 = HEAP32[($2 + 52 | 0) >> 2] | 0;
        $0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
        HEAP32[($2 + 64 | 0) >> 2] = 20;
        $1 = serde_json__error__Error__syntax__h11c9d7f40fe522f9($2 + 64 | 0 | 0, $0 | 0, $1 | 0) | 0;
        break label$1;
       }
       i64toi32_i32$2 = $5$hi;
       i64toi32_i32$3 = $5;
       i64toi32_i32$1 = 0;
       i64toi32_i32$0 = 32;
       i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = 0;
        $20 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
        $20 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$4 | 0) | 0;
       }
       $1 = $20;
       break label$1;
      }
      serde_json__read__SliceRead__position_of_index__ha8a2610e8c8fa0b4($2 + 40 | 0 | 0, $0 | 0, HEAP32[($0 + 8 | 0) >> 2] | 0 | 0);
      $1 = HEAP32[($2 + 44 | 0) >> 2] | 0;
      $0 = HEAP32[($2 + 40 | 0) >> 2] | 0;
      HEAP32[($2 + 64 | 0) >> 2] = 17;
      $1 = serde_json__error__Error__syntax__h11c9d7f40fe522f9($2 + 64 | 0 | 0, $0 | 0, $1 | 0) | 0;
      break label$1;
     }
     i64toi32_i32$1 = $6$hi;
     HEAP8[($2 + 64 | 0) >> 0] = $6;
     $3 = 1;
     $0 = $2 + 64 | 0;
    }
    $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend__T_2ccore__slice__iter__Iter_T_____spec_extend__hbd860717b01c36cd($1 | 0, $0 | 0, $0 + $3 | 0 | 0);
    $1 = 0;
    break label$1;
   }
   serde_json__read__SliceRead__position_of_index__ha8a2610e8c8fa0b4($2 + 8 | 0 | 0, $0 | 0, HEAP32[($0 + 8 | 0) >> 2] | 0 | 0);
   $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   HEAP32[($2 + 64 | 0) >> 2] = 11;
   $1 = serde_json__error__Error__syntax__h11c9d7f40fe522f9($2 + 64 | 0 | 0, $0 | 0, $1 | 0) | 0;
  }
  global$0 = $2 + 80 | 0;
  return $1 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__Mint___deserialize__hd75757d6517eec3f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, $7 = 0, $12 = 0, $14 = 0, $14$hi = 0, i64toi32_i32$4 = 0, $15 = 0, $15$hi = 0, $11 = 0, $54 = 0, $55 = 0, $56 = 0, $57 = 0, $58 = 0, $59 = 0, $60 = 0, $61 = 0, $62 = 0, $63 = 0, $64 = 0, $65 = 0, $66 = 0, $67 = 0, $68 = 0, $69 = 0, $70 = 0, $71 = 0, $72 = 0, $73 = 0, $74 = 0, $75 = 0, $76 = 0, $77 = 0, $78 = 0, $79 = 0, $80 = 0, $3 = 0, $81 = 0, $82 = 0, $4 = 0, $5 = 0, $6 = 0, $8 = 0, $9 = 0, $10 = 0, $16 = 0, $16$hi = 0, $17 = 0, $17$hi = 0, $13 = 0, $124 = 0, $125 = 0, $125$hi = 0, $127$hi = 0, $130 = 0, $212 = 0, $217 = 0, $234 = 0, $238 = 0, $259 = 0, $265 = 0, $282 = 0, $286 = 0, $316 = 0, $322 = 0, $332 = 0, $346 = 0, $352 = 0, $356 = 0, $361 = 0, $367 = 0, $371 = 0, $383 = 0, $387 = 0, $393 = 0, $399 = 0, $426 = 0;
  $2 = global$0 - 336 | 0;
  global$0 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 12 | 0) >> 2] = 0;
  HEAP32[($2 + 16 | 0) >> 2] = i64toi32_i32$0;
  cbor_event__de__Deserializer_R___map__h7c2a4e830d885a05($2 + 264 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = ($2 + 264 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  $14$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 272 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 276 | 0) >> 2] | 0;
  $15 = i64toi32_i32$1;
  $15$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 264 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 268 | 0) >> 2] | 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
         break label$6
        }
        i64toi32_i32$2 = $14$hi;
        $3 = $14;
        label$7 : {
         i64toi32_i32$2 = $15$hi;
         i64toi32_i32$3 = $15;
         i64toi32_i32$1 = 0;
         i64toi32_i32$0 = 1;
         if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
          break label$7
         }
         if (!$3) {
          break label$3
         }
        }
        $4 = $2 + 216 | 0 | 4 | 0;
        $5 = $2 + 200 | 0 | 5 | 0;
        $6 = $2 + 272 | 0;
        $7 = $2 + 273 | 0;
        $8 = $2 + 264 | 0 | 1 | 0;
        $9 = $2 + 292 | 0;
        $10 = $2 + 291 | 0;
        label$8 : {
         label$9 : {
          label$10 : {
           label$11 : {
            label$12 : while (1) {
             std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 | 0, $1 | 0);
             $11 = 0;
             $12 = 2;
             label$13 : {
              if (HEAP32[($2 + 4 | 0) >> 2] | 0) {
               break label$13
              }
              i64toi32_i32$3 = 0;
              $15 = 8;
              $15$hi = i64toi32_i32$3;
              i64toi32_i32$3 = 0;
              $14 = 0;
              $14$hi = i64toi32_i32$3;
              break label$4;
             }
             label$14 : {
              if ((($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[$2 >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) == (7 | 0)) {
               break label$14
              }
              $cardano_serialization_lib__crypto__ScriptHash_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h589000d40634e72d($2 + 264 | 0 | 0, $1 | 0);
              if ((HEAPU8[($2 + 264 | 0) >> 0] | 0 | 0) == (1 | 0)) {
               break label$11
              }
              HEAP32[($2 + 216 | 0) >> 2] = HEAPU8[$7 >> 0] | 0 | ((HEAPU8[($7 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($7 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($7 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              $12 = $7 + 3 | 0;
              $57 = HEAPU8[$12 >> 0] | 0 | ((HEAPU8[($12 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($12 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($12 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              HEAP8[($2 + 219 | 0) >> 0] = $57;
              HEAP8[($2 + 220 | 0) >> 0] = $57 >>> 8 | 0;
              HEAP8[($2 + 221 | 0) >> 0] = $57 >>> 16 | 0;
              HEAP8[($2 + 222 | 0) >> 0] = $57 >>> 24 | 0;
              $54 = $8;
              HEAP32[($2 + 248 | 0) >> 2] = HEAPU8[$54 >> 0] | 0 | ((HEAPU8[($54 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($54 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($54 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              $58 = $54 + 3 | 0;
              $59 = HEAPU8[$58 >> 0] | 0 | ((HEAPU8[($58 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($58 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($58 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              HEAP8[($2 + 251 | 0) >> 0] = $59;
              HEAP8[($2 + 252 | 0) >> 0] = $59 >>> 8 | 0;
              HEAP8[($2 + 253 | 0) >> 0] = $59 >>> 16 | 0;
              HEAP8[($2 + 254 | 0) >> 0] = $59 >>> 24 | 0;
              HEAP32[($2 + 240 | 0) >> 2] = HEAP32[($2 + 216 | 0) >> 2] | 0;
              $60 = HEAPU8[($2 + 219 | 0) >> 0] | 0 | ((HEAPU8[($2 + 220 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 221 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 222 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              HEAP8[($2 + 243 | 0) >> 0] = $60;
              HEAP8[($2 + 244 | 0) >> 0] = $60 >>> 8 | 0;
              HEAP8[($2 + 245 | 0) >> 0] = $60 >>> 16 | 0;
              HEAP8[($2 + 246 | 0) >> 0] = $60 >>> 24 | 0;
              i64toi32_i32$0 = $9;
              i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0;
              i64toi32_i32$2 = 0;
              $14 = i64toi32_i32$3;
              $14$hi = i64toi32_i32$2;
              $11 = HEAPU8[($2 + 272 | 0) >> 0] | 0;
              i64toi32_i32$0 = $2;
              i64toi32_i32$2 = HEAP32[($2 + 280 | 0) >> 2] | 0;
              i64toi32_i32$3 = HEAP32[($2 + 284 | 0) >> 2] | 0;
              $16 = i64toi32_i32$2;
              $16$hi = i64toi32_i32$3;
              i64toi32_i32$0 = $2;
              i64toi32_i32$3 = HEAP32[($2 + 288 | 0) >> 2] | 0;
              i64toi32_i32$2 = 0;
              $17 = i64toi32_i32$3;
              $17$hi = i64toi32_i32$2;
              cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__MintAssets___deserialize__h1b812f4a046f3f71($2 + 264 | 0 | 0, $1 | 0);
              if ((HEAP32[($2 + 264 | 0) >> 2] | 0 | 0) == (1 | 0)) {
               break label$10
              }
              HEAP32[($2 + 216 | 0) >> 2] = HEAPU8[$7 >> 0] | 0 | ((HEAPU8[($7 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($7 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($7 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              $61 = HEAPU8[$12 >> 0] | 0 | ((HEAPU8[($12 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($12 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($12 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              HEAP8[($2 + 219 | 0) >> 0] = $61;
              HEAP8[($2 + 220 | 0) >> 0] = $61 >>> 8 | 0;
              HEAP8[($2 + 221 | 0) >> 0] = $61 >>> 16 | 0;
              HEAP8[($2 + 222 | 0) >> 0] = $61 >>> 24 | 0;
              HEAP32[($2 + 256 | 0) >> 2] = HEAP32[($2 + 216 | 0) >> 2] | 0;
              $62 = HEAPU8[($2 + 219 | 0) >> 0] | 0 | ((HEAPU8[($2 + 220 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 221 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 222 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              HEAP8[($2 + 259 | 0) >> 0] = $62;
              HEAP8[($2 + 260 | 0) >> 0] = $62 >>> 8 | 0;
              HEAP8[($2 + 261 | 0) >> 0] = $62 >>> 16 | 0;
              HEAP8[($2 + 262 | 0) >> 0] = $62 >>> 24 | 0;
              $12 = HEAP32[($2 + 268 | 0) >> 2] | 0;
              $13 = HEAPU8[($2 + 272 | 0) >> 0] | 0;
              $124 = $2;
              i64toi32_i32$2 = $17$hi;
              $125 = $17;
              $125$hi = i64toi32_i32$2;
              i64toi32_i32$2 = $14$hi;
              i64toi32_i32$0 = $14;
              i64toi32_i32$3 = 0;
              i64toi32_i32$1 = 32;
              i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
              if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
               i64toi32_i32$3 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
               $81 = 0;
              } else {
               i64toi32_i32$3 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
               $81 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
              }
              $127$hi = i64toi32_i32$3;
              i64toi32_i32$3 = $125$hi;
              i64toi32_i32$2 = $125;
              i64toi32_i32$0 = $127$hi;
              i64toi32_i32$1 = $81;
              i64toi32_i32$0 = i64toi32_i32$3 | i64toi32_i32$0 | 0;
              $14 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
              $14$hi = i64toi32_i32$0;
              $63 = $124;
              HEAP8[($63 + 287 | 0) >> 0] = $14;
              HEAP8[($63 + 288 | 0) >> 0] = $14 >>> 8 | 0;
              HEAP8[($63 + 289 | 0) >> 0] = $14 >>> 16 | 0;
              HEAP8[($63 + 290 | 0) >> 0] = $14 >>> 24 | 0;
              $130 = $10;
              i64toi32_i32$3 = $14;
              i64toi32_i32$2 = 0;
              i64toi32_i32$1 = 32;
              i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
              if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
               i64toi32_i32$2 = 0;
               $82 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
              } else {
               i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
               $82 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$4 | 0) | 0;
              }
              HEAP8[$130 >> 0] = $82;
              $64 = HEAPU8[($2 + 251 | 0) >> 0] | 0 | ((HEAPU8[($2 + 252 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 253 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 254 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              HEAP8[($2 + 267 | 0) >> 0] = $64;
              HEAP8[($2 + 268 | 0) >> 0] = $64 >>> 8 | 0;
              HEAP8[($2 + 269 | 0) >> 0] = $64 >>> 16 | 0;
              HEAP8[($2 + 270 | 0) >> 0] = $64 >>> 24 | 0;
              HEAP32[($2 + 264 | 0) >> 2] = HEAP32[($2 + 248 | 0) >> 2] | 0;
              HEAP8[($2 + 271 | 0) >> 0] = $11;
              $55 = $6;
              $65 = HEAP32[($2 + 240 | 0) >> 2] | 0;
              HEAP8[$55 >> 0] = $65;
              HEAP8[($55 + 1 | 0) >> 0] = $65 >>> 8 | 0;
              HEAP8[($55 + 2 | 0) >> 0] = $65 >>> 16 | 0;
              HEAP8[($55 + 3 | 0) >> 0] = $65 >>> 24 | 0;
              $66 = $55 + 3 | 0;
              $67 = HEAPU8[($2 + 243 | 0) >> 0] | 0 | ((HEAPU8[($2 + 244 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 245 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 246 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              HEAP8[$66 >> 0] = $67;
              HEAP8[($66 + 1 | 0) >> 0] = $67 >>> 8 | 0;
              HEAP8[($66 + 2 | 0) >> 0] = $67 >>> 16 | 0;
              HEAP8[($66 + 3 | 0) >> 0] = $67 >>> 24 | 0;
              i64toi32_i32$2 = $16$hi;
              i64toi32_i32$3 = $2;
              $68 = $16;
              HEAP8[($2 + 279 | 0) >> 0] = $68;
              HEAP8[($2 + 280 | 0) >> 0] = $68 >>> 8 | 0;
              HEAP8[($2 + 281 | 0) >> 0] = $68 >>> 16 | 0;
              HEAP8[($2 + 282 | 0) >> 0] = $68 >>> 24 | 0;
              HEAP8[($2 + 283 | 0) >> 0] = i64toi32_i32$2;
              HEAP8[($2 + 284 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
              HEAP8[($2 + 285 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
              HEAP8[($2 + 286 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
              HEAP8[($2 + 204 | 0) >> 0] = $13;
              HEAP32[($2 + 200 | 0) >> 2] = $12;
              $56 = $5;
              $69 = HEAP32[($2 + 256 | 0) >> 2] | 0;
              HEAP8[$56 >> 0] = $69;
              HEAP8[($56 + 1 | 0) >> 0] = $69 >>> 8 | 0;
              HEAP8[($56 + 2 | 0) >> 0] = $69 >>> 16 | 0;
              HEAP8[($56 + 3 | 0) >> 0] = $69 >>> 24 | 0;
              $70 = $56 + 3 | 0;
              $71 = HEAPU8[($2 + 259 | 0) >> 0] | 0 | ((HEAPU8[($2 + 260 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 261 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 262 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              HEAP8[$70 >> 0] = $71;
              HEAP8[($70 + 1 | 0) >> 0] = $71 >>> 8 | 0;
              HEAP8[($70 + 2 | 0) >> 0] = $71 >>> 16 | 0;
              HEAP8[($70 + 3 | 0) >> 0] = $71 >>> 24 | 0;
              alloc__collections__btree__map__BTreeMap_K_2cV___insert__h42468afb2d22301b($2 + 216 | 0 | 0, $2 + 8 | 0 | 0, $2 + 264 | 0 | 0, $2 + 200 | 0 | 0);
              label$15 : {
               $12 = HEAP32[($2 + 216 | 0) >> 2] | 0;
               if (!$12) {
                break label$15
               }
               $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h0265580a5be10b66($4 | 0);
              }
              if ($12) {
               break label$9
              }
              i64toi32_i32$2 = $15$hi;
              i64toi32_i32$0 = $15;
              i64toi32_i32$3 = 0;
              i64toi32_i32$1 = 1;
              if ((i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | 0) {
               continue label$12
              }
              if ((HEAP32[($2 + 16 | 0) >> 2] | 0) >>> 0 < $3 >>> 0) {
               continue label$12
              }
              break label$3;
             }
             break label$12;
            };
            cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 264 | 0 | 0, $1 | 0);
            i64toi32_i32$1 = ($2 + 264 | 0) + 16 | 0;
            i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
            i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
            $14 = i64toi32_i32$0;
            $14$hi = i64toi32_i32$2;
            i64toi32_i32$1 = $2;
            i64toi32_i32$2 = HEAP32[($2 + 272 | 0) >> 2] | 0;
            i64toi32_i32$0 = HEAP32[($2 + 276 | 0) >> 2] | 0;
            $15 = i64toi32_i32$2;
            $15$hi = i64toi32_i32$0;
            i64toi32_i32$1 = $2;
            i64toi32_i32$0 = HEAP32[($2 + 264 | 0) >> 2] | 0;
            i64toi32_i32$2 = HEAP32[($2 + 268 | 0) >> 2] | 0;
            i64toi32_i32$1 = i64toi32_i32$0;
            i64toi32_i32$0 = 0;
            i64toi32_i32$3 = 1;
            if ((i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) | 0) {
             break label$5
            }
            i64toi32_i32$1 = $14$hi;
            i64toi32_i32$2 = $2 + 208 | 0;
            HEAP32[i64toi32_i32$2 >> 2] = $14;
            HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
            i64toi32_i32$1 = $15$hi;
            i64toi32_i32$2 = $2;
            HEAP32[($2 + 200 | 0) >> 2] = $15;
            HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$1;
            if (($15 & 255 | 0 | 0) == (5 | 0)) {
             break label$3
            }
            HEAP32[($2 + 264 | 0) >> 2] = 0;
            core__panicking__assert_failed__h96d8431cc974b591(0 | 0, $2 + 200 | 0 | 0, 1050312 | 0, $2 + 264 | 0 | 0, 1053088 | 0);
            abort();
           }
           i64toi32_i32$3 = $2 + 304 | 0;
           i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
           $212 = i64toi32_i32$1;
           i64toi32_i32$1 = ($2 + 168 | 0) + 8 | 0;
           HEAP32[i64toi32_i32$1 >> 2] = $212;
           HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
           i64toi32_i32$3 = $2 + 312 | 0;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
           $217 = i64toi32_i32$2;
           i64toi32_i32$2 = $2 + 184 | 0;
           HEAP32[i64toi32_i32$2 >> 2] = $217;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
           HEAP32[(($2 + 152 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 332 | 0) >> 2] | 0;
           HEAP32[($2 + 216 | 0) >> 2] = HEAPU8[$7 >> 0] | 0 | ((HEAPU8[($7 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($7 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($7 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $72 = $7 + 3 | 0;
           $73 = HEAPU8[$72 >> 0] | 0 | ((HEAPU8[($72 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($72 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($72 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 219 | 0) >> 0] = $73;
           HEAP8[($2 + 220 | 0) >> 0] = $73 >>> 8 | 0;
           HEAP8[($2 + 221 | 0) >> 0] = $73 >>> 16 | 0;
           HEAP8[($2 + 222 | 0) >> 0] = $73 >>> 24 | 0;
           i64toi32_i32$3 = $2 + 296 | 0;
           i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
           $234 = i64toi32_i32$1;
           i64toi32_i32$1 = $2;
           HEAP32[($2 + 168 | 0) >> 2] = $234;
           HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$2;
           i64toi32_i32$3 = $2 + 324 | 0;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
           $238 = i64toi32_i32$2;
           i64toi32_i32$2 = $2;
           HEAP32[($2 + 152 | 0) >> 2] = $238;
           HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$1;
           $11 = HEAP32[($2 + 320 | 0) >> 2] | 0;
           $12 = HEAPU8[($2 + 272 | 0) >> 0] | 0;
           i64toi32_i32$3 = $2;
           i64toi32_i32$1 = HEAP32[($2 + 280 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($2 + 284 | 0) >> 2] | 0;
           $15 = i64toi32_i32$1;
           $15$hi = i64toi32_i32$2;
           i64toi32_i32$3 = $2;
           i64toi32_i32$2 = HEAP32[($2 + 288 | 0) >> 2] | 0;
           i64toi32_i32$1 = HEAP32[($2 + 292 | 0) >> 2] | 0;
           $14 = i64toi32_i32$2;
           $14$hi = i64toi32_i32$1;
           $74 = HEAPU8[($2 + 219 | 0) >> 0] | 0 | ((HEAPU8[($2 + 220 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 221 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 222 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 195 | 0) >> 0] = $74;
           HEAP8[($2 + 196 | 0) >> 0] = $74 >>> 8 | 0;
           HEAP8[($2 + 197 | 0) >> 0] = $74 >>> 16 | 0;
           HEAP8[($2 + 198 | 0) >> 0] = $74 >>> 24 | 0;
           HEAP32[($2 + 192 | 0) >> 2] = HEAP32[($2 + 216 | 0) >> 2] | 0;
           break label$8;
          }
          i64toi32_i32$3 = $2 + 304 | 0;
          i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
          i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
          $259 = i64toi32_i32$1;
          i64toi32_i32$1 = ($2 + 168 | 0) + 8 | 0;
          HEAP32[i64toi32_i32$1 >> 2] = $259;
          HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
          i64toi32_i32$3 = $2 + 312 | 0;
          i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
          $265 = i64toi32_i32$2;
          i64toi32_i32$2 = ($2 + 168 | 0) + 16 | 0;
          HEAP32[i64toi32_i32$2 >> 2] = $265;
          HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
          HEAP32[(($2 + 152 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 332 | 0) >> 2] | 0;
          HEAP32[($2 + 216 | 0) >> 2] = HEAPU8[$7 >> 0] | 0 | ((HEAPU8[($7 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($7 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($7 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          $75 = $7 + 3 | 0;
          $76 = HEAPU8[$75 >> 0] | 0 | ((HEAPU8[($75 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($75 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($75 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          HEAP8[($2 + 219 | 0) >> 0] = $76;
          HEAP8[($2 + 220 | 0) >> 0] = $76 >>> 8 | 0;
          HEAP8[($2 + 221 | 0) >> 0] = $76 >>> 16 | 0;
          HEAP8[($2 + 222 | 0) >> 0] = $76 >>> 24 | 0;
          i64toi32_i32$3 = $2 + 296 | 0;
          i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
          i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
          $282 = i64toi32_i32$1;
          i64toi32_i32$1 = $2;
          HEAP32[($2 + 168 | 0) >> 2] = $282;
          HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$2;
          i64toi32_i32$3 = $2 + 324 | 0;
          i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
          $286 = i64toi32_i32$2;
          i64toi32_i32$2 = $2;
          HEAP32[($2 + 152 | 0) >> 2] = $286;
          HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$1;
          i64toi32_i32$3 = ($2 + 264 | 0) + 16 | 0;
          i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
          i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
          $15 = i64toi32_i32$1;
          $15$hi = i64toi32_i32$2;
          i64toi32_i32$3 = $2 + 288 | 0;
          i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
          $14 = i64toi32_i32$2;
          $14$hi = i64toi32_i32$1;
          $11 = HEAP32[($2 + 320 | 0) >> 2] | 0;
          $12 = HEAPU8[($2 + 272 | 0) >> 0] | 0;
          $77 = HEAPU8[($2 + 219 | 0) >> 0] | 0 | ((HEAPU8[($2 + 220 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 221 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 222 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          HEAP8[($2 + 195 | 0) >> 0] = $77;
          HEAP8[($2 + 196 | 0) >> 0] = $77 >>> 8 | 0;
          HEAP8[($2 + 197 | 0) >> 0] = $77 >>> 16 | 0;
          HEAP8[($2 + 198 | 0) >> 0] = $77 >>> 24 | 0;
          HEAP32[($2 + 192 | 0) >> 2] = HEAP32[($2 + 216 | 0) >> 2] | 0;
          break label$8;
         }
         alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($2 + 276 | 0 | 0, 1051628 | 0, 33 | 0);
         $11 = 0;
         $1 = ($2 + 264 | 0) + 8 | 0;
         HEAP32[$1 >> 2] = 0;
         i64toi32_i32$3 = $2 + 296 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $316 = i64toi32_i32$1;
         i64toi32_i32$1 = ($2 + 168 | 0) + 8 | 0;
         HEAP32[i64toi32_i32$1 >> 2] = $316;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
         i64toi32_i32$3 = $2 + 304 | 0;
         i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $322 = i64toi32_i32$2;
         i64toi32_i32$2 = ($2 + 168 | 0) + 16 | 0;
         HEAP32[i64toi32_i32$2 >> 2] = $322;
         HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
         HEAP32[($2 + 192 | 0) >> 2] = HEAPU8[($2 + 265 | 0) >> 0] | 0 | ((HEAPU8[($2 + 266 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 267 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 268 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $78 = HEAPU8[($2 + 268 | 0) >> 0] | 0 | ((HEAPU8[($2 + 269 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 270 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 271 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[($2 + 195 | 0) >> 0] = $78;
         HEAP8[($2 + 196 | 0) >> 0] = $78 >>> 8 | 0;
         HEAP8[($2 + 197 | 0) >> 0] = $78 >>> 16 | 0;
         HEAP8[($2 + 198 | 0) >> 0] = $78 >>> 24 | 0;
         i64toi32_i32$3 = $2 + 288 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $332 = i64toi32_i32$1;
         i64toi32_i32$1 = $2;
         HEAP32[($2 + 168 | 0) >> 2] = $332;
         HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$2;
         i64toi32_i32$3 = ($2 + 264 | 0) + 16 | 0;
         i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $14 = i64toi32_i32$2;
         $14$hi = i64toi32_i32$1;
         i64toi32_i32$3 = $1;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $15 = i64toi32_i32$1;
         $15$hi = i64toi32_i32$2;
         $12 = 4;
        }
        if (($12 & 255 | 0 | 0) != (19 | 0)) {
         break label$4
        }
        break label$3;
       }
       i64toi32_i32$3 = $2 + 296 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $346 = i64toi32_i32$2;
       i64toi32_i32$2 = $2 + 176 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $346;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$3 = $2 + 304 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $352 = i64toi32_i32$1;
       i64toi32_i32$1 = ($2 + 168 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $352;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$3 = $2 + 288 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $356 = i64toi32_i32$2;
       i64toi32_i32$2 = $2;
       HEAP32[($2 + 168 | 0) >> 2] = $356;
       HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$1;
       $11 = 0;
       $12 = 2;
       break label$4;
      }
      i64toi32_i32$3 = $2 + 296 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $361 = i64toi32_i32$1;
      i64toi32_i32$1 = $2 + 176 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $361;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$3 = $2 + 304 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $367 = i64toi32_i32$2;
      i64toi32_i32$2 = ($2 + 168 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $367;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$3 = $2 + 288 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $371 = i64toi32_i32$1;
      i64toi32_i32$1 = $2;
      HEAP32[($2 + 168 | 0) >> 2] = $371;
      HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$2;
     }
     i64toi32_i32$2 = $14$hi;
     i64toi32_i32$1 = ($2 + 264 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $14;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$2 = $15$hi;
     i64toi32_i32$1 = ($2 + 264 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $15;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$3 = $2;
     i64toi32_i32$2 = HEAP32[($2 + 168 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 172 | 0) >> 2] | 0;
     $383 = i64toi32_i32$2;
     i64toi32_i32$2 = $2 + 288 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $383;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$3 = $2;
     i64toi32_i32$1 = HEAP32[($2 + 152 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[($2 + 156 | 0) >> 2] | 0;
     $387 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 316 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $387;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$3 = ($2 + 168 | 0) + 8 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $393 = i64toi32_i32$2;
     i64toi32_i32$2 = $2 + 296 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $393;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$3 = ($2 + 168 | 0) + 16 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $399 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 304 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $399;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
     HEAP32[($2 + 324 | 0) >> 2] = HEAP32[(($2 + 152 | 0) + 8 | 0) >> 2] | 0;
     HEAP8[($2 + 264 | 0) >> 0] = $12;
     $79 = HEAP32[($2 + 192 | 0) >> 2] | 0;
     HEAP8[($2 + 265 | 0) >> 0] = $79;
     HEAP8[($2 + 266 | 0) >> 0] = $79 >>> 8 | 0;
     HEAP8[($2 + 267 | 0) >> 0] = $79 >>> 16 | 0;
     HEAP8[($2 + 268 | 0) >> 0] = $79 >>> 24 | 0;
     $80 = HEAPU8[($2 + 195 | 0) >> 0] | 0 | ((HEAPU8[($2 + 196 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 197 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 198 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($2 + 268 | 0) >> 0] = $80;
     HEAP8[($2 + 269 | 0) >> 0] = $80 >>> 8 | 0;
     HEAP8[($2 + 270 | 0) >> 0] = $80 >>> 16 | 0;
     HEAP8[($2 + 271 | 0) >> 0] = $80 >>> 24 | 0;
     HEAP32[($2 + 312 | 0) >> 2] = $11;
     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($2 + 88 | 0 | 0, $2 + 264 | 0 | 0, 1053104 | 0, 4 | 0);
     $7 = HEAPU8[($2 + 88 | 0) >> 0] | 0;
     if (($7 | 0) != (19 | 0)) {
      break label$2
     }
    }
    i64toi32_i32$3 = $2;
    i64toi32_i32$2 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $426 = i64toi32_i32$2;
    i64toi32_i32$2 = $0;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = $426;
    HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
    $1 = 0;
    break label$1;
   }
   $1 = 1;
   memcpy($2 + 25 | 0 | 0, $2 + 88 | 0 | 1 | 0 | 0, 63 | 0) | 0;
   HEAP8[($0 + 8 | 0) >> 0] = $7;
   memcpy($0 + 9 | 0 | 0, $2 + 25 | 0 | 0, 63 | 0) | 0;
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h3981a4152bf24dd0($2 + 8 | 0 | 0);
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 336 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__MultiAsset___deserialize__h0ad8d9aa7509b889($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, $7 = 0, $12 = 0, $14 = 0, $14$hi = 0, i64toi32_i32$4 = 0, $15 = 0, $15$hi = 0, $11 = 0, $54 = 0, $55 = 0, $56 = 0, $57 = 0, $58 = 0, $59 = 0, $60 = 0, $61 = 0, $62 = 0, $63 = 0, $64 = 0, $65 = 0, $66 = 0, $67 = 0, $68 = 0, $69 = 0, $70 = 0, $71 = 0, $72 = 0, $73 = 0, $74 = 0, $75 = 0, $76 = 0, $77 = 0, $78 = 0, $79 = 0, $80 = 0, $3 = 0, $81 = 0, $82 = 0, $4 = 0, $5 = 0, $6 = 0, $8 = 0, $9 = 0, $10 = 0, $16 = 0, $16$hi = 0, $17 = 0, $17$hi = 0, $13 = 0, $124 = 0, $125 = 0, $125$hi = 0, $127$hi = 0, $130 = 0, $212 = 0, $217 = 0, $234 = 0, $238 = 0, $259 = 0, $265 = 0, $282 = 0, $286 = 0, $316 = 0, $322 = 0, $332 = 0, $346 = 0, $352 = 0, $356 = 0, $361 = 0, $367 = 0, $371 = 0, $383 = 0, $387 = 0, $393 = 0, $399 = 0, $426 = 0;
  $2 = global$0 - 336 | 0;
  global$0 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 12 | 0) >> 2] = 0;
  HEAP32[($2 + 16 | 0) >> 2] = i64toi32_i32$0;
  cbor_event__de__Deserializer_R___map__h7c2a4e830d885a05($2 + 264 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = ($2 + 264 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  $14$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 272 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 276 | 0) >> 2] | 0;
  $15 = i64toi32_i32$1;
  $15$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 264 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 268 | 0) >> 2] | 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
         break label$6
        }
        i64toi32_i32$2 = $14$hi;
        $3 = $14;
        label$7 : {
         i64toi32_i32$2 = $15$hi;
         i64toi32_i32$3 = $15;
         i64toi32_i32$1 = 0;
         i64toi32_i32$0 = 1;
         if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
          break label$7
         }
         if (!$3) {
          break label$3
         }
        }
        $4 = $2 + 216 | 0 | 4 | 0;
        $5 = $2 + 200 | 0 | 5 | 0;
        $6 = $2 + 272 | 0;
        $7 = $2 + 273 | 0;
        $8 = $2 + 264 | 0 | 1 | 0;
        $9 = $2 + 292 | 0;
        $10 = $2 + 291 | 0;
        label$8 : {
         label$9 : {
          label$10 : {
           label$11 : {
            label$12 : while (1) {
             std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 | 0, $1 | 0);
             $11 = 0;
             $12 = 2;
             label$13 : {
              if (HEAP32[($2 + 4 | 0) >> 2] | 0) {
               break label$13
              }
              i64toi32_i32$3 = 0;
              $15 = 8;
              $15$hi = i64toi32_i32$3;
              i64toi32_i32$3 = 0;
              $14 = 0;
              $14$hi = i64toi32_i32$3;
              break label$4;
             }
             label$14 : {
              if ((($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[$2 >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) == (7 | 0)) {
               break label$14
              }
              $cardano_serialization_lib__crypto__ScriptHash_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h589000d40634e72d($2 + 264 | 0 | 0, $1 | 0);
              if ((HEAPU8[($2 + 264 | 0) >> 0] | 0 | 0) == (1 | 0)) {
               break label$11
              }
              HEAP32[($2 + 216 | 0) >> 2] = HEAPU8[$7 >> 0] | 0 | ((HEAPU8[($7 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($7 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($7 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              $12 = $7 + 3 | 0;
              $57 = HEAPU8[$12 >> 0] | 0 | ((HEAPU8[($12 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($12 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($12 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              HEAP8[($2 + 219 | 0) >> 0] = $57;
              HEAP8[($2 + 220 | 0) >> 0] = $57 >>> 8 | 0;
              HEAP8[($2 + 221 | 0) >> 0] = $57 >>> 16 | 0;
              HEAP8[($2 + 222 | 0) >> 0] = $57 >>> 24 | 0;
              $54 = $8;
              HEAP32[($2 + 248 | 0) >> 2] = HEAPU8[$54 >> 0] | 0 | ((HEAPU8[($54 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($54 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($54 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              $58 = $54 + 3 | 0;
              $59 = HEAPU8[$58 >> 0] | 0 | ((HEAPU8[($58 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($58 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($58 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              HEAP8[($2 + 251 | 0) >> 0] = $59;
              HEAP8[($2 + 252 | 0) >> 0] = $59 >>> 8 | 0;
              HEAP8[($2 + 253 | 0) >> 0] = $59 >>> 16 | 0;
              HEAP8[($2 + 254 | 0) >> 0] = $59 >>> 24 | 0;
              HEAP32[($2 + 240 | 0) >> 2] = HEAP32[($2 + 216 | 0) >> 2] | 0;
              $60 = HEAPU8[($2 + 219 | 0) >> 0] | 0 | ((HEAPU8[($2 + 220 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 221 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 222 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              HEAP8[($2 + 243 | 0) >> 0] = $60;
              HEAP8[($2 + 244 | 0) >> 0] = $60 >>> 8 | 0;
              HEAP8[($2 + 245 | 0) >> 0] = $60 >>> 16 | 0;
              HEAP8[($2 + 246 | 0) >> 0] = $60 >>> 24 | 0;
              i64toi32_i32$0 = $9;
              i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0;
              i64toi32_i32$2 = 0;
              $14 = i64toi32_i32$3;
              $14$hi = i64toi32_i32$2;
              $11 = HEAPU8[($2 + 272 | 0) >> 0] | 0;
              i64toi32_i32$0 = $2;
              i64toi32_i32$2 = HEAP32[($2 + 280 | 0) >> 2] | 0;
              i64toi32_i32$3 = HEAP32[($2 + 284 | 0) >> 2] | 0;
              $16 = i64toi32_i32$2;
              $16$hi = i64toi32_i32$3;
              i64toi32_i32$0 = $2;
              i64toi32_i32$3 = HEAP32[($2 + 288 | 0) >> 2] | 0;
              i64toi32_i32$2 = 0;
              $17 = i64toi32_i32$3;
              $17$hi = i64toi32_i32$2;
              cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__Assets___deserialize__h1d5e068ce9d78042($2 + 264 | 0 | 0, $1 | 0);
              if ((HEAP32[($2 + 264 | 0) >> 2] | 0 | 0) == (1 | 0)) {
               break label$10
              }
              HEAP32[($2 + 216 | 0) >> 2] = HEAPU8[$7 >> 0] | 0 | ((HEAPU8[($7 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($7 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($7 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              $61 = HEAPU8[$12 >> 0] | 0 | ((HEAPU8[($12 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($12 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($12 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              HEAP8[($2 + 219 | 0) >> 0] = $61;
              HEAP8[($2 + 220 | 0) >> 0] = $61 >>> 8 | 0;
              HEAP8[($2 + 221 | 0) >> 0] = $61 >>> 16 | 0;
              HEAP8[($2 + 222 | 0) >> 0] = $61 >>> 24 | 0;
              HEAP32[($2 + 256 | 0) >> 2] = HEAP32[($2 + 216 | 0) >> 2] | 0;
              $62 = HEAPU8[($2 + 219 | 0) >> 0] | 0 | ((HEAPU8[($2 + 220 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 221 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 222 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              HEAP8[($2 + 259 | 0) >> 0] = $62;
              HEAP8[($2 + 260 | 0) >> 0] = $62 >>> 8 | 0;
              HEAP8[($2 + 261 | 0) >> 0] = $62 >>> 16 | 0;
              HEAP8[($2 + 262 | 0) >> 0] = $62 >>> 24 | 0;
              $12 = HEAP32[($2 + 268 | 0) >> 2] | 0;
              $13 = HEAPU8[($2 + 272 | 0) >> 0] | 0;
              $124 = $2;
              i64toi32_i32$2 = $17$hi;
              $125 = $17;
              $125$hi = i64toi32_i32$2;
              i64toi32_i32$2 = $14$hi;
              i64toi32_i32$0 = $14;
              i64toi32_i32$3 = 0;
              i64toi32_i32$1 = 32;
              i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
              if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
               i64toi32_i32$3 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
               $81 = 0;
              } else {
               i64toi32_i32$3 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
               $81 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
              }
              $127$hi = i64toi32_i32$3;
              i64toi32_i32$3 = $125$hi;
              i64toi32_i32$2 = $125;
              i64toi32_i32$0 = $127$hi;
              i64toi32_i32$1 = $81;
              i64toi32_i32$0 = i64toi32_i32$3 | i64toi32_i32$0 | 0;
              $14 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
              $14$hi = i64toi32_i32$0;
              $63 = $124;
              HEAP8[($63 + 287 | 0) >> 0] = $14;
              HEAP8[($63 + 288 | 0) >> 0] = $14 >>> 8 | 0;
              HEAP8[($63 + 289 | 0) >> 0] = $14 >>> 16 | 0;
              HEAP8[($63 + 290 | 0) >> 0] = $14 >>> 24 | 0;
              $130 = $10;
              i64toi32_i32$3 = $14;
              i64toi32_i32$2 = 0;
              i64toi32_i32$1 = 32;
              i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
              if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
               i64toi32_i32$2 = 0;
               $82 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
              } else {
               i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
               $82 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$4 | 0) | 0;
              }
              HEAP8[$130 >> 0] = $82;
              $64 = HEAPU8[($2 + 251 | 0) >> 0] | 0 | ((HEAPU8[($2 + 252 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 253 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 254 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              HEAP8[($2 + 267 | 0) >> 0] = $64;
              HEAP8[($2 + 268 | 0) >> 0] = $64 >>> 8 | 0;
              HEAP8[($2 + 269 | 0) >> 0] = $64 >>> 16 | 0;
              HEAP8[($2 + 270 | 0) >> 0] = $64 >>> 24 | 0;
              HEAP32[($2 + 264 | 0) >> 2] = HEAP32[($2 + 248 | 0) >> 2] | 0;
              HEAP8[($2 + 271 | 0) >> 0] = $11;
              $55 = $6;
              $65 = HEAP32[($2 + 240 | 0) >> 2] | 0;
              HEAP8[$55 >> 0] = $65;
              HEAP8[($55 + 1 | 0) >> 0] = $65 >>> 8 | 0;
              HEAP8[($55 + 2 | 0) >> 0] = $65 >>> 16 | 0;
              HEAP8[($55 + 3 | 0) >> 0] = $65 >>> 24 | 0;
              $66 = $55 + 3 | 0;
              $67 = HEAPU8[($2 + 243 | 0) >> 0] | 0 | ((HEAPU8[($2 + 244 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 245 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 246 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              HEAP8[$66 >> 0] = $67;
              HEAP8[($66 + 1 | 0) >> 0] = $67 >>> 8 | 0;
              HEAP8[($66 + 2 | 0) >> 0] = $67 >>> 16 | 0;
              HEAP8[($66 + 3 | 0) >> 0] = $67 >>> 24 | 0;
              i64toi32_i32$2 = $16$hi;
              i64toi32_i32$3 = $2;
              $68 = $16;
              HEAP8[($2 + 279 | 0) >> 0] = $68;
              HEAP8[($2 + 280 | 0) >> 0] = $68 >>> 8 | 0;
              HEAP8[($2 + 281 | 0) >> 0] = $68 >>> 16 | 0;
              HEAP8[($2 + 282 | 0) >> 0] = $68 >>> 24 | 0;
              HEAP8[($2 + 283 | 0) >> 0] = i64toi32_i32$2;
              HEAP8[($2 + 284 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
              HEAP8[($2 + 285 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
              HEAP8[($2 + 286 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
              HEAP8[($2 + 204 | 0) >> 0] = $13;
              HEAP32[($2 + 200 | 0) >> 2] = $12;
              $56 = $5;
              $69 = HEAP32[($2 + 256 | 0) >> 2] | 0;
              HEAP8[$56 >> 0] = $69;
              HEAP8[($56 + 1 | 0) >> 0] = $69 >>> 8 | 0;
              HEAP8[($56 + 2 | 0) >> 0] = $69 >>> 16 | 0;
              HEAP8[($56 + 3 | 0) >> 0] = $69 >>> 24 | 0;
              $70 = $56 + 3 | 0;
              $71 = HEAPU8[($2 + 259 | 0) >> 0] | 0 | ((HEAPU8[($2 + 260 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 261 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 262 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
              HEAP8[$70 >> 0] = $71;
              HEAP8[($70 + 1 | 0) >> 0] = $71 >>> 8 | 0;
              HEAP8[($70 + 2 | 0) >> 0] = $71 >>> 16 | 0;
              HEAP8[($70 + 3 | 0) >> 0] = $71 >>> 24 | 0;
              alloc__collections__btree__map__BTreeMap_K_2cV___insert__ha211f93f5765e42b($2 + 216 | 0 | 0, $2 + 8 | 0 | 0, $2 + 264 | 0 | 0, $2 + 200 | 0 | 0);
              label$15 : {
               $12 = HEAP32[($2 + 216 | 0) >> 2] | 0;
               if (!$12) {
                break label$15
               }
               $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h6c9f94f0f82ce2b5($4 | 0);
              }
              if ($12) {
               break label$9
              }
              i64toi32_i32$2 = $15$hi;
              i64toi32_i32$0 = $15;
              i64toi32_i32$3 = 0;
              i64toi32_i32$1 = 1;
              if ((i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | 0) {
               continue label$12
              }
              if ((HEAP32[($2 + 16 | 0) >> 2] | 0) >>> 0 < $3 >>> 0) {
               continue label$12
              }
              break label$3;
             }
             break label$12;
            };
            cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 264 | 0 | 0, $1 | 0);
            i64toi32_i32$1 = ($2 + 264 | 0) + 16 | 0;
            i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
            i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
            $14 = i64toi32_i32$0;
            $14$hi = i64toi32_i32$2;
            i64toi32_i32$1 = $2;
            i64toi32_i32$2 = HEAP32[($2 + 272 | 0) >> 2] | 0;
            i64toi32_i32$0 = HEAP32[($2 + 276 | 0) >> 2] | 0;
            $15 = i64toi32_i32$2;
            $15$hi = i64toi32_i32$0;
            i64toi32_i32$1 = $2;
            i64toi32_i32$0 = HEAP32[($2 + 264 | 0) >> 2] | 0;
            i64toi32_i32$2 = HEAP32[($2 + 268 | 0) >> 2] | 0;
            i64toi32_i32$1 = i64toi32_i32$0;
            i64toi32_i32$0 = 0;
            i64toi32_i32$3 = 1;
            if ((i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) | 0) {
             break label$5
            }
            i64toi32_i32$1 = $14$hi;
            i64toi32_i32$2 = $2 + 208 | 0;
            HEAP32[i64toi32_i32$2 >> 2] = $14;
            HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
            i64toi32_i32$1 = $15$hi;
            i64toi32_i32$2 = $2;
            HEAP32[($2 + 200 | 0) >> 2] = $15;
            HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$1;
            if (($15 & 255 | 0 | 0) == (5 | 0)) {
             break label$3
            }
            HEAP32[($2 + 264 | 0) >> 2] = 0;
            core__panicking__assert_failed__h96d8431cc974b591(0 | 0, $2 + 200 | 0 | 0, 1050312 | 0, $2 + 264 | 0 | 0, 1053032 | 0);
            abort();
           }
           i64toi32_i32$3 = $2 + 304 | 0;
           i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
           $212 = i64toi32_i32$1;
           i64toi32_i32$1 = ($2 + 168 | 0) + 8 | 0;
           HEAP32[i64toi32_i32$1 >> 2] = $212;
           HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
           i64toi32_i32$3 = $2 + 312 | 0;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
           $217 = i64toi32_i32$2;
           i64toi32_i32$2 = $2 + 184 | 0;
           HEAP32[i64toi32_i32$2 >> 2] = $217;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
           HEAP32[(($2 + 152 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 332 | 0) >> 2] | 0;
           HEAP32[($2 + 216 | 0) >> 2] = HEAPU8[$7 >> 0] | 0 | ((HEAPU8[($7 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($7 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($7 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $72 = $7 + 3 | 0;
           $73 = HEAPU8[$72 >> 0] | 0 | ((HEAPU8[($72 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($72 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($72 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 219 | 0) >> 0] = $73;
           HEAP8[($2 + 220 | 0) >> 0] = $73 >>> 8 | 0;
           HEAP8[($2 + 221 | 0) >> 0] = $73 >>> 16 | 0;
           HEAP8[($2 + 222 | 0) >> 0] = $73 >>> 24 | 0;
           i64toi32_i32$3 = $2 + 296 | 0;
           i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
           $234 = i64toi32_i32$1;
           i64toi32_i32$1 = $2;
           HEAP32[($2 + 168 | 0) >> 2] = $234;
           HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$2;
           i64toi32_i32$3 = $2 + 324 | 0;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
           $238 = i64toi32_i32$2;
           i64toi32_i32$2 = $2;
           HEAP32[($2 + 152 | 0) >> 2] = $238;
           HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$1;
           $11 = HEAP32[($2 + 320 | 0) >> 2] | 0;
           $12 = HEAPU8[($2 + 272 | 0) >> 0] | 0;
           i64toi32_i32$3 = $2;
           i64toi32_i32$1 = HEAP32[($2 + 280 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($2 + 284 | 0) >> 2] | 0;
           $15 = i64toi32_i32$1;
           $15$hi = i64toi32_i32$2;
           i64toi32_i32$3 = $2;
           i64toi32_i32$2 = HEAP32[($2 + 288 | 0) >> 2] | 0;
           i64toi32_i32$1 = HEAP32[($2 + 292 | 0) >> 2] | 0;
           $14 = i64toi32_i32$2;
           $14$hi = i64toi32_i32$1;
           $74 = HEAPU8[($2 + 219 | 0) >> 0] | 0 | ((HEAPU8[($2 + 220 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 221 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 222 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 195 | 0) >> 0] = $74;
           HEAP8[($2 + 196 | 0) >> 0] = $74 >>> 8 | 0;
           HEAP8[($2 + 197 | 0) >> 0] = $74 >>> 16 | 0;
           HEAP8[($2 + 198 | 0) >> 0] = $74 >>> 24 | 0;
           HEAP32[($2 + 192 | 0) >> 2] = HEAP32[($2 + 216 | 0) >> 2] | 0;
           break label$8;
          }
          i64toi32_i32$3 = $2 + 304 | 0;
          i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
          i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
          $259 = i64toi32_i32$1;
          i64toi32_i32$1 = ($2 + 168 | 0) + 8 | 0;
          HEAP32[i64toi32_i32$1 >> 2] = $259;
          HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
          i64toi32_i32$3 = $2 + 312 | 0;
          i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
          $265 = i64toi32_i32$2;
          i64toi32_i32$2 = ($2 + 168 | 0) + 16 | 0;
          HEAP32[i64toi32_i32$2 >> 2] = $265;
          HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
          HEAP32[(($2 + 152 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 332 | 0) >> 2] | 0;
          HEAP32[($2 + 216 | 0) >> 2] = HEAPU8[$7 >> 0] | 0 | ((HEAPU8[($7 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($7 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($7 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          $75 = $7 + 3 | 0;
          $76 = HEAPU8[$75 >> 0] | 0 | ((HEAPU8[($75 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($75 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($75 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          HEAP8[($2 + 219 | 0) >> 0] = $76;
          HEAP8[($2 + 220 | 0) >> 0] = $76 >>> 8 | 0;
          HEAP8[($2 + 221 | 0) >> 0] = $76 >>> 16 | 0;
          HEAP8[($2 + 222 | 0) >> 0] = $76 >>> 24 | 0;
          i64toi32_i32$3 = $2 + 296 | 0;
          i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
          i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
          $282 = i64toi32_i32$1;
          i64toi32_i32$1 = $2;
          HEAP32[($2 + 168 | 0) >> 2] = $282;
          HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$2;
          i64toi32_i32$3 = $2 + 324 | 0;
          i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
          $286 = i64toi32_i32$2;
          i64toi32_i32$2 = $2;
          HEAP32[($2 + 152 | 0) >> 2] = $286;
          HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$1;
          i64toi32_i32$3 = ($2 + 264 | 0) + 16 | 0;
          i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
          i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
          $15 = i64toi32_i32$1;
          $15$hi = i64toi32_i32$2;
          i64toi32_i32$3 = $2 + 288 | 0;
          i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
          $14 = i64toi32_i32$2;
          $14$hi = i64toi32_i32$1;
          $11 = HEAP32[($2 + 320 | 0) >> 2] | 0;
          $12 = HEAPU8[($2 + 272 | 0) >> 0] | 0;
          $77 = HEAPU8[($2 + 219 | 0) >> 0] | 0 | ((HEAPU8[($2 + 220 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 221 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 222 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          HEAP8[($2 + 195 | 0) >> 0] = $77;
          HEAP8[($2 + 196 | 0) >> 0] = $77 >>> 8 | 0;
          HEAP8[($2 + 197 | 0) >> 0] = $77 >>> 16 | 0;
          HEAP8[($2 + 198 | 0) >> 0] = $77 >>> 24 | 0;
          HEAP32[($2 + 192 | 0) >> 2] = HEAP32[($2 + 216 | 0) >> 2] | 0;
          break label$8;
         }
         alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($2 + 276 | 0 | 0, 1051628 | 0, 33 | 0);
         $11 = 0;
         $1 = ($2 + 264 | 0) + 8 | 0;
         HEAP32[$1 >> 2] = 0;
         i64toi32_i32$3 = $2 + 296 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $316 = i64toi32_i32$1;
         i64toi32_i32$1 = ($2 + 168 | 0) + 8 | 0;
         HEAP32[i64toi32_i32$1 >> 2] = $316;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
         i64toi32_i32$3 = $2 + 304 | 0;
         i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $322 = i64toi32_i32$2;
         i64toi32_i32$2 = ($2 + 168 | 0) + 16 | 0;
         HEAP32[i64toi32_i32$2 >> 2] = $322;
         HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
         HEAP32[($2 + 192 | 0) >> 2] = HEAPU8[($2 + 265 | 0) >> 0] | 0 | ((HEAPU8[($2 + 266 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 267 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 268 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $78 = HEAPU8[($2 + 268 | 0) >> 0] | 0 | ((HEAPU8[($2 + 269 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 270 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 271 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[($2 + 195 | 0) >> 0] = $78;
         HEAP8[($2 + 196 | 0) >> 0] = $78 >>> 8 | 0;
         HEAP8[($2 + 197 | 0) >> 0] = $78 >>> 16 | 0;
         HEAP8[($2 + 198 | 0) >> 0] = $78 >>> 24 | 0;
         i64toi32_i32$3 = $2 + 288 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $332 = i64toi32_i32$1;
         i64toi32_i32$1 = $2;
         HEAP32[($2 + 168 | 0) >> 2] = $332;
         HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$2;
         i64toi32_i32$3 = ($2 + 264 | 0) + 16 | 0;
         i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $14 = i64toi32_i32$2;
         $14$hi = i64toi32_i32$1;
         i64toi32_i32$3 = $1;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $15 = i64toi32_i32$1;
         $15$hi = i64toi32_i32$2;
         $12 = 4;
        }
        if (($12 & 255 | 0 | 0) != (19 | 0)) {
         break label$4
        }
        break label$3;
       }
       i64toi32_i32$3 = $2 + 296 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $346 = i64toi32_i32$2;
       i64toi32_i32$2 = $2 + 176 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $346;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$3 = $2 + 304 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $352 = i64toi32_i32$1;
       i64toi32_i32$1 = ($2 + 168 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $352;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$3 = $2 + 288 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $356 = i64toi32_i32$2;
       i64toi32_i32$2 = $2;
       HEAP32[($2 + 168 | 0) >> 2] = $356;
       HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$1;
       $11 = 0;
       $12 = 2;
       break label$4;
      }
      i64toi32_i32$3 = $2 + 296 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $361 = i64toi32_i32$1;
      i64toi32_i32$1 = $2 + 176 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $361;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$3 = $2 + 304 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $367 = i64toi32_i32$2;
      i64toi32_i32$2 = ($2 + 168 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $367;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$3 = $2 + 288 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $371 = i64toi32_i32$1;
      i64toi32_i32$1 = $2;
      HEAP32[($2 + 168 | 0) >> 2] = $371;
      HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$2;
     }
     i64toi32_i32$2 = $14$hi;
     i64toi32_i32$1 = ($2 + 264 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $14;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$2 = $15$hi;
     i64toi32_i32$1 = ($2 + 264 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $15;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$3 = $2;
     i64toi32_i32$2 = HEAP32[($2 + 168 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 172 | 0) >> 2] | 0;
     $383 = i64toi32_i32$2;
     i64toi32_i32$2 = $2 + 288 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $383;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$3 = $2;
     i64toi32_i32$1 = HEAP32[($2 + 152 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[($2 + 156 | 0) >> 2] | 0;
     $387 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 316 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $387;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$3 = ($2 + 168 | 0) + 8 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $393 = i64toi32_i32$2;
     i64toi32_i32$2 = $2 + 296 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $393;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$3 = ($2 + 168 | 0) + 16 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $399 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 304 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $399;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
     HEAP32[($2 + 324 | 0) >> 2] = HEAP32[(($2 + 152 | 0) + 8 | 0) >> 2] | 0;
     HEAP8[($2 + 264 | 0) >> 0] = $12;
     $79 = HEAP32[($2 + 192 | 0) >> 2] | 0;
     HEAP8[($2 + 265 | 0) >> 0] = $79;
     HEAP8[($2 + 266 | 0) >> 0] = $79 >>> 8 | 0;
     HEAP8[($2 + 267 | 0) >> 0] = $79 >>> 16 | 0;
     HEAP8[($2 + 268 | 0) >> 0] = $79 >>> 24 | 0;
     $80 = HEAPU8[($2 + 195 | 0) >> 0] | 0 | ((HEAPU8[($2 + 196 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 197 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 198 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($2 + 268 | 0) >> 0] = $80;
     HEAP8[($2 + 269 | 0) >> 0] = $80 >>> 8 | 0;
     HEAP8[($2 + 270 | 0) >> 0] = $80 >>> 16 | 0;
     HEAP8[($2 + 271 | 0) >> 0] = $80 >>> 24 | 0;
     HEAP32[($2 + 312 | 0) >> 2] = $11;
     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($2 + 88 | 0 | 0, $2 + 264 | 0 | 0, 1053048 | 0, 10 | 0);
     $7 = HEAPU8[($2 + 88 | 0) >> 0] | 0;
     if (($7 | 0) != (19 | 0)) {
      break label$2
     }
    }
    i64toi32_i32$3 = $2;
    i64toi32_i32$2 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $426 = i64toi32_i32$2;
    i64toi32_i32$2 = $0;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = $426;
    HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
    $1 = 0;
    break label$1;
   }
   $1 = 1;
   memcpy($2 + 25 | 0 | 0, $2 + 88 | 0 | 1 | 0 | 0, 63 | 0) | 0;
   HEAP8[($0 + 8 | 0) >> 0] = $7;
   memcpy($0 + 9 | 0 | 0, $2 + 25 | 0 | 0, 63 | 0) | 0;
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 8 | 0 | 0);
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 336 | 0;
 }
 
 function $cardano_serialization_lib__metadata__GeneralTransactionMetadata_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h2cbfe28ae9769528($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, $12 = 0, $14 = 0, $12$hi = 0, $13 = 0, $13$hi = 0, $4 = 0, $14$hi = 0, $3 = 0, $72 = 0, $73 = 0, $74 = 0, $6 = 0, $7 = 0, $15 = 0, $15$hi = 0, $5 = 0, $10 = 0, $75 = 0, $76 = 0, $16 = 0, $16$hi = 0, $11 = 0, $77 = 0, $78 = 0, $79 = 0, $80 = 0, $81 = 0, $82 = 0, $83 = 0, $84 = 0, $85 = 0, $86 = 0, $87 = 0, $8 = 0, $9 = 0, $93 = 0, $100 = 0, $103 = 0, $105 = 0, $105$hi = 0, $107 = 0, $107$hi = 0, $110$hi = 0, $112$hi = 0, $128 = 0, $134 = 0, $137 = 0, $146 = 0, $149 = 0, $154 = 0, $158 = 0, $162 = 0, $210 = 0, $216 = 0, $225 = 0, $229 = 0, $256 = 0, $263 = 0, $266 = 0, $290 = 0, $296 = 0, $300 = 0, $302 = 0, $302$hi = 0, $304 = 0, $304$hi = 0, $307$hi = 0, $309$hi = 0, $324 = 0, $330 = 0, $335 = 0, $340 = 0, $346 = 0, $350 = 0, $362 = 0, $366 = 0, $372 = 0, $378 = 0, $391 = 0, $394 = 0;
  $2 = global$0 - 432 | 0;
  global$0 = $2;
  std__thread__local__LocalKey_T___with__h4cd07b14a44a727e($2 + 16 | 0 | 0, 1060968 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $12 = i64toi32_i32$0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $13 = i64toi32_i32$1;
  $13$hi = i64toi32_i32$0;
  $3 = hashbrown__raw__generic__Group__static_empty__hc5a7932fe1bdb1f1() | 0;
  i64toi32_i32$1 = ($2 + 32 | 0) + 24 | 0;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 52 | 0) >> 2] = $3;
  $4 = 0;
  HEAP32[($2 + 48 | 0) >> 2] = 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $13$hi;
  HEAP32[(i64toi32_i32$1 + 40 | 0) >> 2] = $13;
  HEAP32[(i64toi32_i32$1 + 44 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $12$hi;
  HEAP32[(i64toi32_i32$1 + 32 | 0) >> 2] = $12;
  HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] = i64toi32_i32$0;
  cbor_event__de__Deserializer_R___map__h7c2a4e830d885a05(i64toi32_i32$1 + 360 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = (i64toi32_i32$1 + 360 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $13 = i64toi32_i32$0;
  $13$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 368 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 372 | 0) >> 2] | 0;
  $14 = i64toi32_i32$1;
  $14$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         i64toi32_i32$2 = $2;
         i64toi32_i32$0 = HEAP32[($2 + 360 | 0) >> 2] | 0;
         i64toi32_i32$1 = HEAP32[($2 + 364 | 0) >> 2] | 0;
         i64toi32_i32$2 = i64toi32_i32$0;
         i64toi32_i32$0 = 0;
         i64toi32_i32$3 = 1;
         if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
          break label$7
         }
         i64toi32_i32$2 = $13$hi;
         $5 = $13;
         label$8 : {
          i64toi32_i32$2 = $14$hi;
          i64toi32_i32$3 = $14;
          i64toi32_i32$1 = 0;
          i64toi32_i32$0 = 1;
          if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
           break label$8
          }
          if (!$5) {
           break label$3
          }
         }
         $6 = $2 + 384 | 0;
         $7 = $2 + 392 | 0;
         $8 = $2 + 375 | 0;
         $9 = $2 + 373 | 0;
         label$9 : {
          label$10 : {
           label$11 : {
            label$12 : {
             label$13 : while (1) {
              std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 8 | 0 | 0, $1 | 0);
              $4 = 0;
              $3 = 2;
              label$14 : {
               if (HEAP32[($2 + 12 | 0) >> 2] | 0) {
                break label$14
               }
               i64toi32_i32$3 = 0;
               $14 = 8;
               $14$hi = i64toi32_i32$3;
               i64toi32_i32$3 = 0;
               $13 = 0;
               $13$hi = i64toi32_i32$3;
               break label$5;
              }
              label$15 : {
               if ((($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[($2 + 8 | 0) >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) == (7 | 0)) {
                break label$15
               }
               $cardano_serialization_lib__utils__BigNum_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h29637bb571dceb02($2 + 360 | 0 | 0, $1 | 0);
               i64toi32_i32$0 = $2;
               i64toi32_i32$3 = HEAP32[($2 + 368 | 0) >> 2] | 0;
               i64toi32_i32$2 = HEAP32[($2 + 372 | 0) >> 2] | 0;
               $15 = i64toi32_i32$3;
               $15$hi = i64toi32_i32$2;
               i64toi32_i32$0 = $2;
               i64toi32_i32$2 = HEAP32[($2 + 360 | 0) >> 2] | 0;
               i64toi32_i32$3 = HEAP32[($2 + 364 | 0) >> 2] | 0;
               i64toi32_i32$0 = i64toi32_i32$2;
               i64toi32_i32$2 = 0;
               i64toi32_i32$1 = 1;
               if ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) | 0) {
                break label$12
               }
               $cardano_serialization_lib__metadata__TransactionMetadatumEnum_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h6868ff659c396c1d($2 + 360 | 0 | 0, $1 | 0);
               $4 = ($2 + 312 | 0) + 8 | 0;
               i64toi32_i32$1 = $7 + 8 | 0;
               i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
               i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
               $93 = i64toi32_i32$0;
               i64toi32_i32$0 = $4;
               HEAP32[i64toi32_i32$0 >> 2] = $93;
               HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
               $10 = ($2 + 312 | 0) + 16 | 0;
               i64toi32_i32$1 = $7 + 16 | 0;
               i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
               i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
               $100 = i64toi32_i32$3;
               i64toi32_i32$3 = $10;
               HEAP32[i64toi32_i32$3 >> 2] = $100;
               HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
               i64toi32_i32$1 = $7;
               i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
               i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
               $103 = i64toi32_i32$0;
               i64toi32_i32$0 = $2;
               HEAP32[($2 + 312 | 0) >> 2] = $103;
               HEAP32[($2 + 316 | 0) >> 2] = i64toi32_i32$3;
               i64toi32_i32$1 = $2;
               i64toi32_i32$3 = HEAPU8[(i64toi32_i32$1 + 369 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 370 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 371 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 372 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
               i64toi32_i32$0 = 0;
               $105 = i64toi32_i32$3;
               $105$hi = i64toi32_i32$0;
               i64toi32_i32$1 = $9;
               i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
               i64toi32_i32$3 = 0;
               $107 = i64toi32_i32$0;
               $107$hi = i64toi32_i32$3;
               i64toi32_i32$1 = $8;
               i64toi32_i32$3 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
               i64toi32_i32$0 = 0;
               i64toi32_i32$1 = i64toi32_i32$3;
               i64toi32_i32$3 = 0;
               i64toi32_i32$2 = 16;
               i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
               if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                i64toi32_i32$3 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
                $75 = 0;
               } else {
                i64toi32_i32$3 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
                $75 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
               }
               $110$hi = i64toi32_i32$3;
               i64toi32_i32$3 = $107$hi;
               i64toi32_i32$0 = $107;
               i64toi32_i32$1 = $110$hi;
               i64toi32_i32$2 = $75;
               i64toi32_i32$1 = i64toi32_i32$3 | i64toi32_i32$1 | 0;
               i64toi32_i32$3 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
               i64toi32_i32$0 = 0;
               i64toi32_i32$2 = 32;
               i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
               if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
                i64toi32_i32$0 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
                $76 = 0;
               } else {
                i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
                $76 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
               }
               $112$hi = i64toi32_i32$0;
               i64toi32_i32$0 = $105$hi;
               i64toi32_i32$1 = $105;
               i64toi32_i32$3 = $112$hi;
               i64toi32_i32$2 = $76;
               i64toi32_i32$3 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
               $12 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
               $12$hi = i64toi32_i32$3;
               i64toi32_i32$0 = $2;
               i64toi32_i32$3 = HEAP32[($2 + 384 | 0) >> 2] | 0;
               i64toi32_i32$1 = HEAP32[($2 + 388 | 0) >> 2] | 0;
               $13 = i64toi32_i32$3;
               $13$hi = i64toi32_i32$1;
               i64toi32_i32$0 = $2;
               i64toi32_i32$1 = HEAP32[($2 + 376 | 0) >> 2] | 0;
               i64toi32_i32$3 = HEAP32[($2 + 380 | 0) >> 2] | 0;
               $16 = i64toi32_i32$1;
               $16$hi = i64toi32_i32$3;
               $3 = HEAPU8[($2 + 368 | 0) >> 0] | 0;
               i64toi32_i32$0 = $2;
               i64toi32_i32$3 = HEAP32[($2 + 360 | 0) >> 2] | 0;
               i64toi32_i32$1 = HEAP32[($2 + 364 | 0) >> 2] | 0;
               i64toi32_i32$0 = i64toi32_i32$3;
               i64toi32_i32$3 = 0;
               i64toi32_i32$2 = 1;
               if ((i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) | 0) {
                break label$11
               }
               $11 = ($2 + 240 | 0) + 8 | 0;
               i64toi32_i32$2 = $4;
               i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
               i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
               $128 = i64toi32_i32$0;
               i64toi32_i32$0 = $11;
               HEAP32[i64toi32_i32$0 >> 2] = $128;
               HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
               $4 = ($2 + 240 | 0) + 16 | 0;
               i64toi32_i32$2 = $10;
               i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
               i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
               $134 = i64toi32_i32$1;
               i64toi32_i32$1 = $4;
               HEAP32[i64toi32_i32$1 >> 2] = $134;
               HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
               i64toi32_i32$2 = $2;
               i64toi32_i32$0 = HEAP32[($2 + 312 | 0) >> 2] | 0;
               i64toi32_i32$1 = HEAP32[($2 + 316 | 0) >> 2] | 0;
               $137 = i64toi32_i32$0;
               i64toi32_i32$0 = $2;
               HEAP32[($2 + 240 | 0) >> 2] = $137;
               HEAP32[($2 + 244 | 0) >> 2] = i64toi32_i32$1;
               i64toi32_i32$1 = $13$hi;
               i64toi32_i32$0 = $2;
               HEAP32[($2 + 376 | 0) >> 2] = $13;
               HEAP32[($2 + 380 | 0) >> 2] = i64toi32_i32$1;
               i64toi32_i32$1 = $16$hi;
               i64toi32_i32$0 = $2;
               HEAP32[($2 + 368 | 0) >> 2] = $16;
               HEAP32[($2 + 372 | 0) >> 2] = i64toi32_i32$1;
               HEAP8[($2 + 360 | 0) >> 0] = $3;
               i64toi32_i32$1 = $12$hi;
               HEAP8[($2 + 361 | 0) >> 0] = $12;
               HEAP8[($2 + 362 | 0) >> 0] = $12 >>> 8 | 0;
               HEAP8[($2 + 363 | 0) >> 0] = $12 >>> 16 | 0;
               HEAP8[($2 + 364 | 0) >> 0] = $12 >>> 24 | 0;
               $146 = $2;
               i64toi32_i32$2 = $12;
               i64toi32_i32$0 = 0;
               i64toi32_i32$3 = 48;
               i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
               if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                i64toi32_i32$0 = 0;
                $77 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
               } else {
                i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
                $77 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
               }
               HEAP8[($146 + 367 | 0) >> 0] = $77;
               $149 = $2;
               i64toi32_i32$0 = $12$hi;
               i64toi32_i32$1 = $12;
               i64toi32_i32$2 = 0;
               i64toi32_i32$3 = 32;
               i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
               if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                i64toi32_i32$2 = 0;
                $78 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
               } else {
                i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
                $78 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
               }
               $79 = $149;
               $80 = $78;
               HEAP8[($79 + 365 | 0) >> 0] = $80;
               HEAP8[($79 + 366 | 0) >> 0] = $80 >>> 8 | 0;
               i64toi32_i32$0 = $2;
               i64toi32_i32$2 = HEAP32[($2 + 240 | 0) >> 2] | 0;
               i64toi32_i32$1 = HEAP32[($2 + 244 | 0) >> 2] | 0;
               $154 = i64toi32_i32$2;
               i64toi32_i32$2 = $6;
               $72 = $154;
               HEAP8[i64toi32_i32$2 >> 0] = $72;
               HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $72 >>> 8 | 0;
               HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $72 >>> 16 | 0;
               HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $72 >>> 24 | 0;
               HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$1;
               HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
               HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
               HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
               i64toi32_i32$0 = $11;
               i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
               i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
               $158 = i64toi32_i32$1;
               i64toi32_i32$1 = $6 + 8 | 0;
               $73 = $158;
               HEAP8[i64toi32_i32$1 >> 0] = $73;
               HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $73 >>> 8 | 0;
               HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $73 >>> 16 | 0;
               HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $73 >>> 24 | 0;
               HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$2;
               HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
               HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
               HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
               i64toi32_i32$0 = $4;
               i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
               i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
               $162 = i64toi32_i32$2;
               i64toi32_i32$2 = $6 + 16 | 0;
               $74 = $162;
               HEAP8[i64toi32_i32$2 >> 0] = $74;
               HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $74 >>> 8 | 0;
               HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $74 >>> 16 | 0;
               HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $74 >>> 24 | 0;
               HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$1;
               HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
               HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
               HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
               i64toi32_i32$1 = $15$hi;
               linked_hash_map__LinkedHashMap_K_2cV_2cS___insert__h48a3e36a8942b5e6($2 + 312 | 0 | 0, $2 + 32 | 0 | 0, $15 | 0, i64toi32_i32$1 | 0, $2 + 360 | 0 | 0);
               if ((HEAP32[($2 + 312 | 0) >> 2] | 0 | 0) != (5 | 0)) {
                break label$10
               }
               i64toi32_i32$1 = $14$hi;
               i64toi32_i32$0 = $14;
               i64toi32_i32$2 = 0;
               i64toi32_i32$3 = 1;
               if ((i64toi32_i32$0 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$2 | 0) | 0) {
                continue label$13
               }
               if ((HEAP32[($2 + 60 | 0) >> 2] | 0) >>> 0 < $5 >>> 0) {
                continue label$13
               }
               break label$3;
              }
              break label$13;
             };
             cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 360 | 0 | 0, $1 | 0);
             i64toi32_i32$3 = ($2 + 360 | 0) + 16 | 0;
             i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
             i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
             $13 = i64toi32_i32$0;
             $13$hi = i64toi32_i32$1;
             i64toi32_i32$3 = $2;
             i64toi32_i32$1 = HEAP32[($2 + 368 | 0) >> 2] | 0;
             i64toi32_i32$0 = HEAP32[($2 + 372 | 0) >> 2] | 0;
             $14 = i64toi32_i32$1;
             $14$hi = i64toi32_i32$0;
             i64toi32_i32$3 = $2;
             i64toi32_i32$0 = HEAP32[($2 + 360 | 0) >> 2] | 0;
             i64toi32_i32$1 = HEAP32[($2 + 364 | 0) >> 2] | 0;
             i64toi32_i32$3 = i64toi32_i32$0;
             i64toi32_i32$0 = 0;
             i64toi32_i32$2 = 1;
             if ((i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
              break label$6
             }
             i64toi32_i32$3 = $13$hi;
             i64toi32_i32$1 = $2 + 296 | 0;
             HEAP32[i64toi32_i32$1 >> 2] = $13;
             HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
             i64toi32_i32$3 = $14$hi;
             i64toi32_i32$1 = $2;
             HEAP32[(i64toi32_i32$1 + 288 | 0) >> 2] = $14;
             HEAP32[(i64toi32_i32$1 + 292 | 0) >> 2] = i64toi32_i32$3;
             if (($14 & 255 | 0 | 0) == (5 | 0)) {
              break label$3
             }
             HEAP32[($2 + 360 | 0) >> 2] = 0;
             core__panicking__assert_failed__h96d8431cc974b591(0 | 0, $2 + 288 | 0 | 0, 1059816 | 0, $2 + 360 | 0 | 0, 1059956 | 0);
             abort();
            }
            i64toi32_i32$2 = $2 + 400 | 0;
            i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
            i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
            $210 = i64toi32_i32$3;
            i64toi32_i32$3 = ($2 + 216 | 0) + 8 | 0;
            HEAP32[i64toi32_i32$3 >> 2] = $210;
            HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
            i64toi32_i32$2 = $2 + 408 | 0;
            i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
            i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
            $216 = i64toi32_i32$1;
            i64toi32_i32$1 = ($2 + 216 | 0) + 16 | 0;
            HEAP32[i64toi32_i32$1 >> 2] = $216;
            HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
            HEAP32[(($2 + 200 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 428 | 0) >> 2] | 0;
            i64toi32_i32$2 = $2;
            i64toi32_i32$3 = HEAP32[($2 + 420 | 0) >> 2] | 0;
            i64toi32_i32$1 = HEAP32[($2 + 424 | 0) >> 2] | 0;
            $225 = i64toi32_i32$3;
            i64toi32_i32$3 = $2;
            HEAP32[($2 + 200 | 0) >> 2] = $225;
            HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$1;
            i64toi32_i32$2 = $2 + 392 | 0;
            i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
            i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
            $229 = i64toi32_i32$1;
            i64toi32_i32$1 = $2;
            HEAP32[(i64toi32_i32$1 + 216 | 0) >> 2] = $229;
            HEAP32[(i64toi32_i32$1 + 220 | 0) >> 2] = i64toi32_i32$3;
            i64toi32_i32$3 = $15$hi;
            i64toi32_i32$2 = $15;
            i64toi32_i32$1 = 0;
            i64toi32_i32$0 = 8;
            i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
            if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
             i64toi32_i32$1 = 0;
             $81 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
            } else {
             i64toi32_i32$1 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
             $81 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
            }
            $12 = $81;
            $12$hi = i64toi32_i32$1;
            i64toi32_i32$3 = $2 + 384 | 0;
            i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
            i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
            $13 = i64toi32_i32$1;
            $13$hi = i64toi32_i32$2;
            i64toi32_i32$3 = ($2 + 360 | 0) + 16 | 0;
            i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
            i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
            $14 = i64toi32_i32$2;
            $14$hi = i64toi32_i32$1;
            $4 = HEAP32[($2 + 416 | 0) >> 2] | 0;
            i64toi32_i32$1 = $15$hi;
            $3 = $15;
            break label$9;
           }
           HEAP32[(($2 + 200 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 428 | 0) >> 2] | 0;
           i64toi32_i32$3 = ($2 + 312 | 0) + 16 | 0;
           i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
           $256 = i64toi32_i32$1;
           i64toi32_i32$1 = ($2 + 216 | 0) + 16 | 0;
           HEAP32[i64toi32_i32$1 >> 2] = $256;
           HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
           i64toi32_i32$3 = ($2 + 312 | 0) + 8 | 0;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
           $263 = i64toi32_i32$2;
           i64toi32_i32$2 = ($2 + 216 | 0) + 8 | 0;
           HEAP32[i64toi32_i32$2 >> 2] = $263;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
           i64toi32_i32$3 = $2;
           i64toi32_i32$1 = HEAP32[($2 + 420 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($2 + 424 | 0) >> 2] | 0;
           $266 = i64toi32_i32$1;
           i64toi32_i32$1 = $2;
           HEAP32[(i64toi32_i32$1 + 200 | 0) >> 2] = $266;
           HEAP32[(i64toi32_i32$1 + 204 | 0) >> 2] = i64toi32_i32$2;
           i64toi32_i32$3 = i64toi32_i32$1;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 312 | 0) >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$1 + 316 | 0) >> 2] | 0;
           $14 = i64toi32_i32$2;
           $14$hi = i64toi32_i32$1;
           i64toi32_i32$2 = $2;
           HEAP32[($2 + 264 | 0) >> 2] = $14;
           HEAP32[($2 + 268 | 0) >> 2] = i64toi32_i32$1;
           i64toi32_i32$2 = $2;
           HEAP32[($2 + 216 | 0) >> 2] = $14;
           HEAP32[($2 + 220 | 0) >> 2] = i64toi32_i32$1;
           $4 = HEAP32[($2 + 416 | 0) >> 2] | 0;
           i64toi32_i32$1 = $16$hi;
           $14 = $16;
           $14$hi = i64toi32_i32$1;
           break label$9;
          }
          core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatum___headd2d1b596252cc($2 + 312 | 0 | 0);
          alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($2 + 372 | 0 | 0, 1059972 | 0, 33 | 0);
          $4 = 0;
          $1 = ($2 + 360 | 0) + 8 | 0;
          HEAP32[$1 >> 2] = 0;
          i64toi32_i32$3 = $2 + 392 | 0;
          i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
          i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
          $290 = i64toi32_i32$1;
          i64toi32_i32$1 = ($2 + 216 | 0) + 8 | 0;
          HEAP32[i64toi32_i32$1 >> 2] = $290;
          HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
          i64toi32_i32$3 = $2 + 400 | 0;
          i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
          $296 = i64toi32_i32$2;
          i64toi32_i32$2 = ($2 + 216 | 0) + 16 | 0;
          HEAP32[i64toi32_i32$2 >> 2] = $296;
          HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
          i64toi32_i32$3 = $2 + 384 | 0;
          i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
          i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
          $300 = i64toi32_i32$1;
          i64toi32_i32$1 = $2;
          HEAP32[(i64toi32_i32$1 + 216 | 0) >> 2] = $300;
          HEAP32[(i64toi32_i32$1 + 220 | 0) >> 2] = i64toi32_i32$2;
          i64toi32_i32$3 = i64toi32_i32$1;
          i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 361 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 362 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 363 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 364 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          i64toi32_i32$1 = 0;
          $302 = i64toi32_i32$2;
          $302$hi = i64toi32_i32$1;
          i64toi32_i32$3 = $2;
          i64toi32_i32$1 = HEAPU8[($2 + 365 | 0) >> 0] | 0 | ((HEAPU8[($2 + 366 | 0) >> 0] | 0) << 8 | 0) | 0;
          i64toi32_i32$2 = 0;
          $304 = i64toi32_i32$1;
          $304$hi = i64toi32_i32$2;
          i64toi32_i32$3 = $2;
          i64toi32_i32$2 = HEAPU8[($2 + 367 | 0) >> 0] | 0;
          i64toi32_i32$1 = 0;
          i64toi32_i32$3 = i64toi32_i32$2;
          i64toi32_i32$2 = 0;
          i64toi32_i32$0 = 16;
          i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
          if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
           i64toi32_i32$2 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
           $82 = 0;
          } else {
           i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
           $82 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
          }
          $307$hi = i64toi32_i32$2;
          i64toi32_i32$2 = $304$hi;
          i64toi32_i32$1 = $304;
          i64toi32_i32$3 = $307$hi;
          i64toi32_i32$0 = $82;
          i64toi32_i32$3 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
          i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
          i64toi32_i32$1 = 0;
          i64toi32_i32$0 = 32;
          i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
          if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
           i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
           $83 = 0;
          } else {
           i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$4 | 0) | 0;
           $83 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
          }
          $309$hi = i64toi32_i32$1;
          i64toi32_i32$1 = $302$hi;
          i64toi32_i32$3 = $302;
          i64toi32_i32$2 = $309$hi;
          i64toi32_i32$0 = $83;
          i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
          $12 = i64toi32_i32$3 | i64toi32_i32$0 | 0;
          $12$hi = i64toi32_i32$2;
          i64toi32_i32$1 = ($2 + 360 | 0) + 16 | 0;
          i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
          i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
          $13 = i64toi32_i32$2;
          $13$hi = i64toi32_i32$3;
          i64toi32_i32$1 = $1;
          i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
          i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
          $14 = i64toi32_i32$3;
          $14$hi = i64toi32_i32$2;
          $3 = 4;
         }
         if (($3 & 255 | 0 | 0) != (19 | 0)) {
          break label$4
         }
         break label$3;
        }
        i64toi32_i32$1 = $2 + 392 | 0;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
        $324 = i64toi32_i32$2;
        i64toi32_i32$2 = $2 + 224 | 0;
        HEAP32[i64toi32_i32$2 >> 2] = $324;
        HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
        i64toi32_i32$1 = $2 + 400 | 0;
        i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
        $330 = i64toi32_i32$3;
        i64toi32_i32$3 = ($2 + 216 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$3 >> 2] = $330;
        HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
        i64toi32_i32$1 = ($2 + 360 | 0) + 24 | 0;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
        $335 = i64toi32_i32$2;
        i64toi32_i32$2 = $2;
        HEAP32[($2 + 216 | 0) >> 2] = $335;
        HEAP32[($2 + 220 | 0) >> 2] = i64toi32_i32$3;
        $3 = 2;
        break label$5;
       }
       i64toi32_i32$1 = $2 + 392 | 0;
       i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $340 = i64toi32_i32$3;
       i64toi32_i32$3 = $2 + 224 | 0;
       HEAP32[i64toi32_i32$3 >> 2] = $340;
       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$1 = $2 + 400 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $346 = i64toi32_i32$2;
       i64toi32_i32$2 = ($2 + 216 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $346;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
       i64toi32_i32$1 = $2 + 384 | 0;
       i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $350 = i64toi32_i32$3;
       i64toi32_i32$3 = $2;
       HEAP32[($2 + 216 | 0) >> 2] = $350;
       HEAP32[($2 + 220 | 0) >> 2] = i64toi32_i32$2;
      }
     }
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$3 = ($2 + 360 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $13;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$2 = $14$hi;
     i64toi32_i32$3 = ($2 + 360 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $14;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$1 = $2;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 216 | 0) >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 220 | 0) >> 2] | 0;
     $362 = i64toi32_i32$2;
     i64toi32_i32$2 = i64toi32_i32$1 + 384 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $362;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 200 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 204 | 0) >> 2] | 0;
     $366 = i64toi32_i32$3;
     i64toi32_i32$3 = i64toi32_i32$1 + 412 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $366;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$1 = (i64toi32_i32$1 + 216 | 0) + 8 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $372 = i64toi32_i32$2;
     i64toi32_i32$2 = $2 + 392 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $372;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$1 = ($2 + 216 | 0) + 16 | 0;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $378 = i64toi32_i32$3;
     i64toi32_i32$3 = $2 + 400 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $378;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
     HEAP32[($2 + 420 | 0) >> 2] = HEAP32[(($2 + 200 | 0) + 8 | 0) >> 2] | 0;
     HEAP8[($2 + 360 | 0) >> 0] = $3;
     HEAP32[($2 + 408 | 0) >> 2] = $4;
     i64toi32_i32$2 = $12$hi;
     HEAP8[($2 + 361 | 0) >> 0] = $12;
     HEAP8[($2 + 362 | 0) >> 0] = $12 >>> 8 | 0;
     HEAP8[($2 + 363 | 0) >> 0] = $12 >>> 16 | 0;
     HEAP8[($2 + 364 | 0) >> 0] = $12 >>> 24 | 0;
     $391 = $2;
     i64toi32_i32$1 = $12;
     i64toi32_i32$3 = 0;
     i64toi32_i32$0 = 48;
     i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
      i64toi32_i32$3 = 0;
      $84 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
     } else {
      i64toi32_i32$3 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
      $84 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
     }
     HEAP8[($391 + 367 | 0) >> 0] = $84;
     $394 = $2;
     i64toi32_i32$3 = $12$hi;
     i64toi32_i32$2 = $12;
     i64toi32_i32$1 = 0;
     i64toi32_i32$0 = 32;
     i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
      i64toi32_i32$1 = 0;
      $85 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
     } else {
      i64toi32_i32$1 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
      $85 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
     }
     $86 = $394;
     $87 = $85;
     HEAP8[($86 + 365 | 0) >> 0] = $87;
     HEAP8[($86 + 366 | 0) >> 0] = $87 >>> 8 | 0;
     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($2 + 136 | 0 | 0, $2 + 360 | 0 | 0, 1060005 | 0, 26 | 0);
     $1 = HEAPU8[($2 + 136 | 0) >> 0] | 0;
     if (($1 | 0) != (19 | 0)) {
      break label$2
     }
    }
    memcpy($0 + 8 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
    i64toi32_i32$1 = 0;
    $12 = 0;
    $12$hi = i64toi32_i32$1;
    break label$1;
   }
   memcpy($2 + 73 | 0 | 0, $2 + 136 | 0 | 1 | 0 | 0, 63 | 0) | 0;
   HEAP8[($0 + 8 | 0) >> 0] = $1;
   memcpy($0 + 9 | 0 | 0, $2 + 73 | 0 | 0, 63 | 0) | 0;
   $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__he275f3eb7df08493($2 + 32 | 0 | 0);
   label$16 : {
    if (!(HEAP32[($2 + 48 | 0) >> 2] | 0)) {
     break label$16
    }
    hashbrown__raw__RawTable_T_2cA___free_buckets__hfa29170569415d6b(($2 + 32 | 0) + 16 | 0 | 0);
   }
   i64toi32_i32$1 = 0;
   $12 = 1;
   $12$hi = i64toi32_i32$1;
  }
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$2 = $0;
  HEAP32[i64toi32_i32$2 >> 2] = $12;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $2 + 432 | 0;
 }
 
 function $cardano_serialization_lib__crypto__Vkeywitnesses_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h427f277ac56c0c7f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, $10 = 0, $20 = 0, $5 = 0, $8 = 0, $20$hi = 0, $21 = 0, $9 = 0, $21$hi = 0, $7 = 0, $6 = 0, $67 = 0, $68 = 0, $69 = 0, $70 = 0, $71 = 0, $72 = 0, $73 = 0, $74 = 0, $75 = 0, $76 = 0, $77 = 0, $78 = 0, $79 = 0, $80 = 0, $82 = 0, $83 = 0, $84 = 0, $85 = 0, $86 = 0, $87 = 0, $89 = 0, $90 = 0, $91 = 0, $92 = 0, $93 = 0, $94 = 0, $95 = 0, $96 = 0, $98 = 0, $4 = 0, $12 = 0, $13 = 0, $14 = 0, $15 = 0, $17 = 0, $18 = 0, $19 = 0, $81 = 0, $88 = 0, $97 = 0, $11 = 0, $22 = 0, $22$hi = 0, $125 = 0, $132 = 0, $142 = 0, $145 = 0, $16 = 0, $159 = 0, $165 = 0, $168 = 0, $177 = 0, $208 = 0, $220 = 0, $224 = 0, $229 = 0, $236 = 0, $240 = 0, $244 = 0, $290 = 0, $297 = 0, $310 = 0, $313 = 0, $330 = 0, $335 = 0, $349 = 0, $352 = 0, $359 = 0, $365 = 0, $369 = 0, $374 = 0, $380 = 0, $384 = 0, $396 = 0, $400 = 0, $406 = 0, $412 = 0, $439 = 0;
  $2 = global$0 - 448 | 0;
  global$0 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 20 | 0) >> 2] = 0;
  HEAP32[($2 + 24 | 0) >> 2] = i64toi32_i32$0;
  $3 = 0;
  HEAP32[($2 + 16 | 0) >> 2] = HEAP32[(0 + 1066212 | 0) >> 2] | 0;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 344 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = ($2 + 344 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $20 = i64toi32_i32$0;
  $20$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 352 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 356 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  $21$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 344 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 348 | 0) >> 2] | 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
         break label$6
        }
        i64toi32_i32$2 = $20$hi;
        $4 = $20;
        label$7 : {
         i64toi32_i32$2 = $21$hi;
         i64toi32_i32$3 = $21;
         i64toi32_i32$1 = 0;
         i64toi32_i32$0 = 1;
         if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
          break label$7
         }
         if (!$4) {
          break label$3
         }
        }
        $5 = $2 + 416 | 0;
        $6 = $2 + 404 | 0;
        $7 = $2 + 376 | 0;
        $8 = $2 + 353 | 0;
        $9 = $2 + 344 | 0 | 1 | 0;
        label$8 : {
         label$9 : while (1) {
          std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 8 | 0 | 0, $1 | 0);
          $3 = 0;
          $10 = 2;
          label$10 : {
           if (HEAP32[($2 + 12 | 0) >> 2] | 0) {
            break label$10
           }
           i64toi32_i32$3 = 0;
           $21 = 8;
           $21$hi = i64toi32_i32$3;
           i64toi32_i32$3 = 0;
           $20 = 0;
           $20$hi = i64toi32_i32$3;
           break label$4;
          }
          label$11 : {
           if ((($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[($2 + 8 | 0) >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) == (7 | 0)) {
            break label$11
           }
           $cardano_serialization_lib__crypto__Vkeywitness_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h37c9c40e98008804($2 + 344 | 0 | 0, $1 | 0);
           if ((HEAPU8[($2 + 344 | 0) >> 0] | 0 | 0) == (1 | 0)) {
            break label$8
           }
           $3 = ($2 + 312 | 0) + 8 | 0;
           i64toi32_i32$0 = $7 + 8 | 0;
           i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $81 = i64toi32_i32$3;
           i64toi32_i32$3 = $3;
           HEAP32[i64toi32_i32$3 >> 2] = $81;
           HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
           $10 = ($2 + 312 | 0) + 16 | 0;
           i64toi32_i32$0 = $7 + 16 | 0;
           i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$3 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $88 = i64toi32_i32$2;
           i64toi32_i32$2 = $10;
           HEAP32[i64toi32_i32$2 >> 2] = $88;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
           HEAP32[($2 + 288 | 0) >> 2] = HEAPU8[$9 >> 0] | 0 | ((HEAPU8[($9 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($9 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($9 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP32[($2 + 336 | 0) >> 2] = HEAPU8[$8 >> 0] | 0 | ((HEAPU8[($8 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($8 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($8 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$0 = $7;
           i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $97 = i64toi32_i32$3;
           i64toi32_i32$3 = $2;
           HEAP32[($2 + 312 | 0) >> 2] = $97;
           HEAP32[($2 + 316 | 0) >> 2] = i64toi32_i32$2;
           $67 = $9 + 3 | 0;
           $68 = HEAPU8[$67 >> 0] | 0 | ((HEAPU8[($67 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($67 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($67 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 291 | 0) >> 0] = $68;
           HEAP8[($2 + 292 | 0) >> 0] = $68 >>> 8 | 0;
           HEAP8[($2 + 293 | 0) >> 0] = $68 >>> 16 | 0;
           HEAP8[($2 + 294 | 0) >> 0] = $68 >>> 24 | 0;
           $69 = $8 + 3 | 0;
           $70 = HEAPU8[$69 >> 0] | 0 | ((HEAPU8[($69 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($69 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($69 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 339 | 0) >> 0] = $70;
           HEAP8[($2 + 340 | 0) >> 0] = $70 >>> 8 | 0;
           HEAP8[($2 + 341 | 0) >> 0] = $70 >>> 16 | 0;
           HEAP8[($2 + 342 | 0) >> 0] = $70 >>> 24 | 0;
           $11 = HEAPU8[($2 + 352 | 0) >> 0] | 0;
           i64toi32_i32$0 = $2;
           i64toi32_i32$2 = HEAP32[($2 + 360 | 0) >> 2] | 0;
           i64toi32_i32$3 = HEAP32[($2 + 364 | 0) >> 2] | 0;
           $20 = i64toi32_i32$2;
           $20$hi = i64toi32_i32$3;
           i64toi32_i32$0 = $2;
           i64toi32_i32$3 = HEAP32[($2 + 368 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($2 + 372 | 0) >> 2] | 0;
           $22 = i64toi32_i32$3;
           $22$hi = i64toi32_i32$2;
           $12 = ($2 + 296 | 0) + 8 | 0;
           $71 = $6 + 8 | 0;
           HEAP32[$12 >> 2] = HEAPU8[$71 >> 0] | 0 | ((HEAPU8[($71 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($71 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($71 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $13 = ($2 + 208 | 0) + 8 | 0;
           i64toi32_i32$0 = $5 + 8 | 0;
           i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$3 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $125 = i64toi32_i32$2;
           i64toi32_i32$2 = $13;
           HEAP32[i64toi32_i32$2 >> 2] = $125;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
           $14 = ($2 + 208 | 0) + 16 | 0;
           i64toi32_i32$0 = $5 + 16 | 0;
           i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $132 = i64toi32_i32$3;
           i64toi32_i32$3 = $14;
           HEAP32[i64toi32_i32$3 >> 2] = $132;
           HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
           $15 = ($2 + 208 | 0) + 24 | 0;
           HEAP8[$15 >> 0] = HEAPU8[($5 + 24 | 0) >> 0] | 0;
           i64toi32_i32$0 = $6;
           i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$3 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $142 = i64toi32_i32$2;
           i64toi32_i32$2 = $2;
           HEAP32[($2 + 296 | 0) >> 2] = $142;
           HEAP32[($2 + 300 | 0) >> 2] = i64toi32_i32$3;
           i64toi32_i32$0 = $5;
           i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $145 = i64toi32_i32$3;
           i64toi32_i32$3 = $2;
           HEAP32[($2 + 208 | 0) >> 2] = $145;
           HEAP32[($2 + 212 | 0) >> 2] = i64toi32_i32$2;
           HEAP32[($2 + 280 | 0) >> 2] = HEAP32[($2 + 336 | 0) >> 2] | 0;
           $72 = HEAPU8[($2 + 339 | 0) >> 0] | 0 | ((HEAPU8[($2 + 340 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 341 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 342 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 283 | 0) >> 0] = $72;
           HEAP8[($2 + 284 | 0) >> 0] = $72 >>> 8 | 0;
           HEAP8[($2 + 285 | 0) >> 0] = $72 >>> 16 | 0;
           HEAP8[($2 + 286 | 0) >> 0] = $72 >>> 24 | 0;
           $16 = HEAP32[($2 + 400 | 0) >> 2] | 0;
           $17 = ($2 + 256 | 0) + 16 | 0;
           i64toi32_i32$0 = $10;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $159 = i64toi32_i32$2;
           i64toi32_i32$2 = $17;
           HEAP32[i64toi32_i32$2 >> 2] = $159;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
           $18 = ($2 + 256 | 0) + 8 | 0;
           i64toi32_i32$0 = $3;
           i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $165 = i64toi32_i32$3;
           i64toi32_i32$3 = $18;
           HEAP32[i64toi32_i32$3 >> 2] = $165;
           HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
           i64toi32_i32$0 = $2;
           i64toi32_i32$2 = HEAP32[($2 + 312 | 0) >> 2] | 0;
           i64toi32_i32$3 = HEAP32[($2 + 316 | 0) >> 2] | 0;
           $168 = i64toi32_i32$2;
           i64toi32_i32$2 = $2;
           HEAP32[($2 + 256 | 0) >> 2] = $168;
           HEAP32[($2 + 260 | 0) >> 2] = i64toi32_i32$3;
           $19 = ($2 + 240 | 0) + 8 | 0;
           HEAP32[$19 >> 2] = HEAP32[$12 >> 2] | 0;
           i64toi32_i32$0 = $2;
           i64toi32_i32$3 = HEAP32[($2 + 296 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($2 + 300 | 0) >> 2] | 0;
           $177 = i64toi32_i32$3;
           i64toi32_i32$3 = $2;
           HEAP32[($2 + 240 | 0) >> 2] = $177;
           HEAP32[($2 + 244 | 0) >> 2] = i64toi32_i32$2;
           label$12 : {
            $10 = HEAP32[($2 + 24 | 0) >> 2] | 0;
            if ((HEAP32[($2 + 20 | 0) >> 2] | 0 | 0) != ($10 | 0)) {
             break label$12
            }
            alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hf92fb44e4fe7e929($2 + 16 | 0 | 0, $10 | 0, 1 | 0);
            $10 = HEAP32[($2 + 24 | 0) >> 2] | 0;
           }
           $3 = (HEAP32[($2 + 16 | 0) >> 2] | 0) + Math_imul($10, 96) | 0;
           $73 = HEAP32[($2 + 288 | 0) >> 2] | 0;
           HEAP8[$3 >> 0] = $73;
           HEAP8[($3 + 1 | 0) >> 0] = $73 >>> 8 | 0;
           HEAP8[($3 + 2 | 0) >> 0] = $73 >>> 16 | 0;
           HEAP8[($3 + 3 | 0) >> 0] = $73 >>> 24 | 0;
           HEAP8[($3 + 7 | 0) >> 0] = $11;
           $74 = HEAP32[($2 + 280 | 0) >> 2] | 0;
           HEAP8[($3 + 8 | 0) >> 0] = $74;
           HEAP8[($3 + 9 | 0) >> 0] = $74 >>> 8 | 0;
           HEAP8[($3 + 10 | 0) >> 0] = $74 >>> 16 | 0;
           HEAP8[($3 + 11 | 0) >> 0] = $74 >>> 24 | 0;
           i64toi32_i32$2 = $22$hi;
           i64toi32_i32$3 = $3;
           $75 = $22;
           HEAP8[(i64toi32_i32$3 + 23 | 0) >> 0] = $75;
           HEAP8[(i64toi32_i32$3 + 24 | 0) >> 0] = $75 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 25 | 0) >> 0] = $75 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 26 | 0) >> 0] = $75 >>> 24 | 0;
           HEAP8[(i64toi32_i32$3 + 27 | 0) >> 0] = i64toi32_i32$2;
           HEAP8[(i64toi32_i32$3 + 28 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 29 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 30 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
           i64toi32_i32$2 = $20$hi;
           HEAP8[(i64toi32_i32$3 + 15 | 0) >> 0] = $20;
           HEAP8[(i64toi32_i32$3 + 16 | 0) >> 0] = $20 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 17 | 0) >> 0] = $20 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 18 | 0) >> 0] = $20 >>> 24 | 0;
           HEAP8[(i64toi32_i32$3 + 19 | 0) >> 0] = i64toi32_i32$2;
           HEAP8[(i64toi32_i32$3 + 20 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 21 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 22 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
           i64toi32_i32$0 = $2;
           i64toi32_i32$2 = HEAP32[($2 + 256 | 0) >> 2] | 0;
           i64toi32_i32$3 = HEAP32[($2 + 260 | 0) >> 2] | 0;
           $208 = i64toi32_i32$2;
           i64toi32_i32$2 = $3;
           $76 = $208;
           HEAP8[(i64toi32_i32$2 + 31 | 0) >> 0] = $76;
           HEAP8[(i64toi32_i32$2 + 32 | 0) >> 0] = $76 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 33 | 0) >> 0] = $76 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 34 | 0) >> 0] = $76 >>> 24 | 0;
           HEAP8[(i64toi32_i32$2 + 35 | 0) >> 0] = i64toi32_i32$3;
           HEAP8[(i64toi32_i32$2 + 36 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 37 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 38 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
           $77 = i64toi32_i32$2 + 3 | 0;
           $78 = HEAPU8[($2 + 291 | 0) >> 0] | 0 | ((HEAPU8[($2 + 292 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 293 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 294 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[$77 >> 0] = $78;
           HEAP8[($77 + 1 | 0) >> 0] = $78 >>> 8 | 0;
           HEAP8[($77 + 2 | 0) >> 0] = $78 >>> 16 | 0;
           HEAP8[($77 + 3 | 0) >> 0] = $78 >>> 24 | 0;
           $79 = i64toi32_i32$2 + 11 | 0;
           $80 = HEAPU8[($2 + 283 | 0) >> 0] | 0 | ((HEAPU8[($2 + 284 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 285 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 286 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[$79 >> 0] = $80;
           HEAP8[($79 + 1 | 0) >> 0] = $80 >>> 8 | 0;
           HEAP8[($79 + 2 | 0) >> 0] = $80 >>> 16 | 0;
           HEAP8[($79 + 3 | 0) >> 0] = $80 >>> 24 | 0;
           i64toi32_i32$0 = $18;
           i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $220 = i64toi32_i32$3;
           i64toi32_i32$3 = $3 + 39 | 0;
           $82 = $220;
           HEAP8[i64toi32_i32$3 >> 0] = $82;
           HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $82 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $82 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $82 >>> 24 | 0;
           HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$2;
           HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
           i64toi32_i32$0 = $17;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $224 = i64toi32_i32$2;
           i64toi32_i32$2 = $3 + 47 | 0;
           $83 = $224;
           HEAP8[i64toi32_i32$2 >> 0] = $83;
           HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $83 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $83 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $83 >>> 24 | 0;
           HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$3;
           HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
           $84 = $16;
           HEAP8[($3 + 55 | 0) >> 0] = $84;
           HEAP8[($3 + 56 | 0) >> 0] = $84 >>> 8 | 0;
           HEAP8[($3 + 57 | 0) >> 0] = $84 >>> 16 | 0;
           HEAP8[($3 + 58 | 0) >> 0] = $84 >>> 24 | 0;
           i64toi32_i32$0 = $2;
           i64toi32_i32$3 = HEAP32[($2 + 240 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($2 + 244 | 0) >> 2] | 0;
           $229 = i64toi32_i32$3;
           i64toi32_i32$3 = $3;
           $85 = $229;
           HEAP8[(i64toi32_i32$3 + 59 | 0) >> 0] = $85;
           HEAP8[(i64toi32_i32$3 + 60 | 0) >> 0] = $85 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 61 | 0) >> 0] = $85 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 62 | 0) >> 0] = $85 >>> 24 | 0;
           HEAP8[(i64toi32_i32$3 + 63 | 0) >> 0] = i64toi32_i32$2;
           HEAP8[(i64toi32_i32$3 + 64 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 65 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 66 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
           $86 = i64toi32_i32$3 + 67 | 0;
           $87 = HEAP32[$19 >> 2] | 0;
           HEAP8[$86 >> 0] = $87;
           HEAP8[($86 + 1 | 0) >> 0] = $87 >>> 8 | 0;
           HEAP8[($86 + 2 | 0) >> 0] = $87 >>> 16 | 0;
           HEAP8[($86 + 3 | 0) >> 0] = $87 >>> 24 | 0;
           i64toi32_i32$0 = $2;
           i64toi32_i32$2 = HEAP32[($2 + 208 | 0) >> 2] | 0;
           i64toi32_i32$3 = HEAP32[($2 + 212 | 0) >> 2] | 0;
           $236 = i64toi32_i32$2;
           i64toi32_i32$2 = $3;
           $89 = $236;
           HEAP8[(i64toi32_i32$2 + 71 | 0) >> 0] = $89;
           HEAP8[(i64toi32_i32$2 + 72 | 0) >> 0] = $89 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 73 | 0) >> 0] = $89 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 74 | 0) >> 0] = $89 >>> 24 | 0;
           HEAP8[(i64toi32_i32$2 + 75 | 0) >> 0] = i64toi32_i32$3;
           HEAP8[(i64toi32_i32$2 + 76 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 77 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 78 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
           i64toi32_i32$0 = $13;
           i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $240 = i64toi32_i32$3;
           i64toi32_i32$3 = $3 + 79 | 0;
           $90 = $240;
           HEAP8[i64toi32_i32$3 >> 0] = $90;
           HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $90 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $90 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $90 >>> 24 | 0;
           HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$2;
           HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
           i64toi32_i32$0 = $14;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $244 = i64toi32_i32$2;
           i64toi32_i32$2 = $3 + 87 | 0;
           $91 = $244;
           HEAP8[i64toi32_i32$2 >> 0] = $91;
           HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $91 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $91 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $91 >>> 24 | 0;
           HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$3;
           HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
           HEAP8[($3 + 95 | 0) >> 0] = HEAPU8[$15 >> 0] | 0;
           $3 = $10 + 1 | 0;
           HEAP32[($2 + 24 | 0) >> 2] = $3;
           i64toi32_i32$3 = $21$hi;
           i64toi32_i32$0 = $21;
           i64toi32_i32$2 = 0;
           i64toi32_i32$1 = 1;
           if ((i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$3 | 0) != (i64toi32_i32$2 | 0) | 0) {
            continue label$9
           }
           if ($3 >>> 0 < $4 >>> 0) {
            continue label$9
           }
           break label$3;
          }
          break label$9;
         };
         cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 344 | 0 | 0, $1 | 0);
         i64toi32_i32$1 = ($2 + 344 | 0) + 16 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
         $20 = i64toi32_i32$0;
         $20$hi = i64toi32_i32$3;
         i64toi32_i32$1 = $2;
         i64toi32_i32$3 = HEAP32[($2 + 352 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($2 + 356 | 0) >> 2] | 0;
         $21 = i64toi32_i32$3;
         $21$hi = i64toi32_i32$0;
         i64toi32_i32$1 = $2;
         i64toi32_i32$0 = HEAP32[($2 + 344 | 0) >> 2] | 0;
         i64toi32_i32$3 = HEAP32[($2 + 348 | 0) >> 2] | 0;
         i64toi32_i32$1 = i64toi32_i32$0;
         i64toi32_i32$0 = 0;
         i64toi32_i32$2 = 1;
         if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) | 0) {
          break label$5
         }
         i64toi32_i32$1 = $20$hi;
         i64toi32_i32$3 = $2 + 320 | 0;
         HEAP32[i64toi32_i32$3 >> 2] = $20;
         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$1 = $21$hi;
         i64toi32_i32$3 = $2;
         HEAP32[($2 + 312 | 0) >> 2] = $21;
         HEAP32[($2 + 316 | 0) >> 2] = i64toi32_i32$1;
         if (($21 & 255 | 0 | 0) == (5 | 0)) {
          break label$3
         }
         HEAP32[($2 + 344 | 0) >> 2] = 0;
         core__panicking__assert_failed__h96d8431cc974b591(0 | 0, $2 + 312 | 0 | 0, 1066256 | 0, $2 + 344 | 0 | 0, 1066288 | 0);
         abort();
        }
        $5 = ($2 + 312 | 0) + 8 | 0;
        i64toi32_i32$2 = $7 + 8 | 0;
        i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$3 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $290 = i64toi32_i32$1;
        i64toi32_i32$1 = $5;
        HEAP32[i64toi32_i32$1 >> 2] = $290;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
        $1 = ($2 + 312 | 0) + 16 | 0;
        i64toi32_i32$2 = $7 + 16 | 0;
        i64toi32_i32$3 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $297 = i64toi32_i32$3;
        i64toi32_i32$3 = $1;
        HEAP32[i64toi32_i32$3 >> 2] = $297;
        HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
        $9 = ($2 + 296 | 0) + 8 | 0;
        $92 = $6 + 8 | 0;
        HEAP32[$9 >> 2] = HEAPU8[$92 >> 0] | 0 | ((HEAPU8[($92 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($92 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($92 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP32[($2 + 336 | 0) >> 2] = HEAPU8[$8 >> 0] | 0 | ((HEAPU8[($8 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($8 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($8 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$2 = $7;
        i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$3 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $310 = i64toi32_i32$1;
        i64toi32_i32$1 = $2;
        HEAP32[($2 + 312 | 0) >> 2] = $310;
        HEAP32[($2 + 316 | 0) >> 2] = i64toi32_i32$3;
        i64toi32_i32$2 = $6;
        i64toi32_i32$3 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $313 = i64toi32_i32$3;
        i64toi32_i32$3 = $2;
        HEAP32[($2 + 296 | 0) >> 2] = $313;
        HEAP32[($2 + 300 | 0) >> 2] = i64toi32_i32$1;
        $93 = $8 + 3 | 0;
        $94 = HEAPU8[$93 >> 0] | 0 | ((HEAPU8[($93 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($93 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($93 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 339 | 0) >> 0] = $94;
        HEAP8[($2 + 340 | 0) >> 0] = $94 >>> 8 | 0;
        HEAP8[($2 + 341 | 0) >> 0] = $94 >>> 16 | 0;
        HEAP8[($2 + 342 | 0) >> 0] = $94 >>> 24 | 0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$1 = HEAP32[($2 + 360 | 0) >> 2] | 0;
        i64toi32_i32$3 = HEAP32[($2 + 364 | 0) >> 2] | 0;
        $21 = i64toi32_i32$1;
        $21$hi = i64toi32_i32$3;
        i64toi32_i32$2 = $2;
        i64toi32_i32$3 = HEAP32[($2 + 368 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 372 | 0) >> 2] | 0;
        $20 = i64toi32_i32$3;
        $20$hi = i64toi32_i32$1;
        $3 = HEAP32[($2 + 400 | 0) >> 2] | 0;
        $10 = HEAPU8[($2 + 352 | 0) >> 0] | 0;
        i64toi32_i32$2 = $5;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $330 = i64toi32_i32$1;
        i64toi32_i32$1 = ($2 + 176 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $330;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
        i64toi32_i32$2 = $1;
        i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $335 = i64toi32_i32$3;
        i64toi32_i32$3 = ($2 + 176 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$3 >> 2] = $335;
        HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
        HEAP32[(($2 + 160 | 0) + 8 | 0) >> 2] = HEAP32[$9 >> 2] | 0;
        $95 = HEAPU8[($2 + 339 | 0) >> 0] | 0 | ((HEAPU8[($2 + 340 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 341 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 342 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 203 | 0) >> 0] = $95;
        HEAP8[($2 + 204 | 0) >> 0] = $95 >>> 8 | 0;
        HEAP8[($2 + 205 | 0) >> 0] = $95 >>> 16 | 0;
        HEAP8[($2 + 206 | 0) >> 0] = $95 >>> 24 | 0;
        HEAP32[($2 + 200 | 0) >> 2] = HEAP32[($2 + 336 | 0) >> 2] | 0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$1 = HEAP32[($2 + 312 | 0) >> 2] | 0;
        i64toi32_i32$3 = HEAP32[($2 + 316 | 0) >> 2] | 0;
        $349 = i64toi32_i32$1;
        i64toi32_i32$1 = $2;
        HEAP32[($2 + 176 | 0) >> 2] = $349;
        HEAP32[($2 + 180 | 0) >> 2] = i64toi32_i32$3;
        i64toi32_i32$2 = $2;
        i64toi32_i32$3 = HEAP32[($2 + 296 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 300 | 0) >> 2] | 0;
        $352 = i64toi32_i32$3;
        i64toi32_i32$3 = $2;
        HEAP32[($2 + 160 | 0) >> 2] = $352;
        HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
        if (($10 | 0) != (19 | 0)) {
         break label$4
        }
        break label$3;
       }
       i64toi32_i32$2 = $2 + 376 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $359 = i64toi32_i32$1;
       i64toi32_i32$1 = $2 + 184 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $359;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
       i64toi32_i32$2 = $2 + 384 | 0;
       i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $365 = i64toi32_i32$3;
       i64toi32_i32$3 = ($2 + 176 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$3 >> 2] = $365;
       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $2 + 368 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $369 = i64toi32_i32$1;
       i64toi32_i32$1 = $2;
       HEAP32[($2 + 176 | 0) >> 2] = $369;
       HEAP32[($2 + 180 | 0) >> 2] = i64toi32_i32$3;
       $10 = 2;
       break label$4;
      }
      i64toi32_i32$2 = $2 + 376 | 0;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $374 = i64toi32_i32$3;
      i64toi32_i32$3 = $2 + 184 | 0;
      HEAP32[i64toi32_i32$3 >> 2] = $374;
      HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $2 + 384 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $380 = i64toi32_i32$1;
      i64toi32_i32$1 = ($2 + 176 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $380;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
      i64toi32_i32$2 = $2 + 368 | 0;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $384 = i64toi32_i32$3;
      i64toi32_i32$3 = $2;
      HEAP32[($2 + 176 | 0) >> 2] = $384;
      HEAP32[($2 + 180 | 0) >> 2] = i64toi32_i32$1;
     }
     i64toi32_i32$1 = $20$hi;
     i64toi32_i32$3 = ($2 + 344 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $20;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $21$hi;
     i64toi32_i32$3 = ($2 + 344 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $21;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAP32[($2 + 176 | 0) >> 2] | 0;
     i64toi32_i32$3 = HEAP32[($2 + 180 | 0) >> 2] | 0;
     $396 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 368 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $396;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$2 = $2;
     i64toi32_i32$3 = HEAP32[($2 + 160 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 164 | 0) >> 2] | 0;
     $400 = i64toi32_i32$3;
     i64toi32_i32$3 = $2 + 396 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $400;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = ($2 + 176 | 0) + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $406 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 376 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $406;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$2 = ($2 + 176 | 0) + 16 | 0;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $412 = i64toi32_i32$3;
     i64toi32_i32$3 = $2 + 384 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $412;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($2 + 404 | 0) >> 2] = HEAP32[(($2 + 160 | 0) + 8 | 0) >> 2] | 0;
     HEAP8[($2 + 344 | 0) >> 0] = $10;
     $96 = HEAP32[($2 + 200 | 0) >> 2] | 0;
     HEAP8[($2 + 345 | 0) >> 0] = $96;
     HEAP8[($2 + 346 | 0) >> 0] = $96 >>> 8 | 0;
     HEAP8[($2 + 347 | 0) >> 0] = $96 >>> 16 | 0;
     HEAP8[($2 + 348 | 0) >> 0] = $96 >>> 24 | 0;
     $98 = HEAPU8[($2 + 203 | 0) >> 0] | 0 | ((HEAPU8[($2 + 204 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 205 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 206 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($2 + 348 | 0) >> 0] = $98;
     HEAP8[($2 + 349 | 0) >> 0] = $98 >>> 8 | 0;
     HEAP8[($2 + 350 | 0) >> 0] = $98 >>> 16 | 0;
     HEAP8[($2 + 351 | 0) >> 0] = $98 >>> 24 | 0;
     HEAP32[($2 + 392 | 0) >> 2] = $3;
     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($2 + 96 | 0 | 0, $2 + 344 | 0 | 0, 1066304 | 0, 13 | 0);
     $5 = HEAPU8[($2 + 96 | 0) >> 0] | 0;
     if (($5 | 0) != (19 | 0)) {
      break label$2
     }
    }
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
    i64toi32_i32$3 = HEAP32[($2 + 20 | 0) >> 2] | 0;
    $439 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $439;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$3;
    HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = HEAP32[($2 + 24 | 0) >> 2] | 0;
    $3 = 0;
    break label$1;
   }
   $3 = 1;
   memcpy($2 + 33 | 0 | 0, $2 + 96 | 0 | 1 | 0 | 0, 63 | 0) | 0;
   HEAP8[($0 + 8 | 0) >> 0] = $5;
   memcpy($0 + 9 | 0 | 0, $2 + 33 | 0 | 0, 63 | 0) | 0;
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hdd0c057252922c46($2 + 16 | 0 | 0);
  }
  HEAP32[$0 >> 2] = $3;
  global$0 = $2 + 448 | 0;
 }
 
 function cbor_event__de__Deserializer_R___cbor_len__hc68764db78e73af0($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $2 = 0, $4 = 0, $5 = 0, $3 = 0, $6 = 0, $6$hi = 0, $7 = 0, $7$hi = 0, $8 = 0, $8$hi = 0, $9 = 0, $9$hi = 0, $84 = 0, $85 = 0, $86 = 0, $87 = 0, $88 = 0, $89 = 0, $90 = 0, $91 = 0, $92 = 0, $93 = 0, $94 = 0, $95 = 0, $96 = 0, $97 = 0, $98 = 0, $67 = 0, $111 = 0, $112 = 0, $112$hi = 0, $114$hi = 0, $115 = 0, $118 = 0, $126 = 0, $132 = 0, $138 = 0, $142 = 0, $201 = 0, $202 = 0, $202$hi = 0, $204 = 0, $204$hi = 0, $206$hi = 0, $207 = 0, $207$hi = 0, $209$hi = 0, $210 = 0, $210$hi = 0, $211 = 0, $214 = 0, $222 = 0, $228 = 0, $234 = 0, $238 = 0, $10 = 0, $10$hi = 0, $11 = 0, $11$hi = 0, $12 = 0, $12$hi = 0, $13 = 0, $13$hi = 0, $349 = 0, $350 = 0, $350$hi = 0, $352 = 0, $352$hi = 0, $354$hi = 0, $355 = 0, $355$hi = 0, $357$hi = 0, $358 = 0, $358$hi = 0, $360$hi = 0, $361 = 0, $361$hi = 0, $363$hi = 0, $364 = 0, $364$hi = 0, $366$hi = 0, $367 = 0, $367$hi = 0, $369$hi = 0, $370 = 0, $370$hi = 0, $371 = 0, $374 = 0, $382 = 0, $388 = 0, $394 = 0, $398 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  std__io__cursor__Cursor_T___remaining_slice__h5de2a0dd397eef35($2 + 120 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           label$10 : {
            $3 = HEAP32[($2 + 124 | 0) >> 2] | 0;
            if (!$3) {
             break label$10
            }
            $4 = HEAP32[($2 + 120 | 0) >> 2] | 0;
            if (!$4) {
             break label$10
            }
            $3 = (HEAPU8[$4 >> 0] | 0) & 31 | 0;
            if ($3 >>> 0 < 24 >>> 0) {
             break label$9
            }
            switch ($3 + -24 | 0 | 0) {
            case 7:
             break label$3;
            case 3:
             break label$4;
            case 2:
             break label$5;
            case 1:
             break label$6;
            case 0:
             break label$7;
            default:
             break label$8;
            };
           }
           HEAP8[($0 + 8 | 0) >> 0] = 8;
           i64toi32_i32$1 = $0;
           i64toi32_i32$0 = 0;
           HEAP32[i64toi32_i32$1 >> 2] = 1;
           HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
           HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = 0;
           HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = $3;
           break label$1;
          }
          i64toi32_i32$1 = $0;
          i64toi32_i32$0 = 0;
          HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = 1;
          HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
          i64toi32_i32$0 = 0;
          HEAP32[i64toi32_i32$1 >> 2] = 0;
          HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
          HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = 0;
          i64toi32_i32$0 = 0;
          i64toi32_i32$1 = i64toi32_i32$1 + 16 | 0;
          HEAP32[i64toi32_i32$1 >> 2] = $3;
          HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
          break label$1;
         }
         label$11 : {
          if ($3 >>> 0 < 28 >>> 0) {
           break label$11
          }
          if (($3 | 0) != (31 | 0)) {
           break label$2
          }
         }
         core__panicking__panic__h2fd385a887c8bf13(1054592 | 0, 40 | 0, 1054740 | 0);
         abort();
        }
        std__io__cursor__Cursor_T___remaining_slice__h5de2a0dd397eef35($2 | 0, $1 | 0);
        label$12 : {
         label$13 : {
          $3 = HEAP32[($2 + 4 | 0) >> 2] | 0;
          if ($3 >>> 0 < 2 >>> 0) {
           break label$13
          }
          $1 = HEAP32[$2 >> 2] | 0;
          if (!$1) {
           break label$13
          }
          i64toi32_i32$2 = $1;
          i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0;
          i64toi32_i32$1 = 0;
          $67 = i64toi32_i32$0;
          i64toi32_i32$0 = $0 + 16 | 0;
          HEAP32[i64toi32_i32$0 >> 2] = $67;
          HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
          $1 = $0 + 24 | 0;
          i64toi32_i32$1 = 0;
          $6 = 0;
          $6$hi = i64toi32_i32$1;
          i64toi32_i32$1 = 0;
          $7 = 1;
          $7$hi = i64toi32_i32$1;
          break label$12;
         }
         $1 = $0 + 16 | 0;
         i64toi32_i32$1 = 0;
         i64toi32_i32$2 = $3;
         i64toi32_i32$0 = 0;
         i64toi32_i32$3 = 32;
         i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
          i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
          $84 = 0;
         } else {
          i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
          $84 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
         }
         i64toi32_i32$1 = $84;
         i64toi32_i32$2 = 0;
         i64toi32_i32$3 = 8;
         i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
         $7 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
         $7$hi = i64toi32_i32$2;
         i64toi32_i32$2 = 0;
         $6 = 1;
         $6$hi = i64toi32_i32$2;
        }
        i64toi32_i32$2 = $7$hi;
        i64toi32_i32$1 = $0;
        HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $7;
        HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$2;
        HEAP32[$1 >> 2] = 1;
        i64toi32_i32$2 = $6$hi;
        HEAP32[i64toi32_i32$1 >> 2] = $6;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
        break label$1;
       }
       std__io__cursor__Cursor_T___remaining_slice__h5de2a0dd397eef35($2 + 16 | 0 | 0, $1 | 0);
       $3 = 1;
       label$14 : {
        label$15 : {
         $4 = HEAP32[($2 + 20 | 0) >> 2] | 0;
         if ($4 >>> 0 < 2 >>> 0) {
          break label$15
         }
         $5 = HEAP32[($2 + 16 | 0) >> 2] | 0;
         if (!$5) {
          break label$15
         }
         i64toi32_i32$0 = $5;
         i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0;
         i64toi32_i32$1 = 0;
         $6 = i64toi32_i32$2;
         $6$hi = i64toi32_i32$1;
         std__io__cursor__Cursor_T___remaining_slice__h5de2a0dd397eef35($2 + 8 | 0 | 0, $1 | 0);
         $3 = 2;
         $4 = HEAP32[($2 + 12 | 0) >> 2] | 0;
         if ($4 >>> 0 < 3 >>> 0) {
          break label$15
         }
         $1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
         if (!$1) {
          break label$15
         }
         i64toi32_i32$0 = $1;
         i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0;
         i64toi32_i32$2 = 0;
         $7 = i64toi32_i32$1;
         $7$hi = i64toi32_i32$2;
         HEAP32[($0 + 24 | 0) >> 2] = 2;
         i64toi32_i32$1 = $0;
         i64toi32_i32$2 = 0;
         HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = 1;
         HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$2;
         $111 = i64toi32_i32$1 + 16 | 0;
         i64toi32_i32$2 = $7$hi;
         $112 = $7;
         $112$hi = i64toi32_i32$2;
         i64toi32_i32$2 = $6$hi;
         i64toi32_i32$0 = $6;
         i64toi32_i32$1 = 0;
         i64toi32_i32$3 = 8;
         i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
          i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
          $85 = 0;
         } else {
          i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
          $85 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
         }
         $114$hi = i64toi32_i32$1;
         i64toi32_i32$1 = $112$hi;
         i64toi32_i32$2 = $112;
         i64toi32_i32$0 = $114$hi;
         i64toi32_i32$3 = $85;
         i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
         $115 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
         i64toi32_i32$2 = $111;
         HEAP32[i64toi32_i32$2 >> 2] = $115;
         HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$0 = 0;
         $6 = 0;
         $6$hi = i64toi32_i32$0;
         break label$14;
        }
        i64toi32_i32$1 = $2;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 136 | 0) >> 2] | 0;
        $118 = i64toi32_i32$0;
        i64toi32_i32$0 = $0;
        HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = $118;
        HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = i64toi32_i32$2;
        HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $3;
        i64toi32_i32$1 = i64toi32_i32$1 + 140 | 0;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
        $126 = i64toi32_i32$2;
        i64toi32_i32$2 = $0 + 28 | 0;
        HEAP32[i64toi32_i32$2 >> 2] = $126;
        HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$1 = ($2 + 132 | 0) + 16 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
        $132 = i64toi32_i32$0;
        i64toi32_i32$0 = $0 + 36 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $132;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
        HEAP32[($0 + 44 | 0) >> 2] = HEAP32[($2 + 156 | 0) >> 2] | 0;
        $138 = $0;
        i64toi32_i32$2 = 0;
        i64toi32_i32$1 = $4;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 32;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
         $86 = 0;
        } else {
         i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
         $86 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        }
        i64toi32_i32$2 = $86;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 8;
        i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
        $142 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
        i64toi32_i32$2 = $138;
        HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $142;
        HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$1 = 0;
        $6 = 1;
        $6$hi = i64toi32_i32$1;
       }
       i64toi32_i32$1 = $6$hi;
       i64toi32_i32$2 = $0;
       HEAP32[i64toi32_i32$2 >> 2] = $6;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       break label$1;
      }
      std__io__cursor__Cursor_T___remaining_slice__h5de2a0dd397eef35($2 + 48 | 0 | 0, $1 | 0);
      $3 = 1;
      label$16 : {
       label$17 : {
        $4 = HEAP32[($2 + 52 | 0) >> 2] | 0;
        if ($4 >>> 0 < 2 >>> 0) {
         break label$17
        }
        $5 = HEAP32[($2 + 48 | 0) >> 2] | 0;
        if (!$5) {
         break label$17
        }
        i64toi32_i32$0 = $5;
        i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0;
        i64toi32_i32$2 = 0;
        $6 = i64toi32_i32$1;
        $6$hi = i64toi32_i32$2;
        std__io__cursor__Cursor_T___remaining_slice__h5de2a0dd397eef35($2 + 40 | 0 | 0, $1 | 0);
        $3 = 2;
        $4 = HEAP32[($2 + 44 | 0) >> 2] | 0;
        if ($4 >>> 0 < 3 >>> 0) {
         break label$17
        }
        $5 = HEAP32[($2 + 40 | 0) >> 2] | 0;
        if (!$5) {
         break label$17
        }
        i64toi32_i32$0 = $5;
        i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0;
        i64toi32_i32$1 = 0;
        $7 = i64toi32_i32$2;
        $7$hi = i64toi32_i32$1;
        std__io__cursor__Cursor_T___remaining_slice__h5de2a0dd397eef35($2 + 32 | 0 | 0, $1 | 0);
        $3 = 3;
        $4 = HEAP32[($2 + 36 | 0) >> 2] | 0;
        if ($4 >>> 0 < 4 >>> 0) {
         break label$17
        }
        $5 = HEAP32[($2 + 32 | 0) >> 2] | 0;
        if (!$5) {
         break label$17
        }
        i64toi32_i32$0 = $5;
        i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0;
        i64toi32_i32$2 = 0;
        $8 = i64toi32_i32$1;
        $8$hi = i64toi32_i32$2;
        std__io__cursor__Cursor_T___remaining_slice__h5de2a0dd397eef35($2 + 24 | 0 | 0, $1 | 0);
        $3 = 4;
        $4 = HEAP32[($2 + 28 | 0) >> 2] | 0;
        if ($4 >>> 0 < 5 >>> 0) {
         break label$17
        }
        $1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
        if (!$1) {
         break label$17
        }
        i64toi32_i32$0 = $1;
        i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0;
        i64toi32_i32$1 = 0;
        $9 = i64toi32_i32$2;
        $9$hi = i64toi32_i32$1;
        HEAP32[($0 + 24 | 0) >> 2] = 4;
        i64toi32_i32$2 = $0;
        i64toi32_i32$1 = 0;
        HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = 1;
        HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$1;
        $201 = i64toi32_i32$2 + 16 | 0;
        i64toi32_i32$1 = $9$hi;
        $202 = $9;
        $202$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $7$hi;
        i64toi32_i32$0 = $7;
        i64toi32_i32$2 = 0;
        i64toi32_i32$3 = 16;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
         $87 = 0;
        } else {
         i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
         $87 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        }
        $204 = $87;
        $204$hi = i64toi32_i32$2;
        i64toi32_i32$2 = $6$hi;
        i64toi32_i32$1 = $6;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 24;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
         $88 = 0;
        } else {
         i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
         $88 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        }
        $206$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $204$hi;
        i64toi32_i32$2 = $204;
        i64toi32_i32$1 = $206$hi;
        i64toi32_i32$3 = $88;
        i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
        $207 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
        $207$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $8$hi;
        i64toi32_i32$0 = $8;
        i64toi32_i32$2 = 0;
        i64toi32_i32$3 = 8;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
         $89 = 0;
        } else {
         i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
         $89 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        }
        $209$hi = i64toi32_i32$2;
        i64toi32_i32$2 = $207$hi;
        i64toi32_i32$1 = $207;
        i64toi32_i32$0 = $209$hi;
        i64toi32_i32$3 = $89;
        i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
        $210 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
        $210$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $202$hi;
        i64toi32_i32$2 = $202;
        i64toi32_i32$1 = $210$hi;
        i64toi32_i32$3 = $210;
        i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
        $211 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
        i64toi32_i32$2 = $201;
        HEAP32[i64toi32_i32$2 >> 2] = $211;
        HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$1 = 0;
        $6 = 0;
        $6$hi = i64toi32_i32$1;
        break label$16;
       }
       i64toi32_i32$0 = $2;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 132 | 0) >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 136 | 0) >> 2] | 0;
       $214 = i64toi32_i32$1;
       i64toi32_i32$1 = $0;
       HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = $214;
       HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = i64toi32_i32$2;
       HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $3;
       i64toi32_i32$0 = i64toi32_i32$0 + 140 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
       $222 = i64toi32_i32$2;
       i64toi32_i32$2 = $0 + 28 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $222;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$0 = ($2 + 132 | 0) + 16 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
       $228 = i64toi32_i32$1;
       i64toi32_i32$1 = $0 + 36 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $228;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
       HEAP32[($0 + 44 | 0) >> 2] = HEAP32[($2 + 156 | 0) >> 2] | 0;
       $234 = $0;
       i64toi32_i32$2 = 0;
       i64toi32_i32$0 = $4;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $90 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
        $90 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       i64toi32_i32$2 = $90;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 8;
       i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
       $238 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       i64toi32_i32$2 = $234;
       HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $238;
       HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       $6 = 1;
       $6$hi = i64toi32_i32$0;
      }
      i64toi32_i32$0 = $6$hi;
      i64toi32_i32$2 = $0;
      HEAP32[i64toi32_i32$2 >> 2] = $6;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
      break label$1;
     }
     std__io__cursor__Cursor_T___remaining_slice__h5de2a0dd397eef35($2 + 112 | 0 | 0, $1 | 0);
     $3 = 1;
     label$18 : {
      label$19 : {
       $4 = HEAP32[($2 + 116 | 0) >> 2] | 0;
       if ($4 >>> 0 < 2 >>> 0) {
        break label$19
       }
       $5 = HEAP32[($2 + 112 | 0) >> 2] | 0;
       if (!$5) {
        break label$19
       }
       i64toi32_i32$1 = $5;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0;
       i64toi32_i32$2 = 0;
       $6 = i64toi32_i32$0;
       $6$hi = i64toi32_i32$2;
       std__io__cursor__Cursor_T___remaining_slice__h5de2a0dd397eef35($2 + 104 | 0 | 0, $1 | 0);
       $3 = 2;
       $4 = HEAP32[($2 + 108 | 0) >> 2] | 0;
       if ($4 >>> 0 < 3 >>> 0) {
        break label$19
       }
       $5 = HEAP32[($2 + 104 | 0) >> 2] | 0;
       if (!$5) {
        break label$19
       }
       i64toi32_i32$1 = $5;
       i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0;
       i64toi32_i32$0 = 0;
       $7 = i64toi32_i32$2;
       $7$hi = i64toi32_i32$0;
       std__io__cursor__Cursor_T___remaining_slice__h5de2a0dd397eef35($2 + 96 | 0 | 0, $1 | 0);
       $3 = 3;
       $4 = HEAP32[($2 + 100 | 0) >> 2] | 0;
       if ($4 >>> 0 < 4 >>> 0) {
        break label$19
       }
       $5 = HEAP32[($2 + 96 | 0) >> 2] | 0;
       if (!$5) {
        break label$19
       }
       i64toi32_i32$1 = $5;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0;
       i64toi32_i32$2 = 0;
       $8 = i64toi32_i32$0;
       $8$hi = i64toi32_i32$2;
       std__io__cursor__Cursor_T___remaining_slice__h5de2a0dd397eef35($2 + 88 | 0 | 0, $1 | 0);
       $3 = 4;
       $4 = HEAP32[($2 + 92 | 0) >> 2] | 0;
       if ($4 >>> 0 < 5 >>> 0) {
        break label$19
       }
       $5 = HEAP32[($2 + 88 | 0) >> 2] | 0;
       if (!$5) {
        break label$19
       }
       i64toi32_i32$1 = $5;
       i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0;
       i64toi32_i32$0 = 0;
       $9 = i64toi32_i32$2;
       $9$hi = i64toi32_i32$0;
       std__io__cursor__Cursor_T___remaining_slice__h5de2a0dd397eef35($2 + 80 | 0 | 0, $1 | 0);
       $3 = 5;
       $4 = HEAP32[($2 + 84 | 0) >> 2] | 0;
       if ($4 >>> 0 < 6 >>> 0) {
        break label$19
       }
       $5 = HEAP32[($2 + 80 | 0) >> 2] | 0;
       if (!$5) {
        break label$19
       }
       i64toi32_i32$1 = $5;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0;
       i64toi32_i32$2 = 0;
       $10 = i64toi32_i32$0;
       $10$hi = i64toi32_i32$2;
       std__io__cursor__Cursor_T___remaining_slice__h5de2a0dd397eef35($2 + 72 | 0 | 0, $1 | 0);
       $3 = 6;
       $4 = HEAP32[($2 + 76 | 0) >> 2] | 0;
       if ($4 >>> 0 < 7 >>> 0) {
        break label$19
       }
       $5 = HEAP32[($2 + 72 | 0) >> 2] | 0;
       if (!$5) {
        break label$19
       }
       i64toi32_i32$1 = $5;
       i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0;
       i64toi32_i32$0 = 0;
       $11 = i64toi32_i32$2;
       $11$hi = i64toi32_i32$0;
       std__io__cursor__Cursor_T___remaining_slice__h5de2a0dd397eef35($2 + 64 | 0 | 0, $1 | 0);
       $3 = 7;
       $4 = HEAP32[($2 + 68 | 0) >> 2] | 0;
       if ($4 >>> 0 < 8 >>> 0) {
        break label$19
       }
       $5 = HEAP32[($2 + 64 | 0) >> 2] | 0;
       if (!$5) {
        break label$19
       }
       i64toi32_i32$1 = $5;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0;
       i64toi32_i32$2 = 0;
       $12 = i64toi32_i32$0;
       $12$hi = i64toi32_i32$2;
       std__io__cursor__Cursor_T___remaining_slice__h5de2a0dd397eef35($2 + 56 | 0 | 0, $1 | 0);
       $3 = 8;
       $4 = HEAP32[($2 + 60 | 0) >> 2] | 0;
       if ($4 >>> 0 < 9 >>> 0) {
        break label$19
       }
       $1 = HEAP32[($2 + 56 | 0) >> 2] | 0;
       if (!$1) {
        break label$19
       }
       i64toi32_i32$1 = $1;
       i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 8 | 0) >> 0] | 0;
       i64toi32_i32$0 = 0;
       $13 = i64toi32_i32$2;
       $13$hi = i64toi32_i32$0;
       HEAP32[($0 + 24 | 0) >> 2] = 8;
       i64toi32_i32$2 = $0;
       i64toi32_i32$0 = 0;
       HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = 1;
       HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$0;
       $349 = i64toi32_i32$2 + 16 | 0;
       i64toi32_i32$0 = $13$hi;
       $350 = $13;
       $350$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $7$hi;
       i64toi32_i32$1 = $7;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 48;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        $91 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
        $91 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       }
       $352 = $91;
       $352$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $6$hi;
       i64toi32_i32$0 = $6;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 56;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $92 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
        $92 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       $354$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $352$hi;
       i64toi32_i32$2 = $352;
       i64toi32_i32$0 = $354$hi;
       i64toi32_i32$3 = $92;
       i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
       $355 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       $355$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $8$hi;
       i64toi32_i32$1 = $8;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 40;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        $93 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
        $93 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       }
       $357$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $355$hi;
       i64toi32_i32$0 = $355;
       i64toi32_i32$1 = $357$hi;
       i64toi32_i32$3 = $93;
       i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
       $358 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
       $358$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $9$hi;
       i64toi32_i32$2 = $9;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $94 = 0;
       } else {
        i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $94 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       $360$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $358$hi;
       i64toi32_i32$1 = $358;
       i64toi32_i32$2 = $360$hi;
       i64toi32_i32$3 = $94;
       i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
       $361 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       $361$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $10$hi;
       i64toi32_i32$0 = $10;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 24;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $95 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
        $95 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       $363$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $361$hi;
       i64toi32_i32$2 = $361;
       i64toi32_i32$0 = $363$hi;
       i64toi32_i32$3 = $95;
       i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
       $364 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       $364$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $11$hi;
       i64toi32_i32$1 = $11;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        $96 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
        $96 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       }
       $366$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $364$hi;
       i64toi32_i32$0 = $364;
       i64toi32_i32$1 = $366$hi;
       i64toi32_i32$3 = $96;
       i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
       $367 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
       $367$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $12$hi;
       i64toi32_i32$2 = $12;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 8;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $97 = 0;
       } else {
        i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $97 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       $369$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $367$hi;
       i64toi32_i32$1 = $367;
       i64toi32_i32$2 = $369$hi;
       i64toi32_i32$3 = $97;
       i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
       $370 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       $370$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $350$hi;
       i64toi32_i32$0 = $350;
       i64toi32_i32$1 = $370$hi;
       i64toi32_i32$3 = $370;
       i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
       $371 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
       i64toi32_i32$0 = $349;
       HEAP32[i64toi32_i32$0 >> 2] = $371;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$1 = 0;
       $6 = 0;
       $6$hi = i64toi32_i32$1;
       break label$18;
      }
      i64toi32_i32$2 = $2;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 132 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 136 | 0) >> 2] | 0;
      $374 = i64toi32_i32$1;
      i64toi32_i32$1 = $0;
      HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = $374;
      HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $3;
      i64toi32_i32$2 = i64toi32_i32$2 + 140 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $382 = i64toi32_i32$0;
      i64toi32_i32$0 = $0 + 28 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $382;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = ($2 + 132 | 0) + 16 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $388 = i64toi32_i32$1;
      i64toi32_i32$1 = $0 + 36 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $388;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[($0 + 44 | 0) >> 2] = HEAP32[($2 + 156 | 0) >> 2] | 0;
      $394 = $0;
      i64toi32_i32$0 = 0;
      i64toi32_i32$2 = $4;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 32;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       $98 = 0;
      } else {
       i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
       $98 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
      }
      i64toi32_i32$0 = $98;
      i64toi32_i32$2 = 0;
      i64toi32_i32$3 = 8;
      i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
      $398 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
      i64toi32_i32$0 = $394;
      HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $398;
      HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$2 = 0;
      $6 = 1;
      $6$hi = i64toi32_i32$2;
     }
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$0 = $0;
     HEAP32[i64toi32_i32$0 >> 2] = $6;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
     break label$1;
    }
    i64toi32_i32$0 = $0;
    i64toi32_i32$2 = 0;
    HEAP32[i64toi32_i32$0 >> 2] = 0;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = 0;
    i64toi32_i32$0 = i64toi32_i32$0 + 8 | 0;
    i64toi32_i32$2 = 0;
    HEAP32[i64toi32_i32$0 >> 2] = 0;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    break label$1;
   }
   HEAP8[($0 + 8 | 0) >> 0] = 11;
   i64toi32_i32$0 = $0;
   i64toi32_i32$2 = 0;
   HEAP32[i64toi32_i32$0 >> 2] = 1;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   HEAP8[(i64toi32_i32$0 + 9 | 0) >> 0] = $3;
  }
  global$0 = $2 + 160 | 0;
 }
 
 function $cardano_serialization_lib__plutus__PlutusDataEnum_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hb5386eba8d42c5df($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, i64toi32_i32$2 = 0, $16 = 0, $16$hi = 0, $3 = 0, $17 = 0, $18 = 0, $5 = 0, $6 = 0, $7 = 0, $8 = 0, $9 = 0, $10 = 0, $11 = 0, $12 = 0, $13 = 0, $14 = 0, $17$hi = 0, $18$hi = 0, $106 = 0, $113 = 0, $116 = 0, $119 = 0, $124 = 0, $248 = 0, $258 = 0, $263 = 0, $266 = 0, $271 = 0, $274 = 0, $282 = 0, $287 = 0, $292 = 0, $297 = 0, $314 = 0, $322 = 0, $335 = 0, $341 = 0, $349 = 0, $353 = 0, $358 = 0, $15 = 0, $363 = 0, $366 = 0, $372 = 0, $375 = 0, $378 = 0, $381 = 0, $386 = 0, $397 = 0, $402 = 0, $407 = 0;
  $2 = global$0 - 256 | 0;
  global$0 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 184 | 0) >> 2] = 2;
  HEAP32[($2 + 188 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 192 | 0) >> 2] = 0;
  HEAP32[($2 + 196 | 0) >> 2] = i64toi32_i32$0;
  $std__io__cursor__Cursor_T__20as_20std__io__Seek___seek__h4fe82da83d4d5304($2 + 40 | 0 | 0, $1 | 0, $2 + 184 | 0 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           label$10 : {
            if ((HEAP32[($2 + 40 | 0) >> 2] | 0 | 0) == (1 | 0)) {
             break label$10
            }
            $3 = ($2 + 40 | 0) + 8 | 0;
            i64toi32_i32$2 = $3;
            i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
            i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
            $16 = i64toi32_i32$0;
            $16$hi = i64toi32_i32$1;
            $cardano_serialization_lib__plutus__ConstrPlutusData_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h5b3b55e53d3f2947($2 + 184 | 0 | 0, $1 | 0);
            $4 = ($2 + 184 | 0) + 8 | 0;
            label$11 : {
             i64toi32_i32$2 = $2;
             i64toi32_i32$1 = HEAP32[($2 + 184 | 0) >> 2] | 0;
             i64toi32_i32$0 = HEAP32[($2 + 188 | 0) >> 2] | 0;
             i64toi32_i32$2 = i64toi32_i32$1;
             i64toi32_i32$1 = 0;
             i64toi32_i32$3 = 1;
             if ((i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | 0) {
              break label$11
             }
             memcpy($2 + 112 | 0 | 0, $4 | 0, 64 | 0) | 0;
             $4 = memcpy($3 | 0, $2 + 112 | 0 | 0, 64 | 0) | 0;
             i64toi32_i32$0 = $2;
             i64toi32_i32$2 = 0;
             HEAP32[($2 + 40 | 0) >> 2] = 1;
             HEAP32[($2 + 44 | 0) >> 2] = i64toi32_i32$2;
             i64toi32_i32$0 = $2;
             i64toi32_i32$2 = 0;
             HEAP32[($2 + 184 | 0) >> 2] = 0;
             HEAP32[($2 + 188 | 0) >> 2] = i64toi32_i32$2;
             i64toi32_i32$2 = $16$hi;
             i64toi32_i32$0 = $2;
             HEAP32[($2 + 192 | 0) >> 2] = $16;
             HEAP32[($2 + 196 | 0) >> 2] = i64toi32_i32$2;
             $std__io__cursor__Cursor_T__20as_20std__io__Seek___seek__h4fe82da83d4d5304($2 + 112 | 0 | 0, $1 | 0, $2 + 184 | 0 | 0);
             if ((HEAP32[($2 + 112 | 0) >> 2] | 0 | 0) == (1 | 0)) {
              break label$9
             }
             i64toi32_i32$3 = $2;
             i64toi32_i32$2 = HEAP32[($2 + 40 | 0) >> 2] | 0;
             i64toi32_i32$0 = HEAP32[($2 + 44 | 0) >> 2] | 0;
             i64toi32_i32$3 = i64toi32_i32$2;
             i64toi32_i32$2 = 0;
             i64toi32_i32$1 = 0;
             if ((i64toi32_i32$3 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$2 | 0) | 0) {
              break label$8
             }
             break label$7;
            }
            i64toi32_i32$1 = $4 + 8 | 0;
            i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
            i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
            $16 = i64toi32_i32$3;
            $16$hi = i64toi32_i32$0;
            i64toi32_i32$3 = ($2 + 40 | 0) + 16 | 0;
            HEAP32[i64toi32_i32$3 >> 2] = $16;
            HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
            i64toi32_i32$1 = $4 + 16 | 0;
            i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
            i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
            $17 = i64toi32_i32$0;
            $17$hi = i64toi32_i32$3;
            i64toi32_i32$0 = ($2 + 40 | 0) + 24 | 0;
            HEAP32[i64toi32_i32$0 >> 2] = $17;
            HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
            i64toi32_i32$1 = $4;
            i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
            i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
            $18 = i64toi32_i32$3;
            $18$hi = i64toi32_i32$0;
            i64toi32_i32$3 = $2;
            HEAP32[($2 + 48 | 0) >> 2] = $18;
            HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$0;
            i64toi32_i32$0 = $17$hi;
            i64toi32_i32$3 = $2 + 204 | 0;
            HEAP32[i64toi32_i32$3 >> 2] = $17;
            HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
            i64toi32_i32$0 = $16$hi;
            i64toi32_i32$3 = $2 + 196 | 0;
            HEAP32[i64toi32_i32$3 >> 2] = $16;
            HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
            HEAP32[(($2 + 8 | 0) + 24 | 0) >> 2] = HEAP32[(($2 + 184 | 0) + 24 | 0) >> 2] | 0;
            i64toi32_i32$1 = ($2 + 184 | 0) + 16 | 0;
            i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
            i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
            $106 = i64toi32_i32$0;
            i64toi32_i32$0 = ($2 + 8 | 0) + 16 | 0;
            HEAP32[i64toi32_i32$0 >> 2] = $106;
            HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
            i64toi32_i32$3 = $18$hi;
            i64toi32_i32$0 = $2;
            HEAP32[($2 + 188 | 0) >> 2] = $18;
            HEAP32[($2 + 192 | 0) >> 2] = i64toi32_i32$3;
            i64toi32_i32$1 = $4;
            i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
            i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
            $113 = i64toi32_i32$3;
            i64toi32_i32$3 = ($2 + 8 | 0) + 8 | 0;
            HEAP32[i64toi32_i32$3 >> 2] = $113;
            HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
            i64toi32_i32$1 = $2;
            i64toi32_i32$0 = HEAP32[($2 + 184 | 0) >> 2] | 0;
            i64toi32_i32$3 = HEAP32[($2 + 188 | 0) >> 2] | 0;
            $116 = i64toi32_i32$0;
            i64toi32_i32$0 = $2;
            HEAP32[($2 + 8 | 0) >> 2] = $116;
            HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$3;
            $4 = 0;
            break label$6;
           }
           i64toi32_i32$1 = $2;
           i64toi32_i32$3 = HEAP32[($2 + 44 | 0) >> 2] | 0;
           i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
           $119 = i64toi32_i32$3;
           i64toi32_i32$3 = $2;
           HEAP32[($2 + 184 | 0) >> 2] = $119;
           HEAP32[($2 + 188 | 0) >> 2] = i64toi32_i32$0;
           core__result__unwrap_failed__h27f43d993c3864a1(1070651 | 0, 43 | 0, $2 + 184 | 0 | 0, 1070696 | 0, 1071004 | 0);
           abort();
          }
          i64toi32_i32$1 = $2;
          i64toi32_i32$0 = HEAP32[($2 + 116 | 0) >> 2] | 0;
          i64toi32_i32$3 = HEAP32[($2 + 120 | 0) >> 2] | 0;
          $124 = i64toi32_i32$0;
          i64toi32_i32$0 = $2;
          HEAP32[($2 + 184 | 0) >> 2] = $124;
          HEAP32[($2 + 188 | 0) >> 2] = i64toi32_i32$3;
          core__result__unwrap_failed__h27f43d993c3864a1(1070651 | 0, 43 | 0, $2 + 184 | 0 | 0, 1070696 | 0, 1071020 | 0);
          abort();
         }
         core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9_3($4 | 0);
        }
        $cardano_serialization_lib__plutus__PlutusMap_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h76a53e332887551d($2 + 184 | 0 | 0, $1 | 0);
        $4 = 1;
        label$12 : {
         if ((HEAP32[($2 + 184 | 0) >> 2] | 0 | 0) != (1 | 0)) {
          break label$12
         }
         $4 = memcpy(($2 + 40 | 0) + 8 | 0 | 0, memcpy($2 + 112 | 0 | 4 | 0 | 0, ($2 + 184 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
         HEAP32[($2 + 40 | 0) >> 2] = 1;
         i64toi32_i32$0 = $2;
         i64toi32_i32$3 = 0;
         HEAP32[($2 + 184 | 0) >> 2] = 0;
         HEAP32[($2 + 188 | 0) >> 2] = i64toi32_i32$3;
         i64toi32_i32$3 = $16$hi;
         i64toi32_i32$0 = $2;
         HEAP32[($2 + 192 | 0) >> 2] = $16;
         HEAP32[($2 + 196 | 0) >> 2] = i64toi32_i32$3;
         $std__io__cursor__Cursor_T__20as_20std__io__Seek___seek__h4fe82da83d4d5304($2 + 112 | 0 | 0, $1 | 0, $2 + 184 | 0 | 0);
         if ((HEAP32[($2 + 112 | 0) >> 2] | 0 | 0) == (1 | 0)) {
          break label$3
         }
         core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9_3($4 | 0);
         $cardano_serialization_lib__plutus__PlutusList_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hfdf263ce80660b6e($2 + 184 | 0 | 0, $1 | 0);
         label$13 : {
          if ((HEAP32[($2 + 184 | 0) >> 2] | 0 | 0) != (1 | 0)) {
           break label$13
          }
          $4 = memcpy(($2 + 40 | 0) + 8 | 0 | 0, memcpy($2 + 112 | 0 | 4 | 0 | 0, ($2 + 184 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
          HEAP32[($2 + 40 | 0) >> 2] = 1;
          i64toi32_i32$0 = $2;
          i64toi32_i32$3 = 0;
          HEAP32[($2 + 184 | 0) >> 2] = 0;
          HEAP32[($2 + 188 | 0) >> 2] = i64toi32_i32$3;
          i64toi32_i32$3 = $16$hi;
          i64toi32_i32$0 = $2;
          HEAP32[($2 + 192 | 0) >> 2] = $16;
          HEAP32[($2 + 196 | 0) >> 2] = i64toi32_i32$3;
          $std__io__cursor__Cursor_T__20as_20std__io__Seek___seek__h4fe82da83d4d5304($2 + 112 | 0 | 0, $1 | 0, $2 + 184 | 0 | 0);
          if ((HEAP32[($2 + 112 | 0) >> 2] | 0 | 0) == (1 | 0)) {
           break label$2
          }
          core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9_3($4 | 0);
          $cardano_serialization_lib__utils__BigInt_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hebb3828b833490eb($2 + 184 | 0 | 0, $1 | 0);
          label$14 : {
           if ((HEAP32[($2 + 184 | 0) >> 2] | 0 | 0) != (1 | 0)) {
            break label$14
           }
           $3 = memcpy($2 + 112 | 0 | 4 | 0 | 0, ($2 + 184 | 0) + 8 | 0 | 0, 64 | 0) | 0;
           $4 = memcpy(($2 + 40 | 0) + 8 | 0 | 0, $3 | 0, 64 | 0) | 0;
           HEAP32[($2 + 40 | 0) >> 2] = 1;
           i64toi32_i32$0 = $2;
           i64toi32_i32$3 = 0;
           HEAP32[($2 + 184 | 0) >> 2] = 0;
           HEAP32[($2 + 188 | 0) >> 2] = i64toi32_i32$3;
           i64toi32_i32$3 = $16$hi;
           i64toi32_i32$0 = $2;
           HEAP32[($2 + 192 | 0) >> 2] = $16;
           HEAP32[($2 + 196 | 0) >> 2] = i64toi32_i32$3;
           $std__io__cursor__Cursor_T__20as_20std__io__Seek___seek__h4fe82da83d4d5304($2 + 112 | 0 | 0, $1 | 0, $2 + 184 | 0 | 0);
           if ((HEAP32[($2 + 112 | 0) >> 2] | 0 | 0) == (1 | 0)) {
            break label$1
           }
           core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9_3($4 | 0);
           cardano_serialization_lib__utils__read_bounded_bytes__hab7fd43ad4917069($2 + 184 | 0 | 0, $1 | 0);
           label$15 : {
            if ((HEAP32[($2 + 184 | 0) >> 2] | 0 | 0) != (1 | 0)) {
             break label$15
            }
            $4 = memcpy(($2 + 40 | 0) + 8 | 0 | 0, memcpy($3 | 0, ($2 + 184 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
            HEAP32[($2 + 40 | 0) >> 2] = 1;
            i64toi32_i32$0 = $2;
            i64toi32_i32$3 = 0;
            HEAP32[($2 + 184 | 0) >> 2] = 0;
            HEAP32[($2 + 188 | 0) >> 2] = i64toi32_i32$3;
            i64toi32_i32$3 = $16$hi;
            i64toi32_i32$0 = $2;
            HEAP32[($2 + 192 | 0) >> 2] = $16;
            HEAP32[($2 + 196 | 0) >> 2] = i64toi32_i32$3;
            $std__io__cursor__Cursor_T__20as_20std__io__Seek___seek__h4fe82da83d4d5304($2 + 112 | 0 | 0, $1 | 0, $2 + 184 | 0 | 0);
            if ((HEAP32[($2 + 112 | 0) >> 2] | 0 | 0) != (1 | 0)) {
             break label$5
            }
            i64toi32_i32$1 = $2;
            i64toi32_i32$3 = HEAP32[($2 + 116 | 0) >> 2] | 0;
            i64toi32_i32$0 = HEAP32[($2 + 120 | 0) >> 2] | 0;
            $248 = i64toi32_i32$3;
            i64toi32_i32$3 = $2;
            HEAP32[($2 + 184 | 0) >> 2] = $248;
            HEAP32[($2 + 188 | 0) >> 2] = i64toi32_i32$0;
            core__result__unwrap_failed__h27f43d993c3864a1(1070651 | 0, 43 | 0, $2 + 184 | 0 | 0, 1070696 | 0, 1071084 | 0);
            abort();
           }
           HEAP32[($2 + 16 | 0) >> 2] = HEAP32[($2 + 196 | 0) >> 2] | 0;
           i64toi32_i32$1 = $2;
           i64toi32_i32$0 = HEAP32[($2 + 188 | 0) >> 2] | 0;
           i64toi32_i32$3 = HEAP32[($2 + 192 | 0) >> 2] | 0;
           $258 = i64toi32_i32$0;
           i64toi32_i32$0 = $2;
           HEAP32[($2 + 8 | 0) >> 2] = $258;
           HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$3;
           $4 = 4;
           break label$6;
          }
          i64toi32_i32$1 = $2 + 196 | 0;
          i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
          $263 = i64toi32_i32$3;
          i64toi32_i32$3 = $2 + 16 | 0;
          HEAP32[i64toi32_i32$3 >> 2] = $263;
          HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
          i64toi32_i32$1 = $2;
          i64toi32_i32$0 = HEAP32[($2 + 188 | 0) >> 2] | 0;
          i64toi32_i32$3 = HEAP32[($2 + 192 | 0) >> 2] | 0;
          $266 = i64toi32_i32$0;
          i64toi32_i32$0 = $2;
          HEAP32[($2 + 8 | 0) >> 2] = $266;
          HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$3;
          $4 = 3;
          break label$6;
         }
         i64toi32_i32$1 = $2 + 196 | 0;
         i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
         $271 = i64toi32_i32$3;
         i64toi32_i32$3 = $2 + 16 | 0;
         HEAP32[i64toi32_i32$3 >> 2] = $271;
         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$1 = $2;
         i64toi32_i32$0 = HEAP32[($2 + 188 | 0) >> 2] | 0;
         i64toi32_i32$3 = HEAP32[($2 + 192 | 0) >> 2] | 0;
         $274 = i64toi32_i32$0;
         i64toi32_i32$0 = $2;
         HEAP32[($2 + 8 | 0) >> 2] = $274;
         HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$3;
         $4 = 2;
         break label$6;
        }
        HEAP32[($2 + 16 | 0) >> 2] = HEAP32[($2 + 196 | 0) >> 2] | 0;
        i64toi32_i32$1 = $2;
        i64toi32_i32$3 = HEAP32[($2 + 188 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[($2 + 192 | 0) >> 2] | 0;
        $282 = i64toi32_i32$3;
        i64toi32_i32$3 = $2;
        HEAP32[($2 + 8 | 0) >> 2] = $282;
        HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
       }
       HEAP32[($0 + 8 | 0) >> 2] = $4;
       i64toi32_i32$1 = $2;
       i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
       i64toi32_i32$3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
       $287 = i64toi32_i32$0;
       i64toi32_i32$0 = $0;
       HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = $287;
       HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = i64toi32_i32$3;
       i64toi32_i32$1 = $2 + 16 | 0;
       i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $292 = i64toi32_i32$3;
       i64toi32_i32$3 = $0 + 20 | 0;
       HEAP32[i64toi32_i32$3 >> 2] = $292;
       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$1 = $2 + 24 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $297 = i64toi32_i32$0;
       i64toi32_i32$0 = $0 + 28 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $297;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
       HEAP32[($0 + 36 | 0) >> 2] = HEAP32[($2 + 32 | 0) >> 2] | 0;
       i64toi32_i32$3 = 0;
       $16 = 0;
       $16$hi = i64toi32_i32$3;
       break label$4;
      }
      core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9_3($4 | 0);
      $1 = $2 + 232 | 0;
      alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($1 | 0, 1071100 | 0, 14 | 0);
      $3 = ($2 + 8 | 0) + 8 | 0;
      $5 = $2 + 196 | 0;
      i64toi32_i32$1 = $5;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $314 = i64toi32_i32$3;
      i64toi32_i32$3 = $3;
      HEAP32[i64toi32_i32$3 >> 2] = $314;
      HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
      $6 = ($2 + 8 | 0) + 16 | 0;
      $7 = $2 + 204 | 0;
      i64toi32_i32$1 = $7;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $322 = i64toi32_i32$0;
      i64toi32_i32$0 = $6;
      HEAP32[i64toi32_i32$0 >> 2] = $322;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
      $8 = ($2 + 8 | 0) + 24 | 0;
      $9 = $2 + 212 | 0;
      HEAP32[$8 >> 2] = HEAP32[$9 >> 2] | 0;
      $10 = $2 + 224 | 0;
      i64toi32_i32$1 = $10;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $335 = i64toi32_i32$3;
      i64toi32_i32$3 = $4;
      HEAP32[i64toi32_i32$3 >> 2] = $335;
      HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
      $11 = ($2 + 40 | 0) + 16 | 0;
      i64toi32_i32$1 = $1;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $341 = i64toi32_i32$0;
      i64toi32_i32$0 = $11;
      HEAP32[i64toi32_i32$0 >> 2] = $341;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
      $12 = ($2 + 40 | 0) + 24 | 0;
      $13 = $2 + 240 | 0;
      i64toi32_i32$1 = $13;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $349 = i64toi32_i32$3;
      i64toi32_i32$3 = $12;
      HEAP32[i64toi32_i32$3 >> 2] = $349;
      HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
      HEAP8[($2 + 184 | 0) >> 0] = 11;
      i64toi32_i32$1 = $2;
      i64toi32_i32$0 = HEAP32[($2 + 188 | 0) >> 2] | 0;
      i64toi32_i32$3 = HEAP32[($2 + 192 | 0) >> 2] | 0;
      $353 = i64toi32_i32$0;
      i64toi32_i32$0 = $2;
      HEAP32[($2 + 8 | 0) >> 2] = $353;
      HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$3;
      $14 = $2 + 216 | 0;
      i64toi32_i32$1 = $14;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $358 = i64toi32_i32$3;
      i64toi32_i32$3 = $2;
      HEAP32[($2 + 40 | 0) >> 2] = $358;
      HEAP32[($2 + 44 | 0) >> 2] = i64toi32_i32$0;
      $15 = HEAP32[($2 + 184 | 0) >> 2] | 0;
      i64toi32_i32$1 = $3;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $363 = i64toi32_i32$0;
      i64toi32_i32$0 = $5;
      HEAP32[i64toi32_i32$0 >> 2] = $363;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
      i64toi32_i32$1 = $6;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $366 = i64toi32_i32$3;
      i64toi32_i32$3 = $7;
      HEAP32[i64toi32_i32$3 >> 2] = $366;
      HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[$9 >> 2] = HEAP32[$8 >> 2] | 0;
      i64toi32_i32$1 = $2;
      i64toi32_i32$0 = HEAP32[($2 + 40 | 0) >> 2] | 0;
      i64toi32_i32$3 = HEAP32[($2 + 44 | 0) >> 2] | 0;
      $372 = i64toi32_i32$0;
      i64toi32_i32$0 = $14;
      HEAP32[i64toi32_i32$0 >> 2] = $372;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
      i64toi32_i32$1 = $4;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $375 = i64toi32_i32$3;
      i64toi32_i32$3 = $10;
      HEAP32[i64toi32_i32$3 >> 2] = $375;
      HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$1 = $11;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $378 = i64toi32_i32$0;
      i64toi32_i32$0 = $1;
      HEAP32[i64toi32_i32$0 >> 2] = $378;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
      i64toi32_i32$1 = $12;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $381 = i64toi32_i32$3;
      i64toi32_i32$3 = $13;
      HEAP32[i64toi32_i32$3 >> 2] = $381;
      HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[($2 + 184 | 0) >> 2] = $15;
      i64toi32_i32$1 = $2;
      i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
      i64toi32_i32$3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
      $386 = i64toi32_i32$0;
      i64toi32_i32$0 = $2;
      HEAP32[($2 + 188 | 0) >> 2] = $386;
      HEAP32[($2 + 192 | 0) >> 2] = i64toi32_i32$3;
      cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 184 | 0 | 0, 1071100 | 0, 14 | 0);
      i64toi32_i32$3 = 0;
      $16 = 1;
      $16$hi = i64toi32_i32$3;
     }
     i64toi32_i32$3 = $16$hi;
     i64toi32_i32$0 = $0;
     HEAP32[i64toi32_i32$0 >> 2] = $16;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
     global$0 = $2 + 256 | 0;
     return;
    }
    i64toi32_i32$1 = $2;
    i64toi32_i32$3 = HEAP32[($2 + 116 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 120 | 0) >> 2] | 0;
    $397 = i64toi32_i32$3;
    i64toi32_i32$3 = $2;
    HEAP32[($2 + 184 | 0) >> 2] = $397;
    HEAP32[($2 + 188 | 0) >> 2] = i64toi32_i32$0;
    core__result__unwrap_failed__h27f43d993c3864a1(1070651 | 0, 43 | 0, $2 + 184 | 0 | 0, 1070696 | 0, 1071036 | 0);
    abort();
   }
   i64toi32_i32$1 = $2;
   i64toi32_i32$0 = HEAP32[($2 + 116 | 0) >> 2] | 0;
   i64toi32_i32$3 = HEAP32[($2 + 120 | 0) >> 2] | 0;
   $402 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   HEAP32[($2 + 184 | 0) >> 2] = $402;
   HEAP32[($2 + 188 | 0) >> 2] = i64toi32_i32$3;
   core__result__unwrap_failed__h27f43d993c3864a1(1070651 | 0, 43 | 0, $2 + 184 | 0 | 0, 1070696 | 0, 1071052 | 0);
   abort();
  }
  i64toi32_i32$1 = $2;
  i64toi32_i32$3 = HEAP32[($2 + 116 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 120 | 0) >> 2] | 0;
  $407 = i64toi32_i32$3;
  i64toi32_i32$3 = $2;
  HEAP32[($2 + 184 | 0) >> 2] = $407;
  HEAP32[($2 + 188 | 0) >> 2] = i64toi32_i32$0;
  core__result__unwrap_failed__h27f43d993c3864a1(1070651 | 0, 43 | 0, $2 + 184 | 0 | 0, 1070696 | 0, 1071068 | 0);
  abort();
 }
 
 function core__ops__function__impls___impl_20core__ops__function__FnOnce_A__20for_20_mut_20F___call_once__he11c2dc02d9ec84f($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $4 = 0, $5 = 0, $119 = 0, $11 = 0, $120 = 0, $121 = 0, $122 = 0, $123 = 0, $124 = 0, $126 = 0, $127 = 0, $128 = 0, $129 = 0, $6 = 0, $7 = 0, $8 = 0, $9 = 0, $10 = 0, $40 = 0, $40$hi = 0, $130 = 0, $131 = 0, $66 = 0, $71 = 0, $74 = 0, $97 = 0, $102 = 0, $107 = 0, $111 = 0, $118 = 0, $125 = 0, $132 = 0, $135 = 0, $16 = 0, $16$hi = 0, $17 = 0, $17$hi = 0, $18 = 0, $18$hi = 0, $19 = 0, $19$hi = 0, $20 = 0, $20$hi = 0, $21 = 0, $21$hi = 0, $22 = 0, $22$hi = 0, $23 = 0, $23$hi = 0, $24 = 0, $24$hi = 0, $25 = 0, $25$hi = 0, $26 = 0, $26$hi = 0, $27 = 0, $27$hi = 0, $12 = 0, $28 = 0, $28$hi = 0, $29 = 0, $29$hi = 0, $30 = 0, $30$hi = 0, $31 = 0, $31$hi = 0, $13 = 0, $14 = 0, $15 = 0, $32 = 0, $32$hi = 0, $33 = 0, $33$hi = 0, $34 = 0, $34$hi = 0, $35 = 0, $35$hi = 0, $36 = 0, $36$hi = 0, $37 = 0, $37$hi = 0, $38 = 0, $38$hi = 0, $39 = 0, $39$hi = 0, $41 = 0, $41$hi = 0, $42 = 0, $42$hi = 0, $43 = 0, $43$hi = 0, $44 = 0, $44$hi = 0, $234 = 0, $240 = 0, $246 = 0, $252 = 0, $45 = 0, $45$hi = 0, $46 = 0, $46$hi = 0, $47 = 0, $47$hi = 0, $48 = 0, $48$hi = 0, $49 = 0, $49$hi = 0, $50 = 0, $50$hi = 0, $51 = 0, $51$hi = 0, $52 = 0, $52$hi = 0, $53 = 0, $53$hi = 0, $280 = 0, $288 = 0, $291 = 0, $301 = 0, $306 = 0, $309 = 0, $459 = 0, $463 = 0;
  $4 = global$0 - 128 | 0;
  global$0 = $4;
  $119 = $2 + 24 | 0;
  HEAP32[($4 + 24 | 0) >> 2] = HEAPU8[$119 >> 0] | 0 | ((HEAPU8[($119 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($119 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($119 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $2 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $66 = i64toi32_i32$0;
  i64toi32_i32$0 = $4 + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $66;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $71 = i64toi32_i32$1;
  i64toi32_i32$1 = $4 + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $71;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $74 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[i64toi32_i32$0 >> 2] = $74;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $5 = $3 + 320 | 0;
  $6 = $3 + 316 | 0;
  $7 = $3 + 308 | 0;
  $8 = $3 + 300 | 0;
  $9 = $3 + 292 | 0;
  $10 = $3 + 284 | 0;
  $2 = 2;
  label$1 : {
   $11 = HEAPU8[($3 + 372 | 0) >> 0] | 0;
   if (($11 | 0) == (2 | 0)) {
    break label$1
   }
   $2 = 0;
   label$2 : {
    if (($11 | 0) != (1 | 0)) {
     break label$2
    }
    i64toi32_i32$2 = $3 + 397 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $97 = i64toi32_i32$1;
    i64toi32_i32$1 = $4 + 120 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $97;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $3 + 389 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $102 = i64toi32_i32$0;
    i64toi32_i32$0 = $4 + 112 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $102;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $3 + 381 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $107 = i64toi32_i32$1;
    i64toi32_i32$1 = $4 + 104 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $107;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $3 + 373 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $111 = i64toi32_i32$0;
    i64toi32_i32$0 = $4;
    HEAP32[(i64toi32_i32$0 + 96 | 0) >> 2] = $111;
    HEAP32[(i64toi32_i32$0 + 100 | 0) >> 2] = i64toi32_i32$1;
    $2 = 1;
   }
   i64toi32_i32$2 = ($4 + 96 | 0) + 24 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $118 = i64toi32_i32$1;
   i64toi32_i32$1 = ($4 + 48 | 0) + 24 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $118;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = ($4 + 96 | 0) + 16 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $125 = i64toi32_i32$0;
   i64toi32_i32$0 = ($4 + 48 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $125;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = ($4 + 96 | 0) + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $132 = i64toi32_i32$1;
   i64toi32_i32$1 = ($4 + 48 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $132;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $4;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 100 | 0) >> 2] | 0;
   $135 = i64toi32_i32$0;
   i64toi32_i32$0 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = $135;
   HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = i64toi32_i32$1;
  }
  $6 = HEAP32[$6 >> 2] | 0;
  $7 = HEAP32[$7 >> 2] | 0;
  $8 = HEAP32[$8 >> 2] | 0;
  $9 = HEAP32[$9 >> 2] | 0;
  $10 = HEAP32[$10 >> 2] | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 152 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 156 | 0) >> 2] | 0;
  $16 = i64toi32_i32$1;
  $16$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 144 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 148 | 0) >> 2] | 0;
  $17 = i64toi32_i32$0;
  $17$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 136 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 140 | 0) >> 2] | 0;
  $18 = i64toi32_i32$1;
  $18$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 128 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 132 | 0) >> 2] | 0;
  $19 = i64toi32_i32$0;
  $19$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 120 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 124 | 0) >> 2] | 0;
  $20 = i64toi32_i32$1;
  $20$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 112 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 116 | 0) >> 2] | 0;
  $21 = i64toi32_i32$0;
  $21$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 104 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 108 | 0) >> 2] | 0;
  $22 = i64toi32_i32$1;
  $22$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 100 | 0) >> 2] | 0;
  $23 = i64toi32_i32$0;
  $23$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 88 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 92 | 0) >> 2] | 0;
  $24 = i64toi32_i32$1;
  $24$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 80 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 84 | 0) >> 2] | 0;
  $25 = i64toi32_i32$0;
  $25$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 72 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 76 | 0) >> 2] | 0;
  $26 = i64toi32_i32$1;
  $26$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
  $27 = i64toi32_i32$0;
  $27$hi = i64toi32_i32$1;
  $11 = HEAP32[(i64toi32_i32$2 + 312 | 0) >> 2] | 0;
  $12 = HEAP32[(i64toi32_i32$2 + 304 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  $28$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] | 0;
  $29 = i64toi32_i32$0;
  $29$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] | 0;
  $30 = i64toi32_i32$1;
  $30$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  $31$hi = i64toi32_i32$1;
  $13 = HEAP32[(i64toi32_i32$2 + 296 | 0) >> 2] | 0;
  $14 = HEAP32[(i64toi32_i32$2 + 288 | 0) >> 2] | 0;
  $15 = HEAP32[(i64toi32_i32$2 + 280 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $32 = i64toi32_i32$1;
  $32$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $33 = i64toi32_i32$0;
  $33$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $34 = i64toi32_i32$1;
  $34$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $35 = i64toi32_i32$0;
  $35$hi = i64toi32_i32$1;
  label$3 : {
   label$4 : {
    if (HEAP32[$5 >> 2] | 0) {
     break label$4
    }
    HEAP32[($4 + 80 | 0) >> 2] = 0;
    break label$3;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h36101af4d9989b58($4 + 80 | 0 | 0, $5 | 0);
  }
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 184 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 188 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  $36$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 176 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 180 | 0) >> 2] | 0;
  $37 = i64toi32_i32$0;
  $37$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 168 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 172 | 0) >> 2] | 0;
  $38 = i64toi32_i32$1;
  $38$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 160 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 164 | 0) >> 2] | 0;
  $39 = i64toi32_i32$0;
  $39$hi = i64toi32_i32$1;
  $5 = 0;
  label$5 : {
   if ((HEAP32[(i64toi32_i32$2 + 332 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$5
   }
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h663a668224e1772a($4 + 96 | 0 | 4 | 0 | 0, $3 + 336 | 0 | 0);
   $5 = 1;
  }
  HEAP32[($4 + 96 | 0) >> 2] = $5;
  i64toi32_i32$1 = 0;
  $40 = 1;
  $40$hi = i64toi32_i32$1;
  label$6 : {
   label$7 : {
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 192 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 196 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    i64toi32_i32$3 = 1;
    if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
     break label$7
    }
    i64toi32_i32$2 = 0;
    $40 = 0;
    $40$hi = i64toi32_i32$2;
    break label$6;
   }
   i64toi32_i32$3 = $3;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 224 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 228 | 0) >> 2] | 0;
   $41 = i64toi32_i32$2;
   $41$hi = i64toi32_i32$0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 216 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 220 | 0) >> 2] | 0;
   $42 = i64toi32_i32$0;
   $42$hi = i64toi32_i32$2;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 208 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 212 | 0) >> 2] | 0;
   $43 = i64toi32_i32$2;
   $43$hi = i64toi32_i32$0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 200 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 204 | 0) >> 2] | 0;
   $44 = i64toi32_i32$0;
   $44$hi = i64toi32_i32$2;
  }
  i64toi32_i32$3 = $4;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 48 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 52 | 0) >> 2] | 0;
  $234 = i64toi32_i32$2;
  i64toi32_i32$2 = $0 + 405 | 0;
  $120 = $234;
  HEAP8[i64toi32_i32$2 >> 0] = $120;
  HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $120 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $120 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $120 >>> 24 | 0;
  HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$3 = (i64toi32_i32$3 + 48 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
  $240 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 413 | 0;
  $121 = $240;
  HEAP8[i64toi32_i32$0 >> 0] = $121;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $121 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $121 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $121 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$2;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
  i64toi32_i32$3 = ($4 + 48 | 0) + 16 | 0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
  $246 = i64toi32_i32$2;
  i64toi32_i32$2 = $0 + 421 | 0;
  $122 = $246;
  HEAP8[i64toi32_i32$2 >> 0] = $122;
  HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $122 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $122 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $122 >>> 24 | 0;
  HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$3 = ($4 + 48 | 0) + 24 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
  $252 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 429 | 0;
  $123 = $252;
  HEAP8[i64toi32_i32$0 >> 0] = $123;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $123 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $123 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $123 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$2;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
  i64toi32_i32$3 = $3;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 348 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 352 | 0) >> 2] | 0;
  $45 = i64toi32_i32$2;
  $45$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 356 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 360 | 0) >> 2] | 0;
  $46 = i64toi32_i32$0;
  $46$hi = i64toi32_i32$2;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 364 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 368 | 0) >> 2] | 0;
  $47 = i64toi32_i32$2;
  $47$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 232 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 236 | 0) >> 2] | 0;
  $48 = i64toi32_i32$0;
  $48$hi = i64toi32_i32$2;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 240 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 244 | 0) >> 2] | 0;
  $49 = i64toi32_i32$2;
  $49$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 248 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 252 | 0) >> 2] | 0;
  $50 = i64toi32_i32$0;
  $50$hi = i64toi32_i32$2;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 256 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 260 | 0) >> 2] | 0;
  $51 = i64toi32_i32$2;
  $51$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 264 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 268 | 0) >> 2] | 0;
  $52 = i64toi32_i32$0;
  $52$hi = i64toi32_i32$2;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 272 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 276 | 0) >> 2] | 0;
  $53 = i64toi32_i32$2;
  $53$hi = i64toi32_i32$0;
  HEAP32[($0 + 360 | 0) >> 2] = HEAP32[(($4 + 80 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$3 = $4;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 80 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 84 | 0) >> 2] | 0;
  $280 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 352 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $280;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  $3 = (i64toi32_i32$3 + 32 | 0) + 8 | 0;
  i64toi32_i32$3 = (i64toi32_i32$3 + 96 | 0) + 8 | 0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
  $288 = i64toi32_i32$2;
  i64toi32_i32$2 = $3;
  HEAP32[i64toi32_i32$2 >> 2] = $288;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$3 = $4;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 96 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 100 | 0) >> 2] | 0;
  $291 = i64toi32_i32$0;
  i64toi32_i32$0 = i64toi32_i32$3;
  HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] = $291;
  HEAP32[(i64toi32_i32$0 + 36 | 0) >> 2] = i64toi32_i32$2;
  $124 = $0 + 24 | 0;
  $126 = HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] | 0;
  HEAP8[$124 >> 0] = $126;
  HEAP8[($124 + 1 | 0) >> 0] = $126 >>> 8 | 0;
  HEAP8[($124 + 2 | 0) >> 0] = $126 >>> 16 | 0;
  HEAP8[($124 + 3 | 0) >> 0] = $126 >>> 24 | 0;
  i64toi32_i32$3 = i64toi32_i32$0 + 16 | 0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
  $301 = i64toi32_i32$2;
  i64toi32_i32$2 = $0 + 16 | 0;
  $127 = $301;
  HEAP8[i64toi32_i32$2 >> 0] = $127;
  HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $127 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $127 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $127 >>> 24 | 0;
  HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$3 = $4 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
  $306 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 8 | 0;
  $128 = $306;
  HEAP8[i64toi32_i32$0 >> 0] = $128;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $128 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $128 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $128 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$2;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
  i64toi32_i32$3 = $4;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
  $309 = i64toi32_i32$2;
  i64toi32_i32$2 = $0;
  $129 = $309;
  HEAP8[i64toi32_i32$2 >> 0] = $129;
  HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $129 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $129 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $129 >>> 24 | 0;
  HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP32[(i64toi32_i32$2 + 348 | 0) >> 2] = $6;
  HEAP32[(i64toi32_i32$2 + 344 | 0) >> 2] = $11;
  HEAP32[(i64toi32_i32$2 + 340 | 0) >> 2] = $7;
  HEAP32[(i64toi32_i32$2 + 336 | 0) >> 2] = $12;
  HEAP32[(i64toi32_i32$2 + 332 | 0) >> 2] = $8;
  HEAP32[(i64toi32_i32$2 + 328 | 0) >> 2] = $13;
  HEAP32[(i64toi32_i32$2 + 324 | 0) >> 2] = $9;
  HEAP32[(i64toi32_i32$2 + 320 | 0) >> 2] = $14;
  HEAP32[(i64toi32_i32$2 + 316 | 0) >> 2] = $10;
  HEAP32[(i64toi32_i32$2 + 312 | 0) >> 2] = $15;
  i64toi32_i32$0 = $53$hi;
  i64toi32_i32$2 = i64toi32_i32$2 + 304 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $53;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $52$hi;
  i64toi32_i32$2 = $0 + 296 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $52;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $51$hi;
  i64toi32_i32$2 = $0 + 288 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $51;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $50$hi;
  i64toi32_i32$2 = $0 + 280 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $50;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $49$hi;
  i64toi32_i32$2 = $0 + 272 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $49;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $48$hi;
  i64toi32_i32$2 = $0 + 264 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $48;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $41$hi;
  i64toi32_i32$2 = $0 + 256 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $41;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $42$hi;
  i64toi32_i32$2 = $0 + 248 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $42;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $43$hi;
  i64toi32_i32$2 = $0 + 240 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $43;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $44$hi;
  i64toi32_i32$2 = $0 + 232 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $44;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $40$hi;
  i64toi32_i32$2 = $0 + 224 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $40;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $36$hi;
  i64toi32_i32$2 = $0 + 216 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $36;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $37$hi;
  i64toi32_i32$2 = $0 + 208 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $37;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $38$hi;
  i64toi32_i32$2 = $0 + 200 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $38;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $39$hi;
  i64toi32_i32$2 = $0 + 192 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $39;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $16$hi;
  i64toi32_i32$2 = $0 + 184 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $16;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $17$hi;
  i64toi32_i32$2 = $0 + 176 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $17;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $18$hi;
  i64toi32_i32$2 = $0 + 168 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $18;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $19$hi;
  i64toi32_i32$2 = $0 + 160 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $19;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $20$hi;
  i64toi32_i32$2 = $0 + 152 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $20;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $21$hi;
  i64toi32_i32$2 = $0 + 144 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $21;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $22$hi;
  i64toi32_i32$2 = $0 + 136 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $22;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $23$hi;
  i64toi32_i32$2 = $0 + 128 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $23;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $24$hi;
  i64toi32_i32$2 = $0 + 120 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $24;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $25$hi;
  i64toi32_i32$2 = $0 + 112 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $25;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $26$hi;
  i64toi32_i32$2 = $0 + 104 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $26;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $27$hi;
  i64toi32_i32$2 = $0 + 96 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $27;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $28$hi;
  i64toi32_i32$2 = $0 + 88 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $28;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $29$hi;
  i64toi32_i32$2 = $0 + 80 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $29;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $30$hi;
  i64toi32_i32$2 = $0 + 72 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $30;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $31$hi;
  i64toi32_i32$2 = $0 + 64 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $31;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $32$hi;
  i64toi32_i32$2 = $0 + 56 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $32;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $33$hi;
  i64toi32_i32$2 = $0 + 48 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $33;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $34$hi;
  i64toi32_i32$2 = $0 + 40 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $34;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $35$hi;
  i64toi32_i32$2 = $0;
  HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] = $35;
  HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $47$hi;
  i64toi32_i32$2 = i64toi32_i32$2 + 396 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $47;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $46$hi;
  i64toi32_i32$2 = $0 + 388 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $46;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $45$hi;
  i64toi32_i32$2 = $0 + 380 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $45;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP8[($0 + 404 | 0) >> 0] = $2;
  i64toi32_i32$3 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
  $459 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 372 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $459;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$3 = $4;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 32 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 36 | 0) >> 2] | 0;
  $463 = i64toi32_i32$2;
  i64toi32_i32$2 = $0 + 364 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $463;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  $130 = $0 + 437 | 0;
  $131 = HEAPU8[(i64toi32_i32$3 + 96 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 97 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[$130 >> 0] = $131;
  HEAP8[($130 + 1 | 0) >> 0] = $131 >>> 8 | 0;
  HEAP8[($0 + 439 | 0) >> 0] = HEAPU8[(i64toi32_i32$3 + 98 | 0) >> 0] | 0;
  global$0 = i64toi32_i32$3 + 128 | 0;
 }
 
 function num_bigint__bigint__subtraction___impl_20core__ops__arith__Sub__num_bigint__bigint__BigInt__20for_20_num_bigint__bigint__BigInt___sub__h41405c4b9a5a6fac($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, $5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $7 = 0, $6 = 0, $10 = 0, $11 = 0, $14 = 0, $8 = 0, $9 = 0, $12 = 0, $13 = 0, $162 = 0, $226 = 0, $273 = 0, $296 = 0, $404 = 0;
  $3 = global$0 - 80 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    $4 = HEAPU8[($2 + 12 | 0) >> 0] | 0;
    if (($4 | 0) != (1 | 0)) {
     break label$2
    }
    $4 = HEAPU8[($1 + 12 | 0) >> 0] | 0;
    $5 = HEAP32[$1 >> 2] | 0;
    $1 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    alloc__raw_vec__RawVec_T_2cA___allocate_in__hb0817f92bbb8999a($3 | 0, $1 | 0, 0 | 0);
    $2 = HEAP32[$3 >> 2] | 0;
    HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($3 + 4 | 0) >> 2] | 0;
    HEAP32[$0 >> 2] = $2;
    memcpy($2 | 0, $5 | 0, $1 << 2 | 0 | 0) | 0;
    HEAP8[($0 + 12 | 0) >> 0] = $4;
    HEAP32[($0 + 8 | 0) >> 2] = $1;
    break label$1;
   }
   label$3 : {
    label$4 : {
     label$5 : {
      label$6 : {
       label$7 : {
        $6 = HEAPU8[($1 + 12 | 0) >> 0] | 0;
        switch ($6 | 0) {
        case 2:
         break label$6;
        case 1:
         break label$7;
        default:
         break label$5;
        };
       }
       $5 = HEAP32[$2 >> 2] | 0;
       $1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
       alloc__raw_vec__RawVec_T_2cA___allocate_in__hb0817f92bbb8999a($3 + 40 | 0 | 0, $1 | 0, 0 | 0);
       $2 = 2;
       $7 = HEAP32[($3 + 44 | 0) >> 2] | 0;
       $5 = memcpy(HEAP32[($3 + 40 | 0) >> 2] | 0 | 0, $5 | 0, $1 << 2 | 0 | 0) | 0;
       label$8 : {
        label$9 : {
         switch ($4 & 3 | 0 | 0) {
         case 1:
          $2 = 1;
          break label$8;
         case 2:
          break label$9;
         default:
          break label$8;
         };
        }
        $2 = 0;
       }
       HEAP8[($0 + 12 | 0) >> 0] = $2;
       HEAP32[($0 + 8 | 0) >> 2] = $1;
       HEAP32[($0 + 4 | 0) >> 2] = $7;
       HEAP32[$0 >> 2] = $5;
       break label$1;
      }
      if ($4) {
       break label$4
      }
      break label$3;
     }
     if ($4) {
      break label$3
     }
    }
    $8 = HEAP32[$2 >> 2] | 0;
    $9 = HEAP32[$1 >> 2] | 0;
    label$11 : {
     label$12 : {
      label$13 : {
       label$14 : {
        $10 = HEAP32[($1 + 8 | 0) >> 2] | 0;
        $11 = HEAP32[($2 + 8 | 0) >> 2] | 0;
        $7 = $10 >>> 0 < $11 >>> 0 ? -1 : ($10 | 0) != ($11 | 0);
        if ($7) {
         break label$14
        }
        $12 = $8 + -4 | 0;
        $5 = $11 << 2 | 0;
        $4 = $10 << 2 | 0;
        $13 = $9 + -4 | 0;
        label$15 : while (1) {
         label$16 : {
          if ($4) {
           break label$16
          }
          $7 = $5 ? -1 : 0;
          break label$14;
         }
         if (!$5) {
          break label$13
         }
         $7 = $13 + $4 | 0;
         $14 = $12 + $5 | 0;
         $5 = $5 + -4 | 0;
         $4 = $4 + -4 | 0;
         $7 = HEAP32[$7 >> 2] | 0;
         $14 = HEAP32[$14 >> 2] | 0;
         $7 = $7 >>> 0 < $14 >>> 0 ? -1 : ($7 | 0) != ($14 | 0);
         if (!$7) {
          continue label$15
         }
         break label$15;
        };
       }
       label$17 : {
        switch ($7 + 1 | 0 | 0) {
        default:
         $2 = 0;
         $4 = 2;
         label$19 : {
          label$20 : {
           switch ($6 & 3 | 0 | 0) {
           case 1:
            $2 = 1;
            $4 = 1;
            break label$19;
           case 2:
            break label$20;
           default:
            break label$19;
           };
          }
          $2 = 0;
          $4 = 0;
         }
         alloc__raw_vec__RawVec_T_2cA___allocate_in__hb0817f92bbb8999a($3 + 8 | 0 | 0, $11 | 0, 0 | 0);
         HEAP32[($3 + 68 | 0) >> 2] = HEAP32[($3 + 12 | 0) >> 2] | 0;
         $5 = HEAP32[($3 + 8 | 0) >> 2] | 0;
         HEAP32[($3 + 64 | 0) >> 2] = $5;
         memcpy($5 | 0, $8 | 0, $11 << 2 | 0 | 0) | 0;
         $5 = ($3 + 64 | 0) + 8 | 0;
         HEAP32[$5 >> 2] = $11;
         num_bigint__biguint__subtraction___impl_20core__ops__arith__SubAssign__num_bigint__biguint__BigUint__20for_20num_bigint__biguint__BigUint___sub_assign__h4ea1a97f3b7bcde9($3 + 64 | 0 | 0, $1 | 0);
         HEAP32[(($3 + 48 | 0) + 8 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($3 + 64 | 0) >> 2] | 0;
         i64toi32_i32$1 = HEAP32[($3 + 68 | 0) >> 2] | 0;
         $162 = i64toi32_i32$0;
         i64toi32_i32$0 = $3;
         HEAP32[($3 + 48 | 0) >> 2] = $162;
         HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$1;
         label$22 : {
          if ($2) {
           break label$22
          }
          $1 = HEAP32[($3 + 56 | 0) >> 2] | 0 ? $4 : 1;
          break label$11;
         }
         $4 = 0;
         HEAP32[($3 + 56 | 0) >> 2] = 0;
         $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend__T_2ccore__slice__iter__Iter_T_____spec_extend__h5cdab7a667860bc4($3 + 48 | 0 | 0, 1082816 | 0, 1082816 | 0);
         $1 = HEAP32[($3 + 56 | 0) >> 2] | 0;
         if (!$1) {
          break label$12
         }
         $2 = (($1 << 2 | 0) + (HEAP32[($3 + 48 | 0) >> 2] | 0) | 0) + -4 | 0;
         label$23 : while (1) {
          label$24 : {
           if (!(HEAP32[$2 >> 2] | 0)) {
            break label$24
           }
           $4 = $1;
           break label$12;
          }
          $1 = $1 + -1 | 0;
          HEAP32[($3 + 56 | 0) >> 2] = $1;
          $2 = $2 + -4 | 0;
          if ($1) {
           continue label$23
          }
          break label$12;
         };
        case 2:
         break label$13;
        case 1:
         break label$17;
        };
       }
       i64toi32_i32$0 = $0;
       i64toi32_i32$1 = 0;
       HEAP32[($0 + 4 | 0) >> 2] = 0;
       HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$1;
       HEAP8[($0 + 12 | 0) >> 0] = 1;
       HEAP32[$0 >> 2] = HEAP32[(0 + 1082808 | 0) >> 2] | 0;
       break label$1;
      }
      $4 = 0;
      alloc__raw_vec__RawVec_T_2cA___allocate_in__hb0817f92bbb8999a($3 + 16 | 0 | 0, $10 | 0, 0 | 0);
      HEAP32[($3 + 68 | 0) >> 2] = HEAP32[($3 + 20 | 0) >> 2] | 0;
      $1 = HEAP32[($3 + 16 | 0) >> 2] | 0;
      HEAP32[($3 + 64 | 0) >> 2] = $1;
      memcpy($1 | 0, $9 | 0, $10 << 2 | 0 | 0) | 0;
      $1 = ($3 + 64 | 0) + 8 | 0;
      HEAP32[$1 >> 2] = $10;
      num_bigint__biguint__subtraction___impl_20core__ops__arith__SubAssign__num_bigint__biguint__BigUint__20for_20num_bigint__biguint__BigUint___sub_assign__h4ea1a97f3b7bcde9($3 + 64 | 0 | 0, $2 | 0);
      HEAP32[(($3 + 48 | 0) + 8 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($3 + 64 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($3 + 68 | 0) >> 2] | 0;
      $226 = i64toi32_i32$1;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 48 | 0) >> 2] = $226;
      HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$0;
      label$25 : {
       label$26 : {
        if (($6 | 0) == (1 | 0)) {
         break label$26
        }
        $1 = HEAP32[($3 + 56 | 0) >> 2] | 0 ? $6 : 1;
        break label$25;
       }
       HEAP32[($3 + 56 | 0) >> 2] = 0;
       $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend__T_2ccore__slice__iter__Iter_T_____spec_extend__h5cdab7a667860bc4($3 + 48 | 0 | 0, 1082816 | 0, 1082816 | 0);
       label$27 : {
        $1 = HEAP32[($3 + 56 | 0) >> 2] | 0;
        if (!$1) {
         break label$27
        }
        $2 = (($1 << 2 | 0) + (HEAP32[($3 + 48 | 0) >> 2] | 0) | 0) + -4 | 0;
        label$28 : while (1) {
         label$29 : {
          if (!(HEAP32[$2 >> 2] | 0)) {
           break label$29
          }
          $4 = $1;
          break label$27;
         }
         $1 = $1 + -1 | 0;
         HEAP32[($3 + 56 | 0) >> 2] = $1;
         $2 = $2 + -4 | 0;
         if ($1) {
          continue label$28
         }
         break label$28;
        };
       }
       $1 = 1;
       $2 = HEAP32[($3 + 52 | 0) >> 2] | 0;
       if ($2 >>> 0 <= $4 >>> 0) {
        break label$25
       }
       if ($4 >>> 0 >= ($2 >>> 2 | 0) >>> 0) {
        break label$25
       }
       alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($3 + 48 | 0 | 0, $4 | 0);
      }
      HEAP8[($0 + 12 | 0) >> 0] = $1;
      i64toi32_i32$0 = HEAP32[($3 + 48 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($3 + 52 | 0) >> 2] | 0;
      $273 = i64toi32_i32$0;
      i64toi32_i32$0 = $0;
      HEAP32[$0 >> 2] = $273;
      HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($0 + 8 | 0) >> 2] = HEAP32[(($3 + 48 | 0) + 8 | 0) >> 2] | 0;
      break label$1;
     }
     $1 = 1;
     $2 = HEAP32[($3 + 52 | 0) >> 2] | 0;
     if ($2 >>> 0 <= $4 >>> 0) {
      break label$11
     }
     if ($4 >>> 0 >= ($2 >>> 2 | 0) >>> 0) {
      break label$11
     }
     alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($3 + 48 | 0 | 0, $4 | 0);
    }
    HEAP8[($0 + 12 | 0) >> 0] = $1;
    i64toi32_i32$1 = HEAP32[($3 + 48 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($3 + 52 | 0) >> 2] | 0;
    $296 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[$0 >> 2] = $296;
    HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($0 + 8 | 0) >> 2] = HEAP32[(($3 + 48 | 0) + 8 | 0) >> 2] | 0;
    break label$1;
   }
   label$30 : {
    label$31 : {
     $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     $5 = HEAP32[($2 + 8 | 0) >> 2] | 0;
     if ($4 >>> 0 >= $5 >>> 0) {
      break label$31
     }
     $2 = HEAP32[$2 >> 2] | 0;
     alloc__raw_vec__RawVec_T_2cA___allocate_in__hb0817f92bbb8999a($3 + 24 | 0 | 0, $5 | 0, 0 | 0);
     HEAP32[($3 + 68 | 0) >> 2] = HEAP32[($3 + 28 | 0) >> 2] | 0;
     $4 = HEAP32[($3 + 24 | 0) >> 2] | 0;
     HEAP32[($3 + 64 | 0) >> 2] = $4;
     memcpy($4 | 0, $2 | 0, $5 << 2 | 0 | 0) | 0;
     HEAP32[($3 + 72 | 0) >> 2] = $5;
     num_bigint__biguint__addition___impl_20core__ops__arith__Add__num_bigint__biguint__BigUint__20for_20num_bigint__biguint__BigUint___add__ha6a5672f04e3ed65($3 + 48 | 0 | 0, $3 + 64 | 0 | 0, $1 | 0);
     break label$30;
    }
    $1 = HEAP32[$1 >> 2] | 0;
    alloc__raw_vec__RawVec_T_2cA___allocate_in__hb0817f92bbb8999a($3 + 32 | 0 | 0, $4 | 0, 0 | 0);
    HEAP32[($3 + 68 | 0) >> 2] = HEAP32[($3 + 36 | 0) >> 2] | 0;
    $5 = HEAP32[($3 + 32 | 0) >> 2] | 0;
    HEAP32[($3 + 64 | 0) >> 2] = $5;
    memcpy($5 | 0, $1 | 0, $4 << 2 | 0 | 0) | 0;
    HEAP32[($3 + 72 | 0) >> 2] = $4;
    num_bigint__biguint__addition___impl_20core__ops__arith__Add__num_bigint__biguint__BigUint__20for_20num_bigint__biguint__BigUint___add__ha6a5672f04e3ed65($3 + 48 | 0 | 0, $3 + 64 | 0 | 0, $2 | 0);
   }
   label$32 : {
    label$33 : {
     if (($6 | 0) == (1 | 0)) {
      break label$33
     }
     $1 = HEAP32[($3 + 56 | 0) >> 2] | 0 ? $6 : 1;
     break label$32;
    }
    $4 = 0;
    HEAP32[($3 + 56 | 0) >> 2] = 0;
    $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend__T_2ccore__slice__iter__Iter_T_____spec_extend__h5cdab7a667860bc4($3 + 48 | 0 | 0, 1082816 | 0, 1082816 | 0);
    label$34 : {
     $1 = HEAP32[($3 + 56 | 0) >> 2] | 0;
     if (!$1) {
      break label$34
     }
     $2 = (($1 << 2 | 0) + (HEAP32[($3 + 48 | 0) >> 2] | 0) | 0) + -4 | 0;
     label$35 : while (1) {
      label$36 : {
       if (!(HEAP32[$2 >> 2] | 0)) {
        break label$36
       }
       $4 = $1;
       break label$34;
      }
      $1 = $1 + -1 | 0;
      HEAP32[($3 + 56 | 0) >> 2] = $1;
      $2 = $2 + -4 | 0;
      if ($1) {
       continue label$35
      }
      break label$35;
     };
    }
    $1 = 1;
    $2 = HEAP32[($3 + 52 | 0) >> 2] | 0;
    if ($2 >>> 0 <= $4 >>> 0) {
     break label$32
    }
    if ($4 >>> 0 >= ($2 >>> 2 | 0) >>> 0) {
     break label$32
    }
    alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($3 + 48 | 0 | 0, $4 | 0);
   }
   HEAP8[($0 + 12 | 0) >> 0] = $1;
   i64toi32_i32$0 = HEAP32[($3 + 48 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($3 + 52 | 0) >> 2] | 0;
   $404 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[$0 >> 2] = $404;
   HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($0 + 8 | 0) >> 2] = HEAP32[(($3 + 48 | 0) + 8 | 0) >> 2] | 0;
  }
  global$0 = $3 + 80 | 0;
 }
 
 function alloc__str___impl_20str___to_lowercase__hacad3ae1919ab6b6($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $4 = 0, $5 = 0, $13 = 0, $14 = 0, $10 = 0, $12 = 0, $9 = 0, $15 = 0, $6 = 0, $3 = 0, $7 = 0, $8 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $20 = 0, $11 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  $4 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if (($2 | 0) < (0 | 0)) {
       break label$4
      }
      if ($2) {
       break label$3
      }
      $5 = 1;
      break label$2;
     }
     alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
     abort();
    }
    $4 = $2;
    $5 = __rust_alloc($4 | 0, 1 | 0) | 0;
    if (!$5) {
     break label$1
    }
   }
   HEAP32[$0 >> 2] = $5;
   $6 = 0;
   $7 = $0 + 8 | 0;
   HEAP32[$7 >> 2] = 0;
   $8 = $0 + 4 | 0;
   HEAP32[$8 >> 2] = $4;
   label$5 : {
    if (!$2) {
     break label$5
    }
    $9 = $1 + $2 | 0;
    $10 = $1;
    label$6 : {
     label$7 : while (1) {
      $11 = $10;
      $12 = $10 + 1 | 0;
      label$8 : {
       label$9 : {
        $4 = HEAP8[$10 >> 0] | 0;
        if (($4 | 0) <= (-1 | 0)) {
         break label$9
        }
        $4 = $4 & 255 | 0;
        $10 = $12;
        break label$8;
       }
       label$10 : {
        label$11 : {
         if (($12 | 0) != ($9 | 0)) {
          break label$11
         }
         $13 = 0;
         $12 = $9;
         break label$10;
        }
        $12 = $10 + 2 | 0;
        $13 = (HEAPU8[($10 + 1 | 0) >> 0] | 0) & 63 | 0;
       }
       $5 = $4 & 31 | 0;
       label$12 : {
        $4 = $4 & 255 | 0;
        if ($4 >>> 0 > 223 >>> 0) {
         break label$12
        }
        $4 = $13 | ($5 << 6 | 0) | 0;
        $10 = $12;
        break label$8;
       }
       label$13 : {
        label$14 : {
         if (($12 | 0) != ($9 | 0)) {
          break label$14
         }
         $10 = 0;
         $14 = $9;
         break label$13;
        }
        $10 = (HEAPU8[$12 >> 0] | 0) & 63 | 0;
        $14 = $12 + 1 | 0;
        $12 = $14;
       }
       $13 = $10 | ($13 << 6 | 0) | 0;
       label$15 : {
        if ($4 >>> 0 >= 240 >>> 0) {
         break label$15
        }
        $4 = $13 | ($5 << 12 | 0) | 0;
        $10 = $12;
        $12 = $14;
        break label$8;
       }
       label$16 : {
        label$17 : {
         if (($14 | 0) != ($9 | 0)) {
          break label$17
         }
         $4 = 0;
         $10 = $12;
         $12 = $14;
         break label$16;
        }
        $4 = (HEAPU8[$14 >> 0] | 0) & 63 | 0;
        $10 = $14 + 1 | 0;
        $12 = $10;
       }
       $4 = $13 << 6 | 0 | (($5 << 18 | 0) & 1835008 | 0) | 0 | $4 | 0;
       if (($4 | 0) == (1114112 | 0)) {
        break label$5
       }
      }
      label$18 : {
       label$19 : {
        label$20 : {
         label$21 : {
          if (($4 | 0) == (931 | 0)) {
           break label$21
          }
          if (($4 | 0) != (1114112 | 0)) {
           break label$20
          }
          break label$5;
         }
         label$22 : {
          if (!$6) {
           break label$22
          }
          label$23 : {
           if ($6 >>> 0 < $2 >>> 0) {
            break label$23
           }
           if (($6 | 0) == ($2 | 0)) {
            break label$22
           }
           break label$6;
          }
          if ((HEAP8[($1 + $6 | 0) >> 0] | 0 | 0) <= (-65 | 0)) {
           break label$6
          }
         }
         $4 = $1 + $6 | 0;
         label$24 : {
          label$25 : {
           label$26 : while (1) {
            if (($4 | 0) == ($1 | 0)) {
             break label$25
            }
            label$27 : {
             label$28 : {
              $13 = $4 + -1 | 0;
              $5 = HEAPU8[$13 >> 0] | 0;
              $14 = ($5 << 24 | 0) >> 24 | 0;
              if (($14 | 0) > (-1 | 0)) {
               break label$28
              }
              label$29 : {
               label$30 : {
                if (($13 | 0) != ($1 | 0)) {
                 break label$30
                }
                $5 = 0;
                $4 = $1;
                break label$29;
               }
               label$31 : {
                $13 = $4 + -2 | 0;
                $5 = HEAPU8[$13 >> 0] | 0;
                if (($5 & 192 | 0 | 0) == (128 | 0)) {
                 break label$31
                }
                $5 = $5 & 31 | 0;
                $4 = $13;
                break label$29;
               }
               label$32 : {
                label$33 : {
                 if (($13 | 0) != ($1 | 0)) {
                  break label$33
                 }
                 $13 = 0;
                 $4 = $1;
                 break label$32;
                }
                label$34 : {
                 $15 = $4 + -3 | 0;
                 $13 = HEAPU8[$15 >> 0] | 0;
                 if (($13 & 192 | 0 | 0) == (128 | 0)) {
                  break label$34
                 }
                 $13 = $13 & 15 | 0;
                 $4 = $15;
                 break label$32;
                }
                label$35 : {
                 label$36 : {
                  if (($15 | 0) != ($1 | 0)) {
                   break label$36
                  }
                  $15 = 0;
                  $4 = $1;
                  break label$35;
                 }
                 $4 = $4 + -4 | 0;
                 $15 = ((HEAPU8[$4 >> 0] | 0) & 7 | 0) << 6 | 0;
                }
                $13 = $15 | ($13 & 63 | 0) | 0;
               }
               $5 = $13 << 6 | 0 | ($5 & 63 | 0) | 0;
              }
              $5 = $5 << 6 | 0 | ($14 & 63 | 0) | 0;
              if (($5 | 0) != (1114112 | 0)) {
               break label$27
              }
              break label$25;
             }
             $4 = $13;
            }
            if (core__unicode__unicode_data__case_ignorable__lookup__heab570bcd49c0edc($5 | 0) | 0) {
             continue label$26
            }
            break label$26;
           };
           if (!(core__unicode__unicode_data__cased__lookup__hc09fca0edcae4c58($5 | 0) | 0)) {
            break label$25
           }
           label$37 : {
            $4 = $6 + 2 | 0;
            if (!$4) {
             break label$37
            }
            label$38 : {
             if ($4 >>> 0 < $2 >>> 0) {
              break label$38
             }
             if (($4 | 0) == ($2 | 0)) {
              break label$37
             }
             break label$18;
            }
            if ((HEAP8[($1 + $4 | 0) >> 0] | 0 | 0) <= (-65 | 0)) {
             break label$18
            }
           }
           $4 = $1 + $4 | 0;
           $13 = 0;
           label$39 : while (1) {
            if (($4 | 0) == ($9 | 0)) {
             break label$24
            }
            $14 = $4 + 1 | 0;
            label$40 : {
             label$41 : {
              $5 = HEAP8[$4 >> 0] | 0;
              if (($5 | 0) <= (-1 | 0)) {
               break label$41
              }
              $5 = $5 & 255 | 0;
              $4 = $14;
              break label$40;
             }
             label$42 : {
              label$43 : {
               if (($14 | 0) != ($9 | 0)) {
                break label$43
               }
               $15 = 0;
               $14 = $9;
               break label$42;
              }
              $14 = $4 + 2 | 0;
              $15 = (HEAPU8[($4 + 1 | 0) >> 0] | 0) & 63 | 0;
             }
             $16 = $5 & 31 | 0;
             label$44 : {
              $5 = $5 & 255 | 0;
              if ($5 >>> 0 > 223 >>> 0) {
               break label$44
              }
              $5 = $15 | ($16 << 6 | 0) | 0;
              $4 = $14;
              break label$40;
             }
             label$45 : {
              label$46 : {
               if (($14 | 0) != ($9 | 0)) {
                break label$46
               }
               $14 = 0;
               $4 = $9;
               break label$45;
              }
              $4 = $14 + 1 | 0;
              $14 = (HEAPU8[$14 >> 0] | 0) & 63 | 0;
             }
             $14 = $14 | ($15 << 6 | 0) | 0;
             label$47 : {
              if ($5 >>> 0 >= 240 >>> 0) {
               break label$47
              }
              $5 = $14 | ($16 << 12 | 0) | 0;
              break label$40;
             }
             label$48 : {
              label$49 : {
               if (($4 | 0) != ($9 | 0)) {
                break label$49
               }
               $5 = 0;
               $4 = $9;
               break label$48;
              }
              $5 = (HEAPU8[$4 >> 0] | 0) & 63 | 0;
              $4 = $4 + 1 | 0;
             }
             $5 = $14 << 6 | 0 | (($16 << 18 | 0) & 1835008 | 0) | 0 | $5 | 0;
             if (($5 | 0) == (1114112 | 0)) {
              break label$24
             }
            }
            label$50 : {
             label$51 : {
              if ($13 & 255 | 0) {
               break label$51
              }
              if (!(core__unicode__unicode_data__case_ignorable__lookup__heab570bcd49c0edc($5 | 0) | 0)) {
               break label$51
              }
              $5 = 1114112;
              $13 = 0;
              break label$50;
             }
             $13 = 1;
            }
            if (($5 | 0) == (1114112 | 0)) {
             continue label$39
            }
            break label$39;
           };
           if (!(core__unicode__unicode_data__cased__lookup__hc09fca0edcae4c58($5 | 0) | 0)) {
            break label$24
           }
          }
          label$52 : {
           $4 = HEAP32[$7 >> 2] | 0;
           if (((HEAP32[$8 >> 2] | 0) - $4 | 0) >>> 0 > 1 >>> 0) {
            break label$52
           }
           alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h306b444aaeb5adc5($0 | 0, $4 | 0, 2 | 0);
           $4 = HEAP32[$7 >> 2] | 0;
          }
          HEAP32[$7 >> 2] = $4 + 2 | 0;
          $17 = (HEAP32[$0 >> 2] | 0) + $4 | 0;
          $18 = 33743;
          HEAP8[$17 >> 0] = $18;
          HEAP8[($17 + 1 | 0) >> 0] = $18 >>> 8 | 0;
          break label$19;
         }
         label$53 : {
          $4 = HEAP32[$7 >> 2] | 0;
          if (((HEAP32[$8 >> 2] | 0) - $4 | 0) >>> 0 > 1 >>> 0) {
           break label$53
          }
          alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h306b444aaeb5adc5($0 | 0, $4 | 0, 2 | 0);
          $4 = HEAP32[$7 >> 2] | 0;
         }
         HEAP32[$7 >> 2] = $4 + 2 | 0;
         $19 = (HEAP32[$0 >> 2] | 0) + $4 | 0;
         $20 = 33487;
         HEAP8[$19 >> 0] = $20;
         HEAP8[($19 + 1 | 0) >> 0] = $20 >>> 8 | 0;
         break label$19;
        }
        core__unicode__unicode_data__conversions__to_lower__ha1d2dd3b09e52a1a($3 + 4 | 0 | 0, $4 | 0);
        label$54 : {
         label$55 : {
          $5 = HEAP32[($3 + 8 | 0) >> 2] | 0;
          if ($5) {
           break label$55
          }
          $4 = HEAP32[($3 + 4 | 0) >> 2] | 0;
          break label$54;
         }
         $4 = HEAP32[($3 + 12 | 0) >> 2] | 0;
         alloc__string__String__push__hfac6e344dab69dd1($0 | 0, HEAP32[($3 + 4 | 0) >> 2] | 0 | 0);
         alloc__string__String__push__hfac6e344dab69dd1($0 | 0, $5 | 0);
         if (!$4) {
          break label$19
         }
        }
        alloc__string__String__push__hfac6e344dab69dd1($0 | 0, $4 | 0);
       }
       $6 = ($6 - $11 | 0) + $12 | 0;
       if (($10 | 0) != ($9 | 0)) {
        continue label$7
       }
       break label$5;
      }
      break label$7;
     };
     core__str__slice_error_fail__h8a7d2e23b7bba52e($1 | 0, $2 | 0, $4 | 0, $2 | 0, 1145988 | 0);
     abort();
    }
    core__str__slice_error_fail__h8a7d2e23b7bba52e($1 | 0, $2 | 0, 0 | 0, $6 | 0, 1145972 | 0);
    abort();
   }
   global$0 = $3 + 16 | 0;
   return;
  }
  alloc__alloc__handle_alloc_error__he269d8f1bff90960($2 | 0, 1 | 0);
  abort();
 }
 
 function $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$5 = 0, i64toi32_i32$4 = 0, $3 = 0, $4$hi = 0, $5$hi = 0, $6$hi = 0, $8$hi = 0, $4 = 0, $7$hi = 0, $10$hi = 0, $12$hi = 0, $5 = 0, $9$hi = 0, $6 = 0, $8 = 0, $11$hi = 0, $7 = 0, $10 = 0, $12 = 0, $9 = 0, $16$hi = 0, $11 = 0, $17$hi = 0, $13$hi = 0, $13 = 0, $16 = 0, $17 = 0, $14$hi = 0, $15$hi = 0, $18$hi = 0, $14 = 0, $15 = 0, $18 = 0, $264 = 0, $265 = 0, $267 = 0, $268 = 0, $269 = 0, $270 = 0, $271 = 0, $273 = 0, $274 = 0, $275 = 0, $277 = 0, $111 = 0, $111$hi = 0, $148 = 0, $153 = 0, $153$hi = 0, $157 = 0, $157$hi = 0, $161 = 0, $161$hi = 0, $165 = 0, $165$hi = 0, $167 = 0, $167$hi = 0, $172 = 0, $172$hi = 0, $176 = 0, $176$hi = 0, $180 = 0, $180$hi = 0, $184 = 0, $184$hi = 0, $186 = 0, $186$hi = 0, $191 = 0, $191$hi = 0, $195 = 0, $195$hi = 0, $199 = 0, $199$hi = 0, $203 = 0, $203$hi = 0, $206 = 0, $206$hi = 0, $210 = 0, $210$hi = 0, $213 = 0, $213$hi = 0, $214$hi = 0, $217 = 0, $218$hi = 0, $219$hi = 0, $223 = 0, $223$hi = 0, $224$hi = 0, $227 = 0, $228$hi = 0, $229$hi = 0, $233 = 0, $233$hi = 0, $234$hi = 0, $237 = 0, $238$hi = 0, $239$hi = 0, $243 = 0, $243$hi = 0, $244$hi = 0, $247 = 0, $248$hi = 0, $250$hi = 0, $251 = 0, $251$hi = 0, $254 = 0, $254$hi = 0, $258 = 0, $258$hi = 0, $262 = 0, $262$hi = 0, $263$hi = 0, $266 = 0, $267$hi = 0, $268$hi = 0, $272 = 0, $272$hi = 0, $273$hi = 0, $276 = 0, $277$hi = 0, $278$hi = 0, $282 = 0, $282$hi = 0, $283$hi = 0, $286 = 0, $287$hi = 0, $288$hi = 0, $292 = 0, $292$hi = 0, $293$hi = 0, $296 = 0, $297$hi = 0, $298$hi = 0, $301 = 0, $302$hi = 0, $304$hi = 0, $305 = 0, $305$hi = 0, $308 = 0, $309 = 0, $314 = 0, $314$hi = 0, $318 = 0, $318$hi = 0, $322 = 0, $322$hi = 0, $326 = 0, $326$hi = 0, $328 = 0, $328$hi = 0, $330 = 0, $330$hi = 0, $334 = 0, $334$hi = 0, $338 = 0, $338$hi = 0, $339$hi = 0, $342 = 0, $343$hi = 0, $344$hi = 0, $348 = 0, $348$hi = 0, $349$hi = 0, $352 = 0, $353$hi = 0, $354$hi = 0, $358 = 0, $358$hi = 0, $359$hi = 0, $362 = 0, $363$hi = 0, $364$hi = 0, $368 = 0, $368$hi = 0, $369$hi = 0, $372 = 0, $373$hi = 0, $374$hi = 0, $377 = 0, $378$hi = 0, $380$hi = 0, $381 = 0, $381$hi = 0, $385 = 0, $390 = 0, $390$hi = 0, $394 = 0, $394$hi = 0, $398 = 0, $398$hi = 0, $402 = 0, $402$hi = 0, $404 = 0, $404$hi = 0, $406 = 0, $406$hi = 0, $410 = 0, $410$hi = 0, $414 = 0, $414$hi = 0, $415$hi = 0, $418 = 0, $419$hi = 0, $420$hi = 0, $424 = 0, $424$hi = 0, $425$hi = 0, $428 = 0, $429$hi = 0, $430$hi = 0, $434 = 0, $434$hi = 0, $435$hi = 0, $438 = 0, $439$hi = 0, $440$hi = 0, $444 = 0, $444$hi = 0, $445$hi = 0, $448 = 0, $449$hi = 0, $450$hi = 0, $453 = 0, $454$hi = 0, $456$hi = 0, $457 = 0, $457$hi = 0, $461 = 0, $463 = 0, $463$hi = 0, $467 = 0, $467$hi = 0, $471 = 0, $471$hi = 0, $472$hi = 0, $475 = 0, $476$hi = 0, $477$hi = 0, $481 = 0, $481$hi = 0, $482$hi = 0, $485 = 0, $486$hi = 0, $487$hi = 0, $491 = 0, $491$hi = 0, $492$hi = 0, $495 = 0, $496$hi = 0, $497$hi = 0, $501 = 0, $501$hi = 0, $502$hi = 0, $505 = 0, $506$hi = 0, $507$hi = 0, $510 = 0, $511$hi = 0, $513$hi = 0, $278 = 0, $515 = 0, $515$hi = 0, $517 = 0, $517$hi = 0, $520 = 0, $521 = 0, $523$hi = 0, $525 = 0, $525$hi = 0;
  $3 = global$0 - 400 | 0;
  global$0 = $3;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $5 = i64toi32_i32$1;
  $5$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $4$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$2 = $5$hi;
  i64toi32_i32$3 = 0;
  __multi3($3 | 0, $4 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$1 | 0, $5 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$3 | 0);
  i64toi32_i32$1 = $2;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] | 0;
  $6 = i64toi32_i32$3;
  $6$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $5$hi;
  i64toi32_i32$2 = $6$hi;
  i64toi32_i32$3 = 0;
  i64toi32_i32$1 = $5$hi;
  i64toi32_i32$0 = 0;
  __multi3($3 + 16 | 0 | 0, $6 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$3 | 0, $5 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$0 | 0);
  i64toi32_i32$0 = $4$hi;
  i64toi32_i32$3 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 12 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $4$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = $7$hi;
  i64toi32_i32$2 = 0;
  __multi3($3 + 80 | 0 | 0, $4 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$0 | 0, $7 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$2 | 0);
  i64toi32_i32$0 = $2;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] | 0;
  $8 = i64toi32_i32$2;
  $8$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $5$hi;
  i64toi32_i32$3 = $8$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$0 = $5$hi;
  i64toi32_i32$1 = 0;
  __multi3($3 + 32 | 0 | 0, $8 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$2 | 0, $5 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$1 | 0);
  i64toi32_i32$1 = $4$hi;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $4$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$3 = 0;
  __multi3($3 + 96 | 0 | 0, $4 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$1 | 0, $9 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$3 | 0);
  i64toi32_i32$3 = $6$hi;
  i64toi32_i32$3 = $7$hi;
  i64toi32_i32$3 = $6$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$0 = 0;
  __multi3($3 + 144 | 0 | 0, $6 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$2 | 0, $7 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$0 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $5$hi;
  i64toi32_i32$1 = $10$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$2 = $5$hi;
  i64toi32_i32$3 = 0;
  __multi3($3 + 48 | 0 | 0, $10 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$0 | 0, $5 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$3 | 0);
  i64toi32_i32$3 = $4$hi;
  i64toi32_i32$0 = $1;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] | 0;
  $11 = i64toi32_i32$3;
  $11$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$3 = 0;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$1 = 0;
  __multi3($3 + 112 | 0 | 0, $4 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$3 | 0, $11 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$1 | 0);
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = $7$hi;
  i64toi32_i32$2 = 0;
  __multi3($3 + 208 | 0 | 0, $8 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$0 | 0, $7 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$2 | 0);
  i64toi32_i32$2 = $6$hi;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$2 = $6$hi;
  i64toi32_i32$3 = 0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$1 = 0;
  __multi3($3 + 160 | 0 | 0, $6 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$3 | 0, $9 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$1 | 0);
  i64toi32_i32$3 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 32 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 36 | 0) >> 2] | 0;
  $12 = i64toi32_i32$1;
  $12$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $5$hi;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = $5$hi;
  i64toi32_i32$2 = 0;
  __multi3($3 + 64 | 0 | 0, $12 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$1 | 0, $5 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$2 | 0);
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$1 = $1;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 32 | 0) >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] | 0;
  $5 = i64toi32_i32$2;
  $5$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $4$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$1 = $5$hi;
  i64toi32_i32$0 = 0;
  __multi3($3 + 128 | 0 | 0, $4 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$2 | 0, $5 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$0 | 0);
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$3 = 0;
  __multi3($3 + 176 | 0 | 0, $6 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$1 | 0, $11 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$3 | 0);
  i64toi32_i32$3 = $10$hi;
  i64toi32_i32$3 = $7$hi;
  i64toi32_i32$3 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$0 = 0;
  __multi3($3 + 272 | 0 | 0, $10 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$2 | 0, $7 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$0 | 0);
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$3 = 0;
  __multi3($3 + 224 | 0 | 0, $8 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$1 | 0, $9 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$3 | 0);
  i64toi32_i32$3 = $6$hi;
  i64toi32_i32$3 = $5$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_i64_mul($5 | 0, i64toi32_i32$3 | 0, 19 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$3 = i64toi32_i32$HIGH_BITS;
  $4 = i64toi32_i32$2;
  $4$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $6$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$1 = $4$hi;
  i64toi32_i32$0 = 0;
  __multi3($3 + 192 | 0 | 0, $6 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$2 | 0, $4 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$0 | 0);
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_i64_mul($7 | 0, i64toi32_i32$0 | 0, 19 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $111 = i64toi32_i32$1;
  $111$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$2 = $111$hi;
  i64toi32_i32$3 = 0;
  __multi3($3 + 336 | 0 | 0, $12 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$1 | 0, $111 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$3 | 0);
  i64toi32_i32$3 = $10$hi;
  i64toi32_i32$3 = $9$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_i64_mul($9 | 0, i64toi32_i32$3 | 0, 19 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$3 = i64toi32_i32$HIGH_BITS;
  $6 = i64toi32_i32$2;
  $6$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$0 = 0;
  __multi3($3 + 288 | 0 | 0, $10 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$2 | 0, $6 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$0 | 0);
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_i64_mul($11 | 0, i64toi32_i32$0 | 0, 19 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $5 = i64toi32_i32$1;
  $5$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$2 = $5$hi;
  i64toi32_i32$3 = 0;
  __multi3($3 + 240 | 0 | 0, $8 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$1 | 0, $5 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$3 | 0);
  i64toi32_i32$3 = i64toi32_i32$0;
  i64toi32_i32$3 = $4$hi;
  i64toi32_i32$3 = i64toi32_i32$0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$1 = $4$hi;
  i64toi32_i32$0 = 0;
  __multi3($3 + 256 | 0 | 0, $8 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$2 | 0, $4 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$0 | 0);
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$2 = $6$hi;
  i64toi32_i32$3 = 0;
  __multi3($3 + 352 | 0 | 0, $12 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$1 | 0, $6 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$3 | 0);
  i64toi32_i32$3 = $10$hi;
  i64toi32_i32$3 = $5$hi;
  i64toi32_i32$3 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$1 = $5$hi;
  i64toi32_i32$0 = 0;
  __multi3($3 + 304 | 0 | 0, $10 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$2 | 0, $5 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$0 | 0);
  i64toi32_i32$0 = i64toi32_i32$3;
  i64toi32_i32$0 = $4$hi;
  i64toi32_i32$0 = i64toi32_i32$3;
  i64toi32_i32$1 = 0;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$3 = 0;
  __multi3($3 + 320 | 0 | 0, $10 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$1 | 0, $4 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$3 | 0);
  i64toi32_i32$3 = $12$hi;
  i64toi32_i32$3 = $5$hi;
  i64toi32_i32$3 = $12$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$1 = $5$hi;
  i64toi32_i32$0 = 0;
  __multi3($3 + 368 | 0 | 0, $12 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$2 | 0, $5 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$0 | 0);
  i64toi32_i32$0 = i64toi32_i32$3;
  i64toi32_i32$0 = $4$hi;
  i64toi32_i32$0 = i64toi32_i32$3;
  i64toi32_i32$1 = 0;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$3 = 0;
  __multi3($3 + 384 | 0 | 0, $12 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$1 | 0, $4 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$3 | 0);
  $148 = $0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] | 0;
  $13 = i64toi32_i32$3;
  $13$hi = i64toi32_i32$2;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 96 | 0) >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 100 | 0) >> 2] | 0;
  $153 = i64toi32_i32$2;
  $153$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $13$hi;
  i64toi32_i32$1 = $13;
  i64toi32_i32$2 = $153$hi;
  i64toi32_i32$0 = $153;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  i64toi32_i32$5 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $4 = i64toi32_i32$4;
  $4$hi = i64toi32_i32$5;
  i64toi32_i32$3 = $3;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 36 | 0) >> 2] | 0;
  $157 = i64toi32_i32$5;
  $157$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $4$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$5 = $157$hi;
  i64toi32_i32$0 = $157;
  i64toi32_i32$2 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $5 = i64toi32_i32$2;
  $5$hi = i64toi32_i32$4;
  i64toi32_i32$1 = $3;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 320 | 0) >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 324 | 0) >> 2] | 0;
  $161 = i64toi32_i32$4;
  $161$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $5$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$4 = $161$hi;
  i64toi32_i32$0 = $161;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  i64toi32_i32$2 = i64toi32_i32$3 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $6 = i64toi32_i32$5;
  $6$hi = i64toi32_i32$2;
  i64toi32_i32$3 = $3;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 368 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 372 | 0) >> 2] | 0;
  $165 = i64toi32_i32$2;
  $165$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$2 = $165$hi;
  i64toi32_i32$0 = $165;
  i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $7 = i64toi32_i32$4;
  $7$hi = i64toi32_i32$5;
  $167 = i64toi32_i32$4;
  $167$hi = i64toi32_i32$5;
  i64toi32_i32$1 = $3;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] | 0;
  $14 = i64toi32_i32$5;
  $14$hi = i64toi32_i32$3;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 80 | 0) >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 84 | 0) >> 2] | 0;
  $172 = i64toi32_i32$3;
  $172$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $14$hi;
  i64toi32_i32$1 = $14;
  i64toi32_i32$3 = $172$hi;
  i64toi32_i32$0 = $172;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $8 = i64toi32_i32$2;
  $8$hi = i64toi32_i32$4;
  i64toi32_i32$5 = $3;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 256 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 260 | 0) >> 2] | 0;
  $176 = i64toi32_i32$4;
  $176$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$4 = $176$hi;
  i64toi32_i32$0 = $176;
  i64toi32_i32$3 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$3 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $10 = i64toi32_i32$3;
  $10$hi = i64toi32_i32$2;
  i64toi32_i32$1 = $3;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 304 | 0) >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 308 | 0) >> 2] | 0;
  $180 = i64toi32_i32$2;
  $180$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$1 = i64toi32_i32$3;
  i64toi32_i32$2 = $180$hi;
  i64toi32_i32$0 = $180;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  i64toi32_i32$3 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
  }
  $12 = i64toi32_i32$4;
  $12$hi = i64toi32_i32$3;
  i64toi32_i32$5 = $3;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 352 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 356 | 0) >> 2] | 0;
  $184 = i64toi32_i32$3;
  $184$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$3 = $184$hi;
  i64toi32_i32$0 = $184;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $9 = i64toi32_i32$2;
  $9$hi = i64toi32_i32$4;
  $186 = i64toi32_i32$2;
  $186$hi = i64toi32_i32$4;
  i64toi32_i32$1 = $3;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 192 | 0) >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 196 | 0) >> 2] | 0;
  $15 = i64toi32_i32$4;
  $15$hi = i64toi32_i32$5;
  i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $191 = i64toi32_i32$5;
  $191$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $15$hi;
  i64toi32_i32$1 = $15;
  i64toi32_i32$5 = $191$hi;
  i64toi32_i32$0 = $191;
  i64toi32_i32$3 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$3 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $11 = i64toi32_i32$3;
  $11$hi = i64toi32_i32$2;
  i64toi32_i32$4 = $3;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 240 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$4 + 244 | 0) >> 2] | 0;
  $195 = i64toi32_i32$2;
  $195$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$4 = i64toi32_i32$3;
  i64toi32_i32$2 = $195$hi;
  i64toi32_i32$0 = $195;
  i64toi32_i32$5 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
  i64toi32_i32$3 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
  }
  $16 = i64toi32_i32$5;
  $16$hi = i64toi32_i32$3;
  i64toi32_i32$1 = $3;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 288 | 0) >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 292 | 0) >> 2] | 0;
  $199 = i64toi32_i32$3;
  $199$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $16$hi;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$3 = $199$hi;
  i64toi32_i32$0 = $199;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $17 = i64toi32_i32$2;
  $17$hi = i64toi32_i32$5;
  i64toi32_i32$4 = $3;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 336 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$4 + 340 | 0) >> 2] | 0;
  $203 = i64toi32_i32$5;
  $203$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $17$hi;
  i64toi32_i32$4 = i64toi32_i32$2;
  i64toi32_i32$5 = $203$hi;
  i64toi32_i32$0 = $203;
  i64toi32_i32$3 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$3 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $18 = i64toi32_i32$3;
  $18$hi = i64toi32_i32$2;
  i64toi32_i32$1 = i64toi32_i32$3;
  i64toi32_i32$4 = 0;
  i64toi32_i32$0 = 51;
  i64toi32_i32$5 = i64toi32_i32$0 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
   i64toi32_i32$4 = 0;
   $264 = i64toi32_i32$2 >>> i64toi32_i32$5 | 0;
  } else {
   i64toi32_i32$4 = i64toi32_i32$2 >>> i64toi32_i32$5 | 0;
   $264 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$5 | 0) | 0;
  }
  $206 = $264;
  $206$hi = i64toi32_i32$4;
  i64toi32_i32$2 = ($3 + 192 | 0) + 8 | 0;
  i64toi32_i32$4 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $210 = i64toi32_i32$4;
  $210$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $3 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $213 = i64toi32_i32$1;
  $213$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $210$hi;
  i64toi32_i32$2 = $210;
  i64toi32_i32$1 = $213$hi;
  i64toi32_i32$0 = $213;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  i64toi32_i32$3 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
  }
  $214$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $11$hi;
  i64toi32_i32$3 = $15$hi;
  i64toi32_i32$3 = $11$hi;
  i64toi32_i32$4 = $11;
  i64toi32_i32$2 = $15$hi;
  i64toi32_i32$0 = $15;
  $217 = i64toi32_i32$3 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0 | 0) | 0;
  i64toi32_i32$4 = 0;
  $218$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $214$hi;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$3 = $218$hi;
  i64toi32_i32$2 = $217;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $219$hi = i64toi32_i32$5;
  i64toi32_i32$4 = ($3 + 240 | 0) + 8 | 0;
  i64toi32_i32$5 = HEAP32[i64toi32_i32$4 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
  $223 = i64toi32_i32$5;
  $223$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $219$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$5 = $223$hi;
  i64toi32_i32$2 = $223;
  i64toi32_i32$3 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$3 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $224$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $16$hi;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$1 = $16$hi;
  i64toi32_i32$0 = $16;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$2 = $11;
  $227 = i64toi32_i32$1 >>> 0 < i64toi32_i32$4 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$4 | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0;
  i64toi32_i32$0 = 0;
  $228$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $224$hi;
  i64toi32_i32$2 = i64toi32_i32$3;
  i64toi32_i32$1 = $228$hi;
  i64toi32_i32$4 = $227;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  i64toi32_i32$3 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$4 >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
  }
  $229$hi = i64toi32_i32$3;
  i64toi32_i32$0 = ($3 + 288 | 0) + 8 | 0;
  i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $233 = i64toi32_i32$3;
  $233$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $229$hi;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$3 = $233$hi;
  i64toi32_i32$4 = $233;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$4 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $234$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $17$hi;
  i64toi32_i32$5 = $16$hi;
  i64toi32_i32$5 = $17$hi;
  i64toi32_i32$2 = $17;
  i64toi32_i32$0 = $16$hi;
  i64toi32_i32$4 = $16;
  $237 = i64toi32_i32$5 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$4 >>> 0 | 0) | 0;
  i64toi32_i32$2 = 0;
  $238$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $234$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$5 = $238$hi;
  i64toi32_i32$0 = $237;
  i64toi32_i32$3 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$3 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $239$hi = i64toi32_i32$1;
  i64toi32_i32$2 = ($3 + 336 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $243 = i64toi32_i32$1;
  $243$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $239$hi;
  i64toi32_i32$2 = i64toi32_i32$3;
  i64toi32_i32$1 = $243$hi;
  i64toi32_i32$0 = $243;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  i64toi32_i32$3 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
  }
  $244$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $18$hi;
  i64toi32_i32$3 = $17$hi;
  i64toi32_i32$3 = $18$hi;
  i64toi32_i32$4 = $18;
  i64toi32_i32$2 = $17$hi;
  i64toi32_i32$0 = $17;
  $247 = i64toi32_i32$3 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0 | 0) | 0;
  i64toi32_i32$4 = 0;
  $248$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $244$hi;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$3 = $248$hi;
  i64toi32_i32$2 = $247;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$0 = 0;
  i64toi32_i32$2 = 13;
  i64toi32_i32$3 = i64toi32_i32$2 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$4 << i64toi32_i32$3 | 0;
   $265 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$3 | 0) - 1 | 0) & (i64toi32_i32$4 >>> (32 - i64toi32_i32$3 | 0) | 0) | 0 | (i64toi32_i32$5 << i64toi32_i32$3 | 0) | 0;
   $265 = i64toi32_i32$4 << i64toi32_i32$3 | 0;
  }
  $250$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $206$hi;
  i64toi32_i32$5 = $206;
  i64toi32_i32$4 = $250$hi;
  i64toi32_i32$2 = $265;
  i64toi32_i32$4 = i64toi32_i32$0 | i64toi32_i32$4 | 0;
  $251 = i64toi32_i32$5 | i64toi32_i32$2 | 0;
  $251$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $186$hi;
  i64toi32_i32$0 = $186;
  i64toi32_i32$5 = $251$hi;
  i64toi32_i32$2 = $251;
  i64toi32_i32$3 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$3 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $11 = i64toi32_i32$3;
  $11$hi = i64toi32_i32$1;
  i64toi32_i32$4 = i64toi32_i32$3;
  i64toi32_i32$0 = 0;
  i64toi32_i32$2 = 51;
  i64toi32_i32$5 = i64toi32_i32$2 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $267 = i64toi32_i32$1 >>> i64toi32_i32$5 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$5 | 0;
   $267 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$5 | 0) | 0;
  }
  $254 = $267;
  $254$hi = i64toi32_i32$0;
  i64toi32_i32$1 = ($3 + 16 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $258 = i64toi32_i32$0;
  $258$hi = i64toi32_i32$4;
  i64toi32_i32$1 = ($3 + 80 | 0) + 8 | 0;
  i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $262 = i64toi32_i32$4;
  $262$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $258$hi;
  i64toi32_i32$1 = $258;
  i64toi32_i32$4 = $262$hi;
  i64toi32_i32$2 = $262;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$3 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
  }
  $263$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $8$hi;
  i64toi32_i32$3 = $14$hi;
  i64toi32_i32$3 = $8$hi;
  i64toi32_i32$0 = $8;
  i64toi32_i32$1 = $14$hi;
  i64toi32_i32$2 = $14;
  $266 = i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0;
  i64toi32_i32$0 = 0;
  $267$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $263$hi;
  i64toi32_i32$2 = i64toi32_i32$5;
  i64toi32_i32$3 = $267$hi;
  i64toi32_i32$1 = $266;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $268$hi = i64toi32_i32$5;
  i64toi32_i32$0 = ($3 + 256 | 0) + 8 | 0;
  i64toi32_i32$5 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $272 = i64toi32_i32$5;
  $272$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $268$hi;
  i64toi32_i32$0 = i64toi32_i32$4;
  i64toi32_i32$5 = $272$hi;
  i64toi32_i32$1 = $272;
  i64toi32_i32$3 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $273$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $10$hi;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$4 = $10$hi;
  i64toi32_i32$2 = $10;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$1 = $8;
  $276 = i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$1 >>> 0 | 0) | 0;
  i64toi32_i32$2 = 0;
  $277$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $273$hi;
  i64toi32_i32$1 = i64toi32_i32$3;
  i64toi32_i32$4 = $277$hi;
  i64toi32_i32$0 = $276;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  i64toi32_i32$3 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
  }
  $278$hi = i64toi32_i32$3;
  i64toi32_i32$2 = ($3 + 304 | 0) + 8 | 0;
  i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $282 = i64toi32_i32$3;
  $282$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $278$hi;
  i64toi32_i32$2 = i64toi32_i32$5;
  i64toi32_i32$3 = $282$hi;
  i64toi32_i32$0 = $282;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $283$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $12$hi;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$5 = $12$hi;
  i64toi32_i32$1 = $12;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$0 = $10;
  $286 = i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$0 >>> 0 | 0) | 0;
  i64toi32_i32$1 = 0;
  $287$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $283$hi;
  i64toi32_i32$0 = i64toi32_i32$4;
  i64toi32_i32$5 = $287$hi;
  i64toi32_i32$2 = $286;
  i64toi32_i32$3 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$3 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $288$hi = i64toi32_i32$4;
  i64toi32_i32$1 = ($3 + 352 | 0) + 8 | 0;
  i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $292 = i64toi32_i32$4;
  $292$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $288$hi;
  i64toi32_i32$1 = i64toi32_i32$3;
  i64toi32_i32$4 = $292$hi;
  i64toi32_i32$2 = $292;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$3 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
  }
  $293$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $9$hi;
  i64toi32_i32$3 = $12$hi;
  i64toi32_i32$3 = $9$hi;
  i64toi32_i32$0 = $9;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$2 = $12;
  $296 = i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0;
  i64toi32_i32$0 = 0;
  $297$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $293$hi;
  i64toi32_i32$2 = i64toi32_i32$5;
  i64toi32_i32$3 = $297$hi;
  i64toi32_i32$1 = $296;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $298$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $11$hi;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$5 = $11$hi;
  i64toi32_i32$0 = $11;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$1 = $9;
  $301 = i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0 | 0) | 0;
  i64toi32_i32$0 = 0;
  $302$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $298$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$5 = $302$hi;
  i64toi32_i32$2 = $301;
  i64toi32_i32$3 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$3 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  i64toi32_i32$0 = i64toi32_i32$3;
  i64toi32_i32$1 = 0;
  i64toi32_i32$2 = 13;
  i64toi32_i32$5 = i64toi32_i32$2 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$5 | 0;
   $268 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$5 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$5 | 0) | 0) | 0 | (i64toi32_i32$4 << i64toi32_i32$5 | 0) | 0;
   $268 = i64toi32_i32$0 << i64toi32_i32$5 | 0;
  }
  $304$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $254$hi;
  i64toi32_i32$4 = $254;
  i64toi32_i32$0 = $304$hi;
  i64toi32_i32$2 = $268;
  i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
  $305 = i64toi32_i32$4 | i64toi32_i32$2 | 0;
  $305$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $167$hi;
  i64toi32_i32$1 = $167;
  i64toi32_i32$4 = $305$hi;
  i64toi32_i32$2 = $305;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$3 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
  }
  $8 = i64toi32_i32$5;
  $8$hi = i64toi32_i32$3;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$1 = 524287;
  i64toi32_i32$2 = -1;
  i64toi32_i32$1 = i64toi32_i32$3 & i64toi32_i32$1 | 0;
  $308 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
  i64toi32_i32$0 = $148;
  HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $308;
  HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$1;
  $309 = $0;
  i64toi32_i32$3 = $3;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 160 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 164 | 0) >> 2] | 0;
  $17 = i64toi32_i32$1;
  $17$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 112 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 116 | 0) >> 2] | 0;
  $314 = i64toi32_i32$0;
  $314$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $17$hi;
  i64toi32_i32$3 = $17;
  i64toi32_i32$0 = $314$hi;
  i64toi32_i32$2 = $314;
  i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $10 = i64toi32_i32$4;
  $10$hi = i64toi32_i32$5;
  i64toi32_i32$1 = $3;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 208 | 0) >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 212 | 0) >> 2] | 0;
  $318 = i64toi32_i32$5;
  $318$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $10$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$5 = $318$hi;
  i64toi32_i32$2 = $318;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $12 = i64toi32_i32$0;
  $12$hi = i64toi32_i32$4;
  i64toi32_i32$3 = $3;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$3 + 48 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 52 | 0) >> 2] | 0;
  $322 = i64toi32_i32$4;
  $322$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$3 = i64toi32_i32$0;
  i64toi32_i32$4 = $322$hi;
  i64toi32_i32$2 = $322;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $9 = i64toi32_i32$5;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 384 | 0) >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 388 | 0) >> 2] | 0;
  $326 = i64toi32_i32$0;
  $326$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $9$hi;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$0 = $326$hi;
  i64toi32_i32$2 = $326;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$5 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $16 = i64toi32_i32$4;
  $16$hi = i64toi32_i32$5;
  $328 = i64toi32_i32$4;
  $328$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$1 = 0;
  i64toi32_i32$2 = 51;
  i64toi32_i32$0 = i64toi32_i32$2 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $269 = i64toi32_i32$5 >>> i64toi32_i32$0 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$5 >>> i64toi32_i32$0 | 0;
   $269 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$0 | 0) | 0;
  }
  $330 = $269;
  $330$hi = i64toi32_i32$1;
  i64toi32_i32$5 = ($3 + 144 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$5 >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
  $334 = i64toi32_i32$1;
  $334$hi = i64toi32_i32$3;
  i64toi32_i32$5 = ($3 + 96 | 0) + 8 | 0;
  i64toi32_i32$3 = HEAP32[i64toi32_i32$5 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
  $338 = i64toi32_i32$3;
  $338$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $334$hi;
  i64toi32_i32$5 = $334;
  i64toi32_i32$3 = $338$hi;
  i64toi32_i32$2 = $338;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $339$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $4$hi;
  i64toi32_i32$4 = $13$hi;
  i64toi32_i32$4 = $4$hi;
  i64toi32_i32$1 = $4;
  i64toi32_i32$5 = $13$hi;
  i64toi32_i32$2 = $13;
  $342 = i64toi32_i32$4 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0;
  i64toi32_i32$1 = 0;
  $343$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $339$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$4 = $343$hi;
  i64toi32_i32$5 = $342;
  i64toi32_i32$3 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$3 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $344$hi = i64toi32_i32$0;
  i64toi32_i32$1 = ($3 + 32 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $348 = i64toi32_i32$0;
  $348$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $344$hi;
  i64toi32_i32$1 = i64toi32_i32$3;
  i64toi32_i32$0 = $348$hi;
  i64toi32_i32$5 = $348;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  i64toi32_i32$3 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
  }
  $349$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $5$hi;
  i64toi32_i32$3 = $4$hi;
  i64toi32_i32$3 = $5$hi;
  i64toi32_i32$2 = $5;
  i64toi32_i32$1 = $4$hi;
  i64toi32_i32$5 = $4;
  $352 = i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0 | 0) | 0;
  i64toi32_i32$2 = 0;
  $353$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $349$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$3 = $353$hi;
  i64toi32_i32$1 = $352;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $354$hi = i64toi32_i32$4;
  i64toi32_i32$2 = ($3 + 320 | 0) + 8 | 0;
  i64toi32_i32$4 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $358 = i64toi32_i32$4;
  $358$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $354$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$4 = $358$hi;
  i64toi32_i32$1 = $358;
  i64toi32_i32$3 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $359$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$0 = $5$hi;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$5 = $6;
  i64toi32_i32$2 = $5$hi;
  i64toi32_i32$1 = $5;
  $362 = i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$5 >>> 0 < i64toi32_i32$1 >>> 0 | 0) | 0;
  i64toi32_i32$5 = 0;
  $363$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $359$hi;
  i64toi32_i32$1 = i64toi32_i32$3;
  i64toi32_i32$0 = $363$hi;
  i64toi32_i32$2 = $362;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$3 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
  }
  $364$hi = i64toi32_i32$3;
  i64toi32_i32$5 = ($3 + 368 | 0) + 8 | 0;
  i64toi32_i32$3 = HEAP32[i64toi32_i32$5 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
  $368 = i64toi32_i32$3;
  $368$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $364$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$3 = $368$hi;
  i64toi32_i32$2 = $368;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $369$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$4 = $6$hi;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$1 = $7;
  i64toi32_i32$5 = $6$hi;
  i64toi32_i32$2 = $6;
  $372 = i64toi32_i32$4 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0;
  i64toi32_i32$1 = 0;
  $373$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $369$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$4 = $373$hi;
  i64toi32_i32$5 = $372;
  i64toi32_i32$3 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$3 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $374$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$1 = $8;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$5 = $7;
  $377 = i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$5 >>> 0 | 0) | 0;
  i64toi32_i32$1 = 0;
  $378$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $374$hi;
  i64toi32_i32$5 = i64toi32_i32$3;
  i64toi32_i32$0 = $378$hi;
  i64toi32_i32$2 = $377;
  i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
  i64toi32_i32$3 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
  }
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$5 = 0;
  i64toi32_i32$2 = 13;
  i64toi32_i32$0 = i64toi32_i32$2 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$1 << i64toi32_i32$0 | 0;
   $270 = 0;
  } else {
   i64toi32_i32$5 = ((1 << i64toi32_i32$0 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$0 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$0 | 0) | 0;
   $270 = i64toi32_i32$1 << i64toi32_i32$0 | 0;
  }
  $380$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $330$hi;
  i64toi32_i32$3 = $330;
  i64toi32_i32$1 = $380$hi;
  i64toi32_i32$2 = $270;
  i64toi32_i32$1 = i64toi32_i32$5 | i64toi32_i32$1 | 0;
  $381 = i64toi32_i32$3 | i64toi32_i32$2 | 0;
  $381$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $328$hi;
  i64toi32_i32$5 = $328;
  i64toi32_i32$3 = $381$hi;
  i64toi32_i32$2 = $381;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$4;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$5 = 524287;
  i64toi32_i32$2 = -1;
  i64toi32_i32$5 = i64toi32_i32$4 & i64toi32_i32$5 | 0;
  i64toi32_i32$1 = $309;
  HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = i64toi32_i32$0 & i64toi32_i32$2 | 0;
  HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = i64toi32_i32$5;
  $385 = $0;
  i64toi32_i32$4 = $3;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 176 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$4 + 180 | 0) >> 2] | 0;
  $13 = i64toi32_i32$5;
  $13$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$4 + 128 | 0) >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 132 | 0) >> 2] | 0;
  $390 = i64toi32_i32$1;
  $390$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $13$hi;
  i64toi32_i32$4 = $13;
  i64toi32_i32$1 = $390$hi;
  i64toi32_i32$2 = $390;
  i64toi32_i32$3 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$3 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $5 = i64toi32_i32$3;
  $5$hi = i64toi32_i32$0;
  i64toi32_i32$5 = $3;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$5 + 224 | 0) >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 228 | 0) >> 2] | 0;
  $394 = i64toi32_i32$0;
  $394$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $5$hi;
  i64toi32_i32$5 = i64toi32_i32$3;
  i64toi32_i32$0 = $394$hi;
  i64toi32_i32$2 = $394;
  i64toi32_i32$1 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
  i64toi32_i32$3 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
  }
  $6 = i64toi32_i32$1;
  $6$hi = i64toi32_i32$3;
  i64toi32_i32$4 = $3;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 272 | 0) >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 276 | 0) >> 2] | 0;
  $398 = i64toi32_i32$3;
  $398$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $6$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$3 = $398$hi;
  i64toi32_i32$2 = $398;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$5 = $3;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 64 | 0) >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 68 | 0) >> 2] | 0;
  $402 = i64toi32_i32$1;
  $402$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = i64toi32_i32$0;
  i64toi32_i32$1 = $402$hi;
  i64toi32_i32$2 = $402;
  i64toi32_i32$3 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$3 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $8 = i64toi32_i32$3;
  $8$hi = i64toi32_i32$0;
  $404 = i64toi32_i32$3;
  $404$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $4$hi;
  i64toi32_i32$4 = $4;
  i64toi32_i32$5 = 0;
  i64toi32_i32$2 = 51;
  i64toi32_i32$1 = i64toi32_i32$2 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
   i64toi32_i32$5 = 0;
   $271 = i64toi32_i32$0 >>> i64toi32_i32$1 | 0;
  } else {
   i64toi32_i32$5 = i64toi32_i32$0 >>> i64toi32_i32$1 | 0;
   $271 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$1 | 0) | 0;
  }
  $406 = $271;
  $406$hi = i64toi32_i32$5;
  i64toi32_i32$0 = ($3 + 160 | 0) + 8 | 0;
  i64toi32_i32$5 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $410 = i64toi32_i32$5;
  $410$hi = i64toi32_i32$4;
  i64toi32_i32$0 = ($3 + 112 | 0) + 8 | 0;
  i64toi32_i32$4 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $414 = i64toi32_i32$4;
  $414$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $410$hi;
  i64toi32_i32$0 = $410;
  i64toi32_i32$4 = $414$hi;
  i64toi32_i32$2 = $414;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  i64toi32_i32$3 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
  }
  $415$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $10$hi;
  i64toi32_i32$3 = $17$hi;
  i64toi32_i32$3 = $10$hi;
  i64toi32_i32$5 = $10;
  i64toi32_i32$0 = $17$hi;
  i64toi32_i32$2 = $17;
  $418 = i64toi32_i32$3 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0;
  i64toi32_i32$5 = 0;
  $419$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $415$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$3 = $419$hi;
  i64toi32_i32$0 = $418;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $420$hi = i64toi32_i32$1;
  i64toi32_i32$5 = ($3 + 208 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$5 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
  $424 = i64toi32_i32$1;
  $424$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $420$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$1 = $424$hi;
  i64toi32_i32$0 = $424;
  i64toi32_i32$3 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$3 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $425$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $12$hi;
  i64toi32_i32$4 = $10$hi;
  i64toi32_i32$4 = $12$hi;
  i64toi32_i32$2 = $12;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$0 = $10;
  $428 = i64toi32_i32$4 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$0 >>> 0 | 0) | 0;
  i64toi32_i32$2 = 0;
  $429$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $425$hi;
  i64toi32_i32$0 = i64toi32_i32$3;
  i64toi32_i32$4 = $429$hi;
  i64toi32_i32$5 = $428;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  i64toi32_i32$3 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
  }
  $430$hi = i64toi32_i32$3;
  i64toi32_i32$2 = ($3 + 48 | 0) + 8 | 0;
  i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $434 = i64toi32_i32$3;
  $434$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $430$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$3 = $434$hi;
  i64toi32_i32$5 = $434;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $435$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$0 = $9;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$5 = $12;
  $438 = i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0 | 0) | 0;
  i64toi32_i32$0 = 0;
  $439$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $435$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$1 = $439$hi;
  i64toi32_i32$2 = $438;
  i64toi32_i32$3 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$3 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $440$hi = i64toi32_i32$4;
  i64toi32_i32$0 = ($3 + 384 | 0) + 8 | 0;
  i64toi32_i32$4 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $444 = i64toi32_i32$4;
  $444$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $440$hi;
  i64toi32_i32$0 = i64toi32_i32$3;
  i64toi32_i32$4 = $444$hi;
  i64toi32_i32$2 = $444;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  i64toi32_i32$3 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
  }
  $445$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $16$hi;
  i64toi32_i32$3 = $9$hi;
  i64toi32_i32$3 = $16$hi;
  i64toi32_i32$5 = $16;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$2 = $9;
  $448 = i64toi32_i32$3 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0;
  i64toi32_i32$5 = 0;
  $449$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $445$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$3 = $449$hi;
  i64toi32_i32$0 = $448;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $450$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $4$hi;
  i64toi32_i32$1 = $16$hi;
  i64toi32_i32$1 = $4$hi;
  i64toi32_i32$5 = $4;
  i64toi32_i32$2 = $16$hi;
  i64toi32_i32$0 = $16;
  $453 = i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$5 >>> 0 < i64toi32_i32$0 >>> 0 | 0) | 0;
  i64toi32_i32$5 = 0;
  $454$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $450$hi;
  i64toi32_i32$0 = i64toi32_i32$4;
  i64toi32_i32$1 = $454$hi;
  i64toi32_i32$2 = $453;
  i64toi32_i32$3 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$3 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  i64toi32_i32$5 = i64toi32_i32$3;
  i64toi32_i32$0 = 0;
  i64toi32_i32$2 = 13;
  i64toi32_i32$1 = i64toi32_i32$2 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$5 << i64toi32_i32$1 | 0;
   $273 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$1 | 0) - 1 | 0) & (i64toi32_i32$5 >>> (32 - i64toi32_i32$1 | 0) | 0) | 0 | (i64toi32_i32$4 << i64toi32_i32$1 | 0) | 0;
   $273 = i64toi32_i32$5 << i64toi32_i32$1 | 0;
  }
  $456$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $406$hi;
  i64toi32_i32$4 = $406;
  i64toi32_i32$5 = $456$hi;
  i64toi32_i32$2 = $273;
  i64toi32_i32$5 = i64toi32_i32$0 | i64toi32_i32$5 | 0;
  $457 = i64toi32_i32$4 | i64toi32_i32$2 | 0;
  $457$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $404$hi;
  i64toi32_i32$0 = $404;
  i64toi32_i32$4 = $457$hi;
  i64toi32_i32$2 = $457;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  i64toi32_i32$3 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
  }
  $4 = i64toi32_i32$1;
  $4$hi = i64toi32_i32$3;
  i64toi32_i32$5 = i64toi32_i32$1;
  i64toi32_i32$0 = 524287;
  i64toi32_i32$2 = -1;
  i64toi32_i32$0 = i64toi32_i32$3 & i64toi32_i32$0 | 0;
  i64toi32_i32$5 = $385;
  HEAP32[(i64toi32_i32$5 + 32 | 0) >> 2] = i64toi32_i32$1 & i64toi32_i32$2 | 0;
  HEAP32[(i64toi32_i32$5 + 36 | 0) >> 2] = i64toi32_i32$0;
  $461 = $0;
  i64toi32_i32$0 = i64toi32_i32$3;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$5 = 0;
  i64toi32_i32$2 = 51;
  i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
   i64toi32_i32$5 = 0;
   $274 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$5 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $274 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$4 | 0) | 0;
  }
  $463 = $274;
  $463$hi = i64toi32_i32$5;
  i64toi32_i32$0 = ($3 + 176 | 0) + 8 | 0;
  i64toi32_i32$5 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $467 = i64toi32_i32$5;
  $467$hi = i64toi32_i32$3;
  i64toi32_i32$0 = ($3 + 128 | 0) + 8 | 0;
  i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $471 = i64toi32_i32$3;
  $471$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $467$hi;
  i64toi32_i32$0 = $467;
  i64toi32_i32$3 = $471$hi;
  i64toi32_i32$2 = $471;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $472$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $5$hi;
  i64toi32_i32$1 = $13$hi;
  i64toi32_i32$1 = $5$hi;
  i64toi32_i32$5 = $5;
  i64toi32_i32$0 = $13$hi;
  i64toi32_i32$2 = $13;
  $475 = i64toi32_i32$1 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0;
  i64toi32_i32$5 = 0;
  $476$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $472$hi;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$1 = $476$hi;
  i64toi32_i32$0 = $475;
  i64toi32_i32$3 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$3 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $477$hi = i64toi32_i32$4;
  i64toi32_i32$5 = ($3 + 224 | 0) + 8 | 0;
  i64toi32_i32$4 = HEAP32[i64toi32_i32$5 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
  $481 = i64toi32_i32$4;
  $481$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $477$hi;
  i64toi32_i32$5 = i64toi32_i32$3;
  i64toi32_i32$4 = $481$hi;
  i64toi32_i32$0 = $481;
  i64toi32_i32$1 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
  i64toi32_i32$3 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
  }
  $482$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $6$hi;
  i64toi32_i32$3 = $5$hi;
  i64toi32_i32$3 = $6$hi;
  i64toi32_i32$2 = $6;
  i64toi32_i32$5 = $5$hi;
  i64toi32_i32$0 = $5;
  $485 = i64toi32_i32$3 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$0 >>> 0 | 0) | 0;
  i64toi32_i32$2 = 0;
  $486$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $482$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$3 = $486$hi;
  i64toi32_i32$5 = $485;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $487$hi = i64toi32_i32$1;
  i64toi32_i32$2 = ($3 + 272 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $491 = i64toi32_i32$1;
  $491$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $487$hi;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$1 = $491$hi;
  i64toi32_i32$5 = $491;
  i64toi32_i32$3 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$3 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $492$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$4 = $6$hi;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$0 = $7;
  i64toi32_i32$2 = $6$hi;
  i64toi32_i32$5 = $6;
  $495 = i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0 | 0) | 0;
  i64toi32_i32$0 = 0;
  $496$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $492$hi;
  i64toi32_i32$5 = i64toi32_i32$3;
  i64toi32_i32$4 = $496$hi;
  i64toi32_i32$2 = $495;
  i64toi32_i32$1 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
  i64toi32_i32$3 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
  }
  $497$hi = i64toi32_i32$3;
  i64toi32_i32$0 = ($3 + 64 | 0) + 8 | 0;
  i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $501 = i64toi32_i32$3;
  $501$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $497$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$3 = $501$hi;
  i64toi32_i32$2 = $501;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $502$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$5 = $8;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = $7;
  $505 = i64toi32_i32$1 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0;
  i64toi32_i32$5 = 0;
  $506$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $502$hi;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$1 = $506$hi;
  i64toi32_i32$0 = $505;
  i64toi32_i32$3 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$3 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $507$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $4$hi;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$4 = $4$hi;
  i64toi32_i32$5 = $4;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$0 = $8;
  $510 = i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$5 >>> 0 < i64toi32_i32$0 >>> 0 | 0) | 0;
  i64toi32_i32$5 = 0;
  $511$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $507$hi;
  i64toi32_i32$0 = i64toi32_i32$3;
  i64toi32_i32$4 = $511$hi;
  i64toi32_i32$2 = $510;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  i64toi32_i32$3 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
  }
  i64toi32_i32$5 = i64toi32_i32$1;
  i64toi32_i32$0 = 0;
  i64toi32_i32$2 = 13;
  i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$5 << i64toi32_i32$4 | 0;
   $275 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$5 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$4 | 0) | 0;
   $275 = i64toi32_i32$5 << i64toi32_i32$4 | 0;
  }
  $513$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $463$hi;
  i64toi32_i32$3 = $463;
  i64toi32_i32$5 = $513$hi;
  i64toi32_i32$2 = $275;
  i64toi32_i32$5 = i64toi32_i32$0 | i64toi32_i32$5 | 0;
  $278 = i64toi32_i32$3 | i64toi32_i32$2 | 0;
  i64toi32_i32$3 = 0;
  i64toi32_i32$3 = __wasm_i64_mul($278 | 0, i64toi32_i32$5 | 0, 19 | 0, i64toi32_i32$3 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $515 = i64toi32_i32$3;
  $515$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $18$hi;
  i64toi32_i32$0 = $18;
  i64toi32_i32$3 = 524287;
  i64toi32_i32$2 = -1;
  i64toi32_i32$3 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
  $517 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
  $517$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $515$hi;
  i64toi32_i32$5 = $515;
  i64toi32_i32$0 = $517$hi;
  i64toi32_i32$2 = $517;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
  i64toi32_i32$1 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $4 = i64toi32_i32$4;
  $4$hi = i64toi32_i32$1;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$5 = 524287;
  i64toi32_i32$2 = -1;
  i64toi32_i32$5 = i64toi32_i32$1 & i64toi32_i32$5 | 0;
  $520 = i64toi32_i32$3 & i64toi32_i32$2 | 0;
  i64toi32_i32$3 = $461;
  HEAP32[i64toi32_i32$3 >> 2] = $520;
  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
  $521 = $0;
  i64toi32_i32$5 = i64toi32_i32$1;
  i64toi32_i32$5 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$3 = 0;
  i64toi32_i32$2 = 51;
  i64toi32_i32$0 = i64toi32_i32$2 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
   i64toi32_i32$3 = 0;
   $277 = i64toi32_i32$5 >>> i64toi32_i32$0 | 0;
  } else {
   i64toi32_i32$3 = i64toi32_i32$5 >>> i64toi32_i32$0 | 0;
   $277 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$0 | 0) | 0;
  }
  $523$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $11$hi;
  i64toi32_i32$5 = $11;
  i64toi32_i32$1 = 524287;
  i64toi32_i32$2 = -1;
  i64toi32_i32$1 = i64toi32_i32$3 & i64toi32_i32$1 | 0;
  $525 = i64toi32_i32$5 & i64toi32_i32$2 | 0;
  $525$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $523$hi;
  i64toi32_i32$3 = $277;
  i64toi32_i32$5 = $525$hi;
  i64toi32_i32$2 = $525;
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  i64toi32_i32$3 = $521;
  HEAP32[(i64toi32_i32$3 + 8 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$3 + 12 | 0) >> 2] = i64toi32_i32$4;
  global$0 = $3 + 400 | 0;
 }
 
 function $cardano_serialization_lib__metadata__TransactionMetadatumEnum_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h6868ff659c396c1d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $6 = 0, $6$hi = 0, $3 = 0, $4 = 0, $5 = 0, $27 = 0, $28 = 0, $29 = 0, $30 = 0, $47 = 0, $53 = 0, $71 = 0, $180 = 0, $188 = 0, $203 = 0, $231 = 0, $235 = 0, $239 = 0, $314 = 0, $322 = 0, $337 = 0, $365 = 0, $369 = 0, $373 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          if (!(HEAP32[($2 + 4 | 0) >> 2] | 0)) {
           break label$8
          }
          switch (($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[$2 >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) {
          case 2:
           break label$2;
          case 3:
           break label$3;
          case 5:
           break label$4;
          case 4:
           break label$5;
          case 0:
          case 1:
           break label$6;
          default:
           break label$7;
          };
         }
         HEAP8[($0 + 8 | 0) >> 0] = 2;
         i64toi32_i32$1 = $0;
         i64toi32_i32$0 = 0;
         HEAP32[$0 >> 2] = 1;
         HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$1 = $0 + 20 | 0;
         i64toi32_i32$0 = 0;
         HEAP32[i64toi32_i32$1 >> 2] = 0;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
         HEAP8[($0 + 16 | 0) >> 0] = 8;
         HEAP32[($0 + 56 | 0) >> 2] = 0;
         break label$1;
        }
        alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($2 + 152 | 0 | 0, 1059888 | 0, 24 | 0);
        HEAP8[($2 + 104 | 0) >> 0] = 11;
        memcpy($0 + 8 | 0 | 0, $2 + 104 | 0 | 0, 64 | 0) | 0;
        i64toi32_i32$1 = $0;
        i64toi32_i32$0 = 0;
        HEAP32[$0 >> 2] = 1;
        HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$0;
        break label$1;
       }
       $cardano_serialization_lib__utils__Int_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h5b6b41ff800f0b26($2 + 104 | 0 | 0, $1 | 0);
       i64toi32_i32$0 = 0;
       $6 = 1;
       $6$hi = i64toi32_i32$0;
       label$9 : {
        label$10 : {
         i64toi32_i32$2 = $2;
         i64toi32_i32$0 = HEAP32[($2 + 104 | 0) >> 2] | 0;
         i64toi32_i32$1 = HEAP32[($2 + 108 | 0) >> 2] | 0;
         i64toi32_i32$2 = i64toi32_i32$0;
         i64toi32_i32$0 = 0;
         i64toi32_i32$3 = 1;
         if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
          break label$10
         }
         HEAP32[($0 + 8 | 0) >> 2] = 2;
         i64toi32_i32$3 = $2;
         i64toi32_i32$2 = HEAP32[($2 + 112 | 0) >> 2] | 0;
         i64toi32_i32$1 = HEAP32[($2 + 116 | 0) >> 2] | 0;
         $47 = i64toi32_i32$2;
         i64toi32_i32$2 = $0 + 16 | 0;
         HEAP32[i64toi32_i32$2 >> 2] = $47;
         HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$3 = ($2 + 104 | 0) + 16 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $53 = i64toi32_i32$1;
         i64toi32_i32$1 = $0 + 24 | 0;
         HEAP32[i64toi32_i32$1 >> 2] = $53;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
         i64toi32_i32$2 = 0;
         $6 = 0;
         $6$hi = i64toi32_i32$2;
         break label$9;
        }
        memcpy($0 + 8 | 0 | 0, ($2 + 104 | 0) + 8 | 0 | 0, 64 | 0) | 0;
       }
       i64toi32_i32$2 = $6$hi;
       i64toi32_i32$1 = $0;
       HEAP32[$0 >> 2] = $6;
       HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$2;
       break label$1;
      }
      $cardano_serialization_lib__metadata__MetadataList_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h6a4931784602dba8($2 + 104 | 0 | 0, $1 | 0);
      label$11 : {
       label$12 : {
        if ((HEAP32[($2 + 104 | 0) >> 2] | 0 | 0) == (1 | 0)) {
         break label$12
        }
        HEAP32[($0 + 8 | 0) >> 2] = 1;
        i64toi32_i32$3 = $2;
        i64toi32_i32$2 = HEAP32[($2 + 108 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 112 | 0) >> 2] | 0;
        $71 = i64toi32_i32$2;
        i64toi32_i32$2 = $0;
        HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = $71;
        HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] = i64toi32_i32$1;
        HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] = HEAP32[($2 + 116 | 0) >> 2] | 0;
        i64toi32_i32$1 = 0;
        $6 = 0;
        $6$hi = i64toi32_i32$1;
        break label$11;
       }
       memcpy($0 + 8 | 0 | 0, ($2 + 104 | 0) + 8 | 0 | 0, 64 | 0) | 0;
       i64toi32_i32$1 = 0;
       $6 = 1;
       $6$hi = i64toi32_i32$1;
      }
      i64toi32_i32$1 = $6$hi;
      i64toi32_i32$2 = $0;
      HEAP32[i64toi32_i32$2 >> 2] = $6;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      break label$1;
     }
     $cardano_serialization_lib__metadata__MetadataMap_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h8f4b3182d8f5ec31($2 + 104 | 0 | 0, $1 | 0);
     i64toi32_i32$1 = 0;
     $6 = 1;
     $6$hi = i64toi32_i32$1;
     $1 = ($2 + 104 | 0) + 8 | 0;
     label$13 : {
      label$14 : {
       i64toi32_i32$3 = $2;
       i64toi32_i32$1 = HEAP32[($2 + 104 | 0) >> 2] | 0;
       i64toi32_i32$2 = HEAP32[($2 + 108 | 0) >> 2] | 0;
       i64toi32_i32$3 = i64toi32_i32$1;
       i64toi32_i32$1 = 0;
       i64toi32_i32$0 = 1;
       if ((i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$1 | 0) | 0) {
        break label$14
       }
       memcpy($2 + 60 | 0 | 0, $1 | 0, 40 | 0) | 0;
       HEAP32[($0 + 8 | 0) >> 2] = 0;
       memcpy($0 + 12 | 0 | 0, $2 + 56 | 0 | 0, 44 | 0) | 0;
       i64toi32_i32$3 = 0;
       $6 = 0;
       $6$hi = i64toi32_i32$3;
       break label$13;
      }
      memcpy($0 + 8 | 0 | 0, $1 | 0, 64 | 0) | 0;
     }
     i64toi32_i32$3 = $6$hi;
     i64toi32_i32$2 = $0;
     HEAP32[i64toi32_i32$2 >> 2] = $6;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
     break label$1;
    }
    cbor_event__de__Deserializer_R___text__h764f26557f652908($2 + 56 | 0 | 0, $1 | 0);
    label$15 : {
     if ((HEAP32[($2 + 56 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$15
     }
     $1 = HEAPU8[($2 + 67 | 0) >> 0] | 0;
     HEAP8[($2 + 54 | 0) >> 0] = $1;
     $3 = HEAPU8[($2 + 65 | 0) >> 0] | 0 | ((HEAPU8[($2 + 66 | 0) >> 0] | 0) << 8 | 0) | 0;
     HEAP16[($2 + 52 | 0) >> 1] = $3;
     HEAP32[($2 + 8 | 0) >> 2] = HEAP32[($2 + 60 | 0) >> 2] | 0;
     HEAP8[($2 + 13 | 0) >> 0] = $3;
     HEAP8[($2 + 14 | 0) >> 0] = $3 >>> 8 | 0;
     HEAP8[($2 + 12 | 0) >> 0] = HEAPU8[(($2 + 56 | 0) + 8 | 0) >> 0] | 0;
     HEAP8[($2 + 15 | 0) >> 0] = $1;
     HEAP32[($2 + 16 | 0) >> 2] = HEAP32[(($2 + 56 | 0) + 12 | 0) >> 2] | 0;
     cardano_serialization_lib__metadata__TransactionMetadatum__new_text__hc705d7de2d476a57($2 + 104 | 0 | 0, $2 + 8 | 0 | 0);
     label$16 : {
      label$17 : {
       if ((HEAP32[($2 + 104 | 0) >> 2] | 0 | 0) == (1 | 0)) {
        break label$17
       }
       memcpy($0 + 8 | 0 | 0, ($2 + 104 | 0) + 8 | 0 | 0, 48 | 0) | 0;
       i64toi32_i32$3 = 0;
       $6 = 0;
       $6$hi = i64toi32_i32$3;
       break label$16;
      }
      $1 = HEAP32[($2 + 108 | 0) >> 2] | 0;
      HEAP32[($0 + 56 | 0) >> 2] = 0;
      HEAP32[($0 + 12 | 0) >> 2] = $1;
      HEAP8[($0 + 8 | 0) >> 0] = 10;
      i64toi32_i32$3 = 0;
      $6 = 1;
      $6$hi = i64toi32_i32$3;
     }
     i64toi32_i32$3 = $6$hi;
     i64toi32_i32$2 = $0;
     HEAP32[i64toi32_i32$2 >> 2] = $6;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
     break label$1;
    }
    $1 = ($2 + 52 | 0) + 2 | 0;
    HEAP8[$1 >> 0] = HEAPU8[($2 + 67 | 0) >> 0] | 0;
    $3 = ($2 + 24 | 0) + 8 | 0;
    i64toi32_i32$0 = ($2 + 56 | 0) + 28 | 0;
    i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
    $180 = i64toi32_i32$3;
    i64toi32_i32$3 = $3;
    HEAP32[i64toi32_i32$3 >> 2] = $180;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
    $4 = ($2 + 24 | 0) + 16 | 0;
    i64toi32_i32$0 = ($2 + 56 | 0) + 36 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
    $188 = i64toi32_i32$2;
    i64toi32_i32$2 = $4;
    HEAP32[i64toi32_i32$2 >> 2] = $188;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
    $5 = $2 + 48 | 0;
    HEAP32[$5 >> 2] = HEAP32[(($2 + 56 | 0) + 44 | 0) >> 2] | 0;
    HEAP16[($2 + 52 | 0) >> 1] = HEAPU8[($2 + 65 | 0) >> 0] | 0 | ((HEAPU8[($2 + 66 | 0) >> 0] | 0) << 8 | 0) | 0;
    i64toi32_i32$0 = ($2 + 56 | 0) + 20 | 0;
    i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
    $203 = i64toi32_i32$3;
    i64toi32_i32$3 = $2;
    HEAP32[($2 + 24 | 0) >> 2] = $203;
    HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$0 = $2 + 68 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
    $6 = i64toi32_i32$2;
    $6$hi = i64toi32_i32$3;
    HEAP8[($0 + 16 | 0) >> 0] = HEAPU8[(($2 + 56 | 0) + 8 | 0) >> 0] | 0;
    HEAP8[($0 + 8 | 0) >> 0] = 2;
    HEAP32[($0 + 56 | 0) >> 2] = 0;
    i64toi32_i32$2 = $0 + 20 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $6;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
    $27 = $0 + 17 | 0;
    $28 = HEAPU16[($2 + 52 | 0) >> 1] | 0;
    HEAP8[$27 >> 0] = $28;
    HEAP8[($27 + 1 | 0) >> 0] = $28 >>> 8 | 0;
    HEAP8[($0 + 19 | 0) >> 0] = HEAPU8[$1 >> 0] | 0;
    i64toi32_i32$2 = $0;
    i64toi32_i32$3 = 0;
    HEAP32[i64toi32_i32$2 >> 2] = 1;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
    i64toi32_i32$0 = $2;
    i64toi32_i32$3 = HEAP32[($2 + 24 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($2 + 28 | 0) >> 2] | 0;
    $231 = i64toi32_i32$3;
    i64toi32_i32$3 = $0 + 28 | 0;
    HEAP32[i64toi32_i32$3 >> 2] = $231;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$0 = $3;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
    $235 = i64toi32_i32$2;
    i64toi32_i32$2 = $0 + 36 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $235;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
    i64toi32_i32$0 = $4;
    i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
    $239 = i64toi32_i32$3;
    i64toi32_i32$3 = $0 + 44 | 0;
    HEAP32[i64toi32_i32$3 >> 2] = $239;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
    HEAP32[($0 + 52 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
    break label$1;
   }
   cbor_event__de__Deserializer_R___bytes__hc697ccccfa39fd82($2 + 56 | 0 | 0, $1 | 0);
   label$18 : {
    if ((HEAP32[($2 + 56 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$18
    }
    $1 = HEAPU8[($2 + 67 | 0) >> 0] | 0;
    HEAP8[($2 + 54 | 0) >> 0] = $1;
    $3 = HEAPU8[($2 + 65 | 0) >> 0] | 0 | ((HEAPU8[($2 + 66 | 0) >> 0] | 0) << 8 | 0) | 0;
    HEAP16[($2 + 52 | 0) >> 1] = $3;
    HEAP32[($2 + 8 | 0) >> 2] = HEAP32[($2 + 60 | 0) >> 2] | 0;
    HEAP8[($2 + 13 | 0) >> 0] = $3;
    HEAP8[($2 + 14 | 0) >> 0] = $3 >>> 8 | 0;
    HEAP8[($2 + 12 | 0) >> 0] = HEAPU8[(($2 + 56 | 0) + 8 | 0) >> 0] | 0;
    HEAP8[($2 + 15 | 0) >> 0] = $1;
    HEAP32[($2 + 16 | 0) >> 2] = HEAP32[(($2 + 56 | 0) + 12 | 0) >> 2] | 0;
    cardano_serialization_lib__metadata__TransactionMetadatum__new_bytes__h341a06dfb4f1da88($2 + 104 | 0 | 0, $2 + 8 | 0 | 0);
    label$19 : {
     label$20 : {
      if ((HEAP32[($2 + 104 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$20
      }
      memcpy($0 + 8 | 0 | 0, ($2 + 104 | 0) + 8 | 0 | 0, 48 | 0) | 0;
      i64toi32_i32$2 = 0;
      $6 = 0;
      $6$hi = i64toi32_i32$2;
      break label$19;
     }
     $1 = HEAP32[($2 + 108 | 0) >> 2] | 0;
     HEAP32[($0 + 56 | 0) >> 2] = 0;
     HEAP32[($0 + 12 | 0) >> 2] = $1;
     HEAP8[($0 + 8 | 0) >> 0] = 10;
     i64toi32_i32$2 = 0;
     $6 = 1;
     $6$hi = i64toi32_i32$2;
    }
    i64toi32_i32$2 = $6$hi;
    i64toi32_i32$3 = $0;
    HEAP32[$0 >> 2] = $6;
    HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$2;
    break label$1;
   }
   $1 = ($2 + 52 | 0) + 2 | 0;
   HEAP8[$1 >> 0] = HEAPU8[($2 + 67 | 0) >> 0] | 0;
   $3 = ($2 + 24 | 0) + 8 | 0;
   i64toi32_i32$0 = ($2 + 56 | 0) + 28 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $314 = i64toi32_i32$2;
   i64toi32_i32$2 = $3;
   HEAP32[i64toi32_i32$2 >> 2] = $314;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
   $4 = ($2 + 24 | 0) + 16 | 0;
   i64toi32_i32$0 = ($2 + 56 | 0) + 36 | 0;
   i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $322 = i64toi32_i32$3;
   i64toi32_i32$3 = $4;
   HEAP32[i64toi32_i32$3 >> 2] = $322;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
   $5 = $2 + 48 | 0;
   HEAP32[$5 >> 2] = HEAP32[(($2 + 56 | 0) + 44 | 0) >> 2] | 0;
   HEAP16[($2 + 52 | 0) >> 1] = HEAPU8[($2 + 65 | 0) >> 0] | 0 | ((HEAPU8[($2 + 66 | 0) >> 0] | 0) << 8 | 0) | 0;
   i64toi32_i32$0 = ($2 + 56 | 0) + 20 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $337 = i64toi32_i32$2;
   i64toi32_i32$2 = $2;
   HEAP32[($2 + 24 | 0) >> 2] = $337;
   HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$0 = $2 + 68 | 0;
   i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $6 = i64toi32_i32$3;
   $6$hi = i64toi32_i32$2;
   HEAP8[($0 + 16 | 0) >> 0] = HEAPU8[(($2 + 56 | 0) + 8 | 0) >> 0] | 0;
   HEAP8[($0 + 8 | 0) >> 0] = 2;
   HEAP32[($0 + 56 | 0) >> 2] = 0;
   i64toi32_i32$3 = $0 + 20 | 0;
   HEAP32[i64toi32_i32$3 >> 2] = $6;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
   $29 = $0 + 17 | 0;
   $30 = HEAPU16[($2 + 52 | 0) >> 1] | 0;
   HEAP8[$29 >> 0] = $30;
   HEAP8[($29 + 1 | 0) >> 0] = $30 >>> 8 | 0;
   HEAP8[($0 + 19 | 0) >> 0] = HEAPU8[$1 >> 0] | 0;
   i64toi32_i32$3 = $0;
   i64toi32_i32$2 = 0;
   HEAP32[$0 >> 2] = 1;
   HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = $2;
   i64toi32_i32$2 = HEAP32[($2 + 24 | 0) >> 2] | 0;
   i64toi32_i32$3 = HEAP32[($2 + 28 | 0) >> 2] | 0;
   $365 = i64toi32_i32$2;
   i64toi32_i32$2 = $0 + 28 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $365;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$0 = $3;
   i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $369 = i64toi32_i32$3;
   i64toi32_i32$3 = $0 + 36 | 0;
   HEAP32[i64toi32_i32$3 >> 2] = $369;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = $4;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $373 = i64toi32_i32$2;
   i64toi32_i32$2 = $0 + 44 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $373;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
   HEAP32[($0 + 52 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
  }
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__GenesisKeyDelegation___deserialize_as_embedded_group__h009fd03835fe23c0($0, $1, $2, $2$hi, $3, $3$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  var $4 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $12 = 0, $5 = 0, $12$hi = 0, $6 = 0, $8 = 0, i64toi32_i32$0 = 0, $7 = 0, i64toi32_i32$4 = 0, $9 = 0, $49 = 0, $50 = 0, $13 = 0, $13$hi = 0, $51 = 0, $10 = 0, $11 = 0, $14 = 0, $14$hi = 0, $112 = 0, $133 = 0, $138 = 0, $141 = 0, $157 = 0, $175 = 0, $180 = 0, $183 = 0, $204 = 0, $211 = 0, $228 = 0, $234 = 0, $240 = 0, $243 = 0, $257 = 0, $264 = 0, $267 = 0, $273 = 0, $279 = 0, $288 = 0, $292 = 0, $296 = 0, $300 = 0, $303 = 0;
  $4 = global$0 - 480 | 0;
  global$0 = $4;
  cbor_event__de__Deserializer_R___unsigned_integer__h1ed99c0b7fe7eea1($4 + 320 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 328 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 332 | 0) >> 2] | 0;
  $12 = i64toi32_i32$0;
  $12$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 320 | 0) >> 2] | 0;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 324 | 0) >> 2] | 0;
          i64toi32_i32$2 = i64toi32_i32$1;
          i64toi32_i32$1 = 0;
          i64toi32_i32$3 = 1;
          if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
           break label$8
          }
          i64toi32_i32$2 = 0;
          $13 = 5;
          $13$hi = i64toi32_i32$2;
          i64toi32_i32$2 = $12$hi;
          i64toi32_i32$3 = $12;
          i64toi32_i32$0 = 0;
          i64toi32_i32$1 = 5;
          if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) | 0) {
           break label$6
          }
          $5 = 8;
          $6 = 1;
          $7 = 1;
          break label$7;
         }
         i64toi32_i32$3 = $12$hi;
         i64toi32_i32$1 = $12;
         i64toi32_i32$2 = 0;
         i64toi32_i32$0 = 32;
         i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
          i64toi32_i32$2 = 0;
          $51 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
         } else {
          i64toi32_i32$2 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
          $51 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
         }
         $8 = $51;
         i64toi32_i32$3 = $4 + 360 | 0;
         i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $14 = i64toi32_i32$2;
         $14$hi = i64toi32_i32$1;
         i64toi32_i32$3 = $4 + 352 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $13 = i64toi32_i32$1;
         $13$hi = i64toi32_i32$2;
         $9 = HEAP32[($4 + 348 | 0) >> 2] | 0;
         $7 = HEAP32[($4 + 344 | 0) >> 2] | 0;
         i64toi32_i32$2 = $12$hi;
         $6 = $12;
         $5 = 2;
         i64toi32_i32$3 = $4 + 336 | 0;
         i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $12 = i64toi32_i32$2;
         $12$hi = i64toi32_i32$1;
        }
        i64toi32_i32$1 = $14$hi;
        i64toi32_i32$2 = $4 + 360 | 0;
        HEAP32[i64toi32_i32$2 >> 2] = $14;
        HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$1 = $13$hi;
        i64toi32_i32$2 = $4 + 352 | 0;
        HEAP32[i64toi32_i32$2 >> 2] = $13;
        HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
        HEAP32[($4 + 348 | 0) >> 2] = $9;
        HEAP32[($4 + 344 | 0) >> 2] = $7;
        i64toi32_i32$1 = $12$hi;
        i64toi32_i32$2 = $4 + 336 | 0;
        HEAP32[i64toi32_i32$2 >> 2] = $12;
        HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
        HEAP32[($4 + 332 | 0) >> 2] = $8;
        HEAP32[(($4 + 320 | 0) + 8 | 0) >> 2] = $6;
        HEAP32[($4 + 368 | 0) >> 2] = 0;
        HEAP8[($4 + 320 | 0) >> 0] = $5;
        cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($4 + 176 | 0 | 0, $4 + 320 | 0 | 0, 1050766 | 0, 7 | 0);
        $5 = HEAPU8[($4 + 176 | 0) >> 0] | 0;
        if (($5 | 0) != (19 | 0)) {
         break label$5
        }
       }
       $cardano_serialization_lib__crypto__GenesisHash_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h220401e78fc09fba($4 + 320 | 0 | 0, $1 | 0);
       if ((HEAPU8[($4 + 320 | 0) >> 0] | 0 | 0) == (1 | 0)) {
        break label$4
       }
       $7 = ($4 + 176 | 0) + 9 | 0;
       $9 = ($4 + 320 | 0) + 9 | 0;
       i64toi32_i32$3 = $9;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $12 = i64toi32_i32$1;
       $12$hi = i64toi32_i32$2;
       i64toi32_i32$1 = $7;
       HEAP8[i64toi32_i32$1 >> 0] = $12;
       HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $12 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $12 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $12 >>> 24 | 0;
       HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$2;
       HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
       $5 = ($4 + 104 | 0) + 24 | 0;
       $10 = $4 + 345 | 0;
       $49 = $10;
       HEAP32[$5 >> 2] = HEAPU8[$49 >> 0] | 0 | ((HEAPU8[($49 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($49 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($49 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $6 = ($4 + 104 | 0) + 16 | 0;
       $11 = $4 + 337 | 0;
       i64toi32_i32$3 = $11;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $112 = i64toi32_i32$2;
       i64toi32_i32$2 = $6;
       HEAP32[i64toi32_i32$2 >> 2] = $112;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       $8 = ($4 + 104 | 0) + 8 | 0;
       i64toi32_i32$1 = $12$hi;
       i64toi32_i32$2 = $8;
       HEAP32[i64toi32_i32$2 >> 2] = $12;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$3 = $4;
       i64toi32_i32$1 = HEAPU8[($4 + 321 | 0) >> 0] | 0 | ((HEAPU8[($4 + 322 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 323 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 324 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = HEAPU8[($4 + 325 | 0) >> 0] | 0 | ((HEAPU8[($4 + 326 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 327 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 328 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $12 = i64toi32_i32$1;
       $12$hi = i64toi32_i32$2;
       i64toi32_i32$1 = $4;
       HEAP8[($4 + 177 | 0) >> 0] = $12;
       HEAP8[($4 + 178 | 0) >> 0] = $12 >>> 8 | 0;
       HEAP8[($4 + 179 | 0) >> 0] = $12 >>> 16 | 0;
       HEAP8[($4 + 180 | 0) >> 0] = $12 >>> 24 | 0;
       HEAP8[($4 + 181 | 0) >> 0] = i64toi32_i32$2;
       HEAP8[($4 + 182 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
       HEAP8[($4 + 183 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
       HEAP8[($4 + 184 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
       i64toi32_i32$1 = $4;
       HEAP32[($4 + 104 | 0) >> 2] = $12;
       HEAP32[($4 + 108 | 0) >> 2] = i64toi32_i32$2;
       HEAP32[(($4 + 8 | 0) + 24 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
       i64toi32_i32$3 = $6;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $133 = i64toi32_i32$2;
       i64toi32_i32$2 = ($4 + 8 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $133;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$3 = $8;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $138 = i64toi32_i32$1;
       i64toi32_i32$1 = ($4 + 8 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $138;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$3 = $4;
       i64toi32_i32$2 = HEAP32[($4 + 104 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($4 + 108 | 0) >> 2] | 0;
       $141 = i64toi32_i32$2;
       i64toi32_i32$2 = $4;
       HEAP32[($4 + 8 | 0) >> 2] = $141;
       HEAP32[($4 + 12 | 0) >> 2] = i64toi32_i32$1;
       $cardano_serialization_lib__crypto__GenesisDelegateHash_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hd0c1349750fae386($4 + 320 | 0 | 0, $1 | 0);
       if ((HEAPU8[($4 + 320 | 0) >> 0] | 0 | 0) == (1 | 0)) {
        break label$3
       }
       i64toi32_i32$3 = $9;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $12 = i64toi32_i32$1;
       $12$hi = i64toi32_i32$2;
       i64toi32_i32$1 = $7;
       HEAP8[i64toi32_i32$1 >> 0] = $12;
       HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $12 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $12 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $12 >>> 24 | 0;
       HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$2;
       HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
       $50 = $10;
       HEAP32[$5 >> 2] = HEAPU8[$50 >> 0] | 0 | ((HEAPU8[($50 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($50 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($50 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$3 = $11;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $157 = i64toi32_i32$2;
       i64toi32_i32$2 = $6;
       HEAP32[i64toi32_i32$2 >> 2] = $157;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$1 = $12$hi;
       i64toi32_i32$2 = $8;
       HEAP32[i64toi32_i32$2 >> 2] = $12;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$3 = $4;
       i64toi32_i32$1 = HEAPU8[($4 + 321 | 0) >> 0] | 0 | ((HEAPU8[($4 + 322 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 323 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 324 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = HEAPU8[($4 + 325 | 0) >> 0] | 0 | ((HEAPU8[($4 + 326 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 327 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 328 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $12 = i64toi32_i32$1;
       $12$hi = i64toi32_i32$2;
       i64toi32_i32$1 = $4;
       HEAP8[($4 + 177 | 0) >> 0] = $12;
       HEAP8[($4 + 178 | 0) >> 0] = $12 >>> 8 | 0;
       HEAP8[($4 + 179 | 0) >> 0] = $12 >>> 16 | 0;
       HEAP8[($4 + 180 | 0) >> 0] = $12 >>> 24 | 0;
       HEAP8[($4 + 181 | 0) >> 0] = i64toi32_i32$2;
       HEAP8[($4 + 182 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
       HEAP8[($4 + 183 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
       HEAP8[($4 + 184 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
       i64toi32_i32$1 = $4;
       HEAP32[($4 + 104 | 0) >> 2] = $12;
       HEAP32[($4 + 108 | 0) >> 2] = i64toi32_i32$2;
       HEAP32[(($4 + 40 | 0) + 24 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
       i64toi32_i32$3 = $6;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $175 = i64toi32_i32$2;
       i64toi32_i32$2 = ($4 + 40 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $175;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$3 = $8;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $180 = i64toi32_i32$1;
       i64toi32_i32$1 = ($4 + 40 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $180;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$3 = $4;
       i64toi32_i32$2 = HEAP32[($4 + 104 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($4 + 108 | 0) >> 2] | 0;
       $183 = i64toi32_i32$2;
       i64toi32_i32$2 = $4;
       HEAP32[($4 + 40 | 0) >> 2] = $183;
       HEAP32[($4 + 44 | 0) >> 2] = i64toi32_i32$1;
       $cardano_serialization_lib__crypto__VRFKeyHash_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h95fa546888d9bbe4($4 + 320 | 0 | 0, $1 | 0);
       if ((HEAPU8[($4 + 320 | 0) >> 0] | 0 | 0) == (1 | 0)) {
        break label$2
       }
       i64toi32_i32$3 = ($4 + 320 | 0) + 9 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $12 = i64toi32_i32$1;
       $12$hi = i64toi32_i32$2;
       i64toi32_i32$1 = ($4 + 176 | 0) + 9 | 0;
       HEAP8[i64toi32_i32$1 >> 0] = $12;
       HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $12 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $12 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $12 >>> 24 | 0;
       HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$2;
       HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
       $1 = ($4 + 104 | 0) + 24 | 0;
       i64toi32_i32$3 = $4 + 345 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $204 = i64toi32_i32$2;
       i64toi32_i32$2 = $1;
       HEAP32[i64toi32_i32$2 >> 2] = $204;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       $5 = ($4 + 104 | 0) + 16 | 0;
       i64toi32_i32$3 = $4 + 337 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $211 = i64toi32_i32$1;
       i64toi32_i32$1 = $5;
       HEAP32[i64toi32_i32$1 >> 2] = $211;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
       $6 = ($4 + 104 | 0) + 8 | 0;
       i64toi32_i32$2 = $12$hi;
       i64toi32_i32$1 = $6;
       HEAP32[i64toi32_i32$1 >> 2] = $12;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$3 = $4;
       i64toi32_i32$2 = HEAPU8[($4 + 321 | 0) >> 0] | 0 | ((HEAPU8[($4 + 322 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 323 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 324 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[($4 + 325 | 0) >> 0] | 0 | ((HEAPU8[($4 + 326 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 327 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 328 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $12 = i64toi32_i32$2;
       $12$hi = i64toi32_i32$1;
       i64toi32_i32$2 = $4;
       HEAP8[($4 + 177 | 0) >> 0] = $12;
       HEAP8[($4 + 178 | 0) >> 0] = $12 >>> 8 | 0;
       HEAP8[($4 + 179 | 0) >> 0] = $12 >>> 16 | 0;
       HEAP8[($4 + 180 | 0) >> 0] = $12 >>> 24 | 0;
       HEAP8[($4 + 181 | 0) >> 0] = i64toi32_i32$1;
       HEAP8[($4 + 182 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
       HEAP8[($4 + 183 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
       HEAP8[($4 + 184 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
       i64toi32_i32$2 = $4;
       HEAP32[($4 + 104 | 0) >> 2] = $12;
       HEAP32[($4 + 108 | 0) >> 2] = i64toi32_i32$1;
       $8 = ($4 + 72 | 0) + 24 | 0;
       i64toi32_i32$3 = $1;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $228 = i64toi32_i32$1;
       i64toi32_i32$1 = $8;
       HEAP32[i64toi32_i32$1 >> 2] = $228;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
       $1 = ($4 + 72 | 0) + 16 | 0;
       i64toi32_i32$3 = $5;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $234 = i64toi32_i32$2;
       i64toi32_i32$2 = $1;
       HEAP32[i64toi32_i32$2 >> 2] = $234;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       $5 = ($4 + 72 | 0) + 8 | 0;
       i64toi32_i32$3 = $6;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $240 = i64toi32_i32$1;
       i64toi32_i32$1 = $5;
       HEAP32[i64toi32_i32$1 >> 2] = $240;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$3 = $4;
       i64toi32_i32$2 = HEAP32[($4 + 104 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($4 + 108 | 0) >> 2] | 0;
       $243 = i64toi32_i32$2;
       i64toi32_i32$2 = $4;
       HEAP32[($4 + 72 | 0) >> 2] = $243;
       HEAP32[($4 + 76 | 0) >> 2] = i64toi32_i32$1;
       HEAP32[(($4 + 320 | 0) + 24 | 0) >> 2] = HEAP32[(($4 + 8 | 0) + 24 | 0) >> 2] | 0;
       i64toi32_i32$3 = ($4 + 8 | 0) + 16 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $257 = i64toi32_i32$1;
       i64toi32_i32$1 = ($4 + 320 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $257;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$3 = ($4 + 8 | 0) + 8 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $264 = i64toi32_i32$2;
       i64toi32_i32$2 = ($4 + 320 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $264;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$3 = $4;
       i64toi32_i32$1 = HEAP32[($4 + 8 | 0) >> 2] | 0;
       i64toi32_i32$2 = HEAP32[($4 + 12 | 0) >> 2] | 0;
       $267 = i64toi32_i32$1;
       i64toi32_i32$1 = $4;
       HEAP32[($4 + 320 | 0) >> 2] = $267;
       HEAP32[($4 + 324 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$3 = ($4 + 40 | 0) + 8 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $273 = i64toi32_i32$2;
       i64toi32_i32$2 = $4 + 356 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $273;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$3 = ($4 + 40 | 0) + 16 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $279 = i64toi32_i32$1;
       i64toi32_i32$1 = $4 + 364 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $279;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
       HEAP32[($4 + 372 | 0) >> 2] = HEAP32[(($4 + 40 | 0) + 24 | 0) >> 2] | 0;
       i64toi32_i32$3 = $4;
       i64toi32_i32$2 = HEAP32[($4 + 40 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($4 + 44 | 0) >> 2] | 0;
       $288 = i64toi32_i32$2;
       i64toi32_i32$2 = $4;
       HEAP32[($4 + 348 | 0) >> 2] = $288;
       HEAP32[($4 + 352 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$3 = $5;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $292 = i64toi32_i32$1;
       i64toi32_i32$1 = $4 + 384 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $292;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$3 = $1;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $296 = i64toi32_i32$2;
       i64toi32_i32$2 = $4 + 392 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $296;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$3 = $8;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $300 = i64toi32_i32$1;
       i64toi32_i32$1 = $4 + 400 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $300;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$3 = $4;
       i64toi32_i32$2 = HEAP32[($4 + 72 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($4 + 76 | 0) >> 2] | 0;
       $303 = i64toi32_i32$2;
       i64toi32_i32$2 = $4;
       HEAP32[($4 + 376 | 0) >> 2] = $303;
       HEAP32[($4 + 380 | 0) >> 2] = i64toi32_i32$1;
       memcpy($0 + 1 | 0 | 0, $4 + 320 | 0 | 0, 88 | 0) | 0;
       HEAP8[$0 >> 0] = 0;
       break label$1;
      }
      memcpy($0 + 9 | 0 | 0, $4 + 176 | 0 | 1 | 0 | 0, 63 | 0) | 0;
      HEAP8[$0 >> 0] = 1;
      HEAP8[($0 + 8 | 0) >> 0] = $5;
      break label$1;
     }
     memcpy($4 + 320 | 0 | 0, memcpy($4 + 248 | 0 | 7 | 0 | 0, memcpy($4 + 408 | 0 | 7 | 0 | 0, ($4 + 320 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
     $1 = ($4 + 176 | 0) + 8 | 0;
     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 320 | 0 | 0, 1051045 | 0, 11 | 0);
     memcpy($0 + 8 | 0 | 0, memcpy($4 + 104 | 0 | 7 | 0 | 0, $1 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
     HEAP8[$0 >> 0] = 1;
     break label$1;
    }
    memcpy($4 + 320 | 0 | 0, memcpy($4 + 248 | 0 | 7 | 0 | 0, memcpy($4 + 408 | 0 | 7 | 0 | 0, ($4 + 320 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
    $1 = ($4 + 176 | 0) + 8 | 0;
    cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 320 | 0 | 0, 1051056 | 0, 21 | 0);
    memcpy($0 + 8 | 0 | 0, memcpy($4 + 104 | 0 | 7 | 0 | 0, $1 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
    HEAP8[$0 >> 0] = 1;
    break label$1;
   }
   memcpy($4 + 320 | 0 | 0, memcpy($4 + 248 | 0 | 7 | 0 | 0, memcpy($4 + 408 | 0 | 7 | 0 | 0, ($4 + 320 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   $1 = ($4 + 176 | 0) + 8 | 0;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 320 | 0 | 0, 1050908 | 0, 11 | 0);
   memcpy($0 + 8 | 0 | 0, memcpy($4 + 104 | 0 | 7 | 0 | 0, $1 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   HEAP8[$0 >> 0] = 1;
  }
  global$0 = $4 + 480 | 0;
 }
 
 function $cardano_serialization_lib__crypto__BootstrapWitnesses_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h61c411bcc99e880f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $10 = 0, $18 = 0, $8 = 0, $7 = 0, $18$hi = 0, $19 = 0, $19$hi = 0, $11 = 0, $6 = 0, $59 = 0, $60 = 0, $12 = 0, $61 = 0, $62 = 0, $63 = 0, $64 = 0, $65 = 0, $66 = 0, $67 = 0, $68 = 0, $69 = 0, $70 = 0, $71 = 0, $72 = 0, $73 = 0, $4 = 0, $15 = 0, $16 = 0, $17 = 0, $5 = 0, $9 = 0, $77 = 0, $84 = 0, $97 = 0, $100 = 0, $13 = 0, $20 = 0, $20$hi = 0, $14 = 0, $123 = 0, $129 = 0, $144 = 0, $147 = 0, $175 = 0, $186 = 0, $190 = 0, $194 = 0, $248 = 0, $255 = 0, $268 = 0, $271 = 0, $288 = 0, $293 = 0, $307 = 0, $310 = 0, $317 = 0, $323 = 0, $327 = 0, $332 = 0, $338 = 0, $342 = 0, $354 = 0, $358 = 0, $364 = 0, $370 = 0, $397 = 0;
  $2 = global$0 - 480 | 0;
  global$0 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 12 | 0) >> 2] = 0;
  HEAP32[($2 + 16 | 0) >> 2] = i64toi32_i32$0;
  $3 = 0;
  HEAP32[($2 + 8 | 0) >> 2] = HEAP32[(0 + 1066220 | 0) >> 2] | 0;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 352 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = ($2 + 352 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  $18$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 360 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 364 | 0) >> 2] | 0;
  $19 = i64toi32_i32$1;
  $19$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 352 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 356 | 0) >> 2] | 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
         break label$6
        }
        i64toi32_i32$2 = $18$hi;
        $4 = $18;
        label$7 : {
         i64toi32_i32$2 = $19$hi;
         i64toi32_i32$3 = $19;
         i64toi32_i32$1 = 0;
         i64toi32_i32$0 = 1;
         if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
          break label$7
         }
         if (!$4) {
          break label$3
         }
        }
        $5 = $2 + 424 | 0;
        $6 = $2 + 412 | 0;
        $7 = $2 + 384 | 0;
        $8 = $2 + 361 | 0;
        $9 = $8 + 3 | 0;
        label$8 : {
         label$9 : while (1) {
          std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 | 0, $1 | 0);
          $3 = 0;
          $10 = 2;
          label$10 : {
           if (HEAP32[($2 + 4 | 0) >> 2] | 0) {
            break label$10
           }
           i64toi32_i32$3 = 0;
           $19 = 8;
           $19$hi = i64toi32_i32$3;
           i64toi32_i32$3 = 0;
           $18 = 0;
           $18$hi = i64toi32_i32$3;
           break label$4;
          }
          label$11 : {
           if ((($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[$2 >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) == (7 | 0)) {
            break label$11
           }
           $cardano_serialization_lib__crypto__BootstrapWitness_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__haabcdaf43d31e3da($2 + 352 | 0 | 0, $1 | 0);
           if ((HEAP32[($2 + 352 | 0) >> 2] | 0 | 0) == (1 | 0)) {
            break label$8
           }
           $3 = ($2 + 320 | 0) + 8 | 0;
           i64toi32_i32$0 = $7 + 8 | 0;
           i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $77 = i64toi32_i32$3;
           i64toi32_i32$3 = $3;
           HEAP32[i64toi32_i32$3 >> 2] = $77;
           HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
           $10 = ($2 + 320 | 0) + 16 | 0;
           i64toi32_i32$0 = $7 + 16 | 0;
           i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$3 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $84 = i64toi32_i32$2;
           i64toi32_i32$2 = $10;
           HEAP32[i64toi32_i32$2 >> 2] = $84;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
           $11 = ($2 + 304 | 0) + 8 | 0;
           HEAP32[$11 >> 2] = HEAP32[($6 + 8 | 0) >> 2] | 0;
           HEAP32[($2 + 344 | 0) >> 2] = HEAPU8[$8 >> 0] | 0 | ((HEAPU8[($8 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($8 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($8 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$0 = $7;
           i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $97 = i64toi32_i32$3;
           i64toi32_i32$3 = $2;
           HEAP32[($2 + 320 | 0) >> 2] = $97;
           HEAP32[($2 + 324 | 0) >> 2] = i64toi32_i32$2;
           i64toi32_i32$0 = $6;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $100 = i64toi32_i32$2;
           i64toi32_i32$2 = $2;
           HEAP32[($2 + 304 | 0) >> 2] = $100;
           HEAP32[($2 + 308 | 0) >> 2] = i64toi32_i32$3;
           $59 = $9;
           $60 = HEAPU8[$59 >> 0] | 0 | ((HEAPU8[($59 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($59 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($59 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 347 | 0) >> 0] = $60;
           HEAP8[($2 + 348 | 0) >> 0] = $60 >>> 8 | 0;
           HEAP8[($2 + 349 | 0) >> 0] = $60 >>> 16 | 0;
           HEAP8[($2 + 350 | 0) >> 0] = $60 >>> 24 | 0;
           $12 = HEAPU8[($2 + 360 | 0) >> 0] | 0;
           $13 = HEAP32[($2 + 356 | 0) >> 2] | 0;
           i64toi32_i32$0 = $2;
           i64toi32_i32$3 = HEAP32[($2 + 368 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($2 + 372 | 0) >> 2] | 0;
           $18 = i64toi32_i32$3;
           $18$hi = i64toi32_i32$2;
           i64toi32_i32$0 = $2;
           i64toi32_i32$2 = HEAP32[($2 + 376 | 0) >> 2] | 0;
           i64toi32_i32$3 = HEAP32[($2 + 380 | 0) >> 2] | 0;
           $20 = i64toi32_i32$2;
           $20$hi = i64toi32_i32$3;
           $14 = HEAP32[($2 + 408 | 0) >> 2] | 0;
           memcpy($2 + 200 | 0 | 0, $5 | 0, 52 | 0) | 0;
           $15 = ($2 + 272 | 0) + 8 | 0;
           i64toi32_i32$0 = $3;
           i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $123 = i64toi32_i32$3;
           i64toi32_i32$3 = $15;
           HEAP32[i64toi32_i32$3 >> 2] = $123;
           HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
           $16 = ($2 + 272 | 0) + 16 | 0;
           i64toi32_i32$0 = $10;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $129 = i64toi32_i32$2;
           i64toi32_i32$2 = $16;
           HEAP32[i64toi32_i32$2 >> 2] = $129;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
           $17 = ($2 + 256 | 0) + 8 | 0;
           HEAP32[$17 >> 2] = HEAP32[$11 >> 2] | 0;
           HEAP32[($2 + 296 | 0) >> 2] = HEAP32[($2 + 344 | 0) >> 2] | 0;
           $61 = HEAPU8[($2 + 347 | 0) >> 0] | 0 | ((HEAPU8[($2 + 348 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 349 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 350 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 299 | 0) >> 0] = $61;
           HEAP8[($2 + 300 | 0) >> 0] = $61 >>> 8 | 0;
           HEAP8[($2 + 301 | 0) >> 0] = $61 >>> 16 | 0;
           HEAP8[($2 + 302 | 0) >> 0] = $61 >>> 24 | 0;
           i64toi32_i32$0 = $2;
           i64toi32_i32$3 = HEAP32[($2 + 320 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($2 + 324 | 0) >> 2] | 0;
           $144 = i64toi32_i32$3;
           i64toi32_i32$3 = $2;
           HEAP32[($2 + 272 | 0) >> 2] = $144;
           HEAP32[($2 + 276 | 0) >> 2] = i64toi32_i32$2;
           i64toi32_i32$0 = $2;
           i64toi32_i32$2 = HEAP32[($2 + 304 | 0) >> 2] | 0;
           i64toi32_i32$3 = HEAP32[($2 + 308 | 0) >> 2] | 0;
           $147 = i64toi32_i32$2;
           i64toi32_i32$2 = $2;
           HEAP32[($2 + 256 | 0) >> 2] = $147;
           HEAP32[($2 + 260 | 0) >> 2] = i64toi32_i32$3;
           label$12 : {
            $10 = HEAP32[($2 + 16 | 0) >> 2] | 0;
            if ((HEAP32[($2 + 12 | 0) >> 2] | 0 | 0) != ($10 | 0)) {
             break label$12
            }
            alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h4d4877c8b8eb1e24($2 + 8 | 0 | 0, $10 | 0, 1 | 0);
            $10 = HEAP32[($2 + 16 | 0) >> 2] | 0;
           }
           $3 = (HEAP32[($2 + 8 | 0) >> 2] | 0) + Math_imul($10, 120) | 0;
           HEAP8[($3 + 4 | 0) >> 0] = $12;
           HEAP32[$3 >> 2] = $13;
           $62 = HEAP32[($2 + 296 | 0) >> 2] | 0;
           HEAP8[($3 + 5 | 0) >> 0] = $62;
           HEAP8[($3 + 6 | 0) >> 0] = $62 >>> 8 | 0;
           HEAP8[($3 + 7 | 0) >> 0] = $62 >>> 16 | 0;
           HEAP8[($3 + 8 | 0) >> 0] = $62 >>> 24 | 0;
           i64toi32_i32$3 = $18$hi;
           i64toi32_i32$2 = $3;
           HEAP8[(i64toi32_i32$2 + 12 | 0) >> 0] = $18;
           HEAP8[(i64toi32_i32$2 + 13 | 0) >> 0] = $18 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 14 | 0) >> 0] = $18 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 15 | 0) >> 0] = $18 >>> 24 | 0;
           HEAP8[(i64toi32_i32$2 + 16 | 0) >> 0] = i64toi32_i32$3;
           HEAP8[(i64toi32_i32$2 + 17 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 18 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 19 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
           i64toi32_i32$0 = $2;
           i64toi32_i32$3 = HEAP32[($2 + 256 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($2 + 260 | 0) >> 2] | 0;
           $175 = i64toi32_i32$3;
           i64toi32_i32$3 = $3;
           HEAP32[(i64toi32_i32$3 + 56 | 0) >> 2] = $175;
           HEAP32[(i64toi32_i32$3 + 60 | 0) >> 2] = i64toi32_i32$2;
           $63 = i64toi32_i32$3 + 8 | 0;
           $64 = HEAPU8[($2 + 299 | 0) >> 0] | 0 | ((HEAPU8[($2 + 300 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 301 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 302 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[$63 >> 0] = $64;
           HEAP8[($63 + 1 | 0) >> 0] = $64 >>> 8 | 0;
           HEAP8[($63 + 2 | 0) >> 0] = $64 >>> 16 | 0;
           HEAP8[($63 + 3 | 0) >> 0] = $64 >>> 24 | 0;
           i64toi32_i32$2 = $20$hi;
           i64toi32_i32$3 = i64toi32_i32$3 + 20 | 0;
           $65 = $20;
           HEAP8[i64toi32_i32$3 >> 0] = $65;
           HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $65 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $65 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $65 >>> 24 | 0;
           HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$2;
           HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
           i64toi32_i32$0 = $2;
           i64toi32_i32$2 = HEAP32[($2 + 272 | 0) >> 2] | 0;
           i64toi32_i32$3 = HEAP32[($2 + 276 | 0) >> 2] | 0;
           $186 = i64toi32_i32$2;
           i64toi32_i32$2 = $3 + 28 | 0;
           $66 = $186;
           HEAP8[i64toi32_i32$2 >> 0] = $66;
           HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $66 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $66 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $66 >>> 24 | 0;
           HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$3;
           HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
           i64toi32_i32$0 = $15;
           i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $190 = i64toi32_i32$3;
           i64toi32_i32$3 = $3 + 36 | 0;
           $67 = $190;
           HEAP8[i64toi32_i32$3 >> 0] = $67;
           HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $67 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $67 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $67 >>> 24 | 0;
           HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$2;
           HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
           i64toi32_i32$0 = $16;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $194 = i64toi32_i32$2;
           i64toi32_i32$2 = $3 + 44 | 0;
           $68 = $194;
           HEAP8[i64toi32_i32$2 >> 0] = $68;
           HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $68 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $68 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $68 >>> 24 | 0;
           HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$3;
           HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
           HEAP32[($3 + 52 | 0) >> 2] = $14;
           HEAP32[($3 + 64 | 0) >> 2] = HEAP32[$17 >> 2] | 0;
           memcpy($3 + 68 | 0 | 0, $2 + 200 | 0 | 0, 52 | 0) | 0;
           $3 = $10 + 1 | 0;
           HEAP32[($2 + 16 | 0) >> 2] = $3;
           i64toi32_i32$3 = $19$hi;
           i64toi32_i32$0 = $19;
           i64toi32_i32$2 = 0;
           i64toi32_i32$1 = 1;
           if ((i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$3 | 0) != (i64toi32_i32$2 | 0) | 0) {
            continue label$9
           }
           if ($3 >>> 0 < $4 >>> 0) {
            continue label$9
           }
           break label$3;
          }
          break label$9;
         };
         cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 352 | 0 | 0, $1 | 0);
         i64toi32_i32$1 = ($2 + 352 | 0) + 16 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
         $18 = i64toi32_i32$0;
         $18$hi = i64toi32_i32$3;
         i64toi32_i32$1 = $2;
         i64toi32_i32$3 = HEAP32[($2 + 360 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($2 + 364 | 0) >> 2] | 0;
         $19 = i64toi32_i32$3;
         $19$hi = i64toi32_i32$0;
         i64toi32_i32$1 = $2;
         i64toi32_i32$0 = HEAP32[($2 + 352 | 0) >> 2] | 0;
         i64toi32_i32$3 = HEAP32[($2 + 356 | 0) >> 2] | 0;
         i64toi32_i32$1 = i64toi32_i32$0;
         i64toi32_i32$0 = 0;
         i64toi32_i32$2 = 1;
         if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) | 0) {
          break label$5
         }
         i64toi32_i32$1 = $18$hi;
         i64toi32_i32$3 = $2 + 328 | 0;
         HEAP32[i64toi32_i32$3 >> 2] = $18;
         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$1 = $19$hi;
         i64toi32_i32$3 = $2;
         HEAP32[($2 + 320 | 0) >> 2] = $19;
         HEAP32[($2 + 324 | 0) >> 2] = i64toi32_i32$1;
         if (($19 & 255 | 0 | 0) == (5 | 0)) {
          break label$3
         }
         HEAP32[($2 + 352 | 0) >> 2] = 0;
         core__panicking__assert_failed__h96d8431cc974b591(0 | 0, $2 + 320 | 0 | 0, 1066256 | 0, $2 + 352 | 0 | 0, 1066356 | 0);
         abort();
        }
        $1 = ($2 + 320 | 0) + 8 | 0;
        i64toi32_i32$2 = $7 + 8 | 0;
        i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$3 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $248 = i64toi32_i32$1;
        i64toi32_i32$1 = $1;
        HEAP32[i64toi32_i32$1 >> 2] = $248;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
        $11 = ($2 + 320 | 0) + 16 | 0;
        i64toi32_i32$2 = $7 + 16 | 0;
        i64toi32_i32$3 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $255 = i64toi32_i32$3;
        i64toi32_i32$3 = $11;
        HEAP32[i64toi32_i32$3 >> 2] = $255;
        HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
        $12 = ($2 + 304 | 0) + 8 | 0;
        HEAP32[$12 >> 2] = HEAP32[($6 + 8 | 0) >> 2] | 0;
        HEAP32[($2 + 344 | 0) >> 2] = HEAPU8[$8 >> 0] | 0 | ((HEAPU8[($8 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($8 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($8 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$2 = $7;
        i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$3 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $268 = i64toi32_i32$1;
        i64toi32_i32$1 = $2;
        HEAP32[($2 + 320 | 0) >> 2] = $268;
        HEAP32[($2 + 324 | 0) >> 2] = i64toi32_i32$3;
        i64toi32_i32$2 = $6;
        i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $271 = i64toi32_i32$3;
        i64toi32_i32$3 = $2;
        HEAP32[($2 + 304 | 0) >> 2] = $271;
        HEAP32[($2 + 308 | 0) >> 2] = i64toi32_i32$1;
        $69 = $8 + 3 | 0;
        $70 = HEAPU8[$69 >> 0] | 0 | ((HEAPU8[($69 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($69 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($69 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 347 | 0) >> 0] = $70;
        HEAP8[($2 + 348 | 0) >> 0] = $70 >>> 8 | 0;
        HEAP8[($2 + 349 | 0) >> 0] = $70 >>> 16 | 0;
        HEAP8[($2 + 350 | 0) >> 0] = $70 >>> 24 | 0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$1 = HEAP32[($2 + 368 | 0) >> 2] | 0;
        i64toi32_i32$3 = HEAP32[($2 + 372 | 0) >> 2] | 0;
        $19 = i64toi32_i32$1;
        $19$hi = i64toi32_i32$3;
        i64toi32_i32$2 = $2;
        i64toi32_i32$3 = HEAP32[($2 + 376 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 380 | 0) >> 2] | 0;
        $18 = i64toi32_i32$3;
        $18$hi = i64toi32_i32$1;
        $3 = HEAP32[($2 + 408 | 0) >> 2] | 0;
        $10 = HEAPU8[($2 + 360 | 0) >> 0] | 0;
        i64toi32_i32$2 = $1;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $288 = i64toi32_i32$1;
        i64toi32_i32$1 = ($2 + 168 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $288;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
        i64toi32_i32$2 = $11;
        i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $293 = i64toi32_i32$3;
        i64toi32_i32$3 = ($2 + 168 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$3 >> 2] = $293;
        HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
        HEAP32[(($2 + 152 | 0) + 8 | 0) >> 2] = HEAP32[$12 >> 2] | 0;
        $71 = HEAPU8[($2 + 347 | 0) >> 0] | 0 | ((HEAPU8[($2 + 348 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 349 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 350 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 195 | 0) >> 0] = $71;
        HEAP8[($2 + 196 | 0) >> 0] = $71 >>> 8 | 0;
        HEAP8[($2 + 197 | 0) >> 0] = $71 >>> 16 | 0;
        HEAP8[($2 + 198 | 0) >> 0] = $71 >>> 24 | 0;
        HEAP32[($2 + 192 | 0) >> 2] = HEAP32[($2 + 344 | 0) >> 2] | 0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$1 = HEAP32[($2 + 320 | 0) >> 2] | 0;
        i64toi32_i32$3 = HEAP32[($2 + 324 | 0) >> 2] | 0;
        $307 = i64toi32_i32$1;
        i64toi32_i32$1 = $2;
        HEAP32[($2 + 168 | 0) >> 2] = $307;
        HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$3;
        i64toi32_i32$2 = $2;
        i64toi32_i32$3 = HEAP32[($2 + 304 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 308 | 0) >> 2] | 0;
        $310 = i64toi32_i32$3;
        i64toi32_i32$3 = $2;
        HEAP32[($2 + 152 | 0) >> 2] = $310;
        HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$1;
        if (($10 | 0) != (19 | 0)) {
         break label$4
        }
        break label$3;
       }
       i64toi32_i32$2 = $2 + 384 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $317 = i64toi32_i32$1;
       i64toi32_i32$1 = $2 + 176 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $317;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
       i64toi32_i32$2 = $2 + 392 | 0;
       i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $323 = i64toi32_i32$3;
       i64toi32_i32$3 = ($2 + 168 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$3 >> 2] = $323;
       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $2 + 376 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $327 = i64toi32_i32$1;
       i64toi32_i32$1 = $2;
       HEAP32[($2 + 168 | 0) >> 2] = $327;
       HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$3;
       $10 = 2;
       break label$4;
      }
      i64toi32_i32$2 = $2 + 384 | 0;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $332 = i64toi32_i32$3;
      i64toi32_i32$3 = $2 + 176 | 0;
      HEAP32[i64toi32_i32$3 >> 2] = $332;
      HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $2 + 392 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $338 = i64toi32_i32$1;
      i64toi32_i32$1 = ($2 + 168 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $338;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
      i64toi32_i32$2 = $2 + 376 | 0;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $342 = i64toi32_i32$3;
      i64toi32_i32$3 = $2;
      HEAP32[($2 + 168 | 0) >> 2] = $342;
      HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$1;
     }
     i64toi32_i32$1 = $18$hi;
     i64toi32_i32$3 = ($2 + 352 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $18;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $19$hi;
     i64toi32_i32$3 = ($2 + 352 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $19;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAP32[($2 + 168 | 0) >> 2] | 0;
     i64toi32_i32$3 = HEAP32[($2 + 172 | 0) >> 2] | 0;
     $354 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 376 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $354;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$2 = $2;
     i64toi32_i32$3 = HEAP32[($2 + 152 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 156 | 0) >> 2] | 0;
     $358 = i64toi32_i32$3;
     i64toi32_i32$3 = $2 + 404 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $358;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = ($2 + 168 | 0) + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $364 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 384 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $364;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$2 = ($2 + 168 | 0) + 16 | 0;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $370 = i64toi32_i32$3;
     i64toi32_i32$3 = $2 + 392 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $370;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($2 + 412 | 0) >> 2] = HEAP32[(($2 + 152 | 0) + 8 | 0) >> 2] | 0;
     HEAP8[($2 + 352 | 0) >> 0] = $10;
     $72 = HEAP32[($2 + 192 | 0) >> 2] | 0;
     HEAP8[($2 + 353 | 0) >> 0] = $72;
     HEAP8[($2 + 354 | 0) >> 0] = $72 >>> 8 | 0;
     HEAP8[($2 + 355 | 0) >> 0] = $72 >>> 16 | 0;
     HEAP8[($2 + 356 | 0) >> 0] = $72 >>> 24 | 0;
     $73 = HEAPU8[($2 + 195 | 0) >> 0] | 0 | ((HEAPU8[($2 + 196 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 197 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 198 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($2 + 356 | 0) >> 0] = $73;
     HEAP8[($2 + 357 | 0) >> 0] = $73 >>> 8 | 0;
     HEAP8[($2 + 358 | 0) >> 0] = $73 >>> 16 | 0;
     HEAP8[($2 + 359 | 0) >> 0] = $73 >>> 24 | 0;
     HEAP32[($2 + 400 | 0) >> 2] = $3;
     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($2 + 88 | 0 | 0, $2 + 352 | 0 | 0, 1066372 | 0, 18 | 0);
     $7 = HEAPU8[($2 + 88 | 0) >> 0] | 0;
     if (($7 | 0) != (19 | 0)) {
      break label$2
     }
    }
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $397 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $397;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$3;
    HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
    $3 = 0;
    break label$1;
   }
   $3 = 1;
   memcpy($2 + 25 | 0 | 0, $2 + 88 | 0 | 1 | 0 | 0, 63 | 0) | 0;
   HEAP8[($0 + 8 | 0) >> 0] = $7;
   memcpy($0 + 9 | 0 | 0, $2 + 25 | 0 | 0, 63 | 0) | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h28dc4dde55fe2f07($2 + 8 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h79e8c51775f4d5f8($2 + 8 | 0 | 0);
  }
  HEAP32[$0 >> 2] = $3;
  global$0 = $2 + 480 | 0;
 }
 
 function cardano_serialization_lib__utils__encode_json_str_to_native_script__hac20d59c89b6b1bb($0, $1, $2, $3, $4, $5) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  $5 = $5 | 0;
  var $6 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $7 = 0, $7$hi = 0, $64 = 0, $72 = 0, $77 = 0, $83 = 0, $88 = 0, $114 = 0, $8 = 0, $8$hi = 0, $157 = 0, $164 = 0, $167 = 0, $206 = 0, $216 = 0, $244 = 0, $254 = 0, $306 = 0, $313 = 0, $320 = 0, $325 = 0, $339 = 0, $345 = 0, $351 = 0, $357 = 0;
  $6 = global$0 - 336 | 0;
  global$0 = $6;
  serde_json__de__from_str__h84312e5dc76b40c6($6 + 152 | 0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          if ((HEAP32[($6 + 152 | 0) >> 2] | 0 | 0) != (1 | 0)) {
           break label$8
          }
          HEAP32[($6 + 184 | 0) >> 2] = HEAP32[($6 + 156 | 0) >> 2] | 0;
          i64toi32_i32$1 = $6;
          i64toi32_i32$0 = 0;
          HEAP32[($6 + 84 | 0) >> 2] = 0;
          HEAP32[($6 + 88 | 0) >> 2] = i64toi32_i32$0;
          HEAP32[($6 + 80 | 0) >> 2] = HEAP32[(0 + 1057668 | 0) >> 2] | 0;
          core__fmt__Formatter__new__he219faf25326051b($6 + 264 | 0 | 0, $6 + 80 | 0 | 0, 1057336 | 0);
          if ($serde_json__error__Error_20as_20core__fmt__Display___fmt__h9e9840cbd4820f76($6 + 184 | 0 | 0, $6 + 264 | 0 | 0) | 0) {
           break label$7
          }
          $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($6 + 8 | 0 | 0, $6 + 80 | 0 | 0);
          $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($6 + 8 | 0) >> 2] | 0 | 0, HEAP32[($6 + 12 | 0) >> 2] | 0 | 0) | 0;
          $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($6 + 80 | 0 | 0);
          $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($6 + 80 | 0 | 0);
          label$9 : {
           label$10 : {
            label$11 : {
             $2 = HEAP32[($6 + 184 | 0) >> 2] | 0;
             switch (HEAP32[$2 >> 2] | 0 | 0) {
             case 0:
              break label$10;
             case 1:
              break label$11;
             default:
              break label$9;
             };
            }
            core__ptr__drop_in_place_std__io__error__Error___h33c863f956f9c357_1($2 + 4 | 0 | 0);
            break label$9;
           }
           core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0($2 + 4 | 0 | 0);
          }
          __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[($6 + 184 | 0) >> 2] | 0 | 0) | 0 | 0, 20 | 0, 4 | 0);
          break label$2;
         }
         $1 = ($6 + 56 | 0) + 16 | 0;
         i64toi32_i32$2 = $6 + 176 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $64 = i64toi32_i32$0;
         i64toi32_i32$0 = $1;
         HEAP32[i64toi32_i32$0 >> 2] = $64;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         $2 = ($6 + 56 | 0) + 8 | 0;
         i64toi32_i32$2 = ($6 + 152 | 0) + 16 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $72 = i64toi32_i32$1;
         i64toi32_i32$1 = $2;
         HEAP32[i64toi32_i32$1 >> 2] = $72;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$2 = ($6 + 152 | 0) + 8 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $77 = i64toi32_i32$0;
         i64toi32_i32$0 = $6;
         HEAP32[($6 + 56 | 0) >> 2] = $77;
         HEAP32[($6 + 60 | 0) >> 2] = i64toi32_i32$1;
         label$12 : {
          if ($5) {
           break label$12
          }
          i64toi32_i32$2 = $1;
          i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
          $83 = i64toi32_i32$1;
          i64toi32_i32$1 = ($6 + 112 | 0) + 16 | 0;
          HEAP32[i64toi32_i32$1 >> 2] = $83;
          HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
          i64toi32_i32$2 = $2;
          i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
          $88 = i64toi32_i32$0;
          i64toi32_i32$0 = ($6 + 112 | 0) + 8 | 0;
          HEAP32[i64toi32_i32$0 >> 2] = $88;
          HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
          i64toi32_i32$2 = $6;
          i64toi32_i32$1 = HEAP32[($6 + 56 | 0) >> 2] | 0;
          i64toi32_i32$0 = HEAP32[($6 + 60 | 0) >> 2] | 0;
          $7 = i64toi32_i32$1;
          $7$hi = i64toi32_i32$0;
          i64toi32_i32$1 = $6;
          HEAP32[($6 + 112 | 0) >> 2] = $7;
          HEAP32[($6 + 116 | 0) >> 2] = i64toi32_i32$0;
          label$13 : {
           if (($7 & 255 | 0 | 0) != (5 | 0)) {
            break label$13
           }
           $1 = $6 + 112 | 0 | 4 | 0;
           if (!(alloc__collections__btree__map__BTreeMap_K_2cV___get__h1f6710d7f87d2e37($1 | 0, 1057937 | 0, 9 | 0) | 0)) {
            break label$13
           }
           if (!(alloc__collections__btree__map__BTreeMap_K_2cV___get__h1f6710d7f87d2e37($1 | 0, 1057946 | 0, 8 | 0) | 0)) {
            break label$13
           }
           HEAP32[(($6 + 136 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
           i64toi32_i32$2 = $1;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
           $114 = i64toi32_i32$0;
           i64toi32_i32$0 = $6;
           HEAP32[($6 + 136 | 0) >> 2] = $114;
           HEAP32[($6 + 140 | 0) >> 2] = i64toi32_i32$1;
           std__thread__local__LocalKey_T___with__h4cd07b14a44a727e($6 + 40 | 0 | 0, 1057332 | 0);
           i64toi32_i32$2 = $6;
           i64toi32_i32$1 = HEAP32[($6 + 40 | 0) >> 2] | 0;
           i64toi32_i32$0 = HEAP32[($6 + 44 | 0) >> 2] | 0;
           $7 = i64toi32_i32$1;
           $7$hi = i64toi32_i32$0;
           i64toi32_i32$2 = $6;
           i64toi32_i32$0 = HEAP32[($6 + 48 | 0) >> 2] | 0;
           i64toi32_i32$1 = HEAP32[($6 + 52 | 0) >> 2] | 0;
           $8 = i64toi32_i32$0;
           $8$hi = i64toi32_i32$1;
           $1 = hashbrown__raw__generic__Group__static_empty__hc5a7932fe1bdb1f1() | 0;
           i64toi32_i32$0 = $6 + 176 | 0;
           i64toi32_i32$1 = 0;
           HEAP32[i64toi32_i32$0 >> 2] = 0;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
           HEAP32[($6 + 172 | 0) >> 2] = $1;
           HEAP32[($6 + 168 | 0) >> 2] = 0;
           i64toi32_i32$1 = $8$hi;
           i64toi32_i32$0 = $6;
           HEAP32[($6 + 160 | 0) >> 2] = $8;
           HEAP32[($6 + 164 | 0) >> 2] = i64toi32_i32$1;
           i64toi32_i32$1 = $7$hi;
           i64toi32_i32$0 = $6;
           HEAP32[($6 + 152 | 0) >> 2] = $7;
           HEAP32[($6 + 156 | 0) >> 2] = i64toi32_i32$1;
           $1 = alloc__collections__btree__map__BTreeMap_K_2cV___get__h1f6710d7f87d2e37($6 + 136 | 0 | 0, 1057937 | 0, 9 | 0) | 0;
           if (!$1) {
            break label$6
           }
           if ((HEAPU8[$1 >> 0] | 0 | 0) != (5 | 0)) {
            break label$4
           }
           alloc__collections__btree__map__BTreeMap_K_2cV___iter__hf725d43035c2a960($6 + 184 | 0 | 0, $1 + 4 | 0 | 0);
           HEAP32[(($6 + 264 | 0) + 24 | 0) >> 2] = HEAP32[(($6 + 184 | 0) + 24 | 0) >> 2] | 0;
           i64toi32_i32$2 = ($6 + 184 | 0) + 16 | 0;
           i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
           $157 = i64toi32_i32$1;
           i64toi32_i32$1 = ($6 + 264 | 0) + 16 | 0;
           HEAP32[i64toi32_i32$1 >> 2] = $157;
           HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
           i64toi32_i32$2 = ($6 + 184 | 0) + 8 | 0;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
           $164 = i64toi32_i32$0;
           i64toi32_i32$0 = ($6 + 264 | 0) + 8 | 0;
           HEAP32[i64toi32_i32$0 >> 2] = $164;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
           i64toi32_i32$2 = $6;
           i64toi32_i32$1 = HEAP32[($6 + 184 | 0) >> 2] | 0;
           i64toi32_i32$0 = HEAP32[($6 + 188 | 0) >> 2] | 0;
           $167 = i64toi32_i32$1;
           i64toi32_i32$1 = $6;
           HEAP32[($6 + 264 | 0) >> 2] = $167;
           HEAP32[($6 + 268 | 0) >> 2] = i64toi32_i32$0;
           $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h51e8e53778b7cbd1($6 + 32 | 0 | 0, $6 + 264 | 0 | 0);
           $2 = HEAP32[($6 + 32 | 0) >> 2] | 0;
           if (!$2) {
            break label$5
           }
           $1 = HEAP32[($6 + 36 | 0) >> 2] | 0;
           label$14 : while (1) {
            label$15 : {
             label$16 : {
              label$17 : {
               if ((HEAPU8[$1 >> 0] | 0 | 0) != (3 | 0)) {
                break label$17
               }
               $1 = $1 + 4 | 0;
               $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($6 + 24 | 0 | 0, $1 | 0);
               if (core__slice__cmp___impl_20core__cmp__PartialEq__5bB_5d__20for_20_5bA_5d___eq__hc3de93b036fcc30b(HEAP32[($6 + 24 | 0) >> 2] | 0 | 0, HEAP32[($6 + 28 | 0) >> 2] | 0 | 0, 1058026 | 0, 4 | 0) | 0) {
                break label$16
               }
               $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($6 + 232 | 0 | 0, $2 | 0);
               $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($6 + 248 | 0 | 0, $1 | 0);
               HEAP32[(($6 + 304 | 0) + 8 | 0) >> 2] = HEAP32[(($6 + 232 | 0) + 8 | 0) >> 2] | 0;
               i64toi32_i32$2 = $6;
               i64toi32_i32$0 = HEAP32[($6 + 232 | 0) >> 2] | 0;
               i64toi32_i32$1 = HEAP32[($6 + 236 | 0) >> 2] | 0;
               $206 = i64toi32_i32$0;
               i64toi32_i32$0 = $6;
               HEAP32[($6 + 304 | 0) >> 2] = $206;
               HEAP32[($6 + 308 | 0) >> 2] = i64toi32_i32$1;
               HEAP32[(($6 + 320 | 0) + 8 | 0) >> 2] = HEAP32[(($6 + 248 | 0) + 8 | 0) >> 2] | 0;
               i64toi32_i32$2 = $6;
               i64toi32_i32$1 = HEAP32[($6 + 248 | 0) >> 2] | 0;
               i64toi32_i32$0 = HEAP32[($6 + 252 | 0) >> 2] | 0;
               $216 = i64toi32_i32$1;
               i64toi32_i32$1 = $6;
               HEAP32[($6 + 320 | 0) >> 2] = $216;
               HEAP32[($6 + 324 | 0) >> 2] = i64toi32_i32$0;
               hashbrown__map__HashMap_K_2cV_2cS_2cA___insert__h719e57cb0b28913b($6 + 216 | 0 | 0, $6 + 152 | 0 | 0, $6 + 304 | 0 | 0, $6 + 320 | 0 | 0);
               core__ptr__drop_in_place_core__option__Option_alloc__string__String____h8c3a778692ea673c($6 + 216 | 0 | 0);
               break label$15;
              }
              $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1057995 | 0, 31 | 0) | 0;
              break label$3;
             }
             $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($6 + 232 | 0 | 0, $2 | 0);
             alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($6 + 248 | 0 | 0, $3 | 0, $4 | 0);
             HEAP32[(($6 + 304 | 0) + 8 | 0) >> 2] = HEAP32[(($6 + 232 | 0) + 8 | 0) >> 2] | 0;
             i64toi32_i32$2 = $6;
             i64toi32_i32$0 = HEAP32[($6 + 232 | 0) >> 2] | 0;
             i64toi32_i32$1 = HEAP32[($6 + 236 | 0) >> 2] | 0;
             $244 = i64toi32_i32$0;
             i64toi32_i32$0 = $6;
             HEAP32[($6 + 304 | 0) >> 2] = $244;
             HEAP32[($6 + 308 | 0) >> 2] = i64toi32_i32$1;
             HEAP32[(($6 + 320 | 0) + 8 | 0) >> 2] = HEAP32[(($6 + 248 | 0) + 8 | 0) >> 2] | 0;
             i64toi32_i32$2 = $6;
             i64toi32_i32$1 = HEAP32[($6 + 248 | 0) >> 2] | 0;
             i64toi32_i32$0 = HEAP32[($6 + 252 | 0) >> 2] | 0;
             $254 = i64toi32_i32$1;
             i64toi32_i32$1 = $6;
             HEAP32[($6 + 320 | 0) >> 2] = $254;
             HEAP32[($6 + 324 | 0) >> 2] = i64toi32_i32$0;
             hashbrown__map__HashMap_K_2cV_2cS_2cA___insert__h719e57cb0b28913b($6 + 216 | 0 | 0, $6 + 152 | 0 | 0, $6 + 304 | 0 | 0, $6 + 320 | 0 | 0);
             core__ptr__drop_in_place_core__option__Option_alloc__string__String____h8c3a778692ea673c($6 + 216 | 0 | 0);
            }
            $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h51e8e53778b7cbd1($6 + 16 | 0 | 0, $6 + 264 | 0 | 0);
            $1 = HEAP32[($6 + 20 | 0) >> 2] | 0;
            $2 = HEAP32[($6 + 16 | 0) >> 2] | 0;
            if ($2) {
             continue label$14
            }
            break label$5;
           };
          }
          $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1058048 | 0, 69 | 0) | 0;
          label$18 : {
           if ((HEAPU8[($6 + 112 | 0) >> 0] | 0 | 0) == (5 | 0)) {
            break label$18
           }
           core__ptr__drop_in_place_serde_json__value__Value___h0088decf7dc316c7($6 + 112 | 0 | 0);
           break label$2;
          }
          $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h0198cfc402357e50($6 + 112 | 0 | 4 | 0 | 0);
          break label$2;
         }
         core__panicking__panic__h2fd385a887c8bf13(1058893 | 0, 19 | 0, 1058912 | 0);
         abort();
        }
        core__result__unwrap_failed__h27f43d993c3864a1(1057360 | 0, 55 | 0, $6 + 112 | 0 | 0, 1057552 | 0, 1057492 | 0);
        abort();
       }
       core__panicking__panic__h2fd385a887c8bf13(1057508 | 0, 43 | 0, 1057956 | 0);
       abort();
      }
      label$19 : {
       $1 = alloc__collections__btree__map__BTreeMap_K_2cV___get__h1f6710d7f87d2e37($6 + 136 | 0 | 0, 1057946 | 0, 8 | 0) | 0;
       if (!$1) {
        break label$19
       }
       cardano_serialization_lib__utils__encode_template_to_native_script__h6be814cfb3fcf4a8($6 + 264 | 0 | 0, $1 | 0, $6 + 152 | 0 | 0);
       label$20 : {
        if ((HEAP32[($6 + 264 | 0) >> 2] | 0 | 0) != (1 | 0)) {
         break label$20
        }
        $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($6 + 268 | 0) >> 2] | 0 | 0) | 0;
        break label$3;
       }
       i64toi32_i32$2 = $6 + 296 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $306 = i64toi32_i32$0;
       i64toi32_i32$0 = ($6 + 80 | 0) + 24 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $306;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = ($6 + 264 | 0) + 24 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $313 = i64toi32_i32$1;
       i64toi32_i32$1 = ($6 + 80 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $313;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = ($6 + 264 | 0) + 16 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $320 = i64toi32_i32$0;
       i64toi32_i32$0 = ($6 + 80 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $320;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = ($6 + 264 | 0) + 8 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $325 = i64toi32_i32$1;
       i64toi32_i32$1 = $6;
       HEAP32[($6 + 80 | 0) >> 2] = $325;
       HEAP32[($6 + 84 | 0) >> 2] = i64toi32_i32$0;
       $hashbrown__raw__RawTable_T_2cA__20as_20core__ops__drop__Drop___drop__h2ba76806c3733efb(($6 + 152 | 0) + 16 | 0 | 0);
       $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h0198cfc402357e50($6 + 136 | 0 | 0);
       label$21 : {
        if ((HEAPU8[($6 + 112 | 0) >> 0] | 0 | 0) == (5 | 0)) {
         break label$21
        }
        core__ptr__drop_in_place_serde_json__value__Value___h0088decf7dc316c7($6 + 112 | 0 | 0);
       }
       i64toi32_i32$2 = $6;
       i64toi32_i32$0 = HEAP32[($6 + 80 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($6 + 84 | 0) >> 2] | 0;
       $339 = i64toi32_i32$0;
       i64toi32_i32$0 = $0 + 8 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $339;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = ($6 + 80 | 0) + 24 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $345 = i64toi32_i32$1;
       i64toi32_i32$1 = $0 + 32 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $345;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = ($6 + 80 | 0) + 16 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $351 = i64toi32_i32$0;
       i64toi32_i32$0 = $0 + 24 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $351;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = ($6 + 80 | 0) + 8 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $357 = i64toi32_i32$1;
       i64toi32_i32$1 = $0 + 16 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $357;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       HEAP32[$0 >> 2] = 0;
       break label$1;
      }
      core__panicking__panic__h2fd385a887c8bf13(1057508 | 0, 43 | 0, 1058032 | 0);
      abort();
     }
     $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1057972 | 0, 23 | 0) | 0;
    }
    $hashbrown__raw__RawTable_T_2cA__20as_20core__ops__drop__Drop___drop__h2ba76806c3733efb($6 + 168 | 0 | 0);
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h0198cfc402357e50($6 + 136 | 0 | 0);
    if ((HEAPU8[($6 + 112 | 0) >> 0] | 0 | 0) == (5 | 0)) {
     break label$2
    }
    core__ptr__drop_in_place_serde_json__value__Value___h0088decf7dc316c7($6 + 112 | 0 | 0);
   }
   $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($1 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
  }
  global$0 = $6 + 336 | 0;
 }
 
 function $cardano_serialization_lib__address__Address_20as_20core__clone__Clone___clone__h0eb465a6e349d507($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $2 = 0, $22 = 0, $22$hi = 0, $17$hi = 0, $17 = 0, $19 = 0, $19$hi = 0, $20 = 0, $20$hi = 0, $18 = 0, $18$hi = 0, $24$hi = 0, $3 = 0, $24 = 0, $4 = 0, $5 = 0, $15 = 0, $101 = 0, $7 = 0, $102 = 0, $8 = 0, $23 = 0, $23$hi = 0, $103 = 0, $104 = 0, $107 = 0, $108 = 0, $109 = 0, $110 = 0, $6 = 0, $25 = 0, $25$hi = 0, $9 = 0, $12 = 0, $13 = 0, $14 = 0, $16 = 0, $21 = 0, $111 = 0, $112 = 0, $113 = 0, $114 = 0, $115 = 0, $116 = 0, $10 = 0, $117 = 0, $11 = 0, $118 = 0, $119 = 0, $120 = 0, $121 = 0, $122 = 0, $123 = 0, $124 = 0, $125 = 0, $126 = 0, $127 = 0, $128 = 0, $129 = 0, $130 = 0, $131 = 0, $132 = 0, $133 = 0, $134 = 0, $135 = 0, $136 = 0, $137 = 0, $138 = 0, $139 = 0, $140 = 0, $141 = 0, $16$hi = 0, $41 = 0, $21$hi = 0, $72 = 0, $98 = 0, $98$hi = 0, $99 = 0, $99$hi = 0, $101$hi = 0, $103$hi = 0, $105 = 0, $105$hi = 0, $106 = 0, $106$hi = 0, $108$hi = 0, $110$hi = 0, $154 = 0, $160 = 0, $160$hi = 0, $163 = 0, $163$hi = 0, $167$hi = 0, $169$hi = 0, $176$hi = 0, $178 = 0, $178$hi = 0, $181 = 0, $181$hi = 0, $185$hi = 0, $227 = 0, $230 = 0, $230$hi = 0, $233 = 0, $233$hi = 0, $237$hi = 0, $239$hi = 0, $262 = 0, $265 = 0, $265$hi = 0, $268 = 0, $268$hi = 0, $272$hi = 0, $274$hi = 0, $290 = 0, $294 = 0, $297 = 0, $297$hi = 0, $301$hi = 0, $362 = 0, $366 = 0, $413 = 0, $413$hi = 0, $414 = 0, $422 = 0, $425$hi = 0, $427$hi = 0, $428 = 0, $430 = 0, $432$hi = 0, $435 = 0, $435$hi = 0, $436 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      switch (HEAPU8[$1 >> 0] | 0 | 0) {
      default:
       $3 = HEAPU8[($1 + 1 | 0) >> 0] | 0;
       i64toi32_i32$2 = $1 + 3 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $16 = i64toi32_i32$0;
       $16$hi = i64toi32_i32$1;
       i64toi32_i32$0 = $2;
       HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $16;
       HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $1 + 8 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $41 = i64toi32_i32$1;
       i64toi32_i32$1 = $2;
       $101 = $41;
       HEAP8[(i64toi32_i32$1 + 21 | 0) >> 0] = $101;
       HEAP8[(i64toi32_i32$1 + 22 | 0) >> 0] = $101 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 23 | 0) >> 0] = $101 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 24 | 0) >> 0] = $101 >>> 24 | 0;
       HEAP8[(i64toi32_i32$1 + 25 | 0) >> 0] = i64toi32_i32$0;
       HEAP8[(i64toi32_i32$1 + 26 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 27 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 28 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
       $4 = HEAP32[($1 + 20 | 0) >> 2] | 0;
       $5 = HEAP32[($1 + 16 | 0) >> 2] | 0;
       $6 = HEAPU8[($1 + 2 | 0) >> 0] | 0;
       i64toi32_i32$2 = $1 + 24 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = 0;
       $17 = i64toi32_i32$0;
       $17$hi = i64toi32_i32$1;
       i64toi32_i32$2 = $1 + 28 | 0;
       i64toi32_i32$1 = HEAPU16[i64toi32_i32$2 >> 1] | 0;
       i64toi32_i32$0 = 0;
       $18 = i64toi32_i32$1;
       $18$hi = i64toi32_i32$0;
       i64toi32_i32$2 = $1 + 30 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
       i64toi32_i32$1 = 0;
       $19 = i64toi32_i32$0;
       $19$hi = i64toi32_i32$1;
       $7 = HEAPU8[($2 + 17 | 0) >> 0] | 0 | ((HEAPU8[($2 + 18 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 19 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 20 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = $2;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 21 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 22 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 23 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 24 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 25 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 26 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 27 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 28 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $20 = i64toi32_i32$1;
       $20$hi = i64toi32_i32$0;
       i64toi32_i32$2 = $1 + 32 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $21 = i64toi32_i32$0;
       $21$hi = i64toi32_i32$1;
       i64toi32_i32$0 = $2;
       HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $21;
       HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $1 + 37 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $72 = i64toi32_i32$1;
       i64toi32_i32$1 = $2;
       $102 = $72;
       HEAP8[(i64toi32_i32$1 + 21 | 0) >> 0] = $102;
       HEAP8[(i64toi32_i32$1 + 22 | 0) >> 0] = $102 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 23 | 0) >> 0] = $102 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 24 | 0) >> 0] = $102 >>> 24 | 0;
       HEAP8[(i64toi32_i32$1 + 25 | 0) >> 0] = i64toi32_i32$0;
       HEAP8[(i64toi32_i32$1 + 26 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 27 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 28 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
       i64toi32_i32$2 = $1 + 45 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $22 = i64toi32_i32$0;
       $22$hi = i64toi32_i32$1;
       $8 = HEAPU8[($1 + 31 | 0) >> 0] | 0;
       i64toi32_i32$2 = $1 + 53 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = 0;
       $23 = i64toi32_i32$1;
       $23$hi = i64toi32_i32$0;
       i64toi32_i32$2 = $1 + 57 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
       i64toi32_i32$1 = 0;
       $24 = i64toi32_i32$0;
       $24$hi = i64toi32_i32$1;
       i64toi32_i32$2 = $1 + 59 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
       i64toi32_i32$0 = 0;
       $25 = i64toi32_i32$1;
       $25$hi = i64toi32_i32$0;
       $9 = HEAPU8[($2 + 17 | 0) >> 0] | 0;
       HEAP8[(($2 + 12 | 0) + 2 | 0) >> 0] = HEAPU8[($2 + 20 | 0) >> 0] | 0;
       HEAP16[($2 + 12 | 0) >> 1] = HEAPU16[($2 + 18 | 0) >> 1] | 0;
       i64toi32_i32$0 = $17$hi;
       $98 = $17;
       $98$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $18$hi;
       $99 = $18;
       $99$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $19$hi;
       i64toi32_i32$2 = $19;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $111 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
        $111 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       $101$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $99$hi;
       i64toi32_i32$0 = $99;
       i64toi32_i32$2 = $101$hi;
       i64toi32_i32$3 = $111;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
       i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        $112 = 0;
       } else {
        i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
        $112 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       }
       $103$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $98$hi;
       i64toi32_i32$2 = $98;
       i64toi32_i32$1 = $103$hi;
       i64toi32_i32$3 = $112;
       i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
       $17 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       $17$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $23$hi;
       $105 = $23;
       $105$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $24$hi;
       $106 = $24;
       $106$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $25$hi;
       i64toi32_i32$0 = $25;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $113 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $113 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       $108$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $106$hi;
       i64toi32_i32$1 = $106;
       i64toi32_i32$0 = $108$hi;
       i64toi32_i32$3 = $113;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $114 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
        $114 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       $110$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $105$hi;
       i64toi32_i32$0 = $105;
       i64toi32_i32$2 = $110$hi;
       i64toi32_i32$3 = $114;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
       $19 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
       $19$hi = i64toi32_i32$2;
       i64toi32_i32$1 = $19;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 24;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = 0;
        $115 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
        $115 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
       }
       $18 = $115;
       $18$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $19$hi;
       i64toi32_i32$2 = $19;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = 0;
        $116 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
        $116 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
       }
       $10 = $116;
       i64toi32_i32$1 = $19$hi;
       i64toi32_i32$0 = $19;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 8;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = 0;
        $117 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
        $117 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
       }
       $11 = $117;
       i64toi32_i32$1 = $2;
       i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 21 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 22 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 23 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 24 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 25 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 26 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 27 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 28 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $25 = i64toi32_i32$2;
       $25$hi = i64toi32_i32$0;
       i64toi32_i32$1 = i64toi32_i32$2;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = 0;
        $118 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
        $118 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
       }
       $19 = $118;
       $19$hi = i64toi32_i32$2;
       i64toi32_i32$2 = 0;
       i64toi32_i32$0 = ($8 | 0) == (1 | 0);
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 56;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $119 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
        $119 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       $24 = $119;
       $24$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $16$hi;
       $1 = $16;
       i64toi32_i32$1 = $23$hi;
       $8 = $23;
       i64toi32_i32$1 = $21$hi;
       $12 = $21;
       i64toi32_i32$1 = $22$hi;
       i64toi32_i32$2 = $22;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 56;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = 0;
        $120 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
        $120 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
       }
       $13 = $120;
       i64toi32_i32$0 = $25$hi;
       $14 = $25;
       $15 = 0;
       break label$1;
      case 1:
       $12 = HEAPU8[($1 + 32 | 0) >> 0] | 0;
       i64toi32_i32$1 = $1 + 34 | 0;
       i64toi32_i32$0 = HEAPU16[i64toi32_i32$1 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
       i64toi32_i32$2 = HEAPU16[(i64toi32_i32$1 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
       $22 = i64toi32_i32$0;
       $22$hi = i64toi32_i32$2;
       i64toi32_i32$0 = $2;
       HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $22;
       HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$2;
       HEAP8[(i64toi32_i32$0 + 14 | 0) >> 0] = HEAPU8[(i64toi32_i32$0 + 18 | 0) >> 0] | 0;
       i64toi32_i32$1 = $1 + 39 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $154 = i64toi32_i32$2;
       i64toi32_i32$2 = $2;
       $103 = $154;
       HEAP8[(i64toi32_i32$2 + 21 | 0) >> 0] = $103;
       HEAP8[(i64toi32_i32$2 + 22 | 0) >> 0] = $103 >>> 8 | 0;
       HEAP8[(i64toi32_i32$2 + 23 | 0) >> 0] = $103 >>> 16 | 0;
       HEAP8[(i64toi32_i32$2 + 24 | 0) >> 0] = $103 >>> 24 | 0;
       HEAP8[(i64toi32_i32$2 + 25 | 0) >> 0] = i64toi32_i32$0;
       HEAP8[(i64toi32_i32$2 + 26 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
       HEAP8[(i64toi32_i32$2 + 27 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
       HEAP8[(i64toi32_i32$2 + 28 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
       i64toi32_i32$0 = $22$hi;
       HEAP16[(i64toi32_i32$2 + 12 | 0) >> 1] = $22;
       i64toi32_i32$1 = $1 + 55 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = 0;
       $23 = i64toi32_i32$0;
       $23$hi = i64toi32_i32$2;
       $160 = i64toi32_i32$0;
       $160$hi = i64toi32_i32$2;
       i64toi32_i32$1 = $1 + 59 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
       i64toi32_i32$0 = 0;
       $163 = i64toi32_i32$2;
       $163$hi = i64toi32_i32$0;
       i64toi32_i32$1 = $1 + 61 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
       i64toi32_i32$2 = 0;
       i64toi32_i32$1 = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        $121 = 0;
       } else {
        i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
        $121 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       }
       $167$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $163$hi;
       i64toi32_i32$2 = $163;
       i64toi32_i32$1 = $167$hi;
       i64toi32_i32$3 = $121;
       i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $122 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $122 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       $169$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $160$hi;
       i64toi32_i32$1 = $160;
       i64toi32_i32$0 = $169$hi;
       i64toi32_i32$3 = $122;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 8;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = 0;
        $123 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
        $123 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
       }
       $18 = $123;
       $18$hi = i64toi32_i32$1;
       i64toi32_i32$0 = $1 + 47 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $20 = i64toi32_i32$1;
       $20$hi = i64toi32_i32$2;
       i64toi32_i32$0 = i64toi32_i32$1;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $124 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
        $124 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       $176$hi = i64toi32_i32$1;
       i64toi32_i32$2 = $2;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 27 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 28 | 0) >> 0] | 0) << 8 | 0) | 0;
       i64toi32_i32$0 = 0;
       $178 = i64toi32_i32$1;
       $178$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $176$hi;
       i64toi32_i32$2 = $124;
       i64toi32_i32$1 = $178$hi;
       i64toi32_i32$3 = $178;
       i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
       $22 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       $22$hi = i64toi32_i32$1;
       i64toi32_i32$0 = $2;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 21 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 22 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 23 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 24 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = 0;
       $181 = i64toi32_i32$1;
       $181$hi = i64toi32_i32$2;
       i64toi32_i32$0 = i64toi32_i32$0 + 25 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$0 = i64toi32_i32$2;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $125 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $125 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       $185$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $181$hi;
       i64toi32_i32$1 = $181;
       i64toi32_i32$0 = $185$hi;
       i64toi32_i32$3 = $125;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
       $19 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       $19$hi = i64toi32_i32$0;
       $9 = HEAPU8[($1 + 33 | 0) >> 0] | 0;
       $14 = HEAPU8[($2 + 19 | 0) >> 0] | 0 | ((HEAPU8[($2 + 20 | 0) >> 0] | 0) << 8 | 0) | 0;
       i64toi32_i32$2 = $1 + 24 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $17 = i64toi32_i32$0;
       $17$hi = i64toi32_i32$1;
       i64toi32_i32$2 = i64toi32_i32$0;
       i64toi32_i32$0 = -16777216;
       i64toi32_i32$3 = 0;
       i64toi32_i32$0 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
       $24 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
       $24$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $23$hi;
       $10 = $23;
       i64toi32_i32$0 = $20$hi;
       i64toi32_i32$1 = $20;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 48;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = 0;
        $126 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
        $126 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
       }
       $8 = $126;
       i64toi32_i32$2 = $20$hi;
       i64toi32_i32$0 = $20;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 56;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = 0;
        $127 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
        $127 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
       }
       $11 = $127;
       i64toi32_i32$1 = $20$hi;
       i64toi32_i32$2 = $20;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 40;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = 0;
        $128 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
        $128 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
       }
       $13 = $128;
       $4 = HEAP32[($1 + 20 | 0) >> 2] | 0;
       $5 = HEAP32[($1 + 16 | 0) >> 2] | 0;
       i64toi32_i32$1 = $1 + 8 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $20 = i64toi32_i32$0;
       $20$hi = i64toi32_i32$2;
       $15 = 1;
       break label$3;
      case 2:
       $3 = HEAPU8[($1 + 1 | 0) >> 0] | 0;
       i64toi32_i32$1 = $1 + 3 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $22 = i64toi32_i32$2;
       $22$hi = i64toi32_i32$0;
       i64toi32_i32$2 = $2;
       HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] = $22;
       HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$1 = $1 + 8 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $227 = i64toi32_i32$0;
       i64toi32_i32$0 = $2;
       $104 = $227;
       HEAP8[(i64toi32_i32$0 + 21 | 0) >> 0] = $104;
       HEAP8[(i64toi32_i32$0 + 22 | 0) >> 0] = $104 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 23 | 0) >> 0] = $104 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 24 | 0) >> 0] = $104 >>> 24 | 0;
       HEAP8[(i64toi32_i32$0 + 25 | 0) >> 0] = i64toi32_i32$2;
       HEAP8[(i64toi32_i32$0 + 26 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 27 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 28 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
       i64toi32_i32$1 = $1 + 24 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$0 = 0;
       $230 = i64toi32_i32$2;
       $230$hi = i64toi32_i32$0;
       i64toi32_i32$1 = $1 + 28 | 0;
       i64toi32_i32$0 = HEAPU16[i64toi32_i32$1 >> 1] | 0;
       i64toi32_i32$2 = 0;
       $233 = i64toi32_i32$0;
       $233$hi = i64toi32_i32$2;
       i64toi32_i32$1 = $1 + 30 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$1 = i64toi32_i32$2;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        $129 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
        $129 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       }
       $237$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $233$hi;
       i64toi32_i32$0 = $233;
       i64toi32_i32$1 = $237$hi;
       i64toi32_i32$3 = $129;
       i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
       i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $130 = 0;
       } else {
        i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $130 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       $239$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $230$hi;
       i64toi32_i32$1 = $230;
       i64toi32_i32$2 = $239$hi;
       i64toi32_i32$3 = $130;
       i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
       $17 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       $17$hi = i64toi32_i32$2;
       $4 = HEAP32[($1 + 20 | 0) >> 2] | 0;
       $5 = HEAP32[($1 + 16 | 0) >> 2] | 0;
       $15 = 2;
       $6 = HEAPU8[($1 + 2 | 0) >> 0] | 0;
       i64toi32_i32$2 = $22$hi;
       $1 = $22;
       break label$2;
      case 3:
       $15 = 3;
       $3 = HEAPU8[($1 + 1 | 0) >> 0] | 0;
       i64toi32_i32$0 = $1 + 3 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $22 = i64toi32_i32$2;
       $22$hi = i64toi32_i32$1;
       i64toi32_i32$2 = $2;
       HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] = $22;
       HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$0 = $1 + 8 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $262 = i64toi32_i32$1;
       i64toi32_i32$1 = $2;
       $107 = $262;
       HEAP8[(i64toi32_i32$1 + 21 | 0) >> 0] = $107;
       HEAP8[(i64toi32_i32$1 + 22 | 0) >> 0] = $107 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 23 | 0) >> 0] = $107 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 24 | 0) >> 0] = $107 >>> 24 | 0;
       HEAP8[(i64toi32_i32$1 + 25 | 0) >> 0] = i64toi32_i32$2;
       HEAP8[(i64toi32_i32$1 + 26 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 27 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 28 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
       i64toi32_i32$0 = $1 + 24 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
       i64toi32_i32$1 = 0;
       $265 = i64toi32_i32$2;
       $265$hi = i64toi32_i32$1;
       i64toi32_i32$0 = $1 + 28 | 0;
       i64toi32_i32$1 = HEAPU16[i64toi32_i32$0 >> 1] | 0;
       i64toi32_i32$2 = 0;
       $268 = i64toi32_i32$1;
       $268$hi = i64toi32_i32$2;
       i64toi32_i32$0 = $1 + 30 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$0 = i64toi32_i32$2;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $131 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $131 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       $272$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $268$hi;
       i64toi32_i32$1 = $268;
       i64toi32_i32$0 = $272$hi;
       i64toi32_i32$3 = $131;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $132 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
        $132 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       $274$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $265$hi;
       i64toi32_i32$0 = $265;
       i64toi32_i32$2 = $274$hi;
       i64toi32_i32$3 = $132;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
       $17 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
       $17$hi = i64toi32_i32$2;
       $4 = HEAP32[($1 + 20 | 0) >> 2] | 0;
       $5 = HEAP32[($1 + 16 | 0) >> 2] | 0;
       $6 = HEAPU8[($1 + 2 | 0) >> 0] | 0;
       i64toi32_i32$2 = $22$hi;
       $1 = $22;
       break label$2;
      case 4:
       break label$4;
      };
     }
     i64toi32_i32$1 = $1 + 29 | 0;
     i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $290 = i64toi32_i32$2;
     i64toi32_i32$2 = $2;
     $108 = $290;
     HEAP8[(i64toi32_i32$2 + 21 | 0) >> 0] = $108;
     HEAP8[(i64toi32_i32$2 + 22 | 0) >> 0] = $108 >>> 8 | 0;
     HEAP8[(i64toi32_i32$2 + 23 | 0) >> 0] = $108 >>> 16 | 0;
     HEAP8[(i64toi32_i32$2 + 24 | 0) >> 0] = $108 >>> 24 | 0;
     HEAP8[(i64toi32_i32$2 + 25 | 0) >> 0] = i64toi32_i32$0;
     HEAP8[(i64toi32_i32$2 + 26 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
     HEAP8[(i64toi32_i32$2 + 27 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
     HEAP8[(i64toi32_i32$2 + 28 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
     i64toi32_i32$1 = $1 + 24 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $294 = i64toi32_i32$0;
     i64toi32_i32$0 = $2;
     HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $294;
     HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$1 = $1 + 49 | 0;
     i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
     i64toi32_i32$0 = 0;
     $297 = i64toi32_i32$2;
     $297$hi = i64toi32_i32$0;
     i64toi32_i32$1 = $1 + 51 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
     i64toi32_i32$2 = 0;
     i64toi32_i32$1 = i64toi32_i32$0;
     i64toi32_i32$0 = 0;
     i64toi32_i32$3 = 16;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
      $133 = 0;
     } else {
      i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
      $133 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
     }
     $301$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $297$hi;
     i64toi32_i32$2 = $297;
     i64toi32_i32$1 = $301$hi;
     i64toi32_i32$3 = $133;
     i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
     i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
     i64toi32_i32$2 = 0;
     i64toi32_i32$3 = 32;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
      $134 = 0;
     } else {
      i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
      $134 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
     }
     $22 = $134;
     $22$hi = i64toi32_i32$2;
     i64toi32_i32$1 = $1 + 45 | 0;
     i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = 0;
     $17 = i64toi32_i32$2;
     $17$hi = i64toi32_i32$0;
     i64toi32_i32$1 = $1 + 37 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $18 = i64toi32_i32$0;
     $18$hi = i64toi32_i32$2;
     $15 = 4;
     label$9 : {
      label$10 : {
       $3 = $1 + 4 | 0;
       if (HEAP32[$3 >> 2] | 0) {
        break label$10
       }
       $7 = 0;
       break label$9;
      }
      $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($2 + 32 | 0 | 0, $3 | 0);
      i64toi32_i32$1 = $2;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 40 | 0) >> 2] | 0;
      $20 = i64toi32_i32$2;
      $20$hi = i64toi32_i32$0;
      $7 = HEAP32[(i64toi32_i32$1 + 32 | 0) >> 2] | 0;
     }
     i64toi32_i32$0 = $17$hi;
     i64toi32_i32$0 = $22$hi;
     i64toi32_i32$0 = $17$hi;
     i64toi32_i32$1 = $17;
     i64toi32_i32$2 = $22$hi;
     i64toi32_i32$3 = $22;
     i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
     $22 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
     $22$hi = i64toi32_i32$2;
     HEAP8[($2 + 14 | 0) >> 0] = HEAPU8[($2 + 28 | 0) >> 0] | 0;
     HEAP16[($2 + 12 | 0) >> 1] = HEAPU16[($2 + 26 | 0) >> 1] | 0;
     i64toi32_i32$2 = $18$hi;
     i64toi32_i32$0 = $18;
     i64toi32_i32$1 = 0;
     i64toi32_i32$3 = 16;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$1 = 0;
      $135 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
     } else {
      i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
      $135 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
     }
     $19 = $135;
     $19$hi = i64toi32_i32$1;
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
     $17 = i64toi32_i32$1;
     $17$hi = i64toi32_i32$0;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$1 = -16777216;
     i64toi32_i32$3 = 0;
     i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
     $24 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     $24$hi = i64toi32_i32$1;
     $4 = HEAP32[($1 + 20 | 0) >> 2] | 0;
     $5 = HEAP32[($1 + 16 | 0) >> 2] | 0;
     $13 = HEAPU8[($1 + 52 | 0) >> 0] | 0;
     $12 = HEAPU8[($2 + 24 | 0) >> 0] | 0;
     $9 = HEAPU8[($2 + 25 | 0) >> 0] | 0;
     i64toi32_i32$1 = $18$hi;
     $14 = $18;
    }
    break label$1;
   }
   $7 = HEAPU8[($2 + 17 | 0) >> 0] | 0 | ((HEAPU8[($2 + 18 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 19 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 20 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = $2;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 21 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 22 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 23 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 24 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 25 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 26 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 27 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 28 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $20 = i64toi32_i32$1;
   $20$hi = i64toi32_i32$2;
   i64toi32_i32$2 = 0;
   $24 = 0;
   $24$hi = i64toi32_i32$2;
  }
  HEAP8[($0 + 1 | 0) >> 0] = $3;
  HEAP8[$0 >> 0] = $15;
  $362 = $0 + 51 | 0;
  i64toi32_i32$2 = $22$hi;
  i64toi32_i32$0 = $22;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 48;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $136 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   $136 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[$362 >> 0] = $136;
  $366 = $0 + 49 | 0;
  i64toi32_i32$1 = $22$hi;
  i64toi32_i32$2 = $22;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $137 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   $137 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  $138 = $366;
  $139 = $137;
  HEAP8[$138 >> 0] = $139;
  HEAP8[($138 + 1 | 0) >> 0] = $139 >>> 8 | 0;
  i64toi32_i32$0 = $22$hi;
  $109 = $0 + 45 | 0;
  HEAP8[$109 >> 0] = $22;
  HEAP8[($109 + 1 | 0) >> 0] = $22 >>> 8 | 0;
  HEAP8[($109 + 2 | 0) >> 0] = $22 >>> 16 | 0;
  HEAP8[($109 + 3 | 0) >> 0] = $22 >>> 24 | 0;
  HEAP8[($0 + 33 | 0) >> 0] = $9;
  HEAP8[($0 + 32 | 0) >> 0] = $12;
  i64toi32_i32$0 = $20$hi;
  i64toi32_i32$2 = $0 + 8 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $20;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($0 + 4 | 0) >> 2] = $7;
  HEAP8[($0 + 3 | 0) >> 0] = $1;
  HEAP8[($0 + 2 | 0) >> 0] = $6;
  HEAP16[($0 + 34 | 0) >> 1] = HEAPU16[($2 + 12 | 0) >> 1] | 0;
  i64toi32_i32$0 = $18$hi;
  i64toi32_i32$2 = $0 + 56 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $18;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP8[($0 + 55 | 0) >> 0] = $10;
  HEAP8[($0 + 54 | 0) >> 0] = $11;
  HEAP8[($0 + 53 | 0) >> 0] = $8;
  HEAP8[($0 + 52 | 0) >> 0] = $13;
  i64toi32_i32$0 = $24$hi;
  i64toi32_i32$0 = $17$hi;
  i64toi32_i32$1 = $17;
  i64toi32_i32$2 = 16777215;
  i64toi32_i32$3 = -1;
  i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
  $413 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
  $413$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $24$hi;
  i64toi32_i32$0 = $24;
  i64toi32_i32$1 = $413$hi;
  i64toi32_i32$3 = $413;
  i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
  $414 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $0 + 24 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $414;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP8[($0 + 36 | 0) >> 0] = HEAPU8[(($2 + 12 | 0) + 2 | 0) >> 0] | 0;
  $422 = $0 + 16 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $140 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $140 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $425$hi = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  $427$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $425$hi;
  i64toi32_i32$1 = $140;
  i64toi32_i32$2 = $427$hi;
  i64toi32_i32$3 = $5;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  $428 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $422;
  HEAP32[i64toi32_i32$1 >> 2] = $428;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  $430 = $0 + 37 | 0;
  i64toi32_i32$2 = $19$hi;
  i64toi32_i32$0 = $19;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 16;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   $141 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
   $141 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
  }
  $432$hi = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  i64toi32_i32$2 = $14;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 65535;
  i64toi32_i32$0 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
  $435 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
  $435$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $432$hi;
  i64toi32_i32$1 = $141;
  i64toi32_i32$2 = $435$hi;
  i64toi32_i32$3 = $435;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  $436 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $430;
  $110 = $436;
  HEAP8[i64toi32_i32$1 >> 0] = $110;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $110 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $110 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $110 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$2;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
  global$0 = $2 + 48 | 0;
 }
 
 function $cardano_serialization_lib__address__Address_20as_20core__clone__Clone___clone__h0eb465a6e349d507_1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $2 = 0, $22 = 0, $22$hi = 0, $17$hi = 0, $17 = 0, $19 = 0, $19$hi = 0, $20 = 0, $20$hi = 0, $18 = 0, $18$hi = 0, $24$hi = 0, $3 = 0, $24 = 0, $4 = 0, $5 = 0, $15 = 0, $101 = 0, $7 = 0, $102 = 0, $8 = 0, $23 = 0, $23$hi = 0, $103 = 0, $104 = 0, $107 = 0, $108 = 0, $109 = 0, $110 = 0, $6 = 0, $25 = 0, $25$hi = 0, $9 = 0, $12 = 0, $13 = 0, $14 = 0, $16 = 0, $21 = 0, $111 = 0, $112 = 0, $113 = 0, $114 = 0, $115 = 0, $116 = 0, $10 = 0, $117 = 0, $11 = 0, $118 = 0, $119 = 0, $120 = 0, $121 = 0, $122 = 0, $123 = 0, $124 = 0, $125 = 0, $126 = 0, $127 = 0, $128 = 0, $129 = 0, $130 = 0, $131 = 0, $132 = 0, $133 = 0, $134 = 0, $135 = 0, $136 = 0, $137 = 0, $138 = 0, $139 = 0, $140 = 0, $141 = 0, $16$hi = 0, $41 = 0, $21$hi = 0, $72 = 0, $98 = 0, $98$hi = 0, $99 = 0, $99$hi = 0, $101$hi = 0, $103$hi = 0, $105 = 0, $105$hi = 0, $106 = 0, $106$hi = 0, $108$hi = 0, $110$hi = 0, $154 = 0, $160 = 0, $160$hi = 0, $163 = 0, $163$hi = 0, $167$hi = 0, $169$hi = 0, $176$hi = 0, $178 = 0, $178$hi = 0, $181 = 0, $181$hi = 0, $185$hi = 0, $227 = 0, $230 = 0, $230$hi = 0, $233 = 0, $233$hi = 0, $237$hi = 0, $239$hi = 0, $262 = 0, $265 = 0, $265$hi = 0, $268 = 0, $268$hi = 0, $272$hi = 0, $274$hi = 0, $290 = 0, $294 = 0, $297 = 0, $297$hi = 0, $301$hi = 0, $362 = 0, $366 = 0, $413 = 0, $413$hi = 0, $414 = 0, $422 = 0, $425$hi = 0, $427$hi = 0, $428 = 0, $430 = 0, $432$hi = 0, $435 = 0, $435$hi = 0, $436 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      switch (HEAPU8[$1 >> 0] | 0 | 0) {
      default:
       $3 = HEAPU8[($1 + 1 | 0) >> 0] | 0;
       i64toi32_i32$2 = $1 + 3 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $16 = i64toi32_i32$0;
       $16$hi = i64toi32_i32$1;
       i64toi32_i32$0 = $2;
       HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $16;
       HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $1 + 8 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $41 = i64toi32_i32$1;
       i64toi32_i32$1 = $2;
       $101 = $41;
       HEAP8[(i64toi32_i32$1 + 21 | 0) >> 0] = $101;
       HEAP8[(i64toi32_i32$1 + 22 | 0) >> 0] = $101 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 23 | 0) >> 0] = $101 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 24 | 0) >> 0] = $101 >>> 24 | 0;
       HEAP8[(i64toi32_i32$1 + 25 | 0) >> 0] = i64toi32_i32$0;
       HEAP8[(i64toi32_i32$1 + 26 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 27 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 28 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
       $4 = HEAP32[($1 + 20 | 0) >> 2] | 0;
       $5 = HEAP32[($1 + 16 | 0) >> 2] | 0;
       $6 = HEAPU8[($1 + 2 | 0) >> 0] | 0;
       i64toi32_i32$2 = $1 + 24 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = 0;
       $17 = i64toi32_i32$0;
       $17$hi = i64toi32_i32$1;
       i64toi32_i32$2 = $1 + 28 | 0;
       i64toi32_i32$1 = HEAPU16[i64toi32_i32$2 >> 1] | 0;
       i64toi32_i32$0 = 0;
       $18 = i64toi32_i32$1;
       $18$hi = i64toi32_i32$0;
       i64toi32_i32$2 = $1 + 30 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
       i64toi32_i32$1 = 0;
       $19 = i64toi32_i32$0;
       $19$hi = i64toi32_i32$1;
       $7 = HEAPU8[($2 + 17 | 0) >> 0] | 0 | ((HEAPU8[($2 + 18 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 19 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 20 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = $2;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 21 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 22 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 23 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 24 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 25 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 26 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 27 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 28 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $20 = i64toi32_i32$1;
       $20$hi = i64toi32_i32$0;
       i64toi32_i32$2 = $1 + 32 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $21 = i64toi32_i32$0;
       $21$hi = i64toi32_i32$1;
       i64toi32_i32$0 = $2;
       HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $21;
       HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $1 + 37 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $72 = i64toi32_i32$1;
       i64toi32_i32$1 = $2;
       $102 = $72;
       HEAP8[(i64toi32_i32$1 + 21 | 0) >> 0] = $102;
       HEAP8[(i64toi32_i32$1 + 22 | 0) >> 0] = $102 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 23 | 0) >> 0] = $102 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 24 | 0) >> 0] = $102 >>> 24 | 0;
       HEAP8[(i64toi32_i32$1 + 25 | 0) >> 0] = i64toi32_i32$0;
       HEAP8[(i64toi32_i32$1 + 26 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 27 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 28 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
       i64toi32_i32$2 = $1 + 45 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $22 = i64toi32_i32$0;
       $22$hi = i64toi32_i32$1;
       $8 = HEAPU8[($1 + 31 | 0) >> 0] | 0;
       i64toi32_i32$2 = $1 + 53 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = 0;
       $23 = i64toi32_i32$1;
       $23$hi = i64toi32_i32$0;
       i64toi32_i32$2 = $1 + 57 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
       i64toi32_i32$1 = 0;
       $24 = i64toi32_i32$0;
       $24$hi = i64toi32_i32$1;
       i64toi32_i32$2 = $1 + 59 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
       i64toi32_i32$0 = 0;
       $25 = i64toi32_i32$1;
       $25$hi = i64toi32_i32$0;
       $9 = HEAPU8[($2 + 17 | 0) >> 0] | 0;
       HEAP8[(($2 + 12 | 0) + 2 | 0) >> 0] = HEAPU8[($2 + 20 | 0) >> 0] | 0;
       HEAP16[($2 + 12 | 0) >> 1] = HEAPU16[($2 + 18 | 0) >> 1] | 0;
       i64toi32_i32$0 = $17$hi;
       $98 = $17;
       $98$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $18$hi;
       $99 = $18;
       $99$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $19$hi;
       i64toi32_i32$2 = $19;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $111 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
        $111 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       $101$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $99$hi;
       i64toi32_i32$0 = $99;
       i64toi32_i32$2 = $101$hi;
       i64toi32_i32$3 = $111;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
       i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        $112 = 0;
       } else {
        i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
        $112 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       }
       $103$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $98$hi;
       i64toi32_i32$2 = $98;
       i64toi32_i32$1 = $103$hi;
       i64toi32_i32$3 = $112;
       i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
       $17 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       $17$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $23$hi;
       $105 = $23;
       $105$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $24$hi;
       $106 = $24;
       $106$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $25$hi;
       i64toi32_i32$0 = $25;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $113 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $113 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       $108$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $106$hi;
       i64toi32_i32$1 = $106;
       i64toi32_i32$0 = $108$hi;
       i64toi32_i32$3 = $113;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $114 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
        $114 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       $110$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $105$hi;
       i64toi32_i32$0 = $105;
       i64toi32_i32$2 = $110$hi;
       i64toi32_i32$3 = $114;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
       $19 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
       $19$hi = i64toi32_i32$2;
       i64toi32_i32$1 = $19;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 24;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = 0;
        $115 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
        $115 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
       }
       $18 = $115;
       $18$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $19$hi;
       i64toi32_i32$2 = $19;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = 0;
        $116 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
        $116 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
       }
       $10 = $116;
       i64toi32_i32$1 = $19$hi;
       i64toi32_i32$0 = $19;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 8;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = 0;
        $117 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
        $117 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
       }
       $11 = $117;
       i64toi32_i32$1 = $2;
       i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 21 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 22 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 23 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 24 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 25 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 26 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 27 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 28 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $25 = i64toi32_i32$2;
       $25$hi = i64toi32_i32$0;
       i64toi32_i32$1 = i64toi32_i32$2;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = 0;
        $118 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
        $118 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
       }
       $19 = $118;
       $19$hi = i64toi32_i32$2;
       i64toi32_i32$2 = 0;
       i64toi32_i32$0 = ($8 | 0) == (1 | 0);
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 56;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $119 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
        $119 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       $24 = $119;
       $24$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $16$hi;
       $1 = $16;
       i64toi32_i32$1 = $23$hi;
       $8 = $23;
       i64toi32_i32$1 = $21$hi;
       $12 = $21;
       i64toi32_i32$1 = $22$hi;
       i64toi32_i32$2 = $22;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 56;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = 0;
        $120 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
        $120 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
       }
       $13 = $120;
       i64toi32_i32$0 = $25$hi;
       $14 = $25;
       $15 = 0;
       break label$1;
      case 1:
       $12 = HEAPU8[($1 + 32 | 0) >> 0] | 0;
       i64toi32_i32$1 = $1 + 34 | 0;
       i64toi32_i32$0 = HEAPU16[i64toi32_i32$1 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
       i64toi32_i32$2 = HEAPU16[(i64toi32_i32$1 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
       $22 = i64toi32_i32$0;
       $22$hi = i64toi32_i32$2;
       i64toi32_i32$0 = $2;
       HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $22;
       HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$2;
       HEAP8[(i64toi32_i32$0 + 14 | 0) >> 0] = HEAPU8[(i64toi32_i32$0 + 18 | 0) >> 0] | 0;
       i64toi32_i32$1 = $1 + 39 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $154 = i64toi32_i32$2;
       i64toi32_i32$2 = $2;
       $103 = $154;
       HEAP8[(i64toi32_i32$2 + 21 | 0) >> 0] = $103;
       HEAP8[(i64toi32_i32$2 + 22 | 0) >> 0] = $103 >>> 8 | 0;
       HEAP8[(i64toi32_i32$2 + 23 | 0) >> 0] = $103 >>> 16 | 0;
       HEAP8[(i64toi32_i32$2 + 24 | 0) >> 0] = $103 >>> 24 | 0;
       HEAP8[(i64toi32_i32$2 + 25 | 0) >> 0] = i64toi32_i32$0;
       HEAP8[(i64toi32_i32$2 + 26 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
       HEAP8[(i64toi32_i32$2 + 27 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
       HEAP8[(i64toi32_i32$2 + 28 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
       i64toi32_i32$0 = $22$hi;
       HEAP16[(i64toi32_i32$2 + 12 | 0) >> 1] = $22;
       i64toi32_i32$1 = $1 + 55 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = 0;
       $23 = i64toi32_i32$0;
       $23$hi = i64toi32_i32$2;
       $160 = i64toi32_i32$0;
       $160$hi = i64toi32_i32$2;
       i64toi32_i32$1 = $1 + 59 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
       i64toi32_i32$0 = 0;
       $163 = i64toi32_i32$2;
       $163$hi = i64toi32_i32$0;
       i64toi32_i32$1 = $1 + 61 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
       i64toi32_i32$2 = 0;
       i64toi32_i32$1 = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        $121 = 0;
       } else {
        i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
        $121 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       }
       $167$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $163$hi;
       i64toi32_i32$2 = $163;
       i64toi32_i32$1 = $167$hi;
       i64toi32_i32$3 = $121;
       i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $122 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $122 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       $169$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $160$hi;
       i64toi32_i32$1 = $160;
       i64toi32_i32$0 = $169$hi;
       i64toi32_i32$3 = $122;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 8;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = 0;
        $123 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
        $123 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
       }
       $18 = $123;
       $18$hi = i64toi32_i32$1;
       i64toi32_i32$0 = $1 + 47 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $20 = i64toi32_i32$1;
       $20$hi = i64toi32_i32$2;
       i64toi32_i32$0 = i64toi32_i32$1;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $124 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
        $124 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       $176$hi = i64toi32_i32$1;
       i64toi32_i32$2 = $2;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 27 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 28 | 0) >> 0] | 0) << 8 | 0) | 0;
       i64toi32_i32$0 = 0;
       $178 = i64toi32_i32$1;
       $178$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $176$hi;
       i64toi32_i32$2 = $124;
       i64toi32_i32$1 = $178$hi;
       i64toi32_i32$3 = $178;
       i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
       $22 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       $22$hi = i64toi32_i32$1;
       i64toi32_i32$0 = $2;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 21 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 22 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 23 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 24 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = 0;
       $181 = i64toi32_i32$1;
       $181$hi = i64toi32_i32$2;
       i64toi32_i32$0 = i64toi32_i32$0 + 25 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$0 = i64toi32_i32$2;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $125 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $125 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       $185$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $181$hi;
       i64toi32_i32$1 = $181;
       i64toi32_i32$0 = $185$hi;
       i64toi32_i32$3 = $125;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
       $19 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       $19$hi = i64toi32_i32$0;
       $9 = HEAPU8[($1 + 33 | 0) >> 0] | 0;
       $14 = HEAPU8[($2 + 19 | 0) >> 0] | 0 | ((HEAPU8[($2 + 20 | 0) >> 0] | 0) << 8 | 0) | 0;
       i64toi32_i32$2 = $1 + 24 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $17 = i64toi32_i32$0;
       $17$hi = i64toi32_i32$1;
       i64toi32_i32$2 = i64toi32_i32$0;
       i64toi32_i32$0 = -16777216;
       i64toi32_i32$3 = 0;
       i64toi32_i32$0 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
       $24 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
       $24$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $23$hi;
       $10 = $23;
       i64toi32_i32$0 = $20$hi;
       i64toi32_i32$1 = $20;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 48;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = 0;
        $126 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
        $126 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
       }
       $8 = $126;
       i64toi32_i32$2 = $20$hi;
       i64toi32_i32$0 = $20;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 56;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = 0;
        $127 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
        $127 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
       }
       $11 = $127;
       i64toi32_i32$1 = $20$hi;
       i64toi32_i32$2 = $20;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 40;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = 0;
        $128 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
        $128 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
       }
       $13 = $128;
       $4 = HEAP32[($1 + 20 | 0) >> 2] | 0;
       $5 = HEAP32[($1 + 16 | 0) >> 2] | 0;
       i64toi32_i32$1 = $1 + 8 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $20 = i64toi32_i32$0;
       $20$hi = i64toi32_i32$2;
       $15 = 1;
       break label$3;
      case 2:
       $3 = HEAPU8[($1 + 1 | 0) >> 0] | 0;
       i64toi32_i32$1 = $1 + 3 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $22 = i64toi32_i32$2;
       $22$hi = i64toi32_i32$0;
       i64toi32_i32$2 = $2;
       HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] = $22;
       HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$1 = $1 + 8 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $227 = i64toi32_i32$0;
       i64toi32_i32$0 = $2;
       $104 = $227;
       HEAP8[(i64toi32_i32$0 + 21 | 0) >> 0] = $104;
       HEAP8[(i64toi32_i32$0 + 22 | 0) >> 0] = $104 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 23 | 0) >> 0] = $104 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 24 | 0) >> 0] = $104 >>> 24 | 0;
       HEAP8[(i64toi32_i32$0 + 25 | 0) >> 0] = i64toi32_i32$2;
       HEAP8[(i64toi32_i32$0 + 26 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 27 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 28 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
       i64toi32_i32$1 = $1 + 24 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$0 = 0;
       $230 = i64toi32_i32$2;
       $230$hi = i64toi32_i32$0;
       i64toi32_i32$1 = $1 + 28 | 0;
       i64toi32_i32$0 = HEAPU16[i64toi32_i32$1 >> 1] | 0;
       i64toi32_i32$2 = 0;
       $233 = i64toi32_i32$0;
       $233$hi = i64toi32_i32$2;
       i64toi32_i32$1 = $1 + 30 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$1 = i64toi32_i32$2;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        $129 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
        $129 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       }
       $237$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $233$hi;
       i64toi32_i32$0 = $233;
       i64toi32_i32$1 = $237$hi;
       i64toi32_i32$3 = $129;
       i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
       i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $130 = 0;
       } else {
        i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $130 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       $239$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $230$hi;
       i64toi32_i32$1 = $230;
       i64toi32_i32$2 = $239$hi;
       i64toi32_i32$3 = $130;
       i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
       $17 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       $17$hi = i64toi32_i32$2;
       $4 = HEAP32[($1 + 20 | 0) >> 2] | 0;
       $5 = HEAP32[($1 + 16 | 0) >> 2] | 0;
       $15 = 2;
       $6 = HEAPU8[($1 + 2 | 0) >> 0] | 0;
       i64toi32_i32$2 = $22$hi;
       $1 = $22;
       break label$2;
      case 3:
       $15 = 3;
       $3 = HEAPU8[($1 + 1 | 0) >> 0] | 0;
       i64toi32_i32$0 = $1 + 3 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $22 = i64toi32_i32$2;
       $22$hi = i64toi32_i32$1;
       i64toi32_i32$2 = $2;
       HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] = $22;
       HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$0 = $1 + 8 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $262 = i64toi32_i32$1;
       i64toi32_i32$1 = $2;
       $107 = $262;
       HEAP8[(i64toi32_i32$1 + 21 | 0) >> 0] = $107;
       HEAP8[(i64toi32_i32$1 + 22 | 0) >> 0] = $107 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 23 | 0) >> 0] = $107 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 24 | 0) >> 0] = $107 >>> 24 | 0;
       HEAP8[(i64toi32_i32$1 + 25 | 0) >> 0] = i64toi32_i32$2;
       HEAP8[(i64toi32_i32$1 + 26 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 27 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 28 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
       i64toi32_i32$0 = $1 + 24 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
       i64toi32_i32$1 = 0;
       $265 = i64toi32_i32$2;
       $265$hi = i64toi32_i32$1;
       i64toi32_i32$0 = $1 + 28 | 0;
       i64toi32_i32$1 = HEAPU16[i64toi32_i32$0 >> 1] | 0;
       i64toi32_i32$2 = 0;
       $268 = i64toi32_i32$1;
       $268$hi = i64toi32_i32$2;
       i64toi32_i32$0 = $1 + 30 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$0 = i64toi32_i32$2;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $131 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $131 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       $272$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $268$hi;
       i64toi32_i32$1 = $268;
       i64toi32_i32$0 = $272$hi;
       i64toi32_i32$3 = $131;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $132 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
        $132 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       $274$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $265$hi;
       i64toi32_i32$0 = $265;
       i64toi32_i32$2 = $274$hi;
       i64toi32_i32$3 = $132;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
       $17 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
       $17$hi = i64toi32_i32$2;
       $4 = HEAP32[($1 + 20 | 0) >> 2] | 0;
       $5 = HEAP32[($1 + 16 | 0) >> 2] | 0;
       $6 = HEAPU8[($1 + 2 | 0) >> 0] | 0;
       i64toi32_i32$2 = $22$hi;
       $1 = $22;
       break label$2;
      case 4:
       break label$4;
      };
     }
     i64toi32_i32$1 = $1 + 29 | 0;
     i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $290 = i64toi32_i32$2;
     i64toi32_i32$2 = $2;
     $108 = $290;
     HEAP8[(i64toi32_i32$2 + 21 | 0) >> 0] = $108;
     HEAP8[(i64toi32_i32$2 + 22 | 0) >> 0] = $108 >>> 8 | 0;
     HEAP8[(i64toi32_i32$2 + 23 | 0) >> 0] = $108 >>> 16 | 0;
     HEAP8[(i64toi32_i32$2 + 24 | 0) >> 0] = $108 >>> 24 | 0;
     HEAP8[(i64toi32_i32$2 + 25 | 0) >> 0] = i64toi32_i32$0;
     HEAP8[(i64toi32_i32$2 + 26 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
     HEAP8[(i64toi32_i32$2 + 27 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
     HEAP8[(i64toi32_i32$2 + 28 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
     i64toi32_i32$1 = $1 + 24 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $294 = i64toi32_i32$0;
     i64toi32_i32$0 = $2;
     HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $294;
     HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$1 = $1 + 49 | 0;
     i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
     i64toi32_i32$0 = 0;
     $297 = i64toi32_i32$2;
     $297$hi = i64toi32_i32$0;
     i64toi32_i32$1 = $1 + 51 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
     i64toi32_i32$2 = 0;
     i64toi32_i32$1 = i64toi32_i32$0;
     i64toi32_i32$0 = 0;
     i64toi32_i32$3 = 16;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
      $133 = 0;
     } else {
      i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
      $133 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
     }
     $301$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $297$hi;
     i64toi32_i32$2 = $297;
     i64toi32_i32$1 = $301$hi;
     i64toi32_i32$3 = $133;
     i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
     i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
     i64toi32_i32$2 = 0;
     i64toi32_i32$3 = 32;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
      $134 = 0;
     } else {
      i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
      $134 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
     }
     $22 = $134;
     $22$hi = i64toi32_i32$2;
     i64toi32_i32$1 = $1 + 45 | 0;
     i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = 0;
     $17 = i64toi32_i32$2;
     $17$hi = i64toi32_i32$0;
     i64toi32_i32$1 = $1 + 37 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $18 = i64toi32_i32$0;
     $18$hi = i64toi32_i32$2;
     $15 = 4;
     label$9 : {
      label$10 : {
       $3 = $1 + 4 | 0;
       if (HEAP32[$3 >> 2] | 0) {
        break label$10
       }
       $7 = 0;
       break label$9;
      }
      $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($2 + 32 | 0 | 0, $3 | 0);
      i64toi32_i32$1 = $2;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 40 | 0) >> 2] | 0;
      $20 = i64toi32_i32$2;
      $20$hi = i64toi32_i32$0;
      $7 = HEAP32[(i64toi32_i32$1 + 32 | 0) >> 2] | 0;
     }
     i64toi32_i32$0 = $17$hi;
     i64toi32_i32$0 = $22$hi;
     i64toi32_i32$0 = $17$hi;
     i64toi32_i32$1 = $17;
     i64toi32_i32$2 = $22$hi;
     i64toi32_i32$3 = $22;
     i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
     $22 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
     $22$hi = i64toi32_i32$2;
     HEAP8[($2 + 14 | 0) >> 0] = HEAPU8[($2 + 28 | 0) >> 0] | 0;
     HEAP16[($2 + 12 | 0) >> 1] = HEAPU16[($2 + 26 | 0) >> 1] | 0;
     i64toi32_i32$2 = $18$hi;
     i64toi32_i32$0 = $18;
     i64toi32_i32$1 = 0;
     i64toi32_i32$3 = 16;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$1 = 0;
      $135 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
     } else {
      i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
      $135 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
     }
     $19 = $135;
     $19$hi = i64toi32_i32$1;
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
     $17 = i64toi32_i32$1;
     $17$hi = i64toi32_i32$0;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$1 = -16777216;
     i64toi32_i32$3 = 0;
     i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
     $24 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     $24$hi = i64toi32_i32$1;
     $4 = HEAP32[($1 + 20 | 0) >> 2] | 0;
     $5 = HEAP32[($1 + 16 | 0) >> 2] | 0;
     $13 = HEAPU8[($1 + 52 | 0) >> 0] | 0;
     $12 = HEAPU8[($2 + 24 | 0) >> 0] | 0;
     $9 = HEAPU8[($2 + 25 | 0) >> 0] | 0;
     i64toi32_i32$1 = $18$hi;
     $14 = $18;
    }
    break label$1;
   }
   $7 = HEAPU8[($2 + 17 | 0) >> 0] | 0 | ((HEAPU8[($2 + 18 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 19 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 20 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = $2;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 21 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 22 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 23 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 24 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 25 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 26 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 27 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 28 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $20 = i64toi32_i32$1;
   $20$hi = i64toi32_i32$2;
   i64toi32_i32$2 = 0;
   $24 = 0;
   $24$hi = i64toi32_i32$2;
  }
  HEAP8[($0 + 1 | 0) >> 0] = $3;
  HEAP8[$0 >> 0] = $15;
  $362 = $0 + 51 | 0;
  i64toi32_i32$2 = $22$hi;
  i64toi32_i32$0 = $22;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 48;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $136 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   $136 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[$362 >> 0] = $136;
  $366 = $0 + 49 | 0;
  i64toi32_i32$1 = $22$hi;
  i64toi32_i32$2 = $22;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $137 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   $137 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  $138 = $366;
  $139 = $137;
  HEAP8[$138 >> 0] = $139;
  HEAP8[($138 + 1 | 0) >> 0] = $139 >>> 8 | 0;
  i64toi32_i32$0 = $22$hi;
  $109 = $0 + 45 | 0;
  HEAP8[$109 >> 0] = $22;
  HEAP8[($109 + 1 | 0) >> 0] = $22 >>> 8 | 0;
  HEAP8[($109 + 2 | 0) >> 0] = $22 >>> 16 | 0;
  HEAP8[($109 + 3 | 0) >> 0] = $22 >>> 24 | 0;
  HEAP8[($0 + 33 | 0) >> 0] = $9;
  HEAP8[($0 + 32 | 0) >> 0] = $12;
  i64toi32_i32$0 = $20$hi;
  i64toi32_i32$2 = $0 + 8 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $20;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($0 + 4 | 0) >> 2] = $7;
  HEAP8[($0 + 3 | 0) >> 0] = $1;
  HEAP8[($0 + 2 | 0) >> 0] = $6;
  HEAP16[($0 + 34 | 0) >> 1] = HEAPU16[($2 + 12 | 0) >> 1] | 0;
  i64toi32_i32$0 = $18$hi;
  i64toi32_i32$2 = $0 + 56 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $18;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP8[($0 + 55 | 0) >> 0] = $10;
  HEAP8[($0 + 54 | 0) >> 0] = $11;
  HEAP8[($0 + 53 | 0) >> 0] = $8;
  HEAP8[($0 + 52 | 0) >> 0] = $13;
  i64toi32_i32$0 = $24$hi;
  i64toi32_i32$0 = $17$hi;
  i64toi32_i32$1 = $17;
  i64toi32_i32$2 = 16777215;
  i64toi32_i32$3 = -1;
  i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
  $413 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
  $413$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $24$hi;
  i64toi32_i32$0 = $24;
  i64toi32_i32$1 = $413$hi;
  i64toi32_i32$3 = $413;
  i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
  $414 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $0 + 24 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $414;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP8[($0 + 36 | 0) >> 0] = HEAPU8[(($2 + 12 | 0) + 2 | 0) >> 0] | 0;
  $422 = $0 + 16 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $140 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $140 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $425$hi = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  $427$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $425$hi;
  i64toi32_i32$1 = $140;
  i64toi32_i32$2 = $427$hi;
  i64toi32_i32$3 = $5;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  $428 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $422;
  HEAP32[i64toi32_i32$1 >> 2] = $428;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  $430 = $0 + 37 | 0;
  i64toi32_i32$2 = $19$hi;
  i64toi32_i32$0 = $19;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 16;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   $141 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
   $141 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
  }
  $432$hi = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  i64toi32_i32$2 = $14;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 65535;
  i64toi32_i32$0 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
  $435 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
  $435$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $432$hi;
  i64toi32_i32$1 = $141;
  i64toi32_i32$2 = $435$hi;
  i64toi32_i32$3 = $435;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  $436 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $430;
  $110 = $436;
  HEAP8[i64toi32_i32$1 >> 0] = $110;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $110 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $110 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $110 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$2;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
  global$0 = $2 + 48 | 0;
 }
 
 function $cardano_serialization_lib__address__Address_20as_20core__clone__Clone___clone__h0eb465a6e349d507_2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $2 = 0, $22 = 0, $22$hi = 0, $17$hi = 0, $17 = 0, $19 = 0, $19$hi = 0, $20 = 0, $20$hi = 0, $18 = 0, $18$hi = 0, $24$hi = 0, $3 = 0, $24 = 0, $4 = 0, $5 = 0, $15 = 0, $101 = 0, $7 = 0, $102 = 0, $8 = 0, $23 = 0, $23$hi = 0, $103 = 0, $104 = 0, $107 = 0, $108 = 0, $109 = 0, $110 = 0, $6 = 0, $25 = 0, $25$hi = 0, $9 = 0, $12 = 0, $13 = 0, $14 = 0, $16 = 0, $21 = 0, $111 = 0, $112 = 0, $113 = 0, $114 = 0, $115 = 0, $116 = 0, $10 = 0, $117 = 0, $11 = 0, $118 = 0, $119 = 0, $120 = 0, $121 = 0, $122 = 0, $123 = 0, $124 = 0, $125 = 0, $126 = 0, $127 = 0, $128 = 0, $129 = 0, $130 = 0, $131 = 0, $132 = 0, $133 = 0, $134 = 0, $135 = 0, $136 = 0, $137 = 0, $138 = 0, $139 = 0, $140 = 0, $141 = 0, $16$hi = 0, $41 = 0, $21$hi = 0, $72 = 0, $98 = 0, $98$hi = 0, $99 = 0, $99$hi = 0, $101$hi = 0, $103$hi = 0, $105 = 0, $105$hi = 0, $106 = 0, $106$hi = 0, $108$hi = 0, $110$hi = 0, $154 = 0, $160 = 0, $160$hi = 0, $163 = 0, $163$hi = 0, $167$hi = 0, $169$hi = 0, $176$hi = 0, $178 = 0, $178$hi = 0, $181 = 0, $181$hi = 0, $185$hi = 0, $227 = 0, $230 = 0, $230$hi = 0, $233 = 0, $233$hi = 0, $237$hi = 0, $239$hi = 0, $262 = 0, $265 = 0, $265$hi = 0, $268 = 0, $268$hi = 0, $272$hi = 0, $274$hi = 0, $290 = 0, $294 = 0, $297 = 0, $297$hi = 0, $301$hi = 0, $362 = 0, $366 = 0, $413 = 0, $413$hi = 0, $414 = 0, $422 = 0, $425$hi = 0, $427$hi = 0, $428 = 0, $430 = 0, $432$hi = 0, $435 = 0, $435$hi = 0, $436 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      switch (HEAPU8[$1 >> 0] | 0 | 0) {
      default:
       $3 = HEAPU8[($1 + 1 | 0) >> 0] | 0;
       i64toi32_i32$2 = $1 + 3 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $16 = i64toi32_i32$0;
       $16$hi = i64toi32_i32$1;
       i64toi32_i32$0 = $2;
       HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $16;
       HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $1 + 8 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $41 = i64toi32_i32$1;
       i64toi32_i32$1 = $2;
       $101 = $41;
       HEAP8[(i64toi32_i32$1 + 21 | 0) >> 0] = $101;
       HEAP8[(i64toi32_i32$1 + 22 | 0) >> 0] = $101 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 23 | 0) >> 0] = $101 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 24 | 0) >> 0] = $101 >>> 24 | 0;
       HEAP8[(i64toi32_i32$1 + 25 | 0) >> 0] = i64toi32_i32$0;
       HEAP8[(i64toi32_i32$1 + 26 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 27 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 28 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
       $4 = HEAP32[($1 + 20 | 0) >> 2] | 0;
       $5 = HEAP32[($1 + 16 | 0) >> 2] | 0;
       $6 = HEAPU8[($1 + 2 | 0) >> 0] | 0;
       i64toi32_i32$2 = $1 + 24 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = 0;
       $17 = i64toi32_i32$0;
       $17$hi = i64toi32_i32$1;
       i64toi32_i32$2 = $1 + 28 | 0;
       i64toi32_i32$1 = HEAPU16[i64toi32_i32$2 >> 1] | 0;
       i64toi32_i32$0 = 0;
       $18 = i64toi32_i32$1;
       $18$hi = i64toi32_i32$0;
       i64toi32_i32$2 = $1 + 30 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
       i64toi32_i32$1 = 0;
       $19 = i64toi32_i32$0;
       $19$hi = i64toi32_i32$1;
       $7 = HEAPU8[($2 + 17 | 0) >> 0] | 0 | ((HEAPU8[($2 + 18 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 19 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 20 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = $2;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 21 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 22 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 23 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 24 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 25 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 26 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 27 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 28 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $20 = i64toi32_i32$1;
       $20$hi = i64toi32_i32$0;
       i64toi32_i32$2 = $1 + 32 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $21 = i64toi32_i32$0;
       $21$hi = i64toi32_i32$1;
       i64toi32_i32$0 = $2;
       HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $21;
       HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $1 + 37 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $72 = i64toi32_i32$1;
       i64toi32_i32$1 = $2;
       $102 = $72;
       HEAP8[(i64toi32_i32$1 + 21 | 0) >> 0] = $102;
       HEAP8[(i64toi32_i32$1 + 22 | 0) >> 0] = $102 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 23 | 0) >> 0] = $102 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 24 | 0) >> 0] = $102 >>> 24 | 0;
       HEAP8[(i64toi32_i32$1 + 25 | 0) >> 0] = i64toi32_i32$0;
       HEAP8[(i64toi32_i32$1 + 26 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 27 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 28 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
       i64toi32_i32$2 = $1 + 45 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $22 = i64toi32_i32$0;
       $22$hi = i64toi32_i32$1;
       $8 = HEAPU8[($1 + 31 | 0) >> 0] | 0;
       i64toi32_i32$2 = $1 + 53 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = 0;
       $23 = i64toi32_i32$1;
       $23$hi = i64toi32_i32$0;
       i64toi32_i32$2 = $1 + 57 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
       i64toi32_i32$1 = 0;
       $24 = i64toi32_i32$0;
       $24$hi = i64toi32_i32$1;
       i64toi32_i32$2 = $1 + 59 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
       i64toi32_i32$0 = 0;
       $25 = i64toi32_i32$1;
       $25$hi = i64toi32_i32$0;
       $9 = HEAPU8[($2 + 17 | 0) >> 0] | 0;
       HEAP8[(($2 + 12 | 0) + 2 | 0) >> 0] = HEAPU8[($2 + 20 | 0) >> 0] | 0;
       HEAP16[($2 + 12 | 0) >> 1] = HEAPU16[($2 + 18 | 0) >> 1] | 0;
       i64toi32_i32$0 = $17$hi;
       $98 = $17;
       $98$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $18$hi;
       $99 = $18;
       $99$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $19$hi;
       i64toi32_i32$2 = $19;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $111 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
        $111 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       $101$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $99$hi;
       i64toi32_i32$0 = $99;
       i64toi32_i32$2 = $101$hi;
       i64toi32_i32$3 = $111;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
       i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        $112 = 0;
       } else {
        i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
        $112 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       }
       $103$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $98$hi;
       i64toi32_i32$2 = $98;
       i64toi32_i32$1 = $103$hi;
       i64toi32_i32$3 = $112;
       i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
       $17 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       $17$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $23$hi;
       $105 = $23;
       $105$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $24$hi;
       $106 = $24;
       $106$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $25$hi;
       i64toi32_i32$0 = $25;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $113 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $113 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       $108$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $106$hi;
       i64toi32_i32$1 = $106;
       i64toi32_i32$0 = $108$hi;
       i64toi32_i32$3 = $113;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $114 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
        $114 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       $110$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $105$hi;
       i64toi32_i32$0 = $105;
       i64toi32_i32$2 = $110$hi;
       i64toi32_i32$3 = $114;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
       $19 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
       $19$hi = i64toi32_i32$2;
       i64toi32_i32$1 = $19;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 24;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = 0;
        $115 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
        $115 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
       }
       $18 = $115;
       $18$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $19$hi;
       i64toi32_i32$2 = $19;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = 0;
        $116 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
        $116 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
       }
       $10 = $116;
       i64toi32_i32$1 = $19$hi;
       i64toi32_i32$0 = $19;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 8;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = 0;
        $117 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
        $117 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
       }
       $11 = $117;
       i64toi32_i32$1 = $2;
       i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 21 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 22 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 23 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 24 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 25 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 26 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 27 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 28 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $25 = i64toi32_i32$2;
       $25$hi = i64toi32_i32$0;
       i64toi32_i32$1 = i64toi32_i32$2;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = 0;
        $118 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
        $118 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
       }
       $19 = $118;
       $19$hi = i64toi32_i32$2;
       i64toi32_i32$2 = 0;
       i64toi32_i32$0 = ($8 | 0) == (1 | 0);
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 56;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $119 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
        $119 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       $24 = $119;
       $24$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $16$hi;
       $1 = $16;
       i64toi32_i32$1 = $23$hi;
       $8 = $23;
       i64toi32_i32$1 = $21$hi;
       $12 = $21;
       i64toi32_i32$1 = $22$hi;
       i64toi32_i32$2 = $22;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 56;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = 0;
        $120 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
        $120 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
       }
       $13 = $120;
       i64toi32_i32$0 = $25$hi;
       $14 = $25;
       $15 = 0;
       break label$1;
      case 1:
       $12 = HEAPU8[($1 + 32 | 0) >> 0] | 0;
       i64toi32_i32$1 = $1 + 34 | 0;
       i64toi32_i32$0 = HEAPU16[i64toi32_i32$1 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
       i64toi32_i32$2 = HEAPU16[(i64toi32_i32$1 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$1 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
       $22 = i64toi32_i32$0;
       $22$hi = i64toi32_i32$2;
       i64toi32_i32$0 = $2;
       HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $22;
       HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$2;
       HEAP8[(i64toi32_i32$0 + 14 | 0) >> 0] = HEAPU8[(i64toi32_i32$0 + 18 | 0) >> 0] | 0;
       i64toi32_i32$1 = $1 + 39 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $154 = i64toi32_i32$2;
       i64toi32_i32$2 = $2;
       $103 = $154;
       HEAP8[(i64toi32_i32$2 + 21 | 0) >> 0] = $103;
       HEAP8[(i64toi32_i32$2 + 22 | 0) >> 0] = $103 >>> 8 | 0;
       HEAP8[(i64toi32_i32$2 + 23 | 0) >> 0] = $103 >>> 16 | 0;
       HEAP8[(i64toi32_i32$2 + 24 | 0) >> 0] = $103 >>> 24 | 0;
       HEAP8[(i64toi32_i32$2 + 25 | 0) >> 0] = i64toi32_i32$0;
       HEAP8[(i64toi32_i32$2 + 26 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
       HEAP8[(i64toi32_i32$2 + 27 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
       HEAP8[(i64toi32_i32$2 + 28 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
       i64toi32_i32$0 = $22$hi;
       HEAP16[(i64toi32_i32$2 + 12 | 0) >> 1] = $22;
       i64toi32_i32$1 = $1 + 55 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = 0;
       $23 = i64toi32_i32$0;
       $23$hi = i64toi32_i32$2;
       $160 = i64toi32_i32$0;
       $160$hi = i64toi32_i32$2;
       i64toi32_i32$1 = $1 + 59 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
       i64toi32_i32$0 = 0;
       $163 = i64toi32_i32$2;
       $163$hi = i64toi32_i32$0;
       i64toi32_i32$1 = $1 + 61 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
       i64toi32_i32$2 = 0;
       i64toi32_i32$1 = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        $121 = 0;
       } else {
        i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
        $121 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       }
       $167$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $163$hi;
       i64toi32_i32$2 = $163;
       i64toi32_i32$1 = $167$hi;
       i64toi32_i32$3 = $121;
       i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $122 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $122 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       $169$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $160$hi;
       i64toi32_i32$1 = $160;
       i64toi32_i32$0 = $169$hi;
       i64toi32_i32$3 = $122;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 8;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = 0;
        $123 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
        $123 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
       }
       $18 = $123;
       $18$hi = i64toi32_i32$1;
       i64toi32_i32$0 = $1 + 47 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $20 = i64toi32_i32$1;
       $20$hi = i64toi32_i32$2;
       i64toi32_i32$0 = i64toi32_i32$1;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $124 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
        $124 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       $176$hi = i64toi32_i32$1;
       i64toi32_i32$2 = $2;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 27 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 28 | 0) >> 0] | 0) << 8 | 0) | 0;
       i64toi32_i32$0 = 0;
       $178 = i64toi32_i32$1;
       $178$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $176$hi;
       i64toi32_i32$2 = $124;
       i64toi32_i32$1 = $178$hi;
       i64toi32_i32$3 = $178;
       i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
       $22 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       $22$hi = i64toi32_i32$1;
       i64toi32_i32$0 = $2;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 21 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 22 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 23 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 24 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = 0;
       $181 = i64toi32_i32$1;
       $181$hi = i64toi32_i32$2;
       i64toi32_i32$0 = i64toi32_i32$0 + 25 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$0 = i64toi32_i32$2;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $125 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $125 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       $185$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $181$hi;
       i64toi32_i32$1 = $181;
       i64toi32_i32$0 = $185$hi;
       i64toi32_i32$3 = $125;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
       $19 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       $19$hi = i64toi32_i32$0;
       $9 = HEAPU8[($1 + 33 | 0) >> 0] | 0;
       $14 = HEAPU8[($2 + 19 | 0) >> 0] | 0 | ((HEAPU8[($2 + 20 | 0) >> 0] | 0) << 8 | 0) | 0;
       i64toi32_i32$2 = $1 + 24 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $17 = i64toi32_i32$0;
       $17$hi = i64toi32_i32$1;
       i64toi32_i32$2 = i64toi32_i32$0;
       i64toi32_i32$0 = -16777216;
       i64toi32_i32$3 = 0;
       i64toi32_i32$0 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
       $24 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
       $24$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $23$hi;
       $10 = $23;
       i64toi32_i32$0 = $20$hi;
       i64toi32_i32$1 = $20;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 48;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = 0;
        $126 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
        $126 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
       }
       $8 = $126;
       i64toi32_i32$2 = $20$hi;
       i64toi32_i32$0 = $20;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 56;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = 0;
        $127 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
        $127 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
       }
       $11 = $127;
       i64toi32_i32$1 = $20$hi;
       i64toi32_i32$2 = $20;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 40;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = 0;
        $128 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
        $128 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
       }
       $13 = $128;
       $4 = HEAP32[($1 + 20 | 0) >> 2] | 0;
       $5 = HEAP32[($1 + 16 | 0) >> 2] | 0;
       i64toi32_i32$1 = $1 + 8 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $20 = i64toi32_i32$0;
       $20$hi = i64toi32_i32$2;
       $15 = 1;
       break label$3;
      case 2:
       $3 = HEAPU8[($1 + 1 | 0) >> 0] | 0;
       i64toi32_i32$1 = $1 + 3 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $22 = i64toi32_i32$2;
       $22$hi = i64toi32_i32$0;
       i64toi32_i32$2 = $2;
       HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] = $22;
       HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$1 = $1 + 8 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $227 = i64toi32_i32$0;
       i64toi32_i32$0 = $2;
       $104 = $227;
       HEAP8[(i64toi32_i32$0 + 21 | 0) >> 0] = $104;
       HEAP8[(i64toi32_i32$0 + 22 | 0) >> 0] = $104 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 23 | 0) >> 0] = $104 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 24 | 0) >> 0] = $104 >>> 24 | 0;
       HEAP8[(i64toi32_i32$0 + 25 | 0) >> 0] = i64toi32_i32$2;
       HEAP8[(i64toi32_i32$0 + 26 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 27 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 28 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
       i64toi32_i32$1 = $1 + 24 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$0 = 0;
       $230 = i64toi32_i32$2;
       $230$hi = i64toi32_i32$0;
       i64toi32_i32$1 = $1 + 28 | 0;
       i64toi32_i32$0 = HEAPU16[i64toi32_i32$1 >> 1] | 0;
       i64toi32_i32$2 = 0;
       $233 = i64toi32_i32$0;
       $233$hi = i64toi32_i32$2;
       i64toi32_i32$1 = $1 + 30 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$1 = i64toi32_i32$2;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        $129 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
        $129 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       }
       $237$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $233$hi;
       i64toi32_i32$0 = $233;
       i64toi32_i32$1 = $237$hi;
       i64toi32_i32$3 = $129;
       i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
       i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $130 = 0;
       } else {
        i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $130 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       $239$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $230$hi;
       i64toi32_i32$1 = $230;
       i64toi32_i32$2 = $239$hi;
       i64toi32_i32$3 = $130;
       i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
       $17 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       $17$hi = i64toi32_i32$2;
       $4 = HEAP32[($1 + 20 | 0) >> 2] | 0;
       $5 = HEAP32[($1 + 16 | 0) >> 2] | 0;
       $15 = 2;
       $6 = HEAPU8[($1 + 2 | 0) >> 0] | 0;
       i64toi32_i32$2 = $22$hi;
       $1 = $22;
       break label$2;
      case 3:
       $15 = 3;
       $3 = HEAPU8[($1 + 1 | 0) >> 0] | 0;
       i64toi32_i32$0 = $1 + 3 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $22 = i64toi32_i32$2;
       $22$hi = i64toi32_i32$1;
       i64toi32_i32$2 = $2;
       HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] = $22;
       HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$0 = $1 + 8 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $262 = i64toi32_i32$1;
       i64toi32_i32$1 = $2;
       $107 = $262;
       HEAP8[(i64toi32_i32$1 + 21 | 0) >> 0] = $107;
       HEAP8[(i64toi32_i32$1 + 22 | 0) >> 0] = $107 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 23 | 0) >> 0] = $107 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 24 | 0) >> 0] = $107 >>> 24 | 0;
       HEAP8[(i64toi32_i32$1 + 25 | 0) >> 0] = i64toi32_i32$2;
       HEAP8[(i64toi32_i32$1 + 26 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 27 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 28 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
       i64toi32_i32$0 = $1 + 24 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
       i64toi32_i32$1 = 0;
       $265 = i64toi32_i32$2;
       $265$hi = i64toi32_i32$1;
       i64toi32_i32$0 = $1 + 28 | 0;
       i64toi32_i32$1 = HEAPU16[i64toi32_i32$0 >> 1] | 0;
       i64toi32_i32$2 = 0;
       $268 = i64toi32_i32$1;
       $268$hi = i64toi32_i32$2;
       i64toi32_i32$0 = $1 + 30 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$0 = i64toi32_i32$2;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $131 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $131 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       $272$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $268$hi;
       i64toi32_i32$1 = $268;
       i64toi32_i32$0 = $272$hi;
       i64toi32_i32$3 = $131;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $132 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
        $132 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       $274$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $265$hi;
       i64toi32_i32$0 = $265;
       i64toi32_i32$2 = $274$hi;
       i64toi32_i32$3 = $132;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
       $17 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
       $17$hi = i64toi32_i32$2;
       $4 = HEAP32[($1 + 20 | 0) >> 2] | 0;
       $5 = HEAP32[($1 + 16 | 0) >> 2] | 0;
       $6 = HEAPU8[($1 + 2 | 0) >> 0] | 0;
       i64toi32_i32$2 = $22$hi;
       $1 = $22;
       break label$2;
      case 4:
       break label$4;
      };
     }
     i64toi32_i32$1 = $1 + 29 | 0;
     i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $290 = i64toi32_i32$2;
     i64toi32_i32$2 = $2;
     $108 = $290;
     HEAP8[(i64toi32_i32$2 + 21 | 0) >> 0] = $108;
     HEAP8[(i64toi32_i32$2 + 22 | 0) >> 0] = $108 >>> 8 | 0;
     HEAP8[(i64toi32_i32$2 + 23 | 0) >> 0] = $108 >>> 16 | 0;
     HEAP8[(i64toi32_i32$2 + 24 | 0) >> 0] = $108 >>> 24 | 0;
     HEAP8[(i64toi32_i32$2 + 25 | 0) >> 0] = i64toi32_i32$0;
     HEAP8[(i64toi32_i32$2 + 26 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
     HEAP8[(i64toi32_i32$2 + 27 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
     HEAP8[(i64toi32_i32$2 + 28 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
     i64toi32_i32$1 = $1 + 24 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $294 = i64toi32_i32$0;
     i64toi32_i32$0 = $2;
     HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $294;
     HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$1 = $1 + 49 | 0;
     i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
     i64toi32_i32$0 = 0;
     $297 = i64toi32_i32$2;
     $297$hi = i64toi32_i32$0;
     i64toi32_i32$1 = $1 + 51 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
     i64toi32_i32$2 = 0;
     i64toi32_i32$1 = i64toi32_i32$0;
     i64toi32_i32$0 = 0;
     i64toi32_i32$3 = 16;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
      $133 = 0;
     } else {
      i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
      $133 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
     }
     $301$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $297$hi;
     i64toi32_i32$2 = $297;
     i64toi32_i32$1 = $301$hi;
     i64toi32_i32$3 = $133;
     i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
     i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
     i64toi32_i32$2 = 0;
     i64toi32_i32$3 = 32;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
      $134 = 0;
     } else {
      i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
      $134 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
     }
     $22 = $134;
     $22$hi = i64toi32_i32$2;
     i64toi32_i32$1 = $1 + 45 | 0;
     i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = 0;
     $17 = i64toi32_i32$2;
     $17$hi = i64toi32_i32$0;
     i64toi32_i32$1 = $1 + 37 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $18 = i64toi32_i32$0;
     $18$hi = i64toi32_i32$2;
     $15 = 4;
     label$9 : {
      label$10 : {
       $3 = $1 + 4 | 0;
       if (HEAP32[$3 >> 2] | 0) {
        break label$10
       }
       $7 = 0;
       break label$9;
      }
      $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($2 + 32 | 0 | 0, $3 | 0);
      i64toi32_i32$1 = $2;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 40 | 0) >> 2] | 0;
      $20 = i64toi32_i32$2;
      $20$hi = i64toi32_i32$0;
      $7 = HEAP32[(i64toi32_i32$1 + 32 | 0) >> 2] | 0;
     }
     i64toi32_i32$0 = $17$hi;
     i64toi32_i32$0 = $22$hi;
     i64toi32_i32$0 = $17$hi;
     i64toi32_i32$1 = $17;
     i64toi32_i32$2 = $22$hi;
     i64toi32_i32$3 = $22;
     i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
     $22 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
     $22$hi = i64toi32_i32$2;
     HEAP8[($2 + 14 | 0) >> 0] = HEAPU8[($2 + 28 | 0) >> 0] | 0;
     HEAP16[($2 + 12 | 0) >> 1] = HEAPU16[($2 + 26 | 0) >> 1] | 0;
     i64toi32_i32$2 = $18$hi;
     i64toi32_i32$0 = $18;
     i64toi32_i32$1 = 0;
     i64toi32_i32$3 = 16;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$1 = 0;
      $135 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
     } else {
      i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
      $135 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
     }
     $19 = $135;
     $19$hi = i64toi32_i32$1;
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
     $17 = i64toi32_i32$1;
     $17$hi = i64toi32_i32$0;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$1 = -16777216;
     i64toi32_i32$3 = 0;
     i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
     $24 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     $24$hi = i64toi32_i32$1;
     $4 = HEAP32[($1 + 20 | 0) >> 2] | 0;
     $5 = HEAP32[($1 + 16 | 0) >> 2] | 0;
     $13 = HEAPU8[($1 + 52 | 0) >> 0] | 0;
     $12 = HEAPU8[($2 + 24 | 0) >> 0] | 0;
     $9 = HEAPU8[($2 + 25 | 0) >> 0] | 0;
     i64toi32_i32$1 = $18$hi;
     $14 = $18;
    }
    break label$1;
   }
   $7 = HEAPU8[($2 + 17 | 0) >> 0] | 0 | ((HEAPU8[($2 + 18 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 19 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 20 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = $2;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 21 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 22 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 23 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 24 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 25 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 26 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 27 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 28 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $20 = i64toi32_i32$1;
   $20$hi = i64toi32_i32$2;
   i64toi32_i32$2 = 0;
   $24 = 0;
   $24$hi = i64toi32_i32$2;
  }
  HEAP8[($0 + 1 | 0) >> 0] = $3;
  HEAP8[$0 >> 0] = $15;
  $362 = $0 + 51 | 0;
  i64toi32_i32$2 = $22$hi;
  i64toi32_i32$0 = $22;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 48;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $136 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   $136 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[$362 >> 0] = $136;
  $366 = $0 + 49 | 0;
  i64toi32_i32$1 = $22$hi;
  i64toi32_i32$2 = $22;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $137 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   $137 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  $138 = $366;
  $139 = $137;
  HEAP8[$138 >> 0] = $139;
  HEAP8[($138 + 1 | 0) >> 0] = $139 >>> 8 | 0;
  i64toi32_i32$0 = $22$hi;
  $109 = $0 + 45 | 0;
  HEAP8[$109 >> 0] = $22;
  HEAP8[($109 + 1 | 0) >> 0] = $22 >>> 8 | 0;
  HEAP8[($109 + 2 | 0) >> 0] = $22 >>> 16 | 0;
  HEAP8[($109 + 3 | 0) >> 0] = $22 >>> 24 | 0;
  HEAP8[($0 + 33 | 0) >> 0] = $9;
  HEAP8[($0 + 32 | 0) >> 0] = $12;
  i64toi32_i32$0 = $20$hi;
  i64toi32_i32$2 = $0 + 8 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $20;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($0 + 4 | 0) >> 2] = $7;
  HEAP8[($0 + 3 | 0) >> 0] = $1;
  HEAP8[($0 + 2 | 0) >> 0] = $6;
  HEAP16[($0 + 34 | 0) >> 1] = HEAPU16[($2 + 12 | 0) >> 1] | 0;
  i64toi32_i32$0 = $18$hi;
  i64toi32_i32$2 = $0 + 56 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $18;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP8[($0 + 55 | 0) >> 0] = $10;
  HEAP8[($0 + 54 | 0) >> 0] = $11;
  HEAP8[($0 + 53 | 0) >> 0] = $8;
  HEAP8[($0 + 52 | 0) >> 0] = $13;
  i64toi32_i32$0 = $24$hi;
  i64toi32_i32$0 = $17$hi;
  i64toi32_i32$1 = $17;
  i64toi32_i32$2 = 16777215;
  i64toi32_i32$3 = -1;
  i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
  $413 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
  $413$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $24$hi;
  i64toi32_i32$0 = $24;
  i64toi32_i32$1 = $413$hi;
  i64toi32_i32$3 = $413;
  i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
  $414 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $0 + 24 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $414;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP8[($0 + 36 | 0) >> 0] = HEAPU8[(($2 + 12 | 0) + 2 | 0) >> 0] | 0;
  $422 = $0 + 16 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $140 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $140 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $425$hi = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  $427$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $425$hi;
  i64toi32_i32$1 = $140;
  i64toi32_i32$2 = $427$hi;
  i64toi32_i32$3 = $5;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  $428 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $422;
  HEAP32[i64toi32_i32$1 >> 2] = $428;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  $430 = $0 + 37 | 0;
  i64toi32_i32$2 = $19$hi;
  i64toi32_i32$0 = $19;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 16;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   $141 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
   $141 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
  }
  $432$hi = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  i64toi32_i32$2 = $14;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 65535;
  i64toi32_i32$0 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
  $435 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
  $435$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $432$hi;
  i64toi32_i32$1 = $141;
  i64toi32_i32$2 = $435$hi;
  i64toi32_i32$3 = $435;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  $436 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $430;
  $110 = $436;
  HEAP8[i64toi32_i32$1 >> 0] = $110;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $110 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $110 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $110 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$2;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
  global$0 = $2 + 48 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__TransactionWitnessSets___deserialize__hdc8da232218df49c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $9 = 0, $17 = 0, $7 = 0, $6 = 0, $17$hi = 0, $18 = 0, $18$hi = 0, $10 = 0, $5 = 0, $60 = 0, $61 = 0, $11 = 0, $62 = 0, $63 = 0, $64 = 0, $65 = 0, $66 = 0, $67 = 0, $68 = 0, $69 = 0, $70 = 0, $71 = 0, $72 = 0, $73 = 0, $74 = 0, $4 = 0, $14 = 0, $15 = 0, $16 = 0, $8 = 0, $76 = 0, $83 = 0, $96 = 0, $99 = 0, $12 = 0, $19 = 0, $19$hi = 0, $13 = 0, $118 = 0, $124 = 0, $139 = 0, $142 = 0, $20 = 0, $20$hi = 0, $180 = 0, $184 = 0, $188 = 0, $195 = 0, $244 = 0, $251 = 0, $264 = 0, $267 = 0, $284 = 0, $289 = 0, $303 = 0, $306 = 0, $313 = 0, $319 = 0, $323 = 0, $328 = 0, $334 = 0, $338 = 0, $350 = 0, $354 = 0, $360 = 0, $366 = 0, $393 = 0;
  $2 = global$0 - 384 | 0;
  global$0 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 20 | 0) >> 2] = 0;
  HEAP32[($2 + 24 | 0) >> 2] = i64toi32_i32$0;
  $3 = 0;
  HEAP32[($2 + 16 | 0) >> 2] = HEAP32[(0 + 1050220 | 0) >> 2] | 0;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 304 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = ($2 + 304 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $17 = i64toi32_i32$0;
  $17$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 312 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 316 | 0) >> 2] | 0;
  $18 = i64toi32_i32$1;
  $18$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 304 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 308 | 0) >> 2] | 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
         break label$6
        }
        i64toi32_i32$2 = $17$hi;
        $4 = $17;
        label$7 : {
         i64toi32_i32$2 = $18$hi;
         i64toi32_i32$3 = $18;
         i64toi32_i32$1 = 0;
         i64toi32_i32$0 = 1;
         if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
          break label$7
         }
         if (!$4) {
          break label$3
         }
        }
        $5 = $2 + 364 | 0;
        $6 = $2 + 336 | 0;
        $7 = $2 + 313 | 0;
        $8 = $7 + 3 | 0;
        label$8 : {
         label$9 : while (1) {
          std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 8 | 0 | 0, $1 | 0);
          $3 = 0;
          $9 = 2;
          label$10 : {
           if (HEAP32[($2 + 12 | 0) >> 2] | 0) {
            break label$10
           }
           i64toi32_i32$3 = 0;
           $18 = 8;
           $18$hi = i64toi32_i32$3;
           i64toi32_i32$3 = 0;
           $17 = 0;
           $17$hi = i64toi32_i32$3;
           break label$4;
          }
          label$11 : {
           if ((($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[($2 + 8 | 0) >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) == (7 | 0)) {
            break label$11
           }
           cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__TransactionWitnessSet___deserialize__h9deaf1b9ab40fbb6($2 + 304 | 0 | 0, $1 | 0);
           if ((HEAP32[($2 + 304 | 0) >> 2] | 0 | 0) == (1 | 0)) {
            break label$8
           }
           $3 = ($2 + 272 | 0) + 8 | 0;
           i64toi32_i32$0 = $6 + 8 | 0;
           i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $76 = i64toi32_i32$3;
           i64toi32_i32$3 = $3;
           HEAP32[i64toi32_i32$3 >> 2] = $76;
           HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
           $9 = ($2 + 272 | 0) + 16 | 0;
           i64toi32_i32$0 = $6 + 16 | 0;
           i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$3 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $83 = i64toi32_i32$2;
           i64toi32_i32$2 = $9;
           HEAP32[i64toi32_i32$2 >> 2] = $83;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
           $10 = ($2 + 256 | 0) + 8 | 0;
           HEAP32[$10 >> 2] = HEAP32[($5 + 8 | 0) >> 2] | 0;
           HEAP32[($2 + 296 | 0) >> 2] = HEAPU8[$7 >> 0] | 0 | ((HEAPU8[($7 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($7 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($7 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$0 = $6;
           i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $96 = i64toi32_i32$3;
           i64toi32_i32$3 = $2;
           HEAP32[($2 + 272 | 0) >> 2] = $96;
           HEAP32[($2 + 276 | 0) >> 2] = i64toi32_i32$2;
           i64toi32_i32$0 = $5;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $99 = i64toi32_i32$2;
           i64toi32_i32$2 = $2;
           HEAP32[($2 + 256 | 0) >> 2] = $99;
           HEAP32[($2 + 260 | 0) >> 2] = i64toi32_i32$3;
           $60 = $8;
           $61 = HEAPU8[$60 >> 0] | 0 | ((HEAPU8[($60 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($60 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($60 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 299 | 0) >> 0] = $61;
           HEAP8[($2 + 300 | 0) >> 0] = $61 >>> 8 | 0;
           HEAP8[($2 + 301 | 0) >> 0] = $61 >>> 16 | 0;
           HEAP8[($2 + 302 | 0) >> 0] = $61 >>> 24 | 0;
           $11 = HEAPU8[($2 + 312 | 0) >> 0] | 0;
           $12 = HEAP32[($2 + 308 | 0) >> 2] | 0;
           i64toi32_i32$0 = $2;
           i64toi32_i32$3 = HEAP32[($2 + 320 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($2 + 324 | 0) >> 2] | 0;
           $17 = i64toi32_i32$3;
           $17$hi = i64toi32_i32$2;
           i64toi32_i32$0 = $2;
           i64toi32_i32$2 = HEAP32[($2 + 328 | 0) >> 2] | 0;
           i64toi32_i32$3 = HEAP32[($2 + 332 | 0) >> 2] | 0;
           $19 = i64toi32_i32$2;
           $19$hi = i64toi32_i32$3;
           $13 = HEAP32[($2 + 360 | 0) >> 2] | 0;
           $14 = ($2 + 224 | 0) + 8 | 0;
           i64toi32_i32$0 = $3;
           i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $118 = i64toi32_i32$3;
           i64toi32_i32$3 = $14;
           HEAP32[i64toi32_i32$3 >> 2] = $118;
           HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
           $15 = ($2 + 224 | 0) + 16 | 0;
           i64toi32_i32$0 = $9;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $124 = i64toi32_i32$2;
           i64toi32_i32$2 = $15;
           HEAP32[i64toi32_i32$2 >> 2] = $124;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
           $16 = ($2 + 208 | 0) + 8 | 0;
           HEAP32[$16 >> 2] = HEAP32[$10 >> 2] | 0;
           $62 = HEAPU8[($2 + 299 | 0) >> 0] | 0 | ((HEAPU8[($2 + 300 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 301 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 302 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 251 | 0) >> 0] = $62;
           HEAP8[($2 + 252 | 0) >> 0] = $62 >>> 8 | 0;
           HEAP8[($2 + 253 | 0) >> 0] = $62 >>> 16 | 0;
           HEAP8[($2 + 254 | 0) >> 0] = $62 >>> 24 | 0;
           HEAP32[($2 + 248 | 0) >> 2] = HEAP32[($2 + 296 | 0) >> 2] | 0;
           i64toi32_i32$0 = $2;
           i64toi32_i32$3 = HEAP32[($2 + 272 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($2 + 276 | 0) >> 2] | 0;
           $139 = i64toi32_i32$3;
           i64toi32_i32$3 = $2;
           HEAP32[($2 + 224 | 0) >> 2] = $139;
           HEAP32[($2 + 228 | 0) >> 2] = i64toi32_i32$2;
           i64toi32_i32$0 = $2;
           i64toi32_i32$2 = HEAP32[($2 + 256 | 0) >> 2] | 0;
           i64toi32_i32$3 = HEAP32[($2 + 260 | 0) >> 2] | 0;
           $142 = i64toi32_i32$2;
           i64toi32_i32$2 = $2;
           HEAP32[($2 + 208 | 0) >> 2] = $142;
           HEAP32[($2 + 212 | 0) >> 2] = i64toi32_i32$3;
           i64toi32_i32$0 = $2;
           i64toi32_i32$3 = HEAP32[($2 + 376 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($2 + 380 | 0) >> 2] | 0;
           $20 = i64toi32_i32$3;
           $20$hi = i64toi32_i32$2;
           label$12 : {
            $9 = HEAP32[($2 + 24 | 0) >> 2] | 0;
            if ((HEAP32[($2 + 20 | 0) >> 2] | 0 | 0) != ($9 | 0)) {
             break label$12
            }
            alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h2b9e4edca640f3c0($2 + 16 | 0 | 0, $9 | 0, 1 | 0);
            $9 = HEAP32[($2 + 24 | 0) >> 2] | 0;
           }
           $3 = (HEAP32[($2 + 16 | 0) >> 2] | 0) + Math_imul($9, 76) | 0;
           HEAP8[($3 + 4 | 0) >> 0] = $11;
           HEAP32[$3 >> 2] = $12;
           $63 = HEAP32[($2 + 248 | 0) >> 2] | 0;
           HEAP8[($3 + 5 | 0) >> 0] = $63;
           HEAP8[($3 + 6 | 0) >> 0] = $63 >>> 8 | 0;
           HEAP8[($3 + 7 | 0) >> 0] = $63 >>> 16 | 0;
           HEAP8[($3 + 8 | 0) >> 0] = $63 >>> 24 | 0;
           i64toi32_i32$2 = $17$hi;
           i64toi32_i32$3 = $3;
           HEAP8[(i64toi32_i32$3 + 12 | 0) >> 0] = $17;
           HEAP8[(i64toi32_i32$3 + 13 | 0) >> 0] = $17 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 14 | 0) >> 0] = $17 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 15 | 0) >> 0] = $17 >>> 24 | 0;
           HEAP8[(i64toi32_i32$3 + 16 | 0) >> 0] = i64toi32_i32$2;
           HEAP8[(i64toi32_i32$3 + 17 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 18 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 19 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
           $64 = i64toi32_i32$3 + 8 | 0;
           $65 = HEAPU8[($2 + 251 | 0) >> 0] | 0 | ((HEAPU8[($2 + 252 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 253 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 254 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[$64 >> 0] = $65;
           HEAP8[($64 + 1 | 0) >> 0] = $65 >>> 8 | 0;
           HEAP8[($64 + 2 | 0) >> 0] = $65 >>> 16 | 0;
           HEAP8[($64 + 3 | 0) >> 0] = $65 >>> 24 | 0;
           i64toi32_i32$2 = $19$hi;
           i64toi32_i32$3 = i64toi32_i32$3 + 20 | 0;
           $66 = $19;
           HEAP8[i64toi32_i32$3 >> 0] = $66;
           HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $66 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $66 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $66 >>> 24 | 0;
           HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$2;
           HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
           i64toi32_i32$0 = $2;
           i64toi32_i32$2 = HEAP32[($2 + 224 | 0) >> 2] | 0;
           i64toi32_i32$3 = HEAP32[($2 + 228 | 0) >> 2] | 0;
           $180 = i64toi32_i32$2;
           i64toi32_i32$2 = $3 + 28 | 0;
           $67 = $180;
           HEAP8[i64toi32_i32$2 >> 0] = $67;
           HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $67 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $67 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $67 >>> 24 | 0;
           HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$3;
           HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
           i64toi32_i32$0 = $14;
           i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $184 = i64toi32_i32$3;
           i64toi32_i32$3 = $3 + 36 | 0;
           $68 = $184;
           HEAP8[i64toi32_i32$3 >> 0] = $68;
           HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $68 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $68 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $68 >>> 24 | 0;
           HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$2;
           HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
           i64toi32_i32$0 = $15;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $188 = i64toi32_i32$2;
           i64toi32_i32$2 = $3 + 44 | 0;
           $69 = $188;
           HEAP8[i64toi32_i32$2 >> 0] = $69;
           HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $69 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $69 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $69 >>> 24 | 0;
           HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$3;
           HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
           HEAP32[($3 + 52 | 0) >> 2] = $13;
           i64toi32_i32$0 = $2;
           i64toi32_i32$3 = HEAP32[($2 + 208 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($2 + 212 | 0) >> 2] | 0;
           $195 = i64toi32_i32$3;
           i64toi32_i32$3 = $3 + 56 | 0;
           HEAP32[i64toi32_i32$3 >> 2] = $195;
           HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
           HEAP32[($3 + 64 | 0) >> 2] = HEAP32[$16 >> 2] | 0;
           i64toi32_i32$2 = $20$hi;
           i64toi32_i32$3 = $3 + 68 | 0;
           HEAP32[i64toi32_i32$3 >> 2] = $20;
           HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
           $3 = $9 + 1 | 0;
           HEAP32[($2 + 24 | 0) >> 2] = $3;
           i64toi32_i32$2 = $18$hi;
           i64toi32_i32$0 = $18;
           i64toi32_i32$3 = 0;
           i64toi32_i32$1 = 1;
           if ((i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | 0) {
            continue label$9
           }
           if ($3 >>> 0 < $4 >>> 0) {
            continue label$9
           }
           break label$3;
          }
          break label$9;
         };
         cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 304 | 0 | 0, $1 | 0);
         i64toi32_i32$1 = ($2 + 304 | 0) + 16 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
         $17 = i64toi32_i32$0;
         $17$hi = i64toi32_i32$2;
         i64toi32_i32$1 = $2;
         i64toi32_i32$2 = HEAP32[($2 + 312 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($2 + 316 | 0) >> 2] | 0;
         $18 = i64toi32_i32$2;
         $18$hi = i64toi32_i32$0;
         i64toi32_i32$1 = $2;
         i64toi32_i32$0 = HEAP32[($2 + 304 | 0) >> 2] | 0;
         i64toi32_i32$2 = HEAP32[($2 + 308 | 0) >> 2] | 0;
         i64toi32_i32$1 = i64toi32_i32$0;
         i64toi32_i32$0 = 0;
         i64toi32_i32$3 = 1;
         if ((i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) | 0) {
          break label$5
         }
         i64toi32_i32$1 = $17$hi;
         i64toi32_i32$2 = $2 + 232 | 0;
         HEAP32[i64toi32_i32$2 >> 2] = $17;
         HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$1 = $18$hi;
         i64toi32_i32$2 = $2;
         HEAP32[($2 + 224 | 0) >> 2] = $18;
         HEAP32[($2 + 228 | 0) >> 2] = i64toi32_i32$1;
         if (($18 & 255 | 0 | 0) == (5 | 0)) {
          break label$3
         }
         HEAP32[($2 + 304 | 0) >> 2] = 0;
         core__panicking__assert_failed__h96d8431cc974b591(0 | 0, $2 + 224 | 0 | 0, 1050312 | 0, $2 + 304 | 0 | 0, 1052600 | 0);
         abort();
        }
        $1 = ($2 + 272 | 0) + 8 | 0;
        i64toi32_i32$3 = $6 + 8 | 0;
        i64toi32_i32$1 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$2 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $244 = i64toi32_i32$1;
        i64toi32_i32$1 = $1;
        HEAP32[i64toi32_i32$1 >> 2] = $244;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
        $10 = ($2 + 272 | 0) + 16 | 0;
        i64toi32_i32$3 = $6 + 16 | 0;
        i64toi32_i32$2 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$1 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $251 = i64toi32_i32$2;
        i64toi32_i32$2 = $10;
        HEAP32[i64toi32_i32$2 >> 2] = $251;
        HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
        $11 = ($2 + 256 | 0) + 8 | 0;
        HEAP32[$11 >> 2] = HEAP32[($5 + 8 | 0) >> 2] | 0;
        HEAP32[($2 + 296 | 0) >> 2] = HEAPU8[$7 >> 0] | 0 | ((HEAPU8[($7 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($7 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($7 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$3 = $6;
        i64toi32_i32$1 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$2 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $264 = i64toi32_i32$1;
        i64toi32_i32$1 = $2;
        HEAP32[($2 + 272 | 0) >> 2] = $264;
        HEAP32[($2 + 276 | 0) >> 2] = i64toi32_i32$2;
        i64toi32_i32$3 = $5;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $267 = i64toi32_i32$2;
        i64toi32_i32$2 = $2;
        HEAP32[($2 + 256 | 0) >> 2] = $267;
        HEAP32[($2 + 260 | 0) >> 2] = i64toi32_i32$1;
        $70 = $7 + 3 | 0;
        $71 = HEAPU8[$70 >> 0] | 0 | ((HEAPU8[($70 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($70 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($70 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 299 | 0) >> 0] = $71;
        HEAP8[($2 + 300 | 0) >> 0] = $71 >>> 8 | 0;
        HEAP8[($2 + 301 | 0) >> 0] = $71 >>> 16 | 0;
        HEAP8[($2 + 302 | 0) >> 0] = $71 >>> 24 | 0;
        i64toi32_i32$3 = $2;
        i64toi32_i32$1 = HEAP32[($2 + 320 | 0) >> 2] | 0;
        i64toi32_i32$2 = HEAP32[($2 + 324 | 0) >> 2] | 0;
        $18 = i64toi32_i32$1;
        $18$hi = i64toi32_i32$2;
        i64toi32_i32$3 = $2;
        i64toi32_i32$2 = HEAP32[($2 + 328 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 332 | 0) >> 2] | 0;
        $17 = i64toi32_i32$2;
        $17$hi = i64toi32_i32$1;
        $3 = HEAP32[($2 + 360 | 0) >> 2] | 0;
        $9 = HEAPU8[($2 + 312 | 0) >> 0] | 0;
        i64toi32_i32$3 = $1;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $284 = i64toi32_i32$1;
        i64toi32_i32$1 = ($2 + 176 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $284;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
        i64toi32_i32$3 = $10;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $289 = i64toi32_i32$2;
        i64toi32_i32$2 = ($2 + 176 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$2 >> 2] = $289;
        HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
        HEAP32[(($2 + 160 | 0) + 8 | 0) >> 2] = HEAP32[$11 >> 2] | 0;
        $72 = HEAPU8[($2 + 299 | 0) >> 0] | 0 | ((HEAPU8[($2 + 300 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 301 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 302 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 203 | 0) >> 0] = $72;
        HEAP8[($2 + 204 | 0) >> 0] = $72 >>> 8 | 0;
        HEAP8[($2 + 205 | 0) >> 0] = $72 >>> 16 | 0;
        HEAP8[($2 + 206 | 0) >> 0] = $72 >>> 24 | 0;
        HEAP32[($2 + 200 | 0) >> 2] = HEAP32[($2 + 296 | 0) >> 2] | 0;
        i64toi32_i32$3 = $2;
        i64toi32_i32$1 = HEAP32[($2 + 272 | 0) >> 2] | 0;
        i64toi32_i32$2 = HEAP32[($2 + 276 | 0) >> 2] | 0;
        $303 = i64toi32_i32$1;
        i64toi32_i32$1 = $2;
        HEAP32[($2 + 176 | 0) >> 2] = $303;
        HEAP32[($2 + 180 | 0) >> 2] = i64toi32_i32$2;
        i64toi32_i32$3 = $2;
        i64toi32_i32$2 = HEAP32[($2 + 256 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 260 | 0) >> 2] | 0;
        $306 = i64toi32_i32$2;
        i64toi32_i32$2 = $2;
        HEAP32[($2 + 160 | 0) >> 2] = $306;
        HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
        if (($9 | 0) != (19 | 0)) {
         break label$4
        }
        break label$3;
       }
       i64toi32_i32$3 = $2 + 336 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $313 = i64toi32_i32$1;
       i64toi32_i32$1 = $2 + 184 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $313;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$3 = $2 + 344 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $319 = i64toi32_i32$2;
       i64toi32_i32$2 = ($2 + 176 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $319;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$3 = $2 + 328 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $323 = i64toi32_i32$1;
       i64toi32_i32$1 = $2;
       HEAP32[($2 + 176 | 0) >> 2] = $323;
       HEAP32[($2 + 180 | 0) >> 2] = i64toi32_i32$2;
       $9 = 2;
       break label$4;
      }
      i64toi32_i32$3 = $2 + 336 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $328 = i64toi32_i32$2;
      i64toi32_i32$2 = $2 + 184 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $328;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$3 = $2 + 344 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $334 = i64toi32_i32$1;
      i64toi32_i32$1 = ($2 + 176 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $334;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$3 = $2 + 328 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $338 = i64toi32_i32$2;
      i64toi32_i32$2 = $2;
      HEAP32[($2 + 176 | 0) >> 2] = $338;
      HEAP32[($2 + 180 | 0) >> 2] = i64toi32_i32$1;
     }
     i64toi32_i32$1 = $17$hi;
     i64toi32_i32$2 = ($2 + 304 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $17;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $18$hi;
     i64toi32_i32$2 = ($2 + 304 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $18;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$3 = $2;
     i64toi32_i32$1 = HEAP32[($2 + 176 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[($2 + 180 | 0) >> 2] | 0;
     $350 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 328 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $350;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$3 = $2;
     i64toi32_i32$2 = HEAP32[($2 + 160 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 164 | 0) >> 2] | 0;
     $354 = i64toi32_i32$2;
     i64toi32_i32$2 = $2 + 356 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $354;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$3 = ($2 + 176 | 0) + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $360 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 336 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $360;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$3 = ($2 + 176 | 0) + 16 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $366 = i64toi32_i32$2;
     i64toi32_i32$2 = $2 + 344 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $366;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($2 + 364 | 0) >> 2] = HEAP32[(($2 + 160 | 0) + 8 | 0) >> 2] | 0;
     HEAP8[($2 + 304 | 0) >> 0] = $9;
     $73 = HEAP32[($2 + 200 | 0) >> 2] | 0;
     HEAP8[($2 + 305 | 0) >> 0] = $73;
     HEAP8[($2 + 306 | 0) >> 0] = $73 >>> 8 | 0;
     HEAP8[($2 + 307 | 0) >> 0] = $73 >>> 16 | 0;
     HEAP8[($2 + 308 | 0) >> 0] = $73 >>> 24 | 0;
     $74 = HEAPU8[($2 + 203 | 0) >> 0] | 0 | ((HEAPU8[($2 + 204 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 205 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 206 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($2 + 308 | 0) >> 0] = $74;
     HEAP8[($2 + 309 | 0) >> 0] = $74 >>> 8 | 0;
     HEAP8[($2 + 310 | 0) >> 0] = $74 >>> 16 | 0;
     HEAP8[($2 + 311 | 0) >> 0] = $74 >>> 24 | 0;
     HEAP32[($2 + 352 | 0) >> 2] = $3;
     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($2 + 96 | 0 | 0, $2 + 304 | 0 | 0, 1052616 | 0, 22 | 0);
     $6 = HEAPU8[($2 + 96 | 0) >> 0] | 0;
     if (($6 | 0) != (19 | 0)) {
      break label$2
     }
    }
    i64toi32_i32$3 = $2;
    i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($2 + 20 | 0) >> 2] | 0;
    $393 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $393;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$2;
    HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = HEAP32[($2 + 24 | 0) >> 2] | 0;
    $3 = 0;
    break label$1;
   }
   $3 = 1;
   memcpy($2 + 33 | 0 | 0, $2 + 96 | 0 | 1 | 0 | 0, 63 | 0) | 0;
   HEAP8[($0 + 8 | 0) >> 0] = $6;
   memcpy($0 + 9 | 0 | 0, $2 + 33 | 0 | 0, 63 | 0) | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h50c1f6d5a01d91ba($2 + 16 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h0a3e4540c50cd990($2 + 16 | 0 | 0);
  }
  HEAP32[$0 >> 2] = $3;
  global$0 = $2 + 384 | 0;
 }
 
 function alloc__slice__merge_sort__h5aa492ad566875d8($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $10 = 0, $12 = 0, $3 = 0, $8 = 0, $11 = 0, $13 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $7 = 0, i64toi32_i32$0 = 0, $9 = 0, i64toi32_i32$3 = 0, $14 = 0, $4 = 0, $15$hi = 0, $16$hi = 0, $31 = 0, $5 = 0, $6 = 0, $52 = 0, $52$hi = 0, $60 = 0, $60$hi = 0, $15 = 0, $84 = 0, $110 = 0, $110$hi = 0, $118 = 0, $118$hi = 0;
  $3 = global$0 - 64 | 0;
  global$0 = $3;
  HEAP32[($3 + 28 | 0) >> 2] = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     if ($1 >>> 0 < 21 >>> 0) {
      break label$3
     }
     alloc__raw_vec__RawVec_T_2cA___allocate_in__h5dada854c892eb3e($3 + 16 | 0 | 0, $1 >>> 1 | 0 | 0, 0 | 0);
     HEAP32[($3 + 40 | 0) >> 2] = 0;
     i64toi32_i32$2 = $3;
     i64toi32_i32$0 = HEAP32[($3 + 16 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($3 + 20 | 0) >> 2] | 0;
     $31 = i64toi32_i32$0;
     i64toi32_i32$0 = $3;
     HEAP32[($3 + 32 | 0) >> 2] = $31;
     HEAP32[($3 + 36 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$0 = $3;
     i64toi32_i32$1 = 0;
     HEAP32[($3 + 52 | 0) >> 2] = 0;
     HEAP32[($3 + 56 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($3 + 48 | 0) >> 2] = HEAP32[(0 + 1069064 | 0) >> 2] | 0;
     $4 = $0 + -4 | 0;
     $5 = $0 + -8 | 0;
     $6 = $0 + -12 | 0;
     $7 = $1;
     label$4 : while (1) {
      $8 = $7;
      $7 = 0;
      $9 = 1;
      label$5 : {
       $10 = $8 + -1 | 0;
       if (!$10) {
        break label$5
       }
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           label$10 : {
            label$11 : {
             label$12 : {
              label$13 : {
               i64toi32_i32$1 = cardano_serialization_lib__tx_builder__TransactionBuilder__cip2_largest_first_by___7b_7bclosure_7d_7d__hb6689e866bcf147a($2 | 0, $0 + ($10 << 2 | 0) | 0 | 0) | 0;
               i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
               $52 = i64toi32_i32$1;
               $52$hi = i64toi32_i32$0;
               $11 = $8 + -2 | 0;
               i64toi32_i32$0 = cardano_serialization_lib__tx_builder__TransactionBuilder__cip2_largest_first_by___7b_7bclosure_7d_7d__hb6689e866bcf147a($2 | 0, $0 + ($11 << 2 | 0) | 0 | 0) | 0;
               i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
               $60 = i64toi32_i32$0;
               $60$hi = i64toi32_i32$1;
               i64toi32_i32$1 = $52$hi;
               i64toi32_i32$2 = $52;
               i64toi32_i32$0 = $60$hi;
               i64toi32_i32$3 = $60;
               if (i64toi32_i32$1 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0) {
                break label$13
               }
               $11 = $8 + -2 | 0;
               $10 = $6 + ($8 << 2 | 0) | 0;
               $7 = 0;
               $12 = 0;
               label$14 : while (1) {
                label$15 : {
                 if (($11 | 0) != ($12 | 0)) {
                  break label$15
                 }
                 $9 = $8;
                 break label$5;
                }
                i64toi32_i32$2 = cardano_serialization_lib__tx_builder__TransactionBuilder__cip2_largest_first_by___7b_7bclosure_7d_7d__hb6689e866bcf147a($2 | 0, $10 + 4 | 0 | 0) | 0;
                i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
                $15 = i64toi32_i32$2;
                $15$hi = i64toi32_i32$1;
                i64toi32_i32$1 = cardano_serialization_lib__tx_builder__TransactionBuilder__cip2_largest_first_by___7b_7bclosure_7d_7d__hb6689e866bcf147a($2 | 0, $10 | 0) | 0;
                i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
                $16$hi = i64toi32_i32$2;
                $10 = $10 + -4 | 0;
                $12 = $12 + 1 | 0;
                i64toi32_i32$2 = $15$hi;
                i64toi32_i32$2 = $16$hi;
                $84 = i64toi32_i32$1;
                i64toi32_i32$2 = $15$hi;
                i64toi32_i32$3 = $15;
                i64toi32_i32$1 = $16$hi;
                i64toi32_i32$0 = $84;
                if (i64toi32_i32$2 >>> 0 > i64toi32_i32$1 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$3 >>> 0 >= i64toi32_i32$0 >>> 0 | 0) | 0) {
                 continue label$14
                }
                break label$14;
               };
               $9 = $12 + 1 | 0;
               $12 = ($12 ^ -1 | 0) + $8 | 0;
               break label$12;
              }
              $13 = 2;
              $7 = $5 + ($8 << 2 | 0) | 0;
              label$16 : {
               label$17 : while (1) {
                $14 = $13;
                $10 = $7;
                $12 = $11;
                if (!$12) {
                 break label$16
                }
                $7 = $10 + -4 | 0;
                $13 = $14 + 1 | 0;
                i64toi32_i32$3 = cardano_serialization_lib__tx_builder__TransactionBuilder__cip2_largest_first_by___7b_7bclosure_7d_7d__hb6689e866bcf147a($2 | 0, $0 + ($12 << 2 | 0) | 0 | 0) | 0;
                i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
                $110 = i64toi32_i32$3;
                $110$hi = i64toi32_i32$2;
                $11 = $12 + -1 | 0;
                i64toi32_i32$2 = cardano_serialization_lib__tx_builder__TransactionBuilder__cip2_largest_first_by___7b_7bclosure_7d_7d__hb6689e866bcf147a($2 | 0, $0 + ($11 << 2 | 0) | 0 | 0) | 0;
                i64toi32_i32$3 = i64toi32_i32$HIGH_BITS;
                $118 = i64toi32_i32$2;
                $118$hi = i64toi32_i32$3;
                i64toi32_i32$3 = $110$hi;
                i64toi32_i32$0 = $110;
                i64toi32_i32$2 = $118$hi;
                i64toi32_i32$1 = $118;
                if (i64toi32_i32$3 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0 | 0) | 0) {
                 continue label$17
                }
                break label$17;
               };
              }
              if ($8 >>> 0 < $12 >>> 0) {
               break label$11
              }
              if ($8 >>> 0 > $1 >>> 0) {
               break label$10
              }
              $9 = $8 - $12 | 0;
              if (!($9 >>> 1 | 0)) {
               break label$12
              }
              $13 = $14 >>> 1 | 0;
              $11 = $4 + ($8 << 2 | 0) | 0;
              label$18 : while (1) {
               $7 = HEAP32[$10 >> 2] | 0;
               HEAP32[$10 >> 2] = HEAP32[$11 >> 2] | 0;
               HEAP32[$11 >> 2] = $7;
               $10 = $10 + 4 | 0;
               $11 = $11 + -4 | 0;
               $13 = $13 + -1 | 0;
               if ($13) {
                continue label$18
               }
               break label$18;
              };
             }
             if (!$12) {
              break label$6
             }
             if ($9 >>> 0 > 9 >>> 0) {
              break label$6
             }
             $10 = 1 - $12 | 0;
             $11 = $4 + ($12 << 2 | 0) | 0;
             label$19 : while (1) {
              $7 = $12 + -1 | 0;
              if ($8 >>> 0 < $7 >>> 0) {
               break label$9
              }
              if ($8 >>> 0 > $1 >>> 0) {
               break label$8
              }
              $13 = $8 + $10 | 0;
              alloc__slice__insert_head__hc4f7fbe6474bcab2($11 | 0, $13 | 0, $3 + 28 | 0 | 0);
              if (!$10) {
               break label$7
              }
              $10 = $10 + 1 | 0;
              $11 = $11 + -4 | 0;
              $12 = $7;
              if ($13 >>> 0 < 10 >>> 0) {
               continue label$19
              }
              break label$7;
             };
            }
            core__slice__index__slice_index_order_fail__h71e247dec3f266ff($12 | 0, $8 | 0, 1069172 | 0);
            abort();
           }
           core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($8 | 0, $1 | 0, 1069172 | 0);
           abort();
          }
          core__slice__index__slice_index_order_fail__h71e247dec3f266ff($12 + -1 | 0 | 0, $8 | 0, 1069188 | 0);
          abort();
         }
         core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($8 | 0, $1 | 0, 1069188 | 0);
         abort();
        }
        $9 = $8 - $7 | 0;
        break label$5;
       }
       $7 = $12;
      }
      label$20 : {
       $10 = HEAP32[($3 + 56 | 0) >> 2] | 0;
       if ((HEAP32[($3 + 52 | 0) >> 2] | 0 | 0) != ($10 | 0)) {
        break label$20
       }
       alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hf5a91d7c63e29e55($3 + 48 | 0 | 0, $10 | 0, 1 | 0);
       $10 = HEAP32[($3 + 56 | 0) >> 2] | 0;
      }
      $10 = (HEAP32[($3 + 48 | 0) >> 2] | 0) + ($10 << 3 | 0) | 0;
      HEAP32[($10 + 4 | 0) >> 2] = $9;
      HEAP32[$10 >> 2] = $7;
      $10 = (HEAP32[($3 + 56 | 0) >> 2] | 0) + 1 | 0;
      HEAP32[($3 + 56 | 0) >> 2] = $10;
      label$21 : {
       if ($10 >>> 0 < 2 >>> 0) {
        break label$21
       }
       label$22 : {
        label$23 : {
         label$24 : {
          label$25 : {
           label$26 : while (1) {
            label$27 : {
             label$28 : {
              label$29 : {
               label$30 : {
                $8 = HEAP32[($3 + 48 | 0) >> 2] | 0;
                $12 = $8 + (($10 + -1 | 0) << 3 | 0) | 0;
                if (!(HEAP32[$12 >> 2] | 0)) {
                 break label$30
                }
                $9 = ($10 << 3 | 0) + $8 | 0;
                $14 = HEAP32[($9 + -12 | 0) >> 2] | 0;
                $11 = HEAP32[($12 + 4 | 0) >> 2] | 0;
                if ($14 >>> 0 <= $11 >>> 0) {
                 break label$30
                }
                if ($10 >>> 0 < 3 >>> 0) {
                 break label$21
                }
                $12 = $10 + -3 | 0;
                $13 = HEAP32[(($8 + ($12 << 3 | 0) | 0) + 4 | 0) >> 2] | 0;
                if ($13 >>> 0 <= ($11 + $14 | 0) >>> 0) {
                 break label$29
                }
                if ($10 >>> 0 < 4 >>> 0) {
                 break label$21
                }
                if ((HEAP32[($9 + -28 | 0) >> 2] | 0) >>> 0 <= ($13 + $14 | 0) >>> 0) {
                 break label$29
                }
                break label$21;
               }
               if ($10 >>> 0 < 3 >>> 0) {
                break label$28
               }
               $11 = HEAP32[($12 + 4 | 0) >> 2] | 0;
               $12 = $10 + -3 | 0;
               $13 = HEAP32[(($8 + ($12 << 3 | 0) | 0) + 4 | 0) >> 2] | 0;
              }
              if ($13 >>> 0 < $11 >>> 0) {
               break label$27
              }
             }
             $12 = $10 + -2 | 0;
            }
            label$31 : {
             $11 = $12 + 1 | 0;
             if ($10 >>> 0 <= $11 >>> 0) {
              break label$31
             }
             if ($10 >>> 0 <= $12 >>> 0) {
              break label$25
             }
             $14 = $12 << 3 | 0;
             $10 = $8 + $14 | 0;
             $9 = HEAP32[($10 + 4 | 0) >> 2] | 0;
             $13 = $9 + (HEAP32[$10 >> 2] | 0) | 0;
             $8 = $8 + ($11 << 3 | 0) | 0;
             $10 = HEAP32[$8 >> 2] | 0;
             if ($13 >>> 0 < $10 >>> 0) {
              break label$24
             }
             if ($13 >>> 0 > $1 >>> 0) {
              break label$23
             }
             $8 = HEAP32[($8 + 4 | 0) >> 2] | 0;
             alloc__slice__merge__h77a350cbd049521d($0 + ($10 << 2 | 0) | 0 | 0, $13 - $10 | 0 | 0, $8 | 0, HEAP32[($3 + 32 | 0) >> 2] | 0 | 0, $3 + 28 | 0 | 0);
             $13 = HEAP32[($3 + 56 | 0) >> 2] | 0;
             if ($13 >>> 0 <= $12 >>> 0) {
              break label$22
             }
             $12 = (HEAP32[($3 + 48 | 0) >> 2] | 0) + $14 | 0;
             HEAP32[($12 + 4 | 0) >> 2] = $9 + $8 | 0;
             HEAP32[$12 >> 2] = $10;
             alloc__vec__Vec_T_2cA___remove__hf0ee37bb0b07dbd1($3 + 8 | 0 | 0, $3 + 48 | 0 | 0, $11 | 0);
             $10 = HEAP32[($3 + 56 | 0) >> 2] | 0;
             if ($10 >>> 0 > 1 >>> 0) {
              continue label$26
             }
             break label$21;
            }
            break label$26;
           };
           core__panicking__panic_bounds_check__h808b524af17640b1($11 | 0, $10 | 0, 1069204 | 0);
           abort();
          }
          core__panicking__panic_bounds_check__h808b524af17640b1($12 | 0, $10 | 0, 1069220 | 0);
          abort();
         }
         core__slice__index__slice_index_order_fail__h71e247dec3f266ff($10 | 0, $13 | 0, 1069236 | 0);
         abort();
        }
        core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($13 | 0, $1 | 0, 1069236 | 0);
        abort();
       }
       core__panicking__panic_bounds_check__h808b524af17640b1($12 | 0, $13 | 0, 1069252 | 0);
       abort();
      }
      if ($7) {
       continue label$4
      }
      break label$4;
     };
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h28ea22ae705f999b($3 + 48 | 0 | 0);
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hb513c626355ab1b6($3 + 32 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h515a508dccfbb69c($3 + 32 | 0 | 0);
     break label$2;
    }
    if ($1 >>> 0 < 2 >>> 0) {
     break label$2
    }
    core__iter__adapters__rev__Rev_T___new__h11ed92efd1d68010($3 | 0, 0 | 0, $1 + -1 | 0 | 0);
    $13 = HEAP32[$3 >> 2] | 0;
    $11 = HEAP32[($3 + 4 | 0) >> 2] | 0;
    if ($13 >>> 0 >= $11 >>> 0) {
     break label$2
    }
    $10 = ($1 - $11 | 0) + 1 | 0;
    $12 = (($11 << 2 | 0) + $0 | 0) + -4 | 0;
    label$32 : while (1) {
     $8 = $11 + -1 | 0;
     if ($8 >>> 0 > $1 >>> 0) {
      break label$1
     }
     alloc__slice__insert_head__hc4f7fbe6474bcab2($12 | 0, $10 | 0, $3 + 28 | 0 | 0);
     $10 = $10 + 1 | 0;
     $12 = $12 + -4 | 0;
     $11 = $8;
     if ($13 >>> 0 < $8 >>> 0) {
      continue label$32
     }
     break label$32;
    };
   }
   global$0 = $3 + 64 | 0;
   return;
  }
  core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($11 + -1 | 0 | 0, $1 | 0, 1069156 | 0);
  abort();
 }
 
 function alloc__slice__merge_sort__h665fa44369f3a6bc($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $13 = 0, $9 = 0, $11 = 0, $12 = 0, $8 = 0, $10 = 0, $15 = 0, $4 = 0, $5 = 0, $14 = 0, $6 = 0, $7 = 0;
  $3 = global$0 - 192 | 0;
  global$0 = $3;
  HEAP32[($3 + 28 | 0) >> 2] = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     if ($1 >>> 0 < 21 >>> 0) {
      break label$3
     }
     alloc__raw_vec__RawVec_T_2cA___allocate_in__he0e25d30114cc7d7($3 + 16 | 0 | 0, $1 >>> 1 | 0 | 0, 0 | 0);
     HEAP32[($3 + 40 | 0) >> 2] = 0;
     HEAP32[($3 + 36 | 0) >> 2] = HEAP32[($3 + 20 | 0) >> 2] | 0;
     $4 = HEAP32[($3 + 16 | 0) >> 2] | 0;
     HEAP32[($3 + 32 | 0) >> 2] = $4;
     HEAP32[($3 + 52 | 0) >> 2] = 0;
     HEAP32[($3 + 56 | 0) >> 2] = 0;
     HEAP32[($3 + 48 | 0) >> 2] = HEAP32[(0 + 1069064 | 0) >> 2] | 0;
     $5 = $0 + -128 | 0;
     $6 = $0 + -256 | 0;
     $7 = $0 + -384 | 0;
     $8 = $1;
     label$4 : while (1) {
      $9 = $8;
      $8 = 0;
      $10 = 1;
      label$5 : {
       $2 = $9 + -1 | 0;
       if (!$2) {
        break label$5
       }
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           label$10 : {
            label$11 : {
             label$12 : {
              label$13 : {
               $11 = $9 + -2 | 0;
               if (alloc__slice___impl_20_5bT_5d___sort_by_key___7b_7bclosure_7d_7d__h5570c792610ff4df($3 + 28 | 0 | 0, $0 + ($2 << 7 | 0) | 0 | 0, $0 + ($11 << 7 | 0) | 0 | 0) | 0) {
                break label$13
               }
               $12 = $9 + -2 | 0;
               $2 = $7 + ($9 << 7 | 0) | 0;
               $8 = 0;
               $13 = 0;
               label$14 : while (1) {
                label$15 : {
                 if (($12 | 0) != ($13 | 0)) {
                  break label$15
                 }
                 $10 = $9;
                 break label$5;
                }
                $13 = $13 + 1 | 0;
                $11 = alloc__slice___impl_20_5bT_5d___sort_by_key___7b_7bclosure_7d_7d__h5570c792610ff4df($3 + 28 | 0 | 0, $2 + 128 | 0 | 0, $2 | 0) | 0;
                $2 = $2 + -128 | 0;
                if (!$11) {
                 continue label$14
                }
                break label$14;
               };
               $10 = $13 + 1 | 0;
               $2 = ($13 ^ -1 | 0) + $9 | 0;
               break label$12;
              }
              $14 = $9 << 7 | 0;
              $12 = $6 + $14 | 0;
              $8 = 2;
              label$16 : {
               label$17 : while (1) {
                $15 = $8;
                $13 = $12;
                $2 = $11;
                if (!$2) {
                 break label$16
                }
                $12 = $13 + -128 | 0;
                $8 = $15 + 1 | 0;
                $11 = $2 + -1 | 0;
                if (alloc__slice___impl_20_5bT_5d___sort_by_key___7b_7bclosure_7d_7d__h5570c792610ff4df($3 + 28 | 0 | 0, $0 + ($2 << 7 | 0) | 0 | 0, $0 + ($11 << 7 | 0) | 0 | 0) | 0) {
                 continue label$17
                }
                break label$17;
               };
              }
              if ($9 >>> 0 < $2 >>> 0) {
               break label$11
              }
              if ($9 >>> 0 > $1 >>> 0) {
               break label$10
              }
              $10 = $9 - $2 | 0;
              if (!($10 >>> 1 | 0)) {
               break label$12
              }
              $12 = $15 >>> 1 | 0;
              $11 = $5 + $14 | 0;
              label$18 : while (1) {
               memcpy($3 + 64 | 0 | 0, $13 | 0, 128 | 0) | 0;
               $13 = (memmove($13 | 0, $11 | 0, 128 | 0) | 0) + 128 | 0;
               $11 = (memcpy($11 | 0, $3 + 64 | 0 | 0, 128 | 0) | 0) + -128 | 0;
               $12 = $12 + -1 | 0;
               if ($12) {
                continue label$18
               }
               break label$18;
              };
             }
             if (!$2) {
              break label$6
             }
             if ($10 >>> 0 > 9 >>> 0) {
              break label$6
             }
             $13 = 1 - $2 | 0;
             $11 = $5 + ($2 << 7 | 0) | 0;
             label$19 : while (1) {
              $8 = $2 + -1 | 0;
              if ($9 >>> 0 < $8 >>> 0) {
               break label$9
              }
              if ($9 >>> 0 > $1 >>> 0) {
               break label$8
              }
              $12 = $9 + $13 | 0;
              alloc__slice__insert_head__h77ad8b617951af0c($11 | 0, $12 | 0, $3 + 28 | 0 | 0);
              if (!$13) {
               break label$7
              }
              $13 = $13 + 1 | 0;
              $11 = $11 + -128 | 0;
              $2 = $8;
              if ($12 >>> 0 < 10 >>> 0) {
               continue label$19
              }
              break label$7;
             };
            }
            core__slice__index__slice_index_order_fail__h71e247dec3f266ff($2 | 0, $9 | 0, 1069172 | 0);
            abort();
           }
           core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($9 | 0, $1 | 0, 1069172 | 0);
           abort();
          }
          core__slice__index__slice_index_order_fail__h71e247dec3f266ff($2 + -1 | 0 | 0, $9 | 0, 1069188 | 0);
          abort();
         }
         core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($9 | 0, $1 | 0, 1069188 | 0);
         abort();
        }
        $10 = $9 - $8 | 0;
        break label$5;
       }
       $8 = $2;
      }
      label$20 : {
       $2 = HEAP32[($3 + 56 | 0) >> 2] | 0;
       if ((HEAP32[($3 + 52 | 0) >> 2] | 0 | 0) != ($2 | 0)) {
        break label$20
       }
       alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hf5a91d7c63e29e55($3 + 48 | 0 | 0, $2 | 0, 1 | 0);
       $2 = HEAP32[($3 + 56 | 0) >> 2] | 0;
      }
      $2 = (HEAP32[($3 + 48 | 0) >> 2] | 0) + ($2 << 3 | 0) | 0;
      HEAP32[($2 + 4 | 0) >> 2] = $10;
      HEAP32[$2 >> 2] = $8;
      $2 = (HEAP32[($3 + 56 | 0) >> 2] | 0) + 1 | 0;
      HEAP32[($3 + 56 | 0) >> 2] = $2;
      label$21 : {
       if ($2 >>> 0 < 2 >>> 0) {
        break label$21
       }
       label$22 : {
        label$23 : {
         label$24 : {
          label$25 : {
           label$26 : while (1) {
            label$27 : {
             label$28 : {
              label$29 : {
               label$30 : {
                $9 = HEAP32[($3 + 48 | 0) >> 2] | 0;
                $13 = $9 + (($2 + -1 | 0) << 3 | 0) | 0;
                if (!(HEAP32[$13 >> 2] | 0)) {
                 break label$30
                }
                $10 = ($2 << 3 | 0) + $9 | 0;
                $15 = HEAP32[($10 + -12 | 0) >> 2] | 0;
                $11 = HEAP32[($13 + 4 | 0) >> 2] | 0;
                if ($15 >>> 0 <= $11 >>> 0) {
                 break label$30
                }
                if ($2 >>> 0 < 3 >>> 0) {
                 break label$21
                }
                $13 = $2 + -3 | 0;
                $12 = HEAP32[(($9 + ($13 << 3 | 0) | 0) + 4 | 0) >> 2] | 0;
                if ($12 >>> 0 <= ($11 + $15 | 0) >>> 0) {
                 break label$29
                }
                if ($2 >>> 0 < 4 >>> 0) {
                 break label$21
                }
                if ((HEAP32[($10 + -28 | 0) >> 2] | 0) >>> 0 <= ($12 + $15 | 0) >>> 0) {
                 break label$29
                }
                break label$21;
               }
               if ($2 >>> 0 < 3 >>> 0) {
                break label$28
               }
               $11 = HEAP32[($13 + 4 | 0) >> 2] | 0;
               $13 = $2 + -3 | 0;
               $12 = HEAP32[(($9 + ($13 << 3 | 0) | 0) + 4 | 0) >> 2] | 0;
              }
              if ($12 >>> 0 < $11 >>> 0) {
               break label$27
              }
             }
             $13 = $2 + -2 | 0;
            }
            label$31 : {
             $11 = $13 + 1 | 0;
             if ($2 >>> 0 <= $11 >>> 0) {
              break label$31
             }
             if ($2 >>> 0 <= $13 >>> 0) {
              break label$25
             }
             $15 = $13 << 3 | 0;
             $2 = $9 + $15 | 0;
             $10 = HEAP32[($2 + 4 | 0) >> 2] | 0;
             $12 = $10 + (HEAP32[$2 >> 2] | 0) | 0;
             $9 = $9 + ($11 << 3 | 0) | 0;
             $2 = HEAP32[$9 >> 2] | 0;
             if ($12 >>> 0 < $2 >>> 0) {
              break label$24
             }
             if ($12 >>> 0 > $1 >>> 0) {
              break label$23
             }
             $9 = HEAP32[($9 + 4 | 0) >> 2] | 0;
             alloc__slice__merge__ha271ef597e06aa80($0 + ($2 << 7 | 0) | 0 | 0, $12 - $2 | 0 | 0, $9 | 0, $4 | 0, $3 + 28 | 0 | 0);
             $12 = HEAP32[($3 + 56 | 0) >> 2] | 0;
             if ($12 >>> 0 <= $13 >>> 0) {
              break label$22
             }
             $13 = (HEAP32[($3 + 48 | 0) >> 2] | 0) + $15 | 0;
             HEAP32[($13 + 4 | 0) >> 2] = $10 + $9 | 0;
             HEAP32[$13 >> 2] = $2;
             alloc__vec__Vec_T_2cA___remove__hf0ee37bb0b07dbd1($3 + 8 | 0 | 0, $3 + 48 | 0 | 0, $11 | 0);
             $2 = HEAP32[($3 + 56 | 0) >> 2] | 0;
             if ($2 >>> 0 > 1 >>> 0) {
              continue label$26
             }
             break label$21;
            }
            break label$26;
           };
           core__panicking__panic_bounds_check__h808b524af17640b1($11 | 0, $2 | 0, 1069204 | 0);
           abort();
          }
          core__panicking__panic_bounds_check__h808b524af17640b1($13 | 0, $2 | 0, 1069220 | 0);
          abort();
         }
         core__slice__index__slice_index_order_fail__h71e247dec3f266ff($2 | 0, $12 | 0, 1069236 | 0);
         abort();
        }
        core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($12 | 0, $1 | 0, 1069236 | 0);
        abort();
       }
       core__panicking__panic_bounds_check__h808b524af17640b1($13 | 0, $12 | 0, 1069252 | 0);
       abort();
      }
      if ($8) {
       continue label$4
      }
      break label$4;
     };
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h28ea22ae705f999b($3 + 48 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h5107e2b13c386680($3 + 32 | 0 | 0);
     break label$2;
    }
    if ($1 >>> 0 < 2 >>> 0) {
     break label$2
    }
    core__iter__adapters__rev__Rev_T___new__h11ed92efd1d68010($3 | 0, 0 | 0, $1 + -1 | 0 | 0);
    $12 = HEAP32[$3 >> 2] | 0;
    $11 = HEAP32[($3 + 4 | 0) >> 2] | 0;
    if ($12 >>> 0 >= $11 >>> 0) {
     break label$2
    }
    $2 = ($1 - $11 | 0) + 1 | 0;
    $13 = (($11 << 7 | 0) + $0 | 0) + -128 | 0;
    label$32 : while (1) {
     $9 = $11 + -1 | 0;
     if ($9 >>> 0 > $1 >>> 0) {
      break label$1
     }
     alloc__slice__insert_head__h77ad8b617951af0c($13 | 0, $2 | 0, $3 + 28 | 0 | 0);
     $2 = $2 + 1 | 0;
     $13 = $13 + -128 | 0;
     $11 = $9;
     if ($12 >>> 0 < $9 >>> 0) {
      continue label$32
     }
     break label$32;
    };
   }
   global$0 = $3 + 192 | 0;
   return;
  }
  core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($11 + -1 | 0 | 0, $1 | 0, 1069156 | 0);
  abort();
 }
 
 function $cardano_serialization_lib__plutus__Redeemers_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hbb30960977af731e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, $11 = 0, $18 = 0, $20 = 0, $3 = 0, $10 = 0, $12 = 0, $18$hi = 0, $20$hi = 0, $59 = 0, $60 = 0, $61 = 0, $62 = 0, $63 = 0, $64 = 0, $65 = 0, $66 = 0, $67 = 0, $68 = 0, $69 = 0, $70 = 0, $71 = 0, $19 = 0, $19$hi = 0, $7 = 0, $4 = 0, $5 = 0, $6 = 0, $8 = 0, $13 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $9 = 0, $77 = 0, $84 = 0, $100 = 0, $103 = 0, $121 = 0, $127 = 0, $133 = 0, $142 = 0, $151 = 0, $154 = 0, $188 = 0, $192 = 0, $196 = 0, $203 = 0, $211 = 0, $215 = 0, $257 = 0, $264 = 0, $280 = 0, $283 = 0, $291 = 0, $297 = 0, $301 = 0, $307 = 0, $313 = 0, $317 = 0, $329 = 0, $333 = 0, $339 = 0, $345 = 0, $372 = 0;
  $2 = global$0 - 400 | 0;
  global$0 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 12 | 0) >> 2] = 0;
  HEAP32[($2 + 16 | 0) >> 2] = i64toi32_i32$0;
  $3 = 0;
  HEAP32[($2 + 8 | 0) >> 2] = HEAP32[(0 + 1070736 | 0) >> 2] | 0;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 312 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = ($2 + 312 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  $18$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 320 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 324 | 0) >> 2] | 0;
  $19 = i64toi32_i32$1;
  $19$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 312 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 316 | 0) >> 2] | 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
         break label$6
        }
        i64toi32_i32$2 = $18$hi;
        $4 = $18;
        label$7 : {
         i64toi32_i32$2 = $19$hi;
         i64toi32_i32$3 = $19;
         i64toi32_i32$1 = 0;
         i64toi32_i32$0 = 1;
         if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
          break label$7
         }
         if (!$4) {
          break label$3
         }
        }
        $5 = ($2 + 312 | 0) + 72 | 0;
        $6 = ($2 + 312 | 0) + 60 | 0;
        $7 = ($2 + 312 | 0) + 32 | 0;
        $8 = $2 + 321 | 0;
        $9 = $8 + 3 | 0;
        label$8 : {
         label$9 : while (1) {
          std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 | 0, $1 | 0);
          $3 = 0;
          $10 = 2;
          label$10 : {
           if (HEAP32[($2 + 4 | 0) >> 2] | 0) {
            break label$10
           }
           i64toi32_i32$3 = 0;
           $20 = 8;
           $20$hi = i64toi32_i32$3;
           i64toi32_i32$3 = 0;
           $18 = 0;
           $18$hi = i64toi32_i32$3;
           break label$4;
          }
          label$11 : {
           if ((($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[$2 >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) == (7 | 0)) {
            break label$11
           }
           $cardano_serialization_lib__plutus__Redeemer_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h50e886ac76690234($2 + 312 | 0 | 0, $1 | 0);
           $11 = ($2 + 280 | 0) + 8 | 0;
           i64toi32_i32$0 = $7 + 8 | 0;
           i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $77 = i64toi32_i32$3;
           i64toi32_i32$3 = $11;
           HEAP32[i64toi32_i32$3 >> 2] = $77;
           HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
           $12 = ($2 + 280 | 0) + 16 | 0;
           i64toi32_i32$0 = $7 + 16 | 0;
           i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$3 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $84 = i64toi32_i32$2;
           i64toi32_i32$2 = $12;
           HEAP32[i64toi32_i32$2 >> 2] = $84;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
           $13 = ($2 + 264 | 0) + 8 | 0;
           HEAP32[$13 >> 2] = HEAP32[($6 + 8 | 0) >> 2] | 0;
           $59 = $8;
           HEAP32[($2 + 304 | 0) >> 2] = HEAPU8[$59 >> 0] | 0 | ((HEAPU8[($59 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($59 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($59 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $60 = $9;
           $61 = HEAPU8[$60 >> 0] | 0 | ((HEAPU8[($60 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($60 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($60 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 307 | 0) >> 0] = $61;
           HEAP8[($2 + 308 | 0) >> 0] = $61 >>> 8 | 0;
           HEAP8[($2 + 309 | 0) >> 0] = $61 >>> 16 | 0;
           HEAP8[($2 + 310 | 0) >> 0] = $61 >>> 24 | 0;
           i64toi32_i32$0 = $7;
           i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $100 = i64toi32_i32$3;
           i64toi32_i32$3 = $2;
           HEAP32[($2 + 280 | 0) >> 2] = $100;
           HEAP32[($2 + 284 | 0) >> 2] = i64toi32_i32$2;
           i64toi32_i32$0 = $6;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $103 = i64toi32_i32$2;
           i64toi32_i32$2 = $2;
           HEAP32[($2 + 264 | 0) >> 2] = $103;
           HEAP32[($2 + 268 | 0) >> 2] = i64toi32_i32$3;
           $3 = HEAP32[($2 + 368 | 0) >> 2] | 0;
           i64toi32_i32$0 = $2;
           i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 336 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 340 | 0) >> 2] | 0;
           $18 = i64toi32_i32$3;
           $18$hi = i64toi32_i32$2;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 328 | 0) >> 2] | 0;
           i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 332 | 0) >> 2] | 0;
           $20 = i64toi32_i32$2;
           $20$hi = i64toi32_i32$3;
           $10 = HEAPU8[(i64toi32_i32$0 + 320 | 0) >> 0] | 0;
           i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 312 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 316 | 0) >> 2] | 0;
           i64toi32_i32$0 = i64toi32_i32$3;
           i64toi32_i32$3 = 0;
           i64toi32_i32$1 = 1;
           if ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) | 0) {
            break label$8
           }
           $14 = ($2 + 200 | 0) + 8 | 0;
           i64toi32_i32$1 = $5 + 8 | 0;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $121 = i64toi32_i32$0;
           i64toi32_i32$0 = $14;
           HEAP32[i64toi32_i32$0 >> 2] = $121;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
           $15 = ($2 + 232 | 0) + 8 | 0;
           i64toi32_i32$1 = $11;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $127 = i64toi32_i32$2;
           i64toi32_i32$2 = $15;
           HEAP32[i64toi32_i32$2 >> 2] = $127;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
           $16 = ($2 + 232 | 0) + 16 | 0;
           i64toi32_i32$1 = $12;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $133 = i64toi32_i32$0;
           i64toi32_i32$0 = $16;
           HEAP32[i64toi32_i32$0 >> 2] = $133;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
           $17 = ($2 + 216 | 0) + 8 | 0;
           HEAP32[$17 >> 2] = HEAP32[$13 >> 2] | 0;
           i64toi32_i32$1 = $5;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $142 = i64toi32_i32$2;
           i64toi32_i32$2 = $2;
           HEAP32[($2 + 200 | 0) >> 2] = $142;
           HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$0;
           HEAP32[($2 + 256 | 0) >> 2] = HEAP32[($2 + 304 | 0) >> 2] | 0;
           $62 = HEAPU8[($2 + 307 | 0) >> 0] | 0 | ((HEAPU8[($2 + 308 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 309 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 310 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 259 | 0) >> 0] = $62;
           HEAP8[($2 + 260 | 0) >> 0] = $62 >>> 8 | 0;
           HEAP8[($2 + 261 | 0) >> 0] = $62 >>> 16 | 0;
           HEAP8[($2 + 262 | 0) >> 0] = $62 >>> 24 | 0;
           i64toi32_i32$1 = $2;
           i64toi32_i32$0 = HEAP32[($2 + 280 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($2 + 284 | 0) >> 2] | 0;
           $151 = i64toi32_i32$0;
           i64toi32_i32$0 = $2;
           HEAP32[($2 + 232 | 0) >> 2] = $151;
           HEAP32[($2 + 236 | 0) >> 2] = i64toi32_i32$2;
           i64toi32_i32$1 = $2;
           i64toi32_i32$2 = HEAP32[($2 + 264 | 0) >> 2] | 0;
           i64toi32_i32$0 = HEAP32[($2 + 268 | 0) >> 2] | 0;
           $154 = i64toi32_i32$2;
           i64toi32_i32$2 = $2;
           HEAP32[($2 + 216 | 0) >> 2] = $154;
           HEAP32[($2 + 220 | 0) >> 2] = i64toi32_i32$0;
           label$12 : {
            $12 = HEAP32[($2 + 16 | 0) >> 2] | 0;
            if ((HEAP32[($2 + 12 | 0) >> 2] | 0 | 0) != ($12 | 0)) {
             break label$12
            }
            alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hf4e46fc64716925d($2 + 8 | 0 | 0, $12 | 0, 1 | 0);
            $12 = HEAP32[($2 + 16 | 0) >> 2] | 0;
           }
           $11 = (HEAP32[($2 + 8 | 0) >> 2] | 0) + Math_imul($12, 80) | 0;
           HEAP8[$11 >> 0] = $10;
           $63 = HEAP32[($2 + 256 | 0) >> 2] | 0;
           HEAP8[($11 + 1 | 0) >> 0] = $63;
           HEAP8[($11 + 2 | 0) >> 0] = $63 >>> 8 | 0;
           HEAP8[($11 + 3 | 0) >> 0] = $63 >>> 16 | 0;
           HEAP8[($11 + 4 | 0) >> 0] = $63 >>> 24 | 0;
           i64toi32_i32$0 = $20$hi;
           i64toi32_i32$2 = $11;
           HEAP8[(i64toi32_i32$2 + 8 | 0) >> 0] = $20;
           HEAP8[(i64toi32_i32$2 + 9 | 0) >> 0] = $20 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 10 | 0) >> 0] = $20 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 11 | 0) >> 0] = $20 >>> 24 | 0;
           HEAP8[(i64toi32_i32$2 + 12 | 0) >> 0] = i64toi32_i32$0;
           HEAP8[(i64toi32_i32$2 + 13 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 14 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 15 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
           $64 = i64toi32_i32$2 + 4 | 0;
           $65 = HEAPU8[($2 + 259 | 0) >> 0] | 0 | ((HEAPU8[($2 + 260 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 261 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 262 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[$64 >> 0] = $65;
           HEAP8[($64 + 1 | 0) >> 0] = $65 >>> 8 | 0;
           HEAP8[($64 + 2 | 0) >> 0] = $65 >>> 16 | 0;
           HEAP8[($64 + 3 | 0) >> 0] = $65 >>> 24 | 0;
           i64toi32_i32$0 = $18$hi;
           i64toi32_i32$2 = i64toi32_i32$2 + 16 | 0;
           HEAP8[i64toi32_i32$2 >> 0] = $18;
           HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $18 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $18 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $18 >>> 24 | 0;
           HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$0;
           HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
           i64toi32_i32$1 = $2;
           i64toi32_i32$0 = HEAP32[($2 + 232 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($2 + 236 | 0) >> 2] | 0;
           $188 = i64toi32_i32$0;
           i64toi32_i32$0 = $11 + 24 | 0;
           $66 = $188;
           HEAP8[i64toi32_i32$0 >> 0] = $66;
           HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $66 >>> 8 | 0;
           HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $66 >>> 16 | 0;
           HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $66 >>> 24 | 0;
           HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$2;
           HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
           HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
           HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
           i64toi32_i32$1 = $15;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $192 = i64toi32_i32$2;
           i64toi32_i32$2 = $11 + 32 | 0;
           $67 = $192;
           HEAP8[i64toi32_i32$2 >> 0] = $67;
           HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $67 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $67 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $67 >>> 24 | 0;
           HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$0;
           HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
           i64toi32_i32$1 = $16;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $196 = i64toi32_i32$0;
           i64toi32_i32$0 = $11 + 40 | 0;
           $68 = $196;
           HEAP8[i64toi32_i32$0 >> 0] = $68;
           HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $68 >>> 8 | 0;
           HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $68 >>> 16 | 0;
           HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $68 >>> 24 | 0;
           HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$2;
           HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
           HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
           HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
           HEAP32[($11 + 48 | 0) >> 2] = $3;
           i64toi32_i32$1 = $2;
           i64toi32_i32$2 = HEAP32[($2 + 216 | 0) >> 2] | 0;
           i64toi32_i32$0 = HEAP32[($2 + 220 | 0) >> 2] | 0;
           $203 = i64toi32_i32$2;
           i64toi32_i32$2 = $11 + 52 | 0;
           HEAP32[i64toi32_i32$2 >> 2] = $203;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
           HEAP32[($11 + 60 | 0) >> 2] = HEAP32[$17 >> 2] | 0;
           i64toi32_i32$1 = $2;
           i64toi32_i32$0 = HEAP32[($2 + 200 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($2 + 204 | 0) >> 2] | 0;
           $211 = i64toi32_i32$0;
           i64toi32_i32$0 = $11 + 64 | 0;
           HEAP32[i64toi32_i32$0 >> 2] = $211;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
           i64toi32_i32$1 = $14;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $215 = i64toi32_i32$2;
           i64toi32_i32$2 = $11 + 72 | 0;
           HEAP32[i64toi32_i32$2 >> 2] = $215;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
           $11 = $12 + 1 | 0;
           HEAP32[($2 + 16 | 0) >> 2] = $11;
           i64toi32_i32$0 = $19$hi;
           i64toi32_i32$1 = $19;
           i64toi32_i32$2 = 0;
           i64toi32_i32$3 = 1;
           if ((i64toi32_i32$1 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$2 | 0) | 0) {
            continue label$9
           }
           if ($11 >>> 0 < $4 >>> 0) {
            continue label$9
           }
           break label$3;
          }
          break label$9;
         };
         cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 312 | 0 | 0, $1 | 0);
         i64toi32_i32$3 = ($2 + 312 | 0) + 16 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $18 = i64toi32_i32$1;
         $18$hi = i64toi32_i32$0;
         i64toi32_i32$3 = $2;
         i64toi32_i32$0 = HEAP32[($2 + 320 | 0) >> 2] | 0;
         i64toi32_i32$1 = HEAP32[($2 + 324 | 0) >> 2] | 0;
         $20 = i64toi32_i32$0;
         $20$hi = i64toi32_i32$1;
         i64toi32_i32$3 = $2;
         i64toi32_i32$1 = HEAP32[($2 + 312 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($2 + 316 | 0) >> 2] | 0;
         i64toi32_i32$3 = i64toi32_i32$1;
         i64toi32_i32$1 = 0;
         i64toi32_i32$2 = 1;
         if ((i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
          break label$5
         }
         i64toi32_i32$3 = $18$hi;
         i64toi32_i32$0 = $2 + 240 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $18;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
         i64toi32_i32$3 = $20$hi;
         i64toi32_i32$0 = $2;
         HEAP32[(i64toi32_i32$0 + 232 | 0) >> 2] = $20;
         HEAP32[(i64toi32_i32$0 + 236 | 0) >> 2] = i64toi32_i32$3;
         if (($20 & 255 | 0 | 0) == (5 | 0)) {
          break label$3
         }
         HEAP32[($2 + 312 | 0) >> 2] = 0;
         core__panicking__assert_failed__h96d8431cc974b591(0 | 0, $2 + 232 | 0 | 0, 1070752 | 0, $2 + 312 | 0 | 0, 1071252 | 0);
         abort();
        }
        i64toi32_i32$2 = ($2 + 280 | 0) + 8 | 0;
        i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $257 = i64toi32_i32$3;
        i64toi32_i32$3 = ($2 + 168 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$3 >> 2] = $257;
        HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = ($2 + 280 | 0) + 16 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $264 = i64toi32_i32$0;
        i64toi32_i32$0 = ($2 + 168 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $264;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
        HEAP32[(($2 + 152 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 264 | 0) + 8 | 0) >> 2] | 0;
        HEAP32[($2 + 192 | 0) >> 2] = HEAP32[($2 + 304 | 0) >> 2] | 0;
        $69 = HEAPU8[($2 + 307 | 0) >> 0] | 0 | ((HEAPU8[($2 + 308 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 309 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 310 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 195 | 0) >> 0] = $69;
        HEAP8[($2 + 196 | 0) >> 0] = $69 >>> 8 | 0;
        HEAP8[($2 + 197 | 0) >> 0] = $69 >>> 16 | 0;
        HEAP8[($2 + 198 | 0) >> 0] = $69 >>> 24 | 0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$3 = HEAP32[($2 + 280 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[($2 + 284 | 0) >> 2] | 0;
        $280 = i64toi32_i32$3;
        i64toi32_i32$3 = $2;
        HEAP32[($2 + 168 | 0) >> 2] = $280;
        HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 264 | 0) >> 2] | 0;
        i64toi32_i32$3 = HEAP32[($2 + 268 | 0) >> 2] | 0;
        $283 = i64toi32_i32$0;
        i64toi32_i32$0 = $2;
        HEAP32[($2 + 152 | 0) >> 2] = $283;
        HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$3;
        if (($10 & 255 | 0 | 0) != (19 | 0)) {
         break label$4
        }
        break label$3;
       }
       i64toi32_i32$2 = $2 + 344 | 0;
       i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $291 = i64toi32_i32$3;
       i64toi32_i32$3 = $2 + 176 | 0;
       HEAP32[i64toi32_i32$3 >> 2] = $291;
       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = $2 + 352 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $297 = i64toi32_i32$0;
       i64toi32_i32$0 = ($2 + 168 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $297;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
       i64toi32_i32$2 = $2 + 336 | 0;
       i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $301 = i64toi32_i32$3;
       i64toi32_i32$3 = $2;
       HEAP32[($2 + 168 | 0) >> 2] = $301;
       HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$0;
       $10 = 2;
       i64toi32_i32$0 = $19$hi;
       $20 = $19;
       $20$hi = i64toi32_i32$0;
       break label$4;
      }
      i64toi32_i32$2 = $2 + 344 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $307 = i64toi32_i32$0;
      i64toi32_i32$0 = $2 + 176 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $307;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
      i64toi32_i32$2 = $2 + 352 | 0;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $313 = i64toi32_i32$3;
      i64toi32_i32$3 = ($2 + 168 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$3 >> 2] = $313;
      HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $2 + 336 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $317 = i64toi32_i32$0;
      i64toi32_i32$0 = $2;
      HEAP32[($2 + 168 | 0) >> 2] = $317;
      HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$3;
     }
     i64toi32_i32$3 = $18$hi;
     i64toi32_i32$0 = ($2 + 312 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $18;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$3 = $20$hi;
     i64toi32_i32$0 = ($2 + 312 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $20;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$2 = $2;
     i64toi32_i32$3 = HEAP32[($2 + 168 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 172 | 0) >> 2] | 0;
     $329 = i64toi32_i32$3;
     i64toi32_i32$3 = $2 + 336 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $329;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[($2 + 152 | 0) >> 2] | 0;
     i64toi32_i32$3 = HEAP32[($2 + 156 | 0) >> 2] | 0;
     $333 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 364 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $333;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$2 = ($2 + 168 | 0) + 8 | 0;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $339 = i64toi32_i32$3;
     i64toi32_i32$3 = $2 + 344 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $339;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = ($2 + 168 | 0) + 16 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $345 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 352 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $345;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
     HEAP32[($2 + 372 | 0) >> 2] = HEAP32[(($2 + 152 | 0) + 8 | 0) >> 2] | 0;
     HEAP8[($2 + 312 | 0) >> 0] = $10;
     $70 = HEAP32[($2 + 192 | 0) >> 2] | 0;
     HEAP8[($2 + 313 | 0) >> 0] = $70;
     HEAP8[($2 + 314 | 0) >> 0] = $70 >>> 8 | 0;
     HEAP8[($2 + 315 | 0) >> 0] = $70 >>> 16 | 0;
     HEAP8[($2 + 316 | 0) >> 0] = $70 >>> 24 | 0;
     $71 = HEAPU8[($2 + 195 | 0) >> 0] | 0 | ((HEAPU8[($2 + 196 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 197 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 198 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($2 + 316 | 0) >> 0] = $71;
     HEAP8[($2 + 317 | 0) >> 0] = $71 >>> 8 | 0;
     HEAP8[($2 + 318 | 0) >> 0] = $71 >>> 16 | 0;
     HEAP8[($2 + 319 | 0) >> 0] = $71 >>> 24 | 0;
     HEAP32[($2 + 360 | 0) >> 2] = $3;
     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($2 + 88 | 0 | 0, $2 + 312 | 0 | 0, 1071268 | 0, 9 | 0);
     $11 = HEAPU8[($2 + 88 | 0) >> 0] | 0;
     if (($11 | 0) != (19 | 0)) {
      break label$2
     }
    }
    i64toi32_i32$2 = $2;
    i64toi32_i32$3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $372 = i64toi32_i32$3;
    i64toi32_i32$3 = $0;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = $372;
    HEAP32[(i64toi32_i32$3 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[(i64toi32_i32$3 + 12 | 0) >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
    $10 = 0;
    break label$1;
   }
   $10 = 1;
   memcpy($2 + 25 | 0 | 0, $2 + 88 | 0 | 1 | 0 | 0, 63 | 0) | 0;
   HEAP8[($0 + 8 | 0) >> 0] = $11;
   memcpy($0 + 9 | 0 | 0, $2 + 25 | 0 | 0, 63 | 0) | 0;
   label$13 : {
    $11 = HEAP32[($2 + 16 | 0) >> 2] | 0;
    if (!$11) {
     break label$13
    }
    $3 = Math_imul($11, 80);
    $11 = (HEAP32[($2 + 8 | 0) >> 2] | 0) + 8 | 0;
    label$14 : while (1) {
     core__ptr__drop_in_place_cardano_serialization_lib__plutus__PlutusData___hfab843e66e0f9428_2($11 | 0);
     $11 = $11 + 80 | 0;
     $3 = $3 + -80 | 0;
     if ($3) {
      continue label$14
     }
     break label$14;
    };
   }
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h4c688d2d7e8a61fa($2 + 8 | 0 | 0);
  }
  HEAP32[$0 >> 2] = $10;
  global$0 = $2 + 400 | 0;
 }
 
 function alloc__slice__merge_sort__h1ac5e792f8b4e83b($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $4 = 0, $11 = 0, $10 = 0, $14 = 0, $3 = 0, $12 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $13 = 0, $9 = 0, i64toi32_i32$3 = 0, $15 = 0, $18$hi = 0, $18 = 0, $19 = 0, $19$hi = 0, $5 = 0, $6 = 0, $16 = 0, $7 = 0, $8 = 0, $55 = 0, $55$hi = 0, $17 = 0;
  $3 = global$0 - 192 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     if ($1 >>> 0 < 21 >>> 0) {
      break label$3
     }
     $4 = 0;
     alloc__raw_vec__RawVec_T_2cA___allocate_in__he0e25d30114cc7d7($3 + 24 | 0 | 0, $1 >>> 1 | 0 | 0, 0 | 0);
     HEAP32[($3 + 40 | 0) >> 2] = 0;
     HEAP32[($3 + 36 | 0) >> 2] = HEAP32[($3 + 28 | 0) >> 2] | 0;
     $5 = HEAP32[($3 + 24 | 0) >> 2] | 0;
     HEAP32[($3 + 32 | 0) >> 2] = $5;
     i64toi32_i32$1 = $3;
     i64toi32_i32$0 = 0;
     HEAP32[($3 + 52 | 0) >> 2] = 0;
     HEAP32[($3 + 56 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($3 + 48 | 0) >> 2] = HEAP32[(0 + 1069064 | 0) >> 2] | 0;
     $6 = $0 + -128 | 0;
     $7 = $0 + -256 | 0;
     $8 = $0 + -320 | 0;
     $9 = $1;
     label$4 : while (1) {
      label$5 : {
       label$6 : {
        $10 = $9;
        $11 = $10 + -1 | 0;
        if ($11) {
         break label$6
        }
        $9 = 0;
        $10 = 1;
        break label$5;
       }
       label$7 : {
        label$8 : {
         label$9 : {
          label$10 : {
           label$11 : {
            label$12 : {
             label$13 : {
              label$14 : {
               i64toi32_i32$2 = $0 + ($11 << 7 | 0) | 0;
               i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
               i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
               $55 = i64toi32_i32$0;
               $55$hi = i64toi32_i32$1;
               $12 = $10 + -2 | 0;
               i64toi32_i32$2 = $0 + ($12 << 7 | 0) | 0;
               i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
               i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
               $18 = i64toi32_i32$1;
               $18$hi = i64toi32_i32$0;
               i64toi32_i32$0 = $55$hi;
               i64toi32_i32$2 = $55;
               i64toi32_i32$1 = $18$hi;
               i64toi32_i32$3 = $18;
               if (i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0) {
                break label$14
               }
               $13 = $10 + -2 | 0;
               $14 = $8 + ($10 << 7 | 0) | 0;
               $9 = 0;
               $11 = 0;
               label$15 : while (1) {
                if (($13 | 0) == ($11 | 0)) {
                 break label$5
                }
                $11 = $11 + 1 | 0;
                i64toi32_i32$2 = $18$hi;
                i64toi32_i32$3 = $14;
                i64toi32_i32$2 = HEAP32[$14 >> 2] | 0;
                i64toi32_i32$0 = HEAP32[($14 + 4 | 0) >> 2] | 0;
                $19 = i64toi32_i32$2;
                $19$hi = i64toi32_i32$0;
                i64toi32_i32$0 = $18$hi;
                i64toi32_i32$3 = $18;
                i64toi32_i32$2 = $19$hi;
                i64toi32_i32$1 = $19;
                $12 = i64toi32_i32$0 >>> 0 > i64toi32_i32$2 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$3 >>> 0 >= i64toi32_i32$1 >>> 0 | 0) | 0;
                $14 = $14 + -128 | 0;
                i64toi32_i32$3 = i64toi32_i32$2;
                i64toi32_i32$3 = i64toi32_i32$2;
                $18 = i64toi32_i32$1;
                $18$hi = i64toi32_i32$2;
                if ($12) {
                 continue label$15
                }
                break label$15;
               };
               $15 = $11 + 1 | 0;
               $14 = ($11 ^ -1 | 0) + $10 | 0;
               break label$13;
              }
              $16 = $10 << 7 | 0;
              $13 = $7 + $16 | 0;
              $15 = 2;
              label$16 : {
               label$17 : while (1) {
                $9 = $15;
                $11 = $13;
                $14 = $12;
                if (!$14) {
                 break label$16
                }
                $13 = $11 + -128 | 0;
                $15 = $9 + 1 | 0;
                i64toi32_i32$3 = $18$hi;
                $12 = $14 + -1 | 0;
                i64toi32_i32$1 = $0 + ($12 << 7 | 0) | 0;
                i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] | 0;
                i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] | 0;
                $19 = i64toi32_i32$3;
                $19$hi = i64toi32_i32$0;
                i64toi32_i32$0 = $18$hi;
                i64toi32_i32$1 = $18;
                i64toi32_i32$3 = $19$hi;
                i64toi32_i32$2 = $19;
                $17 = i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0;
                i64toi32_i32$1 = i64toi32_i32$3;
                $18 = i64toi32_i32$2;
                $18$hi = i64toi32_i32$1;
                if ($17) {
                 continue label$17
                }
                break label$17;
               };
              }
              if ($10 >>> 0 < $14 >>> 0) {
               break label$12
              }
              if ($10 >>> 0 > $1 >>> 0) {
               break label$11
              }
              $15 = $10 - $14 | 0;
              if (!($15 >>> 1 | 0)) {
               break label$13
              }
              $13 = $9 >>> 1 | 0;
              $12 = $6 + $16 | 0;
              label$18 : while (1) {
               memcpy($3 + 64 | 0 | 0, $11 | 0, 128 | 0) | 0;
               $11 = (memmove($11 | 0, $12 | 0, 128 | 0) | 0) + 128 | 0;
               $12 = (memcpy($12 | 0, $3 + 64 | 0 | 0, 128 | 0) | 0) + -128 | 0;
               $13 = $13 + -1 | 0;
               if ($13) {
                continue label$18
               }
               break label$18;
              };
             }
             if (!$14) {
              break label$7
             }
             if ($15 >>> 0 > 9 >>> 0) {
              break label$7
             }
             $4 = 1 - $14 | 0;
             $11 = $6 + ($14 << 7 | 0) | 0;
             label$19 : while (1) {
              $9 = $14 + -1 | 0;
              if ($10 >>> 0 < $9 >>> 0) {
               break label$10
              }
              if ($10 >>> 0 > $1 >>> 0) {
               break label$9
              }
              $12 = $10 + $4 | 0;
              alloc__slice__insert_head__hb8fe7e978f3960f6($11 | 0, $12 | 0, $3 | 0);
              if (!$4) {
               break label$8
              }
              $4 = $4 + 1 | 0;
              $11 = $11 + -128 | 0;
              $14 = $9;
              if ($12 >>> 0 < 10 >>> 0) {
               continue label$19
              }
              break label$8;
             };
            }
            core__slice__index__slice_index_order_fail__h71e247dec3f266ff($14 | 0, $10 | 0, 1069172 | 0);
            abort();
           }
           core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($10 | 0, $1 | 0, 1069172 | 0);
           abort();
          }
          core__slice__index__slice_index_order_fail__h71e247dec3f266ff($14 + -1 | 0 | 0, $10 | 0, 1069188 | 0);
          abort();
         }
         core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($10 | 0, $1 | 0, 1069188 | 0);
         abort();
        }
        $10 = $10 - $9 | 0;
        $4 = HEAP32[($3 + 56 | 0) >> 2] | 0;
        break label$5;
       }
       $9 = $14;
       $10 = $15;
      }
      label$20 : {
       if ((HEAP32[($3 + 52 | 0) >> 2] | 0 | 0) != ($4 | 0)) {
        break label$20
       }
       alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hf5a91d7c63e29e55($3 + 48 | 0 | 0, $4 | 0, 1 | 0);
       $4 = HEAP32[($3 + 56 | 0) >> 2] | 0;
      }
      $4 = (HEAP32[($3 + 48 | 0) >> 2] | 0) + ($4 << 3 | 0) | 0;
      HEAP32[($4 + 4 | 0) >> 2] = $10;
      HEAP32[$4 >> 2] = $9;
      $4 = (HEAP32[($3 + 56 | 0) >> 2] | 0) + 1 | 0;
      HEAP32[($3 + 56 | 0) >> 2] = $4;
      label$21 : {
       if ($4 >>> 0 < 2 >>> 0) {
        break label$21
       }
       label$22 : {
        label$23 : {
         label$24 : {
          label$25 : {
           label$26 : while (1) {
            label$27 : {
             label$28 : {
              label$29 : {
               label$30 : {
                $10 = HEAP32[($3 + 48 | 0) >> 2] | 0;
                $11 = $10 + (($4 + -1 | 0) << 3 | 0) | 0;
                if (!(HEAP32[$11 >> 2] | 0)) {
                 break label$30
                }
                $15 = ($4 << 3 | 0) + $10 | 0;
                $13 = HEAP32[($15 + -12 | 0) >> 2] | 0;
                $14 = HEAP32[($11 + 4 | 0) >> 2] | 0;
                if ($13 >>> 0 <= $14 >>> 0) {
                 break label$30
                }
                label$31 : {
                 if ($4 >>> 0 >= 3 >>> 0) {
                  break label$31
                 }
                 $4 = 2;
                 break label$21;
                }
                $11 = $4 + -3 | 0;
                $12 = HEAP32[(($10 + ($11 << 3 | 0) | 0) + 4 | 0) >> 2] | 0;
                if ($12 >>> 0 <= ($14 + $13 | 0) >>> 0) {
                 break label$29
                }
                label$32 : {
                 if ($4 >>> 0 >= 4 >>> 0) {
                  break label$32
                 }
                 $4 = 3;
                 break label$21;
                }
                if ((HEAP32[($15 + -28 | 0) >> 2] | 0) >>> 0 > ($12 + $13 | 0) >>> 0) {
                 break label$21
                }
                break label$29;
               }
               if ($4 >>> 0 < 3 >>> 0) {
                break label$28
               }
               $14 = HEAP32[($11 + 4 | 0) >> 2] | 0;
               $11 = $4 + -3 | 0;
               $12 = HEAP32[(($10 + ($11 << 3 | 0) | 0) + 4 | 0) >> 2] | 0;
              }
              if ($12 >>> 0 < $14 >>> 0) {
               break label$27
              }
             }
             $11 = $4 + -2 | 0;
            }
            label$33 : {
             $14 = $11 + 1 | 0;
             if ($4 >>> 0 <= $14 >>> 0) {
              break label$33
             }
             if ($4 >>> 0 <= $11 >>> 0) {
              break label$25
             }
             $13 = $11 << 3 | 0;
             $4 = $10 + $13 | 0;
             $15 = HEAP32[($4 + 4 | 0) >> 2] | 0;
             $12 = $15 + (HEAP32[$4 >> 2] | 0) | 0;
             $10 = $10 + ($14 << 3 | 0) | 0;
             $4 = HEAP32[$10 >> 2] | 0;
             if ($12 >>> 0 < $4 >>> 0) {
              break label$24
             }
             if ($12 >>> 0 > $1 >>> 0) {
              break label$23
             }
             $10 = HEAP32[($10 + 4 | 0) >> 2] | 0;
             alloc__slice__merge__h4a8708c943dcbe36($0 + ($4 << 7 | 0) | 0 | 0, $12 - $4 | 0 | 0, $10 | 0, $5 | 0, $3 | 0);
             $12 = HEAP32[($3 + 56 | 0) >> 2] | 0;
             if ($12 >>> 0 <= $11 >>> 0) {
              break label$22
             }
             $11 = (HEAP32[($3 + 48 | 0) >> 2] | 0) + $13 | 0;
             HEAP32[($11 + 4 | 0) >> 2] = $15 + $10 | 0;
             HEAP32[$11 >> 2] = $4;
             alloc__vec__Vec_T_2cA___remove__hf0ee37bb0b07dbd1($3 + 16 | 0 | 0, $3 + 48 | 0 | 0, $14 | 0);
             $4 = HEAP32[($3 + 56 | 0) >> 2] | 0;
             if ($4 >>> 0 > 1 >>> 0) {
              continue label$26
             }
             break label$21;
            }
            break label$26;
           };
           core__panicking__panic_bounds_check__h808b524af17640b1($14 | 0, $4 | 0, 1069204 | 0);
           abort();
          }
          core__panicking__panic_bounds_check__h808b524af17640b1($11 | 0, $4 | 0, 1069220 | 0);
          abort();
         }
         core__slice__index__slice_index_order_fail__h71e247dec3f266ff($4 | 0, $12 | 0, 1069236 | 0);
         abort();
        }
        core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($12 | 0, $1 | 0, 1069236 | 0);
        abort();
       }
       core__panicking__panic_bounds_check__h808b524af17640b1($11 | 0, $12 | 0, 1069252 | 0);
       abort();
      }
      if ($9) {
       continue label$4
      }
      break label$4;
     };
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h28ea22ae705f999b($3 + 48 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h5107e2b13c386680($3 + 32 | 0 | 0);
     break label$2;
    }
    if ($1 >>> 0 < 2 >>> 0) {
     break label$2
    }
    core__iter__adapters__rev__Rev_T___new__h11ed92efd1d68010($3 + 8 | 0 | 0, 0 | 0, $1 + -1 | 0 | 0);
    $12 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    $14 = HEAP32[($3 + 12 | 0) >> 2] | 0;
    if ($12 >>> 0 >= $14 >>> 0) {
     break label$2
    }
    $4 = ($1 - $14 | 0) + 1 | 0;
    $11 = (($14 << 7 | 0) + $0 | 0) + -128 | 0;
    label$34 : while (1) {
     $10 = $14 + -1 | 0;
     if ($10 >>> 0 > $1 >>> 0) {
      break label$1
     }
     alloc__slice__insert_head__hb8fe7e978f3960f6($11 | 0, $4 | 0, $3 | 0);
     $4 = $4 + 1 | 0;
     $11 = $11 + -128 | 0;
     $14 = $10;
     if ($12 >>> 0 < $10 >>> 0) {
      continue label$34
     }
     break label$34;
    };
   }
   global$0 = $3 + 192 | 0;
   return;
  }
  core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($14 + -1 | 0 | 0, $1 | 0, 1069156 | 0);
  abort();
 }
 
 function alloc__slice__merge_sort__h6d9049cfeabc5e2d($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $4 = 0, $11 = 0, $10 = 0, $14 = 0, $3 = 0, $12 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $13 = 0, $9 = 0, i64toi32_i32$3 = 0, $15 = 0, $18$hi = 0, $18 = 0, $19 = 0, $19$hi = 0, $5 = 0, $6 = 0, $16 = 0, $7 = 0, $8 = 0, $55 = 0, $55$hi = 0, $17 = 0;
  $3 = global$0 - 192 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     if ($1 >>> 0 < 21 >>> 0) {
      break label$3
     }
     $4 = 0;
     alloc__raw_vec__RawVec_T_2cA___allocate_in__he0e25d30114cc7d7($3 + 24 | 0 | 0, $1 >>> 1 | 0 | 0, 0 | 0);
     HEAP32[($3 + 40 | 0) >> 2] = 0;
     HEAP32[($3 + 36 | 0) >> 2] = HEAP32[($3 + 28 | 0) >> 2] | 0;
     $5 = HEAP32[($3 + 24 | 0) >> 2] | 0;
     HEAP32[($3 + 32 | 0) >> 2] = $5;
     i64toi32_i32$1 = $3;
     i64toi32_i32$0 = 0;
     HEAP32[($3 + 52 | 0) >> 2] = 0;
     HEAP32[($3 + 56 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($3 + 48 | 0) >> 2] = HEAP32[(0 + 1069064 | 0) >> 2] | 0;
     $6 = $0 + -128 | 0;
     $7 = $0 + -256 | 0;
     $8 = $0 + -320 | 0;
     $9 = $1;
     label$4 : while (1) {
      label$5 : {
       label$6 : {
        $10 = $9;
        $11 = $10 + -1 | 0;
        if ($11) {
         break label$6
        }
        $9 = 0;
        $10 = 1;
        break label$5;
       }
       label$7 : {
        label$8 : {
         label$9 : {
          label$10 : {
           label$11 : {
            label$12 : {
             label$13 : {
              label$14 : {
               i64toi32_i32$2 = $0 + ($11 << 7 | 0) | 0;
               i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
               i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
               $55 = i64toi32_i32$0;
               $55$hi = i64toi32_i32$1;
               $12 = $10 + -2 | 0;
               i64toi32_i32$2 = $0 + ($12 << 7 | 0) | 0;
               i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
               i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
               $18 = i64toi32_i32$1;
               $18$hi = i64toi32_i32$0;
               i64toi32_i32$0 = $55$hi;
               i64toi32_i32$2 = $55;
               i64toi32_i32$1 = $18$hi;
               i64toi32_i32$3 = $18;
               if (i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0) {
                break label$14
               }
               $13 = $10 + -2 | 0;
               $14 = $8 + ($10 << 7 | 0) | 0;
               $9 = 0;
               $11 = 0;
               label$15 : while (1) {
                if (($13 | 0) == ($11 | 0)) {
                 break label$5
                }
                $11 = $11 + 1 | 0;
                i64toi32_i32$2 = $18$hi;
                i64toi32_i32$3 = $14;
                i64toi32_i32$2 = HEAP32[$14 >> 2] | 0;
                i64toi32_i32$0 = HEAP32[($14 + 4 | 0) >> 2] | 0;
                $19 = i64toi32_i32$2;
                $19$hi = i64toi32_i32$0;
                i64toi32_i32$0 = $18$hi;
                i64toi32_i32$3 = $18;
                i64toi32_i32$2 = $19$hi;
                i64toi32_i32$1 = $19;
                $12 = i64toi32_i32$0 >>> 0 > i64toi32_i32$2 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$3 >>> 0 >= i64toi32_i32$1 >>> 0 | 0) | 0;
                $14 = $14 + -128 | 0;
                i64toi32_i32$3 = i64toi32_i32$2;
                i64toi32_i32$3 = i64toi32_i32$2;
                $18 = i64toi32_i32$1;
                $18$hi = i64toi32_i32$2;
                if ($12) {
                 continue label$15
                }
                break label$15;
               };
               $15 = $11 + 1 | 0;
               $14 = ($11 ^ -1 | 0) + $10 | 0;
               break label$13;
              }
              $16 = $10 << 7 | 0;
              $13 = $7 + $16 | 0;
              $15 = 2;
              label$16 : {
               label$17 : while (1) {
                $9 = $15;
                $11 = $13;
                $14 = $12;
                if (!$14) {
                 break label$16
                }
                $13 = $11 + -128 | 0;
                $15 = $9 + 1 | 0;
                i64toi32_i32$3 = $18$hi;
                $12 = $14 + -1 | 0;
                i64toi32_i32$1 = $0 + ($12 << 7 | 0) | 0;
                i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] | 0;
                i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] | 0;
                $19 = i64toi32_i32$3;
                $19$hi = i64toi32_i32$0;
                i64toi32_i32$0 = $18$hi;
                i64toi32_i32$1 = $18;
                i64toi32_i32$3 = $19$hi;
                i64toi32_i32$2 = $19;
                $17 = i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0;
                i64toi32_i32$1 = i64toi32_i32$3;
                $18 = i64toi32_i32$2;
                $18$hi = i64toi32_i32$1;
                if ($17) {
                 continue label$17
                }
                break label$17;
               };
              }
              if ($10 >>> 0 < $14 >>> 0) {
               break label$12
              }
              if ($10 >>> 0 > $1 >>> 0) {
               break label$11
              }
              $15 = $10 - $14 | 0;
              if (!($15 >>> 1 | 0)) {
               break label$13
              }
              $13 = $9 >>> 1 | 0;
              $12 = $6 + $16 | 0;
              label$18 : while (1) {
               memcpy($3 + 64 | 0 | 0, $11 | 0, 128 | 0) | 0;
               $11 = (memmove($11 | 0, $12 | 0, 128 | 0) | 0) + 128 | 0;
               $12 = (memcpy($12 | 0, $3 + 64 | 0 | 0, 128 | 0) | 0) + -128 | 0;
               $13 = $13 + -1 | 0;
               if ($13) {
                continue label$18
               }
               break label$18;
              };
             }
             if (!$14) {
              break label$7
             }
             if ($15 >>> 0 > 9 >>> 0) {
              break label$7
             }
             $4 = 1 - $14 | 0;
             $11 = $6 + ($14 << 7 | 0) | 0;
             label$19 : while (1) {
              $9 = $14 + -1 | 0;
              if ($10 >>> 0 < $9 >>> 0) {
               break label$10
              }
              if ($10 >>> 0 > $1 >>> 0) {
               break label$9
              }
              $12 = $10 + $4 | 0;
              alloc__slice__insert_head__heaf6bc8fe9c35c8c($11 | 0, $12 | 0, $3 | 0);
              if (!$4) {
               break label$8
              }
              $4 = $4 + 1 | 0;
              $11 = $11 + -128 | 0;
              $14 = $9;
              if ($12 >>> 0 < 10 >>> 0) {
               continue label$19
              }
              break label$8;
             };
            }
            core__slice__index__slice_index_order_fail__h71e247dec3f266ff($14 | 0, $10 | 0, 1069172 | 0);
            abort();
           }
           core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($10 | 0, $1 | 0, 1069172 | 0);
           abort();
          }
          core__slice__index__slice_index_order_fail__h71e247dec3f266ff($14 + -1 | 0 | 0, $10 | 0, 1069188 | 0);
          abort();
         }
         core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($10 | 0, $1 | 0, 1069188 | 0);
         abort();
        }
        $10 = $10 - $9 | 0;
        $4 = HEAP32[($3 + 56 | 0) >> 2] | 0;
        break label$5;
       }
       $9 = $14;
       $10 = $15;
      }
      label$20 : {
       if ((HEAP32[($3 + 52 | 0) >> 2] | 0 | 0) != ($4 | 0)) {
        break label$20
       }
       alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hf5a91d7c63e29e55($3 + 48 | 0 | 0, $4 | 0, 1 | 0);
       $4 = HEAP32[($3 + 56 | 0) >> 2] | 0;
      }
      $4 = (HEAP32[($3 + 48 | 0) >> 2] | 0) + ($4 << 3 | 0) | 0;
      HEAP32[($4 + 4 | 0) >> 2] = $10;
      HEAP32[$4 >> 2] = $9;
      $4 = (HEAP32[($3 + 56 | 0) >> 2] | 0) + 1 | 0;
      HEAP32[($3 + 56 | 0) >> 2] = $4;
      label$21 : {
       if ($4 >>> 0 < 2 >>> 0) {
        break label$21
       }
       label$22 : {
        label$23 : {
         label$24 : {
          label$25 : {
           label$26 : while (1) {
            label$27 : {
             label$28 : {
              label$29 : {
               label$30 : {
                $10 = HEAP32[($3 + 48 | 0) >> 2] | 0;
                $11 = $10 + (($4 + -1 | 0) << 3 | 0) | 0;
                if (!(HEAP32[$11 >> 2] | 0)) {
                 break label$30
                }
                $15 = ($4 << 3 | 0) + $10 | 0;
                $13 = HEAP32[($15 + -12 | 0) >> 2] | 0;
                $14 = HEAP32[($11 + 4 | 0) >> 2] | 0;
                if ($13 >>> 0 <= $14 >>> 0) {
                 break label$30
                }
                label$31 : {
                 if ($4 >>> 0 >= 3 >>> 0) {
                  break label$31
                 }
                 $4 = 2;
                 break label$21;
                }
                $11 = $4 + -3 | 0;
                $12 = HEAP32[(($10 + ($11 << 3 | 0) | 0) + 4 | 0) >> 2] | 0;
                if ($12 >>> 0 <= ($14 + $13 | 0) >>> 0) {
                 break label$29
                }
                label$32 : {
                 if ($4 >>> 0 >= 4 >>> 0) {
                  break label$32
                 }
                 $4 = 3;
                 break label$21;
                }
                if ((HEAP32[($15 + -28 | 0) >> 2] | 0) >>> 0 > ($12 + $13 | 0) >>> 0) {
                 break label$21
                }
                break label$29;
               }
               if ($4 >>> 0 < 3 >>> 0) {
                break label$28
               }
               $14 = HEAP32[($11 + 4 | 0) >> 2] | 0;
               $11 = $4 + -3 | 0;
               $12 = HEAP32[(($10 + ($11 << 3 | 0) | 0) + 4 | 0) >> 2] | 0;
              }
              if ($12 >>> 0 < $14 >>> 0) {
               break label$27
              }
             }
             $11 = $4 + -2 | 0;
            }
            label$33 : {
             $14 = $11 + 1 | 0;
             if ($4 >>> 0 <= $14 >>> 0) {
              break label$33
             }
             if ($4 >>> 0 <= $11 >>> 0) {
              break label$25
             }
             $13 = $11 << 3 | 0;
             $4 = $10 + $13 | 0;
             $15 = HEAP32[($4 + 4 | 0) >> 2] | 0;
             $12 = $15 + (HEAP32[$4 >> 2] | 0) | 0;
             $10 = $10 + ($14 << 3 | 0) | 0;
             $4 = HEAP32[$10 >> 2] | 0;
             if ($12 >>> 0 < $4 >>> 0) {
              break label$24
             }
             if ($12 >>> 0 > $1 >>> 0) {
              break label$23
             }
             $10 = HEAP32[($10 + 4 | 0) >> 2] | 0;
             alloc__slice__merge__h7d79a9efe92f6589($0 + ($4 << 7 | 0) | 0 | 0, $12 - $4 | 0 | 0, $10 | 0, $5 | 0, $3 | 0);
             $12 = HEAP32[($3 + 56 | 0) >> 2] | 0;
             if ($12 >>> 0 <= $11 >>> 0) {
              break label$22
             }
             $11 = (HEAP32[($3 + 48 | 0) >> 2] | 0) + $13 | 0;
             HEAP32[($11 + 4 | 0) >> 2] = $15 + $10 | 0;
             HEAP32[$11 >> 2] = $4;
             alloc__vec__Vec_T_2cA___remove__hf0ee37bb0b07dbd1($3 + 16 | 0 | 0, $3 + 48 | 0 | 0, $14 | 0);
             $4 = HEAP32[($3 + 56 | 0) >> 2] | 0;
             if ($4 >>> 0 > 1 >>> 0) {
              continue label$26
             }
             break label$21;
            }
            break label$26;
           };
           core__panicking__panic_bounds_check__h808b524af17640b1($14 | 0, $4 | 0, 1069204 | 0);
           abort();
          }
          core__panicking__panic_bounds_check__h808b524af17640b1($11 | 0, $4 | 0, 1069220 | 0);
          abort();
         }
         core__slice__index__slice_index_order_fail__h71e247dec3f266ff($4 | 0, $12 | 0, 1069236 | 0);
         abort();
        }
        core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($12 | 0, $1 | 0, 1069236 | 0);
        abort();
       }
       core__panicking__panic_bounds_check__h808b524af17640b1($11 | 0, $12 | 0, 1069252 | 0);
       abort();
      }
      if ($9) {
       continue label$4
      }
      break label$4;
     };
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h28ea22ae705f999b($3 + 48 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h5107e2b13c386680($3 + 32 | 0 | 0);
     break label$2;
    }
    if ($1 >>> 0 < 2 >>> 0) {
     break label$2
    }
    core__iter__adapters__rev__Rev_T___new__h11ed92efd1d68010($3 + 8 | 0 | 0, 0 | 0, $1 + -1 | 0 | 0);
    $12 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    $14 = HEAP32[($3 + 12 | 0) >> 2] | 0;
    if ($12 >>> 0 >= $14 >>> 0) {
     break label$2
    }
    $4 = ($1 - $14 | 0) + 1 | 0;
    $11 = (($14 << 7 | 0) + $0 | 0) + -128 | 0;
    label$34 : while (1) {
     $10 = $14 + -1 | 0;
     if ($10 >>> 0 > $1 >>> 0) {
      break label$1
     }
     alloc__slice__insert_head__heaf6bc8fe9c35c8c($11 | 0, $4 | 0, $3 | 0);
     $4 = $4 + 1 | 0;
     $11 = $11 + -128 | 0;
     $14 = $10;
     if ($12 >>> 0 < $10 >>> 0) {
      continue label$34
     }
     break label$34;
    };
   }
   global$0 = $3 + 192 | 0;
   return;
  }
  core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($14 + -1 | 0 | 0, $1 | 0, 1069156 | 0);
  abort();
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__MintAssets___deserialize__h1b812f4a046f3f71($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, $5 = 0, $6 = 0, $5$hi = 0, $6$hi = 0, $3 = 0, $4 = 0, $4$hi = 0, $7$hi = 0, $56 = 0, $7 = 0, $57 = 0, $58 = 0, $59 = 0, $60 = 0, $61 = 0, $62 = 0, $63 = 0, $64 = 0, $65 = 0, $66 = 0, $67 = 0, $68 = 0, $69 = 0, $70 = 0, $134 = 0, $140 = 0, $149 = 0, $153 = 0, $155 = 0, $155$hi = 0, $157$hi = 0, $179 = 0, $185 = 0, $189 = 0, $192 = 0, $192$hi = 0, $195 = 0, $195$hi = 0, $199$hi = 0, $201$hi = 0, $213 = 0, $219 = 0, $223 = 0, $229 = 0, $234 = 0, $244 = 0, $248 = 0, $251 = 0, $251$hi = 0, $254 = 0, $254$hi = 0, $258$hi = 0, $260$hi = 0, $276 = 0, $282 = 0, $286 = 0, $309 = 0, $313 = 0, $315 = 0, $319 = 0, $327 = 0, $333 = 0, $356 = 0;
  $2 = global$0 - 336 | 0;
  global$0 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 44 | 0) >> 2] = 0;
  HEAP32[($2 + 48 | 0) >> 2] = i64toi32_i32$0;
  cbor_event__de__Deserializer_R___map__h7c2a4e830d885a05($2 + 264 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = ($2 + 264 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 272 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 276 | 0) >> 2] | 0;
  $5 = i64toi32_i32$1;
  $5$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           label$10 : {
            i64toi32_i32$2 = $2;
            i64toi32_i32$0 = HEAP32[($2 + 264 | 0) >> 2] | 0;
            i64toi32_i32$1 = HEAP32[($2 + 268 | 0) >> 2] | 0;
            i64toi32_i32$2 = i64toi32_i32$0;
            i64toi32_i32$0 = 0;
            i64toi32_i32$3 = 1;
            if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
             break label$10
            }
            i64toi32_i32$2 = $4$hi;
            $3 = $4;
            label$11 : {
             i64toi32_i32$2 = $5$hi;
             i64toi32_i32$3 = $5;
             i64toi32_i32$1 = 0;
             i64toi32_i32$0 = 1;
             if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
              break label$11
             }
             if (!$3) {
              break label$3
             }
            }
            label$12 : {
             label$13 : {
              label$14 : while (1) {
               std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 32 | 0 | 0, $1 | 0);
               label$15 : {
                if (HEAP32[($2 + 36 | 0) >> 2] | 0) {
                 break label$15
                }
                i64toi32_i32$3 = 0;
                $4 = 0;
                $4$hi = i64toi32_i32$3;
                i64toi32_i32$3 = 0;
                $5 = 8;
                $5$hi = i64toi32_i32$3;
                break label$7;
               }
               label$16 : {
                if ((($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[($2 + 32 | 0) >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) == (7 | 0)) {
                 break label$16
                }
                cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__AssetName___deserialize__hed130337b055988b($2 + 264 | 0 | 0, $1 | 0);
                if ((HEAP32[($2 + 264 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                 break label$9
                }
                i64toi32_i32$0 = $2 + 279 | 0;
                i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0;
                i64toi32_i32$2 = 0;
                HEAP8[($2 + 251 | 0) >> 0] = i64toi32_i32$3;
                i64toi32_i32$0 = $2 + 277 | 0;
                i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
                i64toi32_i32$3 = 0;
                $57 = $2 + 249 | 0;
                HEAP8[$57 >> 0] = i64toi32_i32$2;
                HEAP8[($57 + 1 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
                i64toi32_i32$0 = $2;
                i64toi32_i32$3 = HEAPU8[($2 + 273 | 0) >> 0] | 0 | ((HEAPU8[($2 + 274 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 275 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 276 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                i64toi32_i32$2 = 0;
                HEAP8[($2 + 245 | 0) >> 0] = i64toi32_i32$3;
                HEAP8[($2 + 246 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
                HEAP8[($2 + 247 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
                HEAP8[($2 + 248 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
                HEAP8[($2 + 244 | 0) >> 0] = HEAPU8[($2 + 272 | 0) >> 0] | 0;
                HEAP32[($2 + 240 | 0) >> 2] = HEAP32[($2 + 268 | 0) >> 2] | 0;
                $cardano_serialization_lib__utils__Int_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h5b6b41ff800f0b26($2 + 264 | 0 | 0, $1 | 0);
                i64toi32_i32$0 = ($2 + 264 | 0) + 16 | 0;
                i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
                i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
                $6 = i64toi32_i32$2;
                $6$hi = i64toi32_i32$3;
                i64toi32_i32$0 = $2;
                i64toi32_i32$3 = HEAP32[($2 + 272 | 0) >> 2] | 0;
                i64toi32_i32$2 = HEAP32[($2 + 276 | 0) >> 2] | 0;
                $7 = i64toi32_i32$3;
                $7$hi = i64toi32_i32$2;
                i64toi32_i32$0 = $2;
                i64toi32_i32$2 = HEAP32[($2 + 264 | 0) >> 2] | 0;
                i64toi32_i32$3 = HEAP32[($2 + 268 | 0) >> 2] | 0;
                i64toi32_i32$0 = i64toi32_i32$2;
                i64toi32_i32$2 = 0;
                i64toi32_i32$1 = 1;
                if ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) | 0) {
                 break label$13
                }
                $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($2 + 264 | 0 | 0, $2 + 240 | 0 | 0);
                i64toi32_i32$0 = $7$hi;
                i64toi32_i32$0 = $6$hi;
                i64toi32_i32$0 = $7$hi;
                i64toi32_i32$3 = $6$hi;
                alloc__collections__btree__map__BTreeMap_K_2cV___insert__h9d3a28073b5db74d($2 + 8 | 0 | 0, $2 + 40 | 0 | 0, $2 + 264 | 0 | 0, $7 | 0, i64toi32_i32$0 | 0, $6 | 0, i64toi32_i32$3 | 0);
                i64toi32_i32$1 = $2;
                i64toi32_i32$3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
                i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
                i64toi32_i32$1 = i64toi32_i32$3;
                i64toi32_i32$3 = 0;
                i64toi32_i32$2 = 1;
                if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) | 0) {
                 break label$12
                }
                $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 240 | 0 | 0);
                $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 240 | 0 | 0);
                i64toi32_i32$1 = $5$hi;
                i64toi32_i32$2 = $5;
                i64toi32_i32$0 = 0;
                i64toi32_i32$3 = 1;
                if ((i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$0 | 0) | 0) {
                 continue label$14
                }
                if ((HEAP32[($2 + 48 | 0) >> 2] | 0) >>> 0 < $3 >>> 0) {
                 continue label$14
                }
                break label$3;
               }
               break label$14;
              };
              cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 264 | 0 | 0, $1 | 0);
              i64toi32_i32$3 = ($2 + 264 | 0) + 16 | 0;
              i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
              i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
              $4 = i64toi32_i32$2;
              $4$hi = i64toi32_i32$1;
              i64toi32_i32$3 = $2;
              i64toi32_i32$1 = HEAP32[($2 + 272 | 0) >> 2] | 0;
              i64toi32_i32$2 = HEAP32[($2 + 276 | 0) >> 2] | 0;
              $5 = i64toi32_i32$1;
              $5$hi = i64toi32_i32$2;
              i64toi32_i32$3 = $2;
              i64toi32_i32$2 = HEAP32[($2 + 264 | 0) >> 2] | 0;
              i64toi32_i32$1 = HEAP32[($2 + 268 | 0) >> 2] | 0;
              i64toi32_i32$3 = i64toi32_i32$2;
              i64toi32_i32$2 = 0;
              i64toi32_i32$0 = 1;
              if ((i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) | 0) {
               break label$8
              }
              i64toi32_i32$3 = $4$hi;
              i64toi32_i32$1 = $2 + 232 | 0;
              HEAP32[i64toi32_i32$1 >> 2] = $4;
              HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
              i64toi32_i32$3 = $5$hi;
              i64toi32_i32$1 = $2;
              HEAP32[($2 + 224 | 0) >> 2] = $5;
              HEAP32[($2 + 228 | 0) >> 2] = i64toi32_i32$3;
              if (($5 & 255 | 0 | 0) == (5 | 0)) {
               break label$3
              }
              HEAP32[($2 + 264 | 0) >> 2] = 0;
              core__panicking__assert_failed__h96d8431cc974b591(0 | 0, $2 + 224 | 0 | 0, 1050312 | 0, $2 + 264 | 0 | 0, 1053060 | 0);
              abort();
             }
             i64toi32_i32$0 = $2 + 304 | 0;
             i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
             i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
             $134 = i64toi32_i32$3;
             i64toi32_i32$3 = ($2 + 200 | 0) + 8 | 0;
             HEAP32[i64toi32_i32$3 >> 2] = $134;
             HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
             i64toi32_i32$0 = $2 + 312 | 0;
             i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
             i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
             $140 = i64toi32_i32$1;
             i64toi32_i32$1 = ($2 + 200 | 0) + 16 | 0;
             HEAP32[i64toi32_i32$1 >> 2] = $140;
             HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
             HEAP32[(($2 + 184 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 332 | 0) >> 2] | 0;
             i64toi32_i32$0 = $2;
             i64toi32_i32$3 = HEAP32[($2 + 324 | 0) >> 2] | 0;
             i64toi32_i32$1 = HEAP32[($2 + 328 | 0) >> 2] | 0;
             $149 = i64toi32_i32$3;
             i64toi32_i32$3 = $2;
             HEAP32[($2 + 184 | 0) >> 2] = $149;
             HEAP32[($2 + 188 | 0) >> 2] = i64toi32_i32$1;
             i64toi32_i32$0 = $2 + 296 | 0;
             i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
             i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
             $153 = i64toi32_i32$1;
             i64toi32_i32$1 = $2;
             HEAP32[($2 + 200 | 0) >> 2] = $153;
             HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$3;
             i64toi32_i32$3 = $7$hi;
             i64toi32_i32$0 = $7;
             i64toi32_i32$1 = 0;
             i64toi32_i32$2 = 8;
             i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
             if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
              i64toi32_i32$1 = 0;
              $58 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
             } else {
              i64toi32_i32$1 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
              $58 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
             }
             $155 = $58;
             $155$hi = i64toi32_i32$1;
             i64toi32_i32$1 = $6$hi;
             i64toi32_i32$3 = $6;
             i64toi32_i32$0 = 0;
             i64toi32_i32$2 = 56;
             i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
             if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
              i64toi32_i32$0 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
              $59 = 0;
             } else {
              i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
              $59 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
             }
             $157$hi = i64toi32_i32$0;
             i64toi32_i32$0 = $155$hi;
             i64toi32_i32$1 = $155;
             i64toi32_i32$3 = $157$hi;
             i64toi32_i32$2 = $59;
             i64toi32_i32$3 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
             $5 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
             $5$hi = i64toi32_i32$3;
             i64toi32_i32$3 = $6$hi;
             i64toi32_i32$0 = $6;
             i64toi32_i32$1 = 0;
             i64toi32_i32$2 = 8;
             i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
             if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
              i64toi32_i32$1 = 0;
              $60 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
             } else {
              i64toi32_i32$1 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
              $60 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
             }
             $6 = $60;
             $6$hi = i64toi32_i32$1;
             i64toi32_i32$3 = $2 + 288 | 0;
             i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
             i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
             $4 = i64toi32_i32$1;
             $4$hi = i64toi32_i32$0;
             $3 = HEAP32[($2 + 320 | 0) >> 2] | 0;
             i64toi32_i32$0 = $7$hi;
             $1 = $7;
             break label$6;
            }
            alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($2 + 276 | 0 | 0, 1051628 | 0, 33 | 0);
            $3 = 0;
            HEAP32[(($2 + 264 | 0) + 8 | 0) >> 2] = 0;
            i64toi32_i32$3 = $2 + 296 | 0;
            i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
            i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
            $179 = i64toi32_i32$0;
            i64toi32_i32$0 = ($2 + 200 | 0) + 8 | 0;
            HEAP32[i64toi32_i32$0 >> 2] = $179;
            HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
            i64toi32_i32$3 = $2 + 304 | 0;
            i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
            i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
            $185 = i64toi32_i32$1;
            i64toi32_i32$1 = ($2 + 200 | 0) + 16 | 0;
            HEAP32[i64toi32_i32$1 >> 2] = $185;
            HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
            i64toi32_i32$3 = $2 + 288 | 0;
            i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
            i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
            $189 = i64toi32_i32$0;
            i64toi32_i32$0 = $2;
            HEAP32[($2 + 200 | 0) >> 2] = $189;
            HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$1;
            i64toi32_i32$3 = $2 + 273 | 0;
            i64toi32_i32$1 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            i64toi32_i32$0 = 0;
            $192 = i64toi32_i32$1;
            $192$hi = i64toi32_i32$0;
            i64toi32_i32$3 = $2 + 277 | 0;
            i64toi32_i32$0 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
            i64toi32_i32$1 = 0;
            $195 = i64toi32_i32$0;
            $195$hi = i64toi32_i32$1;
            i64toi32_i32$3 = $2 + 279 | 0;
            i64toi32_i32$1 = HEAPU8[i64toi32_i32$3 >> 0] | 0;
            i64toi32_i32$0 = 0;
            i64toi32_i32$3 = i64toi32_i32$1;
            i64toi32_i32$1 = 0;
            i64toi32_i32$2 = 16;
            i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
            if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
             i64toi32_i32$1 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
             $61 = 0;
            } else {
             i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
             $61 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
            }
            $199$hi = i64toi32_i32$1;
            i64toi32_i32$1 = $195$hi;
            i64toi32_i32$0 = $195;
            i64toi32_i32$3 = $199$hi;
            i64toi32_i32$2 = $61;
            i64toi32_i32$3 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
            i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
            i64toi32_i32$0 = 0;
            i64toi32_i32$2 = 32;
            i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
            if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
             i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
             $62 = 0;
            } else {
             i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$4 | 0) | 0;
             $62 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
            }
            $201$hi = i64toi32_i32$0;
            i64toi32_i32$0 = $192$hi;
            i64toi32_i32$3 = $192;
            i64toi32_i32$1 = $201$hi;
            i64toi32_i32$2 = $62;
            i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
            $6 = i64toi32_i32$3 | i64toi32_i32$2 | 0;
            $6$hi = i64toi32_i32$1;
            i64toi32_i32$0 = ($2 + 264 | 0) + 16 | 0;
            i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
            i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
            $4 = i64toi32_i32$1;
            $4$hi = i64toi32_i32$3;
            i64toi32_i32$0 = $2;
            i64toi32_i32$3 = HEAPU8[($2 + 265 | 0) >> 0] | 0 | ((HEAPU8[($2 + 266 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 267 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 268 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            i64toi32_i32$1 = HEAPU8[($2 + 269 | 0) >> 0] | 0 | ((HEAPU8[($2 + 270 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 271 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 272 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            $5 = i64toi32_i32$3;
            $5$hi = i64toi32_i32$1;
            $1 = 4;
            break label$6;
           }
           i64toi32_i32$0 = $2 + 296 | 0;
           i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $213 = i64toi32_i32$1;
           i64toi32_i32$1 = $2 + 208 | 0;
           HEAP32[i64toi32_i32$1 >> 2] = $213;
           HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
           i64toi32_i32$0 = $2 + 304 | 0;
           i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $219 = i64toi32_i32$3;
           i64toi32_i32$3 = ($2 + 200 | 0) + 16 | 0;
           HEAP32[i64toi32_i32$3 >> 2] = $219;
           HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
           i64toi32_i32$0 = $2 + 288 | 0;
           i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $223 = i64toi32_i32$1;
           i64toi32_i32$1 = $2;
           HEAP32[($2 + 200 | 0) >> 2] = $223;
           HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$3;
           break label$7;
          }
          i64toi32_i32$0 = $2 + 304 | 0;
          i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
          $229 = i64toi32_i32$3;
          i64toi32_i32$3 = ($2 + 200 | 0) + 8 | 0;
          HEAP32[i64toi32_i32$3 >> 2] = $229;
          HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
          i64toi32_i32$0 = $2 + 312 | 0;
          i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
          i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
          $234 = i64toi32_i32$1;
          i64toi32_i32$1 = $2 + 216 | 0;
          HEAP32[i64toi32_i32$1 >> 2] = $234;
          HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
          HEAP32[(($2 + 184 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 332 | 0) >> 2] | 0;
          i64toi32_i32$0 = $2 + 296 | 0;
          i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
          $244 = i64toi32_i32$3;
          i64toi32_i32$3 = $2;
          HEAP32[($2 + 200 | 0) >> 2] = $244;
          HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$1;
          i64toi32_i32$0 = $2 + 324 | 0;
          i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
          i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
          $248 = i64toi32_i32$1;
          i64toi32_i32$1 = $2;
          HEAP32[($2 + 184 | 0) >> 2] = $248;
          HEAP32[($2 + 188 | 0) >> 2] = i64toi32_i32$3;
          i64toi32_i32$0 = $2 + 281 | 0;
          i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          i64toi32_i32$1 = 0;
          $251 = i64toi32_i32$3;
          $251$hi = i64toi32_i32$1;
          i64toi32_i32$0 = $2 + 285 | 0;
          i64toi32_i32$1 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
          i64toi32_i32$3 = 0;
          $254 = i64toi32_i32$1;
          $254$hi = i64toi32_i32$3;
          i64toi32_i32$0 = $2 + 287 | 0;
          i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0;
          i64toi32_i32$1 = 0;
          i64toi32_i32$0 = i64toi32_i32$3;
          i64toi32_i32$3 = 0;
          i64toi32_i32$2 = 16;
          i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
          if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
           i64toi32_i32$3 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
           $63 = 0;
          } else {
           i64toi32_i32$3 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
           $63 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
          }
          $258$hi = i64toi32_i32$3;
          i64toi32_i32$3 = $254$hi;
          i64toi32_i32$1 = $254;
          i64toi32_i32$0 = $258$hi;
          i64toi32_i32$2 = $63;
          i64toi32_i32$0 = i64toi32_i32$3 | i64toi32_i32$0 | 0;
          i64toi32_i32$3 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
          i64toi32_i32$1 = 0;
          i64toi32_i32$2 = 32;
          i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
          if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
           i64toi32_i32$1 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
           $64 = 0;
          } else {
           i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
           $64 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
          }
          $260$hi = i64toi32_i32$1;
          i64toi32_i32$1 = $251$hi;
          i64toi32_i32$0 = $251;
          i64toi32_i32$3 = $260$hi;
          i64toi32_i32$2 = $64;
          i64toi32_i32$3 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
          $6 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
          $6$hi = i64toi32_i32$3;
          i64toi32_i32$1 = $2 + 288 | 0;
          i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
          $4 = i64toi32_i32$3;
          $4$hi = i64toi32_i32$0;
          $3 = HEAP32[($2 + 320 | 0) >> 2] | 0;
          i64toi32_i32$1 = $2;
          i64toi32_i32$0 = HEAPU8[($2 + 273 | 0) >> 0] | 0 | ((HEAPU8[($2 + 274 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 275 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 276 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          i64toi32_i32$3 = HEAPU8[($2 + 277 | 0) >> 0] | 0 | ((HEAPU8[($2 + 278 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 279 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 280 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          $5 = i64toi32_i32$0;
          $5$hi = i64toi32_i32$3;
          $1 = HEAPU8[($2 + 272 | 0) >> 0] | 0;
          break label$5;
         }
         i64toi32_i32$1 = $2 + 296 | 0;
         i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
         $276 = i64toi32_i32$3;
         i64toi32_i32$3 = $2 + 208 | 0;
         HEAP32[i64toi32_i32$3 >> 2] = $276;
         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$1 = $2 + 304 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
         $282 = i64toi32_i32$0;
         i64toi32_i32$0 = ($2 + 200 | 0) + 16 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $282;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
         i64toi32_i32$1 = $2 + 288 | 0;
         i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
         $286 = i64toi32_i32$3;
         i64toi32_i32$3 = $2;
         HEAP32[($2 + 200 | 0) >> 2] = $286;
         HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$0;
        }
        i64toi32_i32$0 = $5$hi;
        i64toi32_i32$1 = $5;
        i64toi32_i32$3 = 0;
        i64toi32_i32$2 = 8;
        i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
         i64toi32_i32$3 = 0;
         $65 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
        } else {
         i64toi32_i32$3 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
         $65 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
        }
        $6 = $65;
        $6$hi = i64toi32_i32$3;
        i64toi32_i32$3 = $5$hi;
        i64toi32_i32$0 = $5;
        i64toi32_i32$1 = 0;
        i64toi32_i32$2 = 56;
        i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
         i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
         $66 = 0;
        } else {
         i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$4 | 0) | 0;
         $66 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        }
        $5 = $66;
        $5$hi = i64toi32_i32$1;
        $3 = 0;
        $1 = 2;
        break label$4;
       }
       $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 240 | 0 | 0);
       $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 240 | 0 | 0);
      }
      if (($1 & 255 | 0 | 0) == (19 | 0)) {
       break label$3
      }
     }
     i64toi32_i32$1 = $6$hi;
     $56 = ($2 + 264 | 0) + 9 | 0;
     HEAP8[$56 >> 0] = $6;
     HEAP8[($56 + 1 | 0) >> 0] = $6 >>> 8 | 0;
     HEAP8[($56 + 2 | 0) >> 0] = $6 >>> 16 | 0;
     HEAP8[($56 + 3 | 0) >> 0] = $6 >>> 24 | 0;
     i64toi32_i32$1 = $4$hi;
     i64toi32_i32$0 = ($2 + 264 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $4;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$3 = $2;
     i64toi32_i32$1 = HEAP32[($2 + 200 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 204 | 0) >> 2] | 0;
     $309 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 288 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $309;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$3 = $2;
     i64toi32_i32$0 = HEAP32[($2 + 184 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 188 | 0) >> 2] | 0;
     $313 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 316 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $313;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     $315 = $2 + 279 | 0;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$0 = 0;
     i64toi32_i32$2 = 48;
     i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
      i64toi32_i32$0 = 0;
      $67 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
     } else {
      i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
      $67 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$4 | 0) | 0;
     }
     HEAP8[$315 >> 0] = $67;
     $319 = $2 + 277 | 0;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$1 = $6;
     i64toi32_i32$3 = 0;
     i64toi32_i32$2 = 32;
     i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
      i64toi32_i32$3 = 0;
      $68 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
     } else {
      i64toi32_i32$3 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
      $68 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
     }
     $69 = $319;
     $70 = $68;
     HEAP8[$69 >> 0] = $70;
     HEAP8[($69 + 1 | 0) >> 0] = $70 >>> 8 | 0;
     i64toi32_i32$0 = ($2 + 200 | 0) + 8 | 0;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $327 = i64toi32_i32$3;
     i64toi32_i32$3 = $2 + 296 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $327;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$0 = ($2 + 200 | 0) + 16 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $333 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 304 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $333;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
     HEAP32[($2 + 324 | 0) >> 2] = HEAP32[(($2 + 184 | 0) + 8 | 0) >> 2] | 0;
     i64toi32_i32$3 = $5$hi;
     i64toi32_i32$1 = $2;
     HEAP8[($2 + 265 | 0) >> 0] = $5;
     HEAP8[($2 + 266 | 0) >> 0] = $5 >>> 8 | 0;
     HEAP8[($2 + 267 | 0) >> 0] = $5 >>> 16 | 0;
     HEAP8[($2 + 268 | 0) >> 0] = $5 >>> 24 | 0;
     HEAP8[($2 + 269 | 0) >> 0] = i64toi32_i32$3;
     HEAP8[($2 + 270 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
     HEAP8[($2 + 271 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
     HEAP8[($2 + 272 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
     HEAP8[($2 + 264 | 0) >> 0] = $1;
     HEAP32[($2 + 312 | 0) >> 2] = $3;
     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($2 + 120 | 0 | 0, $2 + 264 | 0 | 0, 1053076 | 0, 10 | 0);
     $3 = HEAPU8[($2 + 120 | 0) >> 0] | 0;
     if (($3 | 0) != (19 | 0)) {
      break label$2
     }
    }
    i64toi32_i32$0 = $2;
    i64toi32_i32$3 = HEAP32[($2 + 40 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 44 | 0) >> 2] | 0;
    $356 = i64toi32_i32$3;
    i64toi32_i32$3 = $0;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = $356;
    HEAP32[(i64toi32_i32$3 + 8 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(i64toi32_i32$3 + 12 | 0) >> 2] = HEAP32[($2 + 48 | 0) >> 2] | 0;
    $1 = 0;
    break label$1;
   }
   $1 = 1;
   memcpy($2 + 57 | 0 | 0, $2 + 120 | 0 | 1 | 0 | 0, 63 | 0) | 0;
   HEAP8[($0 + 8 | 0) >> 0] = $3;
   memcpy($0 + 9 | 0 | 0, $2 + 57 | 0 | 0, 63 | 0) | 0;
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h0265580a5be10b66($2 + 40 | 0 | 0);
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 336 | 0;
 }
 
 function cardano_serialization_lib__tx_builder__TransactionBuilder__build_and_size__h9094c1e3b4ead95a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, $3 = 0, $66 = 0, $67 = 0, $68 = 0, $69 = 0, $4 = 0, $5 = 0, $6 = 0, $7 = 0, $8 = 0, $9 = 0, $10 = 0, $11 = 0, $12 = 0, $13 = 0, $14 = 0, $15 = 0, $16 = 0, $70 = 0, $71 = 0, $72 = 0, $73 = 0, $17 = 0, $17$hi = 0, $48 = 0, $55 = 0, $58 = 0, $18 = 0, $18$hi = 0, $19 = 0, $19$hi = 0, $20 = 0, $20$hi = 0, $21 = 0, $21$hi = 0, $117 = 0, $122 = 0, $127 = 0, $131 = 0, $175 = 0, $178 = 0, $181 = 0, $194 = 0, $202 = 0, $210 = 0, $218 = 0, $225 = 0, $233 = 0, $241 = 0, $244 = 0, $247 = 0, $250 = 0, $281 = 0, $286 = 0, $289 = 0, $292 = 0, $295 = 0, $311 = 0, $315 = 0, $319 = 0, $323 = 0, $330 = 0, $333 = 0, $337 = 0, $341 = 0, $345 = 0, $349 = 0;
  $2 = global$0 - 1152 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      i64toi32_i32$2 = $1;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 256 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 260 | 0) >> 2] | 0;
      if (!(i64toi32_i32$0 | i64toi32_i32$1 | 0)) {
       break label$4
      }
      i64toi32_i32$2 = $1 + 264 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $17 = i64toi32_i32$1;
      $17$hi = i64toi32_i32$0;
      alloc__collections__btree__map__BTreeMap_K_2cV___iter__h721110b568622f84($2 + 296 | 0 | 0, $1 + 160 | 0 | 0);
      HEAP32[(($2 + 720 | 0) + 24 | 0) >> 2] = HEAP32[(($2 + 296 | 0) + 24 | 0) >> 2] | 0;
      i64toi32_i32$2 = ($2 + 296 | 0) + 16 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $48 = i64toi32_i32$0;
      i64toi32_i32$0 = ($2 + 720 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $48;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = ($2 + 296 | 0) + 8 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $55 = i64toi32_i32$1;
      i64toi32_i32$1 = ($2 + 720 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $55;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $2;
      i64toi32_i32$0 = HEAP32[($2 + 296 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($2 + 300 | 0) >> 2] | 0;
      $58 = i64toi32_i32$0;
      i64toi32_i32$0 = $2;
      HEAP32[($2 + 720 | 0) >> 2] = $58;
      HEAP32[($2 + 724 | 0) >> 2] = i64toi32_i32$1;
      $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__he4e09da31a8bd115($2 + 200 | 0 | 0, $2 + 720 | 0 | 0);
      $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h699bb0f3db607312($2 + 216 | 0 | 0, $1 + 416 | 0 | 0);
      i64toi32_i32$2 = $1 + 280 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $18 = i64toi32_i32$1;
      $18$hi = i64toi32_i32$0;
      i64toi32_i32$2 = $1;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 272 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 276 | 0) >> 2] | 0;
      $19 = i64toi32_i32$0;
      $19$hi = i64toi32_i32$1;
      label$5 : {
       label$6 : {
        if (HEAP32[(i64toi32_i32$2 + 428 | 0) >> 2] | 0) {
         break label$6
        }
        HEAP32[($2 + 232 | 0) >> 2] = 0;
        break label$5;
       }
       $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h965baa5031061a2e($2 + 232 | 0 | 0, $1 + 428 | 0 | 0);
      }
      label$7 : {
       label$8 : {
        if (HEAP32[($1 + 308 | 0) >> 2] | 0) {
         break label$8
        }
        HEAP32[($2 + 740 | 0) >> 2] = 0;
        break label$7;
       }
       $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h8cac34049618832f($2 + 720 | 0 | 0, $1 + 288 | 0 | 0);
      }
      $3 = 0;
      $4 = 0;
      label$9 : {
       i64toi32_i32$2 = $1;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 328 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 332 | 0) >> 2] | 0;
       i64toi32_i32$2 = i64toi32_i32$1;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 1;
       if ((i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | 0) {
        break label$9
       }
       cardano_serialization_lib__utils__hash_auxiliary_data__h70df64c2596a1cad($2 + 248 | 0 | 0, $1 + 336 | 0 | 0);
       $4 = 1;
      }
      i64toi32_i32$3 = $1 + 408 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $20 = i64toi32_i32$2;
      $20$hi = i64toi32_i32$0;
      i64toi32_i32$3 = $1;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 400 | 0) >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 404 | 0) >> 2] | 0;
      $21 = i64toi32_i32$0;
      $21$hi = i64toi32_i32$2;
      label$10 : {
       if ((HEAP32[(i64toi32_i32$3 + 440 | 0) >> 2] | 0 | 0) != (1 | 0)) {
        break label$10
       }
       $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h3d696390b8f8d3c9($2 + 280 | 0 | 4 | 0 | 0, $1 + 444 | 0 | 0);
       $3 = 1;
      }
      HEAP32[($2 + 280 | 0) >> 2] = $3;
      $3 = 0;
      label$11 : {
       if ((HEAPU8[($1 + 480 | 0) >> 0] | 0 | 0) != (1 | 0)) {
        break label$11
       }
       i64toi32_i32$3 = $1 + 505 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $117 = i64toi32_i32$2;
       i64toi32_i32$2 = $2 + 320 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $117;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$3 = $1 + 497 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $122 = i64toi32_i32$0;
       i64toi32_i32$0 = $2 + 312 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $122;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$3 = $1 + 489 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $127 = i64toi32_i32$2;
       i64toi32_i32$2 = $2 + 304 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $127;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$3 = $1 + 481 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $131 = i64toi32_i32$0;
       i64toi32_i32$0 = $2;
       HEAP32[($2 + 296 | 0) >> 2] = $131;
       HEAP32[($2 + 300 | 0) >> 2] = i64toi32_i32$2;
       $3 = 1;
      }
      cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__inputs_option__hcc9a5caf03e37d78($2 + 80 | 0 | 0, $1 + 176 | 0 | 0);
      if (HEAP32[($1 + 476 | 0) >> 2] | 0) {
       break label$3
      }
      HEAP32[($2 + 64 | 0) >> 2] = 0;
      break label$2;
     }
     $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1065612 | 0, 17 | 0) | 0 | 0) | 0;
     HEAP32[$0 >> 2] = 1;
     HEAP32[($0 + 4 | 0) >> 2] = $1;
     break label$1;
    }
    $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h25db889dc58a550d($2 + 64 | 0 | 0, $1 + 468 | 0 | 0);
   }
   $5 = ($2 + 144 | 0) + 8 | 0;
   HEAP32[$5 >> 2] = HEAP32[(($2 + 200 | 0) + 8 | 0) >> 2] | 0;
   $6 = ($2 + 128 | 0) + 8 | 0;
   HEAP32[$6 >> 2] = HEAP32[(($2 + 216 | 0) + 8 | 0) >> 2] | 0;
   $7 = ($2 + 112 | 0) + 8 | 0;
   HEAP32[$7 >> 2] = HEAP32[(($2 + 232 | 0) + 8 | 0) >> 2] | 0;
   i64toi32_i32$3 = $2;
   i64toi32_i32$2 = HEAP32[($2 + 200 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 204 | 0) >> 2] | 0;
   $175 = i64toi32_i32$2;
   i64toi32_i32$2 = $2;
   HEAP32[($2 + 144 | 0) >> 2] = $175;
   HEAP32[($2 + 148 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$3 = $2;
   i64toi32_i32$0 = HEAP32[($2 + 216 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($2 + 220 | 0) >> 2] | 0;
   $178 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   HEAP32[($2 + 128 | 0) >> 2] = $178;
   HEAP32[($2 + 132 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$3 = $2;
   i64toi32_i32$2 = HEAP32[($2 + 232 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 236 | 0) >> 2] | 0;
   $181 = i64toi32_i32$2;
   i64toi32_i32$2 = $2;
   HEAP32[($2 + 112 | 0) >> 2] = $181;
   HEAP32[($2 + 116 | 0) >> 2] = i64toi32_i32$0;
   memcpy($2 + 160 | 0 | 0, $2 + 720 | 0 | 0, 40 | 0) | 0;
   $8 = ($2 + 32 | 0) + 24 | 0;
   i64toi32_i32$3 = ($2 + 248 | 0) + 24 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$2 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $194 = i64toi32_i32$0;
   i64toi32_i32$0 = $8;
   HEAP32[i64toi32_i32$0 >> 2] = $194;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   $9 = ($2 + 32 | 0) + 16 | 0;
   i64toi32_i32$3 = ($2 + 248 | 0) + 16 | 0;
   i64toi32_i32$2 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $202 = i64toi32_i32$2;
   i64toi32_i32$2 = $9;
   HEAP32[i64toi32_i32$2 >> 2] = $202;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
   $10 = ($2 + 32 | 0) + 8 | 0;
   i64toi32_i32$3 = ($2 + 248 | 0) + 8 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$2 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $210 = i64toi32_i32$0;
   i64toi32_i32$0 = $10;
   HEAP32[i64toi32_i32$0 >> 2] = $210;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   $11 = ($2 + 96 | 0) + 8 | 0;
   i64toi32_i32$3 = ($2 + 280 | 0) + 8 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $218 = i64toi32_i32$2;
   i64toi32_i32$2 = $11;
   HEAP32[i64toi32_i32$2 >> 2] = $218;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
   $12 = $2 + 8 | 0;
   i64toi32_i32$3 = ($2 + 296 | 0) + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $225 = i64toi32_i32$0;
   i64toi32_i32$0 = $12;
   HEAP32[i64toi32_i32$0 >> 2] = $225;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   $13 = $2 + 16 | 0;
   $14 = ($2 + 296 | 0) + 16 | 0;
   i64toi32_i32$3 = $14;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $233 = i64toi32_i32$2;
   i64toi32_i32$2 = $13;
   HEAP32[i64toi32_i32$2 >> 2] = $233;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
   $15 = $2 + 24 | 0;
   $16 = ($2 + 296 | 0) + 24 | 0;
   i64toi32_i32$3 = $16;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $241 = i64toi32_i32$0;
   i64toi32_i32$0 = $15;
   HEAP32[i64toi32_i32$0 >> 2] = $241;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$3 = $2;
   i64toi32_i32$2 = HEAPU8[($2 + 248 | 0) >> 0] | 0 | ((HEAPU8[($2 + 249 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 250 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 251 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[($2 + 252 | 0) >> 0] | 0 | ((HEAPU8[($2 + 253 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 254 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 255 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $244 = i64toi32_i32$2;
   i64toi32_i32$2 = $2;
   HEAP32[($2 + 32 | 0) >> 2] = $244;
   HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$3 = $2;
   i64toi32_i32$0 = HEAP32[($2 + 280 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($2 + 284 | 0) >> 2] | 0;
   $247 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   HEAP32[($2 + 96 | 0) >> 2] = $247;
   HEAP32[($2 + 100 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$3 = $2;
   i64toi32_i32$2 = HEAP32[($2 + 296 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 300 | 0) >> 2] | 0;
   $250 = i64toi32_i32$2;
   i64toi32_i32$2 = $2;
   HEAP32[$2 >> 2] = $250;
   HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $18$hi;
   i64toi32_i32$2 = $14;
   HEAP32[i64toi32_i32$2 >> 2] = $18;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $19$hi;
   i64toi32_i32$2 = $2;
   HEAP32[($2 + 304 | 0) >> 2] = $19;
   HEAP32[($2 + 308 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $17$hi;
   i64toi32_i32$2 = $2;
   HEAP32[($2 + 296 | 0) >> 2] = $17;
   HEAP32[($2 + 300 | 0) >> 2] = i64toi32_i32$0;
   memcpy($16 | 0, $2 + 160 | 0 | 0, 40 | 0) | 0;
   i64toi32_i32$0 = $20$hi;
   i64toi32_i32$2 = $2 + 416 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $20;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($2 + 380 | 0) >> 2] = 0;
   HEAP32[($2 + 432 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
   HEAP32[($2 + 444 | 0) >> 2] = HEAP32[$6 >> 2] | 0;
   HEAP32[($2 + 456 | 0) >> 2] = HEAP32[$7 >> 2] | 0;
   i64toi32_i32$3 = $11;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $281 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 468 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $281;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$2 = $21$hi;
   i64toi32_i32$0 = $2;
   HEAP32[($2 + 408 | 0) >> 2] = $21;
   HEAP32[($2 + 412 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$3 = $2;
   i64toi32_i32$2 = HEAP32[($2 + 144 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 148 | 0) >> 2] | 0;
   $286 = i64toi32_i32$2;
   i64toi32_i32$2 = $2;
   HEAP32[($2 + 424 | 0) >> 2] = $286;
   HEAP32[($2 + 428 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$3 = $2;
   i64toi32_i32$0 = HEAP32[($2 + 128 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($2 + 132 | 0) >> 2] | 0;
   $289 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   HEAP32[($2 + 436 | 0) >> 2] = $289;
   HEAP32[($2 + 440 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$3 = $2;
   i64toi32_i32$2 = HEAP32[($2 + 112 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 116 | 0) >> 2] | 0;
   $292 = i64toi32_i32$2;
   i64toi32_i32$2 = $2;
   HEAP32[($2 + 448 | 0) >> 2] = $292;
   HEAP32[($2 + 452 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$3 = $2;
   i64toi32_i32$0 = HEAP32[($2 + 96 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($2 + 100 | 0) >> 2] | 0;
   $295 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   HEAP32[($2 + 460 | 0) >> 2] = $295;
   HEAP32[($2 + 464 | 0) >> 2] = i64toi32_i32$2;
   HEAP32[($2 + 484 | 0) >> 2] = HEAP32[(($2 + 80 | 0) + 8 | 0) >> 2] | 0;
   HEAP32[($2 + 496 | 0) >> 2] = HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] | 0;
   i64toi32_i32$3 = $2;
   i64toi32_i32$2 = HEAP32[($2 + 32 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 36 | 0) >> 2] | 0;
   $311 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 501 | 0;
   $66 = $311;
   HEAP8[i64toi32_i32$2 >> 0] = $66;
   HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $66 >>> 8 | 0;
   HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $66 >>> 16 | 0;
   HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $66 >>> 24 | 0;
   HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$3 = $10;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $315 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 509 | 0;
   $67 = $315;
   HEAP8[i64toi32_i32$0 >> 0] = $67;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $67 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $67 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $67 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$2;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
   i64toi32_i32$3 = $9;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $319 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 517 | 0;
   $68 = $319;
   HEAP8[i64toi32_i32$2 >> 0] = $68;
   HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $68 >>> 8 | 0;
   HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $68 >>> 16 | 0;
   HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $68 >>> 24 | 0;
   HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$3 = $8;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $323 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 525 | 0;
   $69 = $323;
   HEAP8[i64toi32_i32$0 >> 0] = $69;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $69 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $69 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $69 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$2;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
   HEAP8[($2 + 500 | 0) >> 0] = $4;
   HEAP8[($2 + 533 | 0) >> 0] = $3;
   i64toi32_i32$3 = $2;
   i64toi32_i32$2 = HEAP32[($2 + 80 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 84 | 0) >> 2] | 0;
   $330 = i64toi32_i32$2;
   i64toi32_i32$2 = $2;
   HEAP32[($2 + 476 | 0) >> 2] = $330;
   HEAP32[($2 + 480 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$3 = $2;
   i64toi32_i32$0 = HEAP32[($2 + 64 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($2 + 68 | 0) >> 2] | 0;
   $333 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   HEAP32[($2 + 488 | 0) >> 2] = $333;
   HEAP32[($2 + 492 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$3 = $15;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $337 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 558 | 0;
   $70 = $337;
   HEAP16[i64toi32_i32$2 >> 1] = $70;
   HEAP16[(i64toi32_i32$2 + 2 | 0) >> 1] = $70 >>> 16 | 0;
   HEAP16[(i64toi32_i32$2 + 4 | 0) >> 1] = i64toi32_i32$0;
   HEAP16[(i64toi32_i32$2 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
   i64toi32_i32$3 = $13;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $341 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 550 | 0;
   $71 = $341;
   HEAP16[i64toi32_i32$0 >> 1] = $71;
   HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $71 >>> 16 | 0;
   HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$2;
   HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$2 >>> 16 | 0;
   i64toi32_i32$3 = $12;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $345 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 542 | 0;
   $72 = $345;
   HEAP16[i64toi32_i32$2 >> 1] = $72;
   HEAP16[(i64toi32_i32$2 + 2 | 0) >> 1] = $72 >>> 16 | 0;
   HEAP16[(i64toi32_i32$2 + 4 | 0) >> 1] = i64toi32_i32$0;
   HEAP16[(i64toi32_i32$2 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
   i64toi32_i32$3 = $2;
   i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $349 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 534 | 0;
   $73 = $349;
   HEAP16[i64toi32_i32$0 >> 1] = $73;
   HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $73 >>> 16 | 0;
   HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$2;
   HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$2 >>> 16 | 0;
   HEAP8[($2 + 566 | 0) >> 0] = 2;
   cardano_serialization_lib__tx_builder__fake_full_tx__h790258922a10b915($2 + 720 | 0 | 0, $1 | 0, $2 + 296 | 0 | 0);
   label$12 : {
    if ((HEAP32[($2 + 720 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$12
    }
    memcpy($2 + 296 | 0 | 0, ($2 + 720 | 0) + 8 | 0 | 0, 424 | 0) | 0;
    cardano_serialization_lib__Transaction__to_bytes__h3fc3ee53046075af($2 + 720 | 0 | 0, $2 + 296 | 0 | 0);
    $1 = HEAP32[($2 + 728 | 0) >> 2] | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 720 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 720 | 0 | 0);
    memcpy($0 + 8 | 0 | 0, $2 + 296 | 0 | 0, 272 | 0) | 0;
    HEAP32[$0 >> 2] = 0;
    HEAP32[($0 + 280 | 0) >> 2] = $1;
    core__ptr__drop_in_place_cardano_serialization_lib__TransactionWitnessSet___h7d278d9502f6471a($2 + 640 | 0 | 0);
    i64toi32_i32$3 = $2;
    i64toi32_i32$2 = HEAP32[($2 + 568 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 572 | 0) >> 2] | 0;
    if (!(i64toi32_i32$2 | i64toi32_i32$0 | 0)) {
     break label$1
    }
    core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__metadata__GeneralTransactionMetadata____h37a091753d7f028f_1(($2 + 296 | 0) + 280 | 0 | 0);
    core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__NativeScripts____hdd7d461255ec800a_2($2 + 616 | 0 | 0);
    core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__plutus__PlutusScripts____h6be1d55eac328b7f_2($2 + 628 | 0 | 0);
    break label$1;
   }
   $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($2 + 724 | 0) >> 2] | 0 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
  }
  global$0 = $2 + 1152 | 0;
 }
 
 function cryptoxide__blake2b__Blake2b__new__h7b5a594785d7b8da($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $4 = 0, $4$hi = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $25 = 0, $26 = 0, $27 = 0, $3 = 0, $210 = 0, $218 = 0, $224 = 0, $230 = 0, $239 = 0, $243 = 0, $263 = 0, $269 = 0, $273 = 0;
  $2 = global$0;
  $3 = $2;
  $2 = ($2 - 448 | 0) & -32 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           label$10 : {
            label$11 : {
             label$12 : {
              label$13 : {
               label$14 : {
                label$15 : {
                 label$16 : {
                  label$17 : {
                   if (($1 | 0) > (35 | 0)) {
                    break label$17
                   }
                   label$18 : {
                    switch ($1 + -1 | 0 | 0) {
                    case 2:
                    case 4:
                    case 5:
                    case 6:
                     break label$1;
                    case 7:
                     break label$13;
                    case 3:
                     break label$14;
                    case 1:
                     break label$15;
                    case 0:
                     break label$16;
                    default:
                     break label$18;
                    };
                   }
                   switch ($1 + -24 | 0 | 0) {
                   case 1:
                   case 2:
                   case 3:
                   case 5:
                   case 6:
                   case 7:
                    break label$1;
                   case 4:
                    break label$10;
                   case 0:
                    break label$11;
                   case 9:
                    break label$8;
                   case 8:
                    break label$9;
                   default:
                    break label$12;
                   };
                  }
                  label$19 : {
                   switch ($1 + -36 | 0 | 0) {
                   case 1:
                   case 2:
                   case 3:
                    break label$1;
                   case 4:
                    break label$6;
                   case 0:
                    break label$7;
                   default:
                    break label$19;
                   };
                  }
                  label$20 : {
                   switch ($1 + -44 | 0 | 0) {
                   case 1:
                   case 2:
                   case 3:
                    break label$1;
                   case 4:
                    break label$4;
                   case 0:
                    break label$5;
                   default:
                    break label$20;
                   };
                  }
                  if (($1 | 0) == (64 | 0)) {
                   break label$3
                  }
                  break label$1;
                 }
                 i64toi32_i32$1 = $2;
                 i64toi32_i32$0 = 0;
                 HEAP32[($2 + 192 | 0) >> 2] = 0;
                 HEAP32[($2 + 196 | 0) >> 2] = i64toi32_i32$0;
                 i64toi32_i32$1 = $2;
                 i64toi32_i32$0 = 0;
                 HEAP32[($2 + 200 | 0) >> 2] = 0;
                 HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$0;
                 $1 = 0;
                 memset($2 + 304 | 0 | 0, 0 | 0, 132 | 0) | 0;
                 memcpy($2 + 232 | 0 | 0, 1137376 | 0, 56 | 0) | 0;
                 memcpy($2 + 44 | 0 | 0, $2 + 288 | 0 | 0, 148 | 0) | 0;
                 i64toi32_i32$0 = 1779033703;
                 $4 = -222443255;
                 $4$hi = i64toi32_i32$0;
                 break label$2;
                }
                i64toi32_i32$1 = $2;
                i64toi32_i32$0 = 0;
                HEAP32[($2 + 192 | 0) >> 2] = 0;
                HEAP32[($2 + 196 | 0) >> 2] = i64toi32_i32$0;
                i64toi32_i32$1 = $2;
                i64toi32_i32$0 = 0;
                HEAP32[($2 + 200 | 0) >> 2] = 0;
                HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$0;
                memset($2 + 304 | 0 | 0, 0 | 0, 132 | 0) | 0;
                memcpy($2 + 232 | 0 | 0, 1137376 | 0, 56 | 0) | 0;
                memcpy($2 + 44 | 0 | 0, $2 + 288 | 0 | 0, 148 | 0) | 0;
                $1 = 1;
                i64toi32_i32$0 = 1779033703;
                $4 = -222443254;
                $4$hi = i64toi32_i32$0;
                break label$2;
               }
               i64toi32_i32$1 = $2;
               i64toi32_i32$0 = 0;
               HEAP32[($2 + 192 | 0) >> 2] = 0;
               HEAP32[($2 + 196 | 0) >> 2] = i64toi32_i32$0;
               i64toi32_i32$1 = $2;
               i64toi32_i32$0 = 0;
               HEAP32[($2 + 200 | 0) >> 2] = 0;
               HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$0;
               memset($2 + 304 | 0 | 0, 0 | 0, 132 | 0) | 0;
               memcpy($2 + 232 | 0 | 0, 1137376 | 0, 56 | 0) | 0;
               memcpy($2 + 44 | 0 | 0, $2 + 288 | 0 | 0, 148 | 0) | 0;
               $1 = 2;
               i64toi32_i32$0 = 1779033703;
               $4 = -222443252;
               $4$hi = i64toi32_i32$0;
               break label$2;
              }
              i64toi32_i32$1 = $2;
              i64toi32_i32$0 = 0;
              HEAP32[($2 + 192 | 0) >> 2] = 0;
              HEAP32[($2 + 196 | 0) >> 2] = i64toi32_i32$0;
              i64toi32_i32$1 = $2;
              i64toi32_i32$0 = 0;
              HEAP32[($2 + 200 | 0) >> 2] = 0;
              HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$0;
              memset($2 + 304 | 0 | 0, 0 | 0, 132 | 0) | 0;
              memcpy($2 + 232 | 0 | 0, 1137376 | 0, 56 | 0) | 0;
              memcpy($2 + 44 | 0 | 0, $2 + 288 | 0 | 0, 148 | 0) | 0;
              $1 = 3;
              i64toi32_i32$0 = 1779033703;
              $4 = -222443264;
              $4$hi = i64toi32_i32$0;
              break label$2;
             }
             if (($1 | 0) != (16 | 0)) {
              break label$1
             }
             i64toi32_i32$1 = $2;
             i64toi32_i32$0 = 0;
             HEAP32[($2 + 192 | 0) >> 2] = 0;
             HEAP32[($2 + 196 | 0) >> 2] = i64toi32_i32$0;
             i64toi32_i32$1 = $2;
             i64toi32_i32$0 = 0;
             HEAP32[($2 + 200 | 0) >> 2] = 0;
             HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$0;
             memset(($2 + 288 | 0) + 16 | 0 | 0, 0 | 0, 132 | 0) | 0;
             memcpy($2 + 232 | 0 | 0, 1137376 | 0, 56 | 0) | 0;
             memcpy($2 + 44 | 0 | 0, $2 + 288 | 0 | 0, 148 | 0) | 0;
             $1 = 4;
             i64toi32_i32$0 = 1779033703;
             $4 = -222443240;
             $4$hi = i64toi32_i32$0;
             break label$2;
            }
            i64toi32_i32$1 = $2;
            i64toi32_i32$0 = 0;
            HEAP32[($2 + 192 | 0) >> 2] = 0;
            HEAP32[($2 + 196 | 0) >> 2] = i64toi32_i32$0;
            i64toi32_i32$1 = $2;
            i64toi32_i32$0 = 0;
            HEAP32[($2 + 200 | 0) >> 2] = 0;
            HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$0;
            memset($2 + 304 | 0 | 0, 0 | 0, 132 | 0) | 0;
            memcpy($2 + 232 | 0 | 0, 1137376 | 0, 56 | 0) | 0;
            memcpy($2 + 44 | 0 | 0, $2 + 288 | 0 | 0, 148 | 0) | 0;
            $1 = 5;
            i64toi32_i32$0 = 1779033703;
            $4 = -222443240;
            $4$hi = i64toi32_i32$0;
            break label$2;
           }
           i64toi32_i32$1 = $2;
           i64toi32_i32$0 = 0;
           HEAP32[($2 + 192 | 0) >> 2] = 0;
           HEAP32[($2 + 196 | 0) >> 2] = i64toi32_i32$0;
           i64toi32_i32$1 = $2;
           i64toi32_i32$0 = 0;
           HEAP32[($2 + 200 | 0) >> 2] = 0;
           HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$0;
           memset($2 + 304 | 0 | 0, 0 | 0, 132 | 0) | 0;
           memcpy($2 + 232 | 0 | 0, 1137376 | 0, 56 | 0) | 0;
           memcpy($2 + 44 | 0 | 0, $2 + 288 | 0 | 0, 148 | 0) | 0;
           $1 = 6;
           i64toi32_i32$0 = 1779033703;
           $4 = -222443244;
           $4$hi = i64toi32_i32$0;
           break label$2;
          }
          i64toi32_i32$1 = $2;
          i64toi32_i32$0 = 0;
          HEAP32[($2 + 192 | 0) >> 2] = 0;
          HEAP32[($2 + 196 | 0) >> 2] = i64toi32_i32$0;
          i64toi32_i32$1 = $2;
          i64toi32_i32$0 = 0;
          HEAP32[($2 + 200 | 0) >> 2] = 0;
          HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$0;
          memset($2 + 304 | 0 | 0, 0 | 0, 132 | 0) | 0;
          memcpy($2 + 232 | 0 | 0, 1137376 | 0, 56 | 0) | 0;
          memcpy($2 + 44 | 0 | 0, $2 + 288 | 0 | 0, 148 | 0) | 0;
          $1 = 7;
          i64toi32_i32$0 = 1779033703;
          $4 = -222443224;
          $4$hi = i64toi32_i32$0;
          break label$2;
         }
         i64toi32_i32$1 = $2;
         i64toi32_i32$0 = 0;
         HEAP32[($2 + 192 | 0) >> 2] = 0;
         HEAP32[($2 + 196 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$1 = $2;
         i64toi32_i32$0 = 0;
         HEAP32[($2 + 200 | 0) >> 2] = 0;
         HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$0;
         memset($2 + 304 | 0 | 0, 0 | 0, 132 | 0) | 0;
         memcpy($2 + 232 | 0 | 0, 1137376 | 0, 56 | 0) | 0;
         memcpy($2 + 44 | 0 | 0, $2 + 288 | 0 | 0, 148 | 0) | 0;
         $1 = 8;
         i64toi32_i32$0 = 1779033703;
         $4 = -222443223;
         $4$hi = i64toi32_i32$0;
         break label$2;
        }
        i64toi32_i32$1 = $2;
        i64toi32_i32$0 = 0;
        HEAP32[($2 + 192 | 0) >> 2] = 0;
        HEAP32[($2 + 196 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$1 = $2;
        i64toi32_i32$0 = 0;
        HEAP32[($2 + 200 | 0) >> 2] = 0;
        HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$0;
        memset($2 + 304 | 0 | 0, 0 | 0, 132 | 0) | 0;
        memcpy($2 + 232 | 0 | 0, 1137376 | 0, 56 | 0) | 0;
        memcpy($2 + 44 | 0 | 0, $2 + 288 | 0 | 0, 148 | 0) | 0;
        $1 = 9;
        i64toi32_i32$0 = 1779033703;
        $4 = -222443220;
        $4$hi = i64toi32_i32$0;
        break label$2;
       }
       i64toi32_i32$1 = $2;
       i64toi32_i32$0 = 0;
       HEAP32[($2 + 192 | 0) >> 2] = 0;
       HEAP32[($2 + 196 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$1 = $2;
       i64toi32_i32$0 = 0;
       HEAP32[($2 + 200 | 0) >> 2] = 0;
       HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$0;
       memset($2 + 304 | 0 | 0, 0 | 0, 132 | 0) | 0;
       memcpy($2 + 232 | 0 | 0, 1137376 | 0, 56 | 0) | 0;
       memcpy($2 + 44 | 0 | 0, $2 + 288 | 0 | 0, 148 | 0) | 0;
       $1 = 10;
       i64toi32_i32$0 = 1779033703;
       $4 = -222443232;
       $4$hi = i64toi32_i32$0;
       break label$2;
      }
      i64toi32_i32$1 = $2;
      i64toi32_i32$0 = 0;
      HEAP32[($2 + 192 | 0) >> 2] = 0;
      HEAP32[($2 + 196 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$1 = $2;
      i64toi32_i32$0 = 0;
      HEAP32[($2 + 200 | 0) >> 2] = 0;
      HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$0;
      memset($2 + 304 | 0 | 0, 0 | 0, 132 | 0) | 0;
      memcpy($2 + 232 | 0 | 0, 1137376 | 0, 56 | 0) | 0;
      memcpy($2 + 44 | 0 | 0, $2 + 288 | 0 | 0, 148 | 0) | 0;
      $1 = 11;
      i64toi32_i32$0 = 1779033703;
      $4 = -222443228;
      $4$hi = i64toi32_i32$0;
      break label$2;
     }
     i64toi32_i32$1 = $2;
     i64toi32_i32$0 = 0;
     HEAP32[($2 + 192 | 0) >> 2] = 0;
     HEAP32[($2 + 196 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$1 = $2;
     i64toi32_i32$0 = 0;
     HEAP32[($2 + 200 | 0) >> 2] = 0;
     HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$0;
     memset($2 + 304 | 0 | 0, 0 | 0, 132 | 0) | 0;
     memcpy($2 + 232 | 0 | 0, 1137376 | 0, 56 | 0) | 0;
     memcpy($2 + 44 | 0 | 0, $2 + 288 | 0 | 0, 148 | 0) | 0;
     $1 = 12;
     i64toi32_i32$0 = 1779033703;
     $4 = -222443208;
     $4$hi = i64toi32_i32$0;
     break label$2;
    }
    i64toi32_i32$1 = $2;
    i64toi32_i32$0 = 0;
    HEAP32[($2 + 192 | 0) >> 2] = 0;
    HEAP32[($2 + 196 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$1 = $2;
    i64toi32_i32$0 = 0;
    HEAP32[($2 + 200 | 0) >> 2] = 0;
    HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$0;
    memset($2 + 304 | 0 | 0, 0 | 0, 132 | 0) | 0;
    memcpy($2 + 232 | 0 | 0, 1137376 | 0, 56 | 0) | 0;
    memcpy($2 + 44 | 0 | 0, $2 + 288 | 0 | 0, 148 | 0) | 0;
    $1 = 13;
    i64toi32_i32$0 = 1779033703;
    $4 = -222443192;
    $4$hi = i64toi32_i32$0;
   }
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAPU8[($2 + 288 | 0) >> 0] | 0 | ((HEAPU8[($2 + 289 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 290 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 291 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[($2 + 292 | 0) >> 0] | 0 | ((HEAPU8[($2 + 293 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 294 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 295 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $210 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   $18 = $210;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $18;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $18 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $18 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = $18 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 8 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$1 = $4$hi;
   i64toi32_i32$0 = i64toi32_i32$0 + 32 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $4;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $2 + 311 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $218 = i64toi32_i32$1;
   i64toi32_i32$1 = $0 + 24 | 0;
   $19 = $218;
   HEAP8[i64toi32_i32$1 >> 0] = $19;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $19 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $19 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $19 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = ($2 + 288 | 0) + 16 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $224 = i64toi32_i32$0;
   i64toi32_i32$0 = $0 + 17 | 0;
   $20 = $224;
   HEAP8[i64toi32_i32$0 >> 0] = $20;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $20 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $20 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $20 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = ($2 + 288 | 0) + 8 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $230 = i64toi32_i32$1;
   i64toi32_i32$1 = $0 + 9 | 0;
   $21 = $230;
   HEAP8[i64toi32_i32$1 >> 0] = $21;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $21 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $21 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $21 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   memcpy($0 + 40 | 0 | 0, $2 + 232 | 0 | 0, 56 | 0) | 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[($2 + 200 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 204 | 0) >> 2] | 0;
   $239 = i64toi32_i32$0;
   i64toi32_i32$0 = $0 + 104 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $239;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = HEAP32[($2 + 192 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 196 | 0) >> 2] | 0;
   $243 = i64toi32_i32$1;
   i64toi32_i32$1 = $0 + 96 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $243;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   memcpy($0 + 112 | 0 | 0, $2 + 44 | 0 | 0, 148 | 0) | 0;
   HEAP8[($0 + 288 | 0) >> 0] = 0;
   HEAP8[$0 >> 0] = $1;
   $22 = ($2 + 16 | 0) + 24 | 0;
   $23 = $0 + 284 | 0;
   $24 = HEAPU8[$22 >> 0] | 0 | ((HEAPU8[($22 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($22 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($22 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[$23 >> 0] = $24;
   HEAP8[($23 + 1 | 0) >> 0] = $24 >>> 8 | 0;
   HEAP8[($23 + 2 | 0) >> 0] = $24 >>> 16 | 0;
   HEAP8[($23 + 3 | 0) >> 0] = $24 >>> 24 | 0;
   i64toi32_i32$2 = ($2 + 16 | 0) + 16 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $263 = i64toi32_i32$0;
   i64toi32_i32$0 = $0 + 276 | 0;
   $25 = $263;
   HEAP8[i64toi32_i32$0 >> 0] = $25;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $25 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $25 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $25 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $269 = i64toi32_i32$1;
   i64toi32_i32$1 = $0 + 268 | 0;
   $26 = $269;
   HEAP8[i64toi32_i32$1 >> 0] = $26;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $26 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $26 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $26 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAPU8[($2 + 16 | 0) >> 0] | 0 | ((HEAPU8[($2 + 17 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 18 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 19 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[($2 + 20 | 0) >> 0] | 0 | ((HEAPU8[($2 + 21 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 22 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 23 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $273 = i64toi32_i32$0;
   i64toi32_i32$0 = $0 + 260 | 0;
   $27 = $273;
   HEAP8[i64toi32_i32$0 >> 0] = $27;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $27 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $27 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $27 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   global$0 = $3;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1135576 | 0, 26 | 0, 1135700 | 0);
  abort();
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__TransactionOutputs___deserialize__h3f9df29df082d970($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, $11 = 0, $3 = 0, $17 = 0, $19 = 0, $10 = 0, $12 = 0, $17$hi = 0, $19$hi = 0, $54 = 0, $55 = 0, $56 = 0, $57 = 0, $58 = 0, $59 = 0, $60 = 0, $61 = 0, $62 = 0, $63 = 0, $64 = 0, $65 = 0, $66 = 0, $18 = 0, $18$hi = 0, $7 = 0, $4 = 0, $6 = 0, $8 = 0, $13 = 0, $14 = 0, $15 = 0, $16 = 0, $5 = 0, $9 = 0, $75 = 0, $82 = 0, $98 = 0, $101 = 0, $122 = 0, $128 = 0, $143 = 0, $146 = 0, $181 = 0, $185 = 0, $189 = 0, $196 = 0, $247 = 0, $254 = 0, $270 = 0, $273 = 0, $281 = 0, $287 = 0, $291 = 0, $297 = 0, $303 = 0, $307 = 0, $319 = 0, $323 = 0, $329 = 0, $335 = 0, $362 = 0;
  $2 = global$0 - 496 | 0;
  global$0 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 12 | 0) >> 2] = 0;
  HEAP32[($2 + 16 | 0) >> 2] = i64toi32_i32$0;
  $3 = 0;
  HEAP32[($2 + 8 | 0) >> 2] = HEAP32[(0 + 1050204 | 0) >> 2] | 0;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 360 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = ($2 + 360 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $17 = i64toi32_i32$0;
  $17$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 368 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 372 | 0) >> 2] | 0;
  $18 = i64toi32_i32$1;
  $18$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 360 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 364 | 0) >> 2] | 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
         break label$6
        }
        i64toi32_i32$2 = $17$hi;
        $4 = $17;
        label$7 : {
         i64toi32_i32$2 = $18$hi;
         i64toi32_i32$3 = $18;
         i64toi32_i32$1 = 0;
         i64toi32_i32$0 = 1;
         if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
          break label$7
         }
         if (!$4) {
          break label$3
         }
        }
        $5 = $2 + 432 | 0;
        $6 = ($2 + 360 | 0) + 60 | 0;
        $7 = ($2 + 360 | 0) + 32 | 0;
        $8 = $2 + 369 | 0;
        $9 = $8 + 3 | 0;
        label$8 : {
         label$9 : while (1) {
          std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 | 0, $1 | 0);
          $3 = 0;
          $10 = 2;
          label$10 : {
           if (HEAP32[($2 + 4 | 0) >> 2] | 0) {
            break label$10
           }
           i64toi32_i32$3 = 0;
           $19 = 8;
           $19$hi = i64toi32_i32$3;
           i64toi32_i32$3 = 0;
           $17 = 0;
           $17$hi = i64toi32_i32$3;
           break label$4;
          }
          label$11 : {
           if ((($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[$2 >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) == (7 | 0)) {
            break label$11
           }
           cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__TransactionOutput___deserialize__haabae074445f3776($2 + 360 | 0 | 0, $1 | 0);
           $11 = ($2 + 328 | 0) + 8 | 0;
           i64toi32_i32$0 = $7 + 8 | 0;
           i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $75 = i64toi32_i32$3;
           i64toi32_i32$3 = $11;
           HEAP32[i64toi32_i32$3 >> 2] = $75;
           HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
           $12 = ($2 + 328 | 0) + 16 | 0;
           i64toi32_i32$0 = $7 + 16 | 0;
           i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$3 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $82 = i64toi32_i32$2;
           i64toi32_i32$2 = $12;
           HEAP32[i64toi32_i32$2 >> 2] = $82;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
           $13 = ($2 + 312 | 0) + 8 | 0;
           HEAP32[$13 >> 2] = HEAP32[($6 + 8 | 0) >> 2] | 0;
           $54 = $8;
           HEAP32[($2 + 352 | 0) >> 2] = HEAPU8[$54 >> 0] | 0 | ((HEAPU8[($54 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($54 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($54 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $55 = $9;
           $56 = HEAPU8[$55 >> 0] | 0 | ((HEAPU8[($55 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($55 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($55 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 355 | 0) >> 0] = $56;
           HEAP8[($2 + 356 | 0) >> 0] = $56 >>> 8 | 0;
           HEAP8[($2 + 357 | 0) >> 0] = $56 >>> 16 | 0;
           HEAP8[($2 + 358 | 0) >> 0] = $56 >>> 24 | 0;
           i64toi32_i32$0 = $7;
           i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $98 = i64toi32_i32$3;
           i64toi32_i32$3 = $2;
           HEAP32[($2 + 328 | 0) >> 2] = $98;
           HEAP32[($2 + 332 | 0) >> 2] = i64toi32_i32$2;
           i64toi32_i32$0 = $6;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $101 = i64toi32_i32$2;
           i64toi32_i32$2 = $2;
           HEAP32[($2 + 312 | 0) >> 2] = $101;
           HEAP32[($2 + 316 | 0) >> 2] = i64toi32_i32$3;
           $3 = HEAP32[($2 + 416 | 0) >> 2] | 0;
           i64toi32_i32$0 = $2;
           i64toi32_i32$3 = HEAP32[($2 + 384 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($2 + 388 | 0) >> 2] | 0;
           $17 = i64toi32_i32$3;
           $17$hi = i64toi32_i32$2;
           i64toi32_i32$0 = $2;
           i64toi32_i32$2 = HEAP32[($2 + 376 | 0) >> 2] | 0;
           i64toi32_i32$3 = HEAP32[($2 + 380 | 0) >> 2] | 0;
           $19 = i64toi32_i32$2;
           $19$hi = i64toi32_i32$3;
           $10 = HEAPU8[($2 + 368 | 0) >> 0] | 0;
           i64toi32_i32$0 = $2;
           i64toi32_i32$3 = HEAP32[($2 + 360 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($2 + 364 | 0) >> 2] | 0;
           i64toi32_i32$0 = i64toi32_i32$3;
           i64toi32_i32$3 = 0;
           i64toi32_i32$1 = 1;
           if ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) | 0) {
            break label$8
           }
           memcpy($2 + 200 | 0 | 0, $5 | 0, 64 | 0) | 0;
           $14 = ($2 + 280 | 0) + 8 | 0;
           i64toi32_i32$1 = $11;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $122 = i64toi32_i32$0;
           i64toi32_i32$0 = $14;
           HEAP32[i64toi32_i32$0 >> 2] = $122;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
           $15 = ($2 + 280 | 0) + 16 | 0;
           i64toi32_i32$1 = $12;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $128 = i64toi32_i32$2;
           i64toi32_i32$2 = $15;
           HEAP32[i64toi32_i32$2 >> 2] = $128;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
           $16 = ($2 + 264 | 0) + 8 | 0;
           HEAP32[$16 >> 2] = HEAP32[$13 >> 2] | 0;
           HEAP32[($2 + 304 | 0) >> 2] = HEAP32[($2 + 352 | 0) >> 2] | 0;
           $57 = HEAPU8[($2 + 355 | 0) >> 0] | 0 | ((HEAPU8[($2 + 356 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 357 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 358 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 307 | 0) >> 0] = $57;
           HEAP8[($2 + 308 | 0) >> 0] = $57 >>> 8 | 0;
           HEAP8[($2 + 309 | 0) >> 0] = $57 >>> 16 | 0;
           HEAP8[($2 + 310 | 0) >> 0] = $57 >>> 24 | 0;
           i64toi32_i32$1 = $2;
           i64toi32_i32$0 = HEAP32[($2 + 328 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($2 + 332 | 0) >> 2] | 0;
           $143 = i64toi32_i32$0;
           i64toi32_i32$0 = $2;
           HEAP32[($2 + 280 | 0) >> 2] = $143;
           HEAP32[($2 + 284 | 0) >> 2] = i64toi32_i32$2;
           i64toi32_i32$1 = $2;
           i64toi32_i32$2 = HEAP32[($2 + 312 | 0) >> 2] | 0;
           i64toi32_i32$0 = HEAP32[($2 + 316 | 0) >> 2] | 0;
           $146 = i64toi32_i32$2;
           i64toi32_i32$2 = $2;
           HEAP32[($2 + 264 | 0) >> 2] = $146;
           HEAP32[($2 + 268 | 0) >> 2] = i64toi32_i32$0;
           label$12 : {
            $12 = HEAP32[($2 + 16 | 0) >> 2] | 0;
            if ((HEAP32[($2 + 12 | 0) >> 2] | 0 | 0) != ($12 | 0)) {
             break label$12
            }
            alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hf135acf924159ceb($2 + 8 | 0 | 0, $12 | 0, 1 | 0);
            $12 = HEAP32[($2 + 16 | 0) >> 2] | 0;
           }
           $11 = (HEAP32[($2 + 8 | 0) >> 2] | 0) + ($12 << 7 | 0) | 0;
           HEAP8[$11 >> 0] = $10;
           $58 = HEAP32[($2 + 304 | 0) >> 2] | 0;
           HEAP8[($11 + 1 | 0) >> 0] = $58;
           HEAP8[($11 + 2 | 0) >> 0] = $58 >>> 8 | 0;
           HEAP8[($11 + 3 | 0) >> 0] = $58 >>> 16 | 0;
           HEAP8[($11 + 4 | 0) >> 0] = $58 >>> 24 | 0;
           $59 = $11 + 4 | 0;
           $60 = HEAPU8[($2 + 307 | 0) >> 0] | 0 | ((HEAPU8[($2 + 308 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 309 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 310 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[$59 >> 0] = $60;
           HEAP8[($59 + 1 | 0) >> 0] = $60 >>> 8 | 0;
           HEAP8[($59 + 2 | 0) >> 0] = $60 >>> 16 | 0;
           HEAP8[($59 + 3 | 0) >> 0] = $60 >>> 24 | 0;
           i64toi32_i32$0 = $17$hi;
           i64toi32_i32$2 = $11 + 16 | 0;
           HEAP8[i64toi32_i32$2 >> 0] = $17;
           HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $17 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $17 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $17 >>> 24 | 0;
           HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$0;
           HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
           i64toi32_i32$0 = $19$hi;
           i64toi32_i32$2 = $11 + 8 | 0;
           HEAP8[i64toi32_i32$2 >> 0] = $19;
           HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $19 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $19 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $19 >>> 24 | 0;
           HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$0;
           HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
           i64toi32_i32$1 = $2;
           i64toi32_i32$0 = HEAP32[($2 + 280 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($2 + 284 | 0) >> 2] | 0;
           $181 = i64toi32_i32$0;
           i64toi32_i32$0 = $11 + 24 | 0;
           $61 = $181;
           HEAP8[i64toi32_i32$0 >> 0] = $61;
           HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $61 >>> 8 | 0;
           HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $61 >>> 16 | 0;
           HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $61 >>> 24 | 0;
           HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$2;
           HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
           HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
           HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
           i64toi32_i32$1 = $14;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $185 = i64toi32_i32$2;
           i64toi32_i32$2 = $11 + 32 | 0;
           $62 = $185;
           HEAP8[i64toi32_i32$2 >> 0] = $62;
           HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $62 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $62 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $62 >>> 24 | 0;
           HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$0;
           HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
           i64toi32_i32$1 = $15;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $189 = i64toi32_i32$0;
           i64toi32_i32$0 = $11 + 40 | 0;
           $63 = $189;
           HEAP8[i64toi32_i32$0 >> 0] = $63;
           HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $63 >>> 8 | 0;
           HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $63 >>> 16 | 0;
           HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $63 >>> 24 | 0;
           HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$2;
           HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
           HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
           HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
           HEAP32[($11 + 48 | 0) >> 2] = $3;
           i64toi32_i32$1 = $2;
           i64toi32_i32$2 = HEAP32[($2 + 264 | 0) >> 2] | 0;
           i64toi32_i32$0 = HEAP32[($2 + 268 | 0) >> 2] | 0;
           $196 = i64toi32_i32$2;
           i64toi32_i32$2 = $11 + 52 | 0;
           HEAP32[i64toi32_i32$2 >> 2] = $196;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
           HEAP32[($11 + 60 | 0) >> 2] = HEAP32[$16 >> 2] | 0;
           memcpy($11 + 64 | 0 | 0, $2 + 200 | 0 | 0, 64 | 0) | 0;
           $11 = $12 + 1 | 0;
           HEAP32[($2 + 16 | 0) >> 2] = $11;
           i64toi32_i32$0 = $18$hi;
           i64toi32_i32$1 = $18;
           i64toi32_i32$2 = 0;
           i64toi32_i32$3 = 1;
           if ((i64toi32_i32$1 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$2 | 0) | 0) {
            continue label$9
           }
           if ($11 >>> 0 < $4 >>> 0) {
            continue label$9
           }
           break label$3;
          }
          break label$9;
         };
         cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 360 | 0 | 0, $1 | 0);
         i64toi32_i32$3 = ($2 + 360 | 0) + 16 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $17 = i64toi32_i32$1;
         $17$hi = i64toi32_i32$0;
         i64toi32_i32$3 = $2;
         i64toi32_i32$0 = HEAP32[($2 + 368 | 0) >> 2] | 0;
         i64toi32_i32$1 = HEAP32[($2 + 372 | 0) >> 2] | 0;
         $19 = i64toi32_i32$0;
         $19$hi = i64toi32_i32$1;
         i64toi32_i32$3 = $2;
         i64toi32_i32$1 = HEAP32[($2 + 360 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($2 + 364 | 0) >> 2] | 0;
         i64toi32_i32$3 = i64toi32_i32$1;
         i64toi32_i32$1 = 0;
         i64toi32_i32$2 = 1;
         if ((i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
          break label$5
         }
         i64toi32_i32$3 = $17$hi;
         i64toi32_i32$0 = $2 + 336 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $17;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
         i64toi32_i32$3 = $19$hi;
         i64toi32_i32$0 = $2;
         HEAP32[($2 + 328 | 0) >> 2] = $19;
         HEAP32[($2 + 332 | 0) >> 2] = i64toi32_i32$3;
         if (($19 & 255 | 0 | 0) == (5 | 0)) {
          break label$3
         }
         HEAP32[($2 + 360 | 0) >> 2] = 0;
         core__panicking__assert_failed__h96d8431cc974b591(0 | 0, $2 + 328 | 0 | 0, 1050312 | 0, $2 + 360 | 0 | 0, 1050384 | 0);
         abort();
        }
        i64toi32_i32$2 = ($2 + 328 | 0) + 8 | 0;
        i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $247 = i64toi32_i32$3;
        i64toi32_i32$3 = ($2 + 168 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$3 >> 2] = $247;
        HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = ($2 + 328 | 0) + 16 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $254 = i64toi32_i32$0;
        i64toi32_i32$0 = ($2 + 168 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $254;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
        HEAP32[(($2 + 152 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 312 | 0) + 8 | 0) >> 2] | 0;
        HEAP32[($2 + 192 | 0) >> 2] = HEAP32[($2 + 352 | 0) >> 2] | 0;
        $64 = HEAPU8[($2 + 355 | 0) >> 0] | 0 | ((HEAPU8[($2 + 356 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 357 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 358 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 195 | 0) >> 0] = $64;
        HEAP8[($2 + 196 | 0) >> 0] = $64 >>> 8 | 0;
        HEAP8[($2 + 197 | 0) >> 0] = $64 >>> 16 | 0;
        HEAP8[($2 + 198 | 0) >> 0] = $64 >>> 24 | 0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$3 = HEAP32[($2 + 328 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[($2 + 332 | 0) >> 2] | 0;
        $270 = i64toi32_i32$3;
        i64toi32_i32$3 = $2;
        HEAP32[($2 + 168 | 0) >> 2] = $270;
        HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 312 | 0) >> 2] | 0;
        i64toi32_i32$3 = HEAP32[($2 + 316 | 0) >> 2] | 0;
        $273 = i64toi32_i32$0;
        i64toi32_i32$0 = $2;
        HEAP32[($2 + 152 | 0) >> 2] = $273;
        HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$3;
        if (($10 & 255 | 0 | 0) != (19 | 0)) {
         break label$4
        }
        break label$3;
       }
       i64toi32_i32$2 = $2 + 392 | 0;
       i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $281 = i64toi32_i32$3;
       i64toi32_i32$3 = $2 + 176 | 0;
       HEAP32[i64toi32_i32$3 >> 2] = $281;
       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = $2 + 400 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $287 = i64toi32_i32$0;
       i64toi32_i32$0 = ($2 + 168 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $287;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
       i64toi32_i32$2 = $2 + 384 | 0;
       i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $291 = i64toi32_i32$3;
       i64toi32_i32$3 = $2;
       HEAP32[($2 + 168 | 0) >> 2] = $291;
       HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$0;
       $10 = 2;
       i64toi32_i32$0 = $18$hi;
       $19 = $18;
       $19$hi = i64toi32_i32$0;
       break label$4;
      }
      i64toi32_i32$2 = $2 + 392 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $297 = i64toi32_i32$0;
      i64toi32_i32$0 = $2 + 176 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $297;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
      i64toi32_i32$2 = $2 + 400 | 0;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $303 = i64toi32_i32$3;
      i64toi32_i32$3 = ($2 + 168 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$3 >> 2] = $303;
      HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $2 + 384 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $307 = i64toi32_i32$0;
      i64toi32_i32$0 = $2;
      HEAP32[($2 + 168 | 0) >> 2] = $307;
      HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$3;
     }
     i64toi32_i32$3 = $17$hi;
     i64toi32_i32$0 = ($2 + 360 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $17;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$3 = $19$hi;
     i64toi32_i32$0 = ($2 + 360 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $19;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$2 = $2;
     i64toi32_i32$3 = HEAP32[($2 + 168 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 172 | 0) >> 2] | 0;
     $319 = i64toi32_i32$3;
     i64toi32_i32$3 = $2 + 384 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $319;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[($2 + 152 | 0) >> 2] | 0;
     i64toi32_i32$3 = HEAP32[($2 + 156 | 0) >> 2] | 0;
     $323 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 412 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $323;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$2 = ($2 + 168 | 0) + 8 | 0;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $329 = i64toi32_i32$3;
     i64toi32_i32$3 = $2 + 392 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $329;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = ($2 + 168 | 0) + 16 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $335 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 400 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $335;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
     HEAP32[($2 + 420 | 0) >> 2] = HEAP32[(($2 + 152 | 0) + 8 | 0) >> 2] | 0;
     HEAP8[($2 + 360 | 0) >> 0] = $10;
     $65 = HEAP32[($2 + 192 | 0) >> 2] | 0;
     HEAP8[($2 + 361 | 0) >> 0] = $65;
     HEAP8[($2 + 362 | 0) >> 0] = $65 >>> 8 | 0;
     HEAP8[($2 + 363 | 0) >> 0] = $65 >>> 16 | 0;
     HEAP8[($2 + 364 | 0) >> 0] = $65 >>> 24 | 0;
     $66 = HEAPU8[($2 + 195 | 0) >> 0] | 0 | ((HEAPU8[($2 + 196 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 197 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 198 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($2 + 364 | 0) >> 0] = $66;
     HEAP8[($2 + 365 | 0) >> 0] = $66 >>> 8 | 0;
     HEAP8[($2 + 366 | 0) >> 0] = $66 >>> 16 | 0;
     HEAP8[($2 + 367 | 0) >> 0] = $66 >>> 24 | 0;
     HEAP32[($2 + 408 | 0) >> 2] = $3;
     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($2 + 88 | 0 | 0, $2 + 360 | 0 | 0, 1050400 | 0, 18 | 0);
     $11 = HEAPU8[($2 + 88 | 0) >> 0] | 0;
     if (($11 | 0) != (19 | 0)) {
      break label$2
     }
    }
    i64toi32_i32$2 = $2;
    i64toi32_i32$3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $362 = i64toi32_i32$3;
    i64toi32_i32$3 = $0;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = $362;
    HEAP32[(i64toi32_i32$3 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[(i64toi32_i32$3 + 12 | 0) >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
    $10 = 0;
    break label$1;
   }
   $10 = 1;
   memcpy($2 + 25 | 0 | 0, $2 + 88 | 0 | 1 | 0 | 0, 63 | 0) | 0;
   HEAP8[($0 + 8 | 0) >> 0] = $11;
   memcpy($0 + 9 | 0 | 0, $2 + 25 | 0 | 0, 63 | 0) | 0;
   label$13 : {
    $3 = HEAP32[($2 + 16 | 0) >> 2] | 0;
    if (!$3) {
     break label$13
    }
    $11 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    $3 = $3 << 7 | 0;
    label$14 : while (1) {
     core__ptr__drop_in_place_cardano_serialization_lib__TransactionOutput___h632b3a99817e6ac5_1($11 | 0);
     $11 = $11 + 128 | 0;
     $3 = $3 + -128 | 0;
     if ($3) {
      continue label$14
     }
     break label$14;
    };
   }
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h5107e2b13c386680($2 + 8 | 0 | 0);
  }
  HEAP32[$0 >> 2] = $10;
  global$0 = $2 + 496 | 0;
 }
 
 function cbor_event__de__Deserializer_R___cbor_len__h852681e444aca076($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $2 = 0, $4 = 0, $3 = 0, $5 = 0, $5$hi = 0, $6 = 0, $6$hi = 0, $7 = 0, $7$hi = 0, $8 = 0, $8$hi = 0, $83 = 0, $84 = 0, $85 = 0, $86 = 0, $87 = 0, $88 = 0, $89 = 0, $90 = 0, $91 = 0, $92 = 0, $93 = 0, $96 = 0, $97 = 0, $99 = 0, $100 = 0, $56 = 0, $94 = 0, $95 = 0, $95$hi = 0, $97$hi = 0, $98 = 0, $143 = 0, $144 = 0, $144$hi = 0, $146 = 0, $146$hi = 0, $148$hi = 0, $149 = 0, $149$hi = 0, $151$hi = 0, $152 = 0, $152$hi = 0, $153 = 0, $9 = 0, $9$hi = 0, $10 = 0, $10$hi = 0, $11 = 0, $11$hi = 0, $12 = 0, $12$hi = 0, $238 = 0, $239 = 0, $239$hi = 0, $241 = 0, $241$hi = 0, $243$hi = 0, $244 = 0, $244$hi = 0, $246$hi = 0, $247 = 0, $247$hi = 0, $249$hi = 0, $250 = 0, $250$hi = 0, $252$hi = 0, $253 = 0, $253$hi = 0, $255$hi = 0, $256 = 0, $256$hi = 0, $258$hi = 0, $259 = 0, $259$hi = 0, $260 = 0, $273 = 0, $281 = 0, $287 = 0, $293 = 0, $297 = 0, $302 = 0, $310 = 0, $316 = 0, $322 = 0, $326 = 0, $331 = 0, $339 = 0, $345 = 0, $351 = 0, $355 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 120 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           label$10 : {
            label$11 : {
             label$12 : {
              label$13 : {
               label$14 : {
                label$15 : {
                 label$16 : {
                  if (!(HEAP32[($2 + 124 | 0) >> 2] | 0)) {
                   break label$16
                  }
                  $3 = (HEAPU8[(HEAP32[($2 + 120 | 0) >> 2] | 0) >> 0] | 0) & 31 | 0;
                  if ($3 >>> 0 < 24 >>> 0) {
                   break label$15
                  }
                  switch ($3 + -24 | 0 | 0) {
                  case 3:
                   break label$10;
                  case 2:
                   break label$11;
                  case 1:
                   break label$12;
                  case 0:
                   break label$13;
                  case 7:
                   break label$9;
                  default:
                   break label$14;
                  };
                 }
                 HEAP8[($0 + 8 | 0) >> 0] = 8;
                 i64toi32_i32$1 = $0;
                 i64toi32_i32$0 = 0;
                 HEAP32[i64toi32_i32$1 >> 2] = 1;
                 HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                 i64toi32_i32$1 = i64toi32_i32$1 + 12 | 0;
                 i64toi32_i32$0 = 0;
                 HEAP32[i64toi32_i32$1 >> 2] = 0;
                 HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                 break label$1;
                }
                i64toi32_i32$1 = $0;
                i64toi32_i32$0 = 0;
                HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = 1;
                HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
                i64toi32_i32$0 = 0;
                HEAP32[i64toi32_i32$1 >> 2] = 0;
                HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = 0;
                i64toi32_i32$0 = 0;
                i64toi32_i32$1 = i64toi32_i32$1 + 16 | 0;
                HEAP32[i64toi32_i32$1 >> 2] = $3;
                HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
                break label$1;
               }
               label$17 : {
                if ($3 >>> 0 < 28 >>> 0) {
                 break label$17
                }
                if (($3 | 0) != (31 | 0)) {
                 break label$8
                }
               }
               core__panicking__panic__h2fd385a887c8bf13(1057063 | 0, 40 | 0, 1057196 | 0);
               abort();
              }
              std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 | 0, $1 | 0);
              label$18 : {
               label$19 : {
                $3 = HEAP32[($2 + 4 | 0) >> 2] | 0;
                if ($3 >>> 0 < 2 >>> 0) {
                 break label$19
                }
                i64toi32_i32$2 = HEAP32[$2 >> 2] | 0;
                i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0;
                i64toi32_i32$1 = 0;
                $56 = i64toi32_i32$0;
                i64toi32_i32$0 = $0 + 16 | 0;
                HEAP32[i64toi32_i32$0 >> 2] = $56;
                HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
                $1 = $0 + 24 | 0;
                i64toi32_i32$1 = 0;
                $5 = 0;
                $5$hi = i64toi32_i32$1;
                i64toi32_i32$1 = 0;
                $6 = 1;
                $6$hi = i64toi32_i32$1;
                break label$18;
               }
               $1 = $0 + 16 | 0;
               i64toi32_i32$1 = 0;
               i64toi32_i32$2 = $3;
               i64toi32_i32$0 = 0;
               i64toi32_i32$3 = 32;
               i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
               if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
                $83 = 0;
               } else {
                i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
                $83 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
               }
               i64toi32_i32$1 = $83;
               i64toi32_i32$2 = 0;
               i64toi32_i32$3 = 8;
               i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
               $6 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
               $6$hi = i64toi32_i32$2;
               i64toi32_i32$2 = 0;
               $5 = 1;
               $5$hi = i64toi32_i32$2;
              }
              i64toi32_i32$2 = $6$hi;
              i64toi32_i32$1 = $0;
              HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $6;
              HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$2;
              HEAP32[$1 >> 2] = 1;
              i64toi32_i32$2 = $5$hi;
              HEAP32[i64toi32_i32$1 >> 2] = $5;
              HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
              break label$1;
             }
             std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 16 | 0 | 0, $1 | 0);
             $3 = 2;
             label$20 : {
              $4 = HEAP32[($2 + 20 | 0) >> 2] | 0;
              if ($4 >>> 0 >= 2 >>> 0) {
               break label$20
              }
              $3 = 1;
              break label$3;
             }
             i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
             i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0;
             i64toi32_i32$1 = 0;
             $5 = i64toi32_i32$2;
             $5$hi = i64toi32_i32$1;
             std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 8 | 0 | 0, $1 | 0);
             $4 = HEAP32[($2 + 12 | 0) >> 2] | 0;
             if ($4 >>> 0 < 3 >>> 0) {
              break label$3
             }
             i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
             i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0;
             i64toi32_i32$2 = 0;
             $6 = i64toi32_i32$1;
             $6$hi = i64toi32_i32$2;
             HEAP32[($0 + 24 | 0) >> 2] = 2;
             i64toi32_i32$1 = $0;
             i64toi32_i32$2 = 0;
             HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = 1;
             HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$2;
             $94 = i64toi32_i32$1 + 16 | 0;
             i64toi32_i32$2 = $6$hi;
             $95 = $6;
             $95$hi = i64toi32_i32$2;
             i64toi32_i32$2 = $5$hi;
             i64toi32_i32$0 = $5;
             i64toi32_i32$1 = 0;
             i64toi32_i32$3 = 8;
             i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
             if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
              i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
              $84 = 0;
             } else {
              i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
              $84 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
             }
             $97$hi = i64toi32_i32$1;
             i64toi32_i32$1 = $95$hi;
             i64toi32_i32$2 = $95;
             i64toi32_i32$0 = $97$hi;
             i64toi32_i32$3 = $84;
             i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
             $98 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
             i64toi32_i32$2 = $94;
             HEAP32[i64toi32_i32$2 >> 2] = $98;
             HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
             i64toi32_i32$0 = 0;
             $5 = 0;
             $5$hi = i64toi32_i32$0;
             break label$2;
            }
            std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 48 | 0 | 0, $1 | 0);
            $3 = 2;
            label$21 : {
             $4 = HEAP32[($2 + 52 | 0) >> 2] | 0;
             if ($4 >>> 0 >= 2 >>> 0) {
              break label$21
             }
             $3 = 1;
             break label$5;
            }
            i64toi32_i32$1 = HEAP32[($2 + 48 | 0) >> 2] | 0;
            i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0;
            i64toi32_i32$2 = 0;
            $5 = i64toi32_i32$0;
            $5$hi = i64toi32_i32$2;
            std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 40 | 0 | 0, $1 | 0);
            $4 = HEAP32[($2 + 44 | 0) >> 2] | 0;
            if ($4 >>> 0 < 3 >>> 0) {
             break label$5
            }
            i64toi32_i32$1 = HEAP32[($2 + 40 | 0) >> 2] | 0;
            i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0;
            i64toi32_i32$0 = 0;
            $6 = i64toi32_i32$2;
            $6$hi = i64toi32_i32$0;
            std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 32 | 0 | 0, $1 | 0);
            $3 = 3;
            $4 = HEAP32[($2 + 36 | 0) >> 2] | 0;
            if ($4 >>> 0 < 4 >>> 0) {
             break label$5
            }
            i64toi32_i32$1 = HEAP32[($2 + 32 | 0) >> 2] | 0;
            i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0;
            i64toi32_i32$2 = 0;
            $7 = i64toi32_i32$0;
            $7$hi = i64toi32_i32$2;
            std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 24 | 0 | 0, $1 | 0);
            $3 = 4;
            $4 = HEAP32[($2 + 28 | 0) >> 2] | 0;
            if ($4 >>> 0 < 5 >>> 0) {
             break label$5
            }
            i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
            i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0;
            i64toi32_i32$0 = 0;
            $8 = i64toi32_i32$2;
            $8$hi = i64toi32_i32$0;
            HEAP32[($0 + 24 | 0) >> 2] = 4;
            i64toi32_i32$2 = $0;
            i64toi32_i32$0 = 0;
            HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = 1;
            HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$0;
            $143 = i64toi32_i32$2 + 16 | 0;
            i64toi32_i32$0 = $8$hi;
            $144 = $8;
            $144$hi = i64toi32_i32$0;
            i64toi32_i32$0 = $6$hi;
            i64toi32_i32$1 = $6;
            i64toi32_i32$2 = 0;
            i64toi32_i32$3 = 16;
            i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
            if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
             i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
             $85 = 0;
            } else {
             i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
             $85 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
            }
            $146 = $85;
            $146$hi = i64toi32_i32$2;
            i64toi32_i32$2 = $5$hi;
            i64toi32_i32$0 = $5;
            i64toi32_i32$1 = 0;
            i64toi32_i32$3 = 24;
            i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
            if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
             i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
             $86 = 0;
            } else {
             i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
             $86 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
            }
            $148$hi = i64toi32_i32$1;
            i64toi32_i32$1 = $146$hi;
            i64toi32_i32$2 = $146;
            i64toi32_i32$0 = $148$hi;
            i64toi32_i32$3 = $86;
            i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
            $149 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
            $149$hi = i64toi32_i32$0;
            i64toi32_i32$0 = $7$hi;
            i64toi32_i32$1 = $7;
            i64toi32_i32$2 = 0;
            i64toi32_i32$3 = 8;
            i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
            if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
             i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
             $87 = 0;
            } else {
             i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
             $87 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
            }
            $151$hi = i64toi32_i32$2;
            i64toi32_i32$2 = $149$hi;
            i64toi32_i32$0 = $149;
            i64toi32_i32$1 = $151$hi;
            i64toi32_i32$3 = $87;
            i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
            $152 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
            $152$hi = i64toi32_i32$1;
            i64toi32_i32$1 = $144$hi;
            i64toi32_i32$2 = $144;
            i64toi32_i32$0 = $152$hi;
            i64toi32_i32$3 = $152;
            i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
            $153 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
            i64toi32_i32$2 = $143;
            HEAP32[i64toi32_i32$2 >> 2] = $153;
            HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
            i64toi32_i32$0 = 0;
            $5 = 0;
            $5$hi = i64toi32_i32$0;
            break label$4;
           }
           std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 112 | 0 | 0, $1 | 0);
           $3 = 2;
           label$22 : {
            $4 = HEAP32[($2 + 116 | 0) >> 2] | 0;
            if ($4 >>> 0 >= 2 >>> 0) {
             break label$22
            }
            $3 = 1;
            break label$7;
           }
           i64toi32_i32$1 = HEAP32[($2 + 112 | 0) >> 2] | 0;
           i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0;
           i64toi32_i32$2 = 0;
           $5 = i64toi32_i32$0;
           $5$hi = i64toi32_i32$2;
           std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 104 | 0 | 0, $1 | 0);
           $4 = HEAP32[($2 + 108 | 0) >> 2] | 0;
           if ($4 >>> 0 < 3 >>> 0) {
            break label$7
           }
           i64toi32_i32$1 = HEAP32[($2 + 104 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0;
           i64toi32_i32$0 = 0;
           $6 = i64toi32_i32$2;
           $6$hi = i64toi32_i32$0;
           std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 96 | 0 | 0, $1 | 0);
           $3 = 3;
           $4 = HEAP32[($2 + 100 | 0) >> 2] | 0;
           if ($4 >>> 0 < 4 >>> 0) {
            break label$7
           }
           i64toi32_i32$1 = HEAP32[($2 + 96 | 0) >> 2] | 0;
           i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0;
           i64toi32_i32$2 = 0;
           $7 = i64toi32_i32$0;
           $7$hi = i64toi32_i32$2;
           std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 88 | 0 | 0, $1 | 0);
           $3 = 4;
           $4 = HEAP32[($2 + 92 | 0) >> 2] | 0;
           if ($4 >>> 0 < 5 >>> 0) {
            break label$7
           }
           i64toi32_i32$1 = HEAP32[($2 + 88 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0;
           i64toi32_i32$0 = 0;
           $8 = i64toi32_i32$2;
           $8$hi = i64toi32_i32$0;
           std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 80 | 0 | 0, $1 | 0);
           $3 = 5;
           $4 = HEAP32[($2 + 84 | 0) >> 2] | 0;
           if ($4 >>> 0 < 6 >>> 0) {
            break label$7
           }
           i64toi32_i32$1 = HEAP32[($2 + 80 | 0) >> 2] | 0;
           i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0;
           i64toi32_i32$2 = 0;
           $9 = i64toi32_i32$0;
           $9$hi = i64toi32_i32$2;
           std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 72 | 0 | 0, $1 | 0);
           $3 = 6;
           $4 = HEAP32[($2 + 76 | 0) >> 2] | 0;
           if ($4 >>> 0 < 7 >>> 0) {
            break label$7
           }
           i64toi32_i32$1 = HEAP32[($2 + 72 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0;
           i64toi32_i32$0 = 0;
           $10 = i64toi32_i32$2;
           $10$hi = i64toi32_i32$0;
           std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 64 | 0 | 0, $1 | 0);
           $3 = 7;
           $4 = HEAP32[($2 + 68 | 0) >> 2] | 0;
           if ($4 >>> 0 < 8 >>> 0) {
            break label$7
           }
           i64toi32_i32$1 = HEAP32[($2 + 64 | 0) >> 2] | 0;
           i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0;
           i64toi32_i32$2 = 0;
           $11 = i64toi32_i32$0;
           $11$hi = i64toi32_i32$2;
           std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 56 | 0 | 0, $1 | 0);
           $3 = 8;
           $4 = HEAP32[($2 + 60 | 0) >> 2] | 0;
           if ($4 >>> 0 < 9 >>> 0) {
            break label$7
           }
           i64toi32_i32$1 = HEAP32[($2 + 56 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 8 | 0) >> 0] | 0;
           i64toi32_i32$0 = 0;
           $12 = i64toi32_i32$2;
           $12$hi = i64toi32_i32$0;
           HEAP32[($0 + 24 | 0) >> 2] = 8;
           i64toi32_i32$2 = $0;
           i64toi32_i32$0 = 0;
           HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = 1;
           HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$0;
           $238 = i64toi32_i32$2 + 16 | 0;
           i64toi32_i32$0 = $12$hi;
           $239 = $12;
           $239$hi = i64toi32_i32$0;
           i64toi32_i32$0 = $6$hi;
           i64toi32_i32$1 = $6;
           i64toi32_i32$2 = 0;
           i64toi32_i32$3 = 48;
           i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
           if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
            i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
            $88 = 0;
           } else {
            i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
            $88 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
           }
           $241 = $88;
           $241$hi = i64toi32_i32$2;
           i64toi32_i32$2 = $5$hi;
           i64toi32_i32$0 = $5;
           i64toi32_i32$1 = 0;
           i64toi32_i32$3 = 56;
           i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
           if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
            i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
            $89 = 0;
           } else {
            i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
            $89 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
           }
           $243$hi = i64toi32_i32$1;
           i64toi32_i32$1 = $241$hi;
           i64toi32_i32$2 = $241;
           i64toi32_i32$0 = $243$hi;
           i64toi32_i32$3 = $89;
           i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
           $244 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
           $244$hi = i64toi32_i32$0;
           i64toi32_i32$0 = $7$hi;
           i64toi32_i32$1 = $7;
           i64toi32_i32$2 = 0;
           i64toi32_i32$3 = 40;
           i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
           if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
            i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
            $90 = 0;
           } else {
            i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
            $90 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
           }
           $246$hi = i64toi32_i32$2;
           i64toi32_i32$2 = $244$hi;
           i64toi32_i32$0 = $244;
           i64toi32_i32$1 = $246$hi;
           i64toi32_i32$3 = $90;
           i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
           $247 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
           $247$hi = i64toi32_i32$1;
           i64toi32_i32$1 = $8$hi;
           i64toi32_i32$2 = $8;
           i64toi32_i32$0 = 0;
           i64toi32_i32$3 = 32;
           i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
           if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
            i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
            $91 = 0;
           } else {
            i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
            $91 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
           }
           $249$hi = i64toi32_i32$0;
           i64toi32_i32$0 = $247$hi;
           i64toi32_i32$1 = $247;
           i64toi32_i32$2 = $249$hi;
           i64toi32_i32$3 = $91;
           i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
           $250 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
           $250$hi = i64toi32_i32$2;
           i64toi32_i32$2 = $9$hi;
           i64toi32_i32$0 = $9;
           i64toi32_i32$1 = 0;
           i64toi32_i32$3 = 24;
           i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
           if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
            i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
            $92 = 0;
           } else {
            i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
            $92 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
           }
           $252$hi = i64toi32_i32$1;
           i64toi32_i32$1 = $250$hi;
           i64toi32_i32$2 = $250;
           i64toi32_i32$0 = $252$hi;
           i64toi32_i32$3 = $92;
           i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
           $253 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
           $253$hi = i64toi32_i32$0;
           i64toi32_i32$0 = $10$hi;
           i64toi32_i32$1 = $10;
           i64toi32_i32$2 = 0;
           i64toi32_i32$3 = 16;
           i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
           if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
            i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
            $93 = 0;
           } else {
            i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
            $93 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
           }
           $255$hi = i64toi32_i32$2;
           i64toi32_i32$2 = $253$hi;
           i64toi32_i32$0 = $253;
           i64toi32_i32$1 = $255$hi;
           i64toi32_i32$3 = $93;
           i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
           $256 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
           $256$hi = i64toi32_i32$1;
           i64toi32_i32$1 = $11$hi;
           i64toi32_i32$2 = $11;
           i64toi32_i32$0 = 0;
           i64toi32_i32$3 = 8;
           i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
           if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
            i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
            $96 = 0;
           } else {
            i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
            $96 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
           }
           $258$hi = i64toi32_i32$0;
           i64toi32_i32$0 = $256$hi;
           i64toi32_i32$1 = $256;
           i64toi32_i32$2 = $258$hi;
           i64toi32_i32$3 = $96;
           i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
           $259 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
           $259$hi = i64toi32_i32$2;
           i64toi32_i32$2 = $239$hi;
           i64toi32_i32$0 = $239;
           i64toi32_i32$1 = $259$hi;
           i64toi32_i32$3 = $259;
           i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
           $260 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
           i64toi32_i32$0 = $238;
           HEAP32[i64toi32_i32$0 >> 2] = $260;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
           i64toi32_i32$1 = 0;
           $5 = 0;
           $5$hi = i64toi32_i32$1;
           break label$6;
          }
          i64toi32_i32$0 = $0;
          i64toi32_i32$1 = 0;
          HEAP32[i64toi32_i32$0 >> 2] = 0;
          HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
          HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = 0;
          i64toi32_i32$0 = i64toi32_i32$0 + 8 | 0;
          i64toi32_i32$1 = 0;
          HEAP32[i64toi32_i32$0 >> 2] = 0;
          HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
          break label$1;
         }
         HEAP8[($0 + 8 | 0) >> 0] = 11;
         i64toi32_i32$0 = $0;
         i64toi32_i32$1 = 0;
         HEAP32[i64toi32_i32$0 >> 2] = 1;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         HEAP8[(i64toi32_i32$0 + 9 | 0) >> 0] = $3;
         break label$1;
        }
        i64toi32_i32$2 = $2;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 132 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 136 | 0) >> 2] | 0;
        $273 = i64toi32_i32$1;
        i64toi32_i32$1 = $0;
        HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = $273;
        HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = i64toi32_i32$0;
        HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $3;
        i64toi32_i32$2 = i64toi32_i32$2 + 140 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $281 = i64toi32_i32$0;
        i64toi32_i32$0 = $0 + 28 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $281;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$2 = ($2 + 132 | 0) + 16 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $287 = i64toi32_i32$1;
        i64toi32_i32$1 = $0 + 36 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $287;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        HEAP32[($0 + 44 | 0) >> 2] = HEAP32[($2 + 156 | 0) >> 2] | 0;
        $293 = $0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$2 = $4;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 32;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
         $97 = 0;
        } else {
         i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
         $97 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        }
        i64toi32_i32$0 = $97;
        i64toi32_i32$2 = 0;
        i64toi32_i32$3 = 8;
        i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
        $297 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
        i64toi32_i32$0 = $293;
        HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $297;
        HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
        i64toi32_i32$2 = 0;
        $5 = 1;
        $5$hi = i64toi32_i32$2;
       }
       i64toi32_i32$2 = $5$hi;
       i64toi32_i32$0 = $0;
       HEAP32[i64toi32_i32$0 >> 2] = $5;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
       break label$1;
      }
      i64toi32_i32$1 = $2;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 136 | 0) >> 2] | 0;
      $302 = i64toi32_i32$2;
      i64toi32_i32$2 = $0;
      HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] = $302;
      HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] = $3;
      i64toi32_i32$1 = i64toi32_i32$1 + 140 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $310 = i64toi32_i32$0;
      i64toi32_i32$0 = $0 + 28 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $310;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$1 = ($2 + 132 | 0) + 16 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $316 = i64toi32_i32$2;
      i64toi32_i32$2 = $0 + 36 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $316;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[($0 + 44 | 0) >> 2] = HEAP32[($2 + 156 | 0) >> 2] | 0;
      $322 = $0;
      i64toi32_i32$0 = 0;
      i64toi32_i32$1 = $4;
      i64toi32_i32$2 = 0;
      i64toi32_i32$3 = 32;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       $99 = 0;
      } else {
       i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
       $99 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
      }
      i64toi32_i32$0 = $99;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 8;
      i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
      $326 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
      i64toi32_i32$0 = $322;
      HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $326;
      HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      $5 = 1;
      $5$hi = i64toi32_i32$1;
     }
     i64toi32_i32$1 = $5$hi;
     i64toi32_i32$0 = $0;
     HEAP32[i64toi32_i32$0 >> 2] = $5;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     break label$1;
    }
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 132 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 136 | 0) >> 2] | 0;
    $331 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = $331;
    HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $3;
    i64toi32_i32$2 = i64toi32_i32$2 + 140 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $339 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 28 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $339;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = ($2 + 132 | 0) + 16 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $345 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 36 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $345;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($0 + 44 | 0) >> 2] = HEAP32[($2 + 156 | 0) >> 2] | 0;
    $351 = $0;
    i64toi32_i32$0 = 0;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = 0;
    i64toi32_i32$3 = 32;
    i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
     $100 = 0;
    } else {
     i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
     $100 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
    }
    i64toi32_i32$0 = $100;
    i64toi32_i32$2 = 0;
    i64toi32_i32$3 = 8;
    i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
    $355 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
    i64toi32_i32$0 = $351;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $355;
    HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = 0;
    $5 = 1;
    $5$hi = i64toi32_i32$2;
   }
   i64toi32_i32$2 = $5$hi;
   i64toi32_i32$0 = $0;
   HEAP32[i64toi32_i32$0 >> 2] = $5;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  }
  global$0 = $2 + 160 | 0;
 }
 
 function num_bigint__biguint__division__div_rem_core__ha45fc4d52dd16ec8($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$5 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, i64toi32_i32$0 = 0, $5 = 0, $34$hi = 0, $34 = 0, $6 = 0, $14 = 0, $10 = 0, $20 = 0, $3 = 0, $33$hi = 0, $22 = 0, $4 = 0, $18 = 0, $33 = 0, $21 = 0, $13 = 0, $16 = 0, $30$hi = 0, $8 = 0, $9 = 0, $30 = 0, $15 = 0, $26 = 0, $11 = 0, $12 = 0, $17 = 0, $19 = 0, i64toi32_i32$6 = 0, $7 = 0, $29$hi = 0, $80 = 0, $31$hi = 0, $32$hi = 0, $81 = 0, $82 = 0, $23 = 0, $24 = 0, $25 = 0, $83 = 0, $27 = 0, $84 = 0, $29 = 0, $31 = 0, $32 = 0, $113$hi = 0, $115$hi = 0, $119$hi = 0, $121$hi = 0, $123 = 0, $123$hi = 0, $129 = 0, $129$hi = 0, $141 = 0, $141$hi = 0, $143$hi = 0, $145 = 0, $145$hi = 0, $201 = 0, $204 = 0, $204$hi = 0, $205$hi = 0, $207$hi = 0, $85 = 0, $209 = 0, $209$hi = 0, $28 = 0, $248 = 0, $250 = 0, $250$hi = 0, $252 = 0, $252$hi = 0, $253$hi = 0, $255 = 0, $255$hi = 0, $275 = 0, $278 = 0, $278$hi = 0, $416 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    if (!$4) {
     break label$2
    }
    $5 = $4 + -2 | 0;
    label$3 : {
     if (($4 | 0) == (1 | 0)) {
      break label$3
     }
     $6 = HEAP32[$2 >> 2] | 0;
     $7 = HEAP32[((($4 << 2 | 0) + $6 | 0) + -4 | 0) >> 2] | 0;
     i64toi32_i32$2 = $6 + ($5 << 2 | 0) | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = 0;
     $29 = i64toi32_i32$0;
     $29$hi = i64toi32_i32$1;
     $8 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     $9 = $8 - $4 | 0;
     $10 = $9 + 1 | 0;
     alloc__raw_vec__RawVec_T_2cA___allocate_in__hb0817f92bbb8999a($3 + 8 | 0 | 0, $10 | 0, 1 | 0);
     $11 = HEAP32[($3 + 12 | 0) >> 2] | 0;
     $12 = HEAP32[($3 + 8 | 0) >> 2] | 0;
     label$4 : {
      if ($10 >>> 0 >= $9 >>> 0) {
       break label$4
      }
      $13 = 0;
      $14 = $8;
      break label$1;
     }
     i64toi32_i32$1 = 0;
     $30 = $7;
     $30$hi = i64toi32_i32$1;
     i64toi32_i32$2 = $30;
     i64toi32_i32$0 = 0;
     i64toi32_i32$3 = 32;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
      $80 = 0;
     } else {
      i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
      $80 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
     }
     $31 = $80;
     $31$hi = i64toi32_i32$0;
     $15 = ($4 - $8 | 0) << 2 | 0;
     $16 = HEAP32[$1 >> 2] | 0;
     $17 = $9;
     $14 = $8;
     $13 = 0;
     $18 = $10;
     label$5 : {
      label$6 : {
       label$7 : {
        label$8 : while (1) {
         label$9 : {
          label$10 : {
           if (!$14) {
            break label$10
           }
           $5 = $14 + -2 | 0;
           label$11 : {
            if (($14 | 0) == (1 | 0)) {
             break label$11
            }
            $19 = $14 << 2 | 0;
            $20 = $19 + $16 | 0;
            $6 = HEAP32[($20 + -4 | 0) >> 2] | 0;
            i64toi32_i32$1 = $16 + ($5 << 2 | 0) | 0;
            i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
            i64toi32_i32$2 = 0;
            $32 = i64toi32_i32$0;
            $32$hi = i64toi32_i32$2;
            label$12 : {
             label$13 : {
              if ($13 >>> 0 < $7 >>> 0) {
               break label$13
              }
              i64toi32_i32$2 = 0;
              $113$hi = i64toi32_i32$2;
              i64toi32_i32$2 = 0;
              $115$hi = i64toi32_i32$2;
              i64toi32_i32$2 = $113$hi;
              i64toi32_i32$1 = $6;
              i64toi32_i32$0 = $115$hi;
              i64toi32_i32$3 = $13;
              i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
              i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
              if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
               i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
              }
              $33 = i64toi32_i32$4;
              $33$hi = i64toi32_i32$5;
              $21 = -1;
              break label$12;
             }
             i64toi32_i32$5 = 0;
             i64toi32_i32$2 = $13;
             i64toi32_i32$1 = 0;
             i64toi32_i32$3 = 32;
             i64toi32_i32$0 = i64toi32_i32$3 & 31 | 0;
             if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
              i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$0 | 0;
              $81 = 0;
             } else {
              i64toi32_i32$1 = ((1 << i64toi32_i32$0 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$0 | 0) | 0) | 0 | (i64toi32_i32$5 << i64toi32_i32$0 | 0) | 0;
              $81 = i64toi32_i32$2 << i64toi32_i32$0 | 0;
             }
             $119$hi = i64toi32_i32$1;
             i64toi32_i32$1 = 0;
             $121$hi = i64toi32_i32$1;
             i64toi32_i32$1 = $119$hi;
             i64toi32_i32$5 = $81;
             i64toi32_i32$2 = $121$hi;
             i64toi32_i32$3 = $6;
             i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
             $34 = i64toi32_i32$5 | i64toi32_i32$3 | 0;
             $34$hi = i64toi32_i32$2;
             $123 = $34;
             $123$hi = i64toi32_i32$2;
             i64toi32_i32$2 = $30$hi;
             i64toi32_i32$2 = $34$hi;
             i64toi32_i32$5 = $30$hi;
             i64toi32_i32$5 = __wasm_i64_udiv($34 | 0, i64toi32_i32$2 | 0, $30 | 0, i64toi32_i32$5 | 0) | 0;
             i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
             $34 = i64toi32_i32$5;
             $34$hi = i64toi32_i32$2;
             i64toi32_i32$2 = $30$hi;
             i64toi32_i32$2 = $34$hi;
             i64toi32_i32$5 = $30$hi;
             i64toi32_i32$5 = __wasm_i64_mul($34 | 0, i64toi32_i32$2 | 0, $30 | 0, i64toi32_i32$5 | 0) | 0;
             i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
             $129 = i64toi32_i32$5;
             $129$hi = i64toi32_i32$2;
             i64toi32_i32$2 = $123$hi;
             i64toi32_i32$1 = $123;
             i64toi32_i32$5 = $129$hi;
             i64toi32_i32$3 = $129;
             i64toi32_i32$0 = i64toi32_i32$1 - i64toi32_i32$3 | 0;
             i64toi32_i32$6 = i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0;
             i64toi32_i32$4 = i64toi32_i32$6 + i64toi32_i32$5 | 0;
             i64toi32_i32$4 = i64toi32_i32$2 - i64toi32_i32$4 | 0;
             $33 = i64toi32_i32$0;
             $33$hi = i64toi32_i32$4;
             i64toi32_i32$4 = $34$hi;
             $21 = $34;
            }
            $18 = $18 + -1 | 0;
            i64toi32_i32$4 = $33$hi;
            i64toi32_i32$2 = $33;
            i64toi32_i32$1 = 0;
            i64toi32_i32$3 = -1;
            if (i64toi32_i32$4 >>> 0 > i64toi32_i32$1 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$2 >>> 0 > i64toi32_i32$3 >>> 0 | 0) | 0) {
             break label$9
            }
            i64toi32_i32$2 = $33$hi;
            i64toi32_i32$3 = $33;
            i64toi32_i32$4 = 0;
            i64toi32_i32$1 = 32;
            i64toi32_i32$5 = i64toi32_i32$1 & 31 | 0;
            if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
             i64toi32_i32$4 = i64toi32_i32$3 << i64toi32_i32$5 | 0;
             $82 = 0;
            } else {
             i64toi32_i32$4 = ((1 << i64toi32_i32$5 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$5 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$5 | 0) | 0;
             $82 = i64toi32_i32$3 << i64toi32_i32$5 | 0;
            }
            $34 = $82;
            $34$hi = i64toi32_i32$4;
            label$14 : while (1) {
             i64toi32_i32$4 = $34$hi;
             i64toi32_i32$4 = $32$hi;
             i64toi32_i32$4 = $34$hi;
             i64toi32_i32$2 = $34;
             i64toi32_i32$3 = $32$hi;
             i64toi32_i32$1 = $32;
             i64toi32_i32$3 = i64toi32_i32$4 | i64toi32_i32$3 | 0;
             $141 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
             $141$hi = i64toi32_i32$3;
             i64toi32_i32$3 = 0;
             $143$hi = i64toi32_i32$3;
             i64toi32_i32$3 = $29$hi;
             i64toi32_i32$3 = $143$hi;
             i64toi32_i32$2 = $29$hi;
             i64toi32_i32$2 = __wasm_i64_mul($21 | 0, i64toi32_i32$3 | 0, $29 | 0, i64toi32_i32$2 | 0) | 0;
             i64toi32_i32$3 = i64toi32_i32$HIGH_BITS;
             $145 = i64toi32_i32$2;
             $145$hi = i64toi32_i32$3;
             i64toi32_i32$3 = $141$hi;
             i64toi32_i32$4 = $141;
             i64toi32_i32$2 = $145$hi;
             i64toi32_i32$1 = $145;
             if (i64toi32_i32$3 >>> 0 > i64toi32_i32$2 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$4 >>> 0 >= i64toi32_i32$1 >>> 0 | 0) | 0) {
              break label$9
             }
             i64toi32_i32$4 = $34$hi;
             i64toi32_i32$4 = $31$hi;
             i64toi32_i32$4 = $34$hi;
             i64toi32_i32$1 = $34;
             i64toi32_i32$3 = $31$hi;
             i64toi32_i32$2 = $31;
             i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
             i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
             if (i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0) {
              i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
             }
             $34 = i64toi32_i32$5;
             $34$hi = i64toi32_i32$0;
             $21 = $21 + -1 | 0;
             i64toi32_i32$0 = $33$hi;
             i64toi32_i32$0 = $30$hi;
             i64toi32_i32$0 = $33$hi;
             i64toi32_i32$4 = $33;
             i64toi32_i32$1 = $30$hi;
             i64toi32_i32$2 = $30;
             i64toi32_i32$3 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
             i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
             if (i64toi32_i32$3 >>> 0 < i64toi32_i32$2 >>> 0) {
              i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
             }
             $33 = i64toi32_i32$3;
             $33$hi = i64toi32_i32$5;
             i64toi32_i32$0 = i64toi32_i32$3;
             i64toi32_i32$4 = 1;
             i64toi32_i32$2 = 0;
             if (i64toi32_i32$5 >>> 0 < i64toi32_i32$4 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$4 | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0) {
              continue label$14
             }
             break label$9;
            };
           }
           core__panicking__panic_bounds_check__h808b524af17640b1($5 | 0, $14 | 0, 1084164 | 0);
           abort();
          }
          core__panicking__panic__h2fd385a887c8bf13(1083900 | 0, 43 | 0, 1084148 | 0);
          abort();
         }
         label$15 : {
          if ($14 >>> 0 < $18 >>> 0) {
           break label$15
          }
          label$16 : {
           $22 = HEAP32[($2 + 8 | 0) >> 2] | 0;
           $23 = $18 << 2 | 0;
           $24 = $16 + $23 | 0;
           $5 = ($20 - $24 | 0) >>> 2 | 0;
           if (!($5 >>> 0 > $22 >>> 0 ? $22 : $5)) {
            break label$16
           }
           $5 = ($15 + $19 | 0) >>> 2 | 0;
           $6 = 0 - ($22 >>> 0 < $5 >>> 0 ? $22 : $5) | 0;
           $25 = $17 << 2 | 0;
           $5 = $16 + $25 | 0;
           i64toi32_i32$0 = 0;
           $33 = $21;
           $33$hi = i64toi32_i32$0;
           i64toi32_i32$0 = 0;
           $34 = -1;
           $34$hi = i64toi32_i32$0;
           $26 = HEAP32[$2 >> 2] | 0;
           $20 = $26;
           label$17 : while (1) {
            $201 = $5;
            i64toi32_i32$0 = $34$hi;
            i64toi32_i32$2 = $5;
            i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
            i64toi32_i32$5 = 0;
            $204 = i64toi32_i32$0;
            $204$hi = i64toi32_i32$5;
            i64toi32_i32$5 = $34$hi;
            i64toi32_i32$2 = $34;
            i64toi32_i32$0 = $204$hi;
            i64toi32_i32$4 = $204;
            i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
            i64toi32_i32$3 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
            if (i64toi32_i32$1 >>> 0 < i64toi32_i32$4 >>> 0) {
             i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
            }
            $205$hi = i64toi32_i32$3;
            i64toi32_i32$5 = $20;
            i64toi32_i32$3 = HEAP32[i64toi32_i32$5 >> 2] | 0;
            i64toi32_i32$2 = 0;
            $207$hi = i64toi32_i32$2;
            i64toi32_i32$2 = $33$hi;
            i64toi32_i32$2 = $207$hi;
            $85 = i64toi32_i32$3;
            i64toi32_i32$3 = $33$hi;
            i64toi32_i32$3 = __wasm_i64_mul($85 | 0, i64toi32_i32$2 | 0, $33 | 0, i64toi32_i32$3 | 0) | 0;
            i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
            $209 = i64toi32_i32$3;
            $209$hi = i64toi32_i32$2;
            i64toi32_i32$2 = $205$hi;
            i64toi32_i32$5 = i64toi32_i32$1;
            i64toi32_i32$3 = $209$hi;
            i64toi32_i32$4 = $209;
            i64toi32_i32$0 = i64toi32_i32$5 - i64toi32_i32$4 | 0;
            i64toi32_i32$6 = i64toi32_i32$5 >>> 0 < i64toi32_i32$4 >>> 0;
            i64toi32_i32$1 = i64toi32_i32$6 + i64toi32_i32$3 | 0;
            i64toi32_i32$1 = i64toi32_i32$2 - i64toi32_i32$1 | 0;
            i64toi32_i32$2 = i64toi32_i32$0;
            i64toi32_i32$5 = -2;
            i64toi32_i32$4 = 1;
            i64toi32_i32$3 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
            i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
            if (i64toi32_i32$3 >>> 0 < i64toi32_i32$4 >>> 0) {
             i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
            }
            $34 = i64toi32_i32$3;
            $34$hi = i64toi32_i32$0;
            HEAP32[$201 >> 2] = i64toi32_i32$3;
            i64toi32_i32$1 = i64toi32_i32$3;
            i64toi32_i32$2 = 0;
            i64toi32_i32$4 = 32;
            i64toi32_i32$5 = i64toi32_i32$4 & 31 | 0;
            if (32 >>> 0 <= (i64toi32_i32$4 & 63 | 0) >>> 0) {
             i64toi32_i32$2 = 0;
             $83 = i64toi32_i32$0 >>> i64toi32_i32$5 | 0;
            } else {
             i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$5 | 0;
             $83 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$5 | 0) | 0;
            }
            $34 = $83;
            $34$hi = i64toi32_i32$2;
            $5 = $5 + 4 | 0;
            $20 = $20 + 4 | 0;
            $27 = $6 + 1 | 0;
            $28 = $27 >>> 0 >= $6 >>> 0;
            $6 = $27;
            if ($28) {
             continue label$17
            }
            break label$17;
           };
           i64toi32_i32$2 = $34$hi;
           if ($13 >>> 0 >= ($34 ^ -1 | 0) >>> 0) {
            break label$16
           }
           if (($14 - $18 | 0) >>> 0 < $22 >>> 0) {
            break label$7
           }
           $21 = $21 + -1 | 0;
           if (!$22) {
            break label$16
           }
           $20 = $22 << 2 | 0;
           $6 = $24 + $20 | 0;
           $5 = $16 + $25 | 0;
           i64toi32_i32$2 = 0;
           $34 = 0;
           $34$hi = i64toi32_i32$2;
           label$18 : while (1) {
            $248 = $5;
            i64toi32_i32$2 = $34$hi;
            i64toi32_i32$0 = $34;
            i64toi32_i32$1 = 0;
            i64toi32_i32$4 = 255;
            i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
            $250 = i64toi32_i32$0 & i64toi32_i32$4 | 0;
            $250$hi = i64toi32_i32$1;
            i64toi32_i32$2 = $5;
            i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
            i64toi32_i32$0 = 0;
            $252 = i64toi32_i32$1;
            $252$hi = i64toi32_i32$0;
            i64toi32_i32$0 = $250$hi;
            i64toi32_i32$2 = $250;
            i64toi32_i32$1 = $252$hi;
            i64toi32_i32$4 = $252;
            i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
            i64toi32_i32$3 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
            if (i64toi32_i32$5 >>> 0 < i64toi32_i32$4 >>> 0) {
             i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
            }
            $253$hi = i64toi32_i32$3;
            i64toi32_i32$0 = $26;
            i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
            i64toi32_i32$2 = 0;
            $255 = i64toi32_i32$3;
            $255$hi = i64toi32_i32$2;
            i64toi32_i32$2 = $253$hi;
            i64toi32_i32$0 = i64toi32_i32$5;
            i64toi32_i32$3 = $255$hi;
            i64toi32_i32$4 = $255;
            i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
            i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
            if (i64toi32_i32$1 >>> 0 < i64toi32_i32$4 >>> 0) {
             i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
            }
            $34 = i64toi32_i32$1;
            $34$hi = i64toi32_i32$5;
            HEAP32[$248 >> 2] = i64toi32_i32$1;
            $26 = $26 + 4 | 0;
            $5 = $5 + 4 | 0;
            i64toi32_i32$2 = i64toi32_i32$1;
            i64toi32_i32$0 = 0;
            i64toi32_i32$4 = 32;
            i64toi32_i32$3 = i64toi32_i32$4 & 31 | 0;
            if (32 >>> 0 <= (i64toi32_i32$4 & 63 | 0) >>> 0) {
             i64toi32_i32$0 = 0;
             $84 = i64toi32_i32$5 >>> i64toi32_i32$3 | 0;
            } else {
             i64toi32_i32$0 = i64toi32_i32$5 >>> i64toi32_i32$3 | 0;
             $84 = (((1 << i64toi32_i32$3 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$3 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$3 | 0) | 0;
            }
            $34 = $84;
            $34$hi = i64toi32_i32$0;
            $22 = $22 + -1 | 0;
            if ($22) {
             continue label$18
            }
            break label$18;
           };
           i64toi32_i32$0 = $34$hi;
           if (!($34 | i64toi32_i32$0 | 0)) {
            break label$16
           }
           $5 = $20 - $19 | 0;
           label$19 : while (1) {
            if (($15 | 0) == ($5 | 0)) {
             break label$16
            }
            $275 = $6;
            i64toi32_i32$0 = $34$hi;
            i64toi32_i32$5 = $6;
            i64toi32_i32$0 = HEAP32[i64toi32_i32$5 >> 2] | 0;
            i64toi32_i32$2 = 0;
            $278 = i64toi32_i32$0;
            $278$hi = i64toi32_i32$2;
            i64toi32_i32$2 = $34$hi;
            i64toi32_i32$5 = $34;
            i64toi32_i32$0 = $278$hi;
            i64toi32_i32$4 = $278;
            i64toi32_i32$3 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
            i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
            if (i64toi32_i32$3 >>> 0 < i64toi32_i32$4 >>> 0) {
             i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
            }
            $33 = i64toi32_i32$3;
            $33$hi = i64toi32_i32$1;
            HEAP32[$275 >> 2] = i64toi32_i32$3;
            $5 = $5 + 4 | 0;
            $6 = $6 + 4 | 0;
            i64toi32_i32$1 = 0;
            $34 = 1;
            $34$hi = i64toi32_i32$1;
            i64toi32_i32$1 = $33$hi;
            i64toi32_i32$2 = i64toi32_i32$3;
            i64toi32_i32$5 = 1;
            i64toi32_i32$4 = 0;
            i64toi32_i32$5 = i64toi32_i32$1 & i64toi32_i32$5 | 0;
            i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$4 | 0;
            i64toi32_i32$2 = 0;
            i64toi32_i32$4 = 0;
            if ((i64toi32_i32$1 | 0) != (i64toi32_i32$4 | 0) | (i64toi32_i32$5 | 0) != (i64toi32_i32$2 | 0) | 0) {
             continue label$19
            }
            break label$19;
           };
          }
          if (($9 | 0) == (-1 | 0)) {
           break label$6
          }
          HEAP32[($12 + $23 | 0) >> 2] = $21;
          $5 = HEAP32[($1 + 8 | 0) >> 2] | 0;
          if (!$5) {
           break label$5
          }
          $14 = $5 + -1 | 0;
          HEAP32[($1 + 8 | 0) >> 2] = $14;
          $17 = $17 + -1 | 0;
          $15 = $15 + 4 | 0;
          $16 = HEAP32[$1 >> 2] | 0;
          $13 = HEAP32[($16 + ($14 << 2 | 0) | 0) >> 2] | 0;
          if (!$18) {
           break label$1
          }
          continue label$8;
         }
         break label$8;
        };
        core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($18 | 0, $14 | 0, 1084180 | 0);
        abort();
       }
       core__panicking__panic__h2fd385a887c8bf13(1083769 | 0, 35 | 0, 1083884 | 0);
       abort();
      }
      core__panicking__panic_bounds_check__h808b524af17640b1($18 | 0, $10 | 0, 1084196 | 0);
      abort();
     }
     core__panicking__panic__h2fd385a887c8bf13(1083900 | 0, 43 | 0, 1084212 | 0);
     abort();
    }
    core__panicking__panic_bounds_check__h808b524af17640b1($5 | 0, $4 | 0, 1084132 | 0);
    abort();
   }
   core__panicking__panic__h2fd385a887c8bf13(1083900 | 0, 43 | 0, 1084116 | 0);
   abort();
  }
  label$20 : {
   if (($14 | 0) != (HEAP32[($1 + 4 | 0) >> 2] | 0 | 0)) {
    break label$20
   }
   alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h90c9768825cdae1b($1 | 0, $14 | 0, 1 | 0);
   $14 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  }
  $5 = $14 + 1 | 0;
  HEAP32[($1 + 8 | 0) >> 2] = $5;
  $6 = (HEAP32[$1 >> 2] | 0) + ($14 << 2 | 0) | 0;
  HEAP32[$6 >> 2] = $13;
  $20 = 0;
  label$21 : {
   if ($5 >>> 0 < $14 >>> 0) {
    break label$21
   }
   label$22 : while (1) {
    label$23 : {
     if (!(HEAP32[$6 >> 2] | 0)) {
      break label$23
     }
     $20 = $5;
     break label$21;
    }
    $5 = $5 + -1 | 0;
    HEAP32[($1 + 8 | 0) >> 2] = $5;
    $6 = $6 + -4 | 0;
    if ($5) {
     continue label$22
    }
    break label$22;
   };
  }
  label$24 : {
   $5 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   if ($20 >>> 0 >= ($5 >>> 2 | 0) >>> 0) {
    break label$24
   }
   if ($5 >>> 0 <= $20 >>> 0) {
    break label$24
   }
   alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($1 | 0, $20 | 0);
  }
  HEAP32[($3 + 40 | 0) >> 2] = $10;
  HEAP32[($3 + 36 | 0) >> 2] = $11;
  HEAP32[($3 + 32 | 0) >> 2] = $12;
  label$25 : {
   label$26 : {
    if ($10) {
     break label$26
    }
    $10 = 0;
    break label$25;
   }
   $5 = $12 + (($8 - $4 | 0) << 2 | 0) | 0;
   label$27 : {
    label$28 : while (1) {
     if (HEAP32[$5 >> 2] | 0) {
      break label$27
     }
     $5 = $5 + -4 | 0;
     $10 = $10 + -1 | 0;
     if ($10) {
      continue label$28
     }
     break label$28;
    };
    $10 = 0;
   }
   HEAP32[($3 + 40 | 0) >> 2] = $10;
  }
  label$29 : {
   if ($10 >>> 0 >= ($11 >>> 2 | 0) >>> 0) {
    break label$29
   }
   if ($11 >>> 0 <= $10 >>> 0) {
    break label$29
   }
   alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($3 + 32 | 0 | 0, $10 | 0);
  }
  $5 = HEAP32[(($3 + 32 | 0) + 8 | 0) >> 2] | 0;
  HEAP32[(($3 + 16 | 0) + 8 | 0) >> 2] = $5;
  i64toi32_i32$4 = $3;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$4 + 32 | 0) >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 36 | 0) >> 2] | 0;
  $34 = i64toi32_i32$1;
  $34$hi = i64toi32_i32$5;
  i64toi32_i32$1 = i64toi32_i32$4;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $34;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$5;
  HEAP32[($0 + 8 | 0) >> 2] = $5;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $34;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$5;
  i64toi32_i32$4 = $1;
  i64toi32_i32$5 = HEAP32[i64toi32_i32$4 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
  $416 = i64toi32_i32$5;
  i64toi32_i32$5 = $0;
  HEAP32[(i64toi32_i32$5 + 12 | 0) >> 2] = $416;
  HEAP32[(i64toi32_i32$5 + 16 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$5 + 20 | 0) >> 2] = HEAP32[(i64toi32_i32$4 + 8 | 0) >> 2] | 0;
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__Assets___deserialize__h1d5e068ce9d78042($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $7 = 0, $7$hi = 0, $5 = 0, $6 = 0, $6$hi = 0, $4 = 0, $55 = 0, $9 = 0, $9$hi = 0, $8 = 0, $8$hi = 0, $3 = 0, $56 = 0, $57 = 0, $58 = 0, $59 = 0, $60 = 0, $61 = 0, $62 = 0, $63 = 0, $64 = 0, $65 = 0, $130 = 0, $136 = 0, $145 = 0, $149 = 0, $175 = 0, $181 = 0, $185 = 0, $187 = 0, $187$hi = 0, $189 = 0, $189$hi = 0, $192$hi = 0, $194$hi = 0, $207 = 0, $213 = 0, $223 = 0, $227 = 0, $229 = 0, $229$hi = 0, $232 = 0, $232$hi = 0, $236$hi = 0, $238$hi = 0, $256 = 0, $262 = 0, $266 = 0, $271 = 0, $277 = 0, $281 = 0, $300 = 0, $304 = 0, $310 = 0, $316 = 0, $329 = 0, $332 = 0, $345 = 0;
  $2 = global$0 - 320 | 0;
  global$0 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 28 | 0) >> 2] = 0;
  HEAP32[($2 + 32 | 0) >> 2] = i64toi32_i32$0;
  cbor_event__de__Deserializer_R___map__h7c2a4e830d885a05($2 + 248 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = ($2 + 248 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $6 = i64toi32_i32$0;
  $6$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 256 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 260 | 0) >> 2] | 0;
  $7 = i64toi32_i32$1;
  $7$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           i64toi32_i32$2 = $2;
           i64toi32_i32$0 = HEAP32[($2 + 248 | 0) >> 2] | 0;
           i64toi32_i32$1 = HEAP32[($2 + 252 | 0) >> 2] | 0;
           i64toi32_i32$2 = i64toi32_i32$0;
           i64toi32_i32$0 = 0;
           i64toi32_i32$3 = 1;
           if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
            break label$9
           }
           i64toi32_i32$2 = $6$hi;
           $3 = $6;
           label$10 : {
            i64toi32_i32$2 = $7$hi;
            i64toi32_i32$3 = $7;
            i64toi32_i32$1 = 0;
            i64toi32_i32$0 = 1;
            if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
             break label$10
            }
            if (!$3) {
             break label$3
            }
           }
           label$11 : {
            label$12 : {
             label$13 : {
              label$14 : while (1) {
               std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 16 | 0 | 0, $1 | 0);
               $4 = 0;
               $5 = 2;
               label$15 : {
                if (HEAP32[($2 + 20 | 0) >> 2] | 0) {
                 break label$15
                }
                i64toi32_i32$3 = 0;
                $7 = 8;
                $7$hi = i64toi32_i32$3;
                i64toi32_i32$3 = 0;
                $6 = 0;
                $6$hi = i64toi32_i32$3;
                break label$7;
               }
               label$16 : {
                if ((($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[($2 + 16 | 0) >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) == (7 | 0)) {
                 break label$16
                }
                cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__AssetName___deserialize__hed130337b055988b($2 + 248 | 0 | 0, $1 | 0);
                if ((HEAP32[($2 + 248 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                 break label$11
                }
                i64toi32_i32$0 = $2 + 263 | 0;
                i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0;
                i64toi32_i32$2 = 0;
                HEAP8[($2 + 235 | 0) >> 0] = i64toi32_i32$3;
                i64toi32_i32$0 = $2 + 261 | 0;
                i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
                i64toi32_i32$3 = 0;
                $56 = $2 + 233 | 0;
                HEAP8[$56 >> 0] = i64toi32_i32$2;
                HEAP8[($56 + 1 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
                i64toi32_i32$0 = $2;
                i64toi32_i32$3 = HEAPU8[($2 + 257 | 0) >> 0] | 0 | ((HEAPU8[($2 + 258 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 259 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 260 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
                i64toi32_i32$2 = 0;
                HEAP8[($2 + 229 | 0) >> 0] = i64toi32_i32$3;
                HEAP8[($2 + 230 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
                HEAP8[($2 + 231 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
                HEAP8[($2 + 232 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
                HEAP8[($2 + 228 | 0) >> 0] = HEAPU8[($2 + 256 | 0) >> 0] | 0;
                HEAP32[($2 + 224 | 0) >> 2] = HEAP32[($2 + 252 | 0) >> 2] | 0;
                $cardano_serialization_lib__utils__BigNum_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h29637bb571dceb02($2 + 248 | 0 | 0, $1 | 0);
                i64toi32_i32$0 = $2;
                i64toi32_i32$2 = HEAP32[($2 + 256 | 0) >> 2] | 0;
                i64toi32_i32$3 = HEAP32[($2 + 260 | 0) >> 2] | 0;
                $8 = i64toi32_i32$2;
                $8$hi = i64toi32_i32$3;
                i64toi32_i32$0 = $2;
                i64toi32_i32$3 = HEAP32[($2 + 248 | 0) >> 2] | 0;
                i64toi32_i32$2 = HEAP32[($2 + 252 | 0) >> 2] | 0;
                i64toi32_i32$0 = i64toi32_i32$3;
                i64toi32_i32$3 = 0;
                i64toi32_i32$1 = 1;
                if ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) | 0) {
                 break label$13
                }
                $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($2 + 248 | 0 | 0, $2 + 224 | 0 | 0);
                i64toi32_i32$0 = $8$hi;
                alloc__collections__btree__map__BTreeMap_K_2cV___insert__hc7622c6487a4ba88($2 | 0, $2 + 24 | 0 | 0, $2 + 248 | 0 | 0, $8 | 0, i64toi32_i32$0 | 0);
                i64toi32_i32$1 = $2;
                i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
                i64toi32_i32$2 = HEAP32[($2 + 4 | 0) >> 2] | 0;
                i64toi32_i32$1 = i64toi32_i32$0;
                i64toi32_i32$0 = 0;
                i64toi32_i32$3 = 1;
                if ((i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) | 0) {
                 break label$12
                }
                $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 224 | 0 | 0);
                $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 224 | 0 | 0);
                i64toi32_i32$1 = $7$hi;
                i64toi32_i32$3 = $7;
                i64toi32_i32$2 = 0;
                i64toi32_i32$0 = 1;
                if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$2 | 0) | 0) {
                 continue label$14
                }
                if ((HEAP32[($2 + 32 | 0) >> 2] | 0) >>> 0 < $3 >>> 0) {
                 continue label$14
                }
                break label$3;
               }
               break label$14;
              };
              cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 248 | 0 | 0, $1 | 0);
              i64toi32_i32$0 = ($2 + 248 | 0) + 16 | 0;
              i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
              i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
              $6 = i64toi32_i32$3;
              $6$hi = i64toi32_i32$1;
              i64toi32_i32$0 = $2;
              i64toi32_i32$1 = HEAP32[($2 + 256 | 0) >> 2] | 0;
              i64toi32_i32$3 = HEAP32[($2 + 260 | 0) >> 2] | 0;
              $7 = i64toi32_i32$1;
              $7$hi = i64toi32_i32$3;
              i64toi32_i32$0 = $2;
              i64toi32_i32$3 = HEAP32[($2 + 248 | 0) >> 2] | 0;
              i64toi32_i32$1 = HEAP32[($2 + 252 | 0) >> 2] | 0;
              i64toi32_i32$0 = i64toi32_i32$3;
              i64toi32_i32$3 = 0;
              i64toi32_i32$2 = 1;
              if ((i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) | 0) {
               break label$8
              }
              i64toi32_i32$0 = $6$hi;
              i64toi32_i32$1 = $2 + 216 | 0;
              HEAP32[i64toi32_i32$1 >> 2] = $6;
              HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
              i64toi32_i32$0 = $7$hi;
              i64toi32_i32$1 = $2;
              HEAP32[($2 + 208 | 0) >> 2] = $7;
              HEAP32[($2 + 212 | 0) >> 2] = i64toi32_i32$0;
              if (($7 & 255 | 0 | 0) == (5 | 0)) {
               break label$3
              }
              HEAP32[($2 + 248 | 0) >> 2] = 0;
              core__panicking__assert_failed__h96d8431cc974b591(0 | 0, $2 + 208 | 0 | 0, 1050312 | 0, $2 + 248 | 0 | 0, 1053008 | 0);
              abort();
             }
             i64toi32_i32$2 = $2 + 288 | 0;
             i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
             i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
             $130 = i64toi32_i32$0;
             i64toi32_i32$0 = ($2 + 184 | 0) + 8 | 0;
             HEAP32[i64toi32_i32$0 >> 2] = $130;
             HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
             i64toi32_i32$2 = $2 + 296 | 0;
             i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
             i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
             $136 = i64toi32_i32$1;
             i64toi32_i32$1 = ($2 + 184 | 0) + 16 | 0;
             HEAP32[i64toi32_i32$1 >> 2] = $136;
             HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
             HEAP32[(($2 + 168 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 316 | 0) >> 2] | 0;
             i64toi32_i32$2 = $2;
             i64toi32_i32$0 = HEAP32[($2 + 308 | 0) >> 2] | 0;
             i64toi32_i32$1 = HEAP32[($2 + 312 | 0) >> 2] | 0;
             $145 = i64toi32_i32$0;
             i64toi32_i32$0 = $2;
             HEAP32[($2 + 168 | 0) >> 2] = $145;
             HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$1;
             i64toi32_i32$2 = $2 + 280 | 0;
             i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
             i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
             $149 = i64toi32_i32$1;
             i64toi32_i32$1 = $2;
             HEAP32[($2 + 184 | 0) >> 2] = $149;
             HEAP32[($2 + 188 | 0) >> 2] = i64toi32_i32$0;
             i64toi32_i32$0 = $8$hi;
             i64toi32_i32$2 = $8;
             i64toi32_i32$1 = 0;
             i64toi32_i32$3 = 8;
             i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
             if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
              i64toi32_i32$1 = 0;
              $57 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
             } else {
              i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
              $57 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
             }
             $9 = $57;
             $9$hi = i64toi32_i32$1;
             i64toi32_i32$0 = $2 + 272 | 0;
             i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
             i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
             $6 = i64toi32_i32$1;
             $6$hi = i64toi32_i32$2;
             i64toi32_i32$0 = ($2 + 248 | 0) + 16 | 0;
             i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
             i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
             $7 = i64toi32_i32$2;
             $7$hi = i64toi32_i32$1;
             $4 = HEAP32[($2 + 304 | 0) >> 2] | 0;
             i64toi32_i32$1 = $8$hi;
             $5 = $8;
             break label$6;
            }
            alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($2 + 260 | 0 | 0, 1051628 | 0, 33 | 0);
            $4 = 0;
            $1 = ($2 + 248 | 0) + 8 | 0;
            HEAP32[$1 >> 2] = 0;
            i64toi32_i32$0 = $2 + 280 | 0;
            i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
            i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
            $175 = i64toi32_i32$1;
            i64toi32_i32$1 = ($2 + 184 | 0) + 8 | 0;
            HEAP32[i64toi32_i32$1 >> 2] = $175;
            HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
            i64toi32_i32$0 = $2 + 288 | 0;
            i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
            i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
            $181 = i64toi32_i32$2;
            i64toi32_i32$2 = ($2 + 184 | 0) + 16 | 0;
            HEAP32[i64toi32_i32$2 >> 2] = $181;
            HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
            i64toi32_i32$0 = $2 + 272 | 0;
            i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
            i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
            $185 = i64toi32_i32$1;
            i64toi32_i32$1 = $2;
            HEAP32[($2 + 184 | 0) >> 2] = $185;
            HEAP32[($2 + 188 | 0) >> 2] = i64toi32_i32$2;
            i64toi32_i32$0 = $2;
            i64toi32_i32$2 = HEAPU8[($2 + 249 | 0) >> 0] | 0 | ((HEAPU8[($2 + 250 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 251 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 252 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            i64toi32_i32$1 = 0;
            $187 = i64toi32_i32$2;
            $187$hi = i64toi32_i32$1;
            i64toi32_i32$0 = $2;
            i64toi32_i32$1 = HEAPU8[($2 + 253 | 0) >> 0] | 0 | ((HEAPU8[($2 + 254 | 0) >> 0] | 0) << 8 | 0) | 0;
            i64toi32_i32$2 = 0;
            $189 = i64toi32_i32$1;
            $189$hi = i64toi32_i32$2;
            i64toi32_i32$0 = $2;
            i64toi32_i32$2 = HEAPU8[($2 + 255 | 0) >> 0] | 0;
            i64toi32_i32$1 = 0;
            i64toi32_i32$0 = i64toi32_i32$2;
            i64toi32_i32$2 = 0;
            i64toi32_i32$3 = 16;
            i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
            if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
             i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
             $58 = 0;
            } else {
             i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
             $58 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
            }
            $192$hi = i64toi32_i32$2;
            i64toi32_i32$2 = $189$hi;
            i64toi32_i32$1 = $189;
            i64toi32_i32$0 = $192$hi;
            i64toi32_i32$3 = $58;
            i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
            i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
            i64toi32_i32$1 = 0;
            i64toi32_i32$3 = 32;
            i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
            if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
             i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
             $59 = 0;
            } else {
             i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
             $59 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
            }
            $194$hi = i64toi32_i32$1;
            i64toi32_i32$1 = $187$hi;
            i64toi32_i32$0 = $187;
            i64toi32_i32$2 = $194$hi;
            i64toi32_i32$3 = $59;
            i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
            $9 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
            $9$hi = i64toi32_i32$2;
            i64toi32_i32$1 = ($2 + 248 | 0) + 16 | 0;
            i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
            i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
            $6 = i64toi32_i32$2;
            $6$hi = i64toi32_i32$0;
            i64toi32_i32$1 = $1;
            i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
            i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
            $7 = i64toi32_i32$0;
            $7$hi = i64toi32_i32$2;
            $5 = 4;
            break label$6;
           }
           i64toi32_i32$1 = $2 + 288 | 0;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $207 = i64toi32_i32$2;
           i64toi32_i32$2 = ($2 + 184 | 0) + 8 | 0;
           HEAP32[i64toi32_i32$2 >> 2] = $207;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
           i64toi32_i32$1 = $2 + 296 | 0;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $213 = i64toi32_i32$0;
           i64toi32_i32$0 = ($2 + 184 | 0) + 16 | 0;
           HEAP32[i64toi32_i32$0 >> 2] = $213;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
           HEAP32[(($2 + 168 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 316 | 0) >> 2] | 0;
           i64toi32_i32$1 = $2 + 280 | 0;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $223 = i64toi32_i32$2;
           i64toi32_i32$2 = $2;
           HEAP32[($2 + 184 | 0) >> 2] = $223;
           HEAP32[($2 + 188 | 0) >> 2] = i64toi32_i32$0;
           i64toi32_i32$1 = $2 + 308 | 0;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $227 = i64toi32_i32$0;
           i64toi32_i32$0 = $2;
           HEAP32[($2 + 168 | 0) >> 2] = $227;
           HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$2;
           i64toi32_i32$1 = $2;
           i64toi32_i32$2 = HEAPU8[($2 + 257 | 0) >> 0] | 0 | ((HEAPU8[($2 + 258 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 259 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 260 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$0 = 0;
           $229 = i64toi32_i32$2;
           $229$hi = i64toi32_i32$0;
           i64toi32_i32$1 = $2 + 261 | 0;
           i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
           i64toi32_i32$2 = 0;
           $232 = i64toi32_i32$0;
           $232$hi = i64toi32_i32$2;
           i64toi32_i32$1 = $2 + 263 | 0;
           i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
           i64toi32_i32$0 = 0;
           i64toi32_i32$1 = i64toi32_i32$2;
           i64toi32_i32$2 = 0;
           i64toi32_i32$3 = 16;
           i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
           if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
            i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
            $60 = 0;
           } else {
            i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
            $60 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
           }
           $236$hi = i64toi32_i32$2;
           i64toi32_i32$2 = $232$hi;
           i64toi32_i32$0 = $232;
           i64toi32_i32$1 = $236$hi;
           i64toi32_i32$3 = $60;
           i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
           i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
           i64toi32_i32$0 = 0;
           i64toi32_i32$3 = 32;
           i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
           if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
            i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
            $61 = 0;
           } else {
            i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
            $61 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
           }
           $238$hi = i64toi32_i32$0;
           i64toi32_i32$0 = $229$hi;
           i64toi32_i32$1 = $229;
           i64toi32_i32$2 = $238$hi;
           i64toi32_i32$3 = $61;
           i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
           $9 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
           $9$hi = i64toi32_i32$2;
           i64toi32_i32$0 = $2 + 272 | 0;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $6 = i64toi32_i32$2;
           $6$hi = i64toi32_i32$1;
           i64toi32_i32$0 = ($2 + 248 | 0) + 16 | 0;
           i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $7 = i64toi32_i32$1;
           $7$hi = i64toi32_i32$2;
           $4 = HEAP32[($2 + 304 | 0) >> 2] | 0;
           $5 = HEAPU8[($2 + 256 | 0) >> 0] | 0;
           break label$5;
          }
          i64toi32_i32$0 = $2 + 280 | 0;
          i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
          $256 = i64toi32_i32$2;
          i64toi32_i32$2 = $2 + 192 | 0;
          HEAP32[i64toi32_i32$2 >> 2] = $256;
          HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
          i64toi32_i32$0 = $2 + 288 | 0;
          i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
          i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
          $262 = i64toi32_i32$1;
          i64toi32_i32$1 = ($2 + 184 | 0) + 16 | 0;
          HEAP32[i64toi32_i32$1 >> 2] = $262;
          HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
          i64toi32_i32$0 = $2 + 272 | 0;
          i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
          $266 = i64toi32_i32$2;
          i64toi32_i32$2 = $2;
          HEAP32[($2 + 184 | 0) >> 2] = $266;
          HEAP32[($2 + 188 | 0) >> 2] = i64toi32_i32$1;
          $4 = 0;
          $5 = 2;
          break label$7;
         }
         i64toi32_i32$0 = $2 + 280 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
         $271 = i64toi32_i32$1;
         i64toi32_i32$1 = $2 + 192 | 0;
         HEAP32[i64toi32_i32$1 >> 2] = $271;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
         i64toi32_i32$0 = $2 + 288 | 0;
         i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
         $277 = i64toi32_i32$2;
         i64toi32_i32$2 = ($2 + 184 | 0) + 16 | 0;
         HEAP32[i64toi32_i32$2 >> 2] = $277;
         HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$0 = $2 + 272 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
         $281 = i64toi32_i32$1;
         i64toi32_i32$1 = $2;
         HEAP32[($2 + 184 | 0) >> 2] = $281;
         HEAP32[($2 + 188 | 0) >> 2] = i64toi32_i32$2;
        }
        break label$4;
       }
       $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 224 | 0 | 0);
       $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 224 | 0 | 0);
      }
      if (($5 & 255 | 0 | 0) == (19 | 0)) {
       break label$3
      }
     }
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$1 = ($2 + 248 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $6;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$1 = ($2 + 248 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $7;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$0 = $2;
     i64toi32_i32$2 = HEAP32[($2 + 184 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 188 | 0) >> 2] | 0;
     $300 = i64toi32_i32$2;
     i64toi32_i32$2 = $2 + 272 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $300;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$0 = $2;
     i64toi32_i32$1 = HEAP32[($2 + 168 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[($2 + 172 | 0) >> 2] | 0;
     $304 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 300 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $304;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$0 = ($2 + 184 | 0) + 8 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $310 = i64toi32_i32$2;
     i64toi32_i32$2 = $2 + 280 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $310;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$0 = ($2 + 184 | 0) + 16 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $316 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 288 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $316;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
     HEAP32[($2 + 308 | 0) >> 2] = HEAP32[(($2 + 168 | 0) + 8 | 0) >> 2] | 0;
     HEAP8[($2 + 248 | 0) >> 0] = $5;
     HEAP32[($2 + 296 | 0) >> 2] = $4;
     i64toi32_i32$2 = $9$hi;
     $55 = $9;
     HEAP8[($2 + 249 | 0) >> 0] = $55;
     HEAP8[($2 + 250 | 0) >> 0] = $55 >>> 8 | 0;
     HEAP8[($2 + 251 | 0) >> 0] = $55 >>> 16 | 0;
     HEAP8[($2 + 252 | 0) >> 0] = $55 >>> 24 | 0;
     $329 = $2;
     i64toi32_i32$0 = $55;
     i64toi32_i32$1 = 0;
     i64toi32_i32$3 = 48;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$1 = 0;
      $62 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
     } else {
      i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
      $62 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
     }
     HEAP8[($329 + 255 | 0) >> 0] = $62;
     $332 = $2;
     i64toi32_i32$1 = $9$hi;
     i64toi32_i32$2 = $9;
     i64toi32_i32$0 = 0;
     i64toi32_i32$3 = 32;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$0 = 0;
      $63 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
     } else {
      i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
      $63 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
     }
     $64 = $332;
     $65 = $63;
     HEAP8[($64 + 253 | 0) >> 0] = $65;
     HEAP8[($64 + 254 | 0) >> 0] = $65 >>> 8 | 0;
     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($2 + 104 | 0 | 0, $2 + 248 | 0 | 0, 1053024 | 0, 6 | 0);
     $5 = HEAPU8[($2 + 104 | 0) >> 0] | 0;
     if (($5 | 0) != (19 | 0)) {
      break label$2
     }
    }
    i64toi32_i32$1 = $2;
    i64toi32_i32$0 = HEAP32[($2 + 24 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($2 + 28 | 0) >> 2] | 0;
    $345 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $345;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$2;
    HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = HEAP32[($2 + 32 | 0) >> 2] | 0;
    $1 = 0;
    break label$1;
   }
   $1 = 1;
   memcpy($2 + 41 | 0 | 0, $2 + 104 | 0 | 1 | 0 | 0, 63 | 0) | 0;
   HEAP8[($0 + 8 | 0) >> 0] = $5;
   memcpy($0 + 9 | 0 | 0, $2 + 41 | 0 | 0, 63 | 0) | 0;
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h6c9f94f0f82ce2b5($2 + 24 | 0 | 0);
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 320 | 0;
 }
 
 function num_bigint__bigint__addition___impl_20core__ops__arith__Add_20for_20num_bigint__bigint__BigInt___add__ha39524fef59942b1($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $6 = 0, $7 = 0, $9 = 0, $5 = 0, $4 = 0, $12 = 0, $8 = 0, $22 = 0, $27 = 0, $53 = 0, $63 = 0, $76 = 0, $100 = 0, $148 = 0, $153 = 0, $169 = 0, $10 = 0, $11 = 0, $236 = 0, $246 = 0, $253 = 0, $271 = 0, $298 = 0, $308 = 0, $320 = 0, $389 = 0;
  $3 = global$0 - 64 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    $4 = HEAPU8[($2 + 12 | 0) >> 0] | 0;
    if (($4 | 0) != (1 | 0)) {
     break label$2
    }
    i64toi32_i32$2 = $1;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $22 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[i64toi32_i32$0 >> 2] = $22;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $27 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $27;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
    if (!$1) {
     break label$1
    }
    $1 = $1 << 2 | 0;
    if (!$1) {
     break label$1
    }
    __rust_dealloc(HEAP32[$2 >> 2] | 0 | 0, $1 | 0, 4 | 0);
    break label$1;
   }
   label$3 : {
    label$4 : {
     label$5 : {
      label$6 : {
       label$7 : {
        label$8 : {
         label$9 : {
          label$10 : {
           label$11 : {
            label$12 : {
             $5 = HEAPU8[($1 + 12 | 0) >> 0] | 0;
             switch ($5 | 0) {
             case 2:
              break label$12;
             case 1:
              break label$9;
             default:
              break label$11;
             };
            }
            if ($4) {
             break label$10
            }
            break label$6;
           }
           if ($4) {
            break label$6
           }
          }
          $6 = $1 + 8 | 0;
          HEAP32[(($3 + 16 | 0) + 8 | 0) >> 2] = HEAP32[$6 >> 2] | 0;
          i64toi32_i32$2 = $1;
          i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
          $53 = i64toi32_i32$0;
          i64toi32_i32$0 = $3;
          HEAP32[($3 + 16 | 0) >> 2] = $53;
          HEAP32[($3 + 20 | 0) >> 2] = i64toi32_i32$1;
          $7 = $2 + 8 | 0;
          HEAP32[(($3 + 32 | 0) + 8 | 0) >> 2] = HEAP32[$7 >> 2] | 0;
          i64toi32_i32$2 = $2;
          i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
          i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
          $63 = i64toi32_i32$1;
          i64toi32_i32$1 = $3;
          HEAP32[($3 + 32 | 0) >> 2] = $63;
          HEAP32[($3 + 36 | 0) >> 2] = i64toi32_i32$0;
          label$13 : {
           label$14 : {
            if ((HEAP32[($3 + 20 | 0) >> 2] | 0) >>> 0 < (HEAP32[($3 + 36 | 0) >> 2] | 0) >>> 0) {
             break label$14
            }
            HEAP32[(($3 + 48 | 0) + 8 | 0) >> 2] = HEAP32[$6 >> 2] | 0;
            i64toi32_i32$2 = $1;
            i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
            i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
            $76 = i64toi32_i32$0;
            i64toi32_i32$0 = $3;
            HEAP32[($3 + 48 | 0) >> 2] = $76;
            HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$1;
            num_bigint__biguint__addition___impl_20core__ops__arith__Add__num_bigint__biguint__BigUint__20for_20num_bigint__biguint__BigUint___add__ha6a5672f04e3ed65($3 | 0, $3 + 48 | 0 | 0, $3 + 32 | 0 | 0);
            $2 = HEAP32[($3 + 36 | 0) >> 2] | 0;
            if (!$2) {
             break label$13
            }
            $2 = $2 << 2 | 0;
            if (!$2) {
             break label$13
            }
            __rust_dealloc(HEAP32[($3 + 32 | 0) >> 2] | 0 | 0, $2 | 0, 4 | 0);
            break label$13;
           }
           HEAP32[(($3 + 48 | 0) + 8 | 0) >> 2] = HEAP32[$7 >> 2] | 0;
           i64toi32_i32$2 = $2;
           i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
           $100 = i64toi32_i32$1;
           i64toi32_i32$1 = $3;
           HEAP32[($3 + 48 | 0) >> 2] = $100;
           HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$0;
           num_bigint__biguint__addition___impl_20core__ops__arith__Add__num_bigint__biguint__BigUint__20for_20num_bigint__biguint__BigUint___add__ha6a5672f04e3ed65($3 | 0, $3 + 48 | 0 | 0, $3 + 16 | 0 | 0);
           $2 = HEAP32[($3 + 20 | 0) >> 2] | 0;
           if (!$2) {
            break label$13
           }
           $2 = $2 << 2 | 0;
           if (!$2) {
            break label$13
           }
           __rust_dealloc(HEAP32[($3 + 16 | 0) >> 2] | 0 | 0, $2 | 0, 4 | 0);
          }
          label$15 : {
           if (($5 | 0) == (1 | 0)) {
            break label$15
           }
           $2 = HEAP32[($3 + 8 | 0) >> 2] | 0 ? $5 : 1;
           break label$7;
          }
          $6 = 0;
          HEAP32[($3 + 8 | 0) >> 2] = 0;
          $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend__T_2ccore__slice__iter__Iter_T_____spec_extend__h5cdab7a667860bc4($3 | 0, 1082816 | 0, 1082816 | 0);
          $2 = HEAP32[($3 + 8 | 0) >> 2] | 0;
          if (!$2) {
           break label$8
          }
          $1 = (($2 << 2 | 0) + (HEAP32[$3 >> 2] | 0) | 0) + -4 | 0;
          label$16 : while (1) {
           label$17 : {
            if (!(HEAP32[$1 >> 2] | 0)) {
             break label$17
            }
            $6 = $2;
            break label$8;
           }
           $2 = $2 + -1 | 0;
           HEAP32[($3 + 8 | 0) >> 2] = $2;
           $1 = $1 + -4 | 0;
           if ($2) {
            continue label$16
           }
           break label$8;
          };
         }
         i64toi32_i32$2 = $2;
         i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
         $148 = i64toi32_i32$0;
         i64toi32_i32$0 = $0;
         HEAP32[i64toi32_i32$0 >> 2] = $148;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$2 = $2 + 8 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $153 = i64toi32_i32$1;
         i64toi32_i32$1 = $0 + 8 | 0;
         HEAP32[i64toi32_i32$1 >> 2] = $153;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
         break label$5;
        }
        $2 = 1;
        $1 = HEAP32[($3 + 4 | 0) >> 2] | 0;
        if ($1 >>> 0 <= $6 >>> 0) {
         break label$7
        }
        if ($6 >>> 0 >= ($1 >>> 2 | 0) >>> 0) {
         break label$7
        }
        alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($3 | 0, $6 | 0);
       }
       HEAP8[($0 + 12 | 0) >> 0] = $2;
       i64toi32_i32$2 = $3;
       i64toi32_i32$0 = HEAP32[$3 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($3 + 4 | 0) >> 2] | 0;
       $169 = i64toi32_i32$0;
       i64toi32_i32$0 = $0;
       HEAP32[i64toi32_i32$0 >> 2] = $169;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($3 + 8 | 0) >> 2] | 0;
       break label$1;
      }
      $8 = HEAP32[$2 >> 2] | 0;
      label$18 : {
       label$19 : {
        $6 = HEAP32[($1 + 8 | 0) >> 2] | 0;
        $7 = HEAP32[($2 + 8 | 0) >> 2] | 0;
        $9 = $6 >>> 0 < $7 >>> 0 ? -1 : ($6 | 0) != ($7 | 0);
        if ($9) {
         break label$19
        }
        $10 = $8 + -4 | 0;
        $7 = $7 << 2 | 0;
        $6 = $6 << 2 | 0;
        $11 = (HEAP32[$1 >> 2] | 0) + -4 | 0;
        label$20 : while (1) {
         label$21 : {
          if ($6) {
           break label$21
          }
          $9 = $7 ? -1 : 0;
          break label$19;
         }
         if (!$7) {
          break label$18
         }
         $9 = $11 + $6 | 0;
         $12 = $10 + $7 | 0;
         $7 = $7 + -4 | 0;
         $6 = $6 + -4 | 0;
         $9 = HEAP32[$9 >> 2] | 0;
         $12 = HEAP32[$12 >> 2] | 0;
         $9 = $9 >>> 0 < $12 >>> 0 ? -1 : ($9 | 0) != ($12 | 0);
         if (!$9) {
          continue label$20
         }
         break label$20;
        };
       }
       label$22 : {
        switch ($9 + 1 | 0 | 0) {
        default:
         HEAP32[(($3 + 32 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
         i64toi32_i32$2 = $1;
         i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
         $236 = i64toi32_i32$1;
         i64toi32_i32$1 = $3;
         HEAP32[($3 + 32 | 0) >> 2] = $236;
         HEAP32[($3 + 36 | 0) >> 2] = i64toi32_i32$0;
         $1 = ($3 + 48 | 0) + 8 | 0;
         HEAP32[$1 >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
         i64toi32_i32$2 = $2;
         i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
         $246 = i64toi32_i32$0;
         i64toi32_i32$0 = $3;
         HEAP32[($3 + 48 | 0) >> 2] = $246;
         HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$1;
         num_bigint__biguint__subtraction___impl_20core__ops__arith__SubAssign__num_bigint__biguint__BigUint__20for_20num_bigint__biguint__BigUint___sub_assign__h4ea1a97f3b7bcde9($3 + 48 | 0 | 0, $3 + 32 | 0 | 0);
         i64toi32_i32$2 = $3;
         i64toi32_i32$1 = HEAP32[($3 + 48 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($3 + 52 | 0) >> 2] | 0;
         $253 = i64toi32_i32$1;
         i64toi32_i32$1 = $3;
         HEAP32[($3 + 16 | 0) >> 2] = $253;
         HEAP32[($3 + 20 | 0) >> 2] = i64toi32_i32$0;
         $2 = HEAP32[$1 >> 2] | 0;
         label$24 : {
          $1 = HEAP32[($3 + 36 | 0) >> 2] | 0;
          if (!$1) {
           break label$24
          }
          $1 = $1 << 2 | 0;
          if (!$1) {
           break label$24
          }
          __rust_dealloc(HEAP32[($3 + 32 | 0) >> 2] | 0 | 0, $1 | 0, 4 | 0);
         }
         HEAP32[($0 + 8 | 0) >> 2] = $2;
         i64toi32_i32$2 = $3;
         i64toi32_i32$0 = HEAP32[($3 + 16 | 0) >> 2] | 0;
         i64toi32_i32$1 = HEAP32[($3 + 20 | 0) >> 2] | 0;
         $271 = i64toi32_i32$0;
         i64toi32_i32$0 = $0;
         HEAP32[i64toi32_i32$0 >> 2] = $271;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         HEAP8[(i64toi32_i32$0 + 12 | 0) >> 0] = $2 ? $4 : 1;
         break label$1;
        case 2:
         break label$18;
        case 1:
         break label$22;
        };
       }
       i64toi32_i32$0 = $0;
       i64toi32_i32$1 = 0;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = 0;
       HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
       HEAP8[(i64toi32_i32$0 + 12 | 0) >> 0] = 1;
       HEAP32[i64toi32_i32$0 >> 2] = HEAP32[(0 + 1082808 | 0) >> 2] | 0;
       $2 = HEAP32[($2 + 4 | 0) >> 2] | 0;
       if (!$2) {
        break label$5
       }
       $2 = $2 << 2 | 0;
       if (!$2) {
        break label$5
       }
       __rust_dealloc($8 | 0, $2 | 0, 4 | 0);
       break label$5;
      }
      HEAP32[(($3 + 32 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
      i64toi32_i32$2 = $2;
      i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
      $298 = i64toi32_i32$1;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 32 | 0) >> 2] = $298;
      HEAP32[($3 + 36 | 0) >> 2] = i64toi32_i32$0;
      $2 = ($3 + 48 | 0) + 8 | 0;
      HEAP32[$2 >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
      i64toi32_i32$2 = $1;
      i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      $308 = i64toi32_i32$0;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 48 | 0) >> 2] = $308;
      HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$1;
      num_bigint__biguint__subtraction___impl_20core__ops__arith__SubAssign__num_bigint__biguint__BigUint__20for_20num_bigint__biguint__BigUint___sub_assign__h4ea1a97f3b7bcde9($3 + 48 | 0 | 0, $3 + 32 | 0 | 0);
      HEAP32[(($3 + 16 | 0) + 8 | 0) >> 2] = HEAP32[$2 >> 2] | 0;
      i64toi32_i32$2 = $3;
      i64toi32_i32$1 = HEAP32[($3 + 48 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($3 + 52 | 0) >> 2] | 0;
      $320 = i64toi32_i32$1;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 16 | 0) >> 2] = $320;
      HEAP32[($3 + 20 | 0) >> 2] = i64toi32_i32$0;
      label$25 : {
       $2 = HEAP32[($3 + 36 | 0) >> 2] | 0;
       if (!$2) {
        break label$25
       }
       $2 = $2 << 2 | 0;
       if (!$2) {
        break label$25
       }
       __rust_dealloc(HEAP32[($3 + 32 | 0) >> 2] | 0 | 0, $2 | 0, 4 | 0);
      }
      label$26 : {
       if (($5 | 0) == (1 | 0)) {
        break label$26
       }
       $2 = HEAP32[($3 + 24 | 0) >> 2] | 0 ? $5 : 1;
       break label$3;
      }
      $6 = 0;
      HEAP32[($3 + 24 | 0) >> 2] = 0;
      $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend__T_2ccore__slice__iter__Iter_T_____spec_extend__h5cdab7a667860bc4($3 + 16 | 0 | 0, 1082816 | 0, 1082816 | 0);
      $2 = HEAP32[($3 + 24 | 0) >> 2] | 0;
      if (!$2) {
       break label$4
      }
      $1 = (($2 << 2 | 0) + (HEAP32[($3 + 16 | 0) >> 2] | 0) | 0) + -4 | 0;
      label$27 : while (1) {
       label$28 : {
        if (!(HEAP32[$1 >> 2] | 0)) {
         break label$28
        }
        $6 = $2;
        break label$4;
       }
       $2 = $2 + -1 | 0;
       HEAP32[($3 + 24 | 0) >> 2] = $2;
       $1 = $1 + -4 | 0;
       if ($2) {
        continue label$27
       }
       break label$4;
      };
     }
     $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     if (!$2) {
      break label$1
     }
     $2 = $2 << 2 | 0;
     if (!$2) {
      break label$1
     }
     __rust_dealloc(HEAP32[$1 >> 2] | 0 | 0, $2 | 0, 4 | 0);
     break label$1;
    }
    $2 = 1;
    $1 = HEAP32[($3 + 20 | 0) >> 2] | 0;
    if ($1 >>> 0 <= $6 >>> 0) {
     break label$3
    }
    if ($6 >>> 0 >= ($1 >>> 2 | 0) >>> 0) {
     break label$3
    }
    alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($3 + 16 | 0 | 0, $6 | 0);
   }
   HEAP8[($0 + 12 | 0) >> 0] = $2;
   i64toi32_i32$2 = $3;
   i64toi32_i32$0 = HEAP32[($3 + 16 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($3 + 20 | 0) >> 2] | 0;
   $389 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[i64toi32_i32$0 >> 2] = $389;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[(($3 + 16 | 0) + 8 | 0) >> 2] | 0;
  }
  global$0 = $3 + 64 | 0;
 }
 
 function $cardano_serialization_lib__tx_builder__TransactionBuilder_20as_20core__clone__Clone___clone__h4273e58f8bc63575($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, $2 = 0, i64toi32_i32$1 = 0, $3 = 0, $4 = 0, $63 = 0, $64 = 0, $65 = 0, $66 = 0, $9 = 0, $9$hi = 0, $23 = 0, $23$hi = 0, $5 = 0, $10 = 0, $10$hi = 0, $11 = 0, $11$hi = 0, $12 = 0, $12$hi = 0, $13 = 0, $13$hi = 0, $14 = 0, $14$hi = 0, $6 = 0, $7 = 0, $15 = 0, $15$hi = 0, $16 = 0, $16$hi = 0, $17 = 0, $17$hi = 0, $18 = 0, $18$hi = 0, $8 = 0, $19 = 0, $19$hi = 0, $20 = 0, $20$hi = 0, $21 = 0, $21$hi = 0, $22 = 0, $22$hi = 0, $190 = 0, $193 = 0, $24 = 0, $24$hi = 0, $25 = 0, $25$hi = 0, $231 = 0, $236 = 0, $241 = 0, $245 = 0, $308 = 0, $311 = 0, $339 = 0, $345 = 0, $348 = 0, $358 = 0, $364 = 0, $369 = 0, $374 = 0, $383 = 0;
  $2 = global$0 - 416 | 0;
  global$0 = $2;
  $3 = $1 + 416 | 0;
  $4 = $1 + 176 | 0;
  $5 = $1 + 96 | 0;
  i64toi32_i32$0 = 0;
  $9 = 1;
  $9$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    i64toi32_i32$2 = $1;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    i64toi32_i32$3 = 1;
    if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
     break label$2
    }
    i64toi32_i32$2 = 0;
    $9 = 0;
    $9$hi = i64toi32_i32$2;
    break label$1;
   }
   i64toi32_i32$3 = $1 + 72 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $10 = i64toi32_i32$2;
   $10$hi = i64toi32_i32$1;
   i64toi32_i32$3 = $1 + 64 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $11 = i64toi32_i32$1;
   $11$hi = i64toi32_i32$2;
   i64toi32_i32$3 = $1 + 56 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $12 = i64toi32_i32$2;
   $12$hi = i64toi32_i32$1;
   i64toi32_i32$3 = $1 + 48 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $13 = i64toi32_i32$1;
   $13$hi = i64toi32_i32$2;
  }
  i64toi32_i32$3 = $1;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 36 | 0) >> 2] | 0;
  $14 = i64toi32_i32$2;
  $14$hi = i64toi32_i32$1;
  $6 = HEAP32[(i64toi32_i32$3 + 84 | 0) >> 2] | 0;
  $7 = HEAP32[(i64toi32_i32$3 + 80 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 24 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 28 | 0) >> 2] | 0;
  $15 = i64toi32_i32$1;
  $15$hi = i64toi32_i32$2;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 20 | 0) >> 2] | 0;
  $16 = i64toi32_i32$2;
  $16$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 12 | 0) >> 2] | 0;
  $17 = i64toi32_i32$1;
  $17$hi = i64toi32_i32$2;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$2;
  $18$hi = i64toi32_i32$1;
  $8 = HEAPU8[(i64toi32_i32$3 + 88 | 0) >> 0] | 0;
  $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__hc97a6f621815d13c(($2 + 8 | 0) + 64 | 0 | 0, i64toi32_i32$3 + 160 | 0 | 0);
  $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__hf9a33b4634734bb7(($2 + 88 | 0) + 40 | 0 | 0, i64toi32_i32$3 + 136 | 0 | 0);
  $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h023fc265abc510b5($2 + 88 | 0 | 0, $5 | 0);
  $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__hf5a9da539450c63e(($2 + 88 | 0) + 52 | 0 | 0, i64toi32_i32$3 + 148 | 0 | 0);
  memcpy($2 + 8 | 0 | 0, $2 + 88 | 0 | 0, 64 | 0) | 0;
  $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__hc97a6f621815d13c(($2 + 88 | 0) + 64 | 0 | 0, i64toi32_i32$3 + 240 | 0 | 0);
  $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__hf9a33b4634734bb7(($2 + 336 | 0) + 40 | 0 | 0, i64toi32_i32$3 + 216 | 0 | 0);
  $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h023fc265abc510b5($2 + 336 | 0 | 0, $4 | 0);
  $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__hf5a9da539450c63e(($2 + 336 | 0) + 52 | 0 | 0, i64toi32_i32$3 + 228 | 0 | 0);
  memcpy($2 + 88 | 0 | 0, $2 + 336 | 0 | 0, 64 | 0) | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h699bb0f3db607312($2 + 168 | 0 | 0, $3 | 0);
  i64toi32_i32$3 = i64toi32_i32$3 + 280 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$1;
  $19$hi = i64toi32_i32$2;
  i64toi32_i32$3 = $1 + 264 | 0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
  $20 = i64toi32_i32$2;
  $20$hi = i64toi32_i32$1;
  i64toi32_i32$3 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 272 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 276 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  $21$hi = i64toi32_i32$2;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 256 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 260 | 0) >> 2] | 0;
  $22 = i64toi32_i32$2;
  $22$hi = i64toi32_i32$1;
  label$3 : {
   label$4 : {
    if (HEAP32[(i64toi32_i32$3 + 428 | 0) >> 2] | 0) {
     break label$4
    }
    HEAP32[($2 + 184 | 0) >> 2] = 0;
    break label$3;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h965baa5031061a2e($2 + 184 | 0 | 0, $1 + 428 | 0 | 0);
  }
  label$5 : {
   label$6 : {
    if (HEAP32[($1 + 308 | 0) >> 2] | 0) {
     break label$6
    }
    HEAP32[($2 + 220 | 0) >> 2] = 0;
    break label$5;
   }
   $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h8cac34049618832f($2 + 200 | 0 | 0, $1 + 288 | 0 | 0);
  }
  i64toi32_i32$1 = 0;
  $23 = 0;
  $23$hi = i64toi32_i32$1;
  label$7 : {
   i64toi32_i32$3 = $1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 328 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 332 | 0) >> 2] | 0;
   i64toi32_i32$3 = i64toi32_i32$1;
   i64toi32_i32$1 = 0;
   i64toi32_i32$0 = 1;
   if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
    break label$7
   }
   label$8 : {
    label$9 : {
     if (HEAP32[($1 + 356 | 0) >> 2] | 0) {
      break label$9
     }
     HEAP32[($2 + 260 | 0) >> 2] = 0;
     break label$8;
    }
    $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h44c6d4679ef9fae6($2 + 240 | 0 | 0, $1 + 336 | 0 | 0);
   }
   $3 = $1 + 388 | 0;
   label$10 : {
    label$11 : {
     $4 = HEAP32[($1 + 376 | 0) >> 2] | 0;
     if ($4) {
      break label$11
     }
     HEAP32[($2 + 400 | 0) >> 2] = 0;
     break label$10;
    }
    alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($2 + 400 | 0 | 0, $4 | 0, HEAP32[($1 + 384 | 0) >> 2] | 0 | 0);
   }
   label$12 : {
    label$13 : {
     if (HEAP32[$3 >> 2] | 0) {
      break label$13
     }
     HEAP32[($2 + 304 | 0) >> 2] = 0;
     break label$12;
    }
    $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hc722e22117ee5940($2 + 304 | 0 | 0, $3 | 0);
   }
   memcpy($2 + 336 | 0 | 0, $2 + 240 | 0 | 0, 40 | 0) | 0;
   HEAP32[($2 + 384 | 0) >> 2] = HEAP32[(($2 + 400 | 0) + 8 | 0) >> 2] | 0;
   HEAP32[($2 + 396 | 0) >> 2] = HEAP32[(($2 + 304 | 0) + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = $2;
   i64toi32_i32$3 = HEAP32[($2 + 400 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($2 + 404 | 0) >> 2] | 0;
   $190 = i64toi32_i32$3;
   i64toi32_i32$3 = $2;
   HEAP32[(i64toi32_i32$3 + 376 | 0) >> 2] = $190;
   HEAP32[(i64toi32_i32$3 + 380 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = i64toi32_i32$3;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 304 | 0) >> 2] | 0;
   i64toi32_i32$3 = HEAP32[(i64toi32_i32$3 + 308 | 0) >> 2] | 0;
   $193 = i64toi32_i32$2;
   i64toi32_i32$2 = $2;
   HEAP32[(i64toi32_i32$2 + 388 | 0) >> 2] = $193;
   HEAP32[(i64toi32_i32$2 + 392 | 0) >> 2] = i64toi32_i32$3;
   memcpy(i64toi32_i32$2 + 240 | 0 | 0, i64toi32_i32$2 + 336 | 0 | 0, 64 | 0) | 0;
   i64toi32_i32$3 = 0;
   $23 = 1;
   $23$hi = i64toi32_i32$3;
  }
  i64toi32_i32$0 = $1 + 408 | 0;
  i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $24 = i64toi32_i32$3;
  $24$hi = i64toi32_i32$2;
  i64toi32_i32$0 = $1;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 400 | 0) >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 404 | 0) >> 2] | 0;
  $25 = i64toi32_i32$2;
  $25$hi = i64toi32_i32$3;
  $3 = 0;
  label$14 : {
   if ((HEAP32[(i64toi32_i32$0 + 440 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$14
   }
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h3d696390b8f8d3c9($2 + 304 | 0 | 4 | 0 | 0, $1 + 444 | 0 | 0);
   $3 = 1;
  }
  HEAP32[($2 + 304 | 0) >> 2] = $3;
  label$15 : {
   label$16 : {
    $3 = HEAP32[($1 + 456 | 0) >> 2] | 0;
    if ($3) {
     break label$16
    }
    HEAP32[($2 + 320 | 0) >> 2] = 0;
    break label$15;
   }
   alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($2 + 320 | 0 | 0, $3 | 0, HEAP32[($1 + 464 | 0) >> 2] | 0 | 0);
  }
  $3 = 0;
  label$17 : {
   if ((HEAPU8[($1 + 480 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$17
   }
   i64toi32_i32$0 = $1 + 505 | 0;
   i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $231 = i64toi32_i32$3;
   i64toi32_i32$3 = $2 + 360 | 0;
   HEAP32[i64toi32_i32$3 >> 2] = $231;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = $1 + 497 | 0;
   i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$3 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $236 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 352 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $236;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$0 = $1 + 489 | 0;
   i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $241 = i64toi32_i32$3;
   i64toi32_i32$3 = $2 + 344 | 0;
   HEAP32[i64toi32_i32$3 >> 2] = $241;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = $1 + 481 | 0;
   i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$3 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $245 = i64toi32_i32$2;
   i64toi32_i32$2 = $2;
   HEAP32[(i64toi32_i32$2 + 336 | 0) >> 2] = $245;
   HEAP32[(i64toi32_i32$2 + 340 | 0) >> 2] = i64toi32_i32$3;
   $3 = 1;
  }
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h25db889dc58a550d($2 + 400 | 0 | 0, $1 + 468 | 0 | 0);
  HEAP8[($0 + 88 | 0) >> 0] = $8;
  HEAP32[($0 + 84 | 0) >> 2] = $6;
  HEAP32[($0 + 80 | 0) >> 2] = $7;
  i64toi32_i32$3 = $10$hi;
  i64toi32_i32$2 = $0 + 72 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $10;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
  i64toi32_i32$3 = $11$hi;
  i64toi32_i32$2 = $0 + 64 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $11;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
  i64toi32_i32$3 = $12$hi;
  i64toi32_i32$2 = $0 + 56 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $12;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
  i64toi32_i32$3 = $13$hi;
  i64toi32_i32$2 = $0 + 48 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $13;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
  i64toi32_i32$3 = $9$hi;
  i64toi32_i32$2 = $0;
  HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] = $9;
  HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] = i64toi32_i32$3;
  i64toi32_i32$3 = $14$hi;
  HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] = $14;
  HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] = i64toi32_i32$3;
  i64toi32_i32$3 = $15$hi;
  HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] = $15;
  HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] = i64toi32_i32$3;
  i64toi32_i32$3 = $16$hi;
  HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] = $16;
  HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] = i64toi32_i32$3;
  i64toi32_i32$3 = $17$hi;
  HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $17;
  HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$3;
  i64toi32_i32$3 = $18$hi;
  HEAP32[i64toi32_i32$2 >> 2] = $18;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
  memcpy(i64toi32_i32$2 + 96 | 0 | 0, $2 + 8 | 0 | 0, 80 | 0) | 0;
  memcpy(i64toi32_i32$2 + 176 | 0 | 0, $2 + 88 | 0 | 0, 80 | 0) | 0;
  i64toi32_i32$3 = $19$hi;
  i64toi32_i32$2 = i64toi32_i32$2 + 280 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $19;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
  i64toi32_i32$3 = $21$hi;
  i64toi32_i32$2 = $0;
  HEAP32[(i64toi32_i32$2 + 272 | 0) >> 2] = $21;
  HEAP32[(i64toi32_i32$2 + 276 | 0) >> 2] = i64toi32_i32$3;
  i64toi32_i32$3 = $20$hi;
  i64toi32_i32$2 = i64toi32_i32$2 + 264 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $20;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
  i64toi32_i32$3 = $22$hi;
  i64toi32_i32$2 = $0;
  HEAP32[(i64toi32_i32$2 + 256 | 0) >> 2] = $22;
  HEAP32[(i64toi32_i32$2 + 260 | 0) >> 2] = i64toi32_i32$3;
  HEAP32[(i64toi32_i32$2 + 424 | 0) >> 2] = HEAP32[(($2 + 168 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = $2;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 168 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 172 | 0) >> 2] | 0;
  $308 = i64toi32_i32$3;
  i64toi32_i32$3 = $0;
  HEAP32[(i64toi32_i32$3 + 416 | 0) >> 2] = $308;
  HEAP32[(i64toi32_i32$3 + 420 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 184 | 0) >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 188 | 0) >> 2] | 0;
  $311 = i64toi32_i32$2;
  i64toi32_i32$2 = $0;
  HEAP32[(i64toi32_i32$2 + 428 | 0) >> 2] = $311;
  HEAP32[(i64toi32_i32$2 + 432 | 0) >> 2] = i64toi32_i32$3;
  HEAP32[(i64toi32_i32$2 + 436 | 0) >> 2] = HEAP32[((i64toi32_i32$0 + 184 | 0) + 8 | 0) >> 2] | 0;
  memcpy(i64toi32_i32$2 + 288 | 0 | 0, i64toi32_i32$0 + 200 | 0 | 0, 40 | 0) | 0;
  i64toi32_i32$3 = $23$hi;
  HEAP32[(i64toi32_i32$2 + 328 | 0) >> 2] = $23;
  HEAP32[(i64toi32_i32$2 + 332 | 0) >> 2] = i64toi32_i32$3;
  memcpy(i64toi32_i32$2 + 336 | 0 | 0, i64toi32_i32$0 + 240 | 0 | 0, 64 | 0) | 0;
  i64toi32_i32$3 = $24$hi;
  i64toi32_i32$2 = i64toi32_i32$2 + 408 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $24;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
  i64toi32_i32$3 = $25$hi;
  i64toi32_i32$2 = $0;
  HEAP32[(i64toi32_i32$2 + 400 | 0) >> 2] = $25;
  HEAP32[(i64toi32_i32$2 + 404 | 0) >> 2] = i64toi32_i32$3;
  HEAP8[(i64toi32_i32$2 + 480 | 0) >> 0] = $3;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 304 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 308 | 0) >> 2] | 0;
  $339 = i64toi32_i32$3;
  i64toi32_i32$3 = $0;
  HEAP32[(i64toi32_i32$3 + 440 | 0) >> 2] = $339;
  HEAP32[(i64toi32_i32$3 + 444 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$0 = (i64toi32_i32$0 + 304 | 0) + 8 | 0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $345 = i64toi32_i32$2;
  i64toi32_i32$2 = $0 + 448 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $345;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
  i64toi32_i32$0 = $2;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 320 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 324 | 0) >> 2] | 0;
  $348 = i64toi32_i32$3;
  i64toi32_i32$3 = $0;
  HEAP32[(i64toi32_i32$3 + 456 | 0) >> 2] = $348;
  HEAP32[(i64toi32_i32$3 + 460 | 0) >> 2] = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$3 + 464 | 0) >> 2] = HEAP32[((i64toi32_i32$0 + 320 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 336 | 0) >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 340 | 0) >> 2] | 0;
  $358 = i64toi32_i32$2;
  i64toi32_i32$2 = $0 + 481 | 0;
  $63 = $358;
  HEAP8[i64toi32_i32$2 >> 0] = $63;
  HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $63 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $63 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $63 >>> 24 | 0;
  HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$3;
  HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
  i64toi32_i32$0 = (i64toi32_i32$0 + 336 | 0) + 8 | 0;
  i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $364 = i64toi32_i32$3;
  i64toi32_i32$3 = $0 + 489 | 0;
  $64 = $364;
  HEAP8[i64toi32_i32$3 >> 0] = $64;
  HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $64 >>> 8 | 0;
  HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $64 >>> 16 | 0;
  HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $64 >>> 24 | 0;
  HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$2;
  HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
  HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
  HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
  i64toi32_i32$0 = $2 + 352 | 0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $369 = i64toi32_i32$2;
  i64toi32_i32$2 = $0 + 497 | 0;
  $65 = $369;
  HEAP8[i64toi32_i32$2 >> 0] = $65;
  HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $65 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $65 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $65 >>> 24 | 0;
  HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$3;
  HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
  i64toi32_i32$0 = $2 + 360 | 0;
  i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $374 = i64toi32_i32$3;
  i64toi32_i32$3 = $0 + 505 | 0;
  $66 = $374;
  HEAP8[i64toi32_i32$3 >> 0] = $66;
  HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $66 >>> 8 | 0;
  HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $66 >>> 16 | 0;
  HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $66 >>> 24 | 0;
  HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$2;
  HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
  HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
  HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
  HEAP32[($0 + 476 | 0) >> 2] = HEAP32[(($2 + 400 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = $2;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 400 | 0) >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 404 | 0) >> 2] | 0;
  $383 = i64toi32_i32$2;
  i64toi32_i32$2 = $0;
  HEAP32[(i64toi32_i32$2 + 468 | 0) >> 2] = $383;
  HEAP32[(i64toi32_i32$2 + 472 | 0) >> 2] = i64toi32_i32$3;
  global$0 = i64toi32_i32$0 + 416 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__MoveInstantaneousReward___deserialize__h01d321bfaafb2a23($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, $2 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, $13 = 0, $9 = 0, $7 = 0, $7$hi = 0, $9$hi = 0, $4 = 0, $5 = 0, $6 = 0, $13$hi = 0, $11 = 0, $11$hi = 0, $12 = 0, $12$hi = 0, $3 = 0, $8 = 0, $8$hi = 0, $10 = 0, $10$hi = 0, $36 = 0, $37 = 0, $38 = 0, $39 = 0, $40 = 0, $41 = 0, $42 = 0, $43 = 0, $44 = 0, $45 = 0, $46 = 0, $47 = 0, $48 = 0, $49 = 0, $50 = 0, $51 = 0, $52 = 0, $53 = 0, $89 = 0, $89$hi = 0, $93 = 0, $93$hi = 0, $98$hi = 0, $100$hi = 0, $151 = 0, $156 = 0, $328 = 0, $331 = 0;
  $2 = global$0 - 128 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 56 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2 + 72 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 64 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 68 | 0) >> 2] | 0;
  $8 = i64toi32_i32$1;
  $8$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           i64toi32_i32$2 = $2;
           i64toi32_i32$0 = HEAP32[($2 + 56 | 0) >> 2] | 0;
           i64toi32_i32$1 = HEAP32[($2 + 60 | 0) >> 2] | 0;
           i64toi32_i32$2 = i64toi32_i32$0;
           i64toi32_i32$0 = 0;
           i64toi32_i32$3 = 1;
           if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
            break label$9
           }
           cbor_event__de__Deserializer_R___unsigned_integer__h1ed99c0b7fe7eea1($2 + 56 | 0 | 0, $1 | 0);
           i64toi32_i32$3 = $2;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 64 | 0) >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 68 | 0) >> 2] | 0;
           $9 = i64toi32_i32$2;
           $9$hi = i64toi32_i32$1;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 56 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 60 | 0) >> 2] | 0;
           i64toi32_i32$3 = i64toi32_i32$1;
           i64toi32_i32$1 = 0;
           i64toi32_i32$0 = 1;
           if ((i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$1 | 0) | 0) {
            break label$7
           }
           $3 = 0;
           i64toi32_i32$3 = $9$hi;
           i64toi32_i32$0 = $9;
           i64toi32_i32$2 = 0;
           i64toi32_i32$1 = 1;
           if (i64toi32_i32$3 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$0 >>> 0 <= i64toi32_i32$1 >>> 0 | 0) | 0) {
            break label$8
           }
           $4 = 16;
           $5 = 1;
           i64toi32_i32$0 = $9$hi;
           $7 = $9;
           $7$hi = i64toi32_i32$0;
           break label$2;
          }
          i64toi32_i32$0 = $8$hi;
          i64toi32_i32$1 = $8;
          i64toi32_i32$3 = 0;
          i64toi32_i32$2 = 32;
          i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
          if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
           i64toi32_i32$3 = 0;
           $37 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
          } else {
           i64toi32_i32$3 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
           $37 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
          }
          $6 = $37;
          i64toi32_i32$0 = $2 + 96 | 0;
          i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
          $10 = i64toi32_i32$3;
          $10$hi = i64toi32_i32$1;
          i64toi32_i32$0 = $2 + 88 | 0;
          i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
          i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
          $11 = i64toi32_i32$1;
          $11$hi = i64toi32_i32$3;
          i64toi32_i32$0 = $2 + 80 | 0;
          i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
          $12 = i64toi32_i32$3;
          $12$hi = i64toi32_i32$1;
          i64toi32_i32$1 = $8$hi;
          $5 = $8;
          break label$4;
         }
         i64toi32_i32$1 = $9$hi;
         switch ($9 | 0) {
         case 1:
          break label$6;
         default:
          break label$5;
         };
        }
        i64toi32_i32$1 = $9$hi;
        i64toi32_i32$0 = $9;
        i64toi32_i32$3 = 0;
        i64toi32_i32$2 = 32;
        i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
         i64toi32_i32$3 = 0;
         $38 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
        } else {
         i64toi32_i32$3 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
         $38 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
        }
        $6 = $38;
        i64toi32_i32$1 = $2 + 96 | 0;
        i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
        $10 = i64toi32_i32$3;
        $10$hi = i64toi32_i32$0;
        i64toi32_i32$1 = $2 + 88 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
        $11 = i64toi32_i32$0;
        $11$hi = i64toi32_i32$3;
        i64toi32_i32$1 = $2 + 80 | 0;
        i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
        $12 = i64toi32_i32$3;
        $12$hi = i64toi32_i32$0;
        i64toi32_i32$1 = $2 + 72 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
        $7 = i64toi32_i32$0;
        $7$hi = i64toi32_i32$3;
        i64toi32_i32$3 = $9$hi;
        $5 = $9;
        break label$4;
       }
       $3 = 1;
      }
      std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 | 0, $1 | 0);
      $6 = 0;
      label$10 : {
       label$11 : {
        label$12 : {
         label$13 : {
          label$14 : {
           label$15 : {
            if (HEAP32[($2 + 4 | 0) >> 2] | 0) {
             break label$15
            }
            $4 = 2;
            $5 = 8;
            i64toi32_i32$3 = 0;
            $7 = 0;
            $7$hi = i64toi32_i32$3;
            break label$14;
           }
           $4 = ($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[$2 >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0;
           if (!$4) {
            break label$12
           }
           if (($4 | 0) == (5 | 0)) {
            break label$13
           }
           $4 = 11;
          }
          $3 = 0;
          break label$2;
         }
         cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__MIRToStakeCredentials___deserialize__h4513cde789c99a1f($2 + 56 | 0 | 0, $1 | 0);
         i64toi32_i32$1 = $2;
         i64toi32_i32$3 = HEAPU8[(i64toi32_i32$1 + 65 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 66 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 67 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 68 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$0 = 0;
         $89 = i64toi32_i32$3;
         $89$hi = i64toi32_i32$0;
         i64toi32_i32$1 = (i64toi32_i32$1 + 56 | 0) + 13 | 0;
         i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
         i64toi32_i32$3 = 0;
         $93 = i64toi32_i32$0;
         $93$hi = i64toi32_i32$3;
         i64toi32_i32$1 = ($2 + 56 | 0) + 15 | 0;
         i64toi32_i32$3 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
         i64toi32_i32$0 = 0;
         i64toi32_i32$1 = i64toi32_i32$3;
         i64toi32_i32$3 = 0;
         i64toi32_i32$2 = 16;
         i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
          i64toi32_i32$3 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
          $39 = 0;
         } else {
          i64toi32_i32$3 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
          $39 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
         }
         $98$hi = i64toi32_i32$3;
         i64toi32_i32$3 = $93$hi;
         i64toi32_i32$0 = $93;
         i64toi32_i32$1 = $98$hi;
         i64toi32_i32$2 = $39;
         i64toi32_i32$1 = i64toi32_i32$3 | i64toi32_i32$1 | 0;
         i64toi32_i32$3 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
         i64toi32_i32$0 = 0;
         i64toi32_i32$2 = 32;
         i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
          i64toi32_i32$0 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
          $40 = 0;
         } else {
          i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
          $40 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
         }
         $100$hi = i64toi32_i32$0;
         i64toi32_i32$0 = $89$hi;
         i64toi32_i32$1 = $89;
         i64toi32_i32$3 = $100$hi;
         i64toi32_i32$2 = $40;
         i64toi32_i32$3 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
         $13 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
         $13$hi = i64toi32_i32$3;
         i64toi32_i32$0 = ($2 + 56 | 0) + 40 | 0;
         i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
         $11 = i64toi32_i32$3;
         $11$hi = i64toi32_i32$1;
         i64toi32_i32$0 = ($2 + 56 | 0) + 32 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
         $12 = i64toi32_i32$1;
         $12$hi = i64toi32_i32$3;
         i64toi32_i32$0 = ($2 + 56 | 0) + 24 | 0;
         i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
         $9 = i64toi32_i32$3;
         $9$hi = i64toi32_i32$1;
         $6 = HEAP32[(($2 + 56 | 0) + 20 | 0) >> 2] | 0;
         $5 = HEAP32[(($2 + 56 | 0) + 16 | 0) >> 2] | 0;
         $4 = HEAPU8[($2 + 64 | 0) >> 0] | 0;
         i64toi32_i32$0 = $2;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 56 | 0) >> 2] | 0;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 60 | 0) >> 2] | 0;
         i64toi32_i32$0 = i64toi32_i32$1;
         i64toi32_i32$1 = 0;
         i64toi32_i32$2 = 1;
         if ((i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) | 0) {
          break label$11
         }
         i64toi32_i32$0 = $11$hi;
         i64toi32_i32$3 = ($2 + 8 | 0) + 40 | 0;
         HEAP32[i64toi32_i32$3 >> 2] = $11;
         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$0 = $12$hi;
         i64toi32_i32$3 = ($2 + 8 | 0) + 32 | 0;
         HEAP32[i64toi32_i32$3 >> 2] = $12;
         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$0 = $9$hi;
         i64toi32_i32$3 = ($2 + 8 | 0) + 24 | 0;
         HEAP32[i64toi32_i32$3 >> 2] = $9;
         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
         HEAP32[(($2 + 8 | 0) + 20 | 0) >> 2] = $6;
         HEAP32[(($2 + 8 | 0) + 16 | 0) >> 2] = $5;
         i64toi32_i32$0 = $13$hi;
         HEAP8[($2 + 17 | 0) >> 0] = $13;
         HEAP8[($2 + 18 | 0) >> 0] = $13 >>> 8 | 0;
         HEAP8[($2 + 19 | 0) >> 0] = $13 >>> 16 | 0;
         HEAP8[($2 + 20 | 0) >> 0] = $13 >>> 24 | 0;
         $151 = ($2 + 8 | 0) + 15 | 0;
         i64toi32_i32$2 = $13;
         i64toi32_i32$3 = 0;
         i64toi32_i32$1 = 48;
         i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
          i64toi32_i32$3 = 0;
          $41 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
         } else {
          i64toi32_i32$3 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
          $41 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
         }
         HEAP8[$151 >> 0] = $41;
         $156 = ($2 + 8 | 0) + 13 | 0;
         i64toi32_i32$3 = $13$hi;
         i64toi32_i32$0 = $13;
         i64toi32_i32$2 = 0;
         i64toi32_i32$1 = 32;
         i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
          i64toi32_i32$2 = 0;
          $42 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
         } else {
          i64toi32_i32$2 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
          $42 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
         }
         $43 = $156;
         $44 = $42;
         HEAP8[$43 >> 0] = $44;
         HEAP8[($43 + 1 | 0) >> 0] = $44 >>> 8 | 0;
         HEAP8[($2 + 16 | 0) >> 0] = $4;
         i64toi32_i32$0 = $2;
         i64toi32_i32$2 = 0;
         HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = 1;
         HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
         i64toi32_i32$2 = $13$hi;
         i64toi32_i32$3 = $13;
         i64toi32_i32$0 = 0;
         i64toi32_i32$1 = 24;
         i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
          i64toi32_i32$0 = 0;
          $45 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
         } else {
          i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
          $45 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$4 | 0) | 0;
         }
         $6 = $45;
         $5 = 1;
         break label$10;
        }
        $cardano_serialization_lib__utils__BigNum_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h29637bb571dceb02($2 + 56 | 0 | 0, $1 | 0);
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 64 | 0) >> 2] | 0;
        i64toi32_i32$3 = HEAP32[($2 + 68 | 0) >> 2] | 0;
        $9 = i64toi32_i32$0;
        $9$hi = i64toi32_i32$3;
        label$16 : {
         i64toi32_i32$2 = $2;
         i64toi32_i32$3 = HEAP32[($2 + 56 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($2 + 60 | 0) >> 2] | 0;
         i64toi32_i32$2 = i64toi32_i32$3;
         i64toi32_i32$3 = 0;
         i64toi32_i32$1 = 1;
         if ((i64toi32_i32$2 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) | 0) {
          break label$16
         }
         i64toi32_i32$0 = $2;
         i64toi32_i32$2 = 0;
         HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = 0;
         HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
         i64toi32_i32$2 = $9$hi;
         HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $9;
         HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$2;
         i64toi32_i32$1 = $9;
         i64toi32_i32$0 = 0;
         i64toi32_i32$3 = 32;
         i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
          i64toi32_i32$0 = 0;
          $46 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
         } else {
          i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
          $46 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
         }
         $6 = $46;
         $5 = 0;
         break label$10;
        }
        i64toi32_i32$0 = $9$hi;
        i64toi32_i32$2 = $9;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 8;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$1 = 0;
         $47 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
        } else {
         i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
         $47 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
        }
        $13 = $47;
        $13$hi = i64toi32_i32$1;
        i64toi32_i32$0 = $2 + 120 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
        $8 = i64toi32_i32$1;
        $8$hi = i64toi32_i32$2;
        $3 = HEAP32[($2 + 112 | 0) >> 2] | 0;
        i64toi32_i32$0 = $2 + 104 | 0;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
        $10 = i64toi32_i32$2;
        $10$hi = i64toi32_i32$1;
        i64toi32_i32$0 = $2 + 96 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
        $11 = i64toi32_i32$1;
        $11$hi = i64toi32_i32$2;
        i64toi32_i32$0 = $2 + 88 | 0;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
        $12 = i64toi32_i32$2;
        $12$hi = i64toi32_i32$1;
        i64toi32_i32$0 = $2 + 80 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
        $7 = i64toi32_i32$1;
        $7$hi = i64toi32_i32$2;
        $6 = HEAP32[($2 + 76 | 0) >> 2] | 0;
        $5 = HEAP32[($2 + 72 | 0) >> 2] | 0;
        $1 = HEAP32[($2 + 116 | 0) >> 2] | 0;
        i64toi32_i32$2 = $9$hi;
        $4 = $9;
        break label$2;
       }
       i64toi32_i32$0 = $2 + 120 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
       $8 = i64toi32_i32$2;
       $8$hi = i64toi32_i32$1;
       $3 = HEAP32[($2 + 112 | 0) >> 2] | 0;
       i64toi32_i32$0 = $2 + 104 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
       $10 = i64toi32_i32$1;
       $10$hi = i64toi32_i32$2;
       $1 = HEAP32[($2 + 116 | 0) >> 2] | 0;
       i64toi32_i32$2 = $9$hi;
       $7 = $9;
       $7$hi = i64toi32_i32$2;
       break label$2;
      }
      label$17 : {
       label$18 : {
        label$19 : {
         label$20 : {
          i64toi32_i32$2 = $8$hi;
          i64toi32_i32$0 = $8;
          i64toi32_i32$1 = 0;
          i64toi32_i32$3 = 1;
          if ((i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$1 | 0) | 0) {
           break label$20
          }
          cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 56 | 0 | 0, $1 | 0);
          $1 = HEAPU8[($2 + 64 | 0) >> 0] | 0;
          i64toi32_i32$3 = $2;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 56 | 0) >> 2] | 0;
          i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 60 | 0) >> 2] | 0;
          i64toi32_i32$3 = i64toi32_i32$0;
          i64toi32_i32$0 = 0;
          i64toi32_i32$1 = 1;
          if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) | 0) {
           break label$19
          }
          $4 = 5;
          if (($1 | 0) == (5 | 0)) {
           break label$18
          }
          break label$17;
         }
         i64toi32_i32$3 = $7$hi;
         i64toi32_i32$1 = $7;
         i64toi32_i32$2 = 0;
         i64toi32_i32$0 = 2;
         if ((i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) | 0) {
          break label$18
         }
         $4 = 2;
         $5 = 13;
         $6 = 1051385;
         i64toi32_i32$1 = $7$hi;
         $12 = $7;
         $12$hi = i64toi32_i32$1;
         i64toi32_i32$1 = 0;
         $11 = 1;
         $11$hi = i64toi32_i32$1;
         i64toi32_i32$1 = $7$hi;
         $10 = $7;
         $10$hi = i64toi32_i32$1;
         i64toi32_i32$1 = 0;
         $7 = 23;
         $7$hi = i64toi32_i32$1;
         break label$17;
        }
        $5 = (HEAPU8[($2 + 65 | 0) >> 0] | 0 | ((HEAPU8[($2 + 66 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 67 | 0) >> 0] | 0) << 16 | 0) | 0) << 8 | 0 | $1 | 0;
        i64toi32_i32$0 = $2 + 96 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
        $10 = i64toi32_i32$1;
        $10$hi = i64toi32_i32$3;
        i64toi32_i32$0 = $2 + 88 | 0;
        i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
        $11 = i64toi32_i32$3;
        $11$hi = i64toi32_i32$1;
        i64toi32_i32$0 = $2 + 80 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
        $12 = i64toi32_i32$1;
        $12$hi = i64toi32_i32$3;
        i64toi32_i32$0 = ($2 + 56 | 0) + 16 | 0;
        i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
        $7 = i64toi32_i32$3;
        $7$hi = i64toi32_i32$1;
        $6 = HEAP32[($2 + 68 | 0) >> 2] | 0;
        $4 = 2;
        break label$17;
       }
       i64toi32_i32$0 = ($2 + 8 | 0) + 16 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
       $7 = i64toi32_i32$1;
       $7$hi = i64toi32_i32$3;
       $1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
       i64toi32_i32$3 = 0;
       $13 = 0;
       $13$hi = i64toi32_i32$3;
       i64toi32_i32$3 = 0;
       HEAP8[($0 + 15 | 0) >> 0] = 0;
       $48 = $0 + 13 | 0;
       i64toi32_i32$3 = 0;
       $49 = 0;
       HEAP8[$48 >> 0] = $49;
       HEAP8[($48 + 1 | 0) >> 0] = $49 >>> 8 | 0;
       i64toi32_i32$3 = 0;
       $36 = 0;
       HEAP8[($0 + 9 | 0) >> 0] = $36;
       HEAP8[($0 + 10 | 0) >> 0] = $36 >>> 8 | 0;
       HEAP8[($0 + 11 | 0) >> 0] = $36 >>> 16 | 0;
       HEAP8[($0 + 12 | 0) >> 0] = $36 >>> 24 | 0;
       HEAP32[($0 + 56 | 0) >> 2] = $3;
       i64toi32_i32$3 = $11$hi;
       i64toi32_i32$1 = $0 + 48 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $11;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
       i64toi32_i32$3 = $12$hi;
       i64toi32_i32$1 = $0 + 40 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $12;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
       i64toi32_i32$3 = $9$hi;
       i64toi32_i32$1 = $0 + 32 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $9;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
       i64toi32_i32$3 = $7$hi;
       i64toi32_i32$1 = $0 + 24 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $7;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
       HEAP32[($0 + 20 | 0) >> 2] = $6;
       HEAP32[($0 + 16 | 0) >> 2] = $1;
       HEAP8[($0 + 8 | 0) >> 0] = $5;
       break label$1;
      }
      core__ptr__drop_in_place_cardano_serialization_lib__MIREnum___h06315a825cbe6fa9($2 + 8 | 0 | 0);
      break label$3;
     }
     $4 = 2;
    }
    $3 = 0;
   }
   i64toi32_i32$3 = $8$hi;
   i64toi32_i32$1 = $2 + 112 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $8;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
   HEAP32[($2 + 108 | 0) >> 2] = $1;
   i64toi32_i32$3 = $10$hi;
   i64toi32_i32$1 = $2 + 96 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $10;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$3 = $11$hi;
   i64toi32_i32$1 = $2 + 88 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $11;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$3 = $12$hi;
   i64toi32_i32$1 = $2 + 80 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $12;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$3 = $7$hi;
   i64toi32_i32$1 = $2 + 72 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $7;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
   HEAP32[($2 + 68 | 0) >> 2] = $6;
   HEAP32[(($2 + 56 | 0) + 8 | 0) >> 2] = $5;
   HEAP32[($2 + 104 | 0) >> 2] = $3;
   HEAP8[($2 + 56 | 0) >> 0] = $4;
   i64toi32_i32$3 = $13$hi;
   HEAP8[($2 + 57 | 0) >> 0] = $13;
   HEAP8[($2 + 58 | 0) >> 0] = $13 >>> 8 | 0;
   HEAP8[($2 + 59 | 0) >> 0] = $13 >>> 16 | 0;
   HEAP8[($2 + 60 | 0) >> 0] = $13 >>> 24 | 0;
   $328 = $2;
   i64toi32_i32$0 = $13;
   i64toi32_i32$1 = 0;
   i64toi32_i32$2 = 48;
   i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
    i64toi32_i32$1 = 0;
    $50 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
   } else {
    i64toi32_i32$1 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
    $50 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
   }
   HEAP8[($328 + 63 | 0) >> 0] = $50;
   $331 = $2;
   i64toi32_i32$1 = $13$hi;
   i64toi32_i32$3 = $13;
   i64toi32_i32$0 = 0;
   i64toi32_i32$2 = 32;
   i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
    i64toi32_i32$0 = 0;
    $51 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   } else {
    i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
    $51 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$4 | 0) | 0;
   }
   $52 = $331;
   $53 = $51;
   HEAP8[($52 + 61 | 0) >> 0] = $53;
   HEAP8[($52 + 62 | 0) >> 0] = $53 >>> 8 | 0;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 56 | 0 | 0, 1051385 | 0, 23 | 0);
   i64toi32_i32$0 = 0;
   $13 = 1;
   $13$hi = i64toi32_i32$0;
  }
  i64toi32_i32$0 = $13$hi;
  i64toi32_i32$3 = $0;
  HEAP32[i64toi32_i32$3 >> 2] = $13;
  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 128 | 0;
 }
 
 function $cardano_serialization_lib__plutus__Costmdls_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hfe094af3bf4c55f1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, i64toi32_i32$2 = 0, $7 = 0, $9 = 0, $5 = 0, $9$hi = 0, $8 = 0, $8$hi = 0, $6 = 0, $38 = 0, $39 = 0, $40 = 0, $41 = 0, $42 = 0, $43 = 0, $44 = 0, $45 = 0, $46 = 0, $47 = 0, $48 = 0, $49 = 0, $50 = 0, $51 = 0, $3 = 0, $4 = 0, $66 = 0, $72 = 0, $89 = 0, $93 = 0, $145 = 0, $151 = 0, $167 = 0, $171 = 0, $238 = 0, $244 = 0, $254 = 0, $265 = 0, $271 = 0, $275 = 0, $280 = 0, $286 = 0, $290 = 0, $302 = 0, $306 = 0, $312 = 0, $318 = 0, $345 = 0;
  $2 = global$0 - 320 | 0;
  global$0 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 20 | 0) >> 2] = 0;
  HEAP32[($2 + 24 | 0) >> 2] = i64toi32_i32$0;
  cbor_event__de__Deserializer_R___map__h7c2a4e830d885a05($2 + 248 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = ($2 + 248 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 256 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 260 | 0) >> 2] | 0;
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 248 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 252 | 0) >> 2] | 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
         break label$6
        }
        i64toi32_i32$2 = $8$hi;
        $3 = $8;
        label$7 : {
         i64toi32_i32$2 = $9$hi;
         i64toi32_i32$3 = $9;
         i64toi32_i32$1 = 0;
         i64toi32_i32$0 = 1;
         if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
          break label$7
         }
         if (!$3) {
          break label$3
         }
        }
        $4 = $2 + 248 | 0 | 5 | 0;
        $5 = $2 + 257 | 0;
        label$8 : while (1) {
         std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 8 | 0 | 0, $1 | 0);
         $6 = 0;
         $7 = 2;
         label$9 : {
          if (HEAP32[($2 + 12 | 0) >> 2] | 0) {
           break label$9
          }
          i64toi32_i32$3 = 0;
          $9 = 8;
          $9$hi = i64toi32_i32$3;
          i64toi32_i32$3 = 0;
          $8 = 0;
          $8$hi = i64toi32_i32$3;
          break label$4;
         }
         label$10 : {
          label$11 : {
           label$12 : {
            if ((($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[($2 + 8 | 0) >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) == (7 | 0)) {
             break label$12
            }
            $cardano_serialization_lib__plutus__Language_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__ha3cda676d250cc98($2 + 248 | 0 | 0, $1 | 0);
            $7 = HEAPU8[($2 + 248 | 0) >> 0] | 0;
            if (($7 | 0) != (19 | 0)) {
             break label$11
            }
            $cardano_serialization_lib__plutus__CostModel_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hfd012f99d93cadfd($2 + 248 | 0 | 0, $1 | 0);
            if ((HEAP32[($2 + 248 | 0) >> 2] | 0 | 0) != (1 | 0)) {
             break label$10
            }
            i64toi32_i32$0 = $2 + 288 | 0;
            i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
            i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
            $66 = i64toi32_i32$3;
            i64toi32_i32$3 = ($2 + 176 | 0) + 8 | 0;
            HEAP32[i64toi32_i32$3 >> 2] = $66;
            HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
            i64toi32_i32$0 = $2 + 296 | 0;
            i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
            i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
            $72 = i64toi32_i32$2;
            i64toi32_i32$2 = ($2 + 176 | 0) + 16 | 0;
            HEAP32[i64toi32_i32$2 >> 2] = $72;
            HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
            HEAP32[(($2 + 160 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 316 | 0) >> 2] | 0;
            HEAP32[($2 + 224 | 0) >> 2] = HEAPU8[$5 >> 0] | 0 | ((HEAPU8[($5 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($5 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($5 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            $39 = $5 + 3 | 0;
            $40 = HEAPU8[$39 >> 0] | 0 | ((HEAPU8[($39 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($39 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($39 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            HEAP8[($2 + 227 | 0) >> 0] = $40;
            HEAP8[($2 + 228 | 0) >> 0] = $40 >>> 8 | 0;
            HEAP8[($2 + 229 | 0) >> 0] = $40 >>> 16 | 0;
            HEAP8[($2 + 230 | 0) >> 0] = $40 >>> 24 | 0;
            i64toi32_i32$0 = $2 + 280 | 0;
            i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
            i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
            $89 = i64toi32_i32$3;
            i64toi32_i32$3 = $2;
            HEAP32[($2 + 176 | 0) >> 2] = $89;
            HEAP32[($2 + 180 | 0) >> 2] = i64toi32_i32$2;
            i64toi32_i32$0 = $2 + 308 | 0;
            i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
            i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
            $93 = i64toi32_i32$2;
            i64toi32_i32$2 = $2;
            HEAP32[($2 + 160 | 0) >> 2] = $93;
            HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$3;
            i64toi32_i32$0 = ($2 + 248 | 0) + 16 | 0;
            i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
            i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
            $9 = i64toi32_i32$3;
            $9$hi = i64toi32_i32$2;
            i64toi32_i32$0 = $2 + 272 | 0;
            i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
            i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
            $8 = i64toi32_i32$2;
            $8$hi = i64toi32_i32$3;
            $6 = HEAP32[($2 + 304 | 0) >> 2] | 0;
            $7 = HEAPU8[($2 + 256 | 0) >> 0] | 0;
            $41 = HEAPU8[($2 + 227 | 0) >> 0] | 0 | ((HEAPU8[($2 + 228 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 229 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 230 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            HEAP8[($2 + 203 | 0) >> 0] = $41;
            HEAP8[($2 + 204 | 0) >> 0] = $41 >>> 8 | 0;
            HEAP8[($2 + 205 | 0) >> 0] = $41 >>> 16 | 0;
            HEAP8[($2 + 206 | 0) >> 0] = $41 >>> 24 | 0;
            HEAP32[($2 + 200 | 0) >> 2] = HEAP32[($2 + 224 | 0) >> 2] | 0;
            if (($7 | 0) != (19 | 0)) {
             break label$4
            }
            break label$3;
           }
           cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 248 | 0 | 0, $1 | 0);
           i64toi32_i32$0 = ($2 + 248 | 0) + 16 | 0;
           i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $8 = i64toi32_i32$3;
           $8$hi = i64toi32_i32$2;
           i64toi32_i32$0 = $2;
           i64toi32_i32$2 = HEAP32[($2 + 256 | 0) >> 2] | 0;
           i64toi32_i32$3 = HEAP32[($2 + 260 | 0) >> 2] | 0;
           $9 = i64toi32_i32$2;
           $9$hi = i64toi32_i32$3;
           i64toi32_i32$0 = $2;
           i64toi32_i32$3 = HEAP32[($2 + 248 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($2 + 252 | 0) >> 2] | 0;
           i64toi32_i32$0 = i64toi32_i32$3;
           i64toi32_i32$3 = 0;
           i64toi32_i32$1 = 1;
           if ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) | 0) {
            break label$5
           }
           i64toi32_i32$0 = $8$hi;
           i64toi32_i32$2 = $2 + 216 | 0;
           HEAP32[i64toi32_i32$2 >> 2] = $8;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
           i64toi32_i32$0 = $9$hi;
           i64toi32_i32$2 = $2;
           HEAP32[($2 + 208 | 0) >> 2] = $9;
           HEAP32[($2 + 212 | 0) >> 2] = i64toi32_i32$0;
           if (($9 & 255 | 0 | 0) == (5 | 0)) {
            break label$3
           }
           HEAP32[($2 + 248 | 0) >> 2] = 0;
           core__panicking__assert_failed__h96d8431cc974b591(0 | 0, $2 + 208 | 0 | 0, 1070752 | 0, $2 + 248 | 0 | 0, 1070864 | 0);
           abort();
          }
          i64toi32_i32$1 = $2 + 280 | 0;
          i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
          i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
          $145 = i64toi32_i32$0;
          i64toi32_i32$0 = ($2 + 176 | 0) + 8 | 0;
          HEAP32[i64toi32_i32$0 >> 2] = $145;
          HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
          i64toi32_i32$1 = $2 + 288 | 0;
          i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
          $151 = i64toi32_i32$2;
          i64toi32_i32$2 = ($2 + 176 | 0) + 16 | 0;
          HEAP32[i64toi32_i32$2 >> 2] = $151;
          HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
          HEAP32[(($2 + 160 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 308 | 0) >> 2] | 0;
          $42 = HEAPU8[($2 + 252 | 0) >> 0] | 0 | ((HEAPU8[($2 + 253 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 254 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 255 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          HEAP8[($2 + 203 | 0) >> 0] = $42;
          HEAP8[($2 + 204 | 0) >> 0] = $42 >>> 8 | 0;
          HEAP8[($2 + 205 | 0) >> 0] = $42 >>> 16 | 0;
          HEAP8[($2 + 206 | 0) >> 0] = $42 >>> 24 | 0;
          HEAP32[($2 + 200 | 0) >> 2] = HEAPU8[($2 + 249 | 0) >> 0] | 0 | ((HEAPU8[($2 + 250 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 251 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 252 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          i64toi32_i32$1 = $2 + 272 | 0;
          i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
          i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
          $167 = i64toi32_i32$0;
          i64toi32_i32$0 = $2;
          HEAP32[($2 + 176 | 0) >> 2] = $167;
          HEAP32[($2 + 180 | 0) >> 2] = i64toi32_i32$2;
          i64toi32_i32$1 = $2 + 300 | 0;
          i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
          $171 = i64toi32_i32$2;
          i64toi32_i32$2 = $2;
          HEAP32[($2 + 160 | 0) >> 2] = $171;
          HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$0;
          i64toi32_i32$1 = ($2 + 248 | 0) + 8 | 0;
          i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
          i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
          $9 = i64toi32_i32$0;
          $9$hi = i64toi32_i32$2;
          i64toi32_i32$1 = ($2 + 248 | 0) + 16 | 0;
          i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
          $8 = i64toi32_i32$2;
          $8$hi = i64toi32_i32$0;
          $6 = HEAP32[($2 + 296 | 0) >> 2] | 0;
          break label$4;
         }
         HEAP32[($2 + 224 | 0) >> 2] = HEAPU8[$5 >> 0] | 0 | ((HEAPU8[($5 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($5 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($5 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $43 = $5 + 3 | 0;
         $44 = HEAPU8[$43 >> 0] | 0 | ((HEAPU8[($43 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($43 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($43 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[($2 + 227 | 0) >> 0] = $44;
         HEAP8[($2 + 228 | 0) >> 0] = $44 >>> 8 | 0;
         HEAP8[($2 + 229 | 0) >> 0] = $44 >>> 16 | 0;
         HEAP8[($2 + 230 | 0) >> 0] = $44 >>> 24 | 0;
         HEAP32[($2 + 208 | 0) >> 2] = HEAP32[($2 + 224 | 0) >> 2] | 0;
         $45 = HEAPU8[($2 + 227 | 0) >> 0] | 0 | ((HEAPU8[($2 + 228 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 229 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 230 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[($2 + 211 | 0) >> 0] = $45;
         HEAP8[($2 + 212 | 0) >> 0] = $45 >>> 8 | 0;
         HEAP8[($2 + 213 | 0) >> 0] = $45 >>> 16 | 0;
         HEAP8[($2 + 214 | 0) >> 0] = $45 >>> 24 | 0;
         $7 = HEAP32[($2 + 252 | 0) >> 2] | 0;
         $6 = HEAPU8[($2 + 256 | 0) >> 0] | 0;
         $38 = $4;
         $46 = HEAP32[($2 + 208 | 0) >> 2] | 0;
         HEAP8[$38 >> 0] = $46;
         HEAP8[($38 + 1 | 0) >> 0] = $46 >>> 8 | 0;
         HEAP8[($38 + 2 | 0) >> 0] = $46 >>> 16 | 0;
         HEAP8[($38 + 3 | 0) >> 0] = $46 >>> 24 | 0;
         $47 = $38 + 3 | 0;
         $48 = HEAPU8[($2 + 211 | 0) >> 0] | 0 | ((HEAPU8[($2 + 212 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 213 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 214 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[$47 >> 0] = $48;
         HEAP8[($47 + 1 | 0) >> 0] = $48 >>> 8 | 0;
         HEAP8[($47 + 2 | 0) >> 0] = $48 >>> 16 | 0;
         HEAP8[($47 + 3 | 0) >> 0] = $48 >>> 24 | 0;
         HEAP8[($2 + 252 | 0) >> 0] = $6;
         HEAP32[($2 + 248 | 0) >> 2] = $7;
         alloc__collections__btree__map__BTreeMap_K_2cV___insert__h4d28978302e72baa($2 + 224 | 0 | 0, $2 + 16 | 0 | 0, $2 + 248 | 0 | 0);
         label$13 : {
          if (HEAP32[($2 + 224 | 0) >> 2] | 0) {
           break label$13
          }
          i64toi32_i32$0 = $9$hi;
          i64toi32_i32$1 = $9;
          i64toi32_i32$2 = 0;
          i64toi32_i32$3 = 1;
          if ((i64toi32_i32$1 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$2 | 0) | 0) {
           continue label$8
          }
          if ((HEAP32[($2 + 24 | 0) >> 2] | 0) >>> 0 < $3 >>> 0) {
           continue label$8
          }
          break label$3;
         }
         break label$8;
        };
        $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hebed8fd85cb76c41($2 + 224 | 0 | 0);
        alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($2 + 260 | 0 | 0, 1070880 | 0, 33 | 0);
        $6 = 0;
        $1 = ($2 + 248 | 0) + 8 | 0;
        HEAP32[$1 >> 2] = 0;
        i64toi32_i32$3 = $2 + 280 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $238 = i64toi32_i32$1;
        i64toi32_i32$1 = ($2 + 176 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $238;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$3 = $2 + 288 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $244 = i64toi32_i32$0;
        i64toi32_i32$0 = ($2 + 176 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $244;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        HEAP32[($2 + 200 | 0) >> 2] = HEAPU8[($2 + 249 | 0) >> 0] | 0 | ((HEAPU8[($2 + 250 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 251 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 252 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $49 = HEAPU8[($2 + 252 | 0) >> 0] | 0 | ((HEAPU8[($2 + 253 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 254 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 255 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 203 | 0) >> 0] = $49;
        HEAP8[($2 + 204 | 0) >> 0] = $49 >>> 8 | 0;
        HEAP8[($2 + 205 | 0) >> 0] = $49 >>> 16 | 0;
        HEAP8[($2 + 206 | 0) >> 0] = $49 >>> 24 | 0;
        i64toi32_i32$3 = $2 + 272 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $254 = i64toi32_i32$1;
        i64toi32_i32$1 = $2;
        HEAP32[($2 + 176 | 0) >> 2] = $254;
        HEAP32[($2 + 180 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$3 = ($2 + 248 | 0) + 16 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $8 = i64toi32_i32$0;
        $8$hi = i64toi32_i32$1;
        i64toi32_i32$3 = $1;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $9 = i64toi32_i32$1;
        $9$hi = i64toi32_i32$0;
        $7 = 4;
        break label$4;
       }
       i64toi32_i32$3 = $2 + 280 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $265 = i64toi32_i32$0;
       i64toi32_i32$0 = $2 + 184 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $265;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$3 = $2 + 288 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $271 = i64toi32_i32$1;
       i64toi32_i32$1 = ($2 + 176 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $271;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$3 = $2 + 272 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $275 = i64toi32_i32$0;
       i64toi32_i32$0 = $2;
       HEAP32[($2 + 176 | 0) >> 2] = $275;
       HEAP32[($2 + 180 | 0) >> 2] = i64toi32_i32$1;
       $6 = 0;
       $7 = 2;
       break label$4;
      }
      i64toi32_i32$3 = $2 + 280 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $280 = i64toi32_i32$1;
      i64toi32_i32$1 = $2 + 184 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $280;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$3 = $2 + 288 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $286 = i64toi32_i32$0;
      i64toi32_i32$0 = ($2 + 176 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $286;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$3 = $2 + 272 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $290 = i64toi32_i32$1;
      i64toi32_i32$1 = $2;
      HEAP32[($2 + 176 | 0) >> 2] = $290;
      HEAP32[($2 + 180 | 0) >> 2] = i64toi32_i32$0;
     }
     i64toi32_i32$0 = $8$hi;
     i64toi32_i32$1 = ($2 + 248 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $8;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$0 = $9$hi;
     i64toi32_i32$1 = ($2 + 248 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $9;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$3 = $2;
     i64toi32_i32$0 = HEAP32[($2 + 176 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 180 | 0) >> 2] | 0;
     $302 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 272 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $302;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$3 = $2;
     i64toi32_i32$1 = HEAP32[($2 + 160 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 164 | 0) >> 2] | 0;
     $306 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 300 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $306;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$3 = ($2 + 176 | 0) + 8 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $312 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 280 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $312;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$3 = ($2 + 176 | 0) + 16 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $318 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 288 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $318;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($2 + 308 | 0) >> 2] = HEAP32[(($2 + 160 | 0) + 8 | 0) >> 2] | 0;
     HEAP8[($2 + 248 | 0) >> 0] = $7;
     $50 = HEAP32[($2 + 200 | 0) >> 2] | 0;
     HEAP8[($2 + 249 | 0) >> 0] = $50;
     HEAP8[($2 + 250 | 0) >> 0] = $50 >>> 8 | 0;
     HEAP8[($2 + 251 | 0) >> 0] = $50 >>> 16 | 0;
     HEAP8[($2 + 252 | 0) >> 0] = $50 >>> 24 | 0;
     $51 = HEAPU8[($2 + 203 | 0) >> 0] | 0 | ((HEAPU8[($2 + 204 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 205 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 206 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($2 + 252 | 0) >> 0] = $51;
     HEAP8[($2 + 253 | 0) >> 0] = $51 >>> 8 | 0;
     HEAP8[($2 + 254 | 0) >> 0] = $51 >>> 16 | 0;
     HEAP8[($2 + 255 | 0) >> 0] = $51 >>> 24 | 0;
     HEAP32[($2 + 296 | 0) >> 2] = $6;
     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($2 + 96 | 0 | 0, $2 + 248 | 0 | 0, 1070913 | 0, 8 | 0);
     $7 = HEAPU8[($2 + 96 | 0) >> 0] | 0;
     if (($7 | 0) != (19 | 0)) {
      break label$2
     }
    }
    i64toi32_i32$3 = $2;
    i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
    $345 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $345;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = HEAP32[($2 + 24 | 0) >> 2] | 0;
    $1 = 0;
    break label$1;
   }
   $1 = 1;
   memcpy($2 + 33 | 0 | 0, $2 + 96 | 0 | 1 | 0 | 0, 63 | 0) | 0;
   HEAP8[($0 + 8 | 0) >> 0] = $7;
   memcpy($0 + 9 | 0 | 0, $2 + 33 | 0 | 0, 63 | 0) | 0;
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h5f5dc70d320637e0($2 + 16 | 0 | 0);
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 320 | 0;
 }
 
 function $cardano_serialization_lib__legacy_address__address__Attributes_20as_20cbor_event__de__Deserialize___deserialize__h55085c978ed19726($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, $2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, $9 = 0, $9$hi = 0, $8$hi = 0, $8 = 0, $5 = 0, $6 = 0, $44 = 0, $45 = 0, $46 = 0, $47 = 0, $48 = 0, $4 = 0, $49 = 0, $50 = 0, $51 = 0, $52 = 0, $53 = 0, $3 = 0, $54 = 0, $60 = 0, $65 = 0, $98 = 0, $104 = 0, $110 = 0, $116 = 0, $131 = 0, $147 = 0, $153 = 0, $158 = 0, $210 = 0, $216 = 0, $222 = 0, $227 = 0, $235 = 0, $241 = 0, $247 = 0, $253 = 0, $259 = 0, $7 = 0, $281 = 0, $291 = 0, $312 = 0, $318 = 0, $324 = 0, $336 = 0;
  $2 = global$0 - 192 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___map__h7c2a4e830d885a05($2 + 144 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = ($2 + 144 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 152 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 156 | 0) >> 2] | 0;
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      i64toi32_i32$2 = $2;
      i64toi32_i32$0 = HEAP32[($2 + 144 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($2 + 148 | 0) >> 2] | 0;
      i64toi32_i32$2 = i64toi32_i32$0;
      i64toi32_i32$0 = 0;
      i64toi32_i32$3 = 1;
      if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
       break label$4
      }
      i64toi32_i32$2 = $8$hi;
      i64toi32_i32$1 = $2;
      HEAP32[($2 + 24 | 0) >> 2] = $8;
      HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$2 = $9$hi;
      i64toi32_i32$1 = $2;
      HEAP32[($2 + 16 | 0) >> 2] = $9;
      HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$2;
      label$5 : {
       i64toi32_i32$3 = $9;
       i64toi32_i32$1 = 0;
       i64toi32_i32$0 = 1;
       if ((i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$1 | 0) | 0) {
        break label$5
       }
       HEAP32[($2 + 164 | 0) >> 2] = 1;
       i64toi32_i32$2 = $2;
       i64toi32_i32$3 = 0;
       HEAP32[($2 + 148 | 0) >> 2] = 2;
       HEAP32[($2 + 152 | 0) >> 2] = i64toi32_i32$3;
       HEAP32[($2 + 144 | 0) >> 2] = 1072588;
       HEAP32[($2 + 60 | 0) >> 2] = 147;
       HEAP32[($2 + 160 | 0) >> 2] = $2 + 56 | 0;
       HEAP32[($2 + 56 | 0) >> 2] = $2 + 16 | 0;
       alloc__fmt__format__h6e9e003a52c07309($2 + 120 | 0 | 0, $2 + 144 | 0 | 0);
       $44 = $2 + 83 | 0;
       $45 = HEAP32[(($2 + 120 | 0) + 8 | 0) >> 2] | 0;
       HEAP8[$44 >> 0] = $45;
       HEAP8[($44 + 1 | 0) >> 0] = $45 >>> 8 | 0;
       HEAP8[($44 + 2 | 0) >> 0] = $45 >>> 16 | 0;
       HEAP8[($44 + 3 | 0) >> 0] = $45 >>> 24 | 0;
       i64toi32_i32$0 = $2;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 120 | 0) >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 124 | 0) >> 2] | 0;
       $54 = i64toi32_i32$3;
       i64toi32_i32$3 = i64toi32_i32$0;
       $46 = $54;
       HEAP8[(i64toi32_i32$0 + 75 | 0) >> 0] = $46;
       HEAP8[(i64toi32_i32$0 + 76 | 0) >> 0] = $46 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 77 | 0) >> 0] = $46 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 78 | 0) >> 0] = $46 >>> 24 | 0;
       HEAP8[(i64toi32_i32$0 + 79 | 0) >> 0] = i64toi32_i32$2;
       HEAP8[(i64toi32_i32$0 + 80 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 81 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 82 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
       HEAP8[($0 + 8 | 0) >> 0] = 18;
       i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 72 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 73 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 74 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 75 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$3 = HEAPU8[(i64toi32_i32$0 + 76 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 77 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 78 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 79 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $60 = i64toi32_i32$2;
       i64toi32_i32$2 = $0 + 9 | 0;
       $47 = $60;
       HEAP8[i64toi32_i32$2 >> 0] = $47;
       HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $47 >>> 8 | 0;
       HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $47 >>> 16 | 0;
       HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $47 >>> 24 | 0;
       HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$3;
       HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
       HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
       HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
       i64toi32_i32$0 = i64toi32_i32$0 + 79 | 0;
       i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $65 = i64toi32_i32$3;
       i64toi32_i32$3 = $0 + 16 | 0;
       $48 = $65;
       HEAP8[i64toi32_i32$3 >> 0] = $48;
       HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $48 >>> 8 | 0;
       HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $48 >>> 16 | 0;
       HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $48 >>> 24 | 0;
       HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$2;
       HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
       HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
       HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
       HEAP32[$0 >> 2] = 1;
       break label$1;
      }
      HEAP32[($2 + 32 | 0) >> 2] = 0;
      label$6 : {
       i64toi32_i32$2 = $8$hi;
       if (!!($8 | i64toi32_i32$2 | 0)) {
        break label$6
       }
       $3 = 0;
       break label$2;
      }
      $4 = $2 + 144 | 0 | 4 | 0;
      $5 = ($2 + 120 | 0) + 8 | 0;
      $3 = 0;
      label$7 : while (1) {
       cbor_event__de__Deserializer_R___unsigned_integer__h1ed99c0b7fe7eea1($2 + 144 | 0 | 0, $1 | 0);
       i64toi32_i32$0 = $2;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 152 | 0) >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 156 | 0) >> 2] | 0;
       $9 = i64toi32_i32$2;
       $9$hi = i64toi32_i32$3;
       label$8 : {
        label$9 : {
         label$10 : {
          label$11 : {
           label$12 : {
            i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 144 | 0) >> 2] | 0;
            i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 148 | 0) >> 2] | 0;
            i64toi32_i32$0 = i64toi32_i32$3;
            i64toi32_i32$3 = 0;
            i64toi32_i32$1 = 1;
            if ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) | 0) {
             break label$12
            }
            i64toi32_i32$0 = $9$hi;
            i64toi32_i32$2 = $2;
            HEAP32[($2 + 48 | 0) >> 2] = $9;
            HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$0;
            i64toi32_i32$1 = $9;
            i64toi32_i32$2 = -1;
            i64toi32_i32$3 = -1;
            i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
            i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
            if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
             i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
            }
            $9 = i64toi32_i32$4;
            $9$hi = i64toi32_i32$5;
            i64toi32_i32$0 = i64toi32_i32$4;
            i64toi32_i32$1 = 0;
            i64toi32_i32$3 = 1;
            if (i64toi32_i32$5 >>> 0 > i64toi32_i32$1 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$0 >>> 0 > i64toi32_i32$3 >>> 0 | 0) | 0) {
             break label$11
            }
            i64toi32_i32$0 = $9$hi;
            switch ($9 | 0) {
            case 1:
             break label$10;
            default:
             break label$9;
            };
           }
           i64toi32_i32$3 = ($2 + 144 | 0) + 40 | 0;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
           i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
           $98 = i64toi32_i32$0;
           i64toi32_i32$0 = $0 + 40 | 0;
           HEAP32[i64toi32_i32$0 >> 2] = $98;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$5;
           i64toi32_i32$3 = ($2 + 144 | 0) + 32 | 0;
           i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
           $104 = i64toi32_i32$5;
           i64toi32_i32$5 = $0 + 32 | 0;
           HEAP32[i64toi32_i32$5 >> 2] = $104;
           HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
           i64toi32_i32$3 = ($2 + 144 | 0) + 24 | 0;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
           i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
           $110 = i64toi32_i32$0;
           i64toi32_i32$0 = $0 + 24 | 0;
           HEAP32[i64toi32_i32$0 >> 2] = $110;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$5;
           i64toi32_i32$3 = ($2 + 144 | 0) + 16 | 0;
           i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
           $116 = i64toi32_i32$5;
           i64toi32_i32$5 = $0 + 16 | 0;
           HEAP32[i64toi32_i32$5 >> 2] = $116;
           HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
           HEAP32[$0 >> 2] = 1;
           i64toi32_i32$0 = $9$hi;
           i64toi32_i32$5 = $0 + 8 | 0;
           HEAP32[i64toi32_i32$5 >> 2] = $9;
           HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
           break label$3;
          }
          core__fmt__ArgumentV1__new__h021aa801e74cb4b6($2 + 8 | 0 | 0, $2 + 48 | 0 | 0, 20 | 0);
          HEAP32[($2 + 164 | 0) >> 2] = 1;
          i64toi32_i32$5 = $2;
          i64toi32_i32$0 = 0;
          HEAP32[($2 + 148 | 0) >> 2] = 1;
          HEAP32[($2 + 152 | 0) >> 2] = i64toi32_i32$0;
          HEAP32[($2 + 144 | 0) >> 2] = 1072532;
          i64toi32_i32$3 = $2;
          i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
          i64toi32_i32$5 = HEAP32[($2 + 12 | 0) >> 2] | 0;
          $131 = i64toi32_i32$0;
          i64toi32_i32$0 = $2;
          HEAP32[(i64toi32_i32$0 + 56 | 0) >> 2] = $131;
          HEAP32[(i64toi32_i32$0 + 60 | 0) >> 2] = i64toi32_i32$5;
          HEAP32[(i64toi32_i32$0 + 160 | 0) >> 2] = i64toi32_i32$0 + 56 | 0;
          alloc__fmt__format__h6e9e003a52c07309(i64toi32_i32$0 + 120 | 0 | 0, i64toi32_i32$0 + 144 | 0 | 0);
          $49 = i64toi32_i32$0 + 83 | 0;
          $50 = HEAP32[((i64toi32_i32$0 + 120 | 0) + 8 | 0) >> 2] | 0;
          HEAP8[$49 >> 0] = $50;
          HEAP8[($49 + 1 | 0) >> 0] = $50 >>> 8 | 0;
          HEAP8[($49 + 2 | 0) >> 0] = $50 >>> 16 | 0;
          HEAP8[($49 + 3 | 0) >> 0] = $50 >>> 24 | 0;
          i64toi32_i32$3 = i64toi32_i32$0;
          i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 120 | 0) >> 2] | 0;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$0 + 124 | 0) >> 2] | 0;
          $147 = i64toi32_i32$5;
          i64toi32_i32$5 = $2;
          $51 = $147;
          HEAP8[($2 + 75 | 0) >> 0] = $51;
          HEAP8[($2 + 76 | 0) >> 0] = $51 >>> 8 | 0;
          HEAP8[($2 + 77 | 0) >> 0] = $51 >>> 16 | 0;
          HEAP8[($2 + 78 | 0) >> 0] = $51 >>> 24 | 0;
          HEAP8[($2 + 79 | 0) >> 0] = i64toi32_i32$0;
          HEAP8[($2 + 80 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
          HEAP8[($2 + 81 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
          HEAP8[($2 + 82 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
          HEAP8[($0 + 8 | 0) >> 0] = 18;
          i64toi32_i32$3 = $2;
          i64toi32_i32$0 = HEAPU8[($2 + 72 | 0) >> 0] | 0 | ((HEAPU8[($2 + 73 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 74 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 75 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          i64toi32_i32$5 = HEAPU8[($2 + 76 | 0) >> 0] | 0 | ((HEAPU8[($2 + 77 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 78 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 79 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          $153 = i64toi32_i32$0;
          i64toi32_i32$0 = $0 + 9 | 0;
          $52 = $153;
          HEAP8[i64toi32_i32$0 >> 0] = $52;
          HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $52 >>> 8 | 0;
          HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $52 >>> 16 | 0;
          HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $52 >>> 24 | 0;
          HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$5;
          HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$5 >>> 8 | 0;
          HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$5 >>> 16 | 0;
          HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$5 >>> 24 | 0;
          i64toi32_i32$3 = $2 + 79 | 0;
          i64toi32_i32$5 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          i64toi32_i32$0 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          $158 = i64toi32_i32$5;
          i64toi32_i32$5 = $0 + 16 | 0;
          $53 = $158;
          HEAP8[i64toi32_i32$5 >> 0] = $53;
          HEAP8[(i64toi32_i32$5 + 1 | 0) >> 0] = $53 >>> 8 | 0;
          HEAP8[(i64toi32_i32$5 + 2 | 0) >> 0] = $53 >>> 16 | 0;
          HEAP8[(i64toi32_i32$5 + 3 | 0) >> 0] = $53 >>> 24 | 0;
          HEAP8[(i64toi32_i32$5 + 4 | 0) >> 0] = i64toi32_i32$0;
          HEAP8[(i64toi32_i32$5 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
          HEAP8[(i64toi32_i32$5 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
          HEAP8[(i64toi32_i32$5 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
          HEAP32[$0 >> 2] = 1;
          break label$3;
         }
         cbor_event__de__Deserializer_R___bytes__hc697ccccfa39fd82($2 + 144 | 0 | 0, $1 | 0);
         label$13 : {
          label$14 : {
           label$15 : {
            label$16 : {
             if ((HEAP32[($2 + 144 | 0) >> 2] | 0 | 0) == (1 | 0)) {
              break label$16
             }
             $6 = HEAP32[($4 + 8 | 0) >> 2] | 0;
             HEAP32[(($2 + 56 | 0) + 8 | 0) >> 2] = $6;
             i64toi32_i32$3 = $4;
             i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
             i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
             $9 = i64toi32_i32$0;
             $9$hi = i64toi32_i32$5;
             i64toi32_i32$0 = $2;
             HEAP32[(i64toi32_i32$0 + 56 | 0) >> 2] = $9;
             HEAP32[(i64toi32_i32$0 + 60 | 0) >> 2] = i64toi32_i32$5;
             HEAP32[($5 + 8 | 0) >> 2] = $6;
             i64toi32_i32$0 = $5;
             HEAP32[i64toi32_i32$0 >> 2] = $9;
             HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$5;
             i64toi32_i32$0 = $2;
             i64toi32_i32$5 = 0;
             HEAP32[(i64toi32_i32$0 + 120 | 0) >> 2] = 0;
             HEAP32[(i64toi32_i32$0 + 124 | 0) >> 2] = i64toi32_i32$5;
             cbor_event__de__Deserializer_R___unsigned_integer__h1ed99c0b7fe7eea1(i64toi32_i32$0 + 144 | 0 | 0, i64toi32_i32$0 + 120 | 0 | 0);
             i64toi32_i32$3 = i64toi32_i32$0;
             i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 152 | 0) >> 2] | 0;
             i64toi32_i32$0 = HEAP32[(i64toi32_i32$0 + 156 | 0) >> 2] | 0;
             $9 = i64toi32_i32$5;
             $9$hi = i64toi32_i32$0;
             i64toi32_i32$3 = $2;
             i64toi32_i32$0 = HEAP32[($2 + 144 | 0) >> 2] | 0;
             i64toi32_i32$5 = HEAP32[($2 + 148 | 0) >> 2] | 0;
             i64toi32_i32$3 = i64toi32_i32$0;
             i64toi32_i32$0 = 0;
             i64toi32_i32$1 = 1;
             if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$5 | 0) == (i64toi32_i32$0 | 0) | 0) {
              break label$15
             }
             i64toi32_i32$3 = $9$hi;
             i64toi32_i32$1 = $9;
             i64toi32_i32$5 = 0;
             i64toi32_i32$0 = -1;
             if (i64toi32_i32$3 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$1 >>> 0 <= i64toi32_i32$0 >>> 0 | 0) | 0) {
              break label$13
             }
             i64toi32_i32$1 = 0;
             $8 = 2;
             $8$hi = i64toi32_i32$1;
             i64toi32_i32$1 = 0;
             $9 = 0;
             $9$hi = i64toi32_i32$1;
             break label$14;
            }
            memcpy($0 + 8 | 0 | 0, memcpy($2 + 72 | 0 | 4 | 0 | 0, ($2 + 144 | 0) + 8 | 0 | 0, 40 | 0) | 0 | 0, 40 | 0) | 0;
            HEAP32[$0 >> 2] = 1;
            break label$3;
           }
           i64toi32_i32$0 = $2 + 184 | 0;
           i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $210 = i64toi32_i32$1;
           i64toi32_i32$1 = ($2 + 72 | 0) + 24 | 0;
           HEAP32[i64toi32_i32$1 >> 2] = $210;
           HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
           i64toi32_i32$0 = $2 + 176 | 0;
           i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $216 = i64toi32_i32$3;
           i64toi32_i32$3 = ($2 + 72 | 0) + 16 | 0;
           HEAP32[i64toi32_i32$3 >> 2] = $216;
           HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
           i64toi32_i32$0 = ($2 + 144 | 0) + 24 | 0;
           i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $222 = i64toi32_i32$1;
           i64toi32_i32$1 = $2 + 80 | 0;
           HEAP32[i64toi32_i32$1 >> 2] = $222;
           HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
           i64toi32_i32$0 = ($2 + 144 | 0) + 16 | 0;
           i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $227 = i64toi32_i32$3;
           i64toi32_i32$3 = $2;
           HEAP32[($2 + 72 | 0) >> 2] = $227;
           HEAP32[($2 + 76 | 0) >> 2] = i64toi32_i32$1;
           i64toi32_i32$1 = $9$hi;
           i64toi32_i32$0 = $9;
           i64toi32_i32$3 = 0;
           i64toi32_i32$5 = 255;
           i64toi32_i32$3 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
           $8 = i64toi32_i32$0 & i64toi32_i32$5 | 0;
           $8$hi = i64toi32_i32$3;
           i64toi32_i32$3 = i64toi32_i32$1;
           i64toi32_i32$1 = i64toi32_i32$0;
           i64toi32_i32$0 = -1;
           i64toi32_i32$5 = -256;
           i64toi32_i32$0 = i64toi32_i32$3 & i64toi32_i32$0 | 0;
           $9 = i64toi32_i32$1 & i64toi32_i32$5 | 0;
           $9$hi = i64toi32_i32$0;
          }
          i64toi32_i32$3 = $2;
          i64toi32_i32$0 = HEAP32[($2 + 72 | 0) >> 2] | 0;
          i64toi32_i32$1 = HEAP32[($2 + 76 | 0) >> 2] | 0;
          $235 = i64toi32_i32$0;
          i64toi32_i32$0 = $0 + 16 | 0;
          HEAP32[i64toi32_i32$0 >> 2] = $235;
          HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
          i64toi32_i32$3 = ($2 + 72 | 0) + 24 | 0;
          i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
          $241 = i64toi32_i32$1;
          i64toi32_i32$1 = $0 + 40 | 0;
          HEAP32[i64toi32_i32$1 >> 2] = $241;
          HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
          i64toi32_i32$3 = ($2 + 72 | 0) + 16 | 0;
          i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
          $247 = i64toi32_i32$0;
          i64toi32_i32$0 = $0 + 32 | 0;
          HEAP32[i64toi32_i32$0 >> 2] = $247;
          HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
          i64toi32_i32$3 = ($2 + 72 | 0) + 8 | 0;
          i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
          $253 = i64toi32_i32$1;
          i64toi32_i32$1 = $0 + 24 | 0;
          HEAP32[i64toi32_i32$1 >> 2] = $253;
          HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
          HEAP32[$0 >> 2] = 1;
          i64toi32_i32$0 = $8$hi;
          i64toi32_i32$0 = $9$hi;
          i64toi32_i32$0 = $8$hi;
          i64toi32_i32$3 = $8;
          i64toi32_i32$1 = $9$hi;
          i64toi32_i32$5 = $9;
          i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
          $259 = i64toi32_i32$3 | i64toi32_i32$5 | 0;
          i64toi32_i32$3 = $0 + 8 | 0;
          HEAP32[i64toi32_i32$3 >> 2] = $259;
          HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
          $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($5 | 0);
          $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($5 | 0);
          break label$3;
         }
         $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($5 | 0);
         $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($5 | 0);
         i64toi32_i32$1 = $9$hi;
         $7 = $9;
         $3 = 1;
         break label$8;
        }
        cbor_event__de__Deserializer_R___bytes__hc697ccccfa39fd82($2 + 144 | 0 | 0, $1 | 0);
        label$17 : {
         if ((HEAP32[($2 + 144 | 0) >> 2] | 0 | 0) == (1 | 0)) {
          break label$17
         }
         $6 = ($2 + 72 | 0) + 8 | 0;
         HEAP32[$6 >> 2] = HEAP32[($4 + 8 | 0) >> 2] | 0;
         i64toi32_i32$0 = $4;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
         $281 = i64toi32_i32$1;
         i64toi32_i32$1 = $2;
         HEAP32[($2 + 72 | 0) >> 2] = $281;
         HEAP32[($2 + 76 | 0) >> 2] = i64toi32_i32$3;
         core__ptr__drop_in_place_core__option__Option_alloc__vec__Vec_u8_____ha5300c747747c3c8_3($2 + 32 | 0 | 0);
         HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[$6 >> 2] | 0;
         i64toi32_i32$0 = $2;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 72 | 0) >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 76 | 0) >> 2] | 0;
         $291 = i64toi32_i32$3;
         i64toi32_i32$3 = i64toi32_i32$0;
         HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] = $291;
         HEAP32[(i64toi32_i32$0 + 36 | 0) >> 2] = i64toi32_i32$1;
         break label$8;
        }
        memcpy($0 + 8 | 0 | 0, memcpy($2 + 72 | 0 | 4 | 0 | 0, ($2 + 144 | 0) + 8 | 0 | 0, 40 | 0) | 0 | 0, 40 | 0) | 0;
        HEAP32[$0 >> 2] = 1;
        break label$3;
       }
       i64toi32_i32$1 = $8$hi;
       i64toi32_i32$0 = $8;
       i64toi32_i32$3 = -1;
       i64toi32_i32$5 = -1;
       i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
       i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
       if (i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0) {
        i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
       }
       $8 = i64toi32_i32$2;
       $8$hi = i64toi32_i32$4;
       if (!(i64toi32_i32$2 | i64toi32_i32$4 | 0)) {
        break label$2
       }
       continue label$7;
      };
     }
     i64toi32_i32$1 = ($2 + 144 | 0) + 40 | 0;
     i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $312 = i64toi32_i32$4;
     i64toi32_i32$4 = $0 + 40 | 0;
     HEAP32[i64toi32_i32$4 >> 2] = $312;
     HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$1 = ($2 + 144 | 0) + 32 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $318 = i64toi32_i32$0;
     i64toi32_i32$0 = $0 + 32 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $318;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$4;
     i64toi32_i32$1 = ($2 + 144 | 0) + 24 | 0;
     i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $324 = i64toi32_i32$4;
     i64toi32_i32$4 = $0 + 24 | 0;
     HEAP32[i64toi32_i32$4 >> 2] = $324;
     HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$0 = $8$hi;
     i64toi32_i32$4 = $0 + 16 | 0;
     HEAP32[i64toi32_i32$4 >> 2] = $8;
     HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$0 = $9$hi;
     i64toi32_i32$4 = $0 + 8 | 0;
     HEAP32[i64toi32_i32$4 >> 2] = $9;
     HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[$0 >> 2] = 1;
     break label$1;
    }
    core__ptr__drop_in_place_core__option__Option_alloc__vec__Vec_u8_____ha5300c747747c3c8_3($2 + 32 | 0 | 0);
    break label$1;
   }
   i64toi32_i32$1 = $2;
   i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
   i64toi32_i32$4 = HEAP32[($2 + 36 | 0) >> 2] | 0;
   $336 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $336;
   HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$4;
   HEAP32[i64toi32_i32$0 >> 2] = 0;
   HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = $7;
   HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $3;
   HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = HEAP32[($2 + 40 | 0) >> 2] | 0;
  }
  global$0 = $2 + 192 | 0;
 }
 
 function cryptoxide__curve25519__ge__GePartial__double_scalarmult_vartime__hca77f4037cca72f5($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0;
  $4 = global$0 - 3840 | 0;
  global$0 = $4;
  cryptoxide__curve25519__scalar___impl_20cryptoxide__curve25519__scalar__scalar64__Scalar___slide__h02a6b1f378f41f84($4 + 8 | 0 | 0, $1 | 0);
  cryptoxide__curve25519__scalar___impl_20cryptoxide__curve25519__scalar__scalar64__Scalar___slide__h02a6b1f378f41f84($4 + 264 | 0 | 0, $3 | 0);
  cryptoxide__curve25519__ge__Ge__to_cached__h058a97fcf91788e4($4 + 520 | 0 | 0, $2 | 0);
  cryptoxide__curve25519__ge__Ge__double_p1p1__h995b1d78634e10e5($4 + 1960 | 0 | 0, $2 | 0);
  cryptoxide__curve25519__ge__GeP1P1__to_full__hee64a48e5ca8376f($4 + 680 | 0 | 0, $4 + 1960 | 0 | 0);
  $_cryptoxide__curve25519__ge__Ge_20as_20core__ops__arith__Add__cryptoxide__curve25519__ge__GeCached____add__hdb98361e5d861211($4 + 1960 | 0 | 0, $4 + 680 | 0 | 0, $4 + 520 | 0 | 0);
  cryptoxide__curve25519__ge__GeP1P1__to_full__hee64a48e5ca8376f($4 + 3680 | 0 | 0, $4 + 1960 | 0 | 0);
  cryptoxide__curve25519__ge__Ge__to_cached__h058a97fcf91788e4($4 + 840 | 0 | 0, $4 + 3680 | 0 | 0);
  $_cryptoxide__curve25519__ge__Ge_20as_20core__ops__arith__Add__cryptoxide__curve25519__ge__GeCached____add__hdb98361e5d861211($4 + 1960 | 0 | 0, $4 + 680 | 0 | 0, $4 + 840 | 0 | 0);
  cryptoxide__curve25519__ge__GeP1P1__to_full__hee64a48e5ca8376f($4 + 3680 | 0 | 0, $4 + 1960 | 0 | 0);
  cryptoxide__curve25519__ge__Ge__to_cached__h058a97fcf91788e4($4 + 1e3 | 0 | 0, $4 + 3680 | 0 | 0);
  $_cryptoxide__curve25519__ge__Ge_20as_20core__ops__arith__Add__cryptoxide__curve25519__ge__GeCached____add__hdb98361e5d861211($4 + 1960 | 0 | 0, $4 + 680 | 0 | 0, $4 + 1e3 | 0 | 0);
  cryptoxide__curve25519__ge__GeP1P1__to_full__hee64a48e5ca8376f($4 + 3680 | 0 | 0, $4 + 1960 | 0 | 0);
  cryptoxide__curve25519__ge__Ge__to_cached__h058a97fcf91788e4($4 + 1160 | 0 | 0, $4 + 3680 | 0 | 0);
  $_cryptoxide__curve25519__ge__Ge_20as_20core__ops__arith__Add__cryptoxide__curve25519__ge__GeCached____add__hdb98361e5d861211($4 + 1960 | 0 | 0, $4 + 680 | 0 | 0, $4 + 1160 | 0 | 0);
  cryptoxide__curve25519__ge__GeP1P1__to_full__hee64a48e5ca8376f($4 + 3680 | 0 | 0, $4 + 1960 | 0 | 0);
  cryptoxide__curve25519__ge__Ge__to_cached__h058a97fcf91788e4($4 + 1320 | 0 | 0, $4 + 3680 | 0 | 0);
  $_cryptoxide__curve25519__ge__Ge_20as_20core__ops__arith__Add__cryptoxide__curve25519__ge__GeCached____add__hdb98361e5d861211($4 + 1960 | 0 | 0, $4 + 680 | 0 | 0, $4 + 1320 | 0 | 0);
  cryptoxide__curve25519__ge__GeP1P1__to_full__hee64a48e5ca8376f($4 + 3680 | 0 | 0, $4 + 1960 | 0 | 0);
  cryptoxide__curve25519__ge__Ge__to_cached__h058a97fcf91788e4($4 + 1480 | 0 | 0, $4 + 3680 | 0 | 0);
  $_cryptoxide__curve25519__ge__Ge_20as_20core__ops__arith__Add__cryptoxide__curve25519__ge__GeCached____add__hdb98361e5d861211($4 + 1960 | 0 | 0, $4 + 680 | 0 | 0, $4 + 1480 | 0 | 0);
  cryptoxide__curve25519__ge__GeP1P1__to_full__hee64a48e5ca8376f($4 + 3680 | 0 | 0, $4 + 1960 | 0 | 0);
  cryptoxide__curve25519__ge__Ge__to_cached__h058a97fcf91788e4($4 + 1640 | 0 | 0, $4 + 3680 | 0 | 0);
  $_cryptoxide__curve25519__ge__Ge_20as_20core__ops__arith__Add__cryptoxide__curve25519__ge__GeCached____add__hdb98361e5d861211($4 + 1960 | 0 | 0, $4 + 680 | 0 | 0, $4 + 1640 | 0 | 0);
  cryptoxide__curve25519__ge__GeP1P1__to_full__hee64a48e5ca8376f($4 + 3680 | 0 | 0, $4 + 1960 | 0 | 0);
  cryptoxide__curve25519__ge__Ge__to_cached__h058a97fcf91788e4($4 + 1800 | 0 | 0, $4 + 3680 | 0 | 0);
  memcpy($4 + 1960 | 0 | 0, $4 + 520 | 0 | 0, 160 | 0) | 0;
  memcpy(($4 + 1960 | 0) + 160 | 0 | 0, $4 + 840 | 0 | 0, 160 | 0) | 0;
  memcpy($4 + 2280 | 0 | 0, $4 + 1e3 | 0 | 0, 160 | 0) | 0;
  memcpy($4 + 2440 | 0 | 0, $4 + 1160 | 0 | 0, 160 | 0) | 0;
  memcpy($4 + 2600 | 0 | 0, $4 + 1320 | 0 | 0, 160 | 0) | 0;
  memcpy($4 + 2760 | 0 | 0, $4 + 1480 | 0 | 0, 160 | 0) | 0;
  memcpy($4 + 2920 | 0 | 0, $4 + 1640 | 0 | 0, 160 | 0) | 0;
  memcpy($4 + 3080 | 0 | 0, $4 + 1800 | 0 | 0, 160 | 0) | 0;
  memcpy($4 + 3240 | 0 | 0, 1103272 | 0, 120 | 0) | 0;
  $2 = 255;
  label$1 : {
   label$2 : {
    if (HEAPU8[($4 + 263 | 0) >> 0] | 0) {
     break label$2
    }
    $3 = 255;
    label$3 : while (1) {
     label$4 : {
      if (!(HEAPU8[(($4 + 264 | 0) + $3 | 0) >> 0] | 0)) {
       break label$4
      }
      $2 = $3;
      break label$2;
     }
     label$5 : {
      if (!$3) {
       break label$5
      }
      $1 = ($4 + 8 | 0) + $3 | 0;
      $2 = $3 + -1 | 0;
      $3 = $2;
      if (!(HEAPU8[($1 + -1 | 0) >> 0] | 0)) {
       continue label$3
      }
      break label$2;
     }
     break label$3;
    };
    memcpy($0 | 0, 1103272 | 0, 120 | 0) | 0;
    break label$1;
   }
   label$6 : while (1) {
    cryptoxide__curve25519__ge__GePartial__double_p1p1__hf684fc70b9440336($4 + 3360 | 0 | 0, $4 + 3240 | 0 | 0);
    label$7 : {
     label$8 : {
      label$9 : {
       label$10 : {
        label$11 : {
         label$12 : {
          label$13 : {
           $3 = HEAP8[(($4 + 8 | 0) + $2 | 0) >> 0] | 0;
           switch ((($3 | 0) > (-1 | 0) ? ($3 | 0) != (0 | 0) : -1) + 1 | 0 | 0) {
           case 1:
            break label$11;
           case 2:
            break label$13;
           default:
            break label$12;
           };
          }
          $3 = ($3 | 0) / (2 | 0) | 0;
          $1 = ($3 << 24 | 0) >> 24 | 0;
          cryptoxide__curve25519__ge__GeP1P1__to_full__hee64a48e5ca8376f($4 + 3680 | 0 | 0, $4 + 3360 | 0 | 0);
          label$14 : {
           if (($3 & 255 | 0) >>> 0 > 7 >>> 0) {
            break label$14
           }
           $_cryptoxide__curve25519__ge__Ge_20as_20core__ops__arith__Add__cryptoxide__curve25519__ge__GeCached____add__hdb98361e5d861211($4 + 3520 | 0 | 0, $4 + 3680 | 0 | 0, ($4 + 1960 | 0) + Math_imul($1, 160) | 0 | 0);
           memcpy($4 + 3360 | 0 | 0, $4 + 3520 | 0 | 0, 160 | 0) | 0;
           break label$11;
          }
          core__panicking__panic_bounds_check__h808b524af17640b1($1 | 0, 8 | 0, 1103496 | 0);
          abort();
         }
         $3 = (((0 - $3 | 0) << 24 | 0) >> 24 | 0 | 0) / (2 | 0) | 0;
         $1 = ($3 << 24 | 0) >> 24 | 0;
         cryptoxide__curve25519__ge__GeP1P1__to_full__hee64a48e5ca8376f($4 + 3680 | 0 | 0, $4 + 3360 | 0 | 0);
         if (($3 & 255 | 0) >>> 0 >= 8 >>> 0) {
          break label$10
         }
         $_cryptoxide__curve25519__ge__Ge_20as_20core__ops__arith__Sub__cryptoxide__curve25519__ge__GeCached____sub__ha1434480d6586320($4 + 3520 | 0 | 0, $4 + 3680 | 0 | 0, ($4 + 1960 | 0) + Math_imul($1, 160) | 0 | 0);
         memcpy($4 + 3360 | 0 | 0, $4 + 3520 | 0 | 0, 160 | 0) | 0;
        }
        label$15 : {
         label$16 : {
          $3 = HEAP8[(($4 + 264 | 0) + $2 | 0) >> 0] | 0;
          switch ((($3 | 0) > (-1 | 0) ? ($3 | 0) != (0 | 0) : -1) + 1 | 0 | 0) {
          case 2:
           break label$16;
          case 1:
           break label$7;
          default:
           break label$15;
          };
         }
         $3 = ($3 | 0) / (2 | 0) | 0;
         $1 = ($3 << 24 | 0) >> 24 | 0;
         cryptoxide__curve25519__ge__GeP1P1__to_full__hee64a48e5ca8376f($4 + 3680 | 0 | 0, $4 + 3360 | 0 | 0);
         if (($3 & 255 | 0) >>> 0 > 7 >>> 0) {
          break label$9
         }
         $_cryptoxide__curve25519__ge__Ge_20as_20core__ops__arith__Add__cryptoxide__curve25519__ge__GePrecomp____add__h13dac0ca0b70905e($4 + 3520 | 0 | 0, $4 + 3680 | 0 | 0, Math_imul($1, 120) + 1103544 | 0 | 0);
         memcpy($4 + 3360 | 0 | 0, $4 + 3520 | 0 | 0, 160 | 0) | 0;
         break label$7;
        }
        $1 = (((0 - $3 | 0) << 24 | 0) >> 24 | 0 | 0) / (2 | 0) | 0;
        $3 = ($1 << 24 | 0) >> 24 | 0;
        cryptoxide__curve25519__ge__GeP1P1__to_full__hee64a48e5ca8376f($4 + 3680 | 0 | 0, $4 + 3360 | 0 | 0);
        if (($1 & 255 | 0) >>> 0 < 8 >>> 0) {
         break label$8
        }
        core__panicking__panic_bounds_check__h808b524af17640b1($3 | 0, 8 | 0, 1104504 | 0);
        abort();
       }
       core__panicking__panic_bounds_check__h808b524af17640b1($1 | 0, 8 | 0, 1103512 | 0);
       abort();
      }
      core__panicking__panic_bounds_check__h808b524af17640b1($1 | 0, 8 | 0, 1103528 | 0);
      abort();
     }
     $_cryptoxide__curve25519__ge__Ge_20as_20core__ops__arith__Sub__cryptoxide__curve25519__ge__GePrecomp____sub__h7efe15664f698169($4 + 3520 | 0 | 0, $4 + 3680 | 0 | 0, Math_imul($3, 120) + 1103544 | 0 | 0);
     memcpy($4 + 3360 | 0 | 0, $4 + 3520 | 0 | 0, 160 | 0) | 0;
    }
    cryptoxide__curve25519__ge__GeP1P1__to_partial__h5f1785bbb90d5b59($4 + 3680 | 0 | 0, $4 + 3360 | 0 | 0);
    memcpy($4 + 3240 | 0 | 0, $4 + 3680 | 0 | 0, 120 | 0) | 0;
    label$17 : {
     if ($2) {
      break label$17
     }
     memcpy($0 | 0, $4 + 3240 | 0 | 0, 120 | 0) | 0;
     break label$1;
    }
    $2 = $2 + -1 | 0;
    continue label$6;
   };
  }
  global$0 = $4 + 3840 | 0;
 }
 
 function $cardano_serialization_lib__TransactionOutput_20as_20core__cmp__Ord___cmp__hb8f43680ab4bb508($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $3 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, $2 = 0, $7 = 0, $8 = 0, $7$hi = 0, $8$hi = 0, $5 = 0, $6 = 0, $109 = 0, $123 = 0, $298 = 0, $340 = 0, $347 = 0, $350 = 0, $364 = 0, $371 = 0, $374 = 0;
  $2 = global$0 - 144 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    $3 = HEAPU8[$0 >> 0] | 0;
    $4 = HEAPU8[$1 >> 0] | 0;
    if (($3 | 0) == ($4 | 0)) {
     break label$2
    }
    $3 = $3 >>> 0 < $4 >>> 0 ? -1 : 1;
    break label$1;
   }
   label$3 : {
    label$4 : {
     label$5 : {
      label$6 : {
       switch ($3 | 0) {
       default:
        $3 = HEAPU8[($0 + 1 | 0) >> 0] | 0;
        $4 = HEAPU8[($1 + 1 | 0) >> 0] | 0;
        $3 = $3 >>> 0 < $4 >>> 0 ? -1 : ($3 | 0) != ($4 | 0);
        if ($3) {
         break label$4
        }
        label$11 : {
         $3 = HEAPU8[($0 + 2 | 0) >> 0] | 0;
         $4 = HEAPU8[($1 + 2 | 0) >> 0] | 0;
         if (($3 | 0) == ($4 | 0)) {
          break label$11
         }
         $3 = $3 >>> 0 < $4 >>> 0 ? -1 : 1;
         break label$1;
        }
        $3 = core__slice__cmp___impl_20core__cmp__Ord_20for_20_5bT_5d___cmp__h1f2092e0ba2f27ea($0 + 3 | 0 | 0, 28 | 0, $1 + 3 | 0 | 0, 28 | 0) | 0;
        if ($3 & 255 | 0) {
         break label$4
        }
        $3 = HEAPU8[($0 + 31 | 0) >> 0] | 0;
        $4 = HEAPU8[($1 + 31 | 0) >> 0] | 0;
        if (($3 | 0) == ($4 | 0)) {
         break label$5
        }
        $3 = $3 >>> 0 < $4 >>> 0 ? -1 : 1;
        break label$1;
       case 1:
        $3 = HEAPU8[($0 + 32 | 0) >> 0] | 0;
        $4 = HEAPU8[($1 + 32 | 0) >> 0] | 0;
        $3 = $3 >>> 0 < $4 >>> 0 ? -1 : ($3 | 0) != ($4 | 0);
        if ($3) {
         break label$4
        }
        label$12 : {
         $3 = HEAPU8[($0 + 33 | 0) >> 0] | 0;
         $4 = HEAPU8[($1 + 33 | 0) >> 0] | 0;
         if (($3 | 0) == ($4 | 0)) {
          break label$12
         }
         $3 = $3 >>> 0 < $4 >>> 0 ? -1 : 1;
         break label$1;
        }
        $3 = core__slice__cmp___impl_20core__cmp__Ord_20for_20_5bT_5d___cmp__h1f2092e0ba2f27ea($0 + 34 | 0 | 0, 28 | 0, $1 + 34 | 0 | 0, 28 | 0) | 0;
        if ($3 & 255 | 0) {
         break label$4
        }
        i64toi32_i32$2 = $0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
        $7 = i64toi32_i32$0;
        $7$hi = i64toi32_i32$1;
        i64toi32_i32$2 = $1;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
        $8 = i64toi32_i32$1;
        $8$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $7$hi;
        i64toi32_i32$2 = $7;
        i64toi32_i32$1 = $8$hi;
        i64toi32_i32$3 = $8;
        $109 = (i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$2 = i64toi32_i32$1;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$3 = $7;
        i64toi32_i32$0 = i64toi32_i32$1;
        i64toi32_i32$1 = $8;
        $3 = i64toi32_i32$2 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0 | 0) | 0 ? -1 : $109;
        if ($3) {
         break label$4
        }
        i64toi32_i32$1 = $0 + 16 | 0;
        i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
        $7 = i64toi32_i32$3;
        $7$hi = i64toi32_i32$2;
        i64toi32_i32$1 = $1 + 16 | 0;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
        $8 = i64toi32_i32$2;
        $8$hi = i64toi32_i32$3;
        i64toi32_i32$3 = $7$hi;
        i64toi32_i32$1 = $7;
        i64toi32_i32$2 = $8$hi;
        i64toi32_i32$0 = $8;
        $123 = (i64toi32_i32$1 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$3 | 0) != (i64toi32_i32$2 | 0) | 0;
        i64toi32_i32$1 = i64toi32_i32$3;
        i64toi32_i32$1 = i64toi32_i32$2;
        i64toi32_i32$1 = i64toi32_i32$3;
        i64toi32_i32$0 = $7;
        i64toi32_i32$3 = i64toi32_i32$2;
        i64toi32_i32$2 = $8;
        $3 = i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0 ? -1 : $123;
        if ($3) {
         break label$4
        }
        $3 = 255;
        i64toi32_i32$2 = $0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
        $7 = i64toi32_i32$0;
        $7$hi = i64toi32_i32$1;
        i64toi32_i32$2 = $1;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
        $8 = i64toi32_i32$1;
        $8$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $7$hi;
        i64toi32_i32$2 = $7;
        i64toi32_i32$1 = $8$hi;
        i64toi32_i32$3 = $8;
        if (i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0) {
         break label$1
        }
        i64toi32_i32$2 = $7$hi;
        i64toi32_i32$2 = $8$hi;
        i64toi32_i32$2 = $7$hi;
        i64toi32_i32$3 = $7;
        i64toi32_i32$0 = $8$hi;
        i64toi32_i32$1 = $8;
        $3 = (i64toi32_i32$3 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$0 | 0) | 0;
        break label$4;
       case 2:
        $3 = HEAPU8[($0 + 1 | 0) >> 0] | 0;
        $4 = HEAPU8[($1 + 1 | 0) >> 0] | 0;
        $3 = $3 >>> 0 < $4 >>> 0 ? -1 : ($3 | 0) != ($4 | 0);
        if ($3) {
         break label$4
        }
        label$13 : {
         $3 = HEAPU8[($0 + 2 | 0) >> 0] | 0;
         $4 = HEAPU8[($1 + 2 | 0) >> 0] | 0;
         if (($3 | 0) == ($4 | 0)) {
          break label$13
         }
         $3 = $3 >>> 0 < $4 >>> 0 ? -1 : 1;
         break label$1;
        }
        $3 = core__slice__cmp___impl_20core__cmp__Ord_20for_20_5bT_5d___cmp__h1f2092e0ba2f27ea($0 + 3 | 0 | 0, 28 | 0, $1 + 3 | 0 | 0, 28 | 0) | 0;
        break label$4;
       case 3:
        $3 = HEAPU8[($0 + 1 | 0) >> 0] | 0;
        $4 = HEAPU8[($1 + 1 | 0) >> 0] | 0;
        $3 = $3 >>> 0 < $4 >>> 0 ? -1 : ($3 | 0) != ($4 | 0);
        if ($3) {
         break label$4
        }
        label$14 : {
         $3 = HEAPU8[($0 + 2 | 0) >> 0] | 0;
         $4 = HEAPU8[($1 + 2 | 0) >> 0] | 0;
         if (($3 | 0) == ($4 | 0)) {
          break label$14
         }
         $3 = $3 >>> 0 < $4 >>> 0 ? -1 : 1;
         break label$1;
        }
        $3 = core__slice__cmp___impl_20core__cmp__Ord_20for_20_5bT_5d___cmp__h1f2092e0ba2f27ea($0 + 3 | 0 | 0, 28 | 0, $1 + 3 | 0 | 0, 28 | 0) | 0;
        break label$4;
       case 4:
        break label$6;
       };
      }
      $3 = core__slice__cmp___impl_20core__cmp__Ord_20for_20_5bT_5d___cmp__h1f2092e0ba2f27ea($0 + 24 | 0 | 0, 28 | 0, $1 + 24 | 0 | 0, 28 | 0) | 0;
      if ($3 & 255 | 0) {
       break label$4
      }
      label$15 : {
       $5 = $0 + 4 | 0;
       $3 = HEAP32[$5 >> 2] | 0;
       $6 = $1 + 4 | 0;
       $4 = HEAP32[$6 >> 2] | 0;
       if ((($3 | 0) != (0 | 0) | 0) == (($4 | 0) != (0 | 0) | 0)) {
        break label$15
       }
       $3 = $4 ? ($3 ? 1 : -1) : 1;
       break label$1;
      }
      label$16 : {
       label$17 : {
        label$18 : {
         if (!$3) {
          break label$18
         }
         if (!$4) {
          break label$18
         }
         $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $5 | 0);
         $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
         $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
         $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 | 0, $6 | 0);
         $3 = core__slice__cmp___impl_20core__cmp__Ord_20for_20_5bT_5d___cmp__h1f2092e0ba2f27ea($4 | 0, $3 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0) | 0;
         if ($3 & 255 | 0) {
          break label$17
         }
        }
        label$19 : {
         $3 = HEAP32[($0 + 16 | 0) >> 2] | 0;
         $4 = HEAP32[($1 + 16 | 0) >> 2] | 0;
         if (($3 | 0) == ($4 | 0)) {
          break label$19
         }
         $3 = $3 >>> 0 < $4 >>> 0 ? -1 : 1;
         break label$1;
        }
        if (!$3) {
         break label$16
        }
        $3 = 255;
        $4 = HEAP32[($0 + 20 | 0) >> 2] | 0;
        $5 = HEAP32[($1 + 20 | 0) >> 2] | 0;
        if ($4 >>> 0 < $5 >>> 0) {
         break label$1
        }
        $3 = ($4 | 0) != ($5 | 0);
       }
       if ($3 & 255 | 0) {
        break label$4
       }
      }
      $3 = HEAPU8[($0 + 52 | 0) >> 0] | 0;
      $4 = HEAPU8[($1 + 52 | 0) >> 0] | 0;
      if (($3 | 0) == ($4 | 0)) {
       break label$3
      }
      $3 = $3 >>> 0 < $4 >>> 0 ? -1 : 1;
      break label$1;
     }
     $3 = core__slice__cmp___impl_20core__cmp__Ord_20for_20_5bT_5d___cmp__h1f2092e0ba2f27ea($0 + 32 | 0 | 0, 28 | 0, $1 + 32 | 0 | 0, 28 | 0) | 0;
    }
    if ($3 & 255 | 0) {
     break label$1
    }
   }
   label$20 : {
    label$21 : {
     i64toi32_i32$1 = $0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] | 0;
     $7 = i64toi32_i32$3;
     $7$hi = i64toi32_i32$2;
     i64toi32_i32$1 = $1;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] | 0;
     $8 = i64toi32_i32$2;
     $8$hi = i64toi32_i32$3;
     i64toi32_i32$3 = $7$hi;
     i64toi32_i32$1 = $7;
     i64toi32_i32$2 = $8$hi;
     i64toi32_i32$0 = $8;
     $298 = (i64toi32_i32$1 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$3 | 0) != (i64toi32_i32$2 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$3;
     i64toi32_i32$1 = i64toi32_i32$2;
     i64toi32_i32$1 = i64toi32_i32$3;
     i64toi32_i32$0 = $7;
     i64toi32_i32$3 = i64toi32_i32$2;
     i64toi32_i32$2 = $8;
     $3 = i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0 ? -1 : $298;
     if ($3) {
      break label$21
     }
     label$22 : {
      $3 = HEAP32[($0 + 72 | 0) >> 2] | 0;
      $4 = HEAP32[($1 + 72 | 0) >> 2] | 0;
      if (($3 | 0) == ($4 | 0)) {
       break label$22
      }
      $3 = $3 >>> 0 < $4 >>> 0 ? -1 : 1;
      break label$1;
     }
     if (!$3) {
      break label$20
     }
     alloc__collections__btree__map__BTreeMap_K_2cV___iter__h677e802ff7e211c3($2 + 16 | 0 | 0, $0 + 76 | 0 | 0);
     alloc__collections__btree__map__BTreeMap_K_2cV___iter__h677e802ff7e211c3($2 + 48 | 0 | 0, $1 + 76 | 0 | 0);
     HEAP32[(($2 + 80 | 0) + 24 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 24 | 0) >> 2] | 0;
     i64toi32_i32$2 = ($2 + 16 | 0) + 16 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $340 = i64toi32_i32$0;
     i64toi32_i32$0 = ($2 + 80 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $340;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $347 = i64toi32_i32$1;
     i64toi32_i32$1 = ($2 + 80 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $347;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
     $350 = i64toi32_i32$0;
     i64toi32_i32$0 = i64toi32_i32$2;
     HEAP32[(i64toi32_i32$2 + 80 | 0) >> 2] = $350;
     HEAP32[(i64toi32_i32$2 + 84 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[((i64toi32_i32$2 + 112 | 0) + 24 | 0) >> 2] = HEAP32[((i64toi32_i32$2 + 48 | 0) + 24 | 0) >> 2] | 0;
     i64toi32_i32$2 = (i64toi32_i32$2 + 48 | 0) + 16 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $364 = i64toi32_i32$1;
     i64toi32_i32$1 = ($2 + 112 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $364;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = ($2 + 48 | 0) + 8 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $371 = i64toi32_i32$0;
     i64toi32_i32$0 = ($2 + 112 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $371;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] | 0;
     $374 = i64toi32_i32$1;
     i64toi32_i32$1 = i64toi32_i32$2;
     HEAP32[(i64toi32_i32$2 + 112 | 0) >> 2] = $374;
     HEAP32[(i64toi32_i32$2 + 116 | 0) >> 2] = i64toi32_i32$0;
     $3 = core__iter__traits__iterator__Iterator__cmp_by__hff45e02ccefa0d77(i64toi32_i32$2 + 80 | 0 | 0, i64toi32_i32$2 + 112 | 0 | 0) | 0;
    }
    if ($3 & 255 | 0) {
     break label$1
    }
   }
   label$23 : {
    $3 = HEAPU8[($0 + 88 | 0) >> 0] | 0;
    $4 = HEAPU8[($1 + 88 | 0) >> 0] | 0;
    if (($3 | 0) == ($4 | 0)) {
     break label$23
    }
    $3 = $3 >>> 0 < $4 >>> 0 ? -1 : 1;
    break label$1;
   }
   label$24 : {
    if ($3) {
     break label$24
    }
    $3 = 0;
    break label$1;
   }
   $3 = core__slice__cmp___impl_20core__cmp__Ord_20for_20_5bT_5d___cmp__h1f2092e0ba2f27ea($0 + 89 | 0 | 0, 32 | 0, $1 + 89 | 0 | 0, 32 | 0) | 0;
  }
  global$0 = $2 + 144 | 0;
  return $3 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__TransactionBodies___deserialize__h44087f0dae966260($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, $11 = 0, $17 = 0, $19 = 0, $12 = 0, $3 = 0, $17$hi = 0, $19$hi = 0, $10 = 0, $54 = 0, $55 = 0, $56 = 0, $57 = 0, $58 = 0, $59 = 0, $60 = 0, $61 = 0, $62 = 0, $63 = 0, $64 = 0, $65 = 0, $66 = 0, $18 = 0, $18$hi = 0, $7 = 0, $4 = 0, $6 = 0, $8 = 0, $13 = 0, $14 = 0, $15 = 0, $16 = 0, $5 = 0, $9 = 0, $75 = 0, $82 = 0, $98 = 0, $101 = 0, $122 = 0, $128 = 0, $143 = 0, $146 = 0, $172 = 0, $183 = 0, $187 = 0, $194 = 0, $245 = 0, $252 = 0, $268 = 0, $271 = 0, $279 = 0, $285 = 0, $289 = 0, $295 = 0, $301 = 0, $305 = 0, $317 = 0, $321 = 0, $327 = 0, $333 = 0, $360 = 0;
  $2 = global$0 - 784 | 0;
  global$0 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 12 | 0) >> 2] = 0;
  HEAP32[($2 + 16 | 0) >> 2] = i64toi32_i32$0;
  $3 = 0;
  HEAP32[($2 + 8 | 0) >> 2] = HEAP32[(0 + 1050204 | 0) >> 2] | 0;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 504 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = ($2 + 504 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $17 = i64toi32_i32$0;
  $17$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 512 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 516 | 0) >> 2] | 0;
  $18 = i64toi32_i32$1;
  $18$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 504 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 508 | 0) >> 2] | 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
         break label$6
        }
        i64toi32_i32$2 = $17$hi;
        $4 = $17;
        label$7 : {
         i64toi32_i32$2 = $18$hi;
         i64toi32_i32$3 = $18;
         i64toi32_i32$1 = 0;
         i64toi32_i32$0 = 1;
         if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
          break label$7
         }
         if (!$4) {
          break label$3
         }
        }
        $5 = $2 + 576 | 0;
        $6 = ($2 + 504 | 0) + 60 | 0;
        $7 = ($2 + 504 | 0) + 32 | 0;
        $8 = $2 + 513 | 0;
        $9 = $8 + 3 | 0;
        label$8 : {
         label$9 : while (1) {
          std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 | 0, $1 | 0);
          $3 = 0;
          $10 = 2;
          label$10 : {
           if (HEAP32[($2 + 4 | 0) >> 2] | 0) {
            break label$10
           }
           i64toi32_i32$3 = 0;
           $19 = 8;
           $19$hi = i64toi32_i32$3;
           i64toi32_i32$3 = 0;
           $17 = 0;
           $17$hi = i64toi32_i32$3;
           break label$4;
          }
          label$11 : {
           if ((($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[$2 >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) == (7 | 0)) {
            break label$11
           }
           cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__TransactionBody___deserialize__h3099fdd842acebc9($2 + 504 | 0 | 0, $1 | 0);
           $11 = ($2 + 472 | 0) + 8 | 0;
           i64toi32_i32$0 = $7 + 8 | 0;
           i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $75 = i64toi32_i32$3;
           i64toi32_i32$3 = $11;
           HEAP32[i64toi32_i32$3 >> 2] = $75;
           HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
           $12 = ($2 + 472 | 0) + 16 | 0;
           i64toi32_i32$0 = $7 + 16 | 0;
           i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$3 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $82 = i64toi32_i32$2;
           i64toi32_i32$2 = $12;
           HEAP32[i64toi32_i32$2 >> 2] = $82;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
           $13 = ($2 + 456 | 0) + 8 | 0;
           HEAP32[$13 >> 2] = HEAP32[($6 + 8 | 0) >> 2] | 0;
           $54 = $8;
           HEAP32[($2 + 496 | 0) >> 2] = HEAPU8[$54 >> 0] | 0 | ((HEAPU8[($54 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($54 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($54 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $55 = $9;
           $56 = HEAPU8[$55 >> 0] | 0 | ((HEAPU8[($55 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($55 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($55 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 499 | 0) >> 0] = $56;
           HEAP8[($2 + 500 | 0) >> 0] = $56 >>> 8 | 0;
           HEAP8[($2 + 501 | 0) >> 0] = $56 >>> 16 | 0;
           HEAP8[($2 + 502 | 0) >> 0] = $56 >>> 24 | 0;
           i64toi32_i32$0 = $7;
           i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $98 = i64toi32_i32$3;
           i64toi32_i32$3 = $2;
           HEAP32[($2 + 472 | 0) >> 2] = $98;
           HEAP32[($2 + 476 | 0) >> 2] = i64toi32_i32$2;
           i64toi32_i32$0 = $6;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
           i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
           $101 = i64toi32_i32$2;
           i64toi32_i32$2 = $2;
           HEAP32[($2 + 456 | 0) >> 2] = $101;
           HEAP32[($2 + 460 | 0) >> 2] = i64toi32_i32$3;
           $3 = HEAP32[($2 + 560 | 0) >> 2] | 0;
           i64toi32_i32$0 = $2;
           i64toi32_i32$3 = HEAP32[($2 + 528 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($2 + 532 | 0) >> 2] | 0;
           $17 = i64toi32_i32$3;
           $17$hi = i64toi32_i32$2;
           i64toi32_i32$0 = $2;
           i64toi32_i32$2 = HEAP32[($2 + 520 | 0) >> 2] | 0;
           i64toi32_i32$3 = HEAP32[($2 + 524 | 0) >> 2] | 0;
           $19 = i64toi32_i32$2;
           $19$hi = i64toi32_i32$3;
           $10 = HEAPU8[($2 + 512 | 0) >> 0] | 0;
           i64toi32_i32$0 = $2;
           i64toi32_i32$3 = HEAP32[($2 + 504 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($2 + 508 | 0) >> 2] | 0;
           i64toi32_i32$0 = i64toi32_i32$3;
           i64toi32_i32$3 = 0;
           i64toi32_i32$1 = 1;
           if ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) | 0) {
            break label$8
           }
           memcpy($2 + 200 | 0 | 0, $5 | 0, 208 | 0) | 0;
           $14 = ($2 + 424 | 0) + 8 | 0;
           i64toi32_i32$1 = $11;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $122 = i64toi32_i32$0;
           i64toi32_i32$0 = $14;
           HEAP32[i64toi32_i32$0 >> 2] = $122;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
           $15 = ($2 + 424 | 0) + 16 | 0;
           i64toi32_i32$1 = $12;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $128 = i64toi32_i32$2;
           i64toi32_i32$2 = $15;
           HEAP32[i64toi32_i32$2 >> 2] = $128;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
           $16 = ($2 + 408 | 0) + 8 | 0;
           HEAP32[$16 >> 2] = HEAP32[$13 >> 2] | 0;
           HEAP32[($2 + 448 | 0) >> 2] = HEAP32[($2 + 496 | 0) >> 2] | 0;
           $57 = HEAPU8[($2 + 499 | 0) >> 0] | 0 | ((HEAPU8[($2 + 500 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 501 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 502 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 451 | 0) >> 0] = $57;
           HEAP8[($2 + 452 | 0) >> 0] = $57 >>> 8 | 0;
           HEAP8[($2 + 453 | 0) >> 0] = $57 >>> 16 | 0;
           HEAP8[($2 + 454 | 0) >> 0] = $57 >>> 24 | 0;
           i64toi32_i32$1 = $2;
           i64toi32_i32$0 = HEAP32[($2 + 472 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($2 + 476 | 0) >> 2] | 0;
           $143 = i64toi32_i32$0;
           i64toi32_i32$0 = $2;
           HEAP32[($2 + 424 | 0) >> 2] = $143;
           HEAP32[($2 + 428 | 0) >> 2] = i64toi32_i32$2;
           i64toi32_i32$1 = $2;
           i64toi32_i32$2 = HEAP32[($2 + 456 | 0) >> 2] | 0;
           i64toi32_i32$0 = HEAP32[($2 + 460 | 0) >> 2] | 0;
           $146 = i64toi32_i32$2;
           i64toi32_i32$2 = $2;
           HEAP32[($2 + 408 | 0) >> 2] = $146;
           HEAP32[($2 + 412 | 0) >> 2] = i64toi32_i32$0;
           label$12 : {
            $12 = HEAP32[($2 + 16 | 0) >> 2] | 0;
            if ((HEAP32[($2 + 12 | 0) >> 2] | 0 | 0) != ($12 | 0)) {
             break label$12
            }
            alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hb13b6fa50ee7b823($2 + 8 | 0 | 0, $12 | 0, 1 | 0);
            $12 = HEAP32[($2 + 16 | 0) >> 2] | 0;
           }
           $11 = (HEAP32[($2 + 8 | 0) >> 2] | 0) + Math_imul($12, 272) | 0;
           HEAP8[$11 >> 0] = $10;
           $58 = HEAP32[($2 + 448 | 0) >> 2] | 0;
           HEAP8[($11 + 1 | 0) >> 0] = $58;
           HEAP8[($11 + 2 | 0) >> 0] = $58 >>> 8 | 0;
           HEAP8[($11 + 3 | 0) >> 0] = $58 >>> 16 | 0;
           HEAP8[($11 + 4 | 0) >> 0] = $58 >>> 24 | 0;
           i64toi32_i32$0 = $19$hi;
           i64toi32_i32$2 = $11;
           HEAP8[(i64toi32_i32$2 + 8 | 0) >> 0] = $19;
           HEAP8[(i64toi32_i32$2 + 9 | 0) >> 0] = $19 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 10 | 0) >> 0] = $19 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 11 | 0) >> 0] = $19 >>> 24 | 0;
           HEAP8[(i64toi32_i32$2 + 12 | 0) >> 0] = i64toi32_i32$0;
           HEAP8[(i64toi32_i32$2 + 13 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 14 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 15 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
           i64toi32_i32$1 = $2;
           i64toi32_i32$0 = HEAP32[($2 + 424 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($2 + 428 | 0) >> 2] | 0;
           $172 = i64toi32_i32$0;
           i64toi32_i32$0 = $11;
           $59 = $172;
           HEAP8[(i64toi32_i32$0 + 24 | 0) >> 0] = $59;
           HEAP8[(i64toi32_i32$0 + 25 | 0) >> 0] = $59 >>> 8 | 0;
           HEAP8[(i64toi32_i32$0 + 26 | 0) >> 0] = $59 >>> 16 | 0;
           HEAP8[(i64toi32_i32$0 + 27 | 0) >> 0] = $59 >>> 24 | 0;
           HEAP8[(i64toi32_i32$0 + 28 | 0) >> 0] = i64toi32_i32$2;
           HEAP8[(i64toi32_i32$0 + 29 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
           HEAP8[(i64toi32_i32$0 + 30 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
           HEAP8[(i64toi32_i32$0 + 31 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
           $60 = i64toi32_i32$0 + 4 | 0;
           $61 = HEAPU8[($2 + 451 | 0) >> 0] | 0 | ((HEAPU8[($2 + 452 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 453 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 454 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[$60 >> 0] = $61;
           HEAP8[($60 + 1 | 0) >> 0] = $61 >>> 8 | 0;
           HEAP8[($60 + 2 | 0) >> 0] = $61 >>> 16 | 0;
           HEAP8[($60 + 3 | 0) >> 0] = $61 >>> 24 | 0;
           i64toi32_i32$2 = $17$hi;
           i64toi32_i32$0 = i64toi32_i32$0 + 16 | 0;
           HEAP8[i64toi32_i32$0 >> 0] = $17;
           HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $17 >>> 8 | 0;
           HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $17 >>> 16 | 0;
           HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $17 >>> 24 | 0;
           HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$2;
           HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
           HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
           HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
           i64toi32_i32$1 = $14;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $183 = i64toi32_i32$2;
           i64toi32_i32$2 = $11 + 32 | 0;
           $62 = $183;
           HEAP8[i64toi32_i32$2 >> 0] = $62;
           HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $62 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $62 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $62 >>> 24 | 0;
           HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$0;
           HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
           i64toi32_i32$1 = $15;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $187 = i64toi32_i32$0;
           i64toi32_i32$0 = $11 + 40 | 0;
           $63 = $187;
           HEAP8[i64toi32_i32$0 >> 0] = $63;
           HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $63 >>> 8 | 0;
           HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $63 >>> 16 | 0;
           HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $63 >>> 24 | 0;
           HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$2;
           HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
           HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
           HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
           HEAP32[($11 + 48 | 0) >> 2] = $3;
           i64toi32_i32$1 = $2;
           i64toi32_i32$2 = HEAP32[($2 + 408 | 0) >> 2] | 0;
           i64toi32_i32$0 = HEAP32[($2 + 412 | 0) >> 2] | 0;
           $194 = i64toi32_i32$2;
           i64toi32_i32$2 = $11 + 52 | 0;
           HEAP32[i64toi32_i32$2 >> 2] = $194;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
           HEAP32[($11 + 60 | 0) >> 2] = HEAP32[$16 >> 2] | 0;
           memcpy($11 + 64 | 0 | 0, $2 + 200 | 0 | 0, 208 | 0) | 0;
           $11 = $12 + 1 | 0;
           HEAP32[($2 + 16 | 0) >> 2] = $11;
           i64toi32_i32$0 = $18$hi;
           i64toi32_i32$1 = $18;
           i64toi32_i32$2 = 0;
           i64toi32_i32$3 = 1;
           if ((i64toi32_i32$1 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$2 | 0) | 0) {
            continue label$9
           }
           if ($11 >>> 0 < $4 >>> 0) {
            continue label$9
           }
           break label$3;
          }
          break label$9;
         };
         cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 504 | 0 | 0, $1 | 0);
         i64toi32_i32$3 = ($2 + 504 | 0) + 16 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $17 = i64toi32_i32$1;
         $17$hi = i64toi32_i32$0;
         i64toi32_i32$3 = $2;
         i64toi32_i32$0 = HEAP32[($2 + 512 | 0) >> 2] | 0;
         i64toi32_i32$1 = HEAP32[($2 + 516 | 0) >> 2] | 0;
         $19 = i64toi32_i32$0;
         $19$hi = i64toi32_i32$1;
         i64toi32_i32$3 = $2;
         i64toi32_i32$1 = HEAP32[($2 + 504 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($2 + 508 | 0) >> 2] | 0;
         i64toi32_i32$3 = i64toi32_i32$1;
         i64toi32_i32$1 = 0;
         i64toi32_i32$2 = 1;
         if ((i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
          break label$5
         }
         i64toi32_i32$3 = $17$hi;
         i64toi32_i32$0 = $2 + 480 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $17;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
         i64toi32_i32$3 = $19$hi;
         i64toi32_i32$0 = $2;
         HEAP32[($2 + 472 | 0) >> 2] = $19;
         HEAP32[($2 + 476 | 0) >> 2] = i64toi32_i32$3;
         if (($19 & 255 | 0 | 0) == (5 | 0)) {
          break label$3
         }
         HEAP32[($2 + 504 | 0) >> 2] = 0;
         core__panicking__assert_failed__h96d8431cc974b591(0 | 0, $2 + 472 | 0 | 0, 1050312 | 0, $2 + 504 | 0 | 0, 1052564 | 0);
         abort();
        }
        i64toi32_i32$2 = ($2 + 472 | 0) + 8 | 0;
        i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $245 = i64toi32_i32$3;
        i64toi32_i32$3 = ($2 + 168 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$3 >> 2] = $245;
        HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = ($2 + 472 | 0) + 16 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $252 = i64toi32_i32$0;
        i64toi32_i32$0 = ($2 + 168 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $252;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
        HEAP32[(($2 + 152 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 456 | 0) + 8 | 0) >> 2] | 0;
        HEAP32[($2 + 192 | 0) >> 2] = HEAP32[($2 + 496 | 0) >> 2] | 0;
        $64 = HEAPU8[($2 + 499 | 0) >> 0] | 0 | ((HEAPU8[($2 + 500 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 501 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 502 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 195 | 0) >> 0] = $64;
        HEAP8[($2 + 196 | 0) >> 0] = $64 >>> 8 | 0;
        HEAP8[($2 + 197 | 0) >> 0] = $64 >>> 16 | 0;
        HEAP8[($2 + 198 | 0) >> 0] = $64 >>> 24 | 0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$3 = HEAP32[($2 + 472 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[($2 + 476 | 0) >> 2] | 0;
        $268 = i64toi32_i32$3;
        i64toi32_i32$3 = $2;
        HEAP32[($2 + 168 | 0) >> 2] = $268;
        HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 456 | 0) >> 2] | 0;
        i64toi32_i32$3 = HEAP32[($2 + 460 | 0) >> 2] | 0;
        $271 = i64toi32_i32$0;
        i64toi32_i32$0 = $2;
        HEAP32[($2 + 152 | 0) >> 2] = $271;
        HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$3;
        if (($10 & 255 | 0 | 0) != (19 | 0)) {
         break label$4
        }
        break label$3;
       }
       i64toi32_i32$2 = $2 + 536 | 0;
       i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $279 = i64toi32_i32$3;
       i64toi32_i32$3 = $2 + 176 | 0;
       HEAP32[i64toi32_i32$3 >> 2] = $279;
       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = $2 + 544 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $285 = i64toi32_i32$0;
       i64toi32_i32$0 = ($2 + 168 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $285;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
       i64toi32_i32$2 = $2 + 528 | 0;
       i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $289 = i64toi32_i32$3;
       i64toi32_i32$3 = $2;
       HEAP32[($2 + 168 | 0) >> 2] = $289;
       HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$0;
       $10 = 2;
       i64toi32_i32$0 = $18$hi;
       $19 = $18;
       $19$hi = i64toi32_i32$0;
       break label$4;
      }
      i64toi32_i32$2 = $2 + 536 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $295 = i64toi32_i32$0;
      i64toi32_i32$0 = $2 + 176 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $295;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
      i64toi32_i32$2 = $2 + 544 | 0;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $301 = i64toi32_i32$3;
      i64toi32_i32$3 = ($2 + 168 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$3 >> 2] = $301;
      HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $2 + 528 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $305 = i64toi32_i32$0;
      i64toi32_i32$0 = $2;
      HEAP32[($2 + 168 | 0) >> 2] = $305;
      HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$3;
     }
     i64toi32_i32$3 = $17$hi;
     i64toi32_i32$0 = ($2 + 504 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $17;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$3 = $19$hi;
     i64toi32_i32$0 = ($2 + 504 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $19;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$2 = $2;
     i64toi32_i32$3 = HEAP32[($2 + 168 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 172 | 0) >> 2] | 0;
     $317 = i64toi32_i32$3;
     i64toi32_i32$3 = $2 + 528 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $317;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[($2 + 152 | 0) >> 2] | 0;
     i64toi32_i32$3 = HEAP32[($2 + 156 | 0) >> 2] | 0;
     $321 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 556 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $321;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$2 = ($2 + 168 | 0) + 8 | 0;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $327 = i64toi32_i32$3;
     i64toi32_i32$3 = $2 + 536 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $327;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = ($2 + 168 | 0) + 16 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $333 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 544 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $333;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
     HEAP32[($2 + 564 | 0) >> 2] = HEAP32[(($2 + 152 | 0) + 8 | 0) >> 2] | 0;
     HEAP8[($2 + 504 | 0) >> 0] = $10;
     $65 = HEAP32[($2 + 192 | 0) >> 2] | 0;
     HEAP8[($2 + 505 | 0) >> 0] = $65;
     HEAP8[($2 + 506 | 0) >> 0] = $65 >>> 8 | 0;
     HEAP8[($2 + 507 | 0) >> 0] = $65 >>> 16 | 0;
     HEAP8[($2 + 508 | 0) >> 0] = $65 >>> 24 | 0;
     $66 = HEAPU8[($2 + 195 | 0) >> 0] | 0 | ((HEAPU8[($2 + 196 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 197 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 198 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($2 + 508 | 0) >> 0] = $66;
     HEAP8[($2 + 509 | 0) >> 0] = $66 >>> 8 | 0;
     HEAP8[($2 + 510 | 0) >> 0] = $66 >>> 16 | 0;
     HEAP8[($2 + 511 | 0) >> 0] = $66 >>> 24 | 0;
     HEAP32[($2 + 552 | 0) >> 2] = $3;
     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($2 + 88 | 0 | 0, $2 + 504 | 0 | 0, 1052580 | 0, 17 | 0);
     $3 = HEAPU8[($2 + 88 | 0) >> 0] | 0;
     if (($3 | 0) != (19 | 0)) {
      break label$2
     }
    }
    i64toi32_i32$2 = $2;
    i64toi32_i32$3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $360 = i64toi32_i32$3;
    i64toi32_i32$3 = $0;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = $360;
    HEAP32[(i64toi32_i32$3 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[(i64toi32_i32$3 + 12 | 0) >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
    $11 = 0;
    break label$1;
   }
   $11 = 1;
   memcpy($2 + 25 | 0 | 0, $2 + 88 | 0 | 1 | 0 | 0, 63 | 0) | 0;
   HEAP8[($0 + 8 | 0) >> 0] = $3;
   memcpy($0 + 9 | 0 | 0, $2 + 25 | 0 | 0, 63 | 0) | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h86cdf7dca21c8b48($2 + 8 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h7ca18c2b7d174864($2 + 8 | 0 | 0);
  }
  HEAP32[$0 >> 2] = $11;
  global$0 = $2 + 784 | 0;
 }
 
 function $cardano_serialization_lib__ProtocolParamUpdate_20as_20core__clone__Clone___clone__h79b368642b010c69($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, $2 = 0, $3 = 0, $109 = 0, $110 = 0, $111 = 0, $112 = 0, $4 = 0, $5 = 0, $6 = 0, $7 = 0, $8 = 0, $9 = 0, $10 = 0, $11 = 0, $12 = 0, $13 = 0, $20 = 0, $32 = 0, $32$hi = 0, $39 = 0, $39$hi = 0, $40 = 0, $40$hi = 0, $41 = 0, $41$hi = 0, $21 = 0, $46 = 0, $46$hi = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $103 = 0, $108 = 0, $113 = 0, $117 = 0, $123 = 0, $129 = 0, $135 = 0, $138 = 0, $22 = 0, $22$hi = 0, $23 = 0, $23$hi = 0, $24 = 0, $24$hi = 0, $25 = 0, $25$hi = 0, $26 = 0, $26$hi = 0, $27 = 0, $27$hi = 0, $28 = 0, $28$hi = 0, $29 = 0, $29$hi = 0, $30 = 0, $30$hi = 0, $31 = 0, $31$hi = 0, $33 = 0, $33$hi = 0, $34 = 0, $34$hi = 0, $35 = 0, $35$hi = 0, $36 = 0, $36$hi = 0, $37 = 0, $37$hi = 0, $38 = 0, $38$hi = 0, $42 = 0, $42$hi = 0, $43 = 0, $43$hi = 0, $44 = 0, $44$hi = 0, $45 = 0, $45$hi = 0, $47 = 0, $47$hi = 0, $48 = 0, $48$hi = 0, $49 = 0, $49$hi = 0, $50 = 0, $50$hi = 0, $51 = 0, $51$hi = 0, $52 = 0, $52$hi = 0, $53 = 0, $53$hi = 0, $54 = 0, $54$hi = 0, $55 = 0, $55$hi = 0, $344 = 0, $349 = 0, $354 = 0, $358 = 0, $367 = 0, $383 = 0, $386 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  $3 = $1 + 320 | 0;
  $4 = $1 + 152 | 0;
  $5 = $1 + 144 | 0;
  $6 = $1 + 128 | 0;
  $7 = $1 + 120 | 0;
  $8 = $1 + 104 | 0;
  $9 = $1 + 96 | 0;
  $10 = $1 + 80 | 0;
  $11 = $1 + 72 | 0;
  $12 = $1 + 316 | 0;
  $13 = $1 + 308 | 0;
  $14 = $1 + 56 | 0;
  $15 = $1 + 40 | 0;
  $16 = $1 + 300 | 0;
  $17 = $1 + 292 | 0;
  $18 = $1 + 284 | 0;
  $19 = $1 + 24 | 0;
  $20 = 2;
  label$1 : {
   $21 = HEAPU8[($1 + 372 | 0) >> 0] | 0;
   if (($21 | 0) == (2 | 0)) {
    break label$1
   }
   $20 = 0;
   label$2 : {
    if (($21 | 0) != (1 | 0)) {
     break label$2
    }
    i64toi32_i32$2 = $1 + 397 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $103 = i64toi32_i32$0;
    i64toi32_i32$0 = $2 + 72 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $103;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $1 + 389 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $108 = i64toi32_i32$1;
    i64toi32_i32$1 = $2 + 64 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $108;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $1 + 381 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $113 = i64toi32_i32$0;
    i64toi32_i32$0 = $2 + 56 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $113;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $1 + 373 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $117 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[(i64toi32_i32$1 + 48 | 0) >> 2] = $117;
    HEAP32[(i64toi32_i32$1 + 52 | 0) >> 2] = i64toi32_i32$0;
    $20 = 1;
   }
   i64toi32_i32$2 = ($2 + 48 | 0) + 24 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $123 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 24 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $123;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = ($2 + 48 | 0) + 16 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $129 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 16 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $129;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = ($2 + 48 | 0) + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $135 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $135;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] | 0;
   $138 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[i64toi32_i32$2 >> 2] = $138;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  }
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $22 = i64toi32_i32$0;
  $22$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $5;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $23 = i64toi32_i32$1;
  $23$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $6;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  $24$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $7;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $25 = i64toi32_i32$1;
  $25$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $8;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $26 = i64toi32_i32$0;
  $26$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $27 = i64toi32_i32$1;
  $27$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $10;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $28 = i64toi32_i32$0;
  $28$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $11;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $29 = i64toi32_i32$1;
  $29$hi = i64toi32_i32$0;
  $4 = HEAP32[$12 >> 2] | 0;
  $5 = HEAP32[$13 >> 2] | 0;
  i64toi32_i32$2 = $14;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  $30$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $15;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $31 = i64toi32_i32$1;
  $31$hi = i64toi32_i32$0;
  $6 = HEAP32[$16 >> 2] | 0;
  $7 = HEAP32[$17 >> 2] | 0;
  $8 = HEAP32[$18 >> 2] | 0;
  i64toi32_i32$2 = $19;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $32 = i64toi32_i32$0;
  $32$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 136 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 140 | 0) >> 2] | 0;
  $33 = i64toi32_i32$1;
  $33$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 112 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 116 | 0) >> 2] | 0;
  $34 = i64toi32_i32$0;
  $34$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 88 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 92 | 0) >> 2] | 0;
  $35 = i64toi32_i32$1;
  $35$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
  $36 = i64toi32_i32$0;
  $36$hi = i64toi32_i32$1;
  $9 = HEAP32[(i64toi32_i32$2 + 312 | 0) >> 2] | 0;
  $10 = HEAP32[(i64toi32_i32$2 + 304 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] | 0;
  $37 = i64toi32_i32$1;
  $37$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
  $38 = i64toi32_i32$0;
  $38$hi = i64toi32_i32$1;
  $11 = HEAP32[(i64toi32_i32$2 + 296 | 0) >> 2] | 0;
  $12 = HEAP32[(i64toi32_i32$2 + 288 | 0) >> 2] | 0;
  $13 = HEAP32[(i64toi32_i32$2 + 280 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $39 = i64toi32_i32$1;
  $39$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $40 = i64toi32_i32$0;
  $40$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $41 = i64toi32_i32$1;
  $41$hi = i64toi32_i32$0;
  label$3 : {
   label$4 : {
    if (HEAP32[$3 >> 2] | 0) {
     break label$4
    }
    HEAP32[($2 + 32 | 0) >> 2] = 0;
    break label$3;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h36101af4d9989b58($2 + 32 | 0 | 0, $3 | 0);
  }
  i64toi32_i32$2 = $1 + 184 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $42 = i64toi32_i32$0;
  $42$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 168 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $43 = i64toi32_i32$1;
  $43$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 176 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 180 | 0) >> 2] | 0;
  $44 = i64toi32_i32$0;
  $44$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 160 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 164 | 0) >> 2] | 0;
  $45 = i64toi32_i32$1;
  $45$hi = i64toi32_i32$0;
  $3 = 0;
  label$5 : {
   if ((HEAP32[(i64toi32_i32$2 + 332 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$5
   }
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h663a668224e1772a($2 + 48 | 0 | 4 | 0 | 0, $1 + 336 | 0 | 0);
   $3 = 1;
  }
  HEAP32[($2 + 48 | 0) >> 2] = $3;
  i64toi32_i32$0 = 0;
  $46 = 1;
  $46$hi = i64toi32_i32$0;
  label$6 : {
   label$7 : {
    i64toi32_i32$2 = $1;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 192 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 196 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    i64toi32_i32$3 = 1;
    if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
     break label$7
    }
    i64toi32_i32$2 = 0;
    $46 = 0;
    $46$hi = i64toi32_i32$2;
    break label$6;
   }
   i64toi32_i32$3 = $1 + 224 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $47 = i64toi32_i32$2;
   $47$hi = i64toi32_i32$1;
   i64toi32_i32$3 = $1 + 216 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $48 = i64toi32_i32$1;
   $48$hi = i64toi32_i32$2;
   i64toi32_i32$3 = $1 + 208 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $49 = i64toi32_i32$2;
   $49$hi = i64toi32_i32$1;
   i64toi32_i32$3 = $1 + 200 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $50 = i64toi32_i32$1;
   $50$hi = i64toi32_i32$2;
  }
  HEAP32[($0 + 296 | 0) >> 2] = $11;
  HEAP32[($0 + 288 | 0) >> 2] = $12;
  HEAP32[($0 + 280 | 0) >> 2] = $13;
  i64toi32_i32$2 = $39$hi;
  i64toi32_i32$1 = $0;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $39;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $40$hi;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $40;
  HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $41$hi;
  HEAP32[i64toi32_i32$1 >> 2] = $41;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$1 + 300 | 0) >> 2] = $6;
  HEAP32[(i64toi32_i32$1 + 292 | 0) >> 2] = $7;
  HEAP32[(i64toi32_i32$1 + 284 | 0) >> 2] = $8;
  i64toi32_i32$2 = $32$hi;
  i64toi32_i32$1 = i64toi32_i32$1 + 24 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $32;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$3 = $1 + 240 | 0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
  $32 = i64toi32_i32$2;
  $32$hi = i64toi32_i32$1;
  i64toi32_i32$3 = $1 + 248 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
  $39 = i64toi32_i32$1;
  $39$hi = i64toi32_i32$2;
  i64toi32_i32$3 = $1 + 264 | 0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
  $40 = i64toi32_i32$2;
  $40$hi = i64toi32_i32$1;
  i64toi32_i32$3 = $1 + 272 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
  $41 = i64toi32_i32$1;
  $41$hi = i64toi32_i32$2;
  i64toi32_i32$3 = $1;
  i64toi32_i32$2 = HEAP32[($1 + 232 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 236 | 0) >> 2] | 0;
  $51 = i64toi32_i32$2;
  $51$hi = i64toi32_i32$1;
  i64toi32_i32$3 = $1;
  i64toi32_i32$1 = HEAP32[($1 + 256 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[($1 + 260 | 0) >> 2] | 0;
  $52 = i64toi32_i32$1;
  $52$hi = i64toi32_i32$2;
  i64toi32_i32$3 = $1;
  i64toi32_i32$2 = HEAP32[($1 + 348 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 352 | 0) >> 2] | 0;
  $53 = i64toi32_i32$2;
  $53$hi = i64toi32_i32$1;
  i64toi32_i32$3 = $1;
  i64toi32_i32$1 = HEAP32[($1 + 356 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[($1 + 360 | 0) >> 2] | 0;
  $54 = i64toi32_i32$1;
  $54$hi = i64toi32_i32$2;
  i64toi32_i32$3 = $1;
  i64toi32_i32$2 = HEAP32[($1 + 364 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 368 | 0) >> 2] | 0;
  $55 = i64toi32_i32$2;
  $55$hi = i64toi32_i32$1;
  HEAP32[($0 + 316 | 0) >> 2] = $4;
  HEAP32[($0 + 312 | 0) >> 2] = $9;
  HEAP32[($0 + 308 | 0) >> 2] = $5;
  HEAP32[($0 + 304 | 0) >> 2] = $10;
  i64toi32_i32$1 = $30$hi;
  i64toi32_i32$2 = $0 + 56 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $30;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $37$hi;
  i64toi32_i32$2 = $0;
  HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = $37;
  HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $31$hi;
  i64toi32_i32$2 = i64toi32_i32$2 + 40 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $31;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $38$hi;
  i64toi32_i32$2 = $0;
  HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] = $38;
  HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $36$hi;
  HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] = $36;
  HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $29$hi;
  i64toi32_i32$2 = i64toi32_i32$2 + 72 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $29;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $28$hi;
  i64toi32_i32$2 = $0 + 80 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $28;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $35$hi;
  i64toi32_i32$2 = $0;
  HEAP32[(i64toi32_i32$2 + 88 | 0) >> 2] = $35;
  HEAP32[(i64toi32_i32$2 + 92 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $27$hi;
  i64toi32_i32$2 = i64toi32_i32$2 + 96 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $27;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $26$hi;
  i64toi32_i32$2 = $0 + 104 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $26;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $34$hi;
  i64toi32_i32$2 = $0;
  HEAP32[(i64toi32_i32$2 + 112 | 0) >> 2] = $34;
  HEAP32[(i64toi32_i32$2 + 116 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $25$hi;
  i64toi32_i32$2 = i64toi32_i32$2 + 120 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $25;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $24$hi;
  i64toi32_i32$2 = $0 + 128 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $24;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $33$hi;
  i64toi32_i32$2 = $0;
  HEAP32[(i64toi32_i32$2 + 136 | 0) >> 2] = $33;
  HEAP32[(i64toi32_i32$2 + 140 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $23$hi;
  i64toi32_i32$2 = i64toi32_i32$2 + 144 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $23;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $22$hi;
  i64toi32_i32$2 = $0 + 152 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $22;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP8[($0 + 372 | 0) >> 0] = $20;
  i64toi32_i32$3 = $2 + 24 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
  $344 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 397 | 0;
  $109 = $344;
  HEAP8[i64toi32_i32$1 >> 0] = $109;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $109 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $109 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $109 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$2;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
  i64toi32_i32$3 = $2 + 16 | 0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
  $349 = i64toi32_i32$2;
  i64toi32_i32$2 = $0 + 389 | 0;
  $110 = $349;
  HEAP8[i64toi32_i32$2 >> 0] = $110;
  HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $110 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $110 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $110 >>> 24 | 0;
  HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$3 = $2 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
  $354 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 381 | 0;
  $111 = $354;
  HEAP8[i64toi32_i32$1 >> 0] = $111;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $111 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $111 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $111 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$2;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
  i64toi32_i32$3 = $2;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
  $358 = i64toi32_i32$2;
  i64toi32_i32$2 = $0 + 373 | 0;
  $112 = $358;
  HEAP8[i64toi32_i32$2 >> 0] = $112;
  HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $112 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $112 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $112 >>> 24 | 0;
  HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  HEAP32[($0 + 328 | 0) >> 2] = HEAP32[((i64toi32_i32$3 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 32 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 36 | 0) >> 2] | 0;
  $367 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[(i64toi32_i32$1 + 320 | 0) >> 2] = $367;
  HEAP32[(i64toi32_i32$1 + 324 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $42$hi;
  i64toi32_i32$1 = i64toi32_i32$1 + 184 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $42;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $44$hi;
  i64toi32_i32$1 = $0;
  HEAP32[(i64toi32_i32$1 + 176 | 0) >> 2] = $44;
  HEAP32[(i64toi32_i32$1 + 180 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $43$hi;
  i64toi32_i32$1 = i64toi32_i32$1 + 168 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $43;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $45$hi;
  i64toi32_i32$1 = $0;
  HEAP32[(i64toi32_i32$1 + 160 | 0) >> 2] = $45;
  HEAP32[(i64toi32_i32$1 + 164 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$3 = (i64toi32_i32$3 + 48 | 0) + 8 | 0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
  $383 = i64toi32_i32$2;
  i64toi32_i32$2 = $0 + 340 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $383;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$3 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 48 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 52 | 0) >> 2] | 0;
  $386 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[(i64toi32_i32$1 + 332 | 0) >> 2] = $386;
  HEAP32[(i64toi32_i32$1 + 336 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $55$hi;
  HEAP32[(i64toi32_i32$1 + 364 | 0) >> 2] = $55;
  HEAP32[(i64toi32_i32$1 + 368 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $54$hi;
  HEAP32[(i64toi32_i32$1 + 356 | 0) >> 2] = $54;
  HEAP32[(i64toi32_i32$1 + 360 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $53$hi;
  HEAP32[(i64toi32_i32$1 + 348 | 0) >> 2] = $53;
  HEAP32[(i64toi32_i32$1 + 352 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $41$hi;
  i64toi32_i32$1 = i64toi32_i32$1 + 272 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $41;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $40$hi;
  i64toi32_i32$1 = $0 + 264 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $40;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $52$hi;
  i64toi32_i32$1 = $0;
  HEAP32[(i64toi32_i32$1 + 256 | 0) >> 2] = $52;
  HEAP32[(i64toi32_i32$1 + 260 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $39$hi;
  i64toi32_i32$1 = i64toi32_i32$1 + 248 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $39;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $32$hi;
  i64toi32_i32$1 = $0 + 240 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $32;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $51$hi;
  i64toi32_i32$1 = $0;
  HEAP32[(i64toi32_i32$1 + 232 | 0) >> 2] = $51;
  HEAP32[(i64toi32_i32$1 + 236 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $47$hi;
  i64toi32_i32$1 = i64toi32_i32$1 + 224 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $47;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $48$hi;
  i64toi32_i32$1 = $0 + 216 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $48;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $49$hi;
  i64toi32_i32$1 = $0 + 208 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $49;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $50$hi;
  i64toi32_i32$1 = $0 + 200 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $50;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $46$hi;
  i64toi32_i32$1 = $0;
  HEAP32[(i64toi32_i32$1 + 192 | 0) >> 2] = $46;
  HEAP32[(i64toi32_i32$1 + 196 | 0) >> 2] = i64toi32_i32$2;
  global$0 = i64toi32_i32$3 + 80 | 0;
 }
 
 function $cardano_serialization_lib__crypto__Nonce_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h5cb63bdaa73c6bd6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, $4 = 0, i64toi32_i32$4 = 0, $3 = 0, $5 = 0, $6 = 0, $14 = 0, $14$hi = 0, $15 = 0, $15$hi = 0, $16 = 0, $16$hi = 0, $17 = 0, $17$hi = 0, $18 = 0, $18$hi = 0, $33 = 0, $34 = 0, $35 = 0, $36 = 0, $37 = 0, $38 = 0, $39 = 0, $40 = 0, $41 = 0, $42 = 0, $43 = 0, $44 = 0, $45 = 0, $46 = 0, $47 = 0, $48 = 0, $49 = 0, $50 = 0, $51 = 0, $13 = 0, $13$hi = 0, $12 = 0, $52 = 0, $53 = 0, $54 = 0, $55 = 0, $56 = 0, $57 = 0, $58 = 0, $59 = 0, $60 = 0, $61 = 0, $76 = 0, $7 = 0, $8 = 0, $9 = 0, $10 = 0, $11 = 0, $337 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 48 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2 + 64 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $13 = i64toi32_i32$0;
  $13$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 56 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 60 | 0) >> 2] | 0;
  $14 = i64toi32_i32$1;
  $14$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         i64toi32_i32$2 = $2;
         i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
         i64toi32_i32$1 = HEAP32[($2 + 52 | 0) >> 2] | 0;
         i64toi32_i32$2 = i64toi32_i32$0;
         i64toi32_i32$0 = 0;
         i64toi32_i32$3 = 1;
         if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
          break label$7
         }
         cbor_event__de__Deserializer_R___unsigned_integer__h1ed99c0b7fe7eea1($2 + 48 | 0 | 0, $1 | 0);
         i64toi32_i32$3 = $2;
         i64toi32_i32$2 = HEAP32[($2 + 56 | 0) >> 2] | 0;
         i64toi32_i32$1 = HEAP32[($2 + 60 | 0) >> 2] | 0;
         $15 = i64toi32_i32$2;
         $15$hi = i64toi32_i32$1;
         label$8 : {
          label$9 : {
           label$10 : {
            i64toi32_i32$3 = $2;
            i64toi32_i32$1 = HEAP32[($2 + 48 | 0) >> 2] | 0;
            i64toi32_i32$2 = HEAP32[($2 + 52 | 0) >> 2] | 0;
            i64toi32_i32$3 = i64toi32_i32$1;
            i64toi32_i32$1 = 0;
            i64toi32_i32$0 = 1;
            if ((i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$1 | 0) | 0) {
             break label$10
            }
            i64toi32_i32$3 = $15$hi;
            i64toi32_i32$0 = $15;
            i64toi32_i32$2 = 0;
            i64toi32_i32$1 = 1;
            if (i64toi32_i32$3 >>> 0 > i64toi32_i32$2 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$0 >>> 0 > i64toi32_i32$1 >>> 0 | 0) | 0) {
             break label$3
            }
            $3 = 0;
            $4 = 1;
            i64toi32_i32$0 = $15$hi;
            switch ($15 | 0) {
            case 1:
             break label$9;
            default:
             break label$8;
            };
           }
           i64toi32_i32$0 = $15$hi;
           i64toi32_i32$1 = $15;
           i64toi32_i32$3 = 0;
           i64toi32_i32$2 = 32;
           i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
           if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
            i64toi32_i32$3 = 0;
            $52 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
           } else {
            i64toi32_i32$3 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
            $52 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
           }
           $5 = $52;
           i64toi32_i32$3 = $15$hi;
           i64toi32_i32$0 = $15;
           i64toi32_i32$1 = 0;
           i64toi32_i32$2 = 8;
           i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
           if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
            i64toi32_i32$1 = 0;
            $53 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
           } else {
            i64toi32_i32$1 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
            $53 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
           }
           $1 = $53;
           $6 = HEAP32[($2 + 68 | 0) >> 2] | 0;
           $3 = HEAP32[($2 + 64 | 0) >> 2] | 0;
           i64toi32_i32$3 = $2 + 88 | 0;
           i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
           $16 = i64toi32_i32$1;
           $16$hi = i64toi32_i32$0;
           i64toi32_i32$3 = $2 + 80 | 0;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
           $17 = i64toi32_i32$0;
           $17$hi = i64toi32_i32$1;
           i64toi32_i32$3 = $2 + 72 | 0;
           i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
           $18 = i64toi32_i32$1;
           $18$hi = i64toi32_i32$0;
           i64toi32_i32$0 = $15$hi;
           $4 = $15;
           break label$6;
          }
          cbor_event__de__Deserializer_R___bytes__hc697ccccfa39fd82($2 + 48 | 0 | 0, $1 | 0);
          label$11 : {
           label$12 : {
            if ((HEAP32[($2 + 48 | 0) >> 2] | 0 | 0) == (1 | 0)) {
             break label$12
            }
            i64toi32_i32$3 = $2;
            i64toi32_i32$0 = HEAP32[($2 + 52 | 0) >> 2] | 0;
            i64toi32_i32$1 = HEAP32[($2 + 56 | 0) >> 2] | 0;
            $76 = i64toi32_i32$0;
            i64toi32_i32$0 = $2;
            HEAP32[($2 + 32 | 0) >> 2] = $76;
            HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
            $4 = HEAP32[($2 + 60 | 0) >> 2] | 0;
            HEAP32[($2 + 40 | 0) >> 2] = $4;
            if (($4 | 0) == (32 | 0)) {
             break label$11
            }
            i64toi32_i32$1 = 0;
            $16 = $4;
            $16$hi = i64toi32_i32$1;
            $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 32 | 0 | 0);
            $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 32 | 0 | 0);
            $4 = 13;
            $5 = 1066390;
            $3 = 11;
            i64toi32_i32$1 = 0;
            $17 = 1;
            $17$hi = i64toi32_i32$1;
            i64toi32_i32$1 = 0;
            $18 = 32;
            $18$hi = i64toi32_i32$1;
            break label$6;
           }
           $4 = HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] | 0;
           $1 = $4 >>> 8 | 0;
           $6 = HEAP32[($2 + 68 | 0) >> 2] | 0;
           $3 = HEAP32[($2 + 64 | 0) >> 2] | 0;
           i64toi32_i32$3 = $2 + 88 | 0;
           i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
           $16 = i64toi32_i32$1;
           $16$hi = i64toi32_i32$0;
           i64toi32_i32$3 = $2 + 80 | 0;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
           $17 = i64toi32_i32$0;
           $17$hi = i64toi32_i32$1;
           i64toi32_i32$3 = $2 + 72 | 0;
           i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
           $18 = i64toi32_i32$1;
           $18$hi = i64toi32_i32$0;
           $5 = HEAP32[($2 + 60 | 0) >> 2] | 0;
           break label$6;
          }
          $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 | 0, $2 + 32 | 0 | 0);
          $4 = HEAP32[($2 + 4 | 0) >> 2] | 0;
          if ($4 >>> 0 <= 31 >>> 0) {
           break label$5
          }
          $T_20as_20core__convert__TryInto_U____try_into__ha1ac58dc74faf560($2 + 48 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, 32 | 0);
          $3 = 1;
          if ((HEAPU8[($2 + 48 | 0) >> 0] | 0 | 0) == (1 | 0)) {
           break label$4
          }
          HEAP16[($2 + 28 | 0) >> 1] = HEAPU8[($2 + 53 | 0) >> 0] | 0 | ((HEAPU8[($2 + 54 | 0) >> 0] | 0) << 8 | 0) | 0;
          HEAP32[($2 + 24 | 0) >> 2] = HEAPU8[($2 + 49 | 0) >> 0] | 0 | ((HEAPU8[($2 + 50 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 51 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 52 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          HEAP32[($2 + 16 | 0) >> 2] = HEAP32[($2 + 56 | 0) >> 2] | 0;
          $33 = $2 + 59 | 0;
          $34 = HEAPU8[$33 >> 0] | 0 | ((HEAPU8[($33 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($33 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($33 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          HEAP8[($2 + 19 | 0) >> 0] = $34;
          HEAP8[($2 + 20 | 0) >> 0] = $34 >>> 8 | 0;
          HEAP8[($2 + 21 | 0) >> 0] = $34 >>> 16 | 0;
          HEAP8[($2 + 22 | 0) >> 0] = $34 >>> 24 | 0;
          $6 = HEAPU16[(($2 + 48 | 0) + 16 | 0) >> 1] | 0 | ((HEAPU8[($2 + 66 | 0) >> 0] | 0) << 16 | 0) | 0;
          $7 = HEAPU8[($2 + 63 | 0) >> 0] | 0;
          $35 = $2 + 67 | 0;
          $8 = HEAPU8[$35 >> 0] | 0 | ((HEAPU8[($35 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($35 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($35 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          $36 = $2 + 71 | 0;
          $9 = HEAPU8[$36 >> 0] | 0 | ((HEAPU8[($36 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($36 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($36 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          $37 = $2 + 75 | 0;
          $10 = HEAPU8[$37 >> 0] | 0 | ((HEAPU8[($37 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($37 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($37 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          $54 = $2 + 79 | 0;
          $5 = HEAPU8[$54 >> 0] | 0 | ((HEAPU8[($54 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
          $11 = HEAPU8[($2 + 55 | 0) >> 0] | 0;
          $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 32 | 0 | 0);
          $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 32 | 0 | 0);
          $4 = 0;
         }
         label$13 : {
          label$14 : {
           label$15 : {
            label$16 : {
             i64toi32_i32$0 = $14$hi;
             i64toi32_i32$3 = $14;
             i64toi32_i32$1 = 0;
             i64toi32_i32$2 = 1;
             if ((i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
              break label$16
             }
             cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 48 | 0 | 0, $1 | 0);
             $4 = HEAPU8[($2 + 56 | 0) >> 0] | 0;
             i64toi32_i32$2 = $2;
             i64toi32_i32$3 = HEAP32[($2 + 48 | 0) >> 2] | 0;
             i64toi32_i32$0 = HEAP32[($2 + 52 | 0) >> 2] | 0;
             i64toi32_i32$2 = i64toi32_i32$3;
             i64toi32_i32$3 = 0;
             i64toi32_i32$1 = 1;
             if ((i64toi32_i32$2 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) | 0) {
              break label$15
             }
             $12 = 5;
             if (($4 & 255 | 0 | 0) == (5 | 0)) {
              break label$13
             }
             break label$2;
            }
            i64toi32_i32$2 = $13$hi;
            i64toi32_i32$1 = $13;
            i64toi32_i32$0 = -1;
            i64toi32_i32$3 = -1;
            i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
            i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
            if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
             i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
            }
            $14 = i64toi32_i32$4;
            $14$hi = i64toi32_i32$5;
            i64toi32_i32$2 = i64toi32_i32$4;
            i64toi32_i32$1 = 0;
            i64toi32_i32$3 = 1;
            if (i64toi32_i32$5 >>> 0 > i64toi32_i32$1 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$2 >>> 0 > i64toi32_i32$3 >>> 0 | 0) | 0) {
             break label$3
            }
            label$17 : {
             i64toi32_i32$2 = $14$hi;
             switch ($14 | 0) {
             case 1:
              break label$14;
             default:
              break label$17;
             };
            }
            if (!$4) {
             break label$3
            }
            break label$13;
           }
           $1 = HEAPU8[($2 + 57 | 0) >> 0] | 0 | ((HEAPU8[($2 + 58 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 59 | 0) >> 0] | 0) << 16 | 0) | 0;
           $6 = HEAP32[($2 + 68 | 0) >> 2] | 0;
           $3 = HEAP32[(($2 + 48 | 0) + 16 | 0) >> 2] | 0;
           i64toi32_i32$3 = $2 + 88 | 0;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
           i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
           $16 = i64toi32_i32$2;
           $16$hi = i64toi32_i32$5;
           i64toi32_i32$3 = $2 + 80 | 0;
           i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
           $17 = i64toi32_i32$5;
           $17$hi = i64toi32_i32$2;
           i64toi32_i32$3 = $2 + 72 | 0;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
           i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
           $18 = i64toi32_i32$2;
           $18$hi = i64toi32_i32$5;
           $5 = HEAP32[($2 + 60 | 0) >> 2] | 0;
           break label$6;
          }
          if ($4) {
           break label$3
          }
         }
         $1 = HEAPU16[(($2 + 24 | 0) + 4 | 0) >> 1] | 0;
         HEAP16[(($2 + 48 | 0) + 4 | 0) >> 1] = $1;
         $4 = HEAP32[($2 + 24 | 0) >> 2] | 0;
         HEAP32[($2 + 48 | 0) >> 2] = $4;
         HEAP32[($2 + 8 | 0) >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
         $38 = HEAPU8[($2 + 19 | 0) >> 0] | 0 | ((HEAPU8[($2 + 20 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 21 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 22 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[($2 + 11 | 0) >> 0] = $38;
         HEAP8[($2 + 12 | 0) >> 0] = $38 >>> 8 | 0;
         HEAP8[($2 + 13 | 0) >> 0] = $38 >>> 16 | 0;
         HEAP8[($2 + 14 | 0) >> 0] = $38 >>> 24 | 0;
         HEAP8[($0 + 19 | 0) >> 0] = $6 >>> 16 | 0;
         $55 = $0 + 17 | 0;
         HEAP8[$55 >> 0] = $6;
         HEAP8[($55 + 1 | 0) >> 0] = $6 >>> 8 | 0;
         HEAP8[($0 + 1 | 0) >> 0] = $3;
         $39 = $0 + 2 | 0;
         HEAP8[$39 >> 0] = $4;
         HEAP8[($39 + 1 | 0) >> 0] = $4 >>> 8 | 0;
         HEAP8[($39 + 2 | 0) >> 0] = $4 >>> 16 | 0;
         HEAP8[($39 + 3 | 0) >> 0] = $4 >>> 24 | 0;
         $56 = $0 + 6 | 0;
         HEAP8[$56 >> 0] = $1;
         HEAP8[($56 + 1 | 0) >> 0] = $1 >>> 8 | 0;
         HEAP8[($0 + 8 | 0) >> 0] = $11;
         $40 = $0 + 9 | 0;
         $41 = HEAP32[($2 + 8 | 0) >> 2] | 0;
         HEAP8[$40 >> 0] = $41;
         HEAP8[($40 + 1 | 0) >> 0] = $41 >>> 8 | 0;
         HEAP8[($40 + 2 | 0) >> 0] = $41 >>> 16 | 0;
         HEAP8[($40 + 3 | 0) >> 0] = $41 >>> 24 | 0;
         $42 = $0 + 12 | 0;
         $43 = HEAPU8[($2 + 11 | 0) >> 0] | 0 | ((HEAPU8[($2 + 12 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 13 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 14 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[$42 >> 0] = $43;
         HEAP8[($42 + 1 | 0) >> 0] = $43 >>> 8 | 0;
         HEAP8[($42 + 2 | 0) >> 0] = $43 >>> 16 | 0;
         HEAP8[($42 + 3 | 0) >> 0] = $43 >>> 24 | 0;
         $57 = $0 + 32 | 0;
         HEAP8[$57 >> 0] = $5;
         HEAP8[($57 + 1 | 0) >> 0] = $5 >>> 8 | 0;
         $44 = $0 + 28 | 0;
         $45 = $10;
         HEAP8[$44 >> 0] = $45;
         HEAP8[($44 + 1 | 0) >> 0] = $45 >>> 8 | 0;
         HEAP8[($44 + 2 | 0) >> 0] = $45 >>> 16 | 0;
         HEAP8[($44 + 3 | 0) >> 0] = $45 >>> 24 | 0;
         $46 = $0 + 24 | 0;
         $47 = $9;
         HEAP8[$46 >> 0] = $47;
         HEAP8[($46 + 1 | 0) >> 0] = $47 >>> 8 | 0;
         HEAP8[($46 + 2 | 0) >> 0] = $47 >>> 16 | 0;
         HEAP8[($46 + 3 | 0) >> 0] = $47 >>> 24 | 0;
         $48 = $0 + 20 | 0;
         $49 = $8;
         HEAP8[$48 >> 0] = $49;
         HEAP8[($48 + 1 | 0) >> 0] = $49 >>> 8 | 0;
         HEAP8[($48 + 2 | 0) >> 0] = $49 >>> 16 | 0;
         HEAP8[($48 + 3 | 0) >> 0] = $49 >>> 24 | 0;
         HEAP8[($0 + 16 | 0) >> 0] = $7;
         $1 = 0;
         break label$1;
        }
        i64toi32_i32$5 = $14$hi;
        i64toi32_i32$3 = $14;
        i64toi32_i32$2 = 0;
        i64toi32_i32$1 = 32;
        i64toi32_i32$0 = i64toi32_i32$1 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
         i64toi32_i32$2 = 0;
         $58 = i64toi32_i32$5 >>> i64toi32_i32$0 | 0;
        } else {
         i64toi32_i32$2 = i64toi32_i32$5 >>> i64toi32_i32$0 | 0;
         $58 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$0 | 0) | 0;
        }
        $5 = $58;
        i64toi32_i32$2 = $13$hi;
        i64toi32_i32$5 = $13;
        i64toi32_i32$3 = 0;
        i64toi32_i32$1 = 32;
        i64toi32_i32$0 = i64toi32_i32$1 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
         i64toi32_i32$3 = 0;
         $59 = i64toi32_i32$2 >>> i64toi32_i32$0 | 0;
        } else {
         i64toi32_i32$3 = i64toi32_i32$2 >>> i64toi32_i32$0 | 0;
         $59 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$0 | 0) | 0;
        }
        $6 = $59;
        i64toi32_i32$3 = $14$hi;
        i64toi32_i32$2 = $14;
        i64toi32_i32$5 = 0;
        i64toi32_i32$1 = 8;
        i64toi32_i32$0 = i64toi32_i32$1 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
         i64toi32_i32$5 = 0;
         $60 = i64toi32_i32$3 >>> i64toi32_i32$0 | 0;
        } else {
         i64toi32_i32$5 = i64toi32_i32$3 >>> i64toi32_i32$0 | 0;
         $60 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$0 | 0) | 0;
        }
        $1 = $60;
        i64toi32_i32$3 = $2 + 88 | 0;
        i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $16 = i64toi32_i32$5;
        $16$hi = i64toi32_i32$2;
        i64toi32_i32$3 = $2 + 80 | 0;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $17 = i64toi32_i32$2;
        $17$hi = i64toi32_i32$5;
        i64toi32_i32$3 = $2 + 72 | 0;
        i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $18 = i64toi32_i32$5;
        $18$hi = i64toi32_i32$2;
        i64toi32_i32$2 = $13$hi;
        $3 = $13;
        i64toi32_i32$2 = $14$hi;
        $4 = $14;
       }
       $12 = 2;
       break label$2;
      }
      core__slice__index__slice_end_index_len_fail__h192505a15ac4b345(32 | 0, $4 | 0, 1066408 | 0);
      abort();
     }
     core__result__unwrap_failed__h27f43d993c3864a1(1066120 | 0, 43 | 0, $2 + 8 | 0 | 0, 1066180 | 0, 1066424 | 0);
     abort();
    }
    $12 = 11;
   }
   HEAP8[($2 + 59 | 0) >> 0] = $1 >>> 16 | 0;
   $61 = $2 + 57 | 0;
   HEAP8[$61 >> 0] = $1;
   HEAP8[($61 + 1 | 0) >> 0] = $1 >>> 8 | 0;
   i64toi32_i32$2 = $16$hi;
   i64toi32_i32$5 = $2 + 88 | 0;
   HEAP32[i64toi32_i32$5 >> 2] = $16;
   HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$2 = $17$hi;
   i64toi32_i32$5 = $2 + 80 | 0;
   HEAP32[i64toi32_i32$5 >> 2] = $17;
   HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$2 = $18$hi;
   i64toi32_i32$5 = $2 + 72 | 0;
   HEAP32[i64toi32_i32$5 >> 2] = $18;
   HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$2;
   HEAP32[($2 + 68 | 0) >> 2] = $6;
   HEAP32[(($2 + 48 | 0) + 16 | 0) >> 2] = $3;
   HEAP32[($2 + 60 | 0) >> 2] = $5;
   HEAP8[(($2 + 48 | 0) + 8 | 0) >> 0] = $4;
   i64toi32_i32$3 = $2;
   i64toi32_i32$2 = HEAP32[($2 + 32 | 0) >> 2] | 0;
   i64toi32_i32$5 = HEAP32[($2 + 36 | 0) >> 2] | 0;
   $337 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 100 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $337;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$5;
   HEAP32[($2 + 108 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
   HEAP8[($2 + 48 | 0) >> 0] = $12;
   $50 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   HEAP8[($2 + 49 | 0) >> 0] = $50;
   HEAP8[($2 + 50 | 0) >> 0] = $50 >>> 8 | 0;
   HEAP8[($2 + 51 | 0) >> 0] = $50 >>> 16 | 0;
   HEAP8[($2 + 52 | 0) >> 0] = $50 >>> 24 | 0;
   $51 = HEAPU8[($2 + 11 | 0) >> 0] | 0 | ((HEAPU8[($2 + 12 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 13 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 14 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[($2 + 52 | 0) >> 0] = $51;
   HEAP8[($2 + 53 | 0) >> 0] = $51 >>> 8 | 0;
   HEAP8[($2 + 54 | 0) >> 0] = $51 >>> 16 | 0;
   HEAP8[($2 + 55 | 0) >> 0] = $51 >>> 24 | 0;
   HEAP32[($2 + 96 | 0) >> 2] = 0;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 48 | 0 | 0, 1066401 | 0, 5 | 0);
   $1 = 1;
  }
  HEAP8[$0 >> 0] = $1;
  global$0 = $2 + 112 | 0;
 }
 
 function $cbor_event__error__Error_20as_20core__fmt__Display___fmt__h53a4f5e6c5d2b7ba($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    switch (HEAPU8[$0 >> 0] | 0 | 0) {
    default:
     HEAP32[($2 + 60 | 0) >> 2] = 0;
     HEAP32[($2 + 56 | 0) >> 2] = 1140176;
     i64toi32_i32$0 = 0;
     HEAP32[($2 + 44 | 0) >> 2] = 1;
     HEAP32[($2 + 48 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($2 + 40 | 0) >> 2] = 1141308;
     $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 40 | 0 | 0) | 0;
     break label$1;
    case 1:
     HEAP32[($2 + 60 | 0) >> 2] = 0;
     HEAP32[($2 + 56 | 0) >> 2] = 1140176;
     i64toi32_i32$0 = 0;
     HEAP32[($2 + 44 | 0) >> 2] = 1;
     HEAP32[($2 + 48 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($2 + 40 | 0) >> 2] = 1141248;
     $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 40 | 0 | 0) | 0;
     break label$1;
    case 2:
     HEAP32[($2 + 60 | 0) >> 2] = 0;
     HEAP32[($2 + 56 | 0) >> 2] = 1140176;
     i64toi32_i32$0 = 0;
     HEAP32[($2 + 44 | 0) >> 2] = 1;
     HEAP32[($2 + 48 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($2 + 40 | 0) >> 2] = 1141188;
     $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 40 | 0 | 0) | 0;
     break label$1;
    case 3:
     HEAP32[($2 + 60 | 0) >> 2] = 0;
     HEAP32[($2 + 56 | 0) >> 2] = 1140176;
     i64toi32_i32$0 = 0;
     HEAP32[($2 + 44 | 0) >> 2] = 1;
     HEAP32[($2 + 48 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($2 + 40 | 0) >> 2] = 1141128;
     $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 40 | 0 | 0) | 0;
     break label$1;
    case 4:
     HEAP32[($2 + 60 | 0) >> 2] = 0;
     HEAP32[($2 + 56 | 0) >> 2] = 1140176;
     i64toi32_i32$0 = 0;
     HEAP32[($2 + 44 | 0) >> 2] = 1;
     HEAP32[($2 + 48 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($2 + 40 | 0) >> 2] = 1141068;
     $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 40 | 0 | 0) | 0;
     break label$1;
    case 5:
     HEAP32[($2 + 60 | 0) >> 2] = 0;
     HEAP32[($2 + 56 | 0) >> 2] = 1140176;
     i64toi32_i32$0 = 0;
     HEAP32[($2 + 44 | 0) >> 2] = 1;
     HEAP32[($2 + 48 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($2 + 40 | 0) >> 2] = 1141008;
     $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 40 | 0 | 0) | 0;
     break label$1;
    case 6:
     HEAP32[($2 + 60 | 0) >> 2] = 0;
     HEAP32[($2 + 56 | 0) >> 2] = 1140176;
     i64toi32_i32$0 = 0;
     HEAP32[($2 + 44 | 0) >> 2] = 1;
     HEAP32[($2 + 48 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($2 + 40 | 0) >> 2] = 1140948;
     $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 40 | 0 | 0) | 0;
     break label$1;
    case 7:
     HEAP32[($2 + 60 | 0) >> 2] = 0;
     HEAP32[($2 + 56 | 0) >> 2] = 1140176;
     i64toi32_i32$0 = 0;
     HEAP32[($2 + 44 | 0) >> 2] = 1;
     HEAP32[($2 + 48 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($2 + 40 | 0) >> 2] = 1140888;
     $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 40 | 0 | 0) | 0;
     break label$1;
    case 8:
     HEAP32[($2 + 32 | 0) >> 2] = $0 + 4 | 0;
     HEAP32[($2 + 36 | 0) >> 2] = $0 + 8 | 0;
     HEAP32[($2 + 60 | 0) >> 2] = 2;
     HEAP32[($2 + 20 | 0) >> 2] = 245;
     i64toi32_i32$0 = 0;
     HEAP32[($2 + 44 | 0) >> 2] = 3;
     HEAP32[($2 + 48 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($2 + 40 | 0) >> 2] = 1140812;
     HEAP32[($2 + 12 | 0) >> 2] = 245;
     HEAP32[($2 + 56 | 0) >> 2] = $2 + 8 | 0;
     HEAP32[($2 + 16 | 0) >> 2] = $2 + 32 | 0;
     HEAP32[($2 + 8 | 0) >> 2] = $2 + 36 | 0;
     $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 40 | 0 | 0) | 0;
     break label$1;
    case 9:
     HEAP32[($2 + 32 | 0) >> 2] = $0 + 1 | 0;
     HEAP32[($2 + 36 | 0) >> 2] = $0 + 2 | 0;
     HEAP32[($2 + 60 | 0) >> 2] = 2;
     HEAP32[($2 + 20 | 0) >> 2] = 95;
     i64toi32_i32$0 = 0;
     HEAP32[($2 + 44 | 0) >> 2] = 3;
     HEAP32[($2 + 48 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($2 + 40 | 0) >> 2] = 1140720;
     HEAP32[($2 + 12 | 0) >> 2] = 95;
     HEAP32[($2 + 56 | 0) >> 2] = $2 + 8 | 0;
     HEAP32[($2 + 16 | 0) >> 2] = $2 + 36 | 0;
     HEAP32[($2 + 8 | 0) >> 2] = $2 + 32 | 0;
     $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 40 | 0 | 0) | 0;
     break label$1;
    case 10:
     HEAP32[($2 + 60 | 0) >> 2] = 0;
     HEAP32[($2 + 56 | 0) >> 2] = 1140176;
     i64toi32_i32$0 = 0;
     HEAP32[($2 + 44 | 0) >> 2] = 1;
     HEAP32[($2 + 48 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($2 + 40 | 0) >> 2] = 1140648;
     $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 40 | 0 | 0) | 0;
     break label$1;
    case 11:
     HEAP32[($2 + 36 | 0) >> 2] = $0 + 1 | 0;
     HEAP32[($2 + 60 | 0) >> 2] = 1;
     HEAP32[($2 + 52 | 0) >> 2] = 1;
     HEAP32[($2 + 48 | 0) >> 2] = 1140584;
     HEAP32[($2 + 44 | 0) >> 2] = 1;
     HEAP32[($2 + 40 | 0) >> 2] = 1140576;
     HEAP32[($2 + 12 | 0) >> 2] = 90;
     HEAP32[($2 + 56 | 0) >> 2] = $2 + 8 | 0;
     HEAP32[($2 + 8 | 0) >> 2] = $2 + 36 | 0;
     $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 40 | 0 | 0) | 0;
     break label$1;
    case 12:
     HEAP32[($2 + 36 | 0) >> 2] = $0 + 1 | 0;
     HEAP32[($2 + 60 | 0) >> 2] = 1;
     i64toi32_i32$0 = 0;
     HEAP32[($2 + 44 | 0) >> 2] = 2;
     HEAP32[($2 + 48 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($2 + 40 | 0) >> 2] = 1140520;
     HEAP32[($2 + 12 | 0) >> 2] = 95;
     HEAP32[($2 + 56 | 0) >> 2] = $2 + 8 | 0;
     HEAP32[($2 + 8 | 0) >> 2] = $2 + 36 | 0;
     $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 40 | 0 | 0) | 0;
     break label$1;
    case 13:
     HEAP32[($2 + 4 | 0) >> 2] = $0 + 16 | 0;
     HEAP32[($2 + 32 | 0) >> 2] = $0 + 24 | 0;
     HEAP32[($2 + 36 | 0) >> 2] = $0 + 4 | 0;
     HEAP32[(($2 + 8 | 0) + 20 | 0) >> 2] = 3;
     HEAP32[(($2 + 40 | 0) + 20 | 0) >> 2] = 246;
     HEAP32[($2 + 52 | 0) >> 2] = 87;
     i64toi32_i32$0 = 0;
     HEAP32[($2 + 12 | 0) >> 2] = 4;
     HEAP32[($2 + 16 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($2 + 8 | 0) >> 2] = 1140412;
     HEAP32[($2 + 44 | 0) >> 2] = 247;
     HEAP32[($2 + 24 | 0) >> 2] = $2 + 40 | 0;
     HEAP32[($2 + 56 | 0) >> 2] = $2 + 32 | 0;
     HEAP32[($2 + 48 | 0) >> 2] = $2 + 4 | 0;
     HEAP32[($2 + 40 | 0) >> 2] = $2 + 36 | 0;
     $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 8 | 0 | 0) | 0;
     break label$1;
    case 14:
     HEAP32[($2 + 60 | 0) >> 2] = 0;
     HEAP32[($2 + 56 | 0) >> 2] = 1140176;
     i64toi32_i32$0 = 0;
     HEAP32[($2 + 44 | 0) >> 2] = 1;
     HEAP32[($2 + 48 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($2 + 40 | 0) >> 2] = 1140344;
     $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 40 | 0 | 0) | 0;
     break label$1;
    case 15:
     HEAP32[($2 + 32 | 0) >> 2] = $0 + 1 | 0;
     HEAP32[($2 + 36 | 0) >> 2] = $0 + 4 | 0;
     HEAP32[($2 + 60 | 0) >> 2] = 2;
     HEAP32[($2 + 20 | 0) >> 2] = 248;
     i64toi32_i32$0 = 0;
     HEAP32[($2 + 44 | 0) >> 2] = 2;
     HEAP32[($2 + 48 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($2 + 40 | 0) >> 2] = 1140280;
     HEAP32[($2 + 12 | 0) >> 2] = 95;
     HEAP32[($2 + 56 | 0) >> 2] = $2 + 8 | 0;
     HEAP32[($2 + 16 | 0) >> 2] = $2 + 36 | 0;
     HEAP32[($2 + 8 | 0) >> 2] = $2 + 32 | 0;
     $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 40 | 0 | 0) | 0;
     break label$1;
    case 16:
     HEAP32[($2 + 60 | 0) >> 2] = 0;
     HEAP32[($2 + 56 | 0) >> 2] = 1140176;
     i64toi32_i32$0 = 0;
     HEAP32[($2 + 44 | 0) >> 2] = 1;
     HEAP32[($2 + 48 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($2 + 40 | 0) >> 2] = 1140200;
     $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 40 | 0 | 0) | 0;
     break label$1;
    case 17:
     HEAP32[($2 + 60 | 0) >> 2] = 0;
     HEAP32[($2 + 56 | 0) >> 2] = 1140176;
     i64toi32_i32$0 = 0;
     HEAP32[($2 + 44 | 0) >> 2] = 1;
     HEAP32[($2 + 48 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($2 + 40 | 0) >> 2] = 1140168;
     $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 40 | 0 | 0) | 0;
     break label$1;
    case 18:
     break label$2;
    };
   }
   HEAP32[($2 + 36 | 0) >> 2] = $0 + 4 | 0;
   HEAP32[($2 + 60 | 0) >> 2] = 1;
   i64toi32_i32$0 = 0;
   HEAP32[($2 + 44 | 0) >> 2] = 1;
   HEAP32[($2 + 48 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($2 + 40 | 0) >> 2] = 1140128;
   HEAP32[($2 + 12 | 0) >> 2] = 16;
   HEAP32[($2 + 56 | 0) >> 2] = $2 + 8 | 0;
   HEAP32[($2 + 8 | 0) >> 2] = $2 + 36 | 0;
   $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 40 | 0 | 0) | 0;
  }
  global$0 = $2 + 64 | 0;
  return $0 | 0;
 }
 
 function $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__clone_subtree__h13f26fe92cdbb434($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $4 = 0, $5 = 0, $7 = 0, $6 = 0, $30 = 0, $31 = 0, $32 = 0, $33 = 0, $34 = 0, $35 = 0, $36 = 0, $37 = 0, $38 = 0, $39 = 0, $40 = 0, $41 = 0, $42 = 0, $43 = 0, $52 = 0, $102 = 0, $107 = 0, $129 = 0, $151 = 0, $179 = 0, $8 = 0, $228 = 0, $233 = 0, $246 = 0, $259 = 0, $272 = 0, $282 = 0, $9 = 0, $308 = 0, $311 = 0, $317 = 0, $323 = 0, $359 = 0;
  $3 = global$0 - 208 | 0;
  global$0 = $3;
  alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___force__h8203d42018ada81e($3 + 56 | 0 | 0, $1 | 0, $2 | 0);
  $1 = HEAP32[($3 + 64 | 0) >> 2] | 0;
  $2 = HEAP32[($3 + 60 | 0) >> 2] | 0;
  label$1 : {
   label$2 : {
    if ((HEAP32[($3 + 56 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Owned_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___new__h2d48df2c386b61df($3 + 48 | 0 | 0);
    HEAP32[($3 + 120 | 0) >> 2] = 0;
    $4 = HEAP32[($3 + 52 | 0) >> 2] | 0;
    HEAP32[($3 + 116 | 0) >> 2] = $4;
    HEAP32[($3 + 112 | 0) >> 2] = HEAP32[($3 + 48 | 0) >> 2] | 0;
    label$3 : {
     label$4 : {
      if (!$4) {
       break label$4
      }
      alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Owned_2cK_2cV_2cType___borrow_mut__h53ccf72dd46326bf($3 + 40 | 0 | 0, $3 + 112 | 0 | 0);
      alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___force__h59ee48980727210c($3 + 184 | 0 | 0, HEAP32[($3 + 40 | 0) >> 2] | 0 | 0, HEAP32[($3 + 44 | 0) >> 2] | 0 | 0);
      if ((HEAP32[($3 + 184 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      i64toi32_i32$2 = $3;
      i64toi32_i32$0 = HEAP32[($3 + 188 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($3 + 192 | 0) >> 2] | 0;
      $52 = i64toi32_i32$0;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 96 | 0) >> 2] = $52;
      HEAP32[($3 + 100 | 0) >> 2] = i64toi32_i32$1;
      alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType___first_edge__h9fd77210c962450d($3 + 152 | 0 | 0, $2 | 0, $1 | 0);
      label$5 : {
       $1 = HEAP32[($3 + 160 | 0) >> 2] | 0;
       $2 = HEAP32[($3 + 156 | 0) >> 2] | 0;
       if ($1 >>> 0 >= (HEAPU16[($2 + 402 | 0) >> 1] | 0) >>> 0) {
        break label$5
       }
       $5 = ($3 + 184 | 0) + 8 | 0;
       $4 = $3 + 184 | 0 | 4 | 0;
       label$6 : while (1) {
        HEAP32[($3 + 184 | 0) >> 2] = HEAP32[($3 + 152 | 0) >> 2] | 0;
        HEAP32[($3 + 192 | 0) >> 2] = $1;
        HEAP32[($3 + 188 | 0) >> 2] = $2;
        alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___right_edge__hf795564396a070fc($3 + 152 | 0 | 0, $3 + 184 | 0 | 0);
        $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($3 + 168 | 0 | 0, ($2 + Math_imul($1, 12) | 0) + 268 | 0 | 0);
        label$7 : {
         label$8 : {
          label$9 : {
           label$10 : {
            label$11 : {
             label$12 : {
              label$13 : {
               $1 = $2 + Math_imul($1, 24) | 0;
               switch (HEAPU8[$1 >> 0] | 0 | 0) {
               case 3:
                break label$10;
               case 2:
                break label$11;
               case 1:
                break label$12;
               case 5:
                break label$8;
               case 4:
                break label$9;
               default:
                break label$13;
               };
              }
              HEAP8[($3 + 184 | 0) >> 0] = 0;
              break label$7;
             }
             HEAP8[($3 + 184 | 0) >> 0] = 1;
             HEAP8[($3 + 185 | 0) >> 0] = HEAPU8[($1 + 1 | 0) >> 0] | 0;
             break label$7;
            }
            i64toi32_i32$2 = $1;
            i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
            i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
            $102 = i64toi32_i32$1;
            i64toi32_i32$1 = $5;
            HEAP32[i64toi32_i32$1 >> 2] = $102;
            HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
            i64toi32_i32$2 = i64toi32_i32$2 + 16 | 0;
            i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
            i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
            $107 = i64toi32_i32$0;
            i64toi32_i32$0 = $5 + 8 | 0;
            HEAP32[i64toi32_i32$0 >> 2] = $107;
            HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
            HEAP8[($3 + 184 | 0) >> 0] = 2;
            break label$7;
           }
           $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($4 | 0, $1 + 4 | 0 | 0);
           HEAP8[($3 + 184 | 0) >> 0] = 3;
           break label$7;
          }
          $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__ha732c788391a1960($4 | 0, $1 + 4 | 0 | 0);
          HEAP8[($3 + 184 | 0) >> 0] = 4;
          break label$7;
         }
         $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__hf249498970160004($3 + 128 | 0 | 0, $1 + 4 | 0 | 0);
         HEAP32[($4 + 8 | 0) >> 2] = HEAP32[(($3 + 128 | 0) + 8 | 0) >> 2] | 0;
         i64toi32_i32$2 = $3;
         i64toi32_i32$1 = HEAP32[($3 + 128 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($3 + 132 | 0) >> 2] | 0;
         $129 = i64toi32_i32$1;
         i64toi32_i32$1 = $4;
         HEAP32[i64toi32_i32$1 >> 2] = $129;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
         HEAP8[($3 + 184 | 0) >> 0] = 5;
        }
        alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf___push__hed6a81377b16396f($3 + 96 | 0 | 0, $3 + 168 | 0 | 0, $3 + 184 | 0 | 0);
        HEAP32[($3 + 120 | 0) >> 2] = (HEAP32[($3 + 120 | 0) >> 2] | 0) + 1 | 0;
        $1 = HEAP32[($3 + 160 | 0) >> 2] | 0;
        $2 = HEAP32[($3 + 156 | 0) >> 2] | 0;
        if ($1 >>> 0 < (HEAPU16[($2 + 402 | 0) >> 1] | 0) >>> 0) {
         continue label$6
        }
        break label$6;
       };
      }
      i64toi32_i32$2 = $3;
      i64toi32_i32$0 = HEAP32[($3 + 112 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($3 + 116 | 0) >> 2] | 0;
      $151 = i64toi32_i32$0;
      i64toi32_i32$0 = $0;
      HEAP32[i64toi32_i32$0 >> 2] = $151;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[(($3 + 112 | 0) + 8 | 0) >> 2] | 0;
      break label$1;
     }
     core__panicking__panic__h2fd385a887c8bf13(1067386 | 0, 43 | 0, 1067836 | 0);
     abort();
    }
    core__panicking__panic__h2fd385a887c8bf13(1067852 | 0, 40 | 0, 1067892 | 0);
    abort();
   }
   alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType___first_edge__hcd03120285185059($3 + 184 | 0 | 0, $2 | 0, $1 | 0);
   alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___descend__h3e2a2cdd3746a926($3 + 32 | 0 | 0, $3 + 184 | 0 | 0);
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__clone_subtree__h13f26fe92cdbb434($3 + 72 | 0 | 0, HEAP32[($3 + 32 | 0) >> 2] | 0 | 0, HEAP32[($3 + 36 | 0) >> 2] | 0 | 0);
   alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Owned_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___push_internal_level__h5645c5988692fce9($3 + 24 | 0 | 0, alloc__collections__btree__map__BTreeMap_K_2cV___ensure_is_owned__h192fdf462a287fc7($3 + 72 | 0 | 0) | 0 | 0);
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[($3 + 24 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($3 + 28 | 0) >> 2] | 0;
   $179 = i64toi32_i32$1;
   i64toi32_i32$1 = $3;
   HEAP32[($3 + 88 | 0) >> 2] = $179;
   HEAP32[($3 + 92 | 0) >> 2] = i64toi32_i32$0;
   alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType___first_edge__hcd03120285185059($3 + 96 | 0 | 0, $2 | 0, $1 | 0);
   label$14 : {
    $1 = HEAP32[($3 + 104 | 0) >> 2] | 0;
    $2 = HEAP32[($3 + 100 | 0) >> 2] | 0;
    if ($1 >>> 0 >= (HEAPU16[($2 + 402 | 0) >> 1] | 0) >>> 0) {
     break label$14
    }
    $4 = $3 + 184 | 0 | 2 | 0;
    $6 = $3 + 134 | 0;
    $7 = ($3 + 128 | 0) + 2 | 0;
    label$15 : while (1) {
     HEAP32[($3 + 184 | 0) >> 2] = HEAP32[($3 + 96 | 0) >> 2] | 0;
     HEAP32[($3 + 192 | 0) >> 2] = $1;
     HEAP32[($3 + 188 | 0) >> 2] = $2;
     alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___right_edge__hb28718837482d3cf($3 + 96 | 0 | 0, $3 + 184 | 0 | 0);
     $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($3 + 112 | 0 | 0, ($2 + Math_imul($1, 12) | 0) + 268 | 0 | 0);
     $5 = 0;
     label$16 : {
      label$17 : {
       label$18 : {
        label$19 : {
         label$20 : {
          label$21 : {
           $1 = $2 + Math_imul($1, 24) | 0;
           switch (HEAPU8[$1 >> 0] | 0 | 0) {
           case 5:
            break label$17;
           case 4:
            break label$18;
           case 3:
            break label$19;
           case 2:
            break label$20;
           case 1:
            break label$21;
           default:
            break label$16;
           };
          }
          $8 = HEAPU8[($1 + 1 | 0) >> 0] | 0;
          $5 = 1;
          break label$16;
         }
         i64toi32_i32$2 = $1;
         i64toi32_i32$0 = HEAPU16[($1 + 8 | 0) >> 1] | 0 | ((HEAPU16[($1 + 10 | 0) >> 1] | 0) << 16 | 0) | 0;
         i64toi32_i32$1 = HEAPU16[($1 + 12 | 0) >> 1] | 0 | ((HEAPU16[($1 + 14 | 0) >> 1] | 0) << 16 | 0) | 0;
         $228 = i64toi32_i32$0;
         i64toi32_i32$0 = $6;
         $30 = $228;
         HEAP16[i64toi32_i32$0 >> 1] = $30;
         HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $30 >>> 16 | 0;
         HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$1;
         HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
         i64toi32_i32$2 = $1 + 16 | 0;
         i64toi32_i32$1 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
         i64toi32_i32$0 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
         $233 = i64toi32_i32$1;
         i64toi32_i32$1 = $6 + 8 | 0;
         $31 = $233;
         HEAP16[i64toi32_i32$1 >> 1] = $31;
         HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $31 >>> 16 | 0;
         HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = i64toi32_i32$0;
         HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
         $5 = 2;
         break label$16;
        }
        $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($3 + 184 | 0 | 0, $1 + 4 | 0 | 0);
        $32 = $7 + 8 | 0;
        $33 = HEAP32[(($3 + 184 | 0) + 8 | 0) >> 2] | 0;
        HEAP16[$32 >> 1] = $33;
        HEAP16[($32 + 2 | 0) >> 1] = $33 >>> 16 | 0;
        i64toi32_i32$2 = $3;
        i64toi32_i32$0 = HEAP32[($3 + 184 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($3 + 188 | 0) >> 2] | 0;
        $246 = i64toi32_i32$0;
        i64toi32_i32$0 = $7;
        $34 = $246;
        HEAP16[i64toi32_i32$0 >> 1] = $34;
        HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $34 >>> 16 | 0;
        HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$1;
        HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
        $5 = 3;
        break label$16;
       }
       $5 = 4;
       $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__ha732c788391a1960($3 + 184 | 0 | 0, $1 + 4 | 0 | 0);
       $35 = $7 + 8 | 0;
       $36 = HEAP32[(($3 + 184 | 0) + 8 | 0) >> 2] | 0;
       HEAP16[$35 >> 1] = $36;
       HEAP16[($35 + 2 | 0) >> 1] = $36 >>> 16 | 0;
       i64toi32_i32$2 = $3;
       i64toi32_i32$1 = HEAP32[($3 + 184 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[($3 + 188 | 0) >> 2] | 0;
       $259 = i64toi32_i32$1;
       i64toi32_i32$1 = $7;
       $37 = $259;
       HEAP16[i64toi32_i32$1 >> 1] = $37;
       HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $37 >>> 16 | 0;
       HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = i64toi32_i32$0;
       HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
       break label$16;
      }
      $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__hf249498970160004($3 + 184 | 0 | 0, $1 + 4 | 0 | 0);
      $38 = $7 + 8 | 0;
      $39 = HEAP32[(($3 + 184 | 0) + 8 | 0) >> 2] | 0;
      HEAP16[$38 >> 1] = $39;
      HEAP16[($38 + 2 | 0) >> 1] = $39 >>> 16 | 0;
      i64toi32_i32$2 = $3;
      i64toi32_i32$0 = HEAP32[($3 + 184 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($3 + 188 | 0) >> 2] | 0;
      $272 = i64toi32_i32$0;
      i64toi32_i32$0 = $7;
      $40 = $272;
      HEAP16[i64toi32_i32$0 >> 1] = $40;
      HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $40 >>> 16 | 0;
      HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$1;
      HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
      $5 = 5;
     }
     HEAP32[(($3 + 184 | 0) + 8 | 0) >> 2] = HEAP32[(($3 + 96 | 0) + 8 | 0) >> 2] | 0;
     i64toi32_i32$2 = $3;
     i64toi32_i32$1 = HEAP32[($3 + 96 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($3 + 100 | 0) >> 2] | 0;
     $282 = i64toi32_i32$1;
     i64toi32_i32$1 = $3;
     HEAP32[($3 + 184 | 0) >> 2] = $282;
     HEAP32[($3 + 188 | 0) >> 2] = i64toi32_i32$0;
     alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___descend__h3e2a2cdd3746a926($3 + 16 | 0 | 0, $3 + 184 | 0 | 0);
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__clone_subtree__h13f26fe92cdbb434($3 + 152 | 0 | 0, HEAP32[($3 + 16 | 0) >> 2] | 0 | 0, HEAP32[($3 + 20 | 0) >> 2] | 0 | 0);
     $9 = HEAP32[($3 + 160 | 0) >> 2] | 0;
     $1 = HEAP32[($3 + 156 | 0) >> 2] | 0;
     $2 = HEAP32[($3 + 152 | 0) >> 2] | 0;
     HEAP32[(($3 + 168 | 0) + 8 | 0) >> 2] = HEAP32[(($3 + 112 | 0) + 8 | 0) >> 2] | 0;
     i64toi32_i32$2 = $3;
     i64toi32_i32$0 = HEAP32[($3 + 112 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($3 + 116 | 0) >> 2] | 0;
     $308 = i64toi32_i32$0;
     i64toi32_i32$0 = $3;
     HEAP32[($3 + 168 | 0) >> 2] = $308;
     HEAP32[($3 + 172 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $3;
     i64toi32_i32$1 = HEAPU16[($3 + 128 | 0) >> 1] | 0 | ((HEAPU16[($3 + 130 | 0) >> 1] | 0) << 16 | 0) | 0;
     i64toi32_i32$0 = HEAPU16[($3 + 132 | 0) >> 1] | 0 | ((HEAPU16[($3 + 134 | 0) >> 1] | 0) << 16 | 0) | 0;
     $311 = i64toi32_i32$1;
     i64toi32_i32$1 = $4;
     $41 = $311;
     HEAP16[i64toi32_i32$1 >> 1] = $41;
     HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $41 >>> 16 | 0;
     HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = i64toi32_i32$0;
     HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
     i64toi32_i32$2 = ($3 + 128 | 0) + 8 | 0;
     i64toi32_i32$0 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
     i64toi32_i32$1 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
     $317 = i64toi32_i32$0;
     i64toi32_i32$0 = $4 + 8 | 0;
     $42 = $317;
     HEAP16[i64toi32_i32$0 >> 1] = $42;
     HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $42 >>> 16 | 0;
     HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$1;
     HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
     i64toi32_i32$2 = ($3 + 128 | 0) + 14 | 0;
     i64toi32_i32$1 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
     i64toi32_i32$0 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
     $323 = i64toi32_i32$1;
     i64toi32_i32$1 = $4 + 14 | 0;
     $43 = $323;
     HEAP16[i64toi32_i32$1 >> 1] = $43;
     HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $43 >>> 16 | 0;
     HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = i64toi32_i32$0;
     HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
     HEAP8[($3 + 185 | 0) >> 0] = $8;
     HEAP8[($3 + 184 | 0) >> 0] = $5;
     label$22 : {
      if ($1) {
       break label$22
      }
      alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Owned_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___new__h2d48df2c386b61df($3 + 8 | 0 | 0);
      $1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
      $2 = HEAP32[($3 + 8 | 0) >> 2] | 0;
     }
     alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal___push__h92c515d208d4f729($3 + 88 | 0 | 0, $3 + 168 | 0 | 0, $3 + 184 | 0 | 0, $2 | 0, $1 | 0);
     HEAP32[($3 + 80 | 0) >> 2] = ($9 + (HEAP32[($3 + 80 | 0) >> 2] | 0) | 0) + 1 | 0;
     $1 = HEAP32[($3 + 104 | 0) >> 2] | 0;
     $2 = HEAP32[($3 + 100 | 0) >> 2] | 0;
     if ($1 >>> 0 < (HEAPU16[($2 + 402 | 0) >> 1] | 0) >>> 0) {
      continue label$15
     }
     break label$15;
    };
   }
   i64toi32_i32$2 = $3;
   i64toi32_i32$0 = HEAP32[($3 + 72 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($3 + 76 | 0) >> 2] | 0;
   $359 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[i64toi32_i32$0 >> 2] = $359;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[(($3 + 72 | 0) + 8 | 0) >> 2] | 0;
  }
  global$0 = $3 + 208 | 0;
 }
 
 function $cbor_event__value__Value_20as_20cbor_event__se__Serialize___serialize__h3484ce8083eba035($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $4 = 0, $34 = 0, $38 = 0, $86 = 0, $93 = 0, $96 = 0, $169 = 0, $176 = 0, $179 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $3 = global$0 - 208 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        switch (HEAP32[$1 >> 2] | 0 | 0) {
        default:
         i64toi32_i32$2 = $1 + 8 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($0 | 0, $2 | 0, 0 | 0, i64toi32_i32$0 | 0, i64toi32_i32$1 | 0);
         break label$1;
        case 1:
         i64toi32_i32$2 = $1 + 8 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         i64toi32_i32$2 = i64toi32_i32$1;
         i64toi32_i32$1 = -1;
         i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
         cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($0 | 0, $2 | 0, 1 | 0, i64toi32_i32$2 ^ -1 | 0 | 0, i64toi32_i32$1 | 0);
         break label$1;
        case 2:
         cbor_event__se__Serializer_W___write_bytes__hdbf95a6224c8b5b8($0 | 0, $2 | 0, $1 + 4 | 0 | 0);
         break label$1;
        case 3:
         cbor_event__se__Serializer_W___write_text__hb80b098c4abeea7e($0 | 0, $2 | 0, $1 + 4 | 0 | 0);
         break label$1;
        case 9:
         i64toi32_i32$0 = $1 + 16 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
         $34 = i64toi32_i32$1;
         i64toi32_i32$1 = ($3 + 160 | 0) + 8 | 0;
         HEAP32[i64toi32_i32$1 >> 2] = $34;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
         i64toi32_i32$0 = $1 + 8 | 0;
         i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
         $38 = i64toi32_i32$2;
         i64toi32_i32$2 = $3;
         HEAP32[($3 + 160 | 0) >> 2] = $38;
         HEAP32[($3 + 164 | 0) >> 2] = i64toi32_i32$1;
         cbor_event__se__Serializer_W___write_special__had0377f4ca98c84d($0 | 0, $2 | 0, $3 + 160 | 0 | 0);
         break label$1;
        case 8:
         i64toi32_i32$0 = $1 + 8 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
         cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 + 160 | 0 | 0, $2 | 0, 6 | 0, i64toi32_i32$1 | 0, i64toi32_i32$2 | 0);
         label$16 : {
          if ((HEAP32[($3 + 160 | 0) >> 2] | 0 | 0) == (1 | 0)) {
           break label$16
          }
          $cbor_event__value__Value_20as_20cbor_event__se__Serialize___serialize__h3484ce8083eba035($0 | 0, HEAP32[($1 + 4 | 0) >> 2] | 0 | 0, HEAP32[($3 + 164 | 0) >> 2] | 0 | 0);
          break label$1;
         }
         memcpy($0 + 8 | 0 | 0, ($3 + 160 | 0) + 8 | 0 | 0, 40 | 0) | 0;
         HEAP32[$0 >> 2] = 1;
         break label$1;
        case 7:
         (wasm2js_i32$0 = $3, wasm2js_i32$1 = cbor_event__types__Type__to_byte__h30363627277739c1(5 | 0, 31 | 0) | 0), HEAP8[(wasm2js_i32$0 + 160 | 0) >> 0] = wasm2js_i32$1;
         alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($2 | 0, $3 + 160 | 0 | 0, 1 | 0);
         alloc__collections__btree__map__BTreeMap_K_2cV___iter__h399ff91024363abb($3 + 48 | 0 | 0, $1 + 4 | 0 | 0);
         HEAP32[(($3 + 80 | 0) + 24 | 0) >> 2] = HEAP32[(($3 + 48 | 0) + 24 | 0) >> 2] | 0;
         i64toi32_i32$0 = ($3 + 48 | 0) + 16 | 0;
         i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
         $86 = i64toi32_i32$2;
         i64toi32_i32$2 = ($3 + 80 | 0) + 16 | 0;
         HEAP32[i64toi32_i32$2 >> 2] = $86;
         HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$0 = ($3 + 48 | 0) + 8 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
         $93 = i64toi32_i32$1;
         i64toi32_i32$1 = ($3 + 80 | 0) + 8 | 0;
         HEAP32[i64toi32_i32$1 >> 2] = $93;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
         i64toi32_i32$0 = $3;
         i64toi32_i32$2 = HEAP32[($3 + 48 | 0) >> 2] | 0;
         i64toi32_i32$1 = HEAP32[($3 + 52 | 0) >> 2] | 0;
         $96 = i64toi32_i32$2;
         i64toi32_i32$2 = $3;
         HEAP32[($3 + 80 | 0) >> 2] = $96;
         HEAP32[($3 + 84 | 0) >> 2] = i64toi32_i32$1;
         $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h98ad7991d05240cb($3 + 40 | 0 | 0, $3 + 80 | 0 | 0);
         label$17 : {
          label$18 : {
           $1 = HEAP32[($3 + 40 | 0) >> 2] | 0;
           if (!$1) {
            break label$18
           }
           $4 = HEAP32[($3 + 44 | 0) >> 2] | 0;
           label$19 : while (1) {
            $cbor_event__value__ObjectKey_20as_20cbor_event__se__Serialize___serialize__h2d411ed28971169c($3 + 160 | 0 | 0, $1 | 0, $2 | 0);
            if ((HEAP32[($3 + 160 | 0) >> 2] | 0 | 0) == (1 | 0)) {
             break label$5
            }
            $cbor_event__value__Value_20as_20cbor_event__se__Serialize___serialize__h3484ce8083eba035($3 + 112 | 0 | 0, $4 | 0, HEAP32[($3 + 164 | 0) >> 2] | 0 | 0);
            if ((HEAP32[($3 + 112 | 0) >> 2] | 0 | 0) == (1 | 0)) {
             break label$17
            }
            $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h98ad7991d05240cb($3 + 32 | 0 | 0, $3 + 80 | 0 | 0);
            $4 = HEAP32[($3 + 36 | 0) >> 2] | 0;
            $1 = HEAP32[($3 + 32 | 0) >> 2] | 0;
            if ($1) {
             continue label$19
            }
            break label$19;
           };
          }
          HEAP8[($3 + 160 | 0) >> 0] = 5;
          cbor_event__se__Serializer_W___write_special__had0377f4ca98c84d($0 | 0, $2 | 0, $3 + 160 | 0 | 0);
          break label$1;
         }
         memcpy($0 + 8 | 0 | 0, ($3 + 112 | 0) + 8 | 0 | 0, 40 | 0) | 0;
         HEAP32[$0 >> 2] = 1;
         break label$1;
        case 6:
         i64toi32_i32$0 = $1 + 12 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
         i64toi32_i32$2 = 0;
         cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 + 160 | 0 | 0, $2 | 0, 5 | 0, i64toi32_i32$1 | 0, i64toi32_i32$2 | 0);
         if ((HEAP32[($3 + 160 | 0) >> 2] | 0 | 0) == (1 | 0)) {
          break label$3
         }
         alloc__collections__btree__map__BTreeMap_K_2cV___iter__h399ff91024363abb($3 + 48 | 0 | 0, $1 + 4 | 0 | 0);
         HEAP32[(($3 + 80 | 0) + 24 | 0) >> 2] = HEAP32[(($3 + 48 | 0) + 24 | 0) >> 2] | 0;
         i64toi32_i32$0 = ($3 + 48 | 0) + 16 | 0;
         i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
         $169 = i64toi32_i32$2;
         i64toi32_i32$2 = ($3 + 80 | 0) + 16 | 0;
         HEAP32[i64toi32_i32$2 >> 2] = $169;
         HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$0 = ($3 + 48 | 0) + 8 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
         $176 = i64toi32_i32$1;
         i64toi32_i32$1 = ($3 + 80 | 0) + 8 | 0;
         HEAP32[i64toi32_i32$1 >> 2] = $176;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
         i64toi32_i32$0 = $3;
         i64toi32_i32$2 = HEAP32[($3 + 48 | 0) >> 2] | 0;
         i64toi32_i32$1 = HEAP32[($3 + 52 | 0) >> 2] | 0;
         $179 = i64toi32_i32$2;
         i64toi32_i32$2 = $3;
         HEAP32[($3 + 80 | 0) >> 2] = $179;
         HEAP32[($3 + 84 | 0) >> 2] = i64toi32_i32$1;
         $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h98ad7991d05240cb($3 + 24 | 0 | 0, $3 + 80 | 0 | 0);
         label$20 : {
          label$21 : {
           $1 = HEAP32[($3 + 24 | 0) >> 2] | 0;
           if (!$1) {
            break label$21
           }
           $4 = HEAP32[($3 + 28 | 0) >> 2] | 0;
           label$22 : while (1) {
            $cbor_event__value__ObjectKey_20as_20cbor_event__se__Serialize___serialize__h2d411ed28971169c($3 + 160 | 0 | 0, $1 | 0, $2 | 0);
            if ((HEAP32[($3 + 160 | 0) >> 2] | 0 | 0) == (1 | 0)) {
             break label$4
            }
            $cbor_event__value__Value_20as_20cbor_event__se__Serialize___serialize__h3484ce8083eba035($3 + 112 | 0 | 0, $4 | 0, HEAP32[($3 + 164 | 0) >> 2] | 0 | 0);
            if ((HEAP32[($3 + 112 | 0) >> 2] | 0 | 0) == (1 | 0)) {
             break label$20
            }
            $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h98ad7991d05240cb($3 + 16 | 0 | 0, $3 + 80 | 0 | 0);
            $4 = HEAP32[($3 + 20 | 0) >> 2] | 0;
            $1 = HEAP32[($3 + 16 | 0) >> 2] | 0;
            if ($1) {
             continue label$22
            }
            break label$22;
           };
          }
          HEAP32[$0 >> 2] = 0;
          HEAP32[($0 + 4 | 0) >> 2] = $2;
          break label$1;
         }
         memcpy($0 + 8 | 0 | 0, ($3 + 112 | 0) + 8 | 0 | 0, 40 | 0) | 0;
         HEAP32[$0 >> 2] = 1;
         break label$1;
        case 5:
         (wasm2js_i32$0 = $3, wasm2js_i32$1 = cbor_event__types__Type__to_byte__h30363627277739c1(4 | 0, 31 | 0) | 0), HEAP8[(wasm2js_i32$0 + 160 | 0) >> 0] = wasm2js_i32$1;
         alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($2 | 0, $3 + 160 | 0 | 0, 1 | 0);
         $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__hd769729f4df3c4c0($3 + 8 | 0 | 0, $1 + 4 | 0 | 0);
         label$23 : {
          label$24 : {
           $4 = Math_imul(HEAP32[($3 + 12 | 0) >> 2] | 0, 24);
           if (!$4) {
            break label$24
           }
           $1 = HEAP32[($3 + 8 | 0) >> 2] | 0;
           label$25 : while (1) {
            $cbor_event__value__Value_20as_20cbor_event__se__Serialize___serialize__h3484ce8083eba035($3 + 160 | 0 | 0, $1 | 0, $2 | 0);
            if ((HEAP32[($3 + 160 | 0) >> 2] | 0 | 0) == (1 | 0)) {
             break label$23
            }
            $1 = $1 + 24 | 0;
            $4 = $4 + -24 | 0;
            if ($4) {
             continue label$25
            }
            break label$25;
           };
          }
          HEAP8[($3 + 160 | 0) >> 0] = 5;
          cbor_event__se__Serializer_W___write_special__had0377f4ca98c84d($0 | 0, $2 | 0, $3 + 160 | 0 | 0);
          break label$1;
         }
         memcpy($0 + 8 | 0 | 0, ($3 + 160 | 0) + 8 | 0 | 0, 40 | 0) | 0;
         HEAP32[$0 >> 2] = 1;
         break label$1;
        case 4:
         break label$6;
        };
       }
       i64toi32_i32$0 = $1 + 12 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
       i64toi32_i32$2 = 0;
       cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 + 160 | 0 | 0, $2 | 0, 4 | 0, i64toi32_i32$1 | 0, i64toi32_i32$2 | 0);
       if ((HEAP32[($3 + 160 | 0) >> 2] | 0 | 0) == (1 | 0)) {
        break label$2
       }
       $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__hd769729f4df3c4c0($3 | 0, $1 + 4 | 0 | 0);
       label$26 : {
        label$27 : {
         $4 = Math_imul(HEAP32[($3 + 4 | 0) >> 2] | 0, 24);
         if (!$4) {
          break label$27
         }
         $1 = HEAP32[$3 >> 2] | 0;
         label$28 : while (1) {
          $cbor_event__value__Value_20as_20cbor_event__se__Serialize___serialize__h3484ce8083eba035($3 + 160 | 0 | 0, $1 | 0, $2 | 0);
          if ((HEAP32[($3 + 160 | 0) >> 2] | 0 | 0) == (1 | 0)) {
           break label$26
          }
          $1 = $1 + 24 | 0;
          $4 = $4 + -24 | 0;
          if ($4) {
           continue label$28
          }
          break label$28;
         };
        }
        HEAP32[$0 >> 2] = 0;
        HEAP32[($0 + 4 | 0) >> 2] = $2;
        break label$1;
       }
       memcpy($0 + 8 | 0 | 0, ($3 + 160 | 0) + 8 | 0 | 0, 40 | 0) | 0;
       HEAP32[$0 >> 2] = 1;
       break label$1;
      }
      memcpy($0 + 8 | 0 | 0, ($3 + 160 | 0) + 8 | 0 | 0, 40 | 0) | 0;
      HEAP32[$0 >> 2] = 1;
      break label$1;
     }
     memcpy($0 + 8 | 0 | 0, ($3 + 160 | 0) + 8 | 0 | 0, 40 | 0) | 0;
     HEAP32[$0 >> 2] = 1;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, ($3 + 160 | 0) + 8 | 0 | 0, 40 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, ($3 + 160 | 0) + 8 | 0 | 0, 40 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $3 + 208 | 0;
 }
 
 function cardano_serialization_lib__fees__calculate_ex_units_ceil_cost__hd623ac7a5f7d8d0f($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $4 = 0, $5 = 0, $6 = 0, $7 = 0, $8 = 0, $15 = 0, $18 = 0, $21 = 0, $47 = 0, $55 = 0, $60 = 0, $66 = 0, $69 = 0, $72 = 0, $93 = 0, $98 = 0, $101 = 0, $159 = 0, $162 = 0, $174 = 0, $177 = 0, $214 = 0, $217 = 0, $229 = 0, $232 = 0, $242 = 0, $245 = 0, $251 = 0, $254 = 0, $272 = 0, $294 = 0, $299 = 0, $322 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $3 = global$0 - 256 | 0;
  global$0 = $3;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[($3 + 80 | 0) >> 2] = $15;
  HEAP32[($3 + 84 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[($3 + 72 | 0) >> 2] = $18;
  HEAP32[($3 + 76 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[($3 + 240 | 0) >> 2] = $21;
  HEAP32[($3 + 244 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__fees__calculate_ex_units_ceil_cost__mult__he84254a8750bfe06($3 + 104 | 0 | 0, $3 + 72 | 0 | 0, $3 + 240 | 0 | 0);
  $4 = HEAP32[($3 + 108 | 0) >> 2] | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ((HEAP32[($3 + 104 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      $5 = $3 + 136 | 0;
      HEAP32[(($3 + 40 | 0) + 28 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
      $6 = ($3 + 104 | 0) + 24 | 0;
      i64toi32_i32$2 = $6;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $47 = i64toi32_i32$1;
      i64toi32_i32$1 = ($3 + 40 | 0) + 20 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $47;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      $7 = ($3 + 104 | 0) + 16 | 0;
      i64toi32_i32$2 = $7;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $55 = i64toi32_i32$0;
      i64toi32_i32$0 = ($3 + 40 | 0) + 12 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $55;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      $8 = $3 + 112 | 0;
      i64toi32_i32$2 = $8;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $60 = i64toi32_i32$1;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 44 | 0) >> 2] = $60;
      HEAP32[($3 + 48 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[($3 + 40 | 0) >> 2] = $4;
      i64toi32_i32$2 = $2 + 24 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $66 = i64toi32_i32$0;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 248 | 0) >> 2] = $66;
      HEAP32[($3 + 252 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $2;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
      $69 = i64toi32_i32$1;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 240 | 0) >> 2] = $69;
      HEAP32[($3 + 244 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $1;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
      $72 = i64toi32_i32$0;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 224 | 0) >> 2] = $72;
      HEAP32[($3 + 228 | 0) >> 2] = i64toi32_i32$1;
      cardano_serialization_lib__fees__calculate_ex_units_ceil_cost__mult__he84254a8750bfe06($3 + 104 | 0 | 0, $3 + 240 | 0 | 0, $3 + 224 | 0 | 0);
      $2 = HEAP32[($3 + 108 | 0) >> 2] | 0;
      label$5 : {
       if ((HEAP32[($3 + 104 | 0) >> 2] | 0 | 0) == (1 | 0)) {
        break label$5
       }
       HEAP32[(($3 + 72 | 0) + 28 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
       i64toi32_i32$2 = $6;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $93 = i64toi32_i32$1;
       i64toi32_i32$1 = ($3 + 72 | 0) + 20 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $93;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = $7;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $98 = i64toi32_i32$0;
       i64toi32_i32$0 = ($3 + 72 | 0) + 12 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $98;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $8;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $101 = i64toi32_i32$1;
       i64toi32_i32$1 = $3;
       HEAP32[($3 + 76 | 0) >> 2] = $101;
       HEAP32[($3 + 80 | 0) >> 2] = i64toi32_i32$0;
       HEAP32[($3 + 72 | 0) >> 2] = $2;
       $2 = ($3 + 72 | 0) + 16 | 0;
       $1 = ($3 + 40 | 0) + 16 | 0;
       $4 = HEAPU8[($3 + 52 | 0) >> 0] | 0;
       if (($4 | 0) == (1 | 0)) {
        break label$3
       }
       label$6 : {
        if ((HEAPU8[($3 + 84 | 0) >> 0] | 0 | 0) == (1 | 0)) {
         break label$6
        }
        cardano_serialization_lib__utils__BigInt__mul__h31545dc99f4f564b($3 + 224 | 0 | 0, $3 + 40 | 0 | 0, $2 | 0);
        cardano_serialization_lib__utils__BigInt__mul__h31545dc99f4f564b($3 + 240 | 0 | 0, $3 + 72 | 0 | 0, $1 | 0);
        num_bigint__bigint__addition___impl_20core__ops__arith__Add__num_bigint__bigint__BigInt__20for_20_num_bigint__bigint__BigInt___add__h354544d3f4ae9625_1($3 + 104 | 0 | 0, $3 + 224 | 0 | 0, $3 + 240 | 0 | 0);
        $4 = $3 + 120 | 0;
        cardano_serialization_lib__utils__BigInt__mul__h31545dc99f4f564b($4 | 0, $1 | 0, $2 | 0);
        $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h19f76bdb6b4883ef($3 + 240 | 0 | 0);
        $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h970b13f6299e0f2d($3 + 240 | 0 | 0);
        $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h19f76bdb6b4883ef($3 + 224 | 0 | 0);
        $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h970b13f6299e0f2d($3 + 224 | 0 | 0);
        break label$2;
       }
       $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hd36b5d149e6fd98b($3 + 240 | 0 | 0, $3 + 40 | 0 | 0);
       HEAP8[($3 + 252 | 0) >> 0] = $4;
       $4 = ($3 + 240 | 0) + 8 | 0;
       i64toi32_i32$2 = $4;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $159 = i64toi32_i32$0;
       i64toi32_i32$0 = ($3 + 104 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $159;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $3;
       i64toi32_i32$1 = HEAP32[($3 + 240 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[($3 + 244 | 0) >> 2] | 0;
       $162 = i64toi32_i32$1;
       i64toi32_i32$1 = $3;
       HEAP32[($3 + 104 | 0) >> 2] = $162;
       HEAP32[($3 + 108 | 0) >> 2] = i64toi32_i32$0;
       $5 = HEAPU8[($3 + 68 | 0) >> 0] | 0;
       $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hd36b5d149e6fd98b($3 + 240 | 0 | 0, $1 | 0);
       HEAP8[($3 + 252 | 0) >> 0] = $5;
       i64toi32_i32$2 = $4;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $174 = i64toi32_i32$0;
       i64toi32_i32$0 = $3 + 128 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $174;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $3;
       i64toi32_i32$1 = HEAP32[($3 + 240 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[($3 + 244 | 0) >> 2] | 0;
       $177 = i64toi32_i32$1;
       i64toi32_i32$1 = $3;
       HEAP32[($3 + 120 | 0) >> 2] = $177;
       HEAP32[($3 + 124 | 0) >> 2] = i64toi32_i32$0;
       $4 = $3 + 120 | 0;
       break label$2;
      }
      $2 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($2 | 0) | 0;
      HEAP32[$0 >> 2] = 1;
      HEAP32[($0 + 4 | 0) >> 2] = $2;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h19f76bdb6b4883ef($3 + 40 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h970b13f6299e0f2d($3 + 40 | 0 | 0);
      $2 = ($3 + 40 | 0) + 16 | 0;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h19f76bdb6b4883ef($2 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h970b13f6299e0f2d($2 | 0);
      break label$1;
     }
     $2 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($4 | 0) | 0;
     HEAP32[$0 >> 2] = 1;
     HEAP32[($0 + 4 | 0) >> 2] = $2;
     break label$1;
    }
    $4 = HEAPU8[($3 + 84 | 0) >> 0] | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hd36b5d149e6fd98b($3 + 240 | 0 | 0, $3 + 72 | 0 | 0);
    HEAP8[($3 + 252 | 0) >> 0] = $4;
    $4 = ($3 + 240 | 0) + 8 | 0;
    i64toi32_i32$2 = $4;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $214 = i64toi32_i32$0;
    i64toi32_i32$0 = ($3 + 104 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $214;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAP32[($3 + 240 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($3 + 244 | 0) >> 2] | 0;
    $217 = i64toi32_i32$1;
    i64toi32_i32$1 = $3;
    HEAP32[($3 + 104 | 0) >> 2] = $217;
    HEAP32[($3 + 108 | 0) >> 2] = i64toi32_i32$0;
    $5 = HEAPU8[($3 + 100 | 0) >> 0] | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hd36b5d149e6fd98b($3 + 240 | 0 | 0, $2 | 0);
    HEAP8[($3 + 252 | 0) >> 0] = $5;
    i64toi32_i32$2 = $4;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $229 = i64toi32_i32$0;
    i64toi32_i32$0 = $3 + 128 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $229;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAP32[($3 + 240 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($3 + 244 | 0) >> 2] | 0;
    $232 = i64toi32_i32$1;
    i64toi32_i32$1 = $3;
    HEAP32[($3 + 120 | 0) >> 2] = $232;
    HEAP32[($3 + 124 | 0) >> 2] = i64toi32_i32$0;
    $4 = $3 + 120 | 0;
   }
   $5 = ($3 + 104 | 0) + 8 | 0;
   i64toi32_i32$2 = $5;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $242 = i64toi32_i32$0;
   i64toi32_i32$0 = ($3 + 144 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $242;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[($3 + 104 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($3 + 108 | 0) >> 2] | 0;
   $245 = i64toi32_i32$1;
   i64toi32_i32$1 = $3;
   HEAP32[($3 + 144 | 0) >> 2] = $245;
   HEAP32[($3 + 148 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $4 + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $251 = i64toi32_i32$0;
   i64toi32_i32$0 = ($3 + 160 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $251;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $4;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $254 = i64toi32_i32$1;
   i64toi32_i32$1 = $3;
   HEAP32[($3 + 160 | 0) >> 2] = $254;
   HEAP32[($3 + 164 | 0) >> 2] = i64toi32_i32$0;
   cardano_serialization_lib__utils__BigInt__div_ceil__h1921bbe0a71d04cb($3 + 224 | 0 | 0, $3 + 144 | 0 | 0, $3 + 160 | 0 | 0);
   cardano_serialization_lib__utils__BigInt__as_u64__h39047f01ff5b286b($3 + 24 | 0 | 0, $3 + 224 | 0 | 0);
   $4 = 1;
   label$7 : {
    label$8 : {
     i64toi32_i32$2 = $3;
     i64toi32_i32$0 = HEAP32[($3 + 24 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($3 + 28 | 0) >> 2] | 0;
     if ((i64toi32_i32$0 | 0) != (1 | 0)) {
      break label$8
     }
     i64toi32_i32$2 = $3;
     i64toi32_i32$1 = HEAP32[($3 + 32 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($3 + 36 | 0) >> 2] | 0;
     $272 = i64toi32_i32$1;
     i64toi32_i32$1 = $0 + 8 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $272;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     $4 = 0;
     break label$7;
    }
    cardano_serialization_lib__utils__BigInt__to_str__h54985d40d9e183db($3 + 192 | 0 | 0, $3 + 144 | 0 | 0);
    cardano_serialization_lib__utils__BigInt__to_str__h54985d40d9e183db($3 + 208 | 0 | 0, $3 + 160 | 0 | 0);
    core__fmt__ArgumentV1__new__h56a0e5bff2bd9085($3 + 16 | 0 | 0, $3 + 192 | 0 | 0, 89 | 0);
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAP32[($3 + 16 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($3 + 20 | 0) >> 2] | 0;
    core__fmt__ArgumentV1__new__h56a0e5bff2bd9085($3 + 8 | 0 | 0, $3 + 208 | 0 | 0, 89 | 0);
    HEAP32[($3 + 124 | 0) >> 2] = 2;
    $294 = i64toi32_i32$0;
    i64toi32_i32$0 = $3;
    HEAP32[($3 + 240 | 0) >> 2] = $294;
    HEAP32[($3 + 244 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$0 = $3;
    i64toi32_i32$1 = 0;
    HEAP32[($3 + 108 | 0) >> 2] = 2;
    HEAP32[($3 + 112 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($3 + 104 | 0) >> 2] = 1063648;
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($3 + 12 | 0) >> 2] | 0;
    $299 = i64toi32_i32$1;
    i64toi32_i32$1 = $3;
    HEAP32[($3 + 248 | 0) >> 2] = $299;
    HEAP32[($3 + 252 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($3 + 120 | 0) >> 2] = $3 + 240 | 0;
    alloc__fmt__format__h6e9e003a52c07309($3 + 176 | 0 | 0, $3 + 104 | 0 | 0);
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 208 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 208 | 0 | 0);
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 192 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 192 | 0 | 0);
    HEAP32[$5 >> 2] = HEAP32[(($3 + 176 | 0) + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAP32[($3 + 176 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($3 + 180 | 0) >> 2] | 0;
    $322 = i64toi32_i32$0;
    i64toi32_i32$0 = $3;
    HEAP32[($3 + 104 | 0) >> 2] = $322;
    HEAP32[($3 + 108 | 0) >> 2] = i64toi32_i32$1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 | 0, $3 + 104 | 0 | 0);
    (wasm2js_i32$0 = $0, wasm2js_i32$1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[$3 >> 2] | 0 | 0, HEAP32[($3 + 4 | 0) >> 2] | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 104 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 104 | 0 | 0);
   }
   HEAP32[$0 >> 2] = $4;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h19f76bdb6b4883ef($3 + 160 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h970b13f6299e0f2d($3 + 160 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h19f76bdb6b4883ef($3 + 144 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h970b13f6299e0f2d($3 + 144 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h19f76bdb6b4883ef($3 + 72 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h970b13f6299e0f2d($3 + 72 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h19f76bdb6b4883ef($2 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h970b13f6299e0f2d($2 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h19f76bdb6b4883ef($3 + 40 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h970b13f6299e0f2d($3 + 40 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h19f76bdb6b4883ef($1 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h970b13f6299e0f2d($1 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h19f76bdb6b4883ef($3 + 224 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h970b13f6299e0f2d($3 + 224 | 0 | 0);
  }
  global$0 = $3 + 256 | 0;
 }
 
 function $A_20as_20core__slice__cmp__SliceOrd___compare__hf1814e963025920c($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $7 = 0, $10 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $8 = 0, $9 = 0, i64toi32_i32$0 = 0, $12 = 0, $11 = 0, $6 = 0, $5 = 0, $13 = 0, $14 = 0, $13$hi = 0, $14$hi = 0, $57 = 0, $126 = 0, $133 = 0, $136 = 0, $150 = 0, $157 = 0, $160 = 0;
  $4 = global$0 - 224 | 0;
  global$0 = $4;
  $5 = ($1 >>> 0 > $3 >>> 0 ? $3 : $1) + 1 | 0;
  $6 = 0;
  label$1 : {
   label$2 : {
    label$3 : while (1) {
     label$4 : {
      $5 = $5 + -1 | 0;
      if ($5) {
       break label$4
      }
      $7 = $1 >>> 0 < $3 >>> 0 ? -1 : ($1 | 0) != ($3 | 0);
      break label$2;
     }
     $8 = $0 + $6 | 0;
     $7 = HEAP32[$8 >> 2] | 0;
     $9 = $2 + $6 | 0;
     $10 = HEAP32[$9 >> 2] | 0;
     if (($7 | 0) != ($10 | 0)) {
      break label$1
     }
     label$5 : {
      label$6 : {
       label$7 : {
        label$8 : {
         label$9 : {
          switch ($7 | 0) {
          default:
           i64toi32_i32$2 = $8 + 8 | 0;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
           $13 = i64toi32_i32$0;
           $13$hi = i64toi32_i32$1;
           i64toi32_i32$2 = $9 + 8 | 0;
           i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
           $14 = i64toi32_i32$1;
           $14$hi = i64toi32_i32$0;
           i64toi32_i32$0 = $13$hi;
           i64toi32_i32$2 = $13;
           i64toi32_i32$1 = $14$hi;
           i64toi32_i32$3 = $14;
           $57 = (i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | 0;
           i64toi32_i32$2 = i64toi32_i32$0;
           i64toi32_i32$2 = i64toi32_i32$1;
           i64toi32_i32$2 = i64toi32_i32$0;
           i64toi32_i32$3 = $13;
           i64toi32_i32$0 = i64toi32_i32$1;
           i64toi32_i32$1 = $14;
           $7 = i64toi32_i32$2 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0 | 0) | 0 ? -1 : $57;
           if ($7) {
            break label$8
           }
           $7 = $A_20as_20core__slice__cmp__SliceOrd___compare__hf1814e963025920c(HEAP32[($8 + 16 | 0) >> 2] | 0 | 0, HEAP32[($8 + 24 | 0) >> 2] | 0 | 0, HEAP32[($9 + 16 | 0) >> 2] | 0 | 0, HEAP32[($9 + 24 | 0) >> 2] | 0 | 0) | 0;
           if ($7 & 255 | 0) {
            break label$8
           }
           label$14 : {
            $7 = HEAPU8[($8 + 28 | 0) >> 0] | 0;
            $10 = HEAPU8[($9 + 28 | 0) >> 0] | 0;
            if ((($7 | 0) != (2 | 0) | 0) == (($10 | 0) != (2 | 0) | 0)) {
             break label$14
            }
            $7 = ($10 | 0) != (2 | 0) ? (($7 | 0) != (2 | 0) ? 1 : -1) : 1;
            break label$2;
           }
           if (($7 | 0) == (2 | 0)) {
            break label$7
           }
           if (($10 | 0) == (2 | 0)) {
            break label$7
           }
           $7 = $7 - $10 | 0;
           if (!($7 & 255 | 0)) {
            break label$7
           }
           break label$2;
          case 1:
           alloc__collections__btree__map__BTreeMap_K_2cV___iter__h1146c826d3183069($4 + 96 | 0 | 0, $8 + 4 | 0 | 0);
           alloc__collections__btree__map__BTreeMap_K_2cV___iter__h1146c826d3183069($4 + 128 | 0 | 0, $9 + 4 | 0 | 0);
           HEAP32[(($4 + 160 | 0) + 24 | 0) >> 2] = HEAP32[(($4 + 96 | 0) + 24 | 0) >> 2] | 0;
           i64toi32_i32$1 = ($4 + 96 | 0) + 16 | 0;
           i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $126 = i64toi32_i32$3;
           i64toi32_i32$3 = ($4 + 160 | 0) + 16 | 0;
           HEAP32[i64toi32_i32$3 >> 2] = $126;
           HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
           i64toi32_i32$1 = ($4 + 96 | 0) + 8 | 0;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $133 = i64toi32_i32$2;
           i64toi32_i32$2 = ($4 + 160 | 0) + 8 | 0;
           HEAP32[i64toi32_i32$2 >> 2] = $133;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
           i64toi32_i32$1 = $4;
           i64toi32_i32$3 = HEAP32[($4 + 96 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($4 + 100 | 0) >> 2] | 0;
           $136 = i64toi32_i32$3;
           i64toi32_i32$3 = $4;
           HEAP32[($4 + 160 | 0) >> 2] = $136;
           HEAP32[($4 + 164 | 0) >> 2] = i64toi32_i32$2;
           HEAP32[(($4 + 192 | 0) + 24 | 0) >> 2] = HEAP32[(($4 + 128 | 0) + 24 | 0) >> 2] | 0;
           i64toi32_i32$1 = ($4 + 128 | 0) + 16 | 0;
           i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $150 = i64toi32_i32$2;
           i64toi32_i32$2 = ($4 + 192 | 0) + 16 | 0;
           HEAP32[i64toi32_i32$2 >> 2] = $150;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
           i64toi32_i32$1 = ($4 + 128 | 0) + 8 | 0;
           i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $157 = i64toi32_i32$3;
           i64toi32_i32$3 = ($4 + 192 | 0) + 8 | 0;
           HEAP32[i64toi32_i32$3 >> 2] = $157;
           HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
           i64toi32_i32$1 = $4;
           i64toi32_i32$2 = HEAP32[($4 + 128 | 0) >> 2] | 0;
           i64toi32_i32$3 = HEAP32[($4 + 132 | 0) >> 2] | 0;
           $160 = i64toi32_i32$2;
           i64toi32_i32$2 = $4;
           HEAP32[($4 + 192 | 0) >> 2] = $160;
           HEAP32[($4 + 196 | 0) >> 2] = i64toi32_i32$3;
           $7 = core__iter__traits__iterator__Iterator__cmp_by__hdd4c1d302d53018c($4 + 160 | 0 | 0, $4 + 192 | 0 | 0) | 0;
           break label$8;
          case 2:
           $7 = $A_20as_20core__slice__cmp__SliceOrd___compare__hf1814e963025920c(HEAP32[($8 + 4 | 0) >> 2] | 0 | 0, HEAP32[($8 + 12 | 0) >> 2] | 0 | 0, HEAP32[($9 + 4 | 0) >> 2] | 0 | 0, HEAP32[($9 + 12 | 0) >> 2] | 0 | 0) | 0;
           if ($7 & 255 | 0) {
            break label$8
           }
           label$15 : {
            $7 = HEAPU8[($8 + 16 | 0) >> 0] | 0;
            $10 = HEAPU8[($9 + 16 | 0) >> 0] | 0;
            if ((($7 | 0) != (2 | 0) | 0) == (($10 | 0) != (2 | 0) | 0)) {
             break label$15
            }
            $7 = ($10 | 0) != (2 | 0) ? (($7 | 0) != (2 | 0) ? 1 : -1) : 1;
            break label$2;
           }
           if (($7 | 0) == (2 | 0)) {
            break label$7
           }
           if (($10 | 0) == (2 | 0)) {
            break label$7
           }
           $7 = $7 - $10 | 0;
           if (!($7 & 255 | 0)) {
            break label$7
           }
           break label$2;
          case 3:
           $7 = HEAPU8[($8 + 16 | 0) >> 0] | 0;
           $10 = HEAPU8[($9 + 16 | 0) >> 0] | 0;
           if (($7 | 0) != ($10 | 0)) {
            break label$5
           }
           label$16 : {
            switch ($7 | 0) {
            default:
             $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h7a0ed8a251b429e6($4 + 40 | 0 | 0, $9 + 4 | 0 | 0);
             $11 = HEAP32[($4 + 40 | 0) >> 2] | 0;
             $10 = HEAP32[($4 + 44 | 0) >> 2] | 0;
             $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h7a0ed8a251b429e6($4 + 32 | 0 | 0, $8 + 4 | 0 | 0);
             $12 = HEAP32[($4 + 36 | 0) >> 2] | 0;
             $7 = $10 >>> 0 < $12 >>> 0 ? -1 : ($10 | 0) != ($12 | 0);
             if ($7) {
              break label$8
             }
             $7 = HEAP32[($4 + 32 | 0) >> 2] | 0;
             core__iter__adapters__rev__Rev_T___new__h91ca0d56df8c38ae($4 + 24 | 0 | 0, $11 | 0, $11 + ($10 << 2 | 0) | 0 | 0);
             $10 = HEAP32[($4 + 28 | 0) >> 2] | 0;
             $11 = HEAP32[($4 + 24 | 0) >> 2] | 0;
             core__iter__adapters__rev__Rev_T___new__h91ca0d56df8c38ae($4 + 16 | 0 | 0, $7 | 0, $7 + ($12 << 2 | 0) | 0 | 0);
             $7 = core__iter__traits__iterator__Iterator__cmp__he292810785df7a3c($11 | 0, $10 | 0, HEAP32[($4 + 16 | 0) >> 2] | 0 | 0, HEAP32[($4 + 20 | 0) >> 2] | 0 | 0) | 0;
             break label$8;
            case 2:
             break label$16;
            case 1:
             break label$7;
            };
           }
           $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h7a0ed8a251b429e6($4 + 72 | 0 | 0, $8 + 4 | 0 | 0);
           $11 = HEAP32[($4 + 72 | 0) >> 2] | 0;
           $10 = HEAP32[($4 + 76 | 0) >> 2] | 0;
           $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h7a0ed8a251b429e6($4 + 64 | 0 | 0, $9 + 4 | 0 | 0);
           $12 = HEAP32[($4 + 68 | 0) >> 2] | 0;
           $7 = $10 >>> 0 < $12 >>> 0 ? -1 : ($10 | 0) != ($12 | 0);
           if ($7) {
            break label$8
           }
           $7 = HEAP32[($4 + 64 | 0) >> 2] | 0;
           core__iter__adapters__rev__Rev_T___new__h91ca0d56df8c38ae($4 + 56 | 0 | 0, $11 | 0, $11 + ($10 << 2 | 0) | 0 | 0);
           $10 = HEAP32[($4 + 60 | 0) >> 2] | 0;
           $11 = HEAP32[($4 + 56 | 0) >> 2] | 0;
           core__iter__adapters__rev__Rev_T___new__h91ca0d56df8c38ae($4 + 48 | 0 | 0, $7 | 0, $7 + ($12 << 2 | 0) | 0 | 0);
           $7 = core__iter__traits__iterator__Iterator__cmp__he292810785df7a3c($11 | 0, $10 | 0, HEAP32[($4 + 48 | 0) >> 2] | 0 | 0, HEAP32[($4 + 52 | 0) >> 2] | 0 | 0) | 0;
           break label$8;
          case 4:
           break label$9;
          };
         }
         $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($4 + 88 | 0 | 0, $8 + 4 | 0 | 0);
         $7 = HEAP32[($4 + 92 | 0) >> 2] | 0;
         $10 = HEAP32[($4 + 88 | 0) >> 2] | 0;
         $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($4 + 80 | 0 | 0, $9 + 4 | 0 | 0);
         $7 = core__slice__cmp___impl_20core__cmp__Ord_20for_20_5bT_5d___cmp__h1f2092e0ba2f27ea($10 | 0, $7 | 0, HEAP32[($4 + 80 | 0) >> 2] | 0 | 0, HEAP32[($4 + 84 | 0) >> 2] | 0 | 0) | 0;
        }
        if ($7 & 255 | 0) {
         break label$6
        }
       }
       label$18 : {
        $10 = $8 + 32 | 0;
        $8 = HEAP32[$10 >> 2] | 0;
        $12 = $9 + 32 | 0;
        $9 = HEAP32[$12 >> 2] | 0;
        if ((($8 | 0) != (0 | 0) | 0) == (($9 | 0) != (0 | 0) | 0)) {
         break label$18
        }
        $7 = $9 ? ($8 ? 1 : -1) : 1;
        break label$2;
       }
       $7 = 0;
       if (!$8) {
        break label$6
       }
       if (!$9) {
        break label$6
       }
       $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($4 + 8 | 0 | 0, $10 | 0);
       $7 = HEAP32[($4 + 12 | 0) >> 2] | 0;
       $8 = HEAP32[($4 + 8 | 0) >> 2] | 0;
       $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($4 | 0, $12 | 0);
       $7 = core__slice__cmp___impl_20core__cmp__Ord_20for_20_5bT_5d___cmp__h1f2092e0ba2f27ea($8 | 0, $7 | 0, HEAP32[$4 >> 2] | 0 | 0, HEAP32[($4 + 4 | 0) >> 2] | 0 | 0) | 0;
      }
      $6 = $6 + 48 | 0;
      if (!($7 & 255 | 0)) {
       continue label$3
      }
      break label$2;
     }
     break label$3;
    };
    $7 = $7 >>> 0 < $10 >>> 0 ? -1 : 1;
   }
   global$0 = $4 + 224 | 0;
   return $7 | 0;
  }
  global$0 = $4 + 224 | 0;
  return ($7 >>> 0 < $10 >>> 0 ? -1 : 1) | 0;
 }
 
 function num_bigint__bigint__subtraction___impl_20core__ops__arith__Sub__num_bigint__bigint__BigInt__20for_20num_bigint__bigint__BigInt___sub__h0804349f9fe4b776($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $7 = 0, $6 = 0, i64toi32_i32$2 = 0, $5 = 0, $8 = 0, $20 = 0, $25 = 0, $9 = 0, $10 = 0, $118 = 0, $162 = 0, $173 = 0, $235 = 0, $258 = 0, $273 = 0, $325 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    $4 = HEAPU8[($2 + 12 | 0) >> 0] | 0;
    if (($4 | 0) != (1 | 0)) {
     break label$2
    }
    i64toi32_i32$2 = $1;
    i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $20 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[i64toi32_i32$0 >> 2] = $20;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $1 + 8 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $25 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $25;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    break label$1;
   }
   label$3 : {
    label$4 : {
     label$5 : {
      label$6 : {
       label$7 : {
        label$8 : {
         label$9 : {
          label$10 : {
           label$11 : {
            label$12 : {
             $5 = HEAPU8[($1 + 12 | 0) >> 0] | 0;
             switch ($5 | 0) {
             case 2:
              break label$11;
             case 1:
              break label$12;
             default:
              break label$10;
             };
            }
            $6 = HEAP32[$2 >> 2] | 0;
            $2 = HEAP32[($2 + 8 | 0) >> 2] | 0;
            alloc__raw_vec__RawVec_T_2cA___allocate_in__hb0817f92bbb8999a($3 + 8 | 0 | 0, $2 | 0, 0 | 0);
            $7 = 2;
            $8 = HEAP32[($3 + 12 | 0) >> 2] | 0;
            $6 = memcpy(HEAP32[($3 + 8 | 0) >> 2] | 0 | 0, $6 | 0, $2 << 2 | 0 | 0) | 0;
            label$13 : {
             label$14 : {
              switch ($4 & 3 | 0 | 0) {
              case 1:
               $7 = 1;
               break label$13;
              case 2:
               break label$14;
              default:
               break label$13;
              };
             }
             $7 = 0;
            }
            HEAP8[($0 + 12 | 0) >> 0] = $7;
            HEAP32[($0 + 8 | 0) >> 2] = $2;
            HEAP32[($0 + 4 | 0) >> 2] = $8;
            HEAP32[$0 >> 2] = $6;
            break label$8;
           }
           if ($4) {
            break label$9
           }
           break label$3;
          }
          if ($4) {
           break label$3
          }
         }
         label$16 : {
          label$17 : {
           label$18 : {
            $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
            $7 = HEAP32[($2 + 8 | 0) >> 2] | 0;
            $6 = $4 >>> 0 < $7 >>> 0 ? -1 : ($4 | 0) != ($7 | 0);
            if ($6) {
             break label$18
            }
            $9 = (HEAP32[$2 >> 2] | 0) + -4 | 0;
            $7 = $7 << 2 | 0;
            $4 = $4 << 2 | 0;
            $10 = (HEAP32[$1 >> 2] | 0) + -4 | 0;
            label$19 : while (1) {
             label$20 : {
              if ($4) {
               break label$20
              }
              $6 = $7 ? -1 : 0;
              break label$18;
             }
             if (!$7) {
              break label$17
             }
             $6 = $10 + $4 | 0;
             $8 = $9 + $7 | 0;
             $7 = $7 + -4 | 0;
             $4 = $4 + -4 | 0;
             $6 = HEAP32[$6 >> 2] | 0;
             $8 = HEAP32[$8 >> 2] | 0;
             $6 = $6 >>> 0 < $8 >>> 0 ? -1 : ($6 | 0) != ($8 | 0);
             if (!$6) {
              continue label$19
             }
             break label$19;
            };
           }
           label$21 : {
            switch ($6 + 1 | 0 | 0) {
            case 1:
             break label$16;
            case 2:
             break label$17;
            default:
             break label$21;
            };
           }
           $7 = 2;
           $4 = 0;
           label$22 : {
            label$23 : {
             switch ($5 & 3 | 0 | 0) {
             case 1:
              $4 = 1;
              $7 = 1;
              break label$22;
             case 2:
              break label$23;
             default:
              break label$22;
             };
            }
            $4 = 0;
            $7 = 0;
           }
           HEAP32[(($3 + 32 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
           i64toi32_i32$2 = $1;
           i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
           $118 = i64toi32_i32$0;
           i64toi32_i32$0 = $3;
           HEAP32[($3 + 32 | 0) >> 2] = $118;
           HEAP32[($3 + 36 | 0) >> 2] = i64toi32_i32$1;
           num_bigint__biguint__subtraction___impl_20core__ops__arith__Sub_num_bigint__biguint__BigUint__20for_20_num_bigint__biguint__BigUint___sub__headfbdc5668069dd($3 + 16 | 0 | 0, $2 | 0, $3 + 32 | 0 | 0);
           label$25 : {
            if ($4) {
             break label$25
            }
            $1 = HEAP32[($3 + 24 | 0) >> 2] | 0 ? $7 : 1;
            break label$4;
           }
           $4 = 0;
           HEAP32[($3 + 24 | 0) >> 2] = 0;
           $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend__T_2ccore__slice__iter__Iter_T_____spec_extend__h5cdab7a667860bc4($3 + 16 | 0 | 0, 1082816 | 0, 1082816 | 0);
           $1 = HEAP32[($3 + 24 | 0) >> 2] | 0;
           if (!$1) {
            break label$5
           }
           $2 = (($1 << 2 | 0) + (HEAP32[($3 + 16 | 0) >> 2] | 0) | 0) + -4 | 0;
           label$26 : while (1) {
            label$27 : {
             if (!(HEAP32[$2 >> 2] | 0)) {
              break label$27
             }
             $4 = $1;
             break label$5;
            }
            $1 = $1 + -1 | 0;
            HEAP32[($3 + 24 | 0) >> 2] = $1;
            $2 = $2 + -4 | 0;
            if ($1) {
             continue label$26
            }
            break label$5;
           };
          }
          $4 = ($3 + 32 | 0) + 8 | 0;
          HEAP32[$4 >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
          i64toi32_i32$2 = $1;
          i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
          i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
          $162 = i64toi32_i32$1;
          i64toi32_i32$1 = $3;
          HEAP32[($3 + 32 | 0) >> 2] = $162;
          HEAP32[($3 + 36 | 0) >> 2] = i64toi32_i32$0;
          num_bigint__biguint__subtraction___impl_20core__ops__arith__SubAssign__num_bigint__biguint__BigUint__20for_20num_bigint__biguint__BigUint___sub_assign__h4ea1a97f3b7bcde9($3 + 32 | 0 | 0, $2 | 0);
          HEAP32[(($3 + 16 | 0) + 8 | 0) >> 2] = HEAP32[$4 >> 2] | 0;
          i64toi32_i32$2 = $3;
          i64toi32_i32$0 = HEAP32[($3 + 32 | 0) >> 2] | 0;
          i64toi32_i32$1 = HEAP32[($3 + 36 | 0) >> 2] | 0;
          $173 = i64toi32_i32$0;
          i64toi32_i32$0 = $3;
          HEAP32[($3 + 16 | 0) >> 2] = $173;
          HEAP32[($3 + 20 | 0) >> 2] = i64toi32_i32$1;
          label$28 : {
           if (($5 | 0) == (1 | 0)) {
            break label$28
           }
           $1 = HEAP32[($3 + 24 | 0) >> 2] | 0 ? $5 : 1;
           break label$6;
          }
          $4 = 0;
          HEAP32[($3 + 24 | 0) >> 2] = 0;
          $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend__T_2ccore__slice__iter__Iter_T_____spec_extend__h5cdab7a667860bc4($3 + 16 | 0 | 0, 1082816 | 0, 1082816 | 0);
          $1 = HEAP32[($3 + 24 | 0) >> 2] | 0;
          if (!$1) {
           break label$7
          }
          $2 = (($1 << 2 | 0) + (HEAP32[($3 + 16 | 0) >> 2] | 0) | 0) + -4 | 0;
          label$29 : while (1) {
           label$30 : {
            if (!(HEAP32[$2 >> 2] | 0)) {
             break label$30
            }
            $4 = $1;
            break label$7;
           }
           $1 = $1 + -1 | 0;
           HEAP32[($3 + 24 | 0) >> 2] = $1;
           $2 = $2 + -4 | 0;
           if ($1) {
            continue label$29
           }
           break label$7;
          };
         }
         i64toi32_i32$0 = $0;
         i64toi32_i32$1 = 0;
         HEAP32[($0 + 4 | 0) >> 2] = 0;
         HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$1;
         HEAP8[($0 + 12 | 0) >> 0] = 1;
         HEAP32[$0 >> 2] = HEAP32[(0 + 1082808 | 0) >> 2] | 0;
        }
        $0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
        if (!$0) {
         break label$1
        }
        $0 = $0 << 2 | 0;
        if (!$0) {
         break label$1
        }
        __rust_dealloc(HEAP32[$1 >> 2] | 0 | 0, $0 | 0, 4 | 0);
        break label$1;
       }
       $1 = 1;
       $2 = HEAP32[($3 + 20 | 0) >> 2] | 0;
       if ($2 >>> 0 <= $4 >>> 0) {
        break label$6
       }
       if ($4 >>> 0 >= ($2 >>> 2 | 0) >>> 0) {
        break label$6
       }
       alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($3 + 16 | 0 | 0, $4 | 0);
      }
      HEAP8[($0 + 12 | 0) >> 0] = $1;
      i64toi32_i32$2 = $3;
      i64toi32_i32$1 = HEAP32[($3 + 16 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($3 + 20 | 0) >> 2] | 0;
      $235 = i64toi32_i32$1;
      i64toi32_i32$1 = $0;
      HEAP32[$0 >> 2] = $235;
      HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[($0 + 8 | 0) >> 2] = HEAP32[(($3 + 16 | 0) + 8 | 0) >> 2] | 0;
      break label$1;
     }
     $1 = 1;
     $2 = HEAP32[($3 + 20 | 0) >> 2] | 0;
     if ($2 >>> 0 <= $4 >>> 0) {
      break label$4
     }
     if ($4 >>> 0 >= ($2 >>> 2 | 0) >>> 0) {
      break label$4
     }
     alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($3 + 16 | 0 | 0, $4 | 0);
    }
    HEAP8[($0 + 12 | 0) >> 0] = $1;
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAP32[($3 + 16 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($3 + 20 | 0) >> 2] | 0;
    $258 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[$0 >> 2] = $258;
    HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($0 + 8 | 0) >> 2] = HEAP32[(($3 + 16 | 0) + 8 | 0) >> 2] | 0;
    break label$1;
   }
   HEAP32[(($3 + 32 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   $273 = i64toi32_i32$1;
   i64toi32_i32$1 = $3;
   HEAP32[($3 + 32 | 0) >> 2] = $273;
   HEAP32[($3 + 36 | 0) >> 2] = i64toi32_i32$0;
   num_bigint__biguint__addition___impl_20core__ops__arith__Add__num_bigint__biguint__BigUint__20for_20num_bigint__biguint__BigUint___add__ha6a5672f04e3ed65($3 + 16 | 0 | 0, $3 + 32 | 0 | 0, $2 | 0);
   label$31 : {
    label$32 : {
     if (($5 | 0) == (1 | 0)) {
      break label$32
     }
     $1 = HEAP32[($3 + 24 | 0) >> 2] | 0 ? $5 : 1;
     break label$31;
    }
    $4 = 0;
    HEAP32[($3 + 24 | 0) >> 2] = 0;
    $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend__T_2ccore__slice__iter__Iter_T_____spec_extend__h5cdab7a667860bc4($3 + 16 | 0 | 0, 1082816 | 0, 1082816 | 0);
    label$33 : {
     $1 = HEAP32[($3 + 24 | 0) >> 2] | 0;
     if (!$1) {
      break label$33
     }
     $2 = (($1 << 2 | 0) + (HEAP32[($3 + 16 | 0) >> 2] | 0) | 0) + -4 | 0;
     label$34 : while (1) {
      label$35 : {
       if (!(HEAP32[$2 >> 2] | 0)) {
        break label$35
       }
       $4 = $1;
       break label$33;
      }
      $1 = $1 + -1 | 0;
      HEAP32[($3 + 24 | 0) >> 2] = $1;
      $2 = $2 + -4 | 0;
      if ($1) {
       continue label$34
      }
      break label$34;
     };
    }
    $1 = 1;
    $2 = HEAP32[($3 + 20 | 0) >> 2] | 0;
    if ($2 >>> 0 <= $4 >>> 0) {
     break label$31
    }
    if ($4 >>> 0 >= ($2 >>> 2 | 0) >>> 0) {
     break label$31
    }
    alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($3 + 16 | 0 | 0, $4 | 0);
   }
   HEAP8[($0 + 12 | 0) >> 0] = $1;
   i64toi32_i32$2 = $3;
   i64toi32_i32$0 = HEAP32[($3 + 16 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($3 + 20 | 0) >> 2] | 0;
   $325 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[$0 >> 2] = $325;
   HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($0 + 8 | 0) >> 2] = HEAP32[(($3 + 16 | 0) + 8 | 0) >> 2] | 0;
  }
  global$0 = $3 + 48 | 0;
 }
 
 function header_header_body($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $1 = 0, $90 = 0, $91 = 0, $93 = 0, $94 = 0, $95 = 0, $96 = 0, $97 = 0, $98 = 0, $100 = 0, $101 = 0, $102 = 0, $103 = 0, $104 = 0, $105 = 0, $107 = 0, $108 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $7 = 0, $8 = 0, $9 = 0, $10 = 0, $11 = 0, $12 = 0, $13 = 0, $14 = 0, $15 = 0, $16 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $2 = 0, $25 = 0, $25$hi = 0, $50 = 0, $55 = 0, $60 = 0, $64 = 0, $71 = 0, $78 = 0, $85 = 0, $92 = 0, $99 = 0, $106 = 0, $109 = 0, $112 = 0, $137 = 0, $144 = 0, $151 = 0, $158 = 0, $165 = 0, $172 = 0, $175 = 0, $178 = 0, $17 = 0, $26 = 0, $26$hi = 0, $195 = 0, $203 = 0, $211 = 0, $219 = 0, $227 = 0, $235 = 0, $243 = 0, $246 = 0, $249 = 0, $252 = 0, $27 = 0, $27$hi = 0, $263 = 0, $267 = 0, $271 = 0, $275 = 0, $279 = 0, $284 = 0, $289 = 0, $294 = 0, $301 = 0, $304 = 0, $318 = 0, $322 = 0, $326 = 0, $330 = 0, $335 = 0, $340 = 0, $345 = 0, $352 = 0, $357 = 0, $362 = 0, $367 = 0, $372 = 0, $377 = 0, $382 = 0, $385 = 0, $388 = 0;
  $1 = global$0 - 640 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h60ca34959655b0d6($1 | 0, $0 | 0);
   $0 = HEAP32[$1 >> 2] | 0;
   $2 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   i64toi32_i32$2 = $0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $25 = i64toi32_i32$0;
   $25$hi = i64toi32_i32$1;
   $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   $4 = 0;
   label$2 : {
    if ((HEAPU8[(i64toi32_i32$2 + 176 | 0) >> 0] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    i64toi32_i32$2 = $0 + 201 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $50 = i64toi32_i32$1;
    i64toi32_i32$1 = $1 + 304 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $50;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $0 + 193 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $55 = i64toi32_i32$0;
    i64toi32_i32$0 = $1 + 296 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $55;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $0 + 185 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $60 = i64toi32_i32$1;
    i64toi32_i32$1 = $1 + 288 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $60;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $0 + 177 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $64 = i64toi32_i32$0;
    i64toi32_i32$0 = $1;
    HEAP32[(i64toi32_i32$0 + 280 | 0) >> 2] = $64;
    HEAP32[(i64toi32_i32$0 + 284 | 0) >> 2] = i64toi32_i32$1;
    $4 = 1;
   }
   $5 = ($1 + 72 | 0) + 24 | 0;
   i64toi32_i32$2 = $0 + 233 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $71 = i64toi32_i32$1;
   i64toi32_i32$1 = $5;
   HEAP32[i64toi32_i32$1 >> 2] = $71;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   $6 = ($1 + 72 | 0) + 16 | 0;
   i64toi32_i32$2 = $0 + 225 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $78 = i64toi32_i32$0;
   i64toi32_i32$0 = $6;
   HEAP32[i64toi32_i32$0 >> 2] = $78;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   $7 = ($1 + 72 | 0) + 8 | 0;
   i64toi32_i32$2 = $0 + 217 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $85 = i64toi32_i32$1;
   i64toi32_i32$1 = $7;
   HEAP32[i64toi32_i32$1 >> 2] = $85;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   $8 = ($1 + 40 | 0) + 8 | 0;
   i64toi32_i32$2 = $0 + 249 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $92 = i64toi32_i32$0;
   i64toi32_i32$0 = $8;
   HEAP32[i64toi32_i32$0 >> 2] = $92;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   $9 = ($1 + 40 | 0) + 16 | 0;
   i64toi32_i32$2 = $0 + 257 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $99 = i64toi32_i32$1;
   i64toi32_i32$1 = $9;
   HEAP32[i64toi32_i32$1 >> 2] = $99;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   $10 = ($1 + 40 | 0) + 24 | 0;
   i64toi32_i32$2 = $0 + 265 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $106 = i64toi32_i32$0;
   i64toi32_i32$0 = $10;
   HEAP32[i64toi32_i32$0 >> 2] = $106;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 209 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 210 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 211 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 212 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 213 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 214 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 215 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 216 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $109 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 72 | 0) >> 2] = $109;
   HEAP32[(i64toi32_i32$1 + 76 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 241 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 242 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 243 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 244 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 245 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 246 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 247 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 248 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $112 = i64toi32_i32$0;
   i64toi32_i32$0 = $1;
   HEAP32[(i64toi32_i32$0 + 40 | 0) >> 2] = $112;
   HEAP32[(i64toi32_i32$0 + 44 | 0) >> 2] = i64toi32_i32$1;
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3(i64toi32_i32$0 + 592 | 0 | 0, i64toi32_i32$2 + 12 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3((i64toi32_i32$0 + 592 | 0) + 12 | 0 | 0, i64toi32_i32$2 + 24 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3(i64toi32_i32$0 + 616 | 0 | 0, i64toi32_i32$2 + 36 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3((i64toi32_i32$0 + 616 | 0) + 12 | 0 | 0, i64toi32_i32$2 + 48 | 0 | 0);
   $11 = (i64toi32_i32$0 + 8 | 0) + 8 | 0;
   i64toi32_i32$2 = i64toi32_i32$2 + 281 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $137 = i64toi32_i32$1;
   i64toi32_i32$1 = $11;
   HEAP32[i64toi32_i32$1 >> 2] = $137;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   $12 = ($1 + 8 | 0) + 16 | 0;
   i64toi32_i32$2 = $0 + 289 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $144 = i64toi32_i32$0;
   i64toi32_i32$0 = $12;
   HEAP32[i64toi32_i32$0 >> 2] = $144;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   $13 = ($1 + 8 | 0) + 24 | 0;
   i64toi32_i32$2 = $0 + 297 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $151 = i64toi32_i32$1;
   i64toi32_i32$1 = $13;
   HEAP32[i64toi32_i32$1 >> 2] = $151;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   $14 = ($1 + 200 | 0) + 8 | 0;
   i64toi32_i32$2 = $0 + 80 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $158 = i64toi32_i32$0;
   i64toi32_i32$0 = $14;
   HEAP32[i64toi32_i32$0 >> 2] = $158;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   $15 = ($1 + 200 | 0) + 16 | 0;
   i64toi32_i32$2 = $0 + 88 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $165 = i64toi32_i32$1;
   i64toi32_i32$1 = $15;
   HEAP32[i64toi32_i32$1 >> 2] = $165;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   $16 = ($1 + 200 | 0) + 24 | 0;
   i64toi32_i32$2 = $0 + 96 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $172 = i64toi32_i32$0;
   i64toi32_i32$0 = $16;
   HEAP32[i64toi32_i32$0 >> 2] = $172;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 273 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 274 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 275 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 276 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 277 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 278 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 279 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 280 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $175 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $175;
   HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 72 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 76 | 0) >> 2] | 0;
   $178 = i64toi32_i32$0;
   i64toi32_i32$0 = $1;
   HEAP32[(i64toi32_i32$0 + 200 | 0) >> 2] = $178;
   HEAP32[(i64toi32_i32$0 + 204 | 0) >> 2] = i64toi32_i32$1;
   $17 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
   $26 = i64toi32_i32$1;
   $26$hi = i64toi32_i32$0;
   memcpy($1 + 136 | 0 | 0, i64toi32_i32$2 + 104 | 0 | 0, 64 | 0) | 0;
   $18 = ($1 + 104 | 0) + 8 | 0;
   i64toi32_i32$2 = ($1 + 280 | 0) + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $195 = i64toi32_i32$0;
   i64toi32_i32$0 = $18;
   HEAP32[i64toi32_i32$0 >> 2] = $195;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   $19 = ($1 + 104 | 0) + 16 | 0;
   i64toi32_i32$2 = ($1 + 280 | 0) + 16 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $203 = i64toi32_i32$1;
   i64toi32_i32$1 = $19;
   HEAP32[i64toi32_i32$1 >> 2] = $203;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   $20 = ($1 + 104 | 0) + 24 | 0;
   i64toi32_i32$2 = ($1 + 280 | 0) + 24 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $211 = i64toi32_i32$0;
   i64toi32_i32$0 = $20;
   HEAP32[i64toi32_i32$0 >> 2] = $211;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   $21 = ($1 + 256 | 0) + 8 | 0;
   i64toi32_i32$2 = ($1 + 592 | 0) + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $219 = i64toi32_i32$1;
   i64toi32_i32$1 = $21;
   HEAP32[i64toi32_i32$1 >> 2] = $219;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   $22 = ($1 + 256 | 0) + 16 | 0;
   i64toi32_i32$2 = ($1 + 592 | 0) + 16 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $227 = i64toi32_i32$0;
   i64toi32_i32$0 = $22;
   HEAP32[i64toi32_i32$0 >> 2] = $227;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   $23 = ($1 + 232 | 0) + 8 | 0;
   i64toi32_i32$2 = ($1 + 616 | 0) + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $235 = i64toi32_i32$1;
   i64toi32_i32$1 = $23;
   HEAP32[i64toi32_i32$1 >> 2] = $235;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   $24 = ($1 + 232 | 0) + 16 | 0;
   i64toi32_i32$2 = ($1 + 616 | 0) + 16 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $243 = i64toi32_i32$0;
   i64toi32_i32$0 = $24;
   HEAP32[i64toi32_i32$0 >> 2] = $243;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 280 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 284 | 0) >> 2] | 0;
   $246 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$2 + 104 | 0) >> 2] = $246;
   HEAP32[(i64toi32_i32$2 + 108 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 592 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 596 | 0) >> 2] | 0;
   $249 = i64toi32_i32$0;
   i64toi32_i32$0 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$2 + 256 | 0) >> 2] = $249;
   HEAP32[(i64toi32_i32$2 + 260 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 616 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 620 | 0) >> 2] | 0;
   $252 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$2 + 232 | 0) >> 2] = $252;
   HEAP32[(i64toi32_i32$2 + 236 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 168 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 172 | 0) >> 2] | 0;
   $27 = i64toi32_i32$0;
   $27$hi = i64toi32_i32$1;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
   i64toi32_i32$2 = $21;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $263 = i64toi32_i32$1;
   i64toi32_i32$1 = $1 + 300 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $263;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $22;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $267 = i64toi32_i32$0;
   i64toi32_i32$0 = $1 + 308 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $267;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $23;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $271 = i64toi32_i32$1;
   i64toi32_i32$1 = $1 + 324 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $271;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $24;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $275 = i64toi32_i32$0;
   i64toi32_i32$0 = $1 + 332 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $275;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 200 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 204 | 0) >> 2] | 0;
   $279 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2 + 352 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $279;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $14;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $284 = i64toi32_i32$0;
   i64toi32_i32$0 = ($1 + 280 | 0) + 80 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $284;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $15;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $289 = i64toi32_i32$1;
   i64toi32_i32$1 = ($1 + 280 | 0) + 88 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $289;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $16;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $294 = i64toi32_i32$0;
   i64toi32_i32$0 = ($1 + 280 | 0) + 96 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $294;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($1 + 288 | 0) >> 2] = $2;
   i64toi32_i32$1 = $25$hi;
   i64toi32_i32$0 = $1;
   HEAP32[(i64toi32_i32$0 + 280 | 0) >> 2] = $25;
   HEAP32[(i64toi32_i32$0 + 284 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = i64toi32_i32$0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 256 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 260 | 0) >> 2] | 0;
   $301 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$2 + 292 | 0) >> 2] = $301;
   HEAP32[(i64toi32_i32$2 + 296 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 232 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 236 | 0) >> 2] | 0;
   $304 = i64toi32_i32$0;
   i64toi32_i32$0 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$2 + 316 | 0) >> 2] = $304;
   HEAP32[(i64toi32_i32$2 + 320 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $26$hi;
   i64toi32_i32$0 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$2 + 344 | 0) >> 2] = $26;
   HEAP32[(i64toi32_i32$2 + 348 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[(i64toi32_i32$2 + 340 | 0) >> 2] = $17;
   memcpy((i64toi32_i32$2 + 280 | 0) + 104 | 0 | 0, i64toi32_i32$2 + 136 | 0 | 0, 64 | 0) | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 104 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 108 | 0) >> 2] | 0;
   $318 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2 + 457 | 0;
   $90 = $318;
   HEAP8[i64toi32_i32$1 >> 0] = $90;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $90 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $90 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $90 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $18;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $322 = i64toi32_i32$0;
   i64toi32_i32$0 = $1 + 465 | 0;
   $91 = $322;
   HEAP8[i64toi32_i32$0 >> 0] = $91;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $91 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $91 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $91 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = $19;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $326 = i64toi32_i32$1;
   i64toi32_i32$1 = $1 + 473 | 0;
   $93 = $326;
   HEAP8[i64toi32_i32$1 >> 0] = $93;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $93 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $93 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $93 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $20;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $330 = i64toi32_i32$0;
   i64toi32_i32$0 = $1 + 481 | 0;
   $94 = $330;
   HEAP8[i64toi32_i32$0 >> 0] = $94;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $94 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $94 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $94 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = $7;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $335 = i64toi32_i32$1;
   i64toi32_i32$1 = ($1 + 280 | 0) + 217 | 0;
   $95 = $335;
   HEAP8[i64toi32_i32$1 >> 0] = $95;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $95 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $95 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $95 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $6;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $340 = i64toi32_i32$0;
   i64toi32_i32$0 = ($1 + 280 | 0) + 225 | 0;
   $96 = $340;
   HEAP8[i64toi32_i32$0 >> 0] = $96;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $96 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $96 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $96 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = $5;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $345 = i64toi32_i32$1;
   i64toi32_i32$1 = ($1 + 280 | 0) + 233 | 0;
   $97 = $345;
   HEAP8[i64toi32_i32$1 >> 0] = $97;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $97 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $97 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $97 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   HEAP8[($1 + 456 | 0) >> 0] = $4;
   i64toi32_i32$0 = $27$hi;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 448 | 0) >> 2] = $27;
   HEAP32[(i64toi32_i32$1 + 452 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = i64toi32_i32$1;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 72 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 76 | 0) >> 2] | 0;
   $352 = i64toi32_i32$0;
   i64toi32_i32$0 = i64toi32_i32$2;
   $98 = $352;
   HEAP8[(i64toi32_i32$2 + 489 | 0) >> 0] = $98;
   HEAP8[(i64toi32_i32$2 + 490 | 0) >> 0] = $98 >>> 8 | 0;
   HEAP8[(i64toi32_i32$2 + 491 | 0) >> 0] = $98 >>> 16 | 0;
   HEAP8[(i64toi32_i32$2 + 492 | 0) >> 0] = $98 >>> 24 | 0;
   HEAP8[(i64toi32_i32$2 + 493 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$2 + 494 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$2 + 495 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$2 + 496 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = $10;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $357 = i64toi32_i32$1;
   i64toi32_i32$1 = ($1 + 280 | 0) + 265 | 0;
   $100 = $357;
   HEAP8[i64toi32_i32$1 >> 0] = $100;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $100 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $100 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $100 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $9;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $362 = i64toi32_i32$0;
   i64toi32_i32$0 = ($1 + 280 | 0) + 257 | 0;
   $101 = $362;
   HEAP8[i64toi32_i32$0 >> 0] = $101;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $101 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $101 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $101 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = $8;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $367 = i64toi32_i32$1;
   i64toi32_i32$1 = ($1 + 280 | 0) + 249 | 0;
   $102 = $367;
   HEAP8[i64toi32_i32$1 >> 0] = $102;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $102 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $102 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $102 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $13;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $372 = i64toi32_i32$0;
   i64toi32_i32$0 = ($1 + 280 | 0) + 297 | 0;
   $103 = $372;
   HEAP8[i64toi32_i32$0 >> 0] = $103;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $103 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $103 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $103 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = $12;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $377 = i64toi32_i32$1;
   i64toi32_i32$1 = ($1 + 280 | 0) + 289 | 0;
   $104 = $377;
   HEAP8[i64toi32_i32$1 >> 0] = $104;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $104 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $104 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $104 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $11;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $382 = i64toi32_i32$0;
   i64toi32_i32$0 = ($1 + 280 | 0) + 281 | 0;
   $105 = $382;
   HEAP8[i64toi32_i32$0 >> 0] = $105;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $105 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $105 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $105 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] | 0;
   $385 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   $107 = $385;
   HEAP8[(i64toi32_i32$2 + 521 | 0) >> 0] = $107;
   HEAP8[(i64toi32_i32$2 + 522 | 0) >> 0] = $107 >>> 8 | 0;
   HEAP8[(i64toi32_i32$2 + 523 | 0) >> 0] = $107 >>> 16 | 0;
   HEAP8[(i64toi32_i32$2 + 524 | 0) >> 0] = $107 >>> 24 | 0;
   HEAP8[(i64toi32_i32$2 + 525 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$2 + 526 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$2 + 527 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$2 + 528 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
   $388 = i64toi32_i32$0;
   i64toi32_i32$0 = i64toi32_i32$2;
   $108 = $388;
   HEAP8[(i64toi32_i32$2 + 553 | 0) >> 0] = $108;
   HEAP8[(i64toi32_i32$2 + 554 | 0) >> 0] = $108 >>> 8 | 0;
   HEAP8[(i64toi32_i32$2 + 555 | 0) >> 0] = $108 >>> 16 | 0;
   HEAP8[(i64toi32_i32$2 + 556 | 0) >> 0] = $108 >>> 24 | 0;
   HEAP8[(i64toi32_i32$2 + 557 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$2 + 558 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$2 + 559 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$2 + 560 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   $0 = $cardano_serialization_lib__HeaderBody_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he5de7ce2c4403ed1(i64toi32_i32$2 + 280 | 0 | 0) | 0;
   global$0 = i64toi32_i32$2 + 640 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function core__fmt__float__float_to_decimal_common_exact__heb1add03d918a3dc($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = +$1;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $5 = 0, $6 = 0, $9 = 0, $11 = 0, $11$hi = 0, $15 = 0, $7 = 0, $13 = 0, $13$hi = 0, $15$hi = 0, $8 = 0, $10 = 0, $12 = 0, $32 = 0, $33 = 0, $14 = 0, $14$hi = 0, $34 = 0, $35 = 0, $36 = 0, $12$hi = 0, $28 = 0, $28$hi = 0, $31 = 0, $31$hi = 0, $55$hi = 0, $153 = 0;
  $4 = global$0 - 1120 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    wasm2js_scratch_store_f64(+$1);
    i64toi32_i32$0 = wasm2js_scratch_load_i32(1 | 0) | 0;
    $11 = wasm2js_scratch_load_i32(0 | 0) | 0;
    $11$hi = i64toi32_i32$0;
    i64toi32_i32$2 = $11;
    i64toi32_i32$1 = 2147483647;
    i64toi32_i32$3 = -1;
    i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
    if (!!(i64toi32_i32$2 & i64toi32_i32$3 | 0 | i64toi32_i32$1 | 0)) {
     break label$2
    }
    $5 = 4;
    break label$1;
   }
   i64toi32_i32$1 = $11$hi;
   i64toi32_i32$0 = $11;
   i64toi32_i32$2 = 1048575;
   i64toi32_i32$3 = -1;
   i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
   $12 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
   $12$hi = i64toi32_i32$2;
   i64toi32_i32$1 = $12;
   i64toi32_i32$0 = 1048576;
   i64toi32_i32$3 = 0;
   i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
   $28 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
   $28$hi = i64toi32_i32$0;
   i64toi32_i32$0 = $11$hi;
   i64toi32_i32$2 = $11;
   i64toi32_i32$1 = 0;
   i64toi32_i32$3 = 1;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
    $32 = 0;
   } else {
    i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
    $32 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   }
   i64toi32_i32$0 = $32;
   i64toi32_i32$2 = 2097151;
   i64toi32_i32$3 = -2;
   i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
   $31 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
   $31$hi = i64toi32_i32$2;
   i64toi32_i32$2 = $11$hi;
   i64toi32_i32$1 = $11;
   i64toi32_i32$0 = 0;
   i64toi32_i32$3 = 52;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$0 = 0;
    $33 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   } else {
    i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
    $33 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
   }
   $6 = $33 & 2047 | 0;
   i64toi32_i32$4 = $6;
   i64toi32_i32$0 = $28$hi;
   i64toi32_i32$1 = $31$hi;
   i64toi32_i32$3 = i64toi32_i32$4 ? $28 : $31;
   i64toi32_i32$2 = i64toi32_i32$4 ? i64toi32_i32$0 : i64toi32_i32$1;
   $13 = i64toi32_i32$3;
   $13$hi = i64toi32_i32$2;
   i64toi32_i32$4 = i64toi32_i32$3;
   i64toi32_i32$3 = 0;
   i64toi32_i32$0 = 1;
   i64toi32_i32$3 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
   $14 = i64toi32_i32$4 & i64toi32_i32$0 | 0;
   $14$hi = i64toi32_i32$3;
   label$3 : {
    label$4 : {
     i64toi32_i32$3 = $11$hi;
     i64toi32_i32$2 = $11;
     i64toi32_i32$4 = 2146435072;
     i64toi32_i32$0 = 0;
     i64toi32_i32$4 = i64toi32_i32$3 & i64toi32_i32$4 | 0;
     $15 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
     $15$hi = i64toi32_i32$4;
     if (!($15 | i64toi32_i32$4 | 0)) {
      break label$4
     }
     i64toi32_i32$4 = $15$hi;
     i64toi32_i32$3 = $15;
     i64toi32_i32$2 = 2146435072;
     i64toi32_i32$0 = 0;
     if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$4 | 0) != (i64toi32_i32$2 | 0) | 0) {
      break label$3
     }
     i64toi32_i32$3 = $12$hi;
     $5 = !($12 | i64toi32_i32$3 | 0) ? 3 : 2;
     break label$1;
    }
    $6 = $6 + -1075 | 0;
    i64toi32_i32$3 = $14$hi;
    $5 = $14 ^ 1 | 0;
    i64toi32_i32$3 = 0;
    $15 = 1;
    $15$hi = i64toi32_i32$3;
    break label$1;
   }
   i64toi32_i32$3 = $13$hi;
   i64toi32_i32$0 = $13;
   i64toi32_i32$4 = 0;
   i64toi32_i32$2 = 1;
   i64toi32_i32$1 = i64toi32_i32$2 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
    i64toi32_i32$4 = i64toi32_i32$0 << i64toi32_i32$1 | 0;
    $34 = 0;
   } else {
    i64toi32_i32$4 = ((1 << i64toi32_i32$1 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$1 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$1 | 0) | 0;
    $34 = i64toi32_i32$0 << i64toi32_i32$1 | 0;
   }
   $55$hi = i64toi32_i32$4;
   i64toi32_i32$4 = $13$hi;
   i64toi32_i32$3 = $13;
   i64toi32_i32$0 = 1048576;
   i64toi32_i32$2 = 0;
   $7 = (i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$4 | 0) == (i64toi32_i32$0 | 0) | 0;
   i64toi32_i32$1 = $7;
   i64toi32_i32$3 = 4194304;
   i64toi32_i32$4 = $55$hi;
   i64toi32_i32$0 = i64toi32_i32$1 ? 0 : $34;
   i64toi32_i32$2 = i64toi32_i32$1 ? i64toi32_i32$3 : i64toi32_i32$4;
   $13 = i64toi32_i32$0;
   $13$hi = i64toi32_i32$2;
   i64toi32_i32$4 = i64toi32_i32$1;
   i64toi32_i32$2 = 0;
   i64toi32_i32$0 = 0;
   i64toi32_i32$3 = i64toi32_i32$4 ? 2 : 1;
   i64toi32_i32$1 = i64toi32_i32$4 ? i64toi32_i32$2 : i64toi32_i32$0;
   $15 = i64toi32_i32$3;
   $15$hi = i64toi32_i32$1;
   i64toi32_i32$1 = $14$hi;
   $5 = $14 ^ 1 | 0;
   $6 = (i64toi32_i32$4 ? -1077 : -1076) + $6 | 0;
  }
  HEAP16[($4 + 1112 | 0) >> 1] = $6;
  i64toi32_i32$1 = $15$hi;
  i64toi32_i32$3 = $4;
  HEAP32[($4 + 1104 | 0) >> 2] = $15;
  HEAP32[($4 + 1108 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$3 = $4;
  i64toi32_i32$1 = 0;
  HEAP32[($4 + 1096 | 0) >> 2] = 1;
  HEAP32[($4 + 1100 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $13$hi;
  i64toi32_i32$3 = $4;
  HEAP32[($4 + 1088 | 0) >> 2] = $13;
  HEAP32[($4 + 1092 | 0) >> 2] = i64toi32_i32$1;
  HEAP8[($4 + 1114 | 0) >> 0] = $5;
  label$5 : {
   label$6 : {
    if (($5 | 0) != (2 | 0)) {
     break label$6
    }
    $2 = 1149204;
    $7 = 0;
    break label$5;
   }
   i64toi32_i32$1 = $11$hi;
   i64toi32_i32$4 = $11;
   i64toi32_i32$3 = 0;
   i64toi32_i32$2 = 56;
   i64toi32_i32$0 = i64toi32_i32$2 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
    i64toi32_i32$3 = 0;
    $35 = i64toi32_i32$1 >>> i64toi32_i32$0 | 0;
   } else {
    i64toi32_i32$3 = i64toi32_i32$1 >>> i64toi32_i32$0 | 0;
    $35 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$0 | 0) | 0;
   }
   i64toi32_i32$1 = $35;
   i64toi32_i32$4 = 0;
   i64toi32_i32$2 = 128;
   i64toi32_i32$4 = i64toi32_i32$3 & i64toi32_i32$4 | 0;
   $11 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
   $11$hi = i64toi32_i32$4;
   label$7 : {
    if ($2) {
     break label$7
    }
    i64toi32_i32$4 = $11$hi;
    $2 = !($11 | i64toi32_i32$4 | 0) ? 1149204 : 1149199;
    i64toi32_i32$3 = $11;
    i64toi32_i32$1 = 0;
    i64toi32_i32$2 = 7;
    i64toi32_i32$0 = i64toi32_i32$2 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
     i64toi32_i32$1 = 0;
     $36 = i64toi32_i32$4 >>> i64toi32_i32$0 | 0;
    } else {
     i64toi32_i32$1 = i64toi32_i32$4 >>> i64toi32_i32$0 | 0;
     $36 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$0 | 0) | 0;
    }
    $7 = $36;
    break label$5;
   }
   i64toi32_i32$1 = $11$hi;
   $2 = !($11 | i64toi32_i32$1 | 0) ? 1149200 : 1149199;
   $7 = 1;
  }
  label$8 : {
   label$9 : {
    label$10 : {
     label$11 : {
      label$12 : {
       label$13 : {
        label$14 : {
         label$15 : {
          label$16 : {
           label$17 : {
            label$18 : {
             $5 = $5 + -2 | 0;
             switch ((($5 & 255 | 0) >>> 0 < 3 >>> 0 ? $5 : 3) & 255 | 0 | 0) {
             case 2:
              break label$15;
             case 3:
              break label$16;
             case 1:
              break label$17;
             default:
              break label$18;
             };
            }
            HEAP32[($4 + 1032 | 0) >> 2] = 3;
            HEAP32[($4 + 1028 | 0) >> 2] = 1149208;
            HEAP16[($4 + 1024 | 0) >> 1] = 2;
            break label$9;
           }
           HEAP32[($4 + 1032 | 0) >> 2] = 3;
           HEAP32[($4 + 1028 | 0) >> 2] = 1149205;
           HEAP16[($4 + 1024 | 0) >> 1] = 2;
           break label$9;
          }
          $5 = ($6 << 16 | 0) >> 16 | 0;
          $5 = Math_imul(($5 | 0) < (0 | 0) ? -12 : 5, $5);
          if ($5 >>> 0 > 16063 >>> 0) {
           break label$14
          }
          $6 = ($5 >>> 4 | 0) + 21 | 0;
          $5 = $3 >>> 0 < 32768 >>> 0 ? 0 - $3 | 0 : -32768;
          core__num__flt2dec__strategy__grisu__format_exact_opt__hee3f5edd0e371389($4 + 1024 | 0 | 0, $4 + 1088 | 0 | 0, $4 | 0, $6 | 0, $5 | 0);
          $5 = ($5 << 16 | 0) >> 16 | 0;
          label$19 : {
           label$20 : {
            if (HEAP32[($4 + 1024 | 0) >> 2] | 0) {
             break label$20
            }
            core__num__flt2dec__strategy__dragon__format_exact__h268bf58f3472e2c0($4 + 1072 | 0 | 0, $4 + 1088 | 0 | 0, $4 | 0, $6 | 0, $5 | 0);
            break label$19;
           }
           HEAP32[(($4 + 1072 | 0) + 8 | 0) >> 2] = HEAP32[(($4 + 1024 | 0) + 8 | 0) >> 2] | 0;
           i64toi32_i32$4 = $4;
           i64toi32_i32$1 = HEAP32[($4 + 1024 | 0) >> 2] | 0;
           i64toi32_i32$3 = HEAP32[($4 + 1028 | 0) >> 2] | 0;
           $153 = i64toi32_i32$1;
           i64toi32_i32$1 = $4;
           HEAP32[($4 + 1072 | 0) >> 2] = $153;
           HEAP32[($4 + 1076 | 0) >> 2] = i64toi32_i32$3;
          }
          label$21 : {
           $6 = HEAPU16[($4 + 1080 | 0) >> 1] | 0;
           $8 = ($6 << 16 | 0) >> 16 | 0;
           if (($8 | 0) <= ($5 | 0)) {
            break label$21
           }
           $9 = HEAP32[($4 + 1076 | 0) >> 2] | 0;
           if (!$9) {
            break label$13
           }
           $10 = HEAP32[($4 + 1072 | 0) >> 2] | 0;
           if ((HEAPU8[$10 >> 0] | 0) >>> 0 < 49 >>> 0) {
            break label$12
           }
           label$22 : {
            label$23 : {
             if (($8 | 0) < (1 | 0)) {
              break label$23
             }
             HEAP32[($4 + 1028 | 0) >> 2] = $10;
             $5 = 2;
             HEAP16[($4 + 1024 | 0) >> 1] = 2;
             if ($9 >>> 0 <= $6 >>> 0) {
              break label$22
             }
             HEAP32[($4 + 1044 | 0) >> 2] = 1;
             HEAP32[($4 + 1040 | 0) >> 2] = 1149198;
             HEAP32[($4 + 1032 | 0) >> 2] = $6;
             $9 = $9 - $6 | 0;
             HEAP32[($4 + 1056 | 0) >> 2] = $9;
             HEAP32[($4 + 1052 | 0) >> 2] = $10 + $6 | 0;
             HEAP16[($4 + 1048 | 0) >> 1] = 2;
             HEAP16[($4 + 1036 | 0) >> 1] = 2;
             $5 = 3;
             if ($9 >>> 0 >= $3 >>> 0) {
              break label$10
             }
             HEAP32[($4 + 1064 | 0) >> 2] = $3 - $9 | 0;
             HEAP16[($4 + 1060 | 0) >> 1] = 0;
             $5 = 4;
             break label$10;
            }
            HEAP32[($4 + 1056 | 0) >> 2] = $9;
            HEAP32[($4 + 1052 | 0) >> 2] = $10;
            HEAP16[($4 + 1036 | 0) >> 1] = 0;
            $6 = 0 - $8 | 0;
            HEAP32[($4 + 1040 | 0) >> 2] = $6;
            HEAP16[($4 + 1048 | 0) >> 1] = 2;
            HEAP32[($4 + 1032 | 0) >> 2] = 2;
            HEAP32[($4 + 1028 | 0) >> 2] = 1149196;
            HEAP16[($4 + 1024 | 0) >> 1] = 2;
            $5 = 3;
            if ($3 >>> 0 <= $9 >>> 0) {
             break label$10
            }
            $3 = $3 - $9 | 0;
            if ($3 >>> 0 <= $6 >>> 0) {
             break label$10
            }
            HEAP32[($4 + 1064 | 0) >> 2] = $3 + $8 | 0;
            HEAP16[($4 + 1060 | 0) >> 1] = 0;
            $5 = 4;
            break label$10;
           }
           HEAP32[($4 + 1032 | 0) >> 2] = $9;
           HEAP32[($4 + 1040 | 0) >> 2] = $6 - $9 | 0;
           HEAP16[($4 + 1036 | 0) >> 1] = 0;
           if (!$3) {
            break label$10
           }
           HEAP32[($4 + 1064 | 0) >> 2] = $3;
           HEAP32[($4 + 1056 | 0) >> 2] = 1;
           HEAP32[($4 + 1052 | 0) >> 2] = 1149198;
           HEAP16[($4 + 1060 | 0) >> 1] = 0;
           HEAP16[($4 + 1048 | 0) >> 1] = 2;
           $5 = 4;
           break label$10;
          }
          $5 = 2;
          HEAP16[($4 + 1024 | 0) >> 1] = 2;
          label$24 : {
           if ($3) {
            break label$24
           }
           $5 = 1;
           HEAP32[($4 + 1032 | 0) >> 2] = 1;
           HEAP32[($4 + 1028 | 0) >> 2] = 1149204;
           break label$10;
          }
          HEAP32[($4 + 1040 | 0) >> 2] = $3;
          HEAP16[($4 + 1036 | 0) >> 1] = 0;
          HEAP32[($4 + 1032 | 0) >> 2] = 2;
          HEAP32[($4 + 1028 | 0) >> 2] = 1149196;
          break label$10;
         }
         $5 = 2;
         HEAP16[($4 + 1024 | 0) >> 1] = 2;
         if (!$3) {
          break label$11
         }
         HEAP32[($4 + 1040 | 0) >> 2] = $3;
         HEAP16[($4 + 1036 | 0) >> 1] = 0;
         HEAP32[($4 + 1032 | 0) >> 2] = 2;
         HEAP32[($4 + 1028 | 0) >> 2] = 1149196;
         break label$10;
        }
        core__panicking__panic__h2fd385a887c8bf13(1149211 | 0, 37 | 0, 1149248 | 0);
        abort();
       }
       core__panicking__panic__h2fd385a887c8bf13(1148876 | 0, 33 | 0, 1149128 | 0);
       abort();
      }
      core__panicking__panic__h2fd385a887c8bf13(1149144 | 0, 33 | 0, 1149180 | 0);
      abort();
     }
     $5 = 1;
     HEAP32[($4 + 1032 | 0) >> 2] = 1;
     HEAP32[($4 + 1028 | 0) >> 2] = 1149204;
    }
    HEAP32[($4 + 1072 | 0) >> 2] = $2;
    break label$8;
   }
   HEAP32[($4 + 1072 | 0) >> 2] = $2;
   $5 = 1;
  }
  HEAP32[($4 + 1084 | 0) >> 2] = $5;
  HEAP32[($4 + 1076 | 0) >> 2] = $7;
  HEAP32[($4 + 1080 | 0) >> 2] = $4 + 1024 | 0;
  $5 = core__fmt__Formatter__pad_formatted_parts__h909e13f823ca9407($0 | 0, $4 + 1072 | 0 | 0) | 0;
  global$0 = $4 + 1120 | 0;
  return $5 | 0;
 }
 
 function $cardano_serialization_lib__metadata__MetadataList_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h6a4931784602dba8($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $3 = 0, $8 = 0, $12 = 0, $13 = 0, $9 = 0, $12$hi = 0, $13$hi = 0, $5 = 0, $46 = 0, $47 = 0, $48 = 0, $49 = 0, $50 = 0, $51 = 0, $52 = 0, $53 = 0, $54 = 0, $55 = 0, $56 = 0, $57 = 0, $58 = 0, $59 = 0, $4 = 0, $6 = 0, $14 = 0, $14$hi = 0, $10 = 0, $11 = 0, $7 = 0, $65 = 0, $72 = 0, $81 = 0, $96 = 0, $102 = 0, $111 = 0, $146 = 0, $150 = 0, $154 = 0, $202 = 0, $209 = 0, $212 = 0, $221 = 0, $233 = 0, $239 = 0, $243 = 0, $248 = 0, $254 = 0, $258 = 0, $270 = 0, $274 = 0, $280 = 0, $286 = 0, $313 = 0;
  $2 = global$0 - 336 | 0;
  global$0 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 12 | 0) >> 2] = 0;
  HEAP32[($2 + 16 | 0) >> 2] = i64toi32_i32$0;
  $3 = 0;
  HEAP32[($2 + 8 | 0) >> 2] = HEAP32[(0 + 1059252 | 0) >> 2] | 0;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 264 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = ($2 + 264 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $12 = i64toi32_i32$0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 272 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 276 | 0) >> 2] | 0;
  $13 = i64toi32_i32$1;
  $13$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 264 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 268 | 0) >> 2] | 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
         break label$6
        }
        i64toi32_i32$2 = $12$hi;
        $4 = $12;
        label$7 : {
         i64toi32_i32$2 = $13$hi;
         i64toi32_i32$3 = $13;
         i64toi32_i32$1 = 0;
         i64toi32_i32$0 = 1;
         if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
          break label$7
         }
         if (!$4) {
          break label$3
         }
        }
        $5 = ($2 + 264 | 0) + 32 | 0;
        $6 = $2 + 273 | 0;
        $7 = $6 + 3 | 0;
        label$8 : {
         label$9 : while (1) {
          std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 | 0, $1 | 0);
          $3 = 0;
          $8 = 2;
          label$10 : {
           if (HEAP32[($2 + 4 | 0) >> 2] | 0) {
            break label$10
           }
           i64toi32_i32$3 = 0;
           $13 = 8;
           $13$hi = i64toi32_i32$3;
           i64toi32_i32$3 = 0;
           $12 = 0;
           $12$hi = i64toi32_i32$3;
           break label$4;
          }
          label$11 : {
           if ((($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[$2 >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) == (7 | 0)) {
            break label$11
           }
           $cardano_serialization_lib__metadata__TransactionMetadatum_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hc82759b9ba0db2d8($2 + 264 | 0 | 0, $1 | 0);
           $3 = ($2 + 232 | 0) + 8 | 0;
           i64toi32_i32$0 = $5 + 8 | 0;
           i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $65 = i64toi32_i32$3;
           i64toi32_i32$3 = $3;
           HEAP32[i64toi32_i32$3 >> 2] = $65;
           HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
           $9 = ($2 + 232 | 0) + 16 | 0;
           i64toi32_i32$0 = $5 + 16 | 0;
           i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$3 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $72 = i64toi32_i32$2;
           i64toi32_i32$2 = $9;
           HEAP32[i64toi32_i32$2 >> 2] = $72;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
           $46 = $6;
           HEAP32[($2 + 256 | 0) >> 2] = HEAPU8[$46 >> 0] | 0 | ((HEAPU8[($46 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($46 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($46 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $47 = $7;
           $48 = HEAPU8[$47 >> 0] | 0 | ((HEAPU8[($47 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($47 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($47 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 259 | 0) >> 0] = $48;
           HEAP8[($2 + 260 | 0) >> 0] = $48 >>> 8 | 0;
           HEAP8[($2 + 261 | 0) >> 0] = $48 >>> 16 | 0;
           HEAP8[($2 + 262 | 0) >> 0] = $48 >>> 24 | 0;
           i64toi32_i32$0 = $5;
           i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $81 = i64toi32_i32$3;
           i64toi32_i32$3 = $2;
           HEAP32[($2 + 232 | 0) >> 2] = $81;
           HEAP32[($2 + 236 | 0) >> 2] = i64toi32_i32$2;
           i64toi32_i32$0 = $2;
           i64toi32_i32$2 = HEAP32[($2 + 288 | 0) >> 2] | 0;
           i64toi32_i32$3 = HEAP32[($2 + 292 | 0) >> 2] | 0;
           $12 = i64toi32_i32$2;
           $12$hi = i64toi32_i32$3;
           i64toi32_i32$0 = $2;
           i64toi32_i32$3 = HEAP32[($2 + 280 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($2 + 284 | 0) >> 2] | 0;
           $14 = i64toi32_i32$3;
           $14$hi = i64toi32_i32$2;
           $8 = HEAPU8[($2 + 272 | 0) >> 0] | 0;
           i64toi32_i32$0 = $2;
           i64toi32_i32$2 = HEAP32[($2 + 264 | 0) >> 2] | 0;
           i64toi32_i32$3 = HEAP32[($2 + 268 | 0) >> 2] | 0;
           i64toi32_i32$0 = i64toi32_i32$2;
           i64toi32_i32$2 = 0;
           i64toi32_i32$1 = 1;
           if ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) | 0) {
            break label$8
           }
           $10 = ($2 + 200 | 0) + 8 | 0;
           i64toi32_i32$1 = $3;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $96 = i64toi32_i32$0;
           i64toi32_i32$0 = $10;
           HEAP32[i64toi32_i32$0 >> 2] = $96;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
           $11 = ($2 + 200 | 0) + 16 | 0;
           i64toi32_i32$1 = $9;
           i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $102 = i64toi32_i32$3;
           i64toi32_i32$3 = $11;
           HEAP32[i64toi32_i32$3 >> 2] = $102;
           HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
           HEAP32[($2 + 224 | 0) >> 2] = HEAP32[($2 + 256 | 0) >> 2] | 0;
           $49 = HEAPU8[($2 + 259 | 0) >> 0] | 0 | ((HEAPU8[($2 + 260 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 261 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 262 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 227 | 0) >> 0] = $49;
           HEAP8[($2 + 228 | 0) >> 0] = $49 >>> 8 | 0;
           HEAP8[($2 + 229 | 0) >> 0] = $49 >>> 16 | 0;
           HEAP8[($2 + 230 | 0) >> 0] = $49 >>> 24 | 0;
           i64toi32_i32$1 = $2;
           i64toi32_i32$0 = HEAP32[($2 + 232 | 0) >> 2] | 0;
           i64toi32_i32$3 = HEAP32[($2 + 236 | 0) >> 2] | 0;
           $111 = i64toi32_i32$0;
           i64toi32_i32$0 = $2;
           HEAP32[($2 + 200 | 0) >> 2] = $111;
           HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$3;
           label$12 : {
            $9 = HEAP32[($2 + 16 | 0) >> 2] | 0;
            if ((HEAP32[($2 + 12 | 0) >> 2] | 0 | 0) != ($9 | 0)) {
             break label$12
            }
            alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hf0c17c80fd73868c($2 + 8 | 0 | 0, $9 | 0, 1 | 0);
            $9 = HEAP32[($2 + 16 | 0) >> 2] | 0;
           }
           $3 = (HEAP32[($2 + 8 | 0) >> 2] | 0) + Math_imul($9, 48) | 0;
           $50 = HEAP32[($2 + 224 | 0) >> 2] | 0;
           HEAP8[($3 + 1 | 0) >> 0] = $50;
           HEAP8[($3 + 2 | 0) >> 0] = $50 >>> 8 | 0;
           HEAP8[($3 + 3 | 0) >> 0] = $50 >>> 16 | 0;
           HEAP8[($3 + 4 | 0) >> 0] = $50 >>> 24 | 0;
           HEAP8[$3 >> 0] = $8;
           $51 = $3 + 4 | 0;
           $52 = HEAPU8[($2 + 227 | 0) >> 0] | 0 | ((HEAPU8[($2 + 228 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 229 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 230 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[$51 >> 0] = $52;
           HEAP8[($51 + 1 | 0) >> 0] = $52 >>> 8 | 0;
           HEAP8[($51 + 2 | 0) >> 0] = $52 >>> 16 | 0;
           HEAP8[($51 + 3 | 0) >> 0] = $52 >>> 24 | 0;
           i64toi32_i32$3 = $12$hi;
           i64toi32_i32$0 = $3 + 16 | 0;
           HEAP8[i64toi32_i32$0 >> 0] = $12;
           HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $12 >>> 8 | 0;
           HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $12 >>> 16 | 0;
           HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $12 >>> 24 | 0;
           HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$3;
           HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
           HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
           HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
           i64toi32_i32$3 = $14$hi;
           i64toi32_i32$0 = $3 + 8 | 0;
           $53 = $14;
           HEAP8[i64toi32_i32$0 >> 0] = $53;
           HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $53 >>> 8 | 0;
           HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $53 >>> 16 | 0;
           HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $53 >>> 24 | 0;
           HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$3;
           HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
           HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
           HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
           i64toi32_i32$1 = $2;
           i64toi32_i32$3 = HEAP32[($2 + 200 | 0) >> 2] | 0;
           i64toi32_i32$0 = HEAP32[($2 + 204 | 0) >> 2] | 0;
           $146 = i64toi32_i32$3;
           i64toi32_i32$3 = $3 + 24 | 0;
           $54 = $146;
           HEAP8[i64toi32_i32$3 >> 0] = $54;
           HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $54 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $54 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $54 >>> 24 | 0;
           HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$0;
           HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
           i64toi32_i32$1 = $10;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $150 = i64toi32_i32$0;
           i64toi32_i32$0 = $3 + 32 | 0;
           $55 = $150;
           HEAP8[i64toi32_i32$0 >> 0] = $55;
           HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $55 >>> 8 | 0;
           HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $55 >>> 16 | 0;
           HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $55 >>> 24 | 0;
           HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$3;
           HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
           HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
           HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
           i64toi32_i32$1 = $11;
           i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
           $154 = i64toi32_i32$3;
           i64toi32_i32$3 = $3 + 40 | 0;
           $56 = $154;
           HEAP8[i64toi32_i32$3 >> 0] = $56;
           HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $56 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $56 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $56 >>> 24 | 0;
           HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$0;
           HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
           $3 = $9 + 1 | 0;
           HEAP32[($2 + 16 | 0) >> 2] = $3;
           i64toi32_i32$0 = $13$hi;
           i64toi32_i32$1 = $13;
           i64toi32_i32$3 = 0;
           i64toi32_i32$2 = 1;
           if ((i64toi32_i32$1 | 0) != (i64toi32_i32$2 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$3 | 0) | 0) {
            continue label$9
           }
           if ($3 >>> 0 < $4 >>> 0) {
            continue label$9
           }
           break label$3;
          }
          break label$9;
         };
         cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 264 | 0 | 0, $1 | 0);
         i64toi32_i32$2 = ($2 + 264 | 0) + 16 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $12 = i64toi32_i32$1;
         $12$hi = i64toi32_i32$0;
         i64toi32_i32$2 = $2;
         i64toi32_i32$0 = HEAP32[($2 + 272 | 0) >> 2] | 0;
         i64toi32_i32$1 = HEAP32[($2 + 276 | 0) >> 2] | 0;
         $13 = i64toi32_i32$0;
         $13$hi = i64toi32_i32$1;
         i64toi32_i32$2 = $2;
         i64toi32_i32$1 = HEAP32[($2 + 264 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($2 + 268 | 0) >> 2] | 0;
         i64toi32_i32$2 = i64toi32_i32$1;
         i64toi32_i32$1 = 0;
         i64toi32_i32$3 = 1;
         if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
          break label$5
         }
         i64toi32_i32$2 = $12$hi;
         i64toi32_i32$0 = $2 + 208 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $12;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
         i64toi32_i32$2 = $13$hi;
         i64toi32_i32$0 = $2;
         HEAP32[($2 + 200 | 0) >> 2] = $13;
         HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$2;
         if (($13 & 255 | 0 | 0) == (5 | 0)) {
          break label$3
         }
         HEAP32[($2 + 264 | 0) >> 2] = 0;
         core__panicking__assert_failed__h96d8431cc974b591(0 | 0, $2 + 200 | 0 | 0, 1059816 | 0, $2 + 264 | 0 | 0, 1059860 | 0);
         abort();
        }
        HEAP32[(($2 + 152 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 332 | 0) >> 2] | 0;
        i64toi32_i32$3 = ($2 + 232 | 0) + 8 | 0;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $202 = i64toi32_i32$2;
        i64toi32_i32$2 = ($2 + 168 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$2 >> 2] = $202;
        HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$3 = ($2 + 232 | 0) + 16 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $209 = i64toi32_i32$0;
        i64toi32_i32$0 = ($2 + 168 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $209;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
        i64toi32_i32$3 = $2;
        i64toi32_i32$2 = HEAP32[($2 + 324 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[($2 + 328 | 0) >> 2] | 0;
        $212 = i64toi32_i32$2;
        i64toi32_i32$2 = $2;
        HEAP32[($2 + 152 | 0) >> 2] = $212;
        HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
        HEAP32[($2 + 192 | 0) >> 2] = HEAP32[($2 + 256 | 0) >> 2] | 0;
        $57 = HEAPU8[($2 + 259 | 0) >> 0] | 0 | ((HEAPU8[($2 + 260 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 261 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 262 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 195 | 0) >> 0] = $57;
        HEAP8[($2 + 196 | 0) >> 0] = $57 >>> 8 | 0;
        HEAP8[($2 + 197 | 0) >> 0] = $57 >>> 16 | 0;
        HEAP8[($2 + 198 | 0) >> 0] = $57 >>> 24 | 0;
        i64toi32_i32$3 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 232 | 0) >> 2] | 0;
        i64toi32_i32$2 = HEAP32[($2 + 236 | 0) >> 2] | 0;
        $221 = i64toi32_i32$0;
        i64toi32_i32$0 = $2;
        HEAP32[($2 + 168 | 0) >> 2] = $221;
        HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$2;
        if (($8 & 255 | 0 | 0) == (19 | 0)) {
         break label$3
        }
        $3 = HEAP32[($2 + 320 | 0) >> 2] | 0;
        i64toi32_i32$2 = $14$hi;
        $13 = $14;
        $13$hi = i64toi32_i32$2;
        break label$4;
       }
       i64toi32_i32$3 = $2 + 296 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $233 = i64toi32_i32$2;
       i64toi32_i32$2 = $2 + 176 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $233;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$3 = $2 + 304 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $239 = i64toi32_i32$0;
       i64toi32_i32$0 = ($2 + 168 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $239;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$3 = $2 + 288 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $243 = i64toi32_i32$2;
       i64toi32_i32$2 = $2;
       HEAP32[($2 + 168 | 0) >> 2] = $243;
       HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$0;
       $8 = 2;
       break label$4;
      }
      i64toi32_i32$3 = $2 + 296 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $248 = i64toi32_i32$0;
      i64toi32_i32$0 = $2 + 176 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $248;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$3 = $2 + 304 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $254 = i64toi32_i32$2;
      i64toi32_i32$2 = ($2 + 168 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $254;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$3 = $2 + 288 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $258 = i64toi32_i32$0;
      i64toi32_i32$0 = $2;
      HEAP32[($2 + 168 | 0) >> 2] = $258;
      HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$2;
     }
     i64toi32_i32$2 = $12$hi;
     i64toi32_i32$0 = ($2 + 264 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $12;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$2 = $13$hi;
     i64toi32_i32$0 = ($2 + 264 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $13;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$3 = $2;
     i64toi32_i32$2 = HEAP32[($2 + 168 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 172 | 0) >> 2] | 0;
     $270 = i64toi32_i32$2;
     i64toi32_i32$2 = $2 + 288 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $270;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$3 = $2;
     i64toi32_i32$0 = HEAP32[($2 + 152 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[($2 + 156 | 0) >> 2] | 0;
     $274 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 316 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $274;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$3 = ($2 + 168 | 0) + 8 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $280 = i64toi32_i32$2;
     i64toi32_i32$2 = $2 + 296 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $280;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$3 = ($2 + 168 | 0) + 16 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $286 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 304 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $286;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
     HEAP32[($2 + 324 | 0) >> 2] = HEAP32[(($2 + 152 | 0) + 8 | 0) >> 2] | 0;
     HEAP8[($2 + 264 | 0) >> 0] = $8;
     $58 = HEAP32[($2 + 192 | 0) >> 2] | 0;
     HEAP8[($2 + 265 | 0) >> 0] = $58;
     HEAP8[($2 + 266 | 0) >> 0] = $58 >>> 8 | 0;
     HEAP8[($2 + 267 | 0) >> 0] = $58 >>> 16 | 0;
     HEAP8[($2 + 268 | 0) >> 0] = $58 >>> 24 | 0;
     $59 = HEAPU8[($2 + 195 | 0) >> 0] | 0 | ((HEAPU8[($2 + 196 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 197 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 198 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($2 + 268 | 0) >> 0] = $59;
     HEAP8[($2 + 269 | 0) >> 0] = $59 >>> 8 | 0;
     HEAP8[($2 + 270 | 0) >> 0] = $59 >>> 16 | 0;
     HEAP8[($2 + 271 | 0) >> 0] = $59 >>> 24 | 0;
     HEAP32[($2 + 312 | 0) >> 2] = $3;
     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($2 + 88 | 0 | 0, $2 + 264 | 0 | 0, 1059876 | 0, 12 | 0);
     $3 = HEAPU8[($2 + 88 | 0) >> 0] | 0;
     if (($3 | 0) != (19 | 0)) {
      break label$2
     }
    }
    i64toi32_i32$3 = $2;
    i64toi32_i32$2 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $313 = i64toi32_i32$2;
    i64toi32_i32$2 = $0;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = $313;
    HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
    $5 = 0;
    break label$1;
   }
   $5 = 1;
   memcpy($2 + 25 | 0 | 0, $2 + 88 | 0 | 1 | 0 | 0, 63 | 0) | 0;
   HEAP8[($0 + 8 | 0) >> 0] = $3;
   memcpy($0 + 9 | 0 | 0, $2 + 25 | 0 | 0, 63 | 0) | 0;
   label$13 : {
    $8 = HEAP32[($2 + 16 | 0) >> 2] | 0;
    if (!$8) {
     break label$13
    }
    $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    $8 = Math_imul($8, 48);
    label$14 : while (1) {
     core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatum___headd2d1b596252cc_2($3 | 0);
     $3 = $3 + 48 | 0;
     $8 = $8 + -48 | 0;
     if ($8) {
      continue label$14
     }
     break label$14;
    };
   }
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h81b8a37e31f2de30($2 + 8 | 0 | 0);
  }
  HEAP32[$0 >> 2] = $5;
  global$0 = $2 + 336 | 0;
 }
 
 function cardano_serialization_lib__address__Address__to_bytes__h301d351bd02ea9f1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $5 = 0, i64toi32_i32$2 = 0, $3 = 0, $6 = 0, $57 = 0, $85 = 0, $141 = 0, $171 = 0, $201 = 0, $231 = 0, $285 = 0, $339 = 0, $372 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  i64toi32_i32$1 = $0;
  i64toi32_i32$0 = 0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[$0 >> 2] = HEAP32[(0 + 1070048 | 0) >> 2] | 0;
  label$1 : {
   label$2 : {
    switch (HEAPU8[$1 >> 0] | 0 | 0) {
    default:
     $3 = $1 + 31 | 0;
     $4 = HEAPU8[$3 >> 0] | 0;
     $5 = $1 + 2 | 0;
     $6 = HEAPU8[$5 >> 0] | 0;
     $1 = HEAPU8[($1 + 1 | 0) >> 0] | 0;
     alloc__vec__Vec_T_2cA___reserve__h9cf757d86af8f187($0 | 0, 1 | 0);
     HEAP8[((HEAP32[$0 >> 2] | 0) + (HEAP32[($0 + 8 | 0) >> 2] | 0) | 0) >> 0] = (($4 | 0) == (1 | 0)) << 5 | 0 | ((($6 | 0) == (1 | 0)) << 4 | 0) | 0 | ($1 & 15 | 0) | 0;
     HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
     cardano_serialization_lib__address__StakeCredential__to_raw_bytes__h5ee498f6937345cd($2 | 0, $5 | 0);
     $1 = ($2 + 32 | 0) + 8 | 0;
     $5 = $2 + 8 | 0;
     HEAP32[$1 >> 2] = HEAP32[$5 >> 2] | 0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
     $57 = i64toi32_i32$0;
     i64toi32_i32$0 = $2;
     HEAP32[($2 + 32 | 0) >> 2] = $57;
     HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
     alloc__raw_vec__RawVec_T_2cA___allocator__hdb3b360b6f01e581($2 + 32 | 0 | 0) | 0;
     $4 = HEAP32[($2 + 32 | 0) >> 2] | 0;
     HEAP32[($2 + 24 | 0) >> 2] = $4;
     HEAP32[($2 + 20 | 0) >> 2] = HEAP32[($2 + 36 | 0) >> 2] | 0;
     HEAP32[($2 + 16 | 0) >> 2] = $4;
     HEAP32[($2 + 28 | 0) >> 2] = $4 + (HEAP32[$1 >> 2] | 0) | 0;
     $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend_T_2calloc__vec__into_iter__IntoIter_T_____spec_extend__h93b6c942d0655498($0 | 0, $2 + 16 | 0 | 0);
     cardano_serialization_lib__address__StakeCredential__to_raw_bytes__h5ee498f6937345cd($2 | 0, $3 | 0);
     HEAP32[$1 >> 2] = HEAP32[$5 >> 2] | 0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
     $85 = i64toi32_i32$1;
     i64toi32_i32$1 = $2;
     HEAP32[($2 + 32 | 0) >> 2] = $85;
     HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$0;
     alloc__raw_vec__RawVec_T_2cA___allocator__hdb3b360b6f01e581($2 + 32 | 0 | 0) | 0;
     $4 = HEAP32[($2 + 32 | 0) >> 2] | 0;
     HEAP32[($2 + 24 | 0) >> 2] = $4;
     HEAP32[($2 + 20 | 0) >> 2] = HEAP32[($2 + 36 | 0) >> 2] | 0;
     HEAP32[($2 + 16 | 0) >> 2] = $4;
     HEAP32[($2 + 28 | 0) >> 2] = $4 + (HEAP32[$1 >> 2] | 0) | 0;
     $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend_T_2calloc__vec__into_iter__IntoIter_T_____spec_extend__h93b6c942d0655498($0 | 0, $2 + 16 | 0 | 0);
     break label$1;
    case 1:
     $4 = HEAPU8[($1 + 32 | 0) >> 0] | 0;
     $3 = $1 + 33 | 0;
     $5 = HEAPU8[$3 >> 0] | 0;
     alloc__vec__Vec_T_2cA___reserve__h9cf757d86af8f187($0 | 0, 1 | 0);
     HEAP8[((HEAP32[$0 >> 2] | 0) + (HEAP32[($0 + 8 | 0) >> 2] | 0) | 0) >> 0] = (($5 | 0) == (1 | 0) ? 80 : 64) | ($4 & 15 | 0) | 0;
     HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
     cardano_serialization_lib__address__StakeCredential__to_raw_bytes__h5ee498f6937345cd($2 | 0, $3 | 0);
     $4 = ($2 + 32 | 0) + 8 | 0;
     $3 = $2 + 8 | 0;
     HEAP32[$4 >> 2] = HEAP32[$3 >> 2] | 0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
     $141 = i64toi32_i32$0;
     i64toi32_i32$0 = $2;
     HEAP32[($2 + 32 | 0) >> 2] = $141;
     HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
     alloc__raw_vec__RawVec_T_2cA___allocator__hdb3b360b6f01e581($2 + 32 | 0 | 0) | 0;
     $5 = HEAP32[($2 + 32 | 0) >> 2] | 0;
     HEAP32[($2 + 24 | 0) >> 2] = $5;
     HEAP32[($2 + 20 | 0) >> 2] = HEAP32[($2 + 36 | 0) >> 2] | 0;
     HEAP32[($2 + 16 | 0) >> 2] = $5;
     HEAP32[($2 + 28 | 0) >> 2] = $5 + (HEAP32[$4 >> 2] | 0) | 0;
     $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend_T_2calloc__vec__into_iter__IntoIter_T_____spec_extend__h93b6c942d0655498($0 | 0, $2 + 16 | 0 | 0);
     i64toi32_i32$2 = $1 + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     cardano_serialization_lib__address__variable_nat_encode__ha168666c0b6604c7($2 | 0, i64toi32_i32$1 | 0, i64toi32_i32$0 | 0);
     HEAP32[$4 >> 2] = HEAP32[$3 >> 2] | 0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
     $171 = i64toi32_i32$0;
     i64toi32_i32$0 = $2;
     HEAP32[($2 + 32 | 0) >> 2] = $171;
     HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
     alloc__raw_vec__RawVec_T_2cA___allocator__hdb3b360b6f01e581($2 + 32 | 0 | 0) | 0;
     $5 = HEAP32[($2 + 32 | 0) >> 2] | 0;
     HEAP32[($2 + 24 | 0) >> 2] = $5;
     HEAP32[($2 + 20 | 0) >> 2] = HEAP32[($2 + 36 | 0) >> 2] | 0;
     HEAP32[($2 + 16 | 0) >> 2] = $5;
     HEAP32[($2 + 28 | 0) >> 2] = $5 + (HEAP32[$4 >> 2] | 0) | 0;
     $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend_T_2calloc__vec__into_iter__IntoIter_T_____spec_extend__h93b6c942d0655498($0 | 0, $2 + 16 | 0 | 0);
     i64toi32_i32$2 = $1 + 16 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     cardano_serialization_lib__address__variable_nat_encode__ha168666c0b6604c7($2 | 0, i64toi32_i32$1 | 0, i64toi32_i32$0 | 0);
     HEAP32[$4 >> 2] = HEAP32[$3 >> 2] | 0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
     $201 = i64toi32_i32$0;
     i64toi32_i32$0 = $2;
     HEAP32[($2 + 32 | 0) >> 2] = $201;
     HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
     alloc__raw_vec__RawVec_T_2cA___allocator__hdb3b360b6f01e581($2 + 32 | 0 | 0) | 0;
     $5 = HEAP32[($2 + 32 | 0) >> 2] | 0;
     HEAP32[($2 + 24 | 0) >> 2] = $5;
     HEAP32[($2 + 20 | 0) >> 2] = HEAP32[($2 + 36 | 0) >> 2] | 0;
     HEAP32[($2 + 16 | 0) >> 2] = $5;
     HEAP32[($2 + 28 | 0) >> 2] = $5 + (HEAP32[$4 >> 2] | 0) | 0;
     $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend_T_2calloc__vec__into_iter__IntoIter_T_____spec_extend__h93b6c942d0655498($0 | 0, $2 + 16 | 0 | 0);
     i64toi32_i32$2 = $1 + 24 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     cardano_serialization_lib__address__variable_nat_encode__ha168666c0b6604c7($2 | 0, i64toi32_i32$1 | 0, i64toi32_i32$0 | 0);
     HEAP32[$4 >> 2] = HEAP32[$3 >> 2] | 0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
     $231 = i64toi32_i32$0;
     i64toi32_i32$0 = $2;
     HEAP32[($2 + 32 | 0) >> 2] = $231;
     HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
     alloc__raw_vec__RawVec_T_2cA___allocator__hdb3b360b6f01e581($2 + 32 | 0 | 0) | 0;
     $1 = HEAP32[($2 + 32 | 0) >> 2] | 0;
     HEAP32[($2 + 24 | 0) >> 2] = $1;
     HEAP32[($2 + 20 | 0) >> 2] = HEAP32[($2 + 36 | 0) >> 2] | 0;
     HEAP32[($2 + 16 | 0) >> 2] = $1;
     HEAP32[($2 + 28 | 0) >> 2] = $1 + (HEAP32[$4 >> 2] | 0) | 0;
     $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend_T_2calloc__vec__into_iter__IntoIter_T_____spec_extend__h93b6c942d0655498($0 | 0, $2 + 16 | 0 | 0);
     break label$1;
    case 2:
     $4 = $1 + 2 | 0;
     $3 = HEAPU8[$4 >> 0] | 0;
     $1 = HEAPU8[($1 + 1 | 0) >> 0] | 0;
     alloc__vec__Vec_T_2cA___reserve__h9cf757d86af8f187($0 | 0, 1 | 0);
     HEAP8[((HEAP32[$0 >> 2] | 0) + (HEAP32[($0 + 8 | 0) >> 2] | 0) | 0) >> 0] = (($3 | 0) == (1 | 0) ? 112 : 96) | ($1 & 15 | 0) | 0;
     HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
     cardano_serialization_lib__address__StakeCredential__to_raw_bytes__h5ee498f6937345cd($2 | 0, $4 | 0);
     $4 = ($2 + 32 | 0) + 8 | 0;
     HEAP32[$4 >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
     $285 = i64toi32_i32$1;
     i64toi32_i32$1 = $2;
     HEAP32[($2 + 32 | 0) >> 2] = $285;
     HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$0;
     alloc__raw_vec__RawVec_T_2cA___allocator__hdb3b360b6f01e581($2 + 32 | 0 | 0) | 0;
     $1 = HEAP32[($2 + 32 | 0) >> 2] | 0;
     HEAP32[($2 + 24 | 0) >> 2] = $1;
     HEAP32[($2 + 20 | 0) >> 2] = HEAP32[($2 + 36 | 0) >> 2] | 0;
     HEAP32[($2 + 16 | 0) >> 2] = $1;
     HEAP32[($2 + 28 | 0) >> 2] = $1 + (HEAP32[$4 >> 2] | 0) | 0;
     $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend_T_2calloc__vec__into_iter__IntoIter_T_____spec_extend__h93b6c942d0655498($0 | 0, $2 + 16 | 0 | 0);
     break label$1;
    case 3:
     $4 = $1 + 2 | 0;
     $3 = HEAPU8[$4 >> 0] | 0;
     $1 = HEAPU8[($1 + 1 | 0) >> 0] | 0;
     alloc__vec__Vec_T_2cA___reserve__h9cf757d86af8f187($0 | 0, 1 | 0);
     HEAP8[((HEAP32[$0 >> 2] | 0) + (HEAP32[($0 + 8 | 0) >> 2] | 0) | 0) >> 0] = (($3 | 0) == (1 | 0) ? -16 : -32) | ($1 & 15 | 0) | 0;
     HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
     cardano_serialization_lib__address__StakeCredential__to_raw_bytes__h5ee498f6937345cd($2 | 0, $4 | 0);
     $4 = ($2 + 32 | 0) + 8 | 0;
     HEAP32[$4 >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
     $339 = i64toi32_i32$0;
     i64toi32_i32$0 = $2;
     HEAP32[($2 + 32 | 0) >> 2] = $339;
     HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
     alloc__raw_vec__RawVec_T_2cA___allocator__hdb3b360b6f01e581($2 + 32 | 0 | 0) | 0;
     $1 = HEAP32[($2 + 32 | 0) >> 2] | 0;
     HEAP32[($2 + 24 | 0) >> 2] = $1;
     HEAP32[($2 + 20 | 0) >> 2] = HEAP32[($2 + 36 | 0) >> 2] | 0;
     HEAP32[($2 + 16 | 0) >> 2] = $1;
     HEAP32[($2 + 28 | 0) >> 2] = $1 + (HEAP32[$4 >> 2] | 0) | 0;
     $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend_T_2calloc__vec__into_iter__IntoIter_T_____spec_extend__h93b6c942d0655498($0 | 0, $2 + 16 | 0 | 0);
     break label$1;
    case 4:
     break label$2;
    };
   }
   cardano_serialization_lib__address__ByronAddress__to_bytes__h95edb62bc4a38025($2 | 0, $1 + 4 | 0 | 0);
   $4 = ($2 + 32 | 0) + 8 | 0;
   HEAP32[$4 >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $372 = i64toi32_i32$1;
   i64toi32_i32$1 = $2;
   HEAP32[($2 + 32 | 0) >> 2] = $372;
   HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$0;
   alloc__raw_vec__RawVec_T_2cA___allocator__hdb3b360b6f01e581($2 + 32 | 0 | 0) | 0;
   $1 = HEAP32[($2 + 32 | 0) >> 2] | 0;
   HEAP32[($2 + 24 | 0) >> 2] = $1;
   HEAP32[($2 + 20 | 0) >> 2] = HEAP32[($2 + 36 | 0) >> 2] | 0;
   HEAP32[($2 + 16 | 0) >> 2] = $1;
   HEAP32[($2 + 28 | 0) >> 2] = $1 + (HEAP32[$4 >> 2] | 0) | 0;
   $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend_T_2calloc__vec__into_iter__IntoIter_T_____spec_extend__h93b6c942d0655498($0 | 0, $2 + 16 | 0 | 0);
  }
  global$0 = $2 + 48 | 0;
 }
 
 function $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__clone_subtree__hce8ff294b4963e31($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $4 = 0, $8 = 0, $5 = 0, $6 = 0, $11 = 0, $7 = 0, $9 = 0, $10 = 0, $12 = 0, $13 = 0, $46 = 0, $54 = 0, $62 = 0, $70 = 0, $80 = 0, $93 = 0, $98 = 0, $103 = 0, $106 = 0, $115 = 0, $209 = 0, $217 = 0, $225 = 0, $233 = 0, $243 = 0, $258 = 0, $263 = 0, $268 = 0, $273 = 0, $280 = 0, $330 = 0;
  $3 = global$0 - 240 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    if ($1) {
     break label$2
    }
    $4 = alloc__boxed__Box_T_2cA___new_uninit_in__h2ea6451c7ed438a4() | 0;
    HEAP16[($4 + 1062 | 0) >> 1] = 0;
    HEAP32[($4 + 1056 | 0) >> 2] = 0;
    $5 = 0;
    label$3 : {
     label$4 : {
      if (!(HEAPU16[($2 + 1062 | 0) >> 1] | 0)) {
       break label$4
      }
      $1 = $2 + 560 | 0;
      $6 = ($3 + 192 | 0) + 32 | 0;
      $7 = ($3 + 144 | 0) + 32 | 0;
      $5 = 0;
      label$5 : while (1) {
       $cardano_serialization_lib__plutus__PlutusDataEnum_20as_20core__clone__Clone___clone__h7a95fc7c6f531f3b($3 + 192 | 0 | 0, $1 + -560 | 0 | 0);
       label$6 : {
        label$7 : {
         $8 = $1 + -528 | 0;
         if (HEAP32[$8 >> 2] | 0) {
          break label$7
         }
         HEAP32[($3 + 80 | 0) >> 2] = 0;
         break label$6;
        }
        $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($3 + 80 | 0 | 0, $8 | 0);
       }
       i64toi32_i32$2 = $3;
       i64toi32_i32$0 = HEAP32[($3 + 80 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($3 + 84 | 0) >> 2] | 0;
       $46 = i64toi32_i32$0;
       i64toi32_i32$0 = $7;
       HEAP32[i64toi32_i32$0 >> 2] = $46;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       $8 = ($3 + 192 | 0) + 24 | 0;
       i64toi32_i32$2 = $8;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $54 = i64toi32_i32$1;
       i64toi32_i32$1 = ($3 + 144 | 0) + 24 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $54;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       $9 = ($3 + 192 | 0) + 16 | 0;
       i64toi32_i32$2 = $9;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $62 = i64toi32_i32$0;
       i64toi32_i32$0 = ($3 + 144 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $62;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       $10 = ($3 + 192 | 0) + 8 | 0;
       i64toi32_i32$2 = $10;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $70 = i64toi32_i32$1;
       i64toi32_i32$1 = ($3 + 144 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $70;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       $11 = ($3 + 80 | 0) + 8 | 0;
       HEAP32[($7 + 8 | 0) >> 2] = HEAP32[$11 >> 2] | 0;
       i64toi32_i32$2 = $3;
       i64toi32_i32$0 = HEAP32[($3 + 192 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($3 + 196 | 0) >> 2] | 0;
       $80 = i64toi32_i32$0;
       i64toi32_i32$0 = $3;
       HEAP32[($3 + 144 | 0) >> 2] = $80;
       HEAP32[($3 + 148 | 0) >> 2] = i64toi32_i32$1;
       $cardano_serialization_lib__plutus__PlutusDataEnum_20as_20core__clone__Clone___clone__h7a95fc7c6f531f3b($3 + 80 | 0 | 0, $1 + -32 | 0 | 0);
       label$8 : {
        label$9 : {
         if (HEAP32[$1 >> 2] | 0) {
          break label$9
         }
         HEAP32[($3 + 32 | 0) >> 2] = 0;
         break label$8;
        }
        $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($3 + 32 | 0 | 0, $1 | 0);
       }
       i64toi32_i32$2 = $3;
       i64toi32_i32$1 = HEAP32[($3 + 32 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[($3 + 36 | 0) >> 2] | 0;
       $93 = i64toi32_i32$1;
       i64toi32_i32$1 = $6;
       HEAP32[i64toi32_i32$1 >> 2] = $93;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = ($3 + 80 | 0) + 24 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $98 = i64toi32_i32$0;
       i64toi32_i32$0 = $8;
       HEAP32[i64toi32_i32$0 >> 2] = $98;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = ($3 + 80 | 0) + 16 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $103 = i64toi32_i32$1;
       i64toi32_i32$1 = $9;
       HEAP32[i64toi32_i32$1 >> 2] = $103;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = $11;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $106 = i64toi32_i32$0;
       i64toi32_i32$0 = $10;
       HEAP32[i64toi32_i32$0 >> 2] = $106;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       HEAP32[($6 + 8 | 0) >> 2] = HEAP32[(($3 + 32 | 0) + 8 | 0) >> 2] | 0;
       i64toi32_i32$2 = $3;
       i64toi32_i32$1 = HEAP32[($3 + 80 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[($3 + 84 | 0) >> 2] | 0;
       $115 = i64toi32_i32$1;
       i64toi32_i32$1 = $3;
       HEAP32[($3 + 192 | 0) >> 2] = $115;
       HEAP32[($3 + 196 | 0) >> 2] = i64toi32_i32$0;
       $8 = HEAPU16[($4 + 1062 | 0) >> 1] | 0;
       if ($8 >>> 0 >= 11 >>> 0) {
        break label$3
       }
       HEAP16[($4 + 1062 | 0) >> 1] = $8 + 1 | 0;
       memcpy((memcpy($4 + Math_imul($8, 48) | 0 | 0, $3 + 144 | 0 | 0, 48 | 0) | 0) + 528 | 0 | 0, $3 + 192 | 0 | 0, 48 | 0) | 0;
       $1 = $1 + 48 | 0;
       $5 = $5 + 1 | 0;
       if ($5 >>> 0 < (HEAPU16[($2 + 1062 | 0) >> 1] | 0) >>> 0) {
        continue label$5
       }
       break label$5;
      };
     }
     HEAP32[($0 + 8 | 0) >> 2] = $5;
     HEAP32[($0 + 4 | 0) >> 2] = $4;
     HEAP32[$0 >> 2] = 0;
     break label$1;
    }
    core__panicking__panic__h2fd385a887c8bf13(1048619 | 0, 32 | 0, 1048744 | 0);
    abort();
   }
   $12 = $1 + -1 | 0;
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__clone_subtree__hce8ff294b4963e31($3 + 8 | 0 | 0, $12 | 0, HEAP32[($2 + 1064 | 0) >> 2] | 0 | 0);
   label$10 : {
    label$11 : {
     $4 = HEAP32[($3 + 12 | 0) >> 2] | 0;
     if (!$4) {
      break label$11
     }
     $8 = (HEAP32[($3 + 8 | 0) >> 2] | 0) + 1 | 0;
     break label$10;
    }
    $4 = alloc__boxed__Box_T_2cA___new_uninit_in__h2ea6451c7ed438a4() | 0;
    HEAP16[($4 + 1062 | 0) >> 1] = 0;
    HEAP32[($4 + 1056 | 0) >> 2] = 0;
    $8 = 1;
   }
   $1 = alloc__boxed__Box_T_2cA___new_uninit_in__hf8493d13156d19ba() | 0;
   HEAP32[($1 + 1064 | 0) >> 2] = $4;
   HEAP16[($1 + 1062 | 0) >> 1] = 0;
   HEAP32[($1 + 1056 | 0) >> 2] = 0;
   HEAP16[($4 + 1060 | 0) >> 1] = 0;
   HEAP32[($4 + 1056 | 0) >> 2] = $1;
   HEAP32[($3 + 12 | 0) >> 2] = $1;
   HEAP32[($3 + 8 | 0) >> 2] = $8;
   HEAP32[($3 + 28 | 0) >> 2] = $1;
   HEAP32[($3 + 24 | 0) >> 2] = $8;
   label$12 : {
    if (!(HEAPU16[($2 + 1062 | 0) >> 1] | 0)) {
     break label$12
    }
    $8 = $2 + 1068 | 0;
    $1 = $2 + 560 | 0;
    $9 = ($3 + 80 | 0) + 32 | 0;
    $10 = ($3 + 32 | 0) + 32 | 0;
    $7 = HEAP32[($3 + 16 | 0) >> 2] | 0;
    $5 = 0;
    label$13 : while (1) {
     $cardano_serialization_lib__plutus__PlutusDataEnum_20as_20core__clone__Clone___clone__h7a95fc7c6f531f3b($3 + 192 | 0 | 0, $1 + -560 | 0 | 0);
     label$14 : {
      label$15 : {
       $4 = $1 + -528 | 0;
       if (HEAP32[$4 >> 2] | 0) {
        break label$15
       }
       HEAP32[($3 + 144 | 0) >> 2] = 0;
       break label$14;
      }
      $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($3 + 144 | 0 | 0, $4 | 0);
     }
     i64toi32_i32$2 = $3;
     i64toi32_i32$0 = HEAP32[($3 + 144 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($3 + 148 | 0) >> 2] | 0;
     $209 = i64toi32_i32$0;
     i64toi32_i32$0 = $10;
     HEAP32[i64toi32_i32$0 >> 2] = $209;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     $4 = ($3 + 192 | 0) + 24 | 0;
     i64toi32_i32$2 = $4;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $217 = i64toi32_i32$1;
     i64toi32_i32$1 = ($3 + 32 | 0) + 24 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $217;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     $6 = ($3 + 192 | 0) + 16 | 0;
     i64toi32_i32$2 = $6;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $225 = i64toi32_i32$0;
     i64toi32_i32$0 = ($3 + 32 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $225;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     $11 = ($3 + 192 | 0) + 8 | 0;
     i64toi32_i32$2 = $11;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $233 = i64toi32_i32$1;
     i64toi32_i32$1 = ($3 + 32 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $233;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     $13 = ($3 + 144 | 0) + 8 | 0;
     HEAP32[($10 + 8 | 0) >> 2] = HEAP32[$13 >> 2] | 0;
     i64toi32_i32$2 = $3;
     i64toi32_i32$0 = HEAP32[($3 + 192 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($3 + 196 | 0) >> 2] | 0;
     $243 = i64toi32_i32$0;
     i64toi32_i32$0 = $3;
     HEAP32[($3 + 32 | 0) >> 2] = $243;
     HEAP32[($3 + 36 | 0) >> 2] = i64toi32_i32$1;
     $cardano_serialization_lib__plutus__PlutusDataEnum_20as_20core__clone__Clone___clone__h7a95fc7c6f531f3b($3 + 192 | 0 | 0, $1 + -32 | 0 | 0);
     label$16 : {
      label$17 : {
       if (HEAP32[$1 >> 2] | 0) {
        break label$17
       }
       HEAP32[($3 + 144 | 0) >> 2] = 0;
       break label$16;
      }
      $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($3 + 144 | 0 | 0, $1 | 0);
     }
     $5 = $5 + 1 | 0;
     i64toi32_i32$2 = $3;
     i64toi32_i32$1 = HEAP32[($3 + 144 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($3 + 148 | 0) >> 2] | 0;
     $258 = i64toi32_i32$1;
     i64toi32_i32$1 = $9;
     HEAP32[i64toi32_i32$1 >> 2] = $258;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $4;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $263 = i64toi32_i32$0;
     i64toi32_i32$0 = ($3 + 80 | 0) + 24 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $263;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $6;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $268 = i64toi32_i32$1;
     i64toi32_i32$1 = ($3 + 80 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $268;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $11;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $273 = i64toi32_i32$0;
     i64toi32_i32$0 = ($3 + 80 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $273;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($9 + 8 | 0) >> 2] = HEAP32[$13 >> 2] | 0;
     i64toi32_i32$2 = $3;
     i64toi32_i32$1 = HEAP32[($3 + 192 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($3 + 196 | 0) >> 2] | 0;
     $280 = i64toi32_i32$1;
     i64toi32_i32$1 = $3;
     HEAP32[($3 + 80 | 0) >> 2] = $280;
     HEAP32[($3 + 84 | 0) >> 2] = i64toi32_i32$0;
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__clone_subtree__hce8ff294b4963e31($3 + 128 | 0 | 0, $12 | 0, HEAP32[$8 >> 2] | 0 | 0);
     $11 = HEAP32[($3 + 136 | 0) >> 2] | 0;
     $4 = HEAP32[($3 + 132 | 0) >> 2] | 0;
     $6 = HEAP32[($3 + 128 | 0) >> 2] | 0;
     memcpy($3 + 144 | 0 | 0, $3 + 32 | 0 | 0, 48 | 0) | 0;
     memcpy($3 + 192 | 0 | 0, $3 + 80 | 0 | 0, 48 | 0) | 0;
     label$18 : {
      if ($4) {
       break label$18
      }
      $6 = 0;
      $4 = alloc__boxed__Box_T_2cA___new_uninit_in__h2ea6451c7ed438a4() | 0;
      HEAP16[($4 + 1062 | 0) >> 1] = 0;
      HEAP32[($4 + 1056 | 0) >> 2] = 0;
     }
     alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal___push__h8e97906a7bbaaf79($3 + 24 | 0 | 0, $3 + 144 | 0 | 0, $3 + 192 | 0 | 0, $6 | 0, $4 | 0);
     $8 = $8 + 4 | 0;
     $1 = $1 + 48 | 0;
     $7 = ($11 + $7 | 0) + 1 | 0;
     if ($5 >>> 0 < (HEAPU16[($2 + 1062 | 0) >> 1] | 0) >>> 0) {
      continue label$13
     }
     break label$13;
    };
    HEAP32[($3 + 16 | 0) >> 2] = $7;
   }
   i64toi32_i32$2 = $3;
   i64toi32_i32$0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
   $330 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[i64toi32_i32$0 >> 2] = $330;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[(($3 + 8 | 0) + 8 | 0) >> 2] | 0;
  }
  global$0 = $3 + 240 | 0;
 }
 
 function num_bigint__bigint__addition___impl_20core__ops__arith__Add__num_bigint__bigint__BigInt__20for_20_num_bigint__bigint__BigInt___add__h354544d3f4ae9625($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $5 = 0, $6 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $12 = 0, $10 = 0, $11 = 0, $4 = 0, $7 = 0, $15 = 0, $8 = 0, $9 = 0, $16 = 0, $177 = 0, $13 = 0, $14 = 0, $306 = 0, $353 = 0;
  $3 = global$0 - 80 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    $4 = HEAPU8[($2 + 12 | 0) >> 0] | 0;
    if (($4 | 0) != (1 | 0)) {
     break label$2
    }
    $5 = HEAPU8[($1 + 12 | 0) >> 0] | 0;
    $6 = HEAP32[$1 >> 2] | 0;
    $1 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    alloc__raw_vec__RawVec_T_2cA___allocate_in__hb0817f92bbb8999a($3 | 0, $1 | 0, 0 | 0);
    $2 = HEAP32[$3 >> 2] | 0;
    HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($3 + 4 | 0) >> 2] | 0;
    HEAP32[$0 >> 2] = $2;
    memcpy($2 | 0, $6 | 0, $1 << 2 | 0 | 0) | 0;
    HEAP8[($0 + 12 | 0) >> 0] = $5;
    HEAP32[($0 + 8 | 0) >> 2] = $1;
    break label$1;
   }
   label$3 : {
    label$4 : {
     label$5 : {
      label$6 : {
       label$7 : {
        $7 = HEAPU8[($1 + 12 | 0) >> 0] | 0;
        switch ($7 | 0) {
        case 2:
         break label$6;
        case 1:
         break label$7;
        default:
         break label$5;
        };
       }
       $5 = HEAP32[$2 >> 2] | 0;
       $1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
       alloc__raw_vec__RawVec_T_2cA___allocate_in__hb0817f92bbb8999a($3 + 40 | 0 | 0, $1 | 0, 0 | 0);
       $2 = HEAP32[($3 + 40 | 0) >> 2] | 0;
       HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($3 + 44 | 0) >> 2] | 0;
       HEAP32[$0 >> 2] = $2;
       memcpy($2 | 0, $5 | 0, $1 << 2 | 0 | 0) | 0;
       HEAP8[($0 + 12 | 0) >> 0] = $4;
       HEAP32[($0 + 8 | 0) >> 2] = $1;
       break label$1;
      }
      if ($4) {
       break label$4
      }
      break label$3;
     }
     if ($4) {
      break label$3
     }
    }
    label$8 : {
     label$9 : {
      $5 = HEAP32[($1 + 8 | 0) >> 2] | 0;
      $6 = HEAP32[($2 + 8 | 0) >> 2] | 0;
      if ($5 >>> 0 >= $6 >>> 0) {
       break label$9
      }
      $2 = HEAP32[$2 >> 2] | 0;
      alloc__raw_vec__RawVec_T_2cA___allocate_in__hb0817f92bbb8999a($3 + 8 | 0 | 0, $6 | 0, 0 | 0);
      HEAP32[($3 + 68 | 0) >> 2] = HEAP32[($3 + 12 | 0) >> 2] | 0;
      $5 = HEAP32[($3 + 8 | 0) >> 2] | 0;
      HEAP32[($3 + 64 | 0) >> 2] = $5;
      memcpy($5 | 0, $2 | 0, $6 << 2 | 0 | 0) | 0;
      HEAP32[($3 + 72 | 0) >> 2] = $6;
      num_bigint__biguint__addition___impl_20core__ops__arith__Add__num_bigint__biguint__BigUint__20for_20num_bigint__biguint__BigUint___add__ha6a5672f04e3ed65($3 + 48 | 0 | 0, $3 + 64 | 0 | 0, $1 | 0);
      break label$8;
     }
     $1 = HEAP32[$1 >> 2] | 0;
     alloc__raw_vec__RawVec_T_2cA___allocate_in__hb0817f92bbb8999a($3 + 16 | 0 | 0, $5 | 0, 0 | 0);
     HEAP32[($3 + 68 | 0) >> 2] = HEAP32[($3 + 20 | 0) >> 2] | 0;
     $6 = HEAP32[($3 + 16 | 0) >> 2] | 0;
     HEAP32[($3 + 64 | 0) >> 2] = $6;
     memcpy($6 | 0, $1 | 0, $5 << 2 | 0 | 0) | 0;
     HEAP32[($3 + 72 | 0) >> 2] = $5;
     num_bigint__biguint__addition___impl_20core__ops__arith__Add__num_bigint__biguint__BigUint__20for_20num_bigint__biguint__BigUint___add__ha6a5672f04e3ed65($3 + 48 | 0 | 0, $3 + 64 | 0 | 0, $2 | 0);
    }
    label$10 : {
     label$11 : {
      if (($7 | 0) == (1 | 0)) {
       break label$11
      }
      $1 = HEAP32[($3 + 56 | 0) >> 2] | 0 ? $7 : 1;
      break label$10;
     }
     $5 = 0;
     HEAP32[($3 + 56 | 0) >> 2] = 0;
     $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend__T_2ccore__slice__iter__Iter_T_____spec_extend__h5cdab7a667860bc4($3 + 48 | 0 | 0, 1082816 | 0, 1082816 | 0);
     label$12 : {
      $1 = HEAP32[($3 + 56 | 0) >> 2] | 0;
      if (!$1) {
       break label$12
      }
      $2 = (($1 << 2 | 0) + (HEAP32[($3 + 48 | 0) >> 2] | 0) | 0) + -4 | 0;
      label$13 : while (1) {
       label$14 : {
        if (!(HEAP32[$2 >> 2] | 0)) {
         break label$14
        }
        $5 = $1;
        break label$12;
       }
       $1 = $1 + -1 | 0;
       HEAP32[($3 + 56 | 0) >> 2] = $1;
       $2 = $2 + -4 | 0;
       if ($1) {
        continue label$13
       }
       break label$13;
      };
     }
     $1 = 1;
     $2 = HEAP32[($3 + 52 | 0) >> 2] | 0;
     if ($2 >>> 0 <= $5 >>> 0) {
      break label$10
     }
     if ($5 >>> 0 >= ($2 >>> 2 | 0) >>> 0) {
      break label$10
     }
     alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($3 + 48 | 0 | 0, $5 | 0);
    }
    HEAP8[($0 + 12 | 0) >> 0] = $1;
    i64toi32_i32$0 = HEAP32[($3 + 48 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($3 + 52 | 0) >> 2] | 0;
    $177 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[$0 >> 2] = $177;
    HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($0 + 8 | 0) >> 2] = HEAP32[(($3 + 48 | 0) + 8 | 0) >> 2] | 0;
    break label$1;
   }
   $8 = HEAP32[$2 >> 2] | 0;
   $9 = HEAP32[$1 >> 2] | 0;
   label$15 : {
    label$16 : {
     $10 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     $11 = HEAP32[($2 + 8 | 0) >> 2] | 0;
     $12 = $10 >>> 0 < $11 >>> 0 ? -1 : ($10 | 0) != ($11 | 0);
     if ($12) {
      break label$16
     }
     $13 = $8 + -4 | 0;
     $6 = $11 << 2 | 0;
     $5 = $10 << 2 | 0;
     $14 = $9 + -4 | 0;
     label$17 : while (1) {
      label$18 : {
       if ($5) {
        break label$18
       }
       $12 = $6 ? -1 : 0;
       break label$16;
      }
      if (!$6) {
       break label$15
      }
      $12 = $14 + $5 | 0;
      $15 = $13 + $6 | 0;
      $6 = $6 + -4 | 0;
      $5 = $5 + -4 | 0;
      $12 = HEAP32[$12 >> 2] | 0;
      $15 = HEAP32[$15 >> 2] | 0;
      $12 = $12 >>> 0 < $15 >>> 0 ? -1 : ($12 | 0) != ($15 | 0);
      if (!$12) {
       continue label$17
      }
      break label$17;
     };
    }
    label$19 : {
     switch ($12 + 1 | 0 | 0) {
     default:
      alloc__raw_vec__RawVec_T_2cA___allocate_in__hb0817f92bbb8999a($3 + 24 | 0 | 0, $11 | 0, 0 | 0);
      HEAP32[($3 + 68 | 0) >> 2] = HEAP32[($3 + 28 | 0) >> 2] | 0;
      $2 = HEAP32[($3 + 24 | 0) >> 2] | 0;
      HEAP32[($3 + 64 | 0) >> 2] = $2;
      memcpy($2 | 0, $8 | 0, $11 << 2 | 0 | 0) | 0;
      HEAP32[($3 + 72 | 0) >> 2] = $11;
      num_bigint__biguint__subtraction___impl_20core__ops__arith__SubAssign__num_bigint__biguint__BigUint__20for_20num_bigint__biguint__BigUint___sub_assign__h4ea1a97f3b7bcde9($3 + 64 | 0 | 0, $1 | 0);
      i64toi32_i32$1 = HEAP32[($3 + 64 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($3 + 68 | 0) >> 2] | 0;
      $16 = i64toi32_i32$1;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 48 | 0) >> 2] = $16;
      HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$0;
      $1 = HEAP32[($3 + 72 | 0) >> 2] | 0;
      HEAP8[($0 + 12 | 0) >> 0] = $1 ? $4 : 1;
      HEAP32[($0 + 8 | 0) >> 2] = $1;
      i64toi32_i32$1 = $0;
      HEAP32[$0 >> 2] = $16;
      HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$0;
      break label$1;
     case 2:
      break label$15;
     case 1:
      break label$19;
     };
    }
    i64toi32_i32$1 = $0;
    i64toi32_i32$0 = 0;
    HEAP32[($0 + 4 | 0) >> 2] = 0;
    HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP8[($0 + 12 | 0) >> 0] = 1;
    HEAP32[$0 >> 2] = HEAP32[(0 + 1082808 | 0) >> 2] | 0;
    break label$1;
   }
   $5 = 0;
   alloc__raw_vec__RawVec_T_2cA___allocate_in__hb0817f92bbb8999a($3 + 32 | 0 | 0, $10 | 0, 0 | 0);
   HEAP32[($3 + 68 | 0) >> 2] = HEAP32[($3 + 36 | 0) >> 2] | 0;
   $1 = HEAP32[($3 + 32 | 0) >> 2] | 0;
   HEAP32[($3 + 64 | 0) >> 2] = $1;
   memcpy($1 | 0, $9 | 0, $10 << 2 | 0 | 0) | 0;
   $1 = ($3 + 64 | 0) + 8 | 0;
   HEAP32[$1 >> 2] = $10;
   num_bigint__biguint__subtraction___impl_20core__ops__arith__SubAssign__num_bigint__biguint__BigUint__20for_20num_bigint__biguint__BigUint___sub_assign__h4ea1a97f3b7bcde9($3 + 64 | 0 | 0, $2 | 0);
   HEAP32[(($3 + 48 | 0) + 8 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($3 + 64 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($3 + 68 | 0) >> 2] | 0;
   $306 = i64toi32_i32$0;
   i64toi32_i32$0 = $3;
   HEAP32[($3 + 48 | 0) >> 2] = $306;
   HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$1;
   label$21 : {
    label$22 : {
     if (($7 | 0) == (1 | 0)) {
      break label$22
     }
     $1 = HEAP32[($3 + 56 | 0) >> 2] | 0 ? $7 : 1;
     break label$21;
    }
    HEAP32[($3 + 56 | 0) >> 2] = 0;
    $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend__T_2ccore__slice__iter__Iter_T_____spec_extend__h5cdab7a667860bc4($3 + 48 | 0 | 0, 1082816 | 0, 1082816 | 0);
    label$23 : {
     $1 = HEAP32[($3 + 56 | 0) >> 2] | 0;
     if (!$1) {
      break label$23
     }
     $2 = (($1 << 2 | 0) + (HEAP32[($3 + 48 | 0) >> 2] | 0) | 0) + -4 | 0;
     label$24 : while (1) {
      label$25 : {
       if (!(HEAP32[$2 >> 2] | 0)) {
        break label$25
       }
       $5 = $1;
       break label$23;
      }
      $1 = $1 + -1 | 0;
      HEAP32[($3 + 56 | 0) >> 2] = $1;
      $2 = $2 + -4 | 0;
      if ($1) {
       continue label$24
      }
      break label$24;
     };
    }
    $1 = 1;
    $2 = HEAP32[($3 + 52 | 0) >> 2] | 0;
    if ($2 >>> 0 <= $5 >>> 0) {
     break label$21
    }
    if ($5 >>> 0 >= ($2 >>> 2 | 0) >>> 0) {
     break label$21
    }
    alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($3 + 48 | 0 | 0, $5 | 0);
   }
   HEAP8[($0 + 12 | 0) >> 0] = $1;
   i64toi32_i32$1 = HEAP32[($3 + 48 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($3 + 52 | 0) >> 2] | 0;
   $353 = i64toi32_i32$1;
   i64toi32_i32$1 = $0;
   HEAP32[$0 >> 2] = $353;
   HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($0 + 8 | 0) >> 2] = HEAP32[(($3 + 48 | 0) + 8 | 0) >> 2] | 0;
  }
  global$0 = $3 + 80 | 0;
 }
 
 function num_bigint__biguint__division__div_rem_ref__h525df07a54bd49a5($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, $6 = 0, $5 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $7 = 0, $10 = 0, $4 = 0, $26 = 0, $13 = 0, $9 = 0, $15 = 0, $15$hi = 0, $8 = 0, $14 = 0, $11 = 0, $12 = 0, $14$hi = 0, $274 = 0, $277 = 0, $330 = 0, $341 = 0, $344 = 0;
  $3 = global$0 - 112 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
      if (!$4) {
       break label$4
      }
      label$5 : {
       label$6 : {
        label$7 : {
         $5 = HEAP32[($1 + 8 | 0) >> 2] | 0;
         if (!$5) {
          break label$7
         }
         if (($4 | 0) != (1 | 0)) {
          break label$6
         }
         $26 = HEAP32[$2 >> 2] | 0;
         if ((HEAPU8[$26 >> 0] | 0 | ((HEAPU8[($26 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($26 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($26 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0 | 0) != (1 | 0)) {
          break label$5
         }
         $6 = HEAP32[$1 >> 2] | 0;
         alloc__raw_vec__RawVec_T_2cA___allocate_in__hb0817f92bbb8999a($3 | 0, $5 | 0, 0 | 0);
         $7 = HEAP32[($3 + 4 | 0) >> 2] | 0;
         $6 = memcpy(HEAP32[$3 >> 2] | 0 | 0, $6 | 0, $5 << 2 | 0 | 0) | 0;
         i64toi32_i32$1 = $0 + 16 | 0;
         i64toi32_i32$0 = 0;
         HEAP32[i64toi32_i32$1 >> 2] = 0;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
         HEAP32[($0 + 12 | 0) >> 2] = HEAP32[(0 + 1083944 | 0) >> 2] | 0;
         HEAP32[($0 + 8 | 0) >> 2] = $5;
         HEAP32[($0 + 4 | 0) >> 2] = $7;
         HEAP32[$0 >> 2] = $6;
         break label$1;
        }
        i64toi32_i32$1 = $0;
        i64toi32_i32$0 = 0;
        HEAP32[($0 + 4 | 0) >> 2] = 0;
        HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$1 = $0 + 16 | 0;
        i64toi32_i32$0 = 0;
        HEAP32[i64toi32_i32$1 >> 2] = 0;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        $6 = HEAP32[(0 + 1083944 | 0) >> 2] | 0;
        HEAP32[($0 + 12 | 0) >> 2] = $6;
        HEAP32[$0 >> 2] = $6;
        break label$1;
       }
       $8 = HEAP32[$2 >> 2] | 0;
       $9 = HEAP32[$1 >> 2] | 0;
       label$8 : {
        label$9 : {
         $10 = $5 >>> 0 < $4 >>> 0 ? -1 : ($5 | 0) != ($4 | 0);
         if ($10) {
          break label$9
         }
         $11 = $8 + -4 | 0;
         $6 = $4 << 2 | 0;
         $7 = $5 << 2 | 0;
         $12 = $9 + -4 | 0;
         label$10 : while (1) {
          label$11 : {
           if ($7) {
            break label$11
           }
           $10 = $6 ? -1 : 0;
           break label$9;
          }
          if (!$6) {
           break label$8
          }
          $10 = $12 + $7 | 0;
          $13 = $11 + $6 | 0;
          $6 = $6 + -4 | 0;
          $7 = $7 + -4 | 0;
          $10 = HEAP32[$10 >> 2] | 0;
          $13 = HEAP32[$13 >> 2] | 0;
          $10 = $10 >>> 0 < $13 >>> 0 ? -1 : ($10 | 0) != ($13 | 0);
          if (!$10) {
           continue label$10
          }
          break label$10;
         };
        }
        label$12 : {
         switch ($10 + 1 | 0 | 0) {
         default:
          alloc__raw_vec__RawVec_T_2cA___allocate_in__hb0817f92bbb8999a($3 + 16 | 0 | 0, $5 | 0, 0 | 0);
          $6 = HEAP32[($3 + 20 | 0) >> 2] | 0;
          $7 = memcpy(HEAP32[($3 + 16 | 0) >> 2] | 0 | 0, $9 | 0, $5 << 2 | 0 | 0) | 0;
          HEAP32[($0 + 20 | 0) >> 2] = $5;
          HEAP32[($0 + 16 | 0) >> 2] = $6;
          HEAP32[($0 + 12 | 0) >> 2] = $7;
          i64toi32_i32$1 = $0;
          i64toi32_i32$0 = 0;
          HEAP32[($0 + 4 | 0) >> 2] = 0;
          HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$0;
          HEAP32[$0 >> 2] = HEAP32[(0 + 1083944 | 0) >> 2] | 0;
          break label$1;
         case 1:
          break label$12;
         case 2:
          break label$8;
         };
        }
        $6 = __rust_alloc(4 | 0, 4 | 0) | 0;
        if (!$6) {
         break label$3
        }
        i64toi32_i32$1 = $0;
        i64toi32_i32$0 = 1;
        HEAP32[($0 + 4 | 0) >> 2] = 1;
        HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$0;
        HEAP32[$0 >> 2] = $6;
        HEAP32[$6 >> 2] = 1;
        i64toi32_i32$1 = $0 + 16 | 0;
        i64toi32_i32$0 = 0;
        HEAP32[i64toi32_i32$1 >> 2] = 0;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        HEAP32[($0 + 12 | 0) >> 2] = HEAP32[(0 + 1083944 | 0) >> 2] | 0;
        break label$1;
       }
       label$14 : {
        label$15 : {
         $6 = HEAP32[((($4 << 2 | 0) + $8 | 0) + -4 | 0) >> 2] | 0;
         $7 = Math_clz32($6);
         if ($7) {
          break label$15
         }
         alloc__raw_vec__RawVec_T_2cA___allocate_in__hb0817f92bbb8999a($3 + 24 | 0 | 0, $5 | 0, 0 | 0);
         HEAP32[($3 + 100 | 0) >> 2] = HEAP32[($3 + 28 | 0) >> 2] | 0;
         $1 = HEAP32[($3 + 24 | 0) >> 2] | 0;
         HEAP32[($3 + 96 | 0) >> 2] = $1;
         memcpy($1 | 0, $9 | 0, $5 << 2 | 0 | 0) | 0;
         HEAP32[($3 + 104 | 0) >> 2] = $5;
         num_bigint__biguint__division__div_rem_core__ha45fc4d52dd16ec8($3 + 56 | 0 | 0, $3 + 96 | 0 | 0, $2 | 0);
         break label$14;
        }
        HEAP32[($3 + 60 | 0) >> 2] = $1;
        HEAP32[($3 + 56 | 0) >> 2] = 0;
        $5 = !$6;
        $1 = $7 & 31 | 0;
        num_bigint__biguint__shift__biguint_shl2__h51620e0a9215508c($3 + 80 | 0 | 0, $3 + 56 | 0 | 0, $5 | 0, $1 | 0);
        label$16 : {
         label$17 : {
          if (!(HEAP32[($2 + 8 | 0) >> 2] | 0)) {
           break label$17
          }
          HEAP32[($3 + 60 | 0) >> 2] = $2;
          HEAP32[($3 + 56 | 0) >> 2] = 0;
          num_bigint__biguint__shift__biguint_shl2__h51620e0a9215508c($3 + 96 | 0 | 0, $3 + 56 | 0 | 0, $5 | 0, $1 | 0);
          $2 = HEAP32[($3 + 100 | 0) >> 2] | 0;
          break label$16;
         }
         alloc__raw_vec__RawVec_T_2cA___allocate_in__hb0817f92bbb8999a($3 + 32 | 0 | 0, 0 | 0, 0 | 0);
         HEAP32[($3 + 104 | 0) >> 2] = 0;
         $2 = HEAP32[($3 + 36 | 0) >> 2] | 0;
         HEAP32[($3 + 100 | 0) >> 2] = $2;
         HEAP32[($3 + 96 | 0) >> 2] = HEAP32[($3 + 32 | 0) >> 2] | 0;
        }
        num_bigint__biguint__division__div_rem_core__ha45fc4d52dd16ec8($3 + 56 | 0 | 0, $3 + 80 | 0 | 0, $3 + 96 | 0 | 0);
        if (!$2) {
         break label$14
        }
        $2 = $2 << 2 | 0;
        if (!$2) {
         break label$14
        }
        __rust_dealloc(HEAP32[($3 + 96 | 0) >> 2] | 0 | 0, $2 | 0, 4 | 0);
       }
       $1 = ($3 + 56 | 0) + 8 | 0;
       $2 = HEAP32[$1 >> 2] | 0;
       HEAP32[(($3 + 40 | 0) + 8 | 0) >> 2] = $2;
       i64toi32_i32$2 = $3;
       i64toi32_i32$0 = HEAP32[($3 + 56 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($3 + 60 | 0) >> 2] | 0;
       $14 = i64toi32_i32$0;
       $14$hi = i64toi32_i32$1;
       i64toi32_i32$0 = $3;
       HEAP32[($3 + 40 | 0) >> 2] = $14;
       HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $3 + 72 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $15 = i64toi32_i32$1;
       $15$hi = i64toi32_i32$0;
       $5 = HEAP32[($3 + 68 | 0) >> 2] | 0;
       HEAP32[(($3 + 80 | 0) + 8 | 0) >> 2] = $2;
       i64toi32_i32$0 = $14$hi;
       i64toi32_i32$1 = $3;
       HEAP32[($3 + 80 | 0) >> 2] = $14;
       HEAP32[($3 + 84 | 0) >> 2] = i64toi32_i32$0;
       label$18 : {
        label$19 : {
         i64toi32_i32$0 = $15$hi;
         i64toi32_i32$2 = $15;
         i64toi32_i32$1 = 1;
         if (i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$2 >>> 0 < 0 >>> 0 | 0) | 0) {
          break label$19
         }
         i64toi32_i32$2 = $15$hi;
         i64toi32_i32$0 = $1;
         HEAP32[i64toi32_i32$0 >> 2] = $15;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
         HEAP32[($3 + 60 | 0) >> 2] = $5;
         HEAP32[($3 + 56 | 0) >> 2] = 1;
         num_bigint__biguint__shift__biguint_shr2__hd374167955c1e352($3 + 96 | 0 | 0, $3 + 56 | 0 | 0, !$6 | 0, $7 & 31 | 0 | 0);
         break label$18;
        }
        i64toi32_i32$2 = $15$hi;
        i64toi32_i32$0 = $3;
        HEAP32[($3 + 100 | 0) >> 2] = $15;
        HEAP32[($3 + 104 | 0) >> 2] = i64toi32_i32$2;
        HEAP32[($3 + 96 | 0) >> 2] = $5;
       }
       i64toi32_i32$2 = HEAP32[($3 + 80 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[($3 + 84 | 0) >> 2] | 0;
       $274 = i64toi32_i32$2;
       i64toi32_i32$2 = $0;
       HEAP32[$0 >> 2] = $274;
       HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$0 = HEAP32[($3 + 96 | 0) >> 2] | 0;
       i64toi32_i32$2 = HEAP32[($3 + 100 | 0) >> 2] | 0;
       $277 = i64toi32_i32$0;
       i64toi32_i32$0 = $0;
       HEAP32[($0 + 12 | 0) >> 2] = $277;
       HEAP32[($0 + 16 | 0) >> 2] = i64toi32_i32$2;
       HEAP32[($0 + 8 | 0) >> 2] = HEAP32[(($3 + 80 | 0) + 8 | 0) >> 2] | 0;
       HEAP32[($0 + 20 | 0) >> 2] = HEAP32[(($3 + 96 | 0) + 8 | 0) >> 2] | 0;
       break label$1;
      }
      $6 = HEAP32[$1 >> 2] | 0;
      alloc__raw_vec__RawVec_T_2cA___allocate_in__hb0817f92bbb8999a($3 + 8 | 0 | 0, $5 | 0, 0 | 0);
      HEAP32[($3 + 100 | 0) >> 2] = HEAP32[($3 + 12 | 0) >> 2] | 0;
      $7 = HEAP32[($3 + 8 | 0) >> 2] | 0;
      HEAP32[($3 + 96 | 0) >> 2] = $7;
      memcpy($7 | 0, $6 | 0, $5 << 2 | 0 | 0) | 0;
      HEAP32[($3 + 104 | 0) >> 2] = $5;
      if (!(HEAP32[($2 + 8 | 0) >> 2] | 0)) {
       break label$2
      }
      num_bigint__biguint__division__div_rem_digit__hf51877c9bc7172fa($3 + 56 | 0 | 0, $3 + 96 | 0 | 0, HEAP32[(HEAP32[$2 >> 2] | 0) >> 2] | 0 | 0);
      $6 = ($3 + 96 | 0) + 8 | 0;
      $7 = ($3 + 56 | 0) + 8 | 0;
      HEAP32[$6 >> 2] = HEAP32[$7 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[($3 + 56 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($3 + 60 | 0) >> 2] | 0;
      $330 = i64toi32_i32$2;
      i64toi32_i32$2 = $3;
      HEAP32[($3 + 96 | 0) >> 2] = $330;
      HEAP32[($3 + 100 | 0) >> 2] = i64toi32_i32$0;
      $T_20as_20core__convert__Into_U____into__h9fa017df171d181a($3 + 56 | 0 | 0, HEAP32[($3 + 68 | 0) >> 2] | 0 | 0);
      HEAP32[($0 + 8 | 0) >> 2] = HEAP32[$6 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($3 + 96 | 0) >> 2] | 0;
      i64toi32_i32$2 = HEAP32[($3 + 100 | 0) >> 2] | 0;
      $341 = i64toi32_i32$0;
      i64toi32_i32$0 = $0;
      HEAP32[$0 >> 2] = $341;
      HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$2 = HEAP32[($3 + 56 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($3 + 60 | 0) >> 2] | 0;
      $344 = i64toi32_i32$2;
      i64toi32_i32$2 = $0;
      HEAP32[($0 + 12 | 0) >> 2] = $344;
      HEAP32[($0 + 16 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[($0 + 20 | 0) >> 2] = HEAP32[$7 >> 2] | 0;
      break label$1;
     }
     std__panicking__begin_panic__hf55b754840077f11(1084057 | 0, 25 | 0, 1084084 | 0);
     abort();
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(4 | 0, 4 | 0);
    abort();
   }
   core__panicking__panic_bounds_check__h808b524af17640b1(0 | 0, 0 | 0, 1084100 | 0);
   abort();
  }
  global$0 = $3 + 112 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__TransactionOutput___deserialize_as_embedded_group__hdb5ba370036b9958($0, $1, $2, $2$hi, $3, $3$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  var $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, $5 = 0, $7 = 0, i64toi32_i32$2 = 0, $6 = 0, $31 = 0, $32 = 0, $33 = 0, $34 = 0, $7$hi = 0, $55 = 0, $61 = 0, $151 = 0, $184 = 0, $189 = 0, $194 = 0, $197 = 0, $226 = 0, $239 = 0, $264 = 0, $270 = 0, $273 = 0, $286 = 0, $292 = 0, $298 = 0, $303 = 0;
  $4 = global$0 - 464 | 0;
  global$0 = $4;
  $cardano_serialization_lib__address__Address_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__he3542444dd01e6b6($4 + 312 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[($4 + 312 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($4 + 316 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  $5 = ($4 + 312 | 0) + 8 | 0;
  memcpy($4 + 400 | 0 | 0, $5 | 0, 64 | 0) | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           label$10 : {
            i64toi32_i32$2 = i64toi32_i32$0;
            i64toi32_i32$0 = 0;
            i64toi32_i32$3 = 1;
            if (($7 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
             break label$10
            }
            memcpy($4 + 248 | 0 | 0, $4 + 400 | 0 | 0, 64 | 0) | 0;
            memcpy($4 + 112 | 0 | 0, memcpy(($4 + 176 | 0) + 8 | 0 | 0, $4 + 248 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
            memcpy($4 + 24 | 0 | 0, $4 + 112 | 0 | 0, 64 | 0) | 0;
            $cardano_serialization_lib__utils__Value_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hfd20dfadce0ab65b($4 + 312 | 0 | 0, $1 | 0);
            label$11 : {
             label$12 : {
              i64toi32_i32$3 = $4;
              i64toi32_i32$2 = HEAP32[($4 + 312 | 0) >> 2] | 0;
              i64toi32_i32$1 = HEAP32[($4 + 316 | 0) >> 2] | 0;
              i64toi32_i32$3 = i64toi32_i32$2;
              i64toi32_i32$2 = 0;
              i64toi32_i32$0 = 1;
              if ((i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) | 0) {
               break label$12
              }
              i64toi32_i32$0 = $5 + 16 | 0;
              i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
              i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
              $55 = i64toi32_i32$3;
              i64toi32_i32$3 = ($4 + 88 | 0) + 16 | 0;
              HEAP32[i64toi32_i32$3 >> 2] = $55;
              HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
              i64toi32_i32$0 = $5 + 8 | 0;
              i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
              i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
              $61 = i64toi32_i32$1;
              i64toi32_i32$1 = ($4 + 88 | 0) + 8 | 0;
              HEAP32[i64toi32_i32$1 >> 2] = $61;
              HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
              i64toi32_i32$0 = $5;
              i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
              i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
              $7 = i64toi32_i32$3;
              $7$hi = i64toi32_i32$1;
              i64toi32_i32$3 = $4;
              HEAP32[($4 + 112 | 0) >> 2] = $7;
              HEAP32[($4 + 116 | 0) >> 2] = i64toi32_i32$1;
              i64toi32_i32$3 = $4;
              HEAP32[($4 + 88 | 0) >> 2] = $7;
              HEAP32[($4 + 92 | 0) >> 2] = i64toi32_i32$1;
              std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($4 + 16 | 0 | 0, $1 | 0);
              if (HEAP32[($4 + 20 | 0) >> 2] | 0) {
               break label$11
              }
              i64toi32_i32$3 = $4 + 188 | 0;
              i64toi32_i32$1 = 0;
              HEAP32[i64toi32_i32$3 >> 2] = 0;
              HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
              HEAP8[(($4 + 176 | 0) + 8 | 0) >> 0] = 8;
              HEAP8[($4 + 176 | 0) >> 0] = 1;
              $5 = 0;
              break label$3;
             }
             memcpy($4 + 400 | 0 | 0, $5 | 0, 64 | 0) | 0;
             memcpy($4 + 248 | 0 | 0, $4 + 400 | 0 | 0, 64 | 0) | 0;
             memcpy($4 + 312 | 0 | 0, $4 + 248 | 0 | 0, 64 | 0) | 0;
             $1 = ($4 + 176 | 0) + 8 | 0;
             cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 312 | 0 | 0, 1050743 | 0, 6 | 0);
             memcpy($4 + 112 | 0 | 0, $1 | 0, 64 | 0) | 0;
             memcpy($0 + 8 | 0 | 0, $4 + 112 | 0 | 0, 64 | 0) | 0;
             i64toi32_i32$3 = $0;
             i64toi32_i32$1 = 0;
             HEAP32[i64toi32_i32$3 >> 2] = 1;
             HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
             core__ptr__drop_in_place_cardano_serialization_lib__address__Address___ha7ee337124a79b19($4 + 24 | 0 | 0);
             break label$1;
            }
            $5 = 0;
            $6 = $cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[($4 + 16 | 0) >> 2] | 0) >> 0] | 0 | 0) | 0;
            HEAP8[($4 + 176 | 0) >> 0] = 0;
            $6 = $6 & 255 | 0;
            HEAP8[($4 + 177 | 0) >> 0] = $6;
            if (($6 | 0) != (2 | 0)) {
             break label$2
            }
            i64toi32_i32$3 = $4;
            i64toi32_i32$1 = 0;
            HEAP32[($4 + 312 | 0) >> 2] = 2;
            HEAP32[($4 + 316 | 0) >> 2] = i64toi32_i32$1;
            i64toi32_i32$3 = $4;
            i64toi32_i32$1 = 0;
            HEAP32[($4 + 320 | 0) >> 2] = 0;
            HEAP32[($4 + 324 | 0) >> 2] = i64toi32_i32$1;
            $std__io__cursor__Cursor_T__20as_20std__io__Seek___seek__h4fe82da83d4d5304($4 + 400 | 0 | 0, $1 | 0, $4 + 312 | 0 | 0);
            if ((HEAP32[($4 + 400 | 0) >> 2] | 0 | 0) == (1 | 0)) {
             break label$9
            }
            i64toi32_i32$0 = ($4 + 400 | 0) + 8 | 0;
            i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
            i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
            $7 = i64toi32_i32$1;
            $7$hi = i64toi32_i32$3;
            cbor_event__de__Deserializer_R___bytes__hc697ccccfa39fd82($4 + 312 | 0 | 0, $1 | 0);
            if ((HEAP32[($4 + 312 | 0) >> 2] | 0 | 0) == (1 | 0)) {
             break label$8
            }
            $5 = HEAP32[($4 + 324 | 0) >> 2] | 0;
            HEAP32[(($4 + 248 | 0) + 8 | 0) >> 2] = $5;
            i64toi32_i32$0 = $4;
            i64toi32_i32$3 = HEAP32[($4 + 316 | 0) >> 2] | 0;
            i64toi32_i32$1 = HEAP32[($4 + 320 | 0) >> 2] | 0;
            $151 = i64toi32_i32$3;
            i64toi32_i32$3 = $4;
            HEAP32[($4 + 248 | 0) >> 2] = $151;
            HEAP32[($4 + 252 | 0) >> 2] = i64toi32_i32$1;
            label$13 : {
             if (($5 | 0) == (32 | 0)) {
              break label$13
             }
             i64toi32_i32$3 = $4;
             i64toi32_i32$1 = 0;
             HEAP32[($4 + 312 | 0) >> 2] = 0;
             HEAP32[($4 + 316 | 0) >> 2] = i64toi32_i32$1;
             i64toi32_i32$1 = $7$hi;
             i64toi32_i32$3 = $4;
             HEAP32[($4 + 320 | 0) >> 2] = $7;
             HEAP32[($4 + 324 | 0) >> 2] = i64toi32_i32$1;
             $std__io__cursor__Cursor_T__20as_20std__io__Seek___seek__h4fe82da83d4d5304($4 + 400 | 0 | 0, $1 | 0, $4 + 312 | 0 | 0);
             if ((HEAP32[($4 + 400 | 0) >> 2] | 0 | 0) == (1 | 0)) {
              break label$7
             }
             $5 = 0;
             break label$4;
            }
            $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($4 + 8 | 0 | 0, $4 + 248 | 0 | 0);
            $1 = HEAP32[($4 + 12 | 0) >> 2] | 0;
            if ($1 >>> 0 <= 31 >>> 0) {
             break label$6
            }
            $T_20as_20core__convert__TryInto_U____try_into__ha1ac58dc74faf560($4 + 312 | 0 | 0, HEAP32[($4 + 8 | 0) >> 2] | 0 | 0, 32 | 0);
            $5 = 1;
            if ((HEAPU8[($4 + 312 | 0) >> 0] | 0 | 0) == (1 | 0)) {
             break label$5
            }
            i64toi32_i32$0 = $4 + 337 | 0;
            i64toi32_i32$1 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            i64toi32_i32$3 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            $184 = i64toi32_i32$1;
            i64toi32_i32$1 = $4 + 424 | 0;
            HEAP32[i64toi32_i32$1 >> 2] = $184;
            HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
            i64toi32_i32$0 = $4 + 329 | 0;
            i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            $189 = i64toi32_i32$3;
            i64toi32_i32$3 = $4 + 416 | 0;
            HEAP32[i64toi32_i32$3 >> 2] = $189;
            HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
            i64toi32_i32$0 = $4 + 321 | 0;
            i64toi32_i32$1 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            i64toi32_i32$3 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            $194 = i64toi32_i32$1;
            i64toi32_i32$1 = $4 + 408 | 0;
            HEAP32[i64toi32_i32$1 >> 2] = $194;
            HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
            i64toi32_i32$0 = $4;
            i64toi32_i32$3 = HEAPU8[($4 + 313 | 0) >> 0] | 0 | ((HEAPU8[($4 + 314 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 315 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 316 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            i64toi32_i32$1 = HEAPU8[($4 + 317 | 0) >> 0] | 0 | ((HEAPU8[($4 + 318 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 319 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 320 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
            $197 = i64toi32_i32$3;
            i64toi32_i32$3 = $4;
            HEAP32[($4 + 400 | 0) >> 2] = $197;
            HEAP32[($4 + 404 | 0) >> 2] = i64toi32_i32$1;
            break label$4;
           }
           memcpy($4 + 248 | 0 | 0, $4 + 400 | 0 | 0, 64 | 0) | 0;
           memcpy($4 + 312 | 0 | 0, $4 + 248 | 0 | 0, 64 | 0) | 0;
           $1 = ($4 + 176 | 0) + 8 | 0;
           cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 312 | 0 | 0, 1050736 | 0, 7 | 0);
           memcpy($4 + 112 | 0 | 0, $1 | 0, 64 | 0) | 0;
           memcpy($0 + 8 | 0 | 0, $4 + 112 | 0 | 0, 64 | 0) | 0;
           i64toi32_i32$3 = $0;
           i64toi32_i32$1 = 0;
           HEAP32[i64toi32_i32$3 >> 2] = 1;
           HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
           break label$1;
          }
          i64toi32_i32$0 = $4;
          i64toi32_i32$1 = HEAP32[($4 + 404 | 0) >> 2] | 0;
          i64toi32_i32$3 = HEAP32[($4 + 408 | 0) >> 2] | 0;
          $226 = i64toi32_i32$1;
          i64toi32_i32$1 = $4;
          HEAP32[($4 + 312 | 0) >> 2] = $226;
          HEAP32[($4 + 316 | 0) >> 2] = i64toi32_i32$3;
          core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $4 + 312 | 0 | 0, 1050188 | 0, 1050656 | 0);
          abort();
         }
         memcpy($4 + 400 | 0 | 0, ($4 + 312 | 0) + 8 | 0 | 0, 40 | 0) | 0;
         core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $4 + 400 | 0 | 0, 1050172 | 0, 1050672 | 0);
         abort();
        }
        i64toi32_i32$0 = $4;
        i64toi32_i32$3 = HEAP32[($4 + 404 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($4 + 408 | 0) >> 2] | 0;
        $239 = i64toi32_i32$3;
        i64toi32_i32$3 = $4;
        HEAP32[($4 + 312 | 0) >> 2] = $239;
        HEAP32[($4 + 316 | 0) >> 2] = i64toi32_i32$1;
        core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $4 + 312 | 0 | 0, 1050188 | 0, 1050720 | 0);
        abort();
       }
       core__slice__index__slice_end_index_len_fail__h192505a15ac4b345(32 | 0, $1 | 0, 1050688 | 0);
       abort();
      }
      core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $4 + 400 | 0 | 0, 1050156 | 0, 1050704 | 0);
      abort();
     }
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($4 + 248 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($4 + 248 | 0 | 0);
     if (!(HEAPU8[($4 + 176 | 0) >> 0] | 0)) {
      break label$2
     }
    }
    core__ptr__drop_in_place_cbor_event__error__Error___hbf0141ec70b68c45_3($4 + 184 | 0 | 0);
   }
   memcpy($4 + 312 | 0 | 0, $4 + 24 | 0 | 0, 64 | 0) | 0;
   i64toi32_i32$0 = ($4 + 88 | 0) + 16 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $264 = i64toi32_i32$1;
   i64toi32_i32$1 = $4 + 392 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $264;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$0 = ($4 + 88 | 0) + 8 | 0;
   i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $270 = i64toi32_i32$3;
   i64toi32_i32$3 = $4 + 384 | 0;
   HEAP32[i64toi32_i32$3 >> 2] = $270;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$0 = $4;
   i64toi32_i32$1 = HEAP32[($4 + 88 | 0) >> 2] | 0;
   i64toi32_i32$3 = HEAP32[($4 + 92 | 0) >> 2] | 0;
   $273 = i64toi32_i32$1;
   i64toi32_i32$1 = $4;
   HEAP32[($4 + 376 | 0) >> 2] = $273;
   HEAP32[($4 + 380 | 0) >> 2] = i64toi32_i32$3;
   memcpy($0 + 8 | 0 | 0, $4 + 312 | 0 | 0, 88 | 0) | 0;
   HEAP8[($0 + 96 | 0) >> 0] = $5;
   i64toi32_i32$1 = $0;
   i64toi32_i32$3 = 0;
   HEAP32[i64toi32_i32$1 >> 2] = 0;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$0 = $4;
   i64toi32_i32$3 = HEAP32[($4 + 400 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($4 + 404 | 0) >> 2] | 0;
   $286 = i64toi32_i32$3;
   i64toi32_i32$3 = $0 + 97 | 0;
   $31 = $286;
   HEAP8[i64toi32_i32$3 >> 0] = $31;
   HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $31 >>> 8 | 0;
   HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $31 >>> 16 | 0;
   HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $31 >>> 24 | 0;
   HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$0 = ($4 + 400 | 0) + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $292 = i64toi32_i32$1;
   i64toi32_i32$1 = $0 + 105 | 0;
   $32 = $292;
   HEAP8[i64toi32_i32$1 >> 0] = $32;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $32 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $32 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $32 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$3;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
   i64toi32_i32$0 = ($4 + 400 | 0) + 16 | 0;
   i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $298 = i64toi32_i32$3;
   i64toi32_i32$3 = $0 + 113 | 0;
   $33 = $298;
   HEAP8[i64toi32_i32$3 >> 0] = $33;
   HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $33 >>> 8 | 0;
   HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $33 >>> 16 | 0;
   HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $33 >>> 24 | 0;
   HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$0 = $4 + 424 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $303 = i64toi32_i32$1;
   i64toi32_i32$1 = $0 + 121 | 0;
   $34 = $303;
   HEAP8[i64toi32_i32$1 >> 0] = $34;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $34 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $34 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $34 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$3;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
  }
  global$0 = $4 + 464 | 0;
 }
 
 function core__str__slice_error_fail__h8a7d2e23b7bba52e($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, $6 = 0, $7 = 0, $8 = 0, i64toi32_i32$0 = 0, $9 = 0;
  $5 = global$0 - 112 | 0;
  global$0 = $5;
  HEAP32[($5 + 12 | 0) >> 2] = $3;
  HEAP32[($5 + 8 | 0) >> 2] = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     if ($1 >>> 0 < 257 >>> 0) {
      break label$3
     }
     $6 = 256;
     label$4 : {
      label$5 : while (1) {
       label$6 : {
        label$7 : {
         $7 = $6 >>> 0 < $1 >>> 0;
         if ($7) {
          break label$7
         }
         if (($1 | 0) != ($6 | 0)) {
          break label$6
         }
         $7 = $1;
         break label$4;
        }
        $8 = $0 + $6 | 0;
        if ((HEAP8[$8 >> 0] | 0 | 0) < (-64 | 0)) {
         break label$6
        }
        label$8 : {
         if ($7) {
          break label$8
         }
         $7 = $1;
         if (($1 | 0) == ($6 | 0)) {
          break label$4
         }
         break label$1;
        }
        if ((HEAP8[$8 >> 0] | 0 | 0) <= (-65 | 0)) {
         break label$1
        }
        $7 = $6;
        break label$4;
       }
       $6 = $6 + -1 | 0;
       if ($6) {
        continue label$5
       }
       break label$5;
      };
      $7 = 0;
     }
     HEAP32[($5 + 20 | 0) >> 2] = $7;
     HEAP32[($5 + 16 | 0) >> 2] = $0;
     HEAP32[($5 + 24 | 0) >> 2] = 1151252;
     $6 = 5;
     break label$2;
    }
    HEAP32[($5 + 20 | 0) >> 2] = $1;
    HEAP32[($5 + 16 | 0) >> 2] = $0;
    HEAP32[($5 + 24 | 0) >> 2] = 1149204;
    $6 = 0;
   }
   HEAP32[($5 + 28 | 0) >> 2] = $6;
   label$9 : {
    label$10 : {
     label$11 : {
      label$12 : {
       label$13 : {
        label$14 : {
         label$15 : {
          $6 = $2 >>> 0 > $1 >>> 0;
          if ($6) {
           break label$15
          }
          if ($3 >>> 0 > $1 >>> 0) {
           break label$15
          }
          if ($2 >>> 0 > $3 >>> 0) {
           break label$14
          }
          if (!$2) {
           break label$13
          }
          label$16 : {
           label$17 : {
            if ($2 >>> 0 < $1 >>> 0) {
             break label$17
            }
            if (($1 | 0) != ($2 | 0)) {
             break label$16
            }
            break label$13;
           }
           if ((HEAP8[($0 + $2 | 0) >> 0] | 0 | 0) > (-65 | 0)) {
            break label$13
           }
          }
          HEAP32[($5 + 32 | 0) >> 2] = $2;
          $3 = $2;
          break label$12;
         }
         HEAP32[($5 + 40 | 0) >> 2] = $6 ? $2 : $3;
         HEAP32[(($5 + 48 | 0) + 20 | 0) >> 2] = 3;
         HEAP32[(($5 + 72 | 0) + 20 | 0) >> 2] = 328;
         HEAP32[($5 + 84 | 0) >> 2] = 328;
         i64toi32_i32$0 = 0;
         HEAP32[($5 + 52 | 0) >> 2] = 3;
         HEAP32[($5 + 56 | 0) >> 2] = i64toi32_i32$0;
         HEAP32[($5 + 48 | 0) >> 2] = 1151292;
         HEAP32[($5 + 76 | 0) >> 2] = 46;
         HEAP32[($5 + 64 | 0) >> 2] = $5 + 72 | 0;
         HEAP32[($5 + 88 | 0) >> 2] = $5 + 24 | 0;
         HEAP32[($5 + 80 | 0) >> 2] = $5 + 16 | 0;
         HEAP32[($5 + 72 | 0) >> 2] = $5 + 40 | 0;
         core__panicking__panic_fmt__hbf21a3d4bbb82bf8($5 + 48 | 0 | 0, $4 | 0);
         abort();
        }
        HEAP32[($5 + 100 | 0) >> 2] = 328;
        HEAP32[(($5 + 72 | 0) + 20 | 0) >> 2] = 328;
        HEAP32[($5 + 84 | 0) >> 2] = 46;
        HEAP32[(($5 + 48 | 0) + 20 | 0) >> 2] = 4;
        i64toi32_i32$0 = 0;
        HEAP32[($5 + 52 | 0) >> 2] = 4;
        HEAP32[($5 + 56 | 0) >> 2] = i64toi32_i32$0;
        HEAP32[($5 + 48 | 0) >> 2] = 1151352;
        HEAP32[($5 + 76 | 0) >> 2] = 46;
        HEAP32[($5 + 64 | 0) >> 2] = $5 + 72 | 0;
        HEAP32[($5 + 96 | 0) >> 2] = $5 + 24 | 0;
        HEAP32[($5 + 88 | 0) >> 2] = $5 + 16 | 0;
        HEAP32[($5 + 80 | 0) >> 2] = $5 + 12 | 0;
        HEAP32[($5 + 72 | 0) >> 2] = $5 + 8 | 0;
        core__panicking__panic_fmt__hbf21a3d4bbb82bf8($5 + 48 | 0 | 0, $4 | 0);
        abort();
       }
       HEAP32[($5 + 32 | 0) >> 2] = $3;
       if (!$3) {
        break label$11
       }
      }
      label$18 : while (1) {
       label$19 : {
        label$20 : {
         $6 = $3 >>> 0 < $1 >>> 0;
         if ($6) {
          break label$20
         }
         if (($1 | 0) == ($3 | 0)) {
          break label$9
         }
         break label$19;
        }
        $7 = $0 + $3 | 0;
        if ((HEAP8[$7 >> 0] | 0 | 0) < (-64 | 0)) {
         break label$19
        }
        label$21 : {
         label$22 : {
          if ($6) {
           break label$22
          }
          if (($1 | 0) != ($3 | 0)) {
           break label$21
          }
          break label$9;
         }
         if ((HEAP8[$7 >> 0] | 0 | 0) > (-65 | 0)) {
          break label$10
         }
        }
        core__str__slice_error_fail__h8a7d2e23b7bba52e($0 | 0, $1 | 0, $3 | 0, $1 | 0, $4 | 0);
        abort();
       }
       $3 = $3 + -1 | 0;
       if ($3) {
        continue label$18
       }
       break label$18;
      };
     }
     $3 = 0;
    }
    if (($3 | 0) == ($1 | 0)) {
     break label$9
    }
    $7 = 1;
    label$23 : {
     label$24 : {
      label$25 : {
       label$26 : {
        $8 = $0 + $3 | 0;
        $6 = HEAP8[$8 >> 0] | 0;
        if (($6 | 0) > (-1 | 0)) {
         break label$26
        }
        $2 = 0;
        $1 = $0 + $1 | 0;
        $7 = $1;
        label$27 : {
         if (($8 + 1 | 0 | 0) == ($1 | 0)) {
          break label$27
         }
         $7 = $8 + 2 | 0;
         $2 = (HEAPU8[($8 + 1 | 0) >> 0] | 0) & 63 | 0;
        }
        $0 = $6 & 31 | 0;
        if (($6 & 255 | 0) >>> 0 > 223 >>> 0) {
         break label$25
        }
        $6 = $2 | ($0 << 6 | 0) | 0;
        break label$24;
       }
       HEAP32[($5 + 36 | 0) >> 2] = $6 & 255 | 0;
       break label$23;
      }
      $8 = 0;
      $9 = $1;
      label$28 : {
       if (($7 | 0) == ($1 | 0)) {
        break label$28
       }
       $9 = $7 + 1 | 0;
       $8 = (HEAPU8[$7 >> 0] | 0) & 63 | 0;
      }
      $7 = $8 | ($2 << 6 | 0) | 0;
      label$29 : {
       if (($6 & 255 | 0) >>> 0 >= 240 >>> 0) {
        break label$29
       }
       $6 = $7 | ($0 << 12 | 0) | 0;
       break label$24;
      }
      $6 = 0;
      label$30 : {
       if (($9 | 0) == ($1 | 0)) {
        break label$30
       }
       $6 = (HEAPU8[$9 >> 0] | 0) & 63 | 0;
      }
      $6 = $7 << 6 | 0 | (($0 << 18 | 0) & 1835008 | 0) | 0 | $6 | 0;
      if (($6 | 0) == (1114112 | 0)) {
       break label$9
      }
     }
     HEAP32[($5 + 36 | 0) >> 2] = $6;
     $7 = 1;
     if ($6 >>> 0 < 128 >>> 0) {
      break label$23
     }
     $7 = 2;
     if ($6 >>> 0 < 2048 >>> 0) {
      break label$23
     }
     $7 = $6 >>> 0 < 65536 >>> 0 ? 3 : 4;
    }
    HEAP32[($5 + 40 | 0) >> 2] = $3;
    HEAP32[($5 + 44 | 0) >> 2] = $7 + $3 | 0;
    HEAP32[(($5 + 48 | 0) + 20 | 0) >> 2] = 5;
    HEAP32[($5 + 108 | 0) >> 2] = 328;
    HEAP32[($5 + 100 | 0) >> 2] = 328;
    HEAP32[(($5 + 72 | 0) + 20 | 0) >> 2] = 330;
    HEAP32[($5 + 84 | 0) >> 2] = 265;
    i64toi32_i32$0 = 0;
    HEAP32[($5 + 52 | 0) >> 2] = 5;
    HEAP32[($5 + 56 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($5 + 48 | 0) >> 2] = 1151436;
    HEAP32[($5 + 76 | 0) >> 2] = 46;
    HEAP32[($5 + 64 | 0) >> 2] = $5 + 72 | 0;
    HEAP32[($5 + 104 | 0) >> 2] = $5 + 24 | 0;
    HEAP32[($5 + 96 | 0) >> 2] = $5 + 16 | 0;
    HEAP32[($5 + 88 | 0) >> 2] = $5 + 40 | 0;
    HEAP32[($5 + 80 | 0) >> 2] = $5 + 36 | 0;
    HEAP32[($5 + 72 | 0) >> 2] = $5 + 32 | 0;
    core__panicking__panic_fmt__hbf21a3d4bbb82bf8($5 + 48 | 0 | 0, $4 | 0);
    abort();
   }
   core__panicking__panic__h2fd385a887c8bf13(1149461 | 0, 43 | 0, $4 | 0);
   abort();
  }
  core__str__slice_error_fail__h8a7d2e23b7bba52e($0 | 0, $1 | 0, 0 | 0, $6 | 0, 1151236 | 0);
  abort();
 }
 
 function bech32__decode__h25859b35256032dd($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, $5 = 0, $6 = 0, i64toi32_i32$0 = 0, $10 = 0, i64toi32_i32$1 = 0, $11 = 0, $7 = 0, $9 = 0, $12 = 0, $8 = 0, $13 = 0, $274 = 0;
  $3 = global$0 - 80 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     if ($2 >>> 0 < 8 >>> 0) {
      break label$3
     }
     core__slice__memchr__memrchr__h18f8a2030f79e6f7($3 + 16 | 0 | 0, 49 | 0, $1 | 0, $2 | 0);
     label$4 : {
      if ((HEAP32[($3 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
       break label$4
      }
      $4 = HEAP32[($3 + 20 | 0) >> 2] | 0;
      label$5 : while (1) {
       label$6 : {
        if (($4 | 0) == (-1 | 0)) {
         break label$6
        }
        if (($4 + 1 | 0) >>> 0 > $2 >>> 0) {
         break label$6
        }
        $5 = $1 + $4 | 0;
        if ((HEAPU8[$5 >> 0] | 0 | 0) == (49 | 0)) {
         break label$2
        }
       }
       if ($4 >>> 0 > $2 >>> 0) {
        break label$4
       }
       core__slice__memchr__memrchr__h18f8a2030f79e6f7($3 | 0, 49 | 0, $1 | 0, $4 | 0);
       $4 = HEAP32[($3 + 4 | 0) >> 2] | 0;
       if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
        continue label$5
       }
       break label$5;
      };
     }
     HEAP32[$0 >> 2] = 1;
     HEAP8[($0 + 4 | 0) >> 0] = 0;
     break label$1;
    }
    HEAP32[$0 >> 2] = 1;
    HEAP8[($0 + 4 | 0) >> 0] = 2;
    break label$1;
   }
   label$7 : {
    label$8 : {
     label$9 : {
      label$10 : {
       if ($4 >>> 0 > $2 >>> 0) {
        break label$10
       }
       label$11 : {
        label$12 : {
         $6 = $2 - $4 | 0;
         if ($6 >>> 0 > 1 >>> 0) {
          break label$12
         }
         if (($6 | 0) != (1 | 0)) {
          break label$11
         }
         break label$7;
        }
        if ((HEAP8[($5 + 1 | 0) >> 0] | 0 | 0) <= (-65 | 0)) {
         break label$11
        }
        if (($6 + -1 | 0) >>> 0 < 6 >>> 0) {
         break label$7
        }
        bech32__check_hrp__h41cbe4782f1256ab($3 + 48 | 0 | 0, $1 | 0, $4 | 0);
        label$13 : {
         if ((HEAPU8[($3 + 48 | 0) >> 0] | 0 | 0) == (1 | 0)) {
          break label$13
         }
         $5 = $5 + 1 | 0;
         $6 = HEAPU8[($3 + 49 | 0) >> 0] | 0;
         HEAP8[($3 + 31 | 0) >> 0] = $6;
         label$14 : {
          label$15 : {
           if ($6) {
            break label$15
           }
           alloc__str___impl_20str___to_lowercase__hacad3ae1919ab6b6($3 + 32 | 0 | 0, $1 | 0, $4 | 0);
           break label$14;
          }
          alloc__raw_vec__RawVec_T_2cA___allocate_in__he85a33ecfd36769f($3 + 8 | 0 | 0, $4 | 0, 0 | 0);
          HEAP32[($3 + 36 | 0) >> 2] = HEAP32[($3 + 12 | 0) >> 2] | 0;
          $6 = HEAP32[($3 + 8 | 0) >> 2] | 0;
          HEAP32[($3 + 32 | 0) >> 2] = $6;
          memcpy($6 | 0, $1 | 0, $4 | 0) | 0;
          HEAP32[($3 + 40 | 0) >> 2] = $4;
         }
         HEAP32[($3 + 68 | 0) >> 2] = $1 + $2 | 0;
         HEAP32[($3 + 64 | 0) >> 2] = $5;
         HEAP32[($3 + 72 | 0) >> 2] = $3 + 31 | 0;
         core__iter__adapters__process_results__h19ecc9ffa7017f7f($3 + 48 | 0 | 0, $3 + 64 | 0 | 0);
         if ((HEAP32[($3 + 48 | 0) >> 2] | 0 | 0) == (1 | 0)) {
          break label$9
         }
         $7 = HEAP32[($3 + 60 | 0) >> 2] | 0;
         $8 = HEAP32[($3 + 56 | 0) >> 2] | 0;
         $9 = HEAP32[($3 + 52 | 0) >> 2] | 0;
         $6 = HEAP32[($3 + 32 | 0) >> 2] | 0;
         $10 = HEAP32[($3 + 40 | 0) >> 2] | 0;
         i64toi32_i32$1 = $3;
         i64toi32_i32$0 = 0;
         HEAP32[($3 + 52 | 0) >> 2] = 0;
         HEAP32[($3 + 56 | 0) >> 2] = i64toi32_i32$0;
         $4 = 0;
         HEAP32[($3 + 48 | 0) >> 2] = HEAP32[(0 + 1138240 | 0) >> 2] | 0;
         label$16 : {
          label$17 : {
           if (!$10) {
            break label$17
           }
           $1 = 0;
           $5 = $10;
           $4 = 0;
           $2 = $6;
           label$18 : while (1) {
            $11 = (HEAPU8[$2 >> 0] | 0) >>> 5 | 0;
            label$19 : {
             if (($4 | 0) != ($1 | 0)) {
              break label$19
             }
             alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hace6da240d5ba1ef($3 + 48 | 0 | 0, $1 | 0, 1 | 0);
             $4 = HEAP32[($3 + 56 | 0) >> 2] | 0;
            }
            $2 = $2 + 1 | 0;
            HEAP8[((HEAP32[($3 + 48 | 0) >> 2] | 0) + $4 | 0) >> 0] = $11;
            $4 = (HEAP32[($3 + 56 | 0) >> 2] | 0) + 1 | 0;
            HEAP32[($3 + 56 | 0) >> 2] = $4;
            $1 = HEAP32[($3 + 52 | 0) >> 2] | 0;
            $5 = $5 + -1 | 0;
            if ($5) {
             continue label$18
            }
            break label$18;
           };
           if (($4 | 0) != ($1 | 0)) {
            break label$16
           }
          }
          alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hace6da240d5ba1ef($3 + 48 | 0 | 0, $4 | 0, 1 | 0);
          $4 = HEAP32[($3 + 56 | 0) >> 2] | 0;
         }
         HEAP8[((HEAP32[($3 + 48 | 0) >> 2] | 0) + $4 | 0) >> 0] = 0;
         $5 = 1;
         $4 = (HEAP32[($3 + 56 | 0) >> 2] | 0) + 1 | 0;
         HEAP32[($3 + 56 | 0) >> 2] = $4;
         label$20 : {
          if (!$10) {
           break label$20
          }
          label$21 : while (1) {
           $2 = (HEAPU8[$6 >> 0] | 0) & 31 | 0;
           label$22 : {
            if (($4 | 0) != (HEAP32[($3 + 52 | 0) >> 2] | 0 | 0)) {
             break label$22
            }
            alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hace6da240d5ba1ef($3 + 48 | 0 | 0, $4 | 0, 1 | 0);
            $4 = HEAP32[($3 + 56 | 0) >> 2] | 0;
           }
           $6 = $6 + 1 | 0;
           HEAP8[((HEAP32[($3 + 48 | 0) >> 2] | 0) + $4 | 0) >> 0] = $2;
           $4 = (HEAP32[($3 + 56 | 0) >> 2] | 0) + 1 | 0;
           HEAP32[($3 + 56 | 0) >> 2] = $4;
           $10 = $10 + -1 | 0;
           if ($10) {
            continue label$21
           }
           break label$21;
          };
         }
         $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend__T_2ccore__slice__iter__Iter_T_____spec_extend__hd63284b6e6fa3c45($3 + 48 | 0 | 0, $9 | 0, $9 + $7 | 0 | 0);
         $12 = HEAP32[($3 + 48 | 0) >> 2] | 0;
         label$23 : {
          $4 = HEAP32[($3 + 56 | 0) >> 2] | 0;
          if (!$4) {
           break label$23
          }
          $10 = $12 + $4 | 0;
          $4 = $12 + 1 | 0;
          $5 = 1;
          $11 = $12;
          label$24 : while (1) {
           $2 = $11;
           $11 = $4;
           $6 = $5 >>> 25 | 0;
           $5 = (($5 << 5 | 0) & 1073741792 | 0) ^ (HEAPU8[$2 >> 0] | 0) | 0;
           $4 = 0;
           $1 = 1138480;
           label$25 : while (1) {
            $2 = $4 + 1 | 0;
            label$26 : {
             if (!(($6 >>> ($4 & 255 | 0) | 0) & 1 | 0)) {
              break label$26
             }
             $5 = (HEAP32[$1 >> 2] | 0) ^ $5 | 0;
            }
            $1 = $1 + 4 | 0;
            $4 = $2;
            if (($4 | 0) != (5 | 0)) {
             continue label$25
            }
            break label$25;
           };
           $4 = $11 + 1 | 0;
           if (($11 | 0) != ($10 | 0)) {
            continue label$24
           }
           break label$24;
          };
         }
         label$27 : {
          $4 = HEAP32[($3 + 52 | 0) >> 2] | 0;
          if (!$4) {
           break label$27
          }
          __rust_dealloc($12 | 0, $4 | 0, 1 | 0);
         }
         label$28 : {
          if (($5 | 0) != (1 | 0)) {
           break label$28
          }
          i64toi32_i32$0 = HEAP32[($3 + 32 | 0) >> 2] | 0;
          i64toi32_i32$1 = HEAP32[($3 + 36 | 0) >> 2] | 0;
          $274 = i64toi32_i32$0;
          i64toi32_i32$0 = $0;
          HEAP32[($0 + 4 | 0) >> 2] = $274;
          HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$1;
          HEAP32[$0 >> 2] = 0;
          HEAP32[($0 + 20 | 0) >> 2] = $8;
          HEAP32[($0 + 16 | 0) >> 2] = $9;
          HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($3 + 40 | 0) >> 2] | 0;
          $4 = $7 + -6 | 0;
          HEAP32[($0 + 24 | 0) >> 2] = $7 >>> 0 < $4 >>> 0 ? $7 : $4;
          break label$1;
         }
         HEAP32[$0 >> 2] = 1;
         HEAP8[($0 + 4 | 0) >> 0] = 1;
         if (!$8) {
          break label$8
         }
         __rust_dealloc($9 | 0, $8 | 0, 1 | 0);
         break label$8;
        }
        i64toi32_i32$1 = HEAP32[($3 + 52 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[($3 + 56 | 0) >> 2] | 0;
        $13 = i64toi32_i32$1;
        HEAP32[$0 >> 2] = 1;
        i64toi32_i32$1 = $0;
        HEAP32[($0 + 4 | 0) >> 2] = $13;
        HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$0;
        break label$1;
       }
       core__str__slice_error_fail__h8a7d2e23b7bba52e($5 | 0, $6 | 0, 1 | 0, $6 | 0, 1138620 | 0);
       abort();
      }
      core__str__slice_error_fail__h8a7d2e23b7bba52e($1 | 0, $2 | 0, 0 | 0, $4 | 0, 1138208 | 0);
      abort();
     }
     i64toi32_i32$0 = HEAP32[($3 + 52 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($3 + 56 | 0) >> 2] | 0;
     $13 = i64toi32_i32$0;
     HEAP32[$0 >> 2] = 1;
     i64toi32_i32$0 = $0;
     HEAP32[($0 + 4 | 0) >> 2] = $13;
     HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$1;
    }
    $4 = HEAP32[($3 + 36 | 0) >> 2] | 0;
    if (!$4) {
     break label$1
    }
    __rust_dealloc(HEAP32[($3 + 32 | 0) >> 2] | 0 | 0, $4 | 0, 1 | 0);
    break label$1;
   }
   HEAP32[$0 >> 2] = 1;
   HEAP8[($0 + 4 | 0) >> 0] = 2;
  }
  global$0 = $3 + 80 | 0;
 }
 
 function ryu__d2s__d2d__hbd078b293d767eaa($0, $1, $1$hi, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $1$hi = $1$hi | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$5 = 0, i64toi32_i32$2 = 0, $9$hi = 0, $9 = 0, $6 = 0, $5 = 0, $13 = 0, $13$hi = 0, $11 = 0, $11$hi = 0, $7 = 0, $14$hi = 0, $14 = 0, $8 = 0, $3 = 0, $12 = 0, $12$hi = 0, $4 = 0, $10$hi = 0, $10 = 0, i64toi32_i32$6 = 0, $41 = 0, $42 = 0, $24$hi = 0, $43 = 0, $153$hi = 0, $157$hi = 0, $177 = 0, $177$hi = 0, $179$hi = 0, $181 = 0, $181$hi = 0, $330 = 0, $335 = 0, $345 = 0, $348$hi = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  i64toi32_i32$0 = $1$hi;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 0;
  $4 = ($1 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | 0 | $2 >>> 0 < 2 >>> 0 | 0;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$3 = $1;
  i64toi32_i32$0 = 1048576;
  i64toi32_i32$1 = 0;
  i64toi32_i32$0 = $1$hi | i64toi32_i32$0 | 0;
  $24$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $1$hi;
  i64toi32_i32$4 = $2;
  i64toi32_i32$0 = $24$hi;
  $43 = i64toi32_i32$3 | i64toi32_i32$1 | 0;
  i64toi32_i32$3 = $1$hi;
  i64toi32_i32$1 = i64toi32_i32$4 ? $43 : $1;
  i64toi32_i32$2 = i64toi32_i32$4 ? i64toi32_i32$0 : i64toi32_i32$3;
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$2;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  i64toi32_i32$0 = 2;
  i64toi32_i32$3 = i64toi32_i32$0 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$4 << i64toi32_i32$3 | 0;
   $41 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$3 | 0) - 1 | 0) & (i64toi32_i32$4 >>> (32 - i64toi32_i32$3 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$3 | 0) | 0;
   $41 = i64toi32_i32$4 << i64toi32_i32$3 | 0;
  }
  $1 = $41;
  $1$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$4 = 0;
  i64toi32_i32$0 = 1;
  i64toi32_i32$4 = i64toi32_i32$1 & i64toi32_i32$4 | 0;
  $10 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
  $10$hi = i64toi32_i32$4;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         $5 = $2 ? $2 + -1077 | 0 : -1076;
         if (($5 | 0) > (-1 | 0)) {
          break label$7
         }
         $6 = 1;
         $7 = 0 - $5 | 0;
         $2 = (Math_imul($5, -732923) >>> 20 | 0) - (($7 | 0) > (1 | 0)) | 0;
         $8 = $2 + $5 | 0;
         i64toi32_i32$4 = $9$hi;
         $7 = $7 - $2 | 0;
         i64toi32_i32$4 = ryu__d2s_intrinsics__mul_shift_all_64__h708821f1b5e45ccf($9 | 0, i64toi32_i32$4 | 0, ($7 << 4 | 0) + 1095088 | 0 | 0, ($2 - (Math_imul($7, 1217359) >>> 19 | 0) | 0) + 124 | 0 | 0, $3 | 0, $3 + 8 | 0 | 0, $4 | 0) | 0;
         i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
         $11 = i64toi32_i32$4;
         $11$hi = i64toi32_i32$2;
         i64toi32_i32$1 = $3;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] | 0;
         i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] | 0;
         $12 = i64toi32_i32$2;
         $12$hi = i64toi32_i32$4;
         i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
         $9 = i64toi32_i32$4;
         $9$hi = i64toi32_i32$2;
         if ($2 >>> 0 >= 2 >>> 0) {
          break label$6
         }
         i64toi32_i32$2 = $9$hi;
         i64toi32_i32$2 = $10$hi;
         i64toi32_i32$2 = $9$hi;
         i64toi32_i32$1 = $9;
         i64toi32_i32$4 = $10$hi;
         i64toi32_i32$0 = $10;
         i64toi32_i32$3 = i64toi32_i32$1 - i64toi32_i32$0 | 0;
         i64toi32_i32$6 = i64toi32_i32$1 >>> 0 < i64toi32_i32$0 >>> 0;
         i64toi32_i32$5 = i64toi32_i32$6 + i64toi32_i32$4 | 0;
         i64toi32_i32$5 = i64toi32_i32$2 - i64toi32_i32$5 | 0;
         $9 = i64toi32_i32$3;
         $9$hi = i64toi32_i32$5;
         $7 = 0;
         i64toi32_i32$5 = i64toi32_i32$4;
         i64toi32_i32$5 = i64toi32_i32$4;
         if (!($4 & !(i64toi32_i32$0 | i64toi32_i32$4 | 0) | 0)) {
          break label$2
         }
         break label$3;
        }
        i64toi32_i32$5 = $9$hi;
        $8 = (Math_imul($5, 78913) >>> 18 | 0) - (($5 | 0) > (3 | 0)) | 0;
        i64toi32_i32$5 = ryu__d2s_intrinsics__mul_shift_all_64__h708821f1b5e45ccf($9 | 0, i64toi32_i32$5 | 0, ($8 << 4 | 0) + 1089616 | 0 | 0, (($8 - $5 | 0) + (Math_imul($8, 1217359) >>> 19 | 0) | 0) + 125 | 0 | 0, $3 | 0, $3 + 8 | 0 | 0, $4 | 0) | 0;
        i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
        $11 = i64toi32_i32$5;
        $11$hi = i64toi32_i32$1;
        i64toi32_i32$2 = $3;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
        i64toi32_i32$5 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
        $12 = i64toi32_i32$1;
        $12$hi = i64toi32_i32$5;
        i64toi32_i32$5 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $9 = i64toi32_i32$5;
        $9$hi = i64toi32_i32$1;
        if ($8 >>> 0 > 21 >>> 0) {
         break label$5
        }
        label$8 : {
         i64toi32_i32$1 = $1$hi;
         i64toi32_i32$5 = 0;
         i64toi32_i32$5 = __wasm_i64_udiv($1 | 0, i64toi32_i32$1 | 0, 5 | 0, i64toi32_i32$5 | 0) | 0;
         i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
         i64toi32_i32$1 = $1$hi;
         if ((Math_imul(i64toi32_i32$5, -5) | 0) != (0 - $1 | 0 | 0)) {
          break label$8
         }
         $2 = -1;
         label$9 : while (1) {
          i64toi32_i32$1 = $1$hi;
          $6 = $1;
          $2 = $2 + 1 | 0;
          i64toi32_i32$5 = 0;
          i64toi32_i32$5 = __wasm_i64_udiv($1 | 0, i64toi32_i32$1 | 0, 5 | 0, i64toi32_i32$5 | 0) | 0;
          i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
          $1 = i64toi32_i32$5;
          $1$hi = i64toi32_i32$1;
          if ((Math_imul(i64toi32_i32$5, -5) | 0) == (0 - $6 | 0 | 0)) {
           continue label$9
          }
          break label$9;
         };
         if ($2 >>> 0 < $8 >>> 0) {
          break label$5
         }
         break label$4;
        }
        label$10 : {
         i64toi32_i32$1 = $10$hi;
         if (!($10 | i64toi32_i32$1 | 0)) {
          break label$10
         }
         i64toi32_i32$1 = $1$hi;
         i64toi32_i32$2 = $1;
         i64toi32_i32$5 = 0;
         i64toi32_i32$0 = 2;
         i64toi32_i32$5 = i64toi32_i32$1 | i64toi32_i32$5 | 0;
         $1 = $1 | i64toi32_i32$0 | 0;
         $1$hi = i64toi32_i32$5;
         $2 = -1;
         label$11 : while (1) {
          i64toi32_i32$5 = $1$hi;
          $6 = $1;
          $2 = $2 + 1 | 0;
          i64toi32_i32$2 = 0;
          i64toi32_i32$2 = __wasm_i64_udiv($1 | 0, i64toi32_i32$5 | 0, 5 | 0, i64toi32_i32$2 | 0) | 0;
          i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
          $1 = i64toi32_i32$2;
          $1$hi = i64toi32_i32$5;
          if ((Math_imul($1, -5) | 0) == (0 - $6 | 0 | 0)) {
           continue label$11
          }
          break label$11;
         };
         i64toi32_i32$5 = $9$hi;
         i64toi32_i32$5 = 0;
         $153$hi = i64toi32_i32$5;
         i64toi32_i32$5 = $9$hi;
         i64toi32_i32$1 = $9;
         i64toi32_i32$2 = $153$hi;
         i64toi32_i32$0 = $2 >>> 0 >= $8 >>> 0;
         i64toi32_i32$4 = i64toi32_i32$1 - i64toi32_i32$0 | 0;
         i64toi32_i32$6 = i64toi32_i32$1 >>> 0 < i64toi32_i32$0 >>> 0;
         i64toi32_i32$3 = i64toi32_i32$6 + i64toi32_i32$2 | 0;
         i64toi32_i32$3 = i64toi32_i32$5 - i64toi32_i32$3 | 0;
         $9 = i64toi32_i32$4;
         $9$hi = i64toi32_i32$3;
         break label$5;
        }
        i64toi32_i32$3 = 0;
        i64toi32_i32$5 = $4;
        i64toi32_i32$1 = -1;
        i64toi32_i32$0 = -1;
        i64toi32_i32$1 = i64toi32_i32$3 ^ i64toi32_i32$1 | 0;
        $157$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $1$hi;
        i64toi32_i32$1 = $157$hi;
        i64toi32_i32$3 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
        i64toi32_i32$5 = $1$hi;
        i64toi32_i32$0 = $1;
        i64toi32_i32$2 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
        i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
        if (i64toi32_i32$2 >>> 0 < i64toi32_i32$0 >>> 0) {
         i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
        }
        $1 = i64toi32_i32$2;
        $1$hi = i64toi32_i32$4;
        $2 = -1;
        label$12 : while (1) {
         i64toi32_i32$4 = $1$hi;
         $6 = $1;
         $2 = $2 + 1 | 0;
         i64toi32_i32$3 = 0;
         i64toi32_i32$3 = __wasm_i64_udiv($1 | 0, i64toi32_i32$4 | 0, 5 | 0, i64toi32_i32$3 | 0) | 0;
         i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
         $1 = i64toi32_i32$3;
         $1$hi = i64toi32_i32$4;
         if ((Math_imul(i64toi32_i32$3, -5) | 0) == (0 - $6 | 0 | 0)) {
          continue label$12
         }
         break label$12;
        };
        if ($2 >>> 0 >= $8 >>> 0) {
         break label$3
        }
        break label$5;
       }
       if ($2 >>> 0 > 62 >>> 0) {
        break label$5
       }
       i64toi32_i32$4 = $1$hi;
       $177 = $1;
       $177$hi = i64toi32_i32$4;
       i64toi32_i32$4 = 0;
       $179$hi = i64toi32_i32$4;
       i64toi32_i32$4 = -1;
       i64toi32_i32$1 = -1;
       i64toi32_i32$3 = $179$hi;
       i64toi32_i32$0 = $2;
       i64toi32_i32$5 = i64toi32_i32$0 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
        i64toi32_i32$3 = i64toi32_i32$1 << i64toi32_i32$5 | 0;
        $42 = 0;
       } else {
        i64toi32_i32$3 = ((1 << i64toi32_i32$5 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$5 | 0) | 0) | 0 | (i64toi32_i32$4 << i64toi32_i32$5 | 0) | 0;
        $42 = i64toi32_i32$1 << i64toi32_i32$5 | 0;
       }
       i64toi32_i32$4 = $42;
       i64toi32_i32$1 = -1;
       i64toi32_i32$0 = -1;
       i64toi32_i32$1 = i64toi32_i32$3 ^ i64toi32_i32$1 | 0;
       $181 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
       $181$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $177$hi;
       i64toi32_i32$3 = $177;
       i64toi32_i32$4 = $181$hi;
       i64toi32_i32$0 = $181;
       i64toi32_i32$4 = i64toi32_i32$1 & i64toi32_i32$4 | 0;
       if (!(i64toi32_i32$3 & i64toi32_i32$0 | 0 | i64toi32_i32$4 | 0)) {
        break label$4
       }
      }
      $2 = 0;
      label$13 : {
       label$14 : {
        i64toi32_i32$4 = $9$hi;
        i64toi32_i32$3 = 0;
        i64toi32_i32$3 = __wasm_i64_udiv($9 | 0, i64toi32_i32$4 | 0, 100 | 0, i64toi32_i32$3 | 0) | 0;
        i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
        $13 = i64toi32_i32$3;
        $13$hi = i64toi32_i32$4;
        i64toi32_i32$4 = $12$hi;
        i64toi32_i32$3 = 0;
        i64toi32_i32$3 = __wasm_i64_udiv($12 | 0, i64toi32_i32$4 | 0, 100 | 0, i64toi32_i32$3 | 0) | 0;
        i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
        $14 = i64toi32_i32$3;
        $14$hi = i64toi32_i32$4;
        i64toi32_i32$4 = $13$hi;
        i64toi32_i32$1 = $13;
        i64toi32_i32$3 = $14$hi;
        i64toi32_i32$0 = $14;
        if (i64toi32_i32$4 >>> 0 > i64toi32_i32$3 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$1 >>> 0 > i64toi32_i32$0 >>> 0 | 0) | 0) {
         break label$14
        }
        i64toi32_i32$1 = $12$hi;
        $14 = $12;
        $14$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $9$hi;
        $13 = $9;
        $13$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $11$hi;
        $1 = $11;
        $1$hi = i64toi32_i32$1;
        $6 = 0;
        break label$13;
       }
       i64toi32_i32$1 = $11$hi;
       i64toi32_i32$4 = 0;
       i64toi32_i32$4 = __wasm_i64_udiv($11 | 0, i64toi32_i32$1 | 0, 100 | 0, i64toi32_i32$4 | 0) | 0;
       i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
       $1 = i64toi32_i32$4;
       $1$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $11$hi;
       $6 = (Math_imul(i64toi32_i32$4, -100) + $11 | 0) >>> 0 > 49 >>> 0;
       $2 = 2;
      }
      label$15 : {
       i64toi32_i32$1 = $13$hi;
       i64toi32_i32$4 = 0;
       i64toi32_i32$4 = __wasm_i64_udiv($13 | 0, i64toi32_i32$1 | 0, 10 | 0, i64toi32_i32$4 | 0) | 0;
       i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
       $9 = i64toi32_i32$4;
       $9$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $14$hi;
       i64toi32_i32$4 = 0;
       i64toi32_i32$4 = __wasm_i64_udiv($14 | 0, i64toi32_i32$1 | 0, 10 | 0, i64toi32_i32$4 | 0) | 0;
       i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
       $13 = i64toi32_i32$4;
       $13$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $9$hi;
       i64toi32_i32$0 = $9;
       i64toi32_i32$4 = $13$hi;
       i64toi32_i32$3 = $13;
       if (i64toi32_i32$1 >>> 0 < i64toi32_i32$4 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$4 | 0) & i64toi32_i32$0 >>> 0 <= i64toi32_i32$3 >>> 0 | 0) | 0) {
        break label$15
       }
       label$16 : while (1) {
        $2 = $2 + 1 | 0;
        i64toi32_i32$0 = $1$hi;
        $11 = $1;
        $11$hi = i64toi32_i32$0;
        i64toi32_i32$1 = 0;
        i64toi32_i32$1 = __wasm_i64_udiv($1 | 0, i64toi32_i32$0 | 0, 10 | 0, i64toi32_i32$1 | 0) | 0;
        i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
        $1 = i64toi32_i32$1;
        $1$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $9$hi;
        i64toi32_i32$1 = 0;
        i64toi32_i32$1 = __wasm_i64_udiv($9 | 0, i64toi32_i32$0 | 0, 10 | 0, i64toi32_i32$1 | 0) | 0;
        i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
        $9 = i64toi32_i32$1;
        $9$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $13$hi;
        $14 = $13;
        $14$hi = i64toi32_i32$0;
        i64toi32_i32$1 = 0;
        i64toi32_i32$1 = __wasm_i64_udiv($13 | 0, i64toi32_i32$0 | 0, 10 | 0, i64toi32_i32$1 | 0) | 0;
        i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
        $13 = i64toi32_i32$1;
        $13$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $9$hi;
        i64toi32_i32$3 = $9;
        i64toi32_i32$1 = $13$hi;
        i64toi32_i32$4 = $13;
        if (i64toi32_i32$0 >>> 0 > i64toi32_i32$1 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$3 >>> 0 > i64toi32_i32$4 >>> 0 | 0) | 0) {
         continue label$16
        }
        break label$16;
       };
       i64toi32_i32$3 = $1$hi;
       i64toi32_i32$3 = $11$hi;
       $6 = (Math_imul($1, -10) + $11 | 0) >>> 0 > 4 >>> 0;
      }
      i64toi32_i32$3 = $1$hi;
      i64toi32_i32$3 = $14$hi;
      i64toi32_i32$3 = $1$hi;
      i64toi32_i32$4 = $1;
      i64toi32_i32$0 = $14$hi;
      i64toi32_i32$1 = $14;
      $6 = (i64toi32_i32$4 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) | 0 | $6 | 0;
      break label$1;
     }
     $7 = 0;
     $6 = 1;
     break label$2;
    }
    $6 = $5 >>> 31 | 0;
    $7 = 1;
   }
   $5 = 0;
   label$17 : {
    label$18 : {
     i64toi32_i32$4 = $9$hi;
     i64toi32_i32$3 = 0;
     i64toi32_i32$3 = __wasm_i64_udiv($9 | 0, i64toi32_i32$4 | 0, 10 | 0, i64toi32_i32$3 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $1 = i64toi32_i32$3;
     $1$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $12$hi;
     i64toi32_i32$3 = 0;
     i64toi32_i32$3 = __wasm_i64_udiv($12 | 0, i64toi32_i32$4 | 0, 10 | 0, i64toi32_i32$3 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $14 = i64toi32_i32$3;
     $14$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $1$hi;
     i64toi32_i32$1 = $1;
     i64toi32_i32$3 = $14$hi;
     i64toi32_i32$0 = $14;
     if (i64toi32_i32$4 >>> 0 > i64toi32_i32$3 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$1 >>> 0 > i64toi32_i32$0 >>> 0 | 0) | 0) {
      break label$18
     }
     $2 = 0;
     i64toi32_i32$1 = $12$hi;
     $9 = $12;
     $9$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $11$hi;
     $13 = $11;
     $13$hi = i64toi32_i32$1;
     break label$17;
    }
    $2 = 0;
    $5 = 0;
    label$19 : while (1) {
     i64toi32_i32$1 = $14$hi;
     $9 = $14;
     $9$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $12$hi;
     $7 = $7 & (Math_imul($9, -10) | 0) == (0 - $12 | 0 | 0) | 0;
     $2 = $2 + 1 | 0;
     $6 = $6 & !($5 & 255 | 0) | 0;
     i64toi32_i32$1 = $11$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_i64_udiv($11 | 0, i64toi32_i32$1 | 0, 10 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $13 = i64toi32_i32$4;
     $13$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $11$hi;
     $5 = Math_imul(i64toi32_i32$4, -10) + $11 | 0;
     i64toi32_i32$1 = $13$hi;
     $11 = i64toi32_i32$4;
     $11$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $9$hi;
     $12 = $9;
     $12$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $1$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_i64_udiv($1 | 0, i64toi32_i32$1 | 0, 10 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $1 = i64toi32_i32$4;
     $1$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $9$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_i64_udiv($9 | 0, i64toi32_i32$1 | 0, 10 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $14 = i64toi32_i32$4;
     $14$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $1$hi;
     i64toi32_i32$0 = $1;
     i64toi32_i32$4 = $14$hi;
     i64toi32_i32$3 = $14;
     if (i64toi32_i32$1 >>> 0 > i64toi32_i32$4 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$4 | 0) & i64toi32_i32$0 >>> 0 > i64toi32_i32$3 >>> 0 | 0) | 0) {
      continue label$19
     }
     break label$19;
    };
   }
   label$20 : {
    label$21 : {
     if (!$7) {
      break label$21
     }
     i64toi32_i32$0 = $9$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_i64_udiv($9 | 0, i64toi32_i32$0 | 0, 10 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $11 = i64toi32_i32$1;
     $11$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $9$hi;
     if ((Math_imul(i64toi32_i32$1, -10) | 0) != (0 - $9 | 0 | 0)) {
      break label$21
     }
     label$22 : while (1) {
      $2 = $2 + 1 | 0;
      $6 = $6 & !($5 & 255 | 0) | 0;
      i64toi32_i32$0 = $13$hi;
      i64toi32_i32$1 = 0;
      i64toi32_i32$1 = __wasm_i64_udiv($13 | 0, i64toi32_i32$0 | 0, 10 | 0, i64toi32_i32$1 | 0) | 0;
      i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
      $1 = i64toi32_i32$1;
      $1$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $13$hi;
      $5 = Math_imul(i64toi32_i32$1, -10) + $13 | 0;
      i64toi32_i32$0 = $1$hi;
      $13 = i64toi32_i32$1;
      $13$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $11$hi;
      $9 = $11;
      $9$hi = i64toi32_i32$0;
      i64toi32_i32$1 = 0;
      i64toi32_i32$1 = __wasm_i64_udiv($9 | 0, i64toi32_i32$0 | 0, 10 | 0, i64toi32_i32$1 | 0) | 0;
      i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
      $11 = i64toi32_i32$1;
      $11$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $9$hi;
      if ((Math_imul(i64toi32_i32$1, -10) | 0) == (0 - $9 | 0 | 0)) {
       continue label$22
      }
      break label$20;
     };
    }
    i64toi32_i32$0 = $13$hi;
    $1 = $13;
    $1$hi = i64toi32_i32$0;
   }
   $5 = $5 & 255 | 0;
   i64toi32_i32$0 = $1$hi;
   i64toi32_i32$3 = $1;
   i64toi32_i32$1 = 0;
   i64toi32_i32$4 = 1;
   i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
   $330 = $5 >>> 0 > 4 >>> 0 ^ ((($5 | 0) == (5 | 0) & $6 | 0) & !(i64toi32_i32$3 & i64toi32_i32$4 | 0 | i64toi32_i32$1 | 0) | 0) | 0;
   i64toi32_i32$1 = $10$hi;
   i64toi32_i32$0 = $10;
   i64toi32_i32$3 = 0;
   i64toi32_i32$4 = 0;
   $335 = (i64toi32_i32$0 | 0) != (i64toi32_i32$4 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$3 | 0) | 0 | ($7 ^ -1 | 0) | 0;
   i64toi32_i32$0 = $1$hi;
   i64toi32_i32$0 = $9$hi;
   i64toi32_i32$0 = $1$hi;
   i64toi32_i32$4 = $1;
   i64toi32_i32$1 = $9$hi;
   i64toi32_i32$3 = $9;
   $6 = $330 | ($335 & ((i64toi32_i32$4 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) | 0) | 0;
  }
  HEAP32[($0 + 8 | 0) >> 2] = $2 + $8 | 0;
  $345 = $0;
  i64toi32_i32$4 = $1$hi;
  i64toi32_i32$4 = 0;
  $348$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $1$hi;
  i64toi32_i32$3 = $1;
  i64toi32_i32$0 = $348$hi;
  i64toi32_i32$1 = $6;
  i64toi32_i32$5 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  i64toi32_i32$3 = $345;
  HEAP32[i64toi32_i32$3 >> 2] = i64toi32_i32$5;
  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
  global$0 = $3 + 16 | 0;
 }
 
 function $cardano_serialization_lib__TransactionBody_20as_20core__clone__Clone___clone__h8541427cda4fbd03($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $2 = 0, $4 = 0, $6 = 0, $54 = 0, $55 = 0, $56 = 0, $57 = 0, $58 = 0, $59 = 0, $60 = 0, $61 = 0, $3 = 0, $5 = 0, $7 = 0, $8 = 0, $8$hi = 0, $9 = 0, $9$hi = 0, $10 = 0, $10$hi = 0, $67 = 0, $80 = 0, $85 = 0, $88 = 0, $92 = 0, $103 = 0, $108 = 0, $113 = 0, $117 = 0, $11 = 0, $11$hi = 0, $12 = 0, $12$hi = 0, $142 = 0, $147 = 0, $152 = 0, $156 = 0, $173 = 0, $176 = 0, $183 = 0, $228 = 0, $231 = 0, $235 = 0, $241 = 0, $247 = 0, $251 = 0, $257 = 0, $263 = 0, $269 = 0, $279 = 0, $285 = 0, $289 = 0, $295 = 0, $301 = 0, $307 = 0, $310 = 0, $331 = 0;
  $2 = global$0 - 272 | 0;
  global$0 = $2;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hfe677107e1954f8f($2 + 8 | 0 | 0, $1 + 128 | 0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h699bb0f3db607312($2 + 24 | 0 | 0, $1 + 140 | 0 | 0);
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    if (HEAP32[(i64toi32_i32$2 + 152 | 0) >> 2] | 0) {
     break label$2
    }
    HEAP32[($2 + 40 | 0) >> 2] = 0;
    break label$1;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h965baa5031061a2e($2 + 40 | 0 | 0, $1 + 152 | 0 | 0);
  }
  label$3 : {
   label$4 : {
    if (HEAP32[($1 + 44 | 0) >> 2] | 0) {
     break label$4
    }
    HEAP32[($2 + 76 | 0) >> 2] = 0;
    break label$3;
   }
   $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h8cac34049618832f($2 + 56 | 0 | 0, $1 + 24 | 0 | 0);
  }
  $3 = 0;
  $4 = 0;
  label$5 : {
   if (!(HEAP32[($1 + 84 | 0) >> 2] | 0)) {
    break label$5
   }
   $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h847b9d84e24adaa5($2 + 224 | 0 | 0, $1 + 64 | 0 | 0);
   $4 = $2 + 264 | 0;
   HEAP32[$4 >> 2] = HEAP32[($1 + 104 | 0) >> 2] | 0;
   i64toi32_i32$2 = ($2 + 224 | 0) + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $67 = i64toi32_i32$1;
   i64toi32_i32$1 = ($2 + 120 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $67;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[(($2 + 120 | 0) + 16 | 0) >> 2] = HEAP32[(($2 + 224 | 0) + 16 | 0) >> 2] | 0;
   i64toi32_i32$2 = $2 + 256 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $80 = i64toi32_i32$0;
   i64toi32_i32$0 = ($2 + 96 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $80;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $4;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $85 = i64toi32_i32$1;
   i64toi32_i32$1 = ($2 + 96 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $85;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 224 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 228 | 0) >> 2] | 0;
   $88 = i64toi32_i32$0;
   i64toi32_i32$0 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$0 + 120 | 0) >> 2] = $88;
   HEAP32[(i64toi32_i32$0 + 124 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = i64toi32_i32$0 + 248 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $92 = i64toi32_i32$1;
   i64toi32_i32$1 = $2;
   HEAP32[(i64toi32_i32$1 + 96 | 0) >> 2] = $92;
   HEAP32[(i64toi32_i32$1 + 100 | 0) >> 2] = i64toi32_i32$0;
   $4 = HEAP32[(i64toi32_i32$1 + 244 | 0) >> 2] | 0;
  }
  label$6 : {
   if ((HEAPU8[($1 + 204 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$6
   }
   i64toi32_i32$2 = $1 + 229 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $103 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 168 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $103;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1 + 221 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $108 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 160 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $108;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $1 + 213 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $113 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 152 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $113;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1 + 205 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $117 = i64toi32_i32$1;
   i64toi32_i32$1 = $2;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $117;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   $3 = 1;
  }
  i64toi32_i32$2 = $1 + 120 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $11 = i64toi32_i32$0;
  $11$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 112 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 116 | 0) >> 2] | 0;
  $12 = i64toi32_i32$1;
  $12$hi = i64toi32_i32$0;
  $5 = 0;
  $6 = 0;
  label$7 : {
   if ((HEAP32[(i64toi32_i32$2 + 164 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$7
   }
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h3d696390b8f8d3c9($2 + 176 | 0 | 4 | 0 | 0, $1 + 168 | 0 | 0);
   $6 = 1;
  }
  $7 = $1 + 180 | 0;
  HEAP32[($2 + 176 | 0) >> 2] = $6;
  label$8 : {
   if ((HEAPU8[($1 + 237 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$8
   }
   i64toi32_i32$2 = $1 + 262 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $142 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 248 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $142;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1 + 254 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $147 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 240 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $147;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $1 + 246 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $152 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 232 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $152;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1 + 238 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $156 = i64toi32_i32$1;
   i64toi32_i32$1 = $2;
   HEAP32[(i64toi32_i32$1 + 224 | 0) >> 2] = $156;
   HEAP32[(i64toi32_i32$1 + 228 | 0) >> 2] = i64toi32_i32$0;
   $5 = 1;
  }
  $6 = $1 + 192 | 0;
  label$9 : {
   label$10 : {
    if (HEAP32[$7 >> 2] | 0) {
     break label$10
    }
    HEAP32[($2 + 192 | 0) >> 2] = 0;
    break label$9;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hfe677107e1954f8f($2 + 192 | 0 | 0, $7 | 0);
  }
  label$11 : {
   label$12 : {
    if (HEAP32[$6 >> 2] | 0) {
     break label$12
    }
    HEAP32[($2 + 208 | 0) >> 2] = 0;
    break label$11;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h25db889dc58a550d($2 + 208 | 0 | 0, $6 | 0);
  }
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $173 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 128 | 0) >> 2] = $173;
  HEAP32[(i64toi32_i32$0 + 132 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $176 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[(i64toi32_i32$1 + 140 | 0) >> 2] = $176;
  HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $9;
  HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  HEAP32[i64toi32_i32$1 >> 2] = $10;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] | 0;
  $183 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 152 | 0) >> 2] = $183;
  HEAP32[(i64toi32_i32$0 + 156 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = i64toi32_i32$0 + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($0 + 136 | 0) >> 2] = HEAP32[((i64toi32_i32$2 + 8 | 0) + 8 | 0) >> 2] | 0;
  HEAP32[($0 + 148 | 0) >> 2] = HEAP32[((i64toi32_i32$2 + 24 | 0) + 8 | 0) >> 2] | 0;
  HEAP32[($0 + 160 | 0) >> 2] = HEAP32[((i64toi32_i32$2 + 40 | 0) + 8 | 0) >> 2] | 0;
  $1 = HEAPU8[($1 + 270 | 0) >> 0] | 0;
  memcpy($0 + 24 | 0 | 0, i64toi32_i32$2 + 56 | 0 | 0, 40 | 0) | 0;
  HEAP32[($0 + 84 | 0) >> 2] = $4;
  HEAP8[($0 + 204 | 0) >> 0] = $3;
  HEAP32[($0 + 80 | 0) >> 2] = HEAP32[((i64toi32_i32$2 + 120 | 0) + 16 | 0) >> 2] | 0;
  i64toi32_i32$2 = (i64toi32_i32$2 + 120 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $228 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 72 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $228;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 120 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 124 | 0) >> 2] | 0;
  $231 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 64 | 0) >> 2] = $231;
  HEAP32[(i64toi32_i32$0 + 68 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 100 | 0) >> 2] | 0;
  $235 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 88 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $235;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = (i64toi32_i32$2 + 96 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $241 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 96 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $241;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = ($2 + 96 | 0) + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $247 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 104 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $247;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 144 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 148 | 0) >> 2] | 0;
  $251 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 205 | 0;
  $54 = $251;
  HEAP8[i64toi32_i32$0 >> 0] = $54;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $54 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $54 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $54 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = (i64toi32_i32$2 + 144 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $257 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 213 | 0;
  $55 = $257;
  HEAP8[i64toi32_i32$1 >> 0] = $55;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $55 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $55 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $55 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = ($2 + 144 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $263 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 221 | 0;
  $56 = $263;
  HEAP8[i64toi32_i32$0 >> 0] = $56;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $56 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $56 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $56 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = ($2 + 144 | 0) + 24 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $269 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 229 | 0;
  $57 = $269;
  HEAP8[i64toi32_i32$1 >> 0] = $57;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $57 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $57 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $57 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$1 = $0 + 120 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $11;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$1 = $0;
  HEAP32[(i64toi32_i32$1 + 112 | 0) >> 2] = $12;
  HEAP32[(i64toi32_i32$1 + 116 | 0) >> 2] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 237 | 0) >> 0] = $5;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 176 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 180 | 0) >> 2] | 0;
  $279 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 164 | 0) >> 2] = $279;
  HEAP32[(i64toi32_i32$0 + 168 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = (i64toi32_i32$2 + 176 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $285 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 172 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $285;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 224 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 228 | 0) >> 2] | 0;
  $289 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 238 | 0;
  $58 = $289;
  HEAP8[i64toi32_i32$0 >> 0] = $58;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $58 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $58 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $58 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = (i64toi32_i32$2 + 224 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $295 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 246 | 0;
  $59 = $295;
  HEAP8[i64toi32_i32$1 >> 0] = $59;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $59 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $59 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $59 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = ($2 + 224 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $301 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 254 | 0;
  $60 = $301;
  HEAP8[i64toi32_i32$0 >> 0] = $60;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $60 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $60 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $60 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = ($2 + 224 | 0) + 24 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $307 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 262 | 0;
  $61 = $307;
  HEAP8[i64toi32_i32$1 >> 0] = $61;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $61 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $61 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $61 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 192 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 196 | 0) >> 2] | 0;
  $310 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 180 | 0) >> 2] = $310;
  HEAP32[(i64toi32_i32$0 + 184 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 188 | 0) >> 2] = HEAP32[((i64toi32_i32$2 + 192 | 0) + 8 | 0) >> 2] | 0;
  HEAP8[(i64toi32_i32$0 + 270 | 0) >> 0] = ($1 | 0) == (2 | 0) ? 2 : ($1 | 0) != (0 | 0);
  HEAP32[(i64toi32_i32$0 + 200 | 0) >> 2] = HEAP32[((i64toi32_i32$2 + 208 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 208 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 212 | 0) >> 2] | 0;
  $331 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[(i64toi32_i32$1 + 192 | 0) >> 2] = $331;
  HEAP32[(i64toi32_i32$1 + 196 | 0) >> 2] = i64toi32_i32$0;
  global$0 = i64toi32_i32$2 + 272 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__StakeDelegation___deserialize_as_embedded_group__he2a305551fe9e1ea($0, $1, $2, $2$hi, $3, $3$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  var i64toi32_i32$3 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $4 = 0, $5 = 0, $13 = 0, $6 = 0, $7 = 0, i64toi32_i32$0 = 0, $13$hi = 0, $8 = 0, $9 = 0, i64toi32_i32$4 = 0, $53 = 0, $54 = 0, $55 = 0, $56 = 0, $57 = 0, $58 = 0, $59 = 0, $60 = 0, $61 = 0, $62 = 0, $63 = 0, $64 = 0, $65 = 0, $66 = 0, $67 = 0, $14 = 0, $14$hi = 0, $68 = 0, $10 = 0, $11 = 0, $12 = 0, $15 = 0, $15$hi = 0, $95 = 0, $104 = 0, $110 = 0, $116 = 0, $125 = 0, $131 = 0, $137 = 0, $140 = 0, $146 = 0, $152 = 0, $158 = 0, $161 = 0, $167 = 0, $173 = 0, $179 = 0, $182 = 0, $202 = 0, $222 = 0, $228 = 0, $231 = 0, $236 = 0, $241 = 0, $246 = 0, $249 = 0, $253 = 0, $257 = 0, $264 = 0;
  $4 = global$0 - 432 | 0;
  global$0 = $4;
  cbor_event__de__Deserializer_R___unsigned_integer__h1ed99c0b7fe7eea1($4 + 360 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 368 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 372 | 0) >> 2] | 0;
  $13 = i64toi32_i32$0;
  $13$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 360 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 364 | 0) >> 2] | 0;
         i64toi32_i32$2 = i64toi32_i32$1;
         i64toi32_i32$1 = 0;
         i64toi32_i32$3 = 1;
         if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
          break label$7
         }
         i64toi32_i32$2 = 0;
         $14 = 2;
         $14$hi = i64toi32_i32$2;
         i64toi32_i32$2 = $13$hi;
         i64toi32_i32$3 = $13;
         i64toi32_i32$0 = 0;
         i64toi32_i32$1 = 2;
         if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) | 0) {
          break label$5
         }
         $5 = 8;
         $6 = 1;
         $7 = 1;
         break label$6;
        }
        i64toi32_i32$3 = $13$hi;
        i64toi32_i32$1 = $13;
        i64toi32_i32$2 = 0;
        i64toi32_i32$0 = 32;
        i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
         i64toi32_i32$2 = 0;
         $68 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
        } else {
         i64toi32_i32$2 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
         $68 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
        }
        $8 = $68;
        i64toi32_i32$3 = $4 + 400 | 0;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $15 = i64toi32_i32$2;
        $15$hi = i64toi32_i32$1;
        i64toi32_i32$3 = $4 + 392 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $14 = i64toi32_i32$1;
        $14$hi = i64toi32_i32$2;
        $9 = HEAP32[($4 + 388 | 0) >> 2] | 0;
        $7 = HEAP32[($4 + 384 | 0) >> 2] | 0;
        i64toi32_i32$2 = $13$hi;
        $6 = $13;
        $5 = 2;
        i64toi32_i32$3 = $4 + 376 | 0;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $13 = i64toi32_i32$2;
        $13$hi = i64toi32_i32$1;
       }
       i64toi32_i32$1 = $15$hi;
       i64toi32_i32$2 = $4 + 400 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $15;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$1 = $14$hi;
       i64toi32_i32$2 = $4 + 392 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $14;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       HEAP32[($4 + 388 | 0) >> 2] = $9;
       HEAP32[($4 + 384 | 0) >> 2] = $7;
       i64toi32_i32$1 = $13$hi;
       i64toi32_i32$2 = $4 + 376 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $13;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       HEAP32[($4 + 372 | 0) >> 2] = $8;
       HEAP32[(($4 + 360 | 0) + 8 | 0) >> 2] = $6;
       HEAP32[($4 + 408 | 0) >> 2] = 0;
       HEAP8[($4 + 360 | 0) >> 0] = $5;
       cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($4 + 144 | 0 | 0, $4 + 360 | 0 | 0, 1050766 | 0, 7 | 0);
       $5 = HEAPU8[($4 + 144 | 0) >> 0] | 0;
       if (($5 | 0) != (19 | 0)) {
        break label$4
       }
      }
      $cardano_serialization_lib__address__StakeCredential_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__ha21a31a5230d4f02($4 + 360 | 0 | 0, $1 | 0);
      if ((HEAPU8[($4 + 360 | 0) >> 0] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      $5 = ($4 + 288 | 0) + 21 | 0;
      i64toi32_i32$3 = ($4 + 360 | 0) + 22 | 0;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$2 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $95 = i64toi32_i32$1;
      i64toi32_i32$1 = $5;
      $53 = $95;
      HEAP8[i64toi32_i32$1 >> 0] = $53;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $53 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $53 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $53 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$2;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
      $6 = ($4 + 288 | 0) + 16 | 0;
      $10 = ($4 + 360 | 0) + 17 | 0;
      i64toi32_i32$3 = $10;
      i64toi32_i32$2 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $104 = i64toi32_i32$2;
      i64toi32_i32$2 = $6;
      HEAP32[i64toi32_i32$2 >> 2] = $104;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      $7 = ($4 + 216 | 0) + 16 | 0;
      i64toi32_i32$3 = i64toi32_i32$2;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $110 = i64toi32_i32$1;
      i64toi32_i32$1 = $7;
      HEAP32[i64toi32_i32$1 >> 2] = $110;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
      $6 = ($4 + 216 | 0) + 21 | 0;
      i64toi32_i32$3 = $5;
      i64toi32_i32$2 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $116 = i64toi32_i32$2;
      i64toi32_i32$2 = $6;
      $54 = $116;
      HEAP8[i64toi32_i32$2 >> 0] = $54;
      HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $54 >>> 8 | 0;
      HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $54 >>> 16 | 0;
      HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $54 >>> 24 | 0;
      HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      $8 = ($4 + 144 | 0) + 9 | 0;
      $11 = ($4 + 360 | 0) + 9 | 0;
      i64toi32_i32$3 = $11;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$2 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $125 = i64toi32_i32$1;
      i64toi32_i32$1 = $8;
      $55 = $125;
      HEAP8[i64toi32_i32$1 >> 0] = $55;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $55 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $55 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $55 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$2;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
      $9 = ($4 + 144 | 0) + 17 | 0;
      i64toi32_i32$3 = $7;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $131 = i64toi32_i32$2;
      i64toi32_i32$2 = $9;
      $56 = $131;
      HEAP8[i64toi32_i32$2 >> 0] = $56;
      HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $56 >>> 8 | 0;
      HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $56 >>> 16 | 0;
      HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $56 >>> 24 | 0;
      HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      $5 = ($4 + 144 | 0) + 22 | 0;
      i64toi32_i32$3 = $6;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$2 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $137 = i64toi32_i32$1;
      i64toi32_i32$1 = $5;
      $57 = $137;
      HEAP8[i64toi32_i32$1 >> 0] = $57;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $57 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $57 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $57 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$2;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
      i64toi32_i32$3 = $4;
      i64toi32_i32$2 = HEAPU8[(i64toi32_i32$3 + 361 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 362 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 363 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 364 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$3 + 365 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 366 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 367 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 368 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $140 = i64toi32_i32$2;
      i64toi32_i32$2 = i64toi32_i32$3;
      $58 = $140;
      HEAP8[(i64toi32_i32$2 + 145 | 0) >> 0] = $58;
      HEAP8[(i64toi32_i32$2 + 146 | 0) >> 0] = $58 >>> 8 | 0;
      HEAP8[(i64toi32_i32$2 + 147 | 0) >> 0] = $58 >>> 16 | 0;
      HEAP8[(i64toi32_i32$2 + 148 | 0) >> 0] = $58 >>> 24 | 0;
      HEAP8[(i64toi32_i32$2 + 149 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$2 + 150 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$2 + 151 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$2 + 152 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      $7 = (i64toi32_i32$2 + 72 | 0) + 21 | 0;
      i64toi32_i32$3 = $5;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$2 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $146 = i64toi32_i32$1;
      i64toi32_i32$1 = $7;
      $59 = $146;
      HEAP8[i64toi32_i32$1 >> 0] = $59;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $59 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $59 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $59 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$2;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
      $5 = ($4 + 72 | 0) + 16 | 0;
      i64toi32_i32$3 = $9;
      i64toi32_i32$2 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $152 = i64toi32_i32$2;
      i64toi32_i32$2 = $5;
      HEAP32[i64toi32_i32$2 >> 2] = $152;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      $6 = ($4 + 72 | 0) + 8 | 0;
      i64toi32_i32$3 = $8;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$2 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $158 = i64toi32_i32$1;
      i64toi32_i32$1 = $6;
      HEAP32[i64toi32_i32$1 >> 2] = $158;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$3 = $4;
      i64toi32_i32$2 = HEAPU8[(i64toi32_i32$3 + 145 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 146 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 147 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 148 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$3 + 149 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 150 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 151 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 152 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $161 = i64toi32_i32$2;
      i64toi32_i32$2 = i64toi32_i32$3;
      HEAP32[(i64toi32_i32$3 + 72 | 0) >> 2] = $161;
      HEAP32[(i64toi32_i32$3 + 76 | 0) >> 2] = i64toi32_i32$1;
      $9 = (i64toi32_i32$3 + 8 | 0) + 21 | 0;
      i64toi32_i32$3 = $7;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$2 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $167 = i64toi32_i32$1;
      i64toi32_i32$1 = $9;
      $60 = $167;
      HEAP8[i64toi32_i32$1 >> 0] = $60;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $60 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $60 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $60 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$2;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
      $7 = ($4 + 8 | 0) + 16 | 0;
      i64toi32_i32$3 = $5;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $173 = i64toi32_i32$2;
      i64toi32_i32$2 = $7;
      HEAP32[i64toi32_i32$2 >> 2] = $173;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      $12 = ($4 + 8 | 0) + 8 | 0;
      i64toi32_i32$3 = $6;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $179 = i64toi32_i32$1;
      i64toi32_i32$1 = $12;
      HEAP32[i64toi32_i32$1 >> 2] = $179;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$3 = $4;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 72 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 76 | 0) >> 2] | 0;
      $182 = i64toi32_i32$2;
      i64toi32_i32$2 = i64toi32_i32$3;
      HEAP32[(i64toi32_i32$3 + 8 | 0) >> 2] = $182;
      HEAP32[(i64toi32_i32$3 + 12 | 0) >> 2] = i64toi32_i32$1;
      $cardano_serialization_lib__crypto__Ed25519KeyHash_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h495effbb534e290f(i64toi32_i32$3 + 360 | 0 | 0, $1 | 0);
      if ((HEAPU8[(i64toi32_i32$3 + 360 | 0) >> 0] | 0 | 0) == (1 | 0)) {
       break label$2
      }
      i64toi32_i32$3 = $11;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$2 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $13 = i64toi32_i32$1;
      $13$hi = i64toi32_i32$2;
      i64toi32_i32$1 = $8;
      HEAP8[i64toi32_i32$1 >> 0] = $13;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $13 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $13 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $13 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$2;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
      $1 = ($4 + 72 | 0) + 24 | 0;
      $61 = $4 + 385 | 0;
      HEAP32[$1 >> 2] = HEAPU8[$61 >> 0] | 0 | ((HEAPU8[($61 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($61 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($61 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$3 = $10;
      i64toi32_i32$2 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $202 = i64toi32_i32$2;
      i64toi32_i32$2 = $5;
      HEAP32[i64toi32_i32$2 >> 2] = $202;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$1 = $13$hi;
      i64toi32_i32$2 = $6;
      HEAP32[i64toi32_i32$2 >> 2] = $13;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$3 = $4;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$3 + 361 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 362 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 363 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 364 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$2 = HEAPU8[(i64toi32_i32$3 + 365 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 366 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 367 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 368 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $13 = i64toi32_i32$1;
      $13$hi = i64toi32_i32$2;
      i64toi32_i32$1 = i64toi32_i32$3;
      HEAP8[(i64toi32_i32$3 + 145 | 0) >> 0] = $13;
      HEAP8[(i64toi32_i32$3 + 146 | 0) >> 0] = $13 >>> 8 | 0;
      HEAP8[(i64toi32_i32$3 + 147 | 0) >> 0] = $13 >>> 16 | 0;
      HEAP8[(i64toi32_i32$3 + 148 | 0) >> 0] = $13 >>> 24 | 0;
      HEAP8[(i64toi32_i32$3 + 149 | 0) >> 0] = i64toi32_i32$2;
      HEAP8[(i64toi32_i32$3 + 150 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
      HEAP8[(i64toi32_i32$3 + 151 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
      HEAP8[(i64toi32_i32$3 + 152 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
      i64toi32_i32$1 = i64toi32_i32$3;
      HEAP32[(i64toi32_i32$3 + 72 | 0) >> 2] = $13;
      HEAP32[(i64toi32_i32$3 + 76 | 0) >> 2] = i64toi32_i32$2;
      $8 = (i64toi32_i32$3 + 40 | 0) + 24 | 0;
      HEAP32[$8 >> 2] = HEAP32[$1 >> 2] | 0;
      $1 = (i64toi32_i32$3 + 40 | 0) + 16 | 0;
      i64toi32_i32$3 = $5;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $222 = i64toi32_i32$2;
      i64toi32_i32$2 = $1;
      HEAP32[i64toi32_i32$2 >> 2] = $222;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      $5 = ($4 + 40 | 0) + 8 | 0;
      i64toi32_i32$3 = $6;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $228 = i64toi32_i32$1;
      i64toi32_i32$1 = $5;
      HEAP32[i64toi32_i32$1 >> 2] = $228;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$3 = $4;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 72 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 76 | 0) >> 2] | 0;
      $231 = i64toi32_i32$2;
      i64toi32_i32$2 = i64toi32_i32$3;
      HEAP32[(i64toi32_i32$3 + 40 | 0) >> 2] = $231;
      HEAP32[(i64toi32_i32$3 + 44 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$3 = $9;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$2 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $236 = i64toi32_i32$1;
      i64toi32_i32$1 = ($4 + 360 | 0) + 21 | 0;
      $62 = $236;
      HEAP8[i64toi32_i32$1 >> 0] = $62;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $62 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $62 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $62 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$2;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
      i64toi32_i32$3 = $7;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $241 = i64toi32_i32$2;
      i64toi32_i32$2 = ($4 + 360 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $241;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$3 = $12;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $246 = i64toi32_i32$1;
      i64toi32_i32$1 = ($4 + 360 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $246;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$3 = $4;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 8 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 12 | 0) >> 2] | 0;
      $249 = i64toi32_i32$2;
      i64toi32_i32$2 = i64toi32_i32$3;
      HEAP32[(i64toi32_i32$3 + 360 | 0) >> 2] = $249;
      HEAP32[(i64toi32_i32$3 + 364 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$3 = $5;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $253 = i64toi32_i32$1;
      i64toi32_i32$1 = $4 + 397 | 0;
      $63 = $253;
      HEAP8[i64toi32_i32$1 >> 0] = $63;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $63 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $63 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $63 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$2;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
      i64toi32_i32$3 = $1;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $257 = i64toi32_i32$2;
      i64toi32_i32$2 = $4 + 405 | 0;
      $64 = $257;
      HEAP8[i64toi32_i32$2 >> 0] = $64;
      HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $64 >>> 8 | 0;
      HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $64 >>> 16 | 0;
      HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $64 >>> 24 | 0;
      HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      $65 = $4 + 413 | 0;
      $66 = HEAP32[$8 >> 2] | 0;
      HEAP8[$65 >> 0] = $66;
      HEAP8[($65 + 1 | 0) >> 0] = $66 >>> 8 | 0;
      HEAP8[($65 + 2 | 0) >> 0] = $66 >>> 16 | 0;
      HEAP8[($65 + 3 | 0) >> 0] = $66 >>> 24 | 0;
      i64toi32_i32$3 = $4;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 40 | 0) >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 44 | 0) >> 2] | 0;
      $264 = i64toi32_i32$1;
      i64toi32_i32$1 = i64toi32_i32$3;
      $67 = $264;
      HEAP8[(i64toi32_i32$3 + 389 | 0) >> 0] = $67;
      HEAP8[(i64toi32_i32$3 + 390 | 0) >> 0] = $67 >>> 8 | 0;
      HEAP8[(i64toi32_i32$3 + 391 | 0) >> 0] = $67 >>> 16 | 0;
      HEAP8[(i64toi32_i32$3 + 392 | 0) >> 0] = $67 >>> 24 | 0;
      HEAP8[(i64toi32_i32$3 + 393 | 0) >> 0] = i64toi32_i32$2;
      HEAP8[(i64toi32_i32$3 + 394 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
      HEAP8[(i64toi32_i32$3 + 395 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
      HEAP8[(i64toi32_i32$3 + 396 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
      memcpy($0 + 1 | 0 | 0, i64toi32_i32$3 + 360 | 0 | 0, 57 | 0) | 0;
      HEAP8[$0 >> 0] = 0;
      break label$1;
     }
     memcpy($0 + 9 | 0 | 0, $4 + 144 | 0 | 1 | 0 | 0, 63 | 0) | 0;
     HEAP8[$0 >> 0] = 1;
     HEAP8[($0 + 8 | 0) >> 0] = $5;
     break label$1;
    }
    memcpy($4 + 360 | 0 | 0, memcpy($4 + 216 | 0 | 7 | 0 | 0, memcpy($4 + 288 | 0 | 7 | 0 | 0, ($4 + 360 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
    $1 = ($4 + 144 | 0) + 8 | 0;
    cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 360 | 0 | 0, 1050773 | 0, 16 | 0);
    memcpy($0 + 8 | 0 | 0, memcpy($4 + 72 | 0 | 7 | 0 | 0, $1 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
    HEAP8[$0 >> 0] = 1;
    break label$1;
   }
   memcpy($4 + 360 | 0 | 0, memcpy($4 + 216 | 0 | 7 | 0 | 0, memcpy($4 + 288 | 0 | 7 | 0 | 0, ($4 + 360 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   $1 = ($4 + 144 | 0) + 8 | 0;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 360 | 0 | 0, 1050823 | 0, 12 | 0);
   memcpy($0 + 8 | 0 | 0, memcpy($4 + 72 | 0 | 7 | 0 | 0, $1 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   HEAP8[$0 >> 0] = 1;
  }
  global$0 = $4 + 432 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__RewardAddresses___deserialize__hfc34473540a771a7($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, $3 = 0, i64toi32_i32$4 = 0, $11 = 0, $11$hi = 0, $5 = 0, $9 = 0, $12 = 0, $12$hi = 0, $45 = 0, $46 = 0, $47 = 0, $48 = 0, $49 = 0, $50 = 0, $51 = 0, $52 = 0, $53 = 0, $54 = 0, $55 = 0, $56 = 0, $57 = 0, $58 = 0, $59 = 0, $60 = 0, $61 = 0, $62 = 0, $4 = 0, $63 = 0, $64 = 0, $65 = 0, $66 = 0, $67 = 0, $68 = 0, $6 = 0, $7 = 0, $8 = 0, $85 = 0, $85$hi = 0, $87 = 0, $87$hi = 0, $90$hi = 0, $92$hi = 0, $10 = 0, $13 = 0, $13$hi = 0, $135 = 0, $139 = 0, $182 = 0, $187 = 0, $204 = 0, $208 = 0, $230 = 0, $236 = 0, $240 = 0, $245 = 0, $251 = 0, $255 = 0, $267 = 0, $271 = 0, $277 = 0, $283 = 0, $310 = 0;
  $2 = global$0 - 320 | 0;
  global$0 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 12 | 0) >> 2] = 0;
  HEAP32[($2 + 16 | 0) >> 2] = i64toi32_i32$0;
  $3 = 0;
  HEAP32[($2 + 8 | 0) >> 2] = HEAP32[(0 + 1050212 | 0) >> 2] | 0;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 248 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = ($2 + 248 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $11 = i64toi32_i32$0;
  $11$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 256 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 260 | 0) >> 2] | 0;
  $12 = i64toi32_i32$1;
  $12$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 248 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 252 | 0) >> 2] | 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
         break label$6
        }
        i64toi32_i32$2 = $11$hi;
        $4 = $11;
        label$7 : {
         i64toi32_i32$2 = $12$hi;
         i64toi32_i32$3 = $12;
         i64toi32_i32$1 = 0;
         i64toi32_i32$0 = 1;
         if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
          break label$7
         }
         if (!$4) {
          break label$3
         }
        }
        $5 = $2 + 257 | 0;
        $6 = $2 + 248 | 0 | 1 | 0;
        $7 = ($2 + 248 | 0) + 30 | 0;
        $8 = $2 + 276 | 0;
        label$8 : {
         label$9 : while (1) {
          std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 | 0, $1 | 0);
          $3 = 0;
          $9 = 2;
          label$10 : {
           if (HEAP32[($2 + 4 | 0) >> 2] | 0) {
            break label$10
           }
           i64toi32_i32$3 = 0;
           $12 = 8;
           $12$hi = i64toi32_i32$3;
           i64toi32_i32$3 = 0;
           $11 = 0;
           $11$hi = i64toi32_i32$3;
           break label$4;
          }
          label$11 : {
           if ((($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[$2 >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) == (7 | 0)) {
            break label$11
           }
           $cardano_serialization_lib__address__RewardAddress_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h7ae223ac4e980662($2 + 248 | 0 | 0, $1 | 0);
           if ((HEAPU8[($2 + 248 | 0) >> 0] | 0 | 0) == (1 | 0)) {
            break label$8
           }
           HEAP32[($2 + 216 | 0) >> 2] = HEAPU8[$5 >> 0] | 0 | ((HEAPU8[($5 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($5 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($5 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $46 = $5 + 3 | 0;
           $47 = HEAPU8[$46 >> 0] | 0 | ((HEAPU8[($46 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($46 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($46 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 219 | 0) >> 0] = $47;
           HEAP8[($2 + 220 | 0) >> 0] = $47 >>> 8 | 0;
           HEAP8[($2 + 221 | 0) >> 0] = $47 >>> 16 | 0;
           HEAP8[($2 + 222 | 0) >> 0] = $47 >>> 24 | 0;
           $45 = $6;
           HEAP32[($2 + 200 | 0) >> 2] = HEAPU8[$45 >> 0] | 0 | ((HEAPU8[($45 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($45 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($45 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $48 = $45 + 3 | 0;
           $49 = HEAPU8[$48 >> 0] | 0 | ((HEAPU8[($48 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($48 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($48 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 203 | 0) >> 0] = $49;
           HEAP8[($2 + 204 | 0) >> 0] = $49 >>> 8 | 0;
           HEAP8[($2 + 205 | 0) >> 0] = $49 >>> 16 | 0;
           HEAP8[($2 + 206 | 0) >> 0] = $49 >>> 24 | 0;
           HEAP32[($2 + 240 | 0) >> 2] = HEAP32[($2 + 216 | 0) >> 2] | 0;
           $50 = HEAPU8[($2 + 219 | 0) >> 0] | 0 | ((HEAPU8[($2 + 220 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 221 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 222 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 243 | 0) >> 0] = $50;
           HEAP8[($2 + 244 | 0) >> 0] = $50 >>> 8 | 0;
           HEAP8[($2 + 245 | 0) >> 0] = $50 >>> 16 | 0;
           HEAP8[($2 + 246 | 0) >> 0] = $50 >>> 24 | 0;
           i64toi32_i32$0 = $2;
           i64toi32_i32$3 = HEAP32[($2 + 272 | 0) >> 2] | 0;
           i64toi32_i32$2 = 0;
           $85 = i64toi32_i32$3;
           $85$hi = i64toi32_i32$2;
           i64toi32_i32$0 = $8;
           i64toi32_i32$2 = HEAPU16[i64toi32_i32$0 >> 1] | 0;
           i64toi32_i32$3 = 0;
           $87 = i64toi32_i32$2;
           $87$hi = i64toi32_i32$3;
           i64toi32_i32$0 = $7;
           i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0;
           i64toi32_i32$2 = 0;
           i64toi32_i32$0 = i64toi32_i32$3;
           i64toi32_i32$3 = 0;
           i64toi32_i32$1 = 16;
           i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
           if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
            i64toi32_i32$3 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
            $63 = 0;
           } else {
            i64toi32_i32$3 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
            $63 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
           }
           $90$hi = i64toi32_i32$3;
           i64toi32_i32$3 = $87$hi;
           i64toi32_i32$2 = $87;
           i64toi32_i32$0 = $90$hi;
           i64toi32_i32$1 = $63;
           i64toi32_i32$0 = i64toi32_i32$3 | i64toi32_i32$0 | 0;
           i64toi32_i32$3 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
           i64toi32_i32$2 = 0;
           i64toi32_i32$1 = 32;
           i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
           if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
            i64toi32_i32$2 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
            $64 = 0;
           } else {
            i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
            $64 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
           }
           $92$hi = i64toi32_i32$2;
           i64toi32_i32$2 = $85$hi;
           i64toi32_i32$0 = $85;
           i64toi32_i32$3 = $92$hi;
           i64toi32_i32$1 = $64;
           i64toi32_i32$3 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
           $11 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
           $11$hi = i64toi32_i32$3;
           $10 = HEAPU8[($2 + 256 | 0) >> 0] | 0;
           i64toi32_i32$2 = $2;
           i64toi32_i32$3 = HEAP32[($2 + 264 | 0) >> 2] | 0;
           i64toi32_i32$0 = HEAP32[($2 + 268 | 0) >> 2] | 0;
           $13 = i64toi32_i32$3;
           $13$hi = i64toi32_i32$0;
           label$12 : {
            $9 = HEAP32[($2 + 16 | 0) >> 2] | 0;
            if ((HEAP32[($2 + 12 | 0) >> 2] | 0 | 0) != ($9 | 0)) {
             break label$12
            }
            alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hf7d7cca00a09c6e3($2 + 8 | 0 | 0, $9 | 0, 1 | 0);
            $9 = HEAP32[($2 + 16 | 0) >> 2] | 0;
           }
           $3 = (HEAP32[($2 + 8 | 0) >> 2] | 0) + Math_imul($9, 30) | 0;
           $51 = HEAP32[($2 + 200 | 0) >> 2] | 0;
           HEAP8[$3 >> 0] = $51;
           HEAP8[($3 + 1 | 0) >> 0] = $51 >>> 8 | 0;
           HEAP8[($3 + 2 | 0) >> 0] = $51 >>> 16 | 0;
           HEAP8[($3 + 3 | 0) >> 0] = $51 >>> 24 | 0;
           HEAP8[($3 + 7 | 0) >> 0] = $10;
           $52 = HEAP32[($2 + 240 | 0) >> 2] | 0;
           HEAP8[($3 + 8 | 0) >> 0] = $52;
           HEAP8[($3 + 9 | 0) >> 0] = $52 >>> 8 | 0;
           HEAP8[($3 + 10 | 0) >> 0] = $52 >>> 16 | 0;
           HEAP8[($3 + 11 | 0) >> 0] = $52 >>> 24 | 0;
           i64toi32_i32$0 = $11$hi;
           HEAP8[($3 + 23 | 0) >> 0] = $11;
           HEAP8[($3 + 24 | 0) >> 0] = $11 >>> 8 | 0;
           HEAP8[($3 + 25 | 0) >> 0] = $11 >>> 16 | 0;
           HEAP8[($3 + 26 | 0) >> 0] = $11 >>> 24 | 0;
           i64toi32_i32$0 = $13$hi;
           i64toi32_i32$3 = $3;
           $53 = $13;
           HEAP8[(i64toi32_i32$3 + 15 | 0) >> 0] = $53;
           HEAP8[(i64toi32_i32$3 + 16 | 0) >> 0] = $53 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 17 | 0) >> 0] = $53 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 18 | 0) >> 0] = $53 >>> 24 | 0;
           HEAP8[(i64toi32_i32$3 + 19 | 0) >> 0] = i64toi32_i32$0;
           HEAP8[(i64toi32_i32$3 + 20 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 21 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 22 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
           $54 = i64toi32_i32$3 + 3 | 0;
           $55 = HEAPU8[($2 + 203 | 0) >> 0] | 0 | ((HEAPU8[($2 + 204 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 205 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 206 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[$54 >> 0] = $55;
           HEAP8[($54 + 1 | 0) >> 0] = $55 >>> 8 | 0;
           HEAP8[($54 + 2 | 0) >> 0] = $55 >>> 16 | 0;
           HEAP8[($54 + 3 | 0) >> 0] = $55 >>> 24 | 0;
           $56 = i64toi32_i32$3 + 11 | 0;
           $57 = HEAPU8[($2 + 243 | 0) >> 0] | 0 | ((HEAPU8[($2 + 244 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 245 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 246 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[$56 >> 0] = $57;
           HEAP8[($56 + 1 | 0) >> 0] = $57 >>> 8 | 0;
           HEAP8[($56 + 2 | 0) >> 0] = $57 >>> 16 | 0;
           HEAP8[($56 + 3 | 0) >> 0] = $57 >>> 24 | 0;
           $135 = i64toi32_i32$3 + 29 | 0;
           i64toi32_i32$0 = $11$hi;
           i64toi32_i32$2 = $11;
           i64toi32_i32$3 = 0;
           i64toi32_i32$1 = 48;
           i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
           if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
            i64toi32_i32$3 = 0;
            $65 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
           } else {
            i64toi32_i32$3 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
            $65 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
           }
           HEAP8[$135 >> 0] = $65;
           $139 = $3 + 27 | 0;
           i64toi32_i32$3 = $11$hi;
           i64toi32_i32$0 = $11;
           i64toi32_i32$2 = 0;
           i64toi32_i32$1 = 32;
           i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
           if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
            i64toi32_i32$2 = 0;
            $66 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
           } else {
            i64toi32_i32$2 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
            $66 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
           }
           $67 = $139;
           $68 = $66;
           HEAP8[$67 >> 0] = $68;
           HEAP8[($67 + 1 | 0) >> 0] = $68 >>> 8 | 0;
           $3 = $9 + 1 | 0;
           HEAP32[($2 + 16 | 0) >> 2] = $3;
           i64toi32_i32$2 = $12$hi;
           i64toi32_i32$3 = $12;
           i64toi32_i32$0 = 0;
           i64toi32_i32$1 = 1;
           if ((i64toi32_i32$3 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$0 | 0) | 0) {
            continue label$9
           }
           if ($3 >>> 0 < $4 >>> 0) {
            continue label$9
           }
           break label$3;
          }
          break label$9;
         };
         cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 248 | 0 | 0, $1 | 0);
         i64toi32_i32$1 = ($2 + 248 | 0) + 16 | 0;
         i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
         $11 = i64toi32_i32$3;
         $11$hi = i64toi32_i32$2;
         i64toi32_i32$1 = $2;
         i64toi32_i32$2 = HEAP32[($2 + 256 | 0) >> 2] | 0;
         i64toi32_i32$3 = HEAP32[($2 + 260 | 0) >> 2] | 0;
         $12 = i64toi32_i32$2;
         $12$hi = i64toi32_i32$3;
         i64toi32_i32$1 = $2;
         i64toi32_i32$3 = HEAP32[($2 + 248 | 0) >> 2] | 0;
         i64toi32_i32$2 = HEAP32[($2 + 252 | 0) >> 2] | 0;
         i64toi32_i32$1 = i64toi32_i32$3;
         i64toi32_i32$3 = 0;
         i64toi32_i32$0 = 1;
         if ((i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) | 0) {
          break label$5
         }
         i64toi32_i32$1 = $11$hi;
         i64toi32_i32$2 = $2 + 208 | 0;
         HEAP32[i64toi32_i32$2 >> 2] = $11;
         HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$1 = $12$hi;
         i64toi32_i32$2 = $2;
         HEAP32[($2 + 200 | 0) >> 2] = $12;
         HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$1;
         if (($12 & 255 | 0 | 0) == (5 | 0)) {
          break label$3
         }
         HEAP32[($2 + 248 | 0) >> 2] = 0;
         core__panicking__assert_failed__h96d8431cc974b591(0 | 0, $2 + 200 | 0 | 0, 1050312 | 0, $2 + 248 | 0 | 0, 1051580 | 0);
         abort();
        }
        i64toi32_i32$0 = $2 + 288 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
        $182 = i64toi32_i32$1;
        i64toi32_i32$1 = ($2 + 168 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $182;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
        i64toi32_i32$0 = $2 + 296 | 0;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
        $187 = i64toi32_i32$2;
        i64toi32_i32$2 = $2 + 184 | 0;
        HEAP32[i64toi32_i32$2 >> 2] = $187;
        HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
        HEAP32[(($2 + 152 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 316 | 0) >> 2] | 0;
        HEAP32[($2 + 216 | 0) >> 2] = HEAPU8[$5 >> 0] | 0 | ((HEAPU8[($5 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($5 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($5 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $58 = $5 + 3 | 0;
        $59 = HEAPU8[$58 >> 0] | 0 | ((HEAPU8[($58 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($58 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($58 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 219 | 0) >> 0] = $59;
        HEAP8[($2 + 220 | 0) >> 0] = $59 >>> 8 | 0;
        HEAP8[($2 + 221 | 0) >> 0] = $59 >>> 16 | 0;
        HEAP8[($2 + 222 | 0) >> 0] = $59 >>> 24 | 0;
        i64toi32_i32$0 = $2 + 280 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
        $204 = i64toi32_i32$1;
        i64toi32_i32$1 = $2;
        HEAP32[($2 + 168 | 0) >> 2] = $204;
        HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$2;
        i64toi32_i32$0 = $2 + 308 | 0;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
        $208 = i64toi32_i32$2;
        i64toi32_i32$2 = $2;
        HEAP32[($2 + 152 | 0) >> 2] = $208;
        HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$1;
        $3 = HEAP32[($2 + 304 | 0) >> 2] | 0;
        i64toi32_i32$0 = $2;
        i64toi32_i32$1 = HEAP32[($2 + 264 | 0) >> 2] | 0;
        i64toi32_i32$2 = HEAP32[($2 + 268 | 0) >> 2] | 0;
        $12 = i64toi32_i32$1;
        $12$hi = i64toi32_i32$2;
        i64toi32_i32$0 = $2;
        i64toi32_i32$2 = HEAP32[($2 + 272 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 276 | 0) >> 2] | 0;
        $11 = i64toi32_i32$2;
        $11$hi = i64toi32_i32$1;
        $9 = HEAPU8[($2 + 256 | 0) >> 0] | 0;
        $60 = HEAPU8[($2 + 219 | 0) >> 0] | 0 | ((HEAPU8[($2 + 220 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 221 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 222 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 195 | 0) >> 0] = $60;
        HEAP8[($2 + 196 | 0) >> 0] = $60 >>> 8 | 0;
        HEAP8[($2 + 197 | 0) >> 0] = $60 >>> 16 | 0;
        HEAP8[($2 + 198 | 0) >> 0] = $60 >>> 24 | 0;
        HEAP32[($2 + 192 | 0) >> 2] = HEAP32[($2 + 216 | 0) >> 2] | 0;
        if (($9 | 0) != (19 | 0)) {
         break label$4
        }
        break label$3;
       }
       i64toi32_i32$0 = $2 + 280 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
       $230 = i64toi32_i32$1;
       i64toi32_i32$1 = $2 + 176 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $230;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$0 = $2 + 288 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
       $236 = i64toi32_i32$2;
       i64toi32_i32$2 = ($2 + 168 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $236;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$0 = $2 + 272 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
       $240 = i64toi32_i32$1;
       i64toi32_i32$1 = $2;
       HEAP32[($2 + 168 | 0) >> 2] = $240;
       HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$2;
       $9 = 2;
       break label$4;
      }
      i64toi32_i32$0 = $2 + 280 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
      $245 = i64toi32_i32$2;
      i64toi32_i32$2 = $2 + 176 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $245;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$0 = $2 + 288 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
      $251 = i64toi32_i32$1;
      i64toi32_i32$1 = ($2 + 168 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $251;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$0 = $2 + 272 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
      $255 = i64toi32_i32$2;
      i64toi32_i32$2 = $2;
      HEAP32[($2 + 168 | 0) >> 2] = $255;
      HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$1;
     }
     i64toi32_i32$1 = $11$hi;
     i64toi32_i32$2 = ($2 + 248 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $11;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$2 = ($2 + 248 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $12;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$0 = $2;
     i64toi32_i32$1 = HEAP32[($2 + 168 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[($2 + 172 | 0) >> 2] | 0;
     $267 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 272 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $267;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$0 = $2;
     i64toi32_i32$2 = HEAP32[($2 + 152 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 156 | 0) >> 2] | 0;
     $271 = i64toi32_i32$2;
     i64toi32_i32$2 = $2 + 300 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $271;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$0 = ($2 + 168 | 0) + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $277 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 280 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $277;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$0 = ($2 + 168 | 0) + 16 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $283 = i64toi32_i32$2;
     i64toi32_i32$2 = $2 + 288 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $283;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($2 + 308 | 0) >> 2] = HEAP32[(($2 + 152 | 0) + 8 | 0) >> 2] | 0;
     HEAP8[($2 + 248 | 0) >> 0] = $9;
     $61 = HEAP32[($2 + 192 | 0) >> 2] | 0;
     HEAP8[($2 + 249 | 0) >> 0] = $61;
     HEAP8[($2 + 250 | 0) >> 0] = $61 >>> 8 | 0;
     HEAP8[($2 + 251 | 0) >> 0] = $61 >>> 16 | 0;
     HEAP8[($2 + 252 | 0) >> 0] = $61 >>> 24 | 0;
     $62 = HEAPU8[($2 + 195 | 0) >> 0] | 0 | ((HEAPU8[($2 + 196 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 197 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 198 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($2 + 252 | 0) >> 0] = $62;
     HEAP8[($2 + 253 | 0) >> 0] = $62 >>> 8 | 0;
     HEAP8[($2 + 254 | 0) >> 0] = $62 >>> 16 | 0;
     HEAP8[($2 + 255 | 0) >> 0] = $62 >>> 24 | 0;
     HEAP32[($2 + 296 | 0) >> 2] = $3;
     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($2 + 88 | 0 | 0, $2 + 248 | 0 | 0, 1051596 | 0, 15 | 0);
     $1 = HEAPU8[($2 + 88 | 0) >> 0] | 0;
     if (($1 | 0) != (19 | 0)) {
      break label$2
     }
    }
    i64toi32_i32$0 = $2;
    i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $310 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $310;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$2;
    HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
    $3 = 0;
    break label$1;
   }
   $3 = 1;
   memcpy($2 + 25 | 0 | 0, $2 + 88 | 0 | 1 | 0 | 0, 63 | 0) | 0;
   HEAP8[($0 + 8 | 0) >> 0] = $1;
   memcpy($0 + 9 | 0 | 0, $2 + 25 | 0 | 0, 63 | 0) | 0;
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hf5b7c59907e4555e($2 + 8 | 0 | 0);
  }
  HEAP32[$0 >> 2] = $3;
  global$0 = $2 + 320 | 0;
 }
 
 function $cardano_serialization_lib__plutus__PlutusList_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hfdf263ce80660b6e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, $2 = 0, i64toi32_i32$1 = 0, $3 = 0, $5 = 0, $10 = 0, $10$hi = 0, $11 = 0, $11$hi = 0, $6 = 0, $9$hi = 0, $9 = 0, $13 = 0, $13$hi = 0, $12$hi = 0, $12 = 0, $4 = 0, $7 = 0, $8 = 0, $60 = 0, $67 = 0, $70 = 0, $85 = 0, $91 = 0, $94 = 0, $122 = 0, $126 = 0, $130 = 0, $178 = 0, $185 = 0, $188 = 0, $191 = 0, $204 = 0, $210 = 0, $214 = 0, $219 = 0, $225 = 0, $229 = 0, $243 = 0, $247 = 0, $253 = 0, $259 = 0, $271 = 0, $318 = 0;
  $2 = global$0 - 256 | 0;
  global$0 = $2;
  i64toi32_i32$0 = 0;
  $9 = 0;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 12 | 0) >> 2] = 0;
  HEAP32[($2 + 16 | 0) >> 2] = i64toi32_i32$0;
  $3 = 0;
  HEAP32[($2 + 8 | 0) >> 2] = HEAP32[(0 + 1070736 | 0) >> 2] | 0;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 184 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = ($2 + 184 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 192 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 196 | 0) >> 2] | 0;
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 184 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 188 | 0) >> 2] | 0;
       i64toi32_i32$2 = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 1;
       if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
        break label$5
       }
       i64toi32_i32$2 = $10$hi;
       $4 = $10;
       label$6 : {
        i64toi32_i32$2 = $11$hi;
        i64toi32_i32$3 = $11;
        i64toi32_i32$1 = 0;
        i64toi32_i32$0 = 1;
        if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
         break label$6
        }
        if (!$4) {
         break label$2
        }
       }
       $5 = ($2 + 184 | 0) + 32 | 0;
       label$7 : {
        label$8 : while (1) {
         std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 | 0, $1 | 0);
         $3 = 0;
         i64toi32_i32$3 = 0;
         $12 = 2;
         $12$hi = i64toi32_i32$3;
         i64toi32_i32$3 = 0;
         $9 = 0;
         $9$hi = i64toi32_i32$3;
         label$9 : {
          if (HEAP32[($2 + 4 | 0) >> 2] | 0) {
           break label$9
          }
          i64toi32_i32$3 = 0;
          $11 = 8;
          $11$hi = i64toi32_i32$3;
          i64toi32_i32$3 = 0;
          $10 = 0;
          $10$hi = i64toi32_i32$3;
          break label$3;
         }
         label$10 : {
          if ((($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[$2 >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) == (7 | 0)) {
           break label$10
          }
          $cardano_serialization_lib__plutus__PlutusData_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__haa2b047fc7012f29($2 + 184 | 0 | 0, $1 | 0);
          $3 = ($2 + 160 | 0) + 8 | 0;
          i64toi32_i32$0 = $5 + 8 | 0;
          i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
          i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
          $60 = i64toi32_i32$3;
          i64toi32_i32$3 = $3;
          HEAP32[i64toi32_i32$3 >> 2] = $60;
          HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
          $6 = ($2 + 160 | 0) + 16 | 0;
          i64toi32_i32$0 = $5 + 16 | 0;
          i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
          i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
          $67 = i64toi32_i32$2;
          i64toi32_i32$2 = $6;
          HEAP32[i64toi32_i32$2 >> 2] = $67;
          HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
          i64toi32_i32$0 = $5;
          i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
          i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
          $70 = i64toi32_i32$3;
          i64toi32_i32$3 = $2;
          HEAP32[(i64toi32_i32$3 + 160 | 0) >> 2] = $70;
          HEAP32[(i64toi32_i32$3 + 164 | 0) >> 2] = i64toi32_i32$2;
          i64toi32_i32$0 = i64toi32_i32$3;
          i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 208 | 0) >> 2] | 0;
          i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 212 | 0) >> 2] | 0;
          $10 = i64toi32_i32$2;
          $10$hi = i64toi32_i32$3;
          i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 200 | 0) >> 2] | 0;
          i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 204 | 0) >> 2] | 0;
          $13 = i64toi32_i32$3;
          $13$hi = i64toi32_i32$2;
          i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 192 | 0) >> 2] | 0;
          i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 196 | 0) >> 2] | 0;
          $9 = i64toi32_i32$2;
          $9$hi = i64toi32_i32$3;
          i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 184 | 0) >> 2] | 0;
          i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 188 | 0) >> 2] | 0;
          i64toi32_i32$0 = i64toi32_i32$3;
          i64toi32_i32$3 = 0;
          i64toi32_i32$1 = 1;
          if ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) | 0) {
           break label$7
          }
          $7 = ($2 + 136 | 0) + 8 | 0;
          i64toi32_i32$1 = $3;
          i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
          i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
          $85 = i64toi32_i32$0;
          i64toi32_i32$0 = $7;
          HEAP32[i64toi32_i32$0 >> 2] = $85;
          HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
          $8 = ($2 + 136 | 0) + 16 | 0;
          i64toi32_i32$1 = $6;
          i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
          $91 = i64toi32_i32$2;
          i64toi32_i32$2 = $8;
          HEAP32[i64toi32_i32$2 >> 2] = $91;
          HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
          i64toi32_i32$1 = $2;
          i64toi32_i32$0 = HEAP32[($2 + 160 | 0) >> 2] | 0;
          i64toi32_i32$2 = HEAP32[($2 + 164 | 0) >> 2] | 0;
          $94 = i64toi32_i32$0;
          i64toi32_i32$0 = $2;
          HEAP32[(i64toi32_i32$0 + 136 | 0) >> 2] = $94;
          HEAP32[(i64toi32_i32$0 + 140 | 0) >> 2] = i64toi32_i32$2;
          label$11 : {
           $6 = HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] | 0;
           if ((HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] | 0 | 0) != ($6 | 0)) {
            break label$11
           }
           alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h1a6fd20a90c96048($2 + 8 | 0 | 0, $6 | 0, 1 | 0);
           $6 = HEAP32[($2 + 16 | 0) >> 2] | 0;
          }
          $3 = (HEAP32[($2 + 8 | 0) >> 2] | 0) + Math_imul($6, 48) | 0;
          i64toi32_i32$2 = $9$hi;
          i64toi32_i32$0 = $3;
          HEAP32[i64toi32_i32$0 >> 2] = $9;
          HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
          i64toi32_i32$2 = $10$hi;
          i64toi32_i32$0 = i64toi32_i32$0 + 16 | 0;
          HEAP32[i64toi32_i32$0 >> 2] = $10;
          HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
          i64toi32_i32$2 = $13$hi;
          i64toi32_i32$0 = $3 + 8 | 0;
          HEAP32[i64toi32_i32$0 >> 2] = $13;
          HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
          i64toi32_i32$1 = $2;
          i64toi32_i32$2 = HEAP32[($2 + 136 | 0) >> 2] | 0;
          i64toi32_i32$0 = HEAP32[($2 + 140 | 0) >> 2] | 0;
          $122 = i64toi32_i32$2;
          i64toi32_i32$2 = $3 + 24 | 0;
          HEAP32[i64toi32_i32$2 >> 2] = $122;
          HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
          i64toi32_i32$1 = $7;
          i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
          i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
          $126 = i64toi32_i32$0;
          i64toi32_i32$0 = $3 + 32 | 0;
          HEAP32[i64toi32_i32$0 >> 2] = $126;
          HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
          i64toi32_i32$1 = $8;
          i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
          $130 = i64toi32_i32$2;
          i64toi32_i32$2 = $3 + 40 | 0;
          HEAP32[i64toi32_i32$2 >> 2] = $130;
          HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
          $3 = $6 + 1 | 0;
          HEAP32[($2 + 16 | 0) >> 2] = $3;
          i64toi32_i32$0 = $11$hi;
          i64toi32_i32$1 = $11;
          i64toi32_i32$2 = 0;
          i64toi32_i32$3 = 1;
          if ((i64toi32_i32$1 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$2 | 0) | 0) {
           continue label$8
          }
          if ($3 >>> 0 < $4 >>> 0) {
           continue label$8
          }
          break label$2;
         }
         break label$8;
        };
        cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 184 | 0 | 0, $1 | 0);
        i64toi32_i32$3 = ($2 + 184 | 0) + 16 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $10 = i64toi32_i32$1;
        $10$hi = i64toi32_i32$0;
        i64toi32_i32$3 = $2;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 192 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 196 | 0) >> 2] | 0;
        $13 = i64toi32_i32$0;
        $13$hi = i64toi32_i32$1;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 184 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 188 | 0) >> 2] | 0;
        i64toi32_i32$3 = i64toi32_i32$1;
        i64toi32_i32$1 = 0;
        i64toi32_i32$2 = 1;
        if ((i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
         break label$4
        }
        i64toi32_i32$3 = $10$hi;
        i64toi32_i32$0 = $2 + 144 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $10;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
        i64toi32_i32$3 = $13$hi;
        i64toi32_i32$0 = $2;
        HEAP32[(i64toi32_i32$0 + 136 | 0) >> 2] = $13;
        HEAP32[(i64toi32_i32$0 + 140 | 0) >> 2] = i64toi32_i32$3;
        if (($13 & 255 | 0 | 0) == (5 | 0)) {
         break label$2
        }
        HEAP32[($2 + 184 | 0) >> 2] = 0;
        core__panicking__assert_failed__h96d8431cc974b591(0 | 0, $2 + 136 | 0 | 0, 1070752 | 0, $2 + 184 | 0 | 0, 1071180 | 0);
        abort();
       }
       HEAP32[(($2 + 96 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 252 | 0) >> 2] | 0;
       i64toi32_i32$2 = ($2 + 160 | 0) + 8 | 0;
       i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $178 = i64toi32_i32$3;
       i64toi32_i32$3 = ($2 + 112 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$3 >> 2] = $178;
       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = ($2 + 160 | 0) + 16 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $185 = i64toi32_i32$0;
       i64toi32_i32$0 = ($2 + 112 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $185;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
       i64toi32_i32$2 = $2;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 244 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 248 | 0) >> 2] | 0;
       $188 = i64toi32_i32$3;
       i64toi32_i32$3 = i64toi32_i32$2;
       HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] = $188;
       HEAP32[(i64toi32_i32$2 + 100 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 160 | 0) >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 164 | 0) >> 2] | 0;
       $191 = i64toi32_i32$0;
       i64toi32_i32$0 = i64toi32_i32$2;
       HEAP32[(i64toi32_i32$0 + 112 | 0) >> 2] = $191;
       HEAP32[(i64toi32_i32$0 + 116 | 0) >> 2] = i64toi32_i32$3;
       i64toi32_i32$3 = $9$hi;
       i64toi32_i32$2 = $9;
       i64toi32_i32$0 = 0;
       i64toi32_i32$1 = 255;
       i64toi32_i32$0 = i64toi32_i32$3 & i64toi32_i32$0 | 0;
       $12 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
       $12$hi = i64toi32_i32$0;
       i64toi32_i32$0 = i64toi32_i32$3;
       i64toi32_i32$3 = i64toi32_i32$2;
       i64toi32_i32$2 = -1;
       i64toi32_i32$1 = -256;
       i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
       $9 = i64toi32_i32$3 & i64toi32_i32$1 | 0;
       $9$hi = i64toi32_i32$2;
       $3 = HEAP32[($2 + 240 | 0) >> 2] | 0;
       i64toi32_i32$2 = $13$hi;
       $11 = $13;
       $11$hi = i64toi32_i32$2;
       break label$3;
      }
      i64toi32_i32$0 = $2 + 216 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
      $204 = i64toi32_i32$2;
      i64toi32_i32$2 = $2 + 120 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $204;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
      i64toi32_i32$0 = $2 + 224 | 0;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
      $210 = i64toi32_i32$3;
      i64toi32_i32$3 = ($2 + 112 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$3 >> 2] = $210;
      HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$0 = $2 + 208 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
      $214 = i64toi32_i32$2;
      i64toi32_i32$2 = $2;
      HEAP32[(i64toi32_i32$2 + 112 | 0) >> 2] = $214;
      HEAP32[(i64toi32_i32$2 + 116 | 0) >> 2] = i64toi32_i32$3;
      i64toi32_i32$3 = 0;
      $12 = 2;
      $12$hi = i64toi32_i32$3;
      break label$3;
     }
     i64toi32_i32$0 = $2 + 216 | 0;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $219 = i64toi32_i32$3;
     i64toi32_i32$3 = $2 + 120 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $219;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$0 = $2 + 224 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $225 = i64toi32_i32$2;
     i64toi32_i32$2 = ($2 + 112 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $225;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$0 = $2 + 208 | 0;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $229 = i64toi32_i32$3;
     i64toi32_i32$3 = $2;
     HEAP32[(i64toi32_i32$3 + 112 | 0) >> 2] = $229;
     HEAP32[(i64toi32_i32$3 + 116 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$2 = $13$hi;
     $11 = $13;
     $11$hi = i64toi32_i32$2;
    }
    i64toi32_i32$2 = $10$hi;
    i64toi32_i32$3 = ($2 + 184 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$3 >> 2] = $10;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $11$hi;
    i64toi32_i32$3 = ($2 + 184 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$3 >> 2] = $11;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$0 = $2;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 112 | 0) >> 2] | 0;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 116 | 0) >> 2] | 0;
    $243 = i64toi32_i32$2;
    i64toi32_i32$2 = (i64toi32_i32$0 + 184 | 0) + 24 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $243;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 96 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 100 | 0) >> 2] | 0;
    $247 = i64toi32_i32$3;
    i64toi32_i32$3 = i64toi32_i32$0 + 236 | 0;
    HEAP32[i64toi32_i32$3 >> 2] = $247;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$0 = (i64toi32_i32$0 + 112 | 0) + 8 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
    $253 = i64toi32_i32$2;
    i64toi32_i32$2 = $2 + 216 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $253;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
    i64toi32_i32$0 = ($2 + 112 | 0) + 16 | 0;
    i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
    $259 = i64toi32_i32$3;
    i64toi32_i32$3 = $2 + 224 | 0;
    HEAP32[i64toi32_i32$3 >> 2] = $259;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
    HEAP32[($2 + 244 | 0) >> 2] = HEAP32[(($2 + 96 | 0) + 8 | 0) >> 2] | 0;
    HEAP32[($2 + 232 | 0) >> 2] = $3;
    i64toi32_i32$2 = $12$hi;
    i64toi32_i32$2 = $9$hi;
    i64toi32_i32$2 = $12$hi;
    i64toi32_i32$0 = $12;
    i64toi32_i32$3 = $9$hi;
    i64toi32_i32$1 = $9;
    i64toi32_i32$3 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
    $271 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
    i64toi32_i32$0 = $2;
    HEAP32[(i64toi32_i32$0 + 184 | 0) >> 2] = $271;
    HEAP32[(i64toi32_i32$0 + 188 | 0) >> 2] = i64toi32_i32$3;
    cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e((i64toi32_i32$0 + 24 | 0) + 8 | 0 | 0, i64toi32_i32$0 + 184 | 0 | 0, 1071196 | 0, 10 | 0);
    i64toi32_i32$2 = (i64toi32_i32$0 + 24 | 0) + 16 | 0;
    i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $10 = i64toi32_i32$3;
    $10$hi = i64toi32_i32$0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
    $11 = i64toi32_i32$0;
    $11$hi = i64toi32_i32$3;
    memcpy($0 + 24 | 0 | 0, (i64toi32_i32$2 + 24 | 0) + 24 | 0 | 0, 48 | 0) | 0;
    i64toi32_i32$3 = $10$hi;
    i64toi32_i32$0 = $0 + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $10;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
    i64toi32_i32$3 = $11$hi;
    i64toi32_i32$0 = $0 + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $11;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
    label$12 : {
     $5 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
     if (!$5) {
      break label$12
     }
     $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
     $5 = Math_imul($5, 48);
     label$13 : while (1) {
      core__ptr__drop_in_place_cardano_serialization_lib__plutus__PlutusData___hfab843e66e0f9428_2($3 | 0);
      $3 = $3 + 48 | 0;
      $5 = $5 + -48 | 0;
      if ($5) {
       continue label$13
      }
      break label$13;
     };
    }
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h36e817e704f6f25e($2 + 8 | 0 | 0);
    $3 = 1;
    break label$1;
   }
   HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
   $318 = i64toi32_i32$3;
   i64toi32_i32$3 = $0;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = $318;
   HEAP32[(i64toi32_i32$3 + 8 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $11$hi;
   HEAP8[(i64toi32_i32$3 + 16 | 0) >> 0] = $11;
   $3 = 0;
  }
  HEAP32[$0 >> 2] = $3;
  global$0 = $2 + 256 | 0;
 }
 
 function cardano_serialization_lib__emip3__decrypt_with_password__h0f29b0290b85ef37($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, $8 = 0, i64toi32_i32$3 = 0, $16 = 0, $43 = 0, $6 = 0, $7 = 0, $182 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $5 = global$0 - 672 | 0;
  global$0 = $5;
  $alloc__vec__Vec_u8__20as_20hex__FromHex___from_hex__h4bc81c912cf347f6($5 + 432 | 0 | 0, $1 | 0, $2 | 0);
  $1 = HEAP32[($5 + 436 | 0) >> 2] | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           label$10 : {
            label$11 : {
             if ((HEAP32[($5 + 432 | 0) >> 2] | 0 | 0) != (1 | 0)) {
              break label$11
             }
             HEAP32[($5 + 148 | 0) >> 2] = HEAP32[($5 + 440 | 0) >> 2] | 0;
             HEAP32[($5 + 144 | 0) >> 2] = $1;
             i64toi32_i32$1 = $5;
             i64toi32_i32$0 = 0;
             HEAP32[($5 + 420 | 0) >> 2] = 0;
             HEAP32[($5 + 424 | 0) >> 2] = i64toi32_i32$0;
             HEAP32[($5 + 416 | 0) >> 2] = HEAP32[(0 + 1069072 | 0) >> 2] | 0;
             core__fmt__Formatter__new__he219faf25326051b($5 + 160 | 0 | 0, $5 + 416 | 0 | 0, 1068692 | 0);
             if (!($hex__error__FromHexError_20as_20core__fmt__Display___fmt__haa62d686bf8e55c9($5 + 144 | 0 | 0, $5 + 160 | 0 | 0) | 0)) {
              break label$10
             }
             core__result__unwrap_failed__h27f43d993c3864a1(1068716 | 0, 55 | 0, $5 + 664 | 0 | 0, 1068980 | 0, 1068848 | 0);
             abort();
            }
            i64toi32_i32$2 = $5;
            i64toi32_i32$0 = HEAP32[($5 + 440 | 0) >> 2] | 0;
            i64toi32_i32$1 = HEAP32[($5 + 444 | 0) >> 2] | 0;
            $43 = i64toi32_i32$0;
            i64toi32_i32$0 = $5;
            HEAP32[($5 + 116 | 0) >> 2] = $43;
            HEAP32[($5 + 120 | 0) >> 2] = i64toi32_i32$1;
            HEAP32[($5 + 112 | 0) >> 2] = $1;
            $alloc__vec__Vec_u8__20as_20hex__FromHex___from_hex__h4bc81c912cf347f6($5 + 432 | 0 | 0, $3 | 0, $4 | 0);
            $1 = HEAP32[($5 + 436 | 0) >> 2] | 0;
            label$12 : {
             if ((HEAP32[($5 + 432 | 0) >> 2] | 0 | 0) != (1 | 0)) {
              break label$12
             }
             HEAP32[($5 + 148 | 0) >> 2] = HEAP32[($5 + 440 | 0) >> 2] | 0;
             HEAP32[($5 + 144 | 0) >> 2] = $1;
             i64toi32_i32$0 = $5;
             i64toi32_i32$1 = 0;
             HEAP32[($5 + 420 | 0) >> 2] = 0;
             HEAP32[($5 + 424 | 0) >> 2] = i64toi32_i32$1;
             HEAP32[($5 + 416 | 0) >> 2] = HEAP32[(0 + 1069072 | 0) >> 2] | 0;
             core__fmt__Formatter__new__he219faf25326051b($5 + 160 | 0 | 0, $5 + 416 | 0 | 0, 1068692 | 0);
             if ($hex__error__FromHexError_20as_20core__fmt__Display___fmt__haa62d686bf8e55c9($5 + 144 | 0 | 0, $5 + 160 | 0 | 0) | 0) {
              break label$3
             }
             $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($5 + 16 | 0 | 0, $5 + 416 | 0 | 0);
             $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($5 + 16 | 0) >> 2] | 0 | 0, HEAP32[($5 + 20 | 0) >> 2] | 0 | 0) | 0;
             $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($5 + 416 | 0 | 0);
             $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($5 + 416 | 0 | 0);
             $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($1 | 0) | 0;
             HEAP32[$0 >> 2] = 1;
             HEAP32[($0 + 4 | 0) >> 2] = $1;
             break label$2;
            }
            i64toi32_i32$2 = $5;
            i64toi32_i32$1 = HEAP32[($5 + 440 | 0) >> 2] | 0;
            i64toi32_i32$0 = HEAP32[($5 + 444 | 0) >> 2] | 0;
            $8 = i64toi32_i32$1;
            i64toi32_i32$1 = $5;
            HEAP32[($5 + 132 | 0) >> 2] = $8;
            HEAP32[($5 + 136 | 0) >> 2] = i64toi32_i32$0;
            HEAP32[($5 + 128 | 0) >> 2] = $1;
            label$13 : {
             i64toi32_i32$2 = $8;
             i64toi32_i32$1 = 0;
             i64toi32_i32$3 = 32;
             i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
             if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
              i64toi32_i32$1 = 0;
              $16 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
             } else {
              i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
              $16 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
             }
             if ($16 >>> 0 < 61 >>> 0) {
              break label$13
             }
             $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($5 + 104 | 0 | 0, $5 + 128 | 0 | 0);
             $1 = HEAP32[($5 + 108 | 0) >> 2] | 0;
             if ($1 >>> 0 <= 31 >>> 0) {
              break label$7
             }
             $2 = HEAP32[($5 + 104 | 0) >> 2] | 0;
             $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($5 + 96 | 0 | 0, $5 + 128 | 0 | 0);
             $1 = HEAP32[($5 + 100 | 0) >> 2] | 0;
             if ($1 >>> 0 <= 43 >>> 0) {
              break label$6
             }
             $3 = HEAP32[($5 + 96 | 0) >> 2] | 0;
             $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($5 + 88 | 0 | 0, $5 + 128 | 0 | 0);
             $1 = HEAP32[($5 + 92 | 0) >> 2] | 0;
             if ($1 >>> 0 <= 59 >>> 0) {
              break label$5
             }
             $6 = HEAP32[($5 + 88 | 0) >> 2] | 0;
             $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($5 + 80 | 0 | 0, $5 + 128 | 0 | 0);
             $4 = HEAP32[($5 + 84 | 0) >> 2] | 0;
             if ($4 >>> 0 <= 59 >>> 0) {
              break label$4
             }
             $7 = HEAP32[($5 + 80 | 0) >> 2] | 0;
             cryptoxide__sha2__Sha512__new__h57eb1a61fae5dfc3($5 + 432 | 0 | 0);
             $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($5 + 72 | 0 | 0, $5 + 112 | 0 | 0);
             cryptoxide__hmac__Hmac_D___new__h10c18a5661f5ecf6($5 + 160 | 0 | 0, $5 + 432 | 0 | 0, HEAP32[($5 + 72 | 0) >> 2] | 0 | 0, HEAP32[($5 + 76 | 0) >> 2] | 0 | 0);
             $1 = 0;
             core__iter__adapters__take__Take_I___new__h57f06669aa0e5753($5 + 64 | 0 | 0, 0 | 0, 32 | 0);
             $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter__SpecFromIter_T_2cI____from_iter__hd9e424f0851c7545($5 + 432 | 0 | 0, HEAP32[($5 + 64 | 0) >> 2] | 0 | 0, HEAPU8[($5 + 68 | 0) >> 0] | 0 | 0);
             $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__DerefMut___deref_mut__h1882e042320a120c($5 + 56 | 0 | 0, $5 + 432 | 0 | 0);
             cryptoxide__pbkdf2__pbkdf2__h6d76e9b9cb3d73c2($5 + 160 | 0 | 0, $2 | 0, 32 | 0, 19162 | 0, HEAP32[($5 + 56 | 0) >> 2] | 0 | 0, HEAP32[($5 + 60 | 0) >> 2] | 0 | 0);
             HEAP32[(($5 + 144 | 0) + 8 | 0) >> 2] = HEAP32[(($5 + 432 | 0) + 8 | 0) >> 2] | 0;
             i64toi32_i32$0 = $5;
             i64toi32_i32$1 = HEAP32[($5 + 432 | 0) >> 2] | 0;
             i64toi32_i32$2 = HEAP32[($5 + 436 | 0) >> 2] | 0;
             $182 = i64toi32_i32$1;
             i64toi32_i32$1 = $5;
             HEAP32[($5 + 144 | 0) >> 2] = $182;
             HEAP32[($5 + 148 | 0) >> 2] = i64toi32_i32$2;
             $2 = $5 + 384 | 0;
             $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 | 0);
             $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 | 0);
             $2 = $5 + 396 | 0;
             $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 | 0);
             $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 | 0);
             $2 = $4 + -60 | 0;
             core__iter__adapters__take__Take_I___new__h57f06669aa0e5753($5 + 48 | 0 | 0, 0 | 0, $2 | 0);
             $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter__SpecFromIter_T_2cI____from_iter__hd9e424f0851c7545($5 + 416 | 0 | 0, HEAP32[($5 + 48 | 0) >> 2] | 0 | 0, HEAPU8[($5 + 52 | 0) >> 0] | 0 | 0);
             $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($5 + 40 | 0 | 0, $5 + 144 | 0 | 0);
             cryptoxide__chacha20poly1305__Context_____new__h0cc47d548a2f122a($5 + 432 | 0 | 0, HEAP32[($5 + 40 | 0) >> 2] | 0 | 0, HEAP32[($5 + 44 | 0) >> 2] | 0 | 0, $3 + 32 | 0 | 0, 12 | 0);
             $cryptoxide__poly1305__Poly1305_20as_20cryptoxide__mac__Mac___input__h2055bc09e473001f($5 + 580 | 0 | 0, 1069056 | 0, 0 | 0);
             memcpy($5 + 160 | 0 | 0, $5 + 432 | 0 | 0, 232 | 0) | 0;
             HEAP8[($5 + 392 | 0) >> 0] = 0;
             $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__DerefMut___deref_mut__h1882e042320a120c($5 + 32 | 0 | 0, $5 + 416 | 0 | 0);
             if (cryptoxide__chacha20poly1305__ChaChaPoly1305_____decrypt__h389227096220e6aa($5 + 160 | 0 | 0, $7 + 60 | 0 | 0, $2 | 0, HEAP32[($5 + 32 | 0) >> 2] | 0 | 0, HEAP32[($5 + 36 | 0) >> 2] | 0 | 0, $6 + 44 | 0 | 0, 16 | 0) | 0) {
              break label$9
             }
             (wasm2js_i32$0 = $0, wasm2js_i32$1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1069752 | 0, 16 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
             $1 = 1;
             break label$8;
            }
            $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1069668 | 0, 18 | 0) | 0;
            HEAP32[$0 >> 2] = 1;
            HEAP32[($0 + 4 | 0) >> 2] = $1;
            $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($5 + 128 | 0 | 0);
            $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($5 + 128 | 0 | 0);
            break label$2;
           }
           $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($5 + 8 | 0 | 0, $5 + 416 | 0 | 0);
           $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($5 + 8 | 0) >> 2] | 0 | 0, HEAP32[($5 + 12 | 0) >> 2] | 0 | 0) | 0;
           $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($5 + 416 | 0 | 0);
           $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($5 + 416 | 0 | 0);
           $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($1 | 0) | 0;
           HEAP32[$0 >> 2] = 1;
           HEAP32[($0 + 4 | 0) >> 2] = $1;
           break label$1;
          }
          $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($5 + 24 | 0 | 0, $5 + 416 | 0 | 0);
          hex__encode_to_iter__h3b9b5dcb85c2c5cd($0 + 4 | 0 | 0, 1067368 | 0, HEAP32[($5 + 24 | 0) >> 2] | 0 | 0, HEAP32[($5 + 28 | 0) >> 2] | 0 | 0);
         }
         HEAP32[$0 >> 2] = $1;
         $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($5 + 416 | 0 | 0);
         $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($5 + 416 | 0 | 0);
         $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($5 + 144 | 0 | 0);
         $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($5 + 144 | 0 | 0);
         $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($5 + 128 | 0 | 0);
         $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($5 + 128 | 0 | 0);
         $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($5 + 112 | 0 | 0);
         $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($5 + 112 | 0 | 0);
         break label$1;
        }
        core__slice__index__slice_end_index_len_fail__h192505a15ac4b345(32 | 0, $1 | 0, 1069688 | 0);
        abort();
       }
       core__slice__index__slice_end_index_len_fail__h192505a15ac4b345(44 | 0, $1 | 0, 1069704 | 0);
       abort();
      }
      core__slice__index__slice_end_index_len_fail__h192505a15ac4b345(60 | 0, $1 | 0, 1069720 | 0);
      abort();
     }
     core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4(60 | 0, $4 | 0, 1069736 | 0);
     abort();
    }
    core__result__unwrap_failed__h27f43d993c3864a1(1068716 | 0, 55 | 0, $5 + 664 | 0 | 0, 1068980 | 0, 1068848 | 0);
    abort();
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($5 + 112 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($5 + 112 | 0 | 0);
  }
  global$0 = $5 + 672 | 0;
 }
 
 function dlmalloc__dlmalloc__Dlmalloc_A___free__h37f2ccb1260849b6($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $3 = 0, $4 = 0, $5 = 0, $39 = 0, $6 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $0 = dlmalloc__dlmalloc__Chunk__from_mem__h955f68080880f343($0 | 0) | 0;
  $1 = dlmalloc__dlmalloc__Chunk__size__hbcf51483386243e4($0 | 0) | 0;
  $2 = dlmalloc__dlmalloc__Chunk__plus_offset__h7aa5253a4344ed9a($0 | 0, $1 | 0) | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     if (dlmalloc__dlmalloc__Chunk__pinuse__h3f4a4f8063aa1f27($0 | 0) | 0) {
      break label$3
     }
     $3 = HEAP32[$0 >> 2] | 0;
     label$4 : {
      label$5 : {
       if (dlmalloc__dlmalloc__Chunk__mmapped__h896a47bc7b87f942($0 | 0) | 0) {
        break label$5
       }
       $1 = $3 + $1 | 0;
       $0 = dlmalloc__dlmalloc__Chunk__minus_offset__h475b72a4870c7350($0 | 0, $3 | 0) | 0;
       if (($0 | 0) != (HEAP32[(0 + 1178292 | 0) >> 2] | 0 | 0)) {
        break label$4
       }
       if (((HEAP32[($2 + 4 | 0) >> 2] | 0) & 3 | 0 | 0) != (3 | 0)) {
        break label$3
       }
       HEAP32[(0 + 1178284 | 0) >> 2] = $1;
       dlmalloc__dlmalloc__Chunk__set_free_with_pinuse__hb6fcf1321e8edd9b($0 | 0, $1 | 0, $2 | 0);
       return;
      }
      $39 = $0 - $3 | 0;
      $0 = ($3 + $1 | 0) + 16 | 0;
      if (!($dlmalloc__sys__System_20as_20dlmalloc__Allocator___free__h820779abf265185e(1177884 | 0, $39 | 0, $0 | 0) | 0)) {
       break label$2
      }
      HEAP32[(0 + 1178300 | 0) >> 2] = (HEAP32[(0 + 1178300 | 0) >> 2] | 0) - $0 | 0;
      return;
     }
     label$6 : {
      if ($3 >>> 0 < 256 >>> 0) {
       break label$6
      }
      dlmalloc__dlmalloc__Dlmalloc_A___unlink_large_chunk__h107571aa99375aaf($0 | 0);
      break label$3;
     }
     label$7 : {
      $4 = HEAP32[($0 + 12 | 0) >> 2] | 0;
      $5 = HEAP32[($0 + 8 | 0) >> 2] | 0;
      if (($4 | 0) == ($5 | 0)) {
       break label$7
      }
      HEAP32[($5 + 12 | 0) >> 2] = $4;
      HEAP32[($4 + 8 | 0) >> 2] = $5;
      break label$3;
     }
     (wasm2js_i32$0 = 0, wasm2js_i32$1 = (HEAP32[(0 + 1177884 | 0) >> 2] | 0) & (__wasm_rotl_i32(-2 | 0, $3 >>> 3 | 0 | 0) | 0) | 0), HEAP32[(wasm2js_i32$0 + 1177884 | 0) >> 2] = wasm2js_i32$1;
    }
    label$8 : {
     label$9 : {
      if (!(dlmalloc__dlmalloc__Chunk__cinuse__hfa8040b8ff348e52($2 | 0) | 0)) {
       break label$9
      }
      dlmalloc__dlmalloc__Chunk__set_free_with_pinuse__hb6fcf1321e8edd9b($0 | 0, $1 | 0, $2 | 0);
      break label$8;
     }
     label$10 : {
      label$11 : {
       if (($2 | 0) == (HEAP32[(0 + 1178296 | 0) >> 2] | 0 | 0)) {
        break label$11
       }
       if (($2 | 0) != (HEAP32[(0 + 1178292 | 0) >> 2] | 0 | 0)) {
        break label$10
       }
       HEAP32[(0 + 1178292 | 0) >> 2] = $0;
       $1 = (HEAP32[(0 + 1178284 | 0) >> 2] | 0) + $1 | 0;
       HEAP32[(0 + 1178284 | 0) >> 2] = $1;
       dlmalloc__dlmalloc__Chunk__set_size_and_pinuse_of_free_chunk__hbc4027d35960d532($0 | 0, $1 | 0);
       return;
      }
      HEAP32[(0 + 1178296 | 0) >> 2] = $0;
      $1 = (HEAP32[(0 + 1178288 | 0) >> 2] | 0) + $1 | 0;
      HEAP32[(0 + 1178288 | 0) >> 2] = $1;
      HEAP32[($0 + 4 | 0) >> 2] = $1 | 1 | 0;
      label$12 : {
       if (($0 | 0) != (HEAP32[(0 + 1178292 | 0) >> 2] | 0 | 0)) {
        break label$12
       }
       HEAP32[(0 + 1178284 | 0) >> 2] = 0;
       HEAP32[(0 + 1178292 | 0) >> 2] = 0;
      }
      if ((HEAP32[(0 + 1178324 | 0) >> 2] | 0) >>> 0 >= $1 >>> 0) {
       break label$2
      }
      $0 = dlmalloc__dlmalloc__Chunk__to_mem__he3242996ca597cec(0 | 0) | 0;
      $1 = dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2($0 | 0, 8 | 0) | 0;
      $2 = dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2(20 | 0, 8 | 0) | 0;
      $3 = dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2(16 | 0, 8 | 0) | 0;
      $4 = dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2(16 | 0, 8 | 0) | 0;
      if (!(HEAP32[(0 + 1178296 | 0) >> 2] | 0)) {
       break label$2
      }
      $0 = ((((($0 - $1 | 0) - $2 | 0) - $3 | 0) + -65544 | 0) & -9 | 0) + -3 | 0;
      $1 = 0 - ($4 << 2 | 0) | 0;
      if (!($1 >>> 0 > $0 >>> 0 ? $0 : $1)) {
       break label$2
      }
      $0 = dlmalloc__dlmalloc__Chunk__to_mem__he3242996ca597cec(0 | 0) | 0;
      $1 = dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2($0 | 0, 8 | 0) | 0;
      $3 = dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2(20 | 0, 8 | 0) | 0;
      $4 = dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2(16 | 0, 8 | 0) | 0;
      $2 = 0;
      label$13 : {
       $5 = HEAP32[(0 + 1178288 | 0) >> 2] | 0;
       $0 = $4 + ($3 + ($1 - $0 | 0) | 0) | 0;
       if ($5 >>> 0 <= $0 >>> 0) {
        break label$13
       }
       $3 = ($5 + ($0 ^ -1 | 0) | 0) & -65536 | 0;
       $1 = HEAP32[(0 + 1178296 | 0) >> 2] | 0;
       $0 = 1178308;
       label$14 : {
        label$15 : while (1) {
         label$16 : {
          if ((HEAP32[$0 >> 2] | 0) >>> 0 > $1 >>> 0) {
           break label$16
          }
          if ((dlmalloc__dlmalloc__Segment__top__hf63c2d8a250d607b($0 | 0) | 0) >>> 0 > $1 >>> 0) {
           break label$14
          }
         }
         $0 = HEAP32[($0 + 8 | 0) >> 2] | 0;
         if ($0) {
          continue label$15
         }
         break label$15;
        };
        $0 = 0;
       }
       $2 = 0;
       if (dlmalloc__dlmalloc__Segment__is_extern__hebd3849795a5a7f4($0 | 0) | 0) {
        break label$13
       }
       if (!($dlmalloc__sys__System_20as_20dlmalloc__Allocator___can_release_part__h23e00ec9580583cb(1177884 | 0, (HEAP32[($0 + 12 | 0) >> 2] | 0) >>> 1 | 0 | 0) | 0)) {
        break label$13
       }
       if ((HEAP32[($0 + 4 | 0) >> 2] | 0) >>> 0 < $3 >>> 0) {
        break label$13
       }
       $1 = 1178308;
       label$17 : while (1) {
        if (dlmalloc__dlmalloc__Segment__holds__h401eff113aa2fd65($0 | 0, $1 | 0) | 0) {
         break label$13
        }
        $1 = HEAP32[($1 + 8 | 0) >> 2] | 0;
        if ($1) {
         continue label$17
        }
        break label$17;
       };
       $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
       $1 = $dlmalloc__sys__System_20as_20dlmalloc__Allocator___free_part__hfb3b756bb73698d3(1177884 | 0, HEAP32[$0 >> 2] | 0 | 0, $1 | 0, $1 - $3 | 0 | 0) | 0;
       if (!$3) {
        break label$13
       }
       if (!$1) {
        break label$13
       }
       HEAP32[($0 + 4 | 0) >> 2] = (HEAP32[($0 + 4 | 0) >> 2] | 0) - $3 | 0;
       HEAP32[(0 + 1178300 | 0) >> 2] = (HEAP32[(0 + 1178300 | 0) >> 2] | 0) - $3 | 0;
       $1 = HEAP32[(0 + 1178288 | 0) >> 2] | 0;
       $0 = HEAP32[(0 + 1178296 | 0) >> 2] | 0;
       $2 = dlmalloc__dlmalloc__Chunk__to_mem__he3242996ca597cec($0 | 0) | 0;
       $2 = (dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2($2 | 0, 8 | 0) | 0) - $2 | 0;
       $0 = dlmalloc__dlmalloc__Chunk__plus_offset__h7aa5253a4344ed9a($0 | 0, $2 | 0) | 0;
       $1 = ($1 - $3 | 0) - $2 | 0;
       HEAP32[(0 + 1178288 | 0) >> 2] = $1;
       HEAP32[(0 + 1178296 | 0) >> 2] = $0;
       HEAP32[($0 + 4 | 0) >> 2] = $1 | 1 | 0;
       $2 = dlmalloc__dlmalloc__Chunk__to_mem__he3242996ca597cec(0 | 0) | 0;
       $4 = dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2($2 | 0, 8 | 0) | 0;
       $5 = dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2(20 | 0, 8 | 0) | 0;
       $6 = dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2(16 | 0, 8 | 0) | 0;
       (wasm2js_i32$0 = dlmalloc__dlmalloc__Chunk__plus_offset__h7aa5253a4344ed9a($0 | 0, $1 | 0) | 0, wasm2js_i32$1 = $6 + ($5 + ($4 - $2 | 0) | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
       HEAP32[(0 + 1178324 | 0) >> 2] = 2097152;
       $2 = $3;
      }
      if (($2 | 0) != (0 - (dlmalloc__dlmalloc__Dlmalloc_A___release_unused_segments__h6fd37e9ed5a3fc9c() | 0) | 0 | 0)) {
       break label$2
      }
      if ((HEAP32[(0 + 1178288 | 0) >> 2] | 0) >>> 0 <= (HEAP32[(0 + 1178324 | 0) >> 2] | 0) >>> 0) {
       break label$2
      }
      HEAP32[(0 + 1178324 | 0) >> 2] = -1;
      return;
     }
     $3 = dlmalloc__dlmalloc__Chunk__size__hbcf51483386243e4($2 | 0) | 0;
     $1 = $3 + $1 | 0;
     label$18 : {
      label$19 : {
       if ($3 >>> 0 < 256 >>> 0) {
        break label$19
       }
       dlmalloc__dlmalloc__Dlmalloc_A___unlink_large_chunk__h107571aa99375aaf($2 | 0);
       break label$18;
      }
      label$20 : {
       $4 = HEAP32[($2 + 12 | 0) >> 2] | 0;
       $2 = HEAP32[($2 + 8 | 0) >> 2] | 0;
       if (($4 | 0) == ($2 | 0)) {
        break label$20
       }
       HEAP32[($2 + 12 | 0) >> 2] = $4;
       HEAP32[($4 + 8 | 0) >> 2] = $2;
       break label$18;
      }
      (wasm2js_i32$0 = 0, wasm2js_i32$1 = (HEAP32[(0 + 1177884 | 0) >> 2] | 0) & (__wasm_rotl_i32(-2 | 0, $3 >>> 3 | 0 | 0) | 0) | 0), HEAP32[(wasm2js_i32$0 + 1177884 | 0) >> 2] = wasm2js_i32$1;
     }
     dlmalloc__dlmalloc__Chunk__set_size_and_pinuse_of_free_chunk__hbc4027d35960d532($0 | 0, $1 | 0);
     if (($0 | 0) != (HEAP32[(0 + 1178292 | 0) >> 2] | 0 | 0)) {
      break label$8
     }
     HEAP32[(0 + 1178284 | 0) >> 2] = $1;
     break label$2;
    }
    if ($1 >>> 0 < 256 >>> 0) {
     break label$1
    }
    dlmalloc__dlmalloc__Dlmalloc_A___insert_large_chunk__h524840f32df7e3d2($0 | 0, $1 | 0);
    $0 = (HEAP32[(0 + 1178332 | 0) >> 2] | 0) + -1 | 0;
    HEAP32[(0 + 1178332 | 0) >> 2] = $0;
    if ($0) {
     break label$2
    }
    dlmalloc__dlmalloc__Dlmalloc_A___release_unused_segments__h6fd37e9ed5a3fc9c() | 0;
    return;
   }
   return;
  }
  $2 = $1 >>> 3 | 0;
  $1 = ($2 << 3 | 0) + 1177892 | 0;
  label$21 : {
   label$22 : {
    $3 = HEAP32[(0 + 1177884 | 0) >> 2] | 0;
    $2 = 1 << $2 | 0;
    if (!($3 & $2 | 0)) {
     break label$22
    }
    $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    break label$21;
   }
   HEAP32[(0 + 1177884 | 0) >> 2] = $3 | $2 | 0;
   $2 = $1;
  }
  HEAP32[($1 + 8 | 0) >> 2] = $0;
  HEAP32[($2 + 12 | 0) >> 2] = $0;
  HEAP32[($0 + 12 | 0) >> 2] = $1;
  HEAP32[($0 + 8 | 0) >> 2] = $2;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__Relays___deserialize__h9918765c1fb6ecbf($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $3 = 0, $10 = 0, $5 = 0, $7 = 0, $10$hi = 0, $11 = 0, $11$hi = 0, $35 = 0, $36 = 0, $37 = 0, $38 = 0, $39 = 0, $40 = 0, $41 = 0, $42 = 0, $43 = 0, $44 = 0, $45 = 0, $46 = 0, $47 = 0, $48 = 0, $49 = 0, $50 = 0, $4 = 0, $6 = 0, $8 = 0, $9 = 0, $12 = 0, $12$hi = 0, $164 = 0, $169 = 0, $186 = 0, $190 = 0, $224 = 0, $230 = 0, $234 = 0, $239 = 0, $245 = 0, $249 = 0, $261 = 0, $265 = 0, $271 = 0, $277 = 0, $304 = 0;
  $2 = global$0 - 336 | 0;
  global$0 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 20 | 0) >> 2] = 0;
  HEAP32[($2 + 24 | 0) >> 2] = i64toi32_i32$0;
  $3 = 0;
  HEAP32[($2 + 16 | 0) >> 2] = HEAP32[(0 + 1050220 | 0) >> 2] | 0;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 264 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = ($2 + 264 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 272 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 276 | 0) >> 2] | 0;
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 264 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 268 | 0) >> 2] | 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
         break label$6
        }
        i64toi32_i32$2 = $10$hi;
        $4 = $10;
        label$7 : {
         i64toi32_i32$2 = $11$hi;
         i64toi32_i32$3 = $11;
         i64toi32_i32$1 = 0;
         i64toi32_i32$0 = 1;
         if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
          break label$7
         }
         if (!$4) {
          break label$3
         }
        }
        $5 = $2 + 273 | 0;
        $6 = $5 + 3 | 0;
        label$8 : {
         label$9 : while (1) {
          std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 8 | 0 | 0, $1 | 0);
          $3 = 0;
          $7 = 2;
          label$10 : {
           if (HEAP32[($2 + 12 | 0) >> 2] | 0) {
            break label$10
           }
           i64toi32_i32$3 = 0;
           $11 = 8;
           $11$hi = i64toi32_i32$3;
           i64toi32_i32$3 = 0;
           $10 = 0;
           $10$hi = i64toi32_i32$3;
           break label$4;
          }
          label$11 : {
           if ((($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[($2 + 8 | 0) >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) == (7 | 0)) {
            break label$11
           }
           cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__RelayEnum___deserialize__hd3d69580361177a1($2 + 264 | 0 | 0, $1 | 0);
           if ((HEAP32[($2 + 264 | 0) >> 2] | 0 | 0) == (1 | 0)) {
            break label$8
           }
           HEAP32[($2 + 224 | 0) >> 2] = HEAPU8[$5 >> 0] | 0 | ((HEAPU8[($5 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($5 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($5 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $35 = $6;
           $36 = HEAPU8[$35 >> 0] | 0 | ((HEAPU8[($35 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($35 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($35 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 227 | 0) >> 0] = $36;
           HEAP8[($2 + 228 | 0) >> 0] = $36 >>> 8 | 0;
           HEAP8[($2 + 229 | 0) >> 0] = $36 >>> 16 | 0;
           HEAP8[($2 + 230 | 0) >> 0] = $36 >>> 24 | 0;
           $37 = HEAPU8[($2 + 227 | 0) >> 0] | 0 | ((HEAPU8[($2 + 228 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 229 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 230 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 211 | 0) >> 0] = $37;
           HEAP8[($2 + 212 | 0) >> 0] = $37 >>> 8 | 0;
           HEAP8[($2 + 213 | 0) >> 0] = $37 >>> 16 | 0;
           HEAP8[($2 + 214 | 0) >> 0] = $37 >>> 24 | 0;
           HEAP32[($2 + 208 | 0) >> 2] = HEAP32[($2 + 224 | 0) >> 2] | 0;
           HEAP32[($2 + 256 | 0) >> 2] = HEAP32[($2 + 208 | 0) >> 2] | 0;
           $38 = HEAPU8[($2 + 211 | 0) >> 0] | 0 | ((HEAPU8[($2 + 212 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 213 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 214 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 259 | 0) >> 0] = $38;
           HEAP8[($2 + 260 | 0) >> 0] = $38 >>> 8 | 0;
           HEAP8[($2 + 261 | 0) >> 0] = $38 >>> 16 | 0;
           HEAP8[($2 + 262 | 0) >> 0] = $38 >>> 24 | 0;
           $8 = HEAPU8[($2 + 272 | 0) >> 0] | 0;
           $9 = HEAP32[($2 + 268 | 0) >> 2] | 0;
           i64toi32_i32$0 = $2;
           i64toi32_i32$3 = HEAP32[($2 + 280 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($2 + 284 | 0) >> 2] | 0;
           $10 = i64toi32_i32$3;
           $10$hi = i64toi32_i32$2;
           i64toi32_i32$0 = $2;
           i64toi32_i32$2 = HEAP32[($2 + 288 | 0) >> 2] | 0;
           i64toi32_i32$3 = HEAP32[($2 + 292 | 0) >> 2] | 0;
           $12 = i64toi32_i32$2;
           $12$hi = i64toi32_i32$3;
           $39 = HEAPU8[($2 + 259 | 0) >> 0] | 0 | ((HEAPU8[($2 + 260 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 261 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 262 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 251 | 0) >> 0] = $39;
           HEAP8[($2 + 252 | 0) >> 0] = $39 >>> 8 | 0;
           HEAP8[($2 + 253 | 0) >> 0] = $39 >>> 16 | 0;
           HEAP8[($2 + 254 | 0) >> 0] = $39 >>> 24 | 0;
           HEAP32[($2 + 248 | 0) >> 2] = HEAP32[($2 + 256 | 0) >> 2] | 0;
           label$12 : {
            $7 = HEAP32[($2 + 24 | 0) >> 2] | 0;
            if ((HEAP32[($2 + 20 | 0) >> 2] | 0 | 0) != ($7 | 0)) {
             break label$12
            }
            alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h7f3f684dc85b8ad3($2 + 16 | 0 | 0, $7 | 0, 1 | 0);
            $7 = HEAP32[($2 + 24 | 0) >> 2] | 0;
           }
           $3 = (HEAP32[($2 + 16 | 0) >> 2] | 0) + Math_imul($7, 28) | 0;
           HEAP32[$3 >> 2] = $9;
           $40 = HEAP32[($2 + 248 | 0) >> 2] | 0;
           HEAP8[($3 + 5 | 0) >> 0] = $40;
           HEAP8[($3 + 6 | 0) >> 0] = $40 >>> 8 | 0;
           HEAP8[($3 + 7 | 0) >> 0] = $40 >>> 16 | 0;
           HEAP8[($3 + 8 | 0) >> 0] = $40 >>> 24 | 0;
           HEAP8[($3 + 4 | 0) >> 0] = $8;
           $41 = $3 + 8 | 0;
           $42 = HEAPU8[($2 + 251 | 0) >> 0] | 0 | ((HEAPU8[($2 + 252 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 253 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 254 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[$41 >> 0] = $42;
           HEAP8[($41 + 1 | 0) >> 0] = $42 >>> 8 | 0;
           HEAP8[($41 + 2 | 0) >> 0] = $42 >>> 16 | 0;
           HEAP8[($41 + 3 | 0) >> 0] = $42 >>> 24 | 0;
           i64toi32_i32$3 = $12$hi;
           i64toi32_i32$2 = $3 + 20 | 0;
           $43 = $12;
           HEAP8[i64toi32_i32$2 >> 0] = $43;
           HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $43 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $43 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $43 >>> 24 | 0;
           HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$3;
           HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
           i64toi32_i32$3 = $10$hi;
           i64toi32_i32$2 = $3 + 12 | 0;
           HEAP8[i64toi32_i32$2 >> 0] = $10;
           HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $10 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $10 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $10 >>> 24 | 0;
           HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$3;
           HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
           HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
           HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
           $3 = $7 + 1 | 0;
           HEAP32[($2 + 24 | 0) >> 2] = $3;
           i64toi32_i32$3 = $11$hi;
           i64toi32_i32$0 = $11;
           i64toi32_i32$2 = 0;
           i64toi32_i32$1 = 1;
           if ((i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$3 | 0) != (i64toi32_i32$2 | 0) | 0) {
            continue label$9
           }
           if ($3 >>> 0 < $4 >>> 0) {
            continue label$9
           }
           break label$3;
          }
          break label$9;
         };
         cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 264 | 0 | 0, $1 | 0);
         i64toi32_i32$1 = ($2 + 264 | 0) + 16 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
         $10 = i64toi32_i32$0;
         $10$hi = i64toi32_i32$3;
         i64toi32_i32$1 = $2;
         i64toi32_i32$3 = HEAP32[($2 + 272 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($2 + 276 | 0) >> 2] | 0;
         $11 = i64toi32_i32$3;
         $11$hi = i64toi32_i32$0;
         i64toi32_i32$1 = $2;
         i64toi32_i32$0 = HEAP32[($2 + 264 | 0) >> 2] | 0;
         i64toi32_i32$3 = HEAP32[($2 + 268 | 0) >> 2] | 0;
         i64toi32_i32$1 = i64toi32_i32$0;
         i64toi32_i32$0 = 0;
         i64toi32_i32$2 = 1;
         if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) | 0) {
          break label$5
         }
         i64toi32_i32$1 = $10$hi;
         i64toi32_i32$3 = $2 + 216 | 0;
         HEAP32[i64toi32_i32$3 >> 2] = $10;
         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$1 = $11$hi;
         i64toi32_i32$3 = $2;
         HEAP32[($2 + 208 | 0) >> 2] = $11;
         HEAP32[($2 + 212 | 0) >> 2] = i64toi32_i32$1;
         if (($11 & 255 | 0 | 0) == (5 | 0)) {
          break label$3
         }
         HEAP32[($2 + 264 | 0) >> 2] = 0;
         core__panicking__assert_failed__h96d8431cc974b591(0 | 0, $2 + 208 | 0 | 0, 1050312 | 0, $2 + 264 | 0 | 0, 1050868 | 0);
         abort();
        }
        i64toi32_i32$2 = $2 + 304 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $164 = i64toi32_i32$1;
        i64toi32_i32$1 = ($2 + 176 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $164;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
        i64toi32_i32$2 = $2 + 312 | 0;
        i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $169 = i64toi32_i32$3;
        i64toi32_i32$3 = $2 + 192 | 0;
        HEAP32[i64toi32_i32$3 >> 2] = $169;
        HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
        HEAP32[(($2 + 160 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 332 | 0) >> 2] | 0;
        HEAP32[($2 + 224 | 0) >> 2] = HEAPU8[$5 >> 0] | 0 | ((HEAPU8[($5 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($5 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($5 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $44 = $5 + 3 | 0;
        $45 = HEAPU8[$44 >> 0] | 0 | ((HEAPU8[($44 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($44 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($44 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 227 | 0) >> 0] = $45;
        HEAP8[($2 + 228 | 0) >> 0] = $45 >>> 8 | 0;
        HEAP8[($2 + 229 | 0) >> 0] = $45 >>> 16 | 0;
        HEAP8[($2 + 230 | 0) >> 0] = $45 >>> 24 | 0;
        i64toi32_i32$2 = $2 + 296 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $186 = i64toi32_i32$1;
        i64toi32_i32$1 = $2;
        HEAP32[($2 + 176 | 0) >> 2] = $186;
        HEAP32[($2 + 180 | 0) >> 2] = i64toi32_i32$3;
        i64toi32_i32$2 = $2 + 324 | 0;
        i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $190 = i64toi32_i32$3;
        i64toi32_i32$3 = $2;
        HEAP32[($2 + 160 | 0) >> 2] = $190;
        HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
        $3 = HEAP32[($2 + 320 | 0) >> 2] | 0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$1 = HEAP32[($2 + 280 | 0) >> 2] | 0;
        i64toi32_i32$3 = HEAP32[($2 + 284 | 0) >> 2] | 0;
        $11 = i64toi32_i32$1;
        $11$hi = i64toi32_i32$3;
        i64toi32_i32$2 = $2;
        i64toi32_i32$3 = HEAP32[($2 + 288 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 292 | 0) >> 2] | 0;
        $10 = i64toi32_i32$3;
        $10$hi = i64toi32_i32$1;
        $7 = HEAPU8[($2 + 272 | 0) >> 0] | 0;
        $46 = HEAPU8[($2 + 227 | 0) >> 0] | 0 | ((HEAPU8[($2 + 228 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 229 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 230 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 211 | 0) >> 0] = $46;
        HEAP8[($2 + 212 | 0) >> 0] = $46 >>> 8 | 0;
        HEAP8[($2 + 213 | 0) >> 0] = $46 >>> 16 | 0;
        HEAP8[($2 + 214 | 0) >> 0] = $46 >>> 24 | 0;
        HEAP32[($2 + 208 | 0) >> 2] = HEAP32[($2 + 224 | 0) >> 2] | 0;
        $47 = HEAPU8[($2 + 211 | 0) >> 0] | 0 | ((HEAPU8[($2 + 212 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 213 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 214 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 259 | 0) >> 0] = $47;
        HEAP8[($2 + 260 | 0) >> 0] = $47 >>> 8 | 0;
        HEAP8[($2 + 261 | 0) >> 0] = $47 >>> 16 | 0;
        HEAP8[($2 + 262 | 0) >> 0] = $47 >>> 24 | 0;
        HEAP32[($2 + 256 | 0) >> 2] = HEAP32[($2 + 208 | 0) >> 2] | 0;
        HEAP32[($2 + 200 | 0) >> 2] = HEAP32[($2 + 256 | 0) >> 2] | 0;
        $48 = HEAPU8[($2 + 259 | 0) >> 0] | 0 | ((HEAPU8[($2 + 260 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 261 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 262 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 203 | 0) >> 0] = $48;
        HEAP8[($2 + 204 | 0) >> 0] = $48 >>> 8 | 0;
        HEAP8[($2 + 205 | 0) >> 0] = $48 >>> 16 | 0;
        HEAP8[($2 + 206 | 0) >> 0] = $48 >>> 24 | 0;
        if (($7 | 0) != (19 | 0)) {
         break label$4
        }
        break label$3;
       }
       i64toi32_i32$2 = $2 + 296 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $224 = i64toi32_i32$1;
       i64toi32_i32$1 = $2 + 184 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $224;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
       i64toi32_i32$2 = $2 + 304 | 0;
       i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $230 = i64toi32_i32$3;
       i64toi32_i32$3 = ($2 + 176 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$3 >> 2] = $230;
       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $2 + 288 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $234 = i64toi32_i32$1;
       i64toi32_i32$1 = $2;
       HEAP32[($2 + 176 | 0) >> 2] = $234;
       HEAP32[($2 + 180 | 0) >> 2] = i64toi32_i32$3;
       $7 = 2;
       break label$4;
      }
      i64toi32_i32$2 = $2 + 296 | 0;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $239 = i64toi32_i32$3;
      i64toi32_i32$3 = $2 + 184 | 0;
      HEAP32[i64toi32_i32$3 >> 2] = $239;
      HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $2 + 304 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $245 = i64toi32_i32$1;
      i64toi32_i32$1 = ($2 + 176 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $245;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
      i64toi32_i32$2 = $2 + 288 | 0;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $249 = i64toi32_i32$3;
      i64toi32_i32$3 = $2;
      HEAP32[($2 + 176 | 0) >> 2] = $249;
      HEAP32[($2 + 180 | 0) >> 2] = i64toi32_i32$1;
     }
     i64toi32_i32$1 = $10$hi;
     i64toi32_i32$3 = ($2 + 264 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $10;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $11$hi;
     i64toi32_i32$3 = ($2 + 264 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $11;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAP32[($2 + 176 | 0) >> 2] | 0;
     i64toi32_i32$3 = HEAP32[($2 + 180 | 0) >> 2] | 0;
     $261 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 288 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $261;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$2 = $2;
     i64toi32_i32$3 = HEAP32[($2 + 160 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 164 | 0) >> 2] | 0;
     $265 = i64toi32_i32$3;
     i64toi32_i32$3 = $2 + 316 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $265;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = ($2 + 176 | 0) + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $271 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 296 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $271;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$2 = ($2 + 176 | 0) + 16 | 0;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $277 = i64toi32_i32$3;
     i64toi32_i32$3 = $2 + 304 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $277;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($2 + 324 | 0) >> 2] = HEAP32[(($2 + 160 | 0) + 8 | 0) >> 2] | 0;
     HEAP8[($2 + 264 | 0) >> 0] = $7;
     $49 = HEAP32[($2 + 200 | 0) >> 2] | 0;
     HEAP8[($2 + 265 | 0) >> 0] = $49;
     HEAP8[($2 + 266 | 0) >> 0] = $49 >>> 8 | 0;
     HEAP8[($2 + 267 | 0) >> 0] = $49 >>> 16 | 0;
     HEAP8[($2 + 268 | 0) >> 0] = $49 >>> 24 | 0;
     $50 = HEAPU8[($2 + 203 | 0) >> 0] | 0 | ((HEAPU8[($2 + 204 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 205 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 206 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($2 + 268 | 0) >> 0] = $50;
     HEAP8[($2 + 269 | 0) >> 0] = $50 >>> 8 | 0;
     HEAP8[($2 + 270 | 0) >> 0] = $50 >>> 16 | 0;
     HEAP8[($2 + 271 | 0) >> 0] = $50 >>> 24 | 0;
     HEAP32[($2 + 312 | 0) >> 2] = $3;
     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($2 + 96 | 0 | 0, $2 + 264 | 0 | 0, 1050884 | 0, 6 | 0);
     $1 = HEAPU8[($2 + 96 | 0) >> 0] | 0;
     if (($1 | 0) != (19 | 0)) {
      break label$2
     }
    }
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
    i64toi32_i32$3 = HEAP32[($2 + 20 | 0) >> 2] | 0;
    $304 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $304;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$3;
    HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = HEAP32[($2 + 24 | 0) >> 2] | 0;
    $3 = 0;
    break label$1;
   }
   $3 = 1;
   memcpy($2 + 33 | 0 | 0, $2 + 96 | 0 | 1 | 0 | 0, 63 | 0) | 0;
   HEAP8[($0 + 8 | 0) >> 0] = $1;
   memcpy($0 + 9 | 0 | 0, $2 + 33 | 0 | 0, 63 | 0) | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hb600accf9d1c2a17($2 + 16 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h96b3170d440e3692($2 + 16 | 0 | 0);
  }
  HEAP32[$0 >> 2] = $3;
  global$0 = $2 + 336 | 0;
 }
 
 function core__fmt__Formatter__pad__h381b7c9eef015e8b($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $9 = 0, $3 = 0, $8 = 0, $5 = 0, $7 = 0, $6 = 0, $10 = 0, $4 = 0, $11 = 0, $12 = 0, $13 = 0;
  $3 = HEAP32[($0 + 16 | 0) >> 2] | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $4 = HEAP32[($0 + 8 | 0) >> 2] | 0;
      if (($4 | 0) == (1 | 0)) {
       break label$4
      }
      if (($3 | 0) == (1 | 0)) {
       break label$3
      }
      $3 = FUNCTION_TABLE[HEAP32[((HEAP32[($0 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($0 + 24 | 0) >> 2] | 0, $1, $2) | 0;
      break label$1;
     }
     if (($3 | 0) != (1 | 0)) {
      break label$2
     }
    }
    $5 = $1 + $2 | 0;
    label$5 : {
     label$6 : {
      label$7 : {
       $6 = HEAP32[($0 + 20 | 0) >> 2] | 0;
       if ($6) {
        break label$7
       }
       $7 = 0;
       $8 = $1;
       break label$6;
      }
      $7 = 0;
      $9 = $1;
      label$8 : while (1) {
       $3 = $9;
       if (($3 | 0) == ($5 | 0)) {
        break label$5
       }
       $8 = $3 + 1 | 0;
       label$9 : {
        label$10 : {
         $9 = HEAP8[$3 >> 0] | 0;
         if (($9 | 0) <= (-1 | 0)) {
          break label$10
         }
         $9 = $8;
         break label$9;
        }
        $10 = $9 & 255 | 0;
        label$11 : {
         label$12 : {
          if (($8 | 0) != ($5 | 0)) {
           break label$12
          }
          $11 = 0;
          $9 = $5;
          break label$11;
         }
         $9 = $3 + 2 | 0;
         $11 = (HEAPU8[($3 + 1 | 0) >> 0] | 0) & 63 | 0;
        }
        label$13 : {
         if ($10 >>> 0 >= 224 >>> 0) {
          break label$13
         }
         $8 = $9;
         break label$9;
        }
        label$14 : {
         label$15 : {
          if (($9 | 0) != ($5 | 0)) {
           break label$15
          }
          $12 = 0;
          $8 = $5;
          break label$14;
         }
         $8 = $9 + 1 | 0;
         $12 = (HEAPU8[$9 >> 0] | 0) & 63 | 0;
        }
        label$16 : {
         if ($10 >>> 0 >= 240 >>> 0) {
          break label$16
         }
         $9 = $8;
         break label$9;
        }
        label$17 : {
         label$18 : {
          if (($8 | 0) != ($5 | 0)) {
           break label$18
          }
          $13 = 0;
          $9 = $5;
          break label$17;
         }
         $13 = (HEAPU8[$8 >> 0] | 0) & 63 | 0;
         $9 = $8 + 1 | 0;
         $8 = $9;
        }
        if (($11 << 12 | 0 | (($10 << 18 | 0) & 1835008 | 0) | 0 | ($12 << 6 | 0) | 0 | $13 | 0 | 0) == (1114112 | 0)) {
         break label$5
        }
       }
       $7 = ($7 - $3 | 0) + $9 | 0;
       $6 = $6 + -1 | 0;
       if ($6) {
        continue label$8
       }
       break label$8;
      };
     }
     if (($8 | 0) == ($5 | 0)) {
      break label$5
     }
     label$19 : {
      $3 = HEAP8[$8 >> 0] | 0;
      if (($3 | 0) > (-1 | 0)) {
       break label$19
      }
      label$20 : {
       label$21 : {
        if (($8 + 1 | 0 | 0) != ($5 | 0)) {
         break label$21
        }
        $8 = 0;
        $9 = $5;
        break label$20;
       }
       $9 = $8 + 2 | 0;
       $8 = ((HEAPU8[($8 + 1 | 0) >> 0] | 0) & 63 | 0) << 12 | 0;
      }
      if (($3 & 255 | 0) >>> 0 < 224 >>> 0) {
       break label$19
      }
      label$22 : {
       label$23 : {
        if (($9 | 0) != ($5 | 0)) {
         break label$23
        }
        $9 = 0;
        $6 = $5;
        break label$22;
       }
       $6 = $9 + 1 | 0;
       $9 = ((HEAPU8[$9 >> 0] | 0) & 63 | 0) << 6 | 0;
      }
      if (($3 & 255 | 0) >>> 0 < 240 >>> 0) {
       break label$19
      }
      $3 = $3 & 255 | 0;
      label$24 : {
       label$25 : {
        if (($6 | 0) != ($5 | 0)) {
         break label$25
        }
        $5 = 0;
        break label$24;
       }
       $5 = (HEAPU8[$6 >> 0] | 0) & 63 | 0;
      }
      if (($8 | (($3 << 18 | 0) & 1835008 | 0) | 0 | $9 | 0 | $5 | 0 | 0) == (1114112 | 0)) {
       break label$5
      }
     }
     label$26 : {
      label$27 : {
       label$28 : {
        if ($7) {
         break label$28
        }
        $9 = 0;
        break label$27;
       }
       label$29 : {
        if ($7 >>> 0 < $2 >>> 0) {
         break label$29
        }
        $3 = 0;
        $9 = $2;
        if (($7 | 0) == ($9 | 0)) {
         break label$27
        }
        break label$26;
       }
       $3 = 0;
       $9 = $7;
       if ((HEAP8[($1 + $9 | 0) >> 0] | 0 | 0) < (-64 | 0)) {
        break label$26
       }
      }
      $7 = $9;
      $3 = $1;
     }
     $2 = $3 ? $7 : $2;
     $1 = $3 ? $3 : $1;
    }
    if (($4 | 0) == (1 | 0)) {
     break label$2
    }
    return FUNCTION_TABLE[HEAP32[((HEAP32[($0 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($0 + 24 | 0) >> 2] | 0, $1, $2) | 0 | 0;
   }
   label$30 : {
    label$31 : {
     label$32 : {
      if (!$2) {
       break label$32
      }
      $9 = 0;
      $8 = $2;
      $3 = $1;
      label$33 : while (1) {
       $9 = $9 + (((HEAPU8[$3 >> 0] | 0) & 192 | 0 | 0) != (128 | 0)) | 0;
       $3 = $3 + 1 | 0;
       $8 = $8 + -1 | 0;
       if ($8) {
        continue label$33
       }
       break label$33;
      };
      $7 = HEAP32[($0 + 12 | 0) >> 2] | 0;
      if ($9 >>> 0 >= $7 >>> 0) {
       break label$31
      }
      $9 = 0;
      $8 = $2;
      $3 = $1;
      label$34 : while (1) {
       $9 = $9 + (((HEAPU8[$3 >> 0] | 0) & 192 | 0 | 0) != (128 | 0)) | 0;
       $3 = $3 + 1 | 0;
       $8 = $8 + -1 | 0;
       if ($8) {
        continue label$34
       }
       break label$30;
      };
     }
     $9 = 0;
     $7 = HEAP32[($0 + 12 | 0) >> 2] | 0;
     if ($7) {
      break label$30
     }
    }
    return FUNCTION_TABLE[HEAP32[((HEAP32[($0 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($0 + 24 | 0) >> 2] | 0, $1, $2) | 0 | 0;
   }
   $3 = 0;
   $9 = $7 - $9 | 0;
   $5 = $9;
   label$35 : {
    label$36 : {
     label$37 : {
      $8 = HEAPU8[($0 + 32 | 0) >> 0] | 0;
      switch ((($8 | 0) == (3 | 0) ? 0 : $8) & 3 | 0 | 0) {
      case 2:
       break label$36;
      case 1:
       break label$37;
      default:
       break label$35;
      };
     }
     $5 = 0;
     $3 = $9;
     break label$35;
    }
    $3 = $9 >>> 1 | 0;
    $5 = ($9 + 1 | 0) >>> 1 | 0;
   }
   $3 = $3 + 1 | 0;
   $8 = HEAP32[($0 + 28 | 0) >> 2] | 0;
   $9 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   $7 = HEAP32[($0 + 24 | 0) >> 2] | 0;
   label$38 : {
    label$39 : while (1) {
     $3 = $3 + -1 | 0;
     if (!$3) {
      break label$38
     }
     if (!(FUNCTION_TABLE[HEAP32[($8 + 16 | 0) >> 2] | 0 | 0]($7, $9) | 0)) {
      continue label$39
     }
     break label$39;
    };
    return 1 | 0;
   }
   $3 = 1;
   if (($9 | 0) == (1114112 | 0)) {
    break label$1
   }
   if (FUNCTION_TABLE[HEAP32[($8 + 12 | 0) >> 2] | 0 | 0]($7, $1, $2) | 0) {
    break label$1
   }
   $3 = 0;
   label$40 : while (1) {
    label$41 : {
     if (($5 | 0) != ($3 | 0)) {
      break label$41
     }
     return $5 >>> 0 < $5 >>> 0 | 0;
    }
    $3 = $3 + 1 | 0;
    if (!(FUNCTION_TABLE[HEAP32[($8 + 16 | 0) >> 2] | 0 | 0]($7, $9) | 0)) {
     continue label$40
    }
    break label$40;
   };
   return ($3 + -1 | 0) >>> 0 < $5 >>> 0 | 0;
  }
  return $3 | 0;
 }
 
 function $cardano_serialization_lib__plutus__PlutusData_20as_20core__cmp__Ord___cmp__h6cbb090e8f573f89($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $5 = 0, $6 = 0, i64toi32_i32$0 = 0, $7 = 0, $8 = 0, $7$hi = 0, $8$hi = 0, $32 = 0, $100 = 0, $107 = 0, $110 = 0, $124 = 0, $131 = 0, $134 = 0;
  $2 = global$0 - 224 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    $3 = HEAP32[$0 >> 2] | 0;
    $4 = HEAP32[$1 >> 2] | 0;
    if (($3 | 0) == ($4 | 0)) {
     break label$2
    }
    $3 = $3 >>> 0 < $4 >>> 0 ? -1 : 1;
    break label$1;
   }
   label$3 : {
    label$4 : {
     label$5 : {
      label$6 : {
       label$7 : {
        label$8 : {
         switch ($3 | 0) {
         default:
          i64toi32_i32$2 = $0 + 8 | 0;
          i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
          $7 = i64toi32_i32$0;
          $7$hi = i64toi32_i32$1;
          i64toi32_i32$2 = $1 + 8 | 0;
          i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
          $8 = i64toi32_i32$1;
          $8$hi = i64toi32_i32$0;
          i64toi32_i32$0 = $7$hi;
          i64toi32_i32$2 = $7;
          i64toi32_i32$1 = $8$hi;
          i64toi32_i32$3 = $8;
          $32 = (i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | 0;
          i64toi32_i32$2 = i64toi32_i32$0;
          i64toi32_i32$2 = i64toi32_i32$1;
          i64toi32_i32$2 = i64toi32_i32$0;
          i64toi32_i32$3 = $7;
          i64toi32_i32$0 = i64toi32_i32$1;
          i64toi32_i32$1 = $8;
          $3 = i64toi32_i32$2 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0 | 0) | 0 ? -1 : $32;
          if ($3) {
           break label$4
          }
          $3 = $A_20as_20core__slice__cmp__SliceOrd___compare__hf1814e963025920c(HEAP32[($0 + 16 | 0) >> 2] | 0 | 0, HEAP32[($0 + 24 | 0) >> 2] | 0 | 0, HEAP32[($1 + 16 | 0) >> 2] | 0 | 0, HEAP32[($1 + 24 | 0) >> 2] | 0 | 0) | 0;
          if ($3 & 255 | 0) {
           break label$4
          }
          label$11 : {
           $3 = HEAPU8[($0 + 28 | 0) >> 0] | 0;
           $5 = ($3 | 0) != (2 | 0);
           $4 = HEAPU8[($1 + 28 | 0) >> 0] | 0;
           $6 = ($4 | 0) != (2 | 0);
           if (($5 | 0) == ($6 | 0)) {
            break label$11
           }
           $3 = $6 ? ($5 ? 1 : -1) : 1;
           break label$1;
          }
          if (($3 | 0) == (2 | 0)) {
           break label$3
          }
          if (($4 | 0) == (2 | 0)) {
           break label$3
          }
          $3 = $3 - $4 | 0;
          switch ($3 & 255 | 0 | 0) {
          case 0:
           break label$3;
          case 1:
           break label$7;
          default:
           break label$1;
          };
         case 1:
          alloc__collections__btree__map__BTreeMap_K_2cV___iter__h1146c826d3183069($2 + 96 | 0 | 0, $0 + 4 | 0 | 0);
          alloc__collections__btree__map__BTreeMap_K_2cV___iter__h1146c826d3183069($2 + 128 | 0 | 0, $1 + 4 | 0 | 0);
          HEAP32[(($2 + 160 | 0) + 24 | 0) >> 2] = HEAP32[(($2 + 96 | 0) + 24 | 0) >> 2] | 0;
          i64toi32_i32$1 = ($2 + 96 | 0) + 16 | 0;
          i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
          i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
          $100 = i64toi32_i32$3;
          i64toi32_i32$3 = ($2 + 160 | 0) + 16 | 0;
          HEAP32[i64toi32_i32$3 >> 2] = $100;
          HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
          i64toi32_i32$1 = ($2 + 96 | 0) + 8 | 0;
          i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
          i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
          $107 = i64toi32_i32$2;
          i64toi32_i32$2 = ($2 + 160 | 0) + 8 | 0;
          HEAP32[i64toi32_i32$2 >> 2] = $107;
          HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
          i64toi32_i32$1 = $2;
          i64toi32_i32$3 = HEAP32[($2 + 96 | 0) >> 2] | 0;
          i64toi32_i32$2 = HEAP32[($2 + 100 | 0) >> 2] | 0;
          $110 = i64toi32_i32$3;
          i64toi32_i32$3 = $2;
          HEAP32[($2 + 160 | 0) >> 2] = $110;
          HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$2;
          HEAP32[(($2 + 192 | 0) + 24 | 0) >> 2] = HEAP32[(($2 + 128 | 0) + 24 | 0) >> 2] | 0;
          i64toi32_i32$1 = ($2 + 128 | 0) + 16 | 0;
          i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
          i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
          $124 = i64toi32_i32$2;
          i64toi32_i32$2 = ($2 + 192 | 0) + 16 | 0;
          HEAP32[i64toi32_i32$2 >> 2] = $124;
          HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
          i64toi32_i32$1 = ($2 + 128 | 0) + 8 | 0;
          i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
          i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
          $131 = i64toi32_i32$3;
          i64toi32_i32$3 = ($2 + 192 | 0) + 8 | 0;
          HEAP32[i64toi32_i32$3 >> 2] = $131;
          HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
          i64toi32_i32$1 = $2;
          i64toi32_i32$2 = HEAP32[($2 + 128 | 0) >> 2] | 0;
          i64toi32_i32$3 = HEAP32[($2 + 132 | 0) >> 2] | 0;
          $134 = i64toi32_i32$2;
          i64toi32_i32$2 = $2;
          HEAP32[($2 + 192 | 0) >> 2] = $134;
          HEAP32[($2 + 196 | 0) >> 2] = i64toi32_i32$3;
          $3 = core__iter__traits__iterator__Iterator__cmp_by__hdd4c1d302d53018c($2 + 160 | 0 | 0, $2 + 192 | 0 | 0) | 0;
          break label$4;
         case 4:
          break label$5;
         case 3:
          break label$6;
         case 2:
          break label$8;
         };
        }
        $3 = $A_20as_20core__slice__cmp__SliceOrd___compare__hf1814e963025920c(HEAP32[($0 + 4 | 0) >> 2] | 0 | 0, HEAP32[($0 + 12 | 0) >> 2] | 0 | 0, HEAP32[($1 + 4 | 0) >> 2] | 0 | 0, HEAP32[($1 + 12 | 0) >> 2] | 0 | 0) | 0;
        if ($3 & 255 | 0) {
         break label$4
        }
        label$12 : {
         $3 = HEAPU8[($0 + 16 | 0) >> 0] | 0;
         $5 = ($3 | 0) != (2 | 0);
         $4 = HEAPU8[($1 + 16 | 0) >> 0] | 0;
         $6 = ($4 | 0) != (2 | 0);
         if (($5 | 0) == ($6 | 0)) {
          break label$12
         }
         $3 = $6 ? ($5 ? 1 : -1) : 1;
         break label$1;
        }
        if (($3 | 0) == (2 | 0)) {
         break label$3
        }
        if (($4 | 0) == (2 | 0)) {
         break label$3
        }
        $3 = $3 - $4 | 0;
        switch ($3 & 255 | 0 | 0) {
        case 0:
         break label$3;
        case 1:
         break label$7;
        default:
         break label$1;
        };
       }
       $3 = 1;
       break label$1;
      }
      label$13 : {
       $3 = HEAPU8[($0 + 16 | 0) >> 0] | 0;
       $4 = HEAPU8[($1 + 16 | 0) >> 0] | 0;
       if (($3 | 0) == ($4 | 0)) {
        break label$13
       }
       $3 = $3 >>> 0 < $4 >>> 0 ? -1 : 1;
       break label$1;
      }
      $4 = $1 + 4 | 0;
      $5 = $0 + 4 | 0;
      label$14 : {
       switch ($3 | 0) {
       default:
        $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h7a0ed8a251b429e6($2 + 40 | 0 | 0, $4 | 0);
        $6 = HEAP32[($2 + 40 | 0) >> 2] | 0;
        $4 = HEAP32[($2 + 44 | 0) >> 2] | 0;
        $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h7a0ed8a251b429e6($2 + 32 | 0 | 0, $5 | 0);
        $5 = HEAP32[($2 + 36 | 0) >> 2] | 0;
        $3 = $4 >>> 0 < $5 >>> 0 ? -1 : ($4 | 0) != ($5 | 0);
        if ($3) {
         break label$4
        }
        $3 = HEAP32[($2 + 32 | 0) >> 2] | 0;
        core__iter__adapters__rev__Rev_T___new__h91ca0d56df8c38ae($2 + 24 | 0 | 0, $6 | 0, $6 + ($4 << 2 | 0) | 0 | 0);
        $4 = HEAP32[($2 + 28 | 0) >> 2] | 0;
        $6 = HEAP32[($2 + 24 | 0) >> 2] | 0;
        core__iter__adapters__rev__Rev_T___new__h91ca0d56df8c38ae($2 + 16 | 0 | 0, $3 | 0, $3 + ($5 << 2 | 0) | 0 | 0);
        $3 = core__iter__traits__iterator__Iterator__cmp__he292810785df7a3c($6 | 0, $4 | 0, HEAP32[($2 + 16 | 0) >> 2] | 0 | 0, HEAP32[($2 + 20 | 0) >> 2] | 0 | 0) | 0;
        break label$4;
       case 2:
        break label$14;
       case 1:
        break label$3;
       };
      }
      $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h7a0ed8a251b429e6($2 + 72 | 0 | 0, $5 | 0);
      $6 = HEAP32[($2 + 72 | 0) >> 2] | 0;
      $5 = HEAP32[($2 + 76 | 0) >> 2] | 0;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h7a0ed8a251b429e6($2 + 64 | 0 | 0, $4 | 0);
      $4 = HEAP32[($2 + 68 | 0) >> 2] | 0;
      $3 = $5 >>> 0 < $4 >>> 0 ? -1 : ($5 | 0) != ($4 | 0);
      if ($3) {
       break label$4
      }
      $3 = HEAP32[($2 + 64 | 0) >> 2] | 0;
      core__iter__adapters__rev__Rev_T___new__h91ca0d56df8c38ae($2 + 56 | 0 | 0, $6 | 0, $6 + ($5 << 2 | 0) | 0 | 0);
      $5 = HEAP32[($2 + 60 | 0) >> 2] | 0;
      $6 = HEAP32[($2 + 56 | 0) >> 2] | 0;
      core__iter__adapters__rev__Rev_T___new__h91ca0d56df8c38ae($2 + 48 | 0 | 0, $3 | 0, $3 + ($4 << 2 | 0) | 0 | 0);
      $3 = core__iter__traits__iterator__Iterator__cmp__he292810785df7a3c($6 | 0, $5 | 0, HEAP32[($2 + 48 | 0) >> 2] | 0 | 0, HEAP32[($2 + 52 | 0) >> 2] | 0 | 0) | 0;
      break label$4;
     }
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 88 | 0 | 0, $0 + 4 | 0 | 0);
     $3 = HEAP32[($2 + 92 | 0) >> 2] | 0;
     $4 = HEAP32[($2 + 88 | 0) >> 2] | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 80 | 0 | 0, $1 + 4 | 0 | 0);
     $3 = core__slice__cmp___impl_20core__cmp__Ord_20for_20_5bT_5d___cmp__h1f2092e0ba2f27ea($4 | 0, $3 | 0, HEAP32[($2 + 80 | 0) >> 2] | 0 | 0, HEAP32[($2 + 84 | 0) >> 2] | 0 | 0) | 0;
    }
    if ($3 & 255 | 0) {
     break label$1
    }
   }
   $3 = 0;
   label$16 : {
    $4 = HEAP32[($0 + 32 | 0) >> 2] | 0;
    $5 = HEAP32[($1 + 32 | 0) >> 2] | 0;
    if ((($4 | 0) != (0 | 0) | 0) == (($5 | 0) != (0 | 0) | 0)) {
     break label$16
    }
    $3 = $5 ? ($4 ? 1 : -1) : 1;
    break label$1;
   }
   if (!$4) {
    break label$1
   }
   if (!$5) {
    break label$1
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $0 + 32 | 0 | 0);
   $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 | 0, $1 + 32 | 0 | 0);
   $3 = core__slice__cmp___impl_20core__cmp__Ord_20for_20_5bT_5d___cmp__h1f2092e0ba2f27ea($3 | 0, $0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0) | 0;
  }
  global$0 = $2 + 224 | 0;
  return $3 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__Ed25519KeyHashes___deserialize__hae609f6be80519f0($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, $3 = 0, $10 = 0, i64toi32_i32$4 = 0, $5 = 0, $8 = 0, $10$hi = 0, $11 = 0, $11$hi = 0, $40 = 0, $41 = 0, $42 = 0, $43 = 0, $44 = 0, $45 = 0, $46 = 0, $47 = 0, $48 = 0, $49 = 0, $50 = 0, $51 = 0, $52 = 0, $53 = 0, $54 = 0, $55 = 0, $56 = 0, $57 = 0, $4 = 0, $58 = 0, $59 = 0, $6 = 0, $7 = 0, $82 = 0, $82$hi = 0, $85$hi = 0, $9 = 0, $12 = 0, $12$hi = 0, $128 = 0, $171 = 0, $176 = 0, $193 = 0, $197 = 0, $219 = 0, $225 = 0, $229 = 0, $234 = 0, $240 = 0, $244 = 0, $256 = 0, $260 = 0, $266 = 0, $272 = 0, $299 = 0;
  $2 = global$0 - 320 | 0;
  global$0 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 12 | 0) >> 2] = 0;
  HEAP32[($2 + 16 | 0) >> 2] = i64toi32_i32$0;
  $3 = 0;
  HEAP32[($2 + 8 | 0) >> 2] = HEAP32[(0 + 1050212 | 0) >> 2] | 0;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 248 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = ($2 + 248 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 256 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 260 | 0) >> 2] | 0;
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 248 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 252 | 0) >> 2] | 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
         break label$6
        }
        i64toi32_i32$2 = $10$hi;
        $4 = $10;
        label$7 : {
         i64toi32_i32$2 = $11$hi;
         i64toi32_i32$3 = $11;
         i64toi32_i32$1 = 0;
         i64toi32_i32$0 = 1;
         if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
          break label$7
         }
         if (!$4) {
          break label$3
         }
        }
        $5 = $2 + 257 | 0;
        $6 = $2 + 248 | 0 | 1 | 0;
        $7 = ($2 + 248 | 0) + 28 | 0;
        label$8 : {
         label$9 : while (1) {
          std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 | 0, $1 | 0);
          $3 = 0;
          $8 = 2;
          label$10 : {
           if (HEAP32[($2 + 4 | 0) >> 2] | 0) {
            break label$10
           }
           i64toi32_i32$3 = 0;
           $11 = 8;
           $11$hi = i64toi32_i32$3;
           i64toi32_i32$3 = 0;
           $10 = 0;
           $10$hi = i64toi32_i32$3;
           break label$4;
          }
          label$11 : {
           if ((($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[$2 >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) == (7 | 0)) {
            break label$11
           }
           $cardano_serialization_lib__crypto__Ed25519KeyHash_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h495effbb534e290f($2 + 248 | 0 | 0, $1 | 0);
           if ((HEAPU8[($2 + 248 | 0) >> 0] | 0 | 0) == (1 | 0)) {
            break label$8
           }
           HEAP32[($2 + 216 | 0) >> 2] = HEAPU8[$5 >> 0] | 0 | ((HEAPU8[($5 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($5 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($5 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $41 = $5 + 3 | 0;
           $42 = HEAPU8[$41 >> 0] | 0 | ((HEAPU8[($41 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($41 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($41 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 219 | 0) >> 0] = $42;
           HEAP8[($2 + 220 | 0) >> 0] = $42 >>> 8 | 0;
           HEAP8[($2 + 221 | 0) >> 0] = $42 >>> 16 | 0;
           HEAP8[($2 + 222 | 0) >> 0] = $42 >>> 24 | 0;
           $40 = $6;
           HEAP32[($2 + 200 | 0) >> 2] = HEAPU8[$40 >> 0] | 0 | ((HEAPU8[($40 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($40 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($40 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $43 = $40 + 3 | 0;
           $44 = HEAPU8[$43 >> 0] | 0 | ((HEAPU8[($43 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($43 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($43 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 203 | 0) >> 0] = $44;
           HEAP8[($2 + 204 | 0) >> 0] = $44 >>> 8 | 0;
           HEAP8[($2 + 205 | 0) >> 0] = $44 >>> 16 | 0;
           HEAP8[($2 + 206 | 0) >> 0] = $44 >>> 24 | 0;
           HEAP32[($2 + 240 | 0) >> 2] = HEAP32[($2 + 216 | 0) >> 2] | 0;
           $45 = HEAPU8[($2 + 219 | 0) >> 0] | 0 | ((HEAPU8[($2 + 220 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 221 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 222 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 243 | 0) >> 0] = $45;
           HEAP8[($2 + 244 | 0) >> 0] = $45 >>> 8 | 0;
           HEAP8[($2 + 245 | 0) >> 0] = $45 >>> 16 | 0;
           HEAP8[($2 + 246 | 0) >> 0] = $45 >>> 24 | 0;
           i64toi32_i32$0 = $2;
           i64toi32_i32$3 = HEAP32[($2 + 272 | 0) >> 2] | 0;
           i64toi32_i32$2 = 0;
           $82 = i64toi32_i32$3;
           $82$hi = i64toi32_i32$2;
           i64toi32_i32$0 = $7;
           i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0;
           i64toi32_i32$3 = 0;
           i64toi32_i32$0 = i64toi32_i32$2;
           i64toi32_i32$2 = 0;
           i64toi32_i32$1 = 32;
           i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
           if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
            i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
            $58 = 0;
           } else {
            i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$4 | 0) | 0;
            $58 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
           }
           $85$hi = i64toi32_i32$2;
           i64toi32_i32$2 = $82$hi;
           i64toi32_i32$3 = $82;
           i64toi32_i32$0 = $85$hi;
           i64toi32_i32$1 = $58;
           i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
           $10 = i64toi32_i32$3 | i64toi32_i32$1 | 0;
           $10$hi = i64toi32_i32$0;
           $9 = HEAPU8[($2 + 256 | 0) >> 0] | 0;
           i64toi32_i32$2 = $2;
           i64toi32_i32$0 = HEAP32[($2 + 264 | 0) >> 2] | 0;
           i64toi32_i32$3 = HEAP32[($2 + 268 | 0) >> 2] | 0;
           $12 = i64toi32_i32$0;
           $12$hi = i64toi32_i32$3;
           label$12 : {
            $8 = HEAP32[($2 + 16 | 0) >> 2] | 0;
            if ((HEAP32[($2 + 12 | 0) >> 2] | 0 | 0) != ($8 | 0)) {
             break label$12
            }
            alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h75690594b6280ac0($2 + 8 | 0 | 0, $8 | 0, 1 | 0);
            $8 = HEAP32[($2 + 16 | 0) >> 2] | 0;
           }
           $3 = (HEAP32[($2 + 8 | 0) >> 2] | 0) + Math_imul($8, 28) | 0;
           $46 = HEAP32[($2 + 200 | 0) >> 2] | 0;
           HEAP8[$3 >> 0] = $46;
           HEAP8[($3 + 1 | 0) >> 0] = $46 >>> 8 | 0;
           HEAP8[($3 + 2 | 0) >> 0] = $46 >>> 16 | 0;
           HEAP8[($3 + 3 | 0) >> 0] = $46 >>> 24 | 0;
           HEAP8[($3 + 7 | 0) >> 0] = $9;
           $47 = HEAP32[($2 + 240 | 0) >> 2] | 0;
           HEAP8[($3 + 8 | 0) >> 0] = $47;
           HEAP8[($3 + 9 | 0) >> 0] = $47 >>> 8 | 0;
           HEAP8[($3 + 10 | 0) >> 0] = $47 >>> 16 | 0;
           HEAP8[($3 + 11 | 0) >> 0] = $47 >>> 24 | 0;
           i64toi32_i32$3 = $10$hi;
           HEAP8[($3 + 23 | 0) >> 0] = $10;
           HEAP8[($3 + 24 | 0) >> 0] = $10 >>> 8 | 0;
           HEAP8[($3 + 25 | 0) >> 0] = $10 >>> 16 | 0;
           HEAP8[($3 + 26 | 0) >> 0] = $10 >>> 24 | 0;
           i64toi32_i32$3 = $12$hi;
           i64toi32_i32$0 = $3;
           $48 = $12;
           HEAP8[(i64toi32_i32$0 + 15 | 0) >> 0] = $48;
           HEAP8[(i64toi32_i32$0 + 16 | 0) >> 0] = $48 >>> 8 | 0;
           HEAP8[(i64toi32_i32$0 + 17 | 0) >> 0] = $48 >>> 16 | 0;
           HEAP8[(i64toi32_i32$0 + 18 | 0) >> 0] = $48 >>> 24 | 0;
           HEAP8[(i64toi32_i32$0 + 19 | 0) >> 0] = i64toi32_i32$3;
           HEAP8[(i64toi32_i32$0 + 20 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
           HEAP8[(i64toi32_i32$0 + 21 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
           HEAP8[(i64toi32_i32$0 + 22 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
           $49 = i64toi32_i32$0 + 3 | 0;
           $50 = HEAPU8[($2 + 203 | 0) >> 0] | 0 | ((HEAPU8[($2 + 204 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 205 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 206 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[$49 >> 0] = $50;
           HEAP8[($49 + 1 | 0) >> 0] = $50 >>> 8 | 0;
           HEAP8[($49 + 2 | 0) >> 0] = $50 >>> 16 | 0;
           HEAP8[($49 + 3 | 0) >> 0] = $50 >>> 24 | 0;
           $51 = i64toi32_i32$0 + 11 | 0;
           $52 = HEAPU8[($2 + 243 | 0) >> 0] | 0 | ((HEAPU8[($2 + 244 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 245 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 246 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[$51 >> 0] = $52;
           HEAP8[($51 + 1 | 0) >> 0] = $52 >>> 8 | 0;
           HEAP8[($51 + 2 | 0) >> 0] = $52 >>> 16 | 0;
           HEAP8[($51 + 3 | 0) >> 0] = $52 >>> 24 | 0;
           $128 = i64toi32_i32$0 + 27 | 0;
           i64toi32_i32$3 = $10$hi;
           i64toi32_i32$2 = $10;
           i64toi32_i32$0 = 0;
           i64toi32_i32$1 = 32;
           i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
           if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
            i64toi32_i32$0 = 0;
            $59 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
           } else {
            i64toi32_i32$0 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
            $59 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
           }
           HEAP8[$128 >> 0] = $59;
           $3 = $8 + 1 | 0;
           HEAP32[($2 + 16 | 0) >> 2] = $3;
           i64toi32_i32$0 = $11$hi;
           i64toi32_i32$3 = $11;
           i64toi32_i32$2 = 0;
           i64toi32_i32$1 = 1;
           if ((i64toi32_i32$3 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$2 | 0) | 0) {
            continue label$9
           }
           if ($3 >>> 0 < $4 >>> 0) {
            continue label$9
           }
           break label$3;
          }
          break label$9;
         };
         cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 248 | 0 | 0, $1 | 0);
         i64toi32_i32$1 = ($2 + 248 | 0) + 16 | 0;
         i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
         $10 = i64toi32_i32$3;
         $10$hi = i64toi32_i32$0;
         i64toi32_i32$1 = $2;
         i64toi32_i32$0 = HEAP32[($2 + 256 | 0) >> 2] | 0;
         i64toi32_i32$3 = HEAP32[($2 + 260 | 0) >> 2] | 0;
         $11 = i64toi32_i32$0;
         $11$hi = i64toi32_i32$3;
         i64toi32_i32$1 = $2;
         i64toi32_i32$3 = HEAP32[($2 + 248 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($2 + 252 | 0) >> 2] | 0;
         i64toi32_i32$1 = i64toi32_i32$3;
         i64toi32_i32$3 = 0;
         i64toi32_i32$2 = 1;
         if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) | 0) {
          break label$5
         }
         i64toi32_i32$1 = $10$hi;
         i64toi32_i32$0 = $2 + 208 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $10;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$1 = $11$hi;
         i64toi32_i32$0 = $2;
         HEAP32[($2 + 200 | 0) >> 2] = $11;
         HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$1;
         if (($11 & 255 | 0 | 0) == (5 | 0)) {
          break label$3
         }
         HEAP32[($2 + 248 | 0) >> 2] = 0;
         core__panicking__assert_failed__h96d8431cc974b591(0 | 0, $2 + 200 | 0 | 0, 1050312 | 0, $2 + 248 | 0 | 0, 1050836 | 0);
         abort();
        }
        i64toi32_i32$2 = $2 + 288 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $171 = i64toi32_i32$1;
        i64toi32_i32$1 = ($2 + 168 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $171;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = $2 + 296 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $176 = i64toi32_i32$0;
        i64toi32_i32$0 = $2 + 184 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $176;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        HEAP32[(($2 + 152 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 316 | 0) >> 2] | 0;
        HEAP32[($2 + 216 | 0) >> 2] = HEAPU8[$5 >> 0] | 0 | ((HEAPU8[($5 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($5 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($5 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $53 = $5 + 3 | 0;
        $54 = HEAPU8[$53 >> 0] | 0 | ((HEAPU8[($53 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($53 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($53 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 219 | 0) >> 0] = $54;
        HEAP8[($2 + 220 | 0) >> 0] = $54 >>> 8 | 0;
        HEAP8[($2 + 221 | 0) >> 0] = $54 >>> 16 | 0;
        HEAP8[($2 + 222 | 0) >> 0] = $54 >>> 24 | 0;
        i64toi32_i32$2 = $2 + 280 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $193 = i64toi32_i32$1;
        i64toi32_i32$1 = $2;
        HEAP32[($2 + 168 | 0) >> 2] = $193;
        HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = $2 + 308 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $197 = i64toi32_i32$0;
        i64toi32_i32$0 = $2;
        HEAP32[($2 + 152 | 0) >> 2] = $197;
        HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$1;
        $3 = HEAP32[($2 + 304 | 0) >> 2] | 0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$1 = HEAP32[($2 + 264 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[($2 + 268 | 0) >> 2] | 0;
        $11 = i64toi32_i32$1;
        $11$hi = i64toi32_i32$0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 272 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 276 | 0) >> 2] | 0;
        $10 = i64toi32_i32$0;
        $10$hi = i64toi32_i32$1;
        $8 = HEAPU8[($2 + 256 | 0) >> 0] | 0;
        $55 = HEAPU8[($2 + 219 | 0) >> 0] | 0 | ((HEAPU8[($2 + 220 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 221 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 222 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 195 | 0) >> 0] = $55;
        HEAP8[($2 + 196 | 0) >> 0] = $55 >>> 8 | 0;
        HEAP8[($2 + 197 | 0) >> 0] = $55 >>> 16 | 0;
        HEAP8[($2 + 198 | 0) >> 0] = $55 >>> 24 | 0;
        HEAP32[($2 + 192 | 0) >> 2] = HEAP32[($2 + 216 | 0) >> 2] | 0;
        if (($8 | 0) != (19 | 0)) {
         break label$4
        }
        break label$3;
       }
       i64toi32_i32$2 = $2 + 280 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $219 = i64toi32_i32$1;
       i64toi32_i32$1 = $2 + 176 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $219;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = $2 + 288 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $225 = i64toi32_i32$0;
       i64toi32_i32$0 = ($2 + 168 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $225;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $2 + 272 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $229 = i64toi32_i32$1;
       i64toi32_i32$1 = $2;
       HEAP32[($2 + 168 | 0) >> 2] = $229;
       HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$0;
       $8 = 2;
       break label$4;
      }
      i64toi32_i32$2 = $2 + 280 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $234 = i64toi32_i32$0;
      i64toi32_i32$0 = $2 + 176 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $234;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $2 + 288 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $240 = i64toi32_i32$1;
      i64toi32_i32$1 = ($2 + 168 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $240;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $2 + 272 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $244 = i64toi32_i32$0;
      i64toi32_i32$0 = $2;
      HEAP32[($2 + 168 | 0) >> 2] = $244;
      HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$1;
     }
     i64toi32_i32$1 = $10$hi;
     i64toi32_i32$0 = ($2 + 248 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $10;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $11$hi;
     i64toi32_i32$0 = ($2 + 248 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $11;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAP32[($2 + 168 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 172 | 0) >> 2] | 0;
     $256 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 272 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $256;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[($2 + 152 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 156 | 0) >> 2] | 0;
     $260 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 300 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $260;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = ($2 + 168 | 0) + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $266 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 280 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $266;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = ($2 + 168 | 0) + 16 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $272 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 288 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $272;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($2 + 308 | 0) >> 2] = HEAP32[(($2 + 152 | 0) + 8 | 0) >> 2] | 0;
     HEAP8[($2 + 248 | 0) >> 0] = $8;
     $56 = HEAP32[($2 + 192 | 0) >> 2] | 0;
     HEAP8[($2 + 249 | 0) >> 0] = $56;
     HEAP8[($2 + 250 | 0) >> 0] = $56 >>> 8 | 0;
     HEAP8[($2 + 251 | 0) >> 0] = $56 >>> 16 | 0;
     HEAP8[($2 + 252 | 0) >> 0] = $56 >>> 24 | 0;
     $57 = HEAPU8[($2 + 195 | 0) >> 0] | 0 | ((HEAPU8[($2 + 196 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 197 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 198 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($2 + 252 | 0) >> 0] = $57;
     HEAP8[($2 + 253 | 0) >> 0] = $57 >>> 8 | 0;
     HEAP8[($2 + 254 | 0) >> 0] = $57 >>> 16 | 0;
     HEAP8[($2 + 255 | 0) >> 0] = $57 >>> 24 | 0;
     HEAP32[($2 + 296 | 0) >> 2] = $3;
     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($2 + 88 | 0 | 0, $2 + 248 | 0 | 0, 1050852 | 0, 16 | 0);
     $1 = HEAPU8[($2 + 88 | 0) >> 0] | 0;
     if (($1 | 0) != (19 | 0)) {
      break label$2
     }
    }
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $299 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $299;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
    $3 = 0;
    break label$1;
   }
   $3 = 1;
   memcpy($2 + 25 | 0 | 0, $2 + 88 | 0 | 1 | 0 | 0, 63 | 0) | 0;
   HEAP8[($0 + 8 | 0) >> 0] = $1;
   memcpy($0 + 9 | 0 | 0, $2 + 25 | 0 | 0, 63 | 0) | 0;
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h72de9eab2f0e4669($2 + 8 | 0 | 0);
  }
  HEAP32[$0 >> 2] = $3;
  global$0 = $2 + 320 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__GenesisHashes___deserialize__h3dd731c61bb9d2cd($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, $3 = 0, $10 = 0, i64toi32_i32$4 = 0, $5 = 0, $8 = 0, $10$hi = 0, $11 = 0, $11$hi = 0, $40 = 0, $41 = 0, $42 = 0, $43 = 0, $44 = 0, $45 = 0, $46 = 0, $47 = 0, $48 = 0, $49 = 0, $50 = 0, $51 = 0, $52 = 0, $53 = 0, $54 = 0, $55 = 0, $56 = 0, $57 = 0, $4 = 0, $58 = 0, $59 = 0, $6 = 0, $7 = 0, $82 = 0, $82$hi = 0, $85$hi = 0, $9 = 0, $12 = 0, $12$hi = 0, $128 = 0, $171 = 0, $176 = 0, $193 = 0, $197 = 0, $219 = 0, $225 = 0, $229 = 0, $234 = 0, $240 = 0, $244 = 0, $256 = 0, $260 = 0, $266 = 0, $272 = 0, $299 = 0;
  $2 = global$0 - 320 | 0;
  global$0 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 12 | 0) >> 2] = 0;
  HEAP32[($2 + 16 | 0) >> 2] = i64toi32_i32$0;
  $3 = 0;
  HEAP32[($2 + 8 | 0) >> 2] = HEAP32[(0 + 1050212 | 0) >> 2] | 0;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 248 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = ($2 + 248 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 256 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 260 | 0) >> 2] | 0;
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 248 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 252 | 0) >> 2] | 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
         break label$6
        }
        i64toi32_i32$2 = $10$hi;
        $4 = $10;
        label$7 : {
         i64toi32_i32$2 = $11$hi;
         i64toi32_i32$3 = $11;
         i64toi32_i32$1 = 0;
         i64toi32_i32$0 = 1;
         if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
          break label$7
         }
         if (!$4) {
          break label$3
         }
        }
        $5 = $2 + 257 | 0;
        $6 = $2 + 248 | 0 | 1 | 0;
        $7 = ($2 + 248 | 0) + 28 | 0;
        label$8 : {
         label$9 : while (1) {
          std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 | 0, $1 | 0);
          $3 = 0;
          $8 = 2;
          label$10 : {
           if (HEAP32[($2 + 4 | 0) >> 2] | 0) {
            break label$10
           }
           i64toi32_i32$3 = 0;
           $11 = 8;
           $11$hi = i64toi32_i32$3;
           i64toi32_i32$3 = 0;
           $10 = 0;
           $10$hi = i64toi32_i32$3;
           break label$4;
          }
          label$11 : {
           if ((($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[$2 >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) == (7 | 0)) {
            break label$11
           }
           $cardano_serialization_lib__crypto__GenesisHash_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h220401e78fc09fba($2 + 248 | 0 | 0, $1 | 0);
           if ((HEAPU8[($2 + 248 | 0) >> 0] | 0 | 0) == (1 | 0)) {
            break label$8
           }
           HEAP32[($2 + 216 | 0) >> 2] = HEAPU8[$5 >> 0] | 0 | ((HEAPU8[($5 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($5 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($5 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $41 = $5 + 3 | 0;
           $42 = HEAPU8[$41 >> 0] | 0 | ((HEAPU8[($41 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($41 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($41 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 219 | 0) >> 0] = $42;
           HEAP8[($2 + 220 | 0) >> 0] = $42 >>> 8 | 0;
           HEAP8[($2 + 221 | 0) >> 0] = $42 >>> 16 | 0;
           HEAP8[($2 + 222 | 0) >> 0] = $42 >>> 24 | 0;
           $40 = $6;
           HEAP32[($2 + 200 | 0) >> 2] = HEAPU8[$40 >> 0] | 0 | ((HEAPU8[($40 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($40 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($40 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $43 = $40 + 3 | 0;
           $44 = HEAPU8[$43 >> 0] | 0 | ((HEAPU8[($43 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($43 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($43 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 203 | 0) >> 0] = $44;
           HEAP8[($2 + 204 | 0) >> 0] = $44 >>> 8 | 0;
           HEAP8[($2 + 205 | 0) >> 0] = $44 >>> 16 | 0;
           HEAP8[($2 + 206 | 0) >> 0] = $44 >>> 24 | 0;
           HEAP32[($2 + 240 | 0) >> 2] = HEAP32[($2 + 216 | 0) >> 2] | 0;
           $45 = HEAPU8[($2 + 219 | 0) >> 0] | 0 | ((HEAPU8[($2 + 220 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 221 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 222 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 243 | 0) >> 0] = $45;
           HEAP8[($2 + 244 | 0) >> 0] = $45 >>> 8 | 0;
           HEAP8[($2 + 245 | 0) >> 0] = $45 >>> 16 | 0;
           HEAP8[($2 + 246 | 0) >> 0] = $45 >>> 24 | 0;
           i64toi32_i32$0 = $2;
           i64toi32_i32$3 = HEAP32[($2 + 272 | 0) >> 2] | 0;
           i64toi32_i32$2 = 0;
           $82 = i64toi32_i32$3;
           $82$hi = i64toi32_i32$2;
           i64toi32_i32$0 = $7;
           i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0;
           i64toi32_i32$3 = 0;
           i64toi32_i32$0 = i64toi32_i32$2;
           i64toi32_i32$2 = 0;
           i64toi32_i32$1 = 32;
           i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
           if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
            i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
            $58 = 0;
           } else {
            i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$4 | 0) | 0;
            $58 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
           }
           $85$hi = i64toi32_i32$2;
           i64toi32_i32$2 = $82$hi;
           i64toi32_i32$3 = $82;
           i64toi32_i32$0 = $85$hi;
           i64toi32_i32$1 = $58;
           i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
           $10 = i64toi32_i32$3 | i64toi32_i32$1 | 0;
           $10$hi = i64toi32_i32$0;
           $9 = HEAPU8[($2 + 256 | 0) >> 0] | 0;
           i64toi32_i32$2 = $2;
           i64toi32_i32$0 = HEAP32[($2 + 264 | 0) >> 2] | 0;
           i64toi32_i32$3 = HEAP32[($2 + 268 | 0) >> 2] | 0;
           $12 = i64toi32_i32$0;
           $12$hi = i64toi32_i32$3;
           label$12 : {
            $8 = HEAP32[($2 + 16 | 0) >> 2] | 0;
            if ((HEAP32[($2 + 12 | 0) >> 2] | 0 | 0) != ($8 | 0)) {
             break label$12
            }
            alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h60072695517d08a3($2 + 8 | 0 | 0, $8 | 0, 1 | 0);
            $8 = HEAP32[($2 + 16 | 0) >> 2] | 0;
           }
           $3 = (HEAP32[($2 + 8 | 0) >> 2] | 0) + Math_imul($8, 28) | 0;
           $46 = HEAP32[($2 + 200 | 0) >> 2] | 0;
           HEAP8[$3 >> 0] = $46;
           HEAP8[($3 + 1 | 0) >> 0] = $46 >>> 8 | 0;
           HEAP8[($3 + 2 | 0) >> 0] = $46 >>> 16 | 0;
           HEAP8[($3 + 3 | 0) >> 0] = $46 >>> 24 | 0;
           HEAP8[($3 + 7 | 0) >> 0] = $9;
           $47 = HEAP32[($2 + 240 | 0) >> 2] | 0;
           HEAP8[($3 + 8 | 0) >> 0] = $47;
           HEAP8[($3 + 9 | 0) >> 0] = $47 >>> 8 | 0;
           HEAP8[($3 + 10 | 0) >> 0] = $47 >>> 16 | 0;
           HEAP8[($3 + 11 | 0) >> 0] = $47 >>> 24 | 0;
           i64toi32_i32$3 = $10$hi;
           HEAP8[($3 + 23 | 0) >> 0] = $10;
           HEAP8[($3 + 24 | 0) >> 0] = $10 >>> 8 | 0;
           HEAP8[($3 + 25 | 0) >> 0] = $10 >>> 16 | 0;
           HEAP8[($3 + 26 | 0) >> 0] = $10 >>> 24 | 0;
           i64toi32_i32$3 = $12$hi;
           i64toi32_i32$0 = $3;
           $48 = $12;
           HEAP8[(i64toi32_i32$0 + 15 | 0) >> 0] = $48;
           HEAP8[(i64toi32_i32$0 + 16 | 0) >> 0] = $48 >>> 8 | 0;
           HEAP8[(i64toi32_i32$0 + 17 | 0) >> 0] = $48 >>> 16 | 0;
           HEAP8[(i64toi32_i32$0 + 18 | 0) >> 0] = $48 >>> 24 | 0;
           HEAP8[(i64toi32_i32$0 + 19 | 0) >> 0] = i64toi32_i32$3;
           HEAP8[(i64toi32_i32$0 + 20 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
           HEAP8[(i64toi32_i32$0 + 21 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
           HEAP8[(i64toi32_i32$0 + 22 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
           $49 = i64toi32_i32$0 + 3 | 0;
           $50 = HEAPU8[($2 + 203 | 0) >> 0] | 0 | ((HEAPU8[($2 + 204 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 205 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 206 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[$49 >> 0] = $50;
           HEAP8[($49 + 1 | 0) >> 0] = $50 >>> 8 | 0;
           HEAP8[($49 + 2 | 0) >> 0] = $50 >>> 16 | 0;
           HEAP8[($49 + 3 | 0) >> 0] = $50 >>> 24 | 0;
           $51 = i64toi32_i32$0 + 11 | 0;
           $52 = HEAPU8[($2 + 243 | 0) >> 0] | 0 | ((HEAPU8[($2 + 244 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 245 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 246 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[$51 >> 0] = $52;
           HEAP8[($51 + 1 | 0) >> 0] = $52 >>> 8 | 0;
           HEAP8[($51 + 2 | 0) >> 0] = $52 >>> 16 | 0;
           HEAP8[($51 + 3 | 0) >> 0] = $52 >>> 24 | 0;
           $128 = i64toi32_i32$0 + 27 | 0;
           i64toi32_i32$3 = $10$hi;
           i64toi32_i32$2 = $10;
           i64toi32_i32$0 = 0;
           i64toi32_i32$1 = 32;
           i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
           if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
            i64toi32_i32$0 = 0;
            $59 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
           } else {
            i64toi32_i32$0 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
            $59 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
           }
           HEAP8[$128 >> 0] = $59;
           $3 = $8 + 1 | 0;
           HEAP32[($2 + 16 | 0) >> 2] = $3;
           i64toi32_i32$0 = $11$hi;
           i64toi32_i32$3 = $11;
           i64toi32_i32$2 = 0;
           i64toi32_i32$1 = 1;
           if ((i64toi32_i32$3 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$2 | 0) | 0) {
            continue label$9
           }
           if ($3 >>> 0 < $4 >>> 0) {
            continue label$9
           }
           break label$3;
          }
          break label$9;
         };
         cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 248 | 0 | 0, $1 | 0);
         i64toi32_i32$1 = ($2 + 248 | 0) + 16 | 0;
         i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
         $10 = i64toi32_i32$3;
         $10$hi = i64toi32_i32$0;
         i64toi32_i32$1 = $2;
         i64toi32_i32$0 = HEAP32[($2 + 256 | 0) >> 2] | 0;
         i64toi32_i32$3 = HEAP32[($2 + 260 | 0) >> 2] | 0;
         $11 = i64toi32_i32$0;
         $11$hi = i64toi32_i32$3;
         i64toi32_i32$1 = $2;
         i64toi32_i32$3 = HEAP32[($2 + 248 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($2 + 252 | 0) >> 2] | 0;
         i64toi32_i32$1 = i64toi32_i32$3;
         i64toi32_i32$3 = 0;
         i64toi32_i32$2 = 1;
         if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) | 0) {
          break label$5
         }
         i64toi32_i32$1 = $10$hi;
         i64toi32_i32$0 = $2 + 208 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $10;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$1 = $11$hi;
         i64toi32_i32$0 = $2;
         HEAP32[($2 + 200 | 0) >> 2] = $11;
         HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$1;
         if (($11 & 255 | 0 | 0) == (5 | 0)) {
          break label$3
         }
         HEAP32[($2 + 248 | 0) >> 2] = 0;
         core__panicking__assert_failed__h96d8431cc974b591(0 | 0, $2 + 200 | 0 | 0, 1050312 | 0, $2 + 248 | 0 | 0, 1052040 | 0);
         abort();
        }
        i64toi32_i32$2 = $2 + 288 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $171 = i64toi32_i32$1;
        i64toi32_i32$1 = ($2 + 168 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $171;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = $2 + 296 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $176 = i64toi32_i32$0;
        i64toi32_i32$0 = $2 + 184 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $176;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        HEAP32[(($2 + 152 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 316 | 0) >> 2] | 0;
        HEAP32[($2 + 216 | 0) >> 2] = HEAPU8[$5 >> 0] | 0 | ((HEAPU8[($5 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($5 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($5 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $53 = $5 + 3 | 0;
        $54 = HEAPU8[$53 >> 0] | 0 | ((HEAPU8[($53 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($53 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($53 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 219 | 0) >> 0] = $54;
        HEAP8[($2 + 220 | 0) >> 0] = $54 >>> 8 | 0;
        HEAP8[($2 + 221 | 0) >> 0] = $54 >>> 16 | 0;
        HEAP8[($2 + 222 | 0) >> 0] = $54 >>> 24 | 0;
        i64toi32_i32$2 = $2 + 280 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $193 = i64toi32_i32$1;
        i64toi32_i32$1 = $2;
        HEAP32[($2 + 168 | 0) >> 2] = $193;
        HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = $2 + 308 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $197 = i64toi32_i32$0;
        i64toi32_i32$0 = $2;
        HEAP32[($2 + 152 | 0) >> 2] = $197;
        HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$1;
        $3 = HEAP32[($2 + 304 | 0) >> 2] | 0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$1 = HEAP32[($2 + 264 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[($2 + 268 | 0) >> 2] | 0;
        $11 = i64toi32_i32$1;
        $11$hi = i64toi32_i32$0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 272 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 276 | 0) >> 2] | 0;
        $10 = i64toi32_i32$0;
        $10$hi = i64toi32_i32$1;
        $8 = HEAPU8[($2 + 256 | 0) >> 0] | 0;
        $55 = HEAPU8[($2 + 219 | 0) >> 0] | 0 | ((HEAPU8[($2 + 220 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 221 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 222 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 195 | 0) >> 0] = $55;
        HEAP8[($2 + 196 | 0) >> 0] = $55 >>> 8 | 0;
        HEAP8[($2 + 197 | 0) >> 0] = $55 >>> 16 | 0;
        HEAP8[($2 + 198 | 0) >> 0] = $55 >>> 24 | 0;
        HEAP32[($2 + 192 | 0) >> 2] = HEAP32[($2 + 216 | 0) >> 2] | 0;
        if (($8 | 0) != (19 | 0)) {
         break label$4
        }
        break label$3;
       }
       i64toi32_i32$2 = $2 + 280 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $219 = i64toi32_i32$1;
       i64toi32_i32$1 = $2 + 176 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $219;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = $2 + 288 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $225 = i64toi32_i32$0;
       i64toi32_i32$0 = ($2 + 168 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $225;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $2 + 272 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $229 = i64toi32_i32$1;
       i64toi32_i32$1 = $2;
       HEAP32[($2 + 168 | 0) >> 2] = $229;
       HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$0;
       $8 = 2;
       break label$4;
      }
      i64toi32_i32$2 = $2 + 280 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $234 = i64toi32_i32$0;
      i64toi32_i32$0 = $2 + 176 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $234;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $2 + 288 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $240 = i64toi32_i32$1;
      i64toi32_i32$1 = ($2 + 168 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $240;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $2 + 272 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $244 = i64toi32_i32$0;
      i64toi32_i32$0 = $2;
      HEAP32[($2 + 168 | 0) >> 2] = $244;
      HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$1;
     }
     i64toi32_i32$1 = $10$hi;
     i64toi32_i32$0 = ($2 + 248 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $10;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $11$hi;
     i64toi32_i32$0 = ($2 + 248 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $11;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAP32[($2 + 168 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 172 | 0) >> 2] | 0;
     $256 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 272 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $256;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[($2 + 152 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 156 | 0) >> 2] | 0;
     $260 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 300 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $260;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = ($2 + 168 | 0) + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $266 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 280 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $266;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = ($2 + 168 | 0) + 16 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $272 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 288 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $272;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($2 + 308 | 0) >> 2] = HEAP32[(($2 + 152 | 0) + 8 | 0) >> 2] | 0;
     HEAP8[($2 + 248 | 0) >> 0] = $8;
     $56 = HEAP32[($2 + 192 | 0) >> 2] | 0;
     HEAP8[($2 + 249 | 0) >> 0] = $56;
     HEAP8[($2 + 250 | 0) >> 0] = $56 >>> 8 | 0;
     HEAP8[($2 + 251 | 0) >> 0] = $56 >>> 16 | 0;
     HEAP8[($2 + 252 | 0) >> 0] = $56 >>> 24 | 0;
     $57 = HEAPU8[($2 + 195 | 0) >> 0] | 0 | ((HEAPU8[($2 + 196 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 197 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 198 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($2 + 252 | 0) >> 0] = $57;
     HEAP8[($2 + 253 | 0) >> 0] = $57 >>> 8 | 0;
     HEAP8[($2 + 254 | 0) >> 0] = $57 >>> 16 | 0;
     HEAP8[($2 + 255 | 0) >> 0] = $57 >>> 24 | 0;
     HEAP32[($2 + 296 | 0) >> 2] = $3;
     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($2 + 88 | 0 | 0, $2 + 248 | 0 | 0, 1052056 | 0, 13 | 0);
     $1 = HEAPU8[($2 + 88 | 0) >> 0] | 0;
     if (($1 | 0) != (19 | 0)) {
      break label$2
     }
    }
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $299 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $299;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
    $3 = 0;
    break label$1;
   }
   $3 = 1;
   memcpy($2 + 25 | 0 | 0, $2 + 88 | 0 | 1 | 0 | 0, 63 | 0) | 0;
   HEAP8[($0 + 8 | 0) >> 0] = $1;
   memcpy($0 + 9 | 0 | 0, $2 + 25 | 0 | 0, 63 | 0) | 0;
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hebb629eda405a6ec($2 + 8 | 0 | 0);
  }
  HEAP32[$0 >> 2] = $3;
  global$0 = $2 + 320 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__ScriptHashes___deserialize__h02ad1484d76cb779($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, $3 = 0, $10 = 0, i64toi32_i32$4 = 0, $5 = 0, $8 = 0, $10$hi = 0, $11 = 0, $11$hi = 0, $40 = 0, $41 = 0, $42 = 0, $43 = 0, $44 = 0, $45 = 0, $46 = 0, $47 = 0, $48 = 0, $49 = 0, $50 = 0, $51 = 0, $52 = 0, $53 = 0, $54 = 0, $55 = 0, $56 = 0, $57 = 0, $4 = 0, $58 = 0, $59 = 0, $6 = 0, $7 = 0, $82 = 0, $82$hi = 0, $85$hi = 0, $9 = 0, $12 = 0, $12$hi = 0, $128 = 0, $171 = 0, $176 = 0, $193 = 0, $197 = 0, $219 = 0, $225 = 0, $229 = 0, $234 = 0, $240 = 0, $244 = 0, $256 = 0, $260 = 0, $266 = 0, $272 = 0, $299 = 0;
  $2 = global$0 - 320 | 0;
  global$0 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 12 | 0) >> 2] = 0;
  HEAP32[($2 + 16 | 0) >> 2] = i64toi32_i32$0;
  $3 = 0;
  HEAP32[($2 + 8 | 0) >> 2] = HEAP32[(0 + 1050212 | 0) >> 2] | 0;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 248 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = ($2 + 248 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 256 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 260 | 0) >> 2] | 0;
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 248 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 252 | 0) >> 2] | 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
         break label$6
        }
        i64toi32_i32$2 = $10$hi;
        $4 = $10;
        label$7 : {
         i64toi32_i32$2 = $11$hi;
         i64toi32_i32$3 = $11;
         i64toi32_i32$1 = 0;
         i64toi32_i32$0 = 1;
         if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
          break label$7
         }
         if (!$4) {
          break label$3
         }
        }
        $5 = $2 + 257 | 0;
        $6 = $2 + 248 | 0 | 1 | 0;
        $7 = ($2 + 248 | 0) + 28 | 0;
        label$8 : {
         label$9 : while (1) {
          std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 | 0, $1 | 0);
          $3 = 0;
          $8 = 2;
          label$10 : {
           if (HEAP32[($2 + 4 | 0) >> 2] | 0) {
            break label$10
           }
           i64toi32_i32$3 = 0;
           $11 = 8;
           $11$hi = i64toi32_i32$3;
           i64toi32_i32$3 = 0;
           $10 = 0;
           $10$hi = i64toi32_i32$3;
           break label$4;
          }
          label$11 : {
           if ((($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[$2 >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) == (7 | 0)) {
            break label$11
           }
           $cardano_serialization_lib__crypto__ScriptHash_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h589000d40634e72d($2 + 248 | 0 | 0, $1 | 0);
           if ((HEAPU8[($2 + 248 | 0) >> 0] | 0 | 0) == (1 | 0)) {
            break label$8
           }
           HEAP32[($2 + 216 | 0) >> 2] = HEAPU8[$5 >> 0] | 0 | ((HEAPU8[($5 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($5 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($5 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $41 = $5 + 3 | 0;
           $42 = HEAPU8[$41 >> 0] | 0 | ((HEAPU8[($41 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($41 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($41 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 219 | 0) >> 0] = $42;
           HEAP8[($2 + 220 | 0) >> 0] = $42 >>> 8 | 0;
           HEAP8[($2 + 221 | 0) >> 0] = $42 >>> 16 | 0;
           HEAP8[($2 + 222 | 0) >> 0] = $42 >>> 24 | 0;
           $40 = $6;
           HEAP32[($2 + 200 | 0) >> 2] = HEAPU8[$40 >> 0] | 0 | ((HEAPU8[($40 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($40 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($40 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $43 = $40 + 3 | 0;
           $44 = HEAPU8[$43 >> 0] | 0 | ((HEAPU8[($43 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($43 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($43 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 203 | 0) >> 0] = $44;
           HEAP8[($2 + 204 | 0) >> 0] = $44 >>> 8 | 0;
           HEAP8[($2 + 205 | 0) >> 0] = $44 >>> 16 | 0;
           HEAP8[($2 + 206 | 0) >> 0] = $44 >>> 24 | 0;
           HEAP32[($2 + 240 | 0) >> 2] = HEAP32[($2 + 216 | 0) >> 2] | 0;
           $45 = HEAPU8[($2 + 219 | 0) >> 0] | 0 | ((HEAPU8[($2 + 220 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 221 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 222 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 243 | 0) >> 0] = $45;
           HEAP8[($2 + 244 | 0) >> 0] = $45 >>> 8 | 0;
           HEAP8[($2 + 245 | 0) >> 0] = $45 >>> 16 | 0;
           HEAP8[($2 + 246 | 0) >> 0] = $45 >>> 24 | 0;
           i64toi32_i32$0 = $2;
           i64toi32_i32$3 = HEAP32[($2 + 272 | 0) >> 2] | 0;
           i64toi32_i32$2 = 0;
           $82 = i64toi32_i32$3;
           $82$hi = i64toi32_i32$2;
           i64toi32_i32$0 = $7;
           i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0;
           i64toi32_i32$3 = 0;
           i64toi32_i32$0 = i64toi32_i32$2;
           i64toi32_i32$2 = 0;
           i64toi32_i32$1 = 32;
           i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
           if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
            i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
            $58 = 0;
           } else {
            i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$4 | 0) | 0;
            $58 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
           }
           $85$hi = i64toi32_i32$2;
           i64toi32_i32$2 = $82$hi;
           i64toi32_i32$3 = $82;
           i64toi32_i32$0 = $85$hi;
           i64toi32_i32$1 = $58;
           i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
           $10 = i64toi32_i32$3 | i64toi32_i32$1 | 0;
           $10$hi = i64toi32_i32$0;
           $9 = HEAPU8[($2 + 256 | 0) >> 0] | 0;
           i64toi32_i32$2 = $2;
           i64toi32_i32$0 = HEAP32[($2 + 264 | 0) >> 2] | 0;
           i64toi32_i32$3 = HEAP32[($2 + 268 | 0) >> 2] | 0;
           $12 = i64toi32_i32$0;
           $12$hi = i64toi32_i32$3;
           label$12 : {
            $8 = HEAP32[($2 + 16 | 0) >> 2] | 0;
            if ((HEAP32[($2 + 12 | 0) >> 2] | 0 | 0) != ($8 | 0)) {
             break label$12
            }
            alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h6efd3441b9caf532($2 + 8 | 0 | 0, $8 | 0, 1 | 0);
            $8 = HEAP32[($2 + 16 | 0) >> 2] | 0;
           }
           $3 = (HEAP32[($2 + 8 | 0) >> 2] | 0) + Math_imul($8, 28) | 0;
           $46 = HEAP32[($2 + 200 | 0) >> 2] | 0;
           HEAP8[$3 >> 0] = $46;
           HEAP8[($3 + 1 | 0) >> 0] = $46 >>> 8 | 0;
           HEAP8[($3 + 2 | 0) >> 0] = $46 >>> 16 | 0;
           HEAP8[($3 + 3 | 0) >> 0] = $46 >>> 24 | 0;
           HEAP8[($3 + 7 | 0) >> 0] = $9;
           $47 = HEAP32[($2 + 240 | 0) >> 2] | 0;
           HEAP8[($3 + 8 | 0) >> 0] = $47;
           HEAP8[($3 + 9 | 0) >> 0] = $47 >>> 8 | 0;
           HEAP8[($3 + 10 | 0) >> 0] = $47 >>> 16 | 0;
           HEAP8[($3 + 11 | 0) >> 0] = $47 >>> 24 | 0;
           i64toi32_i32$3 = $10$hi;
           HEAP8[($3 + 23 | 0) >> 0] = $10;
           HEAP8[($3 + 24 | 0) >> 0] = $10 >>> 8 | 0;
           HEAP8[($3 + 25 | 0) >> 0] = $10 >>> 16 | 0;
           HEAP8[($3 + 26 | 0) >> 0] = $10 >>> 24 | 0;
           i64toi32_i32$3 = $12$hi;
           i64toi32_i32$0 = $3;
           $48 = $12;
           HEAP8[(i64toi32_i32$0 + 15 | 0) >> 0] = $48;
           HEAP8[(i64toi32_i32$0 + 16 | 0) >> 0] = $48 >>> 8 | 0;
           HEAP8[(i64toi32_i32$0 + 17 | 0) >> 0] = $48 >>> 16 | 0;
           HEAP8[(i64toi32_i32$0 + 18 | 0) >> 0] = $48 >>> 24 | 0;
           HEAP8[(i64toi32_i32$0 + 19 | 0) >> 0] = i64toi32_i32$3;
           HEAP8[(i64toi32_i32$0 + 20 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
           HEAP8[(i64toi32_i32$0 + 21 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
           HEAP8[(i64toi32_i32$0 + 22 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
           $49 = i64toi32_i32$0 + 3 | 0;
           $50 = HEAPU8[($2 + 203 | 0) >> 0] | 0 | ((HEAPU8[($2 + 204 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 205 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 206 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[$49 >> 0] = $50;
           HEAP8[($49 + 1 | 0) >> 0] = $50 >>> 8 | 0;
           HEAP8[($49 + 2 | 0) >> 0] = $50 >>> 16 | 0;
           HEAP8[($49 + 3 | 0) >> 0] = $50 >>> 24 | 0;
           $51 = i64toi32_i32$0 + 11 | 0;
           $52 = HEAPU8[($2 + 243 | 0) >> 0] | 0 | ((HEAPU8[($2 + 244 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 245 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 246 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[$51 >> 0] = $52;
           HEAP8[($51 + 1 | 0) >> 0] = $52 >>> 8 | 0;
           HEAP8[($51 + 2 | 0) >> 0] = $52 >>> 16 | 0;
           HEAP8[($51 + 3 | 0) >> 0] = $52 >>> 24 | 0;
           $128 = i64toi32_i32$0 + 27 | 0;
           i64toi32_i32$3 = $10$hi;
           i64toi32_i32$2 = $10;
           i64toi32_i32$0 = 0;
           i64toi32_i32$1 = 32;
           i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
           if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
            i64toi32_i32$0 = 0;
            $59 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
           } else {
            i64toi32_i32$0 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
            $59 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
           }
           HEAP8[$128 >> 0] = $59;
           $3 = $8 + 1 | 0;
           HEAP32[($2 + 16 | 0) >> 2] = $3;
           i64toi32_i32$0 = $11$hi;
           i64toi32_i32$3 = $11;
           i64toi32_i32$2 = 0;
           i64toi32_i32$1 = 1;
           if ((i64toi32_i32$3 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$2 | 0) | 0) {
            continue label$9
           }
           if ($3 >>> 0 < $4 >>> 0) {
            continue label$9
           }
           break label$3;
          }
          break label$9;
         };
         cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 248 | 0 | 0, $1 | 0);
         i64toi32_i32$1 = ($2 + 248 | 0) + 16 | 0;
         i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
         $10 = i64toi32_i32$3;
         $10$hi = i64toi32_i32$0;
         i64toi32_i32$1 = $2;
         i64toi32_i32$0 = HEAP32[($2 + 256 | 0) >> 2] | 0;
         i64toi32_i32$3 = HEAP32[($2 + 260 | 0) >> 2] | 0;
         $11 = i64toi32_i32$0;
         $11$hi = i64toi32_i32$3;
         i64toi32_i32$1 = $2;
         i64toi32_i32$3 = HEAP32[($2 + 248 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($2 + 252 | 0) >> 2] | 0;
         i64toi32_i32$1 = i64toi32_i32$3;
         i64toi32_i32$3 = 0;
         i64toi32_i32$2 = 1;
         if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) | 0) {
          break label$5
         }
         i64toi32_i32$1 = $10$hi;
         i64toi32_i32$0 = $2 + 208 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $10;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$1 = $11$hi;
         i64toi32_i32$0 = $2;
         HEAP32[($2 + 200 | 0) >> 2] = $11;
         HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$1;
         if (($11 & 255 | 0 | 0) == (5 | 0)) {
          break label$3
         }
         HEAP32[($2 + 248 | 0) >> 2] = 0;
         core__panicking__assert_failed__h96d8431cc974b591(0 | 0, $2 + 200 | 0 | 0, 1050312 | 0, $2 + 248 | 0 | 0, 1052072 | 0);
         abort();
        }
        i64toi32_i32$2 = $2 + 288 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $171 = i64toi32_i32$1;
        i64toi32_i32$1 = ($2 + 168 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $171;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = $2 + 296 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $176 = i64toi32_i32$0;
        i64toi32_i32$0 = $2 + 184 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $176;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        HEAP32[(($2 + 152 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 316 | 0) >> 2] | 0;
        HEAP32[($2 + 216 | 0) >> 2] = HEAPU8[$5 >> 0] | 0 | ((HEAPU8[($5 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($5 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($5 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $53 = $5 + 3 | 0;
        $54 = HEAPU8[$53 >> 0] | 0 | ((HEAPU8[($53 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($53 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($53 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 219 | 0) >> 0] = $54;
        HEAP8[($2 + 220 | 0) >> 0] = $54 >>> 8 | 0;
        HEAP8[($2 + 221 | 0) >> 0] = $54 >>> 16 | 0;
        HEAP8[($2 + 222 | 0) >> 0] = $54 >>> 24 | 0;
        i64toi32_i32$2 = $2 + 280 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $193 = i64toi32_i32$1;
        i64toi32_i32$1 = $2;
        HEAP32[($2 + 168 | 0) >> 2] = $193;
        HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = $2 + 308 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $197 = i64toi32_i32$0;
        i64toi32_i32$0 = $2;
        HEAP32[($2 + 152 | 0) >> 2] = $197;
        HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$1;
        $3 = HEAP32[($2 + 304 | 0) >> 2] | 0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$1 = HEAP32[($2 + 264 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[($2 + 268 | 0) >> 2] | 0;
        $11 = i64toi32_i32$1;
        $11$hi = i64toi32_i32$0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 272 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 276 | 0) >> 2] | 0;
        $10 = i64toi32_i32$0;
        $10$hi = i64toi32_i32$1;
        $8 = HEAPU8[($2 + 256 | 0) >> 0] | 0;
        $55 = HEAPU8[($2 + 219 | 0) >> 0] | 0 | ((HEAPU8[($2 + 220 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 221 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 222 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 195 | 0) >> 0] = $55;
        HEAP8[($2 + 196 | 0) >> 0] = $55 >>> 8 | 0;
        HEAP8[($2 + 197 | 0) >> 0] = $55 >>> 16 | 0;
        HEAP8[($2 + 198 | 0) >> 0] = $55 >>> 24 | 0;
        HEAP32[($2 + 192 | 0) >> 2] = HEAP32[($2 + 216 | 0) >> 2] | 0;
        if (($8 | 0) != (19 | 0)) {
         break label$4
        }
        break label$3;
       }
       i64toi32_i32$2 = $2 + 280 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $219 = i64toi32_i32$1;
       i64toi32_i32$1 = $2 + 176 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $219;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = $2 + 288 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $225 = i64toi32_i32$0;
       i64toi32_i32$0 = ($2 + 168 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $225;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $2 + 272 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $229 = i64toi32_i32$1;
       i64toi32_i32$1 = $2;
       HEAP32[($2 + 168 | 0) >> 2] = $229;
       HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$0;
       $8 = 2;
       break label$4;
      }
      i64toi32_i32$2 = $2 + 280 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $234 = i64toi32_i32$0;
      i64toi32_i32$0 = $2 + 176 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $234;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $2 + 288 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $240 = i64toi32_i32$1;
      i64toi32_i32$1 = ($2 + 168 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $240;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $2 + 272 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $244 = i64toi32_i32$0;
      i64toi32_i32$0 = $2;
      HEAP32[($2 + 168 | 0) >> 2] = $244;
      HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$1;
     }
     i64toi32_i32$1 = $10$hi;
     i64toi32_i32$0 = ($2 + 248 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $10;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $11$hi;
     i64toi32_i32$0 = ($2 + 248 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $11;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAP32[($2 + 168 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 172 | 0) >> 2] | 0;
     $256 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 272 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $256;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[($2 + 152 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 156 | 0) >> 2] | 0;
     $260 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 300 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $260;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = ($2 + 168 | 0) + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $266 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 280 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $266;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = ($2 + 168 | 0) + 16 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $272 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 288 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $272;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($2 + 308 | 0) >> 2] = HEAP32[(($2 + 152 | 0) + 8 | 0) >> 2] | 0;
     HEAP8[($2 + 248 | 0) >> 0] = $8;
     $56 = HEAP32[($2 + 192 | 0) >> 2] | 0;
     HEAP8[($2 + 249 | 0) >> 0] = $56;
     HEAP8[($2 + 250 | 0) >> 0] = $56 >>> 8 | 0;
     HEAP8[($2 + 251 | 0) >> 0] = $56 >>> 16 | 0;
     HEAP8[($2 + 252 | 0) >> 0] = $56 >>> 24 | 0;
     $57 = HEAPU8[($2 + 195 | 0) >> 0] | 0 | ((HEAPU8[($2 + 196 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 197 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 198 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($2 + 252 | 0) >> 0] = $57;
     HEAP8[($2 + 253 | 0) >> 0] = $57 >>> 8 | 0;
     HEAP8[($2 + 254 | 0) >> 0] = $57 >>> 16 | 0;
     HEAP8[($2 + 255 | 0) >> 0] = $57 >>> 24 | 0;
     HEAP32[($2 + 296 | 0) >> 2] = $3;
     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($2 + 88 | 0 | 0, $2 + 248 | 0 | 0, 1052088 | 0, 12 | 0);
     $1 = HEAPU8[($2 + 88 | 0) >> 0] | 0;
     if (($1 | 0) != (19 | 0)) {
      break label$2
     }
    }
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $299 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $299;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
    $3 = 0;
    break label$1;
   }
   $3 = 1;
   memcpy($2 + 25 | 0 | 0, $2 + 88 | 0 | 1 | 0 | 0, 63 | 0) | 0;
   HEAP8[($0 + 8 | 0) >> 0] = $1;
   memcpy($0 + 9 | 0 | 0, $2 + 25 | 0 | 0, 63 | 0) | 0;
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hd17502cd2c574696($2 + 8 | 0 | 0);
  }
  HEAP32[$0 >> 2] = $3;
  global$0 = $2 + 320 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__StakeCredentials___deserialize__hc50a371d41ef0157($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, $3 = 0, $10 = 0, i64toi32_i32$4 = 0, $5 = 0, $8 = 0, $10$hi = 0, $11 = 0, $11$hi = 0, $40 = 0, $41 = 0, $42 = 0, $43 = 0, $44 = 0, $45 = 0, $46 = 0, $47 = 0, $48 = 0, $49 = 0, $50 = 0, $51 = 0, $52 = 0, $53 = 0, $54 = 0, $55 = 0, $56 = 0, $57 = 0, $4 = 0, $58 = 0, $59 = 0, $60 = 0, $61 = 0, $6 = 0, $7 = 0, $81 = 0, $81$hi = 0, $84$hi = 0, $9 = 0, $12 = 0, $12$hi = 0, $127 = 0, $170 = 0, $175 = 0, $192 = 0, $196 = 0, $218 = 0, $224 = 0, $228 = 0, $233 = 0, $239 = 0, $243 = 0, $255 = 0, $259 = 0, $265 = 0, $271 = 0, $298 = 0;
  $2 = global$0 - 320 | 0;
  global$0 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 12 | 0) >> 2] = 0;
  HEAP32[($2 + 16 | 0) >> 2] = i64toi32_i32$0;
  $3 = 0;
  HEAP32[($2 + 8 | 0) >> 2] = HEAP32[(0 + 1050212 | 0) >> 2] | 0;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 248 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = ($2 + 248 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 256 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 260 | 0) >> 2] | 0;
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 248 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 252 | 0) >> 2] | 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
         break label$6
        }
        i64toi32_i32$2 = $10$hi;
        $4 = $10;
        label$7 : {
         i64toi32_i32$2 = $11$hi;
         i64toi32_i32$3 = $11;
         i64toi32_i32$1 = 0;
         i64toi32_i32$0 = 1;
         if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
          break label$7
         }
         if (!$4) {
          break label$3
         }
        }
        $5 = $2 + 257 | 0;
        $6 = $2 + 248 | 0 | 1 | 0;
        $7 = $2 + 276 | 0;
        label$8 : {
         label$9 : while (1) {
          std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 | 0, $1 | 0);
          $3 = 0;
          $8 = 2;
          label$10 : {
           if (HEAP32[($2 + 4 | 0) >> 2] | 0) {
            break label$10
           }
           i64toi32_i32$3 = 0;
           $11 = 8;
           $11$hi = i64toi32_i32$3;
           i64toi32_i32$3 = 0;
           $10 = 0;
           $10$hi = i64toi32_i32$3;
           break label$4;
          }
          label$11 : {
           if ((($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[$2 >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) == (7 | 0)) {
            break label$11
           }
           $cardano_serialization_lib__address__StakeCredential_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__ha21a31a5230d4f02($2 + 248 | 0 | 0, $1 | 0);
           if ((HEAPU8[($2 + 248 | 0) >> 0] | 0 | 0) == (1 | 0)) {
            break label$8
           }
           HEAP32[($2 + 216 | 0) >> 2] = HEAPU8[$5 >> 0] | 0 | ((HEAPU8[($5 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($5 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($5 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $41 = $5 + 3 | 0;
           $42 = HEAPU8[$41 >> 0] | 0 | ((HEAPU8[($41 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($41 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($41 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 219 | 0) >> 0] = $42;
           HEAP8[($2 + 220 | 0) >> 0] = $42 >>> 8 | 0;
           HEAP8[($2 + 221 | 0) >> 0] = $42 >>> 16 | 0;
           HEAP8[($2 + 222 | 0) >> 0] = $42 >>> 24 | 0;
           $40 = $6;
           HEAP32[($2 + 200 | 0) >> 2] = HEAPU8[$40 >> 0] | 0 | ((HEAPU8[($40 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($40 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($40 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $43 = $40 + 3 | 0;
           $44 = HEAPU8[$43 >> 0] | 0 | ((HEAPU8[($43 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($43 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($43 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 203 | 0) >> 0] = $44;
           HEAP8[($2 + 204 | 0) >> 0] = $44 >>> 8 | 0;
           HEAP8[($2 + 205 | 0) >> 0] = $44 >>> 16 | 0;
           HEAP8[($2 + 206 | 0) >> 0] = $44 >>> 24 | 0;
           HEAP32[($2 + 240 | 0) >> 2] = HEAP32[($2 + 216 | 0) >> 2] | 0;
           $45 = HEAPU8[($2 + 219 | 0) >> 0] | 0 | ((HEAPU8[($2 + 220 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 221 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 222 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 243 | 0) >> 0] = $45;
           HEAP8[($2 + 244 | 0) >> 0] = $45 >>> 8 | 0;
           HEAP8[($2 + 245 | 0) >> 0] = $45 >>> 16 | 0;
           HEAP8[($2 + 246 | 0) >> 0] = $45 >>> 24 | 0;
           i64toi32_i32$0 = $2;
           i64toi32_i32$3 = HEAP32[($2 + 272 | 0) >> 2] | 0;
           i64toi32_i32$2 = 0;
           $81 = i64toi32_i32$3;
           $81$hi = i64toi32_i32$2;
           i64toi32_i32$0 = $7;
           i64toi32_i32$2 = HEAPU16[i64toi32_i32$0 >> 1] | 0;
           i64toi32_i32$3 = 0;
           i64toi32_i32$0 = i64toi32_i32$2;
           i64toi32_i32$2 = 0;
           i64toi32_i32$1 = 32;
           i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
           if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
            i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
            $58 = 0;
           } else {
            i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$4 | 0) | 0;
            $58 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
           }
           $84$hi = i64toi32_i32$2;
           i64toi32_i32$2 = $81$hi;
           i64toi32_i32$3 = $81;
           i64toi32_i32$0 = $84$hi;
           i64toi32_i32$1 = $58;
           i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
           $10 = i64toi32_i32$3 | i64toi32_i32$1 | 0;
           $10$hi = i64toi32_i32$0;
           $9 = HEAPU8[($2 + 256 | 0) >> 0] | 0;
           i64toi32_i32$2 = $2;
           i64toi32_i32$0 = HEAP32[($2 + 264 | 0) >> 2] | 0;
           i64toi32_i32$3 = HEAP32[($2 + 268 | 0) >> 2] | 0;
           $12 = i64toi32_i32$0;
           $12$hi = i64toi32_i32$3;
           label$12 : {
            $8 = HEAP32[($2 + 16 | 0) >> 2] | 0;
            if ((HEAP32[($2 + 12 | 0) >> 2] | 0 | 0) != ($8 | 0)) {
             break label$12
            }
            alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__ha457b0dea7cc7a33($2 + 8 | 0 | 0, $8 | 0, 1 | 0);
            $8 = HEAP32[($2 + 16 | 0) >> 2] | 0;
           }
           $3 = (HEAP32[($2 + 8 | 0) >> 2] | 0) + Math_imul($8, 29) | 0;
           $46 = HEAP32[($2 + 200 | 0) >> 2] | 0;
           HEAP8[$3 >> 0] = $46;
           HEAP8[($3 + 1 | 0) >> 0] = $46 >>> 8 | 0;
           HEAP8[($3 + 2 | 0) >> 0] = $46 >>> 16 | 0;
           HEAP8[($3 + 3 | 0) >> 0] = $46 >>> 24 | 0;
           HEAP8[($3 + 7 | 0) >> 0] = $9;
           $47 = HEAP32[($2 + 240 | 0) >> 2] | 0;
           HEAP8[($3 + 8 | 0) >> 0] = $47;
           HEAP8[($3 + 9 | 0) >> 0] = $47 >>> 8 | 0;
           HEAP8[($3 + 10 | 0) >> 0] = $47 >>> 16 | 0;
           HEAP8[($3 + 11 | 0) >> 0] = $47 >>> 24 | 0;
           i64toi32_i32$3 = $10$hi;
           HEAP8[($3 + 23 | 0) >> 0] = $10;
           HEAP8[($3 + 24 | 0) >> 0] = $10 >>> 8 | 0;
           HEAP8[($3 + 25 | 0) >> 0] = $10 >>> 16 | 0;
           HEAP8[($3 + 26 | 0) >> 0] = $10 >>> 24 | 0;
           i64toi32_i32$3 = $12$hi;
           i64toi32_i32$0 = $3;
           $48 = $12;
           HEAP8[(i64toi32_i32$0 + 15 | 0) >> 0] = $48;
           HEAP8[(i64toi32_i32$0 + 16 | 0) >> 0] = $48 >>> 8 | 0;
           HEAP8[(i64toi32_i32$0 + 17 | 0) >> 0] = $48 >>> 16 | 0;
           HEAP8[(i64toi32_i32$0 + 18 | 0) >> 0] = $48 >>> 24 | 0;
           HEAP8[(i64toi32_i32$0 + 19 | 0) >> 0] = i64toi32_i32$3;
           HEAP8[(i64toi32_i32$0 + 20 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
           HEAP8[(i64toi32_i32$0 + 21 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
           HEAP8[(i64toi32_i32$0 + 22 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
           $49 = i64toi32_i32$0 + 3 | 0;
           $50 = HEAPU8[($2 + 203 | 0) >> 0] | 0 | ((HEAPU8[($2 + 204 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 205 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 206 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[$49 >> 0] = $50;
           HEAP8[($49 + 1 | 0) >> 0] = $50 >>> 8 | 0;
           HEAP8[($49 + 2 | 0) >> 0] = $50 >>> 16 | 0;
           HEAP8[($49 + 3 | 0) >> 0] = $50 >>> 24 | 0;
           $51 = i64toi32_i32$0 + 11 | 0;
           $52 = HEAPU8[($2 + 243 | 0) >> 0] | 0 | ((HEAPU8[($2 + 244 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 245 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 246 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[$51 >> 0] = $52;
           HEAP8[($51 + 1 | 0) >> 0] = $52 >>> 8 | 0;
           HEAP8[($51 + 2 | 0) >> 0] = $52 >>> 16 | 0;
           HEAP8[($51 + 3 | 0) >> 0] = $52 >>> 24 | 0;
           $127 = i64toi32_i32$0 + 27 | 0;
           i64toi32_i32$3 = $10$hi;
           i64toi32_i32$2 = $10;
           i64toi32_i32$0 = 0;
           i64toi32_i32$1 = 32;
           i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
           if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
            i64toi32_i32$0 = 0;
            $59 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
           } else {
            i64toi32_i32$0 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
            $59 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
           }
           $60 = $127;
           $61 = $59;
           HEAP8[$60 >> 0] = $61;
           HEAP8[($60 + 1 | 0) >> 0] = $61 >>> 8 | 0;
           $3 = $8 + 1 | 0;
           HEAP32[($2 + 16 | 0) >> 2] = $3;
           i64toi32_i32$0 = $11$hi;
           i64toi32_i32$3 = $11;
           i64toi32_i32$2 = 0;
           i64toi32_i32$1 = 1;
           if ((i64toi32_i32$3 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$2 | 0) | 0) {
            continue label$9
           }
           if ($3 >>> 0 < $4 >>> 0) {
            continue label$9
           }
           break label$3;
          }
          break label$9;
         };
         cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 248 | 0 | 0, $1 | 0);
         i64toi32_i32$1 = ($2 + 248 | 0) + 16 | 0;
         i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
         $10 = i64toi32_i32$3;
         $10$hi = i64toi32_i32$0;
         i64toi32_i32$1 = $2;
         i64toi32_i32$0 = HEAP32[($2 + 256 | 0) >> 2] | 0;
         i64toi32_i32$3 = HEAP32[($2 + 260 | 0) >> 2] | 0;
         $11 = i64toi32_i32$0;
         $11$hi = i64toi32_i32$3;
         i64toi32_i32$1 = $2;
         i64toi32_i32$3 = HEAP32[($2 + 248 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($2 + 252 | 0) >> 2] | 0;
         i64toi32_i32$1 = i64toi32_i32$3;
         i64toi32_i32$3 = 0;
         i64toi32_i32$2 = 1;
         if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) | 0) {
          break label$5
         }
         i64toi32_i32$1 = $10$hi;
         i64toi32_i32$0 = $2 + 208 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $10;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$1 = $11$hi;
         i64toi32_i32$0 = $2;
         HEAP32[($2 + 200 | 0) >> 2] = $11;
         HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$1;
         if (($11 & 255 | 0 | 0) == (5 | 0)) {
          break label$3
         }
         HEAP32[($2 + 248 | 0) >> 2] = 0;
         core__panicking__assert_failed__h96d8431cc974b591(0 | 0, $2 + 200 | 0 | 0, 1050312 | 0, $2 + 248 | 0 | 0, 1051276 | 0);
         abort();
        }
        i64toi32_i32$2 = $2 + 288 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $170 = i64toi32_i32$1;
        i64toi32_i32$1 = ($2 + 168 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $170;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = $2 + 296 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $175 = i64toi32_i32$0;
        i64toi32_i32$0 = $2 + 184 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $175;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        HEAP32[(($2 + 152 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 316 | 0) >> 2] | 0;
        HEAP32[($2 + 216 | 0) >> 2] = HEAPU8[$5 >> 0] | 0 | ((HEAPU8[($5 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($5 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($5 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $53 = $5 + 3 | 0;
        $54 = HEAPU8[$53 >> 0] | 0 | ((HEAPU8[($53 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($53 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($53 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 219 | 0) >> 0] = $54;
        HEAP8[($2 + 220 | 0) >> 0] = $54 >>> 8 | 0;
        HEAP8[($2 + 221 | 0) >> 0] = $54 >>> 16 | 0;
        HEAP8[($2 + 222 | 0) >> 0] = $54 >>> 24 | 0;
        i64toi32_i32$2 = $2 + 280 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $192 = i64toi32_i32$1;
        i64toi32_i32$1 = $2;
        HEAP32[($2 + 168 | 0) >> 2] = $192;
        HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = $2 + 308 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $196 = i64toi32_i32$0;
        i64toi32_i32$0 = $2;
        HEAP32[($2 + 152 | 0) >> 2] = $196;
        HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$1;
        $3 = HEAP32[($2 + 304 | 0) >> 2] | 0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$1 = HEAP32[($2 + 264 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[($2 + 268 | 0) >> 2] | 0;
        $11 = i64toi32_i32$1;
        $11$hi = i64toi32_i32$0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 272 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 276 | 0) >> 2] | 0;
        $10 = i64toi32_i32$0;
        $10$hi = i64toi32_i32$1;
        $8 = HEAPU8[($2 + 256 | 0) >> 0] | 0;
        $55 = HEAPU8[($2 + 219 | 0) >> 0] | 0 | ((HEAPU8[($2 + 220 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 221 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 222 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 195 | 0) >> 0] = $55;
        HEAP8[($2 + 196 | 0) >> 0] = $55 >>> 8 | 0;
        HEAP8[($2 + 197 | 0) >> 0] = $55 >>> 16 | 0;
        HEAP8[($2 + 198 | 0) >> 0] = $55 >>> 24 | 0;
        HEAP32[($2 + 192 | 0) >> 2] = HEAP32[($2 + 216 | 0) >> 2] | 0;
        if (($8 | 0) != (19 | 0)) {
         break label$4
        }
        break label$3;
       }
       i64toi32_i32$2 = $2 + 280 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $218 = i64toi32_i32$1;
       i64toi32_i32$1 = $2 + 176 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $218;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = $2 + 288 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $224 = i64toi32_i32$0;
       i64toi32_i32$0 = ($2 + 168 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $224;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $2 + 272 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $228 = i64toi32_i32$1;
       i64toi32_i32$1 = $2;
       HEAP32[($2 + 168 | 0) >> 2] = $228;
       HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$0;
       $8 = 2;
       break label$4;
      }
      i64toi32_i32$2 = $2 + 280 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $233 = i64toi32_i32$0;
      i64toi32_i32$0 = $2 + 176 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $233;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $2 + 288 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $239 = i64toi32_i32$1;
      i64toi32_i32$1 = ($2 + 168 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $239;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $2 + 272 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $243 = i64toi32_i32$0;
      i64toi32_i32$0 = $2;
      HEAP32[($2 + 168 | 0) >> 2] = $243;
      HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$1;
     }
     i64toi32_i32$1 = $10$hi;
     i64toi32_i32$0 = ($2 + 248 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $10;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $11$hi;
     i64toi32_i32$0 = ($2 + 248 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $11;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAP32[($2 + 168 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 172 | 0) >> 2] | 0;
     $255 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 272 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $255;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[($2 + 152 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 156 | 0) >> 2] | 0;
     $259 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 300 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $259;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = ($2 + 168 | 0) + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $265 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 280 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $265;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = ($2 + 168 | 0) + 16 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $271 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 288 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $271;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($2 + 308 | 0) >> 2] = HEAP32[(($2 + 152 | 0) + 8 | 0) >> 2] | 0;
     HEAP8[($2 + 248 | 0) >> 0] = $8;
     $56 = HEAP32[($2 + 192 | 0) >> 2] | 0;
     HEAP8[($2 + 249 | 0) >> 0] = $56;
     HEAP8[($2 + 250 | 0) >> 0] = $56 >>> 8 | 0;
     HEAP8[($2 + 251 | 0) >> 0] = $56 >>> 16 | 0;
     HEAP8[($2 + 252 | 0) >> 0] = $56 >>> 24 | 0;
     $57 = HEAPU8[($2 + 195 | 0) >> 0] | 0 | ((HEAPU8[($2 + 196 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 197 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 198 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($2 + 252 | 0) >> 0] = $57;
     HEAP8[($2 + 253 | 0) >> 0] = $57 >>> 8 | 0;
     HEAP8[($2 + 254 | 0) >> 0] = $57 >>> 16 | 0;
     HEAP8[($2 + 255 | 0) >> 0] = $57 >>> 24 | 0;
     HEAP32[($2 + 296 | 0) >> 2] = $3;
     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($2 + 88 | 0 | 0, $2 + 248 | 0 | 0, 1051292 | 0, 16 | 0);
     $1 = HEAPU8[($2 + 88 | 0) >> 0] | 0;
     if (($1 | 0) != (19 | 0)) {
      break label$2
     }
    }
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $298 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $298;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
    $3 = 0;
    break label$1;
   }
   $3 = 1;
   memcpy($2 + 25 | 0 | 0, $2 + 88 | 0 | 1 | 0 | 0, 63 | 0) | 0;
   HEAP8[($0 + 8 | 0) >> 0] = $1;
   memcpy($0 + 9 | 0 | 0, $2 + 25 | 0 | 0, 63 | 0) | 0;
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hf2b315b267dbf438($2 + 8 | 0 | 0);
  }
  HEAP32[$0 >> 2] = $3;
  global$0 = $2 + 320 | 0;
 }
 
 function core__num__flt2dec__strategy__grisu__format_exact_opt__hee3f5edd0e371389($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var i64toi32_i32$4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, i64toi32_i32$2 = 0, i64toi32_i32$5 = 0, $5 = 0, $13$hi = 0, $13 = 0, $16$hi = 0, $14$hi = 0, $7 = 0, $14 = 0, $6 = 0, $16 = 0, $18$hi = 0, $8 = 0, $9 = 0, $17$hi = 0, $15$hi = 0, $18 = 0, $11 = 0, $15 = 0, $17 = 0, $92 = 0, $93 = 0, $94 = 0, $95 = 0, $96 = 0, $97 = 0, $98 = 0, $99 = 0, $100 = 0, $101 = 0, $102 = 0, $103 = 0, $104 = 0, $105 = 0, $106 = 0, $107 = 0, $108 = 0, $19$hi = 0, $109 = 0, $110 = 0, $111 = 0, $112 = 0, $38 = 0, $39 = 0, $41$hi = 0, $50 = 0, $51 = 0, $53$hi = 0, $62 = 0, $63 = 0, $65$hi = 0, $74 = 0, $75 = 0, $77$hi = 0, $84 = 0, $86$hi = 0, $114 = 0, $114$hi = 0, $115 = 0, $115$hi = 0, $118$hi = 0, $125 = 0, $125$hi = 0, $130 = 0, $130$hi = 0, $131 = 0, $131$hi = 0, $138$hi = 0, $139 = 0, $139$hi = 0, $141 = 0, $141$hi = 0, $145$hi = 0, $146$hi = 0, $148 = 0, $148$hi = 0, $151$hi = 0, $217 = 0, $217$hi = 0, $10 = 0, $12 = 0, $268 = 0, $269 = 0, $270 = 0, $271 = 0, $272 = 0, $274 = 0, $274$hi = 0, $276$hi = 0, $278$hi = 0, $19 = 0, $309 = 0, $332 = 0, $333 = 0, $334 = 0, $335 = 0, $336 = 0, $337 = 0, $339$hi = 0, $341$hi = 0, $343 = 0, $343$hi = 0, $345$hi = 0, $347$hi = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         i64toi32_i32$2 = $1;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $13 = i64toi32_i32$0;
         $13$hi = i64toi32_i32$1;
         if (!(i64toi32_i32$0 | i64toi32_i32$1 | 0)) {
          break label$7
         }
         i64toi32_i32$1 = $13$hi;
         i64toi32_i32$2 = $13;
         i64toi32_i32$0 = 536870911;
         i64toi32_i32$3 = -1;
         if (i64toi32_i32$1 >>> 0 > i64toi32_i32$0 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$2 >>> 0 > i64toi32_i32$3 >>> 0 | 0) | 0) {
          break label$6
         }
         if (!$3) {
          break label$4
         }
         $1 = HEAPU16[($1 + 24 | 0) >> 1] | 0;
         i64toi32_i32$2 = $13$hi;
         i64toi32_i32$3 = $13;
         i64toi32_i32$1 = 1;
         i64toi32_i32$0 = 0;
         $5 = i64toi32_i32$2 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$3 >>> 0 < i64toi32_i32$0 >>> 0 | 0) | 0;
         $1 = $5 ? $1 + -32 | 0 : $1;
         $38 = $1 + -16 | 0;
         $39 = $1;
         i64toi32_i32$3 = i64toi32_i32$2;
         i64toi32_i32$0 = $13;
         i64toi32_i32$2 = 0;
         i64toi32_i32$1 = 32;
         i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
          i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
          $92 = 0;
         } else {
          i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$4 | 0) | 0;
          $92 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
         }
         $41$hi = i64toi32_i32$2;
         i64toi32_i32$2 = $13$hi;
         i64toi32_i32$4 = $5;
         i64toi32_i32$2 = $41$hi;
         i64toi32_i32$0 = $13$hi;
         i64toi32_i32$1 = i64toi32_i32$4 ? $92 : $13;
         i64toi32_i32$3 = i64toi32_i32$4 ? i64toi32_i32$2 : i64toi32_i32$0;
         $13 = i64toi32_i32$1;
         $13$hi = i64toi32_i32$3;
         i64toi32_i32$4 = i64toi32_i32$1;
         i64toi32_i32$1 = 65536;
         i64toi32_i32$2 = 0;
         $5 = i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0;
         $1 = $5 ? $38 : $39;
         $50 = $1 + -8 | 0;
         $51 = $1;
         i64toi32_i32$4 = i64toi32_i32$3;
         i64toi32_i32$4 = i64toi32_i32$3;
         i64toi32_i32$2 = $13;
         i64toi32_i32$3 = 0;
         i64toi32_i32$1 = 16;
         i64toi32_i32$0 = i64toi32_i32$1 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
          i64toi32_i32$3 = i64toi32_i32$2 << i64toi32_i32$0 | 0;
          $93 = 0;
         } else {
          i64toi32_i32$3 = ((1 << i64toi32_i32$0 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$0 | 0) | 0) | 0 | (i64toi32_i32$4 << i64toi32_i32$0 | 0) | 0;
          $93 = i64toi32_i32$2 << i64toi32_i32$0 | 0;
         }
         $53$hi = i64toi32_i32$3;
         i64toi32_i32$3 = $13$hi;
         i64toi32_i32$0 = $5;
         i64toi32_i32$3 = $53$hi;
         i64toi32_i32$2 = $13$hi;
         i64toi32_i32$1 = i64toi32_i32$0 ? $93 : $13;
         i64toi32_i32$4 = i64toi32_i32$0 ? i64toi32_i32$3 : i64toi32_i32$2;
         $13 = i64toi32_i32$1;
         $13$hi = i64toi32_i32$4;
         i64toi32_i32$0 = i64toi32_i32$1;
         i64toi32_i32$1 = 16777216;
         i64toi32_i32$3 = 0;
         $5 = i64toi32_i32$4 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
         $1 = $5 ? $50 : $51;
         $62 = $1 + -4 | 0;
         $63 = $1;
         i64toi32_i32$0 = i64toi32_i32$4;
         i64toi32_i32$3 = $13;
         i64toi32_i32$4 = 0;
         i64toi32_i32$1 = 8;
         i64toi32_i32$2 = i64toi32_i32$1 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
          i64toi32_i32$4 = i64toi32_i32$3 << i64toi32_i32$2 | 0;
          $94 = 0;
         } else {
          i64toi32_i32$4 = ((1 << i64toi32_i32$2 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$2 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$2 | 0) | 0;
          $94 = i64toi32_i32$3 << i64toi32_i32$2 | 0;
         }
         $65$hi = i64toi32_i32$4;
         i64toi32_i32$4 = $13$hi;
         i64toi32_i32$2 = $5;
         i64toi32_i32$4 = $65$hi;
         i64toi32_i32$3 = $13$hi;
         i64toi32_i32$1 = i64toi32_i32$2 ? $94 : $13;
         i64toi32_i32$0 = i64toi32_i32$2 ? i64toi32_i32$4 : i64toi32_i32$3;
         $13 = i64toi32_i32$1;
         $13$hi = i64toi32_i32$0;
         i64toi32_i32$2 = i64toi32_i32$1;
         i64toi32_i32$1 = 268435456;
         i64toi32_i32$4 = 0;
         $5 = i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$4 >>> 0 | 0) | 0;
         $1 = $5 ? $62 : $63;
         $74 = $1 + -2 | 0;
         $75 = $1;
         i64toi32_i32$2 = i64toi32_i32$0;
         i64toi32_i32$2 = i64toi32_i32$0;
         i64toi32_i32$4 = $13;
         i64toi32_i32$0 = 0;
         i64toi32_i32$1 = 4;
         i64toi32_i32$3 = i64toi32_i32$1 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
          i64toi32_i32$0 = i64toi32_i32$4 << i64toi32_i32$3 | 0;
          $95 = 0;
         } else {
          i64toi32_i32$0 = ((1 << i64toi32_i32$3 | 0) - 1 | 0) & (i64toi32_i32$4 >>> (32 - i64toi32_i32$3 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$3 | 0) | 0;
          $95 = i64toi32_i32$4 << i64toi32_i32$3 | 0;
         }
         $77$hi = i64toi32_i32$0;
         i64toi32_i32$0 = $13$hi;
         i64toi32_i32$3 = $5;
         i64toi32_i32$0 = $77$hi;
         i64toi32_i32$4 = $13$hi;
         i64toi32_i32$1 = i64toi32_i32$3 ? $95 : $13;
         i64toi32_i32$2 = i64toi32_i32$3 ? i64toi32_i32$0 : i64toi32_i32$4;
         $13 = i64toi32_i32$1;
         $13$hi = i64toi32_i32$2;
         i64toi32_i32$3 = i64toi32_i32$1;
         i64toi32_i32$1 = 1073741824;
         i64toi32_i32$0 = 0;
         $5 = i64toi32_i32$2 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$3 >>> 0 < i64toi32_i32$0 >>> 0 | 0) | 0;
         $84 = $5 ? $74 : $75;
         i64toi32_i32$3 = i64toi32_i32$2;
         i64toi32_i32$0 = $13;
         i64toi32_i32$2 = 0;
         i64toi32_i32$1 = 2;
         i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
          i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
          $96 = 0;
         } else {
          i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$4 | 0) | 0;
          $96 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
         }
         $86$hi = i64toi32_i32$2;
         i64toi32_i32$2 = $13$hi;
         i64toi32_i32$4 = $5;
         i64toi32_i32$2 = $86$hi;
         i64toi32_i32$0 = $13$hi;
         i64toi32_i32$1 = i64toi32_i32$4 ? $96 : $13;
         i64toi32_i32$3 = i64toi32_i32$4 ? i64toi32_i32$2 : i64toi32_i32$0;
         $13 = i64toi32_i32$1;
         $13$hi = i64toi32_i32$3;
         i64toi32_i32$4 = i64toi32_i32$1;
         i64toi32_i32$1 = 0;
         i64toi32_i32$2 = 63;
         i64toi32_i32$0 = i64toi32_i32$2 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
          i64toi32_i32$1 = i64toi32_i32$3 >> 31 | 0;
          $97 = i64toi32_i32$3 >> i64toi32_i32$0 | 0;
         } else {
          i64toi32_i32$1 = i64toi32_i32$3 >> i64toi32_i32$0 | 0;
          $97 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$0 | 0) | 0;
         }
         $5 = $84 + ($97 ^ -1 | 0) | 0;
         $1 = (Math_imul(((-96 - $5 | 0) << 16 | 0) >> 16 | 0, 80) + 86960 | 0 | 0) / (2126 | 0) | 0;
         if ($1 >>> 0 >= 81 >>> 0) {
          break label$5
         }
         $1 = $1 << 4 | 0;
         $6 = HEAPU16[($1 + 1147258 | 0) >> 1] | 0;
         label$8 : {
          label$9 : {
           label$10 : {
            label$11 : {
             i64toi32_i32$3 = $1 + 1147248 | 0;
             i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
             i64toi32_i32$4 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
             $14 = i64toi32_i32$1;
             $14$hi = i64toi32_i32$4;
             i64toi32_i32$3 = i64toi32_i32$1;
             i64toi32_i32$1 = 0;
             i64toi32_i32$2 = -1;
             i64toi32_i32$1 = i64toi32_i32$4 & i64toi32_i32$1 | 0;
             $15 = i64toi32_i32$3 & i64toi32_i32$2 | 0;
             $15$hi = i64toi32_i32$1;
             $114 = $15;
             $114$hi = i64toi32_i32$1;
             i64toi32_i32$1 = $13$hi;
             $115 = $13;
             $115$hi = i64toi32_i32$1;
             i64toi32_i32$4 = $13;
             i64toi32_i32$3 = -1;
             i64toi32_i32$2 = -1;
             i64toi32_i32$3 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
             i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
             i64toi32_i32$4 = 0;
             i64toi32_i32$2 = 63;
             i64toi32_i32$0 = i64toi32_i32$2 & 31 | 0;
             if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
              i64toi32_i32$4 = 0;
              $98 = i64toi32_i32$3 >>> i64toi32_i32$0 | 0;
             } else {
              i64toi32_i32$4 = i64toi32_i32$3 >>> i64toi32_i32$0 | 0;
              $98 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$0 | 0) | 0;
             }
             $118$hi = i64toi32_i32$4;
             i64toi32_i32$4 = $115$hi;
             i64toi32_i32$3 = $115;
             i64toi32_i32$1 = $118$hi;
             i64toi32_i32$2 = $98;
             i64toi32_i32$0 = i64toi32_i32$2 & 31 | 0;
             if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
              i64toi32_i32$1 = i64toi32_i32$3 << i64toi32_i32$0 | 0;
              $99 = 0;
             } else {
              i64toi32_i32$1 = ((1 << i64toi32_i32$0 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$0 | 0) | 0) | 0 | (i64toi32_i32$4 << i64toi32_i32$0 | 0) | 0;
              $99 = i64toi32_i32$3 << i64toi32_i32$0 | 0;
             }
             $13 = $99;
             $13$hi = i64toi32_i32$1;
             i64toi32_i32$4 = $13;
             i64toi32_i32$3 = 0;
             i64toi32_i32$2 = 32;
             i64toi32_i32$0 = i64toi32_i32$2 & 31 | 0;
             if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
              i64toi32_i32$3 = 0;
              $100 = i64toi32_i32$1 >>> i64toi32_i32$0 | 0;
             } else {
              i64toi32_i32$3 = i64toi32_i32$1 >>> i64toi32_i32$0 | 0;
              $100 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$0 | 0) | 0;
             }
             $16 = $100;
             $16$hi = i64toi32_i32$3;
             i64toi32_i32$3 = $114$hi;
             i64toi32_i32$4 = $16$hi;
             i64toi32_i32$4 = __wasm_i64_mul($114 | 0, i64toi32_i32$3 | 0, $16 | 0, i64toi32_i32$4 | 0) | 0;
             i64toi32_i32$3 = i64toi32_i32$HIGH_BITS;
             $17 = i64toi32_i32$4;
             $17$hi = i64toi32_i32$3;
             i64toi32_i32$1 = i64toi32_i32$4;
             i64toi32_i32$4 = 0;
             i64toi32_i32$2 = 32;
             i64toi32_i32$0 = i64toi32_i32$2 & 31 | 0;
             if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
              i64toi32_i32$4 = 0;
              $101 = i64toi32_i32$3 >>> i64toi32_i32$0 | 0;
             } else {
              i64toi32_i32$4 = i64toi32_i32$3 >>> i64toi32_i32$0 | 0;
              $101 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$0 | 0) | 0;
             }
             $125 = $101;
             $125$hi = i64toi32_i32$4;
             i64toi32_i32$4 = $14$hi;
             i64toi32_i32$3 = $14;
             i64toi32_i32$1 = 0;
             i64toi32_i32$2 = 32;
             i64toi32_i32$0 = i64toi32_i32$2 & 31 | 0;
             if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
              i64toi32_i32$1 = 0;
              $102 = i64toi32_i32$4 >>> i64toi32_i32$0 | 0;
             } else {
              i64toi32_i32$1 = i64toi32_i32$4 >>> i64toi32_i32$0 | 0;
              $102 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$0 | 0) | 0;
             }
             $14 = $102;
             $14$hi = i64toi32_i32$1;
             i64toi32_i32$1 = $16$hi;
             i64toi32_i32$1 = $14$hi;
             i64toi32_i32$3 = $16$hi;
             i64toi32_i32$3 = __wasm_i64_mul($14 | 0, i64toi32_i32$1 | 0, $16 | 0, i64toi32_i32$3 | 0) | 0;
             i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
             $130 = i64toi32_i32$3;
             $130$hi = i64toi32_i32$1;
             i64toi32_i32$1 = $125$hi;
             i64toi32_i32$4 = $125;
             i64toi32_i32$3 = $130$hi;
             i64toi32_i32$2 = $130;
             i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
             i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
             if (i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0) {
              i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
             }
             $131 = i64toi32_i32$0;
             $131$hi = i64toi32_i32$5;
             i64toi32_i32$5 = $14$hi;
             i64toi32_i32$5 = $13$hi;
             i64toi32_i32$1 = $13;
             i64toi32_i32$4 = 0;
             i64toi32_i32$2 = -1;
             i64toi32_i32$4 = i64toi32_i32$5 & i64toi32_i32$4 | 0;
             $13 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
             $13$hi = i64toi32_i32$4;
             i64toi32_i32$4 = $14$hi;
             i64toi32_i32$1 = $13$hi;
             i64toi32_i32$1 = __wasm_i64_mul($14 | 0, i64toi32_i32$4 | 0, $13 | 0, i64toi32_i32$1 | 0) | 0;
             i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
             $14 = i64toi32_i32$1;
             $14$hi = i64toi32_i32$4;
             i64toi32_i32$5 = i64toi32_i32$1;
             i64toi32_i32$1 = 0;
             i64toi32_i32$2 = 32;
             i64toi32_i32$3 = i64toi32_i32$2 & 31 | 0;
             if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
              i64toi32_i32$1 = 0;
              $103 = i64toi32_i32$4 >>> i64toi32_i32$3 | 0;
             } else {
              i64toi32_i32$1 = i64toi32_i32$4 >>> i64toi32_i32$3 | 0;
              $103 = (((1 << i64toi32_i32$3 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$3 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$3 | 0) | 0;
             }
             $138$hi = i64toi32_i32$1;
             i64toi32_i32$1 = $131$hi;
             i64toi32_i32$4 = $131;
             i64toi32_i32$5 = $138$hi;
             i64toi32_i32$2 = $103;
             i64toi32_i32$3 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
             i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
             if (i64toi32_i32$3 >>> 0 < i64toi32_i32$2 >>> 0) {
              i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
             }
             $139 = i64toi32_i32$3;
             $139$hi = i64toi32_i32$0;
             i64toi32_i32$0 = $17$hi;
             i64toi32_i32$1 = $17;
             i64toi32_i32$4 = 0;
             i64toi32_i32$2 = -1;
             i64toi32_i32$4 = i64toi32_i32$0 & i64toi32_i32$4 | 0;
             $141 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
             $141$hi = i64toi32_i32$4;
             i64toi32_i32$4 = $15$hi;
             i64toi32_i32$4 = $13$hi;
             i64toi32_i32$4 = $15$hi;
             i64toi32_i32$1 = $13$hi;
             i64toi32_i32$1 = __wasm_i64_mul($15 | 0, i64toi32_i32$4 | 0, $13 | 0, i64toi32_i32$1 | 0) | 0;
             i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
             i64toi32_i32$0 = i64toi32_i32$1;
             i64toi32_i32$1 = 0;
             i64toi32_i32$2 = 32;
             i64toi32_i32$5 = i64toi32_i32$2 & 31 | 0;
             if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
              i64toi32_i32$1 = 0;
              $104 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
             } else {
              i64toi32_i32$1 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
              $104 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$5 | 0) | 0;
             }
             $145$hi = i64toi32_i32$1;
             i64toi32_i32$1 = $141$hi;
             i64toi32_i32$4 = $141;
             i64toi32_i32$0 = $145$hi;
             i64toi32_i32$2 = $104;
             i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
             i64toi32_i32$3 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
             if (i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0) {
              i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
             }
             $146$hi = i64toi32_i32$3;
             i64toi32_i32$3 = $14$hi;
             i64toi32_i32$1 = $14;
             i64toi32_i32$4 = 0;
             i64toi32_i32$2 = -1;
             i64toi32_i32$4 = i64toi32_i32$3 & i64toi32_i32$4 | 0;
             $148 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
             $148$hi = i64toi32_i32$4;
             i64toi32_i32$4 = $146$hi;
             i64toi32_i32$3 = i64toi32_i32$5;
             i64toi32_i32$1 = $148$hi;
             i64toi32_i32$2 = $148;
             i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
             i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
             if (i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0) {
              i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
             }
             i64toi32_i32$4 = i64toi32_i32$0;
             i64toi32_i32$3 = 0;
             i64toi32_i32$2 = -2147483648;
             i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
             i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
             if (i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0) {
              i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
             }
             i64toi32_i32$5 = i64toi32_i32$1;
             i64toi32_i32$4 = 0;
             i64toi32_i32$2 = 32;
             i64toi32_i32$3 = i64toi32_i32$2 & 31 | 0;
             if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
              i64toi32_i32$4 = 0;
              $105 = i64toi32_i32$0 >>> i64toi32_i32$3 | 0;
             } else {
              i64toi32_i32$4 = i64toi32_i32$0 >>> i64toi32_i32$3 | 0;
              $105 = (((1 << i64toi32_i32$3 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$3 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$3 | 0) | 0;
             }
             $151$hi = i64toi32_i32$4;
             i64toi32_i32$4 = $139$hi;
             i64toi32_i32$0 = $139;
             i64toi32_i32$5 = $151$hi;
             i64toi32_i32$2 = $105;
             i64toi32_i32$3 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
             i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
             if (i64toi32_i32$3 >>> 0 < i64toi32_i32$2 >>> 0) {
              i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
             }
             $13 = i64toi32_i32$3;
             $13$hi = i64toi32_i32$1;
             $1 = -64 - ($5 + (HEAPU16[($1 + 1147256 | 0) >> 1] | 0) | 0) | 0;
             i64toi32_i32$1 = 0;
             $16 = $1 & 63 | 0;
             $16$hi = i64toi32_i32$1;
             i64toi32_i32$1 = $13$hi;
             i64toi32_i32$4 = i64toi32_i32$3;
             i64toi32_i32$0 = $16$hi;
             i64toi32_i32$2 = $16;
             i64toi32_i32$5 = i64toi32_i32$2 & 31 | 0;
             if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
              i64toi32_i32$0 = 0;
              $106 = i64toi32_i32$1 >>> i64toi32_i32$5 | 0;
             } else {
              i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$5 | 0;
              $106 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$5 | 0) | 0;
             }
             $7 = $106;
             if ($7 >>> 0 < 1e4 >>> 0) {
              break label$11
             }
             if ($7 >>> 0 < 1e6 >>> 0) {
              break label$10
             }
             if ($7 >>> 0 < 1e8 >>> 0) {
              break label$9
             }
             $5 = $7 >>> 0 < 1e9 >>> 0;
             $8 = $5 ? 8 : 9;
             $5 = $5 ? 1e8 : 1e9;
             break label$8;
            }
            label$12 : {
             if ($7 >>> 0 < 100 >>> 0) {
              break label$12
             }
             $5 = $7 >>> 0 < 1e3 >>> 0;
             $8 = $5 ? 2 : 3;
             $5 = $5 ? 100 : 1e3;
             break label$8;
            }
            $5 = $7 >>> 0 < 10 >>> 0 ? 1 : 10;
            $8 = $7 >>> 0 > 9 >>> 0;
            break label$8;
           }
           $5 = $7 >>> 0 < 1e5 >>> 0;
           $8 = $5 ? 4 : 5;
           $5 = $5 ? 1e4 : 1e5;
           break label$8;
          }
          $5 = $7 >>> 0 < 1e7 >>> 0;
          $8 = $5 ? 6 : 7;
          $5 = $5 ? 1e6 : 1e7;
         }
         i64toi32_i32$0 = $16$hi;
         i64toi32_i32$0 = 0;
         i64toi32_i32$1 = 1;
         i64toi32_i32$4 = $16$hi;
         i64toi32_i32$2 = $16;
         i64toi32_i32$5 = i64toi32_i32$2 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
          i64toi32_i32$4 = i64toi32_i32$1 << i64toi32_i32$5 | 0;
          $107 = 0;
         } else {
          i64toi32_i32$4 = ((1 << i64toi32_i32$5 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$5 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$5 | 0) | 0;
          $107 = i64toi32_i32$1 << i64toi32_i32$5 | 0;
         }
         $18 = $107;
         $18$hi = i64toi32_i32$4;
         label$13 : {
          label$14 : {
           $9 = ((($8 - $6 | 0) << 16 | 0) + 65536 | 0) >> 16 | 0;
           $6 = ($4 << 16 | 0) >> 16 | 0;
           if (($9 | 0) <= ($6 | 0)) {
            break label$14
           }
           i64toi32_i32$4 = $13$hi;
           $217 = $13;
           $217$hi = i64toi32_i32$4;
           i64toi32_i32$4 = $18$hi;
           i64toi32_i32$0 = $18;
           i64toi32_i32$1 = -1;
           i64toi32_i32$2 = -1;
           i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
           i64toi32_i32$3 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
           if (i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0) {
            i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
           }
           $17 = i64toi32_i32$5;
           $17$hi = i64toi32_i32$3;
           i64toi32_i32$3 = $217$hi;
           i64toi32_i32$4 = $217;
           i64toi32_i32$0 = $17$hi;
           i64toi32_i32$2 = i64toi32_i32$5;
           i64toi32_i32$0 = i64toi32_i32$3 & i64toi32_i32$0 | 0;
           $14 = i64toi32_i32$4 & i64toi32_i32$2 | 0;
           $14$hi = i64toi32_i32$0;
           $10 = $1 & 65535 | 0;
           $11 = ($9 - $6 | 0) >>> 0 < $3 >>> 0 ? (($9 - $4 | 0) << 16 | 0) >> 16 | 0 : $3;
           $12 = $11 + -1 | 0;
           $1 = 0;
           label$15 : while (1) {
            $6 = ($7 >>> 0) / ($5 >>> 0) | 0;
            if (($3 | 0) == ($1 | 0)) {
             break label$3
            }
            $7 = $7 - Math_imul($6, $5) | 0;
            HEAP8[($2 + $1 | 0) >> 0] = $6 + 48 | 0;
            if (($12 | 0) == ($1 | 0)) {
             break label$2
            }
            if (($8 | 0) == ($1 | 0)) {
             break label$13
            }
            $1 = $1 + 1 | 0;
            $6 = $5 >>> 0 < 10 >>> 0;
            $5 = ($5 >>> 0) / (10 >>> 0) | 0;
            if (!$6) {
             continue label$15
            }
            break label$15;
           };
           core__panicking__panic__h2fd385a887c8bf13(1148784 | 0, 25 | 0, 1148996 | 0);
           abort();
          }
          $268 = $0;
          $269 = $2;
          $270 = $3;
          $271 = $9;
          $272 = $4;
          i64toi32_i32$0 = $13$hi;
          i64toi32_i32$4 = 0;
          i64toi32_i32$4 = __wasm_i64_udiv($13 | 0, i64toi32_i32$0 | 0, 10 | 0, i64toi32_i32$4 | 0) | 0;
          i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
          $274 = i64toi32_i32$4;
          $274$hi = i64toi32_i32$0;
          i64toi32_i32$0 = 0;
          $276$hi = i64toi32_i32$0;
          i64toi32_i32$0 = $16$hi;
          i64toi32_i32$0 = $276$hi;
          i64toi32_i32$3 = $5;
          i64toi32_i32$4 = $16$hi;
          i64toi32_i32$2 = $16;
          i64toi32_i32$1 = i64toi32_i32$2 & 31 | 0;
          if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
           i64toi32_i32$4 = i64toi32_i32$3 << i64toi32_i32$1 | 0;
           $108 = 0;
          } else {
           i64toi32_i32$4 = ((1 << i64toi32_i32$1 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$1 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$1 | 0) | 0;
           $108 = i64toi32_i32$3 << i64toi32_i32$1 | 0;
          }
          $278$hi = i64toi32_i32$4;
          i64toi32_i32$4 = $18$hi;
          i64toi32_i32$4 = $274$hi;
          i64toi32_i32$3 = $278$hi;
          i64toi32_i32$0 = $18$hi;
          core__num__flt2dec__strategy__grisu__format_exact_opt__possibly_round__hc591c7b9929b43d8($268 | 0, $269 | 0, $270 | 0, 0 | 0, $271 | 0, $272 | 0, $274 | 0, i64toi32_i32$4 | 0, $108 | 0, i64toi32_i32$3 | 0, $18 | 0, i64toi32_i32$0 | 0);
          return;
         }
         $5 = $1 + 1 | 0;
         $1 = $1 >>> 0 < $3 >>> 0 ? $3 : $5;
         i64toi32_i32$0 = 0;
         $19 = ($10 + -1 | 0) & 63 | 0;
         $19$hi = i64toi32_i32$0;
         i64toi32_i32$0 = 0;
         $13 = 1;
         $13$hi = i64toi32_i32$0;
         label$16 : while (1) {
          label$17 : {
           i64toi32_i32$0 = $13$hi;
           i64toi32_i32$0 = $19$hi;
           i64toi32_i32$0 = $13$hi;
           i64toi32_i32$4 = $13;
           i64toi32_i32$3 = $19$hi;
           i64toi32_i32$2 = $19;
           i64toi32_i32$1 = i64toi32_i32$2 & 31 | 0;
           if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
            i64toi32_i32$3 = 0;
            $109 = i64toi32_i32$0 >>> i64toi32_i32$1 | 0;
           } else {
            i64toi32_i32$3 = i64toi32_i32$0 >>> i64toi32_i32$1 | 0;
            $109 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$1 | 0) | 0;
           }
           if (!($109 | i64toi32_i32$3 | 0)) {
            break label$17
           }
           HEAP32[$0 >> 2] = 0;
           return;
          }
          if (($1 | 0) == ($5 | 0)) {
           break label$1
          }
          i64toi32_i32$3 = $13$hi;
          i64toi32_i32$4 = 0;
          i64toi32_i32$4 = __wasm_i64_mul($13 | 0, i64toi32_i32$3 | 0, 10 | 0, i64toi32_i32$4 | 0) | 0;
          i64toi32_i32$3 = i64toi32_i32$HIGH_BITS;
          $13 = i64toi32_i32$4;
          $13$hi = i64toi32_i32$3;
          i64toi32_i32$3 = $14$hi;
          i64toi32_i32$4 = 0;
          i64toi32_i32$4 = __wasm_i64_mul($14 | 0, i64toi32_i32$3 | 0, 10 | 0, i64toi32_i32$4 | 0) | 0;
          i64toi32_i32$3 = i64toi32_i32$HIGH_BITS;
          $15 = i64toi32_i32$4;
          $15$hi = i64toi32_i32$3;
          i64toi32_i32$3 = $17$hi;
          i64toi32_i32$3 = $15$hi;
          i64toi32_i32$0 = i64toi32_i32$4;
          i64toi32_i32$4 = $17$hi;
          i64toi32_i32$2 = $17;
          i64toi32_i32$4 = i64toi32_i32$3 & i64toi32_i32$4 | 0;
          $14 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
          $14$hi = i64toi32_i32$4;
          $309 = $2 + $5 | 0;
          i64toi32_i32$4 = i64toi32_i32$3;
          i64toi32_i32$4 = $16$hi;
          i64toi32_i32$4 = i64toi32_i32$3;
          i64toi32_i32$3 = i64toi32_i32$0;
          i64toi32_i32$0 = $16$hi;
          i64toi32_i32$2 = $16;
          i64toi32_i32$1 = i64toi32_i32$2 & 31 | 0;
          if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
           i64toi32_i32$0 = 0;
           $110 = i64toi32_i32$4 >>> i64toi32_i32$1 | 0;
          } else {
           i64toi32_i32$0 = i64toi32_i32$4 >>> i64toi32_i32$1 | 0;
           $110 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$1 | 0) | 0;
          }
          HEAP8[$309 >> 0] = $110 + 48 | 0;
          $5 = $5 + 1 | 0;
          if (($11 | 0) != ($5 | 0)) {
           continue label$16
          }
          break label$16;
         };
         i64toi32_i32$0 = $14$hi;
         i64toi32_i32$0 = $18$hi;
         i64toi32_i32$0 = $13$hi;
         i64toi32_i32$0 = $14$hi;
         i64toi32_i32$3 = $18$hi;
         i64toi32_i32$4 = $13$hi;
         core__num__flt2dec__strategy__grisu__format_exact_opt__possibly_round__hc591c7b9929b43d8($0 | 0, $2 | 0, $3 | 0, $11 | 0, $9 | 0, $4 | 0, $14 | 0, i64toi32_i32$0 | 0, $18 | 0, i64toi32_i32$3 | 0, $13 | 0, i64toi32_i32$4 | 0);
         return;
        }
        core__panicking__panic__h2fd385a887c8bf13(1146679 | 0, 28 | 0, 1148912 | 0);
        abort();
       }
       core__panicking__panic__h2fd385a887c8bf13(1148928 | 0, 36 | 0, 1148964 | 0);
       abort();
      }
      core__panicking__panic_bounds_check__h808b524af17640b1($1 | 0, 81 | 0, 1148592 | 0);
      abort();
     }
     core__panicking__panic__h2fd385a887c8bf13(1148876 | 0, 33 | 0, 1148980 | 0);
     abort();
    }
    core__panicking__panic_bounds_check__h808b524af17640b1($3 | 0, $3 | 0, 1149012 | 0);
    abort();
   }
   $332 = $0;
   $333 = $2;
   $334 = $3;
   $335 = $11;
   $336 = $9;
   $337 = $4;
   i64toi32_i32$4 = 0;
   $339$hi = i64toi32_i32$4;
   i64toi32_i32$4 = $16$hi;
   i64toi32_i32$4 = $339$hi;
   i64toi32_i32$0 = $7;
   i64toi32_i32$3 = $16$hi;
   i64toi32_i32$2 = $16;
   i64toi32_i32$1 = i64toi32_i32$2 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
    i64toi32_i32$3 = i64toi32_i32$0 << i64toi32_i32$1 | 0;
    $111 = 0;
   } else {
    i64toi32_i32$3 = ((1 << i64toi32_i32$1 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$1 | 0) | 0) | 0 | (i64toi32_i32$4 << i64toi32_i32$1 | 0) | 0;
    $111 = i64toi32_i32$0 << i64toi32_i32$1 | 0;
   }
   $341$hi = i64toi32_i32$3;
   i64toi32_i32$3 = $14$hi;
   i64toi32_i32$3 = $341$hi;
   i64toi32_i32$4 = $111;
   i64toi32_i32$0 = $14$hi;
   i64toi32_i32$2 = $14;
   i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
   i64toi32_i32$5 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
   if (i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0) {
    i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
   }
   $343 = i64toi32_i32$1;
   $343$hi = i64toi32_i32$5;
   i64toi32_i32$5 = 0;
   $345$hi = i64toi32_i32$5;
   i64toi32_i32$5 = $16$hi;
   i64toi32_i32$5 = $345$hi;
   i64toi32_i32$3 = $5;
   i64toi32_i32$4 = $16$hi;
   i64toi32_i32$2 = $16;
   i64toi32_i32$0 = i64toi32_i32$2 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
    i64toi32_i32$4 = i64toi32_i32$3 << i64toi32_i32$0 | 0;
    $112 = 0;
   } else {
    i64toi32_i32$4 = ((1 << i64toi32_i32$0 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$0 | 0) | 0) | 0 | (i64toi32_i32$5 << i64toi32_i32$0 | 0) | 0;
    $112 = i64toi32_i32$3 << i64toi32_i32$0 | 0;
   }
   $347$hi = i64toi32_i32$4;
   i64toi32_i32$4 = $18$hi;
   i64toi32_i32$4 = $343$hi;
   i64toi32_i32$3 = $347$hi;
   i64toi32_i32$5 = $18$hi;
   core__num__flt2dec__strategy__grisu__format_exact_opt__possibly_round__hc591c7b9929b43d8($332 | 0, $333 | 0, $334 | 0, $335 | 0, $336 | 0, $337 | 0, $343 | 0, i64toi32_i32$4 | 0, $112 | 0, i64toi32_i32$3 | 0, $18 | 0, i64toi32_i32$5 | 0);
   return;
  }
  core__panicking__panic_bounds_check__h808b524af17640b1($1 | 0, $3 | 0, 1149028 | 0);
  abort();
 }
 
 function cardano_serialization_lib__utils__Value__checked_add__h5184687782847801($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$3 = 0, i64toi32_i32$5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $11$hi = 0, $4 = 0, $11 = 0, $5 = 0, $8 = 0, $42 = 0, $12$hi = 0, $13$hi = 0, $21 = 0, $21$hi = 0, $12 = 0, $6 = 0, $7 = 0, $72 = 0, $79 = 0, $82 = 0, $109 = 0, $116 = 0, $119 = 0, $141 = 0, $147 = 0, $150 = 0, $185 = 0, $9 = 0, $10 = 0, $221 = 0, $227 = 0, $230 = 0, $246 = 0, $246$hi = 0, $13 = 0, $292 = 0, $306 = 0;
  $3 = global$0 - 368 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      i64toi32_i32$2 = $1;
      i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      $11 = i64toi32_i32$0;
      $11$hi = i64toi32_i32$1;
      i64toi32_i32$2 = $2;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $21 = i64toi32_i32$1;
      $21$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $11$hi;
      i64toi32_i32$2 = $11;
      i64toi32_i32$1 = $21$hi;
      i64toi32_i32$3 = $21;
      i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
      i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
      if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
       i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
      }
      $12 = i64toi32_i32$4;
      $12$hi = i64toi32_i32$5;
      i64toi32_i32$5 = $11$hi;
      i64toi32_i32$5 = $12$hi;
      i64toi32_i32$0 = i64toi32_i32$4;
      i64toi32_i32$2 = $11$hi;
      i64toi32_i32$3 = $11;
      if (i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0) {
       break label$4
      }
      $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
      label$5 : {
       if ((HEAP32[($1 + 8 | 0) >> 2] | 0 | 0) == (1 | 0)) {
        break label$5
       }
       $1 = 0;
       if ($4) {
        break label$3
       }
       break label$2;
      }
      $1 = $1 + 12 | 0;
      label$6 : {
       if ($4) {
        break label$6
       }
       $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($3 + 56 | 0 | 0, $1 | 0);
       $1 = 1;
       break label$2;
      }
      i64toi32_i32$5 = $3;
      i64toi32_i32$0 = 0;
      HEAP32[($3 + 76 | 0) >> 2] = 0;
      HEAP32[($3 + 80 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[($3 + 92 | 0) >> 2] = $2 + 12 | 0;
      HEAP32[($3 + 88 | 0) >> 2] = $1;
      $5 = $3 + 320 | 0 | 4 | 0;
      $6 = $3 + 224 | 0 | 4 | 0;
      $7 = ($3 + 88 | 0) + 8 | 0;
      $8 = $3 + 88 | 0;
      label$7 : while (1) {
       alloc__collections__btree__map__BTreeMap_K_2cV___iter__h677e802ff7e211c3($3 + 96 | 0 | 0, HEAP32[$8 >> 2] | 0 | 0);
       HEAP32[(($3 + 128 | 0) + 24 | 0) >> 2] = HEAP32[(($3 + 96 | 0) + 24 | 0) >> 2] | 0;
       i64toi32_i32$3 = ($3 + 96 | 0) + 16 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $72 = i64toi32_i32$0;
       i64toi32_i32$0 = ($3 + 128 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $72;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$5;
       i64toi32_i32$3 = ($3 + 96 | 0) + 8 | 0;
       i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $79 = i64toi32_i32$5;
       i64toi32_i32$5 = ($3 + 128 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$5 >> 2] = $79;
       HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$3 = $3;
       i64toi32_i32$0 = HEAP32[($3 + 96 | 0) >> 2] | 0;
       i64toi32_i32$5 = HEAP32[($3 + 100 | 0) >> 2] | 0;
       $82 = i64toi32_i32$0;
       i64toi32_i32$0 = $3;
       HEAP32[($3 + 128 | 0) >> 2] = $82;
       HEAP32[($3 + 132 | 0) >> 2] = i64toi32_i32$5;
       $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h03cc330b7b1e4522($3 + 48 | 0 | 0, $3 + 128 | 0 | 0);
       label$8 : {
        $1 = HEAP32[($3 + 48 | 0) >> 2] | 0;
        if (!$1) {
         break label$8
        }
        $2 = HEAP32[($3 + 52 | 0) >> 2] | 0;
        label$9 : while (1) {
         alloc__collections__btree__map__BTreeMap_K_2cV___iter__ha89c9458aca0228d($3 + 160 | 0 | 0, $2 | 0);
         HEAP32[(($3 + 192 | 0) + 24 | 0) >> 2] = HEAP32[(($3 + 160 | 0) + 24 | 0) >> 2] | 0;
         i64toi32_i32$3 = ($3 + 160 | 0) + 16 | 0;
         i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $109 = i64toi32_i32$5;
         i64toi32_i32$5 = ($3 + 192 | 0) + 16 | 0;
         HEAP32[i64toi32_i32$5 >> 2] = $109;
         HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$3 = ($3 + 160 | 0) + 8 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $116 = i64toi32_i32$0;
         i64toi32_i32$0 = ($3 + 192 | 0) + 8 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $116;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$5;
         i64toi32_i32$3 = $3;
         i64toi32_i32$5 = HEAP32[($3 + 160 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($3 + 164 | 0) >> 2] | 0;
         $119 = i64toi32_i32$5;
         i64toi32_i32$5 = $3;
         HEAP32[($3 + 192 | 0) >> 2] = $119;
         HEAP32[($3 + 196 | 0) >> 2] = i64toi32_i32$0;
         $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h36ca092f81b9a0fa($3 + 40 | 0 | 0, $3 + 192 | 0 | 0);
         label$10 : {
          $2 = HEAP32[($3 + 40 | 0) >> 2] | 0;
          if (!$2) {
           break label$10
          }
          $4 = HEAP32[($3 + 44 | 0) >> 2] | 0;
          label$11 : while (1) {
           $42 = $1 + 24 | 0;
           HEAP32[(($3 + 320 | 0) + 24 | 0) >> 2] = HEAPU8[$42 >> 0] | 0 | ((HEAPU8[($42 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($42 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($42 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$3 = $1 + 16 | 0;
           i64toi32_i32$0 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$5 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $141 = i64toi32_i32$0;
           i64toi32_i32$0 = ($3 + 320 | 0) + 16 | 0;
           HEAP32[i64toi32_i32$0 >> 2] = $141;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$5;
           i64toi32_i32$3 = $1 + 8 | 0;
           i64toi32_i32$5 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$0 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $147 = i64toi32_i32$5;
           i64toi32_i32$5 = ($3 + 320 | 0) + 8 | 0;
           HEAP32[i64toi32_i32$5 >> 2] = $147;
           HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
           i64toi32_i32$3 = $1;
           i64toi32_i32$0 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$5 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $150 = i64toi32_i32$0;
           i64toi32_i32$0 = $3;
           HEAP32[($3 + 320 | 0) >> 2] = $150;
           HEAP32[($3 + 324 | 0) >> 2] = i64toi32_i32$5;
           alloc__collections__btree__map__BTreeMap_K_2cV___entry__hd27d6127e1982e7e($3 + 224 | 0 | 0, $3 + 72 | 0 | 0, $3 + 320 | 0 | 0);
           label$12 : {
            label$13 : {
             if ((HEAP32[($3 + 224 | 0) >> 2] | 0 | 0) == (1 | 0)) {
              break label$13
             }
             i64toi32_i32$0 = $3;
             i64toi32_i32$5 = 0;
             HEAP32[($3 + 308 | 0) >> 2] = 0;
             HEAP32[($3 + 312 | 0) >> 2] = i64toi32_i32$5;
             $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($3 + 320 | 0 | 0, $2 | 0);
             i64toi32_i32$3 = $4;
             i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
             i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
             alloc__collections__btree__map__BTreeMap_K_2cV___insert__hc7622c6487a4ba88($3 + 24 | 0 | 0, $3 + 304 | 0 | 0, $3 + 320 | 0 | 0, i64toi32_i32$5 | 0, i64toi32_i32$0 | 0);
             memcpy($3 + 320 | 0 | 0, $6 | 0, 44 | 0) | 0;
             HEAP32[(($3 + 272 | 0) + 8 | 0) >> 2] = HEAP32[(($3 + 304 | 0) + 8 | 0) >> 2] | 0;
             i64toi32_i32$3 = $3;
             i64toi32_i32$0 = HEAP32[($3 + 304 | 0) >> 2] | 0;
             i64toi32_i32$5 = HEAP32[($3 + 308 | 0) >> 2] | 0;
             $185 = i64toi32_i32$0;
             i64toi32_i32$0 = $3;
             HEAP32[($3 + 272 | 0) >> 2] = $185;
             HEAP32[($3 + 276 | 0) >> 2] = i64toi32_i32$5;
             alloc__collections__btree__map__entry__VacantEntry_K_2cV___insert__h1ccac11121812f65($3 + 320 | 0 | 0, $3 + 272 | 0 | 0) | 0;
             break label$12;
            }
            $9 = HEAP32[($3 + 232 | 0) >> 2] | 0;
            $10 = HEAP32[($3 + 236 | 0) >> 2] | 0;
            $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($3 + 272 | 0 | 0, $2 | 0);
            alloc__collections__btree__map__BTreeMap_K_2cV___entry__ha969beb26eee2f30($3 + 320 | 0 | 0, ($9 + Math_imul($10, 12) | 0) + 4 | 0 | 0, $3 + 272 | 0 | 0);
            label$14 : {
             if ((HEAP32[($3 + 320 | 0) >> 2] | 0 | 0) == (1 | 0)) {
              break label$14
             }
             HEAP32[(($3 + 272 | 0) + 24 | 0) >> 2] = HEAP32[($5 + 24 | 0) >> 2] | 0;
             i64toi32_i32$3 = $5 + 16 | 0;
             i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
             i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
             $221 = i64toi32_i32$5;
             i64toi32_i32$5 = ($3 + 272 | 0) + 16 | 0;
             HEAP32[i64toi32_i32$5 >> 2] = $221;
             HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
             i64toi32_i32$3 = $5 + 8 | 0;
             i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
             i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
             $227 = i64toi32_i32$0;
             i64toi32_i32$0 = ($3 + 272 | 0) + 8 | 0;
             HEAP32[i64toi32_i32$0 >> 2] = $227;
             HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$5;
             i64toi32_i32$3 = $5;
             i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
             i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
             $230 = i64toi32_i32$5;
             i64toi32_i32$5 = $3;
             HEAP32[($3 + 272 | 0) >> 2] = $230;
             HEAP32[($3 + 276 | 0) >> 2] = i64toi32_i32$0;
             i64toi32_i32$3 = $4;
             i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
             i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
             alloc__collections__btree__map__entry__VacantEntry_K_2cV___insert__h1331755557d851e2($3 + 272 | 0 | 0, i64toi32_i32$0 | 0, i64toi32_i32$5 | 0) | 0;
             break label$12;
            }
            label$15 : {
             $2 = (HEAP32[($3 + 328 | 0) >> 2] | 0) + ((HEAP32[($3 + 332 | 0) >> 2] | 0) << 3 | 0) | 0;
             i64toi32_i32$3 = $2;
             i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
             i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
             $11 = i64toi32_i32$5;
             $11$hi = i64toi32_i32$0;
             i64toi32_i32$3 = $4;
             i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
             i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
             $246 = i64toi32_i32$0;
             $246$hi = i64toi32_i32$5;
             i64toi32_i32$5 = $11$hi;
             i64toi32_i32$3 = $11;
             i64toi32_i32$0 = $246$hi;
             i64toi32_i32$2 = $246;
             i64toi32_i32$1 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
             i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
             if (i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0) {
              i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
             }
             $13 = i64toi32_i32$1;
             $13$hi = i64toi32_i32$4;
             i64toi32_i32$4 = $11$hi;
             i64toi32_i32$4 = $13$hi;
             i64toi32_i32$5 = i64toi32_i32$1;
             i64toi32_i32$3 = $11$hi;
             i64toi32_i32$2 = $11;
             if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0) {
              break label$15
             }
             i64toi32_i32$5 = $13$hi;
             i64toi32_i32$4 = $2;
             HEAP32[i64toi32_i32$4 >> 2] = $13;
             HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
             break label$12;
            }
            $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1058732 | 0, 8 | 0) | 0 | 0) | 0;
            HEAP32[$0 >> 2] = 1;
            HEAP32[($0 + 4 | 0) >> 2] = $1;
            $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($3 + 72 | 0 | 0);
            break label$1;
           }
           $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h36ca092f81b9a0fa($3 + 16 | 0 | 0, $3 + 192 | 0 | 0);
           $4 = HEAP32[($3 + 20 | 0) >> 2] | 0;
           $2 = HEAP32[($3 + 16 | 0) >> 2] | 0;
           if ($2) {
            continue label$11
           }
           break label$11;
          };
         }
         $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h03cc330b7b1e4522($3 + 8 | 0 | 0, $3 + 128 | 0 | 0);
         $2 = HEAP32[($3 + 12 | 0) >> 2] | 0;
         $1 = HEAP32[($3 + 8 | 0) >> 2] | 0;
         if ($1) {
          continue label$9
         }
         break label$9;
        };
       }
       $8 = $8 + 4 | 0;
       if (($8 | 0) != ($7 | 0)) {
        continue label$7
       }
       break label$7;
      };
      HEAP32[(($3 + 56 | 0) + 8 | 0) >> 2] = HEAP32[(($3 + 72 | 0) + 8 | 0) >> 2] | 0;
      i64toi32_i32$2 = $3;
      i64toi32_i32$5 = HEAP32[($3 + 72 | 0) >> 2] | 0;
      i64toi32_i32$4 = HEAP32[($3 + 76 | 0) >> 2] | 0;
      $292 = i64toi32_i32$5;
      i64toi32_i32$5 = $3;
      HEAP32[($3 + 56 | 0) >> 2] = $292;
      HEAP32[($3 + 60 | 0) >> 2] = i64toi32_i32$4;
      $1 = 1;
      break label$2;
     }
     $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1058732 | 0, 8 | 0) | 0 | 0) | 0;
     HEAP32[$0 >> 2] = 1;
     HEAP32[($0 + 4 | 0) >> 2] = $1;
     break label$1;
    }
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($3 + 56 | 0 | 0, $2 + 12 | 0 | 0);
    $1 = 1;
   }
   HEAP32[$0 >> 2] = 0;
   i64toi32_i32$2 = $3;
   i64toi32_i32$4 = HEAP32[($3 + 56 | 0) >> 2] | 0;
   i64toi32_i32$5 = HEAP32[($3 + 60 | 0) >> 2] | 0;
   $306 = i64toi32_i32$4;
   i64toi32_i32$4 = $0 + 20 | 0;
   HEAP32[i64toi32_i32$4 >> 2] = $306;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   HEAP32[($0 + 16 | 0) >> 2] = $1;
   i64toi32_i32$5 = $12$hi;
   i64toi32_i32$4 = $0 + 8 | 0;
   HEAP32[i64toi32_i32$4 >> 2] = $12;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   HEAP32[($0 + 28 | 0) >> 2] = HEAP32[(($3 + 56 | 0) + 8 | 0) >> 2] | 0;
  }
  global$0 = $3 + 368 | 0;
 }
 
 function cardano_serialization_lib__tx_builder__TransactionBuilder___set_mint_asset__hc476e2038680d8c6($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $5 = 0, $32 = 0, $33 = 0, $34 = 0, $35 = 0, $36 = 0, $37 = 0, $38 = 0, $6 = 0, $31 = 0, $39 = 0, $53 = 0, $59 = 0, $62 = 0, $112 = 0, $122 = 0, $141 = 0, $147 = 0, $151 = 0, $189 = 0, $195 = 0, $201 = 0, $208 = 0, $216 = 0, $223 = 0, $231 = 0, $234 = 0, $259 = 0, $269 = 0, $279 = 0, $297 = 0;
  $4 = global$0 - 96 | 0;
  global$0 = $4;
  $5 = 0;
  label$1 : {
   $6 = HEAP32[($0 + 440 | 0) >> 2] | 0;
   if (($6 | 0) != (1 | 0)) {
    break label$1
   }
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h3d696390b8f8d3c9($4 + 48 | 0 | 4 | 0 | 0, $0 + 444 | 0 | 0);
   $5 = 1;
  }
  HEAP32[($4 + 48 | 0) >> 2] = $5;
  i64toi32_i32$1 = $4;
  i64toi32_i32$0 = 0;
  HEAP32[($4 + 20 | 0) >> 2] = 0;
  HEAP32[($4 + 24 | 0) >> 2] = i64toi32_i32$0;
  label$2 : {
   label$3 : {
    if ($6) {
     break label$3
    }
    HEAP32[($4 + 8 | 0) >> 2] = HEAP32[(($4 + 16 | 0) + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $4;
    i64toi32_i32$0 = HEAP32[($4 + 16 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($4 + 20 | 0) >> 2] | 0;
    $31 = i64toi32_i32$0;
    i64toi32_i32$0 = $4;
    HEAP32[$4 >> 2] = $31;
    HEAP32[($4 + 4 | 0) >> 2] = i64toi32_i32$1;
    break label$2;
   }
   HEAP32[($4 + 8 | 0) >> 2] = HEAP32[($4 + 60 | 0) >> 2] | 0;
   i64toi32_i32$2 = $4;
   i64toi32_i32$1 = HEAP32[($4 + 52 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($4 + 56 | 0) >> 2] | 0;
   $39 = i64toi32_i32$1;
   i64toi32_i32$1 = $4;
   HEAP32[$4 >> 2] = $39;
   HEAP32[($4 + 4 | 0) >> 2] = i64toi32_i32$0;
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h3981a4152bf24dd0($4 + 16 | 0 | 0);
  }
  $32 = $1 + 24 | 0;
  HEAP32[(($4 + 48 | 0) + 24 | 0) >> 2] = HEAPU8[$32 >> 0] | 0 | ((HEAPU8[($32 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($32 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($32 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $53 = i64toi32_i32$0;
  i64toi32_i32$0 = ($4 + 48 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $53;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $59 = i64toi32_i32$1;
  i64toi32_i32$1 = ($4 + 48 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $59;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $62 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[($4 + 48 | 0) >> 2] = $62;
  HEAP32[($4 + 52 | 0) >> 2] = i64toi32_i32$1;
  $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h4a35d7ddb2264390($4 + 80 | 0 | 0, $3 | 0);
  alloc__collections__btree__map__BTreeMap_K_2cV___insert__h42468afb2d22301b($4 + 16 | 0 | 0, $4 | 0, $4 + 48 | 0 | 0, $4 + 80 | 0 | 0);
  label$4 : {
   $5 = HEAP32[($4 + 16 | 0) >> 2] | 0;
   if (!$5) {
    break label$4
   }
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h0265580a5be10b66($4 + 16 | 0 | 4 | 0 | 0);
  }
  $1 = $0 + 456 | 0;
  label$5 : {
   label$6 : {
    $3 = HEAP32[($0 + 456 | 0) >> 2] | 0;
    if ($3) {
     break label$6
    }
    HEAP32[($4 + 16 | 0) >> 2] = 0;
    $3 = 1;
    break label$5;
   }
   $3 = $3 ? $1 : 0;
   alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($4 + 16 | 0 | 0, HEAP32[$3 >> 2] | 0 | 0, HEAP32[($3 + 8 | 0) >> 2] | 0 | 0);
   $3 = !(HEAP32[($4 + 16 | 0) >> 2] | 0);
  }
  i64toi32_i32$0 = $4;
  i64toi32_i32$1 = 0;
  HEAP32[($4 + 52 | 0) >> 2] = 0;
  HEAP32[($4 + 56 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($4 + 48 | 0) >> 2] = HEAP32[(0 + 1050204 | 0) >> 2] | 0;
  label$7 : {
   label$8 : {
    if (!$3) {
     break label$8
    }
    HEAP32[(($4 + 80 | 0) + 8 | 0) >> 2] = HEAP32[(($4 + 48 | 0) + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 48 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($4 + 52 | 0) >> 2] | 0;
    $112 = i64toi32_i32$1;
    i64toi32_i32$1 = $4;
    HEAP32[($4 + 80 | 0) >> 2] = $112;
    HEAP32[($4 + 84 | 0) >> 2] = i64toi32_i32$0;
    break label$7;
   }
   HEAP32[(($4 + 80 | 0) + 8 | 0) >> 2] = HEAP32[(($4 + 16 | 0) + 8 | 0) >> 2] | 0;
   i64toi32_i32$2 = $4;
   i64toi32_i32$0 = HEAP32[($4 + 16 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($4 + 20 | 0) >> 2] | 0;
   $122 = i64toi32_i32$0;
   i64toi32_i32$0 = $4;
   HEAP32[($4 + 80 | 0) >> 2] = $122;
   HEAP32[($4 + 84 | 0) >> 2] = i64toi32_i32$1;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc3d6ec99c05cee40($4 + 48 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h0f78886c344617d4($4 + 48 | 0 | 0);
  }
  label$9 : {
   if ($5) {
    break label$9
   }
   label$10 : {
    label$11 : {
     switch (HEAPU8[$2 >> 0] | 0 | 0) {
     default:
      $33 = $2 + 25 | 0;
      $34 = ($4 + 48 | 0) + 25 | 0;
      $35 = HEAPU8[$33 >> 0] | 0 | ((HEAPU8[($33 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($33 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($33 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[$34 >> 0] = $35;
      HEAP8[($34 + 1 | 0) >> 0] = $35 >>> 8 | 0;
      HEAP8[($34 + 2 | 0) >> 0] = $35 >>> 16 | 0;
      HEAP8[($34 + 3 | 0) >> 0] = $35 >>> 24 | 0;
      i64toi32_i32$2 = $2 + 17 | 0;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $141 = i64toi32_i32$1;
      i64toi32_i32$1 = ($4 + 48 | 0) + 17 | 0;
      $36 = $141;
      HEAP8[i64toi32_i32$1 >> 0] = $36;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $36 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $36 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $36 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      i64toi32_i32$2 = $2 + 9 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $147 = i64toi32_i32$0;
      i64toi32_i32$0 = ($4 + 48 | 0) + 9 | 0;
      $37 = $147;
      HEAP8[i64toi32_i32$0 >> 0] = $37;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $37 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $37 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $37 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      HEAP8[($4 + 48 | 0) >> 0] = 0;
      i64toi32_i32$2 = $2;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $151 = i64toi32_i32$1;
      i64toi32_i32$1 = $4;
      $38 = $151;
      HEAP8[($4 + 49 | 0) >> 0] = $38;
      HEAP8[($4 + 50 | 0) >> 0] = $38 >>> 8 | 0;
      HEAP8[($4 + 51 | 0) >> 0] = $38 >>> 16 | 0;
      HEAP8[($4 + 52 | 0) >> 0] = $38 >>> 24 | 0;
      HEAP8[($4 + 53 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[($4 + 54 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[($4 + 55 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[($4 + 56 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      break label$10;
     case 1:
      alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($4 + 48 | 0 | 4 | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
      HEAP8[($4 + 48 | 0) >> 0] = 1;
      break label$10;
     case 2:
      alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($4 + 48 | 0 | 4 | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
      HEAP8[($4 + 48 | 0) >> 0] = 2;
      break label$10;
     case 3:
      $5 = HEAP32[($2 + 4 | 0) >> 2] | 0;
      alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($4 + 16 | 0 | 4 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 16 | 0) >> 2] | 0 | 0);
      i64toi32_i32$2 = ($4 + 16 | 0) + 8 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $189 = i64toi32_i32$0;
      i64toi32_i32$0 = $4 + 60 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $189;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($4 + 16 | 0) >> 2] = $5;
      HEAP8[($4 + 48 | 0) >> 0] = 3;
      i64toi32_i32$2 = $4;
      i64toi32_i32$1 = HEAP32[($4 + 16 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($4 + 20 | 0) >> 2] | 0;
      $195 = i64toi32_i32$1;
      i64toi32_i32$1 = $4;
      HEAP32[($4 + 52 | 0) >> 2] = $195;
      HEAP32[($4 + 56 | 0) >> 2] = i64toi32_i32$0;
      break label$10;
     case 4:
      i64toi32_i32$2 = $2 + 8 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $201 = i64toi32_i32$0;
      i64toi32_i32$0 = ($4 + 48 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $201;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      HEAP8[($4 + 48 | 0) >> 0] = 4;
      break label$10;
     case 5:
      break label$11;
     };
    }
    i64toi32_i32$2 = $2 + 8 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $208 = i64toi32_i32$1;
    i64toi32_i32$1 = ($4 + 48 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $208;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    HEAP8[($4 + 48 | 0) >> 0] = 5;
   }
   i64toi32_i32$2 = ($4 + 48 | 0) + 24 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $216 = i64toi32_i32$0;
   i64toi32_i32$0 = ($4 + 16 | 0) + 24 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $216;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = ($4 + 48 | 0) + 16 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $223 = i64toi32_i32$1;
   i64toi32_i32$1 = ($4 + 16 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $223;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   $2 = ($4 + 16 | 0) + 8 | 0;
   i64toi32_i32$2 = ($4 + 48 | 0) + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $231 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   HEAP32[i64toi32_i32$0 >> 2] = $231;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $4;
   i64toi32_i32$1 = HEAP32[($4 + 48 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($4 + 52 | 0) >> 2] | 0;
   $234 = i64toi32_i32$1;
   i64toi32_i32$1 = $4;
   HEAP32[($4 + 16 | 0) >> 2] = $234;
   HEAP32[($4 + 20 | 0) >> 2] = i64toi32_i32$0;
   cardano_serialization_lib__NativeScripts__add__h12de25bf2c37f302($4 + 80 | 0 | 0, $4 + 16 | 0 | 0);
   label$17 : {
    label$18 : {
     switch ((HEAPU8[($4 + 16 | 0) >> 0] | 0) + -1 | 0 | 0) {
     case 0:
      $2 = $4 + 16 | 0 | 4 | 0;
      break label$17;
     case 2:
      break label$17;
     case 1:
      break label$18;
     default:
      break label$9;
     };
    }
    $2 = $4 + 16 | 0 | 4 | 0;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc3d6ec99c05cee40($2 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h0f78886c344617d4($2 | 0);
  }
  HEAP32[(($4 + 16 | 0) + 8 | 0) >> 2] = HEAP32[(($4 + 80 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[($4 + 80 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($4 + 84 | 0) >> 2] | 0;
  $259 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[($4 + 16 | 0) >> 2] = $259;
  HEAP32[($4 + 20 | 0) >> 2] = i64toi32_i32$1;
  $2 = ($4 + 48 | 0) + 8 | 0;
  HEAP32[$2 >> 2] = HEAP32[($4 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = HEAP32[$4 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($4 + 4 | 0) >> 2] | 0;
  $269 = i64toi32_i32$1;
  i64toi32_i32$1 = $4;
  HEAP32[($4 + 48 | 0) >> 2] = $269;
  HEAP32[($4 + 52 | 0) >> 2] = i64toi32_i32$0;
  label$20 : {
   if (!(HEAP32[($0 + 440 | 0) >> 2] | 0)) {
    break label$20
   }
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h3981a4152bf24dd0($0 + 444 | 0 | 0);
  }
  HEAP32[($0 + 440 | 0) >> 2] = 1;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[($4 + 48 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($4 + 52 | 0) >> 2] | 0;
  $279 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 444 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $279;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($0 + 452 | 0) >> 2] = HEAP32[$2 >> 2] | 0;
  alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($4 + 48 | 0 | 0, HEAP32[($4 + 16 | 0) >> 2] | 0 | 0, HEAP32[($4 + 24 | 0) >> 2] | 0 | 0);
  core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__NativeScripts____hdd7d461255ec800a_2($1 | 0);
  HEAP32[($1 + 8 | 0) >> 2] = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = HEAP32[($4 + 48 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($4 + 52 | 0) >> 2] | 0;
  $297 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[i64toi32_i32$1 >> 2] = $297;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc3d6ec99c05cee40($4 + 16 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h0f78886c344617d4($4 + 16 | 0 | 0);
  global$0 = $4 + 96 | 0;
 }
 
 function $cardano_serialization_lib__plutus__ExUnits_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h32fa18bd273d182d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $5 = 0, $5$hi = 0, $4 = 0, $7 = 0, $7$hi = 0, $4$hi = 0, $6$hi = 0, $8 = 0, $8$hi = 0, $3 = 0, $6 = 0, $45 = 0, $46 = 0, $47 = 0, $88 = 0, $88$hi = 0, $91 = 0, $91$hi = 0, $95$hi = 0, $97$hi = 0, $99$hi = 0, $102 = 0, $102$hi = 0, $117 = 0, $123 = 0, $127 = 0, $158 = 0, $164 = 0, $173 = 0, $176 = 0, $221 = 0, $227 = 0, $236 = 0, $239 = 0, $266 = 0, $270 = 0, $276 = 0, $282 = 0, $292$hi = 0, $294 = 0;
  $2 = global$0 - 272 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 200 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = ($2 + 200 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 208 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 212 | 0) >> 2] | 0;
  $5 = i64toi32_i32$1;
  $5$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 200 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 204 | 0) >> 2] | 0;
       i64toi32_i32$2 = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 1;
       if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
        break label$5
       }
       $3 = 0;
       i64toi32_i32$2 = 0;
       $6 = 0;
       $6$hi = i64toi32_i32$2;
       label$6 : {
        i64toi32_i32$2 = $5$hi;
        i64toi32_i32$3 = $5;
        i64toi32_i32$1 = 0;
        i64toi32_i32$0 = 1;
        if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
         break label$6
        }
        i64toi32_i32$3 = 0;
        $7 = 3;
        $7$hi = i64toi32_i32$3;
        i64toi32_i32$3 = $4$hi;
        i64toi32_i32$0 = $4;
        i64toi32_i32$2 = 0;
        i64toi32_i32$1 = 2;
        if (i64toi32_i32$3 >>> 0 > i64toi32_i32$2 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$0 >>> 0 >= i64toi32_i32$1 >>> 0 | 0) | 0) {
         break label$6
        }
        i64toi32_i32$0 = 0;
        $8 = 0;
        $8$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $4$hi;
        $5 = $4;
        $5$hi = i64toi32_i32$0;
        break label$2;
       }
       $cardano_serialization_lib__utils__BigNum_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h29637bb571dceb02($2 + 200 | 0 | 0, $1 | 0);
       i64toi32_i32$1 = $2;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 208 | 0) >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 212 | 0) >> 2] | 0;
       $4 = i64toi32_i32$0;
       $4$hi = i64toi32_i32$3;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 200 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 204 | 0) >> 2] | 0;
       i64toi32_i32$1 = i64toi32_i32$3;
       i64toi32_i32$3 = 0;
       i64toi32_i32$2 = 1;
       if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) | 0) {
        break label$4
       }
       $cardano_serialization_lib__utils__BigNum_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h29637bb571dceb02($2 + 200 | 0 | 0, $1 | 0);
       i64toi32_i32$2 = $2;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 208 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 212 | 0) >> 2] | 0;
       $7 = i64toi32_i32$1;
       $7$hi = i64toi32_i32$0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 200 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 204 | 0) >> 2] | 0;
       i64toi32_i32$2 = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 1;
       if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
        break label$3
       }
       label$7 : {
        i64toi32_i32$2 = $5$hi;
        i64toi32_i32$3 = $5;
        i64toi32_i32$1 = 0;
        i64toi32_i32$0 = 1;
        if ((i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$1 | 0) | 0) {
         break label$7
        }
        cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 200 | 0 | 0, $1 | 0);
        $1 = HEAPU8[($2 + 208 | 0) >> 0] | 0;
        label$8 : {
         i64toi32_i32$0 = $2;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 200 | 0) >> 2] | 0;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 204 | 0) >> 2] | 0;
         i64toi32_i32$0 = i64toi32_i32$3;
         i64toi32_i32$3 = 0;
         i64toi32_i32$1 = 1;
         if ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) | 0) {
          break label$8
         }
         if (($1 & 255 | 0 | 0) == (5 | 0)) {
          break label$7
         }
         i64toi32_i32$0 = 0;
         $7 = 5;
         $7$hi = i64toi32_i32$0;
         break label$2;
        }
        i64toi32_i32$1 = $2 + 232 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
        $5 = i64toi32_i32$0;
        $5$hi = i64toi32_i32$2;
        i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $5;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
        i64toi32_i32$1 = $2 + 240 | 0;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
        $4 = i64toi32_i32$2;
        $4$hi = i64toi32_i32$0;
        i64toi32_i32$2 = ($2 + 16 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$2 >> 2] = $4;
        HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$0 = $5$hi;
        i64toi32_i32$2 = ($2 + 144 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$2 >> 2] = $5;
        HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$0 = $4$hi;
        i64toi32_i32$2 = ($2 + 144 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$2 >> 2] = $4;
        HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$1 = $2 + 224 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
        $5 = i64toi32_i32$0;
        $5$hi = i64toi32_i32$2;
        i64toi32_i32$0 = $2;
        HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $5;
        HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$2;
        HEAP32[(i64toi32_i32$0 + 144 | 0) >> 2] = $5;
        HEAP32[(i64toi32_i32$0 + 148 | 0) >> 2] = i64toi32_i32$2;
        i64toi32_i32$1 = i64toi32_i32$0;
        i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 209 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 210 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 211 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 212 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$0 = 0;
        $88 = i64toi32_i32$2;
        $88$hi = i64toi32_i32$0;
        i64toi32_i32$1 = i64toi32_i32$1 + 213 | 0;
        i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
        i64toi32_i32$2 = 0;
        $91 = i64toi32_i32$0;
        $91$hi = i64toi32_i32$2;
        i64toi32_i32$1 = $2 + 215 | 0;
        i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$1 = i64toi32_i32$2;
        i64toi32_i32$2 = 0;
        i64toi32_i32$3 = 16;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
         $45 = 0;
        } else {
         i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
         $45 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        }
        $95$hi = i64toi32_i32$2;
        i64toi32_i32$2 = $91$hi;
        i64toi32_i32$0 = $91;
        i64toi32_i32$1 = $95$hi;
        i64toi32_i32$3 = $45;
        i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
        i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 32;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
         $46 = 0;
        } else {
         i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
         $46 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        }
        $97$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $88$hi;
        i64toi32_i32$1 = $88;
        i64toi32_i32$2 = $97$hi;
        i64toi32_i32$3 = $46;
        i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
        i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 8;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
         $47 = 0;
        } else {
         i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
         $47 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        }
        $99$hi = i64toi32_i32$1;
        i64toi32_i32$1 = 0;
        i64toi32_i32$2 = $1;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 255;
        i64toi32_i32$0 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
        $102 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
        $102$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $99$hi;
        i64toi32_i32$1 = $47;
        i64toi32_i32$2 = $102$hi;
        i64toi32_i32$3 = $102;
        i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
        $5 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
        $5$hi = i64toi32_i32$2;
        i64toi32_i32$0 = ($2 + 200 | 0) + 16 | 0;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
        $8 = i64toi32_i32$2;
        $8$hi = i64toi32_i32$1;
        i64toi32_i32$1 = 0;
        $7 = 2;
        $7$hi = i64toi32_i32$1;
        break label$2;
       }
       i64toi32_i32$1 = $4$hi;
       i64toi32_i32$2 = $0;
       HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $4;
       HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$1 = $7$hi;
       i64toi32_i32$2 = i64toi32_i32$2 + 16 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $7;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$1 = 0;
       $5 = 0;
       $5$hi = i64toi32_i32$1;
       break label$1;
      }
      i64toi32_i32$0 = $2 + 232 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
      $117 = i64toi32_i32$1;
      i64toi32_i32$1 = $2 + 152 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $117;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$0 = $2 + 240 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
      $123 = i64toi32_i32$2;
      i64toi32_i32$2 = ($2 + 144 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $123;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$0 = $2 + 224 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
      $127 = i64toi32_i32$1;
      i64toi32_i32$1 = $2;
      HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $127;
      HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$2;
      $3 = 0;
      i64toi32_i32$2 = 0;
      $7 = 2;
      $7$hi = i64toi32_i32$2;
      i64toi32_i32$2 = 0;
      $6 = 0;
      $6$hi = i64toi32_i32$2;
      i64toi32_i32$2 = $4$hi;
      $8 = $4;
      $8$hi = i64toi32_i32$2;
      break label$2;
     }
     memcpy($2 + 144 | 0 | 0, ($2 + 200 | 0) + 16 | 0 | 0, 56 | 0) | 0;
     memcpy($2 + 88 | 0 | 0, $2 + 144 | 0 | 0, 56 | 0) | 0;
     i64toi32_i32$2 = $4$hi;
     i64toi32_i32$1 = $2;
     HEAP32[(i64toi32_i32$1 + 200 | 0) >> 2] = $4;
     HEAP32[(i64toi32_i32$1 + 204 | 0) >> 2] = i64toi32_i32$2;
     memcpy((i64toi32_i32$1 + 200 | 0) + 8 | 0 | 0, i64toi32_i32$1 + 88 | 0 | 0, 56 | 0) | 0;
     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e((i64toi32_i32$1 + 16 | 0) + 8 | 0 | 0, i64toi32_i32$1 + 200 | 0 | 0, 1070952 | 0, 3 | 0);
     i64toi32_i32$0 = i64toi32_i32$1 + 56 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $158 = i64toi32_i32$2;
     i64toi32_i32$2 = ($2 + 144 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $158;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$0 = $2 + 64 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $164 = i64toi32_i32$1;
     i64toi32_i32$1 = ($2 + 144 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $164;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
     HEAP32[($2 + 8 | 0) >> 2] = HEAP32[($2 + 84 | 0) >> 2] | 0;
     i64toi32_i32$0 = $2 + 48 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $173 = i64toi32_i32$2;
     i64toi32_i32$2 = $2;
     HEAP32[(i64toi32_i32$2 + 144 | 0) >> 2] = $173;
     HEAP32[(i64toi32_i32$2 + 148 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$0 = i64toi32_i32$2;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 76 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$2 + 80 | 0) >> 2] | 0;
     $176 = i64toi32_i32$1;
     i64toi32_i32$1 = i64toi32_i32$0;
     HEAP32[i64toi32_i32$0 >> 2] = $176;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] | 0;
     $7 = i64toi32_i32$2;
     $7$hi = i64toi32_i32$1;
     i64toi32_i32$0 = i64toi32_i32$2;
     i64toi32_i32$2 = -1;
     i64toi32_i32$3 = -256;
     i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
     $6 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
     $6$hi = i64toi32_i32$2;
     i64toi32_i32$1 = ($2 + 16 | 0) + 16 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $5 = i64toi32_i32$2;
     $5$hi = i64toi32_i32$0;
     i64toi32_i32$1 = $2 + 40 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $8 = i64toi32_i32$0;
     $8$hi = i64toi32_i32$2;
     $3 = HEAP32[(($2 + 16 | 0) + 56 | 0) >> 2] | 0;
     break label$2;
    }
    memcpy($2 + 144 | 0 | 0, ($2 + 200 | 0) + 16 | 0 | 0, 56 | 0) | 0;
    memcpy($2 + 88 | 0 | 0, $2 + 144 | 0 | 0, 56 | 0) | 0;
    i64toi32_i32$2 = $7$hi;
    i64toi32_i32$0 = $2;
    HEAP32[(i64toi32_i32$0 + 200 | 0) >> 2] = $7;
    HEAP32[(i64toi32_i32$0 + 204 | 0) >> 2] = i64toi32_i32$2;
    memcpy((i64toi32_i32$0 + 200 | 0) + 8 | 0 | 0, i64toi32_i32$0 + 88 | 0 | 0, 56 | 0) | 0;
    cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e((i64toi32_i32$0 + 16 | 0) + 8 | 0 | 0, i64toi32_i32$0 + 200 | 0 | 0, 1070955 | 0, 5 | 0);
    i64toi32_i32$1 = i64toi32_i32$0 + 56 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
    $221 = i64toi32_i32$2;
    i64toi32_i32$2 = ($2 + 144 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $221;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$1 = $2 + 64 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
    $227 = i64toi32_i32$0;
    i64toi32_i32$0 = ($2 + 144 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $227;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    HEAP32[($2 + 8 | 0) >> 2] = HEAP32[($2 + 84 | 0) >> 2] | 0;
    i64toi32_i32$1 = $2 + 48 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
    $236 = i64toi32_i32$2;
    i64toi32_i32$2 = $2;
    HEAP32[(i64toi32_i32$2 + 144 | 0) >> 2] = $236;
    HEAP32[(i64toi32_i32$2 + 148 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$1 = i64toi32_i32$2;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 76 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$2 + 80 | 0) >> 2] | 0;
    $239 = i64toi32_i32$0;
    i64toi32_i32$0 = i64toi32_i32$1;
    HEAP32[i64toi32_i32$0 >> 2] = $239;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$1 = i64toi32_i32$0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] | 0;
    $7 = i64toi32_i32$2;
    $7$hi = i64toi32_i32$0;
    i64toi32_i32$1 = i64toi32_i32$2;
    i64toi32_i32$2 = -1;
    i64toi32_i32$3 = -256;
    i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
    $6 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
    $6$hi = i64toi32_i32$2;
    i64toi32_i32$0 = ($2 + 16 | 0) + 16 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
    $5 = i64toi32_i32$2;
    $5$hi = i64toi32_i32$1;
    i64toi32_i32$0 = $2 + 40 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
    $8 = i64toi32_i32$1;
    $8$hi = i64toi32_i32$2;
    $3 = HEAP32[(($2 + 16 | 0) + 56 | 0) >> 2] | 0;
   }
   i64toi32_i32$2 = $8$hi;
   i64toi32_i32$1 = ($2 + 200 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $8;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$2 = $5$hi;
   i64toi32_i32$1 = ($2 + 200 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $5;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = $2;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 144 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 148 | 0) >> 2] | 0;
   $266 = i64toi32_i32$2;
   i64toi32_i32$2 = i64toi32_i32$0 + 224 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $266;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $270 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$0 + 252 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $270;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = (i64toi32_i32$0 + 144 | 0) + 8 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $276 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 232 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $276;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$0 = ($2 + 144 | 0) + 16 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $282 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 240 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $282;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
   HEAP32[($2 + 260 | 0) >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
   HEAP32[($2 + 248 | 0) >> 2] = $3;
   i64toi32_i32$2 = $7$hi;
   i64toi32_i32$0 = $7;
   i64toi32_i32$1 = 0;
   i64toi32_i32$3 = 255;
   i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
   $292$hi = i64toi32_i32$1;
   i64toi32_i32$1 = $6$hi;
   i64toi32_i32$1 = $292$hi;
   i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
   i64toi32_i32$0 = $6$hi;
   i64toi32_i32$3 = $6;
   i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
   $294 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
   i64toi32_i32$2 = $2;
   HEAP32[(i64toi32_i32$2 + 200 | 0) >> 2] = $294;
   HEAP32[(i64toi32_i32$2 + 204 | 0) >> 2] = i64toi32_i32$0;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, i64toi32_i32$2 + 200 | 0 | 0, 1070960 | 0, 7 | 0);
   i64toi32_i32$0 = 0;
   $5 = 1;
   $5$hi = i64toi32_i32$0;
  }
  i64toi32_i32$0 = $5$hi;
  i64toi32_i32$2 = $0;
  HEAP32[i64toi32_i32$2 >> 2] = $5;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 272 | 0;
 }
 
 function core__num__from_str_radix__hec67a0886509d445($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, i64toi32_i32$5 = 0, i64toi32_i32$1 = 0, $9$hi = 0, $4 = 0, $6 = 0, $9 = 0, $7 = 0, $8$hi = 0, $10$hi = 0, $8 = 0, $10 = 0, $11$hi = 0, i64toi32_i32$6 = 0, $5 = 0, $11 = 0, $49 = 0, $50 = 0, $51 = 0, $52 = 0, $53 = 0, $54 = 0, $55 = 0, $56 = 0, $57 = 0, $58 = 0, $59 = 0, $60 = 0, $61 = 0, $62 = 0, $63 = 0, $64 = 0, $65 = 0, $66 = 0, $67 = 0, $71 = 0, $72 = 0, $73 = 0, $74 = 0, $75 = 0, $51$hi = 0, $68 = 0, $69 = 0, $70 = 0, $70$hi = 0, $75$hi = 0, $79 = 0, $80$hi = 0, $131$hi = 0, $148 = 0, $149 = 0, $150 = 0, $150$hi = 0, $155$hi = 0, $159 = 0, $160$hi = 0, $193$hi = 0, $217 = 0, $218 = 0, $222 = 0, $223$hi = 0, $264$hi = 0, $288 = 0, $289 = 0, $293 = 0, $294$hi = 0;
  $4 = global$0 - 128 | 0;
  global$0 = $4;
  HEAP32[($4 + 92 | 0) >> 2] = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           if (($3 + -2 | 0) >>> 0 > 34 >>> 0) {
            break label$9
           }
           label$10 : {
            if ($2) {
             break label$10
            }
            HEAP8[($0 + 1 | 0) >> 0] = 0;
            break label$2;
           }
           label$11 : {
            switch ((HEAPU8[$1 >> 0] | 0) + -43 | 0 | 0) {
            case 2:
             if (($2 | 0) != (1 | 0)) {
              break label$6
             }
             break label$3;
            case 0:
             $2 = $2 + -1 | 0;
             if (!$2) {
              break label$3
             }
             $1 = $1 + 1 | 0;
             break;
            default:
             break label$11;
            };
           }
           if ($3 >>> 0 > 10 >>> 0) {
            break label$8
           }
           $5 = $4 + 32 | 0;
           i64toi32_i32$0 = 0;
           $8 = 0;
           $8$hi = i64toi32_i32$0;
           i64toi32_i32$0 = 0;
           $9 = 0;
           $9$hi = i64toi32_i32$0;
           label$14 : while (1) {
            if (!$2) {
             break label$5
            }
            $6 = (HEAPU8[$1 >> 0] | 0) + -48 | 0;
            if ($6 >>> 0 >= $3 >>> 0) {
             break label$3
            }
            HEAP32[($4 + 44 | 0) >> 2] = 0;
            i64toi32_i32$0 = $8$hi;
            i64toi32_i32$0 = $9$hi;
            i64toi32_i32$0 = 0;
            $51$hi = i64toi32_i32$0;
            i64toi32_i32$0 = $8$hi;
            i64toi32_i32$1 = $9$hi;
            i64toi32_i32$2 = $51$hi;
            i64toi32_i32$3 = 0;
            __muloti4($4 + 24 | 0 | 0, $8 | 0, i64toi32_i32$0 | 0, $9 | 0, i64toi32_i32$1 | 0, $3 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$3 | 0, $4 + 44 | 0 | 0);
            if (HEAP32[($4 + 44 | 0) >> 2] | 0) {
             break label$4
            }
            $1 = $1 + 1 | 0;
            $2 = $2 + -1 | 0;
            i64toi32_i32$1 = $5;
            i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
            i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
            $9 = i64toi32_i32$3;
            $9$hi = i64toi32_i32$2;
            i64toi32_i32$1 = i64toi32_i32$3;
            i64toi32_i32$3 = -1;
            i64toi32_i32$0 = -1;
            if ((i64toi32_i32$2 | 0) > (i64toi32_i32$3 | 0)) {
             $49 = 1
            } else {
             if ((i64toi32_i32$2 | 0) >= (i64toi32_i32$3 | 0)) {
              if (i64toi32_i32$1 >>> 0 <= i64toi32_i32$0 >>> 0) {
               $50 = 0
              } else {
               $50 = 1
              }
              $51 = $50;
             } else {
              $51 = 0
             }
             $49 = $51;
            }
            i64toi32_i32$1 = $9$hi;
            $7 = !($9 | i64toi32_i32$1 | 0) ? 1 : $49;
            $68 = ($7 | 0) == (1 | 0);
            $69 = $7;
            $70 = $9;
            $70$hi = i64toi32_i32$1;
            i64toi32_i32$0 = $4;
            i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] | 0;
            i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] | 0;
            $10 = i64toi32_i32$1;
            $10$hi = i64toi32_i32$2;
            i64toi32_i32$2 = 0;
            $75$hi = i64toi32_i32$2;
            i64toi32_i32$2 = $10$hi;
            i64toi32_i32$0 = i64toi32_i32$1;
            i64toi32_i32$1 = $75$hi;
            i64toi32_i32$3 = $6;
            i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
            i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
            if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
             i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
            }
            $8 = i64toi32_i32$4;
            $8$hi = i64toi32_i32$5;
            i64toi32_i32$5 = $10$hi;
            i64toi32_i32$5 = $8$hi;
            i64toi32_i32$2 = i64toi32_i32$4;
            i64toi32_i32$0 = $10$hi;
            i64toi32_i32$3 = $10;
            $79 = i64toi32_i32$5 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
            i64toi32_i32$2 = 0;
            $80$hi = i64toi32_i32$2;
            i64toi32_i32$2 = $70$hi;
            i64toi32_i32$3 = $70;
            i64toi32_i32$5 = $80$hi;
            i64toi32_i32$0 = $79;
            i64toi32_i32$1 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
            i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
            if (i64toi32_i32$1 >>> 0 < i64toi32_i32$0 >>> 0) {
             i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
            }
            $9 = i64toi32_i32$1;
            $9$hi = i64toi32_i32$4;
            i64toi32_i32$2 = i64toi32_i32$1;
            i64toi32_i32$3 = -1;
            i64toi32_i32$0 = -1;
            if ((i64toi32_i32$4 | 0) > (i64toi32_i32$3 | 0)) {
             $52 = 1
            } else {
             if ((i64toi32_i32$4 | 0) >= (i64toi32_i32$3 | 0)) {
              if (i64toi32_i32$2 >>> 0 <= i64toi32_i32$0 >>> 0) {
               $53 = 0
              } else {
               $53 = 1
              }
              $54 = $53;
             } else {
              $54 = 0
             }
             $52 = $54;
            }
            i64toi32_i32$2 = $9$hi;
            if (($68 & ($69 | 0) != ((!($9 | i64toi32_i32$2 | 0) ? 1 : $52) | 0) | 0 | 0) != (1 | 0)) {
             continue label$14
            }
            break label$7;
           };
          }
          HEAP32[($4 + 116 | 0) >> 2] = 1;
          i64toi32_i32$4 = $4;
          i64toi32_i32$2 = 0;
          HEAP32[(i64toi32_i32$4 + 100 | 0) >> 2] = 1;
          HEAP32[(i64toi32_i32$4 + 104 | 0) >> 2] = i64toi32_i32$2;
          HEAP32[(i64toi32_i32$4 + 96 | 0) >> 2] = 1149372;
          HEAP32[(i64toi32_i32$4 + 124 | 0) >> 2] = 46;
          HEAP32[(i64toi32_i32$4 + 112 | 0) >> 2] = i64toi32_i32$4 + 120 | 0;
          HEAP32[(i64toi32_i32$4 + 120 | 0) >> 2] = i64toi32_i32$4 + 92 | 0;
          core__panicking__panic_fmt__hbf21a3d4bbb82bf8(i64toi32_i32$4 + 96 | 0 | 0, 1149408 | 0);
          abort();
         }
         $5 = $4 + 8 | 0;
         i64toi32_i32$2 = 0;
         $8 = 0;
         $8$hi = i64toi32_i32$2;
         i64toi32_i32$2 = 0;
         $9 = 0;
         $9$hi = i64toi32_i32$2;
         label$15 : while (1) {
          if (!$2) {
           break label$5
          }
          label$16 : {
           $7 = HEAPU8[$1 >> 0] | 0;
           $6 = $7 + -48 | 0;
           if ($6 >>> 0 < 10 >>> 0) {
            break label$16
           }
           $6 = $7 | 32 | 0;
           $7 = $6 + -87 | 0;
           $6 = $7 >>> 0 < ($6 + -97 | 0) >>> 0 ? -1 : $7;
           if ($6 >>> 0 >= $3 >>> 0) {
            break label$3
           }
          }
          HEAP32[($4 + 20 | 0) >> 2] = 0;
          i64toi32_i32$2 = $8$hi;
          i64toi32_i32$2 = $9$hi;
          i64toi32_i32$2 = 0;
          $131$hi = i64toi32_i32$2;
          i64toi32_i32$2 = $8$hi;
          i64toi32_i32$4 = $9$hi;
          i64toi32_i32$0 = $131$hi;
          i64toi32_i32$3 = 0;
          __muloti4($4 | 0, $8 | 0, i64toi32_i32$2 | 0, $9 | 0, i64toi32_i32$4 | 0, $3 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$3 | 0, $4 + 20 | 0 | 0);
          if (HEAP32[($4 + 20 | 0) >> 2] | 0) {
           break label$4
          }
          $1 = $1 + 1 | 0;
          $2 = $2 + -1 | 0;
          i64toi32_i32$4 = $5;
          i64toi32_i32$3 = HEAP32[i64toi32_i32$4 >> 2] | 0;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
          $9 = i64toi32_i32$3;
          $9$hi = i64toi32_i32$0;
          i64toi32_i32$4 = i64toi32_i32$3;
          i64toi32_i32$3 = -1;
          i64toi32_i32$2 = -1;
          if ((i64toi32_i32$0 | 0) > (i64toi32_i32$3 | 0)) {
           $55 = 1
          } else {
           if ((i64toi32_i32$0 | 0) >= (i64toi32_i32$3 | 0)) {
            if (i64toi32_i32$4 >>> 0 <= i64toi32_i32$2 >>> 0) {
             $56 = 0
            } else {
             $56 = 1
            }
            $57 = $56;
           } else {
            $57 = 0
           }
           $55 = $57;
          }
          i64toi32_i32$4 = $9$hi;
          $7 = !($9 | i64toi32_i32$4 | 0) ? 1 : $55;
          $148 = ($7 | 0) == (1 | 0);
          $149 = $7;
          $150 = $9;
          $150$hi = i64toi32_i32$4;
          i64toi32_i32$2 = $4;
          i64toi32_i32$4 = HEAP32[i64toi32_i32$2 >> 2] | 0;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
          $10 = i64toi32_i32$4;
          $10$hi = i64toi32_i32$0;
          i64toi32_i32$0 = 0;
          $155$hi = i64toi32_i32$0;
          i64toi32_i32$0 = $10$hi;
          i64toi32_i32$2 = i64toi32_i32$4;
          i64toi32_i32$4 = $155$hi;
          i64toi32_i32$3 = $6;
          i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
          i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
          if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
           i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
          }
          $8 = i64toi32_i32$5;
          $8$hi = i64toi32_i32$1;
          i64toi32_i32$1 = $10$hi;
          i64toi32_i32$1 = $8$hi;
          i64toi32_i32$0 = i64toi32_i32$5;
          i64toi32_i32$2 = $10$hi;
          i64toi32_i32$3 = $10;
          $159 = i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
          i64toi32_i32$0 = 0;
          $160$hi = i64toi32_i32$0;
          i64toi32_i32$0 = $150$hi;
          i64toi32_i32$3 = $150;
          i64toi32_i32$1 = $160$hi;
          i64toi32_i32$2 = $159;
          i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
          i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
          if (i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0) {
           i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
          }
          $9 = i64toi32_i32$4;
          $9$hi = i64toi32_i32$5;
          i64toi32_i32$0 = i64toi32_i32$4;
          i64toi32_i32$3 = -1;
          i64toi32_i32$2 = -1;
          if ((i64toi32_i32$5 | 0) > (i64toi32_i32$3 | 0)) {
           $58 = 1
          } else {
           if ((i64toi32_i32$5 | 0) >= (i64toi32_i32$3 | 0)) {
            if (i64toi32_i32$0 >>> 0 <= i64toi32_i32$2 >>> 0) {
             $59 = 0
            } else {
             $59 = 1
            }
            $60 = $59;
           } else {
            $60 = 0
           }
           $58 = $60;
          }
          i64toi32_i32$0 = $9$hi;
          if (!($148 & ($149 | 0) != ((!($9 | i64toi32_i32$0 | 0) ? 1 : $58) | 0) | 0)) {
           continue label$15
          }
          break label$15;
         };
        }
        HEAP8[($0 + 1 | 0) >> 0] = 2;
        break label$2;
       }
       $1 = $1 + 1 | 0;
       label$17 : {
        label$18 : {
         label$19 : {
          if ($3 >>> 0 > 10 >>> 0) {
           break label$19
          }
          $2 = $2 + -1 | 0;
          $7 = $4 + 80 | 0;
          i64toi32_i32$0 = 0;
          $8 = 0;
          $8$hi = i64toi32_i32$0;
          i64toi32_i32$0 = 0;
          $9 = 0;
          $9$hi = i64toi32_i32$0;
          label$20 : while (1) {
           if (!$2) {
            break label$5
           }
           $6 = (HEAPU8[$1 >> 0] | 0) + -48 | 0;
           if ($6 >>> 0 >= $3 >>> 0) {
            break label$3
           }
           HEAP32[($4 + 88 | 0) >> 2] = 0;
           i64toi32_i32$0 = $8$hi;
           i64toi32_i32$0 = $9$hi;
           i64toi32_i32$0 = 0;
           $193$hi = i64toi32_i32$0;
           i64toi32_i32$0 = $8$hi;
           i64toi32_i32$5 = $9$hi;
           i64toi32_i32$2 = $193$hi;
           i64toi32_i32$3 = 0;
           __muloti4($4 + 72 | 0 | 0, $8 | 0, i64toi32_i32$0 | 0, $9 | 0, i64toi32_i32$5 | 0, $3 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$3 | 0, $4 + 88 | 0 | 0);
           if (HEAP32[($4 + 88 | 0) >> 2] | 0) {
            break label$18
           }
           $1 = $1 + 1 | 0;
           $2 = $2 + -1 | 0;
           i64toi32_i32$5 = $4;
           i64toi32_i32$3 = HEAP32[(i64toi32_i32$5 + 72 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 76 | 0) >> 2] | 0;
           $10 = i64toi32_i32$3;
           $10$hi = i64toi32_i32$2;
           i64toi32_i32$2 = 0;
           $11 = $6;
           $11$hi = i64toi32_i32$2;
           i64toi32_i32$2 = $10$hi;
           i64toi32_i32$5 = i64toi32_i32$3;
           i64toi32_i32$3 = $11$hi;
           i64toi32_i32$0 = $6;
           i64toi32_i32$1 = i64toi32_i32$5 - i64toi32_i32$0 | 0;
           i64toi32_i32$6 = i64toi32_i32$5 >>> 0 < i64toi32_i32$0 >>> 0;
           i64toi32_i32$4 = i64toi32_i32$6 + i64toi32_i32$3 | 0;
           i64toi32_i32$4 = i64toi32_i32$2 - i64toi32_i32$4 | 0;
           $8 = i64toi32_i32$1;
           $8$hi = i64toi32_i32$4;
           i64toi32_i32$2 = $7;
           i64toi32_i32$4 = HEAP32[i64toi32_i32$2 >> 2] | 0;
           i64toi32_i32$5 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
           $9 = i64toi32_i32$4;
           $9$hi = i64toi32_i32$5;
           i64toi32_i32$2 = i64toi32_i32$4;
           i64toi32_i32$4 = -1;
           i64toi32_i32$0 = -1;
           if ((i64toi32_i32$5 | 0) > (i64toi32_i32$4 | 0)) {
            $61 = 1
           } else {
            if ((i64toi32_i32$5 | 0) >= (i64toi32_i32$4 | 0)) {
             if (i64toi32_i32$2 >>> 0 <= i64toi32_i32$0 >>> 0) {
              $62 = 0
             } else {
              $62 = 1
             }
             $63 = $62;
            } else {
             $63 = 0
            }
            $61 = $63;
           }
           i64toi32_i32$2 = $9$hi;
           $6 = !($9 | i64toi32_i32$2 | 0) ? 1 : $61;
           $217 = ($6 | 0) != (1 | 0);
           $218 = $6;
           i64toi32_i32$2 = $10$hi;
           i64toi32_i32$2 = $11$hi;
           i64toi32_i32$2 = $10$hi;
           i64toi32_i32$0 = $10;
           i64toi32_i32$5 = $11$hi;
           i64toi32_i32$4 = $11;
           $222 = i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$4 >>> 0 | 0) | 0;
           i64toi32_i32$0 = 0;
           $223$hi = i64toi32_i32$0;
           i64toi32_i32$0 = $9$hi;
           i64toi32_i32$4 = $9;
           i64toi32_i32$2 = $223$hi;
           i64toi32_i32$5 = $222;
           i64toi32_i32$3 = i64toi32_i32$4 - i64toi32_i32$5 | 0;
           i64toi32_i32$6 = i64toi32_i32$4 >>> 0 < i64toi32_i32$5 >>> 0;
           i64toi32_i32$1 = i64toi32_i32$6 + i64toi32_i32$2 | 0;
           i64toi32_i32$1 = i64toi32_i32$0 - i64toi32_i32$1 | 0;
           $9 = i64toi32_i32$3;
           $9$hi = i64toi32_i32$1;
           i64toi32_i32$0 = i64toi32_i32$3;
           i64toi32_i32$4 = -1;
           i64toi32_i32$5 = -1;
           if ((i64toi32_i32$1 | 0) > (i64toi32_i32$4 | 0)) {
            $64 = 1
           } else {
            if ((i64toi32_i32$1 | 0) >= (i64toi32_i32$4 | 0)) {
             if (i64toi32_i32$0 >>> 0 <= i64toi32_i32$5 >>> 0) {
              $65 = 0
             } else {
              $65 = 1
             }
             $66 = $65;
            } else {
             $66 = 0
            }
            $64 = $66;
           }
           i64toi32_i32$0 = $9$hi;
           if (($217 & ($218 | 0) != ((!($9 | i64toi32_i32$0 | 0) ? 1 : $64) | 0) | 0 | 0) != (1 | 0)) {
            continue label$20
           }
           break label$17;
          };
         }
         $2 = $2 + -1 | 0;
         $5 = $4 + 56 | 0;
         i64toi32_i32$0 = 0;
         $8 = 0;
         $8$hi = i64toi32_i32$0;
         i64toi32_i32$0 = 0;
         $9 = 0;
         $9$hi = i64toi32_i32$0;
         label$21 : while (1) {
          if (!$2) {
           break label$5
          }
          label$22 : {
           $7 = HEAPU8[$1 >> 0] | 0;
           $6 = $7 + -48 | 0;
           if ($6 >>> 0 < 10 >>> 0) {
            break label$22
           }
           $6 = $7 | 32 | 0;
           $7 = $6 + -87 | 0;
           $6 = $7 >>> 0 < ($6 + -97 | 0) >>> 0 ? -1 : $7;
           if ($6 >>> 0 >= $3 >>> 0) {
            break label$3
           }
          }
          HEAP32[($4 + 68 | 0) >> 2] = 0;
          i64toi32_i32$0 = $8$hi;
          i64toi32_i32$0 = $9$hi;
          i64toi32_i32$0 = 0;
          $264$hi = i64toi32_i32$0;
          i64toi32_i32$0 = $8$hi;
          i64toi32_i32$1 = $9$hi;
          i64toi32_i32$5 = $264$hi;
          i64toi32_i32$4 = 0;
          __muloti4($4 + 48 | 0 | 0, $8 | 0, i64toi32_i32$0 | 0, $9 | 0, i64toi32_i32$1 | 0, $3 | 0, i64toi32_i32$5 | 0, 0 | 0, i64toi32_i32$4 | 0, $4 + 68 | 0 | 0);
          if (HEAP32[($4 + 68 | 0) >> 2] | 0) {
           break label$18
          }
          $1 = $1 + 1 | 0;
          $2 = $2 + -1 | 0;
          i64toi32_i32$1 = $4;
          i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 48 | 0) >> 2] | 0;
          i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 52 | 0) >> 2] | 0;
          $10 = i64toi32_i32$4;
          $10$hi = i64toi32_i32$5;
          i64toi32_i32$5 = 0;
          $11 = $6;
          $11$hi = i64toi32_i32$5;
          i64toi32_i32$5 = $10$hi;
          i64toi32_i32$1 = i64toi32_i32$4;
          i64toi32_i32$4 = $11$hi;
          i64toi32_i32$0 = $6;
          i64toi32_i32$2 = i64toi32_i32$1 - i64toi32_i32$0 | 0;
          i64toi32_i32$6 = i64toi32_i32$1 >>> 0 < i64toi32_i32$0 >>> 0;
          i64toi32_i32$3 = i64toi32_i32$6 + i64toi32_i32$4 | 0;
          i64toi32_i32$3 = i64toi32_i32$5 - i64toi32_i32$3 | 0;
          $8 = i64toi32_i32$2;
          $8$hi = i64toi32_i32$3;
          i64toi32_i32$5 = $5;
          i64toi32_i32$3 = HEAP32[i64toi32_i32$5 >> 2] | 0;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
          $9 = i64toi32_i32$3;
          $9$hi = i64toi32_i32$1;
          i64toi32_i32$5 = i64toi32_i32$3;
          i64toi32_i32$3 = -1;
          i64toi32_i32$0 = -1;
          if ((i64toi32_i32$1 | 0) > (i64toi32_i32$3 | 0)) {
           $67 = 1
          } else {
           if ((i64toi32_i32$1 | 0) >= (i64toi32_i32$3 | 0)) {
            if (i64toi32_i32$5 >>> 0 <= i64toi32_i32$0 >>> 0) {
             $71 = 0
            } else {
             $71 = 1
            }
            $72 = $71;
           } else {
            $72 = 0
           }
           $67 = $72;
          }
          i64toi32_i32$5 = $9$hi;
          $6 = !($9 | i64toi32_i32$5 | 0) ? 1 : $67;
          $288 = ($6 | 0) != (1 | 0);
          $289 = $6;
          i64toi32_i32$5 = $10$hi;
          i64toi32_i32$5 = $11$hi;
          i64toi32_i32$5 = $10$hi;
          i64toi32_i32$0 = $10;
          i64toi32_i32$1 = $11$hi;
          i64toi32_i32$3 = $11;
          $293 = i64toi32_i32$5 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
          i64toi32_i32$0 = 0;
          $294$hi = i64toi32_i32$0;
          i64toi32_i32$0 = $9$hi;
          i64toi32_i32$3 = $9;
          i64toi32_i32$5 = $294$hi;
          i64toi32_i32$1 = $293;
          i64toi32_i32$4 = i64toi32_i32$3 - i64toi32_i32$1 | 0;
          i64toi32_i32$6 = i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0;
          i64toi32_i32$2 = i64toi32_i32$6 + i64toi32_i32$5 | 0;
          i64toi32_i32$2 = i64toi32_i32$0 - i64toi32_i32$2 | 0;
          $9 = i64toi32_i32$4;
          $9$hi = i64toi32_i32$2;
          i64toi32_i32$0 = i64toi32_i32$4;
          i64toi32_i32$3 = -1;
          i64toi32_i32$1 = -1;
          if ((i64toi32_i32$2 | 0) > (i64toi32_i32$3 | 0)) {
           $73 = 1
          } else {
           if ((i64toi32_i32$2 | 0) >= (i64toi32_i32$3 | 0)) {
            if (i64toi32_i32$0 >>> 0 <= i64toi32_i32$1 >>> 0) {
             $74 = 0
            } else {
             $74 = 1
            }
            $75 = $74;
           } else {
            $75 = 0
           }
           $73 = $75;
          }
          i64toi32_i32$0 = $9$hi;
          if (!($288 & ($289 | 0) != ((!($9 | i64toi32_i32$0 | 0) ? 1 : $73) | 0) | 0)) {
           continue label$21
          }
          break label$17;
         };
        }
        HEAP8[($0 + 1 | 0) >> 0] = 3;
        break label$2;
       }
       HEAP8[($0 + 1 | 0) >> 0] = 3;
       break label$2;
      }
      i64toi32_i32$0 = $9$hi;
      i64toi32_i32$2 = $0 + 16 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $9;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$0 = $8$hi;
      i64toi32_i32$2 = $0 + 8 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $8;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
      $2 = 0;
      break label$1;
     }
     HEAP8[($0 + 1 | 0) >> 0] = 2;
     break label$2;
    }
    $2 = 1;
    HEAP8[($0 + 1 | 0) >> 0] = 1;
    break label$1;
   }
   $2 = 1;
  }
  HEAP8[$0 >> 0] = $2;
  global$0 = $4 + 128 | 0;
 }
 
 function $cardano_serialization_lib__plutus__ExUnitPrices_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hb43adfd468752d01($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, $2 = 0, i64toi32_i32$0 = 0, $5 = 0, i64toi32_i32$4 = 0, $5$hi = 0, $8 = 0, $8$hi = 0, $9 = 0, $9$hi = 0, $10 = 0, $10$hi = 0, $7$hi = 0, $3 = 0, $7 = 0, $6 = 0, $6$hi = 0, $4 = 0, $44 = 0, $45 = 0, $46 = 0, $84 = 0, $84$hi = 0, $87 = 0, $87$hi = 0, $91$hi = 0, $93$hi = 0, $95$hi = 0, $98 = 0, $98$hi = 0, $121 = 0, $125 = 0, $163 = 0, $172 = 0, $175 = 0, $228 = 0, $237 = 0, $240 = 0, $272 = 0, $276 = 0, $282 = 0, $292$hi = 0, $294 = 0;
  $2 = global$0 - 256 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 184 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2 + 200 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 192 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 196 | 0) >> 2] | 0;
  $6 = i64toi32_i32$1;
  $6$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 184 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 188 | 0) >> 2] | 0;
       i64toi32_i32$2 = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 1;
       if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
        break label$5
       }
       $3 = 0;
       i64toi32_i32$2 = 0;
       $7 = 0;
       $7$hi = i64toi32_i32$2;
       label$6 : {
        i64toi32_i32$2 = $6$hi;
        i64toi32_i32$3 = $6;
        i64toi32_i32$1 = 0;
        i64toi32_i32$0 = 1;
        if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
         break label$6
        }
        i64toi32_i32$3 = $5$hi;
        i64toi32_i32$0 = $5;
        i64toi32_i32$2 = 0;
        i64toi32_i32$1 = 2;
        if (i64toi32_i32$3 >>> 0 > i64toi32_i32$2 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$0 >>> 0 >= i64toi32_i32$1 >>> 0 | 0) | 0) {
         break label$6
        }
        i64toi32_i32$0 = 0;
        $8 = 3;
        $8$hi = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        $9 = 0;
        $9$hi = i64toi32_i32$0;
        break label$2;
       }
       cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__UnitInterval___deserialize__h50a71b45bc03a6b4($2 + 184 | 0 | 0, $1 | 0);
       $4 = ($2 + 184 | 0) + 16 | 0;
       i64toi32_i32$1 = $4;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $5 = i64toi32_i32$0;
       $5$hi = i64toi32_i32$3;
       i64toi32_i32$1 = $2;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 192 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 196 | 0) >> 2] | 0;
       $8 = i64toi32_i32$3;
       $8$hi = i64toi32_i32$0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 184 | 0) >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 188 | 0) >> 2] | 0;
       i64toi32_i32$1 = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$2 = 1;
       if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) | 0) {
        break label$4
       }
       cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__UnitInterval___deserialize__h50a71b45bc03a6b4($2 + 184 | 0 | 0, $1 | 0);
       i64toi32_i32$2 = $4;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $10 = i64toi32_i32$1;
       $10$hi = i64toi32_i32$3;
       i64toi32_i32$2 = $2;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 192 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 196 | 0) >> 2] | 0;
       $9 = i64toi32_i32$3;
       $9$hi = i64toi32_i32$1;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 184 | 0) >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 188 | 0) >> 2] | 0;
       i64toi32_i32$2 = i64toi32_i32$1;
       i64toi32_i32$1 = 0;
       i64toi32_i32$0 = 1;
       if ((i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) | 0) {
        break label$3
       }
       label$7 : {
        i64toi32_i32$2 = $6$hi;
        i64toi32_i32$0 = $6;
        i64toi32_i32$3 = 0;
        i64toi32_i32$1 = 1;
        if ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) | 0) {
         break label$7
        }
        cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 184 | 0 | 0, $1 | 0);
        $1 = HEAPU8[($2 + 192 | 0) >> 0] | 0;
        label$8 : {
         i64toi32_i32$1 = $2;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 184 | 0) >> 2] | 0;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 188 | 0) >> 2] | 0;
         i64toi32_i32$1 = i64toi32_i32$0;
         i64toi32_i32$0 = 0;
         i64toi32_i32$3 = 1;
         if ((i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) | 0) {
          break label$8
         }
         if (($1 & 255 | 0 | 0) == (5 | 0)) {
          break label$7
         }
         i64toi32_i32$1 = 0;
         $8 = 5;
         $8$hi = i64toi32_i32$1;
         break label$2;
        }
        i64toi32_i32$3 = $2 + 224 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $5 = i64toi32_i32$1;
        $5$hi = i64toi32_i32$2;
        i64toi32_i32$1 = ($2 + 16 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $5;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
        i64toi32_i32$1 = ($2 + 136 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $5;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
        i64toi32_i32$3 = $2 + 216 | 0;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $5 = i64toi32_i32$2;
        $5$hi = i64toi32_i32$1;
        i64toi32_i32$2 = $2;
        HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] = $5;
        HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] = i64toi32_i32$1;
        HEAP32[(i64toi32_i32$2 + 136 | 0) >> 2] = $5;
        HEAP32[(i64toi32_i32$2 + 140 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$3 = i64toi32_i32$2;
        i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 193 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 194 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 195 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 196 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$2 = 0;
        $84 = i64toi32_i32$1;
        $84$hi = i64toi32_i32$2;
        i64toi32_i32$3 = i64toi32_i32$3 + 197 | 0;
        i64toi32_i32$2 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
        i64toi32_i32$1 = 0;
        $87 = i64toi32_i32$2;
        $87$hi = i64toi32_i32$1;
        i64toi32_i32$3 = $2 + 199 | 0;
        i64toi32_i32$1 = HEAPU8[i64toi32_i32$3 >> 0] | 0;
        i64toi32_i32$2 = 0;
        i64toi32_i32$3 = i64toi32_i32$1;
        i64toi32_i32$1 = 0;
        i64toi32_i32$0 = 16;
        i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
         i64toi32_i32$1 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
         $44 = 0;
        } else {
         i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
         $44 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
        }
        $91$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $87$hi;
        i64toi32_i32$2 = $87;
        i64toi32_i32$3 = $91$hi;
        i64toi32_i32$0 = $44;
        i64toi32_i32$3 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
        i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
        i64toi32_i32$2 = 0;
        i64toi32_i32$0 = 32;
        i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
         i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
         $45 = 0;
        } else {
         i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$4 | 0) | 0;
         $45 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        }
        $93$hi = i64toi32_i32$2;
        i64toi32_i32$2 = $84$hi;
        i64toi32_i32$3 = $84;
        i64toi32_i32$1 = $93$hi;
        i64toi32_i32$0 = $45;
        i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
        i64toi32_i32$2 = i64toi32_i32$3 | i64toi32_i32$0 | 0;
        i64toi32_i32$3 = 0;
        i64toi32_i32$0 = 8;
        i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
         i64toi32_i32$3 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
         $46 = 0;
        } else {
         i64toi32_i32$3 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
         $46 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        }
        $95$hi = i64toi32_i32$3;
        i64toi32_i32$3 = 0;
        i64toi32_i32$1 = $1;
        i64toi32_i32$2 = 0;
        i64toi32_i32$0 = 255;
        i64toi32_i32$2 = i64toi32_i32$3 & i64toi32_i32$2 | 0;
        $98 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
        $98$hi = i64toi32_i32$2;
        i64toi32_i32$2 = $95$hi;
        i64toi32_i32$3 = $46;
        i64toi32_i32$1 = $98$hi;
        i64toi32_i32$0 = $98;
        i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
        $5 = i64toi32_i32$3 | i64toi32_i32$0 | 0;
        $5$hi = i64toi32_i32$1;
        i64toi32_i32$2 = $2 + 208 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $10 = i64toi32_i32$1;
        $10$hi = i64toi32_i32$3;
        i64toi32_i32$2 = $2 + 200 | 0;
        i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $9 = i64toi32_i32$3;
        $9$hi = i64toi32_i32$1;
        i64toi32_i32$1 = 0;
        $8 = 2;
        $8$hi = i64toi32_i32$1;
        break label$2;
       }
       i64toi32_i32$1 = $8$hi;
       i64toi32_i32$3 = $0;
       HEAP32[(i64toi32_i32$3 + 8 | 0) >> 2] = $8;
       HEAP32[(i64toi32_i32$3 + 12 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$1 = $10$hi;
       i64toi32_i32$3 = i64toi32_i32$3 + 32 | 0;
       HEAP32[i64toi32_i32$3 >> 2] = $10;
       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$1 = $9$hi;
       i64toi32_i32$3 = $0 + 24 | 0;
       HEAP32[i64toi32_i32$3 >> 2] = $9;
       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$1 = $5$hi;
       i64toi32_i32$3 = $0 + 16 | 0;
       HEAP32[i64toi32_i32$3 >> 2] = $5;
       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$1 = 0;
       $5 = 0;
       $5$hi = i64toi32_i32$1;
       break label$1;
      }
      i64toi32_i32$2 = $2 + 224 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $121 = i64toi32_i32$1;
      i64toi32_i32$1 = $2 + 144 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $121;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
      i64toi32_i32$2 = $2 + 216 | 0;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $125 = i64toi32_i32$3;
      i64toi32_i32$3 = $2;
      HEAP32[(i64toi32_i32$3 + 136 | 0) >> 2] = $125;
      HEAP32[(i64toi32_i32$3 + 140 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = i64toi32_i32$3 + 208 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $10 = i64toi32_i32$1;
      $10$hi = i64toi32_i32$3;
      $3 = 0;
      i64toi32_i32$3 = 0;
      $8 = 2;
      $8$hi = i64toi32_i32$3;
      i64toi32_i32$3 = 0;
      $7 = 0;
      $7$hi = i64toi32_i32$3;
      i64toi32_i32$3 = $5$hi;
      $9 = $5;
      $9$hi = i64toi32_i32$3;
      i64toi32_i32$3 = $6$hi;
      $5 = $6;
      $5$hi = i64toi32_i32$3;
      break label$2;
     }
     memcpy($2 + 136 | 0 | 0, ($2 + 184 | 0) + 24 | 0 | 0, 48 | 0) | 0;
     memcpy($2 + 88 | 0 | 0, $2 + 136 | 0 | 0, 48 | 0) | 0;
     i64toi32_i32$3 = $5$hi;
     i64toi32_i32$1 = ($2 + 184 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $5;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$3 = $8$hi;
     i64toi32_i32$1 = $2;
     HEAP32[(i64toi32_i32$1 + 184 | 0) >> 2] = $8;
     HEAP32[(i64toi32_i32$1 + 188 | 0) >> 2] = i64toi32_i32$3;
     memcpy($4 | 0, i64toi32_i32$1 + 88 | 0 | 0, 48 | 0) | 0;
     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e((i64toi32_i32$1 + 16 | 0) + 8 | 0 | 0, i64toi32_i32$1 + 184 | 0 | 0, 1070921 | 0, 9 | 0);
     i64toi32_i32$2 = (i64toi32_i32$1 + 16 | 0) + 48 | 0;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $163 = i64toi32_i32$3;
     i64toi32_i32$3 = ($2 + 136 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $163;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($2 + 8 | 0) >> 2] = HEAP32[($2 + 84 | 0) >> 2] | 0;
     i64toi32_i32$2 = $2 + 56 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $172 = i64toi32_i32$1;
     i64toi32_i32$1 = $2;
     HEAP32[(i64toi32_i32$1 + 136 | 0) >> 2] = $172;
     HEAP32[(i64toi32_i32$1 + 140 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 76 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$1 + 80 | 0) >> 2] | 0;
     $175 = i64toi32_i32$3;
     i64toi32_i32$3 = i64toi32_i32$2;
     HEAP32[i64toi32_i32$2 >> 2] = $175;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
     $8 = i64toi32_i32$1;
     $8$hi = i64toi32_i32$3;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$1 = -1;
     i64toi32_i32$0 = -256;
     i64toi32_i32$1 = i64toi32_i32$3 & i64toi32_i32$1 | 0;
     $7 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
     $7$hi = i64toi32_i32$1;
     i64toi32_i32$3 = ($2 + 16 | 0) + 16 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $5 = i64toi32_i32$1;
     $5$hi = i64toi32_i32$2;
     i64toi32_i32$3 = ($2 + 16 | 0) + 24 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $9 = i64toi32_i32$2;
     $9$hi = i64toi32_i32$1;
     i64toi32_i32$3 = $2 + 48 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $10 = i64toi32_i32$1;
     $10$hi = i64toi32_i32$2;
     $3 = HEAP32[($2 + 72 | 0) >> 2] | 0;
     break label$2;
    }
    memcpy($2 + 136 | 0 | 0, ($2 + 184 | 0) + 24 | 0 | 0, 48 | 0) | 0;
    memcpy($2 + 88 | 0 | 0, $2 + 136 | 0 | 0, 48 | 0) | 0;
    i64toi32_i32$2 = $10$hi;
    i64toi32_i32$1 = ($2 + 184 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $10;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $9$hi;
    i64toi32_i32$1 = $2;
    HEAP32[(i64toi32_i32$1 + 184 | 0) >> 2] = $9;
    HEAP32[(i64toi32_i32$1 + 188 | 0) >> 2] = i64toi32_i32$2;
    memcpy((i64toi32_i32$1 + 184 | 0) + 16 | 0 | 0, i64toi32_i32$1 + 88 | 0 | 0, 48 | 0) | 0;
    cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e((i64toi32_i32$1 + 16 | 0) + 8 | 0 | 0, i64toi32_i32$1 + 184 | 0 | 0, 1070930 | 0, 10 | 0);
    i64toi32_i32$3 = (i64toi32_i32$1 + 16 | 0) + 48 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $228 = i64toi32_i32$2;
    i64toi32_i32$2 = ($2 + 136 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $228;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($2 + 8 | 0) >> 2] = HEAP32[($2 + 84 | 0) >> 2] | 0;
    i64toi32_i32$3 = $2 + 56 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $237 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[(i64toi32_i32$1 + 136 | 0) >> 2] = $237;
    HEAP32[(i64toi32_i32$1 + 140 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$3 = i64toi32_i32$1;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 76 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$1 + 80 | 0) >> 2] | 0;
    $240 = i64toi32_i32$2;
    i64toi32_i32$2 = i64toi32_i32$3;
    HEAP32[i64toi32_i32$2 >> 2] = $240;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$3 = i64toi32_i32$2;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
    $8 = i64toi32_i32$1;
    $8$hi = i64toi32_i32$2;
    i64toi32_i32$3 = i64toi32_i32$1;
    i64toi32_i32$1 = -1;
    i64toi32_i32$0 = -256;
    i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
    $7 = i64toi32_i32$3 & i64toi32_i32$0 | 0;
    $7$hi = i64toi32_i32$1;
    i64toi32_i32$2 = ($2 + 16 | 0) + 16 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $5 = i64toi32_i32$1;
    $5$hi = i64toi32_i32$3;
    i64toi32_i32$2 = ($2 + 16 | 0) + 24 | 0;
    i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $9 = i64toi32_i32$3;
    $9$hi = i64toi32_i32$1;
    i64toi32_i32$2 = $2 + 48 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $10 = i64toi32_i32$1;
    $10$hi = i64toi32_i32$3;
    $3 = HEAP32[($2 + 72 | 0) >> 2] | 0;
   }
   i64toi32_i32$3 = $10$hi;
   i64toi32_i32$1 = $2 + 208 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $10;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$3 = $9$hi;
   i64toi32_i32$1 = $2 + 200 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $9;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$3 = $5$hi;
   i64toi32_i32$1 = ($2 + 184 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $5;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$2 = $2;
   i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 136 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 140 | 0) >> 2] | 0;
   $272 = i64toi32_i32$3;
   i64toi32_i32$3 = i64toi32_i32$2 + 216 | 0;
   HEAP32[i64toi32_i32$3 >> 2] = $272;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $276 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2 + 236 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $276;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$2 = (i64toi32_i32$2 + 136 | 0) + 8 | 0;
   i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $282 = i64toi32_i32$3;
   i64toi32_i32$3 = $2 + 224 | 0;
   HEAP32[i64toi32_i32$3 >> 2] = $282;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($2 + 244 | 0) >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
   HEAP32[($2 + 232 | 0) >> 2] = $3;
   i64toi32_i32$1 = $8$hi;
   i64toi32_i32$2 = $8;
   i64toi32_i32$3 = 0;
   i64toi32_i32$0 = 255;
   i64toi32_i32$3 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
   $292$hi = i64toi32_i32$3;
   i64toi32_i32$3 = $7$hi;
   i64toi32_i32$3 = $292$hi;
   i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
   i64toi32_i32$2 = $7$hi;
   i64toi32_i32$0 = $7;
   i64toi32_i32$2 = i64toi32_i32$3 | i64toi32_i32$2 | 0;
   $294 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
   i64toi32_i32$1 = $2;
   HEAP32[(i64toi32_i32$1 + 184 | 0) >> 2] = $294;
   HEAP32[(i64toi32_i32$1 + 188 | 0) >> 2] = i64toi32_i32$2;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, i64toi32_i32$1 + 184 | 0 | 0, 1070940 | 0, 12 | 0);
   i64toi32_i32$2 = 0;
   $5 = 1;
   $5$hi = i64toi32_i32$2;
  }
  i64toi32_i32$2 = $5$hi;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $5;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  global$0 = $2 + 256 | 0;
 }
 
 function $cardano_serialization_lib__legacy_address__address__ExtendedAddr_20as_20cbor_event__de__Deserialize___deserialize__h3aca879b445064c1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $3 = 0, $8 = 0, i64toi32_i32$4 = 0, $11 = 0, i64toi32_i32$3 = 0, $11$hi = 0, $33 = 0, $34 = 0, $35 = 0, $36 = 0, $37 = 0, $38 = 0, $39 = 0, $40 = 0, $41 = 0, $4 = 0, $5 = 0, $42 = 0, $7 = 0, $10 = 0, $43 = 0, $44 = 0, $13 = 0, $14 = 0, $45 = 0, $46 = 0, $69 = 0, $12 = 0, $12$hi = 0, $6 = 0, $130 = 0, $141 = 0, $9 = 0, $13$hi = 0, $14$hi = 0, $190 = 0, $198 = 0, $199 = 0, $199$hi = 0, $201$hi = 0, $261 = 0;
  $2 = global$0 - 192 | 0;
  global$0 = $2;
  cardano_serialization_lib__legacy_address__cbor__util__raw_with_crc32__hcc0be77464365bdf($2 + 144 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ((HEAP32[($2 + 144 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      $1 = HEAP32[(($2 + 144 | 0) + 12 | 0) >> 2] | 0;
      HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] = $1;
      i64toi32_i32$2 = $2;
      i64toi32_i32$0 = HEAP32[($2 + 148 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($2 + 152 | 0) >> 2] | 0;
      $11 = i64toi32_i32$0;
      $11$hi = i64toi32_i32$1;
      i64toi32_i32$0 = $2;
      HEAP32[($2 + 8 | 0) >> 2] = $11;
      HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($2 + 40 | 0) >> 2] = $1;
      i64toi32_i32$0 = $2;
      HEAP32[($2 + 32 | 0) >> 2] = $11;
      HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$0 = $2;
      i64toi32_i32$1 = 0;
      HEAP32[($2 + 24 | 0) >> 2] = 0;
      HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      cbor_event__de__Deserializer_R___tuple__hfad22f5abd2b96b4($2 + 144 | 0 | 0, $2 + 24 | 0 | 0, 3 | 0, i64toi32_i32$1 | 0, 1072720 | 0, 12 | 0);
      $1 = ($2 + 24 | 0) + 8 | 0;
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           $3 = HEAPU8[($2 + 144 | 0) >> 0] | 0;
           if (($3 | 0) != (19 | 0)) {
            break label$9
           }
           cbor_event__de__Deserializer_R___bytes__hc697ccccfa39fd82($2 + 144 | 0 | 0, $2 + 24 | 0 | 0);
           if ((HEAP32[($2 + 144 | 0) >> 2] | 0 | 0) == (1 | 0)) {
            break label$8
           }
           HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 144 | 0) + 12 | 0) >> 2] | 0;
           i64toi32_i32$2 = $2;
           i64toi32_i32$1 = HEAP32[($2 + 148 | 0) >> 2] | 0;
           i64toi32_i32$0 = HEAP32[($2 + 152 | 0) >> 2] | 0;
           $69 = i64toi32_i32$1;
           i64toi32_i32$1 = $2;
           HEAP32[($2 + 48 | 0) >> 2] = $69;
           HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$0;
           $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 | 0, $2 + 48 | 0 | 0);
           if ((HEAP32[($2 + 4 | 0) >> 2] | 0 | 0) != (28 | 0)) {
            break label$7
           }
           $3 = HEAP32[$2 >> 2] | 0;
           HEAP8[($2 + 62 | 0) >> 0] = HEAPU8[($3 + 10 | 0) >> 0] | 0;
           $4 = HEAPU8[($3 + 6 | 0) >> 0] | 0;
           $5 = HEAPU8[$3 >> 0] | 0 | ((HEAPU8[($3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $42 = $3 + 4 | 0;
           HEAP16[(($2 + 64 | 0) + 4 | 0) >> 1] = HEAPU8[$42 >> 0] | 0 | ((HEAPU8[($42 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
           HEAP8[(($2 + 64 | 0) + 6 | 0) >> 0] = $4;
           HEAP16[($2 + 60 | 0) >> 1] = HEAPU8[($3 + 8 | 0) >> 0] | 0 | ((HEAPU8[($3 + 9 | 0) >> 0] | 0) << 8 | 0) | 0;
           HEAP32[($2 + 64 | 0) >> 2] = $5;
           i64toi32_i32$2 = $3 + 27 | 0;
           i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
           i64toi32_i32$1 = 0;
           $11 = i64toi32_i32$0;
           $11$hi = i64toi32_i32$1;
           i64toi32_i32$2 = $3;
           i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 23 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 24 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 25 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 26 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$0 = 0;
           $12 = i64toi32_i32$1;
           $12$hi = i64toi32_i32$0;
           $4 = HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0;
           $5 = HEAPU8[(i64toi32_i32$2 + 11 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 12 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 13 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 14 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $6 = HEAPU8[(i64toi32_i32$2 + 15 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 16 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 17 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 18 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $3 = HEAPU8[(i64toi32_i32$2 + 19 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 20 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 21 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 22 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $cardano_serialization_lib__legacy_address__address__Attributes_20as_20cbor_event__de__Deserialize___deserialize__h55085c978ed19726($2 + 144 | 0 | 0, $2 + 24 | 0 | 0);
           if ((HEAP32[($2 + 144 | 0) >> 2] | 0 | 0) == (1 | 0)) {
            break label$6
           }
           $7 = ($2 + 72 | 0) + 8 | 0;
           i64toi32_i32$2 = ($2 + 144 | 0) + 12 | 0;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
           $130 = i64toi32_i32$0;
           i64toi32_i32$0 = $7;
           HEAP32[i64toi32_i32$0 >> 2] = $130;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
           $8 = ($2 + 72 | 0) + 16 | 0;
           HEAP32[$8 >> 2] = HEAP32[(($2 + 144 | 0) + 20 | 0) >> 2] | 0;
           i64toi32_i32$2 = $2;
           i64toi32_i32$1 = HEAP32[($2 + 148 | 0) >> 2] | 0;
           i64toi32_i32$0 = HEAP32[($2 + 152 | 0) >> 2] | 0;
           $141 = i64toi32_i32$1;
           i64toi32_i32$1 = $2;
           HEAP32[($2 + 72 | 0) >> 2] = $141;
           HEAP32[($2 + 76 | 0) >> 2] = i64toi32_i32$0;
           $cardano_serialization_lib__legacy_address__address__AddrType_20as_20cbor_event__de__Deserialize___deserialize__ha7e97c2a9bcfdf6c($2 + 144 | 0 | 0, $2 + 24 | 0 | 0);
           if ((HEAPU8[($2 + 144 | 0) >> 0] | 0 | 0) == (1 | 0)) {
            break label$5
           }
           $9 = HEAPU8[($2 + 145 | 0) >> 0] | 0;
           $10 = ($2 + 144 | 0) + 16 | 0;
           HEAP32[$10 >> 2] = HEAP32[$8 >> 2] | 0;
           $8 = $2 + 167 | 0;
           $33 = HEAPU8[($2 + 67 | 0) >> 0] | 0 | ((HEAPU8[($2 + 68 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 69 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 70 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[$8 >> 0] = $33;
           HEAP8[($8 + 1 | 0) >> 0] = $33 >>> 8 | 0;
           HEAP8[($8 + 2 | 0) >> 0] = $33 >>> 16 | 0;
           HEAP8[($8 + 3 | 0) >> 0] = $33 >>> 24 | 0;
           $43 = $0 + 32 | 0;
           $44 = HEAPU16[($2 + 60 | 0) >> 1] | 0;
           HEAP8[$43 >> 0] = $44;
           HEAP8[($43 + 1 | 0) >> 0] = $44 >>> 8 | 0;
           HEAP8[($0 + 34 | 0) >> 0] = HEAPU8[($2 + 62 | 0) >> 0] | 0;
           i64toi32_i32$2 = $7;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
           $13 = i64toi32_i32$0;
           $13$hi = i64toi32_i32$1;
           i64toi32_i32$0 = ($2 + 144 | 0) + 8 | 0;
           HEAP32[i64toi32_i32$0 >> 2] = $13;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
           i64toi32_i32$2 = $2;
           i64toi32_i32$1 = HEAP32[($2 + 72 | 0) >> 2] | 0;
           i64toi32_i32$0 = HEAP32[($2 + 76 | 0) >> 2] | 0;
           $14 = i64toi32_i32$1;
           $14$hi = i64toi32_i32$0;
           i64toi32_i32$1 = $0;
           HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $14;
           HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
           i64toi32_i32$0 = $13$hi;
           i64toi32_i32$1 = i64toi32_i32$1 + 12 | 0;
           HEAP32[i64toi32_i32$1 >> 2] = $13;
           HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
           HEAP32[($2 + 164 | 0) >> 2] = HEAP32[($2 + 64 | 0) >> 2] | 0;
           i64toi32_i32$2 = $10;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
           $190 = i64toi32_i32$0;
           i64toi32_i32$0 = $0 + 20 | 0;
           HEAP32[i64toi32_i32$0 >> 2] = $190;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
           $34 = $0 + 27 | 0;
           $35 = HEAPU8[$8 >> 0] | 0 | ((HEAPU8[($8 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($8 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($8 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[$34 >> 0] = $35;
           HEAP8[($34 + 1 | 0) >> 0] = $35 >>> 8 | 0;
           HEAP8[($34 + 2 | 0) >> 0] = $35 >>> 16 | 0;
           HEAP8[($34 + 3 | 0) >> 0] = $35 >>> 24 | 0;
           i64toi32_i32$1 = $14$hi;
           i64toi32_i32$0 = $2;
           HEAP32[($2 + 144 | 0) >> 2] = $14;
           HEAP32[($2 + 148 | 0) >> 2] = i64toi32_i32$1;
           $198 = $0 + 51 | 0;
           i64toi32_i32$1 = $12$hi;
           $199 = $12;
           $199$hi = i64toi32_i32$1;
           i64toi32_i32$1 = $11$hi;
           i64toi32_i32$2 = $11;
           i64toi32_i32$0 = 0;
           i64toi32_i32$3 = 32;
           i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
           if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
            i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
            $45 = 0;
           } else {
            i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
            $45 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
           }
           $201$hi = i64toi32_i32$0;
           i64toi32_i32$0 = $199$hi;
           i64toi32_i32$1 = $199;
           i64toi32_i32$2 = $201$hi;
           i64toi32_i32$3 = $45;
           i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
           $11 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
           $11$hi = i64toi32_i32$2;
           i64toi32_i32$0 = $11;
           i64toi32_i32$1 = 0;
           i64toi32_i32$3 = 32;
           i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
           if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
            i64toi32_i32$1 = 0;
            $46 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
           } else {
            i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
            $46 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
           }
           HEAP8[$198 >> 0] = $46;
           i64toi32_i32$1 = $11$hi;
           $36 = $0 + 47 | 0;
           HEAP8[$36 >> 0] = $11;
           HEAP8[($36 + 1 | 0) >> 0] = $11 >>> 8 | 0;
           HEAP8[($36 + 2 | 0) >> 0] = $11 >>> 16 | 0;
           HEAP8[($36 + 3 | 0) >> 0] = $11 >>> 24 | 0;
           HEAP8[($0 + 52 | 0) >> 0] = $9;
           $37 = $0 + 43 | 0;
           HEAP8[$37 >> 0] = $3;
           HEAP8[($37 + 1 | 0) >> 0] = $3 >>> 8 | 0;
           HEAP8[($37 + 2 | 0) >> 0] = $3 >>> 16 | 0;
           HEAP8[($37 + 3 | 0) >> 0] = $3 >>> 24 | 0;
           $38 = $0 + 39 | 0;
           $39 = $6;
           HEAP8[$38 >> 0] = $39;
           HEAP8[($38 + 1 | 0) >> 0] = $39 >>> 8 | 0;
           HEAP8[($38 + 2 | 0) >> 0] = $39 >>> 16 | 0;
           HEAP8[($38 + 3 | 0) >> 0] = $39 >>> 24 | 0;
           $40 = $0 + 35 | 0;
           $41 = $5;
           HEAP8[$40 >> 0] = $41;
           HEAP8[($40 + 1 | 0) >> 0] = $41 >>> 8 | 0;
           HEAP8[($40 + 2 | 0) >> 0] = $41 >>> 16 | 0;
           HEAP8[($40 + 3 | 0) >> 0] = $41 >>> 24 | 0;
           HEAP8[($0 + 31 | 0) >> 0] = $4;
           HEAP32[$0 >> 2] = 0;
           $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 48 | 0 | 0);
           $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 48 | 0 | 0);
           break label$2;
          }
          memcpy($2 + 96 | 0 | 0, $2 + 144 | 0 | 1 | 0 | 0, 39 | 0) | 0;
          HEAP8[($0 + 8 | 0) >> 0] = $3;
          memcpy($0 + 9 | 0 | 0, $2 + 96 | 0 | 0, 39 | 0) | 0;
          HEAP32[$0 >> 2] = 1;
          break label$2;
         }
         memcpy($0 + 8 | 0 | 0, memcpy($2 + 96 | 0 | 4 | 0 | 0, ($2 + 144 | 0) + 8 | 0 | 0, 40 | 0) | 0 | 0, 40 | 0) | 0;
         HEAP32[$0 >> 2] = 1;
         break label$2;
        }
        HEAP32[$0 >> 2] = 1;
        i64toi32_i32$0 = $0 + 40 | 0;
        i64toi32_i32$1 = 0;
        HEAP32[i64toi32_i32$0 >> 2] = 28;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$0 = $0 + 32 | 0;
        i64toi32_i32$1 = 0;
        HEAP32[i64toi32_i32$0 >> 2] = 1;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$2 = $2;
        i64toi32_i32$1 = HEAP32[($2 + 56 | 0) >> 2] | 0;
        i64toi32_i32$0 = 0;
        $261 = i64toi32_i32$1;
        i64toi32_i32$1 = $0 + 24 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $261;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        HEAP32[($0 + 16 | 0) >> 2] = 31;
        HEAP32[($0 + 12 | 0) >> 2] = 1072732;
        HEAP8[($0 + 8 | 0) >> 0] = 13;
        break label$3;
       }
       memcpy($0 + 8 | 0 | 0, memcpy($2 + 96 | 0 | 4 | 0 | 0, ($2 + 144 | 0) + 8 | 0 | 0, 40 | 0) | 0 | 0, 40 | 0) | 0;
       HEAP32[$0 >> 2] = 1;
       break label$3;
      }
      memcpy($0 + 8 | 0 | 0, memcpy($2 + 102 | 0 | 0, ($2 + 144 | 0) + 8 | 0 | 0, 40 | 0) | 0 | 0, 40 | 0) | 0;
      HEAP32[$0 >> 2] = 1;
      core__ptr__drop_in_place_core__option__Option_alloc__vec__Vec_u8_____ha5300c747747c3c8_3($2 + 72 | 0 | 0);
      break label$3;
     }
     memcpy($0 + 8 | 0 | 0, memcpy($2 + 96 | 0 | 4 | 0 | 0, ($2 + 144 | 0) + 8 | 0 | 0, 40 | 0) | 0 | 0, 40 | 0) | 0;
     HEAP32[$0 >> 2] = 1;
     break label$1;
    }
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 48 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 48 | 0 | 0);
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  }
  global$0 = $2 + 192 | 0;
 }
 
 function $cardano_serialization_lib__legacy_address__address__ExtendedAddr_20as_20cbor_event__de__Deserialize___deserialize__h960edb2a7588f7b4($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $3 = 0, $8 = 0, i64toi32_i32$4 = 0, $11 = 0, i64toi32_i32$3 = 0, $11$hi = 0, $33 = 0, $34 = 0, $35 = 0, $36 = 0, $37 = 0, $38 = 0, $39 = 0, $40 = 0, $41 = 0, $4 = 0, $5 = 0, $42 = 0, $7 = 0, $10 = 0, $43 = 0, $44 = 0, $13 = 0, $14 = 0, $45 = 0, $46 = 0, $69 = 0, $12 = 0, $12$hi = 0, $6 = 0, $130 = 0, $141 = 0, $9 = 0, $13$hi = 0, $14$hi = 0, $190 = 0, $198 = 0, $199 = 0, $199$hi = 0, $201$hi = 0, $261 = 0;
  $2 = global$0 - 192 | 0;
  global$0 = $2;
  cardano_serialization_lib__legacy_address__cbor__util__raw_with_crc32__h952aabed95f47ca2($2 + 144 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ((HEAP32[($2 + 144 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      $1 = HEAP32[(($2 + 144 | 0) + 12 | 0) >> 2] | 0;
      HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] = $1;
      i64toi32_i32$2 = $2;
      i64toi32_i32$0 = HEAP32[($2 + 148 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($2 + 152 | 0) >> 2] | 0;
      $11 = i64toi32_i32$0;
      $11$hi = i64toi32_i32$1;
      i64toi32_i32$0 = $2;
      HEAP32[($2 + 8 | 0) >> 2] = $11;
      HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($2 + 40 | 0) >> 2] = $1;
      i64toi32_i32$0 = $2;
      HEAP32[($2 + 32 | 0) >> 2] = $11;
      HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$0 = $2;
      i64toi32_i32$1 = 0;
      HEAP32[($2 + 24 | 0) >> 2] = 0;
      HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      cbor_event__de__Deserializer_R___tuple__hfad22f5abd2b96b4($2 + 144 | 0 | 0, $2 + 24 | 0 | 0, 3 | 0, i64toi32_i32$1 | 0, 1072720 | 0, 12 | 0);
      $1 = ($2 + 24 | 0) + 8 | 0;
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           $3 = HEAPU8[($2 + 144 | 0) >> 0] | 0;
           if (($3 | 0) != (19 | 0)) {
            break label$9
           }
           cbor_event__de__Deserializer_R___bytes__hc697ccccfa39fd82($2 + 144 | 0 | 0, $2 + 24 | 0 | 0);
           if ((HEAP32[($2 + 144 | 0) >> 2] | 0 | 0) == (1 | 0)) {
            break label$8
           }
           HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 144 | 0) + 12 | 0) >> 2] | 0;
           i64toi32_i32$2 = $2;
           i64toi32_i32$1 = HEAP32[($2 + 148 | 0) >> 2] | 0;
           i64toi32_i32$0 = HEAP32[($2 + 152 | 0) >> 2] | 0;
           $69 = i64toi32_i32$1;
           i64toi32_i32$1 = $2;
           HEAP32[($2 + 48 | 0) >> 2] = $69;
           HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$0;
           $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 | 0, $2 + 48 | 0 | 0);
           if ((HEAP32[($2 + 4 | 0) >> 2] | 0 | 0) != (28 | 0)) {
            break label$7
           }
           $3 = HEAP32[$2 >> 2] | 0;
           HEAP8[($2 + 62 | 0) >> 0] = HEAPU8[($3 + 10 | 0) >> 0] | 0;
           $4 = HEAPU8[($3 + 6 | 0) >> 0] | 0;
           $5 = HEAPU8[$3 >> 0] | 0 | ((HEAPU8[($3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $42 = $3 + 4 | 0;
           HEAP16[(($2 + 64 | 0) + 4 | 0) >> 1] = HEAPU8[$42 >> 0] | 0 | ((HEAPU8[($42 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
           HEAP8[(($2 + 64 | 0) + 6 | 0) >> 0] = $4;
           HEAP16[($2 + 60 | 0) >> 1] = HEAPU8[($3 + 8 | 0) >> 0] | 0 | ((HEAPU8[($3 + 9 | 0) >> 0] | 0) << 8 | 0) | 0;
           HEAP32[($2 + 64 | 0) >> 2] = $5;
           i64toi32_i32$2 = $3 + 27 | 0;
           i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
           i64toi32_i32$1 = 0;
           $11 = i64toi32_i32$0;
           $11$hi = i64toi32_i32$1;
           i64toi32_i32$2 = $3;
           i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 23 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 24 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 25 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 26 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$0 = 0;
           $12 = i64toi32_i32$1;
           $12$hi = i64toi32_i32$0;
           $4 = HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0;
           $5 = HEAPU8[(i64toi32_i32$2 + 11 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 12 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 13 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 14 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $6 = HEAPU8[(i64toi32_i32$2 + 15 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 16 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 17 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 18 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $3 = HEAPU8[(i64toi32_i32$2 + 19 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 20 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 21 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 22 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $cardano_serialization_lib__legacy_address__address__Attributes_20as_20cbor_event__de__Deserialize___deserialize__h55085c978ed19726($2 + 144 | 0 | 0, $2 + 24 | 0 | 0);
           if ((HEAP32[($2 + 144 | 0) >> 2] | 0 | 0) == (1 | 0)) {
            break label$6
           }
           $7 = ($2 + 72 | 0) + 8 | 0;
           i64toi32_i32$2 = ($2 + 144 | 0) + 12 | 0;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
           $130 = i64toi32_i32$0;
           i64toi32_i32$0 = $7;
           HEAP32[i64toi32_i32$0 >> 2] = $130;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
           $8 = ($2 + 72 | 0) + 16 | 0;
           HEAP32[$8 >> 2] = HEAP32[(($2 + 144 | 0) + 20 | 0) >> 2] | 0;
           i64toi32_i32$2 = $2;
           i64toi32_i32$1 = HEAP32[($2 + 148 | 0) >> 2] | 0;
           i64toi32_i32$0 = HEAP32[($2 + 152 | 0) >> 2] | 0;
           $141 = i64toi32_i32$1;
           i64toi32_i32$1 = $2;
           HEAP32[($2 + 72 | 0) >> 2] = $141;
           HEAP32[($2 + 76 | 0) >> 2] = i64toi32_i32$0;
           $cardano_serialization_lib__legacy_address__address__AddrType_20as_20cbor_event__de__Deserialize___deserialize__ha7e97c2a9bcfdf6c($2 + 144 | 0 | 0, $2 + 24 | 0 | 0);
           if ((HEAPU8[($2 + 144 | 0) >> 0] | 0 | 0) == (1 | 0)) {
            break label$5
           }
           $9 = HEAPU8[($2 + 145 | 0) >> 0] | 0;
           $10 = ($2 + 144 | 0) + 16 | 0;
           HEAP32[$10 >> 2] = HEAP32[$8 >> 2] | 0;
           $8 = $2 + 167 | 0;
           $33 = HEAPU8[($2 + 67 | 0) >> 0] | 0 | ((HEAPU8[($2 + 68 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 69 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 70 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[$8 >> 0] = $33;
           HEAP8[($8 + 1 | 0) >> 0] = $33 >>> 8 | 0;
           HEAP8[($8 + 2 | 0) >> 0] = $33 >>> 16 | 0;
           HEAP8[($8 + 3 | 0) >> 0] = $33 >>> 24 | 0;
           $43 = $0 + 32 | 0;
           $44 = HEAPU16[($2 + 60 | 0) >> 1] | 0;
           HEAP8[$43 >> 0] = $44;
           HEAP8[($43 + 1 | 0) >> 0] = $44 >>> 8 | 0;
           HEAP8[($0 + 34 | 0) >> 0] = HEAPU8[($2 + 62 | 0) >> 0] | 0;
           i64toi32_i32$2 = $7;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
           $13 = i64toi32_i32$0;
           $13$hi = i64toi32_i32$1;
           i64toi32_i32$0 = ($2 + 144 | 0) + 8 | 0;
           HEAP32[i64toi32_i32$0 >> 2] = $13;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
           i64toi32_i32$2 = $2;
           i64toi32_i32$1 = HEAP32[($2 + 72 | 0) >> 2] | 0;
           i64toi32_i32$0 = HEAP32[($2 + 76 | 0) >> 2] | 0;
           $14 = i64toi32_i32$1;
           $14$hi = i64toi32_i32$0;
           i64toi32_i32$1 = $0;
           HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $14;
           HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
           i64toi32_i32$0 = $13$hi;
           i64toi32_i32$1 = i64toi32_i32$1 + 12 | 0;
           HEAP32[i64toi32_i32$1 >> 2] = $13;
           HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
           HEAP32[($2 + 164 | 0) >> 2] = HEAP32[($2 + 64 | 0) >> 2] | 0;
           i64toi32_i32$2 = $10;
           i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
           $190 = i64toi32_i32$0;
           i64toi32_i32$0 = $0 + 20 | 0;
           HEAP32[i64toi32_i32$0 >> 2] = $190;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
           $34 = $0 + 27 | 0;
           $35 = HEAPU8[$8 >> 0] | 0 | ((HEAPU8[($8 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($8 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($8 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[$34 >> 0] = $35;
           HEAP8[($34 + 1 | 0) >> 0] = $35 >>> 8 | 0;
           HEAP8[($34 + 2 | 0) >> 0] = $35 >>> 16 | 0;
           HEAP8[($34 + 3 | 0) >> 0] = $35 >>> 24 | 0;
           i64toi32_i32$1 = $14$hi;
           i64toi32_i32$0 = $2;
           HEAP32[($2 + 144 | 0) >> 2] = $14;
           HEAP32[($2 + 148 | 0) >> 2] = i64toi32_i32$1;
           $198 = $0 + 51 | 0;
           i64toi32_i32$1 = $12$hi;
           $199 = $12;
           $199$hi = i64toi32_i32$1;
           i64toi32_i32$1 = $11$hi;
           i64toi32_i32$2 = $11;
           i64toi32_i32$0 = 0;
           i64toi32_i32$3 = 32;
           i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
           if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
            i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
            $45 = 0;
           } else {
            i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
            $45 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
           }
           $201$hi = i64toi32_i32$0;
           i64toi32_i32$0 = $199$hi;
           i64toi32_i32$1 = $199;
           i64toi32_i32$2 = $201$hi;
           i64toi32_i32$3 = $45;
           i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
           $11 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
           $11$hi = i64toi32_i32$2;
           i64toi32_i32$0 = $11;
           i64toi32_i32$1 = 0;
           i64toi32_i32$3 = 32;
           i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
           if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
            i64toi32_i32$1 = 0;
            $46 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
           } else {
            i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
            $46 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
           }
           HEAP8[$198 >> 0] = $46;
           i64toi32_i32$1 = $11$hi;
           $36 = $0 + 47 | 0;
           HEAP8[$36 >> 0] = $11;
           HEAP8[($36 + 1 | 0) >> 0] = $11 >>> 8 | 0;
           HEAP8[($36 + 2 | 0) >> 0] = $11 >>> 16 | 0;
           HEAP8[($36 + 3 | 0) >> 0] = $11 >>> 24 | 0;
           HEAP8[($0 + 52 | 0) >> 0] = $9;
           $37 = $0 + 43 | 0;
           HEAP8[$37 >> 0] = $3;
           HEAP8[($37 + 1 | 0) >> 0] = $3 >>> 8 | 0;
           HEAP8[($37 + 2 | 0) >> 0] = $3 >>> 16 | 0;
           HEAP8[($37 + 3 | 0) >> 0] = $3 >>> 24 | 0;
           $38 = $0 + 39 | 0;
           $39 = $6;
           HEAP8[$38 >> 0] = $39;
           HEAP8[($38 + 1 | 0) >> 0] = $39 >>> 8 | 0;
           HEAP8[($38 + 2 | 0) >> 0] = $39 >>> 16 | 0;
           HEAP8[($38 + 3 | 0) >> 0] = $39 >>> 24 | 0;
           $40 = $0 + 35 | 0;
           $41 = $5;
           HEAP8[$40 >> 0] = $41;
           HEAP8[($40 + 1 | 0) >> 0] = $41 >>> 8 | 0;
           HEAP8[($40 + 2 | 0) >> 0] = $41 >>> 16 | 0;
           HEAP8[($40 + 3 | 0) >> 0] = $41 >>> 24 | 0;
           HEAP8[($0 + 31 | 0) >> 0] = $4;
           HEAP32[$0 >> 2] = 0;
           $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 48 | 0 | 0);
           $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 48 | 0 | 0);
           break label$2;
          }
          memcpy($2 + 96 | 0 | 0, $2 + 144 | 0 | 1 | 0 | 0, 39 | 0) | 0;
          HEAP8[($0 + 8 | 0) >> 0] = $3;
          memcpy($0 + 9 | 0 | 0, $2 + 96 | 0 | 0, 39 | 0) | 0;
          HEAP32[$0 >> 2] = 1;
          break label$2;
         }
         memcpy($0 + 8 | 0 | 0, memcpy($2 + 96 | 0 | 4 | 0 | 0, ($2 + 144 | 0) + 8 | 0 | 0, 40 | 0) | 0 | 0, 40 | 0) | 0;
         HEAP32[$0 >> 2] = 1;
         break label$2;
        }
        HEAP32[$0 >> 2] = 1;
        i64toi32_i32$0 = $0 + 40 | 0;
        i64toi32_i32$1 = 0;
        HEAP32[i64toi32_i32$0 >> 2] = 28;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$0 = $0 + 32 | 0;
        i64toi32_i32$1 = 0;
        HEAP32[i64toi32_i32$0 >> 2] = 1;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$2 = $2;
        i64toi32_i32$1 = HEAP32[($2 + 56 | 0) >> 2] | 0;
        i64toi32_i32$0 = 0;
        $261 = i64toi32_i32$1;
        i64toi32_i32$1 = $0 + 24 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $261;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        HEAP32[($0 + 16 | 0) >> 2] = 31;
        HEAP32[($0 + 12 | 0) >> 2] = 1072732;
        HEAP8[($0 + 8 | 0) >> 0] = 13;
        break label$3;
       }
       memcpy($0 + 8 | 0 | 0, memcpy($2 + 96 | 0 | 4 | 0 | 0, ($2 + 144 | 0) + 8 | 0 | 0, 40 | 0) | 0 | 0, 40 | 0) | 0;
       HEAP32[$0 >> 2] = 1;
       break label$3;
      }
      memcpy($0 + 8 | 0 | 0, memcpy($2 + 102 | 0 | 0, ($2 + 144 | 0) + 8 | 0 | 0, 40 | 0) | 0 | 0, 40 | 0) | 0;
      HEAP32[$0 >> 2] = 1;
      core__ptr__drop_in_place_core__option__Option_alloc__vec__Vec_u8_____ha5300c747747c3c8_3($2 + 72 | 0 | 0);
      break label$3;
     }
     memcpy($0 + 8 | 0 | 0, memcpy($2 + 96 | 0 | 4 | 0 | 0, ($2 + 144 | 0) + 8 | 0 | 0, 40 | 0) | 0 | 0, 40 | 0) | 0;
     HEAP32[$0 >> 2] = 1;
     break label$1;
    }
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 48 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 48 | 0 | 0);
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  }
  global$0 = $2 + 192 | 0;
 }
 
 function linked_hash_map__LinkedHashMap_K_2cV_2cS___insert__h0e2ff8a07783b7ab($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $5 = 0, $4 = 0, $6 = 0, $11 = 0, $11$hi = 0, $7 = 0, $10 = 0, $36 = 0, $9 = 0, $37 = 0, $38 = 0, $39 = 0, $40 = 0, $41 = 0, $42 = 0, $43 = 0, $8 = 0, $128 = 0, $139 = 0, $12 = 0, $12$hi = 0, $148 = 0, $13 = 0, $13$hi = 0, $157 = 0, $177 = 0, $189 = 0, $201 = 0, $233 = 0, $240 = 0, $243 = 0, $250 = 0, $254 = 0, $258 = 0, $272 = 0, $277 = 0, $282 = 0;
  $4 = global$0 - 368 | 0;
  global$0 = $4;
  label$1 : {
   if (HEAP32[($1 + 32 | 0) >> 2] | 0) {
    break label$1
   }
   $5 = __rust_alloc(192 | 0, 8 | 0) | 0;
   HEAP32[($1 + 32 | 0) >> 2] = $5;
   HEAP32[($5 + 156 | 0) >> 2] = $5;
   HEAP32[($5 + 152 | 0) >> 2] = $5;
  }
  HEAP32[($4 + 180 | 0) >> 2] = $2;
  i64toi32_i32$0 = hashbrown__map__make_hash__h16f0f4baf07b5eeb($1 | 0, $4 + 180 | 0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $11 = i64toi32_i32$0;
  $11$hi = i64toi32_i32$1;
  $6 = i64toi32_i32$0;
  $7 = (HEAP32[($1 + 16 | 0) >> 2] | 0) & i64toi32_i32$0 | 0;
  $36 = (HEAP32[($1 + 20 | 0) >> 2] | 0) + $7 | 0;
  $5 = HEAPU8[$36 >> 0] | 0 | ((HEAPU8[($36 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($36 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($36 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  HEAP32[($4 + 192 | 0) >> 2] = 0;
  HEAP32[($4 + 196 | 0) >> 2] = $5;
  HEAP32[($4 + 188 | 0) >> 2] = $7;
  HEAP32[($4 + 184 | 0) >> 2] = $1 + 16 | 0;
  $6 = i64toi32_i32$0 >>> 25 | 0;
  HEAP8[($4 + 204 | 0) >> 0] = $6;
  $5 = $5 ^ Math_imul($6, 16843009) | 0;
  HEAP32[($4 + 200 | 0) >> 2] = (($5 ^ -1 | 0) & ($5 + -16843009 | 0) | 0) & -2139062144 | 0;
  $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($4 + 24 | 0 | 0, $4 + 184 | 0 | 0);
  label$2 : {
   label$3 : {
    if (!(HEAP32[($4 + 24 | 0) >> 2] | 0)) {
     break label$3
    }
    label$4 : {
     $6 = HEAP32[($4 + 180 | 0) >> 2] | 0;
     $5 = (HEAP32[((HEAP32[($4 + 184 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) - ((HEAP32[($4 + 28 | 0) >> 2] | 0) << 3 | 0) | 0;
     if (!(memcmp($6 | 0, HEAP32[($5 + -8 | 0) >> 2] | 0 | 0, 28 | 0) | 0)) {
      break label$4
     }
     label$5 : while (1) {
      $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($4 + 16 | 0 | 0, $4 + 184 | 0 | 0);
      if (!(HEAP32[($4 + 16 | 0) >> 2] | 0)) {
       break label$3
      }
      $5 = (HEAP32[((HEAP32[($4 + 184 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) - ((HEAP32[($4 + 20 | 0) >> 2] | 0) << 3 | 0) | 0;
      if (memcmp($6 | 0, HEAP32[($5 + -8 | 0) >> 2] | 0 | 0, 28 | 0) | 0) {
       continue label$5
      }
      break label$5;
     };
    }
    $8 = $5 + -4 | 0;
    $9 = HEAP32[$8 >> 2] | 0;
    memcpy($4 + 184 | 0 | 0, $3 | 0, 152 | 0) | 0;
    $6 = 0;
    label$6 : while (1) {
     $5 = $9 + $6 | 0;
     i64toi32_i32$2 = $5;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $11 = i64toi32_i32$1;
     $11$hi = i64toi32_i32$0;
     $2 = ($4 + 184 | 0) + $6 | 0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $128 = i64toi32_i32$0;
     i64toi32_i32$0 = $5;
     HEAP32[i64toi32_i32$0 >> 2] = $128;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $11$hi;
     i64toi32_i32$0 = i64toi32_i32$2;
     HEAP32[i64toi32_i32$0 >> 2] = $11;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     $7 = $5 + 8 | 0;
     i64toi32_i32$2 = $7;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $11 = i64toi32_i32$1;
     $11$hi = i64toi32_i32$0;
     $3 = $2 + 8 | 0;
     i64toi32_i32$2 = $3;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $139 = i64toi32_i32$0;
     i64toi32_i32$0 = $7;
     HEAP32[i64toi32_i32$0 >> 2] = $139;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     $7 = $5 + 16 | 0;
     i64toi32_i32$2 = $7;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $12 = i64toi32_i32$1;
     $12$hi = i64toi32_i32$0;
     $10 = $2 + 16 | 0;
     i64toi32_i32$2 = $10;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $148 = i64toi32_i32$0;
     i64toi32_i32$0 = $7;
     HEAP32[i64toi32_i32$0 >> 2] = $148;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     $5 = $5 + 24 | 0;
     i64toi32_i32$2 = $5;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $13 = i64toi32_i32$1;
     $13$hi = i64toi32_i32$0;
     $2 = $2 + 24 | 0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $157 = i64toi32_i32$0;
     i64toi32_i32$0 = $5;
     HEAP32[i64toi32_i32$0 >> 2] = $157;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$0 = i64toi32_i32$2;
     HEAP32[i64toi32_i32$0 >> 2] = $13;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$0 = $10;
     HEAP32[i64toi32_i32$0 >> 2] = $12;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $11$hi;
     i64toi32_i32$0 = $3;
     HEAP32[i64toi32_i32$0 >> 2] = $11;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     $6 = $6 + 32 | 0;
     if ($6 >>> 0 < 121 >>> 0) {
      continue label$6
     }
     break label$6;
    };
    $5 = ($4 + 184 | 0) + 128 | 0;
    i64toi32_i32$2 = $5;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $11 = i64toi32_i32$1;
    $11$hi = i64toi32_i32$0;
    $2 = $9 + 128 | 0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $177 = i64toi32_i32$0;
    i64toi32_i32$0 = $5;
    HEAP32[i64toi32_i32$0 >> 2] = $177;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $11$hi;
    i64toi32_i32$0 = i64toi32_i32$2;
    HEAP32[i64toi32_i32$0 >> 2] = $11;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    $5 = ($4 + 184 | 0) + 136 | 0;
    i64toi32_i32$2 = $5;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $11 = i64toi32_i32$1;
    $11$hi = i64toi32_i32$0;
    $2 = $9 + 136 | 0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $189 = i64toi32_i32$0;
    i64toi32_i32$0 = $5;
    HEAP32[i64toi32_i32$0 >> 2] = $189;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $11$hi;
    i64toi32_i32$0 = i64toi32_i32$2;
    HEAP32[i64toi32_i32$0 >> 2] = $11;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    $5 = ($4 + 184 | 0) + 144 | 0;
    i64toi32_i32$2 = $5;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $11 = i64toi32_i32$1;
    $11$hi = i64toi32_i32$0;
    $2 = $9 + 144 | 0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $201 = i64toi32_i32$0;
    i64toi32_i32$0 = $5;
    HEAP32[i64toi32_i32$0 >> 2] = $201;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $11$hi;
    i64toi32_i32$0 = i64toi32_i32$2;
    HEAP32[i64toi32_i32$0 >> 2] = $11;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 184 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 188 | 0) >> 2] | 0;
    $11 = i64toi32_i32$1;
    $11$hi = i64toi32_i32$0;
    memcpy(i64toi32_i32$2 + 32 | 0 | 0, i64toi32_i32$2 + 192 | 0 | 0, 144 | 0) | 0;
    $5 = HEAP32[$8 >> 2] | 0;
    break label$2;
   }
   label$7 : {
    $5 = HEAP32[($1 + 36 | 0) >> 2] | 0;
    if (!$5) {
     break label$7
    }
    HEAP32[($1 + 36 | 0) >> 2] = HEAP32[($5 + 152 | 0) >> 2] | 0;
    $6 = ($4 + 184 | 0) + 24 | 0;
    $37 = $2 + 24 | 0;
    HEAP32[$6 >> 2] = HEAPU8[$37 >> 0] | 0 | ((HEAPU8[($37 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($37 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($37 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $7 = ($4 + 184 | 0) + 16 | 0;
    i64toi32_i32$2 = $2 + 16 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $233 = i64toi32_i32$0;
    i64toi32_i32$0 = $7;
    HEAP32[i64toi32_i32$0 >> 2] = $233;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    $10 = ($4 + 184 | 0) + 8 | 0;
    i64toi32_i32$2 = $2 + 8 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $240 = i64toi32_i32$1;
    i64toi32_i32$1 = $10;
    HEAP32[i64toi32_i32$1 >> 2] = $240;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $243 = i64toi32_i32$0;
    i64toi32_i32$0 = $4;
    HEAP32[(i64toi32_i32$0 + 184 | 0) >> 2] = $243;
    HEAP32[(i64toi32_i32$0 + 188 | 0) >> 2] = i64toi32_i32$1;
    $2 = memcpy($5 | 0, $3 | 0, 152 | 0) | 0;
    i64toi32_i32$0 = $2;
    i64toi32_i32$1 = 0;
    HEAP32[(i64toi32_i32$0 + 152 | 0) >> 2] = 0;
    HEAP32[(i64toi32_i32$0 + 156 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 184 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 188 | 0) >> 2] | 0;
    $250 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[(i64toi32_i32$1 + 160 | 0) >> 2] = $250;
    HEAP32[(i64toi32_i32$1 + 164 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $10;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $254 = i64toi32_i32$0;
    i64toi32_i32$0 = $2 + 168 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $254;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $7;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $258 = i64toi32_i32$1;
    i64toi32_i32$1 = $2 + 176 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $258;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($2 + 184 | 0) >> 2] = HEAP32[$6 >> 2] | 0;
    i64toi32_i32$0 = 0;
    $11 = 3;
    $11$hi = i64toi32_i32$0;
    break label$2;
   }
   label$8 : {
    $5 = __rust_alloc(192 | 0, 8 | 0) | 0;
    if (!$5) {
     break label$8
    }
    $6 = memcpy($5 | 0, $3 | 0, 152 | 0) | 0;
    i64toi32_i32$1 = $6;
    i64toi32_i32$0 = 0;
    HEAP32[(i64toi32_i32$1 + 152 | 0) >> 2] = 0;
    HEAP32[(i64toi32_i32$1 + 156 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $272 = i64toi32_i32$0;
    i64toi32_i32$0 = $6;
    $38 = $272;
    HEAP8[(i64toi32_i32$0 + 160 | 0) >> 0] = $38;
    HEAP8[(i64toi32_i32$0 + 161 | 0) >> 0] = $38 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 162 | 0) >> 0] = $38 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 163 | 0) >> 0] = $38 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 164 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 165 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 166 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 167 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $277 = i64toi32_i32$1;
    i64toi32_i32$1 = $6 + 168 | 0;
    $39 = $277;
    HEAP8[i64toi32_i32$1 >> 0] = $39;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $39 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $39 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $39 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$2 = $2 + 16 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $282 = i64toi32_i32$0;
    i64toi32_i32$0 = $6 + 176 | 0;
    $40 = $282;
    HEAP8[i64toi32_i32$0 >> 0] = $40;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $40 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $40 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $40 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    $41 = $2 + 24 | 0;
    $42 = $6 + 184 | 0;
    $43 = HEAPU8[$41 >> 0] | 0 | ((HEAPU8[($41 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($41 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($41 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    HEAP8[$42 >> 0] = $43;
    HEAP8[($42 + 1 | 0) >> 0] = $43 >>> 8 | 0;
    HEAP8[($42 + 2 | 0) >> 0] = $43 >>> 16 | 0;
    HEAP8[($42 + 3 | 0) >> 0] = $43 >>> 24 | 0;
    i64toi32_i32$1 = 0;
    $11 = 3;
    $11$hi = i64toi32_i32$1;
    break label$2;
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(192 | 0, 8 | 0);
   abort();
  }
  memcpy($4 + 184 | 0 | 0, $4 + 32 | 0 | 0, 144 | 0) | 0;
  label$9 : {
   label$10 : {
    i64toi32_i32$1 = $11$hi;
    i64toi32_i32$2 = $11;
    i64toi32_i32$0 = 0;
    if ((i64toi32_i32$2 | 0) != (3 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$0 | 0) | 0) {
     break label$10
    }
    hashbrown__map__HashMap_K_2cV_2cS_2cA___insert__he00a034bc59fe2c2($4 + 8 | 0 | 0, $1 | 0, $5 + 160 | 0 | 0, $5 | 0);
    $2 = HEAP32[($1 + 32 | 0) >> 2] | 0;
    $6 = HEAP32[($2 + 152 | 0) >> 2] | 0;
    HEAP32[($5 + 156 | 0) >> 2] = $2;
    HEAP32[($5 + 152 | 0) >> 2] = $6;
    $2 = $2 + 152 | 0;
    break label$9;
   }
   HEAP32[((HEAP32[($5 + 156 | 0) >> 2] | 0) + 152 | 0) >> 2] = HEAP32[($5 + 152 | 0) >> 2] | 0;
   HEAP32[((HEAP32[($5 + 152 | 0) >> 2] | 0) + 156 | 0) >> 2] = HEAP32[($5 + 156 | 0) >> 2] | 0;
   $2 = HEAP32[($1 + 32 | 0) >> 2] | 0;
   $6 = HEAP32[($2 + 152 | 0) >> 2] | 0;
   HEAP32[($5 + 156 | 0) >> 2] = $2;
   HEAP32[($5 + 152 | 0) >> 2] = $6;
   $2 = $2 + 152 | 0;
  }
  HEAP32[$2 >> 2] = $5;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $11;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  HEAP32[((HEAP32[($5 + 152 | 0) >> 2] | 0) + 156 | 0) >> 2] = $5;
  memcpy(i64toi32_i32$1 + 8 | 0 | 0, $4 + 184 | 0 | 0, 144 | 0) | 0;
  global$0 = $4 + 368 | 0;
 }
 
 function linked_hash_map__LinkedHashMap_K_2cV_2cS___insert__hfa80207d641c294d($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $5 = 0, $4 = 0, $6 = 0, $11 = 0, $11$hi = 0, $7 = 0, $10 = 0, $36 = 0, $9 = 0, $37 = 0, $38 = 0, $39 = 0, $40 = 0, $41 = 0, $42 = 0, $43 = 0, $8 = 0, $128 = 0, $139 = 0, $12 = 0, $12$hi = 0, $148 = 0, $13 = 0, $13$hi = 0, $157 = 0, $177 = 0, $189 = 0, $201 = 0, $233 = 0, $240 = 0, $243 = 0, $250 = 0, $254 = 0, $258 = 0, $272 = 0, $277 = 0, $282 = 0;
  $4 = global$0 - 880 | 0;
  global$0 = $4;
  label$1 : {
   if (HEAP32[($1 + 32 | 0) >> 2] | 0) {
    break label$1
   }
   $5 = __rust_alloc(448 | 0, 8 | 0) | 0;
   HEAP32[($1 + 32 | 0) >> 2] = $5;
   HEAP32[($5 + 412 | 0) >> 2] = $5;
   HEAP32[($5 + 408 | 0) >> 2] = $5;
  }
  HEAP32[($4 + 436 | 0) >> 2] = $2;
  i64toi32_i32$0 = hashbrown__map__make_hash__h5f7c8b88d87207db($1 | 0, $4 + 436 | 0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $11 = i64toi32_i32$0;
  $11$hi = i64toi32_i32$1;
  $6 = i64toi32_i32$0;
  $7 = (HEAP32[($1 + 16 | 0) >> 2] | 0) & i64toi32_i32$0 | 0;
  $36 = (HEAP32[($1 + 20 | 0) >> 2] | 0) + $7 | 0;
  $5 = HEAPU8[$36 >> 0] | 0 | ((HEAPU8[($36 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($36 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($36 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  HEAP32[($4 + 448 | 0) >> 2] = 0;
  HEAP32[($4 + 452 | 0) >> 2] = $5;
  HEAP32[($4 + 444 | 0) >> 2] = $7;
  HEAP32[($4 + 440 | 0) >> 2] = $1 + 16 | 0;
  $6 = i64toi32_i32$0 >>> 25 | 0;
  HEAP8[($4 + 460 | 0) >> 0] = $6;
  $5 = $5 ^ Math_imul($6, 16843009) | 0;
  HEAP32[($4 + 456 | 0) >> 2] = (($5 ^ -1 | 0) & ($5 + -16843009 | 0) | 0) & -2139062144 | 0;
  $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($4 + 24 | 0 | 0, $4 + 440 | 0 | 0);
  label$2 : {
   label$3 : {
    if (!(HEAP32[($4 + 24 | 0) >> 2] | 0)) {
     break label$3
    }
    label$4 : {
     $6 = HEAP32[($4 + 436 | 0) >> 2] | 0;
     $5 = (HEAP32[((HEAP32[($4 + 440 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) - ((HEAP32[($4 + 28 | 0) >> 2] | 0) << 3 | 0) | 0;
     if (!(memcmp($6 | 0, HEAP32[($5 + -8 | 0) >> 2] | 0 | 0, 28 | 0) | 0)) {
      break label$4
     }
     label$5 : while (1) {
      $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($4 + 16 | 0 | 0, $4 + 440 | 0 | 0);
      if (!(HEAP32[($4 + 16 | 0) >> 2] | 0)) {
       break label$3
      }
      $5 = (HEAP32[((HEAP32[($4 + 440 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) - ((HEAP32[($4 + 20 | 0) >> 2] | 0) << 3 | 0) | 0;
      if (memcmp($6 | 0, HEAP32[($5 + -8 | 0) >> 2] | 0 | 0, 28 | 0) | 0) {
       continue label$5
      }
      break label$5;
     };
    }
    $8 = $5 + -4 | 0;
    $9 = HEAP32[$8 >> 2] | 0;
    memcpy($4 + 440 | 0 | 0, $3 | 0, 408 | 0) | 0;
    $6 = 0;
    label$6 : while (1) {
     $5 = $9 + $6 | 0;
     i64toi32_i32$2 = $5;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $11 = i64toi32_i32$1;
     $11$hi = i64toi32_i32$0;
     $2 = ($4 + 440 | 0) + $6 | 0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $128 = i64toi32_i32$0;
     i64toi32_i32$0 = $5;
     HEAP32[i64toi32_i32$0 >> 2] = $128;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $11$hi;
     i64toi32_i32$0 = i64toi32_i32$2;
     HEAP32[i64toi32_i32$0 >> 2] = $11;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     $7 = $5 + 8 | 0;
     i64toi32_i32$2 = $7;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $11 = i64toi32_i32$1;
     $11$hi = i64toi32_i32$0;
     $3 = $2 + 8 | 0;
     i64toi32_i32$2 = $3;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $139 = i64toi32_i32$0;
     i64toi32_i32$0 = $7;
     HEAP32[i64toi32_i32$0 >> 2] = $139;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     $7 = $5 + 16 | 0;
     i64toi32_i32$2 = $7;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $12 = i64toi32_i32$1;
     $12$hi = i64toi32_i32$0;
     $10 = $2 + 16 | 0;
     i64toi32_i32$2 = $10;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $148 = i64toi32_i32$0;
     i64toi32_i32$0 = $7;
     HEAP32[i64toi32_i32$0 >> 2] = $148;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     $5 = $5 + 24 | 0;
     i64toi32_i32$2 = $5;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $13 = i64toi32_i32$1;
     $13$hi = i64toi32_i32$0;
     $2 = $2 + 24 | 0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $157 = i64toi32_i32$0;
     i64toi32_i32$0 = $5;
     HEAP32[i64toi32_i32$0 >> 2] = $157;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$0 = i64toi32_i32$2;
     HEAP32[i64toi32_i32$0 >> 2] = $13;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$0 = $10;
     HEAP32[i64toi32_i32$0 >> 2] = $12;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $11$hi;
     i64toi32_i32$0 = $3;
     HEAP32[i64toi32_i32$0 >> 2] = $11;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     $6 = $6 + 32 | 0;
     if ($6 >>> 0 < 377 >>> 0) {
      continue label$6
     }
     break label$6;
    };
    $5 = ($4 + 440 | 0) + 384 | 0;
    i64toi32_i32$2 = $5;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $11 = i64toi32_i32$1;
    $11$hi = i64toi32_i32$0;
    $2 = $9 + 384 | 0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $177 = i64toi32_i32$0;
    i64toi32_i32$0 = $5;
    HEAP32[i64toi32_i32$0 >> 2] = $177;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $11$hi;
    i64toi32_i32$0 = i64toi32_i32$2;
    HEAP32[i64toi32_i32$0 >> 2] = $11;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    $5 = ($4 + 440 | 0) + 392 | 0;
    i64toi32_i32$2 = $5;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $11 = i64toi32_i32$1;
    $11$hi = i64toi32_i32$0;
    $2 = $9 + 392 | 0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $189 = i64toi32_i32$0;
    i64toi32_i32$0 = $5;
    HEAP32[i64toi32_i32$0 >> 2] = $189;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $11$hi;
    i64toi32_i32$0 = i64toi32_i32$2;
    HEAP32[i64toi32_i32$0 >> 2] = $11;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    $5 = ($4 + 440 | 0) + 400 | 0;
    i64toi32_i32$2 = $5;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $11 = i64toi32_i32$1;
    $11$hi = i64toi32_i32$0;
    $2 = $9 + 400 | 0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $201 = i64toi32_i32$0;
    i64toi32_i32$0 = $5;
    HEAP32[i64toi32_i32$0 >> 2] = $201;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $11$hi;
    i64toi32_i32$0 = i64toi32_i32$2;
    HEAP32[i64toi32_i32$0 >> 2] = $11;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 440 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 444 | 0) >> 2] | 0;
    $11 = i64toi32_i32$1;
    $11$hi = i64toi32_i32$0;
    memcpy(i64toi32_i32$2 + 32 | 0 | 0, i64toi32_i32$2 + 448 | 0 | 0, 400 | 0) | 0;
    $5 = HEAP32[$8 >> 2] | 0;
    break label$2;
   }
   label$7 : {
    $5 = HEAP32[($1 + 36 | 0) >> 2] | 0;
    if (!$5) {
     break label$7
    }
    HEAP32[($1 + 36 | 0) >> 2] = HEAP32[($5 + 408 | 0) >> 2] | 0;
    $6 = ($4 + 440 | 0) + 24 | 0;
    $37 = $2 + 24 | 0;
    HEAP32[$6 >> 2] = HEAPU8[$37 >> 0] | 0 | ((HEAPU8[($37 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($37 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($37 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $7 = ($4 + 440 | 0) + 16 | 0;
    i64toi32_i32$2 = $2 + 16 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $233 = i64toi32_i32$0;
    i64toi32_i32$0 = $7;
    HEAP32[i64toi32_i32$0 >> 2] = $233;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    $10 = ($4 + 440 | 0) + 8 | 0;
    i64toi32_i32$2 = $2 + 8 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $240 = i64toi32_i32$1;
    i64toi32_i32$1 = $10;
    HEAP32[i64toi32_i32$1 >> 2] = $240;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $243 = i64toi32_i32$0;
    i64toi32_i32$0 = $4;
    HEAP32[(i64toi32_i32$0 + 440 | 0) >> 2] = $243;
    HEAP32[(i64toi32_i32$0 + 444 | 0) >> 2] = i64toi32_i32$1;
    $2 = memcpy($5 | 0, $3 | 0, 408 | 0) | 0;
    i64toi32_i32$0 = $2;
    i64toi32_i32$1 = 0;
    HEAP32[(i64toi32_i32$0 + 408 | 0) >> 2] = 0;
    HEAP32[(i64toi32_i32$0 + 412 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 440 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 444 | 0) >> 2] | 0;
    $250 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[(i64toi32_i32$1 + 416 | 0) >> 2] = $250;
    HEAP32[(i64toi32_i32$1 + 420 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $10;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $254 = i64toi32_i32$0;
    i64toi32_i32$0 = $2 + 424 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $254;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $7;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $258 = i64toi32_i32$1;
    i64toi32_i32$1 = $2 + 432 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $258;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($2 + 440 | 0) >> 2] = HEAP32[$6 >> 2] | 0;
    i64toi32_i32$0 = 0;
    $11 = 2;
    $11$hi = i64toi32_i32$0;
    break label$2;
   }
   label$8 : {
    $5 = __rust_alloc(448 | 0, 8 | 0) | 0;
    if (!$5) {
     break label$8
    }
    $6 = memcpy($5 | 0, $3 | 0, 408 | 0) | 0;
    i64toi32_i32$1 = $6;
    i64toi32_i32$0 = 0;
    HEAP32[(i64toi32_i32$1 + 408 | 0) >> 2] = 0;
    HEAP32[(i64toi32_i32$1 + 412 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $272 = i64toi32_i32$0;
    i64toi32_i32$0 = $6;
    $38 = $272;
    HEAP8[(i64toi32_i32$0 + 416 | 0) >> 0] = $38;
    HEAP8[(i64toi32_i32$0 + 417 | 0) >> 0] = $38 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 418 | 0) >> 0] = $38 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 419 | 0) >> 0] = $38 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 420 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 421 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 422 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 423 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $277 = i64toi32_i32$1;
    i64toi32_i32$1 = $6 + 424 | 0;
    $39 = $277;
    HEAP8[i64toi32_i32$1 >> 0] = $39;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $39 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $39 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $39 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$2 = $2 + 16 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $282 = i64toi32_i32$0;
    i64toi32_i32$0 = $6 + 432 | 0;
    $40 = $282;
    HEAP8[i64toi32_i32$0 >> 0] = $40;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $40 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $40 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $40 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    $41 = $2 + 24 | 0;
    $42 = $6 + 440 | 0;
    $43 = HEAPU8[$41 >> 0] | 0 | ((HEAPU8[($41 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($41 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($41 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    HEAP8[$42 >> 0] = $43;
    HEAP8[($42 + 1 | 0) >> 0] = $43 >>> 8 | 0;
    HEAP8[($42 + 2 | 0) >> 0] = $43 >>> 16 | 0;
    HEAP8[($42 + 3 | 0) >> 0] = $43 >>> 24 | 0;
    i64toi32_i32$1 = 0;
    $11 = 2;
    $11$hi = i64toi32_i32$1;
    break label$2;
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(448 | 0, 8 | 0);
   abort();
  }
  memcpy($4 + 440 | 0 | 0, $4 + 32 | 0 | 0, 400 | 0) | 0;
  label$9 : {
   label$10 : {
    i64toi32_i32$1 = $11$hi;
    i64toi32_i32$2 = $11;
    i64toi32_i32$0 = 0;
    if ((i64toi32_i32$2 | 0) != (2 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$0 | 0) | 0) {
     break label$10
    }
    hashbrown__map__HashMap_K_2cV_2cS_2cA___insert__hbcfd3ef1bdc4d2e0($4 + 8 | 0 | 0, $1 | 0, $5 + 416 | 0 | 0, $5 | 0);
    $2 = HEAP32[($1 + 32 | 0) >> 2] | 0;
    $6 = HEAP32[($2 + 408 | 0) >> 2] | 0;
    HEAP32[($5 + 412 | 0) >> 2] = $2;
    HEAP32[($5 + 408 | 0) >> 2] = $6;
    $2 = $2 + 408 | 0;
    break label$9;
   }
   HEAP32[((HEAP32[($5 + 412 | 0) >> 2] | 0) + 408 | 0) >> 2] = HEAP32[($5 + 408 | 0) >> 2] | 0;
   HEAP32[((HEAP32[($5 + 408 | 0) >> 2] | 0) + 412 | 0) >> 2] = HEAP32[($5 + 412 | 0) >> 2] | 0;
   $2 = HEAP32[($1 + 32 | 0) >> 2] | 0;
   $6 = HEAP32[($2 + 408 | 0) >> 2] | 0;
   HEAP32[($5 + 412 | 0) >> 2] = $2;
   HEAP32[($5 + 408 | 0) >> 2] = $6;
   $2 = $2 + 408 | 0;
  }
  HEAP32[$2 >> 2] = $5;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $11;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  HEAP32[((HEAP32[($5 + 408 | 0) >> 2] | 0) + 412 | 0) >> 2] = $5;
  memcpy(i64toi32_i32$1 + 8 | 0 | 0, $4 + 440 | 0 | 0, 400 | 0) | 0;
  global$0 = $4 + 880 | 0;
 }
 
 function cardano_serialization_lib__legacy_address__cbor__util__raw_with_crc32__h952aabed95f47ca2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $6 = 0, $6$hi = 0, $3 = 0, $35 = 0, $36 = 0, $37 = 0, $38 = 0, $39 = 0, $40 = 0, $41 = 0, $42 = 0, $43 = 0, $44 = 0, $4 = 0, $5 = 0, $5$hi = 0, $52 = 0, $94$hi = 0, $98 = 0, $110 = 0, $116 = 0, $122 = 0, $128 = 0, $151 = 0, $167 = 0, $173 = 0, $178 = 0, $185 = 0, $191 = 0, $197 = 0, $210 = 0, $216 = 0, $222 = 0, $228 = 0, $243 = 0, $259 = 0, $265 = 0, $270 = 0;
  $2 = global$0 - 208 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 120 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = ($2 + 120 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 128 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 132 | 0) >> 2] | 0;
  $6 = i64toi32_i32$1;
  $6$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         i64toi32_i32$2 = $2;
         i64toi32_i32$0 = HEAP32[($2 + 120 | 0) >> 2] | 0;
         i64toi32_i32$1 = HEAP32[($2 + 124 | 0) >> 2] | 0;
         i64toi32_i32$2 = i64toi32_i32$0;
         i64toi32_i32$0 = 0;
         i64toi32_i32$3 = 1;
         if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
          break label$7
         }
         i64toi32_i32$2 = $6$hi;
         i64toi32_i32$3 = $6;
         i64toi32_i32$1 = 0;
         i64toi32_i32$0 = 1;
         if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
          break label$6
         }
         i64toi32_i32$3 = $5$hi;
         i64toi32_i32$0 = $5;
         i64toi32_i32$2 = 0;
         i64toi32_i32$1 = 2;
         if ((i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$3 | 0) != (i64toi32_i32$2 | 0) | 0) {
          break label$6
         }
         cbor_event__de__Deserializer_R___tag__ha0ca0c99f1ceb558($2 + 120 | 0 | 0, $1 | 0);
         i64toi32_i32$1 = $2;
         i64toi32_i32$0 = HEAP32[($2 + 128 | 0) >> 2] | 0;
         i64toi32_i32$3 = HEAP32[($2 + 132 | 0) >> 2] | 0;
         $6 = i64toi32_i32$0;
         $6$hi = i64toi32_i32$3;
         i64toi32_i32$1 = $2;
         i64toi32_i32$3 = HEAP32[($2 + 120 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($2 + 124 | 0) >> 2] | 0;
         i64toi32_i32$1 = i64toi32_i32$3;
         i64toi32_i32$3 = 0;
         i64toi32_i32$2 = 1;
         if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) | 0) {
          break label$5
         }
         i64toi32_i32$1 = $6$hi;
         i64toi32_i32$0 = $2;
         HEAP32[($2 + 40 | 0) >> 2] = $6;
         HEAP32[($2 + 44 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$2 = $6;
         i64toi32_i32$0 = 0;
         i64toi32_i32$3 = 24;
         if ((i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$0 | 0) | 0) {
          break label$4
         }
         cbor_event__de__Deserializer_R___bytes__hc697ccccfa39fd82($2 + 120 | 0 | 0, $1 | 0);
         if ((HEAP32[($2 + 120 | 0) >> 2] | 0 | 0) == (1 | 0)) {
          break label$3
         }
         HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 132 | 0) >> 2] | 0;
         i64toi32_i32$3 = $2;
         i64toi32_i32$2 = HEAP32[($2 + 124 | 0) >> 2] | 0;
         i64toi32_i32$1 = HEAP32[($2 + 128 | 0) >> 2] | 0;
         $52 = i64toi32_i32$2;
         i64toi32_i32$2 = $2;
         HEAP32[($2 + 48 | 0) >> 2] = $52;
         HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
         cbor_event__de__Deserializer_R___unsigned_integer__h1ed99c0b7fe7eea1($2 + 120 | 0 | 0, $1 | 0);
         i64toi32_i32$3 = $2;
         i64toi32_i32$1 = HEAP32[($2 + 128 | 0) >> 2] | 0;
         i64toi32_i32$2 = HEAP32[($2 + 132 | 0) >> 2] | 0;
         $6 = i64toi32_i32$1;
         $6$hi = i64toi32_i32$2;
         label$8 : {
          label$9 : {
           i64toi32_i32$3 = $2;
           i64toi32_i32$2 = HEAP32[($2 + 120 | 0) >> 2] | 0;
           i64toi32_i32$1 = HEAP32[($2 + 124 | 0) >> 2] | 0;
           i64toi32_i32$3 = i64toi32_i32$2;
           i64toi32_i32$2 = 0;
           i64toi32_i32$0 = 1;
           if ((i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) | 0) {
            break label$9
           }
           i64toi32_i32$3 = $6$hi;
           i64toi32_i32$1 = $2;
           HEAP32[($2 + 112 | 0) >> 2] = $6;
           HEAP32[($2 + 116 | 0) >> 2] = i64toi32_i32$3;
           $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 24 | 0 | 0, $2 + 48 | 0 | 0);
           label$10 : {
            label$11 : {
             $3 = HEAP32[($2 + 28 | 0) >> 2] | 0;
             if ($3) {
              break label$11
             }
             $1 = 0;
             break label$10;
            }
            $4 = HEAP32[($2 + 24 | 0) >> 2] | 0;
            $1 = -1;
            label$12 : while (1) {
             $1 = (HEAP32[(((($1 & 255 | 0) ^ (HEAPU8[$4 >> 0] | 0) | 0) << 2 | 0) + 1062472 | 0) >> 2] | 0) ^ ($1 >>> 8 | 0) | 0;
             $4 = $4 + 1 | 0;
             $3 = $3 + -1 | 0;
             if ($3) {
              continue label$12
             }
             break label$12;
            };
            $1 = $1 ^ -1 | 0;
           }
           HEAP32[($2 + 172 | 0) >> 2] = $1;
           i64toi32_i32$3 = $6$hi;
           i64toi32_i32$3 = 0;
           $94$hi = i64toi32_i32$3;
           i64toi32_i32$3 = $6$hi;
           i64toi32_i32$0 = $6;
           i64toi32_i32$1 = $94$hi;
           i64toi32_i32$2 = $1;
           if ((i64toi32_i32$0 | 0) != (i64toi32_i32$2 | 0) | (i64toi32_i32$3 | 0) != (i64toi32_i32$1 | 0) | 0) {
            break label$8
           }
           i64toi32_i32$2 = $2;
           i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
           i64toi32_i32$3 = HEAP32[($2 + 52 | 0) >> 2] | 0;
           $98 = i64toi32_i32$0;
           i64toi32_i32$0 = $0;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $98;
           HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$3;
           HEAP32[i64toi32_i32$0 >> 2] = 0;
           HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = HEAP32[($2 + 56 | 0) >> 2] | 0;
           break label$1;
          }
          i64toi32_i32$2 = ($2 + 120 | 0) + 40 | 0;
          i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
          $110 = i64toi32_i32$3;
          i64toi32_i32$3 = $0 + 40 | 0;
          HEAP32[i64toi32_i32$3 >> 2] = $110;
          HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
          i64toi32_i32$2 = ($2 + 120 | 0) + 32 | 0;
          i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
          i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
          $116 = i64toi32_i32$0;
          i64toi32_i32$0 = $0 + 32 | 0;
          HEAP32[i64toi32_i32$0 >> 2] = $116;
          HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
          i64toi32_i32$2 = ($2 + 120 | 0) + 24 | 0;
          i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
          $122 = i64toi32_i32$3;
          i64toi32_i32$3 = $0 + 24 | 0;
          HEAP32[i64toi32_i32$3 >> 2] = $122;
          HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
          i64toi32_i32$2 = ($2 + 120 | 0) + 16 | 0;
          i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
          i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
          $128 = i64toi32_i32$0;
          i64toi32_i32$0 = $0 + 16 | 0;
          HEAP32[i64toi32_i32$0 >> 2] = $128;
          HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
          HEAP32[$0 >> 2] = 1;
          i64toi32_i32$3 = $6$hi;
          i64toi32_i32$0 = $0 + 8 | 0;
          HEAP32[i64toi32_i32$0 >> 2] = $6;
          HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
          break label$2;
         }
         core__fmt__ArgumentV1__new__h021aa801e74cb4b6($2 + 16 | 0 | 0, $2 + 112 | 0 | 0, 18 | 0);
         i64toi32_i32$2 = $2;
         i64toi32_i32$3 = HEAP32[($2 + 16 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
         $6 = i64toi32_i32$3;
         $6$hi = i64toi32_i32$0;
         core__fmt__ArgumentV1__new__hfe8bfc123be7fc32($2 + 8 | 0 | 0, $2 + 172 | 0 | 0, 19 | 0);
         HEAP32[($2 + 140 | 0) >> 2] = 2;
         i64toi32_i32$3 = $2;
         HEAP32[($2 + 64 | 0) >> 2] = $6;
         HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$3 = $2;
         i64toi32_i32$0 = 0;
         HEAP32[($2 + 124 | 0) >> 2] = 2;
         HEAP32[($2 + 128 | 0) >> 2] = i64toi32_i32$0;
         HEAP32[($2 + 120 | 0) >> 2] = 1056956;
         i64toi32_i32$2 = $2;
         i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
         i64toi32_i32$3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
         $151 = i64toi32_i32$0;
         i64toi32_i32$0 = $2;
         HEAP32[($2 + 72 | 0) >> 2] = $151;
         HEAP32[($2 + 76 | 0) >> 2] = i64toi32_i32$3;
         HEAP32[($2 + 136 | 0) >> 2] = $2 + 64 | 0;
         alloc__fmt__format__h6e9e003a52c07309($2 + 192 | 0 | 0, $2 + 120 | 0 | 0);
         $35 = $2 + 187 | 0;
         $36 = HEAP32[(($2 + 192 | 0) + 8 | 0) >> 2] | 0;
         HEAP8[$35 >> 0] = $36;
         HEAP8[($35 + 1 | 0) >> 0] = $36 >>> 8 | 0;
         HEAP8[($35 + 2 | 0) >> 0] = $36 >>> 16 | 0;
         HEAP8[($35 + 3 | 0) >> 0] = $36 >>> 24 | 0;
         i64toi32_i32$2 = $2;
         i64toi32_i32$3 = HEAP32[($2 + 192 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($2 + 196 | 0) >> 2] | 0;
         $167 = i64toi32_i32$3;
         i64toi32_i32$3 = $2;
         $37 = $167;
         HEAP8[($2 + 179 | 0) >> 0] = $37;
         HEAP8[($2 + 180 | 0) >> 0] = $37 >>> 8 | 0;
         HEAP8[($2 + 181 | 0) >> 0] = $37 >>> 16 | 0;
         HEAP8[($2 + 182 | 0) >> 0] = $37 >>> 24 | 0;
         HEAP8[($2 + 183 | 0) >> 0] = i64toi32_i32$0;
         HEAP8[($2 + 184 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
         HEAP8[($2 + 185 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
         HEAP8[($2 + 186 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
         HEAP8[($0 + 8 | 0) >> 0] = 18;
         i64toi32_i32$2 = $2;
         i64toi32_i32$0 = HEAPU8[($2 + 176 | 0) >> 0] | 0 | ((HEAPU8[($2 + 177 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 178 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 179 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$3 = HEAPU8[($2 + 180 | 0) >> 0] | 0 | ((HEAPU8[($2 + 181 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 182 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 183 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $173 = i64toi32_i32$0;
         i64toi32_i32$0 = $0 + 9 | 0;
         $38 = $173;
         HEAP8[i64toi32_i32$0 >> 0] = $38;
         HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $38 >>> 8 | 0;
         HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $38 >>> 16 | 0;
         HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $38 >>> 24 | 0;
         HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$3;
         HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
         HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
         HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
         i64toi32_i32$2 = $2 + 183 | 0;
         i64toi32_i32$3 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $178 = i64toi32_i32$3;
         i64toi32_i32$3 = $0 + 16 | 0;
         $39 = $178;
         HEAP8[i64toi32_i32$3 >> 0] = $39;
         HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $39 >>> 8 | 0;
         HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $39 >>> 16 | 0;
         HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $39 >>> 24 | 0;
         HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$0;
         HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
         HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
         HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
         HEAP32[$0 >> 2] = 1;
         break label$2;
        }
        i64toi32_i32$2 = ($2 + 120 | 0) + 40 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $185 = i64toi32_i32$0;
        i64toi32_i32$0 = $0 + 40 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $185;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
        i64toi32_i32$2 = ($2 + 120 | 0) + 32 | 0;
        i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $191 = i64toi32_i32$3;
        i64toi32_i32$3 = $0 + 32 | 0;
        HEAP32[i64toi32_i32$3 >> 2] = $191;
        HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = ($2 + 120 | 0) + 24 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $197 = i64toi32_i32$0;
        i64toi32_i32$0 = $0 + 24 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $197;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
        i64toi32_i32$3 = $5$hi;
        i64toi32_i32$0 = $0 + 16 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $5;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
        i64toi32_i32$3 = $6$hi;
        i64toi32_i32$0 = $0 + 8 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $6;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
        HEAP32[$0 >> 2] = 1;
        break label$1;
       }
       core__panicking__panic__h2fd385a887c8bf13(1056792 | 0, 36 | 0, 1056856 | 0);
       abort();
      }
      i64toi32_i32$2 = ($2 + 120 | 0) + 40 | 0;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $210 = i64toi32_i32$3;
      i64toi32_i32$3 = $0 + 40 | 0;
      HEAP32[i64toi32_i32$3 >> 2] = $210;
      HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = ($2 + 120 | 0) + 32 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $216 = i64toi32_i32$0;
      i64toi32_i32$0 = $0 + 32 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $216;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
      i64toi32_i32$2 = ($2 + 120 | 0) + 24 | 0;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $222 = i64toi32_i32$3;
      i64toi32_i32$3 = $0 + 24 | 0;
      HEAP32[i64toi32_i32$3 >> 2] = $222;
      HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = ($2 + 120 | 0) + 16 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $228 = i64toi32_i32$0;
      i64toi32_i32$0 = $0 + 16 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $228;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
      HEAP32[$0 >> 2] = 1;
      i64toi32_i32$3 = $6$hi;
      i64toi32_i32$0 = $0 + 8 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $6;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
      break label$1;
     }
     core__fmt__ArgumentV1__new__h021aa801e74cb4b6($2 + 32 | 0 | 0, $2 + 40 | 0 | 0, 20 | 0);
     HEAP32[($2 + 140 | 0) >> 2] = 1;
     i64toi32_i32$0 = $2;
     i64toi32_i32$3 = 0;
     HEAP32[($2 + 124 | 0) >> 2] = 2;
     HEAP32[($2 + 128 | 0) >> 2] = i64toi32_i32$3;
     HEAP32[($2 + 120 | 0) >> 2] = 1056904;
     i64toi32_i32$2 = $2;
     i64toi32_i32$3 = HEAP32[($2 + 32 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 36 | 0) >> 2] | 0;
     $243 = i64toi32_i32$3;
     i64toi32_i32$3 = $2;
     HEAP32[($2 + 192 | 0) >> 2] = $243;
     HEAP32[($2 + 196 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($2 + 136 | 0) >> 2] = $2 + 192 | 0;
     alloc__fmt__format__h6e9e003a52c07309($2 + 176 | 0 | 0, $2 + 120 | 0 | 0);
     $40 = $2 + 75 | 0;
     $41 = HEAP32[(($2 + 176 | 0) + 8 | 0) >> 2] | 0;
     HEAP8[$40 >> 0] = $41;
     HEAP8[($40 + 1 | 0) >> 0] = $41 >>> 8 | 0;
     HEAP8[($40 + 2 | 0) >> 0] = $41 >>> 16 | 0;
     HEAP8[($40 + 3 | 0) >> 0] = $41 >>> 24 | 0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[($2 + 176 | 0) >> 2] | 0;
     i64toi32_i32$3 = HEAP32[($2 + 180 | 0) >> 2] | 0;
     $259 = i64toi32_i32$0;
     i64toi32_i32$0 = $2;
     $42 = $259;
     HEAP8[($2 + 67 | 0) >> 0] = $42;
     HEAP8[($2 + 68 | 0) >> 0] = $42 >>> 8 | 0;
     HEAP8[($2 + 69 | 0) >> 0] = $42 >>> 16 | 0;
     HEAP8[($2 + 70 | 0) >> 0] = $42 >>> 24 | 0;
     HEAP8[($2 + 71 | 0) >> 0] = i64toi32_i32$3;
     HEAP8[($2 + 72 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
     HEAP8[($2 + 73 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
     HEAP8[($2 + 74 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
     HEAP8[($0 + 8 | 0) >> 0] = 18;
     i64toi32_i32$2 = $2;
     i64toi32_i32$3 = HEAPU8[($2 + 64 | 0) >> 0] | 0 | ((HEAPU8[($2 + 65 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 66 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 67 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[($2 + 68 | 0) >> 0] | 0 | ((HEAPU8[($2 + 69 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 70 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 71 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $265 = i64toi32_i32$3;
     i64toi32_i32$3 = $0 + 9 | 0;
     $43 = $265;
     HEAP8[i64toi32_i32$3 >> 0] = $43;
     HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $43 >>> 8 | 0;
     HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $43 >>> 16 | 0;
     HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $43 >>> 24 | 0;
     HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$0;
     HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
     HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
     HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
     i64toi32_i32$2 = $2 + 71 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$3 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $270 = i64toi32_i32$0;
     i64toi32_i32$0 = $0 + 16 | 0;
     $44 = $270;
     HEAP8[i64toi32_i32$0 >> 0] = $44;
     HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $44 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $44 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $44 >>> 24 | 0;
     HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$3;
     HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
     HEAP32[$0 >> 2] = 1;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, memcpy($2 + 64 | 0 | 4 | 0 | 0, ($2 + 120 | 0) + 8 | 0 | 0, 40 | 0) | 0 | 0, 40 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    break label$1;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 48 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 48 | 0 | 0);
  }
  global$0 = $2 + 208 | 0;
 }
 
 function cardano_serialization_lib__legacy_address__cbor__util__raw_with_crc32__hcc0be77464365bdf($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $6 = 0, $6$hi = 0, $3 = 0, $35 = 0, $36 = 0, $37 = 0, $38 = 0, $39 = 0, $40 = 0, $41 = 0, $42 = 0, $43 = 0, $44 = 0, $4 = 0, $5 = 0, $5$hi = 0, $52 = 0, $94$hi = 0, $98 = 0, $110 = 0, $116 = 0, $122 = 0, $128 = 0, $151 = 0, $167 = 0, $173 = 0, $178 = 0, $185 = 0, $191 = 0, $197 = 0, $210 = 0, $216 = 0, $222 = 0, $228 = 0, $243 = 0, $259 = 0, $265 = 0, $270 = 0;
  $2 = global$0 - 208 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___array__h65719d950308186c($2 + 120 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = ($2 + 120 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 128 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 132 | 0) >> 2] | 0;
  $6 = i64toi32_i32$1;
  $6$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         i64toi32_i32$2 = $2;
         i64toi32_i32$0 = HEAP32[($2 + 120 | 0) >> 2] | 0;
         i64toi32_i32$1 = HEAP32[($2 + 124 | 0) >> 2] | 0;
         i64toi32_i32$2 = i64toi32_i32$0;
         i64toi32_i32$0 = 0;
         i64toi32_i32$3 = 1;
         if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
          break label$7
         }
         i64toi32_i32$2 = $6$hi;
         i64toi32_i32$3 = $6;
         i64toi32_i32$1 = 0;
         i64toi32_i32$0 = 1;
         if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
          break label$6
         }
         i64toi32_i32$3 = $5$hi;
         i64toi32_i32$0 = $5;
         i64toi32_i32$2 = 0;
         i64toi32_i32$1 = 2;
         if ((i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$3 | 0) != (i64toi32_i32$2 | 0) | 0) {
          break label$6
         }
         cbor_event__de__Deserializer_R___tag__hae6ff5633a28f977($2 + 120 | 0 | 0, $1 | 0);
         i64toi32_i32$1 = $2;
         i64toi32_i32$0 = HEAP32[($2 + 128 | 0) >> 2] | 0;
         i64toi32_i32$3 = HEAP32[($2 + 132 | 0) >> 2] | 0;
         $6 = i64toi32_i32$0;
         $6$hi = i64toi32_i32$3;
         i64toi32_i32$1 = $2;
         i64toi32_i32$3 = HEAP32[($2 + 120 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($2 + 124 | 0) >> 2] | 0;
         i64toi32_i32$1 = i64toi32_i32$3;
         i64toi32_i32$3 = 0;
         i64toi32_i32$2 = 1;
         if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) | 0) {
          break label$5
         }
         i64toi32_i32$1 = $6$hi;
         i64toi32_i32$0 = $2;
         HEAP32[($2 + 40 | 0) >> 2] = $6;
         HEAP32[($2 + 44 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$2 = $6;
         i64toi32_i32$0 = 0;
         i64toi32_i32$3 = 24;
         if ((i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$0 | 0) | 0) {
          break label$4
         }
         cbor_event__de__Deserializer_R___bytes__h5d4e2578eb751bc2($2 + 120 | 0 | 0, $1 | 0);
         if ((HEAP32[($2 + 120 | 0) >> 2] | 0 | 0) == (1 | 0)) {
          break label$3
         }
         HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 132 | 0) >> 2] | 0;
         i64toi32_i32$3 = $2;
         i64toi32_i32$2 = HEAP32[($2 + 124 | 0) >> 2] | 0;
         i64toi32_i32$1 = HEAP32[($2 + 128 | 0) >> 2] | 0;
         $52 = i64toi32_i32$2;
         i64toi32_i32$2 = $2;
         HEAP32[($2 + 48 | 0) >> 2] = $52;
         HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
         cbor_event__de__Deserializer_R___unsigned_integer__h6e8a066f7fcdccf2($2 + 120 | 0 | 0, $1 | 0);
         i64toi32_i32$3 = $2;
         i64toi32_i32$1 = HEAP32[($2 + 128 | 0) >> 2] | 0;
         i64toi32_i32$2 = HEAP32[($2 + 132 | 0) >> 2] | 0;
         $6 = i64toi32_i32$1;
         $6$hi = i64toi32_i32$2;
         label$8 : {
          label$9 : {
           i64toi32_i32$3 = $2;
           i64toi32_i32$2 = HEAP32[($2 + 120 | 0) >> 2] | 0;
           i64toi32_i32$1 = HEAP32[($2 + 124 | 0) >> 2] | 0;
           i64toi32_i32$3 = i64toi32_i32$2;
           i64toi32_i32$2 = 0;
           i64toi32_i32$0 = 1;
           if ((i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) | 0) {
            break label$9
           }
           i64toi32_i32$3 = $6$hi;
           i64toi32_i32$1 = $2;
           HEAP32[($2 + 112 | 0) >> 2] = $6;
           HEAP32[($2 + 116 | 0) >> 2] = i64toi32_i32$3;
           $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 24 | 0 | 0, $2 + 48 | 0 | 0);
           label$10 : {
            label$11 : {
             $3 = HEAP32[($2 + 28 | 0) >> 2] | 0;
             if ($3) {
              break label$11
             }
             $1 = 0;
             break label$10;
            }
            $4 = HEAP32[($2 + 24 | 0) >> 2] | 0;
            $1 = -1;
            label$12 : while (1) {
             $1 = (HEAP32[(((($1 & 255 | 0) ^ (HEAPU8[$4 >> 0] | 0) | 0) << 2 | 0) + 1062472 | 0) >> 2] | 0) ^ ($1 >>> 8 | 0) | 0;
             $4 = $4 + 1 | 0;
             $3 = $3 + -1 | 0;
             if ($3) {
              continue label$12
             }
             break label$12;
            };
            $1 = $1 ^ -1 | 0;
           }
           HEAP32[($2 + 172 | 0) >> 2] = $1;
           i64toi32_i32$3 = $6$hi;
           i64toi32_i32$3 = 0;
           $94$hi = i64toi32_i32$3;
           i64toi32_i32$3 = $6$hi;
           i64toi32_i32$0 = $6;
           i64toi32_i32$1 = $94$hi;
           i64toi32_i32$2 = $1;
           if ((i64toi32_i32$0 | 0) != (i64toi32_i32$2 | 0) | (i64toi32_i32$3 | 0) != (i64toi32_i32$1 | 0) | 0) {
            break label$8
           }
           i64toi32_i32$2 = $2;
           i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
           i64toi32_i32$3 = HEAP32[($2 + 52 | 0) >> 2] | 0;
           $98 = i64toi32_i32$0;
           i64toi32_i32$0 = $0;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $98;
           HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$3;
           HEAP32[i64toi32_i32$0 >> 2] = 0;
           HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = HEAP32[($2 + 56 | 0) >> 2] | 0;
           break label$1;
          }
          i64toi32_i32$2 = ($2 + 120 | 0) + 40 | 0;
          i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
          $110 = i64toi32_i32$3;
          i64toi32_i32$3 = $0 + 40 | 0;
          HEAP32[i64toi32_i32$3 >> 2] = $110;
          HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
          i64toi32_i32$2 = ($2 + 120 | 0) + 32 | 0;
          i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
          i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
          $116 = i64toi32_i32$0;
          i64toi32_i32$0 = $0 + 32 | 0;
          HEAP32[i64toi32_i32$0 >> 2] = $116;
          HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
          i64toi32_i32$2 = ($2 + 120 | 0) + 24 | 0;
          i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
          $122 = i64toi32_i32$3;
          i64toi32_i32$3 = $0 + 24 | 0;
          HEAP32[i64toi32_i32$3 >> 2] = $122;
          HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
          i64toi32_i32$2 = ($2 + 120 | 0) + 16 | 0;
          i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
          i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
          $128 = i64toi32_i32$0;
          i64toi32_i32$0 = $0 + 16 | 0;
          HEAP32[i64toi32_i32$0 >> 2] = $128;
          HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
          HEAP32[$0 >> 2] = 1;
          i64toi32_i32$3 = $6$hi;
          i64toi32_i32$0 = $0 + 8 | 0;
          HEAP32[i64toi32_i32$0 >> 2] = $6;
          HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
          break label$2;
         }
         core__fmt__ArgumentV1__new__h021aa801e74cb4b6($2 + 16 | 0 | 0, $2 + 112 | 0 | 0, 18 | 0);
         i64toi32_i32$2 = $2;
         i64toi32_i32$3 = HEAP32[($2 + 16 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
         $6 = i64toi32_i32$3;
         $6$hi = i64toi32_i32$0;
         core__fmt__ArgumentV1__new__hfe8bfc123be7fc32($2 + 8 | 0 | 0, $2 + 172 | 0 | 0, 19 | 0);
         HEAP32[($2 + 140 | 0) >> 2] = 2;
         i64toi32_i32$3 = $2;
         HEAP32[($2 + 64 | 0) >> 2] = $6;
         HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$3 = $2;
         i64toi32_i32$0 = 0;
         HEAP32[($2 + 124 | 0) >> 2] = 2;
         HEAP32[($2 + 128 | 0) >> 2] = i64toi32_i32$0;
         HEAP32[($2 + 120 | 0) >> 2] = 1056956;
         i64toi32_i32$2 = $2;
         i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
         i64toi32_i32$3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
         $151 = i64toi32_i32$0;
         i64toi32_i32$0 = $2;
         HEAP32[($2 + 72 | 0) >> 2] = $151;
         HEAP32[($2 + 76 | 0) >> 2] = i64toi32_i32$3;
         HEAP32[($2 + 136 | 0) >> 2] = $2 + 64 | 0;
         alloc__fmt__format__h6e9e003a52c07309($2 + 192 | 0 | 0, $2 + 120 | 0 | 0);
         $35 = $2 + 187 | 0;
         $36 = HEAP32[(($2 + 192 | 0) + 8 | 0) >> 2] | 0;
         HEAP8[$35 >> 0] = $36;
         HEAP8[($35 + 1 | 0) >> 0] = $36 >>> 8 | 0;
         HEAP8[($35 + 2 | 0) >> 0] = $36 >>> 16 | 0;
         HEAP8[($35 + 3 | 0) >> 0] = $36 >>> 24 | 0;
         i64toi32_i32$2 = $2;
         i64toi32_i32$3 = HEAP32[($2 + 192 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($2 + 196 | 0) >> 2] | 0;
         $167 = i64toi32_i32$3;
         i64toi32_i32$3 = $2;
         $37 = $167;
         HEAP8[($2 + 179 | 0) >> 0] = $37;
         HEAP8[($2 + 180 | 0) >> 0] = $37 >>> 8 | 0;
         HEAP8[($2 + 181 | 0) >> 0] = $37 >>> 16 | 0;
         HEAP8[($2 + 182 | 0) >> 0] = $37 >>> 24 | 0;
         HEAP8[($2 + 183 | 0) >> 0] = i64toi32_i32$0;
         HEAP8[($2 + 184 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
         HEAP8[($2 + 185 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
         HEAP8[($2 + 186 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
         HEAP8[($0 + 8 | 0) >> 0] = 18;
         i64toi32_i32$2 = $2;
         i64toi32_i32$0 = HEAPU8[($2 + 176 | 0) >> 0] | 0 | ((HEAPU8[($2 + 177 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 178 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 179 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$3 = HEAPU8[($2 + 180 | 0) >> 0] | 0 | ((HEAPU8[($2 + 181 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 182 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 183 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $173 = i64toi32_i32$0;
         i64toi32_i32$0 = $0 + 9 | 0;
         $38 = $173;
         HEAP8[i64toi32_i32$0 >> 0] = $38;
         HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $38 >>> 8 | 0;
         HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $38 >>> 16 | 0;
         HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $38 >>> 24 | 0;
         HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$3;
         HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
         HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
         HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
         i64toi32_i32$2 = $2 + 183 | 0;
         i64toi32_i32$3 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $178 = i64toi32_i32$3;
         i64toi32_i32$3 = $0 + 16 | 0;
         $39 = $178;
         HEAP8[i64toi32_i32$3 >> 0] = $39;
         HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $39 >>> 8 | 0;
         HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $39 >>> 16 | 0;
         HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $39 >>> 24 | 0;
         HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$0;
         HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
         HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
         HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
         HEAP32[$0 >> 2] = 1;
         break label$2;
        }
        i64toi32_i32$2 = ($2 + 120 | 0) + 40 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $185 = i64toi32_i32$0;
        i64toi32_i32$0 = $0 + 40 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $185;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
        i64toi32_i32$2 = ($2 + 120 | 0) + 32 | 0;
        i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $191 = i64toi32_i32$3;
        i64toi32_i32$3 = $0 + 32 | 0;
        HEAP32[i64toi32_i32$3 >> 2] = $191;
        HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = ($2 + 120 | 0) + 24 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $197 = i64toi32_i32$0;
        i64toi32_i32$0 = $0 + 24 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $197;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
        i64toi32_i32$3 = $5$hi;
        i64toi32_i32$0 = $0 + 16 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $5;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
        i64toi32_i32$3 = $6$hi;
        i64toi32_i32$0 = $0 + 8 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $6;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
        HEAP32[$0 >> 2] = 1;
        break label$1;
       }
       core__panicking__panic__h2fd385a887c8bf13(1056792 | 0, 36 | 0, 1056856 | 0);
       abort();
      }
      i64toi32_i32$2 = ($2 + 120 | 0) + 40 | 0;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $210 = i64toi32_i32$3;
      i64toi32_i32$3 = $0 + 40 | 0;
      HEAP32[i64toi32_i32$3 >> 2] = $210;
      HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = ($2 + 120 | 0) + 32 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $216 = i64toi32_i32$0;
      i64toi32_i32$0 = $0 + 32 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $216;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
      i64toi32_i32$2 = ($2 + 120 | 0) + 24 | 0;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $222 = i64toi32_i32$3;
      i64toi32_i32$3 = $0 + 24 | 0;
      HEAP32[i64toi32_i32$3 >> 2] = $222;
      HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = ($2 + 120 | 0) + 16 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $228 = i64toi32_i32$0;
      i64toi32_i32$0 = $0 + 16 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $228;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
      HEAP32[$0 >> 2] = 1;
      i64toi32_i32$3 = $6$hi;
      i64toi32_i32$0 = $0 + 8 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $6;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
      break label$1;
     }
     core__fmt__ArgumentV1__new__h021aa801e74cb4b6($2 + 32 | 0 | 0, $2 + 40 | 0 | 0, 20 | 0);
     HEAP32[($2 + 140 | 0) >> 2] = 1;
     i64toi32_i32$0 = $2;
     i64toi32_i32$3 = 0;
     HEAP32[($2 + 124 | 0) >> 2] = 2;
     HEAP32[($2 + 128 | 0) >> 2] = i64toi32_i32$3;
     HEAP32[($2 + 120 | 0) >> 2] = 1056904;
     i64toi32_i32$2 = $2;
     i64toi32_i32$3 = HEAP32[($2 + 32 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 36 | 0) >> 2] | 0;
     $243 = i64toi32_i32$3;
     i64toi32_i32$3 = $2;
     HEAP32[($2 + 192 | 0) >> 2] = $243;
     HEAP32[($2 + 196 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($2 + 136 | 0) >> 2] = $2 + 192 | 0;
     alloc__fmt__format__h6e9e003a52c07309($2 + 176 | 0 | 0, $2 + 120 | 0 | 0);
     $40 = $2 + 75 | 0;
     $41 = HEAP32[(($2 + 176 | 0) + 8 | 0) >> 2] | 0;
     HEAP8[$40 >> 0] = $41;
     HEAP8[($40 + 1 | 0) >> 0] = $41 >>> 8 | 0;
     HEAP8[($40 + 2 | 0) >> 0] = $41 >>> 16 | 0;
     HEAP8[($40 + 3 | 0) >> 0] = $41 >>> 24 | 0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[($2 + 176 | 0) >> 2] | 0;
     i64toi32_i32$3 = HEAP32[($2 + 180 | 0) >> 2] | 0;
     $259 = i64toi32_i32$0;
     i64toi32_i32$0 = $2;
     $42 = $259;
     HEAP8[($2 + 67 | 0) >> 0] = $42;
     HEAP8[($2 + 68 | 0) >> 0] = $42 >>> 8 | 0;
     HEAP8[($2 + 69 | 0) >> 0] = $42 >>> 16 | 0;
     HEAP8[($2 + 70 | 0) >> 0] = $42 >>> 24 | 0;
     HEAP8[($2 + 71 | 0) >> 0] = i64toi32_i32$3;
     HEAP8[($2 + 72 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
     HEAP8[($2 + 73 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
     HEAP8[($2 + 74 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
     HEAP8[($0 + 8 | 0) >> 0] = 18;
     i64toi32_i32$2 = $2;
     i64toi32_i32$3 = HEAPU8[($2 + 64 | 0) >> 0] | 0 | ((HEAPU8[($2 + 65 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 66 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 67 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[($2 + 68 | 0) >> 0] | 0 | ((HEAPU8[($2 + 69 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 70 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 71 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $265 = i64toi32_i32$3;
     i64toi32_i32$3 = $0 + 9 | 0;
     $43 = $265;
     HEAP8[i64toi32_i32$3 >> 0] = $43;
     HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $43 >>> 8 | 0;
     HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $43 >>> 16 | 0;
     HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $43 >>> 24 | 0;
     HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$0;
     HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
     HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
     HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
     i64toi32_i32$2 = $2 + 71 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$3 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $270 = i64toi32_i32$0;
     i64toi32_i32$0 = $0 + 16 | 0;
     $44 = $270;
     HEAP8[i64toi32_i32$0 >> 0] = $44;
     HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $44 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $44 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $44 >>> 24 | 0;
     HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$3;
     HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
     HEAP32[$0 >> 2] = 1;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, memcpy($2 + 64 | 0 | 4 | 0 | 0, ($2 + 120 | 0) + 8 | 0 | 0, 40 | 0) | 0 | 0, 40 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    break label$1;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 48 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 48 | 0 | 0);
  }
  global$0 = $2 + 208 | 0;
 }
 
 function $cardano_serialization_lib__plutus__CostModel_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hfd012f99d93cadfd($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$4 = 0, $7 = 0, $8 = 0, $8$hi = 0, $9 = 0, $4 = 0, $9$hi = 0, $3 = 0, $5 = 0, $6 = 0, $10 = 0, $10$hi = 0, $34 = 0, $35 = 0, $36 = 0, $37 = 0, $39 = 0, $38 = 0, $44 = 0, $48 = 0, $134 = 0, $140 = 0, $144 = 0, $160 = 0, $166 = 0, $175 = 0, $179 = 0, $216 = 0, $220 = 0, $226 = 0, $232 = 0, $260 = 0;
  $2 = global$0 - 304 | 0;
  global$0 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 12 | 0) >> 2] = 0;
  HEAP32[($2 + 16 | 0) >> 2] = i64toi32_i32$0;
  $3 = 0;
  HEAP32[($2 + 8 | 0) >> 2] = HEAP32[(0 + 1070736 | 0) >> 2] | 0;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 232 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = ($2 + 232 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 240 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 244 | 0) >> 2] | 0;
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           i64toi32_i32$2 = $2;
           i64toi32_i32$0 = HEAP32[($2 + 232 | 0) >> 2] | 0;
           i64toi32_i32$1 = HEAP32[($2 + 236 | 0) >> 2] | 0;
           i64toi32_i32$2 = i64toi32_i32$0;
           i64toi32_i32$0 = 0;
           i64toi32_i32$3 = 1;
           if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
            break label$9
           }
           i64toi32_i32$2 = $8$hi;
           $4 = $8;
           $5 = 166;
           $6 = 12;
           i64toi32_i32$2 = $9$hi;
           i64toi32_i32$3 = $9;
           i64toi32_i32$1 = 0;
           i64toi32_i32$0 = 1;
           if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
            break label$8
           }
           if ($4) {
            break label$8
           }
           $4 = 166;
           $7 = 0;
           break label$4;
          }
          i64toi32_i32$0 = $2 + 264 | 0;
          i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
          i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
          $38 = i64toi32_i32$3;
          i64toi32_i32$3 = $2 + 176 | 0;
          HEAP32[i64toi32_i32$3 >> 2] = $38;
          HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
          i64toi32_i32$0 = $2 + 272 | 0;
          i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
          i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
          $44 = i64toi32_i32$2;
          i64toi32_i32$2 = ($2 + 168 | 0) + 16 | 0;
          HEAP32[i64toi32_i32$2 >> 2] = $44;
          HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
          i64toi32_i32$0 = $2 + 256 | 0;
          i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
          i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
          $48 = i64toi32_i32$3;
          i64toi32_i32$3 = $2;
          HEAP32[($2 + 168 | 0) >> 2] = $48;
          HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$2;
          i64toi32_i32$2 = $9$hi;
          i64toi32_i32$0 = $9;
          i64toi32_i32$3 = 0;
          i64toi32_i32$1 = 32;
          i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
          if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
           i64toi32_i32$3 = 0;
           $34 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
          } else {
           i64toi32_i32$3 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
           $34 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
          }
          $7 = $34;
          i64toi32_i32$3 = $9$hi;
          $4 = $9;
          $5 = 166;
          break label$7;
         }
         label$10 : {
          label$11 : {
           label$12 : while (1) {
            std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 | 0, $1 | 0);
            label$13 : {
             if (HEAP32[($2 + 4 | 0) >> 2] | 0) {
              break label$13
             }
             i64toi32_i32$3 = 0;
             $8 = 0;
             $8$hi = i64toi32_i32$3;
             $3 = 0;
             $4 = 8;
             $6 = 2;
             $7 = 0;
             break label$4;
            }
            label$14 : {
             if ((($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[$2 >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) == (7 | 0)) {
              break label$14
             }
             $cardano_serialization_lib__utils__Int_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h5b6b41ff800f0b26($2 + 232 | 0 | 0, $1 | 0);
             i64toi32_i32$2 = ($2 + 232 | 0) + 16 | 0;
             i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
             i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
             $10 = i64toi32_i32$3;
             $10$hi = i64toi32_i32$0;
             i64toi32_i32$2 = $2;
             i64toi32_i32$0 = HEAP32[($2 + 240 | 0) >> 2] | 0;
             i64toi32_i32$3 = HEAP32[($2 + 244 | 0) >> 2] | 0;
             $8 = i64toi32_i32$0;
             $8$hi = i64toi32_i32$3;
             i64toi32_i32$2 = $2;
             i64toi32_i32$3 = HEAP32[($2 + 232 | 0) >> 2] | 0;
             i64toi32_i32$0 = HEAP32[($2 + 236 | 0) >> 2] | 0;
             i64toi32_i32$2 = i64toi32_i32$3;
             i64toi32_i32$3 = 0;
             i64toi32_i32$1 = 1;
             if ((i64toi32_i32$2 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) | 0) {
              break label$5
             }
             label$15 : {
              $7 = HEAP32[($2 + 16 | 0) >> 2] | 0;
              if ((HEAP32[($2 + 12 | 0) >> 2] | 0 | 0) != ($7 | 0)) {
               break label$15
              }
              alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h3bf5a6cd2f3fdf29($2 + 8 | 0 | 0, $7 | 0, 1 | 0);
              $7 = HEAP32[($2 + 16 | 0) >> 2] | 0;
             }
             $3 = (HEAP32[($2 + 8 | 0) >> 2] | 0) + ($7 << 4 | 0) | 0;
             i64toi32_i32$2 = $10$hi;
             i64toi32_i32$0 = $3;
             HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $10;
             HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
             i64toi32_i32$2 = $8$hi;
             HEAP32[i64toi32_i32$0 >> 2] = $8;
             HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
             $7 = $7 + 1 | 0;
             HEAP32[($2 + 16 | 0) >> 2] = $7;
             i64toi32_i32$2 = $9$hi;
             i64toi32_i32$1 = $9;
             i64toi32_i32$0 = 0;
             i64toi32_i32$3 = 1;
             if ((i64toi32_i32$1 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$0 | 0) | 0) {
              continue label$12
             }
             if ($7 >>> 0 < $4 >>> 0) {
              continue label$12
             }
             break label$11;
            }
            break label$12;
           };
           cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 232 | 0 | 0, $1 | 0);
           i64toi32_i32$3 = ($2 + 232 | 0) + 16 | 0;
           i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
           i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
           $8 = i64toi32_i32$1;
           $8$hi = i64toi32_i32$2;
           i64toi32_i32$3 = $2;
           i64toi32_i32$2 = HEAP32[($2 + 240 | 0) >> 2] | 0;
           i64toi32_i32$1 = HEAP32[($2 + 244 | 0) >> 2] | 0;
           $9 = i64toi32_i32$2;
           $9$hi = i64toi32_i32$1;
           i64toi32_i32$3 = $2;
           i64toi32_i32$1 = HEAP32[($2 + 232 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($2 + 236 | 0) >> 2] | 0;
           i64toi32_i32$3 = i64toi32_i32$1;
           i64toi32_i32$1 = 0;
           i64toi32_i32$0 = 1;
           if ((i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$1 | 0) | 0) {
            break label$10
           }
           i64toi32_i32$3 = $8$hi;
           i64toi32_i32$2 = $2 + 200 | 0;
           HEAP32[i64toi32_i32$2 >> 2] = $8;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
           i64toi32_i32$3 = $9$hi;
           i64toi32_i32$2 = $2;
           HEAP32[($2 + 192 | 0) >> 2] = $9;
           HEAP32[($2 + 196 | 0) >> 2] = i64toi32_i32$3;
           if (($9 & 255 | 0 | 0) != (5 | 0)) {
            break label$6
           }
           $7 = HEAP32[($2 + 16 | 0) >> 2] | 0;
          }
          $5 = 166;
          if (($7 | 0) == (166 | 0)) {
           break label$3
          }
          $3 = 0;
          $4 = 166;
          break label$4;
         }
         i64toi32_i32$0 = $2 + 264 | 0;
         i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
         $134 = i64toi32_i32$3;
         i64toi32_i32$3 = $2 + 176 | 0;
         HEAP32[i64toi32_i32$3 >> 2] = $134;
         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
         i64toi32_i32$0 = $2 + 272 | 0;
         i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
         $140 = i64toi32_i32$2;
         i64toi32_i32$2 = ($2 + 168 | 0) + 16 | 0;
         HEAP32[i64toi32_i32$2 >> 2] = $140;
         HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
         i64toi32_i32$0 = $2 + 256 | 0;
         i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
         $144 = i64toi32_i32$3;
         i64toi32_i32$3 = $2;
         HEAP32[($2 + 168 | 0) >> 2] = $144;
         HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$2;
         i64toi32_i32$2 = $9$hi;
         i64toi32_i32$0 = $9;
         i64toi32_i32$3 = 0;
         i64toi32_i32$1 = 32;
         i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
          i64toi32_i32$3 = 0;
          $35 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
         } else {
          i64toi32_i32$3 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
          $35 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
         }
         $7 = $35;
         i64toi32_i32$3 = $9$hi;
         $4 = $9;
        }
        $3 = 0;
        $6 = 2;
        break label$4;
       }
       HEAP32[($2 + 232 | 0) >> 2] = 0;
       core__panicking__assert_failed__h96d8431cc974b591(0 | 0, $2 + 192 | 0 | 0, 1070752 | 0, $2 + 232 | 0 | 0, 1070836 | 0);
       abort();
      }
      i64toi32_i32$2 = $2 + 272 | 0;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $160 = i64toi32_i32$3;
      i64toi32_i32$3 = ($2 + 168 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$3 >> 2] = $160;
      HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $2 + 280 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $166 = i64toi32_i32$0;
      i64toi32_i32$0 = ($2 + 168 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $166;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
      HEAP32[(($2 + 152 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 300 | 0) >> 2] | 0;
      i64toi32_i32$2 = $2;
      i64toi32_i32$3 = HEAP32[($2 + 292 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($2 + 296 | 0) >> 2] | 0;
      $175 = i64toi32_i32$3;
      i64toi32_i32$3 = $2;
      HEAP32[($2 + 152 | 0) >> 2] = $175;
      HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $2 + 264 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $179 = i64toi32_i32$0;
      i64toi32_i32$0 = $2;
      HEAP32[($2 + 168 | 0) >> 2] = $179;
      HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$3;
      i64toi32_i32$3 = $8$hi;
      $6 = $8;
      if (($8 & 255 | 0 | 0) == (19 | 0)) {
       break label$3
      }
      i64toi32_i32$3 = $8$hi;
      i64toi32_i32$2 = $8;
      i64toi32_i32$0 = 0;
      i64toi32_i32$1 = 32;
      i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
       i64toi32_i32$0 = 0;
       $36 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
      } else {
       i64toi32_i32$0 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
       $36 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
      }
      $5 = $36;
      i64toi32_i32$0 = $8$hi;
      i64toi32_i32$3 = $8;
      i64toi32_i32$2 = 0;
      i64toi32_i32$1 = 8;
      i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
       i64toi32_i32$2 = 0;
       $37 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
      } else {
       i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       $37 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$4 | 0) | 0;
      }
      $1 = $37;
      i64toi32_i32$2 = $10$hi;
      i64toi32_i32$0 = $10;
      i64toi32_i32$3 = 0;
      i64toi32_i32$1 = 32;
      i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
       i64toi32_i32$3 = 0;
       $39 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
      } else {
       i64toi32_i32$3 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
       $39 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
      }
      $7 = $39;
      i64toi32_i32$2 = $2 + 256 | 0;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $8 = i64toi32_i32$3;
      $8$hi = i64toi32_i32$0;
      $3 = HEAP32[($2 + 288 | 0) >> 2] | 0;
      i64toi32_i32$0 = $10$hi;
      $4 = $10;
     }
     i64toi32_i32$0 = $8$hi;
     i64toi32_i32$3 = ($2 + 232 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $8;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($2 + 244 | 0) >> 2] = $7;
     HEAP32[(($2 + 232 | 0) + 8 | 0) >> 2] = $4;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[($2 + 168 | 0) >> 2] | 0;
     i64toi32_i32$3 = HEAP32[($2 + 172 | 0) >> 2] | 0;
     $216 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 256 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $216;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$2 = $2;
     i64toi32_i32$3 = HEAP32[($2 + 152 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 156 | 0) >> 2] | 0;
     $220 = i64toi32_i32$3;
     i64toi32_i32$3 = $2 + 284 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $220;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = ($2 + 168 | 0) + 8 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $226 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 264 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $226;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$2 = ($2 + 168 | 0) + 16 | 0;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $232 = i64toi32_i32$3;
     i64toi32_i32$3 = $2 + 272 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $232;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($2 + 292 | 0) >> 2] = HEAP32[(($2 + 152 | 0) + 8 | 0) >> 2] | 0;
     HEAP32[($2 + 236 | 0) >> 2] = $5;
     HEAP8[($2 + 232 | 0) >> 0] = $6;
     HEAP32[($2 + 280 | 0) >> 2] = $3;
     HEAP8[($2 + 233 | 0) >> 0] = $1;
     HEAP8[($2 + 234 | 0) >> 0] = $1 >>> 8 | 0;
     HEAP8[($2 + 235 | 0) >> 0] = $1 >>> 16 | 0;
     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($2 + 88 | 0 | 0, $2 + 232 | 0 | 0, 1070852 | 0, 9 | 0);
     $7 = HEAPU8[($2 + 88 | 0) >> 0] | 0;
     if (($7 | 0) != (19 | 0)) {
      break label$2
     }
    }
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $260 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $260;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$3;
    HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
    $1 = 0;
    break label$1;
   }
   $1 = 1;
   memcpy($2 + 25 | 0 | 0, $2 + 88 | 0 | 1 | 0 | 0, 63 | 0) | 0;
   HEAP8[($0 + 8 | 0) >> 0] = $7;
   memcpy($0 + 9 | 0 | 0, $2 + 25 | 0 | 0, 63 | 0) | 0;
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hebed8fd85cb76c41($2 + 8 | 0 | 0);
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 304 | 0;
 }
 
 function ed25519_bip32__derivation__private__h3590740e7b55683f($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, $5 = 0, $6 = 0, $22 = 0, $29 = 0, $36 = 0, $39 = 0, $51 = 0, $56 = 0, $61 = 0, $64 = 0, $146 = 0, $153 = 0, $160 = 0, $163 = 0, $176 = 0, $181 = 0, $186 = 0, $189 = 0;
  $3 = global$0 - 1072 | 0;
  global$0 = $3;
  core__array___impl_20core__convert__TryFrom___5bT_5d__20for_20_5bT_3b_20N_5d___try_from__h6b307791003c682f($3 + 328 | 0 | 0, $1 | 0, 32 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ((HEAPU8[($3 + 328 | 0) >> 0] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      $4 = $3 + 353 | 0;
      i64toi32_i32$2 = $4;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $22 = i64toi32_i32$0;
      i64toi32_i32$0 = ($3 + 8 | 0) + 24 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $22;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      $5 = $3 + 345 | 0;
      i64toi32_i32$2 = $5;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $29 = i64toi32_i32$1;
      i64toi32_i32$1 = ($3 + 8 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $29;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      $6 = $3 + 337 | 0;
      i64toi32_i32$2 = $6;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $36 = i64toi32_i32$0;
      i64toi32_i32$0 = ($3 + 8 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $36;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $3;
      i64toi32_i32$1 = HEAPU8[($3 + 329 | 0) >> 0] | 0 | ((HEAPU8[($3 + 330 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 331 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 332 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[($3 + 333 | 0) >> 0] | 0 | ((HEAPU8[($3 + 334 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 335 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 336 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $39 = i64toi32_i32$1;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 8 | 0) >> 2] = $39;
      HEAP32[($3 + 12 | 0) >> 2] = i64toi32_i32$0;
      core__array___impl_20core__convert__TryFrom___5bT_5d__20for_20_5bT_3b_20N_5d___try_from__h6b307791003c682f($3 + 328 | 0 | 0, $1 + 32 | 0 | 0, 32 | 0);
      if ((HEAPU8[($3 + 328 | 0) >> 0] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      i64toi32_i32$2 = $4;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $51 = i64toi32_i32$0;
      i64toi32_i32$0 = ($3 + 40 | 0) + 24 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $51;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $5;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $56 = i64toi32_i32$1;
      i64toi32_i32$1 = ($3 + 40 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $56;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $6;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $61 = i64toi32_i32$0;
      i64toi32_i32$0 = ($3 + 40 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $61;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $3;
      i64toi32_i32$1 = HEAPU8[($3 + 329 | 0) >> 0] | 0 | ((HEAPU8[($3 + 330 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 331 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 332 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[($3 + 333 | 0) >> 0] | 0 | ((HEAPU8[($3 + 334 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 335 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 336 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $64 = i64toi32_i32$1;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 40 | 0) >> 2] = $64;
      HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$0;
      cryptoxide__sha2__Sha512__new__h57eb1a61fae5dfc3($3 + 328 | 0 | 0);
      $4 = $1 + 64 | 0;
      cryptoxide__hmac__Hmac_D___new__h10c18a5661f5ecf6($3 + 72 | 0 | 0, $3 + 328 | 0 | 0, $4 | 0, 32 | 0);
      cryptoxide__sha2__Sha512__new__h57eb1a61fae5dfc3($3 + 584 | 0 | 0);
      cryptoxide__hmac__Hmac_D___new__h10c18a5661f5ecf6($3 + 328 | 0 | 0, $3 + 584 | 0 | 0, $4 | 0, 32 | 0);
      HEAP32[($3 + 812 | 0) >> 2] = $2;
      label$5 : {
       label$6 : {
        if (($2 | 0) < (0 | 0)) {
         break label$6
        }
        cryptoxide__ed25519__extended_to_public__hb7e9895dfbf0ff6d($3 + 584 | 0 | 0, $1 | 0);
        $cryptoxide__hmac__Hmac_D__20as_20cryptoxide__mac__Mac___input__h8428084cca8543c2($3 + 72 | 0 | 0, 1101454 | 0, 1 | 0);
        $cryptoxide__hmac__Hmac_D__20as_20cryptoxide__mac__Mac___input__h8428084cca8543c2($3 + 72 | 0 | 0, $3 + 584 | 0 | 0, 32 | 0);
        $cryptoxide__hmac__Hmac_D__20as_20cryptoxide__mac__Mac___input__h8428084cca8543c2($3 + 72 | 0 | 0, $3 + 812 | 0 | 0, 4 | 0);
        $cryptoxide__hmac__Hmac_D__20as_20cryptoxide__mac__Mac___input__h8428084cca8543c2($3 + 328 | 0 | 0, 1101455 | 0, 1 | 0);
        $cryptoxide__hmac__Hmac_D__20as_20cryptoxide__mac__Mac___input__h8428084cca8543c2($3 + 328 | 0 | 0, $3 + 584 | 0 | 0, 32 | 0);
        $cryptoxide__hmac__Hmac_D__20as_20cryptoxide__mac__Mac___input__h8428084cca8543c2($3 + 328 | 0 | 0, $3 + 812 | 0 | 0, 4 | 0);
        break label$5;
       }
       $cryptoxide__hmac__Hmac_D__20as_20cryptoxide__mac__Mac___input__h8428084cca8543c2($3 + 72 | 0 | 0, 1101452 | 0, 1 | 0);
       $cryptoxide__hmac__Hmac_D__20as_20cryptoxide__mac__Mac___input__h8428084cca8543c2($3 + 72 | 0 | 0, $1 | 0, 64 | 0);
       $cryptoxide__hmac__Hmac_D__20as_20cryptoxide__mac__Mac___input__h8428084cca8543c2($3 + 72 | 0 | 0, $3 + 812 | 0 | 0, 4 | 0);
       $cryptoxide__hmac__Hmac_D__20as_20cryptoxide__mac__Mac___input__h8428084cca8543c2($3 + 328 | 0 | 0, 1101453 | 0, 1 | 0);
       $cryptoxide__hmac__Hmac_D__20as_20cryptoxide__mac__Mac___input__h8428084cca8543c2($3 + 328 | 0 | 0, $1 | 0, 64 | 0);
       $cryptoxide__hmac__Hmac_D__20as_20cryptoxide__mac__Mac___input__h8428084cca8543c2($3 + 328 | 0 | 0, $3 + 812 | 0 | 0, 4 | 0);
      }
      memset($3 + 816 | 0 | 0, 0 | 0, 64 | 0) | 0;
      $cryptoxide__hmac__Hmac_D__20as_20cryptoxide__mac__Mac___raw_result__hac4d52a01c11d996($3 + 72 | 0 | 0, $3 + 816 | 0 | 0, 64 | 0);
      core__array___impl_20core__convert__TryFrom___5bT_5d__20for_20_5bT_3b_20N_5d___try_from__h6b307791003c682f($3 + 584 | 0 | 0, $3 + 816 | 0 | 0, 32 | 0);
      if ((HEAPU8[($3 + 584 | 0) >> 0] | 0 | 0) == (1 | 0)) {
       break label$2
      }
      $1 = $3 + 609 | 0;
      i64toi32_i32$2 = $1;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $146 = i64toi32_i32$0;
      i64toi32_i32$0 = ($3 + 880 | 0) + 24 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $146;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      $2 = $3 + 601 | 0;
      i64toi32_i32$2 = $2;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $153 = i64toi32_i32$1;
      i64toi32_i32$1 = ($3 + 880 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $153;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      $4 = $3 + 593 | 0;
      i64toi32_i32$2 = $4;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $160 = i64toi32_i32$0;
      i64toi32_i32$0 = ($3 + 880 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $160;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $3;
      i64toi32_i32$1 = HEAPU8[($3 + 585 | 0) >> 0] | 0 | ((HEAPU8[($3 + 586 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 587 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 588 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[($3 + 589 | 0) >> 0] | 0 | ((HEAPU8[($3 + 590 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 591 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 592 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $163 = i64toi32_i32$1;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 880 | 0) >> 2] = $163;
      HEAP32[($3 + 884 | 0) >> 2] = i64toi32_i32$0;
      core__array___impl_20core__convert__TryFrom___5bT_5d__20for_20_5bT_3b_20N_5d___try_from__h6b307791003c682f($3 + 584 | 0 | 0, ($3 + 816 | 0) + 32 | 0 | 0, 32 | 0);
      if ((HEAPU8[($3 + 584 | 0) >> 0] | 0 | 0) == (1 | 0)) {
       break label$1
      }
      i64toi32_i32$2 = $1;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $176 = i64toi32_i32$0;
      i64toi32_i32$0 = ($3 + 912 | 0) + 24 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $176;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $2;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $181 = i64toi32_i32$1;
      i64toi32_i32$1 = ($3 + 912 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $181;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $4;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $186 = i64toi32_i32$0;
      i64toi32_i32$0 = ($3 + 912 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $186;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $3;
      i64toi32_i32$1 = HEAPU8[($3 + 585 | 0) >> 0] | 0 | ((HEAPU8[($3 + 586 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 587 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 588 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[($3 + 589 | 0) >> 0] | 0 | ((HEAPU8[($3 + 590 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 591 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 592 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $189 = i64toi32_i32$1;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 912 | 0) >> 2] = $189;
      HEAP32[($3 + 916 | 0) >> 2] = i64toi32_i32$0;
      ed25519_bip32__derivation__v2__add_28_mul8_v2__hbec4c73081377038($3 + 944 | 0 | 0, $3 + 8 | 0 | 0, $3 + 880 | 0 | 0);
      i64toi32_i32$1 = ($3 + 976 | 0) + 24 | 0;
      i64toi32_i32$0 = 0;
      HEAP32[i64toi32_i32$1 >> 2] = 0;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$1 = ($3 + 976 | 0) + 16 | 0;
      i64toi32_i32$0 = 0;
      HEAP32[i64toi32_i32$1 >> 2] = 0;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$1 = ($3 + 976 | 0) + 8 | 0;
      i64toi32_i32$0 = 0;
      HEAP32[i64toi32_i32$1 >> 2] = 0;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$1 = $3;
      i64toi32_i32$0 = 0;
      HEAP32[($3 + 976 | 0) >> 2] = 0;
      HEAP32[($3 + 980 | 0) >> 2] = i64toi32_i32$0;
      $2 = 0;
      $1 = 0;
      label$7 : while (1) {
       $2 = ($2 + (HEAPU8[(($3 + 40 | 0) + $1 | 0) >> 0] | 0) | 0) + (HEAPU8[(($3 + 912 | 0) + $1 | 0) >> 0] | 0) | 0;
       HEAP8[(($3 + 976 | 0) + $1 | 0) >> 0] = $2;
       $2 = ($2 & 65280 | 0) >>> 8 | 0;
       $1 = $1 + 1 | 0;
       if (($1 | 0) != (32 | 0)) {
        continue label$7
       }
       break label$7;
      };
      memset($3 + 1008 | 0 | 0, 0 | 0, 64 | 0) | 0;
      $cryptoxide__hmac__Hmac_D__20as_20cryptoxide__mac__Mac___raw_result__hac4d52a01c11d996($3 + 328 | 0 | 0, $3 + 1008 | 0 | 0, 64 | 0);
      memset($3 + 584 | 0 | 0, 0 | 0, 96 | 0) | 0;
      ed25519_bip32__key__mk_xprv__h1536372bcc560835($3 + 584 | 0 | 0, $3 + 944 | 0 | 0, 32 | 0, $3 + 976 | 0 | 0, 32 | 0, ($3 + 1008 | 0) + 32 | 0 | 0, 32 | 0);
      $cryptoxide__hmac__Hmac_D__20as_20cryptoxide__mac__Mac___reset__hbf8667f113797205($3 + 328 | 0 | 0);
      $cryptoxide__hmac__Hmac_D__20as_20cryptoxide__mac__Mac___reset__hbf8667f113797205($3 + 72 | 0 | 0);
      memcpy($0 | 0, $3 + 584 | 0 | 0, 96 | 0) | 0;
      core__ptr__drop_in_place_cryptoxide__hmac__Hmac_cryptoxide__sha2__Sha512____hc18b32e73944f3e5($3 + 328 | 0 | 0);
      core__ptr__drop_in_place_cryptoxide__hmac__Hmac_cryptoxide__sha2__Sha512____hc18b32e73944f3e5($3 + 72 | 0 | 0);
      global$0 = $3 + 1072 | 0;
      return;
     }
     core__result__unwrap_failed__h27f43d993c3864a1(1101252 | 0, 43 | 0, $3 + 1008 | 0 | 0, 1101296 | 0, 1101420 | 0);
     abort();
    }
    core__result__unwrap_failed__h27f43d993c3864a1(1101252 | 0, 43 | 0, $3 + 1008 | 0 | 0, 1101296 | 0, 1101436 | 0);
    abort();
   }
   core__result__unwrap_failed__h27f43d993c3864a1(1101252 | 0, 43 | 0, $3 + 1008 | 0 | 0, 1101296 | 0, 1101456 | 0);
   abort();
  }
  core__result__unwrap_failed__h27f43d993c3864a1(1101252 | 0, 43 | 0, $3 + 1008 | 0 | 0, 1101296 | 0, 1101472 | 0);
  abort();
 }
 
 function $str_20as_20core__fmt__Debug___fmt__hc85548718db4c6c4($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, $7 = 0, i64toi32_i32$0 = 0, i64toi32_i32$5 = 0, $16 = 0, $16$hi = 0, $10 = 0, $12 = 0, $13 = 0, $15 = 0, $11 = 0, $14 = 0, i64toi32_i32$4 = 0, $3 = 0, $8 = 0, $4 = 0, $5 = 0, $6 = 0, $9 = 0, $28 = 0, $193 = 0, $193$hi = 0, $195 = 0, $195$hi = 0;
  $3 = 1;
  label$1 : {
   label$2 : {
    $4 = HEAP32[($2 + 24 | 0) >> 2] | 0;
    $5 = HEAP32[($2 + 28 | 0) >> 2] | 0;
    $6 = HEAP32[($5 + 16 | 0) >> 2] | 0;
    if (FUNCTION_TABLE[$6 | 0]($4, 34) | 0) {
     break label$2
    }
    label$3 : {
     label$4 : {
      if ($1) {
       break label$4
      }
      $7 = 0;
      break label$3;
     }
     $8 = $0 + $1 | 0;
     $7 = 0;
     $9 = $0;
     $10 = $0;
     $11 = 0;
     label$5 : {
      label$6 : while (1) {
       $12 = $10 + 1 | 0;
       label$7 : {
        label$8 : {
         label$9 : {
          $2 = HEAP8[$10 >> 0] | 0;
          if (($2 | 0) <= (-1 | 0)) {
           break label$9
          }
          $13 = $2 & 255 | 0;
          break label$8;
         }
         label$10 : {
          label$11 : {
           if (($12 | 0) != ($8 | 0)) {
            break label$11
           }
           $14 = 0;
           $12 = $8;
           break label$10;
          }
          $12 = $10 + 2 | 0;
          $14 = (HEAPU8[($10 + 1 | 0) >> 0] | 0) & 63 | 0;
         }
         $3 = $2 & 31 | 0;
         label$12 : {
          $2 = $2 & 255 | 0;
          if ($2 >>> 0 > 223 >>> 0) {
           break label$12
          }
          $13 = $14 | ($3 << 6 | 0) | 0;
          break label$8;
         }
         label$13 : {
          label$14 : {
           if (($12 | 0) != ($8 | 0)) {
            break label$14
           }
           $10 = 0;
           $15 = $8;
           break label$13;
          }
          $10 = (HEAPU8[$12 >> 0] | 0) & 63 | 0;
          $15 = $12 + 1 | 0;
          $12 = $15;
         }
         $14 = $10 | ($14 << 6 | 0) | 0;
         label$15 : {
          if ($2 >>> 0 >= 240 >>> 0) {
           break label$15
          }
          $13 = $14 | ($3 << 12 | 0) | 0;
          $10 = $12;
          $12 = $15;
          break label$7;
         }
         label$16 : {
          label$17 : {
           if (($15 | 0) != ($8 | 0)) {
            break label$17
           }
           $2 = 0;
           $10 = $12;
           $12 = $15;
           break label$16;
          }
          $2 = (HEAPU8[$15 >> 0] | 0) & 63 | 0;
          $10 = $15 + 1 | 0;
          $12 = $10;
         }
         $13 = $14 << 6 | 0 | (($3 << 18 | 0) & 1835008 | 0) | 0 | $2 | 0;
         if (($13 | 0) != (1114112 | 0)) {
          break label$7
         }
         break label$5;
        }
        $10 = $12;
       }
       $15 = 116;
       $2 = 2;
       label$18 : {
        label$19 : {
         label$20 : {
          label$21 : {
           label$22 : {
            label$23 : {
             switch ($13 + -9 | 0 | 0) {
             default:
              if (($13 | 0) == (92 | 0)) {
               break label$22
              }
             case 2:
             case 3:
             case 5:
             case 6:
             case 7:
             case 8:
             case 9:
             case 10:
             case 11:
             case 12:
             case 13:
             case 14:
             case 15:
             case 16:
             case 17:
             case 18:
             case 19:
             case 20:
             case 21:
             case 22:
             case 23:
             case 24:
              label$27 : {
               if (core__unicode__unicode_data__grapheme_extend__lookup__hff46536597365d27($13 | 0) | 0) {
                break label$27
               }
               if (core__unicode__printable__is_printable__h052c3c4a29b5e66a($13 | 0) | 0) {
                break label$19
               }
              }
              i64toi32_i32$0 = 0;
              i64toi32_i32$2 = (Math_clz32($13 | 1 | 0) >>> 2 | 0) ^ 7 | 0;
              i64toi32_i32$1 = 5;
              i64toi32_i32$3 = 0;
              i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
              $16 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
              $16$hi = i64toi32_i32$1;
              $2 = 3;
              $15 = $13;
              break label$20;
             case 4:
              $15 = 114;
              break label$21;
             case 0:
              break label$20;
             case 25:
              break label$22;
             case 1:
              break label$23;
             };
            }
            $15 = 110;
            break label$21;
           }
           $15 = $13;
          }
         }
         if ($11 >>> 0 < $7 >>> 0) {
          break label$18
         }
         label$28 : {
          if (!$7) {
           break label$28
          }
          label$29 : {
           if ($7 >>> 0 < $1 >>> 0) {
            break label$29
           }
           if (($7 | 0) == ($1 | 0)) {
            break label$28
           }
           break label$18;
          }
          if ((HEAP8[($0 + $7 | 0) >> 0] | 0 | 0) < (-64 | 0)) {
           break label$18
          }
         }
         label$30 : {
          if (!$11) {
           break label$30
          }
          label$31 : {
           if ($11 >>> 0 < $1 >>> 0) {
            break label$31
           }
           if (($11 | 0) != ($1 | 0)) {
            break label$18
           }
           break label$30;
          }
          if ((HEAP8[($0 + $11 | 0) >> 0] | 0 | 0) <= (-65 | 0)) {
           break label$18
          }
         }
         label$32 : {
          if (!(FUNCTION_TABLE[HEAP32[($5 + 12 | 0) >> 2] | 0 | 0]($4, $0 + $7 | 0, $11 - $7 | 0) | 0)) {
           break label$32
          }
          return 1 | 0;
         }
         label$33 : while (1) {
          $14 = $2;
          $3 = 1;
          $7 = 92;
          $2 = 1;
          label$34 : {
           label$35 : {
            label$36 : {
             label$37 : {
              label$38 : {
               switch ($14 | 0) {
               case 3:
                label$40 : {
                 label$41 : {
                  label$42 : {
                   label$43 : {
                    i64toi32_i32$1 = $16$hi;
                    i64toi32_i32$0 = $16;
                    i64toi32_i32$2 = 0;
                    i64toi32_i32$3 = 32;
                    i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
                    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                     i64toi32_i32$2 = 0;
                     $28 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
                    } else {
                     i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
                     $28 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
                    }
                    switch ($28 & 255 | 0 | 0) {
                    case 1:
                     break label$36;
                    case 2:
                     break label$40;
                    case 5:
                     break label$41;
                    case 4:
                     break label$42;
                    case 3:
                     break label$43;
                    default:
                     break label$37;
                    };
                   }
                   i64toi32_i32$2 = $16$hi;
                   i64toi32_i32$1 = $16;
                   i64toi32_i32$0 = -256;
                   i64toi32_i32$3 = -1;
                   i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
                   i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
                   i64toi32_i32$1 = 2;
                   i64toi32_i32$3 = 0;
                   i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
                   $16 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
                   $16$hi = i64toi32_i32$1;
                   $2 = 3;
                   $7 = 123;
                   break label$34;
                  }
                  i64toi32_i32$1 = $16$hi;
                  i64toi32_i32$0 = $16;
                  i64toi32_i32$2 = -256;
                  i64toi32_i32$3 = -1;
                  i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
                  i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
                  i64toi32_i32$0 = 3;
                  i64toi32_i32$3 = 0;
                  i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
                  $16 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
                  $16$hi = i64toi32_i32$0;
                  $2 = 3;
                  $7 = 117;
                  break label$34;
                 }
                 i64toi32_i32$0 = $16$hi;
                 i64toi32_i32$2 = $16;
                 i64toi32_i32$1 = -256;
                 i64toi32_i32$3 = -1;
                 i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
                 i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
                 i64toi32_i32$2 = 4;
                 i64toi32_i32$3 = 0;
                 i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
                 $16 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
                 $16$hi = i64toi32_i32$2;
                 $2 = 3;
                 break label$34;
                }
                i64toi32_i32$2 = $16$hi;
                $2 = $16;
                $7 = ($15 >>> (($2 << 2 | 0) & 28 | 0) | 0) & 15 | 0;
                $7 = ($7 >>> 0 < 10 >>> 0 ? 48 : 87) + $7 | 0;
                if (!$2) {
                 break label$35
                }
                i64toi32_i32$2 = $16$hi;
                i64toi32_i32$1 = $16;
                i64toi32_i32$0 = -1;
                i64toi32_i32$3 = -1;
                i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
                i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
                if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
                 i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
                }
                i64toi32_i32$2 = i64toi32_i32$4;
                i64toi32_i32$1 = 0;
                i64toi32_i32$3 = -1;
                i64toi32_i32$1 = i64toi32_i32$5 & i64toi32_i32$1 | 0;
                $193 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
                $193$hi = i64toi32_i32$1;
                i64toi32_i32$1 = $16$hi;
                i64toi32_i32$5 = $16;
                i64toi32_i32$2 = -1;
                i64toi32_i32$3 = 0;
                i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
                $195 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
                $195$hi = i64toi32_i32$2;
                i64toi32_i32$2 = $193$hi;
                i64toi32_i32$1 = $193;
                i64toi32_i32$5 = $195$hi;
                i64toi32_i32$3 = $195;
                i64toi32_i32$5 = i64toi32_i32$2 | i64toi32_i32$5 | 0;
                $16 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
                $16$hi = i64toi32_i32$5;
                $2 = 3;
                break label$34;
               case 2:
                break label$34;
               case 1:
                break label$38;
               default:
                break label$37;
               };
              }
              $2 = 0;
              $7 = $15;
              break label$34;
             }
             $2 = 1;
             label$44 : {
              if ($13 >>> 0 < 128 >>> 0) {
               break label$44
              }
              $2 = 2;
              if ($13 >>> 0 < 2048 >>> 0) {
               break label$44
              }
              $2 = $13 >>> 0 < 65536 >>> 0 ? 3 : 4;
             }
             $7 = $2 + $11 | 0;
             break label$19;
            }
            i64toi32_i32$5 = $16$hi;
            i64toi32_i32$2 = $16;
            i64toi32_i32$1 = -256;
            i64toi32_i32$3 = -1;
            i64toi32_i32$1 = i64toi32_i32$5 & i64toi32_i32$1 | 0;
            $16 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
            $16$hi = i64toi32_i32$1;
            $2 = 3;
            $7 = 125;
            break label$34;
           }
           i64toi32_i32$1 = $16$hi;
           i64toi32_i32$5 = $16;
           i64toi32_i32$2 = -256;
           i64toi32_i32$3 = -1;
           i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
           i64toi32_i32$1 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
           i64toi32_i32$5 = 1;
           i64toi32_i32$3 = 0;
           i64toi32_i32$5 = i64toi32_i32$2 | i64toi32_i32$5 | 0;
           $16 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
           $16$hi = i64toi32_i32$5;
           $2 = 3;
          }
          if (!(FUNCTION_TABLE[$6 | 0]($4, $7) | 0)) {
           continue label$33
          }
          break label$2;
         };
        }
        $11 = ($11 - $9 | 0) + $12 | 0;
        $9 = $10;
        if (($10 | 0) != ($8 | 0)) {
         continue label$6
        }
        break label$5;
       }
       break label$6;
      };
      core__str__slice_error_fail__h8a7d2e23b7bba52e($0 | 0, $1 | 0, $7 | 0, $11 | 0, 1150588 | 0);
      abort();
     }
     label$45 : {
      if ($7) {
       break label$45
      }
      $7 = 0;
      break label$3;
     }
     label$46 : {
      if ($7 >>> 0 < $1 >>> 0) {
       break label$46
      }
      if (($7 | 0) == ($1 | 0)) {
       break label$3
      }
      break label$1;
     }
     if ((HEAP8[($0 + $7 | 0) >> 0] | 0 | 0) <= (-65 | 0)) {
      break label$1
     }
    }
    $3 = 1;
    if (FUNCTION_TABLE[HEAP32[($5 + 12 | 0) >> 2] | 0 | 0]($4, $0 + $7 | 0, $1 - $7 | 0) | 0) {
     break label$2
    }
    return FUNCTION_TABLE[$6 | 0]($4, 34) | 0 | 0;
   }
   return $3 | 0;
  }
  core__str__slice_error_fail__h8a7d2e23b7bba52e($0 | 0, $1 | 0, $7 | 0, $1 | 0, 1150604 | 0);
  abort();
 }
 
 function core__fmt__float__float_to_decimal_common_shortest__h571c75620c50b577($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = +$1;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $5 = 0, $7 = 0, $6 = 0, $10 = 0, $9 = 0, $10$hi = 0, $8 = 0, $14 = 0, $12 = 0, $12$hi = 0, $14$hi = 0, $11 = 0, $31 = 0, $32 = 0, $13 = 0, $13$hi = 0, $33 = 0, $34 = 0, $35 = 0, $11$hi = 0, $27 = 0, $27$hi = 0, $30 = 0, $30$hi = 0, $54$hi = 0, $129 = 0;
  $4 = global$0 - 128 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    wasm2js_scratch_store_f64(+$1);
    i64toi32_i32$0 = wasm2js_scratch_load_i32(1 | 0) | 0;
    $10 = wasm2js_scratch_load_i32(0 | 0) | 0;
    $10$hi = i64toi32_i32$0;
    i64toi32_i32$2 = $10;
    i64toi32_i32$1 = 2147483647;
    i64toi32_i32$3 = -1;
    i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
    if (!!(i64toi32_i32$2 & i64toi32_i32$3 | 0 | i64toi32_i32$1 | 0)) {
     break label$2
    }
    $5 = 4;
    break label$1;
   }
   i64toi32_i32$1 = $10$hi;
   i64toi32_i32$0 = $10;
   i64toi32_i32$2 = 1048575;
   i64toi32_i32$3 = -1;
   i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
   $11 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
   $11$hi = i64toi32_i32$2;
   i64toi32_i32$1 = $11;
   i64toi32_i32$0 = 1048576;
   i64toi32_i32$3 = 0;
   i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
   $27 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
   $27$hi = i64toi32_i32$0;
   i64toi32_i32$0 = $10$hi;
   i64toi32_i32$2 = $10;
   i64toi32_i32$1 = 0;
   i64toi32_i32$3 = 1;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
    $31 = 0;
   } else {
    i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
    $31 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   }
   i64toi32_i32$0 = $31;
   i64toi32_i32$2 = 2097151;
   i64toi32_i32$3 = -2;
   i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
   $30 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
   $30$hi = i64toi32_i32$2;
   i64toi32_i32$2 = $10$hi;
   i64toi32_i32$1 = $10;
   i64toi32_i32$0 = 0;
   i64toi32_i32$3 = 52;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$0 = 0;
    $32 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   } else {
    i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
    $32 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
   }
   $6 = $32 & 2047 | 0;
   i64toi32_i32$4 = $6;
   i64toi32_i32$0 = $27$hi;
   i64toi32_i32$1 = $30$hi;
   i64toi32_i32$3 = i64toi32_i32$4 ? $27 : $30;
   i64toi32_i32$2 = i64toi32_i32$4 ? i64toi32_i32$0 : i64toi32_i32$1;
   $12 = i64toi32_i32$3;
   $12$hi = i64toi32_i32$2;
   i64toi32_i32$4 = i64toi32_i32$3;
   i64toi32_i32$3 = 0;
   i64toi32_i32$0 = 1;
   i64toi32_i32$3 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
   $13 = i64toi32_i32$4 & i64toi32_i32$0 | 0;
   $13$hi = i64toi32_i32$3;
   label$3 : {
    label$4 : {
     i64toi32_i32$3 = $10$hi;
     i64toi32_i32$2 = $10;
     i64toi32_i32$4 = 2146435072;
     i64toi32_i32$0 = 0;
     i64toi32_i32$4 = i64toi32_i32$3 & i64toi32_i32$4 | 0;
     $14 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
     $14$hi = i64toi32_i32$4;
     if (!($14 | i64toi32_i32$4 | 0)) {
      break label$4
     }
     i64toi32_i32$4 = $14$hi;
     i64toi32_i32$3 = $14;
     i64toi32_i32$2 = 2146435072;
     i64toi32_i32$0 = 0;
     if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$4 | 0) != (i64toi32_i32$2 | 0) | 0) {
      break label$3
     }
     i64toi32_i32$3 = $11$hi;
     $5 = !($11 | i64toi32_i32$3 | 0) ? 3 : 2;
     break label$1;
    }
    $6 = $6 + -1075 | 0;
    i64toi32_i32$3 = $13$hi;
    $5 = $13 ^ 1 | 0;
    i64toi32_i32$3 = 0;
    $14 = 1;
    $14$hi = i64toi32_i32$3;
    break label$1;
   }
   i64toi32_i32$3 = $12$hi;
   i64toi32_i32$0 = $12;
   i64toi32_i32$4 = 0;
   i64toi32_i32$2 = 1;
   i64toi32_i32$1 = i64toi32_i32$2 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
    i64toi32_i32$4 = i64toi32_i32$0 << i64toi32_i32$1 | 0;
    $33 = 0;
   } else {
    i64toi32_i32$4 = ((1 << i64toi32_i32$1 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$1 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$1 | 0) | 0;
    $33 = i64toi32_i32$0 << i64toi32_i32$1 | 0;
   }
   $54$hi = i64toi32_i32$4;
   i64toi32_i32$4 = $12$hi;
   i64toi32_i32$3 = $12;
   i64toi32_i32$0 = 1048576;
   i64toi32_i32$2 = 0;
   $7 = (i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$4 | 0) == (i64toi32_i32$0 | 0) | 0;
   i64toi32_i32$1 = $7;
   i64toi32_i32$3 = 4194304;
   i64toi32_i32$4 = $54$hi;
   i64toi32_i32$0 = i64toi32_i32$1 ? 0 : $33;
   i64toi32_i32$2 = i64toi32_i32$1 ? i64toi32_i32$3 : i64toi32_i32$4;
   $12 = i64toi32_i32$0;
   $12$hi = i64toi32_i32$2;
   i64toi32_i32$4 = i64toi32_i32$1;
   i64toi32_i32$2 = 0;
   i64toi32_i32$0 = 0;
   i64toi32_i32$3 = i64toi32_i32$4 ? 2 : 1;
   i64toi32_i32$1 = i64toi32_i32$4 ? i64toi32_i32$2 : i64toi32_i32$0;
   $14 = i64toi32_i32$3;
   $14$hi = i64toi32_i32$1;
   i64toi32_i32$1 = $13$hi;
   $5 = $13 ^ 1 | 0;
   $6 = (i64toi32_i32$4 ? -1077 : -1076) + $6 | 0;
  }
  HEAP16[($4 + 120 | 0) >> 1] = $6;
  i64toi32_i32$1 = $14$hi;
  i64toi32_i32$3 = $4;
  HEAP32[($4 + 112 | 0) >> 2] = $14;
  HEAP32[($4 + 116 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$3 = $4;
  i64toi32_i32$1 = 0;
  HEAP32[($4 + 104 | 0) >> 2] = 1;
  HEAP32[($4 + 108 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$3 = $4;
  HEAP32[($4 + 96 | 0) >> 2] = $12;
  HEAP32[($4 + 100 | 0) >> 2] = i64toi32_i32$1;
  HEAP8[($4 + 122 | 0) >> 0] = $5;
  label$5 : {
   label$6 : {
    if (($5 | 0) != (2 | 0)) {
     break label$6
    }
    $6 = 1149204;
    $2 = 0;
    break label$5;
   }
   i64toi32_i32$1 = $10$hi;
   i64toi32_i32$4 = $10;
   i64toi32_i32$3 = 0;
   i64toi32_i32$2 = 56;
   i64toi32_i32$0 = i64toi32_i32$2 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
    i64toi32_i32$3 = 0;
    $34 = i64toi32_i32$1 >>> i64toi32_i32$0 | 0;
   } else {
    i64toi32_i32$3 = i64toi32_i32$1 >>> i64toi32_i32$0 | 0;
    $34 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$0 | 0) | 0;
   }
   i64toi32_i32$1 = $34;
   i64toi32_i32$4 = 0;
   i64toi32_i32$2 = 128;
   i64toi32_i32$4 = i64toi32_i32$3 & i64toi32_i32$4 | 0;
   $10 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
   $10$hi = i64toi32_i32$4;
   label$7 : {
    if ($2) {
     break label$7
    }
    i64toi32_i32$4 = $10$hi;
    $6 = !($10 | i64toi32_i32$4 | 0) ? 1149204 : 1149199;
    i64toi32_i32$3 = $10;
    i64toi32_i32$1 = 0;
    i64toi32_i32$2 = 7;
    i64toi32_i32$0 = i64toi32_i32$2 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
     i64toi32_i32$1 = 0;
     $35 = i64toi32_i32$4 >>> i64toi32_i32$0 | 0;
    } else {
     i64toi32_i32$1 = i64toi32_i32$4 >>> i64toi32_i32$0 | 0;
     $35 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$0 | 0) | 0;
    }
    $2 = $35;
    break label$5;
   }
   i64toi32_i32$1 = $10$hi;
   $6 = !($10 | i64toi32_i32$1 | 0) ? 1149200 : 1149199;
   $2 = 1;
  }
  label$8 : {
   label$9 : {
    label$10 : {
     label$11 : {
      label$12 : {
       label$13 : {
        label$14 : {
         label$15 : {
          label$16 : {
           label$17 : {
            $5 = $5 + -2 | 0;
            switch ((($5 & 255 | 0) >>> 0 < 3 >>> 0 ? $5 : 3) & 255 | 0 | 0) {
            case 2:
             break label$14;
            case 3:
             break label$15;
            case 1:
             break label$16;
            default:
             break label$17;
            };
           }
           HEAP32[($4 + 40 | 0) >> 2] = 3;
           HEAP32[($4 + 36 | 0) >> 2] = 1149208;
           HEAP16[($4 + 32 | 0) >> 1] = 2;
           break label$9;
          }
          HEAP32[($4 + 40 | 0) >> 2] = 3;
          HEAP32[($4 + 36 | 0) >> 2] = 1149205;
          HEAP16[($4 + 32 | 0) >> 1] = 2;
          break label$9;
         }
         core__num__flt2dec__strategy__grisu__format_shortest_opt__h11bf281506e98a2a($4 + 32 | 0 | 0, $4 + 96 | 0 | 0, $4 + 15 | 0 | 0, 17 | 0);
         label$18 : {
          label$19 : {
           if (HEAP32[($4 + 32 | 0) >> 2] | 0) {
            break label$19
           }
           core__num__flt2dec__strategy__dragon__format_shortest__he1c6aa82e117523b($4 + 80 | 0 | 0, $4 + 96 | 0 | 0, $4 + 15 | 0 | 0, 17 | 0);
           break label$18;
          }
          HEAP32[(($4 + 80 | 0) + 8 | 0) >> 2] = HEAP32[(($4 + 32 | 0) + 8 | 0) >> 2] | 0;
          i64toi32_i32$4 = $4;
          i64toi32_i32$1 = HEAP32[($4 + 32 | 0) >> 2] | 0;
          i64toi32_i32$3 = HEAP32[($4 + 36 | 0) >> 2] | 0;
          $129 = i64toi32_i32$1;
          i64toi32_i32$1 = $4;
          HEAP32[($4 + 80 | 0) >> 2] = $129;
          HEAP32[($4 + 84 | 0) >> 2] = i64toi32_i32$3;
         }
         $7 = HEAP32[($4 + 84 | 0) >> 2] | 0;
         if (!$7) {
          break label$13
         }
         $8 = HEAP32[($4 + 80 | 0) >> 2] | 0;
         if ((HEAPU8[$8 >> 0] | 0) >>> 0 < 49 >>> 0) {
          break label$12
         }
         label$20 : {
          label$21 : {
           $9 = HEAP16[($4 + 88 | 0) >> 1] | 0;
           if (($9 | 0) < (1 | 0)) {
            break label$21
           }
           HEAP32[($4 + 36 | 0) >> 2] = $8;
           $5 = 2;
           HEAP16[($4 + 32 | 0) >> 1] = 2;
           $9 = $9 & 65535 | 0;
           if ($7 >>> 0 <= $9 >>> 0) {
            break label$20
           }
           HEAP32[($4 + 52 | 0) >> 2] = 1;
           HEAP32[($4 + 48 | 0) >> 2] = 1149198;
           HEAP32[($4 + 40 | 0) >> 2] = $9;
           $7 = $7 - $9 | 0;
           HEAP32[($4 + 64 | 0) >> 2] = $7;
           HEAP32[($4 + 60 | 0) >> 2] = $8 + $9 | 0;
           HEAP16[($4 + 56 | 0) >> 1] = 2;
           HEAP16[($4 + 44 | 0) >> 1] = 2;
           $5 = 3;
           if ($7 >>> 0 >= $3 >>> 0) {
            break label$10
           }
           HEAP32[($4 + 72 | 0) >> 2] = $3 - $7 | 0;
           HEAP16[($4 + 68 | 0) >> 1] = 0;
           $5 = 4;
           break label$10;
          }
          HEAP32[($4 + 64 | 0) >> 2] = $7;
          HEAP32[($4 + 60 | 0) >> 2] = $8;
          HEAP16[($4 + 44 | 0) >> 1] = 0;
          $8 = 0 - $9 | 0;
          HEAP32[($4 + 48 | 0) >> 2] = $8;
          HEAP16[($4 + 56 | 0) >> 1] = 2;
          HEAP32[($4 + 40 | 0) >> 2] = 2;
          HEAP32[($4 + 36 | 0) >> 2] = 1149196;
          HEAP16[($4 + 32 | 0) >> 1] = 2;
          $5 = 3;
          if ($3 >>> 0 <= $7 >>> 0) {
           break label$10
          }
          $3 = $3 - $7 | 0;
          if ($3 >>> 0 <= $8 >>> 0) {
           break label$10
          }
          HEAP32[($4 + 72 | 0) >> 2] = $3 + $9 | 0;
          HEAP16[($4 + 68 | 0) >> 1] = 0;
          $5 = 4;
          break label$10;
         }
         HEAP32[($4 + 40 | 0) >> 2] = $7;
         HEAP32[($4 + 48 | 0) >> 2] = $9 - $7 | 0;
         HEAP16[($4 + 44 | 0) >> 1] = 0;
         if (!$3) {
          break label$10
         }
         HEAP32[($4 + 72 | 0) >> 2] = $3;
         HEAP32[($4 + 64 | 0) >> 2] = 1;
         HEAP32[($4 + 60 | 0) >> 2] = 1149198;
         HEAP16[($4 + 68 | 0) >> 1] = 0;
         HEAP16[($4 + 56 | 0) >> 1] = 2;
         $5 = 4;
         break label$10;
        }
        $5 = 2;
        HEAP16[($4 + 32 | 0) >> 1] = 2;
        if (!$3) {
         break label$11
        }
        HEAP32[($4 + 48 | 0) >> 2] = 1;
        HEAP16[($4 + 44 | 0) >> 1] = 0;
        HEAP32[($4 + 40 | 0) >> 2] = 2;
        HEAP32[($4 + 36 | 0) >> 2] = 1149196;
        break label$10;
       }
       core__panicking__panic__h2fd385a887c8bf13(1148876 | 0, 33 | 0, 1149128 | 0);
       abort();
      }
      core__panicking__panic__h2fd385a887c8bf13(1149144 | 0, 33 | 0, 1149180 | 0);
      abort();
     }
     $5 = 1;
     HEAP32[($4 + 40 | 0) >> 2] = 1;
     HEAP32[($4 + 36 | 0) >> 2] = 1149204;
    }
    HEAP32[($4 + 80 | 0) >> 2] = $6;
    break label$8;
   }
   HEAP32[($4 + 80 | 0) >> 2] = $6;
   $5 = 1;
  }
  HEAP32[($4 + 92 | 0) >> 2] = $5;
  HEAP32[($4 + 84 | 0) >> 2] = $2;
  HEAP32[($4 + 88 | 0) >> 2] = $4 + 32 | 0;
  $5 = core__fmt__Formatter__pad_formatted_parts__h909e13f823ca9407($0 | 0, $4 + 80 | 0 | 0) | 0;
  global$0 = $4 + 128 | 0;
  return $5 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__AssetNames___deserialize__ha31672ab6981a455($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, i64toi32_i32$2 = 0, $3 = 0, i64toi32_i32$0 = 0, $5 = 0, $10 = 0, $10$hi = 0, $9 = 0, $9$hi = 0, $7 = 0, $32 = 0, $33 = 0, $34 = 0, $35 = 0, $36 = 0, $37 = 0, $38 = 0, $39 = 0, $40 = 0, $41 = 0, $42 = 0, $4 = 0, $6 = 0, $8 = 0, $140 = 0, $146 = 0, $163 = 0, $167 = 0, $192 = 0, $198 = 0, $202 = 0, $207 = 0, $213 = 0, $217 = 0, $229 = 0, $233 = 0, $239 = 0, $245 = 0, $272 = 0;
  $2 = global$0 - 320 | 0;
  global$0 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 20 | 0) >> 2] = 0;
  HEAP32[($2 + 24 | 0) >> 2] = i64toi32_i32$0;
  $3 = 0;
  HEAP32[($2 + 16 | 0) >> 2] = HEAP32[(0 + 1050220 | 0) >> 2] | 0;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 248 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = ($2 + 248 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $9 = i64toi32_i32$0;
  $9$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 256 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 260 | 0) >> 2] | 0;
  $10 = i64toi32_i32$1;
  $10$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 248 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 252 | 0) >> 2] | 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
         break label$6
        }
        i64toi32_i32$2 = $9$hi;
        $4 = $9;
        label$7 : {
         i64toi32_i32$2 = $10$hi;
         i64toi32_i32$3 = $10;
         i64toi32_i32$1 = 0;
         i64toi32_i32$0 = 1;
         if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
          break label$7
         }
         if (!$4) {
          break label$3
         }
        }
        $5 = $2 + 257 | 0;
        $6 = $5 + 3 | 0;
        label$8 : {
         label$9 : while (1) {
          std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 8 | 0 | 0, $1 | 0);
          $3 = 0;
          $7 = 2;
          label$10 : {
           if (HEAP32[($2 + 12 | 0) >> 2] | 0) {
            break label$10
           }
           i64toi32_i32$3 = 0;
           $10 = 8;
           $10$hi = i64toi32_i32$3;
           i64toi32_i32$3 = 0;
           $9 = 0;
           $9$hi = i64toi32_i32$3;
           break label$4;
          }
          label$11 : {
           if ((($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[($2 + 8 | 0) >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) == (7 | 0)) {
            break label$11
           }
           cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__AssetName___deserialize__hed130337b055988b($2 + 248 | 0 | 0, $1 | 0);
           if ((HEAP32[($2 + 248 | 0) >> 2] | 0 | 0) == (1 | 0)) {
            break label$8
           }
           HEAP32[($2 + 224 | 0) >> 2] = HEAPU8[$5 >> 0] | 0 | ((HEAPU8[($5 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($5 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($5 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $32 = $6;
           $33 = HEAPU8[$32 >> 0] | 0 | ((HEAPU8[($32 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($32 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($32 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 227 | 0) >> 0] = $33;
           HEAP8[($2 + 228 | 0) >> 0] = $33 >>> 8 | 0;
           HEAP8[($2 + 229 | 0) >> 0] = $33 >>> 16 | 0;
           HEAP8[($2 + 230 | 0) >> 0] = $33 >>> 24 | 0;
           HEAP32[($2 + 208 | 0) >> 2] = HEAP32[($2 + 224 | 0) >> 2] | 0;
           $34 = HEAPU8[($2 + 227 | 0) >> 0] | 0 | ((HEAPU8[($2 + 228 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 229 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 230 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 211 | 0) >> 0] = $34;
           HEAP8[($2 + 212 | 0) >> 0] = $34 >>> 8 | 0;
           HEAP8[($2 + 213 | 0) >> 0] = $34 >>> 16 | 0;
           HEAP8[($2 + 214 | 0) >> 0] = $34 >>> 24 | 0;
           $7 = HEAPU8[($2 + 256 | 0) >> 0] | 0;
           $8 = HEAP32[($2 + 252 | 0) >> 2] | 0;
           label$12 : {
            $3 = HEAP32[($2 + 24 | 0) >> 2] | 0;
            if ((HEAP32[($2 + 20 | 0) >> 2] | 0 | 0) != ($3 | 0)) {
             break label$12
            }
            alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hd40e78aa171f606d($2 + 16 | 0 | 0, $3 | 0, 1 | 0);
            $3 = HEAP32[($2 + 24 | 0) >> 2] | 0;
           }
           $3 = (HEAP32[($2 + 16 | 0) >> 2] | 0) + Math_imul($3, 12) | 0;
           HEAP8[($3 + 4 | 0) >> 0] = $7;
           HEAP32[$3 >> 2] = $8;
           $35 = HEAP32[($2 + 208 | 0) >> 2] | 0;
           HEAP8[($3 + 5 | 0) >> 0] = $35;
           HEAP8[($3 + 6 | 0) >> 0] = $35 >>> 8 | 0;
           HEAP8[($3 + 7 | 0) >> 0] = $35 >>> 16 | 0;
           HEAP8[($3 + 8 | 0) >> 0] = $35 >>> 24 | 0;
           $36 = $3 + 8 | 0;
           $37 = HEAPU8[($2 + 211 | 0) >> 0] | 0 | ((HEAPU8[($2 + 212 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 213 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 214 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[$36 >> 0] = $37;
           HEAP8[($36 + 1 | 0) >> 0] = $37 >>> 8 | 0;
           HEAP8[($36 + 2 | 0) >> 0] = $37 >>> 16 | 0;
           HEAP8[($36 + 3 | 0) >> 0] = $37 >>> 24 | 0;
           $3 = (HEAP32[($2 + 24 | 0) >> 2] | 0) + 1 | 0;
           HEAP32[($2 + 24 | 0) >> 2] = $3;
           i64toi32_i32$3 = $10$hi;
           i64toi32_i32$0 = $10;
           i64toi32_i32$2 = 0;
           i64toi32_i32$1 = 1;
           if ((i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$3 | 0) != (i64toi32_i32$2 | 0) | 0) {
            continue label$9
           }
           if ($3 >>> 0 < $4 >>> 0) {
            continue label$9
           }
           break label$3;
          }
          break label$9;
         };
         cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 248 | 0 | 0, $1 | 0);
         i64toi32_i32$1 = ($2 + 248 | 0) + 16 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
         $9 = i64toi32_i32$0;
         $9$hi = i64toi32_i32$3;
         i64toi32_i32$1 = $2;
         i64toi32_i32$3 = HEAP32[($2 + 256 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($2 + 260 | 0) >> 2] | 0;
         $10 = i64toi32_i32$3;
         $10$hi = i64toi32_i32$0;
         i64toi32_i32$1 = $2;
         i64toi32_i32$0 = HEAP32[($2 + 248 | 0) >> 2] | 0;
         i64toi32_i32$3 = HEAP32[($2 + 252 | 0) >> 2] | 0;
         i64toi32_i32$1 = i64toi32_i32$0;
         i64toi32_i32$0 = 0;
         i64toi32_i32$2 = 1;
         if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) | 0) {
          break label$5
         }
         i64toi32_i32$1 = $9$hi;
         i64toi32_i32$3 = $2 + 216 | 0;
         HEAP32[i64toi32_i32$3 >> 2] = $9;
         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$1 = $10$hi;
         i64toi32_i32$3 = $2;
         HEAP32[($2 + 208 | 0) >> 2] = $10;
         HEAP32[($2 + 212 | 0) >> 2] = i64toi32_i32$1;
         if (($10 & 255 | 0 | 0) == (5 | 0)) {
          break label$3
         }
         HEAP32[($2 + 248 | 0) >> 2] = 0;
         core__panicking__assert_failed__h96d8431cc974b591(0 | 0, $2 + 208 | 0 | 0, 1050312 | 0, $2 + 248 | 0 | 0, 1052980 | 0);
         abort();
        }
        i64toi32_i32$2 = $2 + 288 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $140 = i64toi32_i32$1;
        i64toi32_i32$1 = ($2 + 176 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $140;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
        i64toi32_i32$2 = $2 + 296 | 0;
        i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $146 = i64toi32_i32$3;
        i64toi32_i32$3 = ($2 + 176 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$3 >> 2] = $146;
        HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
        HEAP32[(($2 + 160 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 316 | 0) >> 2] | 0;
        HEAP32[($2 + 224 | 0) >> 2] = HEAPU8[$5 >> 0] | 0 | ((HEAPU8[($5 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($5 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($5 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $38 = $5 + 3 | 0;
        $39 = HEAPU8[$38 >> 0] | 0 | ((HEAPU8[($38 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($38 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($38 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 227 | 0) >> 0] = $39;
        HEAP8[($2 + 228 | 0) >> 0] = $39 >>> 8 | 0;
        HEAP8[($2 + 229 | 0) >> 0] = $39 >>> 16 | 0;
        HEAP8[($2 + 230 | 0) >> 0] = $39 >>> 24 | 0;
        i64toi32_i32$2 = $2 + 280 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $163 = i64toi32_i32$1;
        i64toi32_i32$1 = $2;
        HEAP32[($2 + 176 | 0) >> 2] = $163;
        HEAP32[($2 + 180 | 0) >> 2] = i64toi32_i32$3;
        i64toi32_i32$2 = $2 + 308 | 0;
        i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $167 = i64toi32_i32$3;
        i64toi32_i32$3 = $2;
        HEAP32[($2 + 160 | 0) >> 2] = $167;
        HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$2 = ($2 + 248 | 0) + 16 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $10 = i64toi32_i32$1;
        $10$hi = i64toi32_i32$3;
        i64toi32_i32$2 = $2 + 272 | 0;
        i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $9 = i64toi32_i32$3;
        $9$hi = i64toi32_i32$1;
        $3 = HEAP32[($2 + 304 | 0) >> 2] | 0;
        $7 = HEAPU8[($2 + 256 | 0) >> 0] | 0;
        $40 = HEAPU8[($2 + 227 | 0) >> 0] | 0 | ((HEAPU8[($2 + 228 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 229 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 230 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 203 | 0) >> 0] = $40;
        HEAP8[($2 + 204 | 0) >> 0] = $40 >>> 8 | 0;
        HEAP8[($2 + 205 | 0) >> 0] = $40 >>> 16 | 0;
        HEAP8[($2 + 206 | 0) >> 0] = $40 >>> 24 | 0;
        HEAP32[($2 + 200 | 0) >> 2] = HEAP32[($2 + 224 | 0) >> 2] | 0;
        if (($7 | 0) != (19 | 0)) {
         break label$4
        }
        break label$3;
       }
       i64toi32_i32$2 = $2 + 280 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $192 = i64toi32_i32$1;
       i64toi32_i32$1 = $2 + 184 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $192;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
       i64toi32_i32$2 = $2 + 288 | 0;
       i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $198 = i64toi32_i32$3;
       i64toi32_i32$3 = ($2 + 176 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$3 >> 2] = $198;
       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $2 + 272 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $202 = i64toi32_i32$1;
       i64toi32_i32$1 = $2;
       HEAP32[($2 + 176 | 0) >> 2] = $202;
       HEAP32[($2 + 180 | 0) >> 2] = i64toi32_i32$3;
       $7 = 2;
       break label$4;
      }
      i64toi32_i32$2 = $2 + 280 | 0;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $207 = i64toi32_i32$3;
      i64toi32_i32$3 = $2 + 184 | 0;
      HEAP32[i64toi32_i32$3 >> 2] = $207;
      HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $2 + 288 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $213 = i64toi32_i32$1;
      i64toi32_i32$1 = ($2 + 176 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $213;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
      i64toi32_i32$2 = $2 + 272 | 0;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $217 = i64toi32_i32$3;
      i64toi32_i32$3 = $2;
      HEAP32[($2 + 176 | 0) >> 2] = $217;
      HEAP32[($2 + 180 | 0) >> 2] = i64toi32_i32$1;
     }
     i64toi32_i32$1 = $9$hi;
     i64toi32_i32$3 = ($2 + 248 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $9;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $10$hi;
     i64toi32_i32$3 = ($2 + 248 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $10;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAP32[($2 + 176 | 0) >> 2] | 0;
     i64toi32_i32$3 = HEAP32[($2 + 180 | 0) >> 2] | 0;
     $229 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 272 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $229;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$2 = $2;
     i64toi32_i32$3 = HEAP32[($2 + 160 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 164 | 0) >> 2] | 0;
     $233 = i64toi32_i32$3;
     i64toi32_i32$3 = $2 + 300 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $233;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = ($2 + 176 | 0) + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $239 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 280 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $239;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$2 = ($2 + 176 | 0) + 16 | 0;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $245 = i64toi32_i32$3;
     i64toi32_i32$3 = $2 + 288 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $245;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($2 + 308 | 0) >> 2] = HEAP32[(($2 + 160 | 0) + 8 | 0) >> 2] | 0;
     HEAP8[($2 + 248 | 0) >> 0] = $7;
     $41 = HEAP32[($2 + 200 | 0) >> 2] | 0;
     HEAP8[($2 + 249 | 0) >> 0] = $41;
     HEAP8[($2 + 250 | 0) >> 0] = $41 >>> 8 | 0;
     HEAP8[($2 + 251 | 0) >> 0] = $41 >>> 16 | 0;
     HEAP8[($2 + 252 | 0) >> 0] = $41 >>> 24 | 0;
     $42 = HEAPU8[($2 + 203 | 0) >> 0] | 0 | ((HEAPU8[($2 + 204 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 205 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 206 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($2 + 252 | 0) >> 0] = $42;
     HEAP8[($2 + 253 | 0) >> 0] = $42 >>> 8 | 0;
     HEAP8[($2 + 254 | 0) >> 0] = $42 >>> 16 | 0;
     HEAP8[($2 + 255 | 0) >> 0] = $42 >>> 24 | 0;
     HEAP32[($2 + 296 | 0) >> 2] = $3;
     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($2 + 96 | 0 | 0, $2 + 248 | 0 | 0, 1052996 | 0, 10 | 0);
     $1 = HEAPU8[($2 + 96 | 0) >> 0] | 0;
     if (($1 | 0) != (19 | 0)) {
      break label$2
     }
    }
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
    i64toi32_i32$3 = HEAP32[($2 + 20 | 0) >> 2] | 0;
    $272 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $272;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$3;
    HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = HEAP32[($2 + 24 | 0) >> 2] | 0;
    $3 = 0;
    break label$1;
   }
   $3 = 1;
   memcpy($2 + 33 | 0 | 0, $2 + 96 | 0 | 1 | 0 | 0, 63 | 0) | 0;
   HEAP8[($0 + 8 | 0) >> 0] = $1;
   memcpy($0 + 9 | 0 | 0, $2 + 33 | 0 | 0, 63 | 0) | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__he37b42ff2b07ed41($2 + 16 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h19d691521e7c48e6($2 + 16 | 0 | 0);
  }
  HEAP32[$0 >> 2] = $3;
  global$0 = $2 + 320 | 0;
 }
 
 function $cardano_serialization_lib__plutus__PlutusScripts_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h8b36940d74966a88($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, i64toi32_i32$2 = 0, $3 = 0, i64toi32_i32$0 = 0, $5 = 0, $10 = 0, $10$hi = 0, $9 = 0, $9$hi = 0, $7 = 0, $32 = 0, $33 = 0, $34 = 0, $35 = 0, $36 = 0, $37 = 0, $38 = 0, $39 = 0, $40 = 0, $41 = 0, $42 = 0, $4 = 0, $6 = 0, $8 = 0, $140 = 0, $146 = 0, $163 = 0, $167 = 0, $192 = 0, $198 = 0, $202 = 0, $207 = 0, $213 = 0, $217 = 0, $229 = 0, $233 = 0, $239 = 0, $245 = 0, $272 = 0;
  $2 = global$0 - 320 | 0;
  global$0 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 20 | 0) >> 2] = 0;
  HEAP32[($2 + 24 | 0) >> 2] = i64toi32_i32$0;
  $3 = 0;
  HEAP32[($2 + 16 | 0) >> 2] = HEAP32[(0 + 1070728 | 0) >> 2] | 0;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 248 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = ($2 + 248 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $9 = i64toi32_i32$0;
  $9$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 256 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 260 | 0) >> 2] | 0;
  $10 = i64toi32_i32$1;
  $10$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 248 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 252 | 0) >> 2] | 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
         break label$6
        }
        i64toi32_i32$2 = $9$hi;
        $4 = $9;
        label$7 : {
         i64toi32_i32$2 = $10$hi;
         i64toi32_i32$3 = $10;
         i64toi32_i32$1 = 0;
         i64toi32_i32$0 = 1;
         if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
          break label$7
         }
         if (!$4) {
          break label$3
         }
        }
        $5 = $2 + 257 | 0;
        $6 = $5 + 3 | 0;
        label$8 : {
         label$9 : while (1) {
          std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 8 | 0 | 0, $1 | 0);
          $3 = 0;
          $7 = 2;
          label$10 : {
           if (HEAP32[($2 + 12 | 0) >> 2] | 0) {
            break label$10
           }
           i64toi32_i32$3 = 0;
           $10 = 8;
           $10$hi = i64toi32_i32$3;
           i64toi32_i32$3 = 0;
           $9 = 0;
           $9$hi = i64toi32_i32$3;
           break label$4;
          }
          label$11 : {
           if ((($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[($2 + 8 | 0) >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) == (7 | 0)) {
            break label$11
           }
           $cardano_serialization_lib__plutus__PlutusScript_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h6cd9666f62b56459($2 + 248 | 0 | 0, $1 | 0);
           if ((HEAP32[($2 + 248 | 0) >> 2] | 0 | 0) == (1 | 0)) {
            break label$8
           }
           HEAP32[($2 + 224 | 0) >> 2] = HEAPU8[$5 >> 0] | 0 | ((HEAPU8[($5 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($5 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($5 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $32 = $6;
           $33 = HEAPU8[$32 >> 0] | 0 | ((HEAPU8[($32 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($32 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($32 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 227 | 0) >> 0] = $33;
           HEAP8[($2 + 228 | 0) >> 0] = $33 >>> 8 | 0;
           HEAP8[($2 + 229 | 0) >> 0] = $33 >>> 16 | 0;
           HEAP8[($2 + 230 | 0) >> 0] = $33 >>> 24 | 0;
           HEAP32[($2 + 208 | 0) >> 2] = HEAP32[($2 + 224 | 0) >> 2] | 0;
           $34 = HEAPU8[($2 + 227 | 0) >> 0] | 0 | ((HEAPU8[($2 + 228 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 229 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 230 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 211 | 0) >> 0] = $34;
           HEAP8[($2 + 212 | 0) >> 0] = $34 >>> 8 | 0;
           HEAP8[($2 + 213 | 0) >> 0] = $34 >>> 16 | 0;
           HEAP8[($2 + 214 | 0) >> 0] = $34 >>> 24 | 0;
           $7 = HEAPU8[($2 + 256 | 0) >> 0] | 0;
           $8 = HEAP32[($2 + 252 | 0) >> 2] | 0;
           label$12 : {
            $3 = HEAP32[($2 + 24 | 0) >> 2] | 0;
            if ((HEAP32[($2 + 20 | 0) >> 2] | 0 | 0) != ($3 | 0)) {
             break label$12
            }
            alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h558818d7c1769e53($2 + 16 | 0 | 0, $3 | 0, 1 | 0);
            $3 = HEAP32[($2 + 24 | 0) >> 2] | 0;
           }
           $3 = (HEAP32[($2 + 16 | 0) >> 2] | 0) + Math_imul($3, 12) | 0;
           HEAP8[($3 + 4 | 0) >> 0] = $7;
           HEAP32[$3 >> 2] = $8;
           $35 = HEAP32[($2 + 208 | 0) >> 2] | 0;
           HEAP8[($3 + 5 | 0) >> 0] = $35;
           HEAP8[($3 + 6 | 0) >> 0] = $35 >>> 8 | 0;
           HEAP8[($3 + 7 | 0) >> 0] = $35 >>> 16 | 0;
           HEAP8[($3 + 8 | 0) >> 0] = $35 >>> 24 | 0;
           $36 = $3 + 8 | 0;
           $37 = HEAPU8[($2 + 211 | 0) >> 0] | 0 | ((HEAPU8[($2 + 212 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 213 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 214 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[$36 >> 0] = $37;
           HEAP8[($36 + 1 | 0) >> 0] = $37 >>> 8 | 0;
           HEAP8[($36 + 2 | 0) >> 0] = $37 >>> 16 | 0;
           HEAP8[($36 + 3 | 0) >> 0] = $37 >>> 24 | 0;
           $3 = (HEAP32[($2 + 24 | 0) >> 2] | 0) + 1 | 0;
           HEAP32[($2 + 24 | 0) >> 2] = $3;
           i64toi32_i32$3 = $10$hi;
           i64toi32_i32$0 = $10;
           i64toi32_i32$2 = 0;
           i64toi32_i32$1 = 1;
           if ((i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$3 | 0) != (i64toi32_i32$2 | 0) | 0) {
            continue label$9
           }
           if ($3 >>> 0 < $4 >>> 0) {
            continue label$9
           }
           break label$3;
          }
          break label$9;
         };
         cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 248 | 0 | 0, $1 | 0);
         i64toi32_i32$1 = ($2 + 248 | 0) + 16 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
         $9 = i64toi32_i32$0;
         $9$hi = i64toi32_i32$3;
         i64toi32_i32$1 = $2;
         i64toi32_i32$3 = HEAP32[($2 + 256 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($2 + 260 | 0) >> 2] | 0;
         $10 = i64toi32_i32$3;
         $10$hi = i64toi32_i32$0;
         i64toi32_i32$1 = $2;
         i64toi32_i32$0 = HEAP32[($2 + 248 | 0) >> 2] | 0;
         i64toi32_i32$3 = HEAP32[($2 + 252 | 0) >> 2] | 0;
         i64toi32_i32$1 = i64toi32_i32$0;
         i64toi32_i32$0 = 0;
         i64toi32_i32$2 = 1;
         if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) | 0) {
          break label$5
         }
         i64toi32_i32$1 = $9$hi;
         i64toi32_i32$3 = $2 + 216 | 0;
         HEAP32[i64toi32_i32$3 >> 2] = $9;
         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$1 = $10$hi;
         i64toi32_i32$3 = $2;
         HEAP32[($2 + 208 | 0) >> 2] = $10;
         HEAP32[($2 + 212 | 0) >> 2] = i64toi32_i32$1;
         if (($10 & 255 | 0 | 0) == (5 | 0)) {
          break label$3
         }
         HEAP32[($2 + 248 | 0) >> 2] = 0;
         core__panicking__assert_failed__h96d8431cc974b591(0 | 0, $2 + 208 | 0 | 0, 1070752 | 0, $2 + 248 | 0 | 0, 1070784 | 0);
         abort();
        }
        i64toi32_i32$2 = $2 + 288 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $140 = i64toi32_i32$1;
        i64toi32_i32$1 = ($2 + 176 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $140;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
        i64toi32_i32$2 = $2 + 296 | 0;
        i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $146 = i64toi32_i32$3;
        i64toi32_i32$3 = ($2 + 176 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$3 >> 2] = $146;
        HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
        HEAP32[(($2 + 160 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 316 | 0) >> 2] | 0;
        HEAP32[($2 + 224 | 0) >> 2] = HEAPU8[$5 >> 0] | 0 | ((HEAPU8[($5 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($5 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($5 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $38 = $5 + 3 | 0;
        $39 = HEAPU8[$38 >> 0] | 0 | ((HEAPU8[($38 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($38 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($38 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 227 | 0) >> 0] = $39;
        HEAP8[($2 + 228 | 0) >> 0] = $39 >>> 8 | 0;
        HEAP8[($2 + 229 | 0) >> 0] = $39 >>> 16 | 0;
        HEAP8[($2 + 230 | 0) >> 0] = $39 >>> 24 | 0;
        i64toi32_i32$2 = $2 + 280 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $163 = i64toi32_i32$1;
        i64toi32_i32$1 = $2;
        HEAP32[($2 + 176 | 0) >> 2] = $163;
        HEAP32[($2 + 180 | 0) >> 2] = i64toi32_i32$3;
        i64toi32_i32$2 = $2 + 308 | 0;
        i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $167 = i64toi32_i32$3;
        i64toi32_i32$3 = $2;
        HEAP32[($2 + 160 | 0) >> 2] = $167;
        HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$2 = ($2 + 248 | 0) + 16 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $10 = i64toi32_i32$1;
        $10$hi = i64toi32_i32$3;
        i64toi32_i32$2 = $2 + 272 | 0;
        i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $9 = i64toi32_i32$3;
        $9$hi = i64toi32_i32$1;
        $3 = HEAP32[($2 + 304 | 0) >> 2] | 0;
        $7 = HEAPU8[($2 + 256 | 0) >> 0] | 0;
        $40 = HEAPU8[($2 + 227 | 0) >> 0] | 0 | ((HEAPU8[($2 + 228 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 229 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 230 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 203 | 0) >> 0] = $40;
        HEAP8[($2 + 204 | 0) >> 0] = $40 >>> 8 | 0;
        HEAP8[($2 + 205 | 0) >> 0] = $40 >>> 16 | 0;
        HEAP8[($2 + 206 | 0) >> 0] = $40 >>> 24 | 0;
        HEAP32[($2 + 200 | 0) >> 2] = HEAP32[($2 + 224 | 0) >> 2] | 0;
        if (($7 | 0) != (19 | 0)) {
         break label$4
        }
        break label$3;
       }
       i64toi32_i32$2 = $2 + 280 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $192 = i64toi32_i32$1;
       i64toi32_i32$1 = $2 + 184 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $192;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
       i64toi32_i32$2 = $2 + 288 | 0;
       i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $198 = i64toi32_i32$3;
       i64toi32_i32$3 = ($2 + 176 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$3 >> 2] = $198;
       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $2 + 272 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $202 = i64toi32_i32$1;
       i64toi32_i32$1 = $2;
       HEAP32[($2 + 176 | 0) >> 2] = $202;
       HEAP32[($2 + 180 | 0) >> 2] = i64toi32_i32$3;
       $7 = 2;
       break label$4;
      }
      i64toi32_i32$2 = $2 + 280 | 0;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $207 = i64toi32_i32$3;
      i64toi32_i32$3 = $2 + 184 | 0;
      HEAP32[i64toi32_i32$3 >> 2] = $207;
      HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $2 + 288 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $213 = i64toi32_i32$1;
      i64toi32_i32$1 = ($2 + 176 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $213;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
      i64toi32_i32$2 = $2 + 272 | 0;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $217 = i64toi32_i32$3;
      i64toi32_i32$3 = $2;
      HEAP32[($2 + 176 | 0) >> 2] = $217;
      HEAP32[($2 + 180 | 0) >> 2] = i64toi32_i32$1;
     }
     i64toi32_i32$1 = $9$hi;
     i64toi32_i32$3 = ($2 + 248 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $9;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $10$hi;
     i64toi32_i32$3 = ($2 + 248 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $10;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAP32[($2 + 176 | 0) >> 2] | 0;
     i64toi32_i32$3 = HEAP32[($2 + 180 | 0) >> 2] | 0;
     $229 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 272 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $229;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$2 = $2;
     i64toi32_i32$3 = HEAP32[($2 + 160 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 164 | 0) >> 2] | 0;
     $233 = i64toi32_i32$3;
     i64toi32_i32$3 = $2 + 300 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $233;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = ($2 + 176 | 0) + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $239 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 280 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $239;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$2 = ($2 + 176 | 0) + 16 | 0;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $245 = i64toi32_i32$3;
     i64toi32_i32$3 = $2 + 288 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $245;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($2 + 308 | 0) >> 2] = HEAP32[(($2 + 160 | 0) + 8 | 0) >> 2] | 0;
     HEAP8[($2 + 248 | 0) >> 0] = $7;
     $41 = HEAP32[($2 + 200 | 0) >> 2] | 0;
     HEAP8[($2 + 249 | 0) >> 0] = $41;
     HEAP8[($2 + 250 | 0) >> 0] = $41 >>> 8 | 0;
     HEAP8[($2 + 251 | 0) >> 0] = $41 >>> 16 | 0;
     HEAP8[($2 + 252 | 0) >> 0] = $41 >>> 24 | 0;
     $42 = HEAPU8[($2 + 203 | 0) >> 0] | 0 | ((HEAPU8[($2 + 204 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 205 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 206 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($2 + 252 | 0) >> 0] = $42;
     HEAP8[($2 + 253 | 0) >> 0] = $42 >>> 8 | 0;
     HEAP8[($2 + 254 | 0) >> 0] = $42 >>> 16 | 0;
     HEAP8[($2 + 255 | 0) >> 0] = $42 >>> 24 | 0;
     HEAP32[($2 + 296 | 0) >> 2] = $3;
     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($2 + 96 | 0 | 0, $2 + 248 | 0 | 0, 1070800 | 0, 13 | 0);
     $1 = HEAPU8[($2 + 96 | 0) >> 0] | 0;
     if (($1 | 0) != (19 | 0)) {
      break label$2
     }
    }
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
    i64toi32_i32$3 = HEAP32[($2 + 20 | 0) >> 2] | 0;
    $272 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $272;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$3;
    HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = HEAP32[($2 + 24 | 0) >> 2] | 0;
    $3 = 0;
    break label$1;
   }
   $3 = 1;
   memcpy($2 + 33 | 0 | 0, $2 + 96 | 0 | 1 | 0 | 0, 63 | 0) | 0;
   HEAP8[($0 + 8 | 0) >> 0] = $1;
   memcpy($0 + 9 | 0 | 0, $2 + 33 | 0 | 0, 63 | 0) | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd4b44cb226d8311d($2 + 16 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h3633100df9c96e1e($2 + 16 | 0 | 0);
  }
  HEAP32[$0 >> 2] = $3;
  global$0 = $2 + 320 | 0;
 }
 
 function cbor_event__de__Deserializer_R___special__h10e912d855f56298($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$5 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $2 = 0, $3 = 0, $6 = 0, $4 = 0, $8 = 0, $8$hi = 0, $7 = 0, $7$hi = 0, $5 = 0, $44 = 0, $45 = 0, $46 = 0, $50 = 0, $70 = 0, $74 = 0, $101 = 0, $105 = 0, $110 = 0, $115 = 0, $132 = 0, $149 = 0, $156 = 0, $161 = 0, $162 = 0, $162$hi = 0, $164$hi = 0, $172 = 0, $177 = 0, $182 = 0, $187 = 0, $192 = 0, $207 = 0, $213 = 0, $219 = 0, $225 = 0, $233 = 0, $239 = 0, $245 = 0, $251 = 0;
  $2 = global$0 - 96 | 0;
  global$0 = $2;
  std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 40 | 0 | 0, $1 | 0);
  $3 = 8;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $4 = HEAP32[($2 + 44 | 0) >> 2] | 0;
      if ($4) {
       break label$4
      }
      break label$3;
     }
     $5 = HEAP32[($2 + 40 | 0) >> 2] | 0;
     if (!$5) {
      break label$3
     }
     $3 = 9;
     $6 = ($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[$5 >> 0] | 0 | 0) | 0) & 255 | 0;
     if (($6 | 0) != (7 | 0)) {
      break label$3
     }
     std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 32 | 0 | 0, $1 | 0);
     label$5 : {
      label$6 : {
       label$7 : {
        label$8 : {
         $3 = HEAP32[($2 + 36 | 0) >> 2] | 0;
         if (!$3) {
          break label$8
         }
         $6 = HEAP32[($2 + 32 | 0) >> 2] | 0;
         if (!$6) {
          break label$8
         }
         label$9 : {
          label$10 : {
           label$11 : {
            label$12 : {
             label$13 : {
              label$14 : {
               label$15 : {
                label$16 : {
                 label$17 : {
                  label$18 : {
                   label$19 : {
                    label$20 : {
                     label$21 : {
                      label$22 : {
                       $3 = (HEAPU8[$6 >> 0] | 0) & 31 | 0;
                       if ($3 >>> 0 < 20 >>> 0) {
                        break label$22
                       }
                       switch ($3 + -20 | 0 | 0) {
                       case 1:
                        break label$10;
                       case 2:
                        break label$11;
                       case 3:
                        break label$12;
                       case 6:
                        break label$15;
                       case 7:
                        break label$16;
                       case 11:
                        break label$17;
                       case 5:
                        break label$19;
                       case 4:
                        break label$20;
                       case 0:
                        break label$9;
                       default:
                        break label$21;
                       };
                      }
                      HEAP8[($0 + 8 | 0) >> 0] = 3;
                      HEAP8[($0 + 9 | 0) >> 0] = $3;
                      $50 = $1;
                      i64toi32_i32$2 = $1;
                      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
                      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
                      i64toi32_i32$2 = i64toi32_i32$0;
                      i64toi32_i32$0 = 0;
                      i64toi32_i32$3 = 1;
                      i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
                      i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
                      if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
                       i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
                      }
                      i64toi32_i32$2 = $50;
                      HEAP32[i64toi32_i32$2 >> 2] = i64toi32_i32$4;
                      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$5;
                      break label$5;
                     }
                     label$23 : {
                      if ($3 >>> 0 < 28 >>> 0) {
                       break label$23
                      }
                      if (($3 | 0) != (31 | 0)) {
                       break label$18
                      }
                     }
                     core__panicking__panic__h2fd385a887c8bf13(1054592 | 0, 40 | 0, 1054724 | 0);
                     abort();
                    }
                    std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 8 | 0 | 0, $1 | 0);
                    label$24 : {
                     $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
                     if ($3 >>> 0 < 2 >>> 0) {
                      break label$24
                     }
                     $6 = HEAP32[($2 + 8 | 0) >> 2] | 0;
                     if ($6) {
                      break label$13
                     }
                    }
                    HEAP32[($0 + 16 | 0) >> 2] = 1;
                    $70 = $0;
                    i64toi32_i32$5 = 0;
                    i64toi32_i32$1 = $3;
                    i64toi32_i32$2 = 0;
                    i64toi32_i32$3 = 32;
                    i64toi32_i32$0 = i64toi32_i32$3 & 31 | 0;
                    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                     i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$0 | 0;
                     $44 = 0;
                    } else {
                     i64toi32_i32$2 = ((1 << i64toi32_i32$0 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$0 | 0) | 0) | 0 | (i64toi32_i32$5 << i64toi32_i32$0 | 0) | 0;
                     $44 = i64toi32_i32$1 << i64toi32_i32$0 | 0;
                    }
                    i64toi32_i32$5 = $44;
                    i64toi32_i32$1 = 0;
                    i64toi32_i32$3 = 8;
                    i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
                    $74 = i64toi32_i32$5 | i64toi32_i32$3 | 0;
                    i64toi32_i32$5 = $70;
                    HEAP32[(i64toi32_i32$5 + 8 | 0) >> 2] = $74;
                    HEAP32[(i64toi32_i32$5 + 12 | 0) >> 2] = i64toi32_i32$1;
                    break label$2;
                   }
                   std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 24 | 0 | 0, $1 | 0);
                   $3 = 1;
                   label$25 : {
                    $6 = HEAP32[($2 + 28 | 0) >> 2] | 0;
                    if ($6 >>> 0 < 2 >>> 0) {
                     break label$25
                    }
                    $4 = HEAP32[($2 + 24 | 0) >> 2] | 0;
                    if (!$4) {
                     break label$25
                    }
                    i64toi32_i32$2 = $4;
                    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0;
                    i64toi32_i32$5 = 0;
                    $7 = i64toi32_i32$1;
                    $7$hi = i64toi32_i32$5;
                    std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 16 | 0 | 0, $1 | 0);
                    $3 = 2;
                    $6 = HEAP32[($2 + 20 | 0) >> 2] | 0;
                    if ($6 >>> 0 < 3 >>> 0) {
                     break label$25
                    }
                    $4 = HEAP32[($2 + 16 | 0) >> 2] | 0;
                    if ($4) {
                     break label$14
                    }
                   }
                   HEAP32[($0 + 16 | 0) >> 2] = $3;
                   $101 = $0;
                   i64toi32_i32$5 = 0;
                   i64toi32_i32$2 = $6;
                   i64toi32_i32$1 = 0;
                   i64toi32_i32$3 = 32;
                   i64toi32_i32$0 = i64toi32_i32$3 & 31 | 0;
                   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                    i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$0 | 0;
                    $45 = 0;
                   } else {
                    i64toi32_i32$1 = ((1 << i64toi32_i32$0 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$0 | 0) | 0) | 0 | (i64toi32_i32$5 << i64toi32_i32$0 | 0) | 0;
                    $45 = i64toi32_i32$2 << i64toi32_i32$0 | 0;
                   }
                   i64toi32_i32$5 = $45;
                   i64toi32_i32$2 = 0;
                   i64toi32_i32$3 = 8;
                   i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
                   $105 = i64toi32_i32$5 | i64toi32_i32$3 | 0;
                   i64toi32_i32$5 = $101;
                   HEAP32[(i64toi32_i32$5 + 8 | 0) >> 2] = $105;
                   HEAP32[(i64toi32_i32$5 + 12 | 0) >> 2] = i64toi32_i32$2;
                   break label$2;
                  }
                  HEAP8[($0 + 8 | 0) >> 0] = 3;
                  HEAP8[($0 + 9 | 0) >> 0] = $3;
                  $110 = $1;
                  i64toi32_i32$1 = $1;
                  i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
                  i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
                  i64toi32_i32$1 = i64toi32_i32$2;
                  i64toi32_i32$2 = 0;
                  i64toi32_i32$3 = 1;
                  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
                  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
                  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
                   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
                  }
                  i64toi32_i32$1 = $110;
                  HEAP32[i64toi32_i32$1 >> 2] = i64toi32_i32$0;
                  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$4;
                  break label$5;
                 }
                 HEAP8[($0 + 8 | 0) >> 0] = 5;
                 $115 = $1;
                 i64toi32_i32$5 = $1;
                 i64toi32_i32$4 = HEAP32[i64toi32_i32$5 >> 2] | 0;
                 i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
                 i64toi32_i32$5 = i64toi32_i32$4;
                 i64toi32_i32$4 = 0;
                 i64toi32_i32$3 = 1;
                 i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
                 i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
                 if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
                  i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
                 }
                 i64toi32_i32$5 = $115;
                 HEAP32[i64toi32_i32$5 >> 2] = i64toi32_i32$2;
                 HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
                 break label$5;
                }
                cbor_event__de__Deserializer_R___u64__hb76211f6fef2ef8e($2 + 48 | 0 | 0, $1 | 0);
                i64toi32_i32$0 = 0;
                $7 = 1;
                $7$hi = i64toi32_i32$0;
                i64toi32_i32$1 = $2;
                i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 56 | 0) >> 2] | 0;
                i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 60 | 0) >> 2] | 0;
                $8 = i64toi32_i32$0;
                $8$hi = i64toi32_i32$5;
                i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 48 | 0) >> 2] | 0;
                i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 52 | 0) >> 2] | 0;
                i64toi32_i32$1 = i64toi32_i32$5;
                i64toi32_i32$5 = 0;
                i64toi32_i32$3 = 1;
                if ((i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$5 | 0) | 0) {
                 break label$6
                }
                HEAP8[($0 + 8 | 0) >> 0] = 4;
                i64toi32_i32$1 = $8$hi;
                i64toi32_i32$0 = $8;
                i64toi32_i32$3 = 0;
                HEAPF64[($0 + 16 | 0) >> 3] = +(i64toi32_i32$0 >>> 0) + 4294967296.0 * +(i64toi32_i32$1 >>> 0);
                $132 = $1;
                i64toi32_i32$3 = $1;
                i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
                i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
                i64toi32_i32$3 = i64toi32_i32$1;
                i64toi32_i32$1 = 0;
                i64toi32_i32$5 = 9;
                i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
                i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
                if (i64toi32_i32$4 >>> 0 < i64toi32_i32$5 >>> 0) {
                 i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
                }
                i64toi32_i32$3 = $132;
                HEAP32[i64toi32_i32$3 >> 2] = i64toi32_i32$4;
                HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
                break label$5;
               }
               cbor_event__de__Deserializer_R___u32__h46f77234696376fa($2 + 48 | 0 | 0, $1 | 0);
               i64toi32_i32$2 = 0;
               $7 = 1;
               $7$hi = i64toi32_i32$2;
               i64toi32_i32$0 = $2;
               i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 56 | 0) >> 2] | 0;
               i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 60 | 0) >> 2] | 0;
               $8 = i64toi32_i32$2;
               $8$hi = i64toi32_i32$3;
               i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 48 | 0) >> 2] | 0;
               i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 52 | 0) >> 2] | 0;
               i64toi32_i32$0 = i64toi32_i32$3;
               i64toi32_i32$3 = 0;
               i64toi32_i32$5 = 1;
               if ((i64toi32_i32$0 | 0) == (i64toi32_i32$5 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) | 0) {
                break label$7
               }
               HEAP8[($0 + 8 | 0) >> 0] = 4;
               i64toi32_i32$0 = $8$hi;
               i64toi32_i32$2 = $8;
               i64toi32_i32$5 = 0;
               HEAPF64[($0 + 16 | 0) >> 3] = +(i64toi32_i32$2 >>> 0) + 4294967296.0 * +(i64toi32_i32$0 >>> 0);
               $149 = $1;
               i64toi32_i32$5 = $1;
               i64toi32_i32$0 = HEAP32[i64toi32_i32$5 >> 2] | 0;
               i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
               i64toi32_i32$5 = i64toi32_i32$0;
               i64toi32_i32$0 = 0;
               i64toi32_i32$3 = 5;
               i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
               i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
               if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
                i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
               }
               i64toi32_i32$5 = $149;
               HEAP32[i64toi32_i32$5 >> 2] = i64toi32_i32$1;
               HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$4;
               break label$5;
              }
              i64toi32_i32$2 = $4;
              i64toi32_i32$4 = HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0;
              i64toi32_i32$5 = 0;
              $8 = i64toi32_i32$4;
              $8$hi = i64toi32_i32$5;
              HEAP8[($0 + 8 | 0) >> 0] = 4;
              $156 = $1;
              i64toi32_i32$2 = $1;
              i64toi32_i32$5 = HEAP32[i64toi32_i32$2 >> 2] | 0;
              i64toi32_i32$4 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
              i64toi32_i32$2 = i64toi32_i32$5;
              i64toi32_i32$5 = 0;
              i64toi32_i32$3 = 3;
              i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
              i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
              if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
               i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
              }
              i64toi32_i32$2 = $156;
              HEAP32[i64toi32_i32$2 >> 2] = i64toi32_i32$0;
              HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
              $161 = $0 + 16 | 0;
              i64toi32_i32$1 = $8$hi;
              $162 = $8;
              $162$hi = i64toi32_i32$1;
              i64toi32_i32$1 = $7$hi;
              i64toi32_i32$4 = $7;
              i64toi32_i32$2 = 0;
              i64toi32_i32$3 = 8;
              i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
              if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
               i64toi32_i32$2 = i64toi32_i32$4 << i64toi32_i32$5 | 0;
               $46 = 0;
              } else {
               i64toi32_i32$2 = ((1 << i64toi32_i32$5 | 0) - 1 | 0) & (i64toi32_i32$4 >>> (32 - i64toi32_i32$5 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$5 | 0) | 0;
               $46 = i64toi32_i32$4 << i64toi32_i32$5 | 0;
              }
              $164$hi = i64toi32_i32$2;
              i64toi32_i32$2 = $162$hi;
              i64toi32_i32$1 = $162;
              i64toi32_i32$4 = $164$hi;
              i64toi32_i32$3 = $46;
              i64toi32_i32$4 = i64toi32_i32$2 | i64toi32_i32$4 | 0;
              i64toi32_i32$1 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
              i64toi32_i32$2 = 0;
              HEAPF64[$161 >> 3] = +(i64toi32_i32$1 >>> 0) + 4294967296.0 * +(i64toi32_i32$4 >>> 0);
              break label$5;
             }
             HEAP8[($0 + 9 | 0) >> 0] = HEAPU8[($6 + 1 | 0) >> 0] | 0;
             HEAP8[($0 + 8 | 0) >> 0] = 3;
             $172 = $1;
             i64toi32_i32$2 = $1;
             i64toi32_i32$4 = HEAP32[i64toi32_i32$2 >> 2] | 0;
             i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
             i64toi32_i32$2 = i64toi32_i32$4;
             i64toi32_i32$4 = 0;
             i64toi32_i32$3 = 2;
             i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
             i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
             if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
              i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
             }
             i64toi32_i32$2 = $172;
             HEAP32[i64toi32_i32$2 >> 2] = i64toi32_i32$5;
             HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
             break label$5;
            }
            HEAP8[($0 + 8 | 0) >> 0] = 2;
            $177 = $1;
            i64toi32_i32$1 = $1;
            i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
            i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
            i64toi32_i32$1 = i64toi32_i32$0;
            i64toi32_i32$0 = 0;
            i64toi32_i32$3 = 1;
            i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
            i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
            if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
             i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
            }
            i64toi32_i32$1 = $177;
            HEAP32[i64toi32_i32$1 >> 2] = i64toi32_i32$4;
            HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$5;
            break label$5;
           }
           HEAP8[($0 + 8 | 0) >> 0] = 1;
           $182 = $1;
           i64toi32_i32$2 = $1;
           i64toi32_i32$5 = HEAP32[i64toi32_i32$2 >> 2] | 0;
           i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
           i64toi32_i32$2 = i64toi32_i32$5;
           i64toi32_i32$5 = 0;
           i64toi32_i32$3 = 1;
           i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
           i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
           if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
            i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
           }
           i64toi32_i32$2 = $182;
           HEAP32[i64toi32_i32$2 >> 2] = i64toi32_i32$0;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$4;
           break label$5;
          }
          HEAP16[($0 + 8 | 0) >> 1] = 256;
          $187 = $1;
          i64toi32_i32$1 = $1;
          i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
          i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
          i64toi32_i32$1 = i64toi32_i32$4;
          i64toi32_i32$4 = 0;
          i64toi32_i32$3 = 1;
          i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
          i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
          if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
           i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
          }
          i64toi32_i32$1 = $187;
          HEAP32[i64toi32_i32$1 >> 2] = i64toi32_i32$5;
          HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
          break label$5;
         }
         HEAP16[($0 + 8 | 0) >> 1] = 0;
         $192 = $1;
         i64toi32_i32$2 = $1;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         i64toi32_i32$2 = i64toi32_i32$0;
         i64toi32_i32$0 = 0;
         i64toi32_i32$3 = 1;
         i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
         i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
         if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
          i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
         }
         i64toi32_i32$2 = $192;
         HEAP32[i64toi32_i32$2 >> 2] = i64toi32_i32$4;
         HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$5;
         break label$5;
        }
        HEAP8[($0 + 8 | 0) >> 0] = 8;
        HEAP32[($0 + 16 | 0) >> 2] = 0;
        HEAP32[($0 + 12 | 0) >> 2] = $3;
        break label$2;
       }
       i64toi32_i32$1 = ($2 + 48 | 0) + 40 | 0;
       i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $207 = i64toi32_i32$5;
       i64toi32_i32$5 = $0 + 40 | 0;
       HEAP32[i64toi32_i32$5 >> 2] = $207;
       HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$1 = ($2 + 48 | 0) + 32 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $213 = i64toi32_i32$2;
       i64toi32_i32$2 = $0 + 32 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $213;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$5;
       i64toi32_i32$1 = ($2 + 48 | 0) + 24 | 0;
       i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $219 = i64toi32_i32$5;
       i64toi32_i32$5 = $0 + 24 | 0;
       HEAP32[i64toi32_i32$5 >> 2] = $219;
       HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$1 = ($2 + 48 | 0) + 16 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $225 = i64toi32_i32$2;
       i64toi32_i32$2 = $0 + 16 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $225;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$5;
       i64toi32_i32$5 = $8$hi;
       i64toi32_i32$2 = $0;
       HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $8;
       HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$5;
       break label$1;
      }
      i64toi32_i32$1 = ($2 + 48 | 0) + 40 | 0;
      i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $233 = i64toi32_i32$5;
      i64toi32_i32$5 = $0 + 40 | 0;
      HEAP32[i64toi32_i32$5 >> 2] = $233;
      HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$1 = ($2 + 48 | 0) + 32 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $239 = i64toi32_i32$2;
      i64toi32_i32$2 = $0 + 32 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $239;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$5;
      i64toi32_i32$1 = ($2 + 48 | 0) + 24 | 0;
      i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $245 = i64toi32_i32$5;
      i64toi32_i32$5 = $0 + 24 | 0;
      HEAP32[i64toi32_i32$5 >> 2] = $245;
      HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$1 = ($2 + 48 | 0) + 16 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $251 = i64toi32_i32$2;
      i64toi32_i32$2 = $0 + 16 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $251;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$5;
      i64toi32_i32$5 = $8$hi;
      i64toi32_i32$2 = $0;
      HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $8;
      HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$5;
      break label$1;
     }
     i64toi32_i32$5 = 0;
     $7 = 0;
     $7$hi = i64toi32_i32$5;
     break label$1;
    }
    HEAP8[($0 + 8 | 0) >> 0] = $3;
    HEAP32[($0 + 16 | 0) >> 2] = 0;
    HEAP32[($0 + 12 | 0) >> 2] = $4;
    HEAP8[($0 + 10 | 0) >> 0] = $6;
    HEAP8[($0 + 9 | 0) >> 0] = 7;
   }
   i64toi32_i32$5 = 0;
   $7 = 1;
   $7$hi = i64toi32_i32$5;
  }
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$2 = $0;
  HEAP32[i64toi32_i32$2 >> 2] = $7;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$5;
  global$0 = $2 + 96 | 0;
 }
 
 function std__io__stdio___print__he842e74bc351a82b($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $2 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $6$hi = 0, $35 = 0, $36 = 0, $37 = 0, $38 = 0, $39 = 0, $40 = 0, $41 = 0, $42 = 0, $14 = 0, $19 = 0, $22 = 0, $53 = 0, $59 = 0, $62 = 0, $79 = 0, $79$hi = 0, $82 = 0, $82$hi = 0, $86$hi = 0, $88$hi = 0, $186 = 0, $192 = 0, $195 = 0, $235 = 0, $235$hi = 0, $238 = 0, $238$hi = 0, $242$hi = 0, $244$hi = 0, $246 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  i64toi32_i32$2 = $0 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $14;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $0 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $19;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $22 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[$1 >> 2] = $22;
  HEAP32[($1 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 28 | 0) >> 2] = 6;
  HEAP32[($1 + 24 | 0) >> 2] = 1143820;
  label$1 : {
   label$2 : {
    if (!(HEAPU8[(0 + 1178345 | 0) >> 0] | 0)) {
     break label$2
    }
    label$3 : {
     if ((HEAP32[(0 + 1177864 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     i64toi32_i32$0 = 0;
     i64toi32_i32$1 = 0;
     HEAP32[(i64toi32_i32$0 + 1177864 | 0) >> 2] = 1;
     HEAP32[(i64toi32_i32$0 + 1177868 | 0) >> 2] = i64toi32_i32$1;
     break label$2;
    }
    $0 = HEAP32[(0 + 1177868 | 0) >> 2] | 0;
    HEAP32[(0 + 1177868 | 0) >> 2] = 0;
    if (!$0) {
     break label$2
    }
    $2 = HEAPU8[($0 + 8 | 0) >> 0] | 0;
    $3 = 1;
    HEAP8[($0 + 8 | 0) >> 0] = 1;
    $2 = $2 & 1 | 0;
    HEAP8[($1 + 40 | 0) >> 0] = $2;
    label$4 : {
     if ($2) {
      break label$4
     }
     label$5 : {
      if (!((HEAP32[(0 + 1177836 | 0) >> 2] | 0) & 2147483647 | 0)) {
       break label$5
      }
      $3 = std__panicking__panic_count__is_zero_slow_path__h1d20871758c70487() | 0;
     }
     HEAP8[($1 + 44 | 0) >> 0] = 4;
     HEAP32[($1 + 40 | 0) >> 2] = $0 + 12 | 0;
     i64toi32_i32$2 = $1 + 16 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $53 = i64toi32_i32$1;
     i64toi32_i32$1 = ($1 + 56 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $53;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $1 + 8 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $59 = i64toi32_i32$0;
     i64toi32_i32$0 = ($1 + 56 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $59;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $1;
     i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $62 = i64toi32_i32$1;
     i64toi32_i32$1 = $1;
     HEAP32[($1 + 56 | 0) >> 2] = $62;
     HEAP32[($1 + 60 | 0) >> 2] = i64toi32_i32$0;
     $2 = core__fmt__write__h9b9aa23e7d35702c($1 + 40 | 0 | 0, 1143852 | 0, $1 + 56 | 0 | 0) | 0;
     $4 = HEAPU8[($1 + 44 | 0) >> 0] | 0;
     label$6 : {
      label$7 : {
       if (!$2) {
        break label$7
       }
       $2 = $4 & 255 | 0;
       if (($2 | 0) == (4 | 0)) {
        break label$6
       }
       if (($2 | 0) != (3 | 0)) {
        break label$6
       }
       i64toi32_i32$2 = $1;
       i64toi32_i32$0 = HEAPU8[($1 + 45 | 0) >> 0] | 0 | ((HEAPU8[($1 + 46 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 47 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 48 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = 0;
       $79 = i64toi32_i32$0;
       $79$hi = i64toi32_i32$1;
       i64toi32_i32$2 = $1 + 49 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
       i64toi32_i32$0 = 0;
       $82 = i64toi32_i32$1;
       $82$hi = i64toi32_i32$0;
       i64toi32_i32$2 = $1 + 51 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$2 = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $35 = 0;
       } else {
        i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $35 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       $86$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $82$hi;
       i64toi32_i32$1 = $82;
       i64toi32_i32$2 = $86$hi;
       i64toi32_i32$3 = $35;
       i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
       i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $36 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
        $36 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       $88$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $79$hi;
       i64toi32_i32$2 = $79;
       i64toi32_i32$0 = $88$hi;
       i64toi32_i32$3 = $36;
       i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
       i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 24;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = 0;
        $37 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
        $37 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
       }
       $2 = $37;
       FUNCTION_TABLE[HEAP32[(HEAP32[($2 + 4 | 0) >> 2] | 0) >> 2] | 0 | 0](HEAP32[$2 >> 2] | 0);
       label$8 : {
        $4 = HEAP32[($2 + 4 | 0) >> 2] | 0;
        $5 = HEAP32[($4 + 4 | 0) >> 2] | 0;
        if (!$5) {
         break label$8
        }
        __rust_dealloc(HEAP32[$2 >> 2] | 0 | 0, $5 | 0, HEAP32[($4 + 8 | 0) >> 2] | 0 | 0);
       }
       __rust_dealloc($2 | 0, 12 | 0, 4 | 0);
       break label$6;
      }
      if (($4 & 255 | 0 | 0) != (3 | 0)) {
       break label$6
      }
      $2 = HEAP32[($1 + 48 | 0) >> 2] | 0;
      FUNCTION_TABLE[HEAP32[(HEAP32[($2 + 4 | 0) >> 2] | 0) >> 2] | 0 | 0](HEAP32[$2 >> 2] | 0);
      label$9 : {
       $4 = HEAP32[($2 + 4 | 0) >> 2] | 0;
       $5 = HEAP32[($4 + 4 | 0) >> 2] | 0;
       if (!$5) {
        break label$9
       }
       __rust_dealloc(HEAP32[$2 >> 2] | 0 | 0, $5 | 0, HEAP32[($4 + 8 | 0) >> 2] | 0 | 0);
      }
      __rust_dealloc(HEAP32[($1 + 48 | 0) >> 2] | 0 | 0, 12 | 0, 4 | 0);
     }
     label$10 : {
      if (!$3) {
       break label$10
      }
      if (!((HEAP32[(0 + 1177836 | 0) >> 2] | 0) & 2147483647 | 0)) {
       break label$10
      }
      if (std__panicking__panic_count__is_zero_slow_path__h1d20871758c70487() | 0) {
       break label$10
      }
      HEAP8[($0 + 9 | 0) >> 0] = 1;
     }
     HEAP8[($0 + 8 | 0) >> 0] = 0;
     $3 = HEAP32[(0 + 1177868 | 0) >> 2] | 0;
     HEAP32[(0 + 1177868 | 0) >> 2] = $0;
     if (!$3) {
      break label$1
     }
     $0 = HEAP32[$3 >> 2] | 0;
     HEAP32[$3 >> 2] = $0 + -1 | 0;
     if (($0 | 0) != (1 | 0)) {
      break label$1
     }
     alloc__sync__Arc_T___drop_slow__h5db2bd229aad6626($3 | 0);
     break label$1;
    }
    HEAP32[($1 + 76 | 0) >> 2] = 0;
    HEAP32[($1 + 72 | 0) >> 2] = 1142260;
    i64toi32_i32$1 = $1;
    i64toi32_i32$2 = 0;
    HEAP32[($1 + 60 | 0) >> 2] = 1;
    HEAP32[($1 + 64 | 0) >> 2] = i64toi32_i32$2;
    HEAP32[($1 + 56 | 0) >> 2] = 1145368;
    core__panicking__assert_failed__h1e2384889c2d638e($1 + 40 | 0 | 0, $1 + 56 | 0 | 0);
    abort();
   }
   label$11 : {
    if ((HEAP32[(0 + 1177796 | 0) >> 2] | 0 | 0) == (3 | 0)) {
     break label$11
    }
    HEAP32[($1 + 32 | 0) >> 2] = 1177800;
    if ((HEAP32[(0 + 1177796 | 0) >> 2] | 0 | 0) == (3 | 0)) {
     break label$11
    }
    HEAP32[($1 + 40 | 0) >> 2] = $1 + 32 | 0;
    HEAP32[($1 + 56 | 0) >> 2] = $1 + 40 | 0;
    std__sync__once__Once__call_inner__hc44ad7f626385660(1177796 | 0, 1 | 0, $1 + 56 | 0 | 0, 1143928 | 0);
   }
   HEAP32[($1 + 32 | 0) >> 2] = 1177800;
   HEAP8[($1 + 44 | 0) >> 0] = 4;
   HEAP32[($1 + 40 | 0) >> 2] = $1 + 32 | 0;
   i64toi32_i32$0 = $1 + 16 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $186 = i64toi32_i32$2;
   i64toi32_i32$2 = ($1 + 56 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $186;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$0 = $1 + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $192 = i64toi32_i32$1;
   i64toi32_i32$1 = ($1 + 56 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $192;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = $1;
   i64toi32_i32$2 = HEAP32[$1 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   $195 = i64toi32_i32$2;
   i64toi32_i32$2 = $1;
   HEAP32[($1 + 56 | 0) >> 2] = $195;
   HEAP32[($1 + 60 | 0) >> 2] = i64toi32_i32$1;
   $3 = core__fmt__write__h9b9aa23e7d35702c($1 + 40 | 0 | 0, 1143876 | 0, $1 + 56 | 0 | 0) | 0;
   $0 = HEAPU8[($1 + 44 | 0) >> 0] | 0;
   label$12 : {
    label$13 : {
     label$14 : {
      if (!$3) {
       break label$14
      }
      if (($0 | 0) != (4 | 0)) {
       break label$13
      }
      i64toi32_i32$1 = 0;
      i64toi32_i32$0 = 1143844;
      i64toi32_i32$2 = 0;
      i64toi32_i32$3 = 32;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       $38 = 0;
      } else {
       i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
       $38 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
      }
      i64toi32_i32$1 = $38;
      i64toi32_i32$0 = 0;
      i64toi32_i32$3 = 8;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$0 = 0;
       $39 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
      } else {
       i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
       $39 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
      }
      i64toi32_i32$2 = $39;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 40;
      i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
      $6 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
      $6$hi = i64toi32_i32$1;
      $0 = 2;
      break label$12;
     }
     if (($0 | 0) != (3 | 0)) {
      break label$1
     }
     $0 = HEAP32[($1 + 48 | 0) >> 2] | 0;
     FUNCTION_TABLE[HEAP32[(HEAP32[($0 + 4 | 0) >> 2] | 0) >> 2] | 0 | 0](HEAP32[$0 >> 2] | 0);
     label$15 : {
      $3 = HEAP32[($0 + 4 | 0) >> 2] | 0;
      $2 = HEAP32[($3 + 4 | 0) >> 2] | 0;
      if (!$2) {
       break label$15
      }
      __rust_dealloc(HEAP32[$0 >> 2] | 0 | 0, $2 | 0, HEAP32[($3 + 8 | 0) >> 2] | 0 | 0);
     }
     __rust_dealloc(HEAP32[($1 + 48 | 0) >> 2] | 0 | 0, 12 | 0, 4 | 0);
     break label$1;
    }
    i64toi32_i32$0 = $1;
    i64toi32_i32$1 = HEAPU8[($1 + 45 | 0) >> 0] | 0 | ((HEAPU8[($1 + 46 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 47 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 48 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$2 = 0;
    $235 = i64toi32_i32$1;
    $235$hi = i64toi32_i32$2;
    i64toi32_i32$0 = $1 + 49 | 0;
    i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
    i64toi32_i32$1 = 0;
    $238 = i64toi32_i32$2;
    $238$hi = i64toi32_i32$1;
    i64toi32_i32$0 = $1 + 51 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$0 >> 0] | 0;
    i64toi32_i32$2 = 0;
    i64toi32_i32$0 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    i64toi32_i32$3 = 16;
    i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
     $40 = 0;
    } else {
     i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
     $40 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
    }
    $242$hi = i64toi32_i32$1;
    i64toi32_i32$1 = $238$hi;
    i64toi32_i32$2 = $238;
    i64toi32_i32$0 = $242$hi;
    i64toi32_i32$3 = $40;
    i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
    i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
    i64toi32_i32$2 = 0;
    i64toi32_i32$3 = 32;
    i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
     $41 = 0;
    } else {
     i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
     $41 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
    }
    $244$hi = i64toi32_i32$2;
    i64toi32_i32$2 = $235$hi;
    i64toi32_i32$0 = $235;
    i64toi32_i32$1 = $244$hi;
    i64toi32_i32$3 = $41;
    i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
    $6 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
    $6$hi = i64toi32_i32$1;
   }
   $246 = $1;
   i64toi32_i32$1 = $6$hi;
   i64toi32_i32$2 = $6;
   i64toi32_i32$0 = 0;
   i64toi32_i32$3 = 24;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$0 = 0;
    $42 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   } else {
    i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
    $42 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
   }
   HEAP32[($246 + 36 | 0) >> 2] = $42;
   i64toi32_i32$0 = $6$hi;
   HEAP32[($1 + 32 | 0) >> 2] = $6 << 8 | 0 | $0 | 0;
   HEAP32[($1 + 76 | 0) >> 2] = 2;
   HEAP32[($1 + 52 | 0) >> 2] = 272;
   i64toi32_i32$2 = $1;
   i64toi32_i32$0 = 0;
   HEAP32[($1 + 60 | 0) >> 2] = 2;
   HEAP32[($1 + 64 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($1 + 56 | 0) >> 2] = 1143788;
   HEAP32[($1 + 44 | 0) >> 2] = 271;
   HEAP32[($1 + 72 | 0) >> 2] = $1 + 40 | 0;
   HEAP32[($1 + 48 | 0) >> 2] = $1 + 32 | 0;
   HEAP32[($1 + 40 | 0) >> 2] = $1 + 24 | 0;
   std__panicking__begin_panic_fmt__h3dc1b0b65bbd6c17($1 + 56 | 0 | 0, 1143804 | 0);
   abort();
  }
  global$0 = $1 + 80 | 0;
 }
 
 function alloc__collections__btree__node__BalancingContext_K_2cV___bulk_steal_right__h8845d27dacdbfcf7($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $7 = 0, $16 = 0, $12 = 0, $21 = 0, $2 = 0, $4 = 0, $19 = 0, $3 = 0, $6 = 0, $10 = 0, $14 = 0, $8 = 0, $9 = 0, $13 = 0, $19$hi = 0, $21$hi = 0, $5 = 0, $33 = 0, $17 = 0, $20 = 0, $34 = 0, $22 = 0, $35 = 0, $18 = 0, $36 = 0, $37 = 0, $38 = 0, $20$hi = 0, $22$hi = 0, $11 = 0, $15 = 0, $70 = 0, $100 = 0, $157 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if (!$1) {
       break label$4
      }
      $3 = HEAP32[($0 + 16 | 0) >> 2] | 0;
      $4 = HEAPU16[($3 + 138 | 0) >> 1] | 0;
      $5 = $4 + $1 | 0;
      if ($5 >>> 0 > 11 >>> 0) {
       break label$3
      }
      label$5 : {
       label$6 : {
        label$7 : {
         $6 = HEAP32[($0 + 24 | 0) >> 2] | 0;
         $7 = HEAPU16[($6 + 138 | 0) >> 1] | 0;
         if ($7 >>> 0 < $1 >>> 0) {
          break label$7
         }
         HEAP16[($3 + 138 | 0) >> 1] = $5;
         $8 = $7 - $1 | 0;
         HEAP16[($6 + 138 | 0) >> 1] = $8;
         $9 = ($2 + 8 | 0) + 8 | 0;
         $10 = $1 + -1 | 0;
         $11 = Math_imul($10, 12);
         $7 = $6 + $11 | 0;
         HEAP32[$9 >> 2] = HEAP32[($7 + 12 | 0) >> 2] | 0;
         i64toi32_i32$2 = $7 + 4 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $70 = i64toi32_i32$0;
         i64toi32_i32$0 = $2;
         HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $70;
         HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
         $12 = HEAP32[($0 + 4 | 0) >> 2] | 0;
         $13 = HEAP32[($0 + 8 | 0) >> 2] | 0;
         $7 = $12 + Math_imul($13, 28) | 0;
         $14 = $7 + 140 | 0;
         i64toi32_i32$2 = $14;
         i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $19 = i64toi32_i32$1;
         $19$hi = i64toi32_i32$0;
         $15 = Math_imul($10, 28);
         $16 = $6 + $15 | 0;
         $33 = $16 + 164 | 0;
         $17 = HEAPU8[$33 >> 0] | 0 | ((HEAPU8[($33 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($33 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($33 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$2 = $16 + 156 | 0;
         i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $20 = i64toi32_i32$0;
         $20$hi = i64toi32_i32$1;
         i64toi32_i32$2 = $16 + 148 | 0;
         i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $21 = i64toi32_i32$1;
         $21$hi = i64toi32_i32$0;
         i64toi32_i32$2 = $16 + 140 | 0;
         i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $100 = i64toi32_i32$0;
         i64toi32_i32$0 = $14;
         $34 = $100;
         HEAP8[i64toi32_i32$0 >> 0] = $34;
         HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $34 >>> 8 | 0;
         HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $34 >>> 16 | 0;
         HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $34 >>> 24 | 0;
         HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
         HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
         HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
         HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
         $16 = $7 + 148 | 0;
         i64toi32_i32$2 = $16;
         i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $22 = i64toi32_i32$1;
         $22$hi = i64toi32_i32$0;
         i64toi32_i32$0 = $21$hi;
         i64toi32_i32$1 = i64toi32_i32$2;
         HEAP8[i64toi32_i32$2 >> 0] = $21;
         HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $21 >>> 8 | 0;
         HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $21 >>> 16 | 0;
         HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $21 >>> 24 | 0;
         HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$0;
         HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
         HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
         HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
         $16 = ($2 + 72 | 0) + 8 | 0;
         i64toi32_i32$0 = $22$hi;
         i64toi32_i32$1 = $16;
         HEAP32[i64toi32_i32$1 >> 2] = $22;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
         $14 = $7 + 156 | 0;
         i64toi32_i32$2 = $14;
         i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $21 = i64toi32_i32$0;
         $21$hi = i64toi32_i32$1;
         i64toi32_i32$1 = $20$hi;
         i64toi32_i32$0 = i64toi32_i32$2;
         $35 = $20;
         HEAP8[i64toi32_i32$2 >> 0] = $35;
         HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $35 >>> 8 | 0;
         HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $35 >>> 16 | 0;
         HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $35 >>> 24 | 0;
         HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$1;
         HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
         HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
         HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
         $14 = ($2 + 72 | 0) + 16 | 0;
         i64toi32_i32$1 = $21$hi;
         i64toi32_i32$0 = $14;
         HEAP32[i64toi32_i32$0 >> 2] = $21;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         $7 = $7 + 164 | 0;
         $18 = HEAPU8[$7 >> 0] | 0 | ((HEAPU8[($7 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($7 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($7 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $36 = $17;
         HEAP8[$7 >> 0] = $36;
         HEAP8[($7 + 1 | 0) >> 0] = $36 >>> 8 | 0;
         HEAP8[($7 + 2 | 0) >> 0] = $36 >>> 16 | 0;
         HEAP8[($7 + 3 | 0) >> 0] = $36 >>> 24 | 0;
         $7 = ($2 + 72 | 0) + 24 | 0;
         HEAP32[$7 >> 2] = $18;
         i64toi32_i32$1 = $19$hi;
         i64toi32_i32$0 = $2;
         HEAP32[(i64toi32_i32$0 + 72 | 0) >> 2] = $19;
         HEAP32[(i64toi32_i32$0 + 76 | 0) >> 2] = i64toi32_i32$1;
         $17 = (i64toi32_i32$0 + 24 | 0) + 8 | 0;
         $12 = $12 + Math_imul($13, 12) | 0;
         $13 = $12 + 12 | 0;
         $18 = HEAP32[$13 >> 2] | 0;
         HEAP32[$17 >> 2] = $18;
         $12 = $12 + 4 | 0;
         i64toi32_i32$2 = $12;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $19 = i64toi32_i32$1;
         $19$hi = i64toi32_i32$0;
         i64toi32_i32$1 = $2;
         HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = $19;
         HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$2 = i64toi32_i32$1;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
         $157 = i64toi32_i32$0;
         i64toi32_i32$0 = $12;
         HEAP32[i64toi32_i32$0 >> 2] = $157;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         HEAP32[$13 >> 2] = HEAP32[$9 >> 2] | 0;
         $9 = i64toi32_i32$2 + 108 | 0;
         HEAP32[$9 >> 2] = $18;
         i64toi32_i32$1 = $19$hi;
         i64toi32_i32$0 = i64toi32_i32$2;
         HEAP32[(i64toi32_i32$2 + 100 | 0) >> 2] = $19;
         HEAP32[(i64toi32_i32$2 + 104 | 0) >> 2] = i64toi32_i32$1;
         $12 = HEAP32[$7 >> 2] | 0;
         HEAP32[((i64toi32_i32$2 + 24 | 0) + 24 | 0) >> 2] = $12;
         i64toi32_i32$2 = $14;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $19 = i64toi32_i32$1;
         $19$hi = i64toi32_i32$0;
         i64toi32_i32$1 = ($2 + 24 | 0) + 16 | 0;
         HEAP32[i64toi32_i32$1 >> 2] = $19;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$2 = $16;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $20 = i64toi32_i32$0;
         $20$hi = i64toi32_i32$1;
         i64toi32_i32$0 = $17;
         HEAP32[i64toi32_i32$0 >> 2] = $20;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$2 = $2;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 72 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 76 | 0) >> 2] | 0;
         $21 = i64toi32_i32$1;
         $21$hi = i64toi32_i32$0;
         i64toi32_i32$1 = i64toi32_i32$2;
         HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] = $21;
         HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] = i64toi32_i32$0;
         $16 = HEAP32[$9 >> 2] | 0;
         HEAP32[((i64toi32_i32$2 + 56 | 0) + 8 | 0) >> 2] = $16;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 100 | 0) >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 104 | 0) >> 2] | 0;
         $22 = i64toi32_i32$0;
         $22$hi = i64toi32_i32$1;
         i64toi32_i32$0 = i64toi32_i32$2;
         HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] = $22;
         HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] = i64toi32_i32$1;
         $7 = $3 + Math_imul($4, 28) | 0;
         $37 = $7 + 164 | 0;
         HEAP8[$37 >> 0] = $12;
         HEAP8[($37 + 1 | 0) >> 0] = $12 >>> 8 | 0;
         HEAP8[($37 + 2 | 0) >> 0] = $12 >>> 16 | 0;
         HEAP8[($37 + 3 | 0) >> 0] = $12 >>> 24 | 0;
         i64toi32_i32$1 = $19$hi;
         i64toi32_i32$0 = $7 + 156 | 0;
         HEAP8[i64toi32_i32$0 >> 0] = $19;
         HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $19 >>> 8 | 0;
         HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $19 >>> 16 | 0;
         HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $19 >>> 24 | 0;
         HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
         HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
         HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
         HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
         i64toi32_i32$1 = $20$hi;
         i64toi32_i32$0 = $7 + 148 | 0;
         $38 = $20;
         HEAP8[i64toi32_i32$0 >> 0] = $38;
         HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $38 >>> 8 | 0;
         HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $38 >>> 16 | 0;
         HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $38 >>> 24 | 0;
         HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
         HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
         HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
         HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
         i64toi32_i32$1 = $21$hi;
         i64toi32_i32$0 = $7 + 140 | 0;
         HEAP8[i64toi32_i32$0 >> 0] = $21;
         HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $21 >>> 8 | 0;
         HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $21 >>> 16 | 0;
         HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $21 >>> 24 | 0;
         HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
         HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
         HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
         HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
         $7 = $3 + Math_imul($4, 12) | 0;
         i64toi32_i32$1 = $22$hi;
         i64toi32_i32$0 = $7 + 4 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $22;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         HEAP32[($7 + 12 | 0) >> 2] = $16;
         $7 = $4 + 1 | 0;
         if (($10 | 0) != ($5 - $7 | 0 | 0)) {
          break label$2
         }
         $16 = $6 + 140 | 0;
         memcpy(($3 + Math_imul($7, 28) | 0) + 140 | 0 | 0, $16 | 0, $15 | 0) | 0;
         $10 = $6 + 4 | 0;
         memcpy(($3 + Math_imul($7, 12) | 0) + 4 | 0 | 0, $10 | 0, $11 | 0) | 0;
         memmove($16 | 0, $16 + Math_imul($1, 28) | 0 | 0, Math_imul($8, 28) | 0) | 0;
         memmove($10 | 0, $10 + Math_imul($1, 12) | 0 | 0, Math_imul($8, 12) | 0) | 0;
         $16 = HEAP32[($0 + 12 | 0) >> 2] | 0;
         if (HEAP32[($0 + 20 | 0) >> 2] | 0) {
          break label$6
         }
         if (!$16) {
          break label$5
         }
         break label$1;
        }
        core__panicking__panic__h2fd385a887c8bf13(1049456 | 0, 40 | 0, 1049496 | 0);
        abort();
       }
       if (!$16) {
        break label$1
       }
       $0 = $6 + 448 | 0;
       $16 = $1 << 2 | 0;
       memcpy(($3 + ($7 << 2 | 0) | 0) + 448 | 0 | 0, $0 | 0, $16 | 0) | 0;
       memmove($0 | 0, $0 + $16 | 0 | 0, ($8 << 2 | 0) + 4 | 0 | 0) | 0;
       label$8 : {
        if ($5 >>> 0 <= $4 >>> 0) {
         break label$8
        }
        $0 = ($3 + ($4 << 2 | 0) | 0) + 452 | 0;
        label$9 : while (1) {
         $4 = HEAP32[$0 >> 2] | 0;
         HEAP16[($4 + 136 | 0) >> 1] = $7;
         HEAP32[$4 >> 2] = $3;
         $0 = $0 + 4 | 0;
         $7 = $7 + 1 | 0;
         $1 = $1 + -1 | 0;
         if ($1) {
          continue label$9
         }
         break label$9;
        };
       }
       if (($8 | 0) == (-1 | 0)) {
        break label$5
       }
       $7 = $6 + 448 | 0;
       $4 = $8 + 1 | 0;
       $0 = 0;
       label$10 : while (1) {
        $1 = HEAP32[$7 >> 2] | 0;
        HEAP16[($1 + 136 | 0) >> 1] = $0;
        HEAP32[$1 >> 2] = $6;
        $7 = $7 + 4 | 0;
        $0 = $0 + 1 | 0;
        if (($4 | 0) != ($0 | 0)) {
         continue label$10
        }
        break label$10;
       };
      }
      global$0 = $2 + 112 | 0;
      return;
     }
     core__panicking__panic__h2fd385a887c8bf13(1049148 | 0, 27 | 0, 1049372 | 0);
     abort();
    }
    core__panicking__panic__h2fd385a887c8bf13(1049388 | 0, 50 | 0, 1049440 | 0);
    abort();
   }
   core__panicking__panic__h2fd385a887c8bf13(1048988 | 0, 40 | 0, 1049028 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1049316 | 0, 40 | 0, 1049512 | 0);
  abort();
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__TransactionInputs___deserialize__hccdd71f9bd7c3281($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $10 = 0, $5 = 0, $7 = 0, $10$hi = 0, $11 = 0, $11$hi = 0, $12 = 0, $12$hi = 0, $33 = 0, $34 = 0, $35 = 0, $36 = 0, $37 = 0, $38 = 0, $39 = 0, $40 = 0, $41 = 0, $42 = 0, $43 = 0, $44 = 0, $45 = 0, $46 = 0, $4 = 0, $6 = 0, $8 = 0, $9 = 0, $13 = 0, $13$hi = 0, $156 = 0, $173 = 0, $177 = 0, $201 = 0, $205 = 0, $213 = 0, $217 = 0, $234 = 0, $238 = 0, $244 = 0, $271 = 0;
  $2 = global$0 - 304 | 0;
  global$0 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 20 | 0) >> 2] = 0;
  HEAP32[($2 + 24 | 0) >> 2] = i64toi32_i32$0;
  $3 = 0;
  HEAP32[($2 + 16 | 0) >> 2] = HEAP32[(0 + 1050220 | 0) >> 2] | 0;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 232 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2 + 248 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 240 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 244 | 0) >> 2] | 0;
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 232 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 236 | 0) >> 2] | 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
         break label$6
        }
        i64toi32_i32$2 = $10$hi;
        $4 = $10;
        label$7 : {
         i64toi32_i32$2 = $11$hi;
         i64toi32_i32$3 = $11;
         i64toi32_i32$1 = 0;
         i64toi32_i32$0 = 1;
         if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
          break label$7
         }
         if (!$4) {
          break label$3
         }
        }
        $5 = $2 + 241 | 0;
        $6 = $5 + 3 | 0;
        label$8 : {
         label$9 : while (1) {
          std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 8 | 0 | 0, $1 | 0);
          $3 = 0;
          $7 = 2;
          label$10 : {
           if (HEAP32[($2 + 12 | 0) >> 2] | 0) {
            break label$10
           }
           i64toi32_i32$3 = 0;
           $11 = 8;
           $11$hi = i64toi32_i32$3;
           i64toi32_i32$3 = 0;
           $10 = 0;
           $10$hi = i64toi32_i32$3;
           break label$4;
          }
          label$11 : {
           if ((($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[($2 + 8 | 0) >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) == (7 | 0)) {
            break label$11
           }
           cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__TransactionInput___deserialize__h84b981706980e1e2($2 + 232 | 0 | 0, $1 | 0);
           if ((HEAP32[($2 + 232 | 0) >> 2] | 0 | 0) == (1 | 0)) {
            break label$8
           }
           HEAP32[($2 + 216 | 0) >> 2] = HEAPU8[$5 >> 0] | 0 | ((HEAPU8[($5 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($5 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($5 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $33 = $6;
           $34 = HEAPU8[$33 >> 0] | 0 | ((HEAPU8[($33 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($33 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($33 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 219 | 0) >> 0] = $34;
           HEAP8[($2 + 220 | 0) >> 0] = $34 >>> 8 | 0;
           HEAP8[($2 + 221 | 0) >> 0] = $34 >>> 16 | 0;
           HEAP8[($2 + 222 | 0) >> 0] = $34 >>> 24 | 0;
           HEAP32[($2 + 200 | 0) >> 2] = HEAP32[($2 + 216 | 0) >> 2] | 0;
           $35 = HEAPU8[($2 + 219 | 0) >> 0] | 0 | ((HEAPU8[($2 + 220 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 221 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 222 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 203 | 0) >> 0] = $35;
           HEAP8[($2 + 204 | 0) >> 0] = $35 >>> 8 | 0;
           HEAP8[($2 + 205 | 0) >> 0] = $35 >>> 16 | 0;
           HEAP8[($2 + 206 | 0) >> 0] = $35 >>> 24 | 0;
           $8 = HEAPU8[($2 + 240 | 0) >> 0] | 0;
           $9 = HEAP32[($2 + 236 | 0) >> 2] | 0;
           i64toi32_i32$0 = $2;
           i64toi32_i32$3 = HEAP32[($2 + 248 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($2 + 252 | 0) >> 2] | 0;
           $10 = i64toi32_i32$3;
           $10$hi = i64toi32_i32$2;
           i64toi32_i32$0 = $2;
           i64toi32_i32$2 = HEAP32[($2 + 256 | 0) >> 2] | 0;
           i64toi32_i32$3 = HEAP32[($2 + 260 | 0) >> 2] | 0;
           $12 = i64toi32_i32$2;
           $12$hi = i64toi32_i32$3;
           i64toi32_i32$0 = $2;
           i64toi32_i32$3 = HEAP32[($2 + 264 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($2 + 268 | 0) >> 2] | 0;
           $13 = i64toi32_i32$3;
           $13$hi = i64toi32_i32$2;
           label$12 : {
            $7 = HEAP32[($2 + 24 | 0) >> 2] | 0;
            if ((HEAP32[($2 + 20 | 0) >> 2] | 0 | 0) != ($7 | 0)) {
             break label$12
            }
            alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hf274e025df11641c($2 + 16 | 0 | 0, $7 | 0, 1 | 0);
            $7 = HEAP32[($2 + 24 | 0) >> 2] | 0;
           }
           $3 = (HEAP32[($2 + 16 | 0) >> 2] | 0) + Math_imul($7, 36) | 0;
           HEAP8[($3 + 4 | 0) >> 0] = $8;
           HEAP32[$3 >> 2] = $9;
           $36 = $3 + 5 | 0;
           $37 = HEAP32[($2 + 200 | 0) >> 2] | 0;
           HEAP8[$36 >> 0] = $37;
           HEAP8[($36 + 1 | 0) >> 0] = $37 >>> 8 | 0;
           HEAP8[($36 + 2 | 0) >> 0] = $37 >>> 16 | 0;
           HEAP8[($36 + 3 | 0) >> 0] = $37 >>> 24 | 0;
           $38 = $3 + 8 | 0;
           $39 = HEAPU8[($2 + 203 | 0) >> 0] | 0 | ((HEAPU8[($2 + 204 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 205 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 206 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[$38 >> 0] = $39;
           HEAP8[($38 + 1 | 0) >> 0] = $39 >>> 8 | 0;
           HEAP8[($38 + 2 | 0) >> 0] = $39 >>> 16 | 0;
           HEAP8[($38 + 3 | 0) >> 0] = $39 >>> 24 | 0;
           i64toi32_i32$2 = $13$hi;
           i64toi32_i32$3 = $3 + 28 | 0;
           $40 = $13;
           HEAP8[i64toi32_i32$3 >> 0] = $40;
           HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $40 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $40 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $40 >>> 24 | 0;
           HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$2;
           HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
           i64toi32_i32$2 = $12$hi;
           i64toi32_i32$3 = $3 + 20 | 0;
           $41 = $12;
           HEAP8[i64toi32_i32$3 >> 0] = $41;
           HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $41 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $41 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $41 >>> 24 | 0;
           HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$2;
           HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
           i64toi32_i32$2 = $10$hi;
           i64toi32_i32$3 = $3 + 12 | 0;
           HEAP8[i64toi32_i32$3 >> 0] = $10;
           HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $10 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $10 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $10 >>> 24 | 0;
           HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$2;
           HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
           $3 = $7 + 1 | 0;
           HEAP32[($2 + 24 | 0) >> 2] = $3;
           i64toi32_i32$2 = $11$hi;
           i64toi32_i32$0 = $11;
           i64toi32_i32$3 = 0;
           i64toi32_i32$1 = 1;
           if ((i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | 0) {
            continue label$9
           }
           if ($3 >>> 0 < $4 >>> 0) {
            continue label$9
           }
           break label$3;
          }
          break label$9;
         };
         cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 232 | 0 | 0, $1 | 0);
         i64toi32_i32$1 = $2 + 248 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
         $10 = i64toi32_i32$0;
         $10$hi = i64toi32_i32$2;
         i64toi32_i32$1 = $2;
         i64toi32_i32$2 = HEAP32[($2 + 240 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($2 + 244 | 0) >> 2] | 0;
         $11 = i64toi32_i32$2;
         $11$hi = i64toi32_i32$0;
         i64toi32_i32$1 = $2;
         i64toi32_i32$0 = HEAP32[($2 + 232 | 0) >> 2] | 0;
         i64toi32_i32$2 = HEAP32[($2 + 236 | 0) >> 2] | 0;
         i64toi32_i32$1 = i64toi32_i32$0;
         i64toi32_i32$0 = 0;
         i64toi32_i32$3 = 1;
         if ((i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) | 0) {
          break label$5
         }
         i64toi32_i32$1 = $10$hi;
         i64toi32_i32$2 = $2 + 208 | 0;
         HEAP32[i64toi32_i32$2 >> 2] = $10;
         HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$1 = $11$hi;
         i64toi32_i32$2 = $2;
         HEAP32[($2 + 200 | 0) >> 2] = $11;
         HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$1;
         if (($11 & 255 | 0 | 0) == (5 | 0)) {
          break label$3
         }
         HEAP32[($2 + 232 | 0) >> 2] = 0;
         core__panicking__assert_failed__h96d8431cc974b591(0 | 0, $2 + 200 | 0 | 0, 1050312 | 0, $2 + 232 | 0 | 0, 1050348 | 0);
         abort();
        }
        i64toi32_i32$3 = $2 + 280 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $156 = i64toi32_i32$1;
        i64toi32_i32$1 = ($2 + 176 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $156;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
        HEAP32[(($2 + 160 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 300 | 0) >> 2] | 0;
        HEAP32[($2 + 216 | 0) >> 2] = HEAPU8[$5 >> 0] | 0 | ((HEAPU8[($5 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($5 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($5 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $42 = $5 + 3 | 0;
        $43 = HEAPU8[$42 >> 0] | 0 | ((HEAPU8[($42 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($42 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($42 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 219 | 0) >> 0] = $43;
        HEAP8[($2 + 220 | 0) >> 0] = $43 >>> 8 | 0;
        HEAP8[($2 + 221 | 0) >> 0] = $43 >>> 16 | 0;
        HEAP8[($2 + 222 | 0) >> 0] = $43 >>> 24 | 0;
        i64toi32_i32$3 = $2 + 272 | 0;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $173 = i64toi32_i32$2;
        i64toi32_i32$2 = $2;
        HEAP32[($2 + 176 | 0) >> 2] = $173;
        HEAP32[($2 + 180 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$3 = $2 + 292 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $177 = i64toi32_i32$1;
        i64toi32_i32$1 = $2;
        HEAP32[($2 + 160 | 0) >> 2] = $177;
        HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$2;
        $3 = HEAP32[($2 + 288 | 0) >> 2] | 0;
        i64toi32_i32$3 = $2;
        i64toi32_i32$2 = HEAP32[($2 + 248 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 252 | 0) >> 2] | 0;
        $11 = i64toi32_i32$2;
        $11$hi = i64toi32_i32$1;
        i64toi32_i32$3 = $2;
        i64toi32_i32$1 = HEAP32[($2 + 256 | 0) >> 2] | 0;
        i64toi32_i32$2 = HEAP32[($2 + 260 | 0) >> 2] | 0;
        $10 = i64toi32_i32$1;
        $10$hi = i64toi32_i32$2;
        i64toi32_i32$3 = $2;
        i64toi32_i32$2 = HEAP32[($2 + 264 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 268 | 0) >> 2] | 0;
        $12 = i64toi32_i32$2;
        $12$hi = i64toi32_i32$1;
        $7 = HEAPU8[($2 + 240 | 0) >> 0] | 0;
        HEAP32[($2 + 192 | 0) >> 2] = HEAP32[($2 + 216 | 0) >> 2] | 0;
        $44 = HEAPU8[($2 + 219 | 0) >> 0] | 0 | ((HEAPU8[($2 + 220 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 221 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 222 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 195 | 0) >> 0] = $44;
        HEAP8[($2 + 196 | 0) >> 0] = $44 >>> 8 | 0;
        HEAP8[($2 + 197 | 0) >> 0] = $44 >>> 16 | 0;
        HEAP8[($2 + 198 | 0) >> 0] = $44 >>> 24 | 0;
        if (($7 | 0) != (19 | 0)) {
         break label$4
        }
        break label$3;
       }
       i64toi32_i32$3 = $2 + 272 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $201 = i64toi32_i32$1;
       i64toi32_i32$1 = $2 + 184 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $201;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$3 = $2 + 264 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $205 = i64toi32_i32$2;
       i64toi32_i32$2 = $2;
       HEAP32[($2 + 176 | 0) >> 2] = $205;
       HEAP32[($2 + 180 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$3 = $2 + 256 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $12 = i64toi32_i32$1;
       $12$hi = i64toi32_i32$2;
       $7 = 2;
       break label$4;
      }
      i64toi32_i32$3 = $2 + 272 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $213 = i64toi32_i32$2;
      i64toi32_i32$2 = $2 + 184 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $213;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$3 = $2 + 264 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $217 = i64toi32_i32$1;
      i64toi32_i32$1 = $2;
      HEAP32[($2 + 176 | 0) >> 2] = $217;
      HEAP32[($2 + 180 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$3 = $2 + 256 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $12 = i64toi32_i32$2;
      $12$hi = i64toi32_i32$1;
     }
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$2 = $2 + 256 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $12;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $10$hi;
     i64toi32_i32$2 = $2 + 248 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $10;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $11$hi;
     i64toi32_i32$2 = ($2 + 232 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $11;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$3 = $2;
     i64toi32_i32$1 = HEAP32[($2 + 176 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[($2 + 180 | 0) >> 2] | 0;
     $234 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 264 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $234;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$3 = $2;
     i64toi32_i32$2 = HEAP32[($2 + 160 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 164 | 0) >> 2] | 0;
     $238 = i64toi32_i32$2;
     i64toi32_i32$2 = $2 + 284 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $238;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$3 = ($2 + 176 | 0) + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $244 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 272 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $244;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
     HEAP32[($2 + 292 | 0) >> 2] = HEAP32[(($2 + 160 | 0) + 8 | 0) >> 2] | 0;
     HEAP8[($2 + 232 | 0) >> 0] = $7;
     $45 = HEAP32[($2 + 192 | 0) >> 2] | 0;
     HEAP8[($2 + 233 | 0) >> 0] = $45;
     HEAP8[($2 + 234 | 0) >> 0] = $45 >>> 8 | 0;
     HEAP8[($2 + 235 | 0) >> 0] = $45 >>> 16 | 0;
     HEAP8[($2 + 236 | 0) >> 0] = $45 >>> 24 | 0;
     $46 = HEAPU8[($2 + 195 | 0) >> 0] | 0 | ((HEAPU8[($2 + 196 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 197 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 198 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($2 + 236 | 0) >> 0] = $46;
     HEAP8[($2 + 237 | 0) >> 0] = $46 >>> 8 | 0;
     HEAP8[($2 + 238 | 0) >> 0] = $46 >>> 16 | 0;
     HEAP8[($2 + 239 | 0) >> 0] = $46 >>> 24 | 0;
     HEAP32[($2 + 280 | 0) >> 2] = $3;
     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($2 + 96 | 0 | 0, $2 + 232 | 0 | 0, 1050364 | 0, 17 | 0);
     $1 = HEAPU8[($2 + 96 | 0) >> 0] | 0;
     if (($1 | 0) != (19 | 0)) {
      break label$2
     }
    }
    i64toi32_i32$3 = $2;
    i64toi32_i32$2 = HEAP32[($2 + 16 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
    $271 = i64toi32_i32$2;
    i64toi32_i32$2 = $0;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = $271;
    HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = HEAP32[($2 + 24 | 0) >> 2] | 0;
    $3 = 0;
    break label$1;
   }
   $3 = 1;
   memcpy($2 + 33 | 0 | 0, $2 + 96 | 0 | 1 | 0 | 0, 63 | 0) | 0;
   HEAP8[($0 + 8 | 0) >> 0] = $1;
   memcpy($0 + 9 | 0 | 0, $2 + 33 | 0 | 0, 63 | 0) | 0;
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h98bad0b07702c13e($2 + 16 | 0 | 0);
  }
  HEAP32[$0 >> 2] = $3;
  global$0 = $2 + 304 | 0;
 }
 
 function cardano_serialization_lib__tx_builder__TransactionBuilder__build_tx_unsafe__hd84bd9af0364abde($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, i64toi32_i32$2 = 0, $5 = 0, $6 = 0, $6$hi = 0, $4 = 0, $63 = 0, $83 = 0, $98 = 0, $104 = 0, $107 = 0, $117 = 0, $131 = 0, $149 = 0, $240 = 0, $243 = 0;
  $2 = global$0 - 752 | 0;
  global$0 = $2;
  cardano_serialization_lib__tx_builder__TransactionBuilder__build__h1126ee00e4941d94($2 + 280 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 280 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    memcpy($2 + 8 | 0 | 0, ($2 + 280 | 0) + 8 | 0 | 0, 272 | 0) | 0;
    HEAP8[($2 + 340 | 0) >> 0] = 3;
    HEAP32[($2 + 344 | 0) >> 2] = 0;
    HEAP32[($2 + 316 | 0) >> 2] = 0;
    HEAP32[($2 + 304 | 0) >> 2] = 0;
    HEAP32[($2 + 292 | 0) >> 2] = 0;
    HEAP32[($2 + 280 | 0) >> 2] = 0;
    cardano_serialization_lib__tx_builder__TransactionBuilder__get_combined_native_scripts__hf14076d78c87659b($2 + 736 | 0 | 0, $1 | 0);
    label$3 : {
     if (!(HEAP32[($2 + 736 | 0) >> 2] | 0)) {
      break label$3
     }
     $3 = HEAP32[(($2 + 736 | 0) + 8 | 0) >> 2] | 0;
     HEAP32[(($2 + 560 | 0) + 8 | 0) >> 2] = $3;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[($2 + 736 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 740 | 0) >> 2] | 0;
     $6 = i64toi32_i32$0;
     $6$hi = i64toi32_i32$1;
     i64toi32_i32$0 = $2;
     HEAP32[($2 + 560 | 0) >> 2] = $6;
     HEAP32[($2 + 564 | 0) >> 2] = i64toi32_i32$1;
     alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($2 + 656 | 0 | 0, $6 | 0, $3 | 0);
     $3 = $2 + 292 | 0;
     core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__NativeScripts____hdd7d461255ec800a($3 | 0);
     HEAP32[($3 + 8 | 0) >> 2] = HEAP32[(($2 + 656 | 0) + 8 | 0) >> 2] | 0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAP32[($2 + 656 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 660 | 0) >> 2] | 0;
     $63 = i64toi32_i32$1;
     i64toi32_i32$1 = $3;
     HEAP32[$3 >> 2] = $63;
     HEAP32[($3 + 4 | 0) >> 2] = i64toi32_i32$0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc3d6ec99c05cee40($2 + 560 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h0f78886c344617d4($2 + 560 | 0 | 0);
    }
    cardano_serialization_lib__tx_builder__TransactionBuilder__get_combined_plutus_scripts__he342d6c2d4187ac3($2 + 624 | 0 | 0, $1 | 0);
    label$4 : {
     if (!(HEAP32[($2 + 624 | 0) >> 2] | 0)) {
      break label$4
     }
     HEAP32[(($2 + 640 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 624 | 0) + 8 | 0) >> 2] | 0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[($2 + 624 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 628 | 0) >> 2] | 0;
     $83 = i64toi32_i32$0;
     i64toi32_i32$0 = $2;
     HEAP32[($2 + 640 | 0) >> 2] = $83;
     HEAP32[($2 + 644 | 0) >> 2] = i64toi32_i32$1;
     cardano_serialization_lib__tx_builder__tx_inputs_builder__PlutusWitnesses__collect__h298b5e0ce4f6a5da($2 + 656 | 0 | 0, $2 + 640 | 0 | 0);
     $3 = ($2 + 656 | 0) + 8 | 0;
     HEAP32[(($2 + 720 | 0) + 8 | 0) >> 2] = HEAP32[$3 >> 2] | 0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAP32[($2 + 656 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 660 | 0) >> 2] | 0;
     $98 = i64toi32_i32$1;
     i64toi32_i32$1 = $2;
     HEAP32[($2 + 720 | 0) >> 2] = $98;
     HEAP32[($2 + 724 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $2 + 676 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $104 = i64toi32_i32$0;
     i64toi32_i32$0 = ($2 + 560 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $104;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAP32[($2 + 668 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 672 | 0) >> 2] | 0;
     $107 = i64toi32_i32$1;
     i64toi32_i32$1 = $2;
     HEAP32[($2 + 560 | 0) >> 2] = $107;
     HEAP32[($2 + 564 | 0) >> 2] = i64toi32_i32$0;
     $4 = ($2 + 736 | 0) + 8 | 0;
     HEAP32[$4 >> 2] = HEAP32[($2 + 692 | 0) >> 2] | 0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[($2 + 684 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 688 | 0) >> 2] | 0;
     $117 = i64toi32_i32$0;
     i64toi32_i32$0 = $2;
     HEAP32[($2 + 736 | 0) >> 2] = $117;
     HEAP32[($2 + 740 | 0) >> 2] = i64toi32_i32$1;
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hc722e22117ee5940($2 + 656 | 0 | 0, $2 + 720 | 0 | 0);
     $5 = $2 + 316 | 0;
     core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__plutus__PlutusScripts____h6be1d55eac328b7f($5 | 0);
     HEAP32[($5 + 8 | 0) >> 2] = HEAP32[$3 >> 2] | 0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAP32[($2 + 656 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 660 | 0) >> 2] | 0;
     $131 = i64toi32_i32$1;
     i64toi32_i32$1 = $5;
     HEAP32[i64toi32_i32$1 >> 2] = $131;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     cardano_serialization_lib__TransactionWitnessSet__set_plutus_data__h01fb3bfe431fcf6c($2 + 280 | 0 | 0, $2 + 560 | 0 | 0);
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h1b9d2509f9812649($2 + 656 | 0 | 0, $2 + 736 | 0 | 0);
     $5 = $2 + 344 | 0;
     core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__plutus__Redeemers____hd7679bbdd61edccb($5 | 0);
     HEAP32[($5 + 8 | 0) >> 2] = HEAP32[$3 >> 2] | 0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[($2 + 656 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 660 | 0) >> 2] | 0;
     $149 = i64toi32_i32$0;
     i64toi32_i32$0 = $5;
     HEAP32[i64toi32_i32$0 >> 2] = $149;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     label$5 : {
      $3 = HEAP32[$4 >> 2] | 0;
      if (!$3) {
       break label$5
      }
      $5 = Math_imul($3, 80);
      $3 = (HEAP32[($2 + 736 | 0) >> 2] | 0) + 8 | 0;
      label$6 : while (1) {
       core__ptr__drop_in_place_cardano_serialization_lib__plutus__PlutusData___hfab843e66e0f9428_2($3 | 0);
       $3 = $3 + 80 | 0;
       $5 = $5 + -80 | 0;
       if ($5) {
        continue label$6
       }
       break label$6;
      };
     }
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h4c688d2d7e8a61fa($2 + 736 | 0 | 0);
     label$7 : {
      $5 = HEAP32[($2 + 568 | 0) >> 2] | 0;
      if (!$5) {
       break label$7
      }
      $3 = HEAP32[($2 + 560 | 0) >> 2] | 0;
      $5 = Math_imul($5, 48);
      label$8 : while (1) {
       core__ptr__drop_in_place_cardano_serialization_lib__plutus__PlutusData___hfab843e66e0f9428_2($3 | 0);
       $3 = $3 + 48 | 0;
       $5 = $5 + -48 | 0;
       if ($5) {
        continue label$8
       }
       break label$8;
      };
     }
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h36e817e704f6f25e($2 + 560 | 0 | 0);
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd4b44cb226d8311d($2 + 720 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h3633100df9c96e1e($2 + 720 | 0 | 0);
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h1bbffe174ae872d8($2 + 640 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h9b1d3bb47b46eeb8($2 + 640 | 0 | 0);
    }
    i64toi32_i32$1 = 0;
    $6 = 0;
    $6$hi = i64toi32_i32$1;
    label$9 : {
     i64toi32_i32$2 = $1;
     i64toi32_i32$1 = HEAP32[($1 + 328 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($1 + 332 | 0) >> 2] | 0;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$1 = 0;
     if ((i64toi32_i32$2 | 0) != (1 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | 0) {
      break label$9
     }
     label$10 : {
      label$11 : {
       if (HEAP32[($1 + 356 | 0) >> 2] | 0) {
        break label$11
       }
       HEAP32[($2 + 580 | 0) >> 2] = 0;
       break label$10;
      }
      $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h44c6d4679ef9fae6($2 + 560 | 0 | 0, $1 + 336 | 0 | 0);
     }
     $3 = $1 + 388 | 0;
     label$12 : {
      label$13 : {
       $5 = HEAP32[($1 + 376 | 0) >> 2] | 0;
       if ($5) {
        break label$13
       }
       HEAP32[($2 + 720 | 0) >> 2] = 0;
       break label$12;
      }
      alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($2 + 720 | 0 | 0, $5 | 0, HEAP32[($1 + 384 | 0) >> 2] | 0 | 0);
     }
     label$14 : {
      label$15 : {
       if (HEAP32[$3 >> 2] | 0) {
        break label$15
       }
       HEAP32[($2 + 736 | 0) >> 2] = 0;
       break label$14;
      }
      $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hc722e22117ee5940($2 + 736 | 0 | 0, $3 | 0);
     }
     memcpy($2 + 656 | 0 | 0, $2 + 560 | 0 | 0, 40 | 0) | 0;
     HEAP32[($2 + 704 | 0) >> 2] = HEAP32[(($2 + 720 | 0) + 8 | 0) >> 2] | 0;
     HEAP32[($2 + 716 | 0) >> 2] = HEAP32[(($2 + 736 | 0) + 8 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[($2 + 720 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 724 | 0) >> 2] | 0;
     $240 = i64toi32_i32$2;
     i64toi32_i32$2 = $2;
     HEAP32[($2 + 696 | 0) >> 2] = $240;
     HEAP32[($2 + 700 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$0 = HEAP32[($2 + 736 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[($2 + 740 | 0) >> 2] | 0;
     $243 = i64toi32_i32$0;
     i64toi32_i32$0 = $2;
     HEAP32[($2 + 708 | 0) >> 2] = $243;
     HEAP32[($2 + 712 | 0) >> 2] = i64toi32_i32$2;
     memcpy($2 + 560 | 0 | 0, $2 + 656 | 0 | 0, 64 | 0) | 0;
     i64toi32_i32$2 = 0;
     $6 = 1;
     $6$hi = i64toi32_i32$2;
    }
    memcpy($0 + 8 | 0 | 0, $2 + 8 | 0 | 0, 272 | 0) | 0;
    memcpy($0 + 352 | 0 | 0, $2 + 280 | 0 | 0, 76 | 0) | 0;
    memcpy($0 + 288 | 0 | 0, $2 + 560 | 0 | 0, 64 | 0) | 0;
    HEAP8[($0 + 428 | 0) >> 0] = 1;
    i64toi32_i32$2 = $6$hi;
    i64toi32_i32$0 = $0 + 280 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $6;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    HEAP32[$0 >> 2] = 0;
    break label$1;
   }
   $3 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($2 + 284 | 0) >> 2] | 0 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
   HEAP32[($0 + 4 | 0) >> 2] = $3;
  }
  global$0 = $2 + 752 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__SingleHostName___deserialize_as_embedded_group__h8d6b3aa19718808b($0, $1, $2, $2$hi, $3, $3$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  var $4 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$4 = 0, $5 = 0, $11 = 0, $11$hi = 0, $6 = 0, $10 = 0, $10$hi = 0, $12 = 0, $12$hi = 0, $7 = 0, $34 = 0, $35 = 0, $36 = 0, $37 = 0, $13 = 0, $13$hi = 0, $8 = 0, $9 = 0, $110 = 0, $110$hi = 0, $114$hi = 0, $116$hi = 0, $119 = 0, $119$hi = 0, $120 = 0, $120$hi = 0, $123$hi = 0;
  $4 = global$0 - 384 | 0;
  global$0 = $4;
  cbor_event__de__Deserializer_R___unsigned_integer__h1ed99c0b7fe7eea1($4 + 312 | 0 | 0, $1 | 0);
  i64toi32_i32$0 = 0;
  $10 = 1;
  $10$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[($4 + 320 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($4 + 324 | 0) >> 2] | 0;
  $11 = i64toi32_i32$0;
  $11$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           label$10 : {
            label$11 : {
             i64toi32_i32$2 = $4;
             i64toi32_i32$1 = HEAP32[($4 + 312 | 0) >> 2] | 0;
             i64toi32_i32$0 = HEAP32[($4 + 316 | 0) >> 2] | 0;
             i64toi32_i32$2 = i64toi32_i32$1;
             i64toi32_i32$1 = 0;
             i64toi32_i32$3 = 1;
             if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
              break label$11
             }
             i64toi32_i32$2 = $11$hi;
             i64toi32_i32$3 = $11;
             i64toi32_i32$0 = 0;
             i64toi32_i32$1 = 1;
             if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) | 0) {
              break label$9
             }
             $5 = 8;
             $6 = 1;
             $7 = 1;
             break label$10;
            }
            i64toi32_i32$3 = $11$hi;
            i64toi32_i32$1 = $11;
            i64toi32_i32$2 = 0;
            i64toi32_i32$0 = 32;
            i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
            if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
             i64toi32_i32$2 = 0;
             $34 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
            } else {
             i64toi32_i32$2 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
             $34 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
            }
            $8 = $34;
            i64toi32_i32$3 = $4 + 352 | 0;
            i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
            i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
            $12 = i64toi32_i32$2;
            $12$hi = i64toi32_i32$1;
            i64toi32_i32$3 = $4 + 344 | 0;
            i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
            i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
            $10 = i64toi32_i32$1;
            $10$hi = i64toi32_i32$2;
            $9 = HEAP32[($4 + 340 | 0) >> 2] | 0;
            $6 = HEAP32[($4 + 336 | 0) >> 2] | 0;
            i64toi32_i32$2 = $11$hi;
            $7 = $11;
            $5 = 2;
            i64toi32_i32$3 = $4 + 328 | 0;
            i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
            i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
            $11 = i64toi32_i32$2;
            $11$hi = i64toi32_i32$1;
           }
           i64toi32_i32$1 = $12$hi;
           i64toi32_i32$2 = $4 + 352 | 0;
           HEAP32[i64toi32_i32$2 >> 2] = $12;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
           i64toi32_i32$1 = $10$hi;
           i64toi32_i32$2 = $4 + 344 | 0;
           HEAP32[i64toi32_i32$2 >> 2] = $10;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
           HEAP32[($4 + 340 | 0) >> 2] = $9;
           HEAP32[($4 + 336 | 0) >> 2] = $6;
           i64toi32_i32$1 = $11$hi;
           i64toi32_i32$2 = $4 + 328 | 0;
           HEAP32[i64toi32_i32$2 >> 2] = $11;
           HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
           HEAP32[($4 + 324 | 0) >> 2] = $8;
           HEAP32[(($4 + 312 | 0) + 8 | 0) >> 2] = $7;
           HEAP32[($4 + 360 | 0) >> 2] = 0;
           HEAP8[($4 + 312 | 0) >> 0] = $5;
           cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($4 + 96 | 0 | 0, $4 + 312 | 0 | 0, 1050766 | 0, 7 | 0);
           $5 = HEAPU8[($4 + 96 | 0) >> 0] | 0;
           if (($5 | 0) != (19 | 0)) {
            break label$8
           }
          }
          std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($4 | 0, $1 | 0);
          label$12 : {
           if (HEAP32[($4 + 4 | 0) >> 2] | 0) {
            break label$12
           }
           i64toi32_i32$1 = 0;
           $11 = 0;
           $11$hi = i64toi32_i32$1;
           i64toi32_i32$1 = 0;
           $10 = 8;
           $10$hi = i64toi32_i32$1;
           $1 = 2;
           break label$3;
          }
          label$13 : {
           label$14 : {
            if ((($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[$4 >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) != (7 | 0)) {
             break label$14
            }
            cbor_event__de__Deserializer_R___special__h10e912d855f56298($4 + 240 | 0 | 0, $1 | 0);
            $5 = HEAPU8[($4 + 248 | 0) >> 0] | 0;
            i64toi32_i32$3 = $4;
            i64toi32_i32$1 = HEAP32[($4 + 240 | 0) >> 2] | 0;
            i64toi32_i32$2 = HEAP32[($4 + 244 | 0) >> 2] | 0;
            i64toi32_i32$3 = i64toi32_i32$1;
            i64toi32_i32$1 = 0;
            i64toi32_i32$0 = 1;
            if ((i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$1 | 0) | 0) {
             break label$13
            }
            if (($5 & 255 | 0 | 0) == (1 | 0)) {
             break label$7
            }
            $1 = 6;
            break label$3;
           }
           $u16_20as_20cbor_event__de__Deserialize___deserialize__h16dd941998750727($4 + 240 | 0 | 0, $1 | 0);
           $5 = 1;
           if ((HEAPU16[($4 + 240 | 0) >> 1] | 0 | 0) == (1 | 0)) {
            break label$5
           }
           $6 = HEAPU16[($4 + 242 | 0) >> 1] | 0;
           break label$6;
          }
          i64toi32_i32$0 = $4;
          i64toi32_i32$3 = HEAPU8[($4 + 249 | 0) >> 0] | 0 | ((HEAPU8[($4 + 250 | 0) >> 0] | 0) << 8 | 0) | 0;
          i64toi32_i32$2 = 0;
          $110 = i64toi32_i32$3;
          $110$hi = i64toi32_i32$2;
          i64toi32_i32$0 = $4 + 251 | 0;
          i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0;
          i64toi32_i32$3 = 0;
          i64toi32_i32$0 = i64toi32_i32$2;
          i64toi32_i32$2 = 0;
          i64toi32_i32$1 = 16;
          i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
          if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
           i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
           $35 = 0;
          } else {
           i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$4 | 0) | 0;
           $35 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
          }
          $114$hi = i64toi32_i32$2;
          i64toi32_i32$2 = $110$hi;
          i64toi32_i32$3 = $110;
          i64toi32_i32$0 = $114$hi;
          i64toi32_i32$1 = $35;
          i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
          i64toi32_i32$2 = i64toi32_i32$3 | i64toi32_i32$1 | 0;
          i64toi32_i32$3 = 0;
          i64toi32_i32$1 = 8;
          i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
          if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
           i64toi32_i32$3 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
           $36 = 0;
          } else {
           i64toi32_i32$3 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
           $36 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
          }
          $116$hi = i64toi32_i32$3;
          i64toi32_i32$3 = 0;
          i64toi32_i32$0 = $5;
          i64toi32_i32$2 = 0;
          i64toi32_i32$1 = 255;
          i64toi32_i32$2 = i64toi32_i32$3 & i64toi32_i32$2 | 0;
          $119 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
          $119$hi = i64toi32_i32$2;
          i64toi32_i32$2 = $116$hi;
          i64toi32_i32$3 = $36;
          i64toi32_i32$0 = $119$hi;
          i64toi32_i32$1 = $119;
          i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
          $120 = i64toi32_i32$3 | i64toi32_i32$1 | 0;
          $120$hi = i64toi32_i32$0;
          i64toi32_i32$2 = $4;
          i64toi32_i32$0 = HEAP32[($4 + 252 | 0) >> 2] | 0;
          i64toi32_i32$3 = 0;
          i64toi32_i32$2 = i64toi32_i32$0;
          i64toi32_i32$0 = 0;
          i64toi32_i32$1 = 32;
          i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
          if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
           i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
           $37 = 0;
          } else {
           i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$4 | 0) | 0;
           $37 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
          }
          $123$hi = i64toi32_i32$0;
          i64toi32_i32$0 = $120$hi;
          i64toi32_i32$3 = $120;
          i64toi32_i32$2 = $123$hi;
          i64toi32_i32$1 = $37;
          i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
          $10 = i64toi32_i32$3 | i64toi32_i32$1 | 0;
          $10$hi = i64toi32_i32$2;
          i64toi32_i32$0 = $4 + 280 | 0;
          i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
          i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
          $13 = i64toi32_i32$2;
          $13$hi = i64toi32_i32$3;
          i64toi32_i32$0 = $4 + 272 | 0;
          i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
          i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
          $12 = i64toi32_i32$3;
          $12$hi = i64toi32_i32$2;
          $6 = HEAP32[($4 + 268 | 0) >> 2] | 0;
          $5 = HEAP32[($4 + 264 | 0) >> 2] | 0;
          i64toi32_i32$0 = $4 + 256 | 0;
          i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
          i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
          $11 = i64toi32_i32$2;
          $11$hi = i64toi32_i32$3;
          break label$4;
         }
         memcpy($4 + 240 | 0 | 0, $4 + 96 | 0 | 1 | 0 | 0, 63 | 0) | 0;
         HEAP8[($0 + 8 | 0) >> 0] = $5;
         memcpy($0 + 9 | 0 | 0, $4 + 240 | 0 | 0, 63 | 0) | 0;
         HEAP32[$0 >> 2] = 1;
         break label$1;
        }
        $5 = 0;
       }
       cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__DNSRecordAorAAAA___deserialize__hd54709d96c351cb8($4 + 312 | 0 | 0, $1 | 0);
       if ((HEAP32[($4 + 312 | 0) >> 2] | 0 | 0) == (1 | 0)) {
        break label$2
       }
       $1 = HEAP32[(($4 + 312 | 0) + 12 | 0) >> 2] | 0;
       HEAP32[($4 + 16 | 0) >> 2] = $1;
       i64toi32_i32$0 = $4;
       i64toi32_i32$3 = HEAP32[($4 + 316 | 0) >> 2] | 0;
       i64toi32_i32$2 = HEAP32[($4 + 320 | 0) >> 2] | 0;
       $11 = i64toi32_i32$3;
       $11$hi = i64toi32_i32$2;
       i64toi32_i32$3 = $4;
       HEAP32[($4 + 8 | 0) >> 2] = $11;
       HEAP32[($4 + 12 | 0) >> 2] = i64toi32_i32$2;
       HEAP32[($0 + 12 | 0) >> 2] = $1;
       i64toi32_i32$3 = $0;
       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = $11;
       HEAP32[(i64toi32_i32$3 + 8 | 0) >> 2] = i64toi32_i32$2;
       HEAP16[(i64toi32_i32$3 + 18 | 0) >> 1] = $6;
       HEAP16[(i64toi32_i32$3 + 16 | 0) >> 1] = $5;
       HEAP32[i64toi32_i32$3 >> 2] = 0;
       break label$1;
      }
      i64toi32_i32$0 = $4 + 280 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
      $13 = i64toi32_i32$2;
      $13$hi = i64toi32_i32$3;
      i64toi32_i32$0 = $4 + 272 | 0;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
      $12 = i64toi32_i32$3;
      $12$hi = i64toi32_i32$2;
      $6 = HEAP32[($4 + 268 | 0) >> 2] | 0;
      $5 = HEAP32[($4 + 264 | 0) >> 2] | 0;
      i64toi32_i32$0 = $4 + 256 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
      $11 = i64toi32_i32$2;
      $11$hi = i64toi32_i32$3;
      i64toi32_i32$0 = $4 + 248 | 0;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
      $10 = i64toi32_i32$3;
      $10$hi = i64toi32_i32$2;
     }
     $1 = 2;
    }
    i64toi32_i32$2 = $13$hi;
    i64toi32_i32$3 = $4 + 280 | 0;
    HEAP32[i64toi32_i32$3 >> 2] = $13;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $12$hi;
    i64toi32_i32$3 = $4 + 272 | 0;
    HEAP32[i64toi32_i32$3 >> 2] = $12;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
    HEAP32[($4 + 268 | 0) >> 2] = $6;
    HEAP32[($4 + 264 | 0) >> 2] = $5;
    i64toi32_i32$2 = $11$hi;
    i64toi32_i32$3 = $4 + 256 | 0;
    HEAP32[i64toi32_i32$3 >> 2] = $11;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $10$hi;
    i64toi32_i32$3 = ($4 + 240 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$3 >> 2] = $10;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
    HEAP32[($4 + 288 | 0) >> 2] = 0;
    HEAP8[($4 + 240 | 0) >> 0] = $1;
    $1 = ($4 + 312 | 0) + 8 | 0;
    cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 240 | 0 | 0, 1051422 | 0, 4 | 0);
    memcpy($0 + 8 | 0 | 0, memcpy($4 + 98 | 0 | 0, $1 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    break label$1;
   }
   memcpy($4 + 312 | 0 | 0, memcpy($4 + 168 | 0 | 4 | 0 | 0, memcpy($4 + 240 | 0 | 4 | 0 | 0, ($4 + 312 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   $1 = ($4 + 96 | 0) + 8 | 0;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 312 | 0 | 0, 1051448 | 0, 8 | 0);
   memcpy($0 + 8 | 0 | 0, memcpy($4 + 24 | 0 | 4 | 0 | 0, $1 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $4 + 384 | 0;
 }
 
 function $cardano_serialization_lib__plutus__PlutusDataEnum_20as_20core__cmp__Ord___cmp__ha7781ffdcafff597($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $4 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, $5 = 0, $6 = 0, $5$hi = 0, $6$hi = 0, $30 = 0, $98 = 0, $105 = 0, $108 = 0, $122 = 0, $129 = 0, $132 = 0;
  $2 = global$0 - 208 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    $3 = HEAP32[$0 >> 2] | 0;
    $4 = HEAP32[$1 >> 2] | 0;
    if (($3 | 0) == ($4 | 0)) {
     break label$2
    }
    $3 = $3 >>> 0 < $4 >>> 0 ? -1 : 1;
    break label$1;
   }
   label$3 : {
    switch ($3 | 0) {
    default:
     i64toi32_i32$2 = $0 + 8 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $5 = i64toi32_i32$0;
     $5$hi = i64toi32_i32$1;
     i64toi32_i32$2 = $1 + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $6 = i64toi32_i32$1;
     $6$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $5$hi;
     i64toi32_i32$2 = $5;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$3 = $6;
     $30 = (i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$0;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$2 = i64toi32_i32$0;
     i64toi32_i32$3 = $5;
     i64toi32_i32$0 = i64toi32_i32$1;
     i64toi32_i32$1 = $6;
     $3 = i64toi32_i32$2 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0 | 0) | 0 ? -1 : $30;
     if ($3) {
      break label$1
     }
     $3 = $A_20as_20core__slice__cmp__SliceOrd___compare__hf1814e963025920c(HEAP32[($0 + 16 | 0) >> 2] | 0 | 0, HEAP32[($0 + 24 | 0) >> 2] | 0 | 0, HEAP32[($1 + 16 | 0) >> 2] | 0 | 0, HEAP32[($1 + 24 | 0) >> 2] | 0 | 0) | 0;
     if ($3 & 255 | 0) {
      break label$1
     }
     label$8 : {
      $0 = HEAPU8[($0 + 28 | 0) >> 0] | 0;
      $3 = ($0 | 0) != (2 | 0);
      $1 = HEAPU8[($1 + 28 | 0) >> 0] | 0;
      $4 = ($1 | 0) != (2 | 0);
      if (($3 | 0) == ($4 | 0)) {
       break label$8
      }
      $3 = $4 ? ($3 ? 1 : -1) : 1;
      break label$1;
     }
     $3 = 0;
     if (($0 | 0) == (2 | 0)) {
      break label$1
     }
     if (($1 | 0) == (2 | 0)) {
      break label$1
     }
     global$0 = $2 + 208 | 0;
     return $0 - $1 | 0 | 0;
    case 1:
     alloc__collections__btree__map__BTreeMap_K_2cV___iter__h1146c826d3183069($2 + 80 | 0 | 0, $0 + 4 | 0 | 0);
     alloc__collections__btree__map__BTreeMap_K_2cV___iter__h1146c826d3183069($2 + 112 | 0 | 0, $1 + 4 | 0 | 0);
     HEAP32[(($2 + 144 | 0) + 24 | 0) >> 2] = HEAP32[(($2 + 80 | 0) + 24 | 0) >> 2] | 0;
     i64toi32_i32$1 = ($2 + 80 | 0) + 16 | 0;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $98 = i64toi32_i32$3;
     i64toi32_i32$3 = ($2 + 144 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $98;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$1 = ($2 + 80 | 0) + 8 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $105 = i64toi32_i32$2;
     i64toi32_i32$2 = ($2 + 144 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $105;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$1 = $2;
     i64toi32_i32$3 = HEAP32[($2 + 80 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[($2 + 84 | 0) >> 2] | 0;
     $108 = i64toi32_i32$3;
     i64toi32_i32$3 = $2;
     HEAP32[($2 + 144 | 0) >> 2] = $108;
     HEAP32[($2 + 148 | 0) >> 2] = i64toi32_i32$2;
     HEAP32[(($2 + 176 | 0) + 24 | 0) >> 2] = HEAP32[(($2 + 112 | 0) + 24 | 0) >> 2] | 0;
     i64toi32_i32$1 = ($2 + 112 | 0) + 16 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $122 = i64toi32_i32$2;
     i64toi32_i32$2 = ($2 + 176 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $122;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$1 = ($2 + 112 | 0) + 8 | 0;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $129 = i64toi32_i32$3;
     i64toi32_i32$3 = ($2 + 176 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $129;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$1 = $2;
     i64toi32_i32$2 = HEAP32[($2 + 112 | 0) >> 2] | 0;
     i64toi32_i32$3 = HEAP32[($2 + 116 | 0) >> 2] | 0;
     $132 = i64toi32_i32$2;
     i64toi32_i32$2 = $2;
     HEAP32[($2 + 176 | 0) >> 2] = $132;
     HEAP32[($2 + 180 | 0) >> 2] = i64toi32_i32$3;
     $3 = core__iter__traits__iterator__Iterator__cmp_by__hdd4c1d302d53018c($2 + 144 | 0 | 0, $2 + 176 | 0 | 0) | 0;
     break label$1;
    case 2:
     $3 = $A_20as_20core__slice__cmp__SliceOrd___compare__hf1814e963025920c(HEAP32[($0 + 4 | 0) >> 2] | 0 | 0, HEAP32[($0 + 12 | 0) >> 2] | 0 | 0, HEAP32[($1 + 4 | 0) >> 2] | 0 | 0, HEAP32[($1 + 12 | 0) >> 2] | 0 | 0) | 0;
     if ($3 & 255 | 0) {
      break label$1
     }
     label$9 : {
      $0 = HEAPU8[($0 + 16 | 0) >> 0] | 0;
      $3 = ($0 | 0) != (2 | 0);
      $1 = HEAPU8[($1 + 16 | 0) >> 0] | 0;
      $4 = ($1 | 0) != (2 | 0);
      if (($3 | 0) == ($4 | 0)) {
       break label$9
      }
      $3 = $4 ? ($3 ? 1 : -1) : 1;
      break label$1;
     }
     $3 = 0;
     if (($0 | 0) == (2 | 0)) {
      break label$1
     }
     if (($1 | 0) == (2 | 0)) {
      break label$1
     }
     global$0 = $2 + 208 | 0;
     return $0 - $1 | 0 | 0;
    case 3:
     label$10 : {
      $4 = HEAPU8[($0 + 16 | 0) >> 0] | 0;
      $3 = HEAPU8[($1 + 16 | 0) >> 0] | 0;
      if (($4 | 0) == ($3 | 0)) {
       break label$10
      }
      $3 = $4 >>> 0 < $3 >>> 0 ? -1 : 1;
      break label$1;
     }
     $1 = $1 + 4 | 0;
     $0 = $0 + 4 | 0;
     $3 = 0;
     label$11 : {
      switch ($4 | 0) {
      default:
       $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h7a0ed8a251b429e6($2 + 24 | 0 | 0, $1 | 0);
       $4 = HEAP32[($2 + 24 | 0) >> 2] | 0;
       $1 = HEAP32[($2 + 28 | 0) >> 2] | 0;
       $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h7a0ed8a251b429e6($2 + 16 | 0 | 0, $0 | 0);
       $0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
       $3 = $1 >>> 0 < $0 >>> 0 ? -1 : ($1 | 0) != ($0 | 0);
       if ($3) {
        break label$1
       }
       $3 = HEAP32[($2 + 16 | 0) >> 2] | 0;
       core__iter__adapters__rev__Rev_T___new__h91ca0d56df8c38ae($2 + 8 | 0 | 0, $4 | 0, $4 + ($1 << 2 | 0) | 0 | 0);
       $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
       $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
       core__iter__adapters__rev__Rev_T___new__h91ca0d56df8c38ae($2 | 0, $3 | 0, $3 + ($0 << 2 | 0) | 0 | 0);
       $3 = core__iter__traits__iterator__Iterator__cmp__he292810785df7a3c($4 | 0, $1 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0) | 0;
       break label$1;
      case 1:
       break label$1;
      case 2:
       break label$11;
      };
     }
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h7a0ed8a251b429e6($2 + 56 | 0 | 0, $0 | 0);
     $4 = HEAP32[($2 + 56 | 0) >> 2] | 0;
     $0 = HEAP32[($2 + 60 | 0) >> 2] | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h7a0ed8a251b429e6($2 + 48 | 0 | 0, $1 | 0);
     $1 = HEAP32[($2 + 52 | 0) >> 2] | 0;
     $3 = $0 >>> 0 < $1 >>> 0 ? -1 : ($0 | 0) != ($1 | 0);
     if ($3) {
      break label$1
     }
     $3 = HEAP32[($2 + 48 | 0) >> 2] | 0;
     core__iter__adapters__rev__Rev_T___new__h91ca0d56df8c38ae($2 + 40 | 0 | 0, $4 | 0, $4 + ($0 << 2 | 0) | 0 | 0);
     $0 = HEAP32[($2 + 44 | 0) >> 2] | 0;
     $4 = HEAP32[($2 + 40 | 0) >> 2] | 0;
     core__iter__adapters__rev__Rev_T___new__h91ca0d56df8c38ae($2 + 32 | 0 | 0, $3 | 0, $3 + ($1 << 2 | 0) | 0 | 0);
     $3 = core__iter__traits__iterator__Iterator__cmp__he292810785df7a3c($4 | 0, $0 | 0, HEAP32[($2 + 32 | 0) >> 2] | 0 | 0, HEAP32[($2 + 36 | 0) >> 2] | 0 | 0) | 0;
     break label$1;
    case 4:
     break label$3;
    };
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 72 | 0 | 0, $0 + 4 | 0 | 0);
   $0 = HEAP32[($2 + 76 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 72 | 0) >> 2] | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 64 | 0 | 0, $1 + 4 | 0 | 0);
   $3 = core__slice__cmp___impl_20core__cmp__Ord_20for_20_5bT_5d___cmp__h1f2092e0ba2f27ea($3 | 0, $0 | 0, HEAP32[($2 + 64 | 0) >> 2] | 0 | 0, HEAP32[($2 + 68 | 0) >> 2] | 0 | 0) | 0;
  }
  global$0 = $2 + 208 | 0;
  return $3 | 0;
 }
 
 function cryptoxide__curve25519__fe__fe64__Fe__square_repeatdly__h27bbbe5ee7c76e99($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, i64toi32_i32$5 = 0, $3 = 0, $8$hi = 0, $7$hi = 0, $8 = 0, $5$hi = 0, $7 = 0, $4$hi = 0, $6$hi = 0, $5 = 0, $4 = 0, $6 = 0, $9$hi = 0, $10$hi = 0, $9 = 0, $10 = 0, $12$hi = 0, $12 = 0, $13$hi = 0, $14$hi = 0, $173 = 0, $175 = 0, $176 = 0, $177 = 0, $178 = 0, $179 = 0, $181 = 0, $13 = 0, $182 = 0, $183 = 0, $185 = 0, $14 = 0, $186 = 0, $187 = 0, $188 = 0, $190 = 0, $191 = 0, $192 = 0, $193 = 0, $43$hi = 0, $194 = 0, $46 = 0, $57$hi = 0, $195 = 0, $76 = 0, $84$hi = 0, $196 = 0, $102 = 0, $102$hi = 0, $106 = 0, $106$hi = 0, $109 = 0, $109$hi = 0, $114 = 0, $114$hi = 0, $118 = 0, $118$hi = 0, $121 = 0, $121$hi = 0, $125 = 0, $125$hi = 0, $129 = 0, $129$hi = 0, $130$hi = 0, $133 = 0, $134$hi = 0, $135$hi = 0, $139 = 0, $139$hi = 0, $140$hi = 0, $143 = 0, $144$hi = 0, $146$hi = 0, $147 = 0, $147$hi = 0, $148 = 0, $148$hi = 0, $150 = 0, $150$hi = 0, $155 = 0, $155$hi = 0, $159 = 0, $159$hi = 0, $162 = 0, $162$hi = 0, $166 = 0, $166$hi = 0, $170 = 0, $170$hi = 0, $171$hi = 0, $174 = 0, $175$hi = 0, $176$hi = 0, $180 = 0, $180$hi = 0, $181$hi = 0, $184 = 0, $185$hi = 0, $187$hi = 0, $197 = 0, $189 = 0, $189$hi = 0, $11 = 0, $11$hi = 0, $192$hi = 0, $200 = 0, $200$hi = 0, $204 = 0, $204$hi = 0, $207 = 0, $207$hi = 0, $209 = 0, $209$hi = 0, $212 = 0, $212$hi = 0, $216 = 0, $216$hi = 0, $217$hi = 0, $220 = 0, $221$hi = 0, $222$hi = 0, $226 = 0, $226$hi = 0, $227$hi = 0, $230 = 0, $231$hi = 0, $233$hi = 0, $234 = 0, $234$hi = 0, $235 = 0, $235$hi = 0, $237$hi = 0, $245 = 0, $245$hi = 0, $249 = 0, $249$hi = 0, $252 = 0, $252$hi = 0, $254 = 0, $254$hi = 0, $258 = 0, $258$hi = 0, $262 = 0, $262$hi = 0, $263$hi = 0, $266 = 0, $267$hi = 0, $268$hi = 0, $272 = 0, $272$hi = 0, $273$hi = 0, $276 = 0, $277$hi = 0, $279$hi = 0, $280 = 0, $280$hi = 0, $281 = 0, $281$hi = 0, $283$hi = 0, $288 = 0, $288$hi = 0, $290 = 0, $290$hi = 0, $294 = 0, $294$hi = 0, $298 = 0, $298$hi = 0, $299$hi = 0, $302 = 0, $303$hi = 0, $304$hi = 0, $308 = 0, $308$hi = 0, $309$hi = 0, $312 = 0, $313$hi = 0, $315$hi = 0, $316 = 0, $316$hi = 0, $317 = 0, $317$hi = 0, $319$hi = 0, $325 = 0, $325$hi = 0, $327 = 0, $327$hi = 0;
  $3 = global$0 - 240 | 0;
  global$0 = $3;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $5 = i64toi32_i32$1;
  $5$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $6 = i64toi32_i32$0;
  $6$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $7 = i64toi32_i32$1;
  $7$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  label$1 : {
   if (!$2) {
    break label$1
   }
   label$2 : while (1) {
    i64toi32_i32$1 = $8$hi;
    i64toi32_i32$0 = 0;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$3 = 0;
    __multi3($3 + 224 | 0 | 0, $8 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$0 | 0, $8 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$3 | 0);
    i64toi32_i32$3 = $4$hi;
    i64toi32_i32$2 = 0;
    i64toi32_i32$2 = __wasm_i64_mul($4 | 0, i64toi32_i32$3 | 0, 38 | 0, i64toi32_i32$2 | 0) | 0;
    i64toi32_i32$3 = i64toi32_i32$HIGH_BITS;
    $9 = i64toi32_i32$2;
    $9$hi = i64toi32_i32$3;
    i64toi32_i32$3 = $7$hi;
    i64toi32_i32$3 = $9$hi;
    i64toi32_i32$2 = 0;
    i64toi32_i32$0 = $7$hi;
    i64toi32_i32$1 = 0;
    __multi3($3 + 128 | 0 | 0, $9 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$2 | 0, $7 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$1 | 0);
    i64toi32_i32$1 = $6$hi;
    i64toi32_i32$0 = 0;
    i64toi32_i32$0 = __wasm_i64_mul($6 | 0, i64toi32_i32$1 | 0, 38 | 0, i64toi32_i32$0 | 0) | 0;
    i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
    $43$hi = i64toi32_i32$1;
    i64toi32_i32$1 = $5$hi;
    i64toi32_i32$1 = $43$hi;
    $194 = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    i64toi32_i32$2 = $5$hi;
    i64toi32_i32$3 = 0;
    __multi3($3 + 64 | 0 | 0, $194 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$0 | 0, $5 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$3 | 0);
    $46 = $3 + 208 | 0;
    i64toi32_i32$3 = $8$hi;
    i64toi32_i32$0 = $8;
    i64toi32_i32$2 = 0;
    i64toi32_i32$1 = 1;
    i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
     i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
     $173 = 0;
    } else {
     i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$4 | 0) | 0;
     $173 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
    }
    $8 = $173;
    $8$hi = i64toi32_i32$2;
    i64toi32_i32$2 = $7$hi;
    i64toi32_i32$2 = $8$hi;
    i64toi32_i32$0 = 0;
    i64toi32_i32$3 = $7$hi;
    i64toi32_i32$1 = 0;
    __multi3($46 | 0, $8 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$0 | 0, $7 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$1 | 0);
    i64toi32_i32$1 = $9$hi;
    i64toi32_i32$1 = $6$hi;
    i64toi32_i32$1 = $9$hi;
    i64toi32_i32$3 = 0;
    i64toi32_i32$0 = $6$hi;
    i64toi32_i32$2 = 0;
    __multi3($3 + 112 | 0 | 0, $9 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$3 | 0, $6 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$2 | 0);
    i64toi32_i32$2 = $5$hi;
    i64toi32_i32$0 = 0;
    i64toi32_i32$0 = __wasm_i64_mul($5 | 0, i64toi32_i32$2 | 0, 19 | 0, i64toi32_i32$0 | 0) | 0;
    i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
    $57$hi = i64toi32_i32$2;
    i64toi32_i32$2 = $5$hi;
    i64toi32_i32$2 = $57$hi;
    $195 = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    i64toi32_i32$3 = $5$hi;
    i64toi32_i32$1 = 0;
    __multi3($3 | 0, $195 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$0 | 0, $5 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$1 | 0);
    i64toi32_i32$1 = $6$hi;
    i64toi32_i32$1 = $8$hi;
    i64toi32_i32$1 = $6$hi;
    i64toi32_i32$3 = 0;
    i64toi32_i32$0 = $8$hi;
    i64toi32_i32$2 = 0;
    __multi3($3 + 176 | 0 | 0, $6 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$3 | 0, $8 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$2 | 0);
    i64toi32_i32$2 = $7$hi;
    i64toi32_i32$0 = 0;
    i64toi32_i32$3 = i64toi32_i32$2;
    i64toi32_i32$1 = 0;
    __multi3($3 + 192 | 0 | 0, $7 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$0 | 0, $7 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$1 | 0);
    i64toi32_i32$1 = $9$hi;
    i64toi32_i32$1 = $5$hi;
    i64toi32_i32$1 = $9$hi;
    i64toi32_i32$3 = 0;
    i64toi32_i32$0 = $5$hi;
    i64toi32_i32$2 = 0;
    __multi3($3 + 48 | 0 | 0, $9 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$3 | 0, $5 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$2 | 0);
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$2 = $8$hi;
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    i64toi32_i32$3 = $8$hi;
    i64toi32_i32$1 = 0;
    __multi3($3 + 32 | 0 | 0, $5 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$0 | 0, $8 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$1 | 0);
    $76 = $3 + 160 | 0;
    i64toi32_i32$1 = $7$hi;
    i64toi32_i32$0 = $7;
    i64toi32_i32$3 = 0;
    i64toi32_i32$2 = 1;
    i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
     i64toi32_i32$3 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
     $175 = 0;
    } else {
     i64toi32_i32$3 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
     $175 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
    }
    $7 = $175;
    $7$hi = i64toi32_i32$3;
    i64toi32_i32$3 = $6$hi;
    i64toi32_i32$3 = $7$hi;
    i64toi32_i32$0 = 0;
    i64toi32_i32$1 = $6$hi;
    i64toi32_i32$2 = 0;
    __multi3($76 | 0, $7 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$0 | 0, $6 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$2 | 0);
    i64toi32_i32$2 = $4$hi;
    i64toi32_i32$1 = 0;
    i64toi32_i32$1 = __wasm_i64_mul($4 | 0, i64toi32_i32$2 | 0, 19 | 0, i64toi32_i32$1 | 0) | 0;
    i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
    $84$hi = i64toi32_i32$2;
    i64toi32_i32$2 = $4$hi;
    i64toi32_i32$2 = $84$hi;
    $196 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    i64toi32_i32$0 = $4$hi;
    i64toi32_i32$3 = 0;
    __multi3($3 + 96 | 0 | 0, $196 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$1 | 0, $4 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$3 | 0);
    i64toi32_i32$3 = i64toi32_i32$0;
    i64toi32_i32$3 = $8$hi;
    i64toi32_i32$3 = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    i64toi32_i32$1 = $8$hi;
    i64toi32_i32$2 = 0;
    __multi3($3 + 80 | 0 | 0, $4 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$0 | 0, $8 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$2 | 0);
    i64toi32_i32$2 = $5$hi;
    i64toi32_i32$2 = $7$hi;
    i64toi32_i32$2 = $5$hi;
    i64toi32_i32$1 = 0;
    i64toi32_i32$0 = $7$hi;
    i64toi32_i32$3 = 0;
    __multi3($3 + 16 | 0 | 0, $5 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$1 | 0, $7 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$3 | 0);
    i64toi32_i32$3 = $6$hi;
    i64toi32_i32$0 = 0;
    i64toi32_i32$1 = i64toi32_i32$3;
    i64toi32_i32$2 = 0;
    __multi3($3 + 144 | 0 | 0, $6 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$0 | 0, $6 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$2 | 0);
    i64toi32_i32$0 = $3;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
    $10 = i64toi32_i32$2;
    $10$hi = i64toi32_i32$1;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 208 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 212 | 0) >> 2] | 0;
    $102 = i64toi32_i32$1;
    $102$hi = i64toi32_i32$2;
    i64toi32_i32$2 = $10$hi;
    i64toi32_i32$0 = $10;
    i64toi32_i32$1 = $102$hi;
    i64toi32_i32$3 = $102;
    i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
    i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
    if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
     i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
    }
    $5 = i64toi32_i32$4;
    $5$hi = i64toi32_i32$5;
    i64toi32_i32$2 = $3;
    i64toi32_i32$5 = HEAP32[(i64toi32_i32$2 + 112 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 116 | 0) >> 2] | 0;
    $106 = i64toi32_i32$5;
    $106$hi = i64toi32_i32$0;
    i64toi32_i32$0 = $5$hi;
    i64toi32_i32$2 = i64toi32_i32$4;
    i64toi32_i32$5 = $106$hi;
    i64toi32_i32$3 = $106;
    i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
    i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
    if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
     i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
    }
    $6 = i64toi32_i32$1;
    $6$hi = i64toi32_i32$4;
    i64toi32_i32$0 = i64toi32_i32$1;
    i64toi32_i32$2 = 524287;
    i64toi32_i32$3 = -1;
    i64toi32_i32$2 = i64toi32_i32$4 & i64toi32_i32$2 | 0;
    $109 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
    $109$hi = i64toi32_i32$2;
    i64toi32_i32$4 = $3;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 64 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 68 | 0) >> 2] | 0;
    $8 = i64toi32_i32$2;
    $8$hi = i64toi32_i32$0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 224 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 228 | 0) >> 2] | 0;
    $114 = i64toi32_i32$0;
    $114$hi = i64toi32_i32$2;
    i64toi32_i32$2 = $8$hi;
    i64toi32_i32$4 = $8;
    i64toi32_i32$0 = $114$hi;
    i64toi32_i32$3 = $114;
    i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
    i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
    if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
     i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
    }
    $7 = i64toi32_i32$5;
    $7$hi = i64toi32_i32$1;
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 128 | 0) >> 2] | 0;
    i64toi32_i32$4 = HEAP32[(i64toi32_i32$2 + 132 | 0) >> 2] | 0;
    $118 = i64toi32_i32$1;
    $118$hi = i64toi32_i32$4;
    i64toi32_i32$4 = $7$hi;
    i64toi32_i32$2 = i64toi32_i32$5;
    i64toi32_i32$1 = $118$hi;
    i64toi32_i32$3 = $118;
    i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
    i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
    if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
     i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
    }
    $4 = i64toi32_i32$0;
    $4$hi = i64toi32_i32$5;
    i64toi32_i32$4 = i64toi32_i32$0;
    i64toi32_i32$2 = 0;
    i64toi32_i32$3 = 51;
    i64toi32_i32$1 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$2 = 0;
     $176 = i64toi32_i32$5 >>> i64toi32_i32$1 | 0;
    } else {
     i64toi32_i32$2 = i64toi32_i32$5 >>> i64toi32_i32$1 | 0;
     $176 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$1 | 0) | 0;
    }
    $121 = $176;
    $121$hi = i64toi32_i32$2;
    i64toi32_i32$5 = ($3 + 64 | 0) + 8 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
    i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
    $125 = i64toi32_i32$2;
    $125$hi = i64toi32_i32$4;
    i64toi32_i32$5 = ($3 + 224 | 0) + 8 | 0;
    i64toi32_i32$4 = HEAP32[i64toi32_i32$5 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
    $129 = i64toi32_i32$4;
    $129$hi = i64toi32_i32$2;
    i64toi32_i32$2 = $125$hi;
    i64toi32_i32$5 = $125;
    i64toi32_i32$4 = $129$hi;
    i64toi32_i32$3 = $129;
    i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
    i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
    if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
     i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
    }
    $130$hi = i64toi32_i32$0;
    i64toi32_i32$0 = $7$hi;
    i64toi32_i32$0 = $8$hi;
    i64toi32_i32$0 = $7$hi;
    i64toi32_i32$2 = $7;
    i64toi32_i32$5 = $8$hi;
    i64toi32_i32$3 = $8;
    $133 = i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
    i64toi32_i32$2 = 0;
    $134$hi = i64toi32_i32$2;
    i64toi32_i32$2 = $130$hi;
    i64toi32_i32$3 = i64toi32_i32$1;
    i64toi32_i32$0 = $134$hi;
    i64toi32_i32$5 = $133;
    i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
    i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
    if (i64toi32_i32$4 >>> 0 < i64toi32_i32$5 >>> 0) {
     i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
    }
    $135$hi = i64toi32_i32$1;
    i64toi32_i32$2 = ($3 + 128 | 0) + 8 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $139 = i64toi32_i32$1;
    $139$hi = i64toi32_i32$3;
    i64toi32_i32$3 = $135$hi;
    i64toi32_i32$2 = i64toi32_i32$4;
    i64toi32_i32$1 = $139$hi;
    i64toi32_i32$5 = $139;
    i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
    i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
    if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
     i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
    }
    $140$hi = i64toi32_i32$4;
    i64toi32_i32$4 = $4$hi;
    i64toi32_i32$4 = $7$hi;
    i64toi32_i32$4 = $4$hi;
    i64toi32_i32$3 = $4;
    i64toi32_i32$2 = $7$hi;
    i64toi32_i32$5 = $7;
    $143 = i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$3 >>> 0 < i64toi32_i32$5 >>> 0 | 0) | 0;
    i64toi32_i32$3 = 0;
    $144$hi = i64toi32_i32$3;
    i64toi32_i32$3 = $140$hi;
    i64toi32_i32$5 = i64toi32_i32$0;
    i64toi32_i32$4 = $144$hi;
    i64toi32_i32$2 = $143;
    i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
    i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$4 | 0;
    if (i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0) {
     i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
    }
    i64toi32_i32$3 = i64toi32_i32$1;
    i64toi32_i32$5 = 0;
    i64toi32_i32$2 = 13;
    i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
     i64toi32_i32$5 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
     $177 = 0;
    } else {
     i64toi32_i32$5 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
     $177 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
    }
    $146$hi = i64toi32_i32$5;
    i64toi32_i32$5 = $121$hi;
    i64toi32_i32$0 = $121;
    i64toi32_i32$3 = $146$hi;
    i64toi32_i32$2 = $177;
    i64toi32_i32$3 = i64toi32_i32$5 | i64toi32_i32$3 | 0;
    $147 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
    $147$hi = i64toi32_i32$3;
    i64toi32_i32$3 = $109$hi;
    i64toi32_i32$5 = $109;
    i64toi32_i32$0 = $147$hi;
    i64toi32_i32$2 = $147;
    i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
    i64toi32_i32$1 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
    if (i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0) {
     i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
    }
    $148 = i64toi32_i32$4;
    $148$hi = i64toi32_i32$1;
    i64toi32_i32$1 = $4$hi;
    i64toi32_i32$3 = $4;
    i64toi32_i32$5 = 524287;
    i64toi32_i32$2 = -1;
    i64toi32_i32$5 = i64toi32_i32$1 & i64toi32_i32$5 | 0;
    $150 = i64toi32_i32$3 & i64toi32_i32$2 | 0;
    $150$hi = i64toi32_i32$5;
    i64toi32_i32$1 = $3;
    i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] | 0;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] | 0;
    $8 = i64toi32_i32$5;
    $8$hi = i64toi32_i32$3;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] | 0;
    i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] | 0;
    $155 = i64toi32_i32$3;
    $155$hi = i64toi32_i32$5;
    i64toi32_i32$5 = $8$hi;
    i64toi32_i32$1 = $8;
    i64toi32_i32$3 = $155$hi;
    i64toi32_i32$2 = $155;
    i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
    i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
    if (i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0) {
     i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
    }
    $7 = i64toi32_i32$0;
    $7$hi = i64toi32_i32$4;
    i64toi32_i32$5 = $3;
    i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 80 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 84 | 0) >> 2] | 0;
    $159 = i64toi32_i32$4;
    $159$hi = i64toi32_i32$1;
    i64toi32_i32$1 = $7$hi;
    i64toi32_i32$5 = i64toi32_i32$0;
    i64toi32_i32$4 = $159$hi;
    i64toi32_i32$2 = $159;
    i64toi32_i32$3 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
    i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
    if (i64toi32_i32$3 >>> 0 < i64toi32_i32$2 >>> 0) {
     i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
    }
    $4 = i64toi32_i32$3;
    $4$hi = i64toi32_i32$0;
    i64toi32_i32$1 = i64toi32_i32$3;
    i64toi32_i32$5 = 0;
    i64toi32_i32$2 = 51;
    i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
     i64toi32_i32$5 = 0;
     $178 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
    } else {
     i64toi32_i32$5 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
     $178 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
    }
    $162 = $178;
    $162$hi = i64toi32_i32$5;
    i64toi32_i32$0 = ($3 + 16 | 0) + 8 | 0;
    i64toi32_i32$5 = HEAP32[i64toi32_i32$0 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
    $166 = i64toi32_i32$5;
    $166$hi = i64toi32_i32$1;
    i64toi32_i32$0 = ($3 + 144 | 0) + 8 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
    i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
    $170 = i64toi32_i32$1;
    $170$hi = i64toi32_i32$5;
    i64toi32_i32$5 = $166$hi;
    i64toi32_i32$0 = $166;
    i64toi32_i32$1 = $170$hi;
    i64toi32_i32$2 = $170;
    i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
    i64toi32_i32$3 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
    if (i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0) {
     i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
    }
    $171$hi = i64toi32_i32$3;
    i64toi32_i32$3 = $7$hi;
    i64toi32_i32$3 = $8$hi;
    i64toi32_i32$3 = $7$hi;
    i64toi32_i32$5 = $7;
    i64toi32_i32$0 = $8$hi;
    i64toi32_i32$2 = $8;
    $174 = i64toi32_i32$3 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0;
    i64toi32_i32$5 = 0;
    $175$hi = i64toi32_i32$5;
    i64toi32_i32$5 = $171$hi;
    i64toi32_i32$2 = i64toi32_i32$4;
    i64toi32_i32$3 = $175$hi;
    i64toi32_i32$0 = $174;
    i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
    i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
    if (i64toi32_i32$1 >>> 0 < i64toi32_i32$0 >>> 0) {
     i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
    }
    $176$hi = i64toi32_i32$4;
    i64toi32_i32$5 = ($3 + 80 | 0) + 8 | 0;
    i64toi32_i32$4 = HEAP32[i64toi32_i32$5 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
    $180 = i64toi32_i32$4;
    $180$hi = i64toi32_i32$2;
    i64toi32_i32$2 = $176$hi;
    i64toi32_i32$5 = i64toi32_i32$1;
    i64toi32_i32$4 = $180$hi;
    i64toi32_i32$0 = $180;
    i64toi32_i32$3 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
    i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
    if (i64toi32_i32$3 >>> 0 < i64toi32_i32$0 >>> 0) {
     i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
    }
    $181$hi = i64toi32_i32$1;
    i64toi32_i32$1 = $4$hi;
    i64toi32_i32$1 = $7$hi;
    i64toi32_i32$1 = $4$hi;
    i64toi32_i32$2 = $4;
    i64toi32_i32$5 = $7$hi;
    i64toi32_i32$0 = $7;
    $184 = i64toi32_i32$1 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$0 >>> 0 | 0) | 0;
    i64toi32_i32$2 = 0;
    $185$hi = i64toi32_i32$2;
    i64toi32_i32$2 = $181$hi;
    i64toi32_i32$0 = i64toi32_i32$3;
    i64toi32_i32$1 = $185$hi;
    i64toi32_i32$5 = $184;
    i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
    i64toi32_i32$3 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
    if (i64toi32_i32$4 >>> 0 < i64toi32_i32$5 >>> 0) {
     i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
    }
    i64toi32_i32$2 = i64toi32_i32$4;
    i64toi32_i32$0 = 0;
    i64toi32_i32$5 = 13;
    i64toi32_i32$1 = i64toi32_i32$5 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$5 & 63 | 0) >>> 0) {
     i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$1 | 0;
     $179 = 0;
    } else {
     i64toi32_i32$0 = ((1 << i64toi32_i32$1 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$1 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$1 | 0) | 0;
     $179 = i64toi32_i32$2 << i64toi32_i32$1 | 0;
    }
    $187$hi = i64toi32_i32$0;
    i64toi32_i32$0 = $162$hi;
    i64toi32_i32$3 = $162;
    i64toi32_i32$2 = $187$hi;
    i64toi32_i32$5 = $179;
    i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
    $197 = i64toi32_i32$3 | i64toi32_i32$5 | 0;
    i64toi32_i32$3 = 0;
    i64toi32_i32$3 = __wasm_i64_mul($197 | 0, i64toi32_i32$2 | 0, 19 | 0, i64toi32_i32$3 | 0) | 0;
    i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
    $189 = i64toi32_i32$3;
    $189$hi = i64toi32_i32$2;
    i64toi32_i32$2 = $150$hi;
    i64toi32_i32$0 = $150;
    i64toi32_i32$3 = $189$hi;
    i64toi32_i32$5 = $189;
    i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
    i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
    if (i64toi32_i32$1 >>> 0 < i64toi32_i32$5 >>> 0) {
     i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
    }
    $11 = i64toi32_i32$1;
    $11$hi = i64toi32_i32$4;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$0 = 0;
    i64toi32_i32$5 = 51;
    i64toi32_i32$3 = i64toi32_i32$5 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$5 & 63 | 0) >>> 0) {
     i64toi32_i32$0 = 0;
     $181 = i64toi32_i32$4 >>> i64toi32_i32$3 | 0;
    } else {
     i64toi32_i32$0 = i64toi32_i32$4 >>> i64toi32_i32$3 | 0;
     $181 = (((1 << i64toi32_i32$3 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$3 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$3 | 0) | 0;
    }
    $192$hi = i64toi32_i32$0;
    i64toi32_i32$0 = $148$hi;
    i64toi32_i32$4 = $148;
    i64toi32_i32$2 = $192$hi;
    i64toi32_i32$5 = $181;
    i64toi32_i32$3 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
    i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
    if (i64toi32_i32$3 >>> 0 < i64toi32_i32$5 >>> 0) {
     i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
    }
    $12 = i64toi32_i32$3;
    $12$hi = i64toi32_i32$1;
    i64toi32_i32$0 = i64toi32_i32$3;
    i64toi32_i32$4 = 524287;
    i64toi32_i32$5 = -1;
    i64toi32_i32$4 = i64toi32_i32$1 & i64toi32_i32$4 | 0;
    $7 = i64toi32_i32$3 & i64toi32_i32$5 | 0;
    $7$hi = i64toi32_i32$4;
    i64toi32_i32$1 = $3;
    i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 176 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 180 | 0) >> 2] | 0;
    $13 = i64toi32_i32$4;
    $13$hi = i64toi32_i32$0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 192 | 0) >> 2] | 0;
    i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 196 | 0) >> 2] | 0;
    $200 = i64toi32_i32$0;
    $200$hi = i64toi32_i32$4;
    i64toi32_i32$4 = $13$hi;
    i64toi32_i32$1 = $13;
    i64toi32_i32$0 = $200$hi;
    i64toi32_i32$5 = $200;
    i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
    i64toi32_i32$3 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
    if (i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0) {
     i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
    }
    $8 = i64toi32_i32$2;
    $8$hi = i64toi32_i32$3;
    i64toi32_i32$4 = $3;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 48 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$4 + 52 | 0) >> 2] | 0;
    $204 = i64toi32_i32$3;
    $204$hi = i64toi32_i32$1;
    i64toi32_i32$1 = $8$hi;
    i64toi32_i32$4 = i64toi32_i32$2;
    i64toi32_i32$3 = $204$hi;
    i64toi32_i32$5 = $204;
    i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
    i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
    if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
     i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
    }
    $9 = i64toi32_i32$0;
    $9$hi = i64toi32_i32$2;
    i64toi32_i32$1 = i64toi32_i32$0;
    i64toi32_i32$4 = 524287;
    i64toi32_i32$5 = -1;
    i64toi32_i32$4 = i64toi32_i32$2 & i64toi32_i32$4 | 0;
    $207 = i64toi32_i32$1 & i64toi32_i32$5 | 0;
    $207$hi = i64toi32_i32$4;
    i64toi32_i32$4 = $6$hi;
    i64toi32_i32$2 = $6;
    i64toi32_i32$1 = 0;
    i64toi32_i32$5 = 51;
    i64toi32_i32$3 = i64toi32_i32$5 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$5 & 63 | 0) >>> 0) {
     i64toi32_i32$1 = 0;
     $182 = i64toi32_i32$4 >>> i64toi32_i32$3 | 0;
    } else {
     i64toi32_i32$1 = i64toi32_i32$4 >>> i64toi32_i32$3 | 0;
     $182 = (((1 << i64toi32_i32$3 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$3 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$3 | 0) | 0;
    }
    $209 = $182;
    $209$hi = i64toi32_i32$1;
    i64toi32_i32$4 = $3 + 8 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$4 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
    $212 = i64toi32_i32$1;
    $212$hi = i64toi32_i32$2;
    i64toi32_i32$4 = ($3 + 208 | 0) + 8 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$4 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
    $216 = i64toi32_i32$2;
    $216$hi = i64toi32_i32$1;
    i64toi32_i32$1 = $212$hi;
    i64toi32_i32$4 = $212;
    i64toi32_i32$2 = $216$hi;
    i64toi32_i32$5 = $216;
    i64toi32_i32$3 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
    i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
    if (i64toi32_i32$3 >>> 0 < i64toi32_i32$5 >>> 0) {
     i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
    }
    $217$hi = i64toi32_i32$0;
    i64toi32_i32$0 = $5$hi;
    i64toi32_i32$0 = $10$hi;
    i64toi32_i32$0 = $5$hi;
    i64toi32_i32$1 = $5;
    i64toi32_i32$4 = $10$hi;
    i64toi32_i32$5 = $10;
    $220 = i64toi32_i32$0 >>> 0 < i64toi32_i32$4 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$4 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$5 >>> 0 | 0) | 0;
    i64toi32_i32$1 = 0;
    $221$hi = i64toi32_i32$1;
    i64toi32_i32$1 = $217$hi;
    i64toi32_i32$5 = i64toi32_i32$3;
    i64toi32_i32$0 = $221$hi;
    i64toi32_i32$4 = $220;
    i64toi32_i32$2 = i64toi32_i32$3 + i64toi32_i32$4 | 0;
    i64toi32_i32$3 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
    if (i64toi32_i32$2 >>> 0 < i64toi32_i32$4 >>> 0) {
     i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
    }
    $222$hi = i64toi32_i32$3;
    i64toi32_i32$1 = ($3 + 112 | 0) + 8 | 0;
    i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
    i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
    $226 = i64toi32_i32$3;
    $226$hi = i64toi32_i32$5;
    i64toi32_i32$5 = $222$hi;
    i64toi32_i32$1 = i64toi32_i32$2;
    i64toi32_i32$3 = $226$hi;
    i64toi32_i32$4 = $226;
    i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
    i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
    if (i64toi32_i32$0 >>> 0 < i64toi32_i32$4 >>> 0) {
     i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
    }
    $227$hi = i64toi32_i32$2;
    i64toi32_i32$2 = $6$hi;
    i64toi32_i32$2 = $5$hi;
    i64toi32_i32$2 = $6$hi;
    i64toi32_i32$5 = $6;
    i64toi32_i32$1 = $5$hi;
    i64toi32_i32$4 = $5;
    $230 = i64toi32_i32$2 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$5 >>> 0 < i64toi32_i32$4 >>> 0 | 0) | 0;
    i64toi32_i32$5 = 0;
    $231$hi = i64toi32_i32$5;
    i64toi32_i32$5 = $227$hi;
    i64toi32_i32$4 = i64toi32_i32$0;
    i64toi32_i32$2 = $231$hi;
    i64toi32_i32$1 = $230;
    i64toi32_i32$3 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
    i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
    if (i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0) {
     i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
    }
    i64toi32_i32$5 = i64toi32_i32$3;
    i64toi32_i32$4 = 0;
    i64toi32_i32$1 = 13;
    i64toi32_i32$2 = i64toi32_i32$1 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
     i64toi32_i32$4 = i64toi32_i32$5 << i64toi32_i32$2 | 0;
     $183 = 0;
    } else {
     i64toi32_i32$4 = ((1 << i64toi32_i32$2 | 0) - 1 | 0) & (i64toi32_i32$5 >>> (32 - i64toi32_i32$2 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$2 | 0) | 0;
     $183 = i64toi32_i32$5 << i64toi32_i32$2 | 0;
    }
    $233$hi = i64toi32_i32$4;
    i64toi32_i32$4 = $209$hi;
    i64toi32_i32$0 = $209;
    i64toi32_i32$5 = $233$hi;
    i64toi32_i32$1 = $183;
    i64toi32_i32$5 = i64toi32_i32$4 | i64toi32_i32$5 | 0;
    $234 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
    $234$hi = i64toi32_i32$5;
    i64toi32_i32$5 = $207$hi;
    i64toi32_i32$4 = $207;
    i64toi32_i32$0 = $234$hi;
    i64toi32_i32$1 = $234;
    i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
    i64toi32_i32$3 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
    if (i64toi32_i32$2 >>> 0 < i64toi32_i32$1 >>> 0) {
     i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
    }
    $235 = i64toi32_i32$2;
    $235$hi = i64toi32_i32$3;
    i64toi32_i32$3 = $12$hi;
    i64toi32_i32$5 = $12;
    i64toi32_i32$4 = 0;
    i64toi32_i32$1 = 51;
    i64toi32_i32$0 = i64toi32_i32$1 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
     i64toi32_i32$4 = 0;
     $185 = i64toi32_i32$3 >>> i64toi32_i32$0 | 0;
    } else {
     i64toi32_i32$4 = i64toi32_i32$3 >>> i64toi32_i32$0 | 0;
     $185 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$0 | 0) | 0;
    }
    $237$hi = i64toi32_i32$4;
    i64toi32_i32$4 = $235$hi;
    i64toi32_i32$3 = $235;
    i64toi32_i32$5 = $237$hi;
    i64toi32_i32$1 = $185;
    i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
    i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
    if (i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0) {
     i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
    }
    $5 = i64toi32_i32$0;
    $5$hi = i64toi32_i32$2;
    i64toi32_i32$4 = i64toi32_i32$0;
    i64toi32_i32$3 = 524287;
    i64toi32_i32$1 = -1;
    i64toi32_i32$3 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
    $6 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
    $6$hi = i64toi32_i32$3;
    i64toi32_i32$2 = $3;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
    i64toi32_i32$4 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
    $14 = i64toi32_i32$3;
    $14$hi = i64toi32_i32$4;
    i64toi32_i32$4 = HEAP32[(i64toi32_i32$2 + 160 | 0) >> 2] | 0;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 164 | 0) >> 2] | 0;
    $245 = i64toi32_i32$4;
    $245$hi = i64toi32_i32$3;
    i64toi32_i32$3 = $14$hi;
    i64toi32_i32$2 = $14;
    i64toi32_i32$4 = $245$hi;
    i64toi32_i32$1 = $245;
    i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
    i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$4 | 0;
    if (i64toi32_i32$5 >>> 0 < i64toi32_i32$1 >>> 0) {
     i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
    }
    $10 = i64toi32_i32$5;
    $10$hi = i64toi32_i32$0;
    i64toi32_i32$3 = $3;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 96 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 100 | 0) >> 2] | 0;
    $249 = i64toi32_i32$0;
    $249$hi = i64toi32_i32$2;
    i64toi32_i32$2 = $10$hi;
    i64toi32_i32$3 = i64toi32_i32$5;
    i64toi32_i32$0 = $249$hi;
    i64toi32_i32$1 = $249;
    i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
    i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
    if (i64toi32_i32$4 >>> 0 < i64toi32_i32$1 >>> 0) {
     i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
    }
    $12 = i64toi32_i32$4;
    $12$hi = i64toi32_i32$5;
    i64toi32_i32$2 = i64toi32_i32$4;
    i64toi32_i32$3 = 524287;
    i64toi32_i32$1 = -1;
    i64toi32_i32$3 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
    $252 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
    $252$hi = i64toi32_i32$3;
    i64toi32_i32$3 = $9$hi;
    i64toi32_i32$5 = $9;
    i64toi32_i32$2 = 0;
    i64toi32_i32$1 = 51;
    i64toi32_i32$0 = i64toi32_i32$1 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
     i64toi32_i32$2 = 0;
     $186 = i64toi32_i32$3 >>> i64toi32_i32$0 | 0;
    } else {
     i64toi32_i32$2 = i64toi32_i32$3 >>> i64toi32_i32$0 | 0;
     $186 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$0 | 0) | 0;
    }
    $254 = $186;
    $254$hi = i64toi32_i32$2;
    i64toi32_i32$3 = ($3 + 176 | 0) + 8 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $258 = i64toi32_i32$2;
    $258$hi = i64toi32_i32$5;
    i64toi32_i32$3 = ($3 + 192 | 0) + 8 | 0;
    i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $262 = i64toi32_i32$5;
    $262$hi = i64toi32_i32$2;
    i64toi32_i32$2 = $258$hi;
    i64toi32_i32$3 = $258;
    i64toi32_i32$5 = $262$hi;
    i64toi32_i32$1 = $262;
    i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
    i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
    if (i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0) {
     i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
    }
    $263$hi = i64toi32_i32$4;
    i64toi32_i32$4 = $8$hi;
    i64toi32_i32$4 = $13$hi;
    i64toi32_i32$4 = $8$hi;
    i64toi32_i32$2 = $8;
    i64toi32_i32$3 = $13$hi;
    i64toi32_i32$1 = $13;
    $266 = i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$1 >>> 0 | 0) | 0;
    i64toi32_i32$2 = 0;
    $267$hi = i64toi32_i32$2;
    i64toi32_i32$2 = $263$hi;
    i64toi32_i32$1 = i64toi32_i32$0;
    i64toi32_i32$4 = $267$hi;
    i64toi32_i32$3 = $266;
    i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
    i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
    if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
     i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
    }
    $268$hi = i64toi32_i32$0;
    i64toi32_i32$2 = ($3 + 48 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $272 = i64toi32_i32$0;
    $272$hi = i64toi32_i32$1;
    i64toi32_i32$1 = $268$hi;
    i64toi32_i32$2 = i64toi32_i32$5;
    i64toi32_i32$0 = $272$hi;
    i64toi32_i32$3 = $272;
    i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
    i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
    if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
     i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
    }
    $273$hi = i64toi32_i32$5;
    i64toi32_i32$5 = $9$hi;
    i64toi32_i32$5 = $8$hi;
    i64toi32_i32$5 = $9$hi;
    i64toi32_i32$1 = $9;
    i64toi32_i32$2 = $8$hi;
    i64toi32_i32$3 = $8;
    $276 = i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
    i64toi32_i32$1 = 0;
    $277$hi = i64toi32_i32$1;
    i64toi32_i32$1 = $273$hi;
    i64toi32_i32$3 = i64toi32_i32$4;
    i64toi32_i32$5 = $277$hi;
    i64toi32_i32$2 = $276;
    i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
    i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
    if (i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0) {
     i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
    }
    i64toi32_i32$1 = i64toi32_i32$0;
    i64toi32_i32$3 = 0;
    i64toi32_i32$2 = 13;
    i64toi32_i32$5 = i64toi32_i32$2 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
     i64toi32_i32$3 = i64toi32_i32$1 << i64toi32_i32$5 | 0;
     $187 = 0;
    } else {
     i64toi32_i32$3 = ((1 << i64toi32_i32$5 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$5 | 0) | 0) | 0 | (i64toi32_i32$4 << i64toi32_i32$5 | 0) | 0;
     $187 = i64toi32_i32$1 << i64toi32_i32$5 | 0;
    }
    $279$hi = i64toi32_i32$3;
    i64toi32_i32$3 = $254$hi;
    i64toi32_i32$4 = $254;
    i64toi32_i32$1 = $279$hi;
    i64toi32_i32$2 = $187;
    i64toi32_i32$1 = i64toi32_i32$3 | i64toi32_i32$1 | 0;
    $280 = i64toi32_i32$4 | i64toi32_i32$2 | 0;
    $280$hi = i64toi32_i32$1;
    i64toi32_i32$1 = $252$hi;
    i64toi32_i32$3 = $252;
    i64toi32_i32$4 = $280$hi;
    i64toi32_i32$2 = $280;
    i64toi32_i32$5 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
    i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
    if (i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0) {
     i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
    }
    $281 = i64toi32_i32$5;
    $281$hi = i64toi32_i32$0;
    i64toi32_i32$0 = $5$hi;
    i64toi32_i32$1 = $5;
    i64toi32_i32$3 = 0;
    i64toi32_i32$2 = 51;
    i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
     i64toi32_i32$3 = 0;
     $188 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
    } else {
     i64toi32_i32$3 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
     $188 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
    }
    $283$hi = i64toi32_i32$3;
    i64toi32_i32$3 = $281$hi;
    i64toi32_i32$0 = $281;
    i64toi32_i32$1 = $283$hi;
    i64toi32_i32$2 = $188;
    i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
    i64toi32_i32$5 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
    if (i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0) {
     i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
    }
    $8 = i64toi32_i32$4;
    $8$hi = i64toi32_i32$5;
    i64toi32_i32$3 = i64toi32_i32$4;
    i64toi32_i32$0 = 524287;
    i64toi32_i32$2 = -1;
    i64toi32_i32$0 = i64toi32_i32$5 & i64toi32_i32$0 | 0;
    $5 = i64toi32_i32$3 & i64toi32_i32$2 | 0;
    $5$hi = i64toi32_i32$0;
    i64toi32_i32$0 = $4$hi;
    i64toi32_i32$5 = $4;
    i64toi32_i32$3 = 524287;
    i64toi32_i32$2 = -1;
    i64toi32_i32$3 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
    $288 = i64toi32_i32$5 & i64toi32_i32$2 | 0;
    $288$hi = i64toi32_i32$3;
    i64toi32_i32$3 = $12$hi;
    i64toi32_i32$0 = $12;
    i64toi32_i32$5 = 0;
    i64toi32_i32$2 = 51;
    i64toi32_i32$1 = i64toi32_i32$2 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
     i64toi32_i32$5 = 0;
     $190 = i64toi32_i32$3 >>> i64toi32_i32$1 | 0;
    } else {
     i64toi32_i32$5 = i64toi32_i32$3 >>> i64toi32_i32$1 | 0;
     $190 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$1 | 0) | 0;
    }
    $290 = $190;
    $290$hi = i64toi32_i32$5;
    i64toi32_i32$3 = ($3 + 32 | 0) + 8 | 0;
    i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $294 = i64toi32_i32$5;
    $294$hi = i64toi32_i32$0;
    i64toi32_i32$3 = ($3 + 160 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $298 = i64toi32_i32$0;
    $298$hi = i64toi32_i32$5;
    i64toi32_i32$5 = $294$hi;
    i64toi32_i32$3 = $294;
    i64toi32_i32$0 = $298$hi;
    i64toi32_i32$2 = $298;
    i64toi32_i32$1 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
    i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
    if (i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0) {
     i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
    }
    $299$hi = i64toi32_i32$4;
    i64toi32_i32$4 = $10$hi;
    i64toi32_i32$4 = $14$hi;
    i64toi32_i32$4 = $10$hi;
    i64toi32_i32$5 = $10;
    i64toi32_i32$3 = $14$hi;
    i64toi32_i32$2 = $14;
    $302 = i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0;
    i64toi32_i32$5 = 0;
    $303$hi = i64toi32_i32$5;
    i64toi32_i32$5 = $299$hi;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$4 = $303$hi;
    i64toi32_i32$3 = $302;
    i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
    i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
    if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
     i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
    }
    $304$hi = i64toi32_i32$1;
    i64toi32_i32$5 = ($3 + 96 | 0) + 8 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$5 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
    $308 = i64toi32_i32$1;
    $308$hi = i64toi32_i32$2;
    i64toi32_i32$2 = $304$hi;
    i64toi32_i32$5 = i64toi32_i32$0;
    i64toi32_i32$1 = $308$hi;
    i64toi32_i32$3 = $308;
    i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
    i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
    if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
     i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
    }
    $309$hi = i64toi32_i32$0;
    i64toi32_i32$0 = $12$hi;
    i64toi32_i32$0 = $10$hi;
    i64toi32_i32$0 = $12$hi;
    i64toi32_i32$2 = $12;
    i64toi32_i32$5 = $10$hi;
    i64toi32_i32$3 = $10;
    $312 = i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
    i64toi32_i32$2 = 0;
    $313$hi = i64toi32_i32$2;
    i64toi32_i32$2 = $309$hi;
    i64toi32_i32$3 = i64toi32_i32$4;
    i64toi32_i32$0 = $313$hi;
    i64toi32_i32$5 = $312;
    i64toi32_i32$1 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
    i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
    if (i64toi32_i32$1 >>> 0 < i64toi32_i32$5 >>> 0) {
     i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
    }
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$3 = 0;
    i64toi32_i32$5 = 13;
    i64toi32_i32$0 = i64toi32_i32$5 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$5 & 63 | 0) >>> 0) {
     i64toi32_i32$3 = i64toi32_i32$2 << i64toi32_i32$0 | 0;
     $191 = 0;
    } else {
     i64toi32_i32$3 = ((1 << i64toi32_i32$0 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$0 | 0) | 0) | 0 | (i64toi32_i32$4 << i64toi32_i32$0 | 0) | 0;
     $191 = i64toi32_i32$2 << i64toi32_i32$0 | 0;
    }
    $315$hi = i64toi32_i32$3;
    i64toi32_i32$3 = $290$hi;
    i64toi32_i32$4 = $290;
    i64toi32_i32$2 = $315$hi;
    i64toi32_i32$5 = $191;
    i64toi32_i32$2 = i64toi32_i32$3 | i64toi32_i32$2 | 0;
    $316 = i64toi32_i32$4 | i64toi32_i32$5 | 0;
    $316$hi = i64toi32_i32$2;
    i64toi32_i32$2 = $288$hi;
    i64toi32_i32$3 = $288;
    i64toi32_i32$4 = $316$hi;
    i64toi32_i32$5 = $316;
    i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
    i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
    if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
     i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
    }
    $317 = i64toi32_i32$0;
    $317$hi = i64toi32_i32$1;
    i64toi32_i32$1 = $8$hi;
    i64toi32_i32$2 = $8;
    i64toi32_i32$3 = 0;
    i64toi32_i32$5 = 51;
    i64toi32_i32$4 = i64toi32_i32$5 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$5 & 63 | 0) >>> 0) {
     i64toi32_i32$3 = 0;
     $192 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
    } else {
     i64toi32_i32$3 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
     $192 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
    }
    $319$hi = i64toi32_i32$3;
    i64toi32_i32$3 = $317$hi;
    i64toi32_i32$1 = $317;
    i64toi32_i32$2 = $319$hi;
    i64toi32_i32$5 = $192;
    i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
    i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
    if (i64toi32_i32$4 >>> 0 < i64toi32_i32$5 >>> 0) {
     i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
    }
    $8 = i64toi32_i32$4;
    $8$hi = i64toi32_i32$0;
    i64toi32_i32$3 = i64toi32_i32$4;
    i64toi32_i32$1 = 524287;
    i64toi32_i32$5 = -1;
    i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
    $4 = i64toi32_i32$3 & i64toi32_i32$5 | 0;
    $4$hi = i64toi32_i32$1;
    i64toi32_i32$1 = i64toi32_i32$0;
    i64toi32_i32$0 = i64toi32_i32$3;
    i64toi32_i32$3 = 0;
    i64toi32_i32$5 = 51;
    i64toi32_i32$2 = i64toi32_i32$5 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$5 & 63 | 0) >>> 0) {
     i64toi32_i32$3 = 0;
     $193 = i64toi32_i32$1 >>> i64toi32_i32$2 | 0;
    } else {
     i64toi32_i32$3 = i64toi32_i32$1 >>> i64toi32_i32$2 | 0;
     $193 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$2 | 0) | 0;
    }
    i64toi32_i32$0 = 0;
    i64toi32_i32$0 = __wasm_i64_mul($193 | 0, i64toi32_i32$3 | 0, 19 | 0, i64toi32_i32$0 | 0) | 0;
    i64toi32_i32$3 = i64toi32_i32$HIGH_BITS;
    $325 = i64toi32_i32$0;
    $325$hi = i64toi32_i32$3;
    i64toi32_i32$3 = $11$hi;
    i64toi32_i32$1 = $11;
    i64toi32_i32$0 = 524287;
    i64toi32_i32$5 = -1;
    i64toi32_i32$0 = i64toi32_i32$3 & i64toi32_i32$0 | 0;
    $327 = i64toi32_i32$1 & i64toi32_i32$5 | 0;
    $327$hi = i64toi32_i32$0;
    i64toi32_i32$0 = $325$hi;
    i64toi32_i32$3 = $325;
    i64toi32_i32$1 = $327$hi;
    i64toi32_i32$5 = $327;
    i64toi32_i32$2 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
    i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
    if (i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0) {
     i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
    }
    $8 = i64toi32_i32$2;
    $8$hi = i64toi32_i32$4;
    $2 = $2 + -1 | 0;
    if ($2) {
     continue label$2
    }
    break label$2;
   };
  }
  i64toi32_i32$4 = $4$hi;
  i64toi32_i32$3 = $0;
  HEAP32[(i64toi32_i32$3 + 32 | 0) >> 2] = $4;
  HEAP32[(i64toi32_i32$3 + 36 | 0) >> 2] = i64toi32_i32$4;
  i64toi32_i32$4 = $5$hi;
  HEAP32[(i64toi32_i32$3 + 24 | 0) >> 2] = $5;
  HEAP32[(i64toi32_i32$3 + 28 | 0) >> 2] = i64toi32_i32$4;
  i64toi32_i32$4 = $6$hi;
  HEAP32[(i64toi32_i32$3 + 16 | 0) >> 2] = $6;
  HEAP32[(i64toi32_i32$3 + 20 | 0) >> 2] = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  HEAP32[(i64toi32_i32$3 + 8 | 0) >> 2] = $7;
  HEAP32[(i64toi32_i32$3 + 12 | 0) >> 2] = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  HEAP32[i64toi32_i32$3 >> 2] = $8;
  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$4;
  global$0 = $3 + 240 | 0;
 }
 
 function cardano_serialization_lib__legacy_address__base58__decode__h2aded2be1d6e51f0($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $6 = 0, $4 = 0, $5 = 0, $9 = 0, $8 = 0, $7 = 0, $10 = 0, i64toi32_i32$1 = 0;
  $3 = global$0 - 64 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $4 = __rust_alloc(1 | 0, 1 | 0) | 0;
      if (!$4) {
       break label$4
      }
      $5 = 0;
      HEAP8[$4 >> 0] = 0;
      alloc__slice__hack__into_vec__h7c95d082cf6730ee($3 + 48 | 0 | 0, $4 | 0, 1 | 0);
      label$5 : {
       label$6 : {
        if (!$2) {
         break label$6
        }
        $5 = 0;
        label$7 : while (1) {
         if ((HEAPU8[($1 + $5 | 0) >> 0] | 0 | 0) != (49 | 0)) {
          break label$6
         }
         $5 = $5 + 1 | 0;
         if (($2 | 0) != ($5 | 0)) {
          continue label$7
         }
         break label$5;
        };
       }
       label$8 : {
        if ($5 >>> 0 >= $2 >>> 0) {
         break label$8
        }
        $6 = 1;
        $7 = $5;
        label$9 : while (1) {
         $8 = $7;
         $9 = $1 + $8 | 0;
         $7 = $8 + 1 | 0;
         $4 = 0;
         label$10 : {
          label$11 : {
           label$12 : {
            label$13 : {
             label$14 : {
              label$15 : while (1) {
               if (!($6 & 1 | 0)) {
                break label$13
               }
               if ((HEAPU8[($4 + 1070125 | 0) >> 0] | 0 | 0) == (HEAPU8[$9 >> 0] | 0 | 0)) {
                break label$14
               }
               $4 = $4 + 1 | 0;
               if (($4 | 0) != (58 | 0)) {
                continue label$15
               }
               break label$15;
              };
              HEAP32[$0 >> 2] = 1;
              HEAP32[($0 + 4 | 0) >> 2] = $8;
              $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 48 | 0 | 0);
              $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 48 | 0 | 0);
              break label$1;
             }
             label$16 : {
              $8 = HEAP32[($3 + 56 | 0) >> 2] | 0;
              if (!$8) {
               break label$16
              }
              $6 = 0;
              label$17 : while (1) {
               $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 40 | 0 | 0, $3 + 48 | 0 | 0);
               $9 = HEAP32[($3 + 44 | 0) >> 2] | 0;
               if ($9 >>> 0 <= $6 >>> 0) {
                break label$12
               }
               $9 = HEAPU8[((HEAP32[($3 + 40 | 0) >> 2] | 0) + $6 | 0) >> 0] | 0;
               $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__DerefMut___deref_mut__h1882e042320a120c($3 + 32 | 0 | 0, $3 + 48 | 0 | 0);
               $10 = HEAP32[($3 + 36 | 0) >> 2] | 0;
               if ($10 >>> 0 <= $6 >>> 0) {
                break label$11
               }
               $4 = Math_imul($9, 58) + $4 | 0;
               HEAP8[((HEAP32[($3 + 32 | 0) >> 2] | 0) + $6 | 0) >> 0] = $4;
               $4 = $4 >>> 8 | 0;
               $9 = $6 + 1 | 0;
               $6 = $9;
               if (($8 | 0) != ($6 | 0)) {
                continue label$17
               }
               break label$17;
              };
             }
             if (!$4) {
              break label$10
             }
             $6 = HEAP32[($3 + 56 | 0) >> 2] | 0;
             label$18 : while (1) {
              label$19 : {
               if (($6 | 0) != (HEAP32[($3 + 52 | 0) >> 2] | 0 | 0)) {
                break label$19
               }
               alloc__vec__Vec_T_2cA___reserve__h9cf757d86af8f187($3 + 48 | 0 | 0, 1 | 0);
               $6 = HEAP32[($3 + 56 | 0) >> 2] | 0;
              }
              HEAP8[((HEAP32[($3 + 48 | 0) >> 2] | 0) + $6 | 0) >> 0] = $4;
              $6 = (HEAP32[($3 + 56 | 0) >> 2] | 0) + 1 | 0;
              HEAP32[($3 + 56 | 0) >> 2] = $6;
              $4 = $4 >>> 8 | 0;
              if (!$4) {
               break label$10
              }
              continue label$18;
             };
            }
            core__panicking__panic_bounds_check__h808b524af17640b1($8 | 0, $2 | 0, 1070308 | 0);
            abort();
           }
           core__panicking__panic_bounds_check__h808b524af17640b1($6 | 0, $9 | 0, 1070276 | 0);
           abort();
          }
          core__panicking__panic_bounds_check__h808b524af17640b1($6 | 0, $10 | 0, 1070292 | 0);
          abort();
         }
         $6 = $7 >>> 0 < $2 >>> 0;
         if (($7 | 0) != ($2 | 0)) {
          continue label$9
         }
         break label$9;
        };
       }
       $2 = $5;
      }
      $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 24 | 0 | 0, $3 + 48 | 0 | 0);
      $4 = HEAP32[($3 + 24 | 0) >> 2] | 0;
      core__iter__adapters__rev__Rev_T___new__h8896c06445f3ae2d($3 + 16 | 0 | 0, $4 | 0, $4 + (HEAP32[($3 + 28 | 0) >> 2] | 0) | 0 | 0);
      label$20 : {
       label$21 : {
        $9 = HEAP32[($3 + 16 | 0) >> 2] | 0;
        $6 = HEAP32[($3 + 20 | 0) >> 2] | 0;
        if (($9 | 0) == ($6 | 0)) {
         break label$21
        }
        $4 = $6 + -1 | 0;
        $5 = $9 - $6 | 0;
        $9 = $6 - $9 | 0;
        $6 = 0;
        label$22 : {
         label$23 : while (1) {
          if (HEAPU8[$4 >> 0] | 0) {
           break label$22
          }
          $4 = $4 + -1 | 0;
          $6 = $6 + 1 | 0;
          if ($5 + $6 | 0) {
           continue label$23
          }
          break label$23;
         };
         $6 = $9;
        }
        if ($2 >>> 0 <= $6 >>> 0) {
         break label$2
        }
        if ($6) {
         break label$20
        }
        break label$3;
       }
       if ($2) {
        break label$3
       }
       break label$2;
      }
      $6 = $2 + ($6 ^ -1 | 0) | 0;
      if (!$6) {
       break label$2
      }
      $4 = HEAP32[($3 + 56 | 0) >> 2] | 0;
      label$24 : while (1) {
       label$25 : {
        if (($4 | 0) != (HEAP32[($3 + 52 | 0) >> 2] | 0 | 0)) {
         break label$25
        }
        alloc__vec__Vec_T_2cA___reserve__h9cf757d86af8f187($3 + 48 | 0 | 0, 1 | 0);
        $4 = HEAP32[($3 + 56 | 0) >> 2] | 0;
       }
       HEAP8[((HEAP32[($3 + 48 | 0) >> 2] | 0) + $4 | 0) >> 0] = 0;
       $4 = (HEAP32[($3 + 56 | 0) >> 2] | 0) + 1 | 0;
       HEAP32[($3 + 56 | 0) >> 2] = $4;
       $6 = $6 + -1 | 0;
       if ($6) {
        continue label$24
       }
       break label$2;
      };
     }
     $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
     alloc__alloc__handle_alloc_error__he269d8f1bff90960(1 | 0, 1 | 0);
     abort();
    }
    $4 = HEAP32[($3 + 56 | 0) >> 2] | 0;
    $6 = 0;
    label$26 : while (1) {
     $6 = $6 + 1 | 0;
     label$27 : {
      if (($4 | 0) != (HEAP32[($3 + 52 | 0) >> 2] | 0 | 0)) {
       break label$27
      }
      alloc__vec__Vec_T_2cA___reserve__h9cf757d86af8f187($3 + 48 | 0 | 0, 1 | 0);
      $4 = HEAP32[($3 + 56 | 0) >> 2] | 0;
     }
     HEAP8[((HEAP32[($3 + 48 | 0) >> 2] | 0) + $4 | 0) >> 0] = 0;
     $4 = (HEAP32[($3 + 56 | 0) >> 2] | 0) + 1 | 0;
     HEAP32[($3 + 56 | 0) >> 2] = $4;
     if ($6 >>> 0 < $2 >>> 0) {
      continue label$26
     }
     break label$26;
    };
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__DerefMut___deref_mut__h1882e042320a120c($3 + 8 | 0 | 0, $3 + 48 | 0 | 0);
   label$28 : {
    $6 = HEAP32[($3 + 12 | 0) >> 2] | 0;
    $5 = $6 >>> 1 | 0;
    if (!$5) {
     break label$28
    }
    $4 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    $6 = ($6 + $4 | 0) + -1 | 0;
    label$29 : while (1) {
     $2 = HEAPU8[$4 >> 0] | 0;
     HEAP8[$4 >> 0] = HEAPU8[$6 >> 0] | 0;
     HEAP8[$6 >> 0] = $2;
     $4 = $4 + 1 | 0;
     $6 = $6 + -1 | 0;
     $5 = $5 + -1 | 0;
     if ($5) {
      continue label$29
     }
     break label$29;
    };
   }
   i64toi32_i32$1 = HEAP32[($3 + 52 | 0) >> 2] | 0;
   HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($3 + 48 | 0) >> 2] | 0;
   HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[$0 >> 2] = 0;
   HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($3 + 56 | 0) >> 2] | 0;
  }
  global$0 = $3 + 64 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__GenesisKeyDelegation___deserialize__h3a48f9f97f9ab4bf($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $2 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $7 = 0, $8 = 0, $3 = 0, $7$hi = 0, $8$hi = 0, $42 = 0, $43 = 0, $44 = 0, $46 = 0, $47 = 0, $48 = 0, $49 = 0, $50 = 0, $51 = 0, $52 = 0, $54 = 0, $55 = 0, $56 = 0, $57 = 0, $58 = 0, $59 = 0, $60 = 0, $61 = 0, $62 = 0, $63 = 0, $64 = 0, $4 = 0, $5 = 0, $65 = 0, $66 = 0, $67 = 0, $45 = 0, $53 = 0, $74 = 0, $6 = 0, $128 = 0, $132 = 0, $136 = 0, $144 = 0, $150 = 0, $156 = 0, $160 = 0, $191 = 0, $191$hi = 0, $194 = 0, $194$hi = 0, $198$hi = 0, $200$hi = 0, $202$hi = 0, $205 = 0, $205$hi = 0, $220 = 0, $226 = 0, $230 = 0, $246 = 0, $250 = 0, $256 = 0, $262 = 0;
  $2 = global$0 - 208 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 40 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      i64toi32_i32$2 = $2;
      i64toi32_i32$1 = HEAP32[($2 + 40 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($2 + 44 | 0) >> 2] | 0;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 1;
      if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
       break label$4
      }
      i64toi32_i32$2 = $7$hi;
      i64toi32_i32$0 = i64toi32_i32$2;
      cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__GenesisKeyDelegation___deserialize_as_embedded_group__h009fd03835fe23c0($2 + 40 | 0 | 0, $1 | 0, $7 | 0, i64toi32_i32$0 | 0, $7 | 0, i64toi32_i32$0 | 0);
      label$5 : {
       label$6 : {
        label$7 : {
         i64toi32_i32$3 = $7;
         i64toi32_i32$2 = 0;
         i64toi32_i32$1 = 1;
         if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) | 0) {
          break label$7
         }
         cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 160 | 0 | 0, $1 | 0);
         $3 = HEAPU8[($2 + 168 | 0) >> 0] | 0;
         i64toi32_i32$1 = $2;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 160 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 164 | 0) >> 2] | 0;
         i64toi32_i32$1 = i64toi32_i32$3;
         i64toi32_i32$3 = 0;
         i64toi32_i32$2 = 1;
         if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) | 0) {
          break label$6
         }
         $1 = 5;
         if (($3 & 255 | 0 | 0) != (5 | 0)) {
          break label$5
         }
        }
        $4 = ($2 + 8 | 0) + 8 | 0;
        i64toi32_i32$2 = ($2 + 40 | 0) + 40 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $45 = i64toi32_i32$1;
        i64toi32_i32$1 = $4;
        HEAP32[i64toi32_i32$1 >> 2] = $45;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        $5 = ($2 + 8 | 0) + 16 | 0;
        i64toi32_i32$2 = ($2 + 40 | 0) + 48 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $53 = i64toi32_i32$0;
        i64toi32_i32$0 = $5;
        HEAP32[i64toi32_i32$0 >> 2] = $53;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        HEAP32[($2 + 136 | 0) >> 2] = HEAPU8[($2 + 41 | 0) >> 0] | 0 | ((HEAPU8[($2 + 42 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 43 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 44 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $42 = HEAPU8[($2 + 44 | 0) >> 0] | 0 | ((HEAPU8[($2 + 45 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 46 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 47 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 139 | 0) >> 0] = $42;
        HEAP8[($2 + 140 | 0) >> 0] = $42 >>> 8 | 0;
        HEAP8[($2 + 141 | 0) >> 0] = $42 >>> 16 | 0;
        HEAP8[($2 + 142 | 0) >> 0] = $42 >>> 24 | 0;
        $43 = ($2 + 40 | 0) + 9 | 0;
        HEAP32[($2 + 32 | 0) >> 2] = HEAPU8[$43 >> 0] | 0 | ((HEAPU8[($43 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($43 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($43 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $44 = ($2 + 40 | 0) + 12 | 0;
        $46 = HEAPU8[$44 >> 0] | 0 | ((HEAPU8[($44 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($44 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($44 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 35 | 0) >> 0] = $46;
        HEAP8[($2 + 36 | 0) >> 0] = $46 >>> 8 | 0;
        HEAP8[($2 + 37 | 0) >> 0] = $46 >>> 16 | 0;
        HEAP8[($2 + 38 | 0) >> 0] = $46 >>> 24 | 0;
        i64toi32_i32$2 = ($2 + 40 | 0) + 32 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $74 = i64toi32_i32$1;
        i64toi32_i32$1 = $2;
        HEAP32[($2 + 8 | 0) >> 2] = $74;
        HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
        $1 = HEAPU8[(($2 + 40 | 0) + 8 | 0) >> 0] | 0;
        i64toi32_i32$2 = ($2 + 40 | 0) + 16 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $7 = i64toi32_i32$0;
        $7$hi = i64toi32_i32$1;
        i64toi32_i32$2 = ($2 + 40 | 0) + 24 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $8 = i64toi32_i32$1;
        $8$hi = i64toi32_i32$0;
        $6 = HEAPU8[($2 + 40 | 0) >> 0] | 0;
        $3 = HEAP32[(($2 + 40 | 0) + 56 | 0) >> 2] | 0;
        memcpy($2 + 160 | 0 | 0, ($2 + 40 | 0) + 60 | 0 | 0, 36 | 0) | 0;
        if (($6 | 0) == (1 | 0)) {
         break label$2
        }
        $47 = HEAP32[($2 + 136 | 0) >> 2] | 0;
        HEAP8[($0 + 1 | 0) >> 0] = $47;
        HEAP8[($0 + 2 | 0) >> 0] = $47 >>> 8 | 0;
        HEAP8[($0 + 3 | 0) >> 0] = $47 >>> 16 | 0;
        HEAP8[($0 + 4 | 0) >> 0] = $47 >>> 24 | 0;
        $48 = $0 + 4 | 0;
        $49 = HEAPU8[($2 + 139 | 0) >> 0] | 0 | ((HEAPU8[($2 + 140 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 141 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 142 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[$48 >> 0] = $49;
        HEAP8[($48 + 1 | 0) >> 0] = $49 >>> 8 | 0;
        HEAP8[($48 + 2 | 0) >> 0] = $49 >>> 16 | 0;
        HEAP8[($48 + 3 | 0) >> 0] = $49 >>> 24 | 0;
        HEAP8[($0 + 8 | 0) >> 0] = $1;
        $50 = $0 + 9 | 0;
        $51 = HEAP32[($2 + 32 | 0) >> 2] | 0;
        HEAP8[$50 >> 0] = $51;
        HEAP8[($50 + 1 | 0) >> 0] = $51 >>> 8 | 0;
        HEAP8[($50 + 2 | 0) >> 0] = $51 >>> 16 | 0;
        HEAP8[($50 + 3 | 0) >> 0] = $51 >>> 24 | 0;
        $52 = $0 + 12 | 0;
        $54 = HEAPU8[($2 + 35 | 0) >> 0] | 0 | ((HEAPU8[($2 + 36 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 37 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 38 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[$52 >> 0] = $54;
        HEAP8[($52 + 1 | 0) >> 0] = $54 >>> 8 | 0;
        HEAP8[($52 + 2 | 0) >> 0] = $54 >>> 16 | 0;
        HEAP8[($52 + 3 | 0) >> 0] = $54 >>> 24 | 0;
        i64toi32_i32$0 = $8$hi;
        i64toi32_i32$1 = $0 + 24 | 0;
        HEAP8[i64toi32_i32$1 >> 0] = $8;
        HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $8 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $8 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $8 >>> 24 | 0;
        HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
        HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
        i64toi32_i32$0 = $7$hi;
        i64toi32_i32$1 = $0 + 16 | 0;
        HEAP8[i64toi32_i32$1 >> 0] = $7;
        HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $7 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $7 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $7 >>> 24 | 0;
        HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
        HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
        $128 = i64toi32_i32$0;
        i64toi32_i32$0 = $0 + 32 | 0;
        $55 = $128;
        HEAP8[i64toi32_i32$0 >> 0] = $55;
        HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $55 >>> 8 | 0;
        HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $55 >>> 16 | 0;
        HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $55 >>> 24 | 0;
        HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
        HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
        HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
        HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
        i64toi32_i32$2 = $4;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $132 = i64toi32_i32$1;
        i64toi32_i32$1 = $0 + 40 | 0;
        $56 = $132;
        HEAP8[i64toi32_i32$1 >> 0] = $56;
        HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $56 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $56 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $56 >>> 24 | 0;
        HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
        HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
        i64toi32_i32$2 = $5;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $136 = i64toi32_i32$0;
        i64toi32_i32$0 = $0 + 48 | 0;
        $57 = $136;
        HEAP8[i64toi32_i32$0 >> 0] = $57;
        HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $57 >>> 8 | 0;
        HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $57 >>> 16 | 0;
        HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $57 >>> 24 | 0;
        HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
        HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
        HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
        HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
        $58 = $0 + 56 | 0;
        HEAP8[$58 >> 0] = $3;
        HEAP8[($58 + 1 | 0) >> 0] = $3 >>> 8 | 0;
        HEAP8[($58 + 2 | 0) >> 0] = $3 >>> 16 | 0;
        HEAP8[($58 + 3 | 0) >> 0] = $3 >>> 24 | 0;
        i64toi32_i32$2 = $2 + 181 | 0;
        i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $144 = i64toi32_i32$1;
        i64toi32_i32$1 = $0 + 81 | 0;
        $59 = $144;
        HEAP8[i64toi32_i32$1 >> 0] = $59;
        HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $59 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $59 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $59 >>> 24 | 0;
        HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
        HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
        i64toi32_i32$2 = ($2 + 160 | 0) + 16 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $150 = i64toi32_i32$0;
        i64toi32_i32$0 = $0 + 76 | 0;
        $60 = $150;
        HEAP8[i64toi32_i32$0 >> 0] = $60;
        HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $60 >>> 8 | 0;
        HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $60 >>> 16 | 0;
        HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $60 >>> 24 | 0;
        HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
        HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
        HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
        HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
        i64toi32_i32$2 = ($2 + 160 | 0) + 8 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $156 = i64toi32_i32$1;
        i64toi32_i32$1 = $0 + 68 | 0;
        $61 = $156;
        HEAP8[i64toi32_i32$1 >> 0] = $61;
        HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $61 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $61 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $61 >>> 24 | 0;
        HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
        HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 160 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 164 | 0) >> 2] | 0;
        $160 = i64toi32_i32$0;
        i64toi32_i32$0 = $0 + 60 | 0;
        $62 = $160;
        HEAP8[i64toi32_i32$0 >> 0] = $62;
        HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $62 >>> 8 | 0;
        HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $62 >>> 16 | 0;
        HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $62 >>> 24 | 0;
        HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
        HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
        HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
        HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
        $1 = 0;
        break label$1;
       }
       i64toi32_i32$2 = $2 + 192 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $7 = i64toi32_i32$1;
       $7$hi = i64toi32_i32$0;
       i64toi32_i32$1 = ($2 + 136 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $7;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = $2 + 200 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $8 = i64toi32_i32$0;
       $8$hi = i64toi32_i32$1;
       i64toi32_i32$0 = ($2 + 136 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $8;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$1 = $7$hi;
       i64toi32_i32$0 = ($2 + 8 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $7;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$1 = $8$hi;
       i64toi32_i32$0 = ($2 + 8 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $8;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $2 + 184 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $7 = i64toi32_i32$1;
       $7$hi = i64toi32_i32$0;
       i64toi32_i32$1 = $2;
       HEAP32[(i64toi32_i32$1 + 136 | 0) >> 2] = $7;
       HEAP32[(i64toi32_i32$1 + 140 | 0) >> 2] = i64toi32_i32$0;
       HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $7;
       HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = i64toi32_i32$1;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 169 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 170 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 171 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 172 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = 0;
       $191 = i64toi32_i32$0;
       $191$hi = i64toi32_i32$1;
       i64toi32_i32$2 = $2 + 173 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
       i64toi32_i32$0 = 0;
       $194 = i64toi32_i32$1;
       $194$hi = i64toi32_i32$0;
       i64toi32_i32$2 = $2 + 175 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$2 = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $65 = 0;
       } else {
        i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $65 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       $198$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $194$hi;
       i64toi32_i32$1 = $194;
       i64toi32_i32$2 = $198$hi;
       i64toi32_i32$3 = $65;
       i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
       i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $66 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
        $66 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       $200$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $191$hi;
       i64toi32_i32$2 = $191;
       i64toi32_i32$0 = $200$hi;
       i64toi32_i32$3 = $66;
       i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
       i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 8;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        $67 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
        $67 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       }
       $202$hi = i64toi32_i32$2;
       i64toi32_i32$2 = 0;
       i64toi32_i32$0 = $3;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 255;
       i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
       $205 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
       $205$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $202$hi;
       i64toi32_i32$2 = $67;
       i64toi32_i32$0 = $205$hi;
       i64toi32_i32$3 = $205;
       i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
       $7 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       $7$hi = i64toi32_i32$0;
       i64toi32_i32$1 = ($2 + 160 | 0) + 16 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $8 = i64toi32_i32$0;
       $8$hi = i64toi32_i32$2;
       $1 = 2;
      }
      if (!(HEAPU8[($2 + 40 | 0) >> 0] | 0)) {
       break label$3
      }
      core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9($2 + 48 | 0 | 0);
      break label$3;
     }
     i64toi32_i32$1 = $2 + 72 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $220 = i64toi32_i32$2;
     i64toi32_i32$2 = $2 + 16 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $220;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$1 = $2 + 80 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $226 = i64toi32_i32$0;
     i64toi32_i32$0 = ($2 + 8 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $226;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$1 = $2 + 64 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $230 = i64toi32_i32$2;
     i64toi32_i32$2 = $2;
     HEAP32[($2 + 8 | 0) >> 2] = $230;
     HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$1 = ($2 + 40 | 0) + 16 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $8 = i64toi32_i32$0;
     $8$hi = i64toi32_i32$2;
     $1 = 2;
    }
    $3 = 0;
   }
   i64toi32_i32$2 = $8$hi;
   i64toi32_i32$0 = ($2 + 40 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $8;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$2 = $7$hi;
   i64toi32_i32$0 = ($2 + 40 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $7;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$1 = $2;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] | 0;
   $246 = i64toi32_i32$2;
   i64toi32_i32$2 = i64toi32_i32$1 + 64 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $246;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 160 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 164 | 0) >> 2] | 0;
   $250 = i64toi32_i32$0;
   i64toi32_i32$0 = i64toi32_i32$1 + 92 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $250;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$1 = (i64toi32_i32$1 + 8 | 0) + 8 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $256 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 72 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $256;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$1 = ($2 + 8 | 0) + 16 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $262 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 80 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $262;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   HEAP32[($2 + 100 | 0) >> 2] = HEAP32[(($2 + 160 | 0) + 8 | 0) >> 2] | 0;
   HEAP8[($2 + 40 | 0) >> 0] = $1;
   $63 = HEAP32[($2 + 32 | 0) >> 2] | 0;
   HEAP8[($2 + 41 | 0) >> 0] = $63;
   HEAP8[($2 + 42 | 0) >> 0] = $63 >>> 8 | 0;
   HEAP8[($2 + 43 | 0) >> 0] = $63 >>> 16 | 0;
   HEAP8[($2 + 44 | 0) >> 0] = $63 >>> 24 | 0;
   $64 = HEAPU8[($2 + 35 | 0) >> 0] | 0 | ((HEAPU8[($2 + 36 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 37 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 38 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[($2 + 44 | 0) >> 0] = $64;
   HEAP8[($2 + 45 | 0) >> 0] = $64 >>> 8 | 0;
   HEAP8[($2 + 46 | 0) >> 0] = $64 >>> 16 | 0;
   HEAP8[($2 + 47 | 0) >> 0] = $64 >>> 24 | 0;
   HEAP32[($2 + 88 | 0) >> 2] = $3;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 40 | 0 | 0, 1051025 | 0, 20 | 0);
   $1 = 1;
  }
  HEAP8[$0 >> 0] = $1;
  global$0 = $2 + 208 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__NativeScripts___deserialize__h5fb973a07bcdbe01($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, $3 = 0, $9 = 0, $10 = 0, $7 = 0, $9$hi = 0, $10$hi = 0, $8 = 0, $32 = 0, $33 = 0, $34 = 0, $11 = 0, $11$hi = 0, $35 = 0, $36 = 0, $37 = 0, $38 = 0, $39 = 0, $40 = 0, $41 = 0, $42 = 0, $43 = 0, $4 = 0, $5 = 0, $12 = 0, $12$hi = 0, $6 = 0, $150 = 0, $159 = 0, $163 = 0, $181 = 0, $185 = 0, $193 = 0, $197 = 0, $214 = 0, $218 = 0, $224 = 0, $251 = 0;
  $2 = global$0 - 304 | 0;
  global$0 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 20 | 0) >> 2] = 0;
  HEAP32[($2 + 24 | 0) >> 2] = i64toi32_i32$0;
  $3 = 0;
  HEAP32[($2 + 16 | 0) >> 2] = HEAP32[(0 + 1050204 | 0) >> 2] | 0;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 232 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2 + 248 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $9 = i64toi32_i32$0;
  $9$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 240 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 244 | 0) >> 2] | 0;
  $10 = i64toi32_i32$1;
  $10$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 232 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 236 | 0) >> 2] | 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
         break label$6
        }
        i64toi32_i32$2 = $9$hi;
        $4 = $9;
        label$7 : {
         i64toi32_i32$2 = $10$hi;
         i64toi32_i32$3 = $10;
         i64toi32_i32$1 = 0;
         i64toi32_i32$0 = 1;
         if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
          break label$7
         }
         if (!$4) {
          break label$3
         }
        }
        $5 = $2 + 241 | 0;
        $6 = $5 + 3 | 0;
        label$8 : {
         label$9 : while (1) {
          std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 8 | 0 | 0, $1 | 0);
          $3 = 0;
          $7 = 2;
          label$10 : {
           if (HEAP32[($2 + 12 | 0) >> 2] | 0) {
            break label$10
           }
           i64toi32_i32$3 = 0;
           $10 = 8;
           $10$hi = i64toi32_i32$3;
           i64toi32_i32$3 = 0;
           $9 = 0;
           $9$hi = i64toi32_i32$3;
           break label$4;
          }
          label$11 : {
           if ((($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[($2 + 8 | 0) >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) == (7 | 0)) {
            break label$11
           }
           cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__NativeScript___deserialize__hcd9caa6a3e1b77da($2 + 232 | 0 | 0, $1 | 0);
           $32 = $5;
           HEAP32[($2 + 216 | 0) >> 2] = HEAPU8[$32 >> 0] | 0 | ((HEAPU8[($32 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($32 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($32 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $33 = $6;
           $34 = HEAPU8[$33 >> 0] | 0 | ((HEAPU8[($33 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($33 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($33 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 219 | 0) >> 0] = $34;
           HEAP8[($2 + 220 | 0) >> 0] = $34 >>> 8 | 0;
           HEAP8[($2 + 221 | 0) >> 0] = $34 >>> 16 | 0;
           HEAP8[($2 + 222 | 0) >> 0] = $34 >>> 24 | 0;
           i64toi32_i32$0 = $2;
           i64toi32_i32$3 = HEAP32[($2 + 264 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($2 + 268 | 0) >> 2] | 0;
           $11 = i64toi32_i32$3;
           $11$hi = i64toi32_i32$2;
           i64toi32_i32$0 = $2;
           i64toi32_i32$2 = HEAP32[($2 + 256 | 0) >> 2] | 0;
           i64toi32_i32$3 = HEAP32[($2 + 260 | 0) >> 2] | 0;
           $9 = i64toi32_i32$2;
           $9$hi = i64toi32_i32$3;
           i64toi32_i32$0 = $2;
           i64toi32_i32$3 = HEAP32[($2 + 248 | 0) >> 2] | 0;
           i64toi32_i32$2 = HEAP32[($2 + 252 | 0) >> 2] | 0;
           $12 = i64toi32_i32$3;
           $12$hi = i64toi32_i32$2;
           $7 = HEAPU8[($2 + 240 | 0) >> 0] | 0;
           i64toi32_i32$0 = $2;
           i64toi32_i32$2 = HEAP32[($2 + 232 | 0) >> 2] | 0;
           i64toi32_i32$3 = HEAP32[($2 + 236 | 0) >> 2] | 0;
           i64toi32_i32$0 = i64toi32_i32$2;
           i64toi32_i32$2 = 0;
           i64toi32_i32$1 = 1;
           if ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) | 0) {
            break label$8
           }
           HEAP32[($2 + 200 | 0) >> 2] = HEAP32[($2 + 216 | 0) >> 2] | 0;
           $35 = HEAPU8[($2 + 219 | 0) >> 0] | 0 | ((HEAPU8[($2 + 220 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 221 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 222 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[($2 + 203 | 0) >> 0] = $35;
           HEAP8[($2 + 204 | 0) >> 0] = $35 >>> 8 | 0;
           HEAP8[($2 + 205 | 0) >> 0] = $35 >>> 16 | 0;
           HEAP8[($2 + 206 | 0) >> 0] = $35 >>> 24 | 0;
           label$12 : {
            $8 = HEAP32[($2 + 24 | 0) >> 2] | 0;
            if ((HEAP32[($2 + 20 | 0) >> 2] | 0 | 0) != ($8 | 0)) {
             break label$12
            }
            alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h5af6e4677d294e82($2 + 16 | 0 | 0, $8 | 0, 1 | 0);
            $8 = HEAP32[($2 + 24 | 0) >> 2] | 0;
           }
           $3 = (HEAP32[($2 + 16 | 0) >> 2] | 0) + ($8 << 5 | 0) | 0;
           $36 = HEAP32[($2 + 200 | 0) >> 2] | 0;
           HEAP8[($3 + 1 | 0) >> 0] = $36;
           HEAP8[($3 + 2 | 0) >> 0] = $36 >>> 8 | 0;
           HEAP8[($3 + 3 | 0) >> 0] = $36 >>> 16 | 0;
           HEAP8[($3 + 4 | 0) >> 0] = $36 >>> 24 | 0;
           HEAP8[$3 >> 0] = $7;
           $37 = $3 + 4 | 0;
           $38 = HEAPU8[($2 + 203 | 0) >> 0] | 0 | ((HEAPU8[($2 + 204 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 205 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 206 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           HEAP8[$37 >> 0] = $38;
           HEAP8[($37 + 1 | 0) >> 0] = $38 >>> 8 | 0;
           HEAP8[($37 + 2 | 0) >> 0] = $38 >>> 16 | 0;
           HEAP8[($37 + 3 | 0) >> 0] = $38 >>> 24 | 0;
           i64toi32_i32$0 = $11$hi;
           i64toi32_i32$3 = $3 + 24 | 0;
           $39 = $11;
           HEAP8[i64toi32_i32$3 >> 0] = $39;
           HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $39 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $39 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $39 >>> 24 | 0;
           HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$0;
           HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
           i64toi32_i32$0 = $9$hi;
           i64toi32_i32$3 = $3 + 16 | 0;
           HEAP8[i64toi32_i32$3 >> 0] = $9;
           HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $9 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $9 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $9 >>> 24 | 0;
           HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$0;
           HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
           i64toi32_i32$0 = $12$hi;
           i64toi32_i32$3 = $3 + 8 | 0;
           $40 = $12;
           HEAP8[i64toi32_i32$3 >> 0] = $40;
           HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $40 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $40 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $40 >>> 24 | 0;
           HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$0;
           HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
           HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
           HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
           $3 = $8 + 1 | 0;
           HEAP32[($2 + 24 | 0) >> 2] = $3;
           i64toi32_i32$0 = $10$hi;
           i64toi32_i32$1 = $10;
           i64toi32_i32$3 = 0;
           i64toi32_i32$2 = 1;
           if ((i64toi32_i32$1 | 0) != (i64toi32_i32$2 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$3 | 0) | 0) {
            continue label$9
           }
           if ($3 >>> 0 < $4 >>> 0) {
            continue label$9
           }
           break label$3;
          }
          break label$9;
         };
         cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 232 | 0 | 0, $1 | 0);
         i64toi32_i32$2 = $2 + 248 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $9 = i64toi32_i32$1;
         $9$hi = i64toi32_i32$0;
         i64toi32_i32$2 = $2;
         i64toi32_i32$0 = HEAP32[($2 + 240 | 0) >> 2] | 0;
         i64toi32_i32$1 = HEAP32[($2 + 244 | 0) >> 2] | 0;
         $10 = i64toi32_i32$0;
         $10$hi = i64toi32_i32$1;
         i64toi32_i32$2 = $2;
         i64toi32_i32$1 = HEAP32[($2 + 232 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($2 + 236 | 0) >> 2] | 0;
         i64toi32_i32$2 = i64toi32_i32$1;
         i64toi32_i32$1 = 0;
         i64toi32_i32$3 = 1;
         if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
          break label$5
         }
         i64toi32_i32$2 = $9$hi;
         i64toi32_i32$0 = $2 + 208 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $9;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
         i64toi32_i32$2 = $10$hi;
         i64toi32_i32$0 = $2;
         HEAP32[($2 + 200 | 0) >> 2] = $10;
         HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$2;
         if (($10 & 255 | 0 | 0) == (5 | 0)) {
          break label$3
         }
         HEAP32[($2 + 232 | 0) >> 2] = 0;
         core__panicking__assert_failed__h96d8431cc974b591(0 | 0, $2 + 200 | 0 | 0, 1050312 | 0, $2 + 232 | 0 | 0, 1051968 | 0);
         abort();
        }
        i64toi32_i32$3 = $2 + 280 | 0;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $150 = i64toi32_i32$2;
        i64toi32_i32$2 = ($2 + 176 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$2 >> 2] = $150;
        HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
        HEAP32[(($2 + 160 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 300 | 0) >> 2] | 0;
        i64toi32_i32$3 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 292 | 0) >> 2] | 0;
        i64toi32_i32$2 = HEAP32[($2 + 296 | 0) >> 2] | 0;
        $159 = i64toi32_i32$0;
        i64toi32_i32$0 = $2;
        HEAP32[($2 + 160 | 0) >> 2] = $159;
        HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$2;
        i64toi32_i32$3 = $2 + 272 | 0;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $163 = i64toi32_i32$2;
        i64toi32_i32$2 = $2;
        HEAP32[($2 + 176 | 0) >> 2] = $163;
        HEAP32[($2 + 180 | 0) >> 2] = i64toi32_i32$0;
        HEAP32[($2 + 192 | 0) >> 2] = HEAP32[($2 + 216 | 0) >> 2] | 0;
        $41 = HEAPU8[($2 + 219 | 0) >> 0] | 0 | ((HEAPU8[($2 + 220 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 221 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 222 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 195 | 0) >> 0] = $41;
        HEAP8[($2 + 196 | 0) >> 0] = $41 >>> 8 | 0;
        HEAP8[($2 + 197 | 0) >> 0] = $41 >>> 16 | 0;
        HEAP8[($2 + 198 | 0) >> 0] = $41 >>> 24 | 0;
        if (($7 & 255 | 0 | 0) == (19 | 0)) {
         break label$3
        }
        $3 = HEAP32[($2 + 288 | 0) >> 2] | 0;
        i64toi32_i32$0 = $12$hi;
        $10 = $12;
        $10$hi = i64toi32_i32$0;
        break label$4;
       }
       i64toi32_i32$3 = $2 + 272 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $181 = i64toi32_i32$0;
       i64toi32_i32$0 = $2 + 184 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $181;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$3 = $2 + 264 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $185 = i64toi32_i32$2;
       i64toi32_i32$2 = $2;
       HEAP32[($2 + 176 | 0) >> 2] = $185;
       HEAP32[($2 + 180 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$3 = $2 + 256 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $11 = i64toi32_i32$0;
       $11$hi = i64toi32_i32$2;
       $7 = 2;
       break label$4;
      }
      i64toi32_i32$3 = $2 + 272 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $193 = i64toi32_i32$2;
      i64toi32_i32$2 = $2 + 184 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $193;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$3 = $2 + 264 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $197 = i64toi32_i32$0;
      i64toi32_i32$0 = $2;
      HEAP32[($2 + 176 | 0) >> 2] = $197;
      HEAP32[($2 + 180 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$3 = $2 + 256 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $11 = i64toi32_i32$2;
      $11$hi = i64toi32_i32$0;
     }
     i64toi32_i32$0 = $11$hi;
     i64toi32_i32$2 = $2 + 256 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $11;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$0 = $9$hi;
     i64toi32_i32$2 = $2 + 248 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $9;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$0 = $10$hi;
     i64toi32_i32$2 = ($2 + 232 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $10;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$3 = $2;
     i64toi32_i32$0 = HEAP32[($2 + 176 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[($2 + 180 | 0) >> 2] | 0;
     $214 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 264 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $214;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$3 = $2;
     i64toi32_i32$2 = HEAP32[($2 + 160 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 164 | 0) >> 2] | 0;
     $218 = i64toi32_i32$2;
     i64toi32_i32$2 = $2 + 284 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $218;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$3 = ($2 + 176 | 0) + 8 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $224 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 272 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $224;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
     HEAP32[($2 + 292 | 0) >> 2] = HEAP32[(($2 + 160 | 0) + 8 | 0) >> 2] | 0;
     HEAP8[($2 + 232 | 0) >> 0] = $7;
     $42 = HEAP32[($2 + 192 | 0) >> 2] | 0;
     HEAP8[($2 + 233 | 0) >> 0] = $42;
     HEAP8[($2 + 234 | 0) >> 0] = $42 >>> 8 | 0;
     HEAP8[($2 + 235 | 0) >> 0] = $42 >>> 16 | 0;
     HEAP8[($2 + 236 | 0) >> 0] = $42 >>> 24 | 0;
     $43 = HEAPU8[($2 + 195 | 0) >> 0] | 0 | ((HEAPU8[($2 + 196 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 197 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 198 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($2 + 236 | 0) >> 0] = $43;
     HEAP8[($2 + 237 | 0) >> 0] = $43 >>> 8 | 0;
     HEAP8[($2 + 238 | 0) >> 0] = $43 >>> 16 | 0;
     HEAP8[($2 + 239 | 0) >> 0] = $43 >>> 24 | 0;
     HEAP32[($2 + 280 | 0) >> 2] = $3;
     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($2 + 96 | 0 | 0, $2 + 232 | 0 | 0, 1051984 | 0, 13 | 0);
     $7 = HEAPU8[($2 + 96 | 0) >> 0] | 0;
     if (($7 | 0) != (19 | 0)) {
      break label$2
     }
    }
    i64toi32_i32$3 = $2;
    i64toi32_i32$2 = HEAP32[($2 + 16 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
    $251 = i64toi32_i32$2;
    i64toi32_i32$2 = $0;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = $251;
    HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = HEAP32[($2 + 24 | 0) >> 2] | 0;
    $3 = 0;
    break label$1;
   }
   $3 = 1;
   memcpy($2 + 33 | 0 | 0, $2 + 96 | 0 | 1 | 0 | 0, 63 | 0) | 0;
   HEAP8[($0 + 8 | 0) >> 0] = $7;
   memcpy($0 + 9 | 0 | 0, $2 + 33 | 0 | 0, 63 | 0) | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc3d6ec99c05cee40($2 + 16 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h0f78886c344617d4($2 + 16 | 0 | 0);
  }
  HEAP32[$0 >> 2] = $3;
  global$0 = $2 + 304 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__ProtocolVersions___deserialize__hb8264e18664de337($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, $3 = 0, $8 = 0, $8$hi = 0, $5 = 0, $7 = 0, $7$hi = 0, $6 = 0, $4 = 0, $116 = 0, $122 = 0, $132 = 0, $136 = 0, $161 = 0, $167 = 0, $171 = 0, $176 = 0, $182 = 0, $186 = 0, $198 = 0, $202 = 0, $208 = 0, $214 = 0, $242 = 0;
  $2 = global$0 - 304 | 0;
  global$0 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 12 | 0) >> 2] = 0;
  HEAP32[($2 + 16 | 0) >> 2] = i64toi32_i32$0;
  $3 = 0;
  HEAP32[($2 + 8 | 0) >> 2] = HEAP32[(0 + 1050220 | 0) >> 2] | 0;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 232 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = ($2 + 232 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 240 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 244 | 0) >> 2] | 0;
  $8 = i64toi32_i32$1;
  $8$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 232 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 236 | 0) >> 2] | 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
         break label$6
        }
        i64toi32_i32$2 = $7$hi;
        $4 = $7;
        label$7 : {
         i64toi32_i32$2 = $8$hi;
         i64toi32_i32$3 = $8;
         i64toi32_i32$1 = 0;
         i64toi32_i32$0 = 1;
         if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
          break label$7
         }
         if (!$4) {
          break label$3
         }
        }
        label$8 : {
         label$9 : while (1) {
          std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 | 0, $1 | 0);
          $3 = 0;
          $5 = 2;
          label$10 : {
           if (HEAP32[($2 + 4 | 0) >> 2] | 0) {
            break label$10
           }
           i64toi32_i32$3 = 0;
           $8 = 8;
           $8$hi = i64toi32_i32$3;
           i64toi32_i32$3 = 0;
           $7 = 0;
           $7$hi = i64toi32_i32$3;
           break label$4;
          }
          label$11 : {
           if ((($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[$2 >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) == (7 | 0)) {
            break label$11
           }
           i64toi32_i32$3 = $8$hi;
           i64toi32_i32$2 = i64toi32_i32$3;
           cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__ProtocolVersion___deserialize_as_embedded_group__h2c31b2815aa7e5c5($2 + 232 | 0 | 0, $1 | 0, $8 | 0, i64toi32_i32$2 | 0, $8 | 0, i64toi32_i32$2 | 0);
           if ((HEAP32[($2 + 232 | 0) >> 2] | 0 | 0) == (1 | 0)) {
            break label$8
           }
           $5 = HEAP32[($2 + 240 | 0) >> 2] | 0;
           $6 = HEAP32[($2 + 236 | 0) >> 2] | 0;
           label$12 : {
            $3 = HEAP32[($2 + 16 | 0) >> 2] | 0;
            if ((HEAP32[($2 + 12 | 0) >> 2] | 0 | 0) != ($3 | 0)) {
             break label$12
            }
            alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hb28826101b6ca67b($2 + 8 | 0 | 0, $3 | 0, 1 | 0);
            $3 = HEAP32[($2 + 16 | 0) >> 2] | 0;
           }
           $3 = (HEAP32[($2 + 8 | 0) >> 2] | 0) + ($3 << 3 | 0) | 0;
           HEAP32[($3 + 4 | 0) >> 2] = $5;
           HEAP32[$3 >> 2] = $6;
           $3 = (HEAP32[($2 + 16 | 0) >> 2] | 0) + 1 | 0;
           HEAP32[($2 + 16 | 0) >> 2] = $3;
           i64toi32_i32$2 = $8$hi;
           i64toi32_i32$0 = $8;
           i64toi32_i32$3 = 0;
           i64toi32_i32$1 = 1;
           if ((i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | 0) {
            continue label$9
           }
           if ($3 >>> 0 < $4 >>> 0) {
            continue label$9
           }
           break label$3;
          }
          break label$9;
         };
         cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 232 | 0 | 0, $1 | 0);
         i64toi32_i32$1 = ($2 + 232 | 0) + 16 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
         $7 = i64toi32_i32$0;
         $7$hi = i64toi32_i32$2;
         i64toi32_i32$1 = $2;
         i64toi32_i32$2 = HEAP32[($2 + 240 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($2 + 244 | 0) >> 2] | 0;
         $8 = i64toi32_i32$2;
         $8$hi = i64toi32_i32$0;
         i64toi32_i32$1 = $2;
         i64toi32_i32$0 = HEAP32[($2 + 232 | 0) >> 2] | 0;
         i64toi32_i32$2 = HEAP32[($2 + 236 | 0) >> 2] | 0;
         i64toi32_i32$1 = i64toi32_i32$0;
         i64toi32_i32$0 = 0;
         i64toi32_i32$3 = 1;
         if ((i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) | 0) {
          break label$5
         }
         i64toi32_i32$1 = $7$hi;
         i64toi32_i32$2 = $2 + 200 | 0;
         HEAP32[i64toi32_i32$2 >> 2] = $7;
         HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$1 = $8$hi;
         i64toi32_i32$2 = $2;
         HEAP32[($2 + 192 | 0) >> 2] = $8;
         HEAP32[($2 + 196 | 0) >> 2] = i64toi32_i32$1;
         if (($8 & 255 | 0 | 0) == (5 | 0)) {
          break label$3
         }
         HEAP32[($2 + 232 | 0) >> 2] = 0;
         core__panicking__assert_failed__h96d8431cc974b591(0 | 0, $2 + 192 | 0 | 0, 1050312 | 0, $2 + 232 | 0 | 0, 1052176 | 0);
         abort();
        }
        i64toi32_i32$3 = $2 + 272 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $116 = i64toi32_i32$1;
        i64toi32_i32$1 = ($2 + 168 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $116;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
        i64toi32_i32$3 = $2 + 280 | 0;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $122 = i64toi32_i32$2;
        i64toi32_i32$2 = ($2 + 168 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$2 >> 2] = $122;
        HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
        HEAP32[(($2 + 152 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 300 | 0) >> 2] | 0;
        i64toi32_i32$3 = $2 + 264 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $132 = i64toi32_i32$1;
        i64toi32_i32$1 = $2;
        HEAP32[($2 + 168 | 0) >> 2] = $132;
        HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$2;
        i64toi32_i32$3 = $2 + 292 | 0;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $136 = i64toi32_i32$2;
        i64toi32_i32$2 = $2;
        HEAP32[($2 + 152 | 0) >> 2] = $136;
        HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$1;
        $5 = HEAP32[($2 + 240 | 0) >> 2] | 0;
        if (($5 & 255 | 0 | 0) == (19 | 0)) {
         break label$3
        }
        $1 = $5 >>> 8 | 0;
        i64toi32_i32$3 = $2 + 256 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $7 = i64toi32_i32$1;
        $7$hi = i64toi32_i32$2;
        i64toi32_i32$3 = ($2 + 232 | 0) + 16 | 0;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $8 = i64toi32_i32$2;
        $8$hi = i64toi32_i32$1;
        $6 = HEAP32[($2 + 244 | 0) >> 2] | 0;
        $3 = HEAP32[($2 + 288 | 0) >> 2] | 0;
        break label$4;
       }
       i64toi32_i32$3 = $2 + 264 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $161 = i64toi32_i32$1;
       i64toi32_i32$1 = $2 + 176 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $161;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$3 = $2 + 272 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $167 = i64toi32_i32$2;
       i64toi32_i32$2 = ($2 + 168 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $167;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$3 = $2 + 256 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $171 = i64toi32_i32$1;
       i64toi32_i32$1 = $2;
       HEAP32[($2 + 168 | 0) >> 2] = $171;
       HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$2;
       $5 = 2;
       break label$4;
      }
      i64toi32_i32$3 = $2 + 264 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $176 = i64toi32_i32$2;
      i64toi32_i32$2 = $2 + 176 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $176;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$3 = $2 + 272 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $182 = i64toi32_i32$1;
      i64toi32_i32$1 = ($2 + 168 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $182;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$3 = $2 + 256 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $186 = i64toi32_i32$2;
      i64toi32_i32$2 = $2;
      HEAP32[($2 + 168 | 0) >> 2] = $186;
      HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$1;
     }
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$2 = ($2 + 232 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $7;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $8$hi;
     i64toi32_i32$2 = ($2 + 232 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $8;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$3 = $2;
     i64toi32_i32$1 = HEAP32[($2 + 168 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[($2 + 172 | 0) >> 2] | 0;
     $198 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 256 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $198;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$3 = $2;
     i64toi32_i32$2 = HEAP32[($2 + 152 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 156 | 0) >> 2] | 0;
     $202 = i64toi32_i32$2;
     i64toi32_i32$2 = $2 + 284 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $202;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$3 = ($2 + 168 | 0) + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $208 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 264 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $208;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$3 = ($2 + 168 | 0) + 16 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $214 = i64toi32_i32$2;
     i64toi32_i32$2 = $2 + 272 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $214;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($2 + 292 | 0) >> 2] = HEAP32[(($2 + 152 | 0) + 8 | 0) >> 2] | 0;
     HEAP32[($2 + 236 | 0) >> 2] = $6;
     HEAP8[($2 + 232 | 0) >> 0] = $5;
     HEAP32[($2 + 280 | 0) >> 2] = $3;
     HEAP8[($2 + 233 | 0) >> 0] = $1;
     HEAP8[($2 + 234 | 0) >> 0] = $1 >>> 8 | 0;
     HEAP8[($2 + 235 | 0) >> 0] = $1 >>> 16 | 0;
     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($2 + 88 | 0 | 0, $2 + 232 | 0 | 0, 1052192 | 0, 16 | 0);
     $3 = HEAPU8[($2 + 88 | 0) >> 0] | 0;
     if (($3 | 0) != (19 | 0)) {
      break label$2
     }
    }
    i64toi32_i32$3 = $2;
    i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $242 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $242;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$2;
    HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
    $1 = 0;
    break label$1;
   }
   $1 = 1;
   memcpy($2 + 25 | 0 | 0, $2 + 88 | 0 | 1 | 0 | 0, 63 | 0) | 0;
   HEAP8[($0 + 8 | 0) >> 0] = $3;
   memcpy($0 + 9 | 0 | 0, $2 + 25 | 0 | 0, 63 | 0) | 0;
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h1737752c75bae0f3($2 + 8 | 0 | 0);
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 304 | 0;
 }
 
 function linked_hash_map__LinkedHashMap_K_2cV_2cS___insert__heab3194aa02f42f0($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $6 = 0, $4 = 0, i64toi32_i32$2 = 0, $8 = 0, $7 = 0, $31 = 0, $9 = 0, $9$hi = 0, $10 = 0, $10$hi = 0, $11 = 0, $11$hi = 0, $5 = 0, $122 = 0, $129 = 0, $12 = 0, $12$hi = 0, $136 = 0, $141 = 0, $157 = 0, $165 = 0, $181 = 0, $186 = 0, $189 = 0, $193 = 0, $196 = 0;
  $4 = global$0;
  $5 = $4;
  $4 = ($4 - 224 | 0) & -32 | 0;
  global$0 = $4;
  label$1 : {
   if (HEAP32[($1 + 32 | 0) >> 2] | 0) {
    break label$1
   }
   $6 = __rust_alloc(104 | 0, 8 | 0) | 0;
   HEAP32[($1 + 32 | 0) >> 2] = $6;
   HEAP32[($6 + 100 | 0) >> 2] = $6;
   HEAP32[($6 + 96 | 0) >> 2] = $6;
  }
  HEAP32[($4 + 76 | 0) >> 2] = $2;
  i64toi32_i32$0 = hashbrown__map__make_hash__hc29185c590e608df($1 | 0, $4 + 76 | 0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $9 = i64toi32_i32$0;
  $9$hi = i64toi32_i32$1;
  $7 = i64toi32_i32$0;
  $8 = (HEAP32[($1 + 16 | 0) >> 2] | 0) & i64toi32_i32$0 | 0;
  $31 = (HEAP32[($1 + 20 | 0) >> 2] | 0) + $8 | 0;
  $6 = HEAPU8[$31 >> 0] | 0 | ((HEAPU8[($31 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($31 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($31 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  HEAP32[($4 + 104 | 0) >> 2] = 0;
  HEAP32[($4 + 108 | 0) >> 2] = $6;
  HEAP32[($4 + 100 | 0) >> 2] = $8;
  HEAP32[($4 + 96 | 0) >> 2] = $1 + 16 | 0;
  $7 = i64toi32_i32$0 >>> 25 | 0;
  HEAP8[($4 + 116 | 0) >> 0] = $7;
  $6 = $6 ^ Math_imul($7, 16843009) | 0;
  HEAP32[($4 + 112 | 0) >> 2] = (($6 ^ -1 | 0) & ($6 + -16843009 | 0) | 0) & -2139062144 | 0;
  $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($4 + 24 | 0 | 0, $4 + 96 | 0 | 0);
  label$2 : {
   label$3 : {
    if (!(HEAP32[($4 + 24 | 0) >> 2] | 0)) {
     break label$3
    }
    label$4 : {
     $7 = HEAP32[($4 + 76 | 0) >> 2] | 0;
     $6 = (HEAP32[((HEAP32[($4 + 96 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) - ((HEAP32[($4 + 28 | 0) >> 2] | 0) << 3 | 0) | 0;
     if ($cardano_serialization_lib__metadata__TransactionMetadatum_20as_20core__cmp__PartialEq___eq__h3bd33dd828bf70c0($7 | 0, HEAP32[($6 + -8 | 0) >> 2] | 0 | 0) | 0) {
      break label$4
     }
     label$5 : while (1) {
      $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($4 + 16 | 0 | 0, $4 + 96 | 0 | 0);
      if (!(HEAP32[($4 + 16 | 0) >> 2] | 0)) {
       break label$3
      }
      $6 = (HEAP32[((HEAP32[($4 + 96 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) - ((HEAP32[($4 + 20 | 0) >> 2] | 0) << 3 | 0) | 0;
      if (!($cardano_serialization_lib__metadata__TransactionMetadatum_20as_20core__cmp__PartialEq___eq__h3bd33dd828bf70c0($7 | 0, HEAP32[($6 + -8 | 0) >> 2] | 0 | 0) | 0)) {
       continue label$5
      }
      break label$5;
     };
    }
    $7 = $6 + -4 | 0;
    $6 = HEAP32[$7 >> 2] | 0;
    $8 = $6 + 72 | 0;
    i64toi32_i32$2 = $8;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $10 = i64toi32_i32$1;
    $10$hi = i64toi32_i32$0;
    i64toi32_i32$2 = $3 + 24 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $122 = i64toi32_i32$0;
    i64toi32_i32$0 = $8;
    HEAP32[i64toi32_i32$0 >> 2] = $122;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    $8 = $6 + 64 | 0;
    i64toi32_i32$2 = $8;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $11 = i64toi32_i32$1;
    $11$hi = i64toi32_i32$0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
    $129 = i64toi32_i32$0;
    i64toi32_i32$0 = $8;
    HEAP32[i64toi32_i32$0 >> 2] = $129;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    $8 = $6 + 56 | 0;
    i64toi32_i32$2 = $8;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $12 = i64toi32_i32$1;
    $12$hi = i64toi32_i32$0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
    $136 = i64toi32_i32$0;
    i64toi32_i32$0 = $8;
    HEAP32[i64toi32_i32$0 >> 2] = $136;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $6;
    i64toi32_i32$1 = HEAP32[($6 + 48 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($6 + 52 | 0) >> 2] | 0;
    $9 = i64toi32_i32$1;
    $9$hi = i64toi32_i32$0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $141 = i64toi32_i32$0;
    i64toi32_i32$0 = $6;
    HEAP32[(i64toi32_i32$0 + 48 | 0) >> 2] = $141;
    HEAP32[(i64toi32_i32$0 + 52 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $10$hi;
    i64toi32_i32$0 = $4;
    HEAP32[(i64toi32_i32$0 + 56 | 0) >> 2] = $10;
    HEAP32[(i64toi32_i32$0 + 60 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $11$hi;
    HEAP32[(i64toi32_i32$0 + 48 | 0) >> 2] = $11;
    HEAP32[(i64toi32_i32$0 + 52 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $12$hi;
    HEAP32[(i64toi32_i32$0 + 40 | 0) >> 2] = $12;
    HEAP32[(i64toi32_i32$0 + 44 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $9$hi;
    HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] = $9;
    HEAP32[(i64toi32_i32$0 + 36 | 0) >> 2] = i64toi32_i32$1;
    $8 = $6 + 80 | 0;
    i64toi32_i32$2 = $8;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $10 = i64toi32_i32$1;
    $10$hi = i64toi32_i32$0;
    i64toi32_i32$2 = $3 + 32 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $157 = i64toi32_i32$0;
    i64toi32_i32$0 = $8;
    HEAP32[i64toi32_i32$0 >> 2] = $157;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    $6 = $6 + 88 | 0;
    i64toi32_i32$2 = $6;
    i64toi32_i32$1 = HEAP32[$6 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($6 + 4 | 0) >> 2] | 0;
    $11 = i64toi32_i32$1;
    $11$hi = i64toi32_i32$0;
    i64toi32_i32$2 = $3 + 40 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $165 = i64toi32_i32$0;
    i64toi32_i32$0 = $6;
    HEAP32[i64toi32_i32$0 >> 2] = $165;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    $6 = ($4 + 80 | 0) + 8 | 0;
    i64toi32_i32$1 = $11$hi;
    i64toi32_i32$0 = $6;
    HEAP32[i64toi32_i32$0 >> 2] = $11;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $10$hi;
    i64toi32_i32$0 = $4;
    HEAP32[(i64toi32_i32$0 + 80 | 0) >> 2] = $10;
    HEAP32[(i64toi32_i32$0 + 84 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[((i64toi32_i32$0 + 96 | 0) + 24 | 0) >> 2] = HEAP32[(i64toi32_i32$0 + 60 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 52 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$0 + 56 | 0) >> 2] | 0;
    $181 = i64toi32_i32$1;
    i64toi32_i32$1 = $4 + 112 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $181;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $4;
    i64toi32_i32$0 = HEAP32[($4 + 44 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($4 + 48 | 0) >> 2] | 0;
    $186 = i64toi32_i32$0;
    i64toi32_i32$0 = ($4 + 96 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $186;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 36 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($4 + 40 | 0) >> 2] | 0;
    $189 = i64toi32_i32$1;
    i64toi32_i32$1 = $4;
    HEAP32[(i64toi32_i32$1 + 96 | 0) >> 2] = $189;
    HEAP32[(i64toi32_i32$1 + 100 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $6;
    i64toi32_i32$0 = HEAP32[$6 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($6 + 4 | 0) >> 2] | 0;
    $193 = i64toi32_i32$0;
    i64toi32_i32$0 = $4 + 132 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $193;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 80 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($4 + 84 | 0) >> 2] | 0;
    $196 = i64toi32_i32$1;
    i64toi32_i32$1 = $4;
    HEAP32[($4 + 124 | 0) >> 2] = $196;
    HEAP32[($4 + 128 | 0) >> 2] = i64toi32_i32$0;
    $6 = HEAP32[$7 >> 2] | 0;
    memcpy($4 + 32 | 0 | 0, $4 + 96 | 0 | 0, 44 | 0) | 0;
    i64toi32_i32$0 = $9$hi;
    $3 = $9;
    $7 = 0;
    break label$2;
   }
   label$6 : {
    label$7 : {
     label$8 : {
      $6 = HEAP32[($1 + 36 | 0) >> 2] | 0;
      if (!$6) {
       break label$8
      }
      HEAP32[($1 + 36 | 0) >> 2] = HEAP32[($6 + 96 | 0) >> 2] | 0;
      memcpy($4 + 96 | 0 | 0, $2 | 0, 48 | 0) | 0;
      memcpy(($4 + 96 | 0) + 48 | 0 | 0, $3 | 0, 48 | 0) | 0;
      i64toi32_i32$1 = memcpy($6 | 0, $4 + 96 | 0 | 0, 96 | 0) | 0;
      i64toi32_i32$0 = 0;
      HEAP32[(i64toi32_i32$1 + 96 | 0) >> 2] = 0;
      HEAP32[(i64toi32_i32$1 + 100 | 0) >> 2] = i64toi32_i32$0;
      break label$7;
     }
     memcpy($4 + 96 | 0 | 0, $2 | 0, 48 | 0) | 0;
     memcpy(($4 + 96 | 0) + 48 | 0 | 0, $3 | 0, 48 | 0) | 0;
     $6 = __rust_alloc(104 | 0, 8 | 0) | 0;
     if (!$6) {
      break label$6
     }
     i64toi32_i32$1 = memcpy($6 | 0, $4 + 96 | 0 | 0, 96 | 0) | 0;
     i64toi32_i32$0 = 0;
     HEAP32[(i64toi32_i32$1 + 96 | 0) >> 2] = 0;
     HEAP32[(i64toi32_i32$1 + 100 | 0) >> 2] = i64toi32_i32$0;
    }
    $3 = 5;
    $7 = 1;
    break label$2;
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(104 | 0, 8 | 0);
   abort();
  }
  memcpy($4 + 96 | 0 | 0, $4 + 32 | 0 | 0, 44 | 0) | 0;
  label$9 : {
   label$10 : {
    if (($3 | 0) != (5 | 0)) {
     break label$10
    }
    hashbrown__map__HashMap_K_2cV_2cS_2cA___insert__h7cbfd3192332bd8d($4 + 8 | 0 | 0, $1 | 0, $6 | 0, $6 | 0);
    $1 = HEAP32[($1 + 32 | 0) >> 2] | 0;
    $8 = HEAP32[($1 + 96 | 0) >> 2] | 0;
    HEAP32[($6 + 100 | 0) >> 2] = $1;
    HEAP32[($6 + 96 | 0) >> 2] = $8;
    $1 = $1 + 96 | 0;
    break label$9;
   }
   HEAP32[((HEAP32[($6 + 100 | 0) >> 2] | 0) + 96 | 0) >> 2] = HEAP32[($6 + 96 | 0) >> 2] | 0;
   HEAP32[((HEAP32[($6 + 96 | 0) >> 2] | 0) + 100 | 0) >> 2] = HEAP32[($6 + 100 | 0) >> 2] | 0;
   $1 = HEAP32[($1 + 32 | 0) >> 2] | 0;
   $8 = HEAP32[($1 + 96 | 0) >> 2] | 0;
   HEAP32[($6 + 100 | 0) >> 2] = $1;
   HEAP32[($6 + 96 | 0) >> 2] = $8;
   $1 = $1 + 96 | 0;
  }
  HEAP32[$1 >> 2] = $6;
  HEAP32[$0 >> 2] = $3;
  HEAP32[((HEAP32[($6 + 96 | 0) >> 2] | 0) + 100 | 0) >> 2] = $6;
  memcpy($0 + 4 | 0 | 0, $4 + 96 | 0 | 0, 44 | 0) | 0;
  label$11 : {
   if ($7) {
    break label$11
   }
   core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatumEnum___h27fd15c9b26a768e($2 | 0);
  }
  global$0 = $5;
 }
 
 function cardano_serialization_lib__crypto__PrivateKey__from_bech32__h8decae3edee07559($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $52 = 0, $53 = 0, $54 = 0, $56 = 0, $57 = 0, $58 = 0, $59 = 0, $61 = 0, $6 = 0, $7 = 0, $8 = 0, $4 = 0, $5 = 0, $62 = 0, $64 = 0, $65 = 0, $67 = 0, $68 = 0, $69 = 0, $31 = 0, $38 = 0, $45 = 0, $50 = 0, $55 = 0, $60 = 0, $63 = 0, $66 = 0, $6$hi = 0, $7$hi = 0, $8$hi = 0, $107 = 0, $113 = 0, $119 = 0, $122 = 0, $127 = 0, $132 = 0, $135 = 0, $145 = 0, $152 = 0, $159 = 0, $165 = 0, $171 = 0, $177 = 0, $180 = 0, $183 = 0, $190 = 0, $197 = 0, $200 = 0, $207 = 0, $211 = 0, $217 = 0, $223 = 0, $229 = 0, $235 = 0, $241 = 0, $247 = 0, $253 = 0, $258 = 0, $261 = 0;
  $3 = global$0 - 208 | 0;
  global$0 = $3;
  $cardano_serialization_lib__chain_crypto__key__SecretKey_A__20as_20cardano_serialization_lib__chain_crypto__bech32__Bech32___try_from_bech32_str__h16428d5ee4f524c4($3 + 136 | 0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ((HEAPU8[($3 + 136 | 0) >> 0] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      memcpy($3 + 72 | 0 | 0, $3 + 136 | 0 | 1 | 0 | 0, 64 | 0) | 0;
      i64toi32_i32$2 = ($3 + 72 | 0) + 8 | 0;
      i64toi32_i32$0 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
      i64toi32_i32$1 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
      $31 = i64toi32_i32$0;
      i64toi32_i32$0 = ($3 + 40 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $31;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = ($3 + 72 | 0) + 16 | 0;
      i64toi32_i32$1 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
      i64toi32_i32$0 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
      $38 = i64toi32_i32$1;
      i64toi32_i32$1 = ($3 + 40 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $38;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = ($3 + 72 | 0) + 24 | 0;
      i64toi32_i32$0 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
      i64toi32_i32$1 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
      $45 = i64toi32_i32$0;
      i64toi32_i32$0 = ($3 + 40 | 0) + 24 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $45;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $3 + 112 | 0;
      i64toi32_i32$1 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
      i64toi32_i32$0 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
      $50 = i64toi32_i32$1;
      i64toi32_i32$1 = $3 + 8 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $50;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $3 + 120 | 0;
      i64toi32_i32$0 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
      i64toi32_i32$1 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
      $55 = i64toi32_i32$0;
      i64toi32_i32$0 = $3 + 16 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $55;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $3 + 128 | 0;
      i64toi32_i32$1 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
      i64toi32_i32$0 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
      $60 = i64toi32_i32$1;
      i64toi32_i32$1 = $3 + 24 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $60;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $3;
      i64toi32_i32$0 = HEAPU16[(i64toi32_i32$2 + 72 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 74 | 0) >> 1] | 0) << 16 | 0) | 0;
      i64toi32_i32$1 = HEAPU16[(i64toi32_i32$2 + 76 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 78 | 0) >> 1] | 0) << 16 | 0) | 0;
      $63 = i64toi32_i32$0;
      i64toi32_i32$0 = i64toi32_i32$2;
      HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] = $63;
      HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$1 = HEAPU16[(i64toi32_i32$2 + 104 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 106 | 0) >> 1] | 0) << 16 | 0) | 0;
      i64toi32_i32$0 = HEAPU16[(i64toi32_i32$2 + 108 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 110 | 0) >> 1] | 0) << 16 | 0) | 0;
      $66 = i64toi32_i32$1;
      i64toi32_i32$1 = i64toi32_i32$2;
      HEAP32[i64toi32_i32$2 >> 2] = $66;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
      $2 = 0;
      break label$3;
     }
     $4 = $3 + 156 | 0;
     i64toi32_i32$2 = $4;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $6 = i64toi32_i32$0;
     $6$hi = i64toi32_i32$1;
     i64toi32_i32$0 = ($3 + 72 | 0) + 18 | 0;
     HEAP16[i64toi32_i32$0 >> 1] = $6;
     HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $6 >>> 16 | 0;
     HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$1;
     HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
     $5 = $3 + 148 | 0;
     i64toi32_i32$2 = $5;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $7 = i64toi32_i32$1;
     $7$hi = i64toi32_i32$0;
     i64toi32_i32$1 = ($3 + 72 | 0) + 10 | 0;
     HEAP16[i64toi32_i32$1 >> 1] = $7;
     HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $7 >>> 16 | 0;
     HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = i64toi32_i32$0;
     HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
     i64toi32_i32$2 = $3;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 140 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 144 | 0) >> 2] | 0;
     $8 = i64toi32_i32$0;
     $8$hi = i64toi32_i32$1;
     i64toi32_i32$0 = i64toi32_i32$2;
     HEAP16[(i64toi32_i32$2 + 74 | 0) >> 1] = $8;
     HEAP16[(i64toi32_i32$2 + 76 | 0) >> 1] = $8 >>> 16 | 0;
     HEAP16[(i64toi32_i32$2 + 78 | 0) >> 1] = i64toi32_i32$1;
     HEAP16[(i64toi32_i32$2 + 80 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$0 = i64toi32_i32$2 + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $6;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$0 = i64toi32_i32$2 + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $7;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $8$hi;
     i64toi32_i32$0 = i64toi32_i32$2;
     HEAP32[i64toi32_i32$2 >> 2] = $8;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     $cardano_serialization_lib__chain_crypto__key__SecretKey_A__20as_20cardano_serialization_lib__chain_crypto__bech32__Bech32___try_from_bech32_str__hdcee3af11441aa7a(i64toi32_i32$2 + 136 | 0 | 0, $1 | 0, $2 | 0);
     label$5 : {
      label$6 : {
       $1 = HEAPU8[(i64toi32_i32$2 + 136 | 0) >> 0] | 0;
       if (($1 | 0) == (1 | 0)) {
        break label$6
       }
       i64toi32_i32$2 = $3 + 161 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $107 = i64toi32_i32$1;
       i64toi32_i32$1 = $3 + 64 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $107;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = $3 + 153 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $113 = i64toi32_i32$0;
       i64toi32_i32$0 = ($3 + 40 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $113;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $3 + 145 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $119 = i64toi32_i32$1;
       i64toi32_i32$1 = ($3 + 40 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $119;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = $3;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 137 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 138 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 139 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 140 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 141 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 142 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 143 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 144 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $122 = i64toi32_i32$0;
       i64toi32_i32$0 = i64toi32_i32$2;
       HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] = $122;
       HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] = i64toi32_i32$1;
       break label$5;
      }
      i64toi32_i32$2 = $4;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $127 = i64toi32_i32$1;
      i64toi32_i32$1 = ($3 + 40 | 0) + 18 | 0;
      $62 = $127;
      HEAP16[i64toi32_i32$1 >> 1] = $62;
      HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $62 >>> 16 | 0;
      HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = i64toi32_i32$0;
      HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
      i64toi32_i32$2 = $5;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $132 = i64toi32_i32$0;
      i64toi32_i32$0 = ($3 + 40 | 0) + 10 | 0;
      $64 = $132;
      HEAP16[i64toi32_i32$0 >> 1] = $64;
      HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $64 >>> 16 | 0;
      HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$1;
      HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
      i64toi32_i32$2 = $3;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 140 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 144 | 0) >> 2] | 0;
      $135 = i64toi32_i32$1;
      i64toi32_i32$1 = i64toi32_i32$2;
      $65 = $135;
      HEAP16[(i64toi32_i32$2 + 42 | 0) >> 1] = $65;
      HEAP16[(i64toi32_i32$2 + 44 | 0) >> 1] = $65 >>> 16 | 0;
      HEAP16[(i64toi32_i32$2 + 46 | 0) >> 1] = i64toi32_i32$0;
      HEAP16[(i64toi32_i32$2 + 48 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
     }
     $2 = 1;
     core__ptr__drop_in_place_cardano_serialization_lib__chain_crypto__bech32__Error___hc63804c7ffa39d5a($3 | 0);
     if (($1 | 0) == (1 | 0)) {
      break label$2
     }
    }
    i64toi32_i32$2 = ($3 + 40 | 0) + 24 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $145 = i64toi32_i32$0;
    i64toi32_i32$0 = ($3 + 136 | 0) + 24 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $145;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = ($3 + 40 | 0) + 16 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $152 = i64toi32_i32$1;
    i64toi32_i32$1 = ($3 + 136 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $152;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = ($3 + 40 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $159 = i64toi32_i32$0;
    i64toi32_i32$0 = ($3 + 136 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $159;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $3 + 8 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $165 = i64toi32_i32$1;
    i64toi32_i32$1 = ($3 + 72 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $165;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $3 + 16 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $171 = i64toi32_i32$0;
    i64toi32_i32$0 = ($3 + 72 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $171;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $3 + 24 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $177 = i64toi32_i32$1;
    i64toi32_i32$1 = ($3 + 72 | 0) + 24 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $177;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] | 0;
    $180 = i64toi32_i32$0;
    i64toi32_i32$0 = i64toi32_i32$2;
    HEAP32[(i64toi32_i32$2 + 136 | 0) >> 2] = $180;
    HEAP32[(i64toi32_i32$2 + 140 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $183 = i64toi32_i32$1;
    i64toi32_i32$1 = i64toi32_i32$2;
    HEAP32[(i64toi32_i32$2 + 72 | 0) >> 2] = $183;
    HEAP32[(i64toi32_i32$2 + 76 | 0) >> 2] = i64toi32_i32$0;
    $1 = 0;
    break label$1;
   }
   i64toi32_i32$2 = ($3 + 40 | 0) + 18 | 0;
   i64toi32_i32$0 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
   i64toi32_i32$1 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
   $190 = i64toi32_i32$0;
   i64toi32_i32$0 = ($3 + 136 | 0) + 18 | 0;
   $67 = $190;
   HEAP16[i64toi32_i32$0 >> 1] = $67;
   HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $67 >>> 16 | 0;
   HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$1;
   HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
   i64toi32_i32$2 = ($3 + 40 | 0) + 10 | 0;
   i64toi32_i32$1 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
   i64toi32_i32$0 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
   $197 = i64toi32_i32$1;
   i64toi32_i32$1 = ($3 + 136 | 0) + 10 | 0;
   $68 = $197;
   HEAP16[i64toi32_i32$1 >> 1] = $68;
   HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $68 >>> 16 | 0;
   HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = i64toi32_i32$0;
   HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
   i64toi32_i32$2 = $3;
   i64toi32_i32$0 = HEAPU16[(i64toi32_i32$2 + 42 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 44 | 0) >> 1] | 0) << 16 | 0) | 0;
   i64toi32_i32$1 = HEAPU16[(i64toi32_i32$2 + 46 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 48 | 0) >> 1] | 0) << 16 | 0) | 0;
   $200 = i64toi32_i32$0;
   i64toi32_i32$0 = i64toi32_i32$2;
   $69 = $200;
   HEAP16[(i64toi32_i32$2 + 138 | 0) >> 1] = $69;
   HEAP16[(i64toi32_i32$2 + 140 | 0) >> 1] = $69 >>> 16 | 0;
   HEAP16[(i64toi32_i32$2 + 142 | 0) >> 1] = i64toi32_i32$1;
   HEAP16[(i64toi32_i32$2 + 144 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
   $1 = 1;
   $2 = 1;
  }
  label$7 : {
   label$8 : {
    if ($1) {
     break label$8
    }
    HEAP8[($0 + 1 | 0) >> 0] = $2;
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 136 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 140 | 0) >> 2] | 0;
    $207 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 2 | 0;
    $52 = $207;
    HEAP8[i64toi32_i32$1 >> 0] = $52;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $52 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $52 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $52 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 72 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 76 | 0) >> 2] | 0;
    $211 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 34 | 0;
    $53 = $211;
    HEAP8[i64toi32_i32$0 >> 0] = $53;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $53 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $53 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $53 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$2 = (i64toi32_i32$2 + 136 | 0) + 8 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $217 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 10 | 0;
    $54 = $217;
    HEAP8[i64toi32_i32$1 >> 0] = $54;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $54 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $54 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $54 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$2 = ($3 + 136 | 0) + 16 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $223 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 18 | 0;
    $56 = $223;
    HEAP8[i64toi32_i32$0 >> 0] = $56;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $56 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $56 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $56 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$2 = ($3 + 136 | 0) + 24 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $229 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 26 | 0;
    $57 = $229;
    HEAP8[i64toi32_i32$1 >> 0] = $57;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $57 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $57 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $57 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$2 = ($3 + 72 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $235 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 42 | 0;
    $58 = $235;
    HEAP8[i64toi32_i32$0 >> 0] = $58;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $58 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $58 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $58 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$2 = ($3 + 72 | 0) + 16 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $241 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 50 | 0;
    $59 = $241;
    HEAP8[i64toi32_i32$1 >> 0] = $59;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $59 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $59 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $59 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$2 = ($3 + 72 | 0) + 24 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $247 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 58 | 0;
    $61 = $247;
    HEAP8[i64toi32_i32$0 >> 0] = $61;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $61 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $61 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $61 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    $1 = 0;
    break label$7;
   }
   i64toi32_i32$2 = ($3 + 136 | 0) + 18 | 0;
   i64toi32_i32$1 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
   i64toi32_i32$0 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
   $253 = i64toi32_i32$1;
   i64toi32_i32$1 = $3 + 16 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $253;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $3 + 146 | 0;
   i64toi32_i32$0 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
   i64toi32_i32$1 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
   $258 = i64toi32_i32$0;
   i64toi32_i32$0 = $3 + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $258;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAPU16[(i64toi32_i32$2 + 138 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 140 | 0) >> 1] | 0) << 16 | 0) | 0;
   i64toi32_i32$0 = HEAPU16[(i64toi32_i32$2 + 142 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 144 | 0) >> 1] | 0) << 16 | 0) | 0;
   $261 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[i64toi32_i32$2 >> 2] = $261;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
   $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1066512 | 0, 18 | 0) | 0;
   core__ptr__drop_in_place_cardano_serialization_lib__chain_crypto__bech32__Error___hc63804c7ffa39d5a(i64toi32_i32$2 | 0);
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   $1 = 1;
  }
  HEAP8[$0 >> 0] = $1;
  global$0 = $3 + 208 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__RelayEnum___deserialize_as_embedded_group__he19ef5d468816ea3($0, $1, $2, $2$hi, $3, $3$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  var $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $6 = 0, $6$hi = 0, $7 = 0, $5 = 0, $8 = 0, $7$hi = 0, $24 = 0, $25 = 0, $26 = 0, $27 = 0, $28 = 0, $149 = 0, $155 = 0, $178 = 0, $183 = 0, $233 = 0, $238 = 0, $243 = 0, $248 = 0;
  $4 = global$0 - 224 | 0;
  global$0 = $4;
  i64toi32_i32$1 = $4;
  i64toi32_i32$0 = 0;
  HEAP32[($4 + 152 | 0) >> 2] = 2;
  HEAP32[($4 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$1 = $4;
  i64toi32_i32$0 = 0;
  HEAP32[($4 + 160 | 0) >> 2] = 0;
  HEAP32[($4 + 164 | 0) >> 2] = i64toi32_i32$0;
  $std__io__cursor__Cursor_T__20as_20std__io__Seek___seek__h4fe82da83d4d5304($4 + 8 | 0 | 0, $1 | 0, $4 + 152 | 0 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ((HEAP32[($4 + 8 | 0) >> 2] | 0 | 0) == (1 | 0)) {
        break label$5
       }
       $5 = ($4 + 8 | 0) + 8 | 0;
       i64toi32_i32$2 = $5;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $6 = i64toi32_i32$0;
       $6$hi = i64toi32_i32$1;
       i64toi32_i32$0 = i64toi32_i32$1;
       cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__SingleHostAddr___deserialize_as_embedded_group__ha772ae07f05d383e($4 + 152 | 0 | 0, $1 | 0, $6 | 0, i64toi32_i32$1 | 0, $6 | 0, i64toi32_i32$1 | 0);
       label$6 : {
        if ((HEAPU16[($4 + 152 | 0) >> 1] | 0 | 0) != (1 | 0)) {
         break label$6
        }
        $5 = memcpy($5 | 0, memcpy($4 + 80 | 0 | 6 | 0 | 0, ($4 + 152 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
        HEAP16[($4 + 8 | 0) >> 1] = 1;
        i64toi32_i32$1 = $4;
        i64toi32_i32$0 = 0;
        HEAP32[($4 + 152 | 0) >> 2] = 0;
        HEAP32[($4 + 156 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$0 = $6$hi;
        i64toi32_i32$1 = $4;
        HEAP32[($4 + 160 | 0) >> 2] = $6;
        HEAP32[($4 + 164 | 0) >> 2] = i64toi32_i32$0;
        $std__io__cursor__Cursor_T__20as_20std__io__Seek___seek__h4fe82da83d4d5304($4 + 80 | 0 | 0, $1 | 0, $4 + 152 | 0 | 0);
        if ((HEAP32[($4 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
         break label$4
        }
        core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9($5 | 0);
        i64toi32_i32$0 = $6$hi;
        i64toi32_i32$1 = i64toi32_i32$0;
        cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__SingleHostName___deserialize_as_embedded_group__h8d6b3aa19718808b($4 + 152 | 0 | 0, $1 | 0, $6 | 0, i64toi32_i32$1 | 0, $6 | 0, i64toi32_i32$1 | 0);
        label$7 : {
         if ((HEAP32[($4 + 152 | 0) >> 2] | 0 | 0) != (1 | 0)) {
          break label$7
         }
         $5 = memcpy($4 + 80 | 0 | 4 | 0 | 0, ($4 + 152 | 0) + 8 | 0 | 0, 64 | 0) | 0;
         memcpy(($4 + 8 | 0) + 8 | 0 | 0, $5 | 0, 64 | 0) | 0;
         HEAP32[($4 + 8 | 0) >> 2] = 1;
         i64toi32_i32$0 = $4;
         i64toi32_i32$1 = 0;
         HEAP32[($4 + 152 | 0) >> 2] = 0;
         HEAP32[($4 + 156 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$1 = $6$hi;
         i64toi32_i32$0 = $4;
         HEAP32[($4 + 160 | 0) >> 2] = $6;
         HEAP32[($4 + 164 | 0) >> 2] = i64toi32_i32$1;
         $std__io__cursor__Cursor_T__20as_20std__io__Seek___seek__h4fe82da83d4d5304($4 + 80 | 0 | 0, $1 | 0, $4 + 152 | 0 | 0);
         if ((HEAP32[($4 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
          break label$3
         }
         core__ptr__drop_in_place_core__result__Result_cardano_serialization_lib__SingleHostName_2ccardano_serialization_lib__error__DeserializeError____hacb89d209b69983b($4 + 8 | 0 | 0);
         i64toi32_i32$1 = $6$hi;
         i64toi32_i32$0 = i64toi32_i32$1;
         cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__MultiHostName___deserialize_as_embedded_group__h940a0d3c5a471c2f($4 + 152 | 0 | 0, $1 | 0, $6 | 0, i64toi32_i32$1 | 0, $6 | 0, i64toi32_i32$1 | 0);
         label$8 : {
          if ((HEAP32[($4 + 152 | 0) >> 2] | 0 | 0) != (1 | 0)) {
           break label$8
          }
          memcpy(($4 + 8 | 0) + 8 | 0 | 0, memcpy($5 | 0, ($4 + 152 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
          HEAP32[($4 + 8 | 0) >> 2] = 1;
          i64toi32_i32$1 = $4;
          i64toi32_i32$0 = 0;
          HEAP32[($4 + 152 | 0) >> 2] = 0;
          HEAP32[($4 + 156 | 0) >> 2] = i64toi32_i32$0;
          i64toi32_i32$0 = $6$hi;
          i64toi32_i32$1 = $4;
          HEAP32[($4 + 160 | 0) >> 2] = $6;
          HEAP32[($4 + 164 | 0) >> 2] = i64toi32_i32$0;
          $std__io__cursor__Cursor_T__20as_20std__io__Seek___seek__h4fe82da83d4d5304($4 + 80 | 0 | 0, $1 | 0, $4 + 152 | 0 | 0);
          if ((HEAP32[($4 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
           break label$2
          }
          core__ptr__drop_in_place_core__result__Result_cardano_serialization_lib__MultiHostName_2ccardano_serialization_lib__error__DeserializeError____hebb1c6f92c0f8b11($4 + 8 | 0 | 0);
          alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($0 + 56 | 0 | 0, 1051469 | 0, 9 | 0);
          HEAP32[$0 >> 2] = 1;
          HEAP8[($0 + 8 | 0) >> 0] = 11;
          break label$1;
         }
         $1 = HEAP32[(($4 + 152 | 0) + 12 | 0) >> 2] | 0;
         HEAP32[(($4 + 8 | 0) + 12 | 0) >> 2] = $1;
         i64toi32_i32$2 = $4;
         i64toi32_i32$0 = HEAP32[($4 + 156 | 0) >> 2] | 0;
         i64toi32_i32$1 = HEAP32[($4 + 160 | 0) >> 2] | 0;
         $6 = i64toi32_i32$0;
         $6$hi = i64toi32_i32$1;
         i64toi32_i32$0 = $4;
         HEAP32[($4 + 12 | 0) >> 2] = $6;
         HEAP32[($4 + 16 | 0) >> 2] = i64toi32_i32$1;
         $24 = $4 + 162 | 0;
         HEAP16[$24 >> 1] = $1;
         HEAP16[($24 + 2 | 0) >> 1] = $1 >>> 16 | 0;
         HEAP16[($0 + 4 | 0) >> 1] = 2;
         HEAP32[$0 >> 2] = 0;
         i64toi32_i32$0 = $4;
         HEAP16[($4 + 154 | 0) >> 1] = $6;
         HEAP16[($4 + 156 | 0) >> 1] = $6 >>> 16 | 0;
         HEAP16[($4 + 158 | 0) >> 1] = i64toi32_i32$1;
         HEAP16[($4 + 160 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
         i64toi32_i32$2 = $4;
         i64toi32_i32$1 = HEAPU16[($4 + 152 | 0) >> 1] | 0 | ((HEAPU16[($4 + 154 | 0) >> 1] | 0) << 16 | 0) | 0;
         i64toi32_i32$0 = HEAPU16[($4 + 156 | 0) >> 1] | 0 | ((HEAPU16[($4 + 158 | 0) >> 1] | 0) << 16 | 0) | 0;
         $149 = i64toi32_i32$1;
         i64toi32_i32$1 = $0 + 6 | 0;
         $25 = $149;
         HEAP16[i64toi32_i32$1 >> 1] = $25;
         HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $25 >>> 16 | 0;
         HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = i64toi32_i32$0;
         HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
         i64toi32_i32$2 = ($4 + 152 | 0) + 6 | 0;
         i64toi32_i32$0 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
         i64toi32_i32$1 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
         $155 = i64toi32_i32$0;
         i64toi32_i32$0 = $0 + 12 | 0;
         $26 = $155;
         HEAP16[i64toi32_i32$0 >> 1] = $26;
         HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $26 >>> 16 | 0;
         HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$1;
         HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
         break label$1;
        }
        i64toi32_i32$2 = ($4 + 152 | 0) + 12 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $6 = i64toi32_i32$1;
        $6$hi = i64toi32_i32$0;
        i64toi32_i32$1 = ($4 + 8 | 0) + 12 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $6;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = $4;
        i64toi32_i32$0 = HEAP32[($4 + 156 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($4 + 160 | 0) >> 2] | 0;
        $7 = i64toi32_i32$0;
        $7$hi = i64toi32_i32$1;
        i64toi32_i32$0 = $4;
        HEAP32[($4 + 12 | 0) >> 2] = $7;
        HEAP32[($4 + 16 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$1 = $6$hi;
        i64toi32_i32$0 = $4 + 162 | 0;
        HEAP16[i64toi32_i32$0 >> 1] = $6;
        HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $6 >>> 16 | 0;
        HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$1;
        HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
        HEAP16[($0 + 4 | 0) >> 1] = 1;
        HEAP32[$0 >> 2] = 0;
        i64toi32_i32$1 = $7$hi;
        i64toi32_i32$0 = $4;
        HEAP16[($4 + 154 | 0) >> 1] = $7;
        HEAP16[($4 + 156 | 0) >> 1] = $7 >>> 16 | 0;
        HEAP16[($4 + 158 | 0) >> 1] = i64toi32_i32$1;
        HEAP16[($4 + 160 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
        i64toi32_i32$2 = $4;
        i64toi32_i32$1 = HEAPU16[($4 + 152 | 0) >> 1] | 0 | ((HEAPU16[($4 + 154 | 0) >> 1] | 0) << 16 | 0) | 0;
        i64toi32_i32$0 = HEAPU16[($4 + 156 | 0) >> 1] | 0 | ((HEAPU16[($4 + 158 | 0) >> 1] | 0) << 16 | 0) | 0;
        $178 = i64toi32_i32$1;
        i64toi32_i32$1 = $0 + 6 | 0;
        $27 = $178;
        HEAP16[i64toi32_i32$1 >> 1] = $27;
        HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $27 >>> 16 | 0;
        HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = i64toi32_i32$0;
        HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
        i64toi32_i32$2 = $4 + 160 | 0;
        i64toi32_i32$0 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
        i64toi32_i32$1 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
        $183 = i64toi32_i32$0;
        i64toi32_i32$0 = $0 + 14 | 0;
        $28 = $183;
        HEAP16[i64toi32_i32$0 >> 1] = $28;
        HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $28 >>> 16 | 0;
        HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$1;
        HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
        HEAP16[($0 + 22 | 0) >> 1] = HEAPU16[($4 + 168 | 0) >> 1] | 0;
        break label$1;
       }
       i64toi32_i32$2 = ($4 + 152 | 0) + 10 | 0;
       i64toi32_i32$1 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
       i64toi32_i32$0 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
       $6 = i64toi32_i32$1;
       $6$hi = i64toi32_i32$0;
       i64toi32_i32$1 = ($4 + 8 | 0) + 10 | 0;
       HEAP16[i64toi32_i32$1 >> 1] = $6;
       HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $6 >>> 16 | 0;
       HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = i64toi32_i32$0;
       HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
       i64toi32_i32$2 = ($4 + 152 | 0) + 18 | 0;
       i64toi32_i32$0 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
       i64toi32_i32$1 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
       $7 = i64toi32_i32$0;
       $7$hi = i64toi32_i32$1;
       i64toi32_i32$0 = ($4 + 8 | 0) + 18 | 0;
       HEAP16[i64toi32_i32$0 >> 1] = $7;
       HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $7 >>> 16 | 0;
       HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$1;
       HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
       $1 = HEAPU16[(($4 + 152 | 0) + 26 | 0) >> 1] | 0;
       HEAP16[(($4 + 8 | 0) + 26 | 0) >> 1] = $1;
       i64toi32_i32$2 = $4;
       i64toi32_i32$1 = HEAPU16[($4 + 154 | 0) >> 1] | 0 | ((HEAPU16[($4 + 156 | 0) >> 1] | 0) << 16 | 0) | 0;
       i64toi32_i32$0 = HEAPU16[($4 + 158 | 0) >> 1] | 0 | ((HEAPU16[($4 + 160 | 0) >> 1] | 0) << 16 | 0) | 0;
       $8 = i64toi32_i32$1;
       i64toi32_i32$1 = $4;
       HEAP16[($4 + 10 | 0) >> 1] = $8;
       HEAP16[($4 + 12 | 0) >> 1] = $8 >>> 16 | 0;
       HEAP16[($4 + 14 | 0) >> 1] = i64toi32_i32$0;
       HEAP16[($4 + 16 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
       i64toi32_i32$1 = $0 + 6 | 0;
       HEAP16[i64toi32_i32$1 >> 1] = $8;
       HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $8 >>> 16 | 0;
       HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = i64toi32_i32$0;
       HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
       i64toi32_i32$0 = $6$hi;
       i64toi32_i32$1 = $0 + 14 | 0;
       HEAP16[i64toi32_i32$1 >> 1] = $6;
       HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $6 >>> 16 | 0;
       HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = i64toi32_i32$0;
       HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
       i64toi32_i32$0 = $7$hi;
       i64toi32_i32$1 = $0 + 22 | 0;
       HEAP16[i64toi32_i32$1 >> 1] = $7;
       HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $7 >>> 16 | 0;
       HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = i64toi32_i32$0;
       HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
       HEAP16[($0 + 30 | 0) >> 1] = $1;
       HEAP16[($0 + 4 | 0) >> 1] = 0;
       HEAP32[$0 >> 2] = 0;
       break label$1;
      }
      i64toi32_i32$2 = $4;
      i64toi32_i32$0 = HEAP32[($4 + 12 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($4 + 16 | 0) >> 2] | 0;
      $233 = i64toi32_i32$0;
      i64toi32_i32$0 = $4;
      HEAP32[($4 + 152 | 0) >> 2] = $233;
      HEAP32[($4 + 156 | 0) >> 2] = i64toi32_i32$1;
      core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $4 + 152 | 0 | 0, 1050188 | 0, 1051480 | 0);
      abort();
     }
     i64toi32_i32$2 = $4;
     i64toi32_i32$1 = HEAP32[($4 + 84 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($4 + 88 | 0) >> 2] | 0;
     $238 = i64toi32_i32$1;
     i64toi32_i32$1 = $4;
     HEAP32[($4 + 152 | 0) >> 2] = $238;
     HEAP32[($4 + 156 | 0) >> 2] = i64toi32_i32$0;
     core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $4 + 152 | 0 | 0, 1050188 | 0, 1051496 | 0);
     abort();
    }
    i64toi32_i32$2 = $4;
    i64toi32_i32$0 = HEAP32[($4 + 84 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($4 + 88 | 0) >> 2] | 0;
    $243 = i64toi32_i32$0;
    i64toi32_i32$0 = $4;
    HEAP32[($4 + 152 | 0) >> 2] = $243;
    HEAP32[($4 + 156 | 0) >> 2] = i64toi32_i32$1;
    core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $4 + 152 | 0 | 0, 1050188 | 0, 1051512 | 0);
    abort();
   }
   i64toi32_i32$2 = $4;
   i64toi32_i32$1 = HEAP32[($4 + 84 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($4 + 88 | 0) >> 2] | 0;
   $248 = i64toi32_i32$1;
   i64toi32_i32$1 = $4;
   HEAP32[($4 + 152 | 0) >> 2] = $248;
   HEAP32[($4 + 156 | 0) >> 2] = i64toi32_i32$0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $4 + 152 | 0 | 0, 1050188 | 0, 1051528 | 0);
   abort();
  }
  global$0 = $4 + 224 | 0;
 }
 
 function cryptoxide__curve25519__fe__fe64__Fe__square__h72fd8a55cd006328($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$4 = 0, $2 = 0, $6$hi = 0, $3$hi = 0, $7$hi = 0, $6 = 0, $3 = 0, $8$hi = 0, $7 = 0, $8 = 0, $4$hi = 0, $5$hi = 0, $4 = 0, $5 = 0, $10$hi = 0, $10 = 0, $11$hi = 0, $181 = 0, $182 = 0, $183 = 0, $185 = 0, $186 = 0, $187 = 0, $188 = 0, $11 = 0, $189 = 0, $192 = 0, $193 = 0, $194 = 0, $195 = 0, $197 = 0, $198 = 0, $199 = 0, $201 = 0, $202 = 0, $39 = 0, $39$hi = 0, $41 = 0, $42 = 0, $42$hi = 0, $53$hi = 0, $204 = 0, $72 = 0, $73 = 0, $73$hi = 0, $80$hi = 0, $206 = 0, $93 = 0, $98 = 0, $98$hi = 0, $102 = 0, $102$hi = 0, $105 = 0, $105$hi = 0, $110 = 0, $110$hi = 0, $114 = 0, $114$hi = 0, $117 = 0, $117$hi = 0, $121 = 0, $121$hi = 0, $125 = 0, $125$hi = 0, $126$hi = 0, $129 = 0, $130$hi = 0, $131$hi = 0, $135 = 0, $135$hi = 0, $136$hi = 0, $139 = 0, $140$hi = 0, $142$hi = 0, $143 = 0, $143$hi = 0, $144 = 0, $144$hi = 0, $146 = 0, $146$hi = 0, $151 = 0, $151$hi = 0, $155 = 0, $155$hi = 0, $158 = 0, $158$hi = 0, $162 = 0, $162$hi = 0, $166 = 0, $166$hi = 0, $167$hi = 0, $170 = 0, $171$hi = 0, $172$hi = 0, $175 = 0, $175$hi = 0, $176$hi = 0, $179 = 0, $180$hi = 0, $182$hi = 0, $207 = 0, $184 = 0, $184$hi = 0, $9 = 0, $9$hi = 0, $187$hi = 0, $190 = 0, $191 = 0, $196 = 0, $196$hi = 0, $200 = 0, $200$hi = 0, $203 = 0, $203$hi = 0, $205 = 0, $205$hi = 0, $209 = 0, $209$hi = 0, $213 = 0, $213$hi = 0, $214$hi = 0, $217 = 0, $218$hi = 0, $219$hi = 0, $223 = 0, $223$hi = 0, $224$hi = 0, $227 = 0, $228$hi = 0, $230$hi = 0, $231 = 0, $231$hi = 0, $232 = 0, $232$hi = 0, $234$hi = 0, $238 = 0, $243 = 0, $243$hi = 0, $247 = 0, $247$hi = 0, $250 = 0, $250$hi = 0, $252 = 0, $252$hi = 0, $256 = 0, $256$hi = 0, $260 = 0, $260$hi = 0, $261$hi = 0, $264 = 0, $265$hi = 0, $266$hi = 0, $270 = 0, $270$hi = 0, $271$hi = 0, $274 = 0, $275$hi = 0, $277$hi = 0, $278 = 0, $278$hi = 0, $279 = 0, $279$hi = 0, $281$hi = 0, $284 = 0, $285 = 0, $287 = 0, $287$hi = 0, $289 = 0, $289$hi = 0, $293 = 0, $293$hi = 0, $297 = 0, $297$hi = 0, $298$hi = 0, $301 = 0, $302$hi = 0, $303$hi = 0, $307 = 0, $307$hi = 0, $308$hi = 0, $311 = 0, $312$hi = 0, $314$hi = 0, $315 = 0, $315$hi = 0, $316 = 0, $316$hi = 0, $318$hi = 0, $321 = 0, $322 = 0, $325 = 0, $325$hi = 0, $327 = 0, $327$hi = 0;
  $2 = global$0 - 240 | 0;
  global$0 = $2;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $3 = i64toi32_i32$0;
  $3$hi = i64toi32_i32$1;
  i64toi32_i32$0 = 0;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$3 = 0;
  __multi3($2 + 224 | 0 | 0, $3 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$0 | 0, $3 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$3 | 0);
  i64toi32_i32$0 = $1;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 36 | 0) >> 2] | 0;
  $4 = i64toi32_i32$3;
  $4$hi = i64toi32_i32$2;
  i64toi32_i32$3 = 0;
  i64toi32_i32$3 = __wasm_i64_mul($4 | 0, i64toi32_i32$2 | 0, 38 | 0, i64toi32_i32$3 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $5 = i64toi32_i32$3;
  $5$hi = i64toi32_i32$2;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] | 0;
  $6 = i64toi32_i32$2;
  $6$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $5$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$1 = 0;
  __multi3($2 + 64 | 0 | 0, $5 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$2 | 0, $6 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$1 | 0);
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $7 = i64toi32_i32$1;
  $7$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_i64_mul($8 | 0, i64toi32_i32$1 | 0, 38 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $39 = i64toi32_i32$0;
  $39$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$2 = $39$hi;
  i64toi32_i32$3 = 0;
  __multi3($2 + 128 | 0 | 0, $7 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$0 | 0, $39 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$3 | 0);
  $41 = $2 + 208 | 0;
  i64toi32_i32$3 = $6$hi;
  $42 = $6;
  $42$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $3$hi;
  i64toi32_i32$0 = $3;
  i64toi32_i32$2 = 0;
  i64toi32_i32$1 = 1;
  i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   $181 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$4 | 0) | 0;
   $181 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
  }
  $3 = $181;
  $3$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $42$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = $3$hi;
  i64toi32_i32$1 = 0;
  __multi3($41 | 0, $42 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$0 | 0, $3 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$1 | 0);
  i64toi32_i32$1 = $5$hi;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$1 = $5$hi;
  i64toi32_i32$3 = 0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$2 = 0;
  __multi3($2 + 48 | 0 | 0, $5 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$3 | 0, $8 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$2 | 0);
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_i64_mul($7 | 0, i64toi32_i32$2 | 0, 19 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $53$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$2 = $53$hi;
  $204 = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = $7$hi;
  i64toi32_i32$1 = 0;
  __multi3($2 + 80 | 0 | 0, $204 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$0 | 0, $7 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$1 | 0);
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$1 = $3$hi;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$3 = 0;
  i64toi32_i32$0 = $3$hi;
  i64toi32_i32$2 = 0;
  __multi3($2 + 176 | 0 | 0, $8 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$3 | 0, $3 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$2 | 0);
  i64toi32_i32$2 = $6$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$1 = 0;
  __multi3($2 + 192 | 0 | 0, $6 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$0 | 0, $6 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$1 | 0);
  i64toi32_i32$1 = $5$hi;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$1 = $5$hi;
  i64toi32_i32$3 = 0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  __multi3($2 + 32 | 0 | 0, $5 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$3 | 0, $7 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$2 | 0);
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$2 = $3$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = $3$hi;
  i64toi32_i32$1 = 0;
  __multi3($2 + 112 | 0 | 0, $7 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$0 | 0, $3 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$1 | 0);
  $72 = $2 + 160 | 0;
  i64toi32_i32$1 = $8$hi;
  $73 = $8;
  $73$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$0 = $6;
  i64toi32_i32$3 = 0;
  i64toi32_i32$2 = 1;
  i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   $182 = 0;
  } else {
   i64toi32_i32$3 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $182 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
  }
  $6 = $182;
  $6$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $73$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$2 = 0;
  __multi3($72 | 0, $73 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$0 | 0, $6 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$2 | 0);
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_i64_mul($4 | 0, i64toi32_i32$2 | 0, 19 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $80$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$2 = $80$hi;
  $206 = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  i64toi32_i32$0 = $4$hi;
  i64toi32_i32$3 = 0;
  __multi3($2 + 16 | 0 | 0, $206 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$1 | 0, $4 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$3 | 0);
  i64toi32_i32$3 = i64toi32_i32$0;
  i64toi32_i32$3 = $3$hi;
  i64toi32_i32$3 = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$1 = $3$hi;
  i64toi32_i32$2 = 0;
  __multi3($2 | 0, $4 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$0 | 0, $3 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$2 | 0);
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$2 = $6$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$3 = 0;
  __multi3($2 + 96 | 0 | 0, $7 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$1 | 0, $6 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$3 | 0);
  i64toi32_i32$3 = $8$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$1 = i64toi32_i32$3;
  i64toi32_i32$2 = 0;
  __multi3($2 + 144 | 0 | 0, $8 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$0 | 0, $8 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$2 | 0);
  $93 = $0;
  i64toi32_i32$0 = $2;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 80 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 84 | 0) >> 2] | 0;
  $5 = i64toi32_i32$2;
  $5$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 208 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 212 | 0) >> 2] | 0;
  $98 = i64toi32_i32$1;
  $98$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $5$hi;
  i64toi32_i32$0 = $5;
  i64toi32_i32$1 = $98$hi;
  i64toi32_i32$3 = $98;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $7 = i64toi32_i32$4;
  $7$hi = i64toi32_i32$5;
  i64toi32_i32$2 = $2;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] | 0;
  $102 = i64toi32_i32$5;
  $102$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$5 = $102$hi;
  i64toi32_i32$3 = $102;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $8 = i64toi32_i32$1;
  $8$hi = i64toi32_i32$4;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$2 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$2 = i64toi32_i32$4 & i64toi32_i32$2 | 0;
  $105 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
  $105$hi = i64toi32_i32$2;
  i64toi32_i32$4 = $2;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 128 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 132 | 0) >> 2] | 0;
  $3 = i64toi32_i32$2;
  $3$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 224 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 228 | 0) >> 2] | 0;
  $110 = i64toi32_i32$0;
  $110$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $3$hi;
  i64toi32_i32$4 = $3;
  i64toi32_i32$0 = $110$hi;
  i64toi32_i32$3 = $110;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $6 = i64toi32_i32$5;
  $6$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
  $114 = i64toi32_i32$1;
  $114$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $6$hi;
  i64toi32_i32$2 = i64toi32_i32$5;
  i64toi32_i32$1 = $114$hi;
  i64toi32_i32$3 = $114;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$5;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$1 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $183 = i64toi32_i32$5 >>> i64toi32_i32$1 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$5 >>> i64toi32_i32$1 | 0;
   $183 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$1 | 0) | 0;
  }
  $117 = $183;
  $117$hi = i64toi32_i32$2;
  i64toi32_i32$5 = ($2 + 128 | 0) + 8 | 0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
  $121 = i64toi32_i32$2;
  $121$hi = i64toi32_i32$4;
  i64toi32_i32$5 = ($2 + 224 | 0) + 8 | 0;
  i64toi32_i32$4 = HEAP32[i64toi32_i32$5 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
  $125 = i64toi32_i32$4;
  $125$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $121$hi;
  i64toi32_i32$5 = $121;
  i64toi32_i32$4 = $125$hi;
  i64toi32_i32$3 = $125;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $126$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$0 = $3$hi;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$2 = $6;
  i64toi32_i32$5 = $3$hi;
  i64toi32_i32$3 = $3;
  $129 = i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
  i64toi32_i32$2 = 0;
  $130$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $126$hi;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$0 = $130$hi;
  i64toi32_i32$5 = $129;
  i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $131$hi = i64toi32_i32$1;
  i64toi32_i32$2 = ($2 + 64 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $135 = i64toi32_i32$1;
  $135$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $131$hi;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$1 = $135$hi;
  i64toi32_i32$5 = $135;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $136$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $4$hi;
  i64toi32_i32$4 = $6$hi;
  i64toi32_i32$4 = $4$hi;
  i64toi32_i32$3 = $4;
  i64toi32_i32$2 = $6$hi;
  i64toi32_i32$5 = $6;
  $139 = i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$3 >>> 0 < i64toi32_i32$5 >>> 0 | 0) | 0;
  i64toi32_i32$3 = 0;
  $140$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $136$hi;
  i64toi32_i32$5 = i64toi32_i32$0;
  i64toi32_i32$4 = $140$hi;
  i64toi32_i32$2 = $139;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$5 = 0;
  i64toi32_i32$2 = 13;
  i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
   $185 = 0;
  } else {
   i64toi32_i32$5 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $185 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
  }
  $142$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $117$hi;
  i64toi32_i32$0 = $117;
  i64toi32_i32$3 = $142$hi;
  i64toi32_i32$2 = $185;
  i64toi32_i32$3 = i64toi32_i32$5 | i64toi32_i32$3 | 0;
  $143 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  $143$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $105$hi;
  i64toi32_i32$5 = $105;
  i64toi32_i32$0 = $143$hi;
  i64toi32_i32$2 = $143;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
  i64toi32_i32$1 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $144 = i64toi32_i32$4;
  $144$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $4$hi;
  i64toi32_i32$3 = $4;
  i64toi32_i32$5 = 524287;
  i64toi32_i32$2 = -1;
  i64toi32_i32$5 = i64toi32_i32$1 & i64toi32_i32$5 | 0;
  $146 = i64toi32_i32$3 & i64toi32_i32$2 | 0;
  $146$hi = i64toi32_i32$5;
  i64toi32_i32$1 = $2;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 96 | 0) >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 100 | 0) >> 2] | 0;
  $3 = i64toi32_i32$5;
  $3$hi = i64toi32_i32$3;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] | 0;
  $151 = i64toi32_i32$3;
  $151$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $3$hi;
  i64toi32_i32$1 = $3;
  i64toi32_i32$3 = $151$hi;
  i64toi32_i32$2 = $151;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $6 = i64toi32_i32$0;
  $6$hi = i64toi32_i32$4;
  i64toi32_i32$5 = $2;
  i64toi32_i32$4 = HEAP32[i64toi32_i32$5 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
  $155 = i64toi32_i32$4;
  $155$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$5 = i64toi32_i32$0;
  i64toi32_i32$4 = $155$hi;
  i64toi32_i32$2 = $155;
  i64toi32_i32$3 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$3 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $4 = i64toi32_i32$3;
  $4$hi = i64toi32_i32$0;
  i64toi32_i32$1 = i64toi32_i32$3;
  i64toi32_i32$5 = 0;
  i64toi32_i32$2 = 51;
  i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
   i64toi32_i32$5 = 0;
   $186 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$5 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $186 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
  }
  $158 = $186;
  $158$hi = i64toi32_i32$5;
  i64toi32_i32$0 = ($2 + 96 | 0) + 8 | 0;
  i64toi32_i32$5 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $162 = i64toi32_i32$5;
  $162$hi = i64toi32_i32$1;
  i64toi32_i32$0 = ($2 + 144 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $166 = i64toi32_i32$1;
  $166$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $162$hi;
  i64toi32_i32$0 = $162;
  i64toi32_i32$1 = $166$hi;
  i64toi32_i32$2 = $166;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  i64toi32_i32$3 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
  }
  $167$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $6$hi;
  i64toi32_i32$3 = $3$hi;
  i64toi32_i32$3 = $6$hi;
  i64toi32_i32$5 = $6;
  i64toi32_i32$0 = $3$hi;
  i64toi32_i32$2 = $3;
  $170 = i64toi32_i32$3 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0;
  i64toi32_i32$5 = 0;
  $171$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $167$hi;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$3 = $171$hi;
  i64toi32_i32$0 = $170;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $172$hi = i64toi32_i32$4;
  i64toi32_i32$5 = $2 + 8 | 0;
  i64toi32_i32$4 = HEAP32[i64toi32_i32$5 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
  $175 = i64toi32_i32$4;
  $175$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $172$hi;
  i64toi32_i32$5 = i64toi32_i32$1;
  i64toi32_i32$4 = $175$hi;
  i64toi32_i32$0 = $175;
  i64toi32_i32$3 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$3 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $176$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $4$hi;
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$1 = $4$hi;
  i64toi32_i32$2 = $4;
  i64toi32_i32$5 = $6$hi;
  i64toi32_i32$0 = $6;
  $179 = i64toi32_i32$1 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$0 >>> 0 | 0) | 0;
  i64toi32_i32$2 = 0;
  $180$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $176$hi;
  i64toi32_i32$0 = i64toi32_i32$3;
  i64toi32_i32$1 = $180$hi;
  i64toi32_i32$5 = $179;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  i64toi32_i32$3 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
  }
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$0 = 0;
  i64toi32_i32$5 = 13;
  i64toi32_i32$1 = i64toi32_i32$5 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$5 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$1 | 0;
   $187 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$1 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$1 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$1 | 0) | 0;
   $187 = i64toi32_i32$2 << i64toi32_i32$1 | 0;
  }
  $182$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $158$hi;
  i64toi32_i32$3 = $158;
  i64toi32_i32$2 = $182$hi;
  i64toi32_i32$5 = $187;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  $207 = i64toi32_i32$3 | i64toi32_i32$5 | 0;
  i64toi32_i32$3 = 0;
  i64toi32_i32$3 = __wasm_i64_mul($207 | 0, i64toi32_i32$2 | 0, 19 | 0, i64toi32_i32$3 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $184 = i64toi32_i32$3;
  $184$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $146$hi;
  i64toi32_i32$0 = $146;
  i64toi32_i32$3 = $184$hi;
  i64toi32_i32$5 = $184;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$4;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = 0;
  i64toi32_i32$5 = 51;
  i64toi32_i32$3 = i64toi32_i32$5 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$5 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $188 = i64toi32_i32$4 >>> i64toi32_i32$3 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$4 >>> i64toi32_i32$3 | 0;
   $188 = (((1 << i64toi32_i32$3 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$3 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$3 | 0) | 0;
  }
  $187$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $144$hi;
  i64toi32_i32$4 = $144;
  i64toi32_i32$2 = $187$hi;
  i64toi32_i32$5 = $188;
  i64toi32_i32$3 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$3 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $10 = i64toi32_i32$3;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$0 = i64toi32_i32$3;
  i64toi32_i32$4 = 524287;
  i64toi32_i32$5 = -1;
  i64toi32_i32$4 = i64toi32_i32$1 & i64toi32_i32$4 | 0;
  $190 = i64toi32_i32$0 & i64toi32_i32$5 | 0;
  i64toi32_i32$0 = $93;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $190;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$4;
  $191 = $0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 176 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 180 | 0) >> 2] | 0;
  $11 = i64toi32_i32$4;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 192 | 0) >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 196 | 0) >> 2] | 0;
  $196 = i64toi32_i32$0;
  $196$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$1 = $11;
  i64toi32_i32$0 = $196$hi;
  i64toi32_i32$5 = $196;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  i64toi32_i32$3 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
  }
  $6 = i64toi32_i32$2;
  $6$hi = i64toi32_i32$3;
  i64toi32_i32$4 = $2;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$4 + 36 | 0) >> 2] | 0;
  $200 = i64toi32_i32$3;
  $200$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$4 = i64toi32_i32$2;
  i64toi32_i32$3 = $200$hi;
  i64toi32_i32$5 = $200;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $3 = i64toi32_i32$0;
  $3$hi = i64toi32_i32$2;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$4 = 524287;
  i64toi32_i32$5 = -1;
  i64toi32_i32$4 = i64toi32_i32$2 & i64toi32_i32$4 | 0;
  $203 = i64toi32_i32$0 & i64toi32_i32$5 | 0;
  $203$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$2 = $8;
  i64toi32_i32$1 = 0;
  i64toi32_i32$5 = 51;
  i64toi32_i32$3 = i64toi32_i32$5 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$5 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $189 = i64toi32_i32$4 >>> i64toi32_i32$3 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$4 >>> i64toi32_i32$3 | 0;
   $189 = (((1 << i64toi32_i32$3 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$3 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$3 | 0) | 0;
  }
  $205 = $189;
  $205$hi = i64toi32_i32$1;
  i64toi32_i32$4 = ($2 + 80 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$4 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
  $209 = i64toi32_i32$1;
  $209$hi = i64toi32_i32$2;
  i64toi32_i32$4 = ($2 + 208 | 0) + 8 | 0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$4 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
  $213 = i64toi32_i32$2;
  $213$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $209$hi;
  i64toi32_i32$4 = $209;
  i64toi32_i32$2 = $213$hi;
  i64toi32_i32$5 = $213;
  i64toi32_i32$3 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$3 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $214$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$0 = $5$hi;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$1 = $7;
  i64toi32_i32$4 = $5$hi;
  i64toi32_i32$5 = $5;
  $217 = i64toi32_i32$0 >>> 0 < i64toi32_i32$4 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$4 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$5 >>> 0 | 0) | 0;
  i64toi32_i32$1 = 0;
  $218$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $214$hi;
  i64toi32_i32$5 = i64toi32_i32$3;
  i64toi32_i32$0 = $218$hi;
  i64toi32_i32$4 = $217;
  i64toi32_i32$2 = i64toi32_i32$3 + i64toi32_i32$4 | 0;
  i64toi32_i32$3 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$4 >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
  }
  $219$hi = i64toi32_i32$3;
  i64toi32_i32$1 = ($2 + 48 | 0) + 8 | 0;
  i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $223 = i64toi32_i32$3;
  $223$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $219$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$3 = $223$hi;
  i64toi32_i32$4 = $223;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$4 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $224$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$5 = $8;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$4 = $7;
  $227 = i64toi32_i32$2 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$5 >>> 0 < i64toi32_i32$4 >>> 0 | 0) | 0;
  i64toi32_i32$5 = 0;
  $228$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $224$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$2 = $228$hi;
  i64toi32_i32$1 = $227;
  i64toi32_i32$3 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  i64toi32_i32$5 = i64toi32_i32$3;
  i64toi32_i32$4 = 0;
  i64toi32_i32$1 = 13;
  i64toi32_i32$2 = i64toi32_i32$1 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$5 << i64toi32_i32$2 | 0;
   $192 = 0;
  } else {
   i64toi32_i32$4 = ((1 << i64toi32_i32$2 | 0) - 1 | 0) & (i64toi32_i32$5 >>> (32 - i64toi32_i32$2 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$2 | 0) | 0;
   $192 = i64toi32_i32$5 << i64toi32_i32$2 | 0;
  }
  $230$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $205$hi;
  i64toi32_i32$0 = $205;
  i64toi32_i32$5 = $230$hi;
  i64toi32_i32$1 = $192;
  i64toi32_i32$5 = i64toi32_i32$4 | i64toi32_i32$5 | 0;
  $231 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
  $231$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $203$hi;
  i64toi32_i32$4 = $203;
  i64toi32_i32$0 = $231$hi;
  i64toi32_i32$1 = $231;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  i64toi32_i32$3 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
  }
  $232 = i64toi32_i32$2;
  $232$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $10$hi;
  i64toi32_i32$5 = $10;
  i64toi32_i32$4 = 0;
  i64toi32_i32$1 = 51;
  i64toi32_i32$0 = i64toi32_i32$1 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
   i64toi32_i32$4 = 0;
   $193 = i64toi32_i32$3 >>> i64toi32_i32$0 | 0;
  } else {
   i64toi32_i32$4 = i64toi32_i32$3 >>> i64toi32_i32$0 | 0;
   $193 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$0 | 0) | 0;
  }
  $234$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $232$hi;
  i64toi32_i32$3 = $232;
  i64toi32_i32$5 = $234$hi;
  i64toi32_i32$1 = $193;
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$2;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$3 = 524287;
  i64toi32_i32$1 = -1;
  i64toi32_i32$3 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
  i64toi32_i32$4 = $191;
  HEAP32[(i64toi32_i32$4 + 16 | 0) >> 2] = i64toi32_i32$0 & i64toi32_i32$1 | 0;
  HEAP32[(i64toi32_i32$4 + 20 | 0) >> 2] = i64toi32_i32$3;
  $238 = $0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 112 | 0) >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$2 + 116 | 0) >> 2] | 0;
  $10 = i64toi32_i32$3;
  $10$hi = i64toi32_i32$4;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$2 + 160 | 0) >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 164 | 0) >> 2] | 0;
  $243 = i64toi32_i32$4;
  $243$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $10$hi;
  i64toi32_i32$2 = $10;
  i64toi32_i32$4 = $243$hi;
  i64toi32_i32$1 = $243;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $7 = i64toi32_i32$5;
  $7$hi = i64toi32_i32$0;
  i64toi32_i32$3 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 16 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 20 | 0) >> 2] | 0;
  $247 = i64toi32_i32$0;
  $247$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$0 = $247$hi;
  i64toi32_i32$1 = $247;
  i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $8 = i64toi32_i32$4;
  $8$hi = i64toi32_i32$5;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$3 = 524287;
  i64toi32_i32$1 = -1;
  i64toi32_i32$3 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
  $250 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
  $250$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $3$hi;
  i64toi32_i32$5 = $3;
  i64toi32_i32$2 = 0;
  i64toi32_i32$1 = 51;
  i64toi32_i32$0 = i64toi32_i32$1 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $194 = i64toi32_i32$3 >>> i64toi32_i32$0 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$3 >>> i64toi32_i32$0 | 0;
   $194 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$0 | 0) | 0;
  }
  $252 = $194;
  $252$hi = i64toi32_i32$2;
  i64toi32_i32$3 = ($2 + 176 | 0) + 8 | 0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
  $256 = i64toi32_i32$2;
  $256$hi = i64toi32_i32$5;
  i64toi32_i32$3 = ($2 + 192 | 0) + 8 | 0;
  i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
  $260 = i64toi32_i32$5;
  $260$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $256$hi;
  i64toi32_i32$3 = $256;
  i64toi32_i32$5 = $260$hi;
  i64toi32_i32$1 = $260;
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $261$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $6$hi;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$4 = $6$hi;
  i64toi32_i32$2 = $6;
  i64toi32_i32$3 = $11$hi;
  i64toi32_i32$1 = $11;
  $264 = i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$1 >>> 0 | 0) | 0;
  i64toi32_i32$2 = 0;
  $265$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $261$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$4 = $265$hi;
  i64toi32_i32$3 = $264;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $266$hi = i64toi32_i32$0;
  i64toi32_i32$2 = ($2 + 32 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $270 = i64toi32_i32$0;
  $270$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $266$hi;
  i64toi32_i32$2 = i64toi32_i32$5;
  i64toi32_i32$0 = $270$hi;
  i64toi32_i32$3 = $270;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $271$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $3$hi;
  i64toi32_i32$5 = $6$hi;
  i64toi32_i32$5 = $3$hi;
  i64toi32_i32$1 = $3;
  i64toi32_i32$2 = $6$hi;
  i64toi32_i32$3 = $6;
  $274 = i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
  i64toi32_i32$1 = 0;
  $275$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $271$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$5 = $275$hi;
  i64toi32_i32$2 = $274;
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$3 = 0;
  i64toi32_i32$2 = 13;
  i64toi32_i32$5 = i64toi32_i32$2 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$1 << i64toi32_i32$5 | 0;
   $195 = 0;
  } else {
   i64toi32_i32$3 = ((1 << i64toi32_i32$5 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$5 | 0) | 0) | 0 | (i64toi32_i32$4 << i64toi32_i32$5 | 0) | 0;
   $195 = i64toi32_i32$1 << i64toi32_i32$5 | 0;
  }
  $277$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $252$hi;
  i64toi32_i32$4 = $252;
  i64toi32_i32$1 = $277$hi;
  i64toi32_i32$2 = $195;
  i64toi32_i32$1 = i64toi32_i32$3 | i64toi32_i32$1 | 0;
  $278 = i64toi32_i32$4 | i64toi32_i32$2 | 0;
  $278$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $250$hi;
  i64toi32_i32$3 = $250;
  i64toi32_i32$4 = $278$hi;
  i64toi32_i32$2 = $278;
  i64toi32_i32$5 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $279 = i64toi32_i32$5;
  $279$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $5$hi;
  i64toi32_i32$1 = $5;
  i64toi32_i32$3 = 0;
  i64toi32_i32$2 = 51;
  i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
   i64toi32_i32$3 = 0;
   $197 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$3 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $197 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
  }
  $281$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $279$hi;
  i64toi32_i32$0 = $279;
  i64toi32_i32$1 = $281$hi;
  i64toi32_i32$2 = $197;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  i64toi32_i32$5 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $6 = i64toi32_i32$4;
  $6$hi = i64toi32_i32$5;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$0 = 524287;
  i64toi32_i32$2 = -1;
  i64toi32_i32$0 = i64toi32_i32$5 & i64toi32_i32$0 | 0;
  $284 = i64toi32_i32$3 & i64toi32_i32$2 | 0;
  i64toi32_i32$3 = $238;
  HEAP32[(i64toi32_i32$3 + 24 | 0) >> 2] = $284;
  HEAP32[(i64toi32_i32$3 + 28 | 0) >> 2] = i64toi32_i32$0;
  $285 = $0;
  i64toi32_i32$0 = $4$hi;
  i64toi32_i32$5 = $4;
  i64toi32_i32$3 = 524287;
  i64toi32_i32$2 = -1;
  i64toi32_i32$3 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
  $287 = i64toi32_i32$5 & i64toi32_i32$2 | 0;
  $287$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $8$hi;
  i64toi32_i32$0 = $8;
  i64toi32_i32$5 = 0;
  i64toi32_i32$2 = 51;
  i64toi32_i32$1 = i64toi32_i32$2 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
   i64toi32_i32$5 = 0;
   $198 = i64toi32_i32$3 >>> i64toi32_i32$1 | 0;
  } else {
   i64toi32_i32$5 = i64toi32_i32$3 >>> i64toi32_i32$1 | 0;
   $198 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$1 | 0) | 0;
  }
  $289 = $198;
  $289$hi = i64toi32_i32$5;
  i64toi32_i32$3 = ($2 + 112 | 0) + 8 | 0;
  i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
  $293 = i64toi32_i32$5;
  $293$hi = i64toi32_i32$0;
  i64toi32_i32$3 = ($2 + 160 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
  $297 = i64toi32_i32$0;
  $297$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $293$hi;
  i64toi32_i32$3 = $293;
  i64toi32_i32$0 = $297$hi;
  i64toi32_i32$2 = $297;
  i64toi32_i32$1 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $298$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$4 = $10$hi;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = $7;
  i64toi32_i32$3 = $10$hi;
  i64toi32_i32$2 = $10;
  $301 = i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0;
  i64toi32_i32$5 = 0;
  $302$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $298$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$4 = $302$hi;
  i64toi32_i32$3 = $301;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $303$hi = i64toi32_i32$1;
  i64toi32_i32$5 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$5 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] | 0;
  $307 = i64toi32_i32$1;
  $307$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $303$hi;
  i64toi32_i32$5 = i64toi32_i32$0;
  i64toi32_i32$1 = $307$hi;
  i64toi32_i32$3 = $307;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $308$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$2 = $8;
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$3 = $7;
  $311 = i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
  i64toi32_i32$2 = 0;
  $312$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $308$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$0 = $312$hi;
  i64toi32_i32$5 = $311;
  i64toi32_i32$1 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$3 = 0;
  i64toi32_i32$5 = 13;
  i64toi32_i32$0 = i64toi32_i32$5 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$5 & 63 | 0) >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$2 << i64toi32_i32$0 | 0;
   $199 = 0;
  } else {
   i64toi32_i32$3 = ((1 << i64toi32_i32$0 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$0 | 0) | 0) | 0 | (i64toi32_i32$4 << i64toi32_i32$0 | 0) | 0;
   $199 = i64toi32_i32$2 << i64toi32_i32$0 | 0;
  }
  $314$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $289$hi;
  i64toi32_i32$4 = $289;
  i64toi32_i32$2 = $314$hi;
  i64toi32_i32$5 = $199;
  i64toi32_i32$2 = i64toi32_i32$3 | i64toi32_i32$2 | 0;
  $315 = i64toi32_i32$4 | i64toi32_i32$5 | 0;
  $315$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $287$hi;
  i64toi32_i32$3 = $287;
  i64toi32_i32$4 = $315$hi;
  i64toi32_i32$5 = $315;
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $316 = i64toi32_i32$0;
  $316$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$2 = $6;
  i64toi32_i32$3 = 0;
  i64toi32_i32$5 = 51;
  i64toi32_i32$4 = i64toi32_i32$5 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$5 & 63 | 0) >>> 0) {
   i64toi32_i32$3 = 0;
   $201 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$3 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   $201 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  $318$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $316$hi;
  i64toi32_i32$1 = $316;
  i64toi32_i32$2 = $318$hi;
  i64toi32_i32$5 = $201;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $7 = i64toi32_i32$4;
  $7$hi = i64toi32_i32$0;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$1 = 524287;
  i64toi32_i32$5 = -1;
  i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
  $321 = i64toi32_i32$3 & i64toi32_i32$5 | 0;
  i64toi32_i32$3 = $285;
  HEAP32[(i64toi32_i32$3 + 32 | 0) >> 2] = $321;
  HEAP32[(i64toi32_i32$3 + 36 | 0) >> 2] = i64toi32_i32$1;
  $322 = $0;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$0 = i64toi32_i32$4;
  i64toi32_i32$3 = 0;
  i64toi32_i32$5 = 51;
  i64toi32_i32$2 = i64toi32_i32$5 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$5 & 63 | 0) >>> 0) {
   i64toi32_i32$3 = 0;
   $202 = i64toi32_i32$1 >>> i64toi32_i32$2 | 0;
  } else {
   i64toi32_i32$3 = i64toi32_i32$1 >>> i64toi32_i32$2 | 0;
   $202 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$2 | 0) | 0;
  }
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_i64_mul($202 | 0, i64toi32_i32$3 | 0, 19 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$3 = i64toi32_i32$HIGH_BITS;
  $325 = i64toi32_i32$0;
  $325$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $9$hi;
  i64toi32_i32$1 = $9;
  i64toi32_i32$0 = 524287;
  i64toi32_i32$5 = -1;
  i64toi32_i32$0 = i64toi32_i32$3 & i64toi32_i32$0 | 0;
  $327 = i64toi32_i32$1 & i64toi32_i32$5 | 0;
  $327$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $325$hi;
  i64toi32_i32$3 = $325;
  i64toi32_i32$1 = $327$hi;
  i64toi32_i32$5 = $327;
  i64toi32_i32$2 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  i64toi32_i32$3 = $322;
  HEAP32[i64toi32_i32$3 >> 2] = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$4;
  global$0 = $2 + 240 | 0;
 }
 
 function alloc__collections__btree__node__BalancingContext_K_2cV___bulk_steal_left__he4fcf97c22216196($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $7 = 0, $8 = 0, $9 = 0, $18 = 0, $19 = 0, $2 = 0, $12 = 0, $10 = 0, $3 = 0, $6 = 0, $16 = 0, $18$hi = 0, $19$hi = 0, $15 = 0, $4 = 0, $11 = 0, $32 = 0, $20 = 0, $33 = 0, $21 = 0, $17 = 0, $34 = 0, $35 = 0, $5 = 0, $20$hi = 0, $21$hi = 0, $13 = 0, $14 = 0, $116 = 0, $144 = 0, $201 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if (!$1) {
       break label$4
      }
      $3 = HEAP32[($0 + 24 | 0) >> 2] | 0;
      $4 = HEAPU16[($3 + 138 | 0) >> 1] | 0;
      $5 = $4 + $1 | 0;
      if ($5 >>> 0 > 11 >>> 0) {
       break label$3
      }
      label$5 : {
       label$6 : {
        label$7 : {
         $6 = HEAP32[($0 + 16 | 0) >> 2] | 0;
         $7 = HEAPU16[($6 + 138 | 0) >> 1] | 0;
         if ($7 >>> 0 < $1 >>> 0) {
          break label$7
         }
         $8 = $7 - $1 | 0;
         HEAP16[($6 + 138 | 0) >> 1] = $8;
         HEAP16[($3 + 138 | 0) >> 1] = $5;
         $9 = $3 + 140 | 0;
         memmove($9 + Math_imul($1, 28) | 0 | 0, $9 | 0, Math_imul($4, 28) | 0) | 0;
         $10 = $3 + 4 | 0;
         memmove($10 + Math_imul($1, 12) | 0 | 0, $10 | 0, Math_imul($4, 12) | 0) | 0;
         $11 = $8 + 1 | 0;
         $7 = $7 - $11 | 0;
         if (($7 | 0) != ($1 + -1 | 0 | 0)) {
          break label$2
         }
         $12 = $6 + 140 | 0;
         $13 = Math_imul($7, 28);
         memcpy($9 | 0, $12 + Math_imul($11, 28) | 0 | 0, $13 | 0) | 0;
         $9 = $6 + 4 | 0;
         $14 = Math_imul($7, 12);
         memcpy($10 | 0, $9 + Math_imul($11, 12) | 0 | 0, $14 | 0) | 0;
         $10 = ($2 + 8 | 0) + 8 | 0;
         $7 = $9 + Math_imul($8, 12) | 0;
         HEAP32[$10 >> 2] = HEAP32[($7 + 8 | 0) >> 2] | 0;
         i64toi32_i32$2 = $7;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $116 = i64toi32_i32$0;
         i64toi32_i32$0 = $2;
         HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $116;
         HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
         $8 = $12 + Math_imul($8, 28) | 0;
         $32 = $8 + 24 | 0;
         $9 = HEAPU8[$32 >> 0] | 0 | ((HEAPU8[($32 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($32 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($32 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$2 = $8 + 16 | 0;
         i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $18 = i64toi32_i32$1;
         $18$hi = i64toi32_i32$0;
         i64toi32_i32$2 = $8 + 8 | 0;
         i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $19 = i64toi32_i32$0;
         $19$hi = i64toi32_i32$1;
         $12 = HEAP32[($0 + 4 | 0) >> 2] | 0;
         $15 = HEAP32[($0 + 8 | 0) >> 2] | 0;
         $7 = $12 + Math_imul($15, 28) | 0;
         $16 = $7 + 140 | 0;
         i64toi32_i32$2 = $16;
         i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $20 = i64toi32_i32$1;
         $20$hi = i64toi32_i32$0;
         i64toi32_i32$2 = $8;
         i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $144 = i64toi32_i32$0;
         i64toi32_i32$0 = $16;
         $33 = $144;
         HEAP8[i64toi32_i32$0 >> 0] = $33;
         HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $33 >>> 8 | 0;
         HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $33 >>> 16 | 0;
         HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $33 >>> 24 | 0;
         HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
         HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
         HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
         HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
         $8 = $7 + 148 | 0;
         i64toi32_i32$2 = $8;
         i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $21 = i64toi32_i32$1;
         $21$hi = i64toi32_i32$0;
         i64toi32_i32$0 = $19$hi;
         i64toi32_i32$1 = i64toi32_i32$2;
         HEAP8[i64toi32_i32$2 >> 0] = $19;
         HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $19 >>> 8 | 0;
         HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $19 >>> 16 | 0;
         HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $19 >>> 24 | 0;
         HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$0;
         HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
         HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
         HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
         $8 = ($2 + 72 | 0) + 8 | 0;
         i64toi32_i32$0 = $21$hi;
         i64toi32_i32$1 = $8;
         HEAP32[i64toi32_i32$1 >> 2] = $21;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
         $16 = $7 + 156 | 0;
         i64toi32_i32$2 = $16;
         i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $19 = i64toi32_i32$0;
         $19$hi = i64toi32_i32$1;
         i64toi32_i32$1 = $18$hi;
         i64toi32_i32$0 = i64toi32_i32$2;
         HEAP8[i64toi32_i32$2 >> 0] = $18;
         HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $18 >>> 8 | 0;
         HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $18 >>> 16 | 0;
         HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $18 >>> 24 | 0;
         HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$1;
         HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
         HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
         HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
         $16 = ($2 + 72 | 0) + 16 | 0;
         i64toi32_i32$1 = $19$hi;
         i64toi32_i32$0 = $16;
         HEAP32[i64toi32_i32$0 >> 2] = $19;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         $7 = $7 + 164 | 0;
         $17 = HEAPU8[$7 >> 0] | 0 | ((HEAPU8[($7 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($7 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($7 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[$7 >> 0] = $9;
         HEAP8[($7 + 1 | 0) >> 0] = $9 >>> 8 | 0;
         HEAP8[($7 + 2 | 0) >> 0] = $9 >>> 16 | 0;
         HEAP8[($7 + 3 | 0) >> 0] = $9 >>> 24 | 0;
         $7 = ($2 + 72 | 0) + 24 | 0;
         HEAP32[$7 >> 2] = $17;
         i64toi32_i32$1 = $20$hi;
         i64toi32_i32$0 = $2;
         HEAP32[(i64toi32_i32$0 + 72 | 0) >> 2] = $20;
         HEAP32[(i64toi32_i32$0 + 76 | 0) >> 2] = i64toi32_i32$1;
         $9 = (i64toi32_i32$0 + 24 | 0) + 8 | 0;
         $12 = $12 + Math_imul($15, 12) | 0;
         $15 = $12 + 12 | 0;
         $17 = HEAP32[$15 >> 2] | 0;
         HEAP32[$9 >> 2] = $17;
         $12 = $12 + 4 | 0;
         i64toi32_i32$2 = $12;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $18 = i64toi32_i32$1;
         $18$hi = i64toi32_i32$0;
         i64toi32_i32$1 = $2;
         HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = $18;
         HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$2 = i64toi32_i32$1;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
         $201 = i64toi32_i32$0;
         i64toi32_i32$0 = $12;
         HEAP32[i64toi32_i32$0 >> 2] = $201;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         HEAP32[$15 >> 2] = HEAP32[$10 >> 2] | 0;
         $10 = i64toi32_i32$2 + 108 | 0;
         HEAP32[$10 >> 2] = $17;
         i64toi32_i32$1 = $18$hi;
         i64toi32_i32$0 = i64toi32_i32$2;
         HEAP32[(i64toi32_i32$2 + 100 | 0) >> 2] = $18;
         HEAP32[(i64toi32_i32$2 + 104 | 0) >> 2] = i64toi32_i32$1;
         $7 = HEAP32[$7 >> 2] | 0;
         HEAP32[((i64toi32_i32$2 + 24 | 0) + 24 | 0) >> 2] = $7;
         i64toi32_i32$2 = $16;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $18 = i64toi32_i32$1;
         $18$hi = i64toi32_i32$0;
         i64toi32_i32$1 = ($2 + 24 | 0) + 16 | 0;
         HEAP32[i64toi32_i32$1 >> 2] = $18;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$2 = $8;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $19 = i64toi32_i32$0;
         $19$hi = i64toi32_i32$1;
         i64toi32_i32$0 = $9;
         HEAP32[i64toi32_i32$0 >> 2] = $19;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$2 = $2;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 72 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 76 | 0) >> 2] | 0;
         $20 = i64toi32_i32$1;
         $20$hi = i64toi32_i32$0;
         i64toi32_i32$1 = i64toi32_i32$2;
         HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] = $20;
         HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] = i64toi32_i32$0;
         $9 = HEAP32[$10 >> 2] | 0;
         HEAP32[((i64toi32_i32$2 + 56 | 0) + 8 | 0) >> 2] = $9;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 100 | 0) >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 104 | 0) >> 2] | 0;
         $21 = i64toi32_i32$0;
         $21$hi = i64toi32_i32$1;
         i64toi32_i32$0 = i64toi32_i32$2;
         HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] = $21;
         HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] = i64toi32_i32$1;
         $8 = $3 + $13 | 0;
         $34 = $8 + 164 | 0;
         HEAP8[$34 >> 0] = $7;
         HEAP8[($34 + 1 | 0) >> 0] = $7 >>> 8 | 0;
         HEAP8[($34 + 2 | 0) >> 0] = $7 >>> 16 | 0;
         HEAP8[($34 + 3 | 0) >> 0] = $7 >>> 24 | 0;
         i64toi32_i32$1 = $18$hi;
         i64toi32_i32$0 = $8 + 156 | 0;
         HEAP8[i64toi32_i32$0 >> 0] = $18;
         HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $18 >>> 8 | 0;
         HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $18 >>> 16 | 0;
         HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $18 >>> 24 | 0;
         HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
         HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
         HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
         HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
         i64toi32_i32$1 = $19$hi;
         i64toi32_i32$0 = $8 + 148 | 0;
         HEAP8[i64toi32_i32$0 >> 0] = $19;
         HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $19 >>> 8 | 0;
         HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $19 >>> 16 | 0;
         HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $19 >>> 24 | 0;
         HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
         HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
         HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
         HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
         i64toi32_i32$1 = $20$hi;
         i64toi32_i32$0 = $8 + 140 | 0;
         $35 = $20;
         HEAP8[i64toi32_i32$0 >> 0] = $35;
         HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $35 >>> 8 | 0;
         HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $35 >>> 16 | 0;
         HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $35 >>> 24 | 0;
         HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
         HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
         HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
         HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
         $8 = $3 + $14 | 0;
         i64toi32_i32$1 = $21$hi;
         i64toi32_i32$0 = $8 + 4 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $21;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         HEAP32[($8 + 12 | 0) >> 2] = $9;
         $8 = HEAP32[($0 + 12 | 0) >> 2] | 0;
         if (HEAP32[($0 + 20 | 0) >> 2] | 0) {
          break label$6
         }
         if (!$8) {
          break label$5
         }
         break label$1;
        }
        core__panicking__panic__h2fd385a887c8bf13(1049260 | 0, 39 | 0, 1049300 | 0);
        abort();
       }
       if (!$8) {
        break label$1
       }
       $0 = $3 + 448 | 0;
       $1 = $1 << 2 | 0;
       memmove($0 + $1 | 0 | 0, $0 | 0, ($4 << 2 | 0) + 4 | 0 | 0) | 0;
       memcpy($0 | 0, ($6 + ($11 << 2 | 0) | 0) + 448 | 0 | 0, $1 | 0) | 0;
       $8 = $5 + 1 | 0;
       $1 = 0;
       label$8 : while (1) {
        $6 = HEAP32[$0 >> 2] | 0;
        HEAP16[($6 + 136 | 0) >> 1] = $1;
        HEAP32[$6 >> 2] = $3;
        $0 = $0 + 4 | 0;
        $1 = $1 + 1 | 0;
        if (($8 | 0) != ($1 | 0)) {
         continue label$8
        }
        break label$8;
       };
      }
      global$0 = $2 + 112 | 0;
      return;
     }
     core__panicking__panic__h2fd385a887c8bf13(1049148 | 0, 27 | 0, 1049176 | 0);
     abort();
    }
    core__panicking__panic__h2fd385a887c8bf13(1049192 | 0, 51 | 0, 1049244 | 0);
    abort();
   }
   core__panicking__panic__h2fd385a887c8bf13(1048988 | 0, 40 | 0, 1049028 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1049316 | 0, 40 | 0, 1049356 | 0);
  abort();
 }
 
 function cardano_serialization_lib__metadata__decode_metadatum_to_json_str__h637f31ff22f16dc5($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $6 = 0.0, $22 = 0, $30 = 0, $35 = 0, $41 = 0, $5 = 0, $5$hi = 0, $4 = 0, $153 = 0, $160 = 0, $163 = 0, $203 = 0;
  $3 = global$0 - 176 | 0;
  global$0 = $3;
  cardano_serialization_lib__metadata__decode_metadatum_to_json_value__h971c762f0ec03432($3 + 136 | 0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         if ((HEAP32[($3 + 136 | 0) >> 2] | 0 | 0) == (1 | 0)) {
          break label$7
         }
         i64toi32_i32$2 = $3 + 160 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $22 = i64toi32_i32$0;
         i64toi32_i32$0 = ($3 + 56 | 0) + 16 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $22;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         $1 = ($3 + 56 | 0) + 8 | 0;
         i64toi32_i32$2 = ($3 + 136 | 0) + 16 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $30 = i64toi32_i32$1;
         i64toi32_i32$1 = $1;
         HEAP32[i64toi32_i32$1 >> 2] = $30;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$2 = ($3 + 136 | 0) + 8 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $35 = i64toi32_i32$0;
         i64toi32_i32$0 = $3;
         HEAP32[($3 + 56 | 0) >> 2] = $35;
         HEAP32[($3 + 60 | 0) >> 2] = i64toi32_i32$1;
         alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($3 + 48 | 0 | 0, 128 | 0, 0 | 0);
         HEAP32[($3 + 88 | 0) >> 2] = 0;
         i64toi32_i32$2 = $3;
         i64toi32_i32$1 = HEAP32[($3 + 48 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($3 + 52 | 0) >> 2] | 0;
         $41 = i64toi32_i32$1;
         i64toi32_i32$1 = $3;
         HEAP32[($3 + 80 | 0) >> 2] = $41;
         HEAP32[($3 + 84 | 0) >> 2] = i64toi32_i32$0;
         HEAP32[($3 + 92 | 0) >> 2] = $3 + 80 | 0;
         label$8 : {
          switch (HEAPU8[($3 + 56 | 0) >> 0] | 0 | 0) {
          default:
           alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($3 + 80 | 0 | 0, 1058938 | 0, 4 | 0);
           break label$5;
          case 1:
           $1 = HEAPU8[($3 + 57 | 0) >> 0] | 0;
           alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($3 + 80 | 0 | 0, ($1 ? 1058929 : 1058933) | 0, ($1 ? 4 : 5) | 0);
           break label$5;
          case 2:
           label$13 : {
            switch (HEAP32[$1 >> 2] | 0 | 0) {
            default:
             i64toi32_i32$2 = $3 + 72 | 0;
             i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
             i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
             itoa__Buffer__format__h16c7f26094a64122($3 + 8 | 0 | 0, $3 + 136 | 0 | 0, i64toi32_i32$0 | 0, i64toi32_i32$1 | 0);
             alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($3 + 80 | 0 | 0, HEAP32[($3 + 8 | 0) >> 2] | 0 | 0, HEAP32[($3 + 12 | 0) >> 2] | 0 | 0);
             break label$5;
            case 1:
             i64toi32_i32$2 = $3 + 72 | 0;
             i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
             i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
             itoa__Buffer__format__hed7b710a49053b67($3 + 16 | 0 | 0, $3 + 136 | 0 | 0, i64toi32_i32$1 | 0, i64toi32_i32$0 | 0);
             alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($3 + 80 | 0 | 0, HEAP32[($3 + 16 | 0) >> 2] | 0 | 0, HEAP32[($3 + 20 | 0) >> 2] | 0 | 0);
             break label$5;
            case 2:
             break label$13;
            };
           }
           label$16 : {
            $6 = +HEAPF64[($3 + 72 | 0) >> 3];
            if (((core__f64___impl_20f64___classify__h32c2038c9bc8621a(+$6) | 0) & 255 | 0) >>> 0 < 2 >>> 0) {
             break label$16
            }
            alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($3 + 80 | 0 | 0, $3 + 136 | 0 | 0, ryu__pretty__format64__h68d0de20c01ea6e8(+$6, $3 + 136 | 0 | 0) | 0 | 0);
            break label$5;
           }
           alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($3 + 80 | 0 | 0, 1058938 | 0, 4 | 0);
           break label$5;
          case 3:
           $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 32 | 0 | 0, $3 + 56 | 0 | 4 | 0 | 0);
           i64toi32_i32$0 = serde_json__ser__format_escaped_str__h36c322c8ecbdeb72($3 + 92 | 0 | 0, $3 + 92 | 0 | 0, HEAP32[($3 + 32 | 0) >> 2] | 0 | 0, HEAP32[($3 + 36 | 0) >> 2] | 0 | 0) | 0;
           i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
           $5 = i64toi32_i32$0;
           $5$hi = i64toi32_i32$1;
           if ((i64toi32_i32$0 & 255 | 0 | 0) == (4 | 0)) {
            break label$5
           }
           i64toi32_i32$1 = $5$hi;
           $1 = serde_json__error__Error__io__hab4c507df1786c7e($5 | 0, i64toi32_i32$1 | 0) | 0;
           break label$4;
          case 4:
           break label$6;
          case 5:
           break label$8;
          };
         }
         $1 = 1;
         $2 = $3 + 56 | 0 | 4 | 0;
         $4 = alloc__collections__btree__map__BTreeMap_K_2cV___len__h9902d4fb7515c681($2 | 0) | 0;
         alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($3 + 80 | 0 | 0, 1058942 | 0, 1 | 0);
         label$17 : {
          if ($4) {
           break label$17
          }
          alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($3 + 80 | 0 | 0, 1058928 | 0, 1 | 0);
          $1 = 0;
         }
         HEAP8[($3 + 100 | 0) >> 0] = $1;
         HEAP32[($3 + 96 | 0) >> 2] = $3 + 92 | 0;
         alloc__collections__btree__map__BTreeMap_K_2cV___iter__hf725d43035c2a960($3 + 104 | 0 | 0, $2 | 0);
         HEAP32[(($3 + 136 | 0) + 24 | 0) >> 2] = HEAP32[(($3 + 104 | 0) + 24 | 0) >> 2] | 0;
         i64toi32_i32$2 = ($3 + 104 | 0) + 16 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $153 = i64toi32_i32$1;
         i64toi32_i32$1 = ($3 + 136 | 0) + 16 | 0;
         HEAP32[i64toi32_i32$1 >> 2] = $153;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$2 = ($3 + 104 | 0) + 8 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $160 = i64toi32_i32$0;
         i64toi32_i32$0 = ($3 + 136 | 0) + 8 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $160;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$2 = $3;
         i64toi32_i32$1 = HEAP32[($3 + 104 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($3 + 108 | 0) >> 2] | 0;
         $163 = i64toi32_i32$1;
         i64toi32_i32$1 = $3;
         HEAP32[($3 + 136 | 0) >> 2] = $163;
         HEAP32[($3 + 140 | 0) >> 2] = i64toi32_i32$0;
         label$18 : while (1) {
          $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h51e8e53778b7cbd1($3 + 40 | 0 | 0, $3 + 136 | 0 | 0);
          label$19 : {
           $1 = HEAP32[($3 + 40 | 0) >> 2] | 0;
           if ($1) {
            break label$19
           }
           if (!(HEAPU8[($3 + 100 | 0) >> 0] | 0)) {
            break label$5
           }
           alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb(HEAP32[(HEAP32[($3 + 96 | 0) >> 2] | 0) >> 2] | 0 | 0, 1058928 | 0, 1 | 0);
           break label$5;
          }
          $1 = serde__ser__SerializeMap__serialize_entry__h173bbbfadb8f829e($3 + 96 | 0 | 0, $1 | 0, HEAP32[($3 + 44 | 0) >> 2] | 0 | 0) | 0;
          if (!$1) {
           continue label$18
          }
          break label$4;
         };
        }
        $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($3 + 140 | 0) >> 2] | 0 | 0) | 0;
        HEAP32[$0 >> 2] = 1;
        HEAP32[($0 + 4 | 0) >> 2] = $1;
        break label$2;
       }
       $1 = serde__ser__Serializer__collect_seq__h04407a2a911b47b3($3 + 92 | 0 | 0, $3 + 56 | 0 | 4 | 0 | 0) | 0;
       if ($1) {
        break label$4
       }
      }
      $1 = HEAP32[($3 + 80 | 0) >> 2] | 0;
      i64toi32_i32$2 = $3;
      i64toi32_i32$0 = HEAP32[($3 + 84 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($3 + 88 | 0) >> 2] | 0;
      $203 = i64toi32_i32$0;
      i64toi32_i32$0 = $0 + 8 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $203;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($0 + 4 | 0) >> 2] = $1;
      $1 = 0;
      break label$3;
     }
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 80 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 80 | 0 | 0);
     HEAP32[($3 + 80 | 0) >> 2] = $1;
     i64toi32_i32$0 = $3;
     i64toi32_i32$1 = 0;
     HEAP32[($3 + 108 | 0) >> 2] = 0;
     HEAP32[($3 + 112 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($3 + 104 | 0) >> 2] = HEAP32[(0 + 1059260 | 0) >> 2] | 0;
     core__fmt__Formatter__new__he219faf25326051b($3 + 136 | 0 | 0, $3 + 104 | 0 | 0, 1058944 | 0);
     if ($serde_json__error__Error_20as_20core__fmt__Display___fmt__h9e9840cbd4820f76($3 + 80 | 0 | 0, $3 + 136 | 0 | 0) | 0) {
      break label$1
     }
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 24 | 0 | 0, $3 + 104 | 0 | 0);
     $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($3 + 24 | 0) >> 2] | 0 | 0, HEAP32[($3 + 28 | 0) >> 2] | 0 | 0) | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 104 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 104 | 0 | 0);
     core__ptr__drop_in_place_serde_json__error__Error___h074362a9a9c9d71d($3 + 80 | 0 | 0);
     HEAP32[($0 + 4 | 0) >> 2] = $1;
     $1 = 1;
    }
    HEAP32[$0 >> 2] = $1;
    core__ptr__drop_in_place_serde_json__value__Value___h0088decf7dc316c7_1($3 + 56 | 0 | 0);
   }
   global$0 = $3 + 176 | 0;
   return;
  }
  core__result__unwrap_failed__h27f43d993c3864a1(1058968 | 0, 55 | 0, $3 + 96 | 0 | 0, 1059160 | 0, 1059100 | 0);
  abort();
 }
 
 function $cardano_serialization_lib__metadata__TransactionMetadatumLabels_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__haad9b7d9d4089367($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$4 = 0, $3 = 0, $8 = 0, $7 = 0, $7$hi = 0, $6 = 0, $6$hi = 0, $8$hi = 0, $5 = 0, $4 = 0, $34 = 0, $35 = 0, $36 = 0, $37 = 0, $38 = 0, $109 = 0, $115 = 0, $124 = 0, $128 = 0, $150 = 0, $156 = 0, $160 = 0, $165 = 0, $171 = 0, $175 = 0, $187 = 0, $191 = 0, $197 = 0, $203 = 0, $216 = 0, $219 = 0, $232 = 0;
  $2 = global$0 - 304 | 0;
  global$0 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 12 | 0) >> 2] = 0;
  HEAP32[($2 + 16 | 0) >> 2] = i64toi32_i32$0;
  $3 = 0;
  HEAP32[($2 + 8 | 0) >> 2] = HEAP32[(0 + 1059252 | 0) >> 2] | 0;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 232 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = ($2 + 232 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $6 = i64toi32_i32$0;
  $6$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 240 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 244 | 0) >> 2] | 0;
  $7 = i64toi32_i32$1;
  $7$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         i64toi32_i32$2 = $2;
         i64toi32_i32$0 = HEAP32[($2 + 232 | 0) >> 2] | 0;
         i64toi32_i32$1 = HEAP32[($2 + 236 | 0) >> 2] | 0;
         i64toi32_i32$2 = i64toi32_i32$0;
         i64toi32_i32$0 = 0;
         i64toi32_i32$3 = 1;
         if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
          break label$7
         }
         i64toi32_i32$2 = $6$hi;
         $4 = $6;
         label$8 : {
          i64toi32_i32$2 = $7$hi;
          i64toi32_i32$3 = $7;
          i64toi32_i32$1 = 0;
          i64toi32_i32$0 = 1;
          if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
           break label$8
          }
          if (!$4) {
           break label$3
          }
         }
         label$9 : {
          label$10 : while (1) {
           std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 | 0, $1 | 0);
           $3 = 0;
           $5 = 2;
           label$11 : {
            if (HEAP32[($2 + 4 | 0) >> 2] | 0) {
             break label$11
            }
            i64toi32_i32$3 = 0;
            $7 = 8;
            $7$hi = i64toi32_i32$3;
            i64toi32_i32$3 = 0;
            $6 = 0;
            $6$hi = i64toi32_i32$3;
            break label$5;
           }
           label$12 : {
            if ((($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[$2 >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) == (7 | 0)) {
             break label$12
            }
            $cardano_serialization_lib__utils__BigNum_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h29637bb571dceb02($2 + 232 | 0 | 0, $1 | 0);
            i64toi32_i32$0 = $2;
            i64toi32_i32$3 = HEAP32[($2 + 240 | 0) >> 2] | 0;
            i64toi32_i32$2 = HEAP32[($2 + 244 | 0) >> 2] | 0;
            $8 = i64toi32_i32$3;
            $8$hi = i64toi32_i32$2;
            i64toi32_i32$0 = $2;
            i64toi32_i32$2 = HEAP32[($2 + 232 | 0) >> 2] | 0;
            i64toi32_i32$3 = HEAP32[($2 + 236 | 0) >> 2] | 0;
            i64toi32_i32$0 = i64toi32_i32$2;
            i64toi32_i32$2 = 0;
            i64toi32_i32$1 = 1;
            if ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) | 0) {
             break label$9
            }
            label$13 : {
             $3 = HEAP32[($2 + 16 | 0) >> 2] | 0;
             if ((HEAP32[($2 + 12 | 0) >> 2] | 0 | 0) != ($3 | 0)) {
              break label$13
             }
             alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h747ed10c49fb1468($2 + 8 | 0 | 0, $3 | 0, 1 | 0);
             $3 = HEAP32[($2 + 16 | 0) >> 2] | 0;
            }
            i64toi32_i32$0 = $8$hi;
            i64toi32_i32$3 = (HEAP32[($2 + 8 | 0) >> 2] | 0) + ($3 << 3 | 0) | 0;
            HEAP32[i64toi32_i32$3 >> 2] = $8;
            HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
            $3 = (HEAP32[($2 + 16 | 0) >> 2] | 0) + 1 | 0;
            HEAP32[($2 + 16 | 0) >> 2] = $3;
            i64toi32_i32$0 = $7$hi;
            i64toi32_i32$1 = $7;
            i64toi32_i32$3 = 0;
            i64toi32_i32$2 = 1;
            if ((i64toi32_i32$1 | 0) != (i64toi32_i32$2 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$3 | 0) | 0) {
             continue label$10
            }
            if ($3 >>> 0 < $4 >>> 0) {
             continue label$10
            }
            break label$3;
           }
           break label$10;
          };
          cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 232 | 0 | 0, $1 | 0);
          i64toi32_i32$2 = ($2 + 232 | 0) + 16 | 0;
          i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
          $6 = i64toi32_i32$1;
          $6$hi = i64toi32_i32$0;
          i64toi32_i32$2 = $2;
          i64toi32_i32$0 = HEAP32[($2 + 240 | 0) >> 2] | 0;
          i64toi32_i32$1 = HEAP32[($2 + 244 | 0) >> 2] | 0;
          $7 = i64toi32_i32$0;
          $7$hi = i64toi32_i32$1;
          i64toi32_i32$2 = $2;
          i64toi32_i32$1 = HEAP32[($2 + 232 | 0) >> 2] | 0;
          i64toi32_i32$0 = HEAP32[($2 + 236 | 0) >> 2] | 0;
          i64toi32_i32$2 = i64toi32_i32$1;
          i64toi32_i32$1 = 0;
          i64toi32_i32$3 = 1;
          if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
           break label$6
          }
          i64toi32_i32$2 = $6$hi;
          i64toi32_i32$0 = $2 + 200 | 0;
          HEAP32[i64toi32_i32$0 >> 2] = $6;
          HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
          i64toi32_i32$2 = $7$hi;
          i64toi32_i32$0 = $2;
          HEAP32[($2 + 192 | 0) >> 2] = $7;
          HEAP32[($2 + 196 | 0) >> 2] = i64toi32_i32$2;
          if (($7 & 255 | 0 | 0) == (5 | 0)) {
           break label$3
          }
          HEAP32[($2 + 232 | 0) >> 2] = 0;
          core__panicking__assert_failed__h96d8431cc974b591(0 | 0, $2 + 192 | 0 | 0, 1059816 | 0, $2 + 232 | 0 | 0, 1059912 | 0);
          abort();
         }
         i64toi32_i32$3 = $2 + 272 | 0;
         i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $109 = i64toi32_i32$2;
         i64toi32_i32$2 = ($2 + 168 | 0) + 8 | 0;
         HEAP32[i64toi32_i32$2 >> 2] = $109;
         HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$3 = $2 + 280 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $115 = i64toi32_i32$0;
         i64toi32_i32$0 = ($2 + 168 | 0) + 16 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $115;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
         HEAP32[(($2 + 152 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 300 | 0) >> 2] | 0;
         i64toi32_i32$3 = $2;
         i64toi32_i32$2 = HEAP32[($2 + 292 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($2 + 296 | 0) >> 2] | 0;
         $124 = i64toi32_i32$2;
         i64toi32_i32$2 = $2;
         HEAP32[($2 + 152 | 0) >> 2] = $124;
         HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$3 = $2 + 264 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $128 = i64toi32_i32$0;
         i64toi32_i32$0 = $2;
         HEAP32[($2 + 168 | 0) >> 2] = $128;
         HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$2;
         i64toi32_i32$2 = $8$hi;
         $5 = $8;
         if (($8 & 255 | 0 | 0) == (19 | 0)) {
          break label$3
         }
         i64toi32_i32$2 = $8$hi;
         i64toi32_i32$3 = $8;
         i64toi32_i32$0 = 0;
         i64toi32_i32$1 = 8;
         i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
          i64toi32_i32$0 = 0;
          $34 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
         } else {
          i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
          $34 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$4 | 0) | 0;
         }
         $8 = $34;
         $8$hi = i64toi32_i32$0;
         i64toi32_i32$2 = $2 + 256 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $6 = i64toi32_i32$0;
         $6$hi = i64toi32_i32$3;
         i64toi32_i32$2 = ($2 + 232 | 0) + 16 | 0;
         i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $7 = i64toi32_i32$3;
         $7$hi = i64toi32_i32$0;
         $3 = HEAP32[($2 + 288 | 0) >> 2] | 0;
         break label$4;
        }
        i64toi32_i32$2 = $2 + 264 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $150 = i64toi32_i32$0;
        i64toi32_i32$0 = $2 + 176 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $150;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
        i64toi32_i32$2 = $2 + 272 | 0;
        i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $156 = i64toi32_i32$3;
        i64toi32_i32$3 = ($2 + 168 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$3 >> 2] = $156;
        HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = $2 + 256 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $160 = i64toi32_i32$0;
        i64toi32_i32$0 = $2;
        HEAP32[($2 + 168 | 0) >> 2] = $160;
        HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$3;
        $5 = 2;
        break label$5;
       }
       i64toi32_i32$2 = $2 + 264 | 0;
       i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $165 = i64toi32_i32$3;
       i64toi32_i32$3 = $2 + 176 | 0;
       HEAP32[i64toi32_i32$3 >> 2] = $165;
       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = $2 + 272 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $171 = i64toi32_i32$0;
       i64toi32_i32$0 = ($2 + 168 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $171;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
       i64toi32_i32$2 = $2 + 256 | 0;
       i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $175 = i64toi32_i32$3;
       i64toi32_i32$3 = $2;
       HEAP32[($2 + 168 | 0) >> 2] = $175;
       HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$0;
      }
     }
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$3 = ($2 + 232 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $6;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$3 = ($2 + 232 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $7;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[($2 + 168 | 0) >> 2] | 0;
     i64toi32_i32$3 = HEAP32[($2 + 172 | 0) >> 2] | 0;
     $187 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 256 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $187;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$2 = $2;
     i64toi32_i32$3 = HEAP32[($2 + 152 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 156 | 0) >> 2] | 0;
     $191 = i64toi32_i32$3;
     i64toi32_i32$3 = $2 + 284 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $191;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = ($2 + 168 | 0) + 8 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $197 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 264 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $197;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$2 = ($2 + 168 | 0) + 16 | 0;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $203 = i64toi32_i32$3;
     i64toi32_i32$3 = $2 + 272 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $203;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($2 + 292 | 0) >> 2] = HEAP32[(($2 + 152 | 0) + 8 | 0) >> 2] | 0;
     HEAP8[($2 + 232 | 0) >> 0] = $5;
     HEAP32[($2 + 280 | 0) >> 2] = $3;
     i64toi32_i32$0 = $8$hi;
     HEAP8[($2 + 233 | 0) >> 0] = $8;
     HEAP8[($2 + 234 | 0) >> 0] = $8 >>> 8 | 0;
     HEAP8[($2 + 235 | 0) >> 0] = $8 >>> 16 | 0;
     HEAP8[($2 + 236 | 0) >> 0] = $8 >>> 24 | 0;
     $216 = $2;
     i64toi32_i32$2 = $8;
     i64toi32_i32$3 = 0;
     i64toi32_i32$1 = 48;
     i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
      i64toi32_i32$3 = 0;
      $35 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
     } else {
      i64toi32_i32$3 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
      $35 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
     }
     HEAP8[($216 + 239 | 0) >> 0] = $35;
     $219 = $2;
     i64toi32_i32$3 = $8$hi;
     i64toi32_i32$0 = $8;
     i64toi32_i32$2 = 0;
     i64toi32_i32$1 = 32;
     i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
      i64toi32_i32$2 = 0;
      $36 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
     } else {
      i64toi32_i32$2 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
      $36 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
     }
     $37 = $219;
     $38 = $36;
     HEAP8[($37 + 237 | 0) >> 0] = $38;
     HEAP8[($37 + 238 | 0) >> 0] = $38 >>> 8 | 0;
     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($2 + 88 | 0 | 0, $2 + 232 | 0 | 0, 1059928 | 0, 26 | 0);
     $3 = HEAPU8[($2 + 88 | 0) >> 0] | 0;
     if (($3 | 0) != (19 | 0)) {
      break label$2
     }
    }
    i64toi32_i32$3 = $2;
    i64toi32_i32$2 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $232 = i64toi32_i32$2;
    i64toi32_i32$2 = $0;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = $232;
    HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
    $1 = 0;
    break label$1;
   }
   $1 = 1;
   memcpy($2 + 25 | 0 | 0, $2 + 88 | 0 | 1 | 0 | 0, 63 | 0) | 0;
   HEAP8[($0 + 8 | 0) >> 0] = $3;
   memcpy($0 + 9 | 0 | 0, $2 + 25 | 0 | 0, 63 | 0) | 0;
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h53c1f511db73a3dc($2 + 8 | 0 | 0);
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 304 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__HeaderBody___deserialize__hca688f096fd630fa($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $6 = 0, $3 = 0, $6$hi = 0, $4 = 0, $7 = 0, $7$hi = 0, $37 = 0, $38 = 0, $39 = 0, $40 = 0, $41 = 0, $42 = 0, $43 = 0, $45 = 0, $46 = 0, $47 = 0, $5 = 0, $48 = 0, $49 = 0, $50 = 0, $44 = 0, $52 = 0, $65 = 0, $108 = 0, $115 = 0, $119 = 0, $155 = 0, $155$hi = 0, $158 = 0, $158$hi = 0, $162$hi = 0, $164$hi = 0, $166$hi = 0, $169 = 0, $169$hi = 0, $201 = 0, $207 = 0, $211 = 0, $227 = 0, $231 = 0, $237 = 0, $243 = 0;
  $2 = global$0 - 640 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 296 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 304 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 308 | 0) >> 2] | 0;
  $6 = i64toi32_i32$0;
  $6$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 296 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 300 | 0) >> 2] | 0;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 1;
      if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
       break label$4
      }
      i64toi32_i32$2 = $6$hi;
      i64toi32_i32$0 = i64toi32_i32$2;
      cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__HeaderBody___deserialize_as_embedded_group__h626cfdd4be8109d9($2 + 296 | 0 | 0, $1 | 0, $6 | 0, i64toi32_i32$2 | 0, $6 | 0, i64toi32_i32$2 | 0);
      label$5 : {
       label$6 : {
        label$7 : {
         i64toi32_i32$0 = i64toi32_i32$2;
         i64toi32_i32$0 = i64toi32_i32$2;
         i64toi32_i32$3 = $6;
         i64toi32_i32$2 = 0;
         i64toi32_i32$1 = 1;
         if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) | 0) {
          break label$7
         }
         cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 8 | 0 | 0, $1 | 0);
         $3 = HEAPU8[($2 + 16 | 0) >> 0] | 0;
         i64toi32_i32$1 = $2;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] | 0;
         i64toi32_i32$1 = i64toi32_i32$3;
         i64toi32_i32$3 = 0;
         i64toi32_i32$2 = 1;
         if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) | 0) {
          break label$6
         }
         $1 = 5;
         if (($3 & 255 | 0 | 0) != (5 | 0)) {
          break label$5
         }
        }
        $4 = $2 + 280 | 0;
        i64toi32_i32$2 = ($2 + 296 | 0) + 40 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $44 = i64toi32_i32$1;
        i64toi32_i32$1 = $4;
        HEAP32[i64toi32_i32$1 >> 2] = $44;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        $5 = ($2 + 272 | 0) + 16 | 0;
        i64toi32_i32$2 = ($2 + 296 | 0) + 48 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $52 = i64toi32_i32$0;
        i64toi32_i32$0 = $5;
        HEAP32[i64toi32_i32$0 >> 2] = $52;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        HEAP32[($2 + 616 | 0) >> 2] = HEAPU8[($2 + 305 | 0) >> 0] | 0 | ((HEAPU8[($2 + 306 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 307 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 308 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $37 = ($2 + 296 | 0) + 12 | 0;
        $38 = HEAPU8[$37 >> 0] | 0 | ((HEAPU8[($37 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($37 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($37 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 619 | 0) >> 0] = $38;
        HEAP8[($2 + 620 | 0) >> 0] = $38 >>> 8 | 0;
        HEAP8[($2 + 621 | 0) >> 0] = $38 >>> 16 | 0;
        HEAP8[($2 + 622 | 0) >> 0] = $38 >>> 24 | 0;
        i64toi32_i32$2 = ($2 + 296 | 0) + 32 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $65 = i64toi32_i32$1;
        i64toi32_i32$1 = $2;
        HEAP32[(i64toi32_i32$1 + 272 | 0) >> 2] = $65;
        HEAP32[(i64toi32_i32$1 + 276 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = (i64toi32_i32$1 + 296 | 0) + 16 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $6 = i64toi32_i32$0;
        $6$hi = i64toi32_i32$1;
        i64toi32_i32$2 = ($2 + 296 | 0) + 24 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $7 = i64toi32_i32$1;
        $7$hi = i64toi32_i32$0;
        $3 = HEAP32[(($2 + 296 | 0) + 56 | 0) >> 2] | 0;
        $1 = HEAPU8[($2 + 304 | 0) >> 0] | 0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 296 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 300 | 0) >> 2] | 0;
        memcpy(i64toi32_i32$2 + 8 | 0 | 0, (i64toi32_i32$2 + 296 | 0) + 60 | 0 | 0, 260 | 0) | 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
         break label$2
        }
        HEAP8[($0 + 8 | 0) >> 0] = $1;
        $39 = HEAP32[($2 + 616 | 0) >> 2] | 0;
        HEAP8[($0 + 9 | 0) >> 0] = $39;
        HEAP8[($0 + 10 | 0) >> 0] = $39 >>> 8 | 0;
        HEAP8[($0 + 11 | 0) >> 0] = $39 >>> 16 | 0;
        HEAP8[($0 + 12 | 0) >> 0] = $39 >>> 24 | 0;
        $40 = $0 + 12 | 0;
        $41 = HEAPU8[($2 + 619 | 0) >> 0] | 0 | ((HEAPU8[($2 + 620 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 621 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 622 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[$40 >> 0] = $41;
        HEAP8[($40 + 1 | 0) >> 0] = $41 >>> 8 | 0;
        HEAP8[($40 + 2 | 0) >> 0] = $41 >>> 16 | 0;
        HEAP8[($40 + 3 | 0) >> 0] = $41 >>> 24 | 0;
        i64toi32_i32$2 = $7$hi;
        i64toi32_i32$1 = $0 + 24 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $7;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
        i64toi32_i32$2 = $6$hi;
        i64toi32_i32$1 = $0 + 16 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $6;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
        i64toi32_i32$3 = $2;
        i64toi32_i32$2 = HEAP32[($2 + 272 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 276 | 0) >> 2] | 0;
        $108 = i64toi32_i32$2;
        i64toi32_i32$2 = $0 + 32 | 0;
        $42 = $108;
        HEAP8[i64toi32_i32$2 >> 0] = $42;
        HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $42 >>> 8 | 0;
        HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $42 >>> 16 | 0;
        HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $42 >>> 24 | 0;
        HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$1;
        HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
        HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
        HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
        HEAP32[($0 + 56 | 0) >> 2] = $3;
        i64toi32_i32$3 = $4;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $115 = i64toi32_i32$1;
        i64toi32_i32$1 = $0 + 40 | 0;
        $43 = $115;
        HEAP8[i64toi32_i32$1 >> 0] = $43;
        HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $43 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $43 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $43 >>> 24 | 0;
        HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$2;
        HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
        i64toi32_i32$3 = $5;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $119 = i64toi32_i32$2;
        i64toi32_i32$2 = $0 + 48 | 0;
        $45 = $119;
        HEAP8[i64toi32_i32$2 >> 0] = $45;
        HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $45 >>> 8 | 0;
        HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $45 >>> 16 | 0;
        HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $45 >>> 24 | 0;
        HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$1;
        HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
        HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
        HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
        memcpy($0 + 60 | 0 | 0, $2 + 8 | 0 | 0, 260 | 0) | 0;
        i64toi32_i32$1 = 0;
        $6 = 0;
        $6$hi = i64toi32_i32$1;
        break label$1;
       }
       i64toi32_i32$3 = $2 + 40 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $6 = i64toi32_i32$1;
       $6$hi = i64toi32_i32$2;
       i64toi32_i32$1 = ($2 + 616 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $6;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$3 = $2 + 48 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $7 = i64toi32_i32$2;
       $7$hi = i64toi32_i32$1;
       i64toi32_i32$2 = ($2 + 616 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $7;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$1 = $6$hi;
       i64toi32_i32$2 = ($2 + 272 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $6;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$1 = $7$hi;
       i64toi32_i32$2 = ($2 + 272 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $7;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$3 = $2 + 32 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $6 = i64toi32_i32$1;
       $6$hi = i64toi32_i32$2;
       i64toi32_i32$1 = $2;
       HEAP32[(i64toi32_i32$1 + 616 | 0) >> 2] = $6;
       HEAP32[(i64toi32_i32$1 + 620 | 0) >> 2] = i64toi32_i32$2;
       HEAP32[(i64toi32_i32$1 + 272 | 0) >> 2] = $6;
       HEAP32[(i64toi32_i32$1 + 276 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$3 = i64toi32_i32$1;
       i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 17 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 18 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 19 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 20 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = 0;
       $155 = i64toi32_i32$2;
       $155$hi = i64toi32_i32$1;
       i64toi32_i32$3 = $2 + 21 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
       i64toi32_i32$2 = 0;
       $158 = i64toi32_i32$1;
       $158$hi = i64toi32_i32$2;
       i64toi32_i32$3 = $2 + 23 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$3 >> 0] | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = i64toi32_i32$2;
       i64toi32_i32$2 = 0;
       i64toi32_i32$0 = 16;
       i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
        $48 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $48 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
       }
       $162$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $158$hi;
       i64toi32_i32$1 = $158;
       i64toi32_i32$3 = $162$hi;
       i64toi32_i32$0 = $48;
       i64toi32_i32$3 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$0 = 32;
       i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $49 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$4 | 0) | 0;
        $49 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       $164$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $155$hi;
       i64toi32_i32$3 = $155;
       i64toi32_i32$2 = $164$hi;
       i64toi32_i32$0 = $49;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
       i64toi32_i32$1 = i64toi32_i32$3 | i64toi32_i32$0 | 0;
       i64toi32_i32$3 = 0;
       i64toi32_i32$0 = 8;
       i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
        i64toi32_i32$3 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        $50 = 0;
       } else {
        i64toi32_i32$3 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
        $50 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       }
       $166$hi = i64toi32_i32$3;
       i64toi32_i32$3 = 0;
       i64toi32_i32$2 = $3;
       i64toi32_i32$1 = 0;
       i64toi32_i32$0 = 255;
       i64toi32_i32$1 = i64toi32_i32$3 & i64toi32_i32$1 | 0;
       $169 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
       $169$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $166$hi;
       i64toi32_i32$3 = $50;
       i64toi32_i32$2 = $169$hi;
       i64toi32_i32$0 = $169;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
       $6 = i64toi32_i32$3 | i64toi32_i32$0 | 0;
       $6$hi = i64toi32_i32$2;
       i64toi32_i32$1 = ($2 + 8 | 0) + 16 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $7 = i64toi32_i32$2;
       $7$hi = i64toi32_i32$3;
       $1 = 2;
      }
      $3 = $2 + 304 | 0;
      label$8 : {
       i64toi32_i32$1 = $2;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 296 | 0) >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 300 | 0) >> 2] | 0;
       i64toi32_i32$1 = i64toi32_i32$3;
       i64toi32_i32$3 = 0;
       i64toi32_i32$0 = 0;
       if ((i64toi32_i32$1 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | 0) {
        break label$8
       }
       $4 = $3 + 12 | 0;
       $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($4 | 0);
       $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($4 | 0);
       $4 = $2 + 328 | 0;
       $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($4 | 0);
       $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($4 | 0);
       $3 = $3 + 36 | 0;
       $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 | 0);
       $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 | 0);
       $3 = $2 + 352 | 0;
       $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 | 0);
       $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 | 0);
       break label$3;
      }
      core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9($3 | 0);
      break label$3;
     }
     i64toi32_i32$0 = $2 + 328 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $201 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 280 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $201;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$0 = $2 + 336 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $207 = i64toi32_i32$2;
     i64toi32_i32$2 = ($2 + 272 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $207;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$0 = $2 + 320 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $211 = i64toi32_i32$1;
     i64toi32_i32$1 = $2;
     HEAP32[(i64toi32_i32$1 + 272 | 0) >> 2] = $211;
     HEAP32[(i64toi32_i32$1 + 276 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$0 = (i64toi32_i32$1 + 296 | 0) + 16 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $7 = i64toi32_i32$2;
     $7$hi = i64toi32_i32$1;
     $1 = 2;
    }
    $3 = 0;
   }
   i64toi32_i32$1 = $7$hi;
   i64toi32_i32$2 = ($2 + 296 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $7;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $6$hi;
   i64toi32_i32$2 = ($2 + 296 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $6;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$0 = $2;
   i64toi32_i32$1 = HEAP32[($2 + 272 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($2 + 276 | 0) >> 2] | 0;
   $227 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 320 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $227;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = $2;
   i64toi32_i32$2 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $231 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 348 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $231;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$0 = ($2 + 272 | 0) + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $237 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 328 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $237;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = ($2 + 272 | 0) + 16 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $243 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 336 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $243;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($2 + 356 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
   HEAP8[($2 + 296 | 0) >> 0] = $1;
   $46 = HEAP32[($2 + 616 | 0) >> 2] | 0;
   HEAP8[($2 + 297 | 0) >> 0] = $46;
   HEAP8[($2 + 298 | 0) >> 0] = $46 >>> 8 | 0;
   HEAP8[($2 + 299 | 0) >> 0] = $46 >>> 16 | 0;
   HEAP8[($2 + 300 | 0) >> 0] = $46 >>> 24 | 0;
   $47 = HEAPU8[($2 + 619 | 0) >> 0] | 0 | ((HEAPU8[($2 + 620 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 621 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 622 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[($2 + 300 | 0) >> 0] = $47;
   HEAP8[($2 + 301 | 0) >> 0] = $47 >>> 8 | 0;
   HEAP8[($2 + 302 | 0) >> 0] = $47 >>> 16 | 0;
   HEAP8[($2 + 303 | 0) >> 0] = $47 >>> 24 | 0;
   HEAP32[($2 + 344 | 0) >> 2] = $3;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 296 | 0 | 0, 1052865 | 0, 10 | 0);
   i64toi32_i32$1 = 0;
   $6 = 1;
   $6$hi = i64toi32_i32$1;
  }
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$2 = $0;
  HEAP32[i64toi32_i32$2 >> 2] = $6;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $2 + 640 | 0;
 }
 
 function $cardano_serialization_lib__crypto__BootstrapWitness_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__haabcdaf43d31e3da($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $8 = 0, $3 = 0, $8$hi = 0, $9 = 0, $9$hi = 0, $39 = 0, $40 = 0, $41 = 0, $42 = 0, $43 = 0, $44 = 0, $45 = 0, $47 = 0, $48 = 0, $49 = 0, $4 = 0, $5 = 0, $50 = 0, $51 = 0, $52 = 0, $46 = 0, $54 = 0, $67 = 0, $6 = 0, $7 = 0, $117 = 0, $124 = 0, $128 = 0, $164 = 0, $164$hi = 0, $167 = 0, $167$hi = 0, $171$hi = 0, $173$hi = 0, $175$hi = 0, $178 = 0, $178$hi = 0, $201 = 0, $207 = 0, $211 = 0, $227 = 0, $231 = 0, $237 = 0, $243 = 0;
  $2 = global$0 - 256 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 104 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 112 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 116 | 0) >> 2] | 0;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      i64toi32_i32$2 = $2;
      i64toi32_i32$1 = HEAP32[($2 + 104 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($2 + 108 | 0) >> 2] | 0;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 1;
      if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
       break label$4
      }
      i64toi32_i32$2 = $8$hi;
      i64toi32_i32$0 = i64toi32_i32$2;
      $cardano_serialization_lib__crypto__BootstrapWitness_20as_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup___deserialize_as_embedded_group__h518be7fb64963f77($2 + 104 | 0 | 0, $1 | 0, $8 | 0, i64toi32_i32$0 | 0, $8 | 0, i64toi32_i32$0 | 0);
      label$5 : {
       label$6 : {
        label$7 : {
         i64toi32_i32$3 = $8;
         i64toi32_i32$2 = 0;
         i64toi32_i32$1 = 1;
         if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) | 0) {
          break label$7
         }
         cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 8 | 0 | 0, $1 | 0);
         $3 = HEAPU8[($2 + 16 | 0) >> 0] | 0;
         i64toi32_i32$1 = $2;
         i64toi32_i32$3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
         i64toi32_i32$1 = i64toi32_i32$3;
         i64toi32_i32$3 = 0;
         i64toi32_i32$2 = 1;
         if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) | 0) {
          break label$6
         }
         $1 = 5;
         if (($3 & 255 | 0 | 0) != (5 | 0)) {
          break label$5
         }
        }
        $4 = ($2 + 80 | 0) + 8 | 0;
        i64toi32_i32$2 = ($2 + 104 | 0) + 40 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $46 = i64toi32_i32$1;
        i64toi32_i32$1 = $4;
        HEAP32[i64toi32_i32$1 >> 2] = $46;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        $5 = ($2 + 80 | 0) + 16 | 0;
        i64toi32_i32$2 = ($2 + 104 | 0) + 48 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $54 = i64toi32_i32$0;
        i64toi32_i32$0 = $5;
        HEAP32[i64toi32_i32$0 >> 2] = $54;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        HEAP32[($2 + 232 | 0) >> 2] = HEAPU8[($2 + 113 | 0) >> 0] | 0 | ((HEAPU8[($2 + 114 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 115 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 116 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $39 = ($2 + 104 | 0) + 12 | 0;
        $40 = HEAPU8[$39 >> 0] | 0 | ((HEAPU8[($39 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($39 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($39 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 235 | 0) >> 0] = $40;
        HEAP8[($2 + 236 | 0) >> 0] = $40 >>> 8 | 0;
        HEAP8[($2 + 237 | 0) >> 0] = $40 >>> 16 | 0;
        HEAP8[($2 + 238 | 0) >> 0] = $40 >>> 24 | 0;
        i64toi32_i32$2 = ($2 + 104 | 0) + 32 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $67 = i64toi32_i32$1;
        i64toi32_i32$1 = $2;
        HEAP32[($2 + 80 | 0) >> 2] = $67;
        HEAP32[($2 + 84 | 0) >> 2] = i64toi32_i32$0;
        $1 = HEAPU8[(($2 + 104 | 0) + 8 | 0) >> 0] | 0;
        i64toi32_i32$2 = ($2 + 104 | 0) + 16 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $8 = i64toi32_i32$0;
        $8$hi = i64toi32_i32$1;
        i64toi32_i32$2 = ($2 + 104 | 0) + 24 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $9 = i64toi32_i32$1;
        $9$hi = i64toi32_i32$0;
        $3 = HEAP32[(($2 + 104 | 0) + 56 | 0) >> 2] | 0;
        $6 = HEAP32[($2 + 108 | 0) >> 2] | 0;
        $7 = HEAP32[($2 + 104 | 0) >> 2] | 0;
        memcpy($2 + 8 | 0 | 0, ($2 + 104 | 0) + 60 | 0 | 0, 68 | 0) | 0;
        if (($7 | 0) == (1 | 0)) {
         break label$2
        }
        HEAP32[($0 + 4 | 0) >> 2] = $6;
        $41 = HEAP32[($2 + 232 | 0) >> 2] | 0;
        HEAP8[($0 + 9 | 0) >> 0] = $41;
        HEAP8[($0 + 10 | 0) >> 0] = $41 >>> 8 | 0;
        HEAP8[($0 + 11 | 0) >> 0] = $41 >>> 16 | 0;
        HEAP8[($0 + 12 | 0) >> 0] = $41 >>> 24 | 0;
        HEAP8[($0 + 8 | 0) >> 0] = $1;
        $42 = $0 + 12 | 0;
        $43 = HEAPU8[($2 + 235 | 0) >> 0] | 0 | ((HEAPU8[($2 + 236 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 237 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 238 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[$42 >> 0] = $43;
        HEAP8[($42 + 1 | 0) >> 0] = $43 >>> 8 | 0;
        HEAP8[($42 + 2 | 0) >> 0] = $43 >>> 16 | 0;
        HEAP8[($42 + 3 | 0) >> 0] = $43 >>> 24 | 0;
        i64toi32_i32$0 = $9$hi;
        i64toi32_i32$1 = $0 + 24 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $9;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$0 = $8$hi;
        i64toi32_i32$1 = $0 + 16 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $8;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 80 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 84 | 0) >> 2] | 0;
        $117 = i64toi32_i32$0;
        i64toi32_i32$0 = $0 + 32 | 0;
        $44 = $117;
        HEAP8[i64toi32_i32$0 >> 0] = $44;
        HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $44 >>> 8 | 0;
        HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $44 >>> 16 | 0;
        HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $44 >>> 24 | 0;
        HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
        HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
        HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
        HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
        HEAP32[($0 + 56 | 0) >> 2] = $3;
        i64toi32_i32$2 = $4;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $124 = i64toi32_i32$1;
        i64toi32_i32$1 = $0 + 40 | 0;
        $45 = $124;
        HEAP8[i64toi32_i32$1 >> 0] = $45;
        HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $45 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $45 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $45 >>> 24 | 0;
        HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
        HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
        i64toi32_i32$2 = $5;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $128 = i64toi32_i32$0;
        i64toi32_i32$0 = $0 + 48 | 0;
        $47 = $128;
        HEAP8[i64toi32_i32$0 >> 0] = $47;
        HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $47 >>> 8 | 0;
        HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $47 >>> 16 | 0;
        HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $47 >>> 24 | 0;
        HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
        HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
        HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
        HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
        memcpy($0 + 60 | 0 | 0, $2 + 8 | 0 | 0, 64 | 0) | 0;
        $1 = 0;
        break label$1;
       }
       i64toi32_i32$2 = $2 + 40 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $8 = i64toi32_i32$1;
       $8$hi = i64toi32_i32$0;
       i64toi32_i32$1 = ($2 + 232 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $8;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = $2 + 48 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $9 = i64toi32_i32$0;
       $9$hi = i64toi32_i32$1;
       i64toi32_i32$0 = ($2 + 232 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $9;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$1 = $8$hi;
       i64toi32_i32$0 = ($2 + 80 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $8;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$1 = $9$hi;
       i64toi32_i32$0 = ($2 + 80 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $9;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $2 + 32 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $8 = i64toi32_i32$1;
       $8$hi = i64toi32_i32$0;
       i64toi32_i32$1 = $2;
       HEAP32[($2 + 232 | 0) >> 2] = $8;
       HEAP32[($2 + 236 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$1 = $2;
       HEAP32[($2 + 80 | 0) >> 2] = $8;
       HEAP32[($2 + 84 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = $2;
       i64toi32_i32$0 = HEAPU8[($2 + 17 | 0) >> 0] | 0 | ((HEAPU8[($2 + 18 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 19 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 20 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = 0;
       $164 = i64toi32_i32$0;
       $164$hi = i64toi32_i32$1;
       i64toi32_i32$2 = $2 + 21 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
       i64toi32_i32$0 = 0;
       $167 = i64toi32_i32$1;
       $167$hi = i64toi32_i32$0;
       i64toi32_i32$2 = $2 + 23 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$2 = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $50 = 0;
       } else {
        i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $50 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       $171$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $167$hi;
       i64toi32_i32$1 = $167;
       i64toi32_i32$2 = $171$hi;
       i64toi32_i32$3 = $50;
       i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
       i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $51 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
        $51 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       $173$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $164$hi;
       i64toi32_i32$2 = $164;
       i64toi32_i32$0 = $173$hi;
       i64toi32_i32$3 = $51;
       i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
       i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 8;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        $52 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
        $52 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       }
       $175$hi = i64toi32_i32$2;
       i64toi32_i32$2 = 0;
       i64toi32_i32$0 = $3;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 255;
       i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
       $178 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
       $178$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $175$hi;
       i64toi32_i32$2 = $52;
       i64toi32_i32$0 = $178$hi;
       i64toi32_i32$3 = $178;
       i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
       $8 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       $8$hi = i64toi32_i32$0;
       i64toi32_i32$1 = ($2 + 8 | 0) + 16 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $9 = i64toi32_i32$0;
       $9$hi = i64toi32_i32$2;
       $1 = 2;
      }
      label$8 : {
       if (HEAP32[($2 + 104 | 0) >> 2] | 0) {
        break label$8
       }
       $3 = $2 + 104 | 0 | 4 | 0;
       $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 | 0);
       $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 | 0);
       $3 = $2 + 120 | 0;
       $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 | 0);
       $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 | 0);
       break label$3;
      }
      core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9_1($2 + 112 | 0 | 0);
      break label$3;
     }
     i64toi32_i32$1 = $2 + 136 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $201 = i64toi32_i32$2;
     i64toi32_i32$2 = $2 + 88 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $201;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$1 = $2 + 144 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $207 = i64toi32_i32$0;
     i64toi32_i32$0 = ($2 + 80 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $207;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$1 = $2 + 128 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $211 = i64toi32_i32$2;
     i64toi32_i32$2 = $2;
     HEAP32[($2 + 80 | 0) >> 2] = $211;
     HEAP32[($2 + 84 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$1 = ($2 + 104 | 0) + 16 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $9 = i64toi32_i32$0;
     $9$hi = i64toi32_i32$2;
     $1 = 2;
    }
    $3 = 0;
   }
   i64toi32_i32$2 = $9$hi;
   i64toi32_i32$0 = ($2 + 104 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $9;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$2 = $8$hi;
   i64toi32_i32$0 = ($2 + 104 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $8;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$1 = $2;
   i64toi32_i32$2 = HEAP32[($2 + 80 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 84 | 0) >> 2] | 0;
   $227 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 128 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $227;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$1 = $2;
   i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $231 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 156 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $231;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$1 = ($2 + 80 | 0) + 8 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $237 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 136 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $237;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$1 = ($2 + 80 | 0) + 16 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $243 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 144 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $243;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   HEAP32[($2 + 164 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
   HEAP8[($2 + 104 | 0) >> 0] = $1;
   $48 = HEAP32[($2 + 232 | 0) >> 2] | 0;
   HEAP8[($2 + 105 | 0) >> 0] = $48;
   HEAP8[($2 + 106 | 0) >> 0] = $48 >>> 8 | 0;
   HEAP8[($2 + 107 | 0) >> 0] = $48 >>> 16 | 0;
   HEAP8[($2 + 108 | 0) >> 0] = $48 >>> 24 | 0;
   $49 = HEAPU8[($2 + 235 | 0) >> 0] | 0 | ((HEAPU8[($2 + 236 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 237 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 238 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[($2 + 108 | 0) >> 0] = $49;
   HEAP8[($2 + 109 | 0) >> 0] = $49 >>> 8 | 0;
   HEAP8[($2 + 110 | 0) >> 0] = $49 >>> 16 | 0;
   HEAP8[($2 + 111 | 0) >> 0] = $49 >>> 24 | 0;
   HEAP32[($2 + 152 | 0) >> 2] = $3;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 104 | 0 | 0, 1066317 | 0, 16 | 0);
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 256 | 0;
 }
 
 function alloc__collections__btree__remove___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__KV____remove_leaf_kv__hcb9d23746722cda3($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $8 = 0, $4 = 0, $5 = 0, $6 = 0, $7 = 0, $9 = 0, $32 = 0, $11 = 0, $10 = 0, $12 = 0, $42 = 0, $49 = 0, $54 = 0, $80 = 0, $100 = 0, $105 = 0, $112 = 0, $115 = 0, $167 = 0, $172 = 0, $203 = 0, $208 = 0, $229 = 0, $234 = 0, $251 = 0, $256 = 0;
  $3 = global$0 - 128 | 0;
  global$0 = $3;
  $4 = HEAP32[$1 >> 2] | 0;
  $5 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $6 = HEAPU16[($5 + 138 | 0) >> 1] | 0;
  $7 = ($3 + 40 | 0) + 24 | 0;
  $1 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $8 = $5 + Math_imul($1, 28) | 0;
  $32 = $8 + 164 | 0;
  HEAP32[$7 >> 2] = HEAPU8[$32 >> 0] | 0 | ((HEAPU8[($32 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($32 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($32 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $9 = ($3 + 40 | 0) + 16 | 0;
  i64toi32_i32$2 = $8 + 156 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $42 = i64toi32_i32$0;
  i64toi32_i32$0 = $9;
  HEAP32[i64toi32_i32$0 >> 2] = $42;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $10 = ($3 + 40 | 0) + 8 | 0;
  i64toi32_i32$2 = $8 + 148 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $49 = i64toi32_i32$1;
  i64toi32_i32$1 = $10;
  HEAP32[i64toi32_i32$1 >> 2] = $49;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $11 = $8 + 140 | 0;
  i64toi32_i32$2 = $11;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $54 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[($3 + 40 | 0) >> 2] = $54;
  HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$1;
  $12 = $6 + ($1 ^ -1 | 0) | 0;
  memmove(i64toi32_i32$2 | 0, $8 + 168 | 0 | 0, Math_imul($12, 28) | 0) | 0;
  $11 = ($3 + 72 | 0) + 8 | 0;
  $8 = $5 + Math_imul($1, 12) | 0;
  HEAP32[$11 >> 2] = HEAP32[($8 + 12 | 0) >> 2] | 0;
  i64toi32_i32$2 = $8 + 4 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $80 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[($3 + 72 | 0) >> 2] = $80;
  HEAP32[($3 + 76 | 0) >> 2] = i64toi32_i32$0;
  memmove(i64toi32_i32$2 | 0, $8 + 16 | 0 | 0, Math_imul($12, 12) | 0) | 0;
  $8 = $6 + -1 | 0;
  HEAP16[($5 + 138 | 0) >> 1] = $8;
  HEAP32[(($3 + 88 | 0) + 24 | 0) >> 2] = HEAP32[$7 >> 2] | 0;
  i64toi32_i32$2 = $9;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $100 = i64toi32_i32$0;
  i64toi32_i32$0 = ($3 + 88 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $100;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $10;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $105 = i64toi32_i32$1;
  i64toi32_i32$1 = ($3 + 88 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $105;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($3 + 124 | 0) >> 2] = HEAP32[$11 >> 2] | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[($3 + 40 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($3 + 44 | 0) >> 2] | 0;
  $112 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[($3 + 88 | 0) >> 2] = $112;
  HEAP32[($3 + 92 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[($3 + 72 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($3 + 76 | 0) >> 2] | 0;
  $115 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[($3 + 116 | 0) >> 2] = $115;
  HEAP32[($3 + 120 | 0) >> 2] = i64toi32_i32$0;
  $3 = memcpy($3 | 0, $3 + 88 | 0 | 0, 40 | 0) | 0;
  memcpy($3 + 88 | 0 | 0, $3 | 0, 40 | 0) | 0;
  label$1 : {
   if (($8 & 65535 | 0) >>> 0 > 4 >>> 0) {
    break label$1
   }
   alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___choose_parent_kv__h24a9cf471103309d($3 | 0, $4 | 0, $5 | 0);
   $5 = HEAP32[($3 + 4 | 0) >> 2] | 0;
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
        break label$5
       }
       $4 = HEAP32[($3 + 24 | 0) >> 2] | 0;
       $6 = HEAP32[($3 + 32 | 0) >> 2] | 0;
       $9 = ((HEAPU16[($4 + 138 | 0) >> 1] | 0) + (HEAPU16[($6 + 138 | 0) >> 1] | 0) | 0) + 1 | 0;
       $8 = $3 + 8 | 0;
       $7 = HEAP32[($3 + 28 | 0) >> 2] | 0;
       if (($5 | 0) == (1 | 0)) {
        break label$4
       }
       if ($9 >>> 0 < 12 >>> 0) {
        break label$3
       }
       HEAP32[($3 + 64 | 0) >> 2] = $6;
       HEAP32[($3 + 56 | 0) >> 2] = $4;
       i64toi32_i32$2 = $8 + 8 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $167 = i64toi32_i32$0;
       i64toi32_i32$0 = ($3 + 40 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $167;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       HEAP32[($3 + 60 | 0) >> 2] = $7;
       i64toi32_i32$2 = $8;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $172 = i64toi32_i32$1;
       i64toi32_i32$1 = $3;
       HEAP32[($3 + 40 | 0) >> 2] = $172;
       HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$0;
       alloc__collections__btree__node__BalancingContext_K_2cV___bulk_steal_left__he4fcf97c22216196($3 + 40 | 0 | 0, 1 | 0);
       HEAP32[($3 + 80 | 0) >> 2] = $1 + 1 | 0;
       HEAP32[($3 + 76 | 0) >> 2] = $6;
       HEAP32[($3 + 72 | 0) >> 2] = $7;
       break label$2;
      }
      HEAP32[($3 + 80 | 0) >> 2] = $1;
      HEAP32[($3 + 72 | 0) >> 2] = $5;
      HEAP32[($3 + 76 | 0) >> 2] = HEAP32[($3 + 8 | 0) >> 2] | 0;
      break label$2;
     }
     label$6 : {
      if ($9 >>> 0 < 12 >>> 0) {
       break label$6
      }
      HEAP32[($3 + 64 | 0) >> 2] = $6;
      HEAP32[($3 + 56 | 0) >> 2] = $4;
      i64toi32_i32$2 = $8 + 8 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $203 = i64toi32_i32$0;
      i64toi32_i32$0 = ($3 + 40 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $203;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($3 + 60 | 0) >> 2] = $7;
      i64toi32_i32$2 = $8;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $208 = i64toi32_i32$1;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 40 | 0) >> 2] = $208;
      HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$0;
      alloc__collections__btree__node__BalancingContext_K_2cV___bulk_steal_right__h8845d27dacdbfcf7($3 + 40 | 0 | 0, 1 | 0);
      HEAP32[($3 + 80 | 0) >> 2] = $1;
      HEAP32[($3 + 76 | 0) >> 2] = $4;
      HEAP32[($3 + 72 | 0) >> 2] = HEAP32[($3 + 52 | 0) >> 2] | 0;
      break label$2;
     }
     HEAP32[($3 + 64 | 0) >> 2] = $6;
     HEAP32[($3 + 56 | 0) >> 2] = $4;
     i64toi32_i32$2 = $8 + 8 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $229 = i64toi32_i32$0;
     i64toi32_i32$0 = ($3 + 40 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $229;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($3 + 60 | 0) >> 2] = $7;
     i64toi32_i32$2 = $8;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $234 = i64toi32_i32$1;
     i64toi32_i32$1 = $3;
     HEAP32[($3 + 40 | 0) >> 2] = $234;
     HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$0;
     alloc__collections__btree__node__BalancingContext_K_2cV___merge_tracking_child_edge__hd992b4e84bd3c8df($3 + 72 | 0 | 0, $3 + 40 | 0 | 0, 0 | 0, $1 | 0);
     break label$2;
    }
    HEAP32[($3 + 64 | 0) >> 2] = $6;
    HEAP32[($3 + 56 | 0) >> 2] = $4;
    i64toi32_i32$2 = $8 + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $251 = i64toi32_i32$0;
    i64toi32_i32$0 = ($3 + 40 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $251;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($3 + 60 | 0) >> 2] = $7;
    i64toi32_i32$2 = $8;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $256 = i64toi32_i32$1;
    i64toi32_i32$1 = $3;
    HEAP32[($3 + 40 | 0) >> 2] = $256;
    HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$0;
    alloc__collections__btree__node__BalancingContext_K_2cV___merge_tracking_child_edge__hd992b4e84bd3c8df($3 + 72 | 0 | 0, $3 + 40 | 0 | 0, 1 | 0, $1 | 0);
   }
   $1 = HEAP32[($3 + 80 | 0) >> 2] | 0;
   $4 = HEAP32[($3 + 72 | 0) >> 2] | 0;
   $5 = HEAP32[($3 + 76 | 0) >> 2] | 0;
   $8 = HEAP32[$5 >> 2] | 0;
   if (!$8) {
    break label$1
   }
   if (alloc__collections__btree__fix___impl_20alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____fix_node_and_affected_ancestors__hccbf77174e1338cc($4 + 1 | 0 | 0, $8 | 0) | 0) {
    break label$1
   }
   HEAP8[$2 >> 0] = 1;
  }
  $8 = memcpy($0 | 0, $3 + 88 | 0 | 0, 40 | 0) | 0;
  HEAP32[($8 + 48 | 0) >> 2] = $1;
  HEAP32[($8 + 44 | 0) >> 2] = $5;
  HEAP32[($8 + 40 | 0) >> 2] = $4;
  global$0 = $3 + 128 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__OperationalCert___deserialize_as_embedded_group__h5685b082c2c28803($0, $1, $2, $2$hi, $3, $3$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $8 = 0, $5 = 0, $6 = 0, $25 = 0, $26 = 0, $27 = 0, $28 = 0, $8$hi = 0, $7 = 0, $32 = 0, $39 = 0, $55 = 0, $60 = 0, $65 = 0, $68 = 0, $120 = 0, $125 = 0, $131 = 0, $135 = 0;
  $4 = global$0 - 400 | 0;
  global$0 = $4;
  $cardano_serialization_lib__crypto__KESVKey_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h44235a31cbf1173c($4 + 328 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ((HEAPU8[($4 + 328 | 0) >> 0] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      i64toi32_i32$2 = ($4 + 328 | 0) + 9 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $8 = i64toi32_i32$0;
      $8$hi = i64toi32_i32$1;
      i64toi32_i32$0 = ($4 + 112 | 0) + 9 | 0;
      HEAP8[i64toi32_i32$0 >> 0] = $8;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $8 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $8 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $8 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      $5 = ($4 + 40 | 0) + 24 | 0;
      i64toi32_i32$2 = $4 + 353 | 0;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $32 = i64toi32_i32$1;
      i64toi32_i32$1 = $5;
      HEAP32[i64toi32_i32$1 >> 2] = $32;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      $6 = ($4 + 40 | 0) + 16 | 0;
      i64toi32_i32$2 = $4 + 345 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $39 = i64toi32_i32$0;
      i64toi32_i32$0 = $6;
      HEAP32[i64toi32_i32$0 >> 2] = $39;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      $7 = ($4 + 40 | 0) + 8 | 0;
      i64toi32_i32$1 = $8$hi;
      i64toi32_i32$0 = $7;
      HEAP32[i64toi32_i32$0 >> 2] = $8;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $4;
      i64toi32_i32$1 = HEAPU8[($4 + 329 | 0) >> 0] | 0 | ((HEAPU8[($4 + 330 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 331 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 332 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[($4 + 333 | 0) >> 0] | 0 | ((HEAPU8[($4 + 334 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 335 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 336 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $8 = i64toi32_i32$1;
      $8$hi = i64toi32_i32$0;
      i64toi32_i32$1 = $4;
      HEAP8[($4 + 113 | 0) >> 0] = $8;
      HEAP8[($4 + 114 | 0) >> 0] = $8 >>> 8 | 0;
      HEAP8[($4 + 115 | 0) >> 0] = $8 >>> 16 | 0;
      HEAP8[($4 + 116 | 0) >> 0] = $8 >>> 24 | 0;
      HEAP8[($4 + 117 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[($4 + 118 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[($4 + 119 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[($4 + 120 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      i64toi32_i32$1 = $4;
      HEAP32[($4 + 40 | 0) >> 2] = $8;
      HEAP32[($4 + 44 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $5;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $55 = i64toi32_i32$0;
      i64toi32_i32$0 = ($4 + 8 | 0) + 24 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $55;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $6;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $60 = i64toi32_i32$1;
      i64toi32_i32$1 = ($4 + 8 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $60;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $7;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $65 = i64toi32_i32$0;
      i64toi32_i32$0 = ($4 + 8 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $65;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $4;
      i64toi32_i32$1 = HEAP32[($4 + 40 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($4 + 44 | 0) >> 2] | 0;
      $68 = i64toi32_i32$1;
      i64toi32_i32$1 = $4;
      HEAP32[($4 + 8 | 0) >> 2] = $68;
      HEAP32[($4 + 12 | 0) >> 2] = i64toi32_i32$0;
      $T_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hf422f9333a8bbafa($4 + 328 | 0 | 0, $1 | 0);
      if ((HEAP32[($4 + 328 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      $5 = HEAP32[($4 + 332 | 0) >> 2] | 0;
      $T_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hf422f9333a8bbafa($4 + 328 | 0 | 0, $1 | 0);
      if ((HEAP32[($4 + 328 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$2
      }
      $6 = HEAP32[($4 + 332 | 0) >> 2] | 0;
      $cardano_serialization_lib__crypto__Ed25519Signature_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h6385501ae0da5a4b($4 + 328 | 0 | 0, $1 | 0);
      label$5 : {
       if ((HEAPU8[($4 + 328 | 0) >> 0] | 0 | 0) == (1 | 0)) {
        break label$5
       }
       memcpy($4 + 256 | 0 | 0, $4 + 328 | 0 | 1 | 0 | 0, 64 | 0) | 0;
       memcpy($4 + 184 | 0 | 0, $4 + 256 | 0 | 0, 64 | 0) | 0;
       memcpy($4 + 40 | 0 | 0, memcpy($4 + 112 | 0 | 1 | 0 | 0, $4 + 184 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
       memcpy($0 + 44 | 0 | 0, $4 + 40 | 0 | 0, 64 | 0) | 0;
       i64toi32_i32$2 = $4 + 32 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $120 = i64toi32_i32$0;
       i64toi32_i32$0 = $0 + 36 | 0;
       $25 = $120;
       HEAP8[i64toi32_i32$0 >> 0] = $25;
       HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $25 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $25 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $25 >>> 24 | 0;
       HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
       HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
       i64toi32_i32$2 = $4 + 24 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $125 = i64toi32_i32$1;
       i64toi32_i32$1 = $0 + 28 | 0;
       $26 = $125;
       HEAP8[i64toi32_i32$1 >> 0] = $26;
       HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $26 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $26 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $26 >>> 24 | 0;
       HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
       HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
       i64toi32_i32$2 = ($4 + 8 | 0) + 8 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $131 = i64toi32_i32$0;
       i64toi32_i32$0 = $0 + 20 | 0;
       $27 = $131;
       HEAP8[i64toi32_i32$0 >> 0] = $27;
       HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $27 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $27 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $27 >>> 24 | 0;
       HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
       HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
       i64toi32_i32$2 = $4;
       i64toi32_i32$1 = HEAP32[($4 + 8 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[($4 + 12 | 0) >> 2] | 0;
       $135 = i64toi32_i32$1;
       i64toi32_i32$1 = $0 + 12 | 0;
       $28 = $135;
       HEAP8[i64toi32_i32$1 >> 0] = $28;
       HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $28 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $28 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $28 >>> 24 | 0;
       HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
       HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
       HEAP32[($0 + 8 | 0) >> 2] = $6;
       HEAP32[($0 + 4 | 0) >> 2] = $5;
       HEAP32[$0 >> 2] = 0;
       break label$1;
      }
      memcpy($4 + 328 | 0 | 0, memcpy(($4 + 184 | 0) + 7 | 0 | 0, memcpy($4 + 256 | 0 | 7 | 0 | 0, ($4 + 328 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
      $1 = ($4 + 112 | 0) + 8 | 0;
      cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 328 | 0 | 0, 1052860 | 0, 5 | 0);
      memcpy($0 + 8 | 0 | 0, memcpy(($4 + 40 | 0) + 7 | 0 | 0, $1 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
      HEAP32[$0 >> 2] = 1;
      break label$1;
     }
     memcpy($4 + 328 | 0 | 0, memcpy($4 + 184 | 0 | 7 | 0 | 0, memcpy($4 + 256 | 0 | 7 | 0 | 0, ($4 + 328 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
     $1 = ($4 + 112 | 0) + 8 | 0;
     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 328 | 0 | 0, 1052827 | 0, 8 | 0);
     memcpy($0 + 8 | 0 | 0, memcpy($4 + 40 | 0 | 7 | 0 | 0, $1 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
     HEAP32[$0 >> 2] = 1;
     break label$1;
    }
    memcpy($4 + 256 | 0 | 0, ($4 + 328 | 0) + 8 | 0 | 0, 64 | 0) | 0;
    memcpy($4 + 184 | 0 | 0, $4 + 256 | 0 | 0, 64 | 0) | 0;
    memcpy($4 + 328 | 0 | 0, $4 + 184 | 0 | 0, 64 | 0) | 0;
    $1 = ($4 + 112 | 0) + 8 | 0;
    cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 328 | 0 | 0, 1052835 | 0, 15 | 0);
    memcpy($0 + 8 | 0 | 0, $1 | 0, 64 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    break label$1;
   }
   memcpy($4 + 256 | 0 | 0, ($4 + 328 | 0) + 8 | 0 | 0, 64 | 0) | 0;
   memcpy($4 + 184 | 0 | 0, $4 + 256 | 0 | 0, 64 | 0) | 0;
   memcpy($4 + 328 | 0 | 0, $4 + 184 | 0 | 0, 64 | 0) | 0;
   $1 = ($4 + 112 | 0) + 8 | 0;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 328 | 0 | 0, 1052850 | 0, 10 | 0);
   memcpy($0 + 8 | 0 | 0, $1 | 0, 64 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $4 + 400 | 0;
 }
 
 function linked_hash_map__LinkedHashMap_K_2cV_2cS___insert__h48a3e36a8942b5e6($0, $1, $2, $2$hi, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  $3 = $3 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, $6 = 0, $4 = 0, i64toi32_i32$1 = 0, $8 = 0, $7 = 0, $40 = 0, $9 = 0, $9$hi = 0, $10 = 0, $10$hi = 0, $5 = 0, $82 = 0, $82$hi = 0, $93 = 0, $93$hi = 0, $103 = 0, $103$hi = 0, $114 = 0, $114$hi = 0, $127 = 0, $134 = 0, $11 = 0, $11$hi = 0, $141 = 0, $146 = 0, $162 = 0, $170 = 0, $187 = 0, $192 = 0, $195 = 0, $199 = 0, $202 = 0, $221 = 0;
  $4 = global$0;
  $5 = $4;
  $4 = ($4 - 192 | 0) & -32 | 0;
  global$0 = $4;
  i64toi32_i32$0 = $2$hi;
  i64toi32_i32$1 = $4;
  HEAP32[($4 + 24 | 0) >> 2] = $2;
  HEAP32[($4 + 28 | 0) >> 2] = i64toi32_i32$0;
  label$1 : {
   if (HEAP32[($1 + 32 | 0) >> 2] | 0) {
    break label$1
   }
   $6 = __rust_alloc(64 | 0, 8 | 0) | 0;
   HEAP32[($1 + 32 | 0) >> 2] = $6;
   HEAP32[($6 + 60 | 0) >> 2] = $6;
   HEAP32[($6 + 56 | 0) >> 2] = $6;
  }
  HEAP32[($4 + 92 | 0) >> 2] = $4 + 24 | 0;
  i64toi32_i32$0 = hashbrown__map__make_hash__ha3ef0991d7baec61($1 | 0, $4 + 92 | 0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $2 = i64toi32_i32$0;
  $2$hi = i64toi32_i32$1;
  $7 = i64toi32_i32$0;
  $8 = (HEAP32[($1 + 16 | 0) >> 2] | 0) & i64toi32_i32$0 | 0;
  $40 = (HEAP32[($1 + 20 | 0) >> 2] | 0) + $8 | 0;
  $6 = HEAPU8[$40 >> 0] | 0 | ((HEAPU8[($40 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($40 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($40 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  HEAP32[($4 + 104 | 0) >> 2] = 0;
  HEAP32[($4 + 108 | 0) >> 2] = $6;
  HEAP32[($4 + 100 | 0) >> 2] = $8;
  HEAP32[($4 + 96 | 0) >> 2] = $1 + 16 | 0;
  $7 = i64toi32_i32$0 >>> 25 | 0;
  HEAP8[($4 + 116 | 0) >> 0] = $7;
  $6 = $6 ^ Math_imul($7, 16843009) | 0;
  HEAP32[($4 + 112 | 0) >> 2] = (($6 ^ -1 | 0) & ($6 + -16843009 | 0) | 0) & -2139062144 | 0;
  $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($4 + 16 | 0 | 0, $4 + 96 | 0 | 0);
  label$2 : {
   label$3 : {
    if (!(HEAP32[($4 + 16 | 0) >> 2] | 0)) {
     break label$3
    }
    label$4 : {
     $7 = HEAP32[($4 + 92 | 0) >> 2] | 0;
     i64toi32_i32$2 = $7;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $82 = i64toi32_i32$1;
     $82$hi = i64toi32_i32$0;
     $6 = (HEAP32[((HEAP32[($4 + 96 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) - ((HEAP32[($4 + 20 | 0) >> 2] | 0) << 3 | 0) | 0;
     i64toi32_i32$2 = HEAP32[($6 + -8 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $93 = i64toi32_i32$0;
     $93$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $82$hi;
     i64toi32_i32$2 = $82;
     i64toi32_i32$0 = $93$hi;
     i64toi32_i32$3 = $93;
     if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
      break label$4
     }
     label$5 : while (1) {
      $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($4 + 8 | 0 | 0, $4 + 96 | 0 | 0);
      if (!(HEAP32[($4 + 8 | 0) >> 2] | 0)) {
       break label$3
      }
      i64toi32_i32$3 = $7;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $103 = i64toi32_i32$2;
      $103$hi = i64toi32_i32$1;
      $6 = (HEAP32[((HEAP32[($4 + 96 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) - ((HEAP32[($4 + 12 | 0) >> 2] | 0) << 3 | 0) | 0;
      i64toi32_i32$3 = HEAP32[($6 + -8 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $114 = i64toi32_i32$1;
      $114$hi = i64toi32_i32$2;
      i64toi32_i32$2 = $103$hi;
      i64toi32_i32$3 = $103;
      i64toi32_i32$1 = $114$hi;
      i64toi32_i32$0 = $114;
      if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
       continue label$5
      }
      break label$5;
     };
    }
    $7 = $6 + -4 | 0;
    $6 = HEAP32[$7 >> 2] | 0;
    $8 = $6 + 32 | 0;
    i64toi32_i32$0 = $8;
    i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
    $9 = i64toi32_i32$3;
    $9$hi = i64toi32_i32$2;
    i64toi32_i32$0 = $3 + 24 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
    $127 = i64toi32_i32$2;
    i64toi32_i32$2 = $8;
    HEAP32[i64toi32_i32$2 >> 2] = $127;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
    $8 = $6 + 24 | 0;
    i64toi32_i32$0 = $8;
    i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
    $10 = i64toi32_i32$3;
    $10$hi = i64toi32_i32$2;
    i64toi32_i32$0 = $3;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] | 0;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] | 0;
    $134 = i64toi32_i32$2;
    i64toi32_i32$2 = $8;
    HEAP32[i64toi32_i32$2 >> 2] = $134;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
    $8 = $6 + 16 | 0;
    i64toi32_i32$0 = $8;
    i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
    $11 = i64toi32_i32$3;
    $11$hi = i64toi32_i32$2;
    i64toi32_i32$0 = $3;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] | 0;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] | 0;
    $141 = i64toi32_i32$2;
    i64toi32_i32$2 = $8;
    HEAP32[i64toi32_i32$2 >> 2] = $141;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
    i64toi32_i32$0 = $6;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] | 0;
    $2 = i64toi32_i32$3;
    $2$hi = i64toi32_i32$2;
    i64toi32_i32$0 = $3;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
    $146 = i64toi32_i32$2;
    i64toi32_i32$2 = $6;
    HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $146;
    HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$3;
    i64toi32_i32$3 = $9$hi;
    i64toi32_i32$2 = $4;
    HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] = $9;
    HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] = i64toi32_i32$3;
    i64toi32_i32$3 = $10$hi;
    HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = $10;
    HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = i64toi32_i32$3;
    i64toi32_i32$3 = $11$hi;
    HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] = $11;
    HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] = i64toi32_i32$3;
    i64toi32_i32$3 = $2$hi;
    HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] = $2;
    HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] = i64toi32_i32$3;
    $8 = $6 + 40 | 0;
    i64toi32_i32$0 = $8;
    i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
    $9 = i64toi32_i32$3;
    $9$hi = i64toi32_i32$2;
    i64toi32_i32$0 = $3 + 32 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
    $162 = i64toi32_i32$2;
    i64toi32_i32$2 = $8;
    HEAP32[i64toi32_i32$2 >> 2] = $162;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
    $6 = $6 + 48 | 0;
    i64toi32_i32$0 = $6;
    i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
    $10 = i64toi32_i32$3;
    $10$hi = i64toi32_i32$2;
    i64toi32_i32$0 = $3 + 40 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
    $170 = i64toi32_i32$2;
    i64toi32_i32$2 = $6;
    HEAP32[i64toi32_i32$2 >> 2] = $170;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
    $6 = ($4 + 144 | 0) + 8 | 0;
    i64toi32_i32$3 = $10$hi;
    i64toi32_i32$2 = $6;
    HEAP32[i64toi32_i32$2 >> 2] = $10;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
    i64toi32_i32$3 = $9$hi;
    i64toi32_i32$2 = $4;
    HEAP32[(i64toi32_i32$2 + 144 | 0) >> 2] = $9;
    HEAP32[(i64toi32_i32$2 + 148 | 0) >> 2] = i64toi32_i32$3;
    HEAP32[((i64toi32_i32$2 + 96 | 0) + 24 | 0) >> 2] = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
    i64toi32_i32$0 = i64toi32_i32$2;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
    $187 = i64toi32_i32$3;
    i64toi32_i32$3 = (i64toi32_i32$0 + 96 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$3 >> 2] = $187;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 44 | 0) >> 2] | 0;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 48 | 0) >> 2] | 0;
    $192 = i64toi32_i32$2;
    i64toi32_i32$2 = (i64toi32_i32$0 + 96 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $192;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 36 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 40 | 0) >> 2] | 0;
    $195 = i64toi32_i32$3;
    i64toi32_i32$3 = i64toi32_i32$0;
    HEAP32[(i64toi32_i32$3 + 96 | 0) >> 2] = $195;
    HEAP32[(i64toi32_i32$3 + 100 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$0 = $6;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
    $199 = i64toi32_i32$2;
    i64toi32_i32$2 = $4 + 132 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $199;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
    i64toi32_i32$0 = $4;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 144 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 148 | 0) >> 2] | 0;
    $202 = i64toi32_i32$3;
    i64toi32_i32$3 = i64toi32_i32$0;
    HEAP32[(i64toi32_i32$3 + 124 | 0) >> 2] = $202;
    HEAP32[(i64toi32_i32$3 + 128 | 0) >> 2] = i64toi32_i32$2;
    $6 = HEAP32[$7 >> 2] | 0;
    memcpy(i64toi32_i32$3 + 32 | 0 | 0, i64toi32_i32$3 + 96 | 0 | 0, 44 | 0) | 0;
    i64toi32_i32$2 = $2$hi;
    $3 = $2;
    break label$2;
   }
   label$6 : {
    $6 = HEAP32[($1 + 36 | 0) >> 2] | 0;
    if (!$6) {
     break label$6
    }
    HEAP32[($1 + 36 | 0) >> 2] = HEAP32[($6 + 56 | 0) >> 2] | 0;
    i64toi32_i32$0 = $4;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] | 0;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] | 0;
    $221 = i64toi32_i32$2;
    i64toi32_i32$2 = $6;
    HEAP32[i64toi32_i32$2 >> 2] = $221;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
    memcpy(i64toi32_i32$2 + 8 | 0 | 0, $3 | 0, 48 | 0) | 0;
    i64toi32_i32$3 = 0;
    HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] = 0;
    HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] = i64toi32_i32$3;
    $3 = 5;
    break label$2;
   }
   i64toi32_i32$0 = $4;
   i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] | 0;
   $2 = i64toi32_i32$3;
   $2$hi = i64toi32_i32$2;
   label$7 : {
    $6 = __rust_alloc(64 | 0, 8 | 0) | 0;
    if (!$6) {
     break label$7
    }
    i64toi32_i32$2 = $2$hi;
    i64toi32_i32$3 = $6;
    HEAP32[i64toi32_i32$3 >> 2] = $2;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
    memcpy(i64toi32_i32$3 + 8 | 0 | 0, $3 | 0, 48 | 0) | 0;
    i64toi32_i32$2 = 0;
    HEAP32[(i64toi32_i32$3 + 56 | 0) >> 2] = 0;
    HEAP32[(i64toi32_i32$3 + 60 | 0) >> 2] = i64toi32_i32$2;
    $3 = 5;
    break label$2;
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(64 | 0, 8 | 0);
   abort();
  }
  memcpy($4 + 96 | 0 | 0, $4 + 32 | 0 | 0, 44 | 0) | 0;
  label$8 : {
   label$9 : {
    if (($3 | 0) != (5 | 0)) {
     break label$9
    }
    hashbrown__map__HashMap_K_2cV_2cS_2cA___insert__h7f5a811fd689cb87($4 | 0, $1 | 0, $6 | 0, $6 | 0);
    $1 = HEAP32[($1 + 32 | 0) >> 2] | 0;
    $7 = HEAP32[($1 + 56 | 0) >> 2] | 0;
    HEAP32[($6 + 60 | 0) >> 2] = $1;
    HEAP32[($6 + 56 | 0) >> 2] = $7;
    $1 = $1 + 56 | 0;
    break label$8;
   }
   HEAP32[((HEAP32[($6 + 60 | 0) >> 2] | 0) + 56 | 0) >> 2] = HEAP32[($6 + 56 | 0) >> 2] | 0;
   HEAP32[((HEAP32[($6 + 56 | 0) >> 2] | 0) + 60 | 0) >> 2] = HEAP32[($6 + 60 | 0) >> 2] | 0;
   $1 = HEAP32[($1 + 32 | 0) >> 2] | 0;
   $7 = HEAP32[($1 + 56 | 0) >> 2] | 0;
   HEAP32[($6 + 60 | 0) >> 2] = $1;
   HEAP32[($6 + 56 | 0) >> 2] = $7;
   $1 = $1 + 56 | 0;
  }
  HEAP32[$1 >> 2] = $6;
  HEAP32[$0 >> 2] = $3;
  HEAP32[((HEAP32[($6 + 56 | 0) >> 2] | 0) + 60 | 0) >> 2] = $6;
  memcpy($0 + 4 | 0 | 0, $4 + 96 | 0 | 0, 44 | 0) | 0;
  global$0 = $5;
 }
 
 function cryptoxide__curve25519__ge__Ge__from_bytes__hef188e306ddf7e48($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, $2 = 0, i64toi32_i32$0 = 0, $6 = 0, $6$hi = 0, i64toi32_i32$6 = 0, $5 = 0, $5$hi = 0, $84 = 0, $85 = 0, $86 = 0, $87 = 0, $88 = 0, $89 = 0, $90 = 0, $91 = 0, $92 = 0, $93 = 0, $4 = 0, $95 = 0, $97 = 0, $97$hi = 0, $99 = 0, $99$hi = 0, $100 = 0, $100$hi = 0, $102 = 0, $102$hi = 0, $104 = 0, $104$hi = 0, $107$hi = 0, $110 = 0, $111 = 0, $113 = 0, $113$hi = 0, $115 = 0, $115$hi = 0, $116 = 0, $116$hi = 0, $118$hi = 0, $122 = 0, $124 = 0, $124$hi = 0, $126 = 0, $126$hi = 0, $127 = 0, $127$hi = 0, $129$hi = 0, $133 = 0, $135 = 0, $135$hi = 0, $137 = 0, $137$hi = 0, $138 = 0, $138$hi = 0, $140$hi = 0, $143 = 0, $144 = 0, $147 = 0, $147$hi = 0, $149 = 0, $149$hi = 0, $179 = 0, $181 = 0, $181$hi = 0, $184$hi = 0, $186 = 0, $186$hi = 0, $191 = 0, $193$hi = 0, $195 = 0, $195$hi = 0, $199 = 0, $200 = 0, $202$hi = 0, $204 = 0, $204$hi = 0, $209 = 0, $211$hi = 0, $213 = 0, $213$hi = 0, $217 = 0, $218 = 0, $221 = 0, $221$hi = 0, $223 = 0, $223$hi = 0, $3 = 0;
  $2 = global$0 - 720 | 0;
  global$0 = $2;
  cryptoxide__curve25519__fe__fe64__Fe__from_bytes__h171daceb70a08089($2 + 80 | 0 | 0, $1 | 0);
  cryptoxide__curve25519__fe__fe64__Fe__square__h72fd8a55cd006328($2 + 120 | 0 | 0, $2 + 80 | 0 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Sub___sub__h676cb1e5fa77fb70($2 + 160 | 0 | 0, $2 + 120 | 0 | 0, 1103152 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($2 + 480 | 0 | 0, $2 + 120 | 0 | 0, 1103192 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Add___add__he826ef0e90fce416($2 + 200 | 0 | 0, $2 + 480 | 0 | 0, 1103152 | 0);
  cryptoxide__curve25519__fe__fe64__Fe__square__h72fd8a55cd006328($2 + 480 | 0 | 0, $2 + 200 | 0 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($2 + 240 | 0 | 0, $2 + 480 | 0 | 0, $2 + 200 | 0 | 0);
  cryptoxide__curve25519__fe__fe64__Fe__square__h72fd8a55cd006328($2 + 480 | 0 | 0, $2 + 240 | 0 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($2 + 280 | 0 | 0, $2 + 480 | 0 | 0, $2 + 200 | 0 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($2 + 320 | 0 | 0, $2 + 280 | 0 | 0, $2 + 160 | 0 | 0);
  cryptoxide__curve25519__fe___impl_20cryptoxide__curve25519__fe__fe64__Fe___pow25523__h155bb8902fd1dd34($2 + 480 | 0 | 0, $2 + 320 | 0 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($2 + 640 | 0 | 0, $2 + 480 | 0 | 0, $2 + 240 | 0 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($2 + 360 | 0 | 0, $2 + 640 | 0 | 0, $2 + 160 | 0 | 0);
  cryptoxide__curve25519__fe__fe64__Fe__square__h72fd8a55cd006328($2 + 480 | 0 | 0, $2 + 360 | 0 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($2 + 400 | 0 | 0, $2 + 480 | 0 | 0, $2 + 200 | 0 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Sub___sub__h676cb1e5fa77fb70($2 + 440 | 0 | 0, $2 + 400 | 0 | 0, $2 + 160 | 0 | 0);
  cryptoxide__curve25519__fe__fe64__Fe__to_bytes__h64ae4f7608fd99b8($2 + 480 | 0 | 0, $2 + 440 | 0 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     i64toi32_i32$0 = $__5bu8_3b_20N_5d_20as_20cryptoxide__constant_time__CtEqual___ct_eq__hde8501fb60eb5442($2 + 480 | 0 | 0, 1138100 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     i64toi32_i32$2 = i64toi32_i32$0;
     i64toi32_i32$0 = 0;
     i64toi32_i32$3 = 0;
     if ((i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$0 | 0) | 0) {
      break label$3
     }
     $95 = $2;
     i64toi32_i32$3 = $2;
     i64toi32_i32$2 = HEAP32[($2 + 168 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 172 | 0) >> 2] | 0;
     $97 = i64toi32_i32$2;
     $97$hi = i64toi32_i32$1;
     i64toi32_i32$3 = $2;
     i64toi32_i32$1 = HEAP32[($2 + 408 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[($2 + 412 | 0) >> 2] | 0;
     $99 = i64toi32_i32$1;
     $99$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $97$hi;
     i64toi32_i32$3 = $97;
     i64toi32_i32$1 = $99$hi;
     i64toi32_i32$0 = $99;
     i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $100 = i64toi32_i32$4;
     $100$hi = i64toi32_i32$5;
     i64toi32_i32$2 = $2;
     i64toi32_i32$5 = HEAP32[($2 + 160 | 0) >> 2] | 0;
     i64toi32_i32$3 = HEAP32[($2 + 164 | 0) >> 2] | 0;
     $102 = i64toi32_i32$5;
     $102$hi = i64toi32_i32$3;
     i64toi32_i32$3 = HEAP32[($2 + 400 | 0) >> 2] | 0;
     i64toi32_i32$5 = HEAP32[($2 + 404 | 0) >> 2] | 0;
     $104 = i64toi32_i32$3;
     $104$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $102$hi;
     i64toi32_i32$2 = $102;
     i64toi32_i32$3 = $104$hi;
     i64toi32_i32$0 = $104;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$0 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $5 = i64toi32_i32$1;
     $5$hi = i64toi32_i32$4;
     i64toi32_i32$5 = i64toi32_i32$1;
     i64toi32_i32$2 = 0;
     i64toi32_i32$0 = 51;
     i64toi32_i32$3 = i64toi32_i32$0 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
      i64toi32_i32$2 = 0;
      $84 = i64toi32_i32$4 >>> i64toi32_i32$3 | 0;
     } else {
      i64toi32_i32$2 = i64toi32_i32$4 >>> i64toi32_i32$3 | 0;
      $84 = (((1 << i64toi32_i32$3 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$3 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$3 | 0) | 0;
     }
     $107$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $100$hi;
     i64toi32_i32$4 = $100;
     i64toi32_i32$5 = $107$hi;
     i64toi32_i32$0 = $84;
     i64toi32_i32$3 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$3 >>> 0 < i64toi32_i32$0 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $6 = i64toi32_i32$3;
     $6$hi = i64toi32_i32$1;
     i64toi32_i32$2 = i64toi32_i32$3;
     i64toi32_i32$4 = 524287;
     i64toi32_i32$0 = -1;
     i64toi32_i32$4 = i64toi32_i32$1 & i64toi32_i32$4 | 0;
     $110 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
     i64toi32_i32$2 = $95;
     HEAP32[(i64toi32_i32$2 + 648 | 0) >> 2] = $110;
     HEAP32[(i64toi32_i32$2 + 652 | 0) >> 2] = i64toi32_i32$4;
     $111 = $2;
     i64toi32_i32$1 = $2;
     i64toi32_i32$4 = HEAP32[($2 + 176 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[($2 + 180 | 0) >> 2] | 0;
     $113 = i64toi32_i32$4;
     $113$hi = i64toi32_i32$2;
     i64toi32_i32$1 = $2;
     i64toi32_i32$2 = HEAP32[($2 + 416 | 0) >> 2] | 0;
     i64toi32_i32$4 = HEAP32[($2 + 420 | 0) >> 2] | 0;
     $115 = i64toi32_i32$2;
     $115$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $113$hi;
     i64toi32_i32$1 = $113;
     i64toi32_i32$2 = $115$hi;
     i64toi32_i32$0 = $115;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
     i64toi32_i32$3 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$0 >>> 0) {
      i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
     }
     $116 = i64toi32_i32$5;
     $116$hi = i64toi32_i32$3;
     i64toi32_i32$3 = $6$hi;
     i64toi32_i32$4 = $6;
     i64toi32_i32$1 = 0;
     i64toi32_i32$0 = 51;
     i64toi32_i32$2 = i64toi32_i32$0 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
      i64toi32_i32$1 = 0;
      $85 = i64toi32_i32$3 >>> i64toi32_i32$2 | 0;
     } else {
      i64toi32_i32$1 = i64toi32_i32$3 >>> i64toi32_i32$2 | 0;
      $85 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$2 | 0) | 0;
     }
     $118$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $116$hi;
     i64toi32_i32$3 = $116;
     i64toi32_i32$4 = $118$hi;
     i64toi32_i32$0 = $85;
     i64toi32_i32$2 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$0 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $6 = i64toi32_i32$2;
     $6$hi = i64toi32_i32$5;
     i64toi32_i32$1 = i64toi32_i32$2;
     i64toi32_i32$3 = 524287;
     i64toi32_i32$0 = -1;
     i64toi32_i32$3 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     i64toi32_i32$1 = $111;
     HEAP32[(i64toi32_i32$1 + 656 | 0) >> 2] = i64toi32_i32$2 & i64toi32_i32$0 | 0;
     HEAP32[(i64toi32_i32$1 + 660 | 0) >> 2] = i64toi32_i32$3;
     $122 = $2;
     i64toi32_i32$5 = $2;
     i64toi32_i32$3 = HEAP32[($2 + 184 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 188 | 0) >> 2] | 0;
     $124 = i64toi32_i32$3;
     $124$hi = i64toi32_i32$1;
     i64toi32_i32$5 = $2;
     i64toi32_i32$1 = HEAP32[($2 + 424 | 0) >> 2] | 0;
     i64toi32_i32$3 = HEAP32[($2 + 428 | 0) >> 2] | 0;
     $126 = i64toi32_i32$1;
     $126$hi = i64toi32_i32$3;
     i64toi32_i32$3 = $124$hi;
     i64toi32_i32$5 = $124;
     i64toi32_i32$1 = $126$hi;
     i64toi32_i32$0 = $126;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
     i64toi32_i32$2 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $127 = i64toi32_i32$4;
     $127$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$3 = $6;
     i64toi32_i32$5 = 0;
     i64toi32_i32$0 = 51;
     i64toi32_i32$1 = i64toi32_i32$0 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
      i64toi32_i32$5 = 0;
      $86 = i64toi32_i32$2 >>> i64toi32_i32$1 | 0;
     } else {
      i64toi32_i32$5 = i64toi32_i32$2 >>> i64toi32_i32$1 | 0;
      $86 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$1 | 0) | 0;
     }
     $129$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $127$hi;
     i64toi32_i32$2 = $127;
     i64toi32_i32$3 = $129$hi;
     i64toi32_i32$0 = $86;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$0 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $6 = i64toi32_i32$1;
     $6$hi = i64toi32_i32$4;
     i64toi32_i32$5 = i64toi32_i32$1;
     i64toi32_i32$2 = 524287;
     i64toi32_i32$0 = -1;
     i64toi32_i32$2 = i64toi32_i32$4 & i64toi32_i32$2 | 0;
     i64toi32_i32$5 = $122;
     HEAP32[(i64toi32_i32$5 + 664 | 0) >> 2] = i64toi32_i32$1 & i64toi32_i32$0 | 0;
     HEAP32[(i64toi32_i32$5 + 668 | 0) >> 2] = i64toi32_i32$2;
     $133 = $2;
     i64toi32_i32$4 = $2;
     i64toi32_i32$2 = HEAP32[($2 + 192 | 0) >> 2] | 0;
     i64toi32_i32$5 = HEAP32[($2 + 196 | 0) >> 2] | 0;
     $135 = i64toi32_i32$2;
     $135$hi = i64toi32_i32$5;
     i64toi32_i32$4 = $2;
     i64toi32_i32$5 = HEAP32[($2 + 432 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[($2 + 436 | 0) >> 2] | 0;
     $137 = i64toi32_i32$5;
     $137$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $135$hi;
     i64toi32_i32$4 = $135;
     i64toi32_i32$5 = $137$hi;
     i64toi32_i32$0 = $137;
     i64toi32_i32$3 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$3 >>> 0 < i64toi32_i32$0 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $138 = i64toi32_i32$3;
     $138$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$2 = $6;
     i64toi32_i32$4 = 0;
     i64toi32_i32$0 = 51;
     i64toi32_i32$5 = i64toi32_i32$0 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
      i64toi32_i32$4 = 0;
      $87 = i64toi32_i32$1 >>> i64toi32_i32$5 | 0;
     } else {
      i64toi32_i32$4 = i64toi32_i32$1 >>> i64toi32_i32$5 | 0;
      $87 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$5 | 0) | 0;
     }
     $140$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $138$hi;
     i64toi32_i32$1 = $138;
     i64toi32_i32$2 = $140$hi;
     i64toi32_i32$0 = $87;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
     i64toi32_i32$3 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$0 >>> 0) {
      i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
     }
     $6 = i64toi32_i32$5;
     $6$hi = i64toi32_i32$3;
     i64toi32_i32$4 = i64toi32_i32$5;
     i64toi32_i32$1 = 524287;
     i64toi32_i32$0 = -1;
     i64toi32_i32$1 = i64toi32_i32$3 & i64toi32_i32$1 | 0;
     $143 = i64toi32_i32$4 & i64toi32_i32$0 | 0;
     i64toi32_i32$4 = $133;
     HEAP32[(i64toi32_i32$4 + 672 | 0) >> 2] = $143;
     HEAP32[(i64toi32_i32$4 + 676 | 0) >> 2] = i64toi32_i32$1;
     $144 = $2;
     i64toi32_i32$1 = i64toi32_i32$3;
     i64toi32_i32$1 = i64toi32_i32$3;
     i64toi32_i32$3 = i64toi32_i32$5;
     i64toi32_i32$4 = 0;
     i64toi32_i32$0 = 51;
     i64toi32_i32$2 = i64toi32_i32$0 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
      i64toi32_i32$4 = 0;
      $88 = i64toi32_i32$1 >>> i64toi32_i32$2 | 0;
     } else {
      i64toi32_i32$4 = i64toi32_i32$1 >>> i64toi32_i32$2 | 0;
      $88 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$2 | 0) | 0;
     }
     i64toi32_i32$3 = 0;
     i64toi32_i32$3 = __wasm_i64_mul($88 | 0, i64toi32_i32$4 | 0, 19 | 0, i64toi32_i32$3 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $147 = i64toi32_i32$3;
     $147$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $5$hi;
     i64toi32_i32$1 = $5;
     i64toi32_i32$3 = 524287;
     i64toi32_i32$0 = -1;
     i64toi32_i32$3 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
     $149 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
     $149$hi = i64toi32_i32$3;
     i64toi32_i32$3 = $147$hi;
     i64toi32_i32$4 = $147;
     i64toi32_i32$1 = $149$hi;
     i64toi32_i32$0 = $149;
     i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
     i64toi32_i32$5 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$0 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     i64toi32_i32$4 = $144;
     HEAP32[(i64toi32_i32$4 + 640 | 0) >> 2] = i64toi32_i32$2;
     HEAP32[(i64toi32_i32$4 + 644 | 0) >> 2] = i64toi32_i32$5;
     cryptoxide__curve25519__fe__fe64__Fe__to_bytes__h64ae4f7608fd99b8($2 + 480 | 0 | 0, $2 + 640 | 0 | 0);
     i64toi32_i32$5 = $__5bu8_3b_20N_5d_20as_20cryptoxide__constant_time__CtEqual___ct_eq__hde8501fb60eb5442($2 + 480 | 0 | 0, 1138100 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     if (!(i64toi32_i32$5 | i64toi32_i32$4 | 0)) {
      break label$2
     }
     $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($2 + 480 | 0 | 0, $2 + 360 | 0 | 0, 1103232 | 0);
     memcpy($2 + 360 | 0 | 0, $2 + 480 | 0 | 0, 40 | 0) | 0;
    }
    cryptoxide__curve25519__fe__fe64__Fe__to_packed__h856c6b32110c5ed6($2 + 480 | 0 | 0, $2 + 360 | 0 | 0);
    label$4 : {
     if (((HEAP32[($2 + 480 | 0) >> 2] | 0) & 1 | 0 | 0) == ((HEAP8[($1 + 31 | 0) >> 0] | 0 | 0) > (-1 | 0) | 0)) {
      break label$4
     }
     $179 = $2;
     i64toi32_i32$3 = $2;
     i64toi32_i32$4 = HEAP32[($2 + 360 | 0) >> 2] | 0;
     i64toi32_i32$5 = HEAP32[($2 + 364 | 0) >> 2] | 0;
     $181 = i64toi32_i32$4;
     $181$hi = i64toi32_i32$5;
     i64toi32_i32$5 = 2097151;
     i64toi32_i32$3 = -76;
     i64toi32_i32$4 = $181$hi;
     i64toi32_i32$0 = $181;
     i64toi32_i32$1 = i64toi32_i32$3 - i64toi32_i32$0 | 0;
     i64toi32_i32$6 = i64toi32_i32$3 >>> 0 < i64toi32_i32$0 >>> 0;
     i64toi32_i32$2 = i64toi32_i32$6 + i64toi32_i32$4 | 0;
     i64toi32_i32$2 = i64toi32_i32$5 - i64toi32_i32$2 | 0;
     $5 = i64toi32_i32$1;
     $5$hi = i64toi32_i32$2;
     i64toi32_i32$5 = i64toi32_i32$1;
     i64toi32_i32$3 = 0;
     i64toi32_i32$0 = 51;
     i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
      i64toi32_i32$3 = 0;
      $89 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
     } else {
      i64toi32_i32$3 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
      $89 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$4 | 0) | 0;
     }
     $184$hi = i64toi32_i32$3;
     i64toi32_i32$2 = $2;
     i64toi32_i32$3 = HEAP32[($2 + 368 | 0) >> 2] | 0;
     i64toi32_i32$5 = HEAP32[($2 + 372 | 0) >> 2] | 0;
     $186 = i64toi32_i32$3;
     $186$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $184$hi;
     i64toi32_i32$2 = $89;
     i64toi32_i32$3 = $186$hi;
     i64toi32_i32$0 = $186;
     i64toi32_i32$4 = i64toi32_i32$2 - i64toi32_i32$0 | 0;
     i64toi32_i32$6 = i64toi32_i32$2 >>> 0 < i64toi32_i32$0 >>> 0;
     i64toi32_i32$1 = i64toi32_i32$6 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$5 - i64toi32_i32$1 | 0;
     i64toi32_i32$5 = i64toi32_i32$4;
     i64toi32_i32$2 = 2097151;
     i64toi32_i32$0 = -4;
     i64toi32_i32$3 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
     i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$3 >>> 0 < i64toi32_i32$0 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $6 = i64toi32_i32$3;
     $6$hi = i64toi32_i32$4;
     i64toi32_i32$1 = i64toi32_i32$3;
     i64toi32_i32$5 = 524287;
     i64toi32_i32$0 = -1;
     i64toi32_i32$5 = i64toi32_i32$4 & i64toi32_i32$5 | 0;
     i64toi32_i32$1 = $179;
     HEAP32[(i64toi32_i32$1 + 368 | 0) >> 2] = i64toi32_i32$3 & i64toi32_i32$0 | 0;
     HEAP32[(i64toi32_i32$1 + 372 | 0) >> 2] = i64toi32_i32$5;
     $191 = $2;
     i64toi32_i32$5 = i64toi32_i32$4;
     i64toi32_i32$5 = i64toi32_i32$4;
     i64toi32_i32$4 = i64toi32_i32$3;
     i64toi32_i32$1 = 0;
     i64toi32_i32$0 = 51;
     i64toi32_i32$2 = i64toi32_i32$0 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
      i64toi32_i32$1 = 0;
      $90 = i64toi32_i32$5 >>> i64toi32_i32$2 | 0;
     } else {
      i64toi32_i32$1 = i64toi32_i32$5 >>> i64toi32_i32$2 | 0;
      $90 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$2 | 0) | 0;
     }
     $193$hi = i64toi32_i32$1;
     i64toi32_i32$5 = $2;
     i64toi32_i32$1 = HEAP32[($2 + 376 | 0) >> 2] | 0;
     i64toi32_i32$4 = HEAP32[($2 + 380 | 0) >> 2] | 0;
     $195 = i64toi32_i32$1;
     $195$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $193$hi;
     i64toi32_i32$5 = $90;
     i64toi32_i32$1 = $195$hi;
     i64toi32_i32$0 = $195;
     i64toi32_i32$2 = i64toi32_i32$5 - i64toi32_i32$0 | 0;
     i64toi32_i32$6 = i64toi32_i32$5 >>> 0 < i64toi32_i32$0 >>> 0;
     i64toi32_i32$3 = i64toi32_i32$6 + i64toi32_i32$1 | 0;
     i64toi32_i32$3 = i64toi32_i32$4 - i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$2;
     i64toi32_i32$5 = 2097151;
     i64toi32_i32$0 = -4;
     i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
     i64toi32_i32$2 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$0 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $6 = i64toi32_i32$1;
     $6$hi = i64toi32_i32$2;
     i64toi32_i32$3 = i64toi32_i32$1;
     i64toi32_i32$4 = 524287;
     i64toi32_i32$0 = -1;
     i64toi32_i32$4 = i64toi32_i32$2 & i64toi32_i32$4 | 0;
     $199 = i64toi32_i32$3 & i64toi32_i32$0 | 0;
     i64toi32_i32$3 = $191;
     HEAP32[(i64toi32_i32$3 + 376 | 0) >> 2] = $199;
     HEAP32[(i64toi32_i32$3 + 380 | 0) >> 2] = i64toi32_i32$4;
     $200 = $2;
     i64toi32_i32$4 = i64toi32_i32$2;
     i64toi32_i32$4 = i64toi32_i32$2;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$3 = 0;
     i64toi32_i32$0 = 51;
     i64toi32_i32$5 = i64toi32_i32$0 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
      i64toi32_i32$3 = 0;
      $91 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
     } else {
      i64toi32_i32$3 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
      $91 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$5 | 0) | 0;
     }
     $202$hi = i64toi32_i32$3;
     i64toi32_i32$4 = $2;
     i64toi32_i32$3 = HEAP32[($2 + 384 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[($2 + 388 | 0) >> 2] | 0;
     $204 = i64toi32_i32$3;
     $204$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $202$hi;
     i64toi32_i32$4 = $91;
     i64toi32_i32$3 = $204$hi;
     i64toi32_i32$0 = $204;
     i64toi32_i32$5 = i64toi32_i32$4 - i64toi32_i32$0 | 0;
     i64toi32_i32$6 = i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0;
     i64toi32_i32$1 = i64toi32_i32$6 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$2 - i64toi32_i32$1 | 0;
     i64toi32_i32$2 = i64toi32_i32$5;
     i64toi32_i32$4 = 2097151;
     i64toi32_i32$0 = -4;
     i64toi32_i32$3 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
     if (i64toi32_i32$3 >>> 0 < i64toi32_i32$0 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $6 = i64toi32_i32$3;
     $6$hi = i64toi32_i32$5;
     i64toi32_i32$1 = i64toi32_i32$3;
     i64toi32_i32$2 = 524287;
     i64toi32_i32$0 = -1;
     i64toi32_i32$2 = i64toi32_i32$5 & i64toi32_i32$2 | 0;
     i64toi32_i32$1 = $200;
     HEAP32[(i64toi32_i32$1 + 384 | 0) >> 2] = i64toi32_i32$3 & i64toi32_i32$0 | 0;
     HEAP32[(i64toi32_i32$1 + 388 | 0) >> 2] = i64toi32_i32$2;
     $209 = $2;
     i64toi32_i32$2 = i64toi32_i32$5;
     i64toi32_i32$5 = i64toi32_i32$3;
     i64toi32_i32$1 = 0;
     i64toi32_i32$0 = 51;
     i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
      i64toi32_i32$1 = 0;
      $92 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
     } else {
      i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
      $92 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$4 | 0) | 0;
     }
     $211$hi = i64toi32_i32$1;
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAP32[($2 + 392 | 0) >> 2] | 0;
     i64toi32_i32$5 = HEAP32[($2 + 396 | 0) >> 2] | 0;
     $213 = i64toi32_i32$1;
     $213$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $211$hi;
     i64toi32_i32$2 = $92;
     i64toi32_i32$1 = $213$hi;
     i64toi32_i32$0 = $213;
     i64toi32_i32$4 = i64toi32_i32$2 - i64toi32_i32$0 | 0;
     i64toi32_i32$6 = i64toi32_i32$2 >>> 0 < i64toi32_i32$0 >>> 0;
     i64toi32_i32$3 = i64toi32_i32$6 + i64toi32_i32$1 | 0;
     i64toi32_i32$3 = i64toi32_i32$5 - i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$4;
     i64toi32_i32$2 = 2097151;
     i64toi32_i32$0 = -4;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
     i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$0 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $6 = i64toi32_i32$1;
     $6$hi = i64toi32_i32$4;
     i64toi32_i32$3 = i64toi32_i32$1;
     i64toi32_i32$5 = 524287;
     i64toi32_i32$0 = -1;
     i64toi32_i32$5 = i64toi32_i32$4 & i64toi32_i32$5 | 0;
     $217 = i64toi32_i32$3 & i64toi32_i32$0 | 0;
     i64toi32_i32$3 = $209;
     HEAP32[(i64toi32_i32$3 + 392 | 0) >> 2] = $217;
     HEAP32[(i64toi32_i32$3 + 396 | 0) >> 2] = i64toi32_i32$5;
     $218 = $2;
     i64toi32_i32$5 = i64toi32_i32$4;
     i64toi32_i32$5 = i64toi32_i32$4;
     i64toi32_i32$4 = i64toi32_i32$1;
     i64toi32_i32$3 = 0;
     i64toi32_i32$0 = 51;
     i64toi32_i32$2 = i64toi32_i32$0 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
      i64toi32_i32$3 = 0;
      $93 = i64toi32_i32$5 >>> i64toi32_i32$2 | 0;
     } else {
      i64toi32_i32$3 = i64toi32_i32$5 >>> i64toi32_i32$2 | 0;
      $93 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$2 | 0) | 0;
     }
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_i64_mul($93 | 0, i64toi32_i32$3 | 0, 19 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$3 = i64toi32_i32$HIGH_BITS;
     $221 = i64toi32_i32$4;
     $221$hi = i64toi32_i32$3;
     i64toi32_i32$3 = $5$hi;
     i64toi32_i32$5 = $5;
     i64toi32_i32$4 = 524287;
     i64toi32_i32$0 = -1;
     i64toi32_i32$4 = i64toi32_i32$3 & i64toi32_i32$4 | 0;
     $223 = i64toi32_i32$5 & i64toi32_i32$0 | 0;
     $223$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $221$hi;
     i64toi32_i32$3 = $221;
     i64toi32_i32$5 = $223$hi;
     i64toi32_i32$0 = $223;
     i64toi32_i32$2 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$0 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     i64toi32_i32$3 = $218;
     HEAP32[(i64toi32_i32$3 + 360 | 0) >> 2] = i64toi32_i32$2;
     HEAP32[(i64toi32_i32$3 + 364 | 0) >> 2] = i64toi32_i32$1;
    }
    memcpy($2 + 480 | 0 | 0, $2 + 360 | 0 | 0, 40 | 0) | 0;
    $3 = memcpy(($2 + 480 | 0) + 40 | 0 | 0, $2 + 80 | 0 | 0, 40 | 0) | 0;
    $1 = memcpy($2 | 0, $2 + 480 | 0 | 0, 80 | 0) | 0;
    memcpy($1 + 640 | 0 | 0, $1 | 0, 80 | 0) | 0;
    $4 = ($1 + 640 | 0) + 40 | 0;
    $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($1 + 600 | 0 | 0, $1 + 640 | 0 | 0, $4 | 0);
    memcpy($1 + 480 | 0 | 0, $1 + 640 | 0 | 0, 40 | 0) | 0;
    memcpy($3 | 0, $4 | 0, 40 | 0) | 0;
    memcpy(($1 + 480 | 0) + 80 | 0 | 0, 1103152 | 0, 40 | 0) | 0;
    memcpy($0 + 8 | 0 | 0, $1 + 480 | 0 | 0, 160 | 0) | 0;
    i64toi32_i32$1 = 0;
    $5 = 1;
    $5$hi = i64toi32_i32$1;
    break label$1;
   }
   i64toi32_i32$1 = 0;
   $5 = 0;
   $5$hi = i64toi32_i32$1;
  }
  i64toi32_i32$1 = $5$hi;
  i64toi32_i32$3 = $0;
  HEAP32[i64toi32_i32$3 >> 2] = $5;
  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $2 + 720 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__PoolParams___deserialize__h06f7cbac47e8a2a7($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $6 = 0, $3 = 0, $6$hi = 0, $7 = 0, $7$hi = 0, $37 = 0, $38 = 0, $39 = 0, $40 = 0, $41 = 0, $42 = 0, $43 = 0, $45 = 0, $46 = 0, $47 = 0, $4 = 0, $5 = 0, $48 = 0, $49 = 0, $50 = 0, $44 = 0, $52 = 0, $65 = 0, $108 = 0, $115 = 0, $119 = 0, $155 = 0, $155$hi = 0, $158 = 0, $158$hi = 0, $162$hi = 0, $164$hi = 0, $166$hi = 0, $169 = 0, $169$hi = 0, $193 = 0, $199 = 0, $203 = 0, $219 = 0, $223 = 0, $229 = 0, $235 = 0;
  $2 = global$0 - 400 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 176 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 184 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 188 | 0) >> 2] | 0;
  $6 = i64toi32_i32$0;
  $6$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 176 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 180 | 0) >> 2] | 0;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 1;
      if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
       break label$4
      }
      i64toi32_i32$2 = $6$hi;
      i64toi32_i32$0 = i64toi32_i32$2;
      cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__PoolParams___deserialize_as_embedded_group__he3f2f174b1ace167($2 + 176 | 0 | 0, $1 | 0, $6 | 0, i64toi32_i32$2 | 0, $6 | 0, i64toi32_i32$2 | 0);
      label$5 : {
       label$6 : {
        label$7 : {
         i64toi32_i32$0 = i64toi32_i32$2;
         i64toi32_i32$0 = i64toi32_i32$2;
         i64toi32_i32$3 = $6;
         i64toi32_i32$2 = 0;
         i64toi32_i32$1 = 1;
         if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) | 0) {
          break label$7
         }
         cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 8 | 0 | 0, $1 | 0);
         $3 = HEAPU8[($2 + 16 | 0) >> 0] | 0;
         i64toi32_i32$1 = $2;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] | 0;
         i64toi32_i32$1 = i64toi32_i32$3;
         i64toi32_i32$3 = 0;
         i64toi32_i32$2 = 1;
         if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) | 0) {
          break label$6
         }
         $1 = 5;
         if (($3 & 255 | 0 | 0) != (5 | 0)) {
          break label$5
         }
        }
        $4 = $2 + 160 | 0;
        i64toi32_i32$2 = ($2 + 176 | 0) + 40 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $44 = i64toi32_i32$1;
        i64toi32_i32$1 = $4;
        HEAP32[i64toi32_i32$1 >> 2] = $44;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        $5 = ($2 + 152 | 0) + 16 | 0;
        i64toi32_i32$2 = ($2 + 176 | 0) + 48 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $52 = i64toi32_i32$0;
        i64toi32_i32$0 = $5;
        HEAP32[i64toi32_i32$0 >> 2] = $52;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        HEAP32[($2 + 376 | 0) >> 2] = HEAPU8[($2 + 185 | 0) >> 0] | 0 | ((HEAPU8[($2 + 186 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 187 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 188 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $37 = ($2 + 176 | 0) + 12 | 0;
        $38 = HEAPU8[$37 >> 0] | 0 | ((HEAPU8[($37 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($37 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($37 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 379 | 0) >> 0] = $38;
        HEAP8[($2 + 380 | 0) >> 0] = $38 >>> 8 | 0;
        HEAP8[($2 + 381 | 0) >> 0] = $38 >>> 16 | 0;
        HEAP8[($2 + 382 | 0) >> 0] = $38 >>> 24 | 0;
        i64toi32_i32$2 = ($2 + 176 | 0) + 32 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $65 = i64toi32_i32$1;
        i64toi32_i32$1 = $2;
        HEAP32[(i64toi32_i32$1 + 152 | 0) >> 2] = $65;
        HEAP32[(i64toi32_i32$1 + 156 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = (i64toi32_i32$1 + 176 | 0) + 16 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $6 = i64toi32_i32$0;
        $6$hi = i64toi32_i32$1;
        i64toi32_i32$2 = ($2 + 176 | 0) + 24 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $7 = i64toi32_i32$1;
        $7$hi = i64toi32_i32$0;
        $3 = HEAP32[(($2 + 176 | 0) + 56 | 0) >> 2] | 0;
        $1 = HEAPU8[($2 + 184 | 0) >> 0] | 0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 176 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 180 | 0) >> 2] | 0;
        memcpy(i64toi32_i32$2 + 8 | 0 | 0, (i64toi32_i32$2 + 176 | 0) + 60 | 0 | 0, 140 | 0) | 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
         break label$2
        }
        HEAP8[($0 + 8 | 0) >> 0] = $1;
        $39 = HEAP32[($2 + 376 | 0) >> 2] | 0;
        HEAP8[($0 + 9 | 0) >> 0] = $39;
        HEAP8[($0 + 10 | 0) >> 0] = $39 >>> 8 | 0;
        HEAP8[($0 + 11 | 0) >> 0] = $39 >>> 16 | 0;
        HEAP8[($0 + 12 | 0) >> 0] = $39 >>> 24 | 0;
        $40 = $0 + 12 | 0;
        $41 = HEAPU8[($2 + 379 | 0) >> 0] | 0 | ((HEAPU8[($2 + 380 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 381 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 382 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[$40 >> 0] = $41;
        HEAP8[($40 + 1 | 0) >> 0] = $41 >>> 8 | 0;
        HEAP8[($40 + 2 | 0) >> 0] = $41 >>> 16 | 0;
        HEAP8[($40 + 3 | 0) >> 0] = $41 >>> 24 | 0;
        i64toi32_i32$2 = $7$hi;
        i64toi32_i32$1 = $0 + 24 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $7;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
        i64toi32_i32$2 = $6$hi;
        i64toi32_i32$1 = $0 + 16 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $6;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
        i64toi32_i32$3 = $2;
        i64toi32_i32$2 = HEAP32[($2 + 152 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 156 | 0) >> 2] | 0;
        $108 = i64toi32_i32$2;
        i64toi32_i32$2 = $0 + 32 | 0;
        $42 = $108;
        HEAP8[i64toi32_i32$2 >> 0] = $42;
        HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $42 >>> 8 | 0;
        HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $42 >>> 16 | 0;
        HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $42 >>> 24 | 0;
        HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$1;
        HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
        HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
        HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
        HEAP32[($0 + 56 | 0) >> 2] = $3;
        i64toi32_i32$3 = $4;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $115 = i64toi32_i32$1;
        i64toi32_i32$1 = $0 + 40 | 0;
        $43 = $115;
        HEAP8[i64toi32_i32$1 >> 0] = $43;
        HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $43 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $43 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $43 >>> 24 | 0;
        HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$2;
        HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
        i64toi32_i32$3 = $5;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $119 = i64toi32_i32$2;
        i64toi32_i32$2 = $0 + 48 | 0;
        $45 = $119;
        HEAP8[i64toi32_i32$2 >> 0] = $45;
        HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $45 >>> 8 | 0;
        HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $45 >>> 16 | 0;
        HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $45 >>> 24 | 0;
        HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$1;
        HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
        HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
        HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
        memcpy($0 + 60 | 0 | 0, $2 + 8 | 0 | 0, 140 | 0) | 0;
        i64toi32_i32$1 = 0;
        $6 = 0;
        $6$hi = i64toi32_i32$1;
        break label$1;
       }
       i64toi32_i32$3 = $2 + 40 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $6 = i64toi32_i32$1;
       $6$hi = i64toi32_i32$2;
       i64toi32_i32$1 = ($2 + 376 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $6;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$3 = $2 + 48 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $7 = i64toi32_i32$2;
       $7$hi = i64toi32_i32$1;
       i64toi32_i32$2 = ($2 + 376 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $7;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$1 = $6$hi;
       i64toi32_i32$2 = ($2 + 152 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $6;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$1 = $7$hi;
       i64toi32_i32$2 = ($2 + 152 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $7;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$3 = $2 + 32 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $6 = i64toi32_i32$1;
       $6$hi = i64toi32_i32$2;
       i64toi32_i32$1 = $2;
       HEAP32[(i64toi32_i32$1 + 376 | 0) >> 2] = $6;
       HEAP32[(i64toi32_i32$1 + 380 | 0) >> 2] = i64toi32_i32$2;
       HEAP32[(i64toi32_i32$1 + 152 | 0) >> 2] = $6;
       HEAP32[(i64toi32_i32$1 + 156 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$3 = i64toi32_i32$1;
       i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 17 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 18 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 19 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 20 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = 0;
       $155 = i64toi32_i32$2;
       $155$hi = i64toi32_i32$1;
       i64toi32_i32$3 = $2 + 21 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
       i64toi32_i32$2 = 0;
       $158 = i64toi32_i32$1;
       $158$hi = i64toi32_i32$2;
       i64toi32_i32$3 = $2 + 23 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$3 >> 0] | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = i64toi32_i32$2;
       i64toi32_i32$2 = 0;
       i64toi32_i32$0 = 16;
       i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
        $48 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $48 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
       }
       $162$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $158$hi;
       i64toi32_i32$1 = $158;
       i64toi32_i32$3 = $162$hi;
       i64toi32_i32$0 = $48;
       i64toi32_i32$3 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$0 = 32;
       i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $49 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$4 | 0) | 0;
        $49 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       $164$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $155$hi;
       i64toi32_i32$3 = $155;
       i64toi32_i32$2 = $164$hi;
       i64toi32_i32$0 = $49;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
       i64toi32_i32$1 = i64toi32_i32$3 | i64toi32_i32$0 | 0;
       i64toi32_i32$3 = 0;
       i64toi32_i32$0 = 8;
       i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
        i64toi32_i32$3 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        $50 = 0;
       } else {
        i64toi32_i32$3 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
        $50 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       }
       $166$hi = i64toi32_i32$3;
       i64toi32_i32$3 = 0;
       i64toi32_i32$2 = $3;
       i64toi32_i32$1 = 0;
       i64toi32_i32$0 = 255;
       i64toi32_i32$1 = i64toi32_i32$3 & i64toi32_i32$1 | 0;
       $169 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
       $169$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $166$hi;
       i64toi32_i32$3 = $50;
       i64toi32_i32$2 = $169$hi;
       i64toi32_i32$0 = $169;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
       $6 = i64toi32_i32$3 | i64toi32_i32$0 | 0;
       $6$hi = i64toi32_i32$2;
       i64toi32_i32$1 = ($2 + 8 | 0) + 16 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $7 = i64toi32_i32$2;
       $7$hi = i64toi32_i32$3;
       $1 = 2;
      }
      $3 = $2 + 184 | 0;
      label$8 : {
       i64toi32_i32$1 = $2;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 176 | 0) >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 180 | 0) >> 2] | 0;
       i64toi32_i32$1 = i64toi32_i32$3;
       i64toi32_i32$3 = 0;
       i64toi32_i32$0 = 0;
       if ((i64toi32_i32$1 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | 0) {
        break label$8
       }
       $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h72de9eab2f0e4669($2 + 216 | 0 | 0);
       $3 = $3 + 44 | 0;
       $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hb600accf9d1c2a17($3 | 0);
       $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h96b3170d440e3692($3 | 0);
       core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__PoolMetadata____hb1232757542ed318($2 + 240 | 0 | 0);
       break label$3;
      }
      core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9($3 | 0);
      break label$3;
     }
     i64toi32_i32$0 = $2 + 208 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $193 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 160 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $193;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$0 = $2 + 216 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $199 = i64toi32_i32$2;
     i64toi32_i32$2 = ($2 + 152 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $199;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$0 = $2 + 200 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $203 = i64toi32_i32$1;
     i64toi32_i32$1 = $2;
     HEAP32[(i64toi32_i32$1 + 152 | 0) >> 2] = $203;
     HEAP32[(i64toi32_i32$1 + 156 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$0 = (i64toi32_i32$1 + 176 | 0) + 16 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $7 = i64toi32_i32$2;
     $7$hi = i64toi32_i32$1;
     $1 = 2;
    }
    $3 = 0;
   }
   i64toi32_i32$1 = $7$hi;
   i64toi32_i32$2 = ($2 + 176 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $7;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $6$hi;
   i64toi32_i32$2 = ($2 + 176 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $6;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$0 = $2;
   i64toi32_i32$1 = HEAP32[($2 + 152 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($2 + 156 | 0) >> 2] | 0;
   $219 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 200 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $219;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = $2;
   i64toi32_i32$2 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $223 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 228 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $223;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$0 = ($2 + 152 | 0) + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $229 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 208 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $229;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = ($2 + 152 | 0) + 16 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $235 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 216 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $235;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($2 + 236 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
   HEAP8[($2 + 176 | 0) >> 0] = $1;
   $46 = HEAP32[($2 + 376 | 0) >> 2] | 0;
   HEAP8[($2 + 177 | 0) >> 0] = $46;
   HEAP8[($2 + 178 | 0) >> 0] = $46 >>> 8 | 0;
   HEAP8[($2 + 179 | 0) >> 0] = $46 >>> 16 | 0;
   HEAP8[($2 + 180 | 0) >> 0] = $46 >>> 24 | 0;
   $47 = HEAPU8[($2 + 379 | 0) >> 0] | 0 | ((HEAPU8[($2 + 380 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 381 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 382 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[($2 + 180 | 0) >> 0] = $47;
   HEAP8[($2 + 181 | 0) >> 0] = $47 >>> 8 | 0;
   HEAP8[($2 + 182 | 0) >> 0] = $47 >>> 16 | 0;
   HEAP8[($2 + 183 | 0) >> 0] = $47 >>> 24 | 0;
   HEAP32[($2 + 224 | 0) >> 2] = $3;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 176 | 0 | 0, 1050890 | 0, 10 | 0);
   i64toi32_i32$1 = 0;
   $6 = 1;
   $6$hi = i64toi32_i32$1;
  }
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$2 = $0;
  HEAP32[i64toi32_i32$2 >> 2] = $6;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $2 + 400 | 0;
 }
 
 function __rdl_realloc($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $5 = 0, $4 = 0, $6 = 0, $7 = 0, $8 = 0, $9 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ($2 >>> 0 < 9 >>> 0) {
       break label$4
      }
      $2 = dlmalloc__Dlmalloc_A___malloc__h25d3e8a45fd7c029($3 | 0, $2 | 0) | 0;
      if ($2) {
       break label$3
      }
      return 0 | 0;
     }
     $2 = 0;
     $1 = dlmalloc__dlmalloc__Chunk__to_mem__he3242996ca597cec(0 | 0) | 0;
     $1 = ((((($1 - (dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2($1 | 0, 8 | 0) | 0) | 0) - (dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2(20 | 0, 8 | 0) | 0) | 0) - (dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2(16 | 0, 8 | 0) | 0) | 0) + -65544 | 0) & -9 | 0) + -3 | 0;
     $4 = 0 - ((dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2(16 | 0, 8 | 0) | 0) << 2 | 0) | 0;
     if (($4 >>> 0 > $1 >>> 0 ? $1 : $4) >>> 0 <= $3 >>> 0) {
      break label$2
     }
     $4 = dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2((((dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2(16 | 0, 8 | 0) | 0) + -5 | 0) >>> 0 > $3 >>> 0 ? 16 : $3 + 4 | 0) | 0, 8 | 0) | 0;
     $1 = dlmalloc__dlmalloc__Chunk__from_mem__h955f68080880f343($0 | 0) | 0;
     $5 = dlmalloc__dlmalloc__Chunk__size__hbcf51483386243e4($1 | 0) | 0;
     $6 = dlmalloc__dlmalloc__Chunk__plus_offset__h7aa5253a4344ed9a($1 | 0, $5 | 0) | 0;
     label$5 : {
      label$6 : {
       label$7 : {
        label$8 : {
         label$9 : {
          label$10 : {
           label$11 : {
            label$12 : {
             if (dlmalloc__dlmalloc__Chunk__mmapped__h896a47bc7b87f942($1 | 0) | 0) {
              break label$12
             }
             if ($5 >>> 0 >= $4 >>> 0) {
              break label$11
             }
             if (($6 | 0) == (HEAP32[(0 + 1178296 | 0) >> 2] | 0 | 0)) {
              break label$10
             }
             if (($6 | 0) == (HEAP32[(0 + 1178292 | 0) >> 2] | 0 | 0)) {
              break label$9
             }
             if (dlmalloc__dlmalloc__Chunk__cinuse__hfa8040b8ff348e52($6 | 0) | 0) {
              break label$5
             }
             $7 = dlmalloc__dlmalloc__Chunk__size__hbcf51483386243e4($6 | 0) | 0;
             $5 = $7 + $5 | 0;
             if ($5 >>> 0 < $4 >>> 0) {
              break label$5
             }
             $8 = $5 - $4 | 0;
             if ($7 >>> 0 < 256 >>> 0) {
              break label$8
             }
             dlmalloc__dlmalloc__Dlmalloc_A___unlink_large_chunk__h107571aa99375aaf($6 | 0);
             break label$7;
            }
            $5 = dlmalloc__dlmalloc__Chunk__size__hbcf51483386243e4($1 | 0) | 0;
            if ($4 >>> 0 < 256 >>> 0) {
             break label$5
            }
            label$13 : {
             if ($5 >>> 0 < ($4 + 4 | 0) >>> 0) {
              break label$13
             }
             if (($5 - $4 | 0) >>> 0 < 131073 >>> 0) {
              break label$6
             }
            }
            $6 = HEAP32[$1 >> 2] | 0;
            $7 = ($5 + $6 | 0) + 16 | 0;
            $5 = dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2($4 + 31 | 0 | 0, $dlmalloc__sys__System_20as_20dlmalloc__Allocator___page_size__h059ddbce5f954b7d(1177884 | 0) | 0 | 0) | 0;
            $4 = $dlmalloc__sys__System_20as_20dlmalloc__Allocator___remap__h9cb2c0371550a3f8(1177884 | 0, $1 - $6 | 0 | 0, $7 | 0, $5 | 0, 1 | 0) | 0;
            if (!$4) {
             break label$5
            }
            $1 = $4 + $6 | 0;
            $3 = $5 - $6 | 0;
            $2 = $3 + -16 | 0;
            HEAP32[($1 + 4 | 0) >> 2] = $2;
            $0 = dlmalloc__dlmalloc__Chunk__fencepost_head__hd9702b75b47fe031() | 0;
            (wasm2js_i32$0 = dlmalloc__dlmalloc__Chunk__plus_offset__h7aa5253a4344ed9a($1 | 0, $2 | 0) | 0, wasm2js_i32$1 = $0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
            (wasm2js_i32$0 = dlmalloc__dlmalloc__Chunk__plus_offset__h7aa5253a4344ed9a($1 | 0, $3 + -12 | 0 | 0) | 0, wasm2js_i32$1 = 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
            $3 = (HEAP32[(0 + 1178300 | 0) >> 2] | 0) + ($5 - $7 | 0) | 0;
            HEAP32[(0 + 1178300 | 0) >> 2] = $3;
            $2 = HEAP32[(0 + 1178328 | 0) >> 2] | 0;
            HEAP32[(0 + 1178328 | 0) >> 2] = $4 >>> 0 > $2 >>> 0 ? $2 : $4;
            $2 = HEAP32[(0 + 1178304 | 0) >> 2] | 0;
            HEAP32[(0 + 1178304 | 0) >> 2] = $2 >>> 0 > $3 >>> 0 ? $2 : $3;
            break label$1;
           }
           $5 = $5 - $4 | 0;
           if ($5 >>> 0 < (dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2(16 | 0, 8 | 0) | 0) >>> 0) {
            break label$6
           }
           $6 = dlmalloc__dlmalloc__Chunk__plus_offset__h7aa5253a4344ed9a($1 | 0, $4 | 0) | 0;
           dlmalloc__dlmalloc__Chunk__set_inuse__h3ef3278ef1a39233($1 | 0, $4 | 0);
           dlmalloc__dlmalloc__Chunk__set_inuse__h3ef3278ef1a39233($6 | 0, $5 | 0);
           dlmalloc__dlmalloc__Dlmalloc_A___dispose_chunk__hb19ba4f57c862d12($6 | 0, $5 | 0);
           break label$6;
          }
          $5 = (HEAP32[(0 + 1178288 | 0) >> 2] | 0) + $5 | 0;
          if ($5 >>> 0 <= $4 >>> 0) {
           break label$5
          }
          $6 = dlmalloc__dlmalloc__Chunk__plus_offset__h7aa5253a4344ed9a($1 | 0, $4 | 0) | 0;
          dlmalloc__dlmalloc__Chunk__set_inuse__h3ef3278ef1a39233($1 | 0, $4 | 0);
          $4 = $5 - $4 | 0;
          HEAP32[($6 + 4 | 0) >> 2] = $4 | 1 | 0;
          HEAP32[(0 + 1178288 | 0) >> 2] = $4;
          HEAP32[(0 + 1178296 | 0) >> 2] = $6;
          break label$6;
         }
         $5 = (HEAP32[(0 + 1178284 | 0) >> 2] | 0) + $5 | 0;
         if ($5 >>> 0 < $4 >>> 0) {
          break label$5
         }
         label$14 : {
          label$15 : {
           $6 = $5 - $4 | 0;
           if ($6 >>> 0 >= (dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2(16 | 0, 8 | 0) | 0) >>> 0) {
            break label$15
           }
           dlmalloc__dlmalloc__Chunk__set_inuse__h3ef3278ef1a39233($1 | 0, $5 | 0);
           $6 = 0;
           $5 = 0;
           break label$14;
          }
          $5 = dlmalloc__dlmalloc__Chunk__plus_offset__h7aa5253a4344ed9a($1 | 0, $4 | 0) | 0;
          $7 = dlmalloc__dlmalloc__Chunk__plus_offset__h7aa5253a4344ed9a($5 | 0, $6 | 0) | 0;
          dlmalloc__dlmalloc__Chunk__set_inuse__h3ef3278ef1a39233($1 | 0, $4 | 0);
          dlmalloc__dlmalloc__Chunk__set_size_and_pinuse_of_free_chunk__hbc4027d35960d532($5 | 0, $6 | 0);
          dlmalloc__dlmalloc__Chunk__clear_pinuse__h2a00a020eb5c5082($7 | 0);
         }
         HEAP32[(0 + 1178292 | 0) >> 2] = $5;
         HEAP32[(0 + 1178284 | 0) >> 2] = $6;
         break label$6;
        }
        label$16 : {
         $9 = HEAP32[($6 + 12 | 0) >> 2] | 0;
         $6 = HEAP32[($6 + 8 | 0) >> 2] | 0;
         if (($9 | 0) == ($6 | 0)) {
          break label$16
         }
         HEAP32[($6 + 12 | 0) >> 2] = $9;
         HEAP32[($9 + 8 | 0) >> 2] = $6;
         break label$7;
        }
        (wasm2js_i32$0 = 0, wasm2js_i32$1 = (HEAP32[(0 + 1177884 | 0) >> 2] | 0) & (__wasm_rotl_i32(-2 | 0, $7 >>> 3 | 0 | 0) | 0) | 0), HEAP32[(wasm2js_i32$0 + 1177884 | 0) >> 2] = wasm2js_i32$1;
       }
       label$17 : {
        if ($8 >>> 0 < (dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2(16 | 0, 8 | 0) | 0) >>> 0) {
         break label$17
        }
        $5 = dlmalloc__dlmalloc__Chunk__plus_offset__h7aa5253a4344ed9a($1 | 0, $4 | 0) | 0;
        dlmalloc__dlmalloc__Chunk__set_inuse__h3ef3278ef1a39233($1 | 0, $4 | 0);
        dlmalloc__dlmalloc__Chunk__set_inuse__h3ef3278ef1a39233($5 | 0, $8 | 0);
        dlmalloc__dlmalloc__Dlmalloc_A___dispose_chunk__hb19ba4f57c862d12($5 | 0, $8 | 0);
        break label$6;
       }
       dlmalloc__dlmalloc__Chunk__set_inuse__h3ef3278ef1a39233($1 | 0, $5 | 0);
      }
      if ($1) {
       break label$1
      }
     }
     $4 = dlmalloc__dlmalloc__Dlmalloc_A___malloc__h817d0bdbe748994d($3 | 0) | 0;
     if (!$4) {
      break label$2
     }
     $2 = (dlmalloc__dlmalloc__Chunk__size__hbcf51483386243e4($1 | 0) | 0) + (dlmalloc__dlmalloc__Chunk__mmapped__h896a47bc7b87f942($1 | 0) | 0 ? -8 : -4) | 0;
     $3 = memcpy($4 | 0, $0 | 0, ($2 >>> 0 > $3 >>> 0 ? $3 : $2) | 0) | 0;
     dlmalloc__dlmalloc__Dlmalloc_A___free__h37f2ccb1260849b6($0 | 0);
     return $3 | 0;
    }
    memcpy($2 | 0, $0 | 0, ($1 >>> 0 > $3 >>> 0 ? $3 : $1) | 0) | 0;
    dlmalloc__dlmalloc__Dlmalloc_A___free__h37f2ccb1260849b6($0 | 0);
   }
   return $2 | 0;
  }
  dlmalloc__dlmalloc__Chunk__mmapped__h896a47bc7b87f942($1 | 0) | 0;
  return dlmalloc__dlmalloc__Chunk__to_mem__he3242996ca597cec($1 | 0) | 0 | 0;
 }
 
 function core__num__bignum__Big32x40__mul_digits__h5211d0d110d18ae1($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$5 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$4 = 0, $11 = 0, i64toi32_i32$3 = 0, $12 = 0, $5 = 0, $10 = 0, $13 = 0, $17$hi = 0, $9 = 0, $6 = 0, $17 = 0, $4 = 0, $16$hi = 0, $14 = 0, $15 = 0, $7 = 0, $8 = 0, $16 = 0, $40 = 0, $41 = 0, $74 = 0, $77 = 0, $77$hi = 0, $78$hi = 0, $80$hi = 0, $42 = 0, $82 = 0, $82$hi = 0, $191 = 0, $194 = 0, $194$hi = 0, $195$hi = 0, $197$hi = 0, $43 = 0, $199 = 0, $199$hi = 0;
  $3 = global$0 - 160 | 0;
  global$0 = $3;
  $4 = memset($3 | 0, 0 | 0, 160 | 0) | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         $5 = HEAP32[$0 >> 2] | 0;
         if ($5 >>> 0 < $2 >>> 0) {
          break label$7
         }
         if ($5 >>> 0 >= 41 >>> 0) {
          break label$6
         }
         $6 = $1 + ($2 << 2 | 0) | 0;
         label$8 : {
          label$9 : {
           if (!$5) {
            break label$9
           }
           $7 = $5 + 1 | 0;
           $2 = $0 + 4 | 0;
           $8 = $5 << 2 | 0;
           $9 = 0;
           $10 = 0;
           label$10 : while (1) {
            $11 = $4 + ($9 << 2 | 0) | 0;
            label$11 : while (1) {
             $12 = $9;
             $3 = $11;
             if (($1 | 0) == ($6 | 0)) {
              break label$1
             }
             $11 = $3 + 4 | 0;
             $9 = $12 + 1 | 0;
             $13 = HEAP32[$1 >> 2] | 0;
             $14 = $1 + 4 | 0;
             $1 = $14;
             if (!$13) {
              continue label$11
             }
             break label$11;
            };
            $15 = ($12 >>> 0 < 40 >>> 0 ? $12 : 40) + -40 | 0;
            i64toi32_i32$0 = 0;
            $16 = $13;
            $16$hi = i64toi32_i32$0;
            i64toi32_i32$0 = 0;
            $17 = 0;
            $17$hi = i64toi32_i32$0;
            $1 = 0;
            $13 = $8;
            $11 = $2;
            label$12 : while (1) {
             if (($15 | 0) == ($1 | 0)) {
              break label$8
             }
             $74 = $3;
             i64toi32_i32$0 = $17$hi;
             i64toi32_i32$2 = $3;
             i64toi32_i32$0 = HEAP32[$3 >> 2] | 0;
             i64toi32_i32$1 = 0;
             $77 = i64toi32_i32$0;
             $77$hi = i64toi32_i32$1;
             i64toi32_i32$1 = $17$hi;
             i64toi32_i32$2 = $17;
             i64toi32_i32$0 = $77$hi;
             i64toi32_i32$3 = $77;
             i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
             i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
             if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
              i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
             }
             $78$hi = i64toi32_i32$5;
             i64toi32_i32$1 = $11;
             i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
             i64toi32_i32$2 = 0;
             $80$hi = i64toi32_i32$2;
             i64toi32_i32$2 = $16$hi;
             i64toi32_i32$2 = $80$hi;
             $42 = i64toi32_i32$5;
             i64toi32_i32$5 = $16$hi;
             i64toi32_i32$5 = __wasm_i64_mul($42 | 0, i64toi32_i32$2 | 0, $16 | 0, i64toi32_i32$5 | 0) | 0;
             i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
             $82 = i64toi32_i32$5;
             $82$hi = i64toi32_i32$2;
             i64toi32_i32$2 = $78$hi;
             i64toi32_i32$1 = i64toi32_i32$4;
             i64toi32_i32$5 = $82$hi;
             i64toi32_i32$3 = $82;
             i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
             i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
             if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
              i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
             }
             $17 = i64toi32_i32$0;
             $17$hi = i64toi32_i32$4;
             HEAP32[$74 >> 2] = i64toi32_i32$0;
             i64toi32_i32$2 = i64toi32_i32$0;
             i64toi32_i32$1 = 0;
             i64toi32_i32$3 = 32;
             i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
             if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
              i64toi32_i32$1 = 0;
              $40 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
             } else {
              i64toi32_i32$1 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
              $40 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$5 | 0) | 0;
             }
             $17 = $40;
             $17$hi = i64toi32_i32$1;
             $3 = $3 + 4 | 0;
             $1 = $1 + -1 | 0;
             $11 = $11 + 4 | 0;
             $13 = $13 + -4 | 0;
             if ($13) {
              continue label$12
             }
             break label$12;
            };
            $3 = $5;
            label$13 : {
             i64toi32_i32$1 = $17$hi;
             $1 = $17;
             if (!$1) {
              break label$13
             }
             $3 = $12 + $5 | 0;
             if ($3 >>> 0 > 39 >>> 0) {
              break label$5
             }
             HEAP32[($4 + ($3 << 2 | 0) | 0) >> 2] = $1;
             $3 = $7;
            }
            $3 = $3 + $12 | 0;
            $10 = $10 >>> 0 < $3 >>> 0 ? $3 : $10;
            $1 = $14;
            continue label$10;
           };
          }
          $10 = 0;
          $3 = 0;
          label$14 : while (1) {
           if (($6 | 0) == ($1 | 0)) {
            break label$1
           }
           $3 = $3 + 1 | 0;
           $11 = HEAP32[$1 >> 2] | 0;
           $12 = $1 + 4 | 0;
           $1 = $12;
           if (!$11) {
            continue label$14
           }
           $1 = $3 + -1 | 0;
           $10 = $10 >>> 0 < $1 >>> 0 ? $1 : $10;
           $1 = $12;
           continue label$14;
          };
         }
         core__panicking__panic_bounds_check__h808b524af17640b1(($1 ^ -1 | 0) + $9 | 0 | 0, 40 | 0, 1153020 | 0);
         abort();
        }
        if ($5 >>> 0 >= 41 >>> 0) {
         break label$4
        }
        $11 = $0 + 4 | 0;
        $14 = $11 + ($5 << 2 | 0) | 0;
        $8 = $2 << 2 | 0;
        $7 = $2 + 1 | 0;
        $13 = 0;
        $10 = 0;
        label$15 : while (1) {
         $12 = $4 + ($13 << 2 | 0) | 0;
         label$16 : while (1) {
          $9 = $13;
          $3 = $12;
          if (($11 | 0) == ($14 | 0)) {
           break label$1
          }
          $12 = $3 + 4 | 0;
          $13 = $9 + 1 | 0;
          $6 = HEAP32[$11 >> 2] | 0;
          $15 = $11 + 4 | 0;
          $11 = $15;
          if (!$6) {
           continue label$16
          }
          break label$16;
         };
         $5 = ($9 >>> 0 < 40 >>> 0 ? $9 : 40) + -40 | 0;
         i64toi32_i32$1 = 0;
         $16 = $6;
         $16$hi = i64toi32_i32$1;
         i64toi32_i32$1 = 0;
         $17 = 0;
         $17$hi = i64toi32_i32$1;
         $11 = 0;
         $6 = $8;
         $12 = $1;
         label$17 : while (1) {
          if (($5 | 0) == ($11 | 0)) {
           break label$3
          }
          $191 = $3;
          i64toi32_i32$1 = $17$hi;
          i64toi32_i32$4 = $3;
          i64toi32_i32$1 = HEAP32[$3 >> 2] | 0;
          i64toi32_i32$2 = 0;
          $194 = i64toi32_i32$1;
          $194$hi = i64toi32_i32$2;
          i64toi32_i32$2 = $17$hi;
          i64toi32_i32$4 = $17;
          i64toi32_i32$1 = $194$hi;
          i64toi32_i32$3 = $194;
          i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
          i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
          if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
           i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
          }
          $195$hi = i64toi32_i32$0;
          i64toi32_i32$2 = $12;
          i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
          i64toi32_i32$4 = 0;
          $197$hi = i64toi32_i32$4;
          i64toi32_i32$4 = $16$hi;
          i64toi32_i32$4 = $197$hi;
          $43 = i64toi32_i32$0;
          i64toi32_i32$0 = $16$hi;
          i64toi32_i32$0 = __wasm_i64_mul($43 | 0, i64toi32_i32$4 | 0, $16 | 0, i64toi32_i32$0 | 0) | 0;
          i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
          $199 = i64toi32_i32$0;
          $199$hi = i64toi32_i32$4;
          i64toi32_i32$4 = $195$hi;
          i64toi32_i32$2 = i64toi32_i32$5;
          i64toi32_i32$0 = $199$hi;
          i64toi32_i32$3 = $199;
          i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
          i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
          if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
           i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
          }
          $17 = i64toi32_i32$1;
          $17$hi = i64toi32_i32$5;
          HEAP32[$191 >> 2] = i64toi32_i32$1;
          i64toi32_i32$4 = i64toi32_i32$1;
          i64toi32_i32$2 = 0;
          i64toi32_i32$3 = 32;
          i64toi32_i32$0 = i64toi32_i32$3 & 31 | 0;
          if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
           i64toi32_i32$2 = 0;
           $41 = i64toi32_i32$5 >>> i64toi32_i32$0 | 0;
          } else {
           i64toi32_i32$2 = i64toi32_i32$5 >>> i64toi32_i32$0 | 0;
           $41 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$0 | 0) | 0;
          }
          $17 = $41;
          $17$hi = i64toi32_i32$2;
          $3 = $3 + 4 | 0;
          $11 = $11 + -1 | 0;
          $12 = $12 + 4 | 0;
          $6 = $6 + -4 | 0;
          if ($6) {
           continue label$17
          }
          break label$17;
         };
         $3 = $2;
         label$18 : {
          i64toi32_i32$2 = $17$hi;
          $11 = $17;
          if (!$11) {
           break label$18
          }
          $3 = $9 + $2 | 0;
          if ($3 >>> 0 > 39 >>> 0) {
           break label$2
          }
          HEAP32[($4 + ($3 << 2 | 0) | 0) >> 2] = $11;
          $3 = $7;
         }
         $3 = $3 + $9 | 0;
         $10 = $10 >>> 0 < $3 >>> 0 ? $3 : $10;
         $11 = $15;
         continue label$15;
        };
       }
       core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($5 | 0, 40 | 0, 1153020 | 0);
       abort();
      }
      core__panicking__panic_bounds_check__h808b524af17640b1($3 | 0, 40 | 0, 1153020 | 0);
      abort();
     }
     core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($5 | 0, 40 | 0, 1153020 | 0);
     abort();
    }
    core__panicking__panic_bounds_check__h808b524af17640b1(($11 ^ -1 | 0) + $13 | 0 | 0, 40 | 0, 1153020 | 0);
    abort();
   }
   core__panicking__panic_bounds_check__h808b524af17640b1($3 | 0, 40 | 0, 1153020 | 0);
   abort();
  }
  memcpy($0 + 4 | 0 | 0, $4 | 0, 160 | 0) | 0;
  HEAP32[$0 >> 2] = $10;
  global$0 = $4 + 160 | 0;
  return $0 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__Transaction___deserialize__hb4f9215300fe97ce($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $6 = 0, $6$hi = 0, $3 = 0, $7 = 0, $7$hi = 0, $37 = 0, $38 = 0, $39 = 0, $40 = 0, $41 = 0, $42 = 0, $43 = 0, $45 = 0, $46 = 0, $47 = 0, $4 = 0, $5 = 0, $48 = 0, $49 = 0, $50 = 0, $44 = 0, $52 = 0, $65 = 0, $108 = 0, $115 = 0, $119 = 0, $155 = 0, $155$hi = 0, $158 = 0, $158$hi = 0, $162$hi = 0, $164$hi = 0, $166$hi = 0, $169 = 0, $169$hi = 0, $190 = 0, $196 = 0, $200 = 0, $216 = 0, $220 = 0, $226 = 0, $232 = 0;
  $2 = global$0 - 864 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 408 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 416 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 420 | 0) >> 2] | 0;
  $6 = i64toi32_i32$0;
  $6$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 408 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 412 | 0) >> 2] | 0;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 1;
      if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
       break label$4
      }
      i64toi32_i32$2 = $6$hi;
      i64toi32_i32$0 = i64toi32_i32$2;
      cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__Transaction___deserialize_as_embedded_group__hf38a6fe2a34e8cd2($2 + 408 | 0 | 0, $1 | 0, $6 | 0, i64toi32_i32$2 | 0, $6 | 0, i64toi32_i32$2 | 0);
      label$5 : {
       label$6 : {
        label$7 : {
         i64toi32_i32$0 = i64toi32_i32$2;
         i64toi32_i32$0 = i64toi32_i32$2;
         i64toi32_i32$3 = $6;
         i64toi32_i32$2 = 0;
         i64toi32_i32$1 = 1;
         if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) | 0) {
          break label$7
         }
         cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 8 | 0 | 0, $1 | 0);
         $3 = HEAPU8[($2 + 16 | 0) >> 0] | 0;
         i64toi32_i32$1 = $2;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] | 0;
         i64toi32_i32$1 = i64toi32_i32$3;
         i64toi32_i32$3 = 0;
         i64toi32_i32$2 = 1;
         if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) | 0) {
          break label$6
         }
         $1 = 5;
         if (($3 & 255 | 0 | 0) != (5 | 0)) {
          break label$5
         }
        }
        $4 = $2 + 392 | 0;
        i64toi32_i32$2 = ($2 + 408 | 0) + 40 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $44 = i64toi32_i32$1;
        i64toi32_i32$1 = $4;
        HEAP32[i64toi32_i32$1 >> 2] = $44;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        $5 = ($2 + 384 | 0) + 16 | 0;
        i64toi32_i32$2 = ($2 + 408 | 0) + 48 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $52 = i64toi32_i32$0;
        i64toi32_i32$0 = $5;
        HEAP32[i64toi32_i32$0 >> 2] = $52;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        HEAP32[($2 + 840 | 0) >> 2] = HEAPU8[($2 + 417 | 0) >> 0] | 0 | ((HEAPU8[($2 + 418 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 419 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 420 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $37 = ($2 + 408 | 0) + 12 | 0;
        $38 = HEAPU8[$37 >> 0] | 0 | ((HEAPU8[($37 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($37 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($37 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 843 | 0) >> 0] = $38;
        HEAP8[($2 + 844 | 0) >> 0] = $38 >>> 8 | 0;
        HEAP8[($2 + 845 | 0) >> 0] = $38 >>> 16 | 0;
        HEAP8[($2 + 846 | 0) >> 0] = $38 >>> 24 | 0;
        i64toi32_i32$2 = ($2 + 408 | 0) + 32 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $65 = i64toi32_i32$1;
        i64toi32_i32$1 = $2;
        HEAP32[(i64toi32_i32$1 + 384 | 0) >> 2] = $65;
        HEAP32[(i64toi32_i32$1 + 388 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = (i64toi32_i32$1 + 408 | 0) + 16 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $6 = i64toi32_i32$0;
        $6$hi = i64toi32_i32$1;
        i64toi32_i32$2 = ($2 + 408 | 0) + 24 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $7 = i64toi32_i32$1;
        $7$hi = i64toi32_i32$0;
        $3 = HEAP32[(($2 + 408 | 0) + 56 | 0) >> 2] | 0;
        $1 = HEAPU8[($2 + 416 | 0) >> 0] | 0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 408 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 412 | 0) >> 2] | 0;
        memcpy(i64toi32_i32$2 + 8 | 0 | 0, (i64toi32_i32$2 + 408 | 0) + 60 | 0 | 0, 372 | 0) | 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
         break label$2
        }
        HEAP8[($0 + 8 | 0) >> 0] = $1;
        $39 = HEAP32[($2 + 840 | 0) >> 2] | 0;
        HEAP8[($0 + 9 | 0) >> 0] = $39;
        HEAP8[($0 + 10 | 0) >> 0] = $39 >>> 8 | 0;
        HEAP8[($0 + 11 | 0) >> 0] = $39 >>> 16 | 0;
        HEAP8[($0 + 12 | 0) >> 0] = $39 >>> 24 | 0;
        $40 = $0 + 12 | 0;
        $41 = HEAPU8[($2 + 843 | 0) >> 0] | 0 | ((HEAPU8[($2 + 844 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 845 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 846 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[$40 >> 0] = $41;
        HEAP8[($40 + 1 | 0) >> 0] = $41 >>> 8 | 0;
        HEAP8[($40 + 2 | 0) >> 0] = $41 >>> 16 | 0;
        HEAP8[($40 + 3 | 0) >> 0] = $41 >>> 24 | 0;
        i64toi32_i32$2 = $7$hi;
        i64toi32_i32$1 = $0 + 24 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $7;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
        i64toi32_i32$2 = $6$hi;
        i64toi32_i32$1 = $0 + 16 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $6;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
        i64toi32_i32$3 = $2;
        i64toi32_i32$2 = HEAP32[($2 + 384 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 388 | 0) >> 2] | 0;
        $108 = i64toi32_i32$2;
        i64toi32_i32$2 = $0 + 32 | 0;
        $42 = $108;
        HEAP8[i64toi32_i32$2 >> 0] = $42;
        HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $42 >>> 8 | 0;
        HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $42 >>> 16 | 0;
        HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $42 >>> 24 | 0;
        HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$1;
        HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
        HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
        HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
        HEAP32[($0 + 56 | 0) >> 2] = $3;
        i64toi32_i32$3 = $4;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $115 = i64toi32_i32$1;
        i64toi32_i32$1 = $0 + 40 | 0;
        $43 = $115;
        HEAP8[i64toi32_i32$1 >> 0] = $43;
        HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $43 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $43 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $43 >>> 24 | 0;
        HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$2;
        HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
        i64toi32_i32$3 = $5;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $119 = i64toi32_i32$2;
        i64toi32_i32$2 = $0 + 48 | 0;
        $45 = $119;
        HEAP8[i64toi32_i32$2 >> 0] = $45;
        HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $45 >>> 8 | 0;
        HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $45 >>> 16 | 0;
        HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $45 >>> 24 | 0;
        HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$1;
        HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
        HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
        HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
        memcpy($0 + 60 | 0 | 0, $2 + 8 | 0 | 0, 372 | 0) | 0;
        i64toi32_i32$1 = 0;
        $6 = 0;
        $6$hi = i64toi32_i32$1;
        break label$1;
       }
       i64toi32_i32$3 = $2 + 40 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $6 = i64toi32_i32$1;
       $6$hi = i64toi32_i32$2;
       i64toi32_i32$1 = ($2 + 840 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $6;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$3 = $2 + 48 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $7 = i64toi32_i32$2;
       $7$hi = i64toi32_i32$1;
       i64toi32_i32$2 = ($2 + 840 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $7;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$1 = $6$hi;
       i64toi32_i32$2 = ($2 + 384 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $6;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$1 = $7$hi;
       i64toi32_i32$2 = ($2 + 384 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $7;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$3 = $2 + 32 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $6 = i64toi32_i32$1;
       $6$hi = i64toi32_i32$2;
       i64toi32_i32$1 = $2;
       HEAP32[(i64toi32_i32$1 + 840 | 0) >> 2] = $6;
       HEAP32[(i64toi32_i32$1 + 844 | 0) >> 2] = i64toi32_i32$2;
       HEAP32[(i64toi32_i32$1 + 384 | 0) >> 2] = $6;
       HEAP32[(i64toi32_i32$1 + 388 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$3 = i64toi32_i32$1;
       i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 17 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 18 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 19 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 20 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = 0;
       $155 = i64toi32_i32$2;
       $155$hi = i64toi32_i32$1;
       i64toi32_i32$3 = $2 + 21 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
       i64toi32_i32$2 = 0;
       $158 = i64toi32_i32$1;
       $158$hi = i64toi32_i32$2;
       i64toi32_i32$3 = $2 + 23 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$3 >> 0] | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = i64toi32_i32$2;
       i64toi32_i32$2 = 0;
       i64toi32_i32$0 = 16;
       i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
        $48 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $48 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
       }
       $162$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $158$hi;
       i64toi32_i32$1 = $158;
       i64toi32_i32$3 = $162$hi;
       i64toi32_i32$0 = $48;
       i64toi32_i32$3 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$0 = 32;
       i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $49 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$4 | 0) | 0;
        $49 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       $164$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $155$hi;
       i64toi32_i32$3 = $155;
       i64toi32_i32$2 = $164$hi;
       i64toi32_i32$0 = $49;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
       i64toi32_i32$1 = i64toi32_i32$3 | i64toi32_i32$0 | 0;
       i64toi32_i32$3 = 0;
       i64toi32_i32$0 = 8;
       i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
        i64toi32_i32$3 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        $50 = 0;
       } else {
        i64toi32_i32$3 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
        $50 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       }
       $166$hi = i64toi32_i32$3;
       i64toi32_i32$3 = 0;
       i64toi32_i32$2 = $3;
       i64toi32_i32$1 = 0;
       i64toi32_i32$0 = 255;
       i64toi32_i32$1 = i64toi32_i32$3 & i64toi32_i32$1 | 0;
       $169 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
       $169$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $166$hi;
       i64toi32_i32$3 = $50;
       i64toi32_i32$2 = $169$hi;
       i64toi32_i32$0 = $169;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
       $6 = i64toi32_i32$3 | i64toi32_i32$0 | 0;
       $6$hi = i64toi32_i32$2;
       i64toi32_i32$1 = ($2 + 8 | 0) + 16 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $7 = i64toi32_i32$2;
       $7$hi = i64toi32_i32$3;
       $1 = 2;
      }
      $3 = $2 + 416 | 0;
      label$8 : {
       i64toi32_i32$1 = $2;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 408 | 0) >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 412 | 0) >> 2] | 0;
       i64toi32_i32$1 = i64toi32_i32$3;
       i64toi32_i32$3 = 0;
       i64toi32_i32$0 = 0;
       if ((i64toi32_i32$1 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | 0) {
        break label$8
       }
       core__ptr__drop_in_place_cardano_serialization_lib__TransactionBody___h9274013021a1d568_1($3 | 0);
       core__ptr__drop_in_place_cardano_serialization_lib__TransactionWitnessSet___h7d278d9502f6471a_1($2 + 760 | 0 | 0);
       core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__metadata__AuxiliaryData____ha98f6c5d89b7a772($2 + 688 | 0 | 0);
       break label$3;
      }
      core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9($3 | 0);
      break label$3;
     }
     i64toi32_i32$0 = $2 + 440 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $190 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 392 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $190;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$0 = $2 + 448 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $196 = i64toi32_i32$2;
     i64toi32_i32$2 = ($2 + 384 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $196;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$0 = $2 + 432 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $200 = i64toi32_i32$1;
     i64toi32_i32$1 = $2;
     HEAP32[(i64toi32_i32$1 + 384 | 0) >> 2] = $200;
     HEAP32[(i64toi32_i32$1 + 388 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$0 = (i64toi32_i32$1 + 408 | 0) + 16 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $7 = i64toi32_i32$2;
     $7$hi = i64toi32_i32$1;
     $1 = 2;
    }
    $3 = 0;
   }
   i64toi32_i32$1 = $7$hi;
   i64toi32_i32$2 = ($2 + 408 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $7;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $6$hi;
   i64toi32_i32$2 = ($2 + 408 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $6;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$0 = $2;
   i64toi32_i32$1 = HEAP32[($2 + 384 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($2 + 388 | 0) >> 2] | 0;
   $216 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 432 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $216;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = $2;
   i64toi32_i32$2 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $220 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 460 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $220;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$0 = ($2 + 384 | 0) + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $226 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 440 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $226;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = ($2 + 384 | 0) + 16 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $232 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 448 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $232;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($2 + 468 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
   HEAP8[($2 + 408 | 0) >> 0] = $1;
   $46 = HEAP32[($2 + 840 | 0) >> 2] | 0;
   HEAP8[($2 + 409 | 0) >> 0] = $46;
   HEAP8[($2 + 410 | 0) >> 0] = $46 >>> 8 | 0;
   HEAP8[($2 + 411 | 0) >> 0] = $46 >>> 16 | 0;
   HEAP8[($2 + 412 | 0) >> 0] = $46 >>> 24 | 0;
   $47 = HEAPU8[($2 + 843 | 0) >> 0] | 0 | ((HEAPU8[($2 + 844 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 845 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 846 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[($2 + 412 | 0) >> 0] = $47;
   HEAP8[($2 + 413 | 0) >> 0] = $47 >>> 8 | 0;
   HEAP8[($2 + 414 | 0) >> 0] = $47 >>> 16 | 0;
   HEAP8[($2 + 415 | 0) >> 0] = $47 >>> 24 | 0;
   HEAP32[($2 + 456 | 0) >> 2] = $3;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 408 | 0 | 0, 1050260 | 0, 11 | 0);
   i64toi32_i32$1 = 0;
   $6 = 1;
   $6$hi = i64toi32_i32$1;
  }
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$2 = $0;
  HEAP32[i64toi32_i32$2 >> 2] = $6;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $2 + 864 | 0;
 }
 
 function $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__clone_subtree__h5434fcebccdb4d74($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $4 = 0, $11 = 0, $10 = 0, $5 = 0, $6 = 0, $7 = 0, $8 = 0, $9 = 0, $33 = 0, $34 = 0, $35 = 0, $36 = 0, $37 = 0, $38 = 0, $39 = 0, $12 = 0, $13 = 0, $42 = 0, $49 = 0, $52 = 0, $70 = 0, $74 = 0, $78 = 0, $90 = 0, $169 = 0, $176 = 0, $179 = 0, $14 = 0, $203 = 0, $208 = 0, $211 = 0, $221 = 0, $254 = 0;
  $3 = global$0 - 144 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     if ($1) {
      break label$3
     }
     $4 = alloc__boxed__Box_T_2cA___new_uninit_in__hcce3eeaf87129ab3() | 0;
     HEAP16[($4 + 138 | 0) >> 1] = 0;
     HEAP32[$4 >> 2] = 0;
     $5 = 0;
     label$4 : {
      if (!(HEAPU16[($2 + 138 | 0) >> 1] | 0)) {
       break label$4
      }
      $6 = $2 + 4 | 0;
      $1 = $2 + 140 | 0;
      $5 = 0;
      label$5 : while (1) {
       $7 = ($3 + 96 | 0) + 24 | 0;
       $33 = $1 + 24 | 0;
       HEAP32[$7 >> 2] = HEAPU8[$33 >> 0] | 0 | ((HEAPU8[($33 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($33 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($33 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $8 = ($3 + 96 | 0) + 16 | 0;
       i64toi32_i32$2 = $1 + 16 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $42 = i64toi32_i32$0;
       i64toi32_i32$0 = $8;
       HEAP32[i64toi32_i32$0 >> 2] = $42;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       $9 = ($3 + 96 | 0) + 8 | 0;
       i64toi32_i32$2 = $1 + 8 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $49 = i64toi32_i32$1;
       i64toi32_i32$1 = $9;
       HEAP32[i64toi32_i32$1 >> 2] = $49;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = $1;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $52 = i64toi32_i32$0;
       i64toi32_i32$0 = $3;
       HEAP32[($3 + 96 | 0) >> 2] = $52;
       HEAP32[($3 + 100 | 0) >> 2] = i64toi32_i32$1;
       $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h3f0faaa5740c6934($3 + 32 | 0 | 0, $6 | 0);
       $10 = HEAPU16[($4 + 138 | 0) >> 1] | 0;
       if ($10 >>> 0 >= 11 >>> 0) {
        break label$1
       }
       HEAP16[($4 + 138 | 0) >> 1] = $10 + 1 | 0;
       $11 = $4 + Math_imul($10, 28) | 0;
       i64toi32_i32$2 = $3;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 100 | 0) >> 2] | 0;
       $70 = i64toi32_i32$1;
       i64toi32_i32$1 = $11 + 140 | 0;
       $34 = $70;
       HEAP8[i64toi32_i32$1 >> 0] = $34;
       HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $34 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $34 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $34 >>> 24 | 0;
       HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
       HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
       i64toi32_i32$2 = $9;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $74 = i64toi32_i32$0;
       i64toi32_i32$0 = $11 + 148 | 0;
       $35 = $74;
       HEAP8[i64toi32_i32$0 >> 0] = $35;
       HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $35 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $35 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $35 >>> 24 | 0;
       HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
       HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
       i64toi32_i32$2 = $8;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $78 = i64toi32_i32$1;
       i64toi32_i32$1 = $11 + 156 | 0;
       $36 = $78;
       HEAP8[i64toi32_i32$1 >> 0] = $36;
       HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $36 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $36 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $36 >>> 24 | 0;
       HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
       HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
       $37 = $11 + 164 | 0;
       $38 = HEAP32[$7 >> 2] | 0;
       HEAP8[$37 >> 0] = $38;
       HEAP8[($37 + 1 | 0) >> 0] = $38 >>> 8 | 0;
       HEAP8[($37 + 2 | 0) >> 0] = $38 >>> 16 | 0;
       HEAP8[($37 + 3 | 0) >> 0] = $38 >>> 24 | 0;
       $10 = $4 + Math_imul($10, 12) | 0;
       i64toi32_i32$2 = $3;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
       $90 = i64toi32_i32$0;
       i64toi32_i32$0 = $10 + 4 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $90;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       HEAP32[($10 + 12 | 0) >> 2] = HEAP32[((i64toi32_i32$2 + 32 | 0) + 8 | 0) >> 2] | 0;
       $6 = $6 + 12 | 0;
       $1 = $1 + 28 | 0;
       $5 = $5 + 1 | 0;
       if ($5 >>> 0 < (HEAPU16[($2 + 138 | 0) >> 1] | 0) >>> 0) {
        continue label$5
       }
       break label$5;
      };
     }
     HEAP32[($0 + 8 | 0) >> 2] = $5;
     HEAP32[($0 + 4 | 0) >> 2] = $4;
     HEAP32[$0 >> 2] = 0;
     break label$2;
    }
    $12 = $1 + -1 | 0;
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__clone_subtree__h5434fcebccdb4d74($3 + 8 | 0 | 0, $12 | 0, HEAP32[($2 + 448 | 0) >> 2] | 0 | 0);
    label$6 : {
     label$7 : {
      $4 = HEAP32[($3 + 12 | 0) >> 2] | 0;
      if (!$4) {
       break label$7
      }
      $11 = (HEAP32[($3 + 8 | 0) >> 2] | 0) + 1 | 0;
      break label$6;
     }
     $4 = alloc__boxed__Box_T_2cA___new_uninit_in__hcce3eeaf87129ab3() | 0;
     HEAP16[($4 + 138 | 0) >> 1] = 0;
     HEAP32[$4 >> 2] = 0;
     $11 = 1;
    }
    $1 = alloc__boxed__Box_T_2cA___new_uninit_in__h030094152bc6ae31() | 0;
    HEAP32[($1 + 448 | 0) >> 2] = $4;
    $10 = 0;
    HEAP16[($1 + 138 | 0) >> 1] = 0;
    HEAP32[$1 >> 2] = 0;
    HEAP32[$4 >> 2] = $1;
    HEAP16[($4 + 136 | 0) >> 1] = 0;
    HEAP32[($3 + 12 | 0) >> 2] = $1;
    HEAP32[($3 + 8 | 0) >> 2] = $11;
    HEAP32[($3 + 28 | 0) >> 2] = $1;
    HEAP32[($3 + 24 | 0) >> 2] = $11;
    label$8 : {
     if (!(HEAPU16[($2 + 138 | 0) >> 1] | 0)) {
      break label$8
     }
     $11 = $2 + 4 | 0;
     $1 = $2 + 140 | 0;
     $6 = $2 + 452 | 0;
     $7 = HEAP32[($3 + 16 | 0) >> 2] | 0;
     label$9 : while (1) {
      $8 = ($3 + 32 | 0) + 24 | 0;
      $39 = $1 + 24 | 0;
      HEAP32[$8 >> 2] = HEAPU8[$39 >> 0] | 0 | ((HEAPU8[($39 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($39 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($39 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $9 = ($3 + 32 | 0) + 16 | 0;
      i64toi32_i32$2 = $1 + 16 | 0;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $169 = i64toi32_i32$1;
      i64toi32_i32$1 = $9;
      HEAP32[i64toi32_i32$1 >> 2] = $169;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      $13 = ($3 + 32 | 0) + 8 | 0;
      i64toi32_i32$2 = $1 + 8 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $176 = i64toi32_i32$0;
      i64toi32_i32$0 = $13;
      HEAP32[i64toi32_i32$0 >> 2] = $176;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $1;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $179 = i64toi32_i32$1;
      i64toi32_i32$1 = $3;
      HEAP32[(i64toi32_i32$1 + 32 | 0) >> 2] = $179;
      HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] = i64toi32_i32$0;
      $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h3f0faaa5740c6934(i64toi32_i32$1 + 64 | 0 | 0, $11 | 0);
      $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__clone_subtree__h5434fcebccdb4d74(i64toi32_i32$1 + 80 | 0 | 0, $12 | 0, HEAP32[$6 >> 2] | 0 | 0);
      $14 = HEAP32[(i64toi32_i32$1 + 88 | 0) >> 2] | 0;
      $4 = HEAP32[(i64toi32_i32$1 + 84 | 0) >> 2] | 0;
      $5 = HEAP32[(i64toi32_i32$1 + 80 | 0) >> 2] | 0;
      HEAP32[((i64toi32_i32$1 + 96 | 0) + 24 | 0) >> 2] = HEAP32[$8 >> 2] | 0;
      i64toi32_i32$2 = $9;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $203 = i64toi32_i32$0;
      i64toi32_i32$0 = ($3 + 96 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $203;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $13;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $208 = i64toi32_i32$1;
      i64toi32_i32$1 = ($3 + 96 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $208;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $3;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
      $211 = i64toi32_i32$0;
      i64toi32_i32$0 = i64toi32_i32$2;
      HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] = $211;
      HEAP32[(i64toi32_i32$2 + 100 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[((i64toi32_i32$2 + 128 | 0) + 8 | 0) >> 2] = HEAP32[((i64toi32_i32$2 + 64 | 0) + 8 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
      $221 = i64toi32_i32$1;
      i64toi32_i32$1 = i64toi32_i32$2;
      HEAP32[(i64toi32_i32$2 + 128 | 0) >> 2] = $221;
      HEAP32[(i64toi32_i32$2 + 132 | 0) >> 2] = i64toi32_i32$0;
      $10 = $10 + 1 | 0;
      label$10 : {
       if ($4) {
        break label$10
       }
       $5 = 0;
       $4 = alloc__boxed__Box_T_2cA___new_uninit_in__hcce3eeaf87129ab3() | 0;
       HEAP16[($4 + 138 | 0) >> 1] = 0;
       HEAP32[$4 >> 2] = 0;
      }
      alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal___push__h58c3a8a4c681696e($3 + 24 | 0 | 0, $3 + 96 | 0 | 0, $3 + 128 | 0 | 0, $5 | 0, $4 | 0);
      $11 = $11 + 12 | 0;
      $1 = $1 + 28 | 0;
      $6 = $6 + 4 | 0;
      $7 = ($14 + $7 | 0) + 1 | 0;
      if ($10 >>> 0 < (HEAPU16[($2 + 138 | 0) >> 1] | 0) >>> 0) {
       continue label$9
      }
      break label$9;
     };
     HEAP32[($3 + 16 | 0) >> 2] = $7;
    }
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
    $254 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[i64toi32_i32$0 >> 2] = $254;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[((i64toi32_i32$2 + 8 | 0) + 8 | 0) >> 2] | 0;
   }
   global$0 = $3 + 144 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1048619 | 0, 32 | 0, 1048744 | 0);
  abort();
 }
 
 function $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__clone_subtree__hea30e1a0150984fa($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $4 = 0, $11 = 0, $10 = 0, $5 = 0, $6 = 0, $7 = 0, $8 = 0, $9 = 0, $33 = 0, $34 = 0, $35 = 0, $36 = 0, $37 = 0, $38 = 0, $39 = 0, $12 = 0, $13 = 0, $42 = 0, $49 = 0, $52 = 0, $70 = 0, $74 = 0, $78 = 0, $90 = 0, $169 = 0, $176 = 0, $179 = 0, $14 = 0, $203 = 0, $208 = 0, $211 = 0, $221 = 0, $254 = 0;
  $3 = global$0 - 144 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     if ($1) {
      break label$3
     }
     $4 = alloc__boxed__Box_T_2cA___new_uninit_in__h8bd6a5af2b5d8b6d() | 0;
     HEAP16[($4 + 138 | 0) >> 1] = 0;
     HEAP32[$4 >> 2] = 0;
     $5 = 0;
     label$4 : {
      if (!(HEAPU16[($2 + 138 | 0) >> 1] | 0)) {
       break label$4
      }
      $6 = $2 + 4 | 0;
      $1 = $2 + 140 | 0;
      $5 = 0;
      label$5 : while (1) {
       $7 = ($3 + 96 | 0) + 24 | 0;
       $33 = $1 + 24 | 0;
       HEAP32[$7 >> 2] = HEAPU8[$33 >> 0] | 0 | ((HEAPU8[($33 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($33 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($33 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $8 = ($3 + 96 | 0) + 16 | 0;
       i64toi32_i32$2 = $1 + 16 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $42 = i64toi32_i32$0;
       i64toi32_i32$0 = $8;
       HEAP32[i64toi32_i32$0 >> 2] = $42;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       $9 = ($3 + 96 | 0) + 8 | 0;
       i64toi32_i32$2 = $1 + 8 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $49 = i64toi32_i32$1;
       i64toi32_i32$1 = $9;
       HEAP32[i64toi32_i32$1 >> 2] = $49;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = $1;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $52 = i64toi32_i32$0;
       i64toi32_i32$0 = $3;
       HEAP32[($3 + 96 | 0) >> 2] = $52;
       HEAP32[($3 + 100 | 0) >> 2] = i64toi32_i32$1;
       $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h4a35d7ddb2264390($3 + 32 | 0 | 0, $6 | 0);
       $10 = HEAPU16[($4 + 138 | 0) >> 1] | 0;
       if ($10 >>> 0 >= 11 >>> 0) {
        break label$1
       }
       HEAP16[($4 + 138 | 0) >> 1] = $10 + 1 | 0;
       $11 = $4 + Math_imul($10, 28) | 0;
       i64toi32_i32$2 = $3;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 100 | 0) >> 2] | 0;
       $70 = i64toi32_i32$1;
       i64toi32_i32$1 = $11 + 140 | 0;
       $34 = $70;
       HEAP8[i64toi32_i32$1 >> 0] = $34;
       HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $34 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $34 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $34 >>> 24 | 0;
       HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
       HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
       i64toi32_i32$2 = $9;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $74 = i64toi32_i32$0;
       i64toi32_i32$0 = $11 + 148 | 0;
       $35 = $74;
       HEAP8[i64toi32_i32$0 >> 0] = $35;
       HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $35 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $35 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $35 >>> 24 | 0;
       HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
       HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
       i64toi32_i32$2 = $8;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $78 = i64toi32_i32$1;
       i64toi32_i32$1 = $11 + 156 | 0;
       $36 = $78;
       HEAP8[i64toi32_i32$1 >> 0] = $36;
       HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $36 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $36 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $36 >>> 24 | 0;
       HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
       HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
       $37 = $11 + 164 | 0;
       $38 = HEAP32[$7 >> 2] | 0;
       HEAP8[$37 >> 0] = $38;
       HEAP8[($37 + 1 | 0) >> 0] = $38 >>> 8 | 0;
       HEAP8[($37 + 2 | 0) >> 0] = $38 >>> 16 | 0;
       HEAP8[($37 + 3 | 0) >> 0] = $38 >>> 24 | 0;
       $10 = $4 + Math_imul($10, 12) | 0;
       i64toi32_i32$2 = $3;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
       $90 = i64toi32_i32$0;
       i64toi32_i32$0 = $10 + 4 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $90;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       HEAP32[($10 + 12 | 0) >> 2] = HEAP32[((i64toi32_i32$2 + 32 | 0) + 8 | 0) >> 2] | 0;
       $6 = $6 + 12 | 0;
       $1 = $1 + 28 | 0;
       $5 = $5 + 1 | 0;
       if ($5 >>> 0 < (HEAPU16[($2 + 138 | 0) >> 1] | 0) >>> 0) {
        continue label$5
       }
       break label$5;
      };
     }
     HEAP32[($0 + 8 | 0) >> 2] = $5;
     HEAP32[($0 + 4 | 0) >> 2] = $4;
     HEAP32[$0 >> 2] = 0;
     break label$2;
    }
    $12 = $1 + -1 | 0;
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__clone_subtree__hea30e1a0150984fa($3 + 8 | 0 | 0, $12 | 0, HEAP32[($2 + 448 | 0) >> 2] | 0 | 0);
    label$6 : {
     label$7 : {
      $4 = HEAP32[($3 + 12 | 0) >> 2] | 0;
      if (!$4) {
       break label$7
      }
      $11 = (HEAP32[($3 + 8 | 0) >> 2] | 0) + 1 | 0;
      break label$6;
     }
     $4 = alloc__boxed__Box_T_2cA___new_uninit_in__h8bd6a5af2b5d8b6d() | 0;
     HEAP16[($4 + 138 | 0) >> 1] = 0;
     HEAP32[$4 >> 2] = 0;
     $11 = 1;
    }
    $1 = alloc__boxed__Box_T_2cA___new_uninit_in__h4be0289855654d00() | 0;
    HEAP32[($1 + 448 | 0) >> 2] = $4;
    $10 = 0;
    HEAP16[($1 + 138 | 0) >> 1] = 0;
    HEAP32[$1 >> 2] = 0;
    HEAP32[$4 >> 2] = $1;
    HEAP16[($4 + 136 | 0) >> 1] = 0;
    HEAP32[($3 + 12 | 0) >> 2] = $1;
    HEAP32[($3 + 8 | 0) >> 2] = $11;
    HEAP32[($3 + 28 | 0) >> 2] = $1;
    HEAP32[($3 + 24 | 0) >> 2] = $11;
    label$8 : {
     if (!(HEAPU16[($2 + 138 | 0) >> 1] | 0)) {
      break label$8
     }
     $11 = $2 + 4 | 0;
     $1 = $2 + 140 | 0;
     $6 = $2 + 452 | 0;
     $7 = HEAP32[($3 + 16 | 0) >> 2] | 0;
     label$9 : while (1) {
      $8 = ($3 + 32 | 0) + 24 | 0;
      $39 = $1 + 24 | 0;
      HEAP32[$8 >> 2] = HEAPU8[$39 >> 0] | 0 | ((HEAPU8[($39 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($39 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($39 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $9 = ($3 + 32 | 0) + 16 | 0;
      i64toi32_i32$2 = $1 + 16 | 0;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $169 = i64toi32_i32$1;
      i64toi32_i32$1 = $9;
      HEAP32[i64toi32_i32$1 >> 2] = $169;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      $13 = ($3 + 32 | 0) + 8 | 0;
      i64toi32_i32$2 = $1 + 8 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $176 = i64toi32_i32$0;
      i64toi32_i32$0 = $13;
      HEAP32[i64toi32_i32$0 >> 2] = $176;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $1;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $179 = i64toi32_i32$1;
      i64toi32_i32$1 = $3;
      HEAP32[(i64toi32_i32$1 + 32 | 0) >> 2] = $179;
      HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] = i64toi32_i32$0;
      $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h4a35d7ddb2264390(i64toi32_i32$1 + 64 | 0 | 0, $11 | 0);
      $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__clone_subtree__hea30e1a0150984fa(i64toi32_i32$1 + 80 | 0 | 0, $12 | 0, HEAP32[$6 >> 2] | 0 | 0);
      $14 = HEAP32[(i64toi32_i32$1 + 88 | 0) >> 2] | 0;
      $4 = HEAP32[(i64toi32_i32$1 + 84 | 0) >> 2] | 0;
      $5 = HEAP32[(i64toi32_i32$1 + 80 | 0) >> 2] | 0;
      HEAP32[((i64toi32_i32$1 + 96 | 0) + 24 | 0) >> 2] = HEAP32[$8 >> 2] | 0;
      i64toi32_i32$2 = $9;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $203 = i64toi32_i32$0;
      i64toi32_i32$0 = ($3 + 96 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $203;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $13;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $208 = i64toi32_i32$1;
      i64toi32_i32$1 = ($3 + 96 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $208;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $3;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
      $211 = i64toi32_i32$0;
      i64toi32_i32$0 = i64toi32_i32$2;
      HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] = $211;
      HEAP32[(i64toi32_i32$2 + 100 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[((i64toi32_i32$2 + 128 | 0) + 8 | 0) >> 2] = HEAP32[((i64toi32_i32$2 + 64 | 0) + 8 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
      $221 = i64toi32_i32$1;
      i64toi32_i32$1 = i64toi32_i32$2;
      HEAP32[(i64toi32_i32$2 + 128 | 0) >> 2] = $221;
      HEAP32[(i64toi32_i32$2 + 132 | 0) >> 2] = i64toi32_i32$0;
      $10 = $10 + 1 | 0;
      label$10 : {
       if ($4) {
        break label$10
       }
       $5 = 0;
       $4 = alloc__boxed__Box_T_2cA___new_uninit_in__h8bd6a5af2b5d8b6d() | 0;
       HEAP16[($4 + 138 | 0) >> 1] = 0;
       HEAP32[$4 >> 2] = 0;
      }
      alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal___push__h46c23fc0db2aa9a2($3 + 24 | 0 | 0, $3 + 96 | 0 | 0, $3 + 128 | 0 | 0, $5 | 0, $4 | 0);
      $11 = $11 + 12 | 0;
      $1 = $1 + 28 | 0;
      $6 = $6 + 4 | 0;
      $7 = ($14 + $7 | 0) + 1 | 0;
      if ($10 >>> 0 < (HEAPU16[($2 + 138 | 0) >> 1] | 0) >>> 0) {
       continue label$9
      }
      break label$9;
     };
     HEAP32[($3 + 16 | 0) >> 2] = $7;
    }
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
    $254 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[i64toi32_i32$0 >> 2] = $254;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[((i64toi32_i32$2 + 8 | 0) + 8 | 0) >> 2] | 0;
   }
   global$0 = $3 + 144 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1048619 | 0, 32 | 0, 1048744 | 0);
  abort();
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__StakeDelegation___deserialize__h6b9919e2fbcd8be7($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $7 = 0, $8 = 0, $7$hi = 0, $3 = 0, $8$hi = 0, $39 = 0, $40 = 0, $41 = 0, $42 = 0, $43 = 0, $45 = 0, $46 = 0, $47 = 0, $48 = 0, $49 = 0, $50 = 0, $52 = 0, $53 = 0, $54 = 0, $55 = 0, $56 = 0, $4 = 0, $5 = 0, $57 = 0, $58 = 0, $59 = 0, $60 = 0, $44 = 0, $51 = 0, $72 = 0, $6 = 0, $96 = 0, $130 = 0, $134 = 0, $138 = 0, $170 = 0, $170$hi = 0, $173 = 0, $173$hi = 0, $177$hi = 0, $179$hi = 0, $181$hi = 0, $184 = 0, $184$hi = 0, $199 = 0, $204 = 0, $208 = 0, $224 = 0, $228 = 0, $233 = 0, $238 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 32 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 40 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 44 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      i64toi32_i32$2 = $2;
      i64toi32_i32$1 = HEAP32[($2 + 32 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($2 + 36 | 0) >> 2] | 0;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 1;
      if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
       break label$4
      }
      i64toi32_i32$2 = $7$hi;
      i64toi32_i32$0 = i64toi32_i32$2;
      cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__StakeDelegation___deserialize_as_embedded_group__he2a305551fe9e1ea($2 + 32 | 0 | 0, $1 | 0, $7 | 0, i64toi32_i32$0 | 0, $7 | 0, i64toi32_i32$0 | 0);
      label$5 : {
       label$6 : {
        label$7 : {
         i64toi32_i32$3 = $7;
         i64toi32_i32$2 = 0;
         i64toi32_i32$1 = 1;
         if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) | 0) {
          break label$7
         }
         cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 128 | 0 | 0, $1 | 0);
         $3 = HEAPU8[($2 + 136 | 0) >> 0] | 0;
         i64toi32_i32$1 = $2;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 128 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] | 0;
         i64toi32_i32$1 = i64toi32_i32$3;
         i64toi32_i32$3 = 0;
         i64toi32_i32$2 = 1;
         if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) | 0) {
          break label$6
         }
         $1 = 5;
         if (($3 & 255 | 0 | 0) != (5 | 0)) {
          break label$5
         }
        }
        $4 = $2 + 8 | 0;
        i64toi32_i32$2 = ($2 + 32 | 0) + 40 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $44 = i64toi32_i32$1;
        i64toi32_i32$1 = $4;
        HEAP32[i64toi32_i32$1 >> 2] = $44;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        $5 = $2 + 16 | 0;
        i64toi32_i32$2 = ($2 + 32 | 0) + 48 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $51 = i64toi32_i32$0;
        i64toi32_i32$0 = $5;
        HEAP32[i64toi32_i32$0 >> 2] = $51;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        HEAP32[($2 + 104 | 0) >> 2] = HEAPU8[($2 + 33 | 0) >> 0] | 0 | ((HEAPU8[($2 + 34 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 35 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 36 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $39 = HEAPU8[($2 + 36 | 0) >> 0] | 0 | ((HEAPU8[($2 + 37 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 38 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 39 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 107 | 0) >> 0] = $39;
        HEAP8[($2 + 108 | 0) >> 0] = $39 >>> 8 | 0;
        HEAP8[($2 + 109 | 0) >> 0] = $39 >>> 16 | 0;
        HEAP8[($2 + 110 | 0) >> 0] = $39 >>> 24 | 0;
        $40 = ($2 + 32 | 0) + 9 | 0;
        HEAP32[($2 + 24 | 0) >> 2] = HEAPU8[$40 >> 0] | 0 | ((HEAPU8[($40 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($40 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($40 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $41 = ($2 + 32 | 0) + 12 | 0;
        $42 = HEAPU8[$41 >> 0] | 0 | ((HEAPU8[($41 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($41 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($41 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 27 | 0) >> 0] = $42;
        HEAP8[($2 + 28 | 0) >> 0] = $42 >>> 8 | 0;
        HEAP8[($2 + 29 | 0) >> 0] = $42 >>> 16 | 0;
        HEAP8[($2 + 30 | 0) >> 0] = $42 >>> 24 | 0;
        i64toi32_i32$2 = ($2 + 32 | 0) + 32 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $72 = i64toi32_i32$1;
        i64toi32_i32$1 = $2;
        HEAP32[$2 >> 2] = $72;
        HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$0;
        $1 = HEAPU8[(($2 + 32 | 0) + 8 | 0) >> 0] | 0;
        i64toi32_i32$2 = ($2 + 32 | 0) + 16 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $7 = i64toi32_i32$0;
        $7$hi = i64toi32_i32$1;
        i64toi32_i32$2 = ($2 + 32 | 0) + 24 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $8 = i64toi32_i32$1;
        $8$hi = i64toi32_i32$0;
        $6 = HEAPU8[($2 + 32 | 0) >> 0] | 0;
        HEAP32[(($2 + 128 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 100 | 0) >> 2] | 0;
        i64toi32_i32$2 = $2 + 92 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $96 = i64toi32_i32$0;
        i64toi32_i32$0 = $2;
        HEAP32[($2 + 128 | 0) >> 2] = $96;
        HEAP32[($2 + 132 | 0) >> 2] = i64toi32_i32$1;
        $3 = HEAP32[(($2 + 32 | 0) + 56 | 0) >> 2] | 0;
        if (($6 | 0) == (1 | 0)) {
         break label$2
        }
        $43 = HEAP32[($2 + 104 | 0) >> 2] | 0;
        HEAP8[($0 + 1 | 0) >> 0] = $43;
        HEAP8[($0 + 2 | 0) >> 0] = $43 >>> 8 | 0;
        HEAP8[($0 + 3 | 0) >> 0] = $43 >>> 16 | 0;
        HEAP8[($0 + 4 | 0) >> 0] = $43 >>> 24 | 0;
        $45 = $0 + 4 | 0;
        $46 = HEAPU8[($2 + 107 | 0) >> 0] | 0 | ((HEAPU8[($2 + 108 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 109 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 110 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[$45 >> 0] = $46;
        HEAP8[($45 + 1 | 0) >> 0] = $46 >>> 8 | 0;
        HEAP8[($45 + 2 | 0) >> 0] = $46 >>> 16 | 0;
        HEAP8[($45 + 3 | 0) >> 0] = $46 >>> 24 | 0;
        HEAP8[($0 + 8 | 0) >> 0] = $1;
        $47 = $0 + 9 | 0;
        $48 = HEAP32[($2 + 24 | 0) >> 2] | 0;
        HEAP8[$47 >> 0] = $48;
        HEAP8[($47 + 1 | 0) >> 0] = $48 >>> 8 | 0;
        HEAP8[($47 + 2 | 0) >> 0] = $48 >>> 16 | 0;
        HEAP8[($47 + 3 | 0) >> 0] = $48 >>> 24 | 0;
        $49 = $0 + 12 | 0;
        $50 = HEAPU8[($2 + 27 | 0) >> 0] | 0 | ((HEAPU8[($2 + 28 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 29 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 30 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[$49 >> 0] = $50;
        HEAP8[($49 + 1 | 0) >> 0] = $50 >>> 8 | 0;
        HEAP8[($49 + 2 | 0) >> 0] = $50 >>> 16 | 0;
        HEAP8[($49 + 3 | 0) >> 0] = $50 >>> 24 | 0;
        i64toi32_i32$1 = $8$hi;
        i64toi32_i32$0 = $0 + 24 | 0;
        HEAP8[i64toi32_i32$0 >> 0] = $8;
        HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $8 >>> 8 | 0;
        HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $8 >>> 16 | 0;
        HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $8 >>> 24 | 0;
        HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
        HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
        HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
        HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
        i64toi32_i32$1 = $7$hi;
        i64toi32_i32$0 = $0 + 16 | 0;
        HEAP8[i64toi32_i32$0 >> 0] = $7;
        HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $7 >>> 8 | 0;
        HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $7 >>> 16 | 0;
        HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $7 >>> 24 | 0;
        HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
        HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
        HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
        HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
        $130 = i64toi32_i32$1;
        i64toi32_i32$1 = $0 + 32 | 0;
        $52 = $130;
        HEAP8[i64toi32_i32$1 >> 0] = $52;
        HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $52 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $52 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $52 >>> 24 | 0;
        HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
        HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
        i64toi32_i32$2 = $4;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $134 = i64toi32_i32$0;
        i64toi32_i32$0 = $0 + 40 | 0;
        $53 = $134;
        HEAP8[i64toi32_i32$0 >> 0] = $53;
        HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $53 >>> 8 | 0;
        HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $53 >>> 16 | 0;
        HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $53 >>> 24 | 0;
        HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
        HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
        HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
        HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
        i64toi32_i32$2 = $5;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $138 = i64toi32_i32$1;
        i64toi32_i32$1 = $0 + 48 | 0;
        $54 = $138;
        HEAP8[i64toi32_i32$1 >> 0] = $54;
        HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $54 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $54 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $54 >>> 24 | 0;
        HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
        HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
        $57 = $0 + 56 | 0;
        HEAP8[$57 >> 0] = $3;
        HEAP8[($57 + 1 | 0) >> 0] = $3 >>> 8 | 0;
        $1 = 0;
        break label$1;
       }
       i64toi32_i32$2 = $2 + 160 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $7 = i64toi32_i32$0;
       $7$hi = i64toi32_i32$1;
       i64toi32_i32$0 = ($2 + 104 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $7;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $2 + 168 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $8 = i64toi32_i32$1;
       $8$hi = i64toi32_i32$0;
       i64toi32_i32$1 = ($2 + 104 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $8;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$0 = $7$hi;
       i64toi32_i32$1 = $2 + 8 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $7;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$0 = $8$hi;
       i64toi32_i32$1 = $2 + 16 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $8;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = $2 + 152 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $7 = i64toi32_i32$0;
       $7$hi = i64toi32_i32$1;
       i64toi32_i32$0 = $2;
       HEAP32[($2 + 104 | 0) >> 2] = $7;
       HEAP32[($2 + 108 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$0 = $2;
       HEAP32[$2 >> 2] = $7;
       HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $2;
       i64toi32_i32$1 = HEAPU8[($2 + 137 | 0) >> 0] | 0 | ((HEAPU8[($2 + 138 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 139 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 140 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = 0;
       $170 = i64toi32_i32$1;
       $170$hi = i64toi32_i32$0;
       i64toi32_i32$2 = $2 + 141 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
       i64toi32_i32$1 = 0;
       $173 = i64toi32_i32$0;
       $173$hi = i64toi32_i32$1;
       i64toi32_i32$2 = $2 + 143 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$2 = i64toi32_i32$1;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $58 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
        $58 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       $177$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $173$hi;
       i64toi32_i32$0 = $173;
       i64toi32_i32$2 = $177$hi;
       i64toi32_i32$3 = $58;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
       i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        $59 = 0;
       } else {
        i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
        $59 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       }
       $179$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $170$hi;
       i64toi32_i32$2 = $170;
       i64toi32_i32$1 = $179$hi;
       i64toi32_i32$3 = $59;
       i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 8;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $60 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $60 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       $181$hi = i64toi32_i32$2;
       i64toi32_i32$2 = 0;
       i64toi32_i32$1 = $3;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 255;
       i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
       $184 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
       $184$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $181$hi;
       i64toi32_i32$2 = $60;
       i64toi32_i32$1 = $184$hi;
       i64toi32_i32$3 = $184;
       i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
       $7 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       $7$hi = i64toi32_i32$1;
       i64toi32_i32$0 = ($2 + 128 | 0) + 16 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
       $8 = i64toi32_i32$1;
       $8$hi = i64toi32_i32$2;
       $1 = 2;
      }
      if (!(HEAPU8[($2 + 32 | 0) >> 0] | 0)) {
       break label$3
      }
      core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9($2 + 40 | 0 | 0);
      break label$3;
     }
     i64toi32_i32$0 = $2 + 64 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $199 = i64toi32_i32$2;
     i64toi32_i32$2 = $2 + 8 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $199;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$0 = $2 + 72 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $204 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 16 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $204;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$0 = $2 + 56 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $208 = i64toi32_i32$2;
     i64toi32_i32$2 = $2;
     HEAP32[$2 >> 2] = $208;
     HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$0 = ($2 + 32 | 0) + 16 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $8 = i64toi32_i32$1;
     $8$hi = i64toi32_i32$2;
     $1 = 2;
    }
    $3 = 0;
   }
   i64toi32_i32$2 = $8$hi;
   i64toi32_i32$1 = ($2 + 32 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $8;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$2 = $7$hi;
   i64toi32_i32$1 = ($2 + 32 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $7;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = $2;
   i64toi32_i32$2 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $224 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 56 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $224;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$0 = $2;
   i64toi32_i32$1 = HEAP32[($2 + 128 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($2 + 132 | 0) >> 2] | 0;
   $228 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 84 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $228;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = $2 + 8 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $233 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 64 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $233;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$0 = $2 + 16 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $238 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 72 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $238;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
   HEAP32[($2 + 92 | 0) >> 2] = HEAP32[(($2 + 128 | 0) + 8 | 0) >> 2] | 0;
   HEAP8[($2 + 32 | 0) >> 0] = $1;
   $55 = HEAP32[($2 + 24 | 0) >> 2] | 0;
   HEAP8[($2 + 33 | 0) >> 0] = $55;
   HEAP8[($2 + 34 | 0) >> 0] = $55 >>> 8 | 0;
   HEAP8[($2 + 35 | 0) >> 0] = $55 >>> 16 | 0;
   HEAP8[($2 + 36 | 0) >> 0] = $55 >>> 24 | 0;
   $56 = HEAPU8[($2 + 27 | 0) >> 0] | 0 | ((HEAPU8[($2 + 28 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 29 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 30 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[($2 + 36 | 0) >> 0] = $56;
   HEAP8[($2 + 37 | 0) >> 0] = $56 >>> 8 | 0;
   HEAP8[($2 + 38 | 0) >> 0] = $56 >>> 16 | 0;
   HEAP8[($2 + 39 | 0) >> 0] = $56 >>> 24 | 0;
   HEAP32[($2 + 80 | 0) >> 2] = $3;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 32 | 0 | 0, 1050808 | 0, 15 | 0);
   $1 = 1;
  }
  HEAP8[$0 >> 0] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__OperationalCert___deserialize__he0f26523763e73af($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $8 = 0, $8$hi = 0, $9 = 0, $3 = 0, $9$hi = 0, $39 = 0, $40 = 0, $41 = 0, $42 = 0, $43 = 0, $44 = 0, $45 = 0, $47 = 0, $48 = 0, $49 = 0, $4 = 0, $5 = 0, $50 = 0, $51 = 0, $52 = 0, $46 = 0, $54 = 0, $67 = 0, $6 = 0, $7 = 0, $117 = 0, $124 = 0, $128 = 0, $164 = 0, $164$hi = 0, $167 = 0, $167$hi = 0, $171$hi = 0, $173$hi = 0, $175$hi = 0, $178 = 0, $178$hi = 0, $193 = 0, $199 = 0, $203 = 0, $219 = 0, $223 = 0, $229 = 0, $235 = 0;
  $2 = global$0 - 224 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 88 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 96 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 100 | 0) >> 2] | 0;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      i64toi32_i32$2 = $2;
      i64toi32_i32$1 = HEAP32[($2 + 88 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($2 + 92 | 0) >> 2] | 0;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 1;
      if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
       break label$4
      }
      i64toi32_i32$2 = $8$hi;
      i64toi32_i32$0 = i64toi32_i32$2;
      cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__OperationalCert___deserialize_as_embedded_group__h5685b082c2c28803($2 + 88 | 0 | 0, $1 | 0, $8 | 0, i64toi32_i32$0 | 0, $8 | 0, i64toi32_i32$0 | 0);
      label$5 : {
       label$6 : {
        label$7 : {
         i64toi32_i32$3 = $8;
         i64toi32_i32$2 = 0;
         i64toi32_i32$1 = 1;
         if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) | 0) {
          break label$7
         }
         cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 8 | 0 | 0, $1 | 0);
         $3 = HEAPU8[($2 + 16 | 0) >> 0] | 0;
         i64toi32_i32$1 = $2;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] | 0;
         i64toi32_i32$1 = i64toi32_i32$3;
         i64toi32_i32$3 = 0;
         i64toi32_i32$2 = 1;
         if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) | 0) {
          break label$6
         }
         $1 = 5;
         if (($3 & 255 | 0 | 0) != (5 | 0)) {
          break label$5
         }
        }
        $4 = ($2 + 64 | 0) + 8 | 0;
        i64toi32_i32$2 = ($2 + 88 | 0) + 40 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $46 = i64toi32_i32$1;
        i64toi32_i32$1 = $4;
        HEAP32[i64toi32_i32$1 >> 2] = $46;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        $5 = ($2 + 64 | 0) + 16 | 0;
        i64toi32_i32$2 = ($2 + 88 | 0) + 48 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $54 = i64toi32_i32$0;
        i64toi32_i32$0 = $5;
        HEAP32[i64toi32_i32$0 >> 2] = $54;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        HEAP32[($2 + 200 | 0) >> 2] = HEAPU8[($2 + 97 | 0) >> 0] | 0 | ((HEAPU8[($2 + 98 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 99 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 100 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $39 = ($2 + 88 | 0) + 12 | 0;
        $40 = HEAPU8[$39 >> 0] | 0 | ((HEAPU8[($39 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($39 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($39 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 203 | 0) >> 0] = $40;
        HEAP8[($2 + 204 | 0) >> 0] = $40 >>> 8 | 0;
        HEAP8[($2 + 205 | 0) >> 0] = $40 >>> 16 | 0;
        HEAP8[($2 + 206 | 0) >> 0] = $40 >>> 24 | 0;
        i64toi32_i32$2 = ($2 + 88 | 0) + 32 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $67 = i64toi32_i32$1;
        i64toi32_i32$1 = $2;
        HEAP32[($2 + 64 | 0) >> 2] = $67;
        HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$0;
        $1 = HEAPU8[(($2 + 88 | 0) + 8 | 0) >> 0] | 0;
        i64toi32_i32$2 = ($2 + 88 | 0) + 16 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $8 = i64toi32_i32$0;
        $8$hi = i64toi32_i32$1;
        i64toi32_i32$2 = ($2 + 88 | 0) + 24 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $9 = i64toi32_i32$1;
        $9$hi = i64toi32_i32$0;
        $3 = HEAP32[(($2 + 88 | 0) + 56 | 0) >> 2] | 0;
        $6 = HEAP32[($2 + 92 | 0) >> 2] | 0;
        $7 = HEAP32[($2 + 88 | 0) >> 2] | 0;
        memcpy($2 + 8 | 0 | 0, ($2 + 88 | 0) + 60 | 0 | 0, 52 | 0) | 0;
        if (($7 | 0) == (1 | 0)) {
         break label$2
        }
        HEAP32[($0 + 4 | 0) >> 2] = $6;
        $41 = HEAP32[($2 + 200 | 0) >> 2] | 0;
        HEAP8[($0 + 9 | 0) >> 0] = $41;
        HEAP8[($0 + 10 | 0) >> 0] = $41 >>> 8 | 0;
        HEAP8[($0 + 11 | 0) >> 0] = $41 >>> 16 | 0;
        HEAP8[($0 + 12 | 0) >> 0] = $41 >>> 24 | 0;
        HEAP8[($0 + 8 | 0) >> 0] = $1;
        $42 = $0 + 12 | 0;
        $43 = HEAPU8[($2 + 203 | 0) >> 0] | 0 | ((HEAPU8[($2 + 204 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 205 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 206 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[$42 >> 0] = $43;
        HEAP8[($42 + 1 | 0) >> 0] = $43 >>> 8 | 0;
        HEAP8[($42 + 2 | 0) >> 0] = $43 >>> 16 | 0;
        HEAP8[($42 + 3 | 0) >> 0] = $43 >>> 24 | 0;
        i64toi32_i32$0 = $9$hi;
        i64toi32_i32$1 = $0 + 24 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $9;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$0 = $8$hi;
        i64toi32_i32$1 = $0 + 16 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $8;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 64 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 68 | 0) >> 2] | 0;
        $117 = i64toi32_i32$0;
        i64toi32_i32$0 = $0 + 32 | 0;
        $44 = $117;
        HEAP8[i64toi32_i32$0 >> 0] = $44;
        HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $44 >>> 8 | 0;
        HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $44 >>> 16 | 0;
        HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $44 >>> 24 | 0;
        HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
        HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
        HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
        HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
        HEAP32[($0 + 56 | 0) >> 2] = $3;
        i64toi32_i32$2 = $4;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $124 = i64toi32_i32$1;
        i64toi32_i32$1 = $0 + 40 | 0;
        $45 = $124;
        HEAP8[i64toi32_i32$1 >> 0] = $45;
        HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $45 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $45 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $45 >>> 24 | 0;
        HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
        HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
        i64toi32_i32$2 = $5;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $128 = i64toi32_i32$0;
        i64toi32_i32$0 = $0 + 48 | 0;
        $47 = $128;
        HEAP8[i64toi32_i32$0 >> 0] = $47;
        HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $47 >>> 8 | 0;
        HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $47 >>> 16 | 0;
        HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $47 >>> 24 | 0;
        HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
        HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
        HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
        HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
        memcpy($0 + 60 | 0 | 0, $2 + 8 | 0 | 0, 48 | 0) | 0;
        $1 = 0;
        break label$1;
       }
       i64toi32_i32$2 = $2 + 40 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $8 = i64toi32_i32$1;
       $8$hi = i64toi32_i32$0;
       i64toi32_i32$1 = ($2 + 200 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $8;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = $2 + 48 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $9 = i64toi32_i32$0;
       $9$hi = i64toi32_i32$1;
       i64toi32_i32$0 = ($2 + 200 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $9;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$1 = $8$hi;
       i64toi32_i32$0 = ($2 + 64 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $8;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$1 = $9$hi;
       i64toi32_i32$0 = ($2 + 64 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $9;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $2 + 32 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $8 = i64toi32_i32$1;
       $8$hi = i64toi32_i32$0;
       i64toi32_i32$1 = $2;
       HEAP32[($2 + 200 | 0) >> 2] = $8;
       HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$1 = $2;
       HEAP32[($2 + 64 | 0) >> 2] = $8;
       HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = $2;
       i64toi32_i32$0 = HEAPU8[($2 + 17 | 0) >> 0] | 0 | ((HEAPU8[($2 + 18 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 19 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 20 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = 0;
       $164 = i64toi32_i32$0;
       $164$hi = i64toi32_i32$1;
       i64toi32_i32$2 = $2 + 21 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
       i64toi32_i32$0 = 0;
       $167 = i64toi32_i32$1;
       $167$hi = i64toi32_i32$0;
       i64toi32_i32$2 = $2 + 23 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$2 = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $50 = 0;
       } else {
        i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $50 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       $171$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $167$hi;
       i64toi32_i32$1 = $167;
       i64toi32_i32$2 = $171$hi;
       i64toi32_i32$3 = $50;
       i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
       i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $51 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
        $51 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       $173$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $164$hi;
       i64toi32_i32$2 = $164;
       i64toi32_i32$0 = $173$hi;
       i64toi32_i32$3 = $51;
       i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
       i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 8;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        $52 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
        $52 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       }
       $175$hi = i64toi32_i32$2;
       i64toi32_i32$2 = 0;
       i64toi32_i32$0 = $3;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 255;
       i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
       $178 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
       $178$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $175$hi;
       i64toi32_i32$2 = $52;
       i64toi32_i32$0 = $178$hi;
       i64toi32_i32$3 = $178;
       i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
       $8 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       $8$hi = i64toi32_i32$0;
       i64toi32_i32$1 = ($2 + 8 | 0) + 16 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $9 = i64toi32_i32$0;
       $9$hi = i64toi32_i32$2;
       $1 = 2;
      }
      if (!(HEAP32[($2 + 88 | 0) >> 2] | 0)) {
       break label$3
      }
      core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9($2 + 96 | 0 | 0);
      break label$3;
     }
     i64toi32_i32$1 = $2 + 120 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $193 = i64toi32_i32$2;
     i64toi32_i32$2 = $2 + 72 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $193;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$1 = $2 + 128 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $199 = i64toi32_i32$0;
     i64toi32_i32$0 = ($2 + 64 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $199;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$1 = $2 + 112 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $203 = i64toi32_i32$2;
     i64toi32_i32$2 = $2;
     HEAP32[($2 + 64 | 0) >> 2] = $203;
     HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$1 = ($2 + 88 | 0) + 16 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $9 = i64toi32_i32$0;
     $9$hi = i64toi32_i32$2;
     $1 = 2;
    }
    $3 = 0;
   }
   i64toi32_i32$2 = $9$hi;
   i64toi32_i32$0 = ($2 + 88 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $9;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$2 = $8$hi;
   i64toi32_i32$0 = ($2 + 88 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $8;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$1 = $2;
   i64toi32_i32$2 = HEAP32[($2 + 64 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 68 | 0) >> 2] | 0;
   $219 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 112 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $219;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$1 = $2;
   i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $223 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 140 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $223;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$1 = ($2 + 64 | 0) + 8 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $229 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 120 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $229;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$1 = ($2 + 64 | 0) + 16 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $235 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 128 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $235;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   HEAP32[($2 + 148 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
   HEAP8[($2 + 88 | 0) >> 0] = $1;
   $48 = HEAP32[($2 + 200 | 0) >> 2] | 0;
   HEAP8[($2 + 89 | 0) >> 0] = $48;
   HEAP8[($2 + 90 | 0) >> 0] = $48 >>> 8 | 0;
   HEAP8[($2 + 91 | 0) >> 0] = $48 >>> 16 | 0;
   HEAP8[($2 + 92 | 0) >> 0] = $48 >>> 24 | 0;
   $49 = HEAPU8[($2 + 203 | 0) >> 0] | 0 | ((HEAPU8[($2 + 204 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 205 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 206 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[($2 + 92 | 0) >> 0] = $49;
   HEAP8[($2 + 93 | 0) >> 0] = $49 >>> 8 | 0;
   HEAP8[($2 + 94 | 0) >> 0] = $49 >>> 16 | 0;
   HEAP8[($2 + 95 | 0) >> 0] = $49 >>> 24 | 0;
   HEAP32[($2 + 136 | 0) >> 2] = $3;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 88 | 0 | 0, 1052812 | 0, 15 | 0);
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 224 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__TransactionOutput___deserialize__haabae074445f3776($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $6 = 0, $6$hi = 0, $3 = 0, $7 = 0, $7$hi = 0, $37 = 0, $38 = 0, $39 = 0, $40 = 0, $41 = 0, $42 = 0, $43 = 0, $45 = 0, $46 = 0, $47 = 0, $4 = 0, $5 = 0, $48 = 0, $49 = 0, $50 = 0, $44 = 0, $52 = 0, $65 = 0, $108 = 0, $115 = 0, $119 = 0, $155 = 0, $155$hi = 0, $158 = 0, $158$hi = 0, $162$hi = 0, $164$hi = 0, $166$hi = 0, $169 = 0, $169$hi = 0, $186 = 0, $192 = 0, $196 = 0, $212 = 0, $216 = 0, $222 = 0, $228 = 0;
  $2 = global$0 - 272 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 112 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 120 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 124 | 0) >> 2] | 0;
  $6 = i64toi32_i32$0;
  $6$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 112 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 116 | 0) >> 2] | 0;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 1;
      if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
       break label$4
      }
      i64toi32_i32$2 = $6$hi;
      i64toi32_i32$0 = i64toi32_i32$2;
      cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__TransactionOutput___deserialize_as_embedded_group__hdb5ba370036b9958($2 + 112 | 0 | 0, $1 | 0, $6 | 0, i64toi32_i32$2 | 0, $6 | 0, i64toi32_i32$2 | 0);
      label$5 : {
       label$6 : {
        label$7 : {
         i64toi32_i32$0 = i64toi32_i32$2;
         i64toi32_i32$0 = i64toi32_i32$2;
         i64toi32_i32$3 = $6;
         i64toi32_i32$2 = 0;
         i64toi32_i32$1 = 1;
         if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) | 0) {
          break label$7
         }
         cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 8 | 0 | 0, $1 | 0);
         $3 = HEAPU8[($2 + 16 | 0) >> 0] | 0;
         i64toi32_i32$1 = $2;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] | 0;
         i64toi32_i32$1 = i64toi32_i32$3;
         i64toi32_i32$3 = 0;
         i64toi32_i32$2 = 1;
         if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) | 0) {
          break label$6
         }
         $1 = 5;
         if (($3 & 255 | 0 | 0) != (5 | 0)) {
          break label$5
         }
        }
        $4 = $2 + 96 | 0;
        i64toi32_i32$2 = ($2 + 112 | 0) + 40 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $44 = i64toi32_i32$1;
        i64toi32_i32$1 = $4;
        HEAP32[i64toi32_i32$1 >> 2] = $44;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        $5 = ($2 + 88 | 0) + 16 | 0;
        i64toi32_i32$2 = ($2 + 112 | 0) + 48 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $52 = i64toi32_i32$0;
        i64toi32_i32$0 = $5;
        HEAP32[i64toi32_i32$0 >> 2] = $52;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        HEAP32[($2 + 248 | 0) >> 2] = HEAPU8[($2 + 121 | 0) >> 0] | 0 | ((HEAPU8[($2 + 122 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 123 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 124 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $37 = ($2 + 112 | 0) + 12 | 0;
        $38 = HEAPU8[$37 >> 0] | 0 | ((HEAPU8[($37 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($37 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($37 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 251 | 0) >> 0] = $38;
        HEAP8[($2 + 252 | 0) >> 0] = $38 >>> 8 | 0;
        HEAP8[($2 + 253 | 0) >> 0] = $38 >>> 16 | 0;
        HEAP8[($2 + 254 | 0) >> 0] = $38 >>> 24 | 0;
        i64toi32_i32$2 = ($2 + 112 | 0) + 32 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $65 = i64toi32_i32$1;
        i64toi32_i32$1 = $2;
        HEAP32[(i64toi32_i32$1 + 88 | 0) >> 2] = $65;
        HEAP32[(i64toi32_i32$1 + 92 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = (i64toi32_i32$1 + 112 | 0) + 16 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $6 = i64toi32_i32$0;
        $6$hi = i64toi32_i32$1;
        i64toi32_i32$2 = ($2 + 112 | 0) + 24 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $7 = i64toi32_i32$1;
        $7$hi = i64toi32_i32$0;
        $3 = HEAP32[(($2 + 112 | 0) + 56 | 0) >> 2] | 0;
        $1 = HEAPU8[($2 + 120 | 0) >> 0] | 0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 112 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 116 | 0) >> 2] | 0;
        memcpy(i64toi32_i32$2 + 8 | 0 | 0, (i64toi32_i32$2 + 112 | 0) + 60 | 0 | 0, 76 | 0) | 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
         break label$2
        }
        HEAP8[($0 + 8 | 0) >> 0] = $1;
        $39 = HEAP32[($2 + 248 | 0) >> 2] | 0;
        HEAP8[($0 + 9 | 0) >> 0] = $39;
        HEAP8[($0 + 10 | 0) >> 0] = $39 >>> 8 | 0;
        HEAP8[($0 + 11 | 0) >> 0] = $39 >>> 16 | 0;
        HEAP8[($0 + 12 | 0) >> 0] = $39 >>> 24 | 0;
        $40 = $0 + 12 | 0;
        $41 = HEAPU8[($2 + 251 | 0) >> 0] | 0 | ((HEAPU8[($2 + 252 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 253 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 254 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[$40 >> 0] = $41;
        HEAP8[($40 + 1 | 0) >> 0] = $41 >>> 8 | 0;
        HEAP8[($40 + 2 | 0) >> 0] = $41 >>> 16 | 0;
        HEAP8[($40 + 3 | 0) >> 0] = $41 >>> 24 | 0;
        i64toi32_i32$2 = $7$hi;
        i64toi32_i32$1 = $0 + 24 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $7;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
        i64toi32_i32$2 = $6$hi;
        i64toi32_i32$1 = $0 + 16 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $6;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
        i64toi32_i32$3 = $2;
        i64toi32_i32$2 = HEAP32[($2 + 88 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 92 | 0) >> 2] | 0;
        $108 = i64toi32_i32$2;
        i64toi32_i32$2 = $0 + 32 | 0;
        $42 = $108;
        HEAP8[i64toi32_i32$2 >> 0] = $42;
        HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $42 >>> 8 | 0;
        HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $42 >>> 16 | 0;
        HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $42 >>> 24 | 0;
        HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$1;
        HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
        HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
        HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
        HEAP32[($0 + 56 | 0) >> 2] = $3;
        i64toi32_i32$3 = $4;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $115 = i64toi32_i32$1;
        i64toi32_i32$1 = $0 + 40 | 0;
        $43 = $115;
        HEAP8[i64toi32_i32$1 >> 0] = $43;
        HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $43 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $43 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $43 >>> 24 | 0;
        HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$2;
        HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
        i64toi32_i32$3 = $5;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $119 = i64toi32_i32$2;
        i64toi32_i32$2 = $0 + 48 | 0;
        $45 = $119;
        HEAP8[i64toi32_i32$2 >> 0] = $45;
        HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $45 >>> 8 | 0;
        HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $45 >>> 16 | 0;
        HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $45 >>> 24 | 0;
        HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$1;
        HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
        HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
        HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
        memcpy($0 + 60 | 0 | 0, $2 + 8 | 0 | 0, 76 | 0) | 0;
        i64toi32_i32$1 = 0;
        $6 = 0;
        $6$hi = i64toi32_i32$1;
        break label$1;
       }
       i64toi32_i32$3 = $2 + 40 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $6 = i64toi32_i32$1;
       $6$hi = i64toi32_i32$2;
       i64toi32_i32$1 = ($2 + 248 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $6;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$3 = $2 + 48 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $7 = i64toi32_i32$2;
       $7$hi = i64toi32_i32$1;
       i64toi32_i32$2 = ($2 + 248 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $7;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$1 = $6$hi;
       i64toi32_i32$2 = ($2 + 88 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $6;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$1 = $7$hi;
       i64toi32_i32$2 = ($2 + 88 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $7;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$3 = $2 + 32 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $6 = i64toi32_i32$1;
       $6$hi = i64toi32_i32$2;
       i64toi32_i32$1 = $2;
       HEAP32[(i64toi32_i32$1 + 248 | 0) >> 2] = $6;
       HEAP32[(i64toi32_i32$1 + 252 | 0) >> 2] = i64toi32_i32$2;
       HEAP32[(i64toi32_i32$1 + 88 | 0) >> 2] = $6;
       HEAP32[(i64toi32_i32$1 + 92 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$3 = i64toi32_i32$1;
       i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 17 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 18 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 19 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 20 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = 0;
       $155 = i64toi32_i32$2;
       $155$hi = i64toi32_i32$1;
       i64toi32_i32$3 = $2 + 21 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
       i64toi32_i32$2 = 0;
       $158 = i64toi32_i32$1;
       $158$hi = i64toi32_i32$2;
       i64toi32_i32$3 = $2 + 23 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$3 >> 0] | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = i64toi32_i32$2;
       i64toi32_i32$2 = 0;
       i64toi32_i32$0 = 16;
       i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
        $48 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $48 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
       }
       $162$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $158$hi;
       i64toi32_i32$1 = $158;
       i64toi32_i32$3 = $162$hi;
       i64toi32_i32$0 = $48;
       i64toi32_i32$3 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$0 = 32;
       i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $49 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$4 | 0) | 0;
        $49 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       $164$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $155$hi;
       i64toi32_i32$3 = $155;
       i64toi32_i32$2 = $164$hi;
       i64toi32_i32$0 = $49;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
       i64toi32_i32$1 = i64toi32_i32$3 | i64toi32_i32$0 | 0;
       i64toi32_i32$3 = 0;
       i64toi32_i32$0 = 8;
       i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
        i64toi32_i32$3 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        $50 = 0;
       } else {
        i64toi32_i32$3 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
        $50 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       }
       $166$hi = i64toi32_i32$3;
       i64toi32_i32$3 = 0;
       i64toi32_i32$2 = $3;
       i64toi32_i32$1 = 0;
       i64toi32_i32$0 = 255;
       i64toi32_i32$1 = i64toi32_i32$3 & i64toi32_i32$1 | 0;
       $169 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
       $169$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $166$hi;
       i64toi32_i32$3 = $50;
       i64toi32_i32$2 = $169$hi;
       i64toi32_i32$0 = $169;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
       $6 = i64toi32_i32$3 | i64toi32_i32$0 | 0;
       $6$hi = i64toi32_i32$2;
       i64toi32_i32$1 = ($2 + 8 | 0) + 16 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $7 = i64toi32_i32$2;
       $7$hi = i64toi32_i32$3;
       $1 = 2;
      }
      $3 = $2 + 120 | 0;
      label$8 : {
       i64toi32_i32$1 = $2;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 112 | 0) >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 116 | 0) >> 2] | 0;
       i64toi32_i32$1 = i64toi32_i32$3;
       i64toi32_i32$3 = 0;
       i64toi32_i32$0 = 0;
       if ((i64toi32_i32$1 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | 0) {
        break label$8
       }
       core__ptr__drop_in_place_cardano_serialization_lib__TransactionOutput___h632b3a99817e6ac5_2($3 | 0);
       break label$3;
      }
      core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9($3 | 0);
      break label$3;
     }
     i64toi32_i32$0 = $2 + 144 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $186 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 96 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $186;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$0 = $2 + 152 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $192 = i64toi32_i32$2;
     i64toi32_i32$2 = ($2 + 88 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $192;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$0 = $2 + 136 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $196 = i64toi32_i32$1;
     i64toi32_i32$1 = $2;
     HEAP32[(i64toi32_i32$1 + 88 | 0) >> 2] = $196;
     HEAP32[(i64toi32_i32$1 + 92 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$0 = (i64toi32_i32$1 + 112 | 0) + 16 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $7 = i64toi32_i32$2;
     $7$hi = i64toi32_i32$1;
     $1 = 2;
    }
    $3 = 0;
   }
   i64toi32_i32$1 = $7$hi;
   i64toi32_i32$2 = ($2 + 112 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $7;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $6$hi;
   i64toi32_i32$2 = ($2 + 112 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $6;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$0 = $2;
   i64toi32_i32$1 = HEAP32[($2 + 88 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($2 + 92 | 0) >> 2] | 0;
   $212 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 136 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $212;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = $2;
   i64toi32_i32$2 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $216 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 164 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $216;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$0 = ($2 + 88 | 0) + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $222 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 144 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $222;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = ($2 + 88 | 0) + 16 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $228 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 152 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $228;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($2 + 172 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
   HEAP8[($2 + 112 | 0) >> 0] = $1;
   $46 = HEAP32[($2 + 248 | 0) >> 2] | 0;
   HEAP8[($2 + 113 | 0) >> 0] = $46;
   HEAP8[($2 + 114 | 0) >> 0] = $46 >>> 8 | 0;
   HEAP8[($2 + 115 | 0) >> 0] = $46 >>> 16 | 0;
   HEAP8[($2 + 116 | 0) >> 0] = $46 >>> 24 | 0;
   $47 = HEAPU8[($2 + 251 | 0) >> 0] | 0 | ((HEAPU8[($2 + 252 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 253 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 254 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[($2 + 116 | 0) >> 0] = $47;
   HEAP8[($2 + 117 | 0) >> 0] = $47 >>> 8 | 0;
   HEAP8[($2 + 118 | 0) >> 0] = $47 >>> 16 | 0;
   HEAP8[($2 + 119 | 0) >> 0] = $47 >>> 24 | 0;
   HEAP32[($2 + 160 | 0) >> 2] = $3;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 112 | 0 | 0, 1050637 | 0, 17 | 0);
   i64toi32_i32$1 = 0;
   $6 = 1;
   $6$hi = i64toi32_i32$1;
  }
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$2 = $0;
  HEAP32[i64toi32_i32$2 >> 2] = $6;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $2 + 272 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__CertificateEnum___deserialize__h3059f65111c7091a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $6 = 0, $6$hi = 0, $3 = 0, $7 = 0, $7$hi = 0, $37 = 0, $38 = 0, $39 = 0, $40 = 0, $41 = 0, $42 = 0, $43 = 0, $45 = 0, $46 = 0, $47 = 0, $4 = 0, $5 = 0, $48 = 0, $49 = 0, $50 = 0, $44 = 0, $52 = 0, $65 = 0, $108 = 0, $115 = 0, $119 = 0, $155 = 0, $155$hi = 0, $158 = 0, $158$hi = 0, $162$hi = 0, $164$hi = 0, $166$hi = 0, $169 = 0, $169$hi = 0, $186 = 0, $192 = 0, $196 = 0, $212 = 0, $216 = 0, $222 = 0, $228 = 0;
  $2 = global$0 - 416 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 184 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 192 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 196 | 0) >> 2] | 0;
  $6 = i64toi32_i32$0;
  $6$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 184 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 188 | 0) >> 2] | 0;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 1;
      if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
       break label$4
      }
      i64toi32_i32$2 = $6$hi;
      i64toi32_i32$0 = i64toi32_i32$2;
      cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__CertificateEnum___deserialize_as_embedded_group__ha6eb74d19a708487($2 + 184 | 0 | 0, $1 | 0, $6 | 0, i64toi32_i32$2 | 0, $6 | 0, i64toi32_i32$2 | 0);
      label$5 : {
       label$6 : {
        label$7 : {
         i64toi32_i32$0 = i64toi32_i32$2;
         i64toi32_i32$0 = i64toi32_i32$2;
         i64toi32_i32$3 = $6;
         i64toi32_i32$2 = 0;
         i64toi32_i32$1 = 1;
         if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) | 0) {
          break label$7
         }
         cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 8 | 0 | 0, $1 | 0);
         $3 = HEAPU8[($2 + 16 | 0) >> 0] | 0;
         i64toi32_i32$1 = $2;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] | 0;
         i64toi32_i32$1 = i64toi32_i32$3;
         i64toi32_i32$3 = 0;
         i64toi32_i32$2 = 1;
         if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) | 0) {
          break label$6
         }
         $1 = 5;
         if (($3 & 255 | 0 | 0) != (5 | 0)) {
          break label$5
         }
        }
        $4 = $2 + 168 | 0;
        i64toi32_i32$2 = ($2 + 184 | 0) + 40 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $44 = i64toi32_i32$1;
        i64toi32_i32$1 = $4;
        HEAP32[i64toi32_i32$1 >> 2] = $44;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        $5 = ($2 + 160 | 0) + 16 | 0;
        i64toi32_i32$2 = ($2 + 184 | 0) + 48 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $52 = i64toi32_i32$0;
        i64toi32_i32$0 = $5;
        HEAP32[i64toi32_i32$0 >> 2] = $52;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        HEAP32[($2 + 392 | 0) >> 2] = HEAPU8[($2 + 193 | 0) >> 0] | 0 | ((HEAPU8[($2 + 194 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 195 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 196 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $37 = ($2 + 184 | 0) + 12 | 0;
        $38 = HEAPU8[$37 >> 0] | 0 | ((HEAPU8[($37 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($37 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($37 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 395 | 0) >> 0] = $38;
        HEAP8[($2 + 396 | 0) >> 0] = $38 >>> 8 | 0;
        HEAP8[($2 + 397 | 0) >> 0] = $38 >>> 16 | 0;
        HEAP8[($2 + 398 | 0) >> 0] = $38 >>> 24 | 0;
        i64toi32_i32$2 = ($2 + 184 | 0) + 32 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $65 = i64toi32_i32$1;
        i64toi32_i32$1 = $2;
        HEAP32[(i64toi32_i32$1 + 160 | 0) >> 2] = $65;
        HEAP32[(i64toi32_i32$1 + 164 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = (i64toi32_i32$1 + 184 | 0) + 16 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $6 = i64toi32_i32$0;
        $6$hi = i64toi32_i32$1;
        i64toi32_i32$2 = ($2 + 184 | 0) + 24 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $7 = i64toi32_i32$1;
        $7$hi = i64toi32_i32$0;
        $3 = HEAP32[(($2 + 184 | 0) + 56 | 0) >> 2] | 0;
        $1 = HEAPU8[($2 + 192 | 0) >> 0] | 0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 184 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 188 | 0) >> 2] | 0;
        memcpy(i64toi32_i32$2 + 8 | 0 | 0, (i64toi32_i32$2 + 184 | 0) + 60 | 0 | 0, 148 | 0) | 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
         break label$2
        }
        HEAP8[($0 + 8 | 0) >> 0] = $1;
        $39 = HEAP32[($2 + 392 | 0) >> 2] | 0;
        HEAP8[($0 + 9 | 0) >> 0] = $39;
        HEAP8[($0 + 10 | 0) >> 0] = $39 >>> 8 | 0;
        HEAP8[($0 + 11 | 0) >> 0] = $39 >>> 16 | 0;
        HEAP8[($0 + 12 | 0) >> 0] = $39 >>> 24 | 0;
        $40 = $0 + 12 | 0;
        $41 = HEAPU8[($2 + 395 | 0) >> 0] | 0 | ((HEAPU8[($2 + 396 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 397 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 398 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[$40 >> 0] = $41;
        HEAP8[($40 + 1 | 0) >> 0] = $41 >>> 8 | 0;
        HEAP8[($40 + 2 | 0) >> 0] = $41 >>> 16 | 0;
        HEAP8[($40 + 3 | 0) >> 0] = $41 >>> 24 | 0;
        i64toi32_i32$2 = $7$hi;
        i64toi32_i32$1 = $0 + 24 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $7;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
        i64toi32_i32$2 = $6$hi;
        i64toi32_i32$1 = $0 + 16 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $6;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
        i64toi32_i32$3 = $2;
        i64toi32_i32$2 = HEAP32[($2 + 160 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 164 | 0) >> 2] | 0;
        $108 = i64toi32_i32$2;
        i64toi32_i32$2 = $0 + 32 | 0;
        $42 = $108;
        HEAP8[i64toi32_i32$2 >> 0] = $42;
        HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $42 >>> 8 | 0;
        HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $42 >>> 16 | 0;
        HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $42 >>> 24 | 0;
        HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$1;
        HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
        HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
        HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
        HEAP32[($0 + 56 | 0) >> 2] = $3;
        i64toi32_i32$3 = $4;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $115 = i64toi32_i32$1;
        i64toi32_i32$1 = $0 + 40 | 0;
        $43 = $115;
        HEAP8[i64toi32_i32$1 >> 0] = $43;
        HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $43 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $43 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $43 >>> 24 | 0;
        HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$2;
        HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
        i64toi32_i32$3 = $5;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $119 = i64toi32_i32$2;
        i64toi32_i32$2 = $0 + 48 | 0;
        $45 = $119;
        HEAP8[i64toi32_i32$2 >> 0] = $45;
        HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $45 >>> 8 | 0;
        HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $45 >>> 16 | 0;
        HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $45 >>> 24 | 0;
        HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$1;
        HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
        HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
        HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
        memcpy($0 + 60 | 0 | 0, $2 + 8 | 0 | 0, 148 | 0) | 0;
        i64toi32_i32$1 = 0;
        $6 = 0;
        $6$hi = i64toi32_i32$1;
        break label$1;
       }
       i64toi32_i32$3 = $2 + 40 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $6 = i64toi32_i32$1;
       $6$hi = i64toi32_i32$2;
       i64toi32_i32$1 = ($2 + 392 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $6;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$3 = $2 + 48 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $7 = i64toi32_i32$2;
       $7$hi = i64toi32_i32$1;
       i64toi32_i32$2 = ($2 + 392 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $7;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$1 = $6$hi;
       i64toi32_i32$2 = ($2 + 160 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $6;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$1 = $7$hi;
       i64toi32_i32$2 = ($2 + 160 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $7;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$3 = $2 + 32 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $6 = i64toi32_i32$1;
       $6$hi = i64toi32_i32$2;
       i64toi32_i32$1 = $2;
       HEAP32[(i64toi32_i32$1 + 392 | 0) >> 2] = $6;
       HEAP32[(i64toi32_i32$1 + 396 | 0) >> 2] = i64toi32_i32$2;
       HEAP32[(i64toi32_i32$1 + 160 | 0) >> 2] = $6;
       HEAP32[(i64toi32_i32$1 + 164 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$3 = i64toi32_i32$1;
       i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 17 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 18 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 19 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 20 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = 0;
       $155 = i64toi32_i32$2;
       $155$hi = i64toi32_i32$1;
       i64toi32_i32$3 = $2 + 21 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
       i64toi32_i32$2 = 0;
       $158 = i64toi32_i32$1;
       $158$hi = i64toi32_i32$2;
       i64toi32_i32$3 = $2 + 23 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$3 >> 0] | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = i64toi32_i32$2;
       i64toi32_i32$2 = 0;
       i64toi32_i32$0 = 16;
       i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
        $48 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $48 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
       }
       $162$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $158$hi;
       i64toi32_i32$1 = $158;
       i64toi32_i32$3 = $162$hi;
       i64toi32_i32$0 = $48;
       i64toi32_i32$3 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$0 = 32;
       i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $49 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$4 | 0) | 0;
        $49 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       $164$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $155$hi;
       i64toi32_i32$3 = $155;
       i64toi32_i32$2 = $164$hi;
       i64toi32_i32$0 = $49;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
       i64toi32_i32$1 = i64toi32_i32$3 | i64toi32_i32$0 | 0;
       i64toi32_i32$3 = 0;
       i64toi32_i32$0 = 8;
       i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
        i64toi32_i32$3 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        $50 = 0;
       } else {
        i64toi32_i32$3 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
        $50 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       }
       $166$hi = i64toi32_i32$3;
       i64toi32_i32$3 = 0;
       i64toi32_i32$2 = $3;
       i64toi32_i32$1 = 0;
       i64toi32_i32$0 = 255;
       i64toi32_i32$1 = i64toi32_i32$3 & i64toi32_i32$1 | 0;
       $169 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
       $169$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $166$hi;
       i64toi32_i32$3 = $50;
       i64toi32_i32$2 = $169$hi;
       i64toi32_i32$0 = $169;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
       $6 = i64toi32_i32$3 | i64toi32_i32$0 | 0;
       $6$hi = i64toi32_i32$2;
       i64toi32_i32$1 = ($2 + 8 | 0) + 16 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $7 = i64toi32_i32$2;
       $7$hi = i64toi32_i32$3;
       $1 = 2;
      }
      $3 = $2 + 192 | 0;
      label$8 : {
       i64toi32_i32$1 = $2;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 184 | 0) >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 188 | 0) >> 2] | 0;
       i64toi32_i32$1 = i64toi32_i32$3;
       i64toi32_i32$3 = 0;
       i64toi32_i32$0 = 0;
       if ((i64toi32_i32$1 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | 0) {
        break label$8
       }
       core__ptr__drop_in_place_cardano_serialization_lib__CertificateEnum___h537567b60c24bc16($3 | 0);
       break label$3;
      }
      core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9($3 | 0);
      break label$3;
     }
     i64toi32_i32$0 = $2 + 216 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $186 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 168 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $186;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$0 = $2 + 224 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $192 = i64toi32_i32$2;
     i64toi32_i32$2 = ($2 + 160 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $192;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$0 = $2 + 208 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $196 = i64toi32_i32$1;
     i64toi32_i32$1 = $2;
     HEAP32[(i64toi32_i32$1 + 160 | 0) >> 2] = $196;
     HEAP32[(i64toi32_i32$1 + 164 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$0 = (i64toi32_i32$1 + 184 | 0) + 16 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $7 = i64toi32_i32$2;
     $7$hi = i64toi32_i32$1;
     $1 = 2;
    }
    $3 = 0;
   }
   i64toi32_i32$1 = $7$hi;
   i64toi32_i32$2 = ($2 + 184 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $7;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $6$hi;
   i64toi32_i32$2 = ($2 + 184 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $6;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$0 = $2;
   i64toi32_i32$1 = HEAP32[($2 + 160 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($2 + 164 | 0) >> 2] | 0;
   $212 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 208 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $212;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = $2;
   i64toi32_i32$2 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $216 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 236 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $216;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$0 = ($2 + 160 | 0) + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $222 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 216 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $222;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = ($2 + 160 | 0) + 16 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $228 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 224 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $228;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($2 + 244 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
   HEAP8[($2 + 184 | 0) >> 0] = $1;
   $46 = HEAP32[($2 + 392 | 0) >> 2] | 0;
   HEAP8[($2 + 185 | 0) >> 0] = $46;
   HEAP8[($2 + 186 | 0) >> 0] = $46 >>> 8 | 0;
   HEAP8[($2 + 187 | 0) >> 0] = $46 >>> 16 | 0;
   HEAP8[($2 + 188 | 0) >> 0] = $46 >>> 24 | 0;
   $47 = HEAPU8[($2 + 395 | 0) >> 0] | 0 | ((HEAPU8[($2 + 396 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 397 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 398 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[($2 + 188 | 0) >> 0] = $47;
   HEAP8[($2 + 189 | 0) >> 0] = $47 >>> 8 | 0;
   HEAP8[($2 + 190 | 0) >> 0] = $47 >>> 16 | 0;
   HEAP8[($2 + 191 | 0) >> 0] = $47 >>> 24 | 0;
   HEAP32[($2 + 232 | 0) >> 2] = $3;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 184 | 0 | 0, 1051130 | 0, 15 | 0);
   i64toi32_i32$1 = 0;
   $6 = 1;
   $6$hi = i64toi32_i32$1;
  }
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$2 = $0;
  HEAP32[i64toi32_i32$2 >> 2] = $6;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $2 + 416 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__Header___deserialize__hdf156fa217230f38($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $6 = 0, $6$hi = 0, $3 = 0, $7 = 0, $7$hi = 0, $37 = 0, $38 = 0, $39 = 0, $40 = 0, $41 = 0, $42 = 0, $43 = 0, $45 = 0, $46 = 0, $47 = 0, $4 = 0, $5 = 0, $48 = 0, $49 = 0, $50 = 0, $44 = 0, $52 = 0, $65 = 0, $108 = 0, $115 = 0, $119 = 0, $155 = 0, $155$hi = 0, $158 = 0, $158$hi = 0, $162$hi = 0, $164$hi = 0, $166$hi = 0, $169 = 0, $169$hi = 0, $186 = 0, $192 = 0, $196 = 0, $212 = 0, $216 = 0, $222 = 0, $228 = 0;
  $2 = global$0 - 672 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 312 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 320 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 324 | 0) >> 2] | 0;
  $6 = i64toi32_i32$0;
  $6$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 312 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 316 | 0) >> 2] | 0;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 1;
      if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
       break label$4
      }
      i64toi32_i32$2 = $6$hi;
      i64toi32_i32$0 = i64toi32_i32$2;
      cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__Header___deserialize_as_embedded_group__h3abb3b455930f669($2 + 312 | 0 | 0, $1 | 0, $6 | 0, i64toi32_i32$2 | 0, $6 | 0, i64toi32_i32$2 | 0);
      label$5 : {
       label$6 : {
        label$7 : {
         i64toi32_i32$0 = i64toi32_i32$2;
         i64toi32_i32$0 = i64toi32_i32$2;
         i64toi32_i32$3 = $6;
         i64toi32_i32$2 = 0;
         i64toi32_i32$1 = 1;
         if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) | 0) {
          break label$7
         }
         cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 8 | 0 | 0, $1 | 0);
         $3 = HEAPU8[($2 + 16 | 0) >> 0] | 0;
         i64toi32_i32$1 = $2;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] | 0;
         i64toi32_i32$1 = i64toi32_i32$3;
         i64toi32_i32$3 = 0;
         i64toi32_i32$2 = 1;
         if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) | 0) {
          break label$6
         }
         $1 = 5;
         if (($3 & 255 | 0 | 0) != (5 | 0)) {
          break label$5
         }
        }
        $4 = $2 + 296 | 0;
        i64toi32_i32$2 = ($2 + 312 | 0) + 40 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $44 = i64toi32_i32$1;
        i64toi32_i32$1 = $4;
        HEAP32[i64toi32_i32$1 >> 2] = $44;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        $5 = ($2 + 288 | 0) + 16 | 0;
        i64toi32_i32$2 = ($2 + 312 | 0) + 48 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $52 = i64toi32_i32$0;
        i64toi32_i32$0 = $5;
        HEAP32[i64toi32_i32$0 >> 2] = $52;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        HEAP32[($2 + 648 | 0) >> 2] = HEAPU8[($2 + 321 | 0) >> 0] | 0 | ((HEAPU8[($2 + 322 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 323 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 324 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $37 = ($2 + 312 | 0) + 12 | 0;
        $38 = HEAPU8[$37 >> 0] | 0 | ((HEAPU8[($37 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($37 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($37 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 651 | 0) >> 0] = $38;
        HEAP8[($2 + 652 | 0) >> 0] = $38 >>> 8 | 0;
        HEAP8[($2 + 653 | 0) >> 0] = $38 >>> 16 | 0;
        HEAP8[($2 + 654 | 0) >> 0] = $38 >>> 24 | 0;
        i64toi32_i32$2 = ($2 + 312 | 0) + 32 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $65 = i64toi32_i32$1;
        i64toi32_i32$1 = $2;
        HEAP32[(i64toi32_i32$1 + 288 | 0) >> 2] = $65;
        HEAP32[(i64toi32_i32$1 + 292 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = (i64toi32_i32$1 + 312 | 0) + 16 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $6 = i64toi32_i32$0;
        $6$hi = i64toi32_i32$1;
        i64toi32_i32$2 = ($2 + 312 | 0) + 24 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $7 = i64toi32_i32$1;
        $7$hi = i64toi32_i32$0;
        $3 = HEAP32[(($2 + 312 | 0) + 56 | 0) >> 2] | 0;
        $1 = HEAPU8[($2 + 320 | 0) >> 0] | 0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 312 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 316 | 0) >> 2] | 0;
        memcpy(i64toi32_i32$2 + 8 | 0 | 0, (i64toi32_i32$2 + 312 | 0) + 60 | 0 | 0, 276 | 0) | 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
         break label$2
        }
        HEAP8[($0 + 8 | 0) >> 0] = $1;
        $39 = HEAP32[($2 + 648 | 0) >> 2] | 0;
        HEAP8[($0 + 9 | 0) >> 0] = $39;
        HEAP8[($0 + 10 | 0) >> 0] = $39 >>> 8 | 0;
        HEAP8[($0 + 11 | 0) >> 0] = $39 >>> 16 | 0;
        HEAP8[($0 + 12 | 0) >> 0] = $39 >>> 24 | 0;
        $40 = $0 + 12 | 0;
        $41 = HEAPU8[($2 + 651 | 0) >> 0] | 0 | ((HEAPU8[($2 + 652 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 653 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 654 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[$40 >> 0] = $41;
        HEAP8[($40 + 1 | 0) >> 0] = $41 >>> 8 | 0;
        HEAP8[($40 + 2 | 0) >> 0] = $41 >>> 16 | 0;
        HEAP8[($40 + 3 | 0) >> 0] = $41 >>> 24 | 0;
        i64toi32_i32$2 = $7$hi;
        i64toi32_i32$1 = $0 + 24 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $7;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
        i64toi32_i32$2 = $6$hi;
        i64toi32_i32$1 = $0 + 16 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $6;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
        i64toi32_i32$3 = $2;
        i64toi32_i32$2 = HEAP32[($2 + 288 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 292 | 0) >> 2] | 0;
        $108 = i64toi32_i32$2;
        i64toi32_i32$2 = $0 + 32 | 0;
        $42 = $108;
        HEAP8[i64toi32_i32$2 >> 0] = $42;
        HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $42 >>> 8 | 0;
        HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $42 >>> 16 | 0;
        HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $42 >>> 24 | 0;
        HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$1;
        HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
        HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
        HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
        HEAP32[($0 + 56 | 0) >> 2] = $3;
        i64toi32_i32$3 = $4;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $115 = i64toi32_i32$1;
        i64toi32_i32$1 = $0 + 40 | 0;
        $43 = $115;
        HEAP8[i64toi32_i32$1 >> 0] = $43;
        HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $43 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $43 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $43 >>> 24 | 0;
        HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$2;
        HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
        i64toi32_i32$3 = $5;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $119 = i64toi32_i32$2;
        i64toi32_i32$2 = $0 + 48 | 0;
        $45 = $119;
        HEAP8[i64toi32_i32$2 >> 0] = $45;
        HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $45 >>> 8 | 0;
        HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $45 >>> 16 | 0;
        HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $45 >>> 24 | 0;
        HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$1;
        HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
        HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
        HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
        memcpy($0 + 60 | 0 | 0, $2 + 8 | 0 | 0, 276 | 0) | 0;
        i64toi32_i32$1 = 0;
        $6 = 0;
        $6$hi = i64toi32_i32$1;
        break label$1;
       }
       i64toi32_i32$3 = $2 + 40 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $6 = i64toi32_i32$1;
       $6$hi = i64toi32_i32$2;
       i64toi32_i32$1 = ($2 + 648 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $6;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$3 = $2 + 48 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $7 = i64toi32_i32$2;
       $7$hi = i64toi32_i32$1;
       i64toi32_i32$2 = ($2 + 648 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $7;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$1 = $6$hi;
       i64toi32_i32$2 = ($2 + 288 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $6;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$1 = $7$hi;
       i64toi32_i32$2 = ($2 + 288 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $7;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$3 = $2 + 32 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $6 = i64toi32_i32$1;
       $6$hi = i64toi32_i32$2;
       i64toi32_i32$1 = $2;
       HEAP32[(i64toi32_i32$1 + 648 | 0) >> 2] = $6;
       HEAP32[(i64toi32_i32$1 + 652 | 0) >> 2] = i64toi32_i32$2;
       HEAP32[(i64toi32_i32$1 + 288 | 0) >> 2] = $6;
       HEAP32[(i64toi32_i32$1 + 292 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$3 = i64toi32_i32$1;
       i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 17 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 18 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 19 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 20 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = 0;
       $155 = i64toi32_i32$2;
       $155$hi = i64toi32_i32$1;
       i64toi32_i32$3 = $2 + 21 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
       i64toi32_i32$2 = 0;
       $158 = i64toi32_i32$1;
       $158$hi = i64toi32_i32$2;
       i64toi32_i32$3 = $2 + 23 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$3 >> 0] | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = i64toi32_i32$2;
       i64toi32_i32$2 = 0;
       i64toi32_i32$0 = 16;
       i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
        $48 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $48 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
       }
       $162$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $158$hi;
       i64toi32_i32$1 = $158;
       i64toi32_i32$3 = $162$hi;
       i64toi32_i32$0 = $48;
       i64toi32_i32$3 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$0 = 32;
       i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $49 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$4 | 0) | 0;
        $49 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       $164$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $155$hi;
       i64toi32_i32$3 = $155;
       i64toi32_i32$2 = $164$hi;
       i64toi32_i32$0 = $49;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
       i64toi32_i32$1 = i64toi32_i32$3 | i64toi32_i32$0 | 0;
       i64toi32_i32$3 = 0;
       i64toi32_i32$0 = 8;
       i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
        i64toi32_i32$3 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        $50 = 0;
       } else {
        i64toi32_i32$3 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
        $50 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       }
       $166$hi = i64toi32_i32$3;
       i64toi32_i32$3 = 0;
       i64toi32_i32$2 = $3;
       i64toi32_i32$1 = 0;
       i64toi32_i32$0 = 255;
       i64toi32_i32$1 = i64toi32_i32$3 & i64toi32_i32$1 | 0;
       $169 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
       $169$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $166$hi;
       i64toi32_i32$3 = $50;
       i64toi32_i32$2 = $169$hi;
       i64toi32_i32$0 = $169;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
       $6 = i64toi32_i32$3 | i64toi32_i32$0 | 0;
       $6$hi = i64toi32_i32$2;
       i64toi32_i32$1 = ($2 + 8 | 0) + 16 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $7 = i64toi32_i32$2;
       $7$hi = i64toi32_i32$3;
       $1 = 2;
      }
      $3 = $2 + 320 | 0;
      label$8 : {
       i64toi32_i32$1 = $2;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 312 | 0) >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 316 | 0) >> 2] | 0;
       i64toi32_i32$1 = i64toi32_i32$3;
       i64toi32_i32$3 = 0;
       i64toi32_i32$0 = 0;
       if ((i64toi32_i32$1 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | 0) {
        break label$8
       }
       core__ptr__drop_in_place_cardano_serialization_lib__Header___h8385b81bf98ec4f1($3 | 0);
       break label$3;
      }
      core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9($3 | 0);
      break label$3;
     }
     i64toi32_i32$0 = $2 + 344 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $186 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 296 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $186;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$0 = $2 + 352 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $192 = i64toi32_i32$2;
     i64toi32_i32$2 = ($2 + 288 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $192;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$0 = $2 + 336 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $196 = i64toi32_i32$1;
     i64toi32_i32$1 = $2;
     HEAP32[(i64toi32_i32$1 + 288 | 0) >> 2] = $196;
     HEAP32[(i64toi32_i32$1 + 292 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$0 = (i64toi32_i32$1 + 312 | 0) + 16 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $7 = i64toi32_i32$2;
     $7$hi = i64toi32_i32$1;
     $1 = 2;
    }
    $3 = 0;
   }
   i64toi32_i32$1 = $7$hi;
   i64toi32_i32$2 = ($2 + 312 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $7;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $6$hi;
   i64toi32_i32$2 = ($2 + 312 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $6;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$0 = $2;
   i64toi32_i32$1 = HEAP32[($2 + 288 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($2 + 292 | 0) >> 2] | 0;
   $212 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 336 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $212;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = $2;
   i64toi32_i32$2 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $216 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 364 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $216;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$0 = ($2 + 288 | 0) + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $222 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 344 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $222;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = ($2 + 288 | 0) + 16 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $228 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 352 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $228;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($2 + 372 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
   HEAP8[($2 + 312 | 0) >> 0] = $1;
   $46 = HEAP32[($2 + 648 | 0) >> 2] | 0;
   HEAP8[($2 + 313 | 0) >> 0] = $46;
   HEAP8[($2 + 314 | 0) >> 0] = $46 >>> 8 | 0;
   HEAP8[($2 + 315 | 0) >> 0] = $46 >>> 16 | 0;
   HEAP8[($2 + 316 | 0) >> 0] = $46 >>> 24 | 0;
   $47 = HEAPU8[($2 + 651 | 0) >> 0] | 0 | ((HEAPU8[($2 + 652 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 653 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 654 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[($2 + 316 | 0) >> 0] = $47;
   HEAP8[($2 + 317 | 0) >> 0] = $47 >>> 8 | 0;
   HEAP8[($2 + 318 | 0) >> 0] = $47 >>> 16 | 0;
   HEAP8[($2 + 319 | 0) >> 0] = $47 >>> 24 | 0;
   HEAP32[($2 + 360 | 0) >> 2] = $3;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 312 | 0 | 0, 1052781 | 0, 6 | 0);
   i64toi32_i32$1 = 0;
   $6 = 1;
   $6$hi = i64toi32_i32$1;
  }
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$2 = $0;
  HEAP32[i64toi32_i32$2 >> 2] = $6;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $2 + 672 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__Update___deserialize__h5a4f342350ad0ea2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $5 = 0, $3 = 0, $5$hi = 0, $6 = 0, $6$hi = 0, $37 = 0, $38 = 0, $39 = 0, $40 = 0, $41 = 0, $42 = 0, $44 = 0, $45 = 0, $46 = 0, $47 = 0, $4 = 0, $48 = 0, $49 = 0, $50 = 0, $43 = 0, $51 = 0, $63 = 0, $73 = 0, $120 = 0, $120$hi = 0, $123 = 0, $123$hi = 0, $127$hi = 0, $129$hi = 0, $131$hi = 0, $134 = 0, $134$hi = 0, $157 = 0, $163 = 0, $167 = 0, $190 = 0, $194 = 0, $198 = 0, $210 = 0, $214 = 0, $220 = 0, $226 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 32 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] | 0;
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
       i64toi32_i32$2 = i64toi32_i32$1;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 1;
       if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
        break label$5
       }
       i64toi32_i32$2 = $5$hi;
       i64toi32_i32$0 = i64toi32_i32$2;
       cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__Update___deserialize_as_embedded_group__h283b753a842c8d26($2 + 32 | 0 | 0, $1 | 0, $5 | 0, i64toi32_i32$2 | 0, $5 | 0, i64toi32_i32$2 | 0);
       label$6 : {
        label$7 : {
         label$8 : {
          i64toi32_i32$0 = i64toi32_i32$2;
          i64toi32_i32$0 = i64toi32_i32$2;
          i64toi32_i32$3 = $5;
          i64toi32_i32$2 = 0;
          i64toi32_i32$1 = 1;
          if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) | 0) {
           break label$8
          }
          cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 128 | 0 | 0, $1 | 0);
          $3 = HEAPU8[($2 + 136 | 0) >> 0] | 0;
          i64toi32_i32$1 = $2;
          i64toi32_i32$3 = HEAP32[($2 + 128 | 0) >> 2] | 0;
          i64toi32_i32$0 = HEAP32[($2 + 132 | 0) >> 2] | 0;
          i64toi32_i32$1 = i64toi32_i32$3;
          i64toi32_i32$3 = 0;
          i64toi32_i32$2 = 1;
          if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) | 0) {
           break label$7
          }
          $1 = 5;
          if (($3 & 255 | 0 | 0) != (5 | 0)) {
           break label$6
          }
         }
         $3 = ($2 + 8 | 0) + 8 | 0;
         i64toi32_i32$2 = ($2 + 32 | 0) + 40 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $43 = i64toi32_i32$1;
         i64toi32_i32$1 = $3;
         HEAP32[i64toi32_i32$1 >> 2] = $43;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
         $4 = ($2 + 8 | 0) + 16 | 0;
         i64toi32_i32$2 = ($2 + 32 | 0) + 48 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $51 = i64toi32_i32$0;
         i64toi32_i32$0 = $4;
         HEAP32[i64toi32_i32$0 >> 2] = $51;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         HEAP32[(($2 + 128 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 100 | 0) >> 2] | 0;
         HEAP32[($2 + 104 | 0) >> 2] = HEAPU8[($2 + 41 | 0) >> 0] | 0 | ((HEAPU8[($2 + 42 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 43 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 44 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$2 = $2;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 92 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] | 0;
         $63 = i64toi32_i32$1;
         i64toi32_i32$1 = i64toi32_i32$2;
         HEAP32[(i64toi32_i32$2 + 128 | 0) >> 2] = $63;
         HEAP32[(i64toi32_i32$2 + 132 | 0) >> 2] = i64toi32_i32$0;
         $37 = (i64toi32_i32$2 + 32 | 0) + 12 | 0;
         $38 = HEAPU8[$37 >> 0] | 0 | ((HEAPU8[($37 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($37 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($37 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[(i64toi32_i32$2 + 107 | 0) >> 0] = $38;
         HEAP8[(i64toi32_i32$2 + 108 | 0) >> 0] = $38 >>> 8 | 0;
         HEAP8[(i64toi32_i32$2 + 109 | 0) >> 0] = $38 >>> 16 | 0;
         HEAP8[(i64toi32_i32$2 + 110 | 0) >> 0] = $38 >>> 24 | 0;
         i64toi32_i32$2 = (i64toi32_i32$2 + 32 | 0) + 32 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $73 = i64toi32_i32$0;
         i64toi32_i32$0 = $2;
         HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $73;
         HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$2 = (i64toi32_i32$0 + 32 | 0) + 16 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $5 = i64toi32_i32$1;
         $5$hi = i64toi32_i32$0;
         i64toi32_i32$2 = ($2 + 32 | 0) + 24 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $6 = i64toi32_i32$0;
         $6$hi = i64toi32_i32$1;
         $1 = HEAPU8[($2 + 40 | 0) >> 0] | 0;
         i64toi32_i32$2 = $2;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
         i64toi32_i32$2 = i64toi32_i32$1;
         i64toi32_i32$1 = 0;
         i64toi32_i32$3 = 1;
         if ((i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | 0) {
          break label$4
         }
         $3 = HEAP32[($2 + 88 | 0) >> 2] | 0;
         break label$2;
        }
        i64toi32_i32$3 = $2 + 160 | 0;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $5 = i64toi32_i32$2;
        $5$hi = i64toi32_i32$0;
        i64toi32_i32$2 = ($2 + 104 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$2 >> 2] = $5;
        HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$3 = $2 + 168 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $6 = i64toi32_i32$0;
        $6$hi = i64toi32_i32$2;
        i64toi32_i32$0 = ($2 + 104 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $6;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
        i64toi32_i32$2 = $5$hi;
        i64toi32_i32$0 = ($2 + 8 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $5;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
        i64toi32_i32$2 = $6$hi;
        i64toi32_i32$0 = ($2 + 8 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $6;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
        i64toi32_i32$3 = $2 + 152 | 0;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $5 = i64toi32_i32$2;
        $5$hi = i64toi32_i32$0;
        i64toi32_i32$2 = $2;
        HEAP32[(i64toi32_i32$2 + 104 | 0) >> 2] = $5;
        HEAP32[(i64toi32_i32$2 + 108 | 0) >> 2] = i64toi32_i32$0;
        HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $5;
        HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$3 = i64toi32_i32$2;
        i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 137 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 138 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 139 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 140 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$2 = 0;
        $120 = i64toi32_i32$0;
        $120$hi = i64toi32_i32$2;
        i64toi32_i32$3 = $2 + 141 | 0;
        i64toi32_i32$2 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
        i64toi32_i32$0 = 0;
        $123 = i64toi32_i32$2;
        $123$hi = i64toi32_i32$0;
        i64toi32_i32$3 = $2 + 143 | 0;
        i64toi32_i32$0 = HEAPU8[i64toi32_i32$3 >> 0] | 0;
        i64toi32_i32$2 = 0;
        i64toi32_i32$3 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$1 = 16;
        i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
         i64toi32_i32$0 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
         $48 = 0;
        } else {
         i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
         $48 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
        }
        $127$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $123$hi;
        i64toi32_i32$2 = $123;
        i64toi32_i32$3 = $127$hi;
        i64toi32_i32$1 = $48;
        i64toi32_i32$3 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
        i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
        i64toi32_i32$2 = 0;
        i64toi32_i32$1 = 32;
        i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
         i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
         $49 = 0;
        } else {
         i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$4 | 0) | 0;
         $49 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        }
        $129$hi = i64toi32_i32$2;
        i64toi32_i32$2 = $120$hi;
        i64toi32_i32$3 = $120;
        i64toi32_i32$0 = $129$hi;
        i64toi32_i32$1 = $49;
        i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
        i64toi32_i32$2 = i64toi32_i32$3 | i64toi32_i32$1 | 0;
        i64toi32_i32$3 = 0;
        i64toi32_i32$1 = 8;
        i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
         i64toi32_i32$3 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
         $50 = 0;
        } else {
         i64toi32_i32$3 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
         $50 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        }
        $131$hi = i64toi32_i32$3;
        i64toi32_i32$3 = 0;
        i64toi32_i32$0 = $3;
        i64toi32_i32$2 = 0;
        i64toi32_i32$1 = 255;
        i64toi32_i32$2 = i64toi32_i32$3 & i64toi32_i32$2 | 0;
        $134 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
        $134$hi = i64toi32_i32$2;
        i64toi32_i32$2 = $131$hi;
        i64toi32_i32$3 = $50;
        i64toi32_i32$0 = $134$hi;
        i64toi32_i32$1 = $134;
        i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
        $5 = i64toi32_i32$3 | i64toi32_i32$1 | 0;
        $5$hi = i64toi32_i32$0;
        i64toi32_i32$2 = ($2 + 128 | 0) + 16 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $6 = i64toi32_i32$0;
        $6$hi = i64toi32_i32$3;
        $1 = 2;
       }
       $3 = $2 + 40 | 0;
       label$9 : {
        i64toi32_i32$2 = $2;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
        i64toi32_i32$2 = i64toi32_i32$3;
        i64toi32_i32$3 = 0;
        i64toi32_i32$1 = 0;
        if ((i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$3 | 0) | 0) {
         break label$9
        }
        $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__h88c250e8947434a9($3 | 0);
        $3 = $2 + 56 | 0;
        if (!(HEAP32[$3 >> 2] | 0)) {
         break label$3
        }
        hashbrown__raw__RawTable_T_2cA___free_buckets__ha5e2f3faac433f39($3 | 0);
        break label$3;
       }
       core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9($3 | 0);
       break label$3;
      }
      i64toi32_i32$1 = $2 + 64 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $157 = i64toi32_i32$2;
      i64toi32_i32$2 = $2 + 16 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $157;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$1 = $2 + 72 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $163 = i64toi32_i32$0;
      i64toi32_i32$0 = ($2 + 8 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $163;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$1 = $2 + 56 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $167 = i64toi32_i32$2;
      i64toi32_i32$2 = $2;
      HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $167;
      HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$1 = (i64toi32_i32$2 + 32 | 0) + 16 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $6 = i64toi32_i32$0;
      $6$hi = i64toi32_i32$2;
      $1 = 2;
      break label$3;
     }
     HEAP8[($0 + 8 | 0) >> 0] = $1;
     $39 = HEAP32[($2 + 104 | 0) >> 2] | 0;
     HEAP8[($0 + 9 | 0) >> 0] = $39;
     HEAP8[($0 + 10 | 0) >> 0] = $39 >>> 8 | 0;
     HEAP8[($0 + 11 | 0) >> 0] = $39 >>> 16 | 0;
     HEAP8[($0 + 12 | 0) >> 0] = $39 >>> 24 | 0;
     $40 = $0 + 12 | 0;
     $41 = HEAPU8[($2 + 107 | 0) >> 0] | 0 | ((HEAPU8[($2 + 108 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 109 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 110 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[$40 >> 0] = $41;
     HEAP8[($40 + 1 | 0) >> 0] = $41 >>> 8 | 0;
     HEAP8[($40 + 2 | 0) >> 0] = $41 >>> 16 | 0;
     HEAP8[($40 + 3 | 0) >> 0] = $41 >>> 24 | 0;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$0 = $0 + 24 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $6;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$2 = $5$hi;
     i64toi32_i32$0 = $0 + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $5;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$1 = $2;
     i64toi32_i32$2 = HEAP32[($2 + 8 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
     $190 = i64toi32_i32$2;
     i64toi32_i32$2 = $0 + 32 | 0;
     $42 = $190;
     HEAP8[i64toi32_i32$2 >> 0] = $42;
     HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $42 >>> 8 | 0;
     HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $42 >>> 16 | 0;
     HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $42 >>> 24 | 0;
     HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$0;
     HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
     HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
     HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
     i64toi32_i32$1 = $3;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $194 = i64toi32_i32$0;
     i64toi32_i32$0 = $0 + 40 | 0;
     $44 = $194;
     HEAP8[i64toi32_i32$0 >> 0] = $44;
     HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $44 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $44 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $44 >>> 24 | 0;
     HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$2;
     HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
     i64toi32_i32$1 = $4;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $198 = i64toi32_i32$2;
     i64toi32_i32$2 = $0 + 48 | 0;
     $45 = $198;
     HEAP8[i64toi32_i32$2 >> 0] = $45;
     HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $45 >>> 8 | 0;
     HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $45 >>> 16 | 0;
     HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $45 >>> 24 | 0;
     HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$0;
     HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
     HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
     HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
     i64toi32_i32$0 = 0;
     $5 = 0;
     $5$hi = i64toi32_i32$0;
     break label$1;
    }
    $3 = 0;
   }
   i64toi32_i32$0 = $6$hi;
   i64toi32_i32$2 = ($2 + 32 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $6;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $5$hi;
   i64toi32_i32$2 = ($2 + 32 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $5;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$1 = $2;
   i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $210 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 56 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $210;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$1 = $2;
   i64toi32_i32$2 = HEAP32[($2 + 128 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 132 | 0) >> 2] | 0;
   $214 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 84 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $214;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$1 = ($2 + 8 | 0) + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $220 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 64 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $220;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$1 = ($2 + 8 | 0) + 16 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $226 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 72 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $226;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($2 + 92 | 0) >> 2] = HEAP32[(($2 + 128 | 0) + 8 | 0) >> 2] | 0;
   HEAP8[($2 + 32 | 0) >> 0] = $1;
   $46 = HEAP32[($2 + 104 | 0) >> 2] | 0;
   HEAP8[($2 + 33 | 0) >> 0] = $46;
   HEAP8[($2 + 34 | 0) >> 0] = $46 >>> 8 | 0;
   HEAP8[($2 + 35 | 0) >> 0] = $46 >>> 16 | 0;
   HEAP8[($2 + 36 | 0) >> 0] = $46 >>> 24 | 0;
   $47 = HEAPU8[($2 + 107 | 0) >> 0] | 0 | ((HEAPU8[($2 + 108 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 109 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 110 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[($2 + 36 | 0) >> 0] = $47;
   HEAP8[($2 + 37 | 0) >> 0] = $47 >>> 8 | 0;
   HEAP8[($2 + 38 | 0) >> 0] = $47 >>> 16 | 0;
   HEAP8[($2 + 39 | 0) >> 0] = $47 >>> 24 | 0;
   HEAP32[($2 + 80 | 0) >> 2] = $3;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 32 | 0 | 0, 1051997 | 0, 6 | 0);
   i64toi32_i32$0 = 0;
   $5 = 1;
   $5$hi = i64toi32_i32$0;
  }
  i64toi32_i32$0 = $5$hi;
  i64toi32_i32$2 = $0;
  HEAP32[i64toi32_i32$2 >> 2] = $5;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__plutus__Costmdls__language_views_encoding__h4ec764e7749aed37($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $5 = 0, $3 = 0, $4 = 0, $15 = 0, $32 = 0, $40 = 0, $43 = 0, $6 = 0, $89 = 0, $135 = 0, $152 = 0, $175 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 + 16 | 0 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 32 | 0) >> 2] = 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $15;
  HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$1;
  alloc__collections__btree__map__BTreeMap_K_2cV___iter__h351d422ab5212013($2 + 120 | 0 | 0, $1 | 0);
  HEAP32[(($2 + 72 | 0) + 24 | 0) >> 2] = HEAP32[(($2 + 120 | 0) + 24 | 0) >> 2] | 0;
  i64toi32_i32$2 = ($2 + 120 | 0) + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $32 = i64toi32_i32$1;
  i64toi32_i32$1 = ($2 + 72 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $32;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $3 = ($2 + 72 | 0) + 8 | 0;
  i64toi32_i32$2 = ($2 + 120 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $40 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $40;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 120 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 124 | 0) >> 2] | 0;
  $43 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 72 | 0) >> 2] = $43;
  HEAP32[($2 + 76 | 0) >> 2] = i64toi32_i32$0;
  $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__hd8f3cdafde636295($2 + 40 | 0 | 0, $2 + 72 | 0 | 0);
  $4 = HEAP32[($2 + 40 | 0) >> 2] | 0;
  $5 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  alloc__slice__merge_sort__h8a7406e55f001b08($4 | 0, $5 | 0, $2 + 72 | 0 | 0);
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($2 + 72 | 0 | 0, $2 + 24 | 0 | 0, 5 | 0, i64toi32_i32$0 | 0, i64toi32_i32$1 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        if ((HEAP32[($2 + 72 | 0) >> 2] | 0 | 0) == (1 | 0)) {
         break label$6
        }
        label$7 : {
         if (!$5) {
          break label$7
         }
         $6 = $4 + Math_imul($5, 12) | 0;
         label$8 : while (1) {
          cbor_event__se__Serializer_W___write_bytes__hdbf95a6224c8b5b8($2 + 72 | 0 | 0, $2 + 24 | 0 | 0, $4 | 0);
          if ((HEAP32[($2 + 72 | 0) >> 2] | 0 | 0) == (1 | 0)) {
           break label$5
          }
          $5 = alloc__collections__btree__map__BTreeMap_K_2cV___get__h84ab4aba07ccb152($1 | 0, $4 | 0) | 0;
          if (!$5) {
           break label$4
          }
          alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 + 8 | 0 | 0, 512 | 0, 0 | 0);
          HEAP32[($2 + 64 | 0) >> 2] = 0;
          i64toi32_i32$2 = $2;
          i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
          i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
          $89 = i64toi32_i32$1;
          i64toi32_i32$1 = $2;
          HEAP32[($2 + 56 | 0) >> 2] = $89;
          HEAP32[($2 + 60 | 0) >> 2] = i64toi32_i32$0;
          (wasm2js_i32$0 = $2, wasm2js_i32$1 = cbor_event__types__Type__to_byte__h30363627277739c1(4 | 0, 31 | 0) | 0), HEAP8[(wasm2js_i32$0 + 72 | 0) >> 0] = wasm2js_i32$1;
          alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($2 + 56 | 0 | 0, $2 + 72 | 0 | 0, 1 | 0);
          label$9 : {
           $3 = (HEAP32[($5 + 8 | 0) >> 2] | 0) << 4 | 0;
           if (!$3) {
            break label$9
           }
           $5 = HEAP32[$5 >> 2] | 0;
           label$10 : while (1) {
            $cardano_serialization_lib__utils__Int_20as_20cbor_event__se__Serialize___serialize__h52978cec14c40013($2 + 72 | 0 | 0, $5 | 0, $2 + 56 | 0 | 0);
            if ((HEAP32[($2 + 72 | 0) >> 2] | 0 | 0) == (1 | 0)) {
             break label$1
            }
            $5 = $5 + 16 | 0;
            $3 = $3 + -16 | 0;
            if ($3) {
             continue label$10
            }
            break label$10;
           };
          }
          HEAP8[($2 + 120 | 0) >> 0] = 5;
          cbor_event__se__Serializer_W___write_special__had0377f4ca98c84d($2 + 72 | 0 | 0, $2 + 56 | 0 | 0, $2 + 120 | 0 | 0);
          if ((HEAP32[($2 + 72 | 0) >> 2] | 0 | 0) == (1 | 0)) {
           break label$3
          }
          HEAP32[(($2 + 120 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 56 | 0) + 8 | 0) >> 2] | 0;
          i64toi32_i32$2 = $2;
          i64toi32_i32$0 = HEAP32[($2 + 56 | 0) >> 2] | 0;
          i64toi32_i32$1 = HEAP32[($2 + 60 | 0) >> 2] | 0;
          $135 = i64toi32_i32$0;
          i64toi32_i32$0 = $2;
          HEAP32[($2 + 120 | 0) >> 2] = $135;
          HEAP32[($2 + 124 | 0) >> 2] = i64toi32_i32$1;
          cbor_event__se__Serializer_W___write_bytes__h935c22261c9a8184($2 + 72 | 0 | 0, $2 + 24 | 0 | 0, $2 + 120 | 0 | 0);
          if ((HEAP32[($2 + 72 | 0) >> 2] | 0 | 0) == (1 | 0)) {
           break label$2
          }
          $4 = $4 + 12 | 0;
          if (($6 | 0) != ($4 | 0)) {
           continue label$8
          }
          break label$8;
         };
        }
        i64toi32_i32$2 = $2;
        i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[($2 + 28 | 0) >> 2] | 0;
        $152 = i64toi32_i32$1;
        i64toi32_i32$1 = $0;
        HEAP32[i64toi32_i32$1 >> 2] = $152;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 24 | 0) + 8 | 0) >> 2] | 0;
        $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($2 + 72 | 0 | 0, i64toi32_i32$1 | 0);
        hex__encode__ha65497b593c9e23a($2 + 120 | 0 | 0, $2 + 72 | 0 | 0);
        core__fmt__ArgumentV1__new__h56a0e5bff2bd9085($2 | 0, $2 + 120 | 0 | 0, 142 | 0);
        HEAP32[($2 + 92 | 0) >> 2] = 1;
        i64toi32_i32$1 = $2;
        i64toi32_i32$0 = 0;
        HEAP32[($2 + 76 | 0) >> 2] = 2;
        HEAP32[($2 + 80 | 0) >> 2] = i64toi32_i32$0;
        HEAP32[($2 + 72 | 0) >> 2] = 1071588;
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
        $175 = i64toi32_i32$0;
        i64toi32_i32$0 = $2;
        HEAP32[($2 + 56 | 0) >> 2] = $175;
        HEAP32[($2 + 60 | 0) >> 2] = i64toi32_i32$1;
        HEAP32[($2 + 88 | 0) >> 2] = $2 + 56 | 0;
        std__io__stdio___print__he842e74bc351a82b($2 + 72 | 0 | 0);
        $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 120 | 0 | 0);
        $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 120 | 0 | 0);
        $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h5af1c14f46bf1edb($2 + 40 | 0 | 0);
        $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hd4ac14c513c9516d($2 + 40 | 0 | 0);
        global$0 = $2 + 160 | 0;
        return;
       }
       memcpy($2 + 120 | 0 | 0, $3 | 0, 40 | 0) | 0;
       core__result__unwrap_failed__h27f43d993c3864a1(1070651 | 0, 43 | 0, $2 + 120 | 0 | 0, 1070712 | 0, 1071472 | 0);
       abort();
      }
      memcpy($2 + 120 | 0 | 0, $2 + 80 | 0 | 0, 40 | 0) | 0;
      core__result__unwrap_failed__h27f43d993c3864a1(1070651 | 0, 43 | 0, $2 + 120 | 0 | 0, 1070712 | 0, 1071488 | 0);
      abort();
     }
     core__panicking__panic__h2fd385a887c8bf13(1070608 | 0, 43 | 0, 1071504 | 0);
     abort();
    }
    memcpy($2 + 120 | 0 | 0, $2 + 80 | 0 | 0, 40 | 0) | 0;
    core__result__unwrap_failed__h27f43d993c3864a1(1070651 | 0, 43 | 0, $2 + 120 | 0 | 0, 1070712 | 0, 1071536 | 0);
    abort();
   }
   memcpy($2 + 120 | 0 | 0, $2 + 80 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1070651 | 0, 43 | 0, $2 + 120 | 0 | 0, 1070712 | 0, 1071552 | 0);
   abort();
  }
  memcpy($2 + 120 | 0 | 0, $2 + 80 | 0 | 0, 40 | 0) | 0;
  core__result__unwrap_failed__h27f43d993c3864a1(1070651 | 0, 43 | 0, $2 + 120 | 0 | 0, 1070712 | 0, 1071520 | 0);
  abort();
 }
 
 function num_bigint__biguint__multiplication__sub_sign__h115f34decb175430($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $6 = 0, $5 = 0, $7 = 0, $9 = 0, $8 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $12 = 0, $10 = 0, $11 = 0;
  $5 = global$0 - 48 | 0;
  global$0 = $5;
  $6 = $2 << 2 | 0;
  $7 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : while (1) {
           label$10 : {
            if ($6) {
             break label$10
            }
            $8 = 0;
            break label$8;
           }
           $7 = $7 + -1 | 0;
           $9 = $1 + $6 | 0;
           $6 = $6 + -4 | 0;
           if (!(HEAP32[($9 + -4 | 0) >> 2] | 0)) {
            continue label$9
           }
           break label$9;
          };
          $8 = $7 + 1 | 0;
          if ($8 >>> 0 > $2 >>> 0) {
           break label$7
          }
         }
         $6 = $4 << 2 | 0;
         $7 = $4;
         label$11 : {
          label$12 : while (1) {
           label$13 : {
            if ($6) {
             break label$13
            }
            $9 = 0;
            break label$11;
           }
           $7 = $7 + -1 | 0;
           $9 = $3 + $6 | 0;
           $6 = $6 + -4 | 0;
           if (!(HEAP32[($9 + -4 | 0) >> 2] | 0)) {
            continue label$12
           }
           break label$12;
          };
          $9 = $7 + 1 | 0;
          if ($9 >>> 0 > $4 >>> 0) {
           break label$6
          }
         }
         label$14 : {
          label$15 : {
           $2 = $8 >>> 0 < $9 >>> 0 ? -1 : ($8 | 0) != ($9 | 0);
           if ($2) {
            break label$15
           }
           $10 = $3 + -4 | 0;
           $6 = $9 << 2 | 0;
           $7 = $8 << 2 | 0;
           $11 = $1 + -4 | 0;
           label$16 : while (1) {
            label$17 : {
             if ($7) {
              break label$17
             }
             $2 = $6 ? -1 : 0;
             break label$15;
            }
            if (!$6) {
             break label$14
            }
            $2 = $11 + $7 | 0;
            $4 = $10 + $6 | 0;
            $6 = $6 + -4 | 0;
            $7 = $7 + -4 | 0;
            $2 = HEAP32[$2 >> 2] | 0;
            $4 = HEAP32[$4 >> 2] | 0;
            $2 = $2 >>> 0 < $4 >>> 0 ? -1 : ($2 | 0) != ($4 | 0);
            if (!$2) {
             continue label$16
            }
            break label$16;
           };
          }
          label$18 : {
           switch ($2 + 1 | 0 | 0) {
           default:
            $6 = 0;
            alloc__raw_vec__RawVec_T_2cA___allocate_in__hb0817f92bbb8999a($5 | 0, $9 | 0, 0 | 0);
            $7 = HEAP32[($5 + 4 | 0) >> 2] | 0;
            $2 = $9 << 2 | 0;
            $3 = memcpy(HEAP32[$5 >> 2] | 0 | 0, $3 | 0, $2 | 0) | 0;
            num_bigint__biguint__subtraction__sub2__h0b2286b660c85b0d($3 | 0, $9 | 0, $1 | 0, $8 | 0);
            HEAP32[($5 + 40 | 0) >> 2] = $9;
            HEAP32[($5 + 36 | 0) >> 2] = $7;
            HEAP32[($5 + 32 | 0) >> 2] = $3;
            if (!$9) {
             break label$2
            }
            $6 = ($2 + $3 | 0) + -4 | 0;
            label$20 : while (1) {
             label$21 : {
              if (!(HEAP32[$6 >> 2] | 0)) {
               break label$21
              }
              $6 = $9;
              break label$3;
             }
             $6 = $6 + -4 | 0;
             $9 = $9 + -1 | 0;
             if ($9) {
              continue label$20
             }
             break label$20;
            };
            $6 = 0;
            break label$3;
           case 2:
            break label$14;
           case 1:
            break label$18;
           };
          }
          HEAP8[$0 >> 0] = 1;
          i64toi32_i32$1 = $0 + 8 | 0;
          i64toi32_i32$0 = 0;
          HEAP32[i64toi32_i32$1 >> 2] = 0;
          HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
          HEAP32[($0 + 4 | 0) >> 2] = HEAP32[(0 + 1082808 | 0) >> 2] | 0;
          break label$1;
         }
         $6 = 0;
         alloc__raw_vec__RawVec_T_2cA___allocate_in__hb0817f92bbb8999a($5 + 8 | 0 | 0, $8 | 0, 0 | 0);
         $7 = HEAP32[($5 + 12 | 0) >> 2] | 0;
         $2 = $8 << 2 | 0;
         $1 = memcpy(HEAP32[($5 + 8 | 0) >> 2] | 0 | 0, $1 | 0, $2 | 0) | 0;
         num_bigint__biguint__subtraction__sub2__h0b2286b660c85b0d($1 | 0, $8 | 0, $3 | 0, $9 | 0);
         HEAP32[($5 + 40 | 0) >> 2] = $8;
         HEAP32[($5 + 36 | 0) >> 2] = $7;
         HEAP32[($5 + 32 | 0) >> 2] = $1;
         if (!$8) {
          break label$4
         }
         $6 = ($2 + $1 | 0) + -4 | 0;
         label$22 : while (1) {
          label$23 : {
           if (!(HEAP32[$6 >> 2] | 0)) {
            break label$23
           }
           $6 = $8;
           break label$5;
          }
          $6 = $6 + -4 | 0;
          $8 = $8 + -1 | 0;
          if ($8) {
           continue label$22
          }
          break label$22;
         };
         $6 = 0;
         break label$5;
        }
        core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($8 | 0, $2 | 0, 1083108 | 0);
        abort();
       }
       core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($9 | 0, $4 | 0, 1083124 | 0);
       abort();
      }
      HEAP32[($5 + 40 | 0) >> 2] = $6;
     }
     label$24 : {
      if ($6 >>> 0 >= ($7 >>> 2 | 0) >>> 0) {
       break label$24
      }
      if ($7 >>> 0 <= $6 >>> 0) {
       break label$24
      }
      alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($5 + 32 | 0 | 0, $6 | 0);
     }
     $6 = HEAP32[(($5 + 32 | 0) + 8 | 0) >> 2] | 0;
     HEAP32[(($5 + 16 | 0) + 8 | 0) >> 2] = $6;
     i64toi32_i32$0 = HEAP32[($5 + 32 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($5 + 36 | 0) >> 2] | 0;
     $12 = i64toi32_i32$0;
     i64toi32_i32$0 = $5;
     HEAP32[($5 + 16 | 0) >> 2] = $12;
     HEAP32[($5 + 20 | 0) >> 2] = i64toi32_i32$1;
     HEAP8[$0 >> 0] = 2;
     i64toi32_i32$0 = $0;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $12;
     HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = $6;
     break label$1;
    }
    HEAP32[($5 + 40 | 0) >> 2] = $6;
   }
   label$25 : {
    if ($6 >>> 0 >= ($7 >>> 2 | 0) >>> 0) {
     break label$25
    }
    if ($7 >>> 0 <= $6 >>> 0) {
     break label$25
    }
    alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($5 + 32 | 0 | 0, $6 | 0);
   }
   $6 = HEAP32[(($5 + 32 | 0) + 8 | 0) >> 2] | 0;
   HEAP32[(($5 + 16 | 0) + 8 | 0) >> 2] = $6;
   i64toi32_i32$1 = HEAP32[($5 + 32 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($5 + 36 | 0) >> 2] | 0;
   $12 = i64toi32_i32$1;
   i64toi32_i32$1 = $5;
   HEAP32[($5 + 16 | 0) >> 2] = $12;
   HEAP32[($5 + 20 | 0) >> 2] = i64toi32_i32$0;
   HEAP8[$0 >> 0] = 0;
   i64toi32_i32$1 = $0;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $12;
   HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = $6;
  }
  global$0 = $5 + 48 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__PoolMetadata___deserialize__hc2aeb10cf56b6b31($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $4 = 0, $3 = 0, $4$hi = 0, $5 = 0, $5$hi = 0, $35 = 0, $36 = 0, $37 = 0, $38 = 0, $39 = 0, $40 = 0, $41 = 0, $43 = 0, $44 = 0, $45 = 0, $46 = 0, $47 = 0, $42 = 0, $48 = 0, $67 = 0, $71 = 0, $120 = 0, $120$hi = 0, $123 = 0, $123$hi = 0, $127$hi = 0, $129$hi = 0, $131$hi = 0, $134 = 0, $134$hi = 0, $153 = 0, $159 = 0, $163 = 0, $190 = 0, $194 = 0, $206 = 0, $210 = 0, $216 = 0, $222 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 32 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
       i64toi32_i32$2 = i64toi32_i32$1;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 1;
       if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
        break label$5
       }
       i64toi32_i32$2 = $4$hi;
       i64toi32_i32$0 = i64toi32_i32$2;
       cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__PoolMetadata___deserialize_as_embedded_group__hc30afb036576109c($2 + 32 | 0 | 0, $1 | 0, $4 | 0, i64toi32_i32$0 | 0, $4 | 0, i64toi32_i32$0 | 0);
       label$6 : {
        label$7 : {
         label$8 : {
          i64toi32_i32$3 = $4;
          i64toi32_i32$2 = 0;
          i64toi32_i32$1 = 1;
          if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) | 0) {
           break label$8
          }
          cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 128 | 0 | 0, $1 | 0);
          $3 = HEAPU8[($2 + 136 | 0) >> 0] | 0;
          i64toi32_i32$1 = $2;
          i64toi32_i32$3 = HEAP32[($2 + 128 | 0) >> 2] | 0;
          i64toi32_i32$0 = HEAP32[($2 + 132 | 0) >> 2] | 0;
          i64toi32_i32$1 = i64toi32_i32$3;
          i64toi32_i32$3 = 0;
          i64toi32_i32$2 = 1;
          if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) | 0) {
           break label$7
          }
          $1 = 5;
          if (($3 & 255 | 0 | 0) != (5 | 0)) {
           break label$6
          }
         }
         $3 = ($2 + 8 | 0) + 8 | 0;
         i64toi32_i32$2 = ($2 + 32 | 0) + 40 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $42 = i64toi32_i32$1;
         i64toi32_i32$1 = $3;
         HEAP32[i64toi32_i32$1 >> 2] = $42;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$2 = $2 + 80 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $48 = i64toi32_i32$0;
         i64toi32_i32$0 = ($2 + 8 | 0) + 16 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $48;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         HEAP32[(($2 + 128 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 100 | 0) >> 2] | 0;
         HEAP32[($2 + 104 | 0) >> 2] = HEAPU8[($2 + 41 | 0) >> 0] | 0 | ((HEAPU8[($2 + 42 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 43 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 44 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $35 = ($2 + 32 | 0) + 12 | 0;
         $36 = HEAPU8[$35 >> 0] | 0 | ((HEAPU8[($35 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($35 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($35 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[($2 + 107 | 0) >> 0] = $36;
         HEAP8[($2 + 108 | 0) >> 0] = $36 >>> 8 | 0;
         HEAP8[($2 + 109 | 0) >> 0] = $36 >>> 16 | 0;
         HEAP8[($2 + 110 | 0) >> 0] = $36 >>> 24 | 0;
         i64toi32_i32$2 = ($2 + 32 | 0) + 32 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $67 = i64toi32_i32$1;
         i64toi32_i32$1 = $2;
         HEAP32[($2 + 8 | 0) >> 2] = $67;
         HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$2 = $2 + 92 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $71 = i64toi32_i32$0;
         i64toi32_i32$0 = $2;
         HEAP32[(i64toi32_i32$0 + 128 | 0) >> 2] = $71;
         HEAP32[(i64toi32_i32$0 + 132 | 0) >> 2] = i64toi32_i32$1;
         $1 = HEAPU8[((i64toi32_i32$0 + 32 | 0) + 8 | 0) >> 0] | 0;
         i64toi32_i32$2 = (i64toi32_i32$0 + 32 | 0) + 16 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $4 = i64toi32_i32$1;
         $4$hi = i64toi32_i32$0;
         i64toi32_i32$2 = ($2 + 32 | 0) + 24 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $5 = i64toi32_i32$0;
         $5$hi = i64toi32_i32$1;
         if ((HEAP32[($2 + 32 | 0) >> 2] | 0 | 0) != (1 | 0)) {
          break label$4
         }
         $3 = HEAP32[($2 + 88 | 0) >> 2] | 0;
         break label$2;
        }
        i64toi32_i32$2 = $2 + 160 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $4 = i64toi32_i32$1;
        $4$hi = i64toi32_i32$0;
        i64toi32_i32$1 = ($2 + 104 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $4;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = $2 + 168 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $5 = i64toi32_i32$0;
        $5$hi = i64toi32_i32$1;
        i64toi32_i32$0 = ($2 + 104 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $5;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$1 = $4$hi;
        i64toi32_i32$0 = ($2 + 8 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $4;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$1 = $5$hi;
        i64toi32_i32$0 = ($2 + 8 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $5;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$2 = $2 + 152 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $4 = i64toi32_i32$1;
        $4$hi = i64toi32_i32$0;
        i64toi32_i32$1 = $2;
        HEAP32[($2 + 104 | 0) >> 2] = $4;
        HEAP32[($2 + 108 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$1 = $2;
        HEAP32[($2 + 8 | 0) >> 2] = $4;
        HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAPU8[($2 + 137 | 0) >> 0] | 0 | ((HEAPU8[($2 + 138 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 139 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 140 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$1 = 0;
        $120 = i64toi32_i32$0;
        $120$hi = i64toi32_i32$1;
        i64toi32_i32$2 = $2 + 141 | 0;
        i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
        i64toi32_i32$0 = 0;
        $123 = i64toi32_i32$1;
        $123$hi = i64toi32_i32$0;
        i64toi32_i32$2 = $2 + 143 | 0;
        i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
        i64toi32_i32$1 = 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 16;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
         $45 = 0;
        } else {
         i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
         $45 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        }
        $127$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $123$hi;
        i64toi32_i32$1 = $123;
        i64toi32_i32$2 = $127$hi;
        i64toi32_i32$3 = $45;
        i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
        i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 32;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
         $46 = 0;
        } else {
         i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
         $46 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        }
        $129$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $120$hi;
        i64toi32_i32$2 = $120;
        i64toi32_i32$0 = $129$hi;
        i64toi32_i32$3 = $46;
        i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
        i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
        i64toi32_i32$2 = 0;
        i64toi32_i32$3 = 8;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
         $47 = 0;
        } else {
         i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
         $47 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        }
        $131$hi = i64toi32_i32$2;
        i64toi32_i32$2 = 0;
        i64toi32_i32$0 = $3;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 255;
        i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
        $134 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
        $134$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $131$hi;
        i64toi32_i32$2 = $47;
        i64toi32_i32$0 = $134$hi;
        i64toi32_i32$3 = $134;
        i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
        $4 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
        $4$hi = i64toi32_i32$0;
        i64toi32_i32$1 = ($2 + 128 | 0) + 16 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
        $5 = i64toi32_i32$0;
        $5$hi = i64toi32_i32$2;
        $1 = 2;
       }
       label$9 : {
        if (HEAP32[($2 + 32 | 0) >> 2] | 0) {
         break label$9
        }
        $3 = $2 + 32 | 0 | 4 | 0;
        $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 | 0);
        $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 | 0);
        break label$3;
       }
       core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9($2 + 40 | 0 | 0);
       break label$3;
      }
      i64toi32_i32$1 = $2 + 64 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $153 = i64toi32_i32$2;
      i64toi32_i32$2 = $2 + 16 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $153;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$1 = $2 + 72 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $159 = i64toi32_i32$0;
      i64toi32_i32$0 = ($2 + 8 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $159;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$1 = $2 + 56 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $163 = i64toi32_i32$2;
      i64toi32_i32$2 = $2;
      HEAP32[($2 + 8 | 0) >> 2] = $163;
      HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$1 = ($2 + 32 | 0) + 16 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $5 = i64toi32_i32$0;
      $5$hi = i64toi32_i32$2;
      $1 = 2;
      break label$3;
     }
     HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($2 + 36 | 0) >> 2] | 0;
     $37 = HEAP32[($2 + 104 | 0) >> 2] | 0;
     HEAP8[($0 + 9 | 0) >> 0] = $37;
     HEAP8[($0 + 10 | 0) >> 0] = $37 >>> 8 | 0;
     HEAP8[($0 + 11 | 0) >> 0] = $37 >>> 16 | 0;
     HEAP8[($0 + 12 | 0) >> 0] = $37 >>> 24 | 0;
     HEAP8[($0 + 8 | 0) >> 0] = $1;
     $38 = $0 + 12 | 0;
     $39 = HEAPU8[($2 + 107 | 0) >> 0] | 0 | ((HEAPU8[($2 + 108 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 109 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 110 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[$38 >> 0] = $39;
     HEAP8[($38 + 1 | 0) >> 0] = $39 >>> 8 | 0;
     HEAP8[($38 + 2 | 0) >> 0] = $39 >>> 16 | 0;
     HEAP8[($38 + 3 | 0) >> 0] = $39 >>> 24 | 0;
     i64toi32_i32$2 = $5$hi;
     i64toi32_i32$0 = $0 + 24 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $5;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$2 = $4$hi;
     i64toi32_i32$0 = $0 + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $4;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$1 = $2;
     i64toi32_i32$2 = HEAP32[($2 + 8 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
     $190 = i64toi32_i32$2;
     i64toi32_i32$2 = $0 + 32 | 0;
     $40 = $190;
     HEAP8[i64toi32_i32$2 >> 0] = $40;
     HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $40 >>> 8 | 0;
     HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $40 >>> 16 | 0;
     HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $40 >>> 24 | 0;
     HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$0;
     HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
     HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
     HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
     i64toi32_i32$1 = $3;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $194 = i64toi32_i32$0;
     i64toi32_i32$0 = $0 + 40 | 0;
     $41 = $194;
     HEAP8[i64toi32_i32$0 >> 0] = $41;
     HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $41 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $41 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $41 >>> 24 | 0;
     HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$2;
     HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
     $1 = 0;
     break label$1;
    }
    $3 = 0;
   }
   i64toi32_i32$2 = $5$hi;
   i64toi32_i32$0 = ($2 + 32 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $5;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$2 = $4$hi;
   i64toi32_i32$0 = ($2 + 32 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $4;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$1 = $2;
   i64toi32_i32$2 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $206 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 56 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $206;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$1 = $2;
   i64toi32_i32$0 = HEAP32[($2 + 128 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($2 + 132 | 0) >> 2] | 0;
   $210 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 84 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $210;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$1 = ($2 + 8 | 0) + 8 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $216 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 64 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $216;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$1 = ($2 + 8 | 0) + 16 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $222 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 72 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $222;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   HEAP32[($2 + 92 | 0) >> 2] = HEAP32[(($2 + 128 | 0) + 8 | 0) >> 2] | 0;
   HEAP8[($2 + 32 | 0) >> 0] = $1;
   $43 = HEAP32[($2 + 104 | 0) >> 2] | 0;
   HEAP8[($2 + 33 | 0) >> 0] = $43;
   HEAP8[($2 + 34 | 0) >> 0] = $43 >>> 8 | 0;
   HEAP8[($2 + 35 | 0) >> 0] = $43 >>> 16 | 0;
   HEAP8[($2 + 36 | 0) >> 0] = $43 >>> 24 | 0;
   $44 = HEAPU8[($2 + 107 | 0) >> 0] | 0 | ((HEAPU8[($2 + 108 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 109 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 110 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[($2 + 36 | 0) >> 0] = $44;
   HEAP8[($2 + 37 | 0) >> 0] = $44 >>> 8 | 0;
   HEAP8[($2 + 38 | 0) >> 0] = $44 >>> 16 | 0;
   HEAP8[($2 + 39 | 0) >> 0] = $44 >>> 24 | 0;
   HEAP32[($2 + 80 | 0) >> 2] = $3;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 32 | 0 | 0, 1051544 | 0, 12 | 0);
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__ScriptPubkey___deserialize__hcda45a5ae72614ec($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $6 = 0, $6$hi = 0, $5$hi = 0, $7$hi = 0, $3 = 0, $8 = 0, $8$hi = 0, $5 = 0, $7 = 0, $36 = 0, $37 = 0, $38 = 0, $39 = 0, $40 = 0, $41 = 0, $42 = 0, $43 = 0, $44 = 0, $45 = 0, $46 = 0, $47 = 0, $48 = 0, $49 = 0, $50 = 0, $51 = 0, $52 = 0, $53 = 0, $54 = 0, $67 = 0, $67$hi = 0, $70 = 0, $70$hi = 0, $74$hi = 0, $76$hi = 0, $78$hi = 0, $81 = 0, $81$hi = 0, $93 = 0, $97 = 0, $112 = 0, $132 = 0, $4 = 0, $162 = 0, $169 = 0, $206 = 0, $210 = 0, $215 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 24 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2 + 40 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
  $6 = i64toi32_i32$1;
  $6$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
       i64toi32_i32$2 = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 1;
       if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
        break label$5
       }
       i64toi32_i32$2 = 0;
       $7 = 0;
       $7$hi = i64toi32_i32$2;
       label$6 : {
        i64toi32_i32$2 = $6$hi;
        i64toi32_i32$3 = $6;
        i64toi32_i32$1 = 0;
        i64toi32_i32$0 = 1;
        if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
         break label$6
        }
        i64toi32_i32$3 = 0;
        $7 = 2;
        $7$hi = i64toi32_i32$3;
        i64toi32_i32$3 = $5$hi;
        i64toi32_i32$0 = $5;
        i64toi32_i32$2 = 0;
        i64toi32_i32$1 = 2;
        if (i64toi32_i32$3 >>> 0 > i64toi32_i32$2 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$0 >>> 0 >= i64toi32_i32$1 >>> 0 | 0) | 0) {
         break label$6
        }
        $1 = 3;
        $3 = 0;
        i64toi32_i32$0 = 0;
        $8 = 0;
        $8$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $5$hi;
        $6 = $5;
        $6$hi = i64toi32_i32$0;
        break label$2;
       }
       i64toi32_i32$0 = $6$hi;
       i64toi32_i32$3 = i64toi32_i32$0;
       cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__ScriptPubkey___deserialize_as_embedded_group__h27483ec3516d4650($2 + 24 | 0 | 0, $1 | 0, $6 | 0, i64toi32_i32$0 | 0, $6 | 0, i64toi32_i32$0 | 0);
       i64toi32_i32$3 = 0;
       $8 = 1;
       $8$hi = i64toi32_i32$3;
       label$7 : {
        label$8 : {
         i64toi32_i32$3 = i64toi32_i32$0;
         i64toi32_i32$3 = i64toi32_i32$0;
         i64toi32_i32$1 = $6;
         i64toi32_i32$0 = 0;
         i64toi32_i32$2 = 1;
         if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) | 0) {
          break label$8
         }
         cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 112 | 0 | 0, $1 | 0);
         $3 = HEAPU8[($2 + 120 | 0) >> 0] | 0;
         i64toi32_i32$2 = $2;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 112 | 0) >> 2] | 0;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 116 | 0) >> 2] | 0;
         i64toi32_i32$2 = i64toi32_i32$1;
         i64toi32_i32$1 = 0;
         i64toi32_i32$0 = 1;
         if ((i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) | 0) {
          break label$7
         }
         $1 = 5;
         if (($3 & 255 | 0 | 0) != (5 | 0)) {
          break label$4
         }
         break label$3;
        }
        $1 = 3;
        i64toi32_i32$2 = $7$hi;
        i64toi32_i32$2 = $5$hi;
        i64toi32_i32$2 = $7$hi;
        i64toi32_i32$0 = $7;
        i64toi32_i32$3 = $5$hi;
        i64toi32_i32$1 = $5;
        if ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) | 0) {
         break label$3
        }
        break label$4;
       }
       i64toi32_i32$1 = $2 + 152 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $6 = i64toi32_i32$0;
       $6$hi = i64toi32_i32$2;
       i64toi32_i32$0 = ($2 + 96 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $6;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$0 = $2 + 8 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $6;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$1 = $2 + 144 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $6 = i64toi32_i32$2;
       $6$hi = i64toi32_i32$0;
       i64toi32_i32$2 = $2;
       HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] = $6;
       HEAP32[(i64toi32_i32$2 + 100 | 0) >> 2] = i64toi32_i32$0;
       HEAP32[i64toi32_i32$2 >> 2] = $6;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$1 = i64toi32_i32$2;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 121 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 122 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 123 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 124 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = 0;
       $67 = i64toi32_i32$0;
       $67$hi = i64toi32_i32$2;
       i64toi32_i32$1 = $2 + 125 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
       i64toi32_i32$0 = 0;
       $70 = i64toi32_i32$2;
       $70$hi = i64toi32_i32$0;
       i64toi32_i32$1 = $2 + 127 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
       i64toi32_i32$2 = 0;
       i64toi32_i32$1 = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        $51 = 0;
       } else {
        i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
        $51 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       }
       $74$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $70$hi;
       i64toi32_i32$2 = $70;
       i64toi32_i32$1 = $74$hi;
       i64toi32_i32$3 = $51;
       i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $52 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $52 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       $76$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $67$hi;
       i64toi32_i32$1 = $67;
       i64toi32_i32$0 = $76$hi;
       i64toi32_i32$3 = $52;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 8;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $53 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
        $53 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       $78$hi = i64toi32_i32$1;
       i64toi32_i32$1 = 0;
       i64toi32_i32$0 = $3;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 255;
       i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
       $81 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
       $81$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $78$hi;
       i64toi32_i32$1 = $53;
       i64toi32_i32$0 = $81$hi;
       i64toi32_i32$3 = $81;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
       $5 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       $5$hi = i64toi32_i32$0;
       i64toi32_i32$2 = $2 + 136 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $7 = i64toi32_i32$0;
       $7$hi = i64toi32_i32$1;
       i64toi32_i32$2 = $2 + 128 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $8 = i64toi32_i32$1;
       $8$hi = i64toi32_i32$0;
       $1 = 2;
       break label$4;
      }
      i64toi32_i32$2 = $2 + 64 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $93 = i64toi32_i32$0;
      i64toi32_i32$0 = $2 + 8 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $93;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $2 + 56 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $97 = i64toi32_i32$1;
      i64toi32_i32$1 = $2;
      HEAP32[$2 >> 2] = $97;
      HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $2 + 48 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $7 = i64toi32_i32$0;
      $7$hi = i64toi32_i32$1;
      $1 = 2;
      $3 = 0;
      i64toi32_i32$1 = $5$hi;
      $8 = $5;
      $8$hi = i64toi32_i32$1;
      break label$2;
     }
     label$9 : {
      if (!(HEAPU8[($2 + 24 | 0) >> 0] | 0)) {
       break label$9
      }
      core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9($2 + 32 | 0 | 0);
     }
     $3 = 0;
     i64toi32_i32$1 = $5$hi;
     $6 = $5;
     $6$hi = i64toi32_i32$1;
     break label$2;
    }
    i64toi32_i32$2 = $2 + 72 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $112 = i64toi32_i32$1;
    i64toi32_i32$1 = $2 + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $112;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($2 + 96 | 0) >> 2] = HEAPU8[($2 + 25 | 0) >> 0] | 0 | ((HEAPU8[($2 + 26 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 27 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 28 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $36 = HEAPU8[($2 + 28 | 0) >> 0] | 0 | ((HEAPU8[($2 + 29 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 30 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 31 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    HEAP8[($2 + 99 | 0) >> 0] = $36;
    HEAP8[($2 + 100 | 0) >> 0] = $36 >>> 8 | 0;
    HEAP8[($2 + 101 | 0) >> 0] = $36 >>> 16 | 0;
    HEAP8[($2 + 102 | 0) >> 0] = $36 >>> 24 | 0;
    $37 = ($2 + 24 | 0) + 9 | 0;
    HEAP32[($2 + 16 | 0) >> 2] = HEAPU8[$37 >> 0] | 0 | ((HEAPU8[($37 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($37 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($37 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $38 = ($2 + 24 | 0) + 12 | 0;
    $39 = HEAPU8[$38 >> 0] | 0 | ((HEAPU8[($38 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($38 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($38 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    HEAP8[($2 + 19 | 0) >> 0] = $39;
    HEAP8[($2 + 20 | 0) >> 0] = $39 >>> 8 | 0;
    HEAP8[($2 + 21 | 0) >> 0] = $39 >>> 16 | 0;
    HEAP8[($2 + 22 | 0) >> 0] = $39 >>> 24 | 0;
    i64toi32_i32$2 = $2 + 64 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $132 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[i64toi32_i32$0 >> 2] = $132;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    $1 = HEAPU8[((i64toi32_i32$0 + 24 | 0) + 8 | 0) >> 0] | 0;
    i64toi32_i32$2 = (i64toi32_i32$0 + 24 | 0) + 16 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $6 = i64toi32_i32$1;
    $6$hi = i64toi32_i32$0;
    i64toi32_i32$2 = ($2 + 24 | 0) + 24 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $8 = i64toi32_i32$0;
    $8$hi = i64toi32_i32$1;
    i64toi32_i32$2 = $2 + 56 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $7 = i64toi32_i32$1;
    $7$hi = i64toi32_i32$0;
    $3 = HEAP32[($2 + 80 | 0) >> 2] | 0;
    $4 = HEAPU8[($2 + 24 | 0) >> 0] | 0;
    HEAP32[(($2 + 112 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 92 | 0) >> 2] | 0;
    i64toi32_i32$2 = $2 + 84 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $162 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[(i64toi32_i32$0 + 112 | 0) >> 2] = $162;
    HEAP32[(i64toi32_i32$0 + 116 | 0) >> 2] = i64toi32_i32$1;
    if (($4 | 0) == (1 | 0)) {
     break label$2
    }
    $40 = HEAP32[($2 + 96 | 0) >> 2] | 0;
    HEAP8[($0 + 1 | 0) >> 0] = $40;
    HEAP8[($0 + 2 | 0) >> 0] = $40 >>> 8 | 0;
    HEAP8[($0 + 3 | 0) >> 0] = $40 >>> 16 | 0;
    HEAP8[($0 + 4 | 0) >> 0] = $40 >>> 24 | 0;
    $169 = $0 + 28 | 0;
    i64toi32_i32$1 = $8$hi;
    i64toi32_i32$2 = $8;
    i64toi32_i32$0 = 0;
    i64toi32_i32$3 = 32;
    i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$0 = 0;
     $54 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
    } else {
     i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
     $54 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
    }
    HEAP8[$169 >> 0] = $54;
    i64toi32_i32$0 = $8$hi;
    $41 = $0 + 24 | 0;
    $42 = $8;
    HEAP8[$41 >> 0] = $42;
    HEAP8[($41 + 1 | 0) >> 0] = $42 >>> 8 | 0;
    HEAP8[($41 + 2 | 0) >> 0] = $42 >>> 16 | 0;
    HEAP8[($41 + 3 | 0) >> 0] = $42 >>> 24 | 0;
    $43 = $0 + 4 | 0;
    $44 = HEAPU8[($2 + 99 | 0) >> 0] | 0 | ((HEAPU8[($2 + 100 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 101 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 102 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    HEAP8[$43 >> 0] = $44;
    HEAP8[($43 + 1 | 0) >> 0] = $44 >>> 8 | 0;
    HEAP8[($43 + 2 | 0) >> 0] = $44 >>> 16 | 0;
    HEAP8[($43 + 3 | 0) >> 0] = $44 >>> 24 | 0;
    HEAP8[($0 + 8 | 0) >> 0] = $1;
    $45 = $0 + 9 | 0;
    $46 = HEAP32[($2 + 16 | 0) >> 2] | 0;
    HEAP8[$45 >> 0] = $46;
    HEAP8[($45 + 1 | 0) >> 0] = $46 >>> 8 | 0;
    HEAP8[($45 + 2 | 0) >> 0] = $46 >>> 16 | 0;
    HEAP8[($45 + 3 | 0) >> 0] = $46 >>> 24 | 0;
    $47 = $0 + 12 | 0;
    $48 = HEAPU8[($2 + 19 | 0) >> 0] | 0 | ((HEAPU8[($2 + 20 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 21 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 22 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    HEAP8[$47 >> 0] = $48;
    HEAP8[($47 + 1 | 0) >> 0] = $48 >>> 8 | 0;
    HEAP8[($47 + 2 | 0) >> 0] = $48 >>> 16 | 0;
    HEAP8[($47 + 3 | 0) >> 0] = $48 >>> 24 | 0;
    i64toi32_i32$0 = $6$hi;
    i64toi32_i32$2 = $0 + 16 | 0;
    HEAP8[i64toi32_i32$2 >> 0] = $6;
    HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $6 >>> 8 | 0;
    HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $6 >>> 16 | 0;
    HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $6 >>> 24 | 0;
    HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    $1 = 0;
    break label$1;
   }
   i64toi32_i32$0 = $7$hi;
   i64toi32_i32$2 = $2 + 48 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $7;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $8$hi;
   i64toi32_i32$2 = $2 + 40 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $8;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $6$hi;
   i64toi32_i32$2 = ($2 + 24 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $6;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$1 = $2;
   i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $206 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 56 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $206;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$1 = $2;
   i64toi32_i32$2 = HEAP32[($2 + 112 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 116 | 0) >> 2] | 0;
   $210 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 76 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $210;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$1 = $2 + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $215 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 64 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $215;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   HEAP32[($2 + 84 | 0) >> 2] = HEAP32[(($2 + 112 | 0) + 8 | 0) >> 2] | 0;
   HEAP8[($2 + 24 | 0) >> 0] = $1;
   $49 = HEAP32[($2 + 16 | 0) >> 2] | 0;
   HEAP8[($2 + 25 | 0) >> 0] = $49;
   HEAP8[($2 + 26 | 0) >> 0] = $49 >>> 8 | 0;
   HEAP8[($2 + 27 | 0) >> 0] = $49 >>> 16 | 0;
   HEAP8[($2 + 28 | 0) >> 0] = $49 >>> 24 | 0;
   $50 = HEAPU8[($2 + 19 | 0) >> 0] | 0 | ((HEAPU8[($2 + 20 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 21 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 22 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[($2 + 28 | 0) >> 0] = $50;
   HEAP8[($2 + 29 | 0) >> 0] = $50 >>> 8 | 0;
   HEAP8[($2 + 30 | 0) >> 0] = $50 >>> 16 | 0;
   HEAP8[($2 + 31 | 0) >> 0] = $50 >>> 24 | 0;
   HEAP32[($2 + 72 | 0) >> 2] = $3;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 24 | 0 | 0, 1051756 | 0, 12 | 0);
   $1 = 1;
  }
  HEAP8[$0 >> 0] = $1;
  global$0 = $2 + 160 | 0;
 }
 
 function $std__io__error__Error_20as_20core__fmt__Display___fmt__h141afc8863ce4203($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $3 = 0, $2 = 0, $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $10 = 0, $11 = 0, $12 = 0, $13 = 0, $14 = 0, $22 = 0, $24 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     switch (HEAPU8[$0 >> 0] | 0 | 0) {
     default:
      HEAP32[($2 + 4 | 0) >> 2] = HEAP32[($0 + 4 | 0) >> 2] | 0;
      $0 = __rust_alloc(20 | 0, 1 | 0) | 0;
      if (!$0) {
       break label$1
      }
      $10 = 0;
      $11 = $0 + 16 | 0;
      $12 = HEAPU8[($10 + 1145240 | 0) >> 0] | 0 | ((HEAPU8[($10 + 1145241 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($10 + 1145242 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($10 + 1145243 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[$11 >> 0] = $12;
      HEAP8[($11 + 1 | 0) >> 0] = $12 >>> 8 | 0;
      HEAP8[($11 + 2 | 0) >> 0] = $12 >>> 16 | 0;
      HEAP8[($11 + 3 | 0) >> 0] = $12 >>> 24 | 0;
      i64toi32_i32$2 = 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 1145232 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1145233 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 1145234 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 1145235 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 1145236 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1145237 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 1145238 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 1145239 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $22 = i64toi32_i32$0;
      i64toi32_i32$0 = $0 + 8 | 0;
      $13 = $22;
      HEAP8[i64toi32_i32$0 >> 0] = $13;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $13 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $13 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $13 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      i64toi32_i32$2 = 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 1145224 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1145225 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 1145226 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 1145227 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 1145228 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1145229 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 1145230 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 1145231 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $24 = i64toi32_i32$1;
      i64toi32_i32$1 = $0;
      $14 = $24;
      HEAP8[$0 >> 0] = $14;
      HEAP8[($0 + 1 | 0) >> 0] = $14 >>> 8 | 0;
      HEAP8[($0 + 2 | 0) >> 0] = $14 >>> 16 | 0;
      HEAP8[($0 + 3 | 0) >> 0] = $14 >>> 24 | 0;
      HEAP8[($0 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[($0 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[($0 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[($0 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      i64toi32_i32$1 = $2;
      i64toi32_i32$0 = 20;
      HEAP32[($2 + 12 | 0) >> 2] = 20;
      HEAP32[($2 + 16 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[($2 + 8 | 0) >> 2] = $0;
      HEAP32[(($2 + 40 | 0) + 20 | 0) >> 2] = 2;
      HEAP32[($2 + 36 | 0) >> 2] = 167;
      i64toi32_i32$1 = $2;
      i64toi32_i32$0 = 0;
      HEAP32[($2 + 44 | 0) >> 2] = 3;
      HEAP32[($2 + 48 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[($2 + 40 | 0) >> 2] = 1143696;
      HEAP32[($2 + 28 | 0) >> 2] = 270;
      HEAP32[($2 + 56 | 0) >> 2] = $2 + 24 | 0;
      HEAP32[($2 + 32 | 0) >> 2] = $2 + 4 | 0;
      HEAP32[($2 + 24 | 0) >> 2] = $2 + 8 | 0;
      $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 40 | 0 | 0) | 0;
      $1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
      if (!$1) {
       break label$2
      }
      $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
      if (!$3) {
       break label$2
      }
      __rust_dealloc($1 | 0, $3 | 0, 1 | 0);
      break label$2;
     case 1:
      $3 = 1143574;
      $4 = 16;
      label$7 : {
       label$8 : {
        label$9 : {
         switch (HEAPU8[($0 + 1 | 0) >> 0] | 0 | 0) {
         case 1:
          $3 = 1143557;
          $4 = 17;
          break label$7;
         case 2:
          $3 = 1143539;
          $4 = 18;
          break label$7;
         case 3:
          $3 = 1143523;
          break label$7;
         case 4:
          $3 = 1143507;
          break label$7;
         case 5:
          $3 = 1143488;
          break label$8;
         case 6:
          $3 = 1143470;
          $4 = 18;
          break label$7;
         case 7:
          $3 = 1143457;
          $4 = 13;
          break label$7;
         case 8:
          $3 = 1143443;
          $4 = 14;
          break label$7;
         case 9:
          $3 = 1143422;
          $4 = 21;
          break label$7;
         case 10:
          $3 = 1143410;
          $4 = 12;
          break label$7;
         case 11:
          $3 = 1143399;
          $4 = 11;
          break label$7;
         case 12:
          $3 = 1143378;
          $4 = 21;
          break label$7;
         case 13:
          $3 = 1143357;
          $4 = 21;
          break label$7;
         case 14:
          $3 = 1143342;
          $4 = 15;
          break label$7;
         case 15:
          $3 = 1143328;
          $4 = 14;
          break label$7;
         case 16:
          $3 = 1143309;
          break label$8;
         case 17:
          $3 = 1143271;
          $4 = 38;
          break label$7;
         case 18:
          $3 = 1143215;
          $4 = 56;
          break label$7;
         case 19:
          $3 = 1143190;
          $4 = 25;
          break label$7;
         case 20:
          $3 = 1143167;
          $4 = 23;
          break label$7;
         case 21:
          $3 = 1143155;
          $4 = 12;
          break label$7;
         case 22:
          $3 = 1143146;
          $4 = 9;
          break label$7;
         case 23:
          $3 = 1143136;
          $4 = 10;
          break label$7;
         case 24:
          $3 = 1143120;
          break label$7;
         case 25:
          $3 = 1143097;
          $4 = 23;
          break label$7;
         case 26:
          $3 = 1143072;
          $4 = 25;
          break label$7;
         case 27:
          $3 = 1143058;
          $4 = 14;
          break label$7;
         case 28:
          $3 = 1143045;
          $4 = 13;
          break label$7;
         case 29:
          $3 = 1143025;
          $4 = 20;
          break label$7;
         case 30:
          $3 = 1143017;
          $4 = 8;
          break label$7;
         case 31:
          $3 = 1142990;
          $4 = 27;
          break label$7;
         case 32:
          $3 = 1142976;
          $4 = 14;
          break label$7;
         case 33:
          $3 = 1142959;
          $4 = 17;
          break label$7;
         case 34:
          $3 = 1142937;
          $4 = 22;
          break label$7;
         case 35:
          $3 = 1142916;
          $4 = 21;
          break label$7;
         case 36:
          $3 = 1142905;
          $4 = 11;
          break label$7;
         case 37:
          $3 = 1142883;
          $4 = 22;
          break label$7;
         case 38:
          $3 = 1142872;
          $4 = 11;
          break label$7;
         case 39:
          $3 = 1142859;
          $4 = 13;
          break label$7;
         case 40:
          break label$9;
         default:
          break label$7;
         };
        }
        $3 = 1142840;
       }
       $4 = 19;
      }
      HEAP32[($2 + 60 | 0) >> 2] = 1;
      HEAP32[($2 + 28 | 0) >> 2] = $4;
      HEAP32[($2 + 24 | 0) >> 2] = $3;
      HEAP32[($2 + 12 | 0) >> 2] = 271;
      i64toi32_i32$1 = $2;
      i64toi32_i32$0 = 0;
      HEAP32[($2 + 44 | 0) >> 2] = 1;
      HEAP32[($2 + 48 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[($2 + 40 | 0) >> 2] = 1142832;
      HEAP32[($2 + 8 | 0) >> 2] = $2 + 24 | 0;
      HEAP32[($2 + 56 | 0) >> 2] = $2 + 8 | 0;
      $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 40 | 0 | 0) | 0;
      break label$2;
     case 2:
      $0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
      $0 = $str_20as_20core__fmt__Display___fmt__hdd03b40cdcec1d4f(HEAP32[$0 >> 2] | 0 | 0, HEAP32[($0 + 4 | 0) >> 2] | 0 | 0, $1 | 0) | 0;
      break label$2;
     case 3:
      break label$3;
     };
    }
    $0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    $0 = FUNCTION_TABLE[HEAP32[((HEAP32[($0 + 4 | 0) >> 2] | 0) + 32 | 0) >> 2] | 0 | 0](HEAP32[$0 >> 2] | 0, $1) | 0;
   }
   global$0 = $2 + 64 | 0;
   return $0 | 0;
  }
  alloc__alloc__handle_alloc_error__he269d8f1bff90960(20 | 0, 1 | 0);
  abort();
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__PoolRetirement___deserialize__h55f532dbffc17752($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $7 = 0, $7$hi = 0, $3 = 0, $8 = 0, $8$hi = 0, $33 = 0, $34 = 0, $35 = 0, $36 = 0, $37 = 0, $38 = 0, $39 = 0, $40 = 0, $41 = 0, $42 = 0, $4 = 0, $67 = 0, $67$hi = 0, $70 = 0, $70$hi = 0, $74$hi = 0, $76$hi = 0, $78$hi = 0, $81 = 0, $81$hi = 0, $100 = 0, $118 = 0, $5 = 0, $6 = 0, $151 = 0, $179 = 0, $188 = 0, $210 = 0, $214 = 0, $220 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 32 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 40 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 44 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      i64toi32_i32$2 = $2;
      i64toi32_i32$1 = HEAP32[($2 + 32 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($2 + 36 | 0) >> 2] | 0;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 1;
      if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
       break label$4
      }
      i64toi32_i32$2 = $7$hi;
      i64toi32_i32$0 = i64toi32_i32$2;
      cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__PoolRetirement___deserialize_as_embedded_group__h069038c66944b4a7($2 + 32 | 0 | 0, $1 | 0, $7 | 0, i64toi32_i32$2 | 0, $7 | 0, i64toi32_i32$2 | 0);
      label$5 : {
       i64toi32_i32$0 = i64toi32_i32$2;
       i64toi32_i32$0 = i64toi32_i32$2;
       i64toi32_i32$3 = $7;
       i64toi32_i32$2 = 0;
       i64toi32_i32$1 = 1;
       if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) | 0) {
        break label$5
       }
       cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 128 | 0 | 0, $1 | 0);
       $3 = HEAPU8[($2 + 136 | 0) >> 0] | 0;
       label$6 : {
        label$7 : {
         i64toi32_i32$1 = $2;
         i64toi32_i32$3 = HEAP32[($2 + 128 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($2 + 132 | 0) >> 2] | 0;
         i64toi32_i32$1 = i64toi32_i32$3;
         i64toi32_i32$3 = 0;
         i64toi32_i32$2 = 1;
         if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) | 0) {
          break label$7
         }
         $1 = 5;
         if (($3 & 255 | 0 | 0) == (5 | 0)) {
          break label$5
         }
         break label$6;
        }
        i64toi32_i32$2 = $2 + 164 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $7 = i64toi32_i32$1;
        $7$hi = i64toi32_i32$0;
        i64toi32_i32$1 = ($2 + 104 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $7;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        $1 = HEAP32[($2 + 172 | 0) >> 2] | 0;
        HEAP32[(($2 + 104 | 0) + 16 | 0) >> 2] = $1;
        i64toi32_i32$1 = ($2 + 8 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $7;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        HEAP32[(($2 + 8 | 0) + 16 | 0) >> 2] = $1;
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 156 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 160 | 0) >> 2] | 0;
        $7 = i64toi32_i32$0;
        $7$hi = i64toi32_i32$1;
        i64toi32_i32$0 = $2;
        HEAP32[($2 + 104 | 0) >> 2] = $7;
        HEAP32[($2 + 108 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$0 = $2;
        HEAP32[($2 + 8 | 0) >> 2] = $7;
        HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$2 = $2;
        i64toi32_i32$1 = HEAPU8[($2 + 137 | 0) >> 0] | 0 | ((HEAPU8[($2 + 138 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 139 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 140 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$0 = 0;
        $67 = i64toi32_i32$1;
        $67$hi = i64toi32_i32$0;
        i64toi32_i32$2 = $2 + 141 | 0;
        i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
        i64toi32_i32$1 = 0;
        $70 = i64toi32_i32$0;
        $70$hi = i64toi32_i32$1;
        i64toi32_i32$2 = $2 + 143 | 0;
        i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$2 = i64toi32_i32$1;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 16;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
         $40 = 0;
        } else {
         i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
         $40 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        }
        $74$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $70$hi;
        i64toi32_i32$0 = $70;
        i64toi32_i32$2 = $74$hi;
        i64toi32_i32$3 = $40;
        i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
        i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 32;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
         $41 = 0;
        } else {
         i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
         $41 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        }
        $76$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $67$hi;
        i64toi32_i32$2 = $67;
        i64toi32_i32$1 = $76$hi;
        i64toi32_i32$3 = $41;
        i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
        i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
        i64toi32_i32$2 = 0;
        i64toi32_i32$3 = 8;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
         $42 = 0;
        } else {
         i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
         $42 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        }
        $78$hi = i64toi32_i32$2;
        i64toi32_i32$2 = 0;
        i64toi32_i32$1 = $3;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 255;
        i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
        $81 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
        $81$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $78$hi;
        i64toi32_i32$2 = $42;
        i64toi32_i32$1 = $81$hi;
        i64toi32_i32$3 = $81;
        i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
        $7 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
        $7$hi = i64toi32_i32$1;
        $3 = HEAP32[($2 + 152 | 0) >> 2] | 0;
        i64toi32_i32$0 = ($2 + 128 | 0) + 16 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
        $8 = i64toi32_i32$1;
        $8$hi = i64toi32_i32$2;
        $1 = 2;
       }
       if (!(HEAP32[($2 + 32 | 0) >> 2] | 0)) {
        break label$3
       }
       core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9($2 + 40 | 0 | 0);
       break label$3;
      }
      i64toi32_i32$0 = $2 + 76 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
      $100 = i64toi32_i32$2;
      i64toi32_i32$2 = ($2 + 8 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $100;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[(($2 + 8 | 0) + 16 | 0) >> 2] = HEAP32[($2 + 84 | 0) >> 2] | 0;
      HEAP32[($2 + 104 | 0) >> 2] = HEAPU8[($2 + 41 | 0) >> 0] | 0 | ((HEAPU8[($2 + 42 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 43 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 44 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $33 = ($2 + 32 | 0) + 12 | 0;
      $34 = HEAPU8[$33 >> 0] | 0 | ((HEAPU8[($33 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($33 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($33 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[($2 + 107 | 0) >> 0] = $34;
      HEAP8[($2 + 108 | 0) >> 0] = $34 >>> 8 | 0;
      HEAP8[($2 + 109 | 0) >> 0] = $34 >>> 16 | 0;
      HEAP8[($2 + 110 | 0) >> 0] = $34 >>> 24 | 0;
      i64toi32_i32$0 = $2 + 68 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
      $118 = i64toi32_i32$1;
      i64toi32_i32$1 = $2;
      HEAP32[($2 + 8 | 0) >> 2] = $118;
      HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$2;
      $1 = HEAPU8[(($2 + 32 | 0) + 8 | 0) >> 0] | 0;
      i64toi32_i32$0 = ($2 + 32 | 0) + 16 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
      $7 = i64toi32_i32$2;
      $7$hi = i64toi32_i32$1;
      i64toi32_i32$0 = ($2 + 32 | 0) + 24 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
      $8 = i64toi32_i32$1;
      $8$hi = i64toi32_i32$2;
      $3 = HEAP32[(($2 + 32 | 0) + 32 | 0) >> 2] | 0;
      $4 = HEAP32[($2 + 88 | 0) >> 2] | 0;
      $5 = HEAP32[($2 + 36 | 0) >> 2] | 0;
      $6 = HEAP32[($2 + 32 | 0) >> 2] | 0;
      HEAP32[(($2 + 128 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 100 | 0) >> 2] | 0;
      i64toi32_i32$0 = $2 + 92 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
      $151 = i64toi32_i32$2;
      i64toi32_i32$2 = $2;
      HEAP32[($2 + 128 | 0) >> 2] = $151;
      HEAP32[($2 + 132 | 0) >> 2] = i64toi32_i32$1;
      if (($6 | 0) == (1 | 0)) {
       break label$2
      }
      HEAP32[($0 + 4 | 0) >> 2] = $5;
      $35 = HEAP32[($2 + 104 | 0) >> 2] | 0;
      HEAP8[($0 + 9 | 0) >> 0] = $35;
      HEAP8[($0 + 10 | 0) >> 0] = $35 >>> 8 | 0;
      HEAP8[($0 + 11 | 0) >> 0] = $35 >>> 16 | 0;
      HEAP8[($0 + 12 | 0) >> 0] = $35 >>> 24 | 0;
      HEAP8[($0 + 8 | 0) >> 0] = $1;
      $36 = $0 + 12 | 0;
      $37 = HEAPU8[($2 + 107 | 0) >> 0] | 0 | ((HEAPU8[($2 + 108 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 109 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 110 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[$36 >> 0] = $37;
      HEAP8[($36 + 1 | 0) >> 0] = $37 >>> 8 | 0;
      HEAP8[($36 + 2 | 0) >> 0] = $37 >>> 16 | 0;
      HEAP8[($36 + 3 | 0) >> 0] = $37 >>> 24 | 0;
      HEAP32[($0 + 32 | 0) >> 2] = $3;
      i64toi32_i32$1 = $8$hi;
      i64toi32_i32$2 = $0 + 24 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $8;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$1 = $7$hi;
      i64toi32_i32$2 = $0 + 16 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $7;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      $1 = 0;
      break label$1;
     }
     i64toi32_i32$0 = $2 + 68 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $179 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 16 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $179;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
     HEAP32[(($2 + 8 | 0) + 16 | 0) >> 2] = HEAP32[($2 + 76 | 0) >> 2] | 0;
     i64toi32_i32$0 = $2;
     i64toi32_i32$2 = HEAP32[($2 + 60 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 64 | 0) >> 2] | 0;
     $188 = i64toi32_i32$2;
     i64toi32_i32$2 = $2;
     HEAP32[($2 + 8 | 0) >> 2] = $188;
     HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
     $3 = HEAP32[($2 + 56 | 0) >> 2] | 0;
     i64toi32_i32$0 = ($2 + 32 | 0) + 16 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $8 = i64toi32_i32$1;
     $8$hi = i64toi32_i32$2;
     $1 = 2;
    }
    $4 = 0;
   }
   HEAP32[($2 + 56 | 0) >> 2] = $3;
   i64toi32_i32$2 = $8$hi;
   i64toi32_i32$1 = ($2 + 32 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $8;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$2 = $7$hi;
   i64toi32_i32$1 = ($2 + 32 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $7;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = $2;
   i64toi32_i32$2 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $210 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 60 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $210;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$0 = $2;
   i64toi32_i32$1 = HEAP32[($2 + 128 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($2 + 132 | 0) >> 2] | 0;
   $214 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 84 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $214;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = ($2 + 8 | 0) + 8 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $220 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 68 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $220;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($2 + 76 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 16 | 0) >> 2] | 0;
   HEAP32[($2 + 92 | 0) >> 2] = HEAP32[(($2 + 128 | 0) + 8 | 0) >> 2] | 0;
   HEAP8[($2 + 32 | 0) >> 0] = $1;
   $38 = HEAP32[($2 + 104 | 0) >> 2] | 0;
   HEAP8[($2 + 33 | 0) >> 0] = $38;
   HEAP8[($2 + 34 | 0) >> 0] = $38 >>> 8 | 0;
   HEAP8[($2 + 35 | 0) >> 0] = $38 >>> 16 | 0;
   HEAP8[($2 + 36 | 0) >> 0] = $38 >>> 24 | 0;
   $39 = HEAPU8[($2 + 107 | 0) >> 0] | 0 | ((HEAPU8[($2 + 108 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 109 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 110 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[($2 + 36 | 0) >> 0] = $39;
   HEAP8[($2 + 37 | 0) >> 0] = $39 >>> 8 | 0;
   HEAP8[($2 + 38 | 0) >> 0] = $39 >>> 16 | 0;
   HEAP8[($2 + 39 | 0) >> 0] = $39 >>> 24 | 0;
   HEAP32[($2 + 80 | 0) >> 2] = $4;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 32 | 0 | 0, 1051006 | 0, 14 | 0);
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function header_new($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $2 = 0, $46 = 0, $48 = 0, $49 = 0, $50 = 0, $51 = 0, $53 = 0, $54 = 0, $55 = 0, $57 = 0, $58 = 0, $59 = 0, $60 = 0, $61 = 0, $63 = 0, $64 = 0, $65 = 0, $9 = 0, $9$hi = 0, $3 = 0, $6 = 0, $4 = 0, $8 = 0, $8$hi = 0, $5 = 0, $42 = 0, $47 = 0, $52 = 0, $56 = 0, $62 = 0, $68 = 0, $74 = 0, $82 = 0, $88 = 0, $94 = 0, $99 = 0, $7 = 0, $125 = 0, $131 = 0, $137 = 0, $140 = 0, $144 = 0, $150 = 0, $156 = 0, $162 = 0, $10 = 0, $10$hi = 0, $176 = 0, $182 = 0, $188 = 0, $194 = 0, $200 = 0, $206 = 0, $215 = 0, $221 = 0, $227 = 0, $236 = 0;
  $2 = global$0 - 720 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h2ac16fcb64db16b5($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h84d192b5a1b597ea($2 | 0, $1 | 0);
   $4 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   i64toi32_i32$2 = $0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $8 = i64toi32_i32$0;
   $8$hi = i64toi32_i32$1;
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $5 = HEAP32[$2 >> 2] | 0;
   $6 = 0;
   label$2 : {
    if ((HEAPU8[(i64toi32_i32$2 + 176 | 0) >> 0] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    i64toi32_i32$2 = $0 + 201 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $42 = i64toi32_i32$1;
    i64toi32_i32$1 = $2 + 368 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $42;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $0 + 193 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $47 = i64toi32_i32$0;
    i64toi32_i32$0 = $2 + 360 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $47;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $0 + 185 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $52 = i64toi32_i32$1;
    i64toi32_i32$1 = $2 + 352 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $52;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $0 + 177 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $56 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[(i64toi32_i32$0 + 344 | 0) >> 2] = $56;
    HEAP32[(i64toi32_i32$0 + 348 | 0) >> 2] = i64toi32_i32$1;
    $6 = 1;
   }
   i64toi32_i32$2 = $0 + 233 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $62 = i64toi32_i32$1;
   i64toi32_i32$1 = ($2 + 16 | 0) + 233 | 0;
   $46 = $62;
   HEAP8[i64toi32_i32$1 >> 0] = $46;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $46 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $46 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $46 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $0 + 225 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $68 = i64toi32_i32$0;
   i64toi32_i32$0 = ($2 + 16 | 0) + 225 | 0;
   $48 = $68;
   HEAP8[i64toi32_i32$0 >> 0] = $48;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $48 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $48 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $48 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = $0 + 217 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $74 = i64toi32_i32$1;
   i64toi32_i32$1 = ($2 + 16 | 0) + 217 | 0;
   $49 = $74;
   HEAP8[i64toi32_i32$1 >> 0] = $49;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $49 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $49 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $49 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 209 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 210 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 211 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 212 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 213 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 214 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 215 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 216 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $9 = i64toi32_i32$0;
   $9$hi = i64toi32_i32$1;
   i64toi32_i32$2 = i64toi32_i32$2 + 249 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $82 = i64toi32_i32$1;
   i64toi32_i32$1 = ($2 + 16 | 0) + 249 | 0;
   $50 = $82;
   HEAP8[i64toi32_i32$1 >> 0] = $50;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $50 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $50 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $50 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $0 + 257 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $88 = i64toi32_i32$0;
   i64toi32_i32$0 = ($2 + 16 | 0) + 257 | 0;
   $51 = $88;
   HEAP8[i64toi32_i32$0 >> 0] = $51;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $51 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $51 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $51 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = $0 + 265 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $94 = i64toi32_i32$1;
   i64toi32_i32$1 = ($2 + 16 | 0) + 265 | 0;
   $53 = $94;
   HEAP8[i64toi32_i32$1 >> 0] = $53;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $53 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $53 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $53 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$0 = $9$hi;
   i64toi32_i32$1 = $2;
   $54 = $9;
   HEAP8[(i64toi32_i32$1 + 225 | 0) >> 0] = $54;
   HEAP8[(i64toi32_i32$1 + 226 | 0) >> 0] = $54 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 227 | 0) >> 0] = $54 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 228 | 0) >> 0] = $54 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 229 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 230 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 231 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 232 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 241 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 242 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 243 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 244 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 245 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 246 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 247 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 248 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $99 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   $55 = $99;
   HEAP8[(i64toi32_i32$0 + 257 | 0) >> 0] = $55;
   HEAP8[(i64toi32_i32$0 + 258 | 0) >> 0] = $55 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 259 | 0) >> 0] = $55 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 260 | 0) >> 0] = $55 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 261 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 262 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 263 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 264 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3(i64toi32_i32$0 + 672 | 0 | 0, i64toi32_i32$2 + 12 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3((i64toi32_i32$0 + 672 | 0) + 12 | 0 | 0, i64toi32_i32$2 + 24 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3(i64toi32_i32$0 + 696 | 0 | 0, i64toi32_i32$2 + 36 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3((i64toi32_i32$0 + 696 | 0) + 12 | 0 | 0, i64toi32_i32$2 + 48 | 0 | 0);
   $7 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
   i64toi32_i32$2 = i64toi32_i32$2 + 297 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $125 = i64toi32_i32$1;
   i64toi32_i32$1 = ($2 + 16 | 0) + 297 | 0;
   $57 = $125;
   HEAP8[i64toi32_i32$1 >> 0] = $57;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $57 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $57 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $57 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $0 + 289 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $131 = i64toi32_i32$0;
   i64toi32_i32$0 = ($2 + 16 | 0) + 289 | 0;
   $58 = $131;
   HEAP8[i64toi32_i32$0 >> 0] = $58;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $58 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $58 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $58 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = $0 + 281 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $137 = i64toi32_i32$1;
   i64toi32_i32$1 = ($2 + 16 | 0) + 281 | 0;
   $59 = $137;
   HEAP8[i64toi32_i32$1 >> 0] = $59;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $59 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $59 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $59 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 273 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 274 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 275 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 276 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 277 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 278 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 279 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 280 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $140 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   $60 = $140;
   HEAP8[(i64toi32_i32$0 + 289 | 0) >> 0] = $60;
   HEAP8[(i64toi32_i32$0 + 290 | 0) >> 0] = $60 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 291 | 0) >> 0] = $60 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 292 | 0) >> 0] = $60 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 293 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 294 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 295 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 296 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 72 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 76 | 0) >> 2] | 0;
   $144 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 88 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $144;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = i64toi32_i32$2 + 80 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $150 = i64toi32_i32$0;
   i64toi32_i32$0 = ($2 + 16 | 0) + 80 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $150;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $0 + 88 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $156 = i64toi32_i32$1;
   i64toi32_i32$1 = ($2 + 16 | 0) + 88 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $156;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $0 + 96 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $162 = i64toi32_i32$0;
   i64toi32_i32$0 = ($2 + 16 | 0) + 96 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $162;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
   $9 = i64toi32_i32$1;
   $9$hi = i64toi32_i32$0;
   memcpy(($2 + 16 | 0) + 104 | 0 | 0, i64toi32_i32$2 + 104 | 0 | 0, 64 | 0) | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 168 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 172 | 0) >> 2] | 0;
   $10 = i64toi32_i32$0;
   $10$hi = i64toi32_i32$1;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 344 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 348 | 0) >> 2] | 0;
   $176 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2 + 193 | 0;
   $61 = $176;
   HEAP8[i64toi32_i32$1 >> 0] = $61;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $61 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $61 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $61 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = (i64toi32_i32$2 + 344 | 0) + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $182 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 201 | 0;
   $63 = $182;
   HEAP8[i64toi32_i32$0 >> 0] = $63;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $63 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $63 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $63 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = ($2 + 344 | 0) + 16 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $188 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 209 | 0;
   $64 = $188;
   HEAP8[i64toi32_i32$1 >> 0] = $64;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $64 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $64 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $64 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = ($2 + 344 | 0) + 24 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $194 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 217 | 0;
   $65 = $194;
   HEAP8[i64toi32_i32$0 >> 0] = $65;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $65 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $65 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $65 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = ($2 + 672 | 0) + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $200 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 36 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $200;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = ($2 + 672 | 0) + 16 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $206 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 44 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $206;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($2 + 24 | 0) >> 2] = $4;
   i64toi32_i32$1 = $8$hi;
   i64toi32_i32$0 = $2;
   HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $8;
   HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 192 | 0) >> 0] = $6;
   i64toi32_i32$2 = i64toi32_i32$0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 672 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 676 | 0) >> 2] | 0;
   $215 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] = $215;
   HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = (i64toi32_i32$2 + 696 | 0) + 16 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $221 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 68 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $221;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = ($2 + 696 | 0) + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $227 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 60 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $227;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $10$hi;
   i64toi32_i32$1 = $2;
   HEAP32[(i64toi32_i32$1 + 184 | 0) >> 2] = $10;
   HEAP32[(i64toi32_i32$1 + 188 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[(i64toi32_i32$1 + 76 | 0) >> 2] = $7;
   i64toi32_i32$0 = $9$hi;
   HEAP32[(i64toi32_i32$1 + 80 | 0) >> 2] = $9;
   HEAP32[(i64toi32_i32$1 + 84 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = i64toi32_i32$1;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 696 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 700 | 0) >> 2] | 0;
   $236 = i64toi32_i32$0;
   i64toi32_i32$0 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = $236;
   HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] = i64toi32_i32$1;
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3(i64toi32_i32$2 + 328 | 0 | 0, $5 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
   memcpy(i64toi32_i32$2 + 344 | 0 | 0, i64toi32_i32$2 + 16 | 0 | 0, 328 | 0) | 0;
   $0 = $cardano_serialization_lib__Header_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h7c5802dbd37296c4(i64toi32_i32$2 + 344 | 0 | 0) | 0;
   global$0 = i64toi32_i32$2 + 720 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__HeaderBody___serialize__hbb751f3982bde43a($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, $54 = 0, $59 = 0, $64 = 0, $68 = 0, $87 = 0, $92 = 0, $98 = 0, $101 = 0, $134 = 0, $139 = 0, $145 = 0, $148 = 0;
  $3 = global$0 - 80 | 0;
  global$0 = $3;
  i64toi32_i32$0 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, 15 | 0, i64toi32_i32$0 | 0);
  $4 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
         break label$6
        }
        i64toi32_i32$2 = $1;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
        i64toi32_i32$1 = 0;
        cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, i64toi32_i32$0 | 0, i64toi32_i32$1 | 0);
        if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
         break label$5
        }
        i64toi32_i32$2 = $1;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, i64toi32_i32$1 | 0, i64toi32_i32$0 | 0);
        $4 = 1;
        if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
         break label$4
        }
        if ((HEAPU8[($1 + 176 | 0) >> 0] | 0 | 0) == (1 | 0)) {
         break label$3
        }
        HEAP8[($3 + 48 | 0) >> 0] = 1;
        cbor_event__se__Serializer_W___write_special__had0377f4ca98c84d($3 | 0, $2 | 0, $3 + 48 | 0 | 0);
        break label$2;
       }
       memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
       break label$1;
      }
      memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
      $4 = 1;
      break label$1;
     }
     memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
     break label$1;
    }
    i64toi32_i32$2 = $1 + 201 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $54 = i64toi32_i32$0;
    i64toi32_i32$0 = $3 + 72 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $54;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $1 + 193 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $59 = i64toi32_i32$1;
    i64toi32_i32$1 = $3 + 64 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $59;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $1 + 185 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $64 = i64toi32_i32$0;
    i64toi32_i32$0 = $3 + 56 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $64;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $1 + 177 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $68 = i64toi32_i32$1;
    i64toi32_i32$1 = $3;
    HEAP32[($3 + 48 | 0) >> 2] = $68;
    HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$0;
    cbor_event__se__Serializer_W___write_bytes__h85f4434ac9a8a060($3 | 0, $2 | 0, $3 + 48 | 0 | 0);
   }
   $4 = 1;
   label$7 : {
    label$8 : {
     label$9 : {
      label$10 : {
       label$11 : {
        label$12 : {
         label$13 : {
          label$14 : {
           if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
            break label$14
           }
           $cardano_serialization_lib__crypto__Vkey_20as_20cbor_event__se__Serialize___serialize__he0fe1f32129559ab($3 | 0, $1 + 209 | 0 | 0, $2 | 0);
           if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
            break label$13
           }
           i64toi32_i32$2 = $1 + 265 | 0;
           i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $87 = i64toi32_i32$0;
           i64toi32_i32$0 = $3 + 72 | 0;
           HEAP32[i64toi32_i32$0 >> 2] = $87;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
           i64toi32_i32$2 = $1 + 257 | 0;
           i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $92 = i64toi32_i32$1;
           i64toi32_i32$1 = $3 + 64 | 0;
           HEAP32[i64toi32_i32$1 >> 2] = $92;
           HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
           i64toi32_i32$2 = $1 + 249 | 0;
           i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $98 = i64toi32_i32$0;
           i64toi32_i32$0 = ($3 + 48 | 0) + 8 | 0;
           HEAP32[i64toi32_i32$0 >> 2] = $98;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
           i64toi32_i32$2 = $1;
           i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 241 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 242 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 243 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 244 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 245 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 246 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 247 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 248 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $101 = i64toi32_i32$1;
           i64toi32_i32$1 = $3;
           HEAP32[($3 + 48 | 0) >> 2] = $101;
           HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$0;
           cbor_event__se__Serializer_W___write_bytes__h85f4434ac9a8a060($3 | 0, $2 | 0, $3 + 48 | 0 | 0);
           $4 = 1;
           if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
            break label$12
           }
           $cardano_serialization_lib__crypto__VRFCert_20as_20cbor_event__se__Serialize___serialize__hc36d047369e93edb($3 | 0, $1 + 12 | 0 | 0, $2 | 0);
           if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
            break label$11
           }
           $cardano_serialization_lib__crypto__VRFCert_20as_20cbor_event__se__Serialize___serialize__hc36d047369e93edb($3 | 0, $1 + 36 | 0 | 0, $2 | 0);
           $4 = 1;
           if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
            break label$10
           }
           i64toi32_i32$2 = $1;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
           i64toi32_i32$1 = 0;
           cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, i64toi32_i32$0 | 0, i64toi32_i32$1 | 0);
           if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
            break label$9
           }
           i64toi32_i32$2 = $1 + 297 | 0;
           i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $134 = i64toi32_i32$1;
           i64toi32_i32$1 = $3 + 72 | 0;
           HEAP32[i64toi32_i32$1 >> 2] = $134;
           HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
           i64toi32_i32$2 = $1 + 289 | 0;
           i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $139 = i64toi32_i32$0;
           i64toi32_i32$0 = $3 + 64 | 0;
           HEAP32[i64toi32_i32$0 >> 2] = $139;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
           i64toi32_i32$2 = $1 + 281 | 0;
           i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $145 = i64toi32_i32$1;
           i64toi32_i32$1 = ($3 + 48 | 0) + 8 | 0;
           HEAP32[i64toi32_i32$1 >> 2] = $145;
           HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
           i64toi32_i32$2 = $1;
           i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 273 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 274 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 275 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 276 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 277 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 278 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 279 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 280 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $148 = i64toi32_i32$0;
           i64toi32_i32$0 = $3;
           HEAP32[($3 + 48 | 0) >> 2] = $148;
           HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$1;
           cbor_event__se__Serializer_W___write_bytes__h85f4434ac9a8a060($3 | 0, $2 | 0, $3 + 48 | 0 | 0);
           $4 = 1;
           if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
            break label$8
           }
           cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__SerializeEmbeddedGroup_20for_20cardano_serialization_lib__OperationalCert___serialize_as_embedded_group__he54340275d75ae4f($3 | 0, $1 + 64 | 0 | 0, $2 | 0);
           if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
            break label$7
           }
           cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__SerializeEmbeddedGroup_20for_20cardano_serialization_lib__ProtocolVersion___serialize_as_embedded_group__hf0a424996c64ec05($3 | 0, $1 + 168 | 0 | 0, $2 | 0);
           $4 = 1;
           label$15 : {
            if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
             break label$15
            }
            HEAP32[($0 + 4 | 0) >> 2] = $2;
            $4 = 0;
            break label$1;
           }
           memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
           break label$1;
          }
          memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
          break label$1;
         }
         memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
         $4 = 1;
         break label$1;
        }
        memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
        break label$1;
       }
       memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
       $4 = 1;
       break label$1;
      }
      memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
      break label$1;
     }
     memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
     $4 = 1;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $4 = 1;
  }
  HEAP32[$0 >> 2] = $4;
  global$0 = $3 + 80 | 0;
 }
 
 function cardano_serialization_lib__tx_builder__TransactionBuilder__add_output__h626cdf41f713b689($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $5 = 0, $5$hi = 0, $4 = 0, $6$hi = 0, $6 = 0, $7 = 0, $43 = 0, $50 = 0, $85 = 0, $123 = 0, $168 = 0, $175 = 0, $198 = 0, $218 = 0;
  $3 = global$0 - 160 | 0;
  global$0 = $3;
  cardano_serialization_lib__utils__Value__to_bytes__h2820e7e1b4035910($3 + 128 | 0 | 0, $2 + 64 | 0 | 0);
  $4 = HEAP32[($3 + 136 | 0) >> 2] | 0;
  HEAP32[($3 + 60 | 0) >> 2] = $4;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 128 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 128 | 0 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ($4 >>> 0 > (HEAP32[($1 + 80 | 0) >> 2] | 0) >>> 0) {
        break label$5
       }
       i64toi32_i32$2 = $2;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
       $5 = i64toi32_i32$0;
       $5$hi = i64toi32_i32$1;
       $4 = 0;
       label$6 : {
        if ((HEAP32[(i64toi32_i32$2 + 72 | 0) >> 2] | 0 | 0) != (1 | 0)) {
         break label$6
        }
        $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($3 + 80 | 0 | 4 | 0 | 0, $2 + 76 | 0 | 0);
        $4 = 1;
       }
       i64toi32_i32$2 = ($3 + 80 | 0) + 8 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $43 = i64toi32_i32$1;
       i64toi32_i32$1 = $3 + 144 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $43;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       HEAP32[($3 + 80 | 0) >> 2] = $4;
       i64toi32_i32$0 = $5$hi;
       i64toi32_i32$1 = $3;
       HEAP32[($3 + 128 | 0) >> 2] = $5;
       HEAP32[($3 + 132 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = $3;
       i64toi32_i32$0 = HEAP32[($3 + 80 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($3 + 84 | 0) >> 2] | 0;
       $50 = i64toi32_i32$0;
       i64toi32_i32$0 = $3;
       HEAP32[($3 + 136 | 0) >> 2] = $50;
       HEAP32[($3 + 140 | 0) >> 2] = i64toi32_i32$1;
       cardano_serialization_lib__utils__min_ada_required__hfea4b15a263723f5($3 + 104 | 0 | 0, $3 + 128 | 0 | 0, HEAPU8[($2 + 88 | 0) >> 0] | 0 | 0, $1 + 32 | 0 | 0);
       if ((HEAP32[($3 + 104 | 0) >> 2] | 0 | 0) == (1 | 0)) {
        break label$4
       }
       i64toi32_i32$2 = ($3 + 104 | 0) + 8 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $6 = i64toi32_i32$1;
       $6$hi = i64toi32_i32$0;
       label$7 : {
        if (!(HEAP32[($3 + 136 | 0) >> 2] | 0)) {
         break label$7
        }
        $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($3 + 140 | 0 | 0);
       }
       i64toi32_i32$2 = $2;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
       $5 = i64toi32_i32$0;
       $5$hi = i64toi32_i32$1;
       $4 = 0;
       label$8 : {
        if ((HEAP32[(i64toi32_i32$2 + 72 | 0) >> 2] | 0 | 0) != (1 | 0)) {
         break label$8
        }
        $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($3 + 80 | 0 | 4 | 0 | 0, $2 + 76 | 0 | 0);
        $4 = 1;
       }
       i64toi32_i32$2 = $3 + 88 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $85 = i64toi32_i32$1;
       i64toi32_i32$1 = $3 + 144 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $85;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       HEAP32[($3 + 80 | 0) >> 2] = $4;
       i64toi32_i32$0 = $5$hi;
       i64toi32_i32$1 = $3;
       HEAP32[($3 + 128 | 0) >> 2] = $5;
       HEAP32[($3 + 132 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = $3;
       i64toi32_i32$0 = HEAP32[($3 + 80 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($3 + 84 | 0) >> 2] | 0;
       $7 = i64toi32_i32$0;
       i64toi32_i32$0 = $3;
       HEAP32[($3 + 136 | 0) >> 2] = $7;
       HEAP32[($3 + 140 | 0) >> 2] = i64toi32_i32$1;
       label$9 : {
        if (!$7) {
         break label$9
        }
        $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($3 + 140 | 0 | 0);
       }
       i64toi32_i32$1 = $5$hi;
       i64toi32_i32$1 = $6$hi;
       i64toi32_i32$1 = $5$hi;
       i64toi32_i32$2 = $5;
       i64toi32_i32$0 = $6$hi;
       if (i64toi32_i32$1 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$2 >>> 0 < $6 >>> 0 | 0) | 0) {
        break label$3
       }
       cardano_serialization_lib__TransactionOutputs__add__h2527e8fddfba1826($1 + 416 | 0 | 0, $2 | 0);
       $2 = 0;
       break label$1;
      }
      core__fmt__ArgumentV1__new__hfe8bfc123be7fc32($3 + 24 | 0 | 0, $1 + 80 | 0 | 0, 46 | 0);
      i64toi32_i32$2 = HEAP32[($3 + 24 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($3 + 28 | 0) >> 2] | 0;
      $5 = i64toi32_i32$2;
      $5$hi = i64toi32_i32$1;
      core__fmt__ArgumentV1__new__h5702524f4c8ddc75($3 + 16 | 0 | 0, $3 + 60 | 0 | 0, 46 | 0);
      HEAP32[($3 + 148 | 0) >> 2] = 2;
      i64toi32_i32$2 = $3;
      HEAP32[($3 + 80 | 0) >> 2] = $5;
      HEAP32[($3 + 84 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $3;
      i64toi32_i32$1 = 0;
      HEAP32[($3 + 132 | 0) >> 2] = 2;
      HEAP32[($3 + 136 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($3 + 128 | 0) >> 2] = 1065112;
      i64toi32_i32$1 = HEAP32[($3 + 16 | 0) >> 2] | 0;
      i64toi32_i32$2 = HEAP32[($3 + 20 | 0) >> 2] | 0;
      $123 = i64toi32_i32$1;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 88 | 0) >> 2] = $123;
      HEAP32[($3 + 92 | 0) >> 2] = i64toi32_i32$2;
      HEAP32[($3 + 144 | 0) >> 2] = $3 + 80 | 0;
      alloc__fmt__format__h6e9e003a52c07309($3 + 104 | 0 | 0, $3 + 128 | 0 | 0);
      $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $3 + 104 | 0 | 0);
      $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($3 + 8 | 0) >> 2] | 0 | 0, HEAP32[($3 + 12 | 0) >> 2] | 0 | 0) | 0;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 104 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 104 | 0 | 0);
      break label$2;
     }
     $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($3 + 108 | 0) >> 2] | 0 | 0) | 0;
     if (!(HEAP32[($3 + 136 | 0) >> 2] | 0)) {
      break label$2
     }
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($3 + 140 | 0 | 0);
     break label$2;
    }
    i64toi32_i32$2 = HEAP32[($2 + 64 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 68 | 0) >> 2] | 0;
    $5 = i64toi32_i32$2;
    $5$hi = i64toi32_i32$1;
    $1 = 0;
    label$10 : {
     if ((HEAP32[($2 + 72 | 0) >> 2] | 0 | 0) != (1 | 0)) {
      break label$10
     }
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($3 + 80 | 0 | 4 | 0 | 0, $2 + 76 | 0 | 0);
     $1 = 1;
    }
    $2 = ($3 + 80 | 0) + 8 | 0;
    i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($2 + 4 | 0) >> 2] | 0;
    $168 = i64toi32_i32$1;
    i64toi32_i32$1 = $3 + 144 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $168;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
    HEAP32[($3 + 80 | 0) >> 2] = $1;
    i64toi32_i32$2 = $5$hi;
    i64toi32_i32$1 = $3;
    HEAP32[($3 + 128 | 0) >> 2] = $5;
    HEAP32[($3 + 132 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = HEAP32[($3 + 80 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($3 + 84 | 0) >> 2] | 0;
    $175 = i64toi32_i32$2;
    i64toi32_i32$2 = $3;
    HEAP32[($3 + 136 | 0) >> 2] = $175;
    HEAP32[($3 + 140 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $5$hi;
    i64toi32_i32$2 = $3;
    HEAP32[($3 + 120 | 0) >> 2] = $5;
    HEAP32[($3 + 124 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $6$hi;
    i64toi32_i32$2 = $3;
    HEAP32[($3 + 152 | 0) >> 2] = $6;
    HEAP32[($3 + 156 | 0) >> 2] = i64toi32_i32$1;
    core__fmt__ArgumentV1__new__h021aa801e74cb4b6($3 + 48 | 0 | 0, $3 + 120 | 0 | 0, 20 | 0);
    i64toi32_i32$1 = HEAP32[($3 + 48 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($3 + 52 | 0) >> 2] | 0;
    $5 = i64toi32_i32$1;
    $5$hi = i64toi32_i32$2;
    core__fmt__ArgumentV1__new__h021aa801e74cb4b6($3 + 40 | 0 | 0, $3 + 152 | 0 | 0, 20 | 0);
    HEAP32[($3 + 100 | 0) >> 2] = 2;
    i64toi32_i32$1 = $3;
    HEAP32[($3 + 104 | 0) >> 2] = $5;
    HEAP32[($3 + 108 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$1 = $3;
    i64toi32_i32$2 = 0;
    HEAP32[($3 + 84 | 0) >> 2] = 2;
    HEAP32[($3 + 88 | 0) >> 2] = i64toi32_i32$2;
    HEAP32[($3 + 80 | 0) >> 2] = 1065168;
    i64toi32_i32$2 = HEAP32[($3 + 40 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($3 + 44 | 0) >> 2] | 0;
    $198 = i64toi32_i32$2;
    i64toi32_i32$2 = $3;
    HEAP32[($3 + 112 | 0) >> 2] = $198;
    HEAP32[($3 + 116 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($3 + 96 | 0) >> 2] = $3 + 104 | 0;
    alloc__fmt__format__h6e9e003a52c07309($3 + 64 | 0 | 0, $3 + 80 | 0 | 0);
    label$11 : {
     if (!(HEAP32[($3 + 136 | 0) >> 2] | 0)) {
      break label$11
     }
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($3 + 140 | 0 | 0);
    }
    HEAP32[$2 >> 2] = HEAP32[(($3 + 64 | 0) + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($3 + 64 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($3 + 68 | 0) >> 2] | 0;
    $218 = i64toi32_i32$1;
    i64toi32_i32$1 = $3;
    HEAP32[($3 + 80 | 0) >> 2] = $218;
    HEAP32[($3 + 84 | 0) >> 2] = i64toi32_i32$2;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 32 | 0 | 0, $3 + 80 | 0 | 0);
    $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($3 + 32 | 0) >> 2] | 0 | 0, HEAP32[($3 + 36 | 0) >> 2] | 0 | 0) | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 80 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 80 | 0 | 0);
   }
   $2 = 1;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[$0 >> 2] = $2;
  global$0 = $3 + 160 | 0;
 }
 
 function cardano_serialization_lib__legacy_address__base58__encode__h4779b5c745dedf73($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, $7 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $9 = 0, $8 = 0, $6 = 0, $10 = 0, $5 = 0, $69 = 0, $225 = 0, $231 = 0, $11 = 0, $11$hi = 0, $248 = 0;
  $3 = global$0 - 96 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    $4 = __rust_alloc(1 | 0, 1 | 0) | 0;
    if (!$4) {
     break label$2
    }
    HEAP8[$4 >> 0] = 0;
    alloc__slice__hack__into_vec__h7c95d082cf6730ee($3 + 72 | 0 | 0, $4 | 0, 1 | 0);
    label$3 : {
     if (!$2) {
      break label$3
     }
     $5 = $1 + $2 | 0;
     $4 = $1 + 1 | 0;
     $6 = $1;
     label$4 : while (1) {
      $7 = $6;
      $6 = $4;
      $4 = HEAPU8[$7 >> 0] | 0;
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          $8 = HEAP32[($3 + 80 | 0) >> 2] | 0;
          if (!$8) {
           break label$8
          }
          $7 = 0;
          label$9 : while (1) {
           $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 32 | 0 | 0, $3 + 72 | 0 | 0);
           $9 = HEAP32[($3 + 36 | 0) >> 2] | 0;
           if ($9 >>> 0 <= $7 >>> 0) {
            break label$7
           }
           $9 = HEAPU8[((HEAP32[($3 + 32 | 0) >> 2] | 0) + $7 | 0) >> 0] | 0;
           $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__DerefMut___deref_mut__h1882e042320a120c($3 + 24 | 0 | 0, $3 + 72 | 0 | 0);
           $10 = HEAP32[($3 + 28 | 0) >> 2] | 0;
           if ($10 >>> 0 <= $7 >>> 0) {
            break label$6
           }
           $4 = ($9 << 8 | 0) + $4 | 0;
           $69 = $4;
           $4 = ($4 >>> 0) / (58 >>> 0) | 0;
           HEAP8[((HEAP32[($3 + 24 | 0) >> 2] | 0) + $7 | 0) >> 0] = $69 - Math_imul($4, 58) | 0;
           $9 = $7 + 1 | 0;
           $7 = $9;
           if (($8 | 0) != ($7 | 0)) {
            continue label$9
           }
           break label$9;
          };
         }
         if (!$4) {
          break label$5
         }
         $7 = HEAP32[($3 + 80 | 0) >> 2] | 0;
         label$10 : while (1) {
          $9 = ($4 >>> 0) / (58 >>> 0) | 0;
          $8 = $4 - Math_imul($9, 58) | 0;
          label$11 : {
           if (($7 | 0) != (HEAP32[($3 + 76 | 0) >> 2] | 0 | 0)) {
            break label$11
           }
           alloc__vec__Vec_T_2cA___reserve__h9cf757d86af8f187($3 + 72 | 0 | 0, 1 | 0);
           $7 = HEAP32[($3 + 80 | 0) >> 2] | 0;
          }
          HEAP8[((HEAP32[($3 + 72 | 0) >> 2] | 0) + $7 | 0) >> 0] = $8;
          $7 = (HEAP32[($3 + 80 | 0) >> 2] | 0) + 1 | 0;
          HEAP32[($3 + 80 | 0) >> 2] = $7;
          $8 = $4 >>> 0 < 58 >>> 0;
          $4 = $9;
          if ($8) {
           break label$5
          }
          continue label$10;
         };
        }
        core__panicking__panic_bounds_check__h808b524af17640b1($7 | 0, $9 | 0, 1070228 | 0);
        abort();
       }
       core__panicking__panic_bounds_check__h808b524af17640b1($7 | 0, $10 | 0, 1070244 | 0);
       abort();
      }
      $4 = $6 + 1 | 0;
      if (($6 | 0) != ($5 | 0)) {
       continue label$4
      }
      break label$4;
     };
    }
    i64toi32_i32$1 = $3;
    i64toi32_i32$0 = 0;
    HEAP32[($3 + 60 | 0) >> 2] = 0;
    HEAP32[($3 + 64 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($3 + 56 | 0) >> 2] = HEAP32[(0 + 1070048 | 0) >> 2] | 0;
    if (!$2) {
     break label$1
    }
    $4 = 0;
    label$12 : while (1) {
     if (HEAPU8[$1 >> 0] | 0) {
      break label$1
     }
     label$13 : {
      if (($4 | 0) != (HEAP32[($3 + 60 | 0) >> 2] | 0 | 0)) {
       break label$13
      }
      alloc__vec__Vec_T_2cA___reserve__h9cf757d86af8f187($3 + 56 | 0 | 0, 1 | 0);
      $4 = HEAP32[($3 + 64 | 0) >> 2] | 0;
     }
     HEAP8[((HEAP32[($3 + 56 | 0) >> 2] | 0) + $4 | 0) >> 0] = 49;
     $4 = (HEAP32[($3 + 64 | 0) >> 2] | 0) + 1 | 0;
     HEAP32[($3 + 64 | 0) >> 2] = $4;
     $1 = $1 + 1 | 0;
     $2 = $2 + -1 | 0;
     if ($2) {
      continue label$12
     }
     break label$1;
    };
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(1 | 0, 1 | 0);
   abort();
  }
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 16 | 0 | 0, $3 + 72 | 0 | 0);
  $4 = HEAP32[($3 + 16 | 0) >> 2] | 0;
  core__iter__adapters__rev__Rev_T___new__h8896c06445f3ae2d($3 + 8 | 0 | 0, $4 | 0, $4 + (HEAP32[($3 + 20 | 0) >> 2] | 0) | 0 | 0);
  label$14 : {
   label$15 : {
    label$16 : {
     $8 = HEAP32[($3 + 8 | 0) >> 2] | 0;
     $4 = HEAP32[($3 + 12 | 0) >> 2] | 0;
     if (($8 | 0) == ($4 | 0)) {
      break label$16
     }
     label$17 : while (1) {
      $4 = $4 + -1 | 0;
      $7 = HEAPU8[$4 >> 0] | 0;
      if ($7 >>> 0 > 57 >>> 0) {
       break label$15
      }
      $9 = HEAPU8[($7 + 1070125 | 0) >> 0] | 0;
      label$18 : {
       $7 = HEAP32[($3 + 64 | 0) >> 2] | 0;
       if (($7 | 0) != (HEAP32[($3 + 60 | 0) >> 2] | 0 | 0)) {
        break label$18
       }
       alloc__vec__Vec_T_2cA___reserve__h9cf757d86af8f187($3 + 56 | 0 | 0, 1 | 0);
       $7 = HEAP32[($3 + 64 | 0) >> 2] | 0;
      }
      HEAP8[((HEAP32[($3 + 56 | 0) >> 2] | 0) + $7 | 0) >> 0] = $9;
      HEAP32[($3 + 64 | 0) >> 2] = (HEAP32[($3 + 64 | 0) >> 2] | 0) + 1 | 0;
      if (($8 | 0) != ($4 | 0)) {
       continue label$17
      }
      break label$17;
     };
    }
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 72 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 72 | 0 | 0);
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 | 0, $3 + 56 | 0 | 0);
    core__str__converts__from_utf8__h4bd16e554326fb60($3 + 72 | 0 | 0, HEAP32[$3 >> 2] | 0 | 0, HEAP32[($3 + 4 | 0) >> 2] | 0 | 0);
    $4 = ($3 + 40 | 0) + 8 | 0;
    HEAP32[$4 >> 2] = HEAP32[(($3 + 56 | 0) + 8 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($3 + 56 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($3 + 60 | 0) >> 2] | 0;
    $225 = i64toi32_i32$0;
    i64toi32_i32$0 = $3;
    HEAP32[($3 + 40 | 0) >> 2] = $225;
    HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$1;
    if ((HEAP32[($3 + 72 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$14
    }
    i64toi32_i32$1 = HEAP32[($3 + 40 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($3 + 44 | 0) >> 2] | 0;
    $231 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[i64toi32_i32$1 >> 2] = $231;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[$4 >> 2] | 0;
    global$0 = $3 + 96 | 0;
    return;
   }
   core__panicking__panic_bounds_check__h808b524af17640b1($7 | 0, 58 | 0, 1070260 | 0);
   abort();
  }
  i64toi32_i32$0 = HEAP32[($3 + 76 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($3 + 80 | 0) >> 2] | 0;
  $11 = i64toi32_i32$0;
  $11$hi = i64toi32_i32$1;
  HEAP32[(($3 + 72 | 0) + 8 | 0) >> 2] = HEAP32[$4 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($3 + 40 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($3 + 44 | 0) >> 2] | 0;
  $248 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[($3 + 72 | 0) >> 2] = $248;
  HEAP32[($3 + 76 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$1 = $3;
  HEAP32[($3 + 84 | 0) >> 2] = $11;
  HEAP32[($3 + 88 | 0) >> 2] = i64toi32_i32$0;
  core__result__unwrap_failed__h27f43d993c3864a1(1069956 | 0, 43 | 0, $3 + 72 | 0 | 0, 1070016 | 0, 1070212 | 0);
  abort();
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__PoolRegistration___deserialize__h3eddb2951658b6f3($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, $6 = 0, $6$hi = 0, $7 = 0, $3 = 0, $7$hi = 0, $37 = 0, $38 = 0, $39 = 0, $40 = 0, $41 = 0, $42 = 0, $43 = 0, $45 = 0, $46 = 0, $47 = 0, $4 = 0, $5 = 0, $48 = 0, $49 = 0, $50 = 0, $44 = 0, $52 = 0, $65 = 0, $108 = 0, $115 = 0, $119 = 0, $155 = 0, $155$hi = 0, $158 = 0, $158$hi = 0, $162$hi = 0, $164$hi = 0, $166$hi = 0, $169 = 0, $169$hi = 0, $181 = 0, $187 = 0, $191 = 0, $207 = 0, $211 = 0, $217 = 0, $223 = 0;
  $2 = global$0 - 400 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 176 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 184 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 188 | 0) >> 2] | 0;
  $6 = i64toi32_i32$0;
  $6$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 176 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 180 | 0) >> 2] | 0;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 1;
      if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
       break label$4
      }
      i64toi32_i32$2 = $6$hi;
      i64toi32_i32$0 = i64toi32_i32$2;
      cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__PoolRegistration___deserialize_as_embedded_group__h417fb115ca31b437($2 + 176 | 0 | 0, $1 | 0, $6 | 0, i64toi32_i32$2 | 0, $6 | 0, i64toi32_i32$2 | 0);
      label$5 : {
       label$6 : {
        label$7 : {
         i64toi32_i32$0 = i64toi32_i32$2;
         i64toi32_i32$0 = i64toi32_i32$2;
         i64toi32_i32$3 = $6;
         i64toi32_i32$2 = 0;
         i64toi32_i32$1 = 1;
         if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) | 0) {
          break label$7
         }
         cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 8 | 0 | 0, $1 | 0);
         $3 = HEAPU8[($2 + 16 | 0) >> 0] | 0;
         i64toi32_i32$1 = $2;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] | 0;
         i64toi32_i32$1 = i64toi32_i32$3;
         i64toi32_i32$3 = 0;
         i64toi32_i32$2 = 1;
         if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) | 0) {
          break label$6
         }
         $1 = 5;
         if (($3 & 255 | 0 | 0) != (5 | 0)) {
          break label$5
         }
        }
        $4 = $2 + 160 | 0;
        i64toi32_i32$2 = ($2 + 176 | 0) + 40 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $44 = i64toi32_i32$1;
        i64toi32_i32$1 = $4;
        HEAP32[i64toi32_i32$1 >> 2] = $44;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        $5 = ($2 + 152 | 0) + 16 | 0;
        i64toi32_i32$2 = ($2 + 176 | 0) + 48 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $52 = i64toi32_i32$0;
        i64toi32_i32$0 = $5;
        HEAP32[i64toi32_i32$0 >> 2] = $52;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        HEAP32[($2 + 376 | 0) >> 2] = HEAPU8[($2 + 185 | 0) >> 0] | 0 | ((HEAPU8[($2 + 186 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 187 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 188 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $37 = ($2 + 176 | 0) + 12 | 0;
        $38 = HEAPU8[$37 >> 0] | 0 | ((HEAPU8[($37 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($37 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($37 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[($2 + 379 | 0) >> 0] = $38;
        HEAP8[($2 + 380 | 0) >> 0] = $38 >>> 8 | 0;
        HEAP8[($2 + 381 | 0) >> 0] = $38 >>> 16 | 0;
        HEAP8[($2 + 382 | 0) >> 0] = $38 >>> 24 | 0;
        i64toi32_i32$2 = ($2 + 176 | 0) + 32 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $65 = i64toi32_i32$1;
        i64toi32_i32$1 = $2;
        HEAP32[(i64toi32_i32$1 + 152 | 0) >> 2] = $65;
        HEAP32[(i64toi32_i32$1 + 156 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = (i64toi32_i32$1 + 176 | 0) + 16 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $6 = i64toi32_i32$0;
        $6$hi = i64toi32_i32$1;
        i64toi32_i32$2 = ($2 + 176 | 0) + 24 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $7 = i64toi32_i32$1;
        $7$hi = i64toi32_i32$0;
        $3 = HEAP32[(($2 + 176 | 0) + 56 | 0) >> 2] | 0;
        $1 = HEAPU8[($2 + 184 | 0) >> 0] | 0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 176 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 180 | 0) >> 2] | 0;
        memcpy(i64toi32_i32$2 + 8 | 0 | 0, (i64toi32_i32$2 + 176 | 0) + 60 | 0 | 0, 140 | 0) | 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
         break label$2
        }
        HEAP8[($0 + 8 | 0) >> 0] = $1;
        $39 = HEAP32[($2 + 376 | 0) >> 2] | 0;
        HEAP8[($0 + 9 | 0) >> 0] = $39;
        HEAP8[($0 + 10 | 0) >> 0] = $39 >>> 8 | 0;
        HEAP8[($0 + 11 | 0) >> 0] = $39 >>> 16 | 0;
        HEAP8[($0 + 12 | 0) >> 0] = $39 >>> 24 | 0;
        $40 = $0 + 12 | 0;
        $41 = HEAPU8[($2 + 379 | 0) >> 0] | 0 | ((HEAPU8[($2 + 380 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 381 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 382 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[$40 >> 0] = $41;
        HEAP8[($40 + 1 | 0) >> 0] = $41 >>> 8 | 0;
        HEAP8[($40 + 2 | 0) >> 0] = $41 >>> 16 | 0;
        HEAP8[($40 + 3 | 0) >> 0] = $41 >>> 24 | 0;
        i64toi32_i32$2 = $7$hi;
        i64toi32_i32$1 = $0 + 24 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $7;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
        i64toi32_i32$2 = $6$hi;
        i64toi32_i32$1 = $0 + 16 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $6;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
        i64toi32_i32$3 = $2;
        i64toi32_i32$2 = HEAP32[($2 + 152 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 156 | 0) >> 2] | 0;
        $108 = i64toi32_i32$2;
        i64toi32_i32$2 = $0 + 32 | 0;
        $42 = $108;
        HEAP8[i64toi32_i32$2 >> 0] = $42;
        HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $42 >>> 8 | 0;
        HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $42 >>> 16 | 0;
        HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $42 >>> 24 | 0;
        HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$1;
        HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
        HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
        HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
        HEAP32[($0 + 56 | 0) >> 2] = $3;
        i64toi32_i32$3 = $4;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $115 = i64toi32_i32$1;
        i64toi32_i32$1 = $0 + 40 | 0;
        $43 = $115;
        HEAP8[i64toi32_i32$1 >> 0] = $43;
        HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $43 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $43 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $43 >>> 24 | 0;
        HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$2;
        HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
        i64toi32_i32$3 = $5;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $119 = i64toi32_i32$2;
        i64toi32_i32$2 = $0 + 48 | 0;
        $45 = $119;
        HEAP8[i64toi32_i32$2 >> 0] = $45;
        HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $45 >>> 8 | 0;
        HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $45 >>> 16 | 0;
        HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $45 >>> 24 | 0;
        HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$1;
        HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
        HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
        HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
        memcpy($0 + 60 | 0 | 0, $2 + 8 | 0 | 0, 140 | 0) | 0;
        i64toi32_i32$1 = 0;
        $6 = 0;
        $6$hi = i64toi32_i32$1;
        break label$1;
       }
       i64toi32_i32$3 = $2 + 40 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $6 = i64toi32_i32$1;
       $6$hi = i64toi32_i32$2;
       i64toi32_i32$1 = ($2 + 376 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $6;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$3 = $2 + 48 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $7 = i64toi32_i32$2;
       $7$hi = i64toi32_i32$1;
       i64toi32_i32$2 = ($2 + 376 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $7;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$1 = $6$hi;
       i64toi32_i32$2 = ($2 + 152 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $6;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$1 = $7$hi;
       i64toi32_i32$2 = ($2 + 152 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $7;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$3 = $2 + 32 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $6 = i64toi32_i32$1;
       $6$hi = i64toi32_i32$2;
       i64toi32_i32$1 = $2;
       HEAP32[(i64toi32_i32$1 + 376 | 0) >> 2] = $6;
       HEAP32[(i64toi32_i32$1 + 380 | 0) >> 2] = i64toi32_i32$2;
       HEAP32[(i64toi32_i32$1 + 152 | 0) >> 2] = $6;
       HEAP32[(i64toi32_i32$1 + 156 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$3 = i64toi32_i32$1;
       i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 17 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 18 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 19 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 20 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = 0;
       $155 = i64toi32_i32$2;
       $155$hi = i64toi32_i32$1;
       i64toi32_i32$3 = $2 + 21 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
       i64toi32_i32$2 = 0;
       $158 = i64toi32_i32$1;
       $158$hi = i64toi32_i32$2;
       i64toi32_i32$3 = $2 + 23 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$3 >> 0] | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = i64toi32_i32$2;
       i64toi32_i32$2 = 0;
       i64toi32_i32$0 = 16;
       i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
        $48 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $48 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
       }
       $162$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $158$hi;
       i64toi32_i32$1 = $158;
       i64toi32_i32$3 = $162$hi;
       i64toi32_i32$0 = $48;
       i64toi32_i32$3 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$0 = 32;
       i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $49 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$4 | 0) | 0;
        $49 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       $164$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $155$hi;
       i64toi32_i32$3 = $155;
       i64toi32_i32$2 = $164$hi;
       i64toi32_i32$0 = $49;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
       i64toi32_i32$1 = i64toi32_i32$3 | i64toi32_i32$0 | 0;
       i64toi32_i32$3 = 0;
       i64toi32_i32$0 = 8;
       i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
        i64toi32_i32$3 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        $50 = 0;
       } else {
        i64toi32_i32$3 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
        $50 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       }
       $166$hi = i64toi32_i32$3;
       i64toi32_i32$3 = 0;
       i64toi32_i32$2 = $3;
       i64toi32_i32$1 = 0;
       i64toi32_i32$0 = 255;
       i64toi32_i32$1 = i64toi32_i32$3 & i64toi32_i32$1 | 0;
       $169 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
       $169$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $166$hi;
       i64toi32_i32$3 = $50;
       i64toi32_i32$2 = $169$hi;
       i64toi32_i32$0 = $169;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
       $6 = i64toi32_i32$3 | i64toi32_i32$0 | 0;
       $6$hi = i64toi32_i32$2;
       i64toi32_i32$1 = ($2 + 8 | 0) + 16 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $7 = i64toi32_i32$2;
       $7$hi = i64toi32_i32$3;
       $1 = 2;
      }
      core__ptr__drop_in_place_core__result__Result_cardano_serialization_lib__PoolRegistration_2ccardano_serialization_lib__error__DeserializeError____hd0bde1a1981b77c0($2 + 176 | 0 | 0);
      break label$3;
     }
     i64toi32_i32$1 = $2 + 208 | 0;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $181 = i64toi32_i32$3;
     i64toi32_i32$3 = $2 + 160 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $181;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$1 = $2 + 216 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $187 = i64toi32_i32$2;
     i64toi32_i32$2 = ($2 + 152 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $187;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$1 = $2 + 200 | 0;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $191 = i64toi32_i32$3;
     i64toi32_i32$3 = $2;
     HEAP32[($2 + 152 | 0) >> 2] = $191;
     HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$1 = ($2 + 176 | 0) + 16 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $7 = i64toi32_i32$2;
     $7$hi = i64toi32_i32$3;
     $1 = 2;
    }
    $3 = 0;
   }
   i64toi32_i32$3 = $7$hi;
   i64toi32_i32$2 = ($2 + 176 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $7;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$3 = $6$hi;
   i64toi32_i32$2 = ($2 + 176 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $6;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$1 = $2;
   i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 152 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 156 | 0) >> 2] | 0;
   $207 = i64toi32_i32$3;
   i64toi32_i32$3 = i64toi32_i32$1 + 200 | 0;
   HEAP32[i64toi32_i32$3 >> 2] = $207;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] | 0;
   i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] | 0;
   $211 = i64toi32_i32$2;
   i64toi32_i32$2 = i64toi32_i32$1 + 228 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $211;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$1 = (i64toi32_i32$1 + 152 | 0) + 8 | 0;
   i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $217 = i64toi32_i32$3;
   i64toi32_i32$3 = $2 + 208 | 0;
   HEAP32[i64toi32_i32$3 >> 2] = $217;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$1 = ($2 + 152 | 0) + 16 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $223 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 216 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $223;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
   HEAP32[($2 + 236 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
   HEAP8[($2 + 176 | 0) >> 0] = $1;
   $46 = HEAP32[($2 + 376 | 0) >> 2] | 0;
   HEAP8[($2 + 177 | 0) >> 0] = $46;
   HEAP8[($2 + 178 | 0) >> 0] = $46 >>> 8 | 0;
   HEAP8[($2 + 179 | 0) >> 0] = $46 >>> 16 | 0;
   HEAP8[($2 + 180 | 0) >> 0] = $46 >>> 24 | 0;
   $47 = HEAPU8[($2 + 379 | 0) >> 0] | 0 | ((HEAPU8[($2 + 380 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 381 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 382 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[($2 + 180 | 0) >> 0] = $47;
   HEAP8[($2 + 181 | 0) >> 0] = $47 >>> 8 | 0;
   HEAP8[($2 + 182 | 0) >> 0] = $47 >>> 16 | 0;
   HEAP8[($2 + 183 | 0) >> 0] = $47 >>> 24 | 0;
   HEAP32[($2 + 224 | 0) >> 2] = $3;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 176 | 0 | 0, 1050979 | 0, 16 | 0);
   i64toi32_i32$3 = 0;
   $6 = 1;
   $6$hi = i64toi32_i32$3;
  }
  i64toi32_i32$3 = $6$hi;
  i64toi32_i32$2 = $0;
  HEAP32[i64toi32_i32$2 >> 2] = $6;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
  global$0 = $2 + 400 | 0;
 }
 
 function hashbrown__raw__RawTable_T_2cA___rehash_in_place__hf0998e6c04e02483($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $10 = 0, $7 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $9 = 0, $5 = 0, $8 = 0, $3 = 0, $6 = 0, $12 = 0, $2 = 0, $4 = 0, $13 = 0, $30 = 0, $31 = 0, $32 = 0, $33 = 0, $34 = 0, $35 = 0, $36 = 0, $37 = 0, $38 = 0, $39 = 0, $40 = 0, $41 = 0, $42 = 0, $43 = 0, $44 = 0, $45 = 0, $46 = 0, $11 = 0, $14 = 0, $14$hi = 0, $179 = 0, $15 = 0, $15$hi = 0, $197 = 0, $16 = 0, $16$hi = 0, $206 = 0, $238 = 0, $243 = 0, $246 = 0, $268 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  $3 = HEAP32[$0 >> 2] | 0;
  $4 = $3 + 1 | 0;
  core__iter__adapters__step_by__StepBy_I___new__h21a520baea7dc9f1($2 | 0, 0 | 0, $4 | 0, 4 | 0);
  $5 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  $6 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $7 = HEAP32[$2 >> 2] | 0;
  $8 = !(HEAPU8[($2 + 12 | 0) >> 0] | 0);
  $9 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  label$1 : while (1) {
   label$2 : {
    label$3 : {
     label$4 : {
      if (!($8 & 1 | 0)) {
       break label$4
      }
      $10 = $7 + ($T_20as_20core__convert__From_T____from__h09bdeba94dd58819($5 | 0) | 0) | 0;
      if ($10 >>> 0 < $7 >>> 0) {
       break label$3
      }
      if ($10 >>> 0 >= $6 >>> 0) {
       break label$3
      }
      break label$2;
     }
     $10 = $7;
     if ($10 >>> 0 < $6 >>> 0) {
      break label$2
     }
    }
    label$5 : {
     label$6 : {
      label$7 : {
       if ($4 >>> 0 < 4 >>> 0) {
        break label$7
       }
       $30 = $9 + $4 | 0;
       $31 = HEAPU8[$9 >> 0] | 0 | ((HEAPU8[($9 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($9 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($9 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       HEAP8[$30 >> 0] = $31;
       HEAP8[($30 + 1 | 0) >> 0] = $31 >>> 8 | 0;
       HEAP8[($30 + 2 | 0) >> 0] = $31 >>> 16 | 0;
       HEAP8[($30 + 3 | 0) >> 0] = $31 >>> 24 | 0;
       break label$6;
      }
      memmove($9 + 4 | 0 | 0, $9 | 0, $4 | 0) | 0;
      if (!$4) {
       break label$5
      }
     }
     $10 = 0;
     label$8 : while (1) {
      label$9 : {
       $6 = $10;
       $11 = $9 + $10 | 0;
       if ((HEAPU8[$11 >> 0] | 0 | 0) != (128 | 0)) {
        break label$9
       }
       $12 = ($9 + Math_imul(0 - $6 | 0, 28) | 0) + -28 | 0;
       label$10 : while (1) {
        i64toi32_i32$0 = hashbrown__map__make_hash__h3827262269fc5d43($1 | 0, $12 | 0) | 0;
        i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
        $13 = i64toi32_i32$0;
        $5 = $3 & i64toi32_i32$0 | 0;
        $7 = $5;
        label$11 : {
         $32 = $9 + $7 | 0;
         $8 = (HEAPU8[$32 >> 0] | 0 | ((HEAPU8[($32 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($32 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($32 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
         if ($8) {
          break label$11
         }
         $10 = 4;
         $7 = $5;
         label$12 : while (1) {
          $7 = $7 + $10 | 0;
          $10 = $10 + 4 | 0;
          $7 = $7 & $3 | 0;
          $33 = $9 + $7 | 0;
          $8 = (HEAPU8[$33 >> 0] | 0 | ((HEAPU8[($33 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($33 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($33 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
          if (!$8) {
           continue label$12
          }
          break label$12;
         };
        }
        label$13 : {
         $10 = (((__wasm_ctz_i32($8 | 0) | 0) >>> 3 | 0) + $7 | 0) & $3 | 0;
         if ((HEAP8[($9 + $10 | 0) >> 0] | 0 | 0) <= (-1 | 0)) {
          break label$13
         }
         $10 = (__wasm_ctz_i32((HEAP32[$9 >> 2] | 0) & -2139062144 | 0 | 0) | 0) >>> 3 | 0;
        }
        label$14 : {
         if (((($10 - $5 | 0) ^ ($6 - $5 | 0) | 0) & $3 | 0) >>> 0 >= 4 >>> 0) {
          break label$14
         }
         $10 = $13 >>> 25 | 0;
         HEAP8[$11 >> 0] = $10;
         HEAP8[(((($6 + -4 | 0) & $3 | 0) + $9 | 0) + 4 | 0) >> 0] = $10;
         break label$9;
        }
        $7 = $9 + $10 | 0;
        $8 = HEAPU8[$7 >> 0] | 0;
        $5 = $13 >>> 25 | 0;
        HEAP8[$7 >> 0] = $5;
        HEAP8[(((($10 + -4 | 0) & $3 | 0) + $9 | 0) + 4 | 0) >> 0] = $5;
        label$15 : {
         if (($8 | 0) == (255 | 0)) {
          break label$15
         }
         $10 = ($9 + Math_imul(0 - $10 | 0, 28) | 0) + -28 | 0;
         i64toi32_i32$2 = $10;
         i64toi32_i32$1 = HEAPU8[$10 >> 0] | 0 | ((HEAPU8[($10 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($10 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($10 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$0 = HEAPU8[($10 + 4 | 0) >> 0] | 0 | ((HEAPU8[($10 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($10 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($10 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $14 = i64toi32_i32$1;
         $14$hi = i64toi32_i32$0;
         i64toi32_i32$2 = $12;
         i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $179 = i64toi32_i32$0;
         i64toi32_i32$0 = $10;
         $34 = $179;
         HEAP8[$10 >> 0] = $34;
         HEAP8[($10 + 1 | 0) >> 0] = $34 >>> 8 | 0;
         HEAP8[($10 + 2 | 0) >> 0] = $34 >>> 16 | 0;
         HEAP8[($10 + 3 | 0) >> 0] = $34 >>> 24 | 0;
         HEAP8[($10 + 4 | 0) >> 0] = i64toi32_i32$1;
         HEAP8[($10 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
         HEAP8[($10 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
         HEAP8[($10 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
         $7 = $10 + 24 | 0;
         $8 = HEAPU8[$7 >> 0] | 0 | ((HEAPU8[($7 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($7 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($7 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $5 = i64toi32_i32$2 + 24 | 0;
         $35 = HEAPU8[$5 >> 0] | 0 | ((HEAPU8[($5 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($5 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($5 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[$7 >> 0] = $35;
         HEAP8[($7 + 1 | 0) >> 0] = $35 >>> 8 | 0;
         HEAP8[($7 + 2 | 0) >> 0] = $35 >>> 16 | 0;
         HEAP8[($7 + 3 | 0) >> 0] = $35 >>> 24 | 0;
         $7 = $10 + 16 | 0;
         i64toi32_i32$2 = $7;
         i64toi32_i32$1 = HEAPU8[$7 >> 0] | 0 | ((HEAPU8[($7 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($7 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($7 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$0 = HEAPU8[($7 + 4 | 0) >> 0] | 0 | ((HEAPU8[($7 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($7 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($7 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $15 = i64toi32_i32$1;
         $15$hi = i64toi32_i32$0;
         $13 = $12 + 16 | 0;
         i64toi32_i32$2 = $13;
         i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $197 = i64toi32_i32$0;
         i64toi32_i32$0 = $7;
         $36 = $197;
         HEAP8[$7 >> 0] = $36;
         HEAP8[($7 + 1 | 0) >> 0] = $36 >>> 8 | 0;
         HEAP8[($7 + 2 | 0) >> 0] = $36 >>> 16 | 0;
         HEAP8[($7 + 3 | 0) >> 0] = $36 >>> 24 | 0;
         HEAP8[($7 + 4 | 0) >> 0] = i64toi32_i32$1;
         HEAP8[($7 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
         HEAP8[($7 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
         HEAP8[($7 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
         $10 = $10 + 8 | 0;
         i64toi32_i32$2 = $10;
         i64toi32_i32$1 = HEAPU8[$10 >> 0] | 0 | ((HEAPU8[($10 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($10 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($10 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$0 = HEAPU8[($10 + 4 | 0) >> 0] | 0 | ((HEAPU8[($10 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($10 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($10 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $16 = i64toi32_i32$1;
         $16$hi = i64toi32_i32$0;
         $7 = $12 + 8 | 0;
         i64toi32_i32$2 = $7;
         i64toi32_i32$0 = HEAPU8[$7 >> 0] | 0 | ((HEAPU8[($7 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($7 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($7 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$1 = HEAPU8[($7 + 4 | 0) >> 0] | 0 | ((HEAPU8[($7 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($7 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($7 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $206 = i64toi32_i32$0;
         i64toi32_i32$0 = $10;
         $37 = $206;
         HEAP8[$10 >> 0] = $37;
         HEAP8[($10 + 1 | 0) >> 0] = $37 >>> 8 | 0;
         HEAP8[($10 + 2 | 0) >> 0] = $37 >>> 16 | 0;
         HEAP8[($10 + 3 | 0) >> 0] = $37 >>> 24 | 0;
         HEAP8[($10 + 4 | 0) >> 0] = i64toi32_i32$1;
         HEAP8[($10 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
         HEAP8[($10 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
         HEAP8[($10 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
         i64toi32_i32$1 = $14$hi;
         i64toi32_i32$0 = $12;
         $38 = $14;
         HEAP8[i64toi32_i32$0 >> 0] = $38;
         HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $38 >>> 8 | 0;
         HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $38 >>> 16 | 0;
         HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $38 >>> 24 | 0;
         HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
         HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
         HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
         HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
         HEAP8[$5 >> 0] = $8;
         HEAP8[($5 + 1 | 0) >> 0] = $8 >>> 8 | 0;
         HEAP8[($5 + 2 | 0) >> 0] = $8 >>> 16 | 0;
         HEAP8[($5 + 3 | 0) >> 0] = $8 >>> 24 | 0;
         i64toi32_i32$1 = $15$hi;
         i64toi32_i32$0 = $13;
         $39 = $15;
         HEAP8[i64toi32_i32$0 >> 0] = $39;
         HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $39 >>> 8 | 0;
         HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $39 >>> 16 | 0;
         HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $39 >>> 24 | 0;
         HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
         HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
         HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
         HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
         i64toi32_i32$1 = $16$hi;
         i64toi32_i32$0 = $7;
         $40 = $16;
         HEAP8[$7 >> 0] = $40;
         HEAP8[($7 + 1 | 0) >> 0] = $40 >>> 8 | 0;
         HEAP8[($7 + 2 | 0) >> 0] = $40 >>> 16 | 0;
         HEAP8[($7 + 3 | 0) >> 0] = $40 >>> 24 | 0;
         HEAP8[($7 + 4 | 0) >> 0] = i64toi32_i32$1;
         HEAP8[($7 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
         HEAP8[($7 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
         HEAP8[($7 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
         continue label$10;
        }
        break label$10;
       };
       HEAP8[$11 >> 0] = 255;
       HEAP8[(((($6 + -4 | 0) & $3 | 0) + $9 | 0) + 4 | 0) >> 0] = 255;
       $10 = ($9 + Math_imul(0 - $10 | 0, 28) | 0) + -28 | 0;
       $41 = $12 + 24 | 0;
       $42 = $10 + 24 | 0;
       $43 = HEAPU8[$41 >> 0] | 0 | ((HEAPU8[($41 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($41 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($41 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       HEAP8[$42 >> 0] = $43;
       HEAP8[($42 + 1 | 0) >> 0] = $43 >>> 8 | 0;
       HEAP8[($42 + 2 | 0) >> 0] = $43 >>> 16 | 0;
       HEAP8[($42 + 3 | 0) >> 0] = $43 >>> 24 | 0;
       i64toi32_i32$2 = $12 + 16 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $238 = i64toi32_i32$1;
       i64toi32_i32$1 = $10 + 16 | 0;
       $44 = $238;
       HEAP8[i64toi32_i32$1 >> 0] = $44;
       HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $44 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $44 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $44 >>> 24 | 0;
       HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
       HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
       i64toi32_i32$2 = $12 + 8 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $243 = i64toi32_i32$0;
       i64toi32_i32$0 = $10 + 8 | 0;
       $45 = $243;
       HEAP8[i64toi32_i32$0 >> 0] = $45;
       HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $45 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $45 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $45 >>> 24 | 0;
       HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
       HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
       i64toi32_i32$2 = $12;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $246 = i64toi32_i32$1;
       i64toi32_i32$1 = $10;
       $46 = $246;
       HEAP8[$10 >> 0] = $46;
       HEAP8[($10 + 1 | 0) >> 0] = $46 >>> 8 | 0;
       HEAP8[($10 + 2 | 0) >> 0] = $46 >>> 16 | 0;
       HEAP8[($10 + 3 | 0) >> 0] = $46 >>> 24 | 0;
       HEAP8[($10 + 4 | 0) >> 0] = i64toi32_i32$0;
       HEAP8[($10 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
       HEAP8[($10 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
       HEAP8[($10 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      }
      $10 = $6 + 1 | 0;
      if (($6 | 0) != ($3 | 0)) {
       continue label$8
      }
      break label$8;
     };
    }
    HEAP32[($0 + 8 | 0) >> 2] = ($3 >>> 0 < 8 >>> 0 ? $3 : Math_imul($4 >>> 3 | 0, 7)) - (HEAP32[($0 + 12 | 0) >> 2] | 0) | 0;
    global$0 = $2 + 48 | 0;
    return;
   }
   $7 = $9 + $10 | 0;
   $268 = $7;
   $7 = HEAP32[$7 >> 2] | 0;
   HEAP32[$268 >> 2] = ((($7 >>> 7 | 0) ^ -1 | 0) & 16843009 | 0) + ($7 | 2139062143 | 0) | 0;
   $8 = 1;
   $7 = $10 + 1 | 0;
   continue label$1;
  };
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__UnitInterval___deserialize__h50a71b45bc03a6b4($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, $3 = 0, $3$hi = 0, $4 = 0, $5 = 0, $36 = 0, $37 = 0, $38 = 0, $4$hi = 0, $72 = 0, $5$hi = 0, $90 = 0, $92 = 0, $92$hi = 0, $95 = 0, $95$hi = 0, $99$hi = 0, $101$hi = 0, $103$hi = 0, $106 = 0, $106$hi = 0, $107 = 0, $127 = 0, $133 = 0, $146 = 0, $153 = 0, $160 = 0, $166 = 0, $189 = 0, $196 = 0, $203 = 0, $209 = 0;
  $2 = global$0 - 224 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___tag__ha0ca0c99f1ceb558($2 + 80 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 88 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 92 | 0) >> 2] | 0;
  $3 = i64toi32_i32$0;
  $3$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 80 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 84 | 0) >> 2] | 0;
       i64toi32_i32$2 = i64toi32_i32$1;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 1;
       if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
        break label$5
       }
       i64toi32_i32$2 = $3$hi;
       i64toi32_i32$3 = $3;
       i64toi32_i32$0 = 0;
       i64toi32_i32$1 = 30;
       if ((i64toi32_i32$3 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$0 | 0) | 0) {
        break label$4
       }
       cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 80 | 0 | 0, $1 | 0);
       i64toi32_i32$1 = $2;
       i64toi32_i32$3 = HEAP32[($2 + 88 | 0) >> 2] | 0;
       i64toi32_i32$2 = HEAP32[($2 + 92 | 0) >> 2] | 0;
       $3 = i64toi32_i32$3;
       $3$hi = i64toi32_i32$2;
       i64toi32_i32$1 = $2;
       i64toi32_i32$2 = HEAP32[($2 + 80 | 0) >> 2] | 0;
       i64toi32_i32$3 = HEAP32[($2 + 84 | 0) >> 2] | 0;
       i64toi32_i32$1 = i64toi32_i32$2;
       i64toi32_i32$2 = 0;
       i64toi32_i32$0 = 1;
       if ((i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) | 0) {
        break label$3
       }
       i64toi32_i32$1 = $3$hi;
       i64toi32_i32$3 = i64toi32_i32$1;
       cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__UnitInterval___deserialize_as_embedded_group__hd6b16b3f4b8f1ba1($2 + 80 | 0 | 0, $1 | 0, $3 | 0, i64toi32_i32$3 | 0, $3 | 0, i64toi32_i32$3 | 0);
       label$6 : {
        i64toi32_i32$0 = $3;
        i64toi32_i32$1 = 0;
        i64toi32_i32$2 = 1;
        if ((i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) | 0) {
         break label$6
        }
        cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 176 | 0 | 0, $1 | 0);
        $1 = HEAPU8[($2 + 184 | 0) >> 0] | 0;
        label$7 : {
         label$8 : {
          i64toi32_i32$2 = $2;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 176 | 0) >> 2] | 0;
          i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 180 | 0) >> 2] | 0;
          i64toi32_i32$2 = i64toi32_i32$0;
          i64toi32_i32$0 = 0;
          i64toi32_i32$1 = 1;
          if ((i64toi32_i32$2 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) | 0) {
           break label$8
          }
          if (($1 & 255 | 0 | 0) == (5 | 0)) {
           break label$6
          }
          HEAP32[($2 + 64 | 0) >> 2] = 0;
          HEAP8[($2 + 16 | 0) >> 0] = 5;
          i64toi32_i32$3 = $2;
          i64toi32_i32$2 = 0;
          HEAP32[(i64toi32_i32$3 + 8 | 0) >> 2] = 1;
          HEAP32[(i64toi32_i32$3 + 12 | 0) >> 2] = i64toi32_i32$2;
          break label$7;
         }
         i64toi32_i32$1 = ($2 + 176 | 0) + 32 | 0;
         i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
         $3 = i64toi32_i32$2;
         $3$hi = i64toi32_i32$3;
         i64toi32_i32$2 = $2 + 160 | 0;
         HEAP32[i64toi32_i32$2 >> 2] = $3;
         HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
         i64toi32_i32$1 = ($2 + 176 | 0) + 40 | 0;
         i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
         $4 = i64toi32_i32$3;
         $4$hi = i64toi32_i32$2;
         i64toi32_i32$3 = ($2 + 152 | 0) + 16 | 0;
         HEAP32[i64toi32_i32$3 >> 2] = $4;
         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
         HEAP32[($2 + 64 | 0) >> 2] = 0;
         i64toi32_i32$1 = ($2 + 176 | 0) + 16 | 0;
         i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
         $72 = i64toi32_i32$2;
         i64toi32_i32$2 = ($2 + 8 | 0) + 24 | 0;
         HEAP32[i64toi32_i32$2 >> 2] = $72;
         HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
         i64toi32_i32$1 = ($2 + 176 | 0) + 24 | 0;
         i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
         $5 = i64toi32_i32$3;
         $5$hi = i64toi32_i32$2;
         i64toi32_i32$3 = ($2 + 8 | 0) + 32 | 0;
         HEAP32[i64toi32_i32$3 >> 2] = $5;
         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
         i64toi32_i32$2 = $3$hi;
         i64toi32_i32$3 = ($2 + 8 | 0) + 40 | 0;
         HEAP32[i64toi32_i32$3 >> 2] = $3;
         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
         i64toi32_i32$2 = $4$hi;
         i64toi32_i32$3 = $2 + 56 | 0;
         HEAP32[i64toi32_i32$3 >> 2] = $4;
         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
         $90 = ($2 + 8 | 0) + 16 | 0;
         i64toi32_i32$1 = $2;
         i64toi32_i32$2 = HEAPU8[($2 + 185 | 0) >> 0] | 0 | ((HEAPU8[($2 + 186 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 187 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 188 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$3 = 0;
         $92 = i64toi32_i32$2;
         $92$hi = i64toi32_i32$3;
         i64toi32_i32$1 = $2 + 189 | 0;
         i64toi32_i32$3 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
         i64toi32_i32$2 = 0;
         $95 = i64toi32_i32$3;
         $95$hi = i64toi32_i32$2;
         i64toi32_i32$1 = $2 + 191 | 0;
         i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
         i64toi32_i32$3 = 0;
         i64toi32_i32$1 = i64toi32_i32$2;
         i64toi32_i32$2 = 0;
         i64toi32_i32$0 = 16;
         i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
          i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
          $36 = 0;
         } else {
          i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$4 | 0) | 0;
          $36 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
         }
         $99$hi = i64toi32_i32$2;
         i64toi32_i32$2 = $95$hi;
         i64toi32_i32$3 = $95;
         i64toi32_i32$1 = $99$hi;
         i64toi32_i32$0 = $36;
         i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
         i64toi32_i32$2 = i64toi32_i32$3 | i64toi32_i32$0 | 0;
         i64toi32_i32$3 = 0;
         i64toi32_i32$0 = 32;
         i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
          i64toi32_i32$3 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
          $37 = 0;
         } else {
          i64toi32_i32$3 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
          $37 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
         }
         $101$hi = i64toi32_i32$3;
         i64toi32_i32$3 = $92$hi;
         i64toi32_i32$1 = $92;
         i64toi32_i32$2 = $101$hi;
         i64toi32_i32$0 = $37;
         i64toi32_i32$2 = i64toi32_i32$3 | i64toi32_i32$2 | 0;
         i64toi32_i32$3 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
         i64toi32_i32$1 = 0;
         i64toi32_i32$0 = 8;
         i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
          i64toi32_i32$1 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
          $38 = 0;
         } else {
          i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
          $38 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
         }
         $103$hi = i64toi32_i32$1;
         i64toi32_i32$1 = 0;
         i64toi32_i32$2 = $1;
         i64toi32_i32$3 = 0;
         i64toi32_i32$0 = 255;
         i64toi32_i32$3 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
         $106 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
         $106$hi = i64toi32_i32$3;
         i64toi32_i32$3 = $103$hi;
         i64toi32_i32$1 = $38;
         i64toi32_i32$2 = $106$hi;
         i64toi32_i32$0 = $106;
         i64toi32_i32$2 = i64toi32_i32$3 | i64toi32_i32$2 | 0;
         $107 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
         i64toi32_i32$1 = $90;
         HEAP32[i64toi32_i32$1 >> 2] = $107;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
         i64toi32_i32$2 = $5$hi;
         i64toi32_i32$1 = $2;
         HEAP32[($2 + 152 | 0) >> 2] = $5;
         HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$2;
         HEAP8[($2 + 16 | 0) >> 0] = 2;
         i64toi32_i32$1 = $2;
         i64toi32_i32$2 = 0;
         HEAP32[($2 + 8 | 0) >> 2] = 1;
         HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$2;
        }
        i64toi32_i32$3 = $2;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 80 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 84 | 0) >> 2] | 0;
        if (!(i64toi32_i32$2 | i64toi32_i32$1 | 0)) {
         break label$2
        }
        core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9($2 + 88 | 0 | 0);
        break label$2;
       }
       memcpy($2 + 8 | 0 | 0, $2 + 80 | 0 | 0, 72 | 0) | 0;
       i64toi32_i32$3 = $2;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 8 | 0) >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 12 | 0) >> 2] | 0;
       i64toi32_i32$3 = i64toi32_i32$1;
       i64toi32_i32$1 = 0;
       i64toi32_i32$0 = 1;
       if ((i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$1 | 0) | 0) {
        break label$2
       }
       i64toi32_i32$0 = $2;
       i64toi32_i32$3 = HEAP32[($2 + 16 | 0) >> 2] | 0;
       i64toi32_i32$2 = HEAP32[($2 + 20 | 0) >> 2] | 0;
       $127 = i64toi32_i32$3;
       i64toi32_i32$3 = $0;
       HEAP32[(i64toi32_i32$3 + 8 | 0) >> 2] = $127;
       HEAP32[(i64toi32_i32$3 + 12 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$0 = ($2 + 8 | 0) + 16 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
       $133 = i64toi32_i32$2;
       i64toi32_i32$2 = $0 + 16 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $133;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
       i64toi32_i32$3 = 0;
       $3 = 0;
       $3$hi = i64toi32_i32$3;
       break label$1;
      }
      HEAP32[($2 + 64 | 0) >> 2] = 0;
      i64toi32_i32$3 = $3$hi;
      i64toi32_i32$2 = ($2 + 8 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $3;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
      i64toi32_i32$0 = ($2 + 80 | 0) + 16 | 0;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
      $146 = i64toi32_i32$3;
      i64toi32_i32$3 = ($2 + 8 | 0) + 24 | 0;
      HEAP32[i64toi32_i32$3 >> 2] = $146;
      HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$0 = ($2 + 80 | 0) + 24 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
      $153 = i64toi32_i32$2;
      i64toi32_i32$2 = ($2 + 8 | 0) + 32 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $153;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
      i64toi32_i32$0 = ($2 + 80 | 0) + 32 | 0;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
      $160 = i64toi32_i32$3;
      i64toi32_i32$3 = ($2 + 8 | 0) + 40 | 0;
      HEAP32[i64toi32_i32$3 >> 2] = $160;
      HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$0 = ($2 + 80 | 0) + 40 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
      $166 = i64toi32_i32$2;
      i64toi32_i32$2 = $2 + 56 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $166;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
      HEAP8[($2 + 16 | 0) >> 0] = 2;
      break label$2;
     }
     alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($2 + 64 | 0 | 0, 1050228 | 0, 12 | 0);
     i64toi32_i32$2 = $2 + 32 | 0;
     i64toi32_i32$3 = 0;
     HEAP32[i64toi32_i32$2 >> 2] = 30;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$3 = $3$hi;
     i64toi32_i32$2 = $2 + 24 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $3;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
     HEAP8[($2 + 16 | 0) >> 0] = 15;
     i64toi32_i32$2 = $2;
     i64toi32_i32$3 = 0;
     HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = 1;
     HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$3;
     break label$2;
    }
    HEAP32[($2 + 64 | 0) >> 2] = 0;
    i64toi32_i32$3 = $3$hi;
    i64toi32_i32$2 = ($2 + 8 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $3;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
    i64toi32_i32$0 = ($2 + 80 | 0) + 16 | 0;
    i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
    $189 = i64toi32_i32$3;
    i64toi32_i32$3 = ($2 + 8 | 0) + 24 | 0;
    HEAP32[i64toi32_i32$3 >> 2] = $189;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$0 = ($2 + 80 | 0) + 24 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
    $196 = i64toi32_i32$2;
    i64toi32_i32$2 = ($2 + 8 | 0) + 32 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $196;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
    i64toi32_i32$0 = ($2 + 80 | 0) + 32 | 0;
    i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
    $203 = i64toi32_i32$3;
    i64toi32_i32$3 = ($2 + 8 | 0) + 40 | 0;
    HEAP32[i64toi32_i32$3 >> 2] = $203;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$0 = ($2 + 80 | 0) + 40 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
    $209 = i64toi32_i32$2;
    i64toi32_i32$2 = $2 + 56 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $209;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
    HEAP8[($2 + 16 | 0) >> 0] = 2;
   }
   memcpy($2 + 80 | 0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 64 | 0) | 0;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 80 | 0 | 0, 1050228 | 0, 12 | 0);
   i64toi32_i32$3 = 0;
   $3 = 1;
   $3$hi = i64toi32_i32$3;
  }
  i64toi32_i32$3 = $3$hi;
  i64toi32_i32$2 = $0;
  HEAP32[i64toi32_i32$2 >> 2] = $3;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
  global$0 = $2 + 224 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__StakeRegistration___deserialize__hef7d0796e9b28850($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $4 = 0, $5 = 0, $4$hi = 0, $3 = 0, $5$hi = 0, $34 = 0, $35 = 0, $36 = 0, $37 = 0, $38 = 0, $40 = 0, $41 = 0, $42 = 0, $43 = 0, $45 = 0, $46 = 0, $47 = 0, $48 = 0, $49 = 0, $50 = 0, $51 = 0, $52 = 0, $53 = 0, $54 = 0, $55 = 0, $39 = 0, $44 = 0, $64 = 0, $88 = 0, $122 = 0, $122$hi = 0, $125 = 0, $125$hi = 0, $129$hi = 0, $131$hi = 0, $133$hi = 0, $136 = 0, $136$hi = 0, $151 = 0, $156 = 0, $160 = 0, $169 = 0, $204 = 0, $208 = 0, $213 = 0, $218 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 32 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 40 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 44 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       i64toi32_i32$2 = $2;
       i64toi32_i32$1 = HEAP32[($2 + 32 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[($2 + 36 | 0) >> 2] | 0;
       i64toi32_i32$2 = i64toi32_i32$1;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 1;
       if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
        break label$5
       }
       i64toi32_i32$2 = $4$hi;
       i64toi32_i32$0 = i64toi32_i32$2;
       cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__StakeRegistration___deserialize_as_embedded_group__h584ad4f96a0a79b8($2 + 32 | 0 | 0, $1 | 0, $4 | 0, i64toi32_i32$0 | 0, $4 | 0, i64toi32_i32$0 | 0);
       label$6 : {
        label$7 : {
         label$8 : {
          i64toi32_i32$3 = $4;
          i64toi32_i32$2 = 0;
          i64toi32_i32$1 = 1;
          if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) | 0) {
           break label$8
          }
          cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 128 | 0 | 0, $1 | 0);
          $3 = HEAPU8[($2 + 136 | 0) >> 0] | 0;
          i64toi32_i32$1 = $2;
          i64toi32_i32$3 = HEAP32[($2 + 128 | 0) >> 2] | 0;
          i64toi32_i32$0 = HEAP32[($2 + 132 | 0) >> 2] | 0;
          i64toi32_i32$1 = i64toi32_i32$3;
          i64toi32_i32$3 = 0;
          i64toi32_i32$2 = 1;
          if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) | 0) {
           break label$7
          }
          $1 = 5;
          if (($3 & 255 | 0 | 0) != (5 | 0)) {
           break label$6
          }
         }
         i64toi32_i32$2 = $2 + 72 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $39 = i64toi32_i32$1;
         i64toi32_i32$1 = $2 + 8 | 0;
         HEAP32[i64toi32_i32$1 >> 2] = $39;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$2 = $2 + 80 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $44 = i64toi32_i32$0;
         i64toi32_i32$0 = $2 + 16 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $44;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         HEAP32[($2 + 104 | 0) >> 2] = HEAPU8[($2 + 33 | 0) >> 0] | 0 | ((HEAPU8[($2 + 34 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 35 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 36 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $34 = HEAPU8[($2 + 36 | 0) >> 0] | 0 | ((HEAPU8[($2 + 37 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 38 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 39 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[($2 + 107 | 0) >> 0] = $34;
         HEAP8[($2 + 108 | 0) >> 0] = $34 >>> 8 | 0;
         HEAP8[($2 + 109 | 0) >> 0] = $34 >>> 16 | 0;
         HEAP8[($2 + 110 | 0) >> 0] = $34 >>> 24 | 0;
         $35 = ($2 + 32 | 0) + 9 | 0;
         HEAP32[($2 + 24 | 0) >> 2] = HEAPU8[$35 >> 0] | 0 | ((HEAPU8[($35 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($35 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($35 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $36 = ($2 + 32 | 0) + 12 | 0;
         $37 = HEAPU8[$36 >> 0] | 0 | ((HEAPU8[($36 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($36 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($36 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[($2 + 27 | 0) >> 0] = $37;
         HEAP8[($2 + 28 | 0) >> 0] = $37 >>> 8 | 0;
         HEAP8[($2 + 29 | 0) >> 0] = $37 >>> 16 | 0;
         HEAP8[($2 + 30 | 0) >> 0] = $37 >>> 24 | 0;
         i64toi32_i32$2 = $2 + 64 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $64 = i64toi32_i32$1;
         i64toi32_i32$1 = $2;
         HEAP32[$2 >> 2] = $64;
         HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$0;
         $1 = HEAPU8[(($2 + 32 | 0) + 8 | 0) >> 0] | 0;
         i64toi32_i32$2 = ($2 + 32 | 0) + 16 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $4 = i64toi32_i32$0;
         $4$hi = i64toi32_i32$1;
         i64toi32_i32$2 = ($2 + 32 | 0) + 24 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $5 = i64toi32_i32$1;
         $5$hi = i64toi32_i32$0;
         $3 = HEAPU8[($2 + 32 | 0) >> 0] | 0;
         HEAP32[(($2 + 128 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 100 | 0) >> 2] | 0;
         i64toi32_i32$2 = $2 + 92 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $88 = i64toi32_i32$0;
         i64toi32_i32$0 = $2;
         HEAP32[($2 + 128 | 0) >> 2] = $88;
         HEAP32[($2 + 132 | 0) >> 2] = i64toi32_i32$1;
         if (($3 | 0) != (1 | 0)) {
          break label$4
         }
         $3 = HEAP32[($2 + 88 | 0) >> 2] | 0;
         break label$2;
        }
        i64toi32_i32$2 = $2 + 160 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $4 = i64toi32_i32$1;
        $4$hi = i64toi32_i32$0;
        i64toi32_i32$1 = ($2 + 104 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $4;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = $2 + 168 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $5 = i64toi32_i32$0;
        $5$hi = i64toi32_i32$1;
        i64toi32_i32$0 = ($2 + 104 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $5;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$1 = $4$hi;
        i64toi32_i32$0 = $2 + 8 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $4;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$1 = $5$hi;
        i64toi32_i32$0 = $2 + 16 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $5;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$2 = $2 + 152 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $4 = i64toi32_i32$1;
        $4$hi = i64toi32_i32$0;
        i64toi32_i32$1 = $2;
        HEAP32[($2 + 104 | 0) >> 2] = $4;
        HEAP32[($2 + 108 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$1 = $2;
        HEAP32[$2 >> 2] = $4;
        HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAPU8[($2 + 137 | 0) >> 0] | 0 | ((HEAPU8[($2 + 138 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 139 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 140 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$1 = 0;
        $122 = i64toi32_i32$0;
        $122$hi = i64toi32_i32$1;
        i64toi32_i32$2 = $2 + 141 | 0;
        i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
        i64toi32_i32$0 = 0;
        $125 = i64toi32_i32$1;
        $125$hi = i64toi32_i32$0;
        i64toi32_i32$2 = $2 + 143 | 0;
        i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
        i64toi32_i32$1 = 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 16;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
         $50 = 0;
        } else {
         i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
         $50 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        }
        $129$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $125$hi;
        i64toi32_i32$1 = $125;
        i64toi32_i32$2 = $129$hi;
        i64toi32_i32$3 = $50;
        i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
        i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 32;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
         $51 = 0;
        } else {
         i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
         $51 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        }
        $131$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $122$hi;
        i64toi32_i32$2 = $122;
        i64toi32_i32$0 = $131$hi;
        i64toi32_i32$3 = $51;
        i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
        i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
        i64toi32_i32$2 = 0;
        i64toi32_i32$3 = 8;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
         $52 = 0;
        } else {
         i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
         $52 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        }
        $133$hi = i64toi32_i32$2;
        i64toi32_i32$2 = 0;
        i64toi32_i32$0 = $3;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 255;
        i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
        $136 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
        $136$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $133$hi;
        i64toi32_i32$2 = $52;
        i64toi32_i32$0 = $136$hi;
        i64toi32_i32$3 = $136;
        i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
        $4 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
        $4$hi = i64toi32_i32$0;
        i64toi32_i32$1 = ($2 + 128 | 0) + 16 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
        $5 = i64toi32_i32$0;
        $5$hi = i64toi32_i32$2;
        $1 = 2;
       }
       if (!(HEAPU8[($2 + 32 | 0) >> 0] | 0)) {
        break label$3
       }
       core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9($2 + 40 | 0 | 0);
       break label$3;
      }
      i64toi32_i32$1 = $2 + 64 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $151 = i64toi32_i32$2;
      i64toi32_i32$2 = $2 + 8 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $151;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$1 = $2 + 72 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $156 = i64toi32_i32$0;
      i64toi32_i32$0 = $2 + 16 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $156;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$1 = $2 + 56 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $160 = i64toi32_i32$2;
      i64toi32_i32$2 = $2;
      HEAP32[$2 >> 2] = $160;
      HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$1 = ($2 + 32 | 0) + 16 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $5 = i64toi32_i32$0;
      $5$hi = i64toi32_i32$2;
      $1 = 2;
      break label$3;
     }
     $38 = HEAP32[($2 + 104 | 0) >> 2] | 0;
     HEAP8[($0 + 1 | 0) >> 0] = $38;
     HEAP8[($0 + 2 | 0) >> 0] = $38 >>> 8 | 0;
     HEAP8[($0 + 3 | 0) >> 0] = $38 >>> 16 | 0;
     HEAP8[($0 + 4 | 0) >> 0] = $38 >>> 24 | 0;
     $169 = $0 + 28 | 0;
     i64toi32_i32$2 = $5$hi;
     i64toi32_i32$1 = $5;
     i64toi32_i32$0 = 0;
     i64toi32_i32$3 = 32;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$0 = 0;
      $53 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
     } else {
      i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
      $53 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
     }
     $54 = $169;
     $55 = $53;
     HEAP8[$54 >> 0] = $55;
     HEAP8[($54 + 1 | 0) >> 0] = $55 >>> 8 | 0;
     i64toi32_i32$0 = $5$hi;
     $40 = $0 + 24 | 0;
     HEAP8[$40 >> 0] = $5;
     HEAP8[($40 + 1 | 0) >> 0] = $5 >>> 8 | 0;
     HEAP8[($40 + 2 | 0) >> 0] = $5 >>> 16 | 0;
     HEAP8[($40 + 3 | 0) >> 0] = $5 >>> 24 | 0;
     $41 = $0 + 4 | 0;
     $42 = HEAPU8[($2 + 107 | 0) >> 0] | 0 | ((HEAPU8[($2 + 108 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 109 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 110 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[$41 >> 0] = $42;
     HEAP8[($41 + 1 | 0) >> 0] = $42 >>> 8 | 0;
     HEAP8[($41 + 2 | 0) >> 0] = $42 >>> 16 | 0;
     HEAP8[($41 + 3 | 0) >> 0] = $42 >>> 24 | 0;
     HEAP8[($0 + 8 | 0) >> 0] = $1;
     $43 = $0 + 9 | 0;
     $45 = HEAP32[($2 + 24 | 0) >> 2] | 0;
     HEAP8[$43 >> 0] = $45;
     HEAP8[($43 + 1 | 0) >> 0] = $45 >>> 8 | 0;
     HEAP8[($43 + 2 | 0) >> 0] = $45 >>> 16 | 0;
     HEAP8[($43 + 3 | 0) >> 0] = $45 >>> 24 | 0;
     $46 = $0 + 12 | 0;
     $47 = HEAPU8[($2 + 27 | 0) >> 0] | 0 | ((HEAPU8[($2 + 28 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 29 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 30 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[$46 >> 0] = $47;
     HEAP8[($46 + 1 | 0) >> 0] = $47 >>> 8 | 0;
     HEAP8[($46 + 2 | 0) >> 0] = $47 >>> 16 | 0;
     HEAP8[($46 + 3 | 0) >> 0] = $47 >>> 24 | 0;
     i64toi32_i32$0 = $4$hi;
     i64toi32_i32$1 = $0 + 16 | 0;
     HEAP8[i64toi32_i32$1 >> 0] = $4;
     HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $4 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $4 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $4 >>> 24 | 0;
     HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
     HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
     $1 = 0;
     break label$1;
    }
    $3 = 0;
   }
   i64toi32_i32$0 = $5$hi;
   i64toi32_i32$1 = ($2 + 32 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $5;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $4$hi;
   i64toi32_i32$1 = ($2 + 32 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $4;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $204 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 56 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $204;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = HEAP32[($2 + 128 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 132 | 0) >> 2] | 0;
   $208 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 84 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $208;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $2 + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $213 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 64 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $213;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $2 + 16 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $218 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 72 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $218;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($2 + 92 | 0) >> 2] = HEAP32[(($2 + 128 | 0) + 8 | 0) >> 2] | 0;
   HEAP8[($2 + 32 | 0) >> 0] = $1;
   $48 = HEAP32[($2 + 24 | 0) >> 2] | 0;
   HEAP8[($2 + 33 | 0) >> 0] = $48;
   HEAP8[($2 + 34 | 0) >> 0] = $48 >>> 8 | 0;
   HEAP8[($2 + 35 | 0) >> 0] = $48 >>> 16 | 0;
   HEAP8[($2 + 36 | 0) >> 0] = $48 >>> 24 | 0;
   $49 = HEAPU8[($2 + 27 | 0) >> 0] | 0 | ((HEAPU8[($2 + 28 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 29 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 30 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[($2 + 36 | 0) >> 0] = $49;
   HEAP8[($2 + 37 | 0) >> 0] = $49 >>> 8 | 0;
   HEAP8[($2 + 38 | 0) >> 0] = $49 >>> 16 | 0;
   HEAP8[($2 + 39 | 0) >> 0] = $49 >>> 24 | 0;
   HEAP32[($2 + 80 | 0) >> 2] = $3;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 32 | 0 | 0, 1050749 | 0, 17 | 0);
   $1 = 1;
  }
  HEAP8[$0 >> 0] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__StakeDeregistration___deserialize__h63747b9459f1aff0($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $4 = 0, $5 = 0, $4$hi = 0, $3 = 0, $5$hi = 0, $34 = 0, $35 = 0, $36 = 0, $37 = 0, $38 = 0, $40 = 0, $41 = 0, $42 = 0, $43 = 0, $45 = 0, $46 = 0, $47 = 0, $48 = 0, $49 = 0, $50 = 0, $51 = 0, $52 = 0, $53 = 0, $54 = 0, $55 = 0, $39 = 0, $44 = 0, $64 = 0, $88 = 0, $122 = 0, $122$hi = 0, $125 = 0, $125$hi = 0, $129$hi = 0, $131$hi = 0, $133$hi = 0, $136 = 0, $136$hi = 0, $151 = 0, $156 = 0, $160 = 0, $169 = 0, $204 = 0, $208 = 0, $213 = 0, $218 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 32 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 40 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 44 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       i64toi32_i32$2 = $2;
       i64toi32_i32$1 = HEAP32[($2 + 32 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[($2 + 36 | 0) >> 2] | 0;
       i64toi32_i32$2 = i64toi32_i32$1;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 1;
       if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
        break label$5
       }
       i64toi32_i32$2 = $4$hi;
       i64toi32_i32$0 = i64toi32_i32$2;
       cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__StakeDeregistration___deserialize_as_embedded_group__h26da61dcbe3232ba($2 + 32 | 0 | 0, $1 | 0, $4 | 0, i64toi32_i32$0 | 0, $4 | 0, i64toi32_i32$0 | 0);
       label$6 : {
        label$7 : {
         label$8 : {
          i64toi32_i32$3 = $4;
          i64toi32_i32$2 = 0;
          i64toi32_i32$1 = 1;
          if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) | 0) {
           break label$8
          }
          cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 128 | 0 | 0, $1 | 0);
          $3 = HEAPU8[($2 + 136 | 0) >> 0] | 0;
          i64toi32_i32$1 = $2;
          i64toi32_i32$3 = HEAP32[($2 + 128 | 0) >> 2] | 0;
          i64toi32_i32$0 = HEAP32[($2 + 132 | 0) >> 2] | 0;
          i64toi32_i32$1 = i64toi32_i32$3;
          i64toi32_i32$3 = 0;
          i64toi32_i32$2 = 1;
          if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) | 0) {
           break label$7
          }
          $1 = 5;
          if (($3 & 255 | 0 | 0) != (5 | 0)) {
           break label$6
          }
         }
         i64toi32_i32$2 = $2 + 72 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $39 = i64toi32_i32$1;
         i64toi32_i32$1 = $2 + 8 | 0;
         HEAP32[i64toi32_i32$1 >> 2] = $39;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$2 = $2 + 80 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $44 = i64toi32_i32$0;
         i64toi32_i32$0 = $2 + 16 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $44;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         HEAP32[($2 + 104 | 0) >> 2] = HEAPU8[($2 + 33 | 0) >> 0] | 0 | ((HEAPU8[($2 + 34 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 35 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 36 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $34 = HEAPU8[($2 + 36 | 0) >> 0] | 0 | ((HEAPU8[($2 + 37 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 38 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 39 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[($2 + 107 | 0) >> 0] = $34;
         HEAP8[($2 + 108 | 0) >> 0] = $34 >>> 8 | 0;
         HEAP8[($2 + 109 | 0) >> 0] = $34 >>> 16 | 0;
         HEAP8[($2 + 110 | 0) >> 0] = $34 >>> 24 | 0;
         $35 = ($2 + 32 | 0) + 9 | 0;
         HEAP32[($2 + 24 | 0) >> 2] = HEAPU8[$35 >> 0] | 0 | ((HEAPU8[($35 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($35 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($35 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $36 = ($2 + 32 | 0) + 12 | 0;
         $37 = HEAPU8[$36 >> 0] | 0 | ((HEAPU8[($36 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($36 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($36 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[($2 + 27 | 0) >> 0] = $37;
         HEAP8[($2 + 28 | 0) >> 0] = $37 >>> 8 | 0;
         HEAP8[($2 + 29 | 0) >> 0] = $37 >>> 16 | 0;
         HEAP8[($2 + 30 | 0) >> 0] = $37 >>> 24 | 0;
         i64toi32_i32$2 = $2 + 64 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $64 = i64toi32_i32$1;
         i64toi32_i32$1 = $2;
         HEAP32[$2 >> 2] = $64;
         HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$0;
         $1 = HEAPU8[(($2 + 32 | 0) + 8 | 0) >> 0] | 0;
         i64toi32_i32$2 = ($2 + 32 | 0) + 16 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $4 = i64toi32_i32$0;
         $4$hi = i64toi32_i32$1;
         i64toi32_i32$2 = ($2 + 32 | 0) + 24 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $5 = i64toi32_i32$1;
         $5$hi = i64toi32_i32$0;
         $3 = HEAPU8[($2 + 32 | 0) >> 0] | 0;
         HEAP32[(($2 + 128 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 100 | 0) >> 2] | 0;
         i64toi32_i32$2 = $2 + 92 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $88 = i64toi32_i32$0;
         i64toi32_i32$0 = $2;
         HEAP32[($2 + 128 | 0) >> 2] = $88;
         HEAP32[($2 + 132 | 0) >> 2] = i64toi32_i32$1;
         if (($3 | 0) != (1 | 0)) {
          break label$4
         }
         $3 = HEAP32[($2 + 88 | 0) >> 2] | 0;
         break label$2;
        }
        i64toi32_i32$2 = $2 + 160 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $4 = i64toi32_i32$1;
        $4$hi = i64toi32_i32$0;
        i64toi32_i32$1 = ($2 + 104 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $4;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = $2 + 168 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $5 = i64toi32_i32$0;
        $5$hi = i64toi32_i32$1;
        i64toi32_i32$0 = ($2 + 104 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $5;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$1 = $4$hi;
        i64toi32_i32$0 = $2 + 8 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $4;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$1 = $5$hi;
        i64toi32_i32$0 = $2 + 16 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $5;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$2 = $2 + 152 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $4 = i64toi32_i32$1;
        $4$hi = i64toi32_i32$0;
        i64toi32_i32$1 = $2;
        HEAP32[($2 + 104 | 0) >> 2] = $4;
        HEAP32[($2 + 108 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$1 = $2;
        HEAP32[$2 >> 2] = $4;
        HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAPU8[($2 + 137 | 0) >> 0] | 0 | ((HEAPU8[($2 + 138 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 139 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 140 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$1 = 0;
        $122 = i64toi32_i32$0;
        $122$hi = i64toi32_i32$1;
        i64toi32_i32$2 = $2 + 141 | 0;
        i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
        i64toi32_i32$0 = 0;
        $125 = i64toi32_i32$1;
        $125$hi = i64toi32_i32$0;
        i64toi32_i32$2 = $2 + 143 | 0;
        i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
        i64toi32_i32$1 = 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 16;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
         $50 = 0;
        } else {
         i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
         $50 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        }
        $129$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $125$hi;
        i64toi32_i32$1 = $125;
        i64toi32_i32$2 = $129$hi;
        i64toi32_i32$3 = $50;
        i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
        i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 32;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
         $51 = 0;
        } else {
         i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
         $51 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        }
        $131$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $122$hi;
        i64toi32_i32$2 = $122;
        i64toi32_i32$0 = $131$hi;
        i64toi32_i32$3 = $51;
        i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
        i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
        i64toi32_i32$2 = 0;
        i64toi32_i32$3 = 8;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
         $52 = 0;
        } else {
         i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
         $52 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        }
        $133$hi = i64toi32_i32$2;
        i64toi32_i32$2 = 0;
        i64toi32_i32$0 = $3;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 255;
        i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
        $136 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
        $136$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $133$hi;
        i64toi32_i32$2 = $52;
        i64toi32_i32$0 = $136$hi;
        i64toi32_i32$3 = $136;
        i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
        $4 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
        $4$hi = i64toi32_i32$0;
        i64toi32_i32$1 = ($2 + 128 | 0) + 16 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
        $5 = i64toi32_i32$0;
        $5$hi = i64toi32_i32$2;
        $1 = 2;
       }
       if (!(HEAPU8[($2 + 32 | 0) >> 0] | 0)) {
        break label$3
       }
       core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9($2 + 40 | 0 | 0);
       break label$3;
      }
      i64toi32_i32$1 = $2 + 64 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $151 = i64toi32_i32$2;
      i64toi32_i32$2 = $2 + 8 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $151;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$1 = $2 + 72 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $156 = i64toi32_i32$0;
      i64toi32_i32$0 = $2 + 16 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $156;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$1 = $2 + 56 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $160 = i64toi32_i32$2;
      i64toi32_i32$2 = $2;
      HEAP32[$2 >> 2] = $160;
      HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$1 = ($2 + 32 | 0) + 16 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $5 = i64toi32_i32$0;
      $5$hi = i64toi32_i32$2;
      $1 = 2;
      break label$3;
     }
     $38 = HEAP32[($2 + 104 | 0) >> 2] | 0;
     HEAP8[($0 + 1 | 0) >> 0] = $38;
     HEAP8[($0 + 2 | 0) >> 0] = $38 >>> 8 | 0;
     HEAP8[($0 + 3 | 0) >> 0] = $38 >>> 16 | 0;
     HEAP8[($0 + 4 | 0) >> 0] = $38 >>> 24 | 0;
     $169 = $0 + 28 | 0;
     i64toi32_i32$2 = $5$hi;
     i64toi32_i32$1 = $5;
     i64toi32_i32$0 = 0;
     i64toi32_i32$3 = 32;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$0 = 0;
      $53 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
     } else {
      i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
      $53 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
     }
     $54 = $169;
     $55 = $53;
     HEAP8[$54 >> 0] = $55;
     HEAP8[($54 + 1 | 0) >> 0] = $55 >>> 8 | 0;
     i64toi32_i32$0 = $5$hi;
     $40 = $0 + 24 | 0;
     HEAP8[$40 >> 0] = $5;
     HEAP8[($40 + 1 | 0) >> 0] = $5 >>> 8 | 0;
     HEAP8[($40 + 2 | 0) >> 0] = $5 >>> 16 | 0;
     HEAP8[($40 + 3 | 0) >> 0] = $5 >>> 24 | 0;
     $41 = $0 + 4 | 0;
     $42 = HEAPU8[($2 + 107 | 0) >> 0] | 0 | ((HEAPU8[($2 + 108 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 109 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 110 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[$41 >> 0] = $42;
     HEAP8[($41 + 1 | 0) >> 0] = $42 >>> 8 | 0;
     HEAP8[($41 + 2 | 0) >> 0] = $42 >>> 16 | 0;
     HEAP8[($41 + 3 | 0) >> 0] = $42 >>> 24 | 0;
     HEAP8[($0 + 8 | 0) >> 0] = $1;
     $43 = $0 + 9 | 0;
     $45 = HEAP32[($2 + 24 | 0) >> 2] | 0;
     HEAP8[$43 >> 0] = $45;
     HEAP8[($43 + 1 | 0) >> 0] = $45 >>> 8 | 0;
     HEAP8[($43 + 2 | 0) >> 0] = $45 >>> 16 | 0;
     HEAP8[($43 + 3 | 0) >> 0] = $45 >>> 24 | 0;
     $46 = $0 + 12 | 0;
     $47 = HEAPU8[($2 + 27 | 0) >> 0] | 0 | ((HEAPU8[($2 + 28 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 29 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 30 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[$46 >> 0] = $47;
     HEAP8[($46 + 1 | 0) >> 0] = $47 >>> 8 | 0;
     HEAP8[($46 + 2 | 0) >> 0] = $47 >>> 16 | 0;
     HEAP8[($46 + 3 | 0) >> 0] = $47 >>> 24 | 0;
     i64toi32_i32$0 = $4$hi;
     i64toi32_i32$1 = $0 + 16 | 0;
     HEAP8[i64toi32_i32$1 >> 0] = $4;
     HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $4 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $4 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $4 >>> 24 | 0;
     HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
     HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
     $1 = 0;
     break label$1;
    }
    $3 = 0;
   }
   i64toi32_i32$0 = $5$hi;
   i64toi32_i32$1 = ($2 + 32 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $5;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $4$hi;
   i64toi32_i32$1 = ($2 + 32 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $4;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $204 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 56 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $204;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = HEAP32[($2 + 128 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 132 | 0) >> 2] | 0;
   $208 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 84 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $208;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $2 + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $213 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 64 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $213;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $2 + 16 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $218 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 72 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $218;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($2 + 92 | 0) >> 2] = HEAP32[(($2 + 128 | 0) + 8 | 0) >> 2] | 0;
   HEAP8[($2 + 32 | 0) >> 0] = $1;
   $48 = HEAP32[($2 + 24 | 0) >> 2] | 0;
   HEAP8[($2 + 33 | 0) >> 0] = $48;
   HEAP8[($2 + 34 | 0) >> 0] = $48 >>> 8 | 0;
   HEAP8[($2 + 35 | 0) >> 0] = $48 >>> 16 | 0;
   HEAP8[($2 + 36 | 0) >> 0] = $48 >>> 24 | 0;
   $49 = HEAPU8[($2 + 27 | 0) >> 0] | 0 | ((HEAPU8[($2 + 28 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 29 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 30 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[($2 + 36 | 0) >> 0] = $49;
   HEAP8[($2 + 37 | 0) >> 0] = $49 >>> 8 | 0;
   HEAP8[($2 + 38 | 0) >> 0] = $49 >>> 16 | 0;
   HEAP8[($2 + 39 | 0) >> 0] = $49 >>> 24 | 0;
   HEAP32[($2 + 80 | 0) >> 2] = $3;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 32 | 0 | 0, 1050789 | 0, 19 | 0);
   $1 = 1;
  }
  HEAP8[$0 >> 0] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function core__str__converts__from_utf8__h4bd16e554326fb60($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, $3 = 0, $6 = 0, $8 = 0, $9$hi = 0, $10$hi = 0, $9 = 0, $10 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $7 = 0, $4 = 0, $5 = 0, $204$hi = 0, $205$hi = 0, $207 = 0;
  label$1 : {
   if (!$2) {
    break label$1
   }
   $3 = $2 + -7 | 0;
   $4 = $3 >>> 0 > $2 >>> 0 ? 0 : $3;
   $5 = (($1 + 3 | 0) & -4 | 0) - $1 | 0;
   $3 = 0;
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : while (1) {
        label$7 : {
         label$8 : {
          label$9 : {
           $6 = HEAPU8[($1 + $3 | 0) >> 0] | 0;
           $7 = ($6 << 24 | 0) >> 24 | 0;
           if (($7 | 0) < (0 | 0)) {
            break label$9
           }
           if (($5 | 0) == (-1 | 0)) {
            break label$8
           }
           if (($5 - $3 | 0) & 3 | 0) {
            break label$8
           }
           label$10 : {
            if ($3 >>> 0 >= $4 >>> 0) {
             break label$10
            }
            label$11 : while (1) {
             $6 = $1 + $3 | 0;
             if ((HEAP32[($6 + 4 | 0) >> 2] | 0 | (HEAP32[$6 >> 2] | 0) | 0) & -2139062144 | 0) {
              break label$10
             }
             $3 = $3 + 8 | 0;
             if ($3 >>> 0 < $4 >>> 0) {
              continue label$11
             }
             break label$11;
            };
           }
           if ($3 >>> 0 >= $2 >>> 0) {
            break label$7
           }
           label$12 : while (1) {
            if ((HEAP8[($1 + $3 | 0) >> 0] | 0 | 0) < (0 | 0)) {
             break label$7
            }
            $3 = $3 + 1 | 0;
            if (($2 | 0) != ($3 | 0)) {
             continue label$12
            }
            break label$1;
           };
          }
          i64toi32_i32$0 = 256;
          $9 = 0;
          $9$hi = i64toi32_i32$0;
          i64toi32_i32$0 = 1;
          $10 = 0;
          $10$hi = i64toi32_i32$0;
          label$13 : {
           label$14 : {
            label$15 : {
             label$16 : {
              label$17 : {
               label$18 : {
                label$19 : {
                 switch ((HEAPU8[($6 + 1150979 | 0) >> 0] | 0) + -2 | 0 | 0) {
                 case 0:
                  $6 = $3 + 1 | 0;
                  if ($6 >>> 0 < $2 >>> 0) {
                   break label$14
                  }
                  i64toi32_i32$0 = 0;
                  $9 = 0;
                  $9$hi = i64toi32_i32$0;
                  break label$3;
                 case 1:
                  i64toi32_i32$0 = 0;
                  $9 = 0;
                  $9$hi = i64toi32_i32$0;
                  $8 = $3 + 1 | 0;
                  if ($8 >>> 0 >= $2 >>> 0) {
                   break label$3
                  }
                  $8 = HEAPU8[($1 + $8 | 0) >> 0] | 0;
                  switch ($6 + -224 | 0 | 0) {
                  case 13:
                   break label$17;
                  case 0:
                   break label$18;
                  default:
                   break label$16;
                  };
                 case 2:
                  break label$19;
                 default:
                  break label$2;
                 };
                }
                i64toi32_i32$0 = 0;
                $9 = 0;
                $9$hi = i64toi32_i32$0;
                $8 = $3 + 1 | 0;
                if ($8 >>> 0 >= $2 >>> 0) {
                 break label$3
                }
                $8 = HEAPU8[($1 + $8 | 0) >> 0] | 0;
                label$22 : {
                 label$23 : {
                  switch ($6 + -240 | 0 | 0) {
                  default:
                   if (($8 & 255 | 0) >>> 0 > 191 >>> 0) {
                    break label$4
                   }
                   if ((($7 + 15 | 0) & 255 | 0) >>> 0 > 2 >>> 0) {
                    break label$4
                   }
                   if ((($8 << 24 | 0) >> 24 | 0 | 0) >= (0 | 0)) {
                    break label$4
                   }
                   break label$22;
                  case 0:
                   if ((($8 + 112 | 0) & 255 | 0) >>> 0 >= 48 >>> 0) {
                    break label$4
                   }
                   break label$22;
                  case 4:
                   break label$23;
                  };
                 }
                 if ((($8 << 24 | 0) >> 24 | 0 | 0) > (-1 | 0)) {
                  break label$4
                 }
                 if (($8 & 255 | 0) >>> 0 > 143 >>> 0) {
                  break label$4
                 }
                }
                $6 = $3 + 2 | 0;
                if ($6 >>> 0 >= $2 >>> 0) {
                 break label$3
                }
                if (((HEAPU8[($1 + $6 | 0) >> 0] | 0) & 192 | 0 | 0) != (128 | 0)) {
                 break label$5
                }
                i64toi32_i32$0 = 0;
                $10 = 0;
                $10$hi = i64toi32_i32$0;
                $6 = $3 + 3 | 0;
                if ($6 >>> 0 >= $2 >>> 0) {
                 break label$2
                }
                if (((HEAPU8[($1 + $6 | 0) >> 0] | 0) & 192 | 0 | 0) == (128 | 0)) {
                 break label$13
                }
                i64toi32_i32$0 = 768;
                $9 = 0;
                $9$hi = i64toi32_i32$0;
                i64toi32_i32$0 = 1;
                $10 = 0;
                $10$hi = i64toi32_i32$0;
                break label$2;
               }
               if (($8 & 224 | 0 | 0) != (160 | 0)) {
                break label$4
               }
               break label$15;
              }
              if ((($8 << 24 | 0) >> 24 | 0 | 0) > (-1 | 0)) {
               break label$4
              }
              if (($8 & 255 | 0) >>> 0 >= 160 >>> 0) {
               break label$4
              }
              break label$15;
             }
             label$26 : {
              if ((($7 + 31 | 0) & 255 | 0) >>> 0 < 12 >>> 0) {
               break label$26
              }
              if (($8 & 255 | 0) >>> 0 > 191 >>> 0) {
               break label$4
              }
              if (($7 & 254 | 0 | 0) != (238 | 0)) {
               break label$4
              }
              if ((($8 << 24 | 0) >> 24 | 0 | 0) >= (0 | 0)) {
               break label$4
              }
              break label$15;
             }
             if ((($8 << 24 | 0) >> 24 | 0 | 0) > (-1 | 0)) {
              break label$4
             }
             if (($8 & 255 | 0) >>> 0 > 191 >>> 0) {
              break label$4
             }
            }
            i64toi32_i32$0 = 0;
            $10 = 0;
            $10$hi = i64toi32_i32$0;
            $6 = $3 + 2 | 0;
            if ($6 >>> 0 >= $2 >>> 0) {
             break label$2
            }
            if (((HEAPU8[($1 + $6 | 0) >> 0] | 0) & 192 | 0 | 0) != (128 | 0)) {
             break label$5
            }
            break label$13;
           }
           i64toi32_i32$0 = 256;
           $9 = 0;
           $9$hi = i64toi32_i32$0;
           i64toi32_i32$0 = 1;
           $10 = 0;
           $10$hi = i64toi32_i32$0;
           if (((HEAPU8[($1 + $6 | 0) >> 0] | 0) & 192 | 0 | 0) != (128 | 0)) {
            break label$2
           }
          }
          $3 = $6 + 1 | 0;
          break label$7;
         }
         $3 = $3 + 1 | 0;
        }
        if ($3 >>> 0 < $2 >>> 0) {
         continue label$6
        }
        break label$1;
       };
      }
      i64toi32_i32$0 = 512;
      $9 = 0;
      $9$hi = i64toi32_i32$0;
      i64toi32_i32$0 = 1;
      $10 = 0;
      $10$hi = i64toi32_i32$0;
      break label$2;
     }
     i64toi32_i32$0 = 256;
     $9 = 0;
     $9$hi = i64toi32_i32$0;
     i64toi32_i32$0 = 1;
     $10 = 0;
     $10$hi = i64toi32_i32$0;
     break label$2;
    }
    i64toi32_i32$0 = 0;
    $10 = 0;
    $10$hi = i64toi32_i32$0;
   }
   i64toi32_i32$0 = $9$hi;
   i64toi32_i32$0 = 0;
   $204$hi = i64toi32_i32$0;
   i64toi32_i32$0 = $9$hi;
   i64toi32_i32$2 = $9;
   i64toi32_i32$1 = $204$hi;
   i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
   $205$hi = i64toi32_i32$1;
   i64toi32_i32$1 = $10$hi;
   i64toi32_i32$1 = $205$hi;
   i64toi32_i32$0 = i64toi32_i32$2 | $3 | 0;
   i64toi32_i32$2 = $10$hi;
   i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
   $207 = i64toi32_i32$0 | $10 | 0;
   i64toi32_i32$0 = $0;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $207;
   HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$2;
   HEAP32[i64toi32_i32$0 >> 2] = 1;
   return;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[($0 + 8 | 0) >> 2] = $2;
  HEAP32[$0 >> 2] = 0;
 }
 
 function core__fmt__Formatter__pad_integral__h08e3e53a0de517a1($0, $1, $2, $3, $4, $5) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  $5 = $5 | 0;
  var $10 = 0, $9 = 0, $6 = 0, $8 = 0, $7 = 0, $11 = 0;
  label$1 : {
   label$2 : {
    if (!$1) {
     break label$2
    }
    $6 = HEAP32[$0 >> 2] | 0;
    $1 = $6 & 1 | 0;
    $7 = $1 ? 43 : 1114112;
    $8 = $1 + $5 | 0;
    break label$1;
   }
   $8 = $5 + 1 | 0;
   $6 = HEAP32[$0 >> 2] | 0;
   $7 = 45;
  }
  label$3 : {
   label$4 : {
    if ($6 & 4 | 0) {
     break label$4
    }
    $2 = 0;
    break label$3;
   }
   $9 = 0;
   label$5 : {
    if (!$3) {
     break label$5
    }
    $10 = $3;
    $1 = $2;
    label$6 : while (1) {
     $9 = $9 + (((HEAPU8[$1 >> 0] | 0) & 192 | 0 | 0) != (128 | 0)) | 0;
     $1 = $1 + 1 | 0;
     $10 = $10 + -1 | 0;
     if ($10) {
      continue label$6
     }
     break label$6;
    };
   }
   $8 = $9 + $8 | 0;
  }
  $1 = 1;
  label$7 : {
   label$8 : {
    if ((HEAP32[($0 + 8 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$8
    }
    if (core__fmt__Formatter__pad_integral__write_prefix__hab8c9d07f4973a84($0 | 0, $7 | 0, $2 | 0, $3 | 0) | 0) {
     break label$7
    }
    return FUNCTION_TABLE[HEAP32[((HEAP32[($0 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($0 + 24 | 0) >> 2] | 0, $4, $5) | 0 | 0;
   }
   label$9 : {
    label$10 : {
     label$11 : {
      label$12 : {
       label$13 : {
        $9 = HEAP32[($0 + 12 | 0) >> 2] | 0;
        if ($9 >>> 0 <= $8 >>> 0) {
         break label$13
        }
        if ($6 & 8 | 0) {
         break label$9
        }
        $1 = 0;
        $10 = $9 - $8 | 0;
        $6 = $10;
        $9 = HEAPU8[($0 + 32 | 0) >> 0] | 0;
        switch ((($9 | 0) == (3 | 0) ? 1 : $9) & 3 | 0 | 0) {
        case 2:
         break label$11;
        case 1:
         break label$12;
        default:
         break label$10;
        };
       }
       if (core__fmt__Formatter__pad_integral__write_prefix__hab8c9d07f4973a84($0 | 0, $7 | 0, $2 | 0, $3 | 0) | 0) {
        break label$7
       }
       return FUNCTION_TABLE[HEAP32[((HEAP32[($0 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($0 + 24 | 0) >> 2] | 0, $4, $5) | 0 | 0;
      }
      $6 = 0;
      $1 = $10;
      break label$10;
     }
     $1 = $10 >>> 1 | 0;
     $6 = ($10 + 1 | 0) >>> 1 | 0;
    }
    $1 = $1 + 1 | 0;
    $10 = HEAP32[($0 + 28 | 0) >> 2] | 0;
    $9 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    $8 = HEAP32[($0 + 24 | 0) >> 2] | 0;
    label$14 : {
     label$15 : while (1) {
      $1 = $1 + -1 | 0;
      if (!$1) {
       break label$14
      }
      if (!(FUNCTION_TABLE[HEAP32[($10 + 16 | 0) >> 2] | 0 | 0]($8, $9) | 0)) {
       continue label$15
      }
      break label$15;
     };
     return 1 | 0;
    }
    $1 = 1;
    if (($9 | 0) == (1114112 | 0)) {
     break label$7
    }
    if (core__fmt__Formatter__pad_integral__write_prefix__hab8c9d07f4973a84($0 | 0, $7 | 0, $2 | 0, $3 | 0) | 0) {
     break label$7
    }
    if (FUNCTION_TABLE[HEAP32[((HEAP32[($0 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($0 + 24 | 0) >> 2] | 0, $4, $5) | 0) {
     break label$7
    }
    $10 = HEAP32[($0 + 28 | 0) >> 2] | 0;
    $0 = HEAP32[($0 + 24 | 0) >> 2] | 0;
    $1 = 0;
    label$16 : {
     label$17 : while (1) {
      label$18 : {
       if (($6 | 0) != ($1 | 0)) {
        break label$18
       }
       $1 = $6;
       break label$16;
      }
      $1 = $1 + 1 | 0;
      if (!(FUNCTION_TABLE[HEAP32[($10 + 16 | 0) >> 2] | 0 | 0]($0, $9) | 0)) {
       continue label$17
      }
      break label$17;
     };
     $1 = $1 + -1 | 0;
    }
    $1 = $1 >>> 0 < $6 >>> 0;
    break label$7;
   }
   $6 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   HEAP32[($0 + 4 | 0) >> 2] = 48;
   $11 = HEAPU8[($0 + 32 | 0) >> 0] | 0;
   $1 = 1;
   HEAP8[($0 + 32 | 0) >> 0] = 1;
   if (core__fmt__Formatter__pad_integral__write_prefix__hab8c9d07f4973a84($0 | 0, $7 | 0, $2 | 0, $3 | 0) | 0) {
    break label$7
   }
   $1 = 0;
   $10 = $9 - $8 | 0;
   $3 = $10;
   label$19 : {
    label$20 : {
     label$21 : {
      $9 = HEAPU8[($0 + 32 | 0) >> 0] | 0;
      switch ((($9 | 0) == (3 | 0) ? 1 : $9) & 3 | 0 | 0) {
      case 2:
       break label$20;
      case 1:
       break label$21;
      default:
       break label$19;
      };
     }
     $3 = 0;
     $1 = $10;
     break label$19;
    }
    $1 = $10 >>> 1 | 0;
    $3 = ($10 + 1 | 0) >>> 1 | 0;
   }
   $1 = $1 + 1 | 0;
   $10 = HEAP32[($0 + 28 | 0) >> 2] | 0;
   $9 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   $2 = HEAP32[($0 + 24 | 0) >> 2] | 0;
   label$22 : {
    label$23 : while (1) {
     $1 = $1 + -1 | 0;
     if (!$1) {
      break label$22
     }
     if (!(FUNCTION_TABLE[HEAP32[($10 + 16 | 0) >> 2] | 0 | 0]($2, $9) | 0)) {
      continue label$23
     }
     break label$23;
    };
    return 1 | 0;
   }
   $1 = 1;
   if (($9 | 0) == (1114112 | 0)) {
    break label$7
   }
   if (FUNCTION_TABLE[HEAP32[((HEAP32[($0 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($0 + 24 | 0) >> 2] | 0, $4, $5) | 0) {
    break label$7
   }
   $1 = HEAP32[($0 + 28 | 0) >> 2] | 0;
   $2 = HEAP32[($0 + 24 | 0) >> 2] | 0;
   $10 = 0;
   label$24 : {
    label$25 : while (1) {
     if (($3 | 0) == ($10 | 0)) {
      break label$24
     }
     $10 = $10 + 1 | 0;
     if (!(FUNCTION_TABLE[HEAP32[($1 + 16 | 0) >> 2] | 0 | 0]($2, $9) | 0)) {
      continue label$25
     }
     break label$25;
    };
    $1 = 1;
    if (($10 + -1 | 0) >>> 0 < $3 >>> 0) {
     break label$7
    }
   }
   HEAP8[($0 + 32 | 0) >> 0] = $11;
   HEAP32[($0 + 4 | 0) >> 2] = $6;
   return 0 | 0;
  }
  return $1 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__PoolRetirement___deserialize_as_embedded_group__h069038c66944b4a7($0, $1, $2, $2$hi, $3, $3$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  var $4 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $10 = 0, $5 = 0, i64toi32_i32$0 = 0, $10$hi = 0, $6 = 0, $7 = 0, i64toi32_i32$4 = 0, $8 = 0, $30 = 0, $31 = 0, $32 = 0, $33 = 0, $34 = 0, $35 = 0, $11 = 0, $11$hi = 0, $36 = 0, $12 = 0, $12$hi = 0, $9 = 0, $106 = 0, $129 = 0, $135 = 0, $138 = 0, $154 = 0, $158 = 0, $162 = 0;
  $4 = global$0 - 400 | 0;
  global$0 = $4;
  cbor_event__de__Deserializer_R___unsigned_integer__h1ed99c0b7fe7eea1($4 + 328 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[($4 + 336 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($4 + 340 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         i64toi32_i32$2 = $4;
         i64toi32_i32$1 = HEAP32[($4 + 328 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($4 + 332 | 0) >> 2] | 0;
         i64toi32_i32$2 = i64toi32_i32$1;
         i64toi32_i32$1 = 0;
         i64toi32_i32$3 = 1;
         if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
          break label$7
         }
         i64toi32_i32$2 = 0;
         $11 = 4;
         $11$hi = i64toi32_i32$2;
         i64toi32_i32$2 = $10$hi;
         i64toi32_i32$3 = $10;
         i64toi32_i32$0 = 0;
         i64toi32_i32$1 = 4;
         if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) | 0) {
          break label$5
         }
         $5 = 8;
         $6 = 1;
         $7 = 1;
         break label$6;
        }
        i64toi32_i32$3 = $10$hi;
        i64toi32_i32$1 = $10;
        i64toi32_i32$2 = 0;
        i64toi32_i32$0 = 32;
        i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
         i64toi32_i32$2 = 0;
         $36 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
        } else {
         i64toi32_i32$2 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
         $36 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
        }
        $8 = $36;
        i64toi32_i32$3 = $4 + 368 | 0;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $12 = i64toi32_i32$2;
        $12$hi = i64toi32_i32$1;
        i64toi32_i32$3 = $4 + 360 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $11 = i64toi32_i32$1;
        $11$hi = i64toi32_i32$2;
        $9 = HEAP32[($4 + 356 | 0) >> 2] | 0;
        $7 = HEAP32[($4 + 352 | 0) >> 2] | 0;
        i64toi32_i32$2 = $10$hi;
        $6 = $10;
        $5 = 2;
        i64toi32_i32$3 = $4 + 344 | 0;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $10 = i64toi32_i32$2;
        $10$hi = i64toi32_i32$1;
       }
       i64toi32_i32$1 = $12$hi;
       i64toi32_i32$2 = $4 + 368 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $12;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$1 = $11$hi;
       i64toi32_i32$2 = $4 + 360 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $11;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       HEAP32[($4 + 356 | 0) >> 2] = $9;
       HEAP32[($4 + 352 | 0) >> 2] = $7;
       i64toi32_i32$1 = $10$hi;
       i64toi32_i32$2 = $4 + 344 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $10;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       HEAP32[($4 + 340 | 0) >> 2] = $8;
       HEAP32[(($4 + 328 | 0) + 8 | 0) >> 2] = $6;
       HEAP32[($4 + 376 | 0) >> 2] = 0;
       HEAP8[($4 + 328 | 0) >> 0] = $5;
       cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($4 + 184 | 0 | 0, $4 + 328 | 0 | 0, 1050766 | 0, 7 | 0);
       $5 = HEAPU8[($4 + 184 | 0) >> 0] | 0;
       if (($5 | 0) != (19 | 0)) {
        break label$4
       }
      }
      $cardano_serialization_lib__crypto__Ed25519KeyHash_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h495effbb534e290f($4 + 328 | 0 | 0, $1 | 0);
      if ((HEAPU8[($4 + 328 | 0) >> 0] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      i64toi32_i32$3 = ($4 + 328 | 0) + 9 | 0;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$2 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $10 = i64toi32_i32$1;
      $10$hi = i64toi32_i32$2;
      i64toi32_i32$1 = ($4 + 184 | 0) + 9 | 0;
      HEAP8[i64toi32_i32$1 >> 0] = $10;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$2;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
      $5 = ($4 + 40 | 0) + 24 | 0;
      $30 = $4 + 353 | 0;
      HEAP32[$5 >> 2] = HEAPU8[$30 >> 0] | 0 | ((HEAPU8[($30 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($30 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($30 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $6 = ($4 + 40 | 0) + 16 | 0;
      i64toi32_i32$3 = $4 + 345 | 0;
      i64toi32_i32$2 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $106 = i64toi32_i32$2;
      i64toi32_i32$2 = $6;
      HEAP32[i64toi32_i32$2 >> 2] = $106;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      $8 = ($4 + 40 | 0) + 8 | 0;
      i64toi32_i32$1 = $10$hi;
      i64toi32_i32$2 = $8;
      HEAP32[i64toi32_i32$2 >> 2] = $10;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$3 = $4;
      i64toi32_i32$1 = HEAPU8[($4 + 329 | 0) >> 0] | 0 | ((HEAPU8[($4 + 330 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 331 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 332 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$2 = HEAPU8[($4 + 333 | 0) >> 0] | 0 | ((HEAPU8[($4 + 334 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 335 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 336 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $10 = i64toi32_i32$1;
      $10$hi = i64toi32_i32$2;
      i64toi32_i32$1 = $4;
      HEAP8[($4 + 185 | 0) >> 0] = $10;
      HEAP8[($4 + 186 | 0) >> 0] = $10 >>> 8 | 0;
      HEAP8[($4 + 187 | 0) >> 0] = $10 >>> 16 | 0;
      HEAP8[($4 + 188 | 0) >> 0] = $10 >>> 24 | 0;
      HEAP8[($4 + 189 | 0) >> 0] = i64toi32_i32$2;
      HEAP8[($4 + 190 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
      HEAP8[($4 + 191 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
      HEAP8[($4 + 192 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
      i64toi32_i32$1 = $4;
      HEAP32[($4 + 40 | 0) >> 2] = $10;
      HEAP32[($4 + 44 | 0) >> 2] = i64toi32_i32$2;
      $7 = ($4 + 8 | 0) + 24 | 0;
      HEAP32[$7 >> 2] = HEAP32[$5 >> 2] | 0;
      $5 = ($4 + 8 | 0) + 16 | 0;
      i64toi32_i32$3 = $6;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $129 = i64toi32_i32$2;
      i64toi32_i32$2 = $5;
      HEAP32[i64toi32_i32$2 >> 2] = $129;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      $6 = ($4 + 8 | 0) + 8 | 0;
      i64toi32_i32$3 = $8;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $135 = i64toi32_i32$1;
      i64toi32_i32$1 = $6;
      HEAP32[i64toi32_i32$1 >> 2] = $135;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$3 = $4;
      i64toi32_i32$2 = HEAP32[($4 + 40 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($4 + 44 | 0) >> 2] | 0;
      $138 = i64toi32_i32$2;
      i64toi32_i32$2 = $4;
      HEAP32[($4 + 8 | 0) >> 2] = $138;
      HEAP32[($4 + 12 | 0) >> 2] = i64toi32_i32$1;
      $T_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hf422f9333a8bbafa($4 + 328 | 0 | 0, $1 | 0);
      if ((HEAP32[($4 + 328 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$2
      }
      $1 = HEAP32[($4 + 332 | 0) >> 2] | 0;
      $31 = $0 + 32 | 0;
      $32 = HEAP32[$7 >> 2] | 0;
      HEAP8[$31 >> 0] = $32;
      HEAP8[($31 + 1 | 0) >> 0] = $32 >>> 8 | 0;
      HEAP8[($31 + 2 | 0) >> 0] = $32 >>> 16 | 0;
      HEAP8[($31 + 3 | 0) >> 0] = $32 >>> 24 | 0;
      i64toi32_i32$3 = $5;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $154 = i64toi32_i32$1;
      i64toi32_i32$1 = $0 + 24 | 0;
      $33 = $154;
      HEAP8[i64toi32_i32$1 >> 0] = $33;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $33 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $33 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $33 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$2;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
      i64toi32_i32$3 = $6;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $158 = i64toi32_i32$2;
      i64toi32_i32$2 = $0 + 16 | 0;
      $34 = $158;
      HEAP8[i64toi32_i32$2 >> 0] = $34;
      HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $34 >>> 8 | 0;
      HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $34 >>> 16 | 0;
      HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $34 >>> 24 | 0;
      HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      i64toi32_i32$3 = $4;
      i64toi32_i32$1 = HEAP32[($4 + 8 | 0) >> 2] | 0;
      i64toi32_i32$2 = HEAP32[($4 + 12 | 0) >> 2] | 0;
      $162 = i64toi32_i32$1;
      i64toi32_i32$1 = $0 + 8 | 0;
      $35 = $162;
      HEAP8[i64toi32_i32$1 >> 0] = $35;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $35 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $35 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $35 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$2;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
      HEAP32[($0 + 4 | 0) >> 2] = $1;
      HEAP32[$0 >> 2] = 0;
      break label$1;
     }
     memcpy($4 + 256 | 0 | 0, $4 + 184 | 0 | 1 | 0 | 0, 63 | 0) | 0;
     HEAP8[($0 + 8 | 0) >> 0] = $5;
     memcpy($0 + 9 | 0 | 0, $4 + 256 | 0 | 0, 63 | 0) | 0;
     HEAP32[$0 >> 2] = 1;
     break label$1;
    }
    memcpy($4 + 328 | 0 | 0, memcpy($4 + 112 | 0 | 7 | 0 | 0, memcpy($4 + 256 | 0 | 7 | 0 | 0, ($4 + 328 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
    $1 = ($4 + 184 | 0) + 8 | 0;
    cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 328 | 0 | 0, 1050823 | 0, 12 | 0);
    memcpy($0 + 8 | 0 | 0, memcpy($4 + 40 | 0 | 7 | 0 | 0, $1 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    break label$1;
   }
   memcpy($4 + 256 | 0 | 0, ($4 + 328 | 0) + 8 | 0 | 0, 64 | 0) | 0;
   memcpy($4 + 328 | 0 | 0, $4 + 256 | 0 | 0, 64 | 0) | 0;
   $1 = ($4 + 184 | 0) + 8 | 0;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 328 | 0 | 0, 1051020 | 0, 5 | 0);
   memcpy($0 + 8 | 0 | 0, $1 | 0, 64 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $4 + 400 | 0;
 }
 
 function block_header($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $1 = 0, $44 = 0, $45 = 0, $47 = 0, $48 = 0, $49 = 0, $50 = 0, $51 = 0, $53 = 0, $54 = 0, $55 = 0, $56 = 0, $57 = 0, $59 = 0, $60 = 0, $61 = 0, $62 = 0, $7 = 0, $7$hi = 0, $3 = 0, $4 = 0, $2 = 0, $6 = 0, $6$hi = 0, $32 = 0, $37 = 0, $42 = 0, $46 = 0, $52 = 0, $58 = 0, $64 = 0, $72 = 0, $78 = 0, $84 = 0, $89 = 0, $5 = 0, $115 = 0, $121 = 0, $127 = 0, $130 = 0, $134 = 0, $140 = 0, $146 = 0, $152 = 0, $8 = 0, $8$hi = 0, $166 = 0, $172 = 0, $178 = 0, $184 = 0, $190 = 0, $196 = 0, $205 = 0, $211 = 0, $217 = 0, $226 = 0;
  $1 = global$0 - 720 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hdd2a3d9c2413fc4e($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   $2 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   i64toi32_i32$2 = $0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $6 = i64toi32_i32$0;
   $6$hi = i64toi32_i32$1;
   $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   $4 = 0;
   label$2 : {
    if ((HEAPU8[(i64toi32_i32$2 + 176 | 0) >> 0] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    i64toi32_i32$2 = $0 + 201 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $32 = i64toi32_i32$1;
    i64toi32_i32$1 = $1 + 368 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $32;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $0 + 193 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $37 = i64toi32_i32$0;
    i64toi32_i32$0 = $1 + 360 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $37;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $0 + 185 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $42 = i64toi32_i32$1;
    i64toi32_i32$1 = $1 + 352 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $42;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $0 + 177 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $46 = i64toi32_i32$0;
    i64toi32_i32$0 = $1;
    HEAP32[(i64toi32_i32$0 + 344 | 0) >> 2] = $46;
    HEAP32[(i64toi32_i32$0 + 348 | 0) >> 2] = i64toi32_i32$1;
    $4 = 1;
   }
   i64toi32_i32$2 = $0 + 233 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $52 = i64toi32_i32$1;
   i64toi32_i32$1 = ($1 + 16 | 0) + 233 | 0;
   $44 = $52;
   HEAP8[i64toi32_i32$1 >> 0] = $44;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $44 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $44 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $44 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $0 + 225 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $58 = i64toi32_i32$0;
   i64toi32_i32$0 = ($1 + 16 | 0) + 225 | 0;
   $45 = $58;
   HEAP8[i64toi32_i32$0 >> 0] = $45;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $45 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $45 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $45 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = $0 + 217 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $64 = i64toi32_i32$1;
   i64toi32_i32$1 = ($1 + 16 | 0) + 217 | 0;
   $47 = $64;
   HEAP8[i64toi32_i32$1 >> 0] = $47;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $47 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $47 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $47 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 209 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 210 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 211 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 212 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 213 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 214 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 215 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 216 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $7 = i64toi32_i32$0;
   $7$hi = i64toi32_i32$1;
   i64toi32_i32$2 = i64toi32_i32$2 + 249 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $72 = i64toi32_i32$1;
   i64toi32_i32$1 = ($1 + 16 | 0) + 249 | 0;
   $48 = $72;
   HEAP8[i64toi32_i32$1 >> 0] = $48;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $48 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $48 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $48 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $0 + 257 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $78 = i64toi32_i32$0;
   i64toi32_i32$0 = ($1 + 16 | 0) + 257 | 0;
   $49 = $78;
   HEAP8[i64toi32_i32$0 >> 0] = $49;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $49 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $49 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $49 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = $0 + 265 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $84 = i64toi32_i32$1;
   i64toi32_i32$1 = ($1 + 16 | 0) + 265 | 0;
   $50 = $84;
   HEAP8[i64toi32_i32$1 >> 0] = $50;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $50 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $50 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $50 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$0 = $7$hi;
   i64toi32_i32$1 = $1;
   $51 = $7;
   HEAP8[(i64toi32_i32$1 + 225 | 0) >> 0] = $51;
   HEAP8[(i64toi32_i32$1 + 226 | 0) >> 0] = $51 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 227 | 0) >> 0] = $51 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 228 | 0) >> 0] = $51 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 229 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 230 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 231 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 232 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 241 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 242 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 243 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 244 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 245 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 246 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 247 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 248 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $89 = i64toi32_i32$0;
   i64toi32_i32$0 = $1;
   $53 = $89;
   HEAP8[(i64toi32_i32$0 + 257 | 0) >> 0] = $53;
   HEAP8[(i64toi32_i32$0 + 258 | 0) >> 0] = $53 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 259 | 0) >> 0] = $53 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 260 | 0) >> 0] = $53 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 261 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 262 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 263 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 264 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3(i64toi32_i32$0 + 672 | 0 | 0, i64toi32_i32$2 + 12 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3((i64toi32_i32$0 + 672 | 0) + 12 | 0 | 0, i64toi32_i32$2 + 24 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3(i64toi32_i32$0 + 696 | 0 | 0, i64toi32_i32$2 + 36 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3((i64toi32_i32$0 + 696 | 0) + 12 | 0 | 0, i64toi32_i32$2 + 48 | 0 | 0);
   $5 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
   i64toi32_i32$2 = i64toi32_i32$2 + 297 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $115 = i64toi32_i32$1;
   i64toi32_i32$1 = ($1 + 16 | 0) + 297 | 0;
   $54 = $115;
   HEAP8[i64toi32_i32$1 >> 0] = $54;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $54 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $54 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $54 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $0 + 289 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $121 = i64toi32_i32$0;
   i64toi32_i32$0 = ($1 + 16 | 0) + 289 | 0;
   $55 = $121;
   HEAP8[i64toi32_i32$0 >> 0] = $55;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $55 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $55 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $55 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = $0 + 281 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $127 = i64toi32_i32$1;
   i64toi32_i32$1 = ($1 + 16 | 0) + 281 | 0;
   $56 = $127;
   HEAP8[i64toi32_i32$1 >> 0] = $56;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $56 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $56 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $56 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 273 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 274 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 275 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 276 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 277 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 278 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 279 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 280 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $130 = i64toi32_i32$0;
   i64toi32_i32$0 = $1;
   $57 = $130;
   HEAP8[(i64toi32_i32$0 + 289 | 0) >> 0] = $57;
   HEAP8[(i64toi32_i32$0 + 290 | 0) >> 0] = $57 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 291 | 0) >> 0] = $57 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 292 | 0) >> 0] = $57 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 293 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 294 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 295 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 296 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 72 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 76 | 0) >> 2] | 0;
   $134 = i64toi32_i32$1;
   i64toi32_i32$1 = $1 + 88 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $134;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = i64toi32_i32$2 + 80 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $140 = i64toi32_i32$0;
   i64toi32_i32$0 = ($1 + 16 | 0) + 80 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $140;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $0 + 88 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $146 = i64toi32_i32$1;
   i64toi32_i32$1 = ($1 + 16 | 0) + 88 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $146;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $0 + 96 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $152 = i64toi32_i32$0;
   i64toi32_i32$0 = ($1 + 16 | 0) + 96 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $152;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
   $7 = i64toi32_i32$1;
   $7$hi = i64toi32_i32$0;
   memcpy(($1 + 16 | 0) + 104 | 0 | 0, i64toi32_i32$2 + 104 | 0 | 0, 64 | 0) | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 168 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 172 | 0) >> 2] | 0;
   $8 = i64toi32_i32$0;
   $8$hi = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 344 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 348 | 0) >> 2] | 0;
   $166 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2 + 193 | 0;
   $59 = $166;
   HEAP8[i64toi32_i32$1 >> 0] = $59;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $59 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $59 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $59 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = (i64toi32_i32$2 + 344 | 0) + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $172 = i64toi32_i32$0;
   i64toi32_i32$0 = $1 + 201 | 0;
   $60 = $172;
   HEAP8[i64toi32_i32$0 >> 0] = $60;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $60 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $60 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $60 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = ($1 + 344 | 0) + 16 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $178 = i64toi32_i32$1;
   i64toi32_i32$1 = $1 + 209 | 0;
   $61 = $178;
   HEAP8[i64toi32_i32$1 >> 0] = $61;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $61 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $61 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $61 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = ($1 + 344 | 0) + 24 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $184 = i64toi32_i32$0;
   i64toi32_i32$0 = $1 + 217 | 0;
   $62 = $184;
   HEAP8[i64toi32_i32$0 >> 0] = $62;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $62 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $62 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $62 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = ($1 + 672 | 0) + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $190 = i64toi32_i32$1;
   i64toi32_i32$1 = $1 + 36 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $190;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = ($1 + 672 | 0) + 16 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $196 = i64toi32_i32$0;
   i64toi32_i32$0 = $1 + 44 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $196;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($1 + 24 | 0) >> 2] = $2;
   i64toi32_i32$1 = $6$hi;
   i64toi32_i32$0 = $1;
   HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $6;
   HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 192 | 0) >> 0] = $4;
   i64toi32_i32$2 = i64toi32_i32$0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 672 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 676 | 0) >> 2] | 0;
   $205 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] = $205;
   HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = (i64toi32_i32$2 + 696 | 0) + 16 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $211 = i64toi32_i32$0;
   i64toi32_i32$0 = $1 + 68 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $211;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = ($1 + 696 | 0) + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $217 = i64toi32_i32$1;
   i64toi32_i32$1 = $1 + 60 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $217;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $8$hi;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 184 | 0) >> 2] = $8;
   HEAP32[(i64toi32_i32$1 + 188 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[(i64toi32_i32$1 + 76 | 0) >> 2] = $5;
   i64toi32_i32$0 = $7$hi;
   HEAP32[(i64toi32_i32$1 + 80 | 0) >> 2] = $7;
   HEAP32[(i64toi32_i32$1 + 84 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = i64toi32_i32$1;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 696 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 700 | 0) >> 2] | 0;
   $226 = i64toi32_i32$0;
   i64toi32_i32$0 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = $226;
   HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] = i64toi32_i32$1;
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3((i64toi32_i32$2 + 16 | 0) + 312 | 0 | 0, $0 + 312 | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
   memcpy(i64toi32_i32$2 + 344 | 0 | 0, i64toi32_i32$2 + 16 | 0 | 0, 328 | 0) | 0;
   $0 = $cardano_serialization_lib__Header_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h7c5802dbd37296c4(i64toi32_i32$2 + 344 | 0 | 0) | 0;
   global$0 = i64toi32_i32$2 + 720 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__TransactionWitnessSet___serialize__ha4e0dd8fca4a45ce($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $6 = 0, i64toi32_i32$4 = 0, i64toi32_i32$5 = 0, $5 = 0, $4 = 0, $7 = 0, $11 = 0, $12 = 0, $17$hi = 0, $22$hi = 0, $23$hi = 0, $27$hi = 0, $28$hi = 0, $32$hi = 0, $33$hi = 0, $38$hi = 0, $39$hi = 0, $43$hi = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  $11 = $3;
  $12 = $2;
  $4 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  i64toi32_i32$0 = 0;
  $17$hi = i64toi32_i32$0;
  $5 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$0 = 0;
  $22$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $17$hi;
  i64toi32_i32$2 = ($4 | 0) != (0 | 0);
  i64toi32_i32$1 = $22$hi;
  i64toi32_i32$3 = ($5 | 0) != (0 | 0);
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $23$hi = i64toi32_i32$5;
  i64toi32_i32$5 = 0;
  $27$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $23$hi;
  i64toi32_i32$0 = i64toi32_i32$4;
  i64toi32_i32$2 = $27$hi;
  i64toi32_i32$3 = (HEAP32[($1 + 24 | 0) >> 2] | 0 | 0) != (0 | 0);
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $28$hi = i64toi32_i32$4;
  i64toi32_i32$4 = 0;
  $32$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $28$hi;
  i64toi32_i32$5 = i64toi32_i32$1;
  i64toi32_i32$0 = $32$hi;
  i64toi32_i32$3 = (HEAP32[($1 + 36 | 0) >> 2] | 0 | 0) != (0 | 0);
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $33$hi = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  $38$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $33$hi;
  i64toi32_i32$4 = i64toi32_i32$2;
  i64toi32_i32$5 = $38$hi;
  i64toi32_i32$3 = (HEAPU8[($1 + 60 | 0) >> 0] | 0 | 0) != (3 | 0);
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $39$hi = i64toi32_i32$2;
  i64toi32_i32$2 = 0;
  $43$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $39$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$4 = $43$hi;
  i64toi32_i32$3 = (HEAP32[($1 + 64 | 0) >> 2] | 0 | 0) != (0 | 0);
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($11 | 0, $12 | 0, 5 | 0, i64toi32_i32$5 | 0, i64toi32_i32$0 | 0);
  $6 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           label$10 : {
            label$11 : {
             label$12 : {
              label$13 : {
               label$14 : {
                if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                 break label$14
                }
                $7 = $1 + 12 | 0;
                label$15 : {
                 if (!$5) {
                  break label$15
                 }
                 i64toi32_i32$0 = 0;
                 cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 0 | 0, i64toi32_i32$0 | 0);
                 $6 = 1;
                 if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                  break label$13
                 }
                 $cardano_serialization_lib__crypto__Vkeywitnesses_20as_20cbor_event__se__Serialize___serialize__h32c03934e8035b48($3 | 0, $1 | 0, $2 | 0);
                 if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                  break label$12
                 }
                 $4 = HEAP32[$7 >> 2] | 0;
                }
                label$16 : {
                 if (!$4) {
                  break label$16
                 }
                 i64toi32_i32$0 = 0;
                 cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 1 | 0, i64toi32_i32$0 | 0);
                 $6 = 1;
                 if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                  break label$11
                 }
                 cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__NativeScripts___serialize__hecc991a2909139b7($3 | 0, $7 | 0, $2 | 0);
                 if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                  break label$10
                 }
                }
                label$17 : {
                 $5 = $1 + 24 | 0;
                 if (!(HEAP32[$5 >> 2] | 0)) {
                  break label$17
                 }
                 i64toi32_i32$0 = 0;
                 cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 2 | 0, i64toi32_i32$0 | 0);
                 $6 = 1;
                 if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                  break label$9
                 }
                 $cardano_serialization_lib__crypto__BootstrapWitnesses_20as_20cbor_event__se__Serialize___serialize__h9f508575b17573f7($3 | 0, $5 | 0, $2 | 0);
                 if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                  break label$8
                 }
                }
                label$18 : {
                 $5 = $1 + 36 | 0;
                 if (!(HEAP32[$5 >> 2] | 0)) {
                  break label$18
                 }
                 i64toi32_i32$0 = 0;
                 cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 3 | 0, i64toi32_i32$0 | 0);
                 $6 = 1;
                 if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                  break label$7
                 }
                 $cardano_serialization_lib__plutus__PlutusScripts_20as_20cbor_event__se__Serialize___serialize__h460b1286d3728f21($3 | 0, $5 | 0, $2 | 0);
                 if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                  break label$6
                 }
                }
                label$19 : {
                 if ((HEAPU8[($1 + 60 | 0) >> 0] | 0 | 0) == (3 | 0)) {
                  break label$19
                 }
                 i64toi32_i32$0 = 0;
                 cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 4 | 0, i64toi32_i32$0 | 0);
                 $6 = 1;
                 if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                  break label$5
                 }
                 $cardano_serialization_lib__plutus__PlutusList_20as_20cbor_event__se__Serialize___serialize__h4fb04398ef3c9f58($3 | 0, $1 + 48 | 0 | 0, $2 | 0);
                 if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                  break label$4
                 }
                }
                label$20 : {
                 $1 = $1 + 64 | 0;
                 if (!(HEAP32[$1 >> 2] | 0)) {
                  break label$20
                 }
                 i64toi32_i32$0 = 0;
                 cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 5 | 0, i64toi32_i32$0 | 0);
                 $6 = 1;
                 if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                  break label$3
                 }
                 $cardano_serialization_lib__plutus__Redeemers_20as_20cbor_event__se__Serialize___serialize__h3e0a2f954a4fc936($3 | 0, $1 | 0, $2 | 0);
                 if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
                  break label$2
                 }
                }
                HEAP32[($0 + 4 | 0) >> 2] = $2;
                $6 = 0;
                break label$1;
               }
               memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
               break label$1;
              }
              memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
              break label$1;
             }
             memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
             $6 = 1;
             break label$1;
            }
            memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
            break label$1;
           }
           memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
           $6 = 1;
           break label$1;
          }
          memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
          break label$1;
         }
         memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
         $6 = 1;
         break label$1;
        }
        memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
        break label$1;
       }
       memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
       $6 = 1;
       break label$1;
      }
      memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
      break label$1;
     }
     memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
     $6 = 1;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $6 = 1;
  }
  HEAP32[$0 >> 2] = $6;
  global$0 = $3 + 48 | 0;
 }
 
 function num_bigint__biguint__convert__from_radix_digits_be__h923476663a064105($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, $5 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $9 = 0, $10 = 0, $7 = 0, $13 = 0, $11 = 0, i64toi32_i32$5 = 0, $13$hi = 0, $8 = 0, $14 = 0.0, i64toi32_i32$3 = 0, $6 = 0, $12$hi = 0, i64toi32_i32$4 = 0, $27 = 0, $12 = 0, $151 = 0, $153$hi = 0, $28 = 0, $155$hi = 0, $234 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  $5 = 0;
  label$1 : {
   $14 = Math_ceil(+log2(+(+($3 >>> 0))) * +($2 >>> 0) * .03125);
   if ($14 > -1.0 ^ 1 | 0) {
    break label$1
   }
   $5 = 0;
   if ($14 < 4294967296.0 ^ 1 | 0) {
    break label$1
   }
   $5 = ~~$14 >>> 0;
  }
  alloc__raw_vec__RawVec_T_2cA___allocate_in__hb0817f92bbb8999a($4 + 8 | 0 | 0, $5 | 0, 0 | 0);
  HEAP32[($4 + 24 | 0) >> 2] = 0;
  $6 = HEAP32[($4 + 12 | 0) >> 2] | 0;
  HEAP32[($4 + 20 | 0) >> 2] = $6;
  $7 = HEAP32[($4 + 8 | 0) >> 2] | 0;
  HEAP32[($4 + 16 | 0) >> 2] = $7;
  label$2 : {
   label$3 : {
    if ($3 >>> 0 >= 257 >>> 0) {
     break label$3
    }
    label$4 : {
     label$5 : {
      $5 = $3 << 3 | 0;
      $8 = HEAP32[($5 + 1080568 | 0) >> 2] | 0;
      if (!$8) {
       break label$5
      }
      $9 = ($2 >>> 0) % ($8 >>> 0) | 0;
      $10 = $9 ? $9 : $8;
      if ($10 >>> 0 > $2 >>> 0) {
       break label$4
      }
      i64toi32_i32$2 = $5 + 1080564 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = 0;
      $12 = i64toi32_i32$0;
      $12$hi = i64toi32_i32$1;
      $5 = $1 + $10 | 0;
      $9 = 0;
      $11 = $10;
      label$6 : while (1) {
       $9 = Math_imul($9, $3) + (HEAPU8[$1 >> 0] | 0) | 0;
       $1 = $1 + 1 | 0;
       $11 = $11 + -1 | 0;
       if ($11) {
        continue label$6
       }
       break label$6;
      };
      $10 = $2 - $10 | 0;
      $1 = 0;
      label$7 : {
       if ($6) {
        break label$7
       }
       alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h90c9768825cdae1b($4 + 16 | 0 | 0, 0 | 0, 1 | 0);
       $7 = HEAP32[($4 + 16 | 0) >> 2] | 0;
       $1 = HEAP32[($4 + 24 | 0) >> 2] | 0;
      }
      HEAP32[($7 + ($1 << 2 | 0) | 0) >> 2] = $9;
      $2 = (HEAP32[($4 + 24 | 0) >> 2] | 0) + 1 | 0;
      HEAP32[($4 + 24 | 0) >> 2] = $2;
      if (!$10) {
       break label$2
      }
      label$8 : while (1) {
       $9 = $10 >>> 0 > $8 >>> 0 ? $8 : $10;
       label$9 : {
        label$10 : {
         label$11 : {
          if (!$2) {
           break label$11
          }
          $7 = HEAP32[($4 + 16 | 0) >> 2] | 0;
          $11 = ($2 << 2 | 0) + $7 | 0;
          if (!(HEAP32[($11 + -4 | 0) >> 2] | 0)) {
           break label$10
          }
         }
         label$12 : {
          label$13 : {
           if ((HEAP32[($4 + 20 | 0) >> 2] | 0 | 0) == ($2 | 0)) {
            break label$13
           }
           $1 = $2;
           break label$12;
          }
          alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h90c9768825cdae1b($4 + 16 | 0 | 0, $2 | 0, 1 | 0);
          $1 = HEAP32[($4 + 24 | 0) >> 2] | 0;
         }
         $7 = HEAP32[($4 + 16 | 0) >> 2] | 0;
         HEAP32[($7 + ($1 << 2 | 0) | 0) >> 2] = 0;
         $2 = $1 + 1 | 0;
         HEAP32[($4 + 24 | 0) >> 2] = $2;
         label$14 : {
          if ($2 >>> 0 >= $1 >>> 0) {
           break label$14
          }
          $2 = 0;
          break label$9;
         }
         $11 = $7 + ($2 << 2 | 0) | 0;
        }
        i64toi32_i32$1 = 0;
        $13 = 0;
        $13$hi = i64toi32_i32$1;
        $1 = $7;
        label$15 : while (1) {
         $151 = $1;
         i64toi32_i32$2 = $1;
         i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
         i64toi32_i32$0 = 0;
         $153$hi = i64toi32_i32$0;
         i64toi32_i32$0 = $12$hi;
         i64toi32_i32$0 = $153$hi;
         $28 = i64toi32_i32$1;
         i64toi32_i32$1 = $12$hi;
         i64toi32_i32$1 = __wasm_i64_mul($28 | 0, i64toi32_i32$0 | 0, $12 | 0, i64toi32_i32$1 | 0) | 0;
         i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
         $155$hi = i64toi32_i32$0;
         i64toi32_i32$0 = $13$hi;
         i64toi32_i32$0 = $155$hi;
         i64toi32_i32$2 = i64toi32_i32$1;
         i64toi32_i32$1 = $13$hi;
         i64toi32_i32$3 = $13;
         i64toi32_i32$4 = i64toi32_i32$2 + $13 | 0;
         i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
         if (i64toi32_i32$4 >>> 0 < $13 >>> 0) {
          i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
         }
         $13 = i64toi32_i32$4;
         $13$hi = i64toi32_i32$5;
         HEAP32[$151 >> 2] = $13;
         i64toi32_i32$0 = $13;
         i64toi32_i32$2 = 0;
         i64toi32_i32$3 = 32;
         i64toi32_i32$1 = i64toi32_i32$3 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
          i64toi32_i32$2 = 0;
          $27 = i64toi32_i32$5 >>> i64toi32_i32$1 | 0;
         } else {
          i64toi32_i32$2 = i64toi32_i32$5 >>> i64toi32_i32$1 | 0;
          $27 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$1 | 0) | 0;
         }
         $13 = $27;
         $13$hi = i64toi32_i32$2;
         $1 = $1 + 4 | 0;
         if (($11 | 0) != ($1 | 0)) {
          continue label$15
         }
         break label$15;
        };
       }
       $10 = $10 - $9 | 0;
       $11 = $5 + $9 | 0;
       $1 = 0;
       label$16 : while (1) {
        $1 = Math_imul($1, $3) + (HEAPU8[$5 >> 0] | 0) | 0;
        $5 = $5 + 1 | 0;
        $9 = $9 + -1 | 0;
        if ($9) {
         continue label$16
        }
        break label$16;
       };
       HEAP32[($4 + 32 | 0) >> 2] = $1;
       num_bigint__biguint__addition__add2__h85496cf5b0a143eb($7 | 0, $2 | 0, $4 + 32 | 0 | 0, 1 | 0);
       $5 = $11;
       if ($10) {
        continue label$8
       }
       break label$2;
      };
     }
     core__panicking__panic__h2fd385a887c8bf13(1077984 | 0, 57 | 0, 1078316 | 0);
     abort();
    }
    core__panicking__panic__h2fd385a887c8bf13(1078144 | 0, 35 | 0, 1078180 | 0);
    abort();
   }
   core__panicking__panic_bounds_check__h808b524af17640b1($3 | 0, 257 | 0, 1078476 | 0);
   abort();
  }
  $1 = HEAP32[(($4 + 16 | 0) + 8 | 0) >> 2] | 0;
  HEAP32[(($4 + 32 | 0) + 8 | 0) >> 2] = $1;
  i64toi32_i32$5 = $4;
  i64toi32_i32$2 = HEAP32[($4 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($4 + 20 | 0) >> 2] | 0;
  $13 = i64toi32_i32$2;
  $13$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $4;
  HEAP32[($4 + 32 | 0) >> 2] = $13;
  HEAP32[($4 + 36 | 0) >> 2] = i64toi32_i32$0;
  label$17 : {
   label$18 : {
    if ($1) {
     break label$18
    }
    $1 = 0;
    break label$17;
   }
   i64toi32_i32$0 = $13$hi;
   $5 = (($1 << 2 | 0) + $13 | 0) + -4 | 0;
   label$19 : {
    label$20 : while (1) {
     if (HEAP32[$5 >> 2] | 0) {
      break label$19
     }
     $5 = $5 + -4 | 0;
     $1 = $1 + -1 | 0;
     if ($1) {
      continue label$20
     }
     break label$20;
    };
    $1 = 0;
   }
   HEAP32[($4 + 40 | 0) >> 2] = $1;
  }
  label$21 : {
   $5 = HEAP32[($4 + 36 | 0) >> 2] | 0;
   if ($1 >>> 0 >= ($5 >>> 2 | 0) >>> 0) {
    break label$21
   }
   if ($5 >>> 0 <= $1 >>> 0) {
    break label$21
   }
   alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($4 + 32 | 0 | 0, $1 | 0);
  }
  i64toi32_i32$5 = $4;
  i64toi32_i32$0 = HEAP32[($4 + 32 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[($4 + 36 | 0) >> 2] | 0;
  $234 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $234;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[(($4 + 32 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $4 + 48 | 0;
 }
 
 function std__sync__once__Once__call_inner__hc44ad7f626385660($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $6 = 0, $4 = 0, $7 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $5 = 0, $8 = 0;
  $4 = global$0 - 32 | 0;
  global$0 = $4;
  $5 = $4 + 8 | 0 | 2 | 0;
  $6 = HEAP32[$0 >> 2] | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         if ($1) {
          break label$7
         }
         break label$6;
        }
        label$8 : while (1) {
         label$9 : {
          label$10 : {
           $1 = $6;
           switch ($6 | 0) {
           case 3:
            break label$4;
           case 0:
           case 1:
            break label$9;
           default:
            break label$10;
           };
          }
          if (($1 & 3 | 0 | 0) != (2 | 0)) {
           break label$1
          }
          label$11 : {
           label$12 : while (1) {
            $6 = $1;
            label$13 : {
             if ((HEAP32[(0 + 1177872 | 0) >> 2] | 0 | 0) == (1 | 0)) {
              break label$13
             }
             i64toi32_i32$1 = 0;
             i64toi32_i32$0 = 0;
             HEAP32[(i64toi32_i32$1 + 1177872 | 0) >> 2] = 1;
             HEAP32[(i64toi32_i32$1 + 1177876 | 0) >> 2] = i64toi32_i32$0;
             HEAP32[(0 + 1177880 | 0) >> 2] = 0;
            }
            $7 = std__sys_common__thread_info__ThreadInfo__with___7b_7bclosure_7d_7d__h1dbe3ea3b6375635(1177876 | 0) | 0;
            $1 = HEAP32[$0 >> 2] | 0;
            $8 = ($1 | 0) == ($6 | 0);
            HEAP32[$0 >> 2] = $8 ? $5 : $1;
            HEAP8[($4 + 16 | 0) >> 0] = 0;
            HEAP32[($4 + 8 | 0) >> 2] = $7;
            HEAP32[($4 + 12 | 0) >> 2] = $6 & -4 | 0;
            label$14 : {
             if ($8) {
              break label$14
             }
             label$15 : {
              $6 = HEAP32[($4 + 8 | 0) >> 2] | 0;
              if (!$6) {
               break label$15
              }
              $7 = HEAP32[$6 >> 2] | 0;
              HEAP32[$6 >> 2] = $7 + -1 | 0;
              if (($7 | 0) != (1 | 0)) {
               break label$15
              }
              alloc__sync__Arc_T___drop_slow__h1342fde892a03e74(HEAP32[($4 + 8 | 0) >> 2] | 0 | 0);
             }
             if (($1 & 3 | 0 | 0) == (2 | 0)) {
              continue label$12
             }
             break label$11;
            }
            break label$12;
           };
           label$16 : {
            if (HEAPU8[($4 + 16 | 0) >> 0] | 0) {
             break label$16
            }
            label$17 : while (1) {
             std__thread__park__h244f16c0d88cd65a();
             if (!(HEAPU8[($4 + 16 | 0) >> 0] | 0)) {
              continue label$17
             }
             break label$17;
            };
           }
           $6 = HEAP32[($4 + 8 | 0) >> 2] | 0;
           if (!$6) {
            break label$11
           }
           $1 = HEAP32[$6 >> 2] | 0;
           HEAP32[$6 >> 2] = $1 + -1 | 0;
           if (($1 | 0) != (1 | 0)) {
            break label$11
           }
           alloc__sync__Arc_T___drop_slow__h1342fde892a03e74(HEAP32[($4 + 8 | 0) >> 2] | 0 | 0);
          }
          $6 = HEAP32[$0 >> 2] | 0;
          continue label$8;
         }
         $6 = HEAP32[$0 >> 2] | 0;
         $7 = ($6 | 0) == ($1 | 0);
         HEAP32[$0 >> 2] = $7 ? 2 : $6;
         if (!$7) {
          continue label$8
         }
         break label$5;
        };
       }
       label$18 : while (1) {
        label$19 : {
         label$20 : {
          label$21 : {
           label$22 : {
            switch ($6 | 0) {
            case 0:
             $6 = HEAP32[$0 >> 2] | 0;
             HEAP32[$0 >> 2] = $6 ? $6 : 2;
             if ($6) {
              continue label$18
             }
             $1 = 0;
             break label$5;
            default:
             if (($6 & 3 | 0 | 0) != (2 | 0)) {
              break label$1
             }
             label$25 : while (1) {
              $1 = $6;
              label$26 : {
               if ((HEAP32[(0 + 1177872 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                break label$26
               }
               i64toi32_i32$1 = 0;
               i64toi32_i32$0 = 0;
               HEAP32[(i64toi32_i32$1 + 1177872 | 0) >> 2] = 1;
               HEAP32[(i64toi32_i32$1 + 1177876 | 0) >> 2] = i64toi32_i32$0;
               HEAP32[(0 + 1177880 | 0) >> 2] = 0;
              }
              $7 = std__sys_common__thread_info__ThreadInfo__with___7b_7bclosure_7d_7d__h1dbe3ea3b6375635(1177876 | 0) | 0;
              $6 = HEAP32[$0 >> 2] | 0;
              HEAP32[$0 >> 2] = ($6 | 0) == ($1 | 0) ? $5 : $6;
              HEAP8[($4 + 16 | 0) >> 0] = 0;
              HEAP32[($4 + 8 | 0) >> 2] = $7;
              HEAP32[($4 + 12 | 0) >> 2] = $1 & -4 | 0;
              label$27 : {
               if (($6 | 0) != ($1 | 0)) {
                break label$27
               }
               if (!(HEAPU8[($4 + 16 | 0) >> 0] | 0)) {
                break label$21
               }
               break label$20;
              }
              label$28 : {
               $1 = HEAP32[($4 + 8 | 0) >> 2] | 0;
               if (!$1) {
                break label$28
               }
               $7 = HEAP32[$1 >> 2] | 0;
               HEAP32[$1 >> 2] = $7 + -1 | 0;
               if (($7 | 0) != (1 | 0)) {
                break label$28
               }
               alloc__sync__Arc_T___drop_slow__h1342fde892a03e74(HEAP32[($4 + 8 | 0) >> 2] | 0 | 0);
              }
              if (($6 & 3 | 0 | 0) == (2 | 0)) {
               continue label$25
              }
              break label$19;
             };
            case 1:
             break label$22;
            case 3:
             break label$4;
            };
           }
           std__panicking__begin_panic__h7867d4da632f3661(1144040 | 0, 42 | 0, 1144084 | 0);
           abort();
          }
          label$29 : while (1) {
           std__thread__park__h244f16c0d88cd65a();
           if (!(HEAPU8[($4 + 16 | 0) >> 0] | 0)) {
            continue label$29
           }
           break label$29;
          };
         }
         $6 = HEAP32[($4 + 8 | 0) >> 2] | 0;
         if (!$6) {
          break label$19
         }
         $1 = HEAP32[$6 >> 2] | 0;
         HEAP32[$6 >> 2] = $1 + -1 | 0;
         if (($1 | 0) != (1 | 0)) {
          break label$19
         }
         alloc__sync__Arc_T___drop_slow__h1342fde892a03e74(HEAP32[($4 + 8 | 0) >> 2] | 0 | 0);
        }
        $6 = HEAP32[$0 >> 2] | 0;
        continue label$18;
       };
      }
      HEAP8[($4 + 12 | 0) >> 0] = ($1 | 0) == (1 | 0);
      HEAP32[($4 + 8 | 0) >> 2] = 3;
      FUNCTION_TABLE[HEAP32[($3 + 12 | 0) >> 2] | 0 | 0]($2, $4 + 8 | 0);
      $6 = HEAP32[$0 >> 2] | 0;
      HEAP32[$0 >> 2] = HEAP32[($4 + 8 | 0) >> 2] | 0;
      $0 = $6 & 3 | 0;
      HEAP32[($4 + 4 | 0) >> 2] = $0;
      if (($0 | 0) != (2 | 0)) {
       break label$3
      }
      $0 = $6 & -4 | 0;
      if (!$0) {
       break label$4
      }
      label$30 : while (1) {
       $6 = HEAP32[$0 >> 2] | 0;
       HEAP32[$0 >> 2] = 0;
       if (!$6) {
        break label$2
       }
       $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
       HEAP8[($0 + 8 | 0) >> 0] = 1;
       std__sys_common__thread_parker__generic__Parker__unpark__h3b45d170e4cad40d($6 + 24 | 0 | 0);
       $0 = HEAP32[$6 >> 2] | 0;
       HEAP32[$6 >> 2] = $0 + -1 | 0;
       label$31 : {
        if (($0 | 0) != (1 | 0)) {
         break label$31
        }
        alloc__sync__Arc_T___drop_slow__h1342fde892a03e74($6 | 0);
       }
       $0 = $1;
       if ($0) {
        continue label$30
       }
       break label$30;
      };
     }
     global$0 = $4 + 32 | 0;
     return;
    }
    HEAP32[($4 + 8 | 0) >> 2] = 0;
    core__panicking__assert_failed__h26fc3570a5d27733($4 + 4 | 0 | 0, $4 + 8 | 0 | 0, 1144104 | 0);
    abort();
   }
   core__panicking__panic__h2fd385a887c8bf13(1142444 | 0, 43 | 0, 1144120 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1143964 | 0, 57 | 0, 1144024 | 0);
  abort();
 }
 
 function core__unicode__printable__is_printable__h052c3c4a29b5e66a($0) {
  $0 = $0 | 0;
  var $2 = 0, $3 = 0, $1 = 0, $6 = 0, $5 = 0, $4 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           if ($0 >>> 0 < 65536 >>> 0) {
            break label$9
           }
           if ($0 >>> 0 < 131072 >>> 0) {
            break label$8
           }
           $1 = 0;
           if (($0 + -201547 | 0) >>> 0 < 716213 >>> 0) {
            break label$7
           }
           if (($0 + -195102 | 0) >>> 0 < 1506 >>> 0) {
            break label$7
           }
           if (($0 + -191457 | 0) >>> 0 < 3103 >>> 0) {
            break label$7
           }
           if (($0 + -183970 | 0) >>> 0 < 14 >>> 0) {
            break label$7
           }
           if (($0 & 2097150 | 0 | 0) == (178206 | 0)) {
            break label$7
           }
           if (($0 + -173790 | 0) >>> 0 < 34 >>> 0) {
            break label$7
           }
           if (($0 + -177973 | 0) >>> 0 < 11 >>> 0) {
            break label$7
           }
           return $0 >>> 0 < 918e3 >>> 0 | 0;
          }
          $2 = 1151548;
          $3 = 0;
          $4 = ($0 >>> 8 | 0) & 255 | 0;
          label$10 : {
           label$11 : while (1) {
            $5 = $2 + 2 | 0;
            $1 = HEAPU8[($2 + 1 | 0) >> 0] | 0;
            $6 = $3 + $1 | 0;
            label$12 : {
             $2 = HEAPU8[$2 >> 0] | 0;
             if (($2 | 0) == ($4 | 0)) {
              break label$12
             }
             if ($2 >>> 0 > $4 >>> 0) {
              break label$10
             }
             $3 = $6;
             $2 = $5;
             if (($2 | 0) != (1151630 | 0)) {
              continue label$11
             }
             break label$10;
            }
            if ($6 >>> 0 < $3 >>> 0) {
             break label$6
            }
            if ($6 >>> 0 > 290 >>> 0) {
             break label$5
            }
            $2 = $3 + 1151630 | 0;
            label$13 : {
             label$14 : while (1) {
              if (!$1) {
               break label$13
              }
              $1 = $1 + -1 | 0;
              $3 = HEAPU8[$2 >> 0] | 0;
              $2 = $2 + 1 | 0;
              if (($3 | 0) != ($0 & 255 | 0 | 0)) {
               continue label$14
              }
              break label$14;
             };
             $1 = 0;
             break label$7;
            }
            $3 = $6;
            $2 = $5;
            if (($2 | 0) != (1151630 | 0)) {
             continue label$11
            }
            break label$11;
           };
          }
          $0 = $0 & 65535 | 0;
          $2 = 1151920;
          $1 = 1;
          label$15 : while (1) {
           $6 = $2 + 1 | 0;
           label$16 : {
            label$17 : {
             $3 = HEAPU8[$2 >> 0] | 0;
             $5 = ($3 << 24 | 0) >> 24 | 0;
             if (($5 | 0) < (0 | 0)) {
              break label$17
             }
             $2 = $6;
             break label$16;
            }
            if (($6 | 0) == (1152229 | 0)) {
             break label$4
            }
            $3 = ($5 & 127 | 0) << 8 | 0 | (HEAPU8[($2 + 1 | 0) >> 0] | 0) | 0;
            $2 = $2 + 2 | 0;
           }
           $0 = $0 - $3 | 0;
           if (($0 | 0) < (0 | 0)) {
            break label$7
           }
           $1 = $1 ^ 1 | 0;
           if (($2 | 0) != (1152229 | 0)) {
            continue label$15
           }
           break label$7;
          };
         }
         $2 = 1152229;
         $3 = 0;
         $4 = ($0 >>> 8 | 0) & 255 | 0;
         label$18 : {
          label$19 : while (1) {
           $5 = $2 + 2 | 0;
           $1 = HEAPU8[($2 + 1 | 0) >> 0] | 0;
           $6 = $3 + $1 | 0;
           label$20 : {
            $2 = HEAPU8[$2 >> 0] | 0;
            if (($2 | 0) == ($4 | 0)) {
             break label$20
            }
            if ($2 >>> 0 > $4 >>> 0) {
             break label$18
            }
            $3 = $6;
            $2 = $5;
            if (($2 | 0) != (1152305 | 0)) {
             continue label$19
            }
            break label$18;
           }
           if ($6 >>> 0 < $3 >>> 0) {
            break label$3
           }
           if ($6 >>> 0 > 175 >>> 0) {
            break label$2
           }
           $2 = $3 + 1152305 | 0;
           label$21 : {
            label$22 : while (1) {
             if (!$1) {
              break label$21
             }
             $1 = $1 + -1 | 0;
             $3 = HEAPU8[$2 >> 0] | 0;
             $2 = $2 + 1 | 0;
             if (($3 | 0) != ($0 & 255 | 0 | 0)) {
              continue label$22
             }
             break label$22;
            };
            $1 = 0;
            break label$7;
           }
           $3 = $6;
           $2 = $5;
           if (($2 | 0) != (1152305 | 0)) {
            continue label$19
           }
           break label$19;
          };
         }
         $0 = $0 & 65535 | 0;
         $2 = 1152480;
         $1 = 1;
         label$23 : while (1) {
          $6 = $2 + 1 | 0;
          label$24 : {
           label$25 : {
            $3 = HEAPU8[$2 >> 0] | 0;
            $5 = ($3 << 24 | 0) >> 24 | 0;
            if (($5 | 0) < (0 | 0)) {
             break label$25
            }
            $2 = $6;
            break label$24;
           }
           if (($6 | 0) == (1152899 | 0)) {
            break label$1
           }
           $3 = ($5 & 127 | 0) << 8 | 0 | (HEAPU8[($2 + 1 | 0) >> 0] | 0) | 0;
           $2 = $2 + 2 | 0;
          }
          $0 = $0 - $3 | 0;
          if (($0 | 0) < (0 | 0)) {
           break label$7
          }
          $1 = $1 ^ 1 | 0;
          if (($2 | 0) != (1152899 | 0)) {
           continue label$23
          }
          break label$23;
         };
        }
        return $1 & 1 | 0 | 0;
       }
       core__slice__index__slice_index_order_fail__h71e247dec3f266ff($3 | 0, $6 | 0, 1151516 | 0);
       abort();
      }
      core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($6 | 0, 290 | 0, 1151516 | 0);
      abort();
     }
     core__panicking__panic__h2fd385a887c8bf13(1149461 | 0, 43 | 0, 1151532 | 0);
     abort();
    }
    core__slice__index__slice_index_order_fail__h71e247dec3f266ff($3 | 0, $6 | 0, 1151516 | 0);
    abort();
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($6 | 0, 175 | 0, 1151516 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1149461 | 0, 43 | 0, 1151532 | 0);
  abort();
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__RelayEnum___deserialize__hd3d69580361177a1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $4 = 0, $4$hi = 0, $5 = 0, $5$hi = 0, $3 = 0, $33 = 0, $34 = 0, $35 = 0, $36 = 0, $37 = 0, $38 = 0, $39 = 0, $41 = 0, $42 = 0, $43 = 0, $40 = 0, $46 = 0, $64 = 0, $68 = 0, $117 = 0, $117$hi = 0, $120 = 0, $120$hi = 0, $124$hi = 0, $126$hi = 0, $128$hi = 0, $131 = 0, $131$hi = 0, $148 = 0, $154 = 0, $158 = 0, $193 = 0, $197 = 0, $203 = 0, $209 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 32 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 40 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 44 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       i64toi32_i32$2 = $2;
       i64toi32_i32$1 = HEAP32[($2 + 32 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[($2 + 36 | 0) >> 2] | 0;
       i64toi32_i32$2 = i64toi32_i32$1;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 1;
       if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
        break label$5
       }
       i64toi32_i32$2 = $4$hi;
       i64toi32_i32$0 = i64toi32_i32$2;
       cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__RelayEnum___deserialize_as_embedded_group__he19ef5d468816ea3($2 + 32 | 0 | 0, $1 | 0, $4 | 0, i64toi32_i32$0 | 0, $4 | 0, i64toi32_i32$0 | 0);
       label$6 : {
        label$7 : {
         label$8 : {
          i64toi32_i32$3 = $4;
          i64toi32_i32$2 = 0;
          i64toi32_i32$1 = 1;
          if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) | 0) {
           break label$8
          }
          cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 128 | 0 | 0, $1 | 0);
          $3 = HEAPU8[($2 + 136 | 0) >> 0] | 0;
          i64toi32_i32$1 = $2;
          i64toi32_i32$3 = HEAP32[($2 + 128 | 0) >> 2] | 0;
          i64toi32_i32$0 = HEAP32[($2 + 132 | 0) >> 2] | 0;
          i64toi32_i32$1 = i64toi32_i32$3;
          i64toi32_i32$3 = 0;
          i64toi32_i32$2 = 1;
          if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) | 0) {
           break label$7
          }
          $1 = 5;
          if (($3 & 255 | 0 | 0) != (5 | 0)) {
           break label$6
          }
         }
         i64toi32_i32$2 = $2 + 72 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $40 = i64toi32_i32$1;
         i64toi32_i32$1 = ($2 + 8 | 0) + 8 | 0;
         HEAP32[i64toi32_i32$1 >> 2] = $40;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$2 = $2 + 80 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $46 = i64toi32_i32$0;
         i64toi32_i32$0 = ($2 + 8 | 0) + 16 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $46;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         HEAP32[(($2 + 128 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 100 | 0) >> 2] | 0;
         HEAP32[($2 + 104 | 0) >> 2] = HEAPU8[($2 + 41 | 0) >> 0] | 0 | ((HEAPU8[($2 + 42 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 43 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 44 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $33 = ($2 + 32 | 0) + 12 | 0;
         $34 = HEAPU8[$33 >> 0] | 0 | ((HEAPU8[($33 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($33 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($33 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[($2 + 107 | 0) >> 0] = $34;
         HEAP8[($2 + 108 | 0) >> 0] = $34 >>> 8 | 0;
         HEAP8[($2 + 109 | 0) >> 0] = $34 >>> 16 | 0;
         HEAP8[($2 + 110 | 0) >> 0] = $34 >>> 24 | 0;
         i64toi32_i32$2 = $2 + 64 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $64 = i64toi32_i32$1;
         i64toi32_i32$1 = $2;
         HEAP32[($2 + 8 | 0) >> 2] = $64;
         HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$2 = $2 + 92 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $68 = i64toi32_i32$0;
         i64toi32_i32$0 = $2;
         HEAP32[($2 + 128 | 0) >> 2] = $68;
         HEAP32[($2 + 132 | 0) >> 2] = i64toi32_i32$1;
         $1 = HEAPU8[(($2 + 32 | 0) + 8 | 0) >> 0] | 0;
         i64toi32_i32$2 = ($2 + 32 | 0) + 16 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $4 = i64toi32_i32$1;
         $4$hi = i64toi32_i32$0;
         i64toi32_i32$2 = ($2 + 32 | 0) + 24 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $5 = i64toi32_i32$0;
         $5$hi = i64toi32_i32$1;
         if ((HEAP32[($2 + 32 | 0) >> 2] | 0 | 0) != (1 | 0)) {
          break label$4
         }
         $3 = HEAP32[($2 + 88 | 0) >> 2] | 0;
         break label$2;
        }
        i64toi32_i32$2 = $2 + 160 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $4 = i64toi32_i32$1;
        $4$hi = i64toi32_i32$0;
        i64toi32_i32$1 = ($2 + 104 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $4;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = $2 + 168 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $5 = i64toi32_i32$0;
        $5$hi = i64toi32_i32$1;
        i64toi32_i32$0 = ($2 + 104 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $5;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$1 = $4$hi;
        i64toi32_i32$0 = ($2 + 8 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $4;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$1 = $5$hi;
        i64toi32_i32$0 = ($2 + 8 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $5;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$2 = $2 + 152 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $4 = i64toi32_i32$1;
        $4$hi = i64toi32_i32$0;
        i64toi32_i32$1 = $2;
        HEAP32[($2 + 104 | 0) >> 2] = $4;
        HEAP32[($2 + 108 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$1 = $2;
        HEAP32[($2 + 8 | 0) >> 2] = $4;
        HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAPU8[($2 + 137 | 0) >> 0] | 0 | ((HEAPU8[($2 + 138 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 139 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 140 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$1 = 0;
        $117 = i64toi32_i32$0;
        $117$hi = i64toi32_i32$1;
        i64toi32_i32$2 = $2 + 141 | 0;
        i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
        i64toi32_i32$0 = 0;
        $120 = i64toi32_i32$1;
        $120$hi = i64toi32_i32$0;
        i64toi32_i32$2 = $2 + 143 | 0;
        i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
        i64toi32_i32$1 = 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 16;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
         $41 = 0;
        } else {
         i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
         $41 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        }
        $124$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $120$hi;
        i64toi32_i32$1 = $120;
        i64toi32_i32$2 = $124$hi;
        i64toi32_i32$3 = $41;
        i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
        i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 32;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
         $42 = 0;
        } else {
         i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
         $42 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        }
        $126$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $117$hi;
        i64toi32_i32$2 = $117;
        i64toi32_i32$0 = $126$hi;
        i64toi32_i32$3 = $42;
        i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
        i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
        i64toi32_i32$2 = 0;
        i64toi32_i32$3 = 8;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
         $43 = 0;
        } else {
         i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
         $43 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        }
        $128$hi = i64toi32_i32$2;
        i64toi32_i32$2 = 0;
        i64toi32_i32$0 = $3;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 255;
        i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
        $131 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
        $131$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $128$hi;
        i64toi32_i32$2 = $43;
        i64toi32_i32$0 = $131$hi;
        i64toi32_i32$3 = $131;
        i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
        $4 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
        $4$hi = i64toi32_i32$0;
        i64toi32_i32$1 = ($2 + 128 | 0) + 16 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
        $5 = i64toi32_i32$0;
        $5$hi = i64toi32_i32$2;
        $1 = 2;
       }
       label$9 : {
        if (HEAP32[($2 + 32 | 0) >> 2] | 0) {
         break label$9
        }
        core__ptr__drop_in_place_cardano_serialization_lib__RelayEnum___h969d1fa65912b879($2 + 32 | 0 | 4 | 0 | 0);
        break label$3;
       }
       core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9($2 + 40 | 0 | 0);
       break label$3;
      }
      i64toi32_i32$1 = $2 + 64 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $148 = i64toi32_i32$2;
      i64toi32_i32$2 = $2 + 16 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $148;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$1 = $2 + 72 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $154 = i64toi32_i32$0;
      i64toi32_i32$0 = ($2 + 8 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $154;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$1 = $2 + 56 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $158 = i64toi32_i32$2;
      i64toi32_i32$2 = $2;
      HEAP32[($2 + 8 | 0) >> 2] = $158;
      HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$1 = ($2 + 32 | 0) + 16 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $5 = i64toi32_i32$0;
      $5$hi = i64toi32_i32$2;
      $1 = 2;
      break label$3;
     }
     HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($2 + 36 | 0) >> 2] | 0;
     $35 = HEAP32[($2 + 104 | 0) >> 2] | 0;
     HEAP8[($0 + 9 | 0) >> 0] = $35;
     HEAP8[($0 + 10 | 0) >> 0] = $35 >>> 8 | 0;
     HEAP8[($0 + 11 | 0) >> 0] = $35 >>> 16 | 0;
     HEAP8[($0 + 12 | 0) >> 0] = $35 >>> 24 | 0;
     HEAP8[($0 + 8 | 0) >> 0] = $1;
     $36 = $0 + 12 | 0;
     $37 = HEAPU8[($2 + 107 | 0) >> 0] | 0 | ((HEAPU8[($2 + 108 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 109 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 110 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[$36 >> 0] = $37;
     HEAP8[($36 + 1 | 0) >> 0] = $37 >>> 8 | 0;
     HEAP8[($36 + 2 | 0) >> 0] = $37 >>> 16 | 0;
     HEAP8[($36 + 3 | 0) >> 0] = $37 >>> 24 | 0;
     i64toi32_i32$2 = $5$hi;
     i64toi32_i32$0 = $0 + 24 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $5;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$2 = $4$hi;
     i64toi32_i32$0 = $0 + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $4;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
     $1 = 0;
     break label$1;
    }
    $3 = 0;
   }
   i64toi32_i32$2 = $5$hi;
   i64toi32_i32$0 = ($2 + 32 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $5;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$2 = $4$hi;
   i64toi32_i32$0 = ($2 + 32 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $4;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$1 = $2;
   i64toi32_i32$2 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $193 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 56 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $193;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$1 = $2;
   i64toi32_i32$0 = HEAP32[($2 + 128 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($2 + 132 | 0) >> 2] | 0;
   $197 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 84 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $197;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$1 = ($2 + 8 | 0) + 8 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $203 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 64 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $203;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$1 = ($2 + 8 | 0) + 16 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $209 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 72 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $209;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   HEAP32[($2 + 92 | 0) >> 2] = HEAP32[(($2 + 128 | 0) + 8 | 0) >> 2] | 0;
   HEAP8[($2 + 32 | 0) >> 0] = $1;
   $38 = HEAP32[($2 + 104 | 0) >> 2] | 0;
   HEAP8[($2 + 33 | 0) >> 0] = $38;
   HEAP8[($2 + 34 | 0) >> 0] = $38 >>> 8 | 0;
   HEAP8[($2 + 35 | 0) >> 0] = $38 >>> 16 | 0;
   HEAP8[($2 + 36 | 0) >> 0] = $38 >>> 24 | 0;
   $39 = HEAPU8[($2 + 107 | 0) >> 0] | 0 | ((HEAPU8[($2 + 108 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 109 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 110 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[($2 + 36 | 0) >> 0] = $39;
   HEAP8[($2 + 37 | 0) >> 0] = $39 >>> 8 | 0;
   HEAP8[($2 + 38 | 0) >> 0] = $39 >>> 16 | 0;
   HEAP8[($2 + 39 | 0) >> 0] = $39 >>> 24 | 0;
   HEAP32[($2 + 80 | 0) >> 2] = $3;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 32 | 0 | 0, 1051469 | 0, 9 | 0);
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__MoveInstantaneousRewardsCert___deserialize__h5080adfd24aaf632($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, $7 = 0, $7$hi = 0, $8 = 0, $3 = 0, $8$hi = 0, $39 = 0, $40 = 0, $41 = 0, $42 = 0, $43 = 0, $44 = 0, $46 = 0, $47 = 0, $48 = 0, $49 = 0, $4 = 0, $5 = 0, $6 = 0, $50 = 0, $51 = 0, $52 = 0, $45 = 0, $53 = 0, $66 = 0, $9 = 0, $9$hi = 0, $119 = 0, $119$hi = 0, $122 = 0, $122$hi = 0, $126$hi = 0, $128$hi = 0, $130$hi = 0, $133 = 0, $133$hi = 0, $145 = 0, $151 = 0, $155 = 0, $180 = 0, $187 = 0, $191 = 0, $203 = 0, $215 = 0, $221 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 32 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
       i64toi32_i32$2 = i64toi32_i32$1;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 1;
       if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
        break label$5
       }
       i64toi32_i32$2 = $7$hi;
       i64toi32_i32$0 = i64toi32_i32$2;
       cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__MoveInstantaneousRewardsCert___deserialize_as_embedded_group__ha238bf99690081e0($2 + 32 | 0 | 0, $1 | 0, $7 | 0, i64toi32_i32$2 | 0, $7 | 0, i64toi32_i32$2 | 0);
       label$6 : {
        label$7 : {
         label$8 : {
          i64toi32_i32$0 = i64toi32_i32$2;
          i64toi32_i32$0 = i64toi32_i32$2;
          i64toi32_i32$3 = $7;
          i64toi32_i32$2 = 0;
          i64toi32_i32$1 = 1;
          if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) | 0) {
           break label$8
          }
          cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 128 | 0 | 0, $1 | 0);
          $3 = HEAPU8[($2 + 136 | 0) >> 0] | 0;
          i64toi32_i32$1 = $2;
          i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 128 | 0) >> 2] | 0;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] | 0;
          i64toi32_i32$1 = i64toi32_i32$3;
          i64toi32_i32$3 = 0;
          i64toi32_i32$2 = 1;
          if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) | 0) {
           break label$7
          }
          $1 = 5;
          if (($3 & 255 | 0 | 0) != (5 | 0)) {
           break label$6
          }
         }
         $4 = $2 + 16 | 0;
         i64toi32_i32$2 = ($2 + 32 | 0) + 40 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $45 = i64toi32_i32$1;
         i64toi32_i32$1 = $4;
         HEAP32[i64toi32_i32$1 >> 2] = $45;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
         $5 = ($2 + 8 | 0) + 16 | 0;
         i64toi32_i32$2 = ($2 + 32 | 0) + 48 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $53 = i64toi32_i32$0;
         i64toi32_i32$0 = $5;
         HEAP32[i64toi32_i32$0 >> 2] = $53;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         HEAP32[($2 + 128 | 0) >> 2] = HEAPU8[($2 + 41 | 0) >> 0] | 0 | ((HEAPU8[($2 + 42 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 43 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 44 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $39 = ($2 + 32 | 0) + 12 | 0;
         $40 = HEAPU8[$39 >> 0] | 0 | ((HEAPU8[($39 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($39 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($39 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[($2 + 131 | 0) >> 0] = $40;
         HEAP8[($2 + 132 | 0) >> 0] = $40 >>> 8 | 0;
         HEAP8[($2 + 133 | 0) >> 0] = $40 >>> 16 | 0;
         HEAP8[($2 + 134 | 0) >> 0] = $40 >>> 24 | 0;
         i64toi32_i32$2 = ($2 + 32 | 0) + 32 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $66 = i64toi32_i32$1;
         i64toi32_i32$1 = $2;
         HEAP32[($2 + 8 | 0) >> 2] = $66;
         HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$2 = ($2 + 32 | 0) + 16 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $7 = i64toi32_i32$0;
         $7$hi = i64toi32_i32$1;
         i64toi32_i32$2 = ($2 + 32 | 0) + 24 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $8 = i64toi32_i32$1;
         $8$hi = i64toi32_i32$0;
         $3 = HEAP32[(($2 + 32 | 0) + 56 | 0) >> 2] | 0;
         $1 = HEAPU8[($2 + 40 | 0) >> 0] | 0;
         $6 = HEAP32[($2 + 92 | 0) >> 2] | 0;
         i64toi32_i32$2 = $2;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
         i64toi32_i32$2 = i64toi32_i32$0;
         i64toi32_i32$0 = 0;
         i64toi32_i32$3 = 1;
         if ((i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$0 | 0) | 0) {
          break label$4
         }
         i64toi32_i32$3 = $2 + 96 | 0;
         i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $9 = i64toi32_i32$2;
         $9$hi = i64toi32_i32$1;
         break label$2;
        }
        i64toi32_i32$3 = $2 + 160 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $7 = i64toi32_i32$1;
        $7$hi = i64toi32_i32$2;
        i64toi32_i32$1 = ($2 + 104 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $7;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
        i64toi32_i32$3 = $2 + 168 | 0;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $8 = i64toi32_i32$2;
        $8$hi = i64toi32_i32$1;
        i64toi32_i32$2 = ($2 + 104 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$2 >> 2] = $8;
        HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$1 = $7$hi;
        i64toi32_i32$2 = ($2 + 8 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$2 >> 2] = $7;
        HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$1 = $8$hi;
        i64toi32_i32$2 = ($2 + 8 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$2 >> 2] = $8;
        HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$3 = $2 + 152 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $7 = i64toi32_i32$1;
        $7$hi = i64toi32_i32$2;
        i64toi32_i32$1 = $2;
        HEAP32[($2 + 104 | 0) >> 2] = $7;
        HEAP32[($2 + 108 | 0) >> 2] = i64toi32_i32$2;
        i64toi32_i32$1 = $2;
        HEAP32[($2 + 8 | 0) >> 2] = $7;
        HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$2;
        i64toi32_i32$3 = $2;
        i64toi32_i32$2 = HEAPU8[($2 + 137 | 0) >> 0] | 0 | ((HEAPU8[($2 + 138 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 139 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 140 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$1 = 0;
        $119 = i64toi32_i32$2;
        $119$hi = i64toi32_i32$1;
        i64toi32_i32$3 = $2 + 141 | 0;
        i64toi32_i32$1 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
        i64toi32_i32$2 = 0;
        $122 = i64toi32_i32$1;
        $122$hi = i64toi32_i32$2;
        i64toi32_i32$3 = $2 + 143 | 0;
        i64toi32_i32$2 = HEAPU8[i64toi32_i32$3 >> 0] | 0;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = i64toi32_i32$2;
        i64toi32_i32$2 = 0;
        i64toi32_i32$0 = 16;
        i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
         i64toi32_i32$2 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
         $50 = 0;
        } else {
         i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
         $50 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
        }
        $126$hi = i64toi32_i32$2;
        i64toi32_i32$2 = $122$hi;
        i64toi32_i32$1 = $122;
        i64toi32_i32$3 = $126$hi;
        i64toi32_i32$0 = $50;
        i64toi32_i32$3 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
        i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
        i64toi32_i32$1 = 0;
        i64toi32_i32$0 = 32;
        i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
         i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
         $51 = 0;
        } else {
         i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$4 | 0) | 0;
         $51 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        }
        $128$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $119$hi;
        i64toi32_i32$3 = $119;
        i64toi32_i32$2 = $128$hi;
        i64toi32_i32$0 = $51;
        i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
        i64toi32_i32$1 = i64toi32_i32$3 | i64toi32_i32$0 | 0;
        i64toi32_i32$3 = 0;
        i64toi32_i32$0 = 8;
        i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
         i64toi32_i32$3 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
         $52 = 0;
        } else {
         i64toi32_i32$3 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
         $52 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        }
        $130$hi = i64toi32_i32$3;
        i64toi32_i32$3 = 0;
        i64toi32_i32$2 = $3;
        i64toi32_i32$1 = 0;
        i64toi32_i32$0 = 255;
        i64toi32_i32$1 = i64toi32_i32$3 & i64toi32_i32$1 | 0;
        $133 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
        $133$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $130$hi;
        i64toi32_i32$3 = $52;
        i64toi32_i32$2 = $133$hi;
        i64toi32_i32$0 = $133;
        i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
        $7 = i64toi32_i32$3 | i64toi32_i32$0 | 0;
        $7$hi = i64toi32_i32$2;
        i64toi32_i32$1 = ($2 + 128 | 0) + 16 | 0;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
        $8 = i64toi32_i32$2;
        $8$hi = i64toi32_i32$3;
        $1 = 2;
       }
       core__ptr__drop_in_place_core__result__Result_cardano_serialization_lib__MoveInstantaneousRewardsCert_2ccardano_serialization_lib__error__DeserializeError____h3f599aafe2c15b13($2 + 32 | 0 | 0);
       break label$3;
      }
      i64toi32_i32$1 = $2 + 64 | 0;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $145 = i64toi32_i32$3;
      i64toi32_i32$3 = $2 + 16 | 0;
      HEAP32[i64toi32_i32$3 >> 2] = $145;
      HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$1 = $2 + 72 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $151 = i64toi32_i32$2;
      i64toi32_i32$2 = ($2 + 8 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $151;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
      i64toi32_i32$1 = $2 + 56 | 0;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $155 = i64toi32_i32$3;
      i64toi32_i32$3 = $2;
      HEAP32[($2 + 8 | 0) >> 2] = $155;
      HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$1 = ($2 + 32 | 0) + 16 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $8 = i64toi32_i32$2;
      $8$hi = i64toi32_i32$3;
      $1 = 2;
      break label$3;
     }
     HEAP8[($0 + 8 | 0) >> 0] = $1;
     $41 = HEAP32[($2 + 128 | 0) >> 2] | 0;
     HEAP8[($0 + 9 | 0) >> 0] = $41;
     HEAP8[($0 + 10 | 0) >> 0] = $41 >>> 8 | 0;
     HEAP8[($0 + 11 | 0) >> 0] = $41 >>> 16 | 0;
     HEAP8[($0 + 12 | 0) >> 0] = $41 >>> 24 | 0;
     HEAP32[($0 + 60 | 0) >> 2] = $6;
     $42 = $0 + 12 | 0;
     $43 = HEAPU8[($2 + 131 | 0) >> 0] | 0 | ((HEAPU8[($2 + 132 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 133 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 134 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[$42 >> 0] = $43;
     HEAP8[($42 + 1 | 0) >> 0] = $43 >>> 8 | 0;
     HEAP8[($42 + 2 | 0) >> 0] = $43 >>> 16 | 0;
     HEAP8[($42 + 3 | 0) >> 0] = $43 >>> 24 | 0;
     i64toi32_i32$3 = $8$hi;
     i64toi32_i32$2 = $0 + 24 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $8;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$3 = $7$hi;
     i64toi32_i32$2 = $0 + 16 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $7;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$1 = $2;
     i64toi32_i32$3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[($2 + 12 | 0) >> 2] | 0;
     $180 = i64toi32_i32$3;
     i64toi32_i32$3 = $0 + 32 | 0;
     $44 = $180;
     HEAP8[i64toi32_i32$3 >> 0] = $44;
     HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $44 >>> 8 | 0;
     HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $44 >>> 16 | 0;
     HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $44 >>> 24 | 0;
     HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$2;
     HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
     HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
     HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
     HEAP32[($0 + 56 | 0) >> 2] = $3;
     i64toi32_i32$1 = $4;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $187 = i64toi32_i32$2;
     i64toi32_i32$2 = $0 + 40 | 0;
     $46 = $187;
     HEAP8[i64toi32_i32$2 >> 0] = $46;
     HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $46 >>> 8 | 0;
     HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $46 >>> 16 | 0;
     HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $46 >>> 24 | 0;
     HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$3;
     HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
     HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
     HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
     i64toi32_i32$1 = $5;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $191 = i64toi32_i32$3;
     i64toi32_i32$3 = $0 + 48 | 0;
     $47 = $191;
     HEAP8[i64toi32_i32$3 >> 0] = $47;
     HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $47 >>> 8 | 0;
     HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $47 >>> 16 | 0;
     HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $47 >>> 24 | 0;
     HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$2;
     HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
     HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
     HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
     i64toi32_i32$2 = 0;
     $7 = 0;
     $7$hi = i64toi32_i32$2;
     break label$1;
    }
    $3 = 0;
   }
   i64toi32_i32$2 = $8$hi;
   i64toi32_i32$3 = ($2 + 32 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$3 >> 2] = $8;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$2 = $7$hi;
   i64toi32_i32$3 = ($2 + 32 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$3 >> 2] = $7;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$1 = $2;
   i64toi32_i32$2 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $203 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 56 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $203;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$3 = $9$hi;
   i64toi32_i32$2 = $2 + 88 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $9;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
   HEAP32[($2 + 84 | 0) >> 2] = $6;
   i64toi32_i32$1 = ($2 + 8 | 0) + 8 | 0;
   i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $215 = i64toi32_i32$3;
   i64toi32_i32$3 = $2 + 64 | 0;
   HEAP32[i64toi32_i32$3 >> 2] = $215;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$1 = ($2 + 8 | 0) + 16 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $221 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 72 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $221;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
   HEAP8[($2 + 32 | 0) >> 0] = $1;
   $48 = HEAP32[($2 + 128 | 0) >> 2] | 0;
   HEAP8[($2 + 33 | 0) >> 0] = $48;
   HEAP8[($2 + 34 | 0) >> 0] = $48 >>> 8 | 0;
   HEAP8[($2 + 35 | 0) >> 0] = $48 >>> 16 | 0;
   HEAP8[($2 + 36 | 0) >> 0] = $48 >>> 24 | 0;
   $49 = HEAPU8[($2 + 131 | 0) >> 0] | 0 | ((HEAPU8[($2 + 132 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 133 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 134 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[($2 + 36 | 0) >> 0] = $49;
   HEAP8[($2 + 37 | 0) >> 0] = $49 >>> 8 | 0;
   HEAP8[($2 + 38 | 0) >> 0] = $49 >>> 16 | 0;
   HEAP8[($2 + 39 | 0) >> 0] = $49 >>> 24 | 0;
   HEAP32[($2 + 80 | 0) >> 2] = $3;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 32 | 0 | 0, 1051077 | 0, 28 | 0);
   i64toi32_i32$3 = 0;
   $7 = 1;
   $7$hi = i64toi32_i32$3;
  }
  i64toi32_i32$3 = $7$hi;
  i64toi32_i32$2 = $0;
  HEAP32[i64toi32_i32$2 >> 2] = $7;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__Block__new__h40a5a6312a819cab($0, $1, $2, $3, $4, $5) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  $5 = $5 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $6 = 0, $48 = 0, $49 = 0, $50 = 0, $51 = 0, $53 = 0, $54 = 0, $55 = 0, $56 = 0, $57 = 0, $59 = 0, $60 = 0, $61 = 0, $62 = 0, $63 = 0, $65 = 0, $66 = 0, $10 = 0, $10$hi = 0, $8 = 0, $7 = 0, $26 = 0, $31 = 0, $36 = 0, $40 = 0, $46 = 0, $52 = 0, $58 = 0, $64 = 0, $70 = 0, $76 = 0, $79 = 0, $82 = 0, $106 = 0, $112 = 0, $118 = 0, $124 = 0, $130 = 0, $136 = 0, $142 = 0, $145 = 0, $9 = 0, $11 = 0, $11$hi = 0, $159 = 0, $165 = 0, $171 = 0, $177 = 0, $183 = 0, $189 = 0, $198 = 0, $206 = 0, $212 = 0, $221 = 0, $243 = 0;
  $6 = global$0 - 416 | 0;
  global$0 = $6;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  $7 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  $8 = 0;
  label$1 : {
   if ((HEAPU8[(i64toi32_i32$2 + 176 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   i64toi32_i32$2 = $1 + 201 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $26 = i64toi32_i32$1;
   i64toi32_i32$1 = $6 + 360 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $26;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $1 + 193 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $31 = i64toi32_i32$0;
   i64toi32_i32$0 = $6 + 352 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $31;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1 + 185 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $36 = i64toi32_i32$1;
   i64toi32_i32$1 = $6 + 344 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $36;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $1 + 177 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $40 = i64toi32_i32$0;
   i64toi32_i32$0 = $6;
   HEAP32[(i64toi32_i32$0 + 336 | 0) >> 2] = $40;
   HEAP32[(i64toi32_i32$0 + 340 | 0) >> 2] = i64toi32_i32$1;
   $8 = 1;
  }
  i64toi32_i32$2 = $1 + 233 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = ($6 + 8 | 0) + 233 | 0;
  $48 = $46;
  HEAP8[i64toi32_i32$1 >> 0] = $48;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $48 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $48 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $48 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 225 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $52 = i64toi32_i32$0;
  i64toi32_i32$0 = ($6 + 8 | 0) + 225 | 0;
  $49 = $52;
  HEAP8[i64toi32_i32$0 >> 0] = $49;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $49 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $49 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $49 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 217 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $58 = i64toi32_i32$1;
  i64toi32_i32$1 = ($6 + 8 | 0) + 217 | 0;
  $50 = $58;
  HEAP8[i64toi32_i32$1 >> 0] = $50;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $50 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $50 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $50 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 249 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $64 = i64toi32_i32$0;
  i64toi32_i32$0 = ($6 + 8 | 0) + 249 | 0;
  $51 = $64;
  HEAP8[i64toi32_i32$0 >> 0] = $51;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $51 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $51 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $51 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 257 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $70 = i64toi32_i32$1;
  i64toi32_i32$1 = ($6 + 8 | 0) + 257 | 0;
  $53 = $70;
  HEAP8[i64toi32_i32$1 >> 0] = $53;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $53 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $53 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $53 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 265 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $76 = i64toi32_i32$0;
  i64toi32_i32$0 = ($6 + 8 | 0) + 265 | 0;
  $54 = $76;
  HEAP8[i64toi32_i32$0 >> 0] = $54;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $54 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $54 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $54 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 209 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 210 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 211 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 212 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 213 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 214 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 215 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 216 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $79 = i64toi32_i32$1;
  i64toi32_i32$1 = $6;
  $55 = $79;
  HEAP8[(i64toi32_i32$1 + 217 | 0) >> 0] = $55;
  HEAP8[(i64toi32_i32$1 + 218 | 0) >> 0] = $55 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 219 | 0) >> 0] = $55 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 220 | 0) >> 0] = $55 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 221 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 222 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 223 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 224 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 241 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 242 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 243 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 244 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 245 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 246 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 247 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 248 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $82 = i64toi32_i32$0;
  i64toi32_i32$0 = $6;
  $56 = $82;
  HEAP8[(i64toi32_i32$0 + 249 | 0) >> 0] = $56;
  HEAP8[(i64toi32_i32$0 + 250 | 0) >> 0] = $56 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 251 | 0) >> 0] = $56 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 252 | 0) >> 0] = $56 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 253 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 254 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 255 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 256 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3(i64toi32_i32$0 + 368 | 0 | 0, i64toi32_i32$2 + 12 | 0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3((i64toi32_i32$0 + 368 | 0) + 12 | 0 | 0, i64toi32_i32$2 + 24 | 0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3(i64toi32_i32$0 + 392 | 0 | 0, i64toi32_i32$2 + 36 | 0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3((i64toi32_i32$0 + 392 | 0) + 12 | 0 | 0, i64toi32_i32$2 + 48 | 0 | 0);
  i64toi32_i32$2 = i64toi32_i32$2 + 281 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $106 = i64toi32_i32$1;
  i64toi32_i32$1 = ($6 + 8 | 0) + 281 | 0;
  $57 = $106;
  HEAP8[i64toi32_i32$1 >> 0] = $57;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $57 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $57 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $57 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 289 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $112 = i64toi32_i32$0;
  i64toi32_i32$0 = ($6 + 8 | 0) + 289 | 0;
  $59 = $112;
  HEAP8[i64toi32_i32$0 >> 0] = $59;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $59 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $59 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $59 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 297 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $118 = i64toi32_i32$1;
  i64toi32_i32$1 = ($6 + 8 | 0) + 297 | 0;
  $60 = $118;
  HEAP8[i64toi32_i32$1 >> 0] = $60;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $60 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $60 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $60 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 72 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $124 = i64toi32_i32$0;
  i64toi32_i32$0 = ($6 + 8 | 0) + 72 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $124;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 80 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $130 = i64toi32_i32$1;
  i64toi32_i32$1 = ($6 + 8 | 0) + 80 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $130;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1 + 88 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $136 = i64toi32_i32$0;
  i64toi32_i32$0 = ($6 + 8 | 0) + 88 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $136;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 96 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $142 = i64toi32_i32$1;
  i64toi32_i32$1 = ($6 + 8 | 0) + 96 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $142;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 273 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 274 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 275 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 276 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 277 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 278 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 279 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 280 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $145 = i64toi32_i32$0;
  i64toi32_i32$0 = $6;
  $61 = $145;
  HEAP8[(i64toi32_i32$0 + 281 | 0) >> 0] = $61;
  HEAP8[(i64toi32_i32$0 + 282 | 0) >> 0] = $61 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 283 | 0) >> 0] = $61 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 284 | 0) >> 0] = $61 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 285 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 286 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 287 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 288 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $9 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$0;
  memcpy(($6 + 8 | 0) + 104 | 0 | 0, i64toi32_i32$2 + 104 | 0 | 0, 64 | 0) | 0;
  i64toi32_i32$2 = $6;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 336 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 340 | 0) >> 2] | 0;
  $159 = i64toi32_i32$0;
  i64toi32_i32$0 = i64toi32_i32$2 + 185 | 0;
  $62 = $159;
  HEAP8[i64toi32_i32$0 >> 0] = $62;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $62 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $62 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $62 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = (i64toi32_i32$2 + 336 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $165 = i64toi32_i32$1;
  i64toi32_i32$1 = $6 + 193 | 0;
  $63 = $165;
  HEAP8[i64toi32_i32$1 >> 0] = $63;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $63 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $63 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $63 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = ($6 + 336 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $171 = i64toi32_i32$0;
  i64toi32_i32$0 = $6 + 201 | 0;
  $65 = $171;
  HEAP8[i64toi32_i32$0 >> 0] = $65;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $65 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $65 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $65 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = ($6 + 336 | 0) + 24 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $177 = i64toi32_i32$1;
  i64toi32_i32$1 = $6 + 209 | 0;
  $66 = $177;
  HEAP8[i64toi32_i32$1 >> 0] = $66;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $66 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $66 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $66 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = ($6 + 368 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $183 = i64toi32_i32$0;
  i64toi32_i32$0 = $6 + 28 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $183;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = ($6 + 368 | 0) + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $189 = i64toi32_i32$1;
  i64toi32_i32$1 = $6 + 36 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $189;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($6 + 16 | 0) >> 2] = $7;
  HEAP8[($6 + 184 | 0) >> 0] = $8;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$1 = $6;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $10;
  HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 368 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 372 | 0) >> 2] | 0;
  $198 = i64toi32_i32$0;
  i64toi32_i32$0 = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] = $198;
  HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 168 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 172 | 0) >> 2] | 0;
  $10 = i64toi32_i32$1;
  $10$hi = i64toi32_i32$0;
  i64toi32_i32$2 = ($6 + 392 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $206 = i64toi32_i32$0;
  i64toi32_i32$0 = $6 + 60 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $206;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = ($6 + 392 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $212 = i64toi32_i32$1;
  i64toi32_i32$1 = $6 + 52 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $212;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$1 = $6;
  HEAP32[(i64toi32_i32$1 + 176 | 0) >> 2] = $10;
  HEAP32[(i64toi32_i32$1 + 180 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  HEAP32[(i64toi32_i32$1 + 72 | 0) >> 2] = $11;
  HEAP32[(i64toi32_i32$1 + 76 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] = $9;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 392 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 396 | 0) >> 2] | 0;
  $221 = i64toi32_i32$0;
  i64toi32_i32$0 = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] = $221;
  HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = i64toi32_i32$1;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3((i64toi32_i32$2 + 8 | 0) + 312 | 0 | 0, $1 + 312 | 0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h81140d58f8f9ef39($0 + 368 | 0 | 0, $2 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hb198082190ccba71($0 + 380 | 0 | 0, $3 | 0);
  $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h145f71b95ce2a2a5($0 + 328 | 0 | 0, $4 | 0);
  HEAP32[($0 + 400 | 0) >> 2] = HEAP32[($5 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $243 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[(i64toi32_i32$1 + 392 | 0) >> 2] = $243;
  HEAP32[(i64toi32_i32$1 + 396 | 0) >> 2] = i64toi32_i32$0;
  memcpy(i64toi32_i32$1 | 0, $6 + 8 | 0 | 0, 328 | 0) | 0;
  global$0 = $6 + 416 | 0;
 }
 
 function $cardano_serialization_lib__metadata__AuxiliaryData_20as_20cbor_event__se__Serialize___serialize__h6e246ec2e95d27d5($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$5 = 0, $4 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, $5 = 0, i64toi32_i32$2 = 0, $6 = 0, $24 = 0, $25 = 0, $30$hi = 0, $33$hi = 0, $34$hi = 0, $38$hi = 0;
  $3 = global$0 - 64 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           label$10 : {
            label$11 : {
             label$12 : {
              label$13 : {
               label$14 : {
                label$15 : {
                 label$16 : {
                  $4 = HEAP32[($1 + 20 | 0) >> 2] | 0;
                  if (!$4) {
                   break label$16
                  }
                  if (!(HEAP32[($1 + 52 | 0) >> 2] | 0)) {
                   break label$15
                  }
                 }
                 i64toi32_i32$0 = 0;
                 cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 + 16 | 0 | 0, $2 | 0, 6 | 0, 259 | 0, i64toi32_i32$0 | 0);
                 if ((HEAP32[($3 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                  break label$14
                 }
                 $24 = $3 + 16 | 0;
                 $25 = $2;
                 $5 = HEAP32[($1 + 40 | 0) >> 2] | 0;
                 i64toi32_i32$0 = 0;
                 $30$hi = i64toi32_i32$0;
                 i64toi32_i32$0 = 0;
                 $33$hi = i64toi32_i32$0;
                 i64toi32_i32$0 = $30$hi;
                 i64toi32_i32$2 = ($5 | 0) != (0 | 0);
                 i64toi32_i32$1 = $33$hi;
                 i64toi32_i32$3 = ($4 | 0) != (0 | 0);
                 i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
                 i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
                 if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
                  i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
                 }
                 $34$hi = i64toi32_i32$5;
                 i64toi32_i32$5 = 0;
                 $38$hi = i64toi32_i32$5;
                 i64toi32_i32$5 = $34$hi;
                 i64toi32_i32$0 = i64toi32_i32$4;
                 i64toi32_i32$2 = $38$hi;
                 i64toi32_i32$3 = (HEAP32[($1 + 52 | 0) >> 2] | 0 | 0) != (0 | 0);
                 i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
                 i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
                 if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
                  i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
                 }
                 cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($24 | 0, $25 | 0, 5 | 0, i64toi32_i32$1 | 0, i64toi32_i32$4 | 0);
                 if ((HEAP32[($3 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                  break label$13
                 }
                 $6 = $1 + 40 | 0;
                 label$17 : {
                  if (!$4) {
                   break label$17
                  }
                  i64toi32_i32$4 = 0;
                  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 + 16 | 0 | 0, $2 | 0, 0 | 0, 0 | 0, i64toi32_i32$4 | 0);
                  if ((HEAP32[($3 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                   break label$12
                  }
                  $cardano_serialization_lib__metadata__GeneralTransactionMetadata_20as_20cbor_event__se__Serialize___serialize__h54e54d8e88a77b55($3 + 16 | 0 | 0, $1 | 0, $2 | 0);
                  if ((HEAP32[($3 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                   break label$11
                  }
                  $5 = HEAP32[$6 >> 2] | 0;
                 }
                 label$18 : {
                  if (!$5) {
                   break label$18
                  }
                  i64toi32_i32$4 = 0;
                  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 + 16 | 0 | 0, $2 | 0, 0 | 0, 1 | 0, i64toi32_i32$4 | 0);
                  if ((HEAP32[($3 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                   break label$10
                  }
                  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__NativeScripts___serialize__hecc991a2909139b7($3 + 16 | 0 | 0, $6 | 0, $2 | 0);
                  if ((HEAP32[($3 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                   break label$9
                  }
                 }
                 label$19 : {
                  $1 = $1 + 52 | 0;
                  if (!(HEAP32[$1 >> 2] | 0)) {
                   break label$19
                  }
                  i64toi32_i32$4 = 0;
                  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 + 16 | 0 | 0, $2 | 0, 0 | 0, 2 | 0, i64toi32_i32$4 | 0);
                  if ((HEAP32[($3 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                   break label$8
                  }
                  $cardano_serialization_lib__plutus__PlutusScripts_20as_20cbor_event__se__Serialize___serialize__h460b1286d3728f21($3 + 16 | 0 | 0, $1 | 0, $2 | 0);
                  if ((HEAP32[($3 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                   break label$7
                  }
                 }
                 HEAP32[$0 >> 2] = 0;
                 HEAP32[($0 + 4 | 0) >> 2] = $2;
                 break label$1;
                }
                label$20 : {
                 label$21 : {
                  label$22 : {
                   $4 = HEAP32[($1 + 40 | 0) >> 2] | 0;
                   if ($4) {
                    break label$22
                   }
                   HEAP32[$3 >> 2] = 0;
                   break label$21;
                  }
                  alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($3 | 0, $4 | 0, HEAP32[($1 + 48 | 0) >> 2] | 0 | 0);
                  if (HEAP32[$3 >> 2] | 0) {
                   break label$20
                  }
                  if (!(HEAP32[($1 + 20 | 0) >> 2] | 0)) {
                   break label$6
                  }
                 }
                 $cardano_serialization_lib__metadata__GeneralTransactionMetadata_20as_20cbor_event__se__Serialize___serialize__h54e54d8e88a77b55($0 | 0, $1 | 0, $2 | 0);
                 break label$2;
                }
                i64toi32_i32$4 = 0;
                cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 + 16 | 0 | 0, $2 | 0, 4 | 0, 2 | 0, i64toi32_i32$4 | 0);
                label$23 : {
                 if ((HEAP32[($3 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                  break label$23
                 }
                 if (!(HEAP32[($1 + 20 | 0) >> 2] | 0)) {
                  break label$5
                 }
                 $cardano_serialization_lib__metadata__GeneralTransactionMetadata_20as_20cbor_event__se__Serialize___serialize__h54e54d8e88a77b55($3 + 16 | 0 | 0, $1 | 0, $2 | 0);
                 if ((HEAP32[($3 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
                  break label$4
                 }
                 cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__NativeScripts___serialize__hecc991a2909139b7($0 | 0, $3 | 0, $2 | 0);
                 break label$2;
                }
                memcpy($0 + 8 | 0 | 0, ($3 + 16 | 0) + 8 | 0 | 0, 40 | 0) | 0;
                break label$3;
               }
               memcpy($0 + 8 | 0 | 0, ($3 + 16 | 0) + 8 | 0 | 0, 40 | 0) | 0;
               HEAP32[$0 >> 2] = 1;
               break label$1;
              }
              memcpy($0 + 8 | 0 | 0, ($3 + 16 | 0) + 8 | 0 | 0, 40 | 0) | 0;
              HEAP32[$0 >> 2] = 1;
              break label$1;
             }
             memcpy($0 + 8 | 0 | 0, ($3 + 16 | 0) + 8 | 0 | 0, 40 | 0) | 0;
             HEAP32[$0 >> 2] = 1;
             break label$1;
            }
            memcpy($0 + 8 | 0 | 0, ($3 + 16 | 0) + 8 | 0 | 0, 40 | 0) | 0;
            HEAP32[$0 >> 2] = 1;
            break label$1;
           }
           memcpy($0 + 8 | 0 | 0, ($3 + 16 | 0) + 8 | 0 | 0, 40 | 0) | 0;
           HEAP32[$0 >> 2] = 1;
           break label$1;
          }
          memcpy($0 + 8 | 0 | 0, ($3 + 16 | 0) + 8 | 0 | 0, 40 | 0) | 0;
          HEAP32[$0 >> 2] = 1;
          break label$1;
         }
         memcpy($0 + 8 | 0 | 0, ($3 + 16 | 0) + 8 | 0 | 0, 40 | 0) | 0;
         HEAP32[$0 >> 2] = 1;
         break label$1;
        }
        memcpy($0 + 8 | 0 | 0, ($3 + 16 | 0) + 8 | 0 | 0, 40 | 0) | 0;
        HEAP32[$0 >> 2] = 1;
        break label$1;
       }
       core__panicking__panic__h2fd385a887c8bf13(1059116 | 0, 43 | 0, 1060048 | 0);
       abort();
      }
      core__panicking__panic__h2fd385a887c8bf13(1059116 | 0, 43 | 0, 1060032 | 0);
      abort();
     }
     memcpy($0 + 8 | 0 | 0, ($3 + 16 | 0) + 8 | 0 | 0, 40 | 0) | 0;
    }
    HEAP32[$0 >> 2] = 1;
   }
   core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__NativeScripts____hdd7d461255ec800a_1($3 | 0);
  }
  global$0 = $3 + 64 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__SingleHostAddr___deserialize__h59dee13d71df70a3($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $5 = 0, $5$hi = 0, $6 = 0, $3 = 0, $6$hi = 0, $34 = 0, $35 = 0, $36 = 0, $37 = 0, $38 = 0, $39 = 0, $40 = 0, $4 = 0, $41 = 0, $42 = 0, $43 = 0, $44 = 0, $46 = 0, $45 = 0, $50 = 0, $65 = 0, $89 = 0, $123 = 0, $123$hi = 0, $126 = 0, $126$hi = 0, $130$hi = 0, $132$hi = 0, $134$hi = 0, $137 = 0, $137$hi = 0, $152 = 0, $157 = 0, $161 = 0, $200 = 0, $204 = 0, $209 = 0, $214 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 32 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 40 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 44 | 0) >> 2] | 0;
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       i64toi32_i32$2 = $2;
       i64toi32_i32$1 = HEAP32[($2 + 32 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[($2 + 36 | 0) >> 2] | 0;
       i64toi32_i32$2 = i64toi32_i32$1;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 1;
       if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
        break label$5
       }
       i64toi32_i32$2 = $5$hi;
       i64toi32_i32$0 = i64toi32_i32$2;
       cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__SingleHostAddr___deserialize_as_embedded_group__ha772ae07f05d383e($2 + 32 | 0 | 0, $1 | 0, $5 | 0, i64toi32_i32$0 | 0, $5 | 0, i64toi32_i32$0 | 0);
       label$6 : {
        label$7 : {
         label$8 : {
          i64toi32_i32$3 = $5;
          i64toi32_i32$2 = 0;
          i64toi32_i32$1 = 1;
          if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) | 0) {
           break label$8
          }
          cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 128 | 0 | 0, $1 | 0);
          $3 = HEAPU8[($2 + 136 | 0) >> 0] | 0;
          i64toi32_i32$1 = $2;
          i64toi32_i32$3 = HEAP32[($2 + 128 | 0) >> 2] | 0;
          i64toi32_i32$0 = HEAP32[($2 + 132 | 0) >> 2] | 0;
          i64toi32_i32$1 = i64toi32_i32$3;
          i64toi32_i32$3 = 0;
          i64toi32_i32$2 = 1;
          if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) | 0) {
           break label$7
          }
          $1 = 5;
          if (($3 & 255 | 0 | 0) != (5 | 0)) {
           break label$6
          }
         }
         $4 = $2 + 28 | 0;
         HEAP16[$4 >> 1] = HEAPU16[($2 + 38 | 0) >> 1] | 0;
         i64toi32_i32$2 = $2 + 72 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $45 = i64toi32_i32$1;
         i64toi32_i32$1 = $2 + 8 | 0;
         HEAP32[i64toi32_i32$1 >> 2] = $45;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$2 = $2 + 80 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $50 = i64toi32_i32$0;
         i64toi32_i32$0 = $2 + 16 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $50;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         HEAP32[($2 + 24 | 0) >> 2] = HEAPU16[($2 + 34 | 0) >> 1] | 0 | ((HEAPU16[($2 + 36 | 0) >> 1] | 0) << 16 | 0) | 0;
         HEAP32[($2 + 104 | 0) >> 2] = HEAPU8[($2 + 41 | 0) >> 0] | 0 | ((HEAPU8[($2 + 42 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 43 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 44 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $34 = ($2 + 32 | 0) + 12 | 0;
         $35 = HEAPU8[$34 >> 0] | 0 | ((HEAPU8[($34 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($34 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($34 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[($2 + 107 | 0) >> 0] = $35;
         HEAP8[($2 + 108 | 0) >> 0] = $35 >>> 8 | 0;
         HEAP8[($2 + 109 | 0) >> 0] = $35 >>> 16 | 0;
         HEAP8[($2 + 110 | 0) >> 0] = $35 >>> 24 | 0;
         i64toi32_i32$2 = $2 + 64 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $65 = i64toi32_i32$1;
         i64toi32_i32$1 = $2;
         HEAP32[$2 >> 2] = $65;
         HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$0;
         $1 = HEAPU8[(($2 + 32 | 0) + 8 | 0) >> 0] | 0;
         i64toi32_i32$2 = ($2 + 32 | 0) + 16 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $5 = i64toi32_i32$0;
         $5$hi = i64toi32_i32$1;
         i64toi32_i32$2 = ($2 + 32 | 0) + 24 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $6 = i64toi32_i32$1;
         $6$hi = i64toi32_i32$0;
         $3 = HEAPU16[($2 + 32 | 0) >> 1] | 0;
         HEAP32[(($2 + 128 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 100 | 0) >> 2] | 0;
         i64toi32_i32$2 = $2 + 92 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $89 = i64toi32_i32$0;
         i64toi32_i32$0 = $2;
         HEAP32[($2 + 128 | 0) >> 2] = $89;
         HEAP32[($2 + 132 | 0) >> 2] = i64toi32_i32$1;
         if (($3 | 0) != (1 | 0)) {
          break label$4
         }
         $3 = HEAP32[($2 + 88 | 0) >> 2] | 0;
         break label$2;
        }
        i64toi32_i32$2 = $2 + 160 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $5 = i64toi32_i32$1;
        $5$hi = i64toi32_i32$0;
        i64toi32_i32$1 = ($2 + 104 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $5;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = $2 + 168 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $6 = i64toi32_i32$0;
        $6$hi = i64toi32_i32$1;
        i64toi32_i32$0 = ($2 + 104 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $6;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$1 = $5$hi;
        i64toi32_i32$0 = $2 + 8 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $5;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$1 = $6$hi;
        i64toi32_i32$0 = $2 + 16 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $6;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$2 = $2 + 152 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $5 = i64toi32_i32$1;
        $5$hi = i64toi32_i32$0;
        i64toi32_i32$1 = $2;
        HEAP32[($2 + 104 | 0) >> 2] = $5;
        HEAP32[($2 + 108 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$1 = $2;
        HEAP32[$2 >> 2] = $5;
        HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAPU8[($2 + 137 | 0) >> 0] | 0 | ((HEAPU8[($2 + 138 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 139 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 140 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$1 = 0;
        $123 = i64toi32_i32$0;
        $123$hi = i64toi32_i32$1;
        i64toi32_i32$2 = $2 + 141 | 0;
        i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
        i64toi32_i32$0 = 0;
        $126 = i64toi32_i32$1;
        $126$hi = i64toi32_i32$0;
        i64toi32_i32$2 = $2 + 143 | 0;
        i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
        i64toi32_i32$1 = 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 16;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
         $41 = 0;
        } else {
         i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
         $41 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        }
        $130$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $126$hi;
        i64toi32_i32$1 = $126;
        i64toi32_i32$2 = $130$hi;
        i64toi32_i32$3 = $41;
        i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
        i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 32;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
         $42 = 0;
        } else {
         i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
         $42 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        }
        $132$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $123$hi;
        i64toi32_i32$2 = $123;
        i64toi32_i32$0 = $132$hi;
        i64toi32_i32$3 = $42;
        i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
        i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
        i64toi32_i32$2 = 0;
        i64toi32_i32$3 = 8;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
         $43 = 0;
        } else {
         i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
         $43 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        }
        $134$hi = i64toi32_i32$2;
        i64toi32_i32$2 = 0;
        i64toi32_i32$0 = $3;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 255;
        i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
        $137 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
        $137$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $134$hi;
        i64toi32_i32$2 = $43;
        i64toi32_i32$0 = $137$hi;
        i64toi32_i32$3 = $137;
        i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
        $5 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
        $5$hi = i64toi32_i32$0;
        i64toi32_i32$1 = ($2 + 128 | 0) + 16 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
        $6 = i64toi32_i32$0;
        $6$hi = i64toi32_i32$2;
        $1 = 2;
       }
       if (!(HEAPU16[($2 + 32 | 0) >> 1] | 0)) {
        break label$3
       }
       core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9($2 + 40 | 0 | 0);
       break label$3;
      }
      i64toi32_i32$1 = $2 + 64 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $152 = i64toi32_i32$2;
      i64toi32_i32$2 = $2 + 8 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $152;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$1 = $2 + 72 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $157 = i64toi32_i32$0;
      i64toi32_i32$0 = $2 + 16 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $157;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$1 = $2 + 56 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $161 = i64toi32_i32$2;
      i64toi32_i32$2 = $2;
      HEAP32[$2 >> 2] = $161;
      HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$1 = ($2 + 32 | 0) + 16 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $6 = i64toi32_i32$0;
      $6$hi = i64toi32_i32$2;
      $1 = 2;
      break label$3;
     }
     $44 = HEAP32[($2 + 24 | 0) >> 2] | 0;
     HEAP16[($0 + 2 | 0) >> 1] = $44;
     HEAP16[($0 + 4 | 0) >> 1] = $44 >>> 16 | 0;
     $36 = HEAP32[($2 + 104 | 0) >> 2] | 0;
     HEAP8[($0 + 9 | 0) >> 0] = $36;
     HEAP8[($0 + 10 | 0) >> 0] = $36 >>> 8 | 0;
     HEAP8[($0 + 11 | 0) >> 0] = $36 >>> 16 | 0;
     HEAP8[($0 + 12 | 0) >> 0] = $36 >>> 24 | 0;
     HEAP8[($0 + 8 | 0) >> 0] = $1;
     $37 = $0 + 12 | 0;
     $38 = HEAPU8[($2 + 107 | 0) >> 0] | 0 | ((HEAPU8[($2 + 108 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 109 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 110 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[$37 >> 0] = $38;
     HEAP8[($37 + 1 | 0) >> 0] = $38 >>> 8 | 0;
     HEAP8[($37 + 2 | 0) >> 0] = $38 >>> 16 | 0;
     HEAP8[($37 + 3 | 0) >> 0] = $38 >>> 24 | 0;
     i64toi32_i32$2 = $6$hi;
     $46 = $0 + 24 | 0;
     HEAP16[$46 >> 1] = $6;
     HEAP16[($46 + 2 | 0) >> 1] = $6 >>> 16 | 0;
     i64toi32_i32$2 = $5$hi;
     i64toi32_i32$0 = $0 + 16 | 0;
     HEAP16[i64toi32_i32$0 >> 1] = $5;
     HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $5 >>> 16 | 0;
     HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$2;
     HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$2 >>> 16 | 0;
     HEAP16[($0 + 6 | 0) >> 1] = HEAPU16[$4 >> 1] | 0;
     $1 = 0;
     break label$1;
    }
    $3 = 0;
   }
   i64toi32_i32$2 = $6$hi;
   i64toi32_i32$0 = ($2 + 32 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $6;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$2 = $5$hi;
   i64toi32_i32$0 = ($2 + 32 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $5;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$1 = $2;
   i64toi32_i32$2 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $200 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 56 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $200;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$1 = $2;
   i64toi32_i32$0 = HEAP32[($2 + 128 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($2 + 132 | 0) >> 2] | 0;
   $204 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 84 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $204;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$1 = $2 + 8 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $209 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 64 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $209;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$1 = $2 + 16 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $214 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 72 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $214;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   HEAP32[($2 + 92 | 0) >> 2] = HEAP32[(($2 + 128 | 0) + 8 | 0) >> 2] | 0;
   HEAP8[($2 + 32 | 0) >> 0] = $1;
   $39 = HEAP32[($2 + 104 | 0) >> 2] | 0;
   HEAP8[($2 + 33 | 0) >> 0] = $39;
   HEAP8[($2 + 34 | 0) >> 0] = $39 >>> 8 | 0;
   HEAP8[($2 + 35 | 0) >> 0] = $39 >>> 16 | 0;
   HEAP8[($2 + 36 | 0) >> 0] = $39 >>> 24 | 0;
   $40 = HEAPU8[($2 + 107 | 0) >> 0] | 0 | ((HEAPU8[($2 + 108 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 109 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 110 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[($2 + 36 | 0) >> 0] = $40;
   HEAP8[($2 + 37 | 0) >> 0] = $40 >>> 8 | 0;
   HEAP8[($2 + 38 | 0) >> 0] = $40 >>> 16 | 0;
   HEAP8[($2 + 39 | 0) >> 0] = $40 >>> 24 | 0;
   HEAP32[($2 + 80 | 0) >> 2] = $3;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 32 | 0 | 0, 1051408 | 0, 14 | 0);
   $1 = 1;
  }
  HEAP16[$0 >> 1] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function linked_hash_map__LinkedHashMap_K_2cV_2cS___insert__h37110d4804766b2f($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$0 = 0, $5 = 0, $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $6 = 0, $11 = 0, $11$hi = 0, $24 = 0, $7 = 0, $9 = 0, $10 = 0, $8 = 0, $134 = 0, $145 = 0, $12 = 0, $12$hi = 0, $154 = 0, $13 = 0, $13$hi = 0, $163 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $4 = global$0 - 176 | 0;
  global$0 = $4;
  HEAP32[($4 + 36 | 0) >> 2] = $2;
  label$1 : {
   if (HEAP32[($1 + 32 | 0) >> 2] | 0) {
    break label$1
   }
   $2 = __rust_alloc(80 | 0, 8 | 0) | 0;
   HEAP32[($1 + 32 | 0) >> 2] = $2;
   HEAP32[($2 + 68 | 0) >> 2] = $2;
   HEAP32[($2 + 64 | 0) >> 2] = $2;
  }
  HEAP32[($4 + 108 | 0) >> 2] = $4 + 36 | 0;
  i64toi32_i32$0 = hashbrown__map__make_hash__h18de0e6f479ebafc($1 | 0, $4 + 108 | 0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $11 = i64toi32_i32$0;
  $11$hi = i64toi32_i32$1;
  $5 = i64toi32_i32$0;
  $6 = (HEAP32[($1 + 16 | 0) >> 2] | 0) & i64toi32_i32$0 | 0;
  $24 = (HEAP32[($1 + 20 | 0) >> 2] | 0) + $6 | 0;
  $2 = HEAPU8[$24 >> 0] | 0 | ((HEAPU8[($24 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($24 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($24 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  HEAP32[($4 + 120 | 0) >> 2] = 0;
  HEAP32[($4 + 124 | 0) >> 2] = $2;
  HEAP32[($4 + 116 | 0) >> 2] = $6;
  HEAP32[($4 + 112 | 0) >> 2] = $1 + 16 | 0;
  $5 = i64toi32_i32$0 >>> 25 | 0;
  HEAP8[($4 + 132 | 0) >> 0] = $5;
  $2 = $2 ^ Math_imul($5, 16843009) | 0;
  HEAP32[($4 + 128 | 0) >> 2] = (($2 ^ -1 | 0) & ($2 + -16843009 | 0) | 0) & -2139062144 | 0;
  $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($4 + 24 | 0 | 0, $4 + 112 | 0 | 0);
  label$2 : {
   label$3 : {
    if (!(HEAP32[($4 + 24 | 0) >> 2] | 0)) {
     break label$3
    }
    label$4 : {
     $5 = HEAP32[($4 + 108 | 0) >> 2] | 0;
     $2 = (HEAP32[((HEAP32[($4 + 112 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) - ((HEAP32[($4 + 28 | 0) >> 2] | 0) << 3 | 0) | 0;
     if ((HEAP32[$5 >> 2] | 0 | 0) == (HEAP32[(HEAP32[($2 + -8 | 0) >> 2] | 0) >> 2] | 0 | 0)) {
      break label$4
     }
     label$5 : while (1) {
      $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($4 + 16 | 0 | 0, $4 + 112 | 0 | 0);
      if (!(HEAP32[($4 + 16 | 0) >> 2] | 0)) {
       break label$3
      }
      $2 = (HEAP32[((HEAP32[($4 + 112 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) - ((HEAP32[($4 + 20 | 0) >> 2] | 0) << 3 | 0) | 0;
      if ((HEAP32[$5 >> 2] | 0 | 0) != (HEAP32[(HEAP32[($2 + -8 | 0) >> 2] | 0) >> 2] | 0 | 0)) {
       continue label$5
      }
      break label$5;
     };
    }
    $7 = $2 + -4 | 0;
    $8 = HEAP32[$7 >> 2] | 0;
    memcpy($4 + 112 | 0 | 0, $3 | 0, 64 | 0) | 0;
    $6 = 0;
    label$6 : while (1) {
     $2 = $8 + $6 | 0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
     $11 = i64toi32_i32$1;
     $11$hi = i64toi32_i32$0;
     $5 = ($4 + 112 | 0) + $6 | 0;
     i64toi32_i32$2 = $5;
     i64toi32_i32$0 = HEAP32[$5 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($5 + 4 | 0) >> 2] | 0;
     $134 = i64toi32_i32$0;
     i64toi32_i32$0 = $2;
     HEAP32[$2 >> 2] = $134;
     HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $11$hi;
     i64toi32_i32$0 = $5;
     HEAP32[i64toi32_i32$0 >> 2] = $11;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     $3 = $2 + 8 | 0;
     i64toi32_i32$2 = $3;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $11 = i64toi32_i32$1;
     $11$hi = i64toi32_i32$0;
     $9 = $5 + 8 | 0;
     i64toi32_i32$2 = $9;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $145 = i64toi32_i32$0;
     i64toi32_i32$0 = $3;
     HEAP32[i64toi32_i32$0 >> 2] = $145;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     $3 = $2 + 16 | 0;
     i64toi32_i32$2 = $3;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $12 = i64toi32_i32$1;
     $12$hi = i64toi32_i32$0;
     $10 = $5 + 16 | 0;
     i64toi32_i32$2 = $10;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $154 = i64toi32_i32$0;
     i64toi32_i32$0 = $3;
     HEAP32[i64toi32_i32$0 >> 2] = $154;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     $2 = $2 + 24 | 0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
     $13 = i64toi32_i32$1;
     $13$hi = i64toi32_i32$0;
     $5 = $5 + 24 | 0;
     i64toi32_i32$2 = $5;
     i64toi32_i32$0 = HEAP32[$5 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($5 + 4 | 0) >> 2] | 0;
     $163 = i64toi32_i32$0;
     i64toi32_i32$0 = $2;
     HEAP32[$2 >> 2] = $163;
     HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $13$hi;
     i64toi32_i32$0 = $5;
     HEAP32[i64toi32_i32$0 >> 2] = $13;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$0 = $10;
     HEAP32[i64toi32_i32$0 >> 2] = $12;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $11$hi;
     i64toi32_i32$0 = $9;
     HEAP32[i64toi32_i32$0 >> 2] = $11;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     $6 = $6 + 32 | 0;
     if ($6 >>> 0 < 33 >>> 0) {
      continue label$6
     }
     break label$6;
    };
    memcpy($4 + 40 | 0 | 0, $4 + 112 | 0 | 0, 64 | 0) | 0;
    $2 = HEAP32[$7 >> 2] | 0;
    i64toi32_i32$1 = 0;
    $11 = 1;
    $11$hi = i64toi32_i32$1;
    $5 = 0;
    break label$2;
   }
   label$7 : {
    label$8 : {
     label$9 : {
      $2 = HEAP32[($1 + 36 | 0) >> 2] | 0;
      if (!$2) {
       break label$9
      }
      HEAP32[($1 + 36 | 0) >> 2] = HEAP32[($2 + 64 | 0) >> 2] | 0;
      $5 = HEAP32[($4 + 36 | 0) >> 2] | 0;
      (wasm2js_i32$0 = memcpy($2 | 0, $3 | 0, 64 | 0) | 0, wasm2js_i32$1 = $5), HEAP32[(wasm2js_i32$0 + 72 | 0) >> 2] = wasm2js_i32$1;
      break label$8;
     }
     $5 = HEAP32[($4 + 36 | 0) >> 2] | 0;
     $2 = __rust_alloc(80 | 0, 8 | 0) | 0;
     if (!$2) {
      break label$7
     }
     (wasm2js_i32$0 = memcpy($2 | 0, $3 | 0, 64 | 0) | 0, wasm2js_i32$1 = $5), HEAP32[(wasm2js_i32$0 + 72 | 0) >> 2] = wasm2js_i32$1;
    }
    i64toi32_i32$1 = 0;
    $11 = 0;
    $11$hi = i64toi32_i32$1;
    i64toi32_i32$0 = $2;
    i64toi32_i32$1 = 0;
    HEAP32[($2 + 64 | 0) >> 2] = 0;
    HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$1;
    $5 = 1;
    break label$2;
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(80 | 0, 8 | 0);
   abort();
  }
  memcpy($4 + 112 | 0 | 0, $4 + 40 | 0 | 0, 64 | 0) | 0;
  label$10 : {
   label$11 : {
    if (!$5) {
     break label$11
    }
    hashbrown__map__HashMap_K_2cV_2cS_2cA___insert__hb3103c1d05371979($4 + 8 | 0 | 0, $1 | 0, $2 + 72 | 0 | 0, $2 | 0);
    $5 = HEAP32[($1 + 32 | 0) >> 2] | 0;
    $6 = HEAP32[($5 + 64 | 0) >> 2] | 0;
    HEAP32[($2 + 68 | 0) >> 2] = $5;
    HEAP32[($2 + 64 | 0) >> 2] = $6;
    $5 = $5 + 64 | 0;
    break label$10;
   }
   HEAP32[((HEAP32[($2 + 68 | 0) >> 2] | 0) + 64 | 0) >> 2] = HEAP32[($2 + 64 | 0) >> 2] | 0;
   HEAP32[((HEAP32[($2 + 64 | 0) >> 2] | 0) + 68 | 0) >> 2] = HEAP32[($2 + 68 | 0) >> 2] | 0;
   $5 = HEAP32[($1 + 32 | 0) >> 2] | 0;
   $6 = HEAP32[($5 + 64 | 0) >> 2] | 0;
   HEAP32[($2 + 68 | 0) >> 2] = $5;
   HEAP32[($2 + 64 | 0) >> 2] = $6;
   $5 = $5 + 64 | 0;
  }
  HEAP32[$5 >> 2] = $2;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $11;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[((HEAP32[($2 + 64 | 0) >> 2] | 0) + 68 | 0) >> 2] = $2;
  memcpy(i64toi32_i32$0 + 8 | 0 | 0, $4 + 112 | 0 | 0, 64 | 0) | 0;
  global$0 = $4 + 176 | 0;
 }
 
 function cardano_serialization_lib__utils__hash_script_data__h3bfd14619c9a5014($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $6 = 0, i64toi32_i32$2 = 0, $5 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $32 = 0, $65 = 0, $95 = 0, $145 = 0, $211 = 0, $215 = 0, $219 = 0, $222 = 0;
  $4 = global$0 - 96 | 0;
  global$0 = $4;
  i64toi32_i32$1 = $4;
  i64toi32_i32$0 = 0;
  HEAP32[($4 + 20 | 0) >> 2] = 0;
  HEAP32[($4 + 24 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($4 + 16 | 0) >> 2] = HEAP32[(0 + 1057668 | 0) >> 2] | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     if (HEAP32[($1 + 8 | 0) >> 2] | 0) {
      break label$3
     }
     if ((HEAPU8[($3 + 12 | 0) >> 0] | 0 | 0) != (3 | 0)) {
      break label$2
     }
    }
    cardano_serialization_lib__plutus__Redeemers__to_bytes__hc16c7b4820f3e155($4 + 32 | 0 | 0, $1 | 0);
    $1 = ($4 + 80 | 0) + 8 | 0;
    $5 = ($4 + 32 | 0) + 8 | 0;
    HEAP32[$1 >> 2] = HEAP32[$5 >> 2] | 0;
    i64toi32_i32$2 = $4;
    i64toi32_i32$0 = HEAP32[($4 + 32 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($4 + 36 | 0) >> 2] | 0;
    $32 = i64toi32_i32$0;
    i64toi32_i32$0 = $4;
    HEAP32[($4 + 80 | 0) >> 2] = $32;
    HEAP32[($4 + 84 | 0) >> 2] = i64toi32_i32$1;
    alloc__raw_vec__RawVec_T_2cA___allocator__hdb3b360b6f01e581($4 + 80 | 0 | 0) | 0;
    $6 = HEAP32[($4 + 80 | 0) >> 2] | 0;
    HEAP32[($4 + 56 | 0) >> 2] = $6;
    HEAP32[($4 + 52 | 0) >> 2] = HEAP32[($4 + 84 | 0) >> 2] | 0;
    HEAP32[($4 + 48 | 0) >> 2] = $6;
    HEAP32[($4 + 60 | 0) >> 2] = $6 + (HEAP32[$1 >> 2] | 0) | 0;
    $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend_T_2calloc__vec__into_iter__IntoIter_T_____spec_extend__h93b6c942d0655498($4 + 16 | 0 | 0, $4 + 48 | 0 | 0);
    label$4 : {
     if ((HEAPU8[($3 + 12 | 0) >> 0] | 0 | 0) == (3 | 0)) {
      break label$4
     }
     cardano_serialization_lib__plutus__PlutusList__to_bytes__h13c74980ee8c70aa($4 + 32 | 0 | 0, $3 | 0);
     HEAP32[$1 >> 2] = HEAP32[$5 >> 2] | 0;
     i64toi32_i32$2 = $4;
     i64toi32_i32$1 = HEAP32[($4 + 32 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($4 + 36 | 0) >> 2] | 0;
     $65 = i64toi32_i32$1;
     i64toi32_i32$1 = $4;
     HEAP32[($4 + 80 | 0) >> 2] = $65;
     HEAP32[($4 + 84 | 0) >> 2] = i64toi32_i32$0;
     alloc__raw_vec__RawVec_T_2cA___allocator__hdb3b360b6f01e581($4 + 80 | 0 | 0) | 0;
     $6 = HEAP32[($4 + 80 | 0) >> 2] | 0;
     HEAP32[($4 + 56 | 0) >> 2] = $6;
     HEAP32[($4 + 52 | 0) >> 2] = HEAP32[($4 + 84 | 0) >> 2] | 0;
     HEAP32[($4 + 48 | 0) >> 2] = $6;
     HEAP32[($4 + 60 | 0) >> 2] = $6 + (HEAP32[$1 >> 2] | 0) | 0;
     $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend_T_2calloc__vec__into_iter__IntoIter_T_____spec_extend__h93b6c942d0655498($4 + 16 | 0 | 0, $4 + 48 | 0 | 0);
    }
    cardano_serialization_lib__plutus__Costmdls__language_views_encoding__h4ec764e7749aed37($4 + 32 | 0 | 0, $2 | 0);
    HEAP32[$1 >> 2] = HEAP32[$5 >> 2] | 0;
    i64toi32_i32$2 = $4;
    i64toi32_i32$0 = HEAP32[($4 + 32 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($4 + 36 | 0) >> 2] | 0;
    $95 = i64toi32_i32$0;
    i64toi32_i32$0 = $4;
    HEAP32[($4 + 80 | 0) >> 2] = $95;
    HEAP32[($4 + 84 | 0) >> 2] = i64toi32_i32$1;
    alloc__raw_vec__RawVec_T_2cA___allocator__hdb3b360b6f01e581($4 + 80 | 0 | 0) | 0;
    $6 = HEAP32[($4 + 80 | 0) >> 2] | 0;
    HEAP32[($4 + 56 | 0) >> 2] = $6;
    HEAP32[($4 + 52 | 0) >> 2] = HEAP32[($4 + 84 | 0) >> 2] | 0;
    HEAP32[($4 + 48 | 0) >> 2] = $6;
    HEAP32[($4 + 60 | 0) >> 2] = $6 + (HEAP32[$1 >> 2] | 0) | 0;
    $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend_T_2calloc__vec__into_iter__IntoIter_T_____spec_extend__h93b6c942d0655498($4 + 16 | 0 | 0, $4 + 48 | 0 | 0);
    break label$1;
   }
   alloc__vec__Vec_T_2cA___reserve__h9cf757d86af8f187($4 + 16 | 0 | 0, 1 | 0);
   HEAP8[((HEAP32[($4 + 16 | 0) >> 2] | 0) + (HEAP32[($4 + 24 | 0) >> 2] | 0) | 0) >> 0] = 128;
   $1 = (HEAP32[($4 + 24 | 0) >> 2] | 0) + 1 | 0;
   HEAP32[($4 + 24 | 0) >> 2] = $1;
   label$5 : {
    if ((HEAPU8[($3 + 12 | 0) >> 0] | 0 | 0) == (3 | 0)) {
     break label$5
    }
    cardano_serialization_lib__plutus__PlutusList__to_bytes__h13c74980ee8c70aa($4 + 32 | 0 | 0, $3 | 0);
    $6 = ($4 + 80 | 0) + 8 | 0;
    HEAP32[$6 >> 2] = HEAP32[(($4 + 32 | 0) + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 32 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($4 + 36 | 0) >> 2] | 0;
    $145 = i64toi32_i32$1;
    i64toi32_i32$1 = $4;
    HEAP32[($4 + 80 | 0) >> 2] = $145;
    HEAP32[($4 + 84 | 0) >> 2] = i64toi32_i32$0;
    alloc__raw_vec__RawVec_T_2cA___allocator__hdb3b360b6f01e581($4 + 80 | 0 | 0) | 0;
    $1 = HEAP32[($4 + 80 | 0) >> 2] | 0;
    HEAP32[($4 + 56 | 0) >> 2] = $1;
    HEAP32[($4 + 52 | 0) >> 2] = HEAP32[($4 + 84 | 0) >> 2] | 0;
    HEAP32[($4 + 48 | 0) >> 2] = $1;
    HEAP32[($4 + 60 | 0) >> 2] = $1 + (HEAP32[$6 >> 2] | 0) | 0;
    $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend_T_2calloc__vec__into_iter__IntoIter_T_____spec_extend__h93b6c942d0655498($4 + 16 | 0 | 0, $4 + 48 | 0 | 0);
    $1 = HEAP32[($4 + 24 | 0) >> 2] | 0;
   }
   label$6 : {
    if (($1 | 0) != (HEAP32[($4 + 20 | 0) >> 2] | 0 | 0)) {
     break label$6
    }
    alloc__vec__Vec_T_2cA___reserve__h9cf757d86af8f187($4 + 16 | 0 | 0, 1 | 0);
    $1 = HEAP32[($4 + 24 | 0) >> 2] | 0;
   }
   HEAP8[((HEAP32[($4 + 16 | 0) >> 2] | 0) + $1 | 0) >> 0] = 160;
   HEAP32[($4 + 24 | 0) >> 2] = (HEAP32[($4 + 24 | 0) >> 2] | 0) + 1 | 0;
  }
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($4 + 8 | 0 | 0, $4 + 16 | 0 | 0);
  $1 = ($4 + 48 | 0) + 8 | 0;
  i64toi32_i32$1 = $1;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $6 = ($4 + 48 | 0) + 16 | 0;
  i64toi32_i32$1 = $6;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $5 = ($4 + 48 | 0) + 24 | 0;
  i64toi32_i32$1 = $5;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$1 = $4;
  i64toi32_i32$0 = 0;
  HEAP32[($4 + 48 | 0) >> 2] = 0;
  HEAP32[($4 + 52 | 0) >> 2] = i64toi32_i32$0;
  cryptoxide__blake2b__Blake2b__blake2b__hfbfc741a485cb529($4 + 48 | 0 | 0, 32 | 0, HEAP32[($4 + 8 | 0) >> 2] | 0 | 0, HEAP32[($4 + 12 | 0) >> 2] | 0 | 0, 1066228 | 0, 0 | 0);
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $211 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 24 | 0;
  $18 = $211;
  HEAP8[i64toi32_i32$0 >> 0] = $18;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $18 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $18 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $18 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $6;
  i64toi32_i32$1 = HEAP32[$6 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($6 + 4 | 0) >> 2] | 0;
  $215 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 16 | 0;
  $19 = $215;
  HEAP8[i64toi32_i32$1 >> 0] = $19;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $19 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $19 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $19 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $219 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 8 | 0;
  $20 = $219;
  HEAP8[i64toi32_i32$0 >> 0] = $20;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $20 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $20 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $20 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = HEAP32[($4 + 48 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($4 + 52 | 0) >> 2] | 0;
  $222 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  $21 = $222;
  HEAP8[i64toi32_i32$1 >> 0] = $21;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $21 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $21 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $21 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($4 + 16 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($4 + 16 | 0 | 0);
  label$7 : {
   if ((HEAPU8[($3 + 12 | 0) >> 0] | 0 | 0) == (3 | 0)) {
    break label$7
   }
   label$8 : {
    $1 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if (!$1) {
     break label$8
    }
    $0 = HEAP32[$3 >> 2] | 0;
    $1 = Math_imul($1, 48);
    label$9 : while (1) {
     core__ptr__drop_in_place_cardano_serialization_lib__plutus__PlutusData___hfab843e66e0f9428_2($0 | 0);
     $0 = $0 + 48 | 0;
     $1 = $1 + -48 | 0;
     if ($1) {
      continue label$9
     }
     break label$9;
    };
   }
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h36e817e704f6f25e($3 | 0);
  }
  global$0 = $4 + 96 | 0;
 }
 
 function $cardano_serialization_lib__crypto__PoolMetadataHash_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hc26648f5daec7200($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, i64toi32_i32$2 = 0, $7 = 0, $4 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $25 = 0, $26 = 0, $27 = 0, $28 = 0, $7$hi = 0, $5 = 0, $29 = 0, $8 = 0, $8$hi = 0, $9 = 0, $9$hi = 0, $30 = 0, $31 = 0, $32 = 0, $33 = 0, $34 = 0, $6 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___bytes__hc697ccccfa39fd82($2 + 48 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ((HEAP32[($2 + 48 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      HEAP32[($2 + 32 | 0) >> 2] = HEAP32[($2 + 52 | 0) >> 2] | 0;
      $29 = HEAPU8[($2 + 57 | 0) >> 0] | 0 | ((HEAPU8[($2 + 58 | 0) >> 0] | 0) << 8 | 0) | 0;
      HEAP8[($2 + 37 | 0) >> 0] = $29;
      HEAP8[($2 + 38 | 0) >> 0] = $29 >>> 8 | 0;
      HEAP8[($2 + 36 | 0) >> 0] = HEAPU8[($2 + 56 | 0) >> 0] | 0;
      $1 = 11;
      HEAP8[($2 + 39 | 0) >> 0] = HEAPU8[(($2 + 48 | 0) + 11 | 0) >> 0] | 0;
      $3 = HEAP32[($2 + 60 | 0) >> 2] | 0;
      HEAP32[($2 + 40 | 0) >> 2] = $3;
      label$5 : {
       label$6 : {
        if (($3 | 0) != (32 | 0)) {
         break label$6
        }
        $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $2 + 32 | 0 | 0);
        $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
        if ($1 >>> 0 <= 31 >>> 0) {
         break label$1
        }
        $T_20as_20core__convert__TryInto_U____try_into__ha1ac58dc74faf560($2 + 48 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, 32 | 0);
        if ((HEAPU8[($2 + 48 | 0) >> 0] | 0 | 0) != (1 | 0)) {
         break label$5
        }
        core__result__unwrap_failed__h27f43d993c3864a1(1066120 | 0, 43 | 0, $2 + 24 | 0 | 0, 1066180 | 0, 1066956 | 0);
        abort();
       }
       i64toi32_i32$0 = 0;
       $7 = $3;
       $7$hi = i64toi32_i32$0;
       $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 32 | 0 | 0);
       $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 32 | 0 | 0);
       i64toi32_i32$0 = 0;
       $8 = 32;
       $8$hi = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       $9 = 1;
       $9$hi = i64toi32_i32$0;
       $3 = 1066390;
       $4 = 13;
       break label$3;
      }
      $16 = ($2 + 48 | 0) + 9 | 0;
      $17 = $0 + 9 | 0;
      $18 = HEAPU8[$16 >> 0] | 0 | ((HEAPU8[($16 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($16 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($16 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[$17 >> 0] = $18;
      HEAP8[($17 + 1 | 0) >> 0] = $18 >>> 8 | 0;
      HEAP8[($17 + 2 | 0) >> 0] = $18 >>> 16 | 0;
      HEAP8[($17 + 3 | 0) >> 0] = $18 >>> 24 | 0;
      $19 = ($2 + 48 | 0) + 12 | 0;
      $20 = $0 + 12 | 0;
      $21 = HEAPU8[$19 >> 0] | 0 | ((HEAPU8[($19 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($19 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($19 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[$20 >> 0] = $21;
      HEAP8[($20 + 1 | 0) >> 0] = $21 >>> 8 | 0;
      HEAP8[($20 + 2 | 0) >> 0] = $21 >>> 16 | 0;
      HEAP8[($20 + 3 | 0) >> 0] = $21 >>> 24 | 0;
      $1 = $2 + 22 | 0;
      HEAP8[$1 >> 0] = HEAPU8[(($2 + 48 | 0) + 19 | 0) >> 0] | 0;
      $22 = HEAPU8[($2 + 52 | 0) >> 0] | 0 | ((HEAPU8[($2 + 53 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 54 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 55 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[($2 + 28 | 0) >> 0] = $22;
      HEAP8[($2 + 29 | 0) >> 0] = $22 >>> 8 | 0;
      HEAP8[($2 + 30 | 0) >> 0] = $22 >>> 16 | 0;
      HEAP8[($2 + 31 | 0) >> 0] = $22 >>> 24 | 0;
      $23 = HEAPU8[($2 + 49 | 0) >> 0] | 0 | ((HEAPU8[($2 + 50 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 51 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 52 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[($2 + 25 | 0) >> 0] = $23;
      HEAP8[($2 + 26 | 0) >> 0] = $23 >>> 8 | 0;
      HEAP8[($2 + 27 | 0) >> 0] = $23 >>> 16 | 0;
      HEAP8[($2 + 28 | 0) >> 0] = $23 >>> 24 | 0;
      $30 = ($2 + 48 | 0) + 17 | 0;
      HEAP16[($2 + 20 | 0) >> 1] = HEAPU8[$30 >> 0] | 0 | ((HEAPU8[($30 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
      i64toi32_i32$2 = ($2 + 48 | 0) + 20 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $7 = i64toi32_i32$0;
      $7$hi = i64toi32_i32$1;
      $3 = HEAP32[(($2 + 48 | 0) + 28 | 0) >> 2] | 0;
      $4 = HEAPU8[(($2 + 48 | 0) + 32 | 0) >> 0] | 0;
      $5 = HEAPU8[(($2 + 48 | 0) + 8 | 0) >> 0] | 0;
      $6 = HEAPU8[(($2 + 48 | 0) + 16 | 0) >> 0] | 0;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 32 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 32 | 0 | 0);
      $24 = $0 + 4 | 0;
      $25 = HEAPU8[($2 + 28 | 0) >> 0] | 0 | ((HEAPU8[($2 + 29 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 30 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 31 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[$24 >> 0] = $25;
      HEAP8[($24 + 1 | 0) >> 0] = $25 >>> 8 | 0;
      HEAP8[($24 + 2 | 0) >> 0] = $25 >>> 16 | 0;
      HEAP8[($24 + 3 | 0) >> 0] = $25 >>> 24 | 0;
      $26 = HEAPU8[($2 + 25 | 0) >> 0] | 0 | ((HEAPU8[($2 + 26 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 27 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 28 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[($0 + 1 | 0) >> 0] = $26;
      HEAP8[($0 + 2 | 0) >> 0] = $26 >>> 8 | 0;
      HEAP8[($0 + 3 | 0) >> 0] = $26 >>> 16 | 0;
      HEAP8[($0 + 4 | 0) >> 0] = $26 >>> 24 | 0;
      HEAP8[($0 + 16 | 0) >> 0] = $6;
      HEAP8[($0 + 8 | 0) >> 0] = $5;
      $31 = $0 + 17 | 0;
      $32 = HEAPU16[($2 + 20 | 0) >> 1] | 0;
      HEAP8[$31 >> 0] = $32;
      HEAP8[($31 + 1 | 0) >> 0] = $32 >>> 8 | 0;
      HEAP8[($0 + 19 | 0) >> 0] = HEAPU8[$1 >> 0] | 0;
      HEAP8[($0 + 32 | 0) >> 0] = $4;
      $27 = $0 + 28 | 0;
      HEAP8[$27 >> 0] = $3;
      HEAP8[($27 + 1 | 0) >> 0] = $3 >>> 8 | 0;
      HEAP8[($27 + 2 | 0) >> 0] = $3 >>> 16 | 0;
      HEAP8[($27 + 3 | 0) >> 0] = $3 >>> 24 | 0;
      i64toi32_i32$0 = $0 + 20 | 0;
      $28 = $7;
      HEAP8[i64toi32_i32$0 >> 0] = $28;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $28 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $28 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $28 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      $1 = 0;
      break label$2;
     }
     HEAP8[($2 + 22 | 0) >> 0] = HEAPU8[($2 + 59 | 0) >> 0] | 0;
     $1 = HEAPU8[($2 + 57 | 0) >> 0] | 0 | ((HEAPU8[($2 + 58 | 0) >> 0] | 0) << 8 | 0) | 0;
     HEAP16[($2 + 24 | 0) >> 1] = $1;
     HEAP16[($2 + 20 | 0) >> 1] = $1;
     $4 = HEAPU8[($2 + 56 | 0) >> 0] | 0;
     $3 = HEAP32[($2 + 60 | 0) >> 2] | 0;
     $1 = HEAP32[($2 + 64 | 0) >> 2] | 0;
     $5 = HEAP32[($2 + 68 | 0) >> 2] | 0;
     i64toi32_i32$2 = $2 + 72 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $8 = i64toi32_i32$1;
     $8$hi = i64toi32_i32$0;
     i64toi32_i32$2 = $2 + 80 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $9 = i64toi32_i32$0;
     $9$hi = i64toi32_i32$1;
     i64toi32_i32$2 = $2 + 88 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $7 = i64toi32_i32$1;
     $7$hi = i64toi32_i32$0;
    }
    HEAP8[(($2 + 48 | 0) + 8 | 0) >> 0] = $4;
    $33 = $2 + 57 | 0;
    $34 = HEAPU16[($2 + 20 | 0) >> 1] | 0;
    HEAP8[$33 >> 0] = $34;
    HEAP8[($33 + 1 | 0) >> 0] = $34 >>> 8 | 0;
    i64toi32_i32$0 = $7$hi;
    i64toi32_i32$1 = $2 + 88 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $7;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = $9$hi;
    i64toi32_i32$1 = $2 + 80 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $9;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = $8$hi;
    i64toi32_i32$1 = $2 + 72 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $8;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($2 + 68 | 0) >> 2] = $5;
    HEAP32[(($2 + 48 | 0) + 16 | 0) >> 2] = $1;
    HEAP32[($2 + 60 | 0) >> 2] = $3;
    HEAP8[($2 + 48 | 0) >> 0] = 2;
    HEAP8[($2 + 59 | 0) >> 0] = HEAPU8[(($2 + 20 | 0) + 2 | 0) >> 0] | 0;
    HEAP32[($2 + 96 | 0) >> 2] = 0;
    cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 48 | 0 | 0, 1066972 | 0, 16 | 0);
    $1 = 1;
   }
   HEAP8[$0 >> 0] = $1;
   global$0 = $2 + 112 | 0;
   return;
  }
  core__slice__index__slice_end_index_len_fail__h192505a15ac4b345(32 | 0, $1 | 0, 1066956 | 0);
  abort();
 }
 
 function $cardano_serialization_lib__crypto__BlockHash_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h8933d5e4c20cf015($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, i64toi32_i32$2 = 0, $7 = 0, $4 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $25 = 0, $26 = 0, $27 = 0, $28 = 0, $7$hi = 0, $5 = 0, $29 = 0, $8 = 0, $8$hi = 0, $9 = 0, $9$hi = 0, $30 = 0, $31 = 0, $32 = 0, $33 = 0, $34 = 0, $6 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___bytes__hc697ccccfa39fd82($2 + 48 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ((HEAP32[($2 + 48 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      HEAP32[($2 + 32 | 0) >> 2] = HEAP32[($2 + 52 | 0) >> 2] | 0;
      $29 = HEAPU8[($2 + 57 | 0) >> 0] | 0 | ((HEAPU8[($2 + 58 | 0) >> 0] | 0) << 8 | 0) | 0;
      HEAP8[($2 + 37 | 0) >> 0] = $29;
      HEAP8[($2 + 38 | 0) >> 0] = $29 >>> 8 | 0;
      HEAP8[($2 + 36 | 0) >> 0] = HEAPU8[($2 + 56 | 0) >> 0] | 0;
      $1 = 11;
      HEAP8[($2 + 39 | 0) >> 0] = HEAPU8[(($2 + 48 | 0) + 11 | 0) >> 0] | 0;
      $3 = HEAP32[($2 + 60 | 0) >> 2] | 0;
      HEAP32[($2 + 40 | 0) >> 2] = $3;
      label$5 : {
       label$6 : {
        if (($3 | 0) != (32 | 0)) {
         break label$6
        }
        $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $2 + 32 | 0 | 0);
        $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
        if ($1 >>> 0 <= 31 >>> 0) {
         break label$1
        }
        $T_20as_20core__convert__TryInto_U____try_into__ha1ac58dc74faf560($2 + 48 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, 32 | 0);
        if ((HEAPU8[($2 + 48 | 0) >> 0] | 0 | 0) != (1 | 0)) {
         break label$5
        }
        core__result__unwrap_failed__h27f43d993c3864a1(1066120 | 0, 43 | 0, $2 + 24 | 0 | 0, 1066180 | 0, 1067016 | 0);
        abort();
       }
       i64toi32_i32$0 = 0;
       $7 = $3;
       $7$hi = i64toi32_i32$0;
       $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 32 | 0 | 0);
       $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 32 | 0 | 0);
       i64toi32_i32$0 = 0;
       $8 = 32;
       $8$hi = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       $9 = 1;
       $9$hi = i64toi32_i32$0;
       $3 = 1066390;
       $4 = 13;
       break label$3;
      }
      $16 = ($2 + 48 | 0) + 9 | 0;
      $17 = $0 + 9 | 0;
      $18 = HEAPU8[$16 >> 0] | 0 | ((HEAPU8[($16 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($16 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($16 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[$17 >> 0] = $18;
      HEAP8[($17 + 1 | 0) >> 0] = $18 >>> 8 | 0;
      HEAP8[($17 + 2 | 0) >> 0] = $18 >>> 16 | 0;
      HEAP8[($17 + 3 | 0) >> 0] = $18 >>> 24 | 0;
      $19 = ($2 + 48 | 0) + 12 | 0;
      $20 = $0 + 12 | 0;
      $21 = HEAPU8[$19 >> 0] | 0 | ((HEAPU8[($19 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($19 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($19 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[$20 >> 0] = $21;
      HEAP8[($20 + 1 | 0) >> 0] = $21 >>> 8 | 0;
      HEAP8[($20 + 2 | 0) >> 0] = $21 >>> 16 | 0;
      HEAP8[($20 + 3 | 0) >> 0] = $21 >>> 24 | 0;
      $1 = $2 + 22 | 0;
      HEAP8[$1 >> 0] = HEAPU8[(($2 + 48 | 0) + 19 | 0) >> 0] | 0;
      $22 = HEAPU8[($2 + 52 | 0) >> 0] | 0 | ((HEAPU8[($2 + 53 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 54 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 55 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[($2 + 28 | 0) >> 0] = $22;
      HEAP8[($2 + 29 | 0) >> 0] = $22 >>> 8 | 0;
      HEAP8[($2 + 30 | 0) >> 0] = $22 >>> 16 | 0;
      HEAP8[($2 + 31 | 0) >> 0] = $22 >>> 24 | 0;
      $23 = HEAPU8[($2 + 49 | 0) >> 0] | 0 | ((HEAPU8[($2 + 50 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 51 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 52 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[($2 + 25 | 0) >> 0] = $23;
      HEAP8[($2 + 26 | 0) >> 0] = $23 >>> 8 | 0;
      HEAP8[($2 + 27 | 0) >> 0] = $23 >>> 16 | 0;
      HEAP8[($2 + 28 | 0) >> 0] = $23 >>> 24 | 0;
      $30 = ($2 + 48 | 0) + 17 | 0;
      HEAP16[($2 + 20 | 0) >> 1] = HEAPU8[$30 >> 0] | 0 | ((HEAPU8[($30 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
      i64toi32_i32$2 = ($2 + 48 | 0) + 20 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $7 = i64toi32_i32$0;
      $7$hi = i64toi32_i32$1;
      $3 = HEAP32[(($2 + 48 | 0) + 28 | 0) >> 2] | 0;
      $4 = HEAPU8[(($2 + 48 | 0) + 32 | 0) >> 0] | 0;
      $5 = HEAPU8[(($2 + 48 | 0) + 8 | 0) >> 0] | 0;
      $6 = HEAPU8[(($2 + 48 | 0) + 16 | 0) >> 0] | 0;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 32 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 32 | 0 | 0);
      $24 = $0 + 4 | 0;
      $25 = HEAPU8[($2 + 28 | 0) >> 0] | 0 | ((HEAPU8[($2 + 29 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 30 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 31 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[$24 >> 0] = $25;
      HEAP8[($24 + 1 | 0) >> 0] = $25 >>> 8 | 0;
      HEAP8[($24 + 2 | 0) >> 0] = $25 >>> 16 | 0;
      HEAP8[($24 + 3 | 0) >> 0] = $25 >>> 24 | 0;
      $26 = HEAPU8[($2 + 25 | 0) >> 0] | 0 | ((HEAPU8[($2 + 26 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 27 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 28 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[($0 + 1 | 0) >> 0] = $26;
      HEAP8[($0 + 2 | 0) >> 0] = $26 >>> 8 | 0;
      HEAP8[($0 + 3 | 0) >> 0] = $26 >>> 16 | 0;
      HEAP8[($0 + 4 | 0) >> 0] = $26 >>> 24 | 0;
      HEAP8[($0 + 16 | 0) >> 0] = $6;
      HEAP8[($0 + 8 | 0) >> 0] = $5;
      $31 = $0 + 17 | 0;
      $32 = HEAPU16[($2 + 20 | 0) >> 1] | 0;
      HEAP8[$31 >> 0] = $32;
      HEAP8[($31 + 1 | 0) >> 0] = $32 >>> 8 | 0;
      HEAP8[($0 + 19 | 0) >> 0] = HEAPU8[$1 >> 0] | 0;
      HEAP8[($0 + 32 | 0) >> 0] = $4;
      $27 = $0 + 28 | 0;
      HEAP8[$27 >> 0] = $3;
      HEAP8[($27 + 1 | 0) >> 0] = $3 >>> 8 | 0;
      HEAP8[($27 + 2 | 0) >> 0] = $3 >>> 16 | 0;
      HEAP8[($27 + 3 | 0) >> 0] = $3 >>> 24 | 0;
      i64toi32_i32$0 = $0 + 20 | 0;
      $28 = $7;
      HEAP8[i64toi32_i32$0 >> 0] = $28;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $28 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $28 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $28 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      $1 = 0;
      break label$2;
     }
     HEAP8[($2 + 22 | 0) >> 0] = HEAPU8[($2 + 59 | 0) >> 0] | 0;
     $1 = HEAPU8[($2 + 57 | 0) >> 0] | 0 | ((HEAPU8[($2 + 58 | 0) >> 0] | 0) << 8 | 0) | 0;
     HEAP16[($2 + 24 | 0) >> 1] = $1;
     HEAP16[($2 + 20 | 0) >> 1] = $1;
     $4 = HEAPU8[($2 + 56 | 0) >> 0] | 0;
     $3 = HEAP32[($2 + 60 | 0) >> 2] | 0;
     $1 = HEAP32[($2 + 64 | 0) >> 2] | 0;
     $5 = HEAP32[($2 + 68 | 0) >> 2] | 0;
     i64toi32_i32$2 = $2 + 72 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $8 = i64toi32_i32$1;
     $8$hi = i64toi32_i32$0;
     i64toi32_i32$2 = $2 + 80 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $9 = i64toi32_i32$0;
     $9$hi = i64toi32_i32$1;
     i64toi32_i32$2 = $2 + 88 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $7 = i64toi32_i32$1;
     $7$hi = i64toi32_i32$0;
    }
    HEAP8[(($2 + 48 | 0) + 8 | 0) >> 0] = $4;
    $33 = ($2 + 48 | 0) + 9 | 0;
    $34 = HEAPU16[($2 + 20 | 0) >> 1] | 0;
    HEAP8[$33 >> 0] = $34;
    HEAP8[($33 + 1 | 0) >> 0] = $34 >>> 8 | 0;
    i64toi32_i32$0 = $7$hi;
    i64toi32_i32$1 = $2 + 88 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $7;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = $9$hi;
    i64toi32_i32$1 = $2 + 80 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $9;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = $8$hi;
    i64toi32_i32$1 = $2 + 72 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $8;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($2 + 68 | 0) >> 2] = $5;
    HEAP32[($2 + 64 | 0) >> 2] = $1;
    HEAP32[($2 + 60 | 0) >> 2] = $3;
    HEAP8[($2 + 48 | 0) >> 0] = 2;
    HEAP8[($2 + 59 | 0) >> 0] = HEAPU8[(($2 + 20 | 0) + 2 | 0) >> 0] | 0;
    HEAP32[($2 + 96 | 0) >> 2] = 0;
    cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 48 | 0 | 0, 1067032 | 0, 9 | 0);
    $1 = 1;
   }
   HEAP8[$0 >> 0] = $1;
   global$0 = $2 + 112 | 0;
   return;
  }
  core__slice__index__slice_end_index_len_fail__h192505a15ac4b345(32 | 0, $1 | 0, 1067016 | 0);
  abort();
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__StakeDeregistration___deserialize_as_embedded_group__h26da61dcbe3232ba($0, $1, $2, $2$hi, $3, $3$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  var i64toi32_i32$3 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $4 = 0, $5 = 0, $6 = 0, i64toi32_i32$0 = 0, $8 = 0, $11 = 0, $11$hi = 0, i64toi32_i32$4 = 0, $43 = 0, $44 = 0, $45 = 0, $46 = 0, $47 = 0, $48 = 0, $49 = 0, $50 = 0, $51 = 0, $52 = 0, $53 = 0, $54 = 0, $10 = 0, $10$hi = 0, $7 = 0, $55 = 0, $12 = 0, $12$hi = 0, $9 = 0, $92 = 0, $100 = 0, $106 = 0, $112 = 0, $120 = 0, $126 = 0, $132 = 0, $135 = 0, $141 = 0, $147 = 0, $153 = 0, $156 = 0, $162 = 0, $168 = 0, $174 = 0, $177 = 0, $182 = 0, $186 = 0, $190 = 0, $193 = 0;
  $4 = global$0 - 400 | 0;
  global$0 = $4;
  cbor_event__de__Deserializer_R___unsigned_integer__h1ed99c0b7fe7eea1($4 + 328 | 0 | 0, $1 | 0);
  i64toi32_i32$0 = 0;
  $10 = 1;
  $10$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 336 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 340 | 0) >> 2] | 0;
  $11 = i64toi32_i32$0;
  $11$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 328 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 332 | 0) >> 2] | 0;
        i64toi32_i32$2 = i64toi32_i32$1;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
         break label$6
        }
        i64toi32_i32$2 = $11$hi;
        i64toi32_i32$3 = $11;
        i64toi32_i32$0 = 0;
        i64toi32_i32$1 = 1;
        if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) | 0) {
         break label$4
        }
        $5 = 8;
        $6 = 1;
        $7 = 1;
        break label$5;
       }
       i64toi32_i32$3 = $11$hi;
       i64toi32_i32$1 = $11;
       i64toi32_i32$2 = 0;
       i64toi32_i32$0 = 32;
       i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = 0;
        $55 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$2 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
        $55 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
       }
       $8 = $55;
       i64toi32_i32$3 = $4 + 368 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $12 = i64toi32_i32$2;
       $12$hi = i64toi32_i32$1;
       i64toi32_i32$3 = $4 + 360 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $10 = i64toi32_i32$1;
       $10$hi = i64toi32_i32$2;
       $9 = HEAP32[($4 + 356 | 0) >> 2] | 0;
       $7 = HEAP32[($4 + 352 | 0) >> 2] | 0;
       i64toi32_i32$2 = $11$hi;
       $6 = $11;
       $5 = 2;
       i64toi32_i32$3 = $4 + 344 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $11 = i64toi32_i32$2;
       $11$hi = i64toi32_i32$1;
      }
      i64toi32_i32$1 = $12$hi;
      i64toi32_i32$2 = $4 + 368 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $12;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$1 = $10$hi;
      i64toi32_i32$2 = $4 + 360 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $10;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($4 + 356 | 0) >> 2] = $9;
      HEAP32[($4 + 352 | 0) >> 2] = $7;
      i64toi32_i32$1 = $11$hi;
      i64toi32_i32$2 = $4 + 344 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $11;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($4 + 340 | 0) >> 2] = $8;
      HEAP32[(($4 + 328 | 0) + 8 | 0) >> 2] = $6;
      HEAP32[($4 + 376 | 0) >> 2] = 0;
      HEAP8[($4 + 328 | 0) >> 0] = $5;
      cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($4 + 112 | 0 | 0, $4 + 328 | 0 | 0, 1050766 | 0, 7 | 0);
      $5 = HEAPU8[($4 + 112 | 0) >> 0] | 0;
      if (($5 | 0) != (19 | 0)) {
       break label$3
      }
     }
     $cardano_serialization_lib__address__StakeCredential_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__ha21a31a5230d4f02($4 + 328 | 0 | 0, $1 | 0);
     if ((HEAPU8[($4 + 328 | 0) >> 0] | 0 | 0) == (1 | 0)) {
      break label$2
     }
     $1 = ($4 + 256 | 0) + 21 | 0;
     i64toi32_i32$3 = ($4 + 328 | 0) + 22 | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$2 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $92 = i64toi32_i32$1;
     i64toi32_i32$1 = $1;
     $43 = $92;
     HEAP8[i64toi32_i32$1 >> 0] = $43;
     HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $43 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $43 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $43 >>> 24 | 0;
     HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$2;
     HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
     $5 = ($4 + 256 | 0) + 16 | 0;
     i64toi32_i32$3 = ($4 + 328 | 0) + 17 | 0;
     i64toi32_i32$2 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $100 = i64toi32_i32$2;
     i64toi32_i32$2 = $5;
     HEAP32[i64toi32_i32$2 >> 2] = $100;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     $6 = ($4 + 184 | 0) + 16 | 0;
     i64toi32_i32$3 = i64toi32_i32$2;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $106 = i64toi32_i32$1;
     i64toi32_i32$1 = $6;
     HEAP32[i64toi32_i32$1 >> 2] = $106;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
     $5 = ($4 + 184 | 0) + 21 | 0;
     i64toi32_i32$3 = $1;
     i64toi32_i32$2 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $112 = i64toi32_i32$2;
     i64toi32_i32$2 = $5;
     $44 = $112;
     HEAP8[i64toi32_i32$2 >> 0] = $44;
     HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $44 >>> 8 | 0;
     HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $44 >>> 16 | 0;
     HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $44 >>> 24 | 0;
     HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$1;
     HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
     HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
     HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
     $1 = ($4 + 112 | 0) + 9 | 0;
     i64toi32_i32$3 = ($4 + 328 | 0) + 9 | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$2 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $120 = i64toi32_i32$1;
     i64toi32_i32$1 = $1;
     $45 = $120;
     HEAP8[i64toi32_i32$1 >> 0] = $45;
     HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $45 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $45 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $45 >>> 24 | 0;
     HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$2;
     HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
     $8 = ($4 + 112 | 0) + 17 | 0;
     i64toi32_i32$3 = $6;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $126 = i64toi32_i32$2;
     i64toi32_i32$2 = $8;
     $46 = $126;
     HEAP8[i64toi32_i32$2 >> 0] = $46;
     HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $46 >>> 8 | 0;
     HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $46 >>> 16 | 0;
     HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $46 >>> 24 | 0;
     HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$1;
     HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
     HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
     HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
     $6 = ($4 + 112 | 0) + 22 | 0;
     i64toi32_i32$3 = $5;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$2 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $132 = i64toi32_i32$1;
     i64toi32_i32$1 = $6;
     $47 = $132;
     HEAP8[i64toi32_i32$1 >> 0] = $47;
     HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $47 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $47 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $47 >>> 24 | 0;
     HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$2;
     HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
     i64toi32_i32$3 = $4;
     i64toi32_i32$2 = HEAPU8[(i64toi32_i32$3 + 329 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 330 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 331 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 332 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$3 + 333 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 334 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 335 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 336 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $135 = i64toi32_i32$2;
     i64toi32_i32$2 = i64toi32_i32$3;
     $48 = $135;
     HEAP8[(i64toi32_i32$2 + 113 | 0) >> 0] = $48;
     HEAP8[(i64toi32_i32$2 + 114 | 0) >> 0] = $48 >>> 8 | 0;
     HEAP8[(i64toi32_i32$2 + 115 | 0) >> 0] = $48 >>> 16 | 0;
     HEAP8[(i64toi32_i32$2 + 116 | 0) >> 0] = $48 >>> 24 | 0;
     HEAP8[(i64toi32_i32$2 + 117 | 0) >> 0] = i64toi32_i32$1;
     HEAP8[(i64toi32_i32$2 + 118 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
     HEAP8[(i64toi32_i32$2 + 119 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
     HEAP8[(i64toi32_i32$2 + 120 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
     $5 = (i64toi32_i32$2 + 40 | 0) + 21 | 0;
     i64toi32_i32$3 = $6;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$2 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $141 = i64toi32_i32$1;
     i64toi32_i32$1 = $5;
     $49 = $141;
     HEAP8[i64toi32_i32$1 >> 0] = $49;
     HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $49 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $49 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $49 >>> 24 | 0;
     HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$2;
     HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
     $6 = ($4 + 40 | 0) + 16 | 0;
     i64toi32_i32$3 = $8;
     i64toi32_i32$2 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $147 = i64toi32_i32$2;
     i64toi32_i32$2 = $6;
     HEAP32[i64toi32_i32$2 >> 2] = $147;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     $8 = ($4 + 40 | 0) + 8 | 0;
     i64toi32_i32$3 = $1;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$2 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $153 = i64toi32_i32$1;
     i64toi32_i32$1 = $8;
     HEAP32[i64toi32_i32$1 >> 2] = $153;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$3 = $4;
     i64toi32_i32$2 = HEAPU8[(i64toi32_i32$3 + 113 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 114 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 115 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 116 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$3 + 117 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 118 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 119 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 120 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $156 = i64toi32_i32$2;
     i64toi32_i32$2 = i64toi32_i32$3;
     HEAP32[(i64toi32_i32$3 + 40 | 0) >> 2] = $156;
     HEAP32[(i64toi32_i32$3 + 44 | 0) >> 2] = i64toi32_i32$1;
     $1 = (i64toi32_i32$3 + 8 | 0) + 21 | 0;
     i64toi32_i32$3 = $5;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$2 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $162 = i64toi32_i32$1;
     i64toi32_i32$1 = $1;
     $50 = $162;
     HEAP8[i64toi32_i32$1 >> 0] = $50;
     HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $50 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $50 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $50 >>> 24 | 0;
     HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$2;
     HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
     $5 = ($4 + 8 | 0) + 16 | 0;
     i64toi32_i32$3 = $6;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $168 = i64toi32_i32$2;
     i64toi32_i32$2 = $5;
     HEAP32[i64toi32_i32$2 >> 2] = $168;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     $6 = ($4 + 8 | 0) + 8 | 0;
     i64toi32_i32$3 = $8;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $174 = i64toi32_i32$1;
     i64toi32_i32$1 = $6;
     HEAP32[i64toi32_i32$1 >> 2] = $174;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$3 = $4;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 40 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 44 | 0) >> 2] | 0;
     $177 = i64toi32_i32$2;
     i64toi32_i32$2 = i64toi32_i32$3;
     HEAP32[(i64toi32_i32$3 + 8 | 0) >> 2] = $177;
     HEAP32[(i64toi32_i32$3 + 12 | 0) >> 2] = i64toi32_i32$1;
     HEAP8[$0 >> 0] = 0;
     i64toi32_i32$3 = $1;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$2 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $182 = i64toi32_i32$1;
     i64toi32_i32$1 = $0 + 22 | 0;
     $51 = $182;
     HEAP8[i64toi32_i32$1 >> 0] = $51;
     HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $51 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $51 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $51 >>> 24 | 0;
     HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$2;
     HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
     i64toi32_i32$3 = $5;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $186 = i64toi32_i32$2;
     i64toi32_i32$2 = $0 + 17 | 0;
     $52 = $186;
     HEAP8[i64toi32_i32$2 >> 0] = $52;
     HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $52 >>> 8 | 0;
     HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $52 >>> 16 | 0;
     HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $52 >>> 24 | 0;
     HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$1;
     HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
     HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
     HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
     i64toi32_i32$3 = $6;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $190 = i64toi32_i32$1;
     i64toi32_i32$1 = $0 + 9 | 0;
     $53 = $190;
     HEAP8[i64toi32_i32$1 >> 0] = $53;
     HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $53 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $53 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $53 >>> 24 | 0;
     HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$2;
     HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
     i64toi32_i32$3 = $4;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 8 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 12 | 0) >> 2] | 0;
     $193 = i64toi32_i32$2;
     i64toi32_i32$2 = $0;
     $54 = $193;
     HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $54;
     HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $54 >>> 8 | 0;
     HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $54 >>> 16 | 0;
     HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = $54 >>> 24 | 0;
     HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$1;
     HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
     HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
     HEAP8[(i64toi32_i32$2 + 8 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
     break label$1;
    }
    memcpy($0 + 9 | 0 | 0, $4 + 112 | 0 | 1 | 0 | 0, 63 | 0) | 0;
    HEAP8[$0 >> 0] = 1;
    HEAP8[($0 + 8 | 0) >> 0] = $5;
    break label$1;
   }
   memcpy($4 + 328 | 0 | 0, memcpy($4 + 184 | 0 | 7 | 0 | 0, memcpy($4 + 256 | 0 | 7 | 0 | 0, ($4 + 328 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   $1 = ($4 + 112 | 0) + 8 | 0;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 328 | 0 | 0, 1050773 | 0, 16 | 0);
   memcpy($0 + 8 | 0 | 0, memcpy($4 + 40 | 0 | 7 | 0 | 0, $1 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   HEAP8[$0 >> 0] = 1;
  }
  global$0 = $4 + 400 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__StakeRegistration___deserialize_as_embedded_group__h584ad4f96a0a79b8($0, $1, $2, $2$hi, $3, $3$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, $4 = 0, $5 = 0, $6 = 0, i64toi32_i32$1 = 0, $8 = 0, $10 = 0, $10$hi = 0, i64toi32_i32$4 = 0, $43 = 0, $44 = 0, $45 = 0, $46 = 0, $47 = 0, $48 = 0, $49 = 0, $50 = 0, $51 = 0, $52 = 0, $53 = 0, $54 = 0, $11 = 0, $11$hi = 0, $7 = 0, $55 = 0, $12 = 0, $12$hi = 0, $9 = 0, $92 = 0, $100 = 0, $106 = 0, $112 = 0, $120 = 0, $126 = 0, $132 = 0, $135 = 0, $141 = 0, $147 = 0, $153 = 0, $156 = 0, $162 = 0, $168 = 0, $174 = 0, $177 = 0, $182 = 0, $186 = 0, $190 = 0, $193 = 0;
  $4 = global$0 - 400 | 0;
  global$0 = $4;
  cbor_event__de__Deserializer_R___unsigned_integer__h1ed99c0b7fe7eea1($4 + 328 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 336 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 340 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 328 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 332 | 0) >> 2] | 0;
        i64toi32_i32$2 = i64toi32_i32$1;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
         break label$6
        }
        i64toi32_i32$2 = $10$hi;
        if (!($10 | i64toi32_i32$2 | 0)) {
         break label$4
        }
        $5 = 8;
        i64toi32_i32$2 = 0;
        $11 = 0;
        $11$hi = i64toi32_i32$2;
        $6 = 1;
        $7 = 1;
        break label$5;
       }
       i64toi32_i32$2 = $10$hi;
       i64toi32_i32$3 = $10;
       i64toi32_i32$0 = 0;
       i64toi32_i32$1 = 32;
       i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = 0;
        $55 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
        $55 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$4 | 0) | 0;
       }
       $8 = $55;
       i64toi32_i32$2 = $4 + 368 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $12 = i64toi32_i32$0;
       $12$hi = i64toi32_i32$3;
       i64toi32_i32$2 = $4 + 360 | 0;
       i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $11 = i64toi32_i32$3;
       $11$hi = i64toi32_i32$0;
       $9 = HEAP32[($4 + 356 | 0) >> 2] | 0;
       $7 = HEAP32[($4 + 352 | 0) >> 2] | 0;
       i64toi32_i32$0 = $10$hi;
       $6 = $10;
       $5 = 2;
       i64toi32_i32$2 = $4 + 344 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $10 = i64toi32_i32$0;
       $10$hi = i64toi32_i32$3;
      }
      i64toi32_i32$3 = $12$hi;
      i64toi32_i32$0 = $4 + 368 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $12;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
      i64toi32_i32$3 = $11$hi;
      i64toi32_i32$0 = $4 + 360 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $11;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
      HEAP32[($4 + 356 | 0) >> 2] = $9;
      HEAP32[($4 + 352 | 0) >> 2] = $7;
      i64toi32_i32$3 = $10$hi;
      i64toi32_i32$0 = $4 + 344 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $10;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
      HEAP32[($4 + 340 | 0) >> 2] = $8;
      HEAP32[(($4 + 328 | 0) + 8 | 0) >> 2] = $6;
      HEAP32[($4 + 376 | 0) >> 2] = 0;
      HEAP8[($4 + 328 | 0) >> 0] = $5;
      cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($4 + 112 | 0 | 0, $4 + 328 | 0 | 0, 1050766 | 0, 7 | 0);
      $5 = HEAPU8[($4 + 112 | 0) >> 0] | 0;
      if (($5 | 0) != (19 | 0)) {
       break label$3
      }
     }
     $cardano_serialization_lib__address__StakeCredential_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__ha21a31a5230d4f02($4 + 328 | 0 | 0, $1 | 0);
     if ((HEAPU8[($4 + 328 | 0) >> 0] | 0 | 0) == (1 | 0)) {
      break label$2
     }
     $1 = ($4 + 256 | 0) + 21 | 0;
     i64toi32_i32$2 = ($4 + 328 | 0) + 22 | 0;
     i64toi32_i32$3 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $92 = i64toi32_i32$3;
     i64toi32_i32$3 = $1;
     $43 = $92;
     HEAP8[i64toi32_i32$3 >> 0] = $43;
     HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $43 >>> 8 | 0;
     HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $43 >>> 16 | 0;
     HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $43 >>> 24 | 0;
     HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$0;
     HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
     HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
     HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
     $5 = ($4 + 256 | 0) + 16 | 0;
     i64toi32_i32$2 = ($4 + 328 | 0) + 17 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$3 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $100 = i64toi32_i32$0;
     i64toi32_i32$0 = $5;
     HEAP32[i64toi32_i32$0 >> 2] = $100;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
     $6 = ($4 + 184 | 0) + 16 | 0;
     i64toi32_i32$2 = i64toi32_i32$0;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $106 = i64toi32_i32$3;
     i64toi32_i32$3 = $6;
     HEAP32[i64toi32_i32$3 >> 2] = $106;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
     $5 = ($4 + 184 | 0) + 21 | 0;
     i64toi32_i32$2 = $1;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$3 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $112 = i64toi32_i32$0;
     i64toi32_i32$0 = $5;
     $44 = $112;
     HEAP8[i64toi32_i32$0 >> 0] = $44;
     HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $44 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $44 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $44 >>> 24 | 0;
     HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$3;
     HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
     $1 = ($4 + 112 | 0) + 9 | 0;
     i64toi32_i32$2 = ($4 + 328 | 0) + 9 | 0;
     i64toi32_i32$3 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $120 = i64toi32_i32$3;
     i64toi32_i32$3 = $1;
     $45 = $120;
     HEAP8[i64toi32_i32$3 >> 0] = $45;
     HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $45 >>> 8 | 0;
     HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $45 >>> 16 | 0;
     HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $45 >>> 24 | 0;
     HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$0;
     HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
     HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
     HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
     $8 = ($4 + 112 | 0) + 17 | 0;
     i64toi32_i32$2 = $6;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $126 = i64toi32_i32$0;
     i64toi32_i32$0 = $8;
     $46 = $126;
     HEAP8[i64toi32_i32$0 >> 0] = $46;
     HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $46 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $46 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $46 >>> 24 | 0;
     HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$3;
     HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
     $6 = ($4 + 112 | 0) + 22 | 0;
     i64toi32_i32$2 = $5;
     i64toi32_i32$3 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $132 = i64toi32_i32$3;
     i64toi32_i32$3 = $6;
     $47 = $132;
     HEAP8[i64toi32_i32$3 >> 0] = $47;
     HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $47 >>> 8 | 0;
     HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $47 >>> 16 | 0;
     HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $47 >>> 24 | 0;
     HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$0;
     HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
     HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
     HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
     i64toi32_i32$2 = $4;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 329 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 330 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 331 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 332 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$3 = HEAPU8[(i64toi32_i32$2 + 333 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 334 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 335 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 336 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $135 = i64toi32_i32$0;
     i64toi32_i32$0 = i64toi32_i32$2;
     $48 = $135;
     HEAP8[(i64toi32_i32$2 + 113 | 0) >> 0] = $48;
     HEAP8[(i64toi32_i32$2 + 114 | 0) >> 0] = $48 >>> 8 | 0;
     HEAP8[(i64toi32_i32$2 + 115 | 0) >> 0] = $48 >>> 16 | 0;
     HEAP8[(i64toi32_i32$2 + 116 | 0) >> 0] = $48 >>> 24 | 0;
     HEAP8[(i64toi32_i32$2 + 117 | 0) >> 0] = i64toi32_i32$3;
     HEAP8[(i64toi32_i32$2 + 118 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
     HEAP8[(i64toi32_i32$2 + 119 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
     HEAP8[(i64toi32_i32$2 + 120 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
     $5 = (i64toi32_i32$2 + 40 | 0) + 21 | 0;
     i64toi32_i32$2 = $6;
     i64toi32_i32$3 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $141 = i64toi32_i32$3;
     i64toi32_i32$3 = $5;
     $49 = $141;
     HEAP8[i64toi32_i32$3 >> 0] = $49;
     HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $49 >>> 8 | 0;
     HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $49 >>> 16 | 0;
     HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $49 >>> 24 | 0;
     HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$0;
     HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
     HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
     HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
     $6 = ($4 + 40 | 0) + 16 | 0;
     i64toi32_i32$2 = $8;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$3 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $147 = i64toi32_i32$0;
     i64toi32_i32$0 = $6;
     HEAP32[i64toi32_i32$0 >> 2] = $147;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
     $8 = ($4 + 40 | 0) + 8 | 0;
     i64toi32_i32$2 = $1;
     i64toi32_i32$3 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $153 = i64toi32_i32$3;
     i64toi32_i32$3 = $8;
     HEAP32[i64toi32_i32$3 >> 2] = $153;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $4;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 113 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 114 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 115 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 116 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$3 = HEAPU8[(i64toi32_i32$2 + 117 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 118 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 119 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 120 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $156 = i64toi32_i32$0;
     i64toi32_i32$0 = i64toi32_i32$2;
     HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] = $156;
     HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] = i64toi32_i32$3;
     $1 = (i64toi32_i32$2 + 8 | 0) + 21 | 0;
     i64toi32_i32$2 = $5;
     i64toi32_i32$3 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $162 = i64toi32_i32$3;
     i64toi32_i32$3 = $1;
     $50 = $162;
     HEAP8[i64toi32_i32$3 >> 0] = $50;
     HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $50 >>> 8 | 0;
     HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $50 >>> 16 | 0;
     HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $50 >>> 24 | 0;
     HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$0;
     HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
     HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
     HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
     $5 = ($4 + 8 | 0) + 16 | 0;
     i64toi32_i32$2 = $6;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $168 = i64toi32_i32$0;
     i64toi32_i32$0 = $5;
     HEAP32[i64toi32_i32$0 >> 2] = $168;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
     $6 = ($4 + 8 | 0) + 8 | 0;
     i64toi32_i32$2 = $8;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $174 = i64toi32_i32$3;
     i64toi32_i32$3 = $6;
     HEAP32[i64toi32_i32$3 >> 2] = $174;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $4;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] | 0;
     $177 = i64toi32_i32$0;
     i64toi32_i32$0 = i64toi32_i32$2;
     HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $177;
     HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$3;
     HEAP8[$0 >> 0] = 0;
     i64toi32_i32$2 = $1;
     i64toi32_i32$3 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $182 = i64toi32_i32$3;
     i64toi32_i32$3 = $0 + 22 | 0;
     $51 = $182;
     HEAP8[i64toi32_i32$3 >> 0] = $51;
     HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $51 >>> 8 | 0;
     HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $51 >>> 16 | 0;
     HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $51 >>> 24 | 0;
     HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$0;
     HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
     HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
     HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
     i64toi32_i32$2 = $5;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $186 = i64toi32_i32$0;
     i64toi32_i32$0 = $0 + 17 | 0;
     $52 = $186;
     HEAP8[i64toi32_i32$0 >> 0] = $52;
     HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $52 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $52 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $52 >>> 24 | 0;
     HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$3;
     HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
     i64toi32_i32$2 = $6;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $190 = i64toi32_i32$3;
     i64toi32_i32$3 = $0 + 9 | 0;
     $53 = $190;
     HEAP8[i64toi32_i32$3 >> 0] = $53;
     HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $53 >>> 8 | 0;
     HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $53 >>> 16 | 0;
     HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $53 >>> 24 | 0;
     HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$0;
     HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
     HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
     HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
     i64toi32_i32$2 = $4;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
     $193 = i64toi32_i32$0;
     i64toi32_i32$0 = $0;
     $54 = $193;
     HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $54;
     HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $54 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $54 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = $54 >>> 24 | 0;
     HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$3;
     HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 8 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
     break label$1;
    }
    memcpy($0 + 9 | 0 | 0, $4 + 112 | 0 | 1 | 0 | 0, 63 | 0) | 0;
    HEAP8[$0 >> 0] = 1;
    HEAP8[($0 + 8 | 0) >> 0] = $5;
    break label$1;
   }
   memcpy($4 + 328 | 0 | 0, memcpy($4 + 184 | 0 | 7 | 0 | 0, memcpy($4 + 256 | 0 | 7 | 0 | 0, ($4 + 328 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   $1 = ($4 + 112 | 0) + 8 | 0;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 328 | 0 | 0, 1050773 | 0, 16 | 0);
   memcpy($0 + 8 | 0 | 0, memcpy($4 + 40 | 0 | 7 | 0 | 0, $1 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   HEAP8[$0 >> 0] = 1;
  }
  global$0 = $4 + 400 | 0;
 }
 
 function $cardano_serialization_lib__crypto__TransactionHash_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h74dbd8caac71b042($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, i64toi32_i32$2 = 0, $7 = 0, $4 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $25 = 0, $26 = 0, $27 = 0, $28 = 0, $7$hi = 0, $5 = 0, $29 = 0, $8 = 0, $8$hi = 0, $9 = 0, $9$hi = 0, $30 = 0, $31 = 0, $32 = 0, $33 = 0, $34 = 0, $6 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___bytes__hc697ccccfa39fd82($2 + 48 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ((HEAP32[($2 + 48 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      HEAP32[($2 + 32 | 0) >> 2] = HEAP32[($2 + 52 | 0) >> 2] | 0;
      $29 = HEAPU8[($2 + 57 | 0) >> 0] | 0 | ((HEAPU8[($2 + 58 | 0) >> 0] | 0) << 8 | 0) | 0;
      HEAP8[($2 + 37 | 0) >> 0] = $29;
      HEAP8[($2 + 38 | 0) >> 0] = $29 >>> 8 | 0;
      HEAP8[($2 + 36 | 0) >> 0] = HEAPU8[($2 + 56 | 0) >> 0] | 0;
      $1 = 11;
      HEAP8[($2 + 39 | 0) >> 0] = HEAPU8[(($2 + 48 | 0) + 11 | 0) >> 0] | 0;
      $3 = HEAP32[($2 + 60 | 0) >> 2] | 0;
      HEAP32[($2 + 40 | 0) >> 2] = $3;
      label$5 : {
       label$6 : {
        if (($3 | 0) != (32 | 0)) {
         break label$6
        }
        $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $2 + 32 | 0 | 0);
        $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
        if ($1 >>> 0 <= 31 >>> 0) {
         break label$1
        }
        $T_20as_20core__convert__TryInto_U____try_into__ha1ac58dc74faf560($2 + 48 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, 32 | 0);
        if ((HEAPU8[($2 + 48 | 0) >> 0] | 0 | 0) != (1 | 0)) {
         break label$5
        }
        core__result__unwrap_failed__h27f43d993c3864a1(1066120 | 0, 43 | 0, $2 + 24 | 0 | 0, 1066180 | 0, 1066824 | 0);
        abort();
       }
       i64toi32_i32$0 = 0;
       $7 = $3;
       $7$hi = i64toi32_i32$0;
       $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 32 | 0 | 0);
       $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 32 | 0 | 0);
       i64toi32_i32$0 = 0;
       $8 = 32;
       $8$hi = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       $9 = 1;
       $9$hi = i64toi32_i32$0;
       $3 = 1066390;
       $4 = 13;
       break label$3;
      }
      $16 = ($2 + 48 | 0) + 9 | 0;
      $17 = $0 + 9 | 0;
      $18 = HEAPU8[$16 >> 0] | 0 | ((HEAPU8[($16 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($16 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($16 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[$17 >> 0] = $18;
      HEAP8[($17 + 1 | 0) >> 0] = $18 >>> 8 | 0;
      HEAP8[($17 + 2 | 0) >> 0] = $18 >>> 16 | 0;
      HEAP8[($17 + 3 | 0) >> 0] = $18 >>> 24 | 0;
      $19 = ($2 + 48 | 0) + 12 | 0;
      $20 = $0 + 12 | 0;
      $21 = HEAPU8[$19 >> 0] | 0 | ((HEAPU8[($19 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($19 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($19 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[$20 >> 0] = $21;
      HEAP8[($20 + 1 | 0) >> 0] = $21 >>> 8 | 0;
      HEAP8[($20 + 2 | 0) >> 0] = $21 >>> 16 | 0;
      HEAP8[($20 + 3 | 0) >> 0] = $21 >>> 24 | 0;
      $1 = $2 + 22 | 0;
      HEAP8[$1 >> 0] = HEAPU8[(($2 + 48 | 0) + 19 | 0) >> 0] | 0;
      $22 = HEAPU8[($2 + 52 | 0) >> 0] | 0 | ((HEAPU8[($2 + 53 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 54 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 55 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[($2 + 28 | 0) >> 0] = $22;
      HEAP8[($2 + 29 | 0) >> 0] = $22 >>> 8 | 0;
      HEAP8[($2 + 30 | 0) >> 0] = $22 >>> 16 | 0;
      HEAP8[($2 + 31 | 0) >> 0] = $22 >>> 24 | 0;
      $23 = HEAPU8[($2 + 49 | 0) >> 0] | 0 | ((HEAPU8[($2 + 50 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 51 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 52 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[($2 + 25 | 0) >> 0] = $23;
      HEAP8[($2 + 26 | 0) >> 0] = $23 >>> 8 | 0;
      HEAP8[($2 + 27 | 0) >> 0] = $23 >>> 16 | 0;
      HEAP8[($2 + 28 | 0) >> 0] = $23 >>> 24 | 0;
      $30 = ($2 + 48 | 0) + 17 | 0;
      HEAP16[($2 + 20 | 0) >> 1] = HEAPU8[$30 >> 0] | 0 | ((HEAPU8[($30 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
      i64toi32_i32$2 = ($2 + 48 | 0) + 20 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $7 = i64toi32_i32$0;
      $7$hi = i64toi32_i32$1;
      $3 = HEAP32[(($2 + 48 | 0) + 28 | 0) >> 2] | 0;
      $4 = HEAPU8[(($2 + 48 | 0) + 32 | 0) >> 0] | 0;
      $5 = HEAPU8[(($2 + 48 | 0) + 8 | 0) >> 0] | 0;
      $6 = HEAPU8[(($2 + 48 | 0) + 16 | 0) >> 0] | 0;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 32 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 32 | 0 | 0);
      $24 = $0 + 4 | 0;
      $25 = HEAPU8[($2 + 28 | 0) >> 0] | 0 | ((HEAPU8[($2 + 29 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 30 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 31 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[$24 >> 0] = $25;
      HEAP8[($24 + 1 | 0) >> 0] = $25 >>> 8 | 0;
      HEAP8[($24 + 2 | 0) >> 0] = $25 >>> 16 | 0;
      HEAP8[($24 + 3 | 0) >> 0] = $25 >>> 24 | 0;
      $26 = HEAPU8[($2 + 25 | 0) >> 0] | 0 | ((HEAPU8[($2 + 26 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 27 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 28 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[($0 + 1 | 0) >> 0] = $26;
      HEAP8[($0 + 2 | 0) >> 0] = $26 >>> 8 | 0;
      HEAP8[($0 + 3 | 0) >> 0] = $26 >>> 16 | 0;
      HEAP8[($0 + 4 | 0) >> 0] = $26 >>> 24 | 0;
      HEAP8[($0 + 16 | 0) >> 0] = $6;
      HEAP8[($0 + 8 | 0) >> 0] = $5;
      $31 = $0 + 17 | 0;
      $32 = HEAPU16[($2 + 20 | 0) >> 1] | 0;
      HEAP8[$31 >> 0] = $32;
      HEAP8[($31 + 1 | 0) >> 0] = $32 >>> 8 | 0;
      HEAP8[($0 + 19 | 0) >> 0] = HEAPU8[$1 >> 0] | 0;
      HEAP8[($0 + 32 | 0) >> 0] = $4;
      $27 = $0 + 28 | 0;
      HEAP8[$27 >> 0] = $3;
      HEAP8[($27 + 1 | 0) >> 0] = $3 >>> 8 | 0;
      HEAP8[($27 + 2 | 0) >> 0] = $3 >>> 16 | 0;
      HEAP8[($27 + 3 | 0) >> 0] = $3 >>> 24 | 0;
      i64toi32_i32$0 = $0 + 20 | 0;
      $28 = $7;
      HEAP8[i64toi32_i32$0 >> 0] = $28;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $28 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $28 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $28 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      $1 = 0;
      break label$2;
     }
     HEAP8[($2 + 22 | 0) >> 0] = HEAPU8[($2 + 59 | 0) >> 0] | 0;
     $1 = HEAPU8[($2 + 57 | 0) >> 0] | 0 | ((HEAPU8[($2 + 58 | 0) >> 0] | 0) << 8 | 0) | 0;
     HEAP16[($2 + 24 | 0) >> 1] = $1;
     HEAP16[($2 + 20 | 0) >> 1] = $1;
     $4 = HEAPU8[($2 + 56 | 0) >> 0] | 0;
     $3 = HEAP32[($2 + 60 | 0) >> 2] | 0;
     $1 = HEAP32[($2 + 64 | 0) >> 2] | 0;
     $5 = HEAP32[($2 + 68 | 0) >> 2] | 0;
     i64toi32_i32$2 = $2 + 72 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $8 = i64toi32_i32$1;
     $8$hi = i64toi32_i32$0;
     i64toi32_i32$2 = $2 + 80 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $9 = i64toi32_i32$0;
     $9$hi = i64toi32_i32$1;
     i64toi32_i32$2 = $2 + 88 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $7 = i64toi32_i32$1;
     $7$hi = i64toi32_i32$0;
    }
    HEAP8[(($2 + 48 | 0) + 8 | 0) >> 0] = $4;
    $33 = $2 + 57 | 0;
    $34 = HEAPU16[($2 + 20 | 0) >> 1] | 0;
    HEAP8[$33 >> 0] = $34;
    HEAP8[($33 + 1 | 0) >> 0] = $34 >>> 8 | 0;
    i64toi32_i32$0 = $7$hi;
    i64toi32_i32$1 = $2 + 88 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $7;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = $9$hi;
    i64toi32_i32$1 = $2 + 80 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $9;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = $8$hi;
    i64toi32_i32$1 = $2 + 72 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $8;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($2 + 68 | 0) >> 2] = $5;
    HEAP32[($2 + 64 | 0) >> 2] = $1;
    HEAP32[($2 + 60 | 0) >> 2] = $3;
    HEAP8[($2 + 48 | 0) >> 0] = 2;
    HEAP8[($2 + 59 | 0) >> 0] = HEAPU8[(($2 + 20 | 0) + 2 | 0) >> 0] | 0;
    HEAP32[($2 + 96 | 0) >> 2] = 0;
    cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 48 | 0 | 0, 1066840 | 0, 15 | 0);
    $1 = 1;
   }
   HEAP8[$0 >> 0] = $1;
   global$0 = $2 + 112 | 0;
   return;
  }
  core__slice__index__slice_end_index_len_fail__h192505a15ac4b345(32 | 0, $1 | 0, 1066824 | 0);
  abort();
 }
 
 function $cardano_serialization_lib__crypto__AuxiliaryDataHash_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h7e449458f02a8fab($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, i64toi32_i32$2 = 0, $7 = 0, $4 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $25 = 0, $26 = 0, $27 = 0, $28 = 0, $7$hi = 0, $5 = 0, $29 = 0, $8 = 0, $8$hi = 0, $9 = 0, $9$hi = 0, $30 = 0, $31 = 0, $32 = 0, $33 = 0, $34 = 0, $6 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___bytes__hc697ccccfa39fd82($2 + 48 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ((HEAP32[($2 + 48 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      HEAP32[($2 + 32 | 0) >> 2] = HEAP32[($2 + 52 | 0) >> 2] | 0;
      $29 = HEAPU8[($2 + 57 | 0) >> 0] | 0 | ((HEAPU8[($2 + 58 | 0) >> 0] | 0) << 8 | 0) | 0;
      HEAP8[($2 + 37 | 0) >> 0] = $29;
      HEAP8[($2 + 38 | 0) >> 0] = $29 >>> 8 | 0;
      HEAP8[($2 + 36 | 0) >> 0] = HEAPU8[($2 + 56 | 0) >> 0] | 0;
      $1 = 11;
      HEAP8[($2 + 39 | 0) >> 0] = HEAPU8[(($2 + 48 | 0) + 11 | 0) >> 0] | 0;
      $3 = HEAP32[($2 + 60 | 0) >> 2] | 0;
      HEAP32[($2 + 40 | 0) >> 2] = $3;
      label$5 : {
       label$6 : {
        if (($3 | 0) != (32 | 0)) {
         break label$6
        }
        $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $2 + 32 | 0 | 0);
        $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
        if ($1 >>> 0 <= 31 >>> 0) {
         break label$1
        }
        $T_20as_20core__convert__TryInto_U____try_into__ha1ac58dc74faf560($2 + 48 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, 32 | 0);
        if ((HEAPU8[($2 + 48 | 0) >> 0] | 0 | 0) != (1 | 0)) {
         break label$5
        }
        core__result__unwrap_failed__h27f43d993c3864a1(1066120 | 0, 43 | 0, $2 + 24 | 0 | 0, 1066180 | 0, 1066920 | 0);
        abort();
       }
       i64toi32_i32$0 = 0;
       $7 = $3;
       $7$hi = i64toi32_i32$0;
       $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 32 | 0 | 0);
       $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 32 | 0 | 0);
       i64toi32_i32$0 = 0;
       $8 = 32;
       $8$hi = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       $9 = 1;
       $9$hi = i64toi32_i32$0;
       $3 = 1066390;
       $4 = 13;
       break label$3;
      }
      $16 = ($2 + 48 | 0) + 9 | 0;
      $17 = $0 + 9 | 0;
      $18 = HEAPU8[$16 >> 0] | 0 | ((HEAPU8[($16 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($16 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($16 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[$17 >> 0] = $18;
      HEAP8[($17 + 1 | 0) >> 0] = $18 >>> 8 | 0;
      HEAP8[($17 + 2 | 0) >> 0] = $18 >>> 16 | 0;
      HEAP8[($17 + 3 | 0) >> 0] = $18 >>> 24 | 0;
      $19 = ($2 + 48 | 0) + 12 | 0;
      $20 = $0 + 12 | 0;
      $21 = HEAPU8[$19 >> 0] | 0 | ((HEAPU8[($19 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($19 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($19 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[$20 >> 0] = $21;
      HEAP8[($20 + 1 | 0) >> 0] = $21 >>> 8 | 0;
      HEAP8[($20 + 2 | 0) >> 0] = $21 >>> 16 | 0;
      HEAP8[($20 + 3 | 0) >> 0] = $21 >>> 24 | 0;
      $1 = $2 + 22 | 0;
      HEAP8[$1 >> 0] = HEAPU8[(($2 + 48 | 0) + 19 | 0) >> 0] | 0;
      $22 = HEAPU8[($2 + 52 | 0) >> 0] | 0 | ((HEAPU8[($2 + 53 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 54 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 55 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[($2 + 28 | 0) >> 0] = $22;
      HEAP8[($2 + 29 | 0) >> 0] = $22 >>> 8 | 0;
      HEAP8[($2 + 30 | 0) >> 0] = $22 >>> 16 | 0;
      HEAP8[($2 + 31 | 0) >> 0] = $22 >>> 24 | 0;
      $23 = HEAPU8[($2 + 49 | 0) >> 0] | 0 | ((HEAPU8[($2 + 50 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 51 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 52 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[($2 + 25 | 0) >> 0] = $23;
      HEAP8[($2 + 26 | 0) >> 0] = $23 >>> 8 | 0;
      HEAP8[($2 + 27 | 0) >> 0] = $23 >>> 16 | 0;
      HEAP8[($2 + 28 | 0) >> 0] = $23 >>> 24 | 0;
      $30 = ($2 + 48 | 0) + 17 | 0;
      HEAP16[($2 + 20 | 0) >> 1] = HEAPU8[$30 >> 0] | 0 | ((HEAPU8[($30 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
      i64toi32_i32$2 = ($2 + 48 | 0) + 20 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $7 = i64toi32_i32$0;
      $7$hi = i64toi32_i32$1;
      $3 = HEAP32[(($2 + 48 | 0) + 28 | 0) >> 2] | 0;
      $4 = HEAPU8[(($2 + 48 | 0) + 32 | 0) >> 0] | 0;
      $5 = HEAPU8[(($2 + 48 | 0) + 8 | 0) >> 0] | 0;
      $6 = HEAPU8[(($2 + 48 | 0) + 16 | 0) >> 0] | 0;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 32 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 32 | 0 | 0);
      $24 = $0 + 4 | 0;
      $25 = HEAPU8[($2 + 28 | 0) >> 0] | 0 | ((HEAPU8[($2 + 29 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 30 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 31 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[$24 >> 0] = $25;
      HEAP8[($24 + 1 | 0) >> 0] = $25 >>> 8 | 0;
      HEAP8[($24 + 2 | 0) >> 0] = $25 >>> 16 | 0;
      HEAP8[($24 + 3 | 0) >> 0] = $25 >>> 24 | 0;
      $26 = HEAPU8[($2 + 25 | 0) >> 0] | 0 | ((HEAPU8[($2 + 26 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 27 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 28 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[($0 + 1 | 0) >> 0] = $26;
      HEAP8[($0 + 2 | 0) >> 0] = $26 >>> 8 | 0;
      HEAP8[($0 + 3 | 0) >> 0] = $26 >>> 16 | 0;
      HEAP8[($0 + 4 | 0) >> 0] = $26 >>> 24 | 0;
      HEAP8[($0 + 16 | 0) >> 0] = $6;
      HEAP8[($0 + 8 | 0) >> 0] = $5;
      $31 = $0 + 17 | 0;
      $32 = HEAPU16[($2 + 20 | 0) >> 1] | 0;
      HEAP8[$31 >> 0] = $32;
      HEAP8[($31 + 1 | 0) >> 0] = $32 >>> 8 | 0;
      HEAP8[($0 + 19 | 0) >> 0] = HEAPU8[$1 >> 0] | 0;
      HEAP8[($0 + 32 | 0) >> 0] = $4;
      $27 = $0 + 28 | 0;
      HEAP8[$27 >> 0] = $3;
      HEAP8[($27 + 1 | 0) >> 0] = $3 >>> 8 | 0;
      HEAP8[($27 + 2 | 0) >> 0] = $3 >>> 16 | 0;
      HEAP8[($27 + 3 | 0) >> 0] = $3 >>> 24 | 0;
      i64toi32_i32$0 = $0 + 20 | 0;
      $28 = $7;
      HEAP8[i64toi32_i32$0 >> 0] = $28;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $28 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $28 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $28 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      $1 = 0;
      break label$2;
     }
     HEAP8[($2 + 22 | 0) >> 0] = HEAPU8[($2 + 59 | 0) >> 0] | 0;
     $1 = HEAPU8[($2 + 57 | 0) >> 0] | 0 | ((HEAPU8[($2 + 58 | 0) >> 0] | 0) << 8 | 0) | 0;
     HEAP16[($2 + 24 | 0) >> 1] = $1;
     HEAP16[($2 + 20 | 0) >> 1] = $1;
     $4 = HEAPU8[($2 + 56 | 0) >> 0] | 0;
     $3 = HEAP32[($2 + 60 | 0) >> 2] | 0;
     $1 = HEAP32[($2 + 64 | 0) >> 2] | 0;
     $5 = HEAP32[($2 + 68 | 0) >> 2] | 0;
     i64toi32_i32$2 = $2 + 72 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $8 = i64toi32_i32$1;
     $8$hi = i64toi32_i32$0;
     i64toi32_i32$2 = $2 + 80 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $9 = i64toi32_i32$0;
     $9$hi = i64toi32_i32$1;
     i64toi32_i32$2 = $2 + 88 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $7 = i64toi32_i32$1;
     $7$hi = i64toi32_i32$0;
    }
    HEAP8[(($2 + 48 | 0) + 8 | 0) >> 0] = $4;
    $33 = $2 + 57 | 0;
    $34 = HEAPU16[($2 + 20 | 0) >> 1] | 0;
    HEAP8[$33 >> 0] = $34;
    HEAP8[($33 + 1 | 0) >> 0] = $34 >>> 8 | 0;
    i64toi32_i32$0 = $7$hi;
    i64toi32_i32$1 = $2 + 88 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $7;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = $9$hi;
    i64toi32_i32$1 = $2 + 80 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $9;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = $8$hi;
    i64toi32_i32$1 = $2 + 72 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $8;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($2 + 68 | 0) >> 2] = $5;
    HEAP32[($2 + 64 | 0) >> 2] = $1;
    HEAP32[($2 + 60 | 0) >> 2] = $3;
    HEAP8[($2 + 48 | 0) >> 0] = 2;
    HEAP8[($2 + 59 | 0) >> 0] = HEAPU8[(($2 + 20 | 0) + 2 | 0) >> 0] | 0;
    HEAP32[($2 + 96 | 0) >> 2] = 0;
    cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 48 | 0 | 0, 1066936 | 0, 17 | 0);
    $1 = 1;
   }
   HEAP8[$0 >> 0] = $1;
   global$0 = $2 + 112 | 0;
   return;
  }
  core__slice__index__slice_end_index_len_fail__h192505a15ac4b345(32 | 0, $1 | 0, 1066920 | 0);
  abort();
 }
 
 function $cardano_serialization_lib__crypto__VRFKeyHash_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h95fa546888d9bbe4($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, i64toi32_i32$2 = 0, $7 = 0, $4 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $25 = 0, $26 = 0, $27 = 0, $28 = 0, $7$hi = 0, $5 = 0, $29 = 0, $8 = 0, $8$hi = 0, $9 = 0, $9$hi = 0, $30 = 0, $31 = 0, $32 = 0, $33 = 0, $34 = 0, $6 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___bytes__hc697ccccfa39fd82($2 + 48 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ((HEAP32[($2 + 48 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      HEAP32[($2 + 32 | 0) >> 2] = HEAP32[($2 + 52 | 0) >> 2] | 0;
      $29 = HEAPU8[($2 + 57 | 0) >> 0] | 0 | ((HEAPU8[($2 + 58 | 0) >> 0] | 0) << 8 | 0) | 0;
      HEAP8[($2 + 37 | 0) >> 0] = $29;
      HEAP8[($2 + 38 | 0) >> 0] = $29 >>> 8 | 0;
      HEAP8[($2 + 36 | 0) >> 0] = HEAPU8[($2 + 56 | 0) >> 0] | 0;
      $1 = 11;
      HEAP8[($2 + 39 | 0) >> 0] = HEAPU8[(($2 + 48 | 0) + 11 | 0) >> 0] | 0;
      $3 = HEAP32[($2 + 60 | 0) >> 2] | 0;
      HEAP32[($2 + 40 | 0) >> 2] = $3;
      label$5 : {
       label$6 : {
        if (($3 | 0) != (32 | 0)) {
         break label$6
        }
        $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $2 + 32 | 0 | 0);
        $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
        if ($1 >>> 0 <= 31 >>> 0) {
         break label$1
        }
        $T_20as_20core__convert__TryInto_U____try_into__ha1ac58dc74faf560($2 + 48 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, 32 | 0);
        if ((HEAPU8[($2 + 48 | 0) >> 0] | 0 | 0) != (1 | 0)) {
         break label$5
        }
        core__result__unwrap_failed__h27f43d993c3864a1(1066120 | 0, 43 | 0, $2 + 24 | 0 | 0, 1066180 | 0, 1066988 | 0);
        abort();
       }
       i64toi32_i32$0 = 0;
       $7 = $3;
       $7$hi = i64toi32_i32$0;
       $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 32 | 0 | 0);
       $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 32 | 0 | 0);
       i64toi32_i32$0 = 0;
       $8 = 32;
       $8$hi = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       $9 = 1;
       $9$hi = i64toi32_i32$0;
       $3 = 1066390;
       $4 = 13;
       break label$3;
      }
      $16 = ($2 + 48 | 0) + 9 | 0;
      $17 = $0 + 9 | 0;
      $18 = HEAPU8[$16 >> 0] | 0 | ((HEAPU8[($16 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($16 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($16 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[$17 >> 0] = $18;
      HEAP8[($17 + 1 | 0) >> 0] = $18 >>> 8 | 0;
      HEAP8[($17 + 2 | 0) >> 0] = $18 >>> 16 | 0;
      HEAP8[($17 + 3 | 0) >> 0] = $18 >>> 24 | 0;
      $19 = ($2 + 48 | 0) + 12 | 0;
      $20 = $0 + 12 | 0;
      $21 = HEAPU8[$19 >> 0] | 0 | ((HEAPU8[($19 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($19 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($19 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[$20 >> 0] = $21;
      HEAP8[($20 + 1 | 0) >> 0] = $21 >>> 8 | 0;
      HEAP8[($20 + 2 | 0) >> 0] = $21 >>> 16 | 0;
      HEAP8[($20 + 3 | 0) >> 0] = $21 >>> 24 | 0;
      $1 = $2 + 22 | 0;
      HEAP8[$1 >> 0] = HEAPU8[(($2 + 48 | 0) + 19 | 0) >> 0] | 0;
      $22 = HEAPU8[($2 + 52 | 0) >> 0] | 0 | ((HEAPU8[($2 + 53 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 54 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 55 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[($2 + 28 | 0) >> 0] = $22;
      HEAP8[($2 + 29 | 0) >> 0] = $22 >>> 8 | 0;
      HEAP8[($2 + 30 | 0) >> 0] = $22 >>> 16 | 0;
      HEAP8[($2 + 31 | 0) >> 0] = $22 >>> 24 | 0;
      $23 = HEAPU8[($2 + 49 | 0) >> 0] | 0 | ((HEAPU8[($2 + 50 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 51 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 52 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[($2 + 25 | 0) >> 0] = $23;
      HEAP8[($2 + 26 | 0) >> 0] = $23 >>> 8 | 0;
      HEAP8[($2 + 27 | 0) >> 0] = $23 >>> 16 | 0;
      HEAP8[($2 + 28 | 0) >> 0] = $23 >>> 24 | 0;
      $30 = ($2 + 48 | 0) + 17 | 0;
      HEAP16[($2 + 20 | 0) >> 1] = HEAPU8[$30 >> 0] | 0 | ((HEAPU8[($30 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
      i64toi32_i32$2 = ($2 + 48 | 0) + 20 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $7 = i64toi32_i32$0;
      $7$hi = i64toi32_i32$1;
      $3 = HEAP32[(($2 + 48 | 0) + 28 | 0) >> 2] | 0;
      $4 = HEAPU8[(($2 + 48 | 0) + 32 | 0) >> 0] | 0;
      $5 = HEAPU8[(($2 + 48 | 0) + 8 | 0) >> 0] | 0;
      $6 = HEAPU8[(($2 + 48 | 0) + 16 | 0) >> 0] | 0;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 32 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 32 | 0 | 0);
      $24 = $0 + 4 | 0;
      $25 = HEAPU8[($2 + 28 | 0) >> 0] | 0 | ((HEAPU8[($2 + 29 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 30 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 31 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[$24 >> 0] = $25;
      HEAP8[($24 + 1 | 0) >> 0] = $25 >>> 8 | 0;
      HEAP8[($24 + 2 | 0) >> 0] = $25 >>> 16 | 0;
      HEAP8[($24 + 3 | 0) >> 0] = $25 >>> 24 | 0;
      $26 = HEAPU8[($2 + 25 | 0) >> 0] | 0 | ((HEAPU8[($2 + 26 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 27 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 28 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[($0 + 1 | 0) >> 0] = $26;
      HEAP8[($0 + 2 | 0) >> 0] = $26 >>> 8 | 0;
      HEAP8[($0 + 3 | 0) >> 0] = $26 >>> 16 | 0;
      HEAP8[($0 + 4 | 0) >> 0] = $26 >>> 24 | 0;
      HEAP8[($0 + 16 | 0) >> 0] = $6;
      HEAP8[($0 + 8 | 0) >> 0] = $5;
      $31 = $0 + 17 | 0;
      $32 = HEAPU16[($2 + 20 | 0) >> 1] | 0;
      HEAP8[$31 >> 0] = $32;
      HEAP8[($31 + 1 | 0) >> 0] = $32 >>> 8 | 0;
      HEAP8[($0 + 19 | 0) >> 0] = HEAPU8[$1 >> 0] | 0;
      HEAP8[($0 + 32 | 0) >> 0] = $4;
      $27 = $0 + 28 | 0;
      HEAP8[$27 >> 0] = $3;
      HEAP8[($27 + 1 | 0) >> 0] = $3 >>> 8 | 0;
      HEAP8[($27 + 2 | 0) >> 0] = $3 >>> 16 | 0;
      HEAP8[($27 + 3 | 0) >> 0] = $3 >>> 24 | 0;
      i64toi32_i32$0 = $0 + 20 | 0;
      $28 = $7;
      HEAP8[i64toi32_i32$0 >> 0] = $28;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $28 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $28 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $28 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      $1 = 0;
      break label$2;
     }
     HEAP8[($2 + 22 | 0) >> 0] = HEAPU8[($2 + 59 | 0) >> 0] | 0;
     $1 = HEAPU8[($2 + 57 | 0) >> 0] | 0 | ((HEAPU8[($2 + 58 | 0) >> 0] | 0) << 8 | 0) | 0;
     HEAP16[($2 + 24 | 0) >> 1] = $1;
     HEAP16[($2 + 20 | 0) >> 1] = $1;
     $4 = HEAPU8[($2 + 56 | 0) >> 0] | 0;
     $3 = HEAP32[($2 + 60 | 0) >> 2] | 0;
     $1 = HEAP32[($2 + 64 | 0) >> 2] | 0;
     $5 = HEAP32[($2 + 68 | 0) >> 2] | 0;
     i64toi32_i32$2 = $2 + 72 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $8 = i64toi32_i32$1;
     $8$hi = i64toi32_i32$0;
     i64toi32_i32$2 = $2 + 80 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $9 = i64toi32_i32$0;
     $9$hi = i64toi32_i32$1;
     i64toi32_i32$2 = $2 + 88 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $7 = i64toi32_i32$1;
     $7$hi = i64toi32_i32$0;
    }
    HEAP8[(($2 + 48 | 0) + 8 | 0) >> 0] = $4;
    $33 = $2 + 57 | 0;
    $34 = HEAPU16[($2 + 20 | 0) >> 1] | 0;
    HEAP8[$33 >> 0] = $34;
    HEAP8[($33 + 1 | 0) >> 0] = $34 >>> 8 | 0;
    i64toi32_i32$0 = $7$hi;
    i64toi32_i32$1 = $2 + 88 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $7;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = $9$hi;
    i64toi32_i32$1 = $2 + 80 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $9;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = $8$hi;
    i64toi32_i32$1 = $2 + 72 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $8;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($2 + 68 | 0) >> 2] = $5;
    HEAP32[($2 + 64 | 0) >> 2] = $1;
    HEAP32[($2 + 60 | 0) >> 2] = $3;
    HEAP8[($2 + 48 | 0) >> 0] = 2;
    HEAP8[($2 + 59 | 0) >> 0] = HEAPU8[(($2 + 20 | 0) + 2 | 0) >> 0] | 0;
    HEAP32[($2 + 96 | 0) >> 2] = 0;
    cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 48 | 0 | 0, 1067004 | 0, 10 | 0);
    $1 = 1;
   }
   HEAP8[$0 >> 0] = $1;
   global$0 = $2 + 112 | 0;
   return;
  }
  core__slice__index__slice_end_index_len_fail__h192505a15ac4b345(32 | 0, $1 | 0, 1066988 | 0);
  abort();
 }
 
 function $cardano_serialization_lib__crypto__ScriptDataHash_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h6a388763d9e64234($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, i64toi32_i32$2 = 0, $7 = 0, $4 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $25 = 0, $26 = 0, $27 = 0, $28 = 0, $7$hi = 0, $5 = 0, $29 = 0, $8 = 0, $8$hi = 0, $9 = 0, $9$hi = 0, $30 = 0, $31 = 0, $32 = 0, $33 = 0, $34 = 0, $6 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___bytes__hc697ccccfa39fd82($2 + 48 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ((HEAP32[($2 + 48 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      HEAP32[($2 + 32 | 0) >> 2] = HEAP32[($2 + 52 | 0) >> 2] | 0;
      $29 = HEAPU8[($2 + 57 | 0) >> 0] | 0 | ((HEAPU8[($2 + 58 | 0) >> 0] | 0) << 8 | 0) | 0;
      HEAP8[($2 + 37 | 0) >> 0] = $29;
      HEAP8[($2 + 38 | 0) >> 0] = $29 >>> 8 | 0;
      HEAP8[($2 + 36 | 0) >> 0] = HEAPU8[($2 + 56 | 0) >> 0] | 0;
      $1 = 11;
      HEAP8[($2 + 39 | 0) >> 0] = HEAPU8[(($2 + 48 | 0) + 11 | 0) >> 0] | 0;
      $3 = HEAP32[($2 + 60 | 0) >> 2] | 0;
      HEAP32[($2 + 40 | 0) >> 2] = $3;
      label$5 : {
       label$6 : {
        if (($3 | 0) != (32 | 0)) {
         break label$6
        }
        $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $2 + 32 | 0 | 0);
        $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
        if ($1 >>> 0 <= 31 >>> 0) {
         break label$1
        }
        $T_20as_20core__convert__TryInto_U____try_into__ha1ac58dc74faf560($2 + 48 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, 32 | 0);
        if ((HEAPU8[($2 + 48 | 0) >> 0] | 0 | 0) != (1 | 0)) {
         break label$5
        }
        core__result__unwrap_failed__h27f43d993c3864a1(1066120 | 0, 43 | 0, $2 + 24 | 0 | 0, 1066180 | 0, 1067068 | 0);
        abort();
       }
       i64toi32_i32$0 = 0;
       $7 = $3;
       $7$hi = i64toi32_i32$0;
       $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 32 | 0 | 0);
       $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 32 | 0 | 0);
       i64toi32_i32$0 = 0;
       $8 = 32;
       $8$hi = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       $9 = 1;
       $9$hi = i64toi32_i32$0;
       $3 = 1066390;
       $4 = 13;
       break label$3;
      }
      $16 = ($2 + 48 | 0) + 9 | 0;
      $17 = $0 + 9 | 0;
      $18 = HEAPU8[$16 >> 0] | 0 | ((HEAPU8[($16 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($16 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($16 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[$17 >> 0] = $18;
      HEAP8[($17 + 1 | 0) >> 0] = $18 >>> 8 | 0;
      HEAP8[($17 + 2 | 0) >> 0] = $18 >>> 16 | 0;
      HEAP8[($17 + 3 | 0) >> 0] = $18 >>> 24 | 0;
      $19 = ($2 + 48 | 0) + 12 | 0;
      $20 = $0 + 12 | 0;
      $21 = HEAPU8[$19 >> 0] | 0 | ((HEAPU8[($19 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($19 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($19 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[$20 >> 0] = $21;
      HEAP8[($20 + 1 | 0) >> 0] = $21 >>> 8 | 0;
      HEAP8[($20 + 2 | 0) >> 0] = $21 >>> 16 | 0;
      HEAP8[($20 + 3 | 0) >> 0] = $21 >>> 24 | 0;
      $1 = $2 + 22 | 0;
      HEAP8[$1 >> 0] = HEAPU8[(($2 + 48 | 0) + 19 | 0) >> 0] | 0;
      $22 = HEAPU8[($2 + 52 | 0) >> 0] | 0 | ((HEAPU8[($2 + 53 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 54 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 55 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[($2 + 28 | 0) >> 0] = $22;
      HEAP8[($2 + 29 | 0) >> 0] = $22 >>> 8 | 0;
      HEAP8[($2 + 30 | 0) >> 0] = $22 >>> 16 | 0;
      HEAP8[($2 + 31 | 0) >> 0] = $22 >>> 24 | 0;
      $23 = HEAPU8[($2 + 49 | 0) >> 0] | 0 | ((HEAPU8[($2 + 50 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 51 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 52 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[($2 + 25 | 0) >> 0] = $23;
      HEAP8[($2 + 26 | 0) >> 0] = $23 >>> 8 | 0;
      HEAP8[($2 + 27 | 0) >> 0] = $23 >>> 16 | 0;
      HEAP8[($2 + 28 | 0) >> 0] = $23 >>> 24 | 0;
      $30 = ($2 + 48 | 0) + 17 | 0;
      HEAP16[($2 + 20 | 0) >> 1] = HEAPU8[$30 >> 0] | 0 | ((HEAPU8[($30 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
      i64toi32_i32$2 = ($2 + 48 | 0) + 20 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $7 = i64toi32_i32$0;
      $7$hi = i64toi32_i32$1;
      $3 = HEAP32[(($2 + 48 | 0) + 28 | 0) >> 2] | 0;
      $4 = HEAPU8[(($2 + 48 | 0) + 32 | 0) >> 0] | 0;
      $5 = HEAPU8[(($2 + 48 | 0) + 8 | 0) >> 0] | 0;
      $6 = HEAPU8[(($2 + 48 | 0) + 16 | 0) >> 0] | 0;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 32 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 32 | 0 | 0);
      $24 = $0 + 4 | 0;
      $25 = HEAPU8[($2 + 28 | 0) >> 0] | 0 | ((HEAPU8[($2 + 29 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 30 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 31 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[$24 >> 0] = $25;
      HEAP8[($24 + 1 | 0) >> 0] = $25 >>> 8 | 0;
      HEAP8[($24 + 2 | 0) >> 0] = $25 >>> 16 | 0;
      HEAP8[($24 + 3 | 0) >> 0] = $25 >>> 24 | 0;
      $26 = HEAPU8[($2 + 25 | 0) >> 0] | 0 | ((HEAPU8[($2 + 26 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 27 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 28 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[($0 + 1 | 0) >> 0] = $26;
      HEAP8[($0 + 2 | 0) >> 0] = $26 >>> 8 | 0;
      HEAP8[($0 + 3 | 0) >> 0] = $26 >>> 16 | 0;
      HEAP8[($0 + 4 | 0) >> 0] = $26 >>> 24 | 0;
      HEAP8[($0 + 16 | 0) >> 0] = $6;
      HEAP8[($0 + 8 | 0) >> 0] = $5;
      $31 = $0 + 17 | 0;
      $32 = HEAPU16[($2 + 20 | 0) >> 1] | 0;
      HEAP8[$31 >> 0] = $32;
      HEAP8[($31 + 1 | 0) >> 0] = $32 >>> 8 | 0;
      HEAP8[($0 + 19 | 0) >> 0] = HEAPU8[$1 >> 0] | 0;
      HEAP8[($0 + 32 | 0) >> 0] = $4;
      $27 = $0 + 28 | 0;
      HEAP8[$27 >> 0] = $3;
      HEAP8[($27 + 1 | 0) >> 0] = $3 >>> 8 | 0;
      HEAP8[($27 + 2 | 0) >> 0] = $3 >>> 16 | 0;
      HEAP8[($27 + 3 | 0) >> 0] = $3 >>> 24 | 0;
      i64toi32_i32$0 = $0 + 20 | 0;
      $28 = $7;
      HEAP8[i64toi32_i32$0 >> 0] = $28;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $28 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $28 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $28 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      $1 = 0;
      break label$2;
     }
     HEAP8[($2 + 22 | 0) >> 0] = HEAPU8[($2 + 59 | 0) >> 0] | 0;
     $1 = HEAPU8[($2 + 57 | 0) >> 0] | 0 | ((HEAPU8[($2 + 58 | 0) >> 0] | 0) << 8 | 0) | 0;
     HEAP16[($2 + 24 | 0) >> 1] = $1;
     HEAP16[($2 + 20 | 0) >> 1] = $1;
     $4 = HEAPU8[($2 + 56 | 0) >> 0] | 0;
     $3 = HEAP32[($2 + 60 | 0) >> 2] | 0;
     $1 = HEAP32[($2 + 64 | 0) >> 2] | 0;
     $5 = HEAP32[($2 + 68 | 0) >> 2] | 0;
     i64toi32_i32$2 = $2 + 72 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $8 = i64toi32_i32$1;
     $8$hi = i64toi32_i32$0;
     i64toi32_i32$2 = $2 + 80 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $9 = i64toi32_i32$0;
     $9$hi = i64toi32_i32$1;
     i64toi32_i32$2 = $2 + 88 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $7 = i64toi32_i32$1;
     $7$hi = i64toi32_i32$0;
    }
    HEAP8[(($2 + 48 | 0) + 8 | 0) >> 0] = $4;
    $33 = $2 + 57 | 0;
    $34 = HEAPU16[($2 + 20 | 0) >> 1] | 0;
    HEAP8[$33 >> 0] = $34;
    HEAP8[($33 + 1 | 0) >> 0] = $34 >>> 8 | 0;
    i64toi32_i32$0 = $7$hi;
    i64toi32_i32$1 = $2 + 88 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $7;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = $9$hi;
    i64toi32_i32$1 = $2 + 80 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $9;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = $8$hi;
    i64toi32_i32$1 = $2 + 72 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $8;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($2 + 68 | 0) >> 2] = $5;
    HEAP32[($2 + 64 | 0) >> 2] = $1;
    HEAP32[($2 + 60 | 0) >> 2] = $3;
    HEAP8[($2 + 48 | 0) >> 0] = 2;
    HEAP8[($2 + 59 | 0) >> 0] = HEAPU8[(($2 + 20 | 0) + 2 | 0) >> 0] | 0;
    HEAP32[($2 + 96 | 0) >> 2] = 0;
    cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 48 | 0 | 0, 1067084 | 0, 14 | 0);
    $1 = 1;
   }
   HEAP8[$0 >> 0] = $1;
   global$0 = $2 + 112 | 0;
   return;
  }
  core__slice__index__slice_end_index_len_fail__h192505a15ac4b345(32 | 0, $1 | 0, 1067068 | 0);
  abort();
 }
 
 function $cardano_serialization_lib__crypto__VRFVKey_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hde8d95c2ad05bde9($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, i64toi32_i32$2 = 0, $7 = 0, $4 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $25 = 0, $26 = 0, $27 = 0, $28 = 0, $7$hi = 0, $5 = 0, $29 = 0, $8 = 0, $8$hi = 0, $9 = 0, $9$hi = 0, $30 = 0, $31 = 0, $32 = 0, $33 = 0, $34 = 0, $6 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___bytes__hc697ccccfa39fd82($2 + 48 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ((HEAP32[($2 + 48 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      HEAP32[($2 + 32 | 0) >> 2] = HEAP32[($2 + 52 | 0) >> 2] | 0;
      $29 = HEAPU8[($2 + 57 | 0) >> 0] | 0 | ((HEAPU8[($2 + 58 | 0) >> 0] | 0) << 8 | 0) | 0;
      HEAP8[($2 + 37 | 0) >> 0] = $29;
      HEAP8[($2 + 38 | 0) >> 0] = $29 >>> 8 | 0;
      HEAP8[($2 + 36 | 0) >> 0] = HEAPU8[($2 + 56 | 0) >> 0] | 0;
      $1 = 11;
      HEAP8[($2 + 39 | 0) >> 0] = HEAPU8[(($2 + 48 | 0) + 11 | 0) >> 0] | 0;
      $3 = HEAP32[($2 + 60 | 0) >> 2] | 0;
      HEAP32[($2 + 40 | 0) >> 2] = $3;
      label$5 : {
       label$6 : {
        if (($3 | 0) != (32 | 0)) {
         break label$6
        }
        $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $2 + 32 | 0 | 0);
        $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
        if ($1 >>> 0 <= 31 >>> 0) {
         break label$1
        }
        $T_20as_20core__convert__TryInto_U____try_into__ha1ac58dc74faf560($2 + 48 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, 32 | 0);
        if ((HEAPU8[($2 + 48 | 0) >> 0] | 0 | 0) != (1 | 0)) {
         break label$5
        }
        core__result__unwrap_failed__h27f43d993c3864a1(1066120 | 0, 43 | 0, $2 + 24 | 0 | 0, 1066180 | 0, 1067100 | 0);
        abort();
       }
       i64toi32_i32$0 = 0;
       $7 = $3;
       $7$hi = i64toi32_i32$0;
       $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 32 | 0 | 0);
       $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 32 | 0 | 0);
       i64toi32_i32$0 = 0;
       $8 = 32;
       $8$hi = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       $9 = 1;
       $9$hi = i64toi32_i32$0;
       $3 = 1066390;
       $4 = 13;
       break label$3;
      }
      $16 = ($2 + 48 | 0) + 9 | 0;
      $17 = $0 + 9 | 0;
      $18 = HEAPU8[$16 >> 0] | 0 | ((HEAPU8[($16 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($16 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($16 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[$17 >> 0] = $18;
      HEAP8[($17 + 1 | 0) >> 0] = $18 >>> 8 | 0;
      HEAP8[($17 + 2 | 0) >> 0] = $18 >>> 16 | 0;
      HEAP8[($17 + 3 | 0) >> 0] = $18 >>> 24 | 0;
      $19 = ($2 + 48 | 0) + 12 | 0;
      $20 = $0 + 12 | 0;
      $21 = HEAPU8[$19 >> 0] | 0 | ((HEAPU8[($19 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($19 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($19 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[$20 >> 0] = $21;
      HEAP8[($20 + 1 | 0) >> 0] = $21 >>> 8 | 0;
      HEAP8[($20 + 2 | 0) >> 0] = $21 >>> 16 | 0;
      HEAP8[($20 + 3 | 0) >> 0] = $21 >>> 24 | 0;
      $1 = $2 + 22 | 0;
      HEAP8[$1 >> 0] = HEAPU8[(($2 + 48 | 0) + 19 | 0) >> 0] | 0;
      $22 = HEAPU8[($2 + 52 | 0) >> 0] | 0 | ((HEAPU8[($2 + 53 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 54 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 55 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[($2 + 28 | 0) >> 0] = $22;
      HEAP8[($2 + 29 | 0) >> 0] = $22 >>> 8 | 0;
      HEAP8[($2 + 30 | 0) >> 0] = $22 >>> 16 | 0;
      HEAP8[($2 + 31 | 0) >> 0] = $22 >>> 24 | 0;
      $23 = HEAPU8[($2 + 49 | 0) >> 0] | 0 | ((HEAPU8[($2 + 50 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 51 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 52 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[($2 + 25 | 0) >> 0] = $23;
      HEAP8[($2 + 26 | 0) >> 0] = $23 >>> 8 | 0;
      HEAP8[($2 + 27 | 0) >> 0] = $23 >>> 16 | 0;
      HEAP8[($2 + 28 | 0) >> 0] = $23 >>> 24 | 0;
      $30 = ($2 + 48 | 0) + 17 | 0;
      HEAP16[($2 + 20 | 0) >> 1] = HEAPU8[$30 >> 0] | 0 | ((HEAPU8[($30 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
      i64toi32_i32$2 = ($2 + 48 | 0) + 20 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $7 = i64toi32_i32$0;
      $7$hi = i64toi32_i32$1;
      $3 = HEAP32[(($2 + 48 | 0) + 28 | 0) >> 2] | 0;
      $4 = HEAPU8[(($2 + 48 | 0) + 32 | 0) >> 0] | 0;
      $5 = HEAPU8[(($2 + 48 | 0) + 8 | 0) >> 0] | 0;
      $6 = HEAPU8[(($2 + 48 | 0) + 16 | 0) >> 0] | 0;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 32 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 32 | 0 | 0);
      $24 = $0 + 4 | 0;
      $25 = HEAPU8[($2 + 28 | 0) >> 0] | 0 | ((HEAPU8[($2 + 29 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 30 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 31 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[$24 >> 0] = $25;
      HEAP8[($24 + 1 | 0) >> 0] = $25 >>> 8 | 0;
      HEAP8[($24 + 2 | 0) >> 0] = $25 >>> 16 | 0;
      HEAP8[($24 + 3 | 0) >> 0] = $25 >>> 24 | 0;
      $26 = HEAPU8[($2 + 25 | 0) >> 0] | 0 | ((HEAPU8[($2 + 26 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 27 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 28 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[($0 + 1 | 0) >> 0] = $26;
      HEAP8[($0 + 2 | 0) >> 0] = $26 >>> 8 | 0;
      HEAP8[($0 + 3 | 0) >> 0] = $26 >>> 16 | 0;
      HEAP8[($0 + 4 | 0) >> 0] = $26 >>> 24 | 0;
      HEAP8[($0 + 16 | 0) >> 0] = $6;
      HEAP8[($0 + 8 | 0) >> 0] = $5;
      $31 = $0 + 17 | 0;
      $32 = HEAPU16[($2 + 20 | 0) >> 1] | 0;
      HEAP8[$31 >> 0] = $32;
      HEAP8[($31 + 1 | 0) >> 0] = $32 >>> 8 | 0;
      HEAP8[($0 + 19 | 0) >> 0] = HEAPU8[$1 >> 0] | 0;
      HEAP8[($0 + 32 | 0) >> 0] = $4;
      $27 = $0 + 28 | 0;
      HEAP8[$27 >> 0] = $3;
      HEAP8[($27 + 1 | 0) >> 0] = $3 >>> 8 | 0;
      HEAP8[($27 + 2 | 0) >> 0] = $3 >>> 16 | 0;
      HEAP8[($27 + 3 | 0) >> 0] = $3 >>> 24 | 0;
      i64toi32_i32$0 = $0 + 20 | 0;
      $28 = $7;
      HEAP8[i64toi32_i32$0 >> 0] = $28;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $28 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $28 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $28 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      $1 = 0;
      break label$2;
     }
     HEAP8[($2 + 22 | 0) >> 0] = HEAPU8[($2 + 59 | 0) >> 0] | 0;
     $1 = HEAPU8[($2 + 57 | 0) >> 0] | 0 | ((HEAPU8[($2 + 58 | 0) >> 0] | 0) << 8 | 0) | 0;
     HEAP16[($2 + 24 | 0) >> 1] = $1;
     HEAP16[($2 + 20 | 0) >> 1] = $1;
     $4 = HEAPU8[($2 + 56 | 0) >> 0] | 0;
     $3 = HEAP32[($2 + 60 | 0) >> 2] | 0;
     $1 = HEAP32[($2 + 64 | 0) >> 2] | 0;
     $5 = HEAP32[($2 + 68 | 0) >> 2] | 0;
     i64toi32_i32$2 = $2 + 72 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $8 = i64toi32_i32$1;
     $8$hi = i64toi32_i32$0;
     i64toi32_i32$2 = $2 + 80 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $9 = i64toi32_i32$0;
     $9$hi = i64toi32_i32$1;
     i64toi32_i32$2 = $2 + 88 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $7 = i64toi32_i32$1;
     $7$hi = i64toi32_i32$0;
    }
    HEAP8[(($2 + 48 | 0) + 8 | 0) >> 0] = $4;
    $33 = $2 + 57 | 0;
    $34 = HEAPU16[($2 + 20 | 0) >> 1] | 0;
    HEAP8[$33 >> 0] = $34;
    HEAP8[($33 + 1 | 0) >> 0] = $34 >>> 8 | 0;
    i64toi32_i32$0 = $7$hi;
    i64toi32_i32$1 = $2 + 88 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $7;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = $9$hi;
    i64toi32_i32$1 = $2 + 80 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $9;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = $8$hi;
    i64toi32_i32$1 = $2 + 72 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $8;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($2 + 68 | 0) >> 2] = $5;
    HEAP32[($2 + 64 | 0) >> 2] = $1;
    HEAP32[($2 + 60 | 0) >> 2] = $3;
    HEAP8[($2 + 48 | 0) >> 0] = 2;
    HEAP8[($2 + 59 | 0) >> 0] = HEAPU8[(($2 + 20 | 0) + 2 | 0) >> 0] | 0;
    HEAP32[($2 + 96 | 0) >> 2] = 0;
    cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 48 | 0 | 0, 1067116 | 0, 7 | 0);
    $1 = 1;
   }
   HEAP8[$0 >> 0] = $1;
   global$0 = $2 + 112 | 0;
   return;
  }
  core__slice__index__slice_end_index_len_fail__h192505a15ac4b345(32 | 0, $1 | 0, 1067100 | 0);
  abort();
 }
 
 function $cardano_serialization_lib__crypto__KESVKey_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h44235a31cbf1173c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, i64toi32_i32$2 = 0, $7 = 0, $4 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $25 = 0, $26 = 0, $27 = 0, $28 = 0, $7$hi = 0, $5 = 0, $29 = 0, $8 = 0, $8$hi = 0, $9 = 0, $9$hi = 0, $30 = 0, $31 = 0, $32 = 0, $33 = 0, $34 = 0, $6 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___bytes__hc697ccccfa39fd82($2 + 48 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ((HEAP32[($2 + 48 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      HEAP32[($2 + 32 | 0) >> 2] = HEAP32[($2 + 52 | 0) >> 2] | 0;
      $29 = HEAPU8[($2 + 57 | 0) >> 0] | 0 | ((HEAPU8[($2 + 58 | 0) >> 0] | 0) << 8 | 0) | 0;
      HEAP8[($2 + 37 | 0) >> 0] = $29;
      HEAP8[($2 + 38 | 0) >> 0] = $29 >>> 8 | 0;
      HEAP8[($2 + 36 | 0) >> 0] = HEAPU8[($2 + 56 | 0) >> 0] | 0;
      $1 = 11;
      HEAP8[($2 + 39 | 0) >> 0] = HEAPU8[(($2 + 48 | 0) + 11 | 0) >> 0] | 0;
      $3 = HEAP32[($2 + 60 | 0) >> 2] | 0;
      HEAP32[($2 + 40 | 0) >> 2] = $3;
      label$5 : {
       label$6 : {
        if (($3 | 0) != (32 | 0)) {
         break label$6
        }
        $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $2 + 32 | 0 | 0);
        $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
        if ($1 >>> 0 <= 31 >>> 0) {
         break label$1
        }
        $T_20as_20core__convert__TryInto_U____try_into__ha1ac58dc74faf560($2 + 48 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, 32 | 0);
        if ((HEAPU8[($2 + 48 | 0) >> 0] | 0 | 0) != (1 | 0)) {
         break label$5
        }
        core__result__unwrap_failed__h27f43d993c3864a1(1066120 | 0, 43 | 0, $2 + 24 | 0 | 0, 1066180 | 0, 1067124 | 0);
        abort();
       }
       i64toi32_i32$0 = 0;
       $7 = $3;
       $7$hi = i64toi32_i32$0;
       $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 32 | 0 | 0);
       $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 32 | 0 | 0);
       i64toi32_i32$0 = 0;
       $8 = 32;
       $8$hi = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       $9 = 1;
       $9$hi = i64toi32_i32$0;
       $3 = 1066390;
       $4 = 13;
       break label$3;
      }
      $16 = ($2 + 48 | 0) + 9 | 0;
      $17 = $0 + 9 | 0;
      $18 = HEAPU8[$16 >> 0] | 0 | ((HEAPU8[($16 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($16 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($16 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[$17 >> 0] = $18;
      HEAP8[($17 + 1 | 0) >> 0] = $18 >>> 8 | 0;
      HEAP8[($17 + 2 | 0) >> 0] = $18 >>> 16 | 0;
      HEAP8[($17 + 3 | 0) >> 0] = $18 >>> 24 | 0;
      $19 = ($2 + 48 | 0) + 12 | 0;
      $20 = $0 + 12 | 0;
      $21 = HEAPU8[$19 >> 0] | 0 | ((HEAPU8[($19 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($19 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($19 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[$20 >> 0] = $21;
      HEAP8[($20 + 1 | 0) >> 0] = $21 >>> 8 | 0;
      HEAP8[($20 + 2 | 0) >> 0] = $21 >>> 16 | 0;
      HEAP8[($20 + 3 | 0) >> 0] = $21 >>> 24 | 0;
      $1 = $2 + 22 | 0;
      HEAP8[$1 >> 0] = HEAPU8[(($2 + 48 | 0) + 19 | 0) >> 0] | 0;
      $22 = HEAPU8[($2 + 52 | 0) >> 0] | 0 | ((HEAPU8[($2 + 53 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 54 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 55 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[($2 + 28 | 0) >> 0] = $22;
      HEAP8[($2 + 29 | 0) >> 0] = $22 >>> 8 | 0;
      HEAP8[($2 + 30 | 0) >> 0] = $22 >>> 16 | 0;
      HEAP8[($2 + 31 | 0) >> 0] = $22 >>> 24 | 0;
      $23 = HEAPU8[($2 + 49 | 0) >> 0] | 0 | ((HEAPU8[($2 + 50 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 51 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 52 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[($2 + 25 | 0) >> 0] = $23;
      HEAP8[($2 + 26 | 0) >> 0] = $23 >>> 8 | 0;
      HEAP8[($2 + 27 | 0) >> 0] = $23 >>> 16 | 0;
      HEAP8[($2 + 28 | 0) >> 0] = $23 >>> 24 | 0;
      $30 = ($2 + 48 | 0) + 17 | 0;
      HEAP16[($2 + 20 | 0) >> 1] = HEAPU8[$30 >> 0] | 0 | ((HEAPU8[($30 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
      i64toi32_i32$2 = ($2 + 48 | 0) + 20 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $7 = i64toi32_i32$0;
      $7$hi = i64toi32_i32$1;
      $3 = HEAP32[(($2 + 48 | 0) + 28 | 0) >> 2] | 0;
      $4 = HEAPU8[(($2 + 48 | 0) + 32 | 0) >> 0] | 0;
      $5 = HEAPU8[(($2 + 48 | 0) + 8 | 0) >> 0] | 0;
      $6 = HEAPU8[(($2 + 48 | 0) + 16 | 0) >> 0] | 0;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 32 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 32 | 0 | 0);
      $24 = $0 + 4 | 0;
      $25 = HEAPU8[($2 + 28 | 0) >> 0] | 0 | ((HEAPU8[($2 + 29 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 30 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 31 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[$24 >> 0] = $25;
      HEAP8[($24 + 1 | 0) >> 0] = $25 >>> 8 | 0;
      HEAP8[($24 + 2 | 0) >> 0] = $25 >>> 16 | 0;
      HEAP8[($24 + 3 | 0) >> 0] = $25 >>> 24 | 0;
      $26 = HEAPU8[($2 + 25 | 0) >> 0] | 0 | ((HEAPU8[($2 + 26 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 27 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 28 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[($0 + 1 | 0) >> 0] = $26;
      HEAP8[($0 + 2 | 0) >> 0] = $26 >>> 8 | 0;
      HEAP8[($0 + 3 | 0) >> 0] = $26 >>> 16 | 0;
      HEAP8[($0 + 4 | 0) >> 0] = $26 >>> 24 | 0;
      HEAP8[($0 + 16 | 0) >> 0] = $6;
      HEAP8[($0 + 8 | 0) >> 0] = $5;
      $31 = $0 + 17 | 0;
      $32 = HEAPU16[($2 + 20 | 0) >> 1] | 0;
      HEAP8[$31 >> 0] = $32;
      HEAP8[($31 + 1 | 0) >> 0] = $32 >>> 8 | 0;
      HEAP8[($0 + 19 | 0) >> 0] = HEAPU8[$1 >> 0] | 0;
      HEAP8[($0 + 32 | 0) >> 0] = $4;
      $27 = $0 + 28 | 0;
      HEAP8[$27 >> 0] = $3;
      HEAP8[($27 + 1 | 0) >> 0] = $3 >>> 8 | 0;
      HEAP8[($27 + 2 | 0) >> 0] = $3 >>> 16 | 0;
      HEAP8[($27 + 3 | 0) >> 0] = $3 >>> 24 | 0;
      i64toi32_i32$0 = $0 + 20 | 0;
      $28 = $7;
      HEAP8[i64toi32_i32$0 >> 0] = $28;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $28 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $28 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $28 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      $1 = 0;
      break label$2;
     }
     HEAP8[($2 + 22 | 0) >> 0] = HEAPU8[($2 + 59 | 0) >> 0] | 0;
     $1 = HEAPU8[($2 + 57 | 0) >> 0] | 0 | ((HEAPU8[($2 + 58 | 0) >> 0] | 0) << 8 | 0) | 0;
     HEAP16[($2 + 24 | 0) >> 1] = $1;
     HEAP16[($2 + 20 | 0) >> 1] = $1;
     $4 = HEAPU8[($2 + 56 | 0) >> 0] | 0;
     $3 = HEAP32[($2 + 60 | 0) >> 2] | 0;
     $1 = HEAP32[($2 + 64 | 0) >> 2] | 0;
     $5 = HEAP32[($2 + 68 | 0) >> 2] | 0;
     i64toi32_i32$2 = $2 + 72 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $8 = i64toi32_i32$1;
     $8$hi = i64toi32_i32$0;
     i64toi32_i32$2 = $2 + 80 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $9 = i64toi32_i32$0;
     $9$hi = i64toi32_i32$1;
     i64toi32_i32$2 = $2 + 88 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $7 = i64toi32_i32$1;
     $7$hi = i64toi32_i32$0;
    }
    HEAP8[(($2 + 48 | 0) + 8 | 0) >> 0] = $4;
    $33 = $2 + 57 | 0;
    $34 = HEAPU16[($2 + 20 | 0) >> 1] | 0;
    HEAP8[$33 >> 0] = $34;
    HEAP8[($33 + 1 | 0) >> 0] = $34 >>> 8 | 0;
    i64toi32_i32$0 = $7$hi;
    i64toi32_i32$1 = $2 + 88 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $7;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = $9$hi;
    i64toi32_i32$1 = $2 + 80 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $9;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = $8$hi;
    i64toi32_i32$1 = $2 + 72 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $8;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($2 + 68 | 0) >> 2] = $5;
    HEAP32[($2 + 64 | 0) >> 2] = $1;
    HEAP32[($2 + 60 | 0) >> 2] = $3;
    HEAP8[($2 + 48 | 0) >> 0] = 2;
    HEAP8[($2 + 59 | 0) >> 0] = HEAPU8[(($2 + 20 | 0) + 2 | 0) >> 0] | 0;
    HEAP32[($2 + 96 | 0) >> 2] = 0;
    cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 48 | 0 | 0, 1067140 | 0, 7 | 0);
    $1 = 1;
   }
   HEAP8[$0 >> 0] = $1;
   global$0 = $2 + 112 | 0;
   return;
  }
  core__slice__index__slice_end_index_len_fail__h192505a15ac4b345(32 | 0, $1 | 0, 1067124 | 0);
  abort();
 }
 
 function hashbrown__raw__RawTable_T_2cA___rehash_in_place__hedd38d2062614323($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $10 = 0, i64toi32_i32$0 = 0, $7 = 0, i64toi32_i32$1 = 0, $9 = 0, i64toi32_i32$2 = 0, $8 = 0, $3 = 0, $5 = 0, $6 = 0, $12 = 0, $2 = 0, $4 = 0, $30 = 0, $31 = 0, $32 = 0, $33 = 0, $11 = 0, $13 = 0, $14 = 0, $14$hi = 0, $180 = 0, $15 = 0, $15$hi = 0, $189 = 0, $16 = 0, $16$hi = 0, $198 = 0, $223 = 0, $228 = 0, $231 = 0, $253 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  $3 = HEAP32[$0 >> 2] | 0;
  $4 = $3 + 1 | 0;
  core__iter__adapters__step_by__StepBy_I___new__h21a520baea7dc9f1($2 + 8 | 0 | 0, 0 | 0, $4 | 0, 4 | 0);
  $5 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  $6 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $7 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  $8 = !(HEAPU8[($2 + 20 | 0) >> 0] | 0);
  $9 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  label$1 : while (1) {
   label$2 : {
    label$3 : {
     label$4 : {
      if (!($8 & 1 | 0)) {
       break label$4
      }
      $10 = $7 + ($T_20as_20core__convert__From_T____from__h09bdeba94dd58819($5 | 0) | 0) | 0;
      if ($10 >>> 0 < $7 >>> 0) {
       break label$3
      }
      if ($10 >>> 0 >= $6 >>> 0) {
       break label$3
      }
      break label$2;
     }
     $10 = $7;
     if ($10 >>> 0 < $6 >>> 0) {
      break label$2
     }
    }
    label$5 : {
     label$6 : {
      label$7 : {
       if ($4 >>> 0 < 4 >>> 0) {
        break label$7
       }
       $30 = $9 + $4 | 0;
       $31 = HEAPU8[$9 >> 0] | 0 | ((HEAPU8[($9 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($9 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($9 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       HEAP8[$30 >> 0] = $31;
       HEAP8[($30 + 1 | 0) >> 0] = $31 >>> 8 | 0;
       HEAP8[($30 + 2 | 0) >> 0] = $31 >>> 16 | 0;
       HEAP8[($30 + 3 | 0) >> 0] = $31 >>> 24 | 0;
       break label$6;
      }
      memmove($9 + 4 | 0 | 0, $9 | 0, $4 | 0) | 0;
      if (!$4) {
       break label$5
      }
     }
     $10 = 0;
     label$8 : while (1) {
      label$9 : {
       $6 = $10;
       $11 = $9 + $10 | 0;
       if ((HEAPU8[$11 >> 0] | 0 | 0) != (128 | 0)) {
        break label$9
       }
       $12 = ($9 + Math_imul(0 - $6 | 0, 24) | 0) + -24 | 0;
       label$10 : while (1) {
        i64toi32_i32$0 = hashbrown__map__make_hash__hea8f199bb15af0f7($1 | 0, $12 | 0) | 0;
        i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
        $13 = i64toi32_i32$0;
        $5 = $3 & i64toi32_i32$0 | 0;
        $7 = $5;
        label$11 : {
         $32 = $9 + $7 | 0;
         $8 = (HEAPU8[$32 >> 0] | 0 | ((HEAPU8[($32 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($32 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($32 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
         if ($8) {
          break label$11
         }
         $10 = 4;
         $7 = $5;
         label$12 : while (1) {
          $7 = $7 + $10 | 0;
          $10 = $10 + 4 | 0;
          $7 = $7 & $3 | 0;
          $33 = $9 + $7 | 0;
          $8 = (HEAPU8[$33 >> 0] | 0 | ((HEAPU8[($33 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($33 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($33 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
          if (!$8) {
           continue label$12
          }
          break label$12;
         };
        }
        label$13 : {
         $10 = (((__wasm_ctz_i32($8 | 0) | 0) >>> 3 | 0) + $7 | 0) & $3 | 0;
         if ((HEAP8[($9 + $10 | 0) >> 0] | 0 | 0) <= (-1 | 0)) {
          break label$13
         }
         $10 = (__wasm_ctz_i32((HEAP32[$9 >> 2] | 0) & -2139062144 | 0 | 0) | 0) >>> 3 | 0;
        }
        label$14 : {
         if (((($10 - $5 | 0) ^ ($6 - $5 | 0) | 0) & $3 | 0) >>> 0 >= 4 >>> 0) {
          break label$14
         }
         $10 = $13 >>> 25 | 0;
         HEAP8[$11 >> 0] = $10;
         HEAP8[(((($6 + -4 | 0) & $3 | 0) + $9 | 0) + 4 | 0) >> 0] = $10;
         break label$9;
        }
        $7 = $9 + $10 | 0;
        $8 = HEAPU8[$7 >> 0] | 0;
        $5 = $13 >>> 25 | 0;
        HEAP8[$7 >> 0] = $5;
        HEAP8[(((($10 + -4 | 0) & $3 | 0) + $9 | 0) + 4 | 0) >> 0] = $5;
        label$15 : {
         if (($8 | 0) == (255 | 0)) {
          break label$15
         }
         $10 = ($9 + Math_imul(0 - $10 | 0, 24) | 0) + -24 | 0;
         i64toi32_i32$2 = $10;
         i64toi32_i32$1 = HEAP32[$10 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($10 + 4 | 0) >> 2] | 0;
         $14 = i64toi32_i32$1;
         $14$hi = i64toi32_i32$0;
         i64toi32_i32$2 = $12;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $180 = i64toi32_i32$0;
         i64toi32_i32$0 = $10;
         HEAP32[i64toi32_i32$0 >> 2] = $180;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         $7 = i64toi32_i32$0 + 16 | 0;
         i64toi32_i32$2 = $7;
         i64toi32_i32$1 = HEAP32[$7 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($7 + 4 | 0) >> 2] | 0;
         $15 = i64toi32_i32$1;
         $15$hi = i64toi32_i32$0;
         $8 = $12 + 16 | 0;
         i64toi32_i32$2 = $8;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $189 = i64toi32_i32$0;
         i64toi32_i32$0 = $7;
         HEAP32[i64toi32_i32$0 >> 2] = $189;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         $10 = $10 + 8 | 0;
         i64toi32_i32$2 = $10;
         i64toi32_i32$1 = HEAP32[$10 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($10 + 4 | 0) >> 2] | 0;
         $16 = i64toi32_i32$1;
         $16$hi = i64toi32_i32$0;
         $7 = $12 + 8 | 0;
         i64toi32_i32$2 = $7;
         i64toi32_i32$0 = HEAP32[$7 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[($7 + 4 | 0) >> 2] | 0;
         $198 = i64toi32_i32$0;
         i64toi32_i32$0 = $10;
         HEAP32[i64toi32_i32$0 >> 2] = $198;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$1 = $14$hi;
         i64toi32_i32$0 = $12;
         HEAP32[i64toi32_i32$0 >> 2] = $14;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$1 = $15$hi;
         i64toi32_i32$0 = $8;
         HEAP32[i64toi32_i32$0 >> 2] = $15;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$1 = $16$hi;
         i64toi32_i32$0 = $7;
         HEAP32[i64toi32_i32$0 >> 2] = $16;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         continue label$10;
        }
        break label$10;
       };
       HEAP8[$11 >> 0] = 255;
       HEAP8[(((($6 + -4 | 0) & $3 | 0) + $9 | 0) + 4 | 0) >> 0] = 255;
       $10 = ($9 + Math_imul(0 - $10 | 0, 24) | 0) + -24 | 0;
       i64toi32_i32$2 = $12 + 16 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $223 = i64toi32_i32$1;
       i64toi32_i32$1 = $10 + 16 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $223;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = $12 + 8 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $228 = i64toi32_i32$0;
       i64toi32_i32$0 = $10 + 8 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $228;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $12;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $231 = i64toi32_i32$1;
       i64toi32_i32$1 = $10;
       HEAP32[$10 >> 2] = $231;
       HEAP32[($10 + 4 | 0) >> 2] = i64toi32_i32$0;
      }
      $10 = $6 + 1 | 0;
      if (($6 | 0) != ($3 | 0)) {
       continue label$8
      }
      break label$8;
     };
    }
    HEAP32[($0 + 8 | 0) >> 2] = ($3 >>> 0 < 8 >>> 0 ? $3 : Math_imul($4 >>> 3 | 0, 7)) - (HEAP32[($0 + 12 | 0) >> 2] | 0) | 0;
    global$0 = $2 + 48 | 0;
    return;
   }
   $7 = $9 + $10 | 0;
   $253 = $7;
   $7 = HEAP32[$7 >> 2] | 0;
   HEAP32[$253 >> 2] = ((($7 >>> 7 | 0) ^ -1 | 0) & 16843009 | 0) + ($7 | 2139062143 | 0) | 0;
   $8 = 1;
   $7 = $10 + 1 | 0;
   continue label$1;
  };
 }
 
 function cardano_serialization_lib__Certificate__new_pool_registration__h57a31bf78c202bc5($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $2 = 0, $3 = 0, $52 = 0, $53 = 0, $54 = 0, $55 = 0, $56 = 0, $57 = 0, $59 = 0, $60 = 0, $61 = 0, $62 = 0, $63 = 0, $64 = 0, $66 = 0, $67 = 0, $69 = 0, $70 = 0, $4 = 0, $5 = 0, $6 = 0, $7 = 0, $8 = 0, $10 = 0, $11 = 0, $12 = 0, $34 = 0, $41 = 0, $44 = 0, $51 = 0, $58 = 0, $65 = 0, $68 = 0, $14 = 0, $14$hi = 0, $15 = 0, $15$hi = 0, $16 = 0, $16$hi = 0, $17 = 0, $17$hi = 0, $9 = 0, $86 = 0, $93 = 0, $104 = 0, $13 = 0, $126 = 0, $131 = 0, $136 = 0, $140 = 0, $152 = 0, $156 = 0, $160 = 0, $168 = 0, $172 = 0, $176 = 0, $180 = 0, $184 = 0, $188 = 0, $192 = 0, $206 = 0, $217 = 0, $239 = 0;
  $2 = global$0 - 256 | 0;
  global$0 = $2;
  $3 = ($2 + 8 | 0) + 24 | 0;
  $52 = $1 + 124 | 0;
  HEAP32[$3 >> 2] = HEAPU8[$52 >> 0] | 0 | ((HEAPU8[($52 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($52 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($52 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $4 = ($2 + 8 | 0) + 16 | 0;
  i64toi32_i32$2 = $1 + 116 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $34 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[i64toi32_i32$0 >> 2] = $34;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $5 = ($2 + 8 | 0) + 8 | 0;
  i64toi32_i32$2 = $1 + 108 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $41 = i64toi32_i32$1;
  i64toi32_i32$1 = $5;
  HEAP32[i64toi32_i32$1 >> 2] = $41;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 100 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 101 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 102 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 103 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 104 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 105 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 106 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 107 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $44 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $44;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
  $6 = (i64toi32_i32$0 + 40 | 0) + 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 152 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $51 = i64toi32_i32$1;
  i64toi32_i32$1 = $6;
  HEAP32[i64toi32_i32$1 >> 2] = $51;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $7 = ($2 + 40 | 0) + 16 | 0;
  i64toi32_i32$2 = $1 + 144 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $58 = i64toi32_i32$0;
  i64toi32_i32$0 = $7;
  HEAP32[i64toi32_i32$0 >> 2] = $58;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $8 = ($2 + 40 | 0) + 8 | 0;
  i64toi32_i32$2 = $1 + 136 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $65 = i64toi32_i32$1;
  i64toi32_i32$1 = $8;
  HEAP32[i64toi32_i32$1 >> 2] = $65;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 128 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 129 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 130 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 131 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 132 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 133 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 134 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 135 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $68 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[(i64toi32_i32$0 + 40 | 0) >> 2] = $68;
  HEAP32[(i64toi32_i32$0 + 44 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$2 + 24 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$1;
  $14$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $15 = i64toi32_i32$0;
  $15$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $16 = i64toi32_i32$1;
  $16$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $17 = i64toi32_i32$0;
  $17$hi = i64toi32_i32$1;
  $9 = HEAPU8[(i64toi32_i32$2 + 160 | 0) >> 0] | 0;
  $10 = ($2 + 72 | 0) + 8 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 170 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $86 = i64toi32_i32$1;
  i64toi32_i32$1 = $10;
  HEAP32[i64toi32_i32$1 >> 2] = $86;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $11 = ($2 + 72 | 0) + 16 | 0;
  i64toi32_i32$2 = $1 + 178 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $93 = i64toi32_i32$0;
  i64toi32_i32$0 = $11;
  HEAP32[i64toi32_i32$0 >> 2] = $93;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $12 = ($2 + 72 | 0) + 24 | 0;
  $53 = $1 + 186 | 0;
  HEAP32[$12 >> 2] = HEAPU8[$53 >> 0] | 0 | ((HEAPU8[($53 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($53 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($53 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $1 + 162 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $104 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[(i64toi32_i32$1 + 72 | 0) >> 2] = $104;
  HEAP32[(i64toi32_i32$1 + 76 | 0) >> 2] = i64toi32_i32$0;
  $13 = HEAPU8[($1 + 161 | 0) >> 0] | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h25db889dc58a550d(i64toi32_i32$1 + 104 | 0 | 0, $1 + 32 | 0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h3d33b90cd2011dc4(i64toi32_i32$1 + 120 | 0 | 0, $1 + 44 | 0 | 0);
  label$1 : {
   label$2 : {
    if (HEAP32[($1 + 56 | 0) >> 2] | 0) {
     break label$2
    }
    $1 = 0;
    break label$1;
   }
   $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($2 + 176 | 0 | 0, $1 + 56 | 0 | 0);
   i64toi32_i32$2 = $1 + 92 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $126 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 212 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $126;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1 + 84 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $131 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 204 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $131;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $1 + 76 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $136 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 196 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $136;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1 + 68 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $140 = i64toi32_i32$1;
   i64toi32_i32$1 = $2;
   HEAP32[(i64toi32_i32$1 + 188 | 0) >> 2] = $140;
   HEAP32[(i64toi32_i32$1 + 192 | 0) >> 2] = i64toi32_i32$0;
   $1 = HEAP32[(i64toi32_i32$1 + 176 | 0) >> 2] | 0;
   memcpy(i64toi32_i32$1 + 136 | 0 | 0, i64toi32_i32$1 + 176 | 0 | 4 | 0 | 0, 40 | 0) | 0;
  }
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $152 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 108 | 0;
  $54 = $152;
  HEAP8[i64toi32_i32$0 >> 0] = $54;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $54 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $54 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $54 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] | 0;
  $156 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 136 | 0;
  $55 = $156;
  HEAP8[i64toi32_i32$1 >> 0] = $55;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $55 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $55 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $55 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 72 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 76 | 0) >> 2] | 0;
  $160 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 170 | 0;
  $56 = $160;
  HEAP8[i64toi32_i32$0 >> 0] = $56;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $56 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $56 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $56 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $57 = $0 + 132 | 0;
  $59 = HEAP32[$3 >> 2] | 0;
  HEAP8[$57 >> 0] = $59;
  HEAP8[($57 + 1 | 0) >> 0] = $59 >>> 8 | 0;
  HEAP8[($57 + 2 | 0) >> 0] = $59 >>> 16 | 0;
  HEAP8[($57 + 3 | 0) >> 0] = $59 >>> 24 | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $168 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 124 | 0;
  $60 = $168;
  HEAP8[i64toi32_i32$1 >> 0] = $60;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $60 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $60 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $60 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $172 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 116 | 0;
  $61 = $172;
  HEAP8[i64toi32_i32$0 >> 0] = $61;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $61 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $61 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $61 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $8;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $176 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 144 | 0;
  $62 = $176;
  HEAP8[i64toi32_i32$1 >> 0] = $62;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $62 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $62 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $62 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $7;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $180 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 152 | 0;
  $63 = $180;
  HEAP8[i64toi32_i32$0 >> 0] = $63;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $63 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $63 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $63 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $6;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $184 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 160 | 0;
  $64 = $184;
  HEAP8[i64toi32_i32$1 >> 0] = $64;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $64 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $64 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $64 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $10;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $188 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 178 | 0;
  $66 = $188;
  HEAP8[i64toi32_i32$0 >> 0] = $66;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $66 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $66 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $66 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $11;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $192 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 186 | 0;
  $67 = $192;
  HEAP8[i64toi32_i32$1 >> 0] = $67;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $67 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $67 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $67 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $69 = $0 + 194 | 0;
  $70 = HEAP32[$12 >> 2] | 0;
  HEAP8[$69 >> 0] = $70;
  HEAP8[($69 + 1 | 0) >> 0] = $70 >>> 8 | 0;
  HEAP8[($69 + 2 | 0) >> 0] = $70 >>> 16 | 0;
  HEAP8[($69 + 3 | 0) >> 0] = $70 >>> 24 | 0;
  HEAP32[($0 + 48 | 0) >> 2] = HEAP32[(($2 + 104 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 104 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 108 | 0) >> 2] | 0;
  $206 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 40 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $206;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $3 = (i64toi32_i32$2 + 176 | 0) + 8 | 0;
  HEAP32[$3 >> 2] = HEAP32[((i64toi32_i32$2 + 120 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 120 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 124 | 0) >> 2] | 0;
  $217 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$2 + 176 | 0) >> 2] = $217;
  HEAP32[(i64toi32_i32$2 + 180 | 0) >> 2] = i64toi32_i32$0;
  memcpy($0 + 68 | 0 | 0, i64toi32_i32$2 + 136 | 0 | 0, 40 | 0) | 0;
  i64toi32_i32$0 = $14$hi;
  i64toi32_i32$1 = $0 + 32 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $14;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $17$hi;
  i64toi32_i32$1 = $0 + 24 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $17;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $16$hi;
  i64toi32_i32$1 = $0 + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $16;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $15$hi;
  i64toi32_i32$1 = $0 + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $15;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP8[$0 >> 0] = 3;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 176 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 180 | 0) >> 2] | 0;
  $239 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 52 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $239;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($0 + 60 | 0) >> 2] = HEAP32[$3 >> 2] | 0;
  HEAP8[($0 + 169 | 0) >> 0] = $13;
  HEAP8[($0 + 168 | 0) >> 0] = $9;
  HEAP32[($0 + 64 | 0) >> 2] = $1;
  global$0 = i64toi32_i32$2 + 256 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__ScriptNOfK___deserialize__hee5ff3e721c31521($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $4 = 0, $4$hi = 0, $6$hi = 0, $3 = 0, $6 = 0, $7 = 0, $7$hi = 0, $34 = 0, $35 = 0, $36 = 0, $37 = 0, $38 = 0, $39 = 0, $40 = 0, $5 = 0, $5$hi = 0, $41 = 0, $42 = 0, $43 = 0, $66 = 0, $66$hi = 0, $69 = 0, $69$hi = 0, $73$hi = 0, $75$hi = 0, $77$hi = 0, $80 = 0, $80$hi = 0, $92 = 0, $96 = 0, $109 = 0, $127 = 0, $131 = 0, $181 = 0, $185 = 0, $191 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 24 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2 + 40 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
  $5 = i64toi32_i32$1;
  $5$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
       i64toi32_i32$2 = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 1;
       if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
        break label$5
       }
       i64toi32_i32$2 = 0;
       $6 = 0;
       $6$hi = i64toi32_i32$2;
       label$6 : {
        i64toi32_i32$2 = $5$hi;
        i64toi32_i32$3 = $5;
        i64toi32_i32$1 = 0;
        i64toi32_i32$0 = 1;
        if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
         break label$6
        }
        i64toi32_i32$3 = 0;
        $6 = 3;
        $6$hi = i64toi32_i32$3;
        i64toi32_i32$3 = $4$hi;
        i64toi32_i32$0 = $4;
        i64toi32_i32$2 = 0;
        i64toi32_i32$1 = 3;
        if (i64toi32_i32$3 >>> 0 > i64toi32_i32$2 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$0 >>> 0 >= i64toi32_i32$1 >>> 0 | 0) | 0) {
         break label$6
        }
        $1 = 3;
        $3 = 0;
        i64toi32_i32$0 = 0;
        $7 = 0;
        $7$hi = i64toi32_i32$0;
        break label$2;
       }
       i64toi32_i32$0 = $4$hi;
       i64toi32_i32$3 = i64toi32_i32$0;
       cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__ScriptNOfK___deserialize_as_embedded_group__hcd662792aa1dcf35($2 + 24 | 0 | 0, $1 | 0, $4 | 0, i64toi32_i32$0 | 0, $4 | 0, i64toi32_i32$0 | 0);
       i64toi32_i32$3 = 0;
       $7 = 1;
       $7$hi = i64toi32_i32$3;
       label$7 : {
        label$8 : {
         i64toi32_i32$3 = $5$hi;
         i64toi32_i32$1 = $5;
         i64toi32_i32$0 = 0;
         i64toi32_i32$2 = 1;
         if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) | 0) {
          break label$8
         }
         cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 112 | 0 | 0, $1 | 0);
         $3 = HEAPU8[($2 + 120 | 0) >> 0] | 0;
         i64toi32_i32$2 = $2;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 112 | 0) >> 2] | 0;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 116 | 0) >> 2] | 0;
         i64toi32_i32$2 = i64toi32_i32$1;
         i64toi32_i32$1 = 0;
         i64toi32_i32$0 = 1;
         if ((i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) | 0) {
          break label$7
         }
         $1 = 5;
         if (($3 & 255 | 0 | 0) != (5 | 0)) {
          break label$4
         }
         break label$3;
        }
        $1 = 3;
        i64toi32_i32$2 = $6$hi;
        i64toi32_i32$2 = $4$hi;
        i64toi32_i32$2 = $6$hi;
        i64toi32_i32$0 = $6;
        i64toi32_i32$3 = $4$hi;
        i64toi32_i32$1 = $4;
        if ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) | 0) {
         break label$3
        }
        break label$4;
       }
       i64toi32_i32$1 = $2 + 152 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $4 = i64toi32_i32$0;
       $4$hi = i64toi32_i32$2;
       i64toi32_i32$0 = ($2 + 96 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $4;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$0 = ($2 + 8 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $4;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$1 = $2 + 144 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $4 = i64toi32_i32$2;
       $4$hi = i64toi32_i32$0;
       i64toi32_i32$2 = $2;
       HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] = $4;
       HEAP32[(i64toi32_i32$2 + 100 | 0) >> 2] = i64toi32_i32$0;
       HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $4;
       HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$1 = i64toi32_i32$2;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 121 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 122 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 123 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 124 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = 0;
       $66 = i64toi32_i32$0;
       $66$hi = i64toi32_i32$2;
       i64toi32_i32$1 = i64toi32_i32$1 + 125 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
       i64toi32_i32$0 = 0;
       $69 = i64toi32_i32$2;
       $69$hi = i64toi32_i32$0;
       i64toi32_i32$1 = $2 + 127 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
       i64toi32_i32$2 = 0;
       i64toi32_i32$1 = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        $41 = 0;
       } else {
        i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
        $41 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       }
       $73$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $69$hi;
       i64toi32_i32$2 = $69;
       i64toi32_i32$1 = $73$hi;
       i64toi32_i32$3 = $41;
       i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $42 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $42 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       $75$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $66$hi;
       i64toi32_i32$1 = $66;
       i64toi32_i32$0 = $75$hi;
       i64toi32_i32$3 = $42;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 8;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $43 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
        $43 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       $77$hi = i64toi32_i32$1;
       i64toi32_i32$1 = 0;
       i64toi32_i32$0 = $3;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 255;
       i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
       $80 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
       $80$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $77$hi;
       i64toi32_i32$1 = $43;
       i64toi32_i32$0 = $80$hi;
       i64toi32_i32$3 = $80;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
       $4 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       $4$hi = i64toi32_i32$0;
       i64toi32_i32$2 = $2 + 136 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $6 = i64toi32_i32$0;
       $6$hi = i64toi32_i32$1;
       i64toi32_i32$2 = $2 + 128 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $7 = i64toi32_i32$1;
       $7$hi = i64toi32_i32$0;
       $1 = 2;
       break label$4;
      }
      i64toi32_i32$2 = $2 + 64 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $92 = i64toi32_i32$0;
      i64toi32_i32$0 = $2 + 16 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $92;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $2 + 56 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $96 = i64toi32_i32$1;
      i64toi32_i32$1 = $2;
      HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $96;
      HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = i64toi32_i32$1 + 48 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $6 = i64toi32_i32$0;
      $6$hi = i64toi32_i32$1;
      $1 = 2;
      $3 = 0;
      i64toi32_i32$1 = $4$hi;
      $7 = $4;
      $7$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $5$hi;
      $4 = $5;
      $4$hi = i64toi32_i32$1;
      break label$2;
     }
     core__ptr__drop_in_place_core__result__Result_cardano_serialization_lib__ScriptNOfK_2ccardano_serialization_lib__error__DeserializeError____h17201b751208cb38($2 + 24 | 0 | 0);
     $3 = 0;
     break label$2;
    }
    i64toi32_i32$2 = $2 + 72 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $109 = i64toi32_i32$1;
    i64toi32_i32$1 = ($2 + 8 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $109;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[(($2 + 112 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 92 | 0) >> 2] | 0;
    HEAP32[($2 + 96 | 0) >> 2] = HEAPU8[($2 + 33 | 0) >> 0] | 0 | ((HEAPU8[($2 + 34 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 35 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 36 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $34 = ($2 + 24 | 0) + 12 | 0;
    $35 = HEAPU8[$34 >> 0] | 0 | ((HEAPU8[($34 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($34 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($34 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    HEAP8[($2 + 99 | 0) >> 0] = $35;
    HEAP8[($2 + 100 | 0) >> 0] = $35 >>> 8 | 0;
    HEAP8[($2 + 101 | 0) >> 0] = $35 >>> 16 | 0;
    HEAP8[($2 + 102 | 0) >> 0] = $35 >>> 24 | 0;
    i64toi32_i32$2 = $2 + 64 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $127 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $127;
    HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = i64toi32_i32$0 + 84 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $131 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[(i64toi32_i32$1 + 112 | 0) >> 2] = $131;
    HEAP32[(i64toi32_i32$1 + 116 | 0) >> 2] = i64toi32_i32$0;
    $1 = HEAPU8[((i64toi32_i32$1 + 24 | 0) + 8 | 0) >> 0] | 0;
    i64toi32_i32$2 = (i64toi32_i32$1 + 24 | 0) + 16 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $4 = i64toi32_i32$0;
    $4$hi = i64toi32_i32$1;
    label$9 : {
     if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
      break label$9
     }
     i64toi32_i32$2 = $2 + 48 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $7 = i64toi32_i32$1;
     $7$hi = i64toi32_i32$0;
     i64toi32_i32$2 = $2 + 56 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $6 = i64toi32_i32$0;
     $6$hi = i64toi32_i32$1;
     $3 = HEAP32[($2 + 80 | 0) >> 2] | 0;
     break label$2;
    }
    HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
    $36 = HEAP32[($2 + 96 | 0) >> 2] | 0;
    HEAP8[($0 + 9 | 0) >> 0] = $36;
    HEAP8[($0 + 10 | 0) >> 0] = $36 >>> 8 | 0;
    HEAP8[($0 + 11 | 0) >> 0] = $36 >>> 16 | 0;
    HEAP8[($0 + 12 | 0) >> 0] = $36 >>> 24 | 0;
    HEAP8[($0 + 8 | 0) >> 0] = $1;
    $37 = $0 + 12 | 0;
    $38 = HEAPU8[($2 + 99 | 0) >> 0] | 0 | ((HEAPU8[($2 + 100 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 101 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 102 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    HEAP8[$37 >> 0] = $38;
    HEAP8[($37 + 1 | 0) >> 0] = $38 >>> 8 | 0;
    HEAP8[($37 + 2 | 0) >> 0] = $38 >>> 16 | 0;
    HEAP8[($37 + 3 | 0) >> 0] = $38 >>> 24 | 0;
    i64toi32_i32$1 = $4$hi;
    HEAP32[($0 + 16 | 0) >> 2] = $4;
    $1 = 0;
    break label$1;
   }
   i64toi32_i32$1 = $6$hi;
   i64toi32_i32$0 = $2 + 48 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $6;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $7$hi;
   i64toi32_i32$0 = $2 + 40 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $7;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $4$hi;
   i64toi32_i32$0 = ($2 + 24 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $4;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
   $181 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2 + 56 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $181;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 112 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 116 | 0) >> 2] | 0;
   $185 = i64toi32_i32$0;
   i64toi32_i32$0 = i64toi32_i32$2 + 76 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $185;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = (i64toi32_i32$2 + 8 | 0) + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $191 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 64 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $191;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($2 + 84 | 0) >> 2] = HEAP32[(($2 + 112 | 0) + 8 | 0) >> 2] | 0;
   HEAP8[($2 + 24 | 0) >> 0] = $1;
   $39 = HEAP32[($2 + 96 | 0) >> 2] | 0;
   HEAP8[($2 + 25 | 0) >> 0] = $39;
   HEAP8[($2 + 26 | 0) >> 0] = $39 >>> 8 | 0;
   HEAP8[($2 + 27 | 0) >> 0] = $39 >>> 16 | 0;
   HEAP8[($2 + 28 | 0) >> 0] = $39 >>> 24 | 0;
   $40 = HEAPU8[($2 + 99 | 0) >> 0] | 0 | ((HEAPU8[($2 + 100 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 101 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 102 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[($2 + 28 | 0) >> 0] = $40;
   HEAP8[($2 + 29 | 0) >> 0] = $40 >>> 8 | 0;
   HEAP8[($2 + 30 | 0) >> 0] = $40 >>> 16 | 0;
   HEAP8[($2 + 31 | 0) >> 0] = $40 >>> 24 | 0;
   HEAP32[($2 + 72 | 0) >> 2] = $3;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 24 | 0 | 0, 1051798 | 0, 10 | 0);
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 160 | 0;
 }
 
 function cbor_event__de__Deserializer_R___cbor_len__h852681e444aca076_1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, $2 = 0, i64toi32_i32$4 = 0, $3 = 0, $6 = 0, $6$hi = 0, $4 = 0, $7 = 0, $7$hi = 0, $28 = 0, $5 = 0, $29 = 0, $30 = 0, $61 = 0, $105 = 0, $106 = 0, $106$hi = 0, $108$hi = 0, $109 = 0, $112 = 0, $120 = 0, $126 = 0, $132 = 0, $136 = 0, $151 = 0, $172 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 24 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           label$10 : {
            $3 = HEAP32[($2 + 28 | 0) >> 2] | 0;
            if (!$3) {
             break label$10
            }
            $4 = HEAP32[($2 + 24 | 0) >> 2] | 0;
            if (!$4) {
             break label$10
            }
            $3 = (HEAPU8[$4 >> 0] | 0) & 31 | 0;
            if ($3 >>> 0 < 24 >>> 0) {
             break label$9
            }
            switch ($3 + -24 | 0 | 0) {
            case 7:
             break label$3;
            case 3:
             break label$4;
            case 2:
             break label$5;
            case 1:
             break label$6;
            case 0:
             break label$7;
            default:
             break label$8;
            };
           }
           HEAP8[($0 + 8 | 0) >> 0] = 8;
           i64toi32_i32$1 = $0;
           i64toi32_i32$0 = 0;
           HEAP32[i64toi32_i32$1 >> 2] = 1;
           HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
           HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = 0;
           HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = $3;
           break label$1;
          }
          i64toi32_i32$1 = $0;
          i64toi32_i32$0 = 0;
          HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = 1;
          HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
          i64toi32_i32$0 = 0;
          HEAP32[i64toi32_i32$1 >> 2] = 0;
          HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
          HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = 0;
          i64toi32_i32$0 = 0;
          i64toi32_i32$1 = i64toi32_i32$1 + 16 | 0;
          HEAP32[i64toi32_i32$1 >> 2] = $3;
          HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
          break label$1;
         }
         label$11 : {
          if ($3 >>> 0 < 28 >>> 0) {
           break label$11
          }
          if (($3 | 0) != (31 | 0)) {
           break label$2
          }
         }
         core__panicking__panic__h2fd385a887c8bf13(1054592 | 0, 40 | 0, 1054740 | 0);
         abort();
        }
        std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 | 0, $1 | 0);
        label$12 : {
         label$13 : {
          $3 = HEAP32[($2 + 4 | 0) >> 2] | 0;
          if ($3 >>> 0 < 2 >>> 0) {
           break label$13
          }
          $1 = HEAP32[$2 >> 2] | 0;
          if (!$1) {
           break label$13
          }
          i64toi32_i32$2 = $1;
          i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0;
          i64toi32_i32$1 = 0;
          $61 = i64toi32_i32$0;
          i64toi32_i32$0 = $0 + 16 | 0;
          HEAP32[i64toi32_i32$0 >> 2] = $61;
          HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
          $1 = $0 + 24 | 0;
          i64toi32_i32$1 = 0;
          $6 = 0;
          $6$hi = i64toi32_i32$1;
          i64toi32_i32$1 = 0;
          $7 = 1;
          $7$hi = i64toi32_i32$1;
          break label$12;
         }
         $1 = $0 + 16 | 0;
         i64toi32_i32$1 = 0;
         i64toi32_i32$2 = $3;
         i64toi32_i32$0 = 0;
         i64toi32_i32$3 = 32;
         i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
          i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
          $28 = 0;
         } else {
          i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
          $28 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
         }
         i64toi32_i32$1 = $28;
         i64toi32_i32$2 = 0;
         i64toi32_i32$3 = 8;
         i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
         $7 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
         $7$hi = i64toi32_i32$2;
         i64toi32_i32$2 = 0;
         $6 = 1;
         $6$hi = i64toi32_i32$2;
        }
        i64toi32_i32$2 = $7$hi;
        i64toi32_i32$1 = $0;
        HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $7;
        HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$2;
        HEAP32[$1 >> 2] = 1;
        i64toi32_i32$2 = $6$hi;
        HEAP32[i64toi32_i32$1 >> 2] = $6;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
        break label$1;
       }
       std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 16 | 0 | 0, $1 | 0);
       $3 = 1;
       label$14 : {
        label$15 : {
         $4 = HEAP32[($2 + 20 | 0) >> 2] | 0;
         if ($4 >>> 0 < 2 >>> 0) {
          break label$15
         }
         $5 = HEAP32[($2 + 16 | 0) >> 2] | 0;
         if (!$5) {
          break label$15
         }
         i64toi32_i32$0 = $5;
         i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0;
         i64toi32_i32$1 = 0;
         $6 = i64toi32_i32$2;
         $6$hi = i64toi32_i32$1;
         std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 8 | 0 | 0, $1 | 0);
         $3 = 2;
         $4 = HEAP32[($2 + 12 | 0) >> 2] | 0;
         if ($4 >>> 0 < 3 >>> 0) {
          break label$15
         }
         $1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
         if (!$1) {
          break label$15
         }
         i64toi32_i32$0 = $1;
         i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0;
         i64toi32_i32$2 = 0;
         $7 = i64toi32_i32$1;
         $7$hi = i64toi32_i32$2;
         HEAP32[($0 + 24 | 0) >> 2] = 2;
         i64toi32_i32$1 = $0;
         i64toi32_i32$2 = 0;
         HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = 1;
         HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$2;
         $105 = i64toi32_i32$1 + 16 | 0;
         i64toi32_i32$2 = $7$hi;
         $106 = $7;
         $106$hi = i64toi32_i32$2;
         i64toi32_i32$2 = $6$hi;
         i64toi32_i32$0 = $6;
         i64toi32_i32$1 = 0;
         i64toi32_i32$3 = 8;
         i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
          i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
          $29 = 0;
         } else {
          i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
          $29 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
         }
         $108$hi = i64toi32_i32$1;
         i64toi32_i32$1 = $106$hi;
         i64toi32_i32$2 = $106;
         i64toi32_i32$0 = $108$hi;
         i64toi32_i32$3 = $29;
         i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
         $109 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
         i64toi32_i32$2 = $105;
         HEAP32[i64toi32_i32$2 >> 2] = $109;
         HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$0 = 0;
         $6 = 0;
         $6$hi = i64toi32_i32$0;
         break label$14;
        }
        i64toi32_i32$1 = $2;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 32 | 0) >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] | 0;
        $112 = i64toi32_i32$0;
        i64toi32_i32$0 = $0;
        HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = $112;
        HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = i64toi32_i32$2;
        HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $3;
        i64toi32_i32$1 = i64toi32_i32$1 + 40 | 0;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
        $120 = i64toi32_i32$2;
        i64toi32_i32$2 = $0 + 28 | 0;
        HEAP32[i64toi32_i32$2 >> 2] = $120;
        HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$1 = ($2 + 32 | 0) + 16 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
        $126 = i64toi32_i32$0;
        i64toi32_i32$0 = $0 + 36 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $126;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
        HEAP32[($0 + 44 | 0) >> 2] = HEAP32[($2 + 56 | 0) >> 2] | 0;
        $132 = $0;
        i64toi32_i32$2 = 0;
        i64toi32_i32$1 = $4;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 32;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
         $30 = 0;
        } else {
         i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
         $30 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        }
        i64toi32_i32$2 = $30;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 8;
        i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
        $136 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
        i64toi32_i32$2 = $132;
        HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $136;
        HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$1 = 0;
        $6 = 1;
        $6$hi = i64toi32_i32$1;
       }
       i64toi32_i32$1 = $6$hi;
       i64toi32_i32$2 = $0;
       HEAP32[i64toi32_i32$2 >> 2] = $6;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       break label$1;
      }
      cbor_event__de__Deserializer_R___u32__h46f77234696376fa($2 + 32 | 0 | 0, $1 | 0);
      i64toi32_i32$1 = 0;
      $6 = 1;
      $6$hi = i64toi32_i32$1;
      label$16 : {
       label$17 : {
        i64toi32_i32$0 = $2;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 36 | 0) >> 2] | 0;
        i64toi32_i32$0 = i64toi32_i32$1;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$1 | 0) | 0) {
         break label$17
        }
        i64toi32_i32$2 = $0;
        i64toi32_i32$0 = 0;
        HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = 1;
        HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$0;
        HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] = 4;
        i64toi32_i32$3 = $2;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 40 | 0) >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 44 | 0) >> 2] | 0;
        $151 = i64toi32_i32$0;
        i64toi32_i32$0 = $0 + 16 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $151;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
        i64toi32_i32$2 = 0;
        $6 = 0;
        $6$hi = i64toi32_i32$2;
        break label$16;
       }
       memcpy($0 + 8 | 0 | 0, ($2 + 32 | 0) + 8 | 0 | 0, 40 | 0) | 0;
      }
      i64toi32_i32$2 = $6$hi;
      i64toi32_i32$0 = $0;
      HEAP32[i64toi32_i32$0 >> 2] = $6;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
      break label$1;
     }
     cbor_event__de__Deserializer_R___u64__hb76211f6fef2ef8e($2 + 32 | 0 | 0, $1 | 0);
     i64toi32_i32$2 = 0;
     $6 = 1;
     $6$hi = i64toi32_i32$2;
     label$18 : {
      label$19 : {
       i64toi32_i32$3 = $2;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 32 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 36 | 0) >> 2] | 0;
       i64toi32_i32$3 = i64toi32_i32$2;
       i64toi32_i32$2 = 0;
       i64toi32_i32$1 = 1;
       if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) | 0) {
        break label$19
       }
       i64toi32_i32$0 = $0;
       i64toi32_i32$3 = 0;
       HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = 1;
       HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$3;
       HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = 8;
       i64toi32_i32$1 = $2;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 40 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 44 | 0) >> 2] | 0;
       $172 = i64toi32_i32$3;
       i64toi32_i32$3 = $0 + 16 | 0;
       HEAP32[i64toi32_i32$3 >> 2] = $172;
       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       $6 = 0;
       $6$hi = i64toi32_i32$0;
       break label$18;
      }
      memcpy($0 + 8 | 0 | 0, ($2 + 32 | 0) + 8 | 0 | 0, 40 | 0) | 0;
     }
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$3 = $0;
     HEAP32[$0 >> 2] = $6;
     HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$0;
     break label$1;
    }
    i64toi32_i32$3 = $0;
    i64toi32_i32$0 = 0;
    HEAP32[$0 >> 2] = 0;
    HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($0 + 24 | 0) >> 2] = 0;
    i64toi32_i32$3 = $0 + 8 | 0;
    i64toi32_i32$0 = 0;
    HEAP32[i64toi32_i32$3 >> 2] = 0;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
    break label$1;
   }
   HEAP8[($0 + 8 | 0) >> 0] = 11;
   i64toi32_i32$3 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[$0 >> 2] = 1;
   HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP8[($0 + 9 | 0) >> 0] = $3;
  }
  global$0 = $2 + 80 | 0;
 }
 
 function alloc__collections__btree__remove___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__KV____remove_leaf_kv__h27b8b726dbbf8174($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $7 = 0, $5 = 0, $6 = 0, $4 = 0, $9 = 0, $8 = 0, $10 = 0, $11 = 0, $35 = 0, $40 = 0, $12 = 0, $12$hi = 0, $75 = 0, $78 = 0, $123 = 0, $128 = 0, $158 = 0, $163 = 0, $184 = 0, $189 = 0, $206 = 0, $211 = 0, $234 = 0, $248 = 0;
  $3 = global$0 - 112 | 0;
  global$0 = $3;
  $4 = ($3 + 40 | 0) + 8 | 0;
  $5 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $6 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $7 = $5 + Math_imul($6, 12) | 0;
  HEAP32[$4 >> 2] = HEAP32[($7 + 100 | 0) >> 2] | 0;
  $8 = $7 + 92 | 0;
  i64toi32_i32$2 = $8;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $35 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[($3 + 40 | 0) >> 2] = $35;
  HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$1;
  $1 = HEAP32[$1 >> 2] | 0;
  $40 = $7 + 104 | 0;
  $7 = HEAPU16[($5 + 226 | 0) >> 1] | 0;
  $9 = $7 + ($6 ^ -1 | 0) | 0;
  memmove(i64toi32_i32$2 | 0, $40 | 0, Math_imul($9, 12) | 0) | 0;
  $8 = $5 + ($6 << 3 | 0) | 0;
  i64toi32_i32$2 = $8;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $12 = i64toi32_i32$1;
  $12$hi = i64toi32_i32$0;
  $10 = $6 + 1 | 0;
  memmove(i64toi32_i32$2 | 0, $5 + ($10 << 3 | 0) | 0 | 0, $9 << 3 | 0 | 0) | 0;
  $7 = $7 + -1 | 0;
  HEAP16[($5 + 226 | 0) >> 1] = $7;
  $8 = ($3 + 8 | 0) + 8 | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $75 = i64toi32_i32$0;
  i64toi32_i32$0 = $8;
  HEAP32[i64toi32_i32$0 >> 2] = $75;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[($3 + 40 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($3 + 44 | 0) >> 2] | 0;
  $78 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[($3 + 8 | 0) >> 2] = $78;
  HEAP32[($3 + 12 | 0) >> 2] = i64toi32_i32$0;
  label$1 : {
   if (($7 & 65535 | 0) >>> 0 > 4 >>> 0) {
    break label$1
   }
   alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___choose_parent_kv__hcc0b8d6ea18560ad($3 + 40 | 0 | 0, $1 | 0, $5 | 0);
   $5 = HEAP32[($3 + 44 | 0) >> 2] | 0;
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ((HEAP32[($3 + 40 | 0) >> 2] | 0 | 0) == (1 | 0)) {
        break label$5
       }
       $7 = HEAP32[($3 + 64 | 0) >> 2] | 0;
       $4 = HEAP32[($3 + 72 | 0) >> 2] | 0;
       $11 = ((HEAPU16[($7 + 226 | 0) >> 1] | 0) + (HEAPU16[($4 + 226 | 0) >> 1] | 0) | 0) + 1 | 0;
       $1 = $3 + 48 | 0;
       $9 = HEAP32[($3 + 68 | 0) >> 2] | 0;
       if (($5 | 0) == (1 | 0)) {
        break label$4
       }
       if ($11 >>> 0 < 12 >>> 0) {
        break label$3
       }
       HEAP32[($3 + 104 | 0) >> 2] = $4;
       HEAP32[($3 + 96 | 0) >> 2] = $7;
       i64toi32_i32$2 = $1 + 8 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $123 = i64toi32_i32$0;
       i64toi32_i32$0 = ($3 + 80 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $123;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       HEAP32[($3 + 100 | 0) >> 2] = $9;
       i64toi32_i32$2 = $1;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $128 = i64toi32_i32$1;
       i64toi32_i32$1 = $3;
       HEAP32[($3 + 80 | 0) >> 2] = $128;
       HEAP32[($3 + 84 | 0) >> 2] = i64toi32_i32$0;
       alloc__collections__btree__node__BalancingContext_K_2cV___bulk_steal_left__hda63a524cf155183($3 + 80 | 0 | 0, 1 | 0);
       HEAP32[($3 + 32 | 0) >> 2] = $10;
       HEAP32[($3 + 28 | 0) >> 2] = $4;
       HEAP32[($3 + 24 | 0) >> 2] = $9;
       break label$2;
      }
      HEAP32[($3 + 32 | 0) >> 2] = $6;
      HEAP32[($3 + 24 | 0) >> 2] = $5;
      HEAP32[($3 + 28 | 0) >> 2] = HEAP32[($3 + 48 | 0) >> 2] | 0;
      break label$2;
     }
     label$6 : {
      if ($11 >>> 0 < 12 >>> 0) {
       break label$6
      }
      HEAP32[($3 + 104 | 0) >> 2] = $4;
      HEAP32[($3 + 96 | 0) >> 2] = $7;
      i64toi32_i32$2 = $1 + 8 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $158 = i64toi32_i32$0;
      i64toi32_i32$0 = ($3 + 80 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $158;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($3 + 100 | 0) >> 2] = $9;
      i64toi32_i32$2 = $1;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $163 = i64toi32_i32$1;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 80 | 0) >> 2] = $163;
      HEAP32[($3 + 84 | 0) >> 2] = i64toi32_i32$0;
      alloc__collections__btree__node__BalancingContext_K_2cV___bulk_steal_right__hfc3fbd9528abaf5f($3 + 80 | 0 | 0, 1 | 0);
      HEAP32[($3 + 32 | 0) >> 2] = $6;
      HEAP32[($3 + 28 | 0) >> 2] = $7;
      HEAP32[($3 + 24 | 0) >> 2] = HEAP32[($3 + 92 | 0) >> 2] | 0;
      break label$2;
     }
     HEAP32[($3 + 104 | 0) >> 2] = $4;
     HEAP32[($3 + 96 | 0) >> 2] = $7;
     i64toi32_i32$2 = $1 + 8 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $184 = i64toi32_i32$0;
     i64toi32_i32$0 = ($3 + 80 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $184;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($3 + 100 | 0) >> 2] = $9;
     i64toi32_i32$2 = $1;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $189 = i64toi32_i32$1;
     i64toi32_i32$1 = $3;
     HEAP32[($3 + 80 | 0) >> 2] = $189;
     HEAP32[($3 + 84 | 0) >> 2] = i64toi32_i32$0;
     alloc__collections__btree__node__BalancingContext_K_2cV___merge_tracking_child_edge__h4d67870504cb06f4($3 + 24 | 0 | 0, $3 + 80 | 0 | 0, 0 | 0, $6 | 0);
     break label$2;
    }
    HEAP32[($3 + 104 | 0) >> 2] = $4;
    HEAP32[($3 + 96 | 0) >> 2] = $7;
    i64toi32_i32$2 = $1 + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $206 = i64toi32_i32$0;
    i64toi32_i32$0 = ($3 + 80 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $206;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($3 + 100 | 0) >> 2] = $9;
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $211 = i64toi32_i32$1;
    i64toi32_i32$1 = $3;
    HEAP32[($3 + 80 | 0) >> 2] = $211;
    HEAP32[($3 + 84 | 0) >> 2] = i64toi32_i32$0;
    alloc__collections__btree__node__BalancingContext_K_2cV___merge_tracking_child_edge__h4d67870504cb06f4($3 + 24 | 0 | 0, $3 + 80 | 0 | 0, 1 | 0, $6 | 0);
   }
   $6 = HEAP32[($3 + 32 | 0) >> 2] | 0;
   $1 = HEAP32[($3 + 24 | 0) >> 2] | 0;
   $5 = HEAP32[($3 + 28 | 0) >> 2] | 0;
   $7 = HEAP32[($5 + 88 | 0) >> 2] | 0;
   if (!$7) {
    break label$1
   }
   if (alloc__collections__btree__fix___impl_20alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____fix_node_and_affected_ancestors__h5cf4d5878102f95c($1 + 1 | 0 | 0, $7 | 0) | 0) {
    break label$1
   }
   HEAP8[$2 >> 0] = 1;
  }
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
  $234 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $234;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = $1;
  i64toi32_i32$1 = $12$hi;
  HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $12;
  HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] = $6;
  HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = $5;
  i64toi32_i32$2 = $8;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $248 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $248;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $3 + 112 | 0;
 }
 
 function cardano_serialization_lib__Certificate__as_pool_registration__h69561f00b9b1df50($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $3 = 0, $53 = 0, $54 = 0, $55 = 0, $57 = 0, $58 = 0, $59 = 0, $60 = 0, $61 = 0, $62 = 0, $64 = 0, $65 = 0, $66 = 0, $67 = 0, $68 = 0, $69 = 0, $71 = 0, $4 = 0, $5 = 0, $6 = 0, $7 = 0, $8 = 0, $10 = 0, $11 = 0, $12 = 0, $14 = 0, $38 = 0, $45 = 0, $49 = 0, $56 = 0, $63 = 0, $70 = 0, $74 = 0, $15 = 0, $15$hi = 0, $16 = 0, $16$hi = 0, $17 = 0, $17$hi = 0, $18 = 0, $18$hi = 0, $9 = 0, $96 = 0, $103 = 0, $114 = 0, $13 = 0, $137 = 0, $142 = 0, $147 = 0, $151 = 0, $162 = 0, $165 = 0, $168 = 0, $176 = 0, $180 = 0, $184 = 0, $188 = 0, $192 = 0, $196 = 0, $200 = 0, $213 = 0, $224 = 0, $240 = 0;
  $2 = global$0 - 256 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if ((HEAPU8[$1 >> 0] | 0 | 0) != (3 | 0)) {
     break label$2
    }
    $3 = ($2 + 8 | 0) + 24 | 0;
    $53 = $1 + 132 | 0;
    HEAP32[$3 >> 2] = HEAPU8[$53 >> 0] | 0 | ((HEAPU8[($53 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($53 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($53 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $4 = ($2 + 8 | 0) + 16 | 0;
    i64toi32_i32$2 = $1 + 124 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $38 = i64toi32_i32$0;
    i64toi32_i32$0 = $4;
    HEAP32[i64toi32_i32$0 >> 2] = $38;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    $5 = ($2 + 8 | 0) + 8 | 0;
    i64toi32_i32$2 = $1 + 116 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $45 = i64toi32_i32$1;
    i64toi32_i32$1 = $5;
    HEAP32[i64toi32_i32$1 >> 2] = $45;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $1 + 108 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $49 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $49;
    HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
    $6 = (i64toi32_i32$0 + 40 | 0) + 24 | 0;
    i64toi32_i32$2 = $1 + 160 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $56 = i64toi32_i32$1;
    i64toi32_i32$1 = $6;
    HEAP32[i64toi32_i32$1 >> 2] = $56;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    $7 = ($2 + 40 | 0) + 16 | 0;
    i64toi32_i32$2 = $1 + 152 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $63 = i64toi32_i32$0;
    i64toi32_i32$0 = $7;
    HEAP32[i64toi32_i32$0 >> 2] = $63;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    $8 = ($2 + 40 | 0) + 8 | 0;
    i64toi32_i32$2 = $1 + 144 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $70 = i64toi32_i32$1;
    i64toi32_i32$1 = $8;
    HEAP32[i64toi32_i32$1 >> 2] = $70;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $1 + 136 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $74 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[(i64toi32_i32$0 + 40 | 0) >> 2] = $74;
    HEAP32[(i64toi32_i32$0 + 44 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $1 + 8 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $15 = i64toi32_i32$1;
    $15$hi = i64toi32_i32$0;
    i64toi32_i32$2 = $1 + 16 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $16 = i64toi32_i32$0;
    $16$hi = i64toi32_i32$1;
    i64toi32_i32$2 = $1 + 24 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $17 = i64toi32_i32$1;
    $17$hi = i64toi32_i32$0;
    i64toi32_i32$2 = $1 + 32 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $18 = i64toi32_i32$0;
    $18$hi = i64toi32_i32$1;
    $9 = HEAPU8[($1 + 168 | 0) >> 0] | 0;
    $10 = ($2 + 72 | 0) + 8 | 0;
    i64toi32_i32$2 = $1 + 178 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $96 = i64toi32_i32$1;
    i64toi32_i32$1 = $10;
    HEAP32[i64toi32_i32$1 >> 2] = $96;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    $11 = ($2 + 72 | 0) + 16 | 0;
    i64toi32_i32$2 = $1 + 186 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $103 = i64toi32_i32$0;
    i64toi32_i32$0 = $11;
    HEAP32[i64toi32_i32$0 >> 2] = $103;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    $12 = ($2 + 72 | 0) + 24 | 0;
    $54 = $1 + 194 | 0;
    HEAP32[$12 >> 2] = HEAPU8[$54 >> 0] | 0 | ((HEAPU8[($54 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($54 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($54 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$2 = $1 + 170 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $114 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[(i64toi32_i32$1 + 72 | 0) >> 2] = $114;
    HEAP32[(i64toi32_i32$1 + 76 | 0) >> 2] = i64toi32_i32$0;
    $13 = HEAPU8[($1 + 169 | 0) >> 0] | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h25db889dc58a550d(i64toi32_i32$1 + 104 | 0 | 0, $1 + 40 | 0 | 0);
    $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h3d33b90cd2011dc4(i64toi32_i32$1 + 120 | 0 | 0, $1 + 52 | 0 | 0);
    label$3 : {
     label$4 : {
      $14 = $1 + 64 | 0;
      if (HEAP32[$14 >> 2] | 0) {
       break label$4
      }
      $1 = 0;
      break label$3;
     }
     $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($2 + 176 | 0 | 0, $14 | 0);
     i64toi32_i32$2 = $1 + 100 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $137 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 212 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $137;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $1 + 92 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $142 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 204 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $142;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $1 + 84 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $147 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 196 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $147;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $1 + 76 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $151 = i64toi32_i32$1;
     i64toi32_i32$1 = $2;
     HEAP32[(i64toi32_i32$1 + 188 | 0) >> 2] = $151;
     HEAP32[(i64toi32_i32$1 + 192 | 0) >> 2] = i64toi32_i32$0;
     $1 = HEAP32[(i64toi32_i32$1 + 176 | 0) >> 2] | 0;
     memcpy(i64toi32_i32$1 + 136 | 0 | 0, i64toi32_i32$1 + 176 | 0 | 4 | 0 | 0, 40 | 0) | 0;
    }
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
    $162 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    $55 = $162;
    HEAP8[(i64toi32_i32$0 + 100 | 0) >> 0] = $55;
    HEAP8[(i64toi32_i32$0 + 101 | 0) >> 0] = $55 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 102 | 0) >> 0] = $55 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 103 | 0) >> 0] = $55 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 104 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 105 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 106 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 107 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] | 0;
    $165 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    $57 = $165;
    HEAP8[(i64toi32_i32$1 + 128 | 0) >> 0] = $57;
    HEAP8[(i64toi32_i32$1 + 129 | 0) >> 0] = $57 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 130 | 0) >> 0] = $57 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 131 | 0) >> 0] = $57 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 132 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 133 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 134 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 135 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 72 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 76 | 0) >> 2] | 0;
    $168 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    $58 = $168;
    HEAP8[(i64toi32_i32$0 + 162 | 0) >> 0] = $58;
    HEAP8[(i64toi32_i32$0 + 163 | 0) >> 0] = $58 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 164 | 0) >> 0] = $58 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 165 | 0) >> 0] = $58 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 166 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 167 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 168 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 169 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    $59 = i64toi32_i32$0 + 124 | 0;
    $60 = HEAP32[$3 >> 2] | 0;
    HEAP8[$59 >> 0] = $60;
    HEAP8[($59 + 1 | 0) >> 0] = $60 >>> 8 | 0;
    HEAP8[($59 + 2 | 0) >> 0] = $60 >>> 16 | 0;
    HEAP8[($59 + 3 | 0) >> 0] = $60 >>> 24 | 0;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $176 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 116 | 0;
    $61 = $176;
    HEAP8[i64toi32_i32$1 >> 0] = $61;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $61 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $61 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $61 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$2 = $5;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $180 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 108 | 0;
    $62 = $180;
    HEAP8[i64toi32_i32$0 >> 0] = $62;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $62 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $62 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $62 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$2 = $8;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $184 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 136 | 0;
    $64 = $184;
    HEAP8[i64toi32_i32$1 >> 0] = $64;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $64 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $64 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $64 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$2 = $7;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $188 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 144 | 0;
    $65 = $188;
    HEAP8[i64toi32_i32$0 >> 0] = $65;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $65 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $65 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $65 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$2 = $6;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $192 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 152 | 0;
    $66 = $192;
    HEAP8[i64toi32_i32$1 >> 0] = $66;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $66 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $66 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $66 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$2 = $10;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $196 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 170 | 0;
    $67 = $196;
    HEAP8[i64toi32_i32$0 >> 0] = $67;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $67 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $67 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $67 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$2 = $11;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $200 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 178 | 0;
    $68 = $200;
    HEAP8[i64toi32_i32$1 >> 0] = $68;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $68 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $68 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $68 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    $69 = $0 + 186 | 0;
    $71 = HEAP32[$12 >> 2] | 0;
    HEAP8[$69 >> 0] = $71;
    HEAP8[($69 + 1 | 0) >> 0] = $71 >>> 8 | 0;
    HEAP8[($69 + 2 | 0) >> 0] = $71 >>> 16 | 0;
    HEAP8[($69 + 3 | 0) >> 0] = $71 >>> 24 | 0;
    HEAP32[($0 + 40 | 0) >> 2] = HEAP32[(($2 + 104 | 0) + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 104 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 108 | 0) >> 2] | 0;
    $213 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] = $213;
    HEAP32[(i64toi32_i32$0 + 36 | 0) >> 2] = i64toi32_i32$1;
    $3 = (i64toi32_i32$2 + 176 | 0) + 8 | 0;
    HEAP32[$3 >> 2] = HEAP32[((i64toi32_i32$2 + 120 | 0) + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 120 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 124 | 0) >> 2] | 0;
    $224 = i64toi32_i32$1;
    i64toi32_i32$1 = i64toi32_i32$2;
    HEAP32[(i64toi32_i32$2 + 176 | 0) >> 2] = $224;
    HEAP32[(i64toi32_i32$2 + 180 | 0) >> 2] = i64toi32_i32$0;
    memcpy($0 + 60 | 0 | 0, i64toi32_i32$2 + 136 | 0 | 0, 40 | 0) | 0;
    i64toi32_i32$0 = $18$hi;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = $18;
    HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = $17$hi;
    HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $17;
    HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = $16$hi;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $16;
    HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = $15$hi;
    HEAP32[i64toi32_i32$1 >> 2] = $15;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 176 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 180 | 0) >> 2] | 0;
    $240 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 44 | 0) >> 2] = $240;
    HEAP32[(i64toi32_i32$0 + 48 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(i64toi32_i32$0 + 52 | 0) >> 2] = HEAP32[$3 >> 2] | 0;
    HEAP8[(i64toi32_i32$0 + 161 | 0) >> 0] = $13;
    HEAP8[(i64toi32_i32$0 + 160 | 0) >> 0] = $9;
    HEAP32[(i64toi32_i32$0 + 56 | 0) >> 2] = $1;
    break label$1;
   }
   HEAP8[($0 + 161 | 0) >> 0] = 2;
  }
  global$0 = $2 + 256 | 0;
 }
 
 function cardano_serialization_lib__tx_builder__TransactionBuilder__set_mint__hd1a253bf30504cb0($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $7 = 0, $27 = 0, $28 = 0, $29 = 0, $30 = 0, $31 = 0, $32 = 0, $5 = 0, $6 = 0, $9 = 0, $10 = 0, $10$hi = 0, $11 = 0, $11$hi = 0, $62 = 0, $69 = 0, $72 = 0, $8 = 0, $107 = 0, $112 = 0, $117 = 0, $138 = 0, $159 = 0, $199 = 0, $218 = 0;
  $4 = global$0 - 176 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    label$3 : {
     $5 = HEAP32[($3 + 8 | 0) >> 2] | 0;
     if (!$5) {
      break label$3
     }
     $6 = HEAP32[$3 >> 2] | 0;
     std__thread__local__LocalKey_T___with__h4cd07b14a44a727e($4 + 24 | 0 | 0, 1063664 | 0);
     i64toi32_i32$2 = $4;
     i64toi32_i32$0 = HEAP32[($4 + 24 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($4 + 28 | 0) >> 2] | 0;
     $10 = i64toi32_i32$0;
     $10$hi = i64toi32_i32$1;
     i64toi32_i32$2 = $4;
     i64toi32_i32$1 = HEAP32[($4 + 32 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($4 + 36 | 0) >> 2] | 0;
     $11 = i64toi32_i32$1;
     $11$hi = i64toi32_i32$0;
     $3 = hashbrown__raw__generic__Group__static_empty__hc5a7932fe1bdb1f1() | 0;
     i64toi32_i32$1 = ($4 + 40 | 0) + 24 | 0;
     i64toi32_i32$0 = 0;
     HEAP32[i64toi32_i32$1 >> 2] = 0;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($4 + 60 | 0) >> 2] = $3;
     HEAP32[($4 + 56 | 0) >> 2] = 0;
     i64toi32_i32$0 = $11$hi;
     i64toi32_i32$1 = $4;
     HEAP32[($4 + 48 | 0) >> 2] = $11;
     HEAP32[($4 + 52 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$0 = $10$hi;
     i64toi32_i32$1 = $4;
     HEAP32[($4 + 40 | 0) >> 2] = $10;
     HEAP32[($4 + 44 | 0) >> 2] = i64toi32_i32$0;
     $hashbrown__map__HashMap_K_2cV_2cS_2cA__20as_20core__iter__traits__collect__Extend__28K_2cV_29____extend__h9fa35a5044e7202b($4 + 40 | 0 | 0, $6 | 0, $6 + ($5 << 5 | 0) | 0 | 0);
     alloc__collections__btree__map__BTreeMap_K_2cV___iter__hbe8f4ddb910904b5($4 + 112 | 0 | 0, $2 | 0);
     HEAP32[(($4 + 144 | 0) + 24 | 0) >> 2] = HEAP32[(($4 + 112 | 0) + 24 | 0) >> 2] | 0;
     i64toi32_i32$2 = ($4 + 112 | 0) + 16 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $62 = i64toi32_i32$0;
     i64toi32_i32$0 = ($4 + 144 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $62;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = ($4 + 112 | 0) + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $69 = i64toi32_i32$1;
     i64toi32_i32$1 = ($4 + 144 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $69;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $4;
     i64toi32_i32$0 = HEAP32[($4 + 112 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($4 + 116 | 0) >> 2] | 0;
     $72 = i64toi32_i32$0;
     i64toi32_i32$0 = $4;
     HEAP32[($4 + 144 | 0) >> 2] = $72;
     HEAP32[($4 + 148 | 0) >> 2] = i64toi32_i32$1;
     $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__h3acc6a814a137cd3($4 + 72 | 0 | 0, $4 + 144 | 0 | 0);
     $3 = Math_imul(HEAP32[($4 + 80 | 0) >> 2] | 0, 28);
     $7 = HEAP32[($4 + 72 | 0) >> 2] | 0;
     label$4 : {
      label$5 : while (1) {
       if (!$3) {
        break label$4
       }
       $3 = $3 + -28 | 0;
       $8 = hashbrown__map__HashMap_K_2cV_2cS_2cA___contains_key__h55b3ecb4b6dda83d($4 + 40 | 0 | 0, $7 | 0) | 0;
       $9 = $7 + 28 | 0;
       $7 = $9;
       if ($8) {
        continue label$5
       }
       break label$5;
      };
      alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($4 + 16 | 0 | 0, 28 | 0, 0 | 0);
      HEAP32[($4 + 148 | 0) >> 2] = HEAP32[($4 + 20 | 0) >> 2] | 0;
      $3 = HEAP32[($4 + 16 | 0) >> 2] | 0;
      HEAP32[($4 + 144 | 0) >> 2] = $3;
      $7 = $9 + -28 | 0;
      i64toi32_i32$2 = $7;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $107 = i64toi32_i32$1;
      i64toi32_i32$1 = $3;
      $27 = $107;
      HEAP8[i64toi32_i32$1 >> 0] = $27;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $27 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $27 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $27 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $112 = i64toi32_i32$0;
      i64toi32_i32$0 = $3 + 8 | 0;
      $28 = $112;
      HEAP8[i64toi32_i32$0 >> 0] = $28;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $28 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $28 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $28 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      i64toi32_i32$2 = $7 + 16 | 0;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $117 = i64toi32_i32$1;
      i64toi32_i32$1 = $3 + 16 | 0;
      $29 = $117;
      HEAP8[i64toi32_i32$1 >> 0] = $29;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $29 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $29 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $29 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      $30 = $7 + 24 | 0;
      $31 = $3 + 24 | 0;
      $32 = HEAPU8[$30 >> 0] | 0 | ((HEAPU8[($30 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($30 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($30 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[$31 >> 0] = $32;
      HEAP8[($31 + 1 | 0) >> 0] = $32 >>> 8 | 0;
      HEAP8[($31 + 2 | 0) >> 0] = $32 >>> 16 | 0;
      HEAP8[($31 + 3 | 0) >> 0] = $32 >>> 24 | 0;
      HEAP32[($4 + 152 | 0) >> 2] = 28;
      hex__encode__ha65497b593c9e23a($4 + 112 | 0 | 0, $4 + 144 | 0 | 0);
      core__fmt__ArgumentV1__new__h56a0e5bff2bd9085($4 + 8 | 0 | 0, $4 + 112 | 0 | 0, 106 | 0);
      HEAP32[($4 + 164 | 0) >> 2] = 1;
      i64toi32_i32$1 = $4;
      i64toi32_i32$0 = 0;
      HEAP32[($4 + 148 | 0) >> 2] = 2;
      HEAP32[($4 + 152 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[($4 + 144 | 0) >> 2] = 1064192;
      i64toi32_i32$2 = $4;
      i64toi32_i32$0 = HEAP32[($4 + 8 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($4 + 12 | 0) >> 2] | 0;
      $138 = i64toi32_i32$0;
      i64toi32_i32$0 = $4;
      HEAP32[($4 + 104 | 0) >> 2] = $138;
      HEAP32[($4 + 108 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($4 + 160 | 0) >> 2] = $4 + 104 | 0;
      alloc__fmt__format__h6e9e003a52c07309($4 + 88 | 0 | 0, $4 + 144 | 0 | 0);
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($4 + 112 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($4 + 112 | 0 | 0);
      HEAP32[(($4 + 144 | 0) + 8 | 0) >> 2] = HEAP32[(($4 + 88 | 0) + 8 | 0) >> 2] | 0;
      i64toi32_i32$2 = $4;
      i64toi32_i32$1 = HEAP32[($4 + 88 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($4 + 92 | 0) >> 2] | 0;
      $159 = i64toi32_i32$1;
      i64toi32_i32$1 = $4;
      HEAP32[($4 + 144 | 0) >> 2] = $159;
      HEAP32[($4 + 148 | 0) >> 2] = i64toi32_i32$0;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($4 | 0, $4 + 144 | 0 | 0);
      $7 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[$4 >> 2] | 0 | 0, HEAP32[($4 + 4 | 0) >> 2] | 0 | 0) | 0;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($4 + 144 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($4 + 144 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hd17502cd2c574696($4 + 72 | 0 | 0);
      if (!(HEAP32[($4 + 56 | 0) >> 2] | 0)) {
       break label$2
      }
      hashbrown__raw__RawTable_T_2cA___free_buckets__h0d3b2bc1ee0c4acb(($4 + 40 | 0) + 16 | 0 | 0);
      break label$2;
     }
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hd17502cd2c574696($4 + 72 | 0 | 0);
     label$6 : {
      if (!(HEAP32[($4 + 56 | 0) >> 2] | 0)) {
       break label$6
      }
      hashbrown__raw__RawTable_T_2cA___free_buckets__h0d3b2bc1ee0c4acb($4 + 56 | 0 | 0);
     }
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h3d696390b8f8d3c9($4 + 40 | 0 | 0, $2 | 0);
     label$7 : {
      if (!(HEAP32[($1 + 440 | 0) >> 2] | 0)) {
       break label$7
      }
      $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h3981a4152bf24dd0($1 + 444 | 0 | 0);
     }
     HEAP32[($1 + 440 | 0) >> 2] = 1;
     i64toi32_i32$2 = $4;
     i64toi32_i32$0 = HEAP32[($4 + 40 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($4 + 44 | 0) >> 2] | 0;
     $199 = i64toi32_i32$0;
     i64toi32_i32$0 = $1 + 444 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $199;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     $3 = $4 + 48 | 0;
     HEAP32[($1 + 452 | 0) >> 2] = HEAP32[$3 >> 2] | 0;
     alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($4 + 40 | 0 | 0, $6 | 0, $5 | 0);
     core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__NativeScripts____hdd7d461255ec800a_2($1 + 456 | 0 | 0);
     HEAP32[($1 + 464 | 0) >> 2] = HEAP32[$3 >> 2] | 0;
     i64toi32_i32$2 = $4;
     i64toi32_i32$1 = HEAP32[($4 + 40 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($4 + 44 | 0) >> 2] | 0;
     $218 = i64toi32_i32$1;
     i64toi32_i32$1 = $1;
     HEAP32[(i64toi32_i32$1 + 456 | 0) >> 2] = $218;
     HEAP32[(i64toi32_i32$1 + 460 | 0) >> 2] = i64toi32_i32$0;
     $3 = 0;
     break label$1;
    }
    $7 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1064056 | 0, 69 | 0) | 0;
   }
   $3 = 1;
   $7 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($7 | 0) | 0;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $7;
  HEAP32[$0 >> 2] = $3;
  global$0 = $4 + 176 | 0;
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hb198082190ccba71($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $14 = 0, $6 = 0, $13 = 0, $15 = 0, $4 = 0, $12 = 0, $5 = 0, $9 = 0, $10 = 0, $11 = 0, $16 = 0, $27 = 0, $28 = 0, $3 = 0, $7 = 0, $8 = 0, $116 = 0, $139 = 0, $142 = 0, $145 = 0, $148 = 0, $182 = 0, $204 = 0, $225 = 0;
  $2 = global$0 - 192 | 0;
  global$0 = $2;
  $3 = HEAP32[$1 >> 2] | 0;
  $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__hc51b1e7ac9e86799($2 + 8 | 0 | 0, $4 | 0, 0 | 0);
  $5 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  $6 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $6;
  HEAP32[$0 >> 2] = $5;
  label$1 : {
   if (!$6) {
    break label$1
   }
   $7 = Math_imul($4, 76);
   $8 = ($2 + 32 | 0) + 48 | 0;
   $9 = ($2 + 32 | 0) + 36 | 0;
   $10 = ($2 + 32 | 0) + 24 | 0;
   $11 = ($2 + 32 | 0) + 12 | 0;
   $12 = $2 + 189 | 0;
   $13 = 0;
   label$2 : while (1) {
    if (($7 | 0) == ($13 | 0)) {
     break label$1
    }
    label$3 : {
     label$4 : {
      $1 = $3 + $13 | 0;
      if (HEAP32[$1 >> 2] | 0) {
       break label$4
      }
      HEAP32[($2 + 96 | 0) >> 2] = 0;
      break label$3;
     }
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h26733a351c1d0f0b($2 + 96 | 0 | 0, $1 | 0);
    }
    label$5 : {
     label$6 : {
      $14 = HEAP32[($1 + 12 | 0) >> 2] | 0;
      if ($14) {
       break label$6
      }
      HEAP32[($2 + 112 | 0) >> 2] = 0;
      break label$5;
     }
     alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($2 + 112 | 0 | 0, $14 | 0, HEAP32[($1 + 20 | 0) >> 2] | 0 | 0);
    }
    label$7 : {
     label$8 : {
      $14 = $1 + 24 | 0;
      if (HEAP32[$14 >> 2] | 0) {
       break label$8
      }
      HEAP32[($2 + 128 | 0) >> 2] = 0;
      break label$7;
     }
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h09a8331f58cd0bf4($2 + 128 | 0 | 0, $14 | 0);
    }
    label$9 : {
     label$10 : {
      $14 = $1 + 36 | 0;
      if (HEAP32[$14 >> 2] | 0) {
       break label$10
      }
      HEAP32[($2 + 144 | 0) >> 2] = 0;
      break label$9;
     }
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hc722e22117ee5940($2 + 144 | 0 | 0, $14 | 0);
    }
    $14 = 3;
    label$11 : {
     $15 = $1 + 60 | 0;
     if ((HEAPU8[$15 >> 0] | 0 | 0) == (3 | 0)) {
      break label$11
     }
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hc831120dea694494($2 + 176 | 0 | 0, $1 + 48 | 0 | 0);
     HEAP32[(($2 + 160 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 176 | 0) + 8 | 0) >> 2] | 0;
     HEAP8[(($2 + 156 | 0) + 2 | 0) >> 0] = HEAPU8[($12 + 2 | 0) >> 0] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 176 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 180 | 0) >> 2] | 0;
     $116 = i64toi32_i32$0;
     i64toi32_i32$0 = $2;
     HEAP32[($2 + 160 | 0) >> 2] = $116;
     HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
     HEAP16[($2 + 156 | 0) >> 1] = HEAPU8[$12 >> 0] | 0 | ((HEAPU8[($12 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
     $14 = HEAPU8[$15 >> 0] | 0;
     $14 = ($14 | 0) == (2 | 0) ? 2 : ($14 | 0) != (0 | 0);
    }
    $6 = $6 + -1 | 0;
    label$12 : {
     label$13 : {
      $1 = $1 + 64 | 0;
      if (HEAP32[$1 >> 2] | 0) {
       break label$13
      }
      HEAP32[($2 + 176 | 0) >> 2] = 0;
      break label$12;
     }
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h1b9d2509f9812649($2 + 176 | 0 | 0, $1 | 0);
    }
    i64toi32_i32$1 = HEAP32[($2 + 112 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 116 | 0) >> 2] | 0;
    $139 = i64toi32_i32$1;
    i64toi32_i32$1 = $11;
    HEAP32[i64toi32_i32$1 >> 2] = $139;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = HEAP32[($2 + 128 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 132 | 0) >> 2] | 0;
    $142 = i64toi32_i32$0;
    i64toi32_i32$0 = $10;
    HEAP32[i64toi32_i32$0 >> 2] = $142;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = HEAP32[($2 + 144 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 148 | 0) >> 2] | 0;
    $145 = i64toi32_i32$1;
    i64toi32_i32$1 = $9;
    HEAP32[i64toi32_i32$1 >> 2] = $145;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = HEAP32[($2 + 160 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 164 | 0) >> 2] | 0;
    $148 = i64toi32_i32$0;
    i64toi32_i32$0 = $8;
    HEAP32[i64toi32_i32$0 >> 2] = $148;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 96 | 0) + 8 | 0) >> 2] | 0;
    HEAP32[($11 + 8 | 0) >> 2] = HEAP32[(($2 + 112 | 0) + 8 | 0) >> 2] | 0;
    HEAP32[($10 + 8 | 0) >> 2] = HEAP32[(($2 + 128 | 0) + 8 | 0) >> 2] | 0;
    HEAP32[($9 + 8 | 0) >> 2] = HEAP32[(($2 + 144 | 0) + 8 | 0) >> 2] | 0;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[(($2 + 160 | 0) + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 96 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 100 | 0) >> 2] | 0;
    $182 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 32 | 0) >> 2] = $182;
    HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$0;
    $15 = ($2 + 28 | 0) + 2 | 0;
    HEAP8[$15 >> 0] = HEAPU8[(($2 + 156 | 0) + 2 | 0) >> 0] | 0;
    $16 = ($2 + 16 | 0) + 8 | 0;
    HEAP32[$16 >> 2] = HEAP32[(($2 + 176 | 0) + 8 | 0) >> 2] | 0;
    HEAP16[($2 + 28 | 0) >> 1] = HEAPU16[($2 + 156 | 0) >> 1] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 176 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 180 | 0) >> 2] | 0;
    $204 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[($2 + 16 | 0) >> 2] = $204;
    HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$1;
    $1 = memcpy($5 + $13 | 0 | 0, $2 + 32 | 0 | 0, 60 | 0) | 0;
    HEAP8[($1 + 60 | 0) >> 0] = $14;
    $27 = $1 + 61 | 0;
    $28 = HEAPU16[($2 + 28 | 0) >> 1] | 0;
    HEAP8[$27 >> 0] = $28;
    HEAP8[($27 + 1 | 0) >> 0] = $28 >>> 8 | 0;
    HEAP8[($1 + 63 | 0) >> 0] = HEAPU8[$15 >> 0] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
    $225 = i64toi32_i32$1;
    i64toi32_i32$1 = $1 + 64 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $225;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($1 + 72 | 0) >> 2] = HEAP32[$16 >> 2] | 0;
    $13 = $13 + 76 | 0;
    if ($6) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 8 | 0) >> 2] = $4;
  global$0 = $2 + 192 | 0;
 }
 
 function core__fmt__num__parse_u64_into__hf2b8a89cb8a6b459($0, $0$hi, $1, $2) {
  $0 = $0 | 0;
  $0$hi = $0$hi | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$3 = 0, i64toi32_i32$5 = 0, $3 = 0, $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $5 = 0, i64toi32_i32$4 = 0, i64toi32_i32$1 = 0, $6 = 0, $8 = 0, i64toi32_i32$6 = 0, $7 = 0, $8$hi = 0, $9 = 0, $26 = 0, $27 = 0, $28 = 0, $30 = 0, $31 = 0, $32 = 0, $33 = 0, $34 = 0, $35 = 0, $36 = 0, $37 = 0, $38 = 0, $39 = 0, $40 = 0, $41 = 0, $42 = 0, $43 = 0, $44 = 0, $45 = 0, $46 = 0, $47 = 0, $48 = 0, $49 = 0, $50 = 0, $51 = 0, $52 = 0, $53 = 0, $54 = 0, $55 = 0, $56 = 0, $57 = 0, $58 = 0, $59 = 0, $60 = 0, $61 = 0, $62 = 0, $63 = 0, $64 = 0, $65 = 0, $66 = 0, $67 = 0, $68 = 0, $69 = 0, $70 = 0, $71 = 0, $29 = 0, $29$hi = 0, $9$hi = 0, $72 = 0, $73 = 0, $98 = 0, $98$hi = 0, $118 = 0, $118$hi = 0;
  label$1 : {
   $3 = HEAP32[$2 >> 2] | 0;
   if (($3 | 0) < (20 | 0)) {
    break label$1
   }
   label$2 : {
    label$3 : {
     label$4 : {
      i64toi32_i32$0 = $0$hi;
      i64toi32_i32$0 = $0$hi;
      i64toi32_i32$2 = $0;
      i64toi32_i32$1 = 2328306;
      i64toi32_i32$3 = 1874919423;
      if ($0$hi >>> 0 < i64toi32_i32$1 >>> 0 | (($0$hi | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$2 >>> 0 <= i64toi32_i32$3 >>> 0 | 0) | 0) {
       break label$4
      }
      $4 = $3 + -16 | 0;
      HEAP32[$2 >> 2] = $4;
      $5 = $3 + $1 | 0;
      i64toi32_i32$2 = $0$hi;
      i64toi32_i32$2 = $0$hi;
      i64toi32_i32$2 = $0$hi;
      i64toi32_i32$0 = 2328306;
      i64toi32_i32$0 = __wasm_i64_udiv($0 | 0, $0$hi | 0, 1874919424 | 0, i64toi32_i32$0 | 0) | 0;
      i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
      $8 = i64toi32_i32$0;
      $8$hi = i64toi32_i32$2;
      i64toi32_i32$0 = 2328306;
      i64toi32_i32$0 = __wasm_i64_mul($8 | 0, i64toi32_i32$2 | 0, 1874919424 | 0, i64toi32_i32$0 | 0) | 0;
      i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
      $29 = i64toi32_i32$0;
      $29$hi = i64toi32_i32$2;
      i64toi32_i32$2 = $0$hi;
      i64toi32_i32$3 = $0;
      i64toi32_i32$0 = $29$hi;
      i64toi32_i32$1 = $29;
      i64toi32_i32$4 = i64toi32_i32$3 - i64toi32_i32$1 | 0;
      i64toi32_i32$6 = i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0;
      i64toi32_i32$5 = i64toi32_i32$6 + i64toi32_i32$0 | 0;
      i64toi32_i32$5 = $0$hi - i64toi32_i32$5 | 0;
      $0 = i64toi32_i32$4;
      $0$hi = i64toi32_i32$5;
      i64toi32_i32$3 = 0;
      i64toi32_i32$3 = __wasm_i64_udiv($0 | 0, i64toi32_i32$5 | 0, 100 | 0, i64toi32_i32$3 | 0) | 0;
      i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
      $9 = i64toi32_i32$3;
      $9$hi = i64toi32_i32$5;
      i64toi32_i32$3 = 0;
      i64toi32_i32$3 = __wasm_i64_urem($9 | 0, i64toi32_i32$5 | 0, 100 | 0, i64toi32_i32$3 | 0) | 0;
      i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
      $26 = (i64toi32_i32$3 << 1 | 0) + 1150184 | 0;
      $27 = $5 + -4 | 0;
      $28 = HEAPU8[$26 >> 0] | 0 | ((HEAPU8[($26 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
      HEAP8[$27 >> 0] = $28;
      HEAP8[($27 + 1 | 0) >> 0] = $28 >>> 8 | 0;
      i64toi32_i32$5 = $0$hi;
      i64toi32_i32$3 = 0;
      i64toi32_i32$3 = __wasm_i64_udiv($0 | 0, i64toi32_i32$5 | 0, 1e4 | 0, i64toi32_i32$3 | 0) | 0;
      i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
      $72 = i64toi32_i32$3;
      i64toi32_i32$3 = 0;
      i64toi32_i32$3 = __wasm_i64_urem($72 | 0, i64toi32_i32$5 | 0, 100 | 0, i64toi32_i32$3 | 0) | 0;
      i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
      $30 = (i64toi32_i32$3 << 1 | 0) + 1150184 | 0;
      $31 = $5 + -6 | 0;
      $32 = HEAPU8[$30 >> 0] | 0 | ((HEAPU8[($30 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
      HEAP8[$31 >> 0] = $32;
      HEAP8[($31 + 1 | 0) >> 0] = $32 >>> 8 | 0;
      i64toi32_i32$5 = $0$hi;
      i64toi32_i32$3 = 0;
      i64toi32_i32$3 = __wasm_i64_udiv($0 | 0, i64toi32_i32$5 | 0, 1e6 | 0, i64toi32_i32$3 | 0) | 0;
      i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
      $73 = i64toi32_i32$3;
      i64toi32_i32$3 = 0;
      i64toi32_i32$3 = __wasm_i64_urem($73 | 0, i64toi32_i32$5 | 0, 100 | 0, i64toi32_i32$3 | 0) | 0;
      i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
      $33 = (i64toi32_i32$3 << 1 | 0) + 1150184 | 0;
      $34 = $5 + -8 | 0;
      $35 = HEAPU8[$33 >> 0] | 0 | ((HEAPU8[($33 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
      HEAP8[$34 >> 0] = $35;
      HEAP8[($34 + 1 | 0) >> 0] = $35 >>> 8 | 0;
      i64toi32_i32$5 = $0$hi;
      i64toi32_i32$3 = 0;
      i64toi32_i32$3 = __wasm_i64_udiv($0 | 0, i64toi32_i32$5 | 0, 1e8 | 0, i64toi32_i32$3 | 0) | 0;
      i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
      $36 = (((i64toi32_i32$3 >>> 0) % (100 >>> 0) | 0) << 1 | 0) + 1150184 | 0;
      $37 = $5 + -10 | 0;
      $38 = HEAPU8[$36 >> 0] | 0 | ((HEAPU8[($36 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
      HEAP8[$37 >> 0] = $38;
      HEAP8[($37 + 1 | 0) >> 0] = $38 >>> 8 | 0;
      i64toi32_i32$5 = $0$hi;
      i64toi32_i32$3 = 2;
      i64toi32_i32$3 = __wasm_i64_udiv($0 | 0, i64toi32_i32$5 | 0, 1410065408 | 0, i64toi32_i32$3 | 0) | 0;
      i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
      $39 = (((i64toi32_i32$3 >>> 0) % (100 >>> 0) | 0) << 1 | 0) + 1150184 | 0;
      $40 = $5 + -12 | 0;
      $41 = HEAPU8[$39 >> 0] | 0 | ((HEAPU8[($39 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
      HEAP8[$40 >> 0] = $41;
      HEAP8[($40 + 1 | 0) >> 0] = $41 >>> 8 | 0;
      i64toi32_i32$5 = $0$hi;
      i64toi32_i32$3 = 232;
      i64toi32_i32$3 = __wasm_i64_udiv($0 | 0, i64toi32_i32$5 | 0, -727379968 | 0, i64toi32_i32$3 | 0) | 0;
      i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
      $42 = ((((i64toi32_i32$3 & 65535 | 0) >>> 0) % (100 >>> 0) | 0) << 1 | 0) + 1150184 | 0;
      $43 = $5 + -14 | 0;
      $44 = HEAPU8[$42 >> 0] | 0 | ((HEAPU8[($42 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
      HEAP8[$43 >> 0] = $44;
      HEAP8[($43 + 1 | 0) >> 0] = $44 >>> 8 | 0;
      i64toi32_i32$5 = $0$hi;
      i64toi32_i32$3 = 23283;
      i64toi32_i32$3 = __wasm_i64_udiv($0 | 0, i64toi32_i32$5 | 0, 276447232 | 0, i64toi32_i32$3 | 0) | 0;
      i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
      $45 = ((((i64toi32_i32$3 & 255 | 0) >>> 0) % (100 >>> 0) | 0) << 1 | 0) + 1150184 | 0;
      $46 = $1 + $4 | 0;
      $47 = HEAPU8[$45 >> 0] | 0 | ((HEAPU8[($45 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
      HEAP8[$46 >> 0] = $47;
      HEAP8[($46 + 1 | 0) >> 0] = $47 >>> 8 | 0;
      i64toi32_i32$5 = $0$hi;
      i64toi32_i32$5 = $9$hi;
      i64toi32_i32$3 = 0;
      i64toi32_i32$3 = __wasm_i64_mul($9 | 0, i64toi32_i32$5 | 0, 100 | 0, i64toi32_i32$3 | 0) | 0;
      i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
      $98 = i64toi32_i32$3;
      $98$hi = i64toi32_i32$5;
      i64toi32_i32$5 = $0$hi;
      i64toi32_i32$2 = $0;
      i64toi32_i32$3 = $98$hi;
      i64toi32_i32$1 = $98;
      i64toi32_i32$0 = $0 - i64toi32_i32$1 | 0;
      i64toi32_i32$6 = $0 >>> 0 < i64toi32_i32$1 >>> 0;
      i64toi32_i32$4 = i64toi32_i32$6 + i64toi32_i32$3 | 0;
      i64toi32_i32$4 = i64toi32_i32$5 - i64toi32_i32$4 | 0;
      $5 = i64toi32_i32$0;
      break label$3;
     }
     label$5 : {
      i64toi32_i32$4 = $0$hi;
      i64toi32_i32$4 = $0$hi;
      i64toi32_i32$5 = $0;
      i64toi32_i32$2 = 0;
      i64toi32_i32$1 = 1e8;
      if ($0$hi >>> 0 > i64toi32_i32$2 >>> 0 | (($0$hi | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$5 >>> 0 >= i64toi32_i32$1 >>> 0 | 0) | 0) {
       break label$5
      }
      $4 = $3;
      i64toi32_i32$5 = $0$hi;
      $8 = $0;
      $8$hi = i64toi32_i32$5;
      break label$2;
     }
     $4 = $3 + -8 | 0;
     HEAP32[$2 >> 2] = $4;
     $6 = $3 + $1 | 0;
     i64toi32_i32$5 = $0$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_i64_udiv($0 | 0, i64toi32_i32$5 | 0, 1e8 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $8 = i64toi32_i32$4;
     $8$hi = i64toi32_i32$5;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_i64_mul($8 | 0, i64toi32_i32$5 | 0, 1e8 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
     $118 = i64toi32_i32$4;
     $118$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $0$hi;
     i64toi32_i32$1 = $0;
     i64toi32_i32$4 = $118$hi;
     i64toi32_i32$2 = $118;
     i64toi32_i32$3 = $0 - i64toi32_i32$2 | 0;
     i64toi32_i32$6 = $0 >>> 0 < i64toi32_i32$2 >>> 0;
     i64toi32_i32$0 = i64toi32_i32$6 + i64toi32_i32$4 | 0;
     i64toi32_i32$0 = i64toi32_i32$5 - i64toi32_i32$0 | 0;
     $5 = i64toi32_i32$3;
     $7 = (i64toi32_i32$3 >>> 0) / (100 >>> 0) | 0;
     $48 = ((($7 >>> 0) % (100 >>> 0) | 0) << 1 | 0) + 1150184 | 0;
     $49 = $6 + -4 | 0;
     $50 = HEAPU8[$48 >> 0] | 0 | ((HEAPU8[($48 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
     HEAP8[$49 >> 0] = $50;
     HEAP8[($49 + 1 | 0) >> 0] = $50 >>> 8 | 0;
     $51 = ((((((i64toi32_i32$3 >>> 0) / (1e4 >>> 0) | 0) & 65535 | 0) >>> 0) % (100 >>> 0) | 0) << 1 | 0) + 1150184 | 0;
     $52 = $6 + -6 | 0;
     $53 = HEAPU8[$51 >> 0] | 0 | ((HEAPU8[($51 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
     HEAP8[$52 >> 0] = $53;
     HEAP8[($52 + 1 | 0) >> 0] = $53 >>> 8 | 0;
     $54 = ((((((i64toi32_i32$3 >>> 0) / (1e6 >>> 0) | 0) & 255 | 0) >>> 0) % (100 >>> 0) | 0) << 1 | 0) + 1150184 | 0;
     $55 = $1 + $4 | 0;
     $56 = HEAPU8[$54 >> 0] | 0 | ((HEAPU8[($54 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
     HEAP8[$55 >> 0] = $56;
     HEAP8[($55 + 1 | 0) >> 0] = $56 >>> 8 | 0;
     $5 = i64toi32_i32$3 - Math_imul($7, 100) | 0;
    }
    $57 = ($5 << 1 | 0) + 1150184 | 0;
    $58 = ($3 + $1 | 0) + -2 | 0;
    $59 = HEAPU8[$57 >> 0] | 0 | ((HEAPU8[($57 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
    HEAP8[$58 >> 0] = $59;
    HEAP8[($58 + 1 | 0) >> 0] = $59 >>> 8 | 0;
   }
   label$6 : {
    label$7 : {
     i64toi32_i32$0 = $8$hi;
     $6 = $8;
     if ($6 >>> 0 >= 1e4 >>> 0) {
      break label$7
     }
     $3 = $4;
     $5 = $6;
     break label$6;
    }
    $3 = $4 + -4 | 0;
    $5 = ($6 >>> 0) / (1e4 >>> 0) | 0;
    $6 = $6 - Math_imul($5, 1e4) | 0;
    $7 = (($6 & 65535 | 0) >>> 0) / (100 >>> 0) | 0;
    $60 = ($7 << 1 | 0) + 1150184 | 0;
    $61 = $1 + $3 | 0;
    $62 = HEAPU8[$60 >> 0] | 0 | ((HEAPU8[($60 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
    HEAP8[$61 >> 0] = $62;
    HEAP8[($61 + 1 | 0) >> 0] = $62 >>> 8 | 0;
    $63 = ((($6 - Math_imul($7, 100) | 0) & 65535 | 0) << 1 | 0) + 1150184 | 0;
    $64 = ($4 + $1 | 0) + -2 | 0;
    $65 = HEAPU8[$63 >> 0] | 0 | ((HEAPU8[($63 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
    HEAP8[$64 >> 0] = $65;
    HEAP8[($64 + 1 | 0) >> 0] = $65 >>> 8 | 0;
   }
   label$8 : {
    label$9 : {
     $4 = $5 & 65535 | 0;
     if ($4 >>> 0 >= 100 >>> 0) {
      break label$9
     }
     $4 = $5;
     break label$8;
    }
    $3 = $3 + -2 | 0;
    $4 = ($4 >>> 0) / (100 >>> 0) | 0;
    $66 = ((($5 - Math_imul($4, 100) | 0) & 65535 | 0) << 1 | 0) + 1150184 | 0;
    $67 = $1 + $3 | 0;
    $68 = HEAPU8[$66 >> 0] | 0 | ((HEAPU8[($66 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
    HEAP8[$67 >> 0] = $68;
    HEAP8[($67 + 1 | 0) >> 0] = $68 >>> 8 | 0;
   }
   label$10 : {
    if (($4 & 65535 | 0) >>> 0 < 10 >>> 0) {
     break label$10
    }
    $3 = $3 + -2 | 0;
    HEAP32[$2 >> 2] = $3;
    $69 = (($4 & 65535 | 0) << 1 | 0) + 1150184 | 0;
    $70 = $1 + $3 | 0;
    $71 = HEAPU8[$69 >> 0] | 0 | ((HEAPU8[($69 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
    HEAP8[$70 >> 0] = $71;
    HEAP8[($70 + 1 | 0) >> 0] = $71 >>> 8 | 0;
    return;
   }
   $3 = $3 + -1 | 0;
   HEAP32[$2 >> 2] = $3;
   HEAP8[($1 + $3 | 0) >> 0] = $4 + 48 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1150384 | 0, 28 | 0, 1150412 | 0);
  abort();
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__SingleHostName___deserialize__h69e60f7aa4500347($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $4 = 0, $4$hi = 0, $5 = 0, $3 = 0, $5$hi = 0, $33 = 0, $34 = 0, $35 = 0, $36 = 0, $37 = 0, $38 = 0, $39 = 0, $41 = 0, $42 = 0, $43 = 0, $40 = 0, $46 = 0, $64 = 0, $68 = 0, $116 = 0, $116$hi = 0, $119 = 0, $119$hi = 0, $123$hi = 0, $125$hi = 0, $127$hi = 0, $130 = 0, $130$hi = 0, $158 = 0, $164 = 0, $168 = 0, $184 = 0, $188 = 0, $194 = 0, $200 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 32 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 40 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 44 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      i64toi32_i32$2 = $2;
      i64toi32_i32$1 = HEAP32[($2 + 32 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($2 + 36 | 0) >> 2] | 0;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 1;
      if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
       break label$4
      }
      i64toi32_i32$2 = $4$hi;
      i64toi32_i32$0 = i64toi32_i32$2;
      cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__SingleHostName___deserialize_as_embedded_group__h8d6b3aa19718808b($2 + 32 | 0 | 0, $1 | 0, $4 | 0, i64toi32_i32$0 | 0, $4 | 0, i64toi32_i32$0 | 0);
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          i64toi32_i32$3 = $4;
          i64toi32_i32$2 = 0;
          i64toi32_i32$1 = 1;
          if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) | 0) {
           break label$8
          }
          cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 128 | 0 | 0, $1 | 0);
          $3 = HEAPU8[($2 + 136 | 0) >> 0] | 0;
          i64toi32_i32$1 = $2;
          i64toi32_i32$3 = HEAP32[($2 + 128 | 0) >> 2] | 0;
          i64toi32_i32$0 = HEAP32[($2 + 132 | 0) >> 2] | 0;
          i64toi32_i32$1 = i64toi32_i32$3;
          i64toi32_i32$3 = 0;
          i64toi32_i32$2 = 1;
          if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) | 0) {
           break label$7
          }
          $1 = 5;
          if (($3 & 255 | 0 | 0) != (5 | 0)) {
           break label$6
          }
         }
         i64toi32_i32$2 = $2 + 72 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $40 = i64toi32_i32$1;
         i64toi32_i32$1 = ($2 + 8 | 0) + 8 | 0;
         HEAP32[i64toi32_i32$1 >> 2] = $40;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$2 = $2 + 80 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $46 = i64toi32_i32$0;
         i64toi32_i32$0 = ($2 + 8 | 0) + 16 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $46;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         HEAP32[(($2 + 128 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 100 | 0) >> 2] | 0;
         HEAP32[($2 + 104 | 0) >> 2] = HEAPU8[($2 + 41 | 0) >> 0] | 0 | ((HEAPU8[($2 + 42 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 43 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 44 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $33 = ($2 + 32 | 0) + 12 | 0;
         $34 = HEAPU8[$33 >> 0] | 0 | ((HEAPU8[($33 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($33 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($33 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[($2 + 107 | 0) >> 0] = $34;
         HEAP8[($2 + 108 | 0) >> 0] = $34 >>> 8 | 0;
         HEAP8[($2 + 109 | 0) >> 0] = $34 >>> 16 | 0;
         HEAP8[($2 + 110 | 0) >> 0] = $34 >>> 24 | 0;
         i64toi32_i32$2 = $2 + 64 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $64 = i64toi32_i32$1;
         i64toi32_i32$1 = $2;
         HEAP32[($2 + 8 | 0) >> 2] = $64;
         HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$2 = $2 + 92 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $68 = i64toi32_i32$0;
         i64toi32_i32$0 = $2;
         HEAP32[($2 + 128 | 0) >> 2] = $68;
         HEAP32[($2 + 132 | 0) >> 2] = i64toi32_i32$1;
         $1 = HEAPU8[(($2 + 32 | 0) + 8 | 0) >> 0] | 0;
         i64toi32_i32$2 = ($2 + 32 | 0) + 16 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $4 = i64toi32_i32$1;
         $4$hi = i64toi32_i32$0;
         if ((HEAP32[($2 + 32 | 0) >> 2] | 0 | 0) != (1 | 0)) {
          break label$5
         }
         i64toi32_i32$2 = $2 + 56 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $5 = i64toi32_i32$0;
         $5$hi = i64toi32_i32$1;
         $3 = HEAP32[($2 + 88 | 0) >> 2] | 0;
         break label$2;
        }
        i64toi32_i32$2 = $2 + 160 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $4 = i64toi32_i32$1;
        $4$hi = i64toi32_i32$0;
        i64toi32_i32$1 = ($2 + 104 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $4;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = $2 + 168 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $5 = i64toi32_i32$0;
        $5$hi = i64toi32_i32$1;
        i64toi32_i32$0 = ($2 + 104 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $5;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$1 = $4$hi;
        i64toi32_i32$0 = ($2 + 8 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $4;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$1 = $5$hi;
        i64toi32_i32$0 = ($2 + 8 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $5;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$2 = $2 + 152 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $4 = i64toi32_i32$1;
        $4$hi = i64toi32_i32$0;
        i64toi32_i32$1 = $2;
        HEAP32[($2 + 104 | 0) >> 2] = $4;
        HEAP32[($2 + 108 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$1 = $2;
        HEAP32[($2 + 8 | 0) >> 2] = $4;
        HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAPU8[($2 + 137 | 0) >> 0] | 0 | ((HEAPU8[($2 + 138 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 139 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 140 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$1 = 0;
        $116 = i64toi32_i32$0;
        $116$hi = i64toi32_i32$1;
        i64toi32_i32$2 = $2 + 141 | 0;
        i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
        i64toi32_i32$0 = 0;
        $119 = i64toi32_i32$1;
        $119$hi = i64toi32_i32$0;
        i64toi32_i32$2 = $2 + 143 | 0;
        i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
        i64toi32_i32$1 = 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 16;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
         $41 = 0;
        } else {
         i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
         $41 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        }
        $123$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $119$hi;
        i64toi32_i32$1 = $119;
        i64toi32_i32$2 = $123$hi;
        i64toi32_i32$3 = $41;
        i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
        i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 32;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
         $42 = 0;
        } else {
         i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
         $42 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        }
        $125$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $116$hi;
        i64toi32_i32$2 = $116;
        i64toi32_i32$0 = $125$hi;
        i64toi32_i32$3 = $42;
        i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
        i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
        i64toi32_i32$2 = 0;
        i64toi32_i32$3 = 8;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
         $43 = 0;
        } else {
         i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
         $43 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        }
        $127$hi = i64toi32_i32$2;
        i64toi32_i32$2 = 0;
        i64toi32_i32$0 = $3;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 255;
        i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
        $130 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
        $130$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $127$hi;
        i64toi32_i32$2 = $43;
        i64toi32_i32$0 = $130$hi;
        i64toi32_i32$3 = $130;
        i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
        $4 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
        $4$hi = i64toi32_i32$0;
        i64toi32_i32$1 = ($2 + 128 | 0) + 16 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
        $5 = i64toi32_i32$0;
        $5$hi = i64toi32_i32$2;
        $1 = 2;
       }
       core__ptr__drop_in_place_core__result__Result_cardano_serialization_lib__SingleHostName_2ccardano_serialization_lib__error__DeserializeError____hacb89d209b69983b($2 + 32 | 0 | 0);
       break label$3;
      }
      HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($2 + 36 | 0) >> 2] | 0;
      $35 = HEAP32[($2 + 104 | 0) >> 2] | 0;
      HEAP8[($0 + 9 | 0) >> 0] = $35;
      HEAP8[($0 + 10 | 0) >> 0] = $35 >>> 8 | 0;
      HEAP8[($0 + 11 | 0) >> 0] = $35 >>> 16 | 0;
      HEAP8[($0 + 12 | 0) >> 0] = $35 >>> 24 | 0;
      HEAP8[($0 + 8 | 0) >> 0] = $1;
      $36 = $0 + 12 | 0;
      $37 = HEAPU8[($2 + 107 | 0) >> 0] | 0 | ((HEAPU8[($2 + 108 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 109 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 110 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[$36 >> 0] = $37;
      HEAP8[($36 + 1 | 0) >> 0] = $37 >>> 8 | 0;
      HEAP8[($36 + 2 | 0) >> 0] = $37 >>> 16 | 0;
      HEAP8[($36 + 3 | 0) >> 0] = $37 >>> 24 | 0;
      i64toi32_i32$2 = $4$hi;
      HEAP32[($0 + 16 | 0) >> 2] = $4;
      $1 = 0;
      break label$1;
     }
     i64toi32_i32$1 = $2 + 64 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $158 = i64toi32_i32$2;
     i64toi32_i32$2 = $2 + 16 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $158;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$1 = $2 + 72 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $164 = i64toi32_i32$0;
     i64toi32_i32$0 = ($2 + 8 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $164;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$1 = $2 + 56 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $168 = i64toi32_i32$2;
     i64toi32_i32$2 = $2;
     HEAP32[($2 + 8 | 0) >> 2] = $168;
     HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$1 = ($2 + 32 | 0) + 16 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $5 = i64toi32_i32$0;
     $5$hi = i64toi32_i32$2;
     $1 = 2;
    }
    $3 = 0;
   }
   i64toi32_i32$2 = $5$hi;
   i64toi32_i32$0 = ($2 + 32 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $5;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$2 = $4$hi;
   i64toi32_i32$0 = ($2 + 32 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $4;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$1 = $2;
   i64toi32_i32$2 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $184 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 56 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $184;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$1 = $2;
   i64toi32_i32$0 = HEAP32[($2 + 128 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($2 + 132 | 0) >> 2] | 0;
   $188 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 84 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $188;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$1 = ($2 + 8 | 0) + 8 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $194 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 64 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $194;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$1 = ($2 + 8 | 0) + 16 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $200 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 72 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $200;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   HEAP32[($2 + 92 | 0) >> 2] = HEAP32[(($2 + 128 | 0) + 8 | 0) >> 2] | 0;
   HEAP8[($2 + 32 | 0) >> 0] = $1;
   $38 = HEAP32[($2 + 104 | 0) >> 2] | 0;
   HEAP8[($2 + 33 | 0) >> 0] = $38;
   HEAP8[($2 + 34 | 0) >> 0] = $38 >>> 8 | 0;
   HEAP8[($2 + 35 | 0) >> 0] = $38 >>> 16 | 0;
   HEAP8[($2 + 36 | 0) >> 0] = $38 >>> 24 | 0;
   $39 = HEAPU8[($2 + 107 | 0) >> 0] | 0 | ((HEAPU8[($2 + 108 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 109 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 110 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[($2 + 36 | 0) >> 0] = $39;
   HEAP8[($2 + 37 | 0) >> 0] = $39 >>> 8 | 0;
   HEAP8[($2 + 38 | 0) >> 0] = $39 >>> 16 | 0;
   HEAP8[($2 + 39 | 0) >> 0] = $39 >>> 24 | 0;
   HEAP32[($2 + 80 | 0) >> 2] = $3;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 32 | 0 | 0, 1051434 | 0, 14 | 0);
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__ScriptAll___deserialize__h05fd39627d4fe528($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $5 = 0, $5$hi = 0, $4$hi = 0, $6$hi = 0, $3 = 0, $4 = 0, $6 = 0, $7 = 0, $7$hi = 0, $34 = 0, $35 = 0, $36 = 0, $37 = 0, $38 = 0, $39 = 0, $40 = 0, $41 = 0, $42 = 0, $43 = 0, $67 = 0, $67$hi = 0, $70 = 0, $70$hi = 0, $74$hi = 0, $76$hi = 0, $78$hi = 0, $81 = 0, $81$hi = 0, $93 = 0, $97 = 0, $110 = 0, $128 = 0, $132 = 0, $178 = 0, $182 = 0, $188 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 24 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2 + 40 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
  $5 = i64toi32_i32$1;
  $5$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
       i64toi32_i32$2 = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 1;
       if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
        break label$5
       }
       i64toi32_i32$2 = 0;
       $6 = 0;
       $6$hi = i64toi32_i32$2;
       label$6 : {
        i64toi32_i32$2 = $5$hi;
        i64toi32_i32$3 = $5;
        i64toi32_i32$1 = 0;
        i64toi32_i32$0 = 1;
        if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
         break label$6
        }
        i64toi32_i32$3 = 0;
        $6 = 2;
        $6$hi = i64toi32_i32$3;
        i64toi32_i32$3 = $4$hi;
        i64toi32_i32$0 = $4;
        i64toi32_i32$2 = 0;
        i64toi32_i32$1 = 2;
        if (i64toi32_i32$3 >>> 0 > i64toi32_i32$2 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$0 >>> 0 >= i64toi32_i32$1 >>> 0 | 0) | 0) {
         break label$6
        }
        $1 = 3;
        $3 = 0;
        i64toi32_i32$0 = 0;
        $7 = 0;
        $7$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $4$hi;
        $5 = $4;
        $5$hi = i64toi32_i32$0;
        break label$2;
       }
       i64toi32_i32$0 = $5$hi;
       i64toi32_i32$3 = i64toi32_i32$0;
       cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__ScriptAll___deserialize_as_embedded_group__hbafeb78d3b233e94($2 + 24 | 0 | 0, $1 | 0, $5 | 0, i64toi32_i32$0 | 0, $5 | 0, i64toi32_i32$0 | 0);
       i64toi32_i32$3 = 0;
       $7 = 1;
       $7$hi = i64toi32_i32$3;
       label$7 : {
        label$8 : {
         i64toi32_i32$3 = i64toi32_i32$0;
         i64toi32_i32$3 = i64toi32_i32$0;
         i64toi32_i32$1 = $5;
         i64toi32_i32$0 = 0;
         i64toi32_i32$2 = 1;
         if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) | 0) {
          break label$8
         }
         cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 112 | 0 | 0, $1 | 0);
         $3 = HEAPU8[($2 + 120 | 0) >> 0] | 0;
         i64toi32_i32$2 = $2;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 112 | 0) >> 2] | 0;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 116 | 0) >> 2] | 0;
         i64toi32_i32$2 = i64toi32_i32$1;
         i64toi32_i32$1 = 0;
         i64toi32_i32$0 = 1;
         if ((i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) | 0) {
          break label$7
         }
         $1 = 5;
         if (($3 & 255 | 0 | 0) != (5 | 0)) {
          break label$4
         }
         break label$3;
        }
        $1 = 3;
        i64toi32_i32$2 = $6$hi;
        i64toi32_i32$2 = $4$hi;
        i64toi32_i32$2 = $6$hi;
        i64toi32_i32$0 = $6;
        i64toi32_i32$3 = $4$hi;
        i64toi32_i32$1 = $4;
        if ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) | 0) {
         break label$3
        }
        break label$4;
       }
       i64toi32_i32$1 = $2 + 152 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $5 = i64toi32_i32$0;
       $5$hi = i64toi32_i32$2;
       i64toi32_i32$0 = ($2 + 96 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $5;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$0 = ($2 + 8 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $5;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$1 = $2 + 144 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $5 = i64toi32_i32$2;
       $5$hi = i64toi32_i32$0;
       i64toi32_i32$2 = $2;
       HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] = $5;
       HEAP32[(i64toi32_i32$2 + 100 | 0) >> 2] = i64toi32_i32$0;
       HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $5;
       HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$1 = i64toi32_i32$2;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 121 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 122 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 123 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 124 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = 0;
       $67 = i64toi32_i32$0;
       $67$hi = i64toi32_i32$2;
       i64toi32_i32$1 = i64toi32_i32$1 + 125 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
       i64toi32_i32$0 = 0;
       $70 = i64toi32_i32$2;
       $70$hi = i64toi32_i32$0;
       i64toi32_i32$1 = $2 + 127 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
       i64toi32_i32$2 = 0;
       i64toi32_i32$1 = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        $41 = 0;
       } else {
        i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
        $41 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       }
       $74$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $70$hi;
       i64toi32_i32$2 = $70;
       i64toi32_i32$1 = $74$hi;
       i64toi32_i32$3 = $41;
       i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $42 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $42 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       $76$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $67$hi;
       i64toi32_i32$1 = $67;
       i64toi32_i32$0 = $76$hi;
       i64toi32_i32$3 = $42;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 8;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $43 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
        $43 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       $78$hi = i64toi32_i32$1;
       i64toi32_i32$1 = 0;
       i64toi32_i32$0 = $3;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 255;
       i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
       $81 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
       $81$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $78$hi;
       i64toi32_i32$1 = $43;
       i64toi32_i32$0 = $81$hi;
       i64toi32_i32$3 = $81;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
       $4 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       $4$hi = i64toi32_i32$0;
       i64toi32_i32$2 = $2 + 136 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $6 = i64toi32_i32$0;
       $6$hi = i64toi32_i32$1;
       i64toi32_i32$2 = $2 + 128 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $7 = i64toi32_i32$1;
       $7$hi = i64toi32_i32$0;
       $1 = 2;
       break label$4;
      }
      i64toi32_i32$2 = $2 + 64 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $93 = i64toi32_i32$0;
      i64toi32_i32$0 = $2 + 16 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $93;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $2 + 56 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $97 = i64toi32_i32$1;
      i64toi32_i32$1 = $2;
      HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $97;
      HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = i64toi32_i32$1 + 48 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $6 = i64toi32_i32$0;
      $6$hi = i64toi32_i32$1;
      $1 = 2;
      $3 = 0;
      i64toi32_i32$1 = $4$hi;
      $7 = $4;
      $7$hi = i64toi32_i32$1;
      break label$2;
     }
     core__ptr__drop_in_place_core__result__Result_cardano_serialization_lib__ScriptAll_2ccardano_serialization_lib__error__DeserializeError____hbd880b968031b052($2 + 24 | 0 | 0);
     $3 = 0;
     i64toi32_i32$1 = $4$hi;
     $5 = $4;
     $5$hi = i64toi32_i32$1;
     break label$2;
    }
    i64toi32_i32$2 = $2 + 72 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $110 = i64toi32_i32$1;
    i64toi32_i32$1 = ($2 + 8 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $110;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[(($2 + 112 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 92 | 0) >> 2] | 0;
    HEAP32[($2 + 96 | 0) >> 2] = HEAPU8[($2 + 33 | 0) >> 0] | 0 | ((HEAPU8[($2 + 34 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 35 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 36 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $34 = ($2 + 24 | 0) + 12 | 0;
    $35 = HEAPU8[$34 >> 0] | 0 | ((HEAPU8[($34 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($34 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($34 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    HEAP8[($2 + 99 | 0) >> 0] = $35;
    HEAP8[($2 + 100 | 0) >> 0] = $35 >>> 8 | 0;
    HEAP8[($2 + 101 | 0) >> 0] = $35 >>> 16 | 0;
    HEAP8[($2 + 102 | 0) >> 0] = $35 >>> 24 | 0;
    i64toi32_i32$2 = $2 + 64 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $128 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $128;
    HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = i64toi32_i32$0 + 84 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $132 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[(i64toi32_i32$1 + 112 | 0) >> 2] = $132;
    HEAP32[(i64toi32_i32$1 + 116 | 0) >> 2] = i64toi32_i32$0;
    $1 = HEAPU8[((i64toi32_i32$1 + 24 | 0) + 8 | 0) >> 0] | 0;
    label$9 : {
     if ((HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
      break label$9
     }
     i64toi32_i32$2 = $2 + 40 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $5 = i64toi32_i32$0;
     $5$hi = i64toi32_i32$1;
     i64toi32_i32$2 = $2 + 48 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $7 = i64toi32_i32$1;
     $7$hi = i64toi32_i32$0;
     i64toi32_i32$2 = $2 + 56 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $6 = i64toi32_i32$0;
     $6$hi = i64toi32_i32$1;
     $3 = HEAP32[($2 + 80 | 0) >> 2] | 0;
     break label$2;
    }
    HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
    $36 = HEAP32[($2 + 96 | 0) >> 2] | 0;
    HEAP8[($0 + 9 | 0) >> 0] = $36;
    HEAP8[($0 + 10 | 0) >> 0] = $36 >>> 8 | 0;
    HEAP8[($0 + 11 | 0) >> 0] = $36 >>> 16 | 0;
    HEAP8[($0 + 12 | 0) >> 0] = $36 >>> 24 | 0;
    HEAP8[($0 + 8 | 0) >> 0] = $1;
    $37 = $0 + 12 | 0;
    $38 = HEAPU8[($2 + 99 | 0) >> 0] | 0 | ((HEAPU8[($2 + 100 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 101 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 102 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    HEAP8[$37 >> 0] = $38;
    HEAP8[($37 + 1 | 0) >> 0] = $38 >>> 8 | 0;
    HEAP8[($37 + 2 | 0) >> 0] = $38 >>> 16 | 0;
    HEAP8[($37 + 3 | 0) >> 0] = $38 >>> 24 | 0;
    $1 = 0;
    break label$1;
   }
   i64toi32_i32$1 = $6$hi;
   i64toi32_i32$0 = $2 + 48 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $6;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $7$hi;
   i64toi32_i32$0 = $2 + 40 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $7;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $5$hi;
   i64toi32_i32$0 = ($2 + 24 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $5;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
   $178 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2 + 56 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $178;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 112 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 116 | 0) >> 2] | 0;
   $182 = i64toi32_i32$0;
   i64toi32_i32$0 = i64toi32_i32$2 + 76 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $182;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = (i64toi32_i32$2 + 8 | 0) + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $188 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 64 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $188;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($2 + 84 | 0) >> 2] = HEAP32[(($2 + 112 | 0) + 8 | 0) >> 2] | 0;
   HEAP8[($2 + 24 | 0) >> 0] = $1;
   $39 = HEAP32[($2 + 96 | 0) >> 2] | 0;
   HEAP8[($2 + 25 | 0) >> 0] = $39;
   HEAP8[($2 + 26 | 0) >> 0] = $39 >>> 8 | 0;
   HEAP8[($2 + 27 | 0) >> 0] = $39 >>> 16 | 0;
   HEAP8[($2 + 28 | 0) >> 0] = $39 >>> 24 | 0;
   $40 = HEAPU8[($2 + 99 | 0) >> 0] | 0 | ((HEAPU8[($2 + 100 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 101 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 102 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[($2 + 28 | 0) >> 0] = $40;
   HEAP8[($2 + 29 | 0) >> 0] = $40 >>> 8 | 0;
   HEAP8[($2 + 30 | 0) >> 0] = $40 >>> 16 | 0;
   HEAP8[($2 + 31 | 0) >> 0] = $40 >>> 24 | 0;
   HEAP32[($2 + 72 | 0) >> 2] = $3;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 24 | 0 | 0, 1051780 | 0, 9 | 0);
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 160 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__ScriptAny___deserialize__hec03b7272f1e2547($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $5 = 0, $5$hi = 0, $4$hi = 0, $6$hi = 0, $3 = 0, $4 = 0, $6 = 0, $7 = 0, $7$hi = 0, $34 = 0, $35 = 0, $36 = 0, $37 = 0, $38 = 0, $39 = 0, $40 = 0, $41 = 0, $42 = 0, $43 = 0, $67 = 0, $67$hi = 0, $70 = 0, $70$hi = 0, $74$hi = 0, $76$hi = 0, $78$hi = 0, $81 = 0, $81$hi = 0, $93 = 0, $97 = 0, $110 = 0, $128 = 0, $132 = 0, $178 = 0, $182 = 0, $188 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 24 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2 + 40 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
  $5 = i64toi32_i32$1;
  $5$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
       i64toi32_i32$2 = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 1;
       if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
        break label$5
       }
       i64toi32_i32$2 = 0;
       $6 = 0;
       $6$hi = i64toi32_i32$2;
       label$6 : {
        i64toi32_i32$2 = $5$hi;
        i64toi32_i32$3 = $5;
        i64toi32_i32$1 = 0;
        i64toi32_i32$0 = 1;
        if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
         break label$6
        }
        i64toi32_i32$3 = 0;
        $6 = 2;
        $6$hi = i64toi32_i32$3;
        i64toi32_i32$3 = $4$hi;
        i64toi32_i32$0 = $4;
        i64toi32_i32$2 = 0;
        i64toi32_i32$1 = 2;
        if (i64toi32_i32$3 >>> 0 > i64toi32_i32$2 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$0 >>> 0 >= i64toi32_i32$1 >>> 0 | 0) | 0) {
         break label$6
        }
        $1 = 3;
        $3 = 0;
        i64toi32_i32$0 = 0;
        $7 = 0;
        $7$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $4$hi;
        $5 = $4;
        $5$hi = i64toi32_i32$0;
        break label$2;
       }
       i64toi32_i32$0 = $5$hi;
       i64toi32_i32$3 = i64toi32_i32$0;
       cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__ScriptAny___deserialize_as_embedded_group__h33b811880b7eeaff($2 + 24 | 0 | 0, $1 | 0, $5 | 0, i64toi32_i32$0 | 0, $5 | 0, i64toi32_i32$0 | 0);
       i64toi32_i32$3 = 0;
       $7 = 1;
       $7$hi = i64toi32_i32$3;
       label$7 : {
        label$8 : {
         i64toi32_i32$3 = i64toi32_i32$0;
         i64toi32_i32$3 = i64toi32_i32$0;
         i64toi32_i32$1 = $5;
         i64toi32_i32$0 = 0;
         i64toi32_i32$2 = 1;
         if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) | 0) {
          break label$8
         }
         cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 112 | 0 | 0, $1 | 0);
         $3 = HEAPU8[($2 + 120 | 0) >> 0] | 0;
         i64toi32_i32$2 = $2;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 112 | 0) >> 2] | 0;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 116 | 0) >> 2] | 0;
         i64toi32_i32$2 = i64toi32_i32$1;
         i64toi32_i32$1 = 0;
         i64toi32_i32$0 = 1;
         if ((i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) | 0) {
          break label$7
         }
         $1 = 5;
         if (($3 & 255 | 0 | 0) != (5 | 0)) {
          break label$4
         }
         break label$3;
        }
        $1 = 3;
        i64toi32_i32$2 = $6$hi;
        i64toi32_i32$2 = $4$hi;
        i64toi32_i32$2 = $6$hi;
        i64toi32_i32$0 = $6;
        i64toi32_i32$3 = $4$hi;
        i64toi32_i32$1 = $4;
        if ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) | 0) {
         break label$3
        }
        break label$4;
       }
       i64toi32_i32$1 = $2 + 152 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $5 = i64toi32_i32$0;
       $5$hi = i64toi32_i32$2;
       i64toi32_i32$0 = ($2 + 96 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $5;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$0 = ($2 + 8 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $5;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$1 = $2 + 144 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $5 = i64toi32_i32$2;
       $5$hi = i64toi32_i32$0;
       i64toi32_i32$2 = $2;
       HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] = $5;
       HEAP32[(i64toi32_i32$2 + 100 | 0) >> 2] = i64toi32_i32$0;
       HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $5;
       HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$1 = i64toi32_i32$2;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 121 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 122 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 123 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 124 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = 0;
       $67 = i64toi32_i32$0;
       $67$hi = i64toi32_i32$2;
       i64toi32_i32$1 = i64toi32_i32$1 + 125 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
       i64toi32_i32$0 = 0;
       $70 = i64toi32_i32$2;
       $70$hi = i64toi32_i32$0;
       i64toi32_i32$1 = $2 + 127 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
       i64toi32_i32$2 = 0;
       i64toi32_i32$1 = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        $41 = 0;
       } else {
        i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
        $41 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       }
       $74$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $70$hi;
       i64toi32_i32$2 = $70;
       i64toi32_i32$1 = $74$hi;
       i64toi32_i32$3 = $41;
       i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $42 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $42 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       $76$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $67$hi;
       i64toi32_i32$1 = $67;
       i64toi32_i32$0 = $76$hi;
       i64toi32_i32$3 = $42;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 8;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $43 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
        $43 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       $78$hi = i64toi32_i32$1;
       i64toi32_i32$1 = 0;
       i64toi32_i32$0 = $3;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 255;
       i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
       $81 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
       $81$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $78$hi;
       i64toi32_i32$1 = $43;
       i64toi32_i32$0 = $81$hi;
       i64toi32_i32$3 = $81;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
       $4 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       $4$hi = i64toi32_i32$0;
       i64toi32_i32$2 = $2 + 136 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $6 = i64toi32_i32$0;
       $6$hi = i64toi32_i32$1;
       i64toi32_i32$2 = $2 + 128 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $7 = i64toi32_i32$1;
       $7$hi = i64toi32_i32$0;
       $1 = 2;
       break label$4;
      }
      i64toi32_i32$2 = $2 + 64 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $93 = i64toi32_i32$0;
      i64toi32_i32$0 = $2 + 16 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $93;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $2 + 56 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $97 = i64toi32_i32$1;
      i64toi32_i32$1 = $2;
      HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $97;
      HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = i64toi32_i32$1 + 48 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $6 = i64toi32_i32$0;
      $6$hi = i64toi32_i32$1;
      $1 = 2;
      $3 = 0;
      i64toi32_i32$1 = $4$hi;
      $7 = $4;
      $7$hi = i64toi32_i32$1;
      break label$2;
     }
     core__ptr__drop_in_place_core__result__Result_cardano_serialization_lib__ScriptAny_2ccardano_serialization_lib__error__DeserializeError____h226dd032529da919($2 + 24 | 0 | 0);
     $3 = 0;
     i64toi32_i32$1 = $4$hi;
     $5 = $4;
     $5$hi = i64toi32_i32$1;
     break label$2;
    }
    i64toi32_i32$2 = $2 + 72 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $110 = i64toi32_i32$1;
    i64toi32_i32$1 = ($2 + 8 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $110;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[(($2 + 112 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 92 | 0) >> 2] | 0;
    HEAP32[($2 + 96 | 0) >> 2] = HEAPU8[($2 + 33 | 0) >> 0] | 0 | ((HEAPU8[($2 + 34 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 35 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 36 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $34 = ($2 + 24 | 0) + 12 | 0;
    $35 = HEAPU8[$34 >> 0] | 0 | ((HEAPU8[($34 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($34 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($34 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    HEAP8[($2 + 99 | 0) >> 0] = $35;
    HEAP8[($2 + 100 | 0) >> 0] = $35 >>> 8 | 0;
    HEAP8[($2 + 101 | 0) >> 0] = $35 >>> 16 | 0;
    HEAP8[($2 + 102 | 0) >> 0] = $35 >>> 24 | 0;
    i64toi32_i32$2 = $2 + 64 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $128 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $128;
    HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = i64toi32_i32$0 + 84 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $132 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[(i64toi32_i32$1 + 112 | 0) >> 2] = $132;
    HEAP32[(i64toi32_i32$1 + 116 | 0) >> 2] = i64toi32_i32$0;
    $1 = HEAPU8[((i64toi32_i32$1 + 24 | 0) + 8 | 0) >> 0] | 0;
    label$9 : {
     if ((HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
      break label$9
     }
     i64toi32_i32$2 = $2 + 40 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $5 = i64toi32_i32$0;
     $5$hi = i64toi32_i32$1;
     i64toi32_i32$2 = $2 + 48 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $7 = i64toi32_i32$1;
     $7$hi = i64toi32_i32$0;
     i64toi32_i32$2 = $2 + 56 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $6 = i64toi32_i32$0;
     $6$hi = i64toi32_i32$1;
     $3 = HEAP32[($2 + 80 | 0) >> 2] | 0;
     break label$2;
    }
    HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
    $36 = HEAP32[($2 + 96 | 0) >> 2] | 0;
    HEAP8[($0 + 9 | 0) >> 0] = $36;
    HEAP8[($0 + 10 | 0) >> 0] = $36 >>> 8 | 0;
    HEAP8[($0 + 11 | 0) >> 0] = $36 >>> 16 | 0;
    HEAP8[($0 + 12 | 0) >> 0] = $36 >>> 24 | 0;
    HEAP8[($0 + 8 | 0) >> 0] = $1;
    $37 = $0 + 12 | 0;
    $38 = HEAPU8[($2 + 99 | 0) >> 0] | 0 | ((HEAPU8[($2 + 100 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 101 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 102 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    HEAP8[$37 >> 0] = $38;
    HEAP8[($37 + 1 | 0) >> 0] = $38 >>> 8 | 0;
    HEAP8[($37 + 2 | 0) >> 0] = $38 >>> 16 | 0;
    HEAP8[($37 + 3 | 0) >> 0] = $38 >>> 24 | 0;
    $1 = 0;
    break label$1;
   }
   i64toi32_i32$1 = $6$hi;
   i64toi32_i32$0 = $2 + 48 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $6;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $7$hi;
   i64toi32_i32$0 = $2 + 40 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $7;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $5$hi;
   i64toi32_i32$0 = ($2 + 24 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $5;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
   $178 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2 + 56 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $178;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 112 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 116 | 0) >> 2] | 0;
   $182 = i64toi32_i32$0;
   i64toi32_i32$0 = i64toi32_i32$2 + 76 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $182;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = (i64toi32_i32$2 + 8 | 0) + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $188 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 64 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $188;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($2 + 84 | 0) >> 2] = HEAP32[(($2 + 112 | 0) + 8 | 0) >> 2] | 0;
   HEAP8[($2 + 24 | 0) >> 0] = $1;
   $39 = HEAP32[($2 + 96 | 0) >> 2] | 0;
   HEAP8[($2 + 25 | 0) >> 0] = $39;
   HEAP8[($2 + 26 | 0) >> 0] = $39 >>> 8 | 0;
   HEAP8[($2 + 27 | 0) >> 0] = $39 >>> 16 | 0;
   HEAP8[($2 + 28 | 0) >> 0] = $39 >>> 24 | 0;
   $40 = HEAPU8[($2 + 99 | 0) >> 0] | 0 | ((HEAPU8[($2 + 100 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 101 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 102 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[($2 + 28 | 0) >> 0] = $40;
   HEAP8[($2 + 29 | 0) >> 0] = $40 >>> 8 | 0;
   HEAP8[($2 + 30 | 0) >> 0] = $40 >>> 16 | 0;
   HEAP8[($2 + 31 | 0) >> 0] = $40 >>> 24 | 0;
   HEAP32[($2 + 72 | 0) >> 2] = $3;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 24 | 0 | 0, 1051789 | 0, 9 | 0);
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 160 | 0;
 }
 
 function hashbrown__raw__RawTable_T_2cA___resize__hba39572a23a8b6a3($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $5 = 0, $11 = 0, $6 = 0, $15$hi = 0, $15 = 0, $7 = 0, $9 = 0, i64toi32_i32$4 = 0, $12 = 0, $16 = 0, i64toi32_i32$3 = 0, $16$hi = 0, $32 = 0, $13 = 0, $33 = 0, $34 = 0, $35 = 0, $36 = 0, $37 = 0, $38 = 0, $39 = 0, $10 = 0, $40 = 0, $78 = 0, $81$hi = 0, $83 = 0, $8 = 0, $14 = 0, $205 = 0, $210 = 0, $213 = 0, $224 = 0, $233 = 0;
  $5 = global$0 - 80 | 0;
  global$0 = $5;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ($2) {
        break label$5
       }
       i64toi32_i32$0 = 0;
       $15 = 0;
       $15$hi = i64toi32_i32$0;
       $4 = 0;
       $6 = hashbrown__raw__generic__Group__static_empty__hc5a7932fe1bdb1f1() | 0;
       break label$4;
      }
      label$6 : {
       label$7 : {
        if ($2 >>> 0 < 8 >>> 0) {
         break label$7
        }
        label$8 : {
         if (($2 & 536870911 | 0 | 0) != ($2 | 0)) {
          break label$8
         }
         $2 = (-1 >>> Math_clz32(((($2 << 3 | 0) >>> 0) / (7 >>> 0) | 0) + -1 | 0) | 0) + 1 | 0;
         break label$6;
        }
        hashbrown__raw__Fallibility__capacity_overflow__hd790516fe6877097($5 + 8 | 0 | 0, $4 | 0);
        $6 = HEAP32[($5 + 12 | 0) >> 2] | 0;
        $2 = HEAP32[($5 + 8 | 0) >> 2] | 0;
        break label$3;
       }
       $2 = $2 >>> 0 < 4 >>> 0 ? 4 : 8;
      }
      hashbrown__raw__RawTableInner_A___new_uninitialized__h43f4df636ea4ff18($5 + 56 | 0 | 0, 28 | 0, 4 | 0, $2 | 0, $4 | 0);
      $6 = HEAP32[($5 + 64 | 0) >> 2] | 0;
      $2 = HEAP32[($5 + 60 | 0) >> 2] | 0;
      if ((HEAP32[($5 + 56 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      $4 = HEAP32[($5 + 68 | 0) >> 2] | 0;
      memset($6 | 0, 255 | 0, $2 + 5 | 0 | 0) | 0;
      i64toi32_i32$0 = 0;
      $15 = $2;
      $15$hi = i64toi32_i32$0;
     }
     $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
     HEAP32[($5 + 36 | 0) >> 2] = $2;
     HEAP32[(($5 + 16 | 0) + 16 | 0) >> 2] = $4 - $2 | 0;
     i64toi32_i32$1 = $5;
     i64toi32_i32$0 = 4;
     HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = 28;
     HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
     $78 = i64toi32_i32$1;
     i64toi32_i32$0 = 0;
     i64toi32_i32$2 = $6;
     i64toi32_i32$1 = 0;
     i64toi32_i32$3 = 32;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
      $40 = 0;
     } else {
      i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
      $40 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
     }
     $81$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $15$hi;
     i64toi32_i32$1 = $81$hi;
     i64toi32_i32$0 = $40;
     i64toi32_i32$2 = $15$hi;
     i64toi32_i32$3 = $15;
     i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
     $83 = i64toi32_i32$0 | $15 | 0;
     i64toi32_i32$0 = $78;
     HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = $83;
     HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = i64toi32_i32$2;
     $7 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $4 = $7 + 4 | 0;
     $8 = ((HEAP32[$1 >> 2] | 0) + $7 | 0) + 1 | 0;
     $9 = ((HEAP32[$7 >> 2] | 0) ^ -1 | 0) & -2139062144 | 0;
     i64toi32_i32$2 = $15$hi;
     $10 = $15;
     label$9 : while (1) {
      label$10 : {
       if ($9) {
        break label$10
       }
       label$11 : while (1) {
        if ($4 >>> 0 >= $8 >>> 0) {
         break label$2
        }
        $7 = $7 + -112 | 0;
        $2 = HEAP32[$4 >> 2] | 0;
        $11 = $4 + 4 | 0;
        $4 = $11;
        $2 = $2 & -2139062144 | 0;
        if (($2 | 0) == (-2139062144 | 0)) {
         continue label$11
        }
        break label$11;
       };
       $9 = $2 ^ -2139062144 | 0;
       $4 = $11;
      }
      label$12 : {
       i64toi32_i32$2 = $15$hi;
       $12 = ($7 + Math_imul(0 - ((__wasm_ctz_i32($9 | 0) | 0) >>> 3 | 0) | 0, 28) | 0) + -28 | 0;
       i64toi32_i32$2 = hashbrown__map__make_hash__h3827262269fc5d43($3 | 0, $12 | 0) | 0;
       i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
       $16 = i64toi32_i32$2;
       $16$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $15$hi;
       i64toi32_i32$1 = $15;
       i64toi32_i32$2 = $16$hi;
       i64toi32_i32$3 = $16;
       i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
       $11 = i64toi32_i32$1 & $16 | 0;
       $32 = $6 + $11 | 0;
       $13 = (HEAPU8[$32 >> 0] | 0 | ((HEAPU8[($32 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($32 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($32 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
       if ($13) {
        break label$12
       }
       $2 = 4;
       label$13 : while (1) {
        $11 = $11 + $2 | 0;
        $2 = $2 + 4 | 0;
        $11 = $11 & $10 | 0;
        $33 = $6 + $11 | 0;
        $13 = (HEAPU8[$33 >> 0] | 0 | ((HEAPU8[($33 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($33 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($33 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
        if (!$13) {
         continue label$13
        }
        break label$13;
       };
      }
      $14 = $9 + -1 | 0;
      label$14 : {
       $2 = (((__wasm_ctz_i32($13 | 0) | 0) >>> 3 | 0) + $11 | 0) & $10 | 0;
       if ((HEAP8[($6 + $2 | 0) >> 0] | 0 | 0) <= (-1 | 0)) {
        break label$14
       }
       $2 = (__wasm_ctz_i32((HEAP32[$6 >> 2] | 0) & -2139062144 | 0 | 0) | 0) >>> 3 | 0;
      }
      $9 = $14 & $9 | 0;
      i64toi32_i32$2 = $16$hi;
      $11 = $16 >>> 25 | 0;
      HEAP8[($6 + $2 | 0) >> 0] = $11;
      HEAP8[(((($2 + -4 | 0) & $10 | 0) + $6 | 0) + 4 | 0) >> 0] = $11;
      $2 = ($6 + Math_imul(0 - $2 | 0, 28) | 0) + -28 | 0;
      $34 = $12 + 24 | 0;
      $35 = $2 + 24 | 0;
      $36 = HEAPU8[$34 >> 0] | 0 | ((HEAPU8[($34 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($34 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($34 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[$35 >> 0] = $36;
      HEAP8[($35 + 1 | 0) >> 0] = $36 >>> 8 | 0;
      HEAP8[($35 + 2 | 0) >> 0] = $36 >>> 16 | 0;
      HEAP8[($35 + 3 | 0) >> 0] = $36 >>> 24 | 0;
      i64toi32_i32$0 = $12 + 16 | 0;
      i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $205 = i64toi32_i32$2;
      i64toi32_i32$2 = $2 + 16 | 0;
      $37 = $205;
      HEAP8[i64toi32_i32$2 >> 0] = $37;
      HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $37 >>> 8 | 0;
      HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $37 >>> 16 | 0;
      HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $37 >>> 24 | 0;
      HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      i64toi32_i32$0 = $12 + 8 | 0;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $210 = i64toi32_i32$1;
      i64toi32_i32$1 = $2 + 8 | 0;
      $38 = $210;
      HEAP8[i64toi32_i32$1 >> 0] = $38;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $38 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $38 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $38 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$2;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
      i64toi32_i32$0 = $12;
      i64toi32_i32$2 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $213 = i64toi32_i32$2;
      i64toi32_i32$2 = $2;
      $39 = $213;
      HEAP8[i64toi32_i32$2 >> 0] = $39;
      HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $39 >>> 8 | 0;
      HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $39 >>> 16 | 0;
      HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $39 >>> 24 | 0;
      HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      continue label$9;
     };
    }
    HEAP32[($0 + 4 | 0) >> 2] = $2;
    HEAP32[$0 >> 2] = 1;
    HEAP32[($0 + 8 | 0) >> 2] = $6;
    break label$1;
   }
   i64toi32_i32$0 = $1;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $16 = i64toi32_i32$1;
   $16$hi = i64toi32_i32$2;
   i64toi32_i32$0 = $5;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] | 0;
   $224 = i64toi32_i32$2;
   i64toi32_i32$2 = $1;
   HEAP32[i64toi32_i32$2 >> 2] = $224;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   $2 = i64toi32_i32$0 + 32 | 0;
   i64toi32_i32$0 = $2;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $15 = i64toi32_i32$1;
   $15$hi = i64toi32_i32$2;
   $4 = $1 + 8 | 0;
   i64toi32_i32$0 = $4;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $233 = i64toi32_i32$2;
   i64toi32_i32$2 = $2;
   HEAP32[i64toi32_i32$2 >> 2] = $233;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $15$hi;
   i64toi32_i32$2 = i64toi32_i32$0;
   HEAP32[i64toi32_i32$0 >> 2] = $15;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $16$hi;
   i64toi32_i32$2 = $5;
   HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] = $16;
   HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[$0 >> 2] = 0;
   core__ptr__drop_in_place_hashbrown__scopeguard__ScopeGuard_hashbrown__raw__RawTableInner_alloc__alloc__Global__2chashbrown__raw__RawTableInner_alloc__alloc__Global___prepare_resize___7b_7bclosure_7d_7d____hf09be25679474fda(i64toi32_i32$2 + 16 | 0 | 0);
  }
  global$0 = $5 + 80 | 0;
 }
 
 function ed25519_bip32__derivation__public__h71f1912d7f2e7689($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $4 = 0, $13 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $124 = 0, $131 = 0, $142 = 0, $145 = 0;
  $3 = global$0 - 1392 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       $4 = core__array___impl_20core__convert__TryFrom___5bT_5d__20for_20__5bT_3b_20N_5d___try_from__hff8e53c357d25f23($1 | 0, 32 | 0) | 0;
       if (!$4) {
        break label$5
       }
       cryptoxide__sha2__Sha512__new__h57eb1a61fae5dfc3($3 + 264 | 0 | 0);
       $1 = $1 + 32 | 0;
       cryptoxide__hmac__Hmac_D___new__h10c18a5661f5ecf6($3 + 8 | 0 | 0, $3 + 264 | 0 | 0, $1 | 0, 32 | 0);
       cryptoxide__sha2__Sha512__new__h57eb1a61fae5dfc3($3 + 520 | 0 | 0);
       cryptoxide__hmac__Hmac_D___new__h10c18a5661f5ecf6($3 + 264 | 0 | 0, $3 + 520 | 0 | 0, $1 | 0, 32 | 0);
       HEAP32[($3 + 748 | 0) >> 2] = $2;
       label$6 : {
        if (($2 | 0) < (0 | 0)) {
         break label$6
        }
        $cryptoxide__hmac__Hmac_D__20as_20cryptoxide__mac__Mac___input__h8428084cca8543c2($3 + 8 | 0 | 0, 1101454 | 0, 1 | 0);
        $cryptoxide__hmac__Hmac_D__20as_20cryptoxide__mac__Mac___input__h8428084cca8543c2($3 + 8 | 0 | 0, $4 | 0, 32 | 0);
        $cryptoxide__hmac__Hmac_D__20as_20cryptoxide__mac__Mac___input__h8428084cca8543c2($3 + 8 | 0 | 0, $3 + 748 | 0 | 0, 4 | 0);
        $cryptoxide__hmac__Hmac_D__20as_20cryptoxide__mac__Mac___input__h8428084cca8543c2($3 + 264 | 0 | 0, 1101455 | 0, 1 | 0);
        $cryptoxide__hmac__Hmac_D__20as_20cryptoxide__mac__Mac___input__h8428084cca8543c2($3 + 264 | 0 | 0, $4 | 0, 32 | 0);
        $cryptoxide__hmac__Hmac_D__20as_20cryptoxide__mac__Mac___input__h8428084cca8543c2($3 + 264 | 0 | 0, $3 + 748 | 0 | 0, 4 | 0);
        memset($3 + 752 | 0 | 0, 0 | 0, 64 | 0) | 0;
        $cryptoxide__hmac__Hmac_D__20as_20cryptoxide__mac__Mac___raw_result__hac4d52a01c11d996($3 + 8 | 0 | 0, $3 + 752 | 0 | 0, 64 | 0);
        $1 = core__array___impl_20core__convert__TryFrom___5bT_5d__20for_20__5bT_3b_20N_5d___try_from__hff8e53c357d25f23($3 + 752 | 0 | 0, 32 | 0) | 0;
        if (!$1) {
         break label$4
        }
        ed25519_bip32__derivation__v2__add_28_mul8_v2__hbec4c73081377038($3 + 880 | 0 | 0, 1101488 | 0, $1 | 0);
        cryptoxide__curve25519__scalar__scalar64__Scalar__from_bytes__hcfeedd1974a72bb6($3 + 1232 | 0 | 0, $3 + 880 | 0 | 0);
        cryptoxide__curve25519__ge__Ge__scalarmult_base__hfb711866362b33a6($3 + 520 | 0 | 0, $3 + 1232 | 0 | 0);
        cryptoxide__curve25519__ge__Ge__to_bytes__hce32fa3f32cec513($3 + 848 | 0 | 0, $3 + 520 | 0 | 0);
        cryptoxide__curve25519__ge__Ge__from_bytes__hef188e306ddf7e48($3 + 520 | 0 | 0, $4 | 0);
        i64toi32_i32$2 = $3;
        i64toi32_i32$0 = HEAP32[($3 + 520 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($3 + 524 | 0) >> 2] | 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$0 | 0) | 0) {
         break label$3
        }
        $1 = $3 + 528 | 0;
        memcpy($3 + 912 | 0 | 0, $1 | 0, 160 | 0) | 0;
        cryptoxide__curve25519__ge__Ge__from_bytes__hef188e306ddf7e48($3 + 520 | 0 | 0, $3 + 848 | 0 | 0);
        i64toi32_i32$3 = $3;
        i64toi32_i32$2 = HEAP32[($3 + 520 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($3 + 524 | 0) >> 2] | 0;
        i64toi32_i32$3 = i64toi32_i32$2;
        i64toi32_i32$2 = 0;
        i64toi32_i32$0 = 1;
        if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$2 | 0) | 0) {
         break label$3
        }
        memcpy($3 + 1072 | 0 | 0, $1 | 0, 160 | 0) | 0;
        cryptoxide__curve25519__ge__Ge__to_cached__h058a97fcf91788e4($3 + 520 | 0 | 0, $3 + 1072 | 0 | 0);
        $_cryptoxide__curve25519__ge__Ge_20as_20core__ops__arith__Add__cryptoxide__curve25519__ge__GeCached____add__hdb98361e5d861211($3 + 1232 | 0 | 0, $3 + 912 | 0 | 0, $3 + 520 | 0 | 0);
        cryptoxide__curve25519__ge__GeP1P1__to_full__hee64a48e5ca8376f($3 + 520 | 0 | 0, $3 + 1232 | 0 | 0);
        cryptoxide__curve25519__ge__Ge__to_bytes__hce32fa3f32cec513($3 + 880 | 0 | 0, $3 + 520 | 0 | 0);
        i64toi32_i32$0 = ($3 + 880 | 0) + 9 | 0;
        i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $124 = i64toi32_i32$3;
        i64toi32_i32$3 = ($3 + 816 | 0) + 9 | 0;
        $13 = $124;
        HEAP8[i64toi32_i32$3 >> 0] = $13;
        HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $13 >>> 8 | 0;
        HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $13 >>> 16 | 0;
        HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $13 >>> 24 | 0;
        HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$1;
        HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
        HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
        HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
        i64toi32_i32$0 = ($3 + 880 | 0) + 17 | 0;
        i64toi32_i32$1 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$3 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $131 = i64toi32_i32$1;
        i64toi32_i32$1 = ($3 + 816 | 0) + 17 | 0;
        $14 = $131;
        HEAP8[i64toi32_i32$1 >> 0] = $14;
        HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $14 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $14 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $14 >>> 24 | 0;
        HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$3;
        HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
        HEAP8[($3 + 911 | 0) >> 0] = (HEAPU8[($3 + 911 | 0) >> 0] | 0) ^ 128 | 0;
        i64toi32_i32$0 = ($3 + 880 | 0) + 24 | 0;
        i64toi32_i32$3 = HEAPU8[i64toi32_i32$0 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $142 = i64toi32_i32$3;
        i64toi32_i32$3 = ($3 + 816 | 0) + 24 | 0;
        $15 = $142;
        HEAP8[i64toi32_i32$3 >> 0] = $15;
        HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $15 >>> 8 | 0;
        HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $15 >>> 16 | 0;
        HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $15 >>> 24 | 0;
        HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$1;
        HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
        HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
        HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
        i64toi32_i32$0 = $3;
        i64toi32_i32$1 = HEAPU8[($3 + 881 | 0) >> 0] | 0 | ((HEAPU8[($3 + 882 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 883 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 884 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$3 = HEAPU8[($3 + 885 | 0) >> 0] | 0 | ((HEAPU8[($3 + 886 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 887 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 888 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $145 = i64toi32_i32$1;
        i64toi32_i32$1 = $3;
        $16 = $145;
        HEAP8[($3 + 817 | 0) >> 0] = $16;
        HEAP8[($3 + 818 | 0) >> 0] = $16 >>> 8 | 0;
        HEAP8[($3 + 819 | 0) >> 0] = $16 >>> 16 | 0;
        HEAP8[($3 + 820 | 0) >> 0] = $16 >>> 24 | 0;
        HEAP8[($3 + 821 | 0) >> 0] = i64toi32_i32$3;
        HEAP8[($3 + 822 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
        HEAP8[($3 + 823 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
        HEAP8[($3 + 824 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
        HEAP8[($3 + 816 | 0) >> 0] = HEAPU8[($3 + 880 | 0) >> 0] | 0;
        memset($3 + 1232 | 0 | 0, 0 | 0, 64 | 0) | 0;
        $cryptoxide__hmac__Hmac_D__20as_20cryptoxide__mac__Mac___raw_result__hac4d52a01c11d996($3 + 264 | 0 | 0, $3 + 1232 | 0 | 0, 64 | 0);
        memset($3 + 520 | 0 | 0, 0 | 0, 64 | 0) | 0;
        core__slice___impl_20_5bT_5d___copy_from_slice__h0f69c19ed1852955($3 + 520 | 0 | 0, 32 | 0, $3 + 816 | 0 | 0, 32 | 0);
        core__slice___impl_20_5bT_5d___copy_from_slice__h0f69c19ed1852955(($3 + 520 | 0) + 32 | 0 | 0, 32 | 0, ($3 + 1232 | 0) + 32 | 0 | 0, 32 | 0);
        $cryptoxide__hmac__Hmac_D__20as_20cryptoxide__mac__Mac___reset__hbf8667f113797205($3 + 264 | 0 | 0);
        $cryptoxide__hmac__Hmac_D__20as_20cryptoxide__mac__Mac___reset__hbf8667f113797205($3 + 8 | 0 | 0);
        memcpy($0 + 1 | 0 | 0, $3 + 520 | 0 | 0, 64 | 0) | 0;
        HEAP8[$0 >> 0] = 0;
        core__ptr__drop_in_place_cryptoxide__hmac__Hmac_cryptoxide__sha2__Sha512____hc18b32e73944f3e5($3 + 264 | 0 | 0);
        core__ptr__drop_in_place_cryptoxide__hmac__Hmac_cryptoxide__sha2__Sha512____hc18b32e73944f3e5($3 + 8 | 0 | 0);
        break label$1;
       }
       $17 = 257;
       HEAP8[$0 >> 0] = $17;
       HEAP8[($0 + 1 | 0) >> 0] = $17 >>> 8 | 0;
       break label$2;
      }
      core__result__unwrap_failed__h27f43d993c3864a1(1101252 | 0, 43 | 0, $3 + 520 | 0 | 0, 1101296 | 0, 1101520 | 0);
      abort();
     }
     core__result__unwrap_failed__h27f43d993c3864a1(1101252 | 0, 43 | 0, $3 + 520 | 0 | 0, 1101296 | 0, 1101536 | 0);
     abort();
    }
    $18 = 1;
    HEAP8[$0 >> 0] = $18;
    HEAP8[($0 + 1 | 0) >> 0] = $18 >>> 8 | 0;
   }
   core__ptr__drop_in_place_cryptoxide__hmac__Hmac_cryptoxide__sha2__Sha512____hc18b32e73944f3e5($3 + 264 | 0 | 0);
   core__ptr__drop_in_place_cryptoxide__hmac__Hmac_cryptoxide__sha2__Sha512____hc18b32e73944f3e5($3 + 8 | 0 | 0);
  }
  global$0 = $3 + 1392 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__MultiHostName___deserialize__h60fdbf7365429725($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $4 = 0, $4$hi = 0, $5 = 0, $3 = 0, $5$hi = 0, $33 = 0, $34 = 0, $35 = 0, $36 = 0, $37 = 0, $38 = 0, $39 = 0, $41 = 0, $42 = 0, $43 = 0, $40 = 0, $46 = 0, $64 = 0, $68 = 0, $116 = 0, $116$hi = 0, $119 = 0, $119$hi = 0, $123$hi = 0, $125$hi = 0, $127$hi = 0, $130 = 0, $130$hi = 0, $155 = 0, $161 = 0, $165 = 0, $181 = 0, $185 = 0, $191 = 0, $197 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 32 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 40 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 44 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      i64toi32_i32$2 = $2;
      i64toi32_i32$1 = HEAP32[($2 + 32 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($2 + 36 | 0) >> 2] | 0;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 1;
      if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
       break label$4
      }
      i64toi32_i32$2 = $4$hi;
      i64toi32_i32$0 = i64toi32_i32$2;
      cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__MultiHostName___deserialize_as_embedded_group__h940a0d3c5a471c2f($2 + 32 | 0 | 0, $1 | 0, $4 | 0, i64toi32_i32$0 | 0, $4 | 0, i64toi32_i32$0 | 0);
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          i64toi32_i32$3 = $4;
          i64toi32_i32$2 = 0;
          i64toi32_i32$1 = 1;
          if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) | 0) {
           break label$8
          }
          cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 128 | 0 | 0, $1 | 0);
          $3 = HEAPU8[($2 + 136 | 0) >> 0] | 0;
          i64toi32_i32$1 = $2;
          i64toi32_i32$3 = HEAP32[($2 + 128 | 0) >> 2] | 0;
          i64toi32_i32$0 = HEAP32[($2 + 132 | 0) >> 2] | 0;
          i64toi32_i32$1 = i64toi32_i32$3;
          i64toi32_i32$3 = 0;
          i64toi32_i32$2 = 1;
          if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) | 0) {
           break label$7
          }
          $1 = 5;
          if (($3 & 255 | 0 | 0) != (5 | 0)) {
           break label$6
          }
         }
         i64toi32_i32$2 = $2 + 72 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $40 = i64toi32_i32$1;
         i64toi32_i32$1 = ($2 + 8 | 0) + 8 | 0;
         HEAP32[i64toi32_i32$1 >> 2] = $40;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$2 = $2 + 80 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $46 = i64toi32_i32$0;
         i64toi32_i32$0 = ($2 + 8 | 0) + 16 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $46;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         HEAP32[(($2 + 128 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 100 | 0) >> 2] | 0;
         HEAP32[($2 + 104 | 0) >> 2] = HEAPU8[($2 + 41 | 0) >> 0] | 0 | ((HEAPU8[($2 + 42 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 43 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 44 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $33 = ($2 + 32 | 0) + 12 | 0;
         $34 = HEAPU8[$33 >> 0] | 0 | ((HEAPU8[($33 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($33 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($33 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[($2 + 107 | 0) >> 0] = $34;
         HEAP8[($2 + 108 | 0) >> 0] = $34 >>> 8 | 0;
         HEAP8[($2 + 109 | 0) >> 0] = $34 >>> 16 | 0;
         HEAP8[($2 + 110 | 0) >> 0] = $34 >>> 24 | 0;
         i64toi32_i32$2 = $2 + 64 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $64 = i64toi32_i32$1;
         i64toi32_i32$1 = $2;
         HEAP32[($2 + 8 | 0) >> 2] = $64;
         HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$2 = $2 + 92 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $68 = i64toi32_i32$0;
         i64toi32_i32$0 = $2;
         HEAP32[($2 + 128 | 0) >> 2] = $68;
         HEAP32[($2 + 132 | 0) >> 2] = i64toi32_i32$1;
         $1 = HEAPU8[(($2 + 32 | 0) + 8 | 0) >> 0] | 0;
         if ((HEAP32[($2 + 32 | 0) >> 2] | 0 | 0) != (1 | 0)) {
          break label$5
         }
         i64toi32_i32$2 = ($2 + 32 | 0) + 16 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $4 = i64toi32_i32$1;
         $4$hi = i64toi32_i32$0;
         i64toi32_i32$2 = $2 + 56 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $5 = i64toi32_i32$0;
         $5$hi = i64toi32_i32$1;
         $3 = HEAP32[($2 + 88 | 0) >> 2] | 0;
         break label$2;
        }
        i64toi32_i32$2 = $2 + 160 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $4 = i64toi32_i32$1;
        $4$hi = i64toi32_i32$0;
        i64toi32_i32$1 = ($2 + 104 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $4;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = $2 + 168 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $5 = i64toi32_i32$0;
        $5$hi = i64toi32_i32$1;
        i64toi32_i32$0 = ($2 + 104 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $5;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$1 = $4$hi;
        i64toi32_i32$0 = ($2 + 8 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $4;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$1 = $5$hi;
        i64toi32_i32$0 = ($2 + 8 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $5;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$2 = $2 + 152 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $4 = i64toi32_i32$1;
        $4$hi = i64toi32_i32$0;
        i64toi32_i32$1 = $2;
        HEAP32[($2 + 104 | 0) >> 2] = $4;
        HEAP32[($2 + 108 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$1 = $2;
        HEAP32[($2 + 8 | 0) >> 2] = $4;
        HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAPU8[($2 + 137 | 0) >> 0] | 0 | ((HEAPU8[($2 + 138 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 139 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 140 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$1 = 0;
        $116 = i64toi32_i32$0;
        $116$hi = i64toi32_i32$1;
        i64toi32_i32$2 = $2 + 141 | 0;
        i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
        i64toi32_i32$0 = 0;
        $119 = i64toi32_i32$1;
        $119$hi = i64toi32_i32$0;
        i64toi32_i32$2 = $2 + 143 | 0;
        i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
        i64toi32_i32$1 = 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 16;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
         $41 = 0;
        } else {
         i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
         $41 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        }
        $123$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $119$hi;
        i64toi32_i32$1 = $119;
        i64toi32_i32$2 = $123$hi;
        i64toi32_i32$3 = $41;
        i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
        i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 32;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
         $42 = 0;
        } else {
         i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
         $42 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        }
        $125$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $116$hi;
        i64toi32_i32$2 = $116;
        i64toi32_i32$0 = $125$hi;
        i64toi32_i32$3 = $42;
        i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
        i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
        i64toi32_i32$2 = 0;
        i64toi32_i32$3 = 8;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
         $43 = 0;
        } else {
         i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
         $43 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        }
        $127$hi = i64toi32_i32$2;
        i64toi32_i32$2 = 0;
        i64toi32_i32$0 = $3;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 255;
        i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
        $130 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
        $130$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $127$hi;
        i64toi32_i32$2 = $43;
        i64toi32_i32$0 = $130$hi;
        i64toi32_i32$3 = $130;
        i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
        $4 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
        $4$hi = i64toi32_i32$0;
        i64toi32_i32$1 = ($2 + 128 | 0) + 16 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
        $5 = i64toi32_i32$0;
        $5$hi = i64toi32_i32$2;
        $1 = 2;
       }
       core__ptr__drop_in_place_core__result__Result_cardano_serialization_lib__MultiHostName_2ccardano_serialization_lib__error__DeserializeError____hebb1c6f92c0f8b11($2 + 32 | 0 | 0);
       break label$3;
      }
      HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($2 + 36 | 0) >> 2] | 0;
      $35 = HEAP32[($2 + 104 | 0) >> 2] | 0;
      HEAP8[($0 + 9 | 0) >> 0] = $35;
      HEAP8[($0 + 10 | 0) >> 0] = $35 >>> 8 | 0;
      HEAP8[($0 + 11 | 0) >> 0] = $35 >>> 16 | 0;
      HEAP8[($0 + 12 | 0) >> 0] = $35 >>> 24 | 0;
      HEAP8[($0 + 8 | 0) >> 0] = $1;
      $36 = $0 + 12 | 0;
      $37 = HEAPU8[($2 + 107 | 0) >> 0] | 0 | ((HEAPU8[($2 + 108 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 109 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 110 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[$36 >> 0] = $37;
      HEAP8[($36 + 1 | 0) >> 0] = $37 >>> 8 | 0;
      HEAP8[($36 + 2 | 0) >> 0] = $37 >>> 16 | 0;
      HEAP8[($36 + 3 | 0) >> 0] = $37 >>> 24 | 0;
      $1 = 0;
      break label$1;
     }
     i64toi32_i32$1 = $2 + 64 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $155 = i64toi32_i32$2;
     i64toi32_i32$2 = $2 + 16 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $155;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$1 = $2 + 72 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $161 = i64toi32_i32$0;
     i64toi32_i32$0 = ($2 + 8 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $161;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$1 = $2 + 56 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $165 = i64toi32_i32$2;
     i64toi32_i32$2 = $2;
     HEAP32[($2 + 8 | 0) >> 2] = $165;
     HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$1 = ($2 + 32 | 0) + 16 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $5 = i64toi32_i32$0;
     $5$hi = i64toi32_i32$2;
     $1 = 2;
    }
    $3 = 0;
   }
   i64toi32_i32$2 = $5$hi;
   i64toi32_i32$0 = ($2 + 32 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $5;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$2 = $4$hi;
   i64toi32_i32$0 = ($2 + 32 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $4;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$1 = $2;
   i64toi32_i32$2 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $181 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 56 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $181;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$1 = $2;
   i64toi32_i32$0 = HEAP32[($2 + 128 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($2 + 132 | 0) >> 2] | 0;
   $185 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 84 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $185;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$1 = ($2 + 8 | 0) + 8 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $191 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 64 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $191;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$1 = ($2 + 8 | 0) + 16 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $197 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 72 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $197;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   HEAP32[($2 + 92 | 0) >> 2] = HEAP32[(($2 + 128 | 0) + 8 | 0) >> 2] | 0;
   HEAP8[($2 + 32 | 0) >> 0] = $1;
   $38 = HEAP32[($2 + 104 | 0) >> 2] | 0;
   HEAP8[($2 + 33 | 0) >> 0] = $38;
   HEAP8[($2 + 34 | 0) >> 0] = $38 >>> 8 | 0;
   HEAP8[($2 + 35 | 0) >> 0] = $38 >>> 16 | 0;
   HEAP8[($2 + 36 | 0) >> 0] = $38 >>> 24 | 0;
   $39 = HEAPU8[($2 + 107 | 0) >> 0] | 0 | ((HEAPU8[($2 + 108 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 109 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 110 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[($2 + 36 | 0) >> 0] = $39;
   HEAP8[($2 + 37 | 0) >> 0] = $39 >>> 8 | 0;
   HEAP8[($2 + 38 | 0) >> 0] = $39 >>> 16 | 0;
   HEAP8[($2 + 39 | 0) >> 0] = $39 >>> 24 | 0;
   HEAP32[($2 + 80 | 0) >> 2] = $3;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 32 | 0 | 0, 1051456 | 0, 13 | 0);
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function $core__iter__adapters__map__Map_I_2cF__20as_20core__iter__traits__iterator__Iterator___try_fold__ha360decb24de22bf($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$0 = 0, $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $5 = 0, $11 = 0, $7 = 0, $14 = 0, $16 = 0, $43 = 0, $44 = 0, $45 = 0, $46 = 0, $9 = 0, $6 = 0, $8 = 0, $12 = 0, $13 = 0, $15 = 0, $17 = 0, $18 = 0, $10 = 0, $63 = 0, $71 = 0, $74 = 0, $89 = 0, $95 = 0, $98 = 0, $114 = 0, $120 = 0, $123 = 0, $126 = 0, $147 = 0, $150 = 0, $153 = 0, $156 = 0, $177 = 0, $189 = 0, $194 = 0, $197 = 0, $229 = 0, $234 = 0, $239 = 0;
  $4 = global$0 - 208 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    $5 = HEAP32[$1 >> 2] | 0;
    $6 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (($5 | 0) == ($6 | 0)) {
     break label$2
    }
    $7 = (HEAP32[($1 + 8 | 0) >> 2] | 0) + -1 | 0;
    $8 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    $9 = $4 + 33 | 0;
    $10 = ($4 + 24 | 0) + 8 | 0;
    $11 = ($4 + 104 | 0) + 8 | 0;
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : while (1) {
         HEAP32[($1 + 8 | 0) >> 2] = $7;
         $12 = HEAP32[($5 + 100 | 0) >> 2] | 0;
         HEAP32[$1 >> 2] = $12;
         cardano_serialization_lib__metadata__decode_metadatum_to_json_value__h971c762f0ec03432($4 + 104 | 0 | 0, $5 | 0, HEAPU8[$8 >> 0] | 0 | 0);
         if ((HEAP32[($4 + 104 | 0) >> 2] | 0 | 0) == (1 | 0)) {
          break label$6
         }
         $13 = ($4 + 56 | 0) + 16 | 0;
         $14 = $11 + 16 | 0;
         i64toi32_i32$2 = $14;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $63 = i64toi32_i32$0;
         i64toi32_i32$0 = $13;
         HEAP32[i64toi32_i32$0 >> 2] = $63;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         $15 = ($4 + 56 | 0) + 8 | 0;
         $16 = $11 + 8 | 0;
         i64toi32_i32$2 = $16;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $71 = i64toi32_i32$1;
         i64toi32_i32$1 = $15;
         HEAP32[i64toi32_i32$1 >> 2] = $71;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$2 = $11;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $74 = i64toi32_i32$0;
         i64toi32_i32$0 = $4;
         HEAP32[($4 + 56 | 0) >> 2] = $74;
         HEAP32[($4 + 60 | 0) >> 2] = i64toi32_i32$1;
         cardano_serialization_lib__metadata__decode_metadatum_to_json_value__h971c762f0ec03432($4 + 104 | 0 | 0, $5 + 48 | 0 | 0, HEAPU8[$8 >> 0] | 0 | 0);
         if ((HEAP32[($4 + 104 | 0) >> 2] | 0 | 0) == (1 | 0)) {
          break label$5
         }
         $5 = ($4 + 80 | 0) + 16 | 0;
         i64toi32_i32$2 = $14;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $89 = i64toi32_i32$1;
         i64toi32_i32$1 = $5;
         HEAP32[i64toi32_i32$1 >> 2] = $89;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
         $14 = ($4 + 80 | 0) + 8 | 0;
         i64toi32_i32$2 = $16;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $95 = i64toi32_i32$0;
         i64toi32_i32$0 = $14;
         HEAP32[i64toi32_i32$0 >> 2] = $95;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$2 = $11;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $98 = i64toi32_i32$1;
         i64toi32_i32$1 = $4;
         HEAP32[($4 + 80 | 0) >> 2] = $98;
         HEAP32[($4 + 84 | 0) >> 2] = i64toi32_i32$0;
         alloc__collections__btree__map__BTreeMap_K_2cV___new__h241ee1a6e88d54c0($4 + 136 | 0 | 0);
         alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($4 + 176 | 0 | 0, 1063496 | 0, 1 | 0);
         $16 = ($4 + 192 | 0) + 8 | 0;
         $17 = ($4 + 176 | 0) + 8 | 0;
         HEAP32[$16 >> 2] = HEAP32[$17 >> 2] | 0;
         i64toi32_i32$2 = $4;
         i64toi32_i32$0 = HEAP32[($4 + 176 | 0) >> 2] | 0;
         i64toi32_i32$1 = HEAP32[($4 + 180 | 0) >> 2] | 0;
         $114 = i64toi32_i32$0;
         i64toi32_i32$0 = $4;
         HEAP32[($4 + 192 | 0) >> 2] = $114;
         HEAP32[($4 + 196 | 0) >> 2] = i64toi32_i32$1;
         $18 = ($4 + 104 | 0) + 16 | 0;
         i64toi32_i32$2 = $13;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $120 = i64toi32_i32$1;
         i64toi32_i32$1 = $18;
         HEAP32[i64toi32_i32$1 >> 2] = $120;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$2 = $15;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $123 = i64toi32_i32$0;
         i64toi32_i32$0 = $11;
         HEAP32[i64toi32_i32$0 >> 2] = $123;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$2 = $4;
         i64toi32_i32$1 = HEAP32[($4 + 56 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($4 + 60 | 0) >> 2] | 0;
         $126 = i64toi32_i32$1;
         i64toi32_i32$1 = $4;
         HEAP32[($4 + 104 | 0) >> 2] = $126;
         HEAP32[($4 + 108 | 0) >> 2] = i64toi32_i32$0;
         alloc__collections__btree__map__BTreeMap_K_2cV___insert__h676f968c46c3ef24($4 + 152 | 0 | 0, $4 + 136 | 0 | 0, $4 + 192 | 0 | 0, $4 + 104 | 0 | 0);
         label$8 : {
          if ((HEAPU8[($4 + 152 | 0) >> 0] | 0 | 0) == (6 | 0)) {
           break label$8
          }
          core__ptr__drop_in_place_serde_json__value__Value___h0088decf7dc316c7_2($4 + 152 | 0 | 0);
         }
         alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($4 + 176 | 0 | 0, 1063497 | 0, 1 | 0);
         HEAP32[$16 >> 2] = HEAP32[$17 >> 2] | 0;
         i64toi32_i32$2 = $4;
         i64toi32_i32$0 = HEAP32[($4 + 176 | 0) >> 2] | 0;
         i64toi32_i32$1 = HEAP32[($4 + 180 | 0) >> 2] | 0;
         $147 = i64toi32_i32$0;
         i64toi32_i32$0 = $4;
         HEAP32[($4 + 192 | 0) >> 2] = $147;
         HEAP32[($4 + 196 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$2 = $5;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $150 = i64toi32_i32$1;
         i64toi32_i32$1 = $18;
         HEAP32[i64toi32_i32$1 >> 2] = $150;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$2 = $14;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $153 = i64toi32_i32$0;
         i64toi32_i32$0 = $11;
         HEAP32[i64toi32_i32$0 >> 2] = $153;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$2 = $4;
         i64toi32_i32$1 = HEAP32[($4 + 80 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($4 + 84 | 0) >> 2] | 0;
         $156 = i64toi32_i32$1;
         i64toi32_i32$1 = $4;
         HEAP32[($4 + 104 | 0) >> 2] = $156;
         HEAP32[($4 + 108 | 0) >> 2] = i64toi32_i32$0;
         alloc__collections__btree__map__BTreeMap_K_2cV___insert__h676f968c46c3ef24($4 + 152 | 0 | 0, $4 + 136 | 0 | 0, $4 + 192 | 0 | 0, $4 + 104 | 0 | 0);
         label$9 : {
          if ((HEAPU8[($4 + 152 | 0) >> 0] | 0 | 0) == (6 | 0)) {
           break label$9
          }
          core__ptr__drop_in_place_serde_json__value__Value___h0088decf7dc316c7_2($4 + 152 | 0 | 0);
         }
         HEAP32[$11 >> 2] = HEAP32[(($4 + 136 | 0) + 8 | 0) >> 2] | 0;
         i64toi32_i32$2 = $4;
         i64toi32_i32$0 = HEAP32[($4 + 136 | 0) >> 2] | 0;
         i64toi32_i32$1 = HEAP32[($4 + 140 | 0) >> 2] | 0;
         $177 = i64toi32_i32$0;
         i64toi32_i32$0 = $4;
         HEAP32[($4 + 104 | 0) >> 2] = $177;
         HEAP32[($4 + 108 | 0) >> 2] = i64toi32_i32$1;
         serde_json__value__from___impl_20core__convert__From_serde_json__map__Map_alloc__string__String_2cserde_json__value__Value___20for_20serde_json__value__Value___from__hd445317c7fcd41f3($10 | 0, $4 + 104 | 0 | 0);
         label$10 : {
          $5 = HEAPU8[($4 + 32 | 0) >> 0] | 0;
          if (($5 | 0) == (6 | 0)) {
           break label$10
          }
          i64toi32_i32$2 = $9 + 15 | 0;
          i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          $189 = i64toi32_i32$1;
          i64toi32_i32$1 = $4 + 15 | 0;
          $43 = $189;
          HEAP8[i64toi32_i32$1 >> 0] = $43;
          HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $43 >>> 8 | 0;
          HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $43 >>> 16 | 0;
          HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $43 >>> 24 | 0;
          HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
          HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
          HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
          HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
          i64toi32_i32$2 = $9 + 8 | 0;
          i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          $194 = i64toi32_i32$0;
          i64toi32_i32$0 = $4 + 8 | 0;
          HEAP32[i64toi32_i32$0 >> 2] = $194;
          HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
          i64toi32_i32$2 = $9;
          i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          $197 = i64toi32_i32$1;
          i64toi32_i32$1 = $4;
          HEAP32[$4 >> 2] = $197;
          HEAP32[($4 + 4 | 0) >> 2] = i64toi32_i32$0;
          if (($5 | 0) != (7 | 0)) {
           break label$3
          }
         }
         $7 = $7 + -1 | 0;
         $5 = $12;
         if (($5 | 0) == ($6 | 0)) {
          break label$2
         }
         continue label$7;
        };
       }
       $5 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($4 + 108 | 0) >> 2] | 0 | 0) | 0;
       break label$4;
      }
      $5 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($4 + 108 | 0) >> 2] | 0 | 0) | 0;
      core__ptr__drop_in_place_serde_json__value__Value___h0088decf7dc316c7_2($4 + 56 | 0 | 0);
     }
     label$11 : {
      $11 = HEAP32[$3 >> 2] | 0;
      if (!(HEAP32[$11 >> 2] | 0)) {
       break label$11
      }
      $7 = HEAP32[($11 + 4 | 0) >> 2] | 0;
      if ($7 >>> 0 < 36 >>> 0) {
       break label$11
      }
      wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($7 | 0);
     }
     HEAP32[($11 + 4 | 0) >> 2] = $5;
     HEAP32[$11 >> 2] = 1;
     $5 = 6;
    }
    i64toi32_i32$2 = $4;
    i64toi32_i32$0 = HEAP32[$4 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
    $229 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    $44 = $229;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $44;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $44 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $44 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = $44 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 8 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$2 = $4 + 15 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $234 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 16 | 0;
    $45 = $234;
    HEAP8[i64toi32_i32$1 >> 0] = $45;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $45 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $45 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $45 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$2 = $4 + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $239 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 9 | 0;
    $46 = $239;
    HEAP8[i64toi32_i32$0 >> 0] = $46;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $46 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $46 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $46 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    break label$1;
   }
   $5 = 7;
  }
  HEAP8[$0 >> 0] = $5;
  global$0 = $4 + 208 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__ProtocolVersion___deserialize__h3c8c85b9f2b44aff($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $6 = 0, $6$hi = 0, $3 = 0, $7 = 0, $7$hi = 0, $5 = 0, $35 = 0, $36 = 0, $37 = 0, $42 = 0, $48 = 0, $58 = 0, $62 = 0, $4 = 0, $115 = 0, $115$hi = 0, $118 = 0, $118$hi = 0, $122$hi = 0, $124$hi = 0, $126$hi = 0, $129 = 0, $129$hi = 0, $144 = 0, $150 = 0, $154 = 0, $176 = 0, $180 = 0, $186 = 0, $192 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 32 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] | 0;
  $6 = i64toi32_i32$0;
  $6$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
       i64toi32_i32$2 = i64toi32_i32$1;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 1;
       if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
        break label$5
       }
       i64toi32_i32$2 = $6$hi;
       i64toi32_i32$0 = i64toi32_i32$2;
       cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__ProtocolVersion___deserialize_as_embedded_group__h2c31b2815aa7e5c5($2 + 32 | 0 | 0, $1 | 0, $6 | 0, i64toi32_i32$0 | 0, $6 | 0, i64toi32_i32$0 | 0);
       label$6 : {
        label$7 : {
         label$8 : {
          i64toi32_i32$3 = $6;
          i64toi32_i32$2 = 0;
          i64toi32_i32$1 = 1;
          if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) | 0) {
           break label$8
          }
          cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 128 | 0 | 0, $1 | 0);
          $3 = HEAPU8[($2 + 136 | 0) >> 0] | 0;
          i64toi32_i32$1 = $2;
          i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 128 | 0) >> 2] | 0;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] | 0;
          i64toi32_i32$1 = i64toi32_i32$3;
          i64toi32_i32$3 = 0;
          i64toi32_i32$2 = 1;
          if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) | 0) {
           break label$7
          }
          $1 = 5;
          if (($3 & 255 | 0 | 0) != (5 | 0)) {
           break label$6
          }
         }
         i64toi32_i32$2 = $2 + 72 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $42 = i64toi32_i32$1;
         i64toi32_i32$1 = ($2 + 8 | 0) + 8 | 0;
         HEAP32[i64toi32_i32$1 >> 2] = $42;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$2 = $2 + 80 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $48 = i64toi32_i32$0;
         i64toi32_i32$0 = ($2 + 8 | 0) + 16 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $48;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         HEAP32[(($2 + 128 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 100 | 0) >> 2] | 0;
         i64toi32_i32$2 = $2 + 64 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $58 = i64toi32_i32$1;
         i64toi32_i32$1 = $2;
         HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $58;
         HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$2 = i64toi32_i32$1 + 92 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $62 = i64toi32_i32$0;
         i64toi32_i32$0 = $2;
         HEAP32[(i64toi32_i32$0 + 128 | 0) >> 2] = $62;
         HEAP32[(i64toi32_i32$0 + 132 | 0) >> 2] = i64toi32_i32$1;
         $1 = HEAP32[((i64toi32_i32$0 + 32 | 0) + 8 | 0) >> 2] | 0;
         if ((HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] | 0 | 0) != (1 | 0)) {
          break label$4
         }
         $3 = $1 & -256 | 0;
         i64toi32_i32$2 = $2 + 56 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $7 = i64toi32_i32$1;
         $7$hi = i64toi32_i32$0;
         i64toi32_i32$2 = ($2 + 32 | 0) + 16 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $6 = i64toi32_i32$0;
         $6$hi = i64toi32_i32$1;
         $4 = HEAP32[($2 + 44 | 0) >> 2] | 0;
         $5 = HEAP32[($2 + 88 | 0) >> 2] | 0;
         break label$2;
        }
        i64toi32_i32$2 = $2 + 160 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $6 = i64toi32_i32$1;
        $6$hi = i64toi32_i32$0;
        i64toi32_i32$1 = ($2 + 104 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $6;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = $2 + 168 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $7 = i64toi32_i32$0;
        $7$hi = i64toi32_i32$1;
        i64toi32_i32$0 = ($2 + 104 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $7;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$1 = $6$hi;
        i64toi32_i32$0 = ($2 + 8 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $6;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$1 = $7$hi;
        i64toi32_i32$0 = ($2 + 8 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $7;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$2 = $2 + 152 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $6 = i64toi32_i32$1;
        $6$hi = i64toi32_i32$0;
        i64toi32_i32$1 = $2;
        HEAP32[(i64toi32_i32$1 + 104 | 0) >> 2] = $6;
        HEAP32[(i64toi32_i32$1 + 108 | 0) >> 2] = i64toi32_i32$0;
        HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $6;
        HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = i64toi32_i32$1;
        i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 137 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 138 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 139 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 140 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$1 = 0;
        $115 = i64toi32_i32$0;
        $115$hi = i64toi32_i32$1;
        i64toi32_i32$2 = i64toi32_i32$2 + 141 | 0;
        i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
        i64toi32_i32$0 = 0;
        $118 = i64toi32_i32$1;
        $118$hi = i64toi32_i32$0;
        i64toi32_i32$2 = $2 + 143 | 0;
        i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
        i64toi32_i32$1 = 0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 16;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
         $35 = 0;
        } else {
         i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
         $35 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        }
        $122$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $118$hi;
        i64toi32_i32$1 = $118;
        i64toi32_i32$2 = $122$hi;
        i64toi32_i32$3 = $35;
        i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
        i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 32;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
         $36 = 0;
        } else {
         i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
         $36 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        }
        $124$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $115$hi;
        i64toi32_i32$2 = $115;
        i64toi32_i32$0 = $124$hi;
        i64toi32_i32$3 = $36;
        i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
        i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
        i64toi32_i32$2 = 0;
        i64toi32_i32$3 = 8;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
         $37 = 0;
        } else {
         i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
         $37 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        }
        $126$hi = i64toi32_i32$2;
        i64toi32_i32$2 = 0;
        i64toi32_i32$0 = $3;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 255;
        i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
        $129 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
        $129$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $126$hi;
        i64toi32_i32$2 = $37;
        i64toi32_i32$0 = $129$hi;
        i64toi32_i32$3 = $129;
        i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
        $6 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
        $6$hi = i64toi32_i32$0;
        i64toi32_i32$1 = ($2 + 128 | 0) + 16 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
        $7 = i64toi32_i32$0;
        $7$hi = i64toi32_i32$2;
        $1 = 2;
       }
       label$9 : {
        if (!(HEAP32[($2 + 32 | 0) >> 2] | 0)) {
         break label$9
        }
        core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9($2 + 40 | 0 | 0);
       }
       $3 = 0;
       break label$3;
      }
      i64toi32_i32$1 = $2 + 64 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $144 = i64toi32_i32$2;
      i64toi32_i32$2 = $2 + 16 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $144;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$1 = $2 + 72 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $150 = i64toi32_i32$0;
      i64toi32_i32$0 = ($2 + 8 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $150;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$1 = $2 + 56 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $154 = i64toi32_i32$2;
      i64toi32_i32$2 = $2;
      HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $154;
      HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$1 = (i64toi32_i32$2 + 32 | 0) + 16 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $7 = i64toi32_i32$0;
      $7$hi = i64toi32_i32$2;
      $3 = 0;
      $1 = 2;
      break label$3;
     }
     HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($2 + 36 | 0) >> 2] | 0;
     HEAP32[($0 + 8 | 0) >> 2] = $1;
     $1 = 0;
     break label$1;
    }
    $5 = 0;
   }
   i64toi32_i32$2 = $7$hi;
   i64toi32_i32$0 = ($2 + 32 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $7;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$2 = $6$hi;
   i64toi32_i32$0 = ($2 + 32 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $6;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$1 = $2;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] | 0;
   $176 = i64toi32_i32$2;
   i64toi32_i32$2 = i64toi32_i32$1 + 56 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $176;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 128 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] | 0;
   $180 = i64toi32_i32$0;
   i64toi32_i32$0 = i64toi32_i32$1 + 84 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $180;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$1 = (i64toi32_i32$1 + 8 | 0) + 8 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $186 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 64 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $186;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$1 = ($2 + 8 | 0) + 16 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $192 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 72 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $192;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   HEAP32[($2 + 92 | 0) >> 2] = HEAP32[(($2 + 128 | 0) + 8 | 0) >> 2] | 0;
   HEAP32[($2 + 36 | 0) >> 2] = $4;
   HEAP32[($2 + 80 | 0) >> 2] = $5;
   HEAP32[($2 + 32 | 0) >> 2] = $1 & 255 | 0 | $3 | 0;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 32 | 0 | 0, 1052148 | 0, 15 | 0);
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function hashbrown__raw__RawTable_T_2cA___resize__hecbd0329c16f7177($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $5 = 0, $11 = 0, $6 = 0, $15$hi = 0, $15 = 0, $7 = 0, $9 = 0, i64toi32_i32$4 = 0, $16 = 0, i64toi32_i32$3 = 0, $12 = 0, $16$hi = 0, $32 = 0, $13 = 0, $33 = 0, $10 = 0, $34 = 0, $78 = 0, $81$hi = 0, $83 = 0, $8 = 0, $14 = 0, $200 = 0, $205 = 0, $208 = 0, $219 = 0, $228 = 0;
  $5 = global$0 - 80 | 0;
  global$0 = $5;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ($2) {
        break label$5
       }
       i64toi32_i32$0 = 0;
       $15 = 0;
       $15$hi = i64toi32_i32$0;
       $4 = 0;
       $6 = hashbrown__raw__generic__Group__static_empty__hc5a7932fe1bdb1f1() | 0;
       break label$4;
      }
      label$6 : {
       label$7 : {
        if ($2 >>> 0 < 8 >>> 0) {
         break label$7
        }
        label$8 : {
         if (($2 & 536870911 | 0 | 0) != ($2 | 0)) {
          break label$8
         }
         $2 = (-1 >>> Math_clz32(((($2 << 3 | 0) >>> 0) / (7 >>> 0) | 0) + -1 | 0) | 0) + 1 | 0;
         break label$6;
        }
        hashbrown__raw__Fallibility__capacity_overflow__hd790516fe6877097($5 + 8 | 0 | 0, $4 | 0);
        $6 = HEAP32[($5 + 12 | 0) >> 2] | 0;
        $2 = HEAP32[($5 + 8 | 0) >> 2] | 0;
        break label$3;
       }
       $2 = $2 >>> 0 < 4 >>> 0 ? 4 : 8;
      }
      hashbrown__raw__RawTableInner_A___new_uninitialized__h43f4df636ea4ff18($5 + 56 | 0 | 0, 24 | 0, 4 | 0, $2 | 0, $4 | 0);
      $6 = HEAP32[($5 + 64 | 0) >> 2] | 0;
      $2 = HEAP32[($5 + 60 | 0) >> 2] | 0;
      if ((HEAP32[($5 + 56 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      $4 = HEAP32[($5 + 68 | 0) >> 2] | 0;
      memset($6 | 0, 255 | 0, $2 + 5 | 0 | 0) | 0;
      i64toi32_i32$0 = 0;
      $15 = $2;
      $15$hi = i64toi32_i32$0;
     }
     $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
     HEAP32[($5 + 36 | 0) >> 2] = $2;
     HEAP32[(($5 + 16 | 0) + 16 | 0) >> 2] = $4 - $2 | 0;
     i64toi32_i32$1 = $5;
     i64toi32_i32$0 = 4;
     HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = 24;
     HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
     $78 = i64toi32_i32$1;
     i64toi32_i32$0 = 0;
     i64toi32_i32$2 = $6;
     i64toi32_i32$1 = 0;
     i64toi32_i32$3 = 32;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
      $34 = 0;
     } else {
      i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
      $34 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
     }
     $81$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $15$hi;
     i64toi32_i32$1 = $81$hi;
     i64toi32_i32$0 = $34;
     i64toi32_i32$2 = $15$hi;
     i64toi32_i32$3 = $15;
     i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
     $83 = i64toi32_i32$0 | $15 | 0;
     i64toi32_i32$0 = $78;
     HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = $83;
     HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = i64toi32_i32$2;
     $7 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $4 = $7 + 4 | 0;
     $8 = ((HEAP32[$1 >> 2] | 0) + $7 | 0) + 1 | 0;
     $9 = ((HEAP32[$7 >> 2] | 0) ^ -1 | 0) & -2139062144 | 0;
     i64toi32_i32$2 = $15$hi;
     $10 = $15;
     label$9 : while (1) {
      label$10 : {
       if ($9) {
        break label$10
       }
       label$11 : while (1) {
        if ($4 >>> 0 >= $8 >>> 0) {
         break label$2
        }
        $7 = $7 + -96 | 0;
        $2 = HEAP32[$4 >> 2] | 0;
        $11 = $4 + 4 | 0;
        $4 = $11;
        $2 = $2 & -2139062144 | 0;
        if (($2 | 0) == (-2139062144 | 0)) {
         continue label$11
        }
        break label$11;
       };
       $9 = $2 ^ -2139062144 | 0;
       $4 = $11;
      }
      label$12 : {
       i64toi32_i32$2 = $15$hi;
       $12 = ($7 + Math_imul(0 - ((__wasm_ctz_i32($9 | 0) | 0) >>> 3 | 0) | 0, 24) | 0) + -24 | 0;
       i64toi32_i32$2 = hashbrown__map__make_hash__hea8f199bb15af0f7($3 | 0, $12 | 0) | 0;
       i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
       $16 = i64toi32_i32$2;
       $16$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $15$hi;
       i64toi32_i32$1 = $15;
       i64toi32_i32$2 = $16$hi;
       i64toi32_i32$3 = $16;
       i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
       $11 = i64toi32_i32$1 & $16 | 0;
       $32 = $6 + $11 | 0;
       $13 = (HEAPU8[$32 >> 0] | 0 | ((HEAPU8[($32 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($32 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($32 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
       if ($13) {
        break label$12
       }
       $2 = 4;
       label$13 : while (1) {
        $11 = $11 + $2 | 0;
        $2 = $2 + 4 | 0;
        $11 = $11 & $10 | 0;
        $33 = $6 + $11 | 0;
        $13 = (HEAPU8[$33 >> 0] | 0 | ((HEAPU8[($33 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($33 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($33 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
        if (!$13) {
         continue label$13
        }
        break label$13;
       };
      }
      $14 = $9 + -1 | 0;
      label$14 : {
       $2 = (((__wasm_ctz_i32($13 | 0) | 0) >>> 3 | 0) + $11 | 0) & $10 | 0;
       if ((HEAP8[($6 + $2 | 0) >> 0] | 0 | 0) <= (-1 | 0)) {
        break label$14
       }
       $2 = (__wasm_ctz_i32((HEAP32[$6 >> 2] | 0) & -2139062144 | 0 | 0) | 0) >>> 3 | 0;
      }
      $9 = $14 & $9 | 0;
      i64toi32_i32$2 = $16$hi;
      $11 = $16 >>> 25 | 0;
      HEAP8[($6 + $2 | 0) >> 0] = $11;
      HEAP8[(((($2 + -4 | 0) & $10 | 0) + $6 | 0) + 4 | 0) >> 0] = $11;
      $2 = ($6 + Math_imul(0 - $2 | 0, 24) | 0) + -24 | 0;
      i64toi32_i32$0 = $12 + 16 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
      $200 = i64toi32_i32$2;
      i64toi32_i32$2 = $2 + 16 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $200;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$0 = $12 + 8 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
      $205 = i64toi32_i32$1;
      i64toi32_i32$1 = $2 + 8 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $205;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$0 = $12;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
      $208 = i64toi32_i32$2;
      i64toi32_i32$2 = $2;
      HEAP32[i64toi32_i32$2 >> 2] = $208;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      continue label$9;
     };
    }
    HEAP32[($0 + 4 | 0) >> 2] = $2;
    HEAP32[$0 >> 2] = 1;
    HEAP32[($0 + 8 | 0) >> 2] = $6;
    break label$1;
   }
   i64toi32_i32$0 = $1;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $16 = i64toi32_i32$1;
   $16$hi = i64toi32_i32$2;
   i64toi32_i32$0 = $5;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] | 0;
   $219 = i64toi32_i32$2;
   i64toi32_i32$2 = $1;
   HEAP32[i64toi32_i32$2 >> 2] = $219;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   $2 = i64toi32_i32$0 + 32 | 0;
   i64toi32_i32$0 = $2;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $15 = i64toi32_i32$1;
   $15$hi = i64toi32_i32$2;
   $4 = $1 + 8 | 0;
   i64toi32_i32$0 = $4;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $228 = i64toi32_i32$2;
   i64toi32_i32$2 = $2;
   HEAP32[i64toi32_i32$2 >> 2] = $228;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $15$hi;
   i64toi32_i32$2 = i64toi32_i32$0;
   HEAP32[i64toi32_i32$2 >> 2] = $15;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $16$hi;
   i64toi32_i32$2 = $5;
   HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] = $16;
   HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[$0 >> 2] = 0;
   core__ptr__drop_in_place_hashbrown__scopeguard__ScopeGuard_hashbrown__raw__RawTableInner_alloc__alloc__Global__2chashbrown__raw__RawTableInner_alloc__alloc__Global___prepare_resize___7b_7bclosure_7d_7d____hf09be25679474fda(i64toi32_i32$2 + 16 | 0 | 0);
  }
  global$0 = $5 + 80 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__TransactionInput___deserialize__h84b981706980e1e2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $4 = 0, $4$hi = 0, $3 = 0, $32 = 0, $33 = 0, $5 = 0, $5$hi = 0, $6 = 0, $6$hi = 0, $34 = 0, $35 = 0, $36 = 0, $37 = 0, $38 = 0, $39 = 0, $40 = 0, $42 = 0, $41 = 0, $59 = 0, $63 = 0, $105 = 0, $105$hi = 0, $108 = 0, $108$hi = 0, $112$hi = 0, $114$hi = 0, $116$hi = 0, $119 = 0, $119$hi = 0, $136 = 0, $140 = 0, $183 = 0, $187 = 0, $193 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 24 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
       i64toi32_i32$2 = i64toi32_i32$1;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 1;
       if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
        break label$5
       }
       i64toi32_i32$2 = $4$hi;
       i64toi32_i32$0 = i64toi32_i32$2;
       cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__TransactionInput___deserialize_as_embedded_group__h2a795770225d25a6($2 + 24 | 0 | 0, $1 | 0, $4 | 0, i64toi32_i32$2 | 0, $4 | 0, i64toi32_i32$2 | 0);
       label$6 : {
        label$7 : {
         label$8 : {
          i64toi32_i32$0 = i64toi32_i32$2;
          i64toi32_i32$0 = i64toi32_i32$2;
          i64toi32_i32$3 = $4;
          i64toi32_i32$2 = 0;
          i64toi32_i32$1 = 1;
          if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) | 0) {
           break label$8
          }
          cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 112 | 0 | 0, $1 | 0);
          $3 = HEAPU8[($2 + 120 | 0) >> 0] | 0;
          i64toi32_i32$1 = $2;
          i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 112 | 0) >> 2] | 0;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 116 | 0) >> 2] | 0;
          i64toi32_i32$1 = i64toi32_i32$3;
          i64toi32_i32$3 = 0;
          i64toi32_i32$2 = 1;
          if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) | 0) {
           break label$7
          }
          $1 = 5;
          if (($3 & 255 | 0 | 0) != (5 | 0)) {
           break label$6
          }
         }
         i64toi32_i32$2 = $2 + 72 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $41 = i64toi32_i32$1;
         i64toi32_i32$1 = ($2 + 8 | 0) + 8 | 0;
         HEAP32[i64toi32_i32$1 >> 2] = $41;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
         HEAP32[(($2 + 112 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 92 | 0) >> 2] | 0;
         HEAP32[($2 + 96 | 0) >> 2] = HEAPU8[($2 + 33 | 0) >> 0] | 0 | ((HEAPU8[($2 + 34 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 35 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 36 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $32 = ($2 + 24 | 0) + 12 | 0;
         $33 = HEAPU8[$32 >> 0] | 0 | ((HEAPU8[($32 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($32 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($32 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[($2 + 99 | 0) >> 0] = $33;
         HEAP8[($2 + 100 | 0) >> 0] = $33 >>> 8 | 0;
         HEAP8[($2 + 101 | 0) >> 0] = $33 >>> 16 | 0;
         HEAP8[($2 + 102 | 0) >> 0] = $33 >>> 24 | 0;
         i64toi32_i32$2 = $2 + 64 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $59 = i64toi32_i32$0;
         i64toi32_i32$0 = $2;
         HEAP32[($2 + 8 | 0) >> 2] = $59;
         HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$2 = $2 + 84 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $63 = i64toi32_i32$1;
         i64toi32_i32$1 = $2;
         HEAP32[(i64toi32_i32$1 + 112 | 0) >> 2] = $63;
         HEAP32[(i64toi32_i32$1 + 116 | 0) >> 2] = i64toi32_i32$0;
         $1 = HEAPU8[((i64toi32_i32$1 + 24 | 0) + 8 | 0) >> 0] | 0;
         i64toi32_i32$2 = (i64toi32_i32$1 + 24 | 0) + 16 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $4 = i64toi32_i32$0;
         $4$hi = i64toi32_i32$1;
         i64toi32_i32$2 = ($2 + 24 | 0) + 24 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $5 = i64toi32_i32$1;
         $5$hi = i64toi32_i32$0;
         i64toi32_i32$2 = ($2 + 24 | 0) + 32 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $6 = i64toi32_i32$0;
         $6$hi = i64toi32_i32$1;
         if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
          break label$4
         }
         $3 = HEAP32[($2 + 80 | 0) >> 2] | 0;
         break label$2;
        }
        i64toi32_i32$2 = $2 + 152 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $4 = i64toi32_i32$1;
        $4$hi = i64toi32_i32$0;
        i64toi32_i32$1 = ($2 + 96 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $4;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$1 = ($2 + 8 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $4;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = $2 + 144 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $4 = i64toi32_i32$0;
        $4$hi = i64toi32_i32$1;
        i64toi32_i32$0 = $2;
        HEAP32[($2 + 96 | 0) >> 2] = $4;
        HEAP32[($2 + 100 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$0 = $2;
        HEAP32[($2 + 8 | 0) >> 2] = $4;
        HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$2 = $2;
        i64toi32_i32$1 = HEAPU8[($2 + 121 | 0) >> 0] | 0 | ((HEAPU8[($2 + 122 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 123 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 124 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$0 = 0;
        $105 = i64toi32_i32$1;
        $105$hi = i64toi32_i32$0;
        i64toi32_i32$2 = $2 + 125 | 0;
        i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
        i64toi32_i32$1 = 0;
        $108 = i64toi32_i32$0;
        $108$hi = i64toi32_i32$1;
        i64toi32_i32$2 = $2 + 127 | 0;
        i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$2 = i64toi32_i32$1;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 16;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
         $39 = 0;
        } else {
         i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
         $39 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        }
        $112$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $108$hi;
        i64toi32_i32$0 = $108;
        i64toi32_i32$2 = $112$hi;
        i64toi32_i32$3 = $39;
        i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
        i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 32;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
         $40 = 0;
        } else {
         i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
         $40 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        }
        $114$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $105$hi;
        i64toi32_i32$2 = $105;
        i64toi32_i32$1 = $114$hi;
        i64toi32_i32$3 = $40;
        i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
        i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
        i64toi32_i32$2 = 0;
        i64toi32_i32$3 = 8;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
         $42 = 0;
        } else {
         i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
         $42 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        }
        $116$hi = i64toi32_i32$2;
        i64toi32_i32$2 = 0;
        i64toi32_i32$1 = $3;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 255;
        i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
        $119 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
        $119$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $116$hi;
        i64toi32_i32$2 = $42;
        i64toi32_i32$1 = $119$hi;
        i64toi32_i32$3 = $119;
        i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
        $4 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
        $4$hi = i64toi32_i32$1;
        i64toi32_i32$0 = $2 + 136 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
        $6 = i64toi32_i32$1;
        $6$hi = i64toi32_i32$2;
        i64toi32_i32$0 = $2 + 128 | 0;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
        $5 = i64toi32_i32$2;
        $5$hi = i64toi32_i32$1;
        $1 = 2;
       }
       if (!(HEAP32[($2 + 24 | 0) >> 2] | 0)) {
        break label$3
       }
       core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9($2 + 32 | 0 | 0);
       break label$3;
      }
      i64toi32_i32$0 = $2 + 64 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
      $136 = i64toi32_i32$1;
      i64toi32_i32$1 = $2 + 16 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $136;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$0 = $2 + 56 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
      $140 = i64toi32_i32$2;
      i64toi32_i32$2 = $2;
      HEAP32[($2 + 8 | 0) >> 2] = $140;
      HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$0 = $2 + 48 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
      $6 = i64toi32_i32$1;
      $6$hi = i64toi32_i32$2;
      i64toi32_i32$0 = $2 + 40 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
      $5 = i64toi32_i32$2;
      $5$hi = i64toi32_i32$1;
      $1 = 2;
      break label$3;
     }
     HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
     $34 = HEAP32[($2 + 96 | 0) >> 2] | 0;
     HEAP8[($0 + 9 | 0) >> 0] = $34;
     HEAP8[($0 + 10 | 0) >> 0] = $34 >>> 8 | 0;
     HEAP8[($0 + 11 | 0) >> 0] = $34 >>> 16 | 0;
     HEAP8[($0 + 12 | 0) >> 0] = $34 >>> 24 | 0;
     HEAP8[($0 + 8 | 0) >> 0] = $1;
     $35 = $0 + 12 | 0;
     $36 = HEAPU8[($2 + 99 | 0) >> 0] | 0 | ((HEAPU8[($2 + 100 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 101 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 102 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[$35 >> 0] = $36;
     HEAP8[($35 + 1 | 0) >> 0] = $36 >>> 8 | 0;
     HEAP8[($35 + 2 | 0) >> 0] = $36 >>> 16 | 0;
     HEAP8[($35 + 3 | 0) >> 0] = $36 >>> 24 | 0;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$2 = $0 + 32 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $6;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $5$hi;
     i64toi32_i32$2 = $0 + 24 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $5;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $4$hi;
     i64toi32_i32$2 = $0 + 16 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $4;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     $1 = 0;
     break label$1;
    }
    $3 = 0;
   }
   i64toi32_i32$1 = $6$hi;
   i64toi32_i32$2 = $2 + 48 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $6;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $5$hi;
   i64toi32_i32$2 = ($2 + 24 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $5;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $4$hi;
   i64toi32_i32$2 = ($2 + 24 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $4;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$0 = $2;
   i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $183 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 56 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $183;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = $2;
   i64toi32_i32$2 = HEAP32[($2 + 112 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 116 | 0) >> 2] | 0;
   $187 = i64toi32_i32$2;
   i64toi32_i32$2 = $2 + 76 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $187;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$0 = ($2 + 8 | 0) + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $193 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 64 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $193;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
   HEAP32[($2 + 84 | 0) >> 2] = HEAP32[(($2 + 112 | 0) + 8 | 0) >> 2] | 0;
   HEAP8[($2 + 24 | 0) >> 0] = $1;
   $37 = HEAP32[($2 + 96 | 0) >> 2] | 0;
   HEAP8[($2 + 25 | 0) >> 0] = $37;
   HEAP8[($2 + 26 | 0) >> 0] = $37 >>> 8 | 0;
   HEAP8[($2 + 27 | 0) >> 0] = $37 >>> 16 | 0;
   HEAP8[($2 + 28 | 0) >> 0] = $37 >>> 24 | 0;
   $38 = HEAPU8[($2 + 99 | 0) >> 0] | 0 | ((HEAPU8[($2 + 100 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 101 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 102 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[($2 + 28 | 0) >> 0] = $38;
   HEAP8[($2 + 29 | 0) >> 0] = $38 >>> 8 | 0;
   HEAP8[($2 + 30 | 0) >> 0] = $38 >>> 16 | 0;
   HEAP8[($2 + 31 | 0) >> 0] = $38 >>> 24 | 0;
   HEAP32[($2 + 72 | 0) >> 2] = $3;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 24 | 0 | 0, 1050602 | 0, 16 | 0);
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 160 | 0;
 }
 
 function cardano_serialization_lib__PoolRegistration__new__ha06a92da84e1c24a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $3 = 0, $52 = 0, $53 = 0, $54 = 0, $55 = 0, $56 = 0, $57 = 0, $59 = 0, $60 = 0, $61 = 0, $62 = 0, $63 = 0, $64 = 0, $66 = 0, $67 = 0, $69 = 0, $70 = 0, $4 = 0, $5 = 0, $6 = 0, $7 = 0, $8 = 0, $10 = 0, $11 = 0, $12 = 0, $34 = 0, $41 = 0, $44 = 0, $51 = 0, $58 = 0, $65 = 0, $68 = 0, $14 = 0, $14$hi = 0, $15 = 0, $15$hi = 0, $16 = 0, $16$hi = 0, $17 = 0, $17$hi = 0, $9 = 0, $86 = 0, $93 = 0, $104 = 0, $13 = 0, $126 = 0, $131 = 0, $136 = 0, $140 = 0, $151 = 0, $154 = 0, $158 = 0, $166 = 0, $170 = 0, $174 = 0, $178 = 0, $182 = 0, $186 = 0, $190 = 0, $203 = 0, $214 = 0, $231 = 0;
  $2 = global$0 - 256 | 0;
  global$0 = $2;
  $3 = ($2 + 8 | 0) + 24 | 0;
  $52 = $1 + 124 | 0;
  HEAP32[$3 >> 2] = HEAPU8[$52 >> 0] | 0 | ((HEAPU8[($52 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($52 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($52 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $4 = ($2 + 8 | 0) + 16 | 0;
  i64toi32_i32$2 = $1 + 116 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $34 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[i64toi32_i32$0 >> 2] = $34;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $5 = ($2 + 8 | 0) + 8 | 0;
  i64toi32_i32$2 = $1 + 108 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $41 = i64toi32_i32$1;
  i64toi32_i32$1 = $5;
  HEAP32[i64toi32_i32$1 >> 2] = $41;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 100 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 101 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 102 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 103 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 104 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 105 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 106 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 107 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $44 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $44;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
  $6 = (i64toi32_i32$0 + 40 | 0) + 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 152 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $51 = i64toi32_i32$1;
  i64toi32_i32$1 = $6;
  HEAP32[i64toi32_i32$1 >> 2] = $51;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $7 = ($2 + 40 | 0) + 16 | 0;
  i64toi32_i32$2 = $1 + 144 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $58 = i64toi32_i32$0;
  i64toi32_i32$0 = $7;
  HEAP32[i64toi32_i32$0 >> 2] = $58;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $8 = ($2 + 40 | 0) + 8 | 0;
  i64toi32_i32$2 = $1 + 136 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $65 = i64toi32_i32$1;
  i64toi32_i32$1 = $8;
  HEAP32[i64toi32_i32$1 >> 2] = $65;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 128 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 129 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 130 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 131 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 132 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 133 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 134 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 135 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $68 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[(i64toi32_i32$0 + 40 | 0) >> 2] = $68;
  HEAP32[(i64toi32_i32$0 + 44 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$2 + 24 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$1;
  $14$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $15 = i64toi32_i32$0;
  $15$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $16 = i64toi32_i32$1;
  $16$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $17 = i64toi32_i32$0;
  $17$hi = i64toi32_i32$1;
  $9 = HEAPU8[(i64toi32_i32$2 + 160 | 0) >> 0] | 0;
  $10 = ($2 + 72 | 0) + 8 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 170 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $86 = i64toi32_i32$1;
  i64toi32_i32$1 = $10;
  HEAP32[i64toi32_i32$1 >> 2] = $86;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $11 = ($2 + 72 | 0) + 16 | 0;
  i64toi32_i32$2 = $1 + 178 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $93 = i64toi32_i32$0;
  i64toi32_i32$0 = $11;
  HEAP32[i64toi32_i32$0 >> 2] = $93;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $12 = ($2 + 72 | 0) + 24 | 0;
  $53 = $1 + 186 | 0;
  HEAP32[$12 >> 2] = HEAPU8[$53 >> 0] | 0 | ((HEAPU8[($53 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($53 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($53 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $1 + 162 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $104 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[(i64toi32_i32$1 + 72 | 0) >> 2] = $104;
  HEAP32[(i64toi32_i32$1 + 76 | 0) >> 2] = i64toi32_i32$0;
  $13 = HEAPU8[($1 + 161 | 0) >> 0] | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h25db889dc58a550d(i64toi32_i32$1 + 104 | 0 | 0, $1 + 32 | 0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h3d33b90cd2011dc4(i64toi32_i32$1 + 120 | 0 | 0, $1 + 44 | 0 | 0);
  label$1 : {
   label$2 : {
    if (HEAP32[($1 + 56 | 0) >> 2] | 0) {
     break label$2
    }
    $1 = 0;
    break label$1;
   }
   $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($2 + 176 | 0 | 0, $1 + 56 | 0 | 0);
   i64toi32_i32$2 = $1 + 92 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $126 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 212 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $126;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1 + 84 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $131 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 204 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $131;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $1 + 76 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $136 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 196 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $136;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1 + 68 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $140 = i64toi32_i32$1;
   i64toi32_i32$1 = $2;
   HEAP32[(i64toi32_i32$1 + 188 | 0) >> 2] = $140;
   HEAP32[(i64toi32_i32$1 + 192 | 0) >> 2] = i64toi32_i32$0;
   $1 = HEAP32[(i64toi32_i32$1 + 176 | 0) >> 2] | 0;
   memcpy(i64toi32_i32$1 + 136 | 0 | 0, i64toi32_i32$1 + 176 | 0 | 4 | 0 | 0, 40 | 0) | 0;
  }
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $151 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  $54 = $151;
  HEAP8[(i64toi32_i32$0 + 100 | 0) >> 0] = $54;
  HEAP8[(i64toi32_i32$0 + 101 | 0) >> 0] = $54 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 102 | 0) >> 0] = $54 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 103 | 0) >> 0] = $54 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 104 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 105 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 106 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 107 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] | 0;
  $154 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  $55 = $154;
  HEAP8[(i64toi32_i32$1 + 128 | 0) >> 0] = $55;
  HEAP8[(i64toi32_i32$1 + 129 | 0) >> 0] = $55 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 130 | 0) >> 0] = $55 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 131 | 0) >> 0] = $55 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 132 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 133 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 134 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 135 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 72 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 76 | 0) >> 2] | 0;
  $158 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 162 | 0;
  $56 = $158;
  HEAP8[i64toi32_i32$0 >> 0] = $56;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $56 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $56 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $56 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $57 = $0 + 124 | 0;
  $59 = HEAP32[$3 >> 2] | 0;
  HEAP8[$57 >> 0] = $59;
  HEAP8[($57 + 1 | 0) >> 0] = $59 >>> 8 | 0;
  HEAP8[($57 + 2 | 0) >> 0] = $59 >>> 16 | 0;
  HEAP8[($57 + 3 | 0) >> 0] = $59 >>> 24 | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $166 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 116 | 0;
  $60 = $166;
  HEAP8[i64toi32_i32$1 >> 0] = $60;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $60 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $60 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $60 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $170 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 108 | 0;
  $61 = $170;
  HEAP8[i64toi32_i32$0 >> 0] = $61;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $61 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $61 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $61 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $8;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $174 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 136 | 0;
  $62 = $174;
  HEAP8[i64toi32_i32$1 >> 0] = $62;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $62 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $62 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $62 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $7;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $178 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 144 | 0;
  $63 = $178;
  HEAP8[i64toi32_i32$0 >> 0] = $63;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $63 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $63 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $63 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $6;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $182 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 152 | 0;
  $64 = $182;
  HEAP8[i64toi32_i32$1 >> 0] = $64;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $64 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $64 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $64 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $10;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $186 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 170 | 0;
  $66 = $186;
  HEAP8[i64toi32_i32$0 >> 0] = $66;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $66 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $66 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $66 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $11;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $190 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 178 | 0;
  $67 = $190;
  HEAP8[i64toi32_i32$1 >> 0] = $67;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $67 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $67 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $67 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $69 = $0 + 186 | 0;
  $70 = HEAP32[$12 >> 2] | 0;
  HEAP8[$69 >> 0] = $70;
  HEAP8[($69 + 1 | 0) >> 0] = $70 >>> 8 | 0;
  HEAP8[($69 + 2 | 0) >> 0] = $70 >>> 16 | 0;
  HEAP8[($69 + 3 | 0) >> 0] = $70 >>> 24 | 0;
  HEAP32[($0 + 40 | 0) >> 2] = HEAP32[(($2 + 104 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 104 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 108 | 0) >> 2] | 0;
  $203 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] = $203;
  HEAP32[(i64toi32_i32$0 + 36 | 0) >> 2] = i64toi32_i32$1;
  $3 = (i64toi32_i32$2 + 176 | 0) + 8 | 0;
  HEAP32[$3 >> 2] = HEAP32[((i64toi32_i32$2 + 120 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 120 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 124 | 0) >> 2] | 0;
  $214 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$2 + 176 | 0) >> 2] = $214;
  HEAP32[(i64toi32_i32$2 + 180 | 0) >> 2] = i64toi32_i32$0;
  memcpy($0 + 60 | 0 | 0, i64toi32_i32$2 + 136 | 0 | 0, 40 | 0) | 0;
  i64toi32_i32$0 = $14$hi;
  i64toi32_i32$1 = $0 + 24 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $14;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $17$hi;
  i64toi32_i32$1 = $0;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $17;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $16$hi;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $16;
  HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $15$hi;
  HEAP32[i64toi32_i32$1 >> 2] = $15;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 176 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 180 | 0) >> 2] | 0;
  $231 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 44 | 0) >> 2] = $231;
  HEAP32[(i64toi32_i32$0 + 48 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 52 | 0) >> 2] = HEAP32[$3 >> 2] | 0;
  HEAP8[(i64toi32_i32$0 + 161 | 0) >> 0] = $13;
  HEAP8[(i64toi32_i32$0 + 160 | 0) >> 0] = $9;
  HEAP32[(i64toi32_i32$0 + 56 | 0) >> 2] = $1;
  global$0 = i64toi32_i32$2 + 256 | 0;
 }
 
 function cryptoxide__curve25519__scalar__scalar64__Scalar__reduce_from_wide_bytes__h35529550345bd5f0($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $2 = 0, $36 = 0, $24 = 0, $36$hi = 0, $24$hi = 0, $27 = 0, $27$hi = 0, $226 = 0, $228 = 0, $229 = 0, $231 = 0, $232 = 0, $234 = 0, $235 = 0, $236 = 0, $237 = 0, $240 = 0, $242 = 0, $244 = 0, $245 = 0, $247 = 0, $248 = 0, $249 = 0, $250 = 0, $254 = 0, $255 = 0, $256 = 0, $258 = 0, $260 = 0, $261 = 0, $262 = 0, $263 = 0, $267 = 0, $268 = 0, $270 = 0, $271 = 0, $273 = 0, $274 = 0, $276 = 0, $277 = 0, $279 = 0, $280 = 0, $281 = 0, $283 = 0, $284 = 0, $285 = 0, $287 = 0, $288 = 0, $289 = 0, $290 = 0, $291 = 0, $292 = 0, $293 = 0, $294 = 0, $295 = 0, $296 = 0, $297 = 0, $298 = 0, $299 = 0, $3 = 0, $3$hi = 0, $4 = 0, $4$hi = 0, $5 = 0, $5$hi = 0, $6 = 0, $6$hi = 0, $7 = 0, $7$hi = 0, $8 = 0, $8$hi = 0, $9 = 0, $9$hi = 0, $10 = 0, $10$hi = 0, $11 = 0, $11$hi = 0, $12 = 0, $12$hi = 0, $13 = 0, $13$hi = 0, $14 = 0, $14$hi = 0, $15 = 0, $15$hi = 0, $16 = 0, $16$hi = 0, $17 = 0, $17$hi = 0, $18 = 0, $18$hi = 0, $19 = 0, $19$hi = 0, $20 = 0, $20$hi = 0, $21 = 0, $21$hi = 0, $22 = 0, $22$hi = 0, $23 = 0, $23$hi = 0, $25 = 0, $25$hi = 0, $26 = 0, $26$hi = 0, $28 = 0, $28$hi = 0, $29 = 0, $29$hi = 0, $30 = 0, $30$hi = 0, $31 = 0, $31$hi = 0, $32 = 0, $32$hi = 0, $33 = 0, $33$hi = 0, $34 = 0, $34$hi = 0, $35 = 0, $35$hi = 0, $37 = 0, $37$hi = 0, $38 = 0, $38$hi = 0, $39 = 0, $39$hi = 0, $40 = 0, $40$hi = 0, $41 = 0, $41$hi = 0, $42 = 0, $42$hi = 0, $43 = 0, $43$hi = 0, $129 = 0, $131 = 0, $131$hi = 0, $134$hi = 0, $136 = 0, $136$hi = 0, $139 = 0, $139$hi = 0, $142$hi = 0, $144$hi = 0, $145 = 0, $146 = 0, $147 = 0, $147$hi = 0, $149$hi = 0, $150 = 0, $150$hi = 0, $152$hi = 0, $153 = 0, $153$hi = 0, $155$hi = 0, $156 = 0, $157 = 0, $159 = 0, $159$hi = 0, $161 = 0, $161$hi = 0, $163$hi = 0, $164 = 0, $164$hi = 0, $166$hi = 0, $168$hi = 0, $169 = 0, $170 = 0, $171 = 0, $171$hi = 0, $172 = 0, $172$hi = 0, $174$hi = 0, $175 = 0, $175$hi = 0, $177$hi = 0, $179$hi = 0, $181 = 0, $182 = 0, $184 = 0, $184$hi = 0, $185 = 0, $185$hi = 0, $187$hi = 0, $188 = 0, $188$hi = 0, $190$hi = 0, $191 = 0, $191$hi = 0, $193$hi = 0, $194 = 0, $194$hi = 0, $196$hi = 0, $199$hi = 0, $200 = 0, $201 = 0, $202 = 0, $202$hi = 0, $204$hi = 0, $206 = 0, $206$hi = 0, $208$hi = 0, $209 = 0, $209$hi = 0, $211$hi = 0, $212 = 0, $212$hi = 0, $214$hi = 0, $215 = 0, $215$hi = 0, $217$hi = 0, $218 = 0, $218$hi = 0, $220$hi = 0, $223 = 0, $225 = 0, $225$hi = 0, $227 = 0, $227$hi = 0, $229$hi = 0, $230 = 0, $230$hi = 0, $232$hi = 0, $233 = 0, $233$hi = 0, $235$hi = 0, $237$hi = 0, $238 = 0, $239 = 0, $241 = 0, $241$hi = 0, $243 = 0, $243$hi = 0, $245$hi = 0, $246 = 0, $246$hi = 0, $248$hi = 0, $250$hi = 0, $251 = 0, $252 = 0, $253 = 0, $253$hi = 0, $255$hi = 0, $257 = 0, $257$hi = 0, $259 = 0, $259$hi = 0, $261$hi = 0, $263$hi = 0, $264 = 0, $265 = 0, $266 = 0, $266$hi = 0, $268$hi = 0, $269 = 0, $269$hi = 0, $271$hi = 0, $272 = 0, $272$hi = 0, $274$hi = 0, $275 = 0, $275$hi = 0, $277$hi = 0, $278 = 0, $278$hi = 0, $280$hi = 0, $282 = 0, $282$hi = 0, $284$hi = 0, $286 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 37 | 0) >> 0] | 0;
  i64toi32_i32$1 = 0;
  $3 = i64toi32_i32$0;
  $3$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 36 | 0) >> 0] | 0;
  i64toi32_i32$0 = 0;
  $4 = i64toi32_i32$1;
  $4$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 35 | 0) >> 0] | 0;
  i64toi32_i32$1 = 0;
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 33 | 0) >> 0] | 0;
  i64toi32_i32$0 = 0;
  $6 = i64toi32_i32$1;
  $6$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 34 | 0) >> 0] | 0;
  i64toi32_i32$1 = 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 40 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 41 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 42 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 43 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = 0;
  $8 = i64toi32_i32$1;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 44 | 0) >> 0] | 0;
  i64toi32_i32$1 = 0;
  $9 = i64toi32_i32$0;
  $9$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 39 | 0) >> 0] | 0;
  i64toi32_i32$0 = 0;
  $10 = i64toi32_i32$1;
  $10$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 38 | 0) >> 0] | 0;
  i64toi32_i32$1 = 0;
  $11 = i64toi32_i32$0;
  $11$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 48 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 49 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 50 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 51 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = 0;
  $12 = i64toi32_i32$1;
  $12$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 47 | 0) >> 0] | 0;
  i64toi32_i32$1 = 0;
  $13 = i64toi32_i32$0;
  $13$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 45 | 0) >> 0] | 0;
  i64toi32_i32$0 = 0;
  $14 = i64toi32_i32$1;
  $14$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 46 | 0) >> 0] | 0;
  i64toi32_i32$1 = 0;
  $15 = i64toi32_i32$0;
  $15$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 55 | 0) >> 0] | 0;
  i64toi32_i32$0 = 0;
  $16 = i64toi32_i32$1;
  $16$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 54 | 0) >> 0] | 0;
  i64toi32_i32$1 = 0;
  $17 = i64toi32_i32$0;
  $17$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 52 | 0) >> 0] | 0;
  i64toi32_i32$0 = 0;
  $18 = i64toi32_i32$1;
  $18$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 53 | 0) >> 0] | 0;
  i64toi32_i32$1 = 0;
  $19 = i64toi32_i32$0;
  $19$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 63 | 0) >> 0] | 0;
  i64toi32_i32$0 = 0;
  $20 = i64toi32_i32$1;
  $20$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 62 | 0) >> 0] | 0;
  i64toi32_i32$1 = 0;
  $21 = i64toi32_i32$0;
  $21$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 61 | 0) >> 0] | 0;
  i64toi32_i32$0 = 0;
  $22 = i64toi32_i32$1;
  $22$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 60 | 0) >> 0] | 0;
  i64toi32_i32$1 = 0;
  $23 = i64toi32_i32$0;
  $23$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 56 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 57 | 0) >> 0] | 0) << 8 | 0) | 0;
  i64toi32_i32$0 = 0;
  $24 = i64toi32_i32$1;
  $24$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 58 | 0) >> 0] | 0;
  i64toi32_i32$1 = 0;
  $25 = i64toi32_i32$0;
  $25$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 59 | 0) >> 0] | 0;
  i64toi32_i32$0 = 0;
  $26 = i64toi32_i32$1;
  $26$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 32 | 0) >> 0] | 0;
  i64toi32_i32$1 = 0;
  $27 = i64toi32_i32$0;
  $27$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 31 | 0) >> 0] | 0;
  i64toi32_i32$0 = 0;
  $28 = i64toi32_i32$1;
  $28$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 30 | 0) >> 0] | 0;
  i64toi32_i32$1 = 0;
  $29 = i64toi32_i32$0;
  $29$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 28 | 0) >> 0] | 0;
  i64toi32_i32$0 = 0;
  $30 = i64toi32_i32$1;
  $30$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 29 | 0) >> 0] | 0;
  i64toi32_i32$1 = 0;
  $31 = i64toi32_i32$0;
  $31$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0;
  i64toi32_i32$0 = 0;
  $32 = i64toi32_i32$1;
  $32$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 9 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 10 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 11 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = 0;
  $33 = i64toi32_i32$0;
  $33$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 12 | 0) >> 0] | 0;
  i64toi32_i32$0 = 0;
  $34 = i64toi32_i32$1;
  $34$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 13 | 0) >> 0] | 0;
  i64toi32_i32$1 = 0;
  $35 = i64toi32_i32$0;
  $35$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 24 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 25 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 26 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 27 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = 0;
  $36 = i64toi32_i32$1;
  $36$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 23 | 0) >> 0] | 0;
  i64toi32_i32$1 = 0;
  $37 = i64toi32_i32$0;
  $37$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 21 | 0) >> 0] | 0;
  i64toi32_i32$0 = 0;
  $38 = i64toi32_i32$1;
  $38$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 22 | 0) >> 0] | 0;
  i64toi32_i32$1 = 0;
  $39 = i64toi32_i32$0;
  $39$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0;
  i64toi32_i32$0 = 0;
  $40 = i64toi32_i32$1;
  $40$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = 0;
  $41 = i64toi32_i32$0;
  $41$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0;
  i64toi32_i32$0 = 0;
  $42 = i64toi32_i32$1;
  $42$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0;
  i64toi32_i32$1 = 0;
  $43 = i64toi32_i32$0;
  $43$hi = i64toi32_i32$1;
  $129 = $2;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 16 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 17 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 18 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 19 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = 0;
  $131 = i64toi32_i32$1;
  $131$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 20 | 0) >> 0] | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $226 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $226 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $134$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $131$hi;
  i64toi32_i32$1 = $131;
  i64toi32_i32$2 = $134$hi;
  i64toi32_i32$3 = $226;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 16;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   $228 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
   $228 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
  }
  $136 = $228;
  $136$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 15 | 0) >> 0] | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $229 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $229 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $139 = $229;
  $139$hi = i64toi32_i32$1;
  i64toi32_i32$0 = $1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 14 | 0) >> 0] | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 48;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   $231 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
   $231 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
  }
  $142$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $139$hi;
  i64toi32_i32$2 = $139;
  i64toi32_i32$0 = $142$hi;
  i64toi32_i32$3 = $231;
  i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 48;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $232 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $232 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
  }
  $144$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $136$hi;
  i64toi32_i32$0 = $136;
  i64toi32_i32$1 = $144$hi;
  i64toi32_i32$3 = $232;
  i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
  $145 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $129;
  HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $145;
  HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$1;
  $146 = $2;
  i64toi32_i32$1 = $41$hi;
  $147 = $41;
  $147$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $42$hi;
  i64toi32_i32$2 = $42;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $234 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $234 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $149$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $147$hi;
  i64toi32_i32$1 = $147;
  i64toi32_i32$2 = $149$hi;
  i64toi32_i32$3 = $234;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  $150 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  $150$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $43$hi;
  i64toi32_i32$0 = $43;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 40;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   $235 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
   $235 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
  }
  $152$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $150$hi;
  i64toi32_i32$2 = $150;
  i64toi32_i32$0 = $152$hi;
  i64toi32_i32$3 = $235;
  i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
  $153 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  $153$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $40$hi;
  i64toi32_i32$1 = $40;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 48;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
   $236 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $236 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
  }
  $155$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $153$hi;
  i64toi32_i32$0 = $153;
  i64toi32_i32$1 = $155$hi;
  i64toi32_i32$3 = $236;
  i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
  $156 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $146;
  HEAP32[i64toi32_i32$0 >> 2] = $156;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $157 = $2;
  i64toi32_i32$1 = $36$hi;
  i64toi32_i32$2 = $36;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 24;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $237 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $237 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $159 = $237;
  $159$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $38$hi;
  i64toi32_i32$1 = $38;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 40;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
   $240 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $240 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
  }
  $161 = $240;
  $161$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $39$hi;
  i64toi32_i32$0 = $39;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 48;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   $242 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
   $242 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
  }
  $163$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $161$hi;
  i64toi32_i32$2 = $161;
  i64toi32_i32$0 = $163$hi;
  i64toi32_i32$3 = $242;
  i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
  $164 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  $164$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $37$hi;
  i64toi32_i32$1 = $37;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
   $244 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $244 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
  }
  $166$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $164$hi;
  i64toi32_i32$0 = $164;
  i64toi32_i32$1 = $166$hi;
  i64toi32_i32$3 = $244;
  i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 40;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $245 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   $245 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  $168$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $159$hi;
  i64toi32_i32$1 = $159;
  i64toi32_i32$2 = $168$hi;
  i64toi32_i32$3 = $245;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  $169 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $157;
  HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = $169;
  HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = i64toi32_i32$2;
  $170 = $2;
  i64toi32_i32$2 = $32$hi;
  $171 = $32;
  $171$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $33$hi;
  $172 = $33;
  $172$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $34$hi;
  i64toi32_i32$0 = $34;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   $247 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
   $247 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
  }
  $174$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $172$hi;
  i64toi32_i32$2 = $172;
  i64toi32_i32$0 = $174$hi;
  i64toi32_i32$3 = $247;
  i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
  $175 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  $175$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $35$hi;
  i64toi32_i32$1 = $35;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 40;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
   $248 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $248 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
  }
  $177$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $175$hi;
  i64toi32_i32$0 = $175;
  i64toi32_i32$1 = $177$hi;
  i64toi32_i32$3 = $248;
  i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 8;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $249 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $249 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $179$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $171$hi;
  i64toi32_i32$1 = $171;
  i64toi32_i32$2 = $179$hi;
  i64toi32_i32$3 = $249;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  i64toi32_i32$1 = 16777215;
  i64toi32_i32$3 = -1;
  i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
  $181 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $170;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $181;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
  $182 = $2;
  i64toi32_i32$1 = $27$hi;
  i64toi32_i32$2 = $27;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $250 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $250 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $184 = $250;
  $184$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $36$hi;
  $185 = $36;
  $185$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $30$hi;
  i64toi32_i32$1 = $30;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
   $254 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $254 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
  }
  $187$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $185$hi;
  i64toi32_i32$0 = $185;
  i64toi32_i32$1 = $187$hi;
  i64toi32_i32$3 = $254;
  i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
  $188 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $188$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $31$hi;
  i64toi32_i32$2 = $31;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 40;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $255 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $255 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $190$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $188$hi;
  i64toi32_i32$1 = $188;
  i64toi32_i32$2 = $190$hi;
  i64toi32_i32$3 = $255;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  $191 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  $191$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $29$hi;
  i64toi32_i32$0 = $29;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 48;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   $256 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
   $256 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
  }
  $193$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $191$hi;
  i64toi32_i32$2 = $191;
  i64toi32_i32$0 = $193$hi;
  i64toi32_i32$3 = $256;
  i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
  $194 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  $194$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $28$hi;
  i64toi32_i32$1 = $28;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
   $258 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $258 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
  }
  $196$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $194$hi;
  i64toi32_i32$0 = $194;
  i64toi32_i32$1 = $196$hi;
  i64toi32_i32$3 = $258;
  i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
  $36 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $36$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $36;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $260 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   $260 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  $199$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $184$hi;
  i64toi32_i32$1 = $184;
  i64toi32_i32$2 = $199$hi;
  i64toi32_i32$3 = $260;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  $200 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $182;
  HEAP32[(i64toi32_i32$1 + 32 | 0) >> 2] = $200;
  HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] = i64toi32_i32$2;
  $201 = $2;
  i64toi32_i32$2 = $24$hi;
  $202 = $24;
  $202$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $25$hi;
  i64toi32_i32$0 = $25;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 16;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   $261 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
   $261 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
  }
  $204$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $202$hi;
  i64toi32_i32$2 = $202;
  i64toi32_i32$0 = $204$hi;
  i64toi32_i32$3 = $261;
  i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
  $24 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  $24$hi = i64toi32_i32$0;
  $206 = $24;
  $206$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $26$hi;
  i64toi32_i32$1 = $26;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 24;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
   $262 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $262 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
  }
  $208$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $206$hi;
  i64toi32_i32$0 = $206;
  i64toi32_i32$1 = $208$hi;
  i64toi32_i32$3 = $262;
  i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
  $209 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $209$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $23$hi;
  i64toi32_i32$2 = $23;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $263 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $263 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $211$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $209$hi;
  i64toi32_i32$1 = $209;
  i64toi32_i32$2 = $211$hi;
  i64toi32_i32$3 = $263;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  $212 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  $212$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $22$hi;
  i64toi32_i32$0 = $22;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 40;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   $267 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
   $267 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
  }
  $214$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $212$hi;
  i64toi32_i32$2 = $212;
  i64toi32_i32$0 = $214$hi;
  i64toi32_i32$3 = $267;
  i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
  $215 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  $215$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $21$hi;
  i64toi32_i32$1 = $21;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 48;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
   $268 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $268 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
  }
  $217$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $215$hi;
  i64toi32_i32$0 = $215;
  i64toi32_i32$1 = $217$hi;
  i64toi32_i32$3 = $268;
  i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
  $218 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $218$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $20$hi;
  i64toi32_i32$2 = $20;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $270 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $270 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $220$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $218$hi;
  i64toi32_i32$1 = $218;
  i64toi32_i32$2 = $220$hi;
  i64toi32_i32$3 = $270;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 24;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $271 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   $271 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
  }
  i64toi32_i32$0 = $201;
  HEAP32[(i64toi32_i32$0 + 72 | 0) >> 2] = $271;
  HEAP32[(i64toi32_i32$0 + 76 | 0) >> 2] = i64toi32_i32$1;
  $223 = $2;
  i64toi32_i32$1 = $24$hi;
  i64toi32_i32$2 = $24;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $273 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $273 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $225 = $273;
  $225$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $18$hi;
  i64toi32_i32$1 = $18;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
   $274 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $274 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
  }
  $227 = $274;
  $227$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $19$hi;
  i64toi32_i32$0 = $19;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 40;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   $276 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
   $276 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
  }
  $229$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $227$hi;
  i64toi32_i32$2 = $227;
  i64toi32_i32$0 = $229$hi;
  i64toi32_i32$3 = $276;
  i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
  $230 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  $230$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $17$hi;
  i64toi32_i32$1 = $17;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 48;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
   $277 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $277 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
  }
  $232$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $230$hi;
  i64toi32_i32$0 = $230;
  i64toi32_i32$1 = $232$hi;
  i64toi32_i32$3 = $277;
  i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
  $233 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $233$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $16$hi;
  i64toi32_i32$2 = $16;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $279 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $279 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $235$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $233$hi;
  i64toi32_i32$1 = $233;
  i64toi32_i32$2 = $235$hi;
  i64toi32_i32$3 = $279;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $280 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   $280 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
  }
  $237$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $225$hi;
  i64toi32_i32$2 = $225;
  i64toi32_i32$0 = $237$hi;
  i64toi32_i32$3 = $280;
  i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
  $238 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $223;
  HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] = $238;
  HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] = i64toi32_i32$0;
  $239 = $2;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$1 = $12;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 24;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
   $281 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $281 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
  }
  $241 = $281;
  $241$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $14$hi;
  i64toi32_i32$0 = $14;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 40;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   $283 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
   $283 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
  }
  $243 = $283;
  $243$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $15$hi;
  i64toi32_i32$2 = $15;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 48;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $284 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $284 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $245$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $243$hi;
  i64toi32_i32$1 = $243;
  i64toi32_i32$2 = $245$hi;
  i64toi32_i32$3 = $284;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  $246 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  $246$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $13$hi;
  i64toi32_i32$0 = $13;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   $285 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
   $285 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
  }
  $248$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $246$hi;
  i64toi32_i32$2 = $246;
  i64toi32_i32$0 = $248$hi;
  i64toi32_i32$3 = $285;
  i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 40;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $287 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $287 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
  }
  $250$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $241$hi;
  i64toi32_i32$0 = $241;
  i64toi32_i32$1 = $250$hi;
  i64toi32_i32$3 = $287;
  i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
  $251 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $239;
  HEAP32[(i64toi32_i32$0 + 56 | 0) >> 2] = $251;
  HEAP32[(i64toi32_i32$0 + 60 | 0) >> 2] = i64toi32_i32$1;
  $252 = $2;
  i64toi32_i32$1 = $8$hi;
  $253 = $8;
  $253$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $288 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $288 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $255$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $253$hi;
  i64toi32_i32$1 = $253;
  i64toi32_i32$2 = $255$hi;
  i64toi32_i32$3 = $288;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 16;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   $289 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
   $289 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
  }
  $257 = $289;
  $257$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $10$hi;
  i64toi32_i32$2 = $10;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $290 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $290 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $259 = $290;
  $259$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$1 = $11;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 48;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
   $291 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $291 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
  }
  $261$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $259$hi;
  i64toi32_i32$0 = $259;
  i64toi32_i32$1 = $261$hi;
  i64toi32_i32$3 = $291;
  i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 48;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $292 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   $292 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  $263$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $257$hi;
  i64toi32_i32$1 = $257;
  i64toi32_i32$2 = $263$hi;
  i64toi32_i32$3 = $292;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  $264 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $252;
  HEAP32[(i64toi32_i32$1 + 48 | 0) >> 2] = $264;
  HEAP32[(i64toi32_i32$1 + 52 | 0) >> 2] = i64toi32_i32$2;
  $265 = $2;
  i64toi32_i32$2 = $27$hi;
  $266 = $27;
  $266$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $6$hi;
  i64toi32_i32$0 = $6;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 8;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   $293 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
   $293 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
  }
  $268$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $266$hi;
  i64toi32_i32$2 = $266;
  i64toi32_i32$0 = $268$hi;
  i64toi32_i32$3 = $293;
  i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
  $269 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  $269$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$1 = $7;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 16;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
   $294 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $294 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
  }
  $271$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $269$hi;
  i64toi32_i32$0 = $269;
  i64toi32_i32$1 = $271$hi;
  i64toi32_i32$3 = $294;
  i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
  $272 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $272$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $5$hi;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 24;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $295 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $295 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $274$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $272$hi;
  i64toi32_i32$1 = $272;
  i64toi32_i32$2 = $274$hi;
  i64toi32_i32$3 = $295;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  $275 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  $275$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$0 = $4;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   $296 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
   $296 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
  }
  $277$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $275$hi;
  i64toi32_i32$2 = $275;
  i64toi32_i32$0 = $277$hi;
  i64toi32_i32$3 = $296;
  i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
  $278 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  $278$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $3$hi;
  i64toi32_i32$1 = $3;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 40;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
   $297 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $297 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
  }
  $280$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $278$hi;
  i64toi32_i32$0 = $278;
  i64toi32_i32$1 = $280$hi;
  i64toi32_i32$3 = $297;
  i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 8;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $298 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $298 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $282 = $298;
  $282$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $36$hi;
  i64toi32_i32$1 = $36;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $299 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $299 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
  }
  $284$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $282$hi;
  i64toi32_i32$0 = $282;
  i64toi32_i32$1 = $284$hi;
  i64toi32_i32$3 = $299;
  i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 16777215;
  i64toi32_i32$3 = -1;
  i64toi32_i32$0 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
  $286 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $265;
  HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] = $286;
  HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] = i64toi32_i32$0;
  cryptoxide__curve25519__scalar__scalar64__barrett_reduce256__heefb042b74f1284c($0 | 0, $2 + 40 | 0 | 0, $2 | 0);
  global$0 = $2 + 80 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_recursing__h9dcf9ac6ec8c251c($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $30 = 0, $7 = 0, $8 = 0, $9 = 0, $10 = 0, $23 = 0, $35 = 0, $41 = 0, $44 = 0, $94 = 0, $99 = 0, $105 = 0, $133 = 0, $141 = 0, $144 = 0, $176 = 0, $180 = 0, $187 = 0, $201 = 0, $221 = 0, $227 = 0;
  $3 = global$0 - 144 | 0;
  global$0 = $3;
  $4 = ($3 + 8 | 0) + 8 | 0;
  HEAP32[$4 >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $23 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[($3 + 8 | 0) >> 2] = $23;
  HEAP32[($3 + 12 | 0) >> 2] = i64toi32_i32$1;
  $30 = $2 + 24 | 0;
  HEAP32[(($3 + 112 | 0) + 24 | 0) >> 2] = HEAPU8[$30 >> 0] | 0 | ((HEAPU8[($30 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($30 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($30 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $2 + 16 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $35 = i64toi32_i32$1;
  i64toi32_i32$1 = ($3 + 112 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $35;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2 + 8 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $41 = i64toi32_i32$0;
  i64toi32_i32$0 = ($3 + 112 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $41;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $44 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[($3 + 112 | 0) >> 2] = $44;
  HEAP32[($3 + 116 | 0) >> 2] = i64toi32_i32$0;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert__hb2ec731b8769187c($3 + 40 | 0 | 0, $3 + 8 | 0 | 0, $3 + 112 | 0 | 0);
  $5 = HEAP32[(($3 + 40 | 0) + 12 | 0) >> 2] | 0;
  $1 = HEAP32[(($3 + 40 | 0) + 8 | 0) >> 2] | 0;
  $6 = HEAP32[($3 + 44 | 0) >> 2] | 0;
  $7 = HEAP32[($3 + 88 | 0) >> 2] | 0;
  label$1 : {
   label$2 : {
    if ((HEAP32[($3 + 40 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    HEAP32[($0 + 48 | 0) >> 2] = $7;
    HEAP32[($0 + 4 | 0) >> 2] = $6;
    HEAP32[$0 >> 2] = 0;
    HEAP32[($0 + 12 | 0) >> 2] = $5;
    HEAP32[($0 + 8 | 0) >> 2] = $1;
    break label$1;
   }
   $8 = HEAP32[(($3 + 40 | 0) + 16 | 0) >> 2] | 0;
   HEAP32[(($3 + 8 | 0) + 24 | 0) >> 2] = HEAP32[(($3 + 40 | 0) + 44 | 0) >> 2] | 0;
   i64toi32_i32$2 = ($3 + 40 | 0) + 36 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $94 = i64toi32_i32$0;
   i64toi32_i32$0 = ($3 + 8 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $94;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = ($3 + 40 | 0) + 28 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $99 = i64toi32_i32$1;
   i64toi32_i32$1 = $4;
   HEAP32[i64toi32_i32$1 >> 2] = $99;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   $2 = ($3 + 40 | 0) + 20 | 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $105 = i64toi32_i32$0;
   i64toi32_i32$0 = $3;
   HEAP32[($3 + 8 | 0) >> 2] = $105;
   HEAP32[($3 + 12 | 0) >> 2] = i64toi32_i32$1;
   label$3 : {
    $4 = HEAP32[$1 >> 2] | 0;
    if (!$4) {
     break label$3
    }
    label$4 : while (1) {
     HEAP32[($3 + 104 | 0) >> 2] = HEAPU16[($1 + 4 | 0) >> 1] | 0;
     HEAP32[($3 + 100 | 0) >> 2] = $4;
     HEAP32[($3 + 96 | 0) >> 2] = $6 + 1 | 0;
     $4 = ($3 + 8 | 0) + 24 | 0;
     HEAP32[(($3 + 112 | 0) + 24 | 0) >> 2] = HEAP32[$4 >> 2] | 0;
     $9 = ($3 + 8 | 0) + 16 | 0;
     i64toi32_i32$2 = $9;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $133 = i64toi32_i32$1;
     i64toi32_i32$1 = ($3 + 112 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $133;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     $10 = ($3 + 8 | 0) + 8 | 0;
     i64toi32_i32$2 = $10;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $141 = i64toi32_i32$0;
     i64toi32_i32$0 = ($3 + 112 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $141;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $3;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
     $144 = i64toi32_i32$1;
     i64toi32_i32$1 = i64toi32_i32$2;
     HEAP32[(i64toi32_i32$2 + 112 | 0) >> 2] = $144;
     HEAP32[(i64toi32_i32$2 + 116 | 0) >> 2] = i64toi32_i32$0;
     alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert__h236f944aa12520cb(i64toi32_i32$2 + 40 | 0 | 0, i64toi32_i32$2 + 96 | 0 | 0, i64toi32_i32$2 + 112 | 0 | 0, $5 | 0, $8 | 0);
     $5 = HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] | 0;
     $1 = HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] | 0;
     $6 = HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] | 0;
     label$5 : {
      if ((HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$5
      }
      HEAP32[($0 + 48 | 0) >> 2] = $7;
      HEAP32[($0 + 4 | 0) >> 2] = $6;
      HEAP32[$0 >> 2] = 0;
      HEAP32[($0 + 12 | 0) >> 2] = $5;
      HEAP32[($0 + 8 | 0) >> 2] = $1;
      break label$1;
     }
     i64toi32_i32$2 = $2 + 8 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $176 = i64toi32_i32$0;
     i64toi32_i32$0 = $10;
     HEAP32[i64toi32_i32$0 >> 2] = $176;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $2 + 16 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $180 = i64toi32_i32$1;
     i64toi32_i32$1 = $9;
     HEAP32[i64toi32_i32$1 >> 2] = $180;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[$4 >> 2] = HEAP32[($2 + 24 | 0) >> 2] | 0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $187 = i64toi32_i32$0;
     i64toi32_i32$0 = $3;
     HEAP32[($3 + 8 | 0) >> 2] = $187;
     HEAP32[($3 + 12 | 0) >> 2] = i64toi32_i32$1;
     $8 = HEAP32[($3 + 56 | 0) >> 2] | 0;
     $4 = HEAP32[$1 >> 2] | 0;
     if ($4) {
      continue label$4
     }
     break label$4;
    };
   }
   HEAP32[($0 + 48 | 0) >> 2] = $7;
   HEAP32[($0 + 4 | 0) >> 2] = $6;
   HEAP32[$0 >> 2] = 1;
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
   $201 = i64toi32_i32$1;
   i64toi32_i32$1 = $0 + 20 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $201;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($0 + 16 | 0) >> 2] = $8;
   HEAP32[($0 + 12 | 0) >> 2] = $5;
   HEAP32[($0 + 8 | 0) >> 2] = $1;
   HEAP32[($0 + 44 | 0) >> 2] = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
   i64toi32_i32$2 = (i64toi32_i32$2 + 8 | 0) + 16 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $221 = i64toi32_i32$0;
   i64toi32_i32$0 = $0 + 36 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $221;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = ($3 + 8 | 0) + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $227 = i64toi32_i32$1;
   i64toi32_i32$1 = $0 + 28 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $227;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  }
  global$0 = $3 + 144 | 0;
 }
 
 function hashbrown__raw__RawTable_T_2cA___resize__h5eaf2f7565587360($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $5 = 0, $11 = 0, $6 = 0, $15$hi = 0, $15 = 0, $7 = 0, $9 = 0, i64toi32_i32$4 = 0, $16 = 0, i64toi32_i32$3 = 0, $16$hi = 0, $30 = 0, $13 = 0, $31 = 0, $10 = 0, $12 = 0, $32 = 0, $78 = 0, $81$hi = 0, $83 = 0, $8 = 0, $14 = 0, $203 = 0, $214 = 0, $223 = 0;
  $5 = global$0 - 80 | 0;
  global$0 = $5;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ($2) {
        break label$5
       }
       i64toi32_i32$0 = 0;
       $15 = 0;
       $15$hi = i64toi32_i32$0;
       $4 = 0;
       $6 = hashbrown__raw__generic__Group__static_empty__hc5a7932fe1bdb1f1() | 0;
       break label$4;
      }
      label$6 : {
       label$7 : {
        if ($2 >>> 0 < 8 >>> 0) {
         break label$7
        }
        label$8 : {
         if (($2 & 536870911 | 0 | 0) != ($2 | 0)) {
          break label$8
         }
         $2 = (-1 >>> Math_clz32(((($2 << 3 | 0) >>> 0) / (7 >>> 0) | 0) + -1 | 0) | 0) + 1 | 0;
         break label$6;
        }
        hashbrown__raw__Fallibility__capacity_overflow__hd790516fe6877097($5 + 8 | 0 | 0, $4 | 0);
        $6 = HEAP32[($5 + 12 | 0) >> 2] | 0;
        $2 = HEAP32[($5 + 8 | 0) >> 2] | 0;
        break label$3;
       }
       $2 = $2 >>> 0 < 4 >>> 0 ? 4 : 8;
      }
      hashbrown__raw__RawTableInner_A___new_uninitialized__h43f4df636ea4ff18($5 + 56 | 0 | 0, 12 | 0, 4 | 0, $2 | 0, $4 | 0);
      $6 = HEAP32[($5 + 64 | 0) >> 2] | 0;
      $2 = HEAP32[($5 + 60 | 0) >> 2] | 0;
      if ((HEAP32[($5 + 56 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      $4 = HEAP32[(($5 + 56 | 0) + 12 | 0) >> 2] | 0;
      memset($6 | 0, 255 | 0, $2 + 5 | 0 | 0) | 0;
      i64toi32_i32$0 = 0;
      $15 = $2;
      $15$hi = i64toi32_i32$0;
     }
     $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
     HEAP32[($5 + 36 | 0) >> 2] = $2;
     HEAP32[($5 + 32 | 0) >> 2] = $4 - $2 | 0;
     i64toi32_i32$1 = $5;
     i64toi32_i32$0 = 4;
     HEAP32[($5 + 16 | 0) >> 2] = 12;
     HEAP32[($5 + 20 | 0) >> 2] = i64toi32_i32$0;
     $78 = $5;
     i64toi32_i32$0 = 0;
     i64toi32_i32$2 = $6;
     i64toi32_i32$1 = 0;
     i64toi32_i32$3 = 32;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
      $32 = 0;
     } else {
      i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
      $32 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
     }
     $81$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $15$hi;
     i64toi32_i32$1 = $81$hi;
     i64toi32_i32$0 = $32;
     i64toi32_i32$2 = $15$hi;
     i64toi32_i32$3 = $15;
     i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
     $83 = i64toi32_i32$0 | $15 | 0;
     i64toi32_i32$0 = $78;
     HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = $83;
     HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = i64toi32_i32$2;
     $7 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $4 = $7 + 4 | 0;
     $8 = ((HEAP32[$1 >> 2] | 0) + $7 | 0) + 1 | 0;
     $9 = ((HEAP32[$7 >> 2] | 0) ^ -1 | 0) & -2139062144 | 0;
     i64toi32_i32$2 = $15$hi;
     $10 = $15;
     label$9 : while (1) {
      label$10 : {
       if ($9) {
        break label$10
       }
       label$11 : while (1) {
        if ($4 >>> 0 >= $8 >>> 0) {
         break label$2
        }
        $7 = $7 + -48 | 0;
        $2 = HEAP32[$4 >> 2] | 0;
        $11 = $4 + 4 | 0;
        $4 = $11;
        $2 = $2 & -2139062144 | 0;
        if (($2 | 0) == (-2139062144 | 0)) {
         continue label$11
        }
        break label$11;
       };
       $9 = $2 ^ -2139062144 | 0;
       $4 = $11;
      }
      label$12 : {
       i64toi32_i32$2 = $15$hi;
       $12 = ($7 + Math_imul(0 - ((__wasm_ctz_i32($9 | 0) | 0) >>> 3 | 0) | 0, 12) | 0) + -12 | 0;
       i64toi32_i32$2 = hashbrown__map__make_hash__h2529a4f95818d178($3 | 0, $12 | 0) | 0;
       i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
       $16 = i64toi32_i32$2;
       $16$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $15$hi;
       i64toi32_i32$1 = $15;
       i64toi32_i32$2 = $16$hi;
       i64toi32_i32$3 = $16;
       i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
       $11 = i64toi32_i32$1 & $16 | 0;
       $30 = $6 + $11 | 0;
       $13 = (HEAPU8[$30 >> 0] | 0 | ((HEAPU8[($30 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($30 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($30 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
       if ($13) {
        break label$12
       }
       $2 = 4;
       label$13 : while (1) {
        $11 = $11 + $2 | 0;
        $2 = $2 + 4 | 0;
        $11 = $11 & $10 | 0;
        $31 = $6 + $11 | 0;
        $13 = (HEAPU8[$31 >> 0] | 0 | ((HEAPU8[($31 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($31 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($31 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
        if (!$13) {
         continue label$13
        }
        break label$13;
       };
      }
      $14 = $9 + -1 | 0;
      label$14 : {
       $2 = (((__wasm_ctz_i32($13 | 0) | 0) >>> 3 | 0) + $11 | 0) & $10 | 0;
       if ((HEAP8[($6 + $2 | 0) >> 0] | 0 | 0) <= (-1 | 0)) {
        break label$14
       }
       $2 = (__wasm_ctz_i32((HEAP32[$6 >> 2] | 0) & -2139062144 | 0 | 0) | 0) >>> 3 | 0;
      }
      $9 = $14 & $9 | 0;
      i64toi32_i32$2 = $16$hi;
      $11 = $16 >>> 25 | 0;
      HEAP8[($6 + $2 | 0) >> 0] = $11;
      HEAP8[(((($2 + -4 | 0) & $10 | 0) + $6 | 0) + 4 | 0) >> 0] = $11;
      $2 = ($6 + Math_imul(0 - $2 | 0, 12) | 0) + -12 | 0;
      HEAP32[($2 + 8 | 0) >> 2] = HEAP32[($12 + 8 | 0) >> 2] | 0;
      i64toi32_i32$0 = $12;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
      $203 = i64toi32_i32$2;
      i64toi32_i32$2 = $2;
      HEAP32[i64toi32_i32$2 >> 2] = $203;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      continue label$9;
     };
    }
    HEAP32[($0 + 4 | 0) >> 2] = $2;
    HEAP32[$0 >> 2] = 1;
    HEAP32[($0 + 8 | 0) >> 2] = $6;
    break label$1;
   }
   i64toi32_i32$0 = $1;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $16 = i64toi32_i32$1;
   $16$hi = i64toi32_i32$2;
   i64toi32_i32$0 = $5;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] | 0;
   $214 = i64toi32_i32$2;
   i64toi32_i32$2 = $1;
   HEAP32[i64toi32_i32$2 >> 2] = $214;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   $2 = i64toi32_i32$0 + 32 | 0;
   i64toi32_i32$0 = $2;
   i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $15 = i64toi32_i32$1;
   $15$hi = i64toi32_i32$2;
   $4 = $1 + 8 | 0;
   i64toi32_i32$0 = $4;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $223 = i64toi32_i32$2;
   i64toi32_i32$2 = $2;
   HEAP32[i64toi32_i32$2 >> 2] = $223;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $15$hi;
   i64toi32_i32$2 = i64toi32_i32$0;
   HEAP32[i64toi32_i32$2 >> 2] = $15;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $16$hi;
   i64toi32_i32$2 = $5;
   HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] = $16;
   HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[$0 >> 2] = 0;
   core__ptr__drop_in_place_hashbrown__scopeguard__ScopeGuard_hashbrown__raw__RawTableInner_alloc__alloc__Global__2chashbrown__raw__RawTableInner_alloc__alloc__Global___prepare_resize___7b_7bclosure_7d_7d____hf09be25679474fda(i64toi32_i32$2 + 16 | 0 | 0);
  }
  global$0 = $5 + 80 | 0;
 }
 
 function num_bigint__biguint__convert___impl_20num_traits__Num_20for_20num_bigint__biguint__BigUint___from_str_radix__ha7ce9e2a0cdf83db($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $6 = 0, $5 = 0, $7 = 0, $8 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $175 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           label$10 : {
            label$11 : {
             if (($3 + -2 | 0) >>> 0 > 34 >>> 0) {
              break label$11
             }
             HEAP32[($4 + 32 | 0) >> 2] = 43;
             if (!$2) {
              break label$7
             }
             if (core__slice__cmp___impl_20core__cmp__PartialEq__5bB_5d__20for_20_5bA_5d___eq__h90e2e64d8666208c($4 + 32 | 0 | 0, 1 | 0, $1 | 0, 1 | 0) | 0) {
              break label$10
             }
             $5 = $2;
             $6 = $1;
             break label$9;
            }
            std__panicking__begin_panic__hf55b754840077f11(1077016 | 0, 31 | 0, 1077152 | 0);
            abort();
           }
           label$12 : {
            if ($2 >>> 0 < 2 >>> 0) {
             break label$12
            }
            if ((HEAP8[($1 + 1 | 0) >> 0] | 0 | 0) <= (-65 | 0)) {
             break label$4
            }
           }
           HEAP32[($4 + 32 | 0) >> 2] = 43;
           $5 = $2 + -1 | 0;
           if (!$5) {
            break label$7
           }
           $6 = $1 + 1 | 0;
           if (core__slice__cmp___impl_20core__cmp__PartialEq__5bB_5d__20for_20_5bA_5d___eq__h90e2e64d8666208c($4 + 32 | 0 | 0, 1 | 0, $6 | 0, 1 | 0) | 0) {
            break label$8
           }
          }
          $1 = $6;
          $2 = $5;
         }
         HEAP32[($4 + 32 | 0) >> 2] = 95;
         if (core__slice__cmp___impl_20core__cmp__PartialEq__5bB_5d__20for_20_5bA_5d___eq__h90e2e64d8666208c($4 + 32 | 0 | 0, 1 | 0, $1 | 0, 1 | 0) | 0) {
          break label$2
         }
         $6 = 0;
         alloc__raw_vec__RawVec_T_2cA___allocate_in__h7079698aee95f1e4($4 + 8 | 0 | 0, $2 | 0, 0 | 0);
         HEAP32[($4 + 24 | 0) >> 2] = 0;
         HEAP32[($4 + 20 | 0) >> 2] = HEAP32[($4 + 12 | 0) >> 2] | 0;
         $7 = HEAP32[($4 + 8 | 0) >> 2] | 0;
         HEAP32[($4 + 16 | 0) >> 2] = $7;
         label$13 : while (1) {
          label$14 : {
           label$15 : {
            label$16 : {
             label$17 : {
              $8 = HEAPU8[$1 >> 0] | 0;
              $5 = $8 + -48 | 0;
              if (($5 & 255 | 0) >>> 0 < 10 >>> 0) {
               break label$17
              }
              label$18 : {
               label$19 : {
                if ((($8 + -97 | 0) & 255 | 0) >>> 0 < 26 >>> 0) {
                 break label$19
                }
                if ((($8 + -65 | 0) & 255 | 0) >>> 0 < 26 >>> 0) {
                 break label$18
                }
                if (($8 & 255 | 0 | 0) != (95 | 0)) {
                 break label$16
                }
                break label$14;
               }
               $5 = $8 + -87 | 0;
               break label$17;
              }
              $5 = $8 + -55 | 0;
             }
             if (($5 & 255 | 0) >>> 0 < ($3 & 255 | 0) >>> 0) {
              break label$15
             }
            }
            HEAP16[$0 >> 1] = 257;
            $1 = HEAP32[($4 + 20 | 0) >> 2] | 0;
            if (!$1) {
             break label$1
            }
            __rust_dealloc($7 | 0, $1 | 0, 1 | 0);
            break label$1;
           }
           label$20 : {
            if ((HEAP32[($4 + 20 | 0) >> 2] | 0 | 0) != ($6 | 0)) {
             break label$20
            }
            alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hcd3bd1a8d7e51f52($4 + 16 | 0 | 0, $6 | 0, 1 | 0);
            $7 = HEAP32[($4 + 16 | 0) >> 2] | 0;
            $6 = HEAP32[($4 + 24 | 0) >> 2] | 0;
           }
           HEAP8[($7 + $6 | 0) >> 0] = $5;
           $6 = (HEAP32[($4 + 24 | 0) >> 2] | 0) + 1 | 0;
           HEAP32[($4 + 24 | 0) >> 2] = $6;
          }
          $1 = $1 + 1 | 0;
          $2 = $2 + -1 | 0;
          if ($2) {
           continue label$13
          }
          break label$13;
         };
         if ((__wasm_popcnt_i32($3 | 0) | 0 | 0) == (1 | 0)) {
          break label$6
         }
         $7 = HEAP32[($4 + 16 | 0) >> 2] | 0;
         num_bigint__biguint__convert__from_radix_digits_be__h923476663a064105($4 + 32 | 0 | 0, $7 | 0, $6 | 0, $3 | 0);
         break label$5;
        }
        HEAP16[$0 >> 1] = 1;
        break label$1;
       }
       $3 = 31 - Math_clz32($3) | 0;
       $7 = HEAP32[($4 + 16 | 0) >> 2] | 0;
       label$21 : {
        $2 = $6 >>> 1 | 0;
        if (!$2) {
         break label$21
        }
        $1 = ($7 + $6 | 0) + -1 | 0;
        $5 = $7;
        label$22 : while (1) {
         $8 = HEAPU8[$5 >> 0] | 0;
         HEAP8[$5 >> 0] = HEAPU8[$1 >> 0] | 0;
         HEAP8[$1 >> 0] = $8;
         $5 = $5 + 1 | 0;
         $1 = $1 + -1 | 0;
         $2 = $2 + -1 | 0;
         if ($2) {
          continue label$22
         }
         break label$22;
        };
       }
       if (!$3) {
        break label$3
       }
       label$23 : {
        if ((32 >>> 0) % (($3 & 255 | 0) >>> 0) | 0) {
         break label$23
        }
        num_bigint__biguint__convert__from_bitwise_digits_le__h1211a4b63ce79885($4 + 32 | 0 | 0, $7 | 0, $6 | 0, $3 | 0);
        break label$5;
       }
       num_bigint__biguint__convert__from_inexact_bitwise_digits_le__h6c419a1400584927($4 + 32 | 0 | 0, $7 | 0, $6 | 0, $3 | 0);
      }
      HEAP8[$0 >> 0] = 0;
      i64toi32_i32$0 = HEAP32[($4 + 32 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($4 + 36 | 0) >> 2] | 0;
      $175 = i64toi32_i32$0;
      i64toi32_i32$0 = $0 + 4 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $175;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($4 + 40 | 0) >> 2] | 0;
      $1 = HEAP32[($4 + 20 | 0) >> 2] | 0;
      if (!$1) {
       break label$1
      }
      __rust_dealloc($7 | 0, $1 | 0, 1 | 0);
      break label$1;
     }
     core__str__slice_error_fail__h8a7d2e23b7bba52e($1 | 0, $2 | 0, 1 | 0, $2 | 0, 1077168 | 0);
     abort();
    }
    core__panicking__panic__h2fd385a887c8bf13(1076576 | 0, 57 | 0, 1077184 | 0);
    abort();
   }
   HEAP16[$0 >> 1] = 257;
  }
  global$0 = $4 + 48 | 0;
 }
 
 function hashbrown__raw__RawTable_T_2cA___rehash_in_place__h5635ef5f6440afeb($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $10 = 0, $7 = 0, $9 = 0, $8 = 0, i64toi32_i32$0 = 0, $3 = 0, $5 = 0, $6 = 0, i64toi32_i32$1 = 0, $12 = 0, $2 = 0, $4 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $11 = 0, $13 = 0, $14 = 0, $14$hi = 0, $177 = 0, $212 = 0, $234 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  $3 = HEAP32[$0 >> 2] | 0;
  $4 = $3 + 1 | 0;
  core__iter__adapters__step_by__StepBy_I___new__h21a520baea7dc9f1($2 | 0, 0 | 0, $4 | 0, 4 | 0);
  $5 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  $6 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $7 = HEAP32[$2 >> 2] | 0;
  $8 = !(HEAPU8[($2 + 12 | 0) >> 0] | 0);
  $9 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  label$1 : while (1) {
   label$2 : {
    label$3 : {
     label$4 : {
      if (!($8 & 1 | 0)) {
       break label$4
      }
      $10 = $7 + ($T_20as_20core__convert__From_T____from__h09bdeba94dd58819($5 | 0) | 0) | 0;
      if ($10 >>> 0 < $7 >>> 0) {
       break label$3
      }
      if ($10 >>> 0 >= $6 >>> 0) {
       break label$3
      }
      break label$2;
     }
     $10 = $7;
     if ($10 >>> 0 < $6 >>> 0) {
      break label$2
     }
    }
    label$5 : {
     label$6 : {
      label$7 : {
       if ($4 >>> 0 < 4 >>> 0) {
        break label$7
       }
       $21 = $9 + $4 | 0;
       $22 = HEAPU8[$9 >> 0] | 0 | ((HEAPU8[($9 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($9 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($9 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       HEAP8[$21 >> 0] = $22;
       HEAP8[($21 + 1 | 0) >> 0] = $22 >>> 8 | 0;
       HEAP8[($21 + 2 | 0) >> 0] = $22 >>> 16 | 0;
       HEAP8[($21 + 3 | 0) >> 0] = $22 >>> 24 | 0;
       break label$6;
      }
      memmove($9 + 4 | 0 | 0, $9 | 0, $4 | 0) | 0;
      if (!$4) {
       break label$5
      }
     }
     $10 = 0;
     label$8 : while (1) {
      label$9 : {
       $6 = $10;
       $11 = $9 + $10 | 0;
       if ((HEAPU8[$11 >> 0] | 0 | 0) != (128 | 0)) {
        break label$9
       }
       $12 = ($9 + Math_imul(0 - $6 | 0, 12) | 0) + -12 | 0;
       label$10 : while (1) {
        i64toi32_i32$0 = hashbrown__map__make_hash__h2529a4f95818d178($1 | 0, $12 | 0) | 0;
        i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
        $13 = i64toi32_i32$0;
        $5 = $3 & i64toi32_i32$0 | 0;
        $7 = $5;
        label$11 : {
         $23 = $9 + $7 | 0;
         $8 = (HEAPU8[$23 >> 0] | 0 | ((HEAPU8[($23 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($23 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($23 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
         if ($8) {
          break label$11
         }
         $10 = 4;
         $7 = $5;
         label$12 : while (1) {
          $7 = $7 + $10 | 0;
          $10 = $10 + 4 | 0;
          $7 = $7 & $3 | 0;
          $24 = $9 + $7 | 0;
          $8 = (HEAPU8[$24 >> 0] | 0 | ((HEAPU8[($24 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($24 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($24 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
          if (!$8) {
           continue label$12
          }
          break label$12;
         };
        }
        label$13 : {
         $10 = (((__wasm_ctz_i32($8 | 0) | 0) >>> 3 | 0) + $7 | 0) & $3 | 0;
         if ((HEAP8[($9 + $10 | 0) >> 0] | 0 | 0) <= (-1 | 0)) {
          break label$13
         }
         $10 = (__wasm_ctz_i32((HEAP32[$9 >> 2] | 0) & -2139062144 | 0 | 0) | 0) >>> 3 | 0;
        }
        label$14 : {
         if (((($10 - $5 | 0) ^ ($6 - $5 | 0) | 0) & $3 | 0) >>> 0 >= 4 >>> 0) {
          break label$14
         }
         $10 = $13 >>> 25 | 0;
         HEAP8[$11 >> 0] = $10;
         HEAP8[(((($6 + -4 | 0) & $3 | 0) + $9 | 0) + 4 | 0) >> 0] = $10;
         break label$9;
        }
        $7 = $9 + $10 | 0;
        $8 = HEAPU8[$7 >> 0] | 0;
        $5 = $13 >>> 25 | 0;
        HEAP8[$7 >> 0] = $5;
        HEAP8[(((($10 + -4 | 0) & $3 | 0) + $9 | 0) + 4 | 0) >> 0] = $5;
        label$15 : {
         if (($8 | 0) == (255 | 0)) {
          break label$15
         }
         $10 = ($9 + Math_imul(0 - $10 | 0, 12) | 0) + -12 | 0;
         i64toi32_i32$1 = HEAP32[$10 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($10 + 4 | 0) >> 2] | 0;
         $14 = i64toi32_i32$1;
         $14$hi = i64toi32_i32$0;
         i64toi32_i32$0 = HEAP32[$12 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[($12 + 4 | 0) >> 2] | 0;
         $177 = i64toi32_i32$0;
         i64toi32_i32$0 = $10;
         HEAP32[$10 >> 2] = $177;
         HEAP32[($10 + 4 | 0) >> 2] = i64toi32_i32$1;
         $10 = $10 + 8 | 0;
         $7 = HEAP32[$10 >> 2] | 0;
         $8 = $12 + 8 | 0;
         HEAP32[$10 >> 2] = HEAP32[$8 >> 2] | 0;
         i64toi32_i32$1 = $14$hi;
         i64toi32_i32$0 = $12;
         HEAP32[i64toi32_i32$0 >> 2] = $14;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         HEAP32[$8 >> 2] = $7;
         continue label$10;
        }
        break label$10;
       };
       HEAP8[$11 >> 0] = 255;
       HEAP8[(((($6 + -4 | 0) & $3 | 0) + $9 | 0) + 4 | 0) >> 0] = 255;
       $10 = ($9 + Math_imul(0 - $10 | 0, 12) | 0) + -12 | 0;
       HEAP32[($10 + 8 | 0) >> 2] = HEAP32[($12 + 8 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[$12 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[($12 + 4 | 0) >> 2] | 0;
       $212 = i64toi32_i32$1;
       i64toi32_i32$1 = $10;
       HEAP32[$10 >> 2] = $212;
       HEAP32[($10 + 4 | 0) >> 2] = i64toi32_i32$0;
      }
      $10 = $6 + 1 | 0;
      if (($6 | 0) != ($3 | 0)) {
       continue label$8
      }
      break label$8;
     };
    }
    HEAP32[($0 + 8 | 0) >> 2] = ($3 >>> 0 < 8 >>> 0 ? $3 : Math_imul($4 >>> 3 | 0, 7)) - (HEAP32[($0 + 12 | 0) >> 2] | 0) | 0;
    global$0 = $2 + 32 | 0;
    return;
   }
   $7 = $9 + $10 | 0;
   $234 = $7;
   $7 = HEAP32[$7 >> 2] | 0;
   HEAP32[$234 >> 2] = ((($7 >>> 7 | 0) ^ -1 | 0) & 16843009 | 0) + ($7 | 2139062143 | 0) | 0;
   $8 = 1;
   $7 = $10 + 1 | 0;
   continue label$1;
  };
 }
 
 function $serde_json__value__de___impl_20serde__de__Deserialize_20for_20serde_json__value__Value___deserialize__ValueVisitor_20as_20serde__de__Visitor___visit_map__hb4fe0106a753aa87($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $8 = 0, $8$hi = 0, $25 = 0, $26 = 0, $27 = 0, $28 = 0, $29 = 0, $30 = 0, $31 = 0, $32 = 0, $33 = 0, $4 = 0, $5 = 0, $6 = 0, $7 = 0, $52 = 0, $58 = 0, $61 = 0, $114 = 0, $121 = 0, $124 = 0, $140 = 0, $144 = 0, $149 = 0, $156 = 0, $160 = 0, $164 = 0;
  $3 = global$0 - 128 | 0;
  global$0 = $3;
  HEAP8[($3 + 12 | 0) >> 0] = $2;
  HEAP32[($3 + 8 | 0) >> 2] = $1;
  $serde_json__de__MapAccess_R__20as_20serde__de__MapAccess___next_key_seed__h96feefa156c1f5ba($3 + 80 | 0 | 0, $3 + 8 | 0 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ((HEAP32[($3 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
        break label$5
       }
       label$6 : {
        $1 = HEAP32[($3 + 84 | 0) >> 2] | 0;
        if ($1) {
         break label$6
        }
        HEAP32[$0 >> 2] = 0;
        i64toi32_i32$1 = $0 + 16 | 0;
        i64toi32_i32$0 = 0;
        HEAP32[i64toi32_i32$1 >> 2] = 0;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        HEAP8[($0 + 8 | 0) >> 0] = 5;
        break label$1;
       }
       i64toi32_i32$2 = ($3 + 80 | 0) + 8 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $8 = i64toi32_i32$0;
       $8$hi = i64toi32_i32$1;
       i64toi32_i32$0 = $3;
       i64toi32_i32$1 = 0;
       HEAP32[($3 + 20 | 0) >> 2] = 0;
       HEAP32[($3 + 24 | 0) >> 2] = i64toi32_i32$1;
       $serde_json__de__MapAccess_R__20as_20serde__de__MapAccess___next_value_seed__hacf927117f4e5996($3 + 80 | 0 | 0, $3 + 8 | 0 | 0);
       if ((HEAP32[($3 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
        break label$4
       }
       i64toi32_i32$1 = $8$hi;
       i64toi32_i32$0 = $3;
       HEAP32[($3 + 116 | 0) >> 2] = $8;
       HEAP32[($3 + 120 | 0) >> 2] = i64toi32_i32$1;
       HEAP32[($3 + 112 | 0) >> 2] = $1;
       i64toi32_i32$2 = $3 + 104 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $52 = i64toi32_i32$1;
       i64toi32_i32$1 = ($3 + 56 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $52;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = ($3 + 80 | 0) + 16 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $58 = i64toi32_i32$0;
       i64toi32_i32$0 = $3 + 64 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $58;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $3;
       i64toi32_i32$1 = HEAP32[($3 + 88 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[($3 + 92 | 0) >> 2] | 0;
       $61 = i64toi32_i32$1;
       i64toi32_i32$1 = $3;
       HEAP32[($3 + 56 | 0) >> 2] = $61;
       HEAP32[($3 + 60 | 0) >> 2] = i64toi32_i32$0;
       alloc__collections__btree__map__BTreeMap_K_2cV___insert__h676f968c46c3ef24($3 + 32 | 0 | 0, $3 + 16 | 0 | 0, $3 + 112 | 0 | 0, $3 + 56 | 0 | 0);
       label$7 : {
        if ((HEAPU8[($3 + 32 | 0) >> 0] | 0 | 0) == (6 | 0)) {
         break label$7
        }
        core__ptr__drop_in_place_serde_json__value__Value___hb5131c85f9c77304_1($3 + 32 | 0 | 0);
       }
       $serde_json__de__MapAccess_R__20as_20serde__de__MapAccess___next_key_seed__hcd57db292bb18be3($3 + 56 | 0 | 0, $3 + 8 | 0 | 0);
       label$8 : {
        if ((HEAP32[($3 + 56 | 0) >> 2] | 0 | 0) == (1 | 0)) {
         break label$8
        }
        $2 = $3 + 80 | 0 | 1 | 0;
        $1 = $3 + 89 | 0;
        label$9 : while (1) {
         label$10 : {
          label$11 : {
           $4 = HEAP32[($3 + 60 | 0) >> 2] | 0;
           if (!$4) {
            break label$11
           }
           i64toi32_i32$2 = $3;
           i64toi32_i32$0 = HEAP32[($3 + 64 | 0) >> 2] | 0;
           i64toi32_i32$1 = HEAP32[($3 + 68 | 0) >> 2] | 0;
           $8 = i64toi32_i32$0;
           $8$hi = i64toi32_i32$1;
           $serde_json__de__MapAccess_R__20as_20serde__de__MapAccess___next_value_seed__hacf927117f4e5996($3 + 80 | 0 | 0, $3 + 8 | 0 | 0);
           label$12 : {
            if ((HEAP32[($3 + 80 | 0) >> 2] | 0 | 0) != (1 | 0)) {
             break label$12
            }
            $1 = HEAP32[($3 + 84 | 0) >> 2] | 0;
            i64toi32_i32$1 = $8$hi;
            $2 = $8;
            if (!$2) {
             break label$3
            }
            __rust_dealloc($4 | 0, $2 | 0, 1 | 0);
            break label$3;
           }
           $5 = ($3 + 32 | 0) + 8 | 0;
           i64toi32_i32$2 = $1 + 8 | 0;
           i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $114 = i64toi32_i32$1;
           i64toi32_i32$1 = $5;
           HEAP32[i64toi32_i32$1 >> 2] = $114;
           HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
           $6 = ($3 + 32 | 0) + 15 | 0;
           i64toi32_i32$2 = $1 + 15 | 0;
           i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $121 = i64toi32_i32$0;
           i64toi32_i32$0 = $6;
           $25 = $121;
           HEAP8[i64toi32_i32$0 >> 0] = $25;
           HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $25 >>> 8 | 0;
           HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $25 >>> 16 | 0;
           HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $25 >>> 24 | 0;
           HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
           HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
           HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
           HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
           i64toi32_i32$2 = $1;
           i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
           $124 = i64toi32_i32$1;
           i64toi32_i32$1 = $3;
           HEAP32[($3 + 32 | 0) >> 2] = $124;
           HEAP32[($3 + 36 | 0) >> 2] = i64toi32_i32$0;
           $7 = HEAPU8[($3 + 88 | 0) >> 0] | 0;
           if (($7 | 0) != (6 | 0)) {
            break label$10
           }
          }
          $26 = $3 + 91 | 0;
          $27 = HEAP32[(($3 + 16 | 0) + 8 | 0) >> 2] | 0;
          HEAP8[$26 >> 0] = $27;
          HEAP8[($26 + 1 | 0) >> 0] = $27 >>> 8 | 0;
          HEAP8[($26 + 2 | 0) >> 0] = $27 >>> 16 | 0;
          HEAP8[($26 + 3 | 0) >> 0] = $27 >>> 24 | 0;
          HEAP8[($0 + 8 | 0) >> 0] = 5;
          HEAP32[$0 >> 2] = 0;
          i64toi32_i32$2 = $3;
          i64toi32_i32$0 = HEAP32[($3 + 16 | 0) >> 2] | 0;
          i64toi32_i32$1 = HEAP32[($3 + 20 | 0) >> 2] | 0;
          $140 = i64toi32_i32$0;
          i64toi32_i32$0 = $3;
          $28 = $140;
          HEAP8[($3 + 83 | 0) >> 0] = $28;
          HEAP8[($3 + 84 | 0) >> 0] = $28 >>> 8 | 0;
          HEAP8[($3 + 85 | 0) >> 0] = $28 >>> 16 | 0;
          HEAP8[($3 + 86 | 0) >> 0] = $28 >>> 24 | 0;
          HEAP8[($3 + 87 | 0) >> 0] = i64toi32_i32$1;
          HEAP8[($3 + 88 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
          HEAP8[($3 + 89 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
          HEAP8[($3 + 90 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
          i64toi32_i32$2 = $3;
          i64toi32_i32$1 = HEAPU8[($3 + 80 | 0) >> 0] | 0 | ((HEAPU8[($3 + 81 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 82 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 83 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          i64toi32_i32$0 = HEAPU8[($3 + 84 | 0) >> 0] | 0 | ((HEAPU8[($3 + 85 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 86 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 87 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          $144 = i64toi32_i32$1;
          i64toi32_i32$1 = $0 + 9 | 0;
          $29 = $144;
          HEAP8[i64toi32_i32$1 >> 0] = $29;
          HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $29 >>> 8 | 0;
          HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $29 >>> 16 | 0;
          HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $29 >>> 24 | 0;
          HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
          HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
          HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
          HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
          i64toi32_i32$2 = $3 + 87 | 0;
          i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          $149 = i64toi32_i32$0;
          i64toi32_i32$0 = $0 + 16 | 0;
          $30 = $149;
          HEAP8[i64toi32_i32$0 >> 0] = $30;
          HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $30 >>> 8 | 0;
          HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $30 >>> 16 | 0;
          HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $30 >>> 24 | 0;
          HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
          HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
          HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
          HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
          break label$1;
         }
         i64toi32_i32$1 = $8$hi;
         i64toi32_i32$0 = $3;
         HEAP32[($3 + 116 | 0) >> 2] = $8;
         HEAP32[($3 + 120 | 0) >> 2] = i64toi32_i32$1;
         HEAP32[($3 + 112 | 0) >> 2] = $4;
         i64toi32_i32$2 = $3;
         i64toi32_i32$1 = HEAP32[($3 + 32 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($3 + 36 | 0) >> 2] | 0;
         $156 = i64toi32_i32$1;
         i64toi32_i32$1 = $2;
         $31 = $156;
         HEAP8[i64toi32_i32$1 >> 0] = $31;
         HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $31 >>> 8 | 0;
         HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $31 >>> 16 | 0;
         HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $31 >>> 24 | 0;
         HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
         HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
         HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
         HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
         i64toi32_i32$2 = $5;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $160 = i64toi32_i32$0;
         i64toi32_i32$0 = $2 + 8 | 0;
         $32 = $160;
         HEAP8[i64toi32_i32$0 >> 0] = $32;
         HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $32 >>> 8 | 0;
         HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $32 >>> 16 | 0;
         HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $32 >>> 24 | 0;
         HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
         HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
         HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
         HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
         i64toi32_i32$2 = $6;
         i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $164 = i64toi32_i32$1;
         i64toi32_i32$1 = $2 + 15 | 0;
         $33 = $164;
         HEAP8[i64toi32_i32$1 >> 0] = $33;
         HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $33 >>> 8 | 0;
         HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $33 >>> 16 | 0;
         HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $33 >>> 24 | 0;
         HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
         HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
         HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
         HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
         HEAP8[($3 + 80 | 0) >> 0] = $7;
         alloc__collections__btree__map__BTreeMap_K_2cV___insert__h676f968c46c3ef24($3 + 56 | 0 | 0, $3 + 16 | 0 | 0, $3 + 112 | 0 | 0, $3 + 80 | 0 | 0);
         label$13 : {
          if ((HEAPU8[($3 + 56 | 0) >> 0] | 0 | 0) == (6 | 0)) {
           break label$13
          }
          core__ptr__drop_in_place_serde_json__value__Value___hb5131c85f9c77304_1($3 + 56 | 0 | 0);
         }
         $serde_json__de__MapAccess_R__20as_20serde__de__MapAccess___next_key_seed__hcd57db292bb18be3($3 + 56 | 0 | 0, $3 + 8 | 0 | 0);
         if ((HEAP32[($3 + 56 | 0) >> 2] | 0 | 0) != (1 | 0)) {
          continue label$9
         }
         break label$9;
        };
       }
       $1 = HEAP32[($3 + 60 | 0) >> 2] | 0;
       break label$3;
      }
      $1 = HEAP32[($3 + 84 | 0) >> 2] | 0;
      HEAP32[$0 >> 2] = 1;
      HEAP32[($0 + 4 | 0) >> 2] = $1;
      break label$1;
     }
     HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($3 + 84 | 0) >> 2] | 0;
     HEAP32[$0 >> 2] = 1;
     i64toi32_i32$0 = $8$hi;
     $0 = $8;
     if (!$0) {
      break label$2
     }
     __rust_dealloc($1 | 0, $0 | 0, 1 | 0);
     break label$2;
    }
    HEAP32[$0 >> 2] = 1;
    HEAP32[($0 + 4 | 0) >> 2] = $1;
   }
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h0198cfc402357e50($3 + 16 | 0 | 0);
  }
  global$0 = $3 + 128 | 0;
 }
 
 function cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__add_input__hd22960e5a7d88824($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, $5 = 0, $6 = 0, $7 = 0, $35 = 0, $36 = 0, $37 = 0, $38 = 0, $39 = 0, $40 = 0, $41 = 0, $43 = 0, $44 = 0, $45 = 0, $46 = 0, $47 = 0, $48 = 0, $49 = 0, $51 = 0, $52 = 0, $53 = 0, $55 = 0, $56 = 0, $57 = 0, $58 = 0, $59 = 0, $60 = 0, $62 = 0, $63 = 0, $64 = 0, $65 = 0, $66 = 0, $67 = 0, $68 = 0, $69 = 0, $70 = 0, $71 = 0, $72 = 0, $26 = 0, $32 = 0, $42 = 0, $50 = 0, $54 = 0, $61 = 0, $74 = 0, $79 = 0, $87 = 0, $99 = 0, $104 = 0, $112 = 0, $127 = 0, $133 = 0, $143 = 0, $151 = 0, $155 = 0, $162 = 0, $176 = 0, $180 = 0, $183 = 0, $197 = 0, $201 = 0, $204 = 0;
  $4 = global$0 - 128 | 0;
  global$0 = $4;
  cardano_serialization_lib__address__BaseAddress__from_address__h3190075870a36e33($4 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        $5 = HEAPU8[($4 + 1 | 0) >> 0] | 0;
        if (($5 | 0) != (2 | 0)) {
         break label$6
        }
        $5 = HEAPU8[$1 >> 0] | 0;
        if (($5 | 0) != (2 | 0)) {
         break label$5
        }
        $5 = $4 + 72 | 0;
        i64toi32_i32$2 = $1 + 11 | 0;
        i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $26 = i64toi32_i32$0;
        i64toi32_i32$0 = $5;
        HEAP32[i64toi32_i32$0 >> 2] = $26;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        $6 = $4 + 80 | 0;
        i64toi32_i32$2 = $1 + 19 | 0;
        i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $32 = i64toi32_i32$1;
        i64toi32_i32$1 = $6;
        HEAP32[i64toi32_i32$1 >> 2] = $32;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        $7 = $4 + 88 | 0;
        $35 = $1 + 27 | 0;
        HEAP32[$7 >> 2] = HEAPU8[$35 >> 0] | 0 | ((HEAPU8[($35 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($35 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($35 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$2 = $1 + 3 | 0;
        i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $42 = i64toi32_i32$0;
        i64toi32_i32$0 = $4;
        HEAP32[($4 + 64 | 0) >> 2] = $42;
        HEAP32[($4 + 68 | 0) >> 2] = i64toi32_i32$1;
        if ((HEAPU8[($1 + 2 | 0) >> 0] | 0 | 0) != (1 | 0)) {
         break label$4
        }
        i64toi32_i32$2 = $5;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $50 = i64toi32_i32$1;
        i64toi32_i32$1 = $4 + 9 | 0;
        $36 = $50;
        HEAP8[i64toi32_i32$1 >> 0] = $36;
        HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $36 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $36 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $36 >>> 24 | 0;
        HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
        HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
        i64toi32_i32$2 = $6;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $54 = i64toi32_i32$0;
        i64toi32_i32$0 = $4 + 17 | 0;
        $37 = $54;
        HEAP8[i64toi32_i32$0 >> 0] = $37;
        HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $37 >>> 8 | 0;
        HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $37 >>> 16 | 0;
        HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $37 >>> 24 | 0;
        HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
        HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
        HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
        HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
        $38 = $4 + 25 | 0;
        $39 = HEAP32[$7 >> 2] | 0;
        HEAP8[$38 >> 0] = $39;
        HEAP8[($38 + 1 | 0) >> 0] = $39 >>> 8 | 0;
        HEAP8[($38 + 2 | 0) >> 0] = $39 >>> 16 | 0;
        HEAP8[($38 + 3 | 0) >> 0] = $39 >>> 24 | 0;
        i64toi32_i32$2 = $4;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
        $61 = i64toi32_i32$1;
        i64toi32_i32$1 = i64toi32_i32$2;
        $40 = $61;
        HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $40;
        HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $40 >>> 8 | 0;
        HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $40 >>> 16 | 0;
        HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = $40 >>> 24 | 0;
        HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$0;
        HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
        HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
        HEAP8[(i64toi32_i32$2 + 8 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
        HEAP8[i64toi32_i32$2 >> 0] = 1;
        cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__add_script_input__ha8e1111a100bff34($0 | 0, i64toi32_i32$2 | 1 | 0 | 0, $2 | 0, $3 | 0);
        break label$1;
       }
       label$7 : {
        if (($5 | 0) != (1 | 0)) {
         break label$7
        }
        i64toi32_i32$2 = $4 + 10 | 0;
        i64toi32_i32$0 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
        i64toi32_i32$1 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
        $74 = i64toi32_i32$0;
        i64toi32_i32$0 = $4 + 73 | 0;
        $41 = $74;
        HEAP8[i64toi32_i32$0 >> 0] = $41;
        HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $41 >>> 8 | 0;
        HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $41 >>> 16 | 0;
        HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $41 >>> 24 | 0;
        HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
        HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
        HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
        HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
        i64toi32_i32$2 = $4 + 18 | 0;
        i64toi32_i32$1 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
        i64toi32_i32$0 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
        $79 = i64toi32_i32$1;
        i64toi32_i32$1 = $4 + 81 | 0;
        $43 = $79;
        HEAP8[i64toi32_i32$1 >> 0] = $43;
        HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $43 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $43 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $43 >>> 24 | 0;
        HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
        HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
        $71 = $4 + 26 | 0;
        $44 = $4 + 89 | 0;
        $45 = HEAPU16[$71 >> 1] | 0 | ((HEAPU16[($71 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
        HEAP8[$44 >> 0] = $45;
        HEAP8[($44 + 1 | 0) >> 0] = $45 >>> 8 | 0;
        HEAP8[($44 + 2 | 0) >> 0] = $45 >>> 16 | 0;
        HEAP8[($44 + 3 | 0) >> 0] = $45 >>> 24 | 0;
        i64toi32_i32$2 = $4;
        i64toi32_i32$0 = HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0) << 16 | 0) | 0;
        i64toi32_i32$1 = HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 8 | 0) >> 1] | 0) << 16 | 0) | 0;
        $87 = i64toi32_i32$0;
        i64toi32_i32$0 = i64toi32_i32$2;
        $46 = $87;
        HEAP8[(i64toi32_i32$2 + 65 | 0) >> 0] = $46;
        HEAP8[(i64toi32_i32$2 + 66 | 0) >> 0] = $46 >>> 8 | 0;
        HEAP8[(i64toi32_i32$2 + 67 | 0) >> 0] = $46 >>> 16 | 0;
        HEAP8[(i64toi32_i32$2 + 68 | 0) >> 0] = $46 >>> 24 | 0;
        HEAP8[(i64toi32_i32$2 + 69 | 0) >> 0] = i64toi32_i32$1;
        HEAP8[(i64toi32_i32$2 + 70 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
        HEAP8[(i64toi32_i32$2 + 71 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
        HEAP8[(i64toi32_i32$2 + 72 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
        HEAP8[(i64toi32_i32$2 + 64 | 0) >> 0] = 1;
        cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__add_script_input__ha8e1111a100bff34($0 | 0, i64toi32_i32$2 + 64 | 0 | 1 | 0 | 0, $2 | 0, $3 | 0);
        break label$1;
       }
       i64toi32_i32$2 = $4 + 10 | 0;
       i64toi32_i32$1 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
       i64toi32_i32$0 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
       $99 = i64toi32_i32$1;
       i64toi32_i32$1 = $4 + 73 | 0;
       $47 = $99;
       HEAP8[i64toi32_i32$1 >> 0] = $47;
       HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $47 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $47 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $47 >>> 24 | 0;
       HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
       HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
       i64toi32_i32$2 = $4 + 18 | 0;
       i64toi32_i32$0 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
       i64toi32_i32$1 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
       $104 = i64toi32_i32$0;
       i64toi32_i32$0 = $4 + 81 | 0;
       $48 = $104;
       HEAP8[i64toi32_i32$0 >> 0] = $48;
       HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $48 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $48 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $48 >>> 24 | 0;
       HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
       HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
       $72 = $4 + 26 | 0;
       $49 = $4 + 89 | 0;
       $51 = HEAPU16[$72 >> 1] | 0 | ((HEAPU16[($72 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
       HEAP8[$49 >> 0] = $51;
       HEAP8[($49 + 1 | 0) >> 0] = $51 >>> 8 | 0;
       HEAP8[($49 + 2 | 0) >> 0] = $51 >>> 16 | 0;
       HEAP8[($49 + 3 | 0) >> 0] = $51 >>> 24 | 0;
       i64toi32_i32$2 = $4;
       i64toi32_i32$1 = HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0) << 16 | 0) | 0;
       i64toi32_i32$0 = HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 8 | 0) >> 1] | 0) << 16 | 0) | 0;
       $112 = i64toi32_i32$1;
       i64toi32_i32$1 = i64toi32_i32$2;
       $52 = $112;
       HEAP8[(i64toi32_i32$2 + 65 | 0) >> 0] = $52;
       HEAP8[(i64toi32_i32$2 + 66 | 0) >> 0] = $52 >>> 8 | 0;
       HEAP8[(i64toi32_i32$2 + 67 | 0) >> 0] = $52 >>> 16 | 0;
       HEAP8[(i64toi32_i32$2 + 68 | 0) >> 0] = $52 >>> 24 | 0;
       HEAP8[(i64toi32_i32$2 + 69 | 0) >> 0] = i64toi32_i32$0;
       HEAP8[(i64toi32_i32$2 + 70 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
       HEAP8[(i64toi32_i32$2 + 71 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
       HEAP8[(i64toi32_i32$2 + 72 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
       HEAP8[(i64toi32_i32$2 + 64 | 0) >> 0] = 1;
       cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__add_key_input__hcbbcffc3c6e022ad($0 | 0, i64toi32_i32$2 + 64 | 0 | 1 | 0 | 0, $2 | 0, $3 | 0);
       break label$1;
      }
      if (($5 | 0) != (1 | 0)) {
       break label$2
      }
      $5 = $4 + 72 | 0;
      i64toi32_i32$2 = $1 + 42 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $127 = i64toi32_i32$0;
      i64toi32_i32$0 = $5;
      HEAP32[i64toi32_i32$0 >> 2] = $127;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      $6 = $4 + 80 | 0;
      i64toi32_i32$2 = $1 + 50 | 0;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $133 = i64toi32_i32$1;
      i64toi32_i32$1 = $6;
      HEAP32[i64toi32_i32$1 >> 2] = $133;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      $7 = $4 + 88 | 0;
      $53 = $1 + 58 | 0;
      HEAP32[$7 >> 2] = HEAPU8[$53 >> 0] | 0 | ((HEAPU8[($53 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($53 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($53 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$2 = $1 + 34 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $143 = i64toi32_i32$0;
      i64toi32_i32$0 = $4;
      HEAP32[(i64toi32_i32$0 + 64 | 0) >> 2] = $143;
      HEAP32[(i64toi32_i32$0 + 68 | 0) >> 2] = i64toi32_i32$1;
      if ((HEAPU8[($1 + 33 | 0) >> 0] | 0 | 0) != (1 | 0)) {
       break label$3
      }
      i64toi32_i32$2 = $5;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $151 = i64toi32_i32$1;
      i64toi32_i32$1 = $4 + 9 | 0;
      $55 = $151;
      HEAP8[i64toi32_i32$1 >> 0] = $55;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $55 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $55 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $55 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      i64toi32_i32$2 = $6;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $155 = i64toi32_i32$0;
      i64toi32_i32$0 = $4 + 17 | 0;
      $56 = $155;
      HEAP8[i64toi32_i32$0 >> 0] = $56;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $56 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $56 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $56 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      $57 = $4 + 25 | 0;
      $58 = HEAP32[$7 >> 2] | 0;
      HEAP8[$57 >> 0] = $58;
      HEAP8[($57 + 1 | 0) >> 0] = $58 >>> 8 | 0;
      HEAP8[($57 + 2 | 0) >> 0] = $58 >>> 16 | 0;
      HEAP8[($57 + 3 | 0) >> 0] = $58 >>> 24 | 0;
      i64toi32_i32$2 = $4;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
      $162 = i64toi32_i32$1;
      i64toi32_i32$1 = i64toi32_i32$2;
      $59 = $162;
      HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $59;
      HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $59 >>> 8 | 0;
      HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $59 >>> 16 | 0;
      HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = $59 >>> 24 | 0;
      HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$2 + 8 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      HEAP8[i64toi32_i32$2 >> 0] = 1;
      cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__add_script_input__ha8e1111a100bff34($0 | 0, i64toi32_i32$2 | 1 | 0 | 0, $2 | 0, $3 | 0);
      break label$1;
     }
     $60 = $4 + 25 | 0;
     $62 = HEAP32[$7 >> 2] | 0;
     HEAP8[$60 >> 0] = $62;
     HEAP8[($60 + 1 | 0) >> 0] = $62 >>> 8 | 0;
     HEAP8[($60 + 2 | 0) >> 0] = $62 >>> 16 | 0;
     HEAP8[($60 + 3 | 0) >> 0] = $62 >>> 24 | 0;
     i64toi32_i32$2 = $6;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $176 = i64toi32_i32$0;
     i64toi32_i32$0 = $4 + 17 | 0;
     $63 = $176;
     HEAP8[i64toi32_i32$0 >> 0] = $63;
     HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $63 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $63 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $63 >>> 24 | 0;
     HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
     HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
     i64toi32_i32$2 = $5;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $180 = i64toi32_i32$1;
     i64toi32_i32$1 = $4 + 9 | 0;
     $64 = $180;
     HEAP8[i64toi32_i32$1 >> 0] = $64;
     HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $64 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $64 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $64 >>> 24 | 0;
     HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
     HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
     i64toi32_i32$2 = $4;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
     $183 = i64toi32_i32$0;
     i64toi32_i32$0 = i64toi32_i32$2;
     $65 = $183;
     HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $65;
     HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $65 >>> 8 | 0;
     HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $65 >>> 16 | 0;
     HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = $65 >>> 24 | 0;
     HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$1;
     HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
     HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
     HEAP8[(i64toi32_i32$2 + 8 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
     HEAP8[i64toi32_i32$2 >> 0] = 1;
     cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__add_key_input__hcbbcffc3c6e022ad($0 | 0, i64toi32_i32$2 | 1 | 0 | 0, $2 | 0, $3 | 0);
     break label$1;
    }
    $66 = $4 + 25 | 0;
    $67 = HEAP32[$7 >> 2] | 0;
    HEAP8[$66 >> 0] = $67;
    HEAP8[($66 + 1 | 0) >> 0] = $67 >>> 8 | 0;
    HEAP8[($66 + 2 | 0) >> 0] = $67 >>> 16 | 0;
    HEAP8[($66 + 3 | 0) >> 0] = $67 >>> 24 | 0;
    i64toi32_i32$2 = $6;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $197 = i64toi32_i32$1;
    i64toi32_i32$1 = $4 + 17 | 0;
    $68 = $197;
    HEAP8[i64toi32_i32$1 >> 0] = $68;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $68 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $68 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $68 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$2 = $5;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $201 = i64toi32_i32$0;
    i64toi32_i32$0 = $4 + 9 | 0;
    $69 = $201;
    HEAP8[i64toi32_i32$0 >> 0] = $69;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $69 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $69 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $69 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
    $204 = i64toi32_i32$1;
    i64toi32_i32$1 = i64toi32_i32$2;
    $70 = $204;
    HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $70;
    HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $70 >>> 8 | 0;
    HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $70 >>> 16 | 0;
    HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = $70 >>> 24 | 0;
    HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$2 + 8 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    HEAP8[i64toi32_i32$2 >> 0] = 1;
    cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__add_key_input__hcbbcffc3c6e022ad($0 | 0, i64toi32_i32$2 | 1 | 0 | 0, $2 | 0, $3 | 0);
    break label$1;
   }
   cardano_serialization_lib__address__ByronAddress__from_address__hda2f43a52fcf6ed4($4 | 0, $1 | 0);
   if ((HEAP32[($4 + 12 | 0) >> 2] | 0 | 0) == (2 | 0)) {
    break label$1
   }
   cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__add_bootstrap_input__h233fca55423e7cf8($0 | 0, $4 | 0, $2 | 0, $3 | 0);
   if ((HEAP32[($4 + 12 | 0) >> 2] | 0 | 0) == (2 | 0)) {
    break label$1
   }
   core__ptr__drop_in_place_core__option__Option_alloc__vec__Vec_u8_____ha5300c747747c3c8_2($4 | 0);
  }
  global$0 = $4 + 128 | 0;
 }
 
 function num_bigint__biguint__shift__biguint_shl2__h51620e0a9215508c($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $5 = 0, $6 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $9 = 0, $8 = 0, $7 = 0, $11 = 0, $12 = 0, $75 = 0, $96 = 0, $10 = 0, $12$hi = 0, $205 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0, wasm2js_i32$2 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  $5 = HEAP32[$1 >> 2] | 0;
  label$1 : {
   label$2 : {
    if ($2) {
     break label$2
    }
    $6 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    label$3 : {
     label$4 : {
      if (($5 | 0) == (1 | 0)) {
       break label$4
      }
      $7 = HEAP32[$6 >> 2] | 0;
      $5 = HEAP32[($6 + 8 | 0) >> 2] | 0;
      alloc__raw_vec__RawVec_T_2cA___allocate_in__hb0817f92bbb8999a($4 | 0, $5 | 0, 0 | 0);
      $8 = HEAP32[($4 + 4 | 0) >> 2] | 0;
      $6 = HEAP32[$4 >> 2] | 0;
      memcpy($6 | 0, $7 | 0, $5 << 2 | 0 | 0) | 0;
      break label$3;
     }
     $8 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     $5 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    }
    HEAP32[($4 + 24 | 0) >> 2] = $5;
    HEAP32[($4 + 20 | 0) >> 2] = $8;
    HEAP32[($4 + 16 | 0) >> 2] = $6;
    break label$1;
   }
   $5 = (wasm2js_i32$0 = $1 + 4 | 0, wasm2js_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0, wasm2js_i32$2 = ($5 | 0) == (1 | 0), wasm2js_i32$2 ? wasm2js_i32$0 : wasm2js_i32$1);
   $6 = ((HEAP32[($5 + 8 | 0) >> 2] | 0) + $2 | 0) + 1 | 0;
   alloc__raw_vec__RawVec_T_2cA___allocate_in__hb0817f92bbb8999a($4 + 8 | 0 | 0, ($6 >>> 0 < $2 >>> 0 ? -1 : $6) | 0, 0 | 0);
   $6 = ($4 + 32 | 0) + 8 | 0;
   HEAP32[$6 >> 2] = 0;
   i64toi32_i32$0 = HEAP32[($4 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($4 + 12 | 0) >> 2] | 0;
   $75 = i64toi32_i32$0;
   i64toi32_i32$0 = $4;
   HEAP32[($4 + 32 | 0) >> 2] = $75;
   HEAP32[($4 + 36 | 0) >> 2] = i64toi32_i32$1;
   alloc__vec__Vec_T_2cA___extend_with__hc50aa39afa7f1d36($4 + 32 | 0 | 0, $2 | 0, 0 | 0);
   $8 = HEAP32[$5 >> 2] | 0;
   $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend__T_2ccore__slice__iter__Iter_T_____spec_extend__h5cdab7a667860bc4($4 + 32 | 0 | 0, $8 | 0, $8 + ((HEAP32[($5 + 8 | 0) >> 2] | 0) << 2 | 0) | 0 | 0);
   HEAP32[(($4 + 16 | 0) + 8 | 0) >> 2] = HEAP32[$6 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($4 + 32 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($4 + 36 | 0) >> 2] | 0;
   $96 = i64toi32_i32$1;
   i64toi32_i32$1 = $4;
   HEAP32[($4 + 16 | 0) >> 2] = $96;
   HEAP32[($4 + 20 | 0) >> 2] = i64toi32_i32$0;
  }
  label$5 : {
   label$6 : {
    label$7 : {
     label$8 : {
      if (!($3 & 255 | 0)) {
       break label$8
      }
      $9 = HEAP32[($4 + 24 | 0) >> 2] | 0;
      if ($9 >>> 0 < $2 >>> 0) {
       break label$7
      }
      if (($9 | 0) == ($2 | 0)) {
       break label$8
      }
      $5 = $2 << 2 | 0;
      $6 = ($9 << 2 | 0) - $5 | 0;
      $7 = $3 & 31 | 0;
      $10 = (0 - $3 | 0) & 31 | 0;
      $11 = HEAP32[($4 + 16 | 0) >> 2] | 0;
      $3 = $11 + $5 | 0;
      $5 = 0;
      label$9 : while (1) {
       $8 = HEAP32[$3 >> 2] | 0;
       HEAP32[$3 >> 2] = $8 << $7 | 0 | $5 | 0;
       $3 = $3 + 4 | 0;
       $5 = $8 >>> $10 | 0;
       $6 = $6 + -4 | 0;
       if ($6) {
        continue label$9
       }
       break label$9;
      };
      if (!$5) {
       break label$8
      }
      label$10 : {
       if ((HEAP32[($4 + 20 | 0) >> 2] | 0 | 0) != ($9 | 0)) {
        break label$10
       }
       alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h90c9768825cdae1b($4 + 16 | 0 | 0, $9 | 0, 1 | 0);
       $11 = HEAP32[($4 + 16 | 0) >> 2] | 0;
       $9 = HEAP32[($4 + 24 | 0) >> 2] | 0;
      }
      HEAP32[($11 + ($9 << 2 | 0) | 0) >> 2] = $5;
      HEAP32[($4 + 24 | 0) >> 2] = $9 + 1 | 0;
     }
     $5 = HEAP32[(($4 + 16 | 0) + 8 | 0) >> 2] | 0;
     HEAP32[(($4 + 32 | 0) + 8 | 0) >> 2] = $5;
     i64toi32_i32$0 = HEAP32[($4 + 16 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($4 + 20 | 0) >> 2] | 0;
     $12 = i64toi32_i32$0;
     $12$hi = i64toi32_i32$1;
     i64toi32_i32$0 = $4;
     HEAP32[($4 + 32 | 0) >> 2] = $12;
     HEAP32[($4 + 36 | 0) >> 2] = i64toi32_i32$1;
     label$11 : {
      if ($5) {
       break label$11
      }
      $5 = 0;
      break label$5;
     }
     i64toi32_i32$1 = $12$hi;
     $3 = (($5 << 2 | 0) + $12 | 0) + -4 | 0;
     label$12 : while (1) {
      if (HEAP32[$3 >> 2] | 0) {
       break label$6
      }
      $3 = $3 + -4 | 0;
      $5 = $5 + -1 | 0;
      if ($5) {
       continue label$12
      }
      break label$12;
     };
     $5 = 0;
     break label$6;
    }
    core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($2 | 0, $9 | 0, 1077460 | 0);
    abort();
   }
   HEAP32[($4 + 40 | 0) >> 2] = $5;
  }
  label$13 : {
   $3 = HEAP32[($4 + 36 | 0) >> 2] | 0;
   if ($5 >>> 0 >= ($3 >>> 2 | 0) >>> 0) {
    break label$13
   }
   if ($3 >>> 0 <= $5 >>> 0) {
    break label$13
   }
   alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($4 + 32 | 0 | 0, $5 | 0);
  }
  i64toi32_i32$1 = HEAP32[($4 + 32 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($4 + 36 | 0) >> 2] | 0;
  $205 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $205;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($4 + 32 | 0) + 8 | 0) >> 2] | 0;
  label$14 : {
   if (!$2) {
    break label$14
   }
   if (!(HEAP32[$1 >> 2] | 0)) {
    break label$14
   }
   $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   if (!$3) {
    break label$14
   }
   $3 = $3 << 2 | 0;
   if (!$3) {
    break label$14
   }
   __rust_dealloc(HEAP32[($1 + 4 | 0) >> 2] | 0 | 0, $3 | 0, 4 | 0);
  }
  global$0 = $4 + 48 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__TimelockStart___deserialize__h0421432721709e93($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, $2 = 0, $4 = 0, i64toi32_i32$4 = 0, $4$hi = 0, $6 = 0, $6$hi = 0, $3$hi = 0, $5$hi = 0, $3 = 0, $5 = 0, $7 = 0, $7$hi = 0, $8$hi = 0, $8 = 0, $39 = 0, $40 = 0, $41 = 0, $68 = 0, $68$hi = 0, $71 = 0, $71$hi = 0, $75$hi = 0, $77$hi = 0, $79$hi = 0, $82 = 0, $82$hi = 0, $95 = 0, $104 = 0, $108 = 0, $134 = 0, $138 = 0, $162 = 0, $166 = 0, $172 = 0, $183$hi = 0, $185 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 24 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2 + 40 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $3 = i64toi32_i32$0;
  $3$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
  $4 = i64toi32_i32$1;
  $4$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
      i64toi32_i32$2 = i64toi32_i32$0;
      i64toi32_i32$0 = 0;
      i64toi32_i32$3 = 1;
      if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
       break label$4
      }
      i64toi32_i32$2 = 0;
      $5 = 0;
      $5$hi = i64toi32_i32$2;
      label$5 : {
       i64toi32_i32$2 = $4$hi;
       i64toi32_i32$3 = $4;
       i64toi32_i32$1 = 0;
       i64toi32_i32$0 = 1;
       if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
        break label$5
       }
       i64toi32_i32$3 = 0;
       $5 = 2;
       $5$hi = i64toi32_i32$3;
       i64toi32_i32$3 = $3$hi;
       i64toi32_i32$0 = $3;
       i64toi32_i32$2 = 0;
       i64toi32_i32$1 = 2;
       if (i64toi32_i32$3 >>> 0 > i64toi32_i32$2 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$0 >>> 0 >= i64toi32_i32$1 >>> 0 | 0) | 0) {
        break label$5
       }
       $1 = 0;
       i64toi32_i32$0 = 0;
       $6 = 3;
       $6$hi = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       $7 = 0;
       $7$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $3$hi;
       $4 = $3;
       $4$hi = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       $8 = 0;
       $8$hi = i64toi32_i32$0;
       break label$2;
      }
      i64toi32_i32$0 = $4$hi;
      i64toi32_i32$3 = i64toi32_i32$0;
      cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__TimelockStart___deserialize_as_embedded_group__h4f29e66be5595f76($2 + 24 | 0 | 0, $1 | 0, $4 | 0, i64toi32_i32$0 | 0, $4 | 0, i64toi32_i32$0 | 0);
      i64toi32_i32$3 = 0;
      $7 = 1;
      $7$hi = i64toi32_i32$3;
      label$6 : {
       label$7 : {
        label$8 : {
         i64toi32_i32$3 = i64toi32_i32$0;
         i64toi32_i32$3 = i64toi32_i32$0;
         i64toi32_i32$1 = $4;
         i64toi32_i32$0 = 0;
         i64toi32_i32$2 = 1;
         if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) | 0) {
          break label$8
         }
         cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 112 | 0 | 0, $1 | 0);
         $1 = HEAPU8[($2 + 120 | 0) >> 0] | 0;
         i64toi32_i32$2 = $2;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 112 | 0) >> 2] | 0;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 116 | 0) >> 2] | 0;
         i64toi32_i32$2 = i64toi32_i32$1;
         i64toi32_i32$1 = 0;
         i64toi32_i32$0 = 1;
         if ((i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) | 0) {
          break label$7
         }
         if (($1 & 255 | 0 | 0) == (5 | 0)) {
          break label$6
         }
         i64toi32_i32$2 = 0;
         $6 = 5;
         $6$hi = i64toi32_i32$2;
         break label$3;
        }
        i64toi32_i32$2 = 0;
        $6 = 3;
        $6$hi = i64toi32_i32$2;
        i64toi32_i32$2 = $5$hi;
        i64toi32_i32$2 = $3$hi;
        i64toi32_i32$2 = $5$hi;
        i64toi32_i32$0 = $5;
        i64toi32_i32$3 = $3$hi;
        i64toi32_i32$1 = $3;
        if ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) | 0) {
         break label$6
        }
        break label$3;
       }
       i64toi32_i32$1 = $2 + 152 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $4 = i64toi32_i32$0;
       $4$hi = i64toi32_i32$2;
       i64toi32_i32$0 = ($2 + 96 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $4;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$0 = ($2 + 8 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $4;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$1 = $2 + 144 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $4 = i64toi32_i32$2;
       $4$hi = i64toi32_i32$0;
       i64toi32_i32$2 = $2;
       HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] = $4;
       HEAP32[(i64toi32_i32$2 + 100 | 0) >> 2] = i64toi32_i32$0;
       HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $4;
       HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$1 = i64toi32_i32$2;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 121 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 122 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 123 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 124 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = 0;
       $68 = i64toi32_i32$0;
       $68$hi = i64toi32_i32$2;
       i64toi32_i32$1 = i64toi32_i32$1 + 125 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
       i64toi32_i32$0 = 0;
       $71 = i64toi32_i32$2;
       $71$hi = i64toi32_i32$0;
       i64toi32_i32$1 = $2 + 127 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
       i64toi32_i32$2 = 0;
       i64toi32_i32$1 = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        $39 = 0;
       } else {
        i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
        $39 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       }
       $75$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $71$hi;
       i64toi32_i32$2 = $71;
       i64toi32_i32$1 = $75$hi;
       i64toi32_i32$3 = $39;
       i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $40 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $40 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       $77$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $68$hi;
       i64toi32_i32$1 = $68;
       i64toi32_i32$0 = $77$hi;
       i64toi32_i32$3 = $40;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 8;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $41 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
        $41 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       $79$hi = i64toi32_i32$1;
       i64toi32_i32$1 = 0;
       i64toi32_i32$0 = $1;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 255;
       i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
       $82 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
       $82$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $79$hi;
       i64toi32_i32$1 = $41;
       i64toi32_i32$0 = $82$hi;
       i64toi32_i32$3 = $82;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
       $3 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       $3$hi = i64toi32_i32$0;
       i64toi32_i32$2 = $2 + 136 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $5 = i64toi32_i32$0;
       $5$hi = i64toi32_i32$1;
       i64toi32_i32$2 = $2 + 128 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $7 = i64toi32_i32$1;
       $7$hi = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       $6 = 2;
       $6$hi = i64toi32_i32$0;
       break label$3;
      }
      i64toi32_i32$2 = $2 + 72 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $95 = i64toi32_i32$0;
      i64toi32_i32$0 = ($2 + 8 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $95;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[(($2 + 112 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 92 | 0) >> 2] | 0;
      i64toi32_i32$2 = $2;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 84 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 88 | 0) >> 2] | 0;
      $104 = i64toi32_i32$1;
      i64toi32_i32$1 = i64toi32_i32$2;
      HEAP32[(i64toi32_i32$2 + 112 | 0) >> 2] = $104;
      HEAP32[(i64toi32_i32$2 + 116 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = i64toi32_i32$2 + 64 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $108 = i64toi32_i32$0;
      i64toi32_i32$0 = $2;
      HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $108;
      HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = i64toi32_i32$0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
      $6 = i64toi32_i32$1;
      $6$hi = i64toi32_i32$0;
      label$9 : {
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
       i64toi32_i32$2 = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 1;
       if ((i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$0 | 0) | 0) {
        break label$9
       }
       i64toi32_i32$2 = $6$hi;
       i64toi32_i32$3 = $6;
       i64toi32_i32$1 = -1;
       i64toi32_i32$0 = -256;
       i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
       $8 = i64toi32_i32$3 & i64toi32_i32$0 | 0;
       $8$hi = i64toi32_i32$1;
       i64toi32_i32$2 = $2 + 56 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $5 = i64toi32_i32$1;
       $5$hi = i64toi32_i32$3;
       i64toi32_i32$2 = $2 + 48 | 0;
       i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $7 = i64toi32_i32$3;
       $7$hi = i64toi32_i32$1;
       i64toi32_i32$2 = $2 + 40 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $4 = i64toi32_i32$1;
       $4$hi = i64toi32_i32$3;
       $1 = HEAP32[($2 + 80 | 0) >> 2] | 0;
       break label$2;
      }
      i64toi32_i32$3 = $6$hi;
      i64toi32_i32$1 = $0;
      HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $6;
      HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$3;
      i64toi32_i32$3 = 0;
      $4 = 0;
      $4$hi = i64toi32_i32$3;
      break label$1;
     }
     i64toi32_i32$2 = $2 + 64 | 0;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $134 = i64toi32_i32$3;
     i64toi32_i32$3 = $2 + 16 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $134;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $2 + 56 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $138 = i64toi32_i32$1;
     i64toi32_i32$1 = $2;
     HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $138;
     HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$2 = i64toi32_i32$1 + 48 | 0;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $5 = i64toi32_i32$3;
     $5$hi = i64toi32_i32$1;
     $1 = 0;
     i64toi32_i32$1 = 0;
     $6 = 2;
     $6$hi = i64toi32_i32$1;
     i64toi32_i32$1 = 0;
     $8 = 0;
     $8$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $3$hi;
     $7 = $3;
     $7$hi = i64toi32_i32$1;
     break label$2;
    }
    label$10 : {
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
     if (!(i64toi32_i32$1 | i64toi32_i32$3 | 0)) {
      break label$10
     }
     core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9($2 + 32 | 0 | 0);
    }
    $1 = 0;
    i64toi32_i32$3 = 0;
    $8 = 0;
    $8$hi = i64toi32_i32$3;
    i64toi32_i32$3 = $3$hi;
    $4 = $3;
    $4$hi = i64toi32_i32$3;
   }
   i64toi32_i32$3 = $5$hi;
   i64toi32_i32$1 = $2 + 48 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $5;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$3 = $7$hi;
   i64toi32_i32$1 = $2 + 40 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $7;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$3 = $4$hi;
   i64toi32_i32$1 = ($2 + 24 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $4;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$2 = $2;
   i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
   $162 = i64toi32_i32$3;
   i64toi32_i32$3 = i64toi32_i32$2 + 56 | 0;
   HEAP32[i64toi32_i32$3 >> 2] = $162;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 112 | 0) >> 2] | 0;
   i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 116 | 0) >> 2] | 0;
   $166 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2 + 76 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $166;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$2 = (i64toi32_i32$2 + 8 | 0) + 8 | 0;
   i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $172 = i64toi32_i32$3;
   i64toi32_i32$3 = $2 + 64 | 0;
   HEAP32[i64toi32_i32$3 >> 2] = $172;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($2 + 84 | 0) >> 2] = HEAP32[(($2 + 112 | 0) + 8 | 0) >> 2] | 0;
   HEAP32[($2 + 72 | 0) >> 2] = $1;
   i64toi32_i32$1 = $6$hi;
   i64toi32_i32$2 = $6;
   i64toi32_i32$3 = 0;
   i64toi32_i32$0 = 255;
   i64toi32_i32$3 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
   $183$hi = i64toi32_i32$3;
   i64toi32_i32$3 = $8$hi;
   i64toi32_i32$3 = $183$hi;
   i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
   i64toi32_i32$2 = $8$hi;
   i64toi32_i32$0 = $8;
   i64toi32_i32$2 = i64toi32_i32$3 | i64toi32_i32$2 | 0;
   $185 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
   i64toi32_i32$1 = $2;
   HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = $185;
   HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = i64toi32_i32$2;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, i64toi32_i32$1 + 24 | 0 | 0, 1051809 | 0, 13 | 0);
   i64toi32_i32$2 = 0;
   $4 = 1;
   $4$hi = i64toi32_i32$2;
  }
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $4;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  global$0 = $2 + 160 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__TimelockExpiry___deserialize__hb3d0c85b881e4488($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, $2 = 0, $4 = 0, i64toi32_i32$4 = 0, $4$hi = 0, $6 = 0, $6$hi = 0, $3$hi = 0, $5$hi = 0, $3 = 0, $5 = 0, $7 = 0, $7$hi = 0, $8$hi = 0, $8 = 0, $39 = 0, $40 = 0, $41 = 0, $68 = 0, $68$hi = 0, $71 = 0, $71$hi = 0, $75$hi = 0, $77$hi = 0, $79$hi = 0, $82 = 0, $82$hi = 0, $95 = 0, $104 = 0, $108 = 0, $134 = 0, $138 = 0, $162 = 0, $166 = 0, $172 = 0, $183$hi = 0, $185 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($2 + 24 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2 + 40 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $3 = i64toi32_i32$0;
  $3$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
  $4 = i64toi32_i32$1;
  $4$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
      i64toi32_i32$2 = i64toi32_i32$0;
      i64toi32_i32$0 = 0;
      i64toi32_i32$3 = 1;
      if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
       break label$4
      }
      i64toi32_i32$2 = 0;
      $5 = 0;
      $5$hi = i64toi32_i32$2;
      label$5 : {
       i64toi32_i32$2 = $4$hi;
       i64toi32_i32$3 = $4;
       i64toi32_i32$1 = 0;
       i64toi32_i32$0 = 1;
       if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
        break label$5
       }
       i64toi32_i32$3 = 0;
       $5 = 2;
       $5$hi = i64toi32_i32$3;
       i64toi32_i32$3 = $3$hi;
       i64toi32_i32$0 = $3;
       i64toi32_i32$2 = 0;
       i64toi32_i32$1 = 2;
       if (i64toi32_i32$3 >>> 0 > i64toi32_i32$2 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$0 >>> 0 >= i64toi32_i32$1 >>> 0 | 0) | 0) {
        break label$5
       }
       $1 = 0;
       i64toi32_i32$0 = 0;
       $6 = 3;
       $6$hi = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       $7 = 0;
       $7$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $3$hi;
       $4 = $3;
       $4$hi = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       $8 = 0;
       $8$hi = i64toi32_i32$0;
       break label$2;
      }
      i64toi32_i32$0 = $4$hi;
      i64toi32_i32$3 = i64toi32_i32$0;
      cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__TimelockExpiry___deserialize_as_embedded_group__h31f31ef9c6de3fe5($2 + 24 | 0 | 0, $1 | 0, $4 | 0, i64toi32_i32$0 | 0, $4 | 0, i64toi32_i32$0 | 0);
      i64toi32_i32$3 = 0;
      $7 = 1;
      $7$hi = i64toi32_i32$3;
      label$6 : {
       label$7 : {
        label$8 : {
         i64toi32_i32$3 = i64toi32_i32$0;
         i64toi32_i32$3 = i64toi32_i32$0;
         i64toi32_i32$1 = $4;
         i64toi32_i32$0 = 0;
         i64toi32_i32$2 = 1;
         if ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) | 0) {
          break label$8
         }
         cbor_event__de__Deserializer_R___special__h10e912d855f56298($2 + 112 | 0 | 0, $1 | 0);
         $1 = HEAPU8[($2 + 120 | 0) >> 0] | 0;
         i64toi32_i32$2 = $2;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 112 | 0) >> 2] | 0;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 116 | 0) >> 2] | 0;
         i64toi32_i32$2 = i64toi32_i32$1;
         i64toi32_i32$1 = 0;
         i64toi32_i32$0 = 1;
         if ((i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) | 0) {
          break label$7
         }
         if (($1 & 255 | 0 | 0) == (5 | 0)) {
          break label$6
         }
         i64toi32_i32$2 = 0;
         $6 = 5;
         $6$hi = i64toi32_i32$2;
         break label$3;
        }
        i64toi32_i32$2 = 0;
        $6 = 3;
        $6$hi = i64toi32_i32$2;
        i64toi32_i32$2 = $5$hi;
        i64toi32_i32$2 = $3$hi;
        i64toi32_i32$2 = $5$hi;
        i64toi32_i32$0 = $5;
        i64toi32_i32$3 = $3$hi;
        i64toi32_i32$1 = $3;
        if ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) | 0) {
         break label$6
        }
        break label$3;
       }
       i64toi32_i32$1 = $2 + 152 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $4 = i64toi32_i32$0;
       $4$hi = i64toi32_i32$2;
       i64toi32_i32$0 = ($2 + 96 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $4;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$0 = ($2 + 8 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $4;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$1 = $2 + 144 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $4 = i64toi32_i32$2;
       $4$hi = i64toi32_i32$0;
       i64toi32_i32$2 = $2;
       HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] = $4;
       HEAP32[(i64toi32_i32$2 + 100 | 0) >> 2] = i64toi32_i32$0;
       HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $4;
       HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$1 = i64toi32_i32$2;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 121 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 122 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 123 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 124 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = 0;
       $68 = i64toi32_i32$0;
       $68$hi = i64toi32_i32$2;
       i64toi32_i32$1 = i64toi32_i32$1 + 125 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
       i64toi32_i32$0 = 0;
       $71 = i64toi32_i32$2;
       $71$hi = i64toi32_i32$0;
       i64toi32_i32$1 = $2 + 127 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
       i64toi32_i32$2 = 0;
       i64toi32_i32$1 = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        $39 = 0;
       } else {
        i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
        $39 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       }
       $75$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $71$hi;
       i64toi32_i32$2 = $71;
       i64toi32_i32$1 = $75$hi;
       i64toi32_i32$3 = $39;
       i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $40 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $40 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       $77$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $68$hi;
       i64toi32_i32$1 = $68;
       i64toi32_i32$0 = $77$hi;
       i64toi32_i32$3 = $40;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 8;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $41 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
        $41 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       $79$hi = i64toi32_i32$1;
       i64toi32_i32$1 = 0;
       i64toi32_i32$0 = $1;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 255;
       i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
       $82 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
       $82$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $79$hi;
       i64toi32_i32$1 = $41;
       i64toi32_i32$0 = $82$hi;
       i64toi32_i32$3 = $82;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
       $3 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       $3$hi = i64toi32_i32$0;
       i64toi32_i32$2 = $2 + 136 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $5 = i64toi32_i32$0;
       $5$hi = i64toi32_i32$1;
       i64toi32_i32$2 = $2 + 128 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $7 = i64toi32_i32$1;
       $7$hi = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       $6 = 2;
       $6$hi = i64toi32_i32$0;
       break label$3;
      }
      i64toi32_i32$2 = $2 + 72 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $95 = i64toi32_i32$0;
      i64toi32_i32$0 = ($2 + 8 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $95;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[(($2 + 112 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 92 | 0) >> 2] | 0;
      i64toi32_i32$2 = $2;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 84 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 88 | 0) >> 2] | 0;
      $104 = i64toi32_i32$1;
      i64toi32_i32$1 = i64toi32_i32$2;
      HEAP32[(i64toi32_i32$2 + 112 | 0) >> 2] = $104;
      HEAP32[(i64toi32_i32$2 + 116 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = i64toi32_i32$2 + 64 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $108 = i64toi32_i32$0;
      i64toi32_i32$0 = $2;
      HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $108;
      HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = i64toi32_i32$0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
      $6 = i64toi32_i32$1;
      $6$hi = i64toi32_i32$0;
      label$9 : {
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
       i64toi32_i32$2 = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 1;
       if ((i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$0 | 0) | 0) {
        break label$9
       }
       i64toi32_i32$2 = $6$hi;
       i64toi32_i32$3 = $6;
       i64toi32_i32$1 = -1;
       i64toi32_i32$0 = -256;
       i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
       $8 = i64toi32_i32$3 & i64toi32_i32$0 | 0;
       $8$hi = i64toi32_i32$1;
       i64toi32_i32$2 = $2 + 56 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $5 = i64toi32_i32$1;
       $5$hi = i64toi32_i32$3;
       i64toi32_i32$2 = $2 + 48 | 0;
       i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $7 = i64toi32_i32$3;
       $7$hi = i64toi32_i32$1;
       i64toi32_i32$2 = $2 + 40 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $4 = i64toi32_i32$1;
       $4$hi = i64toi32_i32$3;
       $1 = HEAP32[($2 + 80 | 0) >> 2] | 0;
       break label$2;
      }
      i64toi32_i32$3 = $6$hi;
      i64toi32_i32$1 = $0;
      HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $6;
      HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$3;
      i64toi32_i32$3 = 0;
      $4 = 0;
      $4$hi = i64toi32_i32$3;
      break label$1;
     }
     i64toi32_i32$2 = $2 + 64 | 0;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $134 = i64toi32_i32$3;
     i64toi32_i32$3 = $2 + 16 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $134;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $2 + 56 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $138 = i64toi32_i32$1;
     i64toi32_i32$1 = $2;
     HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $138;
     HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$2 = i64toi32_i32$1 + 48 | 0;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $5 = i64toi32_i32$3;
     $5$hi = i64toi32_i32$1;
     $1 = 0;
     i64toi32_i32$1 = 0;
     $6 = 2;
     $6$hi = i64toi32_i32$1;
     i64toi32_i32$1 = 0;
     $8 = 0;
     $8$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $3$hi;
     $7 = $3;
     $7$hi = i64toi32_i32$1;
     break label$2;
    }
    label$10 : {
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
     if (!(i64toi32_i32$1 | i64toi32_i32$3 | 0)) {
      break label$10
     }
     core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9($2 + 32 | 0 | 0);
    }
    $1 = 0;
    i64toi32_i32$3 = 0;
    $8 = 0;
    $8$hi = i64toi32_i32$3;
    i64toi32_i32$3 = $3$hi;
    $4 = $3;
    $4$hi = i64toi32_i32$3;
   }
   i64toi32_i32$3 = $5$hi;
   i64toi32_i32$1 = $2 + 48 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $5;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$3 = $7$hi;
   i64toi32_i32$1 = $2 + 40 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $7;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$3 = $4$hi;
   i64toi32_i32$1 = ($2 + 24 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $4;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$2 = $2;
   i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
   $162 = i64toi32_i32$3;
   i64toi32_i32$3 = i64toi32_i32$2 + 56 | 0;
   HEAP32[i64toi32_i32$3 >> 2] = $162;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 112 | 0) >> 2] | 0;
   i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 116 | 0) >> 2] | 0;
   $166 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2 + 76 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $166;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$2 = (i64toi32_i32$2 + 8 | 0) + 8 | 0;
   i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $172 = i64toi32_i32$3;
   i64toi32_i32$3 = $2 + 64 | 0;
   HEAP32[i64toi32_i32$3 >> 2] = $172;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($2 + 84 | 0) >> 2] = HEAP32[(($2 + 112 | 0) + 8 | 0) >> 2] | 0;
   HEAP32[($2 + 72 | 0) >> 2] = $1;
   i64toi32_i32$1 = $6$hi;
   i64toi32_i32$2 = $6;
   i64toi32_i32$3 = 0;
   i64toi32_i32$0 = 255;
   i64toi32_i32$3 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
   $183$hi = i64toi32_i32$3;
   i64toi32_i32$3 = $8$hi;
   i64toi32_i32$3 = $183$hi;
   i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
   i64toi32_i32$2 = $8$hi;
   i64toi32_i32$0 = $8;
   i64toi32_i32$2 = i64toi32_i32$3 | i64toi32_i32$2 | 0;
   $185 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
   i64toi32_i32$1 = $2;
   HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = $185;
   HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = i64toi32_i32$2;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, i64toi32_i32$1 + 24 | 0 | 0, 1051826 | 0, 14 | 0);
   i64toi32_i32$2 = 0;
   $4 = 1;
   $4$hi = i64toi32_i32$2;
  }
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $4;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  global$0 = $2 + 160 | 0;
 }
 
 function linked_hash_map__LinkedHashMap_K_2cV_2cS___insert__h3e59fdce083c9794($0, $1, $2, $3, $3$hi, $4, $4$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  $4 = $4 | 0;
  $4$hi = $4$hi | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $6 = 0, $5 = 0, $7 = 0, $8 = 0, $9 = 0, $9$hi = 0, $26 = 0, $27 = 0, $28 = 0, $29 = 0, $30 = 0, $31 = 0, $32 = 0, $151 = 0, $158 = 0, $10 = 0, $10$hi = 0, $177 = 0, $181 = 0, $192 = 0, $197 = 0, $202 = 0, $207 = 0;
  $5 = global$0 - 64 | 0;
  global$0 = $5;
  label$1 : {
   if (HEAP32[($1 + 32 | 0) >> 2] | 0) {
    break label$1
   }
   $6 = __rust_alloc(56 | 0, 8 | 0) | 0;
   HEAP32[($1 + 32 | 0) >> 2] = $6;
   HEAP32[($6 + 20 | 0) >> 2] = $6;
   HEAP32[($6 + 16 | 0) >> 2] = $6;
  }
  HEAP32[($5 + 28 | 0) >> 2] = $2;
  i64toi32_i32$0 = hashbrown__map__make_hash__h98d8394e57bcc228($1 | 0, $5 + 28 | 0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $9 = i64toi32_i32$0;
  $9$hi = i64toi32_i32$1;
  $7 = i64toi32_i32$0;
  $8 = (HEAP32[($1 + 16 | 0) >> 2] | 0) & i64toi32_i32$0 | 0;
  $26 = (HEAP32[($1 + 20 | 0) >> 2] | 0) + $8 | 0;
  $6 = HEAPU8[$26 >> 0] | 0 | ((HEAPU8[($26 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($26 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($26 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  HEAP32[($5 + 40 | 0) >> 2] = 0;
  HEAP32[($5 + 44 | 0) >> 2] = $6;
  HEAP32[($5 + 36 | 0) >> 2] = $8;
  HEAP32[($5 + 32 | 0) >> 2] = $1 + 16 | 0;
  $7 = i64toi32_i32$0 >>> 25 | 0;
  HEAP8[($5 + 52 | 0) >> 0] = $7;
  $6 = $6 ^ Math_imul($7, 16843009) | 0;
  HEAP32[($5 + 48 | 0) >> 2] = (($6 ^ -1 | 0) & ($6 + -16843009 | 0) | 0) & -2139062144 | 0;
  $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($5 + 16 | 0 | 0, $5 + 32 | 0 | 0);
  label$2 : {
   label$3 : {
    label$4 : {
     if (!(HEAP32[($5 + 16 | 0) >> 2] | 0)) {
      break label$4
     }
     label$5 : {
      $6 = (HEAP32[((HEAP32[($5 + 32 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) - ((HEAP32[($5 + 20 | 0) >> 2] | 0) << 3 | 0) | 0;
      if ($linked_hash_map__KeyRef_K__20as_20core__cmp__PartialEq___eq__h969d25de4a7a4343($5 + 28 | 0 | 0, $6 + -8 | 0 | 0) | 0) {
       break label$5
      }
      label$6 : while (1) {
       $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($5 + 8 | 0 | 0, $5 + 32 | 0 | 0);
       if (!(HEAP32[($5 + 8 | 0) >> 2] | 0)) {
        break label$4
       }
       $6 = (HEAP32[((HEAP32[($5 + 32 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) - ((HEAP32[($5 + 12 | 0) >> 2] | 0) << 3 | 0) | 0;
       if (!($linked_hash_map__KeyRef_K__20as_20core__cmp__PartialEq___eq__h969d25de4a7a4343($5 + 28 | 0 | 0, $6 + -8 | 0 | 0) | 0)) {
        continue label$6
       }
       break label$6;
      };
     }
     $2 = $6 + -4 | 0;
     $6 = HEAP32[$2 >> 2] | 0;
     i64toi32_i32$2 = $6;
     i64toi32_i32$1 = HEAP32[$6 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($6 + 4 | 0) >> 2] | 0;
     $9 = i64toi32_i32$1;
     $9$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3$hi;
     i64toi32_i32$1 = $6;
     HEAP32[i64toi32_i32$1 >> 2] = $3;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     $6 = i64toi32_i32$1 + 8 | 0;
     i64toi32_i32$2 = $6;
     i64toi32_i32$0 = HEAP32[$6 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($6 + 4 | 0) >> 2] | 0;
     $3 = i64toi32_i32$0;
     $3$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $4$hi;
     i64toi32_i32$0 = $6;
     HEAP32[i64toi32_i32$0 >> 2] = $4;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     $6 = HEAP32[$2 >> 2] | 0;
     HEAP32[((HEAP32[($6 + 20 | 0) >> 2] | 0) + 16 | 0) >> 2] = HEAP32[($6 + 16 | 0) >> 2] | 0;
     HEAP32[((HEAP32[($6 + 16 | 0) >> 2] | 0) + 20 | 0) >> 2] = HEAP32[($6 + 20 | 0) >> 2] | 0;
     $1 = HEAP32[($1 + 32 | 0) >> 2] | 0;
     $2 = HEAP32[($1 + 16 | 0) >> 2] | 0;
     HEAP32[($6 + 20 | 0) >> 2] = $1;
     HEAP32[($6 + 16 | 0) >> 2] = $2;
     HEAP32[($1 + 16 | 0) >> 2] = $6;
     i64toi32_i32$1 = 0;
     $4 = 1;
     $4$hi = i64toi32_i32$1;
     break label$3;
    }
    label$7 : {
     label$8 : {
      $6 = HEAP32[($1 + 36 | 0) >> 2] | 0;
      if (!$6) {
       break label$8
      }
      HEAP32[($1 + 36 | 0) >> 2] = HEAP32[($6 + 16 | 0) >> 2] | 0;
      $7 = ($5 + 32 | 0) + 21 | 0;
      i64toi32_i32$2 = $2 + 21 | 0;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $151 = i64toi32_i32$1;
      i64toi32_i32$1 = $7;
      $27 = $151;
      HEAP8[i64toi32_i32$1 >> 0] = $27;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $27 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $27 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $27 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      $8 = ($5 + 32 | 0) + 16 | 0;
      i64toi32_i32$2 = $2 + 16 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $158 = i64toi32_i32$0;
      i64toi32_i32$0 = $8;
      HEAP32[i64toi32_i32$0 >> 2] = $158;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $2 + 8 | 0;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $9 = i64toi32_i32$1;
      $9$hi = i64toi32_i32$0;
      i64toi32_i32$2 = $2;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $10 = i64toi32_i32$0;
      $10$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $4$hi;
      i64toi32_i32$0 = $6;
      HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $4;
      HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$1 = $3$hi;
      HEAP32[i64toi32_i32$0 >> 2] = $3;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = 0;
      HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$1 = $10$hi;
      HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = $10;
      HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$1 = $9$hi;
      i64toi32_i32$0 = i64toi32_i32$0 + 32 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $9;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $8;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $177 = i64toi32_i32$1;
      i64toi32_i32$1 = $6 + 40 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $177;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $7;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $181 = i64toi32_i32$0;
      i64toi32_i32$0 = $6 + 45 | 0;
      $28 = $181;
      HEAP8[i64toi32_i32$0 >> 0] = $28;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $28 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $28 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $28 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      break label$7;
     }
     $6 = __rust_alloc(56 | 0, 8 | 0) | 0;
     if (!$6) {
      break label$2
     }
     i64toi32_i32$1 = $3$hi;
     i64toi32_i32$0 = $6;
     HEAP32[i64toi32_i32$0 >> 2] = $3;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = 0;
     HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = 0;
     HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $4$hi;
     HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $4;
     HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $192 = i64toi32_i32$1;
     i64toi32_i32$1 = $6;
     $29 = $192;
     HEAP8[(i64toi32_i32$1 + 24 | 0) >> 0] = $29;
     HEAP8[(i64toi32_i32$1 + 25 | 0) >> 0] = $29 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 26 | 0) >> 0] = $29 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 27 | 0) >> 0] = $29 >>> 24 | 0;
     HEAP8[(i64toi32_i32$1 + 28 | 0) >> 0] = i64toi32_i32$0;
     HEAP8[(i64toi32_i32$1 + 29 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 30 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 31 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
     i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $197 = i64toi32_i32$0;
     i64toi32_i32$0 = $6 + 32 | 0;
     $30 = $197;
     HEAP8[i64toi32_i32$0 >> 0] = $30;
     HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $30 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $30 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $30 >>> 24 | 0;
     HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
     HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
     i64toi32_i32$2 = $2 + 16 | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $202 = i64toi32_i32$1;
     i64toi32_i32$1 = $6 + 40 | 0;
     $31 = $202;
     HEAP8[i64toi32_i32$1 >> 0] = $31;
     HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $31 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $31 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $31 >>> 24 | 0;
     HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
     HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
     i64toi32_i32$2 = $2 + 21 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $207 = i64toi32_i32$0;
     i64toi32_i32$0 = $6 + 45 | 0;
     $32 = $207;
     HEAP8[i64toi32_i32$0 >> 0] = $32;
     HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $32 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $32 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $32 >>> 24 | 0;
     HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
     HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    }
    hashbrown__map__HashMap_K_2cV_2cS_2cA___insert__h329a9f5fa6dfcbd2($5 | 0, $1 | 0, $6 + 24 | 0 | 0, $6 | 0);
    $1 = HEAP32[($1 + 32 | 0) >> 2] | 0;
    HEAP32[($6 + 16 | 0) >> 2] = HEAP32[($1 + 16 | 0) >> 2] | 0;
    HEAP32[($6 + 20 | 0) >> 2] = $1;
    HEAP32[($1 + 16 | 0) >> 2] = $6;
    i64toi32_i32$1 = 0;
    $4 = 0;
    $4$hi = i64toi32_i32$1;
   }
   HEAP32[((HEAP32[($6 + 16 | 0) >> 2] | 0) + 20 | 0) >> 2] = $6;
   i64toi32_i32$1 = $3$hi;
   i64toi32_i32$0 = $0 + 16 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $3;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $9$hi;
   i64toi32_i32$0 = $0;
   HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $9;
   HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $4$hi;
   HEAP32[i64toi32_i32$0 >> 2] = $4;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   global$0 = $5 + 64 | 0;
   return;
  }
  $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
  alloc__alloc__handle_alloc_error__he269d8f1bff90960(56 | 0, 8 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__BalancingContext_K_2cV___do_merge__ha68544c15fd893a2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $15 = 0, $18 = 0, $2 = 0, $3 = 0, $12 = 0, $14 = 0, $5 = 0, $4 = 0, $6 = 0, $7 = 0, $30 = 0, $17 = 0, $31 = 0, $32 = 0, $33 = 0, $34 = 0, $35 = 0, $8 = 0, $13 = 0, $16 = 0, $9 = 0, $11 = 0, $66 = 0, $72 = 0, $77 = 0, $101 = 0, $105 = 0, $108 = 0, $133 = 0, $152 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   $3 = HEAP32[($1 + 16 | 0) >> 2] | 0;
   $4 = HEAPU16[($3 + 138 | 0) >> 1] | 0;
   $5 = $4 + 1 | 0;
   $6 = HEAP32[($1 + 24 | 0) >> 2] | 0;
   $7 = HEAPU16[($6 + 138 | 0) >> 1] | 0;
   $8 = $5 + $7 | 0;
   if ($8 >>> 0 > 11 >>> 0) {
    break label$1
   }
   $9 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   $10 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   $11 = HEAP32[$1 >> 2] | 0;
   $12 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   $13 = HEAPU16[($12 + 138 | 0) >> 1] | 0;
   HEAP16[($3 + 138 | 0) >> 1] = $8;
   $14 = $2 + 24 | 0;
   $1 = $12 + Math_imul($10, 28) | 0;
   $30 = $1 + 164 | 0;
   HEAP32[$14 >> 2] = HEAPU8[$30 >> 0] | 0 | ((HEAPU8[($30 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($30 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($30 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $15 = $2 + 16 | 0;
   i64toi32_i32$2 = $1 + 156 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $66 = i64toi32_i32$0;
   i64toi32_i32$0 = $15;
   HEAP32[i64toi32_i32$0 >> 2] = $66;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   $16 = $2 + 8 | 0;
   i64toi32_i32$2 = $1 + 148 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $72 = i64toi32_i32$1;
   i64toi32_i32$1 = $16;
   HEAP32[i64toi32_i32$1 >> 2] = $72;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   $17 = $1 + 140 | 0;
   i64toi32_i32$2 = $17;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $77 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   HEAP32[i64toi32_i32$0 >> 2] = $77;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   $18 = $13 + ($10 ^ -1 | 0) | 0;
   memmove(i64toi32_i32$2 | 0, $1 + 168 | 0 | 0, Math_imul($18, 28) | 0) | 0;
   $17 = $3 + 140 | 0;
   $1 = $17 + Math_imul($4, 28) | 0;
   $31 = $1 + 24 | 0;
   $32 = HEAP32[$14 >> 2] | 0;
   HEAP8[$31 >> 0] = $32;
   HEAP8[($31 + 1 | 0) >> 0] = $32 >>> 8 | 0;
   HEAP8[($31 + 2 | 0) >> 0] = $32 >>> 16 | 0;
   HEAP8[($31 + 3 | 0) >> 0] = $32 >>> 24 | 0;
   i64toi32_i32$2 = $15;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $101 = i64toi32_i32$1;
   i64toi32_i32$1 = $1 + 16 | 0;
   $33 = $101;
   HEAP8[i64toi32_i32$1 >> 0] = $33;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $33 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $33 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $33 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $16;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $105 = i64toi32_i32$0;
   i64toi32_i32$0 = $1 + 8 | 0;
   $34 = $105;
   HEAP8[i64toi32_i32$0 >> 0] = $34;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $34 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $34 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $34 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $108 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   $35 = $108;
   HEAP8[i64toi32_i32$1 >> 0] = $35;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $35 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $35 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $35 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   memcpy($17 + Math_imul($5, 28) | 0 | 0, $6 + 140 | 0 | 0, Math_imul($7, 28) | 0) | 0;
   $14 = (i64toi32_i32$2 + 32 | 0) + 8 | 0;
   $1 = $12 + Math_imul($10, 12) | 0;
   HEAP32[$14 >> 2] = HEAP32[($1 + 12 | 0) >> 2] | 0;
   $15 = $1 + 4 | 0;
   i64toi32_i32$2 = $15;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $133 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] = $133;
   HEAP32[(i64toi32_i32$0 + 36 | 0) >> 2] = i64toi32_i32$1;
   memmove(i64toi32_i32$2 | 0, $1 + 16 | 0 | 0, Math_imul($18, 12) | 0) | 0;
   $1 = $3 + 4 | 0;
   $15 = $1 + Math_imul($4, 12) | 0;
   HEAP32[($15 + 8 | 0) >> 2] = HEAP32[$14 >> 2] | 0;
   i64toi32_i32$2 = i64toi32_i32$0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
   $152 = i64toi32_i32$1;
   i64toi32_i32$1 = $15;
   HEAP32[i64toi32_i32$1 >> 2] = $152;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   memcpy($1 + Math_imul($5, 12) | 0 | 0, $6 + 4 | 0 | 0, Math_imul($7, 12) | 0) | 0;
   $14 = 448;
   $15 = $12 + 448 | 0;
   $1 = $10 + 1 | 0;
   $10 = $10 << 2 | 0;
   memmove($15 + ($1 << 2 | 0) | 0 | 0, ($10 + $15 | 0) + 8 | 0 | 0, $18 << 2 | 0 | 0) | 0;
   label$2 : {
    if ($1 >>> 0 >= $13 >>> 0) {
     break label$2
    }
    $10 = ($10 + $12 | 0) + 452 | 0;
    label$3 : while (1) {
     $18 = HEAP32[$10 >> 2] | 0;
     HEAP16[($18 + 136 | 0) >> 1] = $1;
     HEAP32[$18 >> 2] = $12;
     $10 = $10 + 4 | 0;
     $1 = $1 + 1 | 0;
     if (($13 | 0) != ($1 | 0)) {
      continue label$3
     }
     break label$3;
    };
   }
   HEAP16[($12 + 138 | 0) >> 1] = (HEAPU16[($12 + 138 | 0) >> 1] | 0) + -1 | 0;
   label$4 : {
    if ($11 >>> 0 <= 1 >>> 0) {
     break label$4
    }
    memcpy(($3 + ($5 << 2 | 0) | 0) + 448 | 0 | 0, $6 + 448 | 0 | 0, ($7 << 2 | 0) + 4 | 0 | 0) | 0;
    $14 = 496;
    if ($8 >>> 0 <= $4 >>> 0) {
     break label$4
    }
    $10 = $7 + 1 | 0;
    $1 = (($4 << 2 | 0) + $3 | 0) + 452 | 0;
    label$5 : while (1) {
     $18 = HEAP32[$1 >> 2] | 0;
     HEAP16[($18 + 136 | 0) >> 1] = $5;
     HEAP32[$18 >> 2] = $3;
     $1 = $1 + 4 | 0;
     $5 = $5 + 1 | 0;
     $10 = $10 + -1 | 0;
     if ($10) {
      continue label$5
     }
     break label$5;
    };
   }
   __rust_dealloc($6 | 0, $14 | 0, 4 | 0);
   HEAP32[($0 + 4 | 0) >> 2] = $3;
   HEAP32[$0 >> 2] = $9;
   global$0 = $2 + 48 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1049692 | 0, 42 | 0, 1049736 | 0);
  abort();
 }
 
 function $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone___7b_7bclosure_7d_7d__hcd96b55161ebcbf0($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $5 = 0, $7 = 0, $7$hi = 0, $8 = 0, $8$hi = 0, $4 = 0, $9 = 0, $9$hi = 0, $10 = 0, $10$hi = 0, $6 = 0, $25 = 0, $30 = 0, $33 = 0, $76 = 0, $84 = 0, $87 = 0, $97 = 0, $101 = 0, $104 = 0, $143 = 0, $149 = 0, $155 = 0, $175 = 0, $181 = 0, $187 = 0;
  $3 = global$0 - 96 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    switch (HEAP32[$1 >> 2] | 0 | 0) {
    default:
     $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__hdeea20968268d729($3 + 56 | 0 | 0, $1 + 8 | 0 | 0);
     i64toi32_i32$2 = $3 + 80 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $25 = i64toi32_i32$0;
     i64toi32_i32$0 = ($3 + 32 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $25;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $3 + 88 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $30 = i64toi32_i32$1;
     i64toi32_i32$1 = $3 + 48 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $30;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $3;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 72 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 76 | 0) >> 2] | 0;
     $33 = i64toi32_i32$0;
     i64toi32_i32$0 = i64toi32_i32$2;
     HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] = $33;
     HEAP32[(i64toi32_i32$0 + 36 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = (i64toi32_i32$0 + 56 | 0) + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $7 = i64toi32_i32$1;
     $7$hi = i64toi32_i32$0;
     i64toi32_i32$2 = $3;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
     $8 = i64toi32_i32$0;
     $8$hi = i64toi32_i32$1;
     $4 = 0;
     break label$1;
    case 1:
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hf69db734dd831996($3 + 56 | 0 | 0, $1 + 4 | 0 | 0);
     i64toi32_i32$2 = $3;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
     $8 = i64toi32_i32$1;
     $8$hi = i64toi32_i32$0;
     $1 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
     i64toi32_i32$0 = 0;
     $7 = 0;
     $7$hi = i64toi32_i32$0;
     $4 = 1;
     break label$1;
    case 2:
     i64toi32_i32$2 = $1 + 16 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $7 = i64toi32_i32$0;
     $7$hi = i64toi32_i32$1;
     i64toi32_i32$2 = $1;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
     $8 = i64toi32_i32$1;
     $8$hi = i64toi32_i32$0;
     $4 = 2;
     break label$1;
    case 3:
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($3 + 56 | 0 | 0, $1 + 4 | 0 | 0);
     i64toi32_i32$2 = $3;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
     $8 = i64toi32_i32$0;
     $8$hi = i64toi32_i32$1;
     $1 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
     i64toi32_i32$1 = 0;
     $7 = 0;
     $7$hi = i64toi32_i32$1;
     $4 = 3;
     break label$1;
    case 4:
     break label$2;
    };
   }
   $4 = 4;
   $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($3 + 56 | 0 | 0, $1 + 4 | 0 | 0);
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
   $8 = i64toi32_i32$1;
   $8$hi = i64toi32_i32$0;
   $1 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
   i64toi32_i32$0 = 0;
   $7 = 0;
   $7$hi = i64toi32_i32$0;
  }
  $5 = ($3 + 32 | 0) + 16 | 0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $76 = i64toi32_i32$0;
  i64toi32_i32$0 = ($3 + 8 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $76;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $6 = ($3 + 32 | 0) + 8 | 0;
  i64toi32_i32$2 = $6;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $84 = i64toi32_i32$1;
  i64toi32_i32$1 = ($3 + 8 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $84;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
  $87 = i64toi32_i32$0;
  i64toi32_i32$0 = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $87;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
  label$7 : {
   label$8 : {
    switch (HEAP32[$2 >> 2] | 0 | 0) {
    default:
     $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__hdeea20968268d729($3 + 56 | 0 | 0, $2 + 8 | 0 | 0);
     i64toi32_i32$2 = $3 + 80 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $97 = i64toi32_i32$1;
     i64toi32_i32$1 = $6;
     HEAP32[i64toi32_i32$1 >> 2] = $97;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $3 + 88 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $101 = i64toi32_i32$0;
     i64toi32_i32$0 = $5;
     HEAP32[i64toi32_i32$0 >> 2] = $101;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $3;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 72 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 76 | 0) >> 2] | 0;
     $104 = i64toi32_i32$1;
     i64toi32_i32$1 = i64toi32_i32$2;
     HEAP32[(i64toi32_i32$1 + 32 | 0) >> 2] = $104;
     HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = (i64toi32_i32$1 + 56 | 0) + 8 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $9 = i64toi32_i32$0;
     $9$hi = i64toi32_i32$1;
     i64toi32_i32$2 = $3;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
     $10 = i64toi32_i32$1;
     $10$hi = i64toi32_i32$0;
     $5 = 0;
     break label$7;
    case 1:
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hf69db734dd831996($3 + 56 | 0 | 0, $2 + 4 | 0 | 0);
     i64toi32_i32$2 = $3;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
     $10 = i64toi32_i32$0;
     $10$hi = i64toi32_i32$1;
     $2 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
     i64toi32_i32$1 = 0;
     $9 = 0;
     $9$hi = i64toi32_i32$1;
     $5 = 1;
     break label$7;
    case 2:
     i64toi32_i32$2 = $2 + 16 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $9 = i64toi32_i32$1;
     $9$hi = i64toi32_i32$0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
     $10 = i64toi32_i32$0;
     $10$hi = i64toi32_i32$1;
     $5 = 2;
     break label$7;
    case 3:
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($3 + 56 | 0 | 0, $2 + 4 | 0 | 0);
     i64toi32_i32$2 = $3;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
     $10 = i64toi32_i32$1;
     $10$hi = i64toi32_i32$0;
     $2 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
     i64toi32_i32$0 = 0;
     $9 = 0;
     $9$hi = i64toi32_i32$0;
     $5 = 3;
     break label$7;
    case 4:
     break label$8;
    };
   }
   $5 = 4;
   $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($3 + 56 | 0 | 0, $2 + 4 | 0 | 0);
   i64toi32_i32$2 = $3;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
   $10 = i64toi32_i32$0;
   $10$hi = i64toi32_i32$1;
   $2 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
   i64toi32_i32$1 = 0;
   $9 = 0;
   $9$hi = i64toi32_i32$1;
  }
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
  $143 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 72 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $143;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = (i64toi32_i32$2 + 32 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $149 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 88 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $149;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = ($3 + 32 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $155 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 80 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $155;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$1 = $0 + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $7;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$1 = $0 + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $8;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$1 = $0 + 64 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $9;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$1 = $0 + 56 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $10;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[$0 >> 2] = $4;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $175 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 24 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $175;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = (i64toi32_i32$2 + 8 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $181 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 32 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $181;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = ($3 + 8 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $187 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 40 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $187;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($0 + 52 | 0) >> 2] = $2;
  HEAP32[($0 + 48 | 0) >> 2] = $5;
  global$0 = $3 + 96 | 0;
 }
 
 function cardano_serialization_lib__PoolRegistration__pool_params__h9c7664cd9d439b4e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $2 = 0, $52 = 0, $53 = 0, $54 = 0, $55 = 0, $56 = 0, $57 = 0, $59 = 0, $60 = 0, $61 = 0, $62 = 0, $63 = 0, $64 = 0, $66 = 0, $67 = 0, $69 = 0, $70 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $7 = 0, $8 = 0, $10 = 0, $11 = 0, $12 = 0, $34 = 0, $41 = 0, $44 = 0, $51 = 0, $58 = 0, $65 = 0, $68 = 0, $14 = 0, $14$hi = 0, $15 = 0, $15$hi = 0, $16 = 0, $16$hi = 0, $17 = 0, $17$hi = 0, $9 = 0, $86 = 0, $93 = 0, $104 = 0, $13 = 0, $126 = 0, $131 = 0, $136 = 0, $140 = 0, $151 = 0, $154 = 0, $176 = 0, $180 = 0, $184 = 0, $188 = 0, $192 = 0, $202 = 0, $206 = 0, $210 = 0, $219 = 0, $228 = 0;
  $2 = global$0 - 256 | 0;
  global$0 = $2;
  $3 = ($2 + 8 | 0) + 24 | 0;
  $52 = $1 + 124 | 0;
  HEAP32[$3 >> 2] = HEAPU8[$52 >> 0] | 0 | ((HEAPU8[($52 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($52 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($52 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $4 = ($2 + 8 | 0) + 16 | 0;
  i64toi32_i32$2 = $1 + 116 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $34 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[i64toi32_i32$0 >> 2] = $34;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $5 = ($2 + 8 | 0) + 8 | 0;
  i64toi32_i32$2 = $1 + 108 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $41 = i64toi32_i32$1;
  i64toi32_i32$1 = $5;
  HEAP32[i64toi32_i32$1 >> 2] = $41;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 100 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 101 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 102 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 103 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 104 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 105 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 106 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 107 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $44 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $44;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
  $6 = (i64toi32_i32$0 + 40 | 0) + 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 152 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $51 = i64toi32_i32$1;
  i64toi32_i32$1 = $6;
  HEAP32[i64toi32_i32$1 >> 2] = $51;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $7 = ($2 + 40 | 0) + 16 | 0;
  i64toi32_i32$2 = $1 + 144 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $58 = i64toi32_i32$0;
  i64toi32_i32$0 = $7;
  HEAP32[i64toi32_i32$0 >> 2] = $58;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $8 = ($2 + 40 | 0) + 8 | 0;
  i64toi32_i32$2 = $1 + 136 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $65 = i64toi32_i32$1;
  i64toi32_i32$1 = $8;
  HEAP32[i64toi32_i32$1 >> 2] = $65;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 128 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 129 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 130 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 131 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 132 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 133 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 134 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 135 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $68 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[(i64toi32_i32$0 + 40 | 0) >> 2] = $68;
  HEAP32[(i64toi32_i32$0 + 44 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$2 + 24 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$1;
  $14$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $15 = i64toi32_i32$0;
  $15$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $16 = i64toi32_i32$1;
  $16$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $17 = i64toi32_i32$0;
  $17$hi = i64toi32_i32$1;
  $9 = HEAPU8[(i64toi32_i32$2 + 160 | 0) >> 0] | 0;
  $10 = ($2 + 72 | 0) + 8 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 170 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $86 = i64toi32_i32$1;
  i64toi32_i32$1 = $10;
  HEAP32[i64toi32_i32$1 >> 2] = $86;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $11 = ($2 + 72 | 0) + 16 | 0;
  i64toi32_i32$2 = $1 + 178 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $93 = i64toi32_i32$0;
  i64toi32_i32$0 = $11;
  HEAP32[i64toi32_i32$0 >> 2] = $93;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $12 = ($2 + 72 | 0) + 24 | 0;
  $53 = $1 + 186 | 0;
  HEAP32[$12 >> 2] = HEAPU8[$53 >> 0] | 0 | ((HEAPU8[($53 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($53 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($53 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $1 + 162 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $104 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[(i64toi32_i32$1 + 72 | 0) >> 2] = $104;
  HEAP32[(i64toi32_i32$1 + 76 | 0) >> 2] = i64toi32_i32$0;
  $13 = HEAPU8[($1 + 161 | 0) >> 0] | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h25db889dc58a550d(i64toi32_i32$1 + 104 | 0 | 0, $1 + 32 | 0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h3d33b90cd2011dc4(i64toi32_i32$1 + 120 | 0 | 0, $1 + 44 | 0 | 0);
  label$1 : {
   label$2 : {
    if (HEAP32[($1 + 56 | 0) >> 2] | 0) {
     break label$2
    }
    $1 = 0;
    break label$1;
   }
   $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($2 + 176 | 0 | 0, $1 + 56 | 0 | 0);
   i64toi32_i32$2 = $1 + 92 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $126 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 212 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $126;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1 + 84 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $131 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 204 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $131;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $1 + 76 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $136 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 196 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $136;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1 + 68 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $140 = i64toi32_i32$1;
   i64toi32_i32$1 = $2;
   HEAP32[(i64toi32_i32$1 + 188 | 0) >> 2] = $140;
   HEAP32[(i64toi32_i32$1 + 192 | 0) >> 2] = i64toi32_i32$0;
   $1 = HEAP32[(i64toi32_i32$1 + 176 | 0) >> 2] | 0;
   memcpy(i64toi32_i32$1 + 136 | 0 | 0, i64toi32_i32$1 + 176 | 0 | 4 | 0 | 0, 40 | 0) | 0;
  }
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $151 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  $54 = $151;
  HEAP8[(i64toi32_i32$0 + 100 | 0) >> 0] = $54;
  HEAP8[(i64toi32_i32$0 + 101 | 0) >> 0] = $54 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 102 | 0) >> 0] = $54 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 103 | 0) >> 0] = $54 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 104 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 105 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 106 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 107 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] | 0;
  $154 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  $55 = $154;
  HEAP8[(i64toi32_i32$1 + 128 | 0) >> 0] = $55;
  HEAP8[(i64toi32_i32$1 + 129 | 0) >> 0] = $55 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 130 | 0) >> 0] = $55 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 131 | 0) >> 0] = $55 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 132 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 133 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 134 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 135 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 160 | 0) >> 0] = $9;
  i64toi32_i32$0 = $17$hi;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $17;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $16$hi;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $16;
  HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $15$hi;
  HEAP32[i64toi32_i32$1 >> 2] = $15;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 161 | 0) >> 0] = $13;
  i64toi32_i32$0 = $14$hi;
  i64toi32_i32$1 = i64toi32_i32$1 + 24 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $14;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $56 = $0 + 124 | 0;
  $57 = HEAP32[$3 >> 2] | 0;
  HEAP8[$56 >> 0] = $57;
  HEAP8[($56 + 1 | 0) >> 0] = $57 >>> 8 | 0;
  HEAP8[($56 + 2 | 0) >> 0] = $57 >>> 16 | 0;
  HEAP8[($56 + 3 | 0) >> 0] = $57 >>> 24 | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $176 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 116 | 0;
  $59 = $176;
  HEAP8[i64toi32_i32$0 >> 0] = $59;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $59 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $59 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $59 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $180 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 108 | 0;
  $60 = $180;
  HEAP8[i64toi32_i32$1 >> 0] = $60;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $60 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $60 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $60 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $8;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $184 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 136 | 0;
  $61 = $184;
  HEAP8[i64toi32_i32$0 >> 0] = $61;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $61 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $61 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $61 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $7;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $188 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 144 | 0;
  $62 = $188;
  HEAP8[i64toi32_i32$1 >> 0] = $62;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $62 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $62 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $62 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $6;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $192 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 152 | 0;
  $63 = $192;
  HEAP8[i64toi32_i32$0 >> 0] = $63;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $63 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $63 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $63 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  HEAP32[($0 + 56 | 0) >> 2] = $1;
  $64 = $0 + 186 | 0;
  $66 = HEAP32[$12 >> 2] | 0;
  HEAP8[$64 >> 0] = $66;
  HEAP8[($64 + 1 | 0) >> 0] = $66 >>> 8 | 0;
  HEAP8[($64 + 2 | 0) >> 0] = $66 >>> 16 | 0;
  HEAP8[($64 + 3 | 0) >> 0] = $66 >>> 24 | 0;
  i64toi32_i32$2 = $11;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $202 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 178 | 0;
  $67 = $202;
  HEAP8[i64toi32_i32$1 >> 0] = $67;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $67 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $67 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $67 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $10;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $206 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 170 | 0;
  $69 = $206;
  HEAP8[i64toi32_i32$0 >> 0] = $69;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $69 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $69 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $69 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 72 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 76 | 0) >> 2] | 0;
  $210 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 162 | 0;
  $70 = $210;
  HEAP8[i64toi32_i32$1 >> 0] = $70;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $70 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $70 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $70 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP32[($0 + 40 | 0) >> 2] = HEAP32[((i64toi32_i32$2 + 104 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 104 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 108 | 0) >> 2] | 0;
  $219 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] = $219;
  HEAP32[(i64toi32_i32$0 + 36 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 52 | 0) >> 2] = HEAP32[((i64toi32_i32$2 + 120 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 120 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 124 | 0) >> 2] | 0;
  $228 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[(i64toi32_i32$1 + 44 | 0) >> 2] = $228;
  HEAP32[(i64toi32_i32$1 + 48 | 0) >> 2] = i64toi32_i32$0;
  memcpy(i64toi32_i32$1 + 60 | 0 | 0, i64toi32_i32$2 + 136 | 0 | 0, 40 | 0) | 0;
  global$0 = i64toi32_i32$2 + 256 | 0;
 }
 
 function alloc__collections__btree__node__BalancingContext_K_2cV___do_merge__hbcaaaeaa77b77a9b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $9 = 0, $14 = 0, $11 = 0, $17 = 0, $2 = 0, $13 = 0, $3 = 0, $5 = 0, $4 = 0, $6 = 0, $7 = 0, $29 = 0, $16 = 0, $30 = 0, $31 = 0, $32 = 0, $33 = 0, $34 = 0, $8 = 0, $12 = 0, $10 = 0, $15 = 0, $63 = 0, $69 = 0, $74 = 0, $98 = 0, $102 = 0, $105 = 0, $130 = 0, $149 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   $3 = HEAP32[($1 + 16 | 0) >> 2] | 0;
   $4 = HEAPU16[($3 + 138 | 0) >> 1] | 0;
   $5 = $4 + 1 | 0;
   $6 = HEAP32[($1 + 24 | 0) >> 2] | 0;
   $7 = HEAPU16[($6 + 138 | 0) >> 1] | 0;
   $8 = $5 + $7 | 0;
   if ($8 >>> 0 > 11 >>> 0) {
    break label$1
   }
   $9 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   $10 = HEAP32[$1 >> 2] | 0;
   $11 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   $12 = HEAPU16[($11 + 138 | 0) >> 1] | 0;
   HEAP16[($3 + 138 | 0) >> 1] = $8;
   $13 = $2 + 24 | 0;
   $1 = $11 + Math_imul($9, 28) | 0;
   $29 = $1 + 164 | 0;
   HEAP32[$13 >> 2] = HEAPU8[$29 >> 0] | 0 | ((HEAPU8[($29 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($29 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($29 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $14 = $2 + 16 | 0;
   i64toi32_i32$2 = $1 + 156 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $63 = i64toi32_i32$0;
   i64toi32_i32$0 = $14;
   HEAP32[i64toi32_i32$0 >> 2] = $63;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   $15 = $2 + 8 | 0;
   i64toi32_i32$2 = $1 + 148 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $69 = i64toi32_i32$1;
   i64toi32_i32$1 = $15;
   HEAP32[i64toi32_i32$1 >> 2] = $69;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   $16 = $1 + 140 | 0;
   i64toi32_i32$2 = $16;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $74 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   HEAP32[i64toi32_i32$0 >> 2] = $74;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   $17 = $12 + ($9 ^ -1 | 0) | 0;
   memmove(i64toi32_i32$2 | 0, $1 + 168 | 0 | 0, Math_imul($17, 28) | 0) | 0;
   $16 = $3 + 140 | 0;
   $1 = $16 + Math_imul($4, 28) | 0;
   $30 = $1 + 24 | 0;
   $31 = HEAP32[$13 >> 2] | 0;
   HEAP8[$30 >> 0] = $31;
   HEAP8[($30 + 1 | 0) >> 0] = $31 >>> 8 | 0;
   HEAP8[($30 + 2 | 0) >> 0] = $31 >>> 16 | 0;
   HEAP8[($30 + 3 | 0) >> 0] = $31 >>> 24 | 0;
   i64toi32_i32$2 = $14;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $98 = i64toi32_i32$1;
   i64toi32_i32$1 = $1 + 16 | 0;
   $32 = $98;
   HEAP8[i64toi32_i32$1 >> 0] = $32;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $32 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $32 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $32 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $15;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $102 = i64toi32_i32$0;
   i64toi32_i32$0 = $1 + 8 | 0;
   $33 = $102;
   HEAP8[i64toi32_i32$0 >> 0] = $33;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $33 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $33 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $33 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $105 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   $34 = $105;
   HEAP8[i64toi32_i32$1 >> 0] = $34;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $34 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $34 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $34 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   memcpy($16 + Math_imul($5, 28) | 0 | 0, $6 + 140 | 0 | 0, Math_imul($7, 28) | 0) | 0;
   $13 = (i64toi32_i32$2 + 32 | 0) + 8 | 0;
   $1 = $11 + Math_imul($9, 12) | 0;
   HEAP32[$13 >> 2] = HEAP32[($1 + 12 | 0) >> 2] | 0;
   $14 = $1 + 4 | 0;
   i64toi32_i32$2 = $14;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $130 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] = $130;
   HEAP32[(i64toi32_i32$0 + 36 | 0) >> 2] = i64toi32_i32$1;
   memmove(i64toi32_i32$2 | 0, $1 + 16 | 0 | 0, Math_imul($17, 12) | 0) | 0;
   $1 = $3 + 4 | 0;
   $14 = $1 + Math_imul($4, 12) | 0;
   HEAP32[($14 + 8 | 0) >> 2] = HEAP32[$13 >> 2] | 0;
   i64toi32_i32$2 = i64toi32_i32$0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
   $149 = i64toi32_i32$1;
   i64toi32_i32$1 = $14;
   HEAP32[i64toi32_i32$1 >> 2] = $149;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   memcpy($1 + Math_imul($5, 12) | 0 | 0, $6 + 4 | 0 | 0, Math_imul($7, 12) | 0) | 0;
   $13 = 448;
   $14 = $11 + 448 | 0;
   $1 = $9 + 1 | 0;
   $9 = $9 << 2 | 0;
   memmove($14 + ($1 << 2 | 0) | 0 | 0, ($9 + $14 | 0) + 8 | 0 | 0, $17 << 2 | 0 | 0) | 0;
   label$2 : {
    if ($1 >>> 0 >= $12 >>> 0) {
     break label$2
    }
    $9 = ($9 + $11 | 0) + 452 | 0;
    label$3 : while (1) {
     $17 = HEAP32[$9 >> 2] | 0;
     HEAP16[($17 + 136 | 0) >> 1] = $1;
     HEAP32[$17 >> 2] = $11;
     $9 = $9 + 4 | 0;
     $1 = $1 + 1 | 0;
     if (($12 | 0) != ($1 | 0)) {
      continue label$3
     }
     break label$3;
    };
   }
   HEAP16[($11 + 138 | 0) >> 1] = (HEAPU16[($11 + 138 | 0) >> 1] | 0) + -1 | 0;
   label$4 : {
    if ($10 >>> 0 <= 1 >>> 0) {
     break label$4
    }
    memcpy(($3 + ($5 << 2 | 0) | 0) + 448 | 0 | 0, $6 + 448 | 0 | 0, ($7 << 2 | 0) + 4 | 0 | 0) | 0;
    $13 = 496;
    if ($8 >>> 0 <= $4 >>> 0) {
     break label$4
    }
    $9 = $7 + 1 | 0;
    $1 = (($4 << 2 | 0) + $3 | 0) + 452 | 0;
    label$5 : while (1) {
     $17 = HEAP32[$1 >> 2] | 0;
     HEAP16[($17 + 136 | 0) >> 1] = $5;
     HEAP32[$17 >> 2] = $3;
     $1 = $1 + 4 | 0;
     $5 = $5 + 1 | 0;
     $9 = $9 + -1 | 0;
     if ($9) {
      continue label$5
     }
     break label$5;
    };
   }
   __rust_dealloc($6 | 0, $13 | 0, 4 | 0);
   HEAP32[($0 + 4 | 0) >> 2] = $11;
   HEAP32[$0 >> 2] = $10;
   global$0 = $2 + 48 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1049692 | 0, 42 | 0, 1049736 | 0);
  abort();
 }
 
 function hashbrown__raw__RawTable_T_2cA___resize__h6f95ebb722f91bc1($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $5 = 0, $12 = 0, $6 = 0, $16$hi = 0, $16 = 0, $8 = 0, $10 = 0, i64toi32_i32$4 = 0, $17 = 0, i64toi32_i32$3 = 0, $17$hi = 0, $31 = 0, $14 = 0, $32 = 0, $11 = 0, $33 = 0, $13 = 0, $79 = 0, $82$hi = 0, $84 = 0, $7 = 0, $9 = 0, $15 = 0, $196 = 0, $207 = 0, $216 = 0;
  $5 = global$0 - 80 | 0;
  global$0 = $5;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ($2) {
        break label$5
       }
       i64toi32_i32$0 = 0;
       $16 = 0;
       $16$hi = i64toi32_i32$0;
       $4 = 0;
       $6 = hashbrown__raw__generic__Group__static_empty__hc5a7932fe1bdb1f1() | 0;
       break label$4;
      }
      label$6 : {
       label$7 : {
        if ($2 >>> 0 < 8 >>> 0) {
         break label$7
        }
        label$8 : {
         if (($2 & 536870911 | 0 | 0) != ($2 | 0)) {
          break label$8
         }
         $2 = (-1 >>> Math_clz32(((($2 << 3 | 0) >>> 0) / (7 >>> 0) | 0) + -1 | 0) | 0) + 1 | 0;
         break label$6;
        }
        hashbrown__raw__Fallibility__capacity_overflow__hd790516fe6877097($5 + 8 | 0 | 0, $4 | 0);
        $6 = HEAP32[($5 + 12 | 0) >> 2] | 0;
        $2 = HEAP32[($5 + 8 | 0) >> 2] | 0;
        break label$3;
       }
       $2 = $2 >>> 0 < 4 >>> 0 ? 4 : 8;
      }
      hashbrown__raw__RawTableInner_A___new_uninitialized__h43f4df636ea4ff18($5 + 56 | 0 | 0, 8 | 0, 4 | 0, $2 | 0, $4 | 0);
      $6 = HEAP32[(($5 + 56 | 0) + 8 | 0) >> 2] | 0;
      $2 = HEAP32[($5 + 60 | 0) >> 2] | 0;
      if ((HEAP32[($5 + 56 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      $4 = HEAP32[($5 + 68 | 0) >> 2] | 0;
      memset($6 | 0, 255 | 0, $2 + 5 | 0 | 0) | 0;
      i64toi32_i32$0 = 0;
      $16 = $2;
      $16$hi = i64toi32_i32$0;
     }
     $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
     HEAP32[($5 + 36 | 0) >> 2] = $2;
     HEAP32[($5 + 32 | 0) >> 2] = $4 - $2 | 0;
     i64toi32_i32$1 = $5;
     i64toi32_i32$0 = 4;
     HEAP32[($5 + 16 | 0) >> 2] = 8;
     HEAP32[($5 + 20 | 0) >> 2] = i64toi32_i32$0;
     $79 = $5;
     i64toi32_i32$0 = 0;
     i64toi32_i32$2 = $6;
     i64toi32_i32$1 = 0;
     i64toi32_i32$3 = 32;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
      $33 = 0;
     } else {
      i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
      $33 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
     }
     $82$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $16$hi;
     i64toi32_i32$1 = $82$hi;
     i64toi32_i32$0 = $33;
     i64toi32_i32$2 = $16$hi;
     i64toi32_i32$3 = $16;
     i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
     $84 = i64toi32_i32$0 | $16 | 0;
     i64toi32_i32$0 = $79;
     HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = $84;
     HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = i64toi32_i32$2;
     $7 = $6 + -8 | 0;
     $8 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $4 = $8 + 4 | 0;
     $9 = ((HEAP32[$1 >> 2] | 0) + $8 | 0) + 1 | 0;
     $10 = ((HEAP32[$8 >> 2] | 0) ^ -1 | 0) & -2139062144 | 0;
     i64toi32_i32$2 = $16$hi;
     $11 = $16;
     label$9 : while (1) {
      label$10 : {
       if ($10) {
        break label$10
       }
       label$11 : while (1) {
        if ($4 >>> 0 >= $9 >>> 0) {
         break label$2
        }
        $8 = $8 + -32 | 0;
        $2 = HEAP32[$4 >> 2] | 0;
        $12 = $4 + 4 | 0;
        $4 = $12;
        $2 = $2 & -2139062144 | 0;
        if (($2 | 0) == (-2139062144 | 0)) {
         continue label$11
        }
        break label$11;
       };
       $10 = $2 ^ -2139062144 | 0;
       $4 = $12;
      }
      label$12 : {
       i64toi32_i32$2 = $16$hi;
       $13 = ($8 - ((__wasm_ctz_i32($10 | 0) | 0) & 56 | 0) | 0) + -8 | 0;
       i64toi32_i32$2 = hashbrown__map__make_hash__h16f0f4baf07b5eeb($3 | 0, $13 | 0) | 0;
       i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
       $17 = i64toi32_i32$2;
       $17$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $16$hi;
       i64toi32_i32$1 = $16;
       i64toi32_i32$2 = $17$hi;
       i64toi32_i32$3 = $17;
       i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
       $12 = i64toi32_i32$1 & $17 | 0;
       $31 = $6 + $12 | 0;
       $14 = (HEAPU8[$31 >> 0] | 0 | ((HEAPU8[($31 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($31 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($31 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
       if ($14) {
        break label$12
       }
       $2 = 4;
       label$13 : while (1) {
        $12 = $12 + $2 | 0;
        $2 = $2 + 4 | 0;
        $12 = $12 & $11 | 0;
        $32 = $6 + $12 | 0;
        $14 = (HEAPU8[$32 >> 0] | 0 | ((HEAPU8[($32 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($32 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($32 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
        if (!$14) {
         continue label$13
        }
        break label$13;
       };
      }
      $15 = $10 + -1 | 0;
      label$14 : {
       $2 = (((__wasm_ctz_i32($14 | 0) | 0) >>> 3 | 0) + $12 | 0) & $11 | 0;
       if ((HEAP8[($6 + $2 | 0) >> 0] | 0 | 0) <= (-1 | 0)) {
        break label$14
       }
       $2 = (__wasm_ctz_i32((HEAP32[$6 >> 2] | 0) & -2139062144 | 0 | 0) | 0) >>> 3 | 0;
      }
      $10 = $15 & $10 | 0;
      i64toi32_i32$2 = $17$hi;
      $12 = $17 >>> 25 | 0;
      HEAP8[($6 + $2 | 0) >> 0] = $12;
      HEAP8[(((($2 + -4 | 0) & $11 | 0) + $6 | 0) + 4 | 0) >> 0] = $12;
      i64toi32_i32$0 = $13;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
      $196 = i64toi32_i32$2;
      i64toi32_i32$2 = $7 - ($2 << 3 | 0) | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $196;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      continue label$9;
     };
    }
    HEAP32[($0 + 4 | 0) >> 2] = $2;
    HEAP32[$0 >> 2] = 1;
    HEAP32[($0 + 8 | 0) >> 2] = $6;
    break label$1;
   }
   i64toi32_i32$0 = $1;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $17 = i64toi32_i32$1;
   $17$hi = i64toi32_i32$2;
   i64toi32_i32$0 = $5;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] | 0;
   $207 = i64toi32_i32$2;
   i64toi32_i32$2 = $1;
   HEAP32[i64toi32_i32$2 >> 2] = $207;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   $2 = i64toi32_i32$0 + 32 | 0;
   i64toi32_i32$0 = $2;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $16 = i64toi32_i32$1;
   $16$hi = i64toi32_i32$2;
   $4 = $1 + 8 | 0;
   i64toi32_i32$0 = $4;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $216 = i64toi32_i32$2;
   i64toi32_i32$2 = $2;
   HEAP32[i64toi32_i32$2 >> 2] = $216;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $16$hi;
   i64toi32_i32$2 = i64toi32_i32$0;
   HEAP32[i64toi32_i32$2 >> 2] = $16;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $17$hi;
   i64toi32_i32$2 = $5;
   HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] = $17;
   HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[$0 >> 2] = 0;
   core__ptr__drop_in_place_hashbrown__scopeguard__ScopeGuard_hashbrown__raw__RawTableInner_alloc__alloc__Global__2chashbrown__raw__RawTableInner_alloc__alloc__Global___prepare_resize___7b_7bclosure_7d_7d____hf09be25679474fda(i64toi32_i32$2 + 16 | 0 | 0);
  }
  global$0 = $5 + 80 | 0;
 }
 
 function hashbrown__raw__RawTable_T_2cA___resize__h1555572ec1565477($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $5 = 0, $12 = 0, $6 = 0, $16$hi = 0, $16 = 0, $8 = 0, $10 = 0, i64toi32_i32$4 = 0, $17 = 0, i64toi32_i32$3 = 0, $17$hi = 0, $31 = 0, $14 = 0, $32 = 0, $11 = 0, $33 = 0, $13 = 0, $79 = 0, $82$hi = 0, $84 = 0, $7 = 0, $9 = 0, $15 = 0, $196 = 0, $207 = 0, $216 = 0;
  $5 = global$0 - 80 | 0;
  global$0 = $5;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ($2) {
        break label$5
       }
       i64toi32_i32$0 = 0;
       $16 = 0;
       $16$hi = i64toi32_i32$0;
       $4 = 0;
       $6 = hashbrown__raw__generic__Group__static_empty__hc5a7932fe1bdb1f1() | 0;
       break label$4;
      }
      label$6 : {
       label$7 : {
        if ($2 >>> 0 < 8 >>> 0) {
         break label$7
        }
        label$8 : {
         if (($2 & 536870911 | 0 | 0) != ($2 | 0)) {
          break label$8
         }
         $2 = (-1 >>> Math_clz32(((($2 << 3 | 0) >>> 0) / (7 >>> 0) | 0) + -1 | 0) | 0) + 1 | 0;
         break label$6;
        }
        hashbrown__raw__Fallibility__capacity_overflow__hd790516fe6877097($5 + 8 | 0 | 0, $4 | 0);
        $6 = HEAP32[($5 + 12 | 0) >> 2] | 0;
        $2 = HEAP32[($5 + 8 | 0) >> 2] | 0;
        break label$3;
       }
       $2 = $2 >>> 0 < 4 >>> 0 ? 4 : 8;
      }
      hashbrown__raw__RawTableInner_A___new_uninitialized__h43f4df636ea4ff18($5 + 56 | 0 | 0, 8 | 0, 4 | 0, $2 | 0, $4 | 0);
      $6 = HEAP32[(($5 + 56 | 0) + 8 | 0) >> 2] | 0;
      $2 = HEAP32[($5 + 60 | 0) >> 2] | 0;
      if ((HEAP32[($5 + 56 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      $4 = HEAP32[($5 + 68 | 0) >> 2] | 0;
      memset($6 | 0, 255 | 0, $2 + 5 | 0 | 0) | 0;
      i64toi32_i32$0 = 0;
      $16 = $2;
      $16$hi = i64toi32_i32$0;
     }
     $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
     HEAP32[($5 + 36 | 0) >> 2] = $2;
     HEAP32[($5 + 32 | 0) >> 2] = $4 - $2 | 0;
     i64toi32_i32$1 = $5;
     i64toi32_i32$0 = 4;
     HEAP32[($5 + 16 | 0) >> 2] = 8;
     HEAP32[($5 + 20 | 0) >> 2] = i64toi32_i32$0;
     $79 = $5;
     i64toi32_i32$0 = 0;
     i64toi32_i32$2 = $6;
     i64toi32_i32$1 = 0;
     i64toi32_i32$3 = 32;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
      $33 = 0;
     } else {
      i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
      $33 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
     }
     $82$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $16$hi;
     i64toi32_i32$1 = $82$hi;
     i64toi32_i32$0 = $33;
     i64toi32_i32$2 = $16$hi;
     i64toi32_i32$3 = $16;
     i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
     $84 = i64toi32_i32$0 | $16 | 0;
     i64toi32_i32$0 = $79;
     HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = $84;
     HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = i64toi32_i32$2;
     $7 = $6 + -8 | 0;
     $8 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $4 = $8 + 4 | 0;
     $9 = ((HEAP32[$1 >> 2] | 0) + $8 | 0) + 1 | 0;
     $10 = ((HEAP32[$8 >> 2] | 0) ^ -1 | 0) & -2139062144 | 0;
     i64toi32_i32$2 = $16$hi;
     $11 = $16;
     label$9 : while (1) {
      label$10 : {
       if ($10) {
        break label$10
       }
       label$11 : while (1) {
        if ($4 >>> 0 >= $9 >>> 0) {
         break label$2
        }
        $8 = $8 + -32 | 0;
        $2 = HEAP32[$4 >> 2] | 0;
        $12 = $4 + 4 | 0;
        $4 = $12;
        $2 = $2 & -2139062144 | 0;
        if (($2 | 0) == (-2139062144 | 0)) {
         continue label$11
        }
        break label$11;
       };
       $10 = $2 ^ -2139062144 | 0;
       $4 = $12;
      }
      label$12 : {
       i64toi32_i32$2 = $16$hi;
       $13 = ($8 - ((__wasm_ctz_i32($10 | 0) | 0) & 56 | 0) | 0) + -8 | 0;
       i64toi32_i32$2 = hashbrown__map__make_hash__h5f7c8b88d87207db($3 | 0, $13 | 0) | 0;
       i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
       $17 = i64toi32_i32$2;
       $17$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $16$hi;
       i64toi32_i32$1 = $16;
       i64toi32_i32$2 = $17$hi;
       i64toi32_i32$3 = $17;
       i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
       $12 = i64toi32_i32$1 & $17 | 0;
       $31 = $6 + $12 | 0;
       $14 = (HEAPU8[$31 >> 0] | 0 | ((HEAPU8[($31 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($31 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($31 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
       if ($14) {
        break label$12
       }
       $2 = 4;
       label$13 : while (1) {
        $12 = $12 + $2 | 0;
        $2 = $2 + 4 | 0;
        $12 = $12 & $11 | 0;
        $32 = $6 + $12 | 0;
        $14 = (HEAPU8[$32 >> 0] | 0 | ((HEAPU8[($32 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($32 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($32 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
        if (!$14) {
         continue label$13
        }
        break label$13;
       };
      }
      $15 = $10 + -1 | 0;
      label$14 : {
       $2 = (((__wasm_ctz_i32($14 | 0) | 0) >>> 3 | 0) + $12 | 0) & $11 | 0;
       if ((HEAP8[($6 + $2 | 0) >> 0] | 0 | 0) <= (-1 | 0)) {
        break label$14
       }
       $2 = (__wasm_ctz_i32((HEAP32[$6 >> 2] | 0) & -2139062144 | 0 | 0) | 0) >>> 3 | 0;
      }
      $10 = $15 & $10 | 0;
      i64toi32_i32$2 = $17$hi;
      $12 = $17 >>> 25 | 0;
      HEAP8[($6 + $2 | 0) >> 0] = $12;
      HEAP8[(((($2 + -4 | 0) & $11 | 0) + $6 | 0) + 4 | 0) >> 0] = $12;
      i64toi32_i32$0 = $13;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
      $196 = i64toi32_i32$2;
      i64toi32_i32$2 = $7 - ($2 << 3 | 0) | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $196;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      continue label$9;
     };
    }
    HEAP32[($0 + 4 | 0) >> 2] = $2;
    HEAP32[$0 >> 2] = 1;
    HEAP32[($0 + 8 | 0) >> 2] = $6;
    break label$1;
   }
   i64toi32_i32$0 = $1;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $17 = i64toi32_i32$1;
   $17$hi = i64toi32_i32$2;
   i64toi32_i32$0 = $5;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] | 0;
   $207 = i64toi32_i32$2;
   i64toi32_i32$2 = $1;
   HEAP32[i64toi32_i32$2 >> 2] = $207;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   $2 = i64toi32_i32$0 + 32 | 0;
   i64toi32_i32$0 = $2;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $16 = i64toi32_i32$1;
   $16$hi = i64toi32_i32$2;
   $4 = $1 + 8 | 0;
   i64toi32_i32$0 = $4;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $216 = i64toi32_i32$2;
   i64toi32_i32$2 = $2;
   HEAP32[i64toi32_i32$2 >> 2] = $216;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $16$hi;
   i64toi32_i32$2 = i64toi32_i32$0;
   HEAP32[i64toi32_i32$2 >> 2] = $16;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $17$hi;
   i64toi32_i32$2 = $5;
   HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] = $17;
   HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[$0 >> 2] = 0;
   core__ptr__drop_in_place_hashbrown__scopeguard__ScopeGuard_hashbrown__raw__RawTableInner_alloc__alloc__Global__2chashbrown__raw__RawTableInner_alloc__alloc__Global___prepare_resize___7b_7bclosure_7d_7d____hf09be25679474fda(i64toi32_i32$2 + 16 | 0 | 0);
  }
  global$0 = $5 + 80 | 0;
 }
 
 function hashbrown__raw__RawTable_T_2cA___resize__h98a159c00cc226ef($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $5 = 0, $12 = 0, $6 = 0, $16$hi = 0, $16 = 0, $8 = 0, $10 = 0, i64toi32_i32$4 = 0, $17 = 0, i64toi32_i32$3 = 0, $17$hi = 0, $31 = 0, $14 = 0, $32 = 0, $11 = 0, $33 = 0, $13 = 0, $79 = 0, $82$hi = 0, $84 = 0, $7 = 0, $9 = 0, $15 = 0, $196 = 0, $207 = 0, $216 = 0;
  $5 = global$0 - 80 | 0;
  global$0 = $5;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ($2) {
        break label$5
       }
       i64toi32_i32$0 = 0;
       $16 = 0;
       $16$hi = i64toi32_i32$0;
       $4 = 0;
       $6 = hashbrown__raw__generic__Group__static_empty__hc5a7932fe1bdb1f1() | 0;
       break label$4;
      }
      label$6 : {
       label$7 : {
        if ($2 >>> 0 < 8 >>> 0) {
         break label$7
        }
        label$8 : {
         if (($2 & 536870911 | 0 | 0) != ($2 | 0)) {
          break label$8
         }
         $2 = (-1 >>> Math_clz32(((($2 << 3 | 0) >>> 0) / (7 >>> 0) | 0) + -1 | 0) | 0) + 1 | 0;
         break label$6;
        }
        hashbrown__raw__Fallibility__capacity_overflow__hd790516fe6877097($5 + 8 | 0 | 0, $4 | 0);
        $6 = HEAP32[($5 + 12 | 0) >> 2] | 0;
        $2 = HEAP32[($5 + 8 | 0) >> 2] | 0;
        break label$3;
       }
       $2 = $2 >>> 0 < 4 >>> 0 ? 4 : 8;
      }
      hashbrown__raw__RawTableInner_A___new_uninitialized__h43f4df636ea4ff18($5 + 56 | 0 | 0, 8 | 0, 4 | 0, $2 | 0, $4 | 0);
      $6 = HEAP32[(($5 + 56 | 0) + 8 | 0) >> 2] | 0;
      $2 = HEAP32[($5 + 60 | 0) >> 2] | 0;
      if ((HEAP32[($5 + 56 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      $4 = HEAP32[($5 + 68 | 0) >> 2] | 0;
      memset($6 | 0, 255 | 0, $2 + 5 | 0 | 0) | 0;
      i64toi32_i32$0 = 0;
      $16 = $2;
      $16$hi = i64toi32_i32$0;
     }
     $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
     HEAP32[($5 + 36 | 0) >> 2] = $2;
     HEAP32[($5 + 32 | 0) >> 2] = $4 - $2 | 0;
     i64toi32_i32$1 = $5;
     i64toi32_i32$0 = 4;
     HEAP32[($5 + 16 | 0) >> 2] = 8;
     HEAP32[($5 + 20 | 0) >> 2] = i64toi32_i32$0;
     $79 = $5;
     i64toi32_i32$0 = 0;
     i64toi32_i32$2 = $6;
     i64toi32_i32$1 = 0;
     i64toi32_i32$3 = 32;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
      $33 = 0;
     } else {
      i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
      $33 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
     }
     $82$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $16$hi;
     i64toi32_i32$1 = $82$hi;
     i64toi32_i32$0 = $33;
     i64toi32_i32$2 = $16$hi;
     i64toi32_i32$3 = $16;
     i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
     $84 = i64toi32_i32$0 | $16 | 0;
     i64toi32_i32$0 = $79;
     HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = $84;
     HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = i64toi32_i32$2;
     $7 = $6 + -8 | 0;
     $8 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $4 = $8 + 4 | 0;
     $9 = ((HEAP32[$1 >> 2] | 0) + $8 | 0) + 1 | 0;
     $10 = ((HEAP32[$8 >> 2] | 0) ^ -1 | 0) & -2139062144 | 0;
     i64toi32_i32$2 = $16$hi;
     $11 = $16;
     label$9 : while (1) {
      label$10 : {
       if ($10) {
        break label$10
       }
       label$11 : while (1) {
        if ($4 >>> 0 >= $9 >>> 0) {
         break label$2
        }
        $8 = $8 + -32 | 0;
        $2 = HEAP32[$4 >> 2] | 0;
        $12 = $4 + 4 | 0;
        $4 = $12;
        $2 = $2 & -2139062144 | 0;
        if (($2 | 0) == (-2139062144 | 0)) {
         continue label$11
        }
        break label$11;
       };
       $10 = $2 ^ -2139062144 | 0;
       $4 = $12;
      }
      label$12 : {
       i64toi32_i32$2 = $16$hi;
       $13 = ($8 - ((__wasm_ctz_i32($10 | 0) | 0) & 56 | 0) | 0) + -8 | 0;
       i64toi32_i32$2 = hashbrown__map__make_hash__ha3ef0991d7baec61($3 | 0, $13 | 0) | 0;
       i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
       $17 = i64toi32_i32$2;
       $17$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $16$hi;
       i64toi32_i32$1 = $16;
       i64toi32_i32$2 = $17$hi;
       i64toi32_i32$3 = $17;
       i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
       $12 = i64toi32_i32$1 & $17 | 0;
       $31 = $6 + $12 | 0;
       $14 = (HEAPU8[$31 >> 0] | 0 | ((HEAPU8[($31 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($31 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($31 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
       if ($14) {
        break label$12
       }
       $2 = 4;
       label$13 : while (1) {
        $12 = $12 + $2 | 0;
        $2 = $2 + 4 | 0;
        $12 = $12 & $11 | 0;
        $32 = $6 + $12 | 0;
        $14 = (HEAPU8[$32 >> 0] | 0 | ((HEAPU8[($32 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($32 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($32 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
        if (!$14) {
         continue label$13
        }
        break label$13;
       };
      }
      $15 = $10 + -1 | 0;
      label$14 : {
       $2 = (((__wasm_ctz_i32($14 | 0) | 0) >>> 3 | 0) + $12 | 0) & $11 | 0;
       if ((HEAP8[($6 + $2 | 0) >> 0] | 0 | 0) <= (-1 | 0)) {
        break label$14
       }
       $2 = (__wasm_ctz_i32((HEAP32[$6 >> 2] | 0) & -2139062144 | 0 | 0) | 0) >>> 3 | 0;
      }
      $10 = $15 & $10 | 0;
      i64toi32_i32$2 = $17$hi;
      $12 = $17 >>> 25 | 0;
      HEAP8[($6 + $2 | 0) >> 0] = $12;
      HEAP8[(((($2 + -4 | 0) & $11 | 0) + $6 | 0) + 4 | 0) >> 0] = $12;
      i64toi32_i32$0 = $13;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
      $196 = i64toi32_i32$2;
      i64toi32_i32$2 = $7 - ($2 << 3 | 0) | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $196;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      continue label$9;
     };
    }
    HEAP32[($0 + 4 | 0) >> 2] = $2;
    HEAP32[$0 >> 2] = 1;
    HEAP32[($0 + 8 | 0) >> 2] = $6;
    break label$1;
   }
   i64toi32_i32$0 = $1;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $17 = i64toi32_i32$1;
   $17$hi = i64toi32_i32$2;
   i64toi32_i32$0 = $5;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] | 0;
   $207 = i64toi32_i32$2;
   i64toi32_i32$2 = $1;
   HEAP32[i64toi32_i32$2 >> 2] = $207;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   $2 = i64toi32_i32$0 + 32 | 0;
   i64toi32_i32$0 = $2;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $16 = i64toi32_i32$1;
   $16$hi = i64toi32_i32$2;
   $4 = $1 + 8 | 0;
   i64toi32_i32$0 = $4;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $216 = i64toi32_i32$2;
   i64toi32_i32$2 = $2;
   HEAP32[i64toi32_i32$2 >> 2] = $216;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $16$hi;
   i64toi32_i32$2 = i64toi32_i32$0;
   HEAP32[i64toi32_i32$2 >> 2] = $16;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $17$hi;
   i64toi32_i32$2 = $5;
   HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] = $17;
   HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[$0 >> 2] = 0;
   core__ptr__drop_in_place_hashbrown__scopeguard__ScopeGuard_hashbrown__raw__RawTableInner_alloc__alloc__Global__2chashbrown__raw__RawTableInner_alloc__alloc__Global___prepare_resize___7b_7bclosure_7d_7d____hf09be25679474fda(i64toi32_i32$2 + 16 | 0 | 0);
  }
  global$0 = $5 + 80 | 0;
 }
 
 function hashbrown__raw__RawTable_T_2cA___resize__h272f5993ec3ece2b($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $5 = 0, $12 = 0, $6 = 0, $16$hi = 0, $16 = 0, $8 = 0, $10 = 0, i64toi32_i32$4 = 0, $17 = 0, i64toi32_i32$3 = 0, $17$hi = 0, $31 = 0, $14 = 0, $32 = 0, $11 = 0, $33 = 0, $13 = 0, $79 = 0, $82$hi = 0, $84 = 0, $7 = 0, $9 = 0, $15 = 0, $196 = 0, $207 = 0, $216 = 0;
  $5 = global$0 - 80 | 0;
  global$0 = $5;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ($2) {
        break label$5
       }
       i64toi32_i32$0 = 0;
       $16 = 0;
       $16$hi = i64toi32_i32$0;
       $4 = 0;
       $6 = hashbrown__raw__generic__Group__static_empty__hc5a7932fe1bdb1f1() | 0;
       break label$4;
      }
      label$6 : {
       label$7 : {
        if ($2 >>> 0 < 8 >>> 0) {
         break label$7
        }
        label$8 : {
         if (($2 & 536870911 | 0 | 0) != ($2 | 0)) {
          break label$8
         }
         $2 = (-1 >>> Math_clz32(((($2 << 3 | 0) >>> 0) / (7 >>> 0) | 0) + -1 | 0) | 0) + 1 | 0;
         break label$6;
        }
        hashbrown__raw__Fallibility__capacity_overflow__hd790516fe6877097($5 + 8 | 0 | 0, $4 | 0);
        $6 = HEAP32[($5 + 12 | 0) >> 2] | 0;
        $2 = HEAP32[($5 + 8 | 0) >> 2] | 0;
        break label$3;
       }
       $2 = $2 >>> 0 < 4 >>> 0 ? 4 : 8;
      }
      hashbrown__raw__RawTableInner_A___new_uninitialized__h43f4df636ea4ff18($5 + 56 | 0 | 0, 8 | 0, 4 | 0, $2 | 0, $4 | 0);
      $6 = HEAP32[(($5 + 56 | 0) + 8 | 0) >> 2] | 0;
      $2 = HEAP32[($5 + 60 | 0) >> 2] | 0;
      if ((HEAP32[($5 + 56 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      $4 = HEAP32[($5 + 68 | 0) >> 2] | 0;
      memset($6 | 0, 255 | 0, $2 + 5 | 0 | 0) | 0;
      i64toi32_i32$0 = 0;
      $16 = $2;
      $16$hi = i64toi32_i32$0;
     }
     $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
     HEAP32[($5 + 36 | 0) >> 2] = $2;
     HEAP32[($5 + 32 | 0) >> 2] = $4 - $2 | 0;
     i64toi32_i32$1 = $5;
     i64toi32_i32$0 = 4;
     HEAP32[($5 + 16 | 0) >> 2] = 8;
     HEAP32[($5 + 20 | 0) >> 2] = i64toi32_i32$0;
     $79 = $5;
     i64toi32_i32$0 = 0;
     i64toi32_i32$2 = $6;
     i64toi32_i32$1 = 0;
     i64toi32_i32$3 = 32;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
      $33 = 0;
     } else {
      i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
      $33 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
     }
     $82$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $16$hi;
     i64toi32_i32$1 = $82$hi;
     i64toi32_i32$0 = $33;
     i64toi32_i32$2 = $16$hi;
     i64toi32_i32$3 = $16;
     i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
     $84 = i64toi32_i32$0 | $16 | 0;
     i64toi32_i32$0 = $79;
     HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = $84;
     HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = i64toi32_i32$2;
     $7 = $6 + -8 | 0;
     $8 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $4 = $8 + 4 | 0;
     $9 = ((HEAP32[$1 >> 2] | 0) + $8 | 0) + 1 | 0;
     $10 = ((HEAP32[$8 >> 2] | 0) ^ -1 | 0) & -2139062144 | 0;
     i64toi32_i32$2 = $16$hi;
     $11 = $16;
     label$9 : while (1) {
      label$10 : {
       if ($10) {
        break label$10
       }
       label$11 : while (1) {
        if ($4 >>> 0 >= $9 >>> 0) {
         break label$2
        }
        $8 = $8 + -32 | 0;
        $2 = HEAP32[$4 >> 2] | 0;
        $12 = $4 + 4 | 0;
        $4 = $12;
        $2 = $2 & -2139062144 | 0;
        if (($2 | 0) == (-2139062144 | 0)) {
         continue label$11
        }
        break label$11;
       };
       $10 = $2 ^ -2139062144 | 0;
       $4 = $12;
      }
      label$12 : {
       i64toi32_i32$2 = $16$hi;
       $13 = ($8 - ((__wasm_ctz_i32($10 | 0) | 0) & 56 | 0) | 0) + -8 | 0;
       i64toi32_i32$2 = hashbrown__map__make_hash__hc29185c590e608df($3 | 0, $13 | 0) | 0;
       i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
       $17 = i64toi32_i32$2;
       $17$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $16$hi;
       i64toi32_i32$1 = $16;
       i64toi32_i32$2 = $17$hi;
       i64toi32_i32$3 = $17;
       i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
       $12 = i64toi32_i32$1 & $17 | 0;
       $31 = $6 + $12 | 0;
       $14 = (HEAPU8[$31 >> 0] | 0 | ((HEAPU8[($31 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($31 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($31 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
       if ($14) {
        break label$12
       }
       $2 = 4;
       label$13 : while (1) {
        $12 = $12 + $2 | 0;
        $2 = $2 + 4 | 0;
        $12 = $12 & $11 | 0;
        $32 = $6 + $12 | 0;
        $14 = (HEAPU8[$32 >> 0] | 0 | ((HEAPU8[($32 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($32 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($32 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
        if (!$14) {
         continue label$13
        }
        break label$13;
       };
      }
      $15 = $10 + -1 | 0;
      label$14 : {
       $2 = (((__wasm_ctz_i32($14 | 0) | 0) >>> 3 | 0) + $12 | 0) & $11 | 0;
       if ((HEAP8[($6 + $2 | 0) >> 0] | 0 | 0) <= (-1 | 0)) {
        break label$14
       }
       $2 = (__wasm_ctz_i32((HEAP32[$6 >> 2] | 0) & -2139062144 | 0 | 0) | 0) >>> 3 | 0;
      }
      $10 = $15 & $10 | 0;
      i64toi32_i32$2 = $17$hi;
      $12 = $17 >>> 25 | 0;
      HEAP8[($6 + $2 | 0) >> 0] = $12;
      HEAP8[(((($2 + -4 | 0) & $11 | 0) + $6 | 0) + 4 | 0) >> 0] = $12;
      i64toi32_i32$0 = $13;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
      $196 = i64toi32_i32$2;
      i64toi32_i32$2 = $7 - ($2 << 3 | 0) | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $196;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      continue label$9;
     };
    }
    HEAP32[($0 + 4 | 0) >> 2] = $2;
    HEAP32[$0 >> 2] = 1;
    HEAP32[($0 + 8 | 0) >> 2] = $6;
    break label$1;
   }
   i64toi32_i32$0 = $1;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $17 = i64toi32_i32$1;
   $17$hi = i64toi32_i32$2;
   i64toi32_i32$0 = $5;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] | 0;
   $207 = i64toi32_i32$2;
   i64toi32_i32$2 = $1;
   HEAP32[i64toi32_i32$2 >> 2] = $207;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   $2 = i64toi32_i32$0 + 32 | 0;
   i64toi32_i32$0 = $2;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $16 = i64toi32_i32$1;
   $16$hi = i64toi32_i32$2;
   $4 = $1 + 8 | 0;
   i64toi32_i32$0 = $4;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $216 = i64toi32_i32$2;
   i64toi32_i32$2 = $2;
   HEAP32[i64toi32_i32$2 >> 2] = $216;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $16$hi;
   i64toi32_i32$2 = i64toi32_i32$0;
   HEAP32[i64toi32_i32$2 >> 2] = $16;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $17$hi;
   i64toi32_i32$2 = $5;
   HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] = $17;
   HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[$0 >> 2] = 0;
   core__ptr__drop_in_place_hashbrown__scopeguard__ScopeGuard_hashbrown__raw__RawTableInner_alloc__alloc__Global__2chashbrown__raw__RawTableInner_alloc__alloc__Global___prepare_resize___7b_7bclosure_7d_7d____hf09be25679474fda(i64toi32_i32$2 + 16 | 0 | 0);
  }
  global$0 = $5 + 80 | 0;
 }
 
 function hashbrown__raw__RawTable_T_2cA___resize__hc18bdde8d939a846($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $5 = 0, $12 = 0, $6 = 0, $16$hi = 0, $16 = 0, $8 = 0, $10 = 0, i64toi32_i32$4 = 0, $17 = 0, i64toi32_i32$3 = 0, $17$hi = 0, $31 = 0, $14 = 0, $32 = 0, $11 = 0, $33 = 0, $13 = 0, $79 = 0, $82$hi = 0, $84 = 0, $7 = 0, $9 = 0, $15 = 0, $196 = 0, $207 = 0, $216 = 0;
  $5 = global$0 - 80 | 0;
  global$0 = $5;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ($2) {
        break label$5
       }
       i64toi32_i32$0 = 0;
       $16 = 0;
       $16$hi = i64toi32_i32$0;
       $4 = 0;
       $6 = hashbrown__raw__generic__Group__static_empty__hc5a7932fe1bdb1f1() | 0;
       break label$4;
      }
      label$6 : {
       label$7 : {
        if ($2 >>> 0 < 8 >>> 0) {
         break label$7
        }
        label$8 : {
         if (($2 & 536870911 | 0 | 0) != ($2 | 0)) {
          break label$8
         }
         $2 = (-1 >>> Math_clz32(((($2 << 3 | 0) >>> 0) / (7 >>> 0) | 0) + -1 | 0) | 0) + 1 | 0;
         break label$6;
        }
        hashbrown__raw__Fallibility__capacity_overflow__hd790516fe6877097($5 + 8 | 0 | 0, $4 | 0);
        $6 = HEAP32[($5 + 12 | 0) >> 2] | 0;
        $2 = HEAP32[($5 + 8 | 0) >> 2] | 0;
        break label$3;
       }
       $2 = $2 >>> 0 < 4 >>> 0 ? 4 : 8;
      }
      hashbrown__raw__RawTableInner_A___new_uninitialized__h43f4df636ea4ff18($5 + 56 | 0 | 0, 8 | 0, 4 | 0, $2 | 0, $4 | 0);
      $6 = HEAP32[(($5 + 56 | 0) + 8 | 0) >> 2] | 0;
      $2 = HEAP32[($5 + 60 | 0) >> 2] | 0;
      if ((HEAP32[($5 + 56 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      $4 = HEAP32[($5 + 68 | 0) >> 2] | 0;
      memset($6 | 0, 255 | 0, $2 + 5 | 0 | 0) | 0;
      i64toi32_i32$0 = 0;
      $16 = $2;
      $16$hi = i64toi32_i32$0;
     }
     $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
     HEAP32[($5 + 36 | 0) >> 2] = $2;
     HEAP32[($5 + 32 | 0) >> 2] = $4 - $2 | 0;
     i64toi32_i32$1 = $5;
     i64toi32_i32$0 = 4;
     HEAP32[($5 + 16 | 0) >> 2] = 8;
     HEAP32[($5 + 20 | 0) >> 2] = i64toi32_i32$0;
     $79 = $5;
     i64toi32_i32$0 = 0;
     i64toi32_i32$2 = $6;
     i64toi32_i32$1 = 0;
     i64toi32_i32$3 = 32;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
      $33 = 0;
     } else {
      i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
      $33 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
     }
     $82$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $16$hi;
     i64toi32_i32$1 = $82$hi;
     i64toi32_i32$0 = $33;
     i64toi32_i32$2 = $16$hi;
     i64toi32_i32$3 = $16;
     i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
     $84 = i64toi32_i32$0 | $16 | 0;
     i64toi32_i32$0 = $79;
     HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = $84;
     HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = i64toi32_i32$2;
     $7 = $6 + -8 | 0;
     $8 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $4 = $8 + 4 | 0;
     $9 = ((HEAP32[$1 >> 2] | 0) + $8 | 0) + 1 | 0;
     $10 = ((HEAP32[$8 >> 2] | 0) ^ -1 | 0) & -2139062144 | 0;
     i64toi32_i32$2 = $16$hi;
     $11 = $16;
     label$9 : while (1) {
      label$10 : {
       if ($10) {
        break label$10
       }
       label$11 : while (1) {
        if ($4 >>> 0 >= $9 >>> 0) {
         break label$2
        }
        $8 = $8 + -32 | 0;
        $2 = HEAP32[$4 >> 2] | 0;
        $12 = $4 + 4 | 0;
        $4 = $12;
        $2 = $2 & -2139062144 | 0;
        if (($2 | 0) == (-2139062144 | 0)) {
         continue label$11
        }
        break label$11;
       };
       $10 = $2 ^ -2139062144 | 0;
       $4 = $12;
      }
      label$12 : {
       i64toi32_i32$2 = $16$hi;
       $13 = ($8 - ((__wasm_ctz_i32($10 | 0) | 0) & 56 | 0) | 0) + -8 | 0;
       i64toi32_i32$2 = hashbrown__map__make_hash__h98d8394e57bcc228($3 | 0, $13 | 0) | 0;
       i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
       $17 = i64toi32_i32$2;
       $17$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $16$hi;
       i64toi32_i32$1 = $16;
       i64toi32_i32$2 = $17$hi;
       i64toi32_i32$3 = $17;
       i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
       $12 = i64toi32_i32$1 & $17 | 0;
       $31 = $6 + $12 | 0;
       $14 = (HEAPU8[$31 >> 0] | 0 | ((HEAPU8[($31 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($31 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($31 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
       if ($14) {
        break label$12
       }
       $2 = 4;
       label$13 : while (1) {
        $12 = $12 + $2 | 0;
        $2 = $2 + 4 | 0;
        $12 = $12 & $11 | 0;
        $32 = $6 + $12 | 0;
        $14 = (HEAPU8[$32 >> 0] | 0 | ((HEAPU8[($32 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($32 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($32 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
        if (!$14) {
         continue label$13
        }
        break label$13;
       };
      }
      $15 = $10 + -1 | 0;
      label$14 : {
       $2 = (((__wasm_ctz_i32($14 | 0) | 0) >>> 3 | 0) + $12 | 0) & $11 | 0;
       if ((HEAP8[($6 + $2 | 0) >> 0] | 0 | 0) <= (-1 | 0)) {
        break label$14
       }
       $2 = (__wasm_ctz_i32((HEAP32[$6 >> 2] | 0) & -2139062144 | 0 | 0) | 0) >>> 3 | 0;
      }
      $10 = $15 & $10 | 0;
      i64toi32_i32$2 = $17$hi;
      $12 = $17 >>> 25 | 0;
      HEAP8[($6 + $2 | 0) >> 0] = $12;
      HEAP8[(((($2 + -4 | 0) & $11 | 0) + $6 | 0) + 4 | 0) >> 0] = $12;
      i64toi32_i32$0 = $13;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
      $196 = i64toi32_i32$2;
      i64toi32_i32$2 = $7 - ($2 << 3 | 0) | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $196;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      continue label$9;
     };
    }
    HEAP32[($0 + 4 | 0) >> 2] = $2;
    HEAP32[$0 >> 2] = 1;
    HEAP32[($0 + 8 | 0) >> 2] = $6;
    break label$1;
   }
   i64toi32_i32$0 = $1;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $17 = i64toi32_i32$1;
   $17$hi = i64toi32_i32$2;
   i64toi32_i32$0 = $5;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] | 0;
   $207 = i64toi32_i32$2;
   i64toi32_i32$2 = $1;
   HEAP32[i64toi32_i32$2 >> 2] = $207;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   $2 = i64toi32_i32$0 + 32 | 0;
   i64toi32_i32$0 = $2;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $16 = i64toi32_i32$1;
   $16$hi = i64toi32_i32$2;
   $4 = $1 + 8 | 0;
   i64toi32_i32$0 = $4;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $216 = i64toi32_i32$2;
   i64toi32_i32$2 = $2;
   HEAP32[i64toi32_i32$2 >> 2] = $216;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $16$hi;
   i64toi32_i32$2 = i64toi32_i32$0;
   HEAP32[i64toi32_i32$2 >> 2] = $16;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $17$hi;
   i64toi32_i32$2 = $5;
   HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] = $17;
   HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[$0 >> 2] = 0;
   core__ptr__drop_in_place_hashbrown__scopeguard__ScopeGuard_hashbrown__raw__RawTableInner_alloc__alloc__Global__2chashbrown__raw__RawTableInner_alloc__alloc__Global___prepare_resize___7b_7bclosure_7d_7d____hf09be25679474fda(i64toi32_i32$2 + 16 | 0 | 0);
  }
  global$0 = $5 + 80 | 0;
 }
 
 function hashbrown__raw__RawTable_T_2cA___resize__hdc7ba59faabe2921($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $5 = 0, $12 = 0, $6 = 0, $16$hi = 0, $16 = 0, $8 = 0, $10 = 0, i64toi32_i32$4 = 0, $17 = 0, i64toi32_i32$3 = 0, $17$hi = 0, $31 = 0, $14 = 0, $32 = 0, $11 = 0, $33 = 0, $13 = 0, $79 = 0, $82$hi = 0, $84 = 0, $7 = 0, $9 = 0, $15 = 0, $196 = 0, $207 = 0, $216 = 0;
  $5 = global$0 - 80 | 0;
  global$0 = $5;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ($2) {
        break label$5
       }
       i64toi32_i32$0 = 0;
       $16 = 0;
       $16$hi = i64toi32_i32$0;
       $4 = 0;
       $6 = hashbrown__raw__generic__Group__static_empty__hc5a7932fe1bdb1f1() | 0;
       break label$4;
      }
      label$6 : {
       label$7 : {
        if ($2 >>> 0 < 8 >>> 0) {
         break label$7
        }
        label$8 : {
         if (($2 & 536870911 | 0 | 0) != ($2 | 0)) {
          break label$8
         }
         $2 = (-1 >>> Math_clz32(((($2 << 3 | 0) >>> 0) / (7 >>> 0) | 0) + -1 | 0) | 0) + 1 | 0;
         break label$6;
        }
        hashbrown__raw__Fallibility__capacity_overflow__hd790516fe6877097($5 + 8 | 0 | 0, $4 | 0);
        $6 = HEAP32[($5 + 12 | 0) >> 2] | 0;
        $2 = HEAP32[($5 + 8 | 0) >> 2] | 0;
        break label$3;
       }
       $2 = $2 >>> 0 < 4 >>> 0 ? 4 : 8;
      }
      hashbrown__raw__RawTableInner_A___new_uninitialized__h43f4df636ea4ff18($5 + 56 | 0 | 0, 8 | 0, 4 | 0, $2 | 0, $4 | 0);
      $6 = HEAP32[(($5 + 56 | 0) + 8 | 0) >> 2] | 0;
      $2 = HEAP32[($5 + 60 | 0) >> 2] | 0;
      if ((HEAP32[($5 + 56 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      $4 = HEAP32[($5 + 68 | 0) >> 2] | 0;
      memset($6 | 0, 255 | 0, $2 + 5 | 0 | 0) | 0;
      i64toi32_i32$0 = 0;
      $16 = $2;
      $16$hi = i64toi32_i32$0;
     }
     $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
     HEAP32[($5 + 36 | 0) >> 2] = $2;
     HEAP32[($5 + 32 | 0) >> 2] = $4 - $2 | 0;
     i64toi32_i32$1 = $5;
     i64toi32_i32$0 = 4;
     HEAP32[($5 + 16 | 0) >> 2] = 8;
     HEAP32[($5 + 20 | 0) >> 2] = i64toi32_i32$0;
     $79 = $5;
     i64toi32_i32$0 = 0;
     i64toi32_i32$2 = $6;
     i64toi32_i32$1 = 0;
     i64toi32_i32$3 = 32;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
      $33 = 0;
     } else {
      i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
      $33 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
     }
     $82$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $16$hi;
     i64toi32_i32$1 = $82$hi;
     i64toi32_i32$0 = $33;
     i64toi32_i32$2 = $16$hi;
     i64toi32_i32$3 = $16;
     i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
     $84 = i64toi32_i32$0 | $16 | 0;
     i64toi32_i32$0 = $79;
     HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = $84;
     HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = i64toi32_i32$2;
     $7 = $6 + -8 | 0;
     $8 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $4 = $8 + 4 | 0;
     $9 = ((HEAP32[$1 >> 2] | 0) + $8 | 0) + 1 | 0;
     $10 = ((HEAP32[$8 >> 2] | 0) ^ -1 | 0) & -2139062144 | 0;
     i64toi32_i32$2 = $16$hi;
     $11 = $16;
     label$9 : while (1) {
      label$10 : {
       if ($10) {
        break label$10
       }
       label$11 : while (1) {
        if ($4 >>> 0 >= $9 >>> 0) {
         break label$2
        }
        $8 = $8 + -32 | 0;
        $2 = HEAP32[$4 >> 2] | 0;
        $12 = $4 + 4 | 0;
        $4 = $12;
        $2 = $2 & -2139062144 | 0;
        if (($2 | 0) == (-2139062144 | 0)) {
         continue label$11
        }
        break label$11;
       };
       $10 = $2 ^ -2139062144 | 0;
       $4 = $12;
      }
      label$12 : {
       i64toi32_i32$2 = $16$hi;
       $13 = ($8 - ((__wasm_ctz_i32($10 | 0) | 0) & 56 | 0) | 0) + -8 | 0;
       i64toi32_i32$2 = hashbrown__map__make_hash__hf66765788ec743b7($3 | 0, $13 | 0) | 0;
       i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
       $17 = i64toi32_i32$2;
       $17$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $16$hi;
       i64toi32_i32$1 = $16;
       i64toi32_i32$2 = $17$hi;
       i64toi32_i32$3 = $17;
       i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
       $12 = i64toi32_i32$1 & $17 | 0;
       $31 = $6 + $12 | 0;
       $14 = (HEAPU8[$31 >> 0] | 0 | ((HEAPU8[($31 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($31 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($31 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
       if ($14) {
        break label$12
       }
       $2 = 4;
       label$13 : while (1) {
        $12 = $12 + $2 | 0;
        $2 = $2 + 4 | 0;
        $12 = $12 & $11 | 0;
        $32 = $6 + $12 | 0;
        $14 = (HEAPU8[$32 >> 0] | 0 | ((HEAPU8[($32 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($32 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($32 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
        if (!$14) {
         continue label$13
        }
        break label$13;
       };
      }
      $15 = $10 + -1 | 0;
      label$14 : {
       $2 = (((__wasm_ctz_i32($14 | 0) | 0) >>> 3 | 0) + $12 | 0) & $11 | 0;
       if ((HEAP8[($6 + $2 | 0) >> 0] | 0 | 0) <= (-1 | 0)) {
        break label$14
       }
       $2 = (__wasm_ctz_i32((HEAP32[$6 >> 2] | 0) & -2139062144 | 0 | 0) | 0) >>> 3 | 0;
      }
      $10 = $15 & $10 | 0;
      i64toi32_i32$2 = $17$hi;
      $12 = $17 >>> 25 | 0;
      HEAP8[($6 + $2 | 0) >> 0] = $12;
      HEAP8[(((($2 + -4 | 0) & $11 | 0) + $6 | 0) + 4 | 0) >> 0] = $12;
      i64toi32_i32$0 = $13;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
      $196 = i64toi32_i32$2;
      i64toi32_i32$2 = $7 - ($2 << 3 | 0) | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $196;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      continue label$9;
     };
    }
    HEAP32[($0 + 4 | 0) >> 2] = $2;
    HEAP32[$0 >> 2] = 1;
    HEAP32[($0 + 8 | 0) >> 2] = $6;
    break label$1;
   }
   i64toi32_i32$0 = $1;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $17 = i64toi32_i32$1;
   $17$hi = i64toi32_i32$2;
   i64toi32_i32$0 = $5;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] | 0;
   $207 = i64toi32_i32$2;
   i64toi32_i32$2 = $1;
   HEAP32[i64toi32_i32$2 >> 2] = $207;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   $2 = i64toi32_i32$0 + 32 | 0;
   i64toi32_i32$0 = $2;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $16 = i64toi32_i32$1;
   $16$hi = i64toi32_i32$2;
   $4 = $1 + 8 | 0;
   i64toi32_i32$0 = $4;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $216 = i64toi32_i32$2;
   i64toi32_i32$2 = $2;
   HEAP32[i64toi32_i32$2 >> 2] = $216;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $16$hi;
   i64toi32_i32$2 = i64toi32_i32$0;
   HEAP32[i64toi32_i32$2 >> 2] = $16;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $17$hi;
   i64toi32_i32$2 = $5;
   HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] = $17;
   HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[$0 >> 2] = 0;
   core__ptr__drop_in_place_hashbrown__scopeguard__ScopeGuard_hashbrown__raw__RawTableInner_alloc__alloc__Global__2chashbrown__raw__RawTableInner_alloc__alloc__Global___prepare_resize___7b_7bclosure_7d_7d____hf09be25679474fda(i64toi32_i32$2 + 16 | 0 | 0);
  }
  global$0 = $5 + 80 | 0;
 }
 
 function hashbrown__raw__RawTable_T_2cA___resize__hedba9ac6008c9926($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $5 = 0, $12 = 0, $6 = 0, $16$hi = 0, $16 = 0, $8 = 0, $10 = 0, i64toi32_i32$4 = 0, $17 = 0, i64toi32_i32$3 = 0, $17$hi = 0, $31 = 0, $14 = 0, $32 = 0, $11 = 0, $33 = 0, $13 = 0, $79 = 0, $82$hi = 0, $84 = 0, $7 = 0, $9 = 0, $15 = 0, $196 = 0, $207 = 0, $216 = 0;
  $5 = global$0 - 80 | 0;
  global$0 = $5;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ($2) {
        break label$5
       }
       i64toi32_i32$0 = 0;
       $16 = 0;
       $16$hi = i64toi32_i32$0;
       $4 = 0;
       $6 = hashbrown__raw__generic__Group__static_empty__hc5a7932fe1bdb1f1() | 0;
       break label$4;
      }
      label$6 : {
       label$7 : {
        if ($2 >>> 0 < 8 >>> 0) {
         break label$7
        }
        label$8 : {
         if (($2 & 536870911 | 0 | 0) != ($2 | 0)) {
          break label$8
         }
         $2 = (-1 >>> Math_clz32(((($2 << 3 | 0) >>> 0) / (7 >>> 0) | 0) + -1 | 0) | 0) + 1 | 0;
         break label$6;
        }
        hashbrown__raw__Fallibility__capacity_overflow__hd790516fe6877097($5 + 8 | 0 | 0, $4 | 0);
        $6 = HEAP32[($5 + 12 | 0) >> 2] | 0;
        $2 = HEAP32[($5 + 8 | 0) >> 2] | 0;
        break label$3;
       }
       $2 = $2 >>> 0 < 4 >>> 0 ? 4 : 8;
      }
      hashbrown__raw__RawTableInner_A___new_uninitialized__h43f4df636ea4ff18($5 + 56 | 0 | 0, 8 | 0, 4 | 0, $2 | 0, $4 | 0);
      $6 = HEAP32[(($5 + 56 | 0) + 8 | 0) >> 2] | 0;
      $2 = HEAP32[($5 + 60 | 0) >> 2] | 0;
      if ((HEAP32[($5 + 56 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      $4 = HEAP32[($5 + 68 | 0) >> 2] | 0;
      memset($6 | 0, 255 | 0, $2 + 5 | 0 | 0) | 0;
      i64toi32_i32$0 = 0;
      $16 = $2;
      $16$hi = i64toi32_i32$0;
     }
     $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
     HEAP32[($5 + 36 | 0) >> 2] = $2;
     HEAP32[($5 + 32 | 0) >> 2] = $4 - $2 | 0;
     i64toi32_i32$1 = $5;
     i64toi32_i32$0 = 4;
     HEAP32[($5 + 16 | 0) >> 2] = 8;
     HEAP32[($5 + 20 | 0) >> 2] = i64toi32_i32$0;
     $79 = $5;
     i64toi32_i32$0 = 0;
     i64toi32_i32$2 = $6;
     i64toi32_i32$1 = 0;
     i64toi32_i32$3 = 32;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
      $33 = 0;
     } else {
      i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
      $33 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
     }
     $82$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $16$hi;
     i64toi32_i32$1 = $82$hi;
     i64toi32_i32$0 = $33;
     i64toi32_i32$2 = $16$hi;
     i64toi32_i32$3 = $16;
     i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
     $84 = i64toi32_i32$0 | $16 | 0;
     i64toi32_i32$0 = $79;
     HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = $84;
     HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = i64toi32_i32$2;
     $7 = $6 + -8 | 0;
     $8 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $4 = $8 + 4 | 0;
     $9 = ((HEAP32[$1 >> 2] | 0) + $8 | 0) + 1 | 0;
     $10 = ((HEAP32[$8 >> 2] | 0) ^ -1 | 0) & -2139062144 | 0;
     i64toi32_i32$2 = $16$hi;
     $11 = $16;
     label$9 : while (1) {
      label$10 : {
       if ($10) {
        break label$10
       }
       label$11 : while (1) {
        if ($4 >>> 0 >= $9 >>> 0) {
         break label$2
        }
        $8 = $8 + -32 | 0;
        $2 = HEAP32[$4 >> 2] | 0;
        $12 = $4 + 4 | 0;
        $4 = $12;
        $2 = $2 & -2139062144 | 0;
        if (($2 | 0) == (-2139062144 | 0)) {
         continue label$11
        }
        break label$11;
       };
       $10 = $2 ^ -2139062144 | 0;
       $4 = $12;
      }
      label$12 : {
       i64toi32_i32$2 = $16$hi;
       $13 = ($8 - ((__wasm_ctz_i32($10 | 0) | 0) & 56 | 0) | 0) + -8 | 0;
       i64toi32_i32$2 = hashbrown__map__make_hash__h18de0e6f479ebafc($3 | 0, $13 | 0) | 0;
       i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
       $17 = i64toi32_i32$2;
       $17$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $16$hi;
       i64toi32_i32$1 = $16;
       i64toi32_i32$2 = $17$hi;
       i64toi32_i32$3 = $17;
       i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
       $12 = i64toi32_i32$1 & $17 | 0;
       $31 = $6 + $12 | 0;
       $14 = (HEAPU8[$31 >> 0] | 0 | ((HEAPU8[($31 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($31 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($31 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
       if ($14) {
        break label$12
       }
       $2 = 4;
       label$13 : while (1) {
        $12 = $12 + $2 | 0;
        $2 = $2 + 4 | 0;
        $12 = $12 & $11 | 0;
        $32 = $6 + $12 | 0;
        $14 = (HEAPU8[$32 >> 0] | 0 | ((HEAPU8[($32 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($32 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($32 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
        if (!$14) {
         continue label$13
        }
        break label$13;
       };
      }
      $15 = $10 + -1 | 0;
      label$14 : {
       $2 = (((__wasm_ctz_i32($14 | 0) | 0) >>> 3 | 0) + $12 | 0) & $11 | 0;
       if ((HEAP8[($6 + $2 | 0) >> 0] | 0 | 0) <= (-1 | 0)) {
        break label$14
       }
       $2 = (__wasm_ctz_i32((HEAP32[$6 >> 2] | 0) & -2139062144 | 0 | 0) | 0) >>> 3 | 0;
      }
      $10 = $15 & $10 | 0;
      i64toi32_i32$2 = $17$hi;
      $12 = $17 >>> 25 | 0;
      HEAP8[($6 + $2 | 0) >> 0] = $12;
      HEAP8[(((($2 + -4 | 0) & $11 | 0) + $6 | 0) + 4 | 0) >> 0] = $12;
      i64toi32_i32$0 = $13;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
      $196 = i64toi32_i32$2;
      i64toi32_i32$2 = $7 - ($2 << 3 | 0) | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $196;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      continue label$9;
     };
    }
    HEAP32[($0 + 4 | 0) >> 2] = $2;
    HEAP32[$0 >> 2] = 1;
    HEAP32[($0 + 8 | 0) >> 2] = $6;
    break label$1;
   }
   i64toi32_i32$0 = $1;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $17 = i64toi32_i32$1;
   $17$hi = i64toi32_i32$2;
   i64toi32_i32$0 = $5;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] | 0;
   $207 = i64toi32_i32$2;
   i64toi32_i32$2 = $1;
   HEAP32[i64toi32_i32$2 >> 2] = $207;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   $2 = i64toi32_i32$0 + 32 | 0;
   i64toi32_i32$0 = $2;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $16 = i64toi32_i32$1;
   $16$hi = i64toi32_i32$2;
   $4 = $1 + 8 | 0;
   i64toi32_i32$0 = $4;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $216 = i64toi32_i32$2;
   i64toi32_i32$2 = $2;
   HEAP32[i64toi32_i32$2 >> 2] = $216;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $16$hi;
   i64toi32_i32$2 = i64toi32_i32$0;
   HEAP32[i64toi32_i32$2 >> 2] = $16;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $17$hi;
   i64toi32_i32$2 = $5;
   HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] = $17;
   HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[$0 >> 2] = 0;
   core__ptr__drop_in_place_hashbrown__scopeguard__ScopeGuard_hashbrown__raw__RawTableInner_alloc__alloc__Global__2chashbrown__raw__RawTableInner_alloc__alloc__Global___prepare_resize___7b_7bclosure_7d_7d____hf09be25679474fda(i64toi32_i32$2 + 16 | 0 | 0);
  }
  global$0 = $5 + 80 | 0;
 }
 
 function $cardano_serialization_lib__utils__Int_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h5b6b41ff800f0b26($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, $2 = 0, $5 = 0, $5$hi = 0, $6 = 0, $6$hi = 0, $7 = 0, $7$hi = 0, $4 = 0, $3 = 0, $53 = 0, $54 = 0, $55 = 0, $56 = 0, $57 = 0, $58 = 0, $59 = 0, $60 = 0, $61 = 0, $62 = 0, $63 = 0, $64 = 0, $65 = 0, $66 = 0, $68 = 0, $33 = 0, $33$hi = 0, $35$hi = 0, $46 = 0, $52 = 0, $67 = 0, $70 = 0, $72 = 0, $72$hi = 0, $74$hi = 0, $100 = 0, $102 = 0, $102$hi = 0, $104$hi = 0, $105 = 0, $106 = 0, $108$hi = 0, $111 = 0, $111$hi = 0, $112 = 0, $117 = 0, $123 = 0, $131 = 0, $147 = 0, $151 = 0, $157 = 0, $163 = 0, $177 = 0, $179 = 0, $179$hi = 0, $181$hi = 0, $182 = 0, $183 = 0, $185$hi = 0, $188 = 0, $188$hi = 0, $189 = 0;
  $2 = global$0 - 144 | 0;
  global$0 = $2;
  std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 | 0, $1 | 0);
  $3 = 0;
  $4 = 2;
  label$1 : {
   label$2 : {
    label$3 : {
     if (HEAP32[($2 + 4 | 0) >> 2] | 0) {
      break label$3
     }
     i64toi32_i32$0 = 0;
     $5 = 0;
     $5$hi = i64toi32_i32$0;
     i64toi32_i32$0 = 134217728;
     $6 = 0;
     $6$hi = i64toi32_i32$0;
     $1 = 0;
     break label$2;
    }
    label$4 : {
     label$5 : {
      label$6 : {
       label$7 : {
        switch (($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[$2 >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0 | 0) {
        case 1:
         cardano_serialization_lib__utils__read_nint__h6af092dfd2bc47da($2 + 72 | 0 | 0, $1 | 0);
         i64toi32_i32$2 = ($2 + 72 | 0) + 16 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $5 = i64toi32_i32$0;
         $5$hi = i64toi32_i32$1;
         i64toi32_i32$2 = $2;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 80 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 84 | 0) >> 2] | 0;
         $7 = i64toi32_i32$1;
         $7$hi = i64toi32_i32$0;
         label$9 : {
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 72 | 0) >> 2] | 0;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 76 | 0) >> 2] | 0;
          i64toi32_i32$2 = i64toi32_i32$0;
          i64toi32_i32$0 = 0;
          i64toi32_i32$3 = 1;
          if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
           break label$9
          }
          i64toi32_i32$2 = $7$hi;
          i64toi32_i32$3 = $7;
          i64toi32_i32$1 = 0;
          i64toi32_i32$0 = 8;
          i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
          if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
           i64toi32_i32$1 = 0;
           $53 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
          } else {
           i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
           $53 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$4 | 0) | 0;
          }
          $33 = $53;
          $33$hi = i64toi32_i32$1;
          i64toi32_i32$1 = $5$hi;
          i64toi32_i32$2 = $5;
          i64toi32_i32$3 = 0;
          i64toi32_i32$0 = 56;
          i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
          if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
           i64toi32_i32$3 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
           $54 = 0;
          } else {
           i64toi32_i32$3 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
           $54 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
          }
          $35$hi = i64toi32_i32$3;
          i64toi32_i32$3 = $33$hi;
          i64toi32_i32$1 = $33;
          i64toi32_i32$2 = $35$hi;
          i64toi32_i32$0 = $54;
          i64toi32_i32$2 = i64toi32_i32$3 | i64toi32_i32$2 | 0;
          $6 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
          $6$hi = i64toi32_i32$2;
          i64toi32_i32$2 = $5$hi;
          i64toi32_i32$3 = $5;
          i64toi32_i32$1 = 0;
          i64toi32_i32$0 = 8;
          i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
          if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
           i64toi32_i32$1 = 0;
           $55 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
          } else {
           i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
           $55 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$4 | 0) | 0;
          }
          $5 = $55;
          $5$hi = i64toi32_i32$1;
          i64toi32_i32$1 = $7$hi;
          $1 = $7;
          break label$6;
         }
         i64toi32_i32$2 = $2 + 108 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $46 = i64toi32_i32$1;
         i64toi32_i32$1 = ($2 + 8 | 0) + 8 | 0;
         HEAP32[i64toi32_i32$1 >> 2] = $46;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
         i64toi32_i32$2 = $2 + 116 | 0;
         i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $52 = i64toi32_i32$3;
         i64toi32_i32$3 = ($2 + 8 | 0) + 16 | 0;
         HEAP32[i64toi32_i32$3 >> 2] = $52;
         HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
         HEAP32[(($2 + 8 | 0) + 24 | 0) >> 2] = HEAP32[($2 + 124 | 0) >> 2] | 0;
         HEAP32[(($2 + 40 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 140 | 0) >> 2] | 0;
         i64toi32_i32$2 = $2;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 100 | 0) >> 2] | 0;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 104 | 0) >> 2] | 0;
         $67 = i64toi32_i32$1;
         i64toi32_i32$1 = i64toi32_i32$2;
         HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $67;
         HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$3;
         i64toi32_i32$2 = i64toi32_i32$1;
         i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$1 + 136 | 0) >> 2] | 0;
         $70 = i64toi32_i32$3;
         i64toi32_i32$3 = i64toi32_i32$2;
         HEAP32[(i64toi32_i32$3 + 40 | 0) >> 2] = $70;
         HEAP32[(i64toi32_i32$3 + 44 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$1 = $7$hi;
         i64toi32_i32$2 = $7;
         i64toi32_i32$3 = 0;
         i64toi32_i32$0 = 8;
         i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
          i64toi32_i32$3 = 0;
          $56 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
         } else {
          i64toi32_i32$3 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
          $56 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
         }
         $72 = $56;
         $72$hi = i64toi32_i32$3;
         i64toi32_i32$3 = $5$hi;
         i64toi32_i32$1 = $5;
         i64toi32_i32$2 = 0;
         i64toi32_i32$0 = 56;
         i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
          i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
          $57 = 0;
         } else {
          i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$4 | 0) | 0;
          $57 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
         }
         $74$hi = i64toi32_i32$2;
         i64toi32_i32$2 = $72$hi;
         i64toi32_i32$3 = $72;
         i64toi32_i32$1 = $74$hi;
         i64toi32_i32$0 = $57;
         i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
         $6 = i64toi32_i32$3 | i64toi32_i32$0 | 0;
         $6$hi = i64toi32_i32$1;
         i64toi32_i32$1 = $5$hi;
         i64toi32_i32$2 = $5;
         i64toi32_i32$3 = 0;
         i64toi32_i32$0 = 8;
         i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
          i64toi32_i32$3 = 0;
          $58 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
         } else {
          i64toi32_i32$3 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
          $58 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
         }
         $5 = $58;
         $5$hi = i64toi32_i32$3;
         $1 = HEAP32[(($2 + 72 | 0) + 24 | 0) >> 2] | 0;
         $3 = HEAP32[($2 + 128 | 0) >> 2] | 0;
         i64toi32_i32$3 = $7$hi;
         $4 = $7;
         break label$2;
        case 0:
         break label$7;
        default:
         break label$5;
        };
       }
       cbor_event__de__Deserializer_R___unsigned_integer__h1ed99c0b7fe7eea1($2 + 72 | 0 | 0, $1 | 0);
       i64toi32_i32$1 = $2;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 80 | 0) >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 84 | 0) >> 2] | 0;
       $7 = i64toi32_i32$3;
       $7$hi = i64toi32_i32$2;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 72 | 0) >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 76 | 0) >> 2] | 0;
       i64toi32_i32$1 = i64toi32_i32$2;
       i64toi32_i32$2 = 0;
       i64toi32_i32$0 = 1;
       if ((i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) | 0) {
        break label$4
       }
       i64toi32_i32$1 = $7$hi;
       i64toi32_i32$0 = $7;
       i64toi32_i32$3 = 0;
       i64toi32_i32$2 = 8;
       i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
        i64toi32_i32$3 = 0;
        $59 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$3 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
        $59 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
       }
       $6 = $59;
       $6$hi = i64toi32_i32$3;
       i64toi32_i32$3 = $7$hi;
       $1 = $7;
       i64toi32_i32$3 = 0;
       $5 = 0;
       $5$hi = i64toi32_i32$3;
      }
      $100 = $0 + 16 | 0;
      i64toi32_i32$3 = $5$hi;
      i64toi32_i32$1 = $5;
      i64toi32_i32$0 = 0;
      i64toi32_i32$2 = 8;
      i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
       i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       $60 = 0;
      } else {
       i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$4 | 0) | 0;
       $60 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
      }
      $102 = $60;
      $102$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $6$hi;
      i64toi32_i32$3 = $6;
      i64toi32_i32$1 = 0;
      i64toi32_i32$2 = 56;
      i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
       i64toi32_i32$1 = 0;
       $61 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
      } else {
       i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       $61 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$4 | 0) | 0;
      }
      $104$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $102$hi;
      i64toi32_i32$0 = $102;
      i64toi32_i32$3 = $104$hi;
      i64toi32_i32$2 = $61;
      i64toi32_i32$3 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
      $105 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
      i64toi32_i32$0 = $100;
      HEAP32[i64toi32_i32$0 >> 2] = $105;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
      $106 = $0;
      i64toi32_i32$3 = $6$hi;
      i64toi32_i32$1 = $6;
      i64toi32_i32$0 = 0;
      i64toi32_i32$2 = 8;
      i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
       i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       $62 = 0;
      } else {
       i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$4 | 0) | 0;
       $62 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
      }
      $108$hi = i64toi32_i32$0;
      i64toi32_i32$0 = 0;
      i64toi32_i32$3 = $1;
      i64toi32_i32$1 = 0;
      i64toi32_i32$2 = 255;
      i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
      $111 = i64toi32_i32$3 & i64toi32_i32$2 | 0;
      $111$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $108$hi;
      i64toi32_i32$0 = $62;
      i64toi32_i32$3 = $111$hi;
      i64toi32_i32$2 = $111;
      i64toi32_i32$3 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
      $112 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
      i64toi32_i32$0 = $106;
      HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $112;
      HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$3;
      i64toi32_i32$3 = 0;
      $6 = 0;
      $6$hi = i64toi32_i32$3;
      break label$1;
     }
     i64toi32_i32$3 = 0;
     $6 = 0;
     $6$hi = i64toi32_i32$3;
     $4 = 11;
     i64toi32_i32$3 = 0;
     $5 = 0;
     $5$hi = i64toi32_i32$3;
     break label$2;
    }
    i64toi32_i32$1 = $2 + 100 | 0;
    i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
    $117 = i64toi32_i32$3;
    i64toi32_i32$3 = $2 + 16 | 0;
    HEAP32[i64toi32_i32$3 >> 2] = $117;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$1 = $2 + 108 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
    $123 = i64toi32_i32$0;
    i64toi32_i32$0 = ($2 + 8 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $123;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
    HEAP32[($2 + 32 | 0) >> 2] = HEAP32[($2 + 116 | 0) >> 2] | 0;
    i64toi32_i32$1 = $2;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 92 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 96 | 0) >> 2] | 0;
    $131 = i64toi32_i32$3;
    i64toi32_i32$3 = i64toi32_i32$1;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $131;
    HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = $7$hi;
    i64toi32_i32$1 = $7;
    i64toi32_i32$3 = 0;
    i64toi32_i32$2 = 8;
    i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
     i64toi32_i32$3 = 0;
     $63 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
    } else {
     i64toi32_i32$3 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
     $63 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
    }
    $5 = $63;
    $5$hi = i64toi32_i32$3;
    i64toi32_i32$3 = $7$hi;
    i64toi32_i32$0 = $7;
    i64toi32_i32$1 = 0;
    i64toi32_i32$2 = 56;
    i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
     i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
     $64 = 0;
    } else {
     i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$4 | 0) | 0;
     $64 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
    }
    $6 = $64;
    $6$hi = i64toi32_i32$1;
    $1 = HEAP32[(($2 + 72 | 0) + 16 | 0) >> 2] | 0;
   }
   HEAP32[(($2 + 72 | 0) + 16 | 0) >> 2] = $1;
   i64toi32_i32$3 = $2;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 12 | 0) >> 2] | 0;
   $147 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$3 + 92 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $147;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 40 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 44 | 0) >> 2] | 0;
   $151 = i64toi32_i32$0;
   i64toi32_i32$0 = i64toi32_i32$3 + 124 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $151;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$3 = (i64toi32_i32$3 + 8 | 0) + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $157 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 100 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $157;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$3 = ($2 + 8 | 0) + 16 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $163 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 108 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $163;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($2 + 116 | 0) >> 2] = HEAP32[($2 + 32 | 0) >> 2] | 0;
   HEAP32[($2 + 132 | 0) >> 2] = HEAP32[(($2 + 40 | 0) + 8 | 0) >> 2] | 0;
   HEAP32[($2 + 120 | 0) >> 2] = $3;
   $177 = $2;
   i64toi32_i32$1 = $5$hi;
   i64toi32_i32$3 = $5;
   i64toi32_i32$0 = 0;
   i64toi32_i32$2 = 8;
   i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
    i64toi32_i32$0 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
    $65 = 0;
   } else {
    i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
    $65 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
   }
   $179 = $65;
   $179$hi = i64toi32_i32$0;
   i64toi32_i32$0 = $6$hi;
   i64toi32_i32$1 = $6;
   i64toi32_i32$3 = 0;
   i64toi32_i32$2 = 56;
   i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
    i64toi32_i32$3 = 0;
    $66 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   } else {
    i64toi32_i32$3 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
    $66 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
   }
   $181$hi = i64toi32_i32$3;
   i64toi32_i32$3 = $179$hi;
   i64toi32_i32$0 = $179;
   i64toi32_i32$1 = $181$hi;
   i64toi32_i32$2 = $66;
   i64toi32_i32$1 = i64toi32_i32$3 | i64toi32_i32$1 | 0;
   $182 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
   i64toi32_i32$0 = $177;
   HEAP32[(i64toi32_i32$0 + 80 | 0) >> 2] = $182;
   HEAP32[(i64toi32_i32$0 + 84 | 0) >> 2] = i64toi32_i32$1;
   $183 = $2;
   i64toi32_i32$1 = $6$hi;
   i64toi32_i32$3 = $6;
   i64toi32_i32$0 = 0;
   i64toi32_i32$2 = 8;
   i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
    i64toi32_i32$0 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
    $68 = 0;
   } else {
    i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
    $68 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
   }
   $185$hi = i64toi32_i32$0;
   i64toi32_i32$0 = 0;
   i64toi32_i32$1 = $4;
   i64toi32_i32$3 = 0;
   i64toi32_i32$2 = 255;
   i64toi32_i32$3 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
   $188 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
   $188$hi = i64toi32_i32$3;
   i64toi32_i32$3 = $185$hi;
   i64toi32_i32$0 = $68;
   i64toi32_i32$1 = $188$hi;
   i64toi32_i32$2 = $188;
   i64toi32_i32$1 = i64toi32_i32$3 | i64toi32_i32$1 | 0;
   $189 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
   i64toi32_i32$0 = $183;
   HEAP32[(i64toi32_i32$0 + 72 | 0) >> 2] = $189;
   HEAP32[(i64toi32_i32$0 + 76 | 0) >> 2] = i64toi32_i32$1;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 72 | 0 | 0, 1057809 | 0, 3 | 0);
   i64toi32_i32$1 = 0;
   $6 = 1;
   $6$hi = i64toi32_i32$1;
  }
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $6;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $2 + 144 | 0;
 }
 
 function alloc__collections__btree__node__BalancingContext_K_2cV___bulk_steal_right__hfc3fbd9528abaf5f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $6 = 0, i64toi32_i32$1 = 0, $7 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $9 = 0, $3 = 0, $11 = 0, $4 = 0, $8 = 0, $13 = 0, $2 = 0, $5 = 0, $18 = 0, $10 = 0, $12 = 0, $14 = 0, $15 = 0, $17 = 0, $17$hi = 0, $18$hi = 0, $16 = 0, $81 = 0, $19 = 0, $19$hi = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if (!$1) {
       break label$4
      }
      $3 = HEAP32[($0 + 16 | 0) >> 2] | 0;
      $4 = HEAPU16[($3 + 226 | 0) >> 1] | 0;
      $5 = $4 + $1 | 0;
      if ($5 >>> 0 > 11 >>> 0) {
       break label$3
      }
      label$5 : {
       label$6 : {
        label$7 : {
         $6 = HEAP32[($0 + 24 | 0) >> 2] | 0;
         $7 = HEAPU16[($6 + 226 | 0) >> 1] | 0;
         if ($7 >>> 0 < $1 >>> 0) {
          break label$7
         }
         HEAP16[($3 + 226 | 0) >> 1] = $5;
         $8 = $7 - $1 | 0;
         HEAP16[($6 + 226 | 0) >> 1] = $8;
         $9 = $1 + -1 | 0;
         $10 = $9 << 3 | 0;
         i64toi32_i32$2 = $6 + $10 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $17 = i64toi32_i32$0;
         $17$hi = i64toi32_i32$1;
         $11 = HEAP32[($0 + 4 | 0) >> 2] | 0;
         $12 = HEAP32[($0 + 8 | 0) >> 2] | 0;
         $7 = $11 + Math_imul($12, 12) | 0;
         $13 = $7 + 92 | 0;
         i64toi32_i32$2 = $13;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $18 = i64toi32_i32$1;
         $18$hi = i64toi32_i32$0;
         $14 = Math_imul($9, 12);
         $15 = $6 + $14 | 0;
         $16 = HEAP32[($15 + 100 | 0) >> 2] | 0;
         i64toi32_i32$2 = $15 + 92 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $81 = i64toi32_i32$0;
         i64toi32_i32$0 = $13;
         HEAP32[i64toi32_i32$0 >> 2] = $81;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         $13 = $7 + 100 | 0;
         $7 = HEAP32[$13 >> 2] | 0;
         HEAP32[$13 >> 2] = $16;
         HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] = $7;
         $11 = $11 + ($12 << 3 | 0) | 0;
         i64toi32_i32$2 = $11;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $19 = i64toi32_i32$1;
         $19$hi = i64toi32_i32$0;
         i64toi32_i32$0 = $17$hi;
         i64toi32_i32$1 = i64toi32_i32$2;
         HEAP32[i64toi32_i32$1 >> 2] = $17;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$0 = $18$hi;
         i64toi32_i32$1 = $2;
         HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $18;
         HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
         HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $7;
         HEAP32[i64toi32_i32$1 >> 2] = $18;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
         $11 = $3 + Math_imul($4, 12) | 0;
         HEAP32[($11 + 100 | 0) >> 2] = $7;
         i64toi32_i32$1 = $11 + 92 | 0;
         HEAP32[i64toi32_i32$1 >> 2] = $18;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$0 = $19$hi;
         i64toi32_i32$1 = $3 + ($4 << 3 | 0) | 0;
         HEAP32[i64toi32_i32$1 >> 2] = $19;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
         $7 = $4 + 1 | 0;
         if (($9 | 0) != ($5 - $7 | 0 | 0)) {
          break label$2
         }
         $9 = $6 + 92 | 0;
         memcpy(($3 + Math_imul($7, 12) | 0) + 92 | 0 | 0, $9 | 0, $14 | 0) | 0;
         memcpy($3 + ($7 << 3 | 0) | 0 | 0, $6 | 0, $10 | 0) | 0;
         memmove($9 | 0, $9 + Math_imul($1, 12) | 0 | 0, Math_imul($8, 12) | 0) | 0;
         $9 = memmove($6 | 0, $6 + ($1 << 3 | 0) | 0 | 0, $8 << 3 | 0 | 0) | 0;
         $6 = HEAP32[($0 + 12 | 0) >> 2] | 0;
         if (HEAP32[($0 + 20 | 0) >> 2] | 0) {
          break label$6
         }
         if (!$6) {
          break label$5
         }
         break label$1;
        }
        core__panicking__panic__h2fd385a887c8bf13(1049456 | 0, 40 | 0, 1049496 | 0);
        abort();
       }
       if (!$6) {
        break label$1
       }
       $6 = $9 + 232 | 0;
       $0 = $1 << 2 | 0;
       memcpy(($3 + ($7 << 2 | 0) | 0) + 232 | 0 | 0, $6 | 0, $0 | 0) | 0;
       memmove($6 | 0, $6 + $0 | 0 | 0, ($8 << 2 | 0) + 4 | 0 | 0) | 0;
       label$8 : {
        if ($5 >>> 0 <= $4 >>> 0) {
         break label$8
        }
        $6 = (($4 << 2 | 0) + $3 | 0) + 236 | 0;
        label$9 : while (1) {
         $0 = HEAP32[$6 >> 2] | 0;
         HEAP16[($0 + 224 | 0) >> 1] = $7;
         HEAP32[($0 + 88 | 0) >> 2] = $3;
         $6 = $6 + 4 | 0;
         $7 = $7 + 1 | 0;
         $1 = $1 + -1 | 0;
         if ($1) {
          continue label$9
         }
         break label$9;
        };
       }
       if (($8 | 0) == (-1 | 0)) {
        break label$5
       }
       $7 = $9 + 232 | 0;
       $0 = $8 + 1 | 0;
       $6 = 0;
       label$10 : while (1) {
        $1 = HEAP32[$7 >> 2] | 0;
        HEAP16[($1 + 224 | 0) >> 1] = $6;
        HEAP32[($1 + 88 | 0) >> 2] = $9;
        $7 = $7 + 4 | 0;
        $6 = $6 + 1 | 0;
        if (($0 | 0) != ($6 | 0)) {
         continue label$10
        }
        break label$10;
       };
      }
      global$0 = $2 + 32 | 0;
      return;
     }
     core__panicking__panic__h2fd385a887c8bf13(1049148 | 0, 27 | 0, 1049372 | 0);
     abort();
    }
    core__panicking__panic__h2fd385a887c8bf13(1049388 | 0, 50 | 0, 1049440 | 0);
    abort();
   }
   core__panicking__panic__h2fd385a887c8bf13(1048988 | 0, 40 | 0, 1049028 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1049316 | 0, 40 | 0, 1049512 | 0);
  abort();
 }
 
 function core__ops__function__impls___impl_20core__ops__function__FnOnce_A__20for_20_mut_20F___call_once__h04c7e95d494f6df8($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, $4 = 0, i64toi32_i32$0 = 0, $35 = 0, $36 = 0, $37 = 0, $38 = 0, $39 = 0, $40 = 0, $41 = 0, $42 = 0, $43 = 0, $44 = 0, $45 = 0, $46 = 0, $8 = 0, $8$hi = 0, $9 = 0, $9$hi = 0, $5 = 0, $6 = 0, $7 = 0, $24 = 0, $30 = 0, $33 = 0, $55 = 0, $61 = 0, $65 = 0, $99 = 0, $105 = 0, $109 = 0, $114 = 0, $122 = 0, $129 = 0, $136 = 0, $139 = 0, $159 = 0, $166 = 0, $184 = 0, $194 = 0, $198 = 0;
  $4 = global$0 - 320 | 0;
  global$0 = $4;
  $5 = $4 + 24 | 0;
  $35 = $2 + 24 | 0;
  HEAP32[$5 >> 2] = HEAPU8[$35 >> 0] | 0 | ((HEAPU8[($35 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($35 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($35 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $6 = $4 + 16 | 0;
  i64toi32_i32$2 = $2 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $6;
  HEAP32[i64toi32_i32$0 >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $7 = $4 + 8 | 0;
  i64toi32_i32$2 = $2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $30 = i64toi32_i32$1;
  i64toi32_i32$1 = $7;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $33 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[$4 >> 2] = $33;
  HEAP32[($4 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  $8 = 2;
  $8$hi = i64toi32_i32$1;
  label$1 : {
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $9 = i64toi32_i32$1;
   $9$hi = i64toi32_i32$0;
   i64toi32_i32$2 = i64toi32_i32$1;
   i64toi32_i32$1 = 0;
   i64toi32_i32$3 = 2;
   if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
    break label$1
   }
   $2 = $3 + 8 | 0;
   i64toi32_i32$2 = 0;
   $8 = 1;
   $8$hi = i64toi32_i32$2;
   label$2 : {
    label$3 : {
     i64toi32_i32$2 = $9$hi;
     i64toi32_i32$3 = $9;
     i64toi32_i32$0 = 0;
     i64toi32_i32$1 = 1;
     if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) | 0) {
      break label$3
     }
     label$4 : {
      label$5 : {
       switch (HEAPU8[$2 >> 0] | 0 | 0) {
       default:
        $36 = $2 + 25 | 0;
        $37 = ($4 + 176 | 0) + 25 | 0;
        $38 = HEAPU8[$36 >> 0] | 0 | ((HEAPU8[($36 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($36 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($36 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[$37 >> 0] = $38;
        HEAP8[($37 + 1 | 0) >> 0] = $38 >>> 8 | 0;
        HEAP8[($37 + 2 | 0) >> 0] = $38 >>> 16 | 0;
        HEAP8[($37 + 3 | 0) >> 0] = $38 >>> 24 | 0;
        i64toi32_i32$1 = $2 + 17 | 0;
        i64toi32_i32$3 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $55 = i64toi32_i32$3;
        i64toi32_i32$3 = ($4 + 176 | 0) + 17 | 0;
        $39 = $55;
        HEAP8[i64toi32_i32$3 >> 0] = $39;
        HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $39 >>> 8 | 0;
        HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $39 >>> 16 | 0;
        HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $39 >>> 24 | 0;
        HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$2;
        HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
        HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
        HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
        i64toi32_i32$1 = $2 + 9 | 0;
        i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$3 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $61 = i64toi32_i32$2;
        i64toi32_i32$2 = ($4 + 176 | 0) + 9 | 0;
        $40 = $61;
        HEAP8[i64toi32_i32$2 >> 0] = $40;
        HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $40 >>> 8 | 0;
        HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $40 >>> 16 | 0;
        HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $40 >>> 24 | 0;
        HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$3;
        HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
        HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
        HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
        HEAP8[($4 + 176 | 0) >> 0] = 0;
        i64toi32_i32$1 = $2;
        i64toi32_i32$3 = HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 8 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $65 = i64toi32_i32$3;
        i64toi32_i32$3 = $4;
        $41 = $65;
        HEAP8[(i64toi32_i32$3 + 177 | 0) >> 0] = $41;
        HEAP8[(i64toi32_i32$3 + 178 | 0) >> 0] = $41 >>> 8 | 0;
        HEAP8[(i64toi32_i32$3 + 179 | 0) >> 0] = $41 >>> 16 | 0;
        HEAP8[(i64toi32_i32$3 + 180 | 0) >> 0] = $41 >>> 24 | 0;
        HEAP8[(i64toi32_i32$3 + 181 | 0) >> 0] = i64toi32_i32$2;
        HEAP8[(i64toi32_i32$3 + 182 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
        HEAP8[(i64toi32_i32$3 + 183 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
        HEAP8[(i64toi32_i32$3 + 184 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
        break label$4;
       case 1:
        alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($4 + 176 | 0 | 4 | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
        HEAP8[($4 + 176 | 0) >> 0] = 1;
        break label$4;
       case 2:
        alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($4 + 176 | 0 | 4 | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
        HEAP8[($4 + 176 | 0) >> 0] = 2;
        break label$4;
       case 3:
        $2 = HEAP32[($3 + 12 | 0) >> 2] | 0;
        alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($4 + 32 | 0 | 4 | 0 | 0, HEAP32[($3 + 16 | 0) >> 2] | 0 | 0, HEAP32[($3 + 24 | 0) >> 2] | 0 | 0);
        i64toi32_i32$1 = $4 + 40 | 0;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
        $99 = i64toi32_i32$2;
        i64toi32_i32$2 = $4 + 188 | 0;
        HEAP32[i64toi32_i32$2 >> 2] = $99;
        HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
        HEAP32[($4 + 32 | 0) >> 2] = $2;
        HEAP8[($4 + 176 | 0) >> 0] = 3;
        i64toi32_i32$1 = $4;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 32 | 0) >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] | 0;
        $105 = i64toi32_i32$3;
        i64toi32_i32$3 = i64toi32_i32$1;
        HEAP32[(i64toi32_i32$1 + 180 | 0) >> 2] = $105;
        HEAP32[(i64toi32_i32$1 + 184 | 0) >> 2] = i64toi32_i32$2;
        break label$4;
       case 4:
        i64toi32_i32$1 = $3;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] | 0;
        $109 = i64toi32_i32$2;
        i64toi32_i32$2 = $4 + 184 | 0;
        HEAP32[i64toi32_i32$2 >> 2] = $109;
        HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
        HEAP8[($4 + 176 | 0) >> 0] = 4;
        break label$4;
       case 5:
        break label$5;
       };
      }
      i64toi32_i32$1 = $3;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] | 0;
      $114 = i64toi32_i32$3;
      i64toi32_i32$3 = $4 + 184 | 0;
      HEAP32[i64toi32_i32$3 >> 2] = $114;
      HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
      HEAP8[($4 + 176 | 0) >> 0] = 5;
     }
     i64toi32_i32$1 = ($4 + 176 | 0) + 24 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $122 = i64toi32_i32$2;
     i64toi32_i32$2 = ($4 + 32 | 0) + 24 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $122;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$1 = ($4 + 176 | 0) + 16 | 0;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $129 = i64toi32_i32$3;
     i64toi32_i32$3 = ($4 + 32 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $129;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$1 = ($4 + 176 | 0) + 8 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $136 = i64toi32_i32$2;
     i64toi32_i32$2 = ($4 + 32 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $136;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$1 = $4;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 176 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 180 | 0) >> 2] | 0;
     $139 = i64toi32_i32$3;
     i64toi32_i32$3 = i64toi32_i32$1;
     HEAP32[(i64toi32_i32$1 + 32 | 0) >> 2] = $139;
     HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$2 = 0;
     $8 = 0;
     $8$hi = i64toi32_i32$2;
     break label$2;
    }
    $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($4 + 304 | 0 | 0, $3 + 136 | 0 | 0);
    $cardano_serialization_lib__plutus__PlutusData_20as_20core__clone__Clone___clone__h63d1a98cc18f4609($4 + 176 | 0 | 0, $2 | 0);
    i64toi32_i32$1 = $3;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 56 | 0) >> 2] | 0;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 60 | 0) >> 2] | 0;
    $9 = i64toi32_i32$2;
    $9$hi = i64toi32_i32$3;
    $2 = HEAPU8[(i64toi32_i32$1 + 128 | 0) >> 0] | 0;
    $cardano_serialization_lib__plutus__PlutusData_20as_20core__clone__Clone___clone__h63d1a98cc18f4609($4 + 40 | 0 | 0, i64toi32_i32$1 + 64 | 0 | 0);
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 120 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 124 | 0) >> 2] | 0;
    $159 = i64toi32_i32$3;
    i64toi32_i32$3 = ($4 + 32 | 0) + 64 | 0;
    HEAP32[i64toi32_i32$3 >> 2] = $159;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
    HEAP8[($4 + 104 | 0) >> 0] = $2;
    i64toi32_i32$2 = $9$hi;
    i64toi32_i32$3 = $4;
    HEAP32[(i64toi32_i32$3 + 32 | 0) >> 2] = $9;
    HEAP32[(i64toi32_i32$3 + 36 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 112 | 0) >> 2] | 0;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 116 | 0) >> 2] | 0;
    $166 = i64toi32_i32$2;
    i64toi32_i32$2 = $4;
    HEAP32[(i64toi32_i32$2 + 88 | 0) >> 2] = $166;
    HEAP32[(i64toi32_i32$2 + 92 | 0) >> 2] = i64toi32_i32$3;
    memcpy(i64toi32_i32$2 + 224 | 0 | 0, i64toi32_i32$2 + 32 | 0 | 0, 80 | 0) | 0;
    memcpy(i64toi32_i32$2 + 32 | 0 | 0, i64toi32_i32$2 + 176 | 0 | 0, 144 | 0) | 0;
   }
   memcpy($4 + 176 | 0 | 0, $4 + 32 | 0 | 0, 144 | 0) | 0;
  }
  i64toi32_i32$1 = $4;
  i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $184 = i64toi32_i32$3;
  i64toi32_i32$3 = $0;
  $42 = $184;
  HEAP8[i64toi32_i32$3 >> 0] = $42;
  HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $42 >>> 8 | 0;
  HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $42 >>> 16 | 0;
  HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $42 >>> 24 | 0;
  HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$2;
  HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
  HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
  HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
  i64toi32_i32$2 = $8$hi;
  HEAP32[(i64toi32_i32$3 + 32 | 0) >> 2] = $8;
  HEAP32[(i64toi32_i32$3 + 36 | 0) >> 2] = i64toi32_i32$2;
  $43 = i64toi32_i32$3 + 24 | 0;
  $44 = HEAP32[$5 >> 2] | 0;
  HEAP8[$43 >> 0] = $44;
  HEAP8[($43 + 1 | 0) >> 0] = $44 >>> 8 | 0;
  HEAP8[($43 + 2 | 0) >> 0] = $44 >>> 16 | 0;
  HEAP8[($43 + 3 | 0) >> 0] = $44 >>> 24 | 0;
  i64toi32_i32$1 = $6;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $194 = i64toi32_i32$2;
  i64toi32_i32$2 = $0 + 16 | 0;
  $45 = $194;
  HEAP8[i64toi32_i32$2 >> 0] = $45;
  HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $45 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $45 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $45 >>> 24 | 0;
  HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$3;
  HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
  i64toi32_i32$1 = $7;
  i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $198 = i64toi32_i32$3;
  i64toi32_i32$3 = $0 + 8 | 0;
  $46 = $198;
  HEAP8[i64toi32_i32$3 >> 0] = $46;
  HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $46 >>> 8 | 0;
  HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $46 >>> 16 | 0;
  HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $46 >>> 24 | 0;
  HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$2;
  HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
  HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
  HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
  memcpy($0 + 40 | 0 | 0, $4 + 176 | 0 | 0, 144 | 0) | 0;
  global$0 = $4 + 320 | 0;
 }
 
 function $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__clone_subtree__h2916732d8c8f5a11($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $9 = 0, $7 = 0, $4 = 0, $5 = 0, $6 = 0, $13 = 0, $27 = 0, $28 = 0, $29 = 0, $30 = 0, $31 = 0, $32 = 0, $33 = 0, $8 = 0, $10 = 0, $11 = 0, $82 = 0, $89 = 0, $92 = 0, $12 = 0, $113 = 0, $118 = 0, $121 = 0, $150 = 0, $172 = 0, $177 = 0, $181 = 0;
  $3 = global$0 - 112 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ($1) {
        break label$5
       }
       $4 = alloc__boxed__Box_T_2cA___new_uninit_in__h0c9edbef1faf0ccf() | 0;
       HEAP16[($4 + 6 | 0) >> 1] = 0;
       HEAP32[$4 >> 2] = 0;
       $5 = 0;
       $6 = HEAPU16[($2 + 6 | 0) >> 1] | 0;
       if (!$6) {
        break label$3
       }
       $1 = $2 + 8 | 0;
       $7 = 0;
       $5 = 1;
       break label$4;
      }
      $8 = $1 + -1 | 0;
      $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__clone_subtree__h2916732d8c8f5a11($3 + 8 | 0 | 0, $8 | 0, HEAP32[($2 + 316 | 0) >> 2] | 0 | 0);
      label$6 : {
       label$7 : {
        $9 = HEAP32[($3 + 12 | 0) >> 2] | 0;
        if (!$9) {
         break label$7
        }
        $7 = (HEAP32[($3 + 8 | 0) >> 2] | 0) + 1 | 0;
        break label$6;
       }
       $9 = alloc__boxed__Box_T_2cA___new_uninit_in__h0c9edbef1faf0ccf() | 0;
       HEAP16[($9 + 6 | 0) >> 1] = 0;
       HEAP32[$9 >> 2] = 0;
       $7 = 1;
      }
      $1 = alloc__boxed__Box_T_2cA___new_uninit_in__hef877667b5cd207e() | 0;
      HEAP32[($1 + 316 | 0) >> 2] = $9;
      $5 = 0;
      HEAP16[($1 + 6 | 0) >> 1] = 0;
      HEAP32[$1 >> 2] = 0;
      HEAP16[($9 + 4 | 0) >> 1] = 0;
      HEAP32[$9 >> 2] = $1;
      HEAP32[($3 + 12 | 0) >> 2] = $1;
      HEAP32[($3 + 8 | 0) >> 2] = $7;
      HEAP32[($3 + 28 | 0) >> 2] = $1;
      HEAP32[($3 + 24 | 0) >> 2] = $7;
      label$8 : {
       if (!(HEAPU16[($2 + 6 | 0) >> 1] | 0)) {
        break label$8
       }
       $1 = $2 + 8 | 0;
       $7 = $2 + 320 | 0;
       $4 = HEAP32[($3 + 16 | 0) >> 2] | 0;
       label$9 : while (1) {
        $6 = ($3 + 32 | 0) + 24 | 0;
        $27 = $1 + 24 | 0;
        HEAP32[$6 >> 2] = HEAPU8[$27 >> 0] | 0 | ((HEAPU8[($27 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($27 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($27 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $10 = ($3 + 32 | 0) + 16 | 0;
        i64toi32_i32$2 = $1 + 16 | 0;
        i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $82 = i64toi32_i32$0;
        i64toi32_i32$0 = $10;
        HEAP32[i64toi32_i32$0 >> 2] = $82;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        $11 = ($3 + 32 | 0) + 8 | 0;
        i64toi32_i32$2 = $1 + 8 | 0;
        i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $89 = i64toi32_i32$1;
        i64toi32_i32$1 = $11;
        HEAP32[i64toi32_i32$1 >> 2] = $89;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = $1;
        i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $92 = i64toi32_i32$0;
        i64toi32_i32$0 = $3;
        HEAP32[($3 + 32 | 0) >> 2] = $92;
        HEAP32[($3 + 36 | 0) >> 2] = i64toi32_i32$1;
        $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__clone_subtree__h2916732d8c8f5a11($3 + 64 | 0 | 0, $8 | 0, HEAP32[$7 >> 2] | 0 | 0);
        $12 = HEAP32[($3 + 72 | 0) >> 2] | 0;
        $9 = HEAP32[($3 + 68 | 0) >> 2] | 0;
        $13 = HEAP32[($3 + 64 | 0) >> 2] | 0;
        HEAP32[(($3 + 80 | 0) + 24 | 0) >> 2] = HEAP32[$6 >> 2] | 0;
        i64toi32_i32$2 = $10;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $113 = i64toi32_i32$1;
        i64toi32_i32$1 = ($3 + 80 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $113;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = $11;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $118 = i64toi32_i32$0;
        i64toi32_i32$0 = ($3 + 80 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $118;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$2 = $3;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
        $121 = i64toi32_i32$1;
        i64toi32_i32$1 = i64toi32_i32$2;
        HEAP32[(i64toi32_i32$2 + 80 | 0) >> 2] = $121;
        HEAP32[(i64toi32_i32$2 + 84 | 0) >> 2] = i64toi32_i32$0;
        $5 = $5 + 1 | 0;
        label$10 : {
         if ($9) {
          break label$10
         }
         $13 = 0;
         $9 = alloc__boxed__Box_T_2cA___new_uninit_in__h0c9edbef1faf0ccf() | 0;
         HEAP16[($9 + 6 | 0) >> 1] = 0;
         HEAP32[$9 >> 2] = 0;
        }
        alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal___push__hc0dce87587d46cdc($3 + 24 | 0 | 0, $3 + 80 | 0 | 0, $13 | 0, $9 | 0);
        $1 = $1 + 28 | 0;
        $7 = $7 + 4 | 0;
        $4 = ($12 + $4 | 0) + 1 | 0;
        if ($5 >>> 0 < (HEAPU16[($2 + 6 | 0) >> 1] | 0) >>> 0) {
         continue label$9
        }
        break label$9;
       };
       HEAP32[($3 + 16 | 0) >> 2] = $4;
      }
      i64toi32_i32$2 = $3;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
      $150 = i64toi32_i32$0;
      i64toi32_i32$0 = $0;
      HEAP32[i64toi32_i32$0 >> 2] = $150;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[((i64toi32_i32$2 + 8 | 0) + 8 | 0) >> 2] | 0;
      break label$1;
     }
     label$11 : {
      label$12 : while (1) {
       $13 = $7 & 65535 | 0;
       $9 = $4 + Math_imul($13, 28) | 0;
       $28 = $1 + 24 | 0;
       $29 = $9 + 32 | 0;
       $30 = HEAPU8[$28 >> 0] | 0 | ((HEAPU8[($28 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($28 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($28 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       HEAP8[$29 >> 0] = $30;
       HEAP8[($29 + 1 | 0) >> 0] = $30 >>> 8 | 0;
       HEAP8[($29 + 2 | 0) >> 0] = $30 >>> 16 | 0;
       HEAP8[($29 + 3 | 0) >> 0] = $30 >>> 24 | 0;
       i64toi32_i32$2 = $1 + 16 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $172 = i64toi32_i32$1;
       i64toi32_i32$1 = $9 + 24 | 0;
       $31 = $172;
       HEAP8[i64toi32_i32$1 >> 0] = $31;
       HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $31 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $31 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $31 >>> 24 | 0;
       HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
       HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
       i64toi32_i32$2 = $1 + 8 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $177 = i64toi32_i32$0;
       i64toi32_i32$0 = $9 + 16 | 0;
       $32 = $177;
       HEAP8[i64toi32_i32$0 >> 0] = $32;
       HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $32 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $32 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $32 >>> 24 | 0;
       HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
       HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
       i64toi32_i32$2 = $1;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $181 = i64toi32_i32$1;
       i64toi32_i32$1 = $9 + 8 | 0;
       $33 = $181;
       HEAP8[i64toi32_i32$1 >> 0] = $33;
       HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $33 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $33 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $33 >>> 24 | 0;
       HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
       HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
       $7 = $7 + 1 | 0;
       if ($5 >>> 0 >= $6 >>> 0) {
        break label$11
       }
       $1 = $1 + 28 | 0;
       $5 = $5 + 1 | 0;
       if ($13 >>> 0 >= 10 >>> 0) {
        break label$2
       }
       continue label$12;
      };
     }
     HEAP16[($4 + 6 | 0) >> 1] = $7;
    }
    HEAP32[($0 + 8 | 0) >> 2] = $5;
    HEAP32[($0 + 4 | 0) >> 2] = $4;
    HEAP32[$0 >> 2] = 0;
    break label$1;
   }
   HEAP16[($4 + 6 | 0) >> 1] = $7;
   core__panicking__panic__h2fd385a887c8bf13(1048619 | 0, 32 | 0, 1048744 | 0);
   abort();
  }
  global$0 = $3 + 112 | 0;
 }
 
 function cryptoxide__blake2b__Blake2b__new_keyed__h8b7c7390e3d049ce($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $5 = 0;
  $4 = global$0;
  $5 = $4;
  $4 = ($4 - 544 | 0) & -32 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           label$10 : {
            label$11 : {
             label$12 : {
              label$13 : {
               label$14 : {
                label$15 : {
                 label$16 : {
                  label$17 : {
                   label$18 : {
                    if ($3 >>> 0 > 64 >>> 0) {
                     break label$18
                    }
                    label$19 : {
                     if (($1 | 0) > (35 | 0)) {
                      break label$19
                     }
                     label$20 : {
                      switch ($1 + -1 | 0 | 0) {
                      case 2:
                      case 4:
                      case 5:
                      case 6:
                       break label$1;
                      case 7:
                       break label$13;
                      case 3:
                       break label$14;
                      case 1:
                       break label$15;
                      case 0:
                       break label$16;
                      default:
                       break label$20;
                      };
                     }
                     switch ($1 + -24 | 0 | 0) {
                     case 1:
                     case 2:
                     case 3:
                     case 5:
                     case 6:
                     case 7:
                      break label$1;
                     case 4:
                      break label$10;
                     case 0:
                      break label$11;
                     case 9:
                      break label$8;
                     case 8:
                      break label$9;
                     default:
                      break label$17;
                     };
                    }
                    label$21 : {
                     switch ($1 + -36 | 0 | 0) {
                     case 1:
                     case 2:
                     case 3:
                      break label$1;
                     case 4:
                      break label$6;
                     case 0:
                      break label$7;
                     default:
                      break label$21;
                     };
                    }
                    switch ($1 + -44 | 0 | 0) {
                    case 1:
                    case 2:
                    case 3:
                     break label$1;
                    case 4:
                     break label$4;
                    case 0:
                     break label$5;
                    default:
                     break label$3;
                    };
                   }
                   core__panicking__panic__h2fd385a887c8bf13(1135716 | 0, 33 | 0, 1135752 | 0);
                   abort();
                  }
                  if (($1 | 0) == (16 | 0)) {
                   break label$12
                  }
                  break label$1;
                 }
                 cryptoxide__hashing__blake2b__Context_____new_keyed__h61c8c37774cd350f($4 + 288 | 0 | 0, $2 | 0, $3 | 0);
                 memcpy($4 + 32 | 0 | 0, $4 + 288 | 0 | 0, 256 | 0) | 0;
                 $1 = 0;
                 break label$2;
                }
                cryptoxide__hashing__blake2b__Context_____new_keyed__h61ab3f6f390b3877($4 + 288 | 0 | 0, $2 | 0, $3 | 0);
                memcpy($4 + 32 | 0 | 0, $4 + 288 | 0 | 0, 256 | 0) | 0;
                $1 = 1;
                break label$2;
               }
               cryptoxide__hashing__blake2b__Context_____new_keyed__hcb22d04e84ffb126($4 + 288 | 0 | 0, $2 | 0, $3 | 0);
               memcpy($4 + 32 | 0 | 0, $4 + 288 | 0 | 0, 256 | 0) | 0;
               $1 = 2;
               break label$2;
              }
              cryptoxide__hashing__blake2b__Context_____new_keyed__h8dffec56a0f93183($4 + 288 | 0 | 0, $2 | 0, $3 | 0);
              memcpy($4 + 32 | 0 | 0, $4 + 288 | 0 | 0, 256 | 0) | 0;
              $1 = 3;
              break label$2;
             }
             cryptoxide__hashing__blake2b__Context_____new_keyed__h0020be505a449ec3($4 + 288 | 0 | 0, $2 | 0, $3 | 0);
             memcpy($4 + 32 | 0 | 0, $4 + 288 | 0 | 0, 256 | 0) | 0;
             $1 = 4;
             break label$2;
            }
            cryptoxide__hashing__blake2b__Context_____new_keyed__h0020be505a449ec3($4 + 288 | 0 | 0, $2 | 0, $3 | 0);
            memcpy($4 + 32 | 0 | 0, $4 + 288 | 0 | 0, 256 | 0) | 0;
            $1 = 5;
            break label$2;
           }
           cryptoxide__hashing__blake2b__Context_____new_keyed__h13601b381cfa4335($4 + 288 | 0 | 0, $2 | 0, $3 | 0);
           memcpy($4 + 32 | 0 | 0, $4 + 288 | 0 | 0, 256 | 0) | 0;
           $1 = 6;
           break label$2;
          }
          cryptoxide__hashing__blake2b__Context_____new_keyed__h69bf216b6ea6caf9($4 + 288 | 0 | 0, $2 | 0, $3 | 0);
          memcpy($4 + 32 | 0 | 0, $4 + 288 | 0 | 0, 256 | 0) | 0;
          $1 = 7;
          break label$2;
         }
         cryptoxide__hashing__blake2b__Context_____new_keyed__had6d6d435e04cb52($4 + 288 | 0 | 0, $2 | 0, $3 | 0);
         memcpy($4 + 32 | 0 | 0, $4 + 288 | 0 | 0, 256 | 0) | 0;
         $1 = 8;
         break label$2;
        }
        cryptoxide__hashing__blake2b__Context_____new_keyed__h4eadb007ddfc845f($4 + 288 | 0 | 0, $2 | 0, $3 | 0);
        memcpy($4 + 32 | 0 | 0, $4 + 288 | 0 | 0, 256 | 0) | 0;
        $1 = 9;
        break label$2;
       }
       cryptoxide__hashing__blake2b__Context_____new_keyed__hdc22e70268b93c53($4 + 288 | 0 | 0, $2 | 0, $3 | 0);
       memcpy($4 + 32 | 0 | 0, $4 + 288 | 0 | 0, 256 | 0) | 0;
       $1 = 10;
       break label$2;
      }
      cryptoxide__hashing__blake2b__Context_____new_keyed__h0aac9808807e4fc4($4 + 288 | 0 | 0, $2 | 0, $3 | 0);
      memcpy($4 + 32 | 0 | 0, $4 + 288 | 0 | 0, 256 | 0) | 0;
      $1 = 11;
      break label$2;
     }
     cryptoxide__hashing__blake2b__Context_____new_keyed__h2236c20e723d151b($4 + 288 | 0 | 0, $2 | 0, $3 | 0);
     memcpy($4 + 32 | 0 | 0, $4 + 288 | 0 | 0, 256 | 0) | 0;
     $1 = 12;
     break label$2;
    }
    if (($1 | 0) != (64 | 0)) {
     break label$1
    }
    cryptoxide__hashing__blake2b__Context_____new_keyed__h3e2bc284cc15c72f($4 + 288 | 0 | 0, $2 | 0, $3 | 0);
    memcpy($4 + 32 | 0 | 0, $4 + 288 | 0 | 0, 256 | 0) | 0;
    $1 = 13;
   }
   memcpy($0 + 1 | 0 | 0, $4 + 1 | 0 | 0, 287 | 0) | 0;
   HEAP8[($0 + 288 | 0) >> 0] = 0;
   HEAP8[$0 >> 0] = $1;
   global$0 = $5;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1135576 | 0, 26 | 0, 1135768 | 0);
  abort();
 }
 
 function $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, i64toi32_i32$5 = 0, $7$hi = 0, $7 = 0, $8$hi = 0, $5 = 0, $10$hi = 0, $8 = 0, $4 = 0, $10 = 0, $9$hi = 0, $9 = 0, $3 = 0, $6 = 0, $11$hi = 0, $11 = 0, $12$hi = 0, $76 = 0, $77 = 0, $79 = 0, $12 = 0, $80 = 0, $81 = 0, $40$hi = 0, $43$hi = 0, $44$hi = 0, $55$hi = 0, $58$hi = 0, $59$hi = 0, $62 = 0, $64 = 0, $64$hi = 0, $69$hi = 0, $70$hi = 0, $78 = 0, $82 = 0, $82$hi = 0, $86$hi = 0, $91 = 0, $91$hi = 0, $95 = 0, $95$hi = 0, $98 = 0, $98$hi = 0, $106 = 0, $106$hi = 0, $107 = 0, $110 = 0, $111 = 0, $114 = 0, $114$hi = 0, $117 = 0, $117$hi = 0, $120 = 0, $120$hi = 0, $123 = 0, $127 = 0, $159 = 0, $159$hi = 0, $165 = 0, $165$hi = 0, $171 = 0, $171$hi = 0, $174$hi = 0, $178 = 0, $178$hi = 0, $181 = 0, $181$hi = 0, $218$hi = 0, $221$hi = 0, $222$hi = 0, $235$hi = 0, $238$hi = 0, $239$hi = 0;
  HEAP32[($0 + 56 | 0) >> 2] = (HEAP32[($0 + 56 | 0) >> 2] | 0) + $2 | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $3 = HEAP32[($0 + 60 | 0) >> 2] | 0;
      if ($3) {
       break label$4
      }
      $4 = 0;
      break label$3;
     }
     $5 = 4;
     label$5 : {
      label$6 : {
       $4 = 8 - $3 | 0;
       $6 = $4 >>> 0 < $2 >>> 0 ? $4 : $2;
       if ($6 >>> 0 >= 4 >>> 0) {
        break label$6
       }
       i64toi32_i32$0 = 0;
       $7 = 0;
       $7$hi = i64toi32_i32$0;
       $5 = 0;
       break label$5;
      }
      i64toi32_i32$2 = $1;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = 0;
      $7 = i64toi32_i32$0;
      $7$hi = i64toi32_i32$1;
     }
     label$7 : {
      if (($5 | 1 | 0) >>> 0 >= $6 >>> 0) {
       break label$7
      }
      i64toi32_i32$2 = $1 + $5 | 0;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
      i64toi32_i32$0 = 0;
      $40$hi = i64toi32_i32$0;
      i64toi32_i32$0 = 0;
      $43$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $40$hi;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$1 = $43$hi;
      i64toi32_i32$3 = $5 << 3 | 0;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       $76 = 0;
      } else {
       i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
       $76 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
      }
      $44$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $7$hi;
      i64toi32_i32$1 = $44$hi;
      i64toi32_i32$0 = $76;
      i64toi32_i32$2 = $7$hi;
      i64toi32_i32$3 = $7;
      i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
      $7 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
      $7$hi = i64toi32_i32$2;
      $5 = $5 | 2 | 0;
     }
     label$8 : {
      if ($5 >>> 0 >= $6 >>> 0) {
       break label$8
      }
      i64toi32_i32$1 = $1 + $5 | 0;
      i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
      i64toi32_i32$0 = 0;
      $55$hi = i64toi32_i32$0;
      i64toi32_i32$0 = 0;
      $58$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $55$hi;
      i64toi32_i32$1 = i64toi32_i32$2;
      i64toi32_i32$2 = $58$hi;
      i64toi32_i32$3 = $5 << 3 | 0;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       $77 = 0;
      } else {
       i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
       $77 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
      }
      $59$hi = i64toi32_i32$2;
      i64toi32_i32$2 = $7$hi;
      i64toi32_i32$2 = $59$hi;
      i64toi32_i32$0 = $77;
      i64toi32_i32$1 = $7$hi;
      i64toi32_i32$3 = $7;
      i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
      $7 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
      $7$hi = i64toi32_i32$1;
     }
     $62 = $0;
     i64toi32_i32$2 = $0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] | 0;
     $64 = i64toi32_i32$1;
     $64$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$0 = 0;
     $69$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$2 = $7;
     i64toi32_i32$1 = $69$hi;
     i64toi32_i32$3 = ($3 << 3 | 0) & 56 | 0;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
      $79 = 0;
     } else {
      i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
      $79 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
     }
     $70$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $64$hi;
     i64toi32_i32$0 = $64;
     i64toi32_i32$2 = $70$hi;
     i64toi32_i32$3 = $79;
     i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
     $7 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
     $7$hi = i64toi32_i32$2;
     i64toi32_i32$0 = $62;
     HEAP32[(i64toi32_i32$0 + 48 | 0) >> 2] = $7;
     HEAP32[(i64toi32_i32$0 + 52 | 0) >> 2] = i64toi32_i32$2;
     if ($4 >>> 0 > $2 >>> 0) {
      break label$2
     }
     $5 = $0 + 32 | 0;
     $78 = $5;
     $3 = $0 + 24 | 0;
     i64toi32_i32$1 = $3;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $82 = i64toi32_i32$2;
     $82$hi = i64toi32_i32$0;
     $6 = $0 + 40 | 0;
     i64toi32_i32$1 = $6;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $86$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$2 = $86$hi;
     i64toi32_i32$1 = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
     $8 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $8$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $82$hi;
     i64toi32_i32$2 = $82;
     i64toi32_i32$1 = $8$hi;
     i64toi32_i32$3 = $8;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $9 = i64toi32_i32$4;
     $9$hi = i64toi32_i32$5;
     $91 = i64toi32_i32$4;
     $91$hi = i64toi32_i32$5;
     i64toi32_i32$0 = $5;
     i64toi32_i32$5 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $10 = i64toi32_i32$5;
     $10$hi = i64toi32_i32$2;
     i64toi32_i32$5 = 0;
     i64toi32_i32$5 = __wasm_rotl_i64($10 | 0, i64toi32_i32$2 | 0, 13 | 0, i64toi32_i32$5 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $95 = i64toi32_i32$5;
     $95$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $10$hi;
     i64toi32_i32$0 = $0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] | 0;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] | 0;
     $98 = i64toi32_i32$2;
     $98$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $10$hi;
     i64toi32_i32$0 = $10;
     i64toi32_i32$2 = $98$hi;
     i64toi32_i32$3 = $98;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $10 = i64toi32_i32$1;
     $10$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $95$hi;
     i64toi32_i32$5 = $95;
     i64toi32_i32$0 = $10$hi;
     i64toi32_i32$3 = i64toi32_i32$1;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $11 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
     $11$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $91$hi;
     i64toi32_i32$4 = $91;
     i64toi32_i32$5 = $11$hi;
     i64toi32_i32$3 = $11;
     i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $12 = i64toi32_i32$2;
     $12$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $11$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($11 | 0, i64toi32_i32$1 | 0, 17 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $106 = i64toi32_i32$4;
     $106$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$0 = i64toi32_i32$2;
     i64toi32_i32$4 = $106$hi;
     i64toi32_i32$3 = $106;
     i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
     $107 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     i64toi32_i32$0 = $78;
     HEAP32[i64toi32_i32$0 >> 2] = $107;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$4;
     i64toi32_i32$4 = i64toi32_i32$1;
     i64toi32_i32$4 = i64toi32_i32$1;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64(i64toi32_i32$2 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $110 = i64toi32_i32$0;
     i64toi32_i32$0 = $3;
     HEAP32[i64toi32_i32$0 >> 2] = $110;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$4;
     $111 = $6;
     i64toi32_i32$4 = $9$hi;
     i64toi32_i32$4 = $8$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($8 | 0, i64toi32_i32$4 | 0, 16 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $114 = i64toi32_i32$0;
     $114$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $9$hi;
     i64toi32_i32$1 = $9;
     i64toi32_i32$0 = $114$hi;
     i64toi32_i32$3 = $114;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $8 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $8$hi = i64toi32_i32$0;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($8 | 0, i64toi32_i32$0 | 0, 21 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $117 = i64toi32_i32$1;
     $117$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $8$hi;
     i64toi32_i32$0 = $10$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $120 = i64toi32_i32$1;
     $120$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $8$hi;
     i64toi32_i32$4 = $8;
     i64toi32_i32$1 = $120$hi;
     i64toi32_i32$3 = $120;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $8 = i64toi32_i32$5;
     $8$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $117$hi;
     i64toi32_i32$0 = $117;
     i64toi32_i32$4 = $8$hi;
     i64toi32_i32$3 = i64toi32_i32$5;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $123 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     i64toi32_i32$0 = $111;
     HEAP32[i64toi32_i32$0 >> 2] = $123;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$4;
     i64toi32_i32$4 = $8$hi;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$4 = $8$hi;
     i64toi32_i32$2 = i64toi32_i32$3;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $127 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     i64toi32_i32$2 = $0;
     HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] = $127;
     HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] = i64toi32_i32$0;
    }
    $2 = $2 - $4 | 0;
    $5 = $2 & 7 | 0;
    label$9 : {
     $2 = $2 & -8 | 0;
     if ($4 >>> 0 >= $2 >>> 0) {
      break label$9
     }
     i64toi32_i32$4 = $0 + 24 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
     $8 = i64toi32_i32$0;
     $8$hi = i64toi32_i32$2;
     i64toi32_i32$4 = $0 + 32 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$4 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
     $7 = i64toi32_i32$2;
     $7$hi = i64toi32_i32$0;
     i64toi32_i32$4 = $0 + 40 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
     $9 = i64toi32_i32$0;
     $9$hi = i64toi32_i32$2;
     i64toi32_i32$4 = $0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 16 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 20 | 0) >> 2] | 0;
     $10 = i64toi32_i32$2;
     $10$hi = i64toi32_i32$0;
     label$10 : while (1) {
      i64toi32_i32$4 = $1 + $4 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$4 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$4 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$4 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$4 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$2 = HEAPU8[(i64toi32_i32$4 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$4 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$4 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$4 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $11 = i64toi32_i32$0;
      $11$hi = i64toi32_i32$2;
      i64toi32_i32$2 = $9$hi;
      i64toi32_i32$2 = $11$hi;
      i64toi32_i32$4 = i64toi32_i32$0;
      i64toi32_i32$0 = $9$hi;
      i64toi32_i32$3 = $9;
      i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
      $9 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
      $9$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $8$hi;
      i64toi32_i32$0 = $9$hi;
      i64toi32_i32$2 = $9;
      i64toi32_i32$4 = $8$hi;
      i64toi32_i32$3 = $8;
      i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
      i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
      if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
       i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
      }
      $8 = i64toi32_i32$1;
      $8$hi = i64toi32_i32$5;
      $159 = i64toi32_i32$1;
      $159$hi = i64toi32_i32$5;
      i64toi32_i32$5 = $10$hi;
      i64toi32_i32$5 = $7$hi;
      i64toi32_i32$5 = $10$hi;
      i64toi32_i32$0 = $10;
      i64toi32_i32$2 = $7$hi;
      i64toi32_i32$3 = $7;
      i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
      i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
      if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
       i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
      }
      $10 = i64toi32_i32$4;
      $10$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $7$hi;
      i64toi32_i32$0 = 0;
      i64toi32_i32$0 = __wasm_rotl_i64($7 | 0, i64toi32_i32$1 | 0, 13 | 0, i64toi32_i32$0 | 0) | 0;
      i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
      $165 = i64toi32_i32$0;
      $165$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $10$hi;
      i64toi32_i32$5 = i64toi32_i32$4;
      i64toi32_i32$0 = $165$hi;
      i64toi32_i32$3 = $165;
      i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
      $7 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
      $7$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $159$hi;
      i64toi32_i32$1 = $159;
      i64toi32_i32$5 = $7$hi;
      i64toi32_i32$3 = $7;
      i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
      i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
      if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
       i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
      }
      $12 = i64toi32_i32$2;
      $12$hi = i64toi32_i32$4;
      i64toi32_i32$4 = $7$hi;
      i64toi32_i32$1 = 0;
      i64toi32_i32$1 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 17 | 0, i64toi32_i32$1 | 0) | 0;
      i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
      $171 = i64toi32_i32$1;
      $171$hi = i64toi32_i32$4;
      i64toi32_i32$4 = $12$hi;
      i64toi32_i32$0 = i64toi32_i32$2;
      i64toi32_i32$1 = $171$hi;
      i64toi32_i32$3 = $171;
      i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
      $7 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
      $7$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $9$hi;
      i64toi32_i32$0 = 0;
      i64toi32_i32$0 = __wasm_rotl_i64($9 | 0, i64toi32_i32$1 | 0, 16 | 0, i64toi32_i32$0 | 0) | 0;
      i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
      $174$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $8$hi;
      i64toi32_i32$1 = $174$hi;
      i64toi32_i32$4 = i64toi32_i32$0;
      i64toi32_i32$0 = $8$hi;
      i64toi32_i32$3 = $8;
      i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
      $8 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
      $8$hi = i64toi32_i32$0;
      i64toi32_i32$4 = 0;
      i64toi32_i32$4 = __wasm_rotl_i64($8 | 0, i64toi32_i32$0 | 0, 21 | 0, i64toi32_i32$4 | 0) | 0;
      i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
      $178 = i64toi32_i32$4;
      $178$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $8$hi;
      i64toi32_i32$0 = $10$hi;
      i64toi32_i32$4 = 0;
      i64toi32_i32$4 = __wasm_rotl_i64($10 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
      i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
      $181 = i64toi32_i32$4;
      $181$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $8$hi;
      i64toi32_i32$1 = $8;
      i64toi32_i32$4 = $181$hi;
      i64toi32_i32$3 = $181;
      i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
      i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
      if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
       i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
      }
      $10 = i64toi32_i32$5;
      $10$hi = i64toi32_i32$2;
      i64toi32_i32$2 = $178$hi;
      i64toi32_i32$0 = $178;
      i64toi32_i32$1 = $10$hi;
      i64toi32_i32$3 = i64toi32_i32$5;
      i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
      $9 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
      $9$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $12$hi;
      i64toi32_i32$0 = 0;
      i64toi32_i32$0 = __wasm_rotl_i64($12 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$0 | 0) | 0;
      i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
      $8 = i64toi32_i32$0;
      $8$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $10$hi;
      i64toi32_i32$1 = $11$hi;
      i64toi32_i32$1 = $10$hi;
      i64toi32_i32$2 = i64toi32_i32$3;
      i64toi32_i32$0 = $11$hi;
      i64toi32_i32$3 = $11;
      i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
      $10 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
      $10$hi = i64toi32_i32$0;
      $4 = $4 + 8 | 0;
      if ($4 >>> 0 < $2 >>> 0) {
       continue label$10
      }
      break label$10;
     };
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$2 = $0;
     HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] = $7;
     HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$0 = $10$hi;
     HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] = $10;
     HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$0 = $9$hi;
     HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] = $9;
     HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$0 = $8$hi;
     HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] = $8;
     HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] = i64toi32_i32$0;
    }
    $2 = 4;
    label$11 : {
     label$12 : {
      if ($5 >>> 0 >= 4 >>> 0) {
       break label$12
      }
      i64toi32_i32$0 = 0;
      $7 = 0;
      $7$hi = i64toi32_i32$0;
      $2 = 0;
      break label$11;
     }
     i64toi32_i32$1 = $1 + $4 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$2 = 0;
     $7 = i64toi32_i32$0;
     $7$hi = i64toi32_i32$2;
    }
    label$13 : {
     if (($2 | 1 | 0) >>> 0 >= $5 >>> 0) {
      break label$13
     }
     i64toi32_i32$1 = $1 + ($2 + $4 | 0) | 0;
     i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
     i64toi32_i32$0 = 0;
     $218$hi = i64toi32_i32$0;
     i64toi32_i32$0 = 0;
     $221$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $218$hi;
     i64toi32_i32$1 = i64toi32_i32$2;
     i64toi32_i32$2 = $221$hi;
     i64toi32_i32$3 = $2 << 3 | 0;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
      $80 = 0;
     } else {
      i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
      $80 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
     }
     $222$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$2 = $222$hi;
     i64toi32_i32$0 = $80;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
     $7 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
     $7$hi = i64toi32_i32$1;
     $2 = $2 | 2 | 0;
    }
    label$14 : {
     if ($2 >>> 0 >= $5 >>> 0) {
      break label$14
     }
     i64toi32_i32$2 = $1 + ($2 + $4 | 0) | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
     i64toi32_i32$0 = 0;
     $235$hi = i64toi32_i32$0;
     i64toi32_i32$0 = 0;
     $238$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $235$hi;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$1 = $238$hi;
     i64toi32_i32$3 = $2 << 3 | 0;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
      $81 = 0;
     } else {
      i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
      $81 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
     }
     $239$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$1 = $239$hi;
     i64toi32_i32$0 = $81;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
     $7 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
     $7$hi = i64toi32_i32$2;
    }
    i64toi32_i32$2 = $7$hi;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 48 | 0) >> 2] = $7;
    HEAP32[(i64toi32_i32$0 + 52 | 0) >> 2] = i64toi32_i32$2;
    break label$1;
   }
   $5 = $3 + $2 | 0;
  }
  HEAP32[($0 + 60 | 0) >> 2] = $5;
 }
 
 function $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_1($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, i64toi32_i32$5 = 0, $7$hi = 0, $7 = 0, $8$hi = 0, $5 = 0, $10$hi = 0, $8 = 0, $4 = 0, $10 = 0, $9$hi = 0, $9 = 0, $3 = 0, $6 = 0, $11$hi = 0, $11 = 0, $12$hi = 0, $76 = 0, $77 = 0, $79 = 0, $12 = 0, $80 = 0, $81 = 0, $40$hi = 0, $43$hi = 0, $44$hi = 0, $55$hi = 0, $58$hi = 0, $59$hi = 0, $62 = 0, $64 = 0, $64$hi = 0, $69$hi = 0, $70$hi = 0, $78 = 0, $82 = 0, $82$hi = 0, $86$hi = 0, $91 = 0, $91$hi = 0, $95 = 0, $95$hi = 0, $98 = 0, $98$hi = 0, $106 = 0, $106$hi = 0, $107 = 0, $110 = 0, $111 = 0, $114 = 0, $114$hi = 0, $117 = 0, $117$hi = 0, $120 = 0, $120$hi = 0, $123 = 0, $127 = 0, $159 = 0, $159$hi = 0, $165 = 0, $165$hi = 0, $171 = 0, $171$hi = 0, $174$hi = 0, $178 = 0, $178$hi = 0, $181 = 0, $181$hi = 0, $218$hi = 0, $221$hi = 0, $222$hi = 0, $235$hi = 0, $238$hi = 0, $239$hi = 0;
  HEAP32[($0 + 56 | 0) >> 2] = (HEAP32[($0 + 56 | 0) >> 2] | 0) + $2 | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $3 = HEAP32[($0 + 60 | 0) >> 2] | 0;
      if ($3) {
       break label$4
      }
      $4 = 0;
      break label$3;
     }
     $5 = 4;
     label$5 : {
      label$6 : {
       $4 = 8 - $3 | 0;
       $6 = $4 >>> 0 < $2 >>> 0 ? $4 : $2;
       if ($6 >>> 0 >= 4 >>> 0) {
        break label$6
       }
       i64toi32_i32$0 = 0;
       $7 = 0;
       $7$hi = i64toi32_i32$0;
       $5 = 0;
       break label$5;
      }
      i64toi32_i32$2 = $1;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = 0;
      $7 = i64toi32_i32$0;
      $7$hi = i64toi32_i32$1;
     }
     label$7 : {
      if (($5 | 1 | 0) >>> 0 >= $6 >>> 0) {
       break label$7
      }
      i64toi32_i32$2 = $1 + $5 | 0;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
      i64toi32_i32$0 = 0;
      $40$hi = i64toi32_i32$0;
      i64toi32_i32$0 = 0;
      $43$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $40$hi;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$1 = $43$hi;
      i64toi32_i32$3 = $5 << 3 | 0;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       $76 = 0;
      } else {
       i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
       $76 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
      }
      $44$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $7$hi;
      i64toi32_i32$1 = $44$hi;
      i64toi32_i32$0 = $76;
      i64toi32_i32$2 = $7$hi;
      i64toi32_i32$3 = $7;
      i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
      $7 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
      $7$hi = i64toi32_i32$2;
      $5 = $5 | 2 | 0;
     }
     label$8 : {
      if ($5 >>> 0 >= $6 >>> 0) {
       break label$8
      }
      i64toi32_i32$1 = $1 + $5 | 0;
      i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
      i64toi32_i32$0 = 0;
      $55$hi = i64toi32_i32$0;
      i64toi32_i32$0 = 0;
      $58$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $55$hi;
      i64toi32_i32$1 = i64toi32_i32$2;
      i64toi32_i32$2 = $58$hi;
      i64toi32_i32$3 = $5 << 3 | 0;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       $77 = 0;
      } else {
       i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
       $77 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
      }
      $59$hi = i64toi32_i32$2;
      i64toi32_i32$2 = $7$hi;
      i64toi32_i32$2 = $59$hi;
      i64toi32_i32$0 = $77;
      i64toi32_i32$1 = $7$hi;
      i64toi32_i32$3 = $7;
      i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
      $7 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
      $7$hi = i64toi32_i32$1;
     }
     $62 = $0;
     i64toi32_i32$2 = $0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] | 0;
     $64 = i64toi32_i32$1;
     $64$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$0 = 0;
     $69$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$2 = $7;
     i64toi32_i32$1 = $69$hi;
     i64toi32_i32$3 = ($3 << 3 | 0) & 56 | 0;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
      $79 = 0;
     } else {
      i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
      $79 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
     }
     $70$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $64$hi;
     i64toi32_i32$0 = $64;
     i64toi32_i32$2 = $70$hi;
     i64toi32_i32$3 = $79;
     i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
     $7 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
     $7$hi = i64toi32_i32$2;
     i64toi32_i32$0 = $62;
     HEAP32[(i64toi32_i32$0 + 48 | 0) >> 2] = $7;
     HEAP32[(i64toi32_i32$0 + 52 | 0) >> 2] = i64toi32_i32$2;
     if ($4 >>> 0 > $2 >>> 0) {
      break label$2
     }
     $5 = $0 + 32 | 0;
     $78 = $5;
     $3 = $0 + 24 | 0;
     i64toi32_i32$1 = $3;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $82 = i64toi32_i32$2;
     $82$hi = i64toi32_i32$0;
     $6 = $0 + 40 | 0;
     i64toi32_i32$1 = $6;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $86$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$2 = $86$hi;
     i64toi32_i32$1 = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
     $8 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $8$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $82$hi;
     i64toi32_i32$2 = $82;
     i64toi32_i32$1 = $8$hi;
     i64toi32_i32$3 = $8;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $9 = i64toi32_i32$4;
     $9$hi = i64toi32_i32$5;
     $91 = i64toi32_i32$4;
     $91$hi = i64toi32_i32$5;
     i64toi32_i32$0 = $5;
     i64toi32_i32$5 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $10 = i64toi32_i32$5;
     $10$hi = i64toi32_i32$2;
     i64toi32_i32$5 = 0;
     i64toi32_i32$5 = __wasm_rotl_i64($10 | 0, i64toi32_i32$2 | 0, 13 | 0, i64toi32_i32$5 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $95 = i64toi32_i32$5;
     $95$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $10$hi;
     i64toi32_i32$0 = $0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] | 0;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] | 0;
     $98 = i64toi32_i32$2;
     $98$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $10$hi;
     i64toi32_i32$0 = $10;
     i64toi32_i32$2 = $98$hi;
     i64toi32_i32$3 = $98;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $10 = i64toi32_i32$1;
     $10$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $95$hi;
     i64toi32_i32$5 = $95;
     i64toi32_i32$0 = $10$hi;
     i64toi32_i32$3 = i64toi32_i32$1;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $11 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
     $11$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $91$hi;
     i64toi32_i32$4 = $91;
     i64toi32_i32$5 = $11$hi;
     i64toi32_i32$3 = $11;
     i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $12 = i64toi32_i32$2;
     $12$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $11$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($11 | 0, i64toi32_i32$1 | 0, 17 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $106 = i64toi32_i32$4;
     $106$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$0 = i64toi32_i32$2;
     i64toi32_i32$4 = $106$hi;
     i64toi32_i32$3 = $106;
     i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
     $107 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     i64toi32_i32$0 = $78;
     HEAP32[i64toi32_i32$0 >> 2] = $107;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$4;
     i64toi32_i32$4 = i64toi32_i32$1;
     i64toi32_i32$4 = i64toi32_i32$1;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64(i64toi32_i32$2 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $110 = i64toi32_i32$0;
     i64toi32_i32$0 = $3;
     HEAP32[i64toi32_i32$0 >> 2] = $110;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$4;
     $111 = $6;
     i64toi32_i32$4 = $9$hi;
     i64toi32_i32$4 = $8$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($8 | 0, i64toi32_i32$4 | 0, 16 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $114 = i64toi32_i32$0;
     $114$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $9$hi;
     i64toi32_i32$1 = $9;
     i64toi32_i32$0 = $114$hi;
     i64toi32_i32$3 = $114;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $8 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $8$hi = i64toi32_i32$0;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($8 | 0, i64toi32_i32$0 | 0, 21 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $117 = i64toi32_i32$1;
     $117$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $8$hi;
     i64toi32_i32$0 = $10$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $120 = i64toi32_i32$1;
     $120$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $8$hi;
     i64toi32_i32$4 = $8;
     i64toi32_i32$1 = $120$hi;
     i64toi32_i32$3 = $120;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $8 = i64toi32_i32$5;
     $8$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $117$hi;
     i64toi32_i32$0 = $117;
     i64toi32_i32$4 = $8$hi;
     i64toi32_i32$3 = i64toi32_i32$5;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $123 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     i64toi32_i32$0 = $111;
     HEAP32[i64toi32_i32$0 >> 2] = $123;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$4;
     i64toi32_i32$4 = $8$hi;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$4 = $8$hi;
     i64toi32_i32$2 = i64toi32_i32$3;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $127 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     i64toi32_i32$2 = $0;
     HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] = $127;
     HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] = i64toi32_i32$0;
    }
    $2 = $2 - $4 | 0;
    $5 = $2 & 7 | 0;
    label$9 : {
     $2 = $2 & -8 | 0;
     if ($4 >>> 0 >= $2 >>> 0) {
      break label$9
     }
     i64toi32_i32$4 = $0 + 24 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
     $8 = i64toi32_i32$0;
     $8$hi = i64toi32_i32$2;
     i64toi32_i32$4 = $0 + 32 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$4 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
     $7 = i64toi32_i32$2;
     $7$hi = i64toi32_i32$0;
     i64toi32_i32$4 = $0 + 40 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
     $9 = i64toi32_i32$0;
     $9$hi = i64toi32_i32$2;
     i64toi32_i32$4 = $0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 16 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 20 | 0) >> 2] | 0;
     $10 = i64toi32_i32$2;
     $10$hi = i64toi32_i32$0;
     label$10 : while (1) {
      i64toi32_i32$4 = $1 + $4 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$4 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$4 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$4 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$4 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$2 = HEAPU8[(i64toi32_i32$4 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$4 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$4 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$4 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $11 = i64toi32_i32$0;
      $11$hi = i64toi32_i32$2;
      i64toi32_i32$2 = $9$hi;
      i64toi32_i32$2 = $11$hi;
      i64toi32_i32$4 = i64toi32_i32$0;
      i64toi32_i32$0 = $9$hi;
      i64toi32_i32$3 = $9;
      i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
      $9 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
      $9$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $8$hi;
      i64toi32_i32$0 = $9$hi;
      i64toi32_i32$2 = $9;
      i64toi32_i32$4 = $8$hi;
      i64toi32_i32$3 = $8;
      i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
      i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
      if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
       i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
      }
      $8 = i64toi32_i32$1;
      $8$hi = i64toi32_i32$5;
      $159 = i64toi32_i32$1;
      $159$hi = i64toi32_i32$5;
      i64toi32_i32$5 = $10$hi;
      i64toi32_i32$5 = $7$hi;
      i64toi32_i32$5 = $10$hi;
      i64toi32_i32$0 = $10;
      i64toi32_i32$2 = $7$hi;
      i64toi32_i32$3 = $7;
      i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
      i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
      if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
       i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
      }
      $10 = i64toi32_i32$4;
      $10$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $7$hi;
      i64toi32_i32$0 = 0;
      i64toi32_i32$0 = __wasm_rotl_i64($7 | 0, i64toi32_i32$1 | 0, 13 | 0, i64toi32_i32$0 | 0) | 0;
      i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
      $165 = i64toi32_i32$0;
      $165$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $10$hi;
      i64toi32_i32$5 = i64toi32_i32$4;
      i64toi32_i32$0 = $165$hi;
      i64toi32_i32$3 = $165;
      i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
      $7 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
      $7$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $159$hi;
      i64toi32_i32$1 = $159;
      i64toi32_i32$5 = $7$hi;
      i64toi32_i32$3 = $7;
      i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
      i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
      if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
       i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
      }
      $12 = i64toi32_i32$2;
      $12$hi = i64toi32_i32$4;
      i64toi32_i32$4 = $7$hi;
      i64toi32_i32$1 = 0;
      i64toi32_i32$1 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 17 | 0, i64toi32_i32$1 | 0) | 0;
      i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
      $171 = i64toi32_i32$1;
      $171$hi = i64toi32_i32$4;
      i64toi32_i32$4 = $12$hi;
      i64toi32_i32$0 = i64toi32_i32$2;
      i64toi32_i32$1 = $171$hi;
      i64toi32_i32$3 = $171;
      i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
      $7 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
      $7$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $9$hi;
      i64toi32_i32$0 = 0;
      i64toi32_i32$0 = __wasm_rotl_i64($9 | 0, i64toi32_i32$1 | 0, 16 | 0, i64toi32_i32$0 | 0) | 0;
      i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
      $174$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $8$hi;
      i64toi32_i32$1 = $174$hi;
      i64toi32_i32$4 = i64toi32_i32$0;
      i64toi32_i32$0 = $8$hi;
      i64toi32_i32$3 = $8;
      i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
      $8 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
      $8$hi = i64toi32_i32$0;
      i64toi32_i32$4 = 0;
      i64toi32_i32$4 = __wasm_rotl_i64($8 | 0, i64toi32_i32$0 | 0, 21 | 0, i64toi32_i32$4 | 0) | 0;
      i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
      $178 = i64toi32_i32$4;
      $178$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $8$hi;
      i64toi32_i32$0 = $10$hi;
      i64toi32_i32$4 = 0;
      i64toi32_i32$4 = __wasm_rotl_i64($10 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
      i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
      $181 = i64toi32_i32$4;
      $181$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $8$hi;
      i64toi32_i32$1 = $8;
      i64toi32_i32$4 = $181$hi;
      i64toi32_i32$3 = $181;
      i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
      i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
      if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
       i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
      }
      $10 = i64toi32_i32$5;
      $10$hi = i64toi32_i32$2;
      i64toi32_i32$2 = $178$hi;
      i64toi32_i32$0 = $178;
      i64toi32_i32$1 = $10$hi;
      i64toi32_i32$3 = i64toi32_i32$5;
      i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
      $9 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
      $9$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $12$hi;
      i64toi32_i32$0 = 0;
      i64toi32_i32$0 = __wasm_rotl_i64($12 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$0 | 0) | 0;
      i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
      $8 = i64toi32_i32$0;
      $8$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $10$hi;
      i64toi32_i32$1 = $11$hi;
      i64toi32_i32$1 = $10$hi;
      i64toi32_i32$2 = i64toi32_i32$3;
      i64toi32_i32$0 = $11$hi;
      i64toi32_i32$3 = $11;
      i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
      $10 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
      $10$hi = i64toi32_i32$0;
      $4 = $4 + 8 | 0;
      if ($4 >>> 0 < $2 >>> 0) {
       continue label$10
      }
      break label$10;
     };
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$2 = $0;
     HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] = $7;
     HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$0 = $10$hi;
     HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] = $10;
     HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$0 = $9$hi;
     HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] = $9;
     HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$0 = $8$hi;
     HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] = $8;
     HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] = i64toi32_i32$0;
    }
    $2 = 4;
    label$11 : {
     label$12 : {
      if ($5 >>> 0 >= 4 >>> 0) {
       break label$12
      }
      i64toi32_i32$0 = 0;
      $7 = 0;
      $7$hi = i64toi32_i32$0;
      $2 = 0;
      break label$11;
     }
     i64toi32_i32$1 = $1 + $4 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$2 = 0;
     $7 = i64toi32_i32$0;
     $7$hi = i64toi32_i32$2;
    }
    label$13 : {
     if (($2 | 1 | 0) >>> 0 >= $5 >>> 0) {
      break label$13
     }
     i64toi32_i32$1 = $1 + ($2 + $4 | 0) | 0;
     i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
     i64toi32_i32$0 = 0;
     $218$hi = i64toi32_i32$0;
     i64toi32_i32$0 = 0;
     $221$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $218$hi;
     i64toi32_i32$1 = i64toi32_i32$2;
     i64toi32_i32$2 = $221$hi;
     i64toi32_i32$3 = $2 << 3 | 0;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
      $80 = 0;
     } else {
      i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
      $80 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
     }
     $222$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$2 = $222$hi;
     i64toi32_i32$0 = $80;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
     $7 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
     $7$hi = i64toi32_i32$1;
     $2 = $2 | 2 | 0;
    }
    label$14 : {
     if ($2 >>> 0 >= $5 >>> 0) {
      break label$14
     }
     i64toi32_i32$2 = $1 + ($2 + $4 | 0) | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
     i64toi32_i32$0 = 0;
     $235$hi = i64toi32_i32$0;
     i64toi32_i32$0 = 0;
     $238$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $235$hi;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$1 = $238$hi;
     i64toi32_i32$3 = $2 << 3 | 0;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
      $81 = 0;
     } else {
      i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
      $81 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
     }
     $239$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$1 = $239$hi;
     i64toi32_i32$0 = $81;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
     $7 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
     $7$hi = i64toi32_i32$2;
    }
    i64toi32_i32$2 = $7$hi;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 48 | 0) >> 2] = $7;
    HEAP32[(i64toi32_i32$0 + 52 | 0) >> 2] = i64toi32_i32$2;
    break label$1;
   }
   $5 = $3 + $2 | 0;
  }
  HEAP32[($0 + 60 | 0) >> 2] = $5;
 }
 
 function $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_2($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, i64toi32_i32$5 = 0, $7$hi = 0, $7 = 0, $8$hi = 0, $5 = 0, $10$hi = 0, $8 = 0, $4 = 0, $10 = 0, $9$hi = 0, $9 = 0, $3 = 0, $6 = 0, $11$hi = 0, $11 = 0, $12$hi = 0, $76 = 0, $77 = 0, $79 = 0, $12 = 0, $80 = 0, $81 = 0, $40$hi = 0, $43$hi = 0, $44$hi = 0, $55$hi = 0, $58$hi = 0, $59$hi = 0, $62 = 0, $64 = 0, $64$hi = 0, $69$hi = 0, $70$hi = 0, $78 = 0, $82 = 0, $82$hi = 0, $86$hi = 0, $91 = 0, $91$hi = 0, $95 = 0, $95$hi = 0, $98 = 0, $98$hi = 0, $106 = 0, $106$hi = 0, $107 = 0, $110 = 0, $111 = 0, $114 = 0, $114$hi = 0, $117 = 0, $117$hi = 0, $120 = 0, $120$hi = 0, $123 = 0, $127 = 0, $159 = 0, $159$hi = 0, $165 = 0, $165$hi = 0, $171 = 0, $171$hi = 0, $174$hi = 0, $178 = 0, $178$hi = 0, $181 = 0, $181$hi = 0, $218$hi = 0, $221$hi = 0, $222$hi = 0, $235$hi = 0, $238$hi = 0, $239$hi = 0;
  HEAP32[($0 + 56 | 0) >> 2] = (HEAP32[($0 + 56 | 0) >> 2] | 0) + $2 | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $3 = HEAP32[($0 + 60 | 0) >> 2] | 0;
      if ($3) {
       break label$4
      }
      $4 = 0;
      break label$3;
     }
     $5 = 4;
     label$5 : {
      label$6 : {
       $4 = 8 - $3 | 0;
       $6 = $4 >>> 0 < $2 >>> 0 ? $4 : $2;
       if ($6 >>> 0 >= 4 >>> 0) {
        break label$6
       }
       i64toi32_i32$0 = 0;
       $7 = 0;
       $7$hi = i64toi32_i32$0;
       $5 = 0;
       break label$5;
      }
      i64toi32_i32$2 = $1;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = 0;
      $7 = i64toi32_i32$0;
      $7$hi = i64toi32_i32$1;
     }
     label$7 : {
      if (($5 | 1 | 0) >>> 0 >= $6 >>> 0) {
       break label$7
      }
      i64toi32_i32$2 = $1 + $5 | 0;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
      i64toi32_i32$0 = 0;
      $40$hi = i64toi32_i32$0;
      i64toi32_i32$0 = 0;
      $43$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $40$hi;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$1 = $43$hi;
      i64toi32_i32$3 = $5 << 3 | 0;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       $76 = 0;
      } else {
       i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
       $76 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
      }
      $44$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $7$hi;
      i64toi32_i32$1 = $44$hi;
      i64toi32_i32$0 = $76;
      i64toi32_i32$2 = $7$hi;
      i64toi32_i32$3 = $7;
      i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
      $7 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
      $7$hi = i64toi32_i32$2;
      $5 = $5 | 2 | 0;
     }
     label$8 : {
      if ($5 >>> 0 >= $6 >>> 0) {
       break label$8
      }
      i64toi32_i32$1 = $1 + $5 | 0;
      i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
      i64toi32_i32$0 = 0;
      $55$hi = i64toi32_i32$0;
      i64toi32_i32$0 = 0;
      $58$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $55$hi;
      i64toi32_i32$1 = i64toi32_i32$2;
      i64toi32_i32$2 = $58$hi;
      i64toi32_i32$3 = $5 << 3 | 0;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       $77 = 0;
      } else {
       i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
       $77 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
      }
      $59$hi = i64toi32_i32$2;
      i64toi32_i32$2 = $7$hi;
      i64toi32_i32$2 = $59$hi;
      i64toi32_i32$0 = $77;
      i64toi32_i32$1 = $7$hi;
      i64toi32_i32$3 = $7;
      i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
      $7 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
      $7$hi = i64toi32_i32$1;
     }
     $62 = $0;
     i64toi32_i32$2 = $0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] | 0;
     $64 = i64toi32_i32$1;
     $64$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$0 = 0;
     $69$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$2 = $7;
     i64toi32_i32$1 = $69$hi;
     i64toi32_i32$3 = ($3 << 3 | 0) & 56 | 0;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
      $79 = 0;
     } else {
      i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
      $79 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
     }
     $70$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $64$hi;
     i64toi32_i32$0 = $64;
     i64toi32_i32$2 = $70$hi;
     i64toi32_i32$3 = $79;
     i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
     $7 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
     $7$hi = i64toi32_i32$2;
     i64toi32_i32$0 = $62;
     HEAP32[(i64toi32_i32$0 + 48 | 0) >> 2] = $7;
     HEAP32[(i64toi32_i32$0 + 52 | 0) >> 2] = i64toi32_i32$2;
     if ($4 >>> 0 > $2 >>> 0) {
      break label$2
     }
     $5 = $0 + 32 | 0;
     $78 = $5;
     $3 = $0 + 24 | 0;
     i64toi32_i32$1 = $3;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $82 = i64toi32_i32$2;
     $82$hi = i64toi32_i32$0;
     $6 = $0 + 40 | 0;
     i64toi32_i32$1 = $6;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $86$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$2 = $86$hi;
     i64toi32_i32$1 = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
     $8 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $8$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $82$hi;
     i64toi32_i32$2 = $82;
     i64toi32_i32$1 = $8$hi;
     i64toi32_i32$3 = $8;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $9 = i64toi32_i32$4;
     $9$hi = i64toi32_i32$5;
     $91 = i64toi32_i32$4;
     $91$hi = i64toi32_i32$5;
     i64toi32_i32$0 = $5;
     i64toi32_i32$5 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $10 = i64toi32_i32$5;
     $10$hi = i64toi32_i32$2;
     i64toi32_i32$5 = 0;
     i64toi32_i32$5 = __wasm_rotl_i64($10 | 0, i64toi32_i32$2 | 0, 13 | 0, i64toi32_i32$5 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $95 = i64toi32_i32$5;
     $95$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $10$hi;
     i64toi32_i32$0 = $0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] | 0;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] | 0;
     $98 = i64toi32_i32$2;
     $98$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $10$hi;
     i64toi32_i32$0 = $10;
     i64toi32_i32$2 = $98$hi;
     i64toi32_i32$3 = $98;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $10 = i64toi32_i32$1;
     $10$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $95$hi;
     i64toi32_i32$5 = $95;
     i64toi32_i32$0 = $10$hi;
     i64toi32_i32$3 = i64toi32_i32$1;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $11 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
     $11$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $91$hi;
     i64toi32_i32$4 = $91;
     i64toi32_i32$5 = $11$hi;
     i64toi32_i32$3 = $11;
     i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $12 = i64toi32_i32$2;
     $12$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $11$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($11 | 0, i64toi32_i32$1 | 0, 17 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $106 = i64toi32_i32$4;
     $106$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$0 = i64toi32_i32$2;
     i64toi32_i32$4 = $106$hi;
     i64toi32_i32$3 = $106;
     i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
     $107 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     i64toi32_i32$0 = $78;
     HEAP32[i64toi32_i32$0 >> 2] = $107;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$4;
     i64toi32_i32$4 = i64toi32_i32$1;
     i64toi32_i32$4 = i64toi32_i32$1;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64(i64toi32_i32$2 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $110 = i64toi32_i32$0;
     i64toi32_i32$0 = $3;
     HEAP32[i64toi32_i32$0 >> 2] = $110;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$4;
     $111 = $6;
     i64toi32_i32$4 = $9$hi;
     i64toi32_i32$4 = $8$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($8 | 0, i64toi32_i32$4 | 0, 16 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $114 = i64toi32_i32$0;
     $114$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $9$hi;
     i64toi32_i32$1 = $9;
     i64toi32_i32$0 = $114$hi;
     i64toi32_i32$3 = $114;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $8 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $8$hi = i64toi32_i32$0;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($8 | 0, i64toi32_i32$0 | 0, 21 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $117 = i64toi32_i32$1;
     $117$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $8$hi;
     i64toi32_i32$0 = $10$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $120 = i64toi32_i32$1;
     $120$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $8$hi;
     i64toi32_i32$4 = $8;
     i64toi32_i32$1 = $120$hi;
     i64toi32_i32$3 = $120;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $8 = i64toi32_i32$5;
     $8$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $117$hi;
     i64toi32_i32$0 = $117;
     i64toi32_i32$4 = $8$hi;
     i64toi32_i32$3 = i64toi32_i32$5;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $123 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     i64toi32_i32$0 = $111;
     HEAP32[i64toi32_i32$0 >> 2] = $123;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$4;
     i64toi32_i32$4 = $8$hi;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$4 = $8$hi;
     i64toi32_i32$2 = i64toi32_i32$3;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $127 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     i64toi32_i32$2 = $0;
     HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] = $127;
     HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] = i64toi32_i32$0;
    }
    $2 = $2 - $4 | 0;
    $5 = $2 & 7 | 0;
    label$9 : {
     $2 = $2 & -8 | 0;
     if ($4 >>> 0 >= $2 >>> 0) {
      break label$9
     }
     i64toi32_i32$4 = $0 + 24 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
     $8 = i64toi32_i32$0;
     $8$hi = i64toi32_i32$2;
     i64toi32_i32$4 = $0 + 32 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$4 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
     $7 = i64toi32_i32$2;
     $7$hi = i64toi32_i32$0;
     i64toi32_i32$4 = $0 + 40 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
     $9 = i64toi32_i32$0;
     $9$hi = i64toi32_i32$2;
     i64toi32_i32$4 = $0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 16 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 20 | 0) >> 2] | 0;
     $10 = i64toi32_i32$2;
     $10$hi = i64toi32_i32$0;
     label$10 : while (1) {
      i64toi32_i32$4 = $1 + $4 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$4 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$4 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$4 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$4 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$2 = HEAPU8[(i64toi32_i32$4 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$4 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$4 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$4 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $11 = i64toi32_i32$0;
      $11$hi = i64toi32_i32$2;
      i64toi32_i32$2 = $9$hi;
      i64toi32_i32$2 = $11$hi;
      i64toi32_i32$4 = i64toi32_i32$0;
      i64toi32_i32$0 = $9$hi;
      i64toi32_i32$3 = $9;
      i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
      $9 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
      $9$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $8$hi;
      i64toi32_i32$0 = $9$hi;
      i64toi32_i32$2 = $9;
      i64toi32_i32$4 = $8$hi;
      i64toi32_i32$3 = $8;
      i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
      i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
      if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
       i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
      }
      $8 = i64toi32_i32$1;
      $8$hi = i64toi32_i32$5;
      $159 = i64toi32_i32$1;
      $159$hi = i64toi32_i32$5;
      i64toi32_i32$5 = $10$hi;
      i64toi32_i32$5 = $7$hi;
      i64toi32_i32$5 = $10$hi;
      i64toi32_i32$0 = $10;
      i64toi32_i32$2 = $7$hi;
      i64toi32_i32$3 = $7;
      i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
      i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
      if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
       i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
      }
      $10 = i64toi32_i32$4;
      $10$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $7$hi;
      i64toi32_i32$0 = 0;
      i64toi32_i32$0 = __wasm_rotl_i64($7 | 0, i64toi32_i32$1 | 0, 13 | 0, i64toi32_i32$0 | 0) | 0;
      i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
      $165 = i64toi32_i32$0;
      $165$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $10$hi;
      i64toi32_i32$5 = i64toi32_i32$4;
      i64toi32_i32$0 = $165$hi;
      i64toi32_i32$3 = $165;
      i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
      $7 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
      $7$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $159$hi;
      i64toi32_i32$1 = $159;
      i64toi32_i32$5 = $7$hi;
      i64toi32_i32$3 = $7;
      i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
      i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
      if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
       i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
      }
      $12 = i64toi32_i32$2;
      $12$hi = i64toi32_i32$4;
      i64toi32_i32$4 = $7$hi;
      i64toi32_i32$1 = 0;
      i64toi32_i32$1 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 17 | 0, i64toi32_i32$1 | 0) | 0;
      i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
      $171 = i64toi32_i32$1;
      $171$hi = i64toi32_i32$4;
      i64toi32_i32$4 = $12$hi;
      i64toi32_i32$0 = i64toi32_i32$2;
      i64toi32_i32$1 = $171$hi;
      i64toi32_i32$3 = $171;
      i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
      $7 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
      $7$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $9$hi;
      i64toi32_i32$0 = 0;
      i64toi32_i32$0 = __wasm_rotl_i64($9 | 0, i64toi32_i32$1 | 0, 16 | 0, i64toi32_i32$0 | 0) | 0;
      i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
      $174$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $8$hi;
      i64toi32_i32$1 = $174$hi;
      i64toi32_i32$4 = i64toi32_i32$0;
      i64toi32_i32$0 = $8$hi;
      i64toi32_i32$3 = $8;
      i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
      $8 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
      $8$hi = i64toi32_i32$0;
      i64toi32_i32$4 = 0;
      i64toi32_i32$4 = __wasm_rotl_i64($8 | 0, i64toi32_i32$0 | 0, 21 | 0, i64toi32_i32$4 | 0) | 0;
      i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
      $178 = i64toi32_i32$4;
      $178$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $8$hi;
      i64toi32_i32$0 = $10$hi;
      i64toi32_i32$4 = 0;
      i64toi32_i32$4 = __wasm_rotl_i64($10 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
      i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
      $181 = i64toi32_i32$4;
      $181$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $8$hi;
      i64toi32_i32$1 = $8;
      i64toi32_i32$4 = $181$hi;
      i64toi32_i32$3 = $181;
      i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
      i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
      if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
       i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
      }
      $10 = i64toi32_i32$5;
      $10$hi = i64toi32_i32$2;
      i64toi32_i32$2 = $178$hi;
      i64toi32_i32$0 = $178;
      i64toi32_i32$1 = $10$hi;
      i64toi32_i32$3 = i64toi32_i32$5;
      i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
      $9 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
      $9$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $12$hi;
      i64toi32_i32$0 = 0;
      i64toi32_i32$0 = __wasm_rotl_i64($12 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$0 | 0) | 0;
      i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
      $8 = i64toi32_i32$0;
      $8$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $10$hi;
      i64toi32_i32$1 = $11$hi;
      i64toi32_i32$1 = $10$hi;
      i64toi32_i32$2 = i64toi32_i32$3;
      i64toi32_i32$0 = $11$hi;
      i64toi32_i32$3 = $11;
      i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
      $10 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
      $10$hi = i64toi32_i32$0;
      $4 = $4 + 8 | 0;
      if ($4 >>> 0 < $2 >>> 0) {
       continue label$10
      }
      break label$10;
     };
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$2 = $0;
     HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] = $7;
     HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$0 = $10$hi;
     HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] = $10;
     HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$0 = $9$hi;
     HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] = $9;
     HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$0 = $8$hi;
     HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] = $8;
     HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] = i64toi32_i32$0;
    }
    $2 = 4;
    label$11 : {
     label$12 : {
      if ($5 >>> 0 >= 4 >>> 0) {
       break label$12
      }
      i64toi32_i32$0 = 0;
      $7 = 0;
      $7$hi = i64toi32_i32$0;
      $2 = 0;
      break label$11;
     }
     i64toi32_i32$1 = $1 + $4 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$2 = 0;
     $7 = i64toi32_i32$0;
     $7$hi = i64toi32_i32$2;
    }
    label$13 : {
     if (($2 | 1 | 0) >>> 0 >= $5 >>> 0) {
      break label$13
     }
     i64toi32_i32$1 = $1 + ($2 + $4 | 0) | 0;
     i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
     i64toi32_i32$0 = 0;
     $218$hi = i64toi32_i32$0;
     i64toi32_i32$0 = 0;
     $221$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $218$hi;
     i64toi32_i32$1 = i64toi32_i32$2;
     i64toi32_i32$2 = $221$hi;
     i64toi32_i32$3 = $2 << 3 | 0;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
      $80 = 0;
     } else {
      i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
      $80 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
     }
     $222$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$2 = $222$hi;
     i64toi32_i32$0 = $80;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
     $7 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
     $7$hi = i64toi32_i32$1;
     $2 = $2 | 2 | 0;
    }
    label$14 : {
     if ($2 >>> 0 >= $5 >>> 0) {
      break label$14
     }
     i64toi32_i32$2 = $1 + ($2 + $4 | 0) | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
     i64toi32_i32$0 = 0;
     $235$hi = i64toi32_i32$0;
     i64toi32_i32$0 = 0;
     $238$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $235$hi;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$1 = $238$hi;
     i64toi32_i32$3 = $2 << 3 | 0;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
      $81 = 0;
     } else {
      i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
      $81 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
     }
     $239$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$1 = $239$hi;
     i64toi32_i32$0 = $81;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
     $7 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
     $7$hi = i64toi32_i32$2;
    }
    i64toi32_i32$2 = $7$hi;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 48 | 0) >> 2] = $7;
    HEAP32[(i64toi32_i32$0 + 52 | 0) >> 2] = i64toi32_i32$2;
    break label$1;
   }
   $5 = $3 + $2 | 0;
  }
  HEAP32[($0 + 60 | 0) >> 2] = $5;
 }
 
 function $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_3($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, i64toi32_i32$5 = 0, $7$hi = 0, $7 = 0, $8$hi = 0, $5 = 0, $10$hi = 0, $8 = 0, $4 = 0, $10 = 0, $9$hi = 0, $9 = 0, $3 = 0, $6 = 0, $11$hi = 0, $11 = 0, $12$hi = 0, $76 = 0, $77 = 0, $79 = 0, $12 = 0, $80 = 0, $81 = 0, $40$hi = 0, $43$hi = 0, $44$hi = 0, $55$hi = 0, $58$hi = 0, $59$hi = 0, $62 = 0, $64 = 0, $64$hi = 0, $69$hi = 0, $70$hi = 0, $78 = 0, $82 = 0, $82$hi = 0, $86$hi = 0, $91 = 0, $91$hi = 0, $95 = 0, $95$hi = 0, $98 = 0, $98$hi = 0, $106 = 0, $106$hi = 0, $107 = 0, $110 = 0, $111 = 0, $114 = 0, $114$hi = 0, $117 = 0, $117$hi = 0, $120 = 0, $120$hi = 0, $123 = 0, $127 = 0, $159 = 0, $159$hi = 0, $165 = 0, $165$hi = 0, $171 = 0, $171$hi = 0, $174$hi = 0, $178 = 0, $178$hi = 0, $181 = 0, $181$hi = 0, $218$hi = 0, $221$hi = 0, $222$hi = 0, $235$hi = 0, $238$hi = 0, $239$hi = 0;
  HEAP32[($0 + 56 | 0) >> 2] = (HEAP32[($0 + 56 | 0) >> 2] | 0) + $2 | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $3 = HEAP32[($0 + 60 | 0) >> 2] | 0;
      if ($3) {
       break label$4
      }
      $4 = 0;
      break label$3;
     }
     $5 = 4;
     label$5 : {
      label$6 : {
       $4 = 8 - $3 | 0;
       $6 = $4 >>> 0 < $2 >>> 0 ? $4 : $2;
       if ($6 >>> 0 >= 4 >>> 0) {
        break label$6
       }
       i64toi32_i32$0 = 0;
       $7 = 0;
       $7$hi = i64toi32_i32$0;
       $5 = 0;
       break label$5;
      }
      i64toi32_i32$2 = $1;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = 0;
      $7 = i64toi32_i32$0;
      $7$hi = i64toi32_i32$1;
     }
     label$7 : {
      if (($5 | 1 | 0) >>> 0 >= $6 >>> 0) {
       break label$7
      }
      i64toi32_i32$2 = $1 + $5 | 0;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
      i64toi32_i32$0 = 0;
      $40$hi = i64toi32_i32$0;
      i64toi32_i32$0 = 0;
      $43$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $40$hi;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$1 = $43$hi;
      i64toi32_i32$3 = $5 << 3 | 0;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       $76 = 0;
      } else {
       i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
       $76 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
      }
      $44$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $7$hi;
      i64toi32_i32$1 = $44$hi;
      i64toi32_i32$0 = $76;
      i64toi32_i32$2 = $7$hi;
      i64toi32_i32$3 = $7;
      i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
      $7 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
      $7$hi = i64toi32_i32$2;
      $5 = $5 | 2 | 0;
     }
     label$8 : {
      if ($5 >>> 0 >= $6 >>> 0) {
       break label$8
      }
      i64toi32_i32$1 = $1 + $5 | 0;
      i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0;
      i64toi32_i32$0 = 0;
      $55$hi = i64toi32_i32$0;
      i64toi32_i32$0 = 0;
      $58$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $55$hi;
      i64toi32_i32$1 = i64toi32_i32$2;
      i64toi32_i32$2 = $58$hi;
      i64toi32_i32$3 = $5 << 3 | 0;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       $77 = 0;
      } else {
       i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
       $77 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
      }
      $59$hi = i64toi32_i32$2;
      i64toi32_i32$2 = $7$hi;
      i64toi32_i32$2 = $59$hi;
      i64toi32_i32$0 = $77;
      i64toi32_i32$1 = $7$hi;
      i64toi32_i32$3 = $7;
      i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
      $7 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
      $7$hi = i64toi32_i32$1;
     }
     $62 = $0;
     i64toi32_i32$2 = $0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] | 0;
     $64 = i64toi32_i32$1;
     $64$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$0 = 0;
     $69$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$2 = $7;
     i64toi32_i32$1 = $69$hi;
     i64toi32_i32$3 = ($3 << 3 | 0) & 56 | 0;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
      $79 = 0;
     } else {
      i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
      $79 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
     }
     $70$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $64$hi;
     i64toi32_i32$0 = $64;
     i64toi32_i32$2 = $70$hi;
     i64toi32_i32$3 = $79;
     i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
     $7 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
     $7$hi = i64toi32_i32$2;
     i64toi32_i32$0 = $62;
     HEAP32[(i64toi32_i32$0 + 48 | 0) >> 2] = $7;
     HEAP32[(i64toi32_i32$0 + 52 | 0) >> 2] = i64toi32_i32$2;
     if ($4 >>> 0 > $2 >>> 0) {
      break label$2
     }
     $5 = $0 + 32 | 0;
     $78 = $5;
     $3 = $0 + 24 | 0;
     i64toi32_i32$1 = $3;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $82 = i64toi32_i32$2;
     $82$hi = i64toi32_i32$0;
     $6 = $0 + 40 | 0;
     i64toi32_i32$1 = $6;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $86$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$2 = $86$hi;
     i64toi32_i32$1 = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
     $8 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $8$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $82$hi;
     i64toi32_i32$2 = $82;
     i64toi32_i32$1 = $8$hi;
     i64toi32_i32$3 = $8;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $9 = i64toi32_i32$4;
     $9$hi = i64toi32_i32$5;
     $91 = i64toi32_i32$4;
     $91$hi = i64toi32_i32$5;
     i64toi32_i32$0 = $5;
     i64toi32_i32$5 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $10 = i64toi32_i32$5;
     $10$hi = i64toi32_i32$2;
     i64toi32_i32$5 = 0;
     i64toi32_i32$5 = __wasm_rotl_i64($10 | 0, i64toi32_i32$2 | 0, 13 | 0, i64toi32_i32$5 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $95 = i64toi32_i32$5;
     $95$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $10$hi;
     i64toi32_i32$0 = $0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] | 0;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] | 0;
     $98 = i64toi32_i32$2;
     $98$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $10$hi;
     i64toi32_i32$0 = $10;
     i64toi32_i32$2 = $98$hi;
     i64toi32_i32$3 = $98;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $10 = i64toi32_i32$1;
     $10$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $95$hi;
     i64toi32_i32$5 = $95;
     i64toi32_i32$0 = $10$hi;
     i64toi32_i32$3 = i64toi32_i32$1;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $11 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
     $11$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $91$hi;
     i64toi32_i32$4 = $91;
     i64toi32_i32$5 = $11$hi;
     i64toi32_i32$3 = $11;
     i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $12 = i64toi32_i32$2;
     $12$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $11$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$4 = __wasm_rotl_i64($11 | 0, i64toi32_i32$1 | 0, 17 | 0, i64toi32_i32$4 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $106 = i64toi32_i32$4;
     $106$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $12$hi;
     i64toi32_i32$0 = i64toi32_i32$2;
     i64toi32_i32$4 = $106$hi;
     i64toi32_i32$3 = $106;
     i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
     $107 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     i64toi32_i32$0 = $78;
     HEAP32[i64toi32_i32$0 >> 2] = $107;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$4;
     i64toi32_i32$4 = i64toi32_i32$1;
     i64toi32_i32$4 = i64toi32_i32$1;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64(i64toi32_i32$2 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $110 = i64toi32_i32$0;
     i64toi32_i32$0 = $3;
     HEAP32[i64toi32_i32$0 >> 2] = $110;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$4;
     $111 = $6;
     i64toi32_i32$4 = $9$hi;
     i64toi32_i32$4 = $8$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$0 = __wasm_rotl_i64($8 | 0, i64toi32_i32$4 | 0, 16 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
     $114 = i64toi32_i32$0;
     $114$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $9$hi;
     i64toi32_i32$1 = $9;
     i64toi32_i32$0 = $114$hi;
     i64toi32_i32$3 = $114;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $8 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     $8$hi = i64toi32_i32$0;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($8 | 0, i64toi32_i32$0 | 0, 21 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $117 = i64toi32_i32$1;
     $117$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $8$hi;
     i64toi32_i32$0 = $10$hi;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $120 = i64toi32_i32$1;
     $120$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $8$hi;
     i64toi32_i32$4 = $8;
     i64toi32_i32$1 = $120$hi;
     i64toi32_i32$3 = $120;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
     }
     $8 = i64toi32_i32$5;
     $8$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $117$hi;
     i64toi32_i32$0 = $117;
     i64toi32_i32$4 = $8$hi;
     i64toi32_i32$3 = i64toi32_i32$5;
     i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
     $123 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     i64toi32_i32$0 = $111;
     HEAP32[i64toi32_i32$0 >> 2] = $123;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$4;
     i64toi32_i32$4 = $8$hi;
     i64toi32_i32$4 = $7$hi;
     i64toi32_i32$4 = $8$hi;
     i64toi32_i32$2 = i64toi32_i32$3;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
     $127 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     i64toi32_i32$2 = $0;
     HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] = $127;
     HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] = i64toi32_i32$0;
    }
    $2 = $2 - $4 | 0;
    $5 = $2 & 7 | 0;
    label$9 : {
     $2 = $2 & -8 | 0;
     if ($4 >>> 0 >= $2 >>> 0) {
      break label$9
     }
     i64toi32_i32$4 = $0 + 24 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
     $8 = i64toi32_i32$0;
     $8$hi = i64toi32_i32$2;
     i64toi32_i32$4 = $0 + 32 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$4 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
     $7 = i64toi32_i32$2;
     $7$hi = i64toi32_i32$0;
     i64toi32_i32$4 = $0 + 40 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
     $9 = i64toi32_i32$0;
     $9$hi = i64toi32_i32$2;
     i64toi32_i32$4 = $0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 16 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 20 | 0) >> 2] | 0;
     $10 = i64toi32_i32$2;
     $10$hi = i64toi32_i32$0;
     label$10 : while (1) {
      i64toi32_i32$4 = $1 + $4 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$4 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$4 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$4 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$4 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$2 = HEAPU8[(i64toi32_i32$4 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$4 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$4 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$4 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $11 = i64toi32_i32$0;
      $11$hi = i64toi32_i32$2;
      i64toi32_i32$2 = $9$hi;
      i64toi32_i32$2 = $11$hi;
      i64toi32_i32$4 = i64toi32_i32$0;
      i64toi32_i32$0 = $9$hi;
      i64toi32_i32$3 = $9;
      i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
      $9 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
      $9$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $8$hi;
      i64toi32_i32$0 = $9$hi;
      i64toi32_i32$2 = $9;
      i64toi32_i32$4 = $8$hi;
      i64toi32_i32$3 = $8;
      i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
      i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
      if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
       i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
      }
      $8 = i64toi32_i32$1;
      $8$hi = i64toi32_i32$5;
      $159 = i64toi32_i32$1;
      $159$hi = i64toi32_i32$5;
      i64toi32_i32$5 = $10$hi;
      i64toi32_i32$5 = $7$hi;
      i64toi32_i32$5 = $10$hi;
      i64toi32_i32$0 = $10;
      i64toi32_i32$2 = $7$hi;
      i64toi32_i32$3 = $7;
      i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
      i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
      if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
       i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
      }
      $10 = i64toi32_i32$4;
      $10$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $7$hi;
      i64toi32_i32$0 = 0;
      i64toi32_i32$0 = __wasm_rotl_i64($7 | 0, i64toi32_i32$1 | 0, 13 | 0, i64toi32_i32$0 | 0) | 0;
      i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
      $165 = i64toi32_i32$0;
      $165$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $10$hi;
      i64toi32_i32$5 = i64toi32_i32$4;
      i64toi32_i32$0 = $165$hi;
      i64toi32_i32$3 = $165;
      i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
      $7 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
      $7$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $159$hi;
      i64toi32_i32$1 = $159;
      i64toi32_i32$5 = $7$hi;
      i64toi32_i32$3 = $7;
      i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
      i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
      if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
       i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
      }
      $12 = i64toi32_i32$2;
      $12$hi = i64toi32_i32$4;
      i64toi32_i32$4 = $7$hi;
      i64toi32_i32$1 = 0;
      i64toi32_i32$1 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 17 | 0, i64toi32_i32$1 | 0) | 0;
      i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
      $171 = i64toi32_i32$1;
      $171$hi = i64toi32_i32$4;
      i64toi32_i32$4 = $12$hi;
      i64toi32_i32$0 = i64toi32_i32$2;
      i64toi32_i32$1 = $171$hi;
      i64toi32_i32$3 = $171;
      i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
      $7 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
      $7$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $9$hi;
      i64toi32_i32$0 = 0;
      i64toi32_i32$0 = __wasm_rotl_i64($9 | 0, i64toi32_i32$1 | 0, 16 | 0, i64toi32_i32$0 | 0) | 0;
      i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
      $174$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $8$hi;
      i64toi32_i32$1 = $174$hi;
      i64toi32_i32$4 = i64toi32_i32$0;
      i64toi32_i32$0 = $8$hi;
      i64toi32_i32$3 = $8;
      i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
      $8 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
      $8$hi = i64toi32_i32$0;
      i64toi32_i32$4 = 0;
      i64toi32_i32$4 = __wasm_rotl_i64($8 | 0, i64toi32_i32$0 | 0, 21 | 0, i64toi32_i32$4 | 0) | 0;
      i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
      $178 = i64toi32_i32$4;
      $178$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $8$hi;
      i64toi32_i32$0 = $10$hi;
      i64toi32_i32$4 = 0;
      i64toi32_i32$4 = __wasm_rotl_i64($10 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
      i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
      $181 = i64toi32_i32$4;
      $181$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $8$hi;
      i64toi32_i32$1 = $8;
      i64toi32_i32$4 = $181$hi;
      i64toi32_i32$3 = $181;
      i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
      i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
      if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
       i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
      }
      $10 = i64toi32_i32$5;
      $10$hi = i64toi32_i32$2;
      i64toi32_i32$2 = $178$hi;
      i64toi32_i32$0 = $178;
      i64toi32_i32$1 = $10$hi;
      i64toi32_i32$3 = i64toi32_i32$5;
      i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
      $9 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
      $9$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $12$hi;
      i64toi32_i32$0 = 0;
      i64toi32_i32$0 = __wasm_rotl_i64($12 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$0 | 0) | 0;
      i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
      $8 = i64toi32_i32$0;
      $8$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $10$hi;
      i64toi32_i32$1 = $11$hi;
      i64toi32_i32$1 = $10$hi;
      i64toi32_i32$2 = i64toi32_i32$3;
      i64toi32_i32$0 = $11$hi;
      i64toi32_i32$3 = $11;
      i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
      $10 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
      $10$hi = i64toi32_i32$0;
      $4 = $4 + 8 | 0;
      if ($4 >>> 0 < $2 >>> 0) {
       continue label$10
      }
      break label$10;
     };
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$2 = $0;
     HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] = $7;
     HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$0 = $10$hi;
     HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] = $10;
     HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$0 = $9$hi;
     HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] = $9;
     HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$0 = $8$hi;
     HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] = $8;
     HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] = i64toi32_i32$0;
    }
    $2 = 4;
    label$11 : {
     label$12 : {
      if ($5 >>> 0 >= 4 >>> 0) {
       break label$12
      }
      i64toi32_i32$0 = 0;
      $7 = 0;
      $7$hi = i64toi32_i32$0;
      $2 = 0;
      break label$11;
     }
     i64toi32_i32$1 = $1 + $4 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$2 = 0;
     $7 = i64toi32_i32$0;
     $7$hi = i64toi32_i32$2;
    }
    label$13 : {
     if (($2 | 1 | 0) >>> 0 >= $5 >>> 0) {
      break label$13
     }
     i64toi32_i32$1 = $1 + ($2 + $4 | 0) | 0;
     i64toi32_i32$2 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
     i64toi32_i32$0 = 0;
     $218$hi = i64toi32_i32$0;
     i64toi32_i32$0 = 0;
     $221$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $218$hi;
     i64toi32_i32$1 = i64toi32_i32$2;
     i64toi32_i32$2 = $221$hi;
     i64toi32_i32$3 = $2 << 3 | 0;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
      $80 = 0;
     } else {
      i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
      $80 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
     }
     $222$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$2 = $222$hi;
     i64toi32_i32$0 = $80;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
     $7 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
     $7$hi = i64toi32_i32$1;
     $2 = $2 | 2 | 0;
    }
    label$14 : {
     if ($2 >>> 0 >= $5 >>> 0) {
      break label$14
     }
     i64toi32_i32$2 = $1 + ($2 + $4 | 0) | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
     i64toi32_i32$0 = 0;
     $235$hi = i64toi32_i32$0;
     i64toi32_i32$0 = 0;
     $238$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $235$hi;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$1 = $238$hi;
     i64toi32_i32$3 = $2 << 3 | 0;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
      $81 = 0;
     } else {
      i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
      $81 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
     }
     $239$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$1 = $239$hi;
     i64toi32_i32$0 = $81;
     i64toi32_i32$2 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
     $7 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
     $7$hi = i64toi32_i32$2;
    }
    i64toi32_i32$2 = $7$hi;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 48 | 0) >> 2] = $7;
    HEAP32[(i64toi32_i32$0 + 52 | 0) >> 2] = i64toi32_i32$2;
    break label$1;
   }
   $5 = $3 + $2 | 0;
  }
  HEAP32[($0 + 60 | 0) >> 2] = $5;
 }
 
 function $cardano_serialization_lib__crypto__GenesisHash_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h220401e78fc09fba($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, i64toi32_i32$2 = 0, $6 = 0, $4 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $25 = 0, $26 = 0, $27 = 0, $28 = 0, $6$hi = 0, $5 = 0, $29 = 0, $7 = 0, $7$hi = 0, $8 = 0, $8$hi = 0, $30 = 0, $31 = 0, $32 = 0, $33 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___bytes__hc697ccccfa39fd82($2 + 48 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[($2 + 48 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     HEAP32[($2 + 24 | 0) >> 2] = HEAP32[($2 + 52 | 0) >> 2] | 0;
     $29 = HEAPU8[($2 + 57 | 0) >> 0] | 0 | ((HEAPU8[($2 + 58 | 0) >> 0] | 0) << 8 | 0) | 0;
     HEAP8[($2 + 29 | 0) >> 0] = $29;
     HEAP8[($2 + 30 | 0) >> 0] = $29 >>> 8 | 0;
     HEAP8[($2 + 28 | 0) >> 0] = HEAPU8[($2 + 56 | 0) >> 0] | 0;
     $1 = 11;
     HEAP8[($2 + 31 | 0) >> 0] = HEAPU8[(($2 + 48 | 0) + 11 | 0) >> 0] | 0;
     $3 = HEAP32[($2 + 60 | 0) >> 2] | 0;
     HEAP32[($2 + 32 | 0) >> 2] = $3;
     label$4 : {
      label$5 : {
       if (($3 | 0) != (28 | 0)) {
        break label$5
       }
       $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 | 0, $2 + 24 | 0 | 0);
       $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
       if ($1 >>> 0 > 27 >>> 0) {
        break label$4
       }
       core__slice__index__slice_end_index_len_fail__h192505a15ac4b345(28 | 0, $1 | 0, 1066892 | 0);
       abort();
      }
      i64toi32_i32$0 = 0;
      $6 = $3;
      $6$hi = i64toi32_i32$0;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 24 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 24 | 0 | 0);
      i64toi32_i32$0 = 0;
      $7 = 1;
      $7$hi = i64toi32_i32$0;
      i64toi32_i32$0 = 0;
      $8 = 28;
      $8$hi = i64toi32_i32$0;
      $3 = 1066390;
      $4 = 13;
      break label$2;
     }
     $3 = $2 + 14 | 0;
     $1 = HEAP32[$2 >> 2] | 0;
     HEAP8[$3 >> 0] = HEAPU8[($1 + 18 | 0) >> 0] | 0;
     HEAP32[($2 + 40 | 0) >> 2] = HEAPU8[$1 >> 0] | 0 | ((HEAPU8[($1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $15 = $1 + 3 | 0;
     $16 = HEAPU8[$15 >> 0] | 0 | ((HEAPU8[($15 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($15 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($15 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($2 + 43 | 0) >> 0] = $16;
     HEAP8[($2 + 44 | 0) >> 0] = $16 >>> 8 | 0;
     HEAP8[($2 + 45 | 0) >> 0] = $16 >>> 16 | 0;
     HEAP8[($2 + 46 | 0) >> 0] = $16 >>> 24 | 0;
     HEAP16[($2 + 12 | 0) >> 1] = HEAPU8[($1 + 16 | 0) >> 0] | 0 | ((HEAPU8[($1 + 17 | 0) >> 0] | 0) << 8 | 0) | 0;
     HEAP32[($2 + 16 | 0) >> 2] = HEAPU8[($1 + 8 | 0) >> 0] | 0 | ((HEAPU8[($1 + 9 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 10 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 11 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $17 = $1 + 11 | 0;
     $18 = HEAPU8[$17 >> 0] | 0 | ((HEAPU8[($17 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($17 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($17 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($2 + 19 | 0) >> 0] = $18;
     HEAP8[($2 + 20 | 0) >> 0] = $18 >>> 8 | 0;
     HEAP8[($2 + 21 | 0) >> 0] = $18 >>> 16 | 0;
     HEAP8[($2 + 22 | 0) >> 0] = $18 >>> 24 | 0;
     $4 = HEAPU8[($1 + 7 | 0) >> 0] | 0;
     $19 = HEAPU8[($2 + 43 | 0) >> 0] | 0 | ((HEAPU8[($2 + 44 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 45 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 46 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($2 + 52 | 0) >> 0] = $19;
     HEAP8[($2 + 53 | 0) >> 0] = $19 >>> 8 | 0;
     HEAP8[($2 + 54 | 0) >> 0] = $19 >>> 16 | 0;
     HEAP8[($2 + 55 | 0) >> 0] = $19 >>> 24 | 0;
     $20 = HEAP32[($2 + 40 | 0) >> 2] | 0;
     HEAP8[($2 + 49 | 0) >> 0] = $20;
     HEAP8[($2 + 50 | 0) >> 0] = $20 >>> 8 | 0;
     HEAP8[($2 + 51 | 0) >> 0] = $20 >>> 16 | 0;
     HEAP8[($2 + 52 | 0) >> 0] = $20 >>> 24 | 0;
     i64toi32_i32$2 = $1;
     i64toi32_i32$0 = HEAPU8[($1 + 19 | 0) >> 0] | 0 | ((HEAPU8[($1 + 20 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 21 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 22 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[($1 + 23 | 0) >> 0] | 0 | ((HEAPU8[($1 + 24 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 25 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 26 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $6 = i64toi32_i32$0;
     $6$hi = i64toi32_i32$1;
     $5 = HEAPU8[($1 + 27 | 0) >> 0] | 0;
     $1 = HEAPU8[($1 + 15 | 0) >> 0] | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 24 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 24 | 0 | 0);
     $21 = $0 + 4 | 0;
     $22 = HEAPU8[($2 + 52 | 0) >> 0] | 0 | ((HEAPU8[($2 + 53 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 54 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 55 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[$21 >> 0] = $22;
     HEAP8[($21 + 1 | 0) >> 0] = $22 >>> 8 | 0;
     HEAP8[($21 + 2 | 0) >> 0] = $22 >>> 16 | 0;
     HEAP8[($21 + 3 | 0) >> 0] = $22 >>> 24 | 0;
     $23 = HEAPU8[($2 + 49 | 0) >> 0] | 0 | ((HEAPU8[($2 + 50 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 51 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 52 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($0 + 1 | 0) >> 0] = $23;
     HEAP8[($0 + 2 | 0) >> 0] = $23 >>> 8 | 0;
     HEAP8[($0 + 3 | 0) >> 0] = $23 >>> 16 | 0;
     HEAP8[($0 + 4 | 0) >> 0] = $23 >>> 24 | 0;
     HEAP8[($0 + 8 | 0) >> 0] = $4;
     $24 = $0 + 9 | 0;
     $25 = HEAP32[($2 + 16 | 0) >> 2] | 0;
     HEAP8[$24 >> 0] = $25;
     HEAP8[($24 + 1 | 0) >> 0] = $25 >>> 8 | 0;
     HEAP8[($24 + 2 | 0) >> 0] = $25 >>> 16 | 0;
     HEAP8[($24 + 3 | 0) >> 0] = $25 >>> 24 | 0;
     $26 = $0 + 12 | 0;
     $27 = HEAPU8[($2 + 19 | 0) >> 0] | 0 | ((HEAPU8[($2 + 20 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 21 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 22 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[$26 >> 0] = $27;
     HEAP8[($26 + 1 | 0) >> 0] = $27 >>> 8 | 0;
     HEAP8[($26 + 2 | 0) >> 0] = $27 >>> 16 | 0;
     HEAP8[($26 + 3 | 0) >> 0] = $27 >>> 24 | 0;
     HEAP8[($0 + 16 | 0) >> 0] = $1;
     $30 = $0 + 17 | 0;
     $31 = HEAPU16[($2 + 12 | 0) >> 1] | 0;
     HEAP8[$30 >> 0] = $31;
     HEAP8[($30 + 1 | 0) >> 0] = $31 >>> 8 | 0;
     HEAP8[($0 + 19 | 0) >> 0] = HEAPU8[$3 >> 0] | 0;
     HEAP8[($0 + 28 | 0) >> 0] = $5;
     i64toi32_i32$0 = $0 + 20 | 0;
     $28 = $6;
     HEAP8[i64toi32_i32$0 >> 0] = $28;
     HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $28 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $28 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $28 >>> 24 | 0;
     HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
     HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
     $1 = 0;
     break label$1;
    }
    HEAP8[($2 + 14 | 0) >> 0] = HEAPU8[($2 + 59 | 0) >> 0] | 0;
    $1 = HEAPU8[($2 + 57 | 0) >> 0] | 0 | ((HEAPU8[($2 + 58 | 0) >> 0] | 0) << 8 | 0) | 0;
    HEAP16[($2 + 40 | 0) >> 1] = $1;
    HEAP16[($2 + 12 | 0) >> 1] = $1;
    $4 = HEAPU8[($2 + 56 | 0) >> 0] | 0;
    $3 = HEAP32[($2 + 60 | 0) >> 2] | 0;
    $1 = HEAP32[($2 + 64 | 0) >> 2] | 0;
    $5 = HEAP32[($2 + 68 | 0) >> 2] | 0;
    i64toi32_i32$2 = $2 + 72 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $8 = i64toi32_i32$1;
    $8$hi = i64toi32_i32$0;
    i64toi32_i32$2 = $2 + 80 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $7 = i64toi32_i32$0;
    $7$hi = i64toi32_i32$1;
    i64toi32_i32$2 = $2 + 88 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $6 = i64toi32_i32$1;
    $6$hi = i64toi32_i32$0;
   }
   HEAP8[(($2 + 48 | 0) + 8 | 0) >> 0] = $4;
   $32 = $2 + 57 | 0;
   $33 = HEAPU16[($2 + 12 | 0) >> 1] | 0;
   HEAP8[$32 >> 0] = $33;
   HEAP8[($32 + 1 | 0) >> 0] = $33 >>> 8 | 0;
   i64toi32_i32$0 = $6$hi;
   i64toi32_i32$1 = $2 + 88 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $6;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $7$hi;
   i64toi32_i32$1 = $2 + 80 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $7;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $8$hi;
   i64toi32_i32$1 = $2 + 72 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $8;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($2 + 68 | 0) >> 2] = $5;
   HEAP32[($2 + 64 | 0) >> 2] = $1;
   HEAP32[($2 + 60 | 0) >> 2] = $3;
   HEAP8[($2 + 48 | 0) >> 0] = 2;
   HEAP8[(($2 + 48 | 0) + 11 | 0) >> 0] = HEAPU8[(($2 + 12 | 0) + 2 | 0) >> 0] | 0;
   HEAP32[($2 + 96 | 0) >> 2] = 0;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 48 | 0 | 0, 1066908 | 0, 11 | 0);
   $1 = 1;
  }
  HEAP8[$0 >> 0] = $1;
  global$0 = $2 + 112 | 0;
 }
 
 function num_bigint__biguint__addition___impl_20core__ops__arith__Add__num_bigint__biguint__BigUint__20for_20num_bigint__biguint__BigUint___add__ha6a5672f04e3ed65($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$5 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $4 = 0, $10 = 0, $10$hi = 0, $7 = 0, $5 = 0, $3 = 0, $6 = 0, $9 = 0, $8 = 0, $52 = 0, $53 = 0, $29 = 0, $31 = 0, $31$hi = 0, $33 = 0, $33$hi = 0, $34$hi = 0, $36 = 0, $36$hi = 0, $59 = 0, $61 = 0, $61$hi = 0, $64 = 0, $64$hi = 0, $80 = 0, $82 = 0, $82$hi = 0, $84 = 0, $84$hi = 0, $85$hi = 0, $87 = 0, $87$hi = 0, $112 = 0, $114 = 0, $114$hi = 0, $117 = 0, $117$hi = 0, $148 = 0, $150 = 0, $150$hi = 0, $153 = 0, $153$hi = 0, $160 = 0, $171 = 0, $210 = 0;
  $3 = HEAP32[$2 >> 2] | 0;
  $4 = HEAP32[$1 >> 2] | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     $5 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     $6 = HEAP32[($2 + 8 | 0) >> 2] | 0;
     if ($5 >>> 0 < $6 >>> 0) {
      break label$3
     }
     if (!$6) {
      break label$1
     }
     $7 = $4 + ($6 << 2 | 0) | 0;
     i64toi32_i32$0 = 0;
     $10 = 0;
     $10$hi = i64toi32_i32$0;
     $2 = $6;
     label$4 : while (1) {
      $29 = $4;
      i64toi32_i32$0 = $10$hi;
      i64toi32_i32$2 = $10;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 255;
      i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
      $31 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
      $31$hi = i64toi32_i32$1;
      i64toi32_i32$0 = $4;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$2 = 0;
      $33 = i64toi32_i32$1;
      $33$hi = i64toi32_i32$2;
      i64toi32_i32$2 = $31$hi;
      i64toi32_i32$0 = $31;
      i64toi32_i32$1 = $33$hi;
      i64toi32_i32$3 = $33;
      i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
      i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
      if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
       i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
      }
      $34$hi = i64toi32_i32$5;
      i64toi32_i32$2 = $3;
      i64toi32_i32$5 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = 0;
      $36 = i64toi32_i32$5;
      $36$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $34$hi;
      i64toi32_i32$2 = i64toi32_i32$4;
      i64toi32_i32$5 = $36$hi;
      i64toi32_i32$3 = $36;
      i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
      i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
      if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
       i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
      }
      $10 = i64toi32_i32$1;
      $10$hi = i64toi32_i32$4;
      HEAP32[$29 >> 2] = i64toi32_i32$1;
      $4 = $4 + 4 | 0;
      $3 = $3 + 4 | 0;
      i64toi32_i32$0 = i64toi32_i32$1;
      i64toi32_i32$2 = 0;
      i64toi32_i32$3 = 32;
      i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$2 = 0;
       $52 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
      } else {
       i64toi32_i32$2 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
       $52 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$5 | 0) | 0;
      }
      $10 = $52;
      $10$hi = i64toi32_i32$2;
      $2 = $2 + -1 | 0;
      if ($2) {
       continue label$4
      }
      break label$4;
     };
     i64toi32_i32$2 = $10$hi;
     $2 = $10;
     if (!$2) {
      break label$1
     }
     $4 = ($5 << 2 | 0) - ($6 << 2 | 0) | 0;
     label$5 : while (1) {
      if (!$4) {
       break label$2
      }
      $59 = $7;
      i64toi32_i32$4 = $7;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$4 >> 2] | 0;
      i64toi32_i32$0 = 0;
      $61 = i64toi32_i32$2;
      $61$hi = i64toi32_i32$0;
      i64toi32_i32$0 = 0;
      i64toi32_i32$4 = $2;
      i64toi32_i32$2 = 0;
      i64toi32_i32$3 = 255;
      i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
      $64 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
      $64$hi = i64toi32_i32$2;
      i64toi32_i32$2 = $61$hi;
      i64toi32_i32$0 = $61;
      i64toi32_i32$4 = $64$hi;
      i64toi32_i32$3 = $64;
      i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
      i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
      if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
       i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
      }
      $10 = i64toi32_i32$5;
      $10$hi = i64toi32_i32$1;
      HEAP32[$59 >> 2] = i64toi32_i32$5;
      $4 = $4 + -4 | 0;
      $7 = $7 + 4 | 0;
      $2 = 1;
      i64toi32_i32$2 = i64toi32_i32$5;
      i64toi32_i32$0 = 1;
      i64toi32_i32$3 = 0;
      i64toi32_i32$0 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
      if (!!(i64toi32_i32$5 & i64toi32_i32$3 | 0 | i64toi32_i32$0 | 0)) {
       continue label$5
      }
      break label$1;
     };
    }
    $8 = 0;
    label$6 : {
     if (!$5) {
      break label$6
     }
     i64toi32_i32$0 = 0;
     $10 = 0;
     $10$hi = i64toi32_i32$0;
     $9 = $5;
     $2 = $4;
     $7 = $3;
     label$7 : while (1) {
      $80 = $2;
      i64toi32_i32$0 = $10$hi;
      i64toi32_i32$1 = $10;
      i64toi32_i32$2 = 0;
      i64toi32_i32$3 = 255;
      i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
      $82 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
      $82$hi = i64toi32_i32$2;
      i64toi32_i32$0 = $2;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$1 = 0;
      $84 = i64toi32_i32$2;
      $84$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $82$hi;
      i64toi32_i32$0 = $82;
      i64toi32_i32$2 = $84$hi;
      i64toi32_i32$3 = $84;
      i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
      i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
      if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
       i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
      }
      $85$hi = i64toi32_i32$5;
      i64toi32_i32$1 = $7;
      i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$0 = 0;
      $87 = i64toi32_i32$5;
      $87$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $85$hi;
      i64toi32_i32$1 = i64toi32_i32$4;
      i64toi32_i32$5 = $87$hi;
      i64toi32_i32$3 = $87;
      i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
      i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
      if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
       i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
      }
      $10 = i64toi32_i32$2;
      $10$hi = i64toi32_i32$4;
      HEAP32[$80 >> 2] = i64toi32_i32$2;
      $2 = $2 + 4 | 0;
      $7 = $7 + 4 | 0;
      i64toi32_i32$0 = i64toi32_i32$2;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 32;
      i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$1 = 0;
       $53 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
      } else {
       i64toi32_i32$1 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
       $53 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$5 | 0) | 0;
      }
      $10 = $53;
      $10$hi = i64toi32_i32$1;
      $9 = $9 + -1 | 0;
      if ($9) {
       continue label$7
      }
      break label$7;
     };
     i64toi32_i32$1 = $10$hi;
     $2 = $10;
     if (!$2) {
      break label$6
     }
     $9 = $4 + ($5 << 2 | 0) | 0;
     $4 = 0;
     label$8 : while (1) {
      label$9 : {
       if ($4) {
        break label$9
       }
       $8 = $2;
       break label$6;
      }
      $7 = $9 + $4 | 0;
      $112 = $7;
      i64toi32_i32$4 = $7;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$4 >> 2] | 0;
      i64toi32_i32$0 = 0;
      $114 = i64toi32_i32$1;
      $114$hi = i64toi32_i32$0;
      i64toi32_i32$0 = 0;
      i64toi32_i32$4 = $2;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 255;
      i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
      $117 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
      $117$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $114$hi;
      i64toi32_i32$0 = $114;
      i64toi32_i32$4 = $117$hi;
      i64toi32_i32$3 = $117;
      i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
      i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
      if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
       i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
      }
      $10 = i64toi32_i32$5;
      $10$hi = i64toi32_i32$2;
      HEAP32[$112 >> 2] = i64toi32_i32$5;
      $4 = $4 + 4 | 0;
      $2 = 1;
      i64toi32_i32$1 = i64toi32_i32$5;
      i64toi32_i32$0 = 1;
      i64toi32_i32$3 = 0;
      i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
      i64toi32_i32$2 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 0;
      if ((i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | 0) {
       continue label$8
      }
      break label$8;
     };
     $8 = 0;
    }
    $2 = $5 << 2 | 0;
    $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend__T_2ccore__slice__iter__Iter_T_____spec_extend__h5cdab7a667860bc4($1 | 0, $3 + $2 | 0 | 0, $3 + ($6 << 2 | 0) | 0 | 0);
    label$10 : {
     $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     if ($4 >>> 0 < $5 >>> 0) {
      break label$10
     }
     label$11 : {
      if (($4 | 0) == ($5 | 0)) {
       break label$11
      }
      $3 = HEAP32[$1 >> 2] | 0;
      $2 = $3 + $2 | 0;
      $148 = $2;
      i64toi32_i32$3 = $2;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$0 = 0;
      $150 = i64toi32_i32$2;
      $150$hi = i64toi32_i32$0;
      i64toi32_i32$0 = 0;
      i64toi32_i32$3 = $8;
      i64toi32_i32$2 = 0;
      i64toi32_i32$1 = 255;
      i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
      $153 = i64toi32_i32$3 & i64toi32_i32$1 | 0;
      $153$hi = i64toi32_i32$2;
      i64toi32_i32$2 = $150$hi;
      i64toi32_i32$0 = $150;
      i64toi32_i32$3 = $153$hi;
      i64toi32_i32$1 = $153;
      i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
      i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
      if (i64toi32_i32$4 >>> 0 < i64toi32_i32$1 >>> 0) {
       i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
      }
      $10 = i64toi32_i32$4;
      $10$hi = i64toi32_i32$5;
      HEAP32[$148 >> 2] = i64toi32_i32$4;
      i64toi32_i32$2 = i64toi32_i32$4;
      i64toi32_i32$0 = 1;
      i64toi32_i32$1 = 0;
      i64toi32_i32$0 = i64toi32_i32$5 & i64toi32_i32$0 | 0;
      if (!(i64toi32_i32$4 & i64toi32_i32$1 | 0 | i64toi32_i32$0 | 0)) {
       break label$1
      }
      $160 = $4 << 2 | 0;
      $4 = $5 << 2 | 0;
      $2 = ($160 - $4 | 0) + -4 | 0;
      $4 = ($4 + $3 | 0) + 4 | 0;
      label$12 : while (1) {
       label$13 : {
        if ($2) {
         break label$13
        }
        $2 = 1;
        break label$2;
       }
       $171 = $4;
       i64toi32_i32$5 = $4;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$5 >> 2] | 0;
       i64toi32_i32$2 = 0;
       i64toi32_i32$5 = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$1 = 1;
       i64toi32_i32$3 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
       i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
       if (i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0) {
        i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
       }
       $10 = i64toi32_i32$3;
       $10$hi = i64toi32_i32$4;
       HEAP32[$171 >> 2] = i64toi32_i32$3;
       $4 = $4 + 4 | 0;
       $2 = $2 + -4 | 0;
       i64toi32_i32$2 = i64toi32_i32$3;
       i64toi32_i32$5 = 1;
       i64toi32_i32$1 = 0;
       i64toi32_i32$5 = i64toi32_i32$4 & i64toi32_i32$5 | 0;
       if (!!(i64toi32_i32$2 & i64toi32_i32$1 | 0 | i64toi32_i32$5 | 0)) {
        continue label$12
       }
       break label$1;
      };
     }
     core__panicking__panic__h2fd385a887c8bf13(1076633 | 0, 35 | 0, 1076748 | 0);
     abort();
    }
    core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($5 | 0, $4 | 0, 1076872 | 0);
    abort();
   }
   $2 = $2 & 255 | 0;
   label$14 : {
    $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    if (($4 | 0) != (HEAP32[($1 + 4 | 0) >> 2] | 0 | 0)) {
     break label$14
    }
    alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h90c9768825cdae1b($1 | 0, $4 | 0, 1 | 0);
    $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   }
   HEAP32[((HEAP32[$1 >> 2] | 0) + ($4 << 2 | 0) | 0) >> 2] = $2;
   HEAP32[($1 + 8 | 0) >> 2] = (HEAP32[($1 + 8 | 0) >> 2] | 0) + 1 | 0;
  }
  i64toi32_i32$4 = $1;
  i64toi32_i32$5 = HEAP32[i64toi32_i32$4 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
  $210 = i64toi32_i32$5;
  i64toi32_i32$5 = $0;
  HEAP32[i64toi32_i32$5 >> 2] = $210;
  HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$5 + 8 | 0) >> 2] = HEAP32[(i64toi32_i32$4 + 8 | 0) >> 2] | 0;
 }
 
 function cardano_serialization_lib__tx_builder__TransactionBuilderConfigBuilder__build__he456ef6d8d7b112e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, $2 = 0, i64toi32_i32$1 = 0, $42 = 0, $43 = 0, $44 = 0, $45 = 0, $46 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $10 = 0, $10$hi = 0, $7 = 0, $8 = 0, $11 = 0, $11$hi = 0, $12 = 0, $12$hi = 0, $13 = 0, $13$hi = 0, $14 = 0, $14$hi = 0, $15 = 0, $15$hi = 0, $16 = 0, $16$hi = 0, $9 = 0, $17 = 0, $17$hi = 0, $18 = 0, $18$hi = 0, $19 = 0, $19$hi = 0, $20 = 0, $20$hi = 0, $21 = 0, $21$hi = 0, $22 = 0, $22$hi = 0, $23 = 0, $23$hi = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  i64toi32_i32$0 = 0;
  $10 = 1;
  $10$hi = i64toi32_i32$0;
  $3 = $1 + 64 | 0;
  $4 = $1 + 124 | 0;
  $5 = $1 + 116 | 0;
  $6 = $1 + 48 | 0;
  $7 = $1 + 32 | 0;
  $8 = $1 + 16 | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $11 = i64toi32_i32$0;
  $11$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 72 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 76 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    i64toi32_i32$3 = 1;
    if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
     break label$2
    }
    i64toi32_i32$2 = 0;
    $10 = 0;
    $10$hi = i64toi32_i32$2;
    break label$1;
   }
   i64toi32_i32$3 = $1 + 104 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $12 = i64toi32_i32$2;
   $12$hi = i64toi32_i32$0;
   i64toi32_i32$3 = $1 + 96 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $13 = i64toi32_i32$0;
   $13$hi = i64toi32_i32$2;
   i64toi32_i32$3 = $1 + 88 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $14 = i64toi32_i32$2;
   $14$hi = i64toi32_i32$0;
   i64toi32_i32$3 = $1 + 80 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $15 = i64toi32_i32$0;
   $15$hi = i64toi32_i32$2;
  }
  i64toi32_i32$3 = $3;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
  $16 = i64toi32_i32$2;
  $16$hi = i64toi32_i32$0;
  $9 = HEAP32[$4 >> 2] | 0;
  $5 = HEAP32[$5 >> 2] | 0;
  i64toi32_i32$3 = $6;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
  $17 = i64toi32_i32$0;
  $17$hi = i64toi32_i32$2;
  i64toi32_i32$3 = $7;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$2;
  $18$hi = i64toi32_i32$0;
  i64toi32_i32$3 = $8;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$0;
  $19$hi = i64toi32_i32$2;
  i64toi32_i32$3 = $1;
  i64toi32_i32$2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $20 = i64toi32_i32$2;
  $20$hi = i64toi32_i32$0;
  i64toi32_i32$3 = $1;
  i64toi32_i32$0 = HEAP32[($1 + 56 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[($1 + 60 | 0) >> 2] | 0;
  $21 = i64toi32_i32$0;
  $21$hi = i64toi32_i32$2;
  $4 = HEAP32[($1 + 120 | 0) >> 2] | 0;
  $3 = HEAP32[($1 + 112 | 0) >> 2] | 0;
  i64toi32_i32$3 = $1;
  i64toi32_i32$2 = HEAP32[($1 + 40 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 44 | 0) >> 2] | 0;
  $22 = i64toi32_i32$2;
  $22$hi = i64toi32_i32$0;
  i64toi32_i32$3 = $1;
  i64toi32_i32$0 = HEAP32[($1 + 24 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[($1 + 28 | 0) >> 2] | 0;
  $23 = i64toi32_i32$0;
  $23$hi = i64toi32_i32$2;
  $6 = HEAPU8[($1 + 128 | 0) >> 0] | 0;
  $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1064304 | 0, 29 | 0) | 0;
  label$3 : {
   label$4 : {
    label$5 : {
     label$6 : {
      label$7 : {
       label$8 : {
        i64toi32_i32$2 = $11$hi;
        if (!($11 | i64toi32_i32$2 | 0)) {
         break label$8
        }
        label$9 : {
         if ($1 >>> 0 < 36 >>> 0) {
          break label$9
         }
         wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($1 | 0);
        }
        $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1064333 | 0, 33 | 0) | 0;
        i64toi32_i32$2 = $23$hi;
        if (!($23 | i64toi32_i32$2 | 0)) {
         break label$7
        }
        label$10 : {
         if ($1 >>> 0 < 36 >>> 0) {
          break label$10
         }
         wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($1 | 0);
        }
        $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1064366 | 0, 32 | 0) | 0;
        i64toi32_i32$2 = $22$hi;
        if (!($22 | i64toi32_i32$2 | 0)) {
         break label$6
        }
        label$11 : {
         if ($1 >>> 0 < 36 >>> 0) {
          break label$11
         }
         wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($1 | 0);
        }
        $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1064398 | 0, 35 | 0) | 0;
        if (!$3) {
         break label$5
        }
        label$12 : {
         if ($1 >>> 0 < 36 >>> 0) {
          break label$12
         }
         wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($1 | 0);
        }
        $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1064433 | 0, 32 | 0) | 0;
        if (!$4) {
         break label$4
        }
        label$13 : {
         if ($1 >>> 0 < 36 >>> 0) {
          break label$13
         }
         wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($1 | 0);
        }
        $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1064465 | 0, 40 | 0) | 0;
        label$14 : {
         i64toi32_i32$2 = $21$hi;
         if (!($21 | i64toi32_i32$2 | 0)) {
          break label$14
         }
         label$15 : {
          if ($1 >>> 0 < 36 >>> 0) {
           break label$15
          }
          wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($1 | 0);
         }
         HEAP32[$0 >> 2] = 0;
         HEAP8[($0 + 96 | 0) >> 0] = $6;
         HEAP32[($0 + 92 | 0) >> 2] = $9;
         HEAP32[($0 + 88 | 0) >> 2] = $5;
         i64toi32_i32$2 = $12$hi;
         i64toi32_i32$0 = $0 + 80 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $12;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
         i64toi32_i32$2 = $13$hi;
         i64toi32_i32$0 = $0 + 72 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $13;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
         i64toi32_i32$2 = $14$hi;
         i64toi32_i32$0 = $0 + 64 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $14;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
         i64toi32_i32$2 = $15$hi;
         i64toi32_i32$0 = $0 + 56 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $15;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
         i64toi32_i32$2 = $10$hi;
         i64toi32_i32$0 = $0 + 48 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $10;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
         i64toi32_i32$2 = $16$hi;
         i64toi32_i32$0 = $0 + 40 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $16;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
         i64toi32_i32$2 = $17$hi;
         i64toi32_i32$0 = $0 + 32 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $17;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
         i64toi32_i32$2 = $18$hi;
         i64toi32_i32$0 = $0 + 24 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $18;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
         i64toi32_i32$2 = $19$hi;
         i64toi32_i32$0 = $0 + 16 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $19;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
         i64toi32_i32$2 = $20$hi;
         i64toi32_i32$0 = $0 + 8 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $20;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
         $42 = $0 + 97 | 0;
         $43 = HEAPU8[($2 + 9 | 0) >> 0] | 0 | ((HEAPU8[($2 + 10 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 11 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 12 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[$42 >> 0] = $43;
         HEAP8[($42 + 1 | 0) >> 0] = $43 >>> 8 | 0;
         HEAP8[($42 + 2 | 0) >> 0] = $43 >>> 16 | 0;
         HEAP8[($42 + 3 | 0) >> 0] = $43 >>> 24 | 0;
         $44 = $2 + 12 | 0;
         $45 = $0 + 100 | 0;
         $46 = HEAPU8[$44 >> 0] | 0 | ((HEAPU8[($44 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($44 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($44 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[$45 >> 0] = $46;
         HEAP8[($45 + 1 | 0) >> 0] = $46 >>> 8 | 0;
         HEAP8[($45 + 2 | 0) >> 0] = $46 >>> 16 | 0;
         HEAP8[($45 + 3 | 0) >> 0] = $46 >>> 24 | 0;
         break label$3;
        }
        $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($1 | 0) | 0;
        HEAP32[$0 >> 2] = 1;
        HEAP32[($0 + 4 | 0) >> 2] = $1;
        break label$3;
       }
       $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($1 | 0) | 0;
       HEAP32[$0 >> 2] = 1;
       HEAP32[($0 + 4 | 0) >> 2] = $1;
       break label$3;
      }
      $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($1 | 0) | 0;
      HEAP32[$0 >> 2] = 1;
      HEAP32[($0 + 4 | 0) >> 2] = $1;
      break label$3;
     }
     $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($1 | 0) | 0;
     HEAP32[$0 >> 2] = 1;
     HEAP32[($0 + 4 | 0) >> 2] = $1;
     break label$3;
    }
    $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($1 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    break label$3;
   }
   $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($1 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
  }
  global$0 = $2 + 16 | 0;
 }
 
 function cardano_serialization_lib__crypto__TransactionHash__from_bech32__h61a79be54ec7891b($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $5 = 0, $5$hi = 0, $17 = 0, $18 = 0, $19 = 0, $21 = 0, $4 = 0, $22 = 0, $6 = 0, $7 = 0, $20 = 0, $55 = 0, $6$hi = 0, $7$hi = 0, $198 = 0;
  $3 = global$0 - 160 | 0;
  global$0 = $3;
  bech32__decode__h25859b35256032dd($3 + 72 | 0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ((HEAP32[($3 + 72 | 0) >> 2] | 0 | 0) != (1 | 0)) {
        break label$5
       }
       i64toi32_i32$2 = $3;
       i64toi32_i32$0 = HEAP32[($3 + 76 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($3 + 80 | 0) >> 2] | 0;
       $20 = i64toi32_i32$0;
       i64toi32_i32$0 = $3;
       HEAP32[($3 + 40 | 0) >> 2] = $20;
       HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$0 = $3;
       i64toi32_i32$1 = 0;
       HEAP32[($3 + 108 | 0) >> 2] = 0;
       HEAP32[($3 + 112 | 0) >> 2] = i64toi32_i32$1;
       HEAP32[($3 + 104 | 0) >> 2] = HEAP32[(0 + 1066212 | 0) >> 2] | 0;
       core__fmt__Formatter__new__he219faf25326051b($3 + 120 | 0 | 0, $3 + 104 | 0 | 0, 1065900 | 0);
       if (!($bech32__Error_20as_20core__fmt__Display___fmt__hb94eedebff44411f($3 + 40 | 0 | 0, $3 + 120 | 0 | 0) | 0)) {
        break label$4
       }
       core__result__unwrap_failed__h27f43d993c3864a1(1065924 | 0, 55 | 0, $3 + 24 | 0 | 0, 1066104 | 0, 1066056 | 0);
       abort();
      }
      $4 = ($3 + 56 | 0) + 8 | 0;
      $1 = HEAP32[($3 + 96 | 0) >> 2] | 0;
      HEAP32[$4 >> 2] = $1;
      i64toi32_i32$2 = $3 + 88 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $5 = i64toi32_i32$1;
      $5$hi = i64toi32_i32$0;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 56 | 0) >> 2] = $5;
      HEAP32[($3 + 60 | 0) >> 2] = i64toi32_i32$0;
      $2 = HEAP32[($3 + 76 | 0) >> 2] | 0;
      i64toi32_i32$2 = ($3 + 72 | 0) + 8 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $55 = i64toi32_i32$0;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 28 | 0) >> 2] = $55;
      HEAP32[($3 + 32 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($3 + 24 | 0) >> 2] = $2;
      HEAP32[(($3 + 40 | 0) + 8 | 0) >> 2] = $1;
      i64toi32_i32$1 = $5$hi;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 40 | 0) >> 2] = $5;
      HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$1;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__heed2de4899f9d51c($3 + 16 | 0 | 0, $3 + 40 | 0 | 0);
      $alloc__vec__Vec_u8__20as_20bech32__FromBase32___from_base32__h6e67b5484009b518($3 + 120 | 0 | 0, HEAP32[($3 + 16 | 0) >> 2] | 0 | 0, HEAP32[($3 + 20 | 0) >> 2] | 0 | 0);
      if ((HEAP32[($3 + 120 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$2
      }
      $1 = HEAP32[($3 + 132 | 0) >> 2] | 0;
      HEAP32[$4 >> 2] = $1;
      i64toi32_i32$2 = $3;
      i64toi32_i32$1 = HEAP32[($3 + 124 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($3 + 128 | 0) >> 2] | 0;
      $5 = i64toi32_i32$1;
      $5$hi = i64toi32_i32$0;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 56 | 0) >> 2] = $5;
      HEAP32[($3 + 60 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[(($3 + 104 | 0) + 8 | 0) >> 2] = $1;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 104 | 0) >> 2] = $5;
      HEAP32[($3 + 108 | 0) >> 2] = i64toi32_i32$0;
      cardano_serialization_lib__crypto__TransactionHash__from_bytes__h235906d66c062ba5($3 + 120 | 0 | 0, $3 + 104 | 0 | 0);
      if ((HEAPU8[($3 + 120 | 0) >> 0] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      $22 = HEAPU8[($3 + 121 | 0) >> 0] | 0 | ((HEAPU8[($3 + 122 | 0) >> 0] | 0) << 8 | 0) | 0;
      HEAP8[($0 + 1 | 0) >> 0] = $22;
      HEAP8[($0 + 2 | 0) >> 0] = $22 >>> 8 | 0;
      HEAP8[($0 + 3 | 0) >> 0] = HEAPU8[($3 + 123 | 0) >> 0] | 0;
      i64toi32_i32$2 = ($3 + 120 | 0) + 16 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $5 = i64toi32_i32$0;
      $5$hi = i64toi32_i32$1;
      i64toi32_i32$0 = ($3 + 72 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $5;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = ($3 + 120 | 0) + 24 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $6 = i64toi32_i32$1;
      $6$hi = i64toi32_i32$0;
      i64toi32_i32$1 = ($3 + 72 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $6;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      $1 = HEAPU8[(($3 + 120 | 0) + 32 | 0) >> 0] | 0;
      HEAP8[(($3 + 72 | 0) + 24 | 0) >> 0] = $1;
      i64toi32_i32$2 = ($3 + 120 | 0) + 8 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $7 = i64toi32_i32$0;
      $7$hi = i64toi32_i32$1;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 72 | 0) >> 2] = $7;
      HEAP32[($3 + 76 | 0) >> 2] = i64toi32_i32$1;
      $2 = HEAP32[($3 + 124 | 0) >> 2] | 0;
      HEAP8[($0 + 32 | 0) >> 0] = $1;
      i64toi32_i32$1 = $6$hi;
      i64toi32_i32$0 = $0 + 24 | 0;
      $17 = $6;
      HEAP8[i64toi32_i32$0 >> 0] = $17;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $17 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $17 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $17 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      i64toi32_i32$1 = $5$hi;
      i64toi32_i32$0 = $0 + 16 | 0;
      HEAP8[i64toi32_i32$0 >> 0] = $5;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $5 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $5 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $5 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      i64toi32_i32$1 = $7$hi;
      i64toi32_i32$0 = $0 + 8 | 0;
      $18 = $7;
      HEAP8[i64toi32_i32$0 >> 0] = $18;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $18 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $18 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $18 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      $19 = $0 + 4 | 0;
      $21 = $2;
      HEAP8[$19 >> 0] = $21;
      HEAP8[($19 + 1 | 0) >> 0] = $21 >>> 8 | 0;
      HEAP8[($19 + 2 | 0) >> 0] = $21 >>> 16 | 0;
      HEAP8[($19 + 3 | 0) >> 0] = $21 >>> 24 | 0;
      HEAP8[$0 >> 0] = 0;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc91437b7d7fa2d3a($3 + 40 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h899e85abb4c3d85f($3 + 40 | 0 | 0);
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 24 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 24 | 0 | 0);
      break label$1;
     }
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $3 + 104 | 0 | 0);
     $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($3 + 8 | 0) >> 2] | 0 | 0, HEAP32[($3 + 12 | 0) >> 2] | 0 | 0) | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 104 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 104 | 0 | 0);
     $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($1 | 0) | 0;
     HEAP8[$0 >> 0] = 1;
     HEAP32[($0 + 4 | 0) >> 2] = $1;
     break label$1;
    }
    $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($3 + 124 | 0) >> 2] | 0 | 0) | 0;
    HEAP8[$0 >> 0] = 1;
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc91437b7d7fa2d3a($3 + 40 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h899e85abb4c3d85f($3 + 40 | 0 | 0);
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 24 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 24 | 0 | 0);
    break label$1;
   }
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[($3 + 124 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($3 + 128 | 0) >> 2] | 0;
   $198 = i64toi32_i32$1;
   i64toi32_i32$1 = $3;
   HEAP32[($3 + 72 | 0) >> 2] = $198;
   HEAP32[($3 + 76 | 0) >> 2] = i64toi32_i32$0;
   core__result__unwrap_failed__h27f43d993c3864a1(1066120 | 0, 43 | 0, $3 + 72 | 0 | 0, 1066164 | 0, 1066824 | 0);
   abort();
  }
  global$0 = $3 + 160 | 0;
 }
 
 function cardano_serialization_lib__crypto__AuxiliaryDataHash__from_bech32__h96d109034c059913($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $5 = 0, $5$hi = 0, $17 = 0, $18 = 0, $19 = 0, $21 = 0, $4 = 0, $22 = 0, $6 = 0, $7 = 0, $20 = 0, $55 = 0, $6$hi = 0, $7$hi = 0, $198 = 0;
  $3 = global$0 - 160 | 0;
  global$0 = $3;
  bech32__decode__h25859b35256032dd($3 + 72 | 0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ((HEAP32[($3 + 72 | 0) >> 2] | 0 | 0) != (1 | 0)) {
        break label$5
       }
       i64toi32_i32$2 = $3;
       i64toi32_i32$0 = HEAP32[($3 + 76 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($3 + 80 | 0) >> 2] | 0;
       $20 = i64toi32_i32$0;
       i64toi32_i32$0 = $3;
       HEAP32[($3 + 40 | 0) >> 2] = $20;
       HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$0 = $3;
       i64toi32_i32$1 = 0;
       HEAP32[($3 + 108 | 0) >> 2] = 0;
       HEAP32[($3 + 112 | 0) >> 2] = i64toi32_i32$1;
       HEAP32[($3 + 104 | 0) >> 2] = HEAP32[(0 + 1066212 | 0) >> 2] | 0;
       core__fmt__Formatter__new__he219faf25326051b($3 + 120 | 0 | 0, $3 + 104 | 0 | 0, 1065900 | 0);
       if (!($bech32__Error_20as_20core__fmt__Display___fmt__hb94eedebff44411f($3 + 40 | 0 | 0, $3 + 120 | 0 | 0) | 0)) {
        break label$4
       }
       core__result__unwrap_failed__h27f43d993c3864a1(1065924 | 0, 55 | 0, $3 + 24 | 0 | 0, 1066104 | 0, 1066056 | 0);
       abort();
      }
      $4 = ($3 + 56 | 0) + 8 | 0;
      $1 = HEAP32[($3 + 96 | 0) >> 2] | 0;
      HEAP32[$4 >> 2] = $1;
      i64toi32_i32$2 = $3 + 88 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $5 = i64toi32_i32$1;
      $5$hi = i64toi32_i32$0;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 56 | 0) >> 2] = $5;
      HEAP32[($3 + 60 | 0) >> 2] = i64toi32_i32$0;
      $2 = HEAP32[($3 + 76 | 0) >> 2] | 0;
      i64toi32_i32$2 = ($3 + 72 | 0) + 8 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $55 = i64toi32_i32$0;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 28 | 0) >> 2] = $55;
      HEAP32[($3 + 32 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($3 + 24 | 0) >> 2] = $2;
      HEAP32[(($3 + 40 | 0) + 8 | 0) >> 2] = $1;
      i64toi32_i32$1 = $5$hi;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 40 | 0) >> 2] = $5;
      HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$1;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__heed2de4899f9d51c($3 + 16 | 0 | 0, $3 + 40 | 0 | 0);
      $alloc__vec__Vec_u8__20as_20bech32__FromBase32___from_base32__h6e67b5484009b518($3 + 120 | 0 | 0, HEAP32[($3 + 16 | 0) >> 2] | 0 | 0, HEAP32[($3 + 20 | 0) >> 2] | 0 | 0);
      if ((HEAP32[($3 + 120 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$2
      }
      $1 = HEAP32[($3 + 132 | 0) >> 2] | 0;
      HEAP32[$4 >> 2] = $1;
      i64toi32_i32$2 = $3;
      i64toi32_i32$1 = HEAP32[($3 + 124 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($3 + 128 | 0) >> 2] | 0;
      $5 = i64toi32_i32$1;
      $5$hi = i64toi32_i32$0;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 56 | 0) >> 2] = $5;
      HEAP32[($3 + 60 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[(($3 + 104 | 0) + 8 | 0) >> 2] = $1;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 104 | 0) >> 2] = $5;
      HEAP32[($3 + 108 | 0) >> 2] = i64toi32_i32$0;
      cardano_serialization_lib__crypto__AuxiliaryDataHash__from_bytes__h3474e0570cc047c7($3 + 120 | 0 | 0, $3 + 104 | 0 | 0);
      if ((HEAPU8[($3 + 120 | 0) >> 0] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      $22 = HEAPU8[($3 + 121 | 0) >> 0] | 0 | ((HEAPU8[($3 + 122 | 0) >> 0] | 0) << 8 | 0) | 0;
      HEAP8[($0 + 1 | 0) >> 0] = $22;
      HEAP8[($0 + 2 | 0) >> 0] = $22 >>> 8 | 0;
      HEAP8[($0 + 3 | 0) >> 0] = HEAPU8[($3 + 123 | 0) >> 0] | 0;
      i64toi32_i32$2 = ($3 + 120 | 0) + 16 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $5 = i64toi32_i32$0;
      $5$hi = i64toi32_i32$1;
      i64toi32_i32$0 = ($3 + 72 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $5;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = ($3 + 120 | 0) + 24 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $6 = i64toi32_i32$1;
      $6$hi = i64toi32_i32$0;
      i64toi32_i32$1 = ($3 + 72 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $6;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      $1 = HEAPU8[(($3 + 120 | 0) + 32 | 0) >> 0] | 0;
      HEAP8[(($3 + 72 | 0) + 24 | 0) >> 0] = $1;
      i64toi32_i32$2 = ($3 + 120 | 0) + 8 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $7 = i64toi32_i32$0;
      $7$hi = i64toi32_i32$1;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 72 | 0) >> 2] = $7;
      HEAP32[($3 + 76 | 0) >> 2] = i64toi32_i32$1;
      $2 = HEAP32[($3 + 124 | 0) >> 2] | 0;
      HEAP8[($0 + 32 | 0) >> 0] = $1;
      i64toi32_i32$1 = $6$hi;
      i64toi32_i32$0 = $0 + 24 | 0;
      $17 = $6;
      HEAP8[i64toi32_i32$0 >> 0] = $17;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $17 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $17 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $17 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      i64toi32_i32$1 = $5$hi;
      i64toi32_i32$0 = $0 + 16 | 0;
      HEAP8[i64toi32_i32$0 >> 0] = $5;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $5 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $5 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $5 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      i64toi32_i32$1 = $7$hi;
      i64toi32_i32$0 = $0 + 8 | 0;
      $18 = $7;
      HEAP8[i64toi32_i32$0 >> 0] = $18;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $18 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $18 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $18 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      $19 = $0 + 4 | 0;
      $21 = $2;
      HEAP8[$19 >> 0] = $21;
      HEAP8[($19 + 1 | 0) >> 0] = $21 >>> 8 | 0;
      HEAP8[($19 + 2 | 0) >> 0] = $21 >>> 16 | 0;
      HEAP8[($19 + 3 | 0) >> 0] = $21 >>> 24 | 0;
      HEAP8[$0 >> 0] = 0;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc91437b7d7fa2d3a($3 + 40 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h899e85abb4c3d85f($3 + 40 | 0 | 0);
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 24 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 24 | 0 | 0);
      break label$1;
     }
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $3 + 104 | 0 | 0);
     $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($3 + 8 | 0) >> 2] | 0 | 0, HEAP32[($3 + 12 | 0) >> 2] | 0 | 0) | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 104 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 104 | 0 | 0);
     $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($1 | 0) | 0;
     HEAP8[$0 >> 0] = 1;
     HEAP32[($0 + 4 | 0) >> 2] = $1;
     break label$1;
    }
    $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($3 + 124 | 0) >> 2] | 0 | 0) | 0;
    HEAP8[$0 >> 0] = 1;
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc91437b7d7fa2d3a($3 + 40 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h899e85abb4c3d85f($3 + 40 | 0 | 0);
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 24 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 24 | 0 | 0);
    break label$1;
   }
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[($3 + 124 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($3 + 128 | 0) >> 2] | 0;
   $198 = i64toi32_i32$1;
   i64toi32_i32$1 = $3;
   HEAP32[($3 + 72 | 0) >> 2] = $198;
   HEAP32[($3 + 76 | 0) >> 2] = i64toi32_i32$0;
   core__result__unwrap_failed__h27f43d993c3864a1(1066120 | 0, 43 | 0, $3 + 72 | 0 | 0, 1066164 | 0, 1066920 | 0);
   abort();
  }
  global$0 = $3 + 160 | 0;
 }
 
 function cardano_serialization_lib__crypto__PoolMetadataHash__from_bech32__h09c287ec559a2479($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $5 = 0, $5$hi = 0, $17 = 0, $18 = 0, $19 = 0, $21 = 0, $4 = 0, $22 = 0, $6 = 0, $7 = 0, $20 = 0, $55 = 0, $6$hi = 0, $7$hi = 0, $198 = 0;
  $3 = global$0 - 160 | 0;
  global$0 = $3;
  bech32__decode__h25859b35256032dd($3 + 72 | 0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ((HEAP32[($3 + 72 | 0) >> 2] | 0 | 0) != (1 | 0)) {
        break label$5
       }
       i64toi32_i32$2 = $3;
       i64toi32_i32$0 = HEAP32[($3 + 76 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($3 + 80 | 0) >> 2] | 0;
       $20 = i64toi32_i32$0;
       i64toi32_i32$0 = $3;
       HEAP32[($3 + 40 | 0) >> 2] = $20;
       HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$0 = $3;
       i64toi32_i32$1 = 0;
       HEAP32[($3 + 108 | 0) >> 2] = 0;
       HEAP32[($3 + 112 | 0) >> 2] = i64toi32_i32$1;
       HEAP32[($3 + 104 | 0) >> 2] = HEAP32[(0 + 1066212 | 0) >> 2] | 0;
       core__fmt__Formatter__new__he219faf25326051b($3 + 120 | 0 | 0, $3 + 104 | 0 | 0, 1065900 | 0);
       if (!($bech32__Error_20as_20core__fmt__Display___fmt__hb94eedebff44411f($3 + 40 | 0 | 0, $3 + 120 | 0 | 0) | 0)) {
        break label$4
       }
       core__result__unwrap_failed__h27f43d993c3864a1(1065924 | 0, 55 | 0, $3 + 24 | 0 | 0, 1066104 | 0, 1066056 | 0);
       abort();
      }
      $4 = ($3 + 56 | 0) + 8 | 0;
      $1 = HEAP32[($3 + 96 | 0) >> 2] | 0;
      HEAP32[$4 >> 2] = $1;
      i64toi32_i32$2 = $3 + 88 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $5 = i64toi32_i32$1;
      $5$hi = i64toi32_i32$0;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 56 | 0) >> 2] = $5;
      HEAP32[($3 + 60 | 0) >> 2] = i64toi32_i32$0;
      $2 = HEAP32[($3 + 76 | 0) >> 2] | 0;
      i64toi32_i32$2 = ($3 + 72 | 0) + 8 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $55 = i64toi32_i32$0;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 28 | 0) >> 2] = $55;
      HEAP32[($3 + 32 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($3 + 24 | 0) >> 2] = $2;
      HEAP32[(($3 + 40 | 0) + 8 | 0) >> 2] = $1;
      i64toi32_i32$1 = $5$hi;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 40 | 0) >> 2] = $5;
      HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$1;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__heed2de4899f9d51c($3 + 16 | 0 | 0, $3 + 40 | 0 | 0);
      $alloc__vec__Vec_u8__20as_20bech32__FromBase32___from_base32__h6e67b5484009b518($3 + 120 | 0 | 0, HEAP32[($3 + 16 | 0) >> 2] | 0 | 0, HEAP32[($3 + 20 | 0) >> 2] | 0 | 0);
      if ((HEAP32[($3 + 120 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$2
      }
      $1 = HEAP32[($3 + 132 | 0) >> 2] | 0;
      HEAP32[$4 >> 2] = $1;
      i64toi32_i32$2 = $3;
      i64toi32_i32$1 = HEAP32[($3 + 124 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($3 + 128 | 0) >> 2] | 0;
      $5 = i64toi32_i32$1;
      $5$hi = i64toi32_i32$0;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 56 | 0) >> 2] = $5;
      HEAP32[($3 + 60 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[(($3 + 104 | 0) + 8 | 0) >> 2] = $1;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 104 | 0) >> 2] = $5;
      HEAP32[($3 + 108 | 0) >> 2] = i64toi32_i32$0;
      cardano_serialization_lib__crypto__PoolMetadataHash__from_bytes__hcdbbfaf467fb270a($3 + 120 | 0 | 0, $3 + 104 | 0 | 0);
      if ((HEAPU8[($3 + 120 | 0) >> 0] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      $22 = HEAPU8[($3 + 121 | 0) >> 0] | 0 | ((HEAPU8[($3 + 122 | 0) >> 0] | 0) << 8 | 0) | 0;
      HEAP8[($0 + 1 | 0) >> 0] = $22;
      HEAP8[($0 + 2 | 0) >> 0] = $22 >>> 8 | 0;
      HEAP8[($0 + 3 | 0) >> 0] = HEAPU8[($3 + 123 | 0) >> 0] | 0;
      i64toi32_i32$2 = ($3 + 120 | 0) + 16 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $5 = i64toi32_i32$0;
      $5$hi = i64toi32_i32$1;
      i64toi32_i32$0 = ($3 + 72 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $5;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = ($3 + 120 | 0) + 24 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $6 = i64toi32_i32$1;
      $6$hi = i64toi32_i32$0;
      i64toi32_i32$1 = ($3 + 72 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $6;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      $1 = HEAPU8[(($3 + 120 | 0) + 32 | 0) >> 0] | 0;
      HEAP8[(($3 + 72 | 0) + 24 | 0) >> 0] = $1;
      i64toi32_i32$2 = ($3 + 120 | 0) + 8 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $7 = i64toi32_i32$0;
      $7$hi = i64toi32_i32$1;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 72 | 0) >> 2] = $7;
      HEAP32[($3 + 76 | 0) >> 2] = i64toi32_i32$1;
      $2 = HEAP32[($3 + 124 | 0) >> 2] | 0;
      HEAP8[($0 + 32 | 0) >> 0] = $1;
      i64toi32_i32$1 = $6$hi;
      i64toi32_i32$0 = $0 + 24 | 0;
      $17 = $6;
      HEAP8[i64toi32_i32$0 >> 0] = $17;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $17 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $17 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $17 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      i64toi32_i32$1 = $5$hi;
      i64toi32_i32$0 = $0 + 16 | 0;
      HEAP8[i64toi32_i32$0 >> 0] = $5;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $5 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $5 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $5 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      i64toi32_i32$1 = $7$hi;
      i64toi32_i32$0 = $0 + 8 | 0;
      $18 = $7;
      HEAP8[i64toi32_i32$0 >> 0] = $18;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $18 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $18 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $18 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      $19 = $0 + 4 | 0;
      $21 = $2;
      HEAP8[$19 >> 0] = $21;
      HEAP8[($19 + 1 | 0) >> 0] = $21 >>> 8 | 0;
      HEAP8[($19 + 2 | 0) >> 0] = $21 >>> 16 | 0;
      HEAP8[($19 + 3 | 0) >> 0] = $21 >>> 24 | 0;
      HEAP8[$0 >> 0] = 0;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc91437b7d7fa2d3a($3 + 40 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h899e85abb4c3d85f($3 + 40 | 0 | 0);
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 24 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 24 | 0 | 0);
      break label$1;
     }
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $3 + 104 | 0 | 0);
     $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($3 + 8 | 0) >> 2] | 0 | 0, HEAP32[($3 + 12 | 0) >> 2] | 0 | 0) | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 104 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 104 | 0 | 0);
     $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($1 | 0) | 0;
     HEAP8[$0 >> 0] = 1;
     HEAP32[($0 + 4 | 0) >> 2] = $1;
     break label$1;
    }
    $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($3 + 124 | 0) >> 2] | 0 | 0) | 0;
    HEAP8[$0 >> 0] = 1;
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc91437b7d7fa2d3a($3 + 40 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h899e85abb4c3d85f($3 + 40 | 0 | 0);
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 24 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 24 | 0 | 0);
    break label$1;
   }
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[($3 + 124 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($3 + 128 | 0) >> 2] | 0;
   $198 = i64toi32_i32$1;
   i64toi32_i32$1 = $3;
   HEAP32[($3 + 72 | 0) >> 2] = $198;
   HEAP32[($3 + 76 | 0) >> 2] = i64toi32_i32$0;
   core__result__unwrap_failed__h27f43d993c3864a1(1066120 | 0, 43 | 0, $3 + 72 | 0 | 0, 1066164 | 0, 1066956 | 0);
   abort();
  }
  global$0 = $3 + 160 | 0;
 }
 
 function cardano_serialization_lib__crypto__VRFKeyHash__from_bech32__h81f854309374c8be($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $5 = 0, $5$hi = 0, $17 = 0, $18 = 0, $19 = 0, $21 = 0, $4 = 0, $22 = 0, $6 = 0, $7 = 0, $20 = 0, $55 = 0, $6$hi = 0, $7$hi = 0, $198 = 0;
  $3 = global$0 - 160 | 0;
  global$0 = $3;
  bech32__decode__h25859b35256032dd($3 + 72 | 0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ((HEAP32[($3 + 72 | 0) >> 2] | 0 | 0) != (1 | 0)) {
        break label$5
       }
       i64toi32_i32$2 = $3;
       i64toi32_i32$0 = HEAP32[($3 + 76 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($3 + 80 | 0) >> 2] | 0;
       $20 = i64toi32_i32$0;
       i64toi32_i32$0 = $3;
       HEAP32[($3 + 40 | 0) >> 2] = $20;
       HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$0 = $3;
       i64toi32_i32$1 = 0;
       HEAP32[($3 + 108 | 0) >> 2] = 0;
       HEAP32[($3 + 112 | 0) >> 2] = i64toi32_i32$1;
       HEAP32[($3 + 104 | 0) >> 2] = HEAP32[(0 + 1066212 | 0) >> 2] | 0;
       core__fmt__Formatter__new__he219faf25326051b($3 + 120 | 0 | 0, $3 + 104 | 0 | 0, 1065900 | 0);
       if (!($bech32__Error_20as_20core__fmt__Display___fmt__hb94eedebff44411f($3 + 40 | 0 | 0, $3 + 120 | 0 | 0) | 0)) {
        break label$4
       }
       core__result__unwrap_failed__h27f43d993c3864a1(1065924 | 0, 55 | 0, $3 + 24 | 0 | 0, 1066104 | 0, 1066056 | 0);
       abort();
      }
      $4 = ($3 + 56 | 0) + 8 | 0;
      $1 = HEAP32[($3 + 96 | 0) >> 2] | 0;
      HEAP32[$4 >> 2] = $1;
      i64toi32_i32$2 = $3 + 88 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $5 = i64toi32_i32$1;
      $5$hi = i64toi32_i32$0;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 56 | 0) >> 2] = $5;
      HEAP32[($3 + 60 | 0) >> 2] = i64toi32_i32$0;
      $2 = HEAP32[($3 + 76 | 0) >> 2] | 0;
      i64toi32_i32$2 = ($3 + 72 | 0) + 8 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $55 = i64toi32_i32$0;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 28 | 0) >> 2] = $55;
      HEAP32[($3 + 32 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($3 + 24 | 0) >> 2] = $2;
      HEAP32[(($3 + 40 | 0) + 8 | 0) >> 2] = $1;
      i64toi32_i32$1 = $5$hi;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 40 | 0) >> 2] = $5;
      HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$1;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__heed2de4899f9d51c($3 + 16 | 0 | 0, $3 + 40 | 0 | 0);
      $alloc__vec__Vec_u8__20as_20bech32__FromBase32___from_base32__h6e67b5484009b518($3 + 120 | 0 | 0, HEAP32[($3 + 16 | 0) >> 2] | 0 | 0, HEAP32[($3 + 20 | 0) >> 2] | 0 | 0);
      if ((HEAP32[($3 + 120 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$2
      }
      $1 = HEAP32[($3 + 132 | 0) >> 2] | 0;
      HEAP32[$4 >> 2] = $1;
      i64toi32_i32$2 = $3;
      i64toi32_i32$1 = HEAP32[($3 + 124 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($3 + 128 | 0) >> 2] | 0;
      $5 = i64toi32_i32$1;
      $5$hi = i64toi32_i32$0;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 56 | 0) >> 2] = $5;
      HEAP32[($3 + 60 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[(($3 + 104 | 0) + 8 | 0) >> 2] = $1;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 104 | 0) >> 2] = $5;
      HEAP32[($3 + 108 | 0) >> 2] = i64toi32_i32$0;
      cardano_serialization_lib__crypto__VRFKeyHash__from_bytes__h124511c7aa071f43($3 + 120 | 0 | 0, $3 + 104 | 0 | 0);
      if ((HEAPU8[($3 + 120 | 0) >> 0] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      $22 = HEAPU8[($3 + 121 | 0) >> 0] | 0 | ((HEAPU8[($3 + 122 | 0) >> 0] | 0) << 8 | 0) | 0;
      HEAP8[($0 + 1 | 0) >> 0] = $22;
      HEAP8[($0 + 2 | 0) >> 0] = $22 >>> 8 | 0;
      HEAP8[($0 + 3 | 0) >> 0] = HEAPU8[($3 + 123 | 0) >> 0] | 0;
      i64toi32_i32$2 = ($3 + 120 | 0) + 16 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $5 = i64toi32_i32$0;
      $5$hi = i64toi32_i32$1;
      i64toi32_i32$0 = ($3 + 72 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $5;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = ($3 + 120 | 0) + 24 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $6 = i64toi32_i32$1;
      $6$hi = i64toi32_i32$0;
      i64toi32_i32$1 = ($3 + 72 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $6;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      $1 = HEAPU8[(($3 + 120 | 0) + 32 | 0) >> 0] | 0;
      HEAP8[(($3 + 72 | 0) + 24 | 0) >> 0] = $1;
      i64toi32_i32$2 = ($3 + 120 | 0) + 8 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $7 = i64toi32_i32$0;
      $7$hi = i64toi32_i32$1;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 72 | 0) >> 2] = $7;
      HEAP32[($3 + 76 | 0) >> 2] = i64toi32_i32$1;
      $2 = HEAP32[($3 + 124 | 0) >> 2] | 0;
      HEAP8[($0 + 32 | 0) >> 0] = $1;
      i64toi32_i32$1 = $6$hi;
      i64toi32_i32$0 = $0 + 24 | 0;
      $17 = $6;
      HEAP8[i64toi32_i32$0 >> 0] = $17;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $17 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $17 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $17 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      i64toi32_i32$1 = $5$hi;
      i64toi32_i32$0 = $0 + 16 | 0;
      HEAP8[i64toi32_i32$0 >> 0] = $5;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $5 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $5 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $5 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      i64toi32_i32$1 = $7$hi;
      i64toi32_i32$0 = $0 + 8 | 0;
      $18 = $7;
      HEAP8[i64toi32_i32$0 >> 0] = $18;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $18 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $18 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $18 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      $19 = $0 + 4 | 0;
      $21 = $2;
      HEAP8[$19 >> 0] = $21;
      HEAP8[($19 + 1 | 0) >> 0] = $21 >>> 8 | 0;
      HEAP8[($19 + 2 | 0) >> 0] = $21 >>> 16 | 0;
      HEAP8[($19 + 3 | 0) >> 0] = $21 >>> 24 | 0;
      HEAP8[$0 >> 0] = 0;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc91437b7d7fa2d3a($3 + 40 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h899e85abb4c3d85f($3 + 40 | 0 | 0);
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 24 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 24 | 0 | 0);
      break label$1;
     }
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $3 + 104 | 0 | 0);
     $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($3 + 8 | 0) >> 2] | 0 | 0, HEAP32[($3 + 12 | 0) >> 2] | 0 | 0) | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 104 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 104 | 0 | 0);
     $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($1 | 0) | 0;
     HEAP8[$0 >> 0] = 1;
     HEAP32[($0 + 4 | 0) >> 2] = $1;
     break label$1;
    }
    $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($3 + 124 | 0) >> 2] | 0 | 0) | 0;
    HEAP8[$0 >> 0] = 1;
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc91437b7d7fa2d3a($3 + 40 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h899e85abb4c3d85f($3 + 40 | 0 | 0);
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 24 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 24 | 0 | 0);
    break label$1;
   }
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[($3 + 124 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($3 + 128 | 0) >> 2] | 0;
   $198 = i64toi32_i32$1;
   i64toi32_i32$1 = $3;
   HEAP32[($3 + 72 | 0) >> 2] = $198;
   HEAP32[($3 + 76 | 0) >> 2] = i64toi32_i32$0;
   core__result__unwrap_failed__h27f43d993c3864a1(1066120 | 0, 43 | 0, $3 + 72 | 0 | 0, 1066164 | 0, 1066988 | 0);
   abort();
  }
  global$0 = $3 + 160 | 0;
 }
 
 function cardano_serialization_lib__crypto__BlockHash__from_bech32__he52434727cf154a3($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $5 = 0, $5$hi = 0, $17 = 0, $18 = 0, $19 = 0, $21 = 0, $4 = 0, $22 = 0, $6 = 0, $7 = 0, $20 = 0, $55 = 0, $6$hi = 0, $7$hi = 0, $198 = 0;
  $3 = global$0 - 160 | 0;
  global$0 = $3;
  bech32__decode__h25859b35256032dd($3 + 72 | 0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ((HEAP32[($3 + 72 | 0) >> 2] | 0 | 0) != (1 | 0)) {
        break label$5
       }
       i64toi32_i32$2 = $3;
       i64toi32_i32$0 = HEAP32[($3 + 76 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($3 + 80 | 0) >> 2] | 0;
       $20 = i64toi32_i32$0;
       i64toi32_i32$0 = $3;
       HEAP32[($3 + 40 | 0) >> 2] = $20;
       HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$0 = $3;
       i64toi32_i32$1 = 0;
       HEAP32[($3 + 108 | 0) >> 2] = 0;
       HEAP32[($3 + 112 | 0) >> 2] = i64toi32_i32$1;
       HEAP32[($3 + 104 | 0) >> 2] = HEAP32[(0 + 1066212 | 0) >> 2] | 0;
       core__fmt__Formatter__new__he219faf25326051b($3 + 120 | 0 | 0, $3 + 104 | 0 | 0, 1065900 | 0);
       if (!($bech32__Error_20as_20core__fmt__Display___fmt__hb94eedebff44411f($3 + 40 | 0 | 0, $3 + 120 | 0 | 0) | 0)) {
        break label$4
       }
       core__result__unwrap_failed__h27f43d993c3864a1(1065924 | 0, 55 | 0, $3 + 24 | 0 | 0, 1066104 | 0, 1066056 | 0);
       abort();
      }
      $4 = ($3 + 56 | 0) + 8 | 0;
      $1 = HEAP32[($3 + 96 | 0) >> 2] | 0;
      HEAP32[$4 >> 2] = $1;
      i64toi32_i32$2 = $3 + 88 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $5 = i64toi32_i32$1;
      $5$hi = i64toi32_i32$0;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 56 | 0) >> 2] = $5;
      HEAP32[($3 + 60 | 0) >> 2] = i64toi32_i32$0;
      $2 = HEAP32[($3 + 76 | 0) >> 2] | 0;
      i64toi32_i32$2 = ($3 + 72 | 0) + 8 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $55 = i64toi32_i32$0;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 28 | 0) >> 2] = $55;
      HEAP32[($3 + 32 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($3 + 24 | 0) >> 2] = $2;
      HEAP32[(($3 + 40 | 0) + 8 | 0) >> 2] = $1;
      i64toi32_i32$1 = $5$hi;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 40 | 0) >> 2] = $5;
      HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$1;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__heed2de4899f9d51c($3 + 16 | 0 | 0, $3 + 40 | 0 | 0);
      $alloc__vec__Vec_u8__20as_20bech32__FromBase32___from_base32__h6e67b5484009b518($3 + 120 | 0 | 0, HEAP32[($3 + 16 | 0) >> 2] | 0 | 0, HEAP32[($3 + 20 | 0) >> 2] | 0 | 0);
      if ((HEAP32[($3 + 120 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$2
      }
      $1 = HEAP32[($3 + 132 | 0) >> 2] | 0;
      HEAP32[$4 >> 2] = $1;
      i64toi32_i32$2 = $3;
      i64toi32_i32$1 = HEAP32[($3 + 124 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($3 + 128 | 0) >> 2] | 0;
      $5 = i64toi32_i32$1;
      $5$hi = i64toi32_i32$0;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 56 | 0) >> 2] = $5;
      HEAP32[($3 + 60 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[(($3 + 104 | 0) + 8 | 0) >> 2] = $1;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 104 | 0) >> 2] = $5;
      HEAP32[($3 + 108 | 0) >> 2] = i64toi32_i32$0;
      cardano_serialization_lib__crypto__BlockHash__from_bytes__ha6cff5ff44ff1071($3 + 120 | 0 | 0, $3 + 104 | 0 | 0);
      if ((HEAPU8[($3 + 120 | 0) >> 0] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      $22 = HEAPU8[($3 + 121 | 0) >> 0] | 0 | ((HEAPU8[($3 + 122 | 0) >> 0] | 0) << 8 | 0) | 0;
      HEAP8[($0 + 1 | 0) >> 0] = $22;
      HEAP8[($0 + 2 | 0) >> 0] = $22 >>> 8 | 0;
      HEAP8[($0 + 3 | 0) >> 0] = HEAPU8[($3 + 123 | 0) >> 0] | 0;
      i64toi32_i32$2 = ($3 + 120 | 0) + 16 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $5 = i64toi32_i32$0;
      $5$hi = i64toi32_i32$1;
      i64toi32_i32$0 = ($3 + 72 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $5;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = ($3 + 120 | 0) + 24 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $6 = i64toi32_i32$1;
      $6$hi = i64toi32_i32$0;
      i64toi32_i32$1 = ($3 + 72 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $6;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      $1 = HEAPU8[(($3 + 120 | 0) + 32 | 0) >> 0] | 0;
      HEAP8[(($3 + 72 | 0) + 24 | 0) >> 0] = $1;
      i64toi32_i32$2 = ($3 + 120 | 0) + 8 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $7 = i64toi32_i32$0;
      $7$hi = i64toi32_i32$1;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 72 | 0) >> 2] = $7;
      HEAP32[($3 + 76 | 0) >> 2] = i64toi32_i32$1;
      $2 = HEAP32[($3 + 124 | 0) >> 2] | 0;
      HEAP8[($0 + 32 | 0) >> 0] = $1;
      i64toi32_i32$1 = $6$hi;
      i64toi32_i32$0 = $0 + 24 | 0;
      $17 = $6;
      HEAP8[i64toi32_i32$0 >> 0] = $17;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $17 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $17 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $17 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      i64toi32_i32$1 = $5$hi;
      i64toi32_i32$0 = $0 + 16 | 0;
      HEAP8[i64toi32_i32$0 >> 0] = $5;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $5 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $5 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $5 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      i64toi32_i32$1 = $7$hi;
      i64toi32_i32$0 = $0 + 8 | 0;
      $18 = $7;
      HEAP8[i64toi32_i32$0 >> 0] = $18;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $18 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $18 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $18 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      $19 = $0 + 4 | 0;
      $21 = $2;
      HEAP8[$19 >> 0] = $21;
      HEAP8[($19 + 1 | 0) >> 0] = $21 >>> 8 | 0;
      HEAP8[($19 + 2 | 0) >> 0] = $21 >>> 16 | 0;
      HEAP8[($19 + 3 | 0) >> 0] = $21 >>> 24 | 0;
      HEAP8[$0 >> 0] = 0;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc91437b7d7fa2d3a($3 + 40 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h899e85abb4c3d85f($3 + 40 | 0 | 0);
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 24 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 24 | 0 | 0);
      break label$1;
     }
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $3 + 104 | 0 | 0);
     $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($3 + 8 | 0) >> 2] | 0 | 0, HEAP32[($3 + 12 | 0) >> 2] | 0 | 0) | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 104 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 104 | 0 | 0);
     $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($1 | 0) | 0;
     HEAP8[$0 >> 0] = 1;
     HEAP32[($0 + 4 | 0) >> 2] = $1;
     break label$1;
    }
    $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($3 + 124 | 0) >> 2] | 0 | 0) | 0;
    HEAP8[$0 >> 0] = 1;
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc91437b7d7fa2d3a($3 + 40 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h899e85abb4c3d85f($3 + 40 | 0 | 0);
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 24 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 24 | 0 | 0);
    break label$1;
   }
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[($3 + 124 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($3 + 128 | 0) >> 2] | 0;
   $198 = i64toi32_i32$1;
   i64toi32_i32$1 = $3;
   HEAP32[($3 + 72 | 0) >> 2] = $198;
   HEAP32[($3 + 76 | 0) >> 2] = i64toi32_i32$0;
   core__result__unwrap_failed__h27f43d993c3864a1(1066120 | 0, 43 | 0, $3 + 72 | 0 | 0, 1066164 | 0, 1067016 | 0);
   abort();
  }
  global$0 = $3 + 160 | 0;
 }
 
 function cardano_serialization_lib__crypto__DataHash__from_bech32__h3c968bd64fb7d698($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $5 = 0, $5$hi = 0, $17 = 0, $18 = 0, $19 = 0, $21 = 0, $4 = 0, $22 = 0, $6 = 0, $7 = 0, $20 = 0, $55 = 0, $6$hi = 0, $7$hi = 0, $198 = 0;
  $3 = global$0 - 160 | 0;
  global$0 = $3;
  bech32__decode__h25859b35256032dd($3 + 72 | 0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ((HEAP32[($3 + 72 | 0) >> 2] | 0 | 0) != (1 | 0)) {
        break label$5
       }
       i64toi32_i32$2 = $3;
       i64toi32_i32$0 = HEAP32[($3 + 76 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($3 + 80 | 0) >> 2] | 0;
       $20 = i64toi32_i32$0;
       i64toi32_i32$0 = $3;
       HEAP32[($3 + 40 | 0) >> 2] = $20;
       HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$0 = $3;
       i64toi32_i32$1 = 0;
       HEAP32[($3 + 108 | 0) >> 2] = 0;
       HEAP32[($3 + 112 | 0) >> 2] = i64toi32_i32$1;
       HEAP32[($3 + 104 | 0) >> 2] = HEAP32[(0 + 1066212 | 0) >> 2] | 0;
       core__fmt__Formatter__new__he219faf25326051b($3 + 120 | 0 | 0, $3 + 104 | 0 | 0, 1065900 | 0);
       if (!($bech32__Error_20as_20core__fmt__Display___fmt__hb94eedebff44411f($3 + 40 | 0 | 0, $3 + 120 | 0 | 0) | 0)) {
        break label$4
       }
       core__result__unwrap_failed__h27f43d993c3864a1(1065924 | 0, 55 | 0, $3 + 24 | 0 | 0, 1066104 | 0, 1066056 | 0);
       abort();
      }
      $4 = ($3 + 56 | 0) + 8 | 0;
      $1 = HEAP32[($3 + 96 | 0) >> 2] | 0;
      HEAP32[$4 >> 2] = $1;
      i64toi32_i32$2 = $3 + 88 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $5 = i64toi32_i32$1;
      $5$hi = i64toi32_i32$0;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 56 | 0) >> 2] = $5;
      HEAP32[($3 + 60 | 0) >> 2] = i64toi32_i32$0;
      $2 = HEAP32[($3 + 76 | 0) >> 2] | 0;
      i64toi32_i32$2 = ($3 + 72 | 0) + 8 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $55 = i64toi32_i32$0;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 28 | 0) >> 2] = $55;
      HEAP32[($3 + 32 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($3 + 24 | 0) >> 2] = $2;
      HEAP32[(($3 + 40 | 0) + 8 | 0) >> 2] = $1;
      i64toi32_i32$1 = $5$hi;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 40 | 0) >> 2] = $5;
      HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$1;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__heed2de4899f9d51c($3 + 16 | 0 | 0, $3 + 40 | 0 | 0);
      $alloc__vec__Vec_u8__20as_20bech32__FromBase32___from_base32__h6e67b5484009b518($3 + 120 | 0 | 0, HEAP32[($3 + 16 | 0) >> 2] | 0 | 0, HEAP32[($3 + 20 | 0) >> 2] | 0 | 0);
      if ((HEAP32[($3 + 120 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$2
      }
      $1 = HEAP32[($3 + 132 | 0) >> 2] | 0;
      HEAP32[$4 >> 2] = $1;
      i64toi32_i32$2 = $3;
      i64toi32_i32$1 = HEAP32[($3 + 124 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($3 + 128 | 0) >> 2] | 0;
      $5 = i64toi32_i32$1;
      $5$hi = i64toi32_i32$0;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 56 | 0) >> 2] = $5;
      HEAP32[($3 + 60 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[(($3 + 104 | 0) + 8 | 0) >> 2] = $1;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 104 | 0) >> 2] = $5;
      HEAP32[($3 + 108 | 0) >> 2] = i64toi32_i32$0;
      cardano_serialization_lib__crypto__DataHash__from_bytes__h13af91f9785cf2d4($3 + 120 | 0 | 0, $3 + 104 | 0 | 0);
      if ((HEAPU8[($3 + 120 | 0) >> 0] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      $22 = HEAPU8[($3 + 121 | 0) >> 0] | 0 | ((HEAPU8[($3 + 122 | 0) >> 0] | 0) << 8 | 0) | 0;
      HEAP8[($0 + 1 | 0) >> 0] = $22;
      HEAP8[($0 + 2 | 0) >> 0] = $22 >>> 8 | 0;
      HEAP8[($0 + 3 | 0) >> 0] = HEAPU8[($3 + 123 | 0) >> 0] | 0;
      i64toi32_i32$2 = ($3 + 120 | 0) + 16 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $5 = i64toi32_i32$0;
      $5$hi = i64toi32_i32$1;
      i64toi32_i32$0 = ($3 + 72 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $5;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = ($3 + 120 | 0) + 24 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $6 = i64toi32_i32$1;
      $6$hi = i64toi32_i32$0;
      i64toi32_i32$1 = ($3 + 72 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $6;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      $1 = HEAPU8[(($3 + 120 | 0) + 32 | 0) >> 0] | 0;
      HEAP8[(($3 + 72 | 0) + 24 | 0) >> 0] = $1;
      i64toi32_i32$2 = ($3 + 120 | 0) + 8 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $7 = i64toi32_i32$0;
      $7$hi = i64toi32_i32$1;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 72 | 0) >> 2] = $7;
      HEAP32[($3 + 76 | 0) >> 2] = i64toi32_i32$1;
      $2 = HEAP32[($3 + 124 | 0) >> 2] | 0;
      HEAP8[($0 + 32 | 0) >> 0] = $1;
      i64toi32_i32$1 = $6$hi;
      i64toi32_i32$0 = $0 + 24 | 0;
      $17 = $6;
      HEAP8[i64toi32_i32$0 >> 0] = $17;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $17 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $17 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $17 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      i64toi32_i32$1 = $5$hi;
      i64toi32_i32$0 = $0 + 16 | 0;
      HEAP8[i64toi32_i32$0 >> 0] = $5;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $5 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $5 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $5 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      i64toi32_i32$1 = $7$hi;
      i64toi32_i32$0 = $0 + 8 | 0;
      $18 = $7;
      HEAP8[i64toi32_i32$0 >> 0] = $18;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $18 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $18 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $18 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      $19 = $0 + 4 | 0;
      $21 = $2;
      HEAP8[$19 >> 0] = $21;
      HEAP8[($19 + 1 | 0) >> 0] = $21 >>> 8 | 0;
      HEAP8[($19 + 2 | 0) >> 0] = $21 >>> 16 | 0;
      HEAP8[($19 + 3 | 0) >> 0] = $21 >>> 24 | 0;
      HEAP8[$0 >> 0] = 0;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc91437b7d7fa2d3a($3 + 40 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h899e85abb4c3d85f($3 + 40 | 0 | 0);
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 24 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 24 | 0 | 0);
      break label$1;
     }
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $3 + 104 | 0 | 0);
     $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($3 + 8 | 0) >> 2] | 0 | 0, HEAP32[($3 + 12 | 0) >> 2] | 0 | 0) | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 104 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 104 | 0 | 0);
     $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($1 | 0) | 0;
     HEAP8[$0 >> 0] = 1;
     HEAP32[($0 + 4 | 0) >> 2] = $1;
     break label$1;
    }
    $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($3 + 124 | 0) >> 2] | 0 | 0) | 0;
    HEAP8[$0 >> 0] = 1;
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc91437b7d7fa2d3a($3 + 40 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h899e85abb4c3d85f($3 + 40 | 0 | 0);
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 24 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 24 | 0 | 0);
    break label$1;
   }
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[($3 + 124 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($3 + 128 | 0) >> 2] | 0;
   $198 = i64toi32_i32$1;
   i64toi32_i32$1 = $3;
   HEAP32[($3 + 72 | 0) >> 2] = $198;
   HEAP32[($3 + 76 | 0) >> 2] = i64toi32_i32$0;
   core__result__unwrap_failed__h27f43d993c3864a1(1066120 | 0, 43 | 0, $3 + 72 | 0 | 0, 1066164 | 0, 1067052 | 0);
   abort();
  }
  global$0 = $3 + 160 | 0;
 }
 
 function cardano_serialization_lib__crypto__ScriptDataHash__from_bech32__hf10a40565f031ab7($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $5 = 0, $5$hi = 0, $17 = 0, $18 = 0, $19 = 0, $21 = 0, $4 = 0, $22 = 0, $6 = 0, $7 = 0, $20 = 0, $55 = 0, $6$hi = 0, $7$hi = 0, $198 = 0;
  $3 = global$0 - 160 | 0;
  global$0 = $3;
  bech32__decode__h25859b35256032dd($3 + 72 | 0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ((HEAP32[($3 + 72 | 0) >> 2] | 0 | 0) != (1 | 0)) {
        break label$5
       }
       i64toi32_i32$2 = $3;
       i64toi32_i32$0 = HEAP32[($3 + 76 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($3 + 80 | 0) >> 2] | 0;
       $20 = i64toi32_i32$0;
       i64toi32_i32$0 = $3;
       HEAP32[($3 + 40 | 0) >> 2] = $20;
       HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$0 = $3;
       i64toi32_i32$1 = 0;
       HEAP32[($3 + 108 | 0) >> 2] = 0;
       HEAP32[($3 + 112 | 0) >> 2] = i64toi32_i32$1;
       HEAP32[($3 + 104 | 0) >> 2] = HEAP32[(0 + 1066212 | 0) >> 2] | 0;
       core__fmt__Formatter__new__he219faf25326051b($3 + 120 | 0 | 0, $3 + 104 | 0 | 0, 1065900 | 0);
       if (!($bech32__Error_20as_20core__fmt__Display___fmt__hb94eedebff44411f($3 + 40 | 0 | 0, $3 + 120 | 0 | 0) | 0)) {
        break label$4
       }
       core__result__unwrap_failed__h27f43d993c3864a1(1065924 | 0, 55 | 0, $3 + 24 | 0 | 0, 1066104 | 0, 1066056 | 0);
       abort();
      }
      $4 = ($3 + 56 | 0) + 8 | 0;
      $1 = HEAP32[($3 + 96 | 0) >> 2] | 0;
      HEAP32[$4 >> 2] = $1;
      i64toi32_i32$2 = $3 + 88 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $5 = i64toi32_i32$1;
      $5$hi = i64toi32_i32$0;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 56 | 0) >> 2] = $5;
      HEAP32[($3 + 60 | 0) >> 2] = i64toi32_i32$0;
      $2 = HEAP32[($3 + 76 | 0) >> 2] | 0;
      i64toi32_i32$2 = ($3 + 72 | 0) + 8 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $55 = i64toi32_i32$0;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 28 | 0) >> 2] = $55;
      HEAP32[($3 + 32 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($3 + 24 | 0) >> 2] = $2;
      HEAP32[(($3 + 40 | 0) + 8 | 0) >> 2] = $1;
      i64toi32_i32$1 = $5$hi;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 40 | 0) >> 2] = $5;
      HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$1;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__heed2de4899f9d51c($3 + 16 | 0 | 0, $3 + 40 | 0 | 0);
      $alloc__vec__Vec_u8__20as_20bech32__FromBase32___from_base32__h6e67b5484009b518($3 + 120 | 0 | 0, HEAP32[($3 + 16 | 0) >> 2] | 0 | 0, HEAP32[($3 + 20 | 0) >> 2] | 0 | 0);
      if ((HEAP32[($3 + 120 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$2
      }
      $1 = HEAP32[($3 + 132 | 0) >> 2] | 0;
      HEAP32[$4 >> 2] = $1;
      i64toi32_i32$2 = $3;
      i64toi32_i32$1 = HEAP32[($3 + 124 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($3 + 128 | 0) >> 2] | 0;
      $5 = i64toi32_i32$1;
      $5$hi = i64toi32_i32$0;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 56 | 0) >> 2] = $5;
      HEAP32[($3 + 60 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[(($3 + 104 | 0) + 8 | 0) >> 2] = $1;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 104 | 0) >> 2] = $5;
      HEAP32[($3 + 108 | 0) >> 2] = i64toi32_i32$0;
      cardano_serialization_lib__crypto__ScriptDataHash__from_bytes__hfbd006c5cd3f689b($3 + 120 | 0 | 0, $3 + 104 | 0 | 0);
      if ((HEAPU8[($3 + 120 | 0) >> 0] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      $22 = HEAPU8[($3 + 121 | 0) >> 0] | 0 | ((HEAPU8[($3 + 122 | 0) >> 0] | 0) << 8 | 0) | 0;
      HEAP8[($0 + 1 | 0) >> 0] = $22;
      HEAP8[($0 + 2 | 0) >> 0] = $22 >>> 8 | 0;
      HEAP8[($0 + 3 | 0) >> 0] = HEAPU8[($3 + 123 | 0) >> 0] | 0;
      i64toi32_i32$2 = ($3 + 120 | 0) + 16 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $5 = i64toi32_i32$0;
      $5$hi = i64toi32_i32$1;
      i64toi32_i32$0 = ($3 + 72 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $5;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = ($3 + 120 | 0) + 24 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $6 = i64toi32_i32$1;
      $6$hi = i64toi32_i32$0;
      i64toi32_i32$1 = ($3 + 72 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $6;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      $1 = HEAPU8[(($3 + 120 | 0) + 32 | 0) >> 0] | 0;
      HEAP8[(($3 + 72 | 0) + 24 | 0) >> 0] = $1;
      i64toi32_i32$2 = ($3 + 120 | 0) + 8 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $7 = i64toi32_i32$0;
      $7$hi = i64toi32_i32$1;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 72 | 0) >> 2] = $7;
      HEAP32[($3 + 76 | 0) >> 2] = i64toi32_i32$1;
      $2 = HEAP32[($3 + 124 | 0) >> 2] | 0;
      HEAP8[($0 + 32 | 0) >> 0] = $1;
      i64toi32_i32$1 = $6$hi;
      i64toi32_i32$0 = $0 + 24 | 0;
      $17 = $6;
      HEAP8[i64toi32_i32$0 >> 0] = $17;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $17 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $17 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $17 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      i64toi32_i32$1 = $5$hi;
      i64toi32_i32$0 = $0 + 16 | 0;
      HEAP8[i64toi32_i32$0 >> 0] = $5;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $5 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $5 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $5 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      i64toi32_i32$1 = $7$hi;
      i64toi32_i32$0 = $0 + 8 | 0;
      $18 = $7;
      HEAP8[i64toi32_i32$0 >> 0] = $18;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $18 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $18 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $18 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      $19 = $0 + 4 | 0;
      $21 = $2;
      HEAP8[$19 >> 0] = $21;
      HEAP8[($19 + 1 | 0) >> 0] = $21 >>> 8 | 0;
      HEAP8[($19 + 2 | 0) >> 0] = $21 >>> 16 | 0;
      HEAP8[($19 + 3 | 0) >> 0] = $21 >>> 24 | 0;
      HEAP8[$0 >> 0] = 0;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc91437b7d7fa2d3a($3 + 40 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h899e85abb4c3d85f($3 + 40 | 0 | 0);
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 24 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 24 | 0 | 0);
      break label$1;
     }
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $3 + 104 | 0 | 0);
     $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($3 + 8 | 0) >> 2] | 0 | 0, HEAP32[($3 + 12 | 0) >> 2] | 0 | 0) | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 104 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 104 | 0 | 0);
     $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($1 | 0) | 0;
     HEAP8[$0 >> 0] = 1;
     HEAP32[($0 + 4 | 0) >> 2] = $1;
     break label$1;
    }
    $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($3 + 124 | 0) >> 2] | 0 | 0) | 0;
    HEAP8[$0 >> 0] = 1;
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc91437b7d7fa2d3a($3 + 40 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h899e85abb4c3d85f($3 + 40 | 0 | 0);
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 24 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 24 | 0 | 0);
    break label$1;
   }
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[($3 + 124 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($3 + 128 | 0) >> 2] | 0;
   $198 = i64toi32_i32$1;
   i64toi32_i32$1 = $3;
   HEAP32[($3 + 72 | 0) >> 2] = $198;
   HEAP32[($3 + 76 | 0) >> 2] = i64toi32_i32$0;
   core__result__unwrap_failed__h27f43d993c3864a1(1066120 | 0, 43 | 0, $3 + 72 | 0 | 0, 1066164 | 0, 1067068 | 0);
   abort();
  }
  global$0 = $3 + 160 | 0;
 }
 
 function cardano_serialization_lib__crypto__VRFVKey__from_bech32__h0908331f30976677($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $5 = 0, $5$hi = 0, $17 = 0, $18 = 0, $19 = 0, $21 = 0, $4 = 0, $22 = 0, $6 = 0, $7 = 0, $20 = 0, $55 = 0, $6$hi = 0, $7$hi = 0, $198 = 0;
  $3 = global$0 - 160 | 0;
  global$0 = $3;
  bech32__decode__h25859b35256032dd($3 + 72 | 0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ((HEAP32[($3 + 72 | 0) >> 2] | 0 | 0) != (1 | 0)) {
        break label$5
       }
       i64toi32_i32$2 = $3;
       i64toi32_i32$0 = HEAP32[($3 + 76 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($3 + 80 | 0) >> 2] | 0;
       $20 = i64toi32_i32$0;
       i64toi32_i32$0 = $3;
       HEAP32[($3 + 40 | 0) >> 2] = $20;
       HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$0 = $3;
       i64toi32_i32$1 = 0;
       HEAP32[($3 + 108 | 0) >> 2] = 0;
       HEAP32[($3 + 112 | 0) >> 2] = i64toi32_i32$1;
       HEAP32[($3 + 104 | 0) >> 2] = HEAP32[(0 + 1066212 | 0) >> 2] | 0;
       core__fmt__Formatter__new__he219faf25326051b($3 + 120 | 0 | 0, $3 + 104 | 0 | 0, 1065900 | 0);
       if (!($bech32__Error_20as_20core__fmt__Display___fmt__hb94eedebff44411f($3 + 40 | 0 | 0, $3 + 120 | 0 | 0) | 0)) {
        break label$4
       }
       core__result__unwrap_failed__h27f43d993c3864a1(1065924 | 0, 55 | 0, $3 + 24 | 0 | 0, 1066104 | 0, 1066056 | 0);
       abort();
      }
      $4 = ($3 + 56 | 0) + 8 | 0;
      $1 = HEAP32[($3 + 96 | 0) >> 2] | 0;
      HEAP32[$4 >> 2] = $1;
      i64toi32_i32$2 = $3 + 88 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $5 = i64toi32_i32$1;
      $5$hi = i64toi32_i32$0;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 56 | 0) >> 2] = $5;
      HEAP32[($3 + 60 | 0) >> 2] = i64toi32_i32$0;
      $2 = HEAP32[($3 + 76 | 0) >> 2] | 0;
      i64toi32_i32$2 = ($3 + 72 | 0) + 8 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $55 = i64toi32_i32$0;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 28 | 0) >> 2] = $55;
      HEAP32[($3 + 32 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($3 + 24 | 0) >> 2] = $2;
      HEAP32[(($3 + 40 | 0) + 8 | 0) >> 2] = $1;
      i64toi32_i32$1 = $5$hi;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 40 | 0) >> 2] = $5;
      HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$1;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__heed2de4899f9d51c($3 + 16 | 0 | 0, $3 + 40 | 0 | 0);
      $alloc__vec__Vec_u8__20as_20bech32__FromBase32___from_base32__h6e67b5484009b518($3 + 120 | 0 | 0, HEAP32[($3 + 16 | 0) >> 2] | 0 | 0, HEAP32[($3 + 20 | 0) >> 2] | 0 | 0);
      if ((HEAP32[($3 + 120 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$2
      }
      $1 = HEAP32[($3 + 132 | 0) >> 2] | 0;
      HEAP32[$4 >> 2] = $1;
      i64toi32_i32$2 = $3;
      i64toi32_i32$1 = HEAP32[($3 + 124 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($3 + 128 | 0) >> 2] | 0;
      $5 = i64toi32_i32$1;
      $5$hi = i64toi32_i32$0;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 56 | 0) >> 2] = $5;
      HEAP32[($3 + 60 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[(($3 + 104 | 0) + 8 | 0) >> 2] = $1;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 104 | 0) >> 2] = $5;
      HEAP32[($3 + 108 | 0) >> 2] = i64toi32_i32$0;
      cardano_serialization_lib__crypto__VRFVKey__from_bytes__hf703fd2bd6e45870($3 + 120 | 0 | 0, $3 + 104 | 0 | 0);
      if ((HEAPU8[($3 + 120 | 0) >> 0] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      $22 = HEAPU8[($3 + 121 | 0) >> 0] | 0 | ((HEAPU8[($3 + 122 | 0) >> 0] | 0) << 8 | 0) | 0;
      HEAP8[($0 + 1 | 0) >> 0] = $22;
      HEAP8[($0 + 2 | 0) >> 0] = $22 >>> 8 | 0;
      HEAP8[($0 + 3 | 0) >> 0] = HEAPU8[($3 + 123 | 0) >> 0] | 0;
      i64toi32_i32$2 = ($3 + 120 | 0) + 16 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $5 = i64toi32_i32$0;
      $5$hi = i64toi32_i32$1;
      i64toi32_i32$0 = ($3 + 72 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $5;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = ($3 + 120 | 0) + 24 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $6 = i64toi32_i32$1;
      $6$hi = i64toi32_i32$0;
      i64toi32_i32$1 = ($3 + 72 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $6;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      $1 = HEAPU8[(($3 + 120 | 0) + 32 | 0) >> 0] | 0;
      HEAP8[(($3 + 72 | 0) + 24 | 0) >> 0] = $1;
      i64toi32_i32$2 = ($3 + 120 | 0) + 8 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $7 = i64toi32_i32$0;
      $7$hi = i64toi32_i32$1;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 72 | 0) >> 2] = $7;
      HEAP32[($3 + 76 | 0) >> 2] = i64toi32_i32$1;
      $2 = HEAP32[($3 + 124 | 0) >> 2] | 0;
      HEAP8[($0 + 32 | 0) >> 0] = $1;
      i64toi32_i32$1 = $6$hi;
      i64toi32_i32$0 = $0 + 24 | 0;
      $17 = $6;
      HEAP8[i64toi32_i32$0 >> 0] = $17;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $17 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $17 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $17 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      i64toi32_i32$1 = $5$hi;
      i64toi32_i32$0 = $0 + 16 | 0;
      HEAP8[i64toi32_i32$0 >> 0] = $5;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $5 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $5 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $5 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      i64toi32_i32$1 = $7$hi;
      i64toi32_i32$0 = $0 + 8 | 0;
      $18 = $7;
      HEAP8[i64toi32_i32$0 >> 0] = $18;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $18 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $18 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $18 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      $19 = $0 + 4 | 0;
      $21 = $2;
      HEAP8[$19 >> 0] = $21;
      HEAP8[($19 + 1 | 0) >> 0] = $21 >>> 8 | 0;
      HEAP8[($19 + 2 | 0) >> 0] = $21 >>> 16 | 0;
      HEAP8[($19 + 3 | 0) >> 0] = $21 >>> 24 | 0;
      HEAP8[$0 >> 0] = 0;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc91437b7d7fa2d3a($3 + 40 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h899e85abb4c3d85f($3 + 40 | 0 | 0);
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 24 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 24 | 0 | 0);
      break label$1;
     }
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $3 + 104 | 0 | 0);
     $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($3 + 8 | 0) >> 2] | 0 | 0, HEAP32[($3 + 12 | 0) >> 2] | 0 | 0) | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 104 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 104 | 0 | 0);
     $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($1 | 0) | 0;
     HEAP8[$0 >> 0] = 1;
     HEAP32[($0 + 4 | 0) >> 2] = $1;
     break label$1;
    }
    $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($3 + 124 | 0) >> 2] | 0 | 0) | 0;
    HEAP8[$0 >> 0] = 1;
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc91437b7d7fa2d3a($3 + 40 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h899e85abb4c3d85f($3 + 40 | 0 | 0);
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 24 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 24 | 0 | 0);
    break label$1;
   }
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[($3 + 124 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($3 + 128 | 0) >> 2] | 0;
   $198 = i64toi32_i32$1;
   i64toi32_i32$1 = $3;
   HEAP32[($3 + 72 | 0) >> 2] = $198;
   HEAP32[($3 + 76 | 0) >> 2] = i64toi32_i32$0;
   core__result__unwrap_failed__h27f43d993c3864a1(1066120 | 0, 43 | 0, $3 + 72 | 0 | 0, 1066164 | 0, 1067100 | 0);
   abort();
  }
  global$0 = $3 + 160 | 0;
 }
 
 function cardano_serialization_lib__crypto__KESVKey__from_bech32__hc8825be559d40be0($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $5 = 0, $5$hi = 0, $17 = 0, $18 = 0, $19 = 0, $21 = 0, $4 = 0, $22 = 0, $6 = 0, $7 = 0, $20 = 0, $55 = 0, $6$hi = 0, $7$hi = 0, $198 = 0;
  $3 = global$0 - 160 | 0;
  global$0 = $3;
  bech32__decode__h25859b35256032dd($3 + 72 | 0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ((HEAP32[($3 + 72 | 0) >> 2] | 0 | 0) != (1 | 0)) {
        break label$5
       }
       i64toi32_i32$2 = $3;
       i64toi32_i32$0 = HEAP32[($3 + 76 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($3 + 80 | 0) >> 2] | 0;
       $20 = i64toi32_i32$0;
       i64toi32_i32$0 = $3;
       HEAP32[($3 + 40 | 0) >> 2] = $20;
       HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$0 = $3;
       i64toi32_i32$1 = 0;
       HEAP32[($3 + 108 | 0) >> 2] = 0;
       HEAP32[($3 + 112 | 0) >> 2] = i64toi32_i32$1;
       HEAP32[($3 + 104 | 0) >> 2] = HEAP32[(0 + 1066212 | 0) >> 2] | 0;
       core__fmt__Formatter__new__he219faf25326051b($3 + 120 | 0 | 0, $3 + 104 | 0 | 0, 1065900 | 0);
       if (!($bech32__Error_20as_20core__fmt__Display___fmt__hb94eedebff44411f($3 + 40 | 0 | 0, $3 + 120 | 0 | 0) | 0)) {
        break label$4
       }
       core__result__unwrap_failed__h27f43d993c3864a1(1065924 | 0, 55 | 0, $3 + 24 | 0 | 0, 1066104 | 0, 1066056 | 0);
       abort();
      }
      $4 = ($3 + 56 | 0) + 8 | 0;
      $1 = HEAP32[($3 + 96 | 0) >> 2] | 0;
      HEAP32[$4 >> 2] = $1;
      i64toi32_i32$2 = $3 + 88 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $5 = i64toi32_i32$1;
      $5$hi = i64toi32_i32$0;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 56 | 0) >> 2] = $5;
      HEAP32[($3 + 60 | 0) >> 2] = i64toi32_i32$0;
      $2 = HEAP32[($3 + 76 | 0) >> 2] | 0;
      i64toi32_i32$2 = ($3 + 72 | 0) + 8 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $55 = i64toi32_i32$0;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 28 | 0) >> 2] = $55;
      HEAP32[($3 + 32 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($3 + 24 | 0) >> 2] = $2;
      HEAP32[(($3 + 40 | 0) + 8 | 0) >> 2] = $1;
      i64toi32_i32$1 = $5$hi;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 40 | 0) >> 2] = $5;
      HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$1;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__heed2de4899f9d51c($3 + 16 | 0 | 0, $3 + 40 | 0 | 0);
      $alloc__vec__Vec_u8__20as_20bech32__FromBase32___from_base32__h6e67b5484009b518($3 + 120 | 0 | 0, HEAP32[($3 + 16 | 0) >> 2] | 0 | 0, HEAP32[($3 + 20 | 0) >> 2] | 0 | 0);
      if ((HEAP32[($3 + 120 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$2
      }
      $1 = HEAP32[($3 + 132 | 0) >> 2] | 0;
      HEAP32[$4 >> 2] = $1;
      i64toi32_i32$2 = $3;
      i64toi32_i32$1 = HEAP32[($3 + 124 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($3 + 128 | 0) >> 2] | 0;
      $5 = i64toi32_i32$1;
      $5$hi = i64toi32_i32$0;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 56 | 0) >> 2] = $5;
      HEAP32[($3 + 60 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[(($3 + 104 | 0) + 8 | 0) >> 2] = $1;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 104 | 0) >> 2] = $5;
      HEAP32[($3 + 108 | 0) >> 2] = i64toi32_i32$0;
      cardano_serialization_lib__crypto__KESVKey__from_bytes__hd3afa2883ce70fa1($3 + 120 | 0 | 0, $3 + 104 | 0 | 0);
      if ((HEAPU8[($3 + 120 | 0) >> 0] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      $22 = HEAPU8[($3 + 121 | 0) >> 0] | 0 | ((HEAPU8[($3 + 122 | 0) >> 0] | 0) << 8 | 0) | 0;
      HEAP8[($0 + 1 | 0) >> 0] = $22;
      HEAP8[($0 + 2 | 0) >> 0] = $22 >>> 8 | 0;
      HEAP8[($0 + 3 | 0) >> 0] = HEAPU8[($3 + 123 | 0) >> 0] | 0;
      i64toi32_i32$2 = ($3 + 120 | 0) + 16 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $5 = i64toi32_i32$0;
      $5$hi = i64toi32_i32$1;
      i64toi32_i32$0 = ($3 + 72 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $5;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = ($3 + 120 | 0) + 24 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $6 = i64toi32_i32$1;
      $6$hi = i64toi32_i32$0;
      i64toi32_i32$1 = ($3 + 72 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $6;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      $1 = HEAPU8[(($3 + 120 | 0) + 32 | 0) >> 0] | 0;
      HEAP8[(($3 + 72 | 0) + 24 | 0) >> 0] = $1;
      i64toi32_i32$2 = ($3 + 120 | 0) + 8 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $7 = i64toi32_i32$0;
      $7$hi = i64toi32_i32$1;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 72 | 0) >> 2] = $7;
      HEAP32[($3 + 76 | 0) >> 2] = i64toi32_i32$1;
      $2 = HEAP32[($3 + 124 | 0) >> 2] | 0;
      HEAP8[($0 + 32 | 0) >> 0] = $1;
      i64toi32_i32$1 = $6$hi;
      i64toi32_i32$0 = $0 + 24 | 0;
      $17 = $6;
      HEAP8[i64toi32_i32$0 >> 0] = $17;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $17 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $17 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $17 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      i64toi32_i32$1 = $5$hi;
      i64toi32_i32$0 = $0 + 16 | 0;
      HEAP8[i64toi32_i32$0 >> 0] = $5;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $5 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $5 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $5 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      i64toi32_i32$1 = $7$hi;
      i64toi32_i32$0 = $0 + 8 | 0;
      $18 = $7;
      HEAP8[i64toi32_i32$0 >> 0] = $18;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $18 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $18 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $18 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      $19 = $0 + 4 | 0;
      $21 = $2;
      HEAP8[$19 >> 0] = $21;
      HEAP8[($19 + 1 | 0) >> 0] = $21 >>> 8 | 0;
      HEAP8[($19 + 2 | 0) >> 0] = $21 >>> 16 | 0;
      HEAP8[($19 + 3 | 0) >> 0] = $21 >>> 24 | 0;
      HEAP8[$0 >> 0] = 0;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc91437b7d7fa2d3a($3 + 40 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h899e85abb4c3d85f($3 + 40 | 0 | 0);
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 24 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 24 | 0 | 0);
      break label$1;
     }
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $3 + 104 | 0 | 0);
     $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($3 + 8 | 0) >> 2] | 0 | 0, HEAP32[($3 + 12 | 0) >> 2] | 0 | 0) | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 104 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 104 | 0 | 0);
     $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($1 | 0) | 0;
     HEAP8[$0 >> 0] = 1;
     HEAP32[($0 + 4 | 0) >> 2] = $1;
     break label$1;
    }
    $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($3 + 124 | 0) >> 2] | 0 | 0) | 0;
    HEAP8[$0 >> 0] = 1;
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc91437b7d7fa2d3a($3 + 40 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h899e85abb4c3d85f($3 + 40 | 0 | 0);
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 24 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 24 | 0 | 0);
    break label$1;
   }
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[($3 + 124 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($3 + 128 | 0) >> 2] | 0;
   $198 = i64toi32_i32$1;
   i64toi32_i32$1 = $3;
   HEAP32[($3 + 72 | 0) >> 2] = $198;
   HEAP32[($3 + 76 | 0) >> 2] = i64toi32_i32$0;
   core__result__unwrap_failed__h27f43d993c3864a1(1066120 | 0, 43 | 0, $3 + 72 | 0 | 0, 1066164 | 0, 1067124 | 0);
   abort();
  }
  global$0 = $3 + 160 | 0;
 }
 
 function $cardano_serialization_lib__crypto__Ed25519KeyHash_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h495effbb534e290f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, i64toi32_i32$2 = 0, $6 = 0, $4 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $25 = 0, $26 = 0, $27 = 0, $28 = 0, $6$hi = 0, $5 = 0, $29 = 0, $7 = 0, $7$hi = 0, $8 = 0, $8$hi = 0, $30 = 0, $31 = 0, $32 = 0, $33 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___bytes__hc697ccccfa39fd82($2 + 48 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[($2 + 48 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     HEAP32[($2 + 24 | 0) >> 2] = HEAP32[($2 + 52 | 0) >> 2] | 0;
     $29 = HEAPU8[($2 + 57 | 0) >> 0] | 0 | ((HEAPU8[($2 + 58 | 0) >> 0] | 0) << 8 | 0) | 0;
     HEAP8[($2 + 29 | 0) >> 0] = $29;
     HEAP8[($2 + 30 | 0) >> 0] = $29 >>> 8 | 0;
     HEAP8[($2 + 28 | 0) >> 0] = HEAPU8[($2 + 56 | 0) >> 0] | 0;
     $1 = 11;
     HEAP8[($2 + 31 | 0) >> 0] = HEAPU8[(($2 + 48 | 0) + 11 | 0) >> 0] | 0;
     $3 = HEAP32[($2 + 60 | 0) >> 2] | 0;
     HEAP32[($2 + 32 | 0) >> 2] = $3;
     label$4 : {
      label$5 : {
       if (($3 | 0) != (28 | 0)) {
        break label$5
       }
       $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 | 0, $2 + 24 | 0 | 0);
       $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
       if ($1 >>> 0 > 27 >>> 0) {
        break label$4
       }
       core__slice__index__slice_end_index_len_fail__h192505a15ac4b345(28 | 0, $1 | 0, 1066764 | 0);
       abort();
      }
      i64toi32_i32$0 = 0;
      $6 = $3;
      $6$hi = i64toi32_i32$0;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 24 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 24 | 0 | 0);
      i64toi32_i32$0 = 0;
      $7 = 1;
      $7$hi = i64toi32_i32$0;
      i64toi32_i32$0 = 0;
      $8 = 28;
      $8$hi = i64toi32_i32$0;
      $3 = 1066390;
      $4 = 13;
      break label$2;
     }
     $3 = $2 + 14 | 0;
     $1 = HEAP32[$2 >> 2] | 0;
     HEAP8[$3 >> 0] = HEAPU8[($1 + 18 | 0) >> 0] | 0;
     HEAP32[($2 + 40 | 0) >> 2] = HEAPU8[$1 >> 0] | 0 | ((HEAPU8[($1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $15 = $1 + 3 | 0;
     $16 = HEAPU8[$15 >> 0] | 0 | ((HEAPU8[($15 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($15 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($15 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($2 + 43 | 0) >> 0] = $16;
     HEAP8[($2 + 44 | 0) >> 0] = $16 >>> 8 | 0;
     HEAP8[($2 + 45 | 0) >> 0] = $16 >>> 16 | 0;
     HEAP8[($2 + 46 | 0) >> 0] = $16 >>> 24 | 0;
     HEAP16[($2 + 12 | 0) >> 1] = HEAPU8[($1 + 16 | 0) >> 0] | 0 | ((HEAPU8[($1 + 17 | 0) >> 0] | 0) << 8 | 0) | 0;
     HEAP32[($2 + 16 | 0) >> 2] = HEAPU8[($1 + 8 | 0) >> 0] | 0 | ((HEAPU8[($1 + 9 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 10 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 11 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $17 = $1 + 11 | 0;
     $18 = HEAPU8[$17 >> 0] | 0 | ((HEAPU8[($17 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($17 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($17 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($2 + 19 | 0) >> 0] = $18;
     HEAP8[($2 + 20 | 0) >> 0] = $18 >>> 8 | 0;
     HEAP8[($2 + 21 | 0) >> 0] = $18 >>> 16 | 0;
     HEAP8[($2 + 22 | 0) >> 0] = $18 >>> 24 | 0;
     $4 = HEAPU8[($1 + 7 | 0) >> 0] | 0;
     $19 = HEAPU8[($2 + 43 | 0) >> 0] | 0 | ((HEAPU8[($2 + 44 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 45 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 46 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($2 + 52 | 0) >> 0] = $19;
     HEAP8[($2 + 53 | 0) >> 0] = $19 >>> 8 | 0;
     HEAP8[($2 + 54 | 0) >> 0] = $19 >>> 16 | 0;
     HEAP8[($2 + 55 | 0) >> 0] = $19 >>> 24 | 0;
     $20 = HEAP32[($2 + 40 | 0) >> 2] | 0;
     HEAP8[($2 + 49 | 0) >> 0] = $20;
     HEAP8[($2 + 50 | 0) >> 0] = $20 >>> 8 | 0;
     HEAP8[($2 + 51 | 0) >> 0] = $20 >>> 16 | 0;
     HEAP8[($2 + 52 | 0) >> 0] = $20 >>> 24 | 0;
     i64toi32_i32$2 = $1;
     i64toi32_i32$0 = HEAPU8[($1 + 19 | 0) >> 0] | 0 | ((HEAPU8[($1 + 20 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 21 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 22 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[($1 + 23 | 0) >> 0] | 0 | ((HEAPU8[($1 + 24 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 25 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 26 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $6 = i64toi32_i32$0;
     $6$hi = i64toi32_i32$1;
     $5 = HEAPU8[($1 + 27 | 0) >> 0] | 0;
     $1 = HEAPU8[($1 + 15 | 0) >> 0] | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 24 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 24 | 0 | 0);
     $21 = $0 + 4 | 0;
     $22 = HEAPU8[($2 + 52 | 0) >> 0] | 0 | ((HEAPU8[($2 + 53 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 54 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 55 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[$21 >> 0] = $22;
     HEAP8[($21 + 1 | 0) >> 0] = $22 >>> 8 | 0;
     HEAP8[($21 + 2 | 0) >> 0] = $22 >>> 16 | 0;
     HEAP8[($21 + 3 | 0) >> 0] = $22 >>> 24 | 0;
     $23 = HEAPU8[($2 + 49 | 0) >> 0] | 0 | ((HEAPU8[($2 + 50 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 51 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 52 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($0 + 1 | 0) >> 0] = $23;
     HEAP8[($0 + 2 | 0) >> 0] = $23 >>> 8 | 0;
     HEAP8[($0 + 3 | 0) >> 0] = $23 >>> 16 | 0;
     HEAP8[($0 + 4 | 0) >> 0] = $23 >>> 24 | 0;
     HEAP8[($0 + 8 | 0) >> 0] = $4;
     $24 = $0 + 9 | 0;
     $25 = HEAP32[($2 + 16 | 0) >> 2] | 0;
     HEAP8[$24 >> 0] = $25;
     HEAP8[($24 + 1 | 0) >> 0] = $25 >>> 8 | 0;
     HEAP8[($24 + 2 | 0) >> 0] = $25 >>> 16 | 0;
     HEAP8[($24 + 3 | 0) >> 0] = $25 >>> 24 | 0;
     $26 = $0 + 12 | 0;
     $27 = HEAPU8[($2 + 19 | 0) >> 0] | 0 | ((HEAPU8[($2 + 20 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 21 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 22 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[$26 >> 0] = $27;
     HEAP8[($26 + 1 | 0) >> 0] = $27 >>> 8 | 0;
     HEAP8[($26 + 2 | 0) >> 0] = $27 >>> 16 | 0;
     HEAP8[($26 + 3 | 0) >> 0] = $27 >>> 24 | 0;
     HEAP8[($0 + 16 | 0) >> 0] = $1;
     $30 = $0 + 17 | 0;
     $31 = HEAPU16[($2 + 12 | 0) >> 1] | 0;
     HEAP8[$30 >> 0] = $31;
     HEAP8[($30 + 1 | 0) >> 0] = $31 >>> 8 | 0;
     HEAP8[($0 + 19 | 0) >> 0] = HEAPU8[$3 >> 0] | 0;
     HEAP8[($0 + 28 | 0) >> 0] = $5;
     i64toi32_i32$0 = $0 + 20 | 0;
     $28 = $6;
     HEAP8[i64toi32_i32$0 >> 0] = $28;
     HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $28 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $28 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $28 >>> 24 | 0;
     HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
     HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
     $1 = 0;
     break label$1;
    }
    HEAP8[($2 + 14 | 0) >> 0] = HEAPU8[($2 + 59 | 0) >> 0] | 0;
    $1 = HEAPU8[($2 + 57 | 0) >> 0] | 0 | ((HEAPU8[($2 + 58 | 0) >> 0] | 0) << 8 | 0) | 0;
    HEAP16[($2 + 40 | 0) >> 1] = $1;
    HEAP16[($2 + 12 | 0) >> 1] = $1;
    $4 = HEAPU8[($2 + 56 | 0) >> 0] | 0;
    $3 = HEAP32[($2 + 60 | 0) >> 2] | 0;
    $1 = HEAP32[($2 + 64 | 0) >> 2] | 0;
    $5 = HEAP32[($2 + 68 | 0) >> 2] | 0;
    i64toi32_i32$2 = $2 + 72 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $8 = i64toi32_i32$1;
    $8$hi = i64toi32_i32$0;
    i64toi32_i32$2 = $2 + 80 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $7 = i64toi32_i32$0;
    $7$hi = i64toi32_i32$1;
    i64toi32_i32$2 = $2 + 88 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $6 = i64toi32_i32$1;
    $6$hi = i64toi32_i32$0;
   }
   HEAP8[(($2 + 48 | 0) + 8 | 0) >> 0] = $4;
   $32 = $2 + 57 | 0;
   $33 = HEAPU16[($2 + 12 | 0) >> 1] | 0;
   HEAP8[$32 >> 0] = $33;
   HEAP8[($32 + 1 | 0) >> 0] = $33 >>> 8 | 0;
   i64toi32_i32$0 = $6$hi;
   i64toi32_i32$1 = $2 + 88 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $6;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $7$hi;
   i64toi32_i32$1 = $2 + 80 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $7;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $8$hi;
   i64toi32_i32$1 = $2 + 72 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $8;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($2 + 68 | 0) >> 2] = $5;
   HEAP32[($2 + 64 | 0) >> 2] = $1;
   HEAP32[($2 + 60 | 0) >> 2] = $3;
   HEAP8[($2 + 48 | 0) >> 0] = 2;
   HEAP8[($2 + 59 | 0) >> 0] = HEAPU8[(($2 + 12 | 0) + 2 | 0) >> 0] | 0;
   HEAP32[($2 + 96 | 0) >> 2] = 0;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 48 | 0 | 0, 1066780 | 0, 14 | 0);
   $1 = 1;
  }
  HEAP8[$0 >> 0] = $1;
  global$0 = $2 + 112 | 0;
 }
 
 function $cardano_serialization_lib__crypto__ScriptHash_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h589000d40634e72d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, i64toi32_i32$2 = 0, $6 = 0, $4 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $25 = 0, $26 = 0, $27 = 0, $28 = 0, $6$hi = 0, $5 = 0, $29 = 0, $7 = 0, $7$hi = 0, $8 = 0, $8$hi = 0, $30 = 0, $31 = 0, $32 = 0, $33 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___bytes__hc697ccccfa39fd82($2 + 48 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[($2 + 48 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     HEAP32[($2 + 24 | 0) >> 2] = HEAP32[($2 + 52 | 0) >> 2] | 0;
     $29 = HEAPU8[($2 + 57 | 0) >> 0] | 0 | ((HEAPU8[($2 + 58 | 0) >> 0] | 0) << 8 | 0) | 0;
     HEAP8[($2 + 29 | 0) >> 0] = $29;
     HEAP8[($2 + 30 | 0) >> 0] = $29 >>> 8 | 0;
     HEAP8[($2 + 28 | 0) >> 0] = HEAPU8[($2 + 56 | 0) >> 0] | 0;
     $1 = 11;
     HEAP8[($2 + 31 | 0) >> 0] = HEAPU8[(($2 + 48 | 0) + 11 | 0) >> 0] | 0;
     $3 = HEAP32[($2 + 60 | 0) >> 2] | 0;
     HEAP32[($2 + 32 | 0) >> 2] = $3;
     label$4 : {
      label$5 : {
       if (($3 | 0) != (28 | 0)) {
        break label$5
       }
       $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 | 0, $2 + 24 | 0 | 0);
       $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
       if ($1 >>> 0 > 27 >>> 0) {
        break label$4
       }
       core__slice__index__slice_end_index_len_fail__h192505a15ac4b345(28 | 0, $1 | 0, 1066796 | 0);
       abort();
      }
      i64toi32_i32$0 = 0;
      $6 = $3;
      $6$hi = i64toi32_i32$0;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 24 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 24 | 0 | 0);
      i64toi32_i32$0 = 0;
      $7 = 1;
      $7$hi = i64toi32_i32$0;
      i64toi32_i32$0 = 0;
      $8 = 28;
      $8$hi = i64toi32_i32$0;
      $3 = 1066390;
      $4 = 13;
      break label$2;
     }
     $3 = $2 + 14 | 0;
     $1 = HEAP32[$2 >> 2] | 0;
     HEAP8[$3 >> 0] = HEAPU8[($1 + 18 | 0) >> 0] | 0;
     HEAP32[($2 + 40 | 0) >> 2] = HEAPU8[$1 >> 0] | 0 | ((HEAPU8[($1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $15 = $1 + 3 | 0;
     $16 = HEAPU8[$15 >> 0] | 0 | ((HEAPU8[($15 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($15 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($15 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($2 + 43 | 0) >> 0] = $16;
     HEAP8[($2 + 44 | 0) >> 0] = $16 >>> 8 | 0;
     HEAP8[($2 + 45 | 0) >> 0] = $16 >>> 16 | 0;
     HEAP8[($2 + 46 | 0) >> 0] = $16 >>> 24 | 0;
     HEAP16[($2 + 12 | 0) >> 1] = HEAPU8[($1 + 16 | 0) >> 0] | 0 | ((HEAPU8[($1 + 17 | 0) >> 0] | 0) << 8 | 0) | 0;
     HEAP32[($2 + 16 | 0) >> 2] = HEAPU8[($1 + 8 | 0) >> 0] | 0 | ((HEAPU8[($1 + 9 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 10 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 11 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $17 = $1 + 11 | 0;
     $18 = HEAPU8[$17 >> 0] | 0 | ((HEAPU8[($17 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($17 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($17 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($2 + 19 | 0) >> 0] = $18;
     HEAP8[($2 + 20 | 0) >> 0] = $18 >>> 8 | 0;
     HEAP8[($2 + 21 | 0) >> 0] = $18 >>> 16 | 0;
     HEAP8[($2 + 22 | 0) >> 0] = $18 >>> 24 | 0;
     $4 = HEAPU8[($1 + 7 | 0) >> 0] | 0;
     $19 = HEAPU8[($2 + 43 | 0) >> 0] | 0 | ((HEAPU8[($2 + 44 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 45 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 46 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($2 + 52 | 0) >> 0] = $19;
     HEAP8[($2 + 53 | 0) >> 0] = $19 >>> 8 | 0;
     HEAP8[($2 + 54 | 0) >> 0] = $19 >>> 16 | 0;
     HEAP8[($2 + 55 | 0) >> 0] = $19 >>> 24 | 0;
     $20 = HEAP32[($2 + 40 | 0) >> 2] | 0;
     HEAP8[($2 + 49 | 0) >> 0] = $20;
     HEAP8[($2 + 50 | 0) >> 0] = $20 >>> 8 | 0;
     HEAP8[($2 + 51 | 0) >> 0] = $20 >>> 16 | 0;
     HEAP8[($2 + 52 | 0) >> 0] = $20 >>> 24 | 0;
     i64toi32_i32$2 = $1;
     i64toi32_i32$0 = HEAPU8[($1 + 19 | 0) >> 0] | 0 | ((HEAPU8[($1 + 20 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 21 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 22 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[($1 + 23 | 0) >> 0] | 0 | ((HEAPU8[($1 + 24 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 25 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 26 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $6 = i64toi32_i32$0;
     $6$hi = i64toi32_i32$1;
     $5 = HEAPU8[($1 + 27 | 0) >> 0] | 0;
     $1 = HEAPU8[($1 + 15 | 0) >> 0] | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 24 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 24 | 0 | 0);
     $21 = $0 + 4 | 0;
     $22 = HEAPU8[($2 + 52 | 0) >> 0] | 0 | ((HEAPU8[($2 + 53 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 54 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 55 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[$21 >> 0] = $22;
     HEAP8[($21 + 1 | 0) >> 0] = $22 >>> 8 | 0;
     HEAP8[($21 + 2 | 0) >> 0] = $22 >>> 16 | 0;
     HEAP8[($21 + 3 | 0) >> 0] = $22 >>> 24 | 0;
     $23 = HEAPU8[($2 + 49 | 0) >> 0] | 0 | ((HEAPU8[($2 + 50 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 51 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 52 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($0 + 1 | 0) >> 0] = $23;
     HEAP8[($0 + 2 | 0) >> 0] = $23 >>> 8 | 0;
     HEAP8[($0 + 3 | 0) >> 0] = $23 >>> 16 | 0;
     HEAP8[($0 + 4 | 0) >> 0] = $23 >>> 24 | 0;
     HEAP8[($0 + 8 | 0) >> 0] = $4;
     $24 = $0 + 9 | 0;
     $25 = HEAP32[($2 + 16 | 0) >> 2] | 0;
     HEAP8[$24 >> 0] = $25;
     HEAP8[($24 + 1 | 0) >> 0] = $25 >>> 8 | 0;
     HEAP8[($24 + 2 | 0) >> 0] = $25 >>> 16 | 0;
     HEAP8[($24 + 3 | 0) >> 0] = $25 >>> 24 | 0;
     $26 = $0 + 12 | 0;
     $27 = HEAPU8[($2 + 19 | 0) >> 0] | 0 | ((HEAPU8[($2 + 20 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 21 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 22 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[$26 >> 0] = $27;
     HEAP8[($26 + 1 | 0) >> 0] = $27 >>> 8 | 0;
     HEAP8[($26 + 2 | 0) >> 0] = $27 >>> 16 | 0;
     HEAP8[($26 + 3 | 0) >> 0] = $27 >>> 24 | 0;
     HEAP8[($0 + 16 | 0) >> 0] = $1;
     $30 = $0 + 17 | 0;
     $31 = HEAPU16[($2 + 12 | 0) >> 1] | 0;
     HEAP8[$30 >> 0] = $31;
     HEAP8[($30 + 1 | 0) >> 0] = $31 >>> 8 | 0;
     HEAP8[($0 + 19 | 0) >> 0] = HEAPU8[$3 >> 0] | 0;
     HEAP8[($0 + 28 | 0) >> 0] = $5;
     i64toi32_i32$0 = $0 + 20 | 0;
     $28 = $6;
     HEAP8[i64toi32_i32$0 >> 0] = $28;
     HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $28 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $28 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $28 >>> 24 | 0;
     HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
     HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
     $1 = 0;
     break label$1;
    }
    HEAP8[($2 + 14 | 0) >> 0] = HEAPU8[($2 + 59 | 0) >> 0] | 0;
    $1 = HEAPU8[($2 + 57 | 0) >> 0] | 0 | ((HEAPU8[($2 + 58 | 0) >> 0] | 0) << 8 | 0) | 0;
    HEAP16[($2 + 40 | 0) >> 1] = $1;
    HEAP16[($2 + 12 | 0) >> 1] = $1;
    $4 = HEAPU8[($2 + 56 | 0) >> 0] | 0;
    $3 = HEAP32[($2 + 60 | 0) >> 2] | 0;
    $1 = HEAP32[($2 + 64 | 0) >> 2] | 0;
    $5 = HEAP32[($2 + 68 | 0) >> 2] | 0;
    i64toi32_i32$2 = $2 + 72 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $8 = i64toi32_i32$1;
    $8$hi = i64toi32_i32$0;
    i64toi32_i32$2 = $2 + 80 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $7 = i64toi32_i32$0;
    $7$hi = i64toi32_i32$1;
    i64toi32_i32$2 = $2 + 88 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $6 = i64toi32_i32$1;
    $6$hi = i64toi32_i32$0;
   }
   HEAP8[(($2 + 48 | 0) + 8 | 0) >> 0] = $4;
   $32 = $2 + 57 | 0;
   $33 = HEAPU16[($2 + 12 | 0) >> 1] | 0;
   HEAP8[$32 >> 0] = $33;
   HEAP8[($32 + 1 | 0) >> 0] = $33 >>> 8 | 0;
   i64toi32_i32$0 = $6$hi;
   i64toi32_i32$1 = $2 + 88 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $6;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $7$hi;
   i64toi32_i32$1 = $2 + 80 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $7;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $8$hi;
   i64toi32_i32$1 = $2 + 72 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $8;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($2 + 68 | 0) >> 2] = $5;
   HEAP32[($2 + 64 | 0) >> 2] = $1;
   HEAP32[($2 + 60 | 0) >> 2] = $3;
   HEAP8[($2 + 48 | 0) >> 0] = 2;
   HEAP8[($2 + 59 | 0) >> 0] = HEAPU8[(($2 + 12 | 0) + 2 | 0) >> 0] | 0;
   HEAP32[($2 + 96 | 0) >> 2] = 0;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 48 | 0 | 0, 1066812 | 0, 10 | 0);
   $1 = 1;
  }
  HEAP8[$0 >> 0] = $1;
  global$0 = $2 + 112 | 0;
 }
 
 function $cardano_serialization_lib__crypto__GenesisDelegateHash_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hd0c1349750fae386($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, i64toi32_i32$2 = 0, $6 = 0, $4 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $25 = 0, $26 = 0, $27 = 0, $28 = 0, $6$hi = 0, $5 = 0, $29 = 0, $7 = 0, $7$hi = 0, $8 = 0, $8$hi = 0, $30 = 0, $31 = 0, $32 = 0, $33 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___bytes__hc697ccccfa39fd82($2 + 48 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[($2 + 48 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     HEAP32[($2 + 24 | 0) >> 2] = HEAP32[($2 + 52 | 0) >> 2] | 0;
     $29 = HEAPU8[($2 + 57 | 0) >> 0] | 0 | ((HEAPU8[($2 + 58 | 0) >> 0] | 0) << 8 | 0) | 0;
     HEAP8[($2 + 29 | 0) >> 0] = $29;
     HEAP8[($2 + 30 | 0) >> 0] = $29 >>> 8 | 0;
     HEAP8[($2 + 28 | 0) >> 0] = HEAPU8[($2 + 56 | 0) >> 0] | 0;
     $1 = 11;
     HEAP8[($2 + 31 | 0) >> 0] = HEAPU8[(($2 + 48 | 0) + 11 | 0) >> 0] | 0;
     $3 = HEAP32[($2 + 60 | 0) >> 2] | 0;
     HEAP32[($2 + 32 | 0) >> 2] = $3;
     label$4 : {
      label$5 : {
       if (($3 | 0) != (28 | 0)) {
        break label$5
       }
       $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 | 0, $2 + 24 | 0 | 0);
       $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
       if ($1 >>> 0 > 27 >>> 0) {
        break label$4
       }
       core__slice__index__slice_end_index_len_fail__h192505a15ac4b345(28 | 0, $1 | 0, 1066856 | 0);
       abort();
      }
      i64toi32_i32$0 = 0;
      $6 = $3;
      $6$hi = i64toi32_i32$0;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 24 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 24 | 0 | 0);
      i64toi32_i32$0 = 0;
      $7 = 1;
      $7$hi = i64toi32_i32$0;
      i64toi32_i32$0 = 0;
      $8 = 28;
      $8$hi = i64toi32_i32$0;
      $3 = 1066390;
      $4 = 13;
      break label$2;
     }
     $3 = $2 + 14 | 0;
     $1 = HEAP32[$2 >> 2] | 0;
     HEAP8[$3 >> 0] = HEAPU8[($1 + 18 | 0) >> 0] | 0;
     HEAP32[($2 + 40 | 0) >> 2] = HEAPU8[$1 >> 0] | 0 | ((HEAPU8[($1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $15 = $1 + 3 | 0;
     $16 = HEAPU8[$15 >> 0] | 0 | ((HEAPU8[($15 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($15 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($15 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($2 + 43 | 0) >> 0] = $16;
     HEAP8[($2 + 44 | 0) >> 0] = $16 >>> 8 | 0;
     HEAP8[($2 + 45 | 0) >> 0] = $16 >>> 16 | 0;
     HEAP8[($2 + 46 | 0) >> 0] = $16 >>> 24 | 0;
     HEAP16[($2 + 12 | 0) >> 1] = HEAPU8[($1 + 16 | 0) >> 0] | 0 | ((HEAPU8[($1 + 17 | 0) >> 0] | 0) << 8 | 0) | 0;
     HEAP32[($2 + 16 | 0) >> 2] = HEAPU8[($1 + 8 | 0) >> 0] | 0 | ((HEAPU8[($1 + 9 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 10 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 11 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $17 = $1 + 11 | 0;
     $18 = HEAPU8[$17 >> 0] | 0 | ((HEAPU8[($17 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($17 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($17 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($2 + 19 | 0) >> 0] = $18;
     HEAP8[($2 + 20 | 0) >> 0] = $18 >>> 8 | 0;
     HEAP8[($2 + 21 | 0) >> 0] = $18 >>> 16 | 0;
     HEAP8[($2 + 22 | 0) >> 0] = $18 >>> 24 | 0;
     $4 = HEAPU8[($1 + 7 | 0) >> 0] | 0;
     $19 = HEAPU8[($2 + 43 | 0) >> 0] | 0 | ((HEAPU8[($2 + 44 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 45 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 46 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($2 + 52 | 0) >> 0] = $19;
     HEAP8[($2 + 53 | 0) >> 0] = $19 >>> 8 | 0;
     HEAP8[($2 + 54 | 0) >> 0] = $19 >>> 16 | 0;
     HEAP8[($2 + 55 | 0) >> 0] = $19 >>> 24 | 0;
     $20 = HEAP32[($2 + 40 | 0) >> 2] | 0;
     HEAP8[($2 + 49 | 0) >> 0] = $20;
     HEAP8[($2 + 50 | 0) >> 0] = $20 >>> 8 | 0;
     HEAP8[($2 + 51 | 0) >> 0] = $20 >>> 16 | 0;
     HEAP8[($2 + 52 | 0) >> 0] = $20 >>> 24 | 0;
     i64toi32_i32$2 = $1;
     i64toi32_i32$0 = HEAPU8[($1 + 19 | 0) >> 0] | 0 | ((HEAPU8[($1 + 20 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 21 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 22 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[($1 + 23 | 0) >> 0] | 0 | ((HEAPU8[($1 + 24 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 25 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 26 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $6 = i64toi32_i32$0;
     $6$hi = i64toi32_i32$1;
     $5 = HEAPU8[($1 + 27 | 0) >> 0] | 0;
     $1 = HEAPU8[($1 + 15 | 0) >> 0] | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 24 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 24 | 0 | 0);
     $21 = $0 + 4 | 0;
     $22 = HEAPU8[($2 + 52 | 0) >> 0] | 0 | ((HEAPU8[($2 + 53 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 54 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 55 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[$21 >> 0] = $22;
     HEAP8[($21 + 1 | 0) >> 0] = $22 >>> 8 | 0;
     HEAP8[($21 + 2 | 0) >> 0] = $22 >>> 16 | 0;
     HEAP8[($21 + 3 | 0) >> 0] = $22 >>> 24 | 0;
     $23 = HEAPU8[($2 + 49 | 0) >> 0] | 0 | ((HEAPU8[($2 + 50 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 51 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 52 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($0 + 1 | 0) >> 0] = $23;
     HEAP8[($0 + 2 | 0) >> 0] = $23 >>> 8 | 0;
     HEAP8[($0 + 3 | 0) >> 0] = $23 >>> 16 | 0;
     HEAP8[($0 + 4 | 0) >> 0] = $23 >>> 24 | 0;
     HEAP8[($0 + 8 | 0) >> 0] = $4;
     $24 = $0 + 9 | 0;
     $25 = HEAP32[($2 + 16 | 0) >> 2] | 0;
     HEAP8[$24 >> 0] = $25;
     HEAP8[($24 + 1 | 0) >> 0] = $25 >>> 8 | 0;
     HEAP8[($24 + 2 | 0) >> 0] = $25 >>> 16 | 0;
     HEAP8[($24 + 3 | 0) >> 0] = $25 >>> 24 | 0;
     $26 = $0 + 12 | 0;
     $27 = HEAPU8[($2 + 19 | 0) >> 0] | 0 | ((HEAPU8[($2 + 20 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 21 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 22 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[$26 >> 0] = $27;
     HEAP8[($26 + 1 | 0) >> 0] = $27 >>> 8 | 0;
     HEAP8[($26 + 2 | 0) >> 0] = $27 >>> 16 | 0;
     HEAP8[($26 + 3 | 0) >> 0] = $27 >>> 24 | 0;
     HEAP8[($0 + 16 | 0) >> 0] = $1;
     $30 = $0 + 17 | 0;
     $31 = HEAPU16[($2 + 12 | 0) >> 1] | 0;
     HEAP8[$30 >> 0] = $31;
     HEAP8[($30 + 1 | 0) >> 0] = $31 >>> 8 | 0;
     HEAP8[($0 + 19 | 0) >> 0] = HEAPU8[$3 >> 0] | 0;
     HEAP8[($0 + 28 | 0) >> 0] = $5;
     i64toi32_i32$0 = $0 + 20 | 0;
     $28 = $6;
     HEAP8[i64toi32_i32$0 >> 0] = $28;
     HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $28 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $28 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $28 >>> 24 | 0;
     HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
     HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
     $1 = 0;
     break label$1;
    }
    HEAP8[($2 + 14 | 0) >> 0] = HEAPU8[($2 + 59 | 0) >> 0] | 0;
    $1 = HEAPU8[($2 + 57 | 0) >> 0] | 0 | ((HEAPU8[($2 + 58 | 0) >> 0] | 0) << 8 | 0) | 0;
    HEAP16[($2 + 40 | 0) >> 1] = $1;
    HEAP16[($2 + 12 | 0) >> 1] = $1;
    $4 = HEAPU8[($2 + 56 | 0) >> 0] | 0;
    $3 = HEAP32[($2 + 60 | 0) >> 2] | 0;
    $1 = HEAP32[($2 + 64 | 0) >> 2] | 0;
    $5 = HEAP32[($2 + 68 | 0) >> 2] | 0;
    i64toi32_i32$2 = $2 + 72 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $8 = i64toi32_i32$1;
    $8$hi = i64toi32_i32$0;
    i64toi32_i32$2 = $2 + 80 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $7 = i64toi32_i32$0;
    $7$hi = i64toi32_i32$1;
    i64toi32_i32$2 = $2 + 88 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $6 = i64toi32_i32$1;
    $6$hi = i64toi32_i32$0;
   }
   HEAP8[(($2 + 48 | 0) + 8 | 0) >> 0] = $4;
   $32 = $2 + 57 | 0;
   $33 = HEAPU16[($2 + 12 | 0) >> 1] | 0;
   HEAP8[$32 >> 0] = $33;
   HEAP8[($32 + 1 | 0) >> 0] = $33 >>> 8 | 0;
   i64toi32_i32$0 = $6$hi;
   i64toi32_i32$1 = $2 + 88 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $6;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $7$hi;
   i64toi32_i32$1 = $2 + 80 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $7;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $8$hi;
   i64toi32_i32$1 = $2 + 72 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $8;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($2 + 68 | 0) >> 2] = $5;
   HEAP32[($2 + 64 | 0) >> 2] = $1;
   HEAP32[($2 + 60 | 0) >> 2] = $3;
   HEAP8[($2 + 48 | 0) >> 0] = 2;
   HEAP8[($2 + 59 | 0) >> 0] = HEAPU8[(($2 + 12 | 0) + 2 | 0) >> 0] | 0;
   HEAP32[($2 + 96 | 0) >> 2] = 0;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 48 | 0 | 0, 1066872 | 0, 19 | 0);
   $1 = 1;
  }
  HEAP8[$0 >> 0] = $1;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__MultiAsset__sub__h87ca73850e5358bf($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$3 = 0, $10 = 0, $4 = 0, $8 = 0, $5 = 0, $7 = 0, $10$hi = 0, $9 = 0, $11 = 0, $11$hi = 0, $6 = 0, $33 = 0, $40 = 0, $43 = 0, $78 = 0, $85 = 0, $88 = 0, $113 = 0, $113$hi = 0;
  $3 = global$0 - 320 | 0;
  global$0 = $3;
  $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($0 | 0, $1 | 0);
  alloc__collections__btree__map__BTreeMap_K_2cV___iter__h677e802ff7e211c3($3 + 72 | 0 | 0, $2 | 0);
  HEAP32[(($3 + 104 | 0) + 24 | 0) >> 2] = HEAP32[(($3 + 72 | 0) + 24 | 0) >> 2] | 0;
  i64toi32_i32$2 = ($3 + 72 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $33 = i64toi32_i32$0;
  i64toi32_i32$0 = ($3 + 104 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $33;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = ($3 + 72 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $40 = i64toi32_i32$1;
  i64toi32_i32$1 = ($3 + 104 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $40;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[($3 + 72 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($3 + 76 | 0) >> 2] | 0;
  $43 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[($3 + 104 | 0) >> 2] = $43;
  HEAP32[($3 + 108 | 0) >> 2] = i64toi32_i32$1;
  $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h03cc330b7b1e4522($3 + 64 | 0 | 0, $3 + 104 | 0 | 0);
  label$1 : {
   $4 = HEAP32[($3 + 64 | 0) >> 2] | 0;
   if (!$4) {
    break label$1
   }
   $2 = HEAP32[($3 + 68 | 0) >> 2] | 0;
   $5 = $3 + 308 | 0;
   $6 = $3 + 216 | 0 | 4 | 0;
   $7 = $3 + 200 | 0 | 4 | 0;
   label$2 : while (1) {
    alloc__collections__btree__map__BTreeMap_K_2cV___iter__ha89c9458aca0228d($3 + 136 | 0 | 0, $2 | 0);
    HEAP32[(($3 + 168 | 0) + 24 | 0) >> 2] = HEAP32[(($3 + 136 | 0) + 24 | 0) >> 2] | 0;
    i64toi32_i32$2 = ($3 + 136 | 0) + 16 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $78 = i64toi32_i32$1;
    i64toi32_i32$1 = ($3 + 168 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $78;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = ($3 + 136 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $85 = i64toi32_i32$0;
    i64toi32_i32$0 = ($3 + 168 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $85;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAP32[($3 + 136 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($3 + 140 | 0) >> 2] | 0;
    $88 = i64toi32_i32$1;
    i64toi32_i32$1 = $3;
    HEAP32[($3 + 168 | 0) >> 2] = $88;
    HEAP32[($3 + 172 | 0) >> 2] = i64toi32_i32$0;
    $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h36ca092f81b9a0fa($3 + 56 | 0 | 0, $3 + 168 | 0 | 0);
    label$3 : {
     $1 = HEAP32[($3 + 56 | 0) >> 2] | 0;
     if (!$1) {
      break label$3
     }
     $8 = HEAP32[($3 + 60 | 0) >> 2] | 0;
     label$4 : while (1) {
      label$5 : {
       $2 = alloc__collections__btree__map__BTreeMap_K_2cV___get_mut__h5afebdc50bacca04($0 | 0, $4 | 0) | 0;
       if (!$2) {
        break label$5
       }
       $9 = alloc__collections__btree__map__BTreeMap_K_2cV___get_mut__h36eb13302ff969d4($2 | 0, $1 | 0) | 0;
       if (!$9) {
        break label$5
       }
       label$6 : {
        label$7 : {
         i64toi32_i32$2 = $9;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $10 = i64toi32_i32$0;
         $10$hi = i64toi32_i32$1;
         i64toi32_i32$2 = $8;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $113 = i64toi32_i32$1;
         $113$hi = i64toi32_i32$0;
         i64toi32_i32$0 = $10$hi;
         i64toi32_i32$2 = $10;
         i64toi32_i32$1 = $113$hi;
         i64toi32_i32$3 = $113;
         i64toi32_i32$5 = (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) + i64toi32_i32$1 | 0;
         i64toi32_i32$5 = i64toi32_i32$0 - i64toi32_i32$5 | 0;
         $11 = i64toi32_i32$2 - i64toi32_i32$3 | 0;
         $11$hi = i64toi32_i32$5;
         i64toi32_i32$5 = i64toi32_i32$0;
         i64toi32_i32$5 = $11$hi;
         i64toi32_i32$0 = $11;
         i64toi32_i32$2 = $10$hi;
         i64toi32_i32$3 = $10;
         if (i64toi32_i32$5 >>> 0 > i64toi32_i32$2 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$0 >>> 0 > i64toi32_i32$3 >>> 0 | 0) | 0) {
          break label$7
         }
         i64toi32_i32$0 = $11$hi;
         if (!!($11 | i64toi32_i32$0 | 0)) {
          break label$6
         }
         alloc__collections__btree__map__BTreeMap_K_2cV___remove__h0ff09e7bc29e7fcf($3 + 40 | 0 | 0, $2 | 0, $1 | 0);
         if (HEAP32[($2 + 8 | 0) >> 2] | 0) {
          break label$5
         }
         alloc__collections__btree__map__BTreeMap_K_2cV___remove_entry__h831f61fb54926aec($3 + 216 | 0 | 0, $0 | 0, $4 | 0);
         if ((HEAP32[($3 + 216 | 0) >> 2] | 0 | 0) != (1 | 0)) {
          break label$5
         }
         memcpy($3 + 280 | 0 | 0, $6 | 0, 40 | 0) | 0;
         $2 = HEAP32[($5 + 8 | 0) >> 2] | 0;
         HEAP32[(($3 + 264 | 0) + 8 | 0) >> 2] = $2;
         i64toi32_i32$3 = $5;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $10 = i64toi32_i32$0;
         $10$hi = i64toi32_i32$5;
         i64toi32_i32$0 = $3;
         HEAP32[($3 + 264 | 0) >> 2] = $10;
         HEAP32[($3 + 268 | 0) >> 2] = i64toi32_i32$5;
         HEAP32[($7 + 8 | 0) >> 2] = $2;
         i64toi32_i32$0 = $7;
         HEAP32[i64toi32_i32$0 >> 2] = $10;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$5;
         HEAP32[($3 + 200 | 0) >> 2] = 1;
         $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h6c9f94f0f82ce2b5(i64toi32_i32$0 | 0);
         break label$5;
        }
        $8 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1058740 | 0, 9 | 0) | 0;
        alloc__collections__btree__map__BTreeMap_K_2cV___remove__h0ff09e7bc29e7fcf($3 + 24 | 0 | 0, $2 | 0, $1 | 0);
        label$8 : {
         if (HEAP32[($2 + 8 | 0) >> 2] | 0) {
          break label$8
         }
         alloc__collections__btree__map__BTreeMap_K_2cV___remove_entry__h831f61fb54926aec($3 + 216 | 0 | 0, $0 | 0, $4 | 0);
         if ((HEAP32[($3 + 216 | 0) >> 2] | 0 | 0) != (1 | 0)) {
          break label$8
         }
         memcpy($3 + 280 | 0 | 0, $6 | 0, 40 | 0) | 0;
         $2 = HEAP32[($5 + 8 | 0) >> 2] | 0;
         HEAP32[(($3 + 264 | 0) + 8 | 0) >> 2] = $2;
         i64toi32_i32$3 = $5;
         i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $10 = i64toi32_i32$5;
         $10$hi = i64toi32_i32$0;
         i64toi32_i32$5 = $3;
         HEAP32[($3 + 264 | 0) >> 2] = $10;
         HEAP32[($3 + 268 | 0) >> 2] = i64toi32_i32$0;
         HEAP32[($7 + 8 | 0) >> 2] = $2;
         i64toi32_i32$5 = $7;
         HEAP32[i64toi32_i32$5 >> 2] = $10;
         HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
         HEAP32[($3 + 200 | 0) >> 2] = 1;
         $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h6c9f94f0f82ce2b5(i64toi32_i32$5 | 0);
        }
        if ($8 >>> 0 < 36 >>> 0) {
         break label$5
        }
        wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($8 | 0);
        break label$5;
       }
       i64toi32_i32$0 = $11$hi;
       i64toi32_i32$5 = $9;
       HEAP32[i64toi32_i32$5 >> 2] = $11;
       HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
      }
      $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h36ca092f81b9a0fa($3 + 16 | 0 | 0, $3 + 168 | 0 | 0);
      $8 = HEAP32[($3 + 20 | 0) >> 2] | 0;
      $1 = HEAP32[($3 + 16 | 0) >> 2] | 0;
      if ($1) {
       continue label$4
      }
      break label$4;
     };
    }
    $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h03cc330b7b1e4522($3 + 8 | 0 | 0, $3 + 104 | 0 | 0);
    $2 = HEAP32[($3 + 12 | 0) >> 2] | 0;
    $4 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if ($4) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $3 + 320 | 0;
 }
 
 function cardano_serialization_lib__legacy_address__address__ExtendedAddr__new__h78aa0057fb94bbe4($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $5 = 0, i64toi32_i32$2 = 0, $17 = 0, $6 = 0, $18 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $25 = 0, $26 = 0, $4 = 0, $19 = 0, $57 = 0, $162 = 0, $166 = 0, $170 = 0, $185 = 0, $188 = 0;
  $3 = global$0;
  $4 = $3;
  $3 = ($3 - 640 | 0) & -32 | 0;
  global$0 = $3;
  HEAP8[($3 + 47 | 0) >> 0] = 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($3 + 8 | 0 | 0, 512 | 0, 0 | 0);
  HEAP32[($3 + 24 | 0) >> 2] = 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
  $19 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[($3 + 16 | 0) >> 2] = $19;
  HEAP32[($3 + 20 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($3 + 72 | 0) >> 2] = $2;
  HEAP32[($3 + 48 | 0) >> 2] = $1;
  HEAP32[($3 + 68 | 0) >> 2] = $3 + 48 | 0;
  HEAP32[($3 + 64 | 0) >> 2] = $3 + 47 | 0;
  $_28_A_2c_B_2c_C_29_20as_20cbor_event__se__Serialize___serialize__h6e5b7c5a6d89b7b1($3 + 320 | 0 | 0, $3 + 64 | 0 | 0, $3 + 16 | 0 | 0);
  $1 = 19;
  label$1 : {
   if ((HEAP32[($3 + 320 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   $1 = HEAPU8[($3 + 328 | 0) >> 0] | 0;
   memcpy($3 + 104 | 0 | 0, $3 + 329 | 0 | 0, 39 | 0) | 0;
  }
  $5 = ($3 + 320 | 0) + 8 | 0;
  HEAP32[$5 >> 2] = HEAP32[(($3 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[($3 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($3 + 20 | 0) >> 2] | 0;
  $57 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[($3 + 320 | 0) >> 2] = $57;
  HEAP32[($3 + 324 | 0) >> 2] = i64toi32_i32$0;
  label$2 : {
   label$3 : {
    if (($1 & 255 | 0 | 0) != (19 | 0)) {
     break label$3
    }
    HEAP32[($3 + 64 | 0) >> 2] = HEAPU8[($3 + 325 | 0) >> 0] | 0 | ((HEAPU8[($3 + 326 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 327 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 328 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $17 = HEAPU8[$5 >> 0] | 0 | ((HEAPU8[($5 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($5 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($5 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    HEAP8[($3 + 67 | 0) >> 0] = $17;
    HEAP8[($3 + 68 | 0) >> 0] = $17 >>> 8 | 0;
    HEAP8[($3 + 69 | 0) >> 0] = $17 >>> 16 | 0;
    HEAP8[($3 + 70 | 0) >> 0] = $17 >>> 24 | 0;
    $5 = HEAPU8[($3 + 324 | 0) >> 0] | 0;
    $6 = HEAP32[($3 + 320 | 0) >> 2] | 0;
    break label$2;
   }
   memcpy($3 + 64 | 0 | 0, $3 + 104 | 0 | 0, 39 | 0) | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 320 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 320 | 0 | 0);
   $5 = $1;
  }
  label$4 : {
   if (($1 & 255 | 0 | 0) == (19 | 0)) {
    break label$4
   }
   HEAP8[($3 + 320 | 0) >> 0] = $5;
   memcpy($3 + 320 | 0 | 1 | 0 | 0, $3 + 64 | 0 | 0, 39 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1072633 | 0, 46 | 0, $3 + 320 | 0 | 0, 1072092 | 0, 1072680 | 0);
   abort();
  }
  $18 = ($3 + 48 | 0) + 8 | 0;
  $20 = HEAPU8[($3 + 67 | 0) >> 0] | 0 | ((HEAPU8[($3 + 68 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 69 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 70 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  HEAP8[$18 >> 0] = $20;
  HEAP8[($18 + 1 | 0) >> 0] = $20 >>> 8 | 0;
  HEAP8[($18 + 2 | 0) >> 0] = $20 >>> 16 | 0;
  HEAP8[($18 + 3 | 0) >> 0] = $20 >>> 24 | 0;
  HEAP8[($3 + 52 | 0) >> 0] = $5;
  HEAP32[($3 + 48 | 0) >> 2] = $6;
  $21 = HEAP32[($3 + 64 | 0) >> 2] | 0;
  HEAP8[($3 + 53 | 0) >> 0] = $21;
  HEAP8[($3 + 54 | 0) >> 0] = $21 >>> 8 | 0;
  HEAP8[($3 + 55 | 0) >> 0] = $21 >>> 16 | 0;
  HEAP8[($3 + 56 | 0) >> 0] = $21 >>> 24 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 | 0, $3 + 48 | 0 | 0);
  $1 = HEAP32[($3 + 4 | 0) >> 2] | 0;
  $5 = HEAP32[$3 >> 2] | 0;
  cryptoxide__sha3__Sha3_256__new__hb1af8a9803a96acf($3 + 104 | 0 | 0);
  i64toi32_i32$1 = ($3 + 64 | 0) + 24 | 0;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$1 = ($3 + 64 | 0) + 16 | 0;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$1 = ($3 + 64 | 0) + 8 | 0;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  HEAP32[($3 + 64 | 0) >> 2] = 0;
  HEAP32[($3 + 68 | 0) >> 2] = i64toi32_i32$0;
  $cryptoxide__sha3__Sha3_256_20as_20cryptoxide__digest__Digest___input__hf816d8e33a17a244($3 + 104 | 0 | 0, $5 | 0, $1 | 0);
  $cryptoxide__sha3__Sha3_256_20as_20cryptoxide__digest__Digest___result__hacd163af1c76f2fe($3 + 104 | 0 | 0, $3 + 64 | 0 | 0, 32 | 0);
  cryptoxide__blake2b__Blake2b__new__h7b5a594785d7b8da($3 + 320 | 0 | 0, 28 | 0);
  $1 = ($3 + 16 | 0) + 24 | 0;
  HEAP32[$1 >> 2] = 0;
  $5 = ($3 + 16 | 0) + 16 | 0;
  i64toi32_i32$1 = $5;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $6 = ($3 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = $6;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  HEAP32[($3 + 16 | 0) >> 2] = 0;
  HEAP32[($3 + 20 | 0) >> 2] = i64toi32_i32$0;
  $cryptoxide__blake2b__Blake2b_20as_20cryptoxide__digest__Digest___input__hf896b827e2ed32e6($3 + 320 | 0 | 0, $3 + 64 | 0 | 0, 32 | 0);
  $cryptoxide__blake2b__Blake2b_20as_20cryptoxide__digest__Digest___result__h730aa000117361cb($3 + 320 | 0 | 0, $3 + 16 | 0 | 0, 28 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 48 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 48 | 0 | 0);
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[($3 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($3 + 20 | 0) >> 2] | 0;
  $162 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  $22 = $162;
  HEAP8[(i64toi32_i32$0 + 20 | 0) >> 0] = $22;
  HEAP8[(i64toi32_i32$0 + 21 | 0) >> 0] = $22 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 22 | 0) >> 0] = $22 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 23 | 0) >> 0] = $22 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 24 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 25 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 26 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 27 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $6;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $166 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 28 | 0;
  $23 = $166;
  HEAP8[i64toi32_i32$1 >> 0] = $23;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $23 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $23 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $23 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = HEAP32[$5 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($5 + 4 | 0) >> 2] | 0;
  $170 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 36 | 0;
  $24 = $170;
  HEAP8[i64toi32_i32$0 >> 0] = $24;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $24 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $24 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $24 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $25 = $0 + 44 | 0;
  $26 = HEAP32[$1 >> 2] | 0;
  HEAP8[$25 >> 0] = $26;
  HEAP8[($25 + 1 | 0) >> 0] = $26 >>> 8 | 0;
  HEAP8[($25 + 2 | 0) >> 0] = $26 >>> 16 | 0;
  HEAP8[($25 + 3 | 0) >> 0] = $26 >>> 24 | 0;
  HEAP8[($0 + 48 | 0) >> 0] = 0;
  HEAP32[($0 + 16 | 0) >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $185 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $185;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $188 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $188;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $4;
 }
 
 function cardano_serialization_lib__Transaction__new__h1cddc40f64679f42($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $5 = 0, $6 = 0, $6$hi = 0, $69 = 0, $72 = 0, $100 = 0, $103 = 0, $106 = 0, $156 = 0, $159 = 0;
  $4 = global$0 - 512 | 0;
  global$0 = $4;
  $cardano_serialization_lib__TransactionBody_20as_20core__clone__Clone___clone__h8541427cda4fbd03($4 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    if (HEAP32[$2 >> 2] | 0) {
     break label$2
    }
    HEAP32[($4 + 480 | 0) >> 2] = 0;
    break label$1;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h26733a351c1d0f0b($4 + 480 | 0 | 0, $2 | 0);
  }
  $1 = $2 + 24 | 0;
  label$3 : {
   label$4 : {
    $5 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    if ($5) {
     break label$4
    }
    HEAP32[($4 + 496 | 0) >> 2] = 0;
    break label$3;
   }
   alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($4 + 496 | 0 | 0, $5 | 0, HEAP32[($2 + 20 | 0) >> 2] | 0 | 0);
  }
  label$5 : {
   label$6 : {
    if (HEAP32[$1 >> 2] | 0) {
     break label$6
    }
    HEAP32[($4 + 352 | 0) >> 2] = 0;
    break label$5;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h09a8331f58cd0bf4($4 + 352 | 0 | 0, $1 | 0);
  }
  label$7 : {
   label$8 : {
    if (HEAP32[($2 + 36 | 0) >> 2] | 0) {
     break label$8
    }
    HEAP32[($4 + 308 | 0) >> 2] = 0;
    break label$7;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hc722e22117ee5940(($4 + 272 | 0) + 36 | 0 | 0, $2 + 36 | 0 | 0);
  }
  $1 = $2 + 64 | 0;
  label$9 : {
   label$10 : {
    if ((HEAPU8[($2 + 60 | 0) >> 0] | 0 | 0) != (3 | 0)) {
     break label$10
    }
    HEAP8[(($4 + 272 | 0) + 60 | 0) >> 0] = 3;
    break label$9;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hc831120dea694494($4 + 416 | 0 | 0, $2 + 48 | 0 | 0);
   $2 = HEAPU8[($2 + 60 | 0) >> 0] | 0;
   HEAP8[($4 + 428 | 0) >> 0] = ($2 | 0) == (2 | 0) ? 2 : ($2 | 0) != (0 | 0);
   i64toi32_i32$2 = $4 + 424 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $69 = i64toi32_i32$0;
   i64toi32_i32$0 = $4 + 328 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $69;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $4;
   i64toi32_i32$1 = HEAP32[($4 + 416 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($4 + 420 | 0) >> 2] | 0;
   $72 = i64toi32_i32$1;
   i64toi32_i32$1 = $4;
   HEAP32[($4 + 320 | 0) >> 2] = $72;
   HEAP32[($4 + 324 | 0) >> 2] = i64toi32_i32$0;
  }
  label$11 : {
   label$12 : {
    if (HEAP32[$1 >> 2] | 0) {
     break label$12
    }
    HEAP32[($4 + 336 | 0) >> 2] = 0;
    break label$11;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h1b9d2509f9812649($4 + 336 | 0 | 0, $1 | 0);
  }
  HEAP32[(($4 + 272 | 0) + 8 | 0) >> 2] = HEAP32[(($4 + 480 | 0) + 8 | 0) >> 2] | 0;
  HEAP32[($4 + 292 | 0) >> 2] = HEAP32[(($4 + 496 | 0) + 8 | 0) >> 2] | 0;
  HEAP32[($4 + 304 | 0) >> 2] = HEAP32[(($4 + 352 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[($4 + 480 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($4 + 484 | 0) >> 2] | 0;
  $100 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[($4 + 272 | 0) >> 2] = $100;
  HEAP32[($4 + 276 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = HEAP32[($4 + 496 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($4 + 500 | 0) >> 2] | 0;
  $103 = i64toi32_i32$1;
  i64toi32_i32$1 = $4;
  HEAP32[($4 + 284 | 0) >> 2] = $103;
  HEAP32[($4 + 288 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[($4 + 352 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($4 + 356 | 0) >> 2] | 0;
  $106 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[($4 + 296 | 0) >> 2] = $106;
  HEAP32[($4 + 300 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  $6 = 0;
  $6$hi = i64toi32_i32$1;
  label$13 : {
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   i64toi32_i32$2 = i64toi32_i32$1;
   i64toi32_i32$1 = 0;
   if ((i64toi32_i32$2 | 0) != (1 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | 0) {
    break label$13
   }
   label$14 : {
    label$15 : {
     if (HEAP32[($3 + 28 | 0) >> 2] | 0) {
      break label$15
     }
     HEAP32[($4 + 372 | 0) >> 2] = 0;
     break label$14;
    }
    $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h44c6d4679ef9fae6($4 + 352 | 0 | 0, $3 + 8 | 0 | 0);
   }
   $2 = $3 + 60 | 0;
   label$16 : {
    label$17 : {
     $1 = HEAP32[($3 + 48 | 0) >> 2] | 0;
     if ($1) {
      break label$17
     }
     HEAP32[($4 + 480 | 0) >> 2] = 0;
     break label$16;
    }
    alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($4 + 480 | 0 | 0, $1 | 0, HEAP32[($3 + 56 | 0) >> 2] | 0 | 0);
   }
   label$18 : {
    label$19 : {
     if (HEAP32[$2 >> 2] | 0) {
      break label$19
     }
     HEAP32[($4 + 496 | 0) >> 2] = 0;
     break label$18;
    }
    $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hc722e22117ee5940($4 + 496 | 0 | 0, $2 | 0);
   }
   memcpy($4 + 416 | 0 | 0, $4 + 352 | 0 | 0, 40 | 0) | 0;
   HEAP32[($4 + 464 | 0) >> 2] = HEAP32[(($4 + 480 | 0) + 8 | 0) >> 2] | 0;
   HEAP32[($4 + 476 | 0) >> 2] = HEAP32[(($4 + 496 | 0) + 8 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($4 + 480 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($4 + 484 | 0) >> 2] | 0;
   $156 = i64toi32_i32$2;
   i64toi32_i32$2 = $4;
   HEAP32[($4 + 456 | 0) >> 2] = $156;
   HEAP32[($4 + 460 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = HEAP32[($4 + 496 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($4 + 500 | 0) >> 2] | 0;
   $159 = i64toi32_i32$0;
   i64toi32_i32$0 = $4;
   HEAP32[($4 + 468 | 0) >> 2] = $159;
   HEAP32[($4 + 472 | 0) >> 2] = i64toi32_i32$2;
   memcpy($4 + 352 | 0 | 0, $4 + 416 | 0 | 0, 64 | 0) | 0;
   i64toi32_i32$2 = 0;
   $6 = 1;
   $6$hi = i64toi32_i32$2;
  }
  $2 = memcpy($0 | 0, $4 | 0, 272 | 0) | 0;
  memcpy($2 + 344 | 0 | 0, $4 + 272 | 0 | 0, 76 | 0) | 0;
  i64toi32_i32$2 = $6$hi;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 272 | 0) >> 2] = $6;
  HEAP32[($2 + 276 | 0) >> 2] = i64toi32_i32$2;
  HEAP8[($2 + 420 | 0) >> 0] = 1;
  memcpy($2 + 280 | 0 | 0, $4 + 352 | 0 | 0, 64 | 0) | 0;
  core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__metadata__AuxiliaryData____ha98f6c5d89b7a772($3 | 0);
  global$0 = $4 + 512 | 0;
 }
 
 function hashbrown__raw__RawTable_T_2cA___rehash_in_place__h7ea6576ba60d582c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $10 = 0, $7 = 0, $9 = 0, $3 = 0, $8 = 0, $5 = 0, $6 = 0, i64toi32_i32$0 = 0, $2 = 0, $13 = 0, $4 = 0, i64toi32_i32$1 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $11 = 0, $12 = 0, $15 = 0, $14 = 0, $180 = 0, $198 = 0, $220 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $3 = HEAP32[$0 >> 2] | 0;
  $4 = $3 + 1 | 0;
  core__iter__adapters__step_by__StepBy_I___new__h21a520baea7dc9f1($2 | 0, 0 | 0, $4 | 0, 4 | 0);
  $5 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  $6 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $7 = HEAP32[$2 >> 2] | 0;
  $8 = !(HEAPU8[($2 + 12 | 0) >> 0] | 0);
  $9 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  label$1 : while (1) {
   label$2 : {
    label$3 : {
     label$4 : {
      if (!($8 & 1 | 0)) {
       break label$4
      }
      $10 = $7 + ($T_20as_20core__convert__From_T____from__h09bdeba94dd58819($5 | 0) | 0) | 0;
      if ($10 >>> 0 < $7 >>> 0) {
       break label$3
      }
      if ($10 >>> 0 >= $6 >>> 0) {
       break label$3
      }
      break label$2;
     }
     $10 = $7;
     if ($10 >>> 0 < $6 >>> 0) {
      break label$2
     }
    }
    label$5 : {
     label$6 : {
      label$7 : {
       if ($4 >>> 0 < 4 >>> 0) {
        break label$7
       }
       $21 = $9 + $4 | 0;
       $22 = HEAPU8[$9 >> 0] | 0 | ((HEAPU8[($9 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($9 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($9 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       HEAP8[$21 >> 0] = $22;
       HEAP8[($21 + 1 | 0) >> 0] = $22 >>> 8 | 0;
       HEAP8[($21 + 2 | 0) >> 0] = $22 >>> 16 | 0;
       HEAP8[($21 + 3 | 0) >> 0] = $22 >>> 24 | 0;
       break label$6;
      }
      memmove($9 + 4 | 0 | 0, $9 | 0, $4 | 0) | 0;
      if (!$4) {
       break label$5
      }
     }
     $11 = $9 + -8 | 0;
     $10 = 0;
     label$8 : while (1) {
      label$9 : {
       $6 = $10;
       $12 = $9 + $10 | 0;
       if ((HEAPU8[$12 >> 0] | 0 | 0) != (128 | 0)) {
        break label$9
       }
       $13 = $11 - ($6 << 3 | 0) | 0;
       $14 = $13 + 4 | 0;
       label$10 : while (1) {
        i64toi32_i32$0 = hashbrown__map__make_hash__h16f0f4baf07b5eeb($1 | 0, $13 | 0) | 0;
        i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
        $15 = i64toi32_i32$0;
        $5 = $3 & i64toi32_i32$0 | 0;
        $7 = $5;
        label$11 : {
         $23 = $9 + $7 | 0;
         $8 = (HEAPU8[$23 >> 0] | 0 | ((HEAPU8[($23 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($23 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($23 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
         if ($8) {
          break label$11
         }
         $10 = 4;
         $7 = $5;
         label$12 : while (1) {
          $7 = $7 + $10 | 0;
          $10 = $10 + 4 | 0;
          $7 = $7 & $3 | 0;
          $24 = $9 + $7 | 0;
          $8 = (HEAPU8[$24 >> 0] | 0 | ((HEAPU8[($24 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($24 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($24 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
          if (!$8) {
           continue label$12
          }
          break label$12;
         };
        }
        label$13 : {
         $10 = (((__wasm_ctz_i32($8 | 0) | 0) >>> 3 | 0) + $7 | 0) & $3 | 0;
         if ((HEAP8[($9 + $10 | 0) >> 0] | 0 | 0) <= (-1 | 0)) {
          break label$13
         }
         $10 = (__wasm_ctz_i32((HEAP32[$9 >> 2] | 0) & -2139062144 | 0 | 0) | 0) >>> 3 | 0;
        }
        label$14 : {
         if (((($10 - $5 | 0) ^ ($6 - $5 | 0) | 0) & $3 | 0) >>> 0 >= 4 >>> 0) {
          break label$14
         }
         $10 = $15 >>> 25 | 0;
         HEAP8[$12 >> 0] = $10;
         HEAP8[(((($6 + -4 | 0) & $3 | 0) + $9 | 0) + 4 | 0) >> 0] = $10;
         break label$9;
        }
        $7 = $9 + $10 | 0;
        $8 = HEAPU8[$7 >> 0] | 0;
        $5 = $15 >>> 25 | 0;
        HEAP8[$7 >> 0] = $5;
        HEAP8[(((($10 + -4 | 0) & $3 | 0) + $9 | 0) + 4 | 0) >> 0] = $5;
        label$15 : {
         if (($8 | 0) == (255 | 0)) {
          break label$15
         }
         $10 = $11 - ($10 << 3 | 0) | 0;
         $7 = HEAP32[($10 + 4 | 0) >> 2] | 0;
         $8 = HEAP32[$10 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[$13 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($13 + 4 | 0) >> 2] | 0;
         $180 = i64toi32_i32$1;
         i64toi32_i32$1 = $10;
         HEAP32[$10 >> 2] = $180;
         HEAP32[($10 + 4 | 0) >> 2] = i64toi32_i32$0;
         HEAP32[$13 >> 2] = $8;
         HEAP32[$14 >> 2] = $7;
         continue label$10;
        }
        break label$10;
       };
       HEAP8[$12 >> 0] = 255;
       HEAP8[(((($6 + -4 | 0) & $3 | 0) + $9 | 0) + 4 | 0) >> 0] = 255;
       i64toi32_i32$0 = HEAP32[$13 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($13 + 4 | 0) >> 2] | 0;
       $198 = i64toi32_i32$0;
       i64toi32_i32$0 = $11 - ($10 << 3 | 0) | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $198;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      }
      $10 = $6 + 1 | 0;
      if (($6 | 0) != ($3 | 0)) {
       continue label$8
      }
      break label$8;
     };
    }
    HEAP32[($0 + 8 | 0) >> 2] = ($3 >>> 0 < 8 >>> 0 ? $3 : Math_imul($4 >>> 3 | 0, 7)) - (HEAP32[($0 + 12 | 0) >> 2] | 0) | 0;
    global$0 = $2 + 16 | 0;
    return;
   }
   $7 = $9 + $10 | 0;
   $220 = $7;
   $7 = HEAP32[$7 >> 2] | 0;
   HEAP32[$220 >> 2] = ((($7 >>> 7 | 0) ^ -1 | 0) & 16843009 | 0) + ($7 | 2139062143 | 0) | 0;
   $8 = 1;
   $7 = $10 + 1 | 0;
   continue label$1;
  };
 }
 
 function hashbrown__raw__RawTable_T_2cA___rehash_in_place__haec697783d339c16($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $10 = 0, $7 = 0, $9 = 0, $3 = 0, $8 = 0, $5 = 0, $6 = 0, i64toi32_i32$0 = 0, $2 = 0, $13 = 0, $4 = 0, i64toi32_i32$1 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $11 = 0, $12 = 0, $15 = 0, $14 = 0, $180 = 0, $198 = 0, $220 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $3 = HEAP32[$0 >> 2] | 0;
  $4 = $3 + 1 | 0;
  core__iter__adapters__step_by__StepBy_I___new__h21a520baea7dc9f1($2 | 0, 0 | 0, $4 | 0, 4 | 0);
  $5 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  $6 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $7 = HEAP32[$2 >> 2] | 0;
  $8 = !(HEAPU8[($2 + 12 | 0) >> 0] | 0);
  $9 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  label$1 : while (1) {
   label$2 : {
    label$3 : {
     label$4 : {
      if (!($8 & 1 | 0)) {
       break label$4
      }
      $10 = $7 + ($T_20as_20core__convert__From_T____from__h09bdeba94dd58819($5 | 0) | 0) | 0;
      if ($10 >>> 0 < $7 >>> 0) {
       break label$3
      }
      if ($10 >>> 0 >= $6 >>> 0) {
       break label$3
      }
      break label$2;
     }
     $10 = $7;
     if ($10 >>> 0 < $6 >>> 0) {
      break label$2
     }
    }
    label$5 : {
     label$6 : {
      label$7 : {
       if ($4 >>> 0 < 4 >>> 0) {
        break label$7
       }
       $21 = $9 + $4 | 0;
       $22 = HEAPU8[$9 >> 0] | 0 | ((HEAPU8[($9 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($9 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($9 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       HEAP8[$21 >> 0] = $22;
       HEAP8[($21 + 1 | 0) >> 0] = $22 >>> 8 | 0;
       HEAP8[($21 + 2 | 0) >> 0] = $22 >>> 16 | 0;
       HEAP8[($21 + 3 | 0) >> 0] = $22 >>> 24 | 0;
       break label$6;
      }
      memmove($9 + 4 | 0 | 0, $9 | 0, $4 | 0) | 0;
      if (!$4) {
       break label$5
      }
     }
     $11 = $9 + -8 | 0;
     $10 = 0;
     label$8 : while (1) {
      label$9 : {
       $6 = $10;
       $12 = $9 + $10 | 0;
       if ((HEAPU8[$12 >> 0] | 0 | 0) != (128 | 0)) {
        break label$9
       }
       $13 = $11 - ($6 << 3 | 0) | 0;
       $14 = $13 + 4 | 0;
       label$10 : while (1) {
        i64toi32_i32$0 = hashbrown__map__make_hash__h5f7c8b88d87207db($1 | 0, $13 | 0) | 0;
        i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
        $15 = i64toi32_i32$0;
        $5 = $3 & i64toi32_i32$0 | 0;
        $7 = $5;
        label$11 : {
         $23 = $9 + $7 | 0;
         $8 = (HEAPU8[$23 >> 0] | 0 | ((HEAPU8[($23 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($23 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($23 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
         if ($8) {
          break label$11
         }
         $10 = 4;
         $7 = $5;
         label$12 : while (1) {
          $7 = $7 + $10 | 0;
          $10 = $10 + 4 | 0;
          $7 = $7 & $3 | 0;
          $24 = $9 + $7 | 0;
          $8 = (HEAPU8[$24 >> 0] | 0 | ((HEAPU8[($24 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($24 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($24 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
          if (!$8) {
           continue label$12
          }
          break label$12;
         };
        }
        label$13 : {
         $10 = (((__wasm_ctz_i32($8 | 0) | 0) >>> 3 | 0) + $7 | 0) & $3 | 0;
         if ((HEAP8[($9 + $10 | 0) >> 0] | 0 | 0) <= (-1 | 0)) {
          break label$13
         }
         $10 = (__wasm_ctz_i32((HEAP32[$9 >> 2] | 0) & -2139062144 | 0 | 0) | 0) >>> 3 | 0;
        }
        label$14 : {
         if (((($10 - $5 | 0) ^ ($6 - $5 | 0) | 0) & $3 | 0) >>> 0 >= 4 >>> 0) {
          break label$14
         }
         $10 = $15 >>> 25 | 0;
         HEAP8[$12 >> 0] = $10;
         HEAP8[(((($6 + -4 | 0) & $3 | 0) + $9 | 0) + 4 | 0) >> 0] = $10;
         break label$9;
        }
        $7 = $9 + $10 | 0;
        $8 = HEAPU8[$7 >> 0] | 0;
        $5 = $15 >>> 25 | 0;
        HEAP8[$7 >> 0] = $5;
        HEAP8[(((($10 + -4 | 0) & $3 | 0) + $9 | 0) + 4 | 0) >> 0] = $5;
        label$15 : {
         if (($8 | 0) == (255 | 0)) {
          break label$15
         }
         $10 = $11 - ($10 << 3 | 0) | 0;
         $7 = HEAP32[($10 + 4 | 0) >> 2] | 0;
         $8 = HEAP32[$10 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[$13 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($13 + 4 | 0) >> 2] | 0;
         $180 = i64toi32_i32$1;
         i64toi32_i32$1 = $10;
         HEAP32[$10 >> 2] = $180;
         HEAP32[($10 + 4 | 0) >> 2] = i64toi32_i32$0;
         HEAP32[$13 >> 2] = $8;
         HEAP32[$14 >> 2] = $7;
         continue label$10;
        }
        break label$10;
       };
       HEAP8[$12 >> 0] = 255;
       HEAP8[(((($6 + -4 | 0) & $3 | 0) + $9 | 0) + 4 | 0) >> 0] = 255;
       i64toi32_i32$0 = HEAP32[$13 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($13 + 4 | 0) >> 2] | 0;
       $198 = i64toi32_i32$0;
       i64toi32_i32$0 = $11 - ($10 << 3 | 0) | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $198;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      }
      $10 = $6 + 1 | 0;
      if (($6 | 0) != ($3 | 0)) {
       continue label$8
      }
      break label$8;
     };
    }
    HEAP32[($0 + 8 | 0) >> 2] = ($3 >>> 0 < 8 >>> 0 ? $3 : Math_imul($4 >>> 3 | 0, 7)) - (HEAP32[($0 + 12 | 0) >> 2] | 0) | 0;
    global$0 = $2 + 16 | 0;
    return;
   }
   $7 = $9 + $10 | 0;
   $220 = $7;
   $7 = HEAP32[$7 >> 2] | 0;
   HEAP32[$220 >> 2] = ((($7 >>> 7 | 0) ^ -1 | 0) & 16843009 | 0) + ($7 | 2139062143 | 0) | 0;
   $8 = 1;
   $7 = $10 + 1 | 0;
   continue label$1;
  };
 }
 
 function hashbrown__raw__RawTable_T_2cA___rehash_in_place__hb19b3af64e2051bd($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $10 = 0, $7 = 0, $9 = 0, $3 = 0, $8 = 0, $5 = 0, $6 = 0, i64toi32_i32$0 = 0, $2 = 0, $13 = 0, $4 = 0, i64toi32_i32$1 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $11 = 0, $12 = 0, $15 = 0, $14 = 0, $180 = 0, $198 = 0, $220 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $3 = HEAP32[$0 >> 2] | 0;
  $4 = $3 + 1 | 0;
  core__iter__adapters__step_by__StepBy_I___new__h21a520baea7dc9f1($2 | 0, 0 | 0, $4 | 0, 4 | 0);
  $5 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  $6 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $7 = HEAP32[$2 >> 2] | 0;
  $8 = !(HEAPU8[($2 + 12 | 0) >> 0] | 0);
  $9 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  label$1 : while (1) {
   label$2 : {
    label$3 : {
     label$4 : {
      if (!($8 & 1 | 0)) {
       break label$4
      }
      $10 = $7 + ($T_20as_20core__convert__From_T____from__h09bdeba94dd58819($5 | 0) | 0) | 0;
      if ($10 >>> 0 < $7 >>> 0) {
       break label$3
      }
      if ($10 >>> 0 >= $6 >>> 0) {
       break label$3
      }
      break label$2;
     }
     $10 = $7;
     if ($10 >>> 0 < $6 >>> 0) {
      break label$2
     }
    }
    label$5 : {
     label$6 : {
      label$7 : {
       if ($4 >>> 0 < 4 >>> 0) {
        break label$7
       }
       $21 = $9 + $4 | 0;
       $22 = HEAPU8[$9 >> 0] | 0 | ((HEAPU8[($9 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($9 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($9 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       HEAP8[$21 >> 0] = $22;
       HEAP8[($21 + 1 | 0) >> 0] = $22 >>> 8 | 0;
       HEAP8[($21 + 2 | 0) >> 0] = $22 >>> 16 | 0;
       HEAP8[($21 + 3 | 0) >> 0] = $22 >>> 24 | 0;
       break label$6;
      }
      memmove($9 + 4 | 0 | 0, $9 | 0, $4 | 0) | 0;
      if (!$4) {
       break label$5
      }
     }
     $11 = $9 + -8 | 0;
     $10 = 0;
     label$8 : while (1) {
      label$9 : {
       $6 = $10;
       $12 = $9 + $10 | 0;
       if ((HEAPU8[$12 >> 0] | 0 | 0) != (128 | 0)) {
        break label$9
       }
       $13 = $11 - ($6 << 3 | 0) | 0;
       $14 = $13 + 4 | 0;
       label$10 : while (1) {
        i64toi32_i32$0 = hashbrown__map__make_hash__ha3ef0991d7baec61($1 | 0, $13 | 0) | 0;
        i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
        $15 = i64toi32_i32$0;
        $5 = $3 & i64toi32_i32$0 | 0;
        $7 = $5;
        label$11 : {
         $23 = $9 + $7 | 0;
         $8 = (HEAPU8[$23 >> 0] | 0 | ((HEAPU8[($23 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($23 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($23 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
         if ($8) {
          break label$11
         }
         $10 = 4;
         $7 = $5;
         label$12 : while (1) {
          $7 = $7 + $10 | 0;
          $10 = $10 + 4 | 0;
          $7 = $7 & $3 | 0;
          $24 = $9 + $7 | 0;
          $8 = (HEAPU8[$24 >> 0] | 0 | ((HEAPU8[($24 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($24 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($24 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
          if (!$8) {
           continue label$12
          }
          break label$12;
         };
        }
        label$13 : {
         $10 = (((__wasm_ctz_i32($8 | 0) | 0) >>> 3 | 0) + $7 | 0) & $3 | 0;
         if ((HEAP8[($9 + $10 | 0) >> 0] | 0 | 0) <= (-1 | 0)) {
          break label$13
         }
         $10 = (__wasm_ctz_i32((HEAP32[$9 >> 2] | 0) & -2139062144 | 0 | 0) | 0) >>> 3 | 0;
        }
        label$14 : {
         if (((($10 - $5 | 0) ^ ($6 - $5 | 0) | 0) & $3 | 0) >>> 0 >= 4 >>> 0) {
          break label$14
         }
         $10 = $15 >>> 25 | 0;
         HEAP8[$12 >> 0] = $10;
         HEAP8[(((($6 + -4 | 0) & $3 | 0) + $9 | 0) + 4 | 0) >> 0] = $10;
         break label$9;
        }
        $7 = $9 + $10 | 0;
        $8 = HEAPU8[$7 >> 0] | 0;
        $5 = $15 >>> 25 | 0;
        HEAP8[$7 >> 0] = $5;
        HEAP8[(((($10 + -4 | 0) & $3 | 0) + $9 | 0) + 4 | 0) >> 0] = $5;
        label$15 : {
         if (($8 | 0) == (255 | 0)) {
          break label$15
         }
         $10 = $11 - ($10 << 3 | 0) | 0;
         $7 = HEAP32[($10 + 4 | 0) >> 2] | 0;
         $8 = HEAP32[$10 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[$13 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($13 + 4 | 0) >> 2] | 0;
         $180 = i64toi32_i32$1;
         i64toi32_i32$1 = $10;
         HEAP32[$10 >> 2] = $180;
         HEAP32[($10 + 4 | 0) >> 2] = i64toi32_i32$0;
         HEAP32[$13 >> 2] = $8;
         HEAP32[$14 >> 2] = $7;
         continue label$10;
        }
        break label$10;
       };
       HEAP8[$12 >> 0] = 255;
       HEAP8[(((($6 + -4 | 0) & $3 | 0) + $9 | 0) + 4 | 0) >> 0] = 255;
       i64toi32_i32$0 = HEAP32[$13 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($13 + 4 | 0) >> 2] | 0;
       $198 = i64toi32_i32$0;
       i64toi32_i32$0 = $11 - ($10 << 3 | 0) | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $198;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      }
      $10 = $6 + 1 | 0;
      if (($6 | 0) != ($3 | 0)) {
       continue label$8
      }
      break label$8;
     };
    }
    HEAP32[($0 + 8 | 0) >> 2] = ($3 >>> 0 < 8 >>> 0 ? $3 : Math_imul($4 >>> 3 | 0, 7)) - (HEAP32[($0 + 12 | 0) >> 2] | 0) | 0;
    global$0 = $2 + 16 | 0;
    return;
   }
   $7 = $9 + $10 | 0;
   $220 = $7;
   $7 = HEAP32[$7 >> 2] | 0;
   HEAP32[$220 >> 2] = ((($7 >>> 7 | 0) ^ -1 | 0) & 16843009 | 0) + ($7 | 2139062143 | 0) | 0;
   $8 = 1;
   $7 = $10 + 1 | 0;
   continue label$1;
  };
 }
 
 function hashbrown__raw__RawTable_T_2cA___rehash_in_place__h221d94fac61a9274($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $10 = 0, $7 = 0, $9 = 0, $3 = 0, $8 = 0, $5 = 0, $6 = 0, i64toi32_i32$0 = 0, $2 = 0, $13 = 0, $4 = 0, i64toi32_i32$1 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $11 = 0, $12 = 0, $15 = 0, $14 = 0, $180 = 0, $198 = 0, $220 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $3 = HEAP32[$0 >> 2] | 0;
  $4 = $3 + 1 | 0;
  core__iter__adapters__step_by__StepBy_I___new__h21a520baea7dc9f1($2 | 0, 0 | 0, $4 | 0, 4 | 0);
  $5 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  $6 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $7 = HEAP32[$2 >> 2] | 0;
  $8 = !(HEAPU8[($2 + 12 | 0) >> 0] | 0);
  $9 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  label$1 : while (1) {
   label$2 : {
    label$3 : {
     label$4 : {
      if (!($8 & 1 | 0)) {
       break label$4
      }
      $10 = $7 + ($T_20as_20core__convert__From_T____from__h09bdeba94dd58819($5 | 0) | 0) | 0;
      if ($10 >>> 0 < $7 >>> 0) {
       break label$3
      }
      if ($10 >>> 0 >= $6 >>> 0) {
       break label$3
      }
      break label$2;
     }
     $10 = $7;
     if ($10 >>> 0 < $6 >>> 0) {
      break label$2
     }
    }
    label$5 : {
     label$6 : {
      label$7 : {
       if ($4 >>> 0 < 4 >>> 0) {
        break label$7
       }
       $21 = $9 + $4 | 0;
       $22 = HEAPU8[$9 >> 0] | 0 | ((HEAPU8[($9 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($9 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($9 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       HEAP8[$21 >> 0] = $22;
       HEAP8[($21 + 1 | 0) >> 0] = $22 >>> 8 | 0;
       HEAP8[($21 + 2 | 0) >> 0] = $22 >>> 16 | 0;
       HEAP8[($21 + 3 | 0) >> 0] = $22 >>> 24 | 0;
       break label$6;
      }
      memmove($9 + 4 | 0 | 0, $9 | 0, $4 | 0) | 0;
      if (!$4) {
       break label$5
      }
     }
     $11 = $9 + -8 | 0;
     $10 = 0;
     label$8 : while (1) {
      label$9 : {
       $6 = $10;
       $12 = $9 + $10 | 0;
       if ((HEAPU8[$12 >> 0] | 0 | 0) != (128 | 0)) {
        break label$9
       }
       $13 = $11 - ($6 << 3 | 0) | 0;
       $14 = $13 + 4 | 0;
       label$10 : while (1) {
        i64toi32_i32$0 = hashbrown__map__make_hash__hc29185c590e608df($1 | 0, $13 | 0) | 0;
        i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
        $15 = i64toi32_i32$0;
        $5 = $3 & i64toi32_i32$0 | 0;
        $7 = $5;
        label$11 : {
         $23 = $9 + $7 | 0;
         $8 = (HEAPU8[$23 >> 0] | 0 | ((HEAPU8[($23 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($23 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($23 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
         if ($8) {
          break label$11
         }
         $10 = 4;
         $7 = $5;
         label$12 : while (1) {
          $7 = $7 + $10 | 0;
          $10 = $10 + 4 | 0;
          $7 = $7 & $3 | 0;
          $24 = $9 + $7 | 0;
          $8 = (HEAPU8[$24 >> 0] | 0 | ((HEAPU8[($24 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($24 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($24 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
          if (!$8) {
           continue label$12
          }
          break label$12;
         };
        }
        label$13 : {
         $10 = (((__wasm_ctz_i32($8 | 0) | 0) >>> 3 | 0) + $7 | 0) & $3 | 0;
         if ((HEAP8[($9 + $10 | 0) >> 0] | 0 | 0) <= (-1 | 0)) {
          break label$13
         }
         $10 = (__wasm_ctz_i32((HEAP32[$9 >> 2] | 0) & -2139062144 | 0 | 0) | 0) >>> 3 | 0;
        }
        label$14 : {
         if (((($10 - $5 | 0) ^ ($6 - $5 | 0) | 0) & $3 | 0) >>> 0 >= 4 >>> 0) {
          break label$14
         }
         $10 = $15 >>> 25 | 0;
         HEAP8[$12 >> 0] = $10;
         HEAP8[(((($6 + -4 | 0) & $3 | 0) + $9 | 0) + 4 | 0) >> 0] = $10;
         break label$9;
        }
        $7 = $9 + $10 | 0;
        $8 = HEAPU8[$7 >> 0] | 0;
        $5 = $15 >>> 25 | 0;
        HEAP8[$7 >> 0] = $5;
        HEAP8[(((($10 + -4 | 0) & $3 | 0) + $9 | 0) + 4 | 0) >> 0] = $5;
        label$15 : {
         if (($8 | 0) == (255 | 0)) {
          break label$15
         }
         $10 = $11 - ($10 << 3 | 0) | 0;
         $7 = HEAP32[($10 + 4 | 0) >> 2] | 0;
         $8 = HEAP32[$10 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[$13 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($13 + 4 | 0) >> 2] | 0;
         $180 = i64toi32_i32$1;
         i64toi32_i32$1 = $10;
         HEAP32[$10 >> 2] = $180;
         HEAP32[($10 + 4 | 0) >> 2] = i64toi32_i32$0;
         HEAP32[$13 >> 2] = $8;
         HEAP32[$14 >> 2] = $7;
         continue label$10;
        }
        break label$10;
       };
       HEAP8[$12 >> 0] = 255;
       HEAP8[(((($6 + -4 | 0) & $3 | 0) + $9 | 0) + 4 | 0) >> 0] = 255;
       i64toi32_i32$0 = HEAP32[$13 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($13 + 4 | 0) >> 2] | 0;
       $198 = i64toi32_i32$0;
       i64toi32_i32$0 = $11 - ($10 << 3 | 0) | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $198;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      }
      $10 = $6 + 1 | 0;
      if (($6 | 0) != ($3 | 0)) {
       continue label$8
      }
      break label$8;
     };
    }
    HEAP32[($0 + 8 | 0) >> 2] = ($3 >>> 0 < 8 >>> 0 ? $3 : Math_imul($4 >>> 3 | 0, 7)) - (HEAP32[($0 + 12 | 0) >> 2] | 0) | 0;
    global$0 = $2 + 16 | 0;
    return;
   }
   $7 = $9 + $10 | 0;
   $220 = $7;
   $7 = HEAP32[$7 >> 2] | 0;
   HEAP32[$220 >> 2] = ((($7 >>> 7 | 0) ^ -1 | 0) & 16843009 | 0) + ($7 | 2139062143 | 0) | 0;
   $8 = 1;
   $7 = $10 + 1 | 0;
   continue label$1;
  };
 }
 
 function hashbrown__raw__RawTable_T_2cA___rehash_in_place__h848e040d15a86367($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $10 = 0, $7 = 0, $9 = 0, $3 = 0, $8 = 0, $5 = 0, $6 = 0, i64toi32_i32$0 = 0, $2 = 0, $13 = 0, $4 = 0, i64toi32_i32$1 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $11 = 0, $12 = 0, $15 = 0, $14 = 0, $180 = 0, $198 = 0, $220 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $3 = HEAP32[$0 >> 2] | 0;
  $4 = $3 + 1 | 0;
  core__iter__adapters__step_by__StepBy_I___new__h21a520baea7dc9f1($2 | 0, 0 | 0, $4 | 0, 4 | 0);
  $5 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  $6 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $7 = HEAP32[$2 >> 2] | 0;
  $8 = !(HEAPU8[($2 + 12 | 0) >> 0] | 0);
  $9 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  label$1 : while (1) {
   label$2 : {
    label$3 : {
     label$4 : {
      if (!($8 & 1 | 0)) {
       break label$4
      }
      $10 = $7 + ($T_20as_20core__convert__From_T____from__h09bdeba94dd58819($5 | 0) | 0) | 0;
      if ($10 >>> 0 < $7 >>> 0) {
       break label$3
      }
      if ($10 >>> 0 >= $6 >>> 0) {
       break label$3
      }
      break label$2;
     }
     $10 = $7;
     if ($10 >>> 0 < $6 >>> 0) {
      break label$2
     }
    }
    label$5 : {
     label$6 : {
      label$7 : {
       if ($4 >>> 0 < 4 >>> 0) {
        break label$7
       }
       $21 = $9 + $4 | 0;
       $22 = HEAPU8[$9 >> 0] | 0 | ((HEAPU8[($9 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($9 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($9 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       HEAP8[$21 >> 0] = $22;
       HEAP8[($21 + 1 | 0) >> 0] = $22 >>> 8 | 0;
       HEAP8[($21 + 2 | 0) >> 0] = $22 >>> 16 | 0;
       HEAP8[($21 + 3 | 0) >> 0] = $22 >>> 24 | 0;
       break label$6;
      }
      memmove($9 + 4 | 0 | 0, $9 | 0, $4 | 0) | 0;
      if (!$4) {
       break label$5
      }
     }
     $11 = $9 + -8 | 0;
     $10 = 0;
     label$8 : while (1) {
      label$9 : {
       $6 = $10;
       $12 = $9 + $10 | 0;
       if ((HEAPU8[$12 >> 0] | 0 | 0) != (128 | 0)) {
        break label$9
       }
       $13 = $11 - ($6 << 3 | 0) | 0;
       $14 = $13 + 4 | 0;
       label$10 : while (1) {
        i64toi32_i32$0 = hashbrown__map__make_hash__h98d8394e57bcc228($1 | 0, $13 | 0) | 0;
        i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
        $15 = i64toi32_i32$0;
        $5 = $3 & i64toi32_i32$0 | 0;
        $7 = $5;
        label$11 : {
         $23 = $9 + $7 | 0;
         $8 = (HEAPU8[$23 >> 0] | 0 | ((HEAPU8[($23 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($23 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($23 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
         if ($8) {
          break label$11
         }
         $10 = 4;
         $7 = $5;
         label$12 : while (1) {
          $7 = $7 + $10 | 0;
          $10 = $10 + 4 | 0;
          $7 = $7 & $3 | 0;
          $24 = $9 + $7 | 0;
          $8 = (HEAPU8[$24 >> 0] | 0 | ((HEAPU8[($24 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($24 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($24 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
          if (!$8) {
           continue label$12
          }
          break label$12;
         };
        }
        label$13 : {
         $10 = (((__wasm_ctz_i32($8 | 0) | 0) >>> 3 | 0) + $7 | 0) & $3 | 0;
         if ((HEAP8[($9 + $10 | 0) >> 0] | 0 | 0) <= (-1 | 0)) {
          break label$13
         }
         $10 = (__wasm_ctz_i32((HEAP32[$9 >> 2] | 0) & -2139062144 | 0 | 0) | 0) >>> 3 | 0;
        }
        label$14 : {
         if (((($10 - $5 | 0) ^ ($6 - $5 | 0) | 0) & $3 | 0) >>> 0 >= 4 >>> 0) {
          break label$14
         }
         $10 = $15 >>> 25 | 0;
         HEAP8[$12 >> 0] = $10;
         HEAP8[(((($6 + -4 | 0) & $3 | 0) + $9 | 0) + 4 | 0) >> 0] = $10;
         break label$9;
        }
        $7 = $9 + $10 | 0;
        $8 = HEAPU8[$7 >> 0] | 0;
        $5 = $15 >>> 25 | 0;
        HEAP8[$7 >> 0] = $5;
        HEAP8[(((($10 + -4 | 0) & $3 | 0) + $9 | 0) + 4 | 0) >> 0] = $5;
        label$15 : {
         if (($8 | 0) == (255 | 0)) {
          break label$15
         }
         $10 = $11 - ($10 << 3 | 0) | 0;
         $7 = HEAP32[($10 + 4 | 0) >> 2] | 0;
         $8 = HEAP32[$10 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[$13 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($13 + 4 | 0) >> 2] | 0;
         $180 = i64toi32_i32$1;
         i64toi32_i32$1 = $10;
         HEAP32[$10 >> 2] = $180;
         HEAP32[($10 + 4 | 0) >> 2] = i64toi32_i32$0;
         HEAP32[$13 >> 2] = $8;
         HEAP32[$14 >> 2] = $7;
         continue label$10;
        }
        break label$10;
       };
       HEAP8[$12 >> 0] = 255;
       HEAP8[(((($6 + -4 | 0) & $3 | 0) + $9 | 0) + 4 | 0) >> 0] = 255;
       i64toi32_i32$0 = HEAP32[$13 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($13 + 4 | 0) >> 2] | 0;
       $198 = i64toi32_i32$0;
       i64toi32_i32$0 = $11 - ($10 << 3 | 0) | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $198;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      }
      $10 = $6 + 1 | 0;
      if (($6 | 0) != ($3 | 0)) {
       continue label$8
      }
      break label$8;
     };
    }
    HEAP32[($0 + 8 | 0) >> 2] = ($3 >>> 0 < 8 >>> 0 ? $3 : Math_imul($4 >>> 3 | 0, 7)) - (HEAP32[($0 + 12 | 0) >> 2] | 0) | 0;
    global$0 = $2 + 16 | 0;
    return;
   }
   $7 = $9 + $10 | 0;
   $220 = $7;
   $7 = HEAP32[$7 >> 2] | 0;
   HEAP32[$220 >> 2] = ((($7 >>> 7 | 0) ^ -1 | 0) & 16843009 | 0) + ($7 | 2139062143 | 0) | 0;
   $8 = 1;
   $7 = $10 + 1 | 0;
   continue label$1;
  };
 }
 
 function hashbrown__raw__RawTable_T_2cA___rehash_in_place__hdaa6605ef49d78a4($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $10 = 0, $7 = 0, $9 = 0, $3 = 0, $8 = 0, $5 = 0, $6 = 0, i64toi32_i32$0 = 0, $2 = 0, $13 = 0, $4 = 0, i64toi32_i32$1 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $11 = 0, $12 = 0, $15 = 0, $14 = 0, $180 = 0, $198 = 0, $220 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $3 = HEAP32[$0 >> 2] | 0;
  $4 = $3 + 1 | 0;
  core__iter__adapters__step_by__StepBy_I___new__h21a520baea7dc9f1($2 | 0, 0 | 0, $4 | 0, 4 | 0);
  $5 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  $6 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $7 = HEAP32[$2 >> 2] | 0;
  $8 = !(HEAPU8[($2 + 12 | 0) >> 0] | 0);
  $9 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  label$1 : while (1) {
   label$2 : {
    label$3 : {
     label$4 : {
      if (!($8 & 1 | 0)) {
       break label$4
      }
      $10 = $7 + ($T_20as_20core__convert__From_T____from__h09bdeba94dd58819($5 | 0) | 0) | 0;
      if ($10 >>> 0 < $7 >>> 0) {
       break label$3
      }
      if ($10 >>> 0 >= $6 >>> 0) {
       break label$3
      }
      break label$2;
     }
     $10 = $7;
     if ($10 >>> 0 < $6 >>> 0) {
      break label$2
     }
    }
    label$5 : {
     label$6 : {
      label$7 : {
       if ($4 >>> 0 < 4 >>> 0) {
        break label$7
       }
       $21 = $9 + $4 | 0;
       $22 = HEAPU8[$9 >> 0] | 0 | ((HEAPU8[($9 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($9 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($9 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       HEAP8[$21 >> 0] = $22;
       HEAP8[($21 + 1 | 0) >> 0] = $22 >>> 8 | 0;
       HEAP8[($21 + 2 | 0) >> 0] = $22 >>> 16 | 0;
       HEAP8[($21 + 3 | 0) >> 0] = $22 >>> 24 | 0;
       break label$6;
      }
      memmove($9 + 4 | 0 | 0, $9 | 0, $4 | 0) | 0;
      if (!$4) {
       break label$5
      }
     }
     $11 = $9 + -8 | 0;
     $10 = 0;
     label$8 : while (1) {
      label$9 : {
       $6 = $10;
       $12 = $9 + $10 | 0;
       if ((HEAPU8[$12 >> 0] | 0 | 0) != (128 | 0)) {
        break label$9
       }
       $13 = $11 - ($6 << 3 | 0) | 0;
       $14 = $13 + 4 | 0;
       label$10 : while (1) {
        i64toi32_i32$0 = hashbrown__map__make_hash__hf66765788ec743b7($1 | 0, $13 | 0) | 0;
        i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
        $15 = i64toi32_i32$0;
        $5 = $3 & i64toi32_i32$0 | 0;
        $7 = $5;
        label$11 : {
         $23 = $9 + $7 | 0;
         $8 = (HEAPU8[$23 >> 0] | 0 | ((HEAPU8[($23 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($23 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($23 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
         if ($8) {
          break label$11
         }
         $10 = 4;
         $7 = $5;
         label$12 : while (1) {
          $7 = $7 + $10 | 0;
          $10 = $10 + 4 | 0;
          $7 = $7 & $3 | 0;
          $24 = $9 + $7 | 0;
          $8 = (HEAPU8[$24 >> 0] | 0 | ((HEAPU8[($24 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($24 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($24 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
          if (!$8) {
           continue label$12
          }
          break label$12;
         };
        }
        label$13 : {
         $10 = (((__wasm_ctz_i32($8 | 0) | 0) >>> 3 | 0) + $7 | 0) & $3 | 0;
         if ((HEAP8[($9 + $10 | 0) >> 0] | 0 | 0) <= (-1 | 0)) {
          break label$13
         }
         $10 = (__wasm_ctz_i32((HEAP32[$9 >> 2] | 0) & -2139062144 | 0 | 0) | 0) >>> 3 | 0;
        }
        label$14 : {
         if (((($10 - $5 | 0) ^ ($6 - $5 | 0) | 0) & $3 | 0) >>> 0 >= 4 >>> 0) {
          break label$14
         }
         $10 = $15 >>> 25 | 0;
         HEAP8[$12 >> 0] = $10;
         HEAP8[(((($6 + -4 | 0) & $3 | 0) + $9 | 0) + 4 | 0) >> 0] = $10;
         break label$9;
        }
        $7 = $9 + $10 | 0;
        $8 = HEAPU8[$7 >> 0] | 0;
        $5 = $15 >>> 25 | 0;
        HEAP8[$7 >> 0] = $5;
        HEAP8[(((($10 + -4 | 0) & $3 | 0) + $9 | 0) + 4 | 0) >> 0] = $5;
        label$15 : {
         if (($8 | 0) == (255 | 0)) {
          break label$15
         }
         $10 = $11 - ($10 << 3 | 0) | 0;
         $7 = HEAP32[($10 + 4 | 0) >> 2] | 0;
         $8 = HEAP32[$10 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[$13 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($13 + 4 | 0) >> 2] | 0;
         $180 = i64toi32_i32$1;
         i64toi32_i32$1 = $10;
         HEAP32[$10 >> 2] = $180;
         HEAP32[($10 + 4 | 0) >> 2] = i64toi32_i32$0;
         HEAP32[$13 >> 2] = $8;
         HEAP32[$14 >> 2] = $7;
         continue label$10;
        }
        break label$10;
       };
       HEAP8[$12 >> 0] = 255;
       HEAP8[(((($6 + -4 | 0) & $3 | 0) + $9 | 0) + 4 | 0) >> 0] = 255;
       i64toi32_i32$0 = HEAP32[$13 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($13 + 4 | 0) >> 2] | 0;
       $198 = i64toi32_i32$0;
       i64toi32_i32$0 = $11 - ($10 << 3 | 0) | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $198;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      }
      $10 = $6 + 1 | 0;
      if (($6 | 0) != ($3 | 0)) {
       continue label$8
      }
      break label$8;
     };
    }
    HEAP32[($0 + 8 | 0) >> 2] = ($3 >>> 0 < 8 >>> 0 ? $3 : Math_imul($4 >>> 3 | 0, 7)) - (HEAP32[($0 + 12 | 0) >> 2] | 0) | 0;
    global$0 = $2 + 16 | 0;
    return;
   }
   $7 = $9 + $10 | 0;
   $220 = $7;
   $7 = HEAP32[$7 >> 2] | 0;
   HEAP32[$220 >> 2] = ((($7 >>> 7 | 0) ^ -1 | 0) & 16843009 | 0) + ($7 | 2139062143 | 0) | 0;
   $8 = 1;
   $7 = $10 + 1 | 0;
   continue label$1;
  };
 }
 
 function hashbrown__raw__RawTable_T_2cA___rehash_in_place__he20b6634c1b2e53a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $10 = 0, $7 = 0, $9 = 0, $3 = 0, $8 = 0, $5 = 0, $6 = 0, i64toi32_i32$0 = 0, $2 = 0, $13 = 0, $4 = 0, i64toi32_i32$1 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $11 = 0, $12 = 0, $15 = 0, $14 = 0, $180 = 0, $198 = 0, $220 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $3 = HEAP32[$0 >> 2] | 0;
  $4 = $3 + 1 | 0;
  core__iter__adapters__step_by__StepBy_I___new__h21a520baea7dc9f1($2 | 0, 0 | 0, $4 | 0, 4 | 0);
  $5 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  $6 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $7 = HEAP32[$2 >> 2] | 0;
  $8 = !(HEAPU8[($2 + 12 | 0) >> 0] | 0);
  $9 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  label$1 : while (1) {
   label$2 : {
    label$3 : {
     label$4 : {
      if (!($8 & 1 | 0)) {
       break label$4
      }
      $10 = $7 + ($T_20as_20core__convert__From_T____from__h09bdeba94dd58819($5 | 0) | 0) | 0;
      if ($10 >>> 0 < $7 >>> 0) {
       break label$3
      }
      if ($10 >>> 0 >= $6 >>> 0) {
       break label$3
      }
      break label$2;
     }
     $10 = $7;
     if ($10 >>> 0 < $6 >>> 0) {
      break label$2
     }
    }
    label$5 : {
     label$6 : {
      label$7 : {
       if ($4 >>> 0 < 4 >>> 0) {
        break label$7
       }
       $21 = $9 + $4 | 0;
       $22 = HEAPU8[$9 >> 0] | 0 | ((HEAPU8[($9 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($9 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($9 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       HEAP8[$21 >> 0] = $22;
       HEAP8[($21 + 1 | 0) >> 0] = $22 >>> 8 | 0;
       HEAP8[($21 + 2 | 0) >> 0] = $22 >>> 16 | 0;
       HEAP8[($21 + 3 | 0) >> 0] = $22 >>> 24 | 0;
       break label$6;
      }
      memmove($9 + 4 | 0 | 0, $9 | 0, $4 | 0) | 0;
      if (!$4) {
       break label$5
      }
     }
     $11 = $9 + -8 | 0;
     $10 = 0;
     label$8 : while (1) {
      label$9 : {
       $6 = $10;
       $12 = $9 + $10 | 0;
       if ((HEAPU8[$12 >> 0] | 0 | 0) != (128 | 0)) {
        break label$9
       }
       $13 = $11 - ($6 << 3 | 0) | 0;
       $14 = $13 + 4 | 0;
       label$10 : while (1) {
        i64toi32_i32$0 = hashbrown__map__make_hash__h18de0e6f479ebafc($1 | 0, $13 | 0) | 0;
        i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
        $15 = i64toi32_i32$0;
        $5 = $3 & i64toi32_i32$0 | 0;
        $7 = $5;
        label$11 : {
         $23 = $9 + $7 | 0;
         $8 = (HEAPU8[$23 >> 0] | 0 | ((HEAPU8[($23 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($23 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($23 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
         if ($8) {
          break label$11
         }
         $10 = 4;
         $7 = $5;
         label$12 : while (1) {
          $7 = $7 + $10 | 0;
          $10 = $10 + 4 | 0;
          $7 = $7 & $3 | 0;
          $24 = $9 + $7 | 0;
          $8 = (HEAPU8[$24 >> 0] | 0 | ((HEAPU8[($24 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($24 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($24 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
          if (!$8) {
           continue label$12
          }
          break label$12;
         };
        }
        label$13 : {
         $10 = (((__wasm_ctz_i32($8 | 0) | 0) >>> 3 | 0) + $7 | 0) & $3 | 0;
         if ((HEAP8[($9 + $10 | 0) >> 0] | 0 | 0) <= (-1 | 0)) {
          break label$13
         }
         $10 = (__wasm_ctz_i32((HEAP32[$9 >> 2] | 0) & -2139062144 | 0 | 0) | 0) >>> 3 | 0;
        }
        label$14 : {
         if (((($10 - $5 | 0) ^ ($6 - $5 | 0) | 0) & $3 | 0) >>> 0 >= 4 >>> 0) {
          break label$14
         }
         $10 = $15 >>> 25 | 0;
         HEAP8[$12 >> 0] = $10;
         HEAP8[(((($6 + -4 | 0) & $3 | 0) + $9 | 0) + 4 | 0) >> 0] = $10;
         break label$9;
        }
        $7 = $9 + $10 | 0;
        $8 = HEAPU8[$7 >> 0] | 0;
        $5 = $15 >>> 25 | 0;
        HEAP8[$7 >> 0] = $5;
        HEAP8[(((($10 + -4 | 0) & $3 | 0) + $9 | 0) + 4 | 0) >> 0] = $5;
        label$15 : {
         if (($8 | 0) == (255 | 0)) {
          break label$15
         }
         $10 = $11 - ($10 << 3 | 0) | 0;
         $7 = HEAP32[($10 + 4 | 0) >> 2] | 0;
         $8 = HEAP32[$10 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[$13 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($13 + 4 | 0) >> 2] | 0;
         $180 = i64toi32_i32$1;
         i64toi32_i32$1 = $10;
         HEAP32[$10 >> 2] = $180;
         HEAP32[($10 + 4 | 0) >> 2] = i64toi32_i32$0;
         HEAP32[$13 >> 2] = $8;
         HEAP32[$14 >> 2] = $7;
         continue label$10;
        }
        break label$10;
       };
       HEAP8[$12 >> 0] = 255;
       HEAP8[(((($6 + -4 | 0) & $3 | 0) + $9 | 0) + 4 | 0) >> 0] = 255;
       i64toi32_i32$0 = HEAP32[$13 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($13 + 4 | 0) >> 2] | 0;
       $198 = i64toi32_i32$0;
       i64toi32_i32$0 = $11 - ($10 << 3 | 0) | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $198;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      }
      $10 = $6 + 1 | 0;
      if (($6 | 0) != ($3 | 0)) {
       continue label$8
      }
      break label$8;
     };
    }
    HEAP32[($0 + 8 | 0) >> 2] = ($3 >>> 0 < 8 >>> 0 ? $3 : Math_imul($4 >>> 3 | 0, 7)) - (HEAP32[($0 + 12 | 0) >> 2] | 0) | 0;
    global$0 = $2 + 16 | 0;
    return;
   }
   $7 = $9 + $10 | 0;
   $220 = $7;
   $7 = HEAP32[$7 >> 2] | 0;
   HEAP32[$220 >> 2] = ((($7 >>> 7 | 0) ^ -1 | 0) & 16843009 | 0) + ($7 | 2139062143 | 0) | 0;
   $8 = 1;
   $7 = $10 + 1 | 0;
   continue label$1;
  };
 }
 
 function num_bigint__biguint__shift__biguint_shr2__hd374167955c1e352($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $6 = 0, $7 = 0, $5 = 0, $9 = 0, $8 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $88 = 0, $10 = 0, $152 = 0, $203 = 0;
  $4 = global$0 - 64 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          $5 = $1 + 4 | 0;
          $6 = HEAP32[($1 + 4 | 0) >> 2] | 0;
          $7 = HEAP32[$1 >> 2] | 0;
          if ((HEAP32[((($7 | 0) == (1 | 0) ? $5 : $6) + 8 | 0) >> 2] | 0) >>> 0 <= $2 >>> 0) {
           break label$8
          }
          if ($7) {
           break label$7
          }
          $1 = HEAP32[($6 + 8 | 0) >> 2] | 0;
          if ($1 >>> 0 < $2 >>> 0) {
           break label$5
          }
          $7 = HEAP32[$6 >> 2] | 0;
          $6 = $1 - $2 | 0;
          alloc__raw_vec__RawVec_T_2cA___allocate_in__hb0817f92bbb8999a($4 + 8 | 0 | 0, $6 | 0, 0 | 0);
          $8 = HEAP32[($4 + 12 | 0) >> 2] | 0;
          $9 = HEAP32[($4 + 8 | 0) >> 2] | 0;
          memcpy($9 | 0, $7 + ($2 << 2 | 0) | 0 | 0, $6 << 2 | 0 | 0) | 0;
          break label$6;
         }
         label$9 : {
          label$10 : {
           if ($7) {
            break label$10
           }
           $2 = HEAP32[$6 >> 2] | 0;
           $7 = HEAP32[($6 + 8 | 0) >> 2] | 0;
           alloc__raw_vec__RawVec_T_2cA___allocate_in__hb0817f92bbb8999a($4 + 16 | 0 | 0, $7 | 0, 0 | 0);
           $1 = HEAP32[($4 + 20 | 0) >> 2] | 0;
           $6 = HEAP32[($4 + 16 | 0) >> 2] | 0;
           memcpy($6 | 0, $2 | 0, $7 << 2 | 0 | 0) | 0;
           break label$9;
          }
          $1 = HEAP32[($1 + 8 | 0) >> 2] | 0;
         }
         HEAP32[($0 + 8 | 0) >> 2] = 0;
         HEAP32[($0 + 4 | 0) >> 2] = $1;
         HEAP32[$0 >> 2] = $6;
         break label$1;
        }
        $6 = HEAP32[($5 + 8 | 0) >> 2] | 0;
        HEAP32[(($4 + 24 | 0) + 8 | 0) >> 2] = $6;
        i64toi32_i32$0 = HEAP32[$5 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($5 + 4 | 0) >> 2] | 0;
        $88 = i64toi32_i32$0;
        i64toi32_i32$0 = $4;
        HEAP32[($4 + 24 | 0) >> 2] = $88;
        HEAP32[($4 + 28 | 0) >> 2] = i64toi32_i32$1;
        if ($6 >>> 0 < $2 >>> 0) {
         break label$4
        }
        $1 = HEAP32[($4 + 24 | 0) >> 2] | 0;
        $7 = $1 + ($2 << 2 | 0) | 0;
        HEAP32[($4 + 52 | 0) >> 2] = $7;
        HEAP32[($4 + 32 | 0) >> 2] = 0;
        HEAP32[($4 + 48 | 0) >> 2] = $1;
        HEAP32[($4 + 40 | 0) >> 2] = $2;
        HEAP32[($4 + 44 | 0) >> 2] = $6 - $2 | 0;
        HEAP32[($4 + 56 | 0) >> 2] = $4 + 24 | 0;
        label$11 : {
         if (!$2) {
          break label$11
         }
         HEAP32[($4 + 48 | 0) >> 2] = (((($7 - $1 | 0) + -4 | 0) & -4 | 0) + $1 | 0) + 4 | 0;
        }
        HEAP32[($4 + 60 | 0) >> 2] = $4 + 40 | 0;
        $_alloc__vec__drain__Drain_T_2cA__20as_20core__ops__drop__Drop___drop__DropGuard_T_2cA__20as_20core__ops__drop__Drop___drop__h68f792ed4e68d59e($4 + 60 | 0 | 0);
        $9 = HEAP32[($4 + 24 | 0) >> 2] | 0;
        $8 = HEAP32[($4 + 28 | 0) >> 2] | 0;
        $6 = HEAP32[($4 + 32 | 0) >> 2] | 0;
       }
       label$12 : {
        if (!($3 & 255 | 0)) {
         break label$12
        }
        if (!$6) {
         break label$12
        }
        $5 = $9 + -4 | 0;
        $1 = $6 << 2 | 0;
        $10 = $3 & 31 | 0;
        $2 = 0;
        $3 = (0 - $3 | 0) & 31 | 0;
        label$13 : while (1) {
         $7 = $5 + $1 | 0;
         $152 = $7;
         $7 = HEAP32[$7 >> 2] | 0;
         HEAP32[$152 >> 2] = $7 >>> $10 | 0 | $2 | 0;
         $2 = $7 << $3 | 0;
         $1 = $1 + -4 | 0;
         if ($1) {
          continue label$13
         }
         break label$13;
        };
       }
       HEAP32[($4 + 48 | 0) >> 2] = $6;
       HEAP32[($4 + 44 | 0) >> 2] = $8;
       HEAP32[($4 + 40 | 0) >> 2] = $9;
       label$14 : {
        if ($6) {
         break label$14
        }
        $6 = 0;
        break label$2;
       }
       $1 = (($6 << 2 | 0) + $9 | 0) + -4 | 0;
       label$15 : while (1) {
        if (HEAP32[$1 >> 2] | 0) {
         break label$3
        }
        $1 = $1 + -4 | 0;
        $6 = $6 + -1 | 0;
        if ($6) {
         continue label$15
        }
        break label$15;
       };
       $6 = 0;
       break label$3;
      }
      core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($2 | 0, $1 | 0, 1077476 | 0);
      abort();
     }
     core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($2 | 0, $6 | 0, 1083480 | 0);
     abort();
    }
    HEAP32[($4 + 48 | 0) >> 2] = $6;
   }
   label$16 : {
    if ($6 >>> 0 >= ($8 >>> 2 | 0) >>> 0) {
     break label$16
    }
    if ($8 >>> 0 <= $6 >>> 0) {
     break label$16
    }
    alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($4 + 40 | 0 | 0, $6 | 0);
   }
   i64toi32_i32$1 = HEAP32[($4 + 40 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($4 + 44 | 0) >> 2] | 0;
   $203 = i64toi32_i32$1;
   i64toi32_i32$1 = $0;
   HEAP32[$0 >> 2] = $203;
   HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($0 + 8 | 0) >> 2] = HEAP32[(($4 + 40 | 0) + 8 | 0) >> 2] | 0;
  }
  global$0 = $4 + 64 | 0;
 }
 
 function linked_hash_map__LinkedHashMap_K_2cV_2cS___insert__h654f744b7b23f305($0, $1, $2, $3, $3$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $5 = 0, $4 = 0, $6 = 0, $7 = 0, $8 = 0, $8$hi = 0, $24 = 0, $25 = 0, $26 = 0, $27 = 0, $28 = 0, $29 = 0, $30 = 0, $144 = 0, $151 = 0, $9 = 0, $9$hi = 0, $168 = 0, $172 = 0, $181 = 0, $186 = 0, $191 = 0, $196 = 0;
  $4 = global$0 - 64 | 0;
  global$0 = $4;
  label$1 : {
   if (HEAP32[($1 + 32 | 0) >> 2] | 0) {
    break label$1
   }
   $5 = __rust_alloc(48 | 0, 8 | 0) | 0;
   HEAP32[($1 + 32 | 0) >> 2] = $5;
   HEAP32[($5 + 12 | 0) >> 2] = $5;
   HEAP32[($5 + 8 | 0) >> 2] = $5;
  }
  HEAP32[($4 + 28 | 0) >> 2] = $2;
  i64toi32_i32$0 = hashbrown__map__make_hash__hf66765788ec743b7($1 | 0, $4 + 28 | 0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  $6 = i64toi32_i32$0;
  $7 = (HEAP32[($1 + 16 | 0) >> 2] | 0) & i64toi32_i32$0 | 0;
  $24 = (HEAP32[($1 + 20 | 0) >> 2] | 0) + $7 | 0;
  $5 = HEAPU8[$24 >> 0] | 0 | ((HEAPU8[($24 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($24 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($24 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  HEAP32[($4 + 40 | 0) >> 2] = 0;
  HEAP32[($4 + 44 | 0) >> 2] = $5;
  HEAP32[($4 + 36 | 0) >> 2] = $7;
  HEAP32[($4 + 32 | 0) >> 2] = $1 + 16 | 0;
  $6 = i64toi32_i32$0 >>> 25 | 0;
  HEAP8[($4 + 52 | 0) >> 0] = $6;
  $5 = $5 ^ Math_imul($6, 16843009) | 0;
  HEAP32[($4 + 48 | 0) >> 2] = (($5 ^ -1 | 0) & ($5 + -16843009 | 0) | 0) & -2139062144 | 0;
  $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($4 + 16 | 0 | 0, $4 + 32 | 0 | 0);
  label$2 : {
   label$3 : {
    label$4 : {
     if (!(HEAP32[($4 + 16 | 0) >> 2] | 0)) {
      break label$4
     }
     label$5 : {
      $5 = (HEAP32[((HEAP32[($4 + 32 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) - ((HEAP32[($4 + 20 | 0) >> 2] | 0) << 3 | 0) | 0;
      if ($linked_hash_map__KeyRef_K__20as_20core__cmp__PartialEq___eq__h384b914ed9be434a($4 + 28 | 0 | 0, $5 + -8 | 0 | 0) | 0) {
       break label$5
      }
      label$6 : while (1) {
       $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($4 + 8 | 0 | 0, $4 + 32 | 0 | 0);
       if (!(HEAP32[($4 + 8 | 0) >> 2] | 0)) {
        break label$4
       }
       $5 = (HEAP32[((HEAP32[($4 + 32 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) - ((HEAP32[($4 + 12 | 0) >> 2] | 0) << 3 | 0) | 0;
       if (!($linked_hash_map__KeyRef_K__20as_20core__cmp__PartialEq___eq__h384b914ed9be434a($4 + 28 | 0 | 0, $5 + -8 | 0 | 0) | 0)) {
        continue label$6
       }
       break label$6;
      };
     }
     $5 = $5 + -4 | 0;
     $2 = HEAP32[$5 >> 2] | 0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $8 = i64toi32_i32$1;
     $8$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $3$hi;
     i64toi32_i32$1 = i64toi32_i32$2;
     HEAP32[i64toi32_i32$1 >> 2] = $3;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     $5 = HEAP32[$5 >> 2] | 0;
     HEAP32[((HEAP32[($5 + 12 | 0) >> 2] | 0) + 8 | 0) >> 2] = HEAP32[($5 + 8 | 0) >> 2] | 0;
     HEAP32[((HEAP32[($5 + 8 | 0) >> 2] | 0) + 12 | 0) >> 2] = HEAP32[($5 + 12 | 0) >> 2] | 0;
     $1 = HEAP32[($1 + 32 | 0) >> 2] | 0;
     $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     HEAP32[($5 + 12 | 0) >> 2] = $1;
     HEAP32[($5 + 8 | 0) >> 2] = $2;
     HEAP32[($1 + 8 | 0) >> 2] = $5;
     i64toi32_i32$0 = 0;
     $3 = 1;
     $3$hi = i64toi32_i32$0;
     break label$3;
    }
    label$7 : {
     label$8 : {
      $5 = HEAP32[($1 + 36 | 0) >> 2] | 0;
      if (!$5) {
       break label$8
      }
      HEAP32[($1 + 36 | 0) >> 2] = HEAP32[($5 + 8 | 0) >> 2] | 0;
      $6 = ($4 + 32 | 0) + 22 | 0;
      i64toi32_i32$2 = $2 + 22 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $144 = i64toi32_i32$0;
      i64toi32_i32$0 = $6;
      $29 = $144;
      HEAP16[i64toi32_i32$0 >> 1] = $29;
      HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $29 >>> 16 | 0;
      HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$1;
      HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
      $7 = ($4 + 32 | 0) + 16 | 0;
      i64toi32_i32$2 = $2 + 16 | 0;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $151 = i64toi32_i32$1;
      i64toi32_i32$1 = $7;
      HEAP32[i64toi32_i32$1 >> 2] = $151;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $2 + 8 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $8 = i64toi32_i32$0;
      $8$hi = i64toi32_i32$1;
      i64toi32_i32$2 = $2;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $9 = i64toi32_i32$1;
      $9$hi = i64toi32_i32$0;
      i64toi32_i32$1 = $5;
      i64toi32_i32$0 = 0;
      HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = 0;
      HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$0 = $3$hi;
      HEAP32[i64toi32_i32$1 >> 2] = $3;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$0 = $9$hi;
      HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $9;
      HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$0 = $8$hi;
      i64toi32_i32$1 = i64toi32_i32$1 + 24 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $8;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $7;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $168 = i64toi32_i32$0;
      i64toi32_i32$0 = $5 + 32 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $168;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $6;
      i64toi32_i32$1 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
      i64toi32_i32$0 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
      $172 = i64toi32_i32$1;
      i64toi32_i32$1 = $5 + 38 | 0;
      $30 = $172;
      HEAP16[i64toi32_i32$1 >> 1] = $30;
      HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $30 >>> 16 | 0;
      HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = i64toi32_i32$0;
      HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
      break label$7;
     }
     $5 = __rust_alloc(48 | 0, 8 | 0) | 0;
     if (!$5) {
      break label$2
     }
     i64toi32_i32$1 = $5;
     i64toi32_i32$0 = 0;
     HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = 0;
     HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$0 = $3$hi;
     HEAP32[i64toi32_i32$1 >> 2] = $3;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $181 = i64toi32_i32$0;
     i64toi32_i32$0 = $5;
     $25 = $181;
     HEAP8[(i64toi32_i32$0 + 16 | 0) >> 0] = $25;
     HEAP8[(i64toi32_i32$0 + 17 | 0) >> 0] = $25 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 18 | 0) >> 0] = $25 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 19 | 0) >> 0] = $25 >>> 24 | 0;
     HEAP8[(i64toi32_i32$0 + 20 | 0) >> 0] = i64toi32_i32$1;
     HEAP8[(i64toi32_i32$0 + 21 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 22 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 23 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
     i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $186 = i64toi32_i32$1;
     i64toi32_i32$1 = $5 + 24 | 0;
     $26 = $186;
     HEAP8[i64toi32_i32$1 >> 0] = $26;
     HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $26 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $26 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $26 >>> 24 | 0;
     HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
     HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
     i64toi32_i32$2 = $2 + 16 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $191 = i64toi32_i32$0;
     i64toi32_i32$0 = $5 + 32 | 0;
     $27 = $191;
     HEAP8[i64toi32_i32$0 >> 0] = $27;
     HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $27 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $27 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $27 >>> 24 | 0;
     HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
     HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
     i64toi32_i32$2 = $2 + 22 | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $196 = i64toi32_i32$1;
     i64toi32_i32$1 = $5 + 38 | 0;
     $28 = $196;
     HEAP8[i64toi32_i32$1 >> 0] = $28;
     HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $28 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $28 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $28 >>> 24 | 0;
     HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
     HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    }
    hashbrown__map__HashMap_K_2cV_2cS_2cA___insert__h73bc0b2d4216f700($4 | 0, $1 | 0, $5 + 16 | 0 | 0, $5 | 0);
    $1 = HEAP32[($1 + 32 | 0) >> 2] | 0;
    HEAP32[($5 + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
    HEAP32[($5 + 12 | 0) >> 2] = $1;
    HEAP32[($1 + 8 | 0) >> 2] = $5;
    i64toi32_i32$0 = 0;
    $3 = 0;
    $3$hi = i64toi32_i32$0;
   }
   HEAP32[((HEAP32[($5 + 8 | 0) >> 2] | 0) + 12 | 0) >> 2] = $5;
   i64toi32_i32$0 = $8$hi;
   i64toi32_i32$1 = $0;
   HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $8;
   HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $3$hi;
   HEAP32[i64toi32_i32$1 >> 2] = $3;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   global$0 = $4 + 64 | 0;
   return;
  }
  $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
  alloc__alloc__handle_alloc_error__he269d8f1bff90960(48 | 0, 8 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_recursing__hf1669f31df85556c($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $22 = 0, $7 = 0, $5 = 0, $6 = 0, $9 = 0, $21 = 0, $33 = 0, $39 = 0, $42 = 0, $51 = 0, $8 = 0, $126 = 0, $133 = 0, $136 = 0, $145 = 0;
  $4 = global$0 - 176 | 0;
  global$0 = $4;
  HEAP32[(($4 + 160 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[($4 + 160 | 0) >> 2] = $21;
  HEAP32[($4 + 164 | 0) >> 2] = i64toi32_i32$1;
  $22 = $2 + 24 | 0;
  HEAP32[(($4 + 8 | 0) + 24 | 0) >> 2] = HEAPU8[$22 >> 0] | 0 | ((HEAPU8[($22 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($22 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($22 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $2 + 16 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $33 = i64toi32_i32$1;
  i64toi32_i32$1 = ($4 + 8 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $33;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2 + 8 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $39 = i64toi32_i32$0;
  i64toi32_i32$0 = ($4 + 8 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $39;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $42 = i64toi32_i32$1;
  i64toi32_i32$1 = $4;
  HEAP32[($4 + 8 | 0) >> 2] = $42;
  HEAP32[($4 + 12 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(($4 + 128 | 0) + 8 | 0) >> 2] = HEAP32[($3 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $51 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[($4 + 128 | 0) >> 2] = $51;
  HEAP32[($4 + 132 | 0) >> 2] = i64toi32_i32$1;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert__he7138860d55d997e($4 + 48 | 0 | 0, $4 + 160 | 0 | 0, $4 + 8 | 0 | 0, $4 + 128 | 0 | 0);
  $2 = HEAP32[(($4 + 48 | 0) + 8 | 0) >> 2] | 0;
  $3 = HEAP32[($4 + 52 | 0) >> 2] | 0;
  $5 = HEAP32[($4 + 108 | 0) >> 2] | 0;
  label$1 : {
   label$2 : {
    if ((HEAP32[($4 + 48 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    HEAP32[($0 + 60 | 0) >> 2] = $5;
    HEAP32[($0 + 4 | 0) >> 2] = $3;
    HEAP32[$0 >> 2] = 0;
    HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($4 + 60 | 0) >> 2] | 0;
    HEAP32[($0 + 8 | 0) >> 2] = $2;
    break label$1;
   }
   $1 = HEAP32[(($4 + 48 | 0) + 56 | 0) >> 2] | 0;
   $6 = HEAP32[(($4 + 48 | 0) + 52 | 0) >> 2] | 0;
   memcpy($4 + 8 | 0 | 0, ($4 + 48 | 0) + 12 | 0 | 0, 40 | 0) | 0;
   label$3 : {
    $7 = HEAP32[$2 >> 2] | 0;
    if (!$7) {
     break label$3
    }
    $8 = $4 + 60 | 0;
    $9 = $4 + 36 | 0;
    label$4 : while (1) {
     HEAP32[($4 + 120 | 0) >> 2] = HEAPU16[($2 + 136 | 0) >> 1] | 0;
     HEAP32[($4 + 116 | 0) >> 2] = $7;
     HEAP32[($4 + 112 | 0) >> 2] = $3 + 1 | 0;
     HEAP32[(($4 + 128 | 0) + 24 | 0) >> 2] = HEAP32[(($4 + 8 | 0) + 24 | 0) >> 2] | 0;
     i64toi32_i32$2 = ($4 + 8 | 0) + 16 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $126 = i64toi32_i32$1;
     i64toi32_i32$1 = ($4 + 128 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $126;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = ($4 + 8 | 0) + 8 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $133 = i64toi32_i32$0;
     i64toi32_i32$0 = ($4 + 128 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $133;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $4;
     i64toi32_i32$1 = HEAP32[($4 + 8 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($4 + 12 | 0) >> 2] | 0;
     $136 = i64toi32_i32$1;
     i64toi32_i32$1 = $4;
     HEAP32[($4 + 128 | 0) >> 2] = $136;
     HEAP32[($4 + 132 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[(($4 + 160 | 0) + 8 | 0) >> 2] = HEAP32[($9 + 8 | 0) >> 2] | 0;
     i64toi32_i32$2 = $9;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $145 = i64toi32_i32$0;
     i64toi32_i32$0 = $4;
     HEAP32[($4 + 160 | 0) >> 2] = $145;
     HEAP32[($4 + 164 | 0) >> 2] = i64toi32_i32$1;
     alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert__h100db9f5a34c2994($4 + 48 | 0 | 0, $4 + 112 | 0 | 0, $4 + 128 | 0 | 0, $4 + 160 | 0 | 0, $6 | 0, $1 | 0);
     $2 = HEAP32[($4 + 56 | 0) >> 2] | 0;
     $3 = HEAP32[($4 + 52 | 0) >> 2] | 0;
     label$5 : {
      if ((HEAP32[($4 + 48 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$5
      }
      HEAP32[($0 + 60 | 0) >> 2] = $5;
      HEAP32[($0 + 4 | 0) >> 2] = $3;
      HEAP32[$0 >> 2] = 0;
      HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($4 + 60 | 0) >> 2] | 0;
      HEAP32[($0 + 8 | 0) >> 2] = $2;
      break label$1;
     }
     $1 = HEAP32[($4 + 104 | 0) >> 2] | 0;
     $6 = HEAP32[($4 + 100 | 0) >> 2] | 0;
     memcpy($4 + 8 | 0 | 0, $8 | 0, 40 | 0) | 0;
     $7 = HEAP32[$2 >> 2] | 0;
     if ($7) {
      continue label$4
     }
     break label$4;
    };
   }
   HEAP32[($0 + 4 | 0) >> 2] = $3;
   HEAP32[$0 >> 2] = 1;
   HEAP32[($0 + 8 | 0) >> 2] = $2;
   memcpy($0 + 12 | 0 | 0, $4 + 8 | 0 | 0, 40 | 0) | 0;
   HEAP32[($0 + 60 | 0) >> 2] = $5;
   HEAP32[($0 + 56 | 0) >> 2] = $1;
   HEAP32[($0 + 52 | 0) >> 2] = $6;
  }
  global$0 = $4 + 176 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_recursing__hffbe4982de10255b($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $22 = 0, $7 = 0, $5 = 0, $6 = 0, $9 = 0, $21 = 0, $33 = 0, $39 = 0, $42 = 0, $51 = 0, $8 = 0, $126 = 0, $133 = 0, $136 = 0, $145 = 0;
  $4 = global$0 - 176 | 0;
  global$0 = $4;
  HEAP32[(($4 + 160 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[($4 + 160 | 0) >> 2] = $21;
  HEAP32[($4 + 164 | 0) >> 2] = i64toi32_i32$1;
  $22 = $2 + 24 | 0;
  HEAP32[(($4 + 8 | 0) + 24 | 0) >> 2] = HEAPU8[$22 >> 0] | 0 | ((HEAPU8[($22 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($22 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($22 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $2 + 16 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $33 = i64toi32_i32$1;
  i64toi32_i32$1 = ($4 + 8 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $33;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2 + 8 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $39 = i64toi32_i32$0;
  i64toi32_i32$0 = ($4 + 8 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $39;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $42 = i64toi32_i32$1;
  i64toi32_i32$1 = $4;
  HEAP32[($4 + 8 | 0) >> 2] = $42;
  HEAP32[($4 + 12 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(($4 + 128 | 0) + 8 | 0) >> 2] = HEAP32[($3 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $51 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[($4 + 128 | 0) >> 2] = $51;
  HEAP32[($4 + 132 | 0) >> 2] = i64toi32_i32$1;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert__h45dfeb628bd48518($4 + 48 | 0 | 0, $4 + 160 | 0 | 0, $4 + 8 | 0 | 0, $4 + 128 | 0 | 0);
  $2 = HEAP32[(($4 + 48 | 0) + 8 | 0) >> 2] | 0;
  $3 = HEAP32[($4 + 52 | 0) >> 2] | 0;
  $5 = HEAP32[($4 + 108 | 0) >> 2] | 0;
  label$1 : {
   label$2 : {
    if ((HEAP32[($4 + 48 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    HEAP32[($0 + 60 | 0) >> 2] = $5;
    HEAP32[($0 + 4 | 0) >> 2] = $3;
    HEAP32[$0 >> 2] = 0;
    HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($4 + 60 | 0) >> 2] | 0;
    HEAP32[($0 + 8 | 0) >> 2] = $2;
    break label$1;
   }
   $1 = HEAP32[(($4 + 48 | 0) + 56 | 0) >> 2] | 0;
   $6 = HEAP32[(($4 + 48 | 0) + 52 | 0) >> 2] | 0;
   memcpy($4 + 8 | 0 | 0, ($4 + 48 | 0) + 12 | 0 | 0, 40 | 0) | 0;
   label$3 : {
    $7 = HEAP32[$2 >> 2] | 0;
    if (!$7) {
     break label$3
    }
    $8 = $4 + 60 | 0;
    $9 = $4 + 36 | 0;
    label$4 : while (1) {
     HEAP32[($4 + 120 | 0) >> 2] = HEAPU16[($2 + 136 | 0) >> 1] | 0;
     HEAP32[($4 + 116 | 0) >> 2] = $7;
     HEAP32[($4 + 112 | 0) >> 2] = $3 + 1 | 0;
     HEAP32[(($4 + 128 | 0) + 24 | 0) >> 2] = HEAP32[(($4 + 8 | 0) + 24 | 0) >> 2] | 0;
     i64toi32_i32$2 = ($4 + 8 | 0) + 16 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $126 = i64toi32_i32$1;
     i64toi32_i32$1 = ($4 + 128 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $126;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = ($4 + 8 | 0) + 8 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $133 = i64toi32_i32$0;
     i64toi32_i32$0 = ($4 + 128 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $133;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $4;
     i64toi32_i32$1 = HEAP32[($4 + 8 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($4 + 12 | 0) >> 2] | 0;
     $136 = i64toi32_i32$1;
     i64toi32_i32$1 = $4;
     HEAP32[($4 + 128 | 0) >> 2] = $136;
     HEAP32[($4 + 132 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[(($4 + 160 | 0) + 8 | 0) >> 2] = HEAP32[($9 + 8 | 0) >> 2] | 0;
     i64toi32_i32$2 = $9;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $145 = i64toi32_i32$0;
     i64toi32_i32$0 = $4;
     HEAP32[($4 + 160 | 0) >> 2] = $145;
     HEAP32[($4 + 164 | 0) >> 2] = i64toi32_i32$1;
     alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert__had2107e19eda647d($4 + 48 | 0 | 0, $4 + 112 | 0 | 0, $4 + 128 | 0 | 0, $4 + 160 | 0 | 0, $6 | 0, $1 | 0);
     $2 = HEAP32[($4 + 56 | 0) >> 2] | 0;
     $3 = HEAP32[($4 + 52 | 0) >> 2] | 0;
     label$5 : {
      if ((HEAP32[($4 + 48 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$5
      }
      HEAP32[($0 + 60 | 0) >> 2] = $5;
      HEAP32[($0 + 4 | 0) >> 2] = $3;
      HEAP32[$0 >> 2] = 0;
      HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($4 + 60 | 0) >> 2] | 0;
      HEAP32[($0 + 8 | 0) >> 2] = $2;
      break label$1;
     }
     $1 = HEAP32[($4 + 104 | 0) >> 2] | 0;
     $6 = HEAP32[($4 + 100 | 0) >> 2] | 0;
     memcpy($4 + 8 | 0 | 0, $8 | 0, 40 | 0) | 0;
     $7 = HEAP32[$2 >> 2] | 0;
     if ($7) {
      continue label$4
     }
     break label$4;
    };
   }
   HEAP32[($0 + 4 | 0) >> 2] = $3;
   HEAP32[$0 >> 2] = 1;
   HEAP32[($0 + 8 | 0) >> 2] = $2;
   memcpy($0 + 12 | 0 | 0, $4 + 8 | 0 | 0, 40 | 0) | 0;
   HEAP32[($0 + 60 | 0) >> 2] = $5;
   HEAP32[($0 + 56 | 0) >> 2] = $1;
   HEAP32[($0 + 52 | 0) >> 2] = $6;
  }
  global$0 = $4 + 176 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__PoolMetadata___deserialize_as_embedded_group__hc30afb036576109c($0, $1, $2, $2$hi, $3, $3$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  var $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $9 = 0, $6 = 0, $7 = 0, $8 = 0, $32 = 0, $33 = 0, $5 = 0, $9$hi = 0, $28 = 0, $50 = 0, $58 = 0, $75 = 0, $81 = 0, $87 = 0, $90 = 0, $96 = 0, $102 = 0, $108 = 0, $111 = 0, $119 = 0, $123 = 0, $127 = 0, $131 = 0, $134 = 0;
  $4 = global$0 - 416 | 0;
  global$0 = $4;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__URL___deserialize__hc711c8b8b85e87e8($4 + 344 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[($4 + 344 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $5 = ($4 + 8 | 0) + 8 | 0;
    HEAP32[$5 >> 2] = HEAP32[($4 + 356 | 0) >> 2] | 0;
    i64toi32_i32$2 = $4;
    i64toi32_i32$0 = HEAP32[($4 + 348 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($4 + 352 | 0) >> 2] | 0;
    $28 = i64toi32_i32$0;
    i64toi32_i32$0 = $4;
    HEAP32[($4 + 8 | 0) >> 2] = $28;
    HEAP32[($4 + 12 | 0) >> 2] = i64toi32_i32$1;
    $cardano_serialization_lib__crypto__PoolMetadataHash_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hc26648f5daec7200($4 + 344 | 0 | 0, $1 | 0);
    label$3 : {
     if ((HEAPU8[($4 + 344 | 0) >> 0] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     i64toi32_i32$2 = ($4 + 344 | 0) + 9 | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $9 = i64toi32_i32$1;
     $9$hi = i64toi32_i32$0;
     i64toi32_i32$1 = ($4 + 200 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $9;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     $1 = ($4 + 128 | 0) + 25 | 0;
     i64toi32_i32$2 = ($4 + 344 | 0) + 25 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $50 = i64toi32_i32$0;
     i64toi32_i32$0 = $1;
     $32 = $50;
     HEAP8[i64toi32_i32$0 >> 0] = $32;
     HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $32 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $32 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $32 >>> 24 | 0;
     HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
     HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
     $6 = ($4 + 128 | 0) + 17 | 0;
     i64toi32_i32$2 = ($4 + 344 | 0) + 17 | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $58 = i64toi32_i32$1;
     i64toi32_i32$1 = $6;
     $33 = $58;
     HEAP8[i64toi32_i32$1 >> 0] = $33;
     HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $33 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $33 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $33 >>> 24 | 0;
     HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
     HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
     $7 = ($4 + 128 | 0) + 9 | 0;
     i64toi32_i32$0 = $9$hi;
     i64toi32_i32$1 = $7;
     HEAP8[i64toi32_i32$1 >> 0] = $9;
     HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $9 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $9 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $9 >>> 24 | 0;
     HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
     HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
     i64toi32_i32$2 = $4;
     i64toi32_i32$0 = HEAPU8[($4 + 345 | 0) >> 0] | 0 | ((HEAPU8[($4 + 346 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 347 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 348 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[($4 + 349 | 0) >> 0] | 0 | ((HEAPU8[($4 + 350 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 351 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 352 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $9 = i64toi32_i32$0;
     $9$hi = i64toi32_i32$1;
     i64toi32_i32$0 = $4;
     HEAP32[($4 + 200 | 0) >> 2] = $9;
     HEAP32[($4 + 204 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$0 = $4;
     HEAP8[($4 + 129 | 0) >> 0] = $9;
     HEAP8[($4 + 130 | 0) >> 0] = $9 >>> 8 | 0;
     HEAP8[($4 + 131 | 0) >> 0] = $9 >>> 16 | 0;
     HEAP8[($4 + 132 | 0) >> 0] = $9 >>> 24 | 0;
     HEAP8[($4 + 133 | 0) >> 0] = i64toi32_i32$1;
     HEAP8[($4 + 134 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
     HEAP8[($4 + 135 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
     HEAP8[($4 + 136 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
     $8 = ($4 + 56 | 0) + 24 | 0;
     i64toi32_i32$2 = $1;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $75 = i64toi32_i32$1;
     i64toi32_i32$1 = $8;
     HEAP32[i64toi32_i32$1 >> 2] = $75;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     $1 = ($4 + 56 | 0) + 16 | 0;
     i64toi32_i32$2 = $6;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $81 = i64toi32_i32$0;
     i64toi32_i32$0 = $1;
     HEAP32[i64toi32_i32$0 >> 2] = $81;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     $6 = ($4 + 56 | 0) + 8 | 0;
     i64toi32_i32$2 = $7;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $87 = i64toi32_i32$1;
     i64toi32_i32$1 = $6;
     HEAP32[i64toi32_i32$1 >> 2] = $87;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $4;
     i64toi32_i32$0 = HEAPU8[($4 + 129 | 0) >> 0] | 0 | ((HEAPU8[($4 + 130 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 131 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 132 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[($4 + 133 | 0) >> 0] | 0 | ((HEAPU8[($4 + 134 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 135 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 136 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $90 = i64toi32_i32$0;
     i64toi32_i32$0 = $4;
     HEAP32[($4 + 56 | 0) >> 2] = $90;
     HEAP32[($4 + 60 | 0) >> 2] = i64toi32_i32$1;
     $7 = ($4 + 24 | 0) + 24 | 0;
     i64toi32_i32$2 = $8;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $96 = i64toi32_i32$1;
     i64toi32_i32$1 = $7;
     HEAP32[i64toi32_i32$1 >> 2] = $96;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     $8 = ($4 + 24 | 0) + 16 | 0;
     i64toi32_i32$2 = $1;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $102 = i64toi32_i32$0;
     i64toi32_i32$0 = $8;
     HEAP32[i64toi32_i32$0 >> 2] = $102;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     $1 = ($4 + 24 | 0) + 8 | 0;
     i64toi32_i32$2 = $6;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $108 = i64toi32_i32$1;
     i64toi32_i32$1 = $1;
     HEAP32[i64toi32_i32$1 >> 2] = $108;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $4;
     i64toi32_i32$0 = HEAP32[($4 + 56 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($4 + 60 | 0) >> 2] | 0;
     $111 = i64toi32_i32$0;
     i64toi32_i32$0 = $4;
     HEAP32[($4 + 24 | 0) >> 2] = $111;
     HEAP32[($4 + 28 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[(($4 + 344 | 0) + 8 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
     i64toi32_i32$2 = $4;
     i64toi32_i32$1 = HEAP32[($4 + 8 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($4 + 12 | 0) >> 2] | 0;
     $119 = i64toi32_i32$1;
     i64toi32_i32$1 = $4;
     HEAP32[($4 + 344 | 0) >> 2] = $119;
     HEAP32[($4 + 348 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $1;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $123 = i64toi32_i32$0;
     i64toi32_i32$0 = $4 + 364 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $123;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $8;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $127 = i64toi32_i32$1;
     i64toi32_i32$1 = $4 + 372 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $127;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $7;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $131 = i64toi32_i32$0;
     i64toi32_i32$0 = $4 + 380 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $131;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $4;
     i64toi32_i32$1 = HEAP32[($4 + 24 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($4 + 28 | 0) >> 2] | 0;
     $134 = i64toi32_i32$1;
     i64toi32_i32$1 = $4;
     HEAP32[($4 + 356 | 0) >> 2] = $134;
     HEAP32[($4 + 360 | 0) >> 2] = i64toi32_i32$0;
     memcpy($0 + 4 | 0 | 0, $4 + 344 | 0 | 0, 44 | 0) | 0;
     HEAP32[$0 >> 2] = 0;
     break label$1;
    }
    memcpy($4 + 344 | 0 | 0, memcpy($4 + 200 | 0 | 7 | 0 | 0, memcpy($4 + 272 | 0 | 7 | 0 | 0, ($4 + 344 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
    $1 = ($4 + 128 | 0) + 8 | 0;
    cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 344 | 0 | 0, 1051559 | 0, 18 | 0);
    memcpy($0 + 8 | 0 | 0, memcpy($4 + 56 | 0 | 7 | 0 | 0, $1 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($4 + 8 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($4 + 8 | 0 | 0);
    break label$1;
   }
   memcpy($4 + 344 | 0 | 0, memcpy($4 + 200 | 0 | 4 | 0 | 0, memcpy($4 + 272 | 0 | 4 | 0 | 0, ($4 + 344 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   $1 = ($4 + 128 | 0) + 8 | 0;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 344 | 0 | 0, 1051556 | 0, 3 | 0);
   memcpy($0 + 8 | 0 | 0, memcpy($4 + 56 | 0 | 4 | 0 | 0, $1 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $4 + 416 | 0;
 }
 
 function cardano_serialization_lib__utils__make_daedalus_bootstrap_witness__h7e21e4ecf8b27efa($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $4 = 0, $7 = 0, $6 = 0, $29 = 0, $30 = 0, $32 = 0, $33 = 0, $34 = 0, $35 = 0, $37 = 0, $38 = 0, $39 = 0, $40 = 0, $41 = 0, $42 = 0, $8 = 0, $9 = 0, $5 = 0, $21 = 0, $26 = 0, $31 = 0, $36 = 0, $80 = 0, $85 = 0, $90 = 0, $93 = 0, $105 = 0, $110 = 0, $115 = 0, $120 = 0, $170 = 0, $175 = 0, $180 = 0, $183 = 0;
  $4 = global$0 - 304 | 0;
  global$0 = $4;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($4 + 32 | 0 | 0, 32 | 0, 0 | 0);
  $5 = HEAP32[($4 + 36 | 0) >> 2] | 0;
  $6 = HEAP32[($4 + 32 | 0) >> 2] | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 64 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 65 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 66 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 67 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 68 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 69 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 70 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 71 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $21 = i64toi32_i32$0;
  i64toi32_i32$0 = $6;
  $29 = $21;
  HEAP8[i64toi32_i32$0 >> 0] = $29;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $29 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $29 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $29 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 88 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $26 = i64toi32_i32$1;
  i64toi32_i32$1 = $6 + 24 | 0;
  $30 = $26;
  HEAP8[i64toi32_i32$1 >> 0] = $30;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $30 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $30 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $30 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $3 + 80 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $6 + 16 | 0;
  $32 = $31;
  HEAP8[i64toi32_i32$0 >> 0] = $32;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $32 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $32 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $32 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $3 + 72 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $6 + 8 | 0;
  $33 = $36;
  HEAP8[i64toi32_i32$1 >> 0] = $33;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $33 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $33 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $33 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $cardano_serialization_lib__chain_crypto__algorithms__legacy_daedalus__LegacyDaedalus_20as_20cardano_serialization_lib__chain_crypto__key__AsymmetricKey___compute_public__h784e6c837b0c7a87($4 + 224 | 0 | 0, $3 | 0);
  $ed25519_bip32__key__XPub_20as_20core__convert__AsRef__5bu8_5d____as_ref__h69a664c2b5ee8b25($4 + 24 | 0 | 0, $4 + 224 | 0 | 0);
  cardano_serialization_lib__crypto__Bip32PublicKey__from_bytes__h9e2151b5ecc26a5e($4 + 136 | 0 | 0, HEAP32[($4 + 24 | 0) >> 2] | 0 | 0, HEAP32[($4 + 28 | 0) >> 2] | 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAPU8[($4 + 136 | 0) >> 0] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    memcpy($4 + 40 | 0 | 0, $4 + 136 | 0 | 1 | 0 | 0, 64 | 0) | 0;
    $7 = ($4 + 136 | 0) + 24 | 0;
    i64toi32_i32$1 = $7;
    i64toi32_i32$0 = 0;
    HEAP32[i64toi32_i32$1 >> 2] = 0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    $8 = ($4 + 136 | 0) + 16 | 0;
    i64toi32_i32$1 = $8;
    i64toi32_i32$0 = 0;
    HEAP32[i64toi32_i32$1 >> 2] = 0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    $9 = ($4 + 136 | 0) + 8 | 0;
    i64toi32_i32$1 = $9;
    i64toi32_i32$0 = 0;
    HEAP32[i64toi32_i32$1 >> 2] = 0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$1 = $4;
    i64toi32_i32$0 = 0;
    HEAP32[(i64toi32_i32$1 + 136 | 0) >> 2] = 0;
    HEAP32[(i64toi32_i32$1 + 140 | 0) >> 2] = i64toi32_i32$0;
    ed25519_bip32__key__XPub__get_without_chaincode__h1b3f335862724d9d(i64toi32_i32$1 + 40 | 0 | 0, i64toi32_i32$1 + 136 | 0 | 0);
    i64toi32_i32$2 = $7;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $80 = i64toi32_i32$0;
    i64toi32_i32$0 = ($4 + 104 | 0) + 24 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $80;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $8;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $85 = i64toi32_i32$1;
    i64toi32_i32$1 = ($4 + 104 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $85;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $9;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $90 = i64toi32_i32$0;
    i64toi32_i32$0 = ($4 + 104 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $90;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 136 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 140 | 0) >> 2] | 0;
    $93 = i64toi32_i32$1;
    i64toi32_i32$1 = i64toi32_i32$2;
    HEAP32[(i64toi32_i32$1 + 104 | 0) >> 2] = $93;
    HEAP32[(i64toi32_i32$1 + 108 | 0) >> 2] = i64toi32_i32$0;
    alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9(i64toi32_i32$1 + 16 | 0 | 0, 32 | 0, 0 | 0);
    HEAP32[(i64toi32_i32$1 + 292 | 0) >> 2] = HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] | 0;
    $7 = HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] | 0;
    HEAP32[(i64toi32_i32$1 + 288 | 0) >> 2] = $7;
    i64toi32_i32$2 = $1;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $105 = i64toi32_i32$0;
    i64toi32_i32$0 = $7;
    $34 = $105;
    HEAP8[i64toi32_i32$0 >> 0] = $34;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $34 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $34 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $34 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $110 = i64toi32_i32$1;
    i64toi32_i32$1 = $7 + 8 | 0;
    $35 = $110;
    HEAP8[i64toi32_i32$1 >> 0] = $35;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $35 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $35 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $35 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$2 = $1 + 16 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $115 = i64toi32_i32$0;
    i64toi32_i32$0 = $7 + 16 | 0;
    $37 = $115;
    HEAP8[i64toi32_i32$0 >> 0] = $37;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $37 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $37 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $37 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$2 = $1 + 24 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $120 = i64toi32_i32$1;
    i64toi32_i32$1 = $7 + 24 | 0;
    $38 = $120;
    HEAP8[i64toi32_i32$1 >> 0] = $38;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $38 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $38 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $38 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    HEAP32[($4 + 296 | 0) >> 2] = 32;
    cardano_serialization_lib__chain_crypto__sign___impl_20cardano_serialization_lib__chain_crypto__key__SecretKey_A____sign__h00427a3a04db3396($4 + 224 | 0 | 0, $3 | 0, $4 + 288 | 0 | 0);
    alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($4 + 8 | 0 | 0, 64 | 0, 0 | 0);
    HEAP32[($4 + 212 | 0) >> 2] = HEAP32[($4 + 12 | 0) >> 2] | 0;
    $3 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    HEAP32[($4 + 208 | 0) >> 2] = $3;
    memcpy($3 | 0, $4 + 224 | 0 | 0, 64 | 0) | 0;
    HEAP32[($4 + 216 | 0) >> 2] = 64;
    cardano_serialization_lib__crypto__Ed25519Signature__from_bytes__hf5afe24ffdbd3318($4 + 136 | 0 | 0, $4 + 208 | 0 | 0);
    if ((HEAPU8[($4 + 136 | 0) >> 0] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    memcpy($0 + 56 | 0 | 0, $4 + 136 | 0 | 1 | 0 | 0, 64 | 0) | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($4 + 288 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($4 + 288 | 0 | 0);
    cardano_serialization_lib__address__ByronAddress__attributes__hedb23cddc1880465($0 + 12 | 0 | 0, $2 | 0);
    HEAP32[($0 + 8 | 0) >> 2] = 32;
    HEAP32[($0 + 4 | 0) >> 2] = $5;
    HEAP32[$0 >> 2] = $6;
    i64toi32_i32$2 = $4 + 128 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $170 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 48 | 0;
    $39 = $170;
    HEAP8[i64toi32_i32$0 >> 0] = $39;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $39 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $39 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $39 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$2 = $4 + 120 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $175 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 40 | 0;
    $40 = $175;
    HEAP8[i64toi32_i32$1 >> 0] = $40;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $40 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $40 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $40 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$2 = $4 + 112 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $180 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 32 | 0;
    $41 = $180;
    HEAP8[i64toi32_i32$0 >> 0] = $41;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $41 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $41 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $41 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 104 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 108 | 0) >> 2] | 0;
    $183 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    $42 = $183;
    HEAP8[(i64toi32_i32$1 + 24 | 0) >> 0] = $42;
    HEAP8[(i64toi32_i32$1 + 25 | 0) >> 0] = $42 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 26 | 0) >> 0] = $42 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 27 | 0) >> 0] = $42 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 28 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 29 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 30 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 31 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    global$0 = i64toi32_i32$2 + 304 | 0;
    return;
   }
   HEAP32[($4 + 40 | 0) >> 2] = HEAP32[($4 + 140 | 0) >> 2] | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1057568 | 0, 43 | 0, $4 + 40 | 0 | 0, 1057612 | 0, 1058836 | 0);
   abort();
  }
  HEAP32[($4 + 208 | 0) >> 2] = HEAP32[($4 + 140 | 0) >> 2] | 0;
  core__result__unwrap_failed__h27f43d993c3864a1(1057568 | 0, 43 | 0, $4 + 208 | 0 | 0, 1057612 | 0, 1058852 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_recursing__h2616a53b5ac2d36f($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $8 = 0, $5 = 0, $6 = 0, $7 = 0, $21 = 0, $30 = 0, $36 = 0, $42 = 0, $45 = 0, $63 = 0, $9 = 0, $120 = 0, $126 = 0, $132 = 0, $135 = 0, $153 = 0;
  $4 = global$0 - 176 | 0;
  global$0 = $4;
  HEAP32[(($4 + 136 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[($4 + 136 | 0) >> 2] = $21;
  HEAP32[($4 + 140 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(($4 + 152 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$1;
  i64toi32_i32$1 = $4;
  HEAP32[($4 + 152 | 0) >> 2] = $30;
  HEAP32[($4 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $3 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$0;
  i64toi32_i32$0 = ($4 + 8 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $36;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $3 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $42 = i64toi32_i32$1;
  i64toi32_i32$1 = ($4 + 8 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $42;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $45 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[($4 + 8 | 0) >> 2] = $45;
  HEAP32[($4 + 12 | 0) >> 2] = i64toi32_i32$1;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert__hce42e63ba7a2d923($4 + 48 | 0 | 0, $4 + 136 | 0 | 0, $4 + 152 | 0 | 0, $4 + 8 | 0 | 0);
  $5 = HEAP32[($4 + 112 | 0) >> 2] | 0;
  label$1 : {
   label$2 : {
    if ((HEAP32[($4 + 48 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    HEAP32[($0 + 64 | 0) >> 2] = $5;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 52 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($4 + 56 | 0) >> 2] | 0;
    $63 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $63;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[i64toi32_i32$1 >> 2] = 0;
    HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = HEAP32[(($4 + 48 | 0) + 12 | 0) >> 2] | 0;
    break label$1;
   }
   $1 = HEAP32[(($4 + 48 | 0) + 60 | 0) >> 2] | 0;
   $6 = HEAP32[(($4 + 48 | 0) + 56 | 0) >> 2] | 0;
   $7 = HEAP32[(($4 + 48 | 0) + 48 | 0) >> 2] | 0;
   $3 = HEAP32[(($4 + 48 | 0) + 52 | 0) >> 2] | 0;
   memcpy($4 + 8 | 0 | 0, ($4 + 48 | 0) + 8 | 0 | 0, 40 | 0) | 0;
   label$3 : {
    $8 = HEAP32[($3 + 264 | 0) >> 2] | 0;
    if (!$8) {
     break label$3
    }
    $9 = ($4 + 48 | 0) + 8 | 0;
    $2 = ($4 + 8 | 0) + 16 | 0;
    label$4 : while (1) {
     HEAP32[($4 + 128 | 0) >> 2] = HEAPU16[($3 + 400 | 0) >> 1] | 0;
     HEAP32[($4 + 124 | 0) >> 2] = $8;
     HEAP32[($4 + 120 | 0) >> 2] = $7 + 1 | 0;
     HEAP32[(($4 + 136 | 0) + 8 | 0) >> 2] = HEAP32[(($4 + 8 | 0) + 8 | 0) >> 2] | 0;
     i64toi32_i32$2 = $4;
     i64toi32_i32$0 = HEAP32[($4 + 8 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($4 + 12 | 0) >> 2] | 0;
     $120 = i64toi32_i32$0;
     i64toi32_i32$0 = $4;
     HEAP32[($4 + 136 | 0) >> 2] = $120;
     HEAP32[($4 + 140 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $2 + 16 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $126 = i64toi32_i32$1;
     i64toi32_i32$1 = ($4 + 152 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $126;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $2 + 8 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $132 = i64toi32_i32$0;
     i64toi32_i32$0 = ($4 + 152 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $132;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $135 = i64toi32_i32$1;
     i64toi32_i32$1 = $4;
     HEAP32[($4 + 152 | 0) >> 2] = $135;
     HEAP32[($4 + 156 | 0) >> 2] = i64toi32_i32$0;
     alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert__h03a244908a0f74f5($4 + 48 | 0 | 0, $4 + 120 | 0 | 0, $4 + 136 | 0 | 0, $4 + 152 | 0 | 0, $6 | 0, $1 | 0);
     label$5 : {
      if ((HEAP32[($4 + 48 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$5
      }
      HEAP32[($0 + 64 | 0) >> 2] = $5;
      i64toi32_i32$2 = $4;
      i64toi32_i32$0 = HEAP32[($4 + 52 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($4 + 56 | 0) >> 2] | 0;
      $153 = i64toi32_i32$0;
      i64toi32_i32$0 = $0;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $153;
      HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[i64toi32_i32$0 >> 2] = 0;
      HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = HEAP32[(($4 + 48 | 0) + 12 | 0) >> 2] | 0;
      break label$1;
     }
     $1 = HEAP32[($4 + 108 | 0) >> 2] | 0;
     $6 = HEAP32[($4 + 104 | 0) >> 2] | 0;
     $7 = HEAP32[($4 + 96 | 0) >> 2] | 0;
     $3 = HEAP32[($4 + 100 | 0) >> 2] | 0;
     memcpy($4 + 8 | 0 | 0, $9 | 0, 40 | 0) | 0;
     $8 = HEAP32[($3 + 264 | 0) >> 2] | 0;
     if ($8) {
      continue label$4
     }
     break label$4;
    };
   }
   memcpy(($4 + 48 | 0) + 4 | 0 | 0, $4 + 8 | 0 | 0, 40 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
   memcpy($0 + 4 | 0 | 0, $4 + 48 | 0 | 0, 44 | 0) | 0;
   HEAP32[($0 + 64 | 0) >> 2] = $5;
   HEAP32[($0 + 60 | 0) >> 2] = $1;
   HEAP32[($0 + 56 | 0) >> 2] = $6;
   HEAP32[($0 + 52 | 0) >> 2] = $3;
   HEAP32[($0 + 48 | 0) >> 2] = $7;
  }
  global$0 = $4 + 176 | 0;
 }
 
 function alloc__collections__btree__remove___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__KV____remove_leaf_kv__hb724496be72afff3($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $5 = 0, $4 = 0, $6 = 0, $7 = 0, $11 = 0, $9 = 0, $10 = 0, $8 = 0, $35 = 0, $92 = 0, $97 = 0, $127 = 0, $132 = 0, $153 = 0, $158 = 0, $175 = 0, $180 = 0;
  $3 = global$0 - 96 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = $4 + 4 | 0;
  $6 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $7 = $5 + ($6 << 2 | 0) | 0;
  $8 = HEAP32[$7 >> 2] | 0;
  $1 = HEAP32[$1 >> 2] | 0;
  $9 = $6 + 1 | 0;
  $35 = $5 + ($9 << 2 | 0) | 0;
  $5 = HEAPU16[($4 + 50 | 0) >> 1] | 0;
  memmove($7 | 0, $35 | 0, ($5 + ($6 ^ -1 | 0) | 0) << 2 | 0 | 0) | 0;
  $5 = $5 + -1 | 0;
  HEAP16[($4 + 50 | 0) >> 1] = $5;
  label$1 : {
   if (($5 & 65535 | 0) >>> 0 > 4 >>> 0) {
    break label$1
   }
   alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___choose_parent_kv__hffff788951b41f8b($3 + 24 | 0 | 0, $1 | 0, $4 | 0);
   $4 = HEAP32[($3 + 28 | 0) >> 2] | 0;
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ((HEAP32[($3 + 24 | 0) >> 2] | 0 | 0) == (1 | 0)) {
        break label$5
       }
       $5 = HEAP32[($3 + 48 | 0) >> 2] | 0;
       $7 = HEAP32[($3 + 56 | 0) >> 2] | 0;
       $10 = ((HEAPU16[($5 + 50 | 0) >> 1] | 0) + (HEAPU16[($7 + 50 | 0) >> 1] | 0) | 0) + 1 | 0;
       $1 = $3 + 32 | 0;
       $11 = HEAP32[($3 + 52 | 0) >> 2] | 0;
       if (($4 | 0) == (1 | 0)) {
        break label$4
       }
       if ($10 >>> 0 < 12 >>> 0) {
        break label$3
       }
       HEAP32[($3 + 88 | 0) >> 2] = $7;
       HEAP32[($3 + 80 | 0) >> 2] = $5;
       i64toi32_i32$2 = $1 + 8 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $92 = i64toi32_i32$0;
       i64toi32_i32$0 = ($3 + 64 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $92;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       HEAP32[($3 + 84 | 0) >> 2] = $11;
       i64toi32_i32$2 = $1;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $97 = i64toi32_i32$1;
       i64toi32_i32$1 = $3;
       HEAP32[($3 + 64 | 0) >> 2] = $97;
       HEAP32[($3 + 68 | 0) >> 2] = i64toi32_i32$0;
       alloc__collections__btree__node__BalancingContext_K_2cV___bulk_steal_left__h1d363b549e6145dd($3 + 64 | 0 | 0, 1 | 0);
       HEAP32[($3 + 16 | 0) >> 2] = $9;
       HEAP32[($3 + 12 | 0) >> 2] = $7;
       HEAP32[($3 + 8 | 0) >> 2] = $11;
       break label$2;
      }
      HEAP32[($3 + 16 | 0) >> 2] = $6;
      HEAP32[($3 + 8 | 0) >> 2] = $4;
      HEAP32[($3 + 12 | 0) >> 2] = HEAP32[($3 + 32 | 0) >> 2] | 0;
      break label$2;
     }
     label$6 : {
      if ($10 >>> 0 < 12 >>> 0) {
       break label$6
      }
      HEAP32[($3 + 88 | 0) >> 2] = $7;
      HEAP32[($3 + 80 | 0) >> 2] = $5;
      i64toi32_i32$2 = $1 + 8 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $127 = i64toi32_i32$0;
      i64toi32_i32$0 = ($3 + 64 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $127;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($3 + 84 | 0) >> 2] = $11;
      i64toi32_i32$2 = $1;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $132 = i64toi32_i32$1;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 64 | 0) >> 2] = $132;
      HEAP32[($3 + 68 | 0) >> 2] = i64toi32_i32$0;
      alloc__collections__btree__node__BalancingContext_K_2cV___bulk_steal_right__h5eaa656be70e1d95($3 + 64 | 0 | 0, 1 | 0);
      HEAP32[($3 + 16 | 0) >> 2] = $6;
      HEAP32[($3 + 12 | 0) >> 2] = $5;
      HEAP32[($3 + 8 | 0) >> 2] = HEAP32[($3 + 76 | 0) >> 2] | 0;
      break label$2;
     }
     HEAP32[($3 + 88 | 0) >> 2] = $7;
     HEAP32[($3 + 80 | 0) >> 2] = $5;
     i64toi32_i32$2 = $1 + 8 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $153 = i64toi32_i32$0;
     i64toi32_i32$0 = ($3 + 64 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $153;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($3 + 84 | 0) >> 2] = $11;
     i64toi32_i32$2 = $1;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $158 = i64toi32_i32$1;
     i64toi32_i32$1 = $3;
     HEAP32[($3 + 64 | 0) >> 2] = $158;
     HEAP32[($3 + 68 | 0) >> 2] = i64toi32_i32$0;
     alloc__collections__btree__node__BalancingContext_K_2cV___merge_tracking_child_edge__hce68ab54ee2d92c2($3 + 8 | 0 | 0, $3 + 64 | 0 | 0, 0 | 0, $6 | 0);
     break label$2;
    }
    HEAP32[($3 + 88 | 0) >> 2] = $7;
    HEAP32[($3 + 80 | 0) >> 2] = $5;
    i64toi32_i32$2 = $1 + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $175 = i64toi32_i32$0;
    i64toi32_i32$0 = ($3 + 64 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $175;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($3 + 84 | 0) >> 2] = $11;
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $180 = i64toi32_i32$1;
    i64toi32_i32$1 = $3;
    HEAP32[($3 + 64 | 0) >> 2] = $180;
    HEAP32[($3 + 68 | 0) >> 2] = i64toi32_i32$0;
    alloc__collections__btree__node__BalancingContext_K_2cV___merge_tracking_child_edge__hce68ab54ee2d92c2($3 + 8 | 0 | 0, $3 + 64 | 0 | 0, 1 | 0, $6 | 0);
   }
   $6 = HEAP32[($3 + 16 | 0) >> 2] | 0;
   $1 = HEAP32[($3 + 8 | 0) >> 2] | 0;
   $4 = HEAP32[($3 + 12 | 0) >> 2] | 0;
   $5 = HEAP32[$4 >> 2] | 0;
   if (!$5) {
    break label$1
   }
   if (alloc__collections__btree__fix___impl_20alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____fix_node_and_affected_ancestors__he91a4cdc5babb35c($1 + 1 | 0 | 0, $5 | 0) | 0) {
    break label$1
   }
   HEAP8[$2 >> 0] = 1;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[$0 >> 2] = $8;
  HEAP32[($0 + 12 | 0) >> 2] = $6;
  HEAP32[($0 + 8 | 0) >> 2] = $4;
  global$0 = $3 + 96 | 0;
 }
 
 function cardano_serialization_lib__utils__BigInt__div_ceil__h1921bbe0a71d04cb($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $5 = 0, $4 = 0, $6 = 0, $8 = 0, $29 = 0, $8$hi = 0, $38 = 0, $7 = 0, $60 = 0, $83 = 0, $86 = 0, $92 = 0, $109 = 0, $122 = 0, $125 = 0, $144 = 0, $155 = 0, $158 = 0, $167 = 0, $181 = 0, $184 = 0, $195 = 0, $199 = 0;
  $3 = global$0 - 128 | 0;
  global$0 = $3;
  num_bigint__biguint__division__div_rem_ref__h525df07a54bd49a5($3 + 88 | 0 | 0, $1 | 0, $2 | 0);
  $4 = ($3 + 88 | 0) + 8 | 0;
  $5 = HEAP32[$4 >> 2] | 0;
  HEAP32[(($3 + 72 | 0) + 8 | 0) >> 2] = $5;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[($3 + 88 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($3 + 92 | 0) >> 2] | 0;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$0 = $3;
  HEAP32[($3 + 72 | 0) >> 2] = $8;
  HEAP32[($3 + 76 | 0) >> 2] = i64toi32_i32$1;
  $6 = ($3 + 16 | 0) + 8 | 0;
  HEAP32[$6 >> 2] = HEAP32[($3 + 108 | 0) >> 2] | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[($3 + 100 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($3 + 104 | 0) >> 2] | 0;
  $38 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[($3 + 16 | 0) >> 2] = $38;
  HEAP32[($3 + 20 | 0) >> 2] = i64toi32_i32$0;
  $7 = HEAPU8[($1 + 12 | 0) >> 0] | 0;
  HEAP32[$4 >> 2] = $5;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$1 = $3;
  HEAP32[($3 + 88 | 0) >> 2] = $8;
  HEAP32[($3 + 92 | 0) >> 2] = i64toi32_i32$0;
  num_bigint__bigint__BigInt__from_biguint__hc8c58ec5989a4432($3 + 112 | 0 | 0, $7 | 0, $3 + 88 | 0 | 0);
  $1 = HEAPU8[($1 + 12 | 0) >> 0] | 0;
  $5 = ($3 + 32 | 0) + 8 | 0;
  HEAP32[$5 >> 2] = HEAP32[$6 >> 2] | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[($3 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($3 + 20 | 0) >> 2] | 0;
  $60 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[($3 + 32 | 0) >> 2] = $60;
  HEAP32[($3 + 36 | 0) >> 2] = i64toi32_i32$1;
  num_bigint__bigint__BigInt__from_biguint__hc8c58ec5989a4432($3 + 88 | 0 | 0, $1 | 0, $3 + 32 | 0 | 0);
  label$1 : {
   label$2 : {
    if (!(HEAPU8[($2 + 12 | 0) >> 0] | 0)) {
     break label$2
    }
    HEAP32[(($3 + 56 | 0) + 8 | 0) >> 2] = HEAP32[(($3 + 112 | 0) + 8 | 0) >> 2] | 0;
    HEAP8[($3 + 54 | 0) >> 0] = HEAPU8[($3 + 127 | 0) >> 0] | 0;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $83 = i64toi32_i32$1;
    i64toi32_i32$1 = $5;
    HEAP32[i64toi32_i32$1 >> 2] = $83;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAP32[($3 + 112 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($3 + 116 | 0) >> 2] | 0;
    $86 = i64toi32_i32$0;
    i64toi32_i32$0 = $3;
    HEAP32[($3 + 56 | 0) >> 2] = $86;
    HEAP32[($3 + 60 | 0) >> 2] = i64toi32_i32$1;
    HEAP16[($3 + 52 | 0) >> 1] = HEAPU8[($3 + 125 | 0) >> 0] | 0 | ((HEAPU8[($3 + 126 | 0) >> 0] | 0) << 8 | 0) | 0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAP32[($3 + 88 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($3 + 92 | 0) >> 2] | 0;
    $92 = i64toi32_i32$1;
    i64toi32_i32$1 = $3;
    HEAP32[($3 + 32 | 0) >> 2] = $92;
    HEAP32[($3 + 36 | 0) >> 2] = i64toi32_i32$0;
    $1 = HEAPU8[($3 + 124 | 0) >> 0] | 0;
    break label$1;
   }
   $1 = 2;
   label$3 : {
    label$4 : {
     switch ((HEAPU8[($3 + 124 | 0) >> 0] | 0) & 3 | 0 | 0) {
     case 1:
      $1 = 1;
      break label$3;
     case 2:
      break label$4;
     default:
      break label$3;
     };
    }
    $1 = 0;
   }
   HEAP8[($3 + 54 | 0) >> 0] = HEAPU8[($3 + 127 | 0) >> 0] | 0;
   i64toi32_i32$2 = ($3 + 88 | 0) + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $109 = i64toi32_i32$0;
   i64toi32_i32$0 = ($3 + 32 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $109;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[(($3 + 56 | 0) + 8 | 0) >> 2] = HEAP32[(($3 + 112 | 0) + 8 | 0) >> 2] | 0;
   HEAP16[($3 + 52 | 0) >> 1] = HEAPU8[($3 + 125 | 0) >> 0] | 0 | ((HEAPU8[($3 + 126 | 0) >> 0] | 0) << 8 | 0) | 0;
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[($3 + 88 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($3 + 92 | 0) >> 2] | 0;
   $122 = i64toi32_i32$1;
   i64toi32_i32$1 = $3;
   HEAP32[($3 + 32 | 0) >> 2] = $122;
   HEAP32[($3 + 36 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $3;
   i64toi32_i32$0 = HEAP32[($3 + 112 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($3 + 116 | 0) >> 2] | 0;
   $125 = i64toi32_i32$0;
   i64toi32_i32$0 = $3;
   HEAP32[($3 + 56 | 0) >> 2] = $125;
   HEAP32[($3 + 60 | 0) >> 2] = i64toi32_i32$1;
  }
  $2 = ($3 + 72 | 0) + 8 | 0;
  HEAP32[$2 >> 2] = HEAP32[(($3 + 56 | 0) + 8 | 0) >> 2] | 0;
  $4 = ($3 + 12 | 0) + 2 | 0;
  HEAP8[$4 >> 0] = HEAPU8[(($3 + 52 | 0) + 2 | 0) >> 0] | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[($3 + 56 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($3 + 60 | 0) >> 2] | 0;
  $144 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[($3 + 72 | 0) >> 2] = $144;
  HEAP32[($3 + 76 | 0) >> 2] = i64toi32_i32$0;
  HEAP16[($3 + 12 | 0) >> 1] = HEAPU16[($3 + 52 | 0) >> 1] | 0;
  $5 = ($3 + 16 | 0) + 8 | 0;
  i64toi32_i32$2 = ($3 + 32 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $155 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[i64toi32_i32$0 >> 2] = $155;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[($3 + 32 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($3 + 36 | 0) >> 2] | 0;
  $158 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[($3 + 16 | 0) >> 2] = $158;
  HEAP32[($3 + 20 | 0) >> 2] = i64toi32_i32$0;
  $6 = ($3 + 112 | 0) + 8 | 0;
  HEAP32[$6 >> 2] = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[($3 + 72 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($3 + 76 | 0) >> 2] | 0;
  $167 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[($3 + 112 | 0) >> 2] = $167;
  HEAP32[($3 + 116 | 0) >> 2] = i64toi32_i32$1;
  HEAP8[($3 + 127 | 0) >> 0] = HEAPU8[$4 >> 0] | 0;
  HEAP8[($3 + 124 | 0) >> 0] = $1;
  $29 = HEAPU16[($3 + 12 | 0) >> 1] | 0;
  HEAP8[($3 + 125 | 0) >> 0] = $29;
  HEAP8[($3 + 126 | 0) >> 0] = $29 >>> 8 | 0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $181 = i64toi32_i32$1;
  i64toi32_i32$1 = ($3 + 88 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $181;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[($3 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($3 + 20 | 0) >> 2] | 0;
  $184 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[($3 + 88 | 0) >> 2] = $184;
  HEAP32[($3 + 92 | 0) >> 2] = i64toi32_i32$1;
  $1 = HEAPU8[($3 + 100 | 0) >> 0] | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h19f76bdb6b4883ef($3 + 88 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h970b13f6299e0f2d($3 + 88 | 0 | 0);
  label$6 : {
   label$7 : {
    if (($1 | 0) != (1 | 0)) {
     break label$7
    }
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAP32[($3 + 112 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($3 + 116 | 0) >> 2] | 0;
    $195 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[i64toi32_i32$1 >> 2] = $195;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $6;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $199 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $199;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    break label$6;
   }
   cardano_serialization_lib__utils__BigInt__increment__h0dd310992170006f($0 | 0, $3 + 112 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h19f76bdb6b4883ef($3 + 112 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h970b13f6299e0f2d($3 + 112 | 0 | 0);
  }
  global$0 = $3 + 128 | 0;
 }
 
 function $cryptoxide__poly1305__Poly1305_20as_20cryptoxide__mac__Mac___raw_result__hdd61081e0bdedce3($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $4 = 0, $5 = 0, $6 = 0, $8 = 0, $11 = 0, $20 = 0, $20$hi = 0, $3 = 0, $10 = 0, $18 = 0, $7 = 0, $9 = 0, $12 = 0, $13 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $19 = 0, $55 = 0, $56 = 0, $57 = 0, $68 = 0, $71 = 0, $74 = 0, $159$hi = 0, $161 = 0, $161$hi = 0, $166 = 0, $179$hi = 0, $182 = 0, $182$hi = 0, $183 = 0, $183$hi = 0, $185$hi = 0, $190 = 0, $203$hi = 0, $206 = 0, $206$hi = 0, $207 = 0, $207$hi = 0, $209$hi = 0, $214 = 0, $226$hi = 0, $229 = 0, $229$hi = 0, $230 = 0, $230$hi = 0, $232$hi = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ($2 >>> 0 < 16 >>> 0) {
       break label$4
      }
      if (!(HEAPU8[($0 + 76 | 0) >> 0] | 0)) {
       break label$3
      }
      $2 = HEAP32[($0 + 32 | 0) >> 2] | 0;
      $4 = HEAP32[($0 + 28 | 0) >> 2] | 0;
      $5 = HEAP32[($0 + 24 | 0) >> 2] | 0;
      $6 = HEAP32[($0 + 20 | 0) >> 2] | 0;
      break label$2;
     }
     core__panicking__panic__h2fd385a887c8bf13(1137664 | 0, 36 | 0, 1137700 | 0);
     abort();
    }
    label$5 : {
     $2 = HEAP32[($0 + 56 | 0) >> 2] | 0;
     if (!$2) {
      break label$5
     }
     if ($2 >>> 0 > 15 >>> 0) {
      break label$1
     }
     HEAP8[(($0 + $2 | 0) + 60 | 0) >> 0] = 1;
     label$6 : {
      $2 = HEAP32[($0 + 56 | 0) >> 2] | 0;
      $4 = $2 + 1 | 0;
      if ($4 >>> 0 > 15 >>> 0) {
       break label$6
      }
      memset(($0 + $4 | 0) + 60 | 0 | 0, 0 | 0, 15 - $2 | 0 | 0) | 0;
     }
     HEAP8[($0 + 76 | 0) >> 0] = 1;
     i64toi32_i32$2 = $0 + 68 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $68 = i64toi32_i32$0;
     i64toi32_i32$0 = $3 + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $68;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 60 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 61 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 62 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 63 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 64 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 65 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 66 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 67 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $71 = i64toi32_i32$1;
     i64toi32_i32$1 = $3;
     HEAP32[i64toi32_i32$1 >> 2] = $71;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     cryptoxide__poly1305__Poly1305__block__h169ca472edf19e75(i64toi32_i32$2 | 0, i64toi32_i32$1 | 0, 16 | 0);
    }
    $74 = $0;
    $7 = $0 + 28 | 0;
    $8 = $0 + 24 | 0;
    $2 = HEAP32[$8 >> 2] | 0;
    $4 = (HEAP32[$7 >> 2] | 0) + ($2 >>> 26 | 0) | 0;
    $9 = $0 + 32 | 0;
    $5 = ($4 >>> 26 | 0) + (HEAP32[$9 >> 2] | 0) | 0;
    $10 = ($5 >>> 26 | 0) + (HEAP32[($0 + 36 | 0) >> 2] | 0) | 0;
    $6 = Math_imul($10 >>> 26 | 0, 5) + (HEAP32[($0 + 20 | 0) >> 2] | 0) | 0;
    $11 = $6 & 67108863 | 0;
    $12 = $11 + 5 | 0;
    $6 = ($6 >>> 26 | 0) + ($2 & 67108863 | 0) | 0;
    $13 = ($12 >>> 26 | 0) + $6 | 0;
    $14 = $4 & 67108863 | 0;
    $15 = ($13 >>> 26 | 0) + $14 | 0;
    $16 = $5 & 67108863 | 0;
    $17 = ($15 >>> 26 | 0) + $16 | 0;
    $18 = ($17 >>> 26 | 0) + ($10 | -67108864 | 0) | 0;
    $19 = ($18 >>> 31 | 0) + -1 | 0;
    $4 = $19 & 67108863 | 0;
    $2 = $18 >> 31 | 0;
    $5 = $4 & $13 | 0 | ($2 & $6 | 0) | 0;
    i64toi32_i32$0 = 0;
    $159$hi = i64toi32_i32$0;
    i64toi32_i32$2 = $0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
    i64toi32_i32$1 = 0;
    $161 = i64toi32_i32$0;
    $161$hi = i64toi32_i32$1;
    i64toi32_i32$1 = $159$hi;
    i64toi32_i32$2 = $4 & $12 | 0 | ($2 & $11 | 0) | 0 | ($5 << 26 | 0) | 0;
    i64toi32_i32$0 = $161$hi;
    i64toi32_i32$3 = $161;
    i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
    i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
    if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
     i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
    }
    $20 = i64toi32_i32$4;
    $20$hi = i64toi32_i32$5;
    $6 = i64toi32_i32$4;
    HEAP32[($74 + 20 | 0) >> 2] = i64toi32_i32$4;
    $166 = $8;
    $11 = $4 & $15 | 0 | ($2 & $14 | 0) | 0;
    i64toi32_i32$5 = 0;
    $179$hi = i64toi32_i32$5;
    i64toi32_i32$1 = $0 + 44 | 0;
    i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
    i64toi32_i32$2 = 0;
    $182 = i64toi32_i32$5;
    $182$hi = i64toi32_i32$2;
    i64toi32_i32$2 = $179$hi;
    i64toi32_i32$1 = $5 >>> 6 | 0 | ($11 << 20 | 0) | 0;
    i64toi32_i32$5 = $182$hi;
    i64toi32_i32$3 = $182;
    i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
    i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
    if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
     i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
    }
    $183 = i64toi32_i32$0;
    $183$hi = i64toi32_i32$4;
    i64toi32_i32$4 = $20$hi;
    i64toi32_i32$2 = $20;
    i64toi32_i32$1 = 0;
    i64toi32_i32$3 = 32;
    i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$1 = 0;
     $55 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
    } else {
     i64toi32_i32$1 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
     $55 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$5 | 0) | 0;
    }
    $185$hi = i64toi32_i32$1;
    i64toi32_i32$1 = $183$hi;
    i64toi32_i32$4 = $183;
    i64toi32_i32$2 = $185$hi;
    i64toi32_i32$3 = $55;
    i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
    i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
    if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
     i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
    }
    $20 = i64toi32_i32$5;
    $20$hi = i64toi32_i32$0;
    $5 = i64toi32_i32$5;
    HEAP32[$166 >> 2] = i64toi32_i32$5;
    $190 = $7;
    $8 = $4 & $17 | 0 | ($2 & $16 | 0) | 0;
    i64toi32_i32$0 = 0;
    $203$hi = i64toi32_i32$0;
    i64toi32_i32$1 = $0 + 48 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
    i64toi32_i32$4 = 0;
    $206 = i64toi32_i32$0;
    $206$hi = i64toi32_i32$4;
    i64toi32_i32$4 = $203$hi;
    i64toi32_i32$1 = $11 >>> 12 | 0 | ($8 << 14 | 0) | 0;
    i64toi32_i32$0 = $206$hi;
    i64toi32_i32$3 = $206;
    i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
    i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
    if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
     i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
    }
    $207 = i64toi32_i32$2;
    $207$hi = i64toi32_i32$5;
    i64toi32_i32$5 = $20$hi;
    i64toi32_i32$4 = $20;
    i64toi32_i32$1 = 0;
    i64toi32_i32$3 = 32;
    i64toi32_i32$0 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$1 = 0;
     $56 = i64toi32_i32$5 >>> i64toi32_i32$0 | 0;
    } else {
     i64toi32_i32$1 = i64toi32_i32$5 >>> i64toi32_i32$0 | 0;
     $56 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$0 | 0) | 0;
    }
    $209$hi = i64toi32_i32$1;
    i64toi32_i32$1 = $207$hi;
    i64toi32_i32$5 = $207;
    i64toi32_i32$4 = $209$hi;
    i64toi32_i32$3 = $56;
    i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
    i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
    if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
     i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
    }
    $20 = i64toi32_i32$0;
    $20$hi = i64toi32_i32$2;
    $4 = i64toi32_i32$0;
    HEAP32[$190 >> 2] = i64toi32_i32$0;
    $214 = $9;
    i64toi32_i32$2 = 0;
    $226$hi = i64toi32_i32$2;
    i64toi32_i32$1 = $0 + 52 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
    i64toi32_i32$5 = 0;
    $229 = i64toi32_i32$2;
    $229$hi = i64toi32_i32$5;
    i64toi32_i32$5 = $226$hi;
    i64toi32_i32$1 = $8 >>> 18 | 0 | (($19 & $18 | 0 | ($2 & $10 | 0) | 0) << 8 | 0) | 0;
    i64toi32_i32$2 = $229$hi;
    i64toi32_i32$3 = $229;
    i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
    i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
    if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
     i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
    }
    $230 = i64toi32_i32$4;
    $230$hi = i64toi32_i32$0;
    i64toi32_i32$0 = $20$hi;
    i64toi32_i32$5 = $20;
    i64toi32_i32$1 = 0;
    i64toi32_i32$3 = 32;
    i64toi32_i32$2 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$1 = 0;
     $57 = i64toi32_i32$0 >>> i64toi32_i32$2 | 0;
    } else {
     i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$2 | 0;
     $57 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$2 | 0) | 0;
    }
    $232$hi = i64toi32_i32$1;
    i64toi32_i32$1 = $230$hi;
    i64toi32_i32$0 = $230;
    i64toi32_i32$5 = $232$hi;
    i64toi32_i32$3 = $57;
    i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
    i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
    if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
     i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
    }
    $2 = i64toi32_i32$2;
    HEAP32[$214 >> 2] = i64toi32_i32$2;
   }
   HEAP8[($1 + 12 | 0) >> 0] = $2;
   HEAP8[($1 + 13 | 0) >> 0] = $2 >>> 8 | 0;
   HEAP8[($1 + 14 | 0) >> 0] = $2 >>> 16 | 0;
   HEAP8[($1 + 15 | 0) >> 0] = $2 >>> 24 | 0;
   HEAP8[($1 + 8 | 0) >> 0] = $4;
   HEAP8[($1 + 9 | 0) >> 0] = $4 >>> 8 | 0;
   HEAP8[($1 + 10 | 0) >> 0] = $4 >>> 16 | 0;
   HEAP8[($1 + 11 | 0) >> 0] = $4 >>> 24 | 0;
   HEAP8[($1 + 4 | 0) >> 0] = $5;
   HEAP8[($1 + 5 | 0) >> 0] = $5 >>> 8 | 0;
   HEAP8[($1 + 6 | 0) >> 0] = $5 >>> 16 | 0;
   HEAP8[($1 + 7 | 0) >> 0] = $5 >>> 24 | 0;
   HEAP8[$1 >> 0] = $6;
   HEAP8[($1 + 1 | 0) >> 0] = $6 >>> 8 | 0;
   HEAP8[($1 + 2 | 0) >> 0] = $6 >>> 16 | 0;
   HEAP8[($1 + 3 | 0) >> 0] = $6 >>> 24 | 0;
   global$0 = $3 + 16 | 0;
   return;
  }
  core__panicking__panic_bounds_check__h808b524af17640b1($2 | 0, 16 | 0, 1137796 | 0);
  abort();
 }
 
 function cardano_serialization_lib__crypto__Ed25519KeyHash__from_bech32__h8e5db0771bf3fadc($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $5 = 0, $4 = 0, $5$hi = 0, $17 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $18 = 0, $53 = 0, $110 = 0, $118 = 0, $130 = 0, $134 = 0, $186 = 0;
  $3 = global$0 - 160 | 0;
  global$0 = $3;
  bech32__decode__h25859b35256032dd($3 + 56 | 0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ((HEAP32[($3 + 56 | 0) >> 2] | 0 | 0) != (1 | 0)) {
        break label$5
       }
       i64toi32_i32$2 = $3;
       i64toi32_i32$0 = HEAP32[($3 + 60 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($3 + 64 | 0) >> 2] | 0;
       $18 = i64toi32_i32$0;
       i64toi32_i32$0 = $3;
       HEAP32[($3 + 40 | 0) >> 2] = $18;
       HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$0 = $3;
       i64toi32_i32$1 = 0;
       HEAP32[($3 + 108 | 0) >> 2] = 0;
       HEAP32[($3 + 112 | 0) >> 2] = i64toi32_i32$1;
       HEAP32[($3 + 104 | 0) >> 2] = HEAP32[(0 + 1066212 | 0) >> 2] | 0;
       core__fmt__Formatter__new__he219faf25326051b($3 + 120 | 0 | 0, $3 + 104 | 0 | 0, 1065900 | 0);
       if (!($bech32__Error_20as_20core__fmt__Display___fmt__hb94eedebff44411f($3 + 40 | 0 | 0, $3 + 120 | 0 | 0) | 0)) {
        break label$4
       }
       core__result__unwrap_failed__h27f43d993c3864a1(1065924 | 0, 55 | 0, $3 + 24 | 0 | 0, 1066104 | 0, 1066056 | 0);
       abort();
      }
      $4 = ($3 + 88 | 0) + 8 | 0;
      $1 = HEAP32[($3 + 80 | 0) >> 2] | 0;
      HEAP32[$4 >> 2] = $1;
      i64toi32_i32$2 = $3 + 72 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $5 = i64toi32_i32$1;
      $5$hi = i64toi32_i32$0;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 88 | 0) >> 2] = $5;
      HEAP32[($3 + 92 | 0) >> 2] = i64toi32_i32$0;
      $2 = HEAP32[($3 + 60 | 0) >> 2] | 0;
      i64toi32_i32$2 = ($3 + 56 | 0) + 8 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $53 = i64toi32_i32$0;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 28 | 0) >> 2] = $53;
      HEAP32[($3 + 32 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($3 + 24 | 0) >> 2] = $2;
      HEAP32[(($3 + 40 | 0) + 8 | 0) >> 2] = $1;
      i64toi32_i32$1 = $5$hi;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 40 | 0) >> 2] = $5;
      HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$1;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__heed2de4899f9d51c($3 + 16 | 0 | 0, $3 + 40 | 0 | 0);
      $alloc__vec__Vec_u8__20as_20bech32__FromBase32___from_base32__h6e67b5484009b518($3 + 120 | 0 | 0, HEAP32[($3 + 16 | 0) >> 2] | 0 | 0, HEAP32[($3 + 20 | 0) >> 2] | 0 | 0);
      if ((HEAP32[($3 + 120 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$2
      }
      $1 = HEAP32[($3 + 132 | 0) >> 2] | 0;
      HEAP32[$4 >> 2] = $1;
      i64toi32_i32$2 = $3;
      i64toi32_i32$1 = HEAP32[($3 + 124 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($3 + 128 | 0) >> 2] | 0;
      $5 = i64toi32_i32$1;
      $5$hi = i64toi32_i32$0;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 88 | 0) >> 2] = $5;
      HEAP32[($3 + 92 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[(($3 + 104 | 0) + 8 | 0) >> 2] = $1;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 104 | 0) >> 2] = $5;
      HEAP32[($3 + 108 | 0) >> 2] = i64toi32_i32$0;
      cardano_serialization_lib__crypto__Ed25519KeyHash__from_bytes__hd3490b826cff55ec($3 + 120 | 0 | 0, $3 + 104 | 0 | 0);
      if ((HEAPU8[($3 + 120 | 0) >> 0] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      $23 = HEAPU8[($3 + 121 | 0) >> 0] | 0 | ((HEAPU8[($3 + 122 | 0) >> 0] | 0) << 8 | 0) | 0;
      HEAP8[($0 + 1 | 0) >> 0] = $23;
      HEAP8[($0 + 2 | 0) >> 0] = $23 >>> 8 | 0;
      HEAP8[($0 + 3 | 0) >> 0] = HEAPU8[($3 + 123 | 0) >> 0] | 0;
      $1 = $3 + 69 | 0;
      i64toi32_i32$2 = ($3 + 120 | 0) + 21 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $110 = i64toi32_i32$0;
      i64toi32_i32$0 = $1;
      $17 = $110;
      HEAP8[i64toi32_i32$0 >> 0] = $17;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $17 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $17 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $17 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      $2 = ($3 + 56 | 0) + 8 | 0;
      i64toi32_i32$2 = ($3 + 120 | 0) + 16 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $118 = i64toi32_i32$1;
      i64toi32_i32$1 = $2;
      HEAP32[i64toi32_i32$1 >> 2] = $118;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = ($3 + 120 | 0) + 8 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $5 = i64toi32_i32$0;
      $5$hi = i64toi32_i32$1;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 56 | 0) >> 2] = $5;
      HEAP32[($3 + 60 | 0) >> 2] = i64toi32_i32$1;
      $4 = HEAP32[($3 + 124 | 0) >> 2] | 0;
      i64toi32_i32$2 = $1;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $130 = i64toi32_i32$1;
      i64toi32_i32$1 = $0 + 21 | 0;
      $19 = $130;
      HEAP8[i64toi32_i32$1 >> 0] = $19;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $19 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $19 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $19 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      i64toi32_i32$2 = $2;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $134 = i64toi32_i32$0;
      i64toi32_i32$0 = $0 + 16 | 0;
      $20 = $134;
      HEAP8[i64toi32_i32$0 >> 0] = $20;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $20 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $20 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $20 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      i64toi32_i32$1 = $5$hi;
      i64toi32_i32$0 = $0 + 8 | 0;
      HEAP8[i64toi32_i32$0 >> 0] = $5;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $5 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $5 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $5 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      $21 = $0 + 4 | 0;
      $22 = $4;
      HEAP8[$21 >> 0] = $22;
      HEAP8[($21 + 1 | 0) >> 0] = $22 >>> 8 | 0;
      HEAP8[($21 + 2 | 0) >> 0] = $22 >>> 16 | 0;
      HEAP8[($21 + 3 | 0) >> 0] = $22 >>> 24 | 0;
      HEAP8[$0 >> 0] = 0;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc91437b7d7fa2d3a($3 + 40 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h899e85abb4c3d85f($3 + 40 | 0 | 0);
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 24 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 24 | 0 | 0);
      break label$1;
     }
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $3 + 104 | 0 | 0);
     $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($3 + 8 | 0) >> 2] | 0 | 0, HEAP32[($3 + 12 | 0) >> 2] | 0 | 0) | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 104 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 104 | 0 | 0);
     $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($1 | 0) | 0;
     HEAP8[$0 >> 0] = 1;
     HEAP32[($0 + 4 | 0) >> 2] = $1;
     break label$1;
    }
    $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($3 + 124 | 0) >> 2] | 0 | 0) | 0;
    HEAP8[$0 >> 0] = 1;
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc91437b7d7fa2d3a($3 + 40 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h899e85abb4c3d85f($3 + 40 | 0 | 0);
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 24 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 24 | 0 | 0);
    break label$1;
   }
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[($3 + 124 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($3 + 128 | 0) >> 2] | 0;
   $186 = i64toi32_i32$1;
   i64toi32_i32$1 = $3;
   HEAP32[($3 + 56 | 0) >> 2] = $186;
   HEAP32[($3 + 60 | 0) >> 2] = i64toi32_i32$0;
   core__result__unwrap_failed__h27f43d993c3864a1(1066120 | 0, 43 | 0, $3 + 56 | 0 | 0, 1066164 | 0, 1066764 | 0);
   abort();
  }
  global$0 = $3 + 160 | 0;
 }
 
 function cardano_serialization_lib__crypto__ScriptHash__from_bech32__hefbc370370a0c52a($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $5 = 0, $4 = 0, $5$hi = 0, $17 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $18 = 0, $53 = 0, $110 = 0, $118 = 0, $130 = 0, $134 = 0, $186 = 0;
  $3 = global$0 - 160 | 0;
  global$0 = $3;
  bech32__decode__h25859b35256032dd($3 + 56 | 0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ((HEAP32[($3 + 56 | 0) >> 2] | 0 | 0) != (1 | 0)) {
        break label$5
       }
       i64toi32_i32$2 = $3;
       i64toi32_i32$0 = HEAP32[($3 + 60 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($3 + 64 | 0) >> 2] | 0;
       $18 = i64toi32_i32$0;
       i64toi32_i32$0 = $3;
       HEAP32[($3 + 40 | 0) >> 2] = $18;
       HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$0 = $3;
       i64toi32_i32$1 = 0;
       HEAP32[($3 + 108 | 0) >> 2] = 0;
       HEAP32[($3 + 112 | 0) >> 2] = i64toi32_i32$1;
       HEAP32[($3 + 104 | 0) >> 2] = HEAP32[(0 + 1066212 | 0) >> 2] | 0;
       core__fmt__Formatter__new__he219faf25326051b($3 + 120 | 0 | 0, $3 + 104 | 0 | 0, 1065900 | 0);
       if (!($bech32__Error_20as_20core__fmt__Display___fmt__hb94eedebff44411f($3 + 40 | 0 | 0, $3 + 120 | 0 | 0) | 0)) {
        break label$4
       }
       core__result__unwrap_failed__h27f43d993c3864a1(1065924 | 0, 55 | 0, $3 + 24 | 0 | 0, 1066104 | 0, 1066056 | 0);
       abort();
      }
      $4 = ($3 + 88 | 0) + 8 | 0;
      $1 = HEAP32[($3 + 80 | 0) >> 2] | 0;
      HEAP32[$4 >> 2] = $1;
      i64toi32_i32$2 = $3 + 72 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $5 = i64toi32_i32$1;
      $5$hi = i64toi32_i32$0;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 88 | 0) >> 2] = $5;
      HEAP32[($3 + 92 | 0) >> 2] = i64toi32_i32$0;
      $2 = HEAP32[($3 + 60 | 0) >> 2] | 0;
      i64toi32_i32$2 = ($3 + 56 | 0) + 8 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $53 = i64toi32_i32$0;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 28 | 0) >> 2] = $53;
      HEAP32[($3 + 32 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($3 + 24 | 0) >> 2] = $2;
      HEAP32[(($3 + 40 | 0) + 8 | 0) >> 2] = $1;
      i64toi32_i32$1 = $5$hi;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 40 | 0) >> 2] = $5;
      HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$1;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__heed2de4899f9d51c($3 + 16 | 0 | 0, $3 + 40 | 0 | 0);
      $alloc__vec__Vec_u8__20as_20bech32__FromBase32___from_base32__h6e67b5484009b518($3 + 120 | 0 | 0, HEAP32[($3 + 16 | 0) >> 2] | 0 | 0, HEAP32[($3 + 20 | 0) >> 2] | 0 | 0);
      if ((HEAP32[($3 + 120 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$2
      }
      $1 = HEAP32[($3 + 132 | 0) >> 2] | 0;
      HEAP32[$4 >> 2] = $1;
      i64toi32_i32$2 = $3;
      i64toi32_i32$1 = HEAP32[($3 + 124 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($3 + 128 | 0) >> 2] | 0;
      $5 = i64toi32_i32$1;
      $5$hi = i64toi32_i32$0;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 88 | 0) >> 2] = $5;
      HEAP32[($3 + 92 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[(($3 + 104 | 0) + 8 | 0) >> 2] = $1;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 104 | 0) >> 2] = $5;
      HEAP32[($3 + 108 | 0) >> 2] = i64toi32_i32$0;
      cardano_serialization_lib__crypto__ScriptHash__from_bytes__heb261e3c2077a8e6($3 + 120 | 0 | 0, $3 + 104 | 0 | 0);
      if ((HEAPU8[($3 + 120 | 0) >> 0] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      $23 = HEAPU8[($3 + 121 | 0) >> 0] | 0 | ((HEAPU8[($3 + 122 | 0) >> 0] | 0) << 8 | 0) | 0;
      HEAP8[($0 + 1 | 0) >> 0] = $23;
      HEAP8[($0 + 2 | 0) >> 0] = $23 >>> 8 | 0;
      HEAP8[($0 + 3 | 0) >> 0] = HEAPU8[($3 + 123 | 0) >> 0] | 0;
      $1 = $3 + 69 | 0;
      i64toi32_i32$2 = ($3 + 120 | 0) + 21 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $110 = i64toi32_i32$0;
      i64toi32_i32$0 = $1;
      $17 = $110;
      HEAP8[i64toi32_i32$0 >> 0] = $17;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $17 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $17 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $17 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      $2 = ($3 + 56 | 0) + 8 | 0;
      i64toi32_i32$2 = ($3 + 120 | 0) + 16 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $118 = i64toi32_i32$1;
      i64toi32_i32$1 = $2;
      HEAP32[i64toi32_i32$1 >> 2] = $118;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = ($3 + 120 | 0) + 8 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $5 = i64toi32_i32$0;
      $5$hi = i64toi32_i32$1;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 56 | 0) >> 2] = $5;
      HEAP32[($3 + 60 | 0) >> 2] = i64toi32_i32$1;
      $4 = HEAP32[($3 + 124 | 0) >> 2] | 0;
      i64toi32_i32$2 = $1;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $130 = i64toi32_i32$1;
      i64toi32_i32$1 = $0 + 21 | 0;
      $19 = $130;
      HEAP8[i64toi32_i32$1 >> 0] = $19;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $19 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $19 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $19 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      i64toi32_i32$2 = $2;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $134 = i64toi32_i32$0;
      i64toi32_i32$0 = $0 + 16 | 0;
      $20 = $134;
      HEAP8[i64toi32_i32$0 >> 0] = $20;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $20 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $20 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $20 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      i64toi32_i32$1 = $5$hi;
      i64toi32_i32$0 = $0 + 8 | 0;
      HEAP8[i64toi32_i32$0 >> 0] = $5;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $5 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $5 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $5 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      $21 = $0 + 4 | 0;
      $22 = $4;
      HEAP8[$21 >> 0] = $22;
      HEAP8[($21 + 1 | 0) >> 0] = $22 >>> 8 | 0;
      HEAP8[($21 + 2 | 0) >> 0] = $22 >>> 16 | 0;
      HEAP8[($21 + 3 | 0) >> 0] = $22 >>> 24 | 0;
      HEAP8[$0 >> 0] = 0;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc91437b7d7fa2d3a($3 + 40 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h899e85abb4c3d85f($3 + 40 | 0 | 0);
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 24 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 24 | 0 | 0);
      break label$1;
     }
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $3 + 104 | 0 | 0);
     $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($3 + 8 | 0) >> 2] | 0 | 0, HEAP32[($3 + 12 | 0) >> 2] | 0 | 0) | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 104 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 104 | 0 | 0);
     $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($1 | 0) | 0;
     HEAP8[$0 >> 0] = 1;
     HEAP32[($0 + 4 | 0) >> 2] = $1;
     break label$1;
    }
    $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($3 + 124 | 0) >> 2] | 0 | 0) | 0;
    HEAP8[$0 >> 0] = 1;
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc91437b7d7fa2d3a($3 + 40 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h899e85abb4c3d85f($3 + 40 | 0 | 0);
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 24 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 24 | 0 | 0);
    break label$1;
   }
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[($3 + 124 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($3 + 128 | 0) >> 2] | 0;
   $186 = i64toi32_i32$1;
   i64toi32_i32$1 = $3;
   HEAP32[($3 + 56 | 0) >> 2] = $186;
   HEAP32[($3 + 60 | 0) >> 2] = i64toi32_i32$0;
   core__result__unwrap_failed__h27f43d993c3864a1(1066120 | 0, 43 | 0, $3 + 56 | 0 | 0, 1066164 | 0, 1066796 | 0);
   abort();
  }
  global$0 = $3 + 160 | 0;
 }
 
 function cardano_serialization_lib__crypto__GenesisDelegateHash__from_bech32__hbb851a692b2f068b($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $5 = 0, $4 = 0, $5$hi = 0, $17 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $18 = 0, $53 = 0, $110 = 0, $118 = 0, $130 = 0, $134 = 0, $186 = 0;
  $3 = global$0 - 160 | 0;
  global$0 = $3;
  bech32__decode__h25859b35256032dd($3 + 56 | 0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ((HEAP32[($3 + 56 | 0) >> 2] | 0 | 0) != (1 | 0)) {
        break label$5
       }
       i64toi32_i32$2 = $3;
       i64toi32_i32$0 = HEAP32[($3 + 60 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($3 + 64 | 0) >> 2] | 0;
       $18 = i64toi32_i32$0;
       i64toi32_i32$0 = $3;
       HEAP32[($3 + 40 | 0) >> 2] = $18;
       HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$0 = $3;
       i64toi32_i32$1 = 0;
       HEAP32[($3 + 108 | 0) >> 2] = 0;
       HEAP32[($3 + 112 | 0) >> 2] = i64toi32_i32$1;
       HEAP32[($3 + 104 | 0) >> 2] = HEAP32[(0 + 1066212 | 0) >> 2] | 0;
       core__fmt__Formatter__new__he219faf25326051b($3 + 120 | 0 | 0, $3 + 104 | 0 | 0, 1065900 | 0);
       if (!($bech32__Error_20as_20core__fmt__Display___fmt__hb94eedebff44411f($3 + 40 | 0 | 0, $3 + 120 | 0 | 0) | 0)) {
        break label$4
       }
       core__result__unwrap_failed__h27f43d993c3864a1(1065924 | 0, 55 | 0, $3 + 24 | 0 | 0, 1066104 | 0, 1066056 | 0);
       abort();
      }
      $4 = ($3 + 88 | 0) + 8 | 0;
      $1 = HEAP32[($3 + 80 | 0) >> 2] | 0;
      HEAP32[$4 >> 2] = $1;
      i64toi32_i32$2 = $3 + 72 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $5 = i64toi32_i32$1;
      $5$hi = i64toi32_i32$0;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 88 | 0) >> 2] = $5;
      HEAP32[($3 + 92 | 0) >> 2] = i64toi32_i32$0;
      $2 = HEAP32[($3 + 60 | 0) >> 2] | 0;
      i64toi32_i32$2 = ($3 + 56 | 0) + 8 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $53 = i64toi32_i32$0;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 28 | 0) >> 2] = $53;
      HEAP32[($3 + 32 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($3 + 24 | 0) >> 2] = $2;
      HEAP32[(($3 + 40 | 0) + 8 | 0) >> 2] = $1;
      i64toi32_i32$1 = $5$hi;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 40 | 0) >> 2] = $5;
      HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$1;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__heed2de4899f9d51c($3 + 16 | 0 | 0, $3 + 40 | 0 | 0);
      $alloc__vec__Vec_u8__20as_20bech32__FromBase32___from_base32__h6e67b5484009b518($3 + 120 | 0 | 0, HEAP32[($3 + 16 | 0) >> 2] | 0 | 0, HEAP32[($3 + 20 | 0) >> 2] | 0 | 0);
      if ((HEAP32[($3 + 120 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$2
      }
      $1 = HEAP32[($3 + 132 | 0) >> 2] | 0;
      HEAP32[$4 >> 2] = $1;
      i64toi32_i32$2 = $3;
      i64toi32_i32$1 = HEAP32[($3 + 124 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($3 + 128 | 0) >> 2] | 0;
      $5 = i64toi32_i32$1;
      $5$hi = i64toi32_i32$0;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 88 | 0) >> 2] = $5;
      HEAP32[($3 + 92 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[(($3 + 104 | 0) + 8 | 0) >> 2] = $1;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 104 | 0) >> 2] = $5;
      HEAP32[($3 + 108 | 0) >> 2] = i64toi32_i32$0;
      cardano_serialization_lib__crypto__GenesisDelegateHash__from_bytes__hc6d86e4470d3551a($3 + 120 | 0 | 0, $3 + 104 | 0 | 0);
      if ((HEAPU8[($3 + 120 | 0) >> 0] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      $23 = HEAPU8[($3 + 121 | 0) >> 0] | 0 | ((HEAPU8[($3 + 122 | 0) >> 0] | 0) << 8 | 0) | 0;
      HEAP8[($0 + 1 | 0) >> 0] = $23;
      HEAP8[($0 + 2 | 0) >> 0] = $23 >>> 8 | 0;
      HEAP8[($0 + 3 | 0) >> 0] = HEAPU8[($3 + 123 | 0) >> 0] | 0;
      $1 = $3 + 69 | 0;
      i64toi32_i32$2 = ($3 + 120 | 0) + 21 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $110 = i64toi32_i32$0;
      i64toi32_i32$0 = $1;
      $17 = $110;
      HEAP8[i64toi32_i32$0 >> 0] = $17;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $17 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $17 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $17 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      $2 = ($3 + 56 | 0) + 8 | 0;
      i64toi32_i32$2 = ($3 + 120 | 0) + 16 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $118 = i64toi32_i32$1;
      i64toi32_i32$1 = $2;
      HEAP32[i64toi32_i32$1 >> 2] = $118;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = ($3 + 120 | 0) + 8 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $5 = i64toi32_i32$0;
      $5$hi = i64toi32_i32$1;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 56 | 0) >> 2] = $5;
      HEAP32[($3 + 60 | 0) >> 2] = i64toi32_i32$1;
      $4 = HEAP32[($3 + 124 | 0) >> 2] | 0;
      i64toi32_i32$2 = $1;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $130 = i64toi32_i32$1;
      i64toi32_i32$1 = $0 + 21 | 0;
      $19 = $130;
      HEAP8[i64toi32_i32$1 >> 0] = $19;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $19 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $19 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $19 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      i64toi32_i32$2 = $2;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $134 = i64toi32_i32$0;
      i64toi32_i32$0 = $0 + 16 | 0;
      $20 = $134;
      HEAP8[i64toi32_i32$0 >> 0] = $20;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $20 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $20 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $20 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      i64toi32_i32$1 = $5$hi;
      i64toi32_i32$0 = $0 + 8 | 0;
      HEAP8[i64toi32_i32$0 >> 0] = $5;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $5 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $5 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $5 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      $21 = $0 + 4 | 0;
      $22 = $4;
      HEAP8[$21 >> 0] = $22;
      HEAP8[($21 + 1 | 0) >> 0] = $22 >>> 8 | 0;
      HEAP8[($21 + 2 | 0) >> 0] = $22 >>> 16 | 0;
      HEAP8[($21 + 3 | 0) >> 0] = $22 >>> 24 | 0;
      HEAP8[$0 >> 0] = 0;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc91437b7d7fa2d3a($3 + 40 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h899e85abb4c3d85f($3 + 40 | 0 | 0);
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 24 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 24 | 0 | 0);
      break label$1;
     }
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $3 + 104 | 0 | 0);
     $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($3 + 8 | 0) >> 2] | 0 | 0, HEAP32[($3 + 12 | 0) >> 2] | 0 | 0) | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 104 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 104 | 0 | 0);
     $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($1 | 0) | 0;
     HEAP8[$0 >> 0] = 1;
     HEAP32[($0 + 4 | 0) >> 2] = $1;
     break label$1;
    }
    $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($3 + 124 | 0) >> 2] | 0 | 0) | 0;
    HEAP8[$0 >> 0] = 1;
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc91437b7d7fa2d3a($3 + 40 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h899e85abb4c3d85f($3 + 40 | 0 | 0);
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 24 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 24 | 0 | 0);
    break label$1;
   }
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[($3 + 124 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($3 + 128 | 0) >> 2] | 0;
   $186 = i64toi32_i32$1;
   i64toi32_i32$1 = $3;
   HEAP32[($3 + 56 | 0) >> 2] = $186;
   HEAP32[($3 + 60 | 0) >> 2] = i64toi32_i32$0;
   core__result__unwrap_failed__h27f43d993c3864a1(1066120 | 0, 43 | 0, $3 + 56 | 0 | 0, 1066164 | 0, 1066856 | 0);
   abort();
  }
  global$0 = $3 + 160 | 0;
 }
 
 function cardano_serialization_lib__crypto__GenesisHash__from_bech32__hf73e448ecc0e7f72($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $5 = 0, $4 = 0, $5$hi = 0, $17 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $18 = 0, $53 = 0, $110 = 0, $118 = 0, $130 = 0, $134 = 0, $186 = 0;
  $3 = global$0 - 160 | 0;
  global$0 = $3;
  bech32__decode__h25859b35256032dd($3 + 56 | 0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ((HEAP32[($3 + 56 | 0) >> 2] | 0 | 0) != (1 | 0)) {
        break label$5
       }
       i64toi32_i32$2 = $3;
       i64toi32_i32$0 = HEAP32[($3 + 60 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($3 + 64 | 0) >> 2] | 0;
       $18 = i64toi32_i32$0;
       i64toi32_i32$0 = $3;
       HEAP32[($3 + 40 | 0) >> 2] = $18;
       HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$0 = $3;
       i64toi32_i32$1 = 0;
       HEAP32[($3 + 108 | 0) >> 2] = 0;
       HEAP32[($3 + 112 | 0) >> 2] = i64toi32_i32$1;
       HEAP32[($3 + 104 | 0) >> 2] = HEAP32[(0 + 1066212 | 0) >> 2] | 0;
       core__fmt__Formatter__new__he219faf25326051b($3 + 120 | 0 | 0, $3 + 104 | 0 | 0, 1065900 | 0);
       if (!($bech32__Error_20as_20core__fmt__Display___fmt__hb94eedebff44411f($3 + 40 | 0 | 0, $3 + 120 | 0 | 0) | 0)) {
        break label$4
       }
       core__result__unwrap_failed__h27f43d993c3864a1(1065924 | 0, 55 | 0, $3 + 24 | 0 | 0, 1066104 | 0, 1066056 | 0);
       abort();
      }
      $4 = ($3 + 88 | 0) + 8 | 0;
      $1 = HEAP32[($3 + 80 | 0) >> 2] | 0;
      HEAP32[$4 >> 2] = $1;
      i64toi32_i32$2 = $3 + 72 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $5 = i64toi32_i32$1;
      $5$hi = i64toi32_i32$0;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 88 | 0) >> 2] = $5;
      HEAP32[($3 + 92 | 0) >> 2] = i64toi32_i32$0;
      $2 = HEAP32[($3 + 60 | 0) >> 2] | 0;
      i64toi32_i32$2 = ($3 + 56 | 0) + 8 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $53 = i64toi32_i32$0;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 28 | 0) >> 2] = $53;
      HEAP32[($3 + 32 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($3 + 24 | 0) >> 2] = $2;
      HEAP32[(($3 + 40 | 0) + 8 | 0) >> 2] = $1;
      i64toi32_i32$1 = $5$hi;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 40 | 0) >> 2] = $5;
      HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$1;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__heed2de4899f9d51c($3 + 16 | 0 | 0, $3 + 40 | 0 | 0);
      $alloc__vec__Vec_u8__20as_20bech32__FromBase32___from_base32__h6e67b5484009b518($3 + 120 | 0 | 0, HEAP32[($3 + 16 | 0) >> 2] | 0 | 0, HEAP32[($3 + 20 | 0) >> 2] | 0 | 0);
      if ((HEAP32[($3 + 120 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$2
      }
      $1 = HEAP32[($3 + 132 | 0) >> 2] | 0;
      HEAP32[$4 >> 2] = $1;
      i64toi32_i32$2 = $3;
      i64toi32_i32$1 = HEAP32[($3 + 124 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($3 + 128 | 0) >> 2] | 0;
      $5 = i64toi32_i32$1;
      $5$hi = i64toi32_i32$0;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 88 | 0) >> 2] = $5;
      HEAP32[($3 + 92 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[(($3 + 104 | 0) + 8 | 0) >> 2] = $1;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 104 | 0) >> 2] = $5;
      HEAP32[($3 + 108 | 0) >> 2] = i64toi32_i32$0;
      cardano_serialization_lib__crypto__GenesisHash__from_bytes__he8377b8a376c1d46($3 + 120 | 0 | 0, $3 + 104 | 0 | 0);
      if ((HEAPU8[($3 + 120 | 0) >> 0] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      $23 = HEAPU8[($3 + 121 | 0) >> 0] | 0 | ((HEAPU8[($3 + 122 | 0) >> 0] | 0) << 8 | 0) | 0;
      HEAP8[($0 + 1 | 0) >> 0] = $23;
      HEAP8[($0 + 2 | 0) >> 0] = $23 >>> 8 | 0;
      HEAP8[($0 + 3 | 0) >> 0] = HEAPU8[($3 + 123 | 0) >> 0] | 0;
      $1 = $3 + 69 | 0;
      i64toi32_i32$2 = ($3 + 120 | 0) + 21 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $110 = i64toi32_i32$0;
      i64toi32_i32$0 = $1;
      $17 = $110;
      HEAP8[i64toi32_i32$0 >> 0] = $17;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $17 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $17 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $17 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      $2 = ($3 + 56 | 0) + 8 | 0;
      i64toi32_i32$2 = ($3 + 120 | 0) + 16 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $118 = i64toi32_i32$1;
      i64toi32_i32$1 = $2;
      HEAP32[i64toi32_i32$1 >> 2] = $118;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = ($3 + 120 | 0) + 8 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $5 = i64toi32_i32$0;
      $5$hi = i64toi32_i32$1;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 56 | 0) >> 2] = $5;
      HEAP32[($3 + 60 | 0) >> 2] = i64toi32_i32$1;
      $4 = HEAP32[($3 + 124 | 0) >> 2] | 0;
      i64toi32_i32$2 = $1;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $130 = i64toi32_i32$1;
      i64toi32_i32$1 = $0 + 21 | 0;
      $19 = $130;
      HEAP8[i64toi32_i32$1 >> 0] = $19;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $19 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $19 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $19 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      i64toi32_i32$2 = $2;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $134 = i64toi32_i32$0;
      i64toi32_i32$0 = $0 + 16 | 0;
      $20 = $134;
      HEAP8[i64toi32_i32$0 >> 0] = $20;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $20 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $20 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $20 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      i64toi32_i32$1 = $5$hi;
      i64toi32_i32$0 = $0 + 8 | 0;
      HEAP8[i64toi32_i32$0 >> 0] = $5;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $5 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $5 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $5 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      $21 = $0 + 4 | 0;
      $22 = $4;
      HEAP8[$21 >> 0] = $22;
      HEAP8[($21 + 1 | 0) >> 0] = $22 >>> 8 | 0;
      HEAP8[($21 + 2 | 0) >> 0] = $22 >>> 16 | 0;
      HEAP8[($21 + 3 | 0) >> 0] = $22 >>> 24 | 0;
      HEAP8[$0 >> 0] = 0;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc91437b7d7fa2d3a($3 + 40 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h899e85abb4c3d85f($3 + 40 | 0 | 0);
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 24 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 24 | 0 | 0);
      break label$1;
     }
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $3 + 104 | 0 | 0);
     $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($3 + 8 | 0) >> 2] | 0 | 0, HEAP32[($3 + 12 | 0) >> 2] | 0 | 0) | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 104 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 104 | 0 | 0);
     $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($1 | 0) | 0;
     HEAP8[$0 >> 0] = 1;
     HEAP32[($0 + 4 | 0) >> 2] = $1;
     break label$1;
    }
    $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($3 + 124 | 0) >> 2] | 0 | 0) | 0;
    HEAP8[$0 >> 0] = 1;
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc91437b7d7fa2d3a($3 + 40 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h899e85abb4c3d85f($3 + 40 | 0 | 0);
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 24 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 24 | 0 | 0);
    break label$1;
   }
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[($3 + 124 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($3 + 128 | 0) >> 2] | 0;
   $186 = i64toi32_i32$1;
   i64toi32_i32$1 = $3;
   HEAP32[($3 + 56 | 0) >> 2] = $186;
   HEAP32[($3 + 60 | 0) >> 2] = i64toi32_i32$0;
   core__result__unwrap_failed__h27f43d993c3864a1(1066120 | 0, 43 | 0, $3 + 56 | 0 | 0, 1066164 | 0, 1066892 | 0);
   abort();
  }
  global$0 = $3 + 160 | 0;
 }
 
 function cbor_event__de__Deserializer_R___text__h764f26557f652908($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $6 = 0, $8 = 0, $8$hi = 0, $7 = 0, $7$hi = 0, $3 = 0, $4 = 0, $5 = 0, i64toi32_i32$4 = 0, $69 = 0, $75 = 0, $90 = 0, $92$hi = 0, $95$hi = 0, $128 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 24 | 0 | 0, $1 | 0);
  $3 = 8;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $4 = HEAP32[($2 + 28 | 0) >> 2] | 0;
      if (!$4) {
       break label$4
      }
      $3 = 8;
      $5 = HEAP32[($2 + 24 | 0) >> 2] | 0;
      if (!$5) {
       break label$4
      }
      $3 = 9;
      $6 = ($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[$5 >> 0] | 0 | 0) | 0) & 255 | 0;
      if (($6 | 0) != (3 | 0)) {
       break label$4
      }
      cbor_event__de__Deserializer_R___cbor_len__h852681e444aca076_1($2 + 32 | 0 | 0, $1 | 0);
      $6 = HEAP32[(($2 + 32 | 0) + 24 | 0) >> 2] | 0;
      i64toi32_i32$2 = ($2 + 32 | 0) + 16 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $7 = i64toi32_i32$0;
      $7$hi = i64toi32_i32$1;
      i64toi32_i32$2 = $2;
      i64toi32_i32$1 = HEAP32[($2 + 40 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($2 + 44 | 0) >> 2] | 0;
      $8 = i64toi32_i32$1;
      $8$hi = i64toi32_i32$0;
      i64toi32_i32$2 = $2;
      i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
      i64toi32_i32$2 = i64toi32_i32$0;
      i64toi32_i32$0 = 0;
      i64toi32_i32$3 = 1;
      if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
       break label$3
      }
      i64toi32_i32$2 = $8$hi;
      if ($8) {
       break label$2
      }
      HEAP32[$0 >> 2] = 1;
      HEAP16[($0 + 8 | 0) >> 1] = 780;
      break label$1;
     }
     HEAP32[$0 >> 2] = 1;
     HEAP32[($0 + 16 | 0) >> 2] = 0;
     HEAP32[($0 + 12 | 0) >> 2] = $4;
     HEAP8[($0 + 10 | 0) >> 0] = $6;
     HEAP8[($0 + 9 | 0) >> 0] = 3;
     HEAP8[($0 + 8 | 0) >> 0] = $3;
     break label$1;
    }
    i64toi32_i32$3 = ($2 + 32 | 0) + 32 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $69 = i64toi32_i32$2;
    i64toi32_i32$2 = $0 + 32 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $69;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$3 = ($2 + 32 | 0) + 40 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $75 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 40 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $75;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
    HEAP32[($0 + 28 | 0) >> 2] = HEAP32[($2 + 60 | 0) >> 2] | 0;
    HEAP32[($0 + 24 | 0) >> 2] = $6;
    i64toi32_i32$2 = $7$hi;
    i64toi32_i32$1 = $0 + 16 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $7;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $8$hi;
    i64toi32_i32$1 = $0 + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $8;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
    HEAP32[$0 >> 2] = 1;
    break label$1;
   }
   $90 = $1;
   i64toi32_i32$3 = $1;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $92$hi = i64toi32_i32$1;
   i64toi32_i32$1 = 0;
   $95$hi = i64toi32_i32$1;
   i64toi32_i32$1 = $92$hi;
   i64toi32_i32$3 = i64toi32_i32$2;
   i64toi32_i32$2 = $95$hi;
   i64toi32_i32$0 = $6 + 1 | 0;
   i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
   i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
   if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
    i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
   }
   i64toi32_i32$3 = $90;
   HEAP32[i64toi32_i32$3 >> 2] = i64toi32_i32$4;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$5 = $7$hi;
   alloc__vec__from_elem__hdc900c1db7c0f1ee($2 + 80 | 0 | 0, 0 | 0, $7 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__DerefMut___deref_mut__h1882e042320a120c($2 + 16 | 0 | 0, $2 + 80 | 0 | 0);
   label$5 : {
    label$6 : {
     i64toi32_i32$5 = $std__io__cursor__Cursor_T__20as_20std__io__Read___read_exact__h9623dbdca04d0b37($1 | 0, HEAP32[($2 + 16 | 0) >> 2] | 0 | 0, HEAP32[($2 + 20 | 0) >> 2] | 0 | 0) | 0;
     i64toi32_i32$3 = i64toi32_i32$HIGH_BITS;
     $8 = i64toi32_i32$5;
     $8$hi = i64toi32_i32$3;
     if ((i64toi32_i32$5 & 255 | 0 | 0) == (4 | 0)) {
      break label$6
     }
     i64toi32_i32$3 = $8$hi;
     i64toi32_i32$1 = $8;
     i64toi32_i32$5 = 0;
     i64toi32_i32$0 = 255;
     i64toi32_i32$5 = i64toi32_i32$3 & i64toi32_i32$5 | 0;
     i64toi32_i32$3 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
     i64toi32_i32$1 = 0;
     i64toi32_i32$0 = 4;
     if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$5 | 0) != (i64toi32_i32$1 | 0) | 0) {
      break label$5
     }
    }
    $6 = ($2 + 144 | 0) + 8 | 0;
    HEAP32[$6 >> 2] = HEAP32[(($2 + 80 | 0) + 8 | 0) >> 2] | 0;
    i64toi32_i32$0 = $2;
    i64toi32_i32$3 = HEAP32[($2 + 80 | 0) >> 2] | 0;
    i64toi32_i32$5 = HEAP32[($2 + 84 | 0) >> 2] | 0;
    $128 = i64toi32_i32$3;
    i64toi32_i32$3 = $2;
    HEAP32[($2 + 144 | 0) >> 2] = $128;
    HEAP32[($2 + 148 | 0) >> 2] = i64toi32_i32$5;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $2 + 144 | 0 | 0);
    core__str__converts__from_utf8__h4bd16e554326fb60($2 + 32 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
    label$7 : {
     if ((HEAP32[($2 + 32 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$7
     }
     $6 = HEAP32[$6 >> 2] | 0;
     HEAP32[(($2 + 96 | 0) + 8 | 0) >> 2] = $6;
     i64toi32_i32$0 = $2;
     i64toi32_i32$5 = HEAP32[($2 + 144 | 0) >> 2] | 0;
     i64toi32_i32$3 = HEAP32[($2 + 148 | 0) >> 2] | 0;
     $8 = i64toi32_i32$5;
     $8$hi = i64toi32_i32$3;
     i64toi32_i32$5 = $2;
     HEAP32[($2 + 96 | 0) >> 2] = $8;
     HEAP32[($2 + 100 | 0) >> 2] = i64toi32_i32$3;
     HEAP32[($0 + 12 | 0) >> 2] = $6;
     i64toi32_i32$5 = $0;
     HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = $8;
     HEAP32[(i64toi32_i32$5 + 8 | 0) >> 2] = i64toi32_i32$3;
     HEAP32[i64toi32_i32$5 >> 2] = 0;
     break label$1;
    }
    $6 = HEAP32[$6 >> 2] | 0;
    HEAP32[(($2 + 112 | 0) + 8 | 0) >> 2] = $6;
    i64toi32_i32$0 = $2;
    i64toi32_i32$3 = HEAP32[($2 + 144 | 0) >> 2] | 0;
    i64toi32_i32$5 = HEAP32[($2 + 148 | 0) >> 2] | 0;
    $8 = i64toi32_i32$3;
    $8$hi = i64toi32_i32$5;
    i64toi32_i32$3 = $2;
    HEAP32[($2 + 112 | 0) >> 2] = $8;
    HEAP32[($2 + 116 | 0) >> 2] = i64toi32_i32$5;
    i64toi32_i32$0 = $2;
    i64toi32_i32$5 = HEAP32[($2 + 36 | 0) >> 2] | 0;
    i64toi32_i32$3 = HEAP32[($2 + 40 | 0) >> 2] | 0;
    $7 = i64toi32_i32$5;
    $7$hi = i64toi32_i32$3;
    HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = $6;
    i64toi32_i32$3 = $8$hi;
    i64toi32_i32$5 = $2;
    HEAP32[($2 + 32 | 0) >> 2] = $8;
    HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$3;
    i64toi32_i32$3 = $7$hi;
    i64toi32_i32$5 = $2;
    HEAP32[($2 + 44 | 0) >> 2] = $7;
    HEAP32[($2 + 48 | 0) >> 2] = i64toi32_i32$3;
    $cbor_event__error__Error_20as_20core__convert__From_alloc__string__FromUtf8Error____from__hdc659cdcf1613a8b($0 + 8 | 0 | 0, $2 + 32 | 0 | 0);
    HEAP32[$0 >> 2] = 1;
    break label$1;
   }
   i64toi32_i32$3 = $8$hi;
   $cbor_event__error__Error_20as_20core__convert__From_std__io__error__Error____from__hd172f94a2e75bf41($0 + 8 | 0 | 0, $8 | 0, i64toi32_i32$3 | 0);
   HEAP32[$0 >> 2] = 1;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 80 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 80 | 0 | 0);
  }
  global$0 = $2 + 160 | 0;
 }
 
 function cardano_serialization_lib__tx_builder__TransactionBuilder__get_total_input__hf80aba4988a4a524($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $5 = 0, $17 = 0, $23 = 0, $26 = 0, $55 = 0, $63 = 0, $69 = 0, $87 = 0, $92 = 0, $95 = 0, $110 = 0, $117 = 0, $122 = 0;
  $2 = global$0 - 208 | 0;
  global$0 = $2;
  cardano_serialization_lib__tx_builder__TransactionBuilder__get_mint_as_values__hfca4f89cac3bdba6($2 + 24 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = ($2 + 24 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $17 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $17;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = ($2 + 24 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $23 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $23;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $26 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[$2 >> 2] = $26;
  HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   if (!(HEAP32[($2 + 56 | 0) >> 2] | 0)) {
    break label$1
   }
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 60 | 0 | 0);
  }
  alloc__collections__btree__map__BTreeMap_K_2cV___iter__h721110b568622f84($2 + 152 | 0 | 0, $1 + 160 | 0 | 0);
  HEAP32[($2 + 192 | 0) >> 2] = 0;
  i64toi32_i32$0 = $2;
  i64toi32_i32$1 = 0;
  HEAP32[($2 + 184 | 0) >> 2] = 0;
  HEAP32[($2 + 188 | 0) >> 2] = i64toi32_i32$1;
  $core__iter__adapters__map__Map_I_2cF__20as_20core__iter__traits__iterator__Iterator___try_fold__h995a63110091bbf7($2 + 24 | 0 | 0, $2 + 152 | 0 | 0, $2 + 184 | 0 | 0);
  label$2 : {
   label$3 : {
    label$4 : {
     label$5 : {
      label$6 : {
       if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) == (1 | 0)) {
        break label$6
       }
       $3 = ($2 + 24 | 0) + 24 | 0;
       i64toi32_i32$2 = $3;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $55 = i64toi32_i32$1;
       i64toi32_i32$1 = ($2 + 128 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $55;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       $4 = ($2 + 24 | 0) + 16 | 0;
       i64toi32_i32$2 = $4;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $63 = i64toi32_i32$0;
       i64toi32_i32$0 = ($2 + 128 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $63;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       $5 = ($2 + 24 | 0) + 8 | 0;
       i64toi32_i32$2 = $5;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $69 = i64toi32_i32$1;
       i64toi32_i32$1 = $2;
       HEAP32[($2 + 128 | 0) >> 2] = $69;
       HEAP32[($2 + 132 | 0) >> 2] = i64toi32_i32$0;
       cardano_serialization_lib__utils__internal_get_implicit_input__h61eaf21c0f86e6a4($2 + 24 | 0 | 0, $1 + 288 | 0 | 0, $1 + 428 | 0 | 0, $1 + 16 | 0 | 0, $1 + 24 | 0 | 0);
       if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) == (1 | 0)) {
        break label$5
       }
       i64toi32_i32$2 = $3;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $87 = i64toi32_i32$0;
       i64toi32_i32$0 = ($2 + 152 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $87;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $4;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $92 = i64toi32_i32$1;
       i64toi32_i32$1 = ($2 + 152 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $92;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = $5;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $95 = i64toi32_i32$0;
       i64toi32_i32$0 = $2;
       HEAP32[($2 + 152 | 0) >> 2] = $95;
       HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$1;
       cardano_serialization_lib__utils__Value__checked_add__h5184687782847801($2 + 96 | 0 | 0, $2 + 128 | 0 | 0, $2 + 152 | 0 | 0);
       if ((HEAP32[($2 + 96 | 0) >> 2] | 0 | 0) == (1 | 0)) {
        break label$4
       }
       i64toi32_i32$2 = $2 + 120 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $110 = i64toi32_i32$1;
       i64toi32_i32$1 = ($2 + 72 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $110;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = ($2 + 96 | 0) + 16 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $117 = i64toi32_i32$0;
       i64toi32_i32$0 = ($2 + 72 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $117;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = ($2 + 96 | 0) + 8 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $122 = i64toi32_i32$1;
       i64toi32_i32$1 = $2;
       HEAP32[($2 + 72 | 0) >> 2] = $122;
       HEAP32[($2 + 76 | 0) >> 2] = i64toi32_i32$0;
       cardano_serialization_lib__utils__Value__checked_add__h5184687782847801($0 | 0, $2 + 72 | 0 | 0, $2 | 0);
       label$7 : {
        if (!(HEAP32[($2 + 8 | 0) >> 2] | 0)) {
         break label$7
        }
        $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 12 | 0 | 0);
       }
       label$8 : {
        if (!(HEAP32[($2 + 80 | 0) >> 2] | 0)) {
         break label$8
        }
        $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 84 | 0 | 0);
       }
       label$9 : {
        if (!(HEAP32[($2 + 160 | 0) >> 2] | 0)) {
         break label$9
        }
        $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 164 | 0 | 0);
       }
       if (!(HEAP32[($2 + 136 | 0) >> 2] | 0)) {
        break label$2
       }
       $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 140 | 0 | 0);
       break label$2;
      }
      $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($2 + 28 | 0) >> 2] | 0 | 0) | 0;
      HEAP32[$0 >> 2] = 1;
      HEAP32[($0 + 4 | 0) >> 2] = $1;
      if (!(HEAP32[($2 + 8 | 0) >> 2] | 0)) {
       break label$2
      }
      $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 12 | 0 | 0);
      break label$2;
     }
     $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($2 + 28 | 0) >> 2] | 0 | 0) | 0;
     HEAP32[$0 >> 2] = 1;
     HEAP32[($0 + 4 | 0) >> 2] = $1;
     if (!(HEAP32[($2 + 8 | 0) >> 2] | 0)) {
      break label$3
     }
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 12 | 0 | 0);
     break label$3;
    }
    $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($2 + 100 | 0) >> 2] | 0 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    label$10 : {
     if (!(HEAP32[($2 + 8 | 0) >> 2] | 0)) {
      break label$10
     }
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 12 | 0 | 0);
    }
    if (!(HEAP32[($2 + 160 | 0) >> 2] | 0)) {
     break label$3
    }
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 164 | 0 | 0);
   }
   if (!(HEAP32[($2 + 136 | 0) >> 2] | 0)) {
    break label$2
   }
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 140 | 0 | 0);
  }
  global$0 = $2 + 208 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_recursing__hd04c34fee68d848e($0, $1, $2, $3, $3$hi, $4, $4$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  $4 = $4 | 0;
  $4$hi = $4$hi | 0;
  var $5 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $6 = 0, $7 = 0, $9 = 0, $10 = 0, $8 = 0, $11 = 0, $12 = 0, $24 = 0, $33 = 0, $50 = 0, $87 = 0, $92 = 0, $117 = 0, $135 = 0, $146 = 0, $149 = 0, $170 = 0, $194 = 0, $197 = 0, $203 = 0;
  $5 = global$0 - 112 | 0;
  global$0 = $5;
  HEAP32[(($5 + 96 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[($5 + 96 | 0) >> 2] = $24;
  HEAP32[($5 + 100 | 0) >> 2] = i64toi32_i32$1;
  $6 = $5 + 8 | 0;
  HEAP32[$6 >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $33 = i64toi32_i32$1;
  i64toi32_i32$1 = $5;
  HEAP32[$5 >> 2] = $33;
  HEAP32[($5 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $3$hi;
  i64toi32_i32$0 = $4$hi;
  i64toi32_i32$0 = $3$hi;
  i64toi32_i32$1 = $4$hi;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert__h60bbba19db10f7c2($5 + 16 | 0 | 0, $5 + 96 | 0 | 0, $5 | 0, $3 | 0, i64toi32_i32$0 | 0, $4 | 0, i64toi32_i32$1 | 0);
  $7 = HEAP32[($5 + 72 | 0) >> 2] | 0;
  label$1 : {
   label$2 : {
    if ((HEAP32[($5 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    HEAP32[($0 + 56 | 0) >> 2] = $7;
    i64toi32_i32$2 = $5;
    i64toi32_i32$1 = HEAP32[($5 + 20 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($5 + 24 | 0) >> 2] | 0;
    $50 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $50;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[i64toi32_i32$1 >> 2] = 0;
    HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = HEAP32[(($5 + 16 | 0) + 12 | 0) >> 2] | 0;
    break label$1;
   }
   $8 = ($5 + 16 | 0) + 32 | 0;
   i64toi32_i32$2 = $8;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $3 = i64toi32_i32$0;
   $3$hi = i64toi32_i32$1;
   i64toi32_i32$2 = ($5 + 16 | 0) + 24 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $4 = i64toi32_i32$1;
   $4$hi = i64toi32_i32$0;
   $1 = HEAP32[(($5 + 16 | 0) + 52 | 0) >> 2] | 0;
   $9 = HEAP32[(($5 + 16 | 0) + 48 | 0) >> 2] | 0;
   $10 = HEAP32[(($5 + 16 | 0) + 40 | 0) >> 2] | 0;
   $2 = HEAP32[(($5 + 16 | 0) + 44 | 0) >> 2] | 0;
   $11 = $5 + 32 | 0;
   i64toi32_i32$2 = $11;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $87 = i64toi32_i32$0;
   i64toi32_i32$0 = $6;
   HEAP32[i64toi32_i32$0 >> 2] = $87;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = ($5 + 16 | 0) + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $92 = i64toi32_i32$1;
   i64toi32_i32$1 = $5;
   HEAP32[$5 >> 2] = $92;
   HEAP32[($5 + 4 | 0) >> 2] = i64toi32_i32$0;
   label$3 : {
    $6 = HEAP32[($2 + 176 | 0) >> 2] | 0;
    if (!$6) {
     break label$3
    }
    $12 = ($5 + 16 | 0) + 8 | 0;
    label$4 : while (1) {
     HEAP32[($5 + 88 | 0) >> 2] = HEAPU16[($2 + 312 | 0) >> 1] | 0;
     HEAP32[($5 + 84 | 0) >> 2] = $6;
     HEAP32[($5 + 80 | 0) >> 2] = $10 + 1 | 0;
     $2 = $5 + 8 | 0;
     HEAP32[(($5 + 96 | 0) + 8 | 0) >> 2] = HEAP32[$2 >> 2] | 0;
     i64toi32_i32$2 = $5;
     i64toi32_i32$0 = HEAP32[$5 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($5 + 4 | 0) >> 2] | 0;
     $117 = i64toi32_i32$0;
     i64toi32_i32$0 = $5;
     HEAP32[($5 + 96 | 0) >> 2] = $117;
     HEAP32[($5 + 100 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $4$hi;
     i64toi32_i32$1 = $3$hi;
     i64toi32_i32$1 = $4$hi;
     i64toi32_i32$0 = $3$hi;
     alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert__hea09a6888ea80fc7($5 + 16 | 0 | 0, $5 + 80 | 0 | 0, $5 + 96 | 0 | 0, $4 | 0, i64toi32_i32$1 | 0, $3 | 0, i64toi32_i32$0 | 0, $9 | 0, $1 | 0);
     label$5 : {
      if ((HEAP32[($5 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$5
      }
      HEAP32[($0 + 56 | 0) >> 2] = $7;
      i64toi32_i32$2 = $5;
      i64toi32_i32$0 = HEAP32[($5 + 20 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($5 + 24 | 0) >> 2] | 0;
      $135 = i64toi32_i32$0;
      i64toi32_i32$0 = $0;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $135;
      HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[i64toi32_i32$0 >> 2] = 0;
      HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = HEAP32[(($5 + 16 | 0) + 12 | 0) >> 2] | 0;
      break label$1;
     }
     i64toi32_i32$2 = $12 + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $146 = i64toi32_i32$1;
     i64toi32_i32$1 = $2;
     HEAP32[i64toi32_i32$1 >> 2] = $146;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $12;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $149 = i64toi32_i32$0;
     i64toi32_i32$0 = $5;
     HEAP32[$5 >> 2] = $149;
     HEAP32[($5 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $8;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $3 = i64toi32_i32$1;
     $3$hi = i64toi32_i32$0;
     i64toi32_i32$2 = $5;
     i64toi32_i32$0 = HEAP32[($5 + 40 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($5 + 44 | 0) >> 2] | 0;
     $4 = i64toi32_i32$0;
     $4$hi = i64toi32_i32$1;
     $1 = HEAP32[($5 + 68 | 0) >> 2] | 0;
     $9 = HEAP32[($5 + 64 | 0) >> 2] | 0;
     $10 = HEAP32[($5 + 56 | 0) >> 2] | 0;
     $2 = HEAP32[($5 + 60 | 0) >> 2] | 0;
     $6 = HEAP32[($2 + 176 | 0) >> 2] | 0;
     if ($6) {
      continue label$4
     }
     break label$4;
    };
   }
   i64toi32_i32$2 = $5 + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $170 = i64toi32_i32$1;
   i64toi32_i32$1 = ($5 + 16 | 0) + 12 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $170;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[$0 >> 2] = 1;
   HEAP32[($0 + 56 | 0) >> 2] = $7;
   i64toi32_i32$0 = $3$hi;
   i64toi32_i32$1 = $0 + 32 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $3;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $4$hi;
   i64toi32_i32$1 = $0 + 24 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $4;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($0 + 52 | 0) >> 2] = $1;
   HEAP32[($0 + 48 | 0) >> 2] = $9;
   HEAP32[($0 + 44 | 0) >> 2] = $2;
   HEAP32[($0 + 40 | 0) >> 2] = $10;
   i64toi32_i32$2 = $5;
   i64toi32_i32$0 = HEAP32[$5 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($5 + 4 | 0) >> 2] | 0;
   $194 = i64toi32_i32$0;
   i64toi32_i32$0 = $5;
   HEAP32[($5 + 20 | 0) >> 2] = $194;
   HEAP32[($5 + 24 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $5;
   i64toi32_i32$1 = HEAP32[($5 + 16 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($5 + 20 | 0) >> 2] | 0;
   $197 = i64toi32_i32$1;
   i64toi32_i32$1 = $0;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $197;
   HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = ($5 + 16 | 0) + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $203 = i64toi32_i32$0;
   i64toi32_i32$0 = $0 + 12 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $203;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($0 + 20 | 0) >> 2] = HEAP32[$11 >> 2] | 0;
  }
  global$0 = $5 + 112 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__ScriptNOfK___deserialize_as_embedded_group__hcd662792aa1dcf35($0, $1, $2, $2$hi, $3, $3$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  var $4 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, $10 = 0, $5 = 0, $10$hi = 0, i64toi32_i32$4 = 0, $11 = 0, $11$hi = 0, $6 = 0, $7 = 0, $23 = 0, $8 = 0, $12 = 0, $12$hi = 0, $9 = 0;
  $4 = global$0 - 384 | 0;
  global$0 = $4;
  cbor_event__de__Deserializer_R___unsigned_integer__h1ed99c0b7fe7eea1($4 + 312 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[($4 + 320 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($4 + 324 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         i64toi32_i32$2 = $4;
         i64toi32_i32$1 = HEAP32[($4 + 312 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($4 + 316 | 0) >> 2] | 0;
         i64toi32_i32$2 = i64toi32_i32$1;
         i64toi32_i32$1 = 0;
         i64toi32_i32$3 = 1;
         if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
          break label$7
         }
         i64toi32_i32$2 = 0;
         $11 = 3;
         $11$hi = i64toi32_i32$2;
         i64toi32_i32$2 = $10$hi;
         i64toi32_i32$3 = $10;
         i64toi32_i32$0 = 0;
         i64toi32_i32$1 = 3;
         if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) | 0) {
          break label$5
         }
         $5 = 8;
         $6 = 1;
         $7 = 1;
         break label$6;
        }
        i64toi32_i32$3 = $10$hi;
        i64toi32_i32$1 = $10;
        i64toi32_i32$2 = 0;
        i64toi32_i32$0 = 32;
        i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
         i64toi32_i32$2 = 0;
         $23 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
        } else {
         i64toi32_i32$2 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
         $23 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
        }
        $8 = $23;
        i64toi32_i32$3 = $4 + 352 | 0;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $12 = i64toi32_i32$2;
        $12$hi = i64toi32_i32$1;
        i64toi32_i32$3 = $4 + 344 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $11 = i64toi32_i32$1;
        $11$hi = i64toi32_i32$2;
        $9 = HEAP32[($4 + 340 | 0) >> 2] | 0;
        $7 = HEAP32[($4 + 336 | 0) >> 2] | 0;
        i64toi32_i32$2 = $10$hi;
        $6 = $10;
        $5 = 2;
        i64toi32_i32$3 = $4 + 328 | 0;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $10 = i64toi32_i32$2;
        $10$hi = i64toi32_i32$1;
       }
       i64toi32_i32$1 = $12$hi;
       i64toi32_i32$2 = $4 + 352 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $12;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$1 = $11$hi;
       i64toi32_i32$2 = $4 + 344 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $11;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       HEAP32[($4 + 340 | 0) >> 2] = $9;
       HEAP32[($4 + 336 | 0) >> 2] = $7;
       i64toi32_i32$1 = $10$hi;
       i64toi32_i32$2 = $4 + 328 | 0;
       HEAP32[i64toi32_i32$2 >> 2] = $10;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       HEAP32[($4 + 324 | 0) >> 2] = $8;
       HEAP32[(($4 + 312 | 0) + 8 | 0) >> 2] = $6;
       HEAP32[($4 + 360 | 0) >> 2] = 0;
       HEAP8[($4 + 312 | 0) >> 0] = $5;
       cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($4 + 96 | 0 | 0, $4 + 312 | 0 | 0, 1050766 | 0, 7 | 0);
       $5 = HEAPU8[($4 + 96 | 0) >> 0] | 0;
       if (($5 | 0) != (19 | 0)) {
        break label$4
       }
      }
      $T_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hf422f9333a8bbafa($4 + 312 | 0 | 0, $1 | 0);
      if ((HEAP32[($4 + 312 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      $5 = HEAP32[($4 + 316 | 0) >> 2] | 0;
      cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__NativeScripts___deserialize__h5fb973a07bcdbe01($4 + 312 | 0 | 0, $1 | 0);
      if ((HEAP32[($4 + 312 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$2
      }
      $1 = HEAP32[($4 + 324 | 0) >> 2] | 0;
      HEAP32[(($4 + 8 | 0) + 8 | 0) >> 2] = $1;
      i64toi32_i32$3 = $4;
      i64toi32_i32$1 = HEAP32[($4 + 316 | 0) >> 2] | 0;
      i64toi32_i32$2 = HEAP32[($4 + 320 | 0) >> 2] | 0;
      $10 = i64toi32_i32$1;
      $10$hi = i64toi32_i32$2;
      i64toi32_i32$1 = $4;
      HEAP32[($4 + 8 | 0) >> 2] = $10;
      HEAP32[($4 + 12 | 0) >> 2] = i64toi32_i32$2;
      HEAP32[($0 + 4 | 0) >> 2] = $5;
      i64toi32_i32$1 = $0 + 8 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $10;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
      HEAP32[($0 + 16 | 0) >> 2] = $1;
      HEAP32[$0 >> 2] = 0;
      break label$1;
     }
     memcpy($4 + 240 | 0 | 0, $4 + 96 | 0 | 1 | 0 | 0, 63 | 0) | 0;
     HEAP8[($0 + 8 | 0) >> 0] = $5;
     memcpy($0 + 9 | 0 | 0, $4 + 240 | 0 | 0, 63 | 0) | 0;
     HEAP32[$0 >> 2] = 1;
     break label$1;
    }
    memcpy($4 + 240 | 0 | 0, ($4 + 312 | 0) + 8 | 0 | 0, 64 | 0) | 0;
    memcpy($4 + 312 | 0 | 0, $4 + 240 | 0 | 0, 64 | 0) | 0;
    $1 = ($4 + 96 | 0) + 8 | 0;
    cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 312 | 0 | 0, 1051808 | 0, 1 | 0);
    memcpy($0 + 8 | 0 | 0, $1 | 0, 64 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    break label$1;
   }
   memcpy($4 + 312 | 0 | 0, memcpy($4 + 168 | 0 | 4 | 0 | 0, memcpy($4 + 240 | 0 | 4 | 0 | 0, ($4 + 312 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   $1 = ($4 + 96 | 0) + 8 | 0;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 312 | 0 | 0, 1051677 | 0, 14 | 0);
   memcpy($0 + 8 | 0 | 0, memcpy($4 + 24 | 0 | 4 | 0 | 0, $1 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $4 + 384 | 0;
 }
 
 function cbor_event__de__Deserializer_R___u64__hb76211f6fef2ef8e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $2 = 0, $3 = 0, $4 = 0, $5 = 0, $5$hi = 0, $64 = 0, $65 = 0, $66 = 0, $67 = 0, $68 = 0, $69 = 0, $70 = 0, $71 = 0, $72 = 0, $73 = 0, $74 = 0, $75 = 0, $76 = 0, $77 = 0, $78 = 0, $6 = 0, $6$hi = 0, $7 = 0, $7$hi = 0, $8 = 0, $8$hi = 0, $9 = 0, $9$hi = 0, $10 = 0, $10$hi = 0, $11 = 0, $11$hi = 0, $116 = 0, $118 = 0, $118$hi = 0, $120$hi = 0, $121 = 0, $121$hi = 0, $123$hi = 0, $124 = 0, $124$hi = 0, $126$hi = 0, $127 = 0, $127$hi = 0, $129$hi = 0, $130 = 0, $130$hi = 0, $132$hi = 0, $133 = 0, $133$hi = 0, $135$hi = 0, $136 = 0, $136$hi = 0, $138 = 0, $138$hi = 0, $139 = 0, $142 = 0, $146 = 0, $149 = 0, $153 = 0, $156 = 0, $160 = 0, $163 = 0, $167 = 0, $170 = 0, $174 = 0, $177 = 0, $181 = 0, $184 = 0, $188 = 0, $191 = 0, $195 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 56 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           $3 = HEAP32[($2 + 60 | 0) >> 2] | 0;
           if ($3 >>> 0 < 2 >>> 0) {
            break label$9
           }
           $4 = HEAP32[($2 + 56 | 0) >> 2] | 0;
           if (!$4) {
            break label$9
           }
           i64toi32_i32$2 = $4;
           i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0;
           i64toi32_i32$1 = 0;
           $5 = i64toi32_i32$0;
           $5$hi = i64toi32_i32$1;
           std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 48 | 0 | 0, $1 | 0);
           $3 = HEAP32[($2 + 52 | 0) >> 2] | 0;
           if ($3 >>> 0 < 3 >>> 0) {
            break label$8
           }
           $4 = HEAP32[($2 + 48 | 0) >> 2] | 0;
           if (!$4) {
            break label$8
           }
           i64toi32_i32$2 = $4;
           i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0;
           i64toi32_i32$0 = 0;
           $6 = i64toi32_i32$1;
           $6$hi = i64toi32_i32$0;
           std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 40 | 0 | 0, $1 | 0);
           $3 = HEAP32[($2 + 44 | 0) >> 2] | 0;
           if ($3 >>> 0 < 4 >>> 0) {
            break label$7
           }
           $4 = HEAP32[($2 + 40 | 0) >> 2] | 0;
           if (!$4) {
            break label$7
           }
           i64toi32_i32$2 = $4;
           i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0;
           i64toi32_i32$1 = 0;
           $7 = i64toi32_i32$0;
           $7$hi = i64toi32_i32$1;
           std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 32 | 0 | 0, $1 | 0);
           $3 = HEAP32[($2 + 36 | 0) >> 2] | 0;
           if ($3 >>> 0 < 5 >>> 0) {
            break label$6
           }
           $4 = HEAP32[($2 + 32 | 0) >> 2] | 0;
           if (!$4) {
            break label$6
           }
           i64toi32_i32$2 = $4;
           i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0;
           i64toi32_i32$0 = 0;
           $8 = i64toi32_i32$1;
           $8$hi = i64toi32_i32$0;
           std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 24 | 0 | 0, $1 | 0);
           $3 = HEAP32[($2 + 28 | 0) >> 2] | 0;
           if ($3 >>> 0 < 6 >>> 0) {
            break label$5
           }
           $4 = HEAP32[($2 + 24 | 0) >> 2] | 0;
           if (!$4) {
            break label$5
           }
           i64toi32_i32$2 = $4;
           i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0;
           i64toi32_i32$1 = 0;
           $9 = i64toi32_i32$0;
           $9$hi = i64toi32_i32$1;
           std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 16 | 0 | 0, $1 | 0);
           $3 = HEAP32[($2 + 20 | 0) >> 2] | 0;
           if ($3 >>> 0 < 7 >>> 0) {
            break label$4
           }
           $4 = HEAP32[($2 + 16 | 0) >> 2] | 0;
           if (!$4) {
            break label$4
           }
           i64toi32_i32$2 = $4;
           i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0;
           i64toi32_i32$0 = 0;
           $10 = i64toi32_i32$1;
           $10$hi = i64toi32_i32$0;
           std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 8 | 0 | 0, $1 | 0);
           $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
           if ($3 >>> 0 < 8 >>> 0) {
            break label$3
           }
           $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
           if (!$4) {
            break label$3
           }
           i64toi32_i32$2 = $4;
           i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0;
           i64toi32_i32$1 = 0;
           $11 = i64toi32_i32$0;
           $11$hi = i64toi32_i32$1;
           std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 | 0, $1 | 0);
           label$10 : {
            $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
            if ($1 >>> 0 < 9 >>> 0) {
             break label$10
            }
            $3 = HEAP32[$2 >> 2] | 0;
            if (!$3) {
             break label$10
            }
            $116 = $0;
            i64toi32_i32$1 = $6$hi;
            i64toi32_i32$2 = $6;
            i64toi32_i32$0 = 0;
            i64toi32_i32$3 = 48;
            i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
            if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
             i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
             $64 = 0;
            } else {
             i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
             $64 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
            }
            $118 = $64;
            $118$hi = i64toi32_i32$0;
            i64toi32_i32$0 = $5$hi;
            i64toi32_i32$1 = $5;
            i64toi32_i32$2 = 0;
            i64toi32_i32$3 = 56;
            i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
            if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
             i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
             $65 = 0;
            } else {
             i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
             $65 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
            }
            $120$hi = i64toi32_i32$2;
            i64toi32_i32$2 = $118$hi;
            i64toi32_i32$0 = $118;
            i64toi32_i32$1 = $120$hi;
            i64toi32_i32$3 = $65;
            i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
            $121 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
            $121$hi = i64toi32_i32$1;
            i64toi32_i32$1 = $7$hi;
            i64toi32_i32$2 = $7;
            i64toi32_i32$0 = 0;
            i64toi32_i32$3 = 40;
            i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
            if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
             i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
             $66 = 0;
            } else {
             i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
             $66 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
            }
            $123$hi = i64toi32_i32$0;
            i64toi32_i32$0 = $121$hi;
            i64toi32_i32$1 = $121;
            i64toi32_i32$2 = $123$hi;
            i64toi32_i32$3 = $66;
            i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
            $124 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
            $124$hi = i64toi32_i32$2;
            i64toi32_i32$2 = $8$hi;
            i64toi32_i32$0 = $8;
            i64toi32_i32$1 = 0;
            i64toi32_i32$3 = 32;
            i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
            if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
             i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
             $67 = 0;
            } else {
             i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
             $67 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
            }
            $126$hi = i64toi32_i32$1;
            i64toi32_i32$1 = $124$hi;
            i64toi32_i32$2 = $124;
            i64toi32_i32$0 = $126$hi;
            i64toi32_i32$3 = $67;
            i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
            $127 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
            $127$hi = i64toi32_i32$0;
            i64toi32_i32$0 = $9$hi;
            i64toi32_i32$1 = $9;
            i64toi32_i32$2 = 0;
            i64toi32_i32$3 = 24;
            i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
            if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
             i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
             $68 = 0;
            } else {
             i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
             $68 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
            }
            $129$hi = i64toi32_i32$2;
            i64toi32_i32$2 = $127$hi;
            i64toi32_i32$0 = $127;
            i64toi32_i32$1 = $129$hi;
            i64toi32_i32$3 = $68;
            i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
            $130 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
            $130$hi = i64toi32_i32$1;
            i64toi32_i32$1 = $10$hi;
            i64toi32_i32$2 = $10;
            i64toi32_i32$0 = 0;
            i64toi32_i32$3 = 16;
            i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
            if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
             i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
             $69 = 0;
            } else {
             i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
             $69 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
            }
            $132$hi = i64toi32_i32$0;
            i64toi32_i32$0 = $130$hi;
            i64toi32_i32$1 = $130;
            i64toi32_i32$2 = $132$hi;
            i64toi32_i32$3 = $69;
            i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
            $133 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
            $133$hi = i64toi32_i32$2;
            i64toi32_i32$2 = $11$hi;
            i64toi32_i32$0 = $11;
            i64toi32_i32$1 = 0;
            i64toi32_i32$3 = 8;
            i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
            if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
             i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
             $70 = 0;
            } else {
             i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
             $70 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
            }
            $135$hi = i64toi32_i32$1;
            i64toi32_i32$1 = $133$hi;
            i64toi32_i32$2 = $133;
            i64toi32_i32$0 = $135$hi;
            i64toi32_i32$3 = $70;
            i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
            $136 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
            $136$hi = i64toi32_i32$0;
            i64toi32_i32$1 = $3;
            i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 8 | 0) >> 0] | 0;
            i64toi32_i32$2 = 0;
            $138 = i64toi32_i32$0;
            $138$hi = i64toi32_i32$2;
            i64toi32_i32$2 = $136$hi;
            i64toi32_i32$1 = $136;
            i64toi32_i32$0 = $138$hi;
            i64toi32_i32$3 = $138;
            i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
            $139 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
            i64toi32_i32$1 = $116;
            HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $139;
            HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
            i64toi32_i32$0 = 0;
            $5 = 0;
            $5$hi = i64toi32_i32$0;
            break label$1;
           }
           HEAP32[($0 + 16 | 0) >> 2] = 8;
           $142 = $0;
           i64toi32_i32$0 = 0;
           i64toi32_i32$2 = $1;
           i64toi32_i32$1 = 0;
           i64toi32_i32$3 = 32;
           i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
           if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
            i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
            $71 = 0;
           } else {
            i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
            $71 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
           }
           i64toi32_i32$0 = $71;
           i64toi32_i32$2 = 0;
           i64toi32_i32$3 = 8;
           i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
           $146 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
           i64toi32_i32$0 = $142;
           HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $146;
           HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
           break label$2;
          }
          HEAP32[($0 + 16 | 0) >> 2] = 1;
          $149 = $0;
          i64toi32_i32$2 = 0;
          i64toi32_i32$1 = $3;
          i64toi32_i32$0 = 0;
          i64toi32_i32$3 = 32;
          i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
          if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
           i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
           $72 = 0;
          } else {
           i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
           $72 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
          }
          i64toi32_i32$2 = $72;
          i64toi32_i32$1 = 0;
          i64toi32_i32$3 = 8;
          i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
          $153 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
          i64toi32_i32$2 = $149;
          HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $153;
          HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$1;
          break label$2;
         }
         HEAP32[($0 + 16 | 0) >> 2] = 2;
         $156 = $0;
         i64toi32_i32$1 = 0;
         i64toi32_i32$0 = $3;
         i64toi32_i32$2 = 0;
         i64toi32_i32$3 = 32;
         i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
          i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
          $73 = 0;
         } else {
          i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
          $73 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
         }
         i64toi32_i32$1 = $73;
         i64toi32_i32$0 = 0;
         i64toi32_i32$3 = 8;
         i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
         $160 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
         i64toi32_i32$1 = $156;
         HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $160;
         HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
         break label$2;
        }
        HEAP32[($0 + 16 | 0) >> 2] = 3;
        $163 = $0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$2 = $3;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 32;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
         $74 = 0;
        } else {
         i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
         $74 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        }
        i64toi32_i32$0 = $74;
        i64toi32_i32$2 = 0;
        i64toi32_i32$3 = 8;
        i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
        $167 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
        i64toi32_i32$0 = $163;
        HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $167;
        HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
        break label$2;
       }
       HEAP32[($0 + 16 | 0) >> 2] = 4;
       $170 = $0;
       i64toi32_i32$2 = 0;
       i64toi32_i32$1 = $3;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        $75 = 0;
       } else {
        i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
        $75 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       }
       i64toi32_i32$2 = $75;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 8;
       i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
       $174 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       i64toi32_i32$2 = $170;
       HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $174;
       HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$1;
       break label$2;
      }
      HEAP32[($0 + 16 | 0) >> 2] = 5;
      $177 = $0;
      i64toi32_i32$1 = 0;
      i64toi32_i32$0 = $3;
      i64toi32_i32$2 = 0;
      i64toi32_i32$3 = 32;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       $76 = 0;
      } else {
       i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
       $76 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
      }
      i64toi32_i32$1 = $76;
      i64toi32_i32$0 = 0;
      i64toi32_i32$3 = 8;
      i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
      $181 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
      i64toi32_i32$1 = $177;
      HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $181;
      HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
      break label$2;
     }
     HEAP32[($0 + 16 | 0) >> 2] = 6;
     $184 = $0;
     i64toi32_i32$0 = 0;
     i64toi32_i32$2 = $3;
     i64toi32_i32$1 = 0;
     i64toi32_i32$3 = 32;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
      $77 = 0;
     } else {
      i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
      $77 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
     }
     i64toi32_i32$0 = $77;
     i64toi32_i32$2 = 0;
     i64toi32_i32$3 = 8;
     i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
     $188 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
     i64toi32_i32$0 = $184;
     HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $188;
     HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
     break label$2;
    }
    HEAP32[($0 + 16 | 0) >> 2] = 7;
    $191 = $0;
    i64toi32_i32$2 = 0;
    i64toi32_i32$1 = $3;
    i64toi32_i32$0 = 0;
    i64toi32_i32$3 = 32;
    i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
     $78 = 0;
    } else {
     i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
     $78 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
    }
    i64toi32_i32$2 = $78;
    i64toi32_i32$1 = 0;
    i64toi32_i32$3 = 8;
    i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
    $195 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
    i64toi32_i32$2 = $191;
    HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $195;
    HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$1;
   }
   i64toi32_i32$1 = 0;
   $5 = 1;
   $5$hi = i64toi32_i32$1;
  }
  i64toi32_i32$1 = $5$hi;
  i64toi32_i32$2 = $0;
  HEAP32[i64toi32_i32$2 >> 2] = $5;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $2 + 64 | 0;
 }
 
 function $cbor_event__error__Error_20as_20core__fmt__Debug___fmt__h24703f8b05f4c892($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    switch (HEAPU8[$0 >> 0] | 0 | 0) {
    default:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1141692 | 0, 10 | 0);
     break label$1;
    case 1:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1141681 | 0, 11 | 0);
     break label$1;
    case 2:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1141670 | 0, 11 | 0);
     break label$1;
    case 3:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1141659 | 0, 11 | 0);
     break label$1;
    case 4:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1141649 | 0, 10 | 0);
     break label$1;
    case 5:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1141638 | 0, 11 | 0);
     break label$1;
    case 6:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1141627 | 0, 11 | 0);
     break label$1;
    case 7:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1141616 | 0, 11 | 0);
     break label$1;
    case 8:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1141590 | 0, 9 | 0);
     HEAP32[($2 + 12 | 0) >> 2] = $0 + 4 | 0;
     core__fmt__builders__DebugTuple__field__h5e7e3e19ad5aa557($2 | 0, $2 + 12 | 0 | 0, 1141600 | 0) | 0;
     HEAP32[($2 + 12 | 0) >> 2] = $0 + 8 | 0;
     core__fmt__builders__DebugTuple__field__h5e7e3e19ad5aa557($2 | 0, $2 + 12 | 0 | 0, 1141600 | 0) | 0;
     break label$1;
    case 9:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1141582 | 0, 8 | 0);
     HEAP32[($2 + 12 | 0) >> 2] = $0 + 1 | 0;
     core__fmt__builders__DebugTuple__field__h5e7e3e19ad5aa557($2 | 0, $2 + 12 | 0 | 0, 1141392 | 0) | 0;
     HEAP32[($2 + 12 | 0) >> 2] = $0 + 2 | 0;
     core__fmt__builders__DebugTuple__field__h5e7e3e19ad5aa557($2 | 0, $2 + 12 | 0 | 0, 1141392 | 0) | 0;
     break label$1;
    case 10:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1141568 | 0, 14 | 0);
     break label$1;
    case 11:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1141537 | 0, 14 | 0);
     HEAP32[($2 + 12 | 0) >> 2] = $0 + 1 | 0;
     core__fmt__builders__DebugTuple__field__h5e7e3e19ad5aa557($2 | 0, $2 + 12 | 0 | 0, 1141552 | 0) | 0;
     break label$1;
    case 12:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1141512 | 0, 25 | 0);
     HEAP32[($2 + 12 | 0) >> 2] = $0 + 1 | 0;
     core__fmt__builders__DebugTuple__field__h5e7e3e19ad5aa557($2 | 0, $2 + 12 | 0 | 0, 1141392 | 0) | 0;
     break label$1;
    case 13:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1141456 | 0, 8 | 0);
     HEAP32[($2 + 12 | 0) >> 2] = $0 + 16 | 0;
     core__fmt__builders__DebugTuple__field__h5e7e3e19ad5aa557($2 | 0, $2 + 12 | 0 | 0, 1141464 | 0) | 0;
     HEAP32[($2 + 12 | 0) >> 2] = $0 + 24 | 0;
     core__fmt__builders__DebugTuple__field__h5e7e3e19ad5aa557($2 | 0, $2 + 12 | 0 | 0, 1141480 | 0) | 0;
     HEAP32[($2 + 12 | 0) >> 2] = $0 + 4 | 0;
     core__fmt__builders__DebugTuple__field__h5e7e3e19ad5aa557($2 | 0, $2 + 12 | 0 | 0, 1141496 | 0) | 0;
     break label$1;
    case 14:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1141424 | 0, 16 | 0);
     HEAP32[($2 + 12 | 0) >> 2] = $0 + 4 | 0;
     core__fmt__builders__DebugTuple__field__h5e7e3e19ad5aa557($2 | 0, $2 + 12 | 0 | 0, 1141440 | 0) | 0;
     break label$1;
    case 15:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1141380 | 0, 11 | 0);
     HEAP32[($2 + 12 | 0) >> 2] = $0 + 1 | 0;
     core__fmt__builders__DebugTuple__field__h5e7e3e19ad5aa557($2 | 0, $2 + 12 | 0 | 0, 1141392 | 0) | 0;
     HEAP32[($2 + 12 | 0) >> 2] = $0 + 4 | 0;
     core__fmt__builders__DebugTuple__field__h5e7e3e19ad5aa557($2 | 0, $2 + 12 | 0 | 0, 1141408 | 0) | 0;
     break label$1;
    case 16:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1141356 | 0, 7 | 0);
     HEAP32[($2 + 12 | 0) >> 2] = $0 + 4 | 0;
     core__fmt__builders__DebugTuple__field__h5e7e3e19ad5aa557($2 | 0, $2 + 12 | 0 | 0, 1141364 | 0) | 0;
     break label$1;
    case 17:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1141344 | 0, 12 | 0);
     break label$1;
    case 18:
     break label$2;
    };
   }
   core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1141316 | 0, 11 | 0);
   HEAP32[($2 + 12 | 0) >> 2] = $0 + 4 | 0;
   core__fmt__builders__DebugTuple__field__h5e7e3e19ad5aa557($2 | 0, $2 + 12 | 0 | 0, 1141328 | 0) | 0;
  }
  $0 = core__fmt__builders__DebugTuple__finish__hc3c3f1efaa75a6e2($2 | 0) | 0;
  global$0 = $2 + 16 | 0;
  return $0 | 0;
 }
 
 function cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__add_required_native_input_scripts__h855e8fd3c83a9c4c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $2 = 0, $3 = 0, $6 = 0, $7 = 0, $8 = 0, $28 = 0, $29 = 0, $30 = 0, $31 = 0, $32 = 0, $33 = 0, $4 = 0, $5 = 0, $9 = 0, $54 = 0, $60 = 0, $63 = 0, $75 = 0, $80 = 0, $84 = 0, $10 = 0, $117 = 0, $122 = 0, $128 = 0, $133 = 0, $136 = 0, $142 = 0, $148 = 0, $154 = 0;
  $2 = global$0 - 384 | 0;
  global$0 = $2;
  label$1 : {
   $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   if (!$3) {
    break label$1
   }
   $4 = HEAP32[$1 >> 2] | 0;
   $5 = $3 << 5 | 0;
   $6 = ($2 + 216 | 0) + 8 | 0;
   $7 = $2 + 32 | 0 | 1 | 0;
   $8 = $2 + 32 | 0 | 4 | 0;
   $9 = $2 + 368 | 0 | 4 | 0;
   $1 = 0;
   label$2 : while (1) {
    $3 = $4 + $1 | 0;
    cardano_serialization_lib__NativeScript__hash__hb812a54d2c7bdca2($2 | 0, $3 | 0);
    label$3 : {
     if (!(hashbrown__map__HashMap_K_2cV_2cS_2cA___contains_key__h0a193e832d1442fa($0 | 0, $2 | 0) | 0)) {
      break label$3
     }
     HEAP32[(($2 + 184 | 0) + 24 | 0) >> 2] = HEAP32[($2 + 24 | 0) >> 2] | 0;
     i64toi32_i32$2 = $2 + 16 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $54 = i64toi32_i32$0;
     i64toi32_i32$0 = ($2 + 184 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $54;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $2 + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $60 = i64toi32_i32$1;
     i64toi32_i32$1 = ($2 + 184 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $60;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
     $63 = i64toi32_i32$0;
     i64toi32_i32$0 = $2;
     HEAP32[($2 + 184 | 0) >> 2] = $63;
     HEAP32[($2 + 188 | 0) >> 2] = i64toi32_i32$1;
     label$4 : {
      label$5 : {
       switch (HEAPU8[$3 >> 0] | 0 | 0) {
       default:
        $28 = $3 + 25 | 0;
        $29 = $7 + 24 | 0;
        $30 = HEAPU8[$28 >> 0] | 0 | ((HEAPU8[($28 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($28 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($28 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        HEAP8[$29 >> 0] = $30;
        HEAP8[($29 + 1 | 0) >> 0] = $30 >>> 8 | 0;
        HEAP8[($29 + 2 | 0) >> 0] = $30 >>> 16 | 0;
        HEAP8[($29 + 3 | 0) >> 0] = $30 >>> 24 | 0;
        i64toi32_i32$2 = $3 + 17 | 0;
        i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $75 = i64toi32_i32$1;
        i64toi32_i32$1 = $7 + 16 | 0;
        $31 = $75;
        HEAP8[i64toi32_i32$1 >> 0] = $31;
        HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $31 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $31 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $31 >>> 24 | 0;
        HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
        HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
        i64toi32_i32$2 = $3 + 9 | 0;
        i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $80 = i64toi32_i32$0;
        i64toi32_i32$0 = $7 + 8 | 0;
        $32 = $80;
        HEAP8[i64toi32_i32$0 >> 0] = $32;
        HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $32 >>> 8 | 0;
        HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $32 >>> 16 | 0;
        HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $32 >>> 24 | 0;
        HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
        HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
        HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
        HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
        i64toi32_i32$2 = $3 + 1 | 0;
        i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $84 = i64toi32_i32$1;
        i64toi32_i32$1 = $7;
        $33 = $84;
        HEAP8[i64toi32_i32$1 >> 0] = $33;
        HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $33 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $33 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $33 >>> 24 | 0;
        HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
        HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
        HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
        HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
        HEAP8[($2 + 32 | 0) >> 0] = 0;
        break label$4;
       case 1:
        alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($8 | 0, HEAP32[($3 + 4 | 0) >> 2] | 0 | 0, HEAP32[($3 + 12 | 0) >> 2] | 0 | 0);
        HEAP8[($2 + 32 | 0) >> 0] = 1;
        break label$4;
       case 2:
        alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($8 | 0, HEAP32[($3 + 4 | 0) >> 2] | 0 | 0, HEAP32[($3 + 12 | 0) >> 2] | 0 | 0);
        HEAP8[($2 + 32 | 0) >> 0] = 2;
        break label$4;
       case 3:
        $10 = HEAP32[($3 + 4 | 0) >> 2] | 0;
        alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($9 | 0, HEAP32[($3 + 8 | 0) >> 2] | 0 | 0, HEAP32[($3 + 16 | 0) >> 2] | 0 | 0);
        i64toi32_i32$2 = ($2 + 368 | 0) + 8 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $117 = i64toi32_i32$0;
        i64toi32_i32$0 = $8 + 8 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $117;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        HEAP32[($2 + 368 | 0) >> 2] = $10;
        i64toi32_i32$2 = $2;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 368 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 372 | 0) >> 2] | 0;
        $122 = i64toi32_i32$1;
        i64toi32_i32$1 = $8;
        HEAP32[i64toi32_i32$1 >> 2] = $122;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        HEAP8[(i64toi32_i32$2 + 32 | 0) >> 0] = 3;
        break label$4;
       case 4:
        HEAP8[($2 + 32 | 0) >> 0] = 4;
        i64toi32_i32$2 = $3 + 8 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $128 = i64toi32_i32$0;
        i64toi32_i32$0 = $2;
        HEAP32[(i64toi32_i32$0 + 40 | 0) >> 2] = $128;
        HEAP32[(i64toi32_i32$0 + 44 | 0) >> 2] = i64toi32_i32$1;
        break label$4;
       case 5:
        break label$5;
       };
      }
      HEAP8[($2 + 32 | 0) >> 0] = 5;
      i64toi32_i32$2 = $3 + 8 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $133 = i64toi32_i32$1;
      i64toi32_i32$1 = $2;
      HEAP32[(i64toi32_i32$1 + 40 | 0) >> 2] = $133;
      HEAP32[(i64toi32_i32$1 + 44 | 0) >> 2] = i64toi32_i32$0;
     }
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
     $136 = i64toi32_i32$0;
     i64toi32_i32$0 = $6;
     HEAP32[i64toi32_i32$0 >> 2] = $136;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = (i64toi32_i32$2 + 32 | 0) + 24 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $142 = i64toi32_i32$1;
     i64toi32_i32$1 = $6 + 24 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $142;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = ($2 + 32 | 0) + 16 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $148 = i64toi32_i32$0;
     i64toi32_i32$0 = $6 + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $148;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = ($2 + 32 | 0) + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $154 = i64toi32_i32$1;
     i64toi32_i32$1 = $6 + 8 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $154;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$1 = $2;
     i64toi32_i32$0 = 0;
     HEAP32[(i64toi32_i32$1 + 216 | 0) >> 2] = 0;
     HEAP32[(i64toi32_i32$1 + 220 | 0) >> 2] = i64toi32_i32$0;
     linked_hash_map__LinkedHashMap_K_2cV_2cS___insert__h0e2ff8a07783b7ab(i64toi32_i32$1 + 32 | 0 | 0, $0 | 0, i64toi32_i32$1 + 184 | 0 | 0, i64toi32_i32$1 + 216 | 0 | 0);
     core__ptr__drop_in_place_core__option__Option_core__option__Option_cardano_serialization_lib__tx_builder__tx_inputs_builder__ScriptWitnessType_____hc1cbaf0cb4e97823(i64toi32_i32$1 + 32 | 0 | 0);
    }
    $1 = $1 + 32 | 0;
    if (($5 | 0) != ($1 | 0)) {
     continue label$2
    }
    break label$2;
   };
  }
  $3 = 0;
  $1 = 0;
  label$11 : {
   $6 = HEAP32[($0 + 32 | 0) >> 2] | 0;
   if (!$6) {
    break label$11
   }
   $1 = HEAP32[($6 + 156 | 0) >> 2] | 0;
  }
  label$12 : {
   if (($1 | 0) == ($6 | 0)) {
    break label$12
   }
   $3 = 0;
   label$13 : while (1) {
    i64toi32_i32$2 = $1;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    $3 = $3 + ((i64toi32_i32$2 | 0) == (2 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) | 0;
    $1 = HEAP32[($1 + 156 | 0) >> 2] | 0;
    if (($1 | 0) != ($6 | 0)) {
     continue label$13
    }
    break label$13;
   };
  }
  global$0 = $2 + 384 | 0;
  return $3 | 0;
 }
 
 function $cardano_serialization_lib__legacy_address__address__Attributes_20as_20cbor_event__se__Serialize___serialize__haf99c3c1d66b9efa($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$4 = 0, i64toi32_i32$0 = 0, $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $17 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, i64toi32_i32$3 = 0, $5 = 0, $16$hi = 0, $19$hi = 0, $22 = 0, $6 = 0, $6$hi = 0, $72 = 0, $99 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $3 = global$0 - 256 | 0;
  global$0 = $3;
  $4 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$4 = $4;
  i64toi32_i32$0 = 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = i64toi32_i32$4 ? 2 : 1;
  i64toi32_i32$2 = i64toi32_i32$4 ? i64toi32_i32$0 : i64toi32_i32$1;
  $16$hi = i64toi32_i32$2;
  i64toi32_i32$2 = 0;
  $19$hi = i64toi32_i32$2;
  $5 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  i64toi32_i32$1 = ($5 | 0) == (1 | 0);
  i64toi32_i32$2 = $16$hi;
  $22 = i64toi32_i32$3;
  i64toi32_i32$3 = $19$hi;
  i64toi32_i32$0 = i64toi32_i32$1 ? $22 : (i64toi32_i32$4 | 0) != (0 | 0);
  i64toi32_i32$4 = i64toi32_i32$1 ? i64toi32_i32$2 : i64toi32_i32$3;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 + 208 | 0 | 0, $2 | 0, 5 | 0, i64toi32_i32$0 | 0, i64toi32_i32$4 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[($3 + 208 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     $2 = HEAP32[($3 + 212 | 0) >> 2] | 0;
     label$4 : {
      if (!$4) {
       break label$4
      }
      HEAP32[($3 + 8 | 0) >> 2] = $1;
      (wasm2js_i32$0 = $3, wasm2js_i32$1 = cbor_event__types__Type__to_byte__h30363627277739c1(0 | 0, 1 | 0) | 0), HEAP8[(wasm2js_i32$0 + 169 | 0) >> 0] = wasm2js_i32$1;
      alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($2 | 0, $3 + 169 | 0 | 0, 1 | 0);
      cbor_event__se__Serializer_W___write_bytes__h94a35e08d7a7d3b8($3 + 208 | 0 | 0, $2 | 0, $3 + 8 | 0 | 0);
      label$5 : {
       if ((HEAP32[($3 + 208 | 0) >> 2] | 0 | 0) != (1 | 0)) {
        break label$5
       }
       memcpy($0 + 8 | 0 | 0, ($3 + 208 | 0) + 8 | 0 | 0, 40 | 0) | 0;
       HEAP32[$0 >> 2] = 1;
       break label$1;
      }
      $2 = HEAP32[($3 + 212 | 0) >> 2] | 0;
      $5 = HEAP32[($1 + 12 | 0) >> 2] | 0;
     }
     label$6 : {
      label$7 : {
       if (!$5) {
        break label$7
       }
       i64toi32_i32$1 = $1 + 16 | 0;
       i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$0 = 0;
       $6 = i64toi32_i32$4;
       $6$hi = i64toi32_i32$0;
       (wasm2js_i32$0 = $3, wasm2js_i32$1 = cbor_event__types__Type__to_byte__h30363627277739c1(0 | 0, 2 | 0) | 0), HEAP8[(wasm2js_i32$0 + 208 | 0) >> 0] = wasm2js_i32$1;
       alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($2 | 0, $3 + 208 | 0 | 0, 1 | 0);
       alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($3 | 0, 512 | 0, 0 | 0);
       HEAP32[($3 + 160 | 0) >> 2] = 0;
       i64toi32_i32$1 = $3;
       i64toi32_i32$0 = HEAP32[$3 >> 2] | 0;
       i64toi32_i32$4 = HEAP32[($3 + 4 | 0) >> 2] | 0;
       $72 = i64toi32_i32$0;
       i64toi32_i32$0 = $3;
       HEAP32[($3 + 152 | 0) >> 2] = $72;
       HEAP32[($3 + 156 | 0) >> 2] = i64toi32_i32$4;
       i64toi32_i32$4 = $6$hi;
       cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 + 208 | 0 | 0, $3 + 152 | 0 | 0, 0 | 0, $6 | 0, i64toi32_i32$4 | 0);
       $1 = 19;
       label$8 : {
        if ((HEAP32[($3 + 208 | 0) >> 2] | 0 | 0) != (1 | 0)) {
         break label$8
        }
        $1 = HEAPU8[($3 + 216 | 0) >> 0] | 0;
        memcpy($3 + 169 | 0 | 0, $3 + 217 | 0 | 0, 39 | 0) | 0;
       }
       $4 = ($3 + 208 | 0) + 8 | 0;
       HEAP32[$4 >> 2] = HEAP32[(($3 + 152 | 0) + 8 | 0) >> 2] | 0;
       i64toi32_i32$1 = $3;
       i64toi32_i32$4 = HEAP32[($3 + 152 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[($3 + 156 | 0) >> 2] | 0;
       $99 = i64toi32_i32$4;
       i64toi32_i32$4 = $3;
       HEAP32[($3 + 208 | 0) >> 2] = $99;
       HEAP32[($3 + 212 | 0) >> 2] = i64toi32_i32$0;
       if (($1 & 255 | 0 | 0) != (19 | 0)) {
        break label$2
       }
       HEAP32[($3 + 112 | 0) >> 2] = HEAPU8[($3 + 213 | 0) >> 0] | 0 | ((HEAPU8[($3 + 214 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 215 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 216 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $17 = HEAPU8[$4 >> 0] | 0 | ((HEAPU8[($4 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       HEAP8[($3 + 115 | 0) >> 0] = $17;
       HEAP8[($3 + 116 | 0) >> 0] = $17 >>> 8 | 0;
       HEAP8[($3 + 117 | 0) >> 0] = $17 >>> 16 | 0;
       HEAP8[($3 + 118 | 0) >> 0] = $17 >>> 24 | 0;
       $18 = HEAPU8[($3 + 115 | 0) >> 0] | 0 | ((HEAPU8[($3 + 116 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 117 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 118 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       HEAP8[($3 + 75 | 0) >> 0] = $18;
       HEAP8[($3 + 76 | 0) >> 0] = $18 >>> 8 | 0;
       HEAP8[($3 + 77 | 0) >> 0] = $18 >>> 16 | 0;
       HEAP8[($3 + 78 | 0) >> 0] = $18 >>> 24 | 0;
       HEAP32[($3 + 72 | 0) >> 2] = HEAP32[($3 + 112 | 0) >> 2] | 0;
       $19 = ($3 + 56 | 0) + 8 | 0;
       $20 = HEAPU8[($3 + 75 | 0) >> 0] | 0 | ((HEAPU8[($3 + 76 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 77 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 78 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       HEAP8[$19 >> 0] = $20;
       HEAP8[($19 + 1 | 0) >> 0] = $20 >>> 8 | 0;
       HEAP8[($19 + 2 | 0) >> 0] = $20 >>> 16 | 0;
       HEAP8[($19 + 3 | 0) >> 0] = $20 >>> 24 | 0;
       $21 = HEAP32[($3 + 72 | 0) >> 2] | 0;
       HEAP8[($3 + 61 | 0) >> 0] = $21;
       HEAP8[($3 + 62 | 0) >> 0] = $21 >>> 8 | 0;
       HEAP8[($3 + 63 | 0) >> 0] = $21 >>> 16 | 0;
       HEAP8[($3 + 64 | 0) >> 0] = $21 >>> 24 | 0;
       $1 = HEAP32[($3 + 208 | 0) >> 2] | 0;
       HEAP8[($3 + 60 | 0) >> 0] = HEAPU8[($3 + 212 | 0) >> 0] | 0;
       HEAP32[($3 + 56 | 0) >> 2] = $1;
       cbor_event__se__Serializer_W___write_bytes__h935c22261c9a8184($3 + 8 | 0 | 0, $2 | 0, $3 + 56 | 0 | 0);
       if ((HEAP32[($3 + 8 | 0) >> 2] | 0 | 0) == (1 | 0)) {
        break label$6
       }
       $2 = HEAP32[($3 + 12 | 0) >> 2] | 0;
      }
      HEAP32[$0 >> 2] = 0;
      HEAP32[($0 + 4 | 0) >> 2] = $2;
      break label$1;
     }
     memcpy($0 + 8 | 0 | 0, ($3 + 8 | 0) + 8 | 0 | 0, 40 | 0) | 0;
     HEAP32[$0 >> 2] = 1;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, ($3 + 208 | 0) + 8 | 0 | 0, 40 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    break label$1;
   }
   memcpy($3 + 112 | 0 | 0, $3 + 169 | 0 | 0, 39 | 0) | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 208 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 208 | 0 | 0);
   memcpy($3 + 72 | 0 | 0, $3 + 112 | 0 | 0, 39 | 0) | 0;
   HEAP8[($0 + 8 | 0) >> 0] = $1;
   memcpy($0 + 9 | 0 | 0, $3 + 72 | 0 | 0, 39 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $3 + 256 | 0;
 }
 
 function cardano_serialization_lib__PoolParams__new__h8e143b44b120ba76($0, $1, $2, $3, $4, $5, $6, $7, $8, $9) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  $5 = $5 | 0;
  $6 = $6 | 0;
  $7 = $7 | 0;
  $8 = $8 | 0;
  $9 = $9 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $10 = 0, $47 = 0, $48 = 0, $49 = 0, $50 = 0, $51 = 0, $52 = 0, $53 = 0, $54 = 0, $55 = 0, $56 = 0, $57 = 0, $58 = 0, $59 = 0, $60 = 0, $62 = 0, $63 = 0, $11 = 0, $12 = 0, $13 = 0, $34 = 0, $41 = 0, $44 = 0, $14 = 0, $14$hi = 0, $15 = 0, $15$hi = 0, $16 = 0, $16$hi = 0, $17 = 0, $17$hi = 0, $61 = 0, $68 = 0, $79 = 0, $98 = 0, $104 = 0, $110 = 0, $114 = 0, $125 = 0, $136 = 0, $150 = 0, $154 = 0, $159 = 0, $164 = 0, $169 = 0, $179 = 0, $183 = 0, $187 = 0, $196 = 0, $205 = 0;
  $10 = global$0 - 224 | 0;
  global$0 = $10;
  $11 = ($10 + 8 | 0) + 24 | 0;
  $47 = $1 + 24 | 0;
  HEAP32[$11 >> 2] = HEAPU8[$47 >> 0] | 0 | ((HEAPU8[($47 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($47 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($47 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $12 = ($10 + 8 | 0) + 16 | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $34 = i64toi32_i32$0;
  i64toi32_i32$0 = $12;
  HEAP32[i64toi32_i32$0 >> 2] = $34;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $13 = ($10 + 8 | 0) + 8 | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $41 = i64toi32_i32$1;
  i64toi32_i32$1 = $13;
  HEAP32[i64toi32_i32$1 >> 2] = $41;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $44 = i64toi32_i32$0;
  i64toi32_i32$0 = $10;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $44;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$1;
  $14$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $15 = i64toi32_i32$0;
  $15$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $5;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $16 = i64toi32_i32$1;
  $16$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $17 = i64toi32_i32$0;
  $17$hi = i64toi32_i32$1;
  $1 = HEAPU8[$6 >> 0] | 0;
  $5 = ($10 + 40 | 0) + 8 | 0;
  i64toi32_i32$2 = $6 + 10 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $61 = i64toi32_i32$1;
  i64toi32_i32$1 = $5;
  HEAP32[i64toi32_i32$1 >> 2] = $61;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = ($10 + 40 | 0) + 16 | 0;
  i64toi32_i32$2 = $6 + 18 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $68 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[i64toi32_i32$0 >> 2] = $68;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $3 = ($10 + 40 | 0) + 24 | 0;
  $48 = $6 + 26 | 0;
  HEAP32[$3 >> 2] = HEAPU8[$48 >> 0] | 0 | ((HEAPU8[($48 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($48 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($48 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $6 + 2 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $79 = i64toi32_i32$1;
  i64toi32_i32$1 = $10;
  HEAP32[(i64toi32_i32$1 + 40 | 0) >> 2] = $79;
  HEAP32[(i64toi32_i32$1 + 44 | 0) >> 2] = i64toi32_i32$0;
  $6 = HEAPU8[($6 + 1 | 0) >> 0] | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h25db889dc58a550d(i64toi32_i32$1 + 72 | 0 | 0, $7 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h3d33b90cd2011dc4(i64toi32_i32$1 + 88 | 0 | 0, $8 | 0);
  label$1 : {
   label$2 : {
    if (HEAP32[$9 >> 2] | 0) {
     break label$2
    }
    $8 = 0;
    break label$1;
   }
   $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($10 + 144 | 0 | 0, $9 | 0);
   i64toi32_i32$2 = $9 + 36 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $98 = i64toi32_i32$0;
   i64toi32_i32$0 = ($10 + 144 | 0) + 36 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $98;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $9 + 28 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $104 = i64toi32_i32$1;
   i64toi32_i32$1 = ($10 + 144 | 0) + 28 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $104;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $9 + 20 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $110 = i64toi32_i32$0;
   i64toi32_i32$0 = ($10 + 144 | 0) + 20 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $110;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $9 + 12 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $114 = i64toi32_i32$1;
   i64toi32_i32$1 = $10;
   HEAP32[(i64toi32_i32$1 + 156 | 0) >> 2] = $114;
   HEAP32[(i64toi32_i32$1 + 160 | 0) >> 2] = i64toi32_i32$0;
   $8 = HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] | 0;
   memcpy(i64toi32_i32$1 + 104 | 0 | 0, i64toi32_i32$1 + 144 | 0 | 4 | 0 | 0, 40 | 0) | 0;
  }
  i64toi32_i32$2 = $10;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $125 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  $49 = $125;
  HEAP8[(i64toi32_i32$0 + 100 | 0) >> 0] = $49;
  HEAP8[(i64toi32_i32$0 + 101 | 0) >> 0] = $49 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 102 | 0) >> 0] = $49 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 103 | 0) >> 0] = $49 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 104 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 105 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 106 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 107 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 160 | 0) >> 0] = $1;
  i64toi32_i32$1 = $16$hi;
  HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $16;
  HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $15$hi;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $15;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $14$hi;
  HEAP32[i64toi32_i32$0 >> 2] = $14;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $136 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  $50 = $136;
  HEAP8[(i64toi32_i32$1 + 128 | 0) >> 0] = $50;
  HEAP8[(i64toi32_i32$1 + 129 | 0) >> 0] = $50 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 130 | 0) >> 0] = $50 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 131 | 0) >> 0] = $50 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 132 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 133 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 134 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 135 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 161 | 0) >> 0] = $6;
  i64toi32_i32$0 = $17$hi;
  i64toi32_i32$1 = i64toi32_i32$1 + 24 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $17;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $51 = $0 + 124 | 0;
  $52 = HEAP32[$11 >> 2] | 0;
  HEAP8[$51 >> 0] = $52;
  HEAP8[($51 + 1 | 0) >> 0] = $52 >>> 8 | 0;
  HEAP8[($51 + 2 | 0) >> 0] = $52 >>> 16 | 0;
  HEAP8[($51 + 3 | 0) >> 0] = $52 >>> 24 | 0;
  i64toi32_i32$2 = $12;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $150 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 116 | 0;
  $53 = $150;
  HEAP8[i64toi32_i32$0 >> 0] = $53;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $53 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $53 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $53 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $13;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $154 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 108 | 0;
  $54 = $154;
  HEAP8[i64toi32_i32$1 >> 0] = $54;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $54 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $54 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $54 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 8 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $159 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 136 | 0;
  $55 = $159;
  HEAP8[i64toi32_i32$0 >> 0] = $55;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $55 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $55 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $55 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 16 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $164 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 144 | 0;
  $56 = $164;
  HEAP8[i64toi32_i32$1 >> 0] = $56;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $56 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $56 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $56 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 24 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $169 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 152 | 0;
  $57 = $169;
  HEAP8[i64toi32_i32$0 >> 0] = $57;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $57 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $57 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $57 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  HEAP32[($0 + 56 | 0) >> 2] = $8;
  $58 = $0 + 186 | 0;
  $59 = HEAP32[$3 >> 2] | 0;
  HEAP8[$58 >> 0] = $59;
  HEAP8[($58 + 1 | 0) >> 0] = $59 >>> 8 | 0;
  HEAP8[($58 + 2 | 0) >> 0] = $59 >>> 16 | 0;
  HEAP8[($58 + 3 | 0) >> 0] = $59 >>> 24 | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $179 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 178 | 0;
  $60 = $179;
  HEAP8[i64toi32_i32$1 >> 0] = $60;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $60 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $60 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $60 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $183 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 170 | 0;
  $62 = $183;
  HEAP8[i64toi32_i32$0 >> 0] = $62;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $62 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $62 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $62 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $10;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] | 0;
  $187 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 162 | 0;
  $63 = $187;
  HEAP8[i64toi32_i32$1 >> 0] = $63;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $63 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $63 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $63 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP32[($0 + 40 | 0) >> 2] = HEAP32[((i64toi32_i32$2 + 72 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 72 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 76 | 0) >> 2] | 0;
  $196 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] = $196;
  HEAP32[(i64toi32_i32$0 + 36 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 52 | 0) >> 2] = HEAP32[((i64toi32_i32$2 + 88 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 88 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 92 | 0) >> 2] | 0;
  $205 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[(i64toi32_i32$1 + 44 | 0) >> 2] = $205;
  HEAP32[(i64toi32_i32$1 + 48 | 0) >> 2] = i64toi32_i32$0;
  memcpy(i64toi32_i32$1 + 60 | 0 | 0, i64toi32_i32$2 + 104 | 0 | 0, 40 | 0) | 0;
  core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__PoolMetadata____hb1232757542ed318($9 | 0);
  global$0 = i64toi32_i32$2 + 224 | 0;
 }
 
 function $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__clone_subtree__hf11375d59f632633($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $6 = 0, $5 = 0, $7 = 0, i64toi32_i32$2 = 0, $4 = 0, $8 = 0, $10 = 0, $9 = 0, $12$hi = 0, $13$hi = 0, $44 = 0, $58 = 0, $61 = 0, $12 = 0, $13 = 0, $11 = 0, $148 = 0, $181 = 0;
  $3 = global$0 - 80 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     if ($1) {
      break label$3
     }
     $1 = alloc__boxed__Box_T_2cA___new_uninit_in__h637e1ec719c3dde5() | 0;
     HEAP16[($1 + 314 | 0) >> 1] = 0;
     HEAP32[($1 + 176 | 0) >> 2] = 0;
     $4 = 0;
     label$4 : {
      if (!(HEAPU16[($2 + 314 | 0) >> 1] | 0)) {
       break label$4
      }
      $5 = $2 + 180 | 0;
      $4 = 0;
      $6 = $2;
      label$5 : while (1) {
       $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($3 + 64 | 0 | 0, $5 | 0);
       $7 = HEAPU16[($1 + 314 | 0) >> 1] | 0;
       if ($7 >>> 0 >= 11 >>> 0) {
        break label$1
       }
       HEAP16[($1 + 314 | 0) >> 1] = $7 + 1 | 0;
       $8 = $1 + Math_imul($7, 12) | 0;
       i64toi32_i32$2 = $3;
       i64toi32_i32$0 = HEAP32[($3 + 64 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($3 + 68 | 0) >> 2] | 0;
       $44 = i64toi32_i32$0;
       i64toi32_i32$0 = $8 + 180 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $44;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       HEAP32[($8 + 188 | 0) >> 2] = HEAP32[(($3 + 64 | 0) + 8 | 0) >> 2] | 0;
       $7 = $1 + ($7 << 4 | 0) | 0;
       i64toi32_i32$2 = $6 + 8 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $58 = i64toi32_i32$1;
       i64toi32_i32$1 = $7;
       HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $58;
       HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = $6;
       i64toi32_i32$0 = HEAP32[$6 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($6 + 4 | 0) >> 2] | 0;
       $61 = i64toi32_i32$0;
       i64toi32_i32$0 = $7;
       HEAP32[i64toi32_i32$0 >> 2] = $61;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       $5 = $5 + 12 | 0;
       $6 = $6 + 16 | 0;
       $4 = $4 + 1 | 0;
       if ($4 >>> 0 < (HEAPU16[($2 + 314 | 0) >> 1] | 0) >>> 0) {
        continue label$5
       }
       break label$5;
      };
     }
     HEAP32[($0 + 8 | 0) >> 2] = $4;
     HEAP32[($0 + 4 | 0) >> 2] = $1;
     HEAP32[$0 >> 2] = 0;
     break label$2;
    }
    $9 = $1 + -1 | 0;
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__clone_subtree__hf11375d59f632633($3 + 8 | 0 | 0, $9 | 0, HEAP32[($2 + 320 | 0) >> 2] | 0 | 0);
    label$6 : {
     label$7 : {
      $6 = HEAP32[($3 + 12 | 0) >> 2] | 0;
      if (!$6) {
       break label$7
      }
      $5 = (HEAP32[($3 + 8 | 0) >> 2] | 0) + 1 | 0;
      break label$6;
     }
     $6 = alloc__boxed__Box_T_2cA___new_uninit_in__h637e1ec719c3dde5() | 0;
     HEAP16[($6 + 314 | 0) >> 1] = 0;
     HEAP32[($6 + 176 | 0) >> 2] = 0;
     $5 = 1;
    }
    $1 = alloc__boxed__Box_T_2cA___new_uninit_in__h0285c5e433c8dfa2() | 0;
    HEAP32[($1 + 320 | 0) >> 2] = $6;
    $7 = 0;
    HEAP16[($1 + 314 | 0) >> 1] = 0;
    HEAP32[($1 + 176 | 0) >> 2] = 0;
    HEAP16[($6 + 312 | 0) >> 1] = 0;
    HEAP32[($6 + 176 | 0) >> 2] = $1;
    HEAP32[($3 + 12 | 0) >> 2] = $1;
    HEAP32[($3 + 8 | 0) >> 2] = $5;
    HEAP32[($3 + 28 | 0) >> 2] = $1;
    HEAP32[($3 + 24 | 0) >> 2] = $5;
    label$8 : {
     if (!(HEAPU16[($2 + 314 | 0) >> 1] | 0)) {
      break label$8
     }
     $5 = $2 + 180 | 0;
     $4 = $2 + 324 | 0;
     $10 = HEAP32[($3 + 16 | 0) >> 2] | 0;
     $1 = $2;
     label$9 : while (1) {
      $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($3 + 32 | 0 | 0, $5 | 0);
      i64toi32_i32$2 = $1 + 8 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $12 = i64toi32_i32$1;
      $12$hi = i64toi32_i32$0;
      i64toi32_i32$2 = $1;
      i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      $13 = i64toi32_i32$0;
      $13$hi = i64toi32_i32$1;
      $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__clone_subtree__hf11375d59f632633($3 + 48 | 0 | 0, $9 | 0, HEAP32[$4 >> 2] | 0 | 0);
      $11 = HEAP32[($3 + 56 | 0) >> 2] | 0;
      $6 = HEAP32[($3 + 52 | 0) >> 2] | 0;
      $8 = HEAP32[($3 + 48 | 0) >> 2] | 0;
      HEAP32[(($3 + 64 | 0) + 8 | 0) >> 2] = HEAP32[(($3 + 32 | 0) + 8 | 0) >> 2] | 0;
      i64toi32_i32$2 = $3;
      i64toi32_i32$1 = HEAP32[($3 + 32 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($3 + 36 | 0) >> 2] | 0;
      $148 = i64toi32_i32$1;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 64 | 0) >> 2] = $148;
      HEAP32[($3 + 68 | 0) >> 2] = i64toi32_i32$0;
      $7 = $7 + 1 | 0;
      label$10 : {
       if ($6) {
        break label$10
       }
       $8 = 0;
       $6 = alloc__boxed__Box_T_2cA___new_uninit_in__h637e1ec719c3dde5() | 0;
       HEAP16[($6 + 314 | 0) >> 1] = 0;
       HEAP32[($6 + 176 | 0) >> 2] = 0;
      }
      i64toi32_i32$0 = $13$hi;
      i64toi32_i32$0 = $12$hi;
      i64toi32_i32$0 = $13$hi;
      i64toi32_i32$1 = $12$hi;
      alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal___push__h5a800884cf869f03($3 + 24 | 0 | 0, $3 + 64 | 0 | 0, $13 | 0, i64toi32_i32$0 | 0, $12 | 0, i64toi32_i32$1 | 0, $8 | 0, $6 | 0);
      $5 = $5 + 12 | 0;
      $1 = $1 + 16 | 0;
      $4 = $4 + 4 | 0;
      $10 = ($11 + $10 | 0) + 1 | 0;
      if ($7 >>> 0 < (HEAPU16[($2 + 314 | 0) >> 1] | 0) >>> 0) {
       continue label$9
      }
      break label$9;
     };
     HEAP32[($3 + 16 | 0) >> 2] = $10;
    }
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($3 + 12 | 0) >> 2] | 0;
    $181 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[i64toi32_i32$1 >> 2] = $181;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($3 + 8 | 0) + 8 | 0) >> 2] | 0;
   }
   global$0 = $3 + 80 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1048619 | 0, 32 | 0, 1048744 | 0);
  abort();
 }
 
 function alloc__collections__btree__fix___impl_20alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____fix_node_through_parent__h4745793046b3af72($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $5 = 0, $4 = 0, $5$hi = 0, $44 = 0, $50 = 0, $69 = 0, $95 = 0, $101 = 0, $125 = 0, $131 = 0, $134 = 0, $159 = 0, $165 = 0, $168 = 0;
  $3 = global$0 - 128 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        $4 = HEAPU16[($2 + 138 | 0) >> 1] | 0;
        if ($4 >>> 0 > 4 >>> 0) {
         break label$6
        }
        alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___choose_parent_kv__h24a9cf471103309d($3 + 24 | 0 | 0, $1 | 0, $2 | 0);
        if ((HEAP32[($3 + 24 | 0) >> 2] | 0 | 0) == (1 | 0)) {
         break label$5
        }
        if ((HEAP32[($3 + 28 | 0) >> 2] | 0 | 0) == (1 | 0)) {
         break label$4
        }
        $1 = HEAP32[($3 + 56 | 0) >> 2] | 0;
        HEAP32[(($3 + 64 | 0) + 24 | 0) >> 2] = $1;
        i64toi32_i32$2 = ($3 + 24 | 0) + 24 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $5 = i64toi32_i32$0;
        $5$hi = i64toi32_i32$1;
        i64toi32_i32$0 = ($3 + 64 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $5;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$2 = ($3 + 24 | 0) + 16 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $44 = i64toi32_i32$1;
        i64toi32_i32$1 = ($3 + 64 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $44;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        $2 = ($3 + 24 | 0) + 8 | 0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $50 = i64toi32_i32$0;
        i64toi32_i32$0 = $3;
        HEAP32[($3 + 64 | 0) >> 2] = $50;
        HEAP32[($3 + 68 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$1 = $5$hi;
        if ((((HEAPU16[($5 + 138 | 0) >> 1] | 0) + (HEAPU16[($1 + 138 | 0) >> 1] | 0) | 0) + 1 | 0) >>> 0 < 12 >>> 0) {
         break label$3
        }
        alloc__collections__btree__node__BalancingContext_K_2cV___bulk_steal_left__he4fcf97c22216196($3 + 64 | 0 | 0, 5 - $4 | 0 | 0);
        $2 = 0;
        break label$2;
       }
       HEAP32[$0 >> 2] = 0;
       HEAP32[($0 + 8 | 0) >> 2] = 0;
       break label$1;
      }
      label$7 : {
       if ($4) {
        break label$7
       }
       i64toi32_i32$2 = $3;
       i64toi32_i32$1 = HEAP32[($3 + 28 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[($3 + 32 | 0) >> 2] | 0;
       $69 = i64toi32_i32$1;
       i64toi32_i32$1 = $0;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $69;
       HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
       HEAP32[i64toi32_i32$1 >> 2] = 1;
       break label$1;
      }
      HEAP32[$0 >> 2] = 0;
      HEAP32[($0 + 8 | 0) >> 2] = 0;
      break label$1;
     }
     $1 = HEAP32[($3 + 56 | 0) >> 2] | 0;
     HEAP32[(($3 + 64 | 0) + 24 | 0) >> 2] = $1;
     i64toi32_i32$2 = ($3 + 24 | 0) + 24 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $5 = i64toi32_i32$0;
     $5$hi = i64toi32_i32$1;
     i64toi32_i32$0 = ($3 + 64 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $5;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = ($3 + 24 | 0) + 16 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $95 = i64toi32_i32$1;
     i64toi32_i32$1 = ($3 + 64 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $95;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     $2 = ($3 + 24 | 0) + 8 | 0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $101 = i64toi32_i32$0;
     i64toi32_i32$0 = $3;
     HEAP32[($3 + 64 | 0) >> 2] = $101;
     HEAP32[($3 + 68 | 0) >> 2] = i64toi32_i32$1;
     label$8 : {
      label$9 : {
       i64toi32_i32$1 = $5$hi;
       if ((((HEAPU16[($5 + 138 | 0) >> 1] | 0) + (HEAPU16[($1 + 138 | 0) >> 1] | 0) | 0) + 1 | 0) >>> 0 < 12 >>> 0) {
        break label$9
       }
       alloc__collections__btree__node__BalancingContext_K_2cV___bulk_steal_right__h8845d27dacdbfcf7($3 + 64 | 0 | 0, 5 - $4 | 0 | 0);
       $2 = 0;
       break label$8;
      }
      HEAP32[(($3 + 96 | 0) + 24 | 0) >> 2] = HEAP32[($2 + 24 | 0) >> 2] | 0;
      i64toi32_i32$2 = $2 + 16 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $125 = i64toi32_i32$1;
      i64toi32_i32$1 = ($3 + 96 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $125;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $2 + 8 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $131 = i64toi32_i32$0;
      i64toi32_i32$0 = ($3 + 96 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $131;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $2;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $134 = i64toi32_i32$1;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 96 | 0) >> 2] = $134;
      HEAP32[($3 + 100 | 0) >> 2] = i64toi32_i32$0;
      alloc__collections__btree__node__BalancingContext_K_2cV___do_merge__hbcaaaeaa77b77a9b($3 + 8 | 0 | 0, $3 + 96 | 0 | 0);
      $2 = HEAP32[($3 + 12 | 0) >> 2] | 0;
      HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($3 + 8 | 0) >> 2] | 0;
     }
     HEAP32[$0 >> 2] = 0;
     HEAP32[($0 + 8 | 0) >> 2] = $2;
     break label$1;
    }
    HEAP32[(($3 + 96 | 0) + 24 | 0) >> 2] = HEAP32[($2 + 24 | 0) >> 2] | 0;
    i64toi32_i32$2 = $2 + 16 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $159 = i64toi32_i32$0;
    i64toi32_i32$0 = ($3 + 96 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $159;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $2 + 8 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $165 = i64toi32_i32$1;
    i64toi32_i32$1 = ($3 + 96 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $165;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $168 = i64toi32_i32$0;
    i64toi32_i32$0 = $3;
    HEAP32[($3 + 96 | 0) >> 2] = $168;
    HEAP32[($3 + 100 | 0) >> 2] = i64toi32_i32$1;
    alloc__collections__btree__node__BalancingContext_K_2cV___do_merge__hbcaaaeaa77b77a9b($3 + 16 | 0 | 0, $3 + 96 | 0 | 0);
    $2 = HEAP32[($3 + 20 | 0) >> 2] | 0;
    HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($3 + 16 | 0) >> 2] | 0;
   }
   HEAP32[$0 >> 2] = 0;
   HEAP32[($0 + 8 | 0) >> 2] = $2;
  }
  global$0 = $3 + 128 | 0;
 }
 
 function alloc__collections__btree__fix___impl_20alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____fix_node_through_parent__h5a49dfd829c8a7a2($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $5 = 0, $4 = 0, $5$hi = 0, $44 = 0, $50 = 0, $69 = 0, $95 = 0, $101 = 0, $125 = 0, $131 = 0, $134 = 0, $159 = 0, $165 = 0, $168 = 0;
  $3 = global$0 - 128 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        $4 = HEAPU16[($2 + 50 | 0) >> 1] | 0;
        if ($4 >>> 0 > 4 >>> 0) {
         break label$6
        }
        alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___choose_parent_kv__hffff788951b41f8b($3 + 24 | 0 | 0, $1 | 0, $2 | 0);
        if ((HEAP32[($3 + 24 | 0) >> 2] | 0 | 0) == (1 | 0)) {
         break label$5
        }
        if ((HEAP32[($3 + 28 | 0) >> 2] | 0 | 0) == (1 | 0)) {
         break label$4
        }
        $1 = HEAP32[($3 + 56 | 0) >> 2] | 0;
        HEAP32[(($3 + 64 | 0) + 24 | 0) >> 2] = $1;
        i64toi32_i32$2 = ($3 + 24 | 0) + 24 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $5 = i64toi32_i32$0;
        $5$hi = i64toi32_i32$1;
        i64toi32_i32$0 = ($3 + 64 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $5;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$2 = ($3 + 24 | 0) + 16 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $44 = i64toi32_i32$1;
        i64toi32_i32$1 = ($3 + 64 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $44;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        $2 = ($3 + 24 | 0) + 8 | 0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $50 = i64toi32_i32$0;
        i64toi32_i32$0 = $3;
        HEAP32[($3 + 64 | 0) >> 2] = $50;
        HEAP32[($3 + 68 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$1 = $5$hi;
        if ((((HEAPU16[($5 + 50 | 0) >> 1] | 0) + (HEAPU16[($1 + 50 | 0) >> 1] | 0) | 0) + 1 | 0) >>> 0 < 12 >>> 0) {
         break label$3
        }
        alloc__collections__btree__node__BalancingContext_K_2cV___bulk_steal_left__h1d363b549e6145dd($3 + 64 | 0 | 0, 5 - $4 | 0 | 0);
        $2 = 0;
        break label$2;
       }
       HEAP32[$0 >> 2] = 0;
       HEAP32[($0 + 8 | 0) >> 2] = 0;
       break label$1;
      }
      label$7 : {
       if ($4) {
        break label$7
       }
       i64toi32_i32$2 = $3;
       i64toi32_i32$1 = HEAP32[($3 + 28 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[($3 + 32 | 0) >> 2] | 0;
       $69 = i64toi32_i32$1;
       i64toi32_i32$1 = $0;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $69;
       HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
       HEAP32[i64toi32_i32$1 >> 2] = 1;
       break label$1;
      }
      HEAP32[$0 >> 2] = 0;
      HEAP32[($0 + 8 | 0) >> 2] = 0;
      break label$1;
     }
     $1 = HEAP32[($3 + 56 | 0) >> 2] | 0;
     HEAP32[(($3 + 64 | 0) + 24 | 0) >> 2] = $1;
     i64toi32_i32$2 = ($3 + 24 | 0) + 24 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $5 = i64toi32_i32$0;
     $5$hi = i64toi32_i32$1;
     i64toi32_i32$0 = ($3 + 64 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $5;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = ($3 + 24 | 0) + 16 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $95 = i64toi32_i32$1;
     i64toi32_i32$1 = ($3 + 64 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $95;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     $2 = ($3 + 24 | 0) + 8 | 0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $101 = i64toi32_i32$0;
     i64toi32_i32$0 = $3;
     HEAP32[($3 + 64 | 0) >> 2] = $101;
     HEAP32[($3 + 68 | 0) >> 2] = i64toi32_i32$1;
     label$8 : {
      label$9 : {
       i64toi32_i32$1 = $5$hi;
       if ((((HEAPU16[($5 + 50 | 0) >> 1] | 0) + (HEAPU16[($1 + 50 | 0) >> 1] | 0) | 0) + 1 | 0) >>> 0 < 12 >>> 0) {
        break label$9
       }
       alloc__collections__btree__node__BalancingContext_K_2cV___bulk_steal_right__h5eaa656be70e1d95($3 + 64 | 0 | 0, 5 - $4 | 0 | 0);
       $2 = 0;
       break label$8;
      }
      HEAP32[(($3 + 96 | 0) + 24 | 0) >> 2] = HEAP32[($2 + 24 | 0) >> 2] | 0;
      i64toi32_i32$2 = $2 + 16 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $125 = i64toi32_i32$1;
      i64toi32_i32$1 = ($3 + 96 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $125;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $2 + 8 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $131 = i64toi32_i32$0;
      i64toi32_i32$0 = ($3 + 96 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $131;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $2;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $134 = i64toi32_i32$1;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 96 | 0) >> 2] = $134;
      HEAP32[($3 + 100 | 0) >> 2] = i64toi32_i32$0;
      alloc__collections__btree__node__BalancingContext_K_2cV___do_merge__h389c83b864be02be($3 + 8 | 0 | 0, $3 + 96 | 0 | 0);
      $2 = HEAP32[($3 + 12 | 0) >> 2] | 0;
      HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($3 + 8 | 0) >> 2] | 0;
     }
     HEAP32[$0 >> 2] = 0;
     HEAP32[($0 + 8 | 0) >> 2] = $2;
     break label$1;
    }
    HEAP32[(($3 + 96 | 0) + 24 | 0) >> 2] = HEAP32[($2 + 24 | 0) >> 2] | 0;
    i64toi32_i32$2 = $2 + 16 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $159 = i64toi32_i32$0;
    i64toi32_i32$0 = ($3 + 96 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $159;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $2 + 8 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $165 = i64toi32_i32$1;
    i64toi32_i32$1 = ($3 + 96 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $165;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $168 = i64toi32_i32$0;
    i64toi32_i32$0 = $3;
    HEAP32[($3 + 96 | 0) >> 2] = $168;
    HEAP32[($3 + 100 | 0) >> 2] = i64toi32_i32$1;
    alloc__collections__btree__node__BalancingContext_K_2cV___do_merge__h389c83b864be02be($3 + 16 | 0 | 0, $3 + 96 | 0 | 0);
    $2 = HEAP32[($3 + 20 | 0) >> 2] | 0;
    HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($3 + 16 | 0) >> 2] | 0;
   }
   HEAP32[$0 >> 2] = 0;
   HEAP32[($0 + 8 | 0) >> 2] = $2;
  }
  global$0 = $3 + 128 | 0;
 }
 
 function alloc__collections__btree__fix___impl_20alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____fix_node_through_parent__hf092f11351db4dea($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $5 = 0, $4 = 0, $5$hi = 0, $44 = 0, $50 = 0, $69 = 0, $95 = 0, $101 = 0, $125 = 0, $131 = 0, $134 = 0, $159 = 0, $165 = 0, $168 = 0;
  $3 = global$0 - 128 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        $4 = HEAPU16[($2 + 226 | 0) >> 1] | 0;
        if ($4 >>> 0 > 4 >>> 0) {
         break label$6
        }
        alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___choose_parent_kv__hcc0b8d6ea18560ad($3 + 24 | 0 | 0, $1 | 0, $2 | 0);
        if ((HEAP32[($3 + 24 | 0) >> 2] | 0 | 0) == (1 | 0)) {
         break label$5
        }
        if ((HEAP32[($3 + 28 | 0) >> 2] | 0 | 0) == (1 | 0)) {
         break label$4
        }
        $1 = HEAP32[($3 + 56 | 0) >> 2] | 0;
        HEAP32[(($3 + 64 | 0) + 24 | 0) >> 2] = $1;
        i64toi32_i32$2 = ($3 + 24 | 0) + 24 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $5 = i64toi32_i32$0;
        $5$hi = i64toi32_i32$1;
        i64toi32_i32$0 = ($3 + 64 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $5;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$2 = ($3 + 24 | 0) + 16 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $44 = i64toi32_i32$1;
        i64toi32_i32$1 = ($3 + 64 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $44;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        $2 = ($3 + 24 | 0) + 8 | 0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $50 = i64toi32_i32$0;
        i64toi32_i32$0 = $3;
        HEAP32[($3 + 64 | 0) >> 2] = $50;
        HEAP32[($3 + 68 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$1 = $5$hi;
        if ((((HEAPU16[($5 + 226 | 0) >> 1] | 0) + (HEAPU16[($1 + 226 | 0) >> 1] | 0) | 0) + 1 | 0) >>> 0 < 12 >>> 0) {
         break label$3
        }
        alloc__collections__btree__node__BalancingContext_K_2cV___bulk_steal_left__hda63a524cf155183($3 + 64 | 0 | 0, 5 - $4 | 0 | 0);
        $2 = 0;
        break label$2;
       }
       HEAP32[$0 >> 2] = 0;
       HEAP32[($0 + 8 | 0) >> 2] = 0;
       break label$1;
      }
      label$7 : {
       if ($4) {
        break label$7
       }
       i64toi32_i32$2 = $3;
       i64toi32_i32$1 = HEAP32[($3 + 28 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[($3 + 32 | 0) >> 2] | 0;
       $69 = i64toi32_i32$1;
       i64toi32_i32$1 = $0;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $69;
       HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
       HEAP32[i64toi32_i32$1 >> 2] = 1;
       break label$1;
      }
      HEAP32[$0 >> 2] = 0;
      HEAP32[($0 + 8 | 0) >> 2] = 0;
      break label$1;
     }
     $1 = HEAP32[($3 + 56 | 0) >> 2] | 0;
     HEAP32[(($3 + 64 | 0) + 24 | 0) >> 2] = $1;
     i64toi32_i32$2 = ($3 + 24 | 0) + 24 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $5 = i64toi32_i32$0;
     $5$hi = i64toi32_i32$1;
     i64toi32_i32$0 = ($3 + 64 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $5;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = ($3 + 24 | 0) + 16 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $95 = i64toi32_i32$1;
     i64toi32_i32$1 = ($3 + 64 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $95;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     $2 = ($3 + 24 | 0) + 8 | 0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $101 = i64toi32_i32$0;
     i64toi32_i32$0 = $3;
     HEAP32[($3 + 64 | 0) >> 2] = $101;
     HEAP32[($3 + 68 | 0) >> 2] = i64toi32_i32$1;
     label$8 : {
      label$9 : {
       i64toi32_i32$1 = $5$hi;
       if ((((HEAPU16[($5 + 226 | 0) >> 1] | 0) + (HEAPU16[($1 + 226 | 0) >> 1] | 0) | 0) + 1 | 0) >>> 0 < 12 >>> 0) {
        break label$9
       }
       alloc__collections__btree__node__BalancingContext_K_2cV___bulk_steal_right__hfc3fbd9528abaf5f($3 + 64 | 0 | 0, 5 - $4 | 0 | 0);
       $2 = 0;
       break label$8;
      }
      HEAP32[(($3 + 96 | 0) + 24 | 0) >> 2] = HEAP32[($2 + 24 | 0) >> 2] | 0;
      i64toi32_i32$2 = $2 + 16 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $125 = i64toi32_i32$1;
      i64toi32_i32$1 = ($3 + 96 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $125;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $2 + 8 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $131 = i64toi32_i32$0;
      i64toi32_i32$0 = ($3 + 96 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $131;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $2;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $134 = i64toi32_i32$1;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 96 | 0) >> 2] = $134;
      HEAP32[($3 + 100 | 0) >> 2] = i64toi32_i32$0;
      alloc__collections__btree__node__BalancingContext_K_2cV___do_merge__hf05e236205b9e3b0($3 + 8 | 0 | 0, $3 + 96 | 0 | 0);
      $2 = HEAP32[($3 + 12 | 0) >> 2] | 0;
      HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($3 + 8 | 0) >> 2] | 0;
     }
     HEAP32[$0 >> 2] = 0;
     HEAP32[($0 + 8 | 0) >> 2] = $2;
     break label$1;
    }
    HEAP32[(($3 + 96 | 0) + 24 | 0) >> 2] = HEAP32[($2 + 24 | 0) >> 2] | 0;
    i64toi32_i32$2 = $2 + 16 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $159 = i64toi32_i32$0;
    i64toi32_i32$0 = ($3 + 96 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $159;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $2 + 8 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $165 = i64toi32_i32$1;
    i64toi32_i32$1 = ($3 + 96 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $165;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $168 = i64toi32_i32$0;
    i64toi32_i32$0 = $3;
    HEAP32[($3 + 96 | 0) >> 2] = $168;
    HEAP32[($3 + 100 | 0) >> 2] = i64toi32_i32$1;
    alloc__collections__btree__node__BalancingContext_K_2cV___do_merge__hf05e236205b9e3b0($3 + 16 | 0 | 0, $3 + 96 | 0 | 0);
    $2 = HEAP32[($3 + 20 | 0) >> 2] | 0;
    HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($3 + 16 | 0) >> 2] | 0;
   }
   HEAP32[$0 >> 2] = 0;
   HEAP32[($0 + 8 | 0) >> 2] = $2;
  }
  global$0 = $3 + 128 | 0;
 }
 
 function cardano_serialization_lib__legacy_address__cbor__util__encode_with_crc32___h44cd9155717a6906($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, $4 = 0, i64toi32_i32$1 = 0, $12 = 0, $13 = 0, $14 = 0, $16 = 0, $17 = 0, $5 = 0, $6 = 0, $6$hi = 0, $15 = 0, $42 = 0;
  $3 = global$0 - 240 | 0;
  global$0 = $3;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($3 + 8 | 0 | 0, 512 | 0, 0 | 0);
  HEAP32[($3 + 40 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[($3 + 32 | 0) >> 2] = $15;
  HEAP32[($3 + 36 | 0) >> 2] = i64toi32_i32$1;
  $_28_A_2c_B_2c_C_29_20as_20cbor_event__se__Serialize___serialize__h1186f7f09544497e($3 + 192 | 0 | 0, $1 | 0, $3 + 32 | 0 | 0);
  $1 = 19;
  label$1 : {
   if ((HEAP32[($3 + 192 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   $1 = HEAPU8[($3 + 200 | 0) >> 0] | 0;
   memcpy($3 + 144 | 0 | 0, $3 + 201 | 0 | 0, 39 | 0) | 0;
  }
  $4 = ($3 + 192 | 0) + 8 | 0;
  HEAP32[$4 >> 2] = HEAP32[(($3 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($3 + 32 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($3 + 36 | 0) >> 2] | 0;
  $42 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[($3 + 192 | 0) >> 2] = $42;
  HEAP32[($3 + 196 | 0) >> 2] = i64toi32_i32$0;
  label$2 : {
   label$3 : {
    label$4 : {
     if (($1 & 255 | 0 | 0) != (19 | 0)) {
      break label$4
     }
     HEAP32[($3 + 96 | 0) >> 2] = HEAPU8[($3 + 197 | 0) >> 0] | 0 | ((HEAPU8[($3 + 198 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 199 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 200 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $12 = HEAPU8[$4 >> 0] | 0 | ((HEAPU8[($4 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($3 + 99 | 0) >> 0] = $12;
     HEAP8[($3 + 100 | 0) >> 0] = $12 >>> 8 | 0;
     HEAP8[($3 + 101 | 0) >> 0] = $12 >>> 16 | 0;
     HEAP8[($3 + 102 | 0) >> 0] = $12 >>> 24 | 0;
     $13 = HEAPU8[($3 + 99 | 0) >> 0] | 0 | ((HEAPU8[($3 + 100 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 101 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 102 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($3 + 51 | 0) >> 0] = $13;
     HEAP8[($3 + 52 | 0) >> 0] = $13 >>> 8 | 0;
     HEAP8[($3 + 53 | 0) >> 0] = $13 >>> 16 | 0;
     HEAP8[($3 + 54 | 0) >> 0] = $13 >>> 24 | 0;
     HEAP32[($3 + 48 | 0) >> 2] = HEAP32[($3 + 96 | 0) >> 2] | 0;
     $14 = ($3 + 16 | 0) + 8 | 0;
     $16 = HEAPU8[($3 + 51 | 0) >> 0] | 0 | ((HEAPU8[($3 + 52 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 53 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 54 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[$14 >> 0] = $16;
     HEAP8[($14 + 1 | 0) >> 0] = $16 >>> 8 | 0;
     HEAP8[($14 + 2 | 0) >> 0] = $16 >>> 16 | 0;
     HEAP8[($14 + 3 | 0) >> 0] = $16 >>> 24 | 0;
     $17 = HEAP32[($3 + 48 | 0) >> 2] | 0;
     HEAP8[($3 + 21 | 0) >> 0] = $17;
     HEAP8[($3 + 22 | 0) >> 0] = $17 >>> 8 | 0;
     HEAP8[($3 + 23 | 0) >> 0] = $17 >>> 16 | 0;
     HEAP8[($3 + 24 | 0) >> 0] = $17 >>> 24 | 0;
     $1 = HEAP32[($3 + 192 | 0) >> 2] | 0;
     HEAP8[($3 + 20 | 0) >> 0] = HEAPU8[($3 + 196 | 0) >> 0] | 0;
     HEAP32[($3 + 16 | 0) >> 2] = $1;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 | 0, $3 + 16 | 0 | 0);
     label$5 : {
      label$6 : {
       $5 = HEAP32[($3 + 4 | 0) >> 2] | 0;
       if ($5) {
        break label$6
       }
       i64toi32_i32$0 = 0;
       $6 = 0;
       $6$hi = i64toi32_i32$0;
       break label$5;
      }
      $4 = HEAP32[$3 >> 2] | 0;
      $1 = -1;
      label$7 : while (1) {
       $1 = (HEAP32[(((($1 & 255 | 0) ^ (HEAPU8[$4 >> 0] | 0) | 0) << 2 | 0) + 1062472 | 0) >> 2] | 0) ^ ($1 >>> 8 | 0) | 0;
       $4 = $4 + 1 | 0;
       $5 = $5 + -1 | 0;
       if ($5) {
        continue label$7
       }
       break label$7;
      };
      i64toi32_i32$0 = 0;
      $6 = $1 ^ -1 | 0;
      $6$hi = i64toi32_i32$0;
     }
     i64toi32_i32$0 = 0;
     cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 + 192 | 0 | 0, $2 | 0, 4 | 0, 2 | 0, i64toi32_i32$0 | 0);
     label$8 : {
      label$9 : {
       label$10 : {
        label$11 : {
         if ((HEAP32[($3 + 192 | 0) >> 2] | 0 | 0) == (1 | 0)) {
          break label$11
         }
         i64toi32_i32$0 = 0;
         cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 + 144 | 0 | 0, HEAP32[($3 + 196 | 0) >> 2] | 0 | 0, 6 | 0, 24 | 0, i64toi32_i32$0 | 0);
         if ((HEAP32[($3 + 144 | 0) >> 2] | 0 | 0) == (1 | 0)) {
          break label$10
         }
         cbor_event__se__Serializer_W___write_bytes__hdbf95a6224c8b5b8($3 + 96 | 0 | 0, HEAP32[($3 + 148 | 0) >> 2] | 0 | 0, $3 + 16 | 0 | 0);
         if ((HEAP32[($3 + 96 | 0) >> 2] | 0 | 0) == (1 | 0)) {
          break label$9
         }
         i64toi32_i32$0 = $6$hi;
         cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 + 48 | 0 | 0, HEAP32[($3 + 100 | 0) >> 2] | 0 | 0, 0 | 0, $6 | 0, i64toi32_i32$0 | 0);
         if ((HEAP32[($3 + 48 | 0) >> 2] | 0 | 0) == (1 | 0)) {
          break label$8
         }
         HEAP8[$0 >> 0] = 19;
         $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 16 | 0 | 0);
         $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 16 | 0 | 0);
         break label$2;
        }
        memcpy($0 | 0, $3 + 200 | 0 | 0, 40 | 0) | 0;
        break label$3;
       }
       memcpy($0 | 0, $3 + 152 | 0 | 0, 40 | 0) | 0;
       break label$3;
      }
      memcpy($0 | 0, $3 + 104 | 0 | 0, 40 | 0) | 0;
      break label$3;
     }
     memcpy($0 | 0, $3 + 56 | 0 | 0, 40 | 0) | 0;
     break label$3;
    }
    memcpy($3 + 96 | 0 | 0, $3 + 144 | 0 | 0, 39 | 0) | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 192 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 192 | 0 | 0);
    memcpy($3 + 48 | 0 | 0, $3 + 96 | 0 | 0, 39 | 0) | 0;
    memcpy($0 + 1 | 0 | 0, $3 + 48 | 0 | 0, 39 | 0) | 0;
    HEAP8[$0 >> 0] = $1;
    break label$2;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 16 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 16 | 0 | 0);
  }
  global$0 = $3 + 240 | 0;
 }
 
 function core__fmt__write__h9b9aa23e7d35702c($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $8 = 0, $9 = 0, i64toi32_i32$0 = 0, $5 = 0, $6 = 0, $12 = 0, $7 = 0, i64toi32_i32$1 = 0, $4 = 0, $10 = 0, $11 = 0, i64toi32_i32$2 = 0, $17 = 0, $120 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  HEAP32[($3 + 36 | 0) >> 2] = $1;
  HEAP8[($3 + 40 | 0) >> 0] = 3;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 32;
  HEAP32[($3 + 8 | 0) >> 2] = 0;
  HEAP32[($3 + 12 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($3 + 32 | 0) >> 2] = $0;
  $0 = 0;
  HEAP32[($3 + 24 | 0) >> 2] = 0;
  HEAP32[($3 + 16 | 0) >> 2] = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
      if ($1) {
       break label$4
      }
      $4 = HEAP32[$2 >> 2] | 0;
      $5 = HEAP32[($2 + 4 | 0) >> 2] | 0;
      $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
      $6 = $1 >>> 0 > $5 >>> 0 ? $5 : $1;
      if (!$6) {
       break label$3
      }
      $7 = HEAP32[($2 + 16 | 0) >> 2] | 0;
      $0 = 0;
      $1 = $6;
      label$5 : while (1) {
       label$6 : {
        $8 = $4 + $0 | 0;
        $9 = HEAP32[($8 + 4 | 0) >> 2] | 0;
        if (!$9) {
         break label$6
        }
        if (FUNCTION_TABLE[HEAP32[((HEAP32[($3 + 36 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($3 + 32 | 0) >> 2] | 0, HEAP32[$8 >> 2] | 0, $9) | 0) {
         break label$2
        }
       }
       $8 = $7 + $0 | 0;
       if (FUNCTION_TABLE[HEAP32[($8 + 4 | 0) >> 2] | 0 | 0](HEAP32[$8 >> 2] | 0, $3 + 8 | 0) | 0) {
        break label$2
       }
       $0 = $0 + 8 | 0;
       $1 = $1 + -1 | 0;
       if ($1) {
        continue label$5
       }
       break label$5;
      };
      $0 = $6;
      break label$3;
     }
     $4 = HEAP32[$2 >> 2] | 0;
     $5 = HEAP32[($2 + 4 | 0) >> 2] | 0;
     $8 = HEAP32[($2 + 12 | 0) >> 2] | 0;
     $10 = $8 >>> 0 > $5 >>> 0 ? $5 : $8;
     if (!$10) {
      break label$3
     }
     $0 = $1 + 28 | 0;
     $11 = $10;
     $1 = $4;
     label$7 : while (1) {
      label$8 : {
       $8 = HEAP32[($1 + 4 | 0) >> 2] | 0;
       if (!$8) {
        break label$8
       }
       if (FUNCTION_TABLE[HEAP32[((HEAP32[($3 + 36 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($3 + 32 | 0) >> 2] | 0, HEAP32[$1 >> 2] | 0, $8) | 0) {
        break label$2
       }
      }
      HEAP8[($3 + 40 | 0) >> 0] = HEAPU8[$0 >> 0] | 0;
      i64toi32_i32$2 = $0 + -24 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $17 = i64toi32_i32$0;
      i64toi32_i32$0 = 0;
      i64toi32_i32$0 = __wasm_rotl_i64($17 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$0 | 0) | 0;
      i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
      $120 = i64toi32_i32$0;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 8 | 0) >> 2] = $120;
      HEAP32[($3 + 12 | 0) >> 2] = i64toi32_i32$1;
      $8 = HEAP32[($0 + -4 | 0) >> 2] | 0;
      $7 = HEAP32[($2 + 16 | 0) >> 2] | 0;
      $6 = 0;
      $9 = 0;
      label$9 : {
       label$10 : {
        switch (HEAP32[($0 + -8 | 0) >> 2] | 0 | 0) {
        case 1:
         $12 = $8 << 3 | 0;
         $9 = 0;
         $12 = $7 + $12 | 0;
         if ((HEAP32[($12 + 4 | 0) >> 2] | 0 | 0) != (327 | 0)) {
          break label$9
         }
         $8 = HEAP32[(HEAP32[$12 >> 2] | 0) >> 2] | 0;
         break;
        case 2:
         break label$9;
        default:
         break label$10;
        };
       }
       $9 = 1;
      }
      $12 = $0 + -28 | 0;
      HEAP32[($3 + 20 | 0) >> 2] = $8;
      HEAP32[($3 + 16 | 0) >> 2] = $9;
      $8 = HEAP32[($0 + -12 | 0) >> 2] | 0;
      label$12 : {
       label$13 : {
        switch (HEAP32[($0 + -16 | 0) >> 2] | 0 | 0) {
        case 1:
         $9 = $8 << 3 | 0;
         $9 = $7 + $9 | 0;
         if ((HEAP32[($9 + 4 | 0) >> 2] | 0 | 0) != (327 | 0)) {
          break label$12
         }
         $8 = HEAP32[(HEAP32[$9 >> 2] | 0) >> 2] | 0;
         break;
        case 2:
         break label$12;
        default:
         break label$13;
        };
       }
       $6 = 1;
      }
      HEAP32[($3 + 28 | 0) >> 2] = $8;
      HEAP32[($3 + 24 | 0) >> 2] = $6;
      $8 = $7 + ((HEAP32[$12 >> 2] | 0) << 3 | 0) | 0;
      if (FUNCTION_TABLE[HEAP32[($8 + 4 | 0) >> 2] | 0 | 0](HEAP32[$8 >> 2] | 0, $3 + 8 | 0) | 0) {
       break label$2
      }
      $0 = $0 + 32 | 0;
      $1 = $1 + 8 | 0;
      $11 = $11 + -1 | 0;
      if ($11) {
       continue label$7
      }
      break label$7;
     };
     $0 = $10;
    }
    label$15 : {
     if ($0 >>> 0 >= $5 >>> 0) {
      break label$15
     }
     $0 = $4 + ($0 << 3 | 0) | 0;
     if (FUNCTION_TABLE[HEAP32[((HEAP32[($3 + 36 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($3 + 32 | 0) >> 2] | 0, HEAP32[$0 >> 2] | 0, HEAP32[($0 + 4 | 0) >> 2] | 0) | 0) {
      break label$2
     }
    }
    $0 = 0;
    break label$1;
   }
   $0 = 1;
  }
  global$0 = $3 + 48 | 0;
  return $0 | 0;
 }
 
 function cardano_serialization_lib__fees__calculate_ex_units_ceil_cost__mult__he84254a8750bfe06($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $4 = 0, $5 = 0, $6 = 0, $40 = 0, $73 = 0, $109 = 0, $125 = 0, $129 = 0, $133 = 0, $139 = 0;
  $3 = global$0 - 128 | 0;
  global$0 = $3;
  cardano_serialization_lib__utils__BigNum__to_str__h5b9769c85af10e21($3 + 64 | 0 | 0, $1 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 24 | 0 | 0, $3 + 64 | 0 | 0);
  cardano_serialization_lib__utils__BigInt__from_str__h6032a095d77ac3d9($3 + 96 | 0 | 0, HEAP32[($3 + 24 | 0) >> 2] | 0 | 0, HEAP32[($3 + 28 | 0) >> 2] | 0 | 0);
  $4 = HEAP32[($3 + 100 | 0) >> 2] | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[($3 + 96 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     $5 = $3 + 112 | 0;
     HEAP32[(($3 + 32 | 0) + 12 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
     $6 = ($3 + 96 | 0) + 8 | 0;
     i64toi32_i32$2 = $6;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $40 = i64toi32_i32$0;
     i64toi32_i32$0 = $3;
     HEAP32[($3 + 36 | 0) >> 2] = $40;
     HEAP32[($3 + 40 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($3 + 32 | 0) >> 2] = $4;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 64 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 64 | 0 | 0);
     cardano_serialization_lib__utils__BigNum__to_str__h5b9769c85af10e21($3 + 64 | 0 | 0, $1 + 8 | 0 | 0);
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 16 | 0 | 0, $3 + 64 | 0 | 0);
     cardano_serialization_lib__utils__BigInt__from_str__h6032a095d77ac3d9($3 + 96 | 0 | 0, HEAP32[($3 + 16 | 0) >> 2] | 0 | 0, HEAP32[($3 + 20 | 0) >> 2] | 0 | 0);
     $1 = HEAP32[($3 + 100 | 0) >> 2] | 0;
     label$4 : {
      label$5 : {
       if ((HEAP32[($3 + 96 | 0) >> 2] | 0 | 0) == (1 | 0)) {
        break label$5
       }
       HEAP32[(($3 + 48 | 0) + 12 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
       i64toi32_i32$2 = $6;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $73 = i64toi32_i32$1;
       i64toi32_i32$1 = $3;
       HEAP32[($3 + 52 | 0) >> 2] = $73;
       HEAP32[($3 + 56 | 0) >> 2] = i64toi32_i32$0;
       HEAP32[($3 + 48 | 0) >> 2] = $1;
       $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 64 | 0 | 0);
       $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 64 | 0 | 0);
       cardano_serialization_lib__utils__BigNum__to_str__h5b9769c85af10e21($3 + 80 | 0 | 0, $2 | 0);
       $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $3 + 80 | 0 | 0);
       cardano_serialization_lib__utils__BigInt__from_str__h6032a095d77ac3d9($3 + 96 | 0 | 0, HEAP32[($3 + 8 | 0) >> 2] | 0 | 0, HEAP32[($3 + 12 | 0) >> 2] | 0 | 0);
       $1 = HEAP32[($3 + 100 | 0) >> 2] | 0;
       if ((HEAP32[($3 + 96 | 0) >> 2] | 0 | 0) == (1 | 0)) {
        break label$4
       }
       HEAP32[(($3 + 64 | 0) + 12 | 0) >> 2] = HEAP32[($3 + 112 | 0) >> 2] | 0;
       $4 = ($3 + 96 | 0) + 8 | 0;
       i64toi32_i32$2 = $4;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $109 = i64toi32_i32$0;
       i64toi32_i32$0 = $3;
       HEAP32[($3 + 68 | 0) >> 2] = $109;
       HEAP32[($3 + 72 | 0) >> 2] = i64toi32_i32$1;
       HEAP32[($3 + 64 | 0) >> 2] = $1;
       $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 80 | 0 | 0);
       $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 80 | 0 | 0);
       cardano_serialization_lib__utils__BigInt__mul__h31545dc99f4f564b($3 + 96 | 0 | 0, $3 + 32 | 0 | 0, $3 + 64 | 0 | 0);
       HEAP32[$0 >> 2] = 0;
       i64toi32_i32$2 = $3;
       i64toi32_i32$1 = HEAP32[($3 + 96 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[($3 + 100 | 0) >> 2] | 0;
       $125 = i64toi32_i32$1;
       i64toi32_i32$1 = $0;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $125;
       HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = $4;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $129 = i64toi32_i32$0;
       i64toi32_i32$0 = $0 + 12 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $129;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $3;
       i64toi32_i32$1 = HEAP32[($3 + 48 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[($3 + 52 | 0) >> 2] | 0;
       $133 = i64toi32_i32$1;
       i64toi32_i32$1 = $0 + 20 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $133;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = ($3 + 48 | 0) + 8 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $139 = i64toi32_i32$0;
       i64toi32_i32$0 = $0 + 28 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $139;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h19f76bdb6b4883ef($3 + 64 | 0 | 0);
       $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h970b13f6299e0f2d($3 + 64 | 0 | 0);
       $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h19f76bdb6b4883ef($3 + 32 | 0 | 0);
       $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h970b13f6299e0f2d($3 + 32 | 0 | 0);
       break label$1;
      }
      $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($1 | 0) | 0;
      HEAP32[$0 >> 2] = 1;
      HEAP32[($0 + 4 | 0) >> 2] = $1;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 64 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 64 | 0 | 0);
      break label$2;
     }
     $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($1 | 0) | 0;
     HEAP32[$0 >> 2] = 1;
     HEAP32[($0 + 4 | 0) >> 2] = $1;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 80 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 80 | 0 | 0);
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h19f76bdb6b4883ef($3 + 48 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h970b13f6299e0f2d($3 + 48 | 0 | 0);
     break label$2;
    }
    $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($4 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 64 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 64 | 0 | 0);
    break label$1;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h19f76bdb6b4883ef($3 + 32 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h970b13f6299e0f2d($3 + 32 | 0 | 0);
  }
  global$0 = $3 + 128 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_recursing__h39267185ba07887a($0, $1, $2, $3, $3$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $5 = 0, $6 = 0, $7 = 0, $8 = 0, $9 = 0, $10 = 0, $22 = 0, $32 = 0, $49 = 0, $81 = 0, $86 = 0, $112 = 0, $129 = 0, $140 = 0, $143 = 0, $163 = 0, $184 = 0, $187 = 0, $193 = 0;
  $4 = global$0 - 112 | 0;
  global$0 = $4;
  HEAP32[(($4 + 96 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $22 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[($4 + 96 | 0) >> 2] = $22;
  HEAP32[($4 + 100 | 0) >> 2] = i64toi32_i32$1;
  $5 = ($4 + 8 | 0) + 8 | 0;
  HEAP32[$5 >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $32 = i64toi32_i32$1;
  i64toi32_i32$1 = $4;
  HEAP32[($4 + 8 | 0) >> 2] = $32;
  HEAP32[($4 + 12 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $3$hi;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert__h1ee3485b018e040d($4 + 24 | 0 | 0, $4 + 96 | 0 | 0, $4 + 8 | 0 | 0, $3 | 0, i64toi32_i32$0 | 0);
  $6 = HEAP32[($4 + 72 | 0) >> 2] | 0;
  label$1 : {
   label$2 : {
    if ((HEAP32[($4 + 24 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    HEAP32[($0 + 48 | 0) >> 2] = $6;
    i64toi32_i32$2 = $4;
    i64toi32_i32$0 = HEAP32[($4 + 28 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($4 + 32 | 0) >> 2] | 0;
    $49 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $49;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[i64toi32_i32$0 >> 2] = 0;
    HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = HEAP32[(($4 + 24 | 0) + 12 | 0) >> 2] | 0;
    break label$1;
   }
   $1 = HEAP32[(($4 + 24 | 0) + 44 | 0) >> 2] | 0;
   $7 = HEAP32[(($4 + 24 | 0) + 40 | 0) >> 2] | 0;
   $8 = HEAP32[(($4 + 24 | 0) + 32 | 0) >> 2] | 0;
   i64toi32_i32$2 = ($4 + 24 | 0) + 24 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $3 = i64toi32_i32$1;
   $3$hi = i64toi32_i32$0;
   $2 = HEAP32[(($4 + 24 | 0) + 36 | 0) >> 2] | 0;
   $9 = $4 + 40 | 0;
   i64toi32_i32$2 = $9;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $81 = i64toi32_i32$0;
   i64toi32_i32$0 = $5;
   HEAP32[i64toi32_i32$0 >> 2] = $81;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = ($4 + 24 | 0) + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $86 = i64toi32_i32$1;
   i64toi32_i32$1 = $4;
   HEAP32[($4 + 8 | 0) >> 2] = $86;
   HEAP32[($4 + 12 | 0) >> 2] = i64toi32_i32$0;
   label$3 : {
    $5 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    if (!$5) {
     break label$3
    }
    $10 = ($4 + 24 | 0) + 8 | 0;
    label$4 : while (1) {
     HEAP32[($4 + 88 | 0) >> 2] = HEAPU16[($2 + 224 | 0) >> 1] | 0;
     HEAP32[($4 + 84 | 0) >> 2] = $5;
     HEAP32[($4 + 80 | 0) >> 2] = $8 + 1 | 0;
     $2 = ($4 + 8 | 0) + 8 | 0;
     HEAP32[(($4 + 96 | 0) + 8 | 0) >> 2] = HEAP32[$2 >> 2] | 0;
     i64toi32_i32$2 = $4;
     i64toi32_i32$0 = HEAP32[($4 + 8 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($4 + 12 | 0) >> 2] | 0;
     $112 = i64toi32_i32$0;
     i64toi32_i32$0 = $4;
     HEAP32[($4 + 96 | 0) >> 2] = $112;
     HEAP32[($4 + 100 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $3$hi;
     alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert__ha71355666283c225($4 + 24 | 0 | 0, $4 + 80 | 0 | 0, $4 + 96 | 0 | 0, $3 | 0, i64toi32_i32$1 | 0, $7 | 0, $1 | 0);
     label$5 : {
      if ((HEAP32[($4 + 24 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$5
      }
      HEAP32[($0 + 48 | 0) >> 2] = $6;
      i64toi32_i32$2 = $4;
      i64toi32_i32$1 = HEAP32[($4 + 28 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($4 + 32 | 0) >> 2] | 0;
      $129 = i64toi32_i32$1;
      i64toi32_i32$1 = $0;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $129;
      HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[i64toi32_i32$1 >> 2] = 0;
      HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = HEAP32[(($4 + 24 | 0) + 12 | 0) >> 2] | 0;
      break label$1;
     }
     i64toi32_i32$2 = $10 + 8 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $140 = i64toi32_i32$0;
     i64toi32_i32$0 = $2;
     HEAP32[i64toi32_i32$0 >> 2] = $140;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $10;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $143 = i64toi32_i32$1;
     i64toi32_i32$1 = $4;
     HEAP32[($4 + 8 | 0) >> 2] = $143;
     HEAP32[($4 + 12 | 0) >> 2] = i64toi32_i32$0;
     $1 = HEAP32[($4 + 68 | 0) >> 2] | 0;
     $7 = HEAP32[($4 + 64 | 0) >> 2] | 0;
     $8 = HEAP32[($4 + 56 | 0) >> 2] | 0;
     i64toi32_i32$2 = $4;
     i64toi32_i32$0 = HEAP32[($4 + 48 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($4 + 52 | 0) >> 2] | 0;
     $3 = i64toi32_i32$0;
     $3$hi = i64toi32_i32$1;
     $2 = HEAP32[($4 + 60 | 0) >> 2] | 0;
     $5 = HEAP32[($2 + 88 | 0) >> 2] | 0;
     if ($5) {
      continue label$4
     }
     break label$4;
    };
   }
   i64toi32_i32$2 = ($4 + 8 | 0) + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $163 = i64toi32_i32$1;
   i64toi32_i32$1 = ($4 + 24 | 0) + 12 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $163;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[$0 >> 2] = 1;
   HEAP32[($0 + 48 | 0) >> 2] = $6;
   HEAP32[($0 + 44 | 0) >> 2] = $1;
   HEAP32[($0 + 40 | 0) >> 2] = $7;
   HEAP32[($0 + 36 | 0) >> 2] = $2;
   HEAP32[($0 + 32 | 0) >> 2] = $8;
   i64toi32_i32$0 = $3$hi;
   i64toi32_i32$1 = $0 + 24 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $3;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $4;
   i64toi32_i32$0 = HEAP32[($4 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($4 + 12 | 0) >> 2] | 0;
   $184 = i64toi32_i32$0;
   i64toi32_i32$0 = $4;
   HEAP32[($4 + 28 | 0) >> 2] = $184;
   HEAP32[($4 + 32 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $4;
   i64toi32_i32$1 = HEAP32[($4 + 24 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($4 + 28 | 0) >> 2] | 0;
   $187 = i64toi32_i32$1;
   i64toi32_i32$1 = $0;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $187;
   HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = ($4 + 24 | 0) + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $193 = i64toi32_i32$0;
   i64toi32_i32$0 = $0 + 12 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $193;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($0 + 20 | 0) >> 2] = HEAP32[$9 >> 2] | 0;
  }
  global$0 = $4 + 112 | 0;
 }
 
 function cryptoxide__poly1305__Poly1305__block__h169ca472edf19e75($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$5 = 0, i64toi32_i32$1 = 0, i64toi32_i32$4 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, $5$hi = 0, $7$hi = 0, $9$hi = 0, $10$hi = 0, $11$hi = 0, $12$hi = 0, $13$hi = 0, $6$hi = 0, $14$hi = 0, $5 = 0, $12 = 0, $7 = 0, $8$hi = 0, $9 = 0, $10 = 0, $11 = 0, $13 = 0, $14 = 0, $15$hi = 0, $15 = 0, $6 = 0, $8 = 0, $17$hi = 0, $3 = 0, $4 = 0, $125 = 0, $126 = 0, $127 = 0, $129 = 0, $130 = 0, $28 = 0, $44 = 0, $44$hi = 0, $58 = 0, $58$hi = 0, $59$hi = 0, $73 = 0, $73$hi = 0, $74$hi = 0, $90 = 0, $90$hi = 0, $91$hi = 0, $113 = 0, $113$hi = 0, $114 = 0, $114$hi = 0, $117 = 0, $117$hi = 0, $120 = 0, $120$hi = 0, $121$hi = 0, $124 = 0, $124$hi = 0, $125$hi = 0, $128 = 0, $128$hi = 0, $129$hi = 0, $135 = 0, $135$hi = 0, $136 = 0, $136$hi = 0, $139 = 0, $139$hi = 0, $142 = 0, $142$hi = 0, $143$hi = 0, $146 = 0, $146$hi = 0, $147$hi = 0, $150 = 0, $150$hi = 0, $151$hi = 0, $155$hi = 0, $156 = 0, $156$hi = 0, $160 = 0, $160$hi = 0, $164 = 0, $164$hi = 0, $16 = 0, $16$hi = 0, $169 = 0, $172 = 0, $172$hi = 0, $17 = 0, $177 = 0, $177$hi = 0, $178$hi = 0, $181 = 0, $181$hi = 0, $182$hi = 0, $185 = 0, $185$hi = 0, $186$hi = 0, $189 = 0, $189$hi = 0, $190 = 0, $190$hi = 0, $193 = 0, $193$hi = 0, $198 = 0, $201 = 0, $201$hi = 0, $204$hi = 0, $205 = 0, $205$hi = 0, $206$hi = 0, $209 = 0, $209$hi = 0, $210$hi = 0, $213 = 0, $213$hi = 0, $214$hi = 0, $217 = 0, $217$hi = 0, $218 = 0, $218$hi = 0, $221 = 0, $221$hi = 0, $226 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ($2 >>> 0 <= 3 >>> 0) {
        break label$5
       }
       if ($2 >>> 0 <= 6 >>> 0) {
        break label$4
       }
       if ($2 >>> 0 <= 9 >>> 0) {
        break label$3
       }
       if ($2 >>> 0 <= 12 >>> 0) {
        break label$2
       }
       if ($2 >>> 0 <= 15 >>> 0) {
        break label$1
       }
       $28 = $0;
       i64toi32_i32$0 = 0;
       $5 = (((HEAPU8[($1 + 3 | 0) >> 0] | 0 | ((HEAPU8[($1 + 4 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 5 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 6 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) >>> 2 | 0) & 67108863 | 0) + (HEAP32[($0 + 24 | 0) >> 2] | 0) | 0;
       $5$hi = i64toi32_i32$0;
       $2 = HEAP32[($0 + 4 | 0) >> 2] | 0;
       i64toi32_i32$0 = 0;
       $6 = $2;
       $6$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $5$hi;
       i64toi32_i32$1 = $6$hi;
       i64toi32_i32$1 = __wasm_i64_mul($5 | 0, i64toi32_i32$0 | 0, $2 | 0, i64toi32_i32$1 | 0) | 0;
       i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
       $44 = i64toi32_i32$1;
       $44$hi = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       $7 = ((HEAPU8[$1 >> 0] | 0 | ((HEAPU8[($1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & 67108863 | 0) + (HEAP32[($0 + 20 | 0) >> 2] | 0) | 0;
       $7$hi = i64toi32_i32$0;
       $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
       i64toi32_i32$0 = 0;
       $8 = $3;
       $8$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $7$hi;
       i64toi32_i32$1 = $8$hi;
       i64toi32_i32$1 = __wasm_i64_mul($7 | 0, i64toi32_i32$0 | 0, $8 | 0, i64toi32_i32$1 | 0) | 0;
       i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
       $58 = i64toi32_i32$1;
       $58$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $44$hi;
       i64toi32_i32$2 = $44;
       i64toi32_i32$1 = $58$hi;
       i64toi32_i32$3 = $58;
       i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
       i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
       if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
        i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
       }
       $59$hi = i64toi32_i32$5;
       i64toi32_i32$5 = 0;
       $9 = (((HEAPU8[($1 + 6 | 0) >> 0] | 0 | ((HEAPU8[($1 + 7 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 8 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 9 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) >>> 4 | 0) & 67108863 | 0) + (HEAP32[($0 + 28 | 0) >> 2] | 0) | 0;
       $9$hi = i64toi32_i32$5;
       i64toi32_i32$0 = $0;
       i64toi32_i32$5 = HEAP32[i64toi32_i32$0 >> 2] | 0;
       i64toi32_i32$2 = 0;
       $10 = i64toi32_i32$5;
       $10$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $9$hi;
       i64toi32_i32$5 = $10$hi;
       i64toi32_i32$5 = __wasm_i64_mul($9 | 0, i64toi32_i32$2 | 0, $10 | 0, i64toi32_i32$5 | 0) | 0;
       i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
       $73 = i64toi32_i32$5;
       $73$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $59$hi;
       i64toi32_i32$0 = i64toi32_i32$4;
       i64toi32_i32$5 = $73$hi;
       i64toi32_i32$3 = $73;
       i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
       i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
       if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
        i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
       }
       $74$hi = i64toi32_i32$4;
       i64toi32_i32$4 = 0;
       $11 = ((HEAPU8[($1 + 9 | 0) >> 0] | 0 | ((HEAPU8[($1 + 10 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 11 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 12 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) >>> 6 | 0) + (HEAP32[($0 + 32 | 0) >> 2] | 0) | 0;
       $11$hi = i64toi32_i32$4;
       $4 = HEAP32[($0 + 16 | 0) >> 2] | 0;
       i64toi32_i32$4 = 0;
       $12 = Math_imul($4, 5);
       $12$hi = i64toi32_i32$4;
       i64toi32_i32$4 = $11$hi;
       i64toi32_i32$0 = $12$hi;
       i64toi32_i32$0 = __wasm_i64_mul($11 | 0, i64toi32_i32$4 | 0, $12 | 0, i64toi32_i32$0 | 0) | 0;
       i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
       $90 = i64toi32_i32$0;
       $90$hi = i64toi32_i32$4;
       i64toi32_i32$4 = $74$hi;
       i64toi32_i32$2 = i64toi32_i32$1;
       i64toi32_i32$0 = $90$hi;
       i64toi32_i32$3 = $90;
       i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
       i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
       if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
       }
       $91$hi = i64toi32_i32$1;
       i64toi32_i32$1 = 0;
       $13 = ((HEAP32[($0 + 36 | 0) >> 2] | 0) + (!((HEAPU8[($0 + 76 | 0) >> 0] | 0) & 255 | 0) << 24 | 0) | 0) + ((HEAPU8[($1 + 12 | 0) >> 0] | 0 | ((HEAPU8[($1 + 13 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 14 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 15 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) >>> 8 | 0) | 0;
       $13$hi = i64toi32_i32$1;
       $1 = HEAP32[($0 + 12 | 0) >> 2] | 0;
       i64toi32_i32$1 = 0;
       $14 = Math_imul($1, 5);
       $14$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $13$hi;
       i64toi32_i32$2 = $14$hi;
       i64toi32_i32$2 = __wasm_i64_mul($13 | 0, i64toi32_i32$1 | 0, $14 | 0, i64toi32_i32$2 | 0) | 0;
       i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
       $113 = i64toi32_i32$2;
       $113$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $91$hi;
       i64toi32_i32$4 = i64toi32_i32$5;
       i64toi32_i32$2 = $113$hi;
       i64toi32_i32$3 = $113;
       i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
       i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
       if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
        i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
       }
       $114 = i64toi32_i32$0;
       $114$hi = i64toi32_i32$5;
       i64toi32_i32$5 = $5$hi;
       i64toi32_i32$5 = $10$hi;
       i64toi32_i32$5 = $5$hi;
       i64toi32_i32$4 = $10$hi;
       i64toi32_i32$4 = __wasm_i64_mul($5 | 0, i64toi32_i32$5 | 0, $10 | 0, i64toi32_i32$4 | 0) | 0;
       i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
       $117 = i64toi32_i32$4;
       $117$hi = i64toi32_i32$5;
       i64toi32_i32$5 = $7$hi;
       i64toi32_i32$5 = $6$hi;
       i64toi32_i32$5 = $7$hi;
       i64toi32_i32$4 = $6$hi;
       i64toi32_i32$4 = __wasm_i64_mul($7 | 0, i64toi32_i32$5 | 0, $6 | 0, i64toi32_i32$4 | 0) | 0;
       i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
       $120 = i64toi32_i32$4;
       $120$hi = i64toi32_i32$5;
       i64toi32_i32$5 = $117$hi;
       i64toi32_i32$1 = $117;
       i64toi32_i32$4 = $120$hi;
       i64toi32_i32$3 = $120;
       i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
       i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
       if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
        i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
       }
       $121$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $9$hi;
       i64toi32_i32$0 = $12$hi;
       i64toi32_i32$0 = $9$hi;
       i64toi32_i32$1 = $12$hi;
       i64toi32_i32$1 = __wasm_i64_mul($9 | 0, i64toi32_i32$0 | 0, $12 | 0, i64toi32_i32$1 | 0) | 0;
       i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
       $124 = i64toi32_i32$1;
       $124$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $121$hi;
       i64toi32_i32$5 = i64toi32_i32$2;
       i64toi32_i32$1 = $124$hi;
       i64toi32_i32$3 = $124;
       i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
       i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
       if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
       }
       $125$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $11$hi;
       i64toi32_i32$2 = $14$hi;
       i64toi32_i32$2 = $11$hi;
       i64toi32_i32$5 = $14$hi;
       i64toi32_i32$5 = __wasm_i64_mul($11 | 0, i64toi32_i32$2 | 0, $14 | 0, i64toi32_i32$5 | 0) | 0;
       i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
       $128 = i64toi32_i32$5;
       $128$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $125$hi;
       i64toi32_i32$0 = i64toi32_i32$4;
       i64toi32_i32$5 = $128$hi;
       i64toi32_i32$3 = $128;
       i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
       i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
       if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
        i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
       }
       $129$hi = i64toi32_i32$4;
       i64toi32_i32$4 = $13$hi;
       i64toi32_i32$4 = 0;
       $15 = Math_imul($3, 5);
       $15$hi = i64toi32_i32$4;
       i64toi32_i32$4 = $13$hi;
       i64toi32_i32$0 = $15$hi;
       i64toi32_i32$0 = __wasm_i64_mul($13 | 0, i64toi32_i32$4 | 0, $15 | 0, i64toi32_i32$0 | 0) | 0;
       i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
       $135 = i64toi32_i32$0;
       $135$hi = i64toi32_i32$4;
       i64toi32_i32$4 = $129$hi;
       i64toi32_i32$2 = i64toi32_i32$1;
       i64toi32_i32$0 = $135$hi;
       i64toi32_i32$3 = $135;
       i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
       i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
       if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
       }
       $136 = i64toi32_i32$5;
       $136$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $5$hi;
       i64toi32_i32$1 = $12$hi;
       i64toi32_i32$1 = $5$hi;
       i64toi32_i32$2 = $12$hi;
       i64toi32_i32$2 = __wasm_i64_mul($5 | 0, i64toi32_i32$1 | 0, $12 | 0, i64toi32_i32$2 | 0) | 0;
       i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
       $139 = i64toi32_i32$2;
       $139$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $7$hi;
       i64toi32_i32$1 = $10$hi;
       i64toi32_i32$1 = $7$hi;
       i64toi32_i32$2 = $10$hi;
       i64toi32_i32$2 = __wasm_i64_mul($7 | 0, i64toi32_i32$1 | 0, $10 | 0, i64toi32_i32$2 | 0) | 0;
       i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
       $142 = i64toi32_i32$2;
       $142$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $139$hi;
       i64toi32_i32$4 = $139;
       i64toi32_i32$2 = $142$hi;
       i64toi32_i32$3 = $142;
       i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
       i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
       if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
        i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
       }
       $143$hi = i64toi32_i32$5;
       i64toi32_i32$5 = $9$hi;
       i64toi32_i32$5 = $14$hi;
       i64toi32_i32$5 = $9$hi;
       i64toi32_i32$4 = $14$hi;
       i64toi32_i32$4 = __wasm_i64_mul($9 | 0, i64toi32_i32$5 | 0, $14 | 0, i64toi32_i32$4 | 0) | 0;
       i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
       $146 = i64toi32_i32$4;
       $146$hi = i64toi32_i32$5;
       i64toi32_i32$5 = $143$hi;
       i64toi32_i32$1 = i64toi32_i32$0;
       i64toi32_i32$4 = $146$hi;
       i64toi32_i32$3 = $146;
       i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
       i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
       if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
        i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
       }
       $147$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $11$hi;
       i64toi32_i32$0 = $15$hi;
       i64toi32_i32$0 = $11$hi;
       i64toi32_i32$1 = $15$hi;
       i64toi32_i32$1 = __wasm_i64_mul($11 | 0, i64toi32_i32$0 | 0, $15 | 0, i64toi32_i32$1 | 0) | 0;
       i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
       $150 = i64toi32_i32$1;
       $150$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $147$hi;
       i64toi32_i32$5 = i64toi32_i32$2;
       i64toi32_i32$1 = $150$hi;
       i64toi32_i32$3 = $150;
       i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
       i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
       if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
       }
       $151$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $13$hi;
       i64toi32_i32$2 = 0;
       $155$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $13$hi;
       i64toi32_i32$5 = $155$hi;
       i64toi32_i32$5 = __wasm_i64_mul($13 | 0, i64toi32_i32$2 | 0, Math_imul($2, 5) | 0, i64toi32_i32$5 | 0) | 0;
       i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
       $156 = i64toi32_i32$5;
       $156$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $151$hi;
       i64toi32_i32$0 = i64toi32_i32$4;
       i64toi32_i32$5 = $156$hi;
       i64toi32_i32$3 = $156;
       i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
       i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
       if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
        i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
       }
       $14 = i64toi32_i32$1;
       $14$hi = i64toi32_i32$4;
       i64toi32_i32$2 = i64toi32_i32$1;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 26;
       i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = 0;
        $125 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
       } else {
        i64toi32_i32$0 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
        $125 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$5 | 0) | 0;
       }
       i64toi32_i32$4 = $125;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = -1;
       i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
       $160 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
       $160$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $136$hi;
       i64toi32_i32$0 = $136;
       i64toi32_i32$4 = $160$hi;
       i64toi32_i32$3 = $160;
       i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
       i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
       if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
       }
       $15 = i64toi32_i32$5;
       $15$hi = i64toi32_i32$1;
       i64toi32_i32$2 = i64toi32_i32$5;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 26;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = 0;
        $126 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
        $126 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
       }
       i64toi32_i32$1 = $126;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = -1;
       i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
       $164 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
       $164$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $114$hi;
       i64toi32_i32$0 = $114;
       i64toi32_i32$1 = $164$hi;
       i64toi32_i32$3 = $164;
       i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
       i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
       if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
        i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
       }
       $16 = i64toi32_i32$4;
       $16$hi = i64toi32_i32$5;
       HEAP32[($28 + 28 | 0) >> 2] = i64toi32_i32$4 & 67108863 | 0;
       $169 = $0;
       i64toi32_i32$5 = $5$hi;
       i64toi32_i32$5 = $8$hi;
       i64toi32_i32$5 = $5$hi;
       i64toi32_i32$0 = $8$hi;
       i64toi32_i32$0 = __wasm_i64_mul($5 | 0, i64toi32_i32$5 | 0, $8 | 0, i64toi32_i32$0 | 0) | 0;
       i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
       $172 = i64toi32_i32$0;
       $172$hi = i64toi32_i32$5;
       i64toi32_i32$5 = $7$hi;
       i64toi32_i32$5 = 0;
       $17 = $1;
       $17$hi = i64toi32_i32$5;
       i64toi32_i32$5 = $7$hi;
       i64toi32_i32$0 = $17$hi;
       i64toi32_i32$0 = __wasm_i64_mul($7 | 0, i64toi32_i32$5 | 0, $1 | 0, i64toi32_i32$0 | 0) | 0;
       i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
       $177 = i64toi32_i32$0;
       $177$hi = i64toi32_i32$5;
       i64toi32_i32$5 = $172$hi;
       i64toi32_i32$2 = $172;
       i64toi32_i32$0 = $177$hi;
       i64toi32_i32$3 = $177;
       i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
       i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
       if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
        i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
       }
       $178$hi = i64toi32_i32$4;
       i64toi32_i32$4 = $9$hi;
       i64toi32_i32$4 = $6$hi;
       i64toi32_i32$4 = $9$hi;
       i64toi32_i32$2 = $6$hi;
       i64toi32_i32$2 = __wasm_i64_mul($9 | 0, i64toi32_i32$4 | 0, $6 | 0, i64toi32_i32$2 | 0) | 0;
       i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
       $181 = i64toi32_i32$2;
       $181$hi = i64toi32_i32$4;
       i64toi32_i32$4 = $178$hi;
       i64toi32_i32$5 = i64toi32_i32$1;
       i64toi32_i32$2 = $181$hi;
       i64toi32_i32$3 = $181;
       i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
       i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$2 | 0;
       if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
       }
       $182$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $11$hi;
       i64toi32_i32$1 = $10$hi;
       i64toi32_i32$1 = $11$hi;
       i64toi32_i32$5 = $10$hi;
       i64toi32_i32$5 = __wasm_i64_mul($11 | 0, i64toi32_i32$1 | 0, $10 | 0, i64toi32_i32$5 | 0) | 0;
       i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
       $185 = i64toi32_i32$5;
       $185$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $182$hi;
       i64toi32_i32$4 = i64toi32_i32$0;
       i64toi32_i32$5 = $185$hi;
       i64toi32_i32$3 = $185;
       i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
       i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
       if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
        i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
       }
       $186$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $13$hi;
       i64toi32_i32$0 = $12$hi;
       i64toi32_i32$0 = $13$hi;
       i64toi32_i32$4 = $12$hi;
       i64toi32_i32$4 = __wasm_i64_mul($13 | 0, i64toi32_i32$0 | 0, $12 | 0, i64toi32_i32$4 | 0) | 0;
       i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
       $189 = i64toi32_i32$4;
       $189$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $186$hi;
       i64toi32_i32$1 = i64toi32_i32$2;
       i64toi32_i32$4 = $189$hi;
       i64toi32_i32$3 = $189;
       i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
       i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
       if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
       }
       $190 = i64toi32_i32$5;
       $190$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $16$hi;
       i64toi32_i32$0 = $16;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 26;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = 0;
        $127 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
        $127 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
       }
       i64toi32_i32$2 = $127;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = -1;
       i64toi32_i32$0 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
       $193 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
       $193$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $190$hi;
       i64toi32_i32$1 = $190;
       i64toi32_i32$2 = $193$hi;
       i64toi32_i32$3 = $193;
       i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
       i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
       if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
        i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
       }
       $12 = i64toi32_i32$4;
       $12$hi = i64toi32_i32$5;
       HEAP32[($169 + 32 | 0) >> 2] = i64toi32_i32$4 & 67108863 | 0;
       $198 = $0;
       i64toi32_i32$5 = $5$hi;
       i64toi32_i32$5 = $17$hi;
       i64toi32_i32$5 = $5$hi;
       i64toi32_i32$1 = $17$hi;
       i64toi32_i32$1 = __wasm_i64_mul($5 | 0, i64toi32_i32$5 | 0, $17 | 0, i64toi32_i32$1 | 0) | 0;
       i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
       $201 = i64toi32_i32$1;
       $201$hi = i64toi32_i32$5;
       i64toi32_i32$5 = $7$hi;
       i64toi32_i32$5 = 0;
       $204$hi = i64toi32_i32$5;
       i64toi32_i32$5 = $7$hi;
       i64toi32_i32$1 = $204$hi;
       i64toi32_i32$1 = __wasm_i64_mul($7 | 0, i64toi32_i32$5 | 0, $4 | 0, i64toi32_i32$1 | 0) | 0;
       i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
       $205 = i64toi32_i32$1;
       $205$hi = i64toi32_i32$5;
       i64toi32_i32$5 = $201$hi;
       i64toi32_i32$0 = $201;
       i64toi32_i32$1 = $205$hi;
       i64toi32_i32$3 = $205;
       i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
       i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
       if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
        i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
       }
       $206$hi = i64toi32_i32$4;
       i64toi32_i32$4 = $9$hi;
       i64toi32_i32$4 = $8$hi;
       i64toi32_i32$4 = $9$hi;
       i64toi32_i32$0 = $8$hi;
       i64toi32_i32$0 = __wasm_i64_mul($9 | 0, i64toi32_i32$4 | 0, $8 | 0, i64toi32_i32$0 | 0) | 0;
       i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
       $209 = i64toi32_i32$0;
       $209$hi = i64toi32_i32$4;
       i64toi32_i32$4 = $206$hi;
       i64toi32_i32$5 = i64toi32_i32$2;
       i64toi32_i32$0 = $209$hi;
       i64toi32_i32$3 = $209;
       i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
       i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
       if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
       }
       $210$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $11$hi;
       i64toi32_i32$2 = $6$hi;
       i64toi32_i32$2 = $11$hi;
       i64toi32_i32$5 = $6$hi;
       i64toi32_i32$5 = __wasm_i64_mul($11 | 0, i64toi32_i32$2 | 0, $6 | 0, i64toi32_i32$5 | 0) | 0;
       i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
       $213 = i64toi32_i32$5;
       $213$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $210$hi;
       i64toi32_i32$4 = i64toi32_i32$1;
       i64toi32_i32$5 = $213$hi;
       i64toi32_i32$3 = $213;
       i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
       i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
       if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
       }
       $214$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $13$hi;
       i64toi32_i32$1 = $10$hi;
       i64toi32_i32$1 = $13$hi;
       i64toi32_i32$4 = $10$hi;
       i64toi32_i32$4 = __wasm_i64_mul($13 | 0, i64toi32_i32$1 | 0, $10 | 0, i64toi32_i32$4 | 0) | 0;
       i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
       $217 = i64toi32_i32$4;
       $217$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $214$hi;
       i64toi32_i32$2 = i64toi32_i32$0;
       i64toi32_i32$4 = $217$hi;
       i64toi32_i32$3 = $217;
       i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
       i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
       if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
        i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
       }
       $218 = i64toi32_i32$5;
       $218$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $12$hi;
       i64toi32_i32$1 = $12;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 26;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = 0;
        $129 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
        $129 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
       }
       i64toi32_i32$0 = $129;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = -1;
       i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
       $221 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
       $221$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $218$hi;
       i64toi32_i32$2 = $218;
       i64toi32_i32$0 = $221$hi;
       i64toi32_i32$3 = $221;
       i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
       i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
       if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
        i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
       }
       $5 = i64toi32_i32$4;
       $5$hi = i64toi32_i32$5;
       HEAP32[($198 + 36 | 0) >> 2] = i64toi32_i32$4 & 67108863 | 0;
       $226 = $0;
       i64toi32_i32$1 = i64toi32_i32$4;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 26;
       i64toi32_i32$0 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = 0;
        $130 = i64toi32_i32$5 >>> i64toi32_i32$0 | 0;
       } else {
        i64toi32_i32$2 = i64toi32_i32$5 >>> i64toi32_i32$0 | 0;
        $130 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$0 | 0) | 0;
       }
       i64toi32_i32$2 = $14$hi;
       $2 = Math_imul($130, 5) + ($14 & 67108863 | 0) | 0;
       HEAP32[($226 + 20 | 0) >> 2] = $2 & 67108863 | 0;
       i64toi32_i32$2 = $15$hi;
       HEAP32[($0 + 24 | 0) >> 2] = ($2 >>> 26 | 0) + ($15 & 67108863 | 0) | 0;
       return;
      }
      core__slice__index__slice_end_index_len_fail__h192505a15ac4b345(4 | 0, $2 | 0, 1137716 | 0);
      abort();
     }
     core__slice__index__slice_end_index_len_fail__h192505a15ac4b345(7 | 0, $2 | 0, 1137732 | 0);
     abort();
    }
    core__slice__index__slice_end_index_len_fail__h192505a15ac4b345(10 | 0, $2 | 0, 1137748 | 0);
    abort();
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345(13 | 0, $2 | 0, 1137764 | 0);
   abort();
  }
  core__slice__index__slice_end_index_len_fail__h192505a15ac4b345(16 | 0, $2 | 0, 1137780 | 0);
  abort();
 }
 
 function cardano_serialization_lib__metadata__encode_json_value_to_metadatum__encode_array__hdc5d0ec20300a896($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $4 = 0, $6 = 0, $10 = 0, $23 = 0, $24 = 0, $25 = 0, $26 = 0, $5 = 0, $7 = 0, $8 = 0, $9 = 0, $11 = 0, $12 = 0, $13 = 0, $14 = 0, $30 = 0, $65 = 0, $72 = 0, $83 = 0, $87 = 0;
  $3 = global$0 - 176 | 0;
  global$0 = $3;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  HEAP32[($3 + 12 | 0) >> 2] = 0;
  HEAP32[($3 + 16 | 0) >> 2] = i64toi32_i32$0;
  $4 = 0;
  HEAP32[($3 + 8 | 0) >> 2] = HEAP32[(0 + 1059252 | 0) >> 2] | 0;
  $5 = ($3 + 96 | 0) + 8 | 0;
  HEAP32[$5 >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[($3 + 96 | 0) >> 2] = $30;
  HEAP32[($3 + 100 | 0) >> 2] = i64toi32_i32$1;
  alloc__raw_vec__RawVec_T_2cA___allocator__hac7e8c134c0e2bb4($3 + 96 | 0 | 0) | 0;
  $6 = HEAP32[($3 + 96 | 0) >> 2] | 0;
  $7 = HEAP32[$5 >> 2] | 0;
  $8 = $6 + Math_imul($7, 24) | 0;
  $9 = HEAP32[($3 + 100 | 0) >> 2] | 0;
  $1 = $6;
  label$1 : {
   label$2 : {
    if (!$7) {
     break label$2
    }
    $10 = $3 + 152 | 0 | 1 | 0;
    label$3 : {
     label$4 : while (1) {
      label$5 : {
       $1 = $6 + $4 | 0;
       $11 = HEAPU8[$1 >> 0] | 0;
       if (($11 | 0) != (6 | 0)) {
        break label$5
       }
       $1 = $1 + 24 | 0;
       break label$2;
      }
      $12 = ($3 + 24 | 0) + 15 | 0;
      i64toi32_i32$2 = $1 + 16 | 0;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $65 = i64toi32_i32$1;
      i64toi32_i32$1 = $12;
      $23 = $65;
      HEAP8[i64toi32_i32$1 >> 0] = $23;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $23 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $23 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $23 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      $13 = ($3 + 24 | 0) + 8 | 0;
      i64toi32_i32$2 = $1 + 9 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $72 = i64toi32_i32$0;
      i64toi32_i32$0 = $13;
      HEAP32[i64toi32_i32$0 >> 2] = $72;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $1 + 1 | 0;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $14 = i64toi32_i32$1;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 24 | 0) >> 2] = $14;
      HEAP32[($3 + 28 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$1 = $10;
      $24 = $14;
      HEAP8[i64toi32_i32$1 >> 0] = $24;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $24 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $24 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $24 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      i64toi32_i32$2 = $13;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $83 = i64toi32_i32$0;
      i64toi32_i32$0 = $10 + 8 | 0;
      $25 = $83;
      HEAP8[i64toi32_i32$0 >> 0] = $25;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $25 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $25 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $25 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      i64toi32_i32$2 = $12;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $87 = i64toi32_i32$1;
      i64toi32_i32$1 = $10 + 15 | 0;
      $26 = $87;
      HEAP8[i64toi32_i32$1 >> 0] = $26;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $26 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $26 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $26 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      HEAP8[($3 + 152 | 0) >> 0] = $11;
      cardano_serialization_lib__metadata__encode_json_value_to_metadatum__h64667ed57b92baeb($3 + 96 | 0 | 0, $3 + 152 | 0 | 0, $2 | 0);
      if ((HEAP32[($3 + 96 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      memcpy($3 + 48 | 0 | 0, $5 | 0, 48 | 0) | 0;
      $4 = $4 + 24 | 0;
      cardano_serialization_lib__metadata__MetadataList__add__h35547ae43e0f3988($3 + 8 | 0 | 0, $3 + 48 | 0 | 0);
      core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatum___headd2d1b596252cc($3 + 48 | 0 | 0);
      if (($1 + 24 | 0 | 0) != ($8 | 0)) {
       continue label$4
      }
      break label$4;
     };
     $1 = $8;
     break label$2;
    }
    $10 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($3 + 100 | 0) >> 2] | 0 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    HEAP32[($0 + 4 | 0) >> 2] = $10;
    core__ptr__drop_in_place__5bserde_json__value__Value_5d___h6abbb734efb35ee7($1 + 24 | 0 | 0, ((Math_imul($7, 24) - $4 | 0) + -24 | 0 | 0) / (24 | 0) | 0 | 0);
    HEAP32[($3 + 100 | 0) >> 2] = $9;
    HEAP32[($3 + 96 | 0) >> 2] = $6;
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h55384607e9cf45ad($3 + 96 | 0 | 0);
    label$6 : {
     $4 = HEAP32[($3 + 16 | 0) >> 2] | 0;
     if (!$4) {
      break label$6
     }
     $1 = HEAP32[($3 + 8 | 0) >> 2] | 0;
     $4 = Math_imul($4, 48);
     label$7 : while (1) {
      core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatum___headd2d1b596252cc_2($1 | 0);
      $1 = $1 + 48 | 0;
      $4 = $4 + -48 | 0;
      if ($4) {
       continue label$7
      }
      break label$7;
     };
    }
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h81b8a37e31f2de30($3 + 8 | 0 | 0);
    break label$1;
   }
   core__ptr__drop_in_place__5bserde_json__value__Value_5d___h6abbb734efb35ee7($1 | 0, ($8 - $1 | 0 | 0) / (24 | 0) | 0 | 0);
   HEAP32[($3 + 100 | 0) >> 2] = $9;
   HEAP32[($3 + 96 | 0) >> 2] = $6;
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h55384607e9cf45ad($3 + 96 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hf69db734dd831996($3 + 96 | 0 | 4 | 0 | 0, $3 + 8 | 0 | 0);
   HEAP32[($3 + 96 | 0) >> 2] = 1;
   memcpy($0 + 8 | 0 | 0, $3 + 96 | 0 | 0, 48 | 0) | 0;
   HEAP32[$0 >> 2] = 0;
   label$8 : {
    $4 = HEAP32[($3 + 16 | 0) >> 2] | 0;
    if (!$4) {
     break label$8
    }
    $1 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    $4 = Math_imul($4, 48);
    label$9 : while (1) {
     core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatum___headd2d1b596252cc_2($1 | 0);
     $1 = $1 + 48 | 0;
     $4 = $4 + -48 | 0;
     if ($4) {
      continue label$9
     }
     break label$9;
    };
   }
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h81b8a37e31f2de30($3 + 8 | 0 | 0);
  }
  global$0 = $3 + 176 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__SerializeEmbeddedGroup_20for_20cardano_serialization_lib__PoolParams___serialize_as_embedded_group__h6dc6f400e7f8e6e4($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, $3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $7 = 0, $18 = 0, $4 = 0, $5 = 0, $6 = 0, $22 = 0, $29 = 0, $32 = 0, $43 = 0, $47 = 0, $51 = 0, $54 = 0;
  $3 = global$0 - 80 | 0;
  global$0 = $3;
  $4 = $3 + 72 | 0;
  $18 = $1 + 124 | 0;
  HEAP32[$4 >> 2] = HEAPU8[$18 >> 0] | 0 | ((HEAPU8[($18 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($18 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($18 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $5 = $3 + 64 | 0;
  i64toi32_i32$2 = $1 + 116 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $22 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[i64toi32_i32$0 >> 2] = $22;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $6 = ($3 + 48 | 0) + 8 | 0;
  i64toi32_i32$2 = $1 + 108 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $29 = i64toi32_i32$1;
  i64toi32_i32$1 = $6;
  HEAP32[i64toi32_i32$1 >> 2] = $29;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 100 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 101 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 102 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 103 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 104 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 105 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 106 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 107 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $32 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[($3 + 48 | 0) >> 2] = $32;
  HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$1;
  cbor_event__se__Serializer_W___write_bytes__h5e3534de30c993f9($3 | 0, $2 | 0, $3 + 48 | 0 | 0);
  $7 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           label$10 : {
            label$11 : {
             if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
              break label$11
             }
             i64toi32_i32$2 = $1 + 152 | 0;
             i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             $43 = i64toi32_i32$1;
             i64toi32_i32$1 = $4;
             HEAP32[i64toi32_i32$1 >> 2] = $43;
             HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
             i64toi32_i32$2 = $1 + 144 | 0;
             i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             $47 = i64toi32_i32$0;
             i64toi32_i32$0 = $5;
             HEAP32[i64toi32_i32$0 >> 2] = $47;
             HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
             i64toi32_i32$2 = $1 + 136 | 0;
             i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             $51 = i64toi32_i32$1;
             i64toi32_i32$1 = $6;
             HEAP32[i64toi32_i32$1 >> 2] = $51;
             HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
             i64toi32_i32$2 = $1;
             i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 128 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 129 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 130 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 131 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 132 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 133 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 134 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 135 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
             $54 = i64toi32_i32$0;
             i64toi32_i32$0 = $3;
             HEAP32[($3 + 48 | 0) >> 2] = $54;
             HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$1;
             cbor_event__se__Serializer_W___write_bytes__h85f4434ac9a8a060($3 | 0, $2 | 0, $3 + 48 | 0 | 0);
             if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
              break label$10
             }
             i64toi32_i32$2 = $1;
             i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
             i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
             cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, i64toi32_i32$1 | 0, i64toi32_i32$0 | 0);
             $7 = 1;
             if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
              break label$9
             }
             i64toi32_i32$2 = $1;
             i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
             i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
             cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, i64toi32_i32$0 | 0, i64toi32_i32$1 | 0);
             if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
              break label$8
             }
             cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__UnitInterval___serialize__h073d853696277759($3 | 0, $1 + 16 | 0 | 0, $2 | 0);
             $7 = 1;
             if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
              break label$7
             }
             $cardano_serialization_lib__address__RewardAddress_20as_20cbor_event__se__Serialize___serialize__hd22cb20e67f69432($3 | 0, $1 + 160 | 0 | 0, $2 | 0);
             if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
              break label$6
             }
             cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__Ed25519KeyHashes___serialize__h8832695f5a55a024($3 | 0, $1 + 32 | 0 | 0, $2 | 0);
             $7 = 1;
             if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
              break label$5
             }
             cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__Relays___serialize__ha6bdc6309ff8ff6a($3 | 0, $1 + 44 | 0 | 0, $2 | 0);
             if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
              break label$4
             }
             if (HEAP32[($1 + 56 | 0) >> 2] | 0) {
              break label$3
             }
             HEAP8[($3 + 48 | 0) >> 0] = 1;
             cbor_event__se__Serializer_W___write_special__had0377f4ca98c84d($3 | 0, $2 | 0, $3 + 48 | 0 | 0);
             break label$2;
            }
            memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
            break label$1;
           }
           memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
           $7 = 1;
           break label$1;
          }
          memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
          break label$1;
         }
         memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
         $7 = 1;
         break label$1;
        }
        memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
        break label$1;
       }
       memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
       $7 = 1;
       break label$1;
      }
      memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
      break label$1;
     }
     memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
     $7 = 1;
     break label$1;
    }
    cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__PoolMetadata___serialize__h4d5353f47521faee($3 | 0, $1 + 56 | 0 | 0, $2 | 0);
   }
   $7 = 1;
   label$12 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
     break label$12
    }
    HEAP32[($0 + 4 | 0) >> 2] = $2;
    $7 = 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
  }
  HEAP32[$0 >> 2] = $7;
  global$0 = $3 + 80 | 0;
 }
 
 function cardano_serialization_lib__HeaderBody__new__h6bb28ac27adeb425($0, $1, $2, $3, $4, $5, $6, $7, $8, $9, $10, $11) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  $5 = $5 | 0;
  $6 = $6 | 0;
  $7 = $7 | 0;
  $8 = $8 | 0;
  $9 = $9 | 0;
  $10 = $10 | 0;
  $11 = $11 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $12 = 0, $50 = 0, $52 = 0, $53 = 0, $54 = 0, $55 = 0, $57 = 0, $58 = 0, $59 = 0, $60 = 0, $62 = 0, $63 = 0, $64 = 0, $65 = 0, $67 = 0, $68 = 0, $69 = 0, $13 = 0, $13$hi = 0, $27 = 0, $32 = 0, $37 = 0, $40 = 0, $43 = 0, $46 = 0, $51 = 0, $56 = 0, $61 = 0, $66 = 0, $71 = 0, $76 = 0, $97 = 0, $102 = 0, $107 = 0, $110 = 0, $114 = 0, $119 = 0, $124 = 0, $129 = 0, $14 = 0, $14$hi = 0, $146 = 0, $151 = 0, $156 = 0, $161 = 0, $164 = 0, $170 = 0, $176 = 0, $190 = 0, $196 = 0, $199 = 0;
  $12 = global$0 - 80 | 0;
  global$0 = $12;
  i64toi32_i32$0 = $T_20as_20core__convert__Into_U____into__h09f19f33dddda692($2 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $13 = i64toi32_i32$0;
  $13$hi = i64toi32_i32$1;
  $2 = 0;
  label$1 : {
   if ((HEAPU8[$3 >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   i64toi32_i32$2 = $3 + 25 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $27 = i64toi32_i32$1;
   i64toi32_i32$1 = $12 + 24 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $27;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $3 + 17 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $32 = i64toi32_i32$0;
   i64toi32_i32$0 = $12 + 16 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $32;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $3 + 9 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $37 = i64toi32_i32$1;
   i64toi32_i32$1 = $12 + 8 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $37;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $3;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $40 = i64toi32_i32$0;
   i64toi32_i32$0 = $12;
   HEAP32[i64toi32_i32$0 >> 2] = $40;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   $2 = 1;
  }
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $43 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  $50 = $43;
  HEAP8[(i64toi32_i32$1 + 209 | 0) >> 0] = $50;
  HEAP8[(i64toi32_i32$1 + 210 | 0) >> 0] = $50 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 211 | 0) >> 0] = $50 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 212 | 0) >> 0] = $50 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 213 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 214 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 215 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 216 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $46 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  $52 = $46;
  HEAP8[(i64toi32_i32$0 + 241 | 0) >> 0] = $52;
  HEAP8[(i64toi32_i32$0 + 242 | 0) >> 0] = $52 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 243 | 0) >> 0] = $52 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 244 | 0) >> 0] = $52 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 245 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 246 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 247 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 248 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $4 + 24 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $51 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 233 | 0;
  $53 = $51;
  HEAP8[i64toi32_i32$1 >> 0] = $53;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $53 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $53 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $53 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $4 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $56 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 225 | 0;
  $54 = $56;
  HEAP8[i64toi32_i32$0 >> 0] = $54;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $54 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $54 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $54 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $4 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $61 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 217 | 0;
  $55 = $61;
  HEAP8[i64toi32_i32$1 >> 0] = $55;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $55 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $55 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $55 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $5 + 8 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $66 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 249 | 0;
  $57 = $66;
  HEAP8[i64toi32_i32$0 >> 0] = $57;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $57 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $57 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $57 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $5 + 16 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $71 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 257 | 0;
  $58 = $71;
  HEAP8[i64toi32_i32$1 >> 0] = $58;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $58 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $58 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $58 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $5 + 24 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $76 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 265 | 0;
  $59 = $76;
  HEAP8[i64toi32_i32$0 >> 0] = $59;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $59 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $59 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $59 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($12 + 32 | 0 | 0, $6 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3(($12 + 32 | 0) + 12 | 0 | 0, $6 + 12 | 0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($12 + 56 | 0 | 0, $7 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3(($12 + 56 | 0) + 12 | 0 | 0, $7 + 12 | 0 | 0);
  i64toi32_i32$2 = $9 + 24 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $97 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 297 | 0;
  $60 = $97;
  HEAP8[i64toi32_i32$1 >> 0] = $60;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $60 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $60 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $60 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $9 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $102 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 289 | 0;
  $62 = $102;
  HEAP8[i64toi32_i32$0 >> 0] = $62;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $62 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $62 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $62 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $9 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $107 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 281 | 0;
  $63 = $107;
  HEAP8[i64toi32_i32$1 >> 0] = $63;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $63 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $63 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $63 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $9;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $110 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  $64 = $110;
  HEAP8[(i64toi32_i32$0 + 273 | 0) >> 0] = $64;
  HEAP8[(i64toi32_i32$0 + 274 | 0) >> 0] = $64 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 275 | 0) >> 0] = $64 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 276 | 0) >> 0] = $64 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 277 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 278 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 279 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 280 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $10;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $114 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 72 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $114;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = i64toi32_i32$2 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $119 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 80 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $119;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $10 + 24 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $124 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 88 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $124;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $10 + 32 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $129 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 96 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $129;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $10;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$1;
  $14$hi = i64toi32_i32$0;
  memcpy($0 + 104 | 0 | 0, i64toi32_i32$2 + 40 | 0 | 0, 64 | 0) | 0;
  HEAP32[($0 + 8 | 0) >> 2] = $1;
  HEAP8[($0 + 176 | 0) >> 0] = $2;
  i64toi32_i32$0 = $13$hi;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $13;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $12;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $146 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 177 | 0;
  $65 = $146;
  HEAP8[i64toi32_i32$0 >> 0] = $65;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $65 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $65 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $65 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $151 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 185 | 0;
  $67 = $151;
  HEAP8[i64toi32_i32$1 >> 0] = $67;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $67 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $67 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $67 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $12 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $156 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 193 | 0;
  $68 = $156;
  HEAP8[i64toi32_i32$0 >> 0] = $68;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $68 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $68 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $68 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $12 + 24 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $161 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 201 | 0;
  $69 = $161;
  HEAP8[i64toi32_i32$1 >> 0] = $69;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $69 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $69 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $69 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $12;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
  $164 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = $164;
  HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = (i64toi32_i32$2 + 32 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $170 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 20 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $170;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = ($12 + 32 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $176 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 28 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $176;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $11;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $13 = i64toi32_i32$1;
  $13$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $14$hi;
  i64toi32_i32$1 = $0;
  HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] = $14;
  HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $13$hi;
  HEAP32[(i64toi32_i32$1 + 168 | 0) >> 2] = $13;
  HEAP32[(i64toi32_i32$1 + 172 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 60 | 0) >> 2] = $8;
  i64toi32_i32$2 = ($12 + 56 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $190 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 52 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $190;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = ($12 + 56 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $196 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 44 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $196;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $12;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
  $199 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 36 | 0) >> 2] = $199;
  HEAP32[(i64toi32_i32$0 + 40 | 0) >> 2] = i64toi32_i32$1;
  global$0 = i64toi32_i32$2 + 80 | 0;
 }
 
 function cardano_serialization_lib__HeaderBody__new_headerbody__hb0522221521a757d($0, $1, $2, $3, $4, $5, $6, $7, $8, $9, $10, $11) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  $5 = $5 | 0;
  $6 = $6 | 0;
  $7 = $7 | 0;
  $8 = $8 | 0;
  $9 = $9 | 0;
  $10 = $10 | 0;
  $11 = $11 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $12 = 0, $50 = 0, $52 = 0, $53 = 0, $54 = 0, $55 = 0, $57 = 0, $58 = 0, $59 = 0, $60 = 0, $62 = 0, $63 = 0, $64 = 0, $65 = 0, $67 = 0, $68 = 0, $69 = 0, $13 = 0, $13$hi = 0, $27 = 0, $32 = 0, $37 = 0, $40 = 0, $43 = 0, $46 = 0, $51 = 0, $56 = 0, $61 = 0, $66 = 0, $71 = 0, $76 = 0, $97 = 0, $102 = 0, $107 = 0, $110 = 0, $114 = 0, $119 = 0, $124 = 0, $129 = 0, $14 = 0, $14$hi = 0, $146 = 0, $151 = 0, $156 = 0, $161 = 0, $164 = 0, $170 = 0, $176 = 0, $190 = 0, $196 = 0, $199 = 0;
  $12 = global$0 - 80 | 0;
  global$0 = $12;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $13 = i64toi32_i32$0;
  $13$hi = i64toi32_i32$1;
  $2 = 0;
  label$1 : {
   if ((HEAPU8[$3 >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   i64toi32_i32$2 = $3 + 25 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $27 = i64toi32_i32$1;
   i64toi32_i32$1 = $12 + 24 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $27;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $3 + 17 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $32 = i64toi32_i32$0;
   i64toi32_i32$0 = $12 + 16 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $32;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $3 + 9 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $37 = i64toi32_i32$1;
   i64toi32_i32$1 = $12 + 8 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $37;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $3;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $40 = i64toi32_i32$0;
   i64toi32_i32$0 = $12;
   HEAP32[i64toi32_i32$0 >> 2] = $40;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   $2 = 1;
  }
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $43 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  $50 = $43;
  HEAP8[(i64toi32_i32$1 + 209 | 0) >> 0] = $50;
  HEAP8[(i64toi32_i32$1 + 210 | 0) >> 0] = $50 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 211 | 0) >> 0] = $50 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 212 | 0) >> 0] = $50 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 213 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 214 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 215 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 216 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $46 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  $52 = $46;
  HEAP8[(i64toi32_i32$0 + 241 | 0) >> 0] = $52;
  HEAP8[(i64toi32_i32$0 + 242 | 0) >> 0] = $52 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 243 | 0) >> 0] = $52 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 244 | 0) >> 0] = $52 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 245 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 246 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 247 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 248 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $4 + 24 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $51 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 233 | 0;
  $53 = $51;
  HEAP8[i64toi32_i32$1 >> 0] = $53;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $53 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $53 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $53 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $4 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $56 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 225 | 0;
  $54 = $56;
  HEAP8[i64toi32_i32$0 >> 0] = $54;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $54 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $54 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $54 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $4 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $61 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 217 | 0;
  $55 = $61;
  HEAP8[i64toi32_i32$1 >> 0] = $55;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $55 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $55 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $55 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $5 + 8 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $66 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 249 | 0;
  $57 = $66;
  HEAP8[i64toi32_i32$0 >> 0] = $57;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $57 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $57 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $57 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $5 + 16 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $71 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 257 | 0;
  $58 = $71;
  HEAP8[i64toi32_i32$1 >> 0] = $58;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $58 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $58 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $58 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $5 + 24 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $76 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 265 | 0;
  $59 = $76;
  HEAP8[i64toi32_i32$0 >> 0] = $59;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $59 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $59 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $59 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($12 + 32 | 0 | 0, $6 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3(($12 + 32 | 0) + 12 | 0 | 0, $6 + 12 | 0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($12 + 56 | 0 | 0, $7 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3(($12 + 56 | 0) + 12 | 0 | 0, $7 + 12 | 0 | 0);
  i64toi32_i32$2 = $9 + 24 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $97 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 297 | 0;
  $60 = $97;
  HEAP8[i64toi32_i32$1 >> 0] = $60;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $60 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $60 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $60 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $9 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $102 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 289 | 0;
  $62 = $102;
  HEAP8[i64toi32_i32$0 >> 0] = $62;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $62 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $62 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $62 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $9 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $107 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 281 | 0;
  $63 = $107;
  HEAP8[i64toi32_i32$1 >> 0] = $63;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $63 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $63 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $63 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $9;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $110 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  $64 = $110;
  HEAP8[(i64toi32_i32$0 + 273 | 0) >> 0] = $64;
  HEAP8[(i64toi32_i32$0 + 274 | 0) >> 0] = $64 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 275 | 0) >> 0] = $64 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 276 | 0) >> 0] = $64 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 277 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 278 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 279 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 280 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $10;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $114 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 72 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $114;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = i64toi32_i32$2 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $119 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 80 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $119;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $10 + 24 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $124 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 88 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $124;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $10 + 32 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $129 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 96 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $129;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $10;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$1;
  $14$hi = i64toi32_i32$0;
  memcpy($0 + 104 | 0 | 0, i64toi32_i32$2 + 40 | 0 | 0, 64 | 0) | 0;
  HEAP32[($0 + 8 | 0) >> 2] = $1;
  HEAP8[($0 + 176 | 0) >> 0] = $2;
  i64toi32_i32$0 = $13$hi;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $13;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $12;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $146 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 177 | 0;
  $65 = $146;
  HEAP8[i64toi32_i32$0 >> 0] = $65;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $65 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $65 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $65 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $151 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 185 | 0;
  $67 = $151;
  HEAP8[i64toi32_i32$1 >> 0] = $67;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $67 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $67 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $67 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $12 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $156 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 193 | 0;
  $68 = $156;
  HEAP8[i64toi32_i32$0 >> 0] = $68;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $68 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $68 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $68 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $12 + 24 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $161 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 201 | 0;
  $69 = $161;
  HEAP8[i64toi32_i32$1 >> 0] = $69;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $69 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $69 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $69 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $12;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
  $164 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = $164;
  HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = (i64toi32_i32$2 + 32 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $170 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 20 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $170;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = ($12 + 32 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $176 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 28 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $176;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $11;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $13 = i64toi32_i32$1;
  $13$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $14$hi;
  i64toi32_i32$1 = $0;
  HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] = $14;
  HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $13$hi;
  HEAP32[(i64toi32_i32$1 + 168 | 0) >> 2] = $13;
  HEAP32[(i64toi32_i32$1 + 172 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 60 | 0) >> 2] = $8;
  i64toi32_i32$2 = ($12 + 56 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $190 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 52 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $190;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = ($12 + 56 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $196 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 44 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $196;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $12;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
  $199 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 36 | 0) >> 2] = $199;
  HEAP32[(i64toi32_i32$0 + 40 | 0) >> 2] = i64toi32_i32$1;
  global$0 = i64toi32_i32$2 + 80 | 0;
 }
 
 function $std__io__error__ErrorKind_20as_20core__fmt__Debug___fmt__hfd7e1b5a99fa67aa($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    switch (HEAPU8[$0 >> 0] | 0 | 0) {
    default:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1144991 | 0, 8 | 0);
     break label$1;
    case 1:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1144975 | 0, 16 | 0);
     break label$1;
    case 2:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1144958 | 0, 17 | 0);
     break label$1;
    case 3:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1144943 | 0, 15 | 0);
     break label$1;
    case 4:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1144928 | 0, 15 | 0);
     break label$1;
    case 5:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1144910 | 0, 18 | 0);
     break label$1;
    case 6:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1144893 | 0, 17 | 0);
     break label$1;
    case 7:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1144881 | 0, 12 | 0);
     break label$1;
    case 8:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1144872 | 0, 9 | 0);
     break label$1;
    case 9:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1144856 | 0, 16 | 0);
     break label$1;
    case 10:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1144845 | 0, 11 | 0);
     break label$1;
    case 11:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1144835 | 0, 10 | 0);
     break label$1;
    case 12:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1144822 | 0, 13 | 0);
     break label$1;
    case 13:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1144812 | 0, 10 | 0);
     break label$1;
    case 14:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1144799 | 0, 13 | 0);
     break label$1;
    case 15:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1144787 | 0, 12 | 0);
     break label$1;
    case 16:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1144770 | 0, 17 | 0);
     break label$1;
    case 17:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1144752 | 0, 18 | 0);
     break label$1;
    case 18:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1144738 | 0, 14 | 0);
     break label$1;
    case 19:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1144716 | 0, 22 | 0);
     break label$1;
    case 20:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1144704 | 0, 12 | 0);
     break label$1;
    case 21:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1144693 | 0, 11 | 0);
     break label$1;
    case 22:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1144685 | 0, 8 | 0);
     break label$1;
    case 23:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1144676 | 0, 9 | 0);
     break label$1;
    case 24:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1144665 | 0, 11 | 0);
     break label$1;
    case 25:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1144654 | 0, 11 | 0);
     break label$1;
    case 26:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1144631 | 0, 23 | 0);
     break label$1;
    case 27:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1144619 | 0, 12 | 0);
     break label$1;
    case 28:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1144607 | 0, 12 | 0);
     break label$1;
    case 29:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1144589 | 0, 18 | 0);
     break label$1;
    case 30:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1144581 | 0, 8 | 0);
     break label$1;
    case 31:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1144567 | 0, 14 | 0);
     break label$1;
    case 32:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1144555 | 0, 12 | 0);
     break label$1;
    case 33:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1144540 | 0, 15 | 0);
     break label$1;
    case 34:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1144521 | 0, 19 | 0);
     break label$1;
    case 35:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1144510 | 0, 11 | 0);
     break label$1;
    case 36:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1144505 | 0, 5 | 0);
     break label$1;
    case 37:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1144492 | 0, 13 | 0);
     break label$1;
    case 38:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1144388 | 0, 11 | 0);
     break label$1;
    case 39:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1144481 | 0, 11 | 0);
     break label$1;
    case 40:
     break label$2;
    };
   }
   core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1144468 | 0, 13 | 0);
  }
  $0 = core__fmt__builders__DebugTuple__finish__hc3c3f1efaa75a6e2($2 | 0) | 0;
  global$0 = $2 + 16 | 0;
  return $0 | 0;
 }
 
 function cardano_serialization_lib__tx_builder__TransactionBuilder__add_metadatum__hc8424e4cee001d9e($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, $4 = 0, i64toi32_i32$1 = 0, $6 = 0, $6$hi = 0, $7 = 0, $7$hi = 0, $46 = 0, $49 = 0, $62 = 0, $68 = 0, $71 = 0, $75 = 0, $5 = 0, $114 = 0, $128 = 0, $134 = 0, $137 = 0;
  $3 = global$0 - 144 | 0;
  global$0 = $3;
  i64toi32_i32$0 = 0;
  $6 = 0;
  $6$hi = i64toi32_i32$0;
  label$1 : {
   i64toi32_i32$2 = $0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 328 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 332 | 0) >> 2] | 0;
   $7 = i64toi32_i32$0;
   $7$hi = i64toi32_i32$1;
   i64toi32_i32$2 = i64toi32_i32$0;
   i64toi32_i32$0 = 0;
   i64toi32_i32$3 = 1;
   if ((i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$0 | 0) | 0) {
    break label$1
   }
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if (HEAP32[($0 + 356 | 0) >> 2] | 0) {
        break label$5
       }
       HEAP32[($3 + 124 | 0) >> 2] = 0;
       $4 = $3 + 64 | 0;
       break label$4;
      }
      $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h44c6d4679ef9fae6($3 + 104 | 0 | 0, $0 + 336 | 0 | 0);
      $4 = $3 + 64 | 0;
      if (HEAP32[($3 + 124 | 0) >> 2] | 0) {
       break label$3
      }
     }
     HEAP32[($4 + 20 | 0) >> 2] = 0;
     break label$2;
    }
    $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h44c6d4679ef9fae6($4 | 0, $3 + 104 | 0 | 0);
   }
   core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__metadata__GeneralTransactionMetadata____h37a091753d7f028f_1($3 + 104 | 0 | 0);
   i64toi32_i32$2 = 0;
   $6 = 1;
   $6$hi = i64toi32_i32$2;
  }
  i64toi32_i32$2 = $6$hi;
  i64toi32_i32$1 = $3;
  HEAP32[($3 + 56 | 0) >> 2] = $6;
  HEAP32[($3 + 60 | 0) >> 2] = i64toi32_i32$2;
  $4 = 0;
  HEAP32[($3 + 124 | 0) >> 2] = 0;
  label$6 : {
   label$7 : {
    i64toi32_i32$2 = $7$hi;
    i64toi32_i32$3 = $7;
    i64toi32_i32$1 = 0;
    i64toi32_i32$0 = 0;
    if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
     break label$7
    }
    i64toi32_i32$0 = $3 + 136 | 0;
    i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
    $46 = i64toi32_i32$3;
    i64toi32_i32$3 = $3 + 24 | 0;
    HEAP32[i64toi32_i32$3 >> 2] = $46;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$0 = $3;
    i64toi32_i32$2 = HEAP32[($3 + 128 | 0) >> 2] | 0;
    i64toi32_i32$3 = HEAP32[($3 + 132 | 0) >> 2] | 0;
    $49 = i64toi32_i32$2;
    i64toi32_i32$2 = $3;
    HEAP32[($3 + 16 | 0) >> 2] = $49;
    HEAP32[($3 + 20 | 0) >> 2] = i64toi32_i32$3;
    break label$6;
   }
   HEAP32[(($3 + 32 | 0) + 16 | 0) >> 2] = HEAP32[($3 + 80 | 0) >> 2] | 0;
   i64toi32_i32$0 = ($3 + 56 | 0) + 16 | 0;
   i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $62 = i64toi32_i32$3;
   i64toi32_i32$3 = ($3 + 32 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$3 >> 2] = $62;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = $3 + 96 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $68 = i64toi32_i32$2;
   i64toi32_i32$2 = ($3 + 16 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $68;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$0 = $3;
   i64toi32_i32$3 = HEAP32[($3 + 64 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($3 + 68 | 0) >> 2] | 0;
   $71 = i64toi32_i32$3;
   i64toi32_i32$3 = $3;
   HEAP32[($3 + 32 | 0) >> 2] = $71;
   HEAP32[($3 + 36 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = $3 + 88 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $75 = i64toi32_i32$2;
   i64toi32_i32$2 = $3;
   HEAP32[($3 + 16 | 0) >> 2] = $75;
   HEAP32[($3 + 20 | 0) >> 2] = i64toi32_i32$3;
   $4 = HEAP32[($3 + 84 | 0) >> 2] | 0;
   core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__metadata__GeneralTransactionMetadata____h37a091753d7f028f_1($3 + 104 | 0 | 0);
  }
  std__thread__local__LocalKey_T___with__h4cd07b14a44a727e($3 | 0, 1060968 | 0);
  i64toi32_i32$0 = $3;
  i64toi32_i32$3 = HEAP32[$3 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[($3 + 4 | 0) >> 2] | 0;
  $6 = i64toi32_i32$3;
  $6$hi = i64toi32_i32$2;
  i64toi32_i32$0 = $3;
  i64toi32_i32$2 = HEAP32[($3 + 8 | 0) >> 2] | 0;
  i64toi32_i32$3 = HEAP32[($3 + 12 | 0) >> 2] | 0;
  $7 = i64toi32_i32$2;
  $7$hi = i64toi32_i32$3;
  $5 = hashbrown__raw__generic__Group__static_empty__hc5a7932fe1bdb1f1() | 0;
  i64toi32_i32$2 = ($3 + 56 | 0) + 24 | 0;
  i64toi32_i32$3 = 0;
  HEAP32[i64toi32_i32$2 >> 2] = 0;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
  HEAP32[(($3 + 56 | 0) + 20 | 0) >> 2] = $5;
  HEAP32[($3 + 72 | 0) >> 2] = 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$3 = 0;
  HEAP32[($3 + 88 | 0) >> 2] = 0;
  HEAP32[($3 + 92 | 0) >> 2] = i64toi32_i32$3;
  i64toi32_i32$3 = $7$hi;
  i64toi32_i32$2 = $3;
  HEAP32[($3 + 64 | 0) >> 2] = $7;
  HEAP32[($3 + 68 | 0) >> 2] = i64toi32_i32$3;
  i64toi32_i32$3 = $6$hi;
  i64toi32_i32$2 = $3;
  HEAP32[($3 + 56 | 0) >> 2] = $6;
  HEAP32[($3 + 60 | 0) >> 2] = i64toi32_i32$3;
  label$8 : {
   label$9 : {
    if ($4) {
     break label$9
    }
    memcpy($3 + 104 | 0 | 0, $3 + 56 | 0 | 0, 40 | 0) | 0;
    break label$8;
   }
   HEAP32[(($3 + 104 | 0) + 20 | 0) >> 2] = $4;
   i64toi32_i32$0 = $3;
   i64toi32_i32$3 = HEAP32[($3 + 16 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($3 + 20 | 0) >> 2] | 0;
   $114 = i64toi32_i32$3;
   i64toi32_i32$3 = ($3 + 104 | 0) + 24 | 0;
   HEAP32[i64toi32_i32$3 >> 2] = $114;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
   HEAP32[(($3 + 104 | 0) + 16 | 0) >> 2] = HEAP32[(($3 + 32 | 0) + 16 | 0) >> 2] | 0;
   i64toi32_i32$0 = ($3 + 32 | 0) + 8 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $128 = i64toi32_i32$2;
   i64toi32_i32$2 = ($3 + 104 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $128;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$0 = ($3 + 16 | 0) + 8 | 0;
   i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $134 = i64toi32_i32$3;
   i64toi32_i32$3 = $3 + 136 | 0;
   HEAP32[i64toi32_i32$3 >> 2] = $134;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = $3;
   i64toi32_i32$2 = HEAP32[($3 + 32 | 0) >> 2] | 0;
   i64toi32_i32$3 = HEAP32[($3 + 36 | 0) >> 2] | 0;
   $137 = i64toi32_i32$2;
   i64toi32_i32$2 = $3;
   HEAP32[($3 + 104 | 0) >> 2] = $137;
   HEAP32[($3 + 108 | 0) >> 2] = i64toi32_i32$3;
   $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__he275f3eb7df08493($3 + 56 | 0 | 0);
   if (!(HEAP32[($3 + 72 | 0) >> 2] | 0)) {
    break label$8
   }
   hashbrown__raw__RawTable_T_2cA___free_buckets__hfa29170569415d6b(($3 + 56 | 0) + 16 | 0 | 0);
  }
  cardano_serialization_lib__metadata__GeneralTransactionMetadata__insert__h12cd6f278bd1aa86($3 + 56 | 0 | 0, $3 + 104 | 0 | 0, $1 | 0, $2 | 0);
  label$10 : {
   if ((HEAP32[($3 + 56 | 0) >> 2] | 0 | 0) == (5 | 0)) {
    break label$10
   }
   core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatum___headd2d1b596252cc_1($3 + 56 | 0 | 0);
  }
  cardano_serialization_lib__tx_builder__TransactionBuilder__set_metadata__hf30b1ac4dad4b2e1($0 | 0, $3 + 104 | 0 | 0);
  $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__he275f3eb7df08493($3 + 104 | 0 | 0);
  label$11 : {
   if (!(HEAP32[($3 + 120 | 0) >> 2] | 0)) {
    break label$11
   }
   hashbrown__raw__RawTable_T_2cA___free_buckets__hfa29170569415d6b($3 + 120 | 0 | 0);
  }
  global$0 = $3 + 144 | 0;
 }
 
 function $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__clone_subtree__hc4de5541b53cd546($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, $5 = 0, i64toi32_i32$1 = 0, $6 = 0, $7 = 0, $4 = 0, i64toi32_i32$2 = 0, $9 = 0, $8 = 0, $11 = 0, $41 = 0, $49 = 0, $12 = 0, $12$hi = 0, $10 = 0, $139 = 0, $171 = 0;
  $3 = global$0 - 80 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     if ($1) {
      break label$3
     }
     $1 = alloc__boxed__Box_T_2cA___new_uninit_in__h0005f5c05c0883da() | 0;
     HEAP16[($1 + 226 | 0) >> 1] = 0;
     HEAP32[($1 + 88 | 0) >> 2] = 0;
     $4 = 0;
     label$4 : {
      if (!(HEAPU16[($2 + 226 | 0) >> 1] | 0)) {
       break label$4
      }
      $5 = $2 + 92 | 0;
      $4 = 0;
      $6 = $2;
      label$5 : while (1) {
       $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($3 + 64 | 0 | 0, $5 | 0);
       $7 = HEAPU16[($1 + 226 | 0) >> 1] | 0;
       if ($7 >>> 0 >= 11 >>> 0) {
        break label$1
       }
       HEAP16[($1 + 226 | 0) >> 1] = $7 + 1 | 0;
       i64toi32_i32$2 = $6;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $41 = i64toi32_i32$0;
       i64toi32_i32$0 = $1 + ($7 << 3 | 0) | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $41;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       $7 = $1 + Math_imul($7, 12) | 0;
       i64toi32_i32$2 = $3;
       i64toi32_i32$1 = HEAP32[($3 + 64 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[($3 + 68 | 0) >> 2] | 0;
       $49 = i64toi32_i32$1;
       i64toi32_i32$1 = $7 + 92 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $49;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       HEAP32[($7 + 100 | 0) >> 2] = HEAP32[(($3 + 64 | 0) + 8 | 0) >> 2] | 0;
       $5 = $5 + 12 | 0;
       $6 = $6 + 8 | 0;
       $4 = $4 + 1 | 0;
       if ($4 >>> 0 < (HEAPU16[($2 + 226 | 0) >> 1] | 0) >>> 0) {
        continue label$5
       }
       break label$5;
      };
     }
     HEAP32[($0 + 8 | 0) >> 2] = $4;
     HEAP32[($0 + 4 | 0) >> 2] = $1;
     HEAP32[$0 >> 2] = 0;
     break label$2;
    }
    $8 = $1 + -1 | 0;
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__clone_subtree__hc4de5541b53cd546($3 + 8 | 0 | 0, $8 | 0, HEAP32[($2 + 232 | 0) >> 2] | 0 | 0);
    label$6 : {
     label$7 : {
      $5 = HEAP32[($3 + 12 | 0) >> 2] | 0;
      if (!$5) {
       break label$7
      }
      $6 = (HEAP32[($3 + 8 | 0) >> 2] | 0) + 1 | 0;
      break label$6;
     }
     $5 = alloc__boxed__Box_T_2cA___new_uninit_in__h0005f5c05c0883da() | 0;
     HEAP16[($5 + 226 | 0) >> 1] = 0;
     HEAP32[($5 + 88 | 0) >> 2] = 0;
     $6 = 1;
    }
    $1 = alloc__boxed__Box_T_2cA___new_uninit_in__h2752ff92eca24da1() | 0;
    HEAP32[($1 + 232 | 0) >> 2] = $5;
    $7 = 0;
    HEAP16[($1 + 226 | 0) >> 1] = 0;
    HEAP32[($1 + 88 | 0) >> 2] = 0;
    HEAP16[($5 + 224 | 0) >> 1] = 0;
    HEAP32[($5 + 88 | 0) >> 2] = $1;
    HEAP32[($3 + 12 | 0) >> 2] = $1;
    HEAP32[($3 + 8 | 0) >> 2] = $6;
    HEAP32[($3 + 28 | 0) >> 2] = $1;
    HEAP32[($3 + 24 | 0) >> 2] = $6;
    label$8 : {
     if (!(HEAPU16[($2 + 226 | 0) >> 1] | 0)) {
      break label$8
     }
     $5 = $2 + 92 | 0;
     $6 = $2 + 236 | 0;
     $9 = HEAP32[($3 + 16 | 0) >> 2] | 0;
     $4 = $2;
     label$9 : while (1) {
      $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($3 + 32 | 0 | 0, $5 | 0);
      i64toi32_i32$2 = $4;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $12 = i64toi32_i32$0;
      $12$hi = i64toi32_i32$1;
      $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__clone_subtree__hc4de5541b53cd546($3 + 48 | 0 | 0, $8 | 0, HEAP32[$6 >> 2] | 0 | 0);
      $10 = HEAP32[($3 + 56 | 0) >> 2] | 0;
      $1 = HEAP32[($3 + 52 | 0) >> 2] | 0;
      $11 = HEAP32[($3 + 48 | 0) >> 2] | 0;
      HEAP32[(($3 + 64 | 0) + 8 | 0) >> 2] = HEAP32[(($3 + 32 | 0) + 8 | 0) >> 2] | 0;
      i64toi32_i32$2 = $3;
      i64toi32_i32$1 = HEAP32[($3 + 32 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($3 + 36 | 0) >> 2] | 0;
      $139 = i64toi32_i32$1;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 64 | 0) >> 2] = $139;
      HEAP32[($3 + 68 | 0) >> 2] = i64toi32_i32$0;
      $7 = $7 + 1 | 0;
      label$10 : {
       if ($1) {
        break label$10
       }
       $11 = 0;
       $1 = alloc__boxed__Box_T_2cA___new_uninit_in__h0005f5c05c0883da() | 0;
       HEAP16[($1 + 226 | 0) >> 1] = 0;
       HEAP32[($1 + 88 | 0) >> 2] = 0;
      }
      i64toi32_i32$0 = $12$hi;
      alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal___push__h6e96e9816acb473b($3 + 24 | 0 | 0, $3 + 64 | 0 | 0, $12 | 0, i64toi32_i32$0 | 0, $11 | 0, $1 | 0);
      $5 = $5 + 12 | 0;
      $4 = $4 + 8 | 0;
      $6 = $6 + 4 | 0;
      $9 = ($10 + $9 | 0) + 1 | 0;
      if ($7 >>> 0 < (HEAPU16[($2 + 226 | 0) >> 1] | 0) >>> 0) {
       continue label$9
      }
      break label$9;
     };
     HEAP32[($3 + 16 | 0) >> 2] = $9;
    }
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
    $171 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[i64toi32_i32$0 >> 2] = $171;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[(($3 + 8 | 0) + 8 | 0) >> 2] | 0;
   }
   global$0 = $3 + 80 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1048619 | 0, 32 | 0, 1048744 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__BalancingContext_K_2cV___bulk_steal_left__hda63a524cf155183($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, $3 = 0, i64toi32_i32$0 = 0, $8 = 0, $7 = 0, $6 = 0, i64toi32_i32$2 = 0, $9 = 0, $11 = 0, $14 = 0, $2 = 0, $4 = 0, $10 = 0, $5 = 0, $17 = 0, $12 = 0, $13 = 0, $15 = 0, $16 = 0, $16$hi = 0, $17$hi = 0, $122 = 0, $18 = 0, $18$hi = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if (!$1) {
       break label$4
      }
      $3 = HEAP32[($0 + 24 | 0) >> 2] | 0;
      $4 = HEAPU16[($3 + 226 | 0) >> 1] | 0;
      $5 = $4 + $1 | 0;
      if ($5 >>> 0 > 11 >>> 0) {
       break label$3
      }
      label$5 : {
       label$6 : {
        label$7 : {
         $6 = HEAP32[($0 + 16 | 0) >> 2] | 0;
         $7 = HEAPU16[($6 + 226 | 0) >> 1] | 0;
         if ($7 >>> 0 < $1 >>> 0) {
          break label$7
         }
         $8 = $7 - $1 | 0;
         HEAP16[($6 + 226 | 0) >> 1] = $8;
         HEAP16[($3 + 226 | 0) >> 1] = $5;
         $9 = $3 + 92 | 0;
         memmove($9 + Math_imul($1, 12) | 0 | 0, $9 | 0, Math_imul($4, 12) | 0) | 0;
         memmove($3 + ($1 << 3 | 0) | 0 | 0, $3 | 0, $4 << 3 | 0 | 0) | 0;
         $10 = $8 + 1 | 0;
         $7 = $7 - $10 | 0;
         if (($7 | 0) != ($1 + -1 | 0 | 0)) {
          break label$2
         }
         $11 = $6 + 92 | 0;
         $12 = Math_imul($7, 12);
         memcpy($9 | 0, $11 + Math_imul($10, 12) | 0 | 0, $12 | 0) | 0;
         $9 = $7 << 3 | 0;
         $7 = memcpy($3 | 0, $6 + ($10 << 3 | 0) | 0 | 0, $9 | 0) | 0;
         i64toi32_i32$2 = $6 + ($8 << 3 | 0) | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $16 = i64toi32_i32$0;
         $16$hi = i64toi32_i32$1;
         $3 = $11 + Math_imul($8, 12) | 0;
         $8 = HEAP32[($3 + 8 | 0) >> 2] | 0;
         $11 = HEAP32[($0 + 4 | 0) >> 2] | 0;
         $13 = HEAP32[($0 + 8 | 0) >> 2] | 0;
         $14 = $11 + Math_imul($13, 12) | 0;
         $15 = $14 + 92 | 0;
         i64toi32_i32$2 = $15;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $17 = i64toi32_i32$1;
         $17$hi = i64toi32_i32$0;
         i64toi32_i32$2 = $3;
         i64toi32_i32$0 = HEAP32[$3 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[($3 + 4 | 0) >> 2] | 0;
         $122 = i64toi32_i32$0;
         i64toi32_i32$0 = $15;
         HEAP32[i64toi32_i32$0 >> 2] = $122;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         $14 = $14 + 100 | 0;
         $3 = HEAP32[$14 >> 2] | 0;
         HEAP32[$14 >> 2] = $8;
         HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] = $3;
         $8 = $11 + ($13 << 3 | 0) | 0;
         i64toi32_i32$2 = $8;
         i64toi32_i32$1 = HEAP32[$8 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[($8 + 4 | 0) >> 2] | 0;
         $18 = i64toi32_i32$1;
         $18$hi = i64toi32_i32$0;
         i64toi32_i32$0 = $16$hi;
         i64toi32_i32$1 = $8;
         HEAP32[i64toi32_i32$1 >> 2] = $16;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$0 = $17$hi;
         i64toi32_i32$1 = $2;
         HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $17;
         HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
         HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $3;
         HEAP32[i64toi32_i32$1 >> 2] = $17;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
         $8 = $7 + $12 | 0;
         HEAP32[($8 + 100 | 0) >> 2] = $3;
         i64toi32_i32$1 = $8 + 92 | 0;
         HEAP32[i64toi32_i32$1 >> 2] = $17;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$0 = $18$hi;
         i64toi32_i32$1 = $7 + $9 | 0;
         HEAP32[i64toi32_i32$1 >> 2] = $18;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
         $3 = HEAP32[($0 + 12 | 0) >> 2] | 0;
         if (HEAP32[($0 + 20 | 0) >> 2] | 0) {
          break label$6
         }
         if (!$3) {
          break label$5
         }
         break label$1;
        }
        core__panicking__panic__h2fd385a887c8bf13(1049260 | 0, 39 | 0, 1049300 | 0);
        abort();
       }
       if (!$3) {
        break label$1
       }
       $0 = $7 + 232 | 0;
       $1 = $1 << 2 | 0;
       memmove($0 + $1 | 0 | 0, $0 | 0, ($4 << 2 | 0) + 4 | 0 | 0) | 0;
       memcpy($0 | 0, ($6 + ($10 << 2 | 0) | 0) + 232 | 0 | 0, $1 | 0) | 0;
       $6 = $5 + 1 | 0;
       $1 = 0;
       label$8 : while (1) {
        $3 = HEAP32[$0 >> 2] | 0;
        HEAP16[($3 + 224 | 0) >> 1] = $1;
        HEAP32[($3 + 88 | 0) >> 2] = $7;
        $0 = $0 + 4 | 0;
        $1 = $1 + 1 | 0;
        if (($6 | 0) != ($1 | 0)) {
         continue label$8
        }
        break label$8;
       };
      }
      global$0 = $2 + 32 | 0;
      return;
     }
     core__panicking__panic__h2fd385a887c8bf13(1049148 | 0, 27 | 0, 1049176 | 0);
     abort();
    }
    core__panicking__panic__h2fd385a887c8bf13(1049192 | 0, 51 | 0, 1049244 | 0);
    abort();
   }
   core__panicking__panic__h2fd385a887c8bf13(1048988 | 0, 40 | 0, 1049028 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1049316 | 0, 40 | 0, 1049356 | 0);
  abort();
 }
 
 function cryptoxide__ed25519__verify__h8af691346ab1c748($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $6 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$5 = 0, i64toi32_i32$1 = 0, i64toi32_i32$4 = 0, $5 = 0, $11$hi = 0, $4 = 0, $7 = 0, $11 = 0, $12$hi = 0, $9 = 0, $10$hi = 0, $10 = 0, $8 = 0, $37 = 0, $38 = 0, $39 = 0, $72 = 0, $81 = 0, $83 = 0, $83$hi = 0, $86 = 0, $87$hi = 0, $105 = 0, $110$hi = 0, $116 = 0, $118 = 0, $118$hi = 0, $121 = 0, $122$hi = 0, $177 = 0, $177$hi = 0, $185$hi = 0;
  $4 = global$0 - 736 | 0;
  global$0 = $4;
  cryptoxide__curve25519__ge__Ge__from_bytes__hef188e306ddf7e48($4 + 480 | 0 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    i64toi32_i32$2 = $4;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 480 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 484 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    i64toi32_i32$3 = 1;
    if ((i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$0 | 0) | 0) {
     break label$2
    }
    $5 = $4 + 488 | 0;
    $6 = memcpy($4 | 0, $5 | 0, 160 | 0) | 0;
    cryptoxide__curve25519__scalar__scalar64__Scalar__from_bytes_canonical__hf5699d4fb7c90b32($6 + 480 | 0 | 0, $3 + 32 | 0 | 0);
    i64toi32_i32$3 = $6;
    i64toi32_i32$2 = HEAP32[($6 + 480 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($6 + 484 | 0) >> 2] | 0;
    i64toi32_i32$3 = i64toi32_i32$2;
    i64toi32_i32$2 = 0;
    i64toi32_i32$0 = 1;
    if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$2 | 0) | 0) {
     break label$2
    }
    memcpy($6 + 160 | 0 | 0, $5 | 0, 40 | 0) | 0;
    $5 = 0;
    $7 = 0;
    label$3 : while (1) {
     $7 = HEAPU8[($2 + $5 | 0) >> 0] | 0 | $7 | 0;
     $5 = $5 + 1 | 0;
     if (($5 | 0) != (32 | 0)) {
      continue label$3
     }
     break label$3;
    };
    if (!($7 & 255 | 0)) {
     break label$2
    }
    $5 = 0;
    $7 = memset(($6 + 480 | 0) + 80 | 0 | 0, 0 | 0, 132 | 0) | 0;
    $8 = memcpy(($6 + 480 | 0) + 16 | 0 | 0, 1137368 | 0, 64 | 0) | 0;
    i64toi32_i32$3 = 0;
    $10 = 0;
    $10$hi = i64toi32_i32$3;
    i64toi32_i32$1 = $6;
    i64toi32_i32$3 = 0;
    HEAP32[($6 + 488 | 0) >> 2] = 0;
    HEAP32[($6 + 492 | 0) >> 2] = i64toi32_i32$3;
    i64toi32_i32$1 = $6;
    i64toi32_i32$3 = 0;
    HEAP32[($6 + 480 | 0) >> 2] = 32;
    HEAP32[($6 + 484 | 0) >> 2] = i64toi32_i32$3;
    HEAP32[($6 + 264 | 0) >> 2] = $8;
    cryptoxide__cryptoutil__FixedBuffer_____input__h45eb77880e071f02($7 | 0, $3 | 0, 32 | 0, $6 + 264 | 0 | 0);
    memcpy($6 + 264 | 0 | 0, $6 + 480 | 0 | 0, 216 | 0) | 0;
    $72 = $6;
    i64toi32_i32$0 = $6;
    i64toi32_i32$3 = HEAP32[($6 + 264 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($6 + 268 | 0) >> 2] | 0;
    $11 = i64toi32_i32$3;
    $11$hi = i64toi32_i32$1;
    i64toi32_i32$0 = i64toi32_i32$3;
    i64toi32_i32$3 = 0;
    i64toi32_i32$2 = 32;
    i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
    i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
    if (i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0) {
     i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
    }
    $12$hi = i64toi32_i32$5;
    i64toi32_i32$0 = $72;
    HEAP32[(i64toi32_i32$0 + 264 | 0) >> 2] = i64toi32_i32$4;
    HEAP32[(i64toi32_i32$0 + 268 | 0) >> 2] = i64toi32_i32$5;
    $9 = ($6 + 264 | 0) + 8 | 0;
    $81 = $9;
    i64toi32_i32$1 = $9;
    i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
    $83 = i64toi32_i32$5;
    $83$hi = i64toi32_i32$0;
    i64toi32_i32$0 = $12$hi;
    i64toi32_i32$0 = $11$hi;
    i64toi32_i32$0 = $12$hi;
    i64toi32_i32$1 = i64toi32_i32$4;
    i64toi32_i32$5 = $11$hi;
    i64toi32_i32$2 = $11;
    $86 = i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0;
    i64toi32_i32$1 = 0;
    $87$hi = i64toi32_i32$1;
    i64toi32_i32$1 = $83$hi;
    i64toi32_i32$2 = $83;
    i64toi32_i32$0 = $87$hi;
    i64toi32_i32$5 = $86;
    i64toi32_i32$3 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
    i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
    if (i64toi32_i32$3 >>> 0 < i64toi32_i32$5 >>> 0) {
     i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
    }
    i64toi32_i32$2 = $81;
    HEAP32[i64toi32_i32$2 >> 2] = i64toi32_i32$3;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$4;
    $9 = ($6 + 264 | 0) + 16 | 0;
    HEAP32[($6 + 480 | 0) >> 2] = $9;
    cryptoxide__cryptoutil__FixedBuffer_____input__h45eb77880e071f02(($6 + 264 | 0) + 80 | 0 | 0, $2 | 0, 32 | 0, $6 + 480 | 0 | 0);
    memcpy($6 + 480 | 0 | 0, $6 + 264 | 0 | 0, 216 | 0) | 0;
    $105 = $6;
    i64toi32_i32$1 = $6;
    i64toi32_i32$4 = HEAP32[($6 + 480 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($6 + 484 | 0) >> 2] | 0;
    $11 = i64toi32_i32$4;
    $11$hi = i64toi32_i32$2;
    i64toi32_i32$2 = 0;
    $110$hi = i64toi32_i32$2;
    i64toi32_i32$2 = $11$hi;
    i64toi32_i32$1 = i64toi32_i32$4;
    i64toi32_i32$4 = $110$hi;
    i64toi32_i32$5 = $1;
    i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
    i64toi32_i32$3 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
    if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
     i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
    }
    $12$hi = i64toi32_i32$3;
    i64toi32_i32$1 = $105;
    HEAP32[(i64toi32_i32$1 + 480 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[(i64toi32_i32$1 + 484 | 0) >> 2] = i64toi32_i32$3;
    $2 = ($6 + 480 | 0) + 8 | 0;
    $116 = $2;
    i64toi32_i32$2 = $2;
    i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $118 = i64toi32_i32$3;
    $118$hi = i64toi32_i32$1;
    i64toi32_i32$1 = $12$hi;
    i64toi32_i32$1 = $11$hi;
    i64toi32_i32$1 = $12$hi;
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$3 = $11$hi;
    i64toi32_i32$5 = $11;
    $121 = i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0 | 0) | 0;
    i64toi32_i32$2 = 0;
    $122$hi = i64toi32_i32$2;
    i64toi32_i32$2 = $118$hi;
    i64toi32_i32$5 = $118;
    i64toi32_i32$1 = $122$hi;
    i64toi32_i32$3 = $121;
    i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
    i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
    if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
     i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
    }
    i64toi32_i32$5 = $116;
    HEAP32[i64toi32_i32$5 >> 2] = i64toi32_i32$4;
    HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($6 + 264 | 0) >> 2] = $8;
    cryptoxide__cryptoutil__FixedBuffer_____input__h45eb77880e071f02($7 | 0, $0 | 0, $1 | 0, $6 + 264 | 0 | 0);
    memcpy($6 + 264 | 0 | 0, $6 + 480 | 0 | 0, 216 | 0) | 0;
    memset($6 + 200 | 0 | 0, 0 | 0, 64 | 0) | 0;
    cryptoxide__hashing__sha2__Engine512__finish__h18b5152b4b76c624($6 + 264 | 0 | 0);
    cryptoxide__cryptoutil__write_u64v_be__h6888df4c897d2bb4($6 + 200 | 0 | 0, 64 | 0, $9 | 0, 8 | 0);
    cryptoxide__curve25519__scalar__scalar64__Scalar__reduce_from_wide_bytes__h35529550345bd5f0($6 + 696 | 0 | 0, $6 + 200 | 0 | 0);
    memcpy($6 + 480 | 0 | 0, $6 | 0, 160 | 0) | 0;
    cryptoxide__curve25519__ge__GePartial__double_scalarmult_vartime__hca77f4037cca72f5($6 + 264 | 0 | 0, $6 + 696 | 0 | 0, $6 + 480 | 0 | 0, $6 + 160 | 0 | 0);
    cryptoxide__curve25519__ge__GePartial__to_bytes__he4403e81f32db859($6 + 480 | 0 | 0, $6 + 264 | 0 | 0);
    label$4 : while (1) {
     i64toi32_i32$0 = $10$hi;
     $11 = $10;
     $11$hi = i64toi32_i32$0;
     i64toi32_i32$0 = 0;
     i64toi32_i32$2 = (HEAPU8[($3 + $5 | 0) >> 0] | 0) ^ (HEAPU8[(($6 + 480 | 0) + $5 | 0) >> 0] | 0) | 0;
     i64toi32_i32$5 = 0;
     i64toi32_i32$3 = 255;
     i64toi32_i32$5 = i64toi32_i32$0 & i64toi32_i32$5 | 0;
     $177 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     $177$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $11$hi;
     i64toi32_i32$0 = $11;
     i64toi32_i32$2 = $177$hi;
     i64toi32_i32$3 = $177;
     i64toi32_i32$2 = i64toi32_i32$5 | i64toi32_i32$2 | 0;
     $10 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
     $10$hi = i64toi32_i32$2;
     $5 = $5 + 1 | 0;
     if (($5 | 0) != (32 | 0)) {
      continue label$4
     }
     break label$4;
    };
    i64toi32_i32$2 = $11$hi;
    i64toi32_i32$2 = $10$hi;
    i64toi32_i32$2 = 0;
    i64toi32_i32$5 = 0;
    i64toi32_i32$0 = $10$hi;
    i64toi32_i32$3 = $10;
    i64toi32_i32$1 = i64toi32_i32$5 - i64toi32_i32$3 | 0;
    i64toi32_i32$4 = (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) + i64toi32_i32$0 | 0;
    i64toi32_i32$4 = i64toi32_i32$2 - i64toi32_i32$4 | 0;
    $185$hi = i64toi32_i32$4;
    i64toi32_i32$4 = $11$hi;
    i64toi32_i32$2 = $11;
    i64toi32_i32$5 = $185$hi;
    i64toi32_i32$3 = i64toi32_i32$1;
    i64toi32_i32$5 = i64toi32_i32$4 | i64toi32_i32$5 | 0;
    i64toi32_i32$4 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
    i64toi32_i32$2 = -1;
    i64toi32_i32$3 = -1;
    if ((i64toi32_i32$5 | 0) > (i64toi32_i32$2 | 0)) {
     $37 = 1
    } else {
     if ((i64toi32_i32$5 | 0) >= (i64toi32_i32$2 | 0)) {
      if (i64toi32_i32$4 >>> 0 <= i64toi32_i32$3 >>> 0) {
       $38 = 0
      } else {
       $38 = 1
      }
      $39 = $38;
     } else {
      $39 = 0
     }
     $37 = $39;
    }
    $5 = $37;
    break label$1;
   }
   $5 = 0;
  }
  global$0 = $4 + 736 | 0;
  return $5 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert__hb2ec731b8769187c($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $4 = 0, $6 = 0, $5 = 0, $7 = 0, $8 = 0, $9 = 0, $26 = 0, $27 = 0, $28 = 0, $29 = 0, $30 = 0, $31 = 0, $32 = 0, $33 = 0, $34 = 0, $35 = 0, $36 = 0, $37 = 0, $10 = 0, $63 = 0, $70 = 0, $73 = 0, $105 = 0, $109 = 0, $113 = 0, $139 = 0, $146 = 0, $149 = 0, $181 = 0, $185 = 0, $189 = 0;
  $3 = global$0 - 80 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $5 = HEAPU16[($4 + 6 | 0) >> 1] | 0;
    if ($5 >>> 0 < 11 >>> 0) {
     break label$2
    }
    alloc__collections__btree__node__splitpoint__h8424344594b4deb1($3 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
    $6 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    $5 = HEAP32[($3 + 4 | 0) >> 2] | 0;
    $1 = HEAP32[$1 >> 2] | 0;
    HEAP32[($3 + 56 | 0) >> 2] = HEAP32[$3 >> 2] | 0;
    HEAP32[($3 + 52 | 0) >> 2] = $4;
    HEAP32[($3 + 48 | 0) >> 2] = $1;
    alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__KV___split__h932ae7ef40994b5b($3 | 0, $3 + 48 | 0 | 0);
    $1 = HEAP32[(($5 | 0) == (1 | 0) ? $3 + 12 | 0 : $3 | 4 | 0) >> 2] | 0;
    $4 = HEAPU16[($1 + 6 | 0) >> 1] | 0;
    $5 = ($3 + 48 | 0) + 24 | 0;
    $26 = $2 + 24 | 0;
    HEAP32[$5 >> 2] = HEAPU8[$26 >> 0] | 0 | ((HEAPU8[($26 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($26 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($26 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $7 = ($3 + 48 | 0) + 16 | 0;
    i64toi32_i32$2 = $2 + 16 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $63 = i64toi32_i32$0;
    i64toi32_i32$0 = $7;
    HEAP32[i64toi32_i32$0 >> 2] = $63;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    $8 = ($3 + 48 | 0) + 8 | 0;
    i64toi32_i32$2 = $2 + 8 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $70 = i64toi32_i32$1;
    i64toi32_i32$1 = $8;
    HEAP32[i64toi32_i32$1 >> 2] = $70;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $73 = i64toi32_i32$0;
    i64toi32_i32$0 = $3;
    HEAP32[(i64toi32_i32$0 + 48 | 0) >> 2] = $73;
    HEAP32[(i64toi32_i32$0 + 52 | 0) >> 2] = i64toi32_i32$1;
    label$3 : {
     $2 = $6 + 1 | 0;
     if ($2 >>> 0 > $4 >>> 0) {
      break label$3
     }
     $9 = $1 + 8 | 0;
     memmove($9 + Math_imul($2, 28) | 0 | 0, $9 + Math_imul($6, 28) | 0 | 0, Math_imul($4 - $6 | 0, 28) | 0) | 0;
    }
    $2 = $1 + Math_imul($6, 28) | 0;
    $27 = $2 + 32 | 0;
    $28 = HEAP32[$5 >> 2] | 0;
    HEAP8[$27 >> 0] = $28;
    HEAP8[($27 + 1 | 0) >> 0] = $28 >>> 8 | 0;
    HEAP8[($27 + 2 | 0) >> 0] = $28 >>> 16 | 0;
    HEAP8[($27 + 3 | 0) >> 0] = $28 >>> 24 | 0;
    i64toi32_i32$2 = $7;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $105 = i64toi32_i32$1;
    i64toi32_i32$1 = $2 + 24 | 0;
    $29 = $105;
    HEAP8[i64toi32_i32$1 >> 0] = $29;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $29 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $29 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $29 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$2 = $8;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $109 = i64toi32_i32$0;
    i64toi32_i32$0 = $2 + 16 | 0;
    $30 = $109;
    HEAP8[i64toi32_i32$0 >> 0] = $30;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $30 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $30 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $30 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] | 0;
    $113 = i64toi32_i32$1;
    i64toi32_i32$1 = $2 + 8 | 0;
    $31 = $113;
    HEAP8[i64toi32_i32$1 >> 0] = $31;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $31 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $31 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $31 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    HEAP16[($1 + 6 | 0) >> 1] = $4 + 1 | 0;
    memcpy($0 + 4 | 0 | 0, i64toi32_i32$2 | 0, 44 | 0) | 0;
    HEAP32[($0 + 48 | 0) >> 2] = $1;
    HEAP32[$0 >> 2] = 1;
    break label$1;
   }
   $6 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   $7 = ($3 + 48 | 0) + 24 | 0;
   $32 = $2 + 24 | 0;
   HEAP32[$7 >> 2] = HEAPU8[$32 >> 0] | 0 | ((HEAPU8[($32 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($32 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($32 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $8 = ($3 + 48 | 0) + 16 | 0;
   i64toi32_i32$2 = $2 + 16 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $139 = i64toi32_i32$0;
   i64toi32_i32$0 = $8;
   HEAP32[i64toi32_i32$0 >> 2] = $139;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   $9 = ($3 + 48 | 0) + 8 | 0;
   i64toi32_i32$2 = $2 + 8 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $146 = i64toi32_i32$1;
   i64toi32_i32$1 = $9;
   HEAP32[i64toi32_i32$1 >> 2] = $146;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $149 = i64toi32_i32$0;
   i64toi32_i32$0 = $3;
   HEAP32[(i64toi32_i32$0 + 48 | 0) >> 2] = $149;
   HEAP32[(i64toi32_i32$0 + 52 | 0) >> 2] = i64toi32_i32$1;
   label$4 : {
    $2 = $6 + 1 | 0;
    if ($2 >>> 0 > $5 >>> 0) {
     break label$4
    }
    $10 = $4 + 8 | 0;
    memmove($10 + Math_imul($2, 28) | 0 | 0, $10 + Math_imul($6, 28) | 0 | 0, Math_imul($5 - $6 | 0, 28) | 0) | 0;
   }
   $2 = $4 + Math_imul($6, 28) | 0;
   $33 = $2 + 32 | 0;
   $34 = HEAP32[$7 >> 2] | 0;
   HEAP8[$33 >> 0] = $34;
   HEAP8[($33 + 1 | 0) >> 0] = $34 >>> 8 | 0;
   HEAP8[($33 + 2 | 0) >> 0] = $34 >>> 16 | 0;
   HEAP8[($33 + 3 | 0) >> 0] = $34 >>> 24 | 0;
   i64toi32_i32$2 = $8;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $181 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 24 | 0;
   $35 = $181;
   HEAP8[i64toi32_i32$1 >> 0] = $35;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $35 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $35 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $35 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $9;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $185 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 16 | 0;
   $36 = $185;
   HEAP8[i64toi32_i32$0 >> 0] = $36;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $36 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $36 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $36 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] | 0;
   $189 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 8 | 0;
   $37 = $189;
   HEAP8[i64toi32_i32$1 >> 0] = $37;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $37 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $37 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $37 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   HEAP16[($4 + 6 | 0) >> 1] = $5 + 1 | 0;
   HEAP32[($0 + 48 | 0) >> 2] = $4;
   HEAP32[($0 + 12 | 0) >> 2] = $6;
   HEAP32[($0 + 8 | 0) >> 2] = $4;
   HEAP32[$0 >> 2] = 0;
   HEAP32[($0 + 4 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
  }
  global$0 = $3 + 80 | 0;
 }
 
 function cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__get_plutus_input_scripts__h7e973282eea0f34a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $3 = 0, i64toi32_i32$3 = 0, $4 = 0, $5 = 0, $6 = 0, $31 = 0, $38 = 0, $41 = 0, $62 = 0, $83 = 0, $7 = 0, $8 = 0, $146 = 0, $150 = 0, $154 = 0, $169 = 0;
  $2 = global$0 - 256 | 0;
  global$0 = $2;
  alloc__collections__btree__map__BTreeMap_K_2cV___iter__h721110b568622f84($2 + 56 | 0 | 0, $1 + 64 | 0 | 0);
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 44 | 0) >> 2] = 0;
  HEAP32[($2 + 48 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(($2 + 112 | 0) + 24 | 0) >> 2] = HEAP32[(($2 + 56 | 0) + 24 | 0) >> 2] | 0;
  i64toi32_i32$2 = ($2 + 56 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 112 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $31;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = ($2 + 56 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $38 = i64toi32_i32$1;
  i64toi32_i32$1 = ($2 + 112 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $38;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 56 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 60 | 0) >> 2] | 0;
  $41 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 112 | 0) >> 2] = $41;
  HEAP32[($2 + 116 | 0) >> 2] = i64toi32_i32$1;
  $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h7135048eb51d6b68($2 + 32 | 0 | 0, $2 + 112 | 0 | 0);
  label$1 : {
   if (!(HEAP32[($2 + 32 | 0) >> 2] | 0)) {
    break label$1
   }
   $3 = HEAP32[($2 + 36 | 0) >> 2] | 0;
   $4 = 0;
   label$2 : while (1) {
    $5 = ($2 + 88 | 0) + 8 | 0;
    $6 = ($2 + 40 | 0) + 8 | 0;
    HEAP32[$5 >> 2] = HEAP32[$6 >> 2] | 0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[($2 + 40 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 44 | 0) >> 2] | 0;
    $62 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 88 | 0) >> 2] = $62;
    HEAP32[($2 + 92 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($2 + 100 | 0) >> 2] = $4;
    HEAP32[($2 + 104 | 0) >> 2] = $3;
    label$3 : {
     if (!(HEAPU8[($3 + 64 | 0) >> 0] | 0)) {
      break label$3
     }
     i64toi32_i32$0 = 0;
     alloc__collections__btree__map__BTreeMap_K_2cV___insert__h1d253d1db198de85($2 + 16 | 0 | 0, $2 + 88 | 0 | 0, $3 + 65 | 0 | 0, $4 | 0, i64toi32_i32$0 | 0);
    }
    HEAP32[$6 >> 2] = HEAP32[$5 >> 2] | 0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 92 | 0) >> 2] | 0;
    $83 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[($2 + 40 | 0) >> 2] = $83;
    HEAP32[($2 + 44 | 0) >> 2] = i64toi32_i32$1;
    $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h7135048eb51d6b68($2 + 8 | 0 | 0, $2 + 112 | 0 | 0);
    if (!(HEAP32[($2 + 8 | 0) >> 2] | 0)) {
     break label$1
    }
    $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $4 = $4 + 1 | 0;
    continue label$2;
   };
  }
  i64toi32_i32$0 = $2;
  i64toi32_i32$1 = 0;
  HEAP32[($2 + 60 | 0) >> 2] = 0;
  HEAP32[($2 + 64 | 0) >> 2] = i64toi32_i32$1;
  $4 = 0;
  HEAP32[($2 + 56 | 0) >> 2] = HEAP32[(0 + 1069056 | 0) >> 2] | 0;
  label$4 : {
   $5 = HEAP32[($1 + 32 | 0) >> 2] | 0;
   if (!$5) {
    break label$4
   }
   $4 = HEAP32[($5 + 156 | 0) >> 2] | 0;
  }
  label$5 : {
   label$6 : {
    if (($4 | 0) == ($5 | 0)) {
     break label$6
    }
    $7 = $2 + 168 | 0;
    $8 = ($2 + 112 | 0) + 128 | 0;
    label$7 : while (1) {
     $3 = $4;
     $4 = HEAP32[($3 + 156 | 0) >> 2] | 0;
     HEAP32[($2 + 88 | 0) >> 2] = $3 + 160 | 0;
     label$8 : {
      i64toi32_i32$2 = $3;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 1;
      if ((i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | 0) {
       break label$8
      }
      $6 = alloc__collections__btree__map__BTreeMap_K_2cV___get__h702e3889319be60e($2 + 40 | 0 | 0, $2 + 88 | 0 | 0) | 0;
      if (!$6) {
       break label$8
      }
      $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($8 | 0, $3 + 136 | 0 | 0);
      $cardano_serialization_lib__plutus__PlutusData_20as_20core__clone__Clone___clone__h63d1a98cc18f4609_1($2 + 112 | 0 | 0, $3 + 8 | 0 | 0);
      $1 = HEAPU8[($3 + 128 | 0) >> 0] | 0;
      i64toi32_i32$3 = $6;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $cardano_serialization_lib__plutus__PlutusData_20as_20core__clone__Clone___clone__h63d1a98cc18f4609_2($7 | 0, $3 + 64 | 0 | 0);
      HEAP8[($2 + 232 | 0) >> 0] = $1;
      $146 = i64toi32_i32$2;
      i64toi32_i32$2 = $2;
      HEAP32[($2 + 160 | 0) >> 2] = $146;
      HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$3 = $3 + 120 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $150 = i64toi32_i32$0;
      i64toi32_i32$0 = $2;
      HEAP32[($2 + 224 | 0) >> 2] = $150;
      HEAP32[($2 + 228 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$3 = $3 + 112 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $154 = i64toi32_i32$2;
      i64toi32_i32$2 = $2;
      HEAP32[($2 + 216 | 0) >> 2] = $154;
      HEAP32[($2 + 220 | 0) >> 2] = i64toi32_i32$0;
      cardano_serialization_lib__tx_builder__tx_inputs_builder__PlutusWitnesses__add__hec4d4aff8ce90d4a($2 + 56 | 0 | 0, $2 + 112 | 0 | 0);
      core__ptr__drop_in_place_cardano_serialization_lib__tx_builder__tx_inputs_builder__PlutusWitness___he0a62919c4b71e2b($2 + 112 | 0 | 0);
     }
     if (($4 | 0) != ($5 | 0)) {
      continue label$7
     }
     break label$7;
    };
    if (!(HEAP32[($2 + 64 | 0) >> 2] | 0)) {
     break label$6
    }
    i64toi32_i32$3 = $2;
    i64toi32_i32$0 = HEAP32[($2 + 56 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($2 + 60 | 0) >> 2] | 0;
    $169 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[i64toi32_i32$0 >> 2] = $169;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[(($2 + 56 | 0) + 8 | 0) >> 2] | 0;
    break label$5;
   }
   HEAP32[$0 >> 2] = 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h1bbffe174ae872d8($2 + 56 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h9b1d3bb47b46eeb8($2 + 56 | 0 | 0);
  }
  $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h315fcfacfcb22ee3($2 + 40 | 0 | 0);
  global$0 = $2 + 256 | 0;
 }
 
 function core__fmt__Formatter__pad_formatted_parts__h909e13f823ca9407($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $5 = 0, $6 = 0, $4 = 0, $2 = 0, $3 = 0, $11 = 0, $9 = 0, $7 = 0, $8 = 0, $10 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ((HEAP32[($0 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
        break label$5
       }
       $3 = HEAP32[($0 + 12 | 0) >> 2] | 0;
       $4 = HEAP32[($1 + 12 | 0) >> 2] | 0;
       HEAP32[($2 + 12 | 0) >> 2] = $4;
       $5 = HEAP32[($1 + 8 | 0) >> 2] | 0;
       HEAP32[($2 + 8 | 0) >> 2] = $5;
       $6 = HEAP32[($1 + 4 | 0) >> 2] | 0;
       HEAP32[($2 + 4 | 0) >> 2] = $6;
       $1 = HEAP32[$1 >> 2] | 0;
       HEAP32[$2 >> 2] = $1;
       $7 = HEAPU8[($0 + 32 | 0) >> 0] | 0;
       $8 = HEAP32[($0 + 4 | 0) >> 2] | 0;
       if ((HEAPU8[$0 >> 0] | 0) & 8 | 0) {
        break label$4
       }
       $9 = $8;
       $1 = $6;
       $10 = $7;
       break label$3;
      }
      $5 = core__fmt__Formatter__write_formatted_parts__h45709e2ae324d4ac($0 | 0, $1 | 0) | 0;
      break label$1;
     }
     if (FUNCTION_TABLE[HEAP32[((HEAP32[($0 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($0 + 24 | 0) >> 2] | 0, $1, $6) | 0) {
      break label$2
     }
     $10 = 1;
     HEAP8[($0 + 32 | 0) >> 0] = 1;
     $9 = 48;
     HEAP32[($0 + 4 | 0) >> 2] = 48;
     $1 = 0;
     HEAP32[($2 + 4 | 0) >> 2] = 0;
     HEAP32[$2 >> 2] = 1149204;
     $6 = $3 - $6 | 0;
     $3 = $6 >>> 0 > $3 >>> 0 ? 0 : $6;
    }
    label$6 : {
     if (!$4) {
      break label$6
     }
     $4 = Math_imul($4, 12);
     label$7 : while (1) {
      label$8 : {
       label$9 : {
        switch (HEAPU16[$5 >> 1] | 0 | 0) {
        default:
         $6 = HEAP32[($5 + 4 | 0) >> 2] | 0;
         break label$8;
        case 2:
         $6 = HEAP32[($5 + 8 | 0) >> 2] | 0;
         break label$8;
        case 1:
         break label$9;
        };
       }
       label$12 : {
        $11 = HEAPU16[($5 + 2 | 0) >> 1] | 0;
        if ($11 >>> 0 < 1e3 >>> 0) {
         break label$12
        }
        $6 = $11 >>> 0 < 1e4 >>> 0 ? 4 : 5;
        break label$8;
       }
       $6 = 1;
       if ($11 >>> 0 < 10 >>> 0) {
        break label$8
       }
       $6 = $11 >>> 0 < 100 >>> 0 ? 2 : 3;
      }
      $5 = $5 + 12 | 0;
      $1 = $6 + $1 | 0;
      $4 = $4 + -12 | 0;
      if ($4) {
       continue label$7
      }
      break label$7;
     };
    }
    label$13 : {
     label$14 : {
      label$15 : {
       if ($3 >>> 0 <= $1 >>> 0) {
        break label$15
       }
       $5 = 0;
       $1 = $3 - $1 | 0;
       $4 = $1;
       label$16 : {
        label$17 : {
         switch ($10 & 3 | 0 | 0) {
         case 1:
         case 3:
          $4 = 0;
          $5 = $1;
          break label$16;
         case 2:
          break label$17;
         default:
          break label$16;
         };
        }
        $5 = $1 >>> 1 | 0;
        $4 = ($1 + 1 | 0) >>> 1 | 0;
       }
       $5 = $5 + 1 | 0;
       $1 = HEAP32[($0 + 28 | 0) >> 2] | 0;
       $6 = HEAP32[($0 + 24 | 0) >> 2] | 0;
       label$19 : while (1) {
        $5 = $5 + -1 | 0;
        if (!$5) {
         break label$14
        }
        if (!(FUNCTION_TABLE[HEAP32[($1 + 16 | 0) >> 2] | 0 | 0]($6, $9) | 0)) {
         continue label$19
        }
        break label$2;
       };
      }
      $5 = core__fmt__Formatter__write_formatted_parts__h45709e2ae324d4ac($0 | 0, $2 | 0) | 0;
      break label$13;
     }
     if (core__fmt__Formatter__write_formatted_parts__h45709e2ae324d4ac($0 | 0, $2 | 0) | 0) {
      break label$2
     }
     $5 = 0;
     label$20 : while (1) {
      label$21 : {
       if (($4 | 0) != ($5 | 0)) {
        break label$21
       }
       $5 = $4 >>> 0 < $4 >>> 0;
       break label$13;
      }
      $5 = $5 + 1 | 0;
      if (!(FUNCTION_TABLE[HEAP32[($1 + 16 | 0) >> 2] | 0 | 0]($6, $9) | 0)) {
       continue label$20
      }
      break label$20;
     };
     $5 = ($5 + -1 | 0) >>> 0 < $4 >>> 0;
    }
    HEAP8[($0 + 32 | 0) >> 0] = $7;
    HEAP32[($0 + 4 | 0) >> 2] = $8;
    break label$1;
   }
   $5 = 1;
  }
  global$0 = $2 + 16 | 0;
  return $5 | 0;
 }
 
 function cardano_serialization_lib__address__Address__from_bech32__h23213bc9f9149b82($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $4 = 0, $4$hi = 0, $17 = 0, $51 = 0, $81 = 0, $162 = 0;
  $3 = global$0 - 224 | 0;
  global$0 = $3;
  bech32__decode__h25859b35256032dd($3 + 72 | 0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ((HEAP32[($3 + 72 | 0) >> 2] | 0 | 0) != (1 | 0)) {
        break label$5
       }
       i64toi32_i32$2 = $3;
       i64toi32_i32$0 = HEAP32[($3 + 76 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($3 + 80 | 0) >> 2] | 0;
       $17 = i64toi32_i32$0;
       i64toi32_i32$0 = $3;
       HEAP32[($3 + 40 | 0) >> 2] = $17;
       HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$0 = $3;
       i64toi32_i32$1 = 0;
       HEAP32[($3 + 212 | 0) >> 2] = 0;
       HEAP32[($3 + 216 | 0) >> 2] = i64toi32_i32$1;
       HEAP32[($3 + 208 | 0) >> 2] = HEAP32[(0 + 1070048 | 0) >> 2] | 0;
       core__fmt__Formatter__new__he219faf25326051b($3 + 136 | 0 | 0, $3 + 208 | 0 | 0, 1069768 | 0);
       if (!($bech32__Error_20as_20core__fmt__Display___fmt__hb94eedebff44411f($3 + 40 | 0 | 0, $3 + 136 | 0 | 0) | 0)) {
        break label$4
       }
       core__result__unwrap_failed__h27f43d993c3864a1(1069792 | 0, 55 | 0, $3 + 24 | 0 | 0, 1069940 | 0, 1069924 | 0);
       abort();
      }
      $1 = HEAP32[($3 + 96 | 0) >> 2] | 0;
      HEAP32[(($3 + 56 | 0) + 8 | 0) >> 2] = $1;
      i64toi32_i32$2 = $3 + 88 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $4 = i64toi32_i32$1;
      $4$hi = i64toi32_i32$0;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 56 | 0) >> 2] = $4;
      HEAP32[($3 + 60 | 0) >> 2] = i64toi32_i32$0;
      $2 = HEAP32[($3 + 76 | 0) >> 2] | 0;
      i64toi32_i32$2 = ($3 + 72 | 0) + 8 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $51 = i64toi32_i32$0;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 28 | 0) >> 2] = $51;
      HEAP32[($3 + 32 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($3 + 24 | 0) >> 2] = $2;
      HEAP32[(($3 + 40 | 0) + 8 | 0) >> 2] = $1;
      i64toi32_i32$1 = $4$hi;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 40 | 0) >> 2] = $4;
      HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$1;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__heed2de4899f9d51c($3 + 16 | 0 | 0, $3 + 40 | 0 | 0);
      $alloc__vec__Vec_u8__20as_20bech32__FromBase32___from_base32__h6e67b5484009b518($3 + 136 | 0 | 0, HEAP32[($3 + 16 | 0) >> 2] | 0 | 0, HEAP32[($3 + 20 | 0) >> 2] | 0 | 0);
      if ((HEAP32[($3 + 136 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$2
      }
      HEAP32[(($3 + 208 | 0) + 8 | 0) >> 2] = HEAP32[($3 + 148 | 0) >> 2] | 0;
      i64toi32_i32$2 = $3;
      i64toi32_i32$1 = HEAP32[($3 + 140 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($3 + 144 | 0) >> 2] | 0;
      $81 = i64toi32_i32$1;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 208 | 0) >> 2] = $81;
      HEAP32[($3 + 212 | 0) >> 2] = i64toi32_i32$0;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $3 + 208 | 0 | 0);
      cardano_serialization_lib__address__Address__from_bytes_impl__h0b2b4c3a1f339e7a($3 + 136 | 0 | 0, HEAP32[($3 + 8 | 0) >> 2] | 0 | 0, HEAP32[($3 + 12 | 0) >> 2] | 0 | 0);
      i64toi32_i32$2 = $3;
      i64toi32_i32$0 = HEAP32[($3 + 136 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($3 + 140 | 0) >> 2] | 0;
      $4 = i64toi32_i32$0;
      $4$hi = i64toi32_i32$1;
      memcpy($3 + 72 | 0 | 0, ($3 + 136 | 0) + 8 | 0 | 0, 64 | 0) | 0;
      i64toi32_i32$2 = i64toi32_i32$0;
      i64toi32_i32$0 = 0;
      if ((i64toi32_i32$2 | 0) == (1 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
       break label$3
      }
      memcpy($0 + 8 | 0 | 0, $3 + 72 | 0 | 0, 64 | 0) | 0;
      HEAP32[$0 >> 2] = 0;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 208 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 208 | 0 | 0);
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc91437b7d7fa2d3a($3 + 40 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h899e85abb4c3d85f($3 + 40 | 0 | 0);
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 24 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 24 | 0 | 0);
      break label$1;
     }
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 | 0, $3 + 208 | 0 | 0);
     $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[$3 >> 2] | 0 | 0, HEAP32[($3 + 4 | 0) >> 2] | 0 | 0) | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 208 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 208 | 0 | 0);
     $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($1 | 0) | 0;
     HEAP32[$0 >> 2] = 1;
     HEAP32[($0 + 4 | 0) >> 2] = $1;
     break label$1;
    }
    memcpy($3 + 136 | 0 | 0, $3 + 72 | 0 | 0, 64 | 0) | 0;
    $1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($3 + 136 | 0 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 208 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 208 | 0 | 0);
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc91437b7d7fa2d3a($3 + 40 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h899e85abb4c3d85f($3 + 40 | 0 | 0);
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 24 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 24 | 0 | 0);
    break label$1;
   }
   i64toi32_i32$2 = HEAP32[($3 + 140 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($3 + 144 | 0) >> 2] | 0;
   $162 = i64toi32_i32$2;
   i64toi32_i32$2 = $3;
   HEAP32[($3 + 72 | 0) >> 2] = $162;
   HEAP32[($3 + 76 | 0) >> 2] = i64toi32_i32$1;
   core__result__unwrap_failed__h27f43d993c3864a1(1069956 | 0, 43 | 0, $3 + 72 | 0 | 0, 107e4 | 0, 1070560 | 0);
   abort();
  }
  global$0 = $3 + 224 | 0;
 }
 
 function alloc__collections__btree__node__BalancingContext_K_2cV___do_merge__head87d19f7482344($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $10 = 0, i64toi32_i32$0 = 0, $3 = 0, $12 = 0, $14 = 0, $15 = 0, $16 = 0, i64toi32_i32$1 = 0, $5 = 0, $4 = 0, $6 = 0, $7 = 0, $2 = 0, $8 = 0, $13 = 0, $9 = 0, $11 = 0, $64 = 0, $87 = 0, $117 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   $3 = HEAP32[($1 + 16 | 0) >> 2] | 0;
   $4 = HEAPU16[($3 + 226 | 0) >> 1] | 0;
   $5 = $4 + 1 | 0;
   $6 = HEAP32[($1 + 24 | 0) >> 2] | 0;
   $7 = HEAPU16[($6 + 226 | 0) >> 1] | 0;
   $8 = $5 + $7 | 0;
   if ($8 >>> 0 > 11 >>> 0) {
    break label$1
   }
   $9 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   $10 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   $11 = HEAP32[$1 >> 2] | 0;
   $12 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   $13 = HEAPU16[($12 + 226 | 0) >> 1] | 0;
   HEAP16[($3 + 226 | 0) >> 1] = $8;
   $14 = $2 + 8 | 0;
   $1 = $12 + Math_imul($10, 12) | 0;
   HEAP32[$14 >> 2] = HEAP32[($1 + 100 | 0) >> 2] | 0;
   $15 = $1 + 92 | 0;
   i64toi32_i32$0 = HEAP32[$15 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($15 + 4 | 0) >> 2] | 0;
   $64 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   HEAP32[i64toi32_i32$0 >> 2] = $64;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   $16 = $13 + ($10 ^ -1 | 0) | 0;
   memmove($15 | 0, $1 + 104 | 0 | 0, Math_imul($16, 12) | 0) | 0;
   $1 = $3 + 92 | 0;
   $15 = $1 + Math_imul($4, 12) | 0;
   HEAP32[($15 + 8 | 0) >> 2] = HEAP32[$14 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $87 = i64toi32_i32$1;
   i64toi32_i32$1 = $15;
   HEAP32[i64toi32_i32$1 >> 2] = $87;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   memcpy($1 + Math_imul($5, 12) | 0 | 0, $6 + 92 | 0 | 0, Math_imul($7, 12) | 0) | 0;
   $14 = $12 + ($10 << 3 | 0) | 0;
   i64toi32_i32$0 = HEAP32[$14 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($14 + 4 | 0) >> 2] | 0;
   $1 = $10 + 1 | 0;
   memmove($14 | 0, $12 + ($1 << 3 | 0) | 0 | 0, $16 << 3 | 0 | 0) | 0;
   $117 = i64toi32_i32$0;
   i64toi32_i32$0 = $3 + ($4 << 3 | 0) | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $117;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   memcpy($3 + ($5 << 3 | 0) | 0 | 0, $6 | 0, $7 << 3 | 0 | 0) | 0;
   $14 = 232;
   $15 = $12 + 232 | 0;
   $10 = $10 << 2 | 0;
   memmove($15 + ($1 << 2 | 0) | 0 | 0, ($10 + $15 | 0) + 8 | 0 | 0, $16 << 2 | 0 | 0) | 0;
   label$2 : {
    if ($1 >>> 0 >= $13 >>> 0) {
     break label$2
    }
    $10 = ($10 + $12 | 0) + 236 | 0;
    label$3 : while (1) {
     $16 = HEAP32[$10 >> 2] | 0;
     HEAP16[($16 + 224 | 0) >> 1] = $1;
     HEAP32[($16 + 88 | 0) >> 2] = $12;
     $10 = $10 + 4 | 0;
     $1 = $1 + 1 | 0;
     if (($13 | 0) != ($1 | 0)) {
      continue label$3
     }
     break label$3;
    };
   }
   HEAP16[($12 + 226 | 0) >> 1] = (HEAPU16[($12 + 226 | 0) >> 1] | 0) + -1 | 0;
   label$4 : {
    if ($11 >>> 0 <= 1 >>> 0) {
     break label$4
    }
    memcpy(($3 + ($5 << 2 | 0) | 0) + 232 | 0 | 0, $6 + 232 | 0 | 0, ($7 << 2 | 0) + 4 | 0 | 0) | 0;
    $14 = 280;
    if ($8 >>> 0 <= $4 >>> 0) {
     break label$4
    }
    $10 = $7 + 1 | 0;
    $1 = (($4 << 2 | 0) + $3 | 0) + 236 | 0;
    label$5 : while (1) {
     $16 = HEAP32[$1 >> 2] | 0;
     HEAP16[($16 + 224 | 0) >> 1] = $5;
     HEAP32[($16 + 88 | 0) >> 2] = $3;
     $1 = $1 + 4 | 0;
     $5 = $5 + 1 | 0;
     $10 = $10 + -1 | 0;
     if ($10) {
      continue label$5
     }
     break label$5;
    };
   }
   __rust_dealloc($6 | 0, $14 | 0, 8 | 0);
   HEAP32[($0 + 4 | 0) >> 2] = $3;
   HEAP32[$0 >> 2] = $9;
   global$0 = $2 + 16 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1049692 | 0, 42 | 0, 1049736 | 0);
  abort();
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__ScriptPubkey___deserialize_as_embedded_group__h27483ec3516d4650($0, $1, $2, $2$hi, $3, $3$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  var i64toi32_i32$0 = 0, $4 = 0, i64toi32_i32$3 = 0, i64toi32_i32$2 = 0, $10 = 0, i64toi32_i32$1 = 0, $10$hi = 0, $5 = 0, $6 = 0, i64toi32_i32$4 = 0, $27 = 0, $28 = 0, $29 = 0, $30 = 0, $31 = 0, $32 = 0, $11 = 0, $11$hi = 0, $7 = 0, $33 = 0, $8 = 0, $12 = 0, $12$hi = 0, $9 = 0, $106 = 0, $124 = 0, $128 = 0, $131 = 0;
  $4 = global$0 - 368 | 0;
  global$0 = $4;
  cbor_event__de__Deserializer_R___unsigned_integer__h1ed99c0b7fe7eea1($4 + 296 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[($4 + 304 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($4 + 308 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        i64toi32_i32$2 = $4;
        i64toi32_i32$1 = HEAP32[($4 + 296 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[($4 + 300 | 0) >> 2] | 0;
        i64toi32_i32$2 = i64toi32_i32$1;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
         break label$6
        }
        i64toi32_i32$2 = $10$hi;
        if (!($10 | i64toi32_i32$2 | 0)) {
         break label$4
        }
        $5 = 8;
        i64toi32_i32$2 = 0;
        $11 = 0;
        $11$hi = i64toi32_i32$2;
        $6 = 1;
        $7 = 1;
        break label$5;
       }
       i64toi32_i32$2 = $10$hi;
       i64toi32_i32$3 = $10;
       i64toi32_i32$0 = 0;
       i64toi32_i32$1 = 32;
       i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = 0;
        $33 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
        $33 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$4 | 0) | 0;
       }
       $8 = $33;
       i64toi32_i32$2 = $4 + 336 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $12 = i64toi32_i32$0;
       $12$hi = i64toi32_i32$3;
       i64toi32_i32$2 = $4 + 328 | 0;
       i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $11 = i64toi32_i32$3;
       $11$hi = i64toi32_i32$0;
       $9 = HEAP32[($4 + 324 | 0) >> 2] | 0;
       $7 = HEAP32[($4 + 320 | 0) >> 2] | 0;
       i64toi32_i32$0 = $10$hi;
       $6 = $10;
       $5 = 2;
       i64toi32_i32$2 = $4 + 312 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $10 = i64toi32_i32$0;
       $10$hi = i64toi32_i32$3;
      }
      i64toi32_i32$3 = $12$hi;
      i64toi32_i32$0 = $4 + 336 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $12;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
      i64toi32_i32$3 = $11$hi;
      i64toi32_i32$0 = $4 + 328 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $11;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
      HEAP32[($4 + 324 | 0) >> 2] = $9;
      HEAP32[($4 + 320 | 0) >> 2] = $7;
      i64toi32_i32$3 = $10$hi;
      i64toi32_i32$0 = $4 + 312 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $10;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
      HEAP32[($4 + 308 | 0) >> 2] = $8;
      HEAP32[(($4 + 296 | 0) + 8 | 0) >> 2] = $6;
      HEAP32[($4 + 344 | 0) >> 2] = 0;
      HEAP8[($4 + 296 | 0) >> 0] = $5;
      cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($4 + 80 | 0 | 0, $4 + 296 | 0 | 0, 1050766 | 0, 7 | 0);
      $5 = HEAPU8[($4 + 80 | 0) >> 0] | 0;
      if (($5 | 0) != (19 | 0)) {
       break label$3
      }
     }
     $cardano_serialization_lib__crypto__Ed25519KeyHash_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h495effbb534e290f($4 + 296 | 0 | 0, $1 | 0);
     if ((HEAPU8[($4 + 296 | 0) >> 0] | 0 | 0) == (1 | 0)) {
      break label$2
     }
     i64toi32_i32$2 = ($4 + 296 | 0) + 9 | 0;
     i64toi32_i32$3 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $10 = i64toi32_i32$3;
     $10$hi = i64toi32_i32$0;
     i64toi32_i32$3 = ($4 + 80 | 0) + 9 | 0;
     HEAP8[i64toi32_i32$3 >> 0] = $10;
     HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $10 >>> 8 | 0;
     HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $10 >>> 16 | 0;
     HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $10 >>> 24 | 0;
     HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$0;
     HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
     HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
     HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
     $1 = $4 + 32 | 0;
     $27 = ($4 + 296 | 0) + 25 | 0;
     HEAP32[$1 >> 2] = HEAPU8[$27 >> 0] | 0 | ((HEAPU8[($27 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($27 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($27 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $5 = $4 + 24 | 0;
     i64toi32_i32$2 = ($4 + 296 | 0) + 17 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$3 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $106 = i64toi32_i32$0;
     i64toi32_i32$0 = $5;
     HEAP32[i64toi32_i32$0 >> 2] = $106;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
     $6 = $4 + 16 | 0;
     i64toi32_i32$3 = $10$hi;
     i64toi32_i32$0 = $6;
     HEAP32[i64toi32_i32$0 >> 2] = $10;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$2 = $4;
     i64toi32_i32$3 = HEAPU8[($4 + 297 | 0) >> 0] | 0 | ((HEAPU8[($4 + 298 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 299 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 300 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[($4 + 301 | 0) >> 0] | 0 | ((HEAPU8[($4 + 302 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 303 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 304 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $10 = i64toi32_i32$3;
     $10$hi = i64toi32_i32$0;
     i64toi32_i32$3 = $4;
     HEAP8[($4 + 81 | 0) >> 0] = $10;
     HEAP8[($4 + 82 | 0) >> 0] = $10 >>> 8 | 0;
     HEAP8[($4 + 83 | 0) >> 0] = $10 >>> 16 | 0;
     HEAP8[($4 + 84 | 0) >> 0] = $10 >>> 24 | 0;
     HEAP8[($4 + 85 | 0) >> 0] = i64toi32_i32$0;
     HEAP8[($4 + 86 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
     HEAP8[($4 + 87 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
     HEAP8[($4 + 88 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
     i64toi32_i32$3 = $4;
     HEAP32[($4 + 8 | 0) >> 2] = $10;
     HEAP32[($4 + 12 | 0) >> 2] = i64toi32_i32$0;
     $28 = $0 + 25 | 0;
     $29 = HEAP32[$1 >> 2] | 0;
     HEAP8[$28 >> 0] = $29;
     HEAP8[($28 + 1 | 0) >> 0] = $29 >>> 8 | 0;
     HEAP8[($28 + 2 | 0) >> 0] = $29 >>> 16 | 0;
     HEAP8[($28 + 3 | 0) >> 0] = $29 >>> 24 | 0;
     i64toi32_i32$2 = $5;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $124 = i64toi32_i32$0;
     i64toi32_i32$0 = $0 + 17 | 0;
     $30 = $124;
     HEAP8[i64toi32_i32$0 >> 0] = $30;
     HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $30 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $30 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $30 >>> 24 | 0;
     HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$3;
     HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
     i64toi32_i32$2 = $6;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $128 = i64toi32_i32$3;
     i64toi32_i32$3 = $0 + 9 | 0;
     $31 = $128;
     HEAP8[i64toi32_i32$3 >> 0] = $31;
     HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $31 >>> 8 | 0;
     HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $31 >>> 16 | 0;
     HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $31 >>> 24 | 0;
     HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$0;
     HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
     HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
     HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
     i64toi32_i32$2 = $4;
     i64toi32_i32$0 = HEAP32[($4 + 8 | 0) >> 2] | 0;
     i64toi32_i32$3 = HEAP32[($4 + 12 | 0) >> 2] | 0;
     $131 = i64toi32_i32$0;
     i64toi32_i32$0 = $0;
     $32 = $131;
     HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $32;
     HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $32 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $32 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = $32 >>> 24 | 0;
     HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$3;
     HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 8 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
     HEAP8[i64toi32_i32$0 >> 0] = 0;
     break label$1;
    }
    memcpy($0 + 9 | 0 | 0, $4 + 80 | 0 | 1 | 0 | 0, 63 | 0) | 0;
    HEAP8[$0 >> 0] = 1;
    HEAP8[($0 + 8 | 0) >> 0] = $5;
    break label$1;
   }
   memcpy($4 + 296 | 0 | 0, memcpy($4 + 152 | 0 | 7 | 0 | 0, memcpy($4 + 224 | 0 | 7 | 0 | 0, ($4 + 296 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   $1 = ($4 + 80 | 0) + 8 | 0;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 296 | 0 | 0, 1051768 | 0, 12 | 0);
   memcpy($0 + 8 | 0 | 0, memcpy($4 + 8 | 0 | 7 | 0 | 0, $1 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   HEAP8[$0 >> 0] = 1;
  }
  global$0 = $4 + 368 | 0;
 }
 
 function $cardano_serialization_lib__plutus__PlutusData_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__haa2b047fc7012f29($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$5 = 0, i64toi32_i32$4 = 0, i64toi32_i32$1 = 0, $3 = 0, $4 = 0, $6$hi = 0, $6 = 0, $7$hi = 0, $39 = 0, $45 = 0, $51 = 0, $54 = 0, $7 = 0, $5 = 0, $116 = 0, $121 = 0, $127 = 0, $133 = 0, $134 = 0, $136 = 0, $136$hi = 0, $138 = 0, $138$hi = 0, $154 = 0, $159 = 0, $164 = 0;
  $2 = global$0 - 192 | 0;
  global$0 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 120 | 0) >> 2] = 2;
  HEAP32[($2 + 124 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 128 | 0) >> 2] = 0;
  HEAP32[($2 + 132 | 0) >> 2] = i64toi32_i32$0;
  $std__io__cursor__Cursor_T__20as_20std__io__Seek___seek__h4fe82da83d4d5304($2 + 56 | 0 | 0, $1 | 0, $2 + 120 | 0 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ((HEAP32[($2 + 56 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      i64toi32_i32$2 = ($2 + 56 | 0) + 8 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $6 = i64toi32_i32$0;
      $6$hi = i64toi32_i32$1;
      $cardano_serialization_lib__plutus__PlutusDataEnum_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hb5386eba8d42c5df($2 + 120 | 0 | 0, $1 | 0);
      $3 = ($2 + 120 | 0) + 8 | 0;
      label$5 : {
       label$6 : {
        i64toi32_i32$2 = $2;
        i64toi32_i32$1 = HEAP32[($2 + 120 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[($2 + 124 | 0) >> 2] | 0;
        i64toi32_i32$2 = i64toi32_i32$1;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
         break label$6
        }
        i64toi32_i32$3 = $3 + 8 | 0;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $39 = i64toi32_i32$2;
        i64toi32_i32$2 = ($2 + 24 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$2 >> 2] = $39;
        HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$3 = $3 + 16 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $45 = i64toi32_i32$0;
        i64toi32_i32$0 = ($2 + 24 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $45;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
        i64toi32_i32$3 = $3 + 24 | 0;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $51 = i64toi32_i32$2;
        i64toi32_i32$2 = ($2 + 24 | 0) + 24 | 0;
        HEAP32[i64toi32_i32$2 >> 2] = $51;
        HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$3 = $3;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $54 = i64toi32_i32$0;
        i64toi32_i32$0 = $2;
        HEAP32[($2 + 24 | 0) >> 2] = $54;
        HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$2;
        i64toi32_i32$0 = $2;
        i64toi32_i32$2 = 0;
        HEAP32[($2 + 120 | 0) >> 2] = 2;
        HEAP32[($2 + 124 | 0) >> 2] = i64toi32_i32$2;
        i64toi32_i32$0 = $2;
        i64toi32_i32$2 = 0;
        HEAP32[($2 + 128 | 0) >> 2] = 0;
        HEAP32[($2 + 132 | 0) >> 2] = i64toi32_i32$2;
        $std__io__cursor__Cursor_T__20as_20std__io__Seek___seek__h4fe82da83d4d5304($2 + 56 | 0 | 0, $1 | 0, $2 + 120 | 0 | 0);
        if ((HEAP32[($2 + 56 | 0) >> 2] | 0 | 0) == (1 | 0)) {
         break label$3
        }
        i64toi32_i32$3 = $2 + 64 | 0;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $7 = i64toi32_i32$2;
        $7$hi = i64toi32_i32$0;
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = 0;
        HEAP32[($2 + 120 | 0) >> 2] = 0;
        HEAP32[($2 + 124 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$0 = $6$hi;
        i64toi32_i32$2 = $2;
        HEAP32[($2 + 128 | 0) >> 2] = $6;
        HEAP32[($2 + 132 | 0) >> 2] = i64toi32_i32$0;
        $std__io__cursor__Cursor_T__20as_20std__io__Seek___seek__h4fe82da83d4d5304($2 + 56 | 0 | 0, $1 | 0, $2 + 120 | 0 | 0);
        if ((HEAP32[($2 + 56 | 0) >> 2] | 0 | 0) == (1 | 0)) {
         break label$2
        }
        std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 16 | 0 | 0, $1 | 0);
        $4 = HEAP32[($2 + 20 | 0) >> 2] | 0;
        i64toi32_i32$0 = $7$hi;
        i64toi32_i32$0 = $6$hi;
        i64toi32_i32$0 = $7$hi;
        i64toi32_i32$3 = $7;
        i64toi32_i32$2 = $6$hi;
        i64toi32_i32$1 = $6;
        i64toi32_i32$4 = i64toi32_i32$3 - i64toi32_i32$1 | 0;
        i64toi32_i32$5 = (i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0) + i64toi32_i32$2 | 0;
        i64toi32_i32$5 = i64toi32_i32$0 - i64toi32_i32$5 | 0;
        $6 = i64toi32_i32$4;
        $6$hi = i64toi32_i32$5;
        $3 = i64toi32_i32$4;
        if ($4 >>> 0 < i64toi32_i32$4 >>> 0) {
         break label$1
        }
        $4 = HEAP32[($2 + 16 | 0) >> 2] | 0;
        alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 + 8 | 0 | 0, $3 | 0, 0 | 0);
        $5 = HEAP32[($2 + 12 | 0) >> 2] | 0;
        $4 = memcpy(HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, $4 | 0, $3 | 0) | 0;
        HEAP32[($0 + 48 | 0) >> 2] = $3;
        HEAP32[($0 + 44 | 0) >> 2] = $5;
        HEAP32[($0 + 40 | 0) >> 2] = $4;
        i64toi32_i32$3 = $0;
        i64toi32_i32$5 = 0;
        HEAP32[i64toi32_i32$3 >> 2] = 0;
        HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
        i64toi32_i32$0 = $2;
        i64toi32_i32$5 = HEAP32[($2 + 24 | 0) >> 2] | 0;
        i64toi32_i32$3 = HEAP32[($2 + 28 | 0) >> 2] | 0;
        $116 = i64toi32_i32$5;
        i64toi32_i32$5 = $0;
        HEAP32[(i64toi32_i32$5 + 8 | 0) >> 2] = $116;
        HEAP32[(i64toi32_i32$5 + 12 | 0) >> 2] = i64toi32_i32$3;
        i64toi32_i32$0 = $2 + 32 | 0;
        i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
        i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
        $121 = i64toi32_i32$3;
        i64toi32_i32$3 = $0 + 16 | 0;
        HEAP32[i64toi32_i32$3 >> 2] = $121;
        HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
        i64toi32_i32$0 = ($2 + 24 | 0) + 16 | 0;
        i64toi32_i32$5 = HEAP32[i64toi32_i32$0 >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
        $127 = i64toi32_i32$5;
        i64toi32_i32$5 = $0 + 24 | 0;
        HEAP32[i64toi32_i32$5 >> 2] = $127;
        HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$3;
        i64toi32_i32$0 = ($2 + 24 | 0) + 24 | 0;
        i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
        i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
        $133 = i64toi32_i32$3;
        i64toi32_i32$3 = $0 + 32 | 0;
        HEAP32[i64toi32_i32$3 >> 2] = $133;
        HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
        $134 = $1;
        i64toi32_i32$0 = $1;
        i64toi32_i32$5 = HEAP32[i64toi32_i32$0 >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
        $136 = i64toi32_i32$5;
        $136$hi = i64toi32_i32$3;
        i64toi32_i32$3 = $6$hi;
        i64toi32_i32$0 = $6;
        i64toi32_i32$5 = 0;
        i64toi32_i32$1 = -1;
        i64toi32_i32$5 = i64toi32_i32$3 & i64toi32_i32$5 | 0;
        $138 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
        $138$hi = i64toi32_i32$5;
        i64toi32_i32$5 = $136$hi;
        i64toi32_i32$3 = $136;
        i64toi32_i32$0 = $138$hi;
        i64toi32_i32$1 = $138;
        i64toi32_i32$2 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
        i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
        if (i64toi32_i32$2 >>> 0 < i64toi32_i32$1 >>> 0) {
         i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
        }
        i64toi32_i32$3 = $134;
        HEAP32[i64toi32_i32$3 >> 2] = i64toi32_i32$2;
        HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$4;
        break label$5;
       }
       memcpy($2 + 56 | 0 | 0, $3 | 0, 64 | 0) | 0;
       memcpy($0 + 8 | 0 | 0, $2 + 56 | 0 | 0, 64 | 0) | 0;
       i64toi32_i32$3 = $0;
       i64toi32_i32$4 = 0;
       HEAP32[i64toi32_i32$3 >> 2] = 1;
       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$4;
      }
      global$0 = $2 + 192 | 0;
      return;
     }
     i64toi32_i32$5 = $2;
     i64toi32_i32$4 = HEAP32[($2 + 60 | 0) >> 2] | 0;
     i64toi32_i32$3 = HEAP32[($2 + 64 | 0) >> 2] | 0;
     $154 = i64toi32_i32$4;
     i64toi32_i32$4 = $2;
     HEAP32[($2 + 120 | 0) >> 2] = $154;
     HEAP32[($2 + 124 | 0) >> 2] = i64toi32_i32$3;
     core__result__unwrap_failed__h27f43d993c3864a1(1070651 | 0, 43 | 0, $2 + 120 | 0 | 0, 1070696 | 0, 1071116 | 0);
     abort();
    }
    i64toi32_i32$5 = $2;
    i64toi32_i32$3 = HEAP32[($2 + 60 | 0) >> 2] | 0;
    i64toi32_i32$4 = HEAP32[($2 + 64 | 0) >> 2] | 0;
    $159 = i64toi32_i32$3;
    i64toi32_i32$3 = $2;
    HEAP32[($2 + 120 | 0) >> 2] = $159;
    HEAP32[($2 + 124 | 0) >> 2] = i64toi32_i32$4;
    core__result__unwrap_failed__h27f43d993c3864a1(1070651 | 0, 43 | 0, $2 + 120 | 0 | 0, 1070696 | 0, 1071132 | 0);
    abort();
   }
   i64toi32_i32$5 = $2;
   i64toi32_i32$4 = HEAP32[($2 + 60 | 0) >> 2] | 0;
   i64toi32_i32$3 = HEAP32[($2 + 64 | 0) >> 2] | 0;
   $164 = i64toi32_i32$4;
   i64toi32_i32$4 = $2;
   HEAP32[($2 + 120 | 0) >> 2] = $164;
   HEAP32[($2 + 124 | 0) >> 2] = i64toi32_i32$3;
   core__result__unwrap_failed__h27f43d993c3864a1(1070651 | 0, 43 | 0, $2 + 120 | 0 | 0, 1070696 | 0, 1071148 | 0);
   abort();
  }
  core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($3 | 0, $4 | 0, 1071164 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__BalancingContext_K_2cV___do_merge__hf05e236205b9e3b0($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $9 = 0, i64toi32_i32$0 = 0, $11 = 0, $13 = 0, $14 = 0, $15 = 0, $3 = 0, i64toi32_i32$1 = 0, $5 = 0, $4 = 0, $6 = 0, $7 = 0, $2 = 0, $8 = 0, $12 = 0, $10 = 0, $61 = 0, $84 = 0, $114 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   $3 = HEAP32[($1 + 16 | 0) >> 2] | 0;
   $4 = HEAPU16[($3 + 226 | 0) >> 1] | 0;
   $5 = $4 + 1 | 0;
   $6 = HEAP32[($1 + 24 | 0) >> 2] | 0;
   $7 = HEAPU16[($6 + 226 | 0) >> 1] | 0;
   $8 = $5 + $7 | 0;
   if ($8 >>> 0 > 11 >>> 0) {
    break label$1
   }
   $9 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   $10 = HEAP32[$1 >> 2] | 0;
   $11 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   $12 = HEAPU16[($11 + 226 | 0) >> 1] | 0;
   HEAP16[($3 + 226 | 0) >> 1] = $8;
   $13 = $2 + 8 | 0;
   $1 = $11 + Math_imul($9, 12) | 0;
   HEAP32[$13 >> 2] = HEAP32[($1 + 100 | 0) >> 2] | 0;
   $14 = $1 + 92 | 0;
   i64toi32_i32$0 = HEAP32[$14 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($14 + 4 | 0) >> 2] | 0;
   $61 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   HEAP32[i64toi32_i32$0 >> 2] = $61;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   $15 = $12 + ($9 ^ -1 | 0) | 0;
   memmove($14 | 0, $1 + 104 | 0 | 0, Math_imul($15, 12) | 0) | 0;
   $1 = $3 + 92 | 0;
   $14 = $1 + Math_imul($4, 12) | 0;
   HEAP32[($14 + 8 | 0) >> 2] = HEAP32[$13 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $84 = i64toi32_i32$1;
   i64toi32_i32$1 = $14;
   HEAP32[i64toi32_i32$1 >> 2] = $84;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   memcpy($1 + Math_imul($5, 12) | 0 | 0, $6 + 92 | 0 | 0, Math_imul($7, 12) | 0) | 0;
   $13 = $11 + ($9 << 3 | 0) | 0;
   i64toi32_i32$0 = HEAP32[$13 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($13 + 4 | 0) >> 2] | 0;
   $1 = $9 + 1 | 0;
   memmove($13 | 0, $11 + ($1 << 3 | 0) | 0 | 0, $15 << 3 | 0 | 0) | 0;
   $114 = i64toi32_i32$0;
   i64toi32_i32$0 = $3 + ($4 << 3 | 0) | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $114;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   memcpy($3 + ($5 << 3 | 0) | 0 | 0, $6 | 0, $7 << 3 | 0 | 0) | 0;
   $13 = 232;
   $14 = $11 + 232 | 0;
   $9 = $9 << 2 | 0;
   memmove($14 + ($1 << 2 | 0) | 0 | 0, ($9 + $14 | 0) + 8 | 0 | 0, $15 << 2 | 0 | 0) | 0;
   label$2 : {
    if ($1 >>> 0 >= $12 >>> 0) {
     break label$2
    }
    $9 = ($9 + $11 | 0) + 236 | 0;
    label$3 : while (1) {
     $15 = HEAP32[$9 >> 2] | 0;
     HEAP16[($15 + 224 | 0) >> 1] = $1;
     HEAP32[($15 + 88 | 0) >> 2] = $11;
     $9 = $9 + 4 | 0;
     $1 = $1 + 1 | 0;
     if (($12 | 0) != ($1 | 0)) {
      continue label$3
     }
     break label$3;
    };
   }
   HEAP16[($11 + 226 | 0) >> 1] = (HEAPU16[($11 + 226 | 0) >> 1] | 0) + -1 | 0;
   label$4 : {
    if ($10 >>> 0 <= 1 >>> 0) {
     break label$4
    }
    memcpy(($3 + ($5 << 2 | 0) | 0) + 232 | 0 | 0, $6 + 232 | 0 | 0, ($7 << 2 | 0) + 4 | 0 | 0) | 0;
    $13 = 280;
    if ($8 >>> 0 <= $4 >>> 0) {
     break label$4
    }
    $9 = $7 + 1 | 0;
    $1 = (($4 << 2 | 0) + $3 | 0) + 236 | 0;
    label$5 : while (1) {
     $15 = HEAP32[$1 >> 2] | 0;
     HEAP16[($15 + 224 | 0) >> 1] = $5;
     HEAP32[($15 + 88 | 0) >> 2] = $3;
     $1 = $1 + 4 | 0;
     $5 = $5 + 1 | 0;
     $9 = $9 + -1 | 0;
     if ($9) {
      continue label$5
     }
     break label$5;
    };
   }
   __rust_dealloc($6 | 0, $13 | 0, 8 | 0);
   HEAP32[($0 + 4 | 0) >> 2] = $11;
   HEAP32[$0 >> 2] = $10;
   global$0 = $2 + 16 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1049692 | 0, 42 | 0, 1049736 | 0);
  abort();
 }
 
 function cardano_serialization_lib__address__Address__to_bech32__hbfd70d34cd59700e($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $5 = 0, $5$hi = 0, $17 = 0, $53 = 0, $70 = 0, $79 = 0, $4 = 0, $109 = 0, $117 = 0;
  $3 = global$0 - 144 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if (HEAP32[$2 >> 2] | 0) {
       break label$4
      }
      $2 = (HEAPU8[$1 >> 0] | 0 | 0) == (3 | 0);
      HEAP32[($3 + 140 | 0) >> 2] = $2 ? 5 : 4;
      HEAP32[($3 + 136 | 0) >> 2] = $2 ? 1070534 : 1070530;
      i64toi32_i32$0 = cardano_serialization_lib__address__Address__network_id__h6a5da16b4c596a9d($1 | 0) | 0;
      i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
      $5 = i64toi32_i32$0;
      $5$hi = i64toi32_i32$1;
      i64toi32_i32$2 = i64toi32_i32$0;
      i64toi32_i32$0 = 0;
      i64toi32_i32$3 = 1;
      i64toi32_i32$0 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
      if (!!(i64toi32_i32$2 & i64toi32_i32$3 | 0 | i64toi32_i32$0 | 0)) {
       break label$2
      }
      i64toi32_i32$0 = $5$hi;
      i64toi32_i32$1 = $5;
      i64toi32_i32$2 = 0;
      i64toi32_i32$3 = 65280;
      i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
      $2 = !(i64toi32_i32$1 & i64toi32_i32$3 | 0 | i64toi32_i32$2 | 0);
      HEAP32[($3 + 76 | 0) >> 2] = $2 ? 5 : 0;
      HEAP32[($3 + 72 | 0) >> 2] = $2 ? 1070539 : 1070056;
      core__fmt__ArgumentV1__new__hbd2b9e6635c55d43($3 + 32 | 0 | 0, $3 + 136 | 0 | 0, 1 | 0);
      i64toi32_i32$0 = $3;
      i64toi32_i32$2 = HEAP32[($3 + 32 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($3 + 36 | 0) >> 2] | 0;
      $5 = i64toi32_i32$2;
      $5$hi = i64toi32_i32$1;
      core__fmt__ArgumentV1__new__hbd2b9e6635c55d43($3 + 24 | 0 | 0, $3 + 72 | 0 | 0, 1 | 0);
      HEAP32[($3 + 132 | 0) >> 2] = 2;
      i64toi32_i32$2 = $3;
      HEAP32[($3 + 56 | 0) >> 2] = $5;
      HEAP32[($3 + 60 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $3;
      i64toi32_i32$1 = 0;
      HEAP32[($3 + 116 | 0) >> 2] = 2;
      HEAP32[($3 + 120 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($3 + 112 | 0) >> 2] = 1070544;
      i64toi32_i32$0 = $3;
      i64toi32_i32$1 = HEAP32[($3 + 24 | 0) >> 2] | 0;
      i64toi32_i32$2 = HEAP32[($3 + 28 | 0) >> 2] | 0;
      $53 = i64toi32_i32$1;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 64 | 0) >> 2] = $53;
      HEAP32[($3 + 68 | 0) >> 2] = i64toi32_i32$2;
      HEAP32[($3 + 128 | 0) >> 2] = $3 + 56 | 0;
      alloc__fmt__format__h6e9e003a52c07309($3 + 96 | 0 | 0, $3 + 112 | 0 | 0);
      HEAP32[(($3 + 40 | 0) + 8 | 0) >> 2] = HEAP32[(($3 + 96 | 0) + 8 | 0) >> 2] | 0;
      i64toi32_i32$0 = $3;
      i64toi32_i32$2 = HEAP32[($3 + 96 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($3 + 100 | 0) >> 2] | 0;
      $70 = i64toi32_i32$2;
      i64toi32_i32$2 = $3;
      HEAP32[($3 + 40 | 0) >> 2] = $70;
      HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$1;
      break label$3;
     }
     HEAP32[(($3 + 40 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
     i64toi32_i32$0 = $2;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $79 = i64toi32_i32$1;
     i64toi32_i32$1 = $3;
     HEAP32[($3 + 40 | 0) >> 2] = $79;
     HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$2;
    }
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 16 | 0 | 0, $3 + 40 | 0 | 0);
    $2 = HEAP32[($3 + 20 | 0) >> 2] | 0;
    $4 = HEAP32[($3 + 16 | 0) >> 2] | 0;
    cardano_serialization_lib__address__Address__to_bytes__h301d351bd02ea9f1($3 + 72 | 0 | 0, $1 | 0);
    bech32__ToBase32__to_base32__h098342a721ba9592($3 + 112 | 0 | 0, $3 + 72 | 0 | 0);
    bech32__encode__h3845e4a9162a8761($3 + 56 | 0 | 0, $4 | 0, $2 | 0, $3 + 112 | 0 | 0);
    $2 = 1;
    label$5 : {
     label$6 : {
      if ((HEAP32[($3 + 56 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$6
      }
      $2 = $3 + 56 | 0 | 4 | 0;
      i64toi32_i32$0 = $2;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
      $109 = i64toi32_i32$2;
      i64toi32_i32$2 = $0;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = $109;
      HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] | 0;
      $2 = 0;
      break label$5;
     }
     i64toi32_i32$0 = $3;
     i64toi32_i32$1 = HEAP32[($3 + 60 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[($3 + 64 | 0) >> 2] | 0;
     $117 = i64toi32_i32$1;
     i64toi32_i32$1 = $3;
     HEAP32[($3 + 88 | 0) >> 2] = $117;
     HEAP32[($3 + 92 | 0) >> 2] = i64toi32_i32$2;
     HEAP32[($3 + 132 | 0) >> 2] = 1;
     i64toi32_i32$1 = $3;
     i64toi32_i32$2 = 0;
     HEAP32[($3 + 116 | 0) >> 2] = 1;
     HEAP32[($3 + 120 | 0) >> 2] = i64toi32_i32$2;
     HEAP32[($3 + 112 | 0) >> 2] = 1070340;
     HEAP32[($3 + 140 | 0) >> 2] = 113;
     HEAP32[($3 + 128 | 0) >> 2] = $3 + 136 | 0;
     HEAP32[($3 + 136 | 0) >> 2] = $3 + 88 | 0;
     alloc__fmt__format__h6e9e003a52c07309($3 + 96 | 0 | 0, $3 + 112 | 0 | 0);
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $3 + 96 | 0 | 0);
     $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($3 + 8 | 0) >> 2] | 0 | 0, HEAP32[($3 + 12 | 0) >> 2] | 0 | 0) | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 96 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 96 | 0 | 0);
     HEAP32[($0 + 4 | 0) >> 2] = $1;
    }
    HEAP32[$0 >> 2] = $2;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 40 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 40 | 0 | 0);
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 72 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 72 | 0 | 0);
    break label$1;
   }
   i64toi32_i32$2 = $5$hi;
   i64toi32_i32$0 = $5;
   i64toi32_i32$1 = 0;
   i64toi32_i32$3 = 32;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$1 = 0;
    $17 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   } else {
    i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
    $17 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
   }
   $2 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($17 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
   HEAP32[($0 + 4 | 0) >> 2] = $2;
  }
  global$0 = $3 + 144 | 0;
 }
 
 function alloc__collections__btree__remove___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__KV____remove_internal_kv__hb22ff264cc4c624d($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, $4 = 0, $6 = 0, $7 = 0, $5 = 0, $9 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $9$hi = 0, $8 = 0, $98 = 0, $105 = 0, $112 = 0, $116 = 0, $120 = 0, $147 = 0;
  $3 = global$0 - 112 | 0;
  global$0 = $3;
  $4 = HEAP32[(((HEAP32[($1 + 4 | 0) >> 2] | 0) + ((HEAP32[($1 + 8 | 0) >> 2] | 0) << 2 | 0) | 0) + 448 | 0) >> 2] | 0;
  label$1 : {
   $1 = (HEAP32[$1 >> 2] | 0) + -1 | 0;
   if (!$1) {
    break label$1
   }
   label$2 : while (1) {
    $4 = HEAP32[(($4 + ((HEAPU16[($4 + 138 | 0) >> 1] | 0) << 2 | 0) | 0) + 448 | 0) >> 2] | 0;
    $1 = $1 + -1 | 0;
    if ($1) {
     continue label$2
    }
    break label$2;
   };
  }
  $1 = HEAPU16[($4 + 138 | 0) >> 1] | 0;
  HEAP32[$3 >> 2] = 0;
  HEAP32[($3 + 8 | 0) >> 2] = $1 ? $1 + -1 | 0 : 0;
  HEAP32[($3 + 4 | 0) >> 2] = $1 ? $4 : 0;
  alloc__collections__btree__remove___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__KV____remove_leaf_kv__hcb9d23746722cda3($3 + 40 | 0 | 0, $3 | 0, $2 | 0);
  $2 = memcpy($3 | 0, $3 + 40 | 0 | 0, 40 | 0) | 0;
  $5 = HEAP32[($2 + 80 | 0) >> 2] | 0;
  label$3 : {
   label$4 : {
    $3 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    $1 = HEAP32[($2 + 84 | 0) >> 2] | 0;
    if ($3 >>> 0 >= (HEAPU16[($1 + 138 | 0) >> 1] | 0) >>> 0) {
     break label$4
    }
    $4 = $1;
    break label$3;
   }
   label$5 : while (1) {
    label$6 : {
     $4 = HEAP32[$1 >> 2] | 0;
     if ($4) {
      break label$6
     }
     $4 = 0;
     break label$3;
    }
    $5 = $5 + 1 | 0;
    $3 = HEAPU16[($1 + 136 | 0) >> 1] | 0;
    $1 = $4;
    if ($3 >>> 0 >= (HEAPU16[($1 + 138 | 0) >> 1] | 0) >>> 0) {
     continue label$5
    }
    break label$5;
   };
  }
  $1 = $4 + Math_imul($3, 28) | 0;
  $6 = $1 + 164 | 0;
  HEAP32[(($2 + 40 | 0) + 24 | 0) >> 2] = HEAPU8[$6 >> 0] | 0 | ((HEAPU8[($6 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($6 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($6 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $7 = $1 + 156 | 0;
  i64toi32_i32$2 = $7;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $98 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 40 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $98;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $8 = $1 + 148 | 0;
  i64toi32_i32$2 = $8;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $105 = i64toi32_i32$1;
  i64toi32_i32$1 = ($2 + 40 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $105;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $1 = $1 + 140 | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $9 = i64toi32_i32$0;
  $9$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $112 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  $20 = $112;
  HEAP8[$1 >> 0] = $20;
  HEAP8[($1 + 1 | 0) >> 0] = $20 >>> 8 | 0;
  HEAP8[($1 + 2 | 0) >> 0] = $20 >>> 16 | 0;
  HEAP8[($1 + 3 | 0) >> 0] = $20 >>> 24 | 0;
  HEAP8[($1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[($1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[($1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[($1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $116 = i64toi32_i32$0;
  i64toi32_i32$0 = $8;
  $21 = $116;
  HEAP8[i64toi32_i32$0 >> 0] = $21;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $21 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $21 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $21 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $120 = i64toi32_i32$1;
  i64toi32_i32$1 = $7;
  $22 = $120;
  HEAP8[i64toi32_i32$1 >> 0] = $22;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $22 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $22 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $22 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $23 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  HEAP8[$6 >> 0] = $23;
  HEAP8[($6 + 1 | 0) >> 0] = $23 >>> 8 | 0;
  HEAP8[($6 + 2 | 0) >> 0] = $23 >>> 16 | 0;
  HEAP8[($6 + 3 | 0) >> 0] = $23 >>> 24 | 0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$1 = $2;
  HEAP32[(i64toi32_i32$1 + 40 | 0) >> 2] = $9;
  HEAP32[(i64toi32_i32$1 + 44 | 0) >> 2] = i64toi32_i32$0;
  $1 = $4 + Math_imul($3, 12) | 0;
  $6 = $1 + 12 | 0;
  $7 = HEAP32[$6 >> 2] | 0;
  HEAP32[((i64toi32_i32$1 + 96 | 0) + 8 | 0) >> 2] = $7;
  $1 = $1 + 4 | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $9 = i64toi32_i32$0;
  $9$hi = i64toi32_i32$1;
  i64toi32_i32$0 = $2;
  HEAP32[(i64toi32_i32$0 + 96 | 0) >> 2] = $9;
  HEAP32[(i64toi32_i32$0 + 100 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
  $147 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[$1 >> 2] = $147;
  HEAP32[($1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[$6 >> 2] = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
  HEAP32[((i64toi32_i32$2 + 40 | 0) + 36 | 0) >> 2] = $7;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] = $9;
  HEAP32[(i64toi32_i32$2 + 72 | 0) >> 2] = i64toi32_i32$0;
  label$7 : {
   label$8 : {
    if ($5) {
     break label$8
    }
    $3 = $3 + 1 | 0;
    break label$7;
   }
   $4 = HEAP32[((($3 << 2 | 0) + $4 | 0) + 452 | 0) >> 2] | 0;
   label$9 : {
    $1 = $5 + -1 | 0;
    if (!$1) {
     break label$9
    }
    label$10 : while (1) {
     $4 = HEAP32[($4 + 448 | 0) >> 2] | 0;
     $1 = $1 + -1 | 0;
     if ($1) {
      continue label$10
     }
     break label$10;
    };
   }
   $3 = 0;
  }
  $1 = memcpy($0 | 0, $2 + 40 | 0 | 0, 40 | 0) | 0;
  HEAP32[($1 + 48 | 0) >> 2] = $3;
  HEAP32[($1 + 44 | 0) >> 2] = $4;
  HEAP32[($1 + 40 | 0) >> 2] = 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__utils__min_ada_required__hfea4b15a263723f5($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, i64toi32_i32$0 = 0, $9$hi = 0, i64toi32_i32$5 = 0, i64toi32_i32$1 = 0, $9 = 0, $7 = 0, $5 = 0, $8$hi = 0, $6 = 0, $8 = 0, $67 = 0, $72 = 0, $78 = 0, $10 = 0, $10$hi = 0, $147 = 0, $149 = 0, $149$hi = 0, $152$hi = 0, $161 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $4 = global$0 - 240 | 0;
  global$0 = $4;
  i64toi32_i32$4 = $2;
  i64toi32_i32$0 = 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = i64toi32_i32$4 ? 10 : 0;
  i64toi32_i32$2 = i64toi32_i32$4 ? i64toi32_i32$0 : i64toi32_i32$1;
  $8 = i64toi32_i32$3;
  $8$hi = i64toi32_i32$2;
  i64toi32_i32$2 = 0;
  $9 = 29;
  $9$hi = i64toi32_i32$2;
  label$1 : {
   if ((HEAP32[($1 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   $5 = $1 + 12 | 0;
   alloc__collections__btree__map__BTreeMap_K_2cV___iter__h677e802ff7e211c3($4 + 80 | 0 | 0, $5 | 0);
   $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h03cc330b7b1e4522($4 + 72 | 0 | 0, $4 + 80 | 0 | 0);
   label$2 : {
    label$3 : {
     if (HEAP32[($4 + 72 | 0) >> 2] | 0) {
      break label$3
     }
     $6 = 7;
     break label$2;
    }
    $1 = HEAP32[((HEAP32[($4 + 76 | 0) >> 2] | 0) + 8 | 0) >> 2] | 0;
    $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h03cc330b7b1e4522($4 + 64 | 0 | 0, $4 + 80 | 0 | 0);
    label$4 : {
     if (!(HEAP32[($4 + 64 | 0) >> 2] | 0)) {
      break label$4
     }
     $2 = HEAP32[($4 + 68 | 0) >> 2] | 0;
     label$5 : while (1) {
      $1 = (HEAP32[($2 + 8 | 0) >> 2] | 0) + $1 | 0;
      $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h03cc330b7b1e4522($4 + 56 | 0 | 0, $4 + 80 | 0 | 0);
      $2 = HEAP32[($4 + 60 | 0) >> 2] | 0;
      if (HEAP32[($4 + 56 | 0) >> 2] | 0) {
       continue label$5
      }
      break label$5;
     };
    }
    $6 = Math_imul($1, 12) + 7 | 0;
   }
   alloc__collections__btree__map__BTreeMap_K_2cV___iter__h677e802ff7e211c3($4 + 208 | 0 | 0, $5 | 0);
   $1 = 0;
   HEAP32[($4 + 176 | 0) >> 2] = 0;
   HEAP32[($4 + 144 | 0) >> 2] = 0;
   i64toi32_i32$4 = $4;
   i64toi32_i32$2 = HEAP32[($4 + 208 | 0) >> 2] | 0;
   i64toi32_i32$3 = HEAP32[($4 + 212 | 0) >> 2] | 0;
   $67 = i64toi32_i32$2;
   i64toi32_i32$2 = $4 + 116 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $67;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$4 = $4 + 216 | 0;
   i64toi32_i32$3 = HEAP32[i64toi32_i32$4 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
   $72 = i64toi32_i32$3;
   i64toi32_i32$3 = $4 + 124 | 0;
   HEAP32[i64toi32_i32$3 >> 2] = $72;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$4 = ($4 + 208 | 0) + 16 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$4 >> 2] | 0;
   i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
   $78 = i64toi32_i32$2;
   i64toi32_i32$2 = $4 + 132 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $78;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
   HEAP32[($4 + 140 | 0) >> 2] = HEAP32[(($4 + 208 | 0) + 24 | 0) >> 2] | 0;
   HEAP32[($4 + 112 | 0) >> 2] = 1;
   std__thread__local__LocalKey_T___with__h4cd07b14a44a727e($4 + 40 | 0 | 0, 1060968 | 0);
   i64toi32_i32$4 = $4;
   i64toi32_i32$3 = HEAP32[($4 + 40 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($4 + 44 | 0) >> 2] | 0;
   $9 = i64toi32_i32$3;
   $9$hi = i64toi32_i32$2;
   i64toi32_i32$4 = $4;
   i64toi32_i32$2 = HEAP32[($4 + 48 | 0) >> 2] | 0;
   i64toi32_i32$3 = HEAP32[($4 + 52 | 0) >> 2] | 0;
   $10 = i64toi32_i32$2;
   $10$hi = i64toi32_i32$3;
   $2 = hashbrown__raw__generic__Group__static_empty__hc5a7932fe1bdb1f1() | 0;
   i64toi32_i32$2 = ($4 + 80 | 0) + 24 | 0;
   i64toi32_i32$3 = 0;
   HEAP32[i64toi32_i32$2 >> 2] = 0;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
   HEAP32[($4 + 100 | 0) >> 2] = $2;
   HEAP32[($4 + 96 | 0) >> 2] = 0;
   i64toi32_i32$3 = $10$hi;
   i64toi32_i32$2 = $4;
   HEAP32[($4 + 88 | 0) >> 2] = $10;
   HEAP32[($4 + 92 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$3 = $9$hi;
   i64toi32_i32$2 = $4;
   HEAP32[($4 + 80 | 0) >> 2] = $9;
   HEAP32[($4 + 84 | 0) >> 2] = i64toi32_i32$3;
   $2 = 0;
   label$6 : {
    $7 = $itertools__unique_impl__UniqueBy_I_2cV_2cF__20as_20core__iter__traits__iterator__Iterator___next__h5db2cd474a34beda($4 + 80 | 0 | 0) | 0;
    if (!$7) {
     break label$6
    }
    $2 = 0;
    label$7 : while (1) {
     $2 = (HEAP32[($7 + 8 | 0) >> 2] | 0) + $2 | 0;
     $7 = $itertools__unique_impl__UniqueBy_I_2cV_2cF__20as_20core__iter__traits__iterator__Iterator___next__h5db2cd474a34beda($4 + 80 | 0 | 0) | 0;
     if ($7) {
      continue label$7
     }
     break label$7;
    };
   }
   $hashbrown__raw__RawTable_T_2cA__20as_20core__ops__drop__Drop___drop__hc75129679f205904(($4 + 80 | 0) + 16 | 0 | 0);
   alloc__collections__btree__map__BTreeMap_K_2cV___iter__h677e802ff7e211c3($4 + 80 | 0 | 0, $5 | 0);
   $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h03cc330b7b1e4522($4 + 32 | 0 | 0, $4 + 80 | 0 | 0);
   label$8 : {
    if (!(HEAP32[($4 + 32 | 0) >> 2] | 0)) {
     break label$8
    }
    $1 = 0;
    label$9 : while (1) {
     $1 = $1 + 28 | 0;
     $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h03cc330b7b1e4522($4 + 24 | 0 | 0, $4 + 80 | 0 | 0);
     if (HEAP32[($4 + 24 | 0) >> 2] | 0) {
      continue label$9
     }
     break label$9;
    };
   }
   i64toi32_i32$3 = 0;
   $9 = ((($2 + $6 | 0) + $1 | 0) >>> 3 | 0) + 33 | 0;
   $9$hi = i64toi32_i32$3;
  }
  $147 = $4 + 8 | 0;
  i64toi32_i32$4 = $3;
  i64toi32_i32$3 = HEAP32[i64toi32_i32$4 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
  $149 = i64toi32_i32$3;
  $149$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$4 = $9;
  i64toi32_i32$3 = $8$hi;
  i64toi32_i32$0 = $8;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $152$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $149$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$2 = $152$hi;
  i64toi32_i32$0 = 0;
  __multi3($147 | 0, $149 | 0, i64toi32_i32$5 | 0, 0 | 0, i64toi32_i32$4 | 0, i64toi32_i32$1 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$0 | 0);
  label$10 : {
   label$11 : {
    i64toi32_i32$4 = $4;
    i64toi32_i32$0 = HEAP32[($4 + 16 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($4 + 20 | 0) >> 2] | 0;
    if (!(i64toi32_i32$0 | i64toi32_i32$2 | 0)) {
     break label$11
    }
    (wasm2js_i32$0 = $0, wasm2js_i32$1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1058732 | 0, 8 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
    $1 = 1;
    break label$10;
   }
   i64toi32_i32$4 = $4;
   i64toi32_i32$2 = HEAP32[($4 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($4 + 12 | 0) >> 2] | 0;
   $161 = i64toi32_i32$2;
   i64toi32_i32$2 = $0 + 8 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $161;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
   $1 = 0;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $4 + 240 | 0;
 }
 
 function cardano_serialization_lib__Mint__as_multiasset__hfae7c36e40af3e22($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $4 = 0, $8 = 0, $12$hi = 0, $28 = 0, $12 = 0, $6 = 0, $7 = 0, $9 = 0, $10 = 0, $11 = 0, $11$hi = 0, $29 = 0, $30 = 0, $31 = 0, $32 = 0, $33 = 0, $5 = 0, $43 = 0, $69 = 0, $106 = 0, $124 = 0, $139 = 0, $145 = 0, $148 = 0, $172 = 0;
  $3 = global$0 - 192 | 0;
  global$0 = $3;
  alloc__collections__btree__map__BTreeMap_K_2cV___iter__hbe8f4ddb910904b5($3 + 48 | 0 | 0, $1 | 0);
  i64toi32_i32$1 = $0;
  i64toi32_i32$0 = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
  $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h32d71c96a3c9fef9($3 + 40 | 0 | 0, $3 + 48 | 0 | 0);
  label$1 : {
   label$2 : {
    $4 = HEAP32[($3 + 40 | 0) >> 2] | 0;
    if (!$4) {
     break label$2
    }
    $1 = HEAP32[($3 + 44 | 0) >> 2] | 0;
    $5 = $3 + 128 | 0 | 4 | 0;
    label$3 : while (1) {
     $6 = ($3 + 96 | 0) + 8 | 0;
     $7 = $0 + 8 | 0;
     HEAP32[$6 >> 2] = HEAP32[$7 >> 2] | 0;
     i64toi32_i32$2 = $0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $43 = i64toi32_i32$0;
     i64toi32_i32$0 = $3;
     HEAP32[($3 + 96 | 0) >> 2] = $43;
     HEAP32[($3 + 100 | 0) >> 2] = i64toi32_i32$1;
     alloc__collections__btree__map__BTreeMap_K_2cV___iter__h3ab6a151beb58e6b($3 + 144 | 0 | 0, $1 | 0);
     i64toi32_i32$0 = $3;
     i64toi32_i32$1 = 0;
     HEAP32[($3 + 116 | 0) >> 2] = 0;
     HEAP32[($3 + 120 | 0) >> 2] = i64toi32_i32$1;
     $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__hce9499edf49fdc37($3 + 32 | 0 | 0, $3 + 144 | 0 | 0);
     label$4 : {
      $8 = HEAP32[($3 + 32 | 0) >> 2] | 0;
      if (!$8) {
       break label$4
      }
      $1 = HEAP32[($3 + 36 | 0) >> 2] | 0;
      label$5 : while (1) {
       $9 = ($3 + 176 | 0) + 8 | 0;
       $10 = ($3 + 112 | 0) + 8 | 0;
       HEAP32[$9 >> 2] = HEAP32[$10 >> 2] | 0;
       i64toi32_i32$2 = $3;
       i64toi32_i32$1 = HEAP32[($3 + 112 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[($3 + 116 | 0) >> 2] | 0;
       $69 = i64toi32_i32$1;
       i64toi32_i32$1 = $3;
       HEAP32[($3 + 176 | 0) >> 2] = $69;
       HEAP32[($3 + 180 | 0) >> 2] = i64toi32_i32$0;
       label$6 : {
        i64toi32_i32$2 = $1 + 8 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $11 = i64toi32_i32$0;
        $11$hi = i64toi32_i32$1;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = -1;
        i64toi32_i32$3 = -1;
        if ((i64toi32_i32$1 | 0) > (i64toi32_i32$0 | 0)) {
         $29 = 1
        } else {
         if ((i64toi32_i32$1 | 0) >= (i64toi32_i32$0 | 0)) {
          if (i64toi32_i32$2 >>> 0 <= i64toi32_i32$3 >>> 0) {
           $30 = 0
          } else {
           $30 = 1
          }
          $31 = $30;
         } else {
          $31 = 0
         }
         $29 = $31;
        }
        if ($29 ^ $2 | 0) {
         break label$6
        }
        i64toi32_i32$3 = $1;
        i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $12 = i64toi32_i32$2;
        $12$hi = i64toi32_i32$1;
        label$7 : {
         label$8 : {
          if ($2) {
           break label$8
          }
          i64toi32_i32$1 = $12$hi;
          i64toi32_i32$1 = 0;
          i64toi32_i32$3 = 0;
          i64toi32_i32$2 = $12$hi;
          i64toi32_i32$0 = $12;
          i64toi32_i32$5 = (i64toi32_i32$3 >>> 0 < i64toi32_i32$0 >>> 0) + i64toi32_i32$2 | 0;
          i64toi32_i32$5 = i64toi32_i32$1 - i64toi32_i32$5 | 0;
          $12 = i64toi32_i32$3 - i64toi32_i32$0 | 0;
          $12$hi = i64toi32_i32$5;
          i64toi32_i32$5 = $11$hi;
          i64toi32_i32$1 = $11;
          i64toi32_i32$3 = 0;
          i64toi32_i32$0 = 63;
          i64toi32_i32$2 = i64toi32_i32$0 & 31 | 0;
          if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
           i64toi32_i32$3 = 0;
           $32 = i64toi32_i32$5 >>> i64toi32_i32$2 | 0;
          } else {
           i64toi32_i32$3 = i64toi32_i32$5 >>> i64toi32_i32$2 | 0;
           $32 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$2 | 0) | 0;
          }
          $1 = $32;
          break label$7;
         }
         i64toi32_i32$3 = $11$hi;
         i64toi32_i32$5 = $11;
         i64toi32_i32$1 = 0;
         i64toi32_i32$0 = 63;
         i64toi32_i32$2 = i64toi32_i32$0 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
          i64toi32_i32$1 = 0;
          $33 = i64toi32_i32$3 >>> i64toi32_i32$2 | 0;
         } else {
          i64toi32_i32$1 = i64toi32_i32$3 >>> i64toi32_i32$2 | 0;
          $33 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$2 | 0) | 0;
         }
         $1 = $33 ^ 1 | 0;
        }
        if (!$1) {
         break label$1
        }
        $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($3 + 128 | 0 | 0, $8 | 0);
        i64toi32_i32$1 = $12$hi;
        alloc__collections__btree__map__BTreeMap_K_2cV___insert__hc7622c6487a4ba88($3 + 16 | 0 | 0, $3 + 176 | 0 | 0, $3 + 128 | 0 | 0, $12 | 0, i64toi32_i32$1 | 0);
       }
       HEAP32[$10 >> 2] = HEAP32[$9 >> 2] | 0;
       i64toi32_i32$3 = $3;
       i64toi32_i32$1 = HEAP32[($3 + 176 | 0) >> 2] | 0;
       i64toi32_i32$5 = HEAP32[($3 + 180 | 0) >> 2] | 0;
       $106 = i64toi32_i32$1;
       i64toi32_i32$1 = $3;
       HEAP32[($3 + 112 | 0) >> 2] = $106;
       HEAP32[($3 + 116 | 0) >> 2] = i64toi32_i32$5;
       $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__hce9499edf49fdc37($3 + 8 | 0 | 0, $3 + 144 | 0 | 0);
       $1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
       $8 = HEAP32[($3 + 8 | 0) >> 2] | 0;
       if ($8) {
        continue label$5
       }
       break label$5;
      };
     }
     $1 = ($3 + 80 | 0) + 8 | 0;
     HEAP32[$1 >> 2] = HEAP32[$6 >> 2] | 0;
     i64toi32_i32$3 = $3;
     i64toi32_i32$5 = HEAP32[($3 + 96 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($3 + 100 | 0) >> 2] | 0;
     $124 = i64toi32_i32$5;
     i64toi32_i32$5 = $3;
     HEAP32[($3 + 80 | 0) >> 2] = $124;
     HEAP32[($3 + 84 | 0) >> 2] = i64toi32_i32$1;
     label$9 : {
      if (!(HEAP32[($3 + 120 | 0) >> 2] | 0)) {
       break label$9
      }
      $28 = $4 + 24 | 0;
      HEAP32[(($3 + 144 | 0) + 24 | 0) >> 2] = HEAPU8[$28 >> 0] | 0 | ((HEAPU8[($28 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($28 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($28 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$3 = $4 + 16 | 0;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$5 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $139 = i64toi32_i32$1;
      i64toi32_i32$1 = ($3 + 144 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $139;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$5;
      i64toi32_i32$3 = $4 + 8 | 0;
      i64toi32_i32$5 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $145 = i64toi32_i32$5;
      i64toi32_i32$5 = ($3 + 144 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$5 >> 2] = $145;
      HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$3 = $4;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$5 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $148 = i64toi32_i32$1;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 144 | 0) >> 2] = $148;
      HEAP32[($3 + 148 | 0) >> 2] = i64toi32_i32$5;
      $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h3f0faaa5740c6934($3 + 176 | 0 | 0, $3 + 112 | 0 | 0);
      alloc__collections__btree__map__BTreeMap_K_2cV___insert__ha211f93f5765e42b($3 + 128 | 0 | 0, $3 + 80 | 0 | 0, $3 + 144 | 0 | 0, $3 + 176 | 0 | 0);
      if (!(HEAP32[($3 + 128 | 0) >> 2] | 0)) {
       break label$9
      }
      $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h6c9f94f0f82ce2b5($5 | 0);
     }
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h6c9f94f0f82ce2b5($3 + 112 | 0 | 0);
     HEAP32[$7 >> 2] = HEAP32[$1 >> 2] | 0;
     i64toi32_i32$3 = $3;
     i64toi32_i32$5 = HEAP32[($3 + 80 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($3 + 84 | 0) >> 2] | 0;
     $172 = i64toi32_i32$5;
     i64toi32_i32$5 = $0;
     HEAP32[i64toi32_i32$5 >> 2] = $172;
     HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$1;
     $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h32d71c96a3c9fef9($3 | 0, $3 + 48 | 0 | 0);
     $1 = HEAP32[($3 + 4 | 0) >> 2] | 0;
     $4 = HEAP32[$3 >> 2] | 0;
     if ($4) {
      continue label$3
     }
     break label$3;
    };
   }
   global$0 = $3 + 192 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1050052 | 0, 43 | 0, 1054432 | 0);
  abort();
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h3d33b90cd2011dc4($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, $2 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$4 = 0, $12 = 0, $14 = 0, $6 = 0, $10 = 0, $38 = 0, $39 = 0, $40 = 0, $18 = 0, $18$hi = 0, $4 = 0, $9 = 0, $5 = 0, $8 = 0, $17 = 0, $41 = 0, $42 = 0, $43 = 0, $19 = 0, $20 = 0, $3 = 0, $7 = 0, $11 = 0, $13 = 0, $15 = 0, $16 = 0, $84 = 0, $88 = 0, $91 = 0, $95 = 0, $96 = 0, $117 = 0, $117$hi = 0, $128 = 0, $134 = 0, $19$hi = 0, $20$hi = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  $3 = HEAP32[$1 >> 2] | 0;
  $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__hf8388cafa696b413($2 + 8 | 0 | 0, $4 | 0, 0 | 0);
  $5 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  $6 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[($0 + 4 | 0) >> 2] = $6;
  HEAP32[$0 >> 2] = $5;
  label$1 : {
   if (!$6) {
    break label$1
   }
   $7 = Math_imul($4, 28);
   $8 = ($2 + 48 | 0) + 12 | 0;
   $9 = $2 + 48 | 0 | 4 | 0;
   $10 = ($2 + 16 | 0) + 8 | 0;
   $11 = $2 + 58 | 0;
   $1 = 0;
   label$2 : while (1) {
    if (($7 | 0) == ($1 | 0)) {
     break label$1
    }
    $6 = $6 + -1 | 0;
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        $12 = $3 + $1 | 0;
        switch (HEAPU16[$12 >> 1] | 0 | 0) {
        case 2:
         break label$4;
        case 1:
         break label$5;
        default:
         break label$6;
        };
       }
       $38 = $12 + 7 | 0;
       $13 = HEAPU8[$38 >> 0] | 0 | ((HEAPU8[($38 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($38 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($38 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $14 = HEAPU8[($12 + 6 | 0) >> 0] | 0;
       $15 = HEAPU16[($12 + 4 | 0) >> 1] | 0;
       $16 = HEAPU16[($12 + 2 | 0) >> 1] | 0;
       $17 = 0;
       label$7 : {
        if ((HEAPU8[($12 + 11 | 0) >> 0] | 0 | 0) != (1 | 0)) {
         break label$7
        }
        i64toi32_i32$2 = $12 + 20 | 0;
        i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $84 = i64toi32_i32$0;
        i64toi32_i32$0 = $10;
        HEAP32[i64toi32_i32$0 >> 2] = $84;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$2 = $12 + 12 | 0;
        i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $88 = i64toi32_i32$1;
        i64toi32_i32$1 = $2;
        HEAP32[($2 + 16 | 0) >> 2] = $88;
        HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
        $17 = 1;
       }
       i64toi32_i32$2 = $2;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
       $91 = i64toi32_i32$0;
       i64toi32_i32$0 = $8;
       $39 = $91;
       HEAP8[i64toi32_i32$0 >> 0] = $39;
       HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $39 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $39 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $39 >>> 24 | 0;
       HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
       HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
       i64toi32_i32$2 = $10;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $95 = i64toi32_i32$1;
       i64toi32_i32$1 = $8 + 8 | 0;
       $40 = $95;
       HEAP8[i64toi32_i32$1 >> 0] = $40;
       HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $40 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $40 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $40 >>> 24 | 0;
       HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
       HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
       $96 = $11;
       i64toi32_i32$0 = 0;
       i64toi32_i32$2 = $13;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 8;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $41 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
        $41 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       i64toi32_i32$4 = ($14 & 255 | 0 | 0) == (1 | 0);
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = i64toi32_i32$4 ? $41 : 0;
       i64toi32_i32$0 = i64toi32_i32$4 ? i64toi32_i32$1 : i64toi32_i32$2;
       $18 = i64toi32_i32$3;
       $18$hi = i64toi32_i32$0;
       i64toi32_i32$4 = i64toi32_i32$3;
       i64toi32_i32$3 = 0;
       i64toi32_i32$1 = 32;
       i64toi32_i32$2 = i64toi32_i32$1 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
        i64toi32_i32$3 = 0;
        $42 = i64toi32_i32$0 >>> i64toi32_i32$2 | 0;
       } else {
        i64toi32_i32$3 = i64toi32_i32$0 >>> i64toi32_i32$2 | 0;
        $42 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$2 | 0) | 0;
       }
       HEAP8[$96 >> 0] = $42;
       HEAP8[($2 + 59 | 0) >> 0] = $17;
       HEAP16[($2 + 52 | 0) >> 1] = $15;
       HEAP16[($2 + 50 | 0) >> 1] = $16;
       HEAP16[($2 + 48 | 0) >> 1] = 0;
       i64toi32_i32$3 = $18$hi;
       i64toi32_i32$3 = 0;
       i64toi32_i32$0 = $14;
       i64toi32_i32$4 = 0;
       i64toi32_i32$1 = 255;
       i64toi32_i32$4 = i64toi32_i32$3 & i64toi32_i32$4 | 0;
       $117 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
       $117$hi = i64toi32_i32$4;
       i64toi32_i32$4 = $18$hi;
       i64toi32_i32$3 = $18;
       i64toi32_i32$0 = $117$hi;
       i64toi32_i32$1 = $117;
       i64toi32_i32$0 = i64toi32_i32$4 | i64toi32_i32$0 | 0;
       $43 = i64toi32_i32$3 | i64toi32_i32$1 | 0;
       HEAP16[($2 + 54 | 0) >> 1] = $43;
       HEAP16[($2 + 56 | 0) >> 1] = $43 >>> 16 | 0;
       break label$3;
      }
      $14 = HEAP32[($12 + 16 | 0) >> 2] | 0;
      $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($2 + 16 | 0 | 0, $12 + 4 | 0 | 0);
      i64toi32_i32$4 = $2;
      i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
      i64toi32_i32$3 = HEAP32[($2 + 20 | 0) >> 2] | 0;
      $128 = i64toi32_i32$0;
      i64toi32_i32$0 = $9;
      HEAP32[i64toi32_i32$0 >> 2] = $128;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
      HEAP32[($2 + 28 | 0) >> 2] = $14;
      i64toi32_i32$4 = $10;
      i64toi32_i32$3 = HEAP32[i64toi32_i32$4 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
      $134 = i64toi32_i32$3;
      i64toi32_i32$3 = $9 + 8 | 0;
      HEAP32[i64toi32_i32$3 >> 2] = $134;
      HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
      HEAP16[($2 + 48 | 0) >> 1] = 1;
      break label$3;
     }
     $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($9 | 0, $12 + 4 | 0 | 0);
     HEAP16[($2 + 48 | 0) >> 1] = 2;
    }
    $14 = HEAP32[(($2 + 48 | 0) + 24 | 0) >> 2] | 0;
    HEAP32[(($2 + 16 | 0) + 24 | 0) >> 2] = $14;
    i64toi32_i32$4 = ($2 + 48 | 0) + 16 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
    $18 = i64toi32_i32$0;
    $18$hi = i64toi32_i32$3;
    i64toi32_i32$0 = ($2 + 16 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $18;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
    i64toi32_i32$4 = ($2 + 48 | 0) + 8 | 0;
    i64toi32_i32$3 = HEAP32[i64toi32_i32$4 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
    $19 = i64toi32_i32$3;
    $19$hi = i64toi32_i32$0;
    i64toi32_i32$3 = $10;
    HEAP32[i64toi32_i32$3 >> 2] = $19;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$4 = $2;
    i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
    i64toi32_i32$3 = HEAP32[($2 + 52 | 0) >> 2] | 0;
    $20 = i64toi32_i32$0;
    $20$hi = i64toi32_i32$3;
    i64toi32_i32$0 = $2;
    HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $20;
    HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$3;
    $12 = $5 + $1 | 0;
    HEAP32[($12 + 24 | 0) >> 2] = $14;
    i64toi32_i32$3 = $18$hi;
    i64toi32_i32$0 = $12 + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $18;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
    i64toi32_i32$3 = $19$hi;
    i64toi32_i32$0 = $12 + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $19;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
    i64toi32_i32$3 = $20$hi;
    i64toi32_i32$0 = $12;
    HEAP32[i64toi32_i32$0 >> 2] = $20;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
    $1 = $1 + 28 | 0;
    if ($6) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 8 | 0) >> 2] = $4;
  global$0 = $2 + 80 | 0;
 }
 
 function cardano_serialization_lib__tx_builder__TransactionBuilder__get_total_output__h93b375eebf85cbd8($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $13 = 0, $18 = 0, $21 = 0, $39 = 0, $46 = 0, $51 = 0, $68 = 0, $83 = 0, $90 = 0, $95 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  cardano_serialization_lib__tx_builder__TransactionBuilder__get_mint_as_values__hfca4f89cac3bdba6($2 + 32 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2 + 72 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $13 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 24 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $13;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2 + 64 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $18;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 56 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 60 | 0) >> 2] | 0;
  $21 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $21;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   if (!(HEAP32[($2 + 40 | 0) >> 2] | 0)) {
    break label$1
   }
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 44 | 0 | 0);
  }
  cardano_serialization_lib__tx_builder__TransactionBuilder__get_explicit_output__h759c362a670068a6($2 + 32 | 0 | 0, $1 | 0);
  label$2 : {
   label$3 : {
    label$4 : {
     label$5 : {
      label$6 : {
       if ((HEAP32[($2 + 32 | 0) >> 2] | 0 | 0) == (1 | 0)) {
        break label$6
       }
       i64toi32_i32$2 = ($2 + 32 | 0) + 24 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $39 = i64toi32_i32$1;
       i64toi32_i32$1 = ($2 + 136 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $39;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = ($2 + 32 | 0) + 16 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $46 = i64toi32_i32$0;
       i64toi32_i32$0 = ($2 + 136 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $46;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = ($2 + 32 | 0) + 8 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $51 = i64toi32_i32$1;
       i64toi32_i32$1 = $2;
       HEAP32[($2 + 136 | 0) >> 2] = $51;
       HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$0;
       cardano_serialization_lib__utils__internal_get_deposit__h544d8f4f3a980a59($2 + 160 | 0 | 0, $1 + 428 | 0 | 0, $1 + 16 | 0 | 0, $1 + 24 | 0 | 0);
       if ((HEAP32[($2 + 160 | 0) >> 2] | 0 | 0) == (1 | 0)) {
        break label$5
       }
       HEAP32[($2 + 40 | 0) >> 2] = 0;
       i64toi32_i32$2 = ($2 + 160 | 0) + 8 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $68 = i64toi32_i32$0;
       i64toi32_i32$0 = $2;
       HEAP32[($2 + 32 | 0) >> 2] = $68;
       HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
       cardano_serialization_lib__utils__Value__checked_add__h5184687782847801($2 + 104 | 0 | 0, $2 + 136 | 0 | 0, $2 + 32 | 0 | 0);
       if ((HEAP32[($2 + 104 | 0) >> 2] | 0 | 0) == (1 | 0)) {
        break label$4
       }
       i64toi32_i32$2 = $2 + 128 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $83 = i64toi32_i32$1;
       i64toi32_i32$1 = ($2 + 80 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $83;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = ($2 + 104 | 0) + 16 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $90 = i64toi32_i32$0;
       i64toi32_i32$0 = ($2 + 80 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $90;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = ($2 + 104 | 0) + 8 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $95 = i64toi32_i32$1;
       i64toi32_i32$1 = $2;
       HEAP32[($2 + 80 | 0) >> 2] = $95;
       HEAP32[($2 + 84 | 0) >> 2] = i64toi32_i32$0;
       cardano_serialization_lib__utils__Value__checked_add__h5184687782847801($0 | 0, $2 + 80 | 0 | 0, $2 + 8 | 0 | 0);
       label$7 : {
        if (!(HEAP32[($2 + 16 | 0) >> 2] | 0)) {
         break label$7
        }
        $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 20 | 0 | 0);
       }
       label$8 : {
        if (!(HEAP32[($2 + 88 | 0) >> 2] | 0)) {
         break label$8
        }
        $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 92 | 0 | 0);
       }
       label$9 : {
        if (!(HEAP32[($2 + 40 | 0) >> 2] | 0)) {
         break label$9
        }
        $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 44 | 0 | 0);
       }
       if (!(HEAP32[($2 + 144 | 0) >> 2] | 0)) {
        break label$2
       }
       $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 148 | 0 | 0);
       break label$2;
      }
      $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($2 + 36 | 0) >> 2] | 0 | 0) | 0;
      HEAP32[$0 >> 2] = 1;
      HEAP32[($0 + 4 | 0) >> 2] = $1;
      if (!(HEAP32[($2 + 16 | 0) >> 2] | 0)) {
       break label$2
      }
      $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 20 | 0 | 0);
      break label$2;
     }
     $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($2 + 164 | 0) >> 2] | 0 | 0) | 0;
     HEAP32[$0 >> 2] = 1;
     HEAP32[($0 + 4 | 0) >> 2] = $1;
     if (!(HEAP32[($2 + 16 | 0) >> 2] | 0)) {
      break label$3
     }
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 20 | 0 | 0);
     break label$3;
    }
    $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($2 + 108 | 0) >> 2] | 0 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    label$10 : {
     if (!(HEAP32[($2 + 16 | 0) >> 2] | 0)) {
      break label$10
     }
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 20 | 0 | 0);
    }
    if (!(HEAP32[($2 + 40 | 0) >> 2] | 0)) {
     break label$3
    }
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 44 | 0 | 0);
   }
   if (!(HEAP32[($2 + 144 | 0) >> 2] | 0)) {
    break label$2
   }
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 148 | 0 | 0);
  }
  global$0 = $2 + 176 | 0;
 }
 
 function alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, $9 = 0, $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $15 = 0, $15$hi = 0, $12 = 0, $4 = 0, $6 = 0, $23 = 0, $24 = 0, $11 = 0, $25 = 0, $26 = 0, $5 = 0, $8 = 0, $27 = 0, $10 = 0, $13 = 0, $14 = 0, $28 = 0, $29 = 0, $7 = 0, $64 = 0, $138 = 0, $164 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  $4 = 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h9f99f00671a57bc5($3 | 0, $2 | 0, 0 | 0);
  $5 = HEAP32[$3 >> 2] | 0;
  $6 = HEAP32[($3 + 4 | 0) >> 2] | 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[($0 + 4 | 0) >> 2] = $6;
  HEAP32[$0 >> 2] = $5;
  label$1 : {
   if (!$6) {
    break label$1
   }
   $7 = $2 << 5 | 0;
   $8 = ($3 + 28 | 0) + 2 | 0;
   label$2 : while (1) {
    if (($7 | 0) == ($4 | 0)) {
     break label$1
    }
    $6 = $6 + -1 | 0;
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           $9 = $1 + $4 | 0;
           switch (HEAPU8[$9 >> 0] | 0 | 0) {
           case 5:
            break label$4;
           case 4:
            break label$5;
           case 3:
            break label$6;
           case 2:
            break label$7;
           case 1:
            break label$8;
           default:
            break label$9;
           };
          }
          HEAP8[$8 >> 0] = HEAPU8[($9 + 3 | 0) >> 0] | 0;
          HEAP8[(($3 + 32 | 0) + 8 | 0) >> 0] = HEAPU8[($9 + 28 | 0) >> 0] | 0;
          $27 = $9 + 1 | 0;
          HEAP16[($3 + 28 | 0) >> 1] = HEAPU8[$27 >> 0] | 0 | ((HEAPU8[($27 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
          i64toi32_i32$2 = $9 + 20 | 0;
          i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          $64 = i64toi32_i32$0;
          i64toi32_i32$0 = $3;
          HEAP32[($3 + 32 | 0) >> 2] = $64;
          HEAP32[($3 + 36 | 0) >> 2] = i64toi32_i32$1;
          $23 = $9 + 16 | 0;
          $10 = HEAPU8[$23 >> 0] | 0 | ((HEAPU8[($23 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($23 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($23 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          i64toi32_i32$2 = $9 + 8 | 0;
          i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          $15 = i64toi32_i32$1;
          $15$hi = i64toi32_i32$0;
          $24 = $9 + 4 | 0;
          $11 = HEAPU8[$24 >> 0] | 0 | ((HEAPU8[($24 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($24 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($24 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
          $12 = 0;
          break label$3;
         }
         alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($3 + 32 | 0 | 0, HEAP32[($9 + 4 | 0) >> 2] | 0 | 0, HEAP32[($9 + 12 | 0) >> 2] | 0 | 0);
         i64toi32_i32$2 = $3;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
         $15 = i64toi32_i32$0;
         $15$hi = i64toi32_i32$1;
         $11 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
         $12 = 1;
         break label$3;
        }
        alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($3 + 32 | 0 | 0, HEAP32[($9 + 4 | 0) >> 2] | 0 | 0, HEAP32[($9 + 12 | 0) >> 2] | 0 | 0);
        i64toi32_i32$2 = $3;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
        $15 = i64toi32_i32$1;
        $15$hi = i64toi32_i32$0;
        $11 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
        $12 = 2;
        break label$3;
       }
       $11 = HEAP32[($9 + 4 | 0) >> 2] | 0;
       alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($3 + 32 | 0 | 0, HEAP32[($9 + 8 | 0) >> 2] | 0 | 0, HEAP32[($9 + 16 | 0) >> 2] | 0 | 0);
       $10 = HEAP32[($3 + 40 | 0) >> 2] | 0;
       i64toi32_i32$2 = $3;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
       $15 = i64toi32_i32$0;
       $15$hi = i64toi32_i32$1;
       $12 = 3;
       break label$3;
      }
      i64toi32_i32$2 = $9 + 8 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $15 = i64toi32_i32$1;
      $15$hi = i64toi32_i32$0;
      $12 = 4;
      break label$3;
     }
     i64toi32_i32$2 = $9 + 8 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $15 = i64toi32_i32$0;
     $15$hi = i64toi32_i32$1;
     $12 = 5;
    }
    $13 = ($3 + 24 | 0) + 2 | 0;
    HEAP8[$13 >> 0] = HEAPU8[$8 >> 0] | 0;
    $14 = ($3 + 8 | 0) + 8 | 0;
    HEAP32[$14 >> 2] = HEAP32[(($3 + 32 | 0) + 8 | 0) >> 2] | 0;
    HEAP16[($3 + 24 | 0) >> 1] = HEAPU16[($3 + 28 | 0) >> 1] | 0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
    $138 = i64toi32_i32$1;
    i64toi32_i32$1 = i64toi32_i32$2;
    HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $138;
    HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$0;
    $9 = $5 + $4 | 0;
    HEAP8[$9 >> 0] = $12;
    HEAP32[($9 + 16 | 0) >> 2] = $10;
    i64toi32_i32$0 = $15$hi;
    i64toi32_i32$1 = $9 + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $15;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    $25 = $9 + 4 | 0;
    $26 = $11;
    HEAP8[$25 >> 0] = $26;
    HEAP8[($25 + 1 | 0) >> 0] = $26 >>> 8 | 0;
    HEAP8[($25 + 2 | 0) >> 0] = $26 >>> 16 | 0;
    HEAP8[($25 + 3 | 0) >> 0] = $26 >>> 24 | 0;
    $28 = $9 + 1 | 0;
    $29 = HEAPU16[(i64toi32_i32$2 + 24 | 0) >> 1] | 0;
    HEAP8[$28 >> 0] = $29;
    HEAP8[($28 + 1 | 0) >> 0] = $29 >>> 8 | 0;
    HEAP8[($9 + 3 | 0) >> 0] = HEAPU8[$13 >> 0] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
    $164 = i64toi32_i32$0;
    i64toi32_i32$0 = $9 + 20 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $164;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($9 + 28 | 0) >> 2] = HEAP32[$14 >> 2] | 0;
    $4 = $4 + 32 | 0;
    if ($6) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 8 | 0) >> 2] = $2;
  global$0 = $3 + 48 | 0;
 }
 
 function serde_json__ser__format_escaped_str_contents__h319080b8e6932140($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $11 = 0, $4 = 0, $14 = 0, $13 = 0, $7 = 0, $12 = 0, $9 = 0, $10 = 0, $16 = 0, $15 = 0, $5 = 0, $6 = 0, $8 = 0;
  $4 = global$0 - 16 | 0;
  global$0 = $4;
  core__iter__adapters__enumerate__Enumerate_I___new__h17b92aadb2bf6535($4 | 0, $2 | 0, $2 + $3 | 0 | 0);
  $5 = $2 + -1 | 0;
  $6 = $3 ^ -1 | 0;
  $7 = HEAP32[($4 + 8 | 0) >> 2] | 0;
  $8 = HEAP32[($4 + 4 | 0) >> 2] | 0;
  $9 = HEAP32[$4 >> 2] | 0;
  $10 = HEAP32[$0 >> 2] | 0;
  $11 = 0;
  label$1 : while (1) {
   $12 = $8 - $9 | 0;
   $0 = 0;
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           label$10 : {
            label$11 : {
             label$12 : {
              label$13 : while (1) {
               label$14 : {
                if (($12 | 0) != ($0 | 0)) {
                 break label$14
                }
                if (($11 | 0) == ($3 | 0)) {
                 break label$11
                }
                if (!$11) {
                 break label$12
                }
                label$15 : {
                 if ($11 >>> 0 >= $3 >>> 0) {
                  break label$15
                 }
                 if ((HEAP8[($2 + $11 | 0) >> 0] | 0 | 0) > (-65 | 0)) {
                  break label$12
                 }
                }
                core__str__slice_error_fail__h8a7d2e23b7bba52e($2 | 0, $3 | 0, $11 | 0, $3 | 0, 1068456 | 0);
                abort();
               }
               $13 = $9 + $0 | 0;
               $0 = $0 + 1 | 0;
               $14 = HEAPU8[$13 >> 0] | 0;
               $13 = HEAPU8[($14 + 1088212 | 0) >> 0] | 0;
               if (!$13) {
                continue label$13
               }
               break label$13;
              };
              label$16 : {
               $15 = $7 + $0 | 0;
               $12 = $15 + -1 | 0;
               if ($12 >>> 0 <= $11 >>> 0) {
                break label$16
               }
               label$17 : {
                if (!$11) {
                 break label$17
                }
                label$18 : {
                 if ($11 >>> 0 < $3 >>> 0) {
                  break label$18
                 }
                 if (($11 | 0) == ($3 | 0)) {
                  break label$17
                 }
                 break label$2;
                }
                if ((HEAP8[($2 + $11 | 0) >> 0] | 0 | 0) < (-64 | 0)) {
                 break label$2
                }
               }
               label$19 : {
                label$20 : {
                 if ($12 >>> 0 < $3 >>> 0) {
                  break label$20
                 }
                 $12 = $3;
                 if (($6 + $7 | 0) + $0 | 0) {
                  break label$2
                 }
                 break label$19;
                }
                if ((HEAP8[(($5 + $7 | 0) + $0 | 0) >> 0] | 0 | 0) <= (-65 | 0)) {
                 break label$2
                }
               }
               alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($10 | 0, $2 + $11 | 0 | 0, (($7 - $11 | 0) + $0 | 0) + -1 | 0 | 0);
              }
              if (($13 | 0) > (109 | 0)) {
               break label$10
              }
              label$21 : {
               switch ($13 + -98 | 0 | 0) {
               default:
                $14 = 1068502;
                if (($13 | 0) == (34 | 0)) {
                 break label$4
                }
                if (($13 | 0) != (92 | 0)) {
                 break label$9
                }
                $14 = 1068500;
                break label$4;
               case 4:
                $14 = 1068496;
                break label$4;
               case 0:
                break label$21;
               case 1:
               case 2:
               case 3:
                break label$9;
               };
              }
              $14 = 1068498;
              break label$4;
             }
             alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($10 | 0, $2 + $11 | 0 | 0, $3 - $11 | 0 | 0);
            }
            global$0 = $4 + 16 | 0;
            i64toi32_i32$HIGH_BITS = 0;
            return 4 | 0;
           }
           switch ($13 + -110 | 0 | 0) {
           case 0:
            break label$5;
           case 4:
            break label$6;
           case 6:
            break label$7;
           case 7:
            break label$8;
           default:
            break label$9;
           };
          }
          core__panicking__panic__h2fd385a887c8bf13(1068288 | 0, 40 | 0, 1068424 | 0);
          abort();
         }
         $16 = 808482140;
         HEAP8[$4 >> 0] = $16;
         HEAP8[($4 + 1 | 0) >> 0] = $16 >>> 8 | 0;
         HEAP8[($4 + 2 | 0) >> 0] = $16 >>> 16 | 0;
         HEAP8[($4 + 3 | 0) >> 0] = $16 >>> 24 | 0;
         HEAP8[($4 + 5 | 0) >> 0] = HEAPU8[(($14 & 15 | 0) + 1088196 | 0) >> 0] | 0;
         HEAP8[($4 + 4 | 0) >> 0] = HEAPU8[(($14 >>> 4 | 0) + 1088196 | 0) >> 0] | 0;
         alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($10 | 0, $4 | 0, 6 | 0);
         break label$3;
        }
        $14 = 1068490;
        break label$4;
       }
       $14 = 1068492;
       break label$4;
      }
      $14 = 1068494;
     }
     alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($10 | 0, $14 | 0, 2 | 0);
    }
    $9 = $9 + $0 | 0;
    $11 = $12 + 1 | 0;
    $7 = $15;
    continue label$1;
   }
   break label$1;
  };
  core__str__slice_error_fail__h8a7d2e23b7bba52e($2 | 0, $3 | 0, $11 | 0, ($7 + $0 | 0) + -1 | 0 | 0, 1068440 | 0);
  abort();
 }
 
 function ryu__pretty__format64__h68d0de20c01ea6e8($0, $1) {
  $0 = +$0;
  $1 = $1 | 0;
  var $4 = 0, i64toi32_i32$3 = 0, $3 = 0, i64toi32_i32$1 = 0, $5 = 0, i64toi32_i32$0 = 0, $6 = 0, $9 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, $9$hi = 0, $7 = 0, $2 = 0, $10 = 0, $10$hi = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $25 = 0, $26 = 0, $27 = 0, $28 = 0, $8 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  wasm2js_scratch_store_f64(+$0);
  i64toi32_i32$0 = wasm2js_scratch_load_i32(1 | 0) | 0;
  $9 = wasm2js_scratch_load_i32(0 | 0) | 0;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = 1048575;
  i64toi32_i32$3 = -1;
  i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
  $10 = $9 & i64toi32_i32$3 | 0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$0 = $9;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 52;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $18 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   $18 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
  }
  $3 = $18;
  $4 = 0;
  label$1 : {
   i64toi32_i32$2 = $9$hi;
   i64toi32_i32$2 = $9$hi;
   i64toi32_i32$1 = $9;
   i64toi32_i32$0 = -1;
   i64toi32_i32$3 = -1;
   if (($9$hi | 0) > (i64toi32_i32$0 | 0)) {
    $19 = 1
   } else {
    if ((i64toi32_i32$2 | 0) >= (i64toi32_i32$0 | 0)) {
     if (i64toi32_i32$1 >>> 0 <= i64toi32_i32$3 >>> 0) {
      $20 = 0
     } else {
      $20 = 1
     }
     $21 = $20;
    } else {
     $21 = 0
    }
    $19 = $21;
   }
   if ($19) {
    break label$1
   }
   HEAP8[$1 >> 0] = 45;
   $4 = 1;
  }
  $3 = $3 & 2047 | 0;
  label$2 : {
   label$3 : {
    label$4 : {
     label$5 : {
      label$6 : {
       label$7 : {
        label$8 : {
         i64toi32_i32$1 = $10$hi;
         i64toi32_i32$3 = $10;
         i64toi32_i32$2 = 0;
         i64toi32_i32$0 = 0;
         if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$2 | 0) | 0) {
          break label$8
         }
         if (!$3) {
          break label$7
         }
        }
        i64toi32_i32$3 = $10$hi;
        ryu__d2s__d2d__hbd078b293d767eaa($2 | 0, $10 | 0, i64toi32_i32$3 | 0, $3 | 0);
        i64toi32_i32$0 = $2;
        i64toi32_i32$3 = HEAP32[i64toi32_i32$0 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
        $9 = i64toi32_i32$3;
        $9$hi = i64toi32_i32$1;
        $5 = ryu__d2s__decimal_length17__h8f99f1fcbf14e8a2(i64toi32_i32$3 | 0, i64toi32_i32$1 | 0) | 0;
        $6 = HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] | 0;
        $3 = $5 + $6 | 0;
        label$9 : {
         if (($6 | 0) < (0 | 0)) {
          break label$9
         }
         if (($3 | 0) < (17 | 0)) {
          break label$6
         }
        }
        $6 = $3 + -1 | 0;
        if ($6 >>> 0 < 16 >>> 0) {
         break label$5
        }
        if (($3 + 4 | 0) >>> 0 < 5 >>> 0) {
         break label$4
        }
        if (($5 | 0) != (1 | 0)) {
         break label$3
        }
        $3 = $1 + $4 | 0;
        HEAP8[($3 + 1 | 0) >> 0] = 101;
        i64toi32_i32$1 = $9$hi;
        HEAP8[$3 >> 0] = $9 + 48 | 0;
        $4 = $4 | 2 | 0;
        $5 = (ryu__pretty__exponent__write_exponent3__hca613cb8347b0028($6 | 0, $1 + $4 | 0 | 0) | 0) + $4 | 0;
        break label$2;
       }
       $1 = $1 + $4 | 0;
       $22 = 0;
       $23 = HEAPU8[($22 + 1100504 | 0) >> 0] | 0 | ((HEAPU8[($22 + 1100505 | 0) >> 0] | 0) << 8 | 0) | 0;
       HEAP8[$1 >> 0] = $23;
       HEAP8[($1 + 1 | 0) >> 0] = $23 >>> 8 | 0;
       HEAP8[($1 + 2 | 0) >> 0] = HEAPU8[(0 + 1100506 | 0) >> 0] | 0;
       i64toi32_i32$1 = $9$hi;
       i64toi32_i32$0 = $9;
       i64toi32_i32$3 = 0;
       i64toi32_i32$2 = 63;
       i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
        i64toi32_i32$3 = 0;
        $24 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$3 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
        $24 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
       }
       $5 = $24 + 3 | 0;
       break label$2;
      }
      i64toi32_i32$3 = $9$hi;
      $7 = $1 + ($5 + $4 | 0) | 0;
      ryu__pretty__mantissa__write_mantissa_long__h41cacf0fc85ea93b($9 | 0, i64toi32_i32$3 | 0, $7 | 0);
      label$10 : {
       if (($5 | 0) >= ($3 | 0)) {
        break label$10
       }
       memset($7 | 0, 48 | 0, $6 | 0) | 0;
      }
      $4 = $3 + $4 | 0;
      $25 = $1 + $4 | 0;
      $26 = 12334;
      HEAP8[$25 >> 0] = $26;
      HEAP8[($25 + 1 | 0) >> 0] = $26 >>> 8 | 0;
      $5 = $4 + 2 | 0;
      break label$2;
     }
     i64toi32_i32$3 = $9$hi;
     $6 = $4 + 1 | 0;
     $5 = $5 + $6 | 0;
     ryu__pretty__mantissa__write_mantissa_long__h41cacf0fc85ea93b($9 | 0, i64toi32_i32$3 | 0, $1 + $5 | 0 | 0);
     memmove($1 + $4 | 0 | 0, $1 + $6 | 0 | 0, $3 | 0) | 0;
     HEAP8[($1 + ($3 + $4 | 0) | 0) >> 0] = 46;
     break label$2;
    }
    $27 = $1 + $4 | 0;
    $28 = 11824;
    HEAP8[$27 >> 0] = $28;
    HEAP8[($27 + 1 | 0) >> 0] = $28 >>> 8 | 0;
    $6 = 2 - $3 | 0;
    label$11 : {
     if (($3 | 0) > (-1 | 0)) {
      break label$11
     }
     memset($1 + ($4 | 2 | 0) | 0 | 0, 48 | 0, (($6 | 0) > (3 | 0) ? $6 : 3) + -2 | 0 | 0) | 0;
    }
    i64toi32_i32$3 = $9$hi;
    $5 = ($5 + $4 | 0) + $6 | 0;
    ryu__pretty__mantissa__write_mantissa_long__h41cacf0fc85ea93b($9 | 0, i64toi32_i32$3 | 0, $1 + $5 | 0 | 0);
    break label$2;
   }
   i64toi32_i32$3 = $9$hi;
   $3 = $5 + $4 | 0;
   $5 = ($3 + $1 | 0) + 1 | 0;
   ryu__pretty__mantissa__write_mantissa_long__h41cacf0fc85ea93b($9 | 0, i64toi32_i32$3 | 0, $5 | 0);
   $4 = $1 + $4 | 0;
   $7 = $4 + 1 | 0;
   $8 = HEAPU8[$7 >> 0] | 0;
   HEAP8[$7 >> 0] = 46;
   HEAP8[$4 >> 0] = $8;
   HEAP8[$5 >> 0] = 101;
   $4 = $3 + 2 | 0;
   $5 = (ryu__pretty__exponent__write_exponent3__hca613cb8347b0028($6 | 0, $1 + $4 | 0 | 0) | 0) + $4 | 0;
  }
  global$0 = $2 + 16 | 0;
  return $5 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_recursing__hab4e5c589e083d2a($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $8 = 0, $5 = 0, $6 = 0, $7 = 0, $10 = 0, $22 = 0, $34 = 0, $51 = 0, $9 = 0, $109 = 0, $127 = 0;
  $4 = global$0 - 480 | 0;
  global$0 = $4;
  HEAP32[(($4 + 464 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $22 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[($4 + 464 | 0) >> 2] = $22;
  HEAP32[($4 + 468 | 0) >> 2] = i64toi32_i32$1;
  $1 = memcpy($4 | 0, $2 | 0, 128 | 0) | 0;
  HEAP32[(($1 + 336 | 0) + 8 | 0) >> 2] = HEAP32[($3 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $34 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[($1 + 336 | 0) >> 2] = $34;
  HEAP32[($1 + 340 | 0) >> 2] = i64toi32_i32$0;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert__h5345db8c0861aede($1 + 144 | 0 | 0, $1 + 464 | 0 | 0, $1 | 0, $1 + 336 | 0 | 0);
  $5 = HEAP32[($1 + 312 | 0) >> 2] | 0;
  label$1 : {
   label$2 : {
    if ((HEAP32[($1 + 144 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    HEAP32[($0 + 168 | 0) >> 2] = $5;
    i64toi32_i32$2 = $1;
    i64toi32_i32$0 = HEAP32[($1 + 148 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 152 | 0) >> 2] | 0;
    $51 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[($0 + 4 | 0) >> 2] = $51;
    HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[$0 >> 2] = 0;
    HEAP32[($0 + 12 | 0) >> 2] = HEAP32[(($1 + 144 | 0) + 12 | 0) >> 2] | 0;
    break label$1;
   }
   $2 = HEAP32[(($1 + 144 | 0) + 164 | 0) >> 2] | 0;
   $6 = HEAP32[(($1 + 144 | 0) + 160 | 0) >> 2] | 0;
   $7 = HEAP32[(($1 + 144 | 0) + 152 | 0) >> 2] | 0;
   $3 = HEAP32[(($1 + 144 | 0) + 156 | 0) >> 2] | 0;
   $4 = memcpy($1 | 0, ($1 + 144 | 0) + 8 | 0 | 0, 144 | 0) | 0;
   label$3 : {
    $8 = HEAP32[($3 + 1408 | 0) >> 2] | 0;
    if (!$8) {
     break label$3
    }
    $9 = ($4 + 144 | 0) + 8 | 0;
    $10 = $4 + 128 | 0;
    label$4 : while (1) {
     HEAP32[($4 + 328 | 0) >> 2] = HEAPU16[($3 + 1544 | 0) >> 1] | 0;
     HEAP32[($4 + 324 | 0) >> 2] = $8;
     HEAP32[($4 + 320 | 0) >> 2] = $7 + 1 | 0;
     memcpy($4 + 336 | 0 | 0, $4 | 0, 128 | 0) | 0;
     HEAP32[(($4 + 464 | 0) + 8 | 0) >> 2] = HEAP32[($10 + 8 | 0) >> 2] | 0;
     i64toi32_i32$2 = $10;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $109 = i64toi32_i32$1;
     i64toi32_i32$1 = $4;
     HEAP32[($4 + 464 | 0) >> 2] = $109;
     HEAP32[($4 + 468 | 0) >> 2] = i64toi32_i32$0;
     alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert__hfc67a1d82ed9fc5c($4 + 144 | 0 | 0, $4 + 320 | 0 | 0, $4 + 336 | 0 | 0, $4 + 464 | 0 | 0, $6 | 0, $2 | 0);
     label$5 : {
      if ((HEAP32[($4 + 144 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$5
      }
      HEAP32[($0 + 168 | 0) >> 2] = $5;
      i64toi32_i32$2 = $4;
      i64toi32_i32$0 = HEAP32[($4 + 148 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($4 + 152 | 0) >> 2] | 0;
      $127 = i64toi32_i32$0;
      i64toi32_i32$0 = $0;
      HEAP32[($0 + 4 | 0) >> 2] = $127;
      HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[$0 >> 2] = 0;
      HEAP32[($0 + 12 | 0) >> 2] = HEAP32[(($4 + 144 | 0) + 12 | 0) >> 2] | 0;
      break label$1;
     }
     $2 = HEAP32[($4 + 308 | 0) >> 2] | 0;
     $6 = HEAP32[($4 + 304 | 0) >> 2] | 0;
     $7 = HEAP32[($4 + 296 | 0) >> 2] | 0;
     $3 = HEAP32[($4 + 300 | 0) >> 2] | 0;
     memcpy($4 | 0, $9 | 0, 144 | 0) | 0;
     $8 = HEAP32[($3 + 1408 | 0) >> 2] | 0;
     if ($8) {
      continue label$4
     }
     break label$4;
    };
   }
   memcpy(($4 + 144 | 0) + 4 | 0 | 0, $4 | 0, 144 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
   memcpy($0 + 4 | 0 | 0, $4 + 144 | 0 | 0, 148 | 0) | 0;
   HEAP32[($0 + 168 | 0) >> 2] = $5;
   HEAP32[($0 + 164 | 0) >> 2] = $2;
   HEAP32[($0 + 160 | 0) >> 2] = $6;
   HEAP32[($0 + 156 | 0) >> 2] = $3;
   HEAP32[($0 + 152 | 0) >> 2] = $7;
  }
  global$0 = $1 + 480 | 0;
 }
 
 function $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__clone_subtree__h6457b21d29182680($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $7 = 0, $4 = 0, i64toi32_i32$0 = 0, $5 = 0, i64toi32_i32$1 = 0, $6 = 0, $9 = 0, $8 = 0, $46 = 0, $10 = 0, $125 = 0, $154 = 0;
  $3 = global$0 - 80 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     if ($1) {
      break label$3
     }
     $1 = alloc__boxed__Box_T_2cA___new_uninit_in__h3d7406b043db0321() | 0;
     HEAP16[($1 + 138 | 0) >> 1] = 0;
     HEAP32[$1 >> 2] = 0;
     $4 = 0;
     label$4 : {
      if (!(HEAPU16[($2 + 138 | 0) >> 1] | 0)) {
       break label$4
      }
      $5 = $2 + 4 | 0;
      $4 = 0;
      $6 = $3 + 72 | 0;
      label$5 : while (1) {
       $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h614c9de21e58255d($3 + 64 | 0 | 0, $5 | 0);
       $7 = HEAPU16[($1 + 138 | 0) >> 1] | 0;
       if ($7 >>> 0 >= 11 >>> 0) {
        break label$1
       }
       HEAP16[($1 + 138 | 0) >> 1] = $7 + 1 | 0;
       $7 = $1 + Math_imul($7, 12) | 0;
       HEAP32[($7 + 12 | 0) >> 2] = HEAP32[$6 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[($3 + 64 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($3 + 68 | 0) >> 2] | 0;
       $46 = i64toi32_i32$0;
       i64toi32_i32$0 = $7 + 4 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $46;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       $5 = $5 + 12 | 0;
       $4 = $4 + 1 | 0;
       if ($4 >>> 0 < (HEAPU16[($2 + 138 | 0) >> 1] | 0) >>> 0) {
        continue label$5
       }
       break label$5;
      };
     }
     HEAP32[($0 + 8 | 0) >> 2] = $4;
     HEAP32[($0 + 4 | 0) >> 2] = $1;
     HEAP32[$0 >> 2] = 0;
     break label$2;
    }
    $8 = $1 + -1 | 0;
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__clone_subtree__h6457b21d29182680($3 + 8 | 0 | 0, $8 | 0, HEAP32[($2 + 140 | 0) >> 2] | 0 | 0);
    label$6 : {
     label$7 : {
      $7 = HEAP32[($3 + 12 | 0) >> 2] | 0;
      if (!$7) {
       break label$7
      }
      $4 = (HEAP32[($3 + 8 | 0) >> 2] | 0) + 1 | 0;
      break label$6;
     }
     $7 = alloc__boxed__Box_T_2cA___new_uninit_in__h3d7406b043db0321() | 0;
     HEAP16[($7 + 138 | 0) >> 1] = 0;
     HEAP32[$7 >> 2] = 0;
     $4 = 1;
    }
    $1 = alloc__boxed__Box_T_2cA___new_uninit_in__hbee8ec47f689ab87() | 0;
    HEAP32[($1 + 140 | 0) >> 2] = $7;
    $5 = 0;
    HEAP16[($1 + 138 | 0) >> 1] = 0;
    HEAP32[$1 >> 2] = 0;
    HEAP32[$7 >> 2] = $1;
    HEAP16[($7 + 136 | 0) >> 1] = 0;
    HEAP32[($3 + 12 | 0) >> 2] = $1;
    HEAP32[($3 + 8 | 0) >> 2] = $4;
    HEAP32[($3 + 28 | 0) >> 2] = $1;
    HEAP32[($3 + 24 | 0) >> 2] = $4;
    label$8 : {
     if (!(HEAPU16[($2 + 138 | 0) >> 1] | 0)) {
      break label$8
     }
     $7 = $2 + 4 | 0;
     $4 = $2 + 144 | 0;
     $9 = HEAP32[($3 + 16 | 0) >> 2] | 0;
     label$9 : while (1) {
      $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h614c9de21e58255d($3 + 32 | 0 | 0, $7 | 0);
      $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__clone_subtree__h6457b21d29182680($3 + 48 | 0 | 0, $8 | 0, HEAP32[$4 >> 2] | 0 | 0);
      $10 = HEAP32[($3 + 56 | 0) >> 2] | 0;
      $1 = HEAP32[($3 + 52 | 0) >> 2] | 0;
      $6 = HEAP32[($3 + 48 | 0) >> 2] | 0;
      HEAP32[(($3 + 64 | 0) + 8 | 0) >> 2] = HEAP32[(($3 + 32 | 0) + 8 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($3 + 32 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($3 + 36 | 0) >> 2] | 0;
      $125 = i64toi32_i32$1;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 64 | 0) >> 2] = $125;
      HEAP32[($3 + 68 | 0) >> 2] = i64toi32_i32$0;
      $5 = $5 + 1 | 0;
      label$10 : {
       if ($1) {
        break label$10
       }
       $6 = 0;
       $1 = alloc__boxed__Box_T_2cA___new_uninit_in__h3d7406b043db0321() | 0;
       HEAP16[($1 + 138 | 0) >> 1] = 0;
       HEAP32[$1 >> 2] = 0;
      }
      alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal___push__h04f226b3ef6139db($3 + 24 | 0 | 0, $3 + 64 | 0 | 0, $6 | 0, $1 | 0);
      $7 = $7 + 12 | 0;
      $4 = $4 + 4 | 0;
      $9 = ($10 + $9 | 0) + 1 | 0;
      if ($5 >>> 0 < (HEAPU16[($2 + 138 | 0) >> 1] | 0) >>> 0) {
       continue label$9
      }
      break label$9;
     };
     HEAP32[($3 + 16 | 0) >> 2] = $9;
    }
    i64toi32_i32$0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
    $154 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[i64toi32_i32$0 >> 2] = $154;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[(($3 + 8 | 0) + 8 | 0) >> 2] | 0;
   }
   global$0 = $3 + 80 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1048619 | 0, 32 | 0, 1048744 | 0);
  abort();
 }
 
 function $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__clone_subtree__h7ba328195d29e47f($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $7 = 0, $4 = 0, i64toi32_i32$0 = 0, $5 = 0, i64toi32_i32$1 = 0, $6 = 0, $9 = 0, $8 = 0, $46 = 0, $10 = 0, $125 = 0, $154 = 0;
  $3 = global$0 - 80 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     if ($1) {
      break label$3
     }
     $1 = alloc__boxed__Box_T_2cA___new_uninit_in__h04cd43b67903c159() | 0;
     HEAP16[($1 + 138 | 0) >> 1] = 0;
     HEAP32[$1 >> 2] = 0;
     $4 = 0;
     label$4 : {
      if (!(HEAPU16[($2 + 138 | 0) >> 1] | 0)) {
       break label$4
      }
      $5 = $2 + 4 | 0;
      $4 = 0;
      $6 = $3 + 72 | 0;
      label$5 : while (1) {
       $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($3 + 64 | 0 | 0, $5 | 0);
       $7 = HEAPU16[($1 + 138 | 0) >> 1] | 0;
       if ($7 >>> 0 >= 11 >>> 0) {
        break label$1
       }
       HEAP16[($1 + 138 | 0) >> 1] = $7 + 1 | 0;
       $7 = $1 + Math_imul($7, 12) | 0;
       HEAP32[($7 + 12 | 0) >> 2] = HEAP32[$6 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[($3 + 64 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($3 + 68 | 0) >> 2] | 0;
       $46 = i64toi32_i32$0;
       i64toi32_i32$0 = $7 + 4 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $46;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       $5 = $5 + 12 | 0;
       $4 = $4 + 1 | 0;
       if ($4 >>> 0 < (HEAPU16[($2 + 138 | 0) >> 1] | 0) >>> 0) {
        continue label$5
       }
       break label$5;
      };
     }
     HEAP32[($0 + 8 | 0) >> 2] = $4;
     HEAP32[($0 + 4 | 0) >> 2] = $1;
     HEAP32[$0 >> 2] = 0;
     break label$2;
    }
    $8 = $1 + -1 | 0;
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__clone_subtree__h7ba328195d29e47f($3 + 8 | 0 | 0, $8 | 0, HEAP32[($2 + 140 | 0) >> 2] | 0 | 0);
    label$6 : {
     label$7 : {
      $7 = HEAP32[($3 + 12 | 0) >> 2] | 0;
      if (!$7) {
       break label$7
      }
      $4 = (HEAP32[($3 + 8 | 0) >> 2] | 0) + 1 | 0;
      break label$6;
     }
     $7 = alloc__boxed__Box_T_2cA___new_uninit_in__h04cd43b67903c159() | 0;
     HEAP16[($7 + 138 | 0) >> 1] = 0;
     HEAP32[$7 >> 2] = 0;
     $4 = 1;
    }
    $1 = alloc__boxed__Box_T_2cA___new_uninit_in__he0c425f8ad462f5a() | 0;
    HEAP32[($1 + 140 | 0) >> 2] = $7;
    $5 = 0;
    HEAP16[($1 + 138 | 0) >> 1] = 0;
    HEAP32[$1 >> 2] = 0;
    HEAP32[$7 >> 2] = $1;
    HEAP16[($7 + 136 | 0) >> 1] = 0;
    HEAP32[($3 + 12 | 0) >> 2] = $1;
    HEAP32[($3 + 8 | 0) >> 2] = $4;
    HEAP32[($3 + 28 | 0) >> 2] = $1;
    HEAP32[($3 + 24 | 0) >> 2] = $4;
    label$8 : {
     if (!(HEAPU16[($2 + 138 | 0) >> 1] | 0)) {
      break label$8
     }
     $7 = $2 + 4 | 0;
     $4 = $2 + 144 | 0;
     $9 = HEAP32[($3 + 16 | 0) >> 2] | 0;
     label$9 : while (1) {
      $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($3 + 32 | 0 | 0, $7 | 0);
      $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__clone_subtree__h7ba328195d29e47f($3 + 48 | 0 | 0, $8 | 0, HEAP32[$4 >> 2] | 0 | 0);
      $10 = HEAP32[($3 + 56 | 0) >> 2] | 0;
      $1 = HEAP32[($3 + 52 | 0) >> 2] | 0;
      $6 = HEAP32[($3 + 48 | 0) >> 2] | 0;
      HEAP32[(($3 + 64 | 0) + 8 | 0) >> 2] = HEAP32[(($3 + 32 | 0) + 8 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($3 + 32 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($3 + 36 | 0) >> 2] | 0;
      $125 = i64toi32_i32$1;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 64 | 0) >> 2] = $125;
      HEAP32[($3 + 68 | 0) >> 2] = i64toi32_i32$0;
      $5 = $5 + 1 | 0;
      label$10 : {
       if ($1) {
        break label$10
       }
       $6 = 0;
       $1 = alloc__boxed__Box_T_2cA___new_uninit_in__h04cd43b67903c159() | 0;
       HEAP16[($1 + 138 | 0) >> 1] = 0;
       HEAP32[$1 >> 2] = 0;
      }
      alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal___push__ha06be0cc1af1dc69($3 + 24 | 0 | 0, $3 + 64 | 0 | 0, $6 | 0, $1 | 0);
      $7 = $7 + 12 | 0;
      $4 = $4 + 4 | 0;
      $9 = ($10 + $9 | 0) + 1 | 0;
      if ($5 >>> 0 < (HEAPU16[($2 + 138 | 0) >> 1] | 0) >>> 0) {
       continue label$9
      }
      break label$9;
     };
     HEAP32[($3 + 16 | 0) >> 2] = $9;
    }
    i64toi32_i32$0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
    $154 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[i64toi32_i32$0 >> 2] = $154;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[(($3 + 8 | 0) + 8 | 0) >> 2] | 0;
   }
   global$0 = $3 + 80 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1048619 | 0, 32 | 0, 1048744 | 0);
  abort();
 }
 
 function dlmalloc__dlmalloc__Dlmalloc_A___dispose_chunk__hb19ba4f57c862d12($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0, $5 = 0, $34 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = dlmalloc__dlmalloc__Chunk__plus_offset__h7aa5253a4344ed9a($0 | 0, $1 | 0) | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     if (dlmalloc__dlmalloc__Chunk__pinuse__h3f4a4f8063aa1f27($0 | 0) | 0) {
      break label$3
     }
     $3 = HEAP32[$0 >> 2] | 0;
     label$4 : {
      label$5 : {
       if (dlmalloc__dlmalloc__Chunk__mmapped__h896a47bc7b87f942($0 | 0) | 0) {
        break label$5
       }
       $1 = $3 + $1 | 0;
       $0 = dlmalloc__dlmalloc__Chunk__minus_offset__h475b72a4870c7350($0 | 0, $3 | 0) | 0;
       if (($0 | 0) != (HEAP32[(0 + 1178292 | 0) >> 2] | 0 | 0)) {
        break label$4
       }
       if (((HEAP32[($2 + 4 | 0) >> 2] | 0) & 3 | 0 | 0) != (3 | 0)) {
        break label$3
       }
       HEAP32[(0 + 1178284 | 0) >> 2] = $1;
       dlmalloc__dlmalloc__Chunk__set_free_with_pinuse__hb6fcf1321e8edd9b($0 | 0, $1 | 0, $2 | 0);
       return;
      }
      $34 = $0 - $3 | 0;
      $0 = ($3 + $1 | 0) + 16 | 0;
      if (!($dlmalloc__sys__System_20as_20dlmalloc__Allocator___free__h820779abf265185e(1177884 | 0, $34 | 0, $0 | 0) | 0)) {
       break label$2
      }
      HEAP32[(0 + 1178300 | 0) >> 2] = (HEAP32[(0 + 1178300 | 0) >> 2] | 0) - $0 | 0;
      return;
     }
     label$6 : {
      if ($3 >>> 0 < 256 >>> 0) {
       break label$6
      }
      dlmalloc__dlmalloc__Dlmalloc_A___unlink_large_chunk__h107571aa99375aaf($0 | 0);
      break label$3;
     }
     label$7 : {
      $4 = HEAP32[($0 + 12 | 0) >> 2] | 0;
      $5 = HEAP32[($0 + 8 | 0) >> 2] | 0;
      if (($4 | 0) == ($5 | 0)) {
       break label$7
      }
      HEAP32[($5 + 12 | 0) >> 2] = $4;
      HEAP32[($4 + 8 | 0) >> 2] = $5;
      break label$3;
     }
     (wasm2js_i32$0 = 0, wasm2js_i32$1 = (HEAP32[(0 + 1177884 | 0) >> 2] | 0) & (__wasm_rotl_i32(-2 | 0, $3 >>> 3 | 0 | 0) | 0) | 0), HEAP32[(wasm2js_i32$0 + 1177884 | 0) >> 2] = wasm2js_i32$1;
    }
    label$8 : {
     if (!(dlmalloc__dlmalloc__Chunk__cinuse__hfa8040b8ff348e52($2 | 0) | 0)) {
      break label$8
     }
     dlmalloc__dlmalloc__Chunk__set_free_with_pinuse__hb6fcf1321e8edd9b($0 | 0, $1 | 0, $2 | 0);
     break label$1;
    }
    label$9 : {
     label$10 : {
      if (($2 | 0) == (HEAP32[(0 + 1178296 | 0) >> 2] | 0 | 0)) {
       break label$10
      }
      if (($2 | 0) != (HEAP32[(0 + 1178292 | 0) >> 2] | 0 | 0)) {
       break label$9
      }
      HEAP32[(0 + 1178292 | 0) >> 2] = $0;
      $1 = (HEAP32[(0 + 1178284 | 0) >> 2] | 0) + $1 | 0;
      HEAP32[(0 + 1178284 | 0) >> 2] = $1;
      dlmalloc__dlmalloc__Chunk__set_size_and_pinuse_of_free_chunk__hbc4027d35960d532($0 | 0, $1 | 0);
      return;
     }
     HEAP32[(0 + 1178296 | 0) >> 2] = $0;
     $1 = (HEAP32[(0 + 1178288 | 0) >> 2] | 0) + $1 | 0;
     HEAP32[(0 + 1178288 | 0) >> 2] = $1;
     HEAP32[($0 + 4 | 0) >> 2] = $1 | 1 | 0;
     if (($0 | 0) != (HEAP32[(0 + 1178292 | 0) >> 2] | 0 | 0)) {
      break label$2
     }
     HEAP32[(0 + 1178284 | 0) >> 2] = 0;
     HEAP32[(0 + 1178292 | 0) >> 2] = 0;
     return;
    }
    $3 = dlmalloc__dlmalloc__Chunk__size__hbcf51483386243e4($2 | 0) | 0;
    $1 = $3 + $1 | 0;
    label$11 : {
     label$12 : {
      if ($3 >>> 0 < 256 >>> 0) {
       break label$12
      }
      dlmalloc__dlmalloc__Dlmalloc_A___unlink_large_chunk__h107571aa99375aaf($2 | 0);
      break label$11;
     }
     label$13 : {
      $4 = HEAP32[($2 + 12 | 0) >> 2] | 0;
      $2 = HEAP32[($2 + 8 | 0) >> 2] | 0;
      if (($4 | 0) == ($2 | 0)) {
       break label$13
      }
      HEAP32[($2 + 12 | 0) >> 2] = $4;
      HEAP32[($4 + 8 | 0) >> 2] = $2;
      break label$11;
     }
     (wasm2js_i32$0 = 0, wasm2js_i32$1 = (HEAP32[(0 + 1177884 | 0) >> 2] | 0) & (__wasm_rotl_i32(-2 | 0, $3 >>> 3 | 0 | 0) | 0) | 0), HEAP32[(wasm2js_i32$0 + 1177884 | 0) >> 2] = wasm2js_i32$1;
    }
    dlmalloc__dlmalloc__Chunk__set_size_and_pinuse_of_free_chunk__hbc4027d35960d532($0 | 0, $1 | 0);
    if (($0 | 0) != (HEAP32[(0 + 1178292 | 0) >> 2] | 0 | 0)) {
     break label$1
    }
    HEAP32[(0 + 1178284 | 0) >> 2] = $1;
   }
   return;
  }
  label$14 : {
   if ($1 >>> 0 < 256 >>> 0) {
    break label$14
   }
   dlmalloc__dlmalloc__Dlmalloc_A___insert_large_chunk__h524840f32df7e3d2($0 | 0, $1 | 0);
   return;
  }
  $2 = $1 >>> 3 | 0;
  $1 = ($2 << 3 | 0) + 1177892 | 0;
  label$15 : {
   label$16 : {
    $3 = HEAP32[(0 + 1177884 | 0) >> 2] | 0;
    $2 = 1 << $2 | 0;
    if (!($3 & $2 | 0)) {
     break label$16
    }
    $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    break label$15;
   }
   HEAP32[(0 + 1177884 | 0) >> 2] = $3 | $2 | 0;
   $2 = $1;
  }
  HEAP32[($1 + 8 | 0) >> 2] = $0;
  HEAP32[($2 + 12 | 0) >> 2] = $0;
  HEAP32[($0 + 12 | 0) >> 2] = $1;
  HEAP32[($0 + 8 | 0) >> 2] = $2;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_recursing__hadedfb0a053ce437($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $7 = 0, $5 = 0, $6 = 0, $21 = 0, $47 = 0, $8 = 0, $9 = 0, $119 = 0;
  $4 = global$0 - 464 | 0;
  global$0 = $4;
  HEAP32[(($4 + 328 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[($4 + 328 | 0) >> 2] = $21;
  HEAP32[($4 + 332 | 0) >> 2] = i64toi32_i32$1;
  memcpy($4 + 368 | 0 | 0, $2 | 0, 36 | 0) | 0;
  memcpy($4 + 8 | 0 | 0, $3 | 0, 96 | 0) | 0;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert__ha6efcd690a85c850($4 + 144 | 0 | 0, $4 + 328 | 0 | 0, $4 + 368 | 0 | 0, $4 + 8 | 0 | 0);
  $5 = HEAP32[($4 + 304 | 0) >> 2] | 0;
  label$1 : {
   label$2 : {
    if ((HEAP32[($4 + 144 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    HEAP32[($0 + 160 | 0) >> 2] = $5;
    i64toi32_i32$1 = HEAP32[($4 + 148 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($4 + 152 | 0) >> 2] | 0;
    $47 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[($0 + 4 | 0) >> 2] = $47;
    HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[$0 >> 2] = 0;
    HEAP32[($0 + 12 | 0) >> 2] = HEAP32[(($4 + 144 | 0) + 12 | 0) >> 2] | 0;
    break label$1;
   }
   $3 = HEAP32[(($4 + 144 | 0) + 156 | 0) >> 2] | 0;
   $2 = HEAP32[(($4 + 144 | 0) + 152 | 0) >> 2] | 0;
   $6 = HEAP32[(($4 + 144 | 0) + 144 | 0) >> 2] | 0;
   $1 = HEAP32[(($4 + 144 | 0) + 148 | 0) >> 2] | 0;
   memcpy($4 + 8 | 0 | 0, ($4 + 144 | 0) + 8 | 0 | 0, 136 | 0) | 0;
   label$3 : {
    $7 = HEAP32[($1 + 1056 | 0) >> 2] | 0;
    if (!$7) {
     break label$3
    }
    $8 = $4 + 152 | 0;
    $9 = $4 + 48 | 0;
    label$4 : while (1) {
     HEAP32[($4 + 320 | 0) >> 2] = HEAPU16[($1 + 1456 | 0) >> 1] | 0;
     HEAP32[($4 + 316 | 0) >> 2] = $7;
     HEAP32[($4 + 312 | 0) >> 2] = $6 + 1 | 0;
     memcpy($4 + 328 | 0 | 0, $4 + 8 | 0 | 0, 36 | 0) | 0;
     memcpy($4 + 368 | 0 | 0, $9 | 0, 96 | 0) | 0;
     alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert__h34faf8766169445f($4 + 144 | 0 | 0, $4 + 312 | 0 | 0, $4 + 328 | 0 | 0, $4 + 368 | 0 | 0, $2 | 0, $3 | 0);
     label$5 : {
      if ((HEAP32[($4 + 144 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$5
      }
      HEAP32[($0 + 160 | 0) >> 2] = $5;
      i64toi32_i32$0 = HEAP32[($4 + 148 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($4 + 152 | 0) >> 2] | 0;
      $119 = i64toi32_i32$0;
      i64toi32_i32$0 = $0;
      HEAP32[($0 + 4 | 0) >> 2] = $119;
      HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[$0 >> 2] = 0;
      HEAP32[($0 + 12 | 0) >> 2] = HEAP32[(($4 + 144 | 0) + 12 | 0) >> 2] | 0;
      break label$1;
     }
     $3 = HEAP32[($4 + 300 | 0) >> 2] | 0;
     $2 = HEAP32[($4 + 296 | 0) >> 2] | 0;
     $6 = HEAP32[($4 + 288 | 0) >> 2] | 0;
     $1 = HEAP32[($4 + 292 | 0) >> 2] | 0;
     memcpy($4 + 8 | 0 | 0, $8 | 0, 136 | 0) | 0;
     $7 = HEAP32[($1 + 1056 | 0) >> 2] | 0;
     if ($7) {
      continue label$4
     }
     break label$4;
    };
   }
   memcpy(($4 + 144 | 0) + 4 | 0 | 0, $4 + 8 | 0 | 0, 136 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
   memcpy($0 + 4 | 0 | 0, $4 + 144 | 0 | 0, 140 | 0) | 0;
   HEAP32[($0 + 160 | 0) >> 2] = $5;
   HEAP32[($0 + 156 | 0) >> 2] = $3;
   HEAP32[($0 + 152 | 0) >> 2] = $2;
   HEAP32[($0 + 148 | 0) >> 2] = $1;
   HEAP32[($0 + 144 | 0) >> 2] = $6;
  }
  global$0 = $4 + 464 | 0;
 }
 
 function hashbrown__map__HashMap_K_2cV_2cS_2cA___contains_key__h3bb81cf90134dc7f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $5 = 0, $3 = 0, i64toi32_i32$3 = 0, $4 = 0, $26 = 0, $7 = 0, $9 = 0, $6 = 0, $8 = 0, $153 = 0, $153$hi = 0, $156 = 0, $156$hi = 0, $157 = 0, $157$hi = 0, $160 = 0, $160$hi = 0, $163 = 0, $163$hi = 0, $164 = 0, $164$hi = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  i64toi32_i32$0 = hashbrown__map__make_hash__hd31a10d6b64a4e5e($0 | 0, $1 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $3 = i64toi32_i32$0;
  $4 = (HEAP32[($0 + 16 | 0) >> 2] | 0) & i64toi32_i32$0 | 0;
  $26 = (HEAP32[($0 + 20 | 0) >> 2] | 0) + $4 | 0;
  $5 = HEAPU8[$26 >> 0] | 0 | ((HEAPU8[($26 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($26 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($26 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $6 = 0;
  HEAP32[(($2 + 56 | 0) + 8 | 0) >> 2] = 0;
  HEAP32[($2 + 68 | 0) >> 2] = $5;
  HEAP32[($2 + 60 | 0) >> 2] = $4;
  HEAP32[($2 + 56 | 0) >> 2] = $0 + 16 | 0;
  $0 = i64toi32_i32$0 >>> 25 | 0;
  HEAP8[($2 + 76 | 0) >> 0] = $0;
  $0 = $5 ^ Math_imul($0, 16843009) | 0;
  HEAP32[($2 + 72 | 0) >> 2] = (($0 ^ -1 | 0) & ($0 + -16843009 | 0) | 0) & -2139062144 | 0;
  $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($2 + 48 | 0 | 0, $2 + 56 | 0 | 0);
  label$1 : {
   if (!(HEAP32[($2 + 48 | 0) >> 2] | 0)) {
    break label$1
   }
   $7 = $1 + 8 | 0;
   $8 = $1 + 4 | 0;
   $0 = (HEAP32[((HEAP32[($2 + 56 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) - ((HEAP32[($2 + 52 | 0) >> 2] | 0) << 3 | 0) | 0;
   label$2 : while (1) {
    label$3 : {
     $5 = HEAP32[$1 >> 2] | 0;
     $0 = HEAP32[($0 + -8 | 0) >> 2] | 0;
     if (($5 | 0) != (HEAP32[$0 >> 2] | 0 | 0)) {
      break label$3
     }
     label$4 : {
      label$5 : {
       switch ($5 | 0) {
       case 1:
        $9 = HEAP32[($1 + 12 | 0) >> 2] | 0;
        if (($9 | 0) != (HEAP32[($0 + 12 | 0) >> 2] | 0 | 0)) {
         break label$3
        }
        $5 = HEAP32[($0 + 4 | 0) >> 2] | 0;
        $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
        $0 = 0;
        label$10 : while (1) {
         if (($9 | 0) == ($0 | 0)) {
          break label$4
         }
         $0 = $0 + 1 | 0;
         $4 = $cardano_serialization_lib__metadata__TransactionMetadatumEnum_20as_20core__cmp__PartialEq___eq__h1b9ad18ad9a7fd9d($3 | 0, $5 | 0) | 0;
         $3 = $3 + 48 | 0;
         $5 = $5 + 48 | 0;
         if ($4) {
          continue label$10
         }
         break label$10;
        };
        if (($0 + -1 | 0) >>> 0 < $9 >>> 0) {
         break label$3
        }
        break label$4;
       case 3:
        $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 24 | 0 | 0, $8 | 0);
        $5 = HEAP32[($2 + 28 | 0) >> 2] | 0;
        $3 = HEAP32[($2 + 24 | 0) >> 2] | 0;
        $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 16 | 0 | 0, $0 + 4 | 0 | 0);
        if (!(core__slice__cmp___impl_20core__cmp__PartialEq__5bB_5d__20for_20_5bA_5d___eq__hc3de93b036fcc30b($3 | 0, $5 | 0, HEAP32[($2 + 16 | 0) >> 2] | 0 | 0, HEAP32[($2 + 20 | 0) >> 2] | 0 | 0) | 0)) {
         break label$3
        }
        break label$4;
       case 4:
        $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 40 | 0 | 0, $8 | 0);
        $5 = HEAP32[($2 + 44 | 0) >> 2] | 0;
        $3 = HEAP32[($2 + 40 | 0) >> 2] | 0;
        $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 32 | 0 | 0, $0 + 4 | 0 | 0);
        if (!(core__slice__cmp___impl_20core__cmp__PartialEq__5bB_5d__20for_20_5bA_5d___eq__hc3de93b036fcc30b($3 | 0, $5 | 0, HEAP32[($2 + 32 | 0) >> 2] | 0 | 0, HEAP32[($2 + 36 | 0) >> 2] | 0 | 0) | 0)) {
         break label$3
        }
        break label$4;
       default:
        if ($linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__cmp__PartialEq___eq__h47be0878df6ae947($7 | 0, $0 + 8 | 0 | 0) | 0) {
         break label$4
        }
        break label$3;
       case 2:
        break label$5;
       };
      }
      i64toi32_i32$2 = $7;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $153 = i64toi32_i32$1;
      $153$hi = i64toi32_i32$0;
      i64toi32_i32$2 = $0 + 8 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $156 = i64toi32_i32$0;
      $156$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $153$hi;
      i64toi32_i32$2 = $153;
      i64toi32_i32$0 = $156$hi;
      i64toi32_i32$3 = $156;
      i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
      $157 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
      $157$hi = i64toi32_i32$0;
      i64toi32_i32$1 = $7 + 8 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $160 = i64toi32_i32$0;
      $160$hi = i64toi32_i32$2;
      i64toi32_i32$1 = $0 + 16 | 0;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $163 = i64toi32_i32$2;
      $163$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $160$hi;
      i64toi32_i32$1 = $160;
      i64toi32_i32$2 = $163$hi;
      i64toi32_i32$3 = $163;
      i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
      $164 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
      $164$hi = i64toi32_i32$2;
      i64toi32_i32$2 = $157$hi;
      i64toi32_i32$0 = $157;
      i64toi32_i32$1 = $164$hi;
      i64toi32_i32$3 = $164;
      i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
      if (!!(i64toi32_i32$0 | i64toi32_i32$3 | 0 | i64toi32_i32$1 | 0)) {
       break label$3
      }
     }
     $6 = 1;
     break label$1;
    }
    $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($2 + 8 | 0 | 0, $2 + 56 | 0 | 0);
    if (!(HEAP32[($2 + 8 | 0) >> 2] | 0)) {
     break label$1
    }
    $0 = (HEAP32[((HEAP32[($2 + 56 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) - ((HEAP32[($2 + 12 | 0) >> 2] | 0) << 3 | 0) | 0;
    continue label$2;
   };
  }
  global$0 = $2 + 80 | 0;
  return $6 | 0;
 }
 
 function serde_json__value__ser___impl_20serde__ser__Serialize_20for_20serde_json__value__Value___serialize__ha2851daf0650b497($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $4 = 0, $5 = 0.0, $3 = 0, $110 = 0, $117 = 0, $120 = 0;
  $2 = global$0 - 128 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    switch (HEAPU8[$0 >> 0] | 0 | 0) {
    case 1:
     $0 = HEAPU8[($0 + 1 | 0) >> 0] | 0;
     alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb(HEAP32[$1 >> 2] | 0 | 0, ($0 ? 1068474 : 1068478) | 0, ($0 ? 4 : 5) | 0);
     break label$1;
    case 2:
     label$8 : {
      switch (HEAP32[($0 + 8 | 0) >> 2] | 0 | 0) {
      default:
       i64toi32_i32$2 = $0 + 16 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       itoa__Buffer__format__h16c7f26094a64122($2 + 8 | 0 | 0, $2 + 88 | 0 | 0, i64toi32_i32$0 | 0, i64toi32_i32$1 | 0);
       alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb(HEAP32[$1 >> 2] | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
       break label$1;
      case 1:
       i64toi32_i32$2 = $0 + 16 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       itoa__Buffer__format__hed7b710a49053b67($2 + 16 | 0 | 0, $2 + 88 | 0 | 0, i64toi32_i32$1 | 0, i64toi32_i32$0 | 0);
       alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb(HEAP32[$1 >> 2] | 0 | 0, HEAP32[($2 + 16 | 0) >> 2] | 0 | 0, HEAP32[($2 + 20 | 0) >> 2] | 0 | 0);
       break label$1;
      case 2:
       break label$8;
      };
     }
     label$11 : {
      $5 = +HEAPF64[($0 + 16 | 0) >> 3];
      if (((core__f64___impl_20f64___classify__h32c2038c9bc8621a(+$5) | 0) & 255 | 0) >>> 0 < 2 >>> 0) {
       break label$11
      }
      $0 = ryu__pretty__format64__h68d0de20c01ea6e8(+$5, $2 + 88 | 0 | 0) | 0;
      alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb(HEAP32[$1 >> 2] | 0 | 0, $2 + 88 | 0 | 0, $0 | 0);
      break label$1;
     }
     alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb(HEAP32[$1 >> 2] | 0 | 0, 1068483 | 0, 4 | 0);
     break label$1;
    case 3:
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 24 | 0 | 0, $0 + 4 | 0 | 0);
     i64toi32_i32$0 = serde_json__ser__format_escaped_str__h36c322c8ecbdeb72($1 | 0, $2 | 0, HEAP32[($2 + 24 | 0) >> 2] | 0 | 0, HEAP32[($2 + 28 | 0) >> 2] | 0 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     break label$1;
    case 4:
     serde__ser__Serializer__collect_seq__h04407a2a911b47b3($1 | 0, $0 + 4 | 0 | 0) | 0;
     break label$1;
    case 5:
     $3 = 1068488;
     $4 = 1;
     label$12 : {
      $0 = $0 + 4 | 0;
      if (alloc__collections__btree__map__BTreeMap_K_2cV___len__h9902d4fb7515c681($0 | 0) | 0) {
       break label$12
      }
      alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb(HEAP32[$1 >> 2] | 0 | 0, 1068488 | 0, 1 | 0);
      $4 = 0;
      $3 = 1068472;
     }
     alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb(HEAP32[$1 >> 2] | 0 | 0, $3 | 0, 1 | 0);
     HEAP8[($2 + 52 | 0) >> 0] = $4;
     HEAP32[($2 + 48 | 0) >> 2] = $1;
     alloc__collections__btree__map__BTreeMap_K_2cV___iter__hf725d43035c2a960($2 + 56 | 0 | 0, $0 | 0);
     HEAP32[(($2 + 88 | 0) + 24 | 0) >> 2] = HEAP32[(($2 + 56 | 0) + 24 | 0) >> 2] | 0;
     i64toi32_i32$2 = ($2 + 56 | 0) + 16 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $110 = i64toi32_i32$1;
     i64toi32_i32$1 = ($2 + 88 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $110;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = ($2 + 56 | 0) + 8 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $117 = i64toi32_i32$0;
     i64toi32_i32$0 = ($2 + 88 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $117;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAP32[($2 + 56 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 60 | 0) >> 2] | 0;
     $120 = i64toi32_i32$1;
     i64toi32_i32$1 = $2;
     HEAP32[($2 + 88 | 0) >> 2] = $120;
     HEAP32[($2 + 92 | 0) >> 2] = i64toi32_i32$0;
     $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h51e8e53778b7cbd1($2 + 40 | 0 | 0, $2 + 88 | 0 | 0);
     label$13 : {
      $0 = HEAP32[($2 + 40 | 0) >> 2] | 0;
      if (!$0) {
       break label$13
      }
      $1 = HEAP32[($2 + 44 | 0) >> 2] | 0;
      label$14 : while (1) {
       serde__ser__SerializeMap__serialize_entry__h173bbbfadb8f829e($2 + 48 | 0 | 0, $0 | 0, $1 | 0) | 0;
       $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h51e8e53778b7cbd1($2 + 32 | 0 | 0, $2 + 88 | 0 | 0);
       $1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
       $0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
       if ($0) {
        continue label$14
       }
       break label$14;
      };
      $4 = HEAPU8[($2 + 52 | 0) >> 0] | 0;
      $1 = HEAP32[($2 + 48 | 0) >> 2] | 0;
     }
     if (!($4 & 255 | 0)) {
      break label$1
     }
     alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb(HEAP32[$1 >> 2] | 0 | 0, 1068472 | 0, 1 | 0);
     break label$1;
    default:
     break label$2;
    };
   }
   alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb(HEAP32[$1 >> 2] | 0 | 0, 1068483 | 0, 4 | 0);
  }
  global$0 = $2 + 128 | 0;
  return 0 | 0;
 }
 
 function alloc__slice__merge__h6719d5d3dea70774($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $7 = 0, $6 = 0, $5 = 0, $8 = 0, $11 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $9 = 0, $10 = 0, $88 = 0, $163 = 0;
  $5 = global$0 - 32 | 0;
  global$0 = $5;
  $6 = Math_imul($2, 12);
  $7 = $0 + $6 | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     $8 = $1 - $2 | 0;
     if ($8 >>> 0 >= $2 >>> 0) {
      break label$3
     }
     $6 = Math_imul($8, 12);
     $9 = memcpy($3 | 0, $7 | 0, $6 | 0) | 0;
     $6 = $9 + $6 | 0;
     if (($2 | 0) < (1 | 0)) {
      break label$2
     }
     if (($8 | 0) < (1 | 0)) {
      break label$2
     }
     $2 = (Math_imul($1, 12) + $0 | 0) + -12 | 0;
     label$4 : while (1) {
      $8 = $7 + -12 | 0;
      $10 = $6 + -12 | 0;
      label$5 : {
       $1 = HEAP32[($6 + -4 | 0) >> 2] | 0;
       $11 = HEAP32[($7 + -4 | 0) >> 2] | 0;
       $1 = $1 >>> 0 < $11 >>> 0 ? -1 : ($1 | 0) != ($11 | 0);
       if ($1) {
        break label$5
       }
       $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($5 + 8 | 0 | 0, $10 | 0);
       $1 = HEAP32[($5 + 12 | 0) >> 2] | 0;
       $11 = HEAP32[($5 + 8 | 0) >> 2] | 0;
       $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($5 | 0, $8 | 0);
       $1 = core__slice__cmp___impl_20core__cmp__Ord_20for_20_5bT_5d___cmp__h1f2092e0ba2f27ea($11 | 0, $1 | 0, HEAP32[$5 >> 2] | 0 | 0, HEAP32[($5 + 4 | 0) >> 2] | 0 | 0) | 0;
      }
      $1 = ($1 & 255 | 0 | 0) == (255 | 0);
      $11 = ($1 ? $7 : $6) + -12 | 0;
      i64toi32_i32$0 = HEAP32[$11 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($11 + 4 | 0) >> 2] | 0;
      $88 = i64toi32_i32$0;
      i64toi32_i32$0 = $2;
      HEAP32[$2 >> 2] = $88;
      HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($2 + 8 | 0) >> 2] = HEAP32[($11 + 8 | 0) >> 2] | 0;
      $6 = $1 ? $6 : $10;
      $7 = $1 ? $8 : $7;
      if ($0 >>> 0 >= $7 >>> 0) {
       break label$2
      }
      $2 = $2 + -12 | 0;
      if ($6 >>> 0 <= $9 >>> 0) {
       break label$2
      }
      continue label$4;
     };
    }
    $6 = (memcpy($3 | 0, $0 | 0, $6 | 0) | 0) + $6 | 0;
    if (($1 | 0) <= ($2 | 0)) {
     break label$1
    }
    if (($2 | 0) < (1 | 0)) {
     break label$1
    }
    $8 = $0 + Math_imul($1, 12) | 0;
    label$6 : while (1) {
     label$7 : {
      $2 = HEAP32[($7 + 8 | 0) >> 2] | 0;
      $1 = HEAP32[($3 + 8 | 0) >> 2] | 0;
      $2 = $2 >>> 0 < $1 >>> 0 ? -1 : ($2 | 0) != ($1 | 0);
      if ($2) {
       break label$7
      }
      $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($5 + 24 | 0 | 0, $7 | 0);
      $2 = HEAP32[($5 + 28 | 0) >> 2] | 0;
      $1 = HEAP32[($5 + 24 | 0) >> 2] | 0;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($5 + 16 | 0 | 0, $3 | 0);
      $2 = core__slice__cmp___impl_20core__cmp__Ord_20for_20_5bT_5d___cmp__h1f2092e0ba2f27ea($1 | 0, $2 | 0, HEAP32[($5 + 16 | 0) >> 2] | 0 | 0, HEAP32[($5 + 20 | 0) >> 2] | 0 | 0) | 0;
     }
     $2 = ($2 & 255 | 0 | 0) == (255 | 0);
     $1 = $2 ? $7 : $3;
     i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $163 = i64toi32_i32$1;
     i64toi32_i32$1 = $0;
     HEAP32[$0 >> 2] = $163;
     HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($0 + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
     $3 = $2 ? $3 : $3 + 12 | 0;
     $0 = $0 + 12 | 0;
     $7 = $2 ? $7 + 12 | 0 : $7;
     if ($7 >>> 0 >= $8 >>> 0) {
      break label$1
     }
     if ($3 >>> 0 < $6 >>> 0) {
      continue label$6
     }
     break label$1;
    };
   }
   $0 = $7;
  }
  $7 = $6 - $3 | 0;
  memcpy($0 | 0, $3 | 0, $7 - (($7 >>> 0) % (12 >>> 0) | 0) | 0 | 0) | 0;
  global$0 = $5 + 32 | 0;
 }
 
 function cardano_serialization_lib__tx_builder__TransactionBuilder__new__hc837de38ea518a90($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, $2 = 0, $12 = 0, $12$hi = 0, $7 = 0, $7$hi = 0, $3 = 0, $4 = 0, $8 = 0, $8$hi = 0, $9 = 0, $9$hi = 0, $10 = 0, $10$hi = 0, $11 = 0, $11$hi = 0, $13 = 0, $13$hi = 0, $14 = 0, $14$hi = 0, $15 = 0, $15$hi = 0, $16 = 0, $16$hi = 0, $17 = 0, $17$hi = 0, $18 = 0, $18$hi = 0, $5 = 0, $19 = 0, $19$hi = 0, $20 = 0, $20$hi = 0, $6 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  $3 = HEAP32[(i64toi32_i32$2 + 84 | 0) >> 2] | 0;
  $4 = HEAP32[(i64toi32_i32$2 + 80 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $8 = i64toi32_i32$1;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $9 = i64toi32_i32$0;
  $9$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $10 = i64toi32_i32$1;
  $10$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $11 = i64toi32_i32$0;
  $11$hi = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  $12 = 0;
  $12$hi = i64toi32_i32$1;
  label$1 : {
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] | 0;
   i64toi32_i32$2 = i64toi32_i32$1;
   i64toi32_i32$1 = 0;
   i64toi32_i32$3 = 1;
   if ((i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | 0) {
    break label$1
   }
   i64toi32_i32$3 = $1 + 72 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $13 = i64toi32_i32$2;
   $13$hi = i64toi32_i32$0;
   i64toi32_i32$3 = $1 + 64 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $14 = i64toi32_i32$0;
   $14$hi = i64toi32_i32$2;
   i64toi32_i32$3 = $1 + 56 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $15 = i64toi32_i32$2;
   $15$hi = i64toi32_i32$0;
   i64toi32_i32$3 = $1 + 48 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $16 = i64toi32_i32$0;
   $16$hi = i64toi32_i32$2;
   i64toi32_i32$2 = 0;
   $12 = 1;
   $12$hi = i64toi32_i32$2;
  }
  $1 = HEAPU8[($1 + 88 | 0) >> 0] | 0;
  std__thread__local__LocalKey_T___with__h4cd07b14a44a727e($2 + 16 | 0 | 0, 1060968 | 0);
  i64toi32_i32$3 = $2;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 20 | 0) >> 2] | 0;
  $17 = i64toi32_i32$2;
  $17$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 24 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 28 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  $18$hi = i64toi32_i32$2;
  $5 = hashbrown__raw__generic__Group__static_empty__hc5a7932fe1bdb1f1() | 0;
  std__thread__local__LocalKey_T___with__h4cd07b14a44a727e(i64toi32_i32$3 | 0, 1060968 | 0);
  i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$2;
  $19$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 12 | 0) >> 2] | 0;
  $20 = i64toi32_i32$0;
  $20$hi = i64toi32_i32$2;
  $6 = hashbrown__raw__generic__Group__static_empty__hc5a7932fe1bdb1f1() | 0;
  i64toi32_i32$0 = $0 + 208 | 0;
  i64toi32_i32$2 = 0;
  HEAP32[i64toi32_i32$0 >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$0 = $0 + 200 | 0;
  i64toi32_i32$2 = 0;
  HEAP32[i64toi32_i32$0 >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  HEAP32[($0 + 116 | 0) >> 2] = $5;
  HEAP32[($0 + 112 | 0) >> 2] = 0;
  i64toi32_i32$2 = $18$hi;
  i64toi32_i32$0 = $0 + 104 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $17$hi;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 96 | 0) >> 2] = $17;
  HEAP32[(i64toi32_i32$0 + 100 | 0) >> 2] = i64toi32_i32$2;
  HEAP8[(i64toi32_i32$0 + 88 | 0) >> 0] = $1;
  HEAP32[(i64toi32_i32$0 + 84 | 0) >> 2] = $3;
  HEAP32[(i64toi32_i32$0 + 80 | 0) >> 2] = $4;
  i64toi32_i32$2 = $13$hi;
  i64toi32_i32$0 = i64toi32_i32$0 + 72 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $13;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $14$hi;
  i64toi32_i32$0 = $0 + 64 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $14;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $15$hi;
  i64toi32_i32$0 = $0 + 56 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $15;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $16$hi;
  i64toi32_i32$0 = $0 + 48 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $16;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 40 | 0) >> 2] = $12;
  HEAP32[(i64toi32_i32$0 + 44 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 36 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $9$hi;
  HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $9;
  HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $10;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $11$hi;
  HEAP32[i64toi32_i32$0 >> 2] = $11;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$0 = i64toi32_i32$0 + 128 | 0;
  i64toi32_i32$2 = 0;
  HEAP32[i64toi32_i32$0 >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$0 = $0 + 120 | 0;
  i64toi32_i32$2 = 0;
  HEAP32[i64toi32_i32$0 >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$0 = $0 + 420 | 0;
  i64toi32_i32$2 = 0;
  HEAP32[i64toi32_i32$0 >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  HEAP32[($0 + 416 | 0) >> 2] = HEAP32[(0 + 1050204 | 0) >> 2] | 0;
  i64toi32_i32$0 = $0 + 244 | 0;
  i64toi32_i32$2 = 0;
  HEAP32[i64toi32_i32$0 >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$0 = $0 + 232 | 0;
  i64toi32_i32$2 = 0;
  HEAP32[i64toi32_i32$0 >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$0 = $0 + 220 | 0;
  i64toi32_i32$2 = 0;
  HEAP32[i64toi32_i32$0 >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  HEAP32[($0 + 196 | 0) >> 2] = $6;
  i64toi32_i32$2 = $20$hi;
  i64toi32_i32$0 = $0 + 184 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $20;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $19$hi;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 176 | 0) >> 2] = $19;
  HEAP32[(i64toi32_i32$0 + 180 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$0 = i64toi32_i32$0 + 164 | 0;
  i64toi32_i32$2 = 0;
  HEAP32[i64toi32_i32$0 >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$0 = $0 + 152 | 0;
  i64toi32_i32$2 = 0;
  HEAP32[i64toi32_i32$0 >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$0 = $0 + 140 | 0;
  i64toi32_i32$2 = 0;
  HEAP32[i64toi32_i32$0 >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  HEAP32[($0 + 192 | 0) >> 2] = 0;
  HEAP32[($0 + 428 | 0) >> 2] = 0;
  i64toi32_i32$0 = $0;
  i64toi32_i32$2 = 0;
  HEAP32[(i64toi32_i32$0 + 272 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 276 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = 0;
  HEAP32[(i64toi32_i32$0 + 256 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 260 | 0) >> 2] = i64toi32_i32$2;
  HEAP8[(i64toi32_i32$0 + 480 | 0) >> 0] = 0;
  HEAP32[(i64toi32_i32$0 + 456 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 440 | 0) >> 2] = 0;
  i64toi32_i32$2 = 0;
  HEAP32[(i64toi32_i32$0 + 400 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 404 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = 0;
  HEAP32[(i64toi32_i32$0 + 328 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 332 | 0) >> 2] = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$0 + 308 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 468 | 0) >> 2] = HEAP32[(0 + 1050212 | 0) >> 2] | 0;
  i64toi32_i32$0 = i64toi32_i32$0 + 472 | 0;
  i64toi32_i32$2 = 0;
  HEAP32[i64toi32_i32$0 >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  global$0 = i64toi32_i32$3 + 32 | 0;
 }
 
 function core__num__bignum__Big32x40__mul_pow2__haaaae198d66328c2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $3 = 0, $4 = 0, $5 = 0, $2 = 0, $6 = 0, $7 = 0, $8 = 0, $123 = 0;
  label$1 : {
   label$2 : {
    if ($1 >>> 0 > 1279 >>> 0) {
     break label$2
    }
    $2 = $1 >>> 5 | 0;
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         $3 = HEAP32[$0 >> 2] | 0;
         if (!$3) {
          break label$7
         }
         $4 = $0 + ($3 << 2 | 0) | 0;
         $5 = $0 + (($3 + $2 | 0) << 2 | 0) | 0;
         $3 = $3 + -1 | 0;
         $6 = $3 >>> 0 > 39 >>> 0;
         label$8 : while (1) {
          if ($6) {
           break label$6
          }
          $7 = $2 + $3 | 0;
          if ($7 >>> 0 >= 40 >>> 0) {
           break label$1
          }
          HEAP32[$5 >> 2] = HEAP32[$4 >> 2] | 0;
          $5 = $5 + -4 | 0;
          $4 = $4 + -4 | 0;
          $3 = $3 + -1 | 0;
          if (($3 | 0) != (-1 | 0)) {
           continue label$8
          }
          break label$8;
         };
        }
        label$9 : {
         label$10 : {
          label$11 : {
           if (!$2) {
            break label$11
           }
           $4 = $0 + 4 | 0;
           $5 = $2 << 2 | 0;
           $3 = 0;
           label$12 : while (1) {
            if (($3 | 0) == (160 | 0)) {
             break label$10
            }
            HEAP32[($4 + $3 | 0) >> 2] = 0;
            $3 = $3 + 4 | 0;
            if (($5 | 0) != ($3 | 0)) {
             continue label$12
            }
            break label$12;
           };
          }
          $3 = HEAP32[$0 >> 2] | 0;
          $4 = $3 + $2 | 0;
          $6 = $1 & 31 | 0;
          if ($6) {
           break label$9
          }
          HEAP32[$0 >> 2] = $4;
          return $0 | 0;
         }
         core__panicking__panic_bounds_check__h808b524af17640b1(40 | 0, 40 | 0, 1153020 | 0);
         abort();
        }
        $5 = $4 + -1 | 0;
        if ($5 >>> 0 > 39 >>> 0) {
         break label$5
        }
        $8 = $4;
        label$13 : {
         $5 = HEAP32[(($0 + ($5 << 2 | 0) | 0) + 4 | 0) >> 2] | 0;
         $7 = (0 - $1 | 0) & 31 | 0;
         $1 = $5 >>> $7 | 0;
         if (!$1) {
          break label$13
         }
         if ($4 >>> 0 > 39 >>> 0) {
          break label$4
         }
         HEAP32[(($0 + ($4 << 2 | 0) | 0) + 4 | 0) >> 2] = $1;
         $8 = $4 + 1 | 0;
        }
        label$14 : {
         $1 = $2 + 1 | 0;
         if ($1 >>> 0 >= $4 >>> 0) {
          break label$14
         }
         $3 = ((($3 + $2 | 0) << 2 | 0) + $0 | 0) + -4 | 0;
         label$15 : while (1) {
          if (($4 + -2 | 0) >>> 0 >= 40 >>> 0) {
           break label$3
          }
          $123 = $5 << $6 | 0;
          $5 = HEAP32[$3 >> 2] | 0;
          HEAP32[($3 + 4 | 0) >> 2] = $123 | ($5 >>> $7 | 0) | 0;
          $3 = $3 + -4 | 0;
          $4 = $4 + -1 | 0;
          if ($1 >>> 0 < $4 >>> 0) {
           continue label$15
          }
          break label$15;
         };
        }
        $3 = ($0 + ($2 << 2 | 0) | 0) + 4 | 0;
        HEAP32[$3 >> 2] = (HEAP32[$3 >> 2] | 0) << $6 | 0;
        HEAP32[$0 >> 2] = $8;
        return $0 | 0;
       }
       core__panicking__panic_bounds_check__h808b524af17640b1($3 | 0, 40 | 0, 1153020 | 0);
       abort();
      }
      core__panicking__panic_bounds_check__h808b524af17640b1($5 | 0, 40 | 0, 1153020 | 0);
      abort();
     }
     core__panicking__panic_bounds_check__h808b524af17640b1($4 | 0, 40 | 0, 1153020 | 0);
     abort();
    }
    core__panicking__panic_bounds_check__h808b524af17640b1(-1 | 0, 40 | 0, 1153020 | 0);
    abort();
   }
   core__panicking__panic__h2fd385a887c8bf13(1153062 | 0, 29 | 0, 1153020 | 0);
   abort();
  }
  core__panicking__panic_bounds_check__h808b524af17640b1($7 | 0, 40 | 0, 1153020 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_recursing__h600b32a439386d31($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $7 = 0, $4 = 0, $5 = 0, $6 = 0, $8 = 0, $20 = 0, $29 = 0, $78 = 0, $103 = 0, $137 = 0, $156 = 0;
  $3 = global$0 - 96 | 0;
  global$0 = $3;
  HEAP32[(($3 + 64 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[($3 + 64 | 0) >> 2] = $20;
  HEAP32[($3 + 68 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(($3 + 80 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $29 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[($3 + 80 | 0) >> 2] = $29;
  HEAP32[($3 + 84 | 0) >> 2] = i64toi32_i32$0;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert__hb312e199a4732014($3 + 24 | 0 | 0, $3 + 64 | 0 | 0, $3 + 80 | 0 | 0);
  $2 = HEAP32[(($3 + 24 | 0) + 8 | 0) >> 2] | 0;
  $1 = HEAP32[($3 + 28 | 0) >> 2] | 0;
  $4 = HEAP32[($3 + 56 | 0) >> 2] | 0;
  label$1 : {
   label$2 : {
    if ((HEAP32[($3 + 24 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    HEAP32[($0 + 32 | 0) >> 2] = $4;
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    HEAP32[$0 >> 2] = 0;
    HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($3 + 36 | 0) >> 2] | 0;
    HEAP32[($0 + 8 | 0) >> 2] = $2;
    break label$1;
   }
   $5 = HEAP32[(($3 + 24 | 0) + 28 | 0) >> 2] | 0;
   $6 = HEAP32[(($3 + 24 | 0) + 24 | 0) >> 2] | 0;
   $7 = ($3 + 24 | 0) + 12 | 0;
   HEAP32[(($3 + 8 | 0) + 8 | 0) >> 2] = HEAP32[($7 + 8 | 0) >> 2] | 0;
   i64toi32_i32$2 = $7;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $78 = i64toi32_i32$0;
   i64toi32_i32$0 = $3;
   HEAP32[($3 + 8 | 0) >> 2] = $78;
   HEAP32[($3 + 12 | 0) >> 2] = i64toi32_i32$1;
   label$3 : {
    $7 = HEAP32[$2 >> 2] | 0;
    if (!$7) {
     break label$3
    }
    $8 = $3 + 36 | 0;
    label$4 : while (1) {
     HEAP32[($3 + 72 | 0) >> 2] = HEAPU16[($2 + 136 | 0) >> 1] | 0;
     HEAP32[($3 + 68 | 0) >> 2] = $7;
     HEAP32[($3 + 64 | 0) >> 2] = $1 + 1 | 0;
     $7 = ($3 + 8 | 0) + 8 | 0;
     HEAP32[(($3 + 80 | 0) + 8 | 0) >> 2] = HEAP32[$7 >> 2] | 0;
     i64toi32_i32$2 = $3;
     i64toi32_i32$1 = HEAP32[($3 + 8 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($3 + 12 | 0) >> 2] | 0;
     $103 = i64toi32_i32$1;
     i64toi32_i32$1 = $3;
     HEAP32[($3 + 80 | 0) >> 2] = $103;
     HEAP32[($3 + 84 | 0) >> 2] = i64toi32_i32$0;
     alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert__h26d5afec67d4e9d8($3 + 24 | 0 | 0, $3 + 64 | 0 | 0, $3 + 80 | 0 | 0, $6 | 0, $5 | 0);
     $2 = HEAP32[($3 + 32 | 0) >> 2] | 0;
     $1 = HEAP32[($3 + 28 | 0) >> 2] | 0;
     label$5 : {
      if ((HEAP32[($3 + 24 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$5
      }
      HEAP32[($0 + 32 | 0) >> 2] = $4;
      HEAP32[($0 + 4 | 0) >> 2] = $1;
      HEAP32[$0 >> 2] = 0;
      HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($3 + 36 | 0) >> 2] | 0;
      HEAP32[($0 + 8 | 0) >> 2] = $2;
      break label$1;
     }
     HEAP32[$7 >> 2] = HEAP32[($8 + 8 | 0) >> 2] | 0;
     i64toi32_i32$2 = $8;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $137 = i64toi32_i32$0;
     i64toi32_i32$0 = $3;
     HEAP32[($3 + 8 | 0) >> 2] = $137;
     HEAP32[($3 + 12 | 0) >> 2] = i64toi32_i32$1;
     $5 = HEAP32[($3 + 52 | 0) >> 2] | 0;
     $6 = HEAP32[($3 + 48 | 0) >> 2] | 0;
     $7 = HEAP32[$2 >> 2] | 0;
     if ($7) {
      continue label$4
     }
     break label$4;
    };
   }
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = 1;
   HEAP32[($0 + 32 | 0) >> 2] = $4;
   HEAP32[($0 + 8 | 0) >> 2] = $2;
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[($3 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($3 + 12 | 0) >> 2] | 0;
   $156 = i64toi32_i32$1;
   i64toi32_i32$1 = $0 + 12 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $156;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($0 + 28 | 0) >> 2] = $5;
   HEAP32[($0 + 24 | 0) >> 2] = $6;
   HEAP32[($0 + 20 | 0) >> 2] = HEAP32[(($3 + 8 | 0) + 8 | 0) >> 2] | 0;
  }
  global$0 = $3 + 96 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_recursing__h638ded5d44315e91($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $7 = 0, $4 = 0, $5 = 0, $6 = 0, $8 = 0, $20 = 0, $29 = 0, $78 = 0, $103 = 0, $137 = 0, $156 = 0;
  $3 = global$0 - 96 | 0;
  global$0 = $3;
  HEAP32[(($3 + 64 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[($3 + 64 | 0) >> 2] = $20;
  HEAP32[($3 + 68 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(($3 + 80 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $29 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[($3 + 80 | 0) >> 2] = $29;
  HEAP32[($3 + 84 | 0) >> 2] = i64toi32_i32$0;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert__h43316994191d56a4($3 + 24 | 0 | 0, $3 + 64 | 0 | 0, $3 + 80 | 0 | 0);
  $2 = HEAP32[(($3 + 24 | 0) + 8 | 0) >> 2] | 0;
  $1 = HEAP32[($3 + 28 | 0) >> 2] | 0;
  $4 = HEAP32[($3 + 56 | 0) >> 2] | 0;
  label$1 : {
   label$2 : {
    if ((HEAP32[($3 + 24 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    HEAP32[($0 + 32 | 0) >> 2] = $4;
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    HEAP32[$0 >> 2] = 0;
    HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($3 + 36 | 0) >> 2] | 0;
    HEAP32[($0 + 8 | 0) >> 2] = $2;
    break label$1;
   }
   $5 = HEAP32[(($3 + 24 | 0) + 28 | 0) >> 2] | 0;
   $6 = HEAP32[(($3 + 24 | 0) + 24 | 0) >> 2] | 0;
   $7 = ($3 + 24 | 0) + 12 | 0;
   HEAP32[(($3 + 8 | 0) + 8 | 0) >> 2] = HEAP32[($7 + 8 | 0) >> 2] | 0;
   i64toi32_i32$2 = $7;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $78 = i64toi32_i32$0;
   i64toi32_i32$0 = $3;
   HEAP32[($3 + 8 | 0) >> 2] = $78;
   HEAP32[($3 + 12 | 0) >> 2] = i64toi32_i32$1;
   label$3 : {
    $7 = HEAP32[$2 >> 2] | 0;
    if (!$7) {
     break label$3
    }
    $8 = $3 + 36 | 0;
    label$4 : while (1) {
     HEAP32[($3 + 72 | 0) >> 2] = HEAPU16[($2 + 136 | 0) >> 1] | 0;
     HEAP32[($3 + 68 | 0) >> 2] = $7;
     HEAP32[($3 + 64 | 0) >> 2] = $1 + 1 | 0;
     $7 = ($3 + 8 | 0) + 8 | 0;
     HEAP32[(($3 + 80 | 0) + 8 | 0) >> 2] = HEAP32[$7 >> 2] | 0;
     i64toi32_i32$2 = $3;
     i64toi32_i32$1 = HEAP32[($3 + 8 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($3 + 12 | 0) >> 2] | 0;
     $103 = i64toi32_i32$1;
     i64toi32_i32$1 = $3;
     HEAP32[($3 + 80 | 0) >> 2] = $103;
     HEAP32[($3 + 84 | 0) >> 2] = i64toi32_i32$0;
     alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert__h79a822cb48d5a02c($3 + 24 | 0 | 0, $3 + 64 | 0 | 0, $3 + 80 | 0 | 0, $6 | 0, $5 | 0);
     $2 = HEAP32[($3 + 32 | 0) >> 2] | 0;
     $1 = HEAP32[($3 + 28 | 0) >> 2] | 0;
     label$5 : {
      if ((HEAP32[($3 + 24 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$5
      }
      HEAP32[($0 + 32 | 0) >> 2] = $4;
      HEAP32[($0 + 4 | 0) >> 2] = $1;
      HEAP32[$0 >> 2] = 0;
      HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($3 + 36 | 0) >> 2] | 0;
      HEAP32[($0 + 8 | 0) >> 2] = $2;
      break label$1;
     }
     HEAP32[$7 >> 2] = HEAP32[($8 + 8 | 0) >> 2] | 0;
     i64toi32_i32$2 = $8;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $137 = i64toi32_i32$0;
     i64toi32_i32$0 = $3;
     HEAP32[($3 + 8 | 0) >> 2] = $137;
     HEAP32[($3 + 12 | 0) >> 2] = i64toi32_i32$1;
     $5 = HEAP32[($3 + 52 | 0) >> 2] | 0;
     $6 = HEAP32[($3 + 48 | 0) >> 2] | 0;
     $7 = HEAP32[$2 >> 2] | 0;
     if ($7) {
      continue label$4
     }
     break label$4;
    };
   }
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = 1;
   HEAP32[($0 + 32 | 0) >> 2] = $4;
   HEAP32[($0 + 8 | 0) >> 2] = $2;
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[($3 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($3 + 12 | 0) >> 2] | 0;
   $156 = i64toi32_i32$1;
   i64toi32_i32$1 = $0 + 12 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $156;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($0 + 28 | 0) >> 2] = $5;
   HEAP32[($0 + 24 | 0) >> 2] = $6;
   HEAP32[($0 + 20 | 0) >> 2] = HEAP32[(($3 + 8 | 0) + 8 | 0) >> 2] | 0;
  }
  global$0 = $3 + 96 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__PoolRegistration___deserialize_as_embedded_group__h417fb115ca31b437($0, $1, $2, $2$hi, $3, $3$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  var $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, $10 = 0, $10$hi = 0, $5 = 0, i64toi32_i32$4 = 0, $11 = 0, $11$hi = 0, $6 = 0, $7 = 0, $23 = 0, $8 = 0, $12 = 0, $12$hi = 0, $9 = 0;
  $4 = global$0 - 976 | 0;
  global$0 = $4;
  cbor_event__de__Deserializer_R___unsigned_integer__h1ed99c0b7fe7eea1($4 + 776 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[($4 + 784 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($4 + 788 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        i64toi32_i32$2 = $4;
        i64toi32_i32$1 = HEAP32[($4 + 776 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[($4 + 780 | 0) >> 2] | 0;
        i64toi32_i32$2 = i64toi32_i32$1;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
         break label$6
        }
        i64toi32_i32$2 = 0;
        $11 = 3;
        $11$hi = i64toi32_i32$2;
        i64toi32_i32$2 = $10$hi;
        i64toi32_i32$3 = $10;
        i64toi32_i32$0 = 0;
        i64toi32_i32$1 = 3;
        if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) | 0) {
         break label$4
        }
        $5 = 8;
        $6 = 1;
        $7 = 1;
        break label$5;
       }
       i64toi32_i32$3 = $10$hi;
       i64toi32_i32$1 = $10;
       i64toi32_i32$2 = 0;
       i64toi32_i32$0 = 32;
       i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = 0;
        $23 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$2 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
        $23 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
       }
       $8 = $23;
       i64toi32_i32$3 = $4 + 816 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $12 = i64toi32_i32$2;
       $12$hi = i64toi32_i32$1;
       i64toi32_i32$3 = $4 + 808 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $11 = i64toi32_i32$1;
       $11$hi = i64toi32_i32$2;
       $9 = HEAP32[($4 + 804 | 0) >> 2] | 0;
       $7 = HEAP32[($4 + 800 | 0) >> 2] | 0;
       i64toi32_i32$2 = $10$hi;
       $6 = $10;
       $5 = 2;
       i64toi32_i32$3 = $4 + 792 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $10 = i64toi32_i32$2;
       $10$hi = i64toi32_i32$1;
      }
      i64toi32_i32$1 = $12$hi;
      i64toi32_i32$2 = $4 + 816 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $12;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$1 = $11$hi;
      i64toi32_i32$2 = $4 + 808 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $11;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($4 + 804 | 0) >> 2] = $9;
      HEAP32[($4 + 800 | 0) >> 2] = $7;
      i64toi32_i32$1 = $10$hi;
      i64toi32_i32$2 = $4 + 792 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $10;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($4 + 788 | 0) >> 2] = $8;
      HEAP32[($4 + 784 | 0) >> 2] = $6;
      HEAP32[($4 + 824 | 0) >> 2] = 0;
      HEAP8[($4 + 776 | 0) >> 0] = $5;
      cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($4 + 192 | 0 | 0, $4 + 776 | 0 | 0, 1050766 | 0, 7 | 0);
      $5 = HEAPU8[($4 + 192 | 0) >> 0] | 0;
      if (($5 | 0) != (19 | 0)) {
       break label$3
      }
     }
     i64toi32_i32$1 = $10$hi;
     i64toi32_i32$2 = i64toi32_i32$1;
     cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__PoolParams___deserialize_as_embedded_group__he3f2f174b1ace167($4 + 776 | 0 | 0, $1 | 0, $10 | 0, i64toi32_i32$1 | 0, $10 | 0, i64toi32_i32$1 | 0);
     $1 = ($4 + 776 | 0) + 8 | 0;
     i64toi32_i32$3 = $4;
     i64toi32_i32$2 = HEAP32[($4 + 776 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($4 + 780 | 0) >> 2] | 0;
     i64toi32_i32$3 = i64toi32_i32$2;
     i64toi32_i32$2 = 0;
     i64toi32_i32$0 = 1;
     if ((i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) | 0) {
      break label$2
     }
     memcpy($4 + 584 | 0 | 0, $1 | 0, 192 | 0) | 0;
     memcpy($4 + 392 | 0 | 0, $4 + 584 | 0 | 0, 192 | 0) | 0;
     memcpy($0 + 8 | 0 | 0, memcpy($4 | 0, memcpy(($4 + 192 | 0) + 8 | 0 | 0, $4 + 392 | 0 | 0, 192 | 0) | 0 | 0, 192 | 0) | 0 | 0, 192 | 0) | 0;
     i64toi32_i32$1 = $0;
     i64toi32_i32$3 = 0;
     HEAP32[i64toi32_i32$1 >> 2] = 0;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
     break label$1;
    }
    memcpy($4 + 584 | 0 | 0, $4 + 192 | 0 | 1 | 0 | 0, 63 | 0) | 0;
    HEAP8[($0 + 8 | 0) >> 0] = $5;
    memcpy($0 + 9 | 0 | 0, $4 + 584 | 0 | 0, 63 | 0) | 0;
    i64toi32_i32$1 = $0;
    i64toi32_i32$3 = 0;
    HEAP32[i64toi32_i32$1 >> 2] = 1;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
    break label$1;
   }
   memcpy($4 + 584 | 0 | 0, $1 | 0, 64 | 0) | 0;
   memcpy($4 + 392 | 0 | 0, $4 + 584 | 0 | 0, 64 | 0) | 0;
   memcpy($4 + 776 | 0 | 0, $4 + 392 | 0 | 0, 64 | 0) | 0;
   $1 = ($4 + 192 | 0) + 8 | 0;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 776 | 0 | 0, 1050995 | 0, 11 | 0);
   memcpy($0 + 8 | 0 | 0, memcpy($4 | 0, $1 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$3 = 0;
   HEAP32[i64toi32_i32$1 >> 2] = 1;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
  }
  global$0 = $4 + 976 | 0;
 }
 
 function cardano_serialization_lib___impl_20core__convert__From__cardano_serialization_lib__NativeScripts__20for_20alloc__collections__btree__set__BTreeSet_cardano_serialization_lib__crypto__Ed25519KeyHash____from__h8d3ffd91703d691f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, $4 = 0, $24 = 0, $25 = 0, $6 = 0, $7 = 0, $8 = 0, $9 = 0, $10 = 0, $5 = 0, $37 = 0, $73 = 0, $80 = 0, $83 = 0, $105 = 0, $112 = 0, $115 = 0, $136 = 0, $140 = 0, $143 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  i64toi32_i32$1 = $0;
  i64toi32_i32$0 = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
  label$1 : {
   $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   if (!$3) {
    break label$1
   }
   $4 = HEAP32[$1 >> 2] | 0;
   $5 = $4 + ($3 << 5 | 0) | 0;
   label$2 : while (1) {
    $6 = ($2 + 32 | 0) + 8 | 0;
    $7 = $0 + 8 | 0;
    HEAP32[$6 >> 2] = HEAP32[$7 >> 2] | 0;
    HEAP32[($2 + 44 | 0) >> 2] = $4;
    i64toi32_i32$2 = $0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $37 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[($2 + 32 | 0) >> 2] = $37;
    HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
    cardano_serialization_lib___impl_20core__convert__From__cardano_serialization_lib__NativeScript__20for_20alloc__collections__btree__set__BTreeSet_cardano_serialization_lib__crypto__Ed25519KeyHash____from__h8ccce5a95eccf6e5($2 + 80 | 0 | 0, $4 | 0);
    label$3 : {
     label$4 : {
      $1 = HEAP32[($2 + 84 | 0) >> 2] | 0;
      if (!$1) {
       break label$4
      }
      $3 = HEAP32[($2 + 80 | 0) >> 2] | 0;
      alloc__collections__btree__navigate__full_range__h687ff3c975ae5f45($2 + 48 | 0 | 0, $3 | 0, $1 | 0, $3 | 0, $1 | 0);
      $1 = HEAP32[($2 + 88 | 0) >> 2] | 0;
      break label$3;
     }
     $1 = 0;
     HEAP32[($2 + 64 | 0) >> 2] = 0;
     HEAP32[($2 + 52 | 0) >> 2] = 0;
    }
    $4 = $4 + 32 | 0;
    HEAP32[(($2 + 48 | 0) + 24 | 0) >> 2] = $1;
    HEAP32[(($2 + 96 | 0) + 24 | 0) >> 2] = $1;
    i64toi32_i32$2 = ($2 + 48 | 0) + 16 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $73 = i64toi32_i32$1;
    i64toi32_i32$1 = ($2 + 96 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $73;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = ($2 + 48 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $80 = i64toi32_i32$0;
    i64toi32_i32$0 = ($2 + 96 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $80;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[($2 + 48 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 52 | 0) >> 2] | 0;
    $83 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 96 | 0) >> 2] = $83;
    HEAP32[($2 + 100 | 0) >> 2] = i64toi32_i32$0;
    $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__hbd7038216761c388($2 + 24 | 0 | 0, $2 + 96 | 0 | 0);
    label$5 : {
     $1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
     if (!$1) {
      break label$5
     }
     $3 = ($2 + 128 | 0) + 24 | 0;
     $24 = $1 + 24 | 0;
     HEAP32[$3 >> 2] = HEAPU8[$24 >> 0] | 0 | ((HEAPU8[($24 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($24 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($24 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $8 = ($2 + 128 | 0) + 16 | 0;
     i64toi32_i32$2 = $1 + 16 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $105 = i64toi32_i32$0;
     i64toi32_i32$0 = $8;
     HEAP32[i64toi32_i32$0 >> 2] = $105;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     $9 = ($2 + 128 | 0) + 8 | 0;
     i64toi32_i32$2 = $1 + 8 | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $112 = i64toi32_i32$1;
     i64toi32_i32$1 = $9;
     HEAP32[i64toi32_i32$1 >> 2] = $112;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $1;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $115 = i64toi32_i32$0;
     i64toi32_i32$0 = $2;
     HEAP32[($2 + 128 | 0) >> 2] = $115;
     HEAP32[($2 + 132 | 0) >> 2] = i64toi32_i32$1;
     alloc__collections__btree__map__BTreeMap_K_2cV___insert__h5d8c7a7452747b0f($2 + 32 | 0 | 0, $2 + 128 | 0 | 0) | 0;
     $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__hbd7038216761c388($2 + 16 | 0 | 0, $2 + 96 | 0 | 0);
     $1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
     if (!$1) {
      break label$5
     }
     label$6 : while (1) {
      $25 = $1 + 24 | 0;
      HEAP32[$3 >> 2] = HEAPU8[$25 >> 0] | 0 | ((HEAPU8[($25 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($25 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($25 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$2 = $1 + 16 | 0;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $136 = i64toi32_i32$1;
      i64toi32_i32$1 = $8;
      HEAP32[i64toi32_i32$1 >> 2] = $136;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $1 + 8 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $140 = i64toi32_i32$0;
      i64toi32_i32$0 = $9;
      HEAP32[i64toi32_i32$0 >> 2] = $140;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $1;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $143 = i64toi32_i32$1;
      i64toi32_i32$1 = $2;
      HEAP32[($2 + 128 | 0) >> 2] = $143;
      HEAP32[($2 + 132 | 0) >> 2] = i64toi32_i32$0;
      alloc__collections__btree__map__BTreeMap_K_2cV___insert__h5d8c7a7452747b0f($2 + 32 | 0 | 0, $2 + 128 | 0 | 0) | 0;
      $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__hbd7038216761c388($2 + 8 | 0 | 0, $2 + 96 | 0 | 0);
      $1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
      if ($1) {
       continue label$6
      }
      break label$6;
     };
    }
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h04a6b671c790649f($2 + 80 | 0 | 0);
    $1 = HEAP32[$6 >> 2] | 0;
    HEAP32[(($2 + 128 | 0) + 8 | 0) >> 2] = $1;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
    $10 = i64toi32_i32$0;
    i64toi32_i32$0 = i64toi32_i32$2;
    HEAP32[(i64toi32_i32$2 + 128 | 0) >> 2] = $10;
    HEAP32[(i64toi32_i32$2 + 132 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[$7 >> 2] = $1;
    i64toi32_i32$0 = $0;
    HEAP32[i64toi32_i32$0 >> 2] = $10;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    if (($4 | 0) != ($5 | 0)) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $2 + 160 | 0;
 }
 
 function bech32__convert_bits__h33858259079f1ea0($0, $1, $2, $3, $4, $5) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  $5 = $5 | 0;
  var $6 = 0, $7 = 0, $13 = 0, $14 = 0, i64toi32_i32$0 = 0, $8 = 0, $9 = 0, i64toi32_i32$1 = 0, $12 = 0, $10 = 0, $11 = 0, $15 = 0, $162 = 0;
  $6 = global$0 - 16 | 0;
  global$0 = $6;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if (($4 + -1 | 0 | ($3 + -1 | 0) | 0) >>> 0 > 7 >>> 0) {
       break label$4
      }
      i64toi32_i32$1 = $6;
      i64toi32_i32$0 = 0;
      HEAP32[($6 + 4 | 0) >> 2] = 0;
      HEAP32[($6 + 8 | 0) >> 2] = i64toi32_i32$0;
      $7 = 0;
      $8 = HEAP32[(0 + 1138240 | 0) >> 2] | 0;
      HEAP32[$6 >> 2] = $8;
      $9 = (-1 << $4 | 0) ^ -1 | 0;
      label$5 : {
       label$6 : {
        if (!$2) {
         break label$6
        }
        $10 = $1 + $2 | 0;
        $11 = 0 - $4 | 0;
        $12 = $3 & 31 | 0;
        $13 = $1 + 1 | 0;
        $14 = 0;
        $2 = 0;
        label$7 : {
         label$8 : while (1) {
          $15 = $1;
          $1 = $13;
          $13 = HEAPU8[$15 >> 0] | 0;
          if ($13 >>> $12 | 0) {
           break label$7
          }
          $14 = $14 << $12 | 0 | $13 | 0;
          label$9 : {
           $2 = $2 + $3 | 0;
           if ($2 >>> 0 < $4 >>> 0) {
            break label$9
           }
           label$10 : while (1) {
            $13 = $2 - $4 | 0;
            $2 = ($14 >>> (($11 + $2 | 0) & 31 | 0) | 0) & $9 | 0;
            label$11 : {
             if (($7 | 0) != (HEAP32[($6 + 4 | 0) >> 2] | 0 | 0)) {
              break label$11
             }
             label$12 : {
              if (($7 | 0) != ($7 | 0)) {
               break label$12
              }
              alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hd0f2b8018c7d036d($6 | 0, $7 | 0, 1 | 0);
              $7 = HEAP32[($6 + 8 | 0) >> 2] | 0;
             }
             $8 = HEAP32[$6 >> 2] | 0;
            }
            HEAP8[($8 + $7 | 0) >> 0] = $2;
            $7 = (HEAP32[($6 + 8 | 0) >> 2] | 0) + 1 | 0;
            HEAP32[($6 + 8 | 0) >> 2] = $7;
            $2 = $13;
            if ($2 >>> 0 >= $4 >>> 0) {
             continue label$10
            }
            break label$10;
           };
          }
          $13 = $1 + 1 | 0;
          if (($1 | 0) != ($10 | 0)) {
           continue label$8
          }
          break label$8;
         };
         if (!$5) {
          break label$5
         }
         if (!$2) {
          break label$2
         }
         $2 = ($14 << (($4 - $2 | 0) & 31 | 0) | 0) & $9 | 0;
         label$13 : {
          if (($7 | 0) != (HEAP32[($6 + 4 | 0) >> 2] | 0 | 0)) {
           break label$13
          }
          if (($7 | 0) != ($7 | 0)) {
           break label$13
          }
          alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hd0f2b8018c7d036d($6 | 0, $7 | 0, 1 | 0);
          $7 = HEAP32[($6 + 8 | 0) >> 2] | 0;
         }
         HEAP8[((HEAP32[$6 >> 2] | 0) + $7 | 0) >> 0] = $2;
         HEAP32[($6 + 8 | 0) >> 2] = $7 + 1 | 0;
         break label$2;
        }
        HEAP8[($0 + 4 | 0) >> 0] = 4;
        HEAP8[($0 + 5 | 0) >> 0] = $13;
        break label$3;
       }
       $14 = 0;
       $2 = 0;
       if ($5) {
        break label$2
       }
      }
      label$14 : {
       if ($2 >>> 0 >= $3 >>> 0) {
        break label$14
       }
       if (!(($14 << (($4 - $2 | 0) & 31 | 0) | 0) & $9 | 0)) {
        break label$2
       }
      }
      HEAP8[($0 + 4 | 0) >> 0] = 5;
      break label$3;
     }
     std__panicking__begin_panic__h7de1da834ae32d4b(1138884 | 0, 59 | 0, 1138944 | 0);
     abort();
    }
    HEAP32[$0 >> 2] = 1;
    $7 = HEAP32[($6 + 4 | 0) >> 2] | 0;
    if (!$7) {
     break label$1
    }
    __rust_dealloc(HEAP32[$6 >> 2] | 0 | 0, $7 | 0, 1 | 0);
    break label$1;
   }
   i64toi32_i32$0 = HEAP32[$6 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($6 + 4 | 0) >> 2] | 0;
   $162 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[($0 + 4 | 0) >> 2] = $162;
   HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[$0 >> 2] = 0;
   HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($6 + 8 | 0) >> 2] | 0;
  }
  global$0 = $6 + 16 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__Header___deserialize_as_embedded_group__h3abb3b455930f669($0, $1, $2, $2$hi, $3, $3$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  var $4 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $5 = 0, $56 = 0, $68 = 0;
  $4 = global$0 - 1920 | 0;
  global$0 = $4;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__HeaderBody___deserialize__hca688f096fd630fa($4 + 1280 | 0 | 0, $1 | 0);
  $5 = ($4 + 1280 | 0) + 8 | 0;
  label$1 : {
   label$2 : {
    i64toi32_i32$2 = $4;
    i64toi32_i32$0 = HEAP32[($4 + 1280 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($4 + 1284 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    if ((i64toi32_i32$2 | 0) == (1 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
     break label$2
    }
    memcpy($4 + 1608 | 0 | 0, $5 | 0, 312 | 0) | 0;
    memcpy($4 + 952 | 0 | 0, $4 + 1608 | 0 | 0, 312 | 0) | 0;
    memcpy($4 + 320 | 0 | 0, memcpy(($4 + 632 | 0) + 8 | 0 | 0, $4 + 952 | 0 | 0, 312 | 0) | 0 | 0, 312 | 0) | 0;
    memcpy($4 + 8 | 0 | 0, $4 + 320 | 0 | 0, 312 | 0) | 0;
    $cardano_serialization_lib__crypto__KESSignature_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hc6a4a33a8e3a1489($4 + 1280 | 0 | 0, $1 | 0);
    label$3 : {
     if ((HEAP32[($4 + 1280 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     $1 = ($4 + 1264 | 0) + 8 | 0;
     HEAP32[$1 >> 2] = HEAP32[($4 + 1292 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[($4 + 1284 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($4 + 1288 | 0) >> 2] | 0;
     $56 = i64toi32_i32$2;
     i64toi32_i32$2 = $4;
     HEAP32[($4 + 1264 | 0) >> 2] = $56;
     HEAP32[($4 + 1268 | 0) >> 2] = i64toi32_i32$1;
     memcpy($4 + 1280 | 0 | 0, $4 + 8 | 0 | 0, 312 | 0) | 0;
     HEAP32[($4 + 1600 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($4 + 1264 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[($4 + 1268 | 0) >> 2] | 0;
     $68 = i64toi32_i32$1;
     i64toi32_i32$1 = $4;
     HEAP32[($4 + 1592 | 0) >> 2] = $68;
     HEAP32[($4 + 1596 | 0) >> 2] = i64toi32_i32$2;
     memcpy($0 + 8 | 0 | 0, $4 + 1280 | 0 | 0, 328 | 0) | 0;
     i64toi32_i32$1 = $0;
     i64toi32_i32$2 = 0;
     HEAP32[$0 >> 2] = 0;
     HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$2;
     break label$1;
    }
    memcpy($4 + 1280 | 0 | 0, memcpy($4 + 952 | 0 | 4 | 0 | 0, memcpy($4 + 1608 | 0 | 4 | 0 | 0, ($4 + 1280 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
    $1 = ($4 + 632 | 0) + 8 | 0;
    cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 1280 | 0 | 0, 1052798 | 0, 14 | 0);
    memcpy($0 + 8 | 0 | 0, memcpy($4 + 320 | 0 | 4 | 0 | 0, $1 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
    i64toi32_i32$1 = $0;
    i64toi32_i32$2 = 0;
    HEAP32[$0 >> 2] = 1;
    HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$2;
    $0 = $4 + 20 | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
    $0 = $4 + 32 | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
    $0 = $4 + 44 | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
    $0 = $4 + 56 | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
    break label$1;
   }
   memcpy($4 + 1608 | 0 | 0, $5 | 0, 64 | 0) | 0;
   memcpy($4 + 952 | 0 | 0, $4 + 1608 | 0 | 0, 64 | 0) | 0;
   memcpy($4 + 1280 | 0 | 0, $4 + 952 | 0 | 0, 64 | 0) | 0;
   $1 = ($4 + 632 | 0) + 8 | 0;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 1280 | 0 | 0, 1052787 | 0, 11 | 0);
   memcpy($4 + 320 | 0 | 0, $1 | 0, 64 | 0) | 0;
   memcpy($0 + 8 | 0 | 0, $4 + 320 | 0 | 0, 64 | 0) | 0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$2 = 0;
   HEAP32[$0 >> 2] = 1;
   HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$2;
  }
  global$0 = $4 + 1920 | 0;
 }
 
 function cardano_serialization_lib__output_builder__TransactionOutputAmountBuilder__build__he57d4fcb648faafd($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $4 = 0, $3 = 0, $27 = 0, $28 = 0, $29 = 0, $30 = 0, $5 = 0, $7 = 0, $8 = 0, $9 = 0, $6 = 0, $6$hi = 0, $37 = 0, $51 = 0, $62 = 0, $70 = 0, $75 = 0, $80 = 0, $84 = 0, $99 = 0, $7$hi = 0, $8$hi = 0, $120 = 0, $9$hi = 0, $146 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  $cardano_serialization_lib__address__Address_20as_20core__clone__Clone___clone__h0eb465a6e349d507_1($2 + 32 | 0 | 0, $1 | 0);
  $3 = 2;
  label$1 : {
   $4 = HEAP32[($1 + 72 | 0) >> 2] | 0;
   if (($4 | 0) == (2 | 0)) {
    break label$1
   }
   i64toi32_i32$2 = $1;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
   $6 = i64toi32_i32$0;
   $6$hi = i64toi32_i32$1;
   $3 = 0;
   label$2 : {
    if (($4 | 0) != (1 | 0)) {
     break label$2
    }
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($2 + 144 | 0 | 4 | 0 | 0, $1 + 76 | 0 | 0);
    $3 = 1;
   }
   HEAP32[($2 + 136 | 0) >> 2] = HEAP32[($2 + 156 | 0) >> 2] | 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = HEAP32[($2 + 148 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 152 | 0) >> 2] | 0;
   $37 = i64toi32_i32$1;
   i64toi32_i32$1 = $2;
   HEAP32[(i64toi32_i32$1 + 128 | 0) >> 2] = $37;
   HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] = i64toi32_i32$0;
  }
  $4 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1057017 | 0, 46 | 0) | 0;
  label$3 : {
   label$4 : {
    if (($3 | 0) == (2 | 0)) {
     break label$4
    }
    $5 = ($2 + 112 | 0) + 8 | 0;
    HEAP32[$5 >> 2] = HEAP32[(($2 + 128 | 0) + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[($2 + 128 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 132 | 0) >> 2] | 0;
    $51 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[(i64toi32_i32$0 + 112 | 0) >> 2] = $51;
    HEAP32[(i64toi32_i32$0 + 116 | 0) >> 2] = i64toi32_i32$1;
    label$5 : {
     if ($4 >>> 0 < 36 >>> 0) {
      break label$5
     }
     wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($4 | 0);
    }
    HEAP32[(($2 + 96 | 0) + 8 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[($2 + 112 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 116 | 0) >> 2] | 0;
    $62 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[(i64toi32_i32$1 + 96 | 0) >> 2] = $62;
    HEAP32[(i64toi32_i32$1 + 100 | 0) >> 2] = i64toi32_i32$0;
    $4 = 0;
    label$6 : {
     if ((HEAPU8[($1 + 88 | 0) >> 0] | 0 | 0) != (1 | 0)) {
      break label$6
     }
     i64toi32_i32$2 = $1 + 113 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $70 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 168 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $70;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $1 + 105 | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $75 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 160 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $75;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $1 + 97 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $80 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 152 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $80;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $1 + 89 | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $84 = i64toi32_i32$1;
     i64toi32_i32$1 = $2;
     HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $84;
     HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
     $4 = 1;
    }
    memcpy($0 + 8 | 0 | 0, $2 + 32 | 0 | 0, 64 | 0) | 0;
    HEAP32[($0 + 92 | 0) >> 2] = HEAP32[(($2 + 96 | 0) + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 100 | 0) >> 2] | 0;
    $99 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 84 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $99;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = (i64toi32_i32$2 + 144 | 0) + 16 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $7 = i64toi32_i32$1;
    $7$hi = i64toi32_i32$0;
    i64toi32_i32$1 = $2 + 16 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $7;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = ($2 + 144 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $8 = i64toi32_i32$0;
    $8$hi = i64toi32_i32$1;
    i64toi32_i32$0 = $2 + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $8;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    $1 = $2 + 24 | 0;
    i64toi32_i32$2 = ($2 + 144 | 0) + 24 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $120 = i64toi32_i32$1;
    i64toi32_i32$1 = $1;
    HEAP32[i64toi32_i32$1 >> 2] = $120;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 144 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 148 | 0) >> 2] | 0;
    $9 = i64toi32_i32$0;
    $9$hi = i64toi32_i32$1;
    i64toi32_i32$0 = i64toi32_i32$2;
    HEAP32[i64toi32_i32$2 >> 2] = $9;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP8[($0 + 96 | 0) >> 0] = $4;
    HEAP32[($0 + 80 | 0) >> 2] = $3;
    i64toi32_i32$1 = $6$hi;
    i64toi32_i32$0 = $0 + 72 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $6;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $9$hi;
    i64toi32_i32$0 = $0;
    $27 = $9;
    HEAP8[(i64toi32_i32$0 + 97 | 0) >> 0] = $27;
    HEAP8[(i64toi32_i32$0 + 98 | 0) >> 0] = $27 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 99 | 0) >> 0] = $27 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 100 | 0) >> 0] = $27 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 101 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 102 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 103 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 104 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$1 = $8$hi;
    i64toi32_i32$0 = i64toi32_i32$0 + 105 | 0;
    $28 = $8;
    HEAP8[i64toi32_i32$0 >> 0] = $28;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $28 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $28 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $28 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$1 = $7$hi;
    i64toi32_i32$0 = $0 + 113 | 0;
    $29 = $7;
    HEAP8[i64toi32_i32$0 >> 0] = $29;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $29 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $29 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $29 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    HEAP32[$0 >> 2] = 0;
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $146 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 121 | 0;
    $30 = $146;
    HEAP8[i64toi32_i32$1 >> 0] = $30;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $30 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $30 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $30 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    break label$3;
   }
   $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($4 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   if ((HEAPU8[($2 + 32 | 0) >> 0] | 0) >>> 0 < 4 >>> 0) {
    break label$3
   }
   core__ptr__drop_in_place_core__option__Option_alloc__vec__Vec_u8_____ha5300c747747c3c8($2 + 32 | 0 | 4 | 0 | 0);
  }
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__MoveInstantaneousRewardsCert___deserialize_as_embedded_group__ha238bf99690081e0($0, $1, $2, $2$hi, $3, $3$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  var $4 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, $10 = 0, $10$hi = 0, $5 = 0, i64toi32_i32$4 = 0, $11 = 0, $11$hi = 0, $6 = 0, $7 = 0, $23 = 0, $8 = 0, $12 = 0, $12$hi = 0, $9 = 0;
  $4 = global$0 - 336 | 0;
  global$0 = $4;
  cbor_event__de__Deserializer_R___unsigned_integer__h1ed99c0b7fe7eea1($4 + 264 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[($4 + 272 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($4 + 276 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        i64toi32_i32$2 = $4;
        i64toi32_i32$1 = HEAP32[($4 + 264 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[($4 + 268 | 0) >> 2] | 0;
        i64toi32_i32$2 = i64toi32_i32$1;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
         break label$6
        }
        i64toi32_i32$2 = 0;
        $11 = 6;
        $11$hi = i64toi32_i32$2;
        i64toi32_i32$2 = $10$hi;
        i64toi32_i32$3 = $10;
        i64toi32_i32$0 = 0;
        i64toi32_i32$1 = 6;
        if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) | 0) {
         break label$4
        }
        $5 = 8;
        $6 = 1;
        $7 = 1;
        break label$5;
       }
       i64toi32_i32$3 = $10$hi;
       i64toi32_i32$1 = $10;
       i64toi32_i32$2 = 0;
       i64toi32_i32$0 = 32;
       i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = 0;
        $23 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$2 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
        $23 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
       }
       $8 = $23;
       i64toi32_i32$3 = $4 + 304 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $12 = i64toi32_i32$2;
       $12$hi = i64toi32_i32$1;
       i64toi32_i32$3 = $4 + 296 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $11 = i64toi32_i32$1;
       $11$hi = i64toi32_i32$2;
       $9 = HEAP32[($4 + 292 | 0) >> 2] | 0;
       $7 = HEAP32[($4 + 288 | 0) >> 2] | 0;
       i64toi32_i32$2 = $10$hi;
       $6 = $10;
       $5 = 2;
       i64toi32_i32$3 = $4 + 280 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $10 = i64toi32_i32$2;
       $10$hi = i64toi32_i32$1;
      }
      i64toi32_i32$1 = $12$hi;
      i64toi32_i32$2 = $4 + 304 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $12;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$1 = $11$hi;
      i64toi32_i32$2 = $4 + 296 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $11;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($4 + 292 | 0) >> 2] = $9;
      HEAP32[($4 + 288 | 0) >> 2] = $7;
      i64toi32_i32$1 = $10$hi;
      i64toi32_i32$2 = $4 + 280 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $10;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($4 + 276 | 0) >> 2] = $8;
      HEAP32[($4 + 272 | 0) >> 2] = $6;
      HEAP32[($4 + 312 | 0) >> 2] = 0;
      HEAP8[($4 + 264 | 0) >> 0] = $5;
      cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($4 + 64 | 0 | 0, $4 + 264 | 0 | 0, 1050766 | 0, 7 | 0);
      $5 = HEAPU8[($4 + 64 | 0) >> 0] | 0;
      if (($5 | 0) != (19 | 0)) {
       break label$3
      }
     }
     cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__MoveInstantaneousReward___deserialize__h01d321bfaafb2a23($4 + 264 | 0 | 0, $1 | 0);
     $1 = ($4 + 264 | 0) + 8 | 0;
     i64toi32_i32$3 = $4;
     i64toi32_i32$1 = HEAP32[($4 + 264 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[($4 + 268 | 0) >> 2] | 0;
     i64toi32_i32$3 = i64toi32_i32$1;
     i64toi32_i32$1 = 0;
     i64toi32_i32$0 = 1;
     if ((i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$1 | 0) | 0) {
      break label$2
     }
     memcpy($4 + 200 | 0 | 0, $1 | 0, 56 | 0) | 0;
     memcpy($4 + 136 | 0 | 0, $4 + 200 | 0 | 0, 56 | 0) | 0;
     memcpy($0 + 8 | 0 | 0, memcpy($4 | 0, memcpy(($4 + 64 | 0) + 8 | 0 | 0, $4 + 136 | 0 | 0, 56 | 0) | 0 | 0, 56 | 0) | 0 | 0, 56 | 0) | 0;
     i64toi32_i32$2 = $0;
     i64toi32_i32$3 = 0;
     HEAP32[i64toi32_i32$2 >> 2] = 0;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
     break label$1;
    }
    memcpy($4 + 200 | 0 | 0, $4 + 64 | 0 | 1 | 0 | 0, 63 | 0) | 0;
    HEAP8[($0 + 8 | 0) >> 0] = $5;
    memcpy($0 + 9 | 0 | 0, $4 + 200 | 0 | 0, 63 | 0) | 0;
    i64toi32_i32$2 = $0;
    i64toi32_i32$3 = 0;
    HEAP32[i64toi32_i32$2 >> 2] = 1;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
    break label$1;
   }
   memcpy($4 + 200 | 0 | 0, $1 | 0, 64 | 0) | 0;
   memcpy($4 + 136 | 0 | 0, $4 + 200 | 0 | 0, 64 | 0) | 0;
   memcpy($4 + 264 | 0 | 0, $4 + 136 | 0 | 0, 64 | 0) | 0;
   $1 = ($4 + 64 | 0) + 8 | 0;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 264 | 0 | 0, 1051105 | 0, 25 | 0);
   memcpy($0 + 8 | 0 | 0, memcpy($4 | 0, $1 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   i64toi32_i32$2 = $0;
   i64toi32_i32$3 = 0;
   HEAP32[i64toi32_i32$2 >> 2] = 1;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
  }
  global$0 = $4 + 336 | 0;
 }
 
 function cardano_serialization_lib__crypto__Bip32PrivateKey__to_128_xprv__he72d886a3f7cebc8($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $5 = 0, $6 = 0, $7 = 0, $53 = 0, $59 = 0, $65 = 0, $68 = 0, $80 = 0, $84 = 0, $88 = 0, $92 = 0;
  $2 = global$0 - 304 | 0;
  global$0 = $2;
  memset($2 + 240 | 0 | 0, 0 | 0, 64 | 0) | 0;
  ed25519_bip32__key__XPrv__get_extended_mut__h396b8224008dfa18($1 | 0, $2 + 240 | 0 | 0);
  memcpy($2 + 112 | 0 | 1 | 0 | 0, $2 + 240 | 0 | 0, 64 | 0) | 0;
  HEAP8[($2 + 112 | 0) >> 0] = 0;
  cardano_serialization_lib__crypto__PrivateKey__as_bytes__ha195925edbe0b49d($2 + 48 | 0 | 0, $2 + 112 | 0 | 0);
  ed25519_bip32__key__XPrv__public__h9a90c9dc9e5d18c6($2 + 112 | 0 | 0, $1 | 0);
  $3 = ($2 + 240 | 0) + 24 | 0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = ($2 + 240 | 0) + 16 | 0;
  i64toi32_i32$1 = $4;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $5 = ($2 + 240 | 0) + 8 | 0;
  i64toi32_i32$1 = $5;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 240 | 0) >> 2] = 0;
  HEAP32[($2 + 244 | 0) >> 2] = i64toi32_i32$0;
  ed25519_bip32__key__XPub__get_without_chaincode__h1b3f335862724d9d($2 + 112 | 0 | 0, $2 + 240 | 0 | 0);
  $6 = ($2 + 80 | 0) + 24 | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $53 = i64toi32_i32$0;
  i64toi32_i32$0 = $6;
  HEAP32[i64toi32_i32$0 >> 2] = $53;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $7 = ($2 + 80 | 0) + 16 | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $59 = i64toi32_i32$1;
  i64toi32_i32$1 = $7;
  HEAP32[i64toi32_i32$1 >> 2] = $59;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = ($2 + 80 | 0) + 8 | 0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $65 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[i64toi32_i32$0 >> 2] = $65;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 240 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 244 | 0) >> 2] | 0;
  $68 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 80 | 0) >> 2] = $68;
  HEAP32[($2 + 84 | 0) >> 2] = i64toi32_i32$0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 + 40 | 0 | 0, 32 | 0, 0 | 0);
  HEAP32[($2 + 68 | 0) >> 2] = HEAP32[($2 + 44 | 0) >> 2] | 0;
  $3 = HEAP32[($2 + 40 | 0) >> 2] | 0;
  HEAP32[($2 + 64 | 0) >> 2] = $3;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 80 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 84 | 0) >> 2] | 0;
  $80 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  $19 = $80;
  HEAP8[i64toi32_i32$0 >> 0] = $19;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $19 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $19 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $19 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $84 = i64toi32_i32$1;
  i64toi32_i32$1 = $3 + 8 | 0;
  $20 = $84;
  HEAP8[i64toi32_i32$1 >> 0] = $20;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $20 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $20 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $20 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $7;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $88 = i64toi32_i32$0;
  i64toi32_i32$0 = $3 + 16 | 0;
  $21 = $88;
  HEAP8[i64toi32_i32$0 >> 0] = $21;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $21 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $21 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $21 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $6;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $92 = i64toi32_i32$1;
  i64toi32_i32$1 = $3 + 24 | 0;
  $22 = $92;
  HEAP8[i64toi32_i32$1 >> 0] = $22;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $22 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $22 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $22 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP32[($2 + 72 | 0) >> 2] = 32;
  cardano_serialization_lib__crypto__Bip32PrivateKey__chaincode__h32cbffafab5e64aa($2 + 240 | 0 | 0, $1 | 0);
  memset($2 + 112 | 0 | 0, 0 | 0, 128 | 0) | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 32 | 0 | 0, $2 + 48 | 0 | 0);
  core__slice___impl_20_5bT_5d___clone_from_slice__h1742dfbd5d5d9efd($2 + 112 | 0 | 0, 64 | 0, HEAP32[($2 + 32 | 0) >> 2] | 0 | 0, HEAP32[($2 + 36 | 0) >> 2] | 0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 24 | 0 | 0, $2 + 64 | 0 | 0);
  core__slice___impl_20_5bT_5d___clone_from_slice__h1742dfbd5d5d9efd(($2 + 112 | 0) + 64 | 0 | 0, 32 | 0, HEAP32[($2 + 24 | 0) >> 2] | 0 | 0, HEAP32[($2 + 28 | 0) >> 2] | 0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 16 | 0 | 0, $2 + 240 | 0 | 0);
  core__slice___impl_20_5bT_5d___clone_from_slice__h1742dfbd5d5d9efd($2 + 208 | 0 | 0, 32 | 0, HEAP32[($2 + 16 | 0) >> 2] | 0 | 0, HEAP32[($2 + 20 | 0) >> 2] | 0 | 0);
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 + 8 | 0 | 0, 128 | 0, 0 | 0);
  $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($2 + 12 | 0) >> 2] | 0;
  HEAP32[$0 >> 2] = $3;
  memcpy($3 | 0, $2 + 112 | 0 | 0, 128 | 0) | 0;
  HEAP32[($0 + 8 | 0) >> 2] = 128;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 240 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 240 | 0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 64 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 64 | 0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 48 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 48 | 0 | 0);
  global$0 = $2 + 304 | 0;
 }
 
 function $serde_json__de__MapAccess_R__20as_20serde__de__MapAccess___next_key_seed__h96feefa156c1f5ba($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $4 = 0, $2 = 0, $3 = 0, $8 = 0, $5 = 0, $7 = 0, $9 = 0, i64toi32_i32$0 = 0, $6 = 0, i64toi32_i32$1 = 0, $131 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     $3 = HEAP32[$1 >> 2] | 0;
     $4 = HEAP32[($3 + 8 | 0) >> 2] | 0;
     $5 = HEAP32[($3 + 4 | 0) >> 2] | 0;
     if ($4 >>> 0 >= $5 >>> 0) {
      break label$3
     }
     $6 = HEAP32[$3 >> 2] | 0;
     $7 = 1;
     label$4 : {
      label$5 : while (1) {
       $8 = HEAPU8[($6 + $4 | 0) >> 0] | 0;
       $9 = $8 + -9 | 0;
       if ($9 >>> 0 > 23 >>> 0) {
        break label$4
       }
       if (!((1 << $9 | 0) & 8388627 | 0)) {
        break label$4
       }
       $4 = $4 + 1 | 0;
       HEAP32[($3 + 8 | 0) >> 2] = $4;
       $7 = $4 >>> 0 < $5 >>> 0;
       if (($5 | 0) != ($4 | 0)) {
        continue label$5
       }
       break label$5;
      };
      $8 = 0;
      $4 = $5;
     }
     if ($7 & 1 | 0) {
      break label$2
     }
    }
    HEAP32[$2 >> 2] = 3;
    $4 = serde_json__de__Deserializer_R___peek_error__hf8794e102c1db2df($3 | 0, $2 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    HEAP32[($0 + 4 | 0) >> 2] = $4;
    break label$1;
   }
   label$6 : {
    label$7 : {
     label$8 : {
      if (($8 | 0) == (44 | 0)) {
       break label$8
      }
      label$9 : {
       if (($8 | 0) == (125 | 0)) {
        break label$9
       }
       if (HEAPU8[($1 + 4 | 0) >> 0] | 0) {
        break label$7
       }
       HEAP32[$2 >> 2] = 8;
       $4 = serde_json__de__Deserializer_R___peek_error__hf8794e102c1db2df($3 | 0, $2 | 0) | 0;
       HEAP32[$0 >> 2] = 1;
       HEAP32[($0 + 4 | 0) >> 2] = $4;
       break label$1;
      }
      i64toi32_i32$1 = $0;
      i64toi32_i32$0 = 0;
      HEAP32[$0 >> 2] = 0;
      HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$0;
      break label$1;
     }
     if (HEAPU8[($1 + 4 | 0) >> 0] | 0) {
      break label$7
     }
     $4 = $4 + 1 | 0;
     HEAP32[($3 + 8 | 0) >> 2] = $4;
     label$10 : {
      if ($4 >>> 0 >= $5 >>> 0) {
       break label$10
      }
      $7 = 1;
      label$11 : {
       label$12 : while (1) {
        $8 = HEAPU8[($6 + $4 | 0) >> 0] | 0;
        $9 = $8 + -9 | 0;
        if ($9 >>> 0 > 23 >>> 0) {
         break label$11
        }
        if (!((1 << $9 | 0) & 8388627 | 0)) {
         break label$11
        }
        $4 = $4 + 1 | 0;
        HEAP32[($3 + 8 | 0) >> 2] = $4;
        $7 = $4 >>> 0 < $5 >>> 0;
        if (($5 | 0) != ($4 | 0)) {
         continue label$12
        }
        break label$12;
       };
       $8 = 0;
      }
      if ($7 & 1 | 0) {
       break label$6
      }
     }
     HEAP32[$2 >> 2] = 5;
     $4 = serde_json__de__Deserializer_R___peek_error__hf8794e102c1db2df($3 | 0, $2 | 0) | 0;
     HEAP32[$0 >> 2] = 1;
     HEAP32[($0 + 4 | 0) >> 2] = $4;
     break label$1;
    }
    HEAP8[($1 + 4 | 0) >> 0] = 0;
   }
   label$13 : {
    label$14 : {
     if (($8 | 0) == (34 | 0)) {
      break label$14
     }
     if (($8 | 0) == (125 | 0)) {
      break label$13
     }
     HEAP32[$2 >> 2] = 16;
     $4 = serde_json__de__Deserializer_R___peek_error__hf8794e102c1db2df($3 | 0, $2 | 0) | 0;
     HEAP32[$0 >> 2] = 1;
     HEAP32[($0 + 4 | 0) >> 2] = $4;
     break label$1;
    }
    $serde_json__value__de__KeyClassifier_20as_20serde__de__DeserializeSeed___deserialize__h8d10a2630f030965($2 | 0, $3 | 0);
    $4 = 1;
    label$15 : {
     label$16 : {
      if ((HEAP32[$2 >> 2] | 0 | 0) == (1 | 0)) {
       break label$16
      }
      $4 = $2 | 4 | 0;
      i64toi32_i32$0 = HEAP32[$4 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
      $131 = i64toi32_i32$0;
      i64toi32_i32$0 = $0;
      HEAP32[($0 + 4 | 0) >> 2] = $131;
      HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($4 + 8 | 0) >> 2] | 0;
      $4 = 0;
      break label$15;
     }
     HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($2 + 4 | 0) >> 2] | 0;
    }
    HEAP32[$0 >> 2] = $4;
    break label$1;
   }
   HEAP32[$2 >> 2] = 18;
   $4 = serde_json__de__Deserializer_R___peek_error__hf8794e102c1db2df($3 | 0, $2 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
   HEAP32[($0 + 4 | 0) >> 2] = $4;
  }
  global$0 = $2 + 16 | 0;
 }
 
 function $serde_json__de__MapAccess_R__20as_20serde__de__MapAccess___next_key_seed__hcd57db292bb18be3($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $4 = 0, $2 = 0, $3 = 0, $8 = 0, $5 = 0, $7 = 0, $9 = 0, i64toi32_i32$0 = 0, $6 = 0, i64toi32_i32$1 = 0, $131 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     $3 = HEAP32[$1 >> 2] | 0;
     $4 = HEAP32[($3 + 8 | 0) >> 2] | 0;
     $5 = HEAP32[($3 + 4 | 0) >> 2] | 0;
     if ($4 >>> 0 >= $5 >>> 0) {
      break label$3
     }
     $6 = HEAP32[$3 >> 2] | 0;
     $7 = 1;
     label$4 : {
      label$5 : while (1) {
       $8 = HEAPU8[($6 + $4 | 0) >> 0] | 0;
       $9 = $8 + -9 | 0;
       if ($9 >>> 0 > 23 >>> 0) {
        break label$4
       }
       if (!((1 << $9 | 0) & 8388627 | 0)) {
        break label$4
       }
       $4 = $4 + 1 | 0;
       HEAP32[($3 + 8 | 0) >> 2] = $4;
       $7 = $4 >>> 0 < $5 >>> 0;
       if (($5 | 0) != ($4 | 0)) {
        continue label$5
       }
       break label$5;
      };
      $8 = 0;
      $4 = $5;
     }
     if ($7 & 1 | 0) {
      break label$2
     }
    }
    HEAP32[$2 >> 2] = 3;
    $4 = serde_json__de__Deserializer_R___peek_error__hf8794e102c1db2df($3 | 0, $2 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    HEAP32[($0 + 4 | 0) >> 2] = $4;
    break label$1;
   }
   label$6 : {
    label$7 : {
     label$8 : {
      if (($8 | 0) == (44 | 0)) {
       break label$8
      }
      label$9 : {
       if (($8 | 0) == (125 | 0)) {
        break label$9
       }
       if (HEAPU8[($1 + 4 | 0) >> 0] | 0) {
        break label$7
       }
       HEAP32[$2 >> 2] = 8;
       $4 = serde_json__de__Deserializer_R___peek_error__hf8794e102c1db2df($3 | 0, $2 | 0) | 0;
       HEAP32[$0 >> 2] = 1;
       HEAP32[($0 + 4 | 0) >> 2] = $4;
       break label$1;
      }
      i64toi32_i32$1 = $0;
      i64toi32_i32$0 = 0;
      HEAP32[$0 >> 2] = 0;
      HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$0;
      break label$1;
     }
     if (HEAPU8[($1 + 4 | 0) >> 0] | 0) {
      break label$7
     }
     $4 = $4 + 1 | 0;
     HEAP32[($3 + 8 | 0) >> 2] = $4;
     label$10 : {
      if ($4 >>> 0 >= $5 >>> 0) {
       break label$10
      }
      $7 = 1;
      label$11 : {
       label$12 : while (1) {
        $8 = HEAPU8[($6 + $4 | 0) >> 0] | 0;
        $9 = $8 + -9 | 0;
        if ($9 >>> 0 > 23 >>> 0) {
         break label$11
        }
        if (!((1 << $9 | 0) & 8388627 | 0)) {
         break label$11
        }
        $4 = $4 + 1 | 0;
        HEAP32[($3 + 8 | 0) >> 2] = $4;
        $7 = $4 >>> 0 < $5 >>> 0;
        if (($5 | 0) != ($4 | 0)) {
         continue label$12
        }
        break label$12;
       };
       $8 = 0;
      }
      if ($7 & 1 | 0) {
       break label$6
      }
     }
     HEAP32[$2 >> 2] = 5;
     $4 = serde_json__de__Deserializer_R___peek_error__hf8794e102c1db2df($3 | 0, $2 | 0) | 0;
     HEAP32[$0 >> 2] = 1;
     HEAP32[($0 + 4 | 0) >> 2] = $4;
     break label$1;
    }
    HEAP8[($1 + 4 | 0) >> 0] = 0;
   }
   label$13 : {
    label$14 : {
     if (($8 | 0) == (34 | 0)) {
      break label$14
     }
     if (($8 | 0) == (125 | 0)) {
      break label$13
     }
     HEAP32[$2 >> 2] = 16;
     $4 = serde_json__de__Deserializer_R___peek_error__hf8794e102c1db2df($3 | 0, $2 | 0) | 0;
     HEAP32[$0 >> 2] = 1;
     HEAP32[($0 + 4 | 0) >> 2] = $4;
     break label$1;
    }
    serde__de__impls___impl_20serde__de__Deserialize_20for_20alloc__string__String___deserialize__ha8d5ac457296ae8f($2 | 0, $3 | 0);
    $4 = 1;
    label$15 : {
     label$16 : {
      if ((HEAP32[$2 >> 2] | 0 | 0) == (1 | 0)) {
       break label$16
      }
      $4 = $2 | 4 | 0;
      i64toi32_i32$0 = HEAP32[$4 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
      $131 = i64toi32_i32$0;
      i64toi32_i32$0 = $0;
      HEAP32[($0 + 4 | 0) >> 2] = $131;
      HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($4 + 8 | 0) >> 2] | 0;
      $4 = 0;
      break label$15;
     }
     HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($2 + 4 | 0) >> 2] | 0;
    }
    HEAP32[$0 >> 2] = $4;
    break label$1;
   }
   HEAP32[$2 >> 2] = 18;
   $4 = serde_json__de__Deserializer_R___peek_error__hf8794e102c1db2df($3 | 0, $2 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
   HEAP32[($0 + 4 | 0) >> 2] = $4;
  }
  global$0 = $2 + 16 | 0;
 }
 
 function core__fmt__Formatter__write_formatted_parts__h45709e2ae324d4ac($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $5 = 0, $4 = 0, $10 = 0, $2 = 0, $3 = 0, $7 = 0, $8 = 0, $6 = 0, $9 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     if (!$3) {
      break label$3
     }
     $4 = 1;
     if (FUNCTION_TABLE[HEAP32[((HEAP32[($0 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($0 + 24 | 0) >> 2] | 0, HEAP32[$1 >> 2] | 0, $3) | 0) {
      break label$2
     }
    }
    label$4 : {
     $4 = HEAP32[($1 + 12 | 0) >> 2] | 0;
     if (!$4) {
      break label$4
     }
     $5 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     $6 = $5 + Math_imul($4, 12) | 0;
     $7 = HEAP32[($0 + 28 | 0) >> 2] | 0;
     $3 = ($2 + 8 | 0) + -1 | 0;
     $8 = HEAP32[($0 + 24 | 0) >> 2] | 0;
     $9 = ($2 + 8 | 0) + 4 | 0;
     label$5 : while (1) {
      label$6 : {
       label$7 : {
        label$8 : {
         label$9 : {
          label$10 : {
           label$11 : {
            label$12 : {
             label$13 : {
              switch (HEAPU16[$5 >> 1] | 0 | 0) {
              default:
               $1 = HEAP32[($5 + 4 | 0) >> 2] | 0;
               if ($1 >>> 0 < 65 >>> 0) {
                break label$12
               }
               $0 = HEAP32[($7 + 12 | 0) >> 2] | 0;
               label$16 : while (1) {
                if (FUNCTION_TABLE[$0 | 0]($8, 1150496, 64) | 0) {
                 break label$7
                }
                $1 = $1 + -64 | 0;
                if ($1 >>> 0 > 64 >>> 0) {
                 continue label$16
                }
                break label$8;
               };
              case 1:
               $1 = HEAPU16[($5 + 2 | 0) >> 1] | 0;
               HEAP8[$9 >> 0] = 0;
               HEAP32[($2 + 8 | 0) >> 2] = 0;
               $0 = 1;
               label$17 : {
                switch (HEAPU16[$5 >> 1] | 0 | 0) {
                case 1:
                 label$20 : {
                  $0 = HEAPU16[($5 + 2 | 0) >> 1] | 0;
                  if ($0 >>> 0 < 1e3 >>> 0) {
                   break label$20
                  }
                  $10 = $0 >>> 0 < 1e4 >>> 0 ? 4 : 5;
                  break label$10;
                 }
                 $10 = 1;
                 if ($0 >>> 0 < 10 >>> 0) {
                  break label$10
                 }
                 $10 = $0 >>> 0 < 100 >>> 0 ? 2 : 3;
                 break label$10;
                case 2:
                 $0 = 2;
                 break;
                default:
                 break label$17;
                };
               }
               $10 = HEAP32[($5 + ($0 << 2 | 0) | 0) >> 2] | 0;
               if ($10 >>> 0 >= 6 >>> 0) {
                break label$11
               }
               if ($10) {
                break label$10
               }
               $10 = 0;
               break label$9;
              case 2:
               break label$13;
              };
             }
             if (FUNCTION_TABLE[HEAP32[($7 + 12 | 0) >> 2] | 0 | 0]($8, HEAP32[($5 + 4 | 0) >> 2] | 0, HEAP32[($5 + 8 | 0) >> 2] | 0) | 0) {
              break label$7
             }
             break label$6;
            }
            if ($1) {
             break label$8
            }
            break label$6;
           }
           core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($10 | 0, 5 | 0, 1150480 | 0);
           abort();
          }
          $0 = $10;
          label$21 : while (1) {
           $4 = (($1 & 65535 | 0) >>> 0) / (10 >>> 0) | 0;
           HEAP8[($3 + $0 | 0) >> 0] = $1 - Math_imul($4, 10) | 0 | 48 | 0;
           $1 = $4;
           $0 = $0 + -1 | 0;
           if ($0) {
            continue label$21
           }
           break label$21;
          };
         }
         if (FUNCTION_TABLE[HEAP32[($7 + 12 | 0) >> 2] | 0 | 0]($8, $2 + 8 | 0, $10) | 0) {
          break label$7
         }
         break label$6;
        }
        label$22 : {
         if ($1 >>> 0 > 63 >>> 0) {
          break label$22
         }
         if ((HEAP8[($1 + 1150496 | 0) >> 0] | 0 | 0) <= (-65 | 0)) {
          break label$1
         }
        }
        if (!(FUNCTION_TABLE[HEAP32[($7 + 12 | 0) >> 2] | 0 | 0]($8, 1150496, $1) | 0)) {
         break label$6
        }
       }
       $4 = 1;
       break label$2;
      }
      $5 = $5 + 12 | 0;
      if (($6 | 0) != ($5 | 0)) {
       continue label$5
      }
      break label$5;
     };
    }
    $4 = 0;
   }
   global$0 = $2 + 16 | 0;
   return $4 | 0;
  }
  core__str__slice_error_fail__h8a7d2e23b7bba52e(1150496 | 0, 64 | 0, 0 | 0, $1 | 0, 1150560 | 0);
  abort();
 }
 
 function cryptoxide__hashing__sha3__keccak_f__h42acb6232c3b5d0f($0) {
  $0 = $0 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $1 = 0, i64toi32_i32$3 = 0, $3 = 0, $4 = 0, $8$hi = 0, $5 = 0, $8 = 0, $6 = 0, $2 = 0, $7 = 0, $28 = 0, $28$hi = 0, $30 = 0, $30$hi = 0, $31 = 0, $31$hi = 0, $34 = 0, $34$hi = 0, $35 = 0, $35$hi = 0, $38 = 0, $38$hi = 0, $39 = 0, $39$hi = 0, $42 = 0, $42$hi = 0, $43 = 0, $55 = 0, $61 = 0, $61$hi = 0, $70 = 0, $70$hi = 0, $78 = 0, $78$hi = 0, $79 = 0, $9 = 0, $9$hi = 0, $102 = 0, $102$hi = 0, $103 = 0, $125 = 0, $125$hi = 0, $135 = 0, $135$hi = 0, $137 = 0, $137$hi = 0, $138 = 0, $153 = 0, $153$hi = 0, $157 = 0, $157$hi = 0, $158 = 0;
  $1 = global$0 - 240 | 0;
  global$0 = $1;
  $2 = 0;
  memset($1 + 200 | 0 | 0, 0 | 0, 40 | 0) | 0;
  $3 = memcpy($1 | 0, $0 | 0, 200 | 0) | 0;
  label$1 : while (1) {
   $4 = 0;
   label$2 : while (1) {
    $1 = $3 + $4 | 0;
    i64toi32_i32$2 = $1 + 40 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $28 = i64toi32_i32$0;
    $28$hi = i64toi32_i32$1;
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $30 = i64toi32_i32$1;
    $30$hi = i64toi32_i32$0;
    i64toi32_i32$0 = $28$hi;
    i64toi32_i32$2 = $28;
    i64toi32_i32$1 = $30$hi;
    i64toi32_i32$3 = $30;
    i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
    $31 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
    $31$hi = i64toi32_i32$1;
    i64toi32_i32$0 = $1 + 80 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
    $34 = i64toi32_i32$1;
    $34$hi = i64toi32_i32$2;
    i64toi32_i32$2 = $31$hi;
    i64toi32_i32$0 = $31;
    i64toi32_i32$1 = $34$hi;
    i64toi32_i32$3 = $34;
    i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
    $35 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
    $35$hi = i64toi32_i32$1;
    i64toi32_i32$2 = $1 + 120 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $38 = i64toi32_i32$1;
    $38$hi = i64toi32_i32$0;
    i64toi32_i32$0 = $35$hi;
    i64toi32_i32$2 = $35;
    i64toi32_i32$1 = $38$hi;
    i64toi32_i32$3 = $38;
    i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
    $39 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
    $39$hi = i64toi32_i32$1;
    i64toi32_i32$0 = $1 + 160 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
    $42 = i64toi32_i32$1;
    $42$hi = i64toi32_i32$2;
    i64toi32_i32$2 = $39$hi;
    i64toi32_i32$0 = $39;
    i64toi32_i32$1 = $42$hi;
    i64toi32_i32$3 = $42;
    i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
    $43 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
    i64toi32_i32$0 = ($3 + 200 | 0) + $4 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $43;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    $4 = $4 + 8 | 0;
    if (($4 | 0) != (40 | 0)) {
     continue label$2
    }
    break label$2;
   };
   $5 = 0;
   $6 = $3;
   label$3 : while (1) {
    $1 = $5;
    $5 = $1 + 1 | 0;
    i64toi32_i32$2 = ($3 + 200 | 0) + ((HEAP32[(($5 << 2 | 0) + 1136360 | 0) >> 2] | 0) << 3 | 0) | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $55 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    i64toi32_i32$1 = __wasm_rotl_i64($55 | 0, i64toi32_i32$0 | 0, 1 | 0, i64toi32_i32$1 | 0) | 0;
    i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
    $61 = i64toi32_i32$1;
    $61$hi = i64toi32_i32$0;
    i64toi32_i32$2 = ($3 + 200 | 0) + ((HEAP32[(($1 << 2 | 0) + 1136376 | 0) >> 2] | 0) << 3 | 0) | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $70 = i64toi32_i32$0;
    $70$hi = i64toi32_i32$1;
    i64toi32_i32$1 = $61$hi;
    i64toi32_i32$2 = $61;
    i64toi32_i32$0 = $70$hi;
    i64toi32_i32$3 = $70;
    i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
    $8 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
    $8$hi = i64toi32_i32$0;
    $1 = 0;
    label$4 : while (1) {
     $4 = $6 + $1 | 0;
     i64toi32_i32$0 = $8$hi;
     i64toi32_i32$1 = $4;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $78 = i64toi32_i32$0;
     $78$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $8$hi;
     i64toi32_i32$1 = $8;
     i64toi32_i32$0 = $78$hi;
     i64toi32_i32$3 = $78;
     i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
     $79 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
     i64toi32_i32$1 = $4;
     HEAP32[i64toi32_i32$1 >> 2] = $79;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     $1 = $1 + 40 | 0;
     if (($1 | 0) != (200 | 0)) {
      continue label$4
     }
     break label$4;
    };
    $6 = $6 + 8 | 0;
    if (($5 | 0) != (5 | 0)) {
     continue label$3
    }
    break label$3;
   };
   $1 = -96;
   i64toi32_i32$2 = $3;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
   $8 = i64toi32_i32$0;
   $8$hi = i64toi32_i32$1;
   label$5 : while (1) {
    $4 = $3 + ((HEAP32[($1 + 1136496 | 0) >> 2] | 0) << 3 | 0) | 0;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $9 = i64toi32_i32$1;
    $9$hi = i64toi32_i32$0;
    i64toi32_i32$0 = $8$hi;
    i64toi32_i32$2 = $1 + 1136592 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = 0;
    $102 = i64toi32_i32$0;
    $102$hi = i64toi32_i32$1;
    i64toi32_i32$1 = $8$hi;
    i64toi32_i32$0 = $102$hi;
    i64toi32_i32$0 = __wasm_rotl_i64($8 | 0, i64toi32_i32$1 | 0, $102 | 0, i64toi32_i32$0 | 0) | 0;
    i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
    $103 = i64toi32_i32$0;
    i64toi32_i32$0 = $4;
    HEAP32[i64toi32_i32$0 >> 2] = $103;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $9$hi;
    $8 = $9;
    $8$hi = i64toi32_i32$1;
    $1 = $1 + 4 | 0;
    if ($1) {
     continue label$5
    }
    break label$5;
   };
   $5 = 0;
   $7 = $3;
   label$6 : while (1) {
    memcpy($3 + 200 | 0 | 0, $3 + Math_imul($5, 40) | 0 | 0, 40 | 0) | 0;
    $5 = $5 + 1 | 0;
    $1 = 8;
    $4 = $3 + 200 | 0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 208 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 212 | 0) >> 2] | 0;
    $8 = i64toi32_i32$1;
    $8$hi = i64toi32_i32$0;
    $6 = $7;
    label$7 : while (1) {
     i64toi32_i32$0 = $8$hi;
     i64toi32_i32$2 = $8;
     i64toi32_i32$1 = -1;
     i64toi32_i32$3 = -1;
     i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
     $125 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $125$hi = i64toi32_i32$1;
     i64toi32_i32$0 = ($3 + 200 | 0) + ((HEAP32[($1 + 1136360 | 0) >> 2] | 0) << 3 | 0) | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $8 = i64toi32_i32$1;
     $8$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $125$hi;
     i64toi32_i32$0 = $125;
     i64toi32_i32$1 = $8$hi;
     i64toi32_i32$3 = $8;
     i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
     $135 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
     $135$hi = i64toi32_i32$1;
     i64toi32_i32$2 = $4;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $137 = i64toi32_i32$1;
     $137$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $135$hi;
     i64toi32_i32$2 = $135;
     i64toi32_i32$1 = $137$hi;
     i64toi32_i32$3 = $137;
     i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
     $138 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     i64toi32_i32$2 = $6;
     HEAP32[i64toi32_i32$2 >> 2] = $138;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     $4 = $4 + 8 | 0;
     $6 = i64toi32_i32$2 + 8 | 0;
     $1 = $1 + 4 | 0;
     if (($1 | 0) != (28 | 0)) {
      continue label$7
     }
     break label$7;
    };
    $7 = $7 + 40 | 0;
    if (($5 | 0) != (5 | 0)) {
     continue label$6
    }
    break label$6;
   };
   i64toi32_i32$0 = $3;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $153 = i64toi32_i32$1;
   $153$hi = i64toi32_i32$2;
   i64toi32_i32$0 = ($2 << 3 | 0) + 1136592 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $157 = i64toi32_i32$2;
   $157$hi = i64toi32_i32$1;
   i64toi32_i32$1 = $153$hi;
   i64toi32_i32$0 = $153;
   i64toi32_i32$2 = $157$hi;
   i64toi32_i32$3 = $157;
   i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
   $158 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
   i64toi32_i32$0 = $3;
   HEAP32[i64toi32_i32$0 >> 2] = $158;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   $2 = $2 + 1 | 0;
   if (($2 | 0) != (24 | 0)) {
    continue label$1
   }
   break label$1;
  };
  cryptoxide__cryptoutil__write_u64v_le__h74de04db912254e4($0 | 0, 200 | 0, $3 | 0, 25 | 0);
  global$0 = $3 + 240 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_recursing__h8f240b47fb2e4ef5($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $8 = 0, $5 = 0, $6 = 0, $7 = 0, $22 = 0, $46 = 0, $9 = 0, $10 = 0, $116 = 0;
  $4 = global$0 - 336 | 0;
  global$0 = $4;
  HEAP32[(($4 + 240 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $22 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[($4 + 240 | 0) >> 2] = $22;
  HEAP32[($4 + 244 | 0) >> 2] = i64toi32_i32$1;
  memcpy($4 + 288 | 0 | 0, $2 | 0, 48 | 0) | 0;
  $3 = memcpy($4 | 0, $3 | 0, 48 | 0) | 0;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert__hcdc4e5bf5bce6141($3 + 96 | 0 | 0, $3 + 240 | 0 | 0, $3 + 288 | 0 | 0, $3 | 0);
  $5 = HEAP32[($3 + 216 | 0) >> 2] | 0;
  label$1 : {
   label$2 : {
    if ((HEAP32[($3 + 96 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    HEAP32[($0 + 120 | 0) >> 2] = $5;
    i64toi32_i32$1 = HEAP32[($3 + 100 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($3 + 104 | 0) >> 2] | 0;
    $46 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[($0 + 4 | 0) >> 2] = $46;
    HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[$0 >> 2] = 0;
    HEAP32[($0 + 12 | 0) >> 2] = HEAP32[(($3 + 96 | 0) + 12 | 0) >> 2] | 0;
    break label$1;
   }
   $2 = HEAP32[(($3 + 96 | 0) + 116 | 0) >> 2] | 0;
   $6 = HEAP32[(($3 + 96 | 0) + 112 | 0) >> 2] | 0;
   $7 = HEAP32[(($3 + 96 | 0) + 104 | 0) >> 2] | 0;
   $1 = HEAP32[(($3 + 96 | 0) + 108 | 0) >> 2] | 0;
   $4 = memcpy($3 | 0, ($3 + 96 | 0) + 8 | 0 | 0, 96 | 0) | 0;
   label$3 : {
    $8 = HEAP32[($1 + 1056 | 0) >> 2] | 0;
    if (!$8) {
     break label$3
    }
    $9 = $4 + 104 | 0;
    $10 = $4 + 48 | 0;
    label$4 : while (1) {
     HEAP32[($4 + 232 | 0) >> 2] = HEAPU16[($1 + 1060 | 0) >> 1] | 0;
     HEAP32[($4 + 228 | 0) >> 2] = $8;
     HEAP32[($4 + 224 | 0) >> 2] = $7 + 1 | 0;
     memcpy($4 + 240 | 0 | 0, $4 | 0, 48 | 0) | 0;
     memcpy($4 + 288 | 0 | 0, $10 | 0, 48 | 0) | 0;
     alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert__h17bb893a58beb336($4 + 96 | 0 | 0, $4 + 224 | 0 | 0, $4 + 240 | 0 | 0, $4 + 288 | 0 | 0, $6 | 0, $2 | 0);
     label$5 : {
      if ((HEAP32[($4 + 96 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$5
      }
      HEAP32[($0 + 120 | 0) >> 2] = $5;
      i64toi32_i32$0 = HEAP32[($4 + 100 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($4 + 104 | 0) >> 2] | 0;
      $116 = i64toi32_i32$0;
      i64toi32_i32$0 = $0;
      HEAP32[($0 + 4 | 0) >> 2] = $116;
      HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[$0 >> 2] = 0;
      HEAP32[($0 + 12 | 0) >> 2] = HEAP32[(($4 + 96 | 0) + 12 | 0) >> 2] | 0;
      break label$1;
     }
     $2 = HEAP32[($4 + 212 | 0) >> 2] | 0;
     $6 = HEAP32[($4 + 208 | 0) >> 2] | 0;
     $7 = HEAP32[($4 + 200 | 0) >> 2] | 0;
     $1 = HEAP32[($4 + 204 | 0) >> 2] | 0;
     memcpy($4 | 0, $9 | 0, 96 | 0) | 0;
     $8 = HEAP32[($1 + 1056 | 0) >> 2] | 0;
     if ($8) {
      continue label$4
     }
     break label$4;
    };
   }
   memcpy(($4 + 96 | 0) + 4 | 0 | 0, $4 | 0, 96 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
   memcpy($0 + 4 | 0 | 0, $4 + 96 | 0 | 0, 100 | 0) | 0;
   HEAP32[($0 + 120 | 0) >> 2] = $5;
   HEAP32[($0 + 116 | 0) >> 2] = $2;
   HEAP32[($0 + 112 | 0) >> 2] = $6;
   HEAP32[($0 + 108 | 0) >> 2] = $1;
   HEAP32[($0 + 104 | 0) >> 2] = $7;
  }
  global$0 = $3 + 336 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert__h43316994191d56a4($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, $5 = 0, i64toi32_i32$1 = 0, $7 = 0, $4 = 0, $6 = 0, $9 = 0, $8 = 0, $10 = 0, $60 = 0, $93 = 0, $106 = 0, $130 = 0, $163 = 0;
  $3 = global$0 - 32 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $5 = HEAPU16[($4 + 138 | 0) >> 1] | 0;
    if ($5 >>> 0 < 11 >>> 0) {
     break label$2
    }
    alloc__collections__btree__node__splitpoint__h8424344594b4deb1($3 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
    $6 = ($3 + 16 | 0) + 8 | 0;
    $7 = HEAP32[$6 >> 2] | 0;
    $5 = HEAP32[($3 + 20 | 0) >> 2] | 0;
    $8 = HEAP32[$1 >> 2] | 0;
    HEAP32[($3 + 24 | 0) >> 2] = HEAP32[($3 + 16 | 0) >> 2] | 0;
    HEAP32[($3 + 16 | 0) >> 2] = $8;
    HEAP32[($3 + 20 | 0) >> 2] = $4;
    $1 = alloc__boxed__Box_T_2cA___new_uninit_in__h3d7406b043db0321() | 0;
    HEAP16[($1 + 138 | 0) >> 1] = 0;
    HEAP32[$1 >> 2] = 0;
    alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__hfcd0ac642c531a4c($3 | 0, $3 + 16 | 0 | 0, $1 | 0);
    $5 = ($5 | 0) == (1 | 0) ? $1 : $4;
    $9 = HEAPU16[($5 + 138 | 0) >> 1] | 0;
    HEAP32[$6 >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
    $60 = i64toi32_i32$0;
    i64toi32_i32$0 = $3;
    HEAP32[($3 + 16 | 0) >> 2] = $60;
    HEAP32[($3 + 20 | 0) >> 2] = i64toi32_i32$1;
    label$3 : {
     $2 = $7 + 1 | 0;
     if ($2 >>> 0 > $9 >>> 0) {
      break label$3
     }
     $10 = $5 + 4 | 0;
     memmove($10 + Math_imul($2, 12) | 0 | 0, $10 + Math_imul($7, 12) | 0 | 0, Math_imul($9 - $7 | 0, 12) | 0) | 0;
    }
    $2 = $5 + Math_imul($7, 12) | 0;
    HEAP32[($2 + 12 | 0) >> 2] = HEAP32[$6 >> 2] | 0;
    $2 = $2 + 4 | 0;
    i64toi32_i32$1 = HEAP32[($3 + 16 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($3 + 20 | 0) >> 2] | 0;
    $93 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[$2 >> 2] = $93;
    HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($0 + 8 | 0) >> 2] = $4;
    HEAP32[($0 + 4 | 0) >> 2] = $8;
    HEAP32[$0 >> 2] = 1;
    HEAP16[($5 + 138 | 0) >> 1] = $9 + 1 | 0;
    i64toi32_i32$0 = HEAP32[$3 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($3 + 4 | 0) >> 2] | 0;
    $106 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 12 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $106;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($0 + 20 | 0) >> 2] = HEAP32[($3 + 8 | 0) >> 2] | 0;
    HEAP32[($0 + 32 | 0) >> 2] = $2;
    HEAP32[($0 + 28 | 0) >> 2] = $1;
    HEAP32[($0 + 24 | 0) >> 2] = 0;
    break label$1;
   }
   $7 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   $9 = ($3 + 16 | 0) + 8 | 0;
   HEAP32[$9 >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $130 = i64toi32_i32$1;
   i64toi32_i32$1 = $3;
   HEAP32[($3 + 16 | 0) >> 2] = $130;
   HEAP32[($3 + 20 | 0) >> 2] = i64toi32_i32$0;
   label$4 : {
    $2 = $7 + 1 | 0;
    if ($2 >>> 0 > $5 >>> 0) {
     break label$4
    }
    $6 = $4 + 4 | 0;
    memmove($6 + Math_imul($2, 12) | 0 | 0, $6 + Math_imul($7, 12) | 0 | 0, Math_imul($5 - $7 | 0, 12) | 0) | 0;
   }
   $2 = $4 + Math_imul($7, 12) | 0;
   HEAP32[($2 + 12 | 0) >> 2] = HEAP32[$9 >> 2] | 0;
   $2 = $2 + 4 | 0;
   i64toi32_i32$0 = HEAP32[($3 + 16 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($3 + 20 | 0) >> 2] | 0;
   $163 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   HEAP32[$2 >> 2] = $163;
   HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP16[($4 + 138 | 0) >> 1] = $5 + 1 | 0;
   HEAP32[($0 + 32 | 0) >> 2] = $2;
   HEAP32[($0 + 12 | 0) >> 2] = $7;
   HEAP32[($0 + 8 | 0) >> 2] = $4;
   HEAP32[$0 >> 2] = 0;
   HEAP32[($0 + 4 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
  }
  global$0 = $3 + 32 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert__hb312e199a4732014($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, $7 = 0, i64toi32_i32$1 = 0, $4 = 0, $5 = 0, $6 = 0, $9 = 0, $8 = 0, $10 = 0, $60 = 0, $92 = 0, $105 = 0, $129 = 0, $161 = 0;
  $3 = global$0 - 32 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $5 = HEAPU16[($4 + 138 | 0) >> 1] | 0;
    if ($5 >>> 0 < 11 >>> 0) {
     break label$2
    }
    alloc__collections__btree__node__splitpoint__h8424344594b4deb1($3 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
    $6 = ($3 + 16 | 0) + 8 | 0;
    $5 = HEAP32[$6 >> 2] | 0;
    $7 = HEAP32[($3 + 20 | 0) >> 2] | 0;
    $8 = HEAP32[$1 >> 2] | 0;
    HEAP32[($3 + 24 | 0) >> 2] = HEAP32[($3 + 16 | 0) >> 2] | 0;
    HEAP32[($3 + 16 | 0) >> 2] = $8;
    HEAP32[($3 + 20 | 0) >> 2] = $4;
    $1 = alloc__boxed__Box_T_2cA___new_uninit_in__h04cd43b67903c159() | 0;
    HEAP16[($1 + 138 | 0) >> 1] = 0;
    HEAP32[$1 >> 2] = 0;
    alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__h7f55eb089e806801($3 | 0, $3 + 16 | 0 | 0, $1 | 0);
    $7 = ($7 | 0) == (1 | 0) ? $1 : $4;
    $9 = HEAPU16[($7 + 138 | 0) >> 1] | 0;
    HEAP32[$6 >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
    $60 = i64toi32_i32$0;
    i64toi32_i32$0 = $3;
    HEAP32[($3 + 16 | 0) >> 2] = $60;
    HEAP32[($3 + 20 | 0) >> 2] = i64toi32_i32$1;
    label$3 : {
     $2 = $5 + 1 | 0;
     if ($2 >>> 0 > $9 >>> 0) {
      break label$3
     }
     $10 = $7 + 4 | 0;
     memmove($10 + Math_imul($2, 12) | 0 | 0, $10 + Math_imul($5, 12) | 0 | 0, Math_imul($9 - $5 | 0, 12) | 0) | 0;
    }
    $2 = $7 + Math_imul($5, 12) | 0;
    HEAP32[($2 + 12 | 0) >> 2] = HEAP32[$6 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($3 + 16 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($3 + 20 | 0) >> 2] | 0;
    $92 = i64toi32_i32$1;
    i64toi32_i32$1 = $2 + 4 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $92;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($0 + 8 | 0) >> 2] = $4;
    HEAP32[($0 + 4 | 0) >> 2] = $8;
    HEAP32[$0 >> 2] = 1;
    HEAP16[($7 + 138 | 0) >> 1] = $9 + 1 | 0;
    i64toi32_i32$0 = HEAP32[$3 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($3 + 4 | 0) >> 2] | 0;
    $105 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 12 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $105;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($0 + 20 | 0) >> 2] = HEAP32[($3 + 8 | 0) >> 2] | 0;
    HEAP32[($0 + 32 | 0) >> 2] = $7;
    HEAP32[($0 + 28 | 0) >> 2] = $1;
    HEAP32[($0 + 24 | 0) >> 2] = 0;
    break label$1;
   }
   $7 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   $9 = ($3 + 16 | 0) + 8 | 0;
   HEAP32[$9 >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $129 = i64toi32_i32$1;
   i64toi32_i32$1 = $3;
   HEAP32[($3 + 16 | 0) >> 2] = $129;
   HEAP32[($3 + 20 | 0) >> 2] = i64toi32_i32$0;
   label$4 : {
    $2 = $7 + 1 | 0;
    if ($2 >>> 0 > $5 >>> 0) {
     break label$4
    }
    $6 = $4 + 4 | 0;
    memmove($6 + Math_imul($2, 12) | 0 | 0, $6 + Math_imul($7, 12) | 0 | 0, Math_imul($5 - $7 | 0, 12) | 0) | 0;
   }
   $2 = $4 + Math_imul($7, 12) | 0;
   HEAP32[($2 + 12 | 0) >> 2] = HEAP32[$9 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($3 + 16 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($3 + 20 | 0) >> 2] | 0;
   $161 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 4 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $161;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP16[($4 + 138 | 0) >> 1] = $5 + 1 | 0;
   HEAP32[($0 + 32 | 0) >> 2] = $4;
   HEAP32[($0 + 12 | 0) >> 2] = $7;
   HEAP32[($0 + 8 | 0) >> 2] = $4;
   HEAP32[$0 >> 2] = 0;
   HEAP32[($0 + 4 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
  }
  global$0 = $3 + 32 | 0;
 }
 
 function cryptoxide__pbkdf2__calculate_block__h6e8179bf702dfbe4($0, $1, $2, $3, $4, $5, $6, $7, $8) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  $5 = $5 | 0;
  $6 = $6 | 0;
  $7 = $7 | 0;
  $8 = $8 | 0;
  var $9 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $12 = 0, $12$hi = 0, $10 = 0, $11 = 0, $78 = 0, $81 = 0, $145 = 0, $148 = 0;
  $9 = global$0 - 64 | 0;
  global$0 = $9;
  $cryptoxide__hmac__Hmac_D__20as_20cryptoxide__mac__Mac___input__h8428084cca8543c2($0 | 0, $1 | 0, $2 | 0);
  HEAP32[($9 + 32 | 0) >> 2] = $4 << 24 | 0 | (($4 << 8 | 0) & 16711680 | 0) | 0 | (($4 >>> 8 | 0) & 65280 | 0 | ($4 >>> 24 | 0) | 0) | 0;
  $cryptoxide__hmac__Hmac_D__20as_20cryptoxide__mac__Mac___input__h8428084cca8543c2($0 | 0, $9 + 32 | 0 | 0, 4 | 0);
  $cryptoxide__hmac__Hmac_D__20as_20cryptoxide__mac__Mac___raw_result__hac4d52a01c11d996($0 | 0, $7 | 0, $8 | 0);
  $cryptoxide__hmac__Hmac_D__20as_20cryptoxide__mac__Mac___reset__hbf8667f113797205($0 | 0);
  label$1 : {
   if ($3 >>> 0 < 2 >>> 0) {
    break label$1
   }
   $cryptoxide__hmac__Hmac_D__20as_20cryptoxide__mac__Mac___input__h8428084cca8543c2($0 | 0, $7 | 0, $8 | 0);
   $cryptoxide__hmac__Hmac_D__20as_20cryptoxide__mac__Mac___raw_result__hac4d52a01c11d996($0 | 0, $5 | 0, $6 | 0);
   $cryptoxide__hmac__Hmac_D__20as_20cryptoxide__mac__Mac___reset__hbf8667f113797205($0 | 0);
   $10 = $7 + $8 | 0;
   $11 = $5 + $6 | 0;
   core__iter__adapters__zip__Zip_A_2cB___new__h5300198459615e1f($9 | 0, $7 | 0, $10 | 0, $5 | 0, $11 | 0);
   i64toi32_i32$2 = $9 + 16 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $12 = i64toi32_i32$0;
   $12$hi = i64toi32_i32$1;
   i64toi32_i32$0 = ($9 + 32 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $12;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[(($9 + 32 | 0) + 24 | 0) >> 2] = HEAP32[($9 + 24 | 0) >> 2] | 0;
   i64toi32_i32$2 = $9 + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $78 = i64toi32_i32$1;
   i64toi32_i32$1 = ($9 + 32 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $78;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $9;
   i64toi32_i32$0 = HEAP32[$9 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($9 + 4 | 0) >> 2] | 0;
   $81 = i64toi32_i32$0;
   i64toi32_i32$0 = $9;
   HEAP32[($9 + 32 | 0) >> 2] = $81;
   HEAP32[($9 + 36 | 0) >> 2] = i64toi32_i32$1;
   label$2 : {
    i64toi32_i32$1 = $12$hi;
    $4 = $12;
    if ($4 >>> 0 >= (HEAP32[($9 + 52 | 0) >> 2] | 0) >>> 0) {
     break label$2
    }
    $1 = $9 + 40 | 0;
    label$3 : while (1) {
     HEAP32[($9 + 48 | 0) >> 2] = $4 + 1 | 0;
     $8 = $core__slice__iter__IterMut_T__20as_20core__iter__traits__iterator__Iterator_____iterator_get_unchecked__h7ac01905d3a1b957($9 + 32 | 0 | 0, $4 | 0) | 0;
     $4 = $core__slice__iter__Iter_T__20as_20core__iter__traits__iterator__Iterator_____iterator_get_unchecked__h2e2d52c25f8395d6($1 | 0, $4 | 0) | 0;
     HEAP8[$8 >> 0] = (HEAPU8[$8 >> 0] | 0) ^ (HEAPU8[$4 >> 0] | 0) | 0;
     $4 = HEAP32[($9 + 48 | 0) >> 2] | 0;
     if ($4 >>> 0 < (HEAP32[($9 + 52 | 0) >> 2] | 0) >>> 0) {
      continue label$3
     }
     break label$3;
    };
   }
   if ($3 >>> 0 < 3 >>> 0) {
    break label$1
   }
   $1 = ($9 + 32 | 0) + 8 | 0;
   $2 = 2;
   label$4 : while (1) {
    $cryptoxide__hmac__Hmac_D__20as_20cryptoxide__mac__Mac___input__h8428084cca8543c2($0 | 0, $5 | 0, $6 | 0);
    $cryptoxide__hmac__Hmac_D__20as_20cryptoxide__mac__Mac___raw_result__hac4d52a01c11d996($0 | 0, $5 | 0, $6 | 0);
    $cryptoxide__hmac__Hmac_D__20as_20cryptoxide__mac__Mac___reset__hbf8667f113797205($0 | 0);
    core__iter__adapters__zip__Zip_A_2cB___new__h5300198459615e1f($9 | 0, $7 | 0, $10 | 0, $5 | 0, $11 | 0);
    i64toi32_i32$2 = $9 + 16 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $12 = i64toi32_i32$1;
    $12$hi = i64toi32_i32$0;
    i64toi32_i32$1 = ($9 + 32 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $12;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[(($9 + 32 | 0) + 24 | 0) >> 2] = HEAP32[($9 + 24 | 0) >> 2] | 0;
    i64toi32_i32$2 = $9 + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $145 = i64toi32_i32$0;
    i64toi32_i32$0 = $1;
    HEAP32[i64toi32_i32$0 >> 2] = $145;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $9;
    i64toi32_i32$1 = HEAP32[$9 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($9 + 4 | 0) >> 2] | 0;
    $148 = i64toi32_i32$1;
    i64toi32_i32$1 = $9;
    HEAP32[($9 + 32 | 0) >> 2] = $148;
    HEAP32[($9 + 36 | 0) >> 2] = i64toi32_i32$0;
    $2 = $2 + 1 | 0;
    label$5 : {
     i64toi32_i32$0 = $12$hi;
     $4 = $12;
     if ($4 >>> 0 >= (HEAP32[($9 + 52 | 0) >> 2] | 0) >>> 0) {
      break label$5
     }
     label$6 : while (1) {
      HEAP32[($9 + 48 | 0) >> 2] = $4 + 1 | 0;
      $8 = $core__slice__iter__IterMut_T__20as_20core__iter__traits__iterator__Iterator_____iterator_get_unchecked__h7ac01905d3a1b957($9 + 32 | 0 | 0, $4 | 0) | 0;
      $4 = $core__slice__iter__Iter_T__20as_20core__iter__traits__iterator__Iterator_____iterator_get_unchecked__h2e2d52c25f8395d6($1 | 0, $4 | 0) | 0;
      HEAP8[$8 >> 0] = (HEAPU8[$8 >> 0] | 0) ^ (HEAPU8[$4 >> 0] | 0) | 0;
      $4 = HEAP32[($9 + 48 | 0) >> 2] | 0;
      if ($4 >>> 0 < (HEAP32[($9 + 52 | 0) >> 2] | 0) >>> 0) {
       continue label$6
      }
      break label$6;
     };
    }
    if (($2 | 0) != ($3 | 0)) {
     continue label$4
    }
    break label$4;
   };
  }
  global$0 = $9 + 64 | 0;
 }
 
 function cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__add_native_script_input__h3e7dddcfb342ebab($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $22 = 0, $23 = 0, $24 = 0, $26 = 0, $27 = 0, $28 = 0, $25 = 0, $31 = 0, $34 = 0, $48 = 0, $54 = 0, $58 = 0, $96 = 0, $102 = 0, $108 = 0, $115 = 0, $122 = 0, $129 = 0, $135 = 0, $138 = 0;
  $4 = global$0 - 368 | 0;
  global$0 = $4;
  cardano_serialization_lib__NativeScript__hash__hb812a54d2c7bdca2($4 | 0, $1 | 0);
  cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__add_script_input__ha8e1111a100bff34($0 | 0, $4 | 0, $2 | 0, $3 | 0);
  HEAP32[(($4 + 184 | 0) + 24 | 0) >> 2] = HEAP32[($4 + 24 | 0) >> 2] | 0;
  i64toi32_i32$2 = $4 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $25 = i64toi32_i32$0;
  i64toi32_i32$0 = ($4 + 184 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $25;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $4 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $31 = i64toi32_i32$1;
  i64toi32_i32$1 = ($4 + 184 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $31;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[$4 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
  $34 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[($4 + 184 | 0) >> 2] = $34;
  HEAP32[($4 + 188 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    switch (HEAPU8[$1 >> 0] | 0 | 0) {
    default:
     $22 = $1 + 25 | 0;
     $23 = ($4 + 32 | 0) + 25 | 0;
     $24 = HEAPU8[$22 >> 0] | 0 | ((HEAPU8[($22 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($22 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($22 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[$23 >> 0] = $24;
     HEAP8[($23 + 1 | 0) >> 0] = $24 >>> 8 | 0;
     HEAP8[($23 + 2 | 0) >> 0] = $24 >>> 16 | 0;
     HEAP8[($23 + 3 | 0) >> 0] = $24 >>> 24 | 0;
     i64toi32_i32$2 = $1 + 17 | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $48 = i64toi32_i32$1;
     i64toi32_i32$1 = ($4 + 32 | 0) + 17 | 0;
     $26 = $48;
     HEAP8[i64toi32_i32$1 >> 0] = $26;
     HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $26 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $26 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $26 >>> 24 | 0;
     HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
     HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
     i64toi32_i32$2 = $1 + 9 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $54 = i64toi32_i32$0;
     i64toi32_i32$0 = ($4 + 32 | 0) + 9 | 0;
     $27 = $54;
     HEAP8[i64toi32_i32$0 >> 0] = $27;
     HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $27 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $27 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $27 >>> 24 | 0;
     HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
     HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
     HEAP8[($4 + 32 | 0) >> 0] = 0;
     i64toi32_i32$2 = $1;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $58 = i64toi32_i32$1;
     i64toi32_i32$1 = $4;
     $28 = $58;
     HEAP8[($4 + 33 | 0) >> 0] = $28;
     HEAP8[($4 + 34 | 0) >> 0] = $28 >>> 8 | 0;
     HEAP8[($4 + 35 | 0) >> 0] = $28 >>> 16 | 0;
     HEAP8[($4 + 36 | 0) >> 0] = $28 >>> 24 | 0;
     HEAP8[($4 + 37 | 0) >> 0] = i64toi32_i32$0;
     HEAP8[($4 + 38 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
     HEAP8[($4 + 39 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
     HEAP8[($4 + 40 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
     break label$1;
    case 1:
     alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($4 + 32 | 0 | 4 | 0 | 0, HEAP32[($1 + 4 | 0) >> 2] | 0 | 0, HEAP32[($1 + 12 | 0) >> 2] | 0 | 0);
     HEAP8[($4 + 32 | 0) >> 0] = 1;
     break label$1;
    case 2:
     alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($4 + 32 | 0 | 4 | 0 | 0, HEAP32[($1 + 4 | 0) >> 2] | 0 | 0, HEAP32[($1 + 12 | 0) >> 2] | 0 | 0);
     HEAP8[($4 + 32 | 0) >> 0] = 2;
     break label$1;
    case 3:
     $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($4 + 216 | 0 | 4 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0, HEAP32[($1 + 16 | 0) >> 2] | 0 | 0);
     i64toi32_i32$2 = ($4 + 216 | 0) + 8 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $96 = i64toi32_i32$0;
     i64toi32_i32$0 = $4 + 44 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $96;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($4 + 216 | 0) >> 2] = $2;
     HEAP8[($4 + 32 | 0) >> 0] = 3;
     i64toi32_i32$2 = $4;
     i64toi32_i32$1 = HEAP32[($4 + 216 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($4 + 220 | 0) >> 2] | 0;
     $102 = i64toi32_i32$1;
     i64toi32_i32$1 = $4;
     HEAP32[($4 + 36 | 0) >> 2] = $102;
     HEAP32[($4 + 40 | 0) >> 2] = i64toi32_i32$0;
     break label$1;
    case 4:
     i64toi32_i32$2 = $1 + 8 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $108 = i64toi32_i32$0;
     i64toi32_i32$0 = ($4 + 32 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $108;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     HEAP8[($4 + 32 | 0) >> 0] = 4;
     break label$1;
    case 5:
     break label$2;
    };
   }
   i64toi32_i32$2 = $1 + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $115 = i64toi32_i32$1;
   i64toi32_i32$1 = ($4 + 32 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $115;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP8[($4 + 32 | 0) >> 0] = 5;
  }
  i64toi32_i32$2 = ($4 + 32 | 0) + 24 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $122 = i64toi32_i32$0;
  i64toi32_i32$0 = $4 + 248 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $122;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = ($4 + 32 | 0) + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $129 = i64toi32_i32$1;
  i64toi32_i32$1 = ($4 + 216 | 0) + 24 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $129;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $4 + 40 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $135 = i64toi32_i32$0;
  i64toi32_i32$0 = ($4 + 216 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $135;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = HEAP32[($4 + 32 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($4 + 36 | 0) >> 2] | 0;
  $138 = i64toi32_i32$1;
  i64toi32_i32$1 = $4;
  HEAP32[($4 + 224 | 0) >> 2] = $138;
  HEAP32[($4 + 228 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$1 = $4;
  i64toi32_i32$0 = 0;
  HEAP32[($4 + 216 | 0) >> 2] = 0;
  HEAP32[($4 + 220 | 0) >> 2] = i64toi32_i32$0;
  linked_hash_map__LinkedHashMap_K_2cV_2cS___insert__h0e2ff8a07783b7ab($4 + 32 | 0 | 0, $0 | 0, $4 + 184 | 0 | 0, $4 + 216 | 0 | 0);
  core__ptr__drop_in_place_core__option__Option_core__option__Option_cardano_serialization_lib__tx_builder__tx_inputs_builder__ScriptWitnessType_____hc1cbaf0cb4e97823($4 + 32 | 0 | 0);
  global$0 = $4 + 368 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__MultiHostName___deserialize_as_embedded_group__h940a0d3c5a471c2f($0, $1, $2, $2$hi, $3, $3$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  var $4 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, $10 = 0, $10$hi = 0, $5 = 0, i64toi32_i32$4 = 0, $11 = 0, $11$hi = 0, $6 = 0, $7 = 0, $23 = 0, $8 = 0, $12 = 0, $12$hi = 0, $9 = 0;
  $4 = global$0 - 384 | 0;
  global$0 = $4;
  cbor_event__de__Deserializer_R___unsigned_integer__h1ed99c0b7fe7eea1($4 + 312 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[($4 + 320 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($4 + 324 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        i64toi32_i32$2 = $4;
        i64toi32_i32$1 = HEAP32[($4 + 312 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[($4 + 316 | 0) >> 2] | 0;
        i64toi32_i32$2 = i64toi32_i32$1;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
         break label$6
        }
        i64toi32_i32$2 = 0;
        $11 = 2;
        $11$hi = i64toi32_i32$2;
        i64toi32_i32$2 = $10$hi;
        i64toi32_i32$3 = $10;
        i64toi32_i32$0 = 0;
        i64toi32_i32$1 = 2;
        if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) | 0) {
         break label$4
        }
        $5 = 8;
        $6 = 1;
        $7 = 1;
        break label$5;
       }
       i64toi32_i32$3 = $10$hi;
       i64toi32_i32$1 = $10;
       i64toi32_i32$2 = 0;
       i64toi32_i32$0 = 32;
       i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = 0;
        $23 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$2 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
        $23 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
       }
       $8 = $23;
       i64toi32_i32$3 = $4 + 352 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $12 = i64toi32_i32$2;
       $12$hi = i64toi32_i32$1;
       i64toi32_i32$3 = $4 + 344 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $11 = i64toi32_i32$1;
       $11$hi = i64toi32_i32$2;
       $9 = HEAP32[($4 + 340 | 0) >> 2] | 0;
       $7 = HEAP32[($4 + 336 | 0) >> 2] | 0;
       i64toi32_i32$2 = $10$hi;
       $6 = $10;
       $5 = 2;
       i64toi32_i32$3 = $4 + 328 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $10 = i64toi32_i32$2;
       $10$hi = i64toi32_i32$1;
      }
      i64toi32_i32$1 = $12$hi;
      i64toi32_i32$2 = $4 + 352 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $12;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$1 = $11$hi;
      i64toi32_i32$2 = $4 + 344 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $11;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($4 + 340 | 0) >> 2] = $9;
      HEAP32[($4 + 336 | 0) >> 2] = $7;
      i64toi32_i32$1 = $10$hi;
      i64toi32_i32$2 = $4 + 328 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $10;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($4 + 324 | 0) >> 2] = $8;
      HEAP32[(($4 + 312 | 0) + 8 | 0) >> 2] = $6;
      HEAP32[($4 + 360 | 0) >> 2] = 0;
      HEAP8[($4 + 312 | 0) >> 0] = $5;
      cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($4 + 96 | 0 | 0, $4 + 312 | 0 | 0, 1050766 | 0, 7 | 0);
      $5 = HEAPU8[($4 + 96 | 0) >> 0] | 0;
      if (($5 | 0) != (19 | 0)) {
       break label$3
      }
     }
     cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__DNSRecordSRV___deserialize__h30f1f7710b983e30($4 + 312 | 0 | 0, $1 | 0);
     if ((HEAP32[($4 + 312 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$2
     }
     $1 = HEAP32[(($4 + 312 | 0) + 12 | 0) >> 2] | 0;
     HEAP32[($4 + 16 | 0) >> 2] = $1;
     i64toi32_i32$3 = $4;
     i64toi32_i32$1 = HEAP32[($4 + 316 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[($4 + 320 | 0) >> 2] | 0;
     $10 = i64toi32_i32$1;
     $10$hi = i64toi32_i32$2;
     i64toi32_i32$1 = $4;
     HEAP32[($4 + 8 | 0) >> 2] = $10;
     HEAP32[($4 + 12 | 0) >> 2] = i64toi32_i32$2;
     HEAP32[($0 + 12 | 0) >> 2] = $1;
     i64toi32_i32$1 = $0;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $10;
     HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$2;
     HEAP32[i64toi32_i32$1 >> 2] = 0;
     break label$1;
    }
    memcpy($4 + 240 | 0 | 0, $4 + 96 | 0 | 1 | 0 | 0, 63 | 0) | 0;
    HEAP8[($0 + 8 | 0) >> 0] = $5;
    memcpy($0 + 9 | 0 | 0, $4 + 240 | 0 | 0, 63 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    break label$1;
   }
   memcpy($4 + 312 | 0 | 0, memcpy($4 + 168 | 0 | 4 | 0 | 0, memcpy($4 + 240 | 0 | 4 | 0 | 0, ($4 + 312 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   $1 = ($4 + 96 | 0) + 8 | 0;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 312 | 0 | 0, 1051448 | 0, 8 | 0);
   memcpy($0 + 8 | 0 | 0, memcpy($4 + 24 | 0 | 4 | 0 | 0, $1 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $4 + 384 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__ScriptAll___deserialize_as_embedded_group__hbafeb78d3b233e94($0, $1, $2, $2$hi, $3, $3$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  var $4 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, $11 = 0, $11$hi = 0, $5 = 0, i64toi32_i32$4 = 0, $10 = 0, $10$hi = 0, $6 = 0, $7 = 0, $23 = 0, $8 = 0, $12 = 0, $12$hi = 0, $9 = 0;
  $4 = global$0 - 384 | 0;
  global$0 = $4;
  cbor_event__de__Deserializer_R___unsigned_integer__h1ed99c0b7fe7eea1($4 + 312 | 0 | 0, $1 | 0);
  i64toi32_i32$0 = 0;
  $10 = 1;
  $10$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[($4 + 320 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($4 + 324 | 0) >> 2] | 0;
  $11 = i64toi32_i32$0;
  $11$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        i64toi32_i32$2 = $4;
        i64toi32_i32$1 = HEAP32[($4 + 312 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[($4 + 316 | 0) >> 2] | 0;
        i64toi32_i32$2 = i64toi32_i32$1;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
         break label$6
        }
        i64toi32_i32$2 = $11$hi;
        i64toi32_i32$3 = $11;
        i64toi32_i32$0 = 0;
        i64toi32_i32$1 = 1;
        if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) | 0) {
         break label$4
        }
        $5 = 8;
        $6 = 1;
        $7 = 1;
        break label$5;
       }
       i64toi32_i32$3 = $11$hi;
       i64toi32_i32$1 = $11;
       i64toi32_i32$2 = 0;
       i64toi32_i32$0 = 32;
       i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = 0;
        $23 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$2 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
        $23 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
       }
       $8 = $23;
       i64toi32_i32$3 = $4 + 352 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $12 = i64toi32_i32$2;
       $12$hi = i64toi32_i32$1;
       i64toi32_i32$3 = $4 + 344 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $10 = i64toi32_i32$1;
       $10$hi = i64toi32_i32$2;
       $9 = HEAP32[($4 + 340 | 0) >> 2] | 0;
       $7 = HEAP32[($4 + 336 | 0) >> 2] | 0;
       i64toi32_i32$2 = $11$hi;
       $6 = $11;
       $5 = 2;
       i64toi32_i32$3 = $4 + 328 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $11 = i64toi32_i32$2;
       $11$hi = i64toi32_i32$1;
      }
      i64toi32_i32$1 = $12$hi;
      i64toi32_i32$2 = $4 + 352 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $12;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$1 = $10$hi;
      i64toi32_i32$2 = $4 + 344 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $10;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($4 + 340 | 0) >> 2] = $9;
      HEAP32[($4 + 336 | 0) >> 2] = $7;
      i64toi32_i32$1 = $11$hi;
      i64toi32_i32$2 = $4 + 328 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $11;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($4 + 324 | 0) >> 2] = $8;
      HEAP32[(($4 + 312 | 0) + 8 | 0) >> 2] = $6;
      HEAP32[($4 + 360 | 0) >> 2] = 0;
      HEAP8[($4 + 312 | 0) >> 0] = $5;
      cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($4 + 96 | 0 | 0, $4 + 312 | 0 | 0, 1050766 | 0, 7 | 0);
      $5 = HEAPU8[($4 + 96 | 0) >> 0] | 0;
      if (($5 | 0) != (19 | 0)) {
       break label$3
      }
     }
     cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__NativeScripts___deserialize__h5fb973a07bcdbe01($4 + 312 | 0 | 0, $1 | 0);
     if ((HEAP32[($4 + 312 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$2
     }
     $1 = HEAP32[(($4 + 312 | 0) + 12 | 0) >> 2] | 0;
     HEAP32[($4 + 16 | 0) >> 2] = $1;
     i64toi32_i32$3 = $4;
     i64toi32_i32$1 = HEAP32[($4 + 316 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[($4 + 320 | 0) >> 2] | 0;
     $11 = i64toi32_i32$1;
     $11$hi = i64toi32_i32$2;
     i64toi32_i32$1 = $4;
     HEAP32[($4 + 8 | 0) >> 2] = $11;
     HEAP32[($4 + 12 | 0) >> 2] = i64toi32_i32$2;
     HEAP32[($0 + 12 | 0) >> 2] = $1;
     i64toi32_i32$1 = $0;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $11;
     HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$2;
     HEAP32[i64toi32_i32$1 >> 2] = 0;
     break label$1;
    }
    memcpy($4 + 240 | 0 | 0, $4 + 96 | 0 | 1 | 0 | 0, 63 | 0) | 0;
    HEAP8[($0 + 8 | 0) >> 0] = $5;
    memcpy($0 + 9 | 0 | 0, $4 + 240 | 0 | 0, 63 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    break label$1;
   }
   memcpy($4 + 312 | 0 | 0, memcpy($4 + 168 | 0 | 4 | 0 | 0, memcpy($4 + 240 | 0 | 4 | 0 | 0, ($4 + 312 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   $1 = ($4 + 96 | 0) + 8 | 0;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 312 | 0 | 0, 1051677 | 0, 14 | 0);
   memcpy($0 + 8 | 0 | 0, memcpy($4 + 24 | 0 | 4 | 0 | 0, $1 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $4 + 384 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__ScriptAny___deserialize_as_embedded_group__h33b811880b7eeaff($0, $1, $2, $2$hi, $3, $3$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  var $4 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, $10 = 0, $10$hi = 0, $5 = 0, i64toi32_i32$4 = 0, $11 = 0, $11$hi = 0, $6 = 0, $7 = 0, $23 = 0, $8 = 0, $12 = 0, $12$hi = 0, $9 = 0;
  $4 = global$0 - 384 | 0;
  global$0 = $4;
  cbor_event__de__Deserializer_R___unsigned_integer__h1ed99c0b7fe7eea1($4 + 312 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[($4 + 320 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($4 + 324 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        i64toi32_i32$2 = $4;
        i64toi32_i32$1 = HEAP32[($4 + 312 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[($4 + 316 | 0) >> 2] | 0;
        i64toi32_i32$2 = i64toi32_i32$1;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
         break label$6
        }
        i64toi32_i32$2 = 0;
        $11 = 2;
        $11$hi = i64toi32_i32$2;
        i64toi32_i32$2 = $10$hi;
        i64toi32_i32$3 = $10;
        i64toi32_i32$0 = 0;
        i64toi32_i32$1 = 2;
        if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) | 0) {
         break label$4
        }
        $5 = 8;
        $6 = 1;
        $7 = 1;
        break label$5;
       }
       i64toi32_i32$3 = $10$hi;
       i64toi32_i32$1 = $10;
       i64toi32_i32$2 = 0;
       i64toi32_i32$0 = 32;
       i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = 0;
        $23 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$2 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
        $23 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
       }
       $8 = $23;
       i64toi32_i32$3 = $4 + 352 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $12 = i64toi32_i32$2;
       $12$hi = i64toi32_i32$1;
       i64toi32_i32$3 = $4 + 344 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $11 = i64toi32_i32$1;
       $11$hi = i64toi32_i32$2;
       $9 = HEAP32[($4 + 340 | 0) >> 2] | 0;
       $7 = HEAP32[($4 + 336 | 0) >> 2] | 0;
       i64toi32_i32$2 = $10$hi;
       $6 = $10;
       $5 = 2;
       i64toi32_i32$3 = $4 + 328 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $10 = i64toi32_i32$2;
       $10$hi = i64toi32_i32$1;
      }
      i64toi32_i32$1 = $12$hi;
      i64toi32_i32$2 = $4 + 352 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $12;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$1 = $11$hi;
      i64toi32_i32$2 = $4 + 344 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $11;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($4 + 340 | 0) >> 2] = $9;
      HEAP32[($4 + 336 | 0) >> 2] = $7;
      i64toi32_i32$1 = $10$hi;
      i64toi32_i32$2 = $4 + 328 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $10;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($4 + 324 | 0) >> 2] = $8;
      HEAP32[(($4 + 312 | 0) + 8 | 0) >> 2] = $6;
      HEAP32[($4 + 360 | 0) >> 2] = 0;
      HEAP8[($4 + 312 | 0) >> 0] = $5;
      cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($4 + 96 | 0 | 0, $4 + 312 | 0 | 0, 1050766 | 0, 7 | 0);
      $5 = HEAPU8[($4 + 96 | 0) >> 0] | 0;
      if (($5 | 0) != (19 | 0)) {
       break label$3
      }
     }
     cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__NativeScripts___deserialize__h5fb973a07bcdbe01($4 + 312 | 0 | 0, $1 | 0);
     if ((HEAP32[($4 + 312 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$2
     }
     $1 = HEAP32[(($4 + 312 | 0) + 12 | 0) >> 2] | 0;
     HEAP32[($4 + 16 | 0) >> 2] = $1;
     i64toi32_i32$3 = $4;
     i64toi32_i32$1 = HEAP32[($4 + 316 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[($4 + 320 | 0) >> 2] | 0;
     $10 = i64toi32_i32$1;
     $10$hi = i64toi32_i32$2;
     i64toi32_i32$1 = $4;
     HEAP32[($4 + 8 | 0) >> 2] = $10;
     HEAP32[($4 + 12 | 0) >> 2] = i64toi32_i32$2;
     HEAP32[($0 + 12 | 0) >> 2] = $1;
     i64toi32_i32$1 = $0;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $10;
     HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$2;
     HEAP32[i64toi32_i32$1 >> 2] = 0;
     break label$1;
    }
    memcpy($4 + 240 | 0 | 0, $4 + 96 | 0 | 1 | 0 | 0, 63 | 0) | 0;
    HEAP8[($0 + 8 | 0) >> 0] = $5;
    memcpy($0 + 9 | 0 | 0, $4 + 240 | 0 | 0, 63 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    break label$1;
   }
   memcpy($4 + 312 | 0 | 0, memcpy($4 + 168 | 0 | 4 | 0 | 0, memcpy($4 + 240 | 0 | 4 | 0 | 0, ($4 + 312 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   $1 = ($4 + 96 | 0) + 8 | 0;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 312 | 0 | 0, 1051677 | 0, 14 | 0);
   memcpy($0 + 8 | 0 | 0, memcpy($4 + 24 | 0 | 4 | 0 | 0, $1 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $4 + 384 | 0;
 }
 
 function $serde_json__de__SeqAccess_R__20as_20serde__de__SeqAccess___next_element_seed__h08dfb38d563d34fa($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $4 = 0, $2 = 0, $3 = 0, i64toi32_i32$0 = 0, $8 = 0, i64toi32_i32$1 = 0, $5 = 0, i64toi32_i32$2 = 0, $7 = 0, $9 = 0, $6 = 0, $131 = 0, $136 = 0, $141 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     $3 = HEAP32[$1 >> 2] | 0;
     $4 = HEAP32[($3 + 8 | 0) >> 2] | 0;
     $5 = HEAP32[($3 + 4 | 0) >> 2] | 0;
     if ($4 >>> 0 >= $5 >>> 0) {
      break label$3
     }
     $6 = HEAP32[$3 >> 2] | 0;
     $7 = 1;
     label$4 : {
      label$5 : while (1) {
       $8 = HEAPU8[($6 + $4 | 0) >> 0] | 0;
       $9 = $8 + -9 | 0;
       if ($9 >>> 0 > 23 >>> 0) {
        break label$4
       }
       if (!((1 << $9 | 0) & 8388627 | 0)) {
        break label$4
       }
       $4 = $4 + 1 | 0;
       HEAP32[($3 + 8 | 0) >> 2] = $4;
       $7 = $4 >>> 0 < $5 >>> 0;
       if (($5 | 0) != ($4 | 0)) {
        continue label$5
       }
       break label$5;
      };
      $8 = 0;
      $4 = $5;
     }
     if ($7 & 1 | 0) {
      break label$2
     }
    }
    HEAP32[$2 >> 2] = 2;
    $4 = serde_json__de__Deserializer_R___peek_error__hf8794e102c1db2df($3 | 0, $2 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    HEAP32[($0 + 4 | 0) >> 2] = $4;
    break label$1;
   }
   label$6 : {
    label$7 : {
     label$8 : {
      if (($8 | 0) == (44 | 0)) {
       break label$8
      }
      label$9 : {
       if (($8 | 0) == (93 | 0)) {
        break label$9
       }
       if (HEAPU8[($1 + 4 | 0) >> 0] | 0) {
        break label$7
       }
       HEAP32[$2 >> 2] = 7;
       $4 = serde_json__de__Deserializer_R___peek_error__hf8794e102c1db2df($3 | 0, $2 | 0) | 0;
       HEAP32[$0 >> 2] = 1;
       HEAP32[($0 + 4 | 0) >> 2] = $4;
       break label$1;
      }
      HEAP32[$0 >> 2] = 0;
      HEAP8[($0 + 8 | 0) >> 0] = 6;
      break label$1;
     }
     if (HEAPU8[($1 + 4 | 0) >> 0] | 0) {
      break label$7
     }
     $4 = $4 + 1 | 0;
     HEAP32[($3 + 8 | 0) >> 2] = $4;
     label$10 : {
      if ($4 >>> 0 >= $5 >>> 0) {
       break label$10
      }
      $7 = 1;
      label$11 : {
       label$12 : while (1) {
        $8 = HEAPU8[($6 + $4 | 0) >> 0] | 0;
        $9 = $8 + -9 | 0;
        if ($9 >>> 0 > 23 >>> 0) {
         break label$11
        }
        if (!((1 << $9 | 0) & 8388627 | 0)) {
         break label$11
        }
        $4 = $4 + 1 | 0;
        HEAP32[($3 + 8 | 0) >> 2] = $4;
        $7 = $4 >>> 0 < $5 >>> 0;
        if (($5 | 0) != ($4 | 0)) {
         continue label$12
        }
        break label$12;
       };
       $8 = 0;
      }
      if ($7 & 1 | 0) {
       break label$6
      }
     }
     HEAP32[$2 >> 2] = 5;
     $4 = serde_json__de__Deserializer_R___peek_error__hf8794e102c1db2df($3 | 0, $2 | 0) | 0;
     HEAP32[$0 >> 2] = 1;
     HEAP32[($0 + 4 | 0) >> 2] = $4;
     break label$1;
    }
    HEAP8[($1 + 4 | 0) >> 0] = 0;
   }
   label$13 : {
    if (($8 | 0) != (93 | 0)) {
     break label$13
    }
    HEAP32[$2 >> 2] = 18;
    $4 = serde_json__de__Deserializer_R___peek_error__hf8794e102c1db2df($3 | 0, $2 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    HEAP32[($0 + 4 | 0) >> 2] = $4;
    break label$1;
   }
   $_mut_20serde_json__de__Deserializer_R__20as_20serde__de__Deserializer___deserialize_any__hd0def79dc4acfc54($2 | 0, $3 | 0);
   label$14 : {
    if ((HEAP32[$2 >> 2] | 0 | 0) == (1 | 0)) {
     break label$14
    }
    HEAP32[$0 >> 2] = 0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $131 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $131;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $2 + 24 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $136 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 24 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $136;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $2 + 16 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $141 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $141;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    break label$1;
   }
   HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($2 + 4 | 0) >> 2] | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $2 + 32 | 0;
 }
 
 function num_bigint__biguint__convert__to_bitwise_digits_le__hadd655177eaec017($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $5 = 0, i64toi32_i32$3 = 0, i64toi32_i32$5 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, $4 = 0, $6 = 0, $8 = 0, $13$hi = 0, $3 = 0, $13 = 0, i64toi32_i32$6 = 0, $14$hi = 0, $52$hi = 0, $9 = 0, $33 = 0, $14 = 0, $15 = 0, $10 = 0, $11 = 0, $7 = 0, $35$hi = 0, $42$hi = 0, $45 = 0, $56 = 0, $56$hi = 0, $58 = 0, $59$hi = 0, $12 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  label$1 : {
   $4 = $2 & 255 | 0;
   if (!$4) {
    break label$1
   }
   $5 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   $6 = $5 + -1 | 0;
   $7 = (32 >>> 0) / ($4 >>> 0) | 0;
   $8 = HEAP32[$1 >> 2] | 0;
   i64toi32_i32$0 = 0;
   $13 = 0;
   $13$hi = i64toi32_i32$0;
   label$2 : {
    if (!$5) {
     break label$2
    }
    i64toi32_i32$0 = 0;
    i64toi32_i32$2 = $5;
    i64toi32_i32$1 = 0;
    i64toi32_i32$3 = 5;
    i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
     $33 = 0;
    } else {
     i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
     $33 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
    }
    $35$hi = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    $42$hi = i64toi32_i32$1;
    i64toi32_i32$1 = $35$hi;
    i64toi32_i32$0 = $33;
    i64toi32_i32$2 = $42$hi;
    i64toi32_i32$3 = Math_clz32(HEAP32[($8 + ($6 << 2 | 0) | 0) >> 2] | 0);
    i64toi32_i32$4 = i64toi32_i32$0 - i64toi32_i32$3 | 0;
    i64toi32_i32$6 = i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0;
    i64toi32_i32$5 = i64toi32_i32$6 + i64toi32_i32$2 | 0;
    i64toi32_i32$5 = i64toi32_i32$1 - i64toi32_i32$5 | 0;
    $13 = i64toi32_i32$4;
    $13$hi = i64toi32_i32$5;
   }
   $1 = 0;
   $45 = $3 + 8 | 0;
   i64toi32_i32$5 = $13$hi;
   i64toi32_i32$5 = 0;
   i64toi32_i32$1 = $2;
   i64toi32_i32$0 = 0;
   i64toi32_i32$3 = 255;
   i64toi32_i32$0 = i64toi32_i32$5 & i64toi32_i32$0 | 0;
   $14 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
   $14$hi = i64toi32_i32$0;
   i64toi32_i32$0 = $13$hi;
   i64toi32_i32$1 = $14$hi;
   i64toi32_i32$1 = __wasm_i64_udiv($13 | 0, i64toi32_i32$0 | 0, $14 | 0, i64toi32_i32$1 | 0) | 0;
   i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
   $15 = i64toi32_i32$1;
   $52$hi = i64toi32_i32$0;
   i64toi32_i32$0 = $13$hi;
   i64toi32_i32$0 = $52$hi;
   i64toi32_i32$0 = $14$hi;
   i64toi32_i32$0 = $52$hi;
   i64toi32_i32$1 = $14$hi;
   i64toi32_i32$1 = __wasm_i64_mul($15 | 0, i64toi32_i32$0 | 0, $14 | 0, i64toi32_i32$1 | 0) | 0;
   i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
   $56 = i64toi32_i32$1;
   $56$hi = i64toi32_i32$0;
   i64toi32_i32$0 = $13$hi;
   i64toi32_i32$5 = $13;
   i64toi32_i32$1 = $56$hi;
   i64toi32_i32$3 = $56;
   i64toi32_i32$2 = i64toi32_i32$5 - i64toi32_i32$3 | 0;
   i64toi32_i32$6 = i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0;
   i64toi32_i32$4 = i64toi32_i32$6 + i64toi32_i32$1 | 0;
   i64toi32_i32$4 = i64toi32_i32$0 - i64toi32_i32$4 | 0;
   i64toi32_i32$0 = i64toi32_i32$2;
   i64toi32_i32$5 = 0;
   i64toi32_i32$3 = 0;
   $58 = (i64toi32_i32$0 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$4 | 0) != (i64toi32_i32$5 | 0) | 0;
   i64toi32_i32$0 = 0;
   $59$hi = i64toi32_i32$0;
   i64toi32_i32$0 = $52$hi;
   i64toi32_i32$3 = $15;
   i64toi32_i32$4 = $59$hi;
   i64toi32_i32$5 = $58;
   i64toi32_i32$1 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
   i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
   if (i64toi32_i32$1 >>> 0 < i64toi32_i32$5 >>> 0) {
    i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
   }
   $13 = i64toi32_i32$1;
   $13$hi = i64toi32_i32$2;
   i64toi32_i32$0 = i64toi32_i32$1;
   i64toi32_i32$3 = 1;
   i64toi32_i32$5 = 0;
   alloc__raw_vec__RawVec_T_2cA___allocate_in__h7079698aee95f1e4($45 | 0, (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0 | 0) | 0 ? i64toi32_i32$0 : -1) | 0, 0 | 0);
   $9 = HEAP32[($3 + 8 | 0) >> 2] | 0;
   $4 = HEAP32[($3 + 12 | 0) >> 2] | 0;
   HEAP32[($0 + 8 | 0) >> 2] = 0;
   HEAP32[($0 + 4 | 0) >> 2] = $4;
   HEAP32[$0 >> 2] = $9;
   label$3 : {
    if (!$5) {
     break label$3
    }
    $4 = $2 & 31 | 0;
    $10 = (-1 << $4 | 0) ^ -1 | 0;
    $11 = $8 + ($6 << 2 | 0) | 0;
    label$4 : {
     if (!$6) {
      break label$4
     }
     $5 = $8 + 4 | 0;
     $1 = 0;
     $12 = ($2 & 255 | 0) >>> 0 > 32 >>> 0;
     label$5 : while (1) {
      $2 = $8;
      $8 = $5;
      label$6 : {
       if ($12) {
        break label$6
       }
       $5 = HEAP32[$2 >> 2] | 0;
       $2 = 0;
       label$7 : while (1) {
        $6 = $5 & $10 | 0;
        $2 = $2 + 1 | 0;
        label$8 : {
         if (($1 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
          break label$8
         }
         alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hcd3bd1a8d7e51f52($0 | 0, $1 | 0, 1 | 0);
         $9 = HEAP32[$0 >> 2] | 0;
         $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
        }
        HEAP8[($9 + $1 | 0) >> 0] = $6;
        $1 = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
        HEAP32[($0 + 8 | 0) >> 2] = $1;
        $5 = $5 >>> $4 | 0;
        if (($2 & 255 | 0) >>> 0 < $7 >>> 0) {
         continue label$7
        }
        break label$7;
       };
      }
      $5 = $8 + 4 | 0;
      if (($8 | 0) != ($11 | 0)) {
       continue label$5
      }
      break label$5;
     };
    }
    label$9 : {
     $5 = HEAP32[$11 >> 2] | 0;
     if (!$5) {
      break label$9
     }
     label$10 : while (1) {
      $6 = $5 & $10 | 0;
      label$11 : {
       label$12 : {
        if (($1 | 0) == (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
         break label$12
        }
        $2 = $1;
        break label$11;
       }
       alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hcd3bd1a8d7e51f52($0 | 0, $1 | 0, 1 | 0);
       $2 = HEAP32[($0 + 8 | 0) >> 2] | 0;
      }
      $1 = $2 + 1 | 0;
      HEAP32[($0 + 8 | 0) >> 2] = $1;
      HEAP8[((HEAP32[$0 >> 2] | 0) + $2 | 0) >> 0] = $6;
      $5 = $5 >>> $4 | 0;
      if ($5) {
       continue label$10
      }
      break label$10;
     };
    }
    global$0 = $3 + 16 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($6 | 0, $5 | 0, 1078348 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1077952 | 0, 25 | 0, 1078332 | 0);
  abort();
 }
 
 function bech32__Bech32Writer__new__h65a7836f3a5f87fe($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $7 = 0, $5 = 0, $10 = 0, $9 = 0, $8 = 0, $6 = 0, i64toi32_i32$1 = 0;
  $5 = global$0 - 16 | 0;
  global$0 = $5;
  HEAP32[($5 + 8 | 0) >> 2] = 1;
  HEAP32[($5 + 4 | 0) >> 2] = $4;
  HEAP32[$5 >> 2] = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     if (FUNCTION_TABLE[HEAP32[($4 + 12 | 0) >> 2] | 0 | 0]($3, $1, $2) | 0) {
      break label$3
     }
     if (!(FUNCTION_TABLE[HEAP32[($4 + 16 | 0) >> 2] | 0 | 0]($3, 49) | 0)) {
      break label$2
     }
    }
    HEAP32[$0 >> 2] = 0;
    $bech32__Bech32Writer_20as_20core__ops__drop__Drop___drop__ha90a511234f1ea05($5 | 0);
    break label$1;
   }
   $6 = $1 + $2 | 0;
   $7 = 1;
   label$4 : {
    if (!$2) {
     break label$4
    }
    $3 = $1 + 1 | 0;
    $7 = 1;
    $8 = $1;
    label$5 : while (1) {
     $4 = $8;
     $8 = $3;
     $9 = $7 >>> 25 | 0;
     $3 = 0;
     $10 = 1138480;
     $7 = ($7 << 5 | 0) & 1073741792 | 0 | ((HEAPU8[$4 >> 0] | 0) >>> 5 | 0) | 0;
     label$6 : while (1) {
      $4 = $3 + 1 | 0;
      label$7 : {
       if (!(($9 >>> ($3 & 255 | 0) | 0) & 1 | 0)) {
        break label$7
       }
       $7 = (HEAP32[$10 >> 2] | 0) ^ $7 | 0;
      }
      $10 = $10 + 4 | 0;
      $3 = $4;
      if (($3 | 0) != (5 | 0)) {
       continue label$6
      }
      break label$6;
     };
     $3 = $8 + 1 | 0;
     if (($8 | 0) != ($6 | 0)) {
      continue label$5
     }
     break label$5;
    };
   }
   $9 = $7 >>> 25 | 0;
   $7 = ($7 << 5 | 0) & 1073741792 | 0;
   $3 = 0;
   $10 = 1138480;
   label$8 : while (1) {
    $4 = $3 + 1 | 0;
    label$9 : {
     if (!(($9 >>> ($3 & 255 | 0) | 0) & 1 | 0)) {
      break label$9
     }
     $7 = (HEAP32[$10 >> 2] | 0) ^ $7 | 0;
    }
    $10 = $10 + 4 | 0;
    $3 = $4;
    if (($3 | 0) != (5 | 0)) {
     continue label$8
    }
    break label$8;
   };
   HEAP32[($5 + 8 | 0) >> 2] = $7;
   label$10 : {
    if (!$2) {
     break label$10
    }
    $3 = $1 + 1 | 0;
    label$11 : while (1) {
     $4 = $1;
     $1 = $3;
     $9 = $7 >>> 25 | 0;
     $3 = 0;
     $10 = 1138480;
     $7 = ($7 << 5 | 0) & 1073741792 | 0 | ((HEAPU8[$4 >> 0] | 0) & 31 | 0) | 0;
     label$12 : while (1) {
      $4 = $3 + 1 | 0;
      label$13 : {
       if (!(($9 >>> ($3 & 255 | 0) | 0) & 1 | 0)) {
        break label$13
       }
       $7 = (HEAP32[$10 >> 2] | 0) ^ $7 | 0;
      }
      $10 = $10 + 4 | 0;
      $3 = $4;
      if (($3 | 0) != (5 | 0)) {
       continue label$12
      }
      break label$12;
     };
     $3 = $1 + 1 | 0;
     if (($1 | 0) != ($6 | 0)) {
      continue label$11
     }
     break label$11;
    };
    HEAP32[($5 + 8 | 0) >> 2] = $7;
   }
   i64toi32_i32$1 = HEAP32[($5 + 4 | 0) >> 2] | 0;
   HEAP32[$0 >> 2] = HEAP32[$5 >> 2] | 0;
   HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($0 + 8 | 0) >> 2] = HEAP32[($5 + 8 | 0) >> 2] | 0;
  }
  global$0 = $5 + 16 | 0;
 }
 
 function $std__io__stdio__StdoutLock_20as_20std__io__Write___write_all__ha8d32e9dac01e4a2($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, $4 = 0, $7$hi = 0, $7 = 0, $5 = 0, $3 = 0, $6$hi = 0, $6 = 0, $134 = 0, $134$hi = 0, $136 = 0, $136$hi = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $0 = HEAP32[$0 >> 2] | 0;
      if (HEAP32[$0 >> 2] | 0) {
       break label$4
      }
      HEAP32[$0 >> 2] = -1;
      core__slice__memchr__memrchr__h18f8a2030f79e6f7($3 | 0, 10 | 0, $1 | 0, $2 | 0);
      label$5 : {
       label$6 : {
        label$7 : {
         if (HEAP32[$3 >> 2] | 0) {
          break label$7
         }
         label$8 : {
          label$9 : {
           $4 = HEAP32[($0 + 12 | 0) >> 2] | 0;
           if ($4) {
            break label$9
           }
           $4 = 0;
           break label$8;
          }
          if ((HEAPU8[(($4 + (HEAP32[($0 + 4 | 0) >> 2] | 0) | 0) + -1 | 0) >> 0] | 0 | 0) != (10 | 0)) {
           break label$8
          }
          $4 = 0;
          HEAP32[($0 + 12 | 0) >> 2] = 0;
          HEAP8[($0 + 16 | 0) >> 0] = 0;
         }
         if (((HEAP32[($0 + 8 | 0) >> 2] | 0) - $4 | 0) >>> 0 > $2 >>> 0) {
          break label$6
         }
         i64toi32_i32$0 = std__io__buffered__bufwriter__BufWriter_W___write_all_cold__h38ccb137a9134dc2($0 + 4 | 0 | 0, $1 | 0, $2 | 0) | 0;
         i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
         $6 = i64toi32_i32$0;
         $6$hi = i64toi32_i32$1;
         i64toi32_i32$2 = i64toi32_i32$0;
         i64toi32_i32$0 = 0;
         i64toi32_i32$3 = 255;
         i64toi32_i32$0 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
         $7 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
         $7$hi = i64toi32_i32$0;
         i64toi32_i32$0 = i64toi32_i32$1;
         i64toi32_i32$0 = i64toi32_i32$1;
         i64toi32_i32$1 = i64toi32_i32$2;
         i64toi32_i32$2 = -1;
         i64toi32_i32$3 = -256;
         i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
         $6 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
         $6$hi = i64toi32_i32$2;
         break label$5;
        }
        $4 = (HEAP32[($3 + 4 | 0) >> 2] | 0) + 1 | 0;
        if ($4 >>> 0 > $2 >>> 0) {
         break label$3
        }
        $5 = HEAP32[($0 + 12 | 0) >> 2] | 0;
        if (!$5) {
         break label$2
        }
        label$10 : {
         label$11 : {
          if (((HEAP32[($0 + 8 | 0) >> 2] | 0) - $5 | 0) >>> 0 <= $4 >>> 0) {
           break label$11
          }
          memcpy((HEAP32[($0 + 4 | 0) >> 2] | 0) + $5 | 0 | 0, $1 | 0, $4 | 0) | 0;
          $5 = $5 + $4 | 0;
          HEAP32[($0 + 12 | 0) >> 2] = $5;
          break label$10;
         }
         i64toi32_i32$2 = std__io__buffered__bufwriter__BufWriter_W___write_all_cold__h38ccb137a9134dc2($0 + 4 | 0 | 0, $1 | 0, $4 | 0) | 0;
         i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
         $7 = i64toi32_i32$2;
         $7$hi = i64toi32_i32$1;
         i64toi32_i32$0 = i64toi32_i32$2;
         i64toi32_i32$2 = 0;
         i64toi32_i32$3 = 255;
         i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
         i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
         i64toi32_i32$0 = 0;
         i64toi32_i32$3 = 4;
         if ((i64toi32_i32$1 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$0 | 0) | 0) {
          break label$1
         }
         $5 = HEAP32[($0 + 12 | 0) >> 2] | 0;
        }
        if (!$5) {
         break label$2
        }
        HEAP32[($0 + 12 | 0) >> 2] = 0;
        HEAP8[($0 + 16 | 0) >> 0] = 0;
        break label$2;
       }
       memcpy((HEAP32[($0 + 4 | 0) >> 2] | 0) + $4 | 0 | 0, $1 | 0, $2 | 0) | 0;
       HEAP32[($0 + 12 | 0) >> 2] = $4 + $2 | 0;
       i64toi32_i32$1 = 0;
       $7 = 4;
       $7$hi = i64toi32_i32$1;
       i64toi32_i32$1 = 0;
       $6 = 0;
       $6$hi = i64toi32_i32$1;
      }
      i64toi32_i32$1 = $7$hi;
      i64toi32_i32$1 = $6$hi;
      i64toi32_i32$1 = $7$hi;
      i64toi32_i32$3 = $7;
      i64toi32_i32$2 = $6$hi;
      i64toi32_i32$0 = $6;
      i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
      $7 = i64toi32_i32$3 | i64toi32_i32$0 | 0;
      $7$hi = i64toi32_i32$2;
      break label$1;
     }
     core__result__unwrap_failed__h27f43d993c3864a1(1142260 | 0, 16 | 0, $3 + 8 | 0 | 0, 1142504 | 0, 1143748 | 0);
     abort();
    }
    core__panicking__panic__h2fd385a887c8bf13(1142316 | 0, 35 | 0, 1142428 | 0);
    abort();
   }
   $1 = $1 + $4 | 0;
   label$12 : {
    $2 = $2 - $4 | 0;
    if ((HEAP32[($0 + 8 | 0) >> 2] | 0) >>> 0 > $2 >>> 0) {
     break label$12
    }
    i64toi32_i32$2 = std__io__buffered__bufwriter__BufWriter_W___write_all_cold__h38ccb137a9134dc2($0 + 4 | 0 | 0, $1 | 0, $2 | 0) | 0;
    i64toi32_i32$3 = i64toi32_i32$HIGH_BITS;
    $7 = i64toi32_i32$2;
    $7$hi = i64toi32_i32$3;
    i64toi32_i32$1 = i64toi32_i32$2;
    i64toi32_i32$2 = 0;
    i64toi32_i32$0 = 255;
    i64toi32_i32$2 = i64toi32_i32$3 & i64toi32_i32$2 | 0;
    $134 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
    $134$hi = i64toi32_i32$2;
    i64toi32_i32$2 = i64toi32_i32$3;
    i64toi32_i32$3 = i64toi32_i32$1;
    i64toi32_i32$1 = -1;
    i64toi32_i32$0 = -256;
    i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
    $136 = i64toi32_i32$3 & i64toi32_i32$0 | 0;
    $136$hi = i64toi32_i32$1;
    i64toi32_i32$1 = $134$hi;
    i64toi32_i32$2 = $134;
    i64toi32_i32$3 = $136$hi;
    i64toi32_i32$0 = $136;
    i64toi32_i32$3 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
    $7 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
    $7$hi = i64toi32_i32$3;
    break label$1;
   }
   memcpy(HEAP32[($0 + 4 | 0) >> 2] | 0 | 0, $1 | 0, $2 | 0) | 0;
   HEAP32[($0 + 12 | 0) >> 2] = $2;
   i64toi32_i32$3 = 0;
   i64toi32_i32$1 = 4;
   i64toi32_i32$2 = 0;
   i64toi32_i32$0 = 0;
   i64toi32_i32$2 = i64toi32_i32$3 | i64toi32_i32$2 | 0;
   $7 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
   $7$hi = i64toi32_i32$2;
  }
  HEAP32[$0 >> 2] = (HEAP32[$0 >> 2] | 0) + 1 | 0;
  global$0 = $3 + 16 | 0;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$1 = $7;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$2;
  return i64toi32_i32$1 | 0;
 }
 
 function alloc__collections__btree__remove___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__KV____remove_internal_kv__h16fc58c4c5b6474b($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, i64toi32_i32$2 = 0, $5 = 0, $6 = 0, $59 = 0, $62 = 0, $7 = 0, $7$hi = 0, $8 = 0, $8$hi = 0, $100 = 0, $9 = 0, $9$hi = 0, $144 = 0, $159 = 0;
  $3 = global$0 - 64 | 0;
  global$0 = $3;
  $4 = HEAP32[(((HEAP32[($1 + 4 | 0) >> 2] | 0) + ((HEAP32[($1 + 8 | 0) >> 2] | 0) << 2 | 0) | 0) + 232 | 0) >> 2] | 0;
  label$1 : {
   $1 = (HEAP32[$1 >> 2] | 0) + -1 | 0;
   if (!$1) {
    break label$1
   }
   label$2 : while (1) {
    $4 = HEAP32[(($4 + ((HEAPU16[($4 + 226 | 0) >> 1] | 0) << 2 | 0) | 0) + 232 | 0) >> 2] | 0;
    $1 = $1 + -1 | 0;
    if ($1) {
     continue label$2
    }
    break label$2;
   };
  }
  $1 = HEAPU16[($4 + 226 | 0) >> 1] | 0;
  HEAP32[($3 + 8 | 0) >> 2] = 0;
  HEAP32[($3 + 16 | 0) >> 2] = $1 ? $1 + -1 | 0 : 0;
  HEAP32[($3 + 12 | 0) >> 2] = $1 ? $4 : 0;
  alloc__collections__btree__remove___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__KV____remove_leaf_kv__h27b8b726dbbf8174($3 + 24 | 0 | 0, $3 + 8 | 0 | 0, $2 | 0);
  i64toi32_i32$2 = ($3 + 24 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $59 = i64toi32_i32$0;
  i64toi32_i32$0 = ($3 + 8 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $59;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[($3 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($3 + 28 | 0) >> 2] | 0;
  $62 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[($3 + 8 | 0) >> 2] = $62;
  HEAP32[($3 + 12 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[($3 + 40 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($3 + 44 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  $5 = HEAP32[($3 + 48 | 0) >> 2] | 0;
  label$3 : {
   label$4 : {
    $2 = HEAP32[($3 + 56 | 0) >> 2] | 0;
    $1 = HEAP32[($3 + 52 | 0) >> 2] | 0;
    if ($2 >>> 0 >= (HEAPU16[($1 + 226 | 0) >> 1] | 0) >>> 0) {
     break label$4
    }
    $4 = $1;
    break label$3;
   }
   label$5 : while (1) {
    label$6 : {
     $4 = HEAP32[($1 + 88 | 0) >> 2] | 0;
     if ($4) {
      break label$6
     }
     $4 = 0;
     break label$3;
    }
    $5 = $5 + 1 | 0;
    $2 = HEAPU16[($1 + 224 | 0) >> 1] | 0;
    $1 = $4;
    if ($2 >>> 0 >= (HEAPU16[($1 + 226 | 0) >> 1] | 0) >>> 0) {
     continue label$5
    }
    break label$5;
   };
  }
  $1 = $4 + Math_imul($2, 12) | 0;
  $6 = $1 + 92 | 0;
  i64toi32_i32$2 = $6;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$1;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
  $100 = i64toi32_i32$0;
  i64toi32_i32$0 = $6;
  HEAP32[i64toi32_i32$0 >> 2] = $100;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $1 = $1 + 100 | 0;
  $6 = HEAP32[$1 >> 2] | 0;
  HEAP32[$1 >> 2] = HEAP32[(($3 + 8 | 0) + 8 | 0) >> 2] | 0;
  HEAP32[(($3 + 24 | 0) + 8 | 0) >> 2] = $6;
  $1 = $4 + ($2 << 3 | 0) | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$1 = $1;
  HEAP32[$1 >> 2] = $7;
  HEAP32[($1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$1 = $3;
  HEAP32[($3 + 24 | 0) >> 2] = $8;
  HEAP32[($3 + 28 | 0) >> 2] = i64toi32_i32$0;
  label$7 : {
   label$8 : {
    if ($5) {
     break label$8
    }
    $1 = $2 + 1 | 0;
    break label$7;
   }
   $4 = HEAP32[((($2 << 2 | 0) + $4 | 0) + 236 | 0) >> 2] | 0;
   label$9 : {
    $1 = $5 + -1 | 0;
    if (!$1) {
     break label$9
    }
    label$10 : while (1) {
     $4 = HEAP32[($4 + 232 | 0) >> 2] | 0;
     $1 = $1 + -1 | 0;
     if ($1) {
      continue label$10
     }
     break label$10;
    };
   }
   $1 = 0;
  }
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[($3 + 24 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($3 + 28 | 0) >> 2] | 0;
  $144 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $144;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = 0;
  i64toi32_i32$1 = $9$hi;
  HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $9;
  HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] = $1;
  HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = $4;
  i64toi32_i32$2 = ($3 + 24 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $159 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $159;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $3 + 64 | 0;
 }
 
 function hashbrown__map__HashMap_K_2cV_2cS_2cA___insert__h719e57cb0b28913b($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $7 = 0, i64toi32_i32$2 = 0, $5 = 0, $6 = 0, $20 = 0, $10 = 0, $12 = 0, $12$hi = 0, $9 = 0, $8 = 0, $11 = 0, $140 = 0, $168 = 0, $171 = 0;
  $4 = global$0 - 96 | 0;
  global$0 = $4;
  i64toi32_i32$0 = hashbrown__map__make_insert_hash__h6e13c786bfd61db3($1 | 0, $2 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $12 = i64toi32_i32$0;
  $12$hi = i64toi32_i32$1;
  $5 = i64toi32_i32$0;
  $6 = (HEAP32[($1 + 16 | 0) >> 2] | 0) & i64toi32_i32$0 | 0;
  $20 = (HEAP32[($1 + 20 | 0) >> 2] | 0) + $6 | 0;
  $7 = HEAPU8[$20 >> 0] | 0 | ((HEAPU8[($20 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($20 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($20 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $8 = ($4 + 72 | 0) + 8 | 0;
  HEAP32[$8 >> 2] = 0;
  HEAP32[($4 + 84 | 0) >> 2] = $7;
  HEAP32[($4 + 76 | 0) >> 2] = $6;
  $6 = $1 + 16 | 0;
  HEAP32[($4 + 72 | 0) >> 2] = $6;
  $5 = i64toi32_i32$0 >>> 25 | 0;
  HEAP8[($4 + 92 | 0) >> 0] = $5;
  $7 = $7 ^ Math_imul($5, 16843009) | 0;
  HEAP32[($4 + 88 | 0) >> 2] = (($7 ^ -1 | 0) & ($7 + -16843009 | 0) | 0) & -2139062144 | 0;
  $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($4 + 48 | 0 | 0, $4 + 72 | 0 | 0);
  label$1 : {
   label$2 : {
    if (!(HEAP32[($4 + 48 | 0) >> 2] | 0)) {
     break label$2
    }
    $7 = (HEAP32[((HEAP32[($4 + 72 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) + Math_imul(0 - (HEAP32[($4 + 52 | 0) >> 2] | 0) | 0, 24) | 0;
    $5 = $T_20as_20core__borrow__Borrow_T____borrow__h9271299964c542f1($7 + -24 | 0 | 0) | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($4 + 40 | 0 | 0, $2 | 0);
    $9 = HEAP32[($4 + 44 | 0) >> 2] | 0;
    $10 = HEAP32[($4 + 40 | 0) >> 2] | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($4 + 32 | 0 | 0, $5 | 0);
    label$3 : {
     if (core__slice__cmp___impl_20core__cmp__PartialEq__5bB_5d__20for_20_5bA_5d___eq__hc3de93b036fcc30b($10 | 0, $9 | 0, HEAP32[($4 + 32 | 0) >> 2] | 0 | 0, HEAP32[($4 + 36 | 0) >> 2] | 0 | 0) | 0) {
      break label$3
     }
     label$4 : while (1) {
      $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($4 + 24 | 0 | 0, $4 + 72 | 0 | 0);
      if (!(HEAP32[($4 + 24 | 0) >> 2] | 0)) {
       break label$2
      }
      $10 = HEAP32[((HEAP32[($4 + 72 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0;
      $11 = 0 - (HEAP32[($4 + 28 | 0) >> 2] | 0) | 0;
      $7 = $T_20as_20core__borrow__Borrow_T____borrow__h9271299964c542f1(($10 + Math_imul($11, 24) | 0) + -24 | 0 | 0) | 0;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($4 + 16 | 0 | 0, $2 | 0);
      $5 = HEAP32[($4 + 20 | 0) >> 2] | 0;
      $9 = HEAP32[($4 + 16 | 0) >> 2] | 0;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($4 + 8 | 0 | 0, $7 | 0);
      if (!(core__slice__cmp___impl_20core__cmp__PartialEq__5bB_5d__20for_20_5bA_5d___eq__hc3de93b036fcc30b($9 | 0, $5 | 0, HEAP32[($4 + 8 | 0) >> 2] | 0 | 0, HEAP32[($4 + 12 | 0) >> 2] | 0 | 0) | 0)) {
       continue label$4
      }
      break label$4;
     };
     $7 = $10 + Math_imul($11, 24) | 0;
    }
    $1 = $7 + -12 | 0;
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $12 = i64toi32_i32$1;
    $12$hi = i64toi32_i32$0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $140 = i64toi32_i32$0;
    i64toi32_i32$0 = $1;
    HEAP32[i64toi32_i32$0 >> 2] = $140;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $12$hi;
    i64toi32_i32$0 = $0;
    HEAP32[i64toi32_i32$0 >> 2] = $12;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    $1 = $1 + 8 | 0;
    $7 = HEAP32[$1 >> 2] | 0;
    HEAP32[$1 >> 2] = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $7;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 | 0);
    break label$1;
   }
   HEAP32[$8 >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
   HEAP32[(($4 + 72 | 0) + 20 | 0) >> 2] = HEAP32[($3 + 8 | 0) >> 2] | 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $168 = i64toi32_i32$1;
   i64toi32_i32$1 = $4;
   HEAP32[($4 + 72 | 0) >> 2] = $168;
   HEAP32[($4 + 76 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $3;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $171 = i64toi32_i32$0;
   i64toi32_i32$0 = $4;
   HEAP32[($4 + 84 | 0) >> 2] = $171;
   HEAP32[($4 + 88 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $12$hi;
   hashbrown__raw__RawTable_T_2cA___insert__had6a9928cbe480f0($6 | 0, $12 | 0, i64toi32_i32$1 | 0, $4 + 72 | 0 | 0, $1 | 0) | 0;
   HEAP32[$0 >> 2] = 0;
  }
  global$0 = $4 + 96 | 0;
 }
 
 function num_bigint__biguint__convert__from_inexact_bitwise_digits_le__h6c419a1400584927($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $7 = 0, i64toi32_i32$5 = 0, $8 = 0, i64toi32_i32$3 = 0, $5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, $10 = 0, $10$hi = 0, $6 = 0, $25 = 0, $9 = 0, $15 = 0, $18$hi = 0, $20$hi = 0, $27 = 0, $23$hi = 0, $26 = 0, $27$hi = 0, $155 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  $5 = 0;
  $15 = $4 + 8 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 255;
  i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
  $18$hi = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  $20$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $18$hi;
  $27 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $20$hi;
  i64toi32_i32$2 = __wasm_i64_mul($27 | 0, i64toi32_i32$1 | 0, $2 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $10 = i64toi32_i32$2;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 5;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $25 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   $25 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
  }
  $23$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$1 = $10;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 31;
  i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 0;
  $26 = (i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$2 = 0;
  $27$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $23$hi;
  i64toi32_i32$3 = $25;
  i64toi32_i32$0 = $27$hi;
  i64toi32_i32$1 = $26;
  i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $10 = i64toi32_i32$4;
  $10$hi = i64toi32_i32$5;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$3 = 1;
  i64toi32_i32$1 = 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__hb0817f92bbb8999a($15 | 0, (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$1 >>> 0 | 0) | 0 ? i64toi32_i32$2 : -1) | 0, 0 | 0);
  HEAP32[($4 + 24 | 0) >> 2] = 0;
  HEAP32[($4 + 20 | 0) >> 2] = HEAP32[($4 + 12 | 0) >> 2] | 0;
  $6 = HEAP32[($4 + 8 | 0) >> 2] | 0;
  HEAP32[($4 + 16 | 0) >> 2] = $6;
  label$1 : {
   if (!$2) {
    break label$1
   }
   $7 = 0;
   $8 = 0;
   label$2 : while (1) {
    $9 = HEAPU8[$1 >> 0] | 0;
    $7 = $9 << ($8 & 31 | 0) | 0 | $7 | 0;
    label$3 : {
     $8 = $8 + $3 | 0;
     if (($8 & 255 | 0) >>> 0 < 32 >>> 0) {
      break label$3
     }
     label$4 : {
      if (($5 | 0) != (HEAP32[($4 + 20 | 0) >> 2] | 0 | 0)) {
       break label$4
      }
      alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h90c9768825cdae1b($4 + 16 | 0 | 0, $5 | 0, 1 | 0);
      $6 = HEAP32[($4 + 16 | 0) >> 2] | 0;
      $5 = HEAP32[($4 + 24 | 0) >> 2] | 0;
     }
     HEAP32[($6 + ($5 << 2 | 0) | 0) >> 2] = $7;
     $5 = (HEAP32[($4 + 24 | 0) >> 2] | 0) + 1 | 0;
     HEAP32[($4 + 24 | 0) >> 2] = $5;
     $8 = $8 + -32 | 0;
     $7 = $9 >>> (($3 - $8 | 0) & 31 | 0) | 0;
    }
    $1 = $1 + 1 | 0;
    $2 = $2 + -1 | 0;
    if ($2) {
     continue label$2
    }
    break label$2;
   };
   if (!($8 & 255 | 0)) {
    break label$1
   }
   label$5 : {
    if (($5 | 0) != (HEAP32[($4 + 20 | 0) >> 2] | 0 | 0)) {
     break label$5
    }
    alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h90c9768825cdae1b($4 + 16 | 0 | 0, $5 | 0, 1 | 0);
    $5 = HEAP32[($4 + 24 | 0) >> 2] | 0;
   }
   HEAP32[((HEAP32[($4 + 16 | 0) >> 2] | 0) + ($5 << 2 | 0) | 0) >> 2] = $7;
   HEAP32[($4 + 24 | 0) >> 2] = $5 + 1 | 0;
  }
  $7 = HEAP32[(($4 + 16 | 0) + 8 | 0) >> 2] | 0;
  HEAP32[(($4 + 32 | 0) + 8 | 0) >> 2] = $7;
  i64toi32_i32$1 = $4;
  i64toi32_i32$2 = HEAP32[($4 + 16 | 0) >> 2] | 0;
  i64toi32_i32$5 = HEAP32[($4 + 20 | 0) >> 2] | 0;
  $10 = i64toi32_i32$2;
  $10$hi = i64toi32_i32$5;
  i64toi32_i32$2 = $4;
  HEAP32[($4 + 32 | 0) >> 2] = $10;
  HEAP32[($4 + 36 | 0) >> 2] = i64toi32_i32$5;
  label$6 : {
   label$7 : {
    if ($7) {
     break label$7
    }
    $7 = 0;
    break label$6;
   }
   i64toi32_i32$5 = $10$hi;
   $8 = (($7 << 2 | 0) + $10 | 0) + -4 | 0;
   label$8 : {
    label$9 : while (1) {
     if (HEAP32[$8 >> 2] | 0) {
      break label$8
     }
     $8 = $8 + -4 | 0;
     $7 = $7 + -1 | 0;
     if ($7) {
      continue label$9
     }
     break label$9;
    };
    $7 = 0;
   }
   HEAP32[($4 + 40 | 0) >> 2] = $7;
  }
  label$10 : {
   $8 = HEAP32[($4 + 36 | 0) >> 2] | 0;
   if ($7 >>> 0 >= ($8 >>> 2 | 0) >>> 0) {
    break label$10
   }
   if ($8 >>> 0 <= $7 >>> 0) {
    break label$10
   }
   alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($4 + 32 | 0 | 0, $7 | 0);
  }
  i64toi32_i32$1 = $4;
  i64toi32_i32$5 = HEAP32[($4 + 32 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[($4 + 36 | 0) >> 2] | 0;
  $155 = i64toi32_i32$5;
  i64toi32_i32$5 = $0;
  HEAP32[i64toi32_i32$5 >> 2] = $155;
  HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$5 + 8 | 0) >> 2] = HEAP32[(($4 + 32 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $4 + 48 | 0;
 }
 
 function hashbrown__map__make_insert_hash__h2055ab7176a1ea97($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $8$hi = 0, $7$hi = 0, $7 = 0, $8 = 0, $9$hi = 0, $9 = 0, $10$hi = 0, $10 = 0, $11$hi = 0, $2 = 0, $11 = 0, $12$hi = 0, $12 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $92 = 0, $25 = 0, $30 = 0, $37 = 0, $45 = 0, $76 = 0, $76$hi = 0, $77 = 0, $77$hi = 0, $79$hi = 0, $84 = 0, $84$hi = 0, $90 = 0, $90$hi = 0, $95 = 0, $95$hi = 0, $99 = 0, $99$hi = 0, $102$hi = 0, $109 = 0, $109$hi = 0, $115 = 0, $115$hi = 0, $117 = 0, $117$hi = 0, $119$hi = 0, $125 = 0, $125$hi = 0, $131 = 0, $131$hi = 0, $134 = 0, $134$hi = 0, $135 = 0, $135$hi = 0, $137$hi = 0, $142 = 0, $142$hi = 0, $149 = 0, $149$hi = 0, $150 = 0, $150$hi = 0, $152$hi = 0, $157 = 0, $157$hi = 0, $164 = 0, $164$hi = 0, $165 = 0, $165$hi = 0, $167$hi = 0, $172 = 0, $172$hi = 0, $175$hi = 0, $177 = 0, $177$hi = 0, $179$hi = 0, $184 = 0, $184$hi = 0, $190$hi = 0, $93 = 0, $193 = 0, $193$hi = 0, $194 = 0, $194$hi = 0, $196 = 0, $196$hi = 0, $197 = 0, $197$hi = 0, $199 = 0, $199$hi = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  $3 = $2 + 64 | 0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = $2 + 48 | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = 1952801890;
  i64toi32_i32$3 = 2037671283;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $25 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $4;
  HEAP32[i64toi32_i32$2 >> 2] = $25;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  $5 = $2 + 40 | 0;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$1 = $7;
  i64toi32_i32$2 = 1685025377;
  i64toi32_i32$3 = 1852075885;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $30 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $5;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  $6 = $2 + 32 | 0;
  i64toi32_i32$0 = $0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$2;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$2 = 1819895653;
  i64toi32_i32$3 = 1852142177;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $37 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $6;
  HEAP32[i64toi32_i32$0 >> 2] = $37;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$0 = $2;
  i64toi32_i32$2 = 0;
  HEAP32[(i64toi32_i32$0 + 56 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 60 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$1 = $8;
  i64toi32_i32$0 = 1936682341;
  i64toi32_i32$3 = 1886610805;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $45 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $2;
  HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = $45;
  HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = i64toi32_i32$0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e(i64toi32_i32$1 | 0, $1 | 0);
  $0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  $1 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  HEAP32[(i64toi32_i32$1 + 76 | 0) >> 2] = $1;
  $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_3(i64toi32_i32$1 + 8 | 0 | 0, i64toi32_i32$1 + 76 | 0 | 0, 4 | 0);
  $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_3(i64toi32_i32$1 + 8 | 0 | 0, $0 | 0, $1 | 0);
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = 0;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $6;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $12 = i64toi32_i32$1;
  $12$hi = i64toi32_i32$0;
  global$0 = i64toi32_i32$2 + 80 | 0;
  i64toi32_i32$0 = $10$hi;
  $76 = $10;
  $76$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  $77 = $9;
  $77$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$2 = $8;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $92 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $92 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $79$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $77$hi;
  i64toi32_i32$0 = $77;
  i64toi32_i32$2 = $79$hi;
  i64toi32_i32$3 = $92;
  i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
  $8 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $76$hi;
  i64toi32_i32$1 = $76;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $9 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($9 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $84 = i64toi32_i32$1;
  $84$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$4;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $84$hi;
  i64toi32_i32$0 = $84;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$2;
  $90 = $10;
  $90$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$5 = $7;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $95 = i64toi32_i32$5;
  $95$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $90$hi;
  i64toi32_i32$2 = $90;
  i64toi32_i32$5 = $95$hi;
  i64toi32_i32$3 = $95;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $12 = i64toi32_i32$0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $99 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $99$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($7 | 0, i64toi32_i32$2 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $102$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$2 = $102$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $8 = i64toi32_i32$5;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 17 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $109 = i64toi32_i32$2;
  $109$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$2 = $109$hi;
  i64toi32_i32$3 = $109;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $99$hi;
  i64toi32_i32$0 = $99;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $115 = i64toi32_i32$0;
  $115$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = $115$hi;
  i64toi32_i32$3 = $115;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $7 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$0;
  $117 = $7;
  $117$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($10 | 0, i64toi32_i32$0 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $119$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$0 = $119$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $10$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($8 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 255;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $125 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $125$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$2 = $10;
  i64toi32_i32$0 = $125$hi;
  i64toi32_i32$3 = $125;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $8 = i64toi32_i32$4;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $117$hi;
  i64toi32_i32$5 = $117;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$0;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 17 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $131 = i64toi32_i32$5;
  $131$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$5 = $131$hi;
  i64toi32_i32$3 = $131;
  i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
  $7 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$5;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $134 = i64toi32_i32$1;
  $134$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  $135 = $7;
  $135$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$5 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $137$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $8$hi;
  i64toi32_i32$5 = $137$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $8 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($9 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $142 = i64toi32_i32$4;
  $142$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$5 = $8;
  i64toi32_i32$4 = $142$hi;
  i64toi32_i32$3 = $142;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $9 = i64toi32_i32$2;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $135$hi;
  i64toi32_i32$1 = $135;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$4;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $134$hi;
  i64toi32_i32$0 = $134;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($10 | 0, i64toi32_i32$1 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $149 = i64toi32_i32$0;
  $149$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $10$hi;
  $150 = $10;
  $150$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($8 | 0, i64toi32_i32$1 | 0, 21 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $152$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$1 = $152$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $8 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $157 = i64toi32_i32$2;
  $157$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$1 = $8;
  i64toi32_i32$2 = $157$hi;
  i64toi32_i32$3 = $157;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $9 = i64toi32_i32$5;
  $9$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $150$hi;
  i64toi32_i32$0 = $150;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $10 = i64toi32_i32$2;
  $10$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $149$hi;
  i64toi32_i32$4 = $149;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $11 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $164 = i64toi32_i32$4;
  $164$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  $165 = $11;
  $165$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($8 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $167$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $167$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $8 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $172 = i64toi32_i32$5;
  $172$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$0 = $8;
  i64toi32_i32$5 = $172$hi;
  i64toi32_i32$3 = $172;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$1;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $165$hi;
  i64toi32_i32$4 = $165;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $175$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $164$hi;
  i64toi32_i32$2 = $164;
  i64toi32_i32$4 = $175$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $9 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $9$hi = i64toi32_i32$4;
  $177 = $9;
  $177$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($8 | 0, i64toi32_i32$4 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $179$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$4 = $179$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $184 = i64toi32_i32$1;
  $184$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = $7;
  i64toi32_i32$1 = $184$hi;
  i64toi32_i32$3 = $184;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $177$hi;
  i64toi32_i32$2 = $177;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $10 = i64toi32_i32$1;
  $10$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $190$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$0 = $190$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $93 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($93 | 0, i64toi32_i32$2 | 0, 21 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $193 = i64toi32_i32$5;
  $193$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$5 = $193$hi;
  i64toi32_i32$3 = $193;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $194 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $194$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($9 | 0, i64toi32_i32$5 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $196 = i64toi32_i32$0;
  $196$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $194$hi;
  i64toi32_i32$2 = $194;
  i64toi32_i32$0 = $196$hi;
  i64toi32_i32$3 = $196;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $197 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $197$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $199 = i64toi32_i32$2;
  $199$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $197$hi;
  i64toi32_i32$5 = $197;
  i64toi32_i32$2 = $199$hi;
  i64toi32_i32$3 = $199;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$5 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$2;
  return i64toi32_i32$5 | 0;
 }
 
 function hashbrown__map__make_hash__h2529a4f95818d178($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $8$hi = 0, $7$hi = 0, $7 = 0, $8 = 0, $9$hi = 0, $9 = 0, $10$hi = 0, $10 = 0, $11$hi = 0, $2 = 0, $11 = 0, $12$hi = 0, $12 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $92 = 0, $25 = 0, $30 = 0, $37 = 0, $45 = 0, $76 = 0, $76$hi = 0, $77 = 0, $77$hi = 0, $79$hi = 0, $84 = 0, $84$hi = 0, $90 = 0, $90$hi = 0, $95 = 0, $95$hi = 0, $99 = 0, $99$hi = 0, $102$hi = 0, $109 = 0, $109$hi = 0, $115 = 0, $115$hi = 0, $117 = 0, $117$hi = 0, $119$hi = 0, $125 = 0, $125$hi = 0, $131 = 0, $131$hi = 0, $134 = 0, $134$hi = 0, $135 = 0, $135$hi = 0, $137$hi = 0, $142 = 0, $142$hi = 0, $149 = 0, $149$hi = 0, $150 = 0, $150$hi = 0, $152$hi = 0, $157 = 0, $157$hi = 0, $164 = 0, $164$hi = 0, $165 = 0, $165$hi = 0, $167$hi = 0, $172 = 0, $172$hi = 0, $175$hi = 0, $177 = 0, $177$hi = 0, $179$hi = 0, $184 = 0, $184$hi = 0, $190$hi = 0, $93 = 0, $193 = 0, $193$hi = 0, $194 = 0, $194$hi = 0, $196 = 0, $196$hi = 0, $197 = 0, $197$hi = 0, $199 = 0, $199$hi = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  $3 = $2 + 64 | 0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = $2 + 48 | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = 1952801890;
  i64toi32_i32$3 = 2037671283;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $25 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $4;
  HEAP32[i64toi32_i32$2 >> 2] = $25;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  $5 = $2 + 40 | 0;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$1 = $7;
  i64toi32_i32$2 = 1685025377;
  i64toi32_i32$3 = 1852075885;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $30 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $5;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  $6 = $2 + 32 | 0;
  i64toi32_i32$0 = $0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$2;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$2 = 1819895653;
  i64toi32_i32$3 = 1852142177;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $37 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $6;
  HEAP32[i64toi32_i32$0 >> 2] = $37;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$0 = $2;
  i64toi32_i32$2 = 0;
  HEAP32[(i64toi32_i32$0 + 56 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 60 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$1 = $8;
  i64toi32_i32$0 = 1936682341;
  i64toi32_i32$3 = 1886610805;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $45 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $2;
  HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = $45;
  HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = i64toi32_i32$0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e(i64toi32_i32$1 | 0, $1 | 0);
  $0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  $1 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  HEAP32[(i64toi32_i32$1 + 76 | 0) >> 2] = $1;
  $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_3(i64toi32_i32$1 + 8 | 0 | 0, i64toi32_i32$1 + 76 | 0 | 0, 4 | 0);
  $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_3(i64toi32_i32$1 + 8 | 0 | 0, $0 | 0, $1 | 0);
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = 0;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $6;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $12 = i64toi32_i32$1;
  $12$hi = i64toi32_i32$0;
  global$0 = i64toi32_i32$2 + 80 | 0;
  i64toi32_i32$0 = $10$hi;
  $76 = $10;
  $76$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  $77 = $9;
  $77$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$2 = $8;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $92 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $92 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $79$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $77$hi;
  i64toi32_i32$0 = $77;
  i64toi32_i32$2 = $79$hi;
  i64toi32_i32$3 = $92;
  i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
  $8 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $76$hi;
  i64toi32_i32$1 = $76;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $9 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($9 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $84 = i64toi32_i32$1;
  $84$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$4;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $84$hi;
  i64toi32_i32$0 = $84;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$2;
  $90 = $10;
  $90$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$5 = $7;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $95 = i64toi32_i32$5;
  $95$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $90$hi;
  i64toi32_i32$2 = $90;
  i64toi32_i32$5 = $95$hi;
  i64toi32_i32$3 = $95;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $12 = i64toi32_i32$0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $99 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $99$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($7 | 0, i64toi32_i32$2 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $102$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$2 = $102$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $8 = i64toi32_i32$5;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 17 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $109 = i64toi32_i32$2;
  $109$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$2 = $109$hi;
  i64toi32_i32$3 = $109;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $99$hi;
  i64toi32_i32$0 = $99;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $115 = i64toi32_i32$0;
  $115$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = $115$hi;
  i64toi32_i32$3 = $115;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $7 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$0;
  $117 = $7;
  $117$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($10 | 0, i64toi32_i32$0 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $119$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$0 = $119$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $10$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($8 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 255;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $125 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $125$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$2 = $10;
  i64toi32_i32$0 = $125$hi;
  i64toi32_i32$3 = $125;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $8 = i64toi32_i32$4;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $117$hi;
  i64toi32_i32$5 = $117;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$0;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 17 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $131 = i64toi32_i32$5;
  $131$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$5 = $131$hi;
  i64toi32_i32$3 = $131;
  i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
  $7 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$5;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $134 = i64toi32_i32$1;
  $134$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  $135 = $7;
  $135$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$5 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $137$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $8$hi;
  i64toi32_i32$5 = $137$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $8 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($9 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $142 = i64toi32_i32$4;
  $142$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$5 = $8;
  i64toi32_i32$4 = $142$hi;
  i64toi32_i32$3 = $142;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $9 = i64toi32_i32$2;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $135$hi;
  i64toi32_i32$1 = $135;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$4;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $134$hi;
  i64toi32_i32$0 = $134;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($10 | 0, i64toi32_i32$1 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $149 = i64toi32_i32$0;
  $149$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $10$hi;
  $150 = $10;
  $150$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($8 | 0, i64toi32_i32$1 | 0, 21 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $152$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$1 = $152$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $8 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $157 = i64toi32_i32$2;
  $157$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$1 = $8;
  i64toi32_i32$2 = $157$hi;
  i64toi32_i32$3 = $157;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $9 = i64toi32_i32$5;
  $9$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $150$hi;
  i64toi32_i32$0 = $150;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $10 = i64toi32_i32$2;
  $10$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $149$hi;
  i64toi32_i32$4 = $149;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $11 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $164 = i64toi32_i32$4;
  $164$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  $165 = $11;
  $165$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($8 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $167$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $167$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $8 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $172 = i64toi32_i32$5;
  $172$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$0 = $8;
  i64toi32_i32$5 = $172$hi;
  i64toi32_i32$3 = $172;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$1;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $165$hi;
  i64toi32_i32$4 = $165;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $175$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $164$hi;
  i64toi32_i32$2 = $164;
  i64toi32_i32$4 = $175$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $9 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $9$hi = i64toi32_i32$4;
  $177 = $9;
  $177$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($8 | 0, i64toi32_i32$4 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $179$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$4 = $179$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $184 = i64toi32_i32$1;
  $184$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = $7;
  i64toi32_i32$1 = $184$hi;
  i64toi32_i32$3 = $184;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $177$hi;
  i64toi32_i32$2 = $177;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $10 = i64toi32_i32$1;
  $10$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $190$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$0 = $190$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $93 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($93 | 0, i64toi32_i32$2 | 0, 21 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $193 = i64toi32_i32$5;
  $193$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$5 = $193$hi;
  i64toi32_i32$3 = $193;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $194 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $194$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($9 | 0, i64toi32_i32$5 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $196 = i64toi32_i32$0;
  $196$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $194$hi;
  i64toi32_i32$2 = $194;
  i64toi32_i32$0 = $196$hi;
  i64toi32_i32$3 = $196;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $197 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $197$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $199 = i64toi32_i32$2;
  $199$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $197$hi;
  i64toi32_i32$5 = $197;
  i64toi32_i32$2 = $199$hi;
  i64toi32_i32$3 = $199;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$5 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$2;
  return i64toi32_i32$5 | 0;
 }
 
 function cardano_serialization_lib__TransactionOutputs__add__h2527e8fddfba1826($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $4 = 0, $5 = 0, $29 = 0, $30 = 0, $32 = 0, $33 = 0, $34 = 0, $35 = 0, $37 = 0, $38 = 0, $3 = 0, $6 = 0, $6$hi = 0, $31 = 0, $36 = 0, $44 = 0, $49 = 0, $55 = 0, $59 = 0, $69 = 0, $75 = 0, $82 = 0, $89 = 0, $92 = 0, $95 = 0, $121 = 0, $127 = 0, $131 = 0, $136 = 0, $140 = 0, $144 = 0;
  $2 = global$0 - 224 | 0;
  global$0 = $2;
  $cardano_serialization_lib__address__Address_20as_20core__clone__Clone___clone__h0eb465a6e349d507($2 + 112 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
  $6 = i64toi32_i32$0;
  $6$hi = i64toi32_i32$1;
  $3 = 0;
  $4 = 0;
  label$1 : {
   if ((HEAP32[(i64toi32_i32$2 + 72 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($2 + 48 | 0 | 4 | 0 | 0, $1 + 76 | 0 | 0);
   $4 = 1;
  }
  $5 = ($2 + 176 | 0) + 8 | 0;
  i64toi32_i32$2 = ($2 + 48 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $31 = i64toi32_i32$1;
  i64toi32_i32$1 = $5;
  HEAP32[i64toi32_i32$1 >> 2] = $31;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 48 | 0) >> 2] = $4;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] | 0;
  $36 = i64toi32_i32$0;
  i64toi32_i32$0 = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$0 + 176 | 0) >> 2] = $36;
  HEAP32[(i64toi32_i32$0 + 180 | 0) >> 2] = i64toi32_i32$1;
  label$2 : {
   if ((HEAPU8[($1 + 88 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$2
   }
   i64toi32_i32$2 = $1 + 113 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $44 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 216 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $44;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $1 + 105 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $49 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 208 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $49;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1 + 97 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $55 = i64toi32_i32$1;
   i64toi32_i32$1 = ($2 + 192 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $55;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $1 + 89 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $59 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   HEAP32[(i64toi32_i32$0 + 192 | 0) >> 2] = $59;
   HEAP32[(i64toi32_i32$0 + 196 | 0) >> 2] = i64toi32_i32$1;
   $3 = 1;
  }
  memcpy($2 + 48 | 0 | 0, $2 + 112 | 0 | 0, 64 | 0) | 0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $69 = i64toi32_i32$1;
  i64toi32_i32$1 = ($2 + 32 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $69;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = ($2 + 192 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $75 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $75;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $4 = $2 + 16 | 0;
  i64toi32_i32$2 = ($2 + 192 | 0) + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $82 = i64toi32_i32$1;
  i64toi32_i32$1 = $4;
  HEAP32[i64toi32_i32$1 >> 2] = $82;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $5 = $2 + 24 | 0;
  i64toi32_i32$2 = ($2 + 192 | 0) + 24 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $89 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[i64toi32_i32$0 >> 2] = $89;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 176 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 180 | 0) >> 2] | 0;
  $92 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] = $92;
  HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 192 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 196 | 0) >> 2] | 0;
  $95 = i64toi32_i32$0;
  i64toi32_i32$0 = i64toi32_i32$2;
  HEAP32[i64toi32_i32$2 >> 2] = $95;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
  label$3 : {
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (($1 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
    break label$3
   }
   alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hf135acf924159ceb($0 | 0, $1 | 0, 1 | 0);
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  }
  $1 = memcpy((HEAP32[$0 >> 2] | 0) + ($1 << 7 | 0) | 0 | 0, $2 + 48 | 0 | 0, 64 | 0) | 0;
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$0 = $1;
  HEAP32[(i64toi32_i32$0 + 64 | 0) >> 2] = $6;
  HEAP32[(i64toi32_i32$0 + 68 | 0) >> 2] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 88 | 0) >> 0] = $3;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
  $121 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 72 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $121;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = (i64toi32_i32$2 + 32 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $127 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 80 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $127;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $131 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 89 | 0;
  $29 = $131;
  HEAP8[i64toi32_i32$1 >> 0] = $29;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $29 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $29 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $29 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $136 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 97 | 0;
  $30 = $136;
  HEAP8[i64toi32_i32$0 >> 0] = $30;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $30 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $30 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $30 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $140 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 105 | 0;
  $32 = $140;
  HEAP8[i64toi32_i32$1 >> 0] = $32;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $32 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $32 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $32 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $144 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 113 | 0;
  $33 = $144;
  HEAP8[i64toi32_i32$0 >> 0] = $33;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $33 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $33 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $33 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $34 = HEAPU8[($2 + 112 | 0) >> 0] | 0 | ((HEAPU8[($2 + 113 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 114 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 115 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  HEAP8[($1 + 121 | 0) >> 0] = $34;
  HEAP8[($1 + 122 | 0) >> 0] = $34 >>> 8 | 0;
  HEAP8[($1 + 123 | 0) >> 0] = $34 >>> 16 | 0;
  HEAP8[($1 + 124 | 0) >> 0] = $34 >>> 24 | 0;
  $35 = $2 + 115 | 0;
  $37 = $1 + 124 | 0;
  $38 = HEAPU8[$35 >> 0] | 0 | ((HEAPU8[($35 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($35 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($35 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  HEAP8[$37 >> 0] = $38;
  HEAP8[($37 + 1 | 0) >> 0] = $38 >>> 8 | 0;
  HEAP8[($37 + 2 | 0) >> 0] = $38 >>> 16 | 0;
  HEAP8[($37 + 3 | 0) >> 0] = $38 >>> 24 | 0;
  HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
  global$0 = $2 + 224 | 0;
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hf69db734dd831996($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $2 = 0, $4 = 0, $7 = 0, $9 = 0, $14 = 0, $14$hi = 0, $10 = 0, $5 = 0, $11 = 0, $6 = 0, $13 = 0, $13$hi = 0, $12 = 0, $3 = 0, $8 = 0, $60 = 0, $66 = 0, $69 = 0, $110 = 0, $118 = 0, $121 = 0, $139 = 0, $143 = 0, $147 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  $3 = HEAP32[$1 >> 2] | 0;
  $4 = 0;
  $5 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__hd4ae7e11703b95a3($2 + 8 | 0 | 0, $5 | 0, 0 | 0);
  $6 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  $7 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[($0 + 4 | 0) >> 2] = $7;
  HEAP32[$0 >> 2] = $6;
  label$1 : {
   if (!$7) {
    break label$1
   }
   $8 = Math_imul($5, 48);
   $9 = ($2 + 40 | 0) + 16 | 0;
   label$2 : while (1) {
    if (($8 | 0) == ($4 | 0)) {
     break label$1
    }
    $7 = $7 + -1 | 0;
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          $1 = $3 + $4 | 0;
          switch (HEAP32[$1 >> 2] | 0 | 0) {
          case 4:
           break label$4;
          case 3:
           break label$5;
          case 2:
           break label$6;
          case 1:
           break label$7;
          default:
           break label$8;
          };
         }
         $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__hdeea20968268d729($2 + 40 | 0 | 0, $1 + 8 | 0 | 0);
         i64toi32_i32$2 = $9 + 8 | 0;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $60 = i64toi32_i32$0;
         i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $60;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$2 = $9 + 16 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $66 = i64toi32_i32$1;
         i64toi32_i32$1 = ($2 + 16 | 0) + 16 | 0;
         HEAP32[i64toi32_i32$1 >> 2] = $66;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$2 = $9;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $69 = i64toi32_i32$0;
         i64toi32_i32$0 = $2;
         HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $69;
         HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$2 = (i64toi32_i32$0 + 40 | 0) + 8 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $13 = i64toi32_i32$1;
         $13$hi = i64toi32_i32$0;
         i64toi32_i32$2 = $2;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] | 0;
         $14 = i64toi32_i32$0;
         $14$hi = i64toi32_i32$1;
         $10 = 0;
         break label$3;
        }
        $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hf69db734dd831996($2 + 40 | 0 | 0, $1 + 4 | 0 | 0);
        i64toi32_i32$2 = $2;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] | 0;
        $14 = i64toi32_i32$1;
        $14$hi = i64toi32_i32$0;
        $11 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
        $10 = 1;
        break label$3;
       }
       i64toi32_i32$2 = $1 + 16 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $13 = i64toi32_i32$0;
       $13$hi = i64toi32_i32$1;
       i64toi32_i32$2 = $1 + 8 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $14 = i64toi32_i32$1;
       $14$hi = i64toi32_i32$0;
       $10 = 2;
       break label$3;
      }
      $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($2 + 40 | 0 | 0, $1 + 4 | 0 | 0);
      i64toi32_i32$2 = $2;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] | 0;
      $14 = i64toi32_i32$0;
      $14$hi = i64toi32_i32$1;
      $11 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
      $10 = 3;
      break label$3;
     }
     $10 = 4;
     $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($2 + 40 | 0 | 0, $1 + 4 | 0 | 0);
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] | 0;
     $14 = i64toi32_i32$1;
     $14$hi = i64toi32_i32$0;
     $11 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
    }
    i64toi32_i32$2 = ($2 + 16 | 0) + 16 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $110 = i64toi32_i32$0;
    i64toi32_i32$0 = $9;
    HEAP32[i64toi32_i32$0 >> 2] = $110;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    $12 = ($2 + 40 | 0) + 8 | 0;
    i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $118 = i64toi32_i32$1;
    i64toi32_i32$1 = $12;
    HEAP32[i64toi32_i32$1 >> 2] = $118;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
    $121 = i64toi32_i32$0;
    i64toi32_i32$0 = i64toi32_i32$2;
    HEAP32[(i64toi32_i32$0 + 40 | 0) >> 2] = $121;
    HEAP32[(i64toi32_i32$0 + 44 | 0) >> 2] = i64toi32_i32$1;
    $1 = $6 + $4 | 0;
    i64toi32_i32$1 = $13$hi;
    i64toi32_i32$0 = $1 + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $13;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $14$hi;
    i64toi32_i32$0 = $1 + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $14;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($1 + 4 | 0) >> 2] = $11;
    HEAP32[$1 >> 2] = $10;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] | 0;
    $139 = i64toi32_i32$1;
    i64toi32_i32$1 = $1 + 24 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $139;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $12;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $143 = i64toi32_i32$0;
    i64toi32_i32$0 = $1 + 32 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $143;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $9;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $147 = i64toi32_i32$1;
    i64toi32_i32$1 = $1 + 40 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $147;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    $4 = $4 + 48 | 0;
    if ($7) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 8 | 0) >> 2] = $5;
  global$0 = $2 + 80 | 0;
 }
 
 function alloc__collections__btree__node__BalancingContext_K_2cV___bulk_steal_right__h5eaa656be70e1d95($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $6 = 0, $8 = 0, $3 = 0, $2 = 0, $5 = 0, $7 = 0, $4 = 0, $9 = 0, $10 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if (!$1) {
       break label$4
      }
      $2 = HEAP32[($0 + 16 | 0) >> 2] | 0;
      $3 = HEAPU16[($2 + 50 | 0) >> 1] | 0;
      $4 = $3 + $1 | 0;
      if ($4 >>> 0 > 11 >>> 0) {
       break label$3
      }
      label$5 : {
       label$6 : {
        label$7 : {
         $5 = HEAP32[($0 + 24 | 0) >> 2] | 0;
         $6 = HEAPU16[($5 + 50 | 0) >> 1] | 0;
         if ($6 >>> 0 < $1 >>> 0) {
          break label$7
         }
         HEAP16[($2 + 50 | 0) >> 1] = $4;
         $7 = $6 - $1 | 0;
         HEAP16[($5 + 50 | 0) >> 1] = $7;
         $6 = ((HEAP32[($0 + 4 | 0) >> 2] | 0) + ((HEAP32[($0 + 8 | 0) >> 2] | 0) << 2 | 0) | 0) + 4 | 0;
         $8 = HEAP32[$6 >> 2] | 0;
         $9 = $1 + -1 | 0;
         $10 = $9 << 2 | 0;
         HEAP32[$6 >> 2] = HEAP32[(($5 + $10 | 0) + 4 | 0) >> 2] | 0;
         HEAP32[(($2 + ($3 << 2 | 0) | 0) + 4 | 0) >> 2] = $8;
         $6 = $3 + 1 | 0;
         if (($9 | 0) != ($4 - $6 | 0 | 0)) {
          break label$2
         }
         $8 = $5 + 4 | 0;
         memcpy(($2 + ($6 << 2 | 0) | 0) + 4 | 0 | 0, $8 | 0, $10 | 0) | 0;
         memmove($8 | 0, $8 + ($1 << 2 | 0) | 0 | 0, $7 << 2 | 0 | 0) | 0;
         $8 = HEAP32[($0 + 12 | 0) >> 2] | 0;
         if (HEAP32[($0 + 20 | 0) >> 2] | 0) {
          break label$6
         }
         if (!$8) {
          break label$5
         }
         break label$1;
        }
        core__panicking__panic__h2fd385a887c8bf13(1049456 | 0, 40 | 0, 1049496 | 0);
        abort();
       }
       if (!$8) {
        break label$1
       }
       $0 = $5 + 52 | 0;
       $8 = $1 << 2 | 0;
       memcpy(($2 + ($6 << 2 | 0) | 0) + 52 | 0 | 0, $0 | 0, $8 | 0) | 0;
       memmove($0 | 0, $0 + $8 | 0 | 0, ($7 << 2 | 0) + 4 | 0 | 0) | 0;
       label$8 : {
        if ($4 >>> 0 <= $3 >>> 0) {
         break label$8
        }
        $0 = ($2 + ($3 << 2 | 0) | 0) + 56 | 0;
        label$9 : while (1) {
         $3 = HEAP32[$0 >> 2] | 0;
         HEAP16[($3 + 48 | 0) >> 1] = $6;
         HEAP32[$3 >> 2] = $2;
         $0 = $0 + 4 | 0;
         $6 = $6 + 1 | 0;
         $1 = $1 + -1 | 0;
         if ($1) {
          continue label$9
         }
         break label$9;
        };
       }
       if (($7 | 0) == (-1 | 0)) {
        break label$5
       }
       $6 = $5 + 52 | 0;
       $3 = $7 + 1 | 0;
       $0 = 0;
       label$10 : while (1) {
        $1 = HEAP32[$6 >> 2] | 0;
        HEAP16[($1 + 48 | 0) >> 1] = $0;
        HEAP32[$1 >> 2] = $5;
        $6 = $6 + 4 | 0;
        $0 = $0 + 1 | 0;
        if (($3 | 0) != ($0 | 0)) {
         continue label$10
        }
        break label$10;
       };
      }
      return;
     }
     core__panicking__panic__h2fd385a887c8bf13(1049148 | 0, 27 | 0, 1049372 | 0);
     abort();
    }
    core__panicking__panic__h2fd385a887c8bf13(1049388 | 0, 50 | 0, 1049440 | 0);
    abort();
   }
   core__panicking__panic__h2fd385a887c8bf13(1048988 | 0, 40 | 0, 1049028 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1049316 | 0, 40 | 0, 1049512 | 0);
  abort();
 }
 
 function hashbrown__map__make_insert_hash__h6e13c786bfd61db3($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $8$hi = 0, $7$hi = 0, $7 = 0, $8 = 0, $9$hi = 0, $9 = 0, $10$hi = 0, $10 = 0, $11$hi = 0, $2 = 0, $11 = 0, $12$hi = 0, $12 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $93 = 0, $25 = 0, $30 = 0, $37 = 0, $45 = 0, $73 = 0, $73$hi = 0, $74 = 0, $74$hi = 0, $76$hi = 0, $81 = 0, $81$hi = 0, $87 = 0, $87$hi = 0, $92 = 0, $92$hi = 0, $96 = 0, $96$hi = 0, $99$hi = 0, $106 = 0, $106$hi = 0, $112 = 0, $112$hi = 0, $114 = 0, $114$hi = 0, $116$hi = 0, $122 = 0, $122$hi = 0, $128 = 0, $128$hi = 0, $131 = 0, $131$hi = 0, $132 = 0, $132$hi = 0, $134$hi = 0, $139 = 0, $139$hi = 0, $146 = 0, $146$hi = 0, $147 = 0, $147$hi = 0, $149$hi = 0, $154 = 0, $154$hi = 0, $161 = 0, $161$hi = 0, $162 = 0, $162$hi = 0, $164$hi = 0, $169 = 0, $169$hi = 0, $172$hi = 0, $174 = 0, $174$hi = 0, $176$hi = 0, $181 = 0, $181$hi = 0, $187$hi = 0, $94 = 0, $190 = 0, $190$hi = 0, $191 = 0, $191$hi = 0, $193 = 0, $193$hi = 0, $194 = 0, $194$hi = 0, $196 = 0, $196$hi = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  $3 = $2 + 64 | 0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = $2 + 48 | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = 1952801890;
  i64toi32_i32$3 = 2037671283;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $25 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $4;
  HEAP32[i64toi32_i32$2 >> 2] = $25;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  $5 = $2 + 40 | 0;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$1 = $7;
  i64toi32_i32$2 = 1685025377;
  i64toi32_i32$3 = 1852075885;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $30 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $5;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  $6 = $2 + 32 | 0;
  i64toi32_i32$0 = $0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$2;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$2 = 1819895653;
  i64toi32_i32$3 = 1852142177;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $37 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $6;
  HEAP32[i64toi32_i32$0 >> 2] = $37;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$0 = $2;
  i64toi32_i32$2 = 0;
  HEAP32[(i64toi32_i32$0 + 56 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 60 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$1 = $8;
  i64toi32_i32$0 = 1936682341;
  i64toi32_i32$3 = 1886610805;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $45 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $2;
  HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = $45;
  HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = i64toi32_i32$0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e(i64toi32_i32$1 | 0, $1 | 0);
  $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_3(i64toi32_i32$1 + 8 | 0 | 0, HEAP32[i64toi32_i32$1 >> 2] | 0 | 0, HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0 | 0);
  HEAP8[(i64toi32_i32$1 + 79 | 0) >> 0] = 255;
  $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_3(i64toi32_i32$1 + 8 | 0 | 0, i64toi32_i32$1 + 79 | 0 | 0, 1 | 0);
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = 0;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $6;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $12 = i64toi32_i32$1;
  $12$hi = i64toi32_i32$0;
  global$0 = i64toi32_i32$2 + 80 | 0;
  i64toi32_i32$0 = $10$hi;
  $73 = $10;
  $73$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  $74 = $9;
  $74$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$2 = $8;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $93 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $93 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $76$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $74$hi;
  i64toi32_i32$0 = $74;
  i64toi32_i32$2 = $76$hi;
  i64toi32_i32$3 = $93;
  i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
  $8 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $73$hi;
  i64toi32_i32$1 = $73;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $9 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($9 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $81 = i64toi32_i32$1;
  $81$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$4;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $81$hi;
  i64toi32_i32$0 = $81;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$2;
  $87 = $10;
  $87$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$5 = $7;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $92 = i64toi32_i32$5;
  $92$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $87$hi;
  i64toi32_i32$2 = $87;
  i64toi32_i32$5 = $92$hi;
  i64toi32_i32$3 = $92;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $12 = i64toi32_i32$0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $96 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $96$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($7 | 0, i64toi32_i32$2 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $99$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$2 = $99$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $8 = i64toi32_i32$5;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 17 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $106 = i64toi32_i32$2;
  $106$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$2 = $106$hi;
  i64toi32_i32$3 = $106;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $96$hi;
  i64toi32_i32$0 = $96;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $112 = i64toi32_i32$0;
  $112$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = $112$hi;
  i64toi32_i32$3 = $112;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $7 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$0;
  $114 = $7;
  $114$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($10 | 0, i64toi32_i32$0 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $116$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$0 = $116$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $10$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($8 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 255;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $122 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $122$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$2 = $10;
  i64toi32_i32$0 = $122$hi;
  i64toi32_i32$3 = $122;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $8 = i64toi32_i32$4;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $114$hi;
  i64toi32_i32$5 = $114;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$0;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 17 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $128 = i64toi32_i32$5;
  $128$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$5 = $128$hi;
  i64toi32_i32$3 = $128;
  i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
  $7 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$5;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $131 = i64toi32_i32$1;
  $131$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  $132 = $7;
  $132$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$5 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $134$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $8$hi;
  i64toi32_i32$5 = $134$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $8 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($9 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $139 = i64toi32_i32$4;
  $139$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$5 = $8;
  i64toi32_i32$4 = $139$hi;
  i64toi32_i32$3 = $139;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $9 = i64toi32_i32$2;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $132$hi;
  i64toi32_i32$1 = $132;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$4;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $131$hi;
  i64toi32_i32$0 = $131;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($10 | 0, i64toi32_i32$1 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $146 = i64toi32_i32$0;
  $146$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $10$hi;
  $147 = $10;
  $147$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($8 | 0, i64toi32_i32$1 | 0, 21 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $149$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$1 = $149$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $8 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $154 = i64toi32_i32$2;
  $154$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$1 = $8;
  i64toi32_i32$2 = $154$hi;
  i64toi32_i32$3 = $154;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $9 = i64toi32_i32$5;
  $9$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $147$hi;
  i64toi32_i32$0 = $147;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $10 = i64toi32_i32$2;
  $10$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $146$hi;
  i64toi32_i32$4 = $146;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $11 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $161 = i64toi32_i32$4;
  $161$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  $162 = $11;
  $162$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($8 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $164$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $164$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $8 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $169 = i64toi32_i32$5;
  $169$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$0 = $8;
  i64toi32_i32$5 = $169$hi;
  i64toi32_i32$3 = $169;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$1;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $162$hi;
  i64toi32_i32$4 = $162;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $172$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $161$hi;
  i64toi32_i32$2 = $161;
  i64toi32_i32$4 = $172$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $9 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $9$hi = i64toi32_i32$4;
  $174 = $9;
  $174$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($8 | 0, i64toi32_i32$4 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $176$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$4 = $176$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $181 = i64toi32_i32$1;
  $181$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = $7;
  i64toi32_i32$1 = $181$hi;
  i64toi32_i32$3 = $181;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $174$hi;
  i64toi32_i32$2 = $174;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $10 = i64toi32_i32$1;
  $10$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $187$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$0 = $187$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $94 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($94 | 0, i64toi32_i32$2 | 0, 21 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $190 = i64toi32_i32$5;
  $190$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$5 = $190$hi;
  i64toi32_i32$3 = $190;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $191 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $191$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($9 | 0, i64toi32_i32$5 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $193 = i64toi32_i32$0;
  $193$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $191$hi;
  i64toi32_i32$2 = $191;
  i64toi32_i32$0 = $193$hi;
  i64toi32_i32$3 = $193;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $194 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $194$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $196 = i64toi32_i32$2;
  $196$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $194$hi;
  i64toi32_i32$5 = $194;
  i64toi32_i32$2 = $196$hi;
  i64toi32_i32$3 = $196;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$5 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$2;
  return i64toi32_i32$5 | 0;
 }
 
 function hashbrown__map__make_hash__hea8f199bb15af0f7($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $8$hi = 0, $7$hi = 0, $7 = 0, $8 = 0, $9$hi = 0, $9 = 0, $10$hi = 0, $10 = 0, $11$hi = 0, $2 = 0, $11 = 0, $12$hi = 0, $12 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $93 = 0, $25 = 0, $30 = 0, $37 = 0, $45 = 0, $73 = 0, $73$hi = 0, $74 = 0, $74$hi = 0, $76$hi = 0, $81 = 0, $81$hi = 0, $87 = 0, $87$hi = 0, $92 = 0, $92$hi = 0, $96 = 0, $96$hi = 0, $99$hi = 0, $106 = 0, $106$hi = 0, $112 = 0, $112$hi = 0, $114 = 0, $114$hi = 0, $116$hi = 0, $122 = 0, $122$hi = 0, $128 = 0, $128$hi = 0, $131 = 0, $131$hi = 0, $132 = 0, $132$hi = 0, $134$hi = 0, $139 = 0, $139$hi = 0, $146 = 0, $146$hi = 0, $147 = 0, $147$hi = 0, $149$hi = 0, $154 = 0, $154$hi = 0, $161 = 0, $161$hi = 0, $162 = 0, $162$hi = 0, $164$hi = 0, $169 = 0, $169$hi = 0, $172$hi = 0, $174 = 0, $174$hi = 0, $176$hi = 0, $181 = 0, $181$hi = 0, $187$hi = 0, $94 = 0, $190 = 0, $190$hi = 0, $191 = 0, $191$hi = 0, $193 = 0, $193$hi = 0, $194 = 0, $194$hi = 0, $196 = 0, $196$hi = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  $3 = $2 + 64 | 0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = $2 + 48 | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = 1952801890;
  i64toi32_i32$3 = 2037671283;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $25 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $4;
  HEAP32[i64toi32_i32$2 >> 2] = $25;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  $5 = $2 + 40 | 0;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$1 = $7;
  i64toi32_i32$2 = 1685025377;
  i64toi32_i32$3 = 1852075885;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $30 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $5;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  $6 = $2 + 32 | 0;
  i64toi32_i32$0 = $0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$2;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$2 = 1819895653;
  i64toi32_i32$3 = 1852142177;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $37 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $6;
  HEAP32[i64toi32_i32$0 >> 2] = $37;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$0 = $2;
  i64toi32_i32$2 = 0;
  HEAP32[(i64toi32_i32$0 + 56 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 60 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$1 = $8;
  i64toi32_i32$0 = 1936682341;
  i64toi32_i32$3 = 1886610805;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $45 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $2;
  HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = $45;
  HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = i64toi32_i32$0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e(i64toi32_i32$1 | 0, $1 | 0);
  $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_3(i64toi32_i32$1 + 8 | 0 | 0, HEAP32[i64toi32_i32$1 >> 2] | 0 | 0, HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0 | 0);
  HEAP8[(i64toi32_i32$1 + 79 | 0) >> 0] = 255;
  $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_3(i64toi32_i32$1 + 8 | 0 | 0, i64toi32_i32$1 + 79 | 0 | 0, 1 | 0);
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = 0;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $6;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $12 = i64toi32_i32$1;
  $12$hi = i64toi32_i32$0;
  global$0 = i64toi32_i32$2 + 80 | 0;
  i64toi32_i32$0 = $10$hi;
  $73 = $10;
  $73$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  $74 = $9;
  $74$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$2 = $8;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $93 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $93 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $76$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $74$hi;
  i64toi32_i32$0 = $74;
  i64toi32_i32$2 = $76$hi;
  i64toi32_i32$3 = $93;
  i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
  $8 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $73$hi;
  i64toi32_i32$1 = $73;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $9 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($9 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $81 = i64toi32_i32$1;
  $81$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$4;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $81$hi;
  i64toi32_i32$0 = $81;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$2;
  $87 = $10;
  $87$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$5 = $7;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $92 = i64toi32_i32$5;
  $92$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $87$hi;
  i64toi32_i32$2 = $87;
  i64toi32_i32$5 = $92$hi;
  i64toi32_i32$3 = $92;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $12 = i64toi32_i32$0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $96 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $96$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($7 | 0, i64toi32_i32$2 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $99$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$2 = $99$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $8 = i64toi32_i32$5;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 17 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $106 = i64toi32_i32$2;
  $106$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$2 = $106$hi;
  i64toi32_i32$3 = $106;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $96$hi;
  i64toi32_i32$0 = $96;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $112 = i64toi32_i32$0;
  $112$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = $112$hi;
  i64toi32_i32$3 = $112;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $7 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$0;
  $114 = $7;
  $114$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($10 | 0, i64toi32_i32$0 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $116$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$0 = $116$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $10$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($8 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 255;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $122 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $122$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$2 = $10;
  i64toi32_i32$0 = $122$hi;
  i64toi32_i32$3 = $122;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $8 = i64toi32_i32$4;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $114$hi;
  i64toi32_i32$5 = $114;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$0;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 17 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $128 = i64toi32_i32$5;
  $128$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$5 = $128$hi;
  i64toi32_i32$3 = $128;
  i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
  $7 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$5;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $131 = i64toi32_i32$1;
  $131$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  $132 = $7;
  $132$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$5 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $134$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $8$hi;
  i64toi32_i32$5 = $134$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $8 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($9 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $139 = i64toi32_i32$4;
  $139$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$5 = $8;
  i64toi32_i32$4 = $139$hi;
  i64toi32_i32$3 = $139;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $9 = i64toi32_i32$2;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $132$hi;
  i64toi32_i32$1 = $132;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$4;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $131$hi;
  i64toi32_i32$0 = $131;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($10 | 0, i64toi32_i32$1 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $146 = i64toi32_i32$0;
  $146$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $10$hi;
  $147 = $10;
  $147$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($8 | 0, i64toi32_i32$1 | 0, 21 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $149$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$1 = $149$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $8 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $154 = i64toi32_i32$2;
  $154$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$1 = $8;
  i64toi32_i32$2 = $154$hi;
  i64toi32_i32$3 = $154;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $9 = i64toi32_i32$5;
  $9$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $147$hi;
  i64toi32_i32$0 = $147;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $10 = i64toi32_i32$2;
  $10$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $146$hi;
  i64toi32_i32$4 = $146;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $11 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $161 = i64toi32_i32$4;
  $161$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  $162 = $11;
  $162$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($8 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $164$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $164$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $8 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $169 = i64toi32_i32$5;
  $169$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$0 = $8;
  i64toi32_i32$5 = $169$hi;
  i64toi32_i32$3 = $169;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$1;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $162$hi;
  i64toi32_i32$4 = $162;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $172$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $161$hi;
  i64toi32_i32$2 = $161;
  i64toi32_i32$4 = $172$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $9 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $9$hi = i64toi32_i32$4;
  $174 = $9;
  $174$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($8 | 0, i64toi32_i32$4 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $176$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$4 = $176$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $181 = i64toi32_i32$1;
  $181$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = $7;
  i64toi32_i32$1 = $181$hi;
  i64toi32_i32$3 = $181;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $174$hi;
  i64toi32_i32$2 = $174;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $10 = i64toi32_i32$1;
  $10$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $187$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$0 = $187$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $94 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($94 | 0, i64toi32_i32$2 | 0, 21 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $190 = i64toi32_i32$5;
  $190$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$5 = $190$hi;
  i64toi32_i32$3 = $190;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $191 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $191$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($9 | 0, i64toi32_i32$5 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $193 = i64toi32_i32$0;
  $193$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $191$hi;
  i64toi32_i32$2 = $191;
  i64toi32_i32$0 = $193$hi;
  i64toi32_i32$3 = $193;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $194 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $194$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $196 = i64toi32_i32$2;
  $196$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $194$hi;
  i64toi32_i32$5 = $194;
  i64toi32_i32$2 = $196$hi;
  i64toi32_i32$3 = $196;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$5 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$2;
  return i64toi32_i32$5 | 0;
 }
 
 function num_bigint__bigint__division___impl_20core__ops__arith__Div_i32__20for_20num_bigint__bigint__BigInt___div__he39ea57e2d8da458($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $7 = 0, $9 = 0, $10 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $5 = 0, $6 = 0, $4 = 0, $11 = 0, $8 = 0, $32 = 0, $34 = 0, $40 = 0, $106 = 0, $152 = 0;
  $3 = global$0 - 32 | 0;
  global$0 = $3;
  $4 = HEAPU8[($1 + 12 | 0) >> 0] | 0;
  $5 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $6 = HEAP32[$1 >> 2] | 0;
  label$1 : {
   $7 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   if (!$7) {
    break label$1
   }
   $8 = $6 + -4 | 0;
   $1 = $7 << 2 | 0;
   $9 = 0;
   label$2 : while (1) {
    $10 = $8 + $1 | 0;
    $32 = $10;
    $34 = $9 << 16 | 0;
    $9 = HEAP32[$10 >> 2] | 0;
    $10 = $34 | ($9 >>> 16 | 0) | 0;
    $40 = $10;
    $10 = ($10 >>> 0) / ($2 >>> 0) | 0;
    $9 = ($40 - Math_imul($10, $2) | 0) << 16 | 0 | ($9 & 65535 | 0) | 0;
    $11 = ($9 >>> 0) / ($2 >>> 0) | 0;
    HEAP32[$32 >> 2] = $11 | ($10 << 16 | 0) | 0;
    $9 = $9 - Math_imul($11, $2) | 0;
    $1 = $1 + -4 | 0;
    if ($1) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($3 + 24 | 0) >> 2] = $7;
  HEAP32[($3 + 20 | 0) >> 2] = $5;
  HEAP32[($3 + 16 | 0) >> 2] = $6;
  label$3 : {
   label$4 : {
    if ($7) {
     break label$4
    }
    $7 = 0;
    break label$3;
   }
   $2 = (($7 << 2 | 0) + $6 | 0) + -4 | 0;
   label$5 : {
    label$6 : while (1) {
     if (HEAP32[$2 >> 2] | 0) {
      break label$5
     }
     $2 = $2 + -4 | 0;
     $7 = $7 + -1 | 0;
     if ($7) {
      continue label$6
     }
     break label$6;
    };
    $7 = 0;
   }
   HEAP32[($3 + 24 | 0) >> 2] = $7;
  }
  label$7 : {
   if ($7 >>> 0 >= ($5 >>> 2 | 0) >>> 0) {
    break label$7
   }
   if ($5 >>> 0 <= $7 >>> 0) {
    break label$7
   }
   alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($3 + 16 | 0 | 0, $7 | 0);
  }
  HEAP32[($3 + 8 | 0) >> 2] = HEAP32[(($3 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($3 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($3 + 20 | 0) >> 2] | 0;
  $106 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[$3 >> 2] = $106;
  HEAP32[($3 + 4 | 0) >> 2] = i64toi32_i32$1;
  label$8 : {
   label$9 : {
    if (($4 & 255 | 0 | 0) == (1 | 0)) {
     break label$9
    }
    $2 = HEAP32[($3 + 8 | 0) >> 2] | 0 ? $4 : 1;
    break label$8;
   }
   $9 = 0;
   HEAP32[($3 + 8 | 0) >> 2] = 0;
   $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend__T_2ccore__slice__iter__Iter_T_____spec_extend__h5cdab7a667860bc4($3 | 0, 1082816 | 0, 1082816 | 0);
   label$10 : {
    $2 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if (!$2) {
     break label$10
    }
    $1 = (($2 << 2 | 0) + (HEAP32[$3 >> 2] | 0) | 0) + -4 | 0;
    label$11 : while (1) {
     label$12 : {
      if (!(HEAP32[$1 >> 2] | 0)) {
       break label$12
      }
      $9 = $2;
      break label$10;
     }
     $2 = $2 + -1 | 0;
     HEAP32[($3 + 8 | 0) >> 2] = $2;
     $1 = $1 + -4 | 0;
     if ($2) {
      continue label$11
     }
     break label$11;
    };
   }
   $2 = 1;
   $1 = HEAP32[($3 + 4 | 0) >> 2] | 0;
   if ($1 >>> 0 <= $9 >>> 0) {
    break label$8
   }
   if ($9 >>> 0 >= ($1 >>> 2 | 0) >>> 0) {
    break label$8
   }
   alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($3 | 0, $9 | 0);
  }
  HEAP8[($0 + 12 | 0) >> 0] = $2;
  i64toi32_i32$1 = HEAP32[$3 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($3 + 4 | 0) >> 2] | 0;
  $152 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $152;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[($3 + 8 | 0) >> 2] | 0;
  global$0 = $3 + 32 | 0;
 }
 
 function hashbrown__map__make_insert_hash__h652c972165b1bbd6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $8$hi = 0, $7$hi = 0, $7 = 0, $8 = 0, $9$hi = 0, $9 = 0, $10$hi = 0, $10 = 0, $11$hi = 0, $2 = 0, $11 = 0, $12$hi = 0, $12 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $93 = 0, $25 = 0, $30 = 0, $37 = 0, $45 = 0, $73 = 0, $73$hi = 0, $74 = 0, $74$hi = 0, $76$hi = 0, $81 = 0, $81$hi = 0, $87 = 0, $87$hi = 0, $92 = 0, $92$hi = 0, $96 = 0, $96$hi = 0, $99$hi = 0, $106 = 0, $106$hi = 0, $112 = 0, $112$hi = 0, $114 = 0, $114$hi = 0, $116$hi = 0, $122 = 0, $122$hi = 0, $128 = 0, $128$hi = 0, $131 = 0, $131$hi = 0, $132 = 0, $132$hi = 0, $134$hi = 0, $139 = 0, $139$hi = 0, $146 = 0, $146$hi = 0, $147 = 0, $147$hi = 0, $149$hi = 0, $154 = 0, $154$hi = 0, $161 = 0, $161$hi = 0, $162 = 0, $162$hi = 0, $164$hi = 0, $169 = 0, $169$hi = 0, $172$hi = 0, $174 = 0, $174$hi = 0, $176$hi = 0, $181 = 0, $181$hi = 0, $187$hi = 0, $94 = 0, $190 = 0, $190$hi = 0, $191 = 0, $191$hi = 0, $193 = 0, $193$hi = 0, $194 = 0, $194$hi = 0, $196 = 0, $196$hi = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  $3 = $2 + 64 | 0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = $2 + 48 | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = 1952801890;
  i64toi32_i32$3 = 2037671283;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $25 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $4;
  HEAP32[i64toi32_i32$2 >> 2] = $25;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  $5 = $2 + 40 | 0;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$1 = $7;
  i64toi32_i32$2 = 1685025377;
  i64toi32_i32$3 = 1852075885;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $30 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $5;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  $6 = $2 + 32 | 0;
  i64toi32_i32$0 = $0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$2;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$2 = 1819895653;
  i64toi32_i32$3 = 1852142177;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $37 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $6;
  HEAP32[i64toi32_i32$0 >> 2] = $37;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$0 = $2;
  i64toi32_i32$2 = 0;
  HEAP32[(i64toi32_i32$0 + 56 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 60 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$1 = $8;
  i64toi32_i32$0 = 1936682341;
  i64toi32_i32$3 = 1886610805;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $45 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $2;
  HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = $45;
  HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = i64toi32_i32$0;
  $0 = HEAP32[$1 >> 2] | 0;
  HEAP8[(i64toi32_i32$1 + 79 | 0) >> 0] = HEAPU8[$0 >> 0] | 0;
  $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_3(i64toi32_i32$1 + 8 | 0 | 0, i64toi32_i32$1 + 79 | 0 | 0, 1 | 0);
  $cardano_serialization_lib__address__StakeCredType_20as_20core__hash__Hash___hash__he9f79766a5c45cf6($0 + 1 | 0 | 0, i64toi32_i32$1 + 8 | 0 | 0);
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = 0;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $6;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $12 = i64toi32_i32$1;
  $12$hi = i64toi32_i32$0;
  global$0 = i64toi32_i32$2 + 80 | 0;
  i64toi32_i32$0 = $10$hi;
  $73 = $10;
  $73$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  $74 = $9;
  $74$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$2 = $8;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $93 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $93 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $76$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $74$hi;
  i64toi32_i32$0 = $74;
  i64toi32_i32$2 = $76$hi;
  i64toi32_i32$3 = $93;
  i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
  $8 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $73$hi;
  i64toi32_i32$1 = $73;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $9 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($9 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $81 = i64toi32_i32$1;
  $81$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$4;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $81$hi;
  i64toi32_i32$0 = $81;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$2;
  $87 = $10;
  $87$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$5 = $7;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $92 = i64toi32_i32$5;
  $92$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $87$hi;
  i64toi32_i32$2 = $87;
  i64toi32_i32$5 = $92$hi;
  i64toi32_i32$3 = $92;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $12 = i64toi32_i32$0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $96 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $96$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($7 | 0, i64toi32_i32$2 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $99$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$2 = $99$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $8 = i64toi32_i32$5;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 17 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $106 = i64toi32_i32$2;
  $106$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$2 = $106$hi;
  i64toi32_i32$3 = $106;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $96$hi;
  i64toi32_i32$0 = $96;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $112 = i64toi32_i32$0;
  $112$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = $112$hi;
  i64toi32_i32$3 = $112;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $7 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$0;
  $114 = $7;
  $114$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($10 | 0, i64toi32_i32$0 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $116$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$0 = $116$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $10$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($8 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 255;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $122 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $122$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$2 = $10;
  i64toi32_i32$0 = $122$hi;
  i64toi32_i32$3 = $122;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $8 = i64toi32_i32$4;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $114$hi;
  i64toi32_i32$5 = $114;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$0;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 17 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $128 = i64toi32_i32$5;
  $128$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$5 = $128$hi;
  i64toi32_i32$3 = $128;
  i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
  $7 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$5;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $131 = i64toi32_i32$1;
  $131$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  $132 = $7;
  $132$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$5 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $134$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $8$hi;
  i64toi32_i32$5 = $134$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $8 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($9 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $139 = i64toi32_i32$4;
  $139$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$5 = $8;
  i64toi32_i32$4 = $139$hi;
  i64toi32_i32$3 = $139;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $9 = i64toi32_i32$2;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $132$hi;
  i64toi32_i32$1 = $132;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$4;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $131$hi;
  i64toi32_i32$0 = $131;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($10 | 0, i64toi32_i32$1 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $146 = i64toi32_i32$0;
  $146$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $10$hi;
  $147 = $10;
  $147$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($8 | 0, i64toi32_i32$1 | 0, 21 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $149$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$1 = $149$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $8 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $154 = i64toi32_i32$2;
  $154$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$1 = $8;
  i64toi32_i32$2 = $154$hi;
  i64toi32_i32$3 = $154;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $9 = i64toi32_i32$5;
  $9$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $147$hi;
  i64toi32_i32$0 = $147;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $10 = i64toi32_i32$2;
  $10$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $146$hi;
  i64toi32_i32$4 = $146;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $11 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $161 = i64toi32_i32$4;
  $161$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  $162 = $11;
  $162$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($8 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $164$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $164$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $8 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $169 = i64toi32_i32$5;
  $169$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$0 = $8;
  i64toi32_i32$5 = $169$hi;
  i64toi32_i32$3 = $169;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$1;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $162$hi;
  i64toi32_i32$4 = $162;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $172$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $161$hi;
  i64toi32_i32$2 = $161;
  i64toi32_i32$4 = $172$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $9 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $9$hi = i64toi32_i32$4;
  $174 = $9;
  $174$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($8 | 0, i64toi32_i32$4 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $176$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$4 = $176$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $181 = i64toi32_i32$1;
  $181$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = $7;
  i64toi32_i32$1 = $181$hi;
  i64toi32_i32$3 = $181;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $174$hi;
  i64toi32_i32$2 = $174;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $10 = i64toi32_i32$1;
  $10$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $187$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$0 = $187$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $94 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($94 | 0, i64toi32_i32$2 | 0, 21 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $190 = i64toi32_i32$5;
  $190$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$5 = $190$hi;
  i64toi32_i32$3 = $190;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $191 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $191$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($9 | 0, i64toi32_i32$5 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $193 = i64toi32_i32$0;
  $193$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $191$hi;
  i64toi32_i32$2 = $191;
  i64toi32_i32$0 = $193$hi;
  i64toi32_i32$3 = $193;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $194 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $194$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $196 = i64toi32_i32$2;
  $196$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $194$hi;
  i64toi32_i32$5 = $194;
  i64toi32_i32$2 = $196$hi;
  i64toi32_i32$3 = $196;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$5 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$2;
  return i64toi32_i32$5 | 0;
 }
 
 function hashbrown__map__make_hash__hf66765788ec743b7($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $8$hi = 0, $7$hi = 0, $7 = 0, $8 = 0, $9$hi = 0, $9 = 0, $10$hi = 0, $10 = 0, $11$hi = 0, $2 = 0, $11 = 0, $12$hi = 0, $12 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $93 = 0, $25 = 0, $30 = 0, $37 = 0, $45 = 0, $73 = 0, $73$hi = 0, $74 = 0, $74$hi = 0, $76$hi = 0, $81 = 0, $81$hi = 0, $87 = 0, $87$hi = 0, $92 = 0, $92$hi = 0, $96 = 0, $96$hi = 0, $99$hi = 0, $106 = 0, $106$hi = 0, $112 = 0, $112$hi = 0, $114 = 0, $114$hi = 0, $116$hi = 0, $122 = 0, $122$hi = 0, $128 = 0, $128$hi = 0, $131 = 0, $131$hi = 0, $132 = 0, $132$hi = 0, $134$hi = 0, $139 = 0, $139$hi = 0, $146 = 0, $146$hi = 0, $147 = 0, $147$hi = 0, $149$hi = 0, $154 = 0, $154$hi = 0, $161 = 0, $161$hi = 0, $162 = 0, $162$hi = 0, $164$hi = 0, $169 = 0, $169$hi = 0, $172$hi = 0, $174 = 0, $174$hi = 0, $176$hi = 0, $181 = 0, $181$hi = 0, $187$hi = 0, $94 = 0, $190 = 0, $190$hi = 0, $191 = 0, $191$hi = 0, $193 = 0, $193$hi = 0, $194 = 0, $194$hi = 0, $196 = 0, $196$hi = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  $3 = $2 + 64 | 0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = $2 + 48 | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = 1952801890;
  i64toi32_i32$3 = 2037671283;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $25 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $4;
  HEAP32[i64toi32_i32$2 >> 2] = $25;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  $5 = $2 + 40 | 0;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$1 = $7;
  i64toi32_i32$2 = 1685025377;
  i64toi32_i32$3 = 1852075885;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $30 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $5;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  $6 = $2 + 32 | 0;
  i64toi32_i32$0 = $0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$2;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$2 = 1819895653;
  i64toi32_i32$3 = 1852142177;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $37 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $6;
  HEAP32[i64toi32_i32$0 >> 2] = $37;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$0 = $2;
  i64toi32_i32$2 = 0;
  HEAP32[(i64toi32_i32$0 + 56 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 60 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$1 = $8;
  i64toi32_i32$0 = 1936682341;
  i64toi32_i32$3 = 1886610805;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $45 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $2;
  HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = $45;
  HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = i64toi32_i32$0;
  $0 = HEAP32[$1 >> 2] | 0;
  HEAP8[(i64toi32_i32$1 + 79 | 0) >> 0] = HEAPU8[$0 >> 0] | 0;
  $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_3(i64toi32_i32$1 + 8 | 0 | 0, i64toi32_i32$1 + 79 | 0 | 0, 1 | 0);
  $cardano_serialization_lib__address__StakeCredType_20as_20core__hash__Hash___hash__he9f79766a5c45cf6($0 + 1 | 0 | 0, i64toi32_i32$1 + 8 | 0 | 0);
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = 0;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $6;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $12 = i64toi32_i32$1;
  $12$hi = i64toi32_i32$0;
  global$0 = i64toi32_i32$2 + 80 | 0;
  i64toi32_i32$0 = $10$hi;
  $73 = $10;
  $73$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  $74 = $9;
  $74$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$2 = $8;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $93 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $93 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $76$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $74$hi;
  i64toi32_i32$0 = $74;
  i64toi32_i32$2 = $76$hi;
  i64toi32_i32$3 = $93;
  i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
  $8 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $73$hi;
  i64toi32_i32$1 = $73;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $9 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($9 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $81 = i64toi32_i32$1;
  $81$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$4;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $81$hi;
  i64toi32_i32$0 = $81;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$2;
  $87 = $10;
  $87$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$5 = $7;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $92 = i64toi32_i32$5;
  $92$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $87$hi;
  i64toi32_i32$2 = $87;
  i64toi32_i32$5 = $92$hi;
  i64toi32_i32$3 = $92;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $12 = i64toi32_i32$0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $96 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $96$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($7 | 0, i64toi32_i32$2 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $99$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$2 = $99$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $8 = i64toi32_i32$5;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 17 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $106 = i64toi32_i32$2;
  $106$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$2 = $106$hi;
  i64toi32_i32$3 = $106;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $96$hi;
  i64toi32_i32$0 = $96;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $112 = i64toi32_i32$0;
  $112$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = $112$hi;
  i64toi32_i32$3 = $112;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $7 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$0;
  $114 = $7;
  $114$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($10 | 0, i64toi32_i32$0 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $116$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$0 = $116$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $10$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($8 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 255;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $122 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $122$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$2 = $10;
  i64toi32_i32$0 = $122$hi;
  i64toi32_i32$3 = $122;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $8 = i64toi32_i32$4;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $114$hi;
  i64toi32_i32$5 = $114;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$0;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 17 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $128 = i64toi32_i32$5;
  $128$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$5 = $128$hi;
  i64toi32_i32$3 = $128;
  i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
  $7 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$5;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $131 = i64toi32_i32$1;
  $131$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  $132 = $7;
  $132$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$5 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $134$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $8$hi;
  i64toi32_i32$5 = $134$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $8 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($9 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $139 = i64toi32_i32$4;
  $139$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$5 = $8;
  i64toi32_i32$4 = $139$hi;
  i64toi32_i32$3 = $139;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $9 = i64toi32_i32$2;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $132$hi;
  i64toi32_i32$1 = $132;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$4;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $131$hi;
  i64toi32_i32$0 = $131;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($10 | 0, i64toi32_i32$1 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $146 = i64toi32_i32$0;
  $146$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $10$hi;
  $147 = $10;
  $147$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($8 | 0, i64toi32_i32$1 | 0, 21 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $149$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$1 = $149$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $8 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $154 = i64toi32_i32$2;
  $154$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$1 = $8;
  i64toi32_i32$2 = $154$hi;
  i64toi32_i32$3 = $154;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $9 = i64toi32_i32$5;
  $9$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $147$hi;
  i64toi32_i32$0 = $147;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $10 = i64toi32_i32$2;
  $10$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $146$hi;
  i64toi32_i32$4 = $146;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $11 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $161 = i64toi32_i32$4;
  $161$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  $162 = $11;
  $162$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($8 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $164$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $164$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $8 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $169 = i64toi32_i32$5;
  $169$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$0 = $8;
  i64toi32_i32$5 = $169$hi;
  i64toi32_i32$3 = $169;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$1;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $162$hi;
  i64toi32_i32$4 = $162;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $172$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $161$hi;
  i64toi32_i32$2 = $161;
  i64toi32_i32$4 = $172$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $9 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $9$hi = i64toi32_i32$4;
  $174 = $9;
  $174$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($8 | 0, i64toi32_i32$4 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $176$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$4 = $176$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $181 = i64toi32_i32$1;
  $181$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = $7;
  i64toi32_i32$1 = $181$hi;
  i64toi32_i32$3 = $181;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $174$hi;
  i64toi32_i32$2 = $174;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $10 = i64toi32_i32$1;
  $10$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $187$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$0 = $187$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $94 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($94 | 0, i64toi32_i32$2 | 0, 21 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $190 = i64toi32_i32$5;
  $190$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$5 = $190$hi;
  i64toi32_i32$3 = $190;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $191 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $191$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($9 | 0, i64toi32_i32$5 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $193 = i64toi32_i32$0;
  $193$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $191$hi;
  i64toi32_i32$2 = $191;
  i64toi32_i32$0 = $193$hi;
  i64toi32_i32$3 = $193;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $194 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $194$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $196 = i64toi32_i32$2;
  $196$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $194$hi;
  i64toi32_i32$5 = $194;
  i64toi32_i32$2 = $196$hi;
  i64toi32_i32$3 = $196;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$5 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$2;
  return i64toi32_i32$5 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__TransactionInput___deserialize_as_embedded_group__h2a795770225d25a6($0, $1, $2, $2$hi, $3, $3$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, $9 = 0, $5 = 0, $6 = 0, $26 = 0, $27 = 0, $28 = 0, $29 = 0, $9$hi = 0, $7 = 0, $8 = 0, $33 = 0, $40 = 0, $57 = 0, $63 = 0, $69 = 0, $72 = 0, $84 = 0, $88 = 0, $92 = 0, $96 = 0;
  $4 = global$0 - 400 | 0;
  global$0 = $4;
  $cardano_serialization_lib__crypto__TransactionHash_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h74dbd8caac71b042($4 + 328 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    if ((HEAPU8[($4 + 328 | 0) >> 0] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    i64toi32_i32$2 = ($4 + 328 | 0) + 9 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $9 = i64toi32_i32$0;
    $9$hi = i64toi32_i32$1;
    i64toi32_i32$0 = ($4 + 184 | 0) + 9 | 0;
    HEAP8[i64toi32_i32$0 >> 0] = $9;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $9 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $9 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $9 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    $5 = ($4 + 40 | 0) + 24 | 0;
    i64toi32_i32$2 = $4 + 353 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $33 = i64toi32_i32$1;
    i64toi32_i32$1 = $5;
    HEAP32[i64toi32_i32$1 >> 2] = $33;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    $6 = ($4 + 40 | 0) + 16 | 0;
    i64toi32_i32$2 = $4 + 345 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $40 = i64toi32_i32$0;
    i64toi32_i32$0 = $6;
    HEAP32[i64toi32_i32$0 >> 2] = $40;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    $7 = ($4 + 40 | 0) + 8 | 0;
    i64toi32_i32$1 = $9$hi;
    i64toi32_i32$0 = $7;
    HEAP32[i64toi32_i32$0 >> 2] = $9;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 329 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 330 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 331 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 332 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 333 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 334 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 335 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 336 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $9 = i64toi32_i32$1;
    $9$hi = i64toi32_i32$0;
    i64toi32_i32$1 = i64toi32_i32$2;
    HEAP8[(i64toi32_i32$2 + 185 | 0) >> 0] = $9;
    HEAP8[(i64toi32_i32$2 + 186 | 0) >> 0] = $9 >>> 8 | 0;
    HEAP8[(i64toi32_i32$2 + 187 | 0) >> 0] = $9 >>> 16 | 0;
    HEAP8[(i64toi32_i32$2 + 188 | 0) >> 0] = $9 >>> 24 | 0;
    HEAP8[(i64toi32_i32$2 + 189 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$2 + 190 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$2 + 191 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$2 + 192 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$1 = i64toi32_i32$2;
    HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] = $9;
    HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] = i64toi32_i32$0;
    $8 = (i64toi32_i32$2 + 8 | 0) + 24 | 0;
    i64toi32_i32$2 = $5;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $57 = i64toi32_i32$0;
    i64toi32_i32$0 = $8;
    HEAP32[i64toi32_i32$0 >> 2] = $57;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    $5 = ($4 + 8 | 0) + 16 | 0;
    i64toi32_i32$2 = $6;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $63 = i64toi32_i32$1;
    i64toi32_i32$1 = $5;
    HEAP32[i64toi32_i32$1 >> 2] = $63;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    $6 = ($4 + 8 | 0) + 8 | 0;
    i64toi32_i32$2 = $7;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $69 = i64toi32_i32$0;
    i64toi32_i32$0 = $6;
    HEAP32[i64toi32_i32$0 >> 2] = $69;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] | 0;
    $72 = i64toi32_i32$1;
    i64toi32_i32$1 = i64toi32_i32$2;
    HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $72;
    HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$0;
    $T_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hf422f9333a8bbafa(i64toi32_i32$2 + 328 | 0 | 0, $1 | 0);
    label$3 : {
     if ((HEAP32[(i64toi32_i32$2 + 328 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     $1 = HEAP32[($4 + 332 | 0) >> 2] | 0;
     i64toi32_i32$2 = $8;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $84 = i64toi32_i32$0;
     i64toi32_i32$0 = $0 + 32 | 0;
     $26 = $84;
     HEAP8[i64toi32_i32$0 >> 0] = $26;
     HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $26 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $26 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $26 >>> 24 | 0;
     HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
     HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
     i64toi32_i32$2 = $5;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $88 = i64toi32_i32$1;
     i64toi32_i32$1 = $0 + 24 | 0;
     $27 = $88;
     HEAP8[i64toi32_i32$1 >> 0] = $27;
     HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $27 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $27 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $27 >>> 24 | 0;
     HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
     HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
     i64toi32_i32$2 = $6;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $92 = i64toi32_i32$0;
     i64toi32_i32$0 = $0 + 16 | 0;
     $28 = $92;
     HEAP8[i64toi32_i32$0 >> 0] = $28;
     HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $28 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $28 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $28 >>> 24 | 0;
     HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
     HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
     i64toi32_i32$2 = $4;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
     $96 = i64toi32_i32$1;
     i64toi32_i32$1 = $0 + 8 | 0;
     $29 = $96;
     HEAP8[i64toi32_i32$1 >> 0] = $29;
     HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $29 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $29 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $29 >>> 24 | 0;
     HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
     HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
     HEAP32[($0 + 4 | 0) >> 2] = $1;
     HEAP32[$0 >> 2] = 0;
     break label$1;
    }
    memcpy($4 + 256 | 0 | 0, ($4 + 328 | 0) + 8 | 0 | 0, 64 | 0) | 0;
    memcpy($4 + 328 | 0 | 0, $4 + 256 | 0 | 0, 64 | 0) | 0;
    $1 = ($4 + 184 | 0) + 8 | 0;
    cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 328 | 0 | 0, 1050632 | 0, 5 | 0);
    memcpy($0 + 8 | 0 | 0, $1 | 0, 64 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    break label$1;
   }
   memcpy($4 + 328 | 0 | 0, memcpy($4 + 112 | 0 | 7 | 0 | 0, memcpy($4 + 256 | 0 | 7 | 0 | 0, ($4 + 328 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   $1 = ($4 + 184 | 0) + 8 | 0;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 328 | 0 | 0, 1050618 | 0, 14 | 0);
   memcpy($0 + 8 | 0 | 0, memcpy($4 + 40 | 0 | 7 | 0 | 0, $1 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $4 + 400 | 0;
 }
 
 function hashbrown__map__make_insert_hash__h1511e6cd27b8f68b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $8$hi = 0, $7$hi = 0, $7 = 0, $8 = 0, $9$hi = 0, $9 = 0, $10$hi = 0, $10 = 0, $11$hi = 0, $2 = 0, $11 = 0, $12$hi = 0, $12 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $92 = 0, $25 = 0, $30 = 0, $37 = 0, $45 = 0, $70 = 0, $70$hi = 0, $71 = 0, $71$hi = 0, $73$hi = 0, $78 = 0, $78$hi = 0, $84 = 0, $84$hi = 0, $89 = 0, $89$hi = 0, $93 = 0, $93$hi = 0, $96$hi = 0, $103 = 0, $103$hi = 0, $109 = 0, $109$hi = 0, $111 = 0, $111$hi = 0, $113$hi = 0, $119 = 0, $119$hi = 0, $125 = 0, $125$hi = 0, $128 = 0, $128$hi = 0, $129 = 0, $129$hi = 0, $131$hi = 0, $136 = 0, $136$hi = 0, $143 = 0, $143$hi = 0, $144 = 0, $144$hi = 0, $146$hi = 0, $151 = 0, $151$hi = 0, $158 = 0, $158$hi = 0, $159 = 0, $159$hi = 0, $161$hi = 0, $166 = 0, $166$hi = 0, $169$hi = 0, $171 = 0, $171$hi = 0, $173$hi = 0, $178 = 0, $178$hi = 0, $184$hi = 0, $94 = 0, $187 = 0, $187$hi = 0, $188 = 0, $188$hi = 0, $190 = 0, $190$hi = 0, $191 = 0, $191$hi = 0, $193 = 0, $193$hi = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  $3 = $2 + 64 | 0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = $2 + 48 | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = 1952801890;
  i64toi32_i32$3 = 2037671283;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $25 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $4;
  HEAP32[i64toi32_i32$2 >> 2] = $25;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  $5 = $2 + 40 | 0;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$1 = $7;
  i64toi32_i32$2 = 1685025377;
  i64toi32_i32$3 = 1852075885;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $30 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $5;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  $6 = $2 + 32 | 0;
  i64toi32_i32$0 = $0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$2;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$2 = 1819895653;
  i64toi32_i32$3 = 1852142177;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $37 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $6;
  HEAP32[i64toi32_i32$0 >> 2] = $37;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$0 = $2;
  i64toi32_i32$2 = 0;
  HEAP32[(i64toi32_i32$0 + 56 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 60 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$1 = $8;
  i64toi32_i32$0 = 1936682341;
  i64toi32_i32$3 = 1886610805;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $45 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $2;
  HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = $45;
  HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = i64toi32_i32$0;
  $0 = HEAP32[$1 >> 2] | 0;
  HEAP32[(i64toi32_i32$1 + 76 | 0) >> 2] = 28;
  $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_2(i64toi32_i32$1 + 8 | 0 | 0, i64toi32_i32$1 + 76 | 0 | 0, 4 | 0);
  $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_2(i64toi32_i32$1 + 8 | 0 | 0, $0 | 0, 28 | 0);
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = 0;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $6;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $12 = i64toi32_i32$1;
  $12$hi = i64toi32_i32$0;
  global$0 = i64toi32_i32$2 + 80 | 0;
  i64toi32_i32$0 = $10$hi;
  $70 = $10;
  $70$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  $71 = $9;
  $71$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$2 = $8;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $92 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $92 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $73$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $71$hi;
  i64toi32_i32$0 = $71;
  i64toi32_i32$2 = $73$hi;
  i64toi32_i32$3 = $92;
  i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
  $8 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $70$hi;
  i64toi32_i32$1 = $70;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $9 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($9 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $78 = i64toi32_i32$1;
  $78$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$4;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $78$hi;
  i64toi32_i32$0 = $78;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$2;
  $84 = $10;
  $84$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$5 = $7;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $89 = i64toi32_i32$5;
  $89$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $84$hi;
  i64toi32_i32$2 = $84;
  i64toi32_i32$5 = $89$hi;
  i64toi32_i32$3 = $89;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $12 = i64toi32_i32$0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $93 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $93$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($7 | 0, i64toi32_i32$2 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $96$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$2 = $96$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $8 = i64toi32_i32$5;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 17 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $103 = i64toi32_i32$2;
  $103$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$2 = $103$hi;
  i64toi32_i32$3 = $103;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $93$hi;
  i64toi32_i32$0 = $93;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $109 = i64toi32_i32$0;
  $109$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = $109$hi;
  i64toi32_i32$3 = $109;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $7 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$0;
  $111 = $7;
  $111$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($10 | 0, i64toi32_i32$0 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $113$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$0 = $113$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $10$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($8 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 255;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $119 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $119$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$2 = $10;
  i64toi32_i32$0 = $119$hi;
  i64toi32_i32$3 = $119;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $8 = i64toi32_i32$4;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $111$hi;
  i64toi32_i32$5 = $111;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$0;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 17 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $125 = i64toi32_i32$5;
  $125$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$5 = $125$hi;
  i64toi32_i32$3 = $125;
  i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
  $7 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$5;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $128 = i64toi32_i32$1;
  $128$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  $129 = $7;
  $129$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$5 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $131$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $8$hi;
  i64toi32_i32$5 = $131$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $8 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($9 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $136 = i64toi32_i32$4;
  $136$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$5 = $8;
  i64toi32_i32$4 = $136$hi;
  i64toi32_i32$3 = $136;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $9 = i64toi32_i32$2;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $129$hi;
  i64toi32_i32$1 = $129;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$4;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $128$hi;
  i64toi32_i32$0 = $128;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($10 | 0, i64toi32_i32$1 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $143 = i64toi32_i32$0;
  $143$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $10$hi;
  $144 = $10;
  $144$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($8 | 0, i64toi32_i32$1 | 0, 21 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $146$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$1 = $146$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $8 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $151 = i64toi32_i32$2;
  $151$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$1 = $8;
  i64toi32_i32$2 = $151$hi;
  i64toi32_i32$3 = $151;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $9 = i64toi32_i32$5;
  $9$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $144$hi;
  i64toi32_i32$0 = $144;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $10 = i64toi32_i32$2;
  $10$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $143$hi;
  i64toi32_i32$4 = $143;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $11 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $158 = i64toi32_i32$4;
  $158$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  $159 = $11;
  $159$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($8 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $161$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $161$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $8 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $166 = i64toi32_i32$5;
  $166$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$0 = $8;
  i64toi32_i32$5 = $166$hi;
  i64toi32_i32$3 = $166;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$1;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $159$hi;
  i64toi32_i32$4 = $159;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $169$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $158$hi;
  i64toi32_i32$2 = $158;
  i64toi32_i32$4 = $169$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $9 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $9$hi = i64toi32_i32$4;
  $171 = $9;
  $171$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($8 | 0, i64toi32_i32$4 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $173$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$4 = $173$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $178 = i64toi32_i32$1;
  $178$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = $7;
  i64toi32_i32$1 = $178$hi;
  i64toi32_i32$3 = $178;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $171$hi;
  i64toi32_i32$2 = $171;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $10 = i64toi32_i32$1;
  $10$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $184$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$0 = $184$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $94 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($94 | 0, i64toi32_i32$2 | 0, 21 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $187 = i64toi32_i32$5;
  $187$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$5 = $187$hi;
  i64toi32_i32$3 = $187;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $188 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $188$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($9 | 0, i64toi32_i32$5 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $190 = i64toi32_i32$0;
  $190$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $188$hi;
  i64toi32_i32$2 = $188;
  i64toi32_i32$0 = $190$hi;
  i64toi32_i32$3 = $190;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $191 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $191$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $193 = i64toi32_i32$2;
  $193$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $191$hi;
  i64toi32_i32$5 = $191;
  i64toi32_i32$2 = $193$hi;
  i64toi32_i32$3 = $193;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$5 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$2;
  return i64toi32_i32$5 | 0;
 }
 
 function hashbrown__map__make_insert_hash__h2b8264a344d2c281($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $8$hi = 0, $7$hi = 0, $7 = 0, $8 = 0, $9$hi = 0, $9 = 0, $10$hi = 0, $10 = 0, $11$hi = 0, $2 = 0, $11 = 0, $12$hi = 0, $12 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $92 = 0, $25 = 0, $30 = 0, $37 = 0, $45 = 0, $70 = 0, $70$hi = 0, $71 = 0, $71$hi = 0, $73$hi = 0, $78 = 0, $78$hi = 0, $84 = 0, $84$hi = 0, $89 = 0, $89$hi = 0, $93 = 0, $93$hi = 0, $96$hi = 0, $103 = 0, $103$hi = 0, $109 = 0, $109$hi = 0, $111 = 0, $111$hi = 0, $113$hi = 0, $119 = 0, $119$hi = 0, $125 = 0, $125$hi = 0, $128 = 0, $128$hi = 0, $129 = 0, $129$hi = 0, $131$hi = 0, $136 = 0, $136$hi = 0, $143 = 0, $143$hi = 0, $144 = 0, $144$hi = 0, $146$hi = 0, $151 = 0, $151$hi = 0, $158 = 0, $158$hi = 0, $159 = 0, $159$hi = 0, $161$hi = 0, $166 = 0, $166$hi = 0, $169$hi = 0, $171 = 0, $171$hi = 0, $173$hi = 0, $178 = 0, $178$hi = 0, $184$hi = 0, $94 = 0, $187 = 0, $187$hi = 0, $188 = 0, $188$hi = 0, $190 = 0, $190$hi = 0, $191 = 0, $191$hi = 0, $193 = 0, $193$hi = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  $3 = $2 + 64 | 0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = $2 + 48 | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = 1952801890;
  i64toi32_i32$3 = 2037671283;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $25 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $4;
  HEAP32[i64toi32_i32$2 >> 2] = $25;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  $5 = $2 + 40 | 0;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$1 = $7;
  i64toi32_i32$2 = 1685025377;
  i64toi32_i32$3 = 1852075885;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $30 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $5;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  $6 = $2 + 32 | 0;
  i64toi32_i32$0 = $0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$2;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$2 = 1819895653;
  i64toi32_i32$3 = 1852142177;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $37 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $6;
  HEAP32[i64toi32_i32$0 >> 2] = $37;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$0 = $2;
  i64toi32_i32$2 = 0;
  HEAP32[(i64toi32_i32$0 + 56 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 60 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$1 = $8;
  i64toi32_i32$0 = 1936682341;
  i64toi32_i32$3 = 1886610805;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $45 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $2;
  HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = $45;
  HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = i64toi32_i32$0;
  $0 = HEAP32[$1 >> 2] | 0;
  HEAP32[(i64toi32_i32$1 + 76 | 0) >> 2] = 28;
  $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_2(i64toi32_i32$1 + 8 | 0 | 0, i64toi32_i32$1 + 76 | 0 | 0, 4 | 0);
  $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_2(i64toi32_i32$1 + 8 | 0 | 0, $0 | 0, 28 | 0);
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = 0;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $6;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $12 = i64toi32_i32$1;
  $12$hi = i64toi32_i32$0;
  global$0 = i64toi32_i32$2 + 80 | 0;
  i64toi32_i32$0 = $10$hi;
  $70 = $10;
  $70$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  $71 = $9;
  $71$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$2 = $8;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $92 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $92 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $73$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $71$hi;
  i64toi32_i32$0 = $71;
  i64toi32_i32$2 = $73$hi;
  i64toi32_i32$3 = $92;
  i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
  $8 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $70$hi;
  i64toi32_i32$1 = $70;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $9 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($9 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $78 = i64toi32_i32$1;
  $78$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$4;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $78$hi;
  i64toi32_i32$0 = $78;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$2;
  $84 = $10;
  $84$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$5 = $7;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $89 = i64toi32_i32$5;
  $89$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $84$hi;
  i64toi32_i32$2 = $84;
  i64toi32_i32$5 = $89$hi;
  i64toi32_i32$3 = $89;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $12 = i64toi32_i32$0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $93 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $93$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($7 | 0, i64toi32_i32$2 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $96$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$2 = $96$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $8 = i64toi32_i32$5;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 17 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $103 = i64toi32_i32$2;
  $103$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$2 = $103$hi;
  i64toi32_i32$3 = $103;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $93$hi;
  i64toi32_i32$0 = $93;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $109 = i64toi32_i32$0;
  $109$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = $109$hi;
  i64toi32_i32$3 = $109;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $7 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$0;
  $111 = $7;
  $111$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($10 | 0, i64toi32_i32$0 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $113$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$0 = $113$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $10$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($8 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 255;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $119 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $119$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$2 = $10;
  i64toi32_i32$0 = $119$hi;
  i64toi32_i32$3 = $119;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $8 = i64toi32_i32$4;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $111$hi;
  i64toi32_i32$5 = $111;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$0;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 17 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $125 = i64toi32_i32$5;
  $125$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$5 = $125$hi;
  i64toi32_i32$3 = $125;
  i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
  $7 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$5;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $128 = i64toi32_i32$1;
  $128$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  $129 = $7;
  $129$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$5 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $131$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $8$hi;
  i64toi32_i32$5 = $131$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $8 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($9 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $136 = i64toi32_i32$4;
  $136$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$5 = $8;
  i64toi32_i32$4 = $136$hi;
  i64toi32_i32$3 = $136;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $9 = i64toi32_i32$2;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $129$hi;
  i64toi32_i32$1 = $129;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$4;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $128$hi;
  i64toi32_i32$0 = $128;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($10 | 0, i64toi32_i32$1 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $143 = i64toi32_i32$0;
  $143$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $10$hi;
  $144 = $10;
  $144$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($8 | 0, i64toi32_i32$1 | 0, 21 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $146$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$1 = $146$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $8 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $151 = i64toi32_i32$2;
  $151$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$1 = $8;
  i64toi32_i32$2 = $151$hi;
  i64toi32_i32$3 = $151;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $9 = i64toi32_i32$5;
  $9$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $144$hi;
  i64toi32_i32$0 = $144;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $10 = i64toi32_i32$2;
  $10$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $143$hi;
  i64toi32_i32$4 = $143;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $11 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $158 = i64toi32_i32$4;
  $158$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  $159 = $11;
  $159$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($8 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $161$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $161$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $8 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $166 = i64toi32_i32$5;
  $166$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$0 = $8;
  i64toi32_i32$5 = $166$hi;
  i64toi32_i32$3 = $166;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$1;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $159$hi;
  i64toi32_i32$4 = $159;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $169$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $158$hi;
  i64toi32_i32$2 = $158;
  i64toi32_i32$4 = $169$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $9 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $9$hi = i64toi32_i32$4;
  $171 = $9;
  $171$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($8 | 0, i64toi32_i32$4 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $173$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$4 = $173$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $178 = i64toi32_i32$1;
  $178$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = $7;
  i64toi32_i32$1 = $178$hi;
  i64toi32_i32$3 = $178;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $171$hi;
  i64toi32_i32$2 = $171;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $10 = i64toi32_i32$1;
  $10$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $184$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$0 = $184$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $94 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($94 | 0, i64toi32_i32$2 | 0, 21 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $187 = i64toi32_i32$5;
  $187$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$5 = $187$hi;
  i64toi32_i32$3 = $187;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $188 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $188$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($9 | 0, i64toi32_i32$5 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $190 = i64toi32_i32$0;
  $190$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $188$hi;
  i64toi32_i32$2 = $188;
  i64toi32_i32$0 = $190$hi;
  i64toi32_i32$3 = $190;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $191 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $191$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $193 = i64toi32_i32$2;
  $193$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $191$hi;
  i64toi32_i32$5 = $191;
  i64toi32_i32$2 = $193$hi;
  i64toi32_i32$3 = $193;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$5 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$2;
  return i64toi32_i32$5 | 0;
 }
 
 function hashbrown__map__make_hash__h16f0f4baf07b5eeb($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $8$hi = 0, $7$hi = 0, $7 = 0, $8 = 0, $9$hi = 0, $9 = 0, $10$hi = 0, $10 = 0, $11$hi = 0, $2 = 0, $11 = 0, $12$hi = 0, $12 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $92 = 0, $25 = 0, $30 = 0, $37 = 0, $45 = 0, $70 = 0, $70$hi = 0, $71 = 0, $71$hi = 0, $73$hi = 0, $78 = 0, $78$hi = 0, $84 = 0, $84$hi = 0, $89 = 0, $89$hi = 0, $93 = 0, $93$hi = 0, $96$hi = 0, $103 = 0, $103$hi = 0, $109 = 0, $109$hi = 0, $111 = 0, $111$hi = 0, $113$hi = 0, $119 = 0, $119$hi = 0, $125 = 0, $125$hi = 0, $128 = 0, $128$hi = 0, $129 = 0, $129$hi = 0, $131$hi = 0, $136 = 0, $136$hi = 0, $143 = 0, $143$hi = 0, $144 = 0, $144$hi = 0, $146$hi = 0, $151 = 0, $151$hi = 0, $158 = 0, $158$hi = 0, $159 = 0, $159$hi = 0, $161$hi = 0, $166 = 0, $166$hi = 0, $169$hi = 0, $171 = 0, $171$hi = 0, $173$hi = 0, $178 = 0, $178$hi = 0, $184$hi = 0, $94 = 0, $187 = 0, $187$hi = 0, $188 = 0, $188$hi = 0, $190 = 0, $190$hi = 0, $191 = 0, $191$hi = 0, $193 = 0, $193$hi = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  $3 = $2 + 64 | 0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = $2 + 48 | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = 1952801890;
  i64toi32_i32$3 = 2037671283;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $25 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $4;
  HEAP32[i64toi32_i32$2 >> 2] = $25;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  $5 = $2 + 40 | 0;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$1 = $7;
  i64toi32_i32$2 = 1685025377;
  i64toi32_i32$3 = 1852075885;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $30 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $5;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  $6 = $2 + 32 | 0;
  i64toi32_i32$0 = $0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$2;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$2 = 1819895653;
  i64toi32_i32$3 = 1852142177;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $37 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $6;
  HEAP32[i64toi32_i32$0 >> 2] = $37;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$0 = $2;
  i64toi32_i32$2 = 0;
  HEAP32[(i64toi32_i32$0 + 56 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 60 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$1 = $8;
  i64toi32_i32$0 = 1936682341;
  i64toi32_i32$3 = 1886610805;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $45 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $2;
  HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = $45;
  HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = i64toi32_i32$0;
  $0 = HEAP32[$1 >> 2] | 0;
  HEAP32[(i64toi32_i32$1 + 76 | 0) >> 2] = 28;
  $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_2(i64toi32_i32$1 + 8 | 0 | 0, i64toi32_i32$1 + 76 | 0 | 0, 4 | 0);
  $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_2(i64toi32_i32$1 + 8 | 0 | 0, $0 | 0, 28 | 0);
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = 0;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $6;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $12 = i64toi32_i32$1;
  $12$hi = i64toi32_i32$0;
  global$0 = i64toi32_i32$2 + 80 | 0;
  i64toi32_i32$0 = $10$hi;
  $70 = $10;
  $70$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  $71 = $9;
  $71$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$2 = $8;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $92 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $92 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $73$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $71$hi;
  i64toi32_i32$0 = $71;
  i64toi32_i32$2 = $73$hi;
  i64toi32_i32$3 = $92;
  i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
  $8 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $70$hi;
  i64toi32_i32$1 = $70;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $9 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($9 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $78 = i64toi32_i32$1;
  $78$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$4;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $78$hi;
  i64toi32_i32$0 = $78;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$2;
  $84 = $10;
  $84$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$5 = $7;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $89 = i64toi32_i32$5;
  $89$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $84$hi;
  i64toi32_i32$2 = $84;
  i64toi32_i32$5 = $89$hi;
  i64toi32_i32$3 = $89;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $12 = i64toi32_i32$0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $93 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $93$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($7 | 0, i64toi32_i32$2 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $96$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$2 = $96$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $8 = i64toi32_i32$5;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 17 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $103 = i64toi32_i32$2;
  $103$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$2 = $103$hi;
  i64toi32_i32$3 = $103;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $93$hi;
  i64toi32_i32$0 = $93;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $109 = i64toi32_i32$0;
  $109$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = $109$hi;
  i64toi32_i32$3 = $109;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $7 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$0;
  $111 = $7;
  $111$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($10 | 0, i64toi32_i32$0 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $113$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$0 = $113$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $10$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($8 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 255;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $119 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $119$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$2 = $10;
  i64toi32_i32$0 = $119$hi;
  i64toi32_i32$3 = $119;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $8 = i64toi32_i32$4;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $111$hi;
  i64toi32_i32$5 = $111;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$0;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 17 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $125 = i64toi32_i32$5;
  $125$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$5 = $125$hi;
  i64toi32_i32$3 = $125;
  i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
  $7 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$5;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $128 = i64toi32_i32$1;
  $128$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  $129 = $7;
  $129$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$5 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $131$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $8$hi;
  i64toi32_i32$5 = $131$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $8 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($9 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $136 = i64toi32_i32$4;
  $136$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$5 = $8;
  i64toi32_i32$4 = $136$hi;
  i64toi32_i32$3 = $136;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $9 = i64toi32_i32$2;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $129$hi;
  i64toi32_i32$1 = $129;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$4;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $128$hi;
  i64toi32_i32$0 = $128;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($10 | 0, i64toi32_i32$1 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $143 = i64toi32_i32$0;
  $143$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $10$hi;
  $144 = $10;
  $144$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($8 | 0, i64toi32_i32$1 | 0, 21 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $146$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$1 = $146$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $8 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $151 = i64toi32_i32$2;
  $151$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$1 = $8;
  i64toi32_i32$2 = $151$hi;
  i64toi32_i32$3 = $151;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $9 = i64toi32_i32$5;
  $9$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $144$hi;
  i64toi32_i32$0 = $144;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $10 = i64toi32_i32$2;
  $10$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $143$hi;
  i64toi32_i32$4 = $143;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $11 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $158 = i64toi32_i32$4;
  $158$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  $159 = $11;
  $159$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($8 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $161$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $161$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $8 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $166 = i64toi32_i32$5;
  $166$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$0 = $8;
  i64toi32_i32$5 = $166$hi;
  i64toi32_i32$3 = $166;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$1;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $159$hi;
  i64toi32_i32$4 = $159;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $169$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $158$hi;
  i64toi32_i32$2 = $158;
  i64toi32_i32$4 = $169$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $9 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $9$hi = i64toi32_i32$4;
  $171 = $9;
  $171$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($8 | 0, i64toi32_i32$4 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $173$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$4 = $173$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $178 = i64toi32_i32$1;
  $178$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = $7;
  i64toi32_i32$1 = $178$hi;
  i64toi32_i32$3 = $178;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $171$hi;
  i64toi32_i32$2 = $171;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $10 = i64toi32_i32$1;
  $10$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $184$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$0 = $184$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $94 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($94 | 0, i64toi32_i32$2 | 0, 21 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $187 = i64toi32_i32$5;
  $187$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$5 = $187$hi;
  i64toi32_i32$3 = $187;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $188 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $188$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($9 | 0, i64toi32_i32$5 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $190 = i64toi32_i32$0;
  $190$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $188$hi;
  i64toi32_i32$2 = $188;
  i64toi32_i32$0 = $190$hi;
  i64toi32_i32$3 = $190;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $191 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $191$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $193 = i64toi32_i32$2;
  $193$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $191$hi;
  i64toi32_i32$5 = $191;
  i64toi32_i32$2 = $193$hi;
  i64toi32_i32$3 = $193;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$5 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$2;
  return i64toi32_i32$5 | 0;
 }
 
 function hashbrown__map__make_hash__h5f7c8b88d87207db($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $8$hi = 0, $7$hi = 0, $7 = 0, $8 = 0, $9$hi = 0, $9 = 0, $10$hi = 0, $10 = 0, $11$hi = 0, $2 = 0, $11 = 0, $12$hi = 0, $12 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $92 = 0, $25 = 0, $30 = 0, $37 = 0, $45 = 0, $70 = 0, $70$hi = 0, $71 = 0, $71$hi = 0, $73$hi = 0, $78 = 0, $78$hi = 0, $84 = 0, $84$hi = 0, $89 = 0, $89$hi = 0, $93 = 0, $93$hi = 0, $96$hi = 0, $103 = 0, $103$hi = 0, $109 = 0, $109$hi = 0, $111 = 0, $111$hi = 0, $113$hi = 0, $119 = 0, $119$hi = 0, $125 = 0, $125$hi = 0, $128 = 0, $128$hi = 0, $129 = 0, $129$hi = 0, $131$hi = 0, $136 = 0, $136$hi = 0, $143 = 0, $143$hi = 0, $144 = 0, $144$hi = 0, $146$hi = 0, $151 = 0, $151$hi = 0, $158 = 0, $158$hi = 0, $159 = 0, $159$hi = 0, $161$hi = 0, $166 = 0, $166$hi = 0, $169$hi = 0, $171 = 0, $171$hi = 0, $173$hi = 0, $178 = 0, $178$hi = 0, $184$hi = 0, $94 = 0, $187 = 0, $187$hi = 0, $188 = 0, $188$hi = 0, $190 = 0, $190$hi = 0, $191 = 0, $191$hi = 0, $193 = 0, $193$hi = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  $3 = $2 + 64 | 0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = $2 + 48 | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = 1952801890;
  i64toi32_i32$3 = 2037671283;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $25 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $4;
  HEAP32[i64toi32_i32$2 >> 2] = $25;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  $5 = $2 + 40 | 0;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$1 = $7;
  i64toi32_i32$2 = 1685025377;
  i64toi32_i32$3 = 1852075885;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $30 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $5;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  $6 = $2 + 32 | 0;
  i64toi32_i32$0 = $0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$2;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$2 = 1819895653;
  i64toi32_i32$3 = 1852142177;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $37 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $6;
  HEAP32[i64toi32_i32$0 >> 2] = $37;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$0 = $2;
  i64toi32_i32$2 = 0;
  HEAP32[(i64toi32_i32$0 + 56 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 60 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$1 = $8;
  i64toi32_i32$0 = 1936682341;
  i64toi32_i32$3 = 1886610805;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $45 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $2;
  HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = $45;
  HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = i64toi32_i32$0;
  $0 = HEAP32[$1 >> 2] | 0;
  HEAP32[(i64toi32_i32$1 + 76 | 0) >> 2] = 28;
  $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_2(i64toi32_i32$1 + 8 | 0 | 0, i64toi32_i32$1 + 76 | 0 | 0, 4 | 0);
  $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_2(i64toi32_i32$1 + 8 | 0 | 0, $0 | 0, 28 | 0);
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = 0;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $6;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $12 = i64toi32_i32$1;
  $12$hi = i64toi32_i32$0;
  global$0 = i64toi32_i32$2 + 80 | 0;
  i64toi32_i32$0 = $10$hi;
  $70 = $10;
  $70$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  $71 = $9;
  $71$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$2 = $8;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $92 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $92 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $73$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $71$hi;
  i64toi32_i32$0 = $71;
  i64toi32_i32$2 = $73$hi;
  i64toi32_i32$3 = $92;
  i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
  $8 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $70$hi;
  i64toi32_i32$1 = $70;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $9 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($9 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $78 = i64toi32_i32$1;
  $78$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$4;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $78$hi;
  i64toi32_i32$0 = $78;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$2;
  $84 = $10;
  $84$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$5 = $7;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $89 = i64toi32_i32$5;
  $89$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $84$hi;
  i64toi32_i32$2 = $84;
  i64toi32_i32$5 = $89$hi;
  i64toi32_i32$3 = $89;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $12 = i64toi32_i32$0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $93 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $93$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($7 | 0, i64toi32_i32$2 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $96$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$2 = $96$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $8 = i64toi32_i32$5;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 17 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $103 = i64toi32_i32$2;
  $103$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$2 = $103$hi;
  i64toi32_i32$3 = $103;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $93$hi;
  i64toi32_i32$0 = $93;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $109 = i64toi32_i32$0;
  $109$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = $109$hi;
  i64toi32_i32$3 = $109;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $7 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$0;
  $111 = $7;
  $111$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($10 | 0, i64toi32_i32$0 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $113$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$0 = $113$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $10$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($8 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 255;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $119 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $119$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$2 = $10;
  i64toi32_i32$0 = $119$hi;
  i64toi32_i32$3 = $119;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $8 = i64toi32_i32$4;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $111$hi;
  i64toi32_i32$5 = $111;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$0;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 17 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $125 = i64toi32_i32$5;
  $125$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$5 = $125$hi;
  i64toi32_i32$3 = $125;
  i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
  $7 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$5;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $128 = i64toi32_i32$1;
  $128$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  $129 = $7;
  $129$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$5 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $131$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $8$hi;
  i64toi32_i32$5 = $131$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $8 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($9 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $136 = i64toi32_i32$4;
  $136$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$5 = $8;
  i64toi32_i32$4 = $136$hi;
  i64toi32_i32$3 = $136;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $9 = i64toi32_i32$2;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $129$hi;
  i64toi32_i32$1 = $129;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$4;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $128$hi;
  i64toi32_i32$0 = $128;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($10 | 0, i64toi32_i32$1 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $143 = i64toi32_i32$0;
  $143$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $10$hi;
  $144 = $10;
  $144$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($8 | 0, i64toi32_i32$1 | 0, 21 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $146$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$1 = $146$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $8 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $151 = i64toi32_i32$2;
  $151$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$1 = $8;
  i64toi32_i32$2 = $151$hi;
  i64toi32_i32$3 = $151;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $9 = i64toi32_i32$5;
  $9$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $144$hi;
  i64toi32_i32$0 = $144;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $10 = i64toi32_i32$2;
  $10$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $143$hi;
  i64toi32_i32$4 = $143;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $11 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $158 = i64toi32_i32$4;
  $158$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  $159 = $11;
  $159$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($8 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $161$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $161$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $8 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $166 = i64toi32_i32$5;
  $166$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$0 = $8;
  i64toi32_i32$5 = $166$hi;
  i64toi32_i32$3 = $166;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$1;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $159$hi;
  i64toi32_i32$4 = $159;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $169$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $158$hi;
  i64toi32_i32$2 = $158;
  i64toi32_i32$4 = $169$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $9 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $9$hi = i64toi32_i32$4;
  $171 = $9;
  $171$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($8 | 0, i64toi32_i32$4 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $173$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$4 = $173$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $178 = i64toi32_i32$1;
  $178$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = $7;
  i64toi32_i32$1 = $178$hi;
  i64toi32_i32$3 = $178;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $171$hi;
  i64toi32_i32$2 = $171;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $10 = i64toi32_i32$1;
  $10$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $184$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$0 = $184$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $94 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($94 | 0, i64toi32_i32$2 | 0, 21 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $187 = i64toi32_i32$5;
  $187$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$5 = $187$hi;
  i64toi32_i32$3 = $187;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $188 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $188$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($9 | 0, i64toi32_i32$5 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $190 = i64toi32_i32$0;
  $190$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $188$hi;
  i64toi32_i32$2 = $188;
  i64toi32_i32$0 = $190$hi;
  i64toi32_i32$3 = $190;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $191 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $191$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $193 = i64toi32_i32$2;
  $193$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $191$hi;
  i64toi32_i32$5 = $191;
  i64toi32_i32$2 = $193$hi;
  i64toi32_i32$3 = $193;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$5 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$2;
  return i64toi32_i32$5 | 0;
 }
 
 function cryptoxide__curve25519__ge__Ge__scalarmult_base__hfb711866362b33a6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0, $5 = 0, $21 = 0;
  $2 = global$0 - 1024 | 0;
  global$0 = $2;
  cryptoxide__curve25519__scalar__scalar64__Scalar__nibbles__h905c2b43f6ecdbdb($2 + 280 | 0 | 0, $1 | 0);
  $1 = 0;
  $3 = 0;
  label$1 : while (1) {
   $4 = ($2 + 280 | 0) + $1 | 0;
   $3 = (HEAPU8[$4 >> 0] | 0) + $3 | 0;
   $21 = $3;
   $3 = $3 + 8 | 0;
   HEAP8[$4 >> 0] = $21 - ($3 & 240 | 0) | 0;
   $3 = ($3 << 24 | 0) >> 28 | 0;
   $1 = $1 + 1 | 0;
   if (($1 | 0) != (63 | 0)) {
    continue label$1
   }
   break label$1;
  };
  HEAP8[($2 + 343 | 0) >> 0] = (HEAPU8[($2 + 343 | 0) >> 0] | 0) + $3 | 0;
  $0 = memcpy($0 | 0, 1104560 | 0, 160 | 0) | 0;
  $3 = ($2 + 280 | 0) + 1 | 0;
  $4 = 0;
  label$2 : while (1) {
   cryptoxide__curve25519__ge__GePrecomp__select__hde28bed3cdd11d0b($2 + 864 | 0 | 0, $4 | 0, HEAPU8[$3 >> 0] | 0 | 0);
   memcpy($2 + 160 | 0 | 0, $2 + 864 | 0 | 0, 120 | 0) | 0;
   $_cryptoxide__curve25519__ge__Ge_20as_20core__ops__arith__Add__cryptoxide__curve25519__ge__GePrecomp____add__h13dac0ca0b70905e($2 + 864 | 0 | 0, $0 | 0, $2 + 160 | 0 | 0);
   $1 = memcpy($2 | 0, $2 + 864 | 0 | 0, 160 | 0) | 0;
   cryptoxide__curve25519__ge__GeP1P1__to_full__hee64a48e5ca8376f($1 + 864 | 0 | 0, $1 | 0);
   $5 = memcpy($0 | 0, $1 + 864 | 0 | 0, 160 | 0) | 0;
   $3 = $3 + 2 | 0;
   $4 = $4 + 1 | 0;
   if (($4 | 0) != (32 | 0)) {
    continue label$2
   }
   break label$2;
  };
  cryptoxide__curve25519__ge__Ge__double_p1p1__h995b1d78634e10e5($1 + 864 | 0 | 0, $5 | 0);
  cryptoxide__curve25519__ge__GeP1P1__to_partial__h5f1785bbb90d5b59($1 + 744 | 0 | 0, $1 + 864 | 0 | 0);
  cryptoxide__curve25519__ge__GePartial__double_p1p1__hf684fc70b9440336($1 + 864 | 0 | 0, $1 + 744 | 0 | 0);
  cryptoxide__curve25519__ge__GeP1P1__to_partial__h5f1785bbb90d5b59($1 + 624 | 0 | 0, $1 + 864 | 0 | 0);
  cryptoxide__curve25519__ge__GePartial__double_p1p1__hf684fc70b9440336($1 + 864 | 0 | 0, $1 + 624 | 0 | 0);
  cryptoxide__curve25519__ge__GeP1P1__to_partial__h5f1785bbb90d5b59($1 + 504 | 0 | 0, $1 + 864 | 0 | 0);
  cryptoxide__curve25519__ge__GePartial__double_p1p1__hf684fc70b9440336($1 + 864 | 0 | 0, $1 + 504 | 0 | 0);
  cryptoxide__curve25519__ge__GeP1P1__to_full__hee64a48e5ca8376f($1 + 344 | 0 | 0, $1 + 864 | 0 | 0);
  $0 = memcpy($5 | 0, $1 + 344 | 0 | 0, 160 | 0) | 0;
  $2 = 0;
  $3 = $1 + 280 | 0;
  label$3 : while (1) {
   cryptoxide__curve25519__ge__GePrecomp__select__hde28bed3cdd11d0b($1 + 864 | 0 | 0, $2 | 0, HEAPU8[$3 >> 0] | 0 | 0);
   memcpy($1 + 160 | 0 | 0, $1 + 864 | 0 | 0, 120 | 0) | 0;
   $_cryptoxide__curve25519__ge__Ge_20as_20core__ops__arith__Add__cryptoxide__curve25519__ge__GePrecomp____add__h13dac0ca0b70905e($1 + 864 | 0 | 0, $0 | 0, $1 + 160 | 0 | 0);
   $4 = memcpy($1 | 0, $1 + 864 | 0 | 0, 160 | 0) | 0;
   cryptoxide__curve25519__ge__GeP1P1__to_full__hee64a48e5ca8376f($4 + 864 | 0 | 0, $4 | 0);
   memcpy($0 | 0, $4 + 864 | 0 | 0, 160 | 0) | 0;
   $3 = $3 + 2 | 0;
   $2 = $2 + 1 | 0;
   if (($2 | 0) != (32 | 0)) {
    continue label$3
   }
   break label$3;
  };
  global$0 = $4 + 1024 | 0;
 }
 
 function $cardano_serialization_lib__crypto__KESSignature_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hc6a4a33a8e3a1489($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $5 = 0, $3 = 0, $4 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $20 = 0, $6 = 0, $6$hi = 0, $7 = 0, $7$hi = 0, $8 = 0, $8$hi = 0, $21 = 0, $22 = 0;
  $2 = global$0 - 96 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___bytes__hc697ccccfa39fd82($2 + 32 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[($2 + 32 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     $3 = HEAP32[($2 + 36 | 0) >> 2] | 0;
     HEAP32[($2 + 16 | 0) >> 2] = $3;
     $20 = HEAPU8[($2 + 41 | 0) >> 0] | 0 | ((HEAPU8[($2 + 42 | 0) >> 0] | 0) << 8 | 0) | 0;
     HEAP8[($2 + 21 | 0) >> 0] = $20;
     HEAP8[($2 + 22 | 0) >> 0] = $20 >>> 8 | 0;
     $4 = HEAPU8[(($2 + 32 | 0) + 8 | 0) >> 0] | 0;
     HEAP8[($2 + 20 | 0) >> 0] = $4;
     $1 = 11;
     HEAP8[($2 + 23 | 0) >> 0] = HEAPU8[(($2 + 32 | 0) + 11 | 0) >> 0] | 0;
     $5 = HEAP32[(($2 + 32 | 0) + 12 | 0) >> 2] | 0;
     HEAP32[($2 + 24 | 0) >> 2] = $5;
     label$4 : {
      if (($5 | 0) == (448 | 0)) {
       break label$4
      }
      i64toi32_i32$0 = 0;
      $6 = $5;
      $6$hi = i64toi32_i32$0;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 16 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 16 | 0 | 0);
      i64toi32_i32$0 = 0;
      $7 = 1;
      $7$hi = i64toi32_i32$0;
      i64toi32_i32$0 = 0;
      $8 = 448;
      $8$hi = i64toi32_i32$0;
      $5 = 1066390;
      $3 = 13;
      break label$2;
     }
     $1 = $2 + 16 | 0 | 5 | 0;
     HEAP32[($2 + 32 | 0) >> 2] = HEAPU8[$1 >> 0] | 0 | ((HEAPU8[($1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $15 = $1 + 3 | 0;
     $16 = HEAPU8[$15 >> 0] | 0 | ((HEAPU8[($15 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($15 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($15 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[($2 + 35 | 0) >> 0] = $16;
     HEAP8[($2 + 36 | 0) >> 0] = $16 >>> 8 | 0;
     HEAP8[($2 + 37 | 0) >> 0] = $16 >>> 16 | 0;
     HEAP8[($2 + 38 | 0) >> 0] = $16 >>> 24 | 0;
     HEAP8[($0 + 8 | 0) >> 0] = $4;
     HEAP32[($0 + 4 | 0) >> 2] = $3;
     $17 = HEAP32[($2 + 32 | 0) >> 2] | 0;
     HEAP8[($0 + 9 | 0) >> 0] = $17;
     HEAP8[($0 + 10 | 0) >> 0] = $17 >>> 8 | 0;
     HEAP8[($0 + 11 | 0) >> 0] = $17 >>> 16 | 0;
     HEAP8[($0 + 12 | 0) >> 0] = $17 >>> 24 | 0;
     $18 = $0 + 12 | 0;
     $19 = HEAPU8[($2 + 35 | 0) >> 0] | 0 | ((HEAPU8[($2 + 36 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 37 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 38 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[$18 >> 0] = $19;
     HEAP8[($18 + 1 | 0) >> 0] = $19 >>> 8 | 0;
     HEAP8[($18 + 2 | 0) >> 0] = $19 >>> 16 | 0;
     HEAP8[($18 + 3 | 0) >> 0] = $19 >>> 24 | 0;
     $1 = 0;
     break label$1;
    }
    HEAP8[($2 + 14 | 0) >> 0] = HEAPU8[($2 + 43 | 0) >> 0] | 0;
    $1 = HEAPU8[($2 + 41 | 0) >> 0] | 0 | ((HEAPU8[($2 + 42 | 0) >> 0] | 0) << 8 | 0) | 0;
    HEAP16[($2 + 28 | 0) >> 1] = $1;
    HEAP16[($2 + 12 | 0) >> 1] = $1;
    $3 = HEAPU8[($2 + 40 | 0) >> 0] | 0;
    $5 = HEAP32[($2 + 44 | 0) >> 2] | 0;
    $1 = HEAP32[($2 + 48 | 0) >> 2] | 0;
    $4 = HEAP32[($2 + 52 | 0) >> 2] | 0;
    i64toi32_i32$2 = $2 + 56 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $8 = i64toi32_i32$0;
    $8$hi = i64toi32_i32$1;
    i64toi32_i32$2 = $2 + 64 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $7 = i64toi32_i32$1;
    $7$hi = i64toi32_i32$0;
    i64toi32_i32$2 = $2 + 72 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $6 = i64toi32_i32$0;
    $6$hi = i64toi32_i32$1;
   }
   HEAP8[(($2 + 32 | 0) + 8 | 0) >> 0] = $3;
   $21 = $2 + 41 | 0;
   $22 = HEAPU16[($2 + 12 | 0) >> 1] | 0;
   HEAP8[$21 >> 0] = $22;
   HEAP8[($21 + 1 | 0) >> 0] = $22 >>> 8 | 0;
   i64toi32_i32$1 = $6$hi;
   i64toi32_i32$0 = $2 + 72 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $6;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $7$hi;
   i64toi32_i32$0 = $2 + 64 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $7;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $8$hi;
   i64toi32_i32$0 = $2 + 56 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $8;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($2 + 52 | 0) >> 2] = $4;
   HEAP32[($2 + 48 | 0) >> 2] = $1;
   HEAP32[($2 + 44 | 0) >> 2] = $5;
   HEAP8[($2 + 32 | 0) >> 0] = 2;
   HEAP8[($2 + 43 | 0) >> 0] = HEAPU8[(($2 + 12 | 0) + 2 | 0) >> 0] | 0;
   HEAP32[($2 + 80 | 0) >> 2] = 0;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 32 | 0 | 0, 1066401 | 0, 5 | 0);
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 96 | 0;
 }
 
 function hashbrown__map__make_hash__hd0c0e50f69c097de($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $8$hi = 0, $7$hi = 0, $7 = 0, $8 = 0, $9$hi = 0, $9 = 0, $10$hi = 0, $10 = 0, $11$hi = 0, $2 = 0, $11 = 0, $12$hi = 0, $12 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $92 = 0, $25 = 0, $30 = 0, $37 = 0, $45 = 0, $71 = 0, $71$hi = 0, $72 = 0, $72$hi = 0, $74$hi = 0, $79 = 0, $79$hi = 0, $85 = 0, $85$hi = 0, $90 = 0, $90$hi = 0, $94 = 0, $94$hi = 0, $97$hi = 0, $104 = 0, $104$hi = 0, $110 = 0, $110$hi = 0, $112 = 0, $112$hi = 0, $114$hi = 0, $120 = 0, $120$hi = 0, $126 = 0, $126$hi = 0, $129 = 0, $129$hi = 0, $130 = 0, $130$hi = 0, $132$hi = 0, $137 = 0, $137$hi = 0, $144 = 0, $144$hi = 0, $145 = 0, $145$hi = 0, $147$hi = 0, $152 = 0, $152$hi = 0, $159 = 0, $159$hi = 0, $160 = 0, $160$hi = 0, $162$hi = 0, $167 = 0, $167$hi = 0, $170$hi = 0, $172 = 0, $172$hi = 0, $174$hi = 0, $179 = 0, $179$hi = 0, $185$hi = 0, $93 = 0, $188 = 0, $188$hi = 0, $189 = 0, $189$hi = 0, $191 = 0, $191$hi = 0, $192 = 0, $192$hi = 0, $194 = 0, $194$hi = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  $3 = $2 + 64 | 0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = $2 + 48 | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = 1952801890;
  i64toi32_i32$3 = 2037671283;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $25 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $4;
  HEAP32[i64toi32_i32$2 >> 2] = $25;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  $5 = $2 + 40 | 0;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$1 = $7;
  i64toi32_i32$2 = 1685025377;
  i64toi32_i32$3 = 1852075885;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $30 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $5;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  $6 = $2 + 32 | 0;
  i64toi32_i32$0 = $0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$2;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$2 = 1819895653;
  i64toi32_i32$3 = 1852142177;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $37 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $6;
  HEAP32[i64toi32_i32$0 >> 2] = $37;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$0 = $2;
  i64toi32_i32$2 = 0;
  HEAP32[(i64toi32_i32$0 + 56 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 60 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$1 = $8;
  i64toi32_i32$0 = 1936682341;
  i64toi32_i32$3 = 1886610805;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $45 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $2;
  HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = $45;
  HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 79 | 0) >> 0] = HEAPU8[$1 >> 0] | 0;
  $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_3(i64toi32_i32$1 + 8 | 0 | 0, i64toi32_i32$1 + 79 | 0 | 0, 1 | 0);
  $cardano_serialization_lib__address__StakeCredType_20as_20core__hash__Hash___hash__he9f79766a5c45cf6($1 + 1 | 0 | 0, i64toi32_i32$1 + 8 | 0 | 0);
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = 0;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $6;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $12 = i64toi32_i32$1;
  $12$hi = i64toi32_i32$0;
  global$0 = i64toi32_i32$2 + 80 | 0;
  i64toi32_i32$0 = $10$hi;
  $71 = $10;
  $71$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  $72 = $9;
  $72$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$2 = $8;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $92 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $92 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $74$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $72$hi;
  i64toi32_i32$0 = $72;
  i64toi32_i32$2 = $74$hi;
  i64toi32_i32$3 = $92;
  i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
  $8 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $71$hi;
  i64toi32_i32$1 = $71;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $9 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($9 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $79 = i64toi32_i32$1;
  $79$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$4;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $79$hi;
  i64toi32_i32$0 = $79;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$2;
  $85 = $10;
  $85$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$5 = $7;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $90 = i64toi32_i32$5;
  $90$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $85$hi;
  i64toi32_i32$2 = $85;
  i64toi32_i32$5 = $90$hi;
  i64toi32_i32$3 = $90;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $12 = i64toi32_i32$0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $94 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $94$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($7 | 0, i64toi32_i32$2 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $97$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$2 = $97$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $8 = i64toi32_i32$5;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 17 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $104 = i64toi32_i32$2;
  $104$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$2 = $104$hi;
  i64toi32_i32$3 = $104;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $94$hi;
  i64toi32_i32$0 = $94;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $110 = i64toi32_i32$0;
  $110$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = $110$hi;
  i64toi32_i32$3 = $110;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $7 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$0;
  $112 = $7;
  $112$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($10 | 0, i64toi32_i32$0 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $114$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$0 = $114$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $10$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($8 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 255;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $120 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $120$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$2 = $10;
  i64toi32_i32$0 = $120$hi;
  i64toi32_i32$3 = $120;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $8 = i64toi32_i32$4;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $112$hi;
  i64toi32_i32$5 = $112;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$0;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 17 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $126 = i64toi32_i32$5;
  $126$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$5 = $126$hi;
  i64toi32_i32$3 = $126;
  i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
  $7 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$5;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $129 = i64toi32_i32$1;
  $129$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  $130 = $7;
  $130$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$5 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $132$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $8$hi;
  i64toi32_i32$5 = $132$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $8 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($9 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $137 = i64toi32_i32$4;
  $137$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$5 = $8;
  i64toi32_i32$4 = $137$hi;
  i64toi32_i32$3 = $137;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $9 = i64toi32_i32$2;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $130$hi;
  i64toi32_i32$1 = $130;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$4;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $129$hi;
  i64toi32_i32$0 = $129;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($10 | 0, i64toi32_i32$1 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $144 = i64toi32_i32$0;
  $144$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $10$hi;
  $145 = $10;
  $145$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($8 | 0, i64toi32_i32$1 | 0, 21 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $147$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$1 = $147$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $8 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $152 = i64toi32_i32$2;
  $152$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$1 = $8;
  i64toi32_i32$2 = $152$hi;
  i64toi32_i32$3 = $152;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $9 = i64toi32_i32$5;
  $9$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $145$hi;
  i64toi32_i32$0 = $145;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $10 = i64toi32_i32$2;
  $10$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $144$hi;
  i64toi32_i32$4 = $144;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $11 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $159 = i64toi32_i32$4;
  $159$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  $160 = $11;
  $160$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($8 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $162$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $162$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $8 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $167 = i64toi32_i32$5;
  $167$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$0 = $8;
  i64toi32_i32$5 = $167$hi;
  i64toi32_i32$3 = $167;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$1;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $160$hi;
  i64toi32_i32$4 = $160;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $170$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $159$hi;
  i64toi32_i32$2 = $159;
  i64toi32_i32$4 = $170$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $9 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $9$hi = i64toi32_i32$4;
  $172 = $9;
  $172$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($8 | 0, i64toi32_i32$4 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $174$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$4 = $174$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $179 = i64toi32_i32$1;
  $179$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = $7;
  i64toi32_i32$1 = $179$hi;
  i64toi32_i32$3 = $179;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $172$hi;
  i64toi32_i32$2 = $172;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $10 = i64toi32_i32$1;
  $10$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $185$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$0 = $185$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $93 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($93 | 0, i64toi32_i32$2 | 0, 21 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $188 = i64toi32_i32$5;
  $188$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$5 = $188$hi;
  i64toi32_i32$3 = $188;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $189 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $189$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($9 | 0, i64toi32_i32$5 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $191 = i64toi32_i32$0;
  $191$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $189$hi;
  i64toi32_i32$2 = $189;
  i64toi32_i32$0 = $191$hi;
  i64toi32_i32$3 = $191;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $192 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $192$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $194 = i64toi32_i32$2;
  $194$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $192$hi;
  i64toi32_i32$5 = $192;
  i64toi32_i32$2 = $194$hi;
  i64toi32_i32$3 = $194;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$5 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$2;
  return i64toi32_i32$5 | 0;
 }
 
 function core__num__flt2dec__strategy__dragon__mul_pow10__hb4209e899a74326f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$5 = 0, $7 = 0, $7$hi = 0, i64toi32_i32$4 = 0, $5 = 0, i64toi32_i32$3 = 0, $4 = 0, $6$hi = 0, $21 = 0, $22 = 0, $6 = 0, $30 = 0, $32$hi = 0, $23 = 0, $34$hi = 0, $73 = 0, $24 = 0, $76$hi = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       $2 = $1 & 7 | 0;
       if (!$2) {
        break label$5
       }
       $3 = HEAP32[$0 >> 2] | 0;
       if ($3 >>> 0 >= 41 >>> 0) {
        break label$4
       }
       label$6 : {
        label$7 : {
         if ($3) {
          break label$7
         }
         $3 = 0;
         break label$6;
        }
        i64toi32_i32$2 = ($2 << 2 | 0) + 1146336 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = 0;
        $6 = i64toi32_i32$0;
        $6$hi = i64toi32_i32$1;
        $4 = ($0 + ($3 << 2 | 0) | 0) + 4 | 0;
        $5 = $3 << 2 | 0;
        $2 = $0 + 4 | 0;
        i64toi32_i32$1 = 0;
        $7 = 0;
        $7$hi = i64toi32_i32$1;
        label$8 : while (1) {
         $30 = $2;
         i64toi32_i32$2 = $2;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$0 = 0;
         $32$hi = i64toi32_i32$0;
         i64toi32_i32$0 = $6$hi;
         i64toi32_i32$0 = $32$hi;
         $23 = i64toi32_i32$1;
         i64toi32_i32$1 = $6$hi;
         i64toi32_i32$1 = __wasm_i64_mul($23 | 0, i64toi32_i32$0 | 0, $6 | 0, i64toi32_i32$1 | 0) | 0;
         i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
         $34$hi = i64toi32_i32$0;
         i64toi32_i32$0 = $7$hi;
         i64toi32_i32$0 = $34$hi;
         i64toi32_i32$2 = i64toi32_i32$1;
         i64toi32_i32$1 = $7$hi;
         i64toi32_i32$3 = $7;
         i64toi32_i32$4 = i64toi32_i32$2 + $7 | 0;
         i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
         if (i64toi32_i32$4 >>> 0 < $7 >>> 0) {
          i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
         }
         $7 = i64toi32_i32$4;
         $7$hi = i64toi32_i32$5;
         HEAP32[$30 >> 2] = i64toi32_i32$4;
         $2 = $2 + 4 | 0;
         i64toi32_i32$0 = i64toi32_i32$4;
         i64toi32_i32$2 = 0;
         i64toi32_i32$3 = 32;
         i64toi32_i32$1 = i64toi32_i32$3 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
          i64toi32_i32$2 = 0;
          $21 = i64toi32_i32$5 >>> i64toi32_i32$1 | 0;
         } else {
          i64toi32_i32$2 = i64toi32_i32$5 >>> i64toi32_i32$1 | 0;
          $21 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$1 | 0) | 0;
         }
         $7 = $21;
         $7$hi = i64toi32_i32$2;
         $5 = $5 + -4 | 0;
         if ($5) {
          continue label$8
         }
         break label$8;
        };
        i64toi32_i32$2 = $7$hi;
        $2 = $7;
        if (!$2) {
         break label$6
        }
        if ($3 >>> 0 > 39 >>> 0) {
         break label$3
        }
        HEAP32[$4 >> 2] = $2;
        $3 = $3 + 1 | 0;
       }
       HEAP32[$0 >> 2] = $3;
      }
      label$9 : {
       if (!($1 & 8 | 0)) {
        break label$9
       }
       $3 = HEAP32[$0 >> 2] | 0;
       if ($3 >>> 0 >= 41 >>> 0) {
        break label$2
       }
       label$10 : {
        label$11 : {
         if ($3) {
          break label$11
         }
         $3 = 0;
         break label$10;
        }
        $5 = $3 << 2 | 0;
        $4 = ($0 + $5 | 0) + 4 | 0;
        $2 = $0 + 4 | 0;
        i64toi32_i32$2 = 0;
        $7 = 0;
        $7$hi = i64toi32_i32$2;
        label$12 : while (1) {
         $73 = $2;
         i64toi32_i32$5 = $2;
         i64toi32_i32$2 = HEAP32[i64toi32_i32$5 >> 2] | 0;
         i64toi32_i32$0 = 0;
         $24 = i64toi32_i32$2;
         i64toi32_i32$2 = 0;
         i64toi32_i32$2 = __wasm_i64_mul($24 | 0, i64toi32_i32$0 | 0, 1e8 | 0, i64toi32_i32$2 | 0) | 0;
         i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
         $76$hi = i64toi32_i32$0;
         i64toi32_i32$0 = $7$hi;
         i64toi32_i32$0 = $76$hi;
         i64toi32_i32$5 = i64toi32_i32$2;
         i64toi32_i32$2 = $7$hi;
         i64toi32_i32$3 = $7;
         i64toi32_i32$1 = i64toi32_i32$5 + $7 | 0;
         i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
         if (i64toi32_i32$1 >>> 0 < $7 >>> 0) {
          i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
         }
         $7 = i64toi32_i32$1;
         $7$hi = i64toi32_i32$4;
         HEAP32[$73 >> 2] = i64toi32_i32$1;
         $2 = $2 + 4 | 0;
         i64toi32_i32$0 = i64toi32_i32$1;
         i64toi32_i32$5 = 0;
         i64toi32_i32$3 = 32;
         i64toi32_i32$2 = i64toi32_i32$3 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
          i64toi32_i32$5 = 0;
          $22 = i64toi32_i32$4 >>> i64toi32_i32$2 | 0;
         } else {
          i64toi32_i32$5 = i64toi32_i32$4 >>> i64toi32_i32$2 | 0;
          $22 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$2 | 0) | 0;
         }
         $7 = $22;
         $7$hi = i64toi32_i32$5;
         $5 = $5 + -4 | 0;
         if ($5) {
          continue label$12
         }
         break label$12;
        };
        i64toi32_i32$5 = $7$hi;
        $2 = $7;
        if (!$2) {
         break label$10
        }
        if ($3 >>> 0 > 39 >>> 0) {
         break label$1
        }
        HEAP32[$4 >> 2] = $2;
        $3 = $3 + 1 | 0;
       }
       HEAP32[$0 >> 2] = $3;
      }
      label$13 : {
       if (!($1 & 16 | 0)) {
        break label$13
       }
       core__num__bignum__Big32x40__mul_digits__h5211d0d110d18ae1($0 | 0, 1146416 | 0, 2 | 0) | 0;
      }
      label$14 : {
       if (!($1 & 32 | 0)) {
        break label$14
       }
       core__num__bignum__Big32x40__mul_digits__h5211d0d110d18ae1($0 | 0, 1146424 | 0, 4 | 0) | 0;
      }
      label$15 : {
       if (!($1 & 64 | 0)) {
        break label$15
       }
       core__num__bignum__Big32x40__mul_digits__h5211d0d110d18ae1($0 | 0, 1146440 | 0, 7 | 0) | 0;
      }
      label$16 : {
       if (!($1 & 128 | 0)) {
        break label$16
       }
       core__num__bignum__Big32x40__mul_digits__h5211d0d110d18ae1($0 | 0, 1146468 | 0, 14 | 0) | 0;
      }
      label$17 : {
       if (!($1 & 256 | 0)) {
        break label$17
       }
       core__num__bignum__Big32x40__mul_digits__h5211d0d110d18ae1($0 | 0, 1146524 | 0, 27 | 0) | 0;
      }
      return $0 | 0;
     }
     core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($3 | 0, 40 | 0, 1153020 | 0);
     abort();
    }
    core__panicking__panic_bounds_check__h808b524af17640b1($3 | 0, 40 | 0, 1153020 | 0);
    abort();
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($3 | 0, 40 | 0, 1153020 | 0);
   abort();
  }
  core__panicking__panic_bounds_check__h808b524af17640b1($3 | 0, 40 | 0, 1153020 | 0);
  abort();
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__Block___serialize__h5b93dd14758cd2d8($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0;
  $3 = global$0 - 64 | 0;
  global$0 = $3;
  i64toi32_i32$0 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 + 16 | 0 | 0, $2 | 0, 4 | 0, 5 | 0, i64toi32_i32$0 | 0);
  $4 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          if ((HEAP32[($3 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
           break label$8
          }
          cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__Header___serialize__hd43c55fb578bdd92($3 + 16 | 0 | 0, $1 | 0, $2 | 0);
          if ((HEAP32[($3 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
           break label$7
          }
          cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__TransactionBodies___serialize__h8db917846eff3001($3 + 16 | 0 | 0, $1 + 368 | 0 | 0, $2 | 0);
          $4 = 1;
          if ((HEAP32[($3 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
           break label$6
          }
          cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__TransactionWitnessSets___serialize__hdd6edfd8e35c0d96($3 + 16 | 0 | 0, $1 + 380 | 0 | 0, $2 | 0);
          if ((HEAP32[($3 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
           break label$5
          }
          cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__AuxiliaryDataSet___serialize__hecb5dbb69688610a($3 + 16 | 0 | 0, $1 + 328 | 0 | 0, $2 | 0);
          $4 = 1;
          if ((HEAP32[($3 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
           break label$4
          }
          i64toi32_i32$0 = HEAP32[($1 + 400 | 0) >> 2] | 0;
          i64toi32_i32$1 = 0;
          cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 + 16 | 0 | 0, $2 | 0, 4 | 0, i64toi32_i32$0 | 0, i64toi32_i32$1 | 0);
          if ((HEAP32[($3 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
           break label$3
          }
          $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h7a0ed8a251b429e6($3 + 8 | 0 | 0, $1 + 392 | 0 | 0);
          label$9 : {
           $1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
           if (!$1) {
            break label$9
           }
           $4 = HEAP32[($3 + 8 | 0) >> 2] | 0;
           $1 = $1 << 2 | 0;
           label$10 : while (1) {
            i64toi32_i32$1 = HEAP32[$4 >> 2] | 0;
            i64toi32_i32$0 = 0;
            cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 + 16 | 0 | 0, $2 | 0, 0 | 0, i64toi32_i32$1 | 0, i64toi32_i32$0 | 0);
            if ((HEAP32[($3 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
             break label$2
            }
            $4 = $4 + 4 | 0;
            $1 = $1 + -4 | 0;
            if ($1) {
             continue label$10
            }
            break label$10;
           };
          }
          HEAP32[($0 + 4 | 0) >> 2] = $2;
          $4 = 0;
          break label$1;
         }
         memcpy($0 + 8 | 0 | 0, ($3 + 16 | 0) + 8 | 0 | 0, 40 | 0) | 0;
         break label$1;
        }
        memcpy($0 + 8 | 0 | 0, ($3 + 16 | 0) + 8 | 0 | 0, 40 | 0) | 0;
        $4 = 1;
        break label$1;
       }
       memcpy($0 + 8 | 0 | 0, ($3 + 16 | 0) + 8 | 0 | 0, 40 | 0) | 0;
       break label$1;
      }
      memcpy($0 + 8 | 0 | 0, ($3 + 16 | 0) + 8 | 0 | 0, 40 | 0) | 0;
      $4 = 1;
      break label$1;
     }
     memcpy($0 + 8 | 0 | 0, ($3 + 16 | 0) + 8 | 0 | 0, 40 | 0) | 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, ($3 + 16 | 0) + 8 | 0 | 0, 40 | 0) | 0;
    $4 = 1;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, ($3 + 16 | 0) + 8 | 0 | 0, 40 | 0) | 0;
   $4 = 1;
  }
  HEAP32[$0 >> 2] = $4;
  global$0 = $3 + 64 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert_fit__h49acceb5a90505ee($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $6 = 0, $12 = 0, $5 = 0, $7 = 0, $10 = 0, $8 = 0, $24 = 0, $25 = 0, $26 = 0, $27 = 0, $28 = 0, $29 = 0, $9 = 0, $11 = 0, $33 = 0, $39 = 0, $42 = 0, $75 = 0, $79 = 0, $83 = 0, $90 = 0, $121 = 0;
  $5 = global$0 - 32 | 0;
  global$0 = $5;
  $6 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  $7 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $0 = HEAPU16[($7 + 138 | 0) >> 1] | 0;
  $8 = $5 + 24 | 0;
  $24 = $1 + 24 | 0;
  HEAP32[$8 >> 2] = HEAPU8[$24 >> 0] | 0 | ((HEAPU8[($24 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($24 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($24 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $9 = $5 + 16 | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $33 = i64toi32_i32$0;
  i64toi32_i32$0 = $9;
  HEAP32[i64toi32_i32$0 >> 2] = $33;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $10 = $5 + 8 | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $39 = i64toi32_i32$1;
  i64toi32_i32$1 = $10;
  HEAP32[i64toi32_i32$1 >> 2] = $39;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $42 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[i64toi32_i32$0 >> 2] = $42;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   $1 = $6 + 1 | 0;
   $11 = $1 >>> 0 > $0 >>> 0;
   if ($11) {
    break label$1
   }
   $12 = $7 + 140 | 0;
   memmove($12 + Math_imul($1, 28) | 0 | 0, $12 + Math_imul($6, 28) | 0 | 0, Math_imul($0 - $6 | 0, 28) | 0) | 0;
  }
  $12 = $7 + Math_imul($6, 28) | 0;
  $25 = $12 + 164 | 0;
  $26 = HEAP32[$8 >> 2] | 0;
  HEAP8[$25 >> 0] = $26;
  HEAP8[($25 + 1 | 0) >> 0] = $26 >>> 8 | 0;
  HEAP8[($25 + 2 | 0) >> 0] = $26 >>> 16 | 0;
  HEAP8[($25 + 3 | 0) >> 0] = $26 >>> 24 | 0;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $75 = i64toi32_i32$1;
  i64toi32_i32$1 = $12 + 156 | 0;
  $27 = $75;
  HEAP8[i64toi32_i32$1 >> 0] = $27;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $27 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $27 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $27 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $10;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $79 = i64toi32_i32$0;
  i64toi32_i32$0 = $12 + 148 | 0;
  $28 = $79;
  HEAP8[i64toi32_i32$0 >> 0] = $28;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $28 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $28 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $28 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $83 = i64toi32_i32$1;
  i64toi32_i32$1 = $12 + 140 | 0;
  $29 = $83;
  HEAP8[i64toi32_i32$1 >> 0] = $29;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $29 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $29 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $29 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP32[$10 >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $90 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[i64toi32_i32$0 >> 2] = $90;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  label$2 : {
   if ($11) {
    break label$2
   }
   $12 = $7 + 4 | 0;
   memmove($12 + Math_imul($1, 12) | 0 | 0, $12 + Math_imul($6, 12) | 0 | 0, Math_imul($0 - $6 | 0, 12) | 0) | 0;
  }
  $12 = $0 + 1 | 0;
  $2 = $7 + Math_imul($6, 12) | 0;
  HEAP32[($2 + 12 | 0) >> 2] = HEAP32[($5 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $121 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 4 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $121;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  label$3 : {
   $10 = $6 + 2 | 0;
   $2 = $0 + 2 | 0;
   if ($10 >>> 0 >= $2 >>> 0) {
    break label$3
   }
   $8 = $7 + 448 | 0;
   memmove($8 + ($10 << 2 | 0) | 0 | 0, $8 + ($1 << 2 | 0) | 0 | 0, ($0 - $6 | 0) << 2 | 0 | 0) | 0;
  }
  HEAP32[(($7 + ($1 << 2 | 0) | 0) + 448 | 0) >> 2] = $4;
  HEAP16[($7 + 138 | 0) >> 1] = $12;
  label$4 : {
   if ($1 >>> 0 >= $2 >>> 0) {
    break label$4
   }
   $12 = $0 + 1 | 0;
   $0 = ($7 + ($6 << 2 | 0) | 0) + 452 | 0;
   label$5 : while (1) {
    $1 = HEAP32[$0 >> 2] | 0;
    $6 = $6 + 1 | 0;
    HEAP16[($1 + 136 | 0) >> 1] = $6;
    HEAP32[$1 >> 2] = $7;
    $0 = $0 + 4 | 0;
    if (($12 | 0) != ($6 | 0)) {
     continue label$5
    }
    break label$5;
   };
  }
  global$0 = $5 + 32 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert_fit__h98aecfda81b312ad($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $6 = 0, $12 = 0, $5 = 0, $7 = 0, $10 = 0, $8 = 0, $24 = 0, $25 = 0, $26 = 0, $27 = 0, $28 = 0, $29 = 0, $9 = 0, $11 = 0, $33 = 0, $39 = 0, $42 = 0, $75 = 0, $79 = 0, $83 = 0, $90 = 0, $121 = 0;
  $5 = global$0 - 32 | 0;
  global$0 = $5;
  $6 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  $7 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $0 = HEAPU16[($7 + 138 | 0) >> 1] | 0;
  $8 = $5 + 24 | 0;
  $24 = $1 + 24 | 0;
  HEAP32[$8 >> 2] = HEAPU8[$24 >> 0] | 0 | ((HEAPU8[($24 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($24 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($24 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $9 = $5 + 16 | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $33 = i64toi32_i32$0;
  i64toi32_i32$0 = $9;
  HEAP32[i64toi32_i32$0 >> 2] = $33;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $10 = $5 + 8 | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $39 = i64toi32_i32$1;
  i64toi32_i32$1 = $10;
  HEAP32[i64toi32_i32$1 >> 2] = $39;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $42 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[i64toi32_i32$0 >> 2] = $42;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   $1 = $6 + 1 | 0;
   $11 = $1 >>> 0 > $0 >>> 0;
   if ($11) {
    break label$1
   }
   $12 = $7 + 140 | 0;
   memmove($12 + Math_imul($1, 28) | 0 | 0, $12 + Math_imul($6, 28) | 0 | 0, Math_imul($0 - $6 | 0, 28) | 0) | 0;
  }
  $12 = $7 + Math_imul($6, 28) | 0;
  $25 = $12 + 164 | 0;
  $26 = HEAP32[$8 >> 2] | 0;
  HEAP8[$25 >> 0] = $26;
  HEAP8[($25 + 1 | 0) >> 0] = $26 >>> 8 | 0;
  HEAP8[($25 + 2 | 0) >> 0] = $26 >>> 16 | 0;
  HEAP8[($25 + 3 | 0) >> 0] = $26 >>> 24 | 0;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $75 = i64toi32_i32$1;
  i64toi32_i32$1 = $12 + 156 | 0;
  $27 = $75;
  HEAP8[i64toi32_i32$1 >> 0] = $27;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $27 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $27 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $27 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $10;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $79 = i64toi32_i32$0;
  i64toi32_i32$0 = $12 + 148 | 0;
  $28 = $79;
  HEAP8[i64toi32_i32$0 >> 0] = $28;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $28 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $28 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $28 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $83 = i64toi32_i32$1;
  i64toi32_i32$1 = $12 + 140 | 0;
  $29 = $83;
  HEAP8[i64toi32_i32$1 >> 0] = $29;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $29 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $29 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $29 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP32[$10 >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $90 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[i64toi32_i32$0 >> 2] = $90;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  label$2 : {
   if ($11) {
    break label$2
   }
   $12 = $7 + 4 | 0;
   memmove($12 + Math_imul($1, 12) | 0 | 0, $12 + Math_imul($6, 12) | 0 | 0, Math_imul($0 - $6 | 0, 12) | 0) | 0;
  }
  $12 = $0 + 1 | 0;
  $2 = $7 + Math_imul($6, 12) | 0;
  HEAP32[($2 + 12 | 0) >> 2] = HEAP32[($5 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $121 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 4 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $121;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  label$3 : {
   $10 = $6 + 2 | 0;
   $2 = $0 + 2 | 0;
   if ($10 >>> 0 >= $2 >>> 0) {
    break label$3
   }
   $8 = $7 + 448 | 0;
   memmove($8 + ($10 << 2 | 0) | 0 | 0, $8 + ($1 << 2 | 0) | 0 | 0, ($0 - $6 | 0) << 2 | 0 | 0) | 0;
  }
  HEAP32[(($7 + ($1 << 2 | 0) | 0) + 448 | 0) >> 2] = $4;
  HEAP16[($7 + 138 | 0) >> 1] = $12;
  label$4 : {
   if ($1 >>> 0 >= $2 >>> 0) {
    break label$4
   }
   $12 = $0 + 1 | 0;
   $0 = ($7 + ($6 << 2 | 0) | 0) + 452 | 0;
   label$5 : while (1) {
    $1 = HEAP32[$0 >> 2] | 0;
    $6 = $6 + 1 | 0;
    HEAP16[($1 + 136 | 0) >> 1] = $6;
    HEAP32[$1 >> 2] = $7;
    $0 = $0 + 4 | 0;
    if (($12 | 0) != ($6 | 0)) {
     continue label$5
    }
    break label$5;
   };
  }
  global$0 = $5 + 32 | 0;
 }
 
 function cardano_serialization_lib__NativeScripts__add__h12de25bf2c37f302($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $2 = 0, $24 = 0, $25 = 0, $26 = 0, $27 = 0, $29 = 0, $30 = 0, $3 = 0, $4 = 0, $5 = 0, $22 = 0, $28 = 0, $32 = 0, $68 = 0, $74 = 0, $80 = 0, $87 = 0, $95 = 0, $102 = 0, $109 = 0, $112 = 0, $130 = 0, $134 = 0, $138 = 0, $142 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    switch (HEAPU8[$1 >> 0] | 0 | 0) {
    default:
     $24 = $1 + 25 | 0;
     $25 = ($2 + 32 | 0) + 25 | 0;
     $26 = HEAPU8[$24 >> 0] | 0 | ((HEAPU8[($24 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($24 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($24 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[$25 >> 0] = $26;
     HEAP8[($25 + 1 | 0) >> 0] = $26 >>> 8 | 0;
     HEAP8[($25 + 2 | 0) >> 0] = $26 >>> 16 | 0;
     HEAP8[($25 + 3 | 0) >> 0] = $26 >>> 24 | 0;
     i64toi32_i32$2 = $1 + 17 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $22 = i64toi32_i32$0;
     i64toi32_i32$0 = ($2 + 32 | 0) + 17 | 0;
     $27 = $22;
     HEAP8[i64toi32_i32$0 >> 0] = $27;
     HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $27 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $27 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $27 >>> 24 | 0;
     HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
     HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
     i64toi32_i32$2 = $1 + 9 | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $28 = i64toi32_i32$1;
     i64toi32_i32$1 = ($2 + 32 | 0) + 9 | 0;
     $29 = $28;
     HEAP8[i64toi32_i32$1 >> 0] = $29;
     HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $29 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $29 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $29 >>> 24 | 0;
     HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
     HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
     HEAP8[($2 + 32 | 0) >> 0] = 0;
     i64toi32_i32$2 = $1;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $32 = i64toi32_i32$0;
     i64toi32_i32$0 = $2;
     $30 = $32;
     HEAP8[(i64toi32_i32$0 + 33 | 0) >> 0] = $30;
     HEAP8[(i64toi32_i32$0 + 34 | 0) >> 0] = $30 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 35 | 0) >> 0] = $30 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 36 | 0) >> 0] = $30 >>> 24 | 0;
     HEAP8[(i64toi32_i32$0 + 37 | 0) >> 0] = i64toi32_i32$1;
     HEAP8[(i64toi32_i32$0 + 38 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 39 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 40 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
     break label$1;
    case 1:
     alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($2 + 32 | 0 | 4 | 0 | 0, HEAP32[($1 + 4 | 0) >> 2] | 0 | 0, HEAP32[($1 + 12 | 0) >> 2] | 0 | 0);
     HEAP8[($2 + 32 | 0) >> 0] = 1;
     break label$1;
    case 2:
     alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($2 + 32 | 0 | 4 | 0 | 0, HEAP32[($1 + 4 | 0) >> 2] | 0 | 0, HEAP32[($1 + 12 | 0) >> 2] | 0 | 0);
     HEAP8[($2 + 32 | 0) >> 0] = 2;
     break label$1;
    case 3:
     $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($2 | 4 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0, HEAP32[($1 + 16 | 0) >> 2] | 0 | 0);
     i64toi32_i32$2 = $2 + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $68 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 44 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $68;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[$2 >> 2] = $3;
     HEAP8[($2 + 32 | 0) >> 0] = 3;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $74 = i64toi32_i32$0;
     i64toi32_i32$0 = i64toi32_i32$2;
     HEAP32[(i64toi32_i32$0 + 36 | 0) >> 2] = $74;
     HEAP32[(i64toi32_i32$0 + 40 | 0) >> 2] = i64toi32_i32$1;
     break label$1;
    case 4:
     i64toi32_i32$2 = $1 + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $80 = i64toi32_i32$1;
     i64toi32_i32$1 = ($2 + 32 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $80;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     HEAP8[($2 + 32 | 0) >> 0] = 4;
     break label$1;
    case 5:
     break label$2;
    };
   }
   i64toi32_i32$2 = $1 + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $87 = i64toi32_i32$0;
   i64toi32_i32$0 = ($2 + 32 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $87;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP8[($2 + 32 | 0) >> 0] = 5;
  }
  $3 = $2 + 24 | 0;
  i64toi32_i32$2 = ($2 + 32 | 0) + 24 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $95 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[i64toi32_i32$1 >> 2] = $95;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = $2 + 16 | 0;
  i64toi32_i32$2 = ($2 + 32 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $102 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[i64toi32_i32$0 >> 2] = $102;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $5 = $2 + 8 | 0;
  i64toi32_i32$2 = ($2 + 32 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $109 = i64toi32_i32$1;
  i64toi32_i32$1 = $5;
  HEAP32[i64toi32_i32$1 >> 2] = $109;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
  $112 = i64toi32_i32$0;
  i64toi32_i32$0 = i64toi32_i32$2;
  HEAP32[i64toi32_i32$0 >> 2] = $112;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  label$8 : {
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (($1 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
    break label$8
   }
   alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h5af6e4677d294e82($0 | 0, $1 | 0, 1 | 0);
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  }
  $1 = (HEAP32[$0 >> 2] | 0) + ($1 << 5 | 0) | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $130 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[i64toi32_i32$1 >> 2] = $130;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $134 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 24 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $134;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $138 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $138;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $142 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $142;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
  global$0 = $2 + 64 | 0;
 }
 
 function hashbrown__map__make_insert_hash__hb67cad89ed6c0ea0($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $8$hi = 0, $7$hi = 0, $7 = 0, $8 = 0, $9$hi = 0, $9 = 0, $10$hi = 0, $10 = 0, $11$hi = 0, $2 = 0, $11 = 0, $12$hi = 0, $12 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $92 = 0, $25 = 0, $30 = 0, $37 = 0, $45 = 0, $68 = 0, $68$hi = 0, $69 = 0, $69$hi = 0, $71$hi = 0, $76 = 0, $76$hi = 0, $82 = 0, $82$hi = 0, $87 = 0, $87$hi = 0, $91 = 0, $91$hi = 0, $94$hi = 0, $101 = 0, $101$hi = 0, $107 = 0, $107$hi = 0, $109 = 0, $109$hi = 0, $111$hi = 0, $117 = 0, $117$hi = 0, $123 = 0, $123$hi = 0, $126 = 0, $126$hi = 0, $127 = 0, $127$hi = 0, $129$hi = 0, $134 = 0, $134$hi = 0, $141 = 0, $141$hi = 0, $142 = 0, $142$hi = 0, $144$hi = 0, $149 = 0, $149$hi = 0, $156 = 0, $156$hi = 0, $157 = 0, $157$hi = 0, $159$hi = 0, $164 = 0, $164$hi = 0, $167$hi = 0, $169 = 0, $169$hi = 0, $171$hi = 0, $176 = 0, $176$hi = 0, $182$hi = 0, $93 = 0, $185 = 0, $185$hi = 0, $186 = 0, $186$hi = 0, $188 = 0, $188$hi = 0, $189 = 0, $189$hi = 0, $191 = 0, $191$hi = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  $3 = $2 + 64 | 0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = $2 + 48 | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = 1952801890;
  i64toi32_i32$3 = 2037671283;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $25 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $4;
  HEAP32[i64toi32_i32$2 >> 2] = $25;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  $5 = $2 + 40 | 0;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$1 = $7;
  i64toi32_i32$2 = 1685025377;
  i64toi32_i32$3 = 1852075885;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $30 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $5;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  $6 = $2 + 32 | 0;
  i64toi32_i32$0 = $0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$2;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$2 = 1819895653;
  i64toi32_i32$3 = 1852142177;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $37 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $6;
  HEAP32[i64toi32_i32$0 >> 2] = $37;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$0 = $2;
  i64toi32_i32$2 = 0;
  HEAP32[(i64toi32_i32$0 + 56 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 60 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$1 = $8;
  i64toi32_i32$0 = 1936682341;
  i64toi32_i32$3 = 1886610805;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $45 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $2;
  HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = $45;
  HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 76 | 0) >> 2] = 28;
  $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_2(i64toi32_i32$1 + 8 | 0 | 0, i64toi32_i32$1 + 76 | 0 | 0, 4 | 0);
  $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_2(i64toi32_i32$1 + 8 | 0 | 0, $1 | 0, 28 | 0);
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = 0;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $6;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $12 = i64toi32_i32$1;
  $12$hi = i64toi32_i32$0;
  global$0 = i64toi32_i32$2 + 80 | 0;
  i64toi32_i32$0 = $10$hi;
  $68 = $10;
  $68$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  $69 = $9;
  $69$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$2 = $8;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $92 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $92 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $71$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $69$hi;
  i64toi32_i32$0 = $69;
  i64toi32_i32$2 = $71$hi;
  i64toi32_i32$3 = $92;
  i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
  $8 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $68$hi;
  i64toi32_i32$1 = $68;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $9 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($9 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $76 = i64toi32_i32$1;
  $76$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$4;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $76$hi;
  i64toi32_i32$0 = $76;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$2;
  $82 = $10;
  $82$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$5 = $7;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $87 = i64toi32_i32$5;
  $87$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $82$hi;
  i64toi32_i32$2 = $82;
  i64toi32_i32$5 = $87$hi;
  i64toi32_i32$3 = $87;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $12 = i64toi32_i32$0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $91 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $91$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($7 | 0, i64toi32_i32$2 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $94$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$2 = $94$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $8 = i64toi32_i32$5;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 17 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $101 = i64toi32_i32$2;
  $101$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$2 = $101$hi;
  i64toi32_i32$3 = $101;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $91$hi;
  i64toi32_i32$0 = $91;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $107 = i64toi32_i32$0;
  $107$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = $107$hi;
  i64toi32_i32$3 = $107;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $7 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$0;
  $109 = $7;
  $109$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($10 | 0, i64toi32_i32$0 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $111$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$0 = $111$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $10$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($8 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 255;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $117 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $117$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$2 = $10;
  i64toi32_i32$0 = $117$hi;
  i64toi32_i32$3 = $117;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $8 = i64toi32_i32$4;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $109$hi;
  i64toi32_i32$5 = $109;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$0;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 17 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $123 = i64toi32_i32$5;
  $123$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$5 = $123$hi;
  i64toi32_i32$3 = $123;
  i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
  $7 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$5;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $126 = i64toi32_i32$1;
  $126$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  $127 = $7;
  $127$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$5 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $129$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $8$hi;
  i64toi32_i32$5 = $129$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $8 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($9 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $134 = i64toi32_i32$4;
  $134$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$5 = $8;
  i64toi32_i32$4 = $134$hi;
  i64toi32_i32$3 = $134;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $9 = i64toi32_i32$2;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $127$hi;
  i64toi32_i32$1 = $127;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$4;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $126$hi;
  i64toi32_i32$0 = $126;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($10 | 0, i64toi32_i32$1 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $141 = i64toi32_i32$0;
  $141$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $10$hi;
  $142 = $10;
  $142$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($8 | 0, i64toi32_i32$1 | 0, 21 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $144$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$1 = $144$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $8 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $149 = i64toi32_i32$2;
  $149$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$1 = $8;
  i64toi32_i32$2 = $149$hi;
  i64toi32_i32$3 = $149;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $9 = i64toi32_i32$5;
  $9$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $142$hi;
  i64toi32_i32$0 = $142;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $10 = i64toi32_i32$2;
  $10$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $141$hi;
  i64toi32_i32$4 = $141;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $11 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $156 = i64toi32_i32$4;
  $156$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  $157 = $11;
  $157$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($8 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $159$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $159$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $8 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $164 = i64toi32_i32$5;
  $164$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$0 = $8;
  i64toi32_i32$5 = $164$hi;
  i64toi32_i32$3 = $164;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$1;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $157$hi;
  i64toi32_i32$4 = $157;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $167$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $156$hi;
  i64toi32_i32$2 = $156;
  i64toi32_i32$4 = $167$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $9 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $9$hi = i64toi32_i32$4;
  $169 = $9;
  $169$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($8 | 0, i64toi32_i32$4 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $171$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$4 = $171$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $176 = i64toi32_i32$1;
  $176$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = $7;
  i64toi32_i32$1 = $176$hi;
  i64toi32_i32$3 = $176;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $169$hi;
  i64toi32_i32$2 = $169;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $10 = i64toi32_i32$1;
  $10$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $182$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$0 = $182$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $93 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($93 | 0, i64toi32_i32$2 | 0, 21 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $185 = i64toi32_i32$5;
  $185$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$5 = $185$hi;
  i64toi32_i32$3 = $185;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $186 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $186$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($9 | 0, i64toi32_i32$5 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $188 = i64toi32_i32$0;
  $188$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $186$hi;
  i64toi32_i32$2 = $186;
  i64toi32_i32$0 = $188$hi;
  i64toi32_i32$3 = $188;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $189 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $189$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $191 = i64toi32_i32$2;
  $191$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $189$hi;
  i64toi32_i32$5 = $189;
  i64toi32_i32$2 = $191$hi;
  i64toi32_i32$3 = $191;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$5 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$2;
  return i64toi32_i32$5 | 0;
 }
 
 function hashbrown__map__make_hash__ha12e1e34616aa6c4($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $8$hi = 0, $7$hi = 0, $7 = 0, $8 = 0, $9$hi = 0, $9 = 0, $10$hi = 0, $10 = 0, $11$hi = 0, $2 = 0, $11 = 0, $12$hi = 0, $12 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $92 = 0, $25 = 0, $30 = 0, $37 = 0, $45 = 0, $68 = 0, $68$hi = 0, $69 = 0, $69$hi = 0, $71$hi = 0, $76 = 0, $76$hi = 0, $82 = 0, $82$hi = 0, $87 = 0, $87$hi = 0, $91 = 0, $91$hi = 0, $94$hi = 0, $101 = 0, $101$hi = 0, $107 = 0, $107$hi = 0, $109 = 0, $109$hi = 0, $111$hi = 0, $117 = 0, $117$hi = 0, $123 = 0, $123$hi = 0, $126 = 0, $126$hi = 0, $127 = 0, $127$hi = 0, $129$hi = 0, $134 = 0, $134$hi = 0, $141 = 0, $141$hi = 0, $142 = 0, $142$hi = 0, $144$hi = 0, $149 = 0, $149$hi = 0, $156 = 0, $156$hi = 0, $157 = 0, $157$hi = 0, $159$hi = 0, $164 = 0, $164$hi = 0, $167$hi = 0, $169 = 0, $169$hi = 0, $171$hi = 0, $176 = 0, $176$hi = 0, $182$hi = 0, $93 = 0, $185 = 0, $185$hi = 0, $186 = 0, $186$hi = 0, $188 = 0, $188$hi = 0, $189 = 0, $189$hi = 0, $191 = 0, $191$hi = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  $3 = $2 + 64 | 0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = $2 + 48 | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = 1952801890;
  i64toi32_i32$3 = 2037671283;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $25 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $4;
  HEAP32[i64toi32_i32$2 >> 2] = $25;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  $5 = $2 + 40 | 0;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$1 = $7;
  i64toi32_i32$2 = 1685025377;
  i64toi32_i32$3 = 1852075885;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $30 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $5;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  $6 = $2 + 32 | 0;
  i64toi32_i32$0 = $0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$2;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$2 = 1819895653;
  i64toi32_i32$3 = 1852142177;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $37 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $6;
  HEAP32[i64toi32_i32$0 >> 2] = $37;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$0 = $2;
  i64toi32_i32$2 = 0;
  HEAP32[(i64toi32_i32$0 + 56 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 60 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$1 = $8;
  i64toi32_i32$0 = 1936682341;
  i64toi32_i32$3 = 1886610805;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $45 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $2;
  HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = $45;
  HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 76 | 0) >> 2] = 28;
  $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_2(i64toi32_i32$1 + 8 | 0 | 0, i64toi32_i32$1 + 76 | 0 | 0, 4 | 0);
  $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_2(i64toi32_i32$1 + 8 | 0 | 0, $1 | 0, 28 | 0);
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = 0;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $6;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $12 = i64toi32_i32$1;
  $12$hi = i64toi32_i32$0;
  global$0 = i64toi32_i32$2 + 80 | 0;
  i64toi32_i32$0 = $10$hi;
  $68 = $10;
  $68$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  $69 = $9;
  $69$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$2 = $8;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $92 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $92 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $71$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $69$hi;
  i64toi32_i32$0 = $69;
  i64toi32_i32$2 = $71$hi;
  i64toi32_i32$3 = $92;
  i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
  $8 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $68$hi;
  i64toi32_i32$1 = $68;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $9 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($9 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $76 = i64toi32_i32$1;
  $76$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$4;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $76$hi;
  i64toi32_i32$0 = $76;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$2;
  $82 = $10;
  $82$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$5 = $7;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $87 = i64toi32_i32$5;
  $87$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $82$hi;
  i64toi32_i32$2 = $82;
  i64toi32_i32$5 = $87$hi;
  i64toi32_i32$3 = $87;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $12 = i64toi32_i32$0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $91 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $91$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($7 | 0, i64toi32_i32$2 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $94$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$2 = $94$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $8 = i64toi32_i32$5;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 17 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $101 = i64toi32_i32$2;
  $101$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$2 = $101$hi;
  i64toi32_i32$3 = $101;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $91$hi;
  i64toi32_i32$0 = $91;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $107 = i64toi32_i32$0;
  $107$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = $107$hi;
  i64toi32_i32$3 = $107;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $7 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$0;
  $109 = $7;
  $109$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($10 | 0, i64toi32_i32$0 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $111$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$0 = $111$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $10$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($8 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 255;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $117 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $117$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$2 = $10;
  i64toi32_i32$0 = $117$hi;
  i64toi32_i32$3 = $117;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $8 = i64toi32_i32$4;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $109$hi;
  i64toi32_i32$5 = $109;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$0;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 17 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $123 = i64toi32_i32$5;
  $123$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$5 = $123$hi;
  i64toi32_i32$3 = $123;
  i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
  $7 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$5;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $126 = i64toi32_i32$1;
  $126$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  $127 = $7;
  $127$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$5 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $129$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $8$hi;
  i64toi32_i32$5 = $129$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $8 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($9 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $134 = i64toi32_i32$4;
  $134$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$5 = $8;
  i64toi32_i32$4 = $134$hi;
  i64toi32_i32$3 = $134;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $9 = i64toi32_i32$2;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $127$hi;
  i64toi32_i32$1 = $127;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$4;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $126$hi;
  i64toi32_i32$0 = $126;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($10 | 0, i64toi32_i32$1 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $141 = i64toi32_i32$0;
  $141$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $10$hi;
  $142 = $10;
  $142$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($8 | 0, i64toi32_i32$1 | 0, 21 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $144$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$1 = $144$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $8 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $149 = i64toi32_i32$2;
  $149$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$1 = $8;
  i64toi32_i32$2 = $149$hi;
  i64toi32_i32$3 = $149;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $9 = i64toi32_i32$5;
  $9$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $142$hi;
  i64toi32_i32$0 = $142;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $10 = i64toi32_i32$2;
  $10$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $141$hi;
  i64toi32_i32$4 = $141;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $11 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $156 = i64toi32_i32$4;
  $156$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  $157 = $11;
  $157$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($8 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $159$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $159$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $8 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $164 = i64toi32_i32$5;
  $164$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$0 = $8;
  i64toi32_i32$5 = $164$hi;
  i64toi32_i32$3 = $164;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$1;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $157$hi;
  i64toi32_i32$4 = $157;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $167$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $156$hi;
  i64toi32_i32$2 = $156;
  i64toi32_i32$4 = $167$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $9 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $9$hi = i64toi32_i32$4;
  $169 = $9;
  $169$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($8 | 0, i64toi32_i32$4 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $171$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$4 = $171$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $176 = i64toi32_i32$1;
  $176$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = $7;
  i64toi32_i32$1 = $176$hi;
  i64toi32_i32$3 = $176;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $169$hi;
  i64toi32_i32$2 = $169;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $10 = i64toi32_i32$1;
  $10$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $182$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$0 = $182$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $93 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($93 | 0, i64toi32_i32$2 | 0, 21 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $185 = i64toi32_i32$5;
  $185$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$5 = $185$hi;
  i64toi32_i32$3 = $185;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $186 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $186$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($9 | 0, i64toi32_i32$5 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $188 = i64toi32_i32$0;
  $188$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $186$hi;
  i64toi32_i32$2 = $186;
  i64toi32_i32$0 = $188$hi;
  i64toi32_i32$3 = $188;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $189 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $189$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $191 = i64toi32_i32$2;
  $191$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $189$hi;
  i64toi32_i32$5 = $189;
  i64toi32_i32$2 = $191$hi;
  i64toi32_i32$3 = $191;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$5 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$2;
  return i64toi32_i32$5 | 0;
 }
 
 function hashbrown__map__make_hash__h3827262269fc5d43($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $8$hi = 0, $7$hi = 0, $7 = 0, $8 = 0, $9$hi = 0, $9 = 0, $10$hi = 0, $10 = 0, $11$hi = 0, $2 = 0, $11 = 0, $12$hi = 0, $12 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $92 = 0, $25 = 0, $30 = 0, $37 = 0, $45 = 0, $68 = 0, $68$hi = 0, $69 = 0, $69$hi = 0, $71$hi = 0, $76 = 0, $76$hi = 0, $82 = 0, $82$hi = 0, $87 = 0, $87$hi = 0, $91 = 0, $91$hi = 0, $94$hi = 0, $101 = 0, $101$hi = 0, $107 = 0, $107$hi = 0, $109 = 0, $109$hi = 0, $111$hi = 0, $117 = 0, $117$hi = 0, $123 = 0, $123$hi = 0, $126 = 0, $126$hi = 0, $127 = 0, $127$hi = 0, $129$hi = 0, $134 = 0, $134$hi = 0, $141 = 0, $141$hi = 0, $142 = 0, $142$hi = 0, $144$hi = 0, $149 = 0, $149$hi = 0, $156 = 0, $156$hi = 0, $157 = 0, $157$hi = 0, $159$hi = 0, $164 = 0, $164$hi = 0, $167$hi = 0, $169 = 0, $169$hi = 0, $171$hi = 0, $176 = 0, $176$hi = 0, $182$hi = 0, $93 = 0, $185 = 0, $185$hi = 0, $186 = 0, $186$hi = 0, $188 = 0, $188$hi = 0, $189 = 0, $189$hi = 0, $191 = 0, $191$hi = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  $3 = $2 + 64 | 0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = $2 + 48 | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = 1952801890;
  i64toi32_i32$3 = 2037671283;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $25 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $4;
  HEAP32[i64toi32_i32$2 >> 2] = $25;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  $5 = $2 + 40 | 0;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$1 = $7;
  i64toi32_i32$2 = 1685025377;
  i64toi32_i32$3 = 1852075885;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $30 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $5;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  $6 = $2 + 32 | 0;
  i64toi32_i32$0 = $0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$2;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$2 = 1819895653;
  i64toi32_i32$3 = 1852142177;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $37 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $6;
  HEAP32[i64toi32_i32$0 >> 2] = $37;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$0 = $2;
  i64toi32_i32$2 = 0;
  HEAP32[(i64toi32_i32$0 + 56 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 60 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$1 = $8;
  i64toi32_i32$0 = 1936682341;
  i64toi32_i32$3 = 1886610805;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $45 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $2;
  HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = $45;
  HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 76 | 0) >> 2] = 28;
  $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_2(i64toi32_i32$1 + 8 | 0 | 0, i64toi32_i32$1 + 76 | 0 | 0, 4 | 0);
  $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_2(i64toi32_i32$1 + 8 | 0 | 0, $1 | 0, 28 | 0);
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = 0;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $6;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $12 = i64toi32_i32$1;
  $12$hi = i64toi32_i32$0;
  global$0 = i64toi32_i32$2 + 80 | 0;
  i64toi32_i32$0 = $10$hi;
  $68 = $10;
  $68$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  $69 = $9;
  $69$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$2 = $8;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $92 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $92 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $71$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $69$hi;
  i64toi32_i32$0 = $69;
  i64toi32_i32$2 = $71$hi;
  i64toi32_i32$3 = $92;
  i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
  $8 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $68$hi;
  i64toi32_i32$1 = $68;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $9 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($9 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $76 = i64toi32_i32$1;
  $76$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$4;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $76$hi;
  i64toi32_i32$0 = $76;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$2;
  $82 = $10;
  $82$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$5 = $7;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $87 = i64toi32_i32$5;
  $87$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $82$hi;
  i64toi32_i32$2 = $82;
  i64toi32_i32$5 = $87$hi;
  i64toi32_i32$3 = $87;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $12 = i64toi32_i32$0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $91 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $91$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($7 | 0, i64toi32_i32$2 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $94$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$2 = $94$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $8 = i64toi32_i32$5;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 17 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $101 = i64toi32_i32$2;
  $101$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$2 = $101$hi;
  i64toi32_i32$3 = $101;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $91$hi;
  i64toi32_i32$0 = $91;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $107 = i64toi32_i32$0;
  $107$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = $107$hi;
  i64toi32_i32$3 = $107;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $7 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$0;
  $109 = $7;
  $109$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($10 | 0, i64toi32_i32$0 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $111$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$0 = $111$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $10$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($8 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 255;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $117 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $117$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$2 = $10;
  i64toi32_i32$0 = $117$hi;
  i64toi32_i32$3 = $117;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $8 = i64toi32_i32$4;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $109$hi;
  i64toi32_i32$5 = $109;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$0;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 17 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $123 = i64toi32_i32$5;
  $123$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$5 = $123$hi;
  i64toi32_i32$3 = $123;
  i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
  $7 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$5;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $126 = i64toi32_i32$1;
  $126$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  $127 = $7;
  $127$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$5 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $129$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $8$hi;
  i64toi32_i32$5 = $129$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $8 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($9 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $134 = i64toi32_i32$4;
  $134$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$5 = $8;
  i64toi32_i32$4 = $134$hi;
  i64toi32_i32$3 = $134;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $9 = i64toi32_i32$2;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $127$hi;
  i64toi32_i32$1 = $127;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$4;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $126$hi;
  i64toi32_i32$0 = $126;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($10 | 0, i64toi32_i32$1 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $141 = i64toi32_i32$0;
  $141$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $10$hi;
  $142 = $10;
  $142$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($8 | 0, i64toi32_i32$1 | 0, 21 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $144$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$1 = $144$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $8 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $149 = i64toi32_i32$2;
  $149$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$1 = $8;
  i64toi32_i32$2 = $149$hi;
  i64toi32_i32$3 = $149;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $9 = i64toi32_i32$5;
  $9$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $142$hi;
  i64toi32_i32$0 = $142;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $10 = i64toi32_i32$2;
  $10$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $141$hi;
  i64toi32_i32$4 = $141;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $11 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $156 = i64toi32_i32$4;
  $156$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  $157 = $11;
  $157$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($8 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $159$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $159$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $8 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $164 = i64toi32_i32$5;
  $164$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$0 = $8;
  i64toi32_i32$5 = $164$hi;
  i64toi32_i32$3 = $164;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$1;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $157$hi;
  i64toi32_i32$4 = $157;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $167$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $156$hi;
  i64toi32_i32$2 = $156;
  i64toi32_i32$4 = $167$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $9 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $9$hi = i64toi32_i32$4;
  $169 = $9;
  $169$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($8 | 0, i64toi32_i32$4 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $171$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$4 = $171$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $176 = i64toi32_i32$1;
  $176$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = $7;
  i64toi32_i32$1 = $176$hi;
  i64toi32_i32$3 = $176;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $169$hi;
  i64toi32_i32$2 = $169;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $10 = i64toi32_i32$1;
  $10$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $182$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$0 = $182$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $93 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($93 | 0, i64toi32_i32$2 | 0, 21 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $185 = i64toi32_i32$5;
  $185$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$5 = $185$hi;
  i64toi32_i32$3 = $185;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $186 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $186$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($9 | 0, i64toi32_i32$5 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $188 = i64toi32_i32$0;
  $188$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $186$hi;
  i64toi32_i32$2 = $186;
  i64toi32_i32$0 = $188$hi;
  i64toi32_i32$3 = $188;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $189 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $189$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $191 = i64toi32_i32$2;
  $191$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $189$hi;
  i64toi32_i32$5 = $189;
  i64toi32_i32$2 = $191$hi;
  i64toi32_i32$3 = $191;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$5 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$2;
  return i64toi32_i32$5 | 0;
 }
 
 function hashbrown__map__make_hash__h23b6f8362e6133c3($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $8$hi = 0, $7$hi = 0, $7 = 0, $8 = 0, $9$hi = 0, $9 = 0, $10$hi = 0, $10 = 0, $11$hi = 0, $2 = 0, $11 = 0, $12$hi = 0, $12 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $92 = 0, $25 = 0, $30 = 0, $37 = 0, $45 = 0, $68 = 0, $68$hi = 0, $69 = 0, $69$hi = 0, $71$hi = 0, $76 = 0, $76$hi = 0, $82 = 0, $82$hi = 0, $87 = 0, $87$hi = 0, $91 = 0, $91$hi = 0, $94$hi = 0, $101 = 0, $101$hi = 0, $107 = 0, $107$hi = 0, $109 = 0, $109$hi = 0, $111$hi = 0, $117 = 0, $117$hi = 0, $123 = 0, $123$hi = 0, $126 = 0, $126$hi = 0, $127 = 0, $127$hi = 0, $129$hi = 0, $134 = 0, $134$hi = 0, $141 = 0, $141$hi = 0, $142 = 0, $142$hi = 0, $144$hi = 0, $149 = 0, $149$hi = 0, $156 = 0, $156$hi = 0, $157 = 0, $157$hi = 0, $159$hi = 0, $164 = 0, $164$hi = 0, $167$hi = 0, $169 = 0, $169$hi = 0, $171$hi = 0, $176 = 0, $176$hi = 0, $182$hi = 0, $93 = 0, $185 = 0, $185$hi = 0, $186 = 0, $186$hi = 0, $188 = 0, $188$hi = 0, $189 = 0, $189$hi = 0, $191 = 0, $191$hi = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  $3 = $2 + 64 | 0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = $2 + 48 | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = 1952801890;
  i64toi32_i32$3 = 2037671283;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $25 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $4;
  HEAP32[i64toi32_i32$2 >> 2] = $25;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  $5 = $2 + 40 | 0;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$1 = $7;
  i64toi32_i32$2 = 1685025377;
  i64toi32_i32$3 = 1852075885;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $30 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $5;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  $6 = $2 + 32 | 0;
  i64toi32_i32$0 = $0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$2;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$2 = 1819895653;
  i64toi32_i32$3 = 1852142177;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $37 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $6;
  HEAP32[i64toi32_i32$0 >> 2] = $37;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$0 = $2;
  i64toi32_i32$2 = 0;
  HEAP32[(i64toi32_i32$0 + 56 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 60 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$1 = $8;
  i64toi32_i32$0 = 1936682341;
  i64toi32_i32$3 = 1886610805;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $45 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $2;
  HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = $45;
  HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 76 | 0) >> 2] = 28;
  $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_2(i64toi32_i32$1 + 8 | 0 | 0, i64toi32_i32$1 + 76 | 0 | 0, 4 | 0);
  $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_2(i64toi32_i32$1 + 8 | 0 | 0, $1 | 0, 28 | 0);
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = 0;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $6;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $12 = i64toi32_i32$1;
  $12$hi = i64toi32_i32$0;
  global$0 = i64toi32_i32$2 + 80 | 0;
  i64toi32_i32$0 = $10$hi;
  $68 = $10;
  $68$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  $69 = $9;
  $69$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$2 = $8;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $92 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $92 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $71$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $69$hi;
  i64toi32_i32$0 = $69;
  i64toi32_i32$2 = $71$hi;
  i64toi32_i32$3 = $92;
  i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
  $8 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $68$hi;
  i64toi32_i32$1 = $68;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $9 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($9 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $76 = i64toi32_i32$1;
  $76$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$4;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $76$hi;
  i64toi32_i32$0 = $76;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$2;
  $82 = $10;
  $82$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$5 = $7;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $87 = i64toi32_i32$5;
  $87$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $82$hi;
  i64toi32_i32$2 = $82;
  i64toi32_i32$5 = $87$hi;
  i64toi32_i32$3 = $87;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $12 = i64toi32_i32$0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $91 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $91$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($7 | 0, i64toi32_i32$2 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $94$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$2 = $94$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $8 = i64toi32_i32$5;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 17 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $101 = i64toi32_i32$2;
  $101$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$2 = $101$hi;
  i64toi32_i32$3 = $101;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $91$hi;
  i64toi32_i32$0 = $91;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $107 = i64toi32_i32$0;
  $107$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = $107$hi;
  i64toi32_i32$3 = $107;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $7 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$0;
  $109 = $7;
  $109$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($10 | 0, i64toi32_i32$0 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $111$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$0 = $111$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $10$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($8 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 255;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $117 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $117$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$2 = $10;
  i64toi32_i32$0 = $117$hi;
  i64toi32_i32$3 = $117;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $8 = i64toi32_i32$4;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $109$hi;
  i64toi32_i32$5 = $109;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$0;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 17 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $123 = i64toi32_i32$5;
  $123$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$5 = $123$hi;
  i64toi32_i32$3 = $123;
  i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
  $7 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$5;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $126 = i64toi32_i32$1;
  $126$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  $127 = $7;
  $127$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$5 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $129$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $8$hi;
  i64toi32_i32$5 = $129$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $8 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($9 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $134 = i64toi32_i32$4;
  $134$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$5 = $8;
  i64toi32_i32$4 = $134$hi;
  i64toi32_i32$3 = $134;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $9 = i64toi32_i32$2;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $127$hi;
  i64toi32_i32$1 = $127;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$4;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $126$hi;
  i64toi32_i32$0 = $126;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($10 | 0, i64toi32_i32$1 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $141 = i64toi32_i32$0;
  $141$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $10$hi;
  $142 = $10;
  $142$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($8 | 0, i64toi32_i32$1 | 0, 21 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $144$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$1 = $144$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $8 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $149 = i64toi32_i32$2;
  $149$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$1 = $8;
  i64toi32_i32$2 = $149$hi;
  i64toi32_i32$3 = $149;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $9 = i64toi32_i32$5;
  $9$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $142$hi;
  i64toi32_i32$0 = $142;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $10 = i64toi32_i32$2;
  $10$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $141$hi;
  i64toi32_i32$4 = $141;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $11 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $156 = i64toi32_i32$4;
  $156$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  $157 = $11;
  $157$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($8 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $159$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $159$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $8 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $164 = i64toi32_i32$5;
  $164$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$0 = $8;
  i64toi32_i32$5 = $164$hi;
  i64toi32_i32$3 = $164;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$1;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $157$hi;
  i64toi32_i32$4 = $157;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $167$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $156$hi;
  i64toi32_i32$2 = $156;
  i64toi32_i32$4 = $167$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $9 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $9$hi = i64toi32_i32$4;
  $169 = $9;
  $169$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($8 | 0, i64toi32_i32$4 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $171$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$4 = $171$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $176 = i64toi32_i32$1;
  $176$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = $7;
  i64toi32_i32$1 = $176$hi;
  i64toi32_i32$3 = $176;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $169$hi;
  i64toi32_i32$2 = $169;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $10 = i64toi32_i32$1;
  $10$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $182$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$0 = $182$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $93 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($93 | 0, i64toi32_i32$2 | 0, 21 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $185 = i64toi32_i32$5;
  $185$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$5 = $185$hi;
  i64toi32_i32$3 = $185;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $186 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $186$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($9 | 0, i64toi32_i32$5 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $188 = i64toi32_i32$0;
  $188$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $186$hi;
  i64toi32_i32$2 = $186;
  i64toi32_i32$0 = $188$hi;
  i64toi32_i32$3 = $188;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $189 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $189$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $191 = i64toi32_i32$2;
  $191$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $189$hi;
  i64toi32_i32$5 = $189;
  i64toi32_i32$2 = $191$hi;
  i64toi32_i32$3 = $191;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$5 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$2;
  return i64toi32_i32$5 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert__h100db9f5a34c2994($0, $1, $2, $3, $4, $5) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  $5 = $5 | 0;
  var i64toi32_i32$2 = 0, $6 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $20 = 0, $21 = 0, $7 = 0, $8 = 0, $61 = 0, $67 = 0, $70 = 0, $79 = 0, $118 = 0, $124 = 0, $127 = 0, $136 = 0;
  $6 = global$0 - 128 | 0;
  global$0 = $6;
  label$1 : {
   label$2 : {
    $7 = HEAP32[$1 >> 2] | 0;
    if (($7 + -1 | 0 | 0) != ($4 | 0)) {
     break label$2
    }
    label$3 : {
     label$4 : {
      label$5 : {
       $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
       if ((HEAPU16[($4 + 138 | 0) >> 1] | 0) >>> 0 < 11 >>> 0) {
        break label$5
       }
       alloc__collections__btree__node__splitpoint__h8424344594b4deb1($6 + 8 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
       $1 = HEAP32[($6 + 16 | 0) >> 2] | 0;
       $8 = HEAP32[($6 + 12 | 0) >> 2] | 0;
       HEAP32[($6 + 88 | 0) >> 2] = HEAP32[($6 + 8 | 0) >> 2] | 0;
       HEAP32[($6 + 84 | 0) >> 2] = $4;
       HEAP32[($6 + 80 | 0) >> 2] = $7;
       alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__KV___split__h15f5c8143ad0ad96($6 + 8 | 0 | 0, $6 + 80 | 0 | 0);
       if (($8 | 0) == (1 | 0)) {
        break label$4
       }
       HEAP32[($6 + 64 | 0) >> 2] = HEAP32[($6 + 8 | 0) >> 2] | 0;
       $4 = HEAP32[($6 + 12 | 0) >> 2] | 0;
       break label$3;
      }
      $20 = $2 + 24 | 0;
      HEAP32[(($6 + 8 | 0) + 24 | 0) >> 2] = HEAPU8[$20 >> 0] | 0 | ((HEAPU8[($20 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($20 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($20 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$2 = $2 + 16 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $61 = i64toi32_i32$0;
      i64toi32_i32$0 = ($6 + 8 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $61;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $2 + 8 | 0;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $67 = i64toi32_i32$1;
      i64toi32_i32$1 = ($6 + 8 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $67;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $2;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $70 = i64toi32_i32$0;
      i64toi32_i32$0 = $6;
      HEAP32[($6 + 8 | 0) >> 2] = $70;
      HEAP32[($6 + 12 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[(($6 + 80 | 0) + 8 | 0) >> 2] = HEAP32[($3 + 8 | 0) >> 2] | 0;
      i64toi32_i32$2 = $3;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $79 = i64toi32_i32$1;
      i64toi32_i32$1 = $6;
      HEAP32[($6 + 80 | 0) >> 2] = $79;
      HEAP32[($6 + 84 | 0) >> 2] = i64toi32_i32$0;
      alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert_fit__h49acceb5a90505ee($1 | 0, $6 + 8 | 0 | 0, $6 + 80 | 0 | 0, $6 | 0, $5 | 0);
      HEAP32[($0 + 8 | 0) >> 2] = $4;
      HEAP32[($0 + 4 | 0) >> 2] = $7;
      HEAP32[$0 >> 2] = 0;
      HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
      break label$1;
     }
     HEAP32[($6 + 64 | 0) >> 2] = HEAP32[($6 + 56 | 0) >> 2] | 0;
     $4 = HEAP32[($6 + 60 | 0) >> 2] | 0;
    }
    HEAP32[($6 + 72 | 0) >> 2] = $1;
    HEAP32[($6 + 68 | 0) >> 2] = $4;
    $21 = $2 + 24 | 0;
    HEAP32[(($6 + 80 | 0) + 24 | 0) >> 2] = HEAPU8[$21 >> 0] | 0 | ((HEAPU8[($21 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($21 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($21 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$2 = $2 + 16 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $118 = i64toi32_i32$0;
    i64toi32_i32$0 = ($6 + 80 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $118;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $2 + 8 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $124 = i64toi32_i32$1;
    i64toi32_i32$1 = ($6 + 80 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $124;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $127 = i64toi32_i32$0;
    i64toi32_i32$0 = $6;
    HEAP32[($6 + 80 | 0) >> 2] = $127;
    HEAP32[($6 + 84 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(($6 + 112 | 0) + 8 | 0) >> 2] = HEAP32[($3 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $136 = i64toi32_i32$1;
    i64toi32_i32$1 = $6;
    HEAP32[($6 + 112 | 0) >> 2] = $136;
    HEAP32[($6 + 116 | 0) >> 2] = i64toi32_i32$0;
    alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert_fit__h49acceb5a90505ee($6 + 64 | 0 | 0, $6 + 80 | 0 | 0, $6 + 112 | 0 | 0, $6 | 0, $5 | 0);
    memcpy($0 + 4 | 0 | 0, $6 + 8 | 0 | 0, 56 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    break label$1;
   }
   core__panicking__panic__h2fd385a887c8bf13(1049076 | 0, 53 | 0, 1049132 | 0);
   abort();
  }
  global$0 = $6 + 128 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert__had2107e19eda647d($0, $1, $2, $3, $4, $5) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  $5 = $5 | 0;
  var i64toi32_i32$2 = 0, $6 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $20 = 0, $21 = 0, $7 = 0, $8 = 0, $61 = 0, $67 = 0, $70 = 0, $79 = 0, $118 = 0, $124 = 0, $127 = 0, $136 = 0;
  $6 = global$0 - 128 | 0;
  global$0 = $6;
  label$1 : {
   label$2 : {
    $7 = HEAP32[$1 >> 2] | 0;
    if (($7 + -1 | 0 | 0) != ($4 | 0)) {
     break label$2
    }
    label$3 : {
     label$4 : {
      label$5 : {
       $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
       if ((HEAPU16[($4 + 138 | 0) >> 1] | 0) >>> 0 < 11 >>> 0) {
        break label$5
       }
       alloc__collections__btree__node__splitpoint__h8424344594b4deb1($6 + 8 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
       $1 = HEAP32[($6 + 16 | 0) >> 2] | 0;
       $8 = HEAP32[($6 + 12 | 0) >> 2] | 0;
       HEAP32[($6 + 88 | 0) >> 2] = HEAP32[($6 + 8 | 0) >> 2] | 0;
       HEAP32[($6 + 84 | 0) >> 2] = $4;
       HEAP32[($6 + 80 | 0) >> 2] = $7;
       alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__KV___split__h2a00cf835388566b($6 + 8 | 0 | 0, $6 + 80 | 0 | 0);
       if (($8 | 0) == (1 | 0)) {
        break label$4
       }
       HEAP32[($6 + 64 | 0) >> 2] = HEAP32[($6 + 8 | 0) >> 2] | 0;
       $4 = HEAP32[($6 + 12 | 0) >> 2] | 0;
       break label$3;
      }
      $20 = $2 + 24 | 0;
      HEAP32[(($6 + 8 | 0) + 24 | 0) >> 2] = HEAPU8[$20 >> 0] | 0 | ((HEAPU8[($20 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($20 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($20 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$2 = $2 + 16 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $61 = i64toi32_i32$0;
      i64toi32_i32$0 = ($6 + 8 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $61;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $2 + 8 | 0;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $67 = i64toi32_i32$1;
      i64toi32_i32$1 = ($6 + 8 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $67;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $2;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $70 = i64toi32_i32$0;
      i64toi32_i32$0 = $6;
      HEAP32[($6 + 8 | 0) >> 2] = $70;
      HEAP32[($6 + 12 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[(($6 + 80 | 0) + 8 | 0) >> 2] = HEAP32[($3 + 8 | 0) >> 2] | 0;
      i64toi32_i32$2 = $3;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $79 = i64toi32_i32$1;
      i64toi32_i32$1 = $6;
      HEAP32[($6 + 80 | 0) >> 2] = $79;
      HEAP32[($6 + 84 | 0) >> 2] = i64toi32_i32$0;
      alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert_fit__h98aecfda81b312ad($1 | 0, $6 + 8 | 0 | 0, $6 + 80 | 0 | 0, $6 | 0, $5 | 0);
      HEAP32[($0 + 8 | 0) >> 2] = $4;
      HEAP32[($0 + 4 | 0) >> 2] = $7;
      HEAP32[$0 >> 2] = 0;
      HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
      break label$1;
     }
     HEAP32[($6 + 64 | 0) >> 2] = HEAP32[($6 + 56 | 0) >> 2] | 0;
     $4 = HEAP32[($6 + 60 | 0) >> 2] | 0;
    }
    HEAP32[($6 + 72 | 0) >> 2] = $1;
    HEAP32[($6 + 68 | 0) >> 2] = $4;
    $21 = $2 + 24 | 0;
    HEAP32[(($6 + 80 | 0) + 24 | 0) >> 2] = HEAPU8[$21 >> 0] | 0 | ((HEAPU8[($21 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($21 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($21 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$2 = $2 + 16 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $118 = i64toi32_i32$0;
    i64toi32_i32$0 = ($6 + 80 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $118;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $2 + 8 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $124 = i64toi32_i32$1;
    i64toi32_i32$1 = ($6 + 80 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $124;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $127 = i64toi32_i32$0;
    i64toi32_i32$0 = $6;
    HEAP32[($6 + 80 | 0) >> 2] = $127;
    HEAP32[($6 + 84 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(($6 + 112 | 0) + 8 | 0) >> 2] = HEAP32[($3 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $136 = i64toi32_i32$1;
    i64toi32_i32$1 = $6;
    HEAP32[($6 + 112 | 0) >> 2] = $136;
    HEAP32[($6 + 116 | 0) >> 2] = i64toi32_i32$0;
    alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert_fit__h98aecfda81b312ad($6 + 64 | 0 | 0, $6 + 80 | 0 | 0, $6 + 112 | 0 | 0, $6 | 0, $5 | 0);
    memcpy($0 + 4 | 0 | 0, $6 + 8 | 0 | 0, 56 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    break label$1;
   }
   core__panicking__panic__h2fd385a887c8bf13(1049076 | 0, 53 | 0, 1049132 | 0);
   abort();
  }
  global$0 = $6 + 128 | 0;
 }
 
 function headerbody_new_headerbody($0, $1, $2, $3, $4, $5, $6, $7, $8, $9, $10) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  $5 = $5 | 0;
  $6 = $6 | 0;
  $7 = $7 | 0;
  $8 = $8 | 0;
  $9 = $9 | 0;
  $10 = $10 | 0;
  var $11 = 0, $13 = 0, $12 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0;
  $11 = global$0 - 736 | 0;
  global$0 = $11;
  label$1 : {
   if (!$1) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($11 + 64 | 0 | 0, $1 | 0);
   $1 = HEAP32[($11 + 68 | 0) >> 2] | 0;
   $12 = HEAP32[($11 + 64 | 0) >> 2] | 0;
   label$2 : {
    label$3 : {
     if ($2) {
      break label$3
     }
     $13 = 0;
     break label$2;
    }
    $13 = 1;
    $cardano_serialization_lib__crypto__BlockHash_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hb6c73b3486e647eb($11 + 384 | 0 | 1 | 0 | 0, $2 | 0);
   }
   HEAP8[($11 + 384 | 0) >> 0] = $13;
   if (!$3) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h38603c546ca761f2($11 + 56 | 0 | 0, $3 | 0);
   if (!$4) {
    break label$1
   }
   $3 = HEAP32[($11 + 60 | 0) >> 2] | 0;
   $2 = HEAP32[($11 + 56 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h358f17571789b373($11 + 48 | 0 | 0, $4 | 0);
   if (!$5) {
    break label$1
   }
   $4 = HEAP32[($11 + 52 | 0) >> 2] | 0;
   $13 = HEAP32[($11 + 48 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h1a6acf099b73960c($11 + 40 | 0 | 0, $5 | 0);
   if (!$6) {
    break label$1
   }
   $5 = HEAP32[($11 + 44 | 0) >> 2] | 0;
   $14 = HEAP32[($11 + 40 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h1a6acf099b73960c($11 + 32 | 0 | 0, $6 | 0);
   if (!$8) {
    break label$1
   }
   $6 = HEAP32[($11 + 36 | 0) >> 2] | 0;
   $15 = HEAP32[($11 + 32 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h449d6579c00e5aca($11 + 24 | 0 | 0, $8 | 0);
   if (!$9) {
    break label$1
   }
   $8 = HEAP32[($11 + 28 | 0) >> 2] | 0;
   $16 = HEAP32[($11 + 24 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h4b15d475a6cbc138($11 + 16 | 0 | 0, $9 | 0);
   if (!$10) {
    break label$1
   }
   $9 = HEAP32[($11 + 20 | 0) >> 2] | 0;
   $17 = HEAP32[($11 + 16 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h42c8face5b925abb($11 + 8 | 0 | 0, $10 | 0);
   $10 = HEAP32[($11 + 12 | 0) >> 2] | 0;
   $18 = HEAP32[($11 + 8 | 0) >> 2] | 0;
   memcpy($11 + 424 | 0 | 0, $11 + 384 | 0 | 0, 33 | 0) | 0;
   cardano_serialization_lib__HeaderBody__new_headerbody__hb0522221521a757d($11 + 72 | 0 | 0, $0 | 0, $12 | 0, $11 + 424 | 0 | 0, $2 | 0, $13 | 0, $14 | 0, $15 | 0, $7 | 0, $16 | 0, $17 | 0, $18 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($10 | 0, (HEAP32[$10 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($9 | 0, (HEAP32[$9 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($8 | 0, (HEAP32[$8 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($6 | 0, (HEAP32[$6 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($5 | 0, (HEAP32[$5 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($4 | 0, (HEAP32[$4 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   memcpy($11 + 424 | 0 | 0, $11 + 72 | 0 | 0, 312 | 0) | 0;
   $1 = $cardano_serialization_lib__HeaderBody_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he5de7ce2c4403ed1($11 + 424 | 0 | 0) | 0;
   global$0 = $11 + 736 | 0;
   return $1 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function cryptoxide__ed25519__signature_extended__h26f216ae968c9eed($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$1 = 0, $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, i64toi32_i32$5 = 0, $34 = 0, $35 = 0, $36 = 0, $37 = 0, $8 = 0, $39 = 0, $40 = 0, $41 = 0, $42 = 0, $9 = 0, $10$hi = 0, $5 = 0, $6 = 0, $7 = 0, $11$hi = 0, $38 = 0, $45 = 0, $52 = 0, $55 = 0, $77 = 0, $10 = 0, $82$hi = 0, $88 = 0, $90 = 0, $90$hi = 0, $93 = 0, $94$hi = 0, $143 = 0, $146 = 0, $151 = 0, $154 = 0;
  $4 = global$0 - 752 | 0;
  global$0 = $4;
  cryptoxide__ed25519__extended_to_public__hb7e9895dfbf0ff6d($4 + 8 | 0 | 0, $3 | 0);
  cryptoxide__ed25519__signature_nonce__h963937328d628fd2($4 + 40 | 0 | 0, $3 | 0, $1 | 0, $2 | 0);
  cryptoxide__curve25519__ge__Ge__scalarmult_base__hfb711866362b33a6($4 + 80 | 0 | 0, $4 + 40 | 0 | 0);
  $0 = memset($0 | 0, 0 | 0, 64 | 0) | 0;
  cryptoxide__curve25519__ge__Ge__to_bytes__hce32fa3f32cec513($0 | 0, $4 + 80 | 0 | 0);
  $5 = $0 + 56 | 0;
  i64toi32_i32$2 = ($4 + 8 | 0) + 24 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $38 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  $34 = $38;
  HEAP8[i64toi32_i32$0 >> 0] = $34;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $34 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $34 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $34 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $6 = $0 + 48 | 0;
  i64toi32_i32$2 = ($4 + 8 | 0) + 16 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $45 = i64toi32_i32$1;
  i64toi32_i32$1 = $6;
  $35 = $45;
  HEAP8[i64toi32_i32$1 >> 0] = $35;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $35 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $35 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $35 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $7 = $0 + 40 | 0;
  i64toi32_i32$2 = ($4 + 8 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $52 = i64toi32_i32$0;
  i64toi32_i32$0 = $7;
  $36 = $52;
  HEAP8[i64toi32_i32$0 >> 0] = $36;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $36 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $36 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $36 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = HEAPU8[($4 + 8 | 0) >> 0] | 0 | ((HEAPU8[($4 + 9 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 10 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 11 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[($4 + 12 | 0) >> 0] | 0 | ((HEAPU8[($4 + 13 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 14 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 15 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $55 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  $37 = $55;
  HEAP8[(i64toi32_i32$1 + 32 | 0) >> 0] = $37;
  HEAP8[(i64toi32_i32$1 + 33 | 0) >> 0] = $37 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 34 | 0) >> 0] = $37 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 35 | 0) >> 0] = $37 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 36 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 37 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 38 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 39 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $8 = memset(($4 + 456 | 0) + 80 | 0 | 0, 0 | 0, 132 | 0) | 0;
  $9 = memcpy(($4 + 456 | 0) + 16 | 0 | 0, 1137368 | 0, 64 | 0) | 0;
  i64toi32_i32$1 = $4;
  i64toi32_i32$0 = 0;
  HEAP32[(i64toi32_i32$1 + 464 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 468 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  HEAP32[(i64toi32_i32$1 + 456 | 0) >> 2] = 64;
  HEAP32[(i64toi32_i32$1 + 460 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 240 | 0) >> 2] = $9;
  cryptoxide__cryptoutil__FixedBuffer_____input__h45eb77880e071f02($8 | 0, $0 | 0, 64 | 0, i64toi32_i32$1 + 240 | 0 | 0);
  memcpy(i64toi32_i32$1 + 240 | 0 | 0, i64toi32_i32$1 + 456 | 0 | 0, 216 | 0) | 0;
  $77 = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 240 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$1 + 244 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  $82$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $10$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = $82$hi;
  i64toi32_i32$3 = $2;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $11$hi = i64toi32_i32$5;
  i64toi32_i32$2 = $77;
  HEAP32[(i64toi32_i32$2 + 240 | 0) >> 2] = i64toi32_i32$4;
  HEAP32[(i64toi32_i32$2 + 244 | 0) >> 2] = i64toi32_i32$5;
  $8 = ($4 + 240 | 0) + 8 | 0;
  $88 = $8;
  i64toi32_i32$1 = $8;
  i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $90 = i64toi32_i32$5;
  $90$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$3 = $10;
  $93 = i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
  i64toi32_i32$1 = 0;
  $94$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $90$hi;
  i64toi32_i32$3 = $90;
  i64toi32_i32$2 = $94$hi;
  i64toi32_i32$5 = $93;
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  i64toi32_i32$3 = $88;
  HEAP32[i64toi32_i32$3 >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$4;
  HEAP32[($4 + 456 | 0) >> 2] = ($4 + 240 | 0) + 16 | 0;
  cryptoxide__cryptoutil__FixedBuffer_____input__h45eb77880e071f02(($4 + 240 | 0) + 80 | 0 | 0, $1 | 0, $2 | 0, $4 + 456 | 0 | 0);
  memcpy($4 + 456 | 0 | 0, $4 + 240 | 0 | 0, 216 | 0) | 0;
  memset($4 + 240 | 0 | 0, 0 | 0, 64 | 0) | 0;
  cryptoxide__hashing__sha2__Engine512__finish__h18b5152b4b76c624($4 + 456 | 0 | 0);
  cryptoxide__cryptoutil__write_u64v_be__h6888df4c897d2bb4($4 + 240 | 0 | 0, 64 | 0, $9 | 0, 8 | 0);
  cryptoxide__curve25519__scalar__scalar64__Scalar__reduce_from_wide_bytes__h35529550345bd5f0($4 + 672 | 0 | 0, $4 + 240 | 0 | 0);
  cryptoxide__curve25519__scalar__scalar64__Scalar__from_bytes__hcfeedd1974a72bb6($4 + 456 | 0 | 0, $3 | 0);
  cryptoxide__curve25519__scalar__scalar64__muladd__h77e24dce4fa4fc8b($4 + 712 | 0 | 0, $4 + 672 | 0 | 0, $4 + 456 | 0 | 0, $4 + 40 | 0 | 0);
  cryptoxide__curve25519__scalar__scalar64__Scalar__to_bytes__h1c79e40f602967bf($4 + 456 | 0 | 0, $4 + 712 | 0 | 0);
  i64toi32_i32$1 = ($4 + 456 | 0) + 24 | 0;
  i64toi32_i32$4 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$3 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $143 = i64toi32_i32$4;
  i64toi32_i32$4 = $5;
  $39 = $143;
  HEAP8[i64toi32_i32$4 >> 0] = $39;
  HEAP8[(i64toi32_i32$4 + 1 | 0) >> 0] = $39 >>> 8 | 0;
  HEAP8[(i64toi32_i32$4 + 2 | 0) >> 0] = $39 >>> 16 | 0;
  HEAP8[(i64toi32_i32$4 + 3 | 0) >> 0] = $39 >>> 24 | 0;
  HEAP8[(i64toi32_i32$4 + 4 | 0) >> 0] = i64toi32_i32$3;
  HEAP8[(i64toi32_i32$4 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
  HEAP8[(i64toi32_i32$4 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
  HEAP8[(i64toi32_i32$4 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
  i64toi32_i32$1 = $9;
  i64toi32_i32$3 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$4 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $146 = i64toi32_i32$3;
  i64toi32_i32$3 = $6;
  $40 = $146;
  HEAP8[i64toi32_i32$3 >> 0] = $40;
  HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $40 >>> 8 | 0;
  HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $40 >>> 16 | 0;
  HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $40 >>> 24 | 0;
  HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$4;
  HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$4 >>> 8 | 0;
  HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$4 >>> 16 | 0;
  HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$4 >>> 24 | 0;
  i64toi32_i32$1 = ($4 + 456 | 0) + 8 | 0;
  i64toi32_i32$4 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$3 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $151 = i64toi32_i32$4;
  i64toi32_i32$4 = $7;
  $41 = $151;
  HEAP8[i64toi32_i32$4 >> 0] = $41;
  HEAP8[(i64toi32_i32$4 + 1 | 0) >> 0] = $41 >>> 8 | 0;
  HEAP8[(i64toi32_i32$4 + 2 | 0) >> 0] = $41 >>> 16 | 0;
  HEAP8[(i64toi32_i32$4 + 3 | 0) >> 0] = $41 >>> 24 | 0;
  HEAP8[(i64toi32_i32$4 + 4 | 0) >> 0] = i64toi32_i32$3;
  HEAP8[(i64toi32_i32$4 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
  HEAP8[(i64toi32_i32$4 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
  HEAP8[(i64toi32_i32$4 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
  i64toi32_i32$1 = $4;
  i64toi32_i32$3 = HEAPU8[(i64toi32_i32$1 + 456 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 457 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 458 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 459 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$4 = HEAPU8[(i64toi32_i32$1 + 460 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 461 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 462 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 463 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $154 = i64toi32_i32$3;
  i64toi32_i32$3 = $0;
  $42 = $154;
  HEAP8[(i64toi32_i32$3 + 32 | 0) >> 0] = $42;
  HEAP8[(i64toi32_i32$3 + 33 | 0) >> 0] = $42 >>> 8 | 0;
  HEAP8[(i64toi32_i32$3 + 34 | 0) >> 0] = $42 >>> 16 | 0;
  HEAP8[(i64toi32_i32$3 + 35 | 0) >> 0] = $42 >>> 24 | 0;
  HEAP8[(i64toi32_i32$3 + 36 | 0) >> 0] = i64toi32_i32$4;
  HEAP8[(i64toi32_i32$3 + 37 | 0) >> 0] = i64toi32_i32$4 >>> 8 | 0;
  HEAP8[(i64toi32_i32$3 + 38 | 0) >> 0] = i64toi32_i32$4 >>> 16 | 0;
  HEAP8[(i64toi32_i32$3 + 39 | 0) >> 0] = i64toi32_i32$4 >>> 24 | 0;
  global$0 = i64toi32_i32$1 + 752 | 0;
 }
 
 function cardano_serialization_lib__Relays__add__h8e92b1d7ff1b47e9($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, $2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $4 = 0, $7 = 0, $30 = 0, $3 = 0, $31 = 0, $8$hi = 0, $32 = 0, $34 = 0, $5 = 0, $6 = 0, $33 = 0, $37 = 0, $41 = 0, $46 = 0, $48 = 0, $8 = 0, $69 = 0, $69$hi = 0, $83 = 0, $87 = 0, $107 = 0, $114 = 0, $117 = 0, $135 = 0, $143 = 0, $147 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    switch (HEAPU16[$1 >> 1] | 0 | 0) {
    default:
     $30 = $1 + 7 | 0;
     $3 = HEAPU8[$30 >> 0] | 0 | ((HEAPU8[($30 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($30 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($30 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $4 = HEAPU8[($1 + 6 | 0) >> 0] | 0;
     $5 = HEAPU16[($1 + 4 | 0) >> 1] | 0;
     $6 = HEAPU16[($1 + 2 | 0) >> 1] | 0;
     $7 = 0;
     label$5 : {
      if ((HEAPU8[($1 + 11 | 0) >> 0] | 0 | 0) != (1 | 0)) {
       break label$5
      }
      i64toi32_i32$2 = $1 + 20 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $33 = i64toi32_i32$0;
      i64toi32_i32$0 = $2 + 8 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $33;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $1 + 12 | 0;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $37 = i64toi32_i32$1;
      i64toi32_i32$1 = $2;
      HEAP32[$2 >> 2] = $37;
      HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$0;
      $7 = 1;
     }
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
     $41 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 44 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $41;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $2 + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $46 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 52 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $46;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     $48 = $2 + 42 | 0;
     i64toi32_i32$0 = 0;
     i64toi32_i32$2 = $3;
     i64toi32_i32$1 = 0;
     i64toi32_i32$3 = 8;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
      $31 = 0;
     } else {
      i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
      $31 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
     }
     i64toi32_i32$4 = ($4 & 255 | 0 | 0) == (1 | 0);
     i64toi32_i32$2 = 0;
     i64toi32_i32$3 = i64toi32_i32$4 ? $31 : 0;
     i64toi32_i32$0 = i64toi32_i32$4 ? i64toi32_i32$1 : i64toi32_i32$2;
     $8 = i64toi32_i32$3;
     $8$hi = i64toi32_i32$0;
     i64toi32_i32$4 = i64toi32_i32$3;
     i64toi32_i32$3 = 0;
     i64toi32_i32$1 = 32;
     i64toi32_i32$2 = i64toi32_i32$1 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
      i64toi32_i32$3 = 0;
      $32 = i64toi32_i32$0 >>> i64toi32_i32$2 | 0;
     } else {
      i64toi32_i32$3 = i64toi32_i32$0 >>> i64toi32_i32$2 | 0;
      $32 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$2 | 0) | 0;
     }
     HEAP8[$48 >> 0] = $32;
     HEAP8[($2 + 43 | 0) >> 0] = $7;
     HEAP16[($2 + 36 | 0) >> 1] = $5;
     HEAP16[($2 + 34 | 0) >> 1] = $6;
     HEAP16[($2 + 32 | 0) >> 1] = 0;
     i64toi32_i32$3 = $8$hi;
     i64toi32_i32$3 = 0;
     i64toi32_i32$0 = $4;
     i64toi32_i32$4 = 0;
     i64toi32_i32$1 = 255;
     i64toi32_i32$4 = i64toi32_i32$3 & i64toi32_i32$4 | 0;
     $69 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
     $69$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $8$hi;
     i64toi32_i32$3 = $8;
     i64toi32_i32$0 = $69$hi;
     i64toi32_i32$1 = $69;
     i64toi32_i32$0 = i64toi32_i32$4 | i64toi32_i32$0 | 0;
     $34 = i64toi32_i32$3 | i64toi32_i32$1 | 0;
     HEAP16[($2 + 38 | 0) >> 1] = $34;
     HEAP16[($2 + 40 | 0) >> 1] = $34 >>> 16 | 0;
     break label$1;
    case 1:
     $4 = HEAP32[($1 + 16 | 0) >> 2] | 0;
     $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($2 | 0, $1 + 4 | 0 | 0);
     HEAP32[($2 + 12 | 0) >> 2] = $4;
     i64toi32_i32$4 = $2 + 8 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
     $83 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 44 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $83;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
     HEAP16[($2 + 32 | 0) >> 1] = 1;
     i64toi32_i32$4 = $2;
     i64toi32_i32$3 = HEAP32[$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
     $87 = i64toi32_i32$3;
     i64toi32_i32$3 = $2;
     HEAP32[($2 + 36 | 0) >> 2] = $87;
     HEAP32[($2 + 40 | 0) >> 2] = i64toi32_i32$0;
     break label$1;
    case 2:
     break label$2;
    };
   }
   $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($2 + 32 | 0 | 4 | 0 | 0, $1 + 4 | 0 | 0);
   HEAP16[($2 + 32 | 0) >> 1] = 2;
  }
  $4 = $2 + 24 | 0;
  HEAP32[$4 >> 2] = HEAP32[(($2 + 32 | 0) + 24 | 0) >> 2] | 0;
  $7 = $2 + 16 | 0;
  i64toi32_i32$4 = ($2 + 32 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
  $107 = i64toi32_i32$0;
  i64toi32_i32$0 = $7;
  HEAP32[i64toi32_i32$0 >> 2] = $107;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
  $3 = $2 + 8 | 0;
  i64toi32_i32$4 = ($2 + 32 | 0) + 8 | 0;
  i64toi32_i32$3 = HEAP32[i64toi32_i32$4 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
  $114 = i64toi32_i32$3;
  i64toi32_i32$3 = $3;
  HEAP32[i64toi32_i32$3 >> 2] = $114;
  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$4 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$3 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $117 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[$2 >> 2] = $117;
  HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$3;
  label$6 : {
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (($1 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
    break label$6
   }
   alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h7f3f684dc85b8ad3($0 | 0, $1 | 0, 1 | 0);
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  }
  $1 = (HEAP32[$0 >> 2] | 0) + Math_imul($1, 28) | 0;
  i64toi32_i32$4 = $2;
  i64toi32_i32$3 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $135 = i64toi32_i32$3;
  i64toi32_i32$3 = $1;
  HEAP32[i64toi32_i32$3 >> 2] = $135;
  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$3 + 24 | 0) >> 2] = HEAP32[$4 >> 2] | 0;
  i64toi32_i32$4 = $7;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
  $143 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $143;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
  i64toi32_i32$4 = $3;
  i64toi32_i32$3 = HEAP32[i64toi32_i32$4 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
  $147 = i64toi32_i32$3;
  i64toi32_i32$3 = $1 + 8 | 0;
  HEAP32[i64toi32_i32$3 >> 2] = $147;
  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
  global$0 = $2 + 64 | 0;
 }
 
 function cardano_serialization_lib__output_builder__TransactionOutputAmountBuilder__with_coin_and_asset__h3912d48b40d60b51($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $4 = 0, $6 = 0, $7 = 0, $5 = 0, $30 = 0, $31 = 0, $32 = 0, $33 = 0, $10 = 0, $10$hi = 0, $8 = 0, $9 = 0, $38 = 0, $46 = 0, $51 = 0, $56 = 0, $60 = 0, $77 = 0, $87 = 0, $94 = 0, $99 = 0, $104 = 0, $108 = 0, $124 = 0, $129 = 0, $136 = 0, $141 = 0;
  $4 = global$0 - 112 | 0;
  global$0 = $4;
  $cardano_serialization_lib__address__Address_20as_20core__clone__Clone___clone__h0eb465a6e349d507_1($4 + 16 | 0 | 0, $1 | 0);
  $5 = 2;
  label$1 : {
   $6 = HEAP32[($1 + 72 | 0) >> 2] | 0;
   if (($6 | 0) == (2 | 0)) {
    break label$1
   }
   i64toi32_i32$2 = $1;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
   $10 = i64toi32_i32$0;
   $10$hi = i64toi32_i32$1;
   $5 = 0;
   label$2 : {
    if (($6 | 0) != (1 | 0)) {
     break label$2
    }
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($4 + 80 | 0 | 4 | 0 | 0, $1 + 76 | 0 | 0);
    $5 = 1;
   }
   HEAP32[($4 + 8 | 0) >> 2] = HEAP32[($4 + 92 | 0) >> 2] | 0;
   i64toi32_i32$2 = $4;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 84 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 88 | 0) >> 2] | 0;
   $38 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[i64toi32_i32$1 >> 2] = $38;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  }
  $6 = 0;
  $7 = 0;
  label$3 : {
   if ((HEAPU8[($1 + 88 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$3
   }
   i64toi32_i32$2 = $1 + 113 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $46 = i64toi32_i32$0;
   i64toi32_i32$0 = $4 + 104 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $46;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1 + 105 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $51 = i64toi32_i32$1;
   i64toi32_i32$1 = $4 + 96 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $51;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $1 + 97 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $56 = i64toi32_i32$0;
   i64toi32_i32$0 = $4 + 88 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $56;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1 + 89 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $60 = i64toi32_i32$1;
   i64toi32_i32$1 = $4;
   HEAP32[(i64toi32_i32$1 + 80 | 0) >> 2] = $60;
   HEAP32[(i64toi32_i32$1 + 84 | 0) >> 2] = i64toi32_i32$0;
   $7 = 1;
  }
  $1 = memcpy($0 | 0, $4 + 16 | 0 | 0, 64 | 0) | 0;
  $0 = $1 + 72 | 0;
  HEAP32[$0 >> 2] = $5;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$1 = $1;
  HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] = $10;
  HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 88 | 0) >> 0] = $7;
  $8 = i64toi32_i32$1 + 76 | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $77 = i64toi32_i32$0;
  i64toi32_i32$0 = $8;
  HEAP32[i64toi32_i32$0 >> 2] = $77;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $7 = i64toi32_i32$2 + 8 | 0;
  HEAP32[($1 + 84 | 0) >> 2] = HEAP32[$7 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 80 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 84 | 0) >> 2] | 0;
  $87 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 89 | 0;
  $30 = $87;
  HEAP8[i64toi32_i32$1 >> 0] = $30;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $30 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $30 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $30 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $9 = (i64toi32_i32$2 + 80 | 0) + 8 | 0;
  i64toi32_i32$2 = $9;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $94 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 97 | 0;
  $31 = $94;
  HEAP8[i64toi32_i32$0 >> 0] = $31;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $31 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $31 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $31 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $4 + 96 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $99 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 105 | 0;
  $32 = $99;
  HEAP8[i64toi32_i32$1 >> 0] = $32;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $32 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $32 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $32 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $4 + 104 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $104 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 113 | 0;
  $33 = $104;
  HEAP8[i64toi32_i32$0 >> 0] = $33;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $33 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $33 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $33 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  HEAP32[($4 + 24 | 0) >> 2] = 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $108 = i64toi32_i32$1;
  i64toi32_i32$1 = $4;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $108;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  cardano_serialization_lib__utils__Value__set_multiasset__hcffccef3fc1cfd59(i64toi32_i32$1 + 16 | 0 | 0, $3 | 0);
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  label$4 : {
   if ((HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$4
   }
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($4 + 80 | 0 | 4 | 0 | 0, $4 + 28 | 0 | 0);
   $6 = 1;
  }
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $124 = i64toi32_i32$1;
  i64toi32_i32$1 = $7;
  HEAP32[i64toi32_i32$1 >> 2] = $124;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($4 + 80 | 0) >> 2] = $6;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 80 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 84 | 0) >> 2] | 0;
  $129 = i64toi32_i32$0;
  i64toi32_i32$0 = i64toi32_i32$2;
  HEAP32[i64toi32_i32$2 >> 2] = $129;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
  label$5 : {
   switch ($5 | 0) {
   default:
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($8 | 0);
    break;
   case 0:
   case 2:
    break label$5;
   };
  }
  i64toi32_i32$1 = $10$hi;
  i64toi32_i32$0 = $1;
  HEAP32[(i64toi32_i32$0 + 64 | 0) >> 2] = $10;
  HEAP32[(i64toi32_i32$0 + 68 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $136 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $136;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $141 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $141;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  label$7 : {
   if (!(HEAP32[($4 + 24 | 0) >> 2] | 0)) {
    break label$7
   }
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($4 + 28 | 0 | 0);
  }
  global$0 = $4 + 112 | 0;
 }
 
 function alloc__slice__merge__ha85d6751bbeddfda($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $6 = 0, $7 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, $11 = 0, $10 = 0, $12 = 0, $8 = 0, $9 = 0, $72 = 0, $72$hi = 0, $77 = 0, $77$hi = 0, $139 = 0, $139$hi = 0, $144 = 0, $144$hi = 0;
  $5 = $2 << 2 | 0;
  $6 = $0 + $5 | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       $7 = $1 - $2 | 0;
       if ($7 >>> 0 >= $2 >>> 0) {
        break label$5
       }
       $5 = $7 << 2 | 0;
       $8 = memcpy($3 | 0, $6 | 0, $5 | 0) | 0;
       $5 = $8 + $5 | 0;
       if (($2 | 0) < (1 | 0)) {
        break label$2
       }
       if (($7 | 0) < (1 | 0)) {
        break label$2
       }
       $2 = (($1 << 2 | 0) + $0 | 0) + -4 | 0;
       $9 = HEAP32[$4 >> 2] | 0;
       label$6 : while (1) {
        $10 = HEAP32[(HEAP32[($9 + 4 | 0) >> 2] | 0) >> 2] | 0;
        $4 = HEAP32[($10 + 8 | 0) >> 2] | 0;
        $1 = $5 + -4 | 0;
        $11 = HEAP32[$1 >> 2] | 0;
        if ($4 >>> 0 <= $11 >>> 0) {
         break label$4
        }
        $7 = $6 + -4 | 0;
        $12 = HEAP32[$7 >> 2] | 0;
        if ($4 >>> 0 <= $12 >>> 0) {
         break label$3
        }
        $4 = HEAP32[$10 >> 2] | 0;
        i64toi32_i32$2 = $4 + Math_imul($11, 168) | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
        $72 = i64toi32_i32$0;
        $72$hi = i64toi32_i32$1;
        i64toi32_i32$2 = $4 + Math_imul($12, 168) | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
        $77 = i64toi32_i32$1;
        $77$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $72$hi;
        i64toi32_i32$2 = $72;
        i64toi32_i32$1 = $77$hi;
        i64toi32_i32$3 = $77;
        $4 = i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
        HEAP32[$2 >> 2] = HEAP32[($4 ? $7 : $1) >> 2] | 0;
        $5 = $4 ? $5 : $1;
        $6 = $4 ? $7 : $6;
        if ($0 >>> 0 >= $6 >>> 0) {
         break label$2
        }
        $2 = $2 + -4 | 0;
        if ($5 >>> 0 <= $8 >>> 0) {
         break label$2
        }
        continue label$6;
       };
      }
      $5 = (memcpy($3 | 0, $0 | 0, $5 | 0) | 0) + $5 | 0;
      if (($1 | 0) <= ($2 | 0)) {
       break label$1
      }
      if (($2 | 0) < (1 | 0)) {
       break label$1
      }
      $10 = $0 + ($1 << 2 | 0) | 0;
      $11 = HEAP32[$4 >> 2] | 0;
      label$7 : {
       label$8 : {
        label$9 : while (1) {
         $7 = HEAP32[(HEAP32[($11 + 4 | 0) >> 2] | 0) >> 2] | 0;
         $2 = HEAP32[($7 + 8 | 0) >> 2] | 0;
         $1 = HEAP32[$6 >> 2] | 0;
         if ($2 >>> 0 <= $1 >>> 0) {
          break label$8
         }
         $4 = HEAP32[$3 >> 2] | 0;
         if ($2 >>> 0 <= $4 >>> 0) {
          break label$7
         }
         $2 = HEAP32[$7 >> 2] | 0;
         i64toi32_i32$3 = $2 + Math_imul($1, 168) | 0;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 64 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 68 | 0) >> 2] | 0;
         $139 = i64toi32_i32$2;
         $139$hi = i64toi32_i32$0;
         i64toi32_i32$3 = $2 + Math_imul($4, 168) | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 64 | 0) >> 2] | 0;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 68 | 0) >> 2] | 0;
         $144 = i64toi32_i32$0;
         $144$hi = i64toi32_i32$2;
         i64toi32_i32$2 = $139$hi;
         i64toi32_i32$3 = $139;
         i64toi32_i32$0 = $144$hi;
         i64toi32_i32$1 = $144;
         $2 = i64toi32_i32$2 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0 | 0) | 0;
         HEAP32[$0 >> 2] = HEAP32[($2 ? $6 : $3) >> 2] | 0;
         $3 = $2 ? $3 : $3 + 4 | 0;
         $0 = $0 + 4 | 0;
         $6 = $2 ? $6 + 4 | 0 : $6;
         if ($6 >>> 0 >= $10 >>> 0) {
          break label$1
         }
         if ($3 >>> 0 < $5 >>> 0) {
          continue label$9
         }
         break label$1;
        };
       }
       core__panicking__panic_bounds_check__h808b524af17640b1($1 | 0, $2 | 0, 1069460 | 0);
       abort();
      }
      core__panicking__panic_bounds_check__h808b524af17640b1($4 | 0, $2 | 0, 1069460 | 0);
      abort();
     }
     core__panicking__panic_bounds_check__h808b524af17640b1($11 | 0, $4 | 0, 1069460 | 0);
     abort();
    }
    core__panicking__panic_bounds_check__h808b524af17640b1($12 | 0, $4 | 0, 1069460 | 0);
    abort();
   }
   $0 = $6;
  }
  memcpy($0 | 0, $3 | 0, ($5 - $3 | 0) & -4 | 0 | 0) | 0;
 }
 
 function alloc__slice__merge__h05ffb6395880504a($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $6 = 0, $7 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, $11 = 0, $10 = 0, $12 = 0, $8 = 0, $9 = 0, $72 = 0, $72$hi = 0, $77 = 0, $77$hi = 0, $139 = 0, $139$hi = 0, $144 = 0, $144$hi = 0;
  $5 = $2 << 2 | 0;
  $6 = $0 + $5 | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       $7 = $1 - $2 | 0;
       if ($7 >>> 0 >= $2 >>> 0) {
        break label$5
       }
       $5 = $7 << 2 | 0;
       $8 = memcpy($3 | 0, $6 | 0, $5 | 0) | 0;
       $5 = $8 + $5 | 0;
       if (($2 | 0) < (1 | 0)) {
        break label$2
       }
       if (($7 | 0) < (1 | 0)) {
        break label$2
       }
       $2 = (($1 << 2 | 0) + $0 | 0) + -4 | 0;
       $9 = HEAP32[$4 >> 2] | 0;
       label$6 : while (1) {
        $10 = HEAP32[(HEAP32[($9 + 4 | 0) >> 2] | 0) >> 2] | 0;
        $4 = HEAP32[($10 + 8 | 0) >> 2] | 0;
        $1 = $5 + -4 | 0;
        $11 = HEAP32[$1 >> 2] | 0;
        if ($4 >>> 0 <= $11 >>> 0) {
         break label$4
        }
        $7 = $6 + -4 | 0;
        $12 = HEAP32[$7 >> 2] | 0;
        if ($4 >>> 0 <= $12 >>> 0) {
         break label$3
        }
        $4 = HEAP32[$10 >> 2] | 0;
        i64toi32_i32$2 = $4 + Math_imul($11, 168) | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
        $72 = i64toi32_i32$0;
        $72$hi = i64toi32_i32$1;
        i64toi32_i32$2 = $4 + Math_imul($12, 168) | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
        $77 = i64toi32_i32$1;
        $77$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $72$hi;
        i64toi32_i32$2 = $72;
        i64toi32_i32$1 = $77$hi;
        i64toi32_i32$3 = $77;
        $4 = i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
        HEAP32[$2 >> 2] = HEAP32[($4 ? $7 : $1) >> 2] | 0;
        $5 = $4 ? $5 : $1;
        $6 = $4 ? $7 : $6;
        if ($0 >>> 0 >= $6 >>> 0) {
         break label$2
        }
        $2 = $2 + -4 | 0;
        if ($5 >>> 0 <= $8 >>> 0) {
         break label$2
        }
        continue label$6;
       };
      }
      $5 = (memcpy($3 | 0, $0 | 0, $5 | 0) | 0) + $5 | 0;
      if (($1 | 0) <= ($2 | 0)) {
       break label$1
      }
      if (($2 | 0) < (1 | 0)) {
       break label$1
      }
      $10 = $0 + ($1 << 2 | 0) | 0;
      $11 = HEAP32[$4 >> 2] | 0;
      label$7 : {
       label$8 : {
        label$9 : while (1) {
         $7 = HEAP32[(HEAP32[($11 + 4 | 0) >> 2] | 0) >> 2] | 0;
         $2 = HEAP32[($7 + 8 | 0) >> 2] | 0;
         $1 = HEAP32[$6 >> 2] | 0;
         if ($2 >>> 0 <= $1 >>> 0) {
          break label$8
         }
         $4 = HEAP32[$3 >> 2] | 0;
         if ($2 >>> 0 <= $4 >>> 0) {
          break label$7
         }
         $2 = HEAP32[$7 >> 2] | 0;
         i64toi32_i32$3 = $2 + Math_imul($1, 168) | 0;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 64 | 0) >> 2] | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 68 | 0) >> 2] | 0;
         $139 = i64toi32_i32$2;
         $139$hi = i64toi32_i32$0;
         i64toi32_i32$3 = $2 + Math_imul($4, 168) | 0;
         i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 64 | 0) >> 2] | 0;
         i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 68 | 0) >> 2] | 0;
         $144 = i64toi32_i32$0;
         $144$hi = i64toi32_i32$2;
         i64toi32_i32$2 = $139$hi;
         i64toi32_i32$3 = $139;
         i64toi32_i32$0 = $144$hi;
         i64toi32_i32$1 = $144;
         $2 = i64toi32_i32$2 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0 | 0) | 0;
         HEAP32[$0 >> 2] = HEAP32[($2 ? $6 : $3) >> 2] | 0;
         $3 = $2 ? $3 : $3 + 4 | 0;
         $0 = $0 + 4 | 0;
         $6 = $2 ? $6 + 4 | 0 : $6;
         if ($6 >>> 0 >= $10 >>> 0) {
          break label$1
         }
         if ($3 >>> 0 < $5 >>> 0) {
          continue label$9
         }
         break label$1;
        };
       }
       core__panicking__panic_bounds_check__h808b524af17640b1($1 | 0, $2 | 0, 1069460 | 0);
       abort();
      }
      core__panicking__panic_bounds_check__h808b524af17640b1($4 | 0, $2 | 0, 1069460 | 0);
      abort();
     }
     core__panicking__panic_bounds_check__h808b524af17640b1($11 | 0, $4 | 0, 1069460 | 0);
     abort();
    }
    core__panicking__panic_bounds_check__h808b524af17640b1($12 | 0, $4 | 0, 1069460 | 0);
    abort();
   }
   $0 = $6;
  }
  memcpy($0 | 0, $3 | 0, ($5 - $3 | 0) & -4 | 0 | 0) | 0;
 }
 
 function num_bigint__biguint__division__div_rem_digit__hf51877c9bc7172fa($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, $4 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $5 = 0, i64toi32_i32$5 = 0, $10 = 0, $10$hi = 0, $3 = 0, $7 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $9$hi = 0, $8 = 0, $9 = 0, $30 = 0, $11$hi = 0, $6 = 0, $33 = 0, $35 = 0, $41 = 0, $77 = 0, $79$hi = 0, $81 = 0, $81$hi = 0, $11 = 0, $90 = 0, $90$hi = 0;
  $3 = global$0 - 32 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $5 = HEAP32[$1 >> 2] | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ($2 >>> 0 < 65536 >>> 0) {
       break label$4
      }
      if ($4) {
       break label$3
      }
      break label$2;
     }
     if (!$4) {
      break label$2
     }
     label$5 : {
      if (!$2) {
       break label$5
      }
      $6 = $5 + -4 | 0;
      $4 = $4 << 2 | 0;
      $5 = 0;
      label$6 : while (1) {
       $7 = $6 + $4 | 0;
       $33 = $7;
       $35 = $5 << 16 | 0;
       $5 = HEAP32[$7 >> 2] | 0;
       $7 = $35 | ($5 >>> 16 | 0) | 0;
       $41 = $7;
       $7 = ($7 >>> 0) / ($2 >>> 0) | 0;
       $5 = ($41 - Math_imul($7, $2) | 0) << 16 | 0 | ($5 & 65535 | 0) | 0;
       $8 = ($5 >>> 0) / ($2 >>> 0) | 0;
       HEAP32[$33 >> 2] = $8 | ($7 << 16 | 0) | 0;
       $5 = $5 - Math_imul($8, $2) | 0;
       $4 = $4 + -4 | 0;
       if ($4) {
        continue label$6
       }
       break label$1;
      };
     }
     core__panicking__panic__h2fd385a887c8bf13(1083744 | 0, 25 | 0, 1083720 | 0);
     abort();
    }
    $5 = $5 + -4 | 0;
    $4 = $4 << 2 | 0;
    i64toi32_i32$0 = 0;
    $9 = $2;
    $9$hi = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    $10 = 0;
    $10$hi = i64toi32_i32$0;
    label$7 : while (1) {
     $2 = $5 + $4 | 0;
     $77 = $2;
     i64toi32_i32$0 = $10$hi;
     i64toi32_i32$2 = $10;
     i64toi32_i32$1 = 0;
     i64toi32_i32$3 = 32;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
      $30 = 0;
     } else {
      i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
      $30 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
     }
     $79$hi = i64toi32_i32$1;
     i64toi32_i32$0 = $2;
     i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
     i64toi32_i32$2 = 0;
     $81 = i64toi32_i32$1;
     $81$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $79$hi;
     i64toi32_i32$0 = $30;
     i64toi32_i32$1 = $81$hi;
     i64toi32_i32$3 = $81;
     i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
     $10 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
     $10$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $9$hi;
     i64toi32_i32$1 = $10$hi;
     i64toi32_i32$0 = $9$hi;
     i64toi32_i32$0 = __wasm_i64_udiv($10 | 0, i64toi32_i32$1 | 0, $9 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $11 = i64toi32_i32$0;
     $11$hi = i64toi32_i32$1;
     HEAP32[$77 >> 2] = i64toi32_i32$0;
     i64toi32_i32$1 = $10$hi;
     i64toi32_i32$1 = $11$hi;
     i64toi32_i32$1 = $9$hi;
     i64toi32_i32$1 = $11$hi;
     i64toi32_i32$0 = $9$hi;
     i64toi32_i32$0 = __wasm_i64_mul($11 | 0, i64toi32_i32$1 | 0, $9 | 0, i64toi32_i32$0 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $90 = i64toi32_i32$0;
     $90$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $10$hi;
     i64toi32_i32$2 = $10;
     i64toi32_i32$0 = $90$hi;
     i64toi32_i32$3 = $90;
     i64toi32_i32$4 = i64toi32_i32$2 - i64toi32_i32$3 | 0;
     i64toi32_i32$5 = (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) + i64toi32_i32$0 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 - i64toi32_i32$5 | 0;
     $10 = i64toi32_i32$4;
     $10$hi = i64toi32_i32$5;
     $4 = $4 + -4 | 0;
     if ($4) {
      continue label$7
     }
     break label$7;
    };
    i64toi32_i32$5 = $10$hi;
    $5 = $10;
    break label$1;
   }
   $5 = 0;
  }
  $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  HEAP32[(($3 + 16 | 0) + 8 | 0) >> 2] = $4;
  i64toi32_i32$1 = $1;
  i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$5;
  $10$hi = i64toi32_i32$2;
  i64toi32_i32$5 = $3;
  HEAP32[(i64toi32_i32$5 + 16 | 0) >> 2] = $10;
  HEAP32[(i64toi32_i32$5 + 20 | 0) >> 2] = i64toi32_i32$2;
  label$8 : {
   label$9 : {
    if ($4) {
     break label$9
    }
    $4 = 0;
    break label$8;
   }
   i64toi32_i32$2 = $10$hi;
   $2 = (($4 << 2 | 0) + $10 | 0) + -4 | 0;
   label$10 : {
    label$11 : while (1) {
     if (HEAP32[$2 >> 2] | 0) {
      break label$10
     }
     $2 = $2 + -4 | 0;
     $4 = $4 + -1 | 0;
     if ($4) {
      continue label$11
     }
     break label$11;
    };
    $4 = 0;
   }
   HEAP32[($3 + 24 | 0) >> 2] = $4;
  }
  label$12 : {
   $2 = HEAP32[($3 + 20 | 0) >> 2] | 0;
   if ($4 >>> 0 >= ($2 >>> 2 | 0) >>> 0) {
    break label$12
   }
   if ($2 >>> 0 <= $4 >>> 0) {
    break label$12
   }
   alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($3 + 16 | 0 | 0, $4 | 0);
  }
  $2 = HEAP32[(($3 + 16 | 0) + 8 | 0) >> 2] | 0;
  HEAP32[($3 + 8 | 0) >> 2] = $2;
  i64toi32_i32$1 = $3;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] | 0;
  $10 = i64toi32_i32$2;
  $10$hi = i64toi32_i32$5;
  i64toi32_i32$2 = i64toi32_i32$1;
  HEAP32[i64toi32_i32$1 >> 2] = $10;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$5;
  HEAP32[($0 + 8 | 0) >> 2] = $2;
  i64toi32_i32$2 = $0;
  HEAP32[i64toi32_i32$2 >> 2] = $10;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$5;
  HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = $5;
  global$0 = i64toi32_i32$1 + 32 | 0;
 }
 
 function std__thread__Thread__new__h9938a1a5d62ffab4($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $2 = 0, i64toi32_i32$5 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $3 = 0, $4 = 0, $5 = 0, $5$hi = 0, i64toi32_i32$4 = 0, $14 = 0, $57 = 0, $94 = 0;
  $1 = global$0 - 64 | 0;
  global$0 = $1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       $2 = HEAP32[$0 >> 2] | 0;
       if ($2) {
        break label$5
       }
       $3 = 0;
       break label$4;
      }
      i64toi32_i32$2 = $0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
      $14 = i64toi32_i32$0;
      i64toi32_i32$0 = $1;
      HEAP32[($1 + 44 | 0) >> 2] = $14;
      HEAP32[($1 + 48 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($1 + 40 | 0) >> 2] = $2;
      alloc__string___impl_20core__convert__From_alloc__string__String__20for_20alloc__vec__Vec_u8____from__hd5e271059b2a155b($1 + 24 | 0 | 0, $1 + 40 | 0 | 0);
      $3 = HEAP32[($1 + 24 | 0) >> 2] | 0;
      label$6 : {
       label$7 : {
        $2 = HEAP32[($1 + 32 | 0) >> 2] | 0;
        if ($2 >>> 0 < 8 >>> 0) {
         break label$7
        }
        core__slice__memchr__memchr_general_case__hc8de6bab13ee8435($1 + 16 | 0 | 0, 0 | 0, $3 | 0, $2 | 0);
        $2 = HEAP32[($1 + 20 | 0) >> 2] | 0;
        $4 = HEAP32[($1 + 16 | 0) >> 2] | 0;
        break label$6;
       }
       label$8 : {
        if ($2) {
         break label$8
        }
        $2 = 0;
        $4 = 0;
        break label$6;
       }
       $0 = 0;
       label$9 : {
        label$10 : while (1) {
         if (!(HEAPU8[($3 + $0 | 0) >> 0] | 0)) {
          break label$9
         }
         $0 = $0 + 1 | 0;
         if (($2 | 0) != ($0 | 0)) {
          continue label$10
         }
         break label$10;
        };
        $4 = 0;
        break label$6;
       }
       $4 = 1;
       $2 = $0;
      }
      if ($4) {
       break label$3
      }
      HEAP32[(($1 + 40 | 0) + 8 | 0) >> 2] = HEAP32[(($1 + 24 | 0) + 8 | 0) >> 2] | 0;
      i64toi32_i32$2 = $1;
      i64toi32_i32$1 = HEAP32[($1 + 24 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($1 + 28 | 0) >> 2] | 0;
      $57 = i64toi32_i32$1;
      i64toi32_i32$1 = $1;
      HEAP32[($1 + 40 | 0) >> 2] = $57;
      HEAP32[($1 + 44 | 0) >> 2] = i64toi32_i32$0;
      std__ffi__c_str__CString__from_vec_unchecked__h59e10776c8f9e277($1 + 8 | 0 | 0, $1 + 40 | 0 | 0);
      $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
      $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     }
     $0 = HEAPU8[(0 + 1178344 | 0) >> 0] | 0;
     HEAP8[(0 + 1178344 | 0) >> 0] = 1;
     HEAP8[($1 + 24 | 0) >> 0] = $0;
     if ($0) {
      break label$2
     }
     label$11 : {
      label$12 : {
       i64toi32_i32$2 = 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1177744 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1177748 | 0) >> 2] | 0;
       $5 = i64toi32_i32$0;
       $5$hi = i64toi32_i32$1;
       i64toi32_i32$2 = i64toi32_i32$0;
       i64toi32_i32$0 = -1;
       i64toi32_i32$3 = -1;
       if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
        break label$12
       }
       i64toi32_i32$2 = $5$hi;
       i64toi32_i32$3 = $5;
       i64toi32_i32$1 = 0;
       i64toi32_i32$0 = 1;
       i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
       i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
       if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
        i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
       }
       i64toi32_i32$3 = 0;
       HEAP32[(i64toi32_i32$3 + 1177744 | 0) >> 2] = i64toi32_i32$4;
       HEAP32[(i64toi32_i32$3 + 1177748 | 0) >> 2] = i64toi32_i32$5;
       i64toi32_i32$5 = $5$hi;
       i64toi32_i32$2 = $5;
       i64toi32_i32$3 = 0;
       i64toi32_i32$0 = 0;
       if ((i64toi32_i32$2 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$5 | 0) != (i64toi32_i32$3 | 0) | 0) {
        break label$11
       }
       core__panicking__panic__h2fd385a887c8bf13(1142444 | 0, 43 | 0, 1142748 | 0);
       abort();
      }
      HEAP8[(0 + 1178344 | 0) >> 0] = 0;
      std__panicking__begin_panic__h7867d4da632f3661(1142676 | 0, 55 | 0, 1142732 | 0);
      abort();
     }
     HEAP8[(0 + 1178344 | 0) >> 0] = 0;
     $0 = __rust_alloc(32 | 0, 8 | 0) | 0;
     if (!$0) {
      break label$1
     }
     i64toi32_i32$5 = $0;
     i64toi32_i32$2 = 0;
     HEAP32[($0 + 24 | 0) >> 2] = 0;
     HEAP32[($0 + 28 | 0) >> 2] = i64toi32_i32$2;
     HEAP32[($0 + 20 | 0) >> 2] = $2;
     HEAP32[($0 + 16 | 0) >> 2] = $3;
     i64toi32_i32$2 = $5$hi;
     i64toi32_i32$5 = $0;
     HEAP32[($0 + 8 | 0) >> 2] = $5;
     HEAP32[($0 + 12 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$5 = $0;
     i64toi32_i32$2 = 1;
     HEAP32[$0 >> 2] = 1;
     HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$2;
     global$0 = $1 + 64 | 0;
     return $0 | 0;
    }
    i64toi32_i32$0 = $1;
    i64toi32_i32$2 = HEAP32[($1 + 28 | 0) >> 2] | 0;
    i64toi32_i32$5 = HEAP32[($1 + 32 | 0) >> 2] | 0;
    $94 = i64toi32_i32$2;
    i64toi32_i32$2 = $1 + 48 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $94;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$5;
    HEAP32[($1 + 44 | 0) >> 2] = $3;
    HEAP32[($1 + 40 | 0) >> 2] = $2;
    core__result__unwrap_failed__h27f43d993c3864a1(1142764 | 0, 47 | 0, $1 + 40 | 0 | 0, 1142488 | 0, 1142812 | 0);
    abort();
   }
   HEAP32[($1 + 60 | 0) >> 2] = 0;
   HEAP32[($1 + 56 | 0) >> 2] = 1142260;
   i64toi32_i32$2 = $1;
   i64toi32_i32$5 = 0;
   HEAP32[($1 + 44 | 0) >> 2] = 1;
   HEAP32[($1 + 48 | 0) >> 2] = i64toi32_i32$5;
   HEAP32[($1 + 40 | 0) >> 2] = 1145368;
   core__panicking__assert_failed__h1e2384889c2d638e($1 + 24 | 0 | 0, $1 + 40 | 0 | 0);
   abort();
  }
  alloc__alloc__handle_alloc_error__he269d8f1bff90960(32 | 0, 8 | 0);
  abort();
 }
 
 function core__fmt__num__fmt_u128__h862fe9efac8e40f8($0, $0$hi, $1, $1$hi, $2, $3) {
  $0 = $0 | 0;
  $0$hi = $0$hi | 0;
  $1 = $1 | 0;
  $1$hi = $1$hi | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, i64toi32_i32$5 = 0, i64toi32_i32$2 = 0, $4 = 0, $6$hi = 0, $6 = 0, $7$hi = 0, $7 = 0, $57 = 0, $58 = 0, $59 = 0, $61 = 0, $62 = 0, $64 = 0, $65 = 0, $5 = 0, $29 = 0, $29$hi = 0, $33 = 0, $33$hi = 0, $40 = 0, $40$hi = 0, $44 = 0, $45$hi = 0, $49 = 0, $49$hi = 0, $53 = 0, $54$hi = 0, $55 = 0, $55$hi = 0, $56 = 0, $56$hi = 0, $60 = 0, $60$hi = 0, $63 = 0, $63$hi = 0, $64$hi = 0, $66 = 0, $67$hi = 0, $68$hi = 0, $72 = 0, $73$hi = 0, $78 = 0, $78$hi = 0, $80$hi = 0, $83 = 0, $83$hi = 0, $85$hi = 0, $67 = 0, $93$hi = 0, $112 = 0, $114 = 0, $114$hi = 0, $116$hi = 0, $123$hi = 0;
  $4 = global$0 - 144 | 0;
  global$0 = $4;
  HEAP32[($4 + 140 | 0) >> 2] = 39;
  label$1 : {
   label$2 : {
    i64toi32_i32$0 = $1$hi;
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = 0;
    i64toi32_i32$3 = 524288;
    if (i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0) {
     break label$2
    }
    i64toi32_i32$2 = $0$hi;
    i64toi32_i32$0 = 0;
    i64toi32_i32$3 = -1785137935;
    i64toi32_i32$1 = 0;
    __multi3($4 + 48 | 0 | 0, $0 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$0 | 0, -399107725 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$1 | 0);
    i64toi32_i32$1 = i64toi32_i32$2;
    i64toi32_i32$3 = 0;
    i64toi32_i32$0 = 1980704062;
    i64toi32_i32$2 = 0;
    __multi3($4 + 32 | 0 | 0, $0 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$3 | 0, -615862062 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$2 | 0);
    i64toi32_i32$2 = $1$hi;
    i64toi32_i32$0 = 0;
    i64toi32_i32$3 = -1785137935;
    i64toi32_i32$1 = 0;
    __multi3($4 + 80 | 0 | 0, $1 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$0 | 0, -399107725 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$1 | 0);
    i64toi32_i32$1 = i64toi32_i32$2;
    i64toi32_i32$3 = 0;
    i64toi32_i32$0 = 1980704062;
    i64toi32_i32$2 = 0;
    __multi3($4 + 64 | 0 | 0, $1 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$3 | 0, -615862062 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$2 | 0);
    i64toi32_i32$3 = ($4 + 64 | 0) + 8 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $29 = i64toi32_i32$2;
    $29$hi = i64toi32_i32$0;
    i64toi32_i32$3 = ($4 + 32 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $33 = i64toi32_i32$0;
    $33$hi = i64toi32_i32$2;
    i64toi32_i32$3 = ($4 + 48 | 0) + 8 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $6 = i64toi32_i32$2;
    $6$hi = i64toi32_i32$0;
    i64toi32_i32$3 = $4;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 32 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 36 | 0) >> 2] | 0;
    $40 = i64toi32_i32$0;
    $40$hi = i64toi32_i32$2;
    i64toi32_i32$2 = $6$hi;
    i64toi32_i32$3 = $6;
    i64toi32_i32$0 = $40$hi;
    i64toi32_i32$1 = $40;
    i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
    i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
    if (i64toi32_i32$4 >>> 0 < i64toi32_i32$1 >>> 0) {
     i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
    }
    $1 = i64toi32_i32$4;
    $1$hi = i64toi32_i32$5;
    i64toi32_i32$5 = $6$hi;
    i64toi32_i32$5 = $1$hi;
    i64toi32_i32$2 = i64toi32_i32$4;
    i64toi32_i32$3 = $6$hi;
    i64toi32_i32$1 = $6;
    $44 = i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$4 >>> 0 < i64toi32_i32$1 >>> 0 | 0) | 0;
    i64toi32_i32$2 = 0;
    $45$hi = i64toi32_i32$2;
    i64toi32_i32$2 = $33$hi;
    i64toi32_i32$1 = $33;
    i64toi32_i32$5 = $45$hi;
    i64toi32_i32$3 = $44;
    i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
    i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
    if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
     i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
    }
    $7 = i64toi32_i32$0;
    $7$hi = i64toi32_i32$4;
    i64toi32_i32$2 = $4;
    i64toi32_i32$4 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
    $49 = i64toi32_i32$4;
    $49$hi = i64toi32_i32$1;
    i64toi32_i32$1 = $7$hi;
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$4 = $49$hi;
    i64toi32_i32$3 = $49;
    i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
    i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
    if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
     i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
    }
    $6 = i64toi32_i32$5;
    $6$hi = i64toi32_i32$0;
    i64toi32_i32$0 = $7$hi;
    i64toi32_i32$0 = $6$hi;
    i64toi32_i32$1 = i64toi32_i32$5;
    i64toi32_i32$2 = $7$hi;
    i64toi32_i32$3 = $7;
    $53 = i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
    i64toi32_i32$1 = 0;
    $54$hi = i64toi32_i32$1;
    i64toi32_i32$1 = $29$hi;
    i64toi32_i32$3 = $29;
    i64toi32_i32$0 = $54$hi;
    i64toi32_i32$2 = $53;
    i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
    i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
    if (i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0) {
     i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
    }
    $55 = i64toi32_i32$4;
    $55$hi = i64toi32_i32$5;
    i64toi32_i32$5 = $6$hi;
    $56 = $6;
    $56$hi = i64toi32_i32$5;
    i64toi32_i32$1 = ($4 + 80 | 0) + 8 | 0;
    i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
    $60 = i64toi32_i32$5;
    $60$hi = i64toi32_i32$3;
    i64toi32_i32$3 = $1$hi;
    i64toi32_i32$1 = $4;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 80 | 0) >> 2] | 0;
    i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 84 | 0) >> 2] | 0;
    $63 = i64toi32_i32$3;
    $63$hi = i64toi32_i32$5;
    i64toi32_i32$5 = $1$hi;
    i64toi32_i32$1 = $1;
    i64toi32_i32$3 = $63$hi;
    i64toi32_i32$2 = $63;
    i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
    i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
    if (i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0) {
     i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
    }
    $64$hi = i64toi32_i32$4;
    i64toi32_i32$4 = $1$hi;
    i64toi32_i32$4 = $64$hi;
    i64toi32_i32$5 = i64toi32_i32$0;
    i64toi32_i32$1 = $1$hi;
    i64toi32_i32$2 = $1;
    $66 = i64toi32_i32$4 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0;
    i64toi32_i32$5 = 0;
    $67$hi = i64toi32_i32$5;
    i64toi32_i32$5 = $60$hi;
    i64toi32_i32$2 = $60;
    i64toi32_i32$4 = $67$hi;
    i64toi32_i32$1 = $66;
    i64toi32_i32$3 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
    i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
    if (i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0) {
     i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
    }
    $68$hi = i64toi32_i32$0;
    i64toi32_i32$0 = $56$hi;
    i64toi32_i32$5 = $56;
    i64toi32_i32$2 = $68$hi;
    i64toi32_i32$1 = i64toi32_i32$3;
    i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
    i64toi32_i32$3 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
    if (i64toi32_i32$4 >>> 0 < i64toi32_i32$1 >>> 0) {
     i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
    }
    $1 = i64toi32_i32$4;
    $1$hi = i64toi32_i32$3;
    i64toi32_i32$3 = $6$hi;
    i64toi32_i32$3 = $1$hi;
    i64toi32_i32$0 = i64toi32_i32$4;
    i64toi32_i32$5 = $6$hi;
    i64toi32_i32$1 = $6;
    $72 = i64toi32_i32$3 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0 | 0) | 0;
    i64toi32_i32$0 = 0;
    $73$hi = i64toi32_i32$0;
    i64toi32_i32$0 = $55$hi;
    i64toi32_i32$1 = $55;
    i64toi32_i32$3 = $73$hi;
    i64toi32_i32$5 = $72;
    i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
    i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
    if (i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0) {
     i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
    }
    $7 = i64toi32_i32$2;
    $7$hi = i64toi32_i32$4;
    i64toi32_i32$0 = i64toi32_i32$2;
    i64toi32_i32$1 = 0;
    i64toi32_i32$5 = 62;
    i64toi32_i32$3 = i64toi32_i32$5 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$5 & 63 | 0) >>> 0) {
     i64toi32_i32$1 = 0;
     $57 = i64toi32_i32$4 >>> i64toi32_i32$3 | 0;
    } else {
     i64toi32_i32$1 = i64toi32_i32$4 >>> i64toi32_i32$3 | 0;
     $57 = (((1 << i64toi32_i32$3 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$3 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$3 | 0) | 0;
    }
    $6 = $57;
    $6$hi = i64toi32_i32$1;
    i64toi32_i32$1 = $1$hi;
    i64toi32_i32$4 = $1;
    i64toi32_i32$0 = 0;
    i64toi32_i32$5 = 62;
    i64toi32_i32$3 = i64toi32_i32$5 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$5 & 63 | 0) >>> 0) {
     i64toi32_i32$0 = 0;
     $58 = i64toi32_i32$1 >>> i64toi32_i32$3 | 0;
    } else {
     i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$3 | 0;
     $58 = (((1 << i64toi32_i32$3 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$3 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$3 | 0) | 0;
    }
    $78 = $58;
    $78$hi = i64toi32_i32$0;
    i64toi32_i32$0 = $7$hi;
    i64toi32_i32$1 = $7;
    i64toi32_i32$4 = 0;
    i64toi32_i32$5 = 2;
    i64toi32_i32$3 = i64toi32_i32$5 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$5 & 63 | 0) >>> 0) {
     i64toi32_i32$4 = i64toi32_i32$1 << i64toi32_i32$3 | 0;
     $59 = 0;
    } else {
     i64toi32_i32$4 = ((1 << i64toi32_i32$3 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$3 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$3 | 0) | 0;
     $59 = i64toi32_i32$1 << i64toi32_i32$3 | 0;
    }
    $80$hi = i64toi32_i32$4;
    i64toi32_i32$4 = $78$hi;
    i64toi32_i32$0 = $78;
    i64toi32_i32$1 = $80$hi;
    i64toi32_i32$5 = $59;
    i64toi32_i32$1 = i64toi32_i32$4 | i64toi32_i32$1 | 0;
    $1 = i64toi32_i32$0 | i64toi32_i32$5 | 0;
    $1$hi = i64toi32_i32$1;
    break label$1;
   }
   i64toi32_i32$1 = $0$hi;
   i64toi32_i32$4 = $0;
   i64toi32_i32$0 = 0;
   i64toi32_i32$5 = 19;
   i64toi32_i32$3 = i64toi32_i32$5 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$5 & 63 | 0) >>> 0) {
    i64toi32_i32$0 = 0;
    $61 = i64toi32_i32$1 >>> i64toi32_i32$3 | 0;
   } else {
    i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$3 | 0;
    $61 = (((1 << i64toi32_i32$3 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$3 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$3 | 0) | 0;
   }
   $83 = $61;
   $83$hi = i64toi32_i32$0;
   i64toi32_i32$0 = $1$hi;
   i64toi32_i32$1 = $1;
   i64toi32_i32$4 = 0;
   i64toi32_i32$5 = 45;
   i64toi32_i32$3 = i64toi32_i32$5 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$5 & 63 | 0) >>> 0) {
    i64toi32_i32$4 = i64toi32_i32$1 << i64toi32_i32$3 | 0;
    $62 = 0;
   } else {
    i64toi32_i32$4 = ((1 << i64toi32_i32$3 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$3 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$3 | 0) | 0;
    $62 = i64toi32_i32$1 << i64toi32_i32$3 | 0;
   }
   $85$hi = i64toi32_i32$4;
   i64toi32_i32$4 = $83$hi;
   i64toi32_i32$0 = $83;
   i64toi32_i32$1 = $85$hi;
   i64toi32_i32$5 = $62;
   i64toi32_i32$1 = i64toi32_i32$4 | i64toi32_i32$1 | 0;
   $67 = i64toi32_i32$0 | i64toi32_i32$5 | 0;
   i64toi32_i32$0 = 4440;
   i64toi32_i32$0 = __wasm_i64_udiv($67 | 0, i64toi32_i32$1 | 0, -463433411 | 0, i64toi32_i32$0 | 0) | 0;
   i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
   $1 = i64toi32_i32$0;
   $1$hi = i64toi32_i32$1;
   i64toi32_i32$1 = 0;
   $6 = 0;
   $6$hi = i64toi32_i32$1;
  }
  i64toi32_i32$1 = $1$hi;
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$1 = $1$hi;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$4 = 1966660859;
  i64toi32_i32$5 = -1;
  __multi3($4 + 16 | 0 | 0, $1 | 0, i64toi32_i32$1 | 0, $6 | 0, i64toi32_i32$0 | 0, 1981284352 | 0, i64toi32_i32$4 | 0, -1 | 0, i64toi32_i32$5 | 0);
  i64toi32_i32$0 = $4;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] | 0;
  $93$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $0$hi;
  i64toi32_i32$4 = $93$hi;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$5 = $0$hi;
  i64toi32_i32$1 = $0;
  i64toi32_i32$3 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  core__fmt__num__parse_u64_into__hf2b8a89cb8a6b459(i64toi32_i32$3 | 0, i64toi32_i32$2 | 0, $4 + 101 | 0 | 0, $4 + 140 | 0 | 0);
  label$3 : {
   i64toi32_i32$2 = $1$hi;
   i64toi32_i32$2 = $6$hi;
   i64toi32_i32$2 = $1$hi;
   i64toi32_i32$4 = $1;
   i64toi32_i32$0 = $6$hi;
   i64toi32_i32$1 = $6;
   i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
   if (!(i64toi32_i32$4 | i64toi32_i32$1 | 0 | i64toi32_i32$0 | 0)) {
    break label$3
   }
   memset(($4 + 101 | 0) + 20 | 0 | 0, 48 | 0, (HEAP32[($4 + 140 | 0) >> 2] | 0) + -20 | 0 | 0) | 0;
   HEAP32[($4 + 140 | 0) >> 2] = 20;
   $112 = $4;
   i64toi32_i32$0 = $1$hi;
   i64toi32_i32$2 = $1;
   i64toi32_i32$4 = 0;
   i64toi32_i32$1 = 19;
   i64toi32_i32$5 = i64toi32_i32$1 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
    i64toi32_i32$4 = 0;
    $64 = i64toi32_i32$0 >>> i64toi32_i32$5 | 0;
   } else {
    i64toi32_i32$4 = i64toi32_i32$0 >>> i64toi32_i32$5 | 0;
    $64 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$5 | 0) | 0;
   }
   $114 = $64;
   $114$hi = i64toi32_i32$4;
   i64toi32_i32$4 = $6$hi;
   i64toi32_i32$0 = $6;
   i64toi32_i32$2 = 0;
   i64toi32_i32$1 = 45;
   i64toi32_i32$5 = i64toi32_i32$1 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
    i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$5 | 0;
    $65 = 0;
   } else {
    i64toi32_i32$2 = ((1 << i64toi32_i32$5 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$5 | 0) | 0) | 0 | (i64toi32_i32$4 << i64toi32_i32$5 | 0) | 0;
    $65 = i64toi32_i32$0 << i64toi32_i32$5 | 0;
   }
   $116$hi = i64toi32_i32$2;
   i64toi32_i32$2 = $114$hi;
   i64toi32_i32$4 = $114;
   i64toi32_i32$0 = $116$hi;
   i64toi32_i32$1 = $65;
   i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
   $6 = i64toi32_i32$4 | i64toi32_i32$1 | 0;
   $6$hi = i64toi32_i32$0;
   i64toi32_i32$4 = 4440;
   i64toi32_i32$4 = __wasm_i64_udiv($6 | 0, i64toi32_i32$0 | 0, -463433411 | 0, i64toi32_i32$4 | 0) | 0;
   i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
   $0 = i64toi32_i32$4;
   $0$hi = i64toi32_i32$0;
   i64toi32_i32$0 = $1$hi;
   i64toi32_i32$0 = $0$hi;
   i64toi32_i32$4 = $1$hi;
   i64toi32_i32$2 = 1966660859;
   i64toi32_i32$1 = -1;
   __multi3($112 | 0, $0 | 0, i64toi32_i32$0 | 0, $1 | 0, i64toi32_i32$4 | 0, 1981284352 | 0, i64toi32_i32$2 | 0, -1 | 0, i64toi32_i32$1 | 0);
   i64toi32_i32$4 = $4;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$4 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
   $123$hi = i64toi32_i32$2;
   i64toi32_i32$2 = $1$hi;
   i64toi32_i32$2 = $123$hi;
   i64toi32_i32$4 = i64toi32_i32$1;
   i64toi32_i32$1 = $1$hi;
   i64toi32_i32$0 = $1;
   i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
   i64toi32_i32$3 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
   if (i64toi32_i32$5 >>> 0 < i64toi32_i32$0 >>> 0) {
    i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
   }
   core__fmt__num__parse_u64_into__hf2b8a89cb8a6b459(i64toi32_i32$5 | 0, i64toi32_i32$3 | 0, $4 + 101 | 0 | 0, $4 + 140 | 0 | 0);
   i64toi32_i32$3 = $6$hi;
   i64toi32_i32$2 = $6;
   i64toi32_i32$4 = 4440;
   i64toi32_i32$0 = -463433411;
   if (i64toi32_i32$3 >>> 0 < i64toi32_i32$4 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$4 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$0 >>> 0 | 0) | 0) {
    break label$3
   }
   memset($4 + 102 | 0 | 0, 48 | 0, (HEAP32[($4 + 140 | 0) >> 2] | 0) + -1 | 0 | 0) | 0;
   i64toi32_i32$2 = $0$hi;
   HEAP8[($4 + 101 | 0) >> 0] = $0 | 48 | 0;
   HEAP32[($4 + 140 | 0) >> 2] = 0;
  }
  $5 = HEAP32[($4 + 140 | 0) >> 2] | 0;
  $2 = core__fmt__Formatter__pad_integral__h08e3e53a0de517a1($3 | 0, $2 | 0, 1149204 | 0, 0 | 0, ($4 + 101 | 0) + $5 | 0 | 0, 39 - $5 | 0 | 0) | 0;
  global$0 = $4 + 144 | 0;
  return $2 | 0;
 }
 
 function __muloti4($0, $1, $1$hi, $2, $2$hi, $3, $3$hi, $4, $4$hi, $5) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $1$hi = $1$hi | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  $4 = $4 | 0;
  $4$hi = $4$hi | 0;
  $5 = $5 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$5 = 0, $9$hi = 0, $6 = 0, $9 = 0, $10$hi = 0, i64toi32_i32$6 = 0, $10 = 0, $7 = 0, $8 = 0, $49 = 0, $51 = 0, $52 = 0, $53 = 0, $54 = 0, $55 = 0, $56 = 0, $57 = 0, $58 = 0, $59 = 0, $60 = 0, $61 = 0, $23 = 0, $23$hi = 0, $24 = 0, $24$hi = 0, $30 = 0, $30$hi = 0, $31 = 0, $31$hi = 0, $38 = 0, $39$hi = 0, $40$hi = 0, $41$hi = 0, $50 = 0, $51$hi = 0, $52$hi = 0, $53$hi = 0, $91 = 0, $94 = 0, $94$hi = 0, $113 = 0, $120 = 0, $120$hi = 0, $137 = 0, $138$hi = 0, $139$hi = 0;
  $6 = global$0 - 80 | 0;
  global$0 = $6;
  i64toi32_i32$0 = 0;
  $9 = 0;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  $10 = 0;
  $10$hi = i64toi32_i32$0;
  $7 = 0;
  label$1 : {
   i64toi32_i32$0 = $1$hi;
   i64toi32_i32$0 = $2$hi;
   i64toi32_i32$0 = $1$hi;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = $2$hi;
   i64toi32_i32$3 = $2;
   i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
   if (!(i64toi32_i32$2 | i64toi32_i32$3 | 0 | i64toi32_i32$1 | 0)) {
    break label$1
   }
   i64toi32_i32$1 = $3$hi;
   i64toi32_i32$1 = $4$hi;
   i64toi32_i32$1 = $3$hi;
   i64toi32_i32$0 = $3;
   i64toi32_i32$2 = $4$hi;
   i64toi32_i32$3 = $4;
   i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
   if (!(i64toi32_i32$0 | i64toi32_i32$3 | 0 | i64toi32_i32$2 | 0)) {
    break label$1
   }
   i64toi32_i32$2 = $3$hi;
   i64toi32_i32$2 = 0;
   i64toi32_i32$1 = 0;
   i64toi32_i32$0 = $3$hi;
   i64toi32_i32$3 = $3;
   i64toi32_i32$4 = i64toi32_i32$1 - i64toi32_i32$3 | 0;
   i64toi32_i32$6 = i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0;
   i64toi32_i32$5 = i64toi32_i32$6 + i64toi32_i32$0 | 0;
   i64toi32_i32$5 = i64toi32_i32$2 - i64toi32_i32$5 | 0;
   $23 = i64toi32_i32$4;
   $23$hi = i64toi32_i32$5;
   i64toi32_i32$5 = i64toi32_i32$0;
   $24 = i64toi32_i32$3;
   $24$hi = i64toi32_i32$0;
   i64toi32_i32$5 = $4$hi;
   i64toi32_i32$2 = $4;
   i64toi32_i32$1 = 0;
   i64toi32_i32$3 = 0;
   if ((i64toi32_i32$5 | 0) < (i64toi32_i32$1 | 0)) {
    $49 = 1
   } else {
    if ((i64toi32_i32$5 | 0) <= (i64toi32_i32$1 | 0)) {
     if (i64toi32_i32$2 >>> 0 >= i64toi32_i32$3 >>> 0) {
      $51 = 0
     } else {
      $51 = 1
     }
     $52 = $51;
    } else {
     $52 = 0
    }
    $49 = $52;
   }
   $7 = $49;
   i64toi32_i32$0 = $7;
   i64toi32_i32$2 = $23$hi;
   i64toi32_i32$5 = $24$hi;
   i64toi32_i32$1 = i64toi32_i32$0 ? $23 : $24;
   i64toi32_i32$3 = i64toi32_i32$0 ? i64toi32_i32$2 : i64toi32_i32$5;
   $9 = i64toi32_i32$1;
   $9$hi = i64toi32_i32$3;
   i64toi32_i32$3 = $1$hi;
   i64toi32_i32$3 = 0;
   i64toi32_i32$0 = 0;
   i64toi32_i32$1 = $1$hi;
   i64toi32_i32$2 = $1;
   i64toi32_i32$5 = i64toi32_i32$0 - i64toi32_i32$2 | 0;
   i64toi32_i32$6 = i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0;
   i64toi32_i32$4 = i64toi32_i32$6 + i64toi32_i32$1 | 0;
   i64toi32_i32$4 = i64toi32_i32$3 - i64toi32_i32$4 | 0;
   $30 = i64toi32_i32$5;
   $30$hi = i64toi32_i32$4;
   i64toi32_i32$4 = i64toi32_i32$1;
   $31 = i64toi32_i32$2;
   $31$hi = i64toi32_i32$4;
   i64toi32_i32$4 = $2$hi;
   i64toi32_i32$3 = $2;
   i64toi32_i32$0 = 0;
   i64toi32_i32$2 = 0;
   if ((i64toi32_i32$4 | 0) < (i64toi32_i32$0 | 0)) {
    $53 = 1
   } else {
    if ((i64toi32_i32$4 | 0) <= (i64toi32_i32$0 | 0)) {
     if (i64toi32_i32$3 >>> 0 >= i64toi32_i32$2 >>> 0) {
      $54 = 0
     } else {
      $54 = 1
     }
     $55 = $54;
    } else {
     $55 = 0
    }
    $53 = $55;
   }
   $8 = $53;
   i64toi32_i32$1 = $8;
   i64toi32_i32$3 = $30$hi;
   i64toi32_i32$4 = $31$hi;
   i64toi32_i32$0 = i64toi32_i32$1 ? $30 : $31;
   i64toi32_i32$2 = i64toi32_i32$1 ? i64toi32_i32$3 : i64toi32_i32$4;
   $10 = i64toi32_i32$0;
   $10$hi = i64toi32_i32$2;
   i64toi32_i32$2 = $4$hi;
   i64toi32_i32$2 = $3$hi;
   i64toi32_i32$1 = $3;
   i64toi32_i32$0 = 0;
   i64toi32_i32$3 = 0;
   $38 = (i64toi32_i32$1 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$0 | 0) | 0;
   i64toi32_i32$1 = 0;
   $39$hi = i64toi32_i32$1;
   i64toi32_i32$1 = $4$hi;
   i64toi32_i32$3 = $4;
   i64toi32_i32$2 = $39$hi;
   i64toi32_i32$0 = $38;
   i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
   i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
   if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
    i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
   }
   $40$hi = i64toi32_i32$5;
   i64toi32_i32$5 = 0;
   i64toi32_i32$1 = 0;
   i64toi32_i32$3 = $40$hi;
   i64toi32_i32$0 = i64toi32_i32$4;
   i64toi32_i32$2 = i64toi32_i32$1 - i64toi32_i32$4 | 0;
   i64toi32_i32$6 = i64toi32_i32$1 >>> 0 < i64toi32_i32$4 >>> 0;
   i64toi32_i32$4 = i64toi32_i32$6 + i64toi32_i32$3 | 0;
   i64toi32_i32$4 = i64toi32_i32$5 - i64toi32_i32$4 | 0;
   $41$hi = i64toi32_i32$4;
   i64toi32_i32$4 = $4$hi;
   i64toi32_i32$3 = $7;
   i64toi32_i32$4 = $41$hi;
   i64toi32_i32$1 = $4$hi;
   i64toi32_i32$0 = i64toi32_i32$3 ? i64toi32_i32$2 : $4;
   i64toi32_i32$5 = i64toi32_i32$3 ? i64toi32_i32$4 : i64toi32_i32$1;
   $3 = i64toi32_i32$0;
   $3$hi = i64toi32_i32$5;
   $7 = $8 ^ i64toi32_i32$3 | 0;
   label$2 : {
    label$3 : {
     label$4 : {
      i64toi32_i32$5 = $2$hi;
      i64toi32_i32$5 = $1$hi;
      i64toi32_i32$3 = $1;
      i64toi32_i32$0 = 0;
      i64toi32_i32$4 = 0;
      $50 = (i64toi32_i32$3 | 0) != (i64toi32_i32$4 | 0) | (i64toi32_i32$5 | 0) != (i64toi32_i32$0 | 0) | 0;
      i64toi32_i32$3 = 0;
      $51$hi = i64toi32_i32$3;
      i64toi32_i32$3 = $2$hi;
      i64toi32_i32$4 = $2;
      i64toi32_i32$5 = $51$hi;
      i64toi32_i32$0 = $50;
      i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
      i64toi32_i32$2 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
      if (i64toi32_i32$1 >>> 0 < i64toi32_i32$0 >>> 0) {
       i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
      }
      $52$hi = i64toi32_i32$2;
      i64toi32_i32$2 = 0;
      i64toi32_i32$3 = 0;
      i64toi32_i32$4 = $52$hi;
      i64toi32_i32$0 = i64toi32_i32$1;
      i64toi32_i32$5 = i64toi32_i32$3 - i64toi32_i32$1 | 0;
      i64toi32_i32$6 = i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0;
      i64toi32_i32$1 = i64toi32_i32$6 + i64toi32_i32$4 | 0;
      i64toi32_i32$1 = i64toi32_i32$2 - i64toi32_i32$1 | 0;
      $53$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $2$hi;
      i64toi32_i32$4 = $8;
      i64toi32_i32$1 = $53$hi;
      i64toi32_i32$3 = $2$hi;
      i64toi32_i32$0 = i64toi32_i32$4 ? i64toi32_i32$5 : $2;
      i64toi32_i32$2 = i64toi32_i32$4 ? i64toi32_i32$1 : i64toi32_i32$3;
      $1 = i64toi32_i32$0;
      $1$hi = i64toi32_i32$2;
      if (!(i64toi32_i32$0 | i64toi32_i32$2 | 0)) {
       break label$4
      }
      i64toi32_i32$2 = $3$hi;
      if (!($3 | i64toi32_i32$2 | 0)) {
       break label$3
      }
      i64toi32_i32$2 = $9$hi;
      i64toi32_i32$2 = $3$hi;
      i64toi32_i32$2 = $10$hi;
      i64toi32_i32$2 = $1$hi;
      i64toi32_i32$2 = $9$hi;
      i64toi32_i32$0 = $3$hi;
      i64toi32_i32$4 = $10$hi;
      i64toi32_i32$1 = $1$hi;
      __multi3($6 + 64 | 0 | 0, $9 | 0, i64toi32_i32$2 | 0, $3 | 0, i64toi32_i32$0 | 0, $10 | 0, i64toi32_i32$4 | 0, $1 | 0, i64toi32_i32$1 | 0);
      i64toi32_i32$0 = $6 + 72 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
      $9 = i64toi32_i32$1;
      $9$hi = i64toi32_i32$4;
      $8 = 1;
      i64toi32_i32$0 = $6;
      i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 64 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 68 | 0) >> 2] | 0;
      $1 = i64toi32_i32$4;
      $1$hi = i64toi32_i32$1;
      break label$2;
     }
     i64toi32_i32$1 = $9$hi;
     i64toi32_i32$1 = $10$hi;
     i64toi32_i32$1 = $9$hi;
     i64toi32_i32$4 = 0;
     i64toi32_i32$0 = $10$hi;
     i64toi32_i32$2 = 0;
     __multi3($6 + 16 | 0 | 0, $9 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$4 | 0, $10 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$2 | 0);
     i64toi32_i32$4 = ($6 + 16 | 0) + 8 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$4 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
     $9 = i64toi32_i32$2;
     $9$hi = i64toi32_i32$0;
     i64toi32_i32$4 = $6;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 16 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 20 | 0) >> 2] | 0;
     $1 = i64toi32_i32$0;
     $1$hi = i64toi32_i32$2;
     label$5 : {
      i64toi32_i32$2 = $3$hi;
      if (!!($3 | i64toi32_i32$2 | 0)) {
       break label$5
      }
      $8 = 0;
      break label$2;
     }
     i64toi32_i32$2 = $3$hi;
     i64toi32_i32$2 = $10$hi;
     i64toi32_i32$2 = $3$hi;
     i64toi32_i32$0 = 0;
     i64toi32_i32$4 = $10$hi;
     i64toi32_i32$1 = 0;
     __multi3($6 | 0, $3 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$0 | 0, $10 | 0, i64toi32_i32$4 | 0, 0 | 0, i64toi32_i32$1 | 0);
     i64toi32_i32$0 = $6 + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     i64toi32_i32$0 = i64toi32_i32$1;
     i64toi32_i32$1 = 0;
     i64toi32_i32$2 = 0;
     $91 = (i64toi32_i32$0 | 0) != (i64toi32_i32$2 | 0) | (i64toi32_i32$4 | 0) != (i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$0 = $9$hi;
     i64toi32_i32$2 = $6;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$4 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $94 = i64toi32_i32$0;
     $94$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $9$hi;
     i64toi32_i32$2 = $9;
     i64toi32_i32$0 = $94$hi;
     i64toi32_i32$1 = $94;
     i64toi32_i32$3 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
     if (i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $2 = i64toi32_i32$3;
     $2$hi = i64toi32_i32$5;
     i64toi32_i32$5 = $9$hi;
     i64toi32_i32$5 = $2$hi;
     i64toi32_i32$4 = i64toi32_i32$3;
     i64toi32_i32$2 = $9$hi;
     i64toi32_i32$1 = $9;
     $8 = $91 | (i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$4 >>> 0 < i64toi32_i32$1 >>> 0 | 0) | 0) | 0;
     i64toi32_i32$4 = i64toi32_i32$5;
     $9 = i64toi32_i32$3;
     $9$hi = i64toi32_i32$4;
     break label$2;
    }
    i64toi32_i32$4 = $9$hi;
    i64toi32_i32$4 = $10$hi;
    i64toi32_i32$4 = $9$hi;
    i64toi32_i32$5 = 0;
    i64toi32_i32$1 = $10$hi;
    i64toi32_i32$2 = 0;
    __multi3($6 + 48 | 0 | 0, $9 | 0, i64toi32_i32$4 | 0, 0 | 0, i64toi32_i32$5 | 0, $10 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$2 | 0);
    i64toi32_i32$2 = i64toi32_i32$4;
    i64toi32_i32$2 = $1$hi;
    i64toi32_i32$2 = i64toi32_i32$4;
    i64toi32_i32$1 = 0;
    i64toi32_i32$5 = $1$hi;
    i64toi32_i32$4 = 0;
    __multi3($6 + 32 | 0 | 0, $9 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$1 | 0, $1 | 0, i64toi32_i32$5 | 0, 0 | 0, i64toi32_i32$4 | 0);
    i64toi32_i32$1 = ($6 + 32 | 0) + 8 | 0;
    i64toi32_i32$4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
    i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
    i64toi32_i32$1 = i64toi32_i32$4;
    i64toi32_i32$4 = 0;
    i64toi32_i32$2 = 0;
    $113 = (i64toi32_i32$1 | 0) != (i64toi32_i32$2 | 0) | (i64toi32_i32$5 | 0) != (i64toi32_i32$4 | 0) | 0;
    i64toi32_i32$2 = ($6 + 48 | 0) + 8 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$5 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $1 = i64toi32_i32$1;
    $1$hi = i64toi32_i32$5;
    i64toi32_i32$2 = $6;
    i64toi32_i32$5 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
    $120 = i64toi32_i32$5;
    $120$hi = i64toi32_i32$1;
    i64toi32_i32$1 = $1$hi;
    i64toi32_i32$2 = $1;
    i64toi32_i32$5 = $120$hi;
    i64toi32_i32$4 = $120;
    i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
    i64toi32_i32$3 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
    if (i64toi32_i32$0 >>> 0 < i64toi32_i32$4 >>> 0) {
     i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
    }
    $9 = i64toi32_i32$0;
    $9$hi = i64toi32_i32$3;
    i64toi32_i32$3 = $1$hi;
    i64toi32_i32$3 = $9$hi;
    i64toi32_i32$1 = i64toi32_i32$0;
    i64toi32_i32$2 = $1$hi;
    i64toi32_i32$4 = $1;
    $8 = $113 | (i64toi32_i32$3 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$4 >>> 0 | 0) | 0) | 0;
    i64toi32_i32$4 = $6;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$4 + 48 | 0) >> 2] | 0;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 52 | 0) >> 2] | 0;
    $1 = i64toi32_i32$1;
    $1$hi = i64toi32_i32$3;
   }
   label$6 : {
    label$7 : {
     if ($7) {
      break label$7
     }
     label$8 : {
      i64toi32_i32$3 = $9$hi;
      i64toi32_i32$4 = $9;
      i64toi32_i32$1 = 0;
      i64toi32_i32$2 = 0;
      if ((i64toi32_i32$3 | 0) < (i64toi32_i32$1 | 0)) {
       $56 = 1
      } else {
       if ((i64toi32_i32$3 | 0) <= (i64toi32_i32$1 | 0)) {
        if (i64toi32_i32$4 >>> 0 >= i64toi32_i32$2 >>> 0) {
         $57 = 0
        } else {
         $57 = 1
        }
        $58 = $57;
       } else {
        $58 = 0
       }
       $56 = $58;
      }
      if ($56) {
       break label$8
      }
      i64toi32_i32$4 = $1$hi;
      $10 = $1;
      $10$hi = i64toi32_i32$4;
      break label$6;
     }
     $7 = 1;
     i64toi32_i32$4 = $1$hi;
     $10 = $1;
     $10$hi = i64toi32_i32$4;
     break label$1;
    }
    i64toi32_i32$4 = $1$hi;
    i64toi32_i32$4 = 0;
    i64toi32_i32$2 = 0;
    i64toi32_i32$3 = $1$hi;
    i64toi32_i32$1 = $1;
    i64toi32_i32$5 = i64toi32_i32$2 - i64toi32_i32$1 | 0;
    i64toi32_i32$6 = i64toi32_i32$2 >>> 0 < i64toi32_i32$1 >>> 0;
    i64toi32_i32$0 = i64toi32_i32$6 + i64toi32_i32$3 | 0;
    i64toi32_i32$0 = i64toi32_i32$4 - i64toi32_i32$0 | 0;
    $10 = i64toi32_i32$5;
    $10$hi = i64toi32_i32$0;
    $7 = 1;
    i64toi32_i32$0 = $9$hi;
    i64toi32_i32$0 = i64toi32_i32$3;
    i64toi32_i32$0 = i64toi32_i32$3;
    i64toi32_i32$4 = i64toi32_i32$1;
    i64toi32_i32$2 = 0;
    i64toi32_i32$1 = 0;
    $137 = (i64toi32_i32$4 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$3 | 0) != (i64toi32_i32$2 | 0) | 0;
    i64toi32_i32$4 = 0;
    $138$hi = i64toi32_i32$4;
    i64toi32_i32$4 = $9$hi;
    i64toi32_i32$1 = $9;
    i64toi32_i32$0 = $138$hi;
    i64toi32_i32$2 = $137;
    i64toi32_i32$3 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
    i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
    if (i64toi32_i32$3 >>> 0 < i64toi32_i32$2 >>> 0) {
     i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
    }
    $139$hi = i64toi32_i32$5;
    i64toi32_i32$5 = 0;
    i64toi32_i32$4 = 0;
    i64toi32_i32$1 = $139$hi;
    i64toi32_i32$2 = i64toi32_i32$3;
    i64toi32_i32$0 = i64toi32_i32$4 - i64toi32_i32$2 | 0;
    i64toi32_i32$6 = i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0;
    i64toi32_i32$3 = i64toi32_i32$6 + i64toi32_i32$1 | 0;
    i64toi32_i32$3 = i64toi32_i32$5 - i64toi32_i32$3 | 0;
    $9 = i64toi32_i32$0;
    $9$hi = i64toi32_i32$3;
    i64toi32_i32$5 = i64toi32_i32$0;
    i64toi32_i32$4 = -1;
    i64toi32_i32$2 = -1;
    if ((i64toi32_i32$3 | 0) > (i64toi32_i32$4 | 0)) {
     $59 = 1
    } else {
     if ((i64toi32_i32$3 | 0) >= (i64toi32_i32$4 | 0)) {
      if (i64toi32_i32$5 >>> 0 <= i64toi32_i32$2 >>> 0) {
       $60 = 0
      } else {
       $60 = 1
      }
      $61 = $60;
     } else {
      $61 = 0
     }
     $59 = $61;
    }
    if ($59) {
     break label$1
    }
   }
   $7 = $8;
  }
  HEAP32[$5 >> 2] = $7;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$3 = $0;
  HEAP32[(i64toi32_i32$3 + 8 | 0) >> 2] = $9;
  HEAP32[(i64toi32_i32$3 + 12 | 0) >> 2] = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  HEAP32[i64toi32_i32$3 >> 2] = $10;
  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
  global$0 = $6 + 80 | 0;
 }
 
 function hashbrown__map__make_insert_hash__hb313f57dc55aac55($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$5 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $8$hi = 0, $7$hi = 0, $7 = 0, $8 = 0, $9$hi = 0, $9 = 0, $10$hi = 0, $10 = 0, $2 = 0, $11$hi = 0, $11 = 0, $12$hi = 0, $12 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $93 = 0, $25 = 0, $30 = 0, $37 = 0, $45 = 0, $49 = 0, $68 = 0, $68$hi = 0, $69 = 0, $69$hi = 0, $71$hi = 0, $76 = 0, $76$hi = 0, $82 = 0, $82$hi = 0, $87 = 0, $87$hi = 0, $91 = 0, $91$hi = 0, $94$hi = 0, $101 = 0, $101$hi = 0, $107 = 0, $107$hi = 0, $109 = 0, $109$hi = 0, $111$hi = 0, $117 = 0, $117$hi = 0, $123 = 0, $123$hi = 0, $126 = 0, $126$hi = 0, $127 = 0, $127$hi = 0, $129$hi = 0, $134 = 0, $134$hi = 0, $141 = 0, $141$hi = 0, $142 = 0, $142$hi = 0, $144$hi = 0, $149 = 0, $149$hi = 0, $156 = 0, $156$hi = 0, $157 = 0, $157$hi = 0, $159$hi = 0, $164 = 0, $164$hi = 0, $167$hi = 0, $169 = 0, $169$hi = 0, $171$hi = 0, $176 = 0, $176$hi = 0, $182$hi = 0, $94 = 0, $185 = 0, $185$hi = 0, $186 = 0, $186$hi = 0, $188 = 0, $188$hi = 0, $189 = 0, $189$hi = 0, $191 = 0, $191$hi = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  $3 = $2 + 64 | 0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = $2 + 48 | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = 1952801890;
  i64toi32_i32$3 = 2037671283;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $25 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $4;
  HEAP32[i64toi32_i32$2 >> 2] = $25;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  $5 = $2 + 40 | 0;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$1 = $7;
  i64toi32_i32$2 = 1685025377;
  i64toi32_i32$3 = 1852075885;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $30 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $5;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  $6 = $2 + 32 | 0;
  i64toi32_i32$0 = $0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$2;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$2 = 1819895653;
  i64toi32_i32$3 = 1852142177;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $37 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $6;
  HEAP32[i64toi32_i32$0 >> 2] = $37;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$0 = $2;
  i64toi32_i32$2 = 0;
  HEAP32[(i64toi32_i32$0 + 56 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 60 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$1 = $8;
  i64toi32_i32$0 = 1936682341;
  i64toi32_i32$3 = 1886610805;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $45 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $2;
  HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = $45;
  HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $49 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[(i64toi32_i32$0 + 72 | 0) >> 2] = $49;
  HEAP32[(i64toi32_i32$0 + 76 | 0) >> 2] = i64toi32_i32$1;
  $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5(i64toi32_i32$0 + 8 | 0 | 0, i64toi32_i32$0 + 72 | 0 | 0, 8 | 0);
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = 0;
  $8 = i64toi32_i32$1;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
  $9 = i64toi32_i32$0;
  $9$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$1;
  $10$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $6;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $11 = i64toi32_i32$0;
  $11$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $5;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$1;
  $7$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $12 = i64toi32_i32$0;
  $12$hi = i64toi32_i32$1;
  global$0 = i64toi32_i32$2 + 80 | 0;
  i64toi32_i32$1 = $10$hi;
  $68 = $10;
  $68$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  $69 = $9;
  $69$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$2 = $8;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $93 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $93 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $71$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $69$hi;
  i64toi32_i32$1 = $69;
  i64toi32_i32$2 = $71$hi;
  i64toi32_i32$3 = $93;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  $8 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $68$hi;
  i64toi32_i32$0 = $68;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
  $9 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $9$hi = i64toi32_i32$1;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($9 | 0, i64toi32_i32$1 | 0, 16 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $76 = i64toi32_i32$0;
  $76$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$4;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $76$hi;
  i64toi32_i32$1 = $76;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$2;
  $82 = $10;
  $82$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$5 = $7;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$0;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$0 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $87 = i64toi32_i32$5;
  $87$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $82$hi;
  i64toi32_i32$2 = $82;
  i64toi32_i32$5 = $87$hi;
  i64toi32_i32$3 = $87;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $12 = i64toi32_i32$1;
  $12$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $91 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $91$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($7 | 0, i64toi32_i32$2 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $94$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$2 = $94$hi;
  i64toi32_i32$0 = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  $7 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $8 = i64toi32_i32$5;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$1 | 0, 17 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $101 = i64toi32_i32$2;
  $101$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$2 = $101$hi;
  i64toi32_i32$3 = $101;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $91$hi;
  i64toi32_i32$1 = $91;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$0;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $107 = i64toi32_i32$1;
  $107$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$1 = $107$hi;
  i64toi32_i32$3 = $107;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $7 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$1;
  $109 = $7;
  $109$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($10 | 0, i64toi32_i32$1 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $111$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$1 = $111$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $10$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($8 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 255;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $117 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $117$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$2 = $10;
  i64toi32_i32$1 = $117$hi;
  i64toi32_i32$3 = $117;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $8 = i64toi32_i32$4;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $109$hi;
  i64toi32_i32$5 = $109;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 17 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $123 = i64toi32_i32$5;
  $123$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$5 = $123$hi;
  i64toi32_i32$3 = $123;
  i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$5;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $126 = i64toi32_i32$0;
  $126$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  $127 = $7;
  $127$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($10 | 0, i64toi32_i32$5 | 0, 16 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $129$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $8$hi;
  i64toi32_i32$5 = $129$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $8 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($9 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $134 = i64toi32_i32$4;
  $134$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$5 = $8;
  i64toi32_i32$4 = $134$hi;
  i64toi32_i32$3 = $134;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $9 = i64toi32_i32$2;
  $9$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $127$hi;
  i64toi32_i32$0 = $127;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$4;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $126$hi;
  i64toi32_i32$1 = $126;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $10 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$0 | 0, 17 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $141 = i64toi32_i32$1;
  $141$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  $142 = $10;
  $142$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($8 | 0, i64toi32_i32$0 | 0, 21 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $144$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $144$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
  $8 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($11 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $149 = i64toi32_i32$2;
  $149$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = $8;
  i64toi32_i32$2 = $149$hi;
  i64toi32_i32$3 = $149;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $9 = i64toi32_i32$5;
  $9$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $142$hi;
  i64toi32_i32$1 = $142;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $10 = i64toi32_i32$2;
  $10$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $141$hi;
  i64toi32_i32$4 = $141;
  i64toi32_i32$1 = $10$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $11 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $11$hi = i64toi32_i32$1;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($11 | 0, i64toi32_i32$1 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $156 = i64toi32_i32$4;
  $156$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $11$hi;
  $157 = $11;
  $157$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($8 | 0, i64toi32_i32$1 | 0, 16 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $159$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$1 = $159$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $8 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $164 = i64toi32_i32$5;
  $164$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$1 = $8;
  i64toi32_i32$5 = $164$hi;
  i64toi32_i32$3 = $164;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $157$hi;
  i64toi32_i32$4 = $157;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $167$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $156$hi;
  i64toi32_i32$2 = $156;
  i64toi32_i32$4 = $167$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $9 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $9$hi = i64toi32_i32$4;
  $169 = $9;
  $169$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($8 | 0, i64toi32_i32$4 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $171$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$4 = $171$hi;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($10 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $176 = i64toi32_i32$0;
  $176$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = $7;
  i64toi32_i32$0 = $176$hi;
  i64toi32_i32$3 = $176;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $8 = i64toi32_i32$1;
  $8$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $169$hi;
  i64toi32_i32$2 = $169;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$1 | 0, 16 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $182$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$1 = $182$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $94 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($94 | 0, i64toi32_i32$2 | 0, 21 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $185 = i64toi32_i32$5;
  $185$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$5 = $185$hi;
  i64toi32_i32$3 = $185;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $186 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $186$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($9 | 0, i64toi32_i32$5 | 0, 17 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $188 = i64toi32_i32$1;
  $188$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $186$hi;
  i64toi32_i32$2 = $186;
  i64toi32_i32$1 = $188$hi;
  i64toi32_i32$3 = $188;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $189 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $189$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64(i64toi32_i32$0 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $191 = i64toi32_i32$2;
  $191$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $189$hi;
  i64toi32_i32$5 = $189;
  i64toi32_i32$2 = $191$hi;
  i64toi32_i32$3 = $191;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$5 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$2;
  return i64toi32_i32$5 | 0;
 }
 
 function hashbrown__map__make_insert_hash__he623a39a8b84cb13($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $8$hi = 0, $7$hi = 0, $7 = 0, $8 = 0, $9$hi = 0, $9 = 0, $10$hi = 0, $10 = 0, $11$hi = 0, $2 = 0, $11 = 0, $12$hi = 0, $12 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $92 = 0, $25 = 0, $30 = 0, $37 = 0, $45 = 0, $68 = 0, $68$hi = 0, $69 = 0, $69$hi = 0, $71$hi = 0, $76 = 0, $76$hi = 0, $82 = 0, $82$hi = 0, $87 = 0, $87$hi = 0, $91 = 0, $91$hi = 0, $94$hi = 0, $101 = 0, $101$hi = 0, $107 = 0, $107$hi = 0, $109 = 0, $109$hi = 0, $111$hi = 0, $117 = 0, $117$hi = 0, $123 = 0, $123$hi = 0, $126 = 0, $126$hi = 0, $127 = 0, $127$hi = 0, $129$hi = 0, $134 = 0, $134$hi = 0, $141 = 0, $141$hi = 0, $142 = 0, $142$hi = 0, $144$hi = 0, $149 = 0, $149$hi = 0, $156 = 0, $156$hi = 0, $157 = 0, $157$hi = 0, $159$hi = 0, $164 = 0, $164$hi = 0, $167$hi = 0, $169 = 0, $169$hi = 0, $171$hi = 0, $176 = 0, $176$hi = 0, $182$hi = 0, $93 = 0, $185 = 0, $185$hi = 0, $186 = 0, $186$hi = 0, $188 = 0, $188$hi = 0, $189 = 0, $189$hi = 0, $191 = 0, $191$hi = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  $3 = $2 + 64 | 0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = $2 + 48 | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = 1952801890;
  i64toi32_i32$3 = 2037671283;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $25 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $4;
  HEAP32[i64toi32_i32$2 >> 2] = $25;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  $5 = $2 + 40 | 0;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$1 = $7;
  i64toi32_i32$2 = 1685025377;
  i64toi32_i32$3 = 1852075885;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $30 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $5;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  $6 = $2 + 32 | 0;
  i64toi32_i32$0 = $0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$2;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$2 = 1819895653;
  i64toi32_i32$3 = 1852142177;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $37 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $6;
  HEAP32[i64toi32_i32$0 >> 2] = $37;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$0 = $2;
  i64toi32_i32$2 = 0;
  HEAP32[(i64toi32_i32$0 + 56 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 60 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$1 = $8;
  i64toi32_i32$0 = 1936682341;
  i64toi32_i32$3 = 1886610805;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $45 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $2;
  HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = $45;
  HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 76 | 0) >> 2] = HEAP32[(HEAP32[$1 >> 2] | 0) >> 2] | 0;
  $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_2(i64toi32_i32$1 + 8 | 0 | 0, i64toi32_i32$1 + 76 | 0 | 0, 4 | 0);
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = 0;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $6;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $12 = i64toi32_i32$1;
  $12$hi = i64toi32_i32$0;
  global$0 = i64toi32_i32$2 + 80 | 0;
  i64toi32_i32$0 = $10$hi;
  $68 = $10;
  $68$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  $69 = $9;
  $69$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$2 = $8;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $92 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $92 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $71$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $69$hi;
  i64toi32_i32$0 = $69;
  i64toi32_i32$2 = $71$hi;
  i64toi32_i32$3 = $92;
  i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
  $8 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $68$hi;
  i64toi32_i32$1 = $68;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $9 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($9 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $76 = i64toi32_i32$1;
  $76$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$4;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $76$hi;
  i64toi32_i32$0 = $76;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$2;
  $82 = $10;
  $82$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$5 = $7;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $87 = i64toi32_i32$5;
  $87$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $82$hi;
  i64toi32_i32$2 = $82;
  i64toi32_i32$5 = $87$hi;
  i64toi32_i32$3 = $87;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $12 = i64toi32_i32$0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $91 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $91$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($7 | 0, i64toi32_i32$2 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $94$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$2 = $94$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $8 = i64toi32_i32$5;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 17 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $101 = i64toi32_i32$2;
  $101$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$2 = $101$hi;
  i64toi32_i32$3 = $101;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $91$hi;
  i64toi32_i32$0 = $91;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $107 = i64toi32_i32$0;
  $107$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = $107$hi;
  i64toi32_i32$3 = $107;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $7 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$0;
  $109 = $7;
  $109$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($10 | 0, i64toi32_i32$0 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $111$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$0 = $111$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $10$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($8 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 255;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $117 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $117$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$2 = $10;
  i64toi32_i32$0 = $117$hi;
  i64toi32_i32$3 = $117;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $8 = i64toi32_i32$4;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $109$hi;
  i64toi32_i32$5 = $109;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$0;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 17 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $123 = i64toi32_i32$5;
  $123$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$5 = $123$hi;
  i64toi32_i32$3 = $123;
  i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
  $7 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$5;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $126 = i64toi32_i32$1;
  $126$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  $127 = $7;
  $127$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$5 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $129$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $8$hi;
  i64toi32_i32$5 = $129$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $8 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($9 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $134 = i64toi32_i32$4;
  $134$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$5 = $8;
  i64toi32_i32$4 = $134$hi;
  i64toi32_i32$3 = $134;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $9 = i64toi32_i32$2;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $127$hi;
  i64toi32_i32$1 = $127;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$4;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $126$hi;
  i64toi32_i32$0 = $126;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($10 | 0, i64toi32_i32$1 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $141 = i64toi32_i32$0;
  $141$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $10$hi;
  $142 = $10;
  $142$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($8 | 0, i64toi32_i32$1 | 0, 21 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $144$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$1 = $144$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $8 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $149 = i64toi32_i32$2;
  $149$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$1 = $8;
  i64toi32_i32$2 = $149$hi;
  i64toi32_i32$3 = $149;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $9 = i64toi32_i32$5;
  $9$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $142$hi;
  i64toi32_i32$0 = $142;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $10 = i64toi32_i32$2;
  $10$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $141$hi;
  i64toi32_i32$4 = $141;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $11 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $156 = i64toi32_i32$4;
  $156$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  $157 = $11;
  $157$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($8 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $159$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $159$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $8 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $164 = i64toi32_i32$5;
  $164$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$0 = $8;
  i64toi32_i32$5 = $164$hi;
  i64toi32_i32$3 = $164;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$1;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $157$hi;
  i64toi32_i32$4 = $157;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $167$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $156$hi;
  i64toi32_i32$2 = $156;
  i64toi32_i32$4 = $167$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $9 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $9$hi = i64toi32_i32$4;
  $169 = $9;
  $169$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($8 | 0, i64toi32_i32$4 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $171$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$4 = $171$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $176 = i64toi32_i32$1;
  $176$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = $7;
  i64toi32_i32$1 = $176$hi;
  i64toi32_i32$3 = $176;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $169$hi;
  i64toi32_i32$2 = $169;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $10 = i64toi32_i32$1;
  $10$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $182$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$0 = $182$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $93 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($93 | 0, i64toi32_i32$2 | 0, 21 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $185 = i64toi32_i32$5;
  $185$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$5 = $185$hi;
  i64toi32_i32$3 = $185;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $186 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $186$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($9 | 0, i64toi32_i32$5 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $188 = i64toi32_i32$0;
  $188$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $186$hi;
  i64toi32_i32$2 = $186;
  i64toi32_i32$0 = $188$hi;
  i64toi32_i32$3 = $188;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $189 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $189$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $191 = i64toi32_i32$2;
  $191$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $189$hi;
  i64toi32_i32$5 = $189;
  i64toi32_i32$2 = $191$hi;
  i64toi32_i32$3 = $191;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$5 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$2;
  return i64toi32_i32$5 | 0;
 }
 
 function hashbrown__map__make_hash__h18de0e6f479ebafc($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $8$hi = 0, $7$hi = 0, $7 = 0, $8 = 0, $9$hi = 0, $9 = 0, $10$hi = 0, $10 = 0, $11$hi = 0, $2 = 0, $11 = 0, $12$hi = 0, $12 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $92 = 0, $25 = 0, $30 = 0, $37 = 0, $45 = 0, $68 = 0, $68$hi = 0, $69 = 0, $69$hi = 0, $71$hi = 0, $76 = 0, $76$hi = 0, $82 = 0, $82$hi = 0, $87 = 0, $87$hi = 0, $91 = 0, $91$hi = 0, $94$hi = 0, $101 = 0, $101$hi = 0, $107 = 0, $107$hi = 0, $109 = 0, $109$hi = 0, $111$hi = 0, $117 = 0, $117$hi = 0, $123 = 0, $123$hi = 0, $126 = 0, $126$hi = 0, $127 = 0, $127$hi = 0, $129$hi = 0, $134 = 0, $134$hi = 0, $141 = 0, $141$hi = 0, $142 = 0, $142$hi = 0, $144$hi = 0, $149 = 0, $149$hi = 0, $156 = 0, $156$hi = 0, $157 = 0, $157$hi = 0, $159$hi = 0, $164 = 0, $164$hi = 0, $167$hi = 0, $169 = 0, $169$hi = 0, $171$hi = 0, $176 = 0, $176$hi = 0, $182$hi = 0, $93 = 0, $185 = 0, $185$hi = 0, $186 = 0, $186$hi = 0, $188 = 0, $188$hi = 0, $189 = 0, $189$hi = 0, $191 = 0, $191$hi = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  $3 = $2 + 64 | 0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = $2 + 48 | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = 1952801890;
  i64toi32_i32$3 = 2037671283;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $25 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $4;
  HEAP32[i64toi32_i32$2 >> 2] = $25;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  $5 = $2 + 40 | 0;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$1 = $7;
  i64toi32_i32$2 = 1685025377;
  i64toi32_i32$3 = 1852075885;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $30 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $5;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  $6 = $2 + 32 | 0;
  i64toi32_i32$0 = $0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$2;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$2 = 1819895653;
  i64toi32_i32$3 = 1852142177;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $37 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $6;
  HEAP32[i64toi32_i32$0 >> 2] = $37;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$0 = $2;
  i64toi32_i32$2 = 0;
  HEAP32[(i64toi32_i32$0 + 56 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 60 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$1 = $8;
  i64toi32_i32$0 = 1936682341;
  i64toi32_i32$3 = 1886610805;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $45 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $2;
  HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = $45;
  HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 76 | 0) >> 2] = HEAP32[(HEAP32[$1 >> 2] | 0) >> 2] | 0;
  $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_2(i64toi32_i32$1 + 8 | 0 | 0, i64toi32_i32$1 + 76 | 0 | 0, 4 | 0);
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = 0;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $6;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $12 = i64toi32_i32$1;
  $12$hi = i64toi32_i32$0;
  global$0 = i64toi32_i32$2 + 80 | 0;
  i64toi32_i32$0 = $10$hi;
  $68 = $10;
  $68$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  $69 = $9;
  $69$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$2 = $8;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $92 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $92 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $71$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $69$hi;
  i64toi32_i32$0 = $69;
  i64toi32_i32$2 = $71$hi;
  i64toi32_i32$3 = $92;
  i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
  $8 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $68$hi;
  i64toi32_i32$1 = $68;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $9 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($9 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $76 = i64toi32_i32$1;
  $76$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$4;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $76$hi;
  i64toi32_i32$0 = $76;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$2;
  $82 = $10;
  $82$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$5 = $7;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $87 = i64toi32_i32$5;
  $87$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $82$hi;
  i64toi32_i32$2 = $82;
  i64toi32_i32$5 = $87$hi;
  i64toi32_i32$3 = $87;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $12 = i64toi32_i32$0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $91 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $91$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($7 | 0, i64toi32_i32$2 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $94$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$2 = $94$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $8 = i64toi32_i32$5;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 17 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $101 = i64toi32_i32$2;
  $101$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$2 = $101$hi;
  i64toi32_i32$3 = $101;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $91$hi;
  i64toi32_i32$0 = $91;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $107 = i64toi32_i32$0;
  $107$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = $107$hi;
  i64toi32_i32$3 = $107;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $7 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$0;
  $109 = $7;
  $109$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($10 | 0, i64toi32_i32$0 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $111$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$0 = $111$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $10$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($8 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 255;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $117 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $117$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$2 = $10;
  i64toi32_i32$0 = $117$hi;
  i64toi32_i32$3 = $117;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $8 = i64toi32_i32$4;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $109$hi;
  i64toi32_i32$5 = $109;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$0;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 17 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $123 = i64toi32_i32$5;
  $123$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$5 = $123$hi;
  i64toi32_i32$3 = $123;
  i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
  $7 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$5;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $126 = i64toi32_i32$1;
  $126$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  $127 = $7;
  $127$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$5 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $129$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $8$hi;
  i64toi32_i32$5 = $129$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $8 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($9 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $134 = i64toi32_i32$4;
  $134$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$5 = $8;
  i64toi32_i32$4 = $134$hi;
  i64toi32_i32$3 = $134;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $9 = i64toi32_i32$2;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $127$hi;
  i64toi32_i32$1 = $127;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$4;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $126$hi;
  i64toi32_i32$0 = $126;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($10 | 0, i64toi32_i32$1 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $141 = i64toi32_i32$0;
  $141$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $10$hi;
  $142 = $10;
  $142$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($8 | 0, i64toi32_i32$1 | 0, 21 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $144$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$1 = $144$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $8 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $149 = i64toi32_i32$2;
  $149$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$1 = $8;
  i64toi32_i32$2 = $149$hi;
  i64toi32_i32$3 = $149;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $9 = i64toi32_i32$5;
  $9$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $142$hi;
  i64toi32_i32$0 = $142;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $10 = i64toi32_i32$2;
  $10$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $141$hi;
  i64toi32_i32$4 = $141;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $11 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $156 = i64toi32_i32$4;
  $156$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  $157 = $11;
  $157$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($8 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $159$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $159$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $8 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $164 = i64toi32_i32$5;
  $164$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$0 = $8;
  i64toi32_i32$5 = $164$hi;
  i64toi32_i32$3 = $164;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$1;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $157$hi;
  i64toi32_i32$4 = $157;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $167$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $156$hi;
  i64toi32_i32$2 = $156;
  i64toi32_i32$4 = $167$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $9 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $9$hi = i64toi32_i32$4;
  $169 = $9;
  $169$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($8 | 0, i64toi32_i32$4 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $171$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$4 = $171$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $176 = i64toi32_i32$1;
  $176$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = $7;
  i64toi32_i32$1 = $176$hi;
  i64toi32_i32$3 = $176;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $169$hi;
  i64toi32_i32$2 = $169;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $10 = i64toi32_i32$1;
  $10$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $182$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$0 = $182$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $93 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($93 | 0, i64toi32_i32$2 | 0, 21 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $185 = i64toi32_i32$5;
  $185$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$5 = $185$hi;
  i64toi32_i32$3 = $185;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $186 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $186$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($9 | 0, i64toi32_i32$5 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $188 = i64toi32_i32$0;
  $188$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $186$hi;
  i64toi32_i32$2 = $186;
  i64toi32_i32$0 = $188$hi;
  i64toi32_i32$3 = $188;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $189 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $189$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $191 = i64toi32_i32$2;
  $191$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $189$hi;
  i64toi32_i32$5 = $189;
  i64toi32_i32$2 = $191$hi;
  i64toi32_i32$3 = $191;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$5 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$2;
  return i64toi32_i32$5 | 0;
 }
 
 function hashbrown__map__make_hash__ha3ef0991d7baec61($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$5 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $8$hi = 0, $7$hi = 0, $7 = 0, $8 = 0, $9$hi = 0, $9 = 0, $10$hi = 0, $10 = 0, $2 = 0, $11$hi = 0, $11 = 0, $12$hi = 0, $12 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $93 = 0, $25 = 0, $30 = 0, $37 = 0, $45 = 0, $49 = 0, $68 = 0, $68$hi = 0, $69 = 0, $69$hi = 0, $71$hi = 0, $76 = 0, $76$hi = 0, $82 = 0, $82$hi = 0, $87 = 0, $87$hi = 0, $91 = 0, $91$hi = 0, $94$hi = 0, $101 = 0, $101$hi = 0, $107 = 0, $107$hi = 0, $109 = 0, $109$hi = 0, $111$hi = 0, $117 = 0, $117$hi = 0, $123 = 0, $123$hi = 0, $126 = 0, $126$hi = 0, $127 = 0, $127$hi = 0, $129$hi = 0, $134 = 0, $134$hi = 0, $141 = 0, $141$hi = 0, $142 = 0, $142$hi = 0, $144$hi = 0, $149 = 0, $149$hi = 0, $156 = 0, $156$hi = 0, $157 = 0, $157$hi = 0, $159$hi = 0, $164 = 0, $164$hi = 0, $167$hi = 0, $169 = 0, $169$hi = 0, $171$hi = 0, $176 = 0, $176$hi = 0, $182$hi = 0, $94 = 0, $185 = 0, $185$hi = 0, $186 = 0, $186$hi = 0, $188 = 0, $188$hi = 0, $189 = 0, $189$hi = 0, $191 = 0, $191$hi = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  $3 = $2 + 64 | 0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = $2 + 48 | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = 1952801890;
  i64toi32_i32$3 = 2037671283;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $25 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $4;
  HEAP32[i64toi32_i32$2 >> 2] = $25;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  $5 = $2 + 40 | 0;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$1 = $7;
  i64toi32_i32$2 = 1685025377;
  i64toi32_i32$3 = 1852075885;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $30 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $5;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  $6 = $2 + 32 | 0;
  i64toi32_i32$0 = $0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$2;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$2 = 1819895653;
  i64toi32_i32$3 = 1852142177;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $37 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $6;
  HEAP32[i64toi32_i32$0 >> 2] = $37;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$0 = $2;
  i64toi32_i32$2 = 0;
  HEAP32[(i64toi32_i32$0 + 56 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 60 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$1 = $8;
  i64toi32_i32$0 = 1936682341;
  i64toi32_i32$3 = 1886610805;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $45 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $2;
  HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = $45;
  HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $49 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[(i64toi32_i32$0 + 72 | 0) >> 2] = $49;
  HEAP32[(i64toi32_i32$0 + 76 | 0) >> 2] = i64toi32_i32$1;
  $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5(i64toi32_i32$0 + 8 | 0 | 0, i64toi32_i32$0 + 72 | 0 | 0, 8 | 0);
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = 0;
  $8 = i64toi32_i32$1;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
  $9 = i64toi32_i32$0;
  $9$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$1;
  $10$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $6;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $11 = i64toi32_i32$0;
  $11$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $5;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$1;
  $7$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $12 = i64toi32_i32$0;
  $12$hi = i64toi32_i32$1;
  global$0 = i64toi32_i32$2 + 80 | 0;
  i64toi32_i32$1 = $10$hi;
  $68 = $10;
  $68$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  $69 = $9;
  $69$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$2 = $8;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $93 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $93 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $71$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $69$hi;
  i64toi32_i32$1 = $69;
  i64toi32_i32$2 = $71$hi;
  i64toi32_i32$3 = $93;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  $8 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $68$hi;
  i64toi32_i32$0 = $68;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
  $9 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $9$hi = i64toi32_i32$1;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($9 | 0, i64toi32_i32$1 | 0, 16 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $76 = i64toi32_i32$0;
  $76$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$4;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $76$hi;
  i64toi32_i32$1 = $76;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$2;
  $82 = $10;
  $82$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$5 = $7;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$0;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$0 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $87 = i64toi32_i32$5;
  $87$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $82$hi;
  i64toi32_i32$2 = $82;
  i64toi32_i32$5 = $87$hi;
  i64toi32_i32$3 = $87;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $12 = i64toi32_i32$1;
  $12$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $91 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $91$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($7 | 0, i64toi32_i32$2 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $94$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$2 = $94$hi;
  i64toi32_i32$0 = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  $7 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $8 = i64toi32_i32$5;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$1 | 0, 17 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $101 = i64toi32_i32$2;
  $101$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$2 = $101$hi;
  i64toi32_i32$3 = $101;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $91$hi;
  i64toi32_i32$1 = $91;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$0;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $107 = i64toi32_i32$1;
  $107$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$1 = $107$hi;
  i64toi32_i32$3 = $107;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $7 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$1;
  $109 = $7;
  $109$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($10 | 0, i64toi32_i32$1 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $111$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$1 = $111$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $10$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($8 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 255;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $117 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $117$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$2 = $10;
  i64toi32_i32$1 = $117$hi;
  i64toi32_i32$3 = $117;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $8 = i64toi32_i32$4;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $109$hi;
  i64toi32_i32$5 = $109;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 17 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $123 = i64toi32_i32$5;
  $123$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$5 = $123$hi;
  i64toi32_i32$3 = $123;
  i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$5;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $126 = i64toi32_i32$0;
  $126$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  $127 = $7;
  $127$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($10 | 0, i64toi32_i32$5 | 0, 16 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $129$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $8$hi;
  i64toi32_i32$5 = $129$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $8 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($9 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $134 = i64toi32_i32$4;
  $134$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$5 = $8;
  i64toi32_i32$4 = $134$hi;
  i64toi32_i32$3 = $134;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $9 = i64toi32_i32$2;
  $9$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $127$hi;
  i64toi32_i32$0 = $127;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$4;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $126$hi;
  i64toi32_i32$1 = $126;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $10 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$0 | 0, 17 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $141 = i64toi32_i32$1;
  $141$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  $142 = $10;
  $142$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($8 | 0, i64toi32_i32$0 | 0, 21 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $144$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $144$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
  $8 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($11 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $149 = i64toi32_i32$2;
  $149$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = $8;
  i64toi32_i32$2 = $149$hi;
  i64toi32_i32$3 = $149;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $9 = i64toi32_i32$5;
  $9$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $142$hi;
  i64toi32_i32$1 = $142;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $10 = i64toi32_i32$2;
  $10$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $141$hi;
  i64toi32_i32$4 = $141;
  i64toi32_i32$1 = $10$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $11 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $11$hi = i64toi32_i32$1;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($11 | 0, i64toi32_i32$1 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $156 = i64toi32_i32$4;
  $156$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $11$hi;
  $157 = $11;
  $157$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($8 | 0, i64toi32_i32$1 | 0, 16 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $159$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$1 = $159$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $8 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $164 = i64toi32_i32$5;
  $164$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$1 = $8;
  i64toi32_i32$5 = $164$hi;
  i64toi32_i32$3 = $164;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $157$hi;
  i64toi32_i32$4 = $157;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $167$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $156$hi;
  i64toi32_i32$2 = $156;
  i64toi32_i32$4 = $167$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $9 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $9$hi = i64toi32_i32$4;
  $169 = $9;
  $169$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($8 | 0, i64toi32_i32$4 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $171$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$4 = $171$hi;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($10 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $176 = i64toi32_i32$0;
  $176$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = $7;
  i64toi32_i32$0 = $176$hi;
  i64toi32_i32$3 = $176;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $8 = i64toi32_i32$1;
  $8$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $169$hi;
  i64toi32_i32$2 = $169;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$1 | 0, 16 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $182$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$1 = $182$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $94 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($94 | 0, i64toi32_i32$2 | 0, 21 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $185 = i64toi32_i32$5;
  $185$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$5 = $185$hi;
  i64toi32_i32$3 = $185;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $186 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $186$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($9 | 0, i64toi32_i32$5 | 0, 17 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $188 = i64toi32_i32$1;
  $188$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $186$hi;
  i64toi32_i32$2 = $186;
  i64toi32_i32$1 = $188$hi;
  i64toi32_i32$3 = $188;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $189 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $189$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64(i64toi32_i32$0 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $191 = i64toi32_i32$2;
  $191$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $189$hi;
  i64toi32_i32$5 = $189;
  i64toi32_i32$2 = $191$hi;
  i64toi32_i32$3 = $191;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$5 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$2;
  return i64toi32_i32$5 | 0;
 }
 
 function $serde_json__read__StrRead_20as_20serde_json__read__Read___parse_str__h09f2a2399a6a37b5($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $8 = 0, $4 = 0, $5 = 0, $3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $6 = 0, $7 = 0, $9 = 0, $10 = 0, $11 = 0, $11$hi = 0;
  $3 = global$0 - 32 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           label$10 : while (1) {
            label$11 : {
             label$12 : {
              $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
              $5 = HEAP32[($1 + 4 | 0) >> 2] | 0;
              if ($4 >>> 0 >= $5 >>> 0) {
               break label$12
              }
              $6 = HEAP32[$1 >> 2] | 0;
              $7 = 1;
              $8 = $4;
              label$13 : {
               label$14 : while (1) {
                $9 = $6 + $8 | 0;
                $10 = HEAPU8[$9 >> 0] | 0;
                if (HEAPU8[($10 + 1087684 | 0) >> 0] | 0) {
                 break label$13
                }
                $8 = $8 + 1 | 0;
                HEAP32[($1 + 8 | 0) >> 2] = $8;
                $7 = $7 + 1 | 0;
                if (($5 | 0) != ($8 | 0)) {
                 continue label$14
                }
                break label$2;
               };
              }
              if (($10 | 0) == (92 | 0)) {
               break label$11
              }
              if (($10 | 0) == (34 | 0)) {
               break label$9
              }
              HEAP32[($1 + 8 | 0) >> 2] = $8 + 1 | 0;
              HEAP32[($3 + 16 | 0) >> 2] = 15;
              serde_json__read__error__h78831bedcbd1affe($0 | 0, $1 | 0, $3 + 16 | 0 | 0);
              break label$1;
             }
             if (($4 | 0) == ($5 | 0)) {
              break label$2
             }
             core__panicking__panic_bounds_check__h808b524af17640b1($4 | 0, $5 | 0, 1087604 | 0);
             abort();
            }
            if ($8 >>> 0 < $4 >>> 0) {
             break label$8
            }
            if ($8 >>> 0 > $5 >>> 0) {
             break label$7
            }
            $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend__T_2ccore__slice__iter__Iter_T_____spec_extend__hbd860717b01c36cd($2 | 0, $6 + $4 | 0 | 0, $9 | 0);
            HEAP32[($1 + 8 | 0) >> 2] = $8 + 1 | 0;
            $8 = serde_json__read__parse_escape__h175788f180e5a403($1 | 0, $2 | 0) | 0;
            if (!$8) {
             continue label$10
            }
            break label$10;
           };
           HEAP32[$0 >> 2] = 1;
           HEAP32[($0 + 4 | 0) >> 2] = $8;
           break label$1;
          }
          label$15 : {
           if (!(HEAP32[($2 + 8 | 0) >> 2] | 0)) {
            break label$15
           }
           if ($8 >>> 0 < $4 >>> 0) {
            break label$6
           }
           if ($8 >>> 0 > $5 >>> 0) {
            break label$5
           }
           $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend__T_2ccore__slice__iter__Iter_T_____spec_extend__hbd860717b01c36cd($2 | 0, $6 + $4 | 0 | 0, $9 | 0);
           HEAP32[($1 + 8 | 0) >> 2] = $8 + 1 | 0;
           $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $2 | 0);
           i64toi32_i32$0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
           i64toi32_i32$1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
           $11 = i64toi32_i32$0;
           $11$hi = i64toi32_i32$1;
           i64toi32_i32$0 = $0;
           i64toi32_i32$1 = 1;
           HEAP32[$0 >> 2] = 0;
           HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$1;
           i64toi32_i32$1 = $11$hi;
           i64toi32_i32$0 = $0 + 8 | 0;
           HEAP32[i64toi32_i32$0 >> 2] = $11;
           HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
           break label$1;
          }
          if ($8 >>> 0 < $4 >>> 0) {
           break label$4
          }
          if ($8 >>> 0 > $5 >>> 0) {
           break label$3
          }
          i64toi32_i32$0 = $0;
          i64toi32_i32$1 = 0;
          HEAP32[$0 >> 2] = 0;
          HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$1;
          HEAP32[($0 + 12 | 0) >> 2] = $7 + -1 | 0;
          HEAP32[($0 + 8 | 0) >> 2] = $6 + $4 | 0;
          HEAP32[($1 + 8 | 0) >> 2] = $8 + 1 | 0;
          break label$1;
         }
         core__slice__index__slice_index_order_fail__h71e247dec3f266ff($4 | 0, $8 | 0, 1087620 | 0);
         abort();
        }
        core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($8 | 0, $5 | 0, 1087620 | 0);
        abort();
       }
       core__slice__index__slice_index_order_fail__h71e247dec3f266ff($4 | 0, $8 | 0, 1087652 | 0);
       abort();
      }
      core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($8 | 0, $5 | 0, 1087652 | 0);
      abort();
     }
     core__slice__index__slice_index_order_fail__h71e247dec3f266ff($4 | 0, $8 | 0, 1087636 | 0);
     abort();
    }
    core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($8 | 0, $5 | 0, 1087636 | 0);
    abort();
   }
   HEAP32[($3 + 16 | 0) >> 2] = 4;
   serde_json__read__error__h78831bedcbd1affe($0 | 0, $1 | 0, $3 + 16 | 0 | 0);
  }
  global$0 = $3 + 32 | 0;
 }
 
 function cardano_serialization_lib__tx_builder__tx_inputs_builder___impl_20core__convert__From__cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__20for_20alloc__collections__btree__set__BTreeSet_cardano_serialization_lib__crypto__Ed25519KeyHash____from__h041f14c26c6e4091($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$3 = 0, $2 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $5 = 0, $3 = 0, $21 = 0, $22 = 0, i64toi32_i32$0 = 0, $6 = 0, $7 = 0, $4 = 0, $61 = 0, $68 = 0, $71 = 0, $93 = 0, $100 = 0, $103 = 0, $123 = 0, $127 = 0, $130 = 0;
  $2 = global$0 - 144 | 0;
  global$0 = $2;
  $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__hf9a33b4634734bb7($0 | 0, $1 + 40 | 0 | 0);
  label$1 : {
   label$2 : {
    $3 = HEAP32[($1 + 32 | 0) >> 2] | 0;
    if ($3) {
     break label$2
    }
    $1 = 0;
    break label$1;
   }
   $1 = HEAP32[($3 + 156 | 0) >> 2] | 0;
  }
  label$3 : {
   if (($1 | 0) == ($3 | 0)) {
    break label$3
   }
   label$4 : while (1) {
    $4 = HEAP32[($1 + 156 | 0) >> 2] | 0;
    label$5 : {
     i64toi32_i32$2 = $1;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     i64toi32_i32$2 = i64toi32_i32$0;
     i64toi32_i32$0 = 0;
     i64toi32_i32$3 = 0;
     if ((i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$0 | 0) | 0) {
      break label$5
     }
     cardano_serialization_lib___impl_20core__convert__From__cardano_serialization_lib__NativeScript__20for_20alloc__collections__btree__set__BTreeSet_cardano_serialization_lib__crypto__Ed25519KeyHash____from__h8ccce5a95eccf6e5($2 + 64 | 0 | 0, $1 + 8 | 0 | 0);
     label$6 : {
      label$7 : {
       $1 = HEAP32[($2 + 68 | 0) >> 2] | 0;
       if (!$1) {
        break label$7
       }
       $5 = HEAP32[($2 + 64 | 0) >> 2] | 0;
       alloc__collections__btree__navigate__full_range__h687ff3c975ae5f45($2 + 32 | 0 | 0, $5 | 0, $1 | 0, $5 | 0, $1 | 0);
       $1 = HEAP32[($2 + 72 | 0) >> 2] | 0;
       break label$6;
      }
      $1 = 0;
      HEAP32[($2 + 48 | 0) >> 2] = 0;
      HEAP32[($2 + 36 | 0) >> 2] = 0;
     }
     HEAP32[(($2 + 32 | 0) + 24 | 0) >> 2] = $1;
     HEAP32[(($2 + 80 | 0) + 24 | 0) >> 2] = $1;
     i64toi32_i32$3 = ($2 + 32 | 0) + 16 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $61 = i64toi32_i32$2;
     i64toi32_i32$2 = ($2 + 80 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $61;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$3 = ($2 + 32 | 0) + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $68 = i64toi32_i32$1;
     i64toi32_i32$1 = ($2 + 80 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $68;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$3 = $2;
     i64toi32_i32$2 = HEAP32[($2 + 32 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
     $71 = i64toi32_i32$2;
     i64toi32_i32$2 = $2;
     HEAP32[($2 + 80 | 0) >> 2] = $71;
     HEAP32[($2 + 84 | 0) >> 2] = i64toi32_i32$1;
     $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__hbd7038216761c388($2 + 24 | 0 | 0, $2 + 80 | 0 | 0);
     label$8 : {
      $1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
      if (!$1) {
       break label$8
      }
      $5 = ($2 + 112 | 0) + 24 | 0;
      $21 = $1 + 24 | 0;
      HEAP32[$5 >> 2] = HEAPU8[$21 >> 0] | 0 | ((HEAPU8[($21 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($21 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($21 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $6 = ($2 + 112 | 0) + 16 | 0;
      i64toi32_i32$3 = $1 + 16 | 0;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$2 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $93 = i64toi32_i32$1;
      i64toi32_i32$1 = $6;
      HEAP32[i64toi32_i32$1 >> 2] = $93;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
      $7 = ($2 + 112 | 0) + 8 | 0;
      i64toi32_i32$3 = $1 + 8 | 0;
      i64toi32_i32$2 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $100 = i64toi32_i32$2;
      i64toi32_i32$2 = $7;
      HEAP32[i64toi32_i32$2 >> 2] = $100;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$3 = $1;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$2 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $103 = i64toi32_i32$1;
      i64toi32_i32$1 = $2;
      HEAP32[($2 + 112 | 0) >> 2] = $103;
      HEAP32[($2 + 116 | 0) >> 2] = i64toi32_i32$2;
      alloc__collections__btree__map__BTreeMap_K_2cV___insert__h5d8c7a7452747b0f($0 | 0, $2 + 112 | 0 | 0) | 0;
      $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__hbd7038216761c388($2 + 16 | 0 | 0, $2 + 80 | 0 | 0);
      $1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
      if (!$1) {
       break label$8
      }
      label$9 : while (1) {
       $22 = $1 + 24 | 0;
       HEAP32[$5 >> 2] = HEAPU8[$22 >> 0] | 0 | ((HEAPU8[($22 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($22 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($22 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$3 = $1 + 16 | 0;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $123 = i64toi32_i32$2;
       i64toi32_i32$2 = $6;
       HEAP32[i64toi32_i32$2 >> 2] = $123;
       HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$3 = $1 + 8 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $127 = i64toi32_i32$1;
       i64toi32_i32$1 = $7;
       HEAP32[i64toi32_i32$1 >> 2] = $127;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$3 = $1;
       i64toi32_i32$2 = HEAPU8[i64toi32_i32$3 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$3 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $130 = i64toi32_i32$2;
       i64toi32_i32$2 = $2;
       HEAP32[($2 + 112 | 0) >> 2] = $130;
       HEAP32[($2 + 116 | 0) >> 2] = i64toi32_i32$1;
       alloc__collections__btree__map__BTreeMap_K_2cV___insert__h5d8c7a7452747b0f($0 | 0, $2 + 112 | 0 | 0) | 0;
       $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__hbd7038216761c388($2 + 8 | 0 | 0, $2 + 80 | 0 | 0);
       $1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
       if ($1) {
        continue label$9
       }
       break label$9;
      };
     }
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h04a6b671c790649f($2 + 64 | 0 | 0);
    }
    $1 = $4;
    if (($1 | 0) != ($3 | 0)) {
     continue label$4
    }
    break label$4;
   };
  }
  global$0 = $2 + 144 | 0;
 }
 
 function hashbrown__map__make_hash__ha89093b04cf4755b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$5 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $8$hi = 0, $7$hi = 0, $7 = 0, $8 = 0, $9$hi = 0, $9 = 0, $10$hi = 0, $10 = 0, $2 = 0, $11$hi = 0, $11 = 0, $12$hi = 0, $12 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $93 = 0, $25 = 0, $30 = 0, $37 = 0, $45 = 0, $48 = 0, $67 = 0, $67$hi = 0, $68 = 0, $68$hi = 0, $70$hi = 0, $75 = 0, $75$hi = 0, $81 = 0, $81$hi = 0, $86 = 0, $86$hi = 0, $90 = 0, $90$hi = 0, $93$hi = 0, $100 = 0, $100$hi = 0, $106 = 0, $106$hi = 0, $108 = 0, $108$hi = 0, $110$hi = 0, $116 = 0, $116$hi = 0, $122 = 0, $122$hi = 0, $125 = 0, $125$hi = 0, $126 = 0, $126$hi = 0, $128$hi = 0, $133 = 0, $133$hi = 0, $140 = 0, $140$hi = 0, $141 = 0, $141$hi = 0, $143$hi = 0, $148 = 0, $148$hi = 0, $155 = 0, $155$hi = 0, $156 = 0, $156$hi = 0, $158$hi = 0, $163 = 0, $163$hi = 0, $166$hi = 0, $168 = 0, $168$hi = 0, $170$hi = 0, $175 = 0, $175$hi = 0, $181$hi = 0, $94 = 0, $184 = 0, $184$hi = 0, $185 = 0, $185$hi = 0, $187 = 0, $187$hi = 0, $188 = 0, $188$hi = 0, $190 = 0, $190$hi = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  $3 = $2 + 64 | 0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = $2 + 48 | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = 1952801890;
  i64toi32_i32$3 = 2037671283;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $25 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $4;
  HEAP32[i64toi32_i32$2 >> 2] = $25;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  $5 = $2 + 40 | 0;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$1 = $7;
  i64toi32_i32$2 = 1685025377;
  i64toi32_i32$3 = 1852075885;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $30 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $5;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  $6 = $2 + 32 | 0;
  i64toi32_i32$0 = $0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$2;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$2 = 1819895653;
  i64toi32_i32$3 = 1852142177;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $37 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $6;
  HEAP32[i64toi32_i32$0 >> 2] = $37;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$0 = $2;
  i64toi32_i32$2 = 0;
  HEAP32[(i64toi32_i32$0 + 56 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 60 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$1 = $8;
  i64toi32_i32$0 = 1936682341;
  i64toi32_i32$3 = 1886610805;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $45 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $2;
  HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = $45;
  HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $48 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[(i64toi32_i32$0 + 72 | 0) >> 2] = $48;
  HEAP32[(i64toi32_i32$0 + 76 | 0) >> 2] = i64toi32_i32$1;
  $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5(i64toi32_i32$0 + 8 | 0 | 0, i64toi32_i32$0 + 72 | 0 | 0, 8 | 0);
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = 0;
  $8 = i64toi32_i32$1;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
  $9 = i64toi32_i32$0;
  $9$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$1;
  $10$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $6;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $11 = i64toi32_i32$0;
  $11$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $5;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$1;
  $7$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $12 = i64toi32_i32$0;
  $12$hi = i64toi32_i32$1;
  global$0 = i64toi32_i32$2 + 80 | 0;
  i64toi32_i32$1 = $10$hi;
  $67 = $10;
  $67$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  $68 = $9;
  $68$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$2 = $8;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $93 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $93 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $70$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $68$hi;
  i64toi32_i32$1 = $68;
  i64toi32_i32$2 = $70$hi;
  i64toi32_i32$3 = $93;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  $8 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $67$hi;
  i64toi32_i32$0 = $67;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
  $9 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $9$hi = i64toi32_i32$1;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($9 | 0, i64toi32_i32$1 | 0, 16 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $75 = i64toi32_i32$0;
  $75$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$4;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $75$hi;
  i64toi32_i32$1 = $75;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$2;
  $81 = $10;
  $81$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$5 = $7;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$0;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$0 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $86 = i64toi32_i32$5;
  $86$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $81$hi;
  i64toi32_i32$2 = $81;
  i64toi32_i32$5 = $86$hi;
  i64toi32_i32$3 = $86;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $12 = i64toi32_i32$1;
  $12$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $90 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $90$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($7 | 0, i64toi32_i32$2 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $93$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$2 = $93$hi;
  i64toi32_i32$0 = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  $7 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $8 = i64toi32_i32$5;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$1 | 0, 17 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $100 = i64toi32_i32$2;
  $100$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$2 = $100$hi;
  i64toi32_i32$3 = $100;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $90$hi;
  i64toi32_i32$1 = $90;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$0;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $106 = i64toi32_i32$1;
  $106$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$1 = $106$hi;
  i64toi32_i32$3 = $106;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $7 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$1;
  $108 = $7;
  $108$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($10 | 0, i64toi32_i32$1 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $110$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$1 = $110$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $10$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($8 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 255;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $116 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $116$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$2 = $10;
  i64toi32_i32$1 = $116$hi;
  i64toi32_i32$3 = $116;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $8 = i64toi32_i32$4;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $108$hi;
  i64toi32_i32$5 = $108;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 17 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $122 = i64toi32_i32$5;
  $122$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$5 = $122$hi;
  i64toi32_i32$3 = $122;
  i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$5;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $125 = i64toi32_i32$0;
  $125$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  $126 = $7;
  $126$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($10 | 0, i64toi32_i32$5 | 0, 16 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $128$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $8$hi;
  i64toi32_i32$5 = $128$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $8 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($9 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $133 = i64toi32_i32$4;
  $133$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$5 = $8;
  i64toi32_i32$4 = $133$hi;
  i64toi32_i32$3 = $133;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $9 = i64toi32_i32$2;
  $9$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $126$hi;
  i64toi32_i32$0 = $126;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$4;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $125$hi;
  i64toi32_i32$1 = $125;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $10 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$0 | 0, 17 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $140 = i64toi32_i32$1;
  $140$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  $141 = $10;
  $141$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($8 | 0, i64toi32_i32$0 | 0, 21 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $143$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $143$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
  $8 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($11 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $148 = i64toi32_i32$2;
  $148$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = $8;
  i64toi32_i32$2 = $148$hi;
  i64toi32_i32$3 = $148;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $9 = i64toi32_i32$5;
  $9$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $141$hi;
  i64toi32_i32$1 = $141;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $10 = i64toi32_i32$2;
  $10$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $140$hi;
  i64toi32_i32$4 = $140;
  i64toi32_i32$1 = $10$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $11 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $11$hi = i64toi32_i32$1;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($11 | 0, i64toi32_i32$1 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $155 = i64toi32_i32$4;
  $155$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $11$hi;
  $156 = $11;
  $156$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($8 | 0, i64toi32_i32$1 | 0, 16 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $158$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$1 = $158$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $8 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $163 = i64toi32_i32$5;
  $163$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$1 = $8;
  i64toi32_i32$5 = $163$hi;
  i64toi32_i32$3 = $163;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $156$hi;
  i64toi32_i32$4 = $156;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $166$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $155$hi;
  i64toi32_i32$2 = $155;
  i64toi32_i32$4 = $166$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $9 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $9$hi = i64toi32_i32$4;
  $168 = $9;
  $168$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($8 | 0, i64toi32_i32$4 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $170$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$4 = $170$hi;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($10 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $175 = i64toi32_i32$0;
  $175$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = $7;
  i64toi32_i32$0 = $175$hi;
  i64toi32_i32$3 = $175;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $8 = i64toi32_i32$1;
  $8$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $168$hi;
  i64toi32_i32$2 = $168;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$1 | 0, 16 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $181$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$1 = $181$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $94 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($94 | 0, i64toi32_i32$2 | 0, 21 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $184 = i64toi32_i32$5;
  $184$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$5 = $184$hi;
  i64toi32_i32$3 = $184;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $185 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $185$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($9 | 0, i64toi32_i32$5 | 0, 17 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $187 = i64toi32_i32$1;
  $187$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $185$hi;
  i64toi32_i32$2 = $185;
  i64toi32_i32$1 = $187$hi;
  i64toi32_i32$3 = $187;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $188 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $188$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64(i64toi32_i32$0 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $190 = i64toi32_i32$2;
  $190$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $188$hi;
  i64toi32_i32$5 = $188;
  i64toi32_i32$2 = $190$hi;
  i64toi32_i32$3 = $190;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$5 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$2;
  return i64toi32_i32$5 | 0;
 }
 
 function hashbrown__map__make_hash__hcc2c1bbb7174b1af($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $8$hi = 0, $7$hi = 0, $7 = 0, $8 = 0, $9$hi = 0, $9 = 0, $10$hi = 0, $10 = 0, $11$hi = 0, $2 = 0, $11 = 0, $12$hi = 0, $12 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $92 = 0, $25 = 0, $30 = 0, $37 = 0, $45 = 0, $67 = 0, $67$hi = 0, $68 = 0, $68$hi = 0, $70$hi = 0, $75 = 0, $75$hi = 0, $81 = 0, $81$hi = 0, $86 = 0, $86$hi = 0, $90 = 0, $90$hi = 0, $93$hi = 0, $100 = 0, $100$hi = 0, $106 = 0, $106$hi = 0, $108 = 0, $108$hi = 0, $110$hi = 0, $116 = 0, $116$hi = 0, $122 = 0, $122$hi = 0, $125 = 0, $125$hi = 0, $126 = 0, $126$hi = 0, $128$hi = 0, $133 = 0, $133$hi = 0, $140 = 0, $140$hi = 0, $141 = 0, $141$hi = 0, $143$hi = 0, $148 = 0, $148$hi = 0, $155 = 0, $155$hi = 0, $156 = 0, $156$hi = 0, $158$hi = 0, $163 = 0, $163$hi = 0, $166$hi = 0, $168 = 0, $168$hi = 0, $170$hi = 0, $175 = 0, $175$hi = 0, $181$hi = 0, $93 = 0, $184 = 0, $184$hi = 0, $185 = 0, $185$hi = 0, $187 = 0, $187$hi = 0, $188 = 0, $188$hi = 0, $190 = 0, $190$hi = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  $3 = $2 + 64 | 0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = $2 + 48 | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = 1952801890;
  i64toi32_i32$3 = 2037671283;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $25 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $4;
  HEAP32[i64toi32_i32$2 >> 2] = $25;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  $5 = $2 + 40 | 0;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$1 = $7;
  i64toi32_i32$2 = 1685025377;
  i64toi32_i32$3 = 1852075885;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $30 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $5;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  $6 = $2 + 32 | 0;
  i64toi32_i32$0 = $0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$2;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$2 = 1819895653;
  i64toi32_i32$3 = 1852142177;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $37 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $6;
  HEAP32[i64toi32_i32$0 >> 2] = $37;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$0 = $2;
  i64toi32_i32$2 = 0;
  HEAP32[(i64toi32_i32$0 + 56 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 60 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$1 = $8;
  i64toi32_i32$0 = 1936682341;
  i64toi32_i32$3 = 1886610805;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $45 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $2;
  HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = $45;
  HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 76 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
  $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_2(i64toi32_i32$1 + 8 | 0 | 0, i64toi32_i32$1 + 76 | 0 | 0, 4 | 0);
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = 0;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $6;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $12 = i64toi32_i32$1;
  $12$hi = i64toi32_i32$0;
  global$0 = i64toi32_i32$2 + 80 | 0;
  i64toi32_i32$0 = $10$hi;
  $67 = $10;
  $67$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  $68 = $9;
  $68$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$2 = $8;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $92 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $92 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $70$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $68$hi;
  i64toi32_i32$0 = $68;
  i64toi32_i32$2 = $70$hi;
  i64toi32_i32$3 = $92;
  i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
  $8 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $67$hi;
  i64toi32_i32$1 = $67;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $9 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($9 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $75 = i64toi32_i32$1;
  $75$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$4;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $75$hi;
  i64toi32_i32$0 = $75;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$2;
  $81 = $10;
  $81$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$5 = $7;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $86 = i64toi32_i32$5;
  $86$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $81$hi;
  i64toi32_i32$2 = $81;
  i64toi32_i32$5 = $86$hi;
  i64toi32_i32$3 = $86;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $12 = i64toi32_i32$0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $90 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $90$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($7 | 0, i64toi32_i32$2 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $93$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$2 = $93$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $8 = i64toi32_i32$5;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 17 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $100 = i64toi32_i32$2;
  $100$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$2 = $100$hi;
  i64toi32_i32$3 = $100;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $90$hi;
  i64toi32_i32$0 = $90;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $106 = i64toi32_i32$0;
  $106$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = $106$hi;
  i64toi32_i32$3 = $106;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $7 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$0;
  $108 = $7;
  $108$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($10 | 0, i64toi32_i32$0 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $110$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$0 = $110$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $10$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($8 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 255;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $116 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $116$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$2 = $10;
  i64toi32_i32$0 = $116$hi;
  i64toi32_i32$3 = $116;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $8 = i64toi32_i32$4;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $108$hi;
  i64toi32_i32$5 = $108;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$0;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 17 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $122 = i64toi32_i32$5;
  $122$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$5 = $122$hi;
  i64toi32_i32$3 = $122;
  i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
  $7 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$5;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $125 = i64toi32_i32$1;
  $125$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  $126 = $7;
  $126$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$5 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $128$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $8$hi;
  i64toi32_i32$5 = $128$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $8 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($9 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $133 = i64toi32_i32$4;
  $133$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$5 = $8;
  i64toi32_i32$4 = $133$hi;
  i64toi32_i32$3 = $133;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $9 = i64toi32_i32$2;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $126$hi;
  i64toi32_i32$1 = $126;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$4;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $125$hi;
  i64toi32_i32$0 = $125;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($10 | 0, i64toi32_i32$1 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $140 = i64toi32_i32$0;
  $140$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $10$hi;
  $141 = $10;
  $141$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($8 | 0, i64toi32_i32$1 | 0, 21 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $143$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$1 = $143$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $8 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $148 = i64toi32_i32$2;
  $148$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$1 = $8;
  i64toi32_i32$2 = $148$hi;
  i64toi32_i32$3 = $148;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $9 = i64toi32_i32$5;
  $9$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $141$hi;
  i64toi32_i32$0 = $141;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $10 = i64toi32_i32$2;
  $10$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $140$hi;
  i64toi32_i32$4 = $140;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $11 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $155 = i64toi32_i32$4;
  $155$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  $156 = $11;
  $156$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($8 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $158$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $158$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $8 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $163 = i64toi32_i32$5;
  $163$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$0 = $8;
  i64toi32_i32$5 = $163$hi;
  i64toi32_i32$3 = $163;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$1;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $156$hi;
  i64toi32_i32$4 = $156;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $166$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $155$hi;
  i64toi32_i32$2 = $155;
  i64toi32_i32$4 = $166$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $9 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $9$hi = i64toi32_i32$4;
  $168 = $9;
  $168$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($8 | 0, i64toi32_i32$4 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $170$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$4 = $170$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $175 = i64toi32_i32$1;
  $175$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = $7;
  i64toi32_i32$1 = $175$hi;
  i64toi32_i32$3 = $175;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $168$hi;
  i64toi32_i32$2 = $168;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $10 = i64toi32_i32$1;
  $10$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $181$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$0 = $181$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $93 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($93 | 0, i64toi32_i32$2 | 0, 21 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $184 = i64toi32_i32$5;
  $184$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$5 = $184$hi;
  i64toi32_i32$3 = $184;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $185 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $185$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($9 | 0, i64toi32_i32$5 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $187 = i64toi32_i32$0;
  $187$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $185$hi;
  i64toi32_i32$2 = $185;
  i64toi32_i32$0 = $187$hi;
  i64toi32_i32$3 = $187;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $188 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $188$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $190 = i64toi32_i32$2;
  $190$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $188$hi;
  i64toi32_i32$5 = $188;
  i64toi32_i32$2 = $190$hi;
  i64toi32_i32$3 = $190;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$5 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$2;
  return i64toi32_i32$5 | 0;
 }
 
 function baseaddress_new($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $6 = 0, $8 = 0, $31 = 0, $32 = 0, $33 = 0, $34 = 0, $35 = 0, $36 = 0, $37 = 0, $13 = 0, $13$hi = 0, $14 = 0, $14$hi = 0, $4 = 0, $5 = 0, $9 = 0, $11 = 0, $12 = 0, $38 = 0, $39 = 0, $40 = 0, $41 = 0, $42 = 0, $7 = 0, $51 = 0, $10 = 0, $80 = 0, $98 = 0, $104 = 0, $113 = 0, $127 = 0, $131 = 0, $139 = 0, $143 = 0, $147 = 0, $158 = 0;
  $3 = global$0 - 176 | 0;
  global$0 = $3;
  label$1 : {
   if (!$1) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h7d8a0640f2deb41e($3 + 8 | 0 | 0, $1 | 0);
   if (!$2) {
    break label$1
   }
   $4 = HEAP32[($3 + 12 | 0) >> 2] | 0;
   $1 = HEAP32[($3 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h7d8a0640f2deb41e($3 | 0, $2 | 0);
   $5 = HEAP32[($3 + 4 | 0) >> 2] | 0;
   $2 = HEAP32[$3 >> 2] | 0;
   $31 = $1 + 25 | 0;
   $6 = HEAPU8[$31 >> 0] | 0 | ((HEAPU8[($31 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($31 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($31 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$2 = $1 + 17 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $13 = i64toi32_i32$0;
   $13$hi = i64toi32_i32$1;
   $7 = HEAPU8[$1 >> 0] | 0;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $14 = i64toi32_i32$1;
   $14$hi = i64toi32_i32$0;
   $8 = ($3 + 144 | 0) + 8 | 0;
   i64toi32_i32$2 = i64toi32_i32$2 + 9 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $51 = i64toi32_i32$0;
   i64toi32_i32$0 = $8;
   HEAP32[i64toi32_i32$0 >> 2] = $51;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   $1 = ($3 + 144 | 0) + 16 | 0;
   i64toi32_i32$1 = $13$hi;
   i64toi32_i32$0 = $1;
   HEAP32[i64toi32_i32$0 >> 2] = $13;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   $9 = ($3 + 144 | 0) + 24 | 0;
   HEAP32[$9 >> 2] = $6;
   i64toi32_i32$1 = $14$hi;
   i64toi32_i32$0 = $3;
   HEAP32[(i64toi32_i32$0 + 144 | 0) >> 2] = $14;
   HEAP32[(i64toi32_i32$0 + 148 | 0) >> 2] = i64toi32_i32$1;
   $32 = $2 + 25 | 0;
   $6 = HEAPU8[$32 >> 0] | 0 | ((HEAPU8[($32 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($32 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($32 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$2 = $2 + 17 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $13 = i64toi32_i32$1;
   $13$hi = i64toi32_i32$0;
   $10 = HEAPU8[$2 >> 0] | 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $14 = i64toi32_i32$0;
   $14$hi = i64toi32_i32$1;
   $11 = ($3 + 16 | 0) + 8 | 0;
   i64toi32_i32$2 = i64toi32_i32$2 + 9 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $80 = i64toi32_i32$1;
   i64toi32_i32$1 = $11;
   HEAP32[i64toi32_i32$1 >> 2] = $80;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   $2 = ($3 + 16 | 0) + 16 | 0;
   i64toi32_i32$0 = $13$hi;
   i64toi32_i32$1 = $2;
   HEAP32[i64toi32_i32$1 >> 2] = $13;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   $12 = ($3 + 16 | 0) + 24 | 0;
   HEAP32[$12 >> 2] = $6;
   i64toi32_i32$0 = $14$hi;
   i64toi32_i32$1 = $3;
   HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $14;
   HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
   $6 = (i64toi32_i32$1 + 48 | 0) + 8 | 0;
   i64toi32_i32$2 = $8;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $98 = i64toi32_i32$0;
   i64toi32_i32$0 = $6;
   HEAP32[i64toi32_i32$0 >> 2] = $98;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   $8 = ($3 + 48 | 0) + 16 | 0;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $104 = i64toi32_i32$1;
   i64toi32_i32$1 = $8;
   HEAP32[i64toi32_i32$1 >> 2] = $104;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   $1 = ($3 + 48 | 0) + 24 | 0;
   HEAP32[$1 >> 2] = HEAP32[$9 >> 2] | 0;
   i64toi32_i32$2 = $3;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 144 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 148 | 0) >> 2] | 0;
   $113 = i64toi32_i32$0;
   i64toi32_i32$0 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = $113;
   HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = i64toi32_i32$1;
   core__cell__Cell_T___replace__h74ad9f426af36be8($5 | 0, (HEAP32[$5 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($4 | 0, (HEAP32[$4 >> 2] | 0) + -1 | 0 | 0) | 0;
   i64toi32_i32$2 = $6;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $127 = i64toi32_i32$1;
   i64toi32_i32$1 = $3 + 90 | 0;
   $38 = $127;
   HEAP16[i64toi32_i32$1 >> 1] = $38;
   HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $38 >>> 16 | 0;
   HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = i64toi32_i32$0;
   HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
   i64toi32_i32$2 = $8;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $131 = i64toi32_i32$0;
   i64toi32_i32$0 = $3 + 98 | 0;
   $39 = $131;
   HEAP16[i64toi32_i32$0 >> 1] = $39;
   HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $39 >>> 16 | 0;
   HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$1;
   HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
   $40 = $3 + 106 | 0;
   $41 = HEAP32[$1 >> 2] | 0;
   HEAP16[$40 >> 1] = $41;
   HEAP16[($40 + 2 | 0) >> 1] = $41 >>> 16 | 0;
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
   $139 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2 + 111 | 0;
   $33 = $139;
   HEAP8[i64toi32_i32$1 >> 0] = $33;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $33 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $33 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $33 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $11;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $143 = i64toi32_i32$0;
   i64toi32_i32$0 = $3 + 119 | 0;
   $34 = $143;
   HEAP8[i64toi32_i32$0 >> 0] = $34;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $34 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $34 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $34 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $147 = i64toi32_i32$1;
   i64toi32_i32$1 = $3 + 127 | 0;
   $35 = $147;
   HEAP8[i64toi32_i32$1 >> 0] = $35;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $35 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $35 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $35 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   $36 = $3 + 135 | 0;
   $37 = HEAP32[$12 >> 2] | 0;
   HEAP8[$36 >> 0] = $37;
   HEAP8[($36 + 1 | 0) >> 0] = $37 >>> 8 | 0;
   HEAP8[($36 + 2 | 0) >> 0] = $37 >>> 16 | 0;
   HEAP8[($36 + 3 | 0) >> 0] = $37 >>> 24 | 0;
   HEAP8[($3 + 81 | 0) >> 0] = $7;
   HEAP8[($3 + 80 | 0) >> 0] = $0;
   i64toi32_i32$2 = $3;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] | 0;
   $158 = i64toi32_i32$0;
   i64toi32_i32$0 = i64toi32_i32$2;
   $42 = $158;
   HEAP16[(i64toi32_i32$2 + 82 | 0) >> 1] = $42;
   HEAP16[(i64toi32_i32$2 + 84 | 0) >> 1] = $42 >>> 16 | 0;
   HEAP16[(i64toi32_i32$2 + 86 | 0) >> 1] = i64toi32_i32$1;
   HEAP16[(i64toi32_i32$2 + 88 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$2 + 110 | 0) >> 0] = $10;
   $1 = $cardano_serialization_lib__address__BaseAddress_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h9cfaf9e675023555(i64toi32_i32$2 + 80 | 0 | 0) | 0;
   global$0 = i64toi32_i32$2 + 176 | 0;
   return $1 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function cryptoxide__ed25519__signature__hfac93186ff640827($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $4 = 0, i64toi32_i32$5 = 0, $33 = 0, $34 = 0, $35 = 0, $36 = 0, $8 = 0, $38 = 0, $39 = 0, $40 = 0, $41 = 0, $9$hi = 0, $5 = 0, $6 = 0, $7 = 0, $10$hi = 0, $37 = 0, $43 = 0, $49 = 0, $52 = 0, $74 = 0, $9 = 0, $79$hi = 0, $85 = 0, $87 = 0, $87$hi = 0, $90 = 0, $91$hi = 0, $140 = 0, $143 = 0, $148 = 0, $151 = 0;
  $4 = global$0 - 784 | 0;
  global$0 = $4;
  cryptoxide__ed25519__extended_secret__hc92aa93a99de055a($4 + 8 | 0 | 0, $3 | 0);
  cryptoxide__ed25519__signature_nonce__h963937328d628fd2($4 + 72 | 0 | 0, $4 + 8 | 0 | 0, $1 | 0, $2 | 0);
  cryptoxide__curve25519__ge__Ge__scalarmult_base__hfb711866362b33a6($4 + 112 | 0 | 0, $4 + 72 | 0 | 0);
  $0 = memset($0 | 0, 0 | 0, 64 | 0) | 0;
  cryptoxide__curve25519__ge__Ge__to_bytes__hce32fa3f32cec513($0 | 0, $4 + 112 | 0 | 0);
  $5 = $0 + 56 | 0;
  i64toi32_i32$2 = $3 + 56 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $37 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  $33 = $37;
  HEAP8[i64toi32_i32$0 >> 0] = $33;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $33 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $33 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $33 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $6 = $0 + 48 | 0;
  i64toi32_i32$2 = $3 + 48 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $43 = i64toi32_i32$1;
  i64toi32_i32$1 = $6;
  $34 = $43;
  HEAP8[i64toi32_i32$1 >> 0] = $34;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $34 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $34 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $34 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $7 = $0 + 40 | 0;
  i64toi32_i32$2 = $3 + 40 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $49 = i64toi32_i32$0;
  i64toi32_i32$0 = $7;
  $35 = $49;
  HEAP8[i64toi32_i32$0 >> 0] = $35;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $35 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $35 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $35 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 32 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 33 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 34 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 35 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 36 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 37 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 38 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 39 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $52 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  $36 = $52;
  HEAP8[(i64toi32_i32$1 + 32 | 0) >> 0] = $36;
  HEAP8[(i64toi32_i32$1 + 33 | 0) >> 0] = $36 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 34 | 0) >> 0] = $36 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 35 | 0) >> 0] = $36 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 36 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 37 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 38 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 39 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $8 = memset(($4 + 488 | 0) + 80 | 0 | 0, 0 | 0, 132 | 0) | 0;
  $3 = memcpy(($4 + 488 | 0) + 16 | 0 | 0, 1137368 | 0, 64 | 0) | 0;
  i64toi32_i32$1 = $4;
  i64toi32_i32$0 = 0;
  HEAP32[(i64toi32_i32$1 + 496 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 500 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  HEAP32[(i64toi32_i32$1 + 488 | 0) >> 2] = 64;
  HEAP32[(i64toi32_i32$1 + 492 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 272 | 0) >> 2] = $3;
  cryptoxide__cryptoutil__FixedBuffer_____input__h45eb77880e071f02($8 | 0, $0 | 0, 64 | 0, i64toi32_i32$1 + 272 | 0 | 0);
  memcpy(i64toi32_i32$1 + 272 | 0 | 0, i64toi32_i32$1 + 488 | 0 | 0, 216 | 0) | 0;
  $74 = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 272 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$1 + 276 | 0) >> 2] | 0;
  $9 = i64toi32_i32$0;
  $9$hi = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  $79$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = $79$hi;
  i64toi32_i32$3 = $2;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $10$hi = i64toi32_i32$5;
  i64toi32_i32$2 = $74;
  HEAP32[(i64toi32_i32$2 + 272 | 0) >> 2] = i64toi32_i32$4;
  HEAP32[(i64toi32_i32$2 + 276 | 0) >> 2] = i64toi32_i32$5;
  $8 = ($4 + 272 | 0) + 8 | 0;
  $85 = $8;
  i64toi32_i32$1 = $8;
  i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $87 = i64toi32_i32$5;
  $87$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$3 = $9;
  $90 = i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
  i64toi32_i32$1 = 0;
  $91$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $87$hi;
  i64toi32_i32$3 = $87;
  i64toi32_i32$2 = $91$hi;
  i64toi32_i32$5 = $90;
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  i64toi32_i32$3 = $85;
  HEAP32[i64toi32_i32$3 >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$4;
  HEAP32[($4 + 488 | 0) >> 2] = ($4 + 272 | 0) + 16 | 0;
  cryptoxide__cryptoutil__FixedBuffer_____input__h45eb77880e071f02(($4 + 272 | 0) + 80 | 0 | 0, $1 | 0, $2 | 0, $4 + 488 | 0 | 0);
  memcpy($4 + 488 | 0 | 0, $4 + 272 | 0 | 0, 216 | 0) | 0;
  memset($4 + 272 | 0 | 0, 0 | 0, 64 | 0) | 0;
  cryptoxide__hashing__sha2__Engine512__finish__h18b5152b4b76c624($4 + 488 | 0 | 0);
  cryptoxide__cryptoutil__write_u64v_be__h6888df4c897d2bb4($4 + 272 | 0 | 0, 64 | 0, $3 | 0, 8 | 0);
  cryptoxide__curve25519__scalar__scalar64__Scalar__reduce_from_wide_bytes__h35529550345bd5f0($4 + 704 | 0 | 0, $4 + 272 | 0 | 0);
  cryptoxide__curve25519__scalar__scalar64__Scalar__from_bytes__hcfeedd1974a72bb6($4 + 488 | 0 | 0, $4 + 8 | 0 | 0);
  cryptoxide__curve25519__scalar__scalar64__muladd__h77e24dce4fa4fc8b($4 + 744 | 0 | 0, $4 + 704 | 0 | 0, $4 + 488 | 0 | 0, $4 + 72 | 0 | 0);
  cryptoxide__curve25519__scalar__scalar64__Scalar__to_bytes__h1c79e40f602967bf($4 + 488 | 0 | 0, $4 + 744 | 0 | 0);
  i64toi32_i32$1 = $4 + 512 | 0;
  i64toi32_i32$4 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$3 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $140 = i64toi32_i32$4;
  i64toi32_i32$4 = $5;
  $38 = $140;
  HEAP8[i64toi32_i32$4 >> 0] = $38;
  HEAP8[(i64toi32_i32$4 + 1 | 0) >> 0] = $38 >>> 8 | 0;
  HEAP8[(i64toi32_i32$4 + 2 | 0) >> 0] = $38 >>> 16 | 0;
  HEAP8[(i64toi32_i32$4 + 3 | 0) >> 0] = $38 >>> 24 | 0;
  HEAP8[(i64toi32_i32$4 + 4 | 0) >> 0] = i64toi32_i32$3;
  HEAP8[(i64toi32_i32$4 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
  HEAP8[(i64toi32_i32$4 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
  HEAP8[(i64toi32_i32$4 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$3 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$4 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $143 = i64toi32_i32$3;
  i64toi32_i32$3 = $6;
  $39 = $143;
  HEAP8[i64toi32_i32$3 >> 0] = $39;
  HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $39 >>> 8 | 0;
  HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $39 >>> 16 | 0;
  HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $39 >>> 24 | 0;
  HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$4;
  HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$4 >>> 8 | 0;
  HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$4 >>> 16 | 0;
  HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$4 >>> 24 | 0;
  i64toi32_i32$1 = ($4 + 488 | 0) + 8 | 0;
  i64toi32_i32$4 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$3 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $148 = i64toi32_i32$4;
  i64toi32_i32$4 = $7;
  $40 = $148;
  HEAP8[i64toi32_i32$4 >> 0] = $40;
  HEAP8[(i64toi32_i32$4 + 1 | 0) >> 0] = $40 >>> 8 | 0;
  HEAP8[(i64toi32_i32$4 + 2 | 0) >> 0] = $40 >>> 16 | 0;
  HEAP8[(i64toi32_i32$4 + 3 | 0) >> 0] = $40 >>> 24 | 0;
  HEAP8[(i64toi32_i32$4 + 4 | 0) >> 0] = i64toi32_i32$3;
  HEAP8[(i64toi32_i32$4 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
  HEAP8[(i64toi32_i32$4 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
  HEAP8[(i64toi32_i32$4 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
  i64toi32_i32$1 = $4;
  i64toi32_i32$3 = HEAPU8[(i64toi32_i32$1 + 488 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 489 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 490 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 491 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$4 = HEAPU8[(i64toi32_i32$1 + 492 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 493 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 494 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 495 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $151 = i64toi32_i32$3;
  i64toi32_i32$3 = $0;
  $41 = $151;
  HEAP8[(i64toi32_i32$3 + 32 | 0) >> 0] = $41;
  HEAP8[(i64toi32_i32$3 + 33 | 0) >> 0] = $41 >>> 8 | 0;
  HEAP8[(i64toi32_i32$3 + 34 | 0) >> 0] = $41 >>> 16 | 0;
  HEAP8[(i64toi32_i32$3 + 35 | 0) >> 0] = $41 >>> 24 | 0;
  HEAP8[(i64toi32_i32$3 + 36 | 0) >> 0] = i64toi32_i32$4;
  HEAP8[(i64toi32_i32$3 + 37 | 0) >> 0] = i64toi32_i32$4 >>> 8 | 0;
  HEAP8[(i64toi32_i32$3 + 38 | 0) >> 0] = i64toi32_i32$4 >>> 16 | 0;
  HEAP8[(i64toi32_i32$3 + 39 | 0) >> 0] = i64toi32_i32$4 >>> 24 | 0;
  global$0 = i64toi32_i32$1 + 784 | 0;
 }
 
 function cryptoxide__curve25519__scalar___impl_20cryptoxide__curve25519__scalar__scalar64__Scalar___slide__h02a6b1f378f41f84($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $2 = 0, $5 = 0, $8 = 0, $3 = 0, $4 = 0, $6 = 0, $13 = 0, $13$hi = 0, $9 = 0, $46 = 0, $47 = 0, $49 = 0, $50 = 0, $51 = 0, $52 = 0, $54 = 0, $55 = 0, $10 = 0, $11 = 0, $12 = 0, $18 = 0, $22$hi = 0, $24 = 0, $24$hi = 0, $25 = 0, $26 = 0, $14 = 0, $14$hi = 0, $30 = 0, $30$hi = 0, $32$hi = 0, $33 = 0, $34 = 0, $38 = 0, $38$hi = 0, $40$hi = 0, $41 = 0, $42 = 0, $45 = 0, $45$hi = 0, $47$hi = 0, $48 = 0, $53 = 0, $59$hi = 0, $62$hi = 0, $7 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  $18 = $2;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $13 = i64toi32_i32$0;
  $13$hi = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $46 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $46 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $22$hi = i64toi32_i32$0;
  i64toi32_i32$1 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  $24$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $22$hi;
  i64toi32_i32$1 = $46;
  i64toi32_i32$0 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
  $25 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $18;
  HEAP32[i64toi32_i32$1 >> 2] = $25;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $26 = $2;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  $14$hi = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 48;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $47 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $47 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $30 = $47;
  $30$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $13$hi;
  i64toi32_i32$1 = $13;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 8;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $49 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $49 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
  }
  $32$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $30$hi;
  i64toi32_i32$0 = $30;
  i64toi32_i32$1 = $32$hi;
  i64toi32_i32$3 = $49;
  i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
  $33 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $26;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $33;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
  $34 = $2;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $13 = i64toi32_i32$1;
  $13$hi = i64toi32_i32$0;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 40;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $50 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $50 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $38 = $50;
  $38$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $14$hi;
  i64toi32_i32$0 = $14;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 16;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $51 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   $51 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
  }
  $40$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $38$hi;
  i64toi32_i32$1 = $38;
  i64toi32_i32$0 = $40$hi;
  i64toi32_i32$3 = $51;
  i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
  $41 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $34;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $41;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  $42 = $2;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $52 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $52 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $45 = $52;
  $45$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $13$hi;
  i64toi32_i32$1 = $13;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 24;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $54 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $54 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
  }
  $47$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $45$hi;
  i64toi32_i32$0 = $45;
  i64toi32_i32$1 = $47$hi;
  i64toi32_i32$3 = $54;
  i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
  $48 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $42;
  HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = $48;
  HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = i64toi32_i32$1;
  $1 = 0;
  $3 = memset($0 | 0, 0 | 0, 256 | 0) | 0;
  label$1 : while (1) {
   $53 = $3 + $1 | 0;
   i64toi32_i32$2 = $2 + (($1 >>> 3 | 0) & 536870904 | 0) | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $59$hi = i64toi32_i32$0;
   i64toi32_i32$0 = 0;
   $62$hi = i64toi32_i32$0;
   i64toi32_i32$0 = $59$hi;
   i64toi32_i32$2 = i64toi32_i32$1;
   i64toi32_i32$1 = $62$hi;
   i64toi32_i32$3 = $1 & 63 | 0;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$1 = 0;
    $55 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   } else {
    i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
    $55 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
   }
   HEAP8[$53 >> 0] = $55 & 1 | 0;
   $1 = $1 + 1 | 0;
   if (($1 | 0) != (256 | 0)) {
    continue label$1
   }
   break label$1;
  };
  $4 = 256;
  $5 = 0;
  label$2 : {
   label$3 : while (1) {
    label$4 : {
     if ($5 >>> 0 > 254 >>> 0) {
      break label$4
     }
     $6 = $3 + $5 | 0;
     if (!((HEAPU8[$6 >> 0] | 0) & 255 | 0)) {
      break label$4
     }
     $7 = $4 >>> 0 < 7 >>> 0 ? $4 : 7;
     $8 = 1;
     $9 = $5;
     label$5 : while (1) {
      if (($8 | 0) == ($4 | 0)) {
       break label$2
      }
      label$6 : {
       $10 = $8 + $5 | 0;
       $0 = $3 + $10 | 0;
       $1 = HEAPU8[$0 >> 0] | 0;
       if (!$1) {
        break label$6
       }
       label$7 : {
        $11 = HEAPU8[$6 >> 0] | 0;
        $1 = $1 << ($8 & 7 | 0) | 0;
        $12 = (($11 + $1 | 0) << 24 | 0) >> 24 | 0;
        if (($12 | 0) > (15 | 0)) {
         break label$7
        }
        HEAP8[$0 >> 0] = 0;
        HEAP8[$6 >> 0] = $12;
        break label$6;
       }
       $1 = (($11 - $1 | 0) << 24 | 0) >> 24 | 0;
       if (($1 | 0) < (-15 | 0)) {
        break label$4
       }
       HEAP8[$6 >> 0] = $1;
       if ($10 >>> 0 > 255 >>> 0) {
        break label$6
       }
       $1 = $9;
       label$8 : while (1) {
        $0 = $3 + $1 | 0;
        HEAP8[($0 + 1 | 0) >> 0] = 0;
        $1 = $1 + 1 | 0;
        if ($1 >>> 0 > 254 >>> 0) {
         break label$6
        }
        if (HEAPU8[($0 + 2 | 0) >> 0] | 0) {
         continue label$8
        }
        break label$8;
       };
       HEAP8[(($3 + $1 | 0) + 1 | 0) >> 0] = 1;
      }
      $9 = $9 + 1 | 0;
      $8 = $8 + 1 | 0;
      if (($8 | 0) != ($7 | 0)) {
       continue label$5
      }
      break label$5;
     };
    }
    $4 = $4 + -1 | 0;
    $5 = $5 + 1 | 0;
    if (($5 | 0) != (256 | 0)) {
     continue label$3
    }
    break label$3;
   };
   global$0 = $2 + 32 | 0;
   return;
  }
  core__panicking__panic_bounds_check__h808b524af17640b1(256 | 0, 256 | 0, 1137348 | 0);
  abort();
 }
 
 function cardano_serialization_lib__metadata__decode_arbitrary_bytes_from_metadatum__h90421dc360c70547($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $14 = 0, $30 = 0, $31 = 0, $4 = 0, $72 = 0, $140 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 20 | 0) >> 2] = 0;
  HEAP32[($2 + 24 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 16 | 0) >> 2] = HEAP32[(0 + 1059260 | 0) >> 2] | 0;
  cardano_serialization_lib__metadata__TransactionMetadatum__as_list__he0dbba76ab1128da($2 + 96 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 100 | 0) >> 2] | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ((HEAP32[($2 + 96 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      i64toi32_i32$2 = ($2 + 96 | 0) + 8 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      HEAP32[($2 + 40 | 0) >> 2] = $1;
      HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[($2 + 32 | 0) >> 2] = $1;
      $30 = $2;
      $31 = $1;
      i64toi32_i32$2 = i64toi32_i32$0;
      i64toi32_i32$0 = 0;
      i64toi32_i32$3 = 32;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$0 = 0;
       $14 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
      } else {
       i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
       $14 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
      }
      $3 = $14;
      HEAP32[($30 + 44 | 0) >> 2] = $31 + Math_imul($3, 48) | 0;
      if (!$3) {
       break label$2
      }
      $4 = $2 + 96 | 0 | 4 | 0;
      label$5 : while (1) {
       HEAP32[($2 + 40 | 0) >> 2] = $1 + 48 | 0;
       $3 = HEAP32[$1 >> 2] | 0;
       if (($3 | 0) == (5 | 0)) {
        break label$2
       }
       memcpy($2 + 52 | 0 | 0, $1 + 4 | 0 | 0, 44 | 0) | 0;
       HEAP32[($2 + 96 | 0) >> 2] = $3;
       memcpy($4 | 0, $2 + 52 | 0 | 0, 44 | 0) | 0;
       cardano_serialization_lib__metadata__TransactionMetadatum__as_bytes__h9a588a46ad56b3fa($2 + 160 | 0 | 0, $2 + 96 | 0 | 0);
       $1 = HEAP32[($2 + 164 | 0) >> 2] | 0;
       label$6 : {
        if ((HEAP32[($2 + 160 | 0) >> 2] | 0 | 0) == (1 | 0)) {
         break label$6
        }
        i64toi32_i32$1 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 168 | 0) >> 2] | 0;
        i64toi32_i32$2 = HEAP32[($2 + 172 | 0) >> 2] | 0;
        $72 = i64toi32_i32$0;
        i64toi32_i32$0 = $2;
        HEAP32[($2 + 148 | 0) >> 2] = $72;
        HEAP32[($2 + 152 | 0) >> 2] = i64toi32_i32$2;
        HEAP32[($2 + 144 | 0) >> 2] = $1;
        $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $2 + 144 | 0 | 0);
        $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
        $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
        alloc__vec__Vec_T_2cA___reserve__h9cf757d86af8f187($2 + 16 | 0 | 0, $1 | 0);
        memcpy((HEAP32[($2 + 16 | 0) >> 2] | 0) + (HEAP32[($2 + 24 | 0) >> 2] | 0) | 0 | 0, $3 | 0, $1 | 0) | 0;
        HEAP32[($2 + 152 | 0) >> 2] = 0;
        HEAP32[($2 + 24 | 0) >> 2] = $1 + (HEAP32[($2 + 24 | 0) >> 2] | 0) | 0;
        $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 144 | 0 | 0);
        $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 144 | 0 | 0);
        core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatum___headd2d1b596252cc($2 + 96 | 0 | 0);
        $1 = HEAP32[($2 + 40 | 0) >> 2] | 0;
        if (($1 | 0) != (HEAP32[($2 + 44 | 0) >> 2] | 0 | 0)) {
         continue label$5
        }
        break label$2;
       }
       break label$5;
      };
      $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($1 | 0) | 0;
      HEAP32[$0 >> 2] = 1;
      HEAP32[($0 + 4 | 0) >> 2] = $1;
      core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatum___headd2d1b596252cc($2 + 96 | 0 | 0);
      $alloc__vec__into_iter__IntoIter_T_2cA__20as_20core__ops__drop__Drop___drop__h8ed9ca310048d65b($2 + 32 | 0 | 0);
      break label$3;
     }
     $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($1 | 0) | 0;
     HEAP32[$0 >> 2] = 1;
     HEAP32[($0 + 4 | 0) >> 2] = $1;
    }
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 16 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 16 | 0 | 0);
    break label$1;
   }
   $alloc__vec__into_iter__IntoIter_T_2cA__20as_20core__ops__drop__Drop___drop__h8ed9ca310048d65b($2 + 32 | 0 | 0);
   HEAP32[($0 + 12 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = $2;
   i64toi32_i32$2 = HEAP32[($2 + 16 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   $140 = i64toi32_i32$2;
   i64toi32_i32$2 = $0;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = $140;
   HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[i64toi32_i32$2 >> 2] = 0;
  }
  global$0 = $2 + 176 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert__he7138860d55d997e($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$2 = 0, $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $19 = 0, $20 = 0, $5 = 0, $6 = 0, $7 = 0, $56 = 0, $62 = 0, $65 = 0, $74 = 0, $114 = 0, $120 = 0, $123 = 0, $132 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $4 = global$0 - 128 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $5 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      if ((HEAPU16[($5 + 138 | 0) >> 1] | 0) >>> 0 < 11 >>> 0) {
       break label$4
      }
      alloc__collections__btree__node__splitpoint__h8424344594b4deb1($4 + 8 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
      $6 = HEAP32[($4 + 16 | 0) >> 2] | 0;
      $7 = HEAP32[($4 + 12 | 0) >> 2] | 0;
      $1 = HEAP32[$1 >> 2] | 0;
      HEAP32[($4 + 88 | 0) >> 2] = HEAP32[($4 + 8 | 0) >> 2] | 0;
      HEAP32[($4 + 84 | 0) >> 2] = $5;
      HEAP32[($4 + 80 | 0) >> 2] = $1;
      alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__KV___split__h678cd438a93e6f1b($4 + 8 | 0 | 0, $4 + 80 | 0 | 0);
      if (($7 | 0) == (1 | 0)) {
       break label$3
      }
      HEAP32[($4 + 64 | 0) >> 2] = HEAP32[($4 + 8 | 0) >> 2] | 0;
      $1 = HEAP32[($4 + 12 | 0) >> 2] | 0;
      break label$2;
     }
     $19 = $2 + 24 | 0;
     HEAP32[(($4 + 8 | 0) + 24 | 0) >> 2] = HEAPU8[$19 >> 0] | 0 | ((HEAPU8[($19 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($19 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($19 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$2 = $2 + 16 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $56 = i64toi32_i32$0;
     i64toi32_i32$0 = ($4 + 8 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $56;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $2 + 8 | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $62 = i64toi32_i32$1;
     i64toi32_i32$1 = ($4 + 8 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $62;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $65 = i64toi32_i32$0;
     i64toi32_i32$0 = $4;
     HEAP32[($4 + 8 | 0) >> 2] = $65;
     HEAP32[($4 + 12 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[(($4 + 80 | 0) + 8 | 0) >> 2] = HEAP32[($3 + 8 | 0) >> 2] | 0;
     i64toi32_i32$2 = $3;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $74 = i64toi32_i32$1;
     i64toi32_i32$1 = $4;
     HEAP32[($4 + 80 | 0) >> 2] = $74;
     HEAP32[($4 + 84 | 0) >> 2] = i64toi32_i32$0;
     (wasm2js_i32$0 = $0, wasm2js_i32$1 = alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_fit__he0b77dcf0cf8e7bd($1 | 0, $4 + 8 | 0 | 0, $4 + 80 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 60 | 0) >> 2] = wasm2js_i32$1;
     HEAP32[($0 + 8 | 0) >> 2] = $5;
     HEAP32[$0 >> 2] = 0;
     HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
     HEAP32[($0 + 4 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
     break label$1;
    }
    HEAP32[($4 + 64 | 0) >> 2] = HEAP32[($4 + 56 | 0) >> 2] | 0;
    $1 = HEAP32[($4 + 60 | 0) >> 2] | 0;
   }
   HEAP32[($4 + 72 | 0) >> 2] = $6;
   HEAP32[($4 + 68 | 0) >> 2] = $1;
   $20 = $2 + 24 | 0;
   HEAP32[(($4 + 80 | 0) + 24 | 0) >> 2] = HEAPU8[$20 >> 0] | 0 | ((HEAPU8[($20 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($20 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($20 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$2 = $2 + 16 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $114 = i64toi32_i32$0;
   i64toi32_i32$0 = ($4 + 80 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $114;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $2 + 8 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $120 = i64toi32_i32$1;
   i64toi32_i32$1 = ($4 + 80 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $120;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $123 = i64toi32_i32$0;
   i64toi32_i32$0 = $4;
   HEAP32[($4 + 80 | 0) >> 2] = $123;
   HEAP32[($4 + 84 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[(($4 + 112 | 0) + 8 | 0) >> 2] = HEAP32[($3 + 8 | 0) >> 2] | 0;
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $132 = i64toi32_i32$1;
   i64toi32_i32$1 = $4;
   HEAP32[($4 + 112 | 0) >> 2] = $132;
   HEAP32[($4 + 116 | 0) >> 2] = i64toi32_i32$0;
   $2 = alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_fit__he0b77dcf0cf8e7bd($4 + 64 | 0 | 0, $4 + 80 | 0 | 0, $4 + 112 | 0 | 0) | 0;
   memcpy($0 + 4 | 0 | 0, $4 + 8 | 0 | 0, 56 | 0) | 0;
   HEAP32[($0 + 60 | 0) >> 2] = $2;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $4 + 128 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert__h45dfeb628bd48518($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$2 = 0, $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $19 = 0, $20 = 0, $5 = 0, $6 = 0, $7 = 0, $56 = 0, $62 = 0, $65 = 0, $74 = 0, $114 = 0, $120 = 0, $123 = 0, $132 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $4 = global$0 - 128 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $5 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      if ((HEAPU16[($5 + 138 | 0) >> 1] | 0) >>> 0 < 11 >>> 0) {
       break label$4
      }
      alloc__collections__btree__node__splitpoint__h8424344594b4deb1($4 + 8 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
      $6 = HEAP32[($4 + 16 | 0) >> 2] | 0;
      $7 = HEAP32[($4 + 12 | 0) >> 2] | 0;
      $1 = HEAP32[$1 >> 2] | 0;
      HEAP32[($4 + 88 | 0) >> 2] = HEAP32[($4 + 8 | 0) >> 2] | 0;
      HEAP32[($4 + 84 | 0) >> 2] = $5;
      HEAP32[($4 + 80 | 0) >> 2] = $1;
      alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__KV___split__ha51648547f6ff2af($4 + 8 | 0 | 0, $4 + 80 | 0 | 0);
      if (($7 | 0) == (1 | 0)) {
       break label$3
      }
      HEAP32[($4 + 64 | 0) >> 2] = HEAP32[($4 + 8 | 0) >> 2] | 0;
      $1 = HEAP32[($4 + 12 | 0) >> 2] | 0;
      break label$2;
     }
     $19 = $2 + 24 | 0;
     HEAP32[(($4 + 8 | 0) + 24 | 0) >> 2] = HEAPU8[$19 >> 0] | 0 | ((HEAPU8[($19 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($19 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($19 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$2 = $2 + 16 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $56 = i64toi32_i32$0;
     i64toi32_i32$0 = ($4 + 8 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $56;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $2 + 8 | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $62 = i64toi32_i32$1;
     i64toi32_i32$1 = ($4 + 8 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $62;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $65 = i64toi32_i32$0;
     i64toi32_i32$0 = $4;
     HEAP32[($4 + 8 | 0) >> 2] = $65;
     HEAP32[($4 + 12 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[(($4 + 80 | 0) + 8 | 0) >> 2] = HEAP32[($3 + 8 | 0) >> 2] | 0;
     i64toi32_i32$2 = $3;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $74 = i64toi32_i32$1;
     i64toi32_i32$1 = $4;
     HEAP32[($4 + 80 | 0) >> 2] = $74;
     HEAP32[($4 + 84 | 0) >> 2] = i64toi32_i32$0;
     (wasm2js_i32$0 = $0, wasm2js_i32$1 = alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_fit__h3ff3b3a963f2e253($1 | 0, $4 + 8 | 0 | 0, $4 + 80 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 60 | 0) >> 2] = wasm2js_i32$1;
     HEAP32[($0 + 8 | 0) >> 2] = $5;
     HEAP32[$0 >> 2] = 0;
     HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
     HEAP32[($0 + 4 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
     break label$1;
    }
    HEAP32[($4 + 64 | 0) >> 2] = HEAP32[($4 + 56 | 0) >> 2] | 0;
    $1 = HEAP32[($4 + 60 | 0) >> 2] | 0;
   }
   HEAP32[($4 + 72 | 0) >> 2] = $6;
   HEAP32[($4 + 68 | 0) >> 2] = $1;
   $20 = $2 + 24 | 0;
   HEAP32[(($4 + 80 | 0) + 24 | 0) >> 2] = HEAPU8[$20 >> 0] | 0 | ((HEAPU8[($20 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($20 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($20 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$2 = $2 + 16 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $114 = i64toi32_i32$0;
   i64toi32_i32$0 = ($4 + 80 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $114;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $2 + 8 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $120 = i64toi32_i32$1;
   i64toi32_i32$1 = ($4 + 80 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $120;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $123 = i64toi32_i32$0;
   i64toi32_i32$0 = $4;
   HEAP32[($4 + 80 | 0) >> 2] = $123;
   HEAP32[($4 + 84 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[(($4 + 112 | 0) + 8 | 0) >> 2] = HEAP32[($3 + 8 | 0) >> 2] | 0;
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $132 = i64toi32_i32$1;
   i64toi32_i32$1 = $4;
   HEAP32[($4 + 112 | 0) >> 2] = $132;
   HEAP32[($4 + 116 | 0) >> 2] = i64toi32_i32$0;
   $2 = alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_fit__h3ff3b3a963f2e253($4 + 64 | 0 | 0, $4 + 80 | 0 | 0, $4 + 112 | 0 | 0) | 0;
   memcpy($0 + 4 | 0 | 0, $4 + 8 | 0 | 0, 56 | 0) | 0;
   HEAP32[($0 + 60 | 0) >> 2] = $2;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $4 + 128 | 0;
 }
 
 function poolparams_new($0, $1, $2, $3, $4, $5, $6, $7, $8) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  $5 = $5 | 0;
  $6 = $6 | 0;
  $7 = $7 | 0;
  $8 = $8 | 0;
  var $9 = 0, $10 = 0, $11 = 0, $12 = 0, $13 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0;
  $9 = global$0 - 496 | 0;
  global$0 = $9;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hae9c55c4e91ce40f($9 + 56 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($9 + 60 | 0) >> 2] | 0;
   $10 = HEAP32[($9 + 56 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb2360c57549df4d5($9 + 48 | 0 | 0, $1 | 0);
   if (!$2) {
    break label$1
   }
   $1 = HEAP32[($9 + 52 | 0) >> 2] | 0;
   $11 = HEAP32[($9 + 48 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($9 + 40 | 0 | 0, $2 | 0);
   if (!$3) {
    break label$1
   }
   $2 = HEAP32[($9 + 44 | 0) >> 2] | 0;
   $12 = HEAP32[($9 + 40 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($9 + 32 | 0 | 0, $3 | 0);
   if (!$4) {
    break label$1
   }
   $3 = HEAP32[($9 + 36 | 0) >> 2] | 0;
   $13 = HEAP32[($9 + 32 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h98bfbcc994df632c($9 + 24 | 0 | 0, $4 | 0);
   if (!$5) {
    break label$1
   }
   $4 = HEAP32[($9 + 28 | 0) >> 2] | 0;
   $14 = HEAP32[($9 + 24 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h2338c90e0327d08b($9 + 16 | 0 | 0, $5 | 0);
   if (!$6) {
    break label$1
   }
   $5 = HEAP32[($9 + 20 | 0) >> 2] | 0;
   $15 = HEAP32[($9 + 16 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h38787c785ea84973($9 + 8 | 0 | 0, $6 | 0);
   if (!$7) {
    break label$1
   }
   $6 = HEAP32[($9 + 12 | 0) >> 2] | 0;
   $16 = HEAP32[($9 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hdcd31189477e1360($9 | 0, $7 | 0);
   $7 = HEAP32[($9 + 4 | 0) >> 2] | 0;
   $17 = HEAP32[$9 >> 2] | 0;
   label$2 : {
    label$3 : {
     if (!$8) {
      break label$3
     }
     $cardano_serialization_lib__PoolMetadata_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h21c8a276cf9d0035($9 + 256 | 0 | 0, $8 | 0);
     break label$2;
    }
    HEAP32[($9 + 256 | 0) >> 2] = 0;
   }
   memcpy($9 + 304 | 0 | 0, $9 + 256 | 0 | 0, 44 | 0) | 0;
   cardano_serialization_lib__PoolParams__new__h8e143b44b120ba76($9 + 64 | 0 | 0, $10 | 0, $11 | 0, $12 | 0, $13 | 0, $14 | 0, $15 | 0, $16 | 0, $17 | 0, $9 + 304 | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($7 | 0, (HEAP32[$7 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($6 | 0, (HEAP32[$6 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($5 | 0, (HEAP32[$5 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($4 | 0, (HEAP32[$4 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   memcpy($9 + 304 | 0 | 0, $9 + 64 | 0 | 0, 192 | 0) | 0;
   $0 = $cardano_serialization_lib__PoolParams_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he83d156438296832($9 + 304 | 0 | 0) | 0;
   global$0 = $9 + 496 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function core__iter__traits__iterator__Iterator__cmp_by__hdd4c1d302d53018c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $5 = 0, i64toi32_i32$2 = 0, $4 = 0, $6 = 0, $7 = 0, $22 = 0, $28 = 0, $31 = 0;
  $2 = global$0 - 96 | 0;
  global$0 = $2;
  HEAP32[(($2 + 64 | 0) + 24 | 0) >> 2] = HEAP32[($1 + 24 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $22 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 64 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $22;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = ($2 + 64 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 64 | 0) >> 2] = $31;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   label$2 : while (1) {
    $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__hf8baa7262b1cd562($2 + 56 | 0 | 0, $0 | 0);
    label$3 : {
     $3 = HEAP32[($2 + 56 | 0) >> 2] | 0;
     if ($3) {
      break label$3
     }
     $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__hf8baa7262b1cd562($2 + 8 | 0 | 0, $2 + 64 | 0 | 0);
     $1 = HEAP32[($2 + 8 | 0) >> 2] | 0 ? -1 : 0;
     break label$1;
    }
    $4 = HEAP32[($2 + 60 | 0) >> 2] | 0;
    $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__hf8baa7262b1cd562($2 + 48 | 0 | 0, $2 + 64 | 0 | 0);
    label$4 : {
     $5 = HEAP32[($2 + 48 | 0) >> 2] | 0;
     if ($5) {
      break label$4
     }
     $1 = 1;
     break label$1;
    }
    $6 = HEAP32[($2 + 52 | 0) >> 2] | 0;
    label$5 : {
     label$6 : {
      label$7 : {
       $1 = $cardano_serialization_lib__plutus__PlutusDataEnum_20as_20core__cmp__Ord___cmp__ha7781ffdcafff597($3 | 0, $5 | 0) | 0;
       if ($1 & 255 | 0) {
        break label$7
       }
       label$8 : {
        $1 = HEAP32[($3 + 32 | 0) >> 2] | 0;
        $7 = HEAP32[($5 + 32 | 0) >> 2] | 0;
        if ((($1 | 0) != (0 | 0) | 0) == (($7 | 0) != (0 | 0) | 0)) {
         break label$8
        }
        $1 = $7 ? ($1 ? 1 : -1) : 1;
        break label$1;
       }
       if (!$1) {
        break label$6
       }
       if (!$7) {
        break label$6
       }
       $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 40 | 0 | 0, $3 + 32 | 0 | 0);
       $1 = HEAP32[($2 + 44 | 0) >> 2] | 0;
       $3 = HEAP32[($2 + 40 | 0) >> 2] | 0;
       $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 32 | 0 | 0, $5 + 32 | 0 | 0);
       $1 = core__slice__cmp___impl_20core__cmp__Ord_20for_20_5bT_5d___cmp__h1f2092e0ba2f27ea($3 | 0, $1 | 0, HEAP32[($2 + 32 | 0) >> 2] | 0 | 0, HEAP32[($2 + 36 | 0) >> 2] | 0 | 0) | 0;
      }
      if ($1 & 255 | 0) {
       break label$5
      }
     }
     $1 = $cardano_serialization_lib__plutus__PlutusDataEnum_20as_20core__cmp__Ord___cmp__ha7781ffdcafff597($4 | 0, $6 | 0) | 0;
     if ($1 & 255 | 0) {
      break label$5
     }
     label$9 : {
      $3 = HEAP32[($4 + 32 | 0) >> 2] | 0;
      $5 = HEAP32[($6 + 32 | 0) >> 2] | 0;
      if ((($3 | 0) != (0 | 0) | 0) == (($5 | 0) != (0 | 0) | 0)) {
       break label$9
      }
      $1 = $5 ? ($3 ? 1 : -1) : 1;
      break label$1;
     }
     $1 = 0;
     if (!$3) {
      break label$5
     }
     if (!$5) {
      break label$5
     }
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 24 | 0 | 0, $4 + 32 | 0 | 0);
     $1 = HEAP32[($2 + 28 | 0) >> 2] | 0;
     $3 = HEAP32[($2 + 24 | 0) >> 2] | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 16 | 0 | 0, $6 + 32 | 0 | 0);
     $1 = core__slice__cmp___impl_20core__cmp__Ord_20for_20_5bT_5d___cmp__h1f2092e0ba2f27ea($3 | 0, $1 | 0, HEAP32[($2 + 16 | 0) >> 2] | 0 | 0, HEAP32[($2 + 20 | 0) >> 2] | 0 | 0) | 0;
    }
    if (!($1 & 255 | 0)) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $2 + 96 | 0;
  return $1 | 0;
 }
 
 function cbor_event__de__Deserializer_R___bytes__h5d4e2578eb751bc2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$5 = 0, $6 = 0, $8 = 0, $8$hi = 0, $3 = 0, $4 = 0, $5 = 0, $7 = 0, $7$hi = 0, i64toi32_i32$4 = 0, $69 = 0, $75 = 0, $90 = 0, $92$hi = 0, $95$hi = 0, $119 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  std__io__cursor__Cursor_T___remaining_slice__h5de2a0dd397eef35($2 + 8 | 0 | 0, $1 | 0);
  $3 = 8;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $4 = HEAP32[($2 + 12 | 0) >> 2] | 0;
      if (!$4) {
       break label$4
      }
      $3 = 8;
      $5 = HEAP32[($2 + 8 | 0) >> 2] | 0;
      if (!$5) {
       break label$4
      }
      $3 = 9;
      $6 = ($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[$5 >> 0] | 0 | 0) | 0) & 255 | 0;
      if (($6 | 0) != (2 | 0)) {
       break label$4
      }
      cbor_event__de__Deserializer_R___cbor_len__hc68764db78e73af0($2 + 16 | 0 | 0, $1 | 0);
      $6 = HEAP32[(($2 + 16 | 0) + 24 | 0) >> 2] | 0;
      i64toi32_i32$2 = ($2 + 16 | 0) + 16 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $7 = i64toi32_i32$0;
      $7$hi = i64toi32_i32$1;
      i64toi32_i32$2 = $2;
      i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($2 + 28 | 0) >> 2] | 0;
      $8 = i64toi32_i32$1;
      $8$hi = i64toi32_i32$0;
      i64toi32_i32$2 = $2;
      i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
      i64toi32_i32$2 = i64toi32_i32$0;
      i64toi32_i32$0 = 0;
      i64toi32_i32$3 = 1;
      if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
       break label$3
      }
      i64toi32_i32$2 = $8$hi;
      if ($8) {
       break label$2
      }
      HEAP32[$0 >> 2] = 1;
      HEAP16[($0 + 8 | 0) >> 1] = 524;
      break label$1;
     }
     HEAP32[$0 >> 2] = 1;
     HEAP32[($0 + 16 | 0) >> 2] = 0;
     HEAP32[($0 + 12 | 0) >> 2] = $4;
     HEAP8[($0 + 10 | 0) >> 0] = $6;
     HEAP8[($0 + 9 | 0) >> 0] = 2;
     HEAP8[($0 + 8 | 0) >> 0] = $3;
     break label$1;
    }
    i64toi32_i32$3 = ($2 + 16 | 0) + 32 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $69 = i64toi32_i32$2;
    i64toi32_i32$2 = $0 + 32 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $69;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$3 = ($2 + 16 | 0) + 40 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $75 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 40 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $75;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
    HEAP32[($0 + 28 | 0) >> 2] = HEAP32[($2 + 44 | 0) >> 2] | 0;
    HEAP32[($0 + 24 | 0) >> 2] = $6;
    i64toi32_i32$2 = $7$hi;
    i64toi32_i32$1 = $0 + 16 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $7;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $8$hi;
    i64toi32_i32$1 = $0 + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $8;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
    HEAP32[$0 >> 2] = 1;
    break label$1;
   }
   $90 = $1;
   i64toi32_i32$3 = $1;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $92$hi = i64toi32_i32$1;
   i64toi32_i32$1 = 0;
   $95$hi = i64toi32_i32$1;
   i64toi32_i32$1 = $92$hi;
   i64toi32_i32$3 = i64toi32_i32$2;
   i64toi32_i32$2 = $95$hi;
   i64toi32_i32$0 = $6 + 1 | 0;
   i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
   i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
   if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
    i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
   }
   i64toi32_i32$3 = $90;
   HEAP32[i64toi32_i32$3 >> 2] = i64toi32_i32$4;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$5 = $7$hi;
   alloc__vec__from_elem__hdc900c1db7c0f1ee($2 + 16 | 0 | 0, 0 | 0, $7 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__DerefMut___deref_mut__h1882e042320a120c($2 | 0, $2 + 16 | 0 | 0);
   label$5 : {
    label$6 : {
     i64toi32_i32$5 = $std__io__cursor__Cursor_T__20as_20std__io__Read___read_exact__hbd2417346db3632b($1 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0) | 0;
     i64toi32_i32$3 = i64toi32_i32$HIGH_BITS;
     $8 = i64toi32_i32$5;
     $8$hi = i64toi32_i32$3;
     if ((i64toi32_i32$5 & 255 | 0 | 0) == (4 | 0)) {
      break label$6
     }
     i64toi32_i32$3 = $8$hi;
     i64toi32_i32$1 = $8;
     i64toi32_i32$5 = 0;
     i64toi32_i32$0 = 255;
     i64toi32_i32$5 = i64toi32_i32$3 & i64toi32_i32$5 | 0;
     i64toi32_i32$3 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
     i64toi32_i32$1 = 0;
     i64toi32_i32$0 = 4;
     if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$5 | 0) != (i64toi32_i32$1 | 0) | 0) {
      break label$5
     }
    }
    i64toi32_i32$0 = $2;
    i64toi32_i32$3 = HEAP32[($2 + 16 | 0) >> 2] | 0;
    i64toi32_i32$5 = HEAP32[($2 + 20 | 0) >> 2] | 0;
    $119 = i64toi32_i32$3;
    i64toi32_i32$3 = $0;
    HEAP32[($0 + 4 | 0) >> 2] = $119;
    HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$5;
    HEAP32[$0 >> 2] = 0;
    HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($2 + 24 | 0) >> 2] | 0;
    break label$1;
   }
   i64toi32_i32$5 = $8$hi;
   $cbor_event__error__Error_20as_20core__convert__From_std__io__error__Error____from__hd172f94a2e75bf41($0 + 8 | 0 | 0, $8 | 0, i64toi32_i32$5 | 0);
   HEAP32[$0 >> 2] = 1;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 16 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 16 | 0 | 0);
  }
  global$0 = $2 + 64 | 0;
 }
 
 function cbor_event__de__Deserializer_R___bytes__hc697ccccfa39fd82($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$5 = 0, $6 = 0, $8 = 0, $8$hi = 0, $3 = 0, $4 = 0, $5 = 0, $7 = 0, $7$hi = 0, i64toi32_i32$4 = 0, $69 = 0, $75 = 0, $90 = 0, $92$hi = 0, $95$hi = 0, $119 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 8 | 0 | 0, $1 | 0);
  $3 = 8;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $4 = HEAP32[($2 + 12 | 0) >> 2] | 0;
      if (!$4) {
       break label$4
      }
      $3 = 8;
      $5 = HEAP32[($2 + 8 | 0) >> 2] | 0;
      if (!$5) {
       break label$4
      }
      $3 = 9;
      $6 = ($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[$5 >> 0] | 0 | 0) | 0) & 255 | 0;
      if (($6 | 0) != (2 | 0)) {
       break label$4
      }
      cbor_event__de__Deserializer_R___cbor_len__h852681e444aca076_1($2 + 16 | 0 | 0, $1 | 0);
      $6 = HEAP32[(($2 + 16 | 0) + 24 | 0) >> 2] | 0;
      i64toi32_i32$2 = ($2 + 16 | 0) + 16 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $7 = i64toi32_i32$0;
      $7$hi = i64toi32_i32$1;
      i64toi32_i32$2 = $2;
      i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($2 + 28 | 0) >> 2] | 0;
      $8 = i64toi32_i32$1;
      $8$hi = i64toi32_i32$0;
      i64toi32_i32$2 = $2;
      i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
      i64toi32_i32$2 = i64toi32_i32$0;
      i64toi32_i32$0 = 0;
      i64toi32_i32$3 = 1;
      if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
       break label$3
      }
      i64toi32_i32$2 = $8$hi;
      if ($8) {
       break label$2
      }
      HEAP32[$0 >> 2] = 1;
      HEAP16[($0 + 8 | 0) >> 1] = 524;
      break label$1;
     }
     HEAP32[$0 >> 2] = 1;
     HEAP32[($0 + 16 | 0) >> 2] = 0;
     HEAP32[($0 + 12 | 0) >> 2] = $4;
     HEAP8[($0 + 10 | 0) >> 0] = $6;
     HEAP8[($0 + 9 | 0) >> 0] = 2;
     HEAP8[($0 + 8 | 0) >> 0] = $3;
     break label$1;
    }
    i64toi32_i32$3 = ($2 + 16 | 0) + 32 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $69 = i64toi32_i32$2;
    i64toi32_i32$2 = $0 + 32 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $69;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$3 = ($2 + 16 | 0) + 40 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $75 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 40 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $75;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
    HEAP32[($0 + 28 | 0) >> 2] = HEAP32[($2 + 44 | 0) >> 2] | 0;
    HEAP32[($0 + 24 | 0) >> 2] = $6;
    i64toi32_i32$2 = $7$hi;
    i64toi32_i32$1 = $0 + 16 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $7;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $8$hi;
    i64toi32_i32$1 = $0 + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $8;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
    HEAP32[$0 >> 2] = 1;
    break label$1;
   }
   $90 = $1;
   i64toi32_i32$3 = $1;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $92$hi = i64toi32_i32$1;
   i64toi32_i32$1 = 0;
   $95$hi = i64toi32_i32$1;
   i64toi32_i32$1 = $92$hi;
   i64toi32_i32$3 = i64toi32_i32$2;
   i64toi32_i32$2 = $95$hi;
   i64toi32_i32$0 = $6 + 1 | 0;
   i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
   i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
   if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
    i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
   }
   i64toi32_i32$3 = $90;
   HEAP32[i64toi32_i32$3 >> 2] = i64toi32_i32$4;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$5 = $7$hi;
   alloc__vec__from_elem__hdc900c1db7c0f1ee($2 + 16 | 0 | 0, 0 | 0, $7 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__DerefMut___deref_mut__h1882e042320a120c($2 | 0, $2 + 16 | 0 | 0);
   label$5 : {
    label$6 : {
     i64toi32_i32$5 = $std__io__cursor__Cursor_T__20as_20std__io__Read___read_exact__h9623dbdca04d0b37($1 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0) | 0;
     i64toi32_i32$3 = i64toi32_i32$HIGH_BITS;
     $8 = i64toi32_i32$5;
     $8$hi = i64toi32_i32$3;
     if ((i64toi32_i32$5 & 255 | 0 | 0) == (4 | 0)) {
      break label$6
     }
     i64toi32_i32$3 = $8$hi;
     i64toi32_i32$1 = $8;
     i64toi32_i32$5 = 0;
     i64toi32_i32$0 = 255;
     i64toi32_i32$5 = i64toi32_i32$3 & i64toi32_i32$5 | 0;
     i64toi32_i32$3 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
     i64toi32_i32$1 = 0;
     i64toi32_i32$0 = 4;
     if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$5 | 0) != (i64toi32_i32$1 | 0) | 0) {
      break label$5
     }
    }
    i64toi32_i32$0 = $2;
    i64toi32_i32$3 = HEAP32[($2 + 16 | 0) >> 2] | 0;
    i64toi32_i32$5 = HEAP32[($2 + 20 | 0) >> 2] | 0;
    $119 = i64toi32_i32$3;
    i64toi32_i32$3 = $0;
    HEAP32[($0 + 4 | 0) >> 2] = $119;
    HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$5;
    HEAP32[$0 >> 2] = 0;
    HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($2 + 24 | 0) >> 2] | 0;
    break label$1;
   }
   i64toi32_i32$5 = $8$hi;
   $cbor_event__error__Error_20as_20core__convert__From_std__io__error__Error____from__hd172f94a2e75bf41($0 + 8 | 0 | 0, $8 | 0, i64toi32_i32$5 | 0);
   HEAP32[$0 >> 2] = 1;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 16 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 16 | 0 | 0);
  }
  global$0 = $2 + 64 | 0;
 }
 
 function $cardano_serialization_lib__plutus__PlutusData_20as_20core__clone__Clone___clone__h63d1a98cc18f4609($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $5 = 0, $3 = 0, $5$hi = 0, $23 = 0, $39 = 0, $66 = 0, $69 = 0, $4 = 0, $93 = 0, $107 = 0, $110 = 0, $115 = 0, $120 = 0, $125 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  $3 = $1 + 32 | 0;
  label$1 : {
   label$2 : {
    switch (HEAP32[$1 >> 2] | 0 | 0) {
    default:
     i64toi32_i32$2 = $1 + 8 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $5 = i64toi32_i32$0;
     $5$hi = i64toi32_i32$1;
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hc831120dea694494($2 + 48 | 0 | 0, $1 + 16 | 0 | 0);
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAP32[($2 + 48 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 52 | 0) >> 2] | 0;
     $23 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 16 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $23;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     $1 = HEAPU8[($1 + 28 | 0) >> 0] | 0;
     HEAP32[$2 >> 2] = 0;
     HEAP8[($2 + 60 | 0) >> 0] = ($1 | 0) == (2 | 0) ? 2 : ($1 | 0) != (0 | 0);
     i64toi32_i32$2 = ($2 + 48 | 0) + 8 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $39 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 24 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $39;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $5$hi;
     i64toi32_i32$0 = $2 + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $5;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     break label$1;
    case 1:
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__hf4eb1bac8cecd8c9($2 | 4 | 0 | 0, $1 + 4 | 0 | 0);
     HEAP32[$2 >> 2] = 1;
     break label$1;
    case 2:
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hc831120dea694494($2 + 48 | 0 | 0, $1 + 4 | 0 | 0);
     $1 = HEAPU8[($1 + 16 | 0) >> 0] | 0;
     HEAP32[$2 >> 2] = 2;
     HEAP8[($2 + 60 | 0) >> 0] = ($1 | 0) == (2 | 0) ? 2 : ($1 | 0) != (0 | 0);
     i64toi32_i32$2 = $2 + 56 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $66 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 12 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $66;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 52 | 0) >> 2] | 0;
     $69 = i64toi32_i32$0;
     i64toi32_i32$0 = $2;
     HEAP32[($2 + 4 | 0) >> 2] = $69;
     HEAP32[($2 + 8 | 0) >> 2] = i64toi32_i32$1;
     break label$1;
    case 3:
     $4 = HEAPU8[($1 + 16 | 0) >> 0] | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hd36b5d149e6fd98b($2 + 48 | 0 | 0, $1 + 4 | 0 | 0);
     HEAP8[($2 + 60 | 0) >> 0] = $4;
     i64toi32_i32$2 = ($2 + 48 | 0) + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $5 = i64toi32_i32$1;
     $5$hi = i64toi32_i32$0;
     i64toi32_i32$1 = ($2 + 32 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $5;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$1 = $2 + 12 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $5;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[$2 >> 2] = 3;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 52 | 0) >> 2] | 0;
     $93 = i64toi32_i32$0;
     i64toi32_i32$0 = $2;
     HEAP32[($2 + 4 | 0) >> 2] = $93;
     HEAP32[($2 + 8 | 0) >> 2] = i64toi32_i32$1;
     break label$1;
    case 4:
     break label$2;
    };
   }
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($2 | 4 | 0 | 0, $1 + 4 | 0 | 0);
   HEAP32[$2 >> 2] = 4;
  }
  label$7 : {
   label$8 : {
    if (HEAP32[$3 >> 2] | 0) {
     break label$8
    }
    HEAP32[($2 + 48 | 0) >> 2] = 0;
    break label$7;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($2 + 48 | 0 | 0, $3 | 0);
  }
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $107 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $107;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $110 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] = $110;
  HEAP32[(i64toi32_i32$0 + 36 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2 + 24 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $115 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 24 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $115;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $120 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $120;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $125 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $125;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($0 + 40 | 0) >> 2] = HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 64 | 0;
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__ha732c788391a1960($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $13 = 0, $9 = 0, $12 = 0, $6 = 0, $4 = 0, $5 = 0, $8 = 0, $26 = 0, $27 = 0, $28 = 0, $29 = 0, $30 = 0, $31 = 0, $32 = 0, $33 = 0, $34 = 0, $35 = 0, $36 = 0, $37 = 0, $38 = 0, $39 = 0, $3 = 0, $7 = 0, $10 = 0, $11 = 0, $14 = 0, $70 = 0, $74 = 0, $87 = 0, $100 = 0, $113 = 0, $125 = 0, $129 = 0, $133 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocator__hac7e8c134c0e2bb4($1 | 0) | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h25def2337ddd4f0a($2 + 16 | 0 | 0, $1 | 0);
  $3 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  $1 = 0;
  $4 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h0e767008da1e2eac($2 + 8 | 0 | 0, $4 | 0, 0 | 0);
  $5 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  $6 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[($0 + 4 | 0) >> 2] = $6;
  HEAP32[$0 >> 2] = $5;
  label$1 : {
   if (!$6) {
    break label$1
   }
   $7 = Math_imul($4, 24);
   $8 = $2 + 32 | 0;
   $9 = ($2 + 26 | 0) + 2 | 0;
   $10 = ($2 + 26 | 0) + 8 | 0;
   $11 = $2 + 40 | 0;
   label$2 : while (1) {
    if (($7 | 0) == ($1 | 0)) {
     break label$1
    }
    $6 = $6 + -1 | 0;
    $12 = 0;
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          $13 = $3 + $1 | 0;
          switch (HEAPU8[$13 >> 0] | 0 | 0) {
          case 5:
           break label$4;
          case 4:
           break label$5;
          case 3:
           break label$6;
          case 2:
           break label$7;
          case 1:
           break label$8;
          default:
           break label$3;
          };
         }
         $12 = 1;
         $14 = HEAPU8[($13 + 1 | 0) >> 0] | 0;
         break label$3;
        }
        i64toi32_i32$2 = $13 + 16 | 0;
        i64toi32_i32$0 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
        i64toi32_i32$1 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
        $70 = i64toi32_i32$0;
        i64toi32_i32$0 = $8 + 8 | 0;
        $26 = $70;
        HEAP16[i64toi32_i32$0 >> 1] = $26;
        HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $26 >>> 16 | 0;
        HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$1;
        HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
        i64toi32_i32$2 = $13 + 8 | 0;
        i64toi32_i32$1 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
        i64toi32_i32$0 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
        $74 = i64toi32_i32$1;
        i64toi32_i32$1 = $8;
        $27 = $74;
        HEAP16[i64toi32_i32$1 >> 1] = $27;
        HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $27 >>> 16 | 0;
        HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = i64toi32_i32$0;
        HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
        $12 = 2;
        break label$3;
       }
       $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($2 + 48 | 0 | 0, $13 + 4 | 0 | 0);
       $28 = $9 + 8 | 0;
       $29 = HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] | 0;
       HEAP16[$28 >> 1] = $29;
       HEAP16[($28 + 2 | 0) >> 1] = $29 >>> 16 | 0;
       i64toi32_i32$2 = $2;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] | 0;
       $87 = i64toi32_i32$0;
       i64toi32_i32$0 = $9;
       $30 = $87;
       HEAP16[i64toi32_i32$0 >> 1] = $30;
       HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $30 >>> 16 | 0;
       HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$1;
       HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
       $12 = 3;
       break label$3;
      }
      $12 = 4;
      $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__ha732c788391a1960($2 + 48 | 0 | 0, $13 + 4 | 0 | 0);
      $31 = $9 + 8 | 0;
      $32 = HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] | 0;
      HEAP16[$31 >> 1] = $32;
      HEAP16[($31 + 2 | 0) >> 1] = $32 >>> 16 | 0;
      i64toi32_i32$2 = $2;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] | 0;
      $100 = i64toi32_i32$1;
      i64toi32_i32$1 = $9;
      $33 = $100;
      HEAP16[i64toi32_i32$1 >> 1] = $33;
      HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $33 >>> 16 | 0;
      HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = i64toi32_i32$0;
      HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
      break label$3;
     }
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__hf249498970160004($2 + 48 | 0 | 0, $13 + 4 | 0 | 0);
     $34 = $9 + 8 | 0;
     $35 = HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] | 0;
     HEAP16[$34 >> 1] = $35;
     HEAP16[($34 + 2 | 0) >> 1] = $35 >>> 16 | 0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] | 0;
     $113 = i64toi32_i32$0;
     i64toi32_i32$0 = $9;
     $36 = $113;
     HEAP16[i64toi32_i32$0 >> 1] = $36;
     HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $36 >>> 16 | 0;
     HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$1;
     HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
     $12 = 5;
    }
    $13 = $5 + $1 | 0;
    HEAP8[$13 >> 0] = $12;
    HEAP8[($13 + 1 | 0) >> 0] = $14;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAPU16[(i64toi32_i32$2 + 26 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 28 | 0) >> 1] | 0) << 16 | 0) | 0;
    i64toi32_i32$0 = HEAPU16[(i64toi32_i32$2 + 30 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 32 | 0) >> 1] | 0) << 16 | 0) | 0;
    $125 = i64toi32_i32$1;
    i64toi32_i32$1 = $13 + 2 | 0;
    $37 = $125;
    HEAP16[i64toi32_i32$1 >> 1] = $37;
    HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $37 >>> 16 | 0;
    HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = i64toi32_i32$0;
    HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
    i64toi32_i32$2 = $10;
    i64toi32_i32$0 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
    i64toi32_i32$1 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
    $129 = i64toi32_i32$0;
    i64toi32_i32$0 = $13 + 10 | 0;
    $38 = $129;
    HEAP16[i64toi32_i32$0 >> 1] = $38;
    HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $38 >>> 16 | 0;
    HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$1;
    HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
    i64toi32_i32$2 = $11;
    i64toi32_i32$1 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
    i64toi32_i32$0 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
    $133 = i64toi32_i32$1;
    i64toi32_i32$1 = $13 + 16 | 0;
    $39 = $133;
    HEAP16[i64toi32_i32$1 >> 1] = $39;
    HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $39 >>> 16 | 0;
    HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = i64toi32_i32$0;
    HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
    $1 = $1 + 24 | 0;
    if ($6) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 8 | 0) >> 2] = $4;
  global$0 = $2 + 64 | 0;
 }
 
 function $cardano_serialization_lib__plutus__PlutusData_20as_20core__clone__Clone___clone__h63d1a98cc18f4609_1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $5 = 0, $3 = 0, $5$hi = 0, $23 = 0, $39 = 0, $66 = 0, $69 = 0, $4 = 0, $93 = 0, $107 = 0, $110 = 0, $115 = 0, $120 = 0, $125 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  $3 = $1 + 32 | 0;
  label$1 : {
   label$2 : {
    switch (HEAP32[$1 >> 2] | 0 | 0) {
    default:
     i64toi32_i32$2 = $1 + 8 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $5 = i64toi32_i32$0;
     $5$hi = i64toi32_i32$1;
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hc831120dea694494($2 + 48 | 0 | 0, $1 + 16 | 0 | 0);
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAP32[($2 + 48 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 52 | 0) >> 2] | 0;
     $23 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 16 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $23;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     $1 = HEAPU8[($1 + 28 | 0) >> 0] | 0;
     HEAP32[$2 >> 2] = 0;
     HEAP8[($2 + 60 | 0) >> 0] = ($1 | 0) == (2 | 0) ? 2 : ($1 | 0) != (0 | 0);
     i64toi32_i32$2 = ($2 + 48 | 0) + 8 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $39 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 24 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $39;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $5$hi;
     i64toi32_i32$0 = $2 + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $5;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     break label$1;
    case 1:
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__hf4eb1bac8cecd8c9($2 | 4 | 0 | 0, $1 + 4 | 0 | 0);
     HEAP32[$2 >> 2] = 1;
     break label$1;
    case 2:
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hc831120dea694494($2 + 48 | 0 | 0, $1 + 4 | 0 | 0);
     $1 = HEAPU8[($1 + 16 | 0) >> 0] | 0;
     HEAP32[$2 >> 2] = 2;
     HEAP8[($2 + 60 | 0) >> 0] = ($1 | 0) == (2 | 0) ? 2 : ($1 | 0) != (0 | 0);
     i64toi32_i32$2 = $2 + 56 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $66 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 12 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $66;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 52 | 0) >> 2] | 0;
     $69 = i64toi32_i32$0;
     i64toi32_i32$0 = $2;
     HEAP32[($2 + 4 | 0) >> 2] = $69;
     HEAP32[($2 + 8 | 0) >> 2] = i64toi32_i32$1;
     break label$1;
    case 3:
     $4 = HEAPU8[($1 + 16 | 0) >> 0] | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hd36b5d149e6fd98b($2 + 48 | 0 | 0, $1 + 4 | 0 | 0);
     HEAP8[($2 + 60 | 0) >> 0] = $4;
     i64toi32_i32$2 = ($2 + 48 | 0) + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $5 = i64toi32_i32$1;
     $5$hi = i64toi32_i32$0;
     i64toi32_i32$1 = ($2 + 32 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $5;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$1 = $2 + 12 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $5;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[$2 >> 2] = 3;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 52 | 0) >> 2] | 0;
     $93 = i64toi32_i32$0;
     i64toi32_i32$0 = $2;
     HEAP32[($2 + 4 | 0) >> 2] = $93;
     HEAP32[($2 + 8 | 0) >> 2] = i64toi32_i32$1;
     break label$1;
    case 4:
     break label$2;
    };
   }
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($2 | 4 | 0 | 0, $1 + 4 | 0 | 0);
   HEAP32[$2 >> 2] = 4;
  }
  label$7 : {
   label$8 : {
    if (HEAP32[$3 >> 2] | 0) {
     break label$8
    }
    HEAP32[($2 + 48 | 0) >> 2] = 0;
    break label$7;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($2 + 48 | 0 | 0, $3 | 0);
  }
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $107 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $107;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $110 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] = $110;
  HEAP32[(i64toi32_i32$0 + 36 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2 + 24 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $115 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 24 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $115;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $120 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $120;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $125 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $125;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($0 + 40 | 0) >> 2] = HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 64 | 0;
 }
 
 function $cardano_serialization_lib__plutus__PlutusData_20as_20core__clone__Clone___clone__h63d1a98cc18f4609_2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $5 = 0, $3 = 0, $5$hi = 0, $23 = 0, $39 = 0, $66 = 0, $69 = 0, $4 = 0, $93 = 0, $107 = 0, $110 = 0, $115 = 0, $120 = 0, $125 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  $3 = $1 + 32 | 0;
  label$1 : {
   label$2 : {
    switch (HEAP32[$1 >> 2] | 0 | 0) {
    default:
     i64toi32_i32$2 = $1 + 8 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $5 = i64toi32_i32$0;
     $5$hi = i64toi32_i32$1;
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hc831120dea694494($2 + 48 | 0 | 0, $1 + 16 | 0 | 0);
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAP32[($2 + 48 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 52 | 0) >> 2] | 0;
     $23 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 16 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $23;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     $1 = HEAPU8[($1 + 28 | 0) >> 0] | 0;
     HEAP32[$2 >> 2] = 0;
     HEAP8[($2 + 60 | 0) >> 0] = ($1 | 0) == (2 | 0) ? 2 : ($1 | 0) != (0 | 0);
     i64toi32_i32$2 = ($2 + 48 | 0) + 8 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $39 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 24 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $39;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $5$hi;
     i64toi32_i32$0 = $2 + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $5;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     break label$1;
    case 1:
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__hf4eb1bac8cecd8c9($2 | 4 | 0 | 0, $1 + 4 | 0 | 0);
     HEAP32[$2 >> 2] = 1;
     break label$1;
    case 2:
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hc831120dea694494($2 + 48 | 0 | 0, $1 + 4 | 0 | 0);
     $1 = HEAPU8[($1 + 16 | 0) >> 0] | 0;
     HEAP32[$2 >> 2] = 2;
     HEAP8[($2 + 60 | 0) >> 0] = ($1 | 0) == (2 | 0) ? 2 : ($1 | 0) != (0 | 0);
     i64toi32_i32$2 = $2 + 56 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $66 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 12 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $66;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 52 | 0) >> 2] | 0;
     $69 = i64toi32_i32$0;
     i64toi32_i32$0 = $2;
     HEAP32[($2 + 4 | 0) >> 2] = $69;
     HEAP32[($2 + 8 | 0) >> 2] = i64toi32_i32$1;
     break label$1;
    case 3:
     $4 = HEAPU8[($1 + 16 | 0) >> 0] | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hd36b5d149e6fd98b($2 + 48 | 0 | 0, $1 + 4 | 0 | 0);
     HEAP8[($2 + 60 | 0) >> 0] = $4;
     i64toi32_i32$2 = ($2 + 48 | 0) + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $5 = i64toi32_i32$1;
     $5$hi = i64toi32_i32$0;
     i64toi32_i32$1 = ($2 + 32 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $5;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$1 = $2 + 12 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $5;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[$2 >> 2] = 3;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 52 | 0) >> 2] | 0;
     $93 = i64toi32_i32$0;
     i64toi32_i32$0 = $2;
     HEAP32[($2 + 4 | 0) >> 2] = $93;
     HEAP32[($2 + 8 | 0) >> 2] = i64toi32_i32$1;
     break label$1;
    case 4:
     break label$2;
    };
   }
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($2 | 4 | 0 | 0, $1 + 4 | 0 | 0);
   HEAP32[$2 >> 2] = 4;
  }
  label$7 : {
   label$8 : {
    if (HEAP32[$3 >> 2] | 0) {
     break label$8
    }
    HEAP32[($2 + 48 | 0) >> 2] = 0;
    break label$7;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($2 + 48 | 0 | 0, $3 | 0);
  }
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $107 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $107;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $110 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] = $110;
  HEAP32[(i64toi32_i32$0 + 36 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2 + 24 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $115 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 24 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $115;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $120 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $120;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $125 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $125;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($0 + 40 | 0) >> 2] = HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 64 | 0;
 }
 
 function cryptoxide__chacha20poly1305__ChaChaPoly1305_____decrypt__h389227096220e6aa($0, $1, $2, $3, $4, $5, $6) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  $5 = $5 | 0;
  $6 = $6 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $7 = 0, $8 = 0, $32 = 0, $38 = 0, $44 = 0, $50 = 0, $53 = 0, $57 = 0, $61 = 0, $65 = 0, $93 = 0, $120 = 0, $123 = 0;
  $7 = global$0 - 512 | 0;
  global$0 = $7;
  label$1 : {
   label$2 : {
    label$3 : {
     if (($6 | 0) != (16 | 0)) {
      break label$3
     }
     if (($2 | 0) != ($4 | 0)) {
      break label$2
     }
     if (!(HEAPU8[($0 + 232 | 0) >> 0] | 0)) {
      break label$1
     }
     core__panicking__panic__h2fd385a887c8bf13(1055236 | 0, 32 | 0, 1055268 | 0);
     abort();
    }
    core__panicking__panic__h2fd385a887c8bf13(1055120 | 0, 33 | 0, 1055156 | 0);
    abort();
   }
   core__panicking__panic__h2fd385a887c8bf13(1055172 | 0, 45 | 0, 1055220 | 0);
   abort();
  }
  HEAP8[($0 + 232 | 0) >> 0] = 1;
  $6 = $7 + 8 | 0;
  i64toi32_i32$1 = $6;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$1 = $7;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  core__slice___impl_20_5bT_5d___copy_from_slice__h0f69c19ed1852955(i64toi32_i32$1 | 0, 16 | 0, $5 | 0, 16 | 0);
  i64toi32_i32$2 = $0 + 24 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $32 = i64toi32_i32$0;
  i64toi32_i32$0 = ($7 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $32;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $0 + 40 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $38 = i64toi32_i32$1;
  i64toi32_i32$1 = ($7 + 16 | 0) + 24 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $38;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $0 + 56 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $44 = i64toi32_i32$0;
  i64toi32_i32$0 = ($7 + 16 | 0) + 40 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $44;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $0 + 72 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $50 = i64toi32_i32$1;
  i64toi32_i32$1 = ($7 + 16 | 0) + 56 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $50;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $53 = i64toi32_i32$0;
  i64toi32_i32$0 = $7;
  HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $53;
  HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$2 + 32 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $57 = i64toi32_i32$1;
  i64toi32_i32$1 = $7;
  HEAP32[(i64toi32_i32$1 + 32 | 0) >> 2] = $57;
  HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $0 + 48 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $61 = i64toi32_i32$0;
  i64toi32_i32$0 = $7;
  HEAP32[(i64toi32_i32$0 + 48 | 0) >> 2] = $61;
  HEAP32[(i64toi32_i32$0 + 52 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $0 + 64 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $65 = i64toi32_i32$1;
  i64toi32_i32$1 = $7;
  HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] = $65;
  HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] = i64toi32_i32$0;
  memcpy((i64toi32_i32$1 + 248 | 0) + 84 | 0 | 0, $0 + 84 | 0 | 0, 64 | 0) | 0;
  $4 = HEAP32[($0 + 80 | 0) >> 2] | 0;
  memcpy((i64toi32_i32$1 + 248 | 0) + 16 | 0 | 0, i64toi32_i32$1 + 16 | 0 | 0, 64 | 0) | 0;
  $5 = memcpy((i64toi32_i32$1 + 248 | 0) + 148 | 0 | 0, $0 + 148 | 0 | 0, 80 | 0) | 0;
  HEAP32[((i64toi32_i32$1 + 248 | 0) + 80 | 0) >> 2] = $4;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $93 = i64toi32_i32$0;
  i64toi32_i32$0 = $7;
  HEAP32[(i64toi32_i32$0 + 256 | 0) >> 2] = $93;
  HEAP32[(i64toi32_i32$0 + 260 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$1;
  i64toi32_i32$1 = $7;
  HEAP32[(i64toi32_i32$1 + 248 | 0) >> 2] = $8;
  HEAP32[(i64toi32_i32$1 + 252 | 0) >> 2] = i64toi32_i32$0;
  cryptoxide__chacha20poly1305__pad16__hc43355684cd75a45($5 | 0, $8 | 0, i64toi32_i32$0 | 0);
  memcpy(i64toi32_i32$1 + 16 | 0 | 0, i64toi32_i32$1 + 248 | 0 | 0, 232 | 0) | 0;
  cryptoxide__chacha20poly1305__ContextDecryption_____decrypt__h516503f3ed8845db(i64toi32_i32$1 + 16 | 0 | 0, $1 | 0, $2 | 0, $3 | 0, $2 | 0);
  memcpy(i64toi32_i32$1 + 248 | 0 | 0, i64toi32_i32$1 + 16 | 0 | 0, 232 | 0) | 0;
  i64toi32_i32$2 = $6;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $120 = i64toi32_i32$0;
  i64toi32_i32$0 = ($7 + 480 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $120;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $7;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $123 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$1 + 480 | 0) >> 2] = $123;
  HEAP32[(i64toi32_i32$1 + 484 | 0) >> 2] = i64toi32_i32$0;
  cryptoxide__chacha20poly1305__finalize_raw__ha8a88c220a2fbc52(i64toi32_i32$1 + 496 | 0 | 0, i64toi32_i32$1 + 248 | 0 | 0);
  $0 = $cryptoxide__chacha20poly1305__Tag_20as_20core__cmp__PartialEq___eq__ha1b5a4e4dff7c1e7(i64toi32_i32$1 + 496 | 0 | 0, i64toi32_i32$1 + 480 | 0 | 0) | 0;
  global$0 = i64toi32_i32$1 + 512 | 0;
  return $0 | 0;
 }
 
 function hashbrown__map__make_insert_hash__hde48453e54123393($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $8$hi = 0, $7$hi = 0, $7 = 0, $8 = 0, $9$hi = 0, $9 = 0, $10$hi = 0, $10 = 0, $11$hi = 0, $2 = 0, $11 = 0, $12$hi = 0, $12 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $92 = 0, $25 = 0, $30 = 0, $37 = 0, $45 = 0, $63 = 0, $63$hi = 0, $64 = 0, $64$hi = 0, $66$hi = 0, $71 = 0, $71$hi = 0, $77 = 0, $77$hi = 0, $82 = 0, $82$hi = 0, $86 = 0, $86$hi = 0, $89$hi = 0, $96 = 0, $96$hi = 0, $102 = 0, $102$hi = 0, $104 = 0, $104$hi = 0, $106$hi = 0, $112 = 0, $112$hi = 0, $118 = 0, $118$hi = 0, $121 = 0, $121$hi = 0, $122 = 0, $122$hi = 0, $124$hi = 0, $129 = 0, $129$hi = 0, $136 = 0, $136$hi = 0, $137 = 0, $137$hi = 0, $139$hi = 0, $144 = 0, $144$hi = 0, $151 = 0, $151$hi = 0, $152 = 0, $152$hi = 0, $154$hi = 0, $159 = 0, $159$hi = 0, $162$hi = 0, $164 = 0, $164$hi = 0, $166$hi = 0, $171 = 0, $171$hi = 0, $177$hi = 0, $93 = 0, $180 = 0, $180$hi = 0, $181 = 0, $181$hi = 0, $183 = 0, $183$hi = 0, $184 = 0, $184$hi = 0, $186 = 0, $186$hi = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  $3 = $2 + 56 | 0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = $2 + 40 | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = 1952801890;
  i64toi32_i32$3 = 2037671283;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $25 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $4;
  HEAP32[i64toi32_i32$2 >> 2] = $25;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  $5 = $2 + 32 | 0;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$1 = $7;
  i64toi32_i32$2 = 1685025377;
  i64toi32_i32$3 = 1852075885;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $30 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $5;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  $6 = $2 + 24 | 0;
  i64toi32_i32$0 = $0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$2;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$2 = 1819895653;
  i64toi32_i32$3 = 1852142177;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $37 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $6;
  HEAP32[i64toi32_i32$0 >> 2] = $37;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$0 = $2;
  i64toi32_i32$2 = 0;
  HEAP32[(i64toi32_i32$0 + 48 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 52 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = i64toi32_i32$1;
  HEAP32[i64toi32_i32$0 >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$1 = $8;
  i64toi32_i32$0 = 1936682341;
  i64toi32_i32$3 = 1886610805;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $45 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $2;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $45;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  $cardano_serialization_lib__address__StakeCredType_20as_20core__hash__Hash___hash__he9f79766a5c45cf6(HEAP32[$1 >> 2] | 0 | 0, i64toi32_i32$1 | 0);
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = 0;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] | 0;
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $6;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $12 = i64toi32_i32$1;
  $12$hi = i64toi32_i32$0;
  global$0 = i64toi32_i32$2 + 64 | 0;
  i64toi32_i32$0 = $10$hi;
  $63 = $10;
  $63$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  $64 = $9;
  $64$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$2 = $8;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $92 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $92 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $66$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $64$hi;
  i64toi32_i32$0 = $64;
  i64toi32_i32$2 = $66$hi;
  i64toi32_i32$3 = $92;
  i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
  $8 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $63$hi;
  i64toi32_i32$1 = $63;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $9 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($9 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $71 = i64toi32_i32$1;
  $71$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$4;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $71$hi;
  i64toi32_i32$0 = $71;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$2;
  $77 = $10;
  $77$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$5 = $7;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $82 = i64toi32_i32$5;
  $82$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $77$hi;
  i64toi32_i32$2 = $77;
  i64toi32_i32$5 = $82$hi;
  i64toi32_i32$3 = $82;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $12 = i64toi32_i32$0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $86 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $86$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($7 | 0, i64toi32_i32$2 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $89$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$2 = $89$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $8 = i64toi32_i32$5;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 17 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $96 = i64toi32_i32$2;
  $96$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$2 = $96$hi;
  i64toi32_i32$3 = $96;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $86$hi;
  i64toi32_i32$0 = $86;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $102 = i64toi32_i32$0;
  $102$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = $102$hi;
  i64toi32_i32$3 = $102;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $7 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$0;
  $104 = $7;
  $104$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($10 | 0, i64toi32_i32$0 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $106$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$0 = $106$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $10$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($8 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 255;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $112 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $112$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$2 = $10;
  i64toi32_i32$0 = $112$hi;
  i64toi32_i32$3 = $112;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $8 = i64toi32_i32$4;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $104$hi;
  i64toi32_i32$5 = $104;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$0;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 17 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $118 = i64toi32_i32$5;
  $118$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$5 = $118$hi;
  i64toi32_i32$3 = $118;
  i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
  $7 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$5;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $121 = i64toi32_i32$1;
  $121$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  $122 = $7;
  $122$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$5 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $124$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $8$hi;
  i64toi32_i32$5 = $124$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $8 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($9 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $129 = i64toi32_i32$4;
  $129$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$5 = $8;
  i64toi32_i32$4 = $129$hi;
  i64toi32_i32$3 = $129;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $9 = i64toi32_i32$2;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $122$hi;
  i64toi32_i32$1 = $122;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$4;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $121$hi;
  i64toi32_i32$0 = $121;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($10 | 0, i64toi32_i32$1 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $136 = i64toi32_i32$0;
  $136$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $10$hi;
  $137 = $10;
  $137$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($8 | 0, i64toi32_i32$1 | 0, 21 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $139$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$1 = $139$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $8 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $144 = i64toi32_i32$2;
  $144$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$1 = $8;
  i64toi32_i32$2 = $144$hi;
  i64toi32_i32$3 = $144;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $9 = i64toi32_i32$5;
  $9$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $137$hi;
  i64toi32_i32$0 = $137;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $10 = i64toi32_i32$2;
  $10$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $136$hi;
  i64toi32_i32$4 = $136;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $11 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $151 = i64toi32_i32$4;
  $151$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  $152 = $11;
  $152$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($8 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $154$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $154$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $8 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $159 = i64toi32_i32$5;
  $159$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$0 = $8;
  i64toi32_i32$5 = $159$hi;
  i64toi32_i32$3 = $159;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$1;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $152$hi;
  i64toi32_i32$4 = $152;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $162$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $151$hi;
  i64toi32_i32$2 = $151;
  i64toi32_i32$4 = $162$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $9 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $9$hi = i64toi32_i32$4;
  $164 = $9;
  $164$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($8 | 0, i64toi32_i32$4 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $166$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$4 = $166$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $171 = i64toi32_i32$1;
  $171$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = $7;
  i64toi32_i32$1 = $171$hi;
  i64toi32_i32$3 = $171;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $164$hi;
  i64toi32_i32$2 = $164;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $10 = i64toi32_i32$1;
  $10$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $177$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$0 = $177$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $93 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($93 | 0, i64toi32_i32$2 | 0, 21 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $180 = i64toi32_i32$5;
  $180$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$5 = $180$hi;
  i64toi32_i32$3 = $180;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $181 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $181$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($9 | 0, i64toi32_i32$5 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $183 = i64toi32_i32$0;
  $183$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $181$hi;
  i64toi32_i32$2 = $181;
  i64toi32_i32$0 = $183$hi;
  i64toi32_i32$3 = $183;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $184 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $184$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $186 = i64toi32_i32$2;
  $186$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $184$hi;
  i64toi32_i32$5 = $184;
  i64toi32_i32$2 = $186$hi;
  i64toi32_i32$3 = $186;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$5 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$2;
  return i64toi32_i32$5 | 0;
 }
 
 function hashbrown__map__make_insert_hash__he686a9e564c69811($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $8$hi = 0, $7$hi = 0, $7 = 0, $8 = 0, $9$hi = 0, $9 = 0, $10$hi = 0, $10 = 0, $11$hi = 0, $2 = 0, $11 = 0, $12$hi = 0, $12 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $92 = 0, $25 = 0, $30 = 0, $37 = 0, $45 = 0, $63 = 0, $63$hi = 0, $64 = 0, $64$hi = 0, $66$hi = 0, $71 = 0, $71$hi = 0, $77 = 0, $77$hi = 0, $82 = 0, $82$hi = 0, $86 = 0, $86$hi = 0, $89$hi = 0, $96 = 0, $96$hi = 0, $102 = 0, $102$hi = 0, $104 = 0, $104$hi = 0, $106$hi = 0, $112 = 0, $112$hi = 0, $118 = 0, $118$hi = 0, $121 = 0, $121$hi = 0, $122 = 0, $122$hi = 0, $124$hi = 0, $129 = 0, $129$hi = 0, $136 = 0, $136$hi = 0, $137 = 0, $137$hi = 0, $139$hi = 0, $144 = 0, $144$hi = 0, $151 = 0, $151$hi = 0, $152 = 0, $152$hi = 0, $154$hi = 0, $159 = 0, $159$hi = 0, $162$hi = 0, $164 = 0, $164$hi = 0, $166$hi = 0, $171 = 0, $171$hi = 0, $177$hi = 0, $93 = 0, $180 = 0, $180$hi = 0, $181 = 0, $181$hi = 0, $183 = 0, $183$hi = 0, $184 = 0, $184$hi = 0, $186 = 0, $186$hi = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  $3 = $2 + 56 | 0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = $2 + 40 | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = 1952801890;
  i64toi32_i32$3 = 2037671283;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $25 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $4;
  HEAP32[i64toi32_i32$2 >> 2] = $25;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  $5 = $2 + 32 | 0;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$1 = $7;
  i64toi32_i32$2 = 1685025377;
  i64toi32_i32$3 = 1852075885;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $30 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $5;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  $6 = $2 + 24 | 0;
  i64toi32_i32$0 = $0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$2;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$2 = 1819895653;
  i64toi32_i32$3 = 1852142177;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $37 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $6;
  HEAP32[i64toi32_i32$0 >> 2] = $37;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$0 = $2;
  i64toi32_i32$2 = 0;
  HEAP32[(i64toi32_i32$0 + 48 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 52 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = i64toi32_i32$1;
  HEAP32[i64toi32_i32$0 >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$1 = $8;
  i64toi32_i32$0 = 1936682341;
  i64toi32_i32$3 = 1886610805;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $45 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $2;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $45;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  $cardano_serialization_lib__metadata__TransactionMetadatumEnum_20as_20core__hash__Hash___hash__hfff2aa722e4e1880(HEAP32[$1 >> 2] | 0 | 0, i64toi32_i32$1 | 0);
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = 0;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] | 0;
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $6;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $12 = i64toi32_i32$1;
  $12$hi = i64toi32_i32$0;
  global$0 = i64toi32_i32$2 + 64 | 0;
  i64toi32_i32$0 = $10$hi;
  $63 = $10;
  $63$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  $64 = $9;
  $64$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$2 = $8;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $92 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $92 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $66$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $64$hi;
  i64toi32_i32$0 = $64;
  i64toi32_i32$2 = $66$hi;
  i64toi32_i32$3 = $92;
  i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
  $8 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $63$hi;
  i64toi32_i32$1 = $63;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $9 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($9 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $71 = i64toi32_i32$1;
  $71$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$4;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $71$hi;
  i64toi32_i32$0 = $71;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$2;
  $77 = $10;
  $77$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$5 = $7;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $82 = i64toi32_i32$5;
  $82$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $77$hi;
  i64toi32_i32$2 = $77;
  i64toi32_i32$5 = $82$hi;
  i64toi32_i32$3 = $82;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $12 = i64toi32_i32$0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $86 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $86$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($7 | 0, i64toi32_i32$2 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $89$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$2 = $89$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $8 = i64toi32_i32$5;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 17 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $96 = i64toi32_i32$2;
  $96$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$2 = $96$hi;
  i64toi32_i32$3 = $96;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $86$hi;
  i64toi32_i32$0 = $86;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $102 = i64toi32_i32$0;
  $102$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = $102$hi;
  i64toi32_i32$3 = $102;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $7 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$0;
  $104 = $7;
  $104$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($10 | 0, i64toi32_i32$0 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $106$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$0 = $106$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $10$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($8 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 255;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $112 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $112$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$2 = $10;
  i64toi32_i32$0 = $112$hi;
  i64toi32_i32$3 = $112;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $8 = i64toi32_i32$4;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $104$hi;
  i64toi32_i32$5 = $104;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$0;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 17 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $118 = i64toi32_i32$5;
  $118$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$5 = $118$hi;
  i64toi32_i32$3 = $118;
  i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
  $7 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$5;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $121 = i64toi32_i32$1;
  $121$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  $122 = $7;
  $122$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$5 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $124$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $8$hi;
  i64toi32_i32$5 = $124$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $8 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($9 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $129 = i64toi32_i32$4;
  $129$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$5 = $8;
  i64toi32_i32$4 = $129$hi;
  i64toi32_i32$3 = $129;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $9 = i64toi32_i32$2;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $122$hi;
  i64toi32_i32$1 = $122;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$4;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $121$hi;
  i64toi32_i32$0 = $121;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($10 | 0, i64toi32_i32$1 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $136 = i64toi32_i32$0;
  $136$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $10$hi;
  $137 = $10;
  $137$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($8 | 0, i64toi32_i32$1 | 0, 21 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $139$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$1 = $139$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $8 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $144 = i64toi32_i32$2;
  $144$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$1 = $8;
  i64toi32_i32$2 = $144$hi;
  i64toi32_i32$3 = $144;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $9 = i64toi32_i32$5;
  $9$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $137$hi;
  i64toi32_i32$0 = $137;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $10 = i64toi32_i32$2;
  $10$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $136$hi;
  i64toi32_i32$4 = $136;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $11 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $151 = i64toi32_i32$4;
  $151$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  $152 = $11;
  $152$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($8 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $154$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $154$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $8 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $159 = i64toi32_i32$5;
  $159$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$0 = $8;
  i64toi32_i32$5 = $159$hi;
  i64toi32_i32$3 = $159;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$1;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $152$hi;
  i64toi32_i32$4 = $152;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $162$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $151$hi;
  i64toi32_i32$2 = $151;
  i64toi32_i32$4 = $162$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $9 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $9$hi = i64toi32_i32$4;
  $164 = $9;
  $164$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($8 | 0, i64toi32_i32$4 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $166$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$4 = $166$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $171 = i64toi32_i32$1;
  $171$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = $7;
  i64toi32_i32$1 = $171$hi;
  i64toi32_i32$3 = $171;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $164$hi;
  i64toi32_i32$2 = $164;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $10 = i64toi32_i32$1;
  $10$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $177$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$0 = $177$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $93 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($93 | 0, i64toi32_i32$2 | 0, 21 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $180 = i64toi32_i32$5;
  $180$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$5 = $180$hi;
  i64toi32_i32$3 = $180;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $181 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $181$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($9 | 0, i64toi32_i32$5 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $183 = i64toi32_i32$0;
  $183$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $181$hi;
  i64toi32_i32$2 = $181;
  i64toi32_i32$0 = $183$hi;
  i64toi32_i32$3 = $183;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $184 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $184$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $186 = i64toi32_i32$2;
  $186$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $184$hi;
  i64toi32_i32$5 = $184;
  i64toi32_i32$2 = $186$hi;
  i64toi32_i32$3 = $186;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$5 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$2;
  return i64toi32_i32$5 | 0;
 }
 
 function hashbrown__map__make_hash__h98d8394e57bcc228($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $8$hi = 0, $7$hi = 0, $7 = 0, $8 = 0, $9$hi = 0, $9 = 0, $10$hi = 0, $10 = 0, $11$hi = 0, $2 = 0, $11 = 0, $12$hi = 0, $12 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $92 = 0, $25 = 0, $30 = 0, $37 = 0, $45 = 0, $63 = 0, $63$hi = 0, $64 = 0, $64$hi = 0, $66$hi = 0, $71 = 0, $71$hi = 0, $77 = 0, $77$hi = 0, $82 = 0, $82$hi = 0, $86 = 0, $86$hi = 0, $89$hi = 0, $96 = 0, $96$hi = 0, $102 = 0, $102$hi = 0, $104 = 0, $104$hi = 0, $106$hi = 0, $112 = 0, $112$hi = 0, $118 = 0, $118$hi = 0, $121 = 0, $121$hi = 0, $122 = 0, $122$hi = 0, $124$hi = 0, $129 = 0, $129$hi = 0, $136 = 0, $136$hi = 0, $137 = 0, $137$hi = 0, $139$hi = 0, $144 = 0, $144$hi = 0, $151 = 0, $151$hi = 0, $152 = 0, $152$hi = 0, $154$hi = 0, $159 = 0, $159$hi = 0, $162$hi = 0, $164 = 0, $164$hi = 0, $166$hi = 0, $171 = 0, $171$hi = 0, $177$hi = 0, $93 = 0, $180 = 0, $180$hi = 0, $181 = 0, $181$hi = 0, $183 = 0, $183$hi = 0, $184 = 0, $184$hi = 0, $186 = 0, $186$hi = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  $3 = $2 + 56 | 0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = $2 + 40 | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = 1952801890;
  i64toi32_i32$3 = 2037671283;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $25 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $4;
  HEAP32[i64toi32_i32$2 >> 2] = $25;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  $5 = $2 + 32 | 0;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$1 = $7;
  i64toi32_i32$2 = 1685025377;
  i64toi32_i32$3 = 1852075885;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $30 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $5;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  $6 = $2 + 24 | 0;
  i64toi32_i32$0 = $0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$2;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$2 = 1819895653;
  i64toi32_i32$3 = 1852142177;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $37 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $6;
  HEAP32[i64toi32_i32$0 >> 2] = $37;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$0 = $2;
  i64toi32_i32$2 = 0;
  HEAP32[(i64toi32_i32$0 + 48 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 52 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = i64toi32_i32$1;
  HEAP32[i64toi32_i32$0 >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$1 = $8;
  i64toi32_i32$0 = 1936682341;
  i64toi32_i32$3 = 1886610805;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $45 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $2;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $45;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  $cardano_serialization_lib__address__StakeCredType_20as_20core__hash__Hash___hash__he9f79766a5c45cf6(HEAP32[$1 >> 2] | 0 | 0, i64toi32_i32$1 | 0);
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = 0;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] | 0;
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $6;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $12 = i64toi32_i32$1;
  $12$hi = i64toi32_i32$0;
  global$0 = i64toi32_i32$2 + 64 | 0;
  i64toi32_i32$0 = $10$hi;
  $63 = $10;
  $63$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  $64 = $9;
  $64$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$2 = $8;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $92 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $92 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $66$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $64$hi;
  i64toi32_i32$0 = $64;
  i64toi32_i32$2 = $66$hi;
  i64toi32_i32$3 = $92;
  i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
  $8 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $63$hi;
  i64toi32_i32$1 = $63;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $9 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($9 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $71 = i64toi32_i32$1;
  $71$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$4;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $71$hi;
  i64toi32_i32$0 = $71;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$2;
  $77 = $10;
  $77$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$5 = $7;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $82 = i64toi32_i32$5;
  $82$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $77$hi;
  i64toi32_i32$2 = $77;
  i64toi32_i32$5 = $82$hi;
  i64toi32_i32$3 = $82;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $12 = i64toi32_i32$0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $86 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $86$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($7 | 0, i64toi32_i32$2 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $89$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$2 = $89$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $8 = i64toi32_i32$5;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 17 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $96 = i64toi32_i32$2;
  $96$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$2 = $96$hi;
  i64toi32_i32$3 = $96;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $86$hi;
  i64toi32_i32$0 = $86;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $102 = i64toi32_i32$0;
  $102$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = $102$hi;
  i64toi32_i32$3 = $102;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $7 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$0;
  $104 = $7;
  $104$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($10 | 0, i64toi32_i32$0 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $106$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$0 = $106$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $10$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($8 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 255;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $112 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $112$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$2 = $10;
  i64toi32_i32$0 = $112$hi;
  i64toi32_i32$3 = $112;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $8 = i64toi32_i32$4;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $104$hi;
  i64toi32_i32$5 = $104;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$0;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 17 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $118 = i64toi32_i32$5;
  $118$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$5 = $118$hi;
  i64toi32_i32$3 = $118;
  i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
  $7 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$5;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $121 = i64toi32_i32$1;
  $121$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  $122 = $7;
  $122$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$5 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $124$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $8$hi;
  i64toi32_i32$5 = $124$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $8 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($9 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $129 = i64toi32_i32$4;
  $129$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$5 = $8;
  i64toi32_i32$4 = $129$hi;
  i64toi32_i32$3 = $129;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $9 = i64toi32_i32$2;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $122$hi;
  i64toi32_i32$1 = $122;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$4;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $121$hi;
  i64toi32_i32$0 = $121;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($10 | 0, i64toi32_i32$1 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $136 = i64toi32_i32$0;
  $136$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $10$hi;
  $137 = $10;
  $137$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($8 | 0, i64toi32_i32$1 | 0, 21 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $139$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$1 = $139$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $8 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $144 = i64toi32_i32$2;
  $144$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$1 = $8;
  i64toi32_i32$2 = $144$hi;
  i64toi32_i32$3 = $144;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $9 = i64toi32_i32$5;
  $9$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $137$hi;
  i64toi32_i32$0 = $137;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $10 = i64toi32_i32$2;
  $10$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $136$hi;
  i64toi32_i32$4 = $136;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $11 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $151 = i64toi32_i32$4;
  $151$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  $152 = $11;
  $152$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($8 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $154$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $154$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $8 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $159 = i64toi32_i32$5;
  $159$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$0 = $8;
  i64toi32_i32$5 = $159$hi;
  i64toi32_i32$3 = $159;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$1;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $152$hi;
  i64toi32_i32$4 = $152;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $162$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $151$hi;
  i64toi32_i32$2 = $151;
  i64toi32_i32$4 = $162$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $9 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $9$hi = i64toi32_i32$4;
  $164 = $9;
  $164$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($8 | 0, i64toi32_i32$4 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $166$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$4 = $166$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $171 = i64toi32_i32$1;
  $171$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = $7;
  i64toi32_i32$1 = $171$hi;
  i64toi32_i32$3 = $171;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $164$hi;
  i64toi32_i32$2 = $164;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $10 = i64toi32_i32$1;
  $10$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $177$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$0 = $177$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $93 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($93 | 0, i64toi32_i32$2 | 0, 21 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $180 = i64toi32_i32$5;
  $180$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$5 = $180$hi;
  i64toi32_i32$3 = $180;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $181 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $181$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($9 | 0, i64toi32_i32$5 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $183 = i64toi32_i32$0;
  $183$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $181$hi;
  i64toi32_i32$2 = $181;
  i64toi32_i32$0 = $183$hi;
  i64toi32_i32$3 = $183;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $184 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $184$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $186 = i64toi32_i32$2;
  $186$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $184$hi;
  i64toi32_i32$5 = $184;
  i64toi32_i32$2 = $186$hi;
  i64toi32_i32$3 = $186;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$5 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$2;
  return i64toi32_i32$5 | 0;
 }
 
 function hashbrown__map__make_hash__hc29185c590e608df($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $8$hi = 0, $7$hi = 0, $7 = 0, $8 = 0, $9$hi = 0, $9 = 0, $10$hi = 0, $10 = 0, $11$hi = 0, $2 = 0, $11 = 0, $12$hi = 0, $12 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $92 = 0, $25 = 0, $30 = 0, $37 = 0, $45 = 0, $63 = 0, $63$hi = 0, $64 = 0, $64$hi = 0, $66$hi = 0, $71 = 0, $71$hi = 0, $77 = 0, $77$hi = 0, $82 = 0, $82$hi = 0, $86 = 0, $86$hi = 0, $89$hi = 0, $96 = 0, $96$hi = 0, $102 = 0, $102$hi = 0, $104 = 0, $104$hi = 0, $106$hi = 0, $112 = 0, $112$hi = 0, $118 = 0, $118$hi = 0, $121 = 0, $121$hi = 0, $122 = 0, $122$hi = 0, $124$hi = 0, $129 = 0, $129$hi = 0, $136 = 0, $136$hi = 0, $137 = 0, $137$hi = 0, $139$hi = 0, $144 = 0, $144$hi = 0, $151 = 0, $151$hi = 0, $152 = 0, $152$hi = 0, $154$hi = 0, $159 = 0, $159$hi = 0, $162$hi = 0, $164 = 0, $164$hi = 0, $166$hi = 0, $171 = 0, $171$hi = 0, $177$hi = 0, $93 = 0, $180 = 0, $180$hi = 0, $181 = 0, $181$hi = 0, $183 = 0, $183$hi = 0, $184 = 0, $184$hi = 0, $186 = 0, $186$hi = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  $3 = $2 + 56 | 0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = $2 + 40 | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = 1952801890;
  i64toi32_i32$3 = 2037671283;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $25 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $4;
  HEAP32[i64toi32_i32$2 >> 2] = $25;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  $5 = $2 + 32 | 0;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$1 = $7;
  i64toi32_i32$2 = 1685025377;
  i64toi32_i32$3 = 1852075885;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $30 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $5;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  $6 = $2 + 24 | 0;
  i64toi32_i32$0 = $0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$2;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$2 = 1819895653;
  i64toi32_i32$3 = 1852142177;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $37 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $6;
  HEAP32[i64toi32_i32$0 >> 2] = $37;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$0 = $2;
  i64toi32_i32$2 = 0;
  HEAP32[(i64toi32_i32$0 + 48 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 52 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = i64toi32_i32$1;
  HEAP32[i64toi32_i32$0 >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$1 = $8;
  i64toi32_i32$0 = 1936682341;
  i64toi32_i32$3 = 1886610805;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $45 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $2;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $45;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  $cardano_serialization_lib__metadata__TransactionMetadatumEnum_20as_20core__hash__Hash___hash__hfff2aa722e4e1880(HEAP32[$1 >> 2] | 0 | 0, i64toi32_i32$1 | 0);
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = 0;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] | 0;
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $6;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $12 = i64toi32_i32$1;
  $12$hi = i64toi32_i32$0;
  global$0 = i64toi32_i32$2 + 64 | 0;
  i64toi32_i32$0 = $10$hi;
  $63 = $10;
  $63$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  $64 = $9;
  $64$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$2 = $8;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $92 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $92 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $66$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $64$hi;
  i64toi32_i32$0 = $64;
  i64toi32_i32$2 = $66$hi;
  i64toi32_i32$3 = $92;
  i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
  $8 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $63$hi;
  i64toi32_i32$1 = $63;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $9 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($9 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $71 = i64toi32_i32$1;
  $71$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$4;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $71$hi;
  i64toi32_i32$0 = $71;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$2;
  $77 = $10;
  $77$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$5 = $7;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $82 = i64toi32_i32$5;
  $82$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $77$hi;
  i64toi32_i32$2 = $77;
  i64toi32_i32$5 = $82$hi;
  i64toi32_i32$3 = $82;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $12 = i64toi32_i32$0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $86 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $86$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($7 | 0, i64toi32_i32$2 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $89$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$2 = $89$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $8 = i64toi32_i32$5;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 17 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $96 = i64toi32_i32$2;
  $96$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$2 = $96$hi;
  i64toi32_i32$3 = $96;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $86$hi;
  i64toi32_i32$0 = $86;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $102 = i64toi32_i32$0;
  $102$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = $102$hi;
  i64toi32_i32$3 = $102;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $7 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$0;
  $104 = $7;
  $104$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($10 | 0, i64toi32_i32$0 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $106$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$0 = $106$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $10$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($8 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 255;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $112 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $112$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$2 = $10;
  i64toi32_i32$0 = $112$hi;
  i64toi32_i32$3 = $112;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $8 = i64toi32_i32$4;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $104$hi;
  i64toi32_i32$5 = $104;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$0;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 17 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $118 = i64toi32_i32$5;
  $118$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$5 = $118$hi;
  i64toi32_i32$3 = $118;
  i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
  $7 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$5;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $121 = i64toi32_i32$1;
  $121$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  $122 = $7;
  $122$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$5 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $124$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $8$hi;
  i64toi32_i32$5 = $124$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $8 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($9 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $129 = i64toi32_i32$4;
  $129$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$5 = $8;
  i64toi32_i32$4 = $129$hi;
  i64toi32_i32$3 = $129;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $9 = i64toi32_i32$2;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $122$hi;
  i64toi32_i32$1 = $122;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$4;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $121$hi;
  i64toi32_i32$0 = $121;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($10 | 0, i64toi32_i32$1 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $136 = i64toi32_i32$0;
  $136$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $10$hi;
  $137 = $10;
  $137$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($8 | 0, i64toi32_i32$1 | 0, 21 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $139$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$1 = $139$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $8 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $144 = i64toi32_i32$2;
  $144$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$1 = $8;
  i64toi32_i32$2 = $144$hi;
  i64toi32_i32$3 = $144;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $9 = i64toi32_i32$5;
  $9$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $137$hi;
  i64toi32_i32$0 = $137;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $10 = i64toi32_i32$2;
  $10$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $136$hi;
  i64toi32_i32$4 = $136;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $11 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $151 = i64toi32_i32$4;
  $151$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  $152 = $11;
  $152$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($8 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $154$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $154$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $8 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $159 = i64toi32_i32$5;
  $159$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$0 = $8;
  i64toi32_i32$5 = $159$hi;
  i64toi32_i32$3 = $159;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$1;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $152$hi;
  i64toi32_i32$4 = $152;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $162$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $151$hi;
  i64toi32_i32$2 = $151;
  i64toi32_i32$4 = $162$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $9 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $9$hi = i64toi32_i32$4;
  $164 = $9;
  $164$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($8 | 0, i64toi32_i32$4 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $166$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$4 = $166$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $171 = i64toi32_i32$1;
  $171$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = $7;
  i64toi32_i32$1 = $171$hi;
  i64toi32_i32$3 = $171;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $164$hi;
  i64toi32_i32$2 = $164;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $10 = i64toi32_i32$1;
  $10$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $177$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$0 = $177$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $93 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($93 | 0, i64toi32_i32$2 | 0, 21 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $180 = i64toi32_i32$5;
  $180$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$5 = $180$hi;
  i64toi32_i32$3 = $180;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $181 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $181$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($9 | 0, i64toi32_i32$5 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $183 = i64toi32_i32$0;
  $183$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $181$hi;
  i64toi32_i32$2 = $181;
  i64toi32_i32$0 = $183$hi;
  i64toi32_i32$3 = $183;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $184 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $184$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $186 = i64toi32_i32$2;
  $186$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $184$hi;
  i64toi32_i32$5 = $184;
  i64toi32_i32$2 = $186$hi;
  i64toi32_i32$3 = $186;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$5 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$2;
  return i64toi32_i32$5 | 0;
 }
 
 function cryptoxide__curve25519__fe__fe64__Fe__from_bytes__h171daceb70a08089($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $14 = 0, $14$hi = 0, $20 = 0, $20$hi = 0, $21 = 0, $21$hi = 0, $24 = 0, $24$hi = 0, $156 = 0, $157 = 0, $159 = 0, $160 = 0, $161 = 0, $162 = 0, $166 = 0, $167 = 0, $169 = 0, $170 = 0, $172 = 0, $173 = 0, $175 = 0, $176 = 0, $178 = 0, $179 = 0, $181 = 0, $182 = 0, $184 = 0, $185 = 0, $186 = 0, $187 = 0, $189 = 0, $190 = 0, $191 = 0, $192 = 0, $193 = 0, $194 = 0, $195 = 0, $196 = 0, $197 = 0, $198 = 0, $199 = 0, $2 = 0, $2$hi = 0, $3 = 0, $3$hi = 0, $4 = 0, $4$hi = 0, $5 = 0, $5$hi = 0, $6 = 0, $6$hi = 0, $7 = 0, $7$hi = 0, $8 = 0, $8$hi = 0, $9 = 0, $9$hi = 0, $10 = 0, $10$hi = 0, $11 = 0, $11$hi = 0, $12 = 0, $12$hi = 0, $13 = 0, $13$hi = 0, $15 = 0, $15$hi = 0, $16 = 0, $16$hi = 0, $17 = 0, $17$hi = 0, $18 = 0, $18$hi = 0, $19 = 0, $19$hi = 0, $22 = 0, $22$hi = 0, $23 = 0, $23$hi = 0, $25 = 0, $25$hi = 0, $26 = 0, $26$hi = 0, $78 = 0, $80 = 0, $80$hi = 0, $83$hi = 0, $84 = 0, $84$hi = 0, $87$hi = 0, $88 = 0, $88$hi = 0, $27 = 0, $27$hi = 0, $92$hi = 0, $94 = 0, $95 = 0, $96 = 0, $96$hi = 0, $98$hi = 0, $99 = 0, $99$hi = 0, $101$hi = 0, $102 = 0, $102$hi = 0, $104$hi = 0, $105 = 0, $105$hi = 0, $107$hi = 0, $108 = 0, $108$hi = 0, $110$hi = 0, $111 = 0, $111$hi = 0, $113$hi = 0, $116 = 0, $117 = 0, $118 = 0, $118$hi = 0, $120$hi = 0, $121 = 0, $121$hi = 0, $123$hi = 0, $124 = 0, $124$hi = 0, $126$hi = 0, $127 = 0, $127$hi = 0, $129$hi = 0, $130 = 0, $130$hi = 0, $132$hi = 0, $133 = 0, $133$hi = 0, $135$hi = 0, $138 = 0, $139 = 0, $140 = 0, $140$hi = 0, $142$hi = 0, $143 = 0, $143$hi = 0, $145$hi = 0, $146 = 0, $146$hi = 0, $148$hi = 0, $149 = 0, $149$hi = 0, $151$hi = 0, $152 = 0, $152$hi = 0, $154$hi = 0, $155 = 0, $155$hi = 0, $157$hi = 0, $158 = 0, $158$hi = 0, $160$hi = 0, $163 = 0, $164 = 0, $165 = 0, $165$hi = 0, $167$hi = 0, $168 = 0, $168$hi = 0, $170$hi = 0, $171 = 0, $171$hi = 0, $173$hi = 0, $174 = 0, $174$hi = 0, $176$hi = 0, $177 = 0, $177$hi = 0, $179$hi = 0, $180 = 0, $180$hi = 0, $182$hi = 0, $183 = 0, $183$hi = 0, $185$hi = 0, $188 = 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 18 | 0) >> 0] | 0;
  i64toi32_i32$1 = 0;
  $2 = i64toi32_i32$0;
  $2$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 17 | 0) >> 0] | 0;
  i64toi32_i32$0 = 0;
  $3 = i64toi32_i32$1;
  $3$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 16 | 0) >> 0] | 0;
  i64toi32_i32$1 = 0;
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 15 | 0) >> 0] | 0;
  i64toi32_i32$0 = 0;
  $5 = i64toi32_i32$1;
  $5$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 13 | 0) >> 0] | 0;
  i64toi32_i32$1 = 0;
  $6 = i64toi32_i32$0;
  $6$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 14 | 0) >> 0] | 0;
  i64toi32_i32$0 = 0;
  $7 = i64toi32_i32$1;
  $7$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 31 | 0) >> 0] | 0;
  i64toi32_i32$1 = 0;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 30 | 0) >> 0] | 0;
  i64toi32_i32$0 = 0;
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 29 | 0) >> 0] | 0;
  i64toi32_i32$1 = 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 28 | 0) >> 0] | 0;
  i64toi32_i32$0 = 0;
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 27 | 0) >> 0] | 0;
  i64toi32_i32$1 = 0;
  $12 = i64toi32_i32$0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 26 | 0) >> 0] | 0;
  i64toi32_i32$0 = 0;
  $13 = i64toi32_i32$1;
  $13$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 12 | 0) >> 0] | 0;
  i64toi32_i32$1 = 0;
  $14 = i64toi32_i32$0;
  $14$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 11 | 0) >> 0] | 0;
  i64toi32_i32$0 = 0;
  $15 = i64toi32_i32$1;
  $15$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 10 | 0) >> 0] | 0;
  i64toi32_i32$1 = 0;
  $16 = i64toi32_i32$0;
  $16$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 9 | 0) >> 0] | 0;
  i64toi32_i32$0 = 0;
  $17 = i64toi32_i32$1;
  $17$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0;
  i64toi32_i32$1 = 0;
  $18 = i64toi32_i32$0;
  $18$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0;
  i64toi32_i32$0 = 0;
  $19 = i64toi32_i32$1;
  $19$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 25 | 0) >> 0] | 0;
  i64toi32_i32$1 = 0;
  $20 = i64toi32_i32$0;
  $20$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 24 | 0) >> 0] | 0;
  i64toi32_i32$0 = 0;
  $21 = i64toi32_i32$1;
  $21$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 23 | 0) >> 0] | 0;
  i64toi32_i32$1 = 0;
  $22 = i64toi32_i32$0;
  $22$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 22 | 0) >> 0] | 0;
  i64toi32_i32$0 = 0;
  $23 = i64toi32_i32$1;
  $23$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 19 | 0) >> 0] | 0;
  i64toi32_i32$1 = 0;
  $24 = i64toi32_i32$0;
  $24$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 20 | 0) >> 0] | 0;
  i64toi32_i32$0 = 0;
  $25 = i64toi32_i32$1;
  $25$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 21 | 0) >> 0] | 0;
  i64toi32_i32$1 = 0;
  $26 = i64toi32_i32$0;
  $26$hi = i64toi32_i32$1;
  $78 = $0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = 0;
  $80 = i64toi32_i32$1;
  $80$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $156 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $156 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $83$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $80$hi;
  i64toi32_i32$1 = $80;
  i64toi32_i32$2 = $83$hi;
  i64toi32_i32$3 = $156;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  $84 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  $84$hi = i64toi32_i32$2;
  i64toi32_i32$0 = $1;
  i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 5 | 0) >> 0] | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 40;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   $157 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $157 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
  }
  $87$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $84$hi;
  i64toi32_i32$1 = $84;
  i64toi32_i32$0 = $87$hi;
  i64toi32_i32$3 = $157;
  i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
  $88 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  $88$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0;
  i64toi32_i32$1 = 0;
  $27 = i64toi32_i32$0;
  $27$hi = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 48;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $159 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $159 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $92$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $88$hi;
  i64toi32_i32$1 = $88;
  i64toi32_i32$2 = $92$hi;
  i64toi32_i32$3 = $159;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  i64toi32_i32$1 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
  $94 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $78;
  HEAP32[i64toi32_i32$0 >> 2] = $94;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $95 = $0;
  i64toi32_i32$1 = $24$hi;
  $96 = $24;
  $96$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $25$hi;
  i64toi32_i32$2 = $25;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 8;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $160 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $160 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $98$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $96$hi;
  i64toi32_i32$1 = $96;
  i64toi32_i32$2 = $98$hi;
  i64toi32_i32$3 = $160;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  $99 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  $99$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $26$hi;
  i64toi32_i32$0 = $26;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 16;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   $161 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
   $161 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
  }
  $101$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $99$hi;
  i64toi32_i32$2 = $99;
  i64toi32_i32$0 = $101$hi;
  i64toi32_i32$3 = $161;
  i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
  $102 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  $102$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $23$hi;
  i64toi32_i32$1 = $23;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 24;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
   $162 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $162 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
  }
  $104$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $102$hi;
  i64toi32_i32$0 = $102;
  i64toi32_i32$1 = $104$hi;
  i64toi32_i32$3 = $162;
  i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
  $105 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $105$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $22$hi;
  i64toi32_i32$2 = $22;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $166 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $166 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $107$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $105$hi;
  i64toi32_i32$1 = $105;
  i64toi32_i32$2 = $107$hi;
  i64toi32_i32$3 = $166;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  $108 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  $108$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $21$hi;
  i64toi32_i32$0 = $21;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 40;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   $167 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
   $167 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
  }
  $110$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $108$hi;
  i64toi32_i32$2 = $108;
  i64toi32_i32$0 = $110$hi;
  i64toi32_i32$3 = $167;
  i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
  $111 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  $111$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $20$hi;
  i64toi32_i32$1 = $20;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 48;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
   $169 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $169 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
  }
  $113$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $111$hi;
  i64toi32_i32$0 = $111;
  i64toi32_i32$1 = $113$hi;
  i64toi32_i32$3 = $169;
  i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 1;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $170 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   $170 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  i64toi32_i32$1 = $170;
  i64toi32_i32$2 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
  $116 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $95;
  HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = $116;
  HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = i64toi32_i32$2;
  $117 = $0;
  i64toi32_i32$2 = $27$hi;
  $118 = $27;
  $118$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $18$hi;
  i64toi32_i32$0 = $18;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 8;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   $172 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
   $172 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
  }
  $120$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $118$hi;
  i64toi32_i32$2 = $118;
  i64toi32_i32$0 = $120$hi;
  i64toi32_i32$3 = $172;
  i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
  $121 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  $121$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $19$hi;
  i64toi32_i32$1 = $19;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 16;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
   $173 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $173 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
  }
  $123$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $121$hi;
  i64toi32_i32$0 = $121;
  i64toi32_i32$1 = $123$hi;
  i64toi32_i32$3 = $173;
  i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
  $124 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $124$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $17$hi;
  i64toi32_i32$2 = $17;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 24;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $175 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $175 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $126$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $124$hi;
  i64toi32_i32$1 = $124;
  i64toi32_i32$2 = $126$hi;
  i64toi32_i32$3 = $175;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  $127 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  $127$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $16$hi;
  i64toi32_i32$0 = $16;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   $176 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
   $176 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
  }
  $129$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $127$hi;
  i64toi32_i32$2 = $127;
  i64toi32_i32$0 = $129$hi;
  i64toi32_i32$3 = $176;
  i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
  $130 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  $130$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $15$hi;
  i64toi32_i32$1 = $15;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 40;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
   $178 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $178 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
  }
  $132$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $130$hi;
  i64toi32_i32$0 = $130;
  i64toi32_i32$1 = $132$hi;
  i64toi32_i32$3 = $178;
  i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
  $133 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $133$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $14$hi;
  i64toi32_i32$2 = $14;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 48;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $179 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $179 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $135$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $133$hi;
  i64toi32_i32$1 = $133;
  i64toi32_i32$2 = $135$hi;
  i64toi32_i32$3 = $179;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 3;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $181 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   $181 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
  }
  i64toi32_i32$2 = $181;
  i64toi32_i32$0 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$0 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
  $138 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $117;
  HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $138;
  HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$0;
  $139 = $0;
  i64toi32_i32$0 = $21$hi;
  $140 = $21;
  $140$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $20$hi;
  i64toi32_i32$1 = $20;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 8;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
   $182 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $182 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
  }
  $142$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $140$hi;
  i64toi32_i32$0 = $140;
  i64toi32_i32$1 = $142$hi;
  i64toi32_i32$3 = $182;
  i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
  $143 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $143$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $13$hi;
  i64toi32_i32$2 = $13;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 16;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $184 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $184 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $145$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $143$hi;
  i64toi32_i32$1 = $143;
  i64toi32_i32$2 = $145$hi;
  i64toi32_i32$3 = $184;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  $146 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  $146$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$0 = $12;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 24;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   $185 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
   $185 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
  }
  $148$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $146$hi;
  i64toi32_i32$2 = $146;
  i64toi32_i32$0 = $148$hi;
  i64toi32_i32$3 = $185;
  i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
  $149 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  $149$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$1 = $11;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
   $186 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $186 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
  }
  $151$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $149$hi;
  i64toi32_i32$0 = $149;
  i64toi32_i32$1 = $151$hi;
  i64toi32_i32$3 = $186;
  i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
  $152 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $152$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $10$hi;
  i64toi32_i32$2 = $10;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 40;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $187 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $187 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $154$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $152$hi;
  i64toi32_i32$1 = $152;
  i64toi32_i32$2 = $154$hi;
  i64toi32_i32$3 = $187;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  $155 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  $155$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$0 = $9;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 48;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   $189 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
   $189 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
  }
  $157$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $155$hi;
  i64toi32_i32$2 = $155;
  i64toi32_i32$0 = $157$hi;
  i64toi32_i32$3 = $189;
  i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
  $158 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  $158$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$1 = $8;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
   $190 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $190 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
  }
  $160$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $158$hi;
  i64toi32_i32$0 = $158;
  i64toi32_i32$1 = $160$hi;
  i64toi32_i32$3 = $190;
  i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 12;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $191 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   $191 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  i64toi32_i32$1 = $191;
  i64toi32_i32$2 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
  $163 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $139;
  HEAP32[(i64toi32_i32$1 + 32 | 0) >> 2] = $163;
  HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] = i64toi32_i32$2;
  $164 = $0;
  i64toi32_i32$2 = $14$hi;
  $165 = $14;
  $165$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $6$hi;
  i64toi32_i32$0 = $6;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 8;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   $192 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
   $192 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
  }
  $167$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $165$hi;
  i64toi32_i32$2 = $165;
  i64toi32_i32$0 = $167$hi;
  i64toi32_i32$3 = $192;
  i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
  $168 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  $168$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$1 = $7;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 16;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
   $193 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $193 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
  }
  $170$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $168$hi;
  i64toi32_i32$0 = $168;
  i64toi32_i32$1 = $170$hi;
  i64toi32_i32$3 = $193;
  i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
  $171 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $171$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $5$hi;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 24;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $194 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $194 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $173$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $171$hi;
  i64toi32_i32$1 = $171;
  i64toi32_i32$2 = $173$hi;
  i64toi32_i32$3 = $194;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  $174 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  $174$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$0 = $4;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   $195 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
   $195 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
  }
  $176$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $174$hi;
  i64toi32_i32$2 = $174;
  i64toi32_i32$0 = $176$hi;
  i64toi32_i32$3 = $195;
  i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
  $177 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  $177$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $3$hi;
  i64toi32_i32$1 = $3;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 40;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
   $196 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $196 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
  }
  $179$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $177$hi;
  i64toi32_i32$0 = $177;
  i64toi32_i32$1 = $179$hi;
  i64toi32_i32$3 = $196;
  i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
  $180 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $180$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $2$hi;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 48;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $197 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $197 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $182$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $180$hi;
  i64toi32_i32$1 = $180;
  i64toi32_i32$2 = $182$hi;
  i64toi32_i32$3 = $197;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  $183 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  $183$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $24$hi;
  i64toi32_i32$0 = $24;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   $198 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
   $198 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
  }
  $185$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $183$hi;
  i64toi32_i32$2 = $183;
  i64toi32_i32$0 = $185$hi;
  i64toi32_i32$3 = $198;
  i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 6;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $199 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $199 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
  }
  i64toi32_i32$0 = $199;
  i64toi32_i32$1 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
  $188 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $164;
  HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $188;
  HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$1;
 }
 
 function hashbrown__map__make_hash__hd31a10d6b64a4e5e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $8$hi = 0, $7$hi = 0, $7 = 0, $8 = 0, $9$hi = 0, $9 = 0, $10$hi = 0, $10 = 0, $11$hi = 0, $2 = 0, $11 = 0, $12$hi = 0, $12 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $92 = 0, $25 = 0, $30 = 0, $37 = 0, $45 = 0, $62 = 0, $62$hi = 0, $63 = 0, $63$hi = 0, $65$hi = 0, $70 = 0, $70$hi = 0, $76 = 0, $76$hi = 0, $81 = 0, $81$hi = 0, $85 = 0, $85$hi = 0, $88$hi = 0, $95 = 0, $95$hi = 0, $101 = 0, $101$hi = 0, $103 = 0, $103$hi = 0, $105$hi = 0, $111 = 0, $111$hi = 0, $117 = 0, $117$hi = 0, $120 = 0, $120$hi = 0, $121 = 0, $121$hi = 0, $123$hi = 0, $128 = 0, $128$hi = 0, $135 = 0, $135$hi = 0, $136 = 0, $136$hi = 0, $138$hi = 0, $143 = 0, $143$hi = 0, $150 = 0, $150$hi = 0, $151 = 0, $151$hi = 0, $153$hi = 0, $158 = 0, $158$hi = 0, $161$hi = 0, $163 = 0, $163$hi = 0, $165$hi = 0, $170 = 0, $170$hi = 0, $176$hi = 0, $93 = 0, $179 = 0, $179$hi = 0, $180 = 0, $180$hi = 0, $182 = 0, $182$hi = 0, $183 = 0, $183$hi = 0, $185 = 0, $185$hi = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  $3 = $2 + 56 | 0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = $2 + 40 | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = 1952801890;
  i64toi32_i32$3 = 2037671283;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $25 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $4;
  HEAP32[i64toi32_i32$2 >> 2] = $25;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  $5 = $2 + 32 | 0;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$1 = $7;
  i64toi32_i32$2 = 1685025377;
  i64toi32_i32$3 = 1852075885;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $30 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $5;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  $6 = $2 + 24 | 0;
  i64toi32_i32$0 = $0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$2;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$2 = 1819895653;
  i64toi32_i32$3 = 1852142177;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $37 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $6;
  HEAP32[i64toi32_i32$0 >> 2] = $37;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$0 = $2;
  i64toi32_i32$2 = 0;
  HEAP32[(i64toi32_i32$0 + 48 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 52 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = i64toi32_i32$1;
  HEAP32[i64toi32_i32$0 >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$1 = $8;
  i64toi32_i32$0 = 1936682341;
  i64toi32_i32$3 = 1886610805;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $45 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $2;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $45;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  $cardano_serialization_lib__metadata__TransactionMetadatumEnum_20as_20core__hash__Hash___hash__hfff2aa722e4e1880($1 | 0, i64toi32_i32$1 | 0);
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = 0;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] | 0;
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $6;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $12 = i64toi32_i32$1;
  $12$hi = i64toi32_i32$0;
  global$0 = i64toi32_i32$2 + 64 | 0;
  i64toi32_i32$0 = $10$hi;
  $62 = $10;
  $62$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  $63 = $9;
  $63$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$2 = $8;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $92 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $92 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $65$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $63$hi;
  i64toi32_i32$0 = $63;
  i64toi32_i32$2 = $65$hi;
  i64toi32_i32$3 = $92;
  i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
  $8 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $62$hi;
  i64toi32_i32$1 = $62;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $9 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($9 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $70 = i64toi32_i32$1;
  $70$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$4;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $70$hi;
  i64toi32_i32$0 = $70;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$2;
  $76 = $10;
  $76$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$5 = $7;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $81 = i64toi32_i32$5;
  $81$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $76$hi;
  i64toi32_i32$2 = $76;
  i64toi32_i32$5 = $81$hi;
  i64toi32_i32$3 = $81;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $12 = i64toi32_i32$0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $85 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $85$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($7 | 0, i64toi32_i32$2 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $88$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$2 = $88$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $8 = i64toi32_i32$5;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 17 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $95 = i64toi32_i32$2;
  $95$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$2 = $95$hi;
  i64toi32_i32$3 = $95;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $85$hi;
  i64toi32_i32$0 = $85;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $101 = i64toi32_i32$0;
  $101$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = $101$hi;
  i64toi32_i32$3 = $101;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $7 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$0;
  $103 = $7;
  $103$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($10 | 0, i64toi32_i32$0 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $105$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$0 = $105$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $10$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($8 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 255;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $111 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $111$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$2 = $10;
  i64toi32_i32$0 = $111$hi;
  i64toi32_i32$3 = $111;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $8 = i64toi32_i32$4;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $103$hi;
  i64toi32_i32$5 = $103;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$0;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 17 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $117 = i64toi32_i32$5;
  $117$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$5 = $117$hi;
  i64toi32_i32$3 = $117;
  i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
  $7 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$5;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $120 = i64toi32_i32$1;
  $120$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  $121 = $7;
  $121$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$5 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $123$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $8$hi;
  i64toi32_i32$5 = $123$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $8 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($9 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $128 = i64toi32_i32$4;
  $128$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$5 = $8;
  i64toi32_i32$4 = $128$hi;
  i64toi32_i32$3 = $128;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $9 = i64toi32_i32$2;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $121$hi;
  i64toi32_i32$1 = $121;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$4;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $120$hi;
  i64toi32_i32$0 = $120;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($10 | 0, i64toi32_i32$1 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $135 = i64toi32_i32$0;
  $135$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $10$hi;
  $136 = $10;
  $136$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($8 | 0, i64toi32_i32$1 | 0, 21 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $138$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$1 = $138$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $8 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $143 = i64toi32_i32$2;
  $143$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$1 = $8;
  i64toi32_i32$2 = $143$hi;
  i64toi32_i32$3 = $143;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $9 = i64toi32_i32$5;
  $9$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $136$hi;
  i64toi32_i32$0 = $136;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $10 = i64toi32_i32$2;
  $10$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $135$hi;
  i64toi32_i32$4 = $135;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $11 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $150 = i64toi32_i32$4;
  $150$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  $151 = $11;
  $151$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($8 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $153$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $153$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $8 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $158 = i64toi32_i32$5;
  $158$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$0 = $8;
  i64toi32_i32$5 = $158$hi;
  i64toi32_i32$3 = $158;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$1;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $151$hi;
  i64toi32_i32$4 = $151;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $161$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $150$hi;
  i64toi32_i32$2 = $150;
  i64toi32_i32$4 = $161$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $9 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $9$hi = i64toi32_i32$4;
  $163 = $9;
  $163$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($8 | 0, i64toi32_i32$4 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $165$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$4 = $165$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $170 = i64toi32_i32$1;
  $170$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = $7;
  i64toi32_i32$1 = $170$hi;
  i64toi32_i32$3 = $170;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $163$hi;
  i64toi32_i32$2 = $163;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $10 = i64toi32_i32$1;
  $10$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $176$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$0 = $176$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $93 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($93 | 0, i64toi32_i32$2 | 0, 21 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $179 = i64toi32_i32$5;
  $179$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$5 = $179$hi;
  i64toi32_i32$3 = $179;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $180 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $180$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($9 | 0, i64toi32_i32$5 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $182 = i64toi32_i32$0;
  $182$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $180$hi;
  i64toi32_i32$2 = $180;
  i64toi32_i32$0 = $182$hi;
  i64toi32_i32$3 = $182;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $183 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $183$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $185 = i64toi32_i32$2;
  $185$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $183$hi;
  i64toi32_i32$5 = $183;
  i64toi32_i32$2 = $185$hi;
  i64toi32_i32$3 = $185;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$5 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$2;
  return i64toi32_i32$5 | 0;
 }
 
 function hashbrown__map__make_hash__h4a9465e979eb9ff6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $8$hi = 0, $7$hi = 0, $7 = 0, $8 = 0, $9$hi = 0, $9 = 0, $10$hi = 0, $10 = 0, $11$hi = 0, $2 = 0, $11 = 0, $12$hi = 0, $12 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $92 = 0, $25 = 0, $30 = 0, $37 = 0, $45 = 0, $62 = 0, $62$hi = 0, $63 = 0, $63$hi = 0, $65$hi = 0, $70 = 0, $70$hi = 0, $76 = 0, $76$hi = 0, $81 = 0, $81$hi = 0, $85 = 0, $85$hi = 0, $88$hi = 0, $95 = 0, $95$hi = 0, $101 = 0, $101$hi = 0, $103 = 0, $103$hi = 0, $105$hi = 0, $111 = 0, $111$hi = 0, $117 = 0, $117$hi = 0, $120 = 0, $120$hi = 0, $121 = 0, $121$hi = 0, $123$hi = 0, $128 = 0, $128$hi = 0, $135 = 0, $135$hi = 0, $136 = 0, $136$hi = 0, $138$hi = 0, $143 = 0, $143$hi = 0, $150 = 0, $150$hi = 0, $151 = 0, $151$hi = 0, $153$hi = 0, $158 = 0, $158$hi = 0, $161$hi = 0, $163 = 0, $163$hi = 0, $165$hi = 0, $170 = 0, $170$hi = 0, $176$hi = 0, $93 = 0, $179 = 0, $179$hi = 0, $180 = 0, $180$hi = 0, $182 = 0, $182$hi = 0, $183 = 0, $183$hi = 0, $185 = 0, $185$hi = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  $3 = $2 + 56 | 0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = $2 + 40 | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = 1952801890;
  i64toi32_i32$3 = 2037671283;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $25 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $4;
  HEAP32[i64toi32_i32$2 >> 2] = $25;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  $5 = $2 + 32 | 0;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$1 = $7;
  i64toi32_i32$2 = 1685025377;
  i64toi32_i32$3 = 1852075885;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $30 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $5;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  $6 = $2 + 24 | 0;
  i64toi32_i32$0 = $0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$2;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$2 = 1819895653;
  i64toi32_i32$3 = 1852142177;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $37 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $6;
  HEAP32[i64toi32_i32$0 >> 2] = $37;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$0 = $2;
  i64toi32_i32$2 = 0;
  HEAP32[(i64toi32_i32$0 + 48 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 52 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = i64toi32_i32$1;
  HEAP32[i64toi32_i32$0 >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$1 = $8;
  i64toi32_i32$0 = 1936682341;
  i64toi32_i32$3 = 1886610805;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $45 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $2;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $45;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  $cardano_serialization_lib__address__StakeCredType_20as_20core__hash__Hash___hash__he9f79766a5c45cf6($1 | 0, i64toi32_i32$1 | 0);
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = 0;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] | 0;
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $6;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $12 = i64toi32_i32$1;
  $12$hi = i64toi32_i32$0;
  global$0 = i64toi32_i32$2 + 64 | 0;
  i64toi32_i32$0 = $10$hi;
  $62 = $10;
  $62$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  $63 = $9;
  $63$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$2 = $8;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $92 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $92 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $65$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $63$hi;
  i64toi32_i32$0 = $63;
  i64toi32_i32$2 = $65$hi;
  i64toi32_i32$3 = $92;
  i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
  $8 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $62$hi;
  i64toi32_i32$1 = $62;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $9 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($9 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $70 = i64toi32_i32$1;
  $70$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$4;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $70$hi;
  i64toi32_i32$0 = $70;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$2;
  $76 = $10;
  $76$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$5 = $7;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $81 = i64toi32_i32$5;
  $81$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $76$hi;
  i64toi32_i32$2 = $76;
  i64toi32_i32$5 = $81$hi;
  i64toi32_i32$3 = $81;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $12 = i64toi32_i32$0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $85 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $85$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($7 | 0, i64toi32_i32$2 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $88$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$2 = $88$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $8 = i64toi32_i32$5;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 17 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $95 = i64toi32_i32$2;
  $95$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$2 = $95$hi;
  i64toi32_i32$3 = $95;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $85$hi;
  i64toi32_i32$0 = $85;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $101 = i64toi32_i32$0;
  $101$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = $101$hi;
  i64toi32_i32$3 = $101;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $7 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$0;
  $103 = $7;
  $103$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($10 | 0, i64toi32_i32$0 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $105$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$0 = $105$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $10 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $10$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($8 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 255;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $111 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $111$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$2 = $10;
  i64toi32_i32$0 = $111$hi;
  i64toi32_i32$3 = $111;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $8 = i64toi32_i32$4;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $103$hi;
  i64toi32_i32$5 = $103;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $11 = i64toi32_i32$0;
  $11$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 17 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $117 = i64toi32_i32$5;
  $117$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$5 = $117$hi;
  i64toi32_i32$3 = $117;
  i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
  $7 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$5;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($7 | 0, i64toi32_i32$5 | 0, 13 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $120 = i64toi32_i32$1;
  $120$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $7$hi;
  $121 = $7;
  $121$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$5 | 0, 16 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $123$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $8$hi;
  i64toi32_i32$5 = $123$hi;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $8 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($9 | 0, i64toi32_i32$1 | 0, 32 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $128 = i64toi32_i32$4;
  $128$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$5 = $8;
  i64toi32_i32$4 = $128$hi;
  i64toi32_i32$3 = $128;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $9 = i64toi32_i32$2;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $121$hi;
  i64toi32_i32$1 = $121;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$4;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $120$hi;
  i64toi32_i32$0 = $120;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
  $10 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($10 | 0, i64toi32_i32$1 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $135 = i64toi32_i32$0;
  $135$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $10$hi;
  $136 = $10;
  $136$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($8 | 0, i64toi32_i32$1 | 0, 21 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $138$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$1 = $138$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $8 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $143 = i64toi32_i32$2;
  $143$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$1 = $8;
  i64toi32_i32$2 = $143$hi;
  i64toi32_i32$3 = $143;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $9 = i64toi32_i32$5;
  $9$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $136$hi;
  i64toi32_i32$0 = $136;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $10 = i64toi32_i32$2;
  $10$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $135$hi;
  i64toi32_i32$4 = $135;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$3 = i64toi32_i32$2;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $11 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($11 | 0, i64toi32_i32$0 | 0, 13 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $150 = i64toi32_i32$4;
  $150$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  $151 = $11;
  $151$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_rotl_i64($8 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $153$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $153$hi;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$4 = i64toi32_i32$0 ^ i64toi32_i32$4 | 0;
  $8 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($7 | 0, i64toi32_i32$4 | 0, 32 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $158 = i64toi32_i32$5;
  $158$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$0 = $8;
  i64toi32_i32$5 = $158$hi;
  i64toi32_i32$3 = $158;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$1;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $151$hi;
  i64toi32_i32$4 = $151;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $161$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $150$hi;
  i64toi32_i32$2 = $150;
  i64toi32_i32$4 = $161$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $9 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $9$hi = i64toi32_i32$4;
  $163 = $9;
  $163$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($8 | 0, i64toi32_i32$4 | 0, 21 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $165$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $7$hi;
  i64toi32_i32$4 = $165$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$2 = i64toi32_i32$4 ^ i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($10 | 0, i64toi32_i32$2 | 0, 32 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $170 = i64toi32_i32$1;
  $170$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$4 = $7;
  i64toi32_i32$1 = $170$hi;
  i64toi32_i32$3 = $170;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $163$hi;
  i64toi32_i32$2 = $163;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$3 = i64toi32_i32$0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $10 = i64toi32_i32$1;
  $10$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 16 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $176$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$0 = $176$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $93 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($93 | 0, i64toi32_i32$2 | 0, 21 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $179 = i64toi32_i32$5;
  $179$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$5 = $179$hi;
  i64toi32_i32$3 = $179;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $180 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $180$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($9 | 0, i64toi32_i32$5 | 0, 17 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $182 = i64toi32_i32$0;
  $182$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $180$hi;
  i64toi32_i32$2 = $180;
  i64toi32_i32$0 = $182$hi;
  i64toi32_i32$3 = $182;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $183 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $183$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64(i64toi32_i32$1 | 0, i64toi32_i32$0 | 0, 32 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $185 = i64toi32_i32$2;
  $185$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $183$hi;
  i64toi32_i32$5 = $183;
  i64toi32_i32$2 = $185$hi;
  i64toi32_i32$3 = $185;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$5 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$2;
  return i64toi32_i32$5 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert_fit__hac9661061fde4be8($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $6 = 0, $7 = 0, $10 = 0, $5 = 0, $8 = 0, $9 = 0, $29 = 0, $62 = 0, $69 = 0, $73 = 0, $76 = 0, $99 = 0, $103 = 0, $109 = 0;
  $5 = global$0 - 32 | 0;
  global$0 = $5;
  $6 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  $7 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $0 = HEAPU16[($7 + 402 | 0) >> 1] | 0;
  $8 = ($5 + 8 | 0) + 8 | 0;
  HEAP32[$8 >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $29 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $29;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   $1 = $6 + 1 | 0;
   $9 = $1 >>> 0 > $0 >>> 0;
   if ($9) {
    break label$1
   }
   $10 = $7 + 268 | 0;
   memmove($10 + Math_imul($1, 12) | 0 | 0, $10 + Math_imul($6, 12) | 0 | 0, Math_imul($0 - $6 | 0, 12) | 0) | 0;
  }
  $10 = $7 + Math_imul($6, 12) | 0;
  HEAP32[($10 + 276 | 0) >> 2] = HEAP32[$8 >> 2] | 0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $62 = i64toi32_i32$1;
  i64toi32_i32$1 = $10 + 268 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $62;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $10 = (i64toi32_i32$2 + 8 | 0) + 16 | 0;
  i64toi32_i32$2 = $2 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $69 = i64toi32_i32$0;
  i64toi32_i32$0 = $10;
  HEAP32[i64toi32_i32$0 >> 2] = $69;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $73 = i64toi32_i32$1;
  i64toi32_i32$1 = $8;
  HEAP32[i64toi32_i32$1 >> 2] = $73;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $76 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $76;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
  label$2 : {
   if ($9) {
    break label$2
   }
   memmove($7 + Math_imul($1, 24) | 0 | 0, $7 + Math_imul($6, 24) | 0 | 0, Math_imul($0 - $6 | 0, 24) | 0) | 0;
  }
  $8 = $0 + 1 | 0;
  $2 = $7 + Math_imul($6, 24) | 0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $99 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[i64toi32_i32$1 >> 2] = $99;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $10;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $103 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $103;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = ($5 + 8 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $109 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $109;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  label$3 : {
   $9 = $6 + 2 | 0;
   $2 = $0 + 2 | 0;
   if ($9 >>> 0 >= $2 >>> 0) {
    break label$3
   }
   $10 = $7 + 408 | 0;
   memmove($10 + ($9 << 2 | 0) | 0 | 0, $10 + ($1 << 2 | 0) | 0 | 0, ($0 - $6 | 0) << 2 | 0 | 0) | 0;
  }
  HEAP32[(($7 + ($1 << 2 | 0) | 0) + 408 | 0) >> 2] = $4;
  HEAP16[($7 + 402 | 0) >> 1] = $8;
  label$4 : {
   if ($1 >>> 0 >= $2 >>> 0) {
    break label$4
   }
   $2 = $0 + 1 | 0;
   $0 = (($6 << 2 | 0) + $7 | 0) + 412 | 0;
   label$5 : while (1) {
    $1 = HEAP32[$0 >> 2] | 0;
    $6 = $6 + 1 | 0;
    HEAP16[($1 + 400 | 0) >> 1] = $6;
    HEAP32[($1 + 264 | 0) >> 2] = $7;
    $0 = $0 + 4 | 0;
    if (($2 | 0) != ($6 | 0)) {
     continue label$5
    }
    break label$5;
   };
  }
  global$0 = $5 + 32 | 0;
 }
 
 function cryptoxide__curve25519__scalar__scalar64__Scalar__nibbles__h905c2b43f6ecdbdb($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$4 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $7 = 0, $7$hi = 0, $2 = 0, $3 = 0, $5 = 0, $45 = 0, $46 = 0, $48 = 0, $49 = 0, $50 = 0, $51 = 0, $53 = 0, $54 = 0, $55 = 0, $56 = 0, $57 = 0, $58 = 0, $59 = 0, $60 = 0, $61 = 0, $4 = 0, $16 = 0, $6 = 0, $6$hi = 0, $20 = 0, $20$hi = 0, $24$hi = 0, $25 = 0, $26 = 0, $28$hi = 0, $30 = 0, $30$hi = 0, $33 = 0, $8 = 0, $8$hi = 0, $37 = 0, $37$hi = 0, $39$hi = 0, $40 = 0, $41 = 0, $44 = 0, $44$hi = 0, $46$hi = 0, $47 = 0, $52 = 0, $65 = 0, $71 = 0, $77 = 0, $83 = 0, $89 = 0, $95 = 0, $101 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  $3 = 0;
  $4 = memset($0 | 0, 0 | 0, 64 | 0) | 0;
  $5 = $2 + 8 | 0;
  $16 = $5;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $6 = i64toi32_i32$0;
  $6$hi = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 48;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $45 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $45 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $20 = $45;
  $20$hi = i64toi32_i32$0;
  i64toi32_i32$1 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 8;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $46 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   $46 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
  }
  $24$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $20$hi;
  i64toi32_i32$2 = $20;
  i64toi32_i32$1 = $24$hi;
  i64toi32_i32$3 = $46;
  i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
  $25 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $16;
  HEAP32[i64toi32_i32$2 >> 2] = $25;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
  $26 = $2;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$0 = $7;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   $48 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $48 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
  }
  $28$hi = i64toi32_i32$2;
  i64toi32_i32$1 = $1;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$2;
  $30$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $28$hi;
  i64toi32_i32$1 = $48;
  i64toi32_i32$2 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  $7 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$1 = $26;
  HEAP32[i64toi32_i32$1 >> 2] = $7;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  $33 = $2;
  i64toi32_i32$0 = $1;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] | 0;
  $8 = i64toi32_i32$2;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 40;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   $49 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $49 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
  }
  $37 = $49;
  $37$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $6$hi;
  i64toi32_i32$1 = $6;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 16;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $50 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   $50 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
  }
  $39$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $37$hi;
  i64toi32_i32$2 = $37;
  i64toi32_i32$1 = $39$hi;
  i64toi32_i32$3 = $50;
  i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
  $40 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $33;
  HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] = $40;
  HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] = i64toi32_i32$1;
  $41 = $2;
  i64toi32_i32$0 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 36 | 0) >> 2] | 0;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   $51 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
   $51 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
  }
  $44 = $51;
  $44$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$2 = $8;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 24;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $53 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   $53 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  $46$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $44$hi;
  i64toi32_i32$1 = $44;
  i64toi32_i32$2 = $46$hi;
  i64toi32_i32$3 = $53;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  $47 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $41;
  HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = $47;
  HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = i64toi32_i32$2;
  label$1 : {
   label$2 : while (1) {
    $1 = $4 + $3 | 0;
    $52 = $1 + 15 | 0;
    i64toi32_i32$2 = $7$hi;
    i64toi32_i32$0 = $7;
    i64toi32_i32$1 = 0;
    i64toi32_i32$3 = 60;
    i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$1 = 0;
     $54 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
    } else {
     i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
     $54 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
    }
    HEAP8[$52 >> 0] = $54;
    i64toi32_i32$1 = $7$hi;
    $0 = $7;
    HEAP8[($1 + 7 | 0) >> 0] = $7 >>> 28 | 0;
    HEAP8[$1 >> 0] = $7 & 15 | 0;
    $65 = $1 + 14 | 0;
    i64toi32_i32$2 = $7;
    i64toi32_i32$0 = 0;
    i64toi32_i32$3 = 56;
    i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$0 = 0;
     $55 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
    } else {
     i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
     $55 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
    }
    HEAP8[$65 >> 0] = $55 & 15 | 0;
    $71 = $1 + 13 | 0;
    i64toi32_i32$0 = $7$hi;
    i64toi32_i32$1 = $7;
    i64toi32_i32$2 = 0;
    i64toi32_i32$3 = 52;
    i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$2 = 0;
     $56 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
    } else {
     i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
     $56 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
    }
    HEAP8[$71 >> 0] = $56 & 15 | 0;
    $77 = $1 + 12 | 0;
    i64toi32_i32$2 = $7$hi;
    i64toi32_i32$0 = $7;
    i64toi32_i32$1 = 0;
    i64toi32_i32$3 = 48;
    i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$1 = 0;
     $57 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
    } else {
     i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
     $57 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
    }
    HEAP8[$77 >> 0] = $57 & 15 | 0;
    $83 = $1 + 11 | 0;
    i64toi32_i32$1 = $7$hi;
    i64toi32_i32$2 = $7;
    i64toi32_i32$0 = 0;
    i64toi32_i32$3 = 44;
    i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$0 = 0;
     $58 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
    } else {
     i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
     $58 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
    }
    HEAP8[$83 >> 0] = $58 & 15 | 0;
    $89 = $1 + 10 | 0;
    i64toi32_i32$0 = $7$hi;
    i64toi32_i32$1 = $7;
    i64toi32_i32$2 = 0;
    i64toi32_i32$3 = 40;
    i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$2 = 0;
     $59 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
    } else {
     i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
     $59 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
    }
    HEAP8[$89 >> 0] = $59 & 15 | 0;
    $95 = $1 + 9 | 0;
    i64toi32_i32$2 = $7$hi;
    i64toi32_i32$0 = $7;
    i64toi32_i32$1 = 0;
    i64toi32_i32$3 = 36;
    i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$1 = 0;
     $60 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
    } else {
     i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
     $60 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
    }
    HEAP8[$95 >> 0] = $60 & 15 | 0;
    $101 = $1 + 8 | 0;
    i64toi32_i32$1 = $7$hi;
    i64toi32_i32$2 = $7;
    i64toi32_i32$0 = 0;
    i64toi32_i32$3 = 32;
    i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$0 = 0;
     $61 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
    } else {
     i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
     $61 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
    }
    HEAP8[$101 >> 0] = $61 & 15 | 0;
    HEAP8[($1 + 6 | 0) >> 0] = ($0 >>> 24 | 0) & 15 | 0;
    HEAP8[($1 + 5 | 0) >> 0] = ($0 >>> 20 | 0) & 15 | 0;
    HEAP8[($1 + 4 | 0) >> 0] = ($0 >>> 16 | 0) & 15 | 0;
    HEAP8[($1 + 3 | 0) >> 0] = ($0 >>> 12 | 0) & 15 | 0;
    HEAP8[($1 + 2 | 0) >> 0] = ($0 >>> 8 | 0) & 15 | 0;
    HEAP8[($1 + 1 | 0) >> 0] = ($0 & 240 | 0) >>> 4 | 0;
    if (($3 | 0) == (48 | 0)) {
     break label$1
    }
    $3 = $3 + 16 | 0;
    i64toi32_i32$1 = $5;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
    $7 = i64toi32_i32$0;
    $7$hi = i64toi32_i32$2;
    $5 = i64toi32_i32$1 + 8 | 0;
    continue label$2;
   };
  }
  global$0 = $2 + 32 | 0;
 }
 
 function core__num__flt2dec__strategy__grisu__format_exact_opt__possibly_round__hc591c7b9929b43d8($0, $1, $2, $3, $4, $5, $6, $6$hi, $7, $7$hi, $8, $8$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  $5 = $5 | 0;
  $6 = $6 | 0;
  $6$hi = $6$hi | 0;
  $7 = $7 | 0;
  $7$hi = $7$hi | 0;
  $8 = $8 | 0;
  $8$hi = $8$hi | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$5 = 0, i64toi32_i32$6 = 0, $10 = 0, $11 = 0, $33 = 0, $34 = 0, $13 = 0, $19$hi = 0, $24$hi = 0, $27 = 0, $27$hi = 0, $29$hi = 0, $30 = 0, $30$hi = 0, $32$hi = 0, $42$hi = 0, $9 = 0, $12 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         i64toi32_i32$0 = $7$hi;
         i64toi32_i32$0 = $8$hi;
         i64toi32_i32$0 = $7$hi;
         i64toi32_i32$2 = $7;
         i64toi32_i32$1 = $8$hi;
         i64toi32_i32$3 = $8;
         if (i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$2 >>> 0 <= i64toi32_i32$3 >>> 0 | 0) | 0) {
          break label$7
         }
         i64toi32_i32$2 = $7$hi;
         i64toi32_i32$2 = $8$hi;
         i64toi32_i32$2 = $7$hi;
         i64toi32_i32$3 = $7;
         i64toi32_i32$0 = $8$hi;
         i64toi32_i32$1 = $8;
         i64toi32_i32$4 = i64toi32_i32$3 - i64toi32_i32$1 | 0;
         i64toi32_i32$6 = i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0;
         i64toi32_i32$5 = i64toi32_i32$6 + i64toi32_i32$0 | 0;
         i64toi32_i32$5 = i64toi32_i32$2 - i64toi32_i32$5 | 0;
         $19$hi = i64toi32_i32$5;
         i64toi32_i32$5 = i64toi32_i32$0;
         i64toi32_i32$5 = $19$hi;
         i64toi32_i32$2 = i64toi32_i32$4;
         i64toi32_i32$3 = i64toi32_i32$0;
         if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$2 >>> 0 <= i64toi32_i32$1 >>> 0 | 0) | 0) {
          break label$6
         }
         label$8 : {
          i64toi32_i32$2 = $7$hi;
          i64toi32_i32$2 = $6$hi;
          i64toi32_i32$2 = $7$hi;
          i64toi32_i32$1 = $7;
          i64toi32_i32$5 = $6$hi;
          i64toi32_i32$3 = $6;
          i64toi32_i32$0 = i64toi32_i32$1 - i64toi32_i32$3 | 0;
          i64toi32_i32$6 = i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0;
          i64toi32_i32$4 = i64toi32_i32$6 + i64toi32_i32$5 | 0;
          i64toi32_i32$4 = i64toi32_i32$2 - i64toi32_i32$4 | 0;
          $24$hi = i64toi32_i32$4;
          i64toi32_i32$4 = i64toi32_i32$5;
          i64toi32_i32$4 = $24$hi;
          i64toi32_i32$2 = i64toi32_i32$0;
          i64toi32_i32$1 = i64toi32_i32$5;
          if (i64toi32_i32$4 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$2 >>> 0 <= i64toi32_i32$3 >>> 0 | 0) | 0) {
           break label$8
          }
          i64toi32_i32$2 = $7$hi;
          $27 = $7;
          $27$hi = i64toi32_i32$2;
          i64toi32_i32$2 = $6$hi;
          i64toi32_i32$3 = $6;
          i64toi32_i32$4 = 0;
          i64toi32_i32$1 = 1;
          i64toi32_i32$5 = i64toi32_i32$1 & 31 | 0;
          if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
           i64toi32_i32$4 = i64toi32_i32$3 << i64toi32_i32$5 | 0;
           $33 = 0;
          } else {
           i64toi32_i32$4 = ((1 << i64toi32_i32$5 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$5 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$5 | 0) | 0;
           $33 = i64toi32_i32$3 << i64toi32_i32$5 | 0;
          }
          $29$hi = i64toi32_i32$4;
          i64toi32_i32$4 = $27$hi;
          i64toi32_i32$2 = $27;
          i64toi32_i32$3 = $29$hi;
          i64toi32_i32$1 = $33;
          i64toi32_i32$5 = i64toi32_i32$2 - i64toi32_i32$1 | 0;
          i64toi32_i32$6 = i64toi32_i32$2 >>> 0 < i64toi32_i32$1 >>> 0;
          i64toi32_i32$0 = i64toi32_i32$6 + i64toi32_i32$3 | 0;
          i64toi32_i32$0 = i64toi32_i32$4 - i64toi32_i32$0 | 0;
          $30 = i64toi32_i32$5;
          $30$hi = i64toi32_i32$0;
          i64toi32_i32$0 = $8$hi;
          i64toi32_i32$4 = $8;
          i64toi32_i32$2 = 0;
          i64toi32_i32$1 = 1;
          i64toi32_i32$3 = i64toi32_i32$1 & 31 | 0;
          if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
           i64toi32_i32$2 = i64toi32_i32$4 << i64toi32_i32$3 | 0;
           $34 = 0;
          } else {
           i64toi32_i32$2 = ((1 << i64toi32_i32$3 | 0) - 1 | 0) & (i64toi32_i32$4 >>> (32 - i64toi32_i32$3 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$3 | 0) | 0;
           $34 = i64toi32_i32$4 << i64toi32_i32$3 | 0;
          }
          $32$hi = i64toi32_i32$2;
          i64toi32_i32$2 = $30$hi;
          i64toi32_i32$0 = $30;
          i64toi32_i32$4 = $32$hi;
          i64toi32_i32$1 = $34;
          if (i64toi32_i32$2 >>> 0 > i64toi32_i32$4 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$4 | 0) & i64toi32_i32$0 >>> 0 >= i64toi32_i32$1 >>> 0 | 0) | 0) {
           break label$5
          }
         }
         label$9 : {
          i64toi32_i32$0 = $6$hi;
          i64toi32_i32$0 = $8$hi;
          i64toi32_i32$0 = $6$hi;
          i64toi32_i32$1 = $6;
          i64toi32_i32$2 = $8$hi;
          i64toi32_i32$4 = $8;
          if (i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$1 >>> 0 <= i64toi32_i32$4 >>> 0 | 0) | 0) {
           break label$9
          }
          i64toi32_i32$1 = $7$hi;
          i64toi32_i32$1 = $6$hi;
          i64toi32_i32$1 = $8$hi;
          i64toi32_i32$1 = $6$hi;
          i64toi32_i32$4 = $6;
          i64toi32_i32$0 = $8$hi;
          i64toi32_i32$2 = $8;
          i64toi32_i32$3 = i64toi32_i32$4 - i64toi32_i32$2 | 0;
          i64toi32_i32$6 = i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0;
          i64toi32_i32$5 = i64toi32_i32$6 + i64toi32_i32$0 | 0;
          i64toi32_i32$5 = i64toi32_i32$1 - i64toi32_i32$5 | 0;
          $8 = i64toi32_i32$3;
          $8$hi = i64toi32_i32$5;
          i64toi32_i32$5 = $7$hi;
          i64toi32_i32$1 = $7;
          i64toi32_i32$4 = $8$hi;
          i64toi32_i32$2 = i64toi32_i32$3;
          i64toi32_i32$0 = i64toi32_i32$1 - i64toi32_i32$3 | 0;
          i64toi32_i32$6 = i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0;
          i64toi32_i32$3 = i64toi32_i32$6 + i64toi32_i32$4 | 0;
          i64toi32_i32$3 = i64toi32_i32$5 - i64toi32_i32$3 | 0;
          $42$hi = i64toi32_i32$3;
          i64toi32_i32$3 = i64toi32_i32$4;
          i64toi32_i32$3 = $42$hi;
          i64toi32_i32$5 = i64toi32_i32$0;
          i64toi32_i32$1 = i64toi32_i32$4;
          if (i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$5 >>> 0 <= i64toi32_i32$2 >>> 0 | 0) | 0) {
           break label$4
          }
         }
         HEAP32[$0 >> 2] = 0;
         return;
        }
        HEAP32[$0 >> 2] = 0;
        return;
       }
       HEAP32[$0 >> 2] = 0;
       return;
      }
      if ($3 >>> 0 > $2 >>> 0) {
       break label$3
      }
      HEAP32[($0 + 4 | 0) >> 2] = $3;
      HEAP32[$0 >> 2] = $1;
      HEAP16[($0 + 8 | 0) >> 1] = $4;
      return;
     }
     if ($3 >>> 0 > $2 >>> 0) {
      break label$2
     }
     $9 = $1 + $3 | 0;
     $10 = 0;
     $11 = $1;
     label$10 : {
      label$11 : while (1) {
       if (($3 | 0) == ($10 | 0)) {
        break label$10
       }
       $10 = $10 + 1 | 0;
       $12 = $11 + $3 | 0;
       $13 = $11 + -1 | 0;
       $11 = $13;
       if ((HEAPU8[($12 + -1 | 0) >> 0] | 0 | 0) == (57 | 0)) {
        continue label$11
       }
       break label$11;
      };
      $11 = $13 + $3 | 0;
      HEAP8[$11 >> 0] = (HEAPU8[$11 >> 0] | 0) + 1 | 0;
      if ((($3 - $10 | 0) + 1 | 0) >>> 0 >= $3 >>> 0) {
       break label$1
      }
      memset($11 + 1 | 0 | 0, 48 | 0, $10 + -1 | 0 | 0) | 0;
      break label$1;
     }
     label$12 : {
      label$13 : {
       if ($3) {
        break label$13
       }
       $10 = 49;
       break label$12;
      }
      HEAP8[$1 >> 0] = 49;
      $10 = 48;
      if (($3 | 0) == (1 | 0)) {
       break label$12
      }
      $10 = 48;
      memset($1 + 1 | 0 | 0, 48 | 0, $3 + -1 | 0 | 0) | 0;
     }
     $4 = (($4 << 16 | 0) + 65536 | 0) >> 16 | 0;
     if ($3 >>> 0 >= $2 >>> 0) {
      break label$1
     }
     if (($4 | 0) <= (($5 << 16 | 0) >> 16 | 0 | 0)) {
      break label$1
     }
     HEAP8[$9 >> 0] = $10;
     $3 = $3 + 1 | 0;
     break label$1;
    }
    core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($3 | 0, $2 | 0, 1149044 | 0);
    abort();
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($3 | 0, $2 | 0, 1149060 | 0);
   abort();
  }
  label$14 : {
   if ($3 >>> 0 > $2 >>> 0) {
    break label$14
   }
   HEAP32[($0 + 4 | 0) >> 2] = $3;
   HEAP32[$0 >> 2] = $1;
   HEAP16[($0 + 8 | 0) >> 1] = $4;
   return;
  }
  core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($3 | 0, $2 | 0, 1149076 | 0);
  abort();
 }
 
 function hashbrown__raw__RawTable_T_2cA___insert__hf300f52f075b064e($0, $1, $1$hi, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $1$hi = $1$hi | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $10 = 0, i64toi32_i32$1 = 0, $8 = 0, $9 = 0, $5 = 0, $6 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $25 = 0, $26 = 0, $27 = 0, $4 = 0, $7 = 0, $159 = 0, $164 = 0, $167 = 0;
  $4 = global$0 - 16 | 0;
  global$0 = $4;
  label$1 : {
   $5 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   $6 = HEAP32[$0 >> 2] | 0;
   i64toi32_i32$0 = $1$hi;
   $7 = $1;
   $8 = $6 & $7 | 0;
   $18 = $5 + $8 | 0;
   $9 = (HEAPU8[$18 >> 0] | 0 | ((HEAPU8[($18 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($18 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($18 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
   if ($9) {
    break label$1
   }
   $10 = 4;
   label$2 : while (1) {
    $8 = $8 + $10 | 0;
    $10 = $10 + 4 | 0;
    $8 = $8 & $6 | 0;
    $19 = $5 + $8 | 0;
    $9 = (HEAPU8[$19 >> 0] | 0 | ((HEAPU8[($19 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($19 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($19 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
    if (!$9) {
     continue label$2
    }
    break label$2;
   };
  }
  label$3 : {
   $10 = (((__wasm_ctz_i32($9 | 0) | 0) >>> 3 | 0) + $8 | 0) & $6 | 0;
   $8 = HEAP8[($5 + $10 | 0) >> 0] | 0;
   if (($8 | 0) <= (-1 | 0)) {
    break label$3
   }
   $10 = (__wasm_ctz_i32((HEAP32[$5 >> 2] | 0) & -2139062144 | 0 | 0) | 0) >>> 3 | 0;
   $8 = HEAPU8[($5 + $10 | 0) >> 0] | 0;
  }
  label$4 : {
   $8 = $8 & 1 | 0;
   if (!$8) {
    break label$4
   }
   if (HEAP32[($0 + 8 | 0) >> 2] | 0) {
    break label$4
   }
   hashbrown__raw__RawTable_T_2cA___reserve_rehash__h6f0b6bcc2f29bdb2($4 | 0, $0 | 0, 1 | 0, $3 | 0, 1 | 0);
   label$5 : {
    $5 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    $6 = HEAP32[$0 >> 2] | 0;
    $9 = $6 & $7 | 0;
    $20 = $5 + $9 | 0;
    $3 = (HEAPU8[$20 >> 0] | 0 | ((HEAPU8[($20 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($20 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($20 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
    if ($3) {
     break label$5
    }
    $10 = 4;
    label$6 : while (1) {
     $9 = $9 + $10 | 0;
     $10 = $10 + 4 | 0;
     $9 = $9 & $6 | 0;
     $21 = $5 + $9 | 0;
     $3 = (HEAPU8[$21 >> 0] | 0 | ((HEAPU8[($21 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($21 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($21 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
     if (!$3) {
      continue label$6
     }
     break label$6;
    };
   }
   $10 = (((__wasm_ctz_i32($3 | 0) | 0) >>> 3 | 0) + $9 | 0) & $6 | 0;
   if ((HEAP8[($5 + $10 | 0) >> 0] | 0 | 0) <= (-1 | 0)) {
    break label$4
   }
   $10 = (__wasm_ctz_i32((HEAP32[$5 >> 2] | 0) & -2139062144 | 0 | 0) | 0) >>> 3 | 0;
  }
  $9 = $7 >>> 25 | 0;
  HEAP8[($5 + $10 | 0) >> 0] = $9;
  HEAP8[(((($10 + -4 | 0) & $6 | 0) + $5 | 0) + 4 | 0) >> 0] = $9;
  HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) - $8 | 0;
  HEAP32[($0 + 12 | 0) >> 2] = (HEAP32[($0 + 12 | 0) >> 2] | 0) + 1 | 0;
  $8 = $5 + Math_imul(0 - $10 | 0, 28) | 0;
  $10 = $8 + -28 | 0;
  $22 = $2 + 24 | 0;
  $23 = $10 + 24 | 0;
  $24 = HEAPU8[$22 >> 0] | 0 | ((HEAPU8[($22 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($22 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($22 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  HEAP8[$23 >> 0] = $24;
  HEAP8[($23 + 1 | 0) >> 0] = $24 >>> 8 | 0;
  HEAP8[($23 + 2 | 0) >> 0] = $24 >>> 16 | 0;
  HEAP8[($23 + 3 | 0) >> 0] = $24 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $159 = i64toi32_i32$0;
  i64toi32_i32$0 = $10 + 16 | 0;
  $25 = $159;
  HEAP8[i64toi32_i32$0 >> 0] = $25;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $25 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $25 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $25 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $164 = i64toi32_i32$1;
  i64toi32_i32$1 = $10 + 8 | 0;
  $26 = $164;
  HEAP8[i64toi32_i32$1 >> 0] = $26;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $26 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $26 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $26 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $167 = i64toi32_i32$0;
  i64toi32_i32$0 = $10;
  $27 = $167;
  HEAP8[i64toi32_i32$0 >> 0] = $27;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $27 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $27 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $27 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  global$0 = $4 + 16 | 0;
  return $8 | 0;
 }
 
 function rand__rng__Rng__gen_range__he28987be934355f0($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, i64toi32_i32$4 = 0, i64toi32_i32$2 = 0, $9 = 0, $9$hi = 0, $8$hi = 0, i64toi32_i32$3 = 0, $17 = 0, $6 = 0, $7 = 0, $8 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        if ($1 >>> 0 >= $2 >>> 0) {
         break label$6
        }
        $2 = $2 + -1 | 0;
        if ($2 >>> 0 < $1 >>> 0) {
         break label$5
        }
        label$7 : {
         label$8 : {
          $2 = $2 - $1 | 0;
          $4 = $2 + 1 | 0;
          if ($4 >>> 0 >= $2 >>> 0) {
           break label$8
          }
          $2 = HEAP32[$0 >> 2] | 0;
          $5 = HEAP32[($2 + 264 | 0) >> 2] | 0;
          $0 = $2 + 8 | 0;
          $rand_chacha__chacha__Array64_T__20as_20core__convert__AsRef__5bT_5d____as_ref__h92537188a965f192($3 + 16 | 0 | 0, $0 | 0);
          label$9 : {
           if ($5 >>> 0 < (HEAP32[($3 + 20 | 0) >> 2] | 0) >>> 0) {
            break label$9
           }
           $rand_chacha__chacha__Array64_T__20as_20core__convert__AsRef__5bT_5d____as_ref__h92537188a965f192($3 + 8 | 0 | 0, $0 | 0);
           if (!(HEAP32[($3 + 12 | 0) >> 2] | 0)) {
            break label$4
           }
           $rand__rngs__adapter__reseeding__ReseedingCore_R_2cRsdr__20as_20rand_core__block__BlockRngCore___generate__h6e6be967deb36d03($2 + 272 | 0 | 0, $0 | 0);
           HEAP32[($2 + 264 | 0) >> 2] = 0;
          }
          $rand_chacha__chacha__Array64_T__20as_20core__convert__AsRef__5bT_5d____as_ref__h92537188a965f192($3 | 0, $0 | 0);
          $5 = HEAP32[($2 + 264 | 0) >> 2] | 0;
          $0 = HEAP32[($3 + 4 | 0) >> 2] | 0;
          if ($5 >>> 0 >= $0 >>> 0) {
           break label$3
          }
          $0 = HEAP32[((HEAP32[$3 >> 2] | 0) + ($5 << 2 | 0) | 0) >> 2] | 0;
          HEAP32[($2 + 264 | 0) >> 2] = $5 + 1 | 0;
          break label$7;
         }
         $5 = HEAP32[$0 >> 2] | 0;
         $6 = $5 + 272 | 0;
         $2 = $5 + 8 | 0;
         $7 = ($4 << Math_clz32($4) | 0) + -1 | 0;
         $0 = HEAP32[($5 + 264 | 0) >> 2] | 0;
         i64toi32_i32$0 = 0;
         $8 = $4;
         $8$hi = i64toi32_i32$0;
         label$10 : while (1) {
          $rand_chacha__chacha__Array64_T__20as_20core__convert__AsRef__5bT_5d____as_ref__h92537188a965f192($3 + 40 | 0 | 0, $2 | 0);
          label$11 : {
           if ($0 >>> 0 < (HEAP32[($3 + 44 | 0) >> 2] | 0) >>> 0) {
            break label$11
           }
           $rand_chacha__chacha__Array64_T__20as_20core__convert__AsRef__5bT_5d____as_ref__h92537188a965f192($3 + 32 | 0 | 0, $2 | 0);
           if (!(HEAP32[($3 + 36 | 0) >> 2] | 0)) {
            break label$2
           }
           $rand__rngs__adapter__reseeding__ReseedingCore_R_2cRsdr__20as_20rand_core__block__BlockRngCore___generate__h6e6be967deb36d03($6 | 0, $2 | 0);
           HEAP32[($5 + 264 | 0) >> 2] = 0;
          }
          $rand_chacha__chacha__Array64_T__20as_20core__convert__AsRef__5bT_5d____as_ref__h92537188a965f192($3 + 24 | 0 | 0, $2 | 0);
          $0 = HEAP32[($5 + 264 | 0) >> 2] | 0;
          $4 = HEAP32[($3 + 28 | 0) >> 2] | 0;
          if ($0 >>> 0 >= $4 >>> 0) {
           break label$1
          }
          i64toi32_i32$2 = (HEAP32[($3 + 24 | 0) >> 2] | 0) + ($0 << 2 | 0) | 0;
          i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
          i64toi32_i32$1 = 0;
          $9 = i64toi32_i32$0;
          $9$hi = i64toi32_i32$1;
          $0 = $0 + 1 | 0;
          HEAP32[($5 + 264 | 0) >> 2] = $0;
          i64toi32_i32$1 = $8$hi;
          i64toi32_i32$1 = $9$hi;
          i64toi32_i32$0 = $8$hi;
          i64toi32_i32$0 = __wasm_i64_mul($9 | 0, i64toi32_i32$1 | 0, $8 | 0, i64toi32_i32$0 | 0) | 0;
          i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
          $9 = i64toi32_i32$0;
          $9$hi = i64toi32_i32$1;
          if ($7 >>> 0 < i64toi32_i32$0 >>> 0) {
           continue label$10
          }
          break label$10;
         };
         i64toi32_i32$1 = $9$hi;
         i64toi32_i32$2 = $9;
         i64toi32_i32$0 = 0;
         i64toi32_i32$3 = 32;
         i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
          i64toi32_i32$0 = 0;
          $17 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
         } else {
          i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
          $17 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
         }
         $0 = $17 + $1 | 0;
        }
        global$0 = $3 + 48 | 0;
        return $0 | 0;
       }
       core__panicking__panic__h2fd385a887c8bf13(1055856 | 0, 25 | 0, 1055968 | 0);
       abort();
      }
      core__panicking__panic__h2fd385a887c8bf13(1055524 | 0, 51 | 0, 1055508 | 0);
      abort();
     }
     core__panicking__panic__h2fd385a887c8bf13(1056297 | 0, 53 | 0, 1056352 | 0);
     abort();
    }
    core__panicking__panic_bounds_check__h808b524af17640b1($5 | 0, $0 | 0, 1056148 | 0);
    abort();
   }
   core__panicking__panic__h2fd385a887c8bf13(1056297 | 0, 53 | 0, 1056352 | 0);
   abort();
  }
  core__panicking__panic_bounds_check__h808b524af17640b1($0 | 0, $4 | 0, 1056148 | 0);
  abort();
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__TimelockStart___deserialize_as_embedded_group__h4f29e66be5595f76($0, $1, $2, $2$hi, $3, $3$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  var i64toi32_i32$1 = 0, $4 = 0, i64toi32_i32$3 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $10 = 0, $10$hi = 0, $5 = 0, i64toi32_i32$4 = 0, $11 = 0, $11$hi = 0, $6 = 0, $7 = 0, $23 = 0, $8 = 0, $12 = 0, $12$hi = 0, $9 = 0;
  $4 = global$0 - 208 | 0;
  global$0 = $4;
  cbor_event__de__Deserializer_R___unsigned_integer__h1ed99c0b7fe7eea1($4 + 136 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[($4 + 144 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($4 + 148 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        i64toi32_i32$2 = $4;
        i64toi32_i32$1 = HEAP32[($4 + 136 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[($4 + 140 | 0) >> 2] | 0;
        i64toi32_i32$2 = i64toi32_i32$1;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
         break label$6
        }
        i64toi32_i32$2 = 0;
        $11 = 4;
        $11$hi = i64toi32_i32$2;
        i64toi32_i32$2 = $10$hi;
        i64toi32_i32$3 = $10;
        i64toi32_i32$0 = 0;
        i64toi32_i32$1 = 4;
        if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) | 0) {
         break label$4
        }
        $5 = 8;
        $6 = 1;
        $7 = 1;
        break label$5;
       }
       i64toi32_i32$3 = $10$hi;
       i64toi32_i32$1 = $10;
       i64toi32_i32$2 = 0;
       i64toi32_i32$0 = 32;
       i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = 0;
        $23 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$2 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
        $23 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
       }
       $8 = $23;
       i64toi32_i32$3 = $4 + 176 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $12 = i64toi32_i32$2;
       $12$hi = i64toi32_i32$1;
       i64toi32_i32$3 = $4 + 168 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $11 = i64toi32_i32$1;
       $11$hi = i64toi32_i32$2;
       $9 = HEAP32[($4 + 164 | 0) >> 2] | 0;
       $7 = HEAP32[($4 + 160 | 0) >> 2] | 0;
       i64toi32_i32$2 = $10$hi;
       $6 = $10;
       $5 = 2;
       i64toi32_i32$3 = $4 + 152 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $10 = i64toi32_i32$2;
       $10$hi = i64toi32_i32$1;
      }
      i64toi32_i32$1 = $12$hi;
      i64toi32_i32$2 = $4 + 176 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $12;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$1 = $11$hi;
      i64toi32_i32$2 = $4 + 168 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $11;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($4 + 164 | 0) >> 2] = $9;
      HEAP32[($4 + 160 | 0) >> 2] = $7;
      i64toi32_i32$1 = $10$hi;
      i64toi32_i32$2 = $4 + 152 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $10;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($4 + 148 | 0) >> 2] = $8;
      HEAP32[($4 + 144 | 0) >> 2] = $6;
      HEAP32[($4 + 184 | 0) >> 2] = 0;
      HEAP8[($4 + 136 | 0) >> 0] = $5;
      cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($4 + 64 | 0 | 0, $4 + 136 | 0 | 0, 1050766 | 0, 7 | 0);
      $5 = HEAPU8[($4 + 64 | 0) >> 0] | 0;
      if (($5 | 0) != (19 | 0)) {
       break label$3
      }
     }
     $cardano_serialization_lib__utils__BigNum_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h29637bb571dceb02($4 + 136 | 0 | 0, $1 | 0);
     i64toi32_i32$3 = $4;
     i64toi32_i32$1 = HEAP32[($4 + 144 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[($4 + 148 | 0) >> 2] | 0;
     $10 = i64toi32_i32$1;
     $10$hi = i64toi32_i32$2;
     i64toi32_i32$3 = $4;
     i64toi32_i32$2 = HEAP32[($4 + 136 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($4 + 140 | 0) >> 2] | 0;
     i64toi32_i32$3 = i64toi32_i32$2;
     i64toi32_i32$2 = 0;
     i64toi32_i32$0 = 1;
     if ((i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) | 0) {
      break label$2
     }
     i64toi32_i32$1 = $0;
     i64toi32_i32$3 = 0;
     HEAP32[i64toi32_i32$1 >> 2] = 0;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$3 = $10$hi;
     HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $10;
     HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$3;
     break label$1;
    }
    $1 = memcpy($4 | 0, $4 + 64 | 0 | 1 | 0 | 0, 63 | 0) | 0;
    HEAP8[($0 + 8 | 0) >> 0] = $5;
    memcpy($0 + 9 | 0 | 0, $1 | 0, 63 | 0) | 0;
    i64toi32_i32$1 = $0;
    i64toi32_i32$3 = 0;
    HEAP32[i64toi32_i32$1 >> 2] = 1;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
    break label$1;
   }
   $1 = memcpy($4 | 0, ($4 + 136 | 0) + 16 | 0 | 0, 56 | 0) | 0;
   i64toi32_i32$3 = $10$hi;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 136 | 0) >> 2] = $10;
   HEAP32[(i64toi32_i32$1 + 140 | 0) >> 2] = i64toi32_i32$3;
   memcpy((i64toi32_i32$1 + 136 | 0) + 8 | 0 | 0, i64toi32_i32$1 | 0, 56 | 0) | 0;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e((i64toi32_i32$1 + 64 | 0) + 8 | 0 | 0, i64toi32_i32$1 + 136 | 0 | 0, 1051822 | 0, 4 | 0);
   i64toi32_i32$0 = i64toi32_i32$1;
   i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 72 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$1 + 76 | 0) >> 2] | 0;
   $10 = i64toi32_i32$3;
   $10$hi = i64toi32_i32$1;
   memcpy($0 + 16 | 0 | 0, (i64toi32_i32$0 + 64 | 0) + 16 | 0 | 0, 56 | 0) | 0;
   i64toi32_i32$3 = $0;
   i64toi32_i32$1 = 0;
   HEAP32[i64toi32_i32$3 >> 2] = 1;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $10$hi;
   HEAP32[(i64toi32_i32$3 + 8 | 0) >> 2] = $10;
   HEAP32[(i64toi32_i32$3 + 12 | 0) >> 2] = i64toi32_i32$1;
  }
  global$0 = $4 + 208 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__TimelockExpiry___deserialize_as_embedded_group__h31f31ef9c6de3fe5($0, $1, $2, $2$hi, $3, $3$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  var i64toi32_i32$1 = 0, $4 = 0, i64toi32_i32$3 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $10 = 0, $10$hi = 0, $5 = 0, i64toi32_i32$4 = 0, $11 = 0, $11$hi = 0, $6 = 0, $7 = 0, $23 = 0, $8 = 0, $12 = 0, $12$hi = 0, $9 = 0;
  $4 = global$0 - 208 | 0;
  global$0 = $4;
  cbor_event__de__Deserializer_R___unsigned_integer__h1ed99c0b7fe7eea1($4 + 136 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[($4 + 144 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($4 + 148 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        i64toi32_i32$2 = $4;
        i64toi32_i32$1 = HEAP32[($4 + 136 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[($4 + 140 | 0) >> 2] | 0;
        i64toi32_i32$2 = i64toi32_i32$1;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
         break label$6
        }
        i64toi32_i32$2 = 0;
        $11 = 5;
        $11$hi = i64toi32_i32$2;
        i64toi32_i32$2 = $10$hi;
        i64toi32_i32$3 = $10;
        i64toi32_i32$0 = 0;
        i64toi32_i32$1 = 5;
        if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) | 0) {
         break label$4
        }
        $5 = 8;
        $6 = 1;
        $7 = 1;
        break label$5;
       }
       i64toi32_i32$3 = $10$hi;
       i64toi32_i32$1 = $10;
       i64toi32_i32$2 = 0;
       i64toi32_i32$0 = 32;
       i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = 0;
        $23 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$2 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
        $23 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
       }
       $8 = $23;
       i64toi32_i32$3 = $4 + 176 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $12 = i64toi32_i32$2;
       $12$hi = i64toi32_i32$1;
       i64toi32_i32$3 = $4 + 168 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $11 = i64toi32_i32$1;
       $11$hi = i64toi32_i32$2;
       $9 = HEAP32[($4 + 164 | 0) >> 2] | 0;
       $7 = HEAP32[($4 + 160 | 0) >> 2] | 0;
       i64toi32_i32$2 = $10$hi;
       $6 = $10;
       $5 = 2;
       i64toi32_i32$3 = $4 + 152 | 0;
       i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $10 = i64toi32_i32$2;
       $10$hi = i64toi32_i32$1;
      }
      i64toi32_i32$1 = $12$hi;
      i64toi32_i32$2 = $4 + 176 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $12;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$1 = $11$hi;
      i64toi32_i32$2 = $4 + 168 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $11;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($4 + 164 | 0) >> 2] = $9;
      HEAP32[($4 + 160 | 0) >> 2] = $7;
      i64toi32_i32$1 = $10$hi;
      i64toi32_i32$2 = $4 + 152 | 0;
      HEAP32[i64toi32_i32$2 >> 2] = $10;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($4 + 148 | 0) >> 2] = $8;
      HEAP32[($4 + 144 | 0) >> 2] = $6;
      HEAP32[($4 + 184 | 0) >> 2] = 0;
      HEAP8[($4 + 136 | 0) >> 0] = $5;
      cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($4 + 64 | 0 | 0, $4 + 136 | 0 | 0, 1050766 | 0, 7 | 0);
      $5 = HEAPU8[($4 + 64 | 0) >> 0] | 0;
      if (($5 | 0) != (19 | 0)) {
       break label$3
      }
     }
     $cardano_serialization_lib__utils__BigNum_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h29637bb571dceb02($4 + 136 | 0 | 0, $1 | 0);
     i64toi32_i32$3 = $4;
     i64toi32_i32$1 = HEAP32[($4 + 144 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[($4 + 148 | 0) >> 2] | 0;
     $10 = i64toi32_i32$1;
     $10$hi = i64toi32_i32$2;
     i64toi32_i32$3 = $4;
     i64toi32_i32$2 = HEAP32[($4 + 136 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($4 + 140 | 0) >> 2] | 0;
     i64toi32_i32$3 = i64toi32_i32$2;
     i64toi32_i32$2 = 0;
     i64toi32_i32$0 = 1;
     if ((i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) | 0) {
      break label$2
     }
     i64toi32_i32$1 = $0;
     i64toi32_i32$3 = 0;
     HEAP32[i64toi32_i32$1 >> 2] = 0;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$3 = $10$hi;
     HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $10;
     HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$3;
     break label$1;
    }
    $1 = memcpy($4 | 0, $4 + 64 | 0 | 1 | 0 | 0, 63 | 0) | 0;
    HEAP8[($0 + 8 | 0) >> 0] = $5;
    memcpy($0 + 9 | 0 | 0, $1 | 0, 63 | 0) | 0;
    i64toi32_i32$1 = $0;
    i64toi32_i32$3 = 0;
    HEAP32[i64toi32_i32$1 >> 2] = 1;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
    break label$1;
   }
   $1 = memcpy($4 | 0, ($4 + 136 | 0) + 16 | 0 | 0, 56 | 0) | 0;
   i64toi32_i32$3 = $10$hi;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 136 | 0) >> 2] = $10;
   HEAP32[(i64toi32_i32$1 + 140 | 0) >> 2] = i64toi32_i32$3;
   memcpy((i64toi32_i32$1 + 136 | 0) + 8 | 0 | 0, i64toi32_i32$1 | 0, 56 | 0) | 0;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e((i64toi32_i32$1 + 64 | 0) + 8 | 0 | 0, i64toi32_i32$1 + 136 | 0 | 0, 1051822 | 0, 4 | 0);
   i64toi32_i32$0 = i64toi32_i32$1;
   i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 72 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$1 + 76 | 0) >> 2] | 0;
   $10 = i64toi32_i32$3;
   $10$hi = i64toi32_i32$1;
   memcpy($0 + 16 | 0 | 0, (i64toi32_i32$0 + 64 | 0) + 16 | 0 | 0, 56 | 0) | 0;
   i64toi32_i32$3 = $0;
   i64toi32_i32$1 = 0;
   HEAP32[i64toi32_i32$3 >> 2] = 1;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $10$hi;
   HEAP32[(i64toi32_i32$3 + 8 | 0) >> 2] = $10;
   HEAP32[(i64toi32_i32$3 + 12 | 0) >> 2] = i64toi32_i32$1;
  }
  global$0 = $4 + 208 | 0;
 }
 
 function cardano_serialization_lib__tx_builder__min_fee__h8bb5ab8499f01c90($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $3 = 0, i64toi32_i32$2 = 0, $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$5 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $4 = 0, $5$hi = 0, $5 = 0, i64toi32_i32$4 = 0, $6$hi = 0, $92 = 0, $92$hi = 0, $6 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 1408 | 0;
  global$0 = $2;
  cardano_serialization_lib__tx_builder__TransactionBuilder__build__h1126ee00e4941d94($2 + 1128 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ((HEAP32[($2 + 1128 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      memcpy($2 + 856 | 0 | 0, ($2 + 1128 | 0) + 8 | 0 | 0, 272 | 0) | 0;
      cardano_serialization_lib__tx_builder__fake_full_tx__h790258922a10b915($2 + 424 | 0 | 0, $1 | 0, $2 + 856 | 0 | 0);
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          if ((HEAP32[($2 + 424 | 0) >> 2] | 0 | 0) == (1 | 0)) {
           break label$8
          }
          $3 = memcpy($2 | 0, ($2 + 424 | 0) + 8 | 0 | 0, 424 | 0) | 0;
          cardano_serialization_lib__fees__min_fee__hf0827db8ce69035c($3 + 424 | 0 | 0, $3 | 0, $1 | 0);
          $4 = 1;
          if ((HEAP32[($3 + 424 | 0) >> 2] | 0 | 0) == (1 | 0)) {
           break label$7
          }
          i64toi32_i32$2 = $3 + 432 | 0;
          i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
          $5 = i64toi32_i32$0;
          $5$hi = i64toi32_i32$1;
          i64toi32_i32$2 = $1;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
          i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] | 0;
          i64toi32_i32$2 = i64toi32_i32$1;
          i64toi32_i32$1 = 0;
          i64toi32_i32$3 = 1;
          if ((i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | 0) {
           break label$6
          }
          cardano_serialization_lib__fees__min_script_fee__h862c5f4fcf338926($3 + 424 | 0 | 0, $3 | 0, $1 + 48 | 0 | 0);
          $4 = 1;
          if ((HEAP32[($3 + 424 | 0) >> 2] | 0 | 0) != (1 | 0)) {
           break label$5
          }
          (wasm2js_i32$0 = $0, wasm2js_i32$1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($3 + 428 | 0) >> 2] | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
          break label$2;
         }
         $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($2 + 428 | 0) >> 2] | 0 | 0) | 0;
         HEAP32[$0 >> 2] = 1;
         HEAP32[($0 + 4 | 0) >> 2] = $1;
         break label$1;
        }
        (wasm2js_i32$0 = $0, wasm2js_i32$1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($3 + 428 | 0) >> 2] | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
        break label$2;
       }
       if (cardano_serialization_lib__tx_builder__TransactionBuilder__has_plutus_inputs__h1b9c6897141f0331($1 | 0) | 0) {
        break label$3
       }
       HEAP32[$0 >> 2] = 0;
       i64toi32_i32$2 = $5$hi;
       i64toi32_i32$0 = $0 + 8 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $5;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
       core__ptr__drop_in_place_cardano_serialization_lib__TransactionBody___h9274013021a1d568($3 | 0);
       core__ptr__drop_in_place_cardano_serialization_lib__TransactionWitnessSet___h7d278d9502f6471a($3 + 344 | 0 | 0);
       i64toi32_i32$3 = $3;
       i64toi32_i32$2 = HEAP32[($3 + 272 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[($3 + 276 | 0) >> 2] | 0;
       if (!(i64toi32_i32$2 | i64toi32_i32$0 | 0)) {
        break label$1
       }
       core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__metadata__GeneralTransactionMetadata____h37a091753d7f028f_1($3 + 280 | 0 | 0);
       core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__NativeScripts____hdd7d461255ec800a_2($3 + 320 | 0 | 0);
       core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__plutus__PlutusScripts____h6be1d55eac328b7f_2($3 + 332 | 0 | 0);
       break label$1;
      }
      label$9 : {
       i64toi32_i32$0 = $5$hi;
       i64toi32_i32$3 = ($3 + 424 | 0) + 8 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
       $92 = i64toi32_i32$0;
       $92$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $5$hi;
       i64toi32_i32$3 = $5;
       i64toi32_i32$0 = $92$hi;
       i64toi32_i32$1 = $92;
       i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
       i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
       if (i64toi32_i32$4 >>> 0 < i64toi32_i32$1 >>> 0) {
        i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
       }
       $6 = i64toi32_i32$4;
       $6$hi = i64toi32_i32$5;
       i64toi32_i32$5 = $5$hi;
       i64toi32_i32$5 = $6$hi;
       i64toi32_i32$2 = i64toi32_i32$4;
       i64toi32_i32$3 = $5$hi;
       i64toi32_i32$1 = $5;
       if (i64toi32_i32$5 >>> 0 > i64toi32_i32$3 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$2 >>> 0 >= i64toi32_i32$1 >>> 0 | 0) | 0) {
        break label$9
       }
       (wasm2js_i32$0 = $0, wasm2js_i32$1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1058732 | 0, 8 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
       $4 = 1;
       break label$2;
      }
      i64toi32_i32$2 = $6$hi;
      i64toi32_i32$5 = $0 + 8 | 0;
      HEAP32[i64toi32_i32$5 >> 2] = $6;
      HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$2;
      $4 = 0;
      break label$2;
     }
     $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($2 + 1132 | 0) >> 2] | 0 | 0) | 0;
     HEAP32[$0 >> 2] = 1;
     HEAP32[($0 + 4 | 0) >> 2] = $1;
     break label$1;
    }
    (wasm2js_i32$0 = $0, wasm2js_i32$1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1064208 | 0, 71 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
    $4 = 1;
   }
   HEAP32[$0 >> 2] = $4;
   core__ptr__drop_in_place_cardano_serialization_lib__TransactionBody___h9274013021a1d568($3 | 0);
   core__ptr__drop_in_place_cardano_serialization_lib__TransactionWitnessSet___h7d278d9502f6471a($3 + 344 | 0 | 0);
   i64toi32_i32$1 = $3;
   i64toi32_i32$2 = HEAP32[($3 + 272 | 0) >> 2] | 0;
   i64toi32_i32$5 = HEAP32[($3 + 276 | 0) >> 2] | 0;
   if (!(i64toi32_i32$2 | i64toi32_i32$5 | 0)) {
    break label$1
   }
   core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__metadata__GeneralTransactionMetadata____h37a091753d7f028f_1($3 + 280 | 0 | 0);
   core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__NativeScripts____hdd7d461255ec800a_2($3 + 320 | 0 | 0);
   core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__plutus__PlutusScripts____h6be1d55eac328b7f_2($3 + 332 | 0 | 0);
  }
  global$0 = $2 + 1408 | 0;
 }
 
 function cardano_serialization_lib__crypto__PrivateKey__generate_ed25519__hc5a5464d1f4c940e($0) {
  $0 = $0 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $1 = 0, i64toi32_i32$2 = 0, $4 = 0, $5 = 0, $2 = 0, $4$hi = 0, $5$hi = 0, $15 = 0, $16 = 0, $6 = 0, $7 = 0, $17 = 0, $6$hi = 0, $108 = 0, $3 = 0;
  $1 = global$0 - 160 | 0;
  global$0 = $1;
  rand_os__OsRng__new__hc49e74e2fe75aed3($1 + 128 | 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[($1 + 128 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $cardano_serialization_lib__chain_crypto__algorithms__ed25519__Ed25519_20as_20cardano_serialization_lib__chain_crypto__key__AsymmetricKey___generate__hb6bca437408c7cb9($1 + 88 | 0 | 1 | 0 | 0, HEAP32[($1 + 132 | 0) >> 2] | 0 | 0, HEAP32[(($1 + 128 | 0) + 8 | 0) >> 2] | 0 | 0);
    i64toi32_i32$2 = $1 + 113 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $4 = i64toi32_i32$0;
    $4$hi = i64toi32_i32$1;
    i64toi32_i32$0 = ($1 + 56 | 0) + 24 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $4;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $1 + 105 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $5 = i64toi32_i32$1;
    $5$hi = i64toi32_i32$0;
    i64toi32_i32$1 = ($1 + 56 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $5;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $1 + 97 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $6 = i64toi32_i32$0;
    $6$hi = i64toi32_i32$1;
    i64toi32_i32$0 = ($1 + 24 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $6;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $5$hi;
    i64toi32_i32$0 = ($1 + 24 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $5;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $4$hi;
    i64toi32_i32$0 = ($1 + 24 | 0) + 24 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $4;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = HEAPU8[($1 + 89 | 0) >> 0] | 0 | ((HEAPU8[($1 + 90 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 91 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 92 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[($1 + 93 | 0) >> 0] | 0 | ((HEAPU8[($1 + 94 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 95 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 96 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $7 = i64toi32_i32$1;
    i64toi32_i32$1 = $1;
    HEAP32[($1 + 24 | 0) >> 2] = $7;
    HEAP32[($1 + 28 | 0) >> 2] = i64toi32_i32$0;
    HEAP8[($0 + 1 | 0) >> 0] = 1;
    i64toi32_i32$1 = $0 + 2 | 0;
    $15 = $7;
    HEAP8[i64toi32_i32$1 >> 0] = $15;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $15 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $15 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $15 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$0 = $6$hi;
    i64toi32_i32$1 = $0 + 10 | 0;
    $16 = $6;
    HEAP8[i64toi32_i32$1 >> 0] = $16;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $16 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $16 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $16 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$0 = $5$hi;
    i64toi32_i32$1 = $0 + 18 | 0;
    HEAP8[i64toi32_i32$1 >> 0] = $5;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $5 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $5 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $5 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$0 = $4$hi;
    i64toi32_i32$1 = $0 + 26 | 0;
    HEAP8[i64toi32_i32$1 >> 0] = $4;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $4 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $4 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $4 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    $2 = 0;
    break label$1;
   }
   i64toi32_i32$2 = $1 + 140 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $4 = i64toi32_i32$0;
   $4$hi = i64toi32_i32$1;
   i64toi32_i32$0 = $1 + 34 | 0;
   HEAP16[i64toi32_i32$0 >> 1] = $4;
   HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $4 >>> 16 | 0;
   HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$1;
   HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
   $2 = HEAP32[(($1 + 128 | 0) + 20 | 0) >> 2] | 0;
   $17 = $1 + 42 | 0;
   HEAP16[$17 >> 1] = $2;
   HEAP16[($17 + 2 | 0) >> 1] = $2 >>> 16 | 0;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[($1 + 132 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($1 + 136 | 0) >> 2] | 0;
   $5 = i64toi32_i32$1;
   $5$hi = i64toi32_i32$0;
   i64toi32_i32$1 = $1;
   HEAP16[(i64toi32_i32$1 + 26 | 0) >> 1] = $5;
   HEAP16[(i64toi32_i32$1 + 28 | 0) >> 1] = $5 >>> 16 | 0;
   HEAP16[(i64toi32_i32$1 + 30 | 0) >> 1] = i64toi32_i32$0;
   HEAP16[(i64toi32_i32$1 + 32 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
   HEAP32[(i64toi32_i32$1 + 72 | 0) >> 2] = $2;
   $2 = i64toi32_i32$1 + 64 | 0;
   i64toi32_i32$0 = $4$hi;
   i64toi32_i32$1 = $2;
   HEAP32[i64toi32_i32$1 >> 2] = $4;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $5$hi;
   i64toi32_i32$1 = $1;
   HEAP32[(i64toi32_i32$1 + 56 | 0) >> 2] = $5;
   HEAP32[(i64toi32_i32$1 + 60 | 0) >> 2] = i64toi32_i32$0;
   core__fmt__ArgumentV1__new__hc180267ccf44df88(i64toi32_i32$1 + 16 | 0 | 0, i64toi32_i32$1 + 56 | 0 | 0, 109 | 0);
   HEAP32[((i64toi32_i32$1 + 88 | 0) + 20 | 0) >> 2] = 1;
   i64toi32_i32$0 = 0;
   HEAP32[(i64toi32_i32$1 + 92 | 0) >> 2] = 1;
   HEAP32[(i64toi32_i32$1 + 96 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[(i64toi32_i32$1 + 88 | 0) >> 2] = 1066504;
   i64toi32_i32$2 = i64toi32_i32$1;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] | 0;
   $108 = i64toi32_i32$0;
   i64toi32_i32$0 = $1;
   HEAP32[(i64toi32_i32$0 + 152 | 0) >> 2] = $108;
   HEAP32[(i64toi32_i32$0 + 156 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[(i64toi32_i32$0 + 104 | 0) >> 2] = i64toi32_i32$0 + 152 | 0;
   alloc__fmt__format__h6e9e003a52c07309(i64toi32_i32$0 + 128 | 0 | 0, i64toi32_i32$0 + 88 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e(i64toi32_i32$0 + 8 | 0 | 0, i64toi32_i32$0 + 128 | 0 | 0);
   $3 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] | 0 | 0, HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] | 0 | 0) | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7(i64toi32_i32$0 + 128 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2(i64toi32_i32$0 + 128 | 0 | 0);
   label$3 : {
    if (!(HEAP32[$2 >> 2] | 0)) {
     break label$3
    }
    core__ptr__drop_in_place_alloc__boxed__Box_dyn_20std__error__Error_core__marker__Sync_core__marker__Send____h3635675e5a953b32($2 | 0);
   }
   HEAP32[($0 + 4 | 0) >> 2] = $3;
   $2 = 1;
  }
  HEAP8[$0 >> 0] = $2;
  global$0 = $1 + 160 | 0;
 }
 
 function alloc__collections__btree__node__BalancingContext_K_2cV___do_merge__hc2870ff7477356f5($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $9 = 0, $14 = 0, $13 = 0, $2 = 0, $11 = 0, $4 = 0, $15 = 0, $3 = 0, $5 = 0, $16 = 0, $6 = 0, $7 = 0, $12 = 0, $17 = 0, $8 = 0, $10 = 0;
  label$1 : {
   $2 = HEAP32[($1 + 16 | 0) >> 2] | 0;
   $3 = HEAPU16[($2 + 50 | 0) >> 1] | 0;
   $4 = $3 + 1 | 0;
   $5 = HEAP32[($1 + 24 | 0) >> 2] | 0;
   $6 = HEAPU16[($5 + 50 | 0) >> 1] | 0;
   $7 = $4 + $6 | 0;
   if ($7 >>> 0 > 11 >>> 0) {
    break label$1
   }
   $8 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   $9 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   $10 = HEAP32[$1 >> 2] | 0;
   $11 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   $12 = HEAPU16[($11 + 50 | 0) >> 1] | 0;
   HEAP16[($2 + 50 | 0) >> 1] = $7;
   $13 = $11 + 4 | 0;
   $14 = $9 << 2 | 0;
   $15 = $13 + $14 | 0;
   $16 = HEAP32[$15 >> 2] | 0;
   $1 = $9 + 1 | 0;
   $17 = $1 << 2 | 0;
   $9 = ($12 + ($9 ^ -1 | 0) | 0) << 2 | 0;
   memmove($15 | 0, $13 + $17 | 0 | 0, $9 | 0) | 0;
   $13 = $2 + 4 | 0;
   HEAP32[($13 + ($3 << 2 | 0) | 0) >> 2] = $16;
   $16 = $6 << 2 | 0;
   memcpy($13 + ($4 << 2 | 0) | 0 | 0, $5 + 4 | 0 | 0, $16 | 0) | 0;
   $13 = 52;
   $15 = $11 + 52 | 0;
   memmove($15 + $17 | 0 | 0, ($14 + $15 | 0) + 8 | 0 | 0, $9 | 0) | 0;
   label$2 : {
    if ($1 >>> 0 >= $12 >>> 0) {
     break label$2
    }
    $9 = ($14 + $11 | 0) + 56 | 0;
    label$3 : while (1) {
     $14 = HEAP32[$9 >> 2] | 0;
     HEAP16[($14 + 48 | 0) >> 1] = $1;
     HEAP32[$14 >> 2] = $11;
     $9 = $9 + 4 | 0;
     $1 = $1 + 1 | 0;
     if (($12 | 0) != ($1 | 0)) {
      continue label$3
     }
     break label$3;
    };
   }
   HEAP16[($11 + 50 | 0) >> 1] = (HEAPU16[($11 + 50 | 0) >> 1] | 0) + -1 | 0;
   label$4 : {
    if ($10 >>> 0 <= 1 >>> 0) {
     break label$4
    }
    memcpy(($2 + ($4 << 2 | 0) | 0) + 52 | 0 | 0, $5 + 52 | 0 | 0, $16 + 4 | 0 | 0) | 0;
    $13 = 100;
    if ($7 >>> 0 <= $3 >>> 0) {
     break label$4
    }
    $9 = $6 + 1 | 0;
    $1 = (($3 << 2 | 0) + $2 | 0) + 56 | 0;
    label$5 : while (1) {
     $14 = HEAP32[$1 >> 2] | 0;
     HEAP16[($14 + 48 | 0) >> 1] = $4;
     HEAP32[$14 >> 2] = $2;
     $1 = $1 + 4 | 0;
     $4 = $4 + 1 | 0;
     $9 = $9 + -1 | 0;
     if ($9) {
      continue label$5
     }
     break label$5;
    };
   }
   __rust_dealloc($5 | 0, $13 | 0, 4 | 0);
   HEAP32[($0 + 4 | 0) >> 2] = $2;
   HEAP32[$0 >> 2] = $8;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1049692 | 0, 42 | 0, 1049736 | 0);
  abort();
 }
 
 function $cardano_serialization_lib__MultiAsset_20as_20core__cmp__PartialOrd___partial_cmp__is_all_zeros__ha3c92144892c9bcb($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $5 = 0, $3 = 0, $6$hi = 0, $4 = 0, $6 = 0, $26 = 0, $33 = 0, $36 = 0, $66 = 0, $73 = 0, $76 = 0, $102 = 0, $115$hi = 0;
  $2 = global$0 - 192 | 0;
  global$0 = $2;
  alloc__collections__btree__map__BTreeMap_K_2cV___iter__h677e802ff7e211c3($2 + 32 | 0 | 0, $0 | 0);
  HEAP32[(($2 + 64 | 0) + 24 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 24 | 0) >> 2] | 0;
  i64toi32_i32$2 = ($2 + 32 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $26 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 64 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $26;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = ($2 + 32 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $33 = i64toi32_i32$1;
  i64toi32_i32$1 = ($2 + 64 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $33;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $36 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 64 | 0) >> 2] = $36;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$1;
  $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h03cc330b7b1e4522($2 + 24 | 0 | 0, $2 + 64 | 0 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     $3 = HEAP32[($2 + 24 | 0) >> 2] | 0;
     if (!$3) {
      break label$3
     }
     $0 = HEAP32[($2 + 28 | 0) >> 2] | 0;
     $4 = $2 + 160 | 0 | 4 | 0;
     label$4 : while (1) {
      alloc__collections__btree__map__BTreeMap_K_2cV___iter__ha89c9458aca0228d($2 + 96 | 0 | 0, $0 | 0);
      HEAP32[(($2 + 128 | 0) + 24 | 0) >> 2] = HEAP32[(($2 + 96 | 0) + 24 | 0) >> 2] | 0;
      i64toi32_i32$2 = ($2 + 96 | 0) + 16 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $66 = i64toi32_i32$1;
      i64toi32_i32$1 = ($2 + 128 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $66;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = ($2 + 96 | 0) + 8 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $73 = i64toi32_i32$0;
      i64toi32_i32$0 = ($2 + 128 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $73;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $2;
      i64toi32_i32$1 = HEAP32[($2 + 96 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($2 + 100 | 0) >> 2] | 0;
      $76 = i64toi32_i32$1;
      i64toi32_i32$1 = $2;
      HEAP32[($2 + 128 | 0) >> 2] = $76;
      HEAP32[($2 + 132 | 0) >> 2] = i64toi32_i32$0;
      $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h36ca092f81b9a0fa($2 + 16 | 0 | 0, $2 + 128 | 0 | 0);
      label$5 : {
       $5 = HEAP32[($2 + 16 | 0) >> 2] | 0;
       if (!$5) {
        break label$5
       }
       $0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
       label$6 : while (1) {
        cardano_serialization_lib__MultiAsset__get__had0c36a2c855d776($2 + 160 | 0 | 0, $1 | 0, $3 | 0);
        label$7 : {
         label$8 : {
          if ((HEAP32[($2 + 160 | 0) >> 2] | 0 | 0) != (1 | 0)) {
           break label$8
          }
          HEAP32[(($2 + 176 | 0) + 8 | 0) >> 2] = HEAP32[($4 + 8 | 0) >> 2] | 0;
          i64toi32_i32$2 = $4;
          i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
          i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
          $102 = i64toi32_i32$0;
          i64toi32_i32$0 = $2;
          HEAP32[($2 + 176 | 0) >> 2] = $102;
          HEAP32[($2 + 180 | 0) >> 2] = i64toi32_i32$1;
          label$9 : {
           $5 = alloc__collections__btree__map__BTreeMap_K_2cV___get__h825f34112f7eacbf($2 + 176 | 0 | 0, $5 | 0) | 0;
           if (!$5) {
            break label$9
           }
           i64toi32_i32$2 = $5;
           i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
           i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
           $6 = i64toi32_i32$1;
           $6$hi = i64toi32_i32$0;
          }
          $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h6c9f94f0f82ce2b5($2 + 176 | 0 | 0);
          if ($5) {
           break label$7
          }
         }
         i64toi32_i32$0 = 0;
         $6 = 0;
         $6$hi = i64toi32_i32$0;
        }
        i64toi32_i32$2 = $0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $115$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $6$hi;
        i64toi32_i32$1 = $115$hi;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = $6$hi;
        if (i64toi32_i32$1 >>> 0 > i64toi32_i32$0 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$2 >>> 0 > $6 >>> 0 | 0) | 0) {
         break label$2
        }
        $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h36ca092f81b9a0fa($2 + 8 | 0 | 0, $2 + 128 | 0 | 0);
        $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
        $5 = HEAP32[($2 + 8 | 0) >> 2] | 0;
        if ($5) {
         continue label$6
        }
        break label$6;
       };
      }
      $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h03cc330b7b1e4522($2 | 0, $2 + 64 | 0 | 0);
      $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
      $3 = HEAP32[$2 >> 2] | 0;
      if ($3) {
       continue label$4
      }
      break label$4;
     };
    }
    $0 = 1;
    break label$1;
   }
   $0 = 0;
  }
  global$0 = $2 + 192 | 0;
  return $0 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert__hce42e63ba7a2d923($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $5 = 0, $6 = 0, $7 = 0, $54 = 0, $60 = 0, $66 = 0, $69 = 0, $106 = 0, $112 = 0, $118 = 0, $121 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $4 = global$0 - 160 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $5 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      if ((HEAPU16[($5 + 402 | 0) >> 1] | 0) >>> 0 < 11 >>> 0) {
       break label$4
      }
      alloc__collections__btree__node__splitpoint__h8424344594b4deb1($4 + 96 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
      $6 = HEAP32[($4 + 104 | 0) >> 2] | 0;
      $7 = HEAP32[($4 + 100 | 0) >> 2] | 0;
      $1 = HEAP32[$1 >> 2] | 0;
      HEAP32[($4 + 104 | 0) >> 2] = HEAP32[($4 + 96 | 0) >> 2] | 0;
      HEAP32[($4 + 100 | 0) >> 2] = $5;
      HEAP32[($4 + 96 | 0) >> 2] = $1;
      alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__KV___split__hc418ae44080ec59d($4 + 8 | 0 | 0, $4 + 96 | 0 | 0);
      if (($7 | 0) == (1 | 0)) {
       break label$3
      }
      HEAP32[($4 + 64 | 0) >> 2] = HEAP32[($4 + 48 | 0) >> 2] | 0;
      $1 = HEAP32[($4 + 52 | 0) >> 2] | 0;
      break label$2;
     }
     HEAP32[(($4 + 8 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $54 = i64toi32_i32$0;
     i64toi32_i32$0 = $4;
     HEAP32[($4 + 8 | 0) >> 2] = $54;
     HEAP32[($4 + 12 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $3 + 16 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $60 = i64toi32_i32$1;
     i64toi32_i32$1 = ($4 + 96 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $60;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $3 + 8 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $66 = i64toi32_i32$0;
     i64toi32_i32$0 = ($4 + 96 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $66;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $3;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $69 = i64toi32_i32$1;
     i64toi32_i32$1 = $4;
     HEAP32[($4 + 96 | 0) >> 2] = $69;
     HEAP32[($4 + 100 | 0) >> 2] = i64toi32_i32$0;
     (wasm2js_i32$0 = $0, wasm2js_i32$1 = alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_fit__h0a283f3f7809721f($1 | 0, $4 + 8 | 0 | 0, $4 + 96 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 64 | 0) >> 2] = wasm2js_i32$1;
     HEAP32[($0 + 8 | 0) >> 2] = $5;
     HEAP32[$0 >> 2] = 0;
     HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
     HEAP32[($0 + 4 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
     break label$1;
    }
    HEAP32[($4 + 64 | 0) >> 2] = HEAP32[($4 + 56 | 0) >> 2] | 0;
    $1 = HEAP32[($4 + 60 | 0) >> 2] | 0;
   }
   HEAP32[($4 + 72 | 0) >> 2] = $6;
   HEAP32[($4 + 68 | 0) >> 2] = $1;
   HEAP32[(($4 + 80 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $106 = i64toi32_i32$0;
   i64toi32_i32$0 = $4;
   HEAP32[($4 + 80 | 0) >> 2] = $106;
   HEAP32[($4 + 84 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $3 + 16 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $112 = i64toi32_i32$1;
   i64toi32_i32$1 = ($4 + 96 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $112;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $3 + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $118 = i64toi32_i32$0;
   i64toi32_i32$0 = ($4 + 96 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $118;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $121 = i64toi32_i32$1;
   i64toi32_i32$1 = $4;
   HEAP32[($4 + 96 | 0) >> 2] = $121;
   HEAP32[($4 + 100 | 0) >> 2] = i64toi32_i32$0;
   $1 = alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_fit__h0a283f3f7809721f($4 + 64 | 0 | 0, $4 + 80 | 0 | 0, $4 + 96 | 0 | 0) | 0;
   memcpy(($4 + 96 | 0) + 4 | 0 | 0, $4 + 8 | 0 | 0, 56 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
   memcpy($0 + 4 | 0 | 0, $4 + 96 | 0 | 0, 60 | 0) | 0;
   HEAP32[($0 + 64 | 0) >> 2] = $1;
  }
  global$0 = $4 + 160 | 0;
 }
 
 function $char_20as_20core__fmt__Debug___fmt__h09352abe59e90129($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$2 = 0, $7 = 0, $7$hi = 0, i64toi32_i32$5 = 0, i64toi32_i32$4 = 0, $5 = 0, $3 = 0, $4 = 0, $2 = 0, $18 = 0, $6 = 0, $80 = 0, $80$hi = 0, $82$hi = 0;
  $2 = 1;
  label$1 : {
   $3 = HEAP32[($1 + 24 | 0) >> 2] | 0;
   $4 = HEAP32[((HEAP32[($1 + 28 | 0) >> 2] | 0) + 16 | 0) >> 2] | 0;
   if (FUNCTION_TABLE[$4 | 0]($3, 39) | 0) {
    break label$1
   }
   $5 = 116;
   $1 = 2;
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           label$10 : {
            $0 = HEAP32[$0 >> 2] | 0;
            switch ($0 + -9 | 0 | 0) {
            case 0:
             break label$2;
            case 30:
             break label$6;
            case 1:
             break label$7;
            case 4:
             break label$8;
            case 2:
            case 3:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
            case 12:
            case 13:
            case 14:
            case 15:
            case 16:
            case 17:
            case 18:
            case 19:
            case 20:
            case 21:
            case 22:
            case 23:
            case 24:
            case 25:
            case 26:
            case 27:
            case 28:
            case 29:
             break label$9;
            default:
             break label$10;
            };
           }
           if (($0 | 0) == (92 | 0)) {
            break label$6
           }
          }
          if (core__unicode__unicode_data__grapheme_extend__lookup__hff46536597365d27($0 | 0) | 0) {
           break label$5
          }
          if (!(core__unicode__printable__is_printable__h052c3c4a29b5e66a($0 | 0) | 0)) {
           break label$4
          }
          $1 = 1;
          $5 = $0;
          break label$2;
         }
         $5 = 114;
         $1 = 2;
         break label$2;
        }
        $5 = 110;
        $1 = 2;
        break label$2;
       }
       $1 = 2;
       $5 = $0;
       break label$2;
      }
      i64toi32_i32$0 = 0;
      i64toi32_i32$2 = (Math_clz32($0 | 1 | 0) >>> 2 | 0) ^ 7 | 0;
      i64toi32_i32$1 = 5;
      i64toi32_i32$3 = 0;
      i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
      $7 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
      $7$hi = i64toi32_i32$1;
      break label$3;
     }
     i64toi32_i32$1 = 0;
     i64toi32_i32$0 = (Math_clz32($0 | 1 | 0) >>> 2 | 0) ^ 7 | 0;
     i64toi32_i32$2 = 5;
     i64toi32_i32$3 = 0;
     i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
     $7 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
     $7$hi = i64toi32_i32$2;
    }
    $1 = 3;
    $5 = $0;
   }
   label$11 : while (1) {
    $6 = $1;
    $1 = 0;
    $0 = $5;
    label$12 : {
     label$13 : {
      label$14 : {
       label$15 : {
        label$16 : {
         switch ($6 | 0) {
         case 1:
          break label$12;
         case 2:
          break label$14;
         case 3:
          break label$16;
         default:
          break label$15;
         };
        }
        label$17 : {
         label$18 : {
          label$19 : {
           label$20 : {
            label$21 : {
             i64toi32_i32$2 = $7$hi;
             i64toi32_i32$1 = $7;
             i64toi32_i32$0 = 0;
             i64toi32_i32$3 = 32;
             i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
             if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
              i64toi32_i32$0 = 0;
              $18 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
             } else {
              i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
              $18 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
             }
             switch ($18 & 255 | 0 | 0) {
             case 2:
              break label$17;
             case 5:
              break label$18;
             case 4:
              break label$19;
             case 3:
              break label$20;
             case 1:
              break label$21;
             default:
              break label$15;
             };
            }
            i64toi32_i32$0 = $7$hi;
            i64toi32_i32$2 = $7;
            i64toi32_i32$1 = -256;
            i64toi32_i32$3 = -1;
            i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
            $7 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
            $7$hi = i64toi32_i32$1;
            $0 = 125;
            $1 = 3;
            break label$12;
           }
           i64toi32_i32$1 = $7$hi;
           i64toi32_i32$0 = $7;
           i64toi32_i32$2 = -256;
           i64toi32_i32$3 = -1;
           i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
           i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
           i64toi32_i32$0 = 2;
           i64toi32_i32$3 = 0;
           i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
           $7 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
           $7$hi = i64toi32_i32$0;
           $0 = 123;
           $1 = 3;
           break label$12;
          }
          i64toi32_i32$0 = $7$hi;
          i64toi32_i32$2 = $7;
          i64toi32_i32$1 = -256;
          i64toi32_i32$3 = -1;
          i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
          i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
          i64toi32_i32$2 = 3;
          i64toi32_i32$3 = 0;
          i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
          $7 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
          $7$hi = i64toi32_i32$2;
          $0 = 117;
          $1 = 3;
          break label$12;
         }
         i64toi32_i32$2 = $7$hi;
         i64toi32_i32$1 = $7;
         i64toi32_i32$0 = -256;
         i64toi32_i32$3 = -1;
         i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
         i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
         i64toi32_i32$1 = 4;
         i64toi32_i32$3 = 0;
         i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
         $7 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
         $7$hi = i64toi32_i32$1;
         $0 = 92;
         $1 = 3;
         break label$12;
        }
        i64toi32_i32$1 = $7$hi;
        $1 = $7;
        $0 = ($5 >>> (($7 << 2 | 0) & 28 | 0) | 0) & 15 | 0;
        $0 = ($0 >>> 0 < 10 >>> 0 ? 48 : 87) + $0 | 0;
        if (!$7) {
         break label$13
        }
        i64toi32_i32$1 = $7$hi;
        i64toi32_i32$0 = $7;
        i64toi32_i32$2 = -1;
        i64toi32_i32$3 = -1;
        i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
        i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
        if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
         i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
        }
        i64toi32_i32$1 = i64toi32_i32$4;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = -1;
        i64toi32_i32$0 = i64toi32_i32$5 & i64toi32_i32$0 | 0;
        $80 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
        $80$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $7$hi;
        i64toi32_i32$5 = $7;
        i64toi32_i32$1 = -1;
        i64toi32_i32$3 = 0;
        i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
        $82$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $80$hi;
        i64toi32_i32$0 = $80;
        i64toi32_i32$5 = $82$hi;
        i64toi32_i32$3 = $7 & i64toi32_i32$3 | 0;
        i64toi32_i32$5 = i64toi32_i32$1 | i64toi32_i32$5 | 0;
        $7 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
        $7$hi = i64toi32_i32$5;
        $1 = 3;
        break label$12;
       }
       $2 = FUNCTION_TABLE[$4 | 0]($3, 39) | 0;
       break label$1;
      }
      $0 = 92;
      $1 = 1;
      break label$12;
     }
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$5 = $7$hi;
     i64toi32_i32$1 = $7;
     i64toi32_i32$0 = -256;
     i64toi32_i32$3 = -1;
     i64toi32_i32$0 = $7$hi & i64toi32_i32$0 | 0;
     i64toi32_i32$5 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     i64toi32_i32$1 = 1;
     i64toi32_i32$3 = 0;
     i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
     $7 = i64toi32_i32$5 | i64toi32_i32$3 | 0;
     $7$hi = i64toi32_i32$1;
     $1 = 3;
    }
    if (!(FUNCTION_TABLE[$4 | 0]($3, $0) | 0)) {
     continue label$11
    }
    break label$11;
   };
  }
  return $2 | 0;
 }
 
 function certificate_as_stake_delegation($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $22 = 0, $23 = 0, $3 = 0, $2 = 0, $5 = 0, $5$hi = 0, $4 = 0, $6 = 0, $6$hi = 0, $37 = 0, $53 = 0, $59 = 0, $69 = 0, $88 = 0, $95 = 0, $101 = 0, $107 = 0, $116 = 0, $119 = 0;
  $1 = global$0 - 224 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h3b62e22150831bdc($1 | 0, $0 | 0);
   $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   $3 = 2;
   label$2 : {
    $0 = HEAP32[$1 >> 2] | 0;
    if ((HEAPU8[$0 >> 0] | 0 | 0) != (2 | 0)) {
     break label$2
    }
    i64toi32_i32$2 = $0 + 2 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $5 = i64toi32_i32$0;
    $5$hi = i64toi32_i32$1;
    $22 = $0 + 26 | 0;
    $4 = HEAPU8[$22 >> 0] | 0 | ((HEAPU8[($22 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($22 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($22 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$2 = $0 + 18 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $6 = i64toi32_i32$1;
    $6$hi = i64toi32_i32$0;
    $3 = HEAPU8[($0 + 1 | 0) >> 0] | 0;
    i64toi32_i32$2 = $0 + 10 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $37 = i64toi32_i32$0;
    i64toi32_i32$0 = ($1 + 40 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $37;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $6$hi;
    i64toi32_i32$0 = ($1 + 40 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $6;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(($1 + 40 | 0) + 24 | 0) >> 2] = $4;
    i64toi32_i32$1 = $5$hi;
    i64toi32_i32$0 = $1;
    HEAP32[($1 + 40 | 0) >> 2] = $5;
    HEAP32[($1 + 44 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $0 + 38 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $53 = i64toi32_i32$1;
    i64toi32_i32$1 = ($1 + 8 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $53;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $0 + 46 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $59 = i64toi32_i32$0;
    i64toi32_i32$0 = ($1 + 8 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $59;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    $23 = $0 + 54 | 0;
    HEAP32[(($1 + 8 | 0) + 24 | 0) >> 2] = HEAPU8[$23 >> 0] | 0 | ((HEAPU8[($23 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($23 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($23 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$2 = $0 + 30 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $69 = i64toi32_i32$1;
    i64toi32_i32$1 = $1;
    HEAP32[($1 + 8 | 0) >> 2] = $69;
    HEAP32[($1 + 12 | 0) >> 2] = i64toi32_i32$0;
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
   HEAP32[(($1 + 72 | 0) + 24 | 0) >> 2] = HEAP32[(($1 + 40 | 0) + 24 | 0) >> 2] | 0;
   i64toi32_i32$2 = ($1 + 40 | 0) + 16 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $88 = i64toi32_i32$0;
   i64toi32_i32$0 = ($1 + 72 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $88;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = ($1 + 40 | 0) + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $95 = i64toi32_i32$1;
   i64toi32_i32$1 = ($1 + 72 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $95;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = ($1 + 8 | 0) + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $101 = i64toi32_i32$0;
   i64toi32_i32$0 = $1 + 108 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $101;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = ($1 + 8 | 0) + 16 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $107 = i64toi32_i32$1;
   i64toi32_i32$1 = $1 + 116 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $107;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($1 + 124 | 0) >> 2] = HEAP32[(($1 + 8 | 0) + 24 | 0) >> 2] | 0;
   i64toi32_i32$2 = $1;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] | 0;
   $116 = i64toi32_i32$0;
   i64toi32_i32$0 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$2 + 72 | 0) >> 2] = $116;
   HEAP32[(i64toi32_i32$2 + 76 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
   $119 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$2 + 100 | 0) >> 2] = $119;
   HEAP32[(i64toi32_i32$2 + 104 | 0) >> 2] = i64toi32_i32$0;
   $0 = 0;
   label$3 : {
    if (($3 & 255 | 0 | 0) == (2 | 0)) {
     break label$3
    }
    HEAP8[($1 + 160 | 0) >> 0] = $3;
    memcpy($1 + 160 | 0 | 1 | 0 | 0, $1 + 72 | 0 | 0, 56 | 0) | 0;
    $0 = $cardano_serialization_lib__StakeDelegation_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hfbbb778a4aa15e31($1 + 160 | 0 | 0) | 0;
   }
   global$0 = $1 + 224 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function cardano_serialization_lib__tx_builder__TransactionBuilder__get_explicit_output__h759c362a670068a6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $4 = 0, $11 = 0, $11$hi = 0, $3 = 0, $6 = 0, $7 = 0, $10 = 0, $5 = 0, $8 = 0, $9 = 0, $41 = 0, $69 = 0, $75 = 0, $101 = 0, $121 = 0;
  $2 = global$0 - 128 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $3 = HEAP32[($1 + 424 | 0) >> 2] | 0;
      if ($3) {
       break label$4
      }
      i64toi32_i32$0 = 0;
      $11 = 0;
      $11$hi = i64toi32_i32$0;
      $4 = 0;
      break label$3;
     }
     $1 = HEAP32[($1 + 416 | 0) >> 2] | 0;
     $5 = $1 + ($3 << 7 | 0) | 0;
     $6 = $2 + 44 | 0;
     $7 = ($2 + 88 | 0) + 8 | 0;
     $8 = $2 + 112 | 0 | 4 | 0;
     $3 = ($2 + 56 | 0) + 12 | 0;
     $9 = ($2 + 88 | 0) + 12 | 0;
     $4 = 0;
     i64toi32_i32$0 = 0;
     $11 = 0;
     $11$hi = i64toi32_i32$0;
     label$5 : while (1) {
      i64toi32_i32$2 = $2;
      i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
      $41 = i64toi32_i32$0;
      i64toi32_i32$0 = $3;
      HEAP32[i64toi32_i32$0 >> 2] = $41;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      $10 = ($2 + 8 | 0) + 8 | 0;
      HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[$10 >> 2] | 0;
      HEAP32[($2 + 64 | 0) >> 2] = $4;
      i64toi32_i32$1 = $11$hi;
      i64toi32_i32$0 = $2;
      HEAP32[($2 + 56 | 0) >> 2] = $11;
      HEAP32[($2 + 60 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($2 + 80 | 0) >> 2] = $1;
      i64toi32_i32$2 = $1 + 64 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $11 = i64toi32_i32$1;
      $11$hi = i64toi32_i32$0;
      $4 = 0;
      label$6 : {
       if ((HEAP32[($1 + 72 | 0) >> 2] | 0 | 0) != (1 | 0)) {
        break label$6
       }
       $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($8 | 0, $1 + 76 | 0 | 0);
       $4 = 1;
      }
      HEAP32[($2 + 112 | 0) >> 2] = $4;
      i64toi32_i32$2 = $2;
      i64toi32_i32$0 = HEAP32[($2 + 112 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($2 + 116 | 0) >> 2] | 0;
      $69 = i64toi32_i32$0;
      i64toi32_i32$0 = $7;
      HEAP32[i64toi32_i32$0 >> 2] = $69;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = ($2 + 112 | 0) + 8 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $75 = i64toi32_i32$1;
      i64toi32_i32$1 = $7 + 8 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $75;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$0 = $11$hi;
      i64toi32_i32$1 = $2;
      HEAP32[($2 + 88 | 0) >> 2] = $11;
      HEAP32[($2 + 92 | 0) >> 2] = i64toi32_i32$0;
      cardano_serialization_lib__utils__Value__checked_add__h5184687782847801($2 + 24 | 0 | 0, $2 + 56 | 0 | 0, $2 + 88 | 0 | 0);
      label$7 : {
       if (!(HEAP32[($2 + 96 | 0) >> 2] | 0)) {
        break label$7
       }
       $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($9 | 0);
      }
      label$8 : {
       if (!(HEAP32[($2 + 64 | 0) >> 2] | 0)) {
        break label$8
       }
       $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($3 | 0);
      }
      if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$2
      }
      HEAP32[$10 >> 2] = HEAP32[($6 + 8 | 0) >> 2] | 0;
      i64toi32_i32$2 = $6;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $101 = i64toi32_i32$0;
      i64toi32_i32$0 = $2;
      HEAP32[($2 + 8 | 0) >> 2] = $101;
      HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
      $4 = HEAP32[($2 + 40 | 0) >> 2] | 0;
      i64toi32_i32$2 = $2;
      i64toi32_i32$1 = HEAP32[($2 + 32 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($2 + 36 | 0) >> 2] | 0;
      $11 = i64toi32_i32$1;
      $11$hi = i64toi32_i32$0;
      $1 = $1 + 128 | 0;
      if (($5 | 0) != ($1 | 0)) {
       continue label$5
      }
      break label$5;
     };
    }
    HEAP32[$0 >> 2] = 0;
    HEAP32[($0 + 16 | 0) >> 2] = $4;
    i64toi32_i32$0 = $11$hi;
    i64toi32_i32$1 = $0 + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $11;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $121 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 20 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $121;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($0 + 28 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
    break label$1;
   }
   $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($2 + 28 | 0) >> 2] | 0 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
  }
  global$0 = $2 + 128 | 0;
 }
 
 function alloc__collections__btree__node__BalancingContext_K_2cV___do_merge__h389c83b864be02be($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $8 = 0, $13 = 0, $10 = 0, $12 = 0, $2 = 0, $4 = 0, $14 = 0, $3 = 0, $5 = 0, $15 = 0, $6 = 0, $7 = 0, $11 = 0, $9 = 0, $16 = 0;
  label$1 : {
   $2 = HEAP32[($1 + 16 | 0) >> 2] | 0;
   $3 = HEAPU16[($2 + 50 | 0) >> 1] | 0;
   $4 = $3 + 1 | 0;
   $5 = HEAP32[($1 + 24 | 0) >> 2] | 0;
   $6 = HEAPU16[($5 + 50 | 0) >> 1] | 0;
   $7 = $4 + $6 | 0;
   if ($7 >>> 0 > 11 >>> 0) {
    break label$1
   }
   $8 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   $9 = HEAP32[$1 >> 2] | 0;
   $10 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   $11 = HEAPU16[($10 + 50 | 0) >> 1] | 0;
   HEAP16[($2 + 50 | 0) >> 1] = $7;
   $12 = $10 + 4 | 0;
   $13 = $8 << 2 | 0;
   $14 = $12 + $13 | 0;
   $15 = HEAP32[$14 >> 2] | 0;
   $1 = $8 + 1 | 0;
   $16 = $1 << 2 | 0;
   $8 = ($11 + ($8 ^ -1 | 0) | 0) << 2 | 0;
   memmove($14 | 0, $12 + $16 | 0 | 0, $8 | 0) | 0;
   $12 = $2 + 4 | 0;
   HEAP32[($12 + ($3 << 2 | 0) | 0) >> 2] = $15;
   $15 = $6 << 2 | 0;
   memcpy($12 + ($4 << 2 | 0) | 0 | 0, $5 + 4 | 0 | 0, $15 | 0) | 0;
   $12 = 52;
   $14 = $10 + 52 | 0;
   memmove($14 + $16 | 0 | 0, ($13 + $14 | 0) + 8 | 0 | 0, $8 | 0) | 0;
   label$2 : {
    if ($1 >>> 0 >= $11 >>> 0) {
     break label$2
    }
    $8 = ($13 + $10 | 0) + 56 | 0;
    label$3 : while (1) {
     $13 = HEAP32[$8 >> 2] | 0;
     HEAP16[($13 + 48 | 0) >> 1] = $1;
     HEAP32[$13 >> 2] = $10;
     $8 = $8 + 4 | 0;
     $1 = $1 + 1 | 0;
     if (($11 | 0) != ($1 | 0)) {
      continue label$3
     }
     break label$3;
    };
   }
   HEAP16[($10 + 50 | 0) >> 1] = (HEAPU16[($10 + 50 | 0) >> 1] | 0) + -1 | 0;
   label$4 : {
    if ($9 >>> 0 <= 1 >>> 0) {
     break label$4
    }
    memcpy(($2 + ($4 << 2 | 0) | 0) + 52 | 0 | 0, $5 + 52 | 0 | 0, $15 + 4 | 0 | 0) | 0;
    $12 = 100;
    if ($7 >>> 0 <= $3 >>> 0) {
     break label$4
    }
    $8 = $6 + 1 | 0;
    $1 = (($3 << 2 | 0) + $2 | 0) + 56 | 0;
    label$5 : while (1) {
     $13 = HEAP32[$1 >> 2] | 0;
     HEAP16[($13 + 48 | 0) >> 1] = $4;
     HEAP32[$13 >> 2] = $2;
     $1 = $1 + 4 | 0;
     $4 = $4 + 1 | 0;
     $8 = $8 + -1 | 0;
     if ($8) {
      continue label$5
     }
     break label$5;
    };
   }
   __rust_dealloc($5 | 0, $12 | 0, 4 | 0);
   HEAP32[($0 + 4 | 0) >> 2] = $10;
   HEAP32[$0 >> 2] = $9;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1049692 | 0, 42 | 0, 1049736 | 0);
  abort();
 }
 
 function $core__iter__adapters__map__Map_I_2cF__20as_20core__iter__traits__iterator__Iterator___try_fold__ha2c2d2161829fd45($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $8 = 0, $7 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $6 = 0, $10 = 0, $11 = 0, $11$hi = 0, $4 = 0, $9 = 0, $18 = 0, $19 = 0;
  $4 = 2;
  label$1 : {
   label$2 : {
    $5 = HEAP32[$1 >> 2] | 0;
    $6 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (($5 | 0) == ($6 | 0)) {
     break label$2
    }
    $7 = $5 + 1 | 0;
    HEAP32[$1 >> 2] = $7;
    label$3 : {
     label$4 : {
      label$5 : {
       $8 = HEAPU8[$5 >> 0] | 0;
       if ((($8 << 24 | 0) >> 24 | 0 | 0) > (-1 | 0)) {
        break label$5
       }
       label$6 : {
        label$7 : {
         if (($7 | 0) != ($6 | 0)) {
          break label$7
         }
         $5 = 0;
         $7 = $6;
         break label$6;
        }
        $7 = $5 + 2 | 0;
        HEAP32[$1 >> 2] = $7;
        $5 = (HEAPU8[($5 + 1 | 0) >> 0] | 0) & 63 | 0;
       }
       $9 = $8 & 31 | 0;
       label$8 : {
        label$9 : {
         if ($8 >>> 0 > 223 >>> 0) {
          break label$9
         }
         $8 = $5 | ($9 << 6 | 0) | 0;
         break label$8;
        }
        label$10 : {
         label$11 : {
          if (($7 | 0) != ($6 | 0)) {
           break label$11
          }
          $7 = 0;
          $10 = $6;
          break label$10;
         }
         $10 = $7 + 1 | 0;
         HEAP32[$1 >> 2] = $10;
         $7 = (HEAPU8[$7 >> 0] | 0) & 63 | 0;
        }
        $7 = $7 | ($5 << 6 | 0) | 0;
        label$12 : {
         if ($8 >>> 0 >= 240 >>> 0) {
          break label$12
         }
         $8 = $7 | ($9 << 12 | 0) | 0;
         break label$8;
        }
        label$13 : {
         label$14 : {
          if (($10 | 0) != ($6 | 0)) {
           break label$14
          }
          $8 = 0;
          break label$13;
         }
         HEAP32[$1 >> 2] = $10 + 1 | 0;
         $8 = (HEAPU8[$10 >> 0] | 0) & 63 | 0;
        }
        $8 = $7 << 6 | 0 | (($9 << 18 | 0) & 1835008 | 0) | 0 | $8 | 0;
        if (($8 | 0) == (1114112 | 0)) {
         break label$1
        }
       }
       if ($8 >>> 0 > 127 >>> 0) {
        break label$4
       }
      }
      label$15 : {
       label$16 : {
        label$17 : {
         if (($8 + -97 | 0) >>> 0 < 26 >>> 0) {
          break label$17
         }
         if (($8 + -65 | 0) >>> 0 >= 26 >>> 0) {
          break label$15
         }
         i64toi32_i32$0 = 0;
         $11 = 6;
         $11$hi = i64toi32_i32$0;
         $1 = HEAP32[($1 + 8 | 0) >> 2] | 0;
         switch (HEAPU8[$1 >> 0] | 0 | 0) {
         case 2:
          break label$16;
         case 1:
          break label$3;
         default:
          break label$15;
         };
        }
        i64toi32_i32$0 = 0;
        $11 = 6;
        $11$hi = i64toi32_i32$0;
        label$18 : {
         $1 = HEAP32[($1 + 8 | 0) >> 2] | 0;
         switch (HEAPU8[$1 >> 0] | 0 | 0) {
         case 1:
          break label$15;
         case 2:
          break label$18;
         default:
          break label$3;
         };
        }
        HEAP8[$1 >> 0] = 1;
        break label$15;
       }
       HEAP8[$1 >> 0] = 0;
      }
      $4 = 1;
      $5 = HEAPU8[($8 + 1139128 | 0) >> 0] | 0;
      if ($5 >>> 0 < 32 >>> 0) {
       break label$1
      }
      i64toi32_i32$0 = 0;
      i64toi32_i32$2 = $8;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 32;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       $18 = 0;
      } else {
       i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
       $18 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
      }
      i64toi32_i32$0 = $18;
      i64toi32_i32$2 = 0;
      i64toi32_i32$3 = 3;
      i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
      $11 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
      $11$hi = i64toi32_i32$2;
      break label$3;
     }
     i64toi32_i32$2 = 0;
     i64toi32_i32$1 = $8;
     i64toi32_i32$0 = 0;
     i64toi32_i32$3 = 32;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
      $19 = 0;
     } else {
      i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
      $19 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
     }
     i64toi32_i32$2 = $19;
     i64toi32_i32$1 = 0;
     i64toi32_i32$3 = 3;
     i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
     $11 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
     $11$hi = i64toi32_i32$1;
    }
    i64toi32_i32$1 = $11$hi;
    i64toi32_i32$2 = HEAP32[$3 >> 2] | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $11;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
    $4 = 0;
   }
  }
  HEAP8[($0 + 1 | 0) >> 0] = $5;
  HEAP8[$0 >> 0] = $4;
 }
 
 function num_bigint__bigint__addition___impl_20core__ops__arith__Add__num_bigint__bigint__BigInt__20for_20_num_bigint__bigint__BigInt___add__h354544d3f4ae9625_1($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, $5 = 0, $7 = 0, $6 = 0;
  $3 = global$0 - 64 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    $4 = HEAPU8[($2 + 12 | 0) >> 0] | 0;
    if (($4 | 0) != (1 | 0)) {
     break label$2
    }
    $2 = HEAPU8[($1 + 12 | 0) >> 0] | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hd36b5d149e6fd98b($0 | 0, $1 | 0);
    HEAP8[($0 + 12 | 0) >> 0] = $2;
    break label$1;
   }
   label$3 : {
    label$4 : {
     label$5 : {
      label$6 : {
       label$7 : {
        $5 = HEAPU8[($1 + 12 | 0) >> 0] | 0;
        switch ($5 | 0) {
        case 2:
         break label$6;
        case 1:
         break label$7;
        default:
         break label$5;
        };
       }
       $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hd36b5d149e6fd98b($0 | 0, $2 | 0);
       HEAP8[($0 + 12 | 0) >> 0] = $4;
       break label$1;
      }
      if ($4) {
       break label$4
      }
      break label$3;
     }
     if ($4) {
      break label$3
     }
    }
    label$8 : {
     label$9 : {
      if ((HEAP32[($1 + 8 | 0) >> 2] | 0) >>> 0 >= (HEAP32[($2 + 8 | 0) >> 2] | 0) >>> 0) {
       break label$9
      }
      $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hd36b5d149e6fd98b($3 + 48 | 0 | 0, $2 | 0);
      num_bigint__biguint__addition___impl_20core__ops__arith__Add__num_bigint__biguint__BigUint__20for_20num_bigint__biguint__BigUint___add__ha6a5672f04e3ed65($3 + 32 | 0 | 0, $3 + 48 | 0 | 0, $1 | 0);
      break label$8;
     }
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hd36b5d149e6fd98b($3 + 48 | 0 | 0, $1 | 0);
     num_bigint__biguint__addition___impl_20core__ops__arith__Add__num_bigint__biguint__BigUint__20for_20num_bigint__biguint__BigUint___add__ha6a5672f04e3ed65($3 + 32 | 0 | 0, $3 + 48 | 0 | 0, $2 | 0);
    }
    num_bigint__bigint__BigInt__from_biguint__hc8c58ec5989a4432($0 | 0, $5 | 0, $3 + 32 | 0 | 0);
    break label$1;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h7a0ed8a251b429e6($3 + 24 | 0 | 0, $1 | 0);
   $6 = HEAP32[($3 + 24 | 0) >> 2] | 0;
   $4 = HEAP32[($3 + 28 | 0) >> 2] | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h7a0ed8a251b429e6($3 + 16 | 0 | 0, $2 | 0);
   label$10 : {
    $5 = HEAP32[($3 + 20 | 0) >> 2] | 0;
    $7 = $4 >>> 0 < $5 >>> 0 ? -1 : ($4 | 0) != ($5 | 0);
    if ($7) {
     break label$10
    }
    $7 = HEAP32[($3 + 16 | 0) >> 2] | 0;
    core__iter__adapters__rev__Rev_T___new__h91ca0d56df8c38ae($3 + 8 | 0 | 0, $6 | 0, $6 + ($4 << 2 | 0) | 0 | 0);
    $4 = HEAP32[($3 + 12 | 0) >> 2] | 0;
    $6 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    core__iter__adapters__rev__Rev_T___new__h91ca0d56df8c38ae($3 | 0, $7 | 0, $7 + ($5 << 2 | 0) | 0 | 0);
    $7 = core__iter__traits__iterator__Iterator__cmp__he292810785df7a3c($6 | 0, $4 | 0, HEAP32[$3 >> 2] | 0 | 0, HEAP32[($3 + 4 | 0) >> 2] | 0 | 0) | 0;
   }
   label$11 : {
    switch ((($7 << 24 | 0) >> 24 | 0) + 1 | 0 | 0) {
    default:
     $4 = HEAPU8[($2 + 12 | 0) >> 0] | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hd36b5d149e6fd98b($3 + 48 | 0 | 0, $2 | 0);
     num_bigint__biguint__subtraction___impl_20core__ops__arith__Sub__num_bigint__biguint__BigUint__20for_20num_bigint__biguint__BigUint___sub__hac2d36d0edc5bcae($3 + 32 | 0 | 0, $3 + 48 | 0 | 0, $1 | 0);
     num_bigint__bigint__BigInt__from_biguint__hc8c58ec5989a4432($0 | 0, $4 | 0, $3 + 32 | 0 | 0);
     break label$1;
    case 1:
     HEAP32[($0 + 4 | 0) >> 2] = 0;
     HEAP32[($0 + 8 | 0) >> 2] = 0;
     HEAP8[($0 + 12 | 0) >> 0] = 1;
     HEAP32[$0 >> 2] = HEAP32[(0 + 1057660 | 0) >> 2] | 0;
     break label$1;
    case 2:
     break label$11;
    };
   }
   $4 = HEAPU8[($1 + 12 | 0) >> 0] | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hd36b5d149e6fd98b($3 + 48 | 0 | 0, $1 | 0);
   num_bigint__biguint__subtraction___impl_20core__ops__arith__Sub__num_bigint__biguint__BigUint__20for_20num_bigint__biguint__BigUint___sub__hac2d36d0edc5bcae($3 + 32 | 0 | 0, $3 + 48 | 0 | 0, $2 | 0);
   num_bigint__bigint__BigInt__from_biguint__hc8c58ec5989a4432($0 | 0, $4 | 0, $3 + 32 | 0 | 0);
  }
  global$0 = $3 + 64 | 0;
 }
 
 function cardano_serialization_lib__TransactionWitnessSets__get__h4ffac11a62c016aa($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, $4 = 0, i64toi32_i32$1 = 0, $5 = 0, i64toi32_i32$2 = 0, $78 = 0, $91 = 0, $101 = 0, $104 = 0, $107 = 0;
  $3 = global$0 - 64 | 0;
  global$0 = $3;
  label$1 : {
   $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   if ($4 >>> 0 <= $2 >>> 0) {
    break label$1
   }
   $1 = HEAP32[$1 >> 2] | 0;
   $4 = $1 + Math_imul($2, 76) | 0;
   $5 = $4 + 12 | 0;
   label$2 : {
    label$3 : {
     if (HEAP32[$4 >> 2] | 0) {
      break label$3
     }
     HEAP32[$3 >> 2] = 0;
     break label$2;
    }
    $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h26733a351c1d0f0b($3 | 0, $4 | 0);
   }
   $4 = $4 + 24 | 0;
   label$4 : {
    label$5 : {
     $5 = HEAP32[$5 >> 2] | 0;
     if ($5) {
      break label$5
     }
     HEAP32[($3 + 16 | 0) >> 2] = 0;
     break label$4;
    }
    alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($3 + 16 | 0 | 0, $5 | 0, HEAP32[(($1 + Math_imul($2, 76) | 0) + 20 | 0) >> 2] | 0 | 0);
   }
   label$6 : {
    label$7 : {
     if (HEAP32[$4 >> 2] | 0) {
      break label$7
     }
     HEAP32[($3 + 32 | 0) >> 2] = 0;
     break label$6;
    }
    $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h09a8331f58cd0bf4($3 + 32 | 0 | 0, $4 | 0);
   }
   $5 = $0 + 36 | 0;
   label$8 : {
    label$9 : {
     $4 = $1 + Math_imul($2, 76) | 0;
     if (HEAP32[($4 + 36 | 0) >> 2] | 0) {
      break label$9
     }
     HEAP32[$5 >> 2] = 0;
     break label$8;
    }
    $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hc722e22117ee5940($5 | 0, $4 + 36 | 0 | 0);
   }
   $5 = $4 + 64 | 0;
   label$10 : {
    label$11 : {
     $2 = ($1 + Math_imul($2, 76) | 0) + 60 | 0;
     if ((HEAPU8[$2 >> 0] | 0 | 0) != (3 | 0)) {
      break label$11
     }
     HEAP8[($0 + 60 | 0) >> 0] = 3;
     break label$10;
    }
    $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hc831120dea694494($3 + 48 | 0 | 0, $4 + 48 | 0 | 0);
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAP32[($3 + 48 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($3 + 52 | 0) >> 2] | 0;
    $78 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 48 | 0) >> 2] = $78;
    HEAP32[(i64toi32_i32$0 + 52 | 0) >> 2] = i64toi32_i32$1;
    $2 = HEAPU8[$2 >> 0] | 0;
    HEAP8[($3 + 60 | 0) >> 0] = ($2 | 0) == (2 | 0) ? 2 : ($2 | 0) != (0 | 0);
    i64toi32_i32$2 = $3 + 56 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $91 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 56 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $91;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   }
   $2 = $0 + 64 | 0;
   label$12 : {
    label$13 : {
     if (HEAP32[$5 >> 2] | 0) {
      break label$13
     }
     HEAP32[$2 >> 2] = 0;
     break label$12;
    }
    $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h1b9d2509f9812649($2 | 0, $5 | 0);
   }
   i64toi32_i32$2 = $3;
   i64toi32_i32$0 = HEAP32[$3 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($3 + 4 | 0) >> 2] | 0;
   $101 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[i64toi32_i32$0 >> 2] = $101;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[($3 + 16 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($3 + 20 | 0) >> 2] | 0;
   $104 = i64toi32_i32$1;
   i64toi32_i32$1 = $0;
   HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = $104;
   HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $3;
   i64toi32_i32$0 = HEAP32[($3 + 32 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($3 + 36 | 0) >> 2] | 0;
   $107 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = $107;
   HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($3 + 8 | 0) >> 2] | 0;
   HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = HEAP32[(($3 + 16 | 0) + 8 | 0) >> 2] | 0;
   HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] = HEAP32[(($3 + 32 | 0) + 8 | 0) >> 2] | 0;
   global$0 = $3 + 64 | 0;
   return;
  }
  core__panicking__panic_bounds_check__h808b524af17640b1($2 | 0, $4 | 0, 1054244 | 0);
  abort();
 }
 
 function $std__io__error__Repr_20as_20core__fmt__Debug___fmt__h60bb01be6ded0137($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $13 = 0, $14 = 0, $15 = 0, $17 = 0, $18 = 0, $16 = 0, $34 = 0, $36 = 0, $4 = 0, $82 = 0, $96 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     switch (HEAPU8[$0 >> 0] | 0 | 0) {
     default:
      HEAP32[$2 >> 2] = HEAP32[($0 + 4 | 0) >> 2] | 0;
      i64toi32_i32$0 = core__fmt__Formatter__debug_struct__h873400a11fe69724($1 | 0, 1143644 | 0, 2 | 0) | 0;
      i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
      $16 = i64toi32_i32$0;
      i64toi32_i32$0 = $2;
      HEAP32[($2 + 24 | 0) >> 2] = $16;
      HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$1;
      $0 = core__fmt__builders__DebugStruct__field__hec833bfe02704935($2 + 24 | 0 | 0, 1143646 | 0, 4 | 0, $2 | 0, 1143652 | 0) | 0;
      HEAP8[($2 + 7 | 0) >> 0] = 40;
      $1 = core__fmt__builders__DebugStruct__field__hec833bfe02704935($0 | 0, 1143595 | 0, 4 | 0, $2 + 7 | 0 | 0, 1143600 | 0) | 0;
      $0 = __rust_alloc(20 | 0, 1 | 0) | 0;
      if (!$0) {
       break label$1
      }
      $13 = 0;
      $14 = $0 + 16 | 0;
      $15 = HEAPU8[($13 + 1145240 | 0) >> 0] | 0 | ((HEAPU8[($13 + 1145241 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($13 + 1145242 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($13 + 1145243 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[$14 >> 0] = $15;
      HEAP8[($14 + 1 | 0) >> 0] = $15 >>> 8 | 0;
      HEAP8[($14 + 2 | 0) >> 0] = $15 >>> 16 | 0;
      HEAP8[($14 + 3 | 0) >> 0] = $15 >>> 24 | 0;
      i64toi32_i32$2 = 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 1145232 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1145233 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 1145234 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 1145235 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 1145236 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1145237 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 1145238 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 1145239 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $34 = i64toi32_i32$1;
      i64toi32_i32$1 = $0 + 8 | 0;
      $17 = $34;
      HEAP8[i64toi32_i32$1 >> 0] = $17;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      i64toi32_i32$2 = 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 1145224 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1145225 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 1145226 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 1145227 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 1145228 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1145229 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 1145230 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 1145231 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $36 = i64toi32_i32$0;
      i64toi32_i32$0 = $0;
      $18 = $36;
      HEAP8[i64toi32_i32$0 >> 0] = $18;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $18 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $18 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $18 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      i64toi32_i32$0 = $2;
      i64toi32_i32$1 = 20;
      HEAP32[($2 + 12 | 0) >> 2] = 20;
      HEAP32[($2 + 16 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[($2 + 8 | 0) >> 2] = $0;
      $0 = core__fmt__builders__DebugStruct__finish__hb1eae1aa0e288840(core__fmt__builders__DebugStruct__field__hec833bfe02704935($1 | 0, 1143616 | 0, 7 | 0, $2 + 8 | 0 | 0, 1143668 | 0) | 0 | 0) | 0;
      $1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
      if (!$1) {
       break label$2
      }
      $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
      if (!$3) {
       break label$2
      }
      __rust_dealloc($1 | 0, $3 | 0, 1 | 0);
      break label$2;
     case 1:
      HEAP8[($2 + 24 | 0) >> 0] = HEAPU8[($0 + 1 | 0) >> 0] | 0;
      core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 + 8 | 0 | 0, $1 | 0, 1143640 | 0, 4 | 0);
      $0 = core__fmt__builders__DebugTuple__finish__hc3c3f1efaa75a6e2(core__fmt__builders__DebugTuple__field__h5e7e3e19ad5aa557($2 + 8 | 0 | 0, $2 + 24 | 0 | 0, 1143600 | 0) | 0 | 0) | 0;
      break label$2;
     case 2:
      $3 = HEAP32[($0 + 4 | 0) >> 2] | 0;
      $4 = HEAP32[$3 >> 2] | 0;
      HEAP32[($2 + 28 | 0) >> 2] = HEAP32[($3 + 4 | 0) >> 2] | 0;
      HEAP32[($2 + 24 | 0) >> 2] = $4;
      HEAP8[$2 >> 0] = HEAPU8[($0 + 1 | 0) >> 0] | 0;
      i64toi32_i32$1 = core__fmt__Formatter__debug_struct__h873400a11fe69724($1 | 0, 1143590 | 0, 5 | 0) | 0;
      i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
      $82 = i64toi32_i32$1;
      i64toi32_i32$1 = $2;
      HEAP32[($2 + 8 | 0) >> 2] = $82;
      HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
      $0 = core__fmt__builders__DebugStruct__finish__hb1eae1aa0e288840(core__fmt__builders__DebugStruct__field__hec833bfe02704935(core__fmt__builders__DebugStruct__field__hec833bfe02704935($2 + 8 | 0 | 0, 1143595 | 0, 4 | 0, $2 | 0, 1143600 | 0) | 0 | 0, 1143616 | 0, 7 | 0, $2 + 24 | 0 | 0, 1143624 | 0) | 0 | 0) | 0;
      break label$2;
     case 3:
      break label$3;
     };
    }
    $0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    i64toi32_i32$0 = core__fmt__Formatter__debug_struct__h873400a11fe69724($1 | 0, 1144429 | 0, 6 | 0) | 0;
    i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
    $96 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[($2 + 8 | 0) >> 2] = $96;
    HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($2 + 24 | 0) >> 2] = $0 + 8 | 0;
    core__fmt__builders__DebugStruct__field__hec833bfe02704935($2 + 8 | 0 | 0, 1143595 | 0, 4 | 0, $2 + 24 | 0 | 0, 1144436 | 0) | 0;
    HEAP32[($2 + 24 | 0) >> 2] = $0;
    core__fmt__builders__DebugStruct__field__hec833bfe02704935($2 + 8 | 0 | 0, 1144424 | 0, 5 | 0, $2 + 24 | 0 | 0, 1144452 | 0) | 0;
    $0 = core__fmt__builders__DebugStruct__finish__hb1eae1aa0e288840($2 + 8 | 0 | 0) | 0;
   }
   global$0 = $2 + 32 | 0;
   return $0 | 0;
  }
  alloc__alloc__handle_alloc_error__he269d8f1bff90960(20 | 0, 1 | 0);
  abort();
 }
 
 function $core__fmt__builders__PadAdapter_20as_20core__fmt__Write___write_str__h2104fbe324f8507b($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $7 = 0, $8 = 0, $9 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $10 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if (!$2) {
       break label$4
      }
      $4 = HEAP32[($0 + 4 | 0) >> 2] | 0;
      $5 = HEAP32[$0 >> 2] | 0;
      $6 = HEAP32[($0 + 8 | 0) >> 2] | 0;
      label$5 : while (1) {
       label$6 : {
        if (!(HEAPU8[$6 >> 0] | 0)) {
         break label$6
        }
        if (!(FUNCTION_TABLE[HEAP32[($4 + 12 | 0) >> 2] | 0 | 0]($5, 1149828, 4) | 0)) {
         break label$6
        }
        $0 = 1;
        break label$3;
       }
       $7 = 0;
       $8 = $2;
       label$7 : {
        label$8 : while (1) {
         $9 = $1 + $7 | 0;
         label$9 : {
          label$10 : {
           if ($8 >>> 0 < 8 >>> 0) {
            break label$10
           }
           core__slice__memchr__memchr_general_case__hc8de6bab13ee8435($3 + 8 | 0 | 0, 10 | 0, $9 | 0, $8 | 0);
           $8 = HEAP32[($3 + 12 | 0) >> 2] | 0;
           $9 = HEAP32[($3 + 8 | 0) >> 2] | 0;
           break label$9;
          }
          label$11 : {
           if ($8) {
            break label$11
           }
           $8 = 0;
           $9 = 0;
           break label$9;
          }
          $0 = 0;
          label$12 : {
           label$13 : while (1) {
            if ((HEAPU8[($9 + $0 | 0) >> 0] | 0 | 0) == (10 | 0)) {
             break label$12
            }
            $0 = $0 + 1 | 0;
            if (($8 | 0) != ($0 | 0)) {
             continue label$13
            }
            break label$13;
           };
           $9 = 0;
           break label$9;
          }
          $9 = 1;
          $8 = $0;
         }
         $10 = 0;
         label$14 : {
          if (($9 | 0) != (1 | 0)) {
           break label$14
          }
          $0 = $8 + $7 | 0;
          $7 = $0 + 1 | 0;
          label$15 : {
           if ($0 >>> 0 >= $2 >>> 0) {
            break label$15
           }
           if ((HEAPU8[($1 + $0 | 0) >> 0] | 0 | 0) != (10 | 0)) {
            break label$15
           }
           $10 = 1;
           break label$7;
          }
          $8 = $2 - $7 | 0;
          if ($2 >>> 0 >= $7 >>> 0) {
           continue label$8
          }
         }
         break label$8;
        };
        $7 = $2;
       }
       HEAP8[$6 >> 0] = $10;
       label$16 : {
        label$17 : {
         if ($2 >>> 0 > $7 >>> 0) {
          break label$17
         }
         if (($2 | 0) != ($7 | 0)) {
          break label$2
         }
         if (!(FUNCTION_TABLE[HEAP32[($4 + 12 | 0) >> 2] | 0 | 0]($5, $1, $7) | 0)) {
          break label$16
         }
         $0 = 1;
         break label$3;
        }
        $0 = $1 + $7 | 0;
        if ((HEAP8[$0 >> 0] | 0 | 0) <= (-65 | 0)) {
         break label$2
        }
        label$18 : {
         if (!(FUNCTION_TABLE[HEAP32[($4 + 12 | 0) >> 2] | 0 | 0]($5, $1, $7) | 0)) {
          break label$18
         }
         $0 = 1;
         break label$3;
        }
        if ((HEAP8[$0 >> 0] | 0 | 0) <= (-65 | 0)) {
         break label$1
        }
       }
       $1 = $1 + $7 | 0;
       $2 = $2 - $7 | 0;
       if ($2) {
        continue label$5
       }
       break label$5;
      };
     }
     $0 = 0;
    }
    global$0 = $3 + 16 | 0;
    return $0 | 0;
   }
   core__str__slice_error_fail__h8a7d2e23b7bba52e($1 | 0, $2 | 0, 0 | 0, $7 | 0, 1149832 | 0);
   abort();
  }
  core__str__slice_error_fail__h8a7d2e23b7bba52e($1 | 0, $2 | 0, $7 | 0, $2 | 0, 1149848 | 0);
  abort();
 }
 
 function hashbrown__raw__RawTable_T_2cA___insert__had6a9928cbe480f0($0, $1, $1$hi, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $1$hi = $1$hi | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $10 = 0, $8 = 0, $9 = 0, $5 = 0, i64toi32_i32$0 = 0, $6 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $4 = 0, $7 = 0, $154 = 0, $159 = 0, $162 = 0;
  $4 = global$0 - 16 | 0;
  global$0 = $4;
  label$1 : {
   $5 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   $6 = HEAP32[$0 >> 2] | 0;
   i64toi32_i32$0 = $1$hi;
   $7 = $1;
   $8 = $6 & $7 | 0;
   $18 = $5 + $8 | 0;
   $9 = (HEAPU8[$18 >> 0] | 0 | ((HEAPU8[($18 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($18 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($18 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
   if ($9) {
    break label$1
   }
   $10 = 4;
   label$2 : while (1) {
    $8 = $8 + $10 | 0;
    $10 = $10 + 4 | 0;
    $8 = $8 & $6 | 0;
    $19 = $5 + $8 | 0;
    $9 = (HEAPU8[$19 >> 0] | 0 | ((HEAPU8[($19 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($19 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($19 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
    if (!$9) {
     continue label$2
    }
    break label$2;
   };
  }
  label$3 : {
   $10 = (((__wasm_ctz_i32($9 | 0) | 0) >>> 3 | 0) + $8 | 0) & $6 | 0;
   $8 = HEAP8[($5 + $10 | 0) >> 0] | 0;
   if (($8 | 0) <= (-1 | 0)) {
    break label$3
   }
   $10 = (__wasm_ctz_i32((HEAP32[$5 >> 2] | 0) & -2139062144 | 0 | 0) | 0) >>> 3 | 0;
   $8 = HEAPU8[($5 + $10 | 0) >> 0] | 0;
  }
  label$4 : {
   $8 = $8 & 1 | 0;
   if (!$8) {
    break label$4
   }
   if (HEAP32[($0 + 8 | 0) >> 2] | 0) {
    break label$4
   }
   hashbrown__raw__RawTable_T_2cA___reserve_rehash__h3683e854426b5d78($4 | 0, $0 | 0, 1 | 0, $3 | 0, 1 | 0);
   label$5 : {
    $5 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    $6 = HEAP32[$0 >> 2] | 0;
    $9 = $6 & $7 | 0;
    $20 = $5 + $9 | 0;
    $3 = (HEAPU8[$20 >> 0] | 0 | ((HEAPU8[($20 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($20 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($20 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
    if ($3) {
     break label$5
    }
    $10 = 4;
    label$6 : while (1) {
     $9 = $9 + $10 | 0;
     $10 = $10 + 4 | 0;
     $9 = $9 & $6 | 0;
     $21 = $5 + $9 | 0;
     $3 = (HEAPU8[$21 >> 0] | 0 | ((HEAPU8[($21 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($21 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($21 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
     if (!$3) {
      continue label$6
     }
     break label$6;
    };
   }
   $10 = (((__wasm_ctz_i32($3 | 0) | 0) >>> 3 | 0) + $9 | 0) & $6 | 0;
   if ((HEAP8[($5 + $10 | 0) >> 0] | 0 | 0) <= (-1 | 0)) {
    break label$4
   }
   $10 = (__wasm_ctz_i32((HEAP32[$5 >> 2] | 0) & -2139062144 | 0 | 0) | 0) >>> 3 | 0;
  }
  $9 = $7 >>> 25 | 0;
  HEAP8[($5 + $10 | 0) >> 0] = $9;
  HEAP8[(((($10 + -4 | 0) & $6 | 0) + $5 | 0) + 4 | 0) >> 0] = $9;
  HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) - $8 | 0;
  HEAP32[($0 + 12 | 0) >> 2] = (HEAP32[($0 + 12 | 0) >> 2] | 0) + 1 | 0;
  $8 = $5 + Math_imul(0 - $10 | 0, 24) | 0;
  $10 = $8 + -24 | 0;
  i64toi32_i32$2 = $2 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $154 = i64toi32_i32$0;
  i64toi32_i32$0 = $10 + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $154;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $159 = i64toi32_i32$1;
  i64toi32_i32$1 = $10 + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $159;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $162 = i64toi32_i32$0;
  i64toi32_i32$0 = $10;
  HEAP32[$10 >> 2] = $162;
  HEAP32[($10 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $4 + 16 | 0;
  return $8 | 0;
 }
 
 function alloc__collections__btree__map__entry__VacantEntry_K_2cV___insert__h1ccac11121812f65($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $20 = 0, $4 = 0, $7 = 0, $19 = 0, $30 = 0, $36 = 0, $39 = 0, $48 = 0, $3 = 0, $5 = 0, $6 = 0, $104 = 0, $110 = 0, $114 = 0, $124 = 0;
  $2 = global$0 - 128 | 0;
  global$0 = $2;
  HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 64 | 0) >> 2] = $19;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$1;
  $20 = i64toi32_i32$2 + 40 | 0;
  HEAP32[(($2 + 80 | 0) + 24 | 0) >> 2] = HEAPU8[$20 >> 0] | 0 | ((HEAPU8[($20 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($20 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($20 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 32 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $30 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 96 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $0 + 24 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $36 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 80 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $36;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 16 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 17 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 18 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 19 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 20 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 21 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 22 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 23 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $39 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 80 | 0) >> 2] = $39;
  HEAP32[($2 + 84 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(($2 + 112 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $48 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 112 | 0) >> 2] = $48;
  HEAP32[($2 + 116 | 0) >> 2] = i64toi32_i32$1;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_recursing__hf1669f31df85556c($2 | 0, $2 + 64 | 0 | 0, $2 + 80 | 0 | 0, $2 + 112 | 0 | 0);
  $3 = HEAP32[($2 + 60 | 0) >> 2] | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[$2 >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     $0 = HEAP32[($0 + 12 | 0) >> 2] | 0;
     break label$2;
    }
    $0 = HEAP32[($0 + 12 | 0) >> 2] | 0;
    $4 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    if (!$4) {
     break label$1
    }
    $5 = HEAP32[($2 + 56 | 0) >> 2] | 0;
    $6 = HEAP32[($2 + 52 | 0) >> 2] | 0;
    $7 = HEAP32[$0 >> 2] | 0;
    $1 = alloc__boxed__Box_T_2cA___new_uninit_in__h030094152bc6ae31() | 0;
    HEAP32[($1 + 448 | 0) >> 2] = $4;
    HEAP16[($1 + 138 | 0) >> 1] = 0;
    HEAP32[$1 >> 2] = 0;
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    $7 = $7 + 1 | 0;
    HEAP32[$0 >> 2] = $7;
    HEAP16[($4 + 136 | 0) >> 1] = 0;
    HEAP32[$4 >> 2] = $1;
    HEAP32[($2 + 68 | 0) >> 2] = $1;
    HEAP32[($2 + 64 | 0) >> 2] = $7;
    HEAP32[($2 + 104 | 0) >> 2] = HEAP32[($2 + 36 | 0) >> 2] | 0;
    i64toi32_i32$2 = $2 + 28 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $104 = i64toi32_i32$1;
    i64toi32_i32$1 = $2 + 96 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $104;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $2 + 20 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $110 = i64toi32_i32$0;
    i64toi32_i32$0 = ($2 + 80 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $110;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $2 + 12 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $114 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 80 | 0) >> 2] = $114;
    HEAP32[($2 + 84 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[(($2 + 112 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 48 | 0) >> 2] | 0;
    i64toi32_i32$2 = $2 + 40 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $124 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[($2 + 112 | 0) >> 2] = $124;
    HEAP32[($2 + 116 | 0) >> 2] = i64toi32_i32$1;
    alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal___push__h58c3a8a4c681696e($2 + 64 | 0 | 0, $2 + 80 | 0 | 0, $2 + 112 | 0 | 0, $6 | 0, $5 | 0);
   }
   HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
   global$0 = $2 + 128 | 0;
   return $3 | 0;
  }
  core__panicking__panic__h2fd385a887c8bf13(1072048 | 0, 43 | 0, 1072248 | 0);
  abort();
 }
 
 function alloc__collections__btree__map__entry__VacantEntry_K_2cV___insert__hce43ba110ae6b93d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $20 = 0, $4 = 0, $7 = 0, $19 = 0, $30 = 0, $36 = 0, $39 = 0, $48 = 0, $3 = 0, $5 = 0, $6 = 0, $104 = 0, $110 = 0, $114 = 0, $124 = 0;
  $2 = global$0 - 128 | 0;
  global$0 = $2;
  HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 64 | 0) >> 2] = $19;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$1;
  $20 = i64toi32_i32$2 + 40 | 0;
  HEAP32[(($2 + 80 | 0) + 24 | 0) >> 2] = HEAPU8[$20 >> 0] | 0 | ((HEAPU8[($20 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($20 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($20 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 32 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $30 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 96 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $0 + 24 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $36 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 80 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $36;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 16 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 17 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 18 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 19 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 20 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 21 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 22 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 23 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $39 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 80 | 0) >> 2] = $39;
  HEAP32[($2 + 84 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(($2 + 112 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $48 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 112 | 0) >> 2] = $48;
  HEAP32[($2 + 116 | 0) >> 2] = i64toi32_i32$1;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_recursing__hffbe4982de10255b($2 | 0, $2 + 64 | 0 | 0, $2 + 80 | 0 | 0, $2 + 112 | 0 | 0);
  $3 = HEAP32[($2 + 60 | 0) >> 2] | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[$2 >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     $0 = HEAP32[($0 + 12 | 0) >> 2] | 0;
     break label$2;
    }
    $0 = HEAP32[($0 + 12 | 0) >> 2] | 0;
    $4 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    if (!$4) {
     break label$1
    }
    $5 = HEAP32[($2 + 56 | 0) >> 2] | 0;
    $6 = HEAP32[($2 + 52 | 0) >> 2] | 0;
    $7 = HEAP32[$0 >> 2] | 0;
    $1 = alloc__boxed__Box_T_2cA___new_uninit_in__h4be0289855654d00() | 0;
    HEAP32[($1 + 448 | 0) >> 2] = $4;
    HEAP16[($1 + 138 | 0) >> 1] = 0;
    HEAP32[$1 >> 2] = 0;
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    $7 = $7 + 1 | 0;
    HEAP32[$0 >> 2] = $7;
    HEAP16[($4 + 136 | 0) >> 1] = 0;
    HEAP32[$4 >> 2] = $1;
    HEAP32[($2 + 68 | 0) >> 2] = $1;
    HEAP32[($2 + 64 | 0) >> 2] = $7;
    HEAP32[($2 + 104 | 0) >> 2] = HEAP32[($2 + 36 | 0) >> 2] | 0;
    i64toi32_i32$2 = $2 + 28 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $104 = i64toi32_i32$1;
    i64toi32_i32$1 = $2 + 96 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $104;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $2 + 20 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $110 = i64toi32_i32$0;
    i64toi32_i32$0 = ($2 + 80 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $110;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $2 + 12 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $114 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 80 | 0) >> 2] = $114;
    HEAP32[($2 + 84 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[(($2 + 112 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 48 | 0) >> 2] | 0;
    i64toi32_i32$2 = $2 + 40 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $124 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[($2 + 112 | 0) >> 2] = $124;
    HEAP32[($2 + 116 | 0) >> 2] = i64toi32_i32$1;
    alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal___push__h46c23fc0db2aa9a2($2 + 64 | 0 | 0, $2 + 80 | 0 | 0, $2 + 112 | 0 | 0, $6 | 0, $5 | 0);
   }
   HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
   global$0 = $2 + 128 | 0;
   return $3 | 0;
  }
  core__panicking__panic__h2fd385a887c8bf13(1072048 | 0, 43 | 0, 1072248 | 0);
  abort();
 }
 
 function headerbody_new($0, $1, $2, $3, $4, $5, $6, $7, $8, $9, $10) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  $5 = $5 | 0;
  $6 = $6 | 0;
  $7 = $7 | 0;
  $8 = $8 | 0;
  $9 = $9 | 0;
  $10 = $10 | 0;
  var $11 = 0, $12 = 0, $13 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0;
  $11 = global$0 - 720 | 0;
  global$0 = $11;
  label$1 : {
   label$2 : {
    if ($2) {
     break label$2
    }
    $12 = 0;
    break label$1;
   }
   $12 = 1;
   $cardano_serialization_lib__crypto__BlockHash_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hb6c73b3486e647eb($11 + 368 | 0 | 1 | 0 | 0, $2 | 0);
  }
  HEAP8[($11 + 368 | 0) >> 0] = $12;
  label$3 : {
   if (!$3) {
    break label$3
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h38603c546ca761f2($11 + 48 | 0 | 0, $3 | 0);
   if (!$4) {
    break label$3
   }
   $3 = HEAP32[($11 + 52 | 0) >> 2] | 0;
   $2 = HEAP32[($11 + 48 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h358f17571789b373($11 + 40 | 0 | 0, $4 | 0);
   if (!$5) {
    break label$3
   }
   $4 = HEAP32[($11 + 44 | 0) >> 2] | 0;
   $12 = HEAP32[($11 + 40 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h1a6acf099b73960c($11 + 32 | 0 | 0, $5 | 0);
   if (!$6) {
    break label$3
   }
   $5 = HEAP32[($11 + 36 | 0) >> 2] | 0;
   $13 = HEAP32[($11 + 32 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h1a6acf099b73960c($11 + 24 | 0 | 0, $6 | 0);
   if (!$8) {
    break label$3
   }
   $6 = HEAP32[($11 + 28 | 0) >> 2] | 0;
   $14 = HEAP32[($11 + 24 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h449d6579c00e5aca($11 + 16 | 0 | 0, $8 | 0);
   if (!$9) {
    break label$3
   }
   $8 = HEAP32[($11 + 20 | 0) >> 2] | 0;
   $15 = HEAP32[($11 + 16 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h4b15d475a6cbc138($11 + 8 | 0 | 0, $9 | 0);
   if (!$10) {
    break label$3
   }
   $9 = HEAP32[($11 + 12 | 0) >> 2] | 0;
   $16 = HEAP32[($11 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h42c8face5b925abb($11 | 0, $10 | 0);
   $10 = HEAP32[($11 + 4 | 0) >> 2] | 0;
   $17 = HEAP32[$11 >> 2] | 0;
   memcpy($11 + 408 | 0 | 0, $11 + 368 | 0 | 0, 33 | 0) | 0;
   cardano_serialization_lib__HeaderBody__new__h6bb28ac27adeb425($11 + 56 | 0 | 0, $0 | 0, $1 | 0, $11 + 408 | 0 | 0, $2 | 0, $12 | 0, $13 | 0, $14 | 0, $7 | 0, $15 | 0, $16 | 0, $17 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($10 | 0, (HEAP32[$10 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($9 | 0, (HEAP32[$9 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($8 | 0, (HEAP32[$8 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($6 | 0, (HEAP32[$6 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($5 | 0, (HEAP32[$5 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($4 | 0, (HEAP32[$4 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
   memcpy($11 + 408 | 0 | 0, $11 + 56 | 0 | 0, 312 | 0) | 0;
   $3 = $cardano_serialization_lib__HeaderBody_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he5de7ce2c4403ed1($11 + 408 | 0 | 0) | 0;
   global$0 = $11 + 720 | 0;
   return $3 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function cardano_serialization_lib__output_builder__TransactionOutputAmountBuilder__with_value__he6ce3f9f499f4b2f($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $5 = 0, $6 = 0, $4 = 0, $27 = 0, $28 = 0, $29 = 0, $30 = 0, $8 = 0, $8$hi = 0, $7 = 0, $35 = 0, $43 = 0, $48 = 0, $53 = 0, $57 = 0, $73 = 0, $83 = 0, $90 = 0, $95 = 0, $100 = 0, $113 = 0, $118 = 0, $125 = 0, $131 = 0;
  $3 = global$0 - 112 | 0;
  global$0 = $3;
  $cardano_serialization_lib__address__Address_20as_20core__clone__Clone___clone__h0eb465a6e349d507_1($3 | 0, $1 | 0);
  $4 = 2;
  label$1 : {
   $5 = HEAP32[($1 + 72 | 0) >> 2] | 0;
   if (($5 | 0) == (2 | 0)) {
    break label$1
   }
   i64toi32_i32$2 = $1;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
   $8 = i64toi32_i32$0;
   $8$hi = i64toi32_i32$1;
   $4 = 0;
   label$2 : {
    if (($5 | 0) != (1 | 0)) {
     break label$2
    }
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($3 + 80 | 0 | 4 | 0 | 0, $1 + 76 | 0 | 0);
    $4 = 1;
   }
   HEAP32[($3 + 72 | 0) >> 2] = HEAP32[($3 + 92 | 0) >> 2] | 0;
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 84 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 88 | 0) >> 2] | 0;
   $35 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] = $35;
   HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] = i64toi32_i32$0;
  }
  $5 = 0;
  $6 = 0;
  label$3 : {
   if ((HEAPU8[($1 + 88 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$3
   }
   i64toi32_i32$2 = $1 + 113 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $43 = i64toi32_i32$0;
   i64toi32_i32$0 = $3 + 104 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $43;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1 + 105 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $48 = i64toi32_i32$1;
   i64toi32_i32$1 = $3 + 96 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $48;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $1 + 97 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $53 = i64toi32_i32$0;
   i64toi32_i32$0 = $3 + 88 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $53;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1 + 89 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $57 = i64toi32_i32$1;
   i64toi32_i32$1 = $3;
   HEAP32[(i64toi32_i32$1 + 80 | 0) >> 2] = $57;
   HEAP32[(i64toi32_i32$1 + 84 | 0) >> 2] = i64toi32_i32$0;
   $6 = 1;
  }
  $1 = memcpy($0 | 0, $3 | 0, 64 | 0) | 0;
  $0 = $1 + 72 | 0;
  HEAP32[$0 >> 2] = $4;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$1 = $1;
  HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] = $8;
  HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 88 | 0) >> 0] = $6;
  $7 = i64toi32_i32$1 + 76 | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
  $73 = i64toi32_i32$0;
  i64toi32_i32$0 = $7;
  HEAP32[i64toi32_i32$0 >> 2] = $73;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 84 | 0) >> 2] = HEAP32[((i64toi32_i32$2 + 64 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 80 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 84 | 0) >> 2] | 0;
  $83 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 89 | 0;
  $27 = $83;
  HEAP8[i64toi32_i32$1 >> 0] = $27;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $27 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $27 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $27 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $6 = (i64toi32_i32$2 + 80 | 0) + 8 | 0;
  i64toi32_i32$2 = $6;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $90 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 97 | 0;
  $28 = $90;
  HEAP8[i64toi32_i32$0 >> 0] = $28;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $28 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $28 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $28 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $3 + 96 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $95 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 105 | 0;
  $29 = $95;
  HEAP8[i64toi32_i32$1 >> 0] = $29;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $29 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $29 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $29 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $3 + 104 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $100 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 113 | 0;
  $30 = $100;
  HEAP8[i64toi32_i32$0 >> 0] = $30;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $30 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $30 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $30 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$1;
  $8$hi = i64toi32_i32$0;
  label$4 : {
   if ((HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$4
   }
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($3 | 4 | 0 | 0, $2 + 12 | 0 | 0);
   $5 = 1;
  }
  i64toi32_i32$2 = $3 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $113 = i64toi32_i32$0;
  i64toi32_i32$0 = $6;
  HEAP32[i64toi32_i32$0 >> 2] = $113;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[$3 >> 2] = $5;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $118 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$2 + 80 | 0) >> 2] = $118;
  HEAP32[(i64toi32_i32$2 + 84 | 0) >> 2] = i64toi32_i32$0;
  label$5 : {
   switch ($4 | 0) {
   default:
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($7 | 0);
    break;
   case 0:
   case 2:
    break label$5;
   };
  }
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$1 = $1;
  HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] = $8;
  HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 80 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 84 | 0) >> 2] | 0;
  $125 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $125;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = (i64toi32_i32$2 + 80 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $131 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $131;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $3 + 112 | 0;
 }
 
 function baseaddress_to_address($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $1 = 0, $7 = 0, $8 = 0, $32 = 0, $4 = 0, $33 = 0, $34 = 0, $35 = 0, $36 = 0, $37 = 0, $38 = 0, $3 = 0, $6 = 0, $9 = 0, $10 = 0, $11 = 0, $2 = 0, $12 = 0, $12$hi = 0, $5 = 0, $13 = 0, $13$hi = 0, $43 = 0, $62 = 0, $69 = 0, $79 = 0, $93 = 0, $99 = 0, $102 = 0, $111 = 0, $115 = 0, $126 = 0, $130 = 0, $134 = 0, $146 = 0;
  $1 = global$0 - 176 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h41e273aed1ab619e($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $2 = HEAPU8[$0 >> 0] | 0;
  $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $32 = $0 + 26 | 0;
  $4 = HEAPU8[$32 >> 0] | 0 | ((HEAPU8[($32 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($32 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($32 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $0 + 18 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $12 = i64toi32_i32$0;
  $12$hi = i64toi32_i32$1;
  $5 = HEAPU8[($0 + 1 | 0) >> 0] | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 9 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $13 = i64toi32_i32$1;
  $13$hi = i64toi32_i32$0;
  $6 = ($1 + 80 | 0) + 8 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 10 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $43 = i64toi32_i32$0;
  i64toi32_i32$0 = $6;
  HEAP32[i64toi32_i32$0 >> 2] = $43;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $7 = ($1 + 80 | 0) + 16 | 0;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$0 = $7;
  HEAP32[i64toi32_i32$0 >> 2] = $12;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $8 = ($1 + 80 | 0) + 24 | 0;
  HEAP32[$8 >> 2] = $4;
  i64toi32_i32$1 = $13$hi;
  i64toi32_i32$0 = $1;
  HEAP32[(i64toi32_i32$0 + 80 | 0) >> 2] = $13;
  HEAP32[(i64toi32_i32$0 + 84 | 0) >> 2] = i64toi32_i32$1;
  $4 = (i64toi32_i32$0 + 16 | 0) + 8 | 0;
  i64toi32_i32$2 = $0 + 39 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $62 = i64toi32_i32$1;
  i64toi32_i32$1 = $4;
  HEAP32[i64toi32_i32$1 >> 2] = $62;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $9 = ($1 + 16 | 0) + 16 | 0;
  i64toi32_i32$2 = $0 + 47 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $69 = i64toi32_i32$0;
  i64toi32_i32$0 = $9;
  HEAP32[i64toi32_i32$0 >> 2] = $69;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $10 = ($1 + 16 | 0) + 24 | 0;
  $33 = $0 + 55 | 0;
  HEAP32[$10 >> 2] = HEAPU8[$33 >> 0] | 0 | ((HEAPU8[($33 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($33 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($33 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 31 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 32 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 33 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 34 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 35 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 36 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 37 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 38 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $79 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $79;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  $0 = HEAPU8[(i64toi32_i32$2 + 30 | 0) >> 0] | 0;
  $11 = (i64toi32_i32$1 + 48 | 0) + 24 | 0;
  HEAP32[$11 >> 2] = HEAP32[$8 >> 2] | 0;
  $8 = (i64toi32_i32$1 + 48 | 0) + 16 | 0;
  i64toi32_i32$2 = $7;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $93 = i64toi32_i32$0;
  i64toi32_i32$0 = $8;
  HEAP32[i64toi32_i32$0 >> 2] = $93;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $7 = ($1 + 48 | 0) + 8 | 0;
  i64toi32_i32$2 = $6;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $99 = i64toi32_i32$1;
  i64toi32_i32$1 = $7;
  HEAP32[i64toi32_i32$1 >> 2] = $99;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 80 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 84 | 0) >> 2] | 0;
  $102 = i64toi32_i32$0;
  i64toi32_i32$0 = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = $102;
  HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = i64toi32_i32$1;
  core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $7;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $111 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 123 | 0;
  $34 = $111;
  HEAP8[i64toi32_i32$1 >> 0] = $34;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $34 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $34 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $34 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $8;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $115 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 131 | 0;
  $35 = $115;
  HEAP8[i64toi32_i32$0 >> 0] = $35;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $35 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $35 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $35 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $36 = $1 + 139 | 0;
  $37 = HEAP32[$11 >> 2] | 0;
  HEAP8[$36 >> 0] = $37;
  HEAP8[($36 + 1 | 0) >> 0] = $37 >>> 8 | 0;
  HEAP8[($36 + 2 | 0) >> 0] = $37 >>> 16 | 0;
  HEAP8[($36 + 3 | 0) >> 0] = $37 >>> 24 | 0;
  HEAP8[($1 + 143 | 0) >> 0] = $0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $126 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2 + 144 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $126;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $130 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 152 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $130;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $134 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 160 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $134;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($1 + 168 | 0) >> 2] = HEAP32[$10 >> 2] | 0;
  HEAP8[($1 + 114 | 0) >> 0] = $5;
  HEAP8[($1 + 113 | 0) >> 0] = $2;
  HEAP8[($1 + 112 | 0) >> 0] = 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] | 0;
  $146 = i64toi32_i32$0;
  i64toi32_i32$0 = i64toi32_i32$2;
  $38 = $146;
  HEAP8[(i64toi32_i32$2 + 115 | 0) >> 0] = $38;
  HEAP8[(i64toi32_i32$2 + 116 | 0) >> 0] = $38 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 117 | 0) >> 0] = $38 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 118 | 0) >> 0] = $38 >>> 24 | 0;
  HEAP8[(i64toi32_i32$2 + 119 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$2 + 120 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 121 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 122 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $0 = $cardano_serialization_lib__address__Address_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8ce30e61cf34786e(i64toi32_i32$2 + 112 | 0 | 0) | 0;
  global$0 = i64toi32_i32$2 + 176 | 0;
  return $0 | 0;
 }
 
 function rand_core__SeedableRng__from_rng__h076979c7accc940d($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $5 = 0, $2 = 0, $3 = 0, $4 = 0, $7 = 0, $37 = 0, $43 = 0, $49 = 0, $52 = 0, $6 = 0, $60 = 0, $63 = 0, $70 = 0, $73 = 0, $85 = 0, $88 = 0, $97 = 0, $100 = 0;
  $1 = global$0 - 176 | 0;
  global$0 = $1;
  $2 = ($1 + 8 | 0) + 24 | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $3 = ($1 + 8 | 0) + 16 | 0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = ($1 + 8 | 0) + 8 | 0;
  i64toi32_i32$1 = $4;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$1 = $1;
  i64toi32_i32$0 = 0;
  HEAP32[($1 + 8 | 0) >> 2] = 0;
  HEAP32[($1 + 12 | 0) >> 2] = i64toi32_i32$0;
  $rand_core__os__OsRng_20as_20rand_core__RngCore___try_fill_bytes__h93c0b25b73811e88($1 | 0, $1 + 168 | 0 | 0, $1 + 8 | 0 | 0, 32 | 0);
  label$1 : {
   label$2 : {
    $5 = HEAP32[$1 >> 2] | 0;
    if ($5) {
     break label$2
    }
    $5 = ($1 + 40 | 0) + 24 | 0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $37 = i64toi32_i32$0;
    i64toi32_i32$0 = $5;
    HEAP32[i64toi32_i32$0 >> 2] = $37;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    $2 = ($1 + 40 | 0) + 16 | 0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $43 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[i64toi32_i32$1 >> 2] = $43;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    $3 = ($1 + 40 | 0) + 8 | 0;
    i64toi32_i32$2 = $4;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $49 = i64toi32_i32$0;
    i64toi32_i32$0 = $3;
    HEAP32[i64toi32_i32$0 >> 2] = $49;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    $52 = i64toi32_i32$1;
    i64toi32_i32$1 = $1;
    HEAP32[($1 + 40 | 0) >> 2] = $52;
    HEAP32[($1 + 44 | 0) >> 2] = i64toi32_i32$0;
    $4 = rand_chacha__guts__read_u32le__he4399ba7da75efdd(1074608 | 0, 4 | 0) | 0;
    $6 = rand_chacha__guts__read_u32le__he4399ba7da75efdd(1074612 | 0, 4 | 0) | 0;
    $7 = ($1 + 72 | 0) + 8 | 0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $60 = i64toi32_i32$0;
    i64toi32_i32$0 = $7;
    HEAP32[i64toi32_i32$0 >> 2] = $60;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = HEAP32[($1 + 40 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($1 + 44 | 0) >> 2] | 0;
    $63 = i64toi32_i32$1;
    i64toi32_i32$1 = $1;
    HEAP32[($1 + 72 | 0) >> 2] = $63;
    HEAP32[($1 + 76 | 0) >> 2] = i64toi32_i32$0;
    ppv_lite86__generic__dmap__h2188f233a7e87f48($1 + 120 | 0 | 0, $1 + 72 | 0 | 0);
    i64toi32_i32$2 = $5;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $70 = i64toi32_i32$0;
    i64toi32_i32$0 = $7;
    HEAP32[i64toi32_i32$0 >> 2] = $70;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $73 = i64toi32_i32$1;
    i64toi32_i32$1 = $1;
    HEAP32[($1 + 72 | 0) >> 2] = $73;
    HEAP32[($1 + 76 | 0) >> 2] = i64toi32_i32$0;
    ppv_lite86__generic__dmap__h2188f233a7e87f48($1 + 136 | 0 | 0, $1 + 72 | 0 | 0);
    $5 = ($1 + 152 | 0) + 8 | 0;
    i64toi32_i32$2 = ($1 + 120 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $85 = i64toi32_i32$0;
    i64toi32_i32$0 = $5;
    HEAP32[i64toi32_i32$0 >> 2] = $85;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = HEAP32[($1 + 120 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($1 + 124 | 0) >> 2] | 0;
    $88 = i64toi32_i32$1;
    i64toi32_i32$1 = $1;
    HEAP32[($1 + 152 | 0) >> 2] = $88;
    HEAP32[($1 + 156 | 0) >> 2] = i64toi32_i32$0;
    $T_20as_20core__convert__Into_U____into__h22fa69910ba5cfda($1 + 72 | 0 | 0, $1 + 152 | 0 | 0);
    i64toi32_i32$2 = ($1 + 136 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $97 = i64toi32_i32$0;
    i64toi32_i32$0 = $5;
    HEAP32[i64toi32_i32$0 >> 2] = $97;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = HEAP32[($1 + 136 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($1 + 140 | 0) >> 2] | 0;
    $100 = i64toi32_i32$1;
    i64toi32_i32$1 = $1;
    HEAP32[($1 + 152 | 0) >> 2] = $100;
    HEAP32[($1 + 156 | 0) >> 2] = i64toi32_i32$0;
    $T_20as_20core__convert__Into_U____into__h22fa69910ba5cfda(($1 + 72 | 0) + 16 | 0 | 0, $1 + 152 | 0 | 0);
    HEAP32[($1 + 164 | 0) >> 2] = $6;
    HEAP32[($1 + 160 | 0) >> 2] = $4;
    i64toi32_i32$1 = $1;
    i64toi32_i32$0 = 0;
    HEAP32[($1 + 152 | 0) >> 2] = 0;
    HEAP32[($1 + 156 | 0) >> 2] = i64toi32_i32$0;
    $T_20as_20core__convert__Into_U____into__hd2808ec68dba4890(($1 + 72 | 0) + 32 | 0 | 0, $1 + 152 | 0 | 0);
    memcpy($0 + 8 | 0 | 0, $1 + 72 | 0 | 0, 48 | 0) | 0;
    $5 = 0;
    break label$1;
   }
   $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $5;
   HEAP32[($0 + 8 | 0) >> 2] = $2;
   $5 = 1;
  }
  HEAP32[$0 >> 2] = $5;
  global$0 = $1 + 176 | 0;
 }
 
 function rand_core__SeedableRng__from_rng__h69fb0d629616b25c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $5 = 0, $7 = 0, $37 = 0, $43 = 0, $49 = 0, $52 = 0, $6 = 0, $60 = 0, $63 = 0, $70 = 0, $73 = 0, $85 = 0, $88 = 0, $97 = 0, $100 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  $3 = ($2 + 16 | 0) + 24 | 0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = ($2 + 16 | 0) + 16 | 0;
  i64toi32_i32$1 = $4;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $5 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = $5;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  $rand_core__os__OsRng_20as_20rand_core__RngCore___try_fill_bytes__h93c0b25b73811e88($2 + 8 | 0 | 0, $1 | 0, $2 + 16 | 0 | 0, 32 | 0);
  label$1 : {
   label$2 : {
    $1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    if ($1) {
     break label$2
    }
    $1 = ($2 + 48 | 0) + 24 | 0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $37 = i64toi32_i32$0;
    i64toi32_i32$0 = $1;
    HEAP32[i64toi32_i32$0 >> 2] = $37;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    $3 = ($2 + 48 | 0) + 16 | 0;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $43 = i64toi32_i32$1;
    i64toi32_i32$1 = $3;
    HEAP32[i64toi32_i32$1 >> 2] = $43;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    $4 = ($2 + 48 | 0) + 8 | 0;
    i64toi32_i32$2 = $5;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $49 = i64toi32_i32$0;
    i64toi32_i32$0 = $4;
    HEAP32[i64toi32_i32$0 >> 2] = $49;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
    $52 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 48 | 0) >> 2] = $52;
    HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$0;
    $5 = rand_chacha__guts__read_u32le__he4399ba7da75efdd(1074608 | 0, 4 | 0) | 0;
    $6 = rand_chacha__guts__read_u32le__he4399ba7da75efdd(1074612 | 0, 4 | 0) | 0;
    $7 = ($2 + 80 | 0) + 8 | 0;
    i64toi32_i32$2 = $4;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $60 = i64toi32_i32$0;
    i64toi32_i32$0 = $7;
    HEAP32[i64toi32_i32$0 >> 2] = $60;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[($2 + 48 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 52 | 0) >> 2] | 0;
    $63 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 80 | 0) >> 2] = $63;
    HEAP32[($2 + 84 | 0) >> 2] = i64toi32_i32$0;
    ppv_lite86__generic__dmap__h2188f233a7e87f48($2 + 128 | 0 | 0, $2 + 80 | 0 | 0);
    i64toi32_i32$2 = $1;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $70 = i64toi32_i32$0;
    i64toi32_i32$0 = $7;
    HEAP32[i64toi32_i32$0 >> 2] = $70;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $73 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 80 | 0) >> 2] = $73;
    HEAP32[($2 + 84 | 0) >> 2] = i64toi32_i32$0;
    ppv_lite86__generic__dmap__h2188f233a7e87f48($2 + 144 | 0 | 0, $2 + 80 | 0 | 0);
    $1 = ($2 + 160 | 0) + 8 | 0;
    i64toi32_i32$2 = ($2 + 128 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $85 = i64toi32_i32$0;
    i64toi32_i32$0 = $1;
    HEAP32[i64toi32_i32$0 >> 2] = $85;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[($2 + 128 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 132 | 0) >> 2] | 0;
    $88 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 160 | 0) >> 2] = $88;
    HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$0;
    $T_20as_20core__convert__Into_U____into__h22fa69910ba5cfda($2 + 80 | 0 | 0, $2 + 160 | 0 | 0);
    i64toi32_i32$2 = ($2 + 144 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $97 = i64toi32_i32$0;
    i64toi32_i32$0 = $1;
    HEAP32[i64toi32_i32$0 >> 2] = $97;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[($2 + 144 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 148 | 0) >> 2] | 0;
    $100 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 160 | 0) >> 2] = $100;
    HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$0;
    $T_20as_20core__convert__Into_U____into__h22fa69910ba5cfda(($2 + 80 | 0) + 16 | 0 | 0, $2 + 160 | 0 | 0);
    HEAP32[($2 + 172 | 0) >> 2] = $6;
    HEAP32[($2 + 168 | 0) >> 2] = $5;
    i64toi32_i32$1 = $2;
    i64toi32_i32$0 = 0;
    HEAP32[($2 + 160 | 0) >> 2] = 0;
    HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$0;
    $T_20as_20core__convert__Into_U____into__hd2808ec68dba4890(($2 + 80 | 0) + 32 | 0 | 0, $2 + 160 | 0 | 0);
    memcpy($0 + 8 | 0 | 0, $2 + 80 | 0 | 0, 48 | 0) | 0;
    $1 = 0;
    break label$1;
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[($0 + 8 | 0) >> 2] = $3;
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h1b9d2509f9812649($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $6 = 0, $11 = 0, $3 = 0, $27 = 0, $28 = 0, $29 = 0, $30 = 0, $31 = 0, $4 = 0, $5 = 0, $9 = 0, $7 = 0, $8 = 0, $10 = 0, $13 = 0, $13$hi = 0, $12 = 0, $67 = 0, $74 = 0, $81 = 0, $88 = 0, $97 = 0, $14 = 0, $14$hi = 0, $15 = 0, $15$hi = 0;
  $2 = global$0 - 128 | 0;
  global$0 = $2;
  $3 = HEAP32[$1 >> 2] | 0;
  $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__hf0a400f99425a834($2 + 8 | 0 | 0, $4 | 0, 0 | 0);
  $5 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  $6 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $6;
  HEAP32[$0 >> 2] = $5;
  label$1 : {
   if (!$6) {
    break label$1
   }
   $7 = $3 + 40 | 0;
   $8 = Math_imul($4, 80);
   $9 = $2 + 96 | 0;
   $10 = $2 + 67 | 0;
   $11 = 0;
   label$2 : while (1) {
    if (($8 | 0) == ($11 | 0)) {
     break label$1
    }
    $6 = $6 + -1 | 0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $13 = i64toi32_i32$0;
    $13$hi = i64toi32_i32$1;
    $12 = HEAPU8[(i64toi32_i32$2 + 72 | 0) >> 0] | 0;
    $cardano_serialization_lib__plutus__PlutusDataEnum_20as_20core__clone__Clone___clone__h7a95fc7c6f531f3b($2 + 16 | 0 | 0, i64toi32_i32$2 + 8 | 0 | 0);
    label$3 : {
     label$4 : {
      if (HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0) {
       break label$4
      }
      HEAP32[($2 + 112 | 0) >> 2] = 0;
      break label$3;
     }
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($2 + 112 | 0 | 0, $7 + $11 | 0 | 0);
    }
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[($2 + 112 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 116 | 0) >> 2] | 0;
    $67 = i64toi32_i32$1;
    i64toi32_i32$1 = $9;
    HEAP32[i64toi32_i32$1 >> 2] = $67;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = ($2 + 16 | 0) + 24 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $74 = i64toi32_i32$0;
    i64toi32_i32$0 = ($2 + 64 | 0) + 24 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $74;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = ($2 + 16 | 0) + 16 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $81 = i64toi32_i32$1;
    i64toi32_i32$1 = ($2 + 64 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $81;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $88 = i64toi32_i32$0;
    i64toi32_i32$0 = ($2 + 64 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $88;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($9 + 8 | 0) >> 2] = HEAP32[(($2 + 112 | 0) + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
    $97 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 64 | 0) >> 2] = $97;
    HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
    $14 = i64toi32_i32$0;
    $14$hi = i64toi32_i32$1;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
    $15 = i64toi32_i32$1;
    $15$hi = i64toi32_i32$0;
    memcpy($2 + 16 | 0 | 0, $2 + 64 | 0 | 0, 48 | 0) | 0;
    $1 = $5 + $11 | 0;
    i64toi32_i32$0 = $13$hi;
    i64toi32_i32$1 = $1;
    HEAP32[i64toi32_i32$1 >> 2] = $13;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    memcpy(i64toi32_i32$1 + 8 | 0 | 0, $2 + 16 | 0 | 0, 48 | 0) | 0;
    HEAP8[(i64toi32_i32$1 + 72 | 0) >> 0] = $12;
    i64toi32_i32$0 = $15$hi;
    i64toi32_i32$1 = i64toi32_i32$1 + 64 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $15;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = $14$hi;
    i64toi32_i32$1 = $1 + 56 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $14;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    $27 = $1 + 73 | 0;
    $28 = HEAPU8[($2 + 64 | 0) >> 0] | 0 | ((HEAPU8[($2 + 65 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 66 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 67 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    HEAP8[$27 >> 0] = $28;
    HEAP8[($27 + 1 | 0) >> 0] = $28 >>> 8 | 0;
    HEAP8[($27 + 2 | 0) >> 0] = $28 >>> 16 | 0;
    HEAP8[($27 + 3 | 0) >> 0] = $28 >>> 24 | 0;
    $29 = $10;
    $30 = $1 + 76 | 0;
    $31 = HEAPU8[$29 >> 0] | 0 | ((HEAPU8[($29 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($29 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($29 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    HEAP8[$30 >> 0] = $31;
    HEAP8[($30 + 1 | 0) >> 0] = $31 >>> 8 | 0;
    HEAP8[($30 + 2 | 0) >> 0] = $31 >>> 16 | 0;
    HEAP8[($30 + 3 | 0) >> 0] = $31 >>> 24 | 0;
    $11 = $11 + 80 | 0;
    $3 = i64toi32_i32$2 + 80 | 0;
    if ($6) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 8 | 0) >> 2] = $4;
  global$0 = $2 + 128 | 0;
 }
 
 function cryptoxide__curve25519__ge__GePrecomp__select__hde28bed3cdd11d0b($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$5 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$4 = 0, $3 = 0, $4 = 0, $27 = 0, $28 = 0, $29 = 0, $30 = 0, $32 = 0, $34 = 0, $35 = 0, $36 = 0, $12 = 0, $16 = 0, $31 = 0, $33 = 0, $40 = 0, $42 = 0, $49 = 0, $51 = 0, $58 = 0, $60 = 0, $67 = 0, $69 = 0, $76 = 0, $78 = 0, $85 = 0, $87 = 0;
  $3 = global$0 - 208 | 0;
  global$0 = $3;
  $0 = memcpy($0 | 0, 1104720 | 0, 120 | 0) | 0;
  label$1 : {
   if ($1 >>> 0 > 31 >>> 0) {
    break label$1
   }
   $12 = $0;
   $1 = Math_imul($1, 960);
   $16 = $1 + 1104856 | 0;
   $4 = $2 - (((($2 << 24 | 0) >> 31 | 0) & $2 | 0) << 1 | 0) | 0;
   i64toi32_i32$0 = 0;
   i64toi32_i32$2 = $4 ^ 1 | 0;
   i64toi32_i32$1 = 0;
   i64toi32_i32$3 = 255;
   i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
   i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
   i64toi32_i32$2 = -1;
   i64toi32_i32$3 = -1;
   i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
   i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
   if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
    i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
   }
   i64toi32_i32$1 = i64toi32_i32$4;
   i64toi32_i32$0 = 0;
   i64toi32_i32$3 = 63;
   i64toi32_i32$2 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$0 = 0;
    $27 = i64toi32_i32$5 >>> i64toi32_i32$2 | 0;
   } else {
    i64toi32_i32$0 = i64toi32_i32$5 >>> i64toi32_i32$2 | 0;
    $27 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$2 | 0) | 0;
   }
   cryptoxide__curve25519__ge__GePrecomp__maybe_set__h501e3b2851925ba0($12 | 0, $16 | 0, $27 | 0, i64toi32_i32$0 | 0);
   $31 = $0;
   $33 = $1 + 1104976 | 0;
   i64toi32_i32$0 = 0;
   i64toi32_i32$5 = $4 ^ 2 | 0;
   i64toi32_i32$1 = 0;
   i64toi32_i32$3 = 255;
   i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
   i64toi32_i32$0 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
   i64toi32_i32$5 = -1;
   i64toi32_i32$3 = -1;
   i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
   i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
   if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
    i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
   }
   i64toi32_i32$1 = i64toi32_i32$2;
   i64toi32_i32$0 = 0;
   i64toi32_i32$3 = 63;
   i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$0 = 0;
    $28 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
   } else {
    i64toi32_i32$0 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
    $28 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$5 | 0) | 0;
   }
   cryptoxide__curve25519__ge__GePrecomp__maybe_set__h501e3b2851925ba0($31 | 0, $33 | 0, $28 | 0, i64toi32_i32$0 | 0);
   $40 = $0;
   $42 = $1 + 1105096 | 0;
   i64toi32_i32$0 = 0;
   i64toi32_i32$4 = $4 ^ 3 | 0;
   i64toi32_i32$1 = 0;
   i64toi32_i32$3 = 255;
   i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
   i64toi32_i32$0 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
   i64toi32_i32$4 = -1;
   i64toi32_i32$3 = -1;
   i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
   i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
   if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
    i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
   }
   i64toi32_i32$1 = i64toi32_i32$5;
   i64toi32_i32$0 = 0;
   i64toi32_i32$3 = 63;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$0 = 0;
    $29 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   } else {
    i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
    $29 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
   }
   cryptoxide__curve25519__ge__GePrecomp__maybe_set__h501e3b2851925ba0($40 | 0, $42 | 0, $29 | 0, i64toi32_i32$0 | 0);
   $49 = $0;
   $51 = $1 + 1105216 | 0;
   i64toi32_i32$0 = 0;
   i64toi32_i32$2 = $4 ^ 4 | 0;
   i64toi32_i32$1 = 0;
   i64toi32_i32$3 = 255;
   i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
   i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
   i64toi32_i32$2 = -1;
   i64toi32_i32$3 = -1;
   i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
   i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
   if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
    i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
   }
   i64toi32_i32$1 = i64toi32_i32$4;
   i64toi32_i32$0 = 0;
   i64toi32_i32$3 = 63;
   i64toi32_i32$2 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$0 = 0;
    $30 = i64toi32_i32$5 >>> i64toi32_i32$2 | 0;
   } else {
    i64toi32_i32$0 = i64toi32_i32$5 >>> i64toi32_i32$2 | 0;
    $30 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$2 | 0) | 0;
   }
   cryptoxide__curve25519__ge__GePrecomp__maybe_set__h501e3b2851925ba0($49 | 0, $51 | 0, $30 | 0, i64toi32_i32$0 | 0);
   $58 = $0;
   $60 = $1 + 1105336 | 0;
   i64toi32_i32$0 = 0;
   i64toi32_i32$5 = $4 ^ 5 | 0;
   i64toi32_i32$1 = 0;
   i64toi32_i32$3 = 255;
   i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
   i64toi32_i32$0 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
   i64toi32_i32$5 = -1;
   i64toi32_i32$3 = -1;
   i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
   i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
   if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
    i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
   }
   i64toi32_i32$1 = i64toi32_i32$2;
   i64toi32_i32$0 = 0;
   i64toi32_i32$3 = 63;
   i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$0 = 0;
    $32 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
   } else {
    i64toi32_i32$0 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
    $32 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$5 | 0) | 0;
   }
   cryptoxide__curve25519__ge__GePrecomp__maybe_set__h501e3b2851925ba0($58 | 0, $60 | 0, $32 | 0, i64toi32_i32$0 | 0);
   $67 = $0;
   $69 = $1 + 1105456 | 0;
   i64toi32_i32$0 = 0;
   i64toi32_i32$4 = $4 ^ 6 | 0;
   i64toi32_i32$1 = 0;
   i64toi32_i32$3 = 255;
   i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
   i64toi32_i32$0 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
   i64toi32_i32$4 = -1;
   i64toi32_i32$3 = -1;
   i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
   i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
   if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
    i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
   }
   i64toi32_i32$1 = i64toi32_i32$5;
   i64toi32_i32$0 = 0;
   i64toi32_i32$3 = 63;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$0 = 0;
    $34 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   } else {
    i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
    $34 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
   }
   cryptoxide__curve25519__ge__GePrecomp__maybe_set__h501e3b2851925ba0($67 | 0, $69 | 0, $34 | 0, i64toi32_i32$0 | 0);
   $76 = $0;
   $78 = $1 + 1105576 | 0;
   i64toi32_i32$0 = 0;
   i64toi32_i32$2 = $4 ^ 7 | 0;
   i64toi32_i32$1 = 0;
   i64toi32_i32$3 = 255;
   i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
   i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
   i64toi32_i32$2 = -1;
   i64toi32_i32$3 = -1;
   i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
   i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
   if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
    i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
   }
   i64toi32_i32$1 = i64toi32_i32$4;
   i64toi32_i32$0 = 0;
   i64toi32_i32$3 = 63;
   i64toi32_i32$2 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$0 = 0;
    $35 = i64toi32_i32$5 >>> i64toi32_i32$2 | 0;
   } else {
    i64toi32_i32$0 = i64toi32_i32$5 >>> i64toi32_i32$2 | 0;
    $35 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$2 | 0) | 0;
   }
   cryptoxide__curve25519__ge__GePrecomp__maybe_set__h501e3b2851925ba0($76 | 0, $78 | 0, $35 | 0, i64toi32_i32$0 | 0);
   $85 = $0;
   $87 = $1 + 1105696 | 0;
   i64toi32_i32$0 = 0;
   i64toi32_i32$5 = $4 ^ 8 | 0;
   i64toi32_i32$1 = 0;
   i64toi32_i32$3 = 255;
   i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
   i64toi32_i32$0 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
   i64toi32_i32$5 = -1;
   i64toi32_i32$3 = -1;
   i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
   i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
   if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
    i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
   }
   i64toi32_i32$1 = i64toi32_i32$2;
   i64toi32_i32$0 = 0;
   i64toi32_i32$3 = 63;
   i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$0 = 0;
    $36 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
   } else {
    i64toi32_i32$0 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
    $36 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$5 | 0) | 0;
   }
   cryptoxide__curve25519__ge__GePrecomp__maybe_set__h501e3b2851925ba0($85 | 0, $87 | 0, $36 | 0, i64toi32_i32$0 | 0);
   memcpy($3 + 128 | 0 | 0, $0 + 40 | 0 | 0, 40 | 0) | 0;
   memcpy($3 + 168 | 0 | 0, $0 | 0, 40 | 0) | 0;
   $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Neg___neg__h2304cb0016645bc0(($3 + 8 | 0) + 80 | 0 | 0, $0 + 80 | 0 | 0);
   memcpy($3 + 8 | 0 | 0, $3 + 128 | 0 | 0, 40 | 0) | 0;
   memcpy(($3 + 8 | 0) + 40 | 0 | 0, $3 + 168 | 0 | 0, 40 | 0) | 0;
   i64toi32_i32$0 = 0;
   cryptoxide__curve25519__ge__GePrecomp__maybe_set__h501e3b2851925ba0($0 | 0, $3 + 8 | 0 | 0, ($2 & 128 | 0) >>> 7 | 0 | 0, i64toi32_i32$0 | 0);
   global$0 = $3 + 208 | 0;
   return;
  }
  core__panicking__panic_bounds_check__h808b524af17640b1($1 | 0, 32 | 0, 1104840 | 0);
  abort();
 }
 
 function alloc__collections__btree__map__entry__VacantEntry_K_2cV___insert__h0ed6cc8b755d44e5($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $5 = 0, $8 = 0, $4 = 0, $20 = 0, $29 = 0, $35 = 0, $41 = 0, $44 = 0, $3 = 0, $6 = 0, $7 = 0, $109 = 0, $114 = 0, $120 = 0, $123 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  HEAP32[(($2 + 120 | 0) + 8 | 0) >> 2] = HEAP32[($0 + 20 | 0) >> 2] | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 120 | 0) >> 2] = $20;
  HEAP32[($2 + 124 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $29 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 136 | 0) >> 2] = $29;
  HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $35 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 72 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $35;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $41 = i64toi32_i32$1;
  i64toi32_i32$1 = ($2 + 72 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $41;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $44 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 72 | 0) >> 2] = $44;
  HEAP32[($2 + 76 | 0) >> 2] = i64toi32_i32$1;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_recursing__h2616a53b5ac2d36f($2 | 0, $2 + 120 | 0 | 0, $2 + 136 | 0 | 0, $2 + 72 | 0 | 0);
  $3 = HEAP32[($2 + 64 | 0) >> 2] | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[$2 >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     $0 = HEAP32[($0 + 24 | 0) >> 2] | 0;
     HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
     break label$2;
    }
    $4 = $2 + 8 | 0;
    memcpy($2 + 72 | 0 | 0, $4 | 0, 40 | 0) | 0;
    $0 = HEAP32[($0 + 24 | 0) >> 2] | 0;
    $5 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    if (!$5) {
     break label$1
    }
    $6 = HEAP32[($2 + 60 | 0) >> 2] | 0;
    $7 = HEAP32[($2 + 56 | 0) >> 2] | 0;
    $8 = HEAP32[$0 >> 2] | 0;
    $1 = alloc__boxed__Box_T_2cA___new_uninit_in__h22083d1d420f57ec() | 0;
    HEAP32[($1 + 408 | 0) >> 2] = $5;
    HEAP16[($1 + 402 | 0) >> 1] = 0;
    HEAP32[($1 + 264 | 0) >> 2] = 0;
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    $8 = $8 + 1 | 0;
    HEAP32[$0 >> 2] = $8;
    HEAP16[($5 + 400 | 0) >> 1] = 0;
    HEAP32[($5 + 264 | 0) >> 2] = $1;
    HEAP32[($2 + 116 | 0) >> 2] = $1;
    HEAP32[($2 + 112 | 0) >> 2] = $8;
    HEAP32[(($2 + 120 | 0) + 8 | 0) >> 2] = HEAP32[($4 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $109 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 120 | 0) >> 2] = $109;
    HEAP32[($2 + 124 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $2 + 104 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $114 = i64toi32_i32$0;
    i64toi32_i32$0 = $2 + 152 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $114;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $2 + 96 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $120 = i64toi32_i32$1;
    i64toi32_i32$1 = ($2 + 136 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $120;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 92 | 0) >> 2] | 0;
    $123 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[($2 + 136 | 0) >> 2] = $123;
    HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$1;
    alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal___push__h92c515d208d4f729($2 + 112 | 0 | 0, $2 + 120 | 0 | 0, $2 + 136 | 0 | 0, $7 | 0, $6 | 0);
    HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
   }
   global$0 = $2 + 160 | 0;
   return $3 | 0;
  }
  core__panicking__panic__h2fd385a887c8bf13(1089252 | 0, 43 | 0, 1089392 | 0);
  abort();
 }
 
 function cardano_serialization_lib__TransactionWitnessSets__add__h6acbfa8707fa525a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $63 = 0, $66 = 0, $93 = 0, $96 = 0, $99 = 0;
  $2 = global$0 - 144 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if (HEAP32[$1 >> 2] | 0) {
     break label$2
    }
    HEAP32[($2 + 80 | 0) >> 2] = 0;
    break label$1;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h26733a351c1d0f0b($2 + 80 | 0 | 0, $1 | 0);
  }
  $3 = $1 + 24 | 0;
  label$3 : {
   label$4 : {
    $4 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    if ($4) {
     break label$4
    }
    HEAP32[($2 + 96 | 0) >> 2] = 0;
    break label$3;
   }
   alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($2 + 96 | 0 | 0, $4 | 0, HEAP32[($1 + 20 | 0) >> 2] | 0 | 0);
  }
  label$5 : {
   label$6 : {
    if (HEAP32[$3 >> 2] | 0) {
     break label$6
    }
    HEAP32[($2 + 112 | 0) >> 2] = 0;
    break label$5;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h09a8331f58cd0bf4($2 + 112 | 0 | 0, $3 | 0);
  }
  label$7 : {
   label$8 : {
    if (HEAP32[($1 + 36 | 0) >> 2] | 0) {
     break label$8
    }
    HEAP32[($2 + 36 | 0) >> 2] = 0;
    break label$7;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hc722e22117ee5940($2 + 36 | 0 | 0, $1 + 36 | 0 | 0);
  }
  $3 = $1 + 64 | 0;
  label$9 : {
   label$10 : {
    if ((HEAPU8[($1 + 60 | 0) >> 0] | 0 | 0) != (3 | 0)) {
     break label$10
    }
    HEAP8[($2 + 60 | 0) >> 0] = 3;
    break label$9;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hc831120dea694494($2 + 128 | 0 | 0, $1 + 48 | 0 | 0);
   $1 = HEAPU8[($1 + 60 | 0) >> 0] | 0;
   HEAP8[($2 + 140 | 0) >> 0] = ($1 | 0) == (2 | 0) ? 2 : ($1 | 0) != (0 | 0);
   i64toi32_i32$2 = $2 + 136 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $63 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 56 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $63;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = HEAP32[($2 + 128 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 132 | 0) >> 2] | 0;
   $66 = i64toi32_i32$1;
   i64toi32_i32$1 = $2;
   HEAP32[($2 + 48 | 0) >> 2] = $66;
   HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$0;
  }
  label$11 : {
   label$12 : {
    if (HEAP32[$3 >> 2] | 0) {
     break label$12
    }
    HEAP32[($2 + 64 | 0) >> 2] = 0;
    break label$11;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h1b9d2509f9812649($2 + 64 | 0 | 0, $3 | 0);
  }
  HEAP32[($2 + 8 | 0) >> 2] = HEAP32[(($2 + 80 | 0) + 8 | 0) >> 2] | 0;
  HEAP32[($2 + 20 | 0) >> 2] = HEAP32[(($2 + 96 | 0) + 8 | 0) >> 2] | 0;
  HEAP32[($2 + 32 | 0) >> 2] = HEAP32[(($2 + 112 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 80 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 84 | 0) >> 2] | 0;
  $93 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[$2 >> 2] = $93;
  HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 96 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 100 | 0) >> 2] | 0;
  $96 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 12 | 0) >> 2] = $96;
  HEAP32[($2 + 16 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 112 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 116 | 0) >> 2] | 0;
  $99 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $99;
  HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$1;
  label$13 : {
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (($1 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
    break label$13
   }
   alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h2b9e4edca640f3c0($0 | 0, $1 | 0, 1 | 0);
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  }
  memcpy((HEAP32[$0 >> 2] | 0) + Math_imul($1, 76) | 0 | 0, $2 | 0, 76 | 0) | 0;
  HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
  global$0 = $2 + 144 | 0;
 }
 
 function std__io__read_to_end_with_reservation__hb7238e9014e3486e($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $5 = 0, $7 = 0, $6 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $4 = 0, i64toi32_i32$4 = 0, $10 = 0, $90 = 0, $8 = 0, $9 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  HEAP32[($3 + 28 | 0) >> 2] = $4;
  HEAP32[($3 + 24 | 0) >> 2] = $2;
  $5 = $4;
  $6 = $5;
  label$1 : while (1) {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        if (($6 | 0) != ($5 | 0)) {
         break label$6
        }
        i64toi32_i32$2 = $1;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $10 = i64toi32_i32$0;
        i64toi32_i32$2 = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 32;
        i64toi32_i32$4 = i64toi32_i32$1 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
        i64toi32_i32$2 = i64toi32_i32$1;
        i64toi32_i32$1 = 0;
        i64toi32_i32$0 = i64toi32_i32$4 ? $10 : 32;
        i64toi32_i32$3 = i64toi32_i32$4 ? i64toi32_i32$2 : i64toi32_i32$1;
        alloc__vec__Vec_T_2cA___reserve__h9cf757d86af8f187($2 | 0, i64toi32_i32$0 | 0);
        HEAP32[($2 + 8 | 0) >> 2] = HEAP32[($2 + 4 | 0) >> 2] | 0;
        $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__DerefMut___deref_mut__h1882e042320a120c($3 + 16 | 0 | 0, $2 | 0);
        $7 = HEAP32[($3 + 20 | 0) >> 2] | 0;
        if ($7 >>> 0 < $5 >>> 0) {
         break label$5
        }
       }
       $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__DerefMut___deref_mut__h1882e042320a120c($3 + 8 | 0 | 0, $2 | 0);
       $5 = HEAP32[($3 + 12 | 0) >> 2] | 0;
       if ($5 >>> 0 < $6 >>> 0) {
        break label$4
       }
       $5 = $5 - $6 | 0;
       $std__io__Take_T__20as_20std__io__Read___read__h7d727131765c43bf($3 + 32 | 0 | 0, $1 | 0, (HEAP32[($3 + 8 | 0) >> 2] | 0) + $6 | 0 | 0, $5 | 0);
       label$7 : {
        label$8 : {
         label$9 : {
          label$10 : {
           if ((HEAP32[($3 + 32 | 0) >> 2] | 0 | 0) == (1 | 0)) {
            break label$10
           }
           $7 = HEAP32[($3 + 36 | 0) >> 2] | 0;
           if ($7) {
            break label$8
           }
           HEAP32[($0 + 4 | 0) >> 2] = $6 - $4 | 0;
           $6 = 0;
           break label$9;
          }
          label$11 : {
           label$12 : {
            label$13 : {
             label$14 : {
              $7 = HEAPU8[($3 + 36 | 0) >> 0] | 0;
              switch ($7 | 0) {
              case 3:
               break label$12;
              case 1:
              case 2:
               break label$13;
              default:
               break label$14;
              };
             }
             $5 = (std__sys__wasm__common__decode_error_kind__h5a4431004f2950eb(HEAP32[($3 + 40 | 0) >> 2] | 0 | 0) | 0) & 255 | 0;
             break label$11;
            }
            $5 = HEAPU8[($3 + 37 | 0) >> 0] | 0;
            break label$11;
           }
           $5 = HEAPU8[((HEAP32[($3 + 40 | 0) >> 2] | 0) + 8 | 0) >> 0] | 0;
          }
          if (($5 & 255 | 0 | 0) == (35 | 0)) {
           break label$7
          }
          i64toi32_i32$4 = $3;
          i64toi32_i32$3 = HEAP32[($3 + 36 | 0) >> 2] | 0;
          i64toi32_i32$0 = HEAP32[($3 + 40 | 0) >> 2] | 0;
          $90 = i64toi32_i32$3;
          i64toi32_i32$3 = $0;
          HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = $90;
          HEAP32[(i64toi32_i32$3 + 8 | 0) >> 2] = i64toi32_i32$0;
          $6 = 1;
         }
         HEAP32[$0 >> 2] = $6;
         $std__io__Guard_20as_20core__ops__drop__Drop___drop__h461f186cd487a5a1($3 + 24 | 0 | 0);
         global$0 = $3 + 48 | 0;
         return;
        }
        if ($7 >>> 0 > $5 >>> 0) {
         break label$3
        }
        $6 = $7 + $6 | 0;
        HEAP32[($3 + 28 | 0) >> 2] = $6;
        break label$2;
       }
       if (($7 | 0) != (3 | 0)) {
        break label$2
       }
       $5 = HEAP32[($3 + 40 | 0) >> 2] | 0;
       FUNCTION_TABLE[HEAP32[(HEAP32[($5 + 4 | 0) >> 2] | 0) >> 2] | 0 | 0](HEAP32[$5 >> 2] | 0);
       $7 = HEAP32[($5 + 4 | 0) >> 2] | 0;
       $8 = HEAP32[($7 + 8 | 0) >> 2] | 0;
       $7 = HEAP32[($7 + 4 | 0) >> 2] | 0;
       $9 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$5 >> 2] | 0 | 0) | 0;
       label$15 : {
        if (!$7) {
         break label$15
        }
        __rust_dealloc($9 | 0, $7 | 0, $8 | 0);
       }
       __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($5 | 0) | 0 | 0, 12 | 0, 4 | 0);
       break label$2;
      }
      core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($5 | 0, $7 | 0, 1061048 | 0);
      abort();
     }
     core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($6 | 0, $5 | 0, 1061064 | 0);
     abort();
    }
    core__panicking__panic__h2fd385a887c8bf13(1061080 | 0, 32 | 0, 1061112 | 0);
    abort();
   }
   $5 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   continue label$1;
  };
 }
 
 function cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__add_required_plutus_input_scripts__hba7e8d5bf0a2077d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $10 = 0, $4 = 0, $5 = 0, $6 = 0, $7 = 0, $8 = 0, $9 = 0, $57 = 0, $63 = 0, $66 = 0, $84 = 0, $88 = 0, $92 = 0;
  $2 = global$0 - 448 | 0;
  global$0 = $2;
  label$1 : {
   $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   if (!$3) {
    break label$1
   }
   $4 = HEAP32[$1 >> 2] | 0;
   $5 = Math_imul($3, 144);
   $6 = ($2 + 216 | 0) + 8 | 0;
   $7 = ($2 + 32 | 0) + 48 | 0;
   $8 = ($2 + 368 | 0) + 8 | 0;
   $9 = ($2 + 32 | 0) + 128 | 0;
   $3 = 0;
   label$2 : while (1) {
    $1 = $4 + $3 | 0;
    $10 = $1 + 128 | 0;
    cardano_serialization_lib__plutus__PlutusScript__hash__hf798a55ecc919284($2 | 0, $10 | 0);
    label$3 : {
     if (!(hashbrown__map__HashMap_K_2cV_2cS_2cA___contains_key__h0a193e832d1442fa($0 | 0, $2 | 0) | 0)) {
      break label$3
     }
     HEAP32[(($2 + 184 | 0) + 24 | 0) >> 2] = HEAP32[($2 + 24 | 0) >> 2] | 0;
     i64toi32_i32$2 = $2 + 16 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $57 = i64toi32_i32$0;
     i64toi32_i32$0 = ($2 + 184 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $57;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $2 + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $63 = i64toi32_i32$1;
     i64toi32_i32$1 = ($2 + 184 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $63;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
     $66 = i64toi32_i32$0;
     i64toi32_i32$0 = $2;
     HEAP32[($2 + 184 | 0) >> 2] = $66;
     HEAP32[($2 + 188 | 0) >> 2] = i64toi32_i32$1;
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($9 | 0, $10 | 0);
     $cardano_serialization_lib__plutus__PlutusData_20as_20core__clone__Clone___clone__h63d1a98cc18f4609_1($2 + 32 | 0 | 0, $1 | 0);
     i64toi32_i32$2 = $1 + 48 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $10 = HEAPU8[($1 + 120 | 0) >> 0] | 0;
     $cardano_serialization_lib__plutus__PlutusData_20as_20core__clone__Clone___clone__h63d1a98cc18f4609_1($8 | 0, $1 + 56 | 0 | 0);
     HEAP8[($2 + 440 | 0) >> 0] = $10;
     $84 = i64toi32_i32$1;
     i64toi32_i32$1 = $2;
     HEAP32[($2 + 368 | 0) >> 2] = $84;
     HEAP32[($2 + 372 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $1 + 112 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $88 = i64toi32_i32$0;
     i64toi32_i32$0 = $2;
     HEAP32[($2 + 432 | 0) >> 2] = $88;
     HEAP32[($2 + 436 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $1 + 104 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $92 = i64toi32_i32$1;
     i64toi32_i32$1 = $2;
     HEAP32[($2 + 424 | 0) >> 2] = $92;
     HEAP32[($2 + 428 | 0) >> 2] = i64toi32_i32$0;
     memcpy($7 | 0, $2 + 368 | 0 | 0, 80 | 0) | 0;
     memcpy($6 | 0, $2 + 32 | 0 | 0, 144 | 0) | 0;
     i64toi32_i32$1 = $2;
     i64toi32_i32$0 = 0;
     HEAP32[($2 + 216 | 0) >> 2] = 1;
     HEAP32[($2 + 220 | 0) >> 2] = i64toi32_i32$0;
     linked_hash_map__LinkedHashMap_K_2cV_2cS___insert__h0e2ff8a07783b7ab($2 + 32 | 0 | 0, $0 | 0, $2 + 184 | 0 | 0, $2 + 216 | 0 | 0);
     core__ptr__drop_in_place_core__option__Option_core__option__Option_cardano_serialization_lib__tx_builder__tx_inputs_builder__ScriptWitnessType_____hc1cbaf0cb4e97823($2 + 32 | 0 | 0);
    }
    $3 = $3 + 144 | 0;
    if (($5 | 0) != ($3 | 0)) {
     continue label$2
    }
    break label$2;
   };
  }
  $3 = 0;
  $1 = 0;
  label$4 : {
   $0 = HEAP32[($0 + 32 | 0) >> 2] | 0;
   if (!$0) {
    break label$4
   }
   $1 = HEAP32[($0 + 156 | 0) >> 2] | 0;
  }
  label$5 : {
   if (($1 | 0) == ($0 | 0)) {
    break label$5
   }
   $3 = 0;
   label$6 : while (1) {
    i64toi32_i32$2 = $1;
    i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    $3 = $3 + ((i64toi32_i32$2 | 0) == (2 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) | 0;
    $1 = HEAP32[($1 + 156 | 0) >> 2] | 0;
    if (($1 | 0) != ($0 | 0)) {
     continue label$6
    }
    break label$6;
   };
  }
  global$0 = $2 + 448 | 0;
  return $3 | 0;
 }
 
 function cardano_serialization_lib__Relay__from_bytes__h5151689bf24e15be($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $7 = 0, $20 = 0, $44 = 0, $50 = 0, $57 = 0, $5$hi = 0, $6$hi = 0, $7$hi = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 320 | 0;
  global$0 = $2;
  HEAP32[(($2 + 152 | 0) + 16 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 152 | 0) >> 2] = 0;
  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 160 | 0) >> 2] = $20;
  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__RelayEnum___deserialize__hd3d69580361177a1($2 + 248 | 0 | 0, $2 + 152 | 0 | 0);
  $1 = ($2 + 152 | 0) + 8 | 0;
  label$1 : {
   label$2 : {
    $3 = HEAP32[($2 + 248 | 0) >> 2] | 0;
    if (($3 | 0) == (1 | 0)) {
     break label$2
    }
    $4 = HEAP32[($2 + 276 | 0) >> 2] | 0;
    HEAP32[(($2 + 176 | 0) + 24 | 0) >> 2] = $4;
    i64toi32_i32$2 = $2 + 260 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $44 = i64toi32_i32$1;
    i64toi32_i32$1 = ($2 + 80 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $44;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $2 + 268 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $50 = i64toi32_i32$0;
    i64toi32_i32$0 = ($2 + 80 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $50;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(($2 + 80 | 0) + 24 | 0) >> 2] = $4;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[($2 + 252 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 256 | 0) >> 2] | 0;
    $57 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 80 | 0) >> 2] = $57;
    HEAP32[($2 + 84 | 0) >> 2] = i64toi32_i32$0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 4 | 0 | 0, memcpy($2 + 176 | 0 | 4 | 0 | 0, ($2 + 248 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
  }
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  label$3 : {
   label$4 : {
    if ($3) {
     break label$4
    }
    $1 = HEAP32[(($2 + 80 | 0) + 24 | 0) >> 2] | 0;
    HEAP32[(($2 + 8 | 0) + 24 | 0) >> 2] = $1;
    i64toi32_i32$2 = ($2 + 80 | 0) + 16 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $5 = i64toi32_i32$0;
    $5$hi = i64toi32_i32$1;
    i64toi32_i32$0 = ($2 + 8 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $5;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = ($2 + 80 | 0) + 8 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $6 = i64toi32_i32$1;
    $6$hi = i64toi32_i32$0;
    i64toi32_i32$1 = ($2 + 8 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $6;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[($2 + 80 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 84 | 0) >> 2] | 0;
    $7 = i64toi32_i32$0;
    $7$hi = i64toi32_i32$1;
    i64toi32_i32$0 = $2;
    HEAP32[($2 + 8 | 0) >> 2] = $7;
    HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($0 + 28 | 0) >> 2] = $1;
    i64toi32_i32$1 = $5$hi;
    i64toi32_i32$0 = $0 + 20 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $5;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $6$hi;
    i64toi32_i32$0 = $0 + 12 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $6;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $7$hi;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $7;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
    $1 = 0;
    break label$3;
   }
   memcpy($2 + 248 | 0 | 0, memcpy($2 + 8 | 0 | 4 | 0 | 0, $2 + 80 | 0 | 4 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 248 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 320 | 0;
 }
 
 function serde_json__de__Deserializer_R___parse_exponent__h64f12a2a919bb245($0, $1, $2, $3, $3$hi, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  $4 = $4 | 0;
  var $7 = 0, $8 = 0, $5 = 0, $9 = 0, $6 = 0, $11 = 0, i64toi32_i32$0 = 0, $10 = 0;
  $5 = global$0 - 16 | 0;
  global$0 = $5;
  $6 = 1;
  $7 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $8 = $7 + 1 | 0;
  HEAP32[($1 + 8 | 0) >> 2] = $8;
  label$1 : {
   $9 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   if ($8 >>> 0 >= $9 >>> 0) {
    break label$1
   }
   label$2 : {
    switch ((HEAPU8[((HEAP32[$1 >> 2] | 0) + $8 | 0) >> 0] | 0) + -43 | 0 | 0) {
    case 0:
     $8 = $7 + 2 | 0;
     HEAP32[($1 + 8 | 0) >> 2] = $8;
     break label$1;
    case 2:
     break label$2;
    default:
     break label$1;
    };
   }
   $8 = $7 + 2 | 0;
   HEAP32[($1 + 8 | 0) >> 2] = $8;
   $6 = 0;
  }
  label$4 : {
   label$5 : {
    if ($8 >>> 0 < $9 >>> 0) {
     break label$5
    }
    HEAP32[$5 >> 2] = 5;
    $7 = serde_json__de__Deserializer_R___error__h438ab94fbb97beef($1 | 0, $5 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    HEAP32[($0 + 4 | 0) >> 2] = $7;
    break label$4;
   }
   $7 = $8 + 1 | 0;
   HEAP32[($1 + 8 | 0) >> 2] = $7;
   label$6 : {
    $10 = HEAP32[$1 >> 2] | 0;
    $8 = ((HEAPU8[($10 + $8 | 0) >> 0] | 0) + -48 | 0) & 255 | 0;
    if ($8 >>> 0 < 10 >>> 0) {
     break label$6
    }
    HEAP32[$5 >> 2] = 12;
    $7 = serde_json__de__Deserializer_R___error__h438ab94fbb97beef($1 | 0, $5 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    HEAP32[($0 + 4 | 0) >> 2] = $7;
    break label$4;
   }
   label$7 : {
    if ($7 >>> 0 >= $9 >>> 0) {
     break label$7
    }
    label$8 : while (1) {
     $11 = ((HEAPU8[($10 + $7 | 0) >> 0] | 0) + -48 | 0) & 255 | 0;
     if ($11 >>> 0 >= 10 >>> 0) {
      break label$7
     }
     $7 = $7 + 1 | 0;
     HEAP32[($1 + 8 | 0) >> 2] = $7;
     label$9 : {
      label$10 : {
       if (($8 | 0) < (214748364 | 0)) {
        break label$10
       }
       if (($8 | 0) != (214748364 | 0)) {
        break label$9
       }
       if ($11 >>> 0 > 7 >>> 0) {
        break label$9
       }
      }
      $8 = Math_imul($8, 10) + $11 | 0;
      if (($9 | 0) != ($7 | 0)) {
       continue label$8
      }
      break label$7;
     }
     break label$8;
    };
    i64toi32_i32$0 = $3$hi;
    serde_json__de__Deserializer_R___parse_exponent_overflow__hfb467b8d7cf5b1c5($0 | 0, $1 | 0, $2 | 0, !($3 | i64toi32_i32$0 | 0) | 0, $6 | 0);
    break label$4;
   }
   label$11 : {
    label$12 : {
     if ($6) {
      break label$12
     }
     $7 = $4 - $8 | 0;
     $7 = ($8 | 0) > (0 | 0) ^ ($7 | 0) < ($4 | 0) | 0 ? (($7 | 0) < (0 | 0) ? 2147483647 : -2147483648) : $7;
     break label$11;
    }
    $7 = $4 + $8 | 0;
    $7 = ($8 | 0) < (0 | 0) ^ ($7 | 0) < ($4 | 0) | 0 ? (($7 | 0) < (0 | 0) ? 2147483647 : -2147483648) : $7;
   }
   i64toi32_i32$0 = $3$hi;
   serde_json__de__Deserializer_R___f64_from_parts__hb0108f153aa5786e($0 | 0, $1 | 0, $2 | 0, $3 | 0, i64toi32_i32$0 | 0, $7 | 0);
  }
  global$0 = $5 + 16 | 0;
 }
 
 function std__thread__park__h244f16c0d88cd65a() {
  var $0 = 0, $2 = 0, $3 = 0, $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, $5 = 0, $15 = 0;
  $0 = global$0 - 32 | 0;
  global$0 = $0;
  label$1 : {
   if ((HEAP32[(0 + 1177872 | 0) >> 2] | 0 | 0) == (1 | 0)) {
    break label$1
   }
   i64toi32_i32$1 = 0;
   i64toi32_i32$0 = 0;
   HEAP32[(i64toi32_i32$1 + 1177872 | 0) >> 2] = 1;
   HEAP32[(i64toi32_i32$1 + 1177876 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[(0 + 1177880 | 0) >> 2] = 0;
  }
  $1 = std__sys_common__thread_info__ThreadInfo__with___7b_7bclosure_7d_7d__h1dbe3ea3b6375635(1177876 | 0) | 0;
  $2 = HEAP32[($1 + 24 | 0) >> 2] | 0;
  $15 = $2;
  $2 = ($2 | 0) == (2 | 0);
  HEAP32[($1 + 24 | 0) >> 2] = $2 ? 0 : $15;
  label$2 : {
   label$3 : {
    label$4 : {
     label$5 : {
      label$6 : {
       label$7 : {
        if ($2) {
         break label$7
        }
        $2 = $1 + 24 | 0;
        $3 = HEAPU8[($2 + 4 | 0) >> 0] | 0;
        HEAP8[($2 + 4 | 0) >> 0] = 1;
        $3 = $3 & 1 | 0;
        HEAP8[($0 + 4 | 0) >> 0] = $3;
        if ($3) {
         break label$6
        }
        $4 = 0;
        label$8 : {
         if (!((HEAP32[(0 + 1177836 | 0) >> 2] | 0) & 2147483647 | 0)) {
          break label$8
         }
         $4 = (std__panicking__panic_count__is_zero_slow_path__h1d20871758c70487() | 0) ^ 1 | 0;
        }
        $5 = $2 + 4 | 0;
        if (HEAPU8[($2 + 5 | 0) >> 0] | 0) {
         break label$5
        }
        $3 = HEAP32[$2 >> 2] | 0;
        HEAP32[$2 >> 2] = $3 ? $3 : 1;
        if (!$3) {
         break label$2
        }
        if (($3 | 0) != (2 | 0)) {
         break label$4
        }
        $3 = HEAP32[$2 >> 2] | 0;
        HEAP32[$2 >> 2] = 0;
        HEAP32[($0 + 4 | 0) >> 2] = $3;
        if (($3 | 0) != (2 | 0)) {
         break label$3
        }
        label$9 : {
         if ($4) {
          break label$9
         }
         if (!((HEAP32[(0 + 1177836 | 0) >> 2] | 0) & 2147483647 | 0)) {
          break label$9
         }
         if (std__panicking__panic_count__is_zero_slow_path__h1d20871758c70487() | 0) {
          break label$9
         }
         HEAP8[($2 + 5 | 0) >> 0] = 1;
        }
        HEAP8[$5 >> 0] = 0;
       }
       $2 = HEAP32[$1 >> 2] | 0;
       HEAP32[$1 >> 2] = $2 + -1 | 0;
       label$10 : {
        if (($2 | 0) != (1 | 0)) {
         break label$10
        }
        alloc__sync__Arc_T___drop_slow__h1342fde892a03e74($1 | 0);
       }
       global$0 = $0 + 32 | 0;
       return;
      }
      HEAP32[($0 + 28 | 0) >> 2] = 0;
      HEAP32[($0 + 24 | 0) >> 2] = 1142260;
      i64toi32_i32$1 = $0;
      i64toi32_i32$0 = 0;
      HEAP32[($0 + 12 | 0) >> 2] = 1;
      HEAP32[($0 + 16 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[($0 + 8 | 0) >> 2] = 1145368;
      core__panicking__assert_failed__h1e2384889c2d638e($0 + 4 | 0 | 0, $0 + 8 | 0 | 0);
      abort();
     }
     HEAP8[($0 + 12 | 0) >> 0] = $4;
     HEAP32[($0 + 8 | 0) >> 2] = $5;
     core__result__unwrap_failed__h27f43d993c3864a1(1142536 | 0, 43 | 0, $0 + 8 | 0 | 0, 1142580 | 0, 1145052 | 0);
     abort();
    }
    std__panicking__begin_panic__h7867d4da632f3661(1145068 | 0, 23 | 0, 1145092 | 0);
    abort();
   }
   HEAP32[($0 + 28 | 0) >> 2] = 0;
   HEAP32[($0 + 24 | 0) >> 2] = 1142260;
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[($0 + 12 | 0) >> 2] = 1;
   HEAP32[($0 + 16 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($0 + 8 | 0) >> 2] = 1145140;
   core__panicking__assert_failed__h26fc3570a5d27733($0 + 4 | 0 | 0, $0 + 8 | 0 | 0, 1145148 | 0);
   abort();
  }
  std__sys_common__condvar__Condvar__wait__hd66c60e83901bc8f();
  abort();
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__Update___deserialize_as_embedded_group__h283b753a842c8d26($0, $1, $2, $2$hi, $3, $3$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  var $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $5 = 0;
  $4 = global$0 - 384 | 0;
  global$0 = $4;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__ProposedProtocolParameterUpdates___deserialize__heb1e36bac95b3b52($4 + 312 | 0 | 0, $1 | 0);
  $5 = ($4 + 312 | 0) + 8 | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     i64toi32_i32$2 = $4;
     i64toi32_i32$0 = HEAP32[($4 + 312 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($4 + 316 | 0) >> 2] | 0;
     i64toi32_i32$2 = i64toi32_i32$0;
     i64toi32_i32$0 = 0;
     if ((i64toi32_i32$2 | 0) == (1 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
      break label$3
     }
     memcpy($4 + 248 | 0 | 0, $5 | 0, 40 | 0) | 0;
     memcpy($4 + 112 | 0 | 0, $4 + 248 | 0 | 0, 40 | 0) | 0;
     memcpy($4 + 48 | 0 | 0, memcpy(($4 + 176 | 0) + 8 | 0 | 0, $4 + 112 | 0 | 0, 40 | 0) | 0 | 0, 40 | 0) | 0;
     memcpy($4 + 8 | 0 | 0, $4 + 48 | 0 | 0, 40 | 0) | 0;
     $T_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hf422f9333a8bbafa($4 + 312 | 0 | 0, $1 | 0);
     if ((HEAP32[($4 + 312 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$2
     }
     $1 = HEAP32[($4 + 316 | 0) >> 2] | 0;
     memcpy($0 + 8 | 0 | 0, $4 + 8 | 0 | 0, 40 | 0) | 0;
     i64toi32_i32$1 = $0;
     i64toi32_i32$2 = 0;
     HEAP32[i64toi32_i32$1 >> 2] = 0;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
     HEAP32[(i64toi32_i32$1 + 48 | 0) >> 2] = $1;
     break label$1;
    }
    memcpy($4 + 248 | 0 | 0, $5 | 0, 64 | 0) | 0;
    memcpy($4 + 112 | 0 | 0, $4 + 248 | 0 | 0, 64 | 0) | 0;
    memcpy($4 + 312 | 0 | 0, $4 + 112 | 0 | 0, 64 | 0) | 0;
    $1 = ($4 + 176 | 0) + 8 | 0;
    cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 312 | 0 | 0, 1052003 | 0, 35 | 0);
    memcpy($4 + 48 | 0 | 0, $1 | 0, 64 | 0) | 0;
    memcpy($0 + 8 | 0 | 0, $4 + 48 | 0 | 0, 64 | 0) | 0;
    i64toi32_i32$1 = $0;
    i64toi32_i32$2 = 0;
    HEAP32[i64toi32_i32$1 >> 2] = 1;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
    break label$1;
   }
   memcpy($4 + 248 | 0 | 0, ($4 + 312 | 0) + 8 | 0 | 0, 64 | 0) | 0;
   memcpy($4 + 312 | 0 | 0, $4 + 248 | 0 | 0, 64 | 0) | 0;
   $1 = ($4 + 176 | 0) + 8 | 0;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 312 | 0 | 0, 1051020 | 0, 5 | 0);
   memcpy($0 + 8 | 0 | 0, $1 | 0, 64 | 0) | 0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$2 = 0;
   HEAP32[i64toi32_i32$1 >> 2] = 1;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
   $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__h88c250e8947434a9($4 + 8 | 0 | 0);
   if (!(HEAP32[($4 + 24 | 0) >> 2] | 0)) {
    break label$1
   }
   hashbrown__raw__RawTable_T_2cA___free_buckets__ha5e2f3faac433f39($4 + 24 | 0 | 0);
  }
  global$0 = $4 + 384 | 0;
 }
 
 function hashbrown__raw__RawTable_T_2cA___insert__h017d09d046b49d80($0, $1, $1$hi, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $1$hi = $1$hi | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $10 = 0, $8 = 0, $9 = 0, $5 = 0, $6 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $4 = 0, i64toi32_i32$0 = 0, $7 = 0, i64toi32_i32$1 = 0, $157 = 0;
  $4 = global$0 - 16 | 0;
  global$0 = $4;
  label$1 : {
   $5 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   $6 = HEAP32[$0 >> 2] | 0;
   i64toi32_i32$0 = $1$hi;
   $7 = $1;
   $8 = $6 & $7 | 0;
   $15 = $5 + $8 | 0;
   $9 = (HEAPU8[$15 >> 0] | 0 | ((HEAPU8[($15 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($15 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($15 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
   if ($9) {
    break label$1
   }
   $10 = 4;
   label$2 : while (1) {
    $8 = $8 + $10 | 0;
    $10 = $10 + 4 | 0;
    $8 = $8 & $6 | 0;
    $16 = $5 + $8 | 0;
    $9 = (HEAPU8[$16 >> 0] | 0 | ((HEAPU8[($16 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($16 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($16 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
    if (!$9) {
     continue label$2
    }
    break label$2;
   };
  }
  label$3 : {
   $10 = (((__wasm_ctz_i32($9 | 0) | 0) >>> 3 | 0) + $8 | 0) & $6 | 0;
   $8 = HEAP8[($5 + $10 | 0) >> 0] | 0;
   if (($8 | 0) <= (-1 | 0)) {
    break label$3
   }
   $10 = (__wasm_ctz_i32((HEAP32[$5 >> 2] | 0) & -2139062144 | 0 | 0) | 0) >>> 3 | 0;
   $8 = HEAPU8[($5 + $10 | 0) >> 0] | 0;
  }
  label$4 : {
   $8 = $8 & 1 | 0;
   if (!$8) {
    break label$4
   }
   if (HEAP32[($0 + 8 | 0) >> 2] | 0) {
    break label$4
   }
   hashbrown__raw__RawTable_T_2cA___reserve_rehash__hec1cc27e6be9d875($4 | 0, $0 | 0, 1 | 0, $3 | 0, 1 | 0);
   label$5 : {
    $5 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    $6 = HEAP32[$0 >> 2] | 0;
    $9 = $6 & $7 | 0;
    $17 = $5 + $9 | 0;
    $3 = (HEAPU8[$17 >> 0] | 0 | ((HEAPU8[($17 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($17 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($17 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
    if ($3) {
     break label$5
    }
    $10 = 4;
    label$6 : while (1) {
     $9 = $9 + $10 | 0;
     $10 = $10 + 4 | 0;
     $9 = $9 & $6 | 0;
     $18 = $5 + $9 | 0;
     $3 = (HEAPU8[$18 >> 0] | 0 | ((HEAPU8[($18 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($18 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($18 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
     if (!$3) {
      continue label$6
     }
     break label$6;
    };
   }
   $10 = (((__wasm_ctz_i32($3 | 0) | 0) >>> 3 | 0) + $9 | 0) & $6 | 0;
   if ((HEAP8[($5 + $10 | 0) >> 0] | 0 | 0) <= (-1 | 0)) {
    break label$4
   }
   $10 = (__wasm_ctz_i32((HEAP32[$5 >> 2] | 0) & -2139062144 | 0 | 0) | 0) >>> 3 | 0;
  }
  $9 = $7 >>> 25 | 0;
  HEAP8[($5 + $10 | 0) >> 0] = $9;
  HEAP8[(((($10 + -4 | 0) & $6 | 0) + $5 | 0) + 4 | 0) >> 0] = $9;
  HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) - $8 | 0;
  HEAP32[($0 + 12 | 0) >> 2] = (HEAP32[($0 + 12 | 0) >> 2] | 0) + 1 | 0;
  $10 = $5 + Math_imul(0 - $10 | 0, 12) | 0;
  $8 = $10 + -12 | 0;
  HEAP32[($8 + 8 | 0) >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $157 = i64toi32_i32$0;
  i64toi32_i32$0 = $8;
  HEAP32[$8 >> 2] = $157;
  HEAP32[($8 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $4 + 16 | 0;
  return $10 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert__h03a244908a0f74f5($0, $1, $2, $3, $4, $5) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  $5 = $5 | 0;
  var $6 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $7 = 0, $8 = 0, $57 = 0, $62 = 0, $67 = 0, $70 = 0, $105 = 0, $111 = 0, $117 = 0, $120 = 0;
  $6 = global$0 - 112 | 0;
  global$0 = $6;
  label$1 : {
   label$2 : {
    $7 = HEAP32[$1 >> 2] | 0;
    if (($7 + -1 | 0 | 0) != ($4 | 0)) {
     break label$2
    }
    label$3 : {
     label$4 : {
      label$5 : {
       $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
       if ((HEAPU16[($4 + 402 | 0) >> 1] | 0) >>> 0 < 11 >>> 0) {
        break label$5
       }
       alloc__collections__btree__node__splitpoint__h8424344594b4deb1($6 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
       $1 = HEAP32[($6 + 8 | 0) >> 2] | 0;
       $8 = HEAP32[($6 + 4 | 0) >> 2] | 0;
       HEAP32[($6 + 96 | 0) >> 2] = HEAP32[$6 >> 2] | 0;
       HEAP32[($6 + 92 | 0) >> 2] = $4;
       HEAP32[($6 + 88 | 0) >> 2] = $7;
       alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__KV___split__h5d37aa412fb34502($6 | 0, $6 + 88 | 0 | 0);
       if (($8 | 0) == (1 | 0)) {
        break label$4
       }
       HEAP32[($6 + 56 | 0) >> 2] = HEAP32[($6 + 40 | 0) >> 2] | 0;
       $4 = HEAP32[($6 + 44 | 0) >> 2] | 0;
       break label$3;
      }
      HEAP32[(($6 + 88 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
      i64toi32_i32$2 = $2;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $57 = i64toi32_i32$0;
      i64toi32_i32$0 = $6;
      HEAP32[($6 + 88 | 0) >> 2] = $57;
      HEAP32[($6 + 92 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $3 + 16 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $62 = i64toi32_i32$1;
      i64toi32_i32$1 = $6 + 16 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $62;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $3 + 8 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $67 = i64toi32_i32$0;
      i64toi32_i32$0 = $6 + 8 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $67;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $3;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $70 = i64toi32_i32$1;
      i64toi32_i32$1 = $6;
      HEAP32[$6 >> 2] = $70;
      HEAP32[($6 + 4 | 0) >> 2] = i64toi32_i32$0;
      alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert_fit__hac9661061fde4be8($1 | 0, $6 + 88 | 0 | 0, $6 | 0, $6 | 0, $5 | 0);
      HEAP32[($0 + 8 | 0) >> 2] = $4;
      HEAP32[($0 + 4 | 0) >> 2] = $7;
      HEAP32[$0 >> 2] = 0;
      HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
      break label$1;
     }
     HEAP32[($6 + 56 | 0) >> 2] = HEAP32[($6 + 48 | 0) >> 2] | 0;
     $4 = HEAP32[($6 + 52 | 0) >> 2] | 0;
    }
    HEAP32[($6 + 64 | 0) >> 2] = $1;
    HEAP32[($6 + 60 | 0) >> 2] = $4;
    HEAP32[(($6 + 72 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $105 = i64toi32_i32$0;
    i64toi32_i32$0 = $6;
    HEAP32[($6 + 72 | 0) >> 2] = $105;
    HEAP32[($6 + 76 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $3 + 16 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $111 = i64toi32_i32$1;
    i64toi32_i32$1 = ($6 + 88 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $111;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $3 + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $117 = i64toi32_i32$0;
    i64toi32_i32$0 = ($6 + 88 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $117;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $120 = i64toi32_i32$1;
    i64toi32_i32$1 = $6;
    HEAP32[($6 + 88 | 0) >> 2] = $120;
    HEAP32[($6 + 92 | 0) >> 2] = i64toi32_i32$0;
    alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert_fit__hac9661061fde4be8($6 + 56 | 0 | 0, $6 + 72 | 0 | 0, $6 + 88 | 0 | 0, $6 | 0, $5 | 0);
    memcpy($0 + 8 | 0 | 0, $6 | 0, 56 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    break label$1;
   }
   core__panicking__panic__h2fd385a887c8bf13(1084564 | 0, 53 | 0, 1084620 | 0);
   abort();
  }
  global$0 = $6 + 112 | 0;
 }
 
 function serde_json__de__Deserializer_R___parse_integer__ha3f9b36c71394728($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $6 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, $3 = 0, $4 = 0, i64toi32_i32$2 = 0, $9$hi = 0, i64toi32_i32$5 = 0, $9 = 0, $5 = 0, $7 = 0, $8 = 0, i64toi32_i32$4 = 0, $90 = 0, $90$hi = 0, $93$hi = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    $5 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if ($4 >>> 0 < $5 >>> 0) {
     break label$2
    }
    HEAP32[$3 >> 2] = 5;
    $6 = serde_json__de__Deserializer_R___error__h438ab94fbb97beef($1 | 0, $3 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    HEAP32[($0 + 4 | 0) >> 2] = $6;
    break label$1;
   }
   $6 = $4 + 1 | 0;
   HEAP32[($1 + 8 | 0) >> 2] = $6;
   label$3 : {
    label$4 : {
     label$5 : {
      $7 = HEAP32[$1 >> 2] | 0;
      $4 = HEAPU8[($7 + $4 | 0) >> 0] | 0;
      if (($4 | 0) != (48 | 0)) {
       break label$5
      }
      label$6 : {
       if ($6 >>> 0 >= $5 >>> 0) {
        break label$6
       }
       if ((((HEAPU8[($7 + $6 | 0) >> 0] | 0) + -48 | 0) & 255 | 0) >>> 0 < 10 >>> 0) {
        break label$4
       }
      }
      i64toi32_i32$0 = 0;
      serde_json__de__Deserializer_R___parse_number__h15009467721a2ef0($0 | 0, $1 | 0, $2 | 0, 0 | 0, i64toi32_i32$0 | 0);
      break label$1;
     }
     label$7 : {
      if ((($4 + -49 | 0) & 255 | 0) >>> 0 < 9 >>> 0) {
       break label$7
      }
      HEAP32[$3 >> 2] = 12;
      $6 = serde_json__de__Deserializer_R___error__h438ab94fbb97beef($1 | 0, $3 | 0) | 0;
      HEAP32[$0 >> 2] = 1;
      HEAP32[($0 + 4 | 0) >> 2] = $6;
      break label$1;
     }
     i64toi32_i32$0 = 0;
     i64toi32_i32$2 = $4 + -48 | 0;
     i64toi32_i32$1 = 0;
     i64toi32_i32$3 = 255;
     i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
     $9 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     $9$hi = i64toi32_i32$1;
     if ($6 >>> 0 >= $5 >>> 0) {
      break label$3
     }
     label$8 : while (1) {
      $4 = (HEAPU8[($7 + $6 | 0) >> 0] | 0) + -48 | 0;
      $8 = $4 & 255 | 0;
      if ($8 >>> 0 >= 10 >>> 0) {
       break label$3
      }
      label$9 : {
       label$10 : {
        i64toi32_i32$1 = $9$hi;
        i64toi32_i32$0 = $9;
        i64toi32_i32$2 = 429496729;
        i64toi32_i32$3 = -1717986919;
        if (i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0) {
         break label$10
        }
        i64toi32_i32$0 = $9$hi;
        i64toi32_i32$3 = $9;
        i64toi32_i32$1 = 429496729;
        i64toi32_i32$2 = -1717986919;
        if ((i64toi32_i32$3 | 0) != (i64toi32_i32$2 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | 0) {
         break label$9
        }
        if ($8 >>> 0 > 5 >>> 0) {
         break label$9
        }
       }
       $6 = $6 + 1 | 0;
       HEAP32[($1 + 8 | 0) >> 2] = $6;
       i64toi32_i32$3 = $9$hi;
       i64toi32_i32$0 = 0;
       i64toi32_i32$0 = __wasm_i64_mul($9 | 0, i64toi32_i32$3 | 0, 10 | 0, i64toi32_i32$0 | 0) | 0;
       i64toi32_i32$3 = i64toi32_i32$HIGH_BITS;
       $90 = i64toi32_i32$0;
       $90$hi = i64toi32_i32$3;
       i64toi32_i32$3 = 0;
       i64toi32_i32$2 = $4;
       i64toi32_i32$0 = 0;
       i64toi32_i32$1 = 255;
       i64toi32_i32$0 = i64toi32_i32$3 & i64toi32_i32$0 | 0;
       $93$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $90$hi;
       i64toi32_i32$3 = $90;
       i64toi32_i32$2 = $93$hi;
       i64toi32_i32$1 = $4 & i64toi32_i32$1 | 0;
       i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
       i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
       if (i64toi32_i32$4 >>> 0 < i64toi32_i32$1 >>> 0) {
        i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
       }
       $9 = i64toi32_i32$4;
       $9$hi = i64toi32_i32$5;
       if (($5 | 0) != ($6 | 0)) {
        continue label$8
       }
       break label$3;
      }
      break label$8;
     };
     i64toi32_i32$5 = $9$hi;
     serde_json__de__Deserializer_R___parse_long_integer__hf2c70827599d3466($3 | 0, $1 | 0, $2 | 0, $9 | 0, $9$hi | 0);
     $6 = 1;
     label$11 : {
      label$12 : {
       if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
        break label$12
       }
       HEAPF64[($0 + 16 | 0) >> 3] = +HEAPF64[($3 + 8 | 0) >> 3];
       i64toi32_i32$3 = $0 + 8 | 0;
       i64toi32_i32$5 = 0;
       HEAP32[i64toi32_i32$3 >> 2] = 0;
       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
       $6 = 0;
       break label$11;
      }
      HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($3 + 4 | 0) >> 2] | 0;
     }
     HEAP32[$0 >> 2] = $6;
     break label$1;
    }
    HEAP32[$3 >> 2] = 12;
    $6 = serde_json__de__Deserializer_R___peek_error__hf8794e102c1db2df($1 | 0, $3 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    HEAP32[($0 + 4 | 0) >> 2] = $6;
    break label$1;
   }
   i64toi32_i32$5 = $9$hi;
   serde_json__de__Deserializer_R___parse_number__h15009467721a2ef0($0 | 0, $1 | 0, $2 | 0, $9 | 0, $9$hi | 0);
  }
  global$0 = $3 + 16 | 0;
 }
 
 function cardano_serialization_lib__utils__read_nint__h6af092dfd2bc47da($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$5 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $2 = 0, $3 = 0, $4 = 0, $4$hi = 0, $5 = 0, $5$hi = 0, i64toi32_i32$4 = 0, $24 = 0, $6 = 0, $7 = 0, $53 = 0, $54 = 0, $56$hi = 0, $59$hi = 0, $74 = 0, $78 = 0, $6$hi = 0, $7$hi = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 8 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if (!(HEAP32[($2 + 12 | 0) >> 2] | 0)) {
       break label$4
      }
      $3 = ($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[(HEAP32[($2 + 8 | 0) >> 2] | 0) >> 0] | 0 | 0) | 0) & 255 | 0;
      if (($3 | 0) != (1 | 0)) {
       break label$3
      }
      cbor_event__de__Deserializer_R___cbor_len__h852681e444aca076($2 + 32 | 0 | 0, $1 | 0);
      $3 = HEAP32[(($2 + 32 | 0) + 24 | 0) >> 2] | 0;
      i64toi32_i32$2 = ($2 + 32 | 0) + 16 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $4 = i64toi32_i32$0;
      $4$hi = i64toi32_i32$1;
      i64toi32_i32$2 = $2;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] | 0;
      $5 = i64toi32_i32$1;
      $5$hi = i64toi32_i32$0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
      i64toi32_i32$2 = i64toi32_i32$0;
      i64toi32_i32$0 = 0;
      i64toi32_i32$3 = 1;
      if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
       break label$2
      }
      label$5 : {
       i64toi32_i32$2 = $5$hi;
       if ($5) {
        break label$5
       }
       HEAP8[($0 + 8 | 0) >> 0] = 2;
       i64toi32_i32$1 = $0;
       i64toi32_i32$2 = 0;
       HEAP32[$0 >> 2] = 1;
       HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$2;
       i64toi32_i32$1 = $0 + 16 | 0;
       i64toi32_i32$2 = 0;
       HEAP32[i64toi32_i32$1 >> 2] = 268;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
       HEAP32[($0 + 56 | 0) >> 2] = 0;
       break label$1;
      }
      i64toi32_i32$1 = $0;
      i64toi32_i32$2 = 0;
      HEAP32[$0 >> 2] = 0;
      HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$1 = $0 + 16 | 0;
      i64toi32_i32$2 = -1;
      HEAP32[i64toi32_i32$1 >> 2] = -1;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
      i64toi32_i32$2 = $4$hi;
      i64toi32_i32$3 = $4;
      i64toi32_i32$1 = -1;
      i64toi32_i32$0 = -1;
      i64toi32_i32$1 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
      $53 = i64toi32_i32$3 ^ i64toi32_i32$0 | 0;
      i64toi32_i32$3 = $0;
      HEAP32[($0 + 8 | 0) >> 2] = $53;
      HEAP32[($0 + 12 | 0) >> 2] = i64toi32_i32$1;
      $54 = $1;
      i64toi32_i32$2 = $1;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $56$hi = i64toi32_i32$3;
      i64toi32_i32$3 = 0;
      $59$hi = i64toi32_i32$3;
      i64toi32_i32$3 = $56$hi;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$1 = $59$hi;
      i64toi32_i32$0 = $3 + 1 | 0;
      i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
      i64toi32_i32$5 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
      if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
       i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
      }
      i64toi32_i32$2 = $54;
      HEAP32[i64toi32_i32$2 >> 2] = i64toi32_i32$4;
      HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$5;
      break label$1;
     }
     HEAP8[($0 + 8 | 0) >> 0] = 2;
     i64toi32_i32$2 = $0;
     i64toi32_i32$5 = 0;
     HEAP32[i64toi32_i32$2 >> 2] = 1;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$5;
     i64toi32_i32$2 = i64toi32_i32$2 + 24 | 0;
     i64toi32_i32$5 = 0;
     HEAP32[i64toi32_i32$2 >> 2] = 0;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$5;
     i64toi32_i32$2 = $0 + 16 | 0;
     i64toi32_i32$5 = 0;
     HEAP32[i64toi32_i32$2 >> 2] = 8;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$5;
     HEAP32[($0 + 56 | 0) >> 2] = 0;
     break label$1;
    }
    HEAP8[($0 + 8 | 0) >> 0] = 2;
    i64toi32_i32$2 = $0;
    i64toi32_i32$5 = 0;
    HEAP32[i64toi32_i32$2 >> 2] = 1;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$5;
    HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] = 0;
    $74 = i64toi32_i32$2 + 16 | 0;
    i64toi32_i32$5 = 0;
    i64toi32_i32$3 = $3;
    i64toi32_i32$2 = 0;
    i64toi32_i32$0 = 16;
    i64toi32_i32$1 = i64toi32_i32$0 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
     i64toi32_i32$2 = i64toi32_i32$3 << i64toi32_i32$1 | 0;
     $24 = 0;
    } else {
     i64toi32_i32$2 = ((1 << i64toi32_i32$1 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$1 | 0) | 0) | 0 | (i64toi32_i32$5 << i64toi32_i32$1 | 0) | 0;
     $24 = i64toi32_i32$3 << i64toi32_i32$1 | 0;
    }
    i64toi32_i32$5 = $24;
    i64toi32_i32$3 = 0;
    i64toi32_i32$0 = 265;
    i64toi32_i32$3 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
    $78 = i64toi32_i32$5 | i64toi32_i32$0 | 0;
    i64toi32_i32$5 = $74;
    HEAP32[i64toi32_i32$5 >> 2] = $78;
    HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$3;
    break label$1;
   }
   i64toi32_i32$2 = ($2 + 32 | 0) + 40 | 0;
   i64toi32_i32$3 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $6 = i64toi32_i32$3;
   $6$hi = i64toi32_i32$5;
   i64toi32_i32$3 = $2 + 24 | 0;
   HEAP32[i64toi32_i32$3 >> 2] = $6;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$2 = ($2 + 32 | 0) + 32 | 0;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $7 = i64toi32_i32$5;
   $7$hi = i64toi32_i32$3;
   i64toi32_i32$5 = $2;
   HEAP32[(i64toi32_i32$5 + 16 | 0) >> 2] = $7;
   HEAP32[(i64toi32_i32$5 + 20 | 0) >> 2] = i64toi32_i32$3;
   HEAP32[($0 + 36 | 0) >> 2] = HEAP32[(i64toi32_i32$5 + 60 | 0) >> 2] | 0;
   HEAP32[($0 + 32 | 0) >> 2] = $3;
   i64toi32_i32$3 = $4$hi;
   i64toi32_i32$5 = $0 + 24 | 0;
   HEAP32[i64toi32_i32$5 >> 2] = $4;
   HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$3 = $5$hi;
   i64toi32_i32$5 = $0 + 16 | 0;
   HEAP32[i64toi32_i32$5 >> 2] = $5;
   HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$3;
   HEAP8[($0 + 8 | 0) >> 0] = 2;
   HEAP32[($0 + 56 | 0) >> 2] = 0;
   i64toi32_i32$3 = $7$hi;
   i64toi32_i32$5 = $0 + 40 | 0;
   HEAP32[i64toi32_i32$5 >> 2] = $7;
   HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$3 = $6$hi;
   i64toi32_i32$5 = $0 + 48 | 0;
   HEAP32[i64toi32_i32$5 >> 2] = $6;
   HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$5 = $0;
   i64toi32_i32$3 = 0;
   HEAP32[i64toi32_i32$5 >> 2] = 1;
   HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$3;
  }
  global$0 = $2 + 80 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__Mint___serialize__h19eae2b7c2c53b1d($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $14 = 0, $4 = 0, $32 = 0, $39 = 0, $42 = 0, $64 = 0, $70 = 0, $73 = 0;
  $3 = global$0 - 160 | 0;
  global$0 = $3;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 + 80 | 0 | 0, $2 | 0, 5 | 0, i64toi32_i32$0 | 0, i64toi32_i32$1 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ((HEAP32[($3 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
        break label$5
       }
       alloc__collections__btree__map__BTreeMap_K_2cV___iter__hbe8f4ddb910904b5($3 + 16 | 0 | 0, $1 | 0);
       HEAP32[(($3 + 48 | 0) + 24 | 0) >> 2] = HEAP32[(($3 + 16 | 0) + 24 | 0) >> 2] | 0;
       i64toi32_i32$2 = ($3 + 16 | 0) + 16 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $32 = i64toi32_i32$1;
       i64toi32_i32$1 = ($3 + 48 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $32;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = ($3 + 16 | 0) + 8 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $39 = i64toi32_i32$0;
       i64toi32_i32$0 = ($3 + 48 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $39;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $3;
       i64toi32_i32$1 = HEAP32[($3 + 16 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[($3 + 20 | 0) >> 2] | 0;
       $42 = i64toi32_i32$1;
       i64toi32_i32$1 = $3;
       HEAP32[($3 + 48 | 0) >> 2] = $42;
       HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$0;
       $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h32d71c96a3c9fef9($3 + 8 | 0 | 0, $3 + 48 | 0 | 0);
       label$6 : {
        $1 = HEAP32[($3 + 8 | 0) >> 2] | 0;
        if (!$1) {
         break label$6
        }
        $4 = HEAP32[($3 + 12 | 0) >> 2] | 0;
        label$7 : while (1) {
         $14 = $1 + 24 | 0;
         HEAP32[(($3 + 128 | 0) + 24 | 0) >> 2] = HEAPU8[$14 >> 0] | 0 | ((HEAPU8[($14 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($14 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($14 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$2 = $1 + 16 | 0;
         i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $64 = i64toi32_i32$0;
         i64toi32_i32$0 = ($3 + 128 | 0) + 16 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $64;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$2 = $1 + 8 | 0;
         i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $70 = i64toi32_i32$1;
         i64toi32_i32$1 = ($3 + 128 | 0) + 8 | 0;
         HEAP32[i64toi32_i32$1 >> 2] = $70;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$2 = $1;
         i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $73 = i64toi32_i32$0;
         i64toi32_i32$0 = $3;
         HEAP32[($3 + 128 | 0) >> 2] = $73;
         HEAP32[($3 + 132 | 0) >> 2] = i64toi32_i32$1;
         cbor_event__se__Serializer_W___write_bytes__h5e3534de30c993f9($3 + 80 | 0 | 0, $2 | 0, $3 + 128 | 0 | 0);
         if ((HEAP32[($3 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
          break label$4
         }
         cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__MintAssets___serialize__h141cb87b41b2b47f($3 + 80 | 0 | 0, $4 | 0, $2 | 0);
         if ((HEAP32[($3 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
          break label$3
         }
         $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h32d71c96a3c9fef9($3 | 0, $3 + 48 | 0 | 0);
         $4 = HEAP32[($3 + 4 | 0) >> 2] | 0;
         $1 = HEAP32[$3 >> 2] | 0;
         if ($1) {
          continue label$7
         }
         break label$7;
        };
       }
       HEAP32[$0 >> 2] = 0;
       HEAP32[($0 + 4 | 0) >> 2] = $2;
       break label$1;
      }
      memcpy($0 + 8 | 0 | 0, ($3 + 80 | 0) + 8 | 0 | 0, 40 | 0) | 0;
      HEAP32[$0 >> 2] = 1;
      break label$1;
     }
     memcpy($0 + 8 | 0 | 0, ($3 + 80 | 0) + 8 | 0 | 0, 40 | 0) | 0;
     break label$2;
    }
    memcpy($0 + 8 | 0 | 0, ($3 + 80 | 0) + 8 | 0 | 0, 40 | 0) | 0;
   }
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $3 + 160 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__MultiAsset___serialize__h8befd5a1b9cac25b($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $14 = 0, $4 = 0, $32 = 0, $39 = 0, $42 = 0, $64 = 0, $70 = 0, $73 = 0;
  $3 = global$0 - 160 | 0;
  global$0 = $3;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 + 80 | 0 | 0, $2 | 0, 5 | 0, i64toi32_i32$0 | 0, i64toi32_i32$1 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ((HEAP32[($3 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
        break label$5
       }
       alloc__collections__btree__map__BTreeMap_K_2cV___iter__h677e802ff7e211c3($3 + 16 | 0 | 0, $1 | 0);
       HEAP32[(($3 + 48 | 0) + 24 | 0) >> 2] = HEAP32[(($3 + 16 | 0) + 24 | 0) >> 2] | 0;
       i64toi32_i32$2 = ($3 + 16 | 0) + 16 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $32 = i64toi32_i32$1;
       i64toi32_i32$1 = ($3 + 48 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $32;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = ($3 + 16 | 0) + 8 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $39 = i64toi32_i32$0;
       i64toi32_i32$0 = ($3 + 48 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $39;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $3;
       i64toi32_i32$1 = HEAP32[($3 + 16 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[($3 + 20 | 0) >> 2] | 0;
       $42 = i64toi32_i32$1;
       i64toi32_i32$1 = $3;
       HEAP32[($3 + 48 | 0) >> 2] = $42;
       HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$0;
       $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h03cc330b7b1e4522($3 + 8 | 0 | 0, $3 + 48 | 0 | 0);
       label$6 : {
        $1 = HEAP32[($3 + 8 | 0) >> 2] | 0;
        if (!$1) {
         break label$6
        }
        $4 = HEAP32[($3 + 12 | 0) >> 2] | 0;
        label$7 : while (1) {
         $14 = $1 + 24 | 0;
         HEAP32[(($3 + 128 | 0) + 24 | 0) >> 2] = HEAPU8[$14 >> 0] | 0 | ((HEAPU8[($14 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($14 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($14 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$2 = $1 + 16 | 0;
         i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $64 = i64toi32_i32$0;
         i64toi32_i32$0 = ($3 + 128 | 0) + 16 | 0;
         HEAP32[i64toi32_i32$0 >> 2] = $64;
         HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
         i64toi32_i32$2 = $1 + 8 | 0;
         i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $70 = i64toi32_i32$1;
         i64toi32_i32$1 = ($3 + 128 | 0) + 8 | 0;
         HEAP32[i64toi32_i32$1 >> 2] = $70;
         HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
         i64toi32_i32$2 = $1;
         i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $73 = i64toi32_i32$0;
         i64toi32_i32$0 = $3;
         HEAP32[($3 + 128 | 0) >> 2] = $73;
         HEAP32[($3 + 132 | 0) >> 2] = i64toi32_i32$1;
         cbor_event__se__Serializer_W___write_bytes__h5e3534de30c993f9($3 + 80 | 0 | 0, $2 | 0, $3 + 128 | 0 | 0);
         if ((HEAP32[($3 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
          break label$4
         }
         cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__Assets___serialize__hdca9801c50eb469f($3 + 80 | 0 | 0, $4 | 0, $2 | 0);
         if ((HEAP32[($3 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
          break label$3
         }
         $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h03cc330b7b1e4522($3 | 0, $3 + 48 | 0 | 0);
         $4 = HEAP32[($3 + 4 | 0) >> 2] | 0;
         $1 = HEAP32[$3 >> 2] | 0;
         if ($1) {
          continue label$7
         }
         break label$7;
        };
       }
       HEAP32[$0 >> 2] = 0;
       HEAP32[($0 + 4 | 0) >> 2] = $2;
       break label$1;
      }
      memcpy($0 + 8 | 0 | 0, ($3 + 80 | 0) + 8 | 0 | 0, 40 | 0) | 0;
      HEAP32[$0 >> 2] = 1;
      break label$1;
     }
     memcpy($0 + 8 | 0 | 0, ($3 + 80 | 0) + 8 | 0 | 0, 40 | 0) | 0;
     break label$2;
    }
    memcpy($0 + 8 | 0 | 0, ($3 + 80 | 0) + 8 | 0 | 0, 40 | 0) | 0;
   }
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $3 + 160 | 0;
 }
 
 function cardano_serialization_lib__Relays__get__hee627f454c994fde($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $3 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, i64toi32_i32$1 = 0, $4 = 0, $29 = 0, $7 = 0, $9 = 0, $30 = 0, $10$hi = 0, $31 = 0, $32 = 0, $5 = 0, $6 = 0, $8 = 0, $50 = 0, $54 = 0, $58 = 0, $63 = 0, $65 = 0, $10 = 0, $86 = 0, $86$hi = 0, $101 = 0, $105 = 0, $113 = 0, $123 = 0, $128 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  label$1 : {
   $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   if ($4 >>> 0 <= $2 >>> 0) {
    break label$1
   }
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       $4 = HEAP32[$1 >> 2] | 0;
       $1 = $4 + Math_imul($2, 28) | 0;
       switch (HEAPU16[$1 >> 1] | 0 | 0) {
       case 2:
        break label$3;
       case 1:
        break label$4;
       default:
        break label$5;
       };
      }
      $5 = HEAPU16[($1 + 2 | 0) >> 1] | 0;
      $29 = $1 + 7 | 0;
      $6 = HEAPU8[$29 >> 0] | 0 | ((HEAPU8[($29 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($29 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($29 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $7 = HEAPU8[($1 + 6 | 0) >> 0] | 0;
      $8 = HEAPU16[($1 + 4 | 0) >> 1] | 0;
      $9 = 0;
      label$6 : {
       if ((HEAPU8[($1 + 11 | 0) >> 0] | 0 | 0) != (1 | 0)) {
        break label$6
       }
       $1 = $4 + Math_imul($2, 28) | 0;
       i64toi32_i32$2 = $1 + 20 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $50 = i64toi32_i32$0;
       i64toi32_i32$0 = $3 + 40 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $50;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $1 + 12 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $54 = i64toi32_i32$1;
       i64toi32_i32$1 = $3;
       HEAP32[($3 + 32 | 0) >> 2] = $54;
       HEAP32[($3 + 36 | 0) >> 2] = i64toi32_i32$0;
       $9 = 1;
      }
      i64toi32_i32$2 = $3;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
      $58 = i64toi32_i32$0;
      i64toi32_i32$0 = i64toi32_i32$2 + 12 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $58;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = i64toi32_i32$2 + 40 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $63 = i64toi32_i32$1;
      i64toi32_i32$1 = $3 + 20 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $63;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      $65 = $3 + 10 | 0;
      i64toi32_i32$0 = 0;
      i64toi32_i32$2 = $6;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 8;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       $30 = 0;
      } else {
       i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
       $30 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
      }
      i64toi32_i32$4 = ($7 & 255 | 0 | 0) == (1 | 0);
      i64toi32_i32$2 = 0;
      i64toi32_i32$3 = i64toi32_i32$4 ? $30 : 0;
      i64toi32_i32$0 = i64toi32_i32$4 ? i64toi32_i32$1 : i64toi32_i32$2;
      $10 = i64toi32_i32$3;
      $10$hi = i64toi32_i32$0;
      i64toi32_i32$4 = i64toi32_i32$3;
      i64toi32_i32$3 = 0;
      i64toi32_i32$1 = 32;
      i64toi32_i32$2 = i64toi32_i32$1 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
       i64toi32_i32$3 = 0;
       $31 = i64toi32_i32$0 >>> i64toi32_i32$2 | 0;
      } else {
       i64toi32_i32$3 = i64toi32_i32$0 >>> i64toi32_i32$2 | 0;
       $31 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$2 | 0) | 0;
      }
      HEAP8[$65 >> 0] = $31;
      HEAP8[($3 + 11 | 0) >> 0] = $9;
      HEAP16[($3 + 4 | 0) >> 1] = $8;
      HEAP16[($3 + 2 | 0) >> 1] = $5;
      HEAP16[$3 >> 1] = 0;
      i64toi32_i32$3 = $10$hi;
      i64toi32_i32$3 = 0;
      i64toi32_i32$0 = $7;
      i64toi32_i32$4 = 0;
      i64toi32_i32$1 = 255;
      i64toi32_i32$4 = i64toi32_i32$3 & i64toi32_i32$4 | 0;
      $86 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
      $86$hi = i64toi32_i32$4;
      i64toi32_i32$4 = $10$hi;
      i64toi32_i32$3 = $10;
      i64toi32_i32$0 = $86$hi;
      i64toi32_i32$1 = $86;
      i64toi32_i32$0 = i64toi32_i32$4 | i64toi32_i32$0 | 0;
      $32 = i64toi32_i32$3 | i64toi32_i32$1 | 0;
      HEAP16[($3 + 6 | 0) >> 1] = $32;
      HEAP16[($3 + 8 | 0) >> 1] = $32 >>> 16 | 0;
      break label$2;
     }
     $2 = HEAP32[($1 + 16 | 0) >> 2] | 0;
     $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($3 + 32 | 0 | 0, $1 + 4 | 0 | 0);
     HEAP32[($3 + 44 | 0) >> 2] = $2;
     i64toi32_i32$4 = $3 + 40 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
     $101 = i64toi32_i32$0;
     i64toi32_i32$0 = $3 + 12 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $101;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
     HEAP16[$3 >> 1] = 1;
     i64toi32_i32$4 = $3;
     i64toi32_i32$3 = HEAP32[($3 + 32 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($3 + 36 | 0) >> 2] | 0;
     $105 = i64toi32_i32$3;
     i64toi32_i32$3 = $3;
     HEAP32[($3 + 4 | 0) >> 2] = $105;
     HEAP32[($3 + 8 | 0) >> 2] = i64toi32_i32$0;
     break label$2;
    }
    $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($3 | 4 | 0 | 0, $1 + 4 | 0 | 0);
    HEAP16[$3 >> 1] = 2;
   }
   i64toi32_i32$4 = $3;
   i64toi32_i32$0 = HEAP32[$3 >> 2] | 0;
   i64toi32_i32$3 = HEAP32[($3 + 4 | 0) >> 2] | 0;
   $113 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[i64toi32_i32$0 >> 2] = $113;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
   HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = HEAP32[($3 + 24 | 0) >> 2] | 0;
   i64toi32_i32$4 = $3 + 16 | 0;
   i64toi32_i32$3 = HEAP32[i64toi32_i32$4 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
   $123 = i64toi32_i32$3;
   i64toi32_i32$3 = $0 + 16 | 0;
   HEAP32[i64toi32_i32$3 >> 2] = $123;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$4 = $3 + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$4 >> 2] | 0;
   i64toi32_i32$3 = HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] | 0;
   $128 = i64toi32_i32$0;
   i64toi32_i32$0 = $0 + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $128;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
   global$0 = $3 + 48 | 0;
   return;
  }
  core__panicking__panic_bounds_check__h808b524af17640b1($2 | 0, $4 | 0, 1053400 | 0);
  abort();
 }
 
 function cardano_serialization_lib__NativeScript__from_bytes__h15f2e6a3280a33fe($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $5 = 0, $4 = 0, $4$hi = 0, $5$hi = 0, $3 = 0, $6 = 0, $7 = 0, $20 = 0, $47 = 0, $53 = 0, $60 = 0, $6$hi = 0, $7$hi = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 288 | 0;
  global$0 = $2;
  HEAP32[(($2 + 128 | 0) + 16 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 128 | 0) >> 2] = 0;
  HEAP32[($2 + 132 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 136 | 0) >> 2] = $20;
  HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__NativeScriptEnum___deserialize__hb97d8419517d870c($2 + 216 | 0 | 0, $2 + 128 | 0 | 0);
  $1 = ($2 + 216 | 0) + 8 | 0;
  $3 = ($2 + 128 | 0) + 8 | 0;
  label$1 : {
   label$2 : {
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 216 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 220 | 0) >> 2] | 0;
    $4 = i64toi32_i32$1;
    $4$hi = i64toi32_i32$0;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    i64toi32_i32$3 = 1;
    if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
     break label$2
    }
    i64toi32_i32$3 = $1 + 24 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $5 = i64toi32_i32$2;
    $5$hi = i64toi32_i32$0;
    i64toi32_i32$2 = ($2 + 152 | 0) + 24 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $5;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$3 = $1 + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $47 = i64toi32_i32$0;
    i64toi32_i32$0 = ($2 + 64 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $47;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$3 = $1 + 16 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $53 = i64toi32_i32$2;
    i64toi32_i32$2 = ($2 + 64 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $53;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = $5$hi;
    i64toi32_i32$2 = ($2 + 64 | 0) + 24 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $5;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$3 = $1;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $60 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[($2 + 64 | 0) >> 2] = $60;
    HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$2;
    break label$1;
   }
   memcpy($2 + 152 | 0 | 0, $1 | 0, 64 | 0) | 0;
   memcpy($2 + 64 | 0 | 0, $2 + 152 | 0 | 0, 64 | 0) | 0;
  }
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 | 0);
  label$3 : {
   label$4 : {
    i64toi32_i32$2 = $4$hi;
    i64toi32_i32$3 = $4;
    i64toi32_i32$0 = 0;
    i64toi32_i32$1 = 0;
    if ((i64toi32_i32$3 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$0 | 0) | 0) {
     break label$4
    }
    i64toi32_i32$1 = ($2 + 64 | 0) + 24 | 0;
    i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
    $4 = i64toi32_i32$3;
    $4$hi = i64toi32_i32$2;
    i64toi32_i32$3 = $2 + 24 | 0;
    HEAP32[i64toi32_i32$3 >> 2] = $4;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$1 = ($2 + 64 | 0) + 16 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
    $5 = i64toi32_i32$2;
    $5$hi = i64toi32_i32$3;
    i64toi32_i32$2 = $2 + 16 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $5;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
    i64toi32_i32$1 = ($2 + 64 | 0) + 8 | 0;
    i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
    $6 = i64toi32_i32$3;
    $6$hi = i64toi32_i32$2;
    i64toi32_i32$3 = $2 + 8 | 0;
    HEAP32[i64toi32_i32$3 >> 2] = $6;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$1 = $2;
    i64toi32_i32$2 = HEAP32[($2 + 64 | 0) >> 2] | 0;
    i64toi32_i32$3 = HEAP32[($2 + 68 | 0) >> 2] | 0;
    $7 = i64toi32_i32$2;
    $7$hi = i64toi32_i32$3;
    i64toi32_i32$2 = $2;
    HEAP32[i64toi32_i32$2 >> 2] = $7;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
    i64toi32_i32$3 = $4$hi;
    i64toi32_i32$2 = $0 + 32 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $4;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
    i64toi32_i32$3 = $5$hi;
    i64toi32_i32$2 = $0 + 24 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $5;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
    i64toi32_i32$3 = $6$hi;
    i64toi32_i32$2 = $0 + 16 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $6;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
    i64toi32_i32$3 = $7$hi;
    i64toi32_i32$2 = $0 + 8 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $7;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
    $1 = 0;
    break label$3;
   }
   $1 = memcpy($2 | 0, $2 + 64 | 0 | 0, 64 | 0) | 0;
   memcpy($1 + 216 | 0 | 0, $1 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($1 + 216 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 288 | 0;
 }
 
 function cryptoxide__pbkdf2__pbkdf2__h6d76e9b9cb3d73c2($0, $1, $2, $3, $4, $5) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  $5 = $5 | 0;
  var $6 = 0, $8 = 0, $7 = 0, $10 = 0, $9 = 0, $11 = 0;
  $6 = global$0 - 96 | 0;
  global$0 = $6;
  label$1 : {
   label$2 : {
    label$3 : {
     if (!$3) {
      break label$3
     }
     $7 = cryptoxide__digest__Digest__output_bytes__h2bb3c7fed18288f4($0 | 0) | 0;
     core__iter__adapters__take__Take_I___new__h57f06669aa0e5753($6 + 48 | 0 | 0, 0 | 0, $7 | 0);
     $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter__SpecFromIter_T_2cI____from_iter__hd9e424f0851c7545($6 + 56 | 0 | 0, HEAP32[($6 + 48 | 0) >> 2] | 0 | 0, HEAPU8[($6 + 52 | 0) >> 0] | 0 | 0);
     HEAP32[($6 + 68 | 0) >> 2] = $7;
     label$4 : {
      if (!$7) {
       break label$4
      }
      label$5 : {
       if (!$5) {
        break label$5
       }
       $8 = 0;
       label$6 : while (1) {
        $9 = $8 + 1 | 0;
        if ($9 >>> 0 < $8 >>> 0) {
         break label$2
        }
        $10 = $5 >>> 0 > $7 >>> 0 ? $7 : $5;
        label$7 : {
         label$8 : {
          if ($7 >>> 0 <= $5 >>> 0) {
           break label$8
          }
          core__iter__adapters__take__Take_I___new__h57f06669aa0e5753($6 + 32 | 0 | 0, 0 | 0, $7 | 0);
          $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter__SpecFromIter_T_2cI____from_iter__hd9e424f0851c7545($6 + 72 | 0 | 0, HEAP32[($6 + 32 | 0) >> 2] | 0 | 0, HEAPU8[($6 + 36 | 0) >> 0] | 0 | 0);
          $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__DerefMut___deref_mut__h1882e042320a120c($6 + 24 | 0 | 0, $6 + 56 | 0 | 0);
          $8 = HEAP32[($6 + 28 | 0) >> 2] | 0;
          $11 = HEAP32[($6 + 24 | 0) >> 2] | 0;
          $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__DerefMut___deref_mut__h1882e042320a120c($6 + 16 | 0 | 0, $6 + 72 | 0 | 0);
          cryptoxide__pbkdf2__calculate_block__h6e8179bf702dfbe4($0 | 0, $1 | 0, $2 | 0, $3 | 0, $9 | 0, $11 | 0, $8 | 0, HEAP32[($6 + 16 | 0) >> 2] | 0 | 0, HEAP32[($6 + 20 | 0) >> 2] | 0 | 0);
          $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($6 + 8 | 0 | 0, $6 + 72 | 0 | 0);
          $8 = HEAP32[($6 + 12 | 0) >> 2] | 0;
          if ($8 >>> 0 < $10 >>> 0) {
           break label$1
          }
          core__slice___impl_20_5bT_5d___copy_from_slice__h0f69c19ed1852955($4 | 0, $10 | 0, HEAP32[($6 + 8 | 0) >> 2] | 0 | 0, $10 | 0);
          $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($6 + 72 | 0 | 0);
          $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($6 + 72 | 0 | 0);
          break label$7;
         }
         $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__DerefMut___deref_mut__h1882e042320a120c($6 + 40 | 0 | 0, $6 + 56 | 0 | 0);
         cryptoxide__pbkdf2__calculate_block__h6e8179bf702dfbe4($0 | 0, $1 | 0, $2 | 0, $3 | 0, $9 | 0, HEAP32[($6 + 40 | 0) >> 2] | 0 | 0, HEAP32[($6 + 44 | 0) >> 2] | 0 | 0, $4 | 0, $10 | 0);
        }
        $4 = $4 + $10 | 0;
        $8 = $9;
        $5 = $5 - $10 | 0;
        if ($5) {
         continue label$6
        }
        break label$6;
       };
      }
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($6 + 56 | 0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($6 + 56 | 0 | 0);
      global$0 = $6 + 96 | 0;
      return;
     }
     HEAP32[($6 + 72 | 0) >> 2] = 0;
     core__panicking__assert_failed__h7abe5b371cd10d8a(1 | 0, $6 + 68 | 0 | 0, 1068864 | 0, $6 + 72 | 0 | 0, 1068948 | 0);
     abort();
    }
    core__panicking__panic__h2fd385a887c8bf13(1068092 | 0, 23 | 0, 1068212 | 0);
    abort();
   }
   core__option__expect_failed__h66afff61e82fdd86(1068228 | 0, 27 | 0, 1068256 | 0);
   abort();
  }
  core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($10 | 0, $8 | 0, 1068272 | 0);
  abort();
 }
 
 function cardano_serialization_lib__utils__BigInt__from_str__h6032a095d77ac3d9($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $4 = 0, i64toi32_i32$2 = 0, $5 = 0, $6 = 0, $7 = 0, $72 = 0;
  $3 = global$0 - 96 | 0;
  global$0 = $3;
  $4 = 2;
  label$1 : {
   label$2 : {
    if (!(core__str___impl_20str___starts_with__h05665b83cdd3f774($1 | 0, $2 | 0, 45 | 0) | 0)) {
     break label$2
    }
    label$3 : {
     label$4 : {
      if ($2 >>> 0 > 1 >>> 0) {
       break label$4
      }
      if (($2 | 0) == (1 | 0)) {
       break label$3
      }
      break label$1;
     }
     if ((HEAP8[($1 + 1 | 0) >> 0] | 0 | 0) <= (-65 | 0)) {
      break label$1
     }
    }
    $4 = $1 + 1 | 0;
    $5 = $2 + -1 | 0;
    $6 = core__str___impl_20str___starts_with__h05665b83cdd3f774($4 | 0, $5 | 0, 43 | 0) | 0;
    $1 = $6 ? $1 : $4;
    $2 = $6 ? $2 : $5;
    $4 = 0;
   }
   num_bigint__biguint__convert___impl_20num_traits__Num_20for_20num_bigint__biguint__BigUint___from_str_radix__ha7ce9e2a0cdf83db($3 + 40 | 0 | 0, $1 | 0, $2 | 0, 10 | 0);
   $2 = 1;
   label$5 : {
    label$6 : {
     if ((HEAPU8[($3 + 40 | 0) >> 0] | 0 | 0) == (1 | 0)) {
      break label$6
     }
     $2 = HEAP32[($3 + 52 | 0) >> 2] | 0;
     HEAP32[(($3 + 64 | 0) + 8 | 0) >> 2] = $2;
     i64toi32_i32$2 = $3;
     i64toi32_i32$0 = HEAP32[($3 + 44 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($3 + 48 | 0) >> 2] | 0;
     $7 = i64toi32_i32$0;
     i64toi32_i32$0 = $3;
     HEAP32[($3 + 64 | 0) >> 2] = $7;
     HEAP32[($3 + 68 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[(($3 + 40 | 0) + 8 | 0) >> 2] = $2;
     i64toi32_i32$0 = $3;
     HEAP32[($3 + 40 | 0) >> 2] = $7;
     HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$1;
     num_bigint__bigint__BigInt__from_biguint__hc8c58ec5989a4432($3 + 16 | 0 | 4 | 0 | 0, $4 | 0, $3 + 40 | 0 | 0);
     i64toi32_i32$2 = ($3 + 16 | 0) + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $72 = i64toi32_i32$1;
     i64toi32_i32$1 = $0 + 8 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $72;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($0 + 16 | 0) >> 2] = HEAP32[(($3 + 16 | 0) + 16 | 0) >> 2] | 0;
     $1 = HEAP32[($3 + 20 | 0) >> 2] | 0;
     $2 = 0;
     break label$5;
    }
    HEAP8[($3 + 39 | 0) >> 0] = HEAPU8[($3 + 41 | 0) >> 0] | 0;
    HEAP32[($3 + 60 | 0) >> 2] = 1;
    i64toi32_i32$1 = $3;
    i64toi32_i32$0 = 0;
    HEAP32[($3 + 44 | 0) >> 2] = 1;
    HEAP32[($3 + 48 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($3 + 40 | 0) >> 2] = 1058724;
    HEAP32[($3 + 68 | 0) >> 2] = 47;
    HEAP32[($3 + 56 | 0) >> 2] = $3 + 64 | 0;
    HEAP32[($3 + 64 | 0) >> 2] = $3 + 39 | 0;
    alloc__fmt__format__h6e9e003a52c07309($3 + 80 | 0 | 0, $3 + 40 | 0 | 0);
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $3 + 80 | 0 | 0);
    $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($3 + 8 | 0) >> 2] | 0 | 0, HEAP32[($3 + 12 | 0) >> 2] | 0 | 0) | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 80 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 80 | 0 | 0);
   }
   HEAP32[$0 >> 2] = $2;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   global$0 = $3 + 96 | 0;
   return;
  }
  core__str__slice_error_fail__h8a7d2e23b7bba52e($1 | 0, $2 | 0, 1 | 0, $2 | 0, 1057316 | 0);
  abort();
 }
 
 function cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($0, $1, $2, $3, $3$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $4 = 0, $40 = 0, $41 = 0, $44 = 0, $45 = 0, $47 = 0, $48 = 0, $52 = 0, $53 = 0, $54 = 0, $55 = 0, $56 = 0, $22 = 0, $24 = 0, $24$hi = 0, $27 = 0, $27$hi = 0, $28 = 0, $28$hi = 0, $31 = 0, $31$hi = 0, $34 = 0, $34$hi = 0, $35 = 0, $35$hi = 0, $36 = 0, $36$hi = 0, $39 = 0, $39$hi = 0, $42 = 0, $42$hi = 0, $43 = 0, $43$hi = 0, $46 = 0, $46$hi = 0, $48$hi = 0, $49 = 0, $49$hi = 0, $50 = 0, $50$hi = 0, $51 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $4 = global$0 - 16 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       i64toi32_i32$0 = $3$hi;
       i64toi32_i32$2 = $3;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 24;
       if (i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0) {
        break label$5
       }
       i64toi32_i32$2 = $3$hi;
       i64toi32_i32$3 = $3;
       i64toi32_i32$0 = 0;
       i64toi32_i32$1 = 256;
       if (i64toi32_i32$2 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0 | 0) | 0) {
        break label$4
       }
       i64toi32_i32$3 = $3$hi;
       i64toi32_i32$1 = $3;
       i64toi32_i32$2 = 0;
       i64toi32_i32$0 = 65536;
       if (i64toi32_i32$3 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$0 >>> 0 | 0) | 0) {
        break label$3
       }
       i64toi32_i32$1 = $3$hi;
       i64toi32_i32$0 = $3;
       i64toi32_i32$3 = 1;
       i64toi32_i32$2 = 0;
       if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0) {
        break label$2
       }
       (wasm2js_i32$0 = $4, wasm2js_i32$1 = cbor_event__types__Type__to_byte__h30363627277739c1($2 | 0, 27 | 0) | 0), HEAP8[(wasm2js_i32$0 + 1 | 0) >> 0] = wasm2js_i32$1;
       alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($1 | 0, $4 + 1 | 0 | 0, 1 | 0);
       $22 = $4;
       i64toi32_i32$0 = $3$hi;
       i64toi32_i32$2 = $3;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 56;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $44 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
        $44 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       $24 = $44;
       $24$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $3$hi;
       i64toi32_i32$0 = $3;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 40;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $45 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $45 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       i64toi32_i32$1 = $45;
       i64toi32_i32$0 = 16711680;
       i64toi32_i32$3 = 0;
       i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
       $27 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
       $27$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $24$hi;
       i64toi32_i32$2 = $24;
       i64toi32_i32$1 = $27$hi;
       i64toi32_i32$3 = $27;
       i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
       $28 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       $28$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $3$hi;
       i64toi32_i32$0 = $3;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 24;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
        $47 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $47 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       }
       i64toi32_i32$1 = $47;
       i64toi32_i32$0 = 65280;
       i64toi32_i32$3 = 0;
       i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
       $31 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
       $31$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $3$hi;
       i64toi32_i32$2 = $3;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 8;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $48 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
        $48 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       i64toi32_i32$0 = $48;
       i64toi32_i32$2 = 255;
       i64toi32_i32$3 = 0;
       i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
       $34 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
       $34$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $31$hi;
       i64toi32_i32$1 = $31;
       i64toi32_i32$0 = $34$hi;
       i64toi32_i32$3 = $34;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
       $35 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       $35$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $28$hi;
       i64toi32_i32$2 = $28;
       i64toi32_i32$1 = $35$hi;
       i64toi32_i32$3 = $35;
       i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
       $36 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       $36$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $3$hi;
       i64toi32_i32$0 = $3;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 8;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = 0;
        $52 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
        $52 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
       }
       i64toi32_i32$1 = $52;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = -16777216;
       i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
       $39 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
       $39$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $3$hi;
       i64toi32_i32$2 = $3;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 24;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = 0;
        $53 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
        $53 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
       }
       i64toi32_i32$0 = $53;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 16711680;
       i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
       $42 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
       $42$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $39$hi;
       i64toi32_i32$1 = $39;
       i64toi32_i32$0 = $42$hi;
       i64toi32_i32$3 = $42;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
       $43 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       $43$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $3$hi;
       i64toi32_i32$2 = $3;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 40;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = 0;
        $54 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
        $54 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
       }
       i64toi32_i32$0 = $54;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 65280;
       i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
       $46 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
       $46$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $3$hi;
       i64toi32_i32$1 = $3;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 56;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = 0;
        $55 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
        $55 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
       }
       $48$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $46$hi;
       i64toi32_i32$2 = $46;
       i64toi32_i32$1 = $48$hi;
       i64toi32_i32$3 = $55;
       i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
       $49 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       $49$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $43$hi;
       i64toi32_i32$0 = $43;
       i64toi32_i32$2 = $49$hi;
       i64toi32_i32$3 = $49;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
       $50 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
       $50$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $36$hi;
       i64toi32_i32$1 = $36;
       i64toi32_i32$0 = $50$hi;
       i64toi32_i32$3 = $50;
       i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
       $51 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       i64toi32_i32$1 = $22;
       $40 = $51;
       HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = $40;
       HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = $40 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = $40 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = $40 >>> 24 | 0;
       HEAP8[(i64toi32_i32$1 + 8 | 0) >> 0] = i64toi32_i32$0;
       HEAP8[(i64toi32_i32$1 + 9 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 10 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 11 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
       alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($1 | 0, $4 + 4 | 0 | 0, 8 | 0);
       break label$1;
      }
      i64toi32_i32$0 = $3$hi;
      (wasm2js_i32$0 = $4, wasm2js_i32$1 = cbor_event__types__Type__to_byte__h30363627277739c1($2 | 0, $3 | 0) | 0), HEAP8[(wasm2js_i32$0 + 1 | 0) >> 0] = wasm2js_i32$1;
      alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($1 | 0, $4 + 1 | 0 | 0, 1 | 0);
      break label$1;
     }
     (wasm2js_i32$0 = $4, wasm2js_i32$1 = cbor_event__types__Type__to_byte__h30363627277739c1($2 | 0, 24 | 0) | 0), HEAP8[(wasm2js_i32$0 + 1 | 0) >> 0] = wasm2js_i32$1;
     alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($1 | 0, $4 + 1 | 0 | 0, 1 | 0);
     i64toi32_i32$0 = $3$hi;
     HEAP8[($4 + 1 | 0) >> 0] = $3;
     alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($1 | 0, $4 + 1 | 0 | 0, 1 | 0);
     break label$1;
    }
    (wasm2js_i32$0 = $4, wasm2js_i32$1 = cbor_event__types__Type__to_byte__h30363627277739c1($2 | 0, 25 | 0) | 0), HEAP8[(wasm2js_i32$0 + 1 | 0) >> 0] = wasm2js_i32$1;
    alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($1 | 0, $4 + 1 | 0 | 0, 1 | 0);
    i64toi32_i32$0 = $3$hi;
    $2 = $3;
    $56 = ($3 << 24 | 0 | (($3 << 8 | 0) & 16711680 | 0) | 0) >>> 16 | 0;
    HEAP8[($4 + 2 | 0) >> 0] = $56;
    HEAP8[($4 + 3 | 0) >> 0] = $56 >>> 8 | 0;
    alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($1 | 0, $4 + 2 | 0 | 0, 2 | 0);
    break label$1;
   }
   (wasm2js_i32$0 = $4, wasm2js_i32$1 = cbor_event__types__Type__to_byte__h30363627277739c1($2 | 0, 26 | 0) | 0), HEAP8[(wasm2js_i32$0 + 1 | 0) >> 0] = wasm2js_i32$1;
   alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($1 | 0, $4 + 1 | 0 | 0, 1 | 0);
   i64toi32_i32$0 = $3$hi;
   $2 = $3;
   $41 = $3 << 24 | 0 | (($3 << 8 | 0) & 16711680 | 0) | 0 | (($3 >>> 8 | 0) & 65280 | 0 | ($3 >>> 24 | 0) | 0) | 0;
   HEAP8[($4 + 12 | 0) >> 0] = $41;
   HEAP8[($4 + 13 | 0) >> 0] = $41 >>> 8 | 0;
   HEAP8[($4 + 14 | 0) >> 0] = $41 >>> 16 | 0;
   HEAP8[($4 + 15 | 0) >> 0] = $41 >>> 24 | 0;
   alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($1 | 0, $4 + 12 | 0 | 0, 4 | 0);
  }
  HEAP32[$0 >> 2] = 0;
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  global$0 = $4 + 16 | 0;
 }
 
 function bech32__encode_to_fmt__ha4485a0f4323c83a($0, $1, $2, $3, $4, $5) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  $5 = $5 | 0;
  var $6 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $7 = 0, $36 = 0, $48 = 0, $79 = 0, $96 = 0, $105 = 0;
  $6 = global$0 - 96 | 0;
  global$0 = $6;
  bech32__check_hrp__h41cbe4782f1256ab($6 + 80 | 0 | 0, $3 | 0, $4 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ((HEAPU8[($6 + 80 | 0) >> 0] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      if (!(HEAPU8[($6 + 81 | 0) >> 0] | 0)) {
       break label$3
      }
      HEAP32[($6 + 24 | 0) >> 2] = $4;
      HEAP32[($6 + 20 | 0) >> 2] = $3;
      HEAP32[($6 + 16 | 0) >> 2] = 0;
      $7 = $6 + 32 | 0;
      break label$2;
     }
     i64toi32_i32$2 = $6;
     i64toi32_i32$0 = HEAP32[($6 + 84 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($6 + 88 | 0) >> 2] | 0;
     i64toi32_i32$1 = $T_20as_20core__convert__From_T____from__h4de36f70570b7473(i64toi32_i32$0 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     HEAP8[$0 >> 0] = 1;
     $36 = i64toi32_i32$1;
     i64toi32_i32$1 = $0 + 4 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $36;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     break label$1;
    }
    alloc__str___impl_20str___to_lowercase__hacad3ae1919ab6b6($6 + 80 | 0 | 0, $3 | 0, $4 | 0);
    HEAP32[($6 + 28 | 0) >> 2] = HEAP32[($6 + 88 | 0) >> 2] | 0;
    i64toi32_i32$2 = $6;
    i64toi32_i32$0 = HEAP32[($6 + 80 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($6 + 84 | 0) >> 2] | 0;
    $48 = i64toi32_i32$0;
    i64toi32_i32$0 = $6;
    HEAP32[($6 + 20 | 0) >> 2] = $48;
    HEAP32[($6 + 24 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($6 + 16 | 0) >> 2] = 1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($6 + 8 | 0 | 0, $6 + 16 | 0 | 4 | 0 | 0);
    $7 = $6 + 32 | 0;
    $4 = HEAP32[($6 + 12 | 0) >> 2] | 0;
    $3 = HEAP32[($6 + 8 | 0) >> 2] | 0;
   }
   bech32__Bech32Writer__new__h65a7836f3a5f87fe($6 + 32 | 0 | 0, $3 | 0, $4 | 0, $1 | 0, $2 | 0);
   label$5 : {
    label$6 : {
     if (!(HEAP32[($6 + 32 | 0) >> 2] | 0)) {
      break label$6
     }
     $3 = ($6 + 48 | 0) + 8 | 0;
     HEAP32[$3 >> 2] = HEAP32[($7 + 8 | 0) >> 2] | 0;
     i64toi32_i32$2 = $7;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $79 = i64toi32_i32$1;
     i64toi32_i32$1 = $6;
     HEAP32[($6 + 48 | 0) >> 2] = $79;
     HEAP32[($6 + 52 | 0) >> 2] = i64toi32_i32$0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__heed2de4899f9d51c($6 | 0, $5 | 0);
     $4 = bech32__WriteBase32__write__hc6853b536698e2d6($6 + 48 | 0 | 0, HEAP32[$6 >> 2] | 0 | 0, HEAP32[($6 + 4 | 0) >> 2] | 0 | 0) | 0;
     HEAP32[(($6 + 64 | 0) + 8 | 0) >> 2] = HEAP32[$3 >> 2] | 0;
     i64toi32_i32$2 = $6;
     i64toi32_i32$0 = HEAP32[($6 + 48 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($6 + 52 | 0) >> 2] | 0;
     $96 = i64toi32_i32$0;
     i64toi32_i32$0 = $6;
     HEAP32[($6 + 64 | 0) >> 2] = $96;
     HEAP32[($6 + 68 | 0) >> 2] = i64toi32_i32$1;
     label$7 : {
      label$8 : {
       if ($4) {
        break label$8
       }
       HEAP32[(($6 + 80 | 0) + 8 | 0) >> 2] = HEAP32[$3 >> 2] | 0;
       i64toi32_i32$2 = $6;
       i64toi32_i32$1 = HEAP32[($6 + 48 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[($6 + 52 | 0) >> 2] | 0;
       $105 = i64toi32_i32$1;
       i64toi32_i32$1 = $6;
       HEAP32[($6 + 80 | 0) >> 2] = $105;
       HEAP32[($6 + 84 | 0) >> 2] = i64toi32_i32$0;
       $3 = bech32__Bech32Writer__finalize__h8ac49edb73d669a0($6 + 80 | 0 | 0) | 0;
       break label$7;
      }
      $bech32__Bech32Writer_20as_20core__ops__drop__Drop___drop__ha90a511234f1ea05($6 + 64 | 0 | 0);
      $3 = 1;
     }
     HEAP8[$0 >> 0] = 0;
     HEAP8[($0 + 1 | 0) >> 0] = $3;
     break label$5;
    }
    HEAP16[$0 >> 1] = 256;
   }
   if (!(HEAP32[($6 + 16 | 0) >> 2] | 0)) {
    break label$1
   }
   $3 = $6 + 16 | 0 | 4 | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 | 0);
  }
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc91437b7d7fa2d3a($5 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h899e85abb4c3d85f($5 | 0);
  global$0 = $6 + 96 | 0;
 }
 
 function $bech32__Error_20as_20core__fmt__Display___fmt__hb94eedebff44411f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    switch (HEAPU8[$0 >> 0] | 0 | 0) {
    default:
     HEAP32[($2 + 44 | 0) >> 2] = 1;
     i64toi32_i32$0 = 0;
     HEAP32[($2 + 28 | 0) >> 2] = 2;
     HEAP32[($2 + 32 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($2 + 24 | 0) >> 2] = 1138864;
     HEAP32[($2 + 20 | 0) >> 2] = 223;
     HEAP32[($2 + 16 | 0) >> 2] = 1138880;
     HEAP32[($2 + 40 | 0) >> 2] = $2 + 16 | 0;
     $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 24 | 0 | 0) | 0;
     break label$1;
    case 1:
     HEAP32[($2 + 44 | 0) >> 2] = 0;
     HEAP32[($2 + 40 | 0) >> 2] = 1138676;
     i64toi32_i32$0 = 0;
     HEAP32[($2 + 28 | 0) >> 2] = 1;
     HEAP32[($2 + 32 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($2 + 24 | 0) >> 2] = 1138820;
     $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 24 | 0 | 0) | 0;
     break label$1;
    case 2:
     HEAP32[($2 + 44 | 0) >> 2] = 0;
     HEAP32[($2 + 40 | 0) >> 2] = 1138676;
     i64toi32_i32$0 = 0;
     HEAP32[($2 + 28 | 0) >> 2] = 1;
     HEAP32[($2 + 32 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($2 + 24 | 0) >> 2] = 1138796;
     $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 24 | 0 | 0) | 0;
     break label$1;
    case 3:
     HEAP32[($2 + 12 | 0) >> 2] = HEAP32[($0 + 4 | 0) >> 2] | 0;
     HEAP32[($2 + 44 | 0) >> 2] = 1;
     i64toi32_i32$0 = 0;
     HEAP32[($2 + 28 | 0) >> 2] = 2;
     HEAP32[($2 + 32 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($2 + 24 | 0) >> 2] = 1138764;
     HEAP32[($2 + 20 | 0) >> 2] = 223;
     HEAP32[($2 + 40 | 0) >> 2] = $2 + 16 | 0;
     HEAP32[($2 + 16 | 0) >> 2] = $2 + 12 | 0;
     $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 24 | 0 | 0) | 0;
     break label$1;
    case 4:
     HEAP8[($2 + 12 | 0) >> 0] = HEAPU8[($0 + 1 | 0) >> 0] | 0;
     HEAP32[($2 + 44 | 0) >> 2] = 1;
     i64toi32_i32$0 = 0;
     HEAP32[($2 + 28 | 0) >> 2] = 2;
     HEAP32[($2 + 32 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($2 + 24 | 0) >> 2] = 1138724;
     HEAP32[($2 + 20 | 0) >> 2] = 224;
     HEAP32[($2 + 40 | 0) >> 2] = $2 + 16 | 0;
     HEAP32[($2 + 16 | 0) >> 2] = $2 + 12 | 0;
     $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 24 | 0 | 0) | 0;
     break label$1;
    case 5:
     HEAP32[($2 + 44 | 0) >> 2] = 0;
     HEAP32[($2 + 40 | 0) >> 2] = 1138676;
     i64toi32_i32$0 = 0;
     HEAP32[($2 + 28 | 0) >> 2] = 1;
     HEAP32[($2 + 32 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($2 + 24 | 0) >> 2] = 1138692;
     $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 24 | 0 | 0) | 0;
     break label$1;
    case 6:
     break label$2;
    };
   }
   HEAP32[($2 + 44 | 0) >> 2] = 0;
   HEAP32[($2 + 40 | 0) >> 2] = 1138676;
   i64toi32_i32$0 = 0;
   HEAP32[($2 + 28 | 0) >> 2] = 1;
   HEAP32[($2 + 32 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($2 + 24 | 0) >> 2] = 1138668;
   $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 24 | 0 | 0) | 0;
  }
  global$0 = $2 + 48 | 0;
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__crypto__Ed25519Signature_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h6385501ae0da5a4b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, $8 = 0, $9 = 0, $10 = 0, $11 = 0, $12 = 0, $84 = 0, $89 = 0;
  $2 = global$0 - 256 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___bytes__hc697ccccfa39fd82($2 + 208 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 208 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[(($2 + 208 | 0) + 12 | 0) >> 2] | 0;
    HEAP32[(($2 + 160 | 0) + 8 | 0) >> 2] = $1;
    HEAP32[(($2 + 144 | 0) + 8 | 0) >> 2] = $1;
    i64toi32_i32$0 = HEAP32[($2 + 212 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 216 | 0) >> 2] | 0;
    $3 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[($2 + 160 | 0) >> 2] = $3;
    HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$0 = $2;
    HEAP32[($2 + 144 | 0) >> 2] = $3;
    HEAP32[($2 + 148 | 0) >> 2] = i64toi32_i32$1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 | 0, $2 + 144 | 0 | 0);
    cardano_serialization_lib__chain_crypto__sign__Signature_T_2cA___from_binary__h127c757dae4cedbd($2 + 72 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
    label$3 : {
     if ((HEAPU8[($2 + 72 | 0) >> 0] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     memcpy($2 + 8 | 0 | 0, $2 + 72 | 0 | 1 | 0 | 0, 64 | 0) | 0;
     memcpy($0 + 1 | 0 | 0, $2 + 8 | 0 | 0, 64 | 0) | 0;
     HEAP8[$0 >> 0] = 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 144 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 144 | 0 | 0);
     break label$1;
    }
    $1 = HEAP32[(($2 + 72 | 0) + 12 | 0) >> 2] | 0;
    $9 = ($2 + 8 | 0) + 11 | 0;
    HEAP8[$9 >> 0] = $1;
    HEAP8[($9 + 1 | 0) >> 0] = $1 >>> 8 | 0;
    HEAP8[($9 + 2 | 0) >> 0] = $1 >>> 16 | 0;
    HEAP8[($9 + 3 | 0) >> 0] = $1 >>> 24 | 0;
    i64toi32_i32$1 = HEAP32[($2 + 76 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 80 | 0) >> 2] | 0;
    $3 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP8[($2 + 11 | 0) >> 0] = $3;
    HEAP8[($2 + 12 | 0) >> 0] = $3 >>> 8 | 0;
    HEAP8[($2 + 13 | 0) >> 0] = $3 >>> 16 | 0;
    HEAP8[($2 + 14 | 0) >> 0] = $3 >>> 24 | 0;
    HEAP8[($2 + 15 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[($2 + 16 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[($2 + 17 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[($2 + 18 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    $10 = ($2 + 72 | 0) + 11 | 0;
    HEAP8[$10 >> 0] = $1;
    HEAP8[($10 + 1 | 0) >> 0] = $1 >>> 8 | 0;
    HEAP8[($10 + 2 | 0) >> 0] = $1 >>> 16 | 0;
    HEAP8[($10 + 3 | 0) >> 0] = $1 >>> 24 | 0;
    HEAP32[($0 + 56 | 0) >> 2] = 0;
    HEAP8[($0 + 8 | 0) >> 0] = 14;
    i64toi32_i32$1 = $2;
    HEAP8[($2 + 75 | 0) >> 0] = $3;
    HEAP8[($2 + 76 | 0) >> 0] = $3 >>> 8 | 0;
    HEAP8[($2 + 77 | 0) >> 0] = $3 >>> 16 | 0;
    HEAP8[($2 + 78 | 0) >> 0] = $3 >>> 24 | 0;
    HEAP8[($2 + 79 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[($2 + 80 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[($2 + 81 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[($2 + 82 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$0 = HEAPU8[($2 + 72 | 0) >> 0] | 0 | ((HEAPU8[($2 + 73 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 74 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 75 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[($2 + 76 | 0) >> 0] | 0 | ((HEAPU8[($2 + 77 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 78 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 79 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $84 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 9 | 0;
    $11 = $84;
    HEAP8[i64toi32_i32$0 >> 0] = $11;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    $8 = $2 + 79 | 0;
    i64toi32_i32$1 = HEAPU8[$8 >> 0] | 0 | ((HEAPU8[($8 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($8 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($8 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[($8 + 4 | 0) >> 0] | 0 | ((HEAPU8[($8 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($8 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($8 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $89 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 16 | 0;
    $12 = $89;
    HEAP8[i64toi32_i32$1 >> 0] = $12;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $12 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $12 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $12 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    HEAP8[$0 >> 0] = 1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 144 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 144 | 0 | 0);
    break label$1;
   }
   memcpy($2 + 215 | 0 | 0, memcpy($2 + 160 | 0 | 4 | 0 | 0, ($2 + 208 | 0) + 8 | 0 | 0, 40 | 0) | 0 | 0, 40 | 0) | 0;
   HEAP8[($0 + 8 | 0) >> 0] = 2;
   HEAP32[($0 + 56 | 0) >> 2] = 0;
   memcpy($0 + 9 | 0 | 0, $2 + 208 | 0 | 0, 47 | 0) | 0;
   HEAP8[$0 >> 0] = 1;
  }
  global$0 = $2 + 256 | 0;
 }
 
 function core__iter__traits__iterator__Iterator__cmp_by__hff45e02ccefa0d77($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $4 = 0, $20 = 0, $26 = 0, $29 = 0, $3 = 0, $5 = 0, $78 = 0, $85 = 0, $88 = 0, $102 = 0, $109 = 0, $112 = 0;
  $2 = global$0 - 192 | 0;
  global$0 = $2;
  HEAP32[(($2 + 32 | 0) + 24 | 0) >> 2] = HEAP32[($1 + 24 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 32 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $20;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $26 = i64toi32_i32$1;
  i64toi32_i32$1 = ($2 + 32 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $26;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $29 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $29;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   label$2 : while (1) {
    $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h03cc330b7b1e4522($2 + 24 | 0 | 0, $0 | 0);
    label$3 : {
     $1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
     if ($1) {
      break label$3
     }
     $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h03cc330b7b1e4522($2 + 8 | 0 | 0, $2 + 32 | 0 | 0);
     $1 = HEAP32[($2 + 8 | 0) >> 2] | 0 ? -1 : 0;
     break label$1;
    }
    $3 = HEAP32[($2 + 28 | 0) >> 2] | 0;
    $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h03cc330b7b1e4522($2 + 16 | 0 | 0, $2 + 32 | 0 | 0);
    label$4 : {
     $4 = HEAP32[($2 + 16 | 0) >> 2] | 0;
     if ($4) {
      break label$4
     }
     $1 = 1;
     break label$1;
    }
    $5 = HEAP32[($2 + 20 | 0) >> 2] | 0;
    label$5 : {
     $1 = core__slice__cmp___impl_20core__cmp__Ord_20for_20_5bT_5d___cmp__h1f2092e0ba2f27ea($1 | 0, 28 | 0, $4 | 0, 28 | 0) | 0;
     if ($1 & 255 | 0) {
      break label$5
     }
     alloc__collections__btree__map__BTreeMap_K_2cV___iter__ha89c9458aca0228d($2 + 64 | 0 | 0, $3 | 0);
     alloc__collections__btree__map__BTreeMap_K_2cV___iter__ha89c9458aca0228d($2 + 96 | 0 | 0, $5 | 0);
     HEAP32[(($2 + 128 | 0) + 24 | 0) >> 2] = HEAP32[(($2 + 64 | 0) + 24 | 0) >> 2] | 0;
     i64toi32_i32$2 = ($2 + 64 | 0) + 16 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $78 = i64toi32_i32$1;
     i64toi32_i32$1 = ($2 + 128 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $78;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = ($2 + 64 | 0) + 8 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $85 = i64toi32_i32$0;
     i64toi32_i32$0 = ($2 + 128 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $85;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAP32[($2 + 64 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 68 | 0) >> 2] | 0;
     $88 = i64toi32_i32$1;
     i64toi32_i32$1 = $2;
     HEAP32[($2 + 128 | 0) >> 2] = $88;
     HEAP32[($2 + 132 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[(($2 + 160 | 0) + 24 | 0) >> 2] = HEAP32[(($2 + 96 | 0) + 24 | 0) >> 2] | 0;
     i64toi32_i32$2 = ($2 + 96 | 0) + 16 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $102 = i64toi32_i32$0;
     i64toi32_i32$0 = ($2 + 160 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $102;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = ($2 + 96 | 0) + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $109 = i64toi32_i32$1;
     i64toi32_i32$1 = ($2 + 160 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $109;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[($2 + 96 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 100 | 0) >> 2] | 0;
     $112 = i64toi32_i32$0;
     i64toi32_i32$0 = $2;
     HEAP32[($2 + 160 | 0) >> 2] = $112;
     HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
     $1 = core__iter__traits__iterator__Iterator__cmp_by__h9704328b732bb868($2 + 128 | 0 | 0, $2 + 160 | 0 | 0) | 0;
    }
    if (!($1 & 255 | 0)) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $2 + 192 | 0;
  return $1 | 0;
 }
 
 function alloc__slice__insert_head__h35027323f3cb1415($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $5 = 0, $3 = 0, $4 = 0, i64toi32_i32$1 = 0, $6 = 0, i64toi32_i32$0 = 0, $9 = 0, $7 = 0, $8 = 0, $10 = 0, $10$hi = 0, $55 = 0, $114 = 0, $134 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  label$1 : {
   if ($1 >>> 0 < 2 >>> 0) {
    break label$1
   }
   $4 = $0 + 12 | 0;
   label$2 : {
    $5 = HEAP32[($0 + 20 | 0) >> 2] | 0;
    $6 = HEAP32[($0 + 8 | 0) >> 2] | 0;
    $5 = $5 >>> 0 < $6 >>> 0 ? -1 : ($5 | 0) != ($6 | 0);
    if ($5) {
     break label$2
    }
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 24 | 0 | 0, $4 | 0);
    $5 = HEAP32[($3 + 28 | 0) >> 2] | 0;
    $6 = HEAP32[($3 + 24 | 0) >> 2] | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 16 | 0 | 0, $0 | 0);
    $5 = core__slice__cmp___impl_20core__cmp__Ord_20for_20_5bT_5d___cmp__h1f2092e0ba2f27ea($6 | 0, $5 | 0, HEAP32[($3 + 16 | 0) >> 2] | 0 | 0, HEAP32[($3 + 20 | 0) >> 2] | 0 | 0) | 0;
   }
   if (($5 & 255 | 0 | 0) != (255 | 0)) {
    break label$1
   }
   i64toi32_i32$0 = HEAP32[$0 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   $10 = i64toi32_i32$0;
   $10$hi = i64toi32_i32$1;
   i64toi32_i32$1 = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   $55 = i64toi32_i32$1;
   i64toi32_i32$1 = $0;
   HEAP32[i64toi32_i32$1 >> 2] = $55;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   $7 = ($3 + 32 | 0) + 8 | 0;
   $5 = i64toi32_i32$1 + 8 | 0;
   HEAP32[$7 >> 2] = HEAP32[$5 >> 2] | 0;
   HEAP32[$5 >> 2] = HEAP32[($4 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = $10$hi;
   i64toi32_i32$1 = $3;
   HEAP32[($3 + 32 | 0) >> 2] = $10;
   HEAP32[($3 + 36 | 0) >> 2] = i64toi32_i32$0;
   $5 = 1;
   label$3 : {
    if ($1 >>> 0 < 3 >>> 0) {
     break label$3
    }
    $5 = $0 + 24 | 0;
    $6 = 2;
    label$4 : while (1) {
     label$5 : {
      $8 = $5 + 8 | 0;
      $4 = HEAP32[$8 >> 2] | 0;
      $9 = HEAP32[($3 + 40 | 0) >> 2] | 0;
      $4 = $4 >>> 0 < $9 >>> 0 ? -1 : ($4 | 0) != ($9 | 0);
      if ($4) {
       break label$5
      }
      $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $5 | 0);
      $4 = HEAP32[($3 + 12 | 0) >> 2] | 0;
      $9 = HEAP32[($3 + 8 | 0) >> 2] | 0;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 | 0, $3 + 32 | 0 | 0);
      $4 = core__slice__cmp___impl_20core__cmp__Ord_20for_20_5bT_5d___cmp__h1f2092e0ba2f27ea($9 | 0, $4 | 0, HEAP32[$3 >> 2] | 0 | 0, HEAP32[($3 + 4 | 0) >> 2] | 0 | 0) | 0;
     }
     label$6 : {
      if (($4 & 255 | 0 | 0) == (255 | 0)) {
       break label$6
      }
      $5 = $6 + -1 | 0;
      break label$3;
     }
     $4 = $5 + -12 | 0;
     i64toi32_i32$0 = HEAP32[$5 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($5 + 4 | 0) >> 2] | 0;
     $114 = i64toi32_i32$0;
     i64toi32_i32$0 = $4;
     HEAP32[$4 >> 2] = $114;
     HEAP32[($4 + 4 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($4 + 8 | 0) >> 2] = HEAP32[$8 >> 2] | 0;
     $5 = $5 + 12 | 0;
     $6 = $6 + 1 | 0;
     if (($1 | 0) != ($6 | 0)) {
      continue label$4
     }
     break label$4;
    };
    $5 = $6 + -1 | 0;
   }
   $5 = $0 + Math_imul($5, 12) | 0;
   i64toi32_i32$1 = HEAP32[($3 + 32 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($3 + 36 | 0) >> 2] | 0;
   $134 = i64toi32_i32$1;
   i64toi32_i32$1 = $5;
   HEAP32[$5 >> 2] = $134;
   HEAP32[($5 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($5 + 8 | 0) >> 2] = HEAP32[$7 >> 2] | 0;
  }
  global$0 = $3 + 48 | 0;
 }
 
 function hashbrown__raw__RawTable_T_2cA___insert__h06f681ead2656f7c($0, $1, $1$hi, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $1$hi = $1$hi | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $11 = 0, $9 = 0, $10 = 0, $6 = 0, $7 = 0, $13 = 0, $14 = 0, $15 = 0, $16 = 0, $5 = 0, $8 = 0;
  $5 = global$0 - 16 | 0;
  global$0 = $5;
  label$1 : {
   $6 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   $7 = HEAP32[$0 >> 2] | 0;
   $8 = $1;
   $9 = $7 & $8 | 0;
   $13 = $6 + $9 | 0;
   $10 = (HEAPU8[$13 >> 0] | 0 | ((HEAPU8[($13 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($13 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($13 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
   if ($10) {
    break label$1
   }
   $11 = 4;
   label$2 : while (1) {
    $9 = $9 + $11 | 0;
    $11 = $11 + 4 | 0;
    $9 = $9 & $7 | 0;
    $14 = $6 + $9 | 0;
    $10 = (HEAPU8[$14 >> 0] | 0 | ((HEAPU8[($14 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($14 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($14 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
    if (!$10) {
     continue label$2
    }
    break label$2;
   };
  }
  label$3 : {
   $11 = (((__wasm_ctz_i32($10 | 0) | 0) >>> 3 | 0) + $9 | 0) & $7 | 0;
   $9 = HEAP8[($6 + $11 | 0) >> 0] | 0;
   if (($9 | 0) <= (-1 | 0)) {
    break label$3
   }
   $11 = (__wasm_ctz_i32((HEAP32[$6 >> 2] | 0) & -2139062144 | 0 | 0) | 0) >>> 3 | 0;
   $9 = HEAPU8[($6 + $11 | 0) >> 0] | 0;
  }
  label$4 : {
   $9 = $9 & 1 | 0;
   if (!$9) {
    break label$4
   }
   if (HEAP32[($0 + 8 | 0) >> 2] | 0) {
    break label$4
   }
   hashbrown__raw__RawTable_T_2cA___reserve_rehash__h8272927323c5743e($5 | 0, $0 | 0, 1 | 0, $4 | 0, 1 | 0);
   label$5 : {
    $6 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    $7 = HEAP32[$0 >> 2] | 0;
    $10 = $7 & $8 | 0;
    $15 = $6 + $10 | 0;
    $4 = (HEAPU8[$15 >> 0] | 0 | ((HEAPU8[($15 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($15 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($15 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
    if ($4) {
     break label$5
    }
    $11 = 4;
    label$6 : while (1) {
     $10 = $10 + $11 | 0;
     $11 = $11 + 4 | 0;
     $10 = $10 & $7 | 0;
     $16 = $6 + $10 | 0;
     $4 = (HEAPU8[$16 >> 0] | 0 | ((HEAPU8[($16 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($16 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($16 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
     if (!$4) {
      continue label$6
     }
     break label$6;
    };
   }
   $11 = (((__wasm_ctz_i32($4 | 0) | 0) >>> 3 | 0) + $10 | 0) & $7 | 0;
   if ((HEAP8[($6 + $11 | 0) >> 0] | 0 | 0) <= (-1 | 0)) {
    break label$4
   }
   $11 = (__wasm_ctz_i32((HEAP32[$6 >> 2] | 0) & -2139062144 | 0 | 0) | 0) >>> 3 | 0;
  }
  $10 = $8 >>> 25 | 0;
  HEAP8[($6 + $11 | 0) >> 0] = $10;
  HEAP8[(((($11 + -4 | 0) & $7 | 0) + $6 | 0) + 4 | 0) >> 0] = $10;
  HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) - $9 | 0;
  HEAP32[($0 + 12 | 0) >> 2] = (HEAP32[($0 + 12 | 0) >> 2] | 0) + 1 | 0;
  $11 = $6 - ($11 << 3 | 0) | 0;
  $9 = $11 + -8 | 0;
  HEAP32[$9 >> 2] = $2;
  HEAP32[($9 + 4 | 0) >> 2] = $3;
  global$0 = $5 + 16 | 0;
  return $11 | 0;
 }
 
 function hashbrown__raw__RawTable_T_2cA___insert__h418758a7d461f33b($0, $1, $1$hi, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $1$hi = $1$hi | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $11 = 0, $9 = 0, $10 = 0, $6 = 0, $7 = 0, $13 = 0, $14 = 0, $15 = 0, $16 = 0, $5 = 0, $8 = 0;
  $5 = global$0 - 16 | 0;
  global$0 = $5;
  label$1 : {
   $6 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   $7 = HEAP32[$0 >> 2] | 0;
   $8 = $1;
   $9 = $7 & $8 | 0;
   $13 = $6 + $9 | 0;
   $10 = (HEAPU8[$13 >> 0] | 0 | ((HEAPU8[($13 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($13 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($13 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
   if ($10) {
    break label$1
   }
   $11 = 4;
   label$2 : while (1) {
    $9 = $9 + $11 | 0;
    $11 = $11 + 4 | 0;
    $9 = $9 & $7 | 0;
    $14 = $6 + $9 | 0;
    $10 = (HEAPU8[$14 >> 0] | 0 | ((HEAPU8[($14 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($14 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($14 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
    if (!$10) {
     continue label$2
    }
    break label$2;
   };
  }
  label$3 : {
   $11 = (((__wasm_ctz_i32($10 | 0) | 0) >>> 3 | 0) + $9 | 0) & $7 | 0;
   $9 = HEAP8[($6 + $11 | 0) >> 0] | 0;
   if (($9 | 0) <= (-1 | 0)) {
    break label$3
   }
   $11 = (__wasm_ctz_i32((HEAP32[$6 >> 2] | 0) & -2139062144 | 0 | 0) | 0) >>> 3 | 0;
   $9 = HEAPU8[($6 + $11 | 0) >> 0] | 0;
  }
  label$4 : {
   $9 = $9 & 1 | 0;
   if (!$9) {
    break label$4
   }
   if (HEAP32[($0 + 8 | 0) >> 2] | 0) {
    break label$4
   }
   hashbrown__raw__RawTable_T_2cA___reserve_rehash__h9a8b2e47a9b8fcec($5 | 0, $0 | 0, 1 | 0, $4 | 0, 1 | 0);
   label$5 : {
    $6 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    $7 = HEAP32[$0 >> 2] | 0;
    $10 = $7 & $8 | 0;
    $15 = $6 + $10 | 0;
    $4 = (HEAPU8[$15 >> 0] | 0 | ((HEAPU8[($15 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($15 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($15 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
    if ($4) {
     break label$5
    }
    $11 = 4;
    label$6 : while (1) {
     $10 = $10 + $11 | 0;
     $11 = $11 + 4 | 0;
     $10 = $10 & $7 | 0;
     $16 = $6 + $10 | 0;
     $4 = (HEAPU8[$16 >> 0] | 0 | ((HEAPU8[($16 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($16 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($16 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
     if (!$4) {
      continue label$6
     }
     break label$6;
    };
   }
   $11 = (((__wasm_ctz_i32($4 | 0) | 0) >>> 3 | 0) + $10 | 0) & $7 | 0;
   if ((HEAP8[($6 + $11 | 0) >> 0] | 0 | 0) <= (-1 | 0)) {
    break label$4
   }
   $11 = (__wasm_ctz_i32((HEAP32[$6 >> 2] | 0) & -2139062144 | 0 | 0) | 0) >>> 3 | 0;
  }
  $10 = $8 >>> 25 | 0;
  HEAP8[($6 + $11 | 0) >> 0] = $10;
  HEAP8[(((($11 + -4 | 0) & $7 | 0) + $6 | 0) + 4 | 0) >> 0] = $10;
  HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) - $9 | 0;
  HEAP32[($0 + 12 | 0) >> 2] = (HEAP32[($0 + 12 | 0) >> 2] | 0) + 1 | 0;
  $11 = $6 - ($11 << 3 | 0) | 0;
  $9 = $11 + -8 | 0;
  HEAP32[$9 >> 2] = $2;
  HEAP32[($9 + 4 | 0) >> 2] = $3;
  global$0 = $5 + 16 | 0;
  return $11 | 0;
 }
 
 function hashbrown__raw__RawTable_T_2cA___insert__h6db614c9d789f2e1($0, $1, $1$hi, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $1$hi = $1$hi | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $11 = 0, $9 = 0, $10 = 0, $6 = 0, $7 = 0, $13 = 0, $14 = 0, $15 = 0, $16 = 0, $5 = 0, $8 = 0;
  $5 = global$0 - 16 | 0;
  global$0 = $5;
  label$1 : {
   $6 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   $7 = HEAP32[$0 >> 2] | 0;
   $8 = $1;
   $9 = $7 & $8 | 0;
   $13 = $6 + $9 | 0;
   $10 = (HEAPU8[$13 >> 0] | 0 | ((HEAPU8[($13 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($13 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($13 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
   if ($10) {
    break label$1
   }
   $11 = 4;
   label$2 : while (1) {
    $9 = $9 + $11 | 0;
    $11 = $11 + 4 | 0;
    $9 = $9 & $7 | 0;
    $14 = $6 + $9 | 0;
    $10 = (HEAPU8[$14 >> 0] | 0 | ((HEAPU8[($14 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($14 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($14 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
    if (!$10) {
     continue label$2
    }
    break label$2;
   };
  }
  label$3 : {
   $11 = (((__wasm_ctz_i32($10 | 0) | 0) >>> 3 | 0) + $9 | 0) & $7 | 0;
   $9 = HEAP8[($6 + $11 | 0) >> 0] | 0;
   if (($9 | 0) <= (-1 | 0)) {
    break label$3
   }
   $11 = (__wasm_ctz_i32((HEAP32[$6 >> 2] | 0) & -2139062144 | 0 | 0) | 0) >>> 3 | 0;
   $9 = HEAPU8[($6 + $11 | 0) >> 0] | 0;
  }
  label$4 : {
   $9 = $9 & 1 | 0;
   if (!$9) {
    break label$4
   }
   if (HEAP32[($0 + 8 | 0) >> 2] | 0) {
    break label$4
   }
   hashbrown__raw__RawTable_T_2cA___reserve_rehash__h36f8e08ecb372107($5 | 0, $0 | 0, 1 | 0, $4 | 0, 1 | 0);
   label$5 : {
    $6 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    $7 = HEAP32[$0 >> 2] | 0;
    $10 = $7 & $8 | 0;
    $15 = $6 + $10 | 0;
    $4 = (HEAPU8[$15 >> 0] | 0 | ((HEAPU8[($15 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($15 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($15 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
    if ($4) {
     break label$5
    }
    $11 = 4;
    label$6 : while (1) {
     $10 = $10 + $11 | 0;
     $11 = $11 + 4 | 0;
     $10 = $10 & $7 | 0;
     $16 = $6 + $10 | 0;
     $4 = (HEAPU8[$16 >> 0] | 0 | ((HEAPU8[($16 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($16 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($16 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
     if (!$4) {
      continue label$6
     }
     break label$6;
    };
   }
   $11 = (((__wasm_ctz_i32($4 | 0) | 0) >>> 3 | 0) + $10 | 0) & $7 | 0;
   if ((HEAP8[($6 + $11 | 0) >> 0] | 0 | 0) <= (-1 | 0)) {
    break label$4
   }
   $11 = (__wasm_ctz_i32((HEAP32[$6 >> 2] | 0) & -2139062144 | 0 | 0) | 0) >>> 3 | 0;
  }
  $10 = $8 >>> 25 | 0;
  HEAP8[($6 + $11 | 0) >> 0] = $10;
  HEAP8[(((($11 + -4 | 0) & $7 | 0) + $6 | 0) + 4 | 0) >> 0] = $10;
  HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) - $9 | 0;
  HEAP32[($0 + 12 | 0) >> 2] = (HEAP32[($0 + 12 | 0) >> 2] | 0) + 1 | 0;
  $11 = $6 - ($11 << 3 | 0) | 0;
  $9 = $11 + -8 | 0;
  HEAP32[$9 >> 2] = $2;
  HEAP32[($9 + 4 | 0) >> 2] = $3;
  global$0 = $5 + 16 | 0;
  return $11 | 0;
 }
 
 function hashbrown__raw__RawTable_T_2cA___insert__h9e114b5bd533aa2a($0, $1, $1$hi, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $1$hi = $1$hi | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $11 = 0, $9 = 0, $10 = 0, $6 = 0, $7 = 0, $13 = 0, $14 = 0, $15 = 0, $16 = 0, $5 = 0, $8 = 0;
  $5 = global$0 - 16 | 0;
  global$0 = $5;
  label$1 : {
   $6 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   $7 = HEAP32[$0 >> 2] | 0;
   $8 = $1;
   $9 = $7 & $8 | 0;
   $13 = $6 + $9 | 0;
   $10 = (HEAPU8[$13 >> 0] | 0 | ((HEAPU8[($13 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($13 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($13 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
   if ($10) {
    break label$1
   }
   $11 = 4;
   label$2 : while (1) {
    $9 = $9 + $11 | 0;
    $11 = $11 + 4 | 0;
    $9 = $9 & $7 | 0;
    $14 = $6 + $9 | 0;
    $10 = (HEAPU8[$14 >> 0] | 0 | ((HEAPU8[($14 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($14 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($14 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
    if (!$10) {
     continue label$2
    }
    break label$2;
   };
  }
  label$3 : {
   $11 = (((__wasm_ctz_i32($10 | 0) | 0) >>> 3 | 0) + $9 | 0) & $7 | 0;
   $9 = HEAP8[($6 + $11 | 0) >> 0] | 0;
   if (($9 | 0) <= (-1 | 0)) {
    break label$3
   }
   $11 = (__wasm_ctz_i32((HEAP32[$6 >> 2] | 0) & -2139062144 | 0 | 0) | 0) >>> 3 | 0;
   $9 = HEAPU8[($6 + $11 | 0) >> 0] | 0;
  }
  label$4 : {
   $9 = $9 & 1 | 0;
   if (!$9) {
    break label$4
   }
   if (HEAP32[($0 + 8 | 0) >> 2] | 0) {
    break label$4
   }
   hashbrown__raw__RawTable_T_2cA___reserve_rehash__hd1aa58e6d9f62a6c($5 | 0, $0 | 0, 1 | 0, $4 | 0, 1 | 0);
   label$5 : {
    $6 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    $7 = HEAP32[$0 >> 2] | 0;
    $10 = $7 & $8 | 0;
    $15 = $6 + $10 | 0;
    $4 = (HEAPU8[$15 >> 0] | 0 | ((HEAPU8[($15 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($15 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($15 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
    if ($4) {
     break label$5
    }
    $11 = 4;
    label$6 : while (1) {
     $10 = $10 + $11 | 0;
     $11 = $11 + 4 | 0;
     $10 = $10 & $7 | 0;
     $16 = $6 + $10 | 0;
     $4 = (HEAPU8[$16 >> 0] | 0 | ((HEAPU8[($16 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($16 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($16 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
     if (!$4) {
      continue label$6
     }
     break label$6;
    };
   }
   $11 = (((__wasm_ctz_i32($4 | 0) | 0) >>> 3 | 0) + $10 | 0) & $7 | 0;
   if ((HEAP8[($6 + $11 | 0) >> 0] | 0 | 0) <= (-1 | 0)) {
    break label$4
   }
   $11 = (__wasm_ctz_i32((HEAP32[$6 >> 2] | 0) & -2139062144 | 0 | 0) | 0) >>> 3 | 0;
  }
  $10 = $8 >>> 25 | 0;
  HEAP8[($6 + $11 | 0) >> 0] = $10;
  HEAP8[(((($11 + -4 | 0) & $7 | 0) + $6 | 0) + 4 | 0) >> 0] = $10;
  HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) - $9 | 0;
  HEAP32[($0 + 12 | 0) >> 2] = (HEAP32[($0 + 12 | 0) >> 2] | 0) + 1 | 0;
  $11 = $6 - ($11 << 3 | 0) | 0;
  $9 = $11 + -8 | 0;
  HEAP32[$9 >> 2] = $2;
  HEAP32[($9 + 4 | 0) >> 2] = $3;
  global$0 = $5 + 16 | 0;
  return $11 | 0;
 }
 
 function hashbrown__raw__RawTable_T_2cA___insert__ha3d899634fbcfa25($0, $1, $1$hi, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $1$hi = $1$hi | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $11 = 0, $9 = 0, $10 = 0, $6 = 0, $7 = 0, $13 = 0, $14 = 0, $15 = 0, $16 = 0, $5 = 0, $8 = 0;
  $5 = global$0 - 16 | 0;
  global$0 = $5;
  label$1 : {
   $6 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   $7 = HEAP32[$0 >> 2] | 0;
   $8 = $1;
   $9 = $7 & $8 | 0;
   $13 = $6 + $9 | 0;
   $10 = (HEAPU8[$13 >> 0] | 0 | ((HEAPU8[($13 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($13 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($13 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
   if ($10) {
    break label$1
   }
   $11 = 4;
   label$2 : while (1) {
    $9 = $9 + $11 | 0;
    $11 = $11 + 4 | 0;
    $9 = $9 & $7 | 0;
    $14 = $6 + $9 | 0;
    $10 = (HEAPU8[$14 >> 0] | 0 | ((HEAPU8[($14 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($14 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($14 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
    if (!$10) {
     continue label$2
    }
    break label$2;
   };
  }
  label$3 : {
   $11 = (((__wasm_ctz_i32($10 | 0) | 0) >>> 3 | 0) + $9 | 0) & $7 | 0;
   $9 = HEAP8[($6 + $11 | 0) >> 0] | 0;
   if (($9 | 0) <= (-1 | 0)) {
    break label$3
   }
   $11 = (__wasm_ctz_i32((HEAP32[$6 >> 2] | 0) & -2139062144 | 0 | 0) | 0) >>> 3 | 0;
   $9 = HEAPU8[($6 + $11 | 0) >> 0] | 0;
  }
  label$4 : {
   $9 = $9 & 1 | 0;
   if (!$9) {
    break label$4
   }
   if (HEAP32[($0 + 8 | 0) >> 2] | 0) {
    break label$4
   }
   hashbrown__raw__RawTable_T_2cA___reserve_rehash__he1b34538bf0de034($5 | 0, $0 | 0, 1 | 0, $4 | 0, 1 | 0);
   label$5 : {
    $6 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    $7 = HEAP32[$0 >> 2] | 0;
    $10 = $7 & $8 | 0;
    $15 = $6 + $10 | 0;
    $4 = (HEAPU8[$15 >> 0] | 0 | ((HEAPU8[($15 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($15 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($15 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
    if ($4) {
     break label$5
    }
    $11 = 4;
    label$6 : while (1) {
     $10 = $10 + $11 | 0;
     $11 = $11 + 4 | 0;
     $10 = $10 & $7 | 0;
     $16 = $6 + $10 | 0;
     $4 = (HEAPU8[$16 >> 0] | 0 | ((HEAPU8[($16 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($16 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($16 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
     if (!$4) {
      continue label$6
     }
     break label$6;
    };
   }
   $11 = (((__wasm_ctz_i32($4 | 0) | 0) >>> 3 | 0) + $10 | 0) & $7 | 0;
   if ((HEAP8[($6 + $11 | 0) >> 0] | 0 | 0) <= (-1 | 0)) {
    break label$4
   }
   $11 = (__wasm_ctz_i32((HEAP32[$6 >> 2] | 0) & -2139062144 | 0 | 0) | 0) >>> 3 | 0;
  }
  $10 = $8 >>> 25 | 0;
  HEAP8[($6 + $11 | 0) >> 0] = $10;
  HEAP8[(((($11 + -4 | 0) & $7 | 0) + $6 | 0) + 4 | 0) >> 0] = $10;
  HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) - $9 | 0;
  HEAP32[($0 + 12 | 0) >> 2] = (HEAP32[($0 + 12 | 0) >> 2] | 0) + 1 | 0;
  $11 = $6 - ($11 << 3 | 0) | 0;
  $9 = $11 + -8 | 0;
  HEAP32[$9 >> 2] = $2;
  HEAP32[($9 + 4 | 0) >> 2] = $3;
  global$0 = $5 + 16 | 0;
  return $11 | 0;
 }
 
 function hashbrown__raw__RawTable_T_2cA___insert__hbcad5b3968423033($0, $1, $1$hi, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $1$hi = $1$hi | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $11 = 0, $9 = 0, $10 = 0, $6 = 0, $7 = 0, $13 = 0, $14 = 0, $15 = 0, $16 = 0, $5 = 0, $8 = 0;
  $5 = global$0 - 16 | 0;
  global$0 = $5;
  label$1 : {
   $6 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   $7 = HEAP32[$0 >> 2] | 0;
   $8 = $1;
   $9 = $7 & $8 | 0;
   $13 = $6 + $9 | 0;
   $10 = (HEAPU8[$13 >> 0] | 0 | ((HEAPU8[($13 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($13 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($13 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
   if ($10) {
    break label$1
   }
   $11 = 4;
   label$2 : while (1) {
    $9 = $9 + $11 | 0;
    $11 = $11 + 4 | 0;
    $9 = $9 & $7 | 0;
    $14 = $6 + $9 | 0;
    $10 = (HEAPU8[$14 >> 0] | 0 | ((HEAPU8[($14 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($14 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($14 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
    if (!$10) {
     continue label$2
    }
    break label$2;
   };
  }
  label$3 : {
   $11 = (((__wasm_ctz_i32($10 | 0) | 0) >>> 3 | 0) + $9 | 0) & $7 | 0;
   $9 = HEAP8[($6 + $11 | 0) >> 0] | 0;
   if (($9 | 0) <= (-1 | 0)) {
    break label$3
   }
   $11 = (__wasm_ctz_i32((HEAP32[$6 >> 2] | 0) & -2139062144 | 0 | 0) | 0) >>> 3 | 0;
   $9 = HEAPU8[($6 + $11 | 0) >> 0] | 0;
  }
  label$4 : {
   $9 = $9 & 1 | 0;
   if (!$9) {
    break label$4
   }
   if (HEAP32[($0 + 8 | 0) >> 2] | 0) {
    break label$4
   }
   hashbrown__raw__RawTable_T_2cA___reserve_rehash__he1deefcf95f72348($5 | 0, $0 | 0, 1 | 0, $4 | 0, 1 | 0);
   label$5 : {
    $6 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    $7 = HEAP32[$0 >> 2] | 0;
    $10 = $7 & $8 | 0;
    $15 = $6 + $10 | 0;
    $4 = (HEAPU8[$15 >> 0] | 0 | ((HEAPU8[($15 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($15 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($15 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
    if ($4) {
     break label$5
    }
    $11 = 4;
    label$6 : while (1) {
     $10 = $10 + $11 | 0;
     $11 = $11 + 4 | 0;
     $10 = $10 & $7 | 0;
     $16 = $6 + $10 | 0;
     $4 = (HEAPU8[$16 >> 0] | 0 | ((HEAPU8[($16 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($16 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($16 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
     if (!$4) {
      continue label$6
     }
     break label$6;
    };
   }
   $11 = (((__wasm_ctz_i32($4 | 0) | 0) >>> 3 | 0) + $10 | 0) & $7 | 0;
   if ((HEAP8[($6 + $11 | 0) >> 0] | 0 | 0) <= (-1 | 0)) {
    break label$4
   }
   $11 = (__wasm_ctz_i32((HEAP32[$6 >> 2] | 0) & -2139062144 | 0 | 0) | 0) >>> 3 | 0;
  }
  $10 = $8 >>> 25 | 0;
  HEAP8[($6 + $11 | 0) >> 0] = $10;
  HEAP8[(((($11 + -4 | 0) & $7 | 0) + $6 | 0) + 4 | 0) >> 0] = $10;
  HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) - $9 | 0;
  HEAP32[($0 + 12 | 0) >> 2] = (HEAP32[($0 + 12 | 0) >> 2] | 0) + 1 | 0;
  $11 = $6 - ($11 << 3 | 0) | 0;
  $9 = $11 + -8 | 0;
  HEAP32[$9 >> 2] = $2;
  HEAP32[($9 + 4 | 0) >> 2] = $3;
  global$0 = $5 + 16 | 0;
  return $11 | 0;
 }
 
 function hashbrown__raw__RawTable_T_2cA___insert__he0ddabc3bc476eee($0, $1, $1$hi, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $1$hi = $1$hi | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $11 = 0, $9 = 0, $10 = 0, $6 = 0, $7 = 0, $13 = 0, $14 = 0, $15 = 0, $16 = 0, $5 = 0, $8 = 0;
  $5 = global$0 - 16 | 0;
  global$0 = $5;
  label$1 : {
   $6 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   $7 = HEAP32[$0 >> 2] | 0;
   $8 = $1;
   $9 = $7 & $8 | 0;
   $13 = $6 + $9 | 0;
   $10 = (HEAPU8[$13 >> 0] | 0 | ((HEAPU8[($13 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($13 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($13 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
   if ($10) {
    break label$1
   }
   $11 = 4;
   label$2 : while (1) {
    $9 = $9 + $11 | 0;
    $11 = $11 + 4 | 0;
    $9 = $9 & $7 | 0;
    $14 = $6 + $9 | 0;
    $10 = (HEAPU8[$14 >> 0] | 0 | ((HEAPU8[($14 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($14 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($14 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
    if (!$10) {
     continue label$2
    }
    break label$2;
   };
  }
  label$3 : {
   $11 = (((__wasm_ctz_i32($10 | 0) | 0) >>> 3 | 0) + $9 | 0) & $7 | 0;
   $9 = HEAP8[($6 + $11 | 0) >> 0] | 0;
   if (($9 | 0) <= (-1 | 0)) {
    break label$3
   }
   $11 = (__wasm_ctz_i32((HEAP32[$6 >> 2] | 0) & -2139062144 | 0 | 0) | 0) >>> 3 | 0;
   $9 = HEAPU8[($6 + $11 | 0) >> 0] | 0;
  }
  label$4 : {
   $9 = $9 & 1 | 0;
   if (!$9) {
    break label$4
   }
   if (HEAP32[($0 + 8 | 0) >> 2] | 0) {
    break label$4
   }
   hashbrown__raw__RawTable_T_2cA___reserve_rehash__h1afcba29aa7ee604($5 | 0, $0 | 0, 1 | 0, $4 | 0, 1 | 0);
   label$5 : {
    $6 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    $7 = HEAP32[$0 >> 2] | 0;
    $10 = $7 & $8 | 0;
    $15 = $6 + $10 | 0;
    $4 = (HEAPU8[$15 >> 0] | 0 | ((HEAPU8[($15 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($15 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($15 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
    if ($4) {
     break label$5
    }
    $11 = 4;
    label$6 : while (1) {
     $10 = $10 + $11 | 0;
     $11 = $11 + 4 | 0;
     $10 = $10 & $7 | 0;
     $16 = $6 + $10 | 0;
     $4 = (HEAPU8[$16 >> 0] | 0 | ((HEAPU8[($16 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($16 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($16 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & -2139062144 | 0;
     if (!$4) {
      continue label$6
     }
     break label$6;
    };
   }
   $11 = (((__wasm_ctz_i32($4 | 0) | 0) >>> 3 | 0) + $10 | 0) & $7 | 0;
   if ((HEAP8[($6 + $11 | 0) >> 0] | 0 | 0) <= (-1 | 0)) {
    break label$4
   }
   $11 = (__wasm_ctz_i32((HEAP32[$6 >> 2] | 0) & -2139062144 | 0 | 0) | 0) >>> 3 | 0;
  }
  $10 = $8 >>> 25 | 0;
  HEAP8[($6 + $11 | 0) >> 0] = $10;
  HEAP8[(((($11 + -4 | 0) & $7 | 0) + $6 | 0) + 4 | 0) >> 0] = $10;
  HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) - $9 | 0;
  HEAP32[($0 + 12 | 0) >> 2] = (HEAP32[($0 + 12 | 0) >> 2] | 0) + 1 | 0;
  $11 = $6 - ($11 << 3 | 0) | 0;
  $9 = $11 + -8 | 0;
  HEAP32[$9 >> 2] = $2;
  HEAP32[($9 + 4 | 0) >> 2] = $3;
  global$0 = $5 + 16 | 0;
  return $11 | 0;
 }
 
 function $cardano_serialization_lib__address__StakeCredential_20as_20cbor_event__se__Serialize___serialize__h5b8c776cf4ca6024($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, $4 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $25 = 0, $34 = 0, $39 = 0, $44 = 0, $78 = 0, $83 = 0, $88 = 0;
  $3 = global$0 - 64 | 0;
  global$0 = $3;
  i64toi32_i32$0 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 + 16 | 0 | 0, $2 | 0, 4 | 0, 2 | 0, i64toi32_i32$0 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ((HEAP32[($3 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      if ((HEAPU8[$1 >> 0] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      i64toi32_i32$0 = 0;
      cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 + 16 | 0 | 0, $2 | 0, 0 | 0, 0 | 0, i64toi32_i32$0 | 0);
      if ((HEAP32[($3 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$2
      }
      alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($3 + 8 | 0 | 0, 28 | 0, 0 | 0);
      HEAP32[($3 + 20 | 0) >> 2] = HEAP32[($3 + 12 | 0) >> 2] | 0;
      $4 = HEAP32[($3 + 8 | 0) >> 2] | 0;
      HEAP32[($3 + 16 | 0) >> 2] = $4;
      i64toi32_i32$2 = $1;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $34 = i64toi32_i32$0;
      i64toi32_i32$0 = $4;
      $14 = $34;
      HEAP8[i64toi32_i32$0 >> 0] = $14;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $14 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $14 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $14 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      i64toi32_i32$2 = i64toi32_i32$2 + 9 | 0;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $39 = i64toi32_i32$1;
      i64toi32_i32$1 = $4 + 8 | 0;
      $15 = $39;
      HEAP8[i64toi32_i32$1 >> 0] = $15;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $15 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $15 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $15 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      i64toi32_i32$2 = $1 + 17 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $44 = i64toi32_i32$0;
      i64toi32_i32$0 = $4 + 16 | 0;
      $16 = $44;
      HEAP8[i64toi32_i32$0 >> 0] = $16;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $16 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $16 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $16 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      $17 = $1 + 25 | 0;
      $18 = $4 + 24 | 0;
      $19 = HEAPU8[$17 >> 0] | 0 | ((HEAPU8[($17 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($17 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($17 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      HEAP8[$18 >> 0] = $19;
      HEAP8[($18 + 1 | 0) >> 0] = $19 >>> 8 | 0;
      HEAP8[($18 + 2 | 0) >> 0] = $19 >>> 16 | 0;
      HEAP8[($18 + 3 | 0) >> 0] = $19 >>> 24 | 0;
      HEAP32[($3 + 24 | 0) >> 2] = 28;
      cbor_event__se__Serializer_W___write_bytes__h935c22261c9a8184($0 | 0, $2 | 0, $3 + 16 | 0 | 0);
      break label$1;
     }
     memcpy($0 + 8 | 0 | 0, ($3 + 16 | 0) + 8 | 0 | 0, 40 | 0) | 0;
     HEAP32[$0 >> 2] = 1;
     break label$1;
    }
    i64toi32_i32$1 = 0;
    cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 + 16 | 0 | 0, $2 | 0, 0 | 0, 1 | 0, i64toi32_i32$1 | 0);
    label$5 : {
     if ((HEAP32[($3 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$5
     }
     alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($3 | 0, 28 | 0, 0 | 0);
     HEAP32[($3 + 20 | 0) >> 2] = HEAP32[($3 + 4 | 0) >> 2] | 0;
     $4 = HEAP32[$3 >> 2] | 0;
     HEAP32[($3 + 16 | 0) >> 2] = $4;
     i64toi32_i32$2 = $1;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $78 = i64toi32_i32$1;
     i64toi32_i32$1 = $4;
     $20 = $78;
     HEAP8[i64toi32_i32$1 >> 0] = $20;
     HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $20 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $20 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $20 >>> 24 | 0;
     HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
     HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
     i64toi32_i32$2 = i64toi32_i32$2 + 9 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $83 = i64toi32_i32$0;
     i64toi32_i32$0 = $4 + 8 | 0;
     $21 = $83;
     HEAP8[i64toi32_i32$0 >> 0] = $21;
     HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $21 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $21 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $21 >>> 24 | 0;
     HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
     HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
     i64toi32_i32$2 = $1 + 17 | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $88 = i64toi32_i32$1;
     i64toi32_i32$1 = $4 + 16 | 0;
     $22 = $88;
     HEAP8[i64toi32_i32$1 >> 0] = $22;
     HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $22 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $22 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $22 >>> 24 | 0;
     HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
     HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
     $23 = $1 + 25 | 0;
     $24 = $4 + 24 | 0;
     $25 = HEAPU8[$23 >> 0] | 0 | ((HEAPU8[($23 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($23 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($23 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[$24 >> 0] = $25;
     HEAP8[($24 + 1 | 0) >> 0] = $25 >>> 8 | 0;
     HEAP8[($24 + 2 | 0) >> 0] = $25 >>> 16 | 0;
     HEAP8[($24 + 3 | 0) >> 0] = $25 >>> 24 | 0;
     HEAP32[($3 + 24 | 0) >> 2] = 28;
     cbor_event__se__Serializer_W___write_bytes__h935c22261c9a8184($0 | 0, $2 | 0, $3 + 16 | 0 | 0);
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, ($3 + 16 | 0) + 8 | 0 | 0, 40 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, ($3 + 16 | 0) + 8 | 0 | 0, 40 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $3 + 64 | 0;
 }
 
 function alloc__collections__btree__node__BalancingContext_K_2cV___bulk_steal_left__h1d363b549e6145dd($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $6 = 0, $5 = 0, $2 = 0, $3 = 0, $8 = 0, $4 = 0, $7 = 0, $9 = 0, $10 = 0, $11 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if (!$1) {
       break label$4
      }
      $2 = HEAP32[($0 + 24 | 0) >> 2] | 0;
      $3 = HEAPU16[($2 + 50 | 0) >> 1] | 0;
      $4 = $3 + $1 | 0;
      if ($4 >>> 0 > 11 >>> 0) {
       break label$3
      }
      label$5 : {
       label$6 : {
        label$7 : {
         $5 = HEAP32[($0 + 16 | 0) >> 2] | 0;
         $6 = HEAPU16[($5 + 50 | 0) >> 1] | 0;
         if ($6 >>> 0 < $1 >>> 0) {
          break label$7
         }
         $7 = $6 - $1 | 0;
         HEAP16[($5 + 50 | 0) >> 1] = $7;
         HEAP16[($2 + 50 | 0) >> 1] = $4;
         $8 = $2 + 4 | 0;
         $9 = $3 << 2 | 0;
         memmove($8 + ($1 << 2 | 0) | 0 | 0, $8 | 0, $9 | 0) | 0;
         $3 = $7 + 1 | 0;
         $6 = $6 - $3 | 0;
         if (($6 | 0) != ($1 + -1 | 0 | 0)) {
          break label$2
         }
         $10 = $5 + 4 | 0;
         $6 = $6 << 2 | 0;
         memcpy($8 | 0, $10 + ($3 << 2 | 0) | 0 | 0, $6 | 0) | 0;
         $8 = ((HEAP32[($0 + 4 | 0) >> 2] | 0) + ((HEAP32[($0 + 8 | 0) >> 2] | 0) << 2 | 0) | 0) + 4 | 0;
         $11 = HEAP32[$8 >> 2] | 0;
         HEAP32[$8 >> 2] = HEAP32[($10 + ($7 << 2 | 0) | 0) >> 2] | 0;
         HEAP32[(($2 + $6 | 0) + 4 | 0) >> 2] = $11;
         $6 = HEAP32[($0 + 12 | 0) >> 2] | 0;
         if (HEAP32[($0 + 20 | 0) >> 2] | 0) {
          break label$6
         }
         if (!$6) {
          break label$5
         }
         break label$1;
        }
        core__panicking__panic__h2fd385a887c8bf13(1049260 | 0, 39 | 0, 1049300 | 0);
        abort();
       }
       if (!$6) {
        break label$1
       }
       $0 = $2 + 52 | 0;
       $1 = $1 << 2 | 0;
       memmove($0 + $1 | 0 | 0, $0 | 0, $9 + 4 | 0 | 0) | 0;
       memcpy($0 | 0, ($5 + ($3 << 2 | 0) | 0) + 52 | 0 | 0, $1 | 0) | 0;
       $6 = $4 + 1 | 0;
       $1 = 0;
       label$8 : while (1) {
        $5 = HEAP32[$0 >> 2] | 0;
        HEAP16[($5 + 48 | 0) >> 1] = $1;
        HEAP32[$5 >> 2] = $2;
        $0 = $0 + 4 | 0;
        $1 = $1 + 1 | 0;
        if (($6 | 0) != ($1 | 0)) {
         continue label$8
        }
        break label$8;
       };
      }
      return;
     }
     core__panicking__panic__h2fd385a887c8bf13(1049148 | 0, 27 | 0, 1049176 | 0);
     abort();
    }
    core__panicking__panic__h2fd385a887c8bf13(1049192 | 0, 51 | 0, 1049244 | 0);
    abort();
   }
   core__panicking__panic__h2fd385a887c8bf13(1048988 | 0, 40 | 0, 1049028 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1049316 | 0, 40 | 0, 1049356 | 0);
  abort();
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__SerializeEmbeddedGroup_20for_20cardano_serialization_lib__GenesisKeyDelegation___serialize_as_embedded_group__h141b02d2867c596d($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $3 = 0, i64toi32_i32$1 = 0, $4 = 0, $20 = 0, $21 = 0, $5 = 0, $6 = 0, $28 = 0, $35 = 0, $38 = 0, $53 = 0, $57 = 0, $60 = 0, $72 = 0, $77 = 0, $83 = 0, $86 = 0;
  $3 = global$0 - 80 | 0;
  global$0 = $3;
  i64toi32_i32$0 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 5 | 0, i64toi32_i32$0 | 0);
  $4 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
        break label$5
       }
       $4 = ($3 + 48 | 0) + 24 | 0;
       $20 = $1 + 24 | 0;
       HEAP32[$4 >> 2] = HEAPU8[$20 >> 0] | 0 | ((HEAPU8[($20 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($20 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($20 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $5 = ($3 + 48 | 0) + 16 | 0;
       i64toi32_i32$2 = $1 + 16 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $28 = i64toi32_i32$0;
       i64toi32_i32$0 = $5;
       HEAP32[i64toi32_i32$0 >> 2] = $28;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       $6 = ($3 + 48 | 0) + 8 | 0;
       i64toi32_i32$2 = $1 + 8 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $35 = i64toi32_i32$1;
       i64toi32_i32$1 = $6;
       HEAP32[i64toi32_i32$1 >> 2] = $35;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = $1;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $38 = i64toi32_i32$0;
       i64toi32_i32$0 = $3;
       HEAP32[($3 + 48 | 0) >> 2] = $38;
       HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$1;
       cbor_event__se__Serializer_W___write_bytes__h5e3534de30c993f9($3 | 0, $2 | 0, $3 + 48 | 0 | 0);
       if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
        break label$4
       }
       $21 = $1 + 52 | 0;
       HEAP32[$4 >> 2] = HEAPU8[$21 >> 0] | 0 | ((HEAPU8[($21 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($21 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($21 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = $1 + 44 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $53 = i64toi32_i32$1;
       i64toi32_i32$1 = $5;
       HEAP32[i64toi32_i32$1 >> 2] = $53;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = $1 + 36 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $57 = i64toi32_i32$0;
       i64toi32_i32$0 = $6;
       HEAP32[i64toi32_i32$0 >> 2] = $57;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $1;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 28 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 29 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 30 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 31 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 32 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 33 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 34 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 35 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $60 = i64toi32_i32$1;
       i64toi32_i32$1 = $3;
       HEAP32[($3 + 48 | 0) >> 2] = $60;
       HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$0;
       cbor_event__se__Serializer_W___write_bytes__h5e3534de30c993f9($3 | 0, $2 | 0, $3 + 48 | 0 | 0);
       $4 = 1;
       if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
        break label$3
       }
       i64toi32_i32$2 = $1 + 80 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $72 = i64toi32_i32$0;
       i64toi32_i32$0 = $3 + 72 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $72;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $1 + 72 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $77 = i64toi32_i32$1;
       i64toi32_i32$1 = $3 + 64 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $77;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = $1 + 64 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $83 = i64toi32_i32$0;
       i64toi32_i32$0 = ($3 + 48 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $83;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $1;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 56 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 57 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 58 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 59 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 60 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 61 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 62 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 63 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $86 = i64toi32_i32$1;
       i64toi32_i32$1 = $3;
       HEAP32[($3 + 48 | 0) >> 2] = $86;
       HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$0;
       cbor_event__se__Serializer_W___write_bytes__h85f4434ac9a8a060($3 | 0, $2 | 0, $3 + 48 | 0 | 0);
       if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
        break label$2
       }
       HEAP32[($0 + 4 | 0) >> 2] = $2;
       $4 = 0;
       break label$1;
      }
      memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
      break label$1;
     }
     memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
     $4 = 1;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $4 = 1;
  }
  HEAP32[$0 >> 2] = $4;
  global$0 = $3 + 80 | 0;
 }
 
 function hashbrown__map__HashMap_K_2cV_2cS_2cA___insert__h9da49301f604c3c8($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $5 = 0, i64toi32_i32$0 = 0, $3 = 0, $4 = 0, i64toi32_i32$1 = 0, $15 = 0, $8 = 0, $9 = 0, $6 = 0, $7 = 0, $10 = 0, $10$hi = 0, $133 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  i64toi32_i32$0 = hashbrown__map__make_insert_hash__h2055ab7176a1ea97($0 | 0, $1 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  $3 = i64toi32_i32$0;
  $4 = (HEAP32[($0 + 16 | 0) >> 2] | 0) & i64toi32_i32$0 | 0;
  $15 = (HEAP32[($0 + 20 | 0) >> 2] | 0) + $4 | 0;
  $5 = HEAPU8[$15 >> 0] | 0 | ((HEAPU8[($15 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($15 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($15 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $6 = 0;
  $7 = ($2 + 56 | 0) + 8 | 0;
  HEAP32[$7 >> 2] = 0;
  HEAP32[($2 + 68 | 0) >> 2] = $5;
  HEAP32[($2 + 60 | 0) >> 2] = $4;
  $4 = $0 + 16 | 0;
  HEAP32[($2 + 56 | 0) >> 2] = $4;
  $3 = i64toi32_i32$0 >>> 25 | 0;
  HEAP8[($2 + 76 | 0) >> 0] = $3;
  $5 = $5 ^ Math_imul($3, 16843009) | 0;
  HEAP32[($2 + 72 | 0) >> 2] = (($5 ^ -1 | 0) & ($5 + -16843009 | 0) | 0) & -2139062144 | 0;
  $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($2 + 48 | 0 | 0, $2 + 56 | 0 | 0);
  label$1 : {
   label$2 : {
    if (!(HEAP32[($2 + 48 | 0) >> 2] | 0)) {
     break label$2
    }
    $5 = HEAP32[($2 + 52 | 0) >> 2] | 0;
    $3 = HEAP32[((HEAP32[($2 + 56 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 40 | 0 | 0, $1 | 0);
    $8 = HEAP32[($2 + 44 | 0) >> 2] | 0;
    $9 = HEAP32[($2 + 40 | 0) >> 2] | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 32 | 0 | 0, ($3 + Math_imul(0 - $5 | 0, 12) | 0) + -12 | 0 | 0);
    label$3 : {
     if (core__slice__cmp___impl_20core__cmp__PartialEq__5bB_5d__20for_20_5bA_5d___eq__hc3de93b036fcc30b($9 | 0, $8 | 0, HEAP32[($2 + 32 | 0) >> 2] | 0 | 0, HEAP32[($2 + 36 | 0) >> 2] | 0 | 0) | 0) {
      break label$3
     }
     label$4 : while (1) {
      $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($2 + 24 | 0 | 0, $2 + 56 | 0 | 0);
      if (!(HEAP32[($2 + 24 | 0) >> 2] | 0)) {
       break label$2
      }
      $5 = HEAP32[($2 + 28 | 0) >> 2] | 0;
      $3 = HEAP32[((HEAP32[($2 + 56 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 16 | 0 | 0, $1 | 0);
      $8 = HEAP32[($2 + 20 | 0) >> 2] | 0;
      $9 = HEAP32[($2 + 16 | 0) >> 2] | 0;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, ($3 + Math_imul(0 - $5 | 0, 12) | 0) + -12 | 0 | 0);
      if (!(core__slice__cmp___impl_20core__cmp__PartialEq__5bB_5d__20for_20_5bA_5d___eq__hc3de93b036fcc30b($9 | 0, $8 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0) | 0)) {
       continue label$4
      }
      break label$4;
     };
    }
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
    $6 = 1;
    break label$1;
   }
   HEAP32[$7 >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   $133 = i64toi32_i32$1;
   i64toi32_i32$1 = $2;
   HEAP32[($2 + 56 | 0) >> 2] = $133;
   HEAP32[($2 + 60 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $10$hi;
   hashbrown__raw__RawTable_T_2cA___insert__h017d09d046b49d80($4 | 0, $10 | 0, i64toi32_i32$0 | 0, $2 + 56 | 0 | 0, $0 | 0) | 0;
  }
  global$0 = $2 + 80 | 0;
  return $6 | 0;
 }
 
 function cardano_serialization_lib__chain_crypto__bech32__try_from_bech32_to_bytes__h34c47fd00c9fc177($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $4 = 0, $4$hi = 0, $5 = 0, $5$hi = 0, $62 = 0, $94 = 0, $104 = 0;
  $3 = global$0 - 96 | 0;
  global$0 = $3;
  bech32__decode__h25859b35256032dd($3 + 64 | 0 | 0, $1 | 0, $2 | 0);
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[($3 + 68 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($3 + 72 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[($3 + 64 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     $1 = HEAP32[(($3 + 64 | 0) + 24 | 0) >> 2] | 0;
     HEAP32[(($3 + 48 | 0) + 8 | 0) >> 2] = $1;
     i64toi32_i32$2 = ($3 + 64 | 0) + 16 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $5 = i64toi32_i32$1;
     $5$hi = i64toi32_i32$0;
     i64toi32_i32$1 = $3;
     HEAP32[($3 + 48 | 0) >> 2] = $5;
     HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($3 + 24 | 0) >> 2] = HEAP32[(($3 + 64 | 0) + 12 | 0) >> 2] | 0;
     i64toi32_i32$0 = $4$hi;
     i64toi32_i32$1 = $3;
     HEAP32[($3 + 16 | 0) >> 2] = $4;
     HEAP32[($3 + 20 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[(($3 + 32 | 0) + 8 | 0) >> 2] = $1;
     i64toi32_i32$0 = $5$hi;
     i64toi32_i32$1 = $3;
     HEAP32[($3 + 32 | 0) >> 2] = $5;
     HEAP32[($3 + 36 | 0) >> 2] = i64toi32_i32$0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $3 + 16 | 0 | 0);
     if (core__slice__cmp___impl_20core__cmp__PartialEq__5bB_5d__20for_20_5bA_5d___eq__hc3de93b036fcc30b(HEAP32[($3 + 8 | 0) >> 2] | 0 | 0, HEAP32[($3 + 12 | 0) >> 2] | 0 | 0, 1056389 | 0, 4 | 0) | 0) {
      break label$2
     }
     i64toi32_i32$1 = $0;
     i64toi32_i32$0 = 1;
     HEAP32[i64toi32_i32$1 >> 2] = 1;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = 4;
     HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = 1056389;
     i64toi32_i32$2 = $3;
     i64toi32_i32$0 = HEAP32[($3 + 16 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($3 + 20 | 0) >> 2] | 0;
     $62 = i64toi32_i32$0;
     i64toi32_i32$0 = $0 + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $62;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($0 + 24 | 0) >> 2] = HEAP32[(($3 + 16 | 0) + 8 | 0) >> 2] | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc91437b7d7fa2d3a($3 + 32 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h899e85abb4c3d85f($3 + 32 | 0 | 0);
     break label$1;
    }
    i64toi32_i32$0 = $0;
    i64toi32_i32$1 = 0;
    HEAP32[i64toi32_i32$0 >> 2] = 1;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $4$hi;
    i64toi32_i32$0 = i64toi32_i32$0 + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $4;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    break label$1;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__heed2de4899f9d51c($3 | 0, $3 + 32 | 0 | 0);
   $alloc__vec__Vec_u8__20as_20bech32__FromBase32___from_base32__h6e67b5484009b518($3 + 64 | 0 | 0, HEAP32[$3 >> 2] | 0 | 0, HEAP32[($3 + 4 | 0) >> 2] | 0 | 0);
   $1 = 1;
   label$4 : {
    label$5 : {
     if ((HEAP32[($3 + 64 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$5
     }
     $1 = $3 + 64 | 0 | 4 | 0;
     i64toi32_i32$2 = $1;
     i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $94 = i64toi32_i32$1;
     i64toi32_i32$1 = $0;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $94;
     HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
     $1 = 0;
     break label$4;
    }
    HEAP32[($0 + 4 | 0) >> 2] = 0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAP32[($3 + 68 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($3 + 72 | 0) >> 2] | 0;
    $104 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $104;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   }
   HEAP32[$0 >> 2] = $1;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc91437b7d7fa2d3a($3 + 32 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h899e85abb4c3d85f($3 + 32 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 16 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 16 | 0 | 0);
  }
  global$0 = $3 + 96 | 0;
 }
 
 function cardano_serialization_lib__chain_crypto__bech32__try_from_bech32_to_bytes__h3f2ab2a8146239be($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $4 = 0, $4$hi = 0, $5 = 0, $5$hi = 0, $62 = 0, $94 = 0, $104 = 0;
  $3 = global$0 - 96 | 0;
  global$0 = $3;
  bech32__decode__h25859b35256032dd($3 + 64 | 0 | 0, $1 | 0, $2 | 0);
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[($3 + 68 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($3 + 72 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[($3 + 64 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     $1 = HEAP32[(($3 + 64 | 0) + 24 | 0) >> 2] | 0;
     HEAP32[(($3 + 48 | 0) + 8 | 0) >> 2] = $1;
     i64toi32_i32$2 = ($3 + 64 | 0) + 16 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $5 = i64toi32_i32$1;
     $5$hi = i64toi32_i32$0;
     i64toi32_i32$1 = $3;
     HEAP32[($3 + 48 | 0) >> 2] = $5;
     HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($3 + 24 | 0) >> 2] = HEAP32[(($3 + 64 | 0) + 12 | 0) >> 2] | 0;
     i64toi32_i32$0 = $4$hi;
     i64toi32_i32$1 = $3;
     HEAP32[($3 + 16 | 0) >> 2] = $4;
     HEAP32[($3 + 20 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[(($3 + 32 | 0) + 8 | 0) >> 2] = $1;
     i64toi32_i32$0 = $5$hi;
     i64toi32_i32$1 = $3;
     HEAP32[($3 + 32 | 0) >> 2] = $5;
     HEAP32[($3 + 36 | 0) >> 2] = i64toi32_i32$0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $3 + 16 | 0 | 0);
     if (core__slice__cmp___impl_20core__cmp__PartialEq__5bB_5d__20for_20_5bA_5d___eq__hc3de93b036fcc30b(HEAP32[($3 + 8 | 0) >> 2] | 0 | 0, HEAP32[($3 + 12 | 0) >> 2] | 0 | 0, 1056368 | 0, 11 | 0) | 0) {
      break label$2
     }
     i64toi32_i32$1 = $0;
     i64toi32_i32$0 = 1;
     HEAP32[i64toi32_i32$1 >> 2] = 1;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = 11;
     HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = 1056368;
     i64toi32_i32$2 = $3;
     i64toi32_i32$0 = HEAP32[($3 + 16 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($3 + 20 | 0) >> 2] | 0;
     $62 = i64toi32_i32$0;
     i64toi32_i32$0 = $0 + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $62;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($0 + 24 | 0) >> 2] = HEAP32[(($3 + 16 | 0) + 8 | 0) >> 2] | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc91437b7d7fa2d3a($3 + 32 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h899e85abb4c3d85f($3 + 32 | 0 | 0);
     break label$1;
    }
    i64toi32_i32$0 = $0;
    i64toi32_i32$1 = 0;
    HEAP32[i64toi32_i32$0 >> 2] = 1;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $4$hi;
    i64toi32_i32$0 = i64toi32_i32$0 + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $4;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    break label$1;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__heed2de4899f9d51c($3 | 0, $3 + 32 | 0 | 0);
   $alloc__vec__Vec_u8__20as_20bech32__FromBase32___from_base32__h6e67b5484009b518($3 + 64 | 0 | 0, HEAP32[$3 >> 2] | 0 | 0, HEAP32[($3 + 4 | 0) >> 2] | 0 | 0);
   $1 = 1;
   label$4 : {
    label$5 : {
     if ((HEAP32[($3 + 64 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$5
     }
     $1 = $3 + 64 | 0 | 4 | 0;
     i64toi32_i32$2 = $1;
     i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $94 = i64toi32_i32$1;
     i64toi32_i32$1 = $0;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $94;
     HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
     $1 = 0;
     break label$4;
    }
    HEAP32[($0 + 4 | 0) >> 2] = 0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAP32[($3 + 68 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($3 + 72 | 0) >> 2] | 0;
    $104 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $104;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   }
   HEAP32[$0 >> 2] = $1;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc91437b7d7fa2d3a($3 + 32 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h899e85abb4c3d85f($3 + 32 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 16 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 16 | 0 | 0);
  }
  global$0 = $3 + 96 | 0;
 }
 
 function cardano_serialization_lib__chain_crypto__bech32__try_from_bech32_to_bytes__h77d64bec4bd5ad33($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $4 = 0, $4$hi = 0, $5 = 0, $5$hi = 0, $62 = 0, $94 = 0, $104 = 0;
  $3 = global$0 - 96 | 0;
  global$0 = $3;
  bech32__decode__h25859b35256032dd($3 + 64 | 0 | 0, $1 | 0, $2 | 0);
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[($3 + 68 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($3 + 72 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[($3 + 64 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     $1 = HEAP32[(($3 + 64 | 0) + 24 | 0) >> 2] | 0;
     HEAP32[(($3 + 48 | 0) + 8 | 0) >> 2] = $1;
     i64toi32_i32$2 = ($3 + 64 | 0) + 16 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $5 = i64toi32_i32$1;
     $5$hi = i64toi32_i32$0;
     i64toi32_i32$1 = $3;
     HEAP32[($3 + 48 | 0) >> 2] = $5;
     HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($3 + 24 | 0) >> 2] = HEAP32[(($3 + 64 | 0) + 12 | 0) >> 2] | 0;
     i64toi32_i32$0 = $4$hi;
     i64toi32_i32$1 = $3;
     HEAP32[($3 + 16 | 0) >> 2] = $4;
     HEAP32[($3 + 20 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[(($3 + 32 | 0) + 8 | 0) >> 2] = $1;
     i64toi32_i32$0 = $5$hi;
     i64toi32_i32$1 = $3;
     HEAP32[($3 + 32 | 0) >> 2] = $5;
     HEAP32[($3 + 36 | 0) >> 2] = i64toi32_i32$0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $3 + 16 | 0 | 0);
     if (core__slice__cmp___impl_20core__cmp__PartialEq__5bB_5d__20for_20_5bA_5d___eq__hc3de93b036fcc30b(HEAP32[($3 + 8 | 0) >> 2] | 0 | 0, HEAP32[($3 + 12 | 0) >> 2] | 0 | 0, 1056408 | 0, 10 | 0) | 0) {
      break label$2
     }
     i64toi32_i32$1 = $0;
     i64toi32_i32$0 = 1;
     HEAP32[i64toi32_i32$1 >> 2] = 1;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = 10;
     HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = 1056408;
     i64toi32_i32$2 = $3;
     i64toi32_i32$0 = HEAP32[($3 + 16 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($3 + 20 | 0) >> 2] | 0;
     $62 = i64toi32_i32$0;
     i64toi32_i32$0 = $0 + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $62;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($0 + 24 | 0) >> 2] = HEAP32[(($3 + 16 | 0) + 8 | 0) >> 2] | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc91437b7d7fa2d3a($3 + 32 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h899e85abb4c3d85f($3 + 32 | 0 | 0);
     break label$1;
    }
    i64toi32_i32$0 = $0;
    i64toi32_i32$1 = 0;
    HEAP32[i64toi32_i32$0 >> 2] = 1;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $4$hi;
    i64toi32_i32$0 = i64toi32_i32$0 + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $4;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    break label$1;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__heed2de4899f9d51c($3 | 0, $3 + 32 | 0 | 0);
   $alloc__vec__Vec_u8__20as_20bech32__FromBase32___from_base32__h6e67b5484009b518($3 + 64 | 0 | 0, HEAP32[$3 >> 2] | 0 | 0, HEAP32[($3 + 4 | 0) >> 2] | 0 | 0);
   $1 = 1;
   label$4 : {
    label$5 : {
     if ((HEAP32[($3 + 64 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$5
     }
     $1 = $3 + 64 | 0 | 4 | 0;
     i64toi32_i32$2 = $1;
     i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $94 = i64toi32_i32$1;
     i64toi32_i32$1 = $0;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $94;
     HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
     $1 = 0;
     break label$4;
    }
    HEAP32[($0 + 4 | 0) >> 2] = 0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAP32[($3 + 68 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($3 + 72 | 0) >> 2] | 0;
    $104 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $104;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   }
   HEAP32[$0 >> 2] = $1;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc91437b7d7fa2d3a($3 + 32 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h899e85abb4c3d85f($3 + 32 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 16 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 16 | 0 | 0);
  }
  global$0 = $3 + 96 | 0;
 }
 
 function cardano_serialization_lib__chain_crypto__bech32__try_from_bech32_to_bytes__h872d08116783f519($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $4 = 0, $4$hi = 0, $5 = 0, $5$hi = 0, $62 = 0, $94 = 0, $104 = 0;
  $3 = global$0 - 96 | 0;
  global$0 = $3;
  bech32__decode__h25859b35256032dd($3 + 64 | 0 | 0, $1 | 0, $2 | 0);
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[($3 + 68 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($3 + 72 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[($3 + 64 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     $1 = HEAP32[(($3 + 64 | 0) + 24 | 0) >> 2] | 0;
     HEAP32[(($3 + 48 | 0) + 8 | 0) >> 2] = $1;
     i64toi32_i32$2 = ($3 + 64 | 0) + 16 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $5 = i64toi32_i32$1;
     $5$hi = i64toi32_i32$0;
     i64toi32_i32$1 = $3;
     HEAP32[($3 + 48 | 0) >> 2] = $5;
     HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($3 + 24 | 0) >> 2] = HEAP32[(($3 + 64 | 0) + 12 | 0) >> 2] | 0;
     i64toi32_i32$0 = $4$hi;
     i64toi32_i32$1 = $3;
     HEAP32[($3 + 16 | 0) >> 2] = $4;
     HEAP32[($3 + 20 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[(($3 + 32 | 0) + 8 | 0) >> 2] = $1;
     i64toi32_i32$0 = $5$hi;
     i64toi32_i32$1 = $3;
     HEAP32[($3 + 32 | 0) >> 2] = $5;
     HEAP32[($3 + 36 | 0) >> 2] = i64toi32_i32$0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $3 + 16 | 0 | 0);
     if (core__slice__cmp___impl_20core__cmp__PartialEq__5bB_5d__20for_20_5bA_5d___eq__hc3de93b036fcc30b(HEAP32[($3 + 8 | 0) >> 2] | 0 | 0, HEAP32[($3 + 12 | 0) >> 2] | 0 | 0, 1056393 | 0, 4 | 0) | 0) {
      break label$2
     }
     i64toi32_i32$1 = $0;
     i64toi32_i32$0 = 1;
     HEAP32[i64toi32_i32$1 >> 2] = 1;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = 4;
     HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = 1056393;
     i64toi32_i32$2 = $3;
     i64toi32_i32$0 = HEAP32[($3 + 16 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($3 + 20 | 0) >> 2] | 0;
     $62 = i64toi32_i32$0;
     i64toi32_i32$0 = $0 + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $62;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($0 + 24 | 0) >> 2] = HEAP32[(($3 + 16 | 0) + 8 | 0) >> 2] | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc91437b7d7fa2d3a($3 + 32 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h899e85abb4c3d85f($3 + 32 | 0 | 0);
     break label$1;
    }
    i64toi32_i32$0 = $0;
    i64toi32_i32$1 = 0;
    HEAP32[i64toi32_i32$0 >> 2] = 1;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $4$hi;
    i64toi32_i32$0 = i64toi32_i32$0 + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $4;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    break label$1;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__heed2de4899f9d51c($3 | 0, $3 + 32 | 0 | 0);
   $alloc__vec__Vec_u8__20as_20bech32__FromBase32___from_base32__h6e67b5484009b518($3 + 64 | 0 | 0, HEAP32[$3 >> 2] | 0 | 0, HEAP32[($3 + 4 | 0) >> 2] | 0 | 0);
   $1 = 1;
   label$4 : {
    label$5 : {
     if ((HEAP32[($3 + 64 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$5
     }
     $1 = $3 + 64 | 0 | 4 | 0;
     i64toi32_i32$2 = $1;
     i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $94 = i64toi32_i32$1;
     i64toi32_i32$1 = $0;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $94;
     HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
     $1 = 0;
     break label$4;
    }
    HEAP32[($0 + 4 | 0) >> 2] = 0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAP32[($3 + 68 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($3 + 72 | 0) >> 2] | 0;
    $104 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $104;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   }
   HEAP32[$0 >> 2] = $1;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc91437b7d7fa2d3a($3 + 32 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h899e85abb4c3d85f($3 + 32 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 16 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 16 | 0 | 0);
  }
  global$0 = $3 + 96 | 0;
 }
 
 function cardano_serialization_lib__chain_crypto__bech32__try_from_bech32_to_bytes__hac874eaf9db9a288($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $4 = 0, $4$hi = 0, $5 = 0, $5$hi = 0, $62 = 0, $94 = 0, $104 = 0;
  $3 = global$0 - 96 | 0;
  global$0 = $3;
  bech32__decode__h25859b35256032dd($3 + 64 | 0 | 0, $1 | 0, $2 | 0);
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[($3 + 68 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($3 + 72 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[($3 + 64 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     $1 = HEAP32[(($3 + 64 | 0) + 24 | 0) >> 2] | 0;
     HEAP32[(($3 + 48 | 0) + 8 | 0) >> 2] = $1;
     i64toi32_i32$2 = ($3 + 64 | 0) + 16 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $5 = i64toi32_i32$1;
     $5$hi = i64toi32_i32$0;
     i64toi32_i32$1 = $3;
     HEAP32[($3 + 48 | 0) >> 2] = $5;
     HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($3 + 24 | 0) >> 2] = HEAP32[(($3 + 64 | 0) + 12 | 0) >> 2] | 0;
     i64toi32_i32$0 = $4$hi;
     i64toi32_i32$1 = $3;
     HEAP32[($3 + 16 | 0) >> 2] = $4;
     HEAP32[($3 + 20 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[(($3 + 32 | 0) + 8 | 0) >> 2] = $1;
     i64toi32_i32$0 = $5$hi;
     i64toi32_i32$1 = $3;
     HEAP32[($3 + 32 | 0) >> 2] = $5;
     HEAP32[($3 + 36 | 0) >> 2] = i64toi32_i32$0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $3 + 16 | 0 | 0);
     if (core__slice__cmp___impl_20core__cmp__PartialEq__5bB_5d__20for_20_5bA_5d___eq__hc3de93b036fcc30b(HEAP32[($3 + 8 | 0) >> 2] | 0 | 0, HEAP32[($3 + 12 | 0) >> 2] | 0 | 0, 1056397 | 0, 11 | 0) | 0) {
      break label$2
     }
     i64toi32_i32$1 = $0;
     i64toi32_i32$0 = 1;
     HEAP32[i64toi32_i32$1 >> 2] = 1;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = 11;
     HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = 1056397;
     i64toi32_i32$2 = $3;
     i64toi32_i32$0 = HEAP32[($3 + 16 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($3 + 20 | 0) >> 2] | 0;
     $62 = i64toi32_i32$0;
     i64toi32_i32$0 = $0 + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $62;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($0 + 24 | 0) >> 2] = HEAP32[(($3 + 16 | 0) + 8 | 0) >> 2] | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc91437b7d7fa2d3a($3 + 32 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h899e85abb4c3d85f($3 + 32 | 0 | 0);
     break label$1;
    }
    i64toi32_i32$0 = $0;
    i64toi32_i32$1 = 0;
    HEAP32[i64toi32_i32$0 >> 2] = 1;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $4$hi;
    i64toi32_i32$0 = i64toi32_i32$0 + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $4;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    break label$1;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__heed2de4899f9d51c($3 | 0, $3 + 32 | 0 | 0);
   $alloc__vec__Vec_u8__20as_20bech32__FromBase32___from_base32__h6e67b5484009b518($3 + 64 | 0 | 0, HEAP32[$3 >> 2] | 0 | 0, HEAP32[($3 + 4 | 0) >> 2] | 0 | 0);
   $1 = 1;
   label$4 : {
    label$5 : {
     if ((HEAP32[($3 + 64 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$5
     }
     $1 = $3 + 64 | 0 | 4 | 0;
     i64toi32_i32$2 = $1;
     i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $94 = i64toi32_i32$1;
     i64toi32_i32$1 = $0;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $94;
     HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
     $1 = 0;
     break label$4;
    }
    HEAP32[($0 + 4 | 0) >> 2] = 0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAP32[($3 + 68 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($3 + 72 | 0) >> 2] | 0;
    $104 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $104;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   }
   HEAP32[$0 >> 2] = $1;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc91437b7d7fa2d3a($3 + 32 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h899e85abb4c3d85f($3 + 32 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 16 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 16 | 0 | 0);
  }
  global$0 = $3 + 96 | 0;
 }
 
 function cardano_serialization_lib__chain_crypto__bech32__try_from_bech32_to_bytes__hc722a9189251e96f($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $4 = 0, $4$hi = 0, $5 = 0, $5$hi = 0, $62 = 0, $94 = 0, $104 = 0;
  $3 = global$0 - 96 | 0;
  global$0 = $3;
  bech32__decode__h25859b35256032dd($3 + 64 | 0 | 0, $1 | 0, $2 | 0);
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[($3 + 68 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($3 + 72 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[($3 + 64 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     $1 = HEAP32[(($3 + 64 | 0) + 24 | 0) >> 2] | 0;
     HEAP32[(($3 + 48 | 0) + 8 | 0) >> 2] = $1;
     i64toi32_i32$2 = ($3 + 64 | 0) + 16 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $5 = i64toi32_i32$1;
     $5$hi = i64toi32_i32$0;
     i64toi32_i32$1 = $3;
     HEAP32[($3 + 48 | 0) >> 2] = $5;
     HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($3 + 24 | 0) >> 2] = HEAP32[(($3 + 64 | 0) + 12 | 0) >> 2] | 0;
     i64toi32_i32$0 = $4$hi;
     i64toi32_i32$1 = $3;
     HEAP32[($3 + 16 | 0) >> 2] = $4;
     HEAP32[($3 + 20 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[(($3 + 32 | 0) + 8 | 0) >> 2] = $1;
     i64toi32_i32$0 = $5$hi;
     i64toi32_i32$1 = $3;
     HEAP32[($3 + 32 | 0) >> 2] = $5;
     HEAP32[($3 + 36 | 0) >> 2] = i64toi32_i32$0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $3 + 16 | 0 | 0);
     if (core__slice__cmp___impl_20core__cmp__PartialEq__5bB_5d__20for_20_5bA_5d___eq__hc3de93b036fcc30b(HEAP32[($3 + 8 | 0) >> 2] | 0 | 0, HEAP32[($3 + 12 | 0) >> 2] | 0 | 0, 1056379 | 0, 10 | 0) | 0) {
      break label$2
     }
     i64toi32_i32$1 = $0;
     i64toi32_i32$0 = 1;
     HEAP32[i64toi32_i32$1 >> 2] = 1;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = 10;
     HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = 1056379;
     i64toi32_i32$2 = $3;
     i64toi32_i32$0 = HEAP32[($3 + 16 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($3 + 20 | 0) >> 2] | 0;
     $62 = i64toi32_i32$0;
     i64toi32_i32$0 = $0 + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $62;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($0 + 24 | 0) >> 2] = HEAP32[(($3 + 16 | 0) + 8 | 0) >> 2] | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc91437b7d7fa2d3a($3 + 32 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h899e85abb4c3d85f($3 + 32 | 0 | 0);
     break label$1;
    }
    i64toi32_i32$0 = $0;
    i64toi32_i32$1 = 0;
    HEAP32[i64toi32_i32$0 >> 2] = 1;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $4$hi;
    i64toi32_i32$0 = i64toi32_i32$0 + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $4;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    break label$1;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__heed2de4899f9d51c($3 | 0, $3 + 32 | 0 | 0);
   $alloc__vec__Vec_u8__20as_20bech32__FromBase32___from_base32__h6e67b5484009b518($3 + 64 | 0 | 0, HEAP32[$3 >> 2] | 0 | 0, HEAP32[($3 + 4 | 0) >> 2] | 0 | 0);
   $1 = 1;
   label$4 : {
    label$5 : {
     if ((HEAP32[($3 + 64 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$5
     }
     $1 = $3 + 64 | 0 | 4 | 0;
     i64toi32_i32$2 = $1;
     i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $94 = i64toi32_i32$1;
     i64toi32_i32$1 = $0;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $94;
     HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
     $1 = 0;
     break label$4;
    }
    HEAP32[($0 + 4 | 0) >> 2] = 0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAP32[($3 + 68 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($3 + 72 | 0) >> 2] | 0;
    $104 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $104;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   }
   HEAP32[$0 >> 2] = $1;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc91437b7d7fa2d3a($3 + 32 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h899e85abb4c3d85f($3 + 32 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 16 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 16 | 0 | 0);
  }
  global$0 = $3 + 96 | 0;
 }
 
 function alloc__vec__Vec_T_2cA___retain__h41a06215048992f1($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $12 = 0, $3 = 0, $13 = 0, $5 = 0, $4 = 0, $7 = 0, $9 = 0, $11 = 0, $6 = 0, $14 = 0, $8 = 0, $10 = 0, i64toi32_i32$1 = 0;
  $3 = global$0 - 32 | 0;
  global$0 = $3;
  $4 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  $5 = 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  label$1 : {
   if (!$4) {
    break label$1
   }
   $6 = HEAP32[$2 >> 2] | 0;
   $7 = HEAP32[$0 >> 2] | 0;
   $8 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   $9 = $3 + 16 | 0 | 4 | 0;
   $10 = HEAP32[$1 >> 2] | 0;
   $11 = 0;
   $5 = 0;
   $12 = 0;
   label$2 : {
    label$3 : while (1) {
     $1 = $7 + ($12 << 2 | 0) | 0;
     $2 = $7 + (($12 + $11 | 0) << 2 | 0) | 0;
     $13 = $12;
     label$4 : {
      label$5 : {
       label$6 : while (1) {
        $14 = HEAP32[($6 + 8 | 0) >> 2] | 0;
        $12 = HEAP32[$1 >> 2] | 0;
        if ($14 >>> 0 <= $12 >>> 0) {
         break label$5
        }
        $12 = (HEAP32[$6 >> 2] | 0) + Math_imul($12, 168) | 0;
        if ((HEAP32[($12 + 72 | 0) >> 2] | 0 | 0) != (1 | 0)) {
         break label$4
        }
        cardano_serialization_lib__MultiAsset__get__had0c36a2c855d776($3 + 16 | 0 | 0, $12 + 76 | 0 | 0, HEAP32[$10 >> 2] | 0 | 0);
        if ((HEAP32[($3 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
         break label$4
        }
        HEAP32[($3 + 8 | 0) >> 2] = HEAP32[($9 + 8 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($9 + 4 | 0) >> 2] | 0;
        HEAP32[$3 >> 2] = HEAP32[$9 >> 2] | 0;
        HEAP32[($3 + 4 | 0) >> 2] = i64toi32_i32$1;
        $12 = alloc__collections__btree__map__BTreeMap_K_2cV___get__h825f34112f7eacbf($3 | 0, HEAP32[$8 >> 2] | 0 | 0) | 0;
        $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h6c9f94f0f82ce2b5($3 | 0);
        if (!$12) {
         break label$4
        }
        label$7 : {
         if (!$5) {
          break label$7
         }
         HEAP32[$2 >> 2] = HEAP32[$1 >> 2] | 0;
        }
        $1 = $1 + 4 | 0;
        $2 = $2 + 4 | 0;
        $13 = $13 + 1 | 0;
        if ($4 >>> 0 > $13 >>> 0) {
         continue label$6
        }
        break label$2;
       };
      }
      core__panicking__panic_bounds_check__h808b524af17640b1($12 | 0, $14 | 0, 1068076 | 0);
      abort();
     }
     $11 = $11 + -1 | 0;
     $5 = $5 + 1 | 0;
     $12 = $13 + 1 | 0;
     if ($4 >>> 0 > $12 >>> 0) {
      continue label$3
     }
     break label$3;
    };
    $13 = $13 + 1 | 0;
   }
   label$8 : {
    if ($5) {
     break label$8
    }
    $5 = 0;
    break label$1;
   }
   memmove($7 + (($13 - $5 | 0) << 2 | 0) | 0 | 0, $7 + ($13 << 2 | 0) | 0 | 0, ($4 - $13 | 0) << 2 | 0 | 0) | 0;
  }
  HEAP32[($0 + 8 | 0) >> 2] = $4 - $5 | 0;
  global$0 = $3 + 32 | 0;
 }
 
 function cardano_serialization_lib__metadata__MetadataMap__insert__hd93cf89dc2674a42($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $27 = 0, $33 = 0, $70 = 0, $76 = 0;
  $4 = global$0 - 144 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    switch (HEAP32[$2 >> 2] | 0 | 0) {
    default:
     $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__hdeea20968268d729(($4 + 96 | 0) + 8 | 0 | 0, $2 + 8 | 0 | 0);
     HEAP32[($4 + 96 | 0) >> 2] = 0;
     break label$1;
    case 1:
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hf69db734dd831996($4 + 96 | 0 | 4 | 0 | 0, $2 + 4 | 0 | 0);
     HEAP32[($4 + 96 | 0) >> 2] = 1;
     break label$1;
    case 2:
     i64toi32_i32$2 = $2 + 16 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $27 = i64toi32_i32$0;
     i64toi32_i32$0 = ($4 + 96 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $27;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $2 + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $33 = i64toi32_i32$1;
     i64toi32_i32$1 = ($4 + 96 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $33;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($4 + 96 | 0) >> 2] = 2;
     break label$1;
    case 3:
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($4 + 96 | 0 | 4 | 0 | 0, $2 + 4 | 0 | 0);
     HEAP32[($4 + 96 | 0) >> 2] = 3;
     break label$1;
    case 4:
     break label$2;
    };
   }
   $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($4 + 96 | 0 | 4 | 0 | 0, $2 + 4 | 0 | 0);
   HEAP32[($4 + 96 | 0) >> 2] = 4;
  }
  $4 = memcpy($4 | 0, $4 + 96 | 0 | 0, 48 | 0) | 0;
  label$7 : {
   label$8 : {
    switch (HEAP32[$3 >> 2] | 0 | 0) {
    default:
     $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__hdeea20968268d729(($4 + 96 | 0) + 8 | 0 | 0, $3 + 8 | 0 | 0);
     HEAP32[($4 + 96 | 0) >> 2] = 0;
     break label$7;
    case 1:
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hf69db734dd831996($4 + 96 | 0 | 4 | 0 | 0, $3 + 4 | 0 | 0);
     HEAP32[($4 + 96 | 0) >> 2] = 1;
     break label$7;
    case 2:
     i64toi32_i32$2 = $3 + 16 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $70 = i64toi32_i32$0;
     i64toi32_i32$0 = ($4 + 96 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $70;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $3 + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $76 = i64toi32_i32$1;
     i64toi32_i32$1 = ($4 + 96 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $76;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($4 + 96 | 0) >> 2] = 2;
     break label$7;
    case 3:
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($4 + 96 | 0 | 4 | 0 | 0, $3 + 4 | 0 | 0);
     HEAP32[($4 + 96 | 0) >> 2] = 3;
     break label$7;
    case 4:
     break label$8;
    };
   }
   $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($4 + 96 | 0 | 4 | 0 | 0, $3 + 4 | 0 | 0);
   HEAP32[($4 + 96 | 0) >> 2] = 4;
  }
  memcpy($4 + 48 | 0 | 0, $4 + 96 | 0 | 0, 48 | 0) | 0;
  linked_hash_map__LinkedHashMap_K_2cV_2cS___insert__heab3194aa02f42f0($0 | 0, $1 | 0, $4 | 0, $4 + 48 | 0 | 0);
  global$0 = $4 + 144 | 0;
 }
 
 function getrandom__imp__RNG_SOURCE____init__hed786a00ff5c948f($0) {
  $0 = $0 | 0;
  var $3 = 0, $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $2 = 0, $1 = 0, $5 = 0, $6 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         $2 = $T_20as_20core__convert__Into_U____into__ha09bc77f1ba4d1d1($T_20as_20core__convert__Into_U____into__ha09bc77f1ba4d1d1(js_sys__global__hd98d5758cd3589c0() | 0 | 0) | 0 | 0) | 0;
         $3 = $T_20as_20core__convert__Into_U____into__ha09bc77f1ba4d1d1(getrandom__imp__Global__process____wbg_process_2f24d6544ea7b200__hf9233875d912cc2e($2 | 0) | 0 | 0) | 0;
         if ((wasm_bindgen____wbindgen_is_object__he91ec6fcc6bd8d2d($3 | 0) | 0 | 0) != (1 | 0)) {
          break label$7
         }
         $4 = $T_20as_20core__convert__Into_U____into__ha09bc77f1ba4d1d1(getrandom__imp__Process__versions____wbg_versions_6164651e75405d4a__h5d40cbd4a8a1f87e($3 | 0) | 0 | 0) | 0;
         if ((wasm_bindgen____wbindgen_is_object__he91ec6fcc6bd8d2d($4 | 0) | 0 | 0) == (1 | 0)) {
          break label$6
         }
         if ($4 >>> 0 < 36 >>> 0) {
          break label$7
         }
         wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($4 | 0);
        }
        if ($3 >>> 0 < 36 >>> 0) {
         break label$5
        }
        wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($3 | 0);
        break label$5;
       }
       $5 = getrandom__imp__Versions__node____wbg_node_4b517d861cbcb3bc__hf2838fd3d35618a9($4 | 0) | 0;
       $6 = wasm_bindgen____wbindgen_is_string__h68847b1d3af057dc($5 | 0) | 0;
       label$8 : {
        if ($5 >>> 0 < 36 >>> 0) {
         break label$8
        }
        wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($5 | 0);
       }
       label$9 : {
        if ($4 >>> 0 < 36 >>> 0) {
         break label$9
        }
        wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($4 | 0);
       }
       label$10 : {
        if ($3 >>> 0 < 36 >>> 0) {
         break label$10
        }
        wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($3 | 0);
        if (($6 | 0) != (1 | 0)) {
         break label$5
        }
        break label$4;
       }
       if (($6 | 0) == (1 | 0)) {
        break label$4
       }
      }
      $4 = $T_20as_20core__convert__Into_U____into__ha09bc77f1ba4d1d1(getrandom__imp__Global__crypto____wbg_crypto_98fc271021c7d2ad__hf326796a2c49061a($2 | 0) | 0 | 0) | 0;
      $3 = $T_20as_20core__convert__Into_U____into__ha09bc77f1ba4d1d1(getrandom__imp__Global__ms_crypto____wbg_msCrypto_a2cdb043d2bfe57f__h238dd6f4c0c88606($2 | 0) | 0 | 0) | 0;
      label$11 : {
       label$12 : {
        label$13 : {
         label$14 : {
          if ((wasm_bindgen____wbindgen_is_object__he91ec6fcc6bd8d2d($4 | 0) | 0 | 0) != (1 | 0)) {
           break label$14
          }
          if ($3 >>> 0 >= 36 >>> 0) {
           break label$13
          }
          break label$12;
         }
         label$15 : {
          if ((wasm_bindgen____wbindgen_is_object__he91ec6fcc6bd8d2d($3 | 0) | 0 | 0) == (1 | 0)) {
           break label$15
          }
          i64toi32_i32$1 = $0;
          i64toi32_i32$0 = -2147483641;
          HEAP32[i64toi32_i32$1 >> 2] = 1;
          HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
          label$16 : {
           if ($4 >>> 0 < 36 >>> 0) {
            break label$16
           }
           wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($4 | 0);
          }
          if ($3 >>> 0 < 36 >>> 0) {
           break label$3
          }
          wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($3 | 0);
          break label$3;
         }
         if ($4 >>> 0 < 36 >>> 0) {
          break label$11
         }
         wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($4 | 0);
         break label$11;
        }
        wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($3 | 0);
       }
       $3 = $4;
      }
      (wasm2js_i32$0 = $0 + 12 | 0, wasm2js_i32$1 = js_sys__Uint8Array__new_with_length__h1c6c89a5b3f70c07(256 | 0) | 0), HEAP32[wasm2js_i32$0 >> 2] = wasm2js_i32$1;
      HEAP32[($0 + 8 | 0) >> 2] = $3;
      i64toi32_i32$1 = $0;
      i64toi32_i32$0 = 1;
      HEAP32[i64toi32_i32$1 >> 2] = 0;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      if ($2 >>> 0 >= 36 >>> 0) {
       break label$2
      }
      break label$1;
     }
     $3 = getrandom__imp__require____wbg_modulerequire_3440a4bcf44437db__h38943d7066d3d873(1076060 | 0, 6 | 0) | 0;
     wasm_bindgen____rt__take_last_exception__h00302a7bf129f841($1 + 8 | 0 | 0);
     label$17 : {
      if (!(HEAP32[($1 + 8 | 0) >> 2] | 0)) {
       break label$17
      }
      label$18 : {
       $3 = $T_20as_20core__convert__From_T____from__hb95de13f265c6ef4(HEAP32[($1 + 12 | 0) >> 2] | 0 | 0) | 0;
       if ($3 >>> 0 < 36 >>> 0) {
        break label$18
       }
       wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($3 | 0);
      }
      i64toi32_i32$1 = $0;
      i64toi32_i32$0 = -2147483636;
      HEAP32[i64toi32_i32$1 >> 2] = 1;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      break label$3;
     }
     (wasm2js_i32$0 = $0 + 8 | 0, wasm2js_i32$1 = $T_20as_20core__convert__Into_U____into__ha09bc77f1ba4d1d1($3 | 0) | 0), HEAP32[wasm2js_i32$0 >> 2] = wasm2js_i32$1;
     i64toi32_i32$1 = $0;
     i64toi32_i32$0 = 0;
     HEAP32[i64toi32_i32$1 >> 2] = 0;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    }
    if ($2 >>> 0 < 36 >>> 0) {
     break label$1
    }
   }
   wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($2 | 0);
  }
  global$0 = $1 + 16 | 0;
 }
 
 function num_bigint__biguint__subtraction___impl_20core__ops__arith__Sub_num_bigint__biguint__BigUint__20for_20_num_bigint__biguint__BigUint___sub__headfbdc5668069dd($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $4 = 0, i64toi32_i32$2 = 0, i64toi32_i32$5 = 0, $6 = 0, i64toi32_i32$1 = 0, $3 = 0, $5 = 0, $9 = 0, $9$hi = 0, $7 = 0, $8 = 0, $26 = 0, $27 = 0, $28 = 0, $29 = 0, $33 = 0, $35 = 0, $35$hi = 0, $37 = 0, $37$hi = 0, $38$hi = 0, $10 = 0, $10$hi = 0, $125 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  $4 = HEAP32[$2 >> 2] | 0;
  $5 = HEAP32[$1 >> 2] | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       $6 = HEAP32[($2 + 8 | 0) >> 2] | 0;
       $7 = HEAP32[($1 + 8 | 0) >> 2] | 0;
       if ($6 >>> 0 < $7 >>> 0) {
        break label$5
       }
       num_bigint__biguint__subtraction__sub2rev__h9886869f2206b4ea($5 | 0, $7 | 0, $4 | 0, $6 | 0);
       break label$4;
      }
      label$6 : {
       if (!$6) {
        break label$6
       }
       i64toi32_i32$0 = 0;
       $9 = 0;
       $9$hi = i64toi32_i32$0;
       $8 = $6;
       $1 = $5;
       label$7 : while (1) {
        $33 = $4;
        i64toi32_i32$2 = $1;
        i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
        i64toi32_i32$1 = 0;
        $35 = i64toi32_i32$0;
        $35$hi = i64toi32_i32$1;
        i64toi32_i32$2 = $4;
        i64toi32_i32$1 = HEAP32[$4 >> 2] | 0;
        i64toi32_i32$0 = 0;
        $37 = i64toi32_i32$1;
        $37$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $35$hi;
        i64toi32_i32$2 = $35;
        i64toi32_i32$1 = $37$hi;
        i64toi32_i32$3 = $37;
        i64toi32_i32$4 = i64toi32_i32$2 - i64toi32_i32$3 | 0;
        i64toi32_i32$5 = (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) + i64toi32_i32$1 | 0;
        i64toi32_i32$5 = i64toi32_i32$0 - i64toi32_i32$5 | 0;
        $38$hi = i64toi32_i32$5;
        i64toi32_i32$5 = $9$hi;
        i64toi32_i32$5 = $38$hi;
        i64toi32_i32$0 = i64toi32_i32$4;
        i64toi32_i32$2 = $9$hi;
        i64toi32_i32$3 = $9;
        i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
        i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
        if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
         i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
        }
        $10 = i64toi32_i32$1;
        $10$hi = i64toi32_i32$4;
        HEAP32[$33 >> 2] = i64toi32_i32$1;
        $1 = $1 + 4 | 0;
        $4 = $4 + 4 | 0;
        i64toi32_i32$5 = i64toi32_i32$1;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 63;
        i64toi32_i32$2 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$0 = i64toi32_i32$4 >> 31 | 0;
         $26 = i64toi32_i32$4 >> i64toi32_i32$2 | 0;
        } else {
         i64toi32_i32$0 = i64toi32_i32$4 >> i64toi32_i32$2 | 0;
         $26 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$2 | 0) | 0;
        }
        $9 = $26;
        $9$hi = i64toi32_i32$0;
        $8 = $8 + -1 | 0;
        if ($8) {
         continue label$7
        }
        break label$7;
       };
       $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend__T_2ccore__slice__iter__Iter_T_____spec_extend__h5cdab7a667860bc4($2 | 0, $5 + ($6 << 2 | 0) | 0 | 0, $5 + ($7 << 2 | 0) | 0 | 0);
       i64toi32_i32$0 = $10$hi;
       i64toi32_i32$4 = $10;
       i64toi32_i32$5 = -1;
       i64toi32_i32$3 = -1;
       if ((i64toi32_i32$0 | 0) > (i64toi32_i32$5 | 0)) {
        $27 = 1
       } else {
        if ((i64toi32_i32$0 | 0) >= (i64toi32_i32$5 | 0)) {
         if (i64toi32_i32$4 >>> 0 <= i64toi32_i32$3 >>> 0) {
          $28 = 0
         } else {
          $28 = 1
         }
         $29 = $28;
        } else {
         $29 = 0
        }
        $27 = $29;
       }
       if ($27) {
        break label$4
       }
       $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
       if ($4 >>> 0 < $6 >>> 0) {
        break label$3
       }
       num_bigint__biguint__subtraction__sub2__h0b2286b660c85b0d((HEAP32[$2 >> 2] | 0) + ($6 << 2 | 0) | 0 | 0, $4 - $6 | 0 | 0, 1077012 | 0, 1 | 0);
       break label$4;
      }
      $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend__T_2ccore__slice__iter__Iter_T_____spec_extend__h5cdab7a667860bc4($2 | 0, $5 + ($6 << 2 | 0) | 0 | 0, $5 + ($7 << 2 | 0) | 0 | 0);
     }
     $1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
     HEAP32[($3 + 8 | 0) >> 2] = $1;
     i64toi32_i32$3 = $2;
     i64toi32_i32$4 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $9 = i64toi32_i32$4;
     $9$hi = i64toi32_i32$0;
     i64toi32_i32$4 = $3;
     HEAP32[i64toi32_i32$4 >> 2] = $9;
     HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$0;
     label$8 : {
      if ($1) {
       break label$8
      }
      $1 = 0;
      break label$1;
     }
     i64toi32_i32$0 = $9$hi;
     $4 = (($1 << 2 | 0) + $9 | 0) + -4 | 0;
     label$9 : while (1) {
      if (HEAP32[$4 >> 2] | 0) {
       break label$2
      }
      $4 = $4 + -4 | 0;
      $1 = $1 + -1 | 0;
      if ($1) {
       continue label$9
      }
      break label$9;
     };
     $1 = 0;
     break label$2;
    }
    core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($6 | 0, $4 | 0, 1076996 | 0);
    abort();
   }
   HEAP32[($3 + 8 | 0) >> 2] = $1;
  }
  label$10 : {
   $4 = HEAP32[($3 + 4 | 0) >> 2] | 0;
   if ($1 >>> 0 >= ($4 >>> 2 | 0) >>> 0) {
    break label$10
   }
   if ($4 >>> 0 <= $1 >>> 0) {
    break label$10
   }
   alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($3 | 0, $1 | 0);
  }
  i64toi32_i32$3 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
  $125 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $125;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$4;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[(i64toi32_i32$3 + 8 | 0) >> 2] | 0;
  global$0 = i64toi32_i32$3 + 16 | 0;
 }
 
 function cryptoxide__chacha20poly1305__ChaChaPoly1305_____encrypt__h30e753aa5f862ba3($0, $1, $2, $3, $4, $5, $6) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  $5 = $5 | 0;
  $6 = $6 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $7 = 0, $8 = 0, $24 = 0, $29 = 0, $34 = 0, $39 = 0, $42 = 0, $46 = 0, $50 = 0, $54 = 0, $81 = 0, $111 = 0, $114 = 0;
  $7 = global$0 - 480 | 0;
  global$0 = $7;
  label$1 : {
   label$2 : {
    label$3 : {
     if (($2 | 0) != ($4 | 0)) {
      break label$3
     }
     if (HEAPU8[($0 + 232 | 0) >> 0] | 0) {
      break label$2
     }
     if (($6 | 0) == (16 | 0)) {
      break label$1
     }
     core__panicking__panic__h2fd385a887c8bf13(1055316 | 0, 37 | 0, 1055356 | 0);
     abort();
    }
    core__panicking__panic__h2fd385a887c8bf13(1055172 | 0, 45 | 0, 1055284 | 0);
    abort();
   }
   core__panicking__panic__h2fd385a887c8bf13(1055236 | 0, 32 | 0, 1055300 | 0);
   abort();
  }
  HEAP8[($0 + 232 | 0) >> 0] = 1;
  i64toi32_i32$2 = $0 + 24 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $7 + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $0 + 40 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $29 = i64toi32_i32$1;
  i64toi32_i32$1 = $7 + 24 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $29;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $0 + 56 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $34 = i64toi32_i32$0;
  i64toi32_i32$0 = $7 + 40 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $34;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $0 + 72 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $39 = i64toi32_i32$1;
  i64toi32_i32$1 = $7 + 56 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $39;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $42 = i64toi32_i32$0;
  i64toi32_i32$0 = $7;
  HEAP32[i64toi32_i32$0 >> 2] = $42;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$2 + 32 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $7;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $46;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $0 + 48 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $50 = i64toi32_i32$0;
  i64toi32_i32$0 = $7;
  HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] = $50;
  HEAP32[(i64toi32_i32$0 + 36 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $0 + 64 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $54 = i64toi32_i32$1;
  i64toi32_i32$1 = $7;
  HEAP32[(i64toi32_i32$1 + 48 | 0) >> 2] = $54;
  HEAP32[(i64toi32_i32$1 + 52 | 0) >> 2] = i64toi32_i32$0;
  memcpy((i64toi32_i32$1 + 248 | 0) + 84 | 0 | 0, $0 + 84 | 0 | 0, 64 | 0) | 0;
  $4 = HEAP32[($0 + 80 | 0) >> 2] | 0;
  memcpy((i64toi32_i32$1 + 248 | 0) + 16 | 0 | 0, i64toi32_i32$1 | 0, 64 | 0) | 0;
  $6 = memcpy((i64toi32_i32$1 + 248 | 0) + 148 | 0 | 0, $0 + 148 | 0 | 0, 80 | 0) | 0;
  HEAP32[((i64toi32_i32$1 + 248 | 0) + 80 | 0) >> 2] = $4;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $81 = i64toi32_i32$0;
  i64toi32_i32$0 = $7;
  HEAP32[(i64toi32_i32$0 + 256 | 0) >> 2] = $81;
  HEAP32[(i64toi32_i32$0 + 260 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$1;
  i64toi32_i32$1 = $7;
  HEAP32[(i64toi32_i32$1 + 248 | 0) >> 2] = $8;
  HEAP32[(i64toi32_i32$1 + 252 | 0) >> 2] = i64toi32_i32$0;
  cryptoxide__chacha20poly1305__pad16__hc43355684cd75a45($6 | 0, $8 | 0, i64toi32_i32$0 | 0);
  $7 = memcpy(i64toi32_i32$1 | 0, i64toi32_i32$1 + 248 | 0 | 0, 232 | 0) | 0;
  cryptoxide__chacha20poly1305__ContextEncryption_____encrypt__hceb367435c4eb688($7 | 0, $1 | 0, $2 | 0, $3 | 0, $2 | 0);
  memcpy($7 + 248 | 0 | 0, $7 | 0, 232 | 0) | 0;
  cryptoxide__chacha20poly1305__finalize_raw__ha8a88c220a2fbc52($7 + 232 | 0 | 0, $7 + 248 | 0 | 0);
  i64toi32_i32$2 = ($7 + 232 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $111 = i64toi32_i32$0;
  i64toi32_i32$0 = ($7 + 248 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $111;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $7;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 232 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 236 | 0) >> 2] | 0;
  $114 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$1 + 248 | 0) >> 2] = $114;
  HEAP32[(i64toi32_i32$1 + 252 | 0) >> 2] = i64toi32_i32$0;
  core__slice___impl_20_5bT_5d___copy_from_slice__h0f69c19ed1852955($5 | 0, 16 | 0, i64toi32_i32$1 + 248 | 0 | 0, 16 | 0);
  global$0 = i64toi32_i32$1 + 480 | 0;
 }
 
 function $cardano_serialization_lib__crypto__Vkey_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h00a02b49be066c8c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $12 = 0, $13 = 0, $14 = 0, $15 = 0, $4 = 0, $3 = 0, $55 = 0, $60 = 0, $65 = 0, $69 = 0;
  $2 = global$0 - 128 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___bytes__hc697ccccfa39fd82($2 + 80 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[($2 + 92 | 0) >> 2] | 0;
    HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = $1;
    HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] = $1;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[($2 + 84 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    $4 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[($2 + 32 | 0) >> 2] = $4;
    HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$0 = $2;
    HEAP32[($2 + 16 | 0) >> 2] = $4;
    HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
    label$3 : {
     if ((HEAP32[($2 + 12 | 0) >> 2] | 0 | 0) != (32 | 0)) {
      break label$3
     }
     $1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
     $3 = $2 + 104 | 0;
     i64toi32_i32$0 = $3;
     i64toi32_i32$1 = 0;
     HEAP32[i64toi32_i32$0 >> 2] = 0;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$0 = $2 + 96 | 0;
     i64toi32_i32$1 = 0;
     HEAP32[i64toi32_i32$0 >> 2] = 0;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$0 = ($2 + 80 | 0) + 8 | 0;
     i64toi32_i32$1 = 0;
     HEAP32[i64toi32_i32$0 >> 2] = 0;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$0 = $2;
     i64toi32_i32$1 = 0;
     HEAP32[($2 + 80 | 0) >> 2] = 0;
     HEAP32[($2 + 84 | 0) >> 2] = i64toi32_i32$1;
     core__slice___impl_20_5bT_5d___clone_from_slice__h1742dfbd5d5d9efd($2 + 80 | 0 | 0, 32 | 0, $1 | 0, 32 | 0);
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAPU8[($2 + 81 | 0) >> 0] | 0 | ((HEAPU8[($2 + 82 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 83 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 84 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[($2 + 85 | 0) >> 0] | 0 | ((HEAPU8[($2 + 86 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 87 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 88 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $55 = i64toi32_i32$1;
     i64toi32_i32$1 = $0 + 2 | 0;
     $12 = $55;
     HEAP8[i64toi32_i32$1 >> 0] = $12;
     HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $12 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $12 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $12 >>> 24 | 0;
     HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
     HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
     i64toi32_i32$2 = $2 + 89 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $60 = i64toi32_i32$0;
     i64toi32_i32$0 = $0 + 10 | 0;
     $13 = $60;
     HEAP8[i64toi32_i32$0 >> 0] = $13;
     HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $13 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $13 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $13 >>> 24 | 0;
     HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
     HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
     i64toi32_i32$2 = $2 + 97 | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $65 = i64toi32_i32$1;
     i64toi32_i32$1 = $0 + 18 | 0;
     $14 = $65;
     HEAP8[i64toi32_i32$1 >> 0] = $14;
     HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $14 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $14 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $14 >>> 24 | 0;
     HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
     HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
     i64toi32_i32$2 = $3;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $69 = i64toi32_i32$0;
     i64toi32_i32$0 = $0 + 25 | 0;
     $15 = $69;
     HEAP8[i64toi32_i32$0 >> 0] = $15;
     HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $15 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $15 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $15 >>> 24 | 0;
     HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
     HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
     $1 = HEAPU8[($2 + 80 | 0) >> 0] | 0;
     HEAP8[$0 >> 0] = 0;
     HEAP8[($0 + 1 | 0) >> 0] = $1;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 16 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 16 | 0 | 0);
     break label$1;
    }
    HEAP8[$0 >> 0] = 1;
    HEAP16[($0 + 8 | 0) >> 1] = 13;
    HEAP32[($0 + 56 | 0) >> 2] = 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 16 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 16 | 0 | 0);
    break label$1;
   }
   memcpy($2 + 87 | 0 | 0, memcpy($2 + 32 | 0 | 4 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 40 | 0) | 0 | 0, 40 | 0) | 0;
   HEAP8[($0 + 8 | 0) >> 0] = 2;
   HEAP32[($0 + 56 | 0) >> 2] = 0;
   memcpy($0 + 9 | 0 | 0, $2 + 80 | 0 | 0, 47 | 0) | 0;
   HEAP8[$0 >> 0] = 1;
  }
  global$0 = $2 + 128 | 0;
 }
 
 function cardano_serialization_lib__crypto__PoolMetadataHash__from_bytes__hcdbbfaf467fb270a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $2 = 0, $3 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $4 = 0, $5 = 0, $6 = 0, $7 = 0, $4$hi = 0, $5$hi = 0, $6$hi = 0, $7$hi = 0;
  $2 = global$0 - 224 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
      if (($3 | 0) != (32 | 0)) {
       break label$4
      }
      $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 | 0, $1 | 0);
      $3 = HEAP32[($2 + 4 | 0) >> 2] | 0;
      if ($3 >>> 0 <= 31 >>> 0) {
       break label$2
      }
      $T_20as_20core__convert__TryInto_U____try_into__ha1ac58dc74faf560($2 + 152 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, 32 | 0);
      if ((HEAPU8[($2 + 152 | 0) >> 0] | 0 | 0) == (1 | 0)) {
       break label$1
      }
      i64toi32_i32$2 = ($2 + 152 | 0) + 9 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $4 = i64toi32_i32$0;
      $4$hi = i64toi32_i32$1;
      i64toi32_i32$0 = $2 + 16 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $4;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = ($2 + 152 | 0) + 17 | 0;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $5 = i64toi32_i32$1;
      $5$hi = i64toi32_i32$0;
      i64toi32_i32$1 = $2 + 24 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $5;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = ($2 + 152 | 0) + 25 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $6 = i64toi32_i32$0;
      $6$hi = i64toi32_i32$1;
      i64toi32_i32$0 = $2 + 32 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $6;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $2;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 153 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 154 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 155 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 156 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 157 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 158 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 159 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 160 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $7 = i64toi32_i32$1;
      $7$hi = i64toi32_i32$0;
      i64toi32_i32$1 = i64toi32_i32$2;
      HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $7;
      HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$0 = $6$hi;
      i64toi32_i32$1 = $0 + 25 | 0;
      $15 = $6;
      HEAP8[i64toi32_i32$1 >> 0] = $15;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $15 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $15 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $15 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      i64toi32_i32$0 = $5$hi;
      i64toi32_i32$1 = $0 + 17 | 0;
      $16 = $5;
      HEAP8[i64toi32_i32$1 >> 0] = $16;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $16 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $16 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $16 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      i64toi32_i32$0 = $4$hi;
      i64toi32_i32$1 = $0 + 9 | 0;
      $17 = $4;
      HEAP8[i64toi32_i32$1 >> 0] = $17;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      i64toi32_i32$0 = $7$hi;
      i64toi32_i32$1 = $0;
      $18 = $7;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $18;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $18 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $18 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = $18 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 8 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      HEAP8[i64toi32_i32$1 >> 0] = 0;
      break label$3;
     }
     alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($2 + 200 | 0 | 0, 1066972 | 0, 16 | 0);
     i64toi32_i32$0 = 0;
     i64toi32_i32$1 = $2 + 192 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $3;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$1 = ($2 + 152 | 0) + 32 | 0;
     i64toi32_i32$0 = 0;
     HEAP32[i64toi32_i32$1 >> 2] = 1;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$1 = $2 + 176 | 0;
     i64toi32_i32$0 = 0;
     HEAP32[i64toi32_i32$1 >> 2] = 32;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[(($2 + 152 | 0) + 16 | 0) >> 2] = 11;
     HEAP32[($2 + 164 | 0) >> 2] = 1066390;
     HEAP8[($2 + 160 | 0) >> 0] = 13;
     HEAP8[($2 + 152 | 0) >> 0] = 2;
     memcpy($2 + 80 | 0 | 0, memcpy(($2 + 8 | 0) + 7 | 0 | 0, memcpy(($2 + 80 | 0) + 7 | 0 | 0, $2 + 152 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
     $3 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0;
     HEAP8[$0 >> 0] = 1;
     HEAP32[($0 + 4 | 0) >> 2] = $3;
    }
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
    global$0 = $2 + 224 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345(32 | 0, $3 | 0, 1066956 | 0);
   abort();
  }
  core__result__unwrap_failed__h27f43d993c3864a1(1066120 | 0, 43 | 0, $2 + 216 | 0 | 0, 1066180 | 0, 1066956 | 0);
  abort();
 }
 
 function cardano_serialization_lib__crypto__DataHash__from_bytes__h13af91f9785cf2d4($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $2 = 0, $3 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $4 = 0, $5 = 0, $6 = 0, $7 = 0, $4$hi = 0, $5$hi = 0, $6$hi = 0, $7$hi = 0;
  $2 = global$0 - 224 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
      if (($3 | 0) != (32 | 0)) {
       break label$4
      }
      $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 | 0, $1 | 0);
      $3 = HEAP32[($2 + 4 | 0) >> 2] | 0;
      if ($3 >>> 0 <= 31 >>> 0) {
       break label$2
      }
      $T_20as_20core__convert__TryInto_U____try_into__ha1ac58dc74faf560($2 + 152 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, 32 | 0);
      if ((HEAPU8[($2 + 152 | 0) >> 0] | 0 | 0) == (1 | 0)) {
       break label$1
      }
      i64toi32_i32$2 = ($2 + 152 | 0) + 9 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $4 = i64toi32_i32$0;
      $4$hi = i64toi32_i32$1;
      i64toi32_i32$0 = $2 + 16 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $4;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = ($2 + 152 | 0) + 17 | 0;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $5 = i64toi32_i32$1;
      $5$hi = i64toi32_i32$0;
      i64toi32_i32$1 = $2 + 24 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $5;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = ($2 + 152 | 0) + 25 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $6 = i64toi32_i32$0;
      $6$hi = i64toi32_i32$1;
      i64toi32_i32$0 = $2 + 32 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $6;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $2;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 153 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 154 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 155 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 156 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 157 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 158 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 159 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 160 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $7 = i64toi32_i32$1;
      $7$hi = i64toi32_i32$0;
      i64toi32_i32$1 = i64toi32_i32$2;
      HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $7;
      HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$0 = $6$hi;
      i64toi32_i32$1 = $0 + 25 | 0;
      $15 = $6;
      HEAP8[i64toi32_i32$1 >> 0] = $15;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $15 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $15 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $15 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      i64toi32_i32$0 = $5$hi;
      i64toi32_i32$1 = $0 + 17 | 0;
      $16 = $5;
      HEAP8[i64toi32_i32$1 >> 0] = $16;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $16 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $16 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $16 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      i64toi32_i32$0 = $4$hi;
      i64toi32_i32$1 = $0 + 9 | 0;
      $17 = $4;
      HEAP8[i64toi32_i32$1 >> 0] = $17;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      i64toi32_i32$0 = $7$hi;
      i64toi32_i32$1 = $0;
      $18 = $7;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $18;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $18 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $18 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = $18 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 8 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      HEAP8[i64toi32_i32$1 >> 0] = 0;
      break label$3;
     }
     alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($2 + 200 | 0 | 0, 1067041 | 0, 8 | 0);
     i64toi32_i32$0 = 0;
     i64toi32_i32$1 = $2 + 192 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $3;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$1 = ($2 + 152 | 0) + 32 | 0;
     i64toi32_i32$0 = 0;
     HEAP32[i64toi32_i32$1 >> 2] = 1;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$1 = $2 + 176 | 0;
     i64toi32_i32$0 = 0;
     HEAP32[i64toi32_i32$1 >> 2] = 32;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($2 + 168 | 0) >> 2] = 11;
     HEAP32[($2 + 164 | 0) >> 2] = 1066390;
     HEAP8[(($2 + 152 | 0) + 8 | 0) >> 0] = 13;
     HEAP8[($2 + 152 | 0) >> 0] = 2;
     memcpy($2 + 80 | 0 | 0, memcpy(($2 + 8 | 0) + 7 | 0 | 0, memcpy(($2 + 80 | 0) + 7 | 0 | 0, $2 + 152 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
     $3 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0;
     HEAP8[$0 >> 0] = 1;
     HEAP32[($0 + 4 | 0) >> 2] = $3;
    }
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
    global$0 = $2 + 224 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345(32 | 0, $3 | 0, 1067052 | 0);
   abort();
  }
  core__result__unwrap_failed__h27f43d993c3864a1(1066120 | 0, 43 | 0, $2 + 216 | 0 | 0, 1066180 | 0, 1067052 | 0);
  abort();
 }
 
 function cryptoxide__curve25519__fe___impl_20cryptoxide__curve25519__fe__fe64__Fe___invert__ha7ca879e8b04dd36($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 848 | 0;
  global$0 = $2;
  cryptoxide__curve25519__fe__fe64__Fe__square__h72fd8a55cd006328($2 + 8 | 0 | 0, $1 | 0);
  cryptoxide__curve25519__fe__fe64__Fe__square_repeatdly__h27bbbe5ee7c76e99($2 + 48 | 0 | 0, $2 + 8 | 0 | 0, 2 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($2 + 88 | 0 | 0, $1 | 0, $2 + 48 | 0 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($2 + 128 | 0 | 0, $2 + 8 | 0 | 0, $2 + 88 | 0 | 0);
  cryptoxide__curve25519__fe__fe64__Fe__square__h72fd8a55cd006328($2 + 168 | 0 | 0, $2 + 128 | 0 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($2 + 208 | 0 | 0, $2 + 88 | 0 | 0, $2 + 168 | 0 | 0);
  cryptoxide__curve25519__fe__fe64__Fe__square_repeatdly__h27bbbe5ee7c76e99($2 + 248 | 0 | 0, $2 + 208 | 0 | 0, 5 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($2 + 288 | 0 | 0, $2 + 248 | 0 | 0, $2 + 208 | 0 | 0);
  cryptoxide__curve25519__fe__fe64__Fe__square_repeatdly__h27bbbe5ee7c76e99($2 + 328 | 0 | 0, $2 + 288 | 0 | 0, 10 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($2 + 368 | 0 | 0, $2 + 328 | 0 | 0, $2 + 288 | 0 | 0);
  cryptoxide__curve25519__fe__fe64__Fe__square_repeatdly__h27bbbe5ee7c76e99($2 + 408 | 0 | 0, $2 + 368 | 0 | 0, 20 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($2 + 448 | 0 | 0, $2 + 408 | 0 | 0, $2 + 368 | 0 | 0);
  cryptoxide__curve25519__fe__fe64__Fe__square_repeatdly__h27bbbe5ee7c76e99($2 + 488 | 0 | 0, $2 + 448 | 0 | 0, 10 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($2 + 528 | 0 | 0, $2 + 488 | 0 | 0, $2 + 288 | 0 | 0);
  cryptoxide__curve25519__fe__fe64__Fe__square_repeatdly__h27bbbe5ee7c76e99($2 + 568 | 0 | 0, $2 + 528 | 0 | 0, 50 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($2 + 608 | 0 | 0, $2 + 568 | 0 | 0, $2 + 528 | 0 | 0);
  cryptoxide__curve25519__fe__fe64__Fe__square_repeatdly__h27bbbe5ee7c76e99($2 + 648 | 0 | 0, $2 + 608 | 0 | 0, 100 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($2 + 688 | 0 | 0, $2 + 648 | 0 | 0, $2 + 608 | 0 | 0);
  cryptoxide__curve25519__fe__fe64__Fe__square_repeatdly__h27bbbe5ee7c76e99($2 + 728 | 0 | 0, $2 + 688 | 0 | 0, 50 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($2 + 768 | 0 | 0, $2 + 728 | 0 | 0, $2 + 528 | 0 | 0);
  cryptoxide__curve25519__fe__fe64__Fe__square_repeatdly__h27bbbe5ee7c76e99($2 + 808 | 0 | 0, $2 + 768 | 0 | 0, 5 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($0 | 0, $2 + 808 | 0 | 0, $2 + 128 | 0 | 0);
  global$0 = $2 + 848 | 0;
 }
 
 function dlmalloc__Dlmalloc_A___malloc__h25d3e8a45fd7c029($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  label$1 : {
   label$2 : {
    if ($1 >>> 0 < 9 >>> 0) {
     break label$2
    }
    label$3 : {
     if ((dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2(16 | 0, 8 | 0) | 0) >>> 0 <= $1 >>> 0) {
      break label$3
     }
     $1 = dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2(16 | 0, 8 | 0) | 0;
    }
    $2 = 0;
    $3 = dlmalloc__dlmalloc__Chunk__to_mem__he3242996ca597cec(0 | 0) | 0;
    $3 = ((((($3 - (dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2($3 | 0, 8 | 0) | 0) | 0) - (dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2(20 | 0, 8 | 0) | 0) | 0) - (dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2(16 | 0, 8 | 0) | 0) | 0) + -65544 | 0) & -9 | 0) + -3 | 0;
    $4 = 0 - ((dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2(16 | 0, 8 | 0) | 0) << 2 | 0) | 0;
    if ((($4 >>> 0 > $3 >>> 0 ? $3 : $4) - $1 | 0) >>> 0 <= $0 >>> 0) {
     break label$1
    }
    $4 = dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2((((dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2(16 | 0, 8 | 0) | 0) + -5 | 0) >>> 0 > $0 >>> 0 ? 16 : $0 + 4 | 0) | 0, 8 | 0) | 0;
    $3 = dlmalloc__dlmalloc__Dlmalloc_A___malloc__h817d0bdbe748994d((($1 + $4 | 0) + (dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2(16 | 0, 8 | 0) | 0) | 0) + -4 | 0 | 0) | 0;
    if (!$3) {
     break label$1
    }
    $0 = dlmalloc__dlmalloc__Chunk__from_mem__h955f68080880f343($3 | 0) | 0;
    label$4 : {
     label$5 : {
      $2 = $1 + -1 | 0;
      if ($2 & $3 | 0) {
       break label$5
      }
      $1 = $0;
      break label$4;
     }
     $2 = dlmalloc__dlmalloc__Chunk__from_mem__h955f68080880f343(($2 + $3 | 0) & (0 - $1 | 0) | 0 | 0) | 0;
     $3 = dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2(16 | 0, 8 | 0) | 0;
     $1 = ($2 - $0 | 0) >>> 0 > $3 >>> 0 ? $2 : $2 + $1 | 0;
     $2 = $1 - $0 | 0;
     $3 = (dlmalloc__dlmalloc__Chunk__size__hbcf51483386243e4($0 | 0) | 0) - $2 | 0;
     label$6 : {
      if (dlmalloc__dlmalloc__Chunk__mmapped__h896a47bc7b87f942($0 | 0) | 0) {
       break label$6
      }
      dlmalloc__dlmalloc__Chunk__set_inuse__h3ef3278ef1a39233($1 | 0, $3 | 0);
      dlmalloc__dlmalloc__Chunk__set_inuse__h3ef3278ef1a39233($0 | 0, $2 | 0);
      dlmalloc__dlmalloc__Dlmalloc_A___dispose_chunk__hb19ba4f57c862d12($0 | 0, $2 | 0);
      break label$4;
     }
     $0 = HEAP32[$0 >> 2] | 0;
     HEAP32[($1 + 4 | 0) >> 2] = $3;
     HEAP32[$1 >> 2] = $0 + $2 | 0;
    }
    label$7 : {
     if (dlmalloc__dlmalloc__Chunk__mmapped__h896a47bc7b87f942($1 | 0) | 0) {
      break label$7
     }
     $0 = dlmalloc__dlmalloc__Chunk__size__hbcf51483386243e4($1 | 0) | 0;
     if ($0 >>> 0 <= ((dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2(16 | 0, 8 | 0) | 0) + $4 | 0) >>> 0) {
      break label$7
     }
     $2 = dlmalloc__dlmalloc__Chunk__plus_offset__h7aa5253a4344ed9a($1 | 0, $4 | 0) | 0;
     dlmalloc__dlmalloc__Chunk__set_inuse__h3ef3278ef1a39233($1 | 0, $4 | 0);
     $0 = $0 - $4 | 0;
     dlmalloc__dlmalloc__Chunk__set_inuse__h3ef3278ef1a39233($2 | 0, $0 | 0);
     dlmalloc__dlmalloc__Dlmalloc_A___dispose_chunk__hb19ba4f57c862d12($2 | 0, $0 | 0);
    }
    $0 = dlmalloc__dlmalloc__Chunk__to_mem__he3242996ca597cec($1 | 0) | 0;
    dlmalloc__dlmalloc__Chunk__mmapped__h896a47bc7b87f942($1 | 0) | 0;
    return $0 | 0;
   }
   $2 = dlmalloc__dlmalloc__Dlmalloc_A___malloc__h817d0bdbe748994d($0 | 0) | 0;
  }
  return $2 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert__h75cac002114ac4d4($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $5 = 0, $3 = 0, $4 = 0, $6 = 0, $10 = 0, $7 = 0, $9 = 0, $11 = 0, $8 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $5 = HEAPU16[($4 + 50 | 0) >> 1] | 0;
    if ($5 >>> 0 < 11 >>> 0) {
     break label$2
    }
    alloc__collections__btree__node__splitpoint__h8424344594b4deb1($3 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
    $6 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    $5 = HEAP32[($3 + 4 | 0) >> 2] | 0;
    $7 = HEAP32[$1 >> 2] | 0;
    HEAP32[($3 + 8 | 0) >> 2] = HEAP32[$3 >> 2] | 0;
    HEAP32[$3 >> 2] = $7;
    HEAP32[($3 + 4 | 0) >> 2] = $4;
    $1 = alloc__boxed__Box_T_2cA___new_uninit_in__hf695c4eb6d2b8dd9() | 0;
    HEAP16[($1 + 50 | 0) >> 1] = 0;
    HEAP32[$1 >> 2] = 0;
    $8 = alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__h5a312e4369260a49($3 | 0, $1 | 0) | 0;
    label$3 : {
     $9 = $6 + 1 | 0;
     $5 = ($5 | 0) == (1 | 0) ? $1 : $4;
     $10 = HEAPU16[($5 + 50 | 0) >> 1] | 0;
     if ($9 >>> 0 > $10 >>> 0) {
      break label$3
     }
     $11 = $5 + 4 | 0;
     memmove($11 + ($9 << 2 | 0) | 0 | 0, $11 + ($6 << 2 | 0) | 0 | 0, ($10 - $6 | 0) << 2 | 0 | 0) | 0;
    }
    HEAP32[(($5 + ($6 << 2 | 0) | 0) + 4 | 0) >> 2] = $2;
    HEAP32[($0 + 4 | 0) >> 2] = $7;
    HEAP32[$0 >> 2] = 1;
    HEAP32[($0 + 20 | 0) >> 2] = $1;
    HEAP32[($0 + 16 | 0) >> 2] = 0;
    HEAP32[($0 + 12 | 0) >> 2] = $8;
    HEAP32[($0 + 8 | 0) >> 2] = $4;
    HEAP16[($5 + 50 | 0) >> 1] = $10 + 1 | 0;
    $4 = $5;
    break label$1;
   }
   label$4 : {
    $6 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    $7 = $6 + 1 | 0;
    if ($7 >>> 0 > $5 >>> 0) {
     break label$4
    }
    $10 = $4 + 4 | 0;
    memmove($10 + ($7 << 2 | 0) | 0 | 0, $10 + ($6 << 2 | 0) | 0 | 0, ($5 - $6 | 0) << 2 | 0 | 0) | 0;
   }
   HEAP32[(($4 + ($6 << 2 | 0) | 0) + 4 | 0) >> 2] = $2;
   HEAP32[$0 >> 2] = 0;
   HEAP32[($0 + 12 | 0) >> 2] = $6;
   HEAP32[($0 + 8 | 0) >> 2] = $4;
   HEAP32[($0 + 4 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
   HEAP16[($4 + 50 | 0) >> 1] = $5 + 1 | 0;
  }
  HEAP32[($0 + 24 | 0) >> 2] = $4;
  global$0 = $3 + 16 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_recursing__had211746a3747d1e($0, $1, $2, $3, $3$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  var $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $8 = 0, $9 = 0, $5 = 0, $6 = 0, $7 = 0, $21 = 0, $36 = 0, $87 = 0;
  $4 = global$0 - 64 | 0;
  global$0 = $4;
  HEAP32[(($4 + 48 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[($4 + 48 | 0) >> 2] = $21;
  HEAP32[($4 + 52 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $3$hi;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert__hfa2ea511a82b92c9($4 | 0, $4 + 48 | 0 | 0, $2 | 0, $3 | 0, i64toi32_i32$1 | 0);
  $5 = HEAP32[($4 + 40 | 0) >> 2] | 0;
  label$1 : {
   label$2 : {
    if ((HEAP32[$4 >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    HEAP32[($0 + 40 | 0) >> 2] = $5;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    $36 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $36;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[i64toi32_i32$1 >> 2] = 0;
    HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = HEAP32[($4 + 12 | 0) >> 2] | 0;
    break label$1;
   }
   $1 = HEAP32[($4 + 36 | 0) >> 2] | 0;
   $2 = HEAP32[($4 + 32 | 0) >> 2] | 0;
   $6 = HEAP32[($4 + 24 | 0) >> 2] | 0;
   i64toi32_i32$2 = $4 + 16 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $3 = i64toi32_i32$0;
   $3$hi = i64toi32_i32$1;
   $7 = HEAP32[($4 + 8 | 0) >> 2] | 0;
   label$3 : {
    $8 = HEAP32[($4 + 28 | 0) >> 2] | 0;
    $9 = HEAP32[($8 + 88 | 0) >> 2] | 0;
    if (!$9) {
     break label$3
    }
    label$4 : while (1) {
     HEAP32[($4 + 56 | 0) >> 2] = HEAPU16[($8 + 136 | 0) >> 1] | 0;
     HEAP32[($4 + 52 | 0) >> 2] = $9;
     HEAP32[($4 + 48 | 0) >> 2] = $6 + 1 | 0;
     i64toi32_i32$1 = $3$hi;
     alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert__h8e1c603097dda825($4 | 0, $4 + 48 | 0 | 0, $7 | 0, $3 | 0, i64toi32_i32$1 | 0, $2 | 0, $1 | 0);
     label$5 : {
      if ((HEAP32[$4 >> 2] | 0 | 0) == (1 | 0)) {
       break label$5
      }
      HEAP32[($0 + 40 | 0) >> 2] = $5;
      i64toi32_i32$2 = $4;
      i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($4 + 8 | 0) >> 2] | 0;
      $87 = i64toi32_i32$1;
      i64toi32_i32$1 = $0;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $87;
      HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[i64toi32_i32$1 >> 2] = 0;
      HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = HEAP32[($4 + 12 | 0) >> 2] | 0;
      break label$1;
     }
     $1 = HEAP32[($4 + 36 | 0) >> 2] | 0;
     $2 = HEAP32[($4 + 32 | 0) >> 2] | 0;
     $6 = HEAP32[($4 + 24 | 0) >> 2] | 0;
     i64toi32_i32$2 = $4;
     i64toi32_i32$0 = HEAP32[($4 + 16 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($4 + 20 | 0) >> 2] | 0;
     $3 = i64toi32_i32$0;
     $3$hi = i64toi32_i32$1;
     $7 = HEAP32[($4 + 8 | 0) >> 2] | 0;
     $8 = HEAP32[($4 + 28 | 0) >> 2] | 0;
     $9 = HEAP32[($8 + 88 | 0) >> 2] | 0;
     if ($9) {
      continue label$4
     }
     break label$4;
    };
   }
   HEAP32[($0 + 40 | 0) >> 2] = $5;
   HEAP32[$0 >> 2] = 1;
   HEAP32[($0 + 36 | 0) >> 2] = $1;
   HEAP32[($0 + 32 | 0) >> 2] = $2;
   HEAP32[($0 + 28 | 0) >> 2] = $8;
   HEAP32[($0 + 24 | 0) >> 2] = $6;
   i64toi32_i32$1 = $3$hi;
   i64toi32_i32$0 = $0 + 16 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $3;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($0 + 8 | 0) >> 2] = $7;
  }
  global$0 = $4 + 64 | 0;
 }
 
 function $cardano_serialization_lib__chain_crypto__sign__Signature_T_2cA__20as_20cardano_serialization_lib__chain_crypto__bech32__Bech32___try_from_bech32_str__hb2a9289ba5b22cd2($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $4 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $4$hi = 0, $5 = 0, $6 = 0, $28 = 0, $5$hi = 0, $6$hi = 0;
  $3 = global$0 - 144 | 0;
  global$0 = $3;
  cardano_serialization_lib__chain_crypto__bech32__try_from_bech32_to_bytes__hac874eaf9db9a288($3 + 80 | 0 | 0, $1 | 0, $2 | 0);
  $1 = $3 + 80 | 0 | 4 | 0;
  label$1 : {
   label$2 : {
    if ((HEAP32[($3 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    HEAP32[(($3 + 8 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $1;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $28 = i64toi32_i32$0;
    i64toi32_i32$0 = $3;
    HEAP32[($3 + 8 | 0) >> 2] = $28;
    HEAP32[($3 + 12 | 0) >> 2] = i64toi32_i32$1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 | 0, $3 + 8 | 0 | 0);
    label$3 : {
     label$4 : {
      $1 = HEAP32[($3 + 4 | 0) >> 2] | 0;
      if (($1 | 0) != (64 | 0)) {
       break label$4
      }
      $2 = HEAP32[$3 >> 2] | 0;
      $1 = 0;
      memset($3 + 80 | 0 | 0, 0 | 0, 64 | 0) | 0;
      core__slice___impl_20_5bT_5d___clone_from_slice__h1742dfbd5d5d9efd($3 + 80 | 0 | 0, 64 | 0, $2 | 0, 64 | 0);
      HEAP8[($0 + 3 | 0) >> 0] = HEAPU8[($3 + 82 | 0) >> 0] | 0;
      $17 = HEAPU8[($3 + 80 | 0) >> 0] | 0 | ((HEAPU8[($3 + 81 | 0) >> 0] | 0) << 8 | 0) | 0;
      HEAP8[($0 + 1 | 0) >> 0] = $17;
      HEAP8[($0 + 2 | 0) >> 0] = $17 >>> 8 | 0;
      i64toi32_i32$2 = $3;
      i64toi32_i32$1 = HEAPU8[($3 + 83 | 0) >> 0] | 0 | ((HEAPU8[($3 + 84 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 85 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 86 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[($3 + 87 | 0) >> 0] | 0 | ((HEAPU8[($3 + 88 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 89 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 90 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $4 = i64toi32_i32$1;
      $4$hi = i64toi32_i32$0;
      $2 = HEAPU8[($3 + 91 | 0) >> 0] | 0 | ((HEAPU8[($3 + 92 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 93 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 94 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      memcpy($3 + 24 | 0 | 0, $3 + 95 | 0 | 0, 49 | 0) | 0;
      memcpy($0 + 16 | 0 | 0, $3 + 24 | 0 | 0, 49 | 0) | 0;
      $14 = $0 + 12 | 0;
      $15 = $2;
      HEAP8[$14 >> 0] = $15;
      HEAP8[($14 + 1 | 0) >> 0] = $15 >>> 8 | 0;
      HEAP8[($14 + 2 | 0) >> 0] = $15 >>> 16 | 0;
      HEAP8[($14 + 3 | 0) >> 0] = $15 >>> 24 | 0;
      i64toi32_i32$1 = $0 + 4 | 0;
      $16 = $4;
      HEAP8[i64toi32_i32$1 >> 0] = $16;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $16 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $16 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $16 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      break label$3;
     }
     HEAP32[(($3 + 80 | 0) + 8 | 0) >> 2] = $1;
     i64toi32_i32$1 = $3;
     i64toi32_i32$0 = 64;
     HEAP32[($3 + 80 | 0) >> 2] = 0;
     HEAP32[($3 + 84 | 0) >> 2] = i64toi32_i32$0;
     cardano_serialization_lib__chain_crypto__bech32__Error__data_invalid__hc2670bad9cc16601($0 + 4 | 0 | 0, $3 + 80 | 0 | 0);
     $1 = 1;
    }
    HEAP8[$0 >> 0] = $1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 8 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 8 | 0 | 0);
    break label$1;
   }
   i64toi32_i32$2 = $1 + 16 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $4 = i64toi32_i32$0;
   $4$hi = i64toi32_i32$1;
   i64toi32_i32$0 = ($3 + 24 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $4;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1 + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $5 = i64toi32_i32$1;
   $5$hi = i64toi32_i32$0;
   i64toi32_i32$1 = ($3 + 24 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $5;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $1;
   i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   $6 = i64toi32_i32$0;
   $6$hi = i64toi32_i32$1;
   i64toi32_i32$0 = $3;
   HEAP32[($3 + 24 | 0) >> 2] = $6;
   HEAP32[($3 + 28 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $4$hi;
   i64toi32_i32$0 = $0 + 20 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $4;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $5$hi;
   i64toi32_i32$0 = $0 + 12 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $5;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $6$hi;
   i64toi32_i32$0 = $0 + 4 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $6;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP8[$0 >> 0] = 1;
  }
  global$0 = $3 + 144 | 0;
 }
 
 function cardano_serialization_lib__crypto__TransactionHash__from_bytes__h235906d66c062ba5($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $2 = 0, $3 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $4 = 0, $5 = 0, $6 = 0, $7 = 0, $4$hi = 0, $5$hi = 0, $6$hi = 0, $7$hi = 0;
  $2 = global$0 - 224 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
      if (($3 | 0) != (32 | 0)) {
       break label$4
      }
      $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 | 0, $1 | 0);
      $3 = HEAP32[($2 + 4 | 0) >> 2] | 0;
      if ($3 >>> 0 <= 31 >>> 0) {
       break label$2
      }
      $T_20as_20core__convert__TryInto_U____try_into__ha1ac58dc74faf560($2 + 152 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, 32 | 0);
      if ((HEAPU8[($2 + 152 | 0) >> 0] | 0 | 0) == (1 | 0)) {
       break label$1
      }
      i64toi32_i32$2 = ($2 + 152 | 0) + 9 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $4 = i64toi32_i32$0;
      $4$hi = i64toi32_i32$1;
      i64toi32_i32$0 = $2 + 16 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $4;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = ($2 + 152 | 0) + 17 | 0;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $5 = i64toi32_i32$1;
      $5$hi = i64toi32_i32$0;
      i64toi32_i32$1 = $2 + 24 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $5;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = ($2 + 152 | 0) + 25 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $6 = i64toi32_i32$0;
      $6$hi = i64toi32_i32$1;
      i64toi32_i32$0 = $2 + 32 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $6;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $2;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 153 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 154 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 155 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 156 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 157 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 158 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 159 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 160 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $7 = i64toi32_i32$1;
      $7$hi = i64toi32_i32$0;
      i64toi32_i32$1 = i64toi32_i32$2;
      HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $7;
      HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$0 = $6$hi;
      i64toi32_i32$1 = $0 + 25 | 0;
      $15 = $6;
      HEAP8[i64toi32_i32$1 >> 0] = $15;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $15 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $15 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $15 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      i64toi32_i32$0 = $5$hi;
      i64toi32_i32$1 = $0 + 17 | 0;
      $16 = $5;
      HEAP8[i64toi32_i32$1 >> 0] = $16;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $16 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $16 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $16 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      i64toi32_i32$0 = $4$hi;
      i64toi32_i32$1 = $0 + 9 | 0;
      $17 = $4;
      HEAP8[i64toi32_i32$1 >> 0] = $17;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      i64toi32_i32$0 = $7$hi;
      i64toi32_i32$1 = $0;
      $18 = $7;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $18;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $18 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $18 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = $18 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 8 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      HEAP8[i64toi32_i32$1 >> 0] = 0;
      break label$3;
     }
     alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($2 + 200 | 0 | 0, 1066840 | 0, 15 | 0);
     i64toi32_i32$0 = 0;
     i64toi32_i32$1 = $2 + 192 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $3;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$1 = ($2 + 152 | 0) + 32 | 0;
     i64toi32_i32$0 = 0;
     HEAP32[i64toi32_i32$1 >> 2] = 1;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$1 = $2 + 176 | 0;
     i64toi32_i32$0 = 0;
     HEAP32[i64toi32_i32$1 >> 2] = 32;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($2 + 168 | 0) >> 2] = 11;
     HEAP32[($2 + 164 | 0) >> 2] = 1066390;
     HEAP8[($2 + 160 | 0) >> 0] = 13;
     HEAP8[($2 + 152 | 0) >> 0] = 2;
     memcpy($2 + 80 | 0 | 0, memcpy(($2 + 8 | 0) + 7 | 0 | 0, memcpy(($2 + 80 | 0) + 7 | 0 | 0, $2 + 152 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
     $3 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0;
     HEAP8[$0 >> 0] = 1;
     HEAP32[($0 + 4 | 0) >> 2] = $3;
    }
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
    global$0 = $2 + 224 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345(32 | 0, $3 | 0, 1066824 | 0);
   abort();
  }
  core__result__unwrap_failed__h27f43d993c3864a1(1066120 | 0, 43 | 0, $2 + 216 | 0 | 0, 1066180 | 0, 1066824 | 0);
  abort();
 }
 
 function cardano_serialization_lib__crypto__AuxiliaryDataHash__from_bytes__h3474e0570cc047c7($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $2 = 0, $3 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $4 = 0, $5 = 0, $6 = 0, $7 = 0, $4$hi = 0, $5$hi = 0, $6$hi = 0, $7$hi = 0;
  $2 = global$0 - 224 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
      if (($3 | 0) != (32 | 0)) {
       break label$4
      }
      $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 | 0, $1 | 0);
      $3 = HEAP32[($2 + 4 | 0) >> 2] | 0;
      if ($3 >>> 0 <= 31 >>> 0) {
       break label$2
      }
      $T_20as_20core__convert__TryInto_U____try_into__ha1ac58dc74faf560($2 + 152 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, 32 | 0);
      if ((HEAPU8[($2 + 152 | 0) >> 0] | 0 | 0) == (1 | 0)) {
       break label$1
      }
      i64toi32_i32$2 = ($2 + 152 | 0) + 9 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $4 = i64toi32_i32$0;
      $4$hi = i64toi32_i32$1;
      i64toi32_i32$0 = $2 + 16 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $4;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = ($2 + 152 | 0) + 17 | 0;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $5 = i64toi32_i32$1;
      $5$hi = i64toi32_i32$0;
      i64toi32_i32$1 = $2 + 24 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $5;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = ($2 + 152 | 0) + 25 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $6 = i64toi32_i32$0;
      $6$hi = i64toi32_i32$1;
      i64toi32_i32$0 = $2 + 32 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $6;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $2;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 153 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 154 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 155 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 156 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 157 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 158 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 159 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 160 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $7 = i64toi32_i32$1;
      $7$hi = i64toi32_i32$0;
      i64toi32_i32$1 = i64toi32_i32$2;
      HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $7;
      HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$0 = $6$hi;
      i64toi32_i32$1 = $0 + 25 | 0;
      $15 = $6;
      HEAP8[i64toi32_i32$1 >> 0] = $15;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $15 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $15 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $15 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      i64toi32_i32$0 = $5$hi;
      i64toi32_i32$1 = $0 + 17 | 0;
      $16 = $5;
      HEAP8[i64toi32_i32$1 >> 0] = $16;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $16 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $16 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $16 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      i64toi32_i32$0 = $4$hi;
      i64toi32_i32$1 = $0 + 9 | 0;
      $17 = $4;
      HEAP8[i64toi32_i32$1 >> 0] = $17;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      i64toi32_i32$0 = $7$hi;
      i64toi32_i32$1 = $0;
      $18 = $7;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $18;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $18 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $18 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = $18 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 8 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      HEAP8[i64toi32_i32$1 >> 0] = 0;
      break label$3;
     }
     alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($2 + 200 | 0 | 0, 1066936 | 0, 17 | 0);
     i64toi32_i32$0 = 0;
     i64toi32_i32$1 = $2 + 192 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $3;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$1 = ($2 + 152 | 0) + 32 | 0;
     i64toi32_i32$0 = 0;
     HEAP32[i64toi32_i32$1 >> 2] = 1;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$1 = $2 + 176 | 0;
     i64toi32_i32$0 = 0;
     HEAP32[i64toi32_i32$1 >> 2] = 32;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($2 + 168 | 0) >> 2] = 11;
     HEAP32[($2 + 164 | 0) >> 2] = 1066390;
     HEAP8[($2 + 160 | 0) >> 0] = 13;
     HEAP8[($2 + 152 | 0) >> 0] = 2;
     memcpy($2 + 80 | 0 | 0, memcpy(($2 + 8 | 0) + 7 | 0 | 0, memcpy(($2 + 80 | 0) + 7 | 0 | 0, $2 + 152 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
     $3 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0;
     HEAP8[$0 >> 0] = 1;
     HEAP32[($0 + 4 | 0) >> 2] = $3;
    }
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
    global$0 = $2 + 224 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345(32 | 0, $3 | 0, 1066920 | 0);
   abort();
  }
  core__result__unwrap_failed__h27f43d993c3864a1(1066120 | 0, 43 | 0, $2 + 216 | 0 | 0, 1066180 | 0, 1066920 | 0);
  abort();
 }
 
 function cardano_serialization_lib__crypto__VRFKeyHash__from_bytes__h124511c7aa071f43($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $2 = 0, $3 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $4 = 0, $5 = 0, $6 = 0, $7 = 0, $4$hi = 0, $5$hi = 0, $6$hi = 0, $7$hi = 0;
  $2 = global$0 - 224 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
      if (($3 | 0) != (32 | 0)) {
       break label$4
      }
      $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 | 0, $1 | 0);
      $3 = HEAP32[($2 + 4 | 0) >> 2] | 0;
      if ($3 >>> 0 <= 31 >>> 0) {
       break label$2
      }
      $T_20as_20core__convert__TryInto_U____try_into__ha1ac58dc74faf560($2 + 152 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, 32 | 0);
      if ((HEAPU8[($2 + 152 | 0) >> 0] | 0 | 0) == (1 | 0)) {
       break label$1
      }
      i64toi32_i32$2 = ($2 + 152 | 0) + 9 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $4 = i64toi32_i32$0;
      $4$hi = i64toi32_i32$1;
      i64toi32_i32$0 = $2 + 16 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $4;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = ($2 + 152 | 0) + 17 | 0;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $5 = i64toi32_i32$1;
      $5$hi = i64toi32_i32$0;
      i64toi32_i32$1 = $2 + 24 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $5;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = ($2 + 152 | 0) + 25 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $6 = i64toi32_i32$0;
      $6$hi = i64toi32_i32$1;
      i64toi32_i32$0 = $2 + 32 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $6;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $2;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 153 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 154 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 155 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 156 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 157 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 158 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 159 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 160 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $7 = i64toi32_i32$1;
      $7$hi = i64toi32_i32$0;
      i64toi32_i32$1 = i64toi32_i32$2;
      HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $7;
      HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$0 = $6$hi;
      i64toi32_i32$1 = $0 + 25 | 0;
      $15 = $6;
      HEAP8[i64toi32_i32$1 >> 0] = $15;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $15 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $15 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $15 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      i64toi32_i32$0 = $5$hi;
      i64toi32_i32$1 = $0 + 17 | 0;
      $16 = $5;
      HEAP8[i64toi32_i32$1 >> 0] = $16;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $16 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $16 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $16 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      i64toi32_i32$0 = $4$hi;
      i64toi32_i32$1 = $0 + 9 | 0;
      $17 = $4;
      HEAP8[i64toi32_i32$1 >> 0] = $17;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      i64toi32_i32$0 = $7$hi;
      i64toi32_i32$1 = $0;
      $18 = $7;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $18;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $18 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $18 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = $18 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 8 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      HEAP8[i64toi32_i32$1 >> 0] = 0;
      break label$3;
     }
     alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($2 + 200 | 0 | 0, 1067004 | 0, 10 | 0);
     i64toi32_i32$0 = 0;
     i64toi32_i32$1 = $2 + 192 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $3;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$1 = ($2 + 152 | 0) + 32 | 0;
     i64toi32_i32$0 = 0;
     HEAP32[i64toi32_i32$1 >> 2] = 1;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$1 = $2 + 176 | 0;
     i64toi32_i32$0 = 0;
     HEAP32[i64toi32_i32$1 >> 2] = 32;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($2 + 168 | 0) >> 2] = 11;
     HEAP32[($2 + 164 | 0) >> 2] = 1066390;
     HEAP8[($2 + 160 | 0) >> 0] = 13;
     HEAP8[($2 + 152 | 0) >> 0] = 2;
     memcpy($2 + 80 | 0 | 0, memcpy(($2 + 8 | 0) + 7 | 0 | 0, memcpy(($2 + 80 | 0) + 7 | 0 | 0, $2 + 152 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
     $3 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0;
     HEAP8[$0 >> 0] = 1;
     HEAP32[($0 + 4 | 0) >> 2] = $3;
    }
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
    global$0 = $2 + 224 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345(32 | 0, $3 | 0, 1066988 | 0);
   abort();
  }
  core__result__unwrap_failed__h27f43d993c3864a1(1066120 | 0, 43 | 0, $2 + 216 | 0 | 0, 1066180 | 0, 1066988 | 0);
  abort();
 }
 
 function cardano_serialization_lib__crypto__BlockHash__from_bytes__ha6cff5ff44ff1071($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $2 = 0, $3 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $4 = 0, $5 = 0, $6 = 0, $7 = 0, $4$hi = 0, $5$hi = 0, $6$hi = 0, $7$hi = 0;
  $2 = global$0 - 224 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
      if (($3 | 0) != (32 | 0)) {
       break label$4
      }
      $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 | 0, $1 | 0);
      $3 = HEAP32[($2 + 4 | 0) >> 2] | 0;
      if ($3 >>> 0 <= 31 >>> 0) {
       break label$2
      }
      $T_20as_20core__convert__TryInto_U____try_into__ha1ac58dc74faf560($2 + 152 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, 32 | 0);
      if ((HEAPU8[($2 + 152 | 0) >> 0] | 0 | 0) == (1 | 0)) {
       break label$1
      }
      i64toi32_i32$2 = ($2 + 152 | 0) + 9 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $4 = i64toi32_i32$0;
      $4$hi = i64toi32_i32$1;
      i64toi32_i32$0 = $2 + 16 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $4;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = ($2 + 152 | 0) + 17 | 0;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $5 = i64toi32_i32$1;
      $5$hi = i64toi32_i32$0;
      i64toi32_i32$1 = $2 + 24 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $5;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = ($2 + 152 | 0) + 25 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $6 = i64toi32_i32$0;
      $6$hi = i64toi32_i32$1;
      i64toi32_i32$0 = $2 + 32 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $6;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $2;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 153 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 154 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 155 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 156 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 157 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 158 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 159 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 160 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $7 = i64toi32_i32$1;
      $7$hi = i64toi32_i32$0;
      i64toi32_i32$1 = i64toi32_i32$2;
      HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $7;
      HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$0 = $6$hi;
      i64toi32_i32$1 = $0 + 25 | 0;
      $15 = $6;
      HEAP8[i64toi32_i32$1 >> 0] = $15;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $15 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $15 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $15 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      i64toi32_i32$0 = $5$hi;
      i64toi32_i32$1 = $0 + 17 | 0;
      $16 = $5;
      HEAP8[i64toi32_i32$1 >> 0] = $16;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $16 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $16 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $16 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      i64toi32_i32$0 = $4$hi;
      i64toi32_i32$1 = $0 + 9 | 0;
      $17 = $4;
      HEAP8[i64toi32_i32$1 >> 0] = $17;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      i64toi32_i32$0 = $7$hi;
      i64toi32_i32$1 = $0;
      $18 = $7;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $18;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $18 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $18 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = $18 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 8 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      HEAP8[i64toi32_i32$1 >> 0] = 0;
      break label$3;
     }
     alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($2 + 200 | 0 | 0, 1067032 | 0, 9 | 0);
     i64toi32_i32$0 = 0;
     i64toi32_i32$1 = $2 + 192 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $3;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$1 = ($2 + 152 | 0) + 32 | 0;
     i64toi32_i32$0 = 0;
     HEAP32[i64toi32_i32$1 >> 2] = 1;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$1 = $2 + 176 | 0;
     i64toi32_i32$0 = 0;
     HEAP32[i64toi32_i32$1 >> 2] = 32;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($2 + 168 | 0) >> 2] = 11;
     HEAP32[($2 + 164 | 0) >> 2] = 1066390;
     HEAP8[($2 + 160 | 0) >> 0] = 13;
     HEAP8[($2 + 152 | 0) >> 0] = 2;
     memcpy($2 + 80 | 0 | 0, memcpy(($2 + 8 | 0) + 7 | 0 | 0, memcpy(($2 + 80 | 0) + 7 | 0 | 0, $2 + 152 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
     $3 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0;
     HEAP8[$0 >> 0] = 1;
     HEAP32[($0 + 4 | 0) >> 2] = $3;
    }
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
    global$0 = $2 + 224 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345(32 | 0, $3 | 0, 1067016 | 0);
   abort();
  }
  core__result__unwrap_failed__h27f43d993c3864a1(1066120 | 0, 43 | 0, $2 + 216 | 0 | 0, 1066180 | 0, 1067016 | 0);
  abort();
 }
 
 function cardano_serialization_lib__crypto__ScriptDataHash__from_bytes__hfbd006c5cd3f689b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $2 = 0, $3 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $4 = 0, $5 = 0, $6 = 0, $7 = 0, $4$hi = 0, $5$hi = 0, $6$hi = 0, $7$hi = 0;
  $2 = global$0 - 224 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
      if (($3 | 0) != (32 | 0)) {
       break label$4
      }
      $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 | 0, $1 | 0);
      $3 = HEAP32[($2 + 4 | 0) >> 2] | 0;
      if ($3 >>> 0 <= 31 >>> 0) {
       break label$2
      }
      $T_20as_20core__convert__TryInto_U____try_into__ha1ac58dc74faf560($2 + 152 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, 32 | 0);
      if ((HEAPU8[($2 + 152 | 0) >> 0] | 0 | 0) == (1 | 0)) {
       break label$1
      }
      i64toi32_i32$2 = ($2 + 152 | 0) + 9 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $4 = i64toi32_i32$0;
      $4$hi = i64toi32_i32$1;
      i64toi32_i32$0 = $2 + 16 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $4;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = ($2 + 152 | 0) + 17 | 0;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $5 = i64toi32_i32$1;
      $5$hi = i64toi32_i32$0;
      i64toi32_i32$1 = $2 + 24 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $5;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = ($2 + 152 | 0) + 25 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $6 = i64toi32_i32$0;
      $6$hi = i64toi32_i32$1;
      i64toi32_i32$0 = $2 + 32 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $6;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $2;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 153 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 154 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 155 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 156 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 157 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 158 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 159 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 160 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $7 = i64toi32_i32$1;
      $7$hi = i64toi32_i32$0;
      i64toi32_i32$1 = i64toi32_i32$2;
      HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $7;
      HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$0 = $6$hi;
      i64toi32_i32$1 = $0 + 25 | 0;
      $15 = $6;
      HEAP8[i64toi32_i32$1 >> 0] = $15;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $15 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $15 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $15 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      i64toi32_i32$0 = $5$hi;
      i64toi32_i32$1 = $0 + 17 | 0;
      $16 = $5;
      HEAP8[i64toi32_i32$1 >> 0] = $16;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $16 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $16 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $16 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      i64toi32_i32$0 = $4$hi;
      i64toi32_i32$1 = $0 + 9 | 0;
      $17 = $4;
      HEAP8[i64toi32_i32$1 >> 0] = $17;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      i64toi32_i32$0 = $7$hi;
      i64toi32_i32$1 = $0;
      $18 = $7;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $18;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $18 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $18 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = $18 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 8 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      HEAP8[i64toi32_i32$1 >> 0] = 0;
      break label$3;
     }
     alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($2 + 200 | 0 | 0, 1067084 | 0, 14 | 0);
     i64toi32_i32$0 = 0;
     i64toi32_i32$1 = $2 + 192 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $3;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$1 = ($2 + 152 | 0) + 32 | 0;
     i64toi32_i32$0 = 0;
     HEAP32[i64toi32_i32$1 >> 2] = 1;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$1 = $2 + 176 | 0;
     i64toi32_i32$0 = 0;
     HEAP32[i64toi32_i32$1 >> 2] = 32;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($2 + 168 | 0) >> 2] = 11;
     HEAP32[($2 + 164 | 0) >> 2] = 1066390;
     HEAP8[($2 + 160 | 0) >> 0] = 13;
     HEAP8[($2 + 152 | 0) >> 0] = 2;
     memcpy($2 + 80 | 0 | 0, memcpy(($2 + 8 | 0) + 7 | 0 | 0, memcpy(($2 + 80 | 0) + 7 | 0 | 0, $2 + 152 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
     $3 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0;
     HEAP8[$0 >> 0] = 1;
     HEAP32[($0 + 4 | 0) >> 2] = $3;
    }
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
    global$0 = $2 + 224 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345(32 | 0, $3 | 0, 1067068 | 0);
   abort();
  }
  core__result__unwrap_failed__h27f43d993c3864a1(1066120 | 0, 43 | 0, $2 + 216 | 0 | 0, 1066180 | 0, 1067068 | 0);
  abort();
 }
 
 function cardano_serialization_lib__crypto__VRFVKey__from_bytes__hf703fd2bd6e45870($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $2 = 0, $3 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $4 = 0, $5 = 0, $6 = 0, $7 = 0, $4$hi = 0, $5$hi = 0, $6$hi = 0, $7$hi = 0;
  $2 = global$0 - 224 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
      if (($3 | 0) != (32 | 0)) {
       break label$4
      }
      $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 | 0, $1 | 0);
      $3 = HEAP32[($2 + 4 | 0) >> 2] | 0;
      if ($3 >>> 0 <= 31 >>> 0) {
       break label$2
      }
      $T_20as_20core__convert__TryInto_U____try_into__ha1ac58dc74faf560($2 + 152 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, 32 | 0);
      if ((HEAPU8[($2 + 152 | 0) >> 0] | 0 | 0) == (1 | 0)) {
       break label$1
      }
      i64toi32_i32$2 = ($2 + 152 | 0) + 9 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $4 = i64toi32_i32$0;
      $4$hi = i64toi32_i32$1;
      i64toi32_i32$0 = $2 + 16 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $4;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = ($2 + 152 | 0) + 17 | 0;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $5 = i64toi32_i32$1;
      $5$hi = i64toi32_i32$0;
      i64toi32_i32$1 = $2 + 24 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $5;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = ($2 + 152 | 0) + 25 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $6 = i64toi32_i32$0;
      $6$hi = i64toi32_i32$1;
      i64toi32_i32$0 = $2 + 32 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $6;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $2;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 153 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 154 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 155 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 156 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 157 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 158 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 159 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 160 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $7 = i64toi32_i32$1;
      $7$hi = i64toi32_i32$0;
      i64toi32_i32$1 = i64toi32_i32$2;
      HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $7;
      HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$0 = $6$hi;
      i64toi32_i32$1 = $0 + 25 | 0;
      $15 = $6;
      HEAP8[i64toi32_i32$1 >> 0] = $15;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $15 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $15 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $15 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      i64toi32_i32$0 = $5$hi;
      i64toi32_i32$1 = $0 + 17 | 0;
      $16 = $5;
      HEAP8[i64toi32_i32$1 >> 0] = $16;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $16 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $16 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $16 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      i64toi32_i32$0 = $4$hi;
      i64toi32_i32$1 = $0 + 9 | 0;
      $17 = $4;
      HEAP8[i64toi32_i32$1 >> 0] = $17;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      i64toi32_i32$0 = $7$hi;
      i64toi32_i32$1 = $0;
      $18 = $7;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $18;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $18 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $18 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = $18 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 8 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      HEAP8[i64toi32_i32$1 >> 0] = 0;
      break label$3;
     }
     alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($2 + 200 | 0 | 0, 1067116 | 0, 7 | 0);
     i64toi32_i32$0 = 0;
     i64toi32_i32$1 = $2 + 192 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $3;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$1 = ($2 + 152 | 0) + 32 | 0;
     i64toi32_i32$0 = 0;
     HEAP32[i64toi32_i32$1 >> 2] = 1;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$1 = $2 + 176 | 0;
     i64toi32_i32$0 = 0;
     HEAP32[i64toi32_i32$1 >> 2] = 32;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($2 + 168 | 0) >> 2] = 11;
     HEAP32[($2 + 164 | 0) >> 2] = 1066390;
     HEAP8[($2 + 160 | 0) >> 0] = 13;
     HEAP8[($2 + 152 | 0) >> 0] = 2;
     memcpy($2 + 80 | 0 | 0, memcpy(($2 + 8 | 0) + 7 | 0 | 0, memcpy(($2 + 80 | 0) + 7 | 0 | 0, $2 + 152 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
     $3 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0;
     HEAP8[$0 >> 0] = 1;
     HEAP32[($0 + 4 | 0) >> 2] = $3;
    }
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
    global$0 = $2 + 224 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345(32 | 0, $3 | 0, 1067100 | 0);
   abort();
  }
  core__result__unwrap_failed__h27f43d993c3864a1(1066120 | 0, 43 | 0, $2 + 216 | 0 | 0, 1066180 | 0, 1067100 | 0);
  abort();
 }
 
 function cardano_serialization_lib__crypto__KESVKey__from_bytes__hd3afa2883ce70fa1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $2 = 0, $3 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $4 = 0, $5 = 0, $6 = 0, $7 = 0, $4$hi = 0, $5$hi = 0, $6$hi = 0, $7$hi = 0;
  $2 = global$0 - 224 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
      if (($3 | 0) != (32 | 0)) {
       break label$4
      }
      $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 | 0, $1 | 0);
      $3 = HEAP32[($2 + 4 | 0) >> 2] | 0;
      if ($3 >>> 0 <= 31 >>> 0) {
       break label$2
      }
      $T_20as_20core__convert__TryInto_U____try_into__ha1ac58dc74faf560($2 + 152 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, 32 | 0);
      if ((HEAPU8[($2 + 152 | 0) >> 0] | 0 | 0) == (1 | 0)) {
       break label$1
      }
      i64toi32_i32$2 = ($2 + 152 | 0) + 9 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $4 = i64toi32_i32$0;
      $4$hi = i64toi32_i32$1;
      i64toi32_i32$0 = $2 + 16 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $4;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = ($2 + 152 | 0) + 17 | 0;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $5 = i64toi32_i32$1;
      $5$hi = i64toi32_i32$0;
      i64toi32_i32$1 = $2 + 24 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $5;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = ($2 + 152 | 0) + 25 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $6 = i64toi32_i32$0;
      $6$hi = i64toi32_i32$1;
      i64toi32_i32$0 = $2 + 32 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $6;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $2;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 153 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 154 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 155 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 156 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 157 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 158 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 159 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 160 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $7 = i64toi32_i32$1;
      $7$hi = i64toi32_i32$0;
      i64toi32_i32$1 = i64toi32_i32$2;
      HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $7;
      HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$0 = $6$hi;
      i64toi32_i32$1 = $0 + 25 | 0;
      $15 = $6;
      HEAP8[i64toi32_i32$1 >> 0] = $15;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $15 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $15 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $15 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      i64toi32_i32$0 = $5$hi;
      i64toi32_i32$1 = $0 + 17 | 0;
      $16 = $5;
      HEAP8[i64toi32_i32$1 >> 0] = $16;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $16 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $16 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $16 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      i64toi32_i32$0 = $4$hi;
      i64toi32_i32$1 = $0 + 9 | 0;
      $17 = $4;
      HEAP8[i64toi32_i32$1 >> 0] = $17;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      i64toi32_i32$0 = $7$hi;
      i64toi32_i32$1 = $0;
      $18 = $7;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $18;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $18 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $18 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = $18 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 8 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      HEAP8[i64toi32_i32$1 >> 0] = 0;
      break label$3;
     }
     alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($2 + 200 | 0 | 0, 1067140 | 0, 7 | 0);
     i64toi32_i32$0 = 0;
     i64toi32_i32$1 = $2 + 192 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $3;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$1 = ($2 + 152 | 0) + 32 | 0;
     i64toi32_i32$0 = 0;
     HEAP32[i64toi32_i32$1 >> 2] = 1;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$1 = $2 + 176 | 0;
     i64toi32_i32$0 = 0;
     HEAP32[i64toi32_i32$1 >> 2] = 32;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($2 + 168 | 0) >> 2] = 11;
     HEAP32[($2 + 164 | 0) >> 2] = 1066390;
     HEAP8[($2 + 160 | 0) >> 0] = 13;
     HEAP8[($2 + 152 | 0) >> 0] = 2;
     memcpy($2 + 80 | 0 | 0, memcpy(($2 + 8 | 0) + 7 | 0 | 0, memcpy(($2 + 80 | 0) + 7 | 0 | 0, $2 + 152 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
     $3 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0;
     HEAP8[$0 >> 0] = 1;
     HEAP32[($0 + 4 | 0) >> 2] = $3;
    }
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
    global$0 = $2 + 224 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345(32 | 0, $3 | 0, 1067124 | 0);
   abort();
  }
  core__result__unwrap_failed__h27f43d993c3864a1(1066120 | 0, 43 | 0, $2 + 216 | 0 | 0, 1066180 | 0, 1067124 | 0);
  abort();
 }
 
 function cryptoxide__chacha__reference__State_____init__h907baff12ea105b6($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $16 = 0, $6 = 0, $8 = 0, $10 = 0, $12 = 0, $13 = 0, $14 = 0, $15 = 0, $5 = 0, $7 = 0, $9 = 0, $11 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     if (($2 | 0) == (16 | 0)) {
      break label$3
     }
     if (($2 | 0) == (32 | 0)) {
      break label$2
     }
     core__panicking__panic__h2fd385a887c8bf13(1102100 | 0, 40 | 0, 1102248 | 0);
     abort();
    }
    $2 = 824206446;
    $5 = 2036477238;
    $6 = HEAPU8[($1 + 12 | 0) >> 0] | 0 | ((HEAPU8[($1 + 13 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 14 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 15 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $7 = $6;
    $8 = HEAPU8[($1 + 8 | 0) >> 0] | 0 | ((HEAPU8[($1 + 9 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 10 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 11 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $9 = $8;
    $10 = HEAPU8[($1 + 4 | 0) >> 0] | 0 | ((HEAPU8[($1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $11 = $10;
    $12 = HEAPU8[$1 >> 0] | 0 | ((HEAPU8[($1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $1 = $12;
    break label$1;
   }
   $6 = HEAPU8[($1 + 28 | 0) >> 0] | 0 | ((HEAPU8[($1 + 29 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 30 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 31 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $8 = HEAPU8[($1 + 24 | 0) >> 0] | 0 | ((HEAPU8[($1 + 25 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 26 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 27 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $10 = HEAPU8[($1 + 20 | 0) >> 0] | 0 | ((HEAPU8[($1 + 21 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 22 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 23 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $12 = HEAPU8[($1 + 16 | 0) >> 0] | 0 | ((HEAPU8[($1 + 17 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 18 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 19 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $7 = HEAPU8[($1 + 12 | 0) >> 0] | 0 | ((HEAPU8[($1 + 13 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 14 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 15 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $9 = HEAPU8[($1 + 8 | 0) >> 0] | 0 | ((HEAPU8[($1 + 9 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 10 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 11 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $11 = HEAPU8[($1 + 4 | 0) >> 0] | 0 | ((HEAPU8[($1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $1 = HEAPU8[$1 >> 0] | 0 | ((HEAPU8[($1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $2 = 857760878;
   $5 = 2036477234;
  }
  label$4 : {
   label$5 : {
    label$6 : {
     label$7 : {
      switch ($4 + -12 | 0 | 0) {
      case 4:
       $4 = $3 + 8 | 0;
       $13 = HEAPU8[($3 + 4 | 0) >> 0] | 0 | ((HEAPU8[($3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $14 = HEAPU8[$3 >> 0] | 0 | ((HEAPU8[($3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $15 = 12;
       break label$6;
      case 0:
       $4 = $3 + 4 | 0;
       $13 = HEAPU8[$3 >> 0] | 0 | ((HEAPU8[($3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $14 = 0;
       $15 = 8;
       break label$6;
      default:
       break label$7;
      };
     }
     if ($4 >>> 0 <= 3 >>> 0) {
      break label$5
     }
     if ($4 >>> 0 <= 7 >>> 0) {
      break label$4
     }
     $14 = 0;
     $15 = 4;
     $13 = 0;
     $4 = $3;
    }
    HEAP32[($0 + 48 | 0) >> 2] = $14;
    HEAP32[($0 + 32 | 0) >> 2] = $12;
    HEAP32[($0 + 16 | 0) >> 2] = $1;
    HEAP32[($0 + 12 | 0) >> 2] = 1797285236;
    HEAP32[($0 + 8 | 0) >> 2] = $5;
    HEAP32[($0 + 4 | 0) >> 2] = $2;
    HEAP32[$0 >> 2] = 1634760805;
    HEAP32[($0 + 56 | 0) >> 2] = HEAPU8[$4 >> 0] | 0 | ((HEAPU8[($4 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    HEAP32[($0 + 52 | 0) >> 2] = $13;
    HEAP32[($0 + 44 | 0) >> 2] = $6;
    HEAP32[($0 + 40 | 0) >> 2] = $8;
    HEAP32[($0 + 36 | 0) >> 2] = $10;
    HEAP32[($0 + 28 | 0) >> 2] = $7;
    HEAP32[($0 + 24 | 0) >> 2] = $9;
    HEAP32[($0 + 20 | 0) >> 2] = $11;
    $16 = $3 + $15 | 0;
    HEAP32[($0 + 60 | 0) >> 2] = HEAPU8[$16 >> 0] | 0 | ((HEAPU8[($16 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($16 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($16 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345(4 | 0, $4 | 0, 1102264 | 0);
   abort();
  }
  core__slice__index__slice_end_index_len_fail__h192505a15ac4b345(8 | 0, $4 | 0, 1102280 | 0);
  abort();
 }
 
 function cryptoxide__curve25519__fe___impl_20cryptoxide__curve25519__fe__fe64__Fe___pow25523__h155bb8902fd1dd34($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 848 | 0;
  global$0 = $2;
  cryptoxide__curve25519__fe__fe64__Fe__square__h72fd8a55cd006328($2 + 8 | 0 | 0, $1 | 0);
  cryptoxide__curve25519__fe__fe64__Fe__square_repeatdly__h27bbbe5ee7c76e99($2 + 48 | 0 | 0, $2 + 8 | 0 | 0, 2 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($2 + 88 | 0 | 0, $1 | 0, $2 + 48 | 0 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($2 + 128 | 0 | 0, $2 + 8 | 0 | 0, $2 + 88 | 0 | 0);
  cryptoxide__curve25519__fe__fe64__Fe__square__h72fd8a55cd006328($2 + 168 | 0 | 0, $2 + 128 | 0 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($2 + 208 | 0 | 0, $2 + 88 | 0 | 0, $2 + 168 | 0 | 0);
  cryptoxide__curve25519__fe__fe64__Fe__square_repeatdly__h27bbbe5ee7c76e99($2 + 248 | 0 | 0, $2 + 208 | 0 | 0, 5 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($2 + 288 | 0 | 0, $2 + 248 | 0 | 0, $2 + 208 | 0 | 0);
  cryptoxide__curve25519__fe__fe64__Fe__square_repeatdly__h27bbbe5ee7c76e99($2 + 328 | 0 | 0, $2 + 288 | 0 | 0, 10 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($2 + 368 | 0 | 0, $2 + 328 | 0 | 0, $2 + 288 | 0 | 0);
  cryptoxide__curve25519__fe__fe64__Fe__square_repeatdly__h27bbbe5ee7c76e99($2 + 408 | 0 | 0, $2 + 368 | 0 | 0, 20 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($2 + 448 | 0 | 0, $2 + 408 | 0 | 0, $2 + 368 | 0 | 0);
  cryptoxide__curve25519__fe__fe64__Fe__square_repeatdly__h27bbbe5ee7c76e99($2 + 488 | 0 | 0, $2 + 448 | 0 | 0, 10 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($2 + 528 | 0 | 0, $2 + 488 | 0 | 0, $2 + 288 | 0 | 0);
  cryptoxide__curve25519__fe__fe64__Fe__square_repeatdly__h27bbbe5ee7c76e99($2 + 568 | 0 | 0, $2 + 528 | 0 | 0, 50 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($2 + 608 | 0 | 0, $2 + 568 | 0 | 0, $2 + 528 | 0 | 0);
  cryptoxide__curve25519__fe__fe64__Fe__square_repeatdly__h27bbbe5ee7c76e99($2 + 648 | 0 | 0, $2 + 608 | 0 | 0, 100 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($2 + 688 | 0 | 0, $2 + 648 | 0 | 0, $2 + 608 | 0 | 0);
  cryptoxide__curve25519__fe__fe64__Fe__square_repeatdly__h27bbbe5ee7c76e99($2 + 728 | 0 | 0, $2 + 688 | 0 | 0, 50 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($2 + 768 | 0 | 0, $2 + 728 | 0 | 0, $2 + 528 | 0 | 0);
  cryptoxide__curve25519__fe__fe64__Fe__square_repeatdly__h27bbbe5ee7c76e99($2 + 808 | 0 | 0, $2 + 768 | 0 | 0, 2 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($0 | 0, $2 + 808 | 0 | 0, $1 | 0);
  global$0 = $2 + 848 | 0;
 }
 
 function cardano_serialization_lib__tx_builder__TransactionBuilder__get_combined_native_scripts__hf14076d78c87659b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, i64toi32_i32$0 = 0, $4 = 0, i64toi32_i32$1 = 0, $5 = 0, $5$hi = 0, $107 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 4 | 0) >> 2] = 0;
  HEAP32[($2 + 8 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[$2 >> 2] = HEAP32[(0 + 1050204 | 0) >> 2] | 0;
  cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__get_native_input_scripts__h533aaa6e57788da7($2 + 16 | 0 | 0, $1 + 96 | 0 | 0);
  label$1 : {
   if (!(HEAP32[($2 + 16 | 0) >> 2] | 0)) {
    break label$1
   }
   $3 = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
   HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = $3;
   i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   $5 = i64toi32_i32$0;
   $5$hi = i64toi32_i32$1;
   i64toi32_i32$0 = $2;
   HEAP32[($2 + 32 | 0) >> 2] = $5;
   HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
   label$2 : {
    if (!$3) {
     break label$2
    }
    i64toi32_i32$1 = $5$hi;
    $4 = $5;
    $3 = $3 << 5 | 0;
    label$3 : while (1) {
     cardano_serialization_lib__NativeScripts__add__h12de25bf2c37f302($2 | 0, $4 | 0);
     $4 = $4 + 32 | 0;
     $3 = $3 + -32 | 0;
     if ($3) {
      continue label$3
     }
     break label$3;
    };
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc3d6ec99c05cee40($2 + 32 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h0f78886c344617d4($2 + 32 | 0 | 0);
  }
  cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__get_native_input_scripts__h533aaa6e57788da7($2 + 16 | 0 | 0, $1 + 176 | 0 | 0);
  label$4 : {
   if (!(HEAP32[($2 + 16 | 0) >> 2] | 0)) {
    break label$4
   }
   $3 = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
   HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = $3;
   i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   $5 = i64toi32_i32$1;
   $5$hi = i64toi32_i32$0;
   i64toi32_i32$1 = $2;
   HEAP32[($2 + 32 | 0) >> 2] = $5;
   HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$0;
   label$5 : {
    if (!$3) {
     break label$5
    }
    i64toi32_i32$0 = $5$hi;
    $4 = $5;
    $3 = $3 << 5 | 0;
    label$6 : while (1) {
     cardano_serialization_lib__NativeScripts__add__h12de25bf2c37f302($2 | 0, $4 | 0);
     $4 = $4 + 32 | 0;
     $3 = $3 + -32 | 0;
     if ($3) {
      continue label$6
     }
     break label$6;
    };
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc3d6ec99c05cee40($2 + 32 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h0f78886c344617d4($2 + 32 | 0 | 0);
  }
  label$7 : {
   $4 = HEAP32[($1 + 456 | 0) >> 2] | 0;
   if (!$4) {
    break label$7
   }
   $3 = HEAP32[($1 + 464 | 0) >> 2] | 0;
   if (!$3) {
    break label$7
   }
   $3 = $3 << 5 | 0;
   label$8 : while (1) {
    cardano_serialization_lib__NativeScripts__add__h12de25bf2c37f302($2 | 0, $4 | 0);
    $4 = $4 + 32 | 0;
    $3 = $3 + -32 | 0;
    if ($3) {
     continue label$8
    }
    break label$8;
   };
  }
  label$9 : {
   label$10 : {
    if (!(HEAP32[($2 + 8 | 0) >> 2] | 0)) {
     break label$10
    }
    i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
    $107 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[i64toi32_i32$0 >> 2] = $107;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
    break label$9;
   }
   HEAP32[$0 >> 2] = 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc3d6ec99c05cee40($2 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h0f78886c344617d4($2 | 0);
  }
  global$0 = $2 + 48 | 0;
 }
 
 function encrypt_with_password($0, $1, $2, $3, $4, $5, $6, $7, $8) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  $5 = $5 | 0;
  $6 = $6 | 0;
  $7 = $7 | 0;
  $8 = $8 | 0;
  var $9 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $113 = 0, $129 = 0, $135 = 0;
  $9 = global$0 - 112 | 0;
  global$0 = $9;
  HEAP32[($9 + 56 | 0) >> 2] = $2;
  HEAP32[($9 + 52 | 0) >> 2] = $2;
  HEAP32[($9 + 48 | 0) >> 2] = $1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($9 + 40 | 0 | 0, $9 + 48 | 0 | 0);
  $2 = HEAP32[($9 + 44 | 0) >> 2] | 0;
  HEAP32[($9 + 68 | 0) >> 2] = $2;
  $1 = HEAP32[($9 + 40 | 0) >> 2] | 0;
  HEAP32[($9 + 64 | 0) >> 2] = $1;
  HEAP32[($9 + 56 | 0) >> 2] = $4;
  HEAP32[($9 + 52 | 0) >> 2] = $4;
  HEAP32[($9 + 48 | 0) >> 2] = $3;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($9 + 32 | 0 | 0, $9 + 48 | 0 | 0);
  $4 = HEAP32[($9 + 36 | 0) >> 2] | 0;
  HEAP32[($9 + 76 | 0) >> 2] = $4;
  $3 = HEAP32[($9 + 32 | 0) >> 2] | 0;
  HEAP32[($9 + 72 | 0) >> 2] = $3;
  HEAP32[($9 + 56 | 0) >> 2] = $6;
  HEAP32[($9 + 52 | 0) >> 2] = $6;
  HEAP32[($9 + 48 | 0) >> 2] = $5;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($9 + 24 | 0 | 0, $9 + 48 | 0 | 0);
  $6 = HEAP32[($9 + 28 | 0) >> 2] | 0;
  HEAP32[($9 + 84 | 0) >> 2] = $6;
  $5 = HEAP32[($9 + 24 | 0) >> 2] | 0;
  HEAP32[($9 + 80 | 0) >> 2] = $5;
  HEAP32[($9 + 56 | 0) >> 2] = $8;
  HEAP32[($9 + 52 | 0) >> 2] = $8;
  HEAP32[($9 + 48 | 0) >> 2] = $7;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($9 + 16 | 0 | 0, $9 + 48 | 0 | 0);
  $8 = HEAP32[($9 + 20 | 0) >> 2] | 0;
  HEAP32[($9 + 100 | 0) >> 2] = $8;
  $7 = HEAP32[($9 + 16 | 0) >> 2] | 0;
  HEAP32[($9 + 96 | 0) >> 2] = $7;
  cardano_serialization_lib__emip3__encrypt_with_password__hdf5b83dbb9fd714f($9 + 48 | 0 | 0, $1 | 0, $2 | 0, $3 | 0, $4 | 0, $5 | 0, $6 | 0, $7 | 0, $8 | 0);
  core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_3($9 + 96 | 0 | 0);
  core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_3($9 + 80 | 0 | 0);
  core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_3($9 + 72 | 0 | 0);
  core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_3($9 + 64 | 0 | 0);
  $8 = HEAP32[($9 + 52 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($9 + 48 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($8 | 0);
   abort();
  }
  i64toi32_i32$2 = ($9 + 48 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $113 = i64toi32_i32$0;
  i64toi32_i32$0 = $9;
  HEAP32[($9 + 84 | 0) >> 2] = $113;
  HEAP32[($9 + 88 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($9 + 80 | 0) >> 2] = $8;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($9 + 8 | 0 | 0, $9 + 80 | 0 | 0);
  HEAP32[(($9 + 96 | 0) + 8 | 0) >> 2] = HEAP32[(($9 + 80 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = HEAP32[($9 + 80 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($9 + 84 | 0) >> 2] | 0;
  $129 = i64toi32_i32$1;
  i64toi32_i32$1 = $9;
  HEAP32[($9 + 96 | 0) >> 2] = $129;
  HEAP32[($9 + 100 | 0) >> 2] = i64toi32_i32$0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($9 | 0, $9 + 96 | 0 | 0);
  i64toi32_i32$2 = $9;
  i64toi32_i32$0 = HEAP32[$9 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($9 + 4 | 0) >> 2] | 0;
  $135 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $135;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $9 + 112 | 0;
 }
 
 function stakedelegation_new($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $28 = 0, $5 = 0, $29 = 0, $30 = 0, $31 = 0, $32 = 0, $33 = 0, $34 = 0, $35 = 0, $36 = 0, $37 = 0, $38 = 0, $39 = 0, $3 = 0, $4 = 0, $7 = 0, $8 = 0, $9 = 0, $10 = 0, $11 = 0, $11$hi = 0, $6 = 0, $12 = 0, $12$hi = 0, $49 = 0, $68 = 0, $75 = 0, $85 = 0, $100 = 0, $105 = 0, $114 = 0, $118 = 0, $127 = 0, $130 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h7d8a0640f2deb41e($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hae9c55c4e91ce40f($2 | 0, $1 | 0);
   $4 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $1 = HEAP32[$2 >> 2] | 0;
   $28 = $0 + 25 | 0;
   $5 = HEAPU8[$28 >> 0] | 0 | ((HEAPU8[($28 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($28 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($28 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$2 = $0 + 17 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $11 = i64toi32_i32$0;
   $11$hi = i64toi32_i32$1;
   $6 = HEAPU8[$0 >> 0] | 0;
   i64toi32_i32$2 = $0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $12 = i64toi32_i32$1;
   $12$hi = i64toi32_i32$0;
   $7 = ($2 + 48 | 0) + 8 | 0;
   i64toi32_i32$2 = i64toi32_i32$2 + 9 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $49 = i64toi32_i32$0;
   i64toi32_i32$0 = $7;
   HEAP32[i64toi32_i32$0 >> 2] = $49;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   $0 = ($2 + 48 | 0) + 16 | 0;
   i64toi32_i32$1 = $11$hi;
   i64toi32_i32$0 = $0;
   HEAP32[i64toi32_i32$0 >> 2] = $11;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   $8 = ($2 + 48 | 0) + 24 | 0;
   HEAP32[$8 >> 2] = $5;
   i64toi32_i32$1 = $12$hi;
   i64toi32_i32$0 = $2;
   HEAP32[(i64toi32_i32$0 + 48 | 0) >> 2] = $12;
   HEAP32[(i64toi32_i32$0 + 52 | 0) >> 2] = i64toi32_i32$1;
   $5 = (i64toi32_i32$0 + 16 | 0) + 8 | 0;
   i64toi32_i32$2 = $1 + 8 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $68 = i64toi32_i32$1;
   i64toi32_i32$1 = $5;
   HEAP32[i64toi32_i32$1 >> 2] = $68;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   $9 = ($2 + 16 | 0) + 16 | 0;
   i64toi32_i32$2 = $1 + 16 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $75 = i64toi32_i32$0;
   i64toi32_i32$0 = $9;
   HEAP32[i64toi32_i32$0 >> 2] = $75;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   $10 = ($2 + 16 | 0) + 24 | 0;
   $29 = $1 + 24 | 0;
   HEAP32[$10 >> 2] = HEAPU8[$29 >> 0] | 0 | ((HEAPU8[($29 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($29 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($29 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $85 = i64toi32_i32$1;
   i64toi32_i32$1 = $2;
   HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $85;
   HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($4 | 0, (HEAP32[$4 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
   i64toi32_i32$2 = $7;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $100 = i64toi32_i32$0;
   i64toi32_i32$0 = ($2 + 80 | 0) + 9 | 0;
   $30 = $100;
   HEAP8[i64toi32_i32$0 >> 0] = $30;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $30 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $30 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $30 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = $0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $105 = i64toi32_i32$1;
   i64toi32_i32$1 = ($2 + 80 | 0) + 17 | 0;
   $31 = $105;
   HEAP8[i64toi32_i32$1 >> 0] = $31;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $31 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $31 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $31 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   $32 = ($2 + 80 | 0) + 25 | 0;
   $33 = HEAP32[$8 >> 2] | 0;
   HEAP8[$32 >> 0] = $33;
   HEAP8[($32 + 1 | 0) >> 0] = $33 >>> 8 | 0;
   HEAP8[($32 + 2 | 0) >> 0] = $33 >>> 16 | 0;
   HEAP8[($32 + 3 | 0) >> 0] = $33 >>> 24 | 0;
   i64toi32_i32$2 = $5;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $114 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 117 | 0;
   $34 = $114;
   HEAP8[i64toi32_i32$0 >> 0] = $34;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $34 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $34 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $34 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = $9;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $118 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 125 | 0;
   $35 = $118;
   HEAP8[i64toi32_i32$1 >> 0] = $35;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $35 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $35 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $35 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   $36 = $2 + 133 | 0;
   $37 = HEAP32[$10 >> 2] | 0;
   HEAP8[$36 >> 0] = $37;
   HEAP8[($36 + 1 | 0) >> 0] = $37 >>> 8 | 0;
   HEAP8[($36 + 2 | 0) >> 0] = $37 >>> 16 | 0;
   HEAP8[($36 + 3 | 0) >> 0] = $37 >>> 24 | 0;
   HEAP8[($2 + 80 | 0) >> 0] = $6;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] | 0;
   $127 = i64toi32_i32$0;
   i64toi32_i32$0 = i64toi32_i32$2;
   $38 = $127;
   HEAP8[(i64toi32_i32$2 + 81 | 0) >> 0] = $38;
   HEAP8[(i64toi32_i32$2 + 82 | 0) >> 0] = $38 >>> 8 | 0;
   HEAP8[(i64toi32_i32$2 + 83 | 0) >> 0] = $38 >>> 16 | 0;
   HEAP8[(i64toi32_i32$2 + 84 | 0) >> 0] = $38 >>> 24 | 0;
   HEAP8[(i64toi32_i32$2 + 85 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$2 + 86 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$2 + 87 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$2 + 88 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
   $130 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   $39 = $130;
   HEAP8[(i64toi32_i32$2 + 109 | 0) >> 0] = $39;
   HEAP8[(i64toi32_i32$2 + 110 | 0) >> 0] = $39 >>> 8 | 0;
   HEAP8[(i64toi32_i32$2 + 111 | 0) >> 0] = $39 >>> 16 | 0;
   HEAP8[(i64toi32_i32$2 + 112 | 0) >> 0] = $39 >>> 24 | 0;
   HEAP8[(i64toi32_i32$2 + 113 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$2 + 114 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$2 + 115 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$2 + 116 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   $0 = $cardano_serialization_lib__StakeDelegation_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hfbbb778a4aa15e31(i64toi32_i32$2 + 80 | 0 | 0) | 0;
   global$0 = i64toi32_i32$2 + 176 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function $alloc__string__String_20as_20core__iter__traits__collect__Extend_char____extend__h1cb79188832adf99($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $13 = 0, $16 = 0, $28 = 0, $31 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  $3 = ($2 + 8 | 0) + 8 | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $13 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $13;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $16 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $16;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
  $hex__BytesToHexChars_20as_20core__iter__traits__iterator__Iterator___size_hint__h19408d5b08e7a45d($2 + 24 | 0 | 0, $2 + 8 | 0 | 0);
  alloc__vec__Vec_T_2cA___reserve__h9cf757d86af8f187($0 | 0, HEAP32[($2 + 24 | 0) >> 2] | 0 | 0);
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $28 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 24 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $28;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $31 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $31;
  HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$0;
  label$1 : {
   $1 = $hex__BytesToHexChars_20as_20core__iter__traits__iterator__Iterator___next__hc170c11ed012196c($2 + 24 | 0 | 0) | 0;
   if (($1 | 0) == (1114112 | 0)) {
    break label$1
   }
   label$2 : while (1) {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         if ($1 >>> 0 < 128 >>> 0) {
          break label$7
         }
         HEAP32[($2 + 44 | 0) >> 2] = 0;
         if ($1 >>> 0 < 2048 >>> 0) {
          break label$6
         }
         if ($1 >>> 0 >= 65536 >>> 0) {
          break label$5
         }
         HEAP8[($2 + 46 | 0) >> 0] = $1 & 63 | 0 | 128 | 0;
         HEAP8[($2 + 44 | 0) >> 0] = $1 >>> 12 | 0 | 224 | 0;
         HEAP8[($2 + 45 | 0) >> 0] = ($1 >>> 6 | 0) & 63 | 0 | 128 | 0;
         $1 = 3;
         break label$4;
        }
        label$8 : {
         $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
         if (($3 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
          break label$8
         }
         alloc__vec__Vec_T_2cA___reserve__h9cf757d86af8f187($0 | 0, 1 | 0);
         $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
        }
        HEAP8[((HEAP32[$0 >> 2] | 0) + $3 | 0) >> 0] = $1;
        HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
        break label$3;
       }
       HEAP8[($2 + 45 | 0) >> 0] = $1 & 63 | 0 | 128 | 0;
       HEAP8[($2 + 44 | 0) >> 0] = $1 >>> 6 | 0 | 192 | 0;
       $1 = 2;
       break label$4;
      }
      HEAP8[($2 + 47 | 0) >> 0] = $1 & 63 | 0 | 128 | 0;
      HEAP8[($2 + 44 | 0) >> 0] = $1 >>> 18 | 0 | 240 | 0;
      HEAP8[($2 + 46 | 0) >> 0] = ($1 >>> 6 | 0) & 63 | 0 | 128 | 0;
      HEAP8[($2 + 45 | 0) >> 0] = ($1 >>> 12 | 0) & 63 | 0 | 128 | 0;
      $1 = 4;
     }
     alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($0 | 0, $2 + 44 | 0 | 0, $1 | 0);
    }
    $1 = $hex__BytesToHexChars_20as_20core__iter__traits__iterator__Iterator___next__hc170c11ed012196c($2 + 24 | 0 | 0) | 0;
    if (($1 | 0) != (1114112 | 0)) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $2 + 48 | 0;
 }
 
 function cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__add_script_input__ha8e1111a100bff34($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $4 = 0, $5 = 0, $26 = 0, $27 = 0, $28 = 0, $29 = 0, $30 = 0, $8 = 0, $9 = 0, $7 = 0, $7$hi = 0, $6 = 0, $8$hi = 0, $9$hi = 0, $47 = 0, $52 = 0, $57 = 0, $62 = 0, $66 = 0, $72 = 0, $78 = 0, $107 = 0, $112 = 0, $115 = 0;
  $4 = global$0 - 352 | 0;
  global$0 = $4;
  $5 = $2 + 4 | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  $6 = HEAP32[$2 >> 2] | 0;
  $2 = 0;
  label$1 : {
   if ((HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($4 + 200 | 0 | 4 | 0 | 0, $3 + 12 | 0 | 0);
   $2 = 1;
  }
  i64toi32_i32$2 = ($4 + 200 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$1;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$1 = $4 + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $8;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($4 + 200 | 0) >> 2] = $2;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[($4 + 200 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($4 + 204 | 0) >> 2] | 0;
  $9 = i64toi32_i32$0;
  $9$hi = i64toi32_i32$1;
  i64toi32_i32$0 = $4;
  HEAP32[i64toi32_i32$0 >> 2] = $9;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = (i64toi32_i32$0 + 200 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $5;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $47 = i64toi32_i32$1;
  i64toi32_i32$1 = $4 + 228 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $47;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $52 = i64toi32_i32$0;
  i64toi32_i32$0 = $4 + 236 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $52;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $5 + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $57 = i64toi32_i32$1;
  i64toi32_i32$1 = $4 + 244 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $57;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $5 + 24 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $62 = i64toi32_i32$0;
  i64toi32_i32$0 = $4 + 252 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $62;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $66 = i64toi32_i32$1;
  i64toi32_i32$1 = $4 + 265 | 0;
  $26 = $66;
  HEAP8[i64toi32_i32$1 >> 0] = $26;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $26 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $26 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $26 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $5 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $72 = i64toi32_i32$0;
  i64toi32_i32$0 = $4 + 273 | 0;
  $27 = $72;
  HEAP8[i64toi32_i32$0 >> 0] = $27;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $27 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $27 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $27 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $3 = $1 + 16 | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $78 = i64toi32_i32$1;
  i64toi32_i32$1 = $4 + 281 | 0;
  $28 = $78;
  HEAP8[i64toi32_i32$1 >> 0] = $28;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $28 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $28 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $28 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $2 = $1 + 24 | 0;
  $29 = $4 + 289 | 0;
  $30 = HEAPU8[$2 >> 0] | 0 | ((HEAPU8[($2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  HEAP8[$29 >> 0] = $30;
  HEAP8[($29 + 1 | 0) >> 0] = $30 >>> 8 | 0;
  HEAP8[($29 + 2 | 0) >> 0] = $30 >>> 16 | 0;
  HEAP8[($29 + 3 | 0) >> 0] = $30 >>> 24 | 0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$1 = $4;
  HEAP32[(i64toi32_i32$1 + 208 | 0) >> 2] = $9;
  HEAP32[(i64toi32_i32$1 + 212 | 0) >> 2] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 264 | 0) >> 0] = 1;
  HEAP32[(i64toi32_i32$1 + 224 | 0) >> 2] = $6;
  i64toi32_i32$0 = $7$hi;
  HEAP32[(i64toi32_i32$1 + 200 | 0) >> 2] = $7;
  HEAP32[(i64toi32_i32$1 + 204 | 0) >> 2] = i64toi32_i32$0;
  cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__push_input__h5d706b01e1a860c0($0 | 0, i64toi32_i32$1 + 200 | 0 | 0);
  label$2 : {
   if (hashbrown__map__HashMap_K_2cV_2cS_2cA___contains_key__h0a193e832d1442fa($0 | 0, $1 | 0) | 0) {
    break label$2
   }
   HEAP32[(($4 + 168 | 0) + 24 | 0) >> 2] = HEAPU8[$2 >> 0] | 0 | ((HEAPU8[($2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$2 = $3;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $107 = i64toi32_i32$0;
   i64toi32_i32$0 = ($4 + 168 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $107;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $5;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $112 = i64toi32_i32$1;
   i64toi32_i32$1 = ($4 + 168 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $112;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $1;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $115 = i64toi32_i32$0;
   i64toi32_i32$0 = $4;
   HEAP32[(i64toi32_i32$0 + 168 | 0) >> 2] = $115;
   HEAP32[(i64toi32_i32$0 + 172 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = 0;
   HEAP32[(i64toi32_i32$0 + 200 | 0) >> 2] = 2;
   HEAP32[(i64toi32_i32$0 + 204 | 0) >> 2] = i64toi32_i32$1;
   linked_hash_map__LinkedHashMap_K_2cV_2cS___insert__h0e2ff8a07783b7ab(i64toi32_i32$0 + 16 | 0 | 0, $0 | 0, i64toi32_i32$0 + 168 | 0 | 0, i64toi32_i32$0 + 200 | 0 | 0);
   core__ptr__drop_in_place_core__option__Option_core__option__Option_cardano_serialization_lib__tx_builder__tx_inputs_builder__ScriptWitnessType_____hc1cbaf0cb4e97823(i64toi32_i32$0 + 16 | 0 | 0);
  }
  global$0 = $4 + 352 | 0;
 }
 
 function cbor_event__se__Serializer_W___write_special__had0377f4ca98c84d($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $39 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $3 = global$0 - 80 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    switch (HEAPU8[$2 >> 0] | 0 | 0) {
    case 1:
     (wasm2js_i32$0 = $3, wasm2js_i32$1 = cbor_event__types__Type__to_byte__h30363627277739c1(7 | 0, 22 | 0) | 0), HEAP8[(wasm2js_i32$0 + 48 | 0) >> 0] = wasm2js_i32$1;
     alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($1 | 0, $3 + 48 | 0 | 0, 1 | 0);
     break label$1;
    case 2:
     (wasm2js_i32$0 = $3, wasm2js_i32$1 = cbor_event__types__Type__to_byte__h30363627277739c1(7 | 0, 23 | 0) | 0), HEAP8[(wasm2js_i32$0 + 48 | 0) >> 0] = wasm2js_i32$1;
     alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($1 | 0, $3 + 48 | 0 | 0, 1 | 0);
     break label$1;
    case 4:
     HEAPF64[($3 + 8 | 0) >> 3] = +HEAPF64[($2 + 8 | 0) >> 3];
     core__fmt__ArgumentV1__new__hb80fee3ef14de7d5($3 | 0, $3 + 8 | 0 | 0, 145 | 0);
     HEAP32[(($3 + 48 | 0) + 20 | 0) >> 2] = 1;
     HEAP32[(($3 + 16 | 0) + 20 | 0) >> 2] = 1;
     i64toi32_i32$1 = $3;
     i64toi32_i32$0 = 0;
     HEAP32[($3 + 52 | 0) >> 2] = 1;
     HEAP32[($3 + 56 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($3 + 48 | 0) >> 2] = 1071932;
     HEAP32[($3 + 44 | 0) >> 2] = 146;
     i64toi32_i32$1 = $3;
     i64toi32_i32$0 = 0;
     HEAP32[($3 + 20 | 0) >> 2] = 1;
     HEAP32[($3 + 24 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($3 + 16 | 0) >> 2] = 1071848;
     i64toi32_i32$0 = HEAP32[$3 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($3 + 4 | 0) >> 2] | 0;
     $39 = i64toi32_i32$0;
     i64toi32_i32$0 = $3;
     HEAP32[($3 + 72 | 0) >> 2] = $39;
     HEAP32[($3 + 76 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($3 + 64 | 0) >> 2] = $3 + 72 | 0;
     HEAP32[($3 + 40 | 0) >> 2] = $3 + 48 | 0;
     HEAP32[($3 + 32 | 0) >> 2] = $3 + 40 | 0;
     core__panicking__panic_fmt__hbf21a3d4bbb82bf8($3 + 16 | 0 | 0, 1072032 | 0);
     abort();
    case 5:
     (wasm2js_i32$0 = $3, wasm2js_i32$1 = cbor_event__types__Type__to_byte__h30363627277739c1(7 | 0, 31 | 0) | 0), HEAP8[(wasm2js_i32$0 + 48 | 0) >> 0] = wasm2js_i32$1;
     alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($1 | 0, $3 + 48 | 0 | 0, 1 | 0);
     break label$1;
    case 3:
     label$8 : {
      $2 = HEAPU8[($2 + 1 | 0) >> 0] | 0;
      if ($2 >>> 0 < 20 >>> 0) {
       break label$8
      }
      (wasm2js_i32$0 = $3, wasm2js_i32$1 = cbor_event__types__Type__to_byte__h30363627277739c1(7 | 0, 24 | 0) | 0), HEAP8[(wasm2js_i32$0 + 48 | 0) >> 0] = wasm2js_i32$1;
      alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($1 | 0, $3 + 48 | 0 | 0, 1 | 0);
      HEAP8[($3 + 48 | 0) >> 0] = $2;
      alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($1 | 0, $3 + 48 | 0 | 0, 1 | 0);
      break label$1;
     }
     (wasm2js_i32$0 = $3, wasm2js_i32$1 = cbor_event__types__Type__to_byte__h30363627277739c1(7 | 0, $2 | 0) | 0), HEAP8[(wasm2js_i32$0 + 48 | 0) >> 0] = wasm2js_i32$1;
     alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($1 | 0, $3 + 48 | 0 | 0, 1 | 0);
     break label$1;
    default:
     break label$2;
    };
   }
   label$9 : {
    if (!(HEAPU8[($2 + 1 | 0) >> 0] | 0)) {
     break label$9
    }
    (wasm2js_i32$0 = $3, wasm2js_i32$1 = cbor_event__types__Type__to_byte__h30363627277739c1(7 | 0, 21 | 0) | 0), HEAP8[(wasm2js_i32$0 + 48 | 0) >> 0] = wasm2js_i32$1;
    alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($1 | 0, $3 + 48 | 0 | 0, 1 | 0);
    break label$1;
   }
   (wasm2js_i32$0 = $3, wasm2js_i32$1 = cbor_event__types__Type__to_byte__h30363627277739c1(7 | 0, 20 | 0) | 0), HEAP8[(wasm2js_i32$0 + 48 | 0) >> 0] = wasm2js_i32$1;
   alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($1 | 0, $3 + 48 | 0 | 0, 1 | 0);
  }
  HEAP32[$0 >> 2] = 0;
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  global$0 = $3 + 80 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert_fit__h0f5adcefcac0e336($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $6 = 0, $5 = 0, $7 = 0, $8 = 0, i64toi32_i32$1 = 0, $9 = 0, i64toi32_i32$0 = 0, $10 = 0, $56 = 0, $86 = 0;
  $5 = global$0 - 128 | 0;
  global$0 = $5;
  $6 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  $7 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $0 = HEAPU16[($7 + 1546 | 0) >> 1] | 0;
  $5 = memcpy($5 | 0, $1 | 0, 128 | 0) | 0;
  label$1 : {
   $1 = $6 + 1 | 0;
   $8 = $1 >>> 0 > $0 >>> 0;
   if ($8) {
    break label$1
   }
   memmove($7 + ($1 << 7 | 0) | 0 | 0, $7 + ($6 << 7 | 0) | 0 | 0, ($0 - $6 | 0) << 7 | 0 | 0) | 0;
  }
  memcpy($7 + ($6 << 7 | 0) | 0 | 0, $5 | 0, 128 | 0) | 0;
  $9 = $5 + 8 | 0;
  HEAP32[$9 >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $56 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[$5 >> 2] = $56;
  HEAP32[($5 + 4 | 0) >> 2] = i64toi32_i32$1;
  label$2 : {
   if ($8) {
    break label$2
   }
   $2 = $7 + 1412 | 0;
   memmove($2 + Math_imul($1, 12) | 0 | 0, $2 + Math_imul($6, 12) | 0 | 0, Math_imul($0 - $6 | 0, 12) | 0) | 0;
  }
  $2 = $0 + 1 | 0;
  $8 = $7 + Math_imul($6, 12) | 0;
  HEAP32[($8 + 1420 | 0) >> 2] = HEAP32[$9 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[$5 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($5 + 4 | 0) >> 2] | 0;
  $86 = i64toi32_i32$1;
  i64toi32_i32$1 = $8 + 1412 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $86;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  label$3 : {
   $9 = $6 + 2 | 0;
   $8 = $0 + 2 | 0;
   if ($9 >>> 0 >= $8 >>> 0) {
    break label$3
   }
   $10 = $7 + 1552 | 0;
   memmove($10 + ($9 << 2 | 0) | 0 | 0, $10 + ($1 << 2 | 0) | 0 | 0, ($0 - $6 | 0) << 2 | 0 | 0) | 0;
  }
  HEAP32[(($7 + ($1 << 2 | 0) | 0) + 1552 | 0) >> 2] = $4;
  HEAP16[($7 + 1546 | 0) >> 1] = $2;
  label$4 : {
   if ($1 >>> 0 >= $8 >>> 0) {
    break label$4
   }
   $2 = $0 + 1 | 0;
   $0 = (($6 << 2 | 0) + $7 | 0) + 1556 | 0;
   label$5 : while (1) {
    $1 = HEAP32[$0 >> 2] | 0;
    $6 = $6 + 1 | 0;
    HEAP16[($1 + 1544 | 0) >> 1] = $6;
    HEAP32[($1 + 1408 | 0) >> 2] = $7;
    $0 = $0 + 4 | 0;
    if (($2 | 0) != ($6 | 0)) {
     continue label$5
    }
    break label$5;
   };
  }
  global$0 = $5 + 128 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert__h236f944aa12520cb($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var i64toi32_i32$2 = 0, $5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $17 = 0, $18 = 0, $6 = 0, $7 = 0, $56 = 0, $61 = 0, $64 = 0, $100 = 0, $106 = 0, $109 = 0;
  $5 = global$0 - 96 | 0;
  global$0 = $5;
  label$1 : {
   label$2 : {
    $6 = HEAP32[$1 >> 2] | 0;
    if (($6 + -1 | 0 | 0) != ($3 | 0)) {
     break label$2
    }
    label$3 : {
     label$4 : {
      label$5 : {
       $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
       if ((HEAPU16[($3 + 6 | 0) >> 1] | 0) >>> 0 < 11 >>> 0) {
        break label$5
       }
       alloc__collections__btree__node__splitpoint__h8424344594b4deb1($5 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
       $1 = HEAP32[($5 + 8 | 0) >> 2] | 0;
       $7 = HEAP32[($5 + 4 | 0) >> 2] | 0;
       HEAP32[($5 + 72 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
       HEAP32[($5 + 68 | 0) >> 2] = $3;
       HEAP32[($5 + 64 | 0) >> 2] = $6;
       alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__KV___split__h9b427b91ab57d92a($5 | 0, $5 + 64 | 0 | 0);
       if (($7 | 0) == (1 | 0)) {
        break label$4
       }
       HEAP32[($5 + 48 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
       $3 = HEAP32[($5 + 4 | 0) >> 2] | 0;
       break label$3;
      }
      $17 = $2 + 24 | 0;
      HEAP32[($5 + 24 | 0) >> 2] = HEAPU8[$17 >> 0] | 0 | ((HEAPU8[($17 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($17 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($17 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$2 = $2 + 16 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $56 = i64toi32_i32$0;
      i64toi32_i32$0 = $5 + 16 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $56;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $2 + 8 | 0;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $61 = i64toi32_i32$1;
      i64toi32_i32$1 = $5 + 8 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $61;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $2;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $64 = i64toi32_i32$0;
      i64toi32_i32$0 = $5;
      HEAP32[$5 >> 2] = $64;
      HEAP32[($5 + 4 | 0) >> 2] = i64toi32_i32$1;
      alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert_fit__hbb34fc2956828e73($1 | 0, $5 | 0, $5 | 0, $4 | 0);
      HEAP32[($0 + 8 | 0) >> 2] = $3;
      HEAP32[($0 + 4 | 0) >> 2] = $6;
      HEAP32[$0 >> 2] = 0;
      HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
      break label$1;
     }
     HEAP32[($5 + 48 | 0) >> 2] = HEAP32[($5 + 8 | 0) >> 2] | 0;
     $3 = HEAP32[($5 + 12 | 0) >> 2] | 0;
    }
    HEAP32[($5 + 56 | 0) >> 2] = $1;
    HEAP32[($5 + 52 | 0) >> 2] = $3;
    $18 = $2 + 24 | 0;
    HEAP32[(($5 + 64 | 0) + 24 | 0) >> 2] = HEAPU8[$18 >> 0] | 0 | ((HEAPU8[($18 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($18 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($18 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$2 = $2 + 16 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $100 = i64toi32_i32$1;
    i64toi32_i32$1 = ($5 + 64 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $100;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $2 + 8 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $106 = i64toi32_i32$0;
    i64toi32_i32$0 = ($5 + 64 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $106;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $109 = i64toi32_i32$1;
    i64toi32_i32$1 = $5;
    HEAP32[($5 + 64 | 0) >> 2] = $109;
    HEAP32[($5 + 68 | 0) >> 2] = i64toi32_i32$0;
    alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert_fit__hbb34fc2956828e73($5 + 48 | 0 | 0, $5 + 64 | 0 | 0, $5 | 0, $4 | 0);
    memcpy($0 + 4 | 0 | 0, $5 | 0, 44 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    break label$1;
   }
   core__panicking__panic__h2fd385a887c8bf13(1049076 | 0, 53 | 0, 1049132 | 0);
   abort();
  }
  global$0 = $5 + 96 | 0;
 }
 
 function cardano_serialization_lib__NativeScripts__get__h1c4b6c833053ec03($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $3 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $4 = 0, $29 = 0, $34 = 0, $38 = 0, $74 = 0, $80 = 0, $85 = 0, $92 = 0, $95 = 0, $100 = 0, $105 = 0, $110 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  label$1 : {
   $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   if ($4 >>> 0 <= $2 >>> 0) {
    break label$1
   }
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          $2 = (HEAP32[$1 >> 2] | 0) + ($2 << 5 | 0) | 0;
          switch (HEAPU8[$2 >> 0] | 0 | 0) {
          case 5:
           break label$3;
          case 4:
           break label$4;
          case 3:
           break label$5;
          case 2:
           break label$6;
          case 1:
           break label$7;
          default:
           break label$8;
          };
         }
         $19 = $2 + 25 | 0;
         $20 = $3 + 25 | 0;
         $21 = HEAPU8[$19 >> 0] | 0 | ((HEAPU8[($19 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($19 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($19 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         HEAP8[$20 >> 0] = $21;
         HEAP8[($20 + 1 | 0) >> 0] = $21 >>> 8 | 0;
         HEAP8[($20 + 2 | 0) >> 0] = $21 >>> 16 | 0;
         HEAP8[($20 + 3 | 0) >> 0] = $21 >>> 24 | 0;
         i64toi32_i32$2 = $2 + 17 | 0;
         i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $29 = i64toi32_i32$0;
         i64toi32_i32$0 = $3 + 17 | 0;
         $22 = $29;
         HEAP8[i64toi32_i32$0 >> 0] = $22;
         HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $22 >>> 8 | 0;
         HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $22 >>> 16 | 0;
         HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $22 >>> 24 | 0;
         HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
         HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
         HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
         HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
         i64toi32_i32$2 = $2 + 9 | 0;
         i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $34 = i64toi32_i32$1;
         i64toi32_i32$1 = $3 + 9 | 0;
         $23 = $34;
         HEAP8[i64toi32_i32$1 >> 0] = $23;
         HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $23 >>> 8 | 0;
         HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $23 >>> 16 | 0;
         HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $23 >>> 24 | 0;
         HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
         HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
         HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
         HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
         HEAP8[$3 >> 0] = 0;
         i64toi32_i32$2 = $2;
         i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
         $38 = i64toi32_i32$0;
         i64toi32_i32$0 = $3;
         $24 = $38;
         HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $24;
         HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $24 >>> 8 | 0;
         HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $24 >>> 16 | 0;
         HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = $24 >>> 24 | 0;
         HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1;
         HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
         HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
         HEAP8[(i64toi32_i32$0 + 8 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
         break label$2;
        }
        alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($3 | 4 | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
        HEAP8[$3 >> 0] = 1;
        break label$2;
       }
       alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($3 | 4 | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
       HEAP8[$3 >> 0] = 2;
       break label$2;
      }
      $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
      alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($3 + 32 | 0 | 4 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 16 | 0) >> 2] | 0 | 0);
      i64toi32_i32$2 = ($3 + 32 | 0) + 8 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $74 = i64toi32_i32$1;
      i64toi32_i32$1 = $3 + 12 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $74;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[($3 + 32 | 0) >> 2] = $1;
      HEAP8[$3 >> 0] = 3;
      i64toi32_i32$2 = $3;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
      $80 = i64toi32_i32$0;
      i64toi32_i32$0 = i64toi32_i32$2;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $80;
      HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
      break label$2;
     }
     i64toi32_i32$2 = $2 + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $85 = i64toi32_i32$1;
     i64toi32_i32$1 = $3 + 8 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $85;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     HEAP8[$3 >> 0] = 4;
     break label$2;
    }
    HEAP8[$3 >> 0] = 5;
    i64toi32_i32$2 = $2 + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $92 = i64toi32_i32$0;
    i64toi32_i32$0 = $3 + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $92;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   }
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $95 = i64toi32_i32$1;
   i64toi32_i32$1 = $0;
   HEAP32[i64toi32_i32$1 >> 2] = $95;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = i64toi32_i32$2 + 24 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $100 = i64toi32_i32$0;
   i64toi32_i32$0 = $0 + 24 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $100;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $3 + 16 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $105 = i64toi32_i32$1;
   i64toi32_i32$1 = $0 + 16 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $105;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $3 + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $110 = i64toi32_i32$0;
   i64toi32_i32$0 = $0 + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $110;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   global$0 = $3 + 48 | 0;
   return;
  }
  core__panicking__panic_bounds_check__h808b524af17640b1($2 | 0, $4 | 0, 1054020 | 0);
  abort();
 }
 
 function cardano_serialization_lib__output_builder__TransactionOutputBuilder__next__h0f48f77be94ddfc5($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $2 = 0, $4 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $3 = 0, $5 = 0, $6 = 0, $7 = 0, $8 = 0, $44 = 0, $49 = 0, $54 = 0, $58 = 0, $5$hi = 0, $6$hi = 0, $7$hi = 0;
  $2 = global$0 - 224 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if ((HEAPU8[$1 >> 0] | 0 | 0) != (5 | 0)) {
     break label$2
    }
    HEAP8[($2 + 160 | 0) >> 0] = 5;
    $3 = 1;
    break label$1;
   }
   $cardano_serialization_lib__address__Address_20as_20core__clone__Clone___clone__h0eb465a6e349d507_1($2 + 160 | 0 | 0, $1 | 0);
   $3 = (HEAPU8[($2 + 160 | 0) >> 0] | 0 | 0) == (5 | 0);
  }
  $4 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1056972 | 0, 45 | 0) | 0;
  label$3 : {
   label$4 : {
    if ($3) {
     break label$4
    }
    memcpy($2 + 96 | 0 | 0, $2 + 160 | 0 | 0, 64 | 0) | 0;
    label$5 : {
     if ($4 >>> 0 < 36 >>> 0) {
      break label$5
     }
     wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($4 | 0);
    }
    memcpy($2 + 32 | 0 | 0, $2 + 96 | 0 | 0, 64 | 0) | 0;
    $4 = 0;
    label$6 : {
     if ((HEAPU8[($1 + 64 | 0) >> 0] | 0 | 0) != (1 | 0)) {
      break label$6
     }
     i64toi32_i32$2 = $1 + 89 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $44 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 184 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $44;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $1 + 81 | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $49 = i64toi32_i32$1;
     i64toi32_i32$1 = $2 + 176 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $49;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $1 + 73 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $54 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 168 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $54;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $1 + 65 | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $58 = i64toi32_i32$1;
     i64toi32_i32$1 = $2;
     HEAP32[(i64toi32_i32$1 + 160 | 0) >> 2] = $58;
     HEAP32[(i64toi32_i32$1 + 164 | 0) >> 2] = i64toi32_i32$0;
     $4 = 1;
    }
    memcpy($0 + 8 | 0 | 0, $2 + 32 | 0 | 0, 64 | 0) | 0;
    i64toi32_i32$2 = ($2 + 160 | 0) + 24 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $5 = i64toi32_i32$0;
    $5$hi = i64toi32_i32$1;
    i64toi32_i32$0 = $2 + 24 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $5;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = ($2 + 160 | 0) + 16 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $6 = i64toi32_i32$1;
    $6$hi = i64toi32_i32$0;
    i64toi32_i32$1 = $2 + 16 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $6;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = ($2 + 160 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $7 = i64toi32_i32$0;
    $7$hi = i64toi32_i32$1;
    i64toi32_i32$0 = $2 + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $7;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 160 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 164 | 0) >> 2] | 0;
    $8 = i64toi32_i32$1;
    i64toi32_i32$1 = i64toi32_i32$2;
    HEAP32[i64toi32_i32$2 >> 2] = $8;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
    HEAP8[($0 + 96 | 0) >> 0] = $4;
    HEAP32[($0 + 80 | 0) >> 2] = 2;
    i64toi32_i32$1 = $0;
    $19 = $8;
    HEAP8[(i64toi32_i32$1 + 97 | 0) >> 0] = $19;
    HEAP8[(i64toi32_i32$1 + 98 | 0) >> 0] = $19 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 99 | 0) >> 0] = $19 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 100 | 0) >> 0] = $19 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 101 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 102 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 103 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 104 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$0 = $7$hi;
    i64toi32_i32$1 = i64toi32_i32$1 + 105 | 0;
    $20 = $7;
    HEAP8[i64toi32_i32$1 >> 0] = $20;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $20 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $20 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $20 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$0 = $6$hi;
    i64toi32_i32$1 = $0 + 113 | 0;
    $21 = $6;
    HEAP8[i64toi32_i32$1 >> 0] = $21;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $21 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $21 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $21 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$0 = $5$hi;
    i64toi32_i32$1 = $0 + 121 | 0;
    $22 = $5;
    HEAP8[i64toi32_i32$1 >> 0] = $22;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $22 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $22 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $22 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    HEAP32[$0 >> 2] = 0;
    break label$3;
   }
   $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($4 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
  }
  global$0 = $2 + 224 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert__h5345db8c0861aede($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $5 = 0, $6 = 0, $7 = 0, $58 = 0, $99 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $4 = global$0 - 368 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $5 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      if ((HEAPU16[($5 + 1546 | 0) >> 1] | 0) >>> 0 < 11 >>> 0) {
       break label$4
      }
      alloc__collections__btree__node__splitpoint__h8424344594b4deb1($4 + 200 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
      $6 = HEAP32[($4 + 208 | 0) >> 2] | 0;
      $7 = HEAP32[($4 + 204 | 0) >> 2] | 0;
      $1 = HEAP32[$1 >> 2] | 0;
      HEAP32[($4 + 208 | 0) >> 2] = HEAP32[($4 + 200 | 0) >> 2] | 0;
      HEAP32[($4 + 204 | 0) >> 2] = $5;
      HEAP32[($4 + 200 | 0) >> 2] = $1;
      alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__KV___split__h76d4343220eb9849($4 + 8 | 0 | 0, $4 + 200 | 0 | 0);
      if (($7 | 0) == (1 | 0)) {
       break label$3
      }
      HEAP32[($4 + 168 | 0) >> 2] = HEAP32[($4 + 152 | 0) >> 2] | 0;
      $1 = HEAP32[($4 + 156 | 0) >> 2] | 0;
      break label$2;
     }
     memcpy($4 + 200 | 0 | 0, $2 | 0, 128 | 0) | 0;
     HEAP32[(($4 + 8 | 0) + 8 | 0) >> 2] = HEAP32[($3 + 8 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[$3 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($3 + 4 | 0) >> 2] | 0;
     $58 = i64toi32_i32$0;
     i64toi32_i32$0 = $4;
     HEAP32[($4 + 8 | 0) >> 2] = $58;
     HEAP32[($4 + 12 | 0) >> 2] = i64toi32_i32$1;
     (wasm2js_i32$0 = $0, wasm2js_i32$1 = alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_fit__h04dba6bc5ffb39a3($1 | 0, $4 + 200 | 0 | 0, $4 + 8 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 168 | 0) >> 2] = wasm2js_i32$1;
     HEAP32[($0 + 8 | 0) >> 2] = $5;
     HEAP32[$0 >> 2] = 0;
     HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
     HEAP32[($0 + 4 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
     break label$1;
    }
    HEAP32[($4 + 168 | 0) >> 2] = HEAP32[($4 + 160 | 0) >> 2] | 0;
    $1 = HEAP32[($4 + 164 | 0) >> 2] | 0;
   }
   HEAP32[($4 + 176 | 0) >> 2] = $6;
   HEAP32[($4 + 172 | 0) >> 2] = $1;
   memcpy($4 + 200 | 0 | 0, $2 | 0, 128 | 0) | 0;
   HEAP32[(($4 + 184 | 0) + 8 | 0) >> 2] = HEAP32[($3 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[$3 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($3 + 4 | 0) >> 2] | 0;
   $99 = i64toi32_i32$1;
   i64toi32_i32$1 = $4;
   HEAP32[($4 + 184 | 0) >> 2] = $99;
   HEAP32[($4 + 188 | 0) >> 2] = i64toi32_i32$0;
   $1 = alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_fit__h04dba6bc5ffb39a3($4 + 168 | 0 | 0, $4 + 200 | 0 | 0, $4 + 184 | 0 | 0) | 0;
   memcpy(($4 + 200 | 0) + 4 | 0 | 0, $4 + 8 | 0 | 0, 160 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
   memcpy($0 + 4 | 0 | 0, $4 + 200 | 0 | 0, 164 | 0) | 0;
   HEAP32[($0 + 168 | 0) >> 2] = $1;
  }
  global$0 = $4 + 368 | 0;
 }
 
 function core__fmt__Write__write_char__hcb93f82e62502192($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$4 = 0, $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $7 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, $7$hi = 0, $4 = 0, $16 = 0, $17 = 0, $5 = 0, $6 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $3 = 0, $99 = 0, $103 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  HEAP32[($2 + 12 | 0) >> 2] = 0;
  label$1 : {
   label$2 : {
    if ($1 >>> 0 < 128 >>> 0) {
     break label$2
    }
    label$3 : {
     if ($1 >>> 0 < 2048 >>> 0) {
      break label$3
     }
     label$4 : {
      if ($1 >>> 0 < 65536 >>> 0) {
       break label$4
      }
      HEAP8[($2 + 15 | 0) >> 0] = $1 & 63 | 0 | 128 | 0;
      HEAP8[($2 + 12 | 0) >> 0] = $1 >>> 18 | 0 | 240 | 0;
      HEAP8[($2 + 14 | 0) >> 0] = ($1 >>> 6 | 0) & 63 | 0 | 128 | 0;
      HEAP8[($2 + 13 | 0) >> 0] = ($1 >>> 12 | 0) & 63 | 0 | 128 | 0;
      $1 = 4;
      break label$1;
     }
     HEAP8[($2 + 14 | 0) >> 0] = $1 & 63 | 0 | 128 | 0;
     HEAP8[($2 + 12 | 0) >> 0] = $1 >>> 12 | 0 | 224 | 0;
     HEAP8[($2 + 13 | 0) >> 0] = ($1 >>> 6 | 0) & 63 | 0 | 128 | 0;
     $1 = 3;
     break label$1;
    }
    HEAP8[($2 + 13 | 0) >> 0] = $1 & 63 | 0 | 128 | 0;
    HEAP8[($2 + 12 | 0) >> 0] = $1 >>> 6 | 0 | 192 | 0;
    $1 = 2;
    break label$1;
   }
   HEAP8[($2 + 12 | 0) >> 0] = $1;
   $1 = 1;
  }
  label$5 : {
   i64toi32_i32$0 = $std__io__stdio__StdoutLock_20as_20std__io__Write___write_all__ha8d32e9dac01e4a2(HEAP32[$0 >> 2] | 0 | 0, $2 + 12 | 0 | 0, $1 | 0) | 0;
   i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
   $7 = i64toi32_i32$0;
   $7$hi = i64toi32_i32$1;
   $3 = i64toi32_i32$0;
   $1 = i64toi32_i32$0 & 255 | 0;
   if (($1 | 0) == (4 | 0)) {
    break label$5
   }
   i64toi32_i32$1 = $7$hi;
   i64toi32_i32$2 = $7;
   i64toi32_i32$0 = 0;
   i64toi32_i32$3 = 8;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$0 = 0;
    $17 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   } else {
    i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
    $17 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
   }
   $7 = $17;
   $7$hi = i64toi32_i32$0;
   label$6 : {
    if ((HEAPU8[($0 + 4 | 0) >> 0] | 0 | 0) != (3 | 0)) {
     break label$6
    }
    $4 = HEAP32[($0 + 8 | 0) >> 2] | 0;
    FUNCTION_TABLE[HEAP32[(HEAP32[($4 + 4 | 0) >> 2] | 0) >> 2] | 0 | 0](HEAP32[$4 >> 2] | 0);
    label$7 : {
     $5 = HEAP32[($4 + 4 | 0) >> 2] | 0;
     $6 = HEAP32[($5 + 4 | 0) >> 2] | 0;
     if (!$6) {
      break label$7
     }
     __rust_dealloc(HEAP32[$4 >> 2] | 0 | 0, $6 | 0, HEAP32[($5 + 8 | 0) >> 2] | 0 | 0);
    }
    __rust_dealloc($4 | 0, 12 | 0, 4 | 0);
   }
   HEAP8[($0 + 4 | 0) >> 0] = $3;
   $99 = $0 + 11 | 0;
   i64toi32_i32$0 = $7$hi;
   i64toi32_i32$1 = $7;
   i64toi32_i32$2 = 0;
   i64toi32_i32$3 = 48;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$2 = 0;
    $18 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   } else {
    i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
    $18 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
   }
   HEAP8[$99 >> 0] = $18;
   $103 = $0 + 9 | 0;
   i64toi32_i32$2 = $7$hi;
   i64toi32_i32$0 = $7;
   i64toi32_i32$1 = 0;
   i64toi32_i32$3 = 32;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$1 = 0;
    $19 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   } else {
    i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
    $19 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
   }
   $20 = $103;
   $21 = $19;
   HEAP8[$20 >> 0] = $21;
   HEAP8[($20 + 1 | 0) >> 0] = $21 >>> 8 | 0;
   i64toi32_i32$1 = $7$hi;
   $16 = $0 + 5 | 0;
   HEAP8[$16 >> 0] = $7;
   HEAP8[($16 + 1 | 0) >> 0] = $7 >>> 8 | 0;
   HEAP8[($16 + 2 | 0) >> 0] = $7 >>> 16 | 0;
   HEAP8[($16 + 3 | 0) >> 0] = $7 >>> 24 | 0;
  }
  global$0 = $2 + 16 | 0;
  return ($1 | 0) != (4 | 0) | 0;
 }
 
 function core__panicking__assert_failed_inner__h88a2a8b36b85926c($0, $1, $2, $3, $4, $5, $6) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  $5 = $5 | 0;
  $6 = $6 | 0;
  var $7 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $59 = 0, $65 = 0, $68 = 0;
  $7 = global$0 - 112 | 0;
  global$0 = $7;
  HEAP32[($7 + 12 | 0) >> 2] = $2;
  HEAP32[($7 + 8 | 0) >> 2] = $1;
  HEAP32[($7 + 20 | 0) >> 2] = $4;
  HEAP32[($7 + 16 | 0) >> 2] = $3;
  label$1 : {
   label$2 : {
    switch ($0 & 255 | 0 | 0) {
    default:
     HEAP32[($7 + 24 | 0) >> 2] = 1149621;
     $0 = 2;
     break label$1;
    case 1:
     HEAP32[($7 + 24 | 0) >> 2] = 1149619;
     $0 = 2;
     break label$1;
    case 2:
     break label$2;
    };
   }
   HEAP32[($7 + 24 | 0) >> 2] = 1149612;
   $0 = 7;
  }
  HEAP32[($7 + 28 | 0) >> 2] = $0;
  label$5 : {
   if (HEAP32[$5 >> 2] | 0) {
    break label$5
   }
   HEAP32[(($7 + 56 | 0) + 20 | 0) >> 2] = 329;
   HEAP32[($7 + 68 | 0) >> 2] = 329;
   HEAP32[(($7 + 88 | 0) + 20 | 0) >> 2] = 3;
   i64toi32_i32$1 = $7;
   i64toi32_i32$0 = 0;
   HEAP32[($7 + 92 | 0) >> 2] = 4;
   HEAP32[($7 + 96 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($7 + 88 | 0) >> 2] = 1149720;
   HEAP32[($7 + 60 | 0) >> 2] = 328;
   HEAP32[($7 + 104 | 0) >> 2] = $7 + 56 | 0;
   HEAP32[($7 + 72 | 0) >> 2] = $7 + 16 | 0;
   HEAP32[($7 + 64 | 0) >> 2] = $7 + 8 | 0;
   HEAP32[($7 + 56 | 0) >> 2] = $7 + 24 | 0;
   core__panicking__panic_fmt__hbf21a3d4bbb82bf8($7 + 88 | 0 | 0, $6 | 0);
   abort();
  }
  i64toi32_i32$2 = $5 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $59 = i64toi32_i32$0;
  i64toi32_i32$0 = ($7 + 32 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $59;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $5 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $65 = i64toi32_i32$1;
  i64toi32_i32$1 = ($7 + 32 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $65;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $68 = i64toi32_i32$0;
  i64toi32_i32$0 = $7;
  HEAP32[($7 + 32 | 0) >> 2] = $68;
  HEAP32[($7 + 36 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(($7 + 88 | 0) + 20 | 0) >> 2] = 4;
  HEAP32[($7 + 84 | 0) >> 2] = 146;
  HEAP32[(($7 + 56 | 0) + 20 | 0) >> 2] = 329;
  HEAP32[($7 + 68 | 0) >> 2] = 329;
  i64toi32_i32$0 = $7;
  i64toi32_i32$1 = 0;
  HEAP32[($7 + 92 | 0) >> 2] = 4;
  HEAP32[($7 + 96 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($7 + 88 | 0) >> 2] = 1149684;
  HEAP32[($7 + 60 | 0) >> 2] = 328;
  HEAP32[($7 + 104 | 0) >> 2] = $7 + 56 | 0;
  HEAP32[($7 + 80 | 0) >> 2] = $7 + 32 | 0;
  HEAP32[($7 + 72 | 0) >> 2] = $7 + 16 | 0;
  HEAP32[($7 + 64 | 0) >> 2] = $7 + 8 | 0;
  HEAP32[($7 + 56 | 0) >> 2] = $7 + 24 | 0;
  core__panicking__panic_fmt__hbf21a3d4bbb82bf8($7 + 88 | 0 | 0, $6 | 0);
  abort();
 }
 
 function cardano_serialization_lib__crypto__PublicKey__from_bytes__hb62a5cda8a087ae0($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $13 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $5 = 0, $6 = 0, $7 = 0, $18 = 0, $19 = 0, $5$hi = 0, $6$hi = 0, $4 = 0;
  $3 = global$0 - 80 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    if (($2 | 0) != (32 | 0)) {
     break label$2
    }
    i64toi32_i32$1 = ($3 + 48 | 0) + 24 | 0;
    i64toi32_i32$0 = 0;
    HEAP32[i64toi32_i32$1 >> 2] = 0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$1 = ($3 + 48 | 0) + 16 | 0;
    i64toi32_i32$0 = 0;
    HEAP32[i64toi32_i32$1 >> 2] = 0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$1 = ($3 + 48 | 0) + 8 | 0;
    i64toi32_i32$0 = 0;
    HEAP32[i64toi32_i32$1 >> 2] = 0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$1 = $3;
    i64toi32_i32$0 = 0;
    HEAP32[($3 + 48 | 0) >> 2] = 0;
    HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$0;
    core__slice___impl_20_5bT_5d___clone_from_slice__h1742dfbd5d5d9efd($3 + 48 | 0 | 0, 32 | 0, $1 | 0, 32 | 0);
    $2 = HEAPU8[($3 + 79 | 0) >> 0] | 0;
    HEAP8[(($3 + 8 | 0) + 24 | 0) >> 0] = $2;
    i64toi32_i32$2 = $3 + 71 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $5 = i64toi32_i32$0;
    $5$hi = i64toi32_i32$1;
    i64toi32_i32$0 = ($3 + 8 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $5;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $3 + 63 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $6 = i64toi32_i32$1;
    $6$hi = i64toi32_i32$0;
    i64toi32_i32$1 = ($3 + 8 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $6;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAPU8[($3 + 55 | 0) >> 0] | 0 | ((HEAPU8[($3 + 56 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 57 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 58 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[($3 + 59 | 0) >> 0] | 0 | ((HEAPU8[($3 + 60 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 61 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 62 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $7 = i64toi32_i32$0;
    i64toi32_i32$0 = $3;
    HEAP32[($3 + 8 | 0) >> 2] = $7;
    HEAP32[($3 + 12 | 0) >> 2] = i64toi32_i32$1;
    $1 = HEAPU8[($3 + 48 | 0) >> 0] | 0;
    $4 = HEAPU8[($3 + 49 | 0) >> 0] | 0 | ((HEAPU8[($3 + 50 | 0) >> 0] | 0) << 8 | 0) | 0;
    $13 = $0 + 4 | 0;
    $14 = HEAPU8[($3 + 51 | 0) >> 0] | 0 | ((HEAPU8[($3 + 52 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 53 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 54 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    HEAP8[$13 >> 0] = $14;
    HEAP8[($13 + 1 | 0) >> 0] = $14 >>> 8 | 0;
    HEAP8[($13 + 2 | 0) >> 0] = $14 >>> 16 | 0;
    HEAP8[($13 + 3 | 0) >> 0] = $14 >>> 24 | 0;
    $18 = $0 + 2 | 0;
    $19 = $4;
    HEAP8[$18 >> 0] = $19;
    HEAP8[($18 + 1 | 0) >> 0] = $19 >>> 8 | 0;
    HEAP8[($0 + 1 | 0) >> 0] = $1;
    i64toi32_i32$0 = $0 + 8 | 0;
    $15 = $7;
    HEAP8[i64toi32_i32$0 >> 0] = $15;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $15 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $15 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $15 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$1 = $6$hi;
    i64toi32_i32$0 = $0 + 16 | 0;
    $16 = $6;
    HEAP8[i64toi32_i32$0 >> 0] = $16;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $16 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $16 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $16 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$1 = $5$hi;
    i64toi32_i32$0 = $0 + 24 | 0;
    $17 = $5;
    HEAP8[i64toi32_i32$0 >> 0] = $17;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $17 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $17 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $17 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    HEAP8[($0 + 32 | 0) >> 0] = $2;
    $2 = 0;
    break label$1;
   }
   HEAP8[($3 + 39 | 0) >> 0] = 0;
   $2 = 1;
   HEAP32[($3 + 68 | 0) >> 2] = 1;
   i64toi32_i32$0 = $3;
   i64toi32_i32$1 = 0;
   HEAP32[($3 + 52 | 0) >> 2] = 1;
   HEAP32[($3 + 56 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($3 + 48 | 0) >> 2] = 1066504;
   HEAP32[($3 + 44 | 0) >> 2] = 28;
   HEAP32[($3 + 64 | 0) >> 2] = $3 + 40 | 0;
   HEAP32[($3 + 40 | 0) >> 2] = $3 + 39 | 0;
   alloc__fmt__format__h6e9e003a52c07309($3 + 8 | 0 | 0, $3 + 48 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 | 0, $3 + 8 | 0 | 0);
   $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[$3 >> 2] | 0 | 0, HEAP32[($3 + 4 | 0) >> 2] | 0 | 0) | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 8 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 8 | 0 | 0);
   HEAP32[($0 + 4 | 0) >> 2] = $1;
  }
  HEAP8[$0 >> 0] = $2;
  global$0 = $3 + 80 | 0;
 }
 
 function cryptoxide__curve25519__fe__fe64__Fe__to_packed__h856c6b32110c5ed6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$2 = 0, i64toi32_i32$5 = 0, i64toi32_i32$1 = 0, i64toi32_i32$4 = 0, $2$hi = 0, $2 = 0, $3 = 0, $3$hi = 0, $4 = 0, $4$hi = 0, $5 = 0, $5$hi = 0, $6 = 0, $6$hi = 0, $102 = 0, $104 = 0, $105 = 0, $106 = 0, $107 = 0, $108 = 0, $110 = 0, $111 = 0, $115 = 0, $117 = 0, $118 = 0, $119 = 0, $120 = 0, $121 = 0, $123 = 0, $124 = 0, $129 = 0, $130 = 0, $131 = 0, $132 = 0, $133 = 0, $135 = 0, $136 = 0, $139 = 0, $140 = 0, $141 = 0, $7 = 0, $11$hi = 0, $13 = 0, $13$hi = 0, $16$hi = 0, $18 = 0, $18$hi = 0, $21$hi = 0, $23 = 0, $23$hi = 0, $26$hi = 0, $28 = 0, $28$hi = 0, $32 = 0, $32$hi = 0, $34 = 0, $34$hi = 0, $37 = 0, $37$hi = 0, $39$hi = 0, $41 = 0, $41$hi = 0, $44$hi = 0, $46 = 0, $46$hi = 0, $49$hi = 0, $51 = 0, $51$hi = 0, $54$hi = 0, $56 = 0, $56$hi = 0, $60 = 0, $60$hi = 0, $64$hi = 0, $66 = 0, $66$hi = 0, $69 = 0, $69$hi = 0, $71 = 0, $71$hi = 0, $73$hi = 0, $75 = 0, $75$hi = 0, $78$hi = 0, $80 = 0, $80$hi = 0, $83$hi = 0, $85 = 0, $85$hi = 0, $89 = 0, $89$hi = 0, $93$hi = 0, $97$hi = 0, $99 = 0, $99$hi = 0, $100 = 0, $101 = 0, $103 = 0, $103$hi = 0, $105$hi = 0, $109 = 0, $109$hi = 0, $112 = 0, $112$hi = 0, $113 = 0, $114 = 0, $116 = 0, $116$hi = 0, $118$hi = 0, $122 = 0, $122$hi = 0, $125 = 0, $125$hi = 0, $126 = 0, $127 = 0, $128 = 0, $128$hi = 0, $130$hi = 0, $134 = 0, $134$hi = 0, $137 = 0, $137$hi = 0, $138 = 0;
  $7 = $0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $2 = i64toi32_i32$0;
  $2$hi = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $102 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   $102 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$1 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] | 0;
  $13 = i64toi32_i32$0;
  $13$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$1 = $102;
  i64toi32_i32$0 = $13$hi;
  i64toi32_i32$3 = $13;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $3 = i64toi32_i32$4;
  $3$hi = i64toi32_i32$5;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$0 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $104 = i64toi32_i32$5 >>> i64toi32_i32$0 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$5 >>> i64toi32_i32$0 | 0;
   $104 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$0 | 0) | 0;
  }
  $16$hi = i64toi32_i32$1;
  i64toi32_i32$5 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 16 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 20 | 0) >> 2] | 0;
  $18 = i64toi32_i32$1;
  $18$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $16$hi;
  i64toi32_i32$5 = $104;
  i64toi32_i32$1 = $18$hi;
  i64toi32_i32$3 = $18;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$4;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$1 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$5 = 0;
   $105 = i64toi32_i32$4 >>> i64toi32_i32$1 | 0;
  } else {
   i64toi32_i32$5 = i64toi32_i32$4 >>> i64toi32_i32$1 | 0;
   $105 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$1 | 0) | 0;
  }
  $21$hi = i64toi32_i32$5;
  i64toi32_i32$4 = $1;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 24 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 28 | 0) >> 2] | 0;
  $23 = i64toi32_i32$5;
  $23$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $21$hi;
  i64toi32_i32$4 = $105;
  i64toi32_i32$5 = $23$hi;
  i64toi32_i32$3 = $23;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $5 = i64toi32_i32$1;
  $5$hi = i64toi32_i32$0;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$4 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$4 = 0;
   $106 = i64toi32_i32$0 >>> i64toi32_i32$5 | 0;
  } else {
   i64toi32_i32$4 = i64toi32_i32$0 >>> i64toi32_i32$5 | 0;
   $106 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$5 | 0) | 0;
  }
  $26$hi = i64toi32_i32$4;
  i64toi32_i32$0 = $1;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 36 | 0) >> 2] | 0;
  $28 = i64toi32_i32$4;
  $28$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $26$hi;
  i64toi32_i32$0 = $106;
  i64toi32_i32$4 = $28$hi;
  i64toi32_i32$3 = $28;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $6 = i64toi32_i32$5;
  $6$hi = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$5;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $107 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   $107 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_i64_mul($107 | 0, i64toi32_i32$0 | 0, 19 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $32 = i64toi32_i32$2;
  $32$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $2$hi;
  i64toi32_i32$1 = $2;
  i64toi32_i32$2 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
  $34 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
  $34$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $32$hi;
  i64toi32_i32$0 = $32;
  i64toi32_i32$1 = $34$hi;
  i64toi32_i32$3 = $34;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $2 = i64toi32_i32$4;
  $2$hi = i64toi32_i32$5;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$0 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$0 = i64toi32_i32$5 & i64toi32_i32$0 | 0;
  $37 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
  $37$hi = i64toi32_i32$0;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$1 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $108 = i64toi32_i32$0 >>> i64toi32_i32$1 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$1 | 0;
   $108 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$1 | 0) | 0;
  }
  $39$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $3$hi;
  i64toi32_i32$0 = $3;
  i64toi32_i32$5 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$5 = i64toi32_i32$2 & i64toi32_i32$5 | 0;
  $41 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
  $41$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $39$hi;
  i64toi32_i32$2 = $108;
  i64toi32_i32$0 = $41$hi;
  i64toi32_i32$3 = $41;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $2 = i64toi32_i32$1;
  $2$hi = i64toi32_i32$4;
  i64toi32_i32$5 = i64toi32_i32$1;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$0 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $110 = i64toi32_i32$4 >>> i64toi32_i32$0 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$4 >>> i64toi32_i32$0 | 0;
   $110 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$0 | 0) | 0;
  }
  $44$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$4 = $4;
  i64toi32_i32$5 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$5 = i64toi32_i32$2 & i64toi32_i32$5 | 0;
  $46 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
  $46$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $44$hi;
  i64toi32_i32$2 = $110;
  i64toi32_i32$4 = $46$hi;
  i64toi32_i32$3 = $46;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $3 = i64toi32_i32$0;
  $3$hi = i64toi32_i32$1;
  i64toi32_i32$5 = i64toi32_i32$0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $111 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   $111 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$4 | 0) | 0;
  }
  $49$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $5$hi;
  i64toi32_i32$1 = $5;
  i64toi32_i32$5 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$5 = i64toi32_i32$2 & i64toi32_i32$5 | 0;
  $51 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
  $51$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $49$hi;
  i64toi32_i32$2 = $111;
  i64toi32_i32$1 = $51$hi;
  i64toi32_i32$3 = $51;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $4 = i64toi32_i32$4;
  $4$hi = i64toi32_i32$0;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$1 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $115 = i64toi32_i32$0 >>> i64toi32_i32$1 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$1 | 0;
   $115 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$1 | 0) | 0;
  }
  $54$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $6$hi;
  i64toi32_i32$0 = $6;
  i64toi32_i32$5 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$5 = i64toi32_i32$2 & i64toi32_i32$5 | 0;
  $56 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
  $56$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $54$hi;
  i64toi32_i32$2 = $115;
  i64toi32_i32$0 = $56$hi;
  i64toi32_i32$3 = $56;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $5 = i64toi32_i32$1;
  $5$hi = i64toi32_i32$4;
  i64toi32_i32$5 = i64toi32_i32$1;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$0 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $117 = i64toi32_i32$4 >>> i64toi32_i32$0 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$4 >>> i64toi32_i32$0 | 0;
   $117 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$0 | 0) | 0;
  }
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_i64_mul($117 | 0, i64toi32_i32$2 | 0, 19 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $60 = i64toi32_i32$5;
  $60$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $37$hi;
  i64toi32_i32$4 = $37;
  i64toi32_i32$5 = $60$hi;
  i64toi32_i32$3 = $60;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$3 = 19;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $6 = i64toi32_i32$5;
  $6$hi = i64toi32_i32$0;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $118 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $118 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
  }
  $64$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $2$hi;
  i64toi32_i32$0 = $2;
  i64toi32_i32$1 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
  $66 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
  $66$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $64$hi;
  i64toi32_i32$2 = $118;
  i64toi32_i32$0 = $66$hi;
  i64toi32_i32$3 = $66;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $2 = i64toi32_i32$4;
  $2$hi = i64toi32_i32$5;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$2 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$2 = i64toi32_i32$5 & i64toi32_i32$2 | 0;
  $69 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
  $69$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $6$hi;
  i64toi32_i32$5 = $6;
  i64toi32_i32$1 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
  $71 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
  $71$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $2$hi;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$0 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$5 = 0;
   $119 = i64toi32_i32$1 >>> i64toi32_i32$0 | 0;
  } else {
   i64toi32_i32$5 = i64toi32_i32$1 >>> i64toi32_i32$0 | 0;
   $119 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$0 | 0) | 0;
  }
  $73$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $3$hi;
  i64toi32_i32$1 = $3;
  i64toi32_i32$2 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$2 = i64toi32_i32$5 & i64toi32_i32$2 | 0;
  $75 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
  $75$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $73$hi;
  i64toi32_i32$5 = $119;
  i64toi32_i32$1 = $75$hi;
  i64toi32_i32$3 = $75;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $3 = i64toi32_i32$0;
  $3$hi = i64toi32_i32$4;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$1 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$5 = 0;
   $120 = i64toi32_i32$4 >>> i64toi32_i32$1 | 0;
  } else {
   i64toi32_i32$5 = i64toi32_i32$4 >>> i64toi32_i32$1 | 0;
   $120 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$1 | 0) | 0;
  }
  $78$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $4$hi;
  i64toi32_i32$4 = $4;
  i64toi32_i32$2 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$2 = i64toi32_i32$5 & i64toi32_i32$2 | 0;
  $80 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
  $80$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $78$hi;
  i64toi32_i32$5 = $120;
  i64toi32_i32$4 = $80$hi;
  i64toi32_i32$3 = $80;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $4 = i64toi32_i32$1;
  $4$hi = i64toi32_i32$0;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$5 = 0;
   $121 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$5 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $121 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  $83$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $5$hi;
  i64toi32_i32$0 = $5;
  i64toi32_i32$2 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$2 = i64toi32_i32$5 & i64toi32_i32$2 | 0;
  $85 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
  $85$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $83$hi;
  i64toi32_i32$5 = $121;
  i64toi32_i32$0 = $85$hi;
  i64toi32_i32$3 = $85;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $5 = i64toi32_i32$4;
  $5$hi = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$0 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$5 = 0;
   $123 = i64toi32_i32$1 >>> i64toi32_i32$0 | 0;
  } else {
   i64toi32_i32$5 = i64toi32_i32$1 >>> i64toi32_i32$0 | 0;
   $123 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$0 | 0) | 0;
  }
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_i64_mul($123 | 0, i64toi32_i32$5 | 0, 19 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $89 = i64toi32_i32$2;
  $89$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $71$hi;
  i64toi32_i32$1 = $71;
  i64toi32_i32$2 = $89$hi;
  i64toi32_i32$3 = $89;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  i64toi32_i32$5 = i64toi32_i32$0;
  i64toi32_i32$1 = 524287;
  i64toi32_i32$3 = -19;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $6 = i64toi32_i32$2;
  $6$hi = i64toi32_i32$0;
  i64toi32_i32$4 = i64toi32_i32$2;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$1 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$5 = 0;
   $124 = i64toi32_i32$0 >>> i64toi32_i32$1 | 0;
  } else {
   i64toi32_i32$5 = i64toi32_i32$0 >>> i64toi32_i32$1 | 0;
   $124 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$1 | 0) | 0;
  }
  $93$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $69$hi;
  i64toi32_i32$0 = $69;
  i64toi32_i32$4 = $93$hi;
  i64toi32_i32$3 = $124;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  i64toi32_i32$5 = i64toi32_i32$1;
  i64toi32_i32$0 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $2 = i64toi32_i32$4;
  $2$hi = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$0 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$2 << i64toi32_i32$0 | 0;
   $129 = 0;
  } else {
   i64toi32_i32$5 = ((1 << i64toi32_i32$0 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$0 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$0 | 0) | 0;
   $129 = i64toi32_i32$2 << i64toi32_i32$0 | 0;
  }
  $97$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $6$hi;
  i64toi32_i32$1 = $6;
  i64toi32_i32$2 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$2 = i64toi32_i32$5 & i64toi32_i32$2 | 0;
  $99 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
  $99$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $97$hi;
  i64toi32_i32$5 = $129;
  i64toi32_i32$1 = $99$hi;
  i64toi32_i32$3 = $99;
  i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
  $100 = i64toi32_i32$5 | i64toi32_i32$3 | 0;
  i64toi32_i32$5 = $7;
  HEAP32[i64toi32_i32$5 >> 2] = $100;
  HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$1;
  $101 = $0;
  i64toi32_i32$1 = $3$hi;
  i64toi32_i32$2 = $3;
  i64toi32_i32$5 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$5 = i64toi32_i32$1 & i64toi32_i32$5 | 0;
  $103 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
  $103$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $2$hi;
  i64toi32_i32$1 = $2;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$0 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $130 = i64toi32_i32$5 >>> i64toi32_i32$0 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$5 >>> i64toi32_i32$0 | 0;
   $130 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$0 | 0) | 0;
  }
  $105$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $103$hi;
  i64toi32_i32$5 = $103;
  i64toi32_i32$1 = $105$hi;
  i64toi32_i32$3 = $130;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$5 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $3 = i64toi32_i32$1;
  $3$hi = i64toi32_i32$0;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 38;
  i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$4 << i64toi32_i32$5 | 0;
   $131 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$5 | 0) - 1 | 0) & (i64toi32_i32$4 >>> (32 - i64toi32_i32$5 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$5 | 0) | 0;
   $131 = i64toi32_i32$4 << i64toi32_i32$5 | 0;
  }
  $109 = $131;
  $109$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $2$hi;
  i64toi32_i32$0 = $2;
  i64toi32_i32$4 = 0;
  i64toi32_i32$3 = 13;
  i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$4 = 0;
   $132 = i64toi32_i32$2 >>> i64toi32_i32$5 | 0;
  } else {
   i64toi32_i32$4 = i64toi32_i32$2 >>> i64toi32_i32$5 | 0;
   $132 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$5 | 0) | 0;
  }
  i64toi32_i32$2 = $132;
  i64toi32_i32$0 = 63;
  i64toi32_i32$3 = -1;
  i64toi32_i32$0 = i64toi32_i32$4 & i64toi32_i32$0 | 0;
  $112 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
  $112$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $109$hi;
  i64toi32_i32$4 = $109;
  i64toi32_i32$2 = $112$hi;
  i64toi32_i32$3 = $112;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  $113 = i64toi32_i32$4 | i64toi32_i32$3 | 0;
  i64toi32_i32$4 = $101;
  HEAP32[(i64toi32_i32$4 + 8 | 0) >> 2] = $113;
  HEAP32[(i64toi32_i32$4 + 12 | 0) >> 2] = i64toi32_i32$2;
  $114 = $0;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$0 = $4;
  i64toi32_i32$4 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$4 = i64toi32_i32$2 & i64toi32_i32$4 | 0;
  $116 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
  $116$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $3$hi;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $133 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
   $133 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$5 | 0) | 0;
  }
  $118$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $116$hi;
  i64toi32_i32$4 = $116;
  i64toi32_i32$2 = $118$hi;
  i64toi32_i32$3 = $133;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$4 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $2 = i64toi32_i32$2;
  $2$hi = i64toi32_i32$5;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 25;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
   $135 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$5 << i64toi32_i32$4 | 0) | 0;
   $135 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
  }
  $122 = $135;
  $122$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $3$hi;
  i64toi32_i32$5 = $3;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 26;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $136 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $136 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$4 | 0) | 0;
  }
  i64toi32_i32$0 = $136;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 33554431;
  i64toi32_i32$5 = i64toi32_i32$1 & i64toi32_i32$5 | 0;
  $125 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
  $125$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $122$hi;
  i64toi32_i32$1 = $122;
  i64toi32_i32$0 = $125$hi;
  i64toi32_i32$3 = $125;
  i64toi32_i32$0 = i64toi32_i32$5 | i64toi32_i32$0 | 0;
  $126 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $114;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $126;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  $127 = $0;
  i64toi32_i32$0 = $5$hi;
  $128 = $5;
  $128$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $2$hi;
  i64toi32_i32$5 = $2;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $139 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $139 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$4 | 0) | 0;
  }
  $130$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $128$hi;
  i64toi32_i32$0 = $128;
  i64toi32_i32$5 = $130$hi;
  i64toi32_i32$3 = $139;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 12;
  i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$5 | 0;
   $140 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$5 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$5 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$5 | 0) | 0;
   $140 = i64toi32_i32$1 << i64toi32_i32$5 | 0;
  }
  i64toi32_i32$2 = $140;
  i64toi32_i32$1 = -1;
  i64toi32_i32$3 = -4096;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$2 = 2147483647;
  i64toi32_i32$3 = -4096;
  i64toi32_i32$2 = i64toi32_i32$4 & i64toi32_i32$2 | 0;
  $134 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
  $134$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $2$hi;
  i64toi32_i32$4 = $2;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 39;
  i64toi32_i32$1 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $141 = i64toi32_i32$2 >>> i64toi32_i32$1 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$1 | 0;
   $141 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$1 | 0) | 0;
  }
  i64toi32_i32$2 = $141;
  i64toi32_i32$4 = 0;
  i64toi32_i32$3 = 4095;
  i64toi32_i32$4 = i64toi32_i32$0 & i64toi32_i32$4 | 0;
  $137 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
  $137$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $134$hi;
  i64toi32_i32$0 = $134;
  i64toi32_i32$2 = $137$hi;
  i64toi32_i32$3 = $137;
  i64toi32_i32$2 = i64toi32_i32$4 | i64toi32_i32$2 | 0;
  $138 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $127;
  HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = $138;
  HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = i64toi32_i32$2;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert_fit__hbb34fc2956828e73($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $5 = 0, $6 = 0, $4 = 0, $7 = 0, $8 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $25 = 0, $26 = 0, $9 = 0, $32 = 0, $38 = 0, $41 = 0, $11 = 0, $75 = 0, $79 = 0, $83 = 0;
  $4 = global$0 - 32 | 0;
  global$0 = $4;
  $5 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  $6 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $0 = HEAPU16[($6 + 6 | 0) >> 1] | 0;
  $7 = $4 + 24 | 0;
  $21 = $1 + 24 | 0;
  HEAP32[$7 >> 2] = HEAPU8[$21 >> 0] | 0 | ((HEAPU8[($21 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($21 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($21 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $8 = $4 + 16 | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $32 = i64toi32_i32$0;
  i64toi32_i32$0 = $8;
  HEAP32[i64toi32_i32$0 >> 2] = $32;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $9 = $4 + 8 | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $38 = i64toi32_i32$1;
  i64toi32_i32$1 = $9;
  HEAP32[i64toi32_i32$1 >> 2] = $38;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $41 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[i64toi32_i32$0 >> 2] = $41;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   $1 = $5 + 1 | 0;
   if ($1 >>> 0 > $0 >>> 0) {
    break label$1
   }
   $10 = $6 + 8 | 0;
   memmove($10 + Math_imul($1, 28) | 0 | 0, $10 + Math_imul($5, 28) | 0 | 0, Math_imul($0 - $5 | 0, 28) | 0) | 0;
  }
  $11 = $0 + 1 | 0;
  $10 = $6 + Math_imul($5, 28) | 0;
  $22 = $10 + 32 | 0;
  $23 = HEAP32[$7 >> 2] | 0;
  HEAP8[$22 >> 0] = $23;
  HEAP8[($22 + 1 | 0) >> 0] = $23 >>> 8 | 0;
  HEAP8[($22 + 2 | 0) >> 0] = $23 >>> 16 | 0;
  HEAP8[($22 + 3 | 0) >> 0] = $23 >>> 24 | 0;
  i64toi32_i32$2 = $8;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $75 = i64toi32_i32$1;
  i64toi32_i32$1 = $10 + 24 | 0;
  $24 = $75;
  HEAP8[i64toi32_i32$1 >> 0] = $24;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $24 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $24 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $24 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $9;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $79 = i64toi32_i32$0;
  i64toi32_i32$0 = $10 + 16 | 0;
  $25 = $79;
  HEAP8[i64toi32_i32$0 >> 0] = $25;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $25 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $25 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $25 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $83 = i64toi32_i32$1;
  i64toi32_i32$1 = $10 + 8 | 0;
  $26 = $83;
  HEAP8[i64toi32_i32$1 >> 0] = $26;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $26 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $26 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $26 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  label$2 : {
   $7 = $5 + 2 | 0;
   $10 = $0 + 2 | 0;
   if ($7 >>> 0 >= $10 >>> 0) {
    break label$2
   }
   $8 = $6 + 316 | 0;
   memmove($8 + ($7 << 2 | 0) | 0 | 0, $8 + ($1 << 2 | 0) | 0 | 0, ($0 - $5 | 0) << 2 | 0 | 0) | 0;
  }
  HEAP32[(($6 + ($1 << 2 | 0) | 0) + 316 | 0) >> 2] = $3;
  HEAP16[($6 + 6 | 0) >> 1] = $11;
  label$3 : {
   if ($1 >>> 0 >= $10 >>> 0) {
    break label$3
   }
   $10 = $0 + 1 | 0;
   $0 = ($6 + ($5 << 2 | 0) | 0) + 320 | 0;
   label$4 : while (1) {
    $1 = HEAP32[$0 >> 2] | 0;
    $5 = $5 + 1 | 0;
    HEAP16[($1 + 4 | 0) >> 1] = $5;
    HEAP32[$1 >> 2] = $6;
    $0 = $0 + 4 | 0;
    if (($10 | 0) != ($5 | 0)) {
     continue label$4
    }
    break label$4;
   };
  }
  global$0 = $4 + 32 | 0;
 }
 
 function cardano_serialization_lib__tx_builder__TransactionBuilder__add_mint_asset_and_output_min_required_coin__h8d75826e2c913b7c($0, $1, $2, $3, $4, $4$hi, $5, $5$hi, $6) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  $4$hi = $4$hi | 0;
  $5 = $5 | 0;
  $5$hi = $5$hi | 0;
  $6 = $6 | 0;
  var $7 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $14 = 0, $15 = 0, $16 = 0, i64toi32_i32$3 = 0;
  $7 = global$0 - 608 | 0;
  global$0 = $7;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       i64toi32_i32$0 = $5$hi;
       i64toi32_i32$2 = $5;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 0;
       if ((i64toi32_i32$0 | 0) < (i64toi32_i32$1 | 0)) {
        $14 = 1
       } else {
        if ((i64toi32_i32$0 | 0) <= (i64toi32_i32$1 | 0)) {
         if (i64toi32_i32$2 >>> 0 >= i64toi32_i32$3 >>> 0) {
          $15 = 0
         } else {
          $15 = 1
         }
         $16 = $15;
        } else {
         $16 = 0
        }
        $14 = $16;
       }
       if ($14) {
        break label$5
       }
       cardano_serialization_lib__NativeScript__hash__hb812a54d2c7bdca2($7 + 32 | 0 | 0, $2 | 0);
       i64toi32_i32$2 = $4$hi;
       i64toi32_i32$2 = $5$hi;
       i64toi32_i32$2 = $4$hi;
       i64toi32_i32$0 = $5$hi;
       cardano_serialization_lib__tx_builder__TransactionBuilder___add_mint_asset__h060e64edb838acae($1 | 0, $7 + 32 | 0 | 0, $2 | 0, $3 | 0, $4 | 0, i64toi32_i32$2 | 0, $5 | 0, i64toi32_i32$0 | 0);
       i64toi32_i32$2 = $7;
       i64toi32_i32$0 = 0;
       HEAP32[($7 + 212 | 0) >> 2] = 0;
       HEAP32[($7 + 216 | 0) >> 2] = i64toi32_i32$0;
       $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($7 + 472 | 0 | 0, $3 | 0);
       i64toi32_i32$0 = $4$hi;
       i64toi32_i32$0 = $5$hi;
       i64toi32_i32$0 = $4$hi;
       i64toi32_i32$2 = $5$hi;
       alloc__collections__btree__map__BTreeMap_K_2cV___insert__h9d3a28073b5db74d($7 + 8 | 0 | 0, $7 + 208 | 0 | 0, $7 + 472 | 0 | 0, $4 | 0, i64toi32_i32$0 | 0, $5 | 0, $5$hi | 0);
       cardano_serialization_lib__Mint__new_from_entry__hae31aeb23b43a89f($7 + 472 | 0 | 0, $7 + 32 | 0 | 0, $7 + 208 | 0 | 0);
       cardano_serialization_lib__Mint__as_multiasset__hfae7c36e40af3e22($7 + 64 | 0 | 0, $7 + 472 | 0 | 0, 1 | 0);
       $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h3981a4152bf24dd0($7 + 472 | 0 | 0);
       $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h0265580a5be10b66($7 + 208 | 0 | 0);
       cardano_serialization_lib__output_builder__TransactionOutputAmountBuilder__with_asset_and_min_required_coin__hf86cbfe0b07de24a($7 + 472 | 0 | 0, $6 | 0, $7 + 64 | 0 | 0, $1 + 32 | 0 | 0);
       if ((HEAP32[($7 + 472 | 0) >> 2] | 0 | 0) == (1 | 0)) {
        break label$4
       }
       memcpy($7 + 344 | 0 | 0, ($7 + 472 | 0) + 8 | 0 | 0, 128 | 0) | 0;
       cardano_serialization_lib__output_builder__TransactionOutputAmountBuilder__build__he57d4fcb648faafd($7 + 208 | 0 | 0, $7 + 344 | 0 | 0);
       if ((HEAP32[($7 + 208 | 0) >> 2] | 0 | 0) == (1 | 0)) {
        break label$3
       }
       memcpy($7 + 80 | 0 | 0, ($7 + 208 | 0) + 8 | 0 | 0, 128 | 0) | 0;
       cardano_serialization_lib__tx_builder__TransactionBuilder__add_output__h626cdf41f713b689($7 | 0, $1 | 0, $7 + 80 | 0 | 0);
       $1 = HEAP32[($7 + 4 | 0) >> 2] | 0;
       $2 = HEAP32[$7 >> 2] | 0;
       $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($7 + 64 | 0 | 0);
       core__ptr__drop_in_place_cardano_serialization_lib__TransactionOutput___h632b3a99817e6ac5($7 + 80 | 0 | 0);
       core__ptr__drop_in_place_cardano_serialization_lib__output_builder__TransactionOutputAmountBuilder___h4d21635c56401178($7 + 344 | 0 | 0);
       break label$1;
      }
      $2 = 1;
      $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1065200 | 0, 30 | 0) | 0;
      break label$1;
     }
     $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($7 + 476 | 0) >> 2] | 0 | 0) | 0;
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($7 + 64 | 0 | 0);
     break label$2;
    }
    $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($7 + 212 | 0) >> 2] | 0 | 0) | 0;
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($7 + 64 | 0 | 0);
    core__ptr__drop_in_place_cardano_serialization_lib__output_builder__TransactionOutputAmountBuilder___h4d21635c56401178($7 + 344 | 0 | 0);
   }
   $2 = 1;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[$0 >> 2] = $2;
  global$0 = $7 + 608 | 0;
 }
 
 function cardano_serialization_lib__output_builder__TransactionOutputAmountBuilder__with_coin__hed72e8bd0c479163($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, $5 = 0, $4 = 0, $22 = 0, $23 = 0, $24 = 0, $25 = 0, $6 = 0, $6$hi = 0, $33 = 0, $41 = 0, $46 = 0, $51 = 0, $55 = 0, $70 = 0, $80 = 0, $86 = 0, $91 = 0, $96 = 0, $106 = 0;
  $3 = global$0 - 112 | 0;
  global$0 = $3;
  $cardano_serialization_lib__address__Address_20as_20core__clone__Clone___clone__h0eb465a6e349d507_1($3 | 0, $1 | 0);
  $4 = 2;
  label$1 : {
   $5 = HEAP32[($1 + 72 | 0) >> 2] | 0;
   if (($5 | 0) == (2 | 0)) {
    break label$1
   }
   i64toi32_i32$2 = $1;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
   $6 = i64toi32_i32$0;
   $6$hi = i64toi32_i32$1;
   $4 = 0;
   label$2 : {
    if (($5 | 0) != (1 | 0)) {
     break label$2
    }
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($3 + 80 | 0 | 4 | 0 | 0, $1 + 76 | 0 | 0);
    $4 = 1;
   }
   HEAP32[($3 + 72 | 0) >> 2] = HEAP32[($3 + 92 | 0) >> 2] | 0;
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 84 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 88 | 0) >> 2] | 0;
   $33 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] = $33;
   HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] = i64toi32_i32$0;
  }
  $5 = 0;
  label$3 : {
   if ((HEAPU8[($1 + 88 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$3
   }
   i64toi32_i32$2 = $1 + 113 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $41 = i64toi32_i32$0;
   i64toi32_i32$0 = $3 + 104 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $41;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1 + 105 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $46 = i64toi32_i32$1;
   i64toi32_i32$1 = $3 + 96 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $46;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $1 + 97 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $51 = i64toi32_i32$0;
   i64toi32_i32$0 = $3 + 88 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $51;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1 + 89 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $55 = i64toi32_i32$1;
   i64toi32_i32$1 = $3;
   HEAP32[(i64toi32_i32$1 + 80 | 0) >> 2] = $55;
   HEAP32[(i64toi32_i32$1 + 84 | 0) >> 2] = i64toi32_i32$0;
   $5 = 1;
  }
  $1 = memcpy($0 | 0, $3 | 0, 64 | 0) | 0;
  HEAP32[($1 + 72 | 0) >> 2] = $4;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$1 = $1;
  HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] = $6;
  HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 88 | 0) >> 0] = $5;
  $5 = i64toi32_i32$1 + 76 | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
  $70 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[i64toi32_i32$0 >> 2] = $70;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 84 | 0) >> 2] = HEAP32[((i64toi32_i32$2 + 64 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 80 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 84 | 0) >> 2] | 0;
  $80 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 89 | 0;
  $22 = $80;
  HEAP8[i64toi32_i32$1 >> 0] = $22;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $22 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $22 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $22 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = (i64toi32_i32$2 + 80 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $86 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 97 | 0;
  $23 = $86;
  HEAP8[i64toi32_i32$0 >> 0] = $23;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $23 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $23 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $23 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $3 + 96 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $91 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 105 | 0;
  $24 = $91;
  HEAP8[i64toi32_i32$1 >> 0] = $24;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $24 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $24 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $24 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $3 + 104 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $96 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 113 | 0;
  $25 = $96;
  HEAP8[i64toi32_i32$0 >> 0] = $25;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $25 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $25 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $25 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $6 = i64toi32_i32$1;
  $6$hi = i64toi32_i32$0;
  label$4 : {
   switch ($4 | 0) {
   default:
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($5 | 0);
    break;
   case 0:
   case 2:
    break label$4;
   };
  }
  HEAP32[($1 + 72 | 0) >> 2] = 0;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$1 = $1;
  HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] = $6;
  HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $106 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[i64toi32_i32$0 >> 2] = $106;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  global$0 = i64toi32_i32$2 + 112 | 0;
 }
 
 function alloc__collections__btree__map__entry__VacantEntry_K_2cV___insert__ha11e6229b9b858b3($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $7 = 0, $18 = 0, $3 = 0, $6 = 0, $19 = 0, $31 = 0, $37 = 0, $40 = 0, $2 = 0, $4 = 0, $5 = 0, $96 = 0, $101 = 0, $105 = 0;
  $1 = global$0 - 112 | 0;
  global$0 = $1;
  HEAP32[(($1 + 64 | 0) + 8 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[$0 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 64 | 0) >> 2] = $19;
  HEAP32[($1 + 68 | 0) >> 2] = i64toi32_i32$1;
  $18 = $0 + 40 | 0;
  HEAP32[(($1 + 80 | 0) + 24 | 0) >> 2] = HEAPU8[$18 >> 0] | 0 | ((HEAPU8[($18 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($18 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($18 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $0 + 32 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $31 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 80 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $31;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $0 + 24 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $37 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 80 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $37;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 16 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 17 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 18 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 19 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 20 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 21 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 22 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 23 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $40 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[($1 + 80 | 0) >> 2] = $40;
  HEAP32[($1 + 84 | 0) >> 2] = i64toi32_i32$0;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_recursing__h9dcf9ac6ec8c251c($1 + 8 | 0 | 0, $1 + 64 | 0 | 0, $1 + 80 | 0 | 0);
  $2 = HEAP32[($1 + 56 | 0) >> 2] | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[($1 + 8 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     $0 = HEAP32[($0 + 12 | 0) >> 2] | 0;
     break label$2;
    }
    $0 = HEAP32[($0 + 12 | 0) >> 2] | 0;
    $3 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    if (!$3) {
     break label$1
    }
    $4 = HEAP32[(($1 + 8 | 0) + 16 | 0) >> 2] | 0;
    $5 = HEAP32[($1 + 20 | 0) >> 2] | 0;
    $6 = HEAP32[$0 >> 2] | 0;
    $7 = alloc__boxed__Box_T_2cA___new_uninit_in__hef877667b5cd207e() | 0;
    HEAP32[($7 + 316 | 0) >> 2] = $3;
    HEAP16[($7 + 6 | 0) >> 1] = 0;
    HEAP32[$7 >> 2] = 0;
    HEAP32[($0 + 4 | 0) >> 2] = $7;
    $6 = $6 + 1 | 0;
    HEAP32[$0 >> 2] = $6;
    HEAP16[($3 + 4 | 0) >> 1] = 0;
    HEAP32[$3 >> 2] = $7;
    HEAP32[($1 + 68 | 0) >> 2] = $7;
    HEAP32[($1 + 64 | 0) >> 2] = $6;
    HEAP32[($1 + 104 | 0) >> 2] = HEAP32[($1 + 52 | 0) >> 2] | 0;
    i64toi32_i32$2 = $1 + 44 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $96 = i64toi32_i32$0;
    i64toi32_i32$0 = $1 + 96 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $96;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $1 + 36 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $101 = i64toi32_i32$1;
    i64toi32_i32$1 = $1 + 88 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $101;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $1 + 28 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $105 = i64toi32_i32$0;
    i64toi32_i32$0 = $1;
    HEAP32[($1 + 80 | 0) >> 2] = $105;
    HEAP32[($1 + 84 | 0) >> 2] = i64toi32_i32$1;
    alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal___push__hc0dce87587d46cdc($1 + 64 | 0 | 0, $1 + 80 | 0 | 0, $5 | 0, $4 | 0);
   }
   HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
   global$0 = $1 + 112 | 0;
   return $2 | 0;
  }
  core__panicking__panic__h2fd385a887c8bf13(1072048 | 0, 43 | 0, 1072248 | 0);
  abort();
 }
 
 function cryptoxide__curve25519__scalar__scalar64__Scalar__to_bytes__h1c79e40f602967bf($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$4 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $2 = 0, $2$hi = 0, $4 = 0, $4$hi = 0, $6 = 0, $6$hi = 0, $8 = 0, $8$hi = 0, $3 = 0, $3$hi = 0, $61 = 0, $62 = 0, $63 = 0, $65 = 0, $66 = 0, $68 = 0, $69 = 0, $5 = 0, $5$hi = 0, $70 = 0, $71 = 0, $73 = 0, $74 = 0, $76 = 0, $77 = 0, $79 = 0, $7 = 0, $7$hi = 0, $80 = 0, $82 = 0, $83 = 0, $85 = 0, $86 = 0, $87 = 0, $89 = 0, $9 = 0, $9$hi = 0, $90 = 0, $92 = 0, $93 = 0, $95 = 0, $96 = 0, $98 = 0, $99 = 0, $101 = 0, $102 = 0, $104 = 0, $105 = 0, $107 = 0, $108 = 0, $109 = 0, $14 = 0, $19 = 0, $22 = 0, $25 = 0, $30 = 0, $33 = 0, $36 = 0, $40 = 0, $43 = 0, $46 = 0, $51 = 0, $54 = 0, $57 = 0, $60 = 0, $64 = 0, $67 = 0, $72 = 0, $75 = 0, $78 = 0, $81 = 0, $84 = 0, $88 = 0, $91 = 0, $94 = 0, $97 = 0, $100 = 0, $103 = 0, $106 = 0, $108$hi = 0, $112 = 0, $114$hi = 0, $118 = 0, $120$hi = 0, $124 = 0, $125 = 0, $125$hi = 0, $127$hi = 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $2 = i64toi32_i32$0;
  $2$hi = i64toi32_i32$1;
  HEAP8[$0 >> 0] = i64toi32_i32$0;
  $14 = $0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
  $3 = i64toi32_i32$1;
  $3$hi = i64toi32_i32$0;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 24;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $61 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $61 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($14 + 31 | 0) >> 0] = $61;
  $19 = $0;
  i64toi32_i32$1 = $3$hi;
  i64toi32_i32$0 = $3;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 16;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $62 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   $62 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($19 + 30 | 0) >> 0] = $62;
  $22 = $0;
  i64toi32_i32$2 = $3$hi;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 8;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $63 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   $63 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($22 + 29 | 0) >> 0] = $63;
  $25 = $0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 48;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $65 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   $65 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($25 + 27 | 0) >> 0] = $65;
  $30 = $0;
  i64toi32_i32$0 = $4$hi;
  i64toi32_i32$1 = $4;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 40;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $66 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $66 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($30 + 26 | 0) >> 0] = $66;
  $33 = $0;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$0 = $4;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $68 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   $68 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($33 + 25 | 0) >> 0] = $68;
  $36 = $0;
  i64toi32_i32$1 = $4$hi;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 24;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $69 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   $69 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  $5 = $69;
  $5$hi = i64toi32_i32$0;
  HEAP8[($36 + 24 | 0) >> 0] = $5;
  $40 = $0;
  i64toi32_i32$0 = $4$hi;
  i64toi32_i32$1 = $4;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 16;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $70 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $70 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($40 + 23 | 0) >> 0] = $70;
  $43 = $0;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$0 = $4;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 8;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $71 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   $71 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($43 + 22 | 0) >> 0] = $71;
  $46 = $0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $6 = i64toi32_i32$1;
  $6$hi = i64toi32_i32$0;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 48;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $73 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $73 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($46 + 20 | 0) >> 0] = $73;
  $51 = $0;
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$0 = $6;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 40;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $74 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   $74 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($51 + 19 | 0) >> 0] = $74;
  $54 = $0;
  i64toi32_i32$2 = $6$hi;
  i64toi32_i32$1 = $6;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $76 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   $76 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($54 + 18 | 0) >> 0] = $76;
  $57 = $0;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$2 = $6;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 24;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $77 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $77 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($57 + 17 | 0) >> 0] = $77;
  $60 = $0;
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$0 = $6;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 16;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $79 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   $79 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
  }
  $7 = $79;
  $7$hi = i64toi32_i32$2;
  HEAP8[($60 + 16 | 0) >> 0] = $7;
  $64 = $0;
  i64toi32_i32$2 = $6$hi;
  i64toi32_i32$1 = $6;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 8;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $80 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   $80 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($64 + 15 | 0) >> 0] = $80;
  $67 = $0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 48;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $82 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   $82 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($67 + 13 | 0) >> 0] = $82;
  $72 = $0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$1 = $8;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 40;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $83 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $83 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($72 + 12 | 0) >> 0] = $83;
  $75 = $0;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$0 = $8;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $85 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   $85 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($75 + 11 | 0) >> 0] = $85;
  $78 = $0;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$2 = $8;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 24;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $86 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   $86 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($78 + 10 | 0) >> 0] = $86;
  $81 = $0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$1 = $8;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 16;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $87 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $87 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($81 + 9 | 0) >> 0] = $87;
  $84 = $0;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$0 = $8;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 8;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $89 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   $89 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
  }
  $9 = $89;
  $9$hi = i64toi32_i32$1;
  HEAP8[($84 + 8 | 0) >> 0] = $9;
  $88 = $0;
  i64toi32_i32$1 = $2$hi;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 48;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $90 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   $90 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($88 + 6 | 0) >> 0] = $90;
  $91 = $0;
  i64toi32_i32$0 = $2$hi;
  i64toi32_i32$1 = $2;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 40;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $92 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $92 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($91 + 5 | 0) >> 0] = $92;
  $94 = $0;
  i64toi32_i32$2 = $2$hi;
  i64toi32_i32$0 = $2;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $93 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   $93 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($94 + 4 | 0) >> 0] = $93;
  $97 = $0;
  i64toi32_i32$1 = $2$hi;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 24;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $95 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   $95 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($97 + 3 | 0) >> 0] = $95;
  $100 = $0;
  i64toi32_i32$0 = $2$hi;
  i64toi32_i32$1 = $2;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 16;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $96 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $96 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($100 + 2 | 0) >> 0] = $96;
  $103 = $0;
  i64toi32_i32$2 = $2$hi;
  i64toi32_i32$0 = $2;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 8;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $98 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   $98 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($103 + 1 | 0) >> 0] = $98;
  $106 = $0;
  i64toi32_i32$1 = $3$hi;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $99 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $99 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $108$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $5$hi;
  i64toi32_i32$0 = $108$hi;
  i64toi32_i32$1 = $99;
  i64toi32_i32$2 = $5$hi;
  i64toi32_i32$3 = $5;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $101 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   $101 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($106 + 28 | 0) >> 0] = $101;
  $112 = $0;
  i64toi32_i32$1 = $4$hi;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 40;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $102 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $102 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $114$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$0 = $114$hi;
  i64toi32_i32$1 = $102;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 40;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $104 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   $104 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($112 + 21 | 0) >> 0] = $104;
  $118 = $0;
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$2 = $6;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 48;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $105 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $105 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $120$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$0 = $120$hi;
  i64toi32_i32$1 = $105;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 48;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $107 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   $107 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($118 + 14 | 0) >> 0] = $107;
  $124 = $0;
  i64toi32_i32$1 = $2$hi;
  $125 = $2;
  $125$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$2 = $8;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $108 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $108 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $127$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $125$hi;
  i64toi32_i32$1 = $125;
  i64toi32_i32$2 = $127$hi;
  i64toi32_i32$3 = $108;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $109 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   $109 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($124 + 7 | 0) >> 0] = $109;
 }
 
 function cardano_serialization_lib__Transaction__witness_set__h43811a4afb9511d9($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, i64toi32_i32$2 = 0, $4 = 0, $55 = 0, $68 = 0, $78 = 0, $81 = 0, $84 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if (HEAP32[($1 + 344 | 0) >> 2] | 0) {
     break label$2
    }
    HEAP32[$2 >> 2] = 0;
    break label$1;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h26733a351c1d0f0b($2 | 0, $1 + 344 | 0 | 0);
  }
  $3 = $1 + 368 | 0;
  label$3 : {
   label$4 : {
    $4 = HEAP32[($1 + 356 | 0) >> 2] | 0;
    if ($4) {
     break label$4
    }
    HEAP32[($2 + 16 | 0) >> 2] = 0;
    break label$3;
   }
   alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($2 + 16 | 0 | 0, $4 | 0, HEAP32[($1 + 364 | 0) >> 2] | 0 | 0);
  }
  label$5 : {
   label$6 : {
    if (HEAP32[$3 >> 2] | 0) {
     break label$6
    }
    HEAP32[($2 + 32 | 0) >> 2] = 0;
    break label$5;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h09a8331f58cd0bf4($2 + 32 | 0 | 0, $3 | 0);
  }
  $3 = $0 + 36 | 0;
  label$7 : {
   label$8 : {
    $4 = $1 + 380 | 0;
    if (HEAP32[$4 >> 2] | 0) {
     break label$8
    }
    HEAP32[$3 >> 2] = 0;
    break label$7;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hc722e22117ee5940($3 | 0, $4 | 0);
  }
  $3 = $1 + 408 | 0;
  label$9 : {
   label$10 : {
    if ((HEAPU8[($1 + 404 | 0) >> 0] | 0 | 0) != (3 | 0)) {
     break label$10
    }
    HEAP8[($0 + 60 | 0) >> 0] = 3;
    break label$9;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hc831120dea694494($2 + 48 | 0 | 0, $1 + 392 | 0 | 0);
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 52 | 0) >> 2] | 0;
   $55 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[(i64toi32_i32$0 + 48 | 0) >> 2] = $55;
   HEAP32[(i64toi32_i32$0 + 52 | 0) >> 2] = i64toi32_i32$1;
   $1 = HEAPU8[($1 + 404 | 0) >> 0] | 0;
   HEAP8[($2 + 60 | 0) >> 0] = ($1 | 0) == (2 | 0) ? 2 : ($1 | 0) != (0 | 0);
   i64toi32_i32$2 = $2 + 56 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $68 = i64toi32_i32$1;
   i64toi32_i32$1 = $0 + 56 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $68;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  }
  $1 = $0 + 64 | 0;
  label$11 : {
   label$12 : {
    if (HEAP32[$3 >> 2] | 0) {
     break label$12
    }
    HEAP32[$1 >> 2] = 0;
    break label$11;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h1b9d2509f9812649($1 | 0, $3 | 0);
  }
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $78 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $78;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $81 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = $81;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $84 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = $84;
  HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
  HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 64 | 0;
 }
 
 function transactionbody_update($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $4 = 0, $2 = 0, $3 = 0, $36 = 0, $49 = 0, $54 = 0, $57 = 0, $61 = 0, $78 = 0, $92 = 0, $98 = 0, $104 = 0, $107 = 0;
  $1 = global$0 - 112 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h356c30395cf13adb($1 + 8 | 0 | 0, $0 | 0);
   $2 = 0;
   $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   $0 = 0;
   label$2 : {
    $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    if (!(HEAP32[($4 + 84 | 0) >> 2] | 0)) {
     break label$2
    }
    $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h847b9d84e24adaa5($1 + 64 | 0 | 0, $4 + 64 | 0 | 0);
    $0 = $1 + 104 | 0;
    HEAP32[$0 >> 2] = HEAP32[($4 + 104 | 0) >> 2] | 0;
    i64toi32_i32$2 = ($1 + 64 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $36 = i64toi32_i32$0;
    i64toi32_i32$0 = ($1 + 40 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $36;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(($1 + 40 | 0) + 16 | 0) >> 2] = HEAP32[(($1 + 64 | 0) + 16 | 0) >> 2] | 0;
    i64toi32_i32$2 = $1 + 96 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $49 = i64toi32_i32$1;
    i64toi32_i32$1 = ($1 + 16 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $49;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $54 = i64toi32_i32$0;
    i64toi32_i32$0 = ($1 + 16 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $54;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = HEAP32[($1 + 64 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($1 + 68 | 0) >> 2] | 0;
    $57 = i64toi32_i32$1;
    i64toi32_i32$1 = $1;
    HEAP32[($1 + 40 | 0) >> 2] = $57;
    HEAP32[($1 + 44 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $1 + 88 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $61 = i64toi32_i32$0;
    i64toi32_i32$0 = $1;
    HEAP32[($1 + 16 | 0) >> 2] = $61;
    HEAP32[($1 + 20 | 0) >> 2] = i64toi32_i32$1;
    $0 = HEAP32[($1 + 84 | 0) >> 2] | 0;
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
   label$3 : {
    if (!$0) {
     break label$3
    }
    HEAP32[($1 + 84 | 0) >> 2] = $0;
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = HEAP32[($1 + 16 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($1 + 20 | 0) >> 2] | 0;
    $78 = i64toi32_i32$1;
    i64toi32_i32$1 = $1 + 88 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $78;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[(($1 + 64 | 0) + 16 | 0) >> 2] = HEAP32[(($1 + 40 | 0) + 16 | 0) >> 2] | 0;
    i64toi32_i32$2 = ($1 + 40 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $92 = i64toi32_i32$0;
    i64toi32_i32$0 = ($1 + 64 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $92;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = ($1 + 16 | 0) + 8 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $98 = i64toi32_i32$1;
    i64toi32_i32$1 = $1 + 96 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $98;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = ($1 + 16 | 0) + 16 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $104 = i64toi32_i32$0;
    i64toi32_i32$0 = $1 + 104 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $104;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = HEAP32[($1 + 40 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($1 + 44 | 0) >> 2] | 0;
    $107 = i64toi32_i32$1;
    i64toi32_i32$1 = $1;
    HEAP32[($1 + 64 | 0) >> 2] = $107;
    HEAP32[($1 + 68 | 0) >> 2] = i64toi32_i32$0;
    $2 = $cardano_serialization_lib__Update_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__heaf0e9524107f139($1 + 64 | 0 | 0) | 0;
   }
   global$0 = $1 + 112 | 0;
   return $2 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function $cardano_serialization_lib__chain_crypto__key__PublicKey_A__20as_20cardano_serialization_lib__chain_crypto__bech32__Bech32___try_from_bech32_str__he17a6fbbec90bbc9($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $4 = 0, $5 = 0, $6 = 0, $28 = 0, $52 = 0, $57 = 0, $62 = 0, $66 = 0, $4$hi = 0, $5$hi = 0, $6$hi = 0;
  $3 = global$0 - 80 | 0;
  global$0 = $3;
  cardano_serialization_lib__chain_crypto__bech32__try_from_bech32_to_bytes__h77d64bec4bd5ad33($3 + 48 | 0 | 0, $1 | 0, $2 | 0);
  $1 = $3 + 48 | 0 | 4 | 0;
  label$1 : {
   label$2 : {
    if ((HEAP32[($3 + 48 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    HEAP32[(($3 + 8 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $1;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $28 = i64toi32_i32$0;
    i64toi32_i32$0 = $3;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $28;
    HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e(i64toi32_i32$0 | 0, i64toi32_i32$0 + 8 | 0 | 0);
    label$3 : {
     label$4 : {
      if ((HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0 | 0) != (32 | 0)) {
       break label$4
      }
      $1 = HEAP32[$3 >> 2] | 0;
      $2 = $3 + 72 | 0;
      i64toi32_i32$0 = $2;
      i64toi32_i32$1 = 0;
      HEAP32[i64toi32_i32$0 >> 2] = 0;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$0 = $3 + 64 | 0;
      i64toi32_i32$1 = 0;
      HEAP32[i64toi32_i32$0 >> 2] = 0;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$0 = ($3 + 48 | 0) + 8 | 0;
      i64toi32_i32$1 = 0;
      HEAP32[i64toi32_i32$0 >> 2] = 0;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$0 = $3;
      i64toi32_i32$1 = 0;
      HEAP32[(i64toi32_i32$0 + 48 | 0) >> 2] = 0;
      HEAP32[(i64toi32_i32$0 + 52 | 0) >> 2] = i64toi32_i32$1;
      core__slice___impl_20_5bT_5d___clone_from_slice__h1742dfbd5d5d9efd(i64toi32_i32$0 + 48 | 0 | 0, 32 | 0, $1 | 0, 32 | 0);
      i64toi32_i32$2 = i64toi32_i32$0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 49 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 50 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 51 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 52 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$0 + 53 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 54 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 55 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 56 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $52 = i64toi32_i32$1;
      i64toi32_i32$1 = $0 + 2 | 0;
      $18 = $52;
      HEAP8[i64toi32_i32$1 >> 0] = $18;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $18 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $18 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $18 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      i64toi32_i32$2 = $3 + 57 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $57 = i64toi32_i32$0;
      i64toi32_i32$0 = $0 + 10 | 0;
      $19 = $57;
      HEAP8[i64toi32_i32$0 >> 0] = $19;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $19 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $19 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $19 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      i64toi32_i32$2 = $3 + 65 | 0;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $62 = i64toi32_i32$1;
      i64toi32_i32$1 = $0 + 18 | 0;
      $20 = $62;
      HEAP8[i64toi32_i32$1 >> 0] = $20;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $20 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $20 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $20 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      i64toi32_i32$2 = $2;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $66 = i64toi32_i32$0;
      i64toi32_i32$0 = $0 + 25 | 0;
      $21 = $66;
      HEAP8[i64toi32_i32$0 >> 0] = $21;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $21 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $21 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $21 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      HEAP8[($0 + 1 | 0) >> 0] = HEAPU8[($3 + 48 | 0) >> 0] | 0;
      $1 = 0;
      break label$3;
     }
     cardano_serialization_lib__chain_crypto__bech32__Error__data_invalid__h845fc6de9cc87c9e($0 + 4 | 0 | 0, 0 | 0);
     $1 = 1;
    }
    HEAP8[$0 >> 0] = $1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 8 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 8 | 0 | 0);
    break label$1;
   }
   i64toi32_i32$2 = $1 + 16 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $4 = i64toi32_i32$1;
   $4$hi = i64toi32_i32$0;
   i64toi32_i32$1 = ($3 + 24 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $4;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $1 + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $5 = i64toi32_i32$0;
   $5$hi = i64toi32_i32$1;
   i64toi32_i32$0 = ($3 + 24 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $5;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $6 = i64toi32_i32$1;
   $6$hi = i64toi32_i32$0;
   i64toi32_i32$1 = $3;
   HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = $6;
   HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $4$hi;
   i64toi32_i32$1 = $0 + 20 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $4;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $5$hi;
   i64toi32_i32$1 = $0 + 12 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $5;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $6$hi;
   i64toi32_i32$1 = $0 + 4 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $6;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP8[$0 >> 0] = 1;
  }
  global$0 = $3 + 80 | 0;
 }
 
 function $cardano_serialization_lib__chain_crypto__key__SecretKey_A__20as_20cardano_serialization_lib__chain_crypto__bech32__Bech32___try_from_bech32_str__hdcee3af11441aa7a($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $4 = 0, $5 = 0, $6 = 0, $28 = 0, $52 = 0, $57 = 0, $62 = 0, $66 = 0, $4$hi = 0, $5$hi = 0, $6$hi = 0;
  $3 = global$0 - 80 | 0;
  global$0 = $3;
  cardano_serialization_lib__chain_crypto__bech32__try_from_bech32_to_bytes__hc722a9189251e96f($3 + 48 | 0 | 0, $1 | 0, $2 | 0);
  $1 = $3 + 48 | 0 | 4 | 0;
  label$1 : {
   label$2 : {
    if ((HEAP32[($3 + 48 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    HEAP32[(($3 + 8 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $1;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $28 = i64toi32_i32$0;
    i64toi32_i32$0 = $3;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $28;
    HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e(i64toi32_i32$0 | 0, i64toi32_i32$0 + 8 | 0 | 0);
    label$3 : {
     label$4 : {
      if ((HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0 | 0) != (32 | 0)) {
       break label$4
      }
      $1 = HEAP32[$3 >> 2] | 0;
      $2 = $3 + 72 | 0;
      i64toi32_i32$0 = $2;
      i64toi32_i32$1 = 0;
      HEAP32[i64toi32_i32$0 >> 2] = 0;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$0 = $3 + 64 | 0;
      i64toi32_i32$1 = 0;
      HEAP32[i64toi32_i32$0 >> 2] = 0;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$0 = ($3 + 48 | 0) + 8 | 0;
      i64toi32_i32$1 = 0;
      HEAP32[i64toi32_i32$0 >> 2] = 0;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$0 = $3;
      i64toi32_i32$1 = 0;
      HEAP32[(i64toi32_i32$0 + 48 | 0) >> 2] = 0;
      HEAP32[(i64toi32_i32$0 + 52 | 0) >> 2] = i64toi32_i32$1;
      core__slice___impl_20_5bT_5d___clone_from_slice__h1742dfbd5d5d9efd(i64toi32_i32$0 + 48 | 0 | 0, 32 | 0, $1 | 0, 32 | 0);
      i64toi32_i32$2 = i64toi32_i32$0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$0 + 49 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 50 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 51 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 52 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$0 + 53 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$0 + 54 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$0 + 55 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$0 + 56 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $52 = i64toi32_i32$1;
      i64toi32_i32$1 = $0 + 2 | 0;
      $18 = $52;
      HEAP8[i64toi32_i32$1 >> 0] = $18;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $18 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $18 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $18 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      i64toi32_i32$2 = $3 + 57 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $57 = i64toi32_i32$0;
      i64toi32_i32$0 = $0 + 10 | 0;
      $19 = $57;
      HEAP8[i64toi32_i32$0 >> 0] = $19;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $19 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $19 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $19 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      i64toi32_i32$2 = $3 + 65 | 0;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $62 = i64toi32_i32$1;
      i64toi32_i32$1 = $0 + 18 | 0;
      $20 = $62;
      HEAP8[i64toi32_i32$1 >> 0] = $20;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $20 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $20 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $20 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      i64toi32_i32$2 = $2;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $66 = i64toi32_i32$0;
      i64toi32_i32$0 = $0 + 25 | 0;
      $21 = $66;
      HEAP8[i64toi32_i32$0 >> 0] = $21;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $21 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $21 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $21 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      HEAP8[($0 + 1 | 0) >> 0] = HEAPU8[($3 + 48 | 0) >> 0] | 0;
      $1 = 0;
      break label$3;
     }
     cardano_serialization_lib__chain_crypto__bech32__Error__data_invalid__he819388589c1a4db($0 + 4 | 0 | 0, 0 | 0);
     $1 = 1;
    }
    HEAP8[$0 >> 0] = $1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 8 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 8 | 0 | 0);
    break label$1;
   }
   i64toi32_i32$2 = $1 + 16 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $4 = i64toi32_i32$1;
   $4$hi = i64toi32_i32$0;
   i64toi32_i32$1 = ($3 + 24 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $4;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $1 + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $5 = i64toi32_i32$0;
   $5$hi = i64toi32_i32$1;
   i64toi32_i32$0 = ($3 + 24 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $5;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $6 = i64toi32_i32$1;
   $6$hi = i64toi32_i32$0;
   i64toi32_i32$1 = $3;
   HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = $6;
   HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $4$hi;
   i64toi32_i32$1 = $0 + 20 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $4;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $5$hi;
   i64toi32_i32$1 = $0 + 12 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $5;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $6$hi;
   i64toi32_i32$1 = $0 + 4 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $6;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP8[$0 >> 0] = 1;
  }
  global$0 = $3 + 80 | 0;
 }
 
 function alloc__collections__btree__map__entry__VacantEntry_K_2cV___insert__h46f4eca0a6822bea($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $5 = 0, $8 = 0, $4 = 0, $20 = 0, $33 = 0, $3 = 0, $6 = 0, $7 = 0, $103 = 0;
  $2 = global$0 - 480 | 0;
  global$0 = $2;
  HEAP32[(($2 + 464 | 0) + 8 | 0) >> 2] = HEAP32[($0 + 136 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($0 + 128 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($0 + 132 | 0) >> 2] | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 464 | 0) >> 2] = $20;
  HEAP32[($2 + 468 | 0) >> 2] = i64toi32_i32$1;
  memcpy($2 + 184 | 0 | 0, $0 | 0, 128 | 0) | 0;
  HEAP32[(($2 + 336 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $33 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 336 | 0) >> 2] = $33;
  HEAP32[($2 + 340 | 0) >> 2] = i64toi32_i32$0;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_recursing__hab4e5c589e083d2a($2 + 8 | 0 | 0, $2 + 464 | 0 | 0, $2 + 184 | 0 | 0, $2 + 336 | 0 | 0);
  $3 = HEAP32[($2 + 176 | 0) >> 2] | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     $0 = HEAP32[($0 + 140 | 0) >> 2] | 0;
     HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
     break label$2;
    }
    $4 = ($2 + 8 | 0) + 8 | 0;
    memcpy($2 + 184 | 0 | 0, $4 | 0, 144 | 0) | 0;
    $0 = HEAP32[($0 + 140 | 0) >> 2] | 0;
    $5 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    if (!$5) {
     break label$1
    }
    $6 = HEAP32[($2 + 172 | 0) >> 2] | 0;
    $7 = HEAP32[($2 + 168 | 0) >> 2] | 0;
    $8 = HEAP32[$0 >> 2] | 0;
    $1 = alloc__boxed__Box_T_2cA___new_uninit_in__h57df8859addacc9a() | 0;
    HEAP32[($1 + 1552 | 0) >> 2] = $5;
    HEAP16[($1 + 1546 | 0) >> 1] = 0;
    HEAP32[($1 + 1408 | 0) >> 2] = 0;
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    $8 = $8 + 1 | 0;
    HEAP32[$0 >> 2] = $8;
    HEAP16[($5 + 1544 | 0) >> 1] = 0;
    HEAP32[($5 + 1408 | 0) >> 2] = $1;
    HEAP32[($2 + 332 | 0) >> 2] = $1;
    HEAP32[($2 + 328 | 0) >> 2] = $8;
    memcpy($2 + 336 | 0 | 0, $4 | 0, 128 | 0) | 0;
    HEAP32[($2 + 472 | 0) >> 2] = HEAP32[($2 + 320 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 312 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 316 | 0) >> 2] | 0;
    $103 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[($2 + 464 | 0) >> 2] = $103;
    HEAP32[($2 + 468 | 0) >> 2] = i64toi32_i32$1;
    alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal___push__h7628a10c0a82fa84($2 + 328 | 0 | 0, $2 + 336 | 0 | 0, $2 + 464 | 0 | 0, $7 | 0, $6 | 0);
    HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
   }
   global$0 = $2 + 480 | 0;
   return $3 | 0;
  }
  core__panicking__panic__h2fd385a887c8bf13(1072048 | 0, 43 | 0, 1072248 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_recursing__h92f2000fc44dc2eb($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, $8 = 0, $5 = 0, $6 = 0, $7 = 0, i64toi32_i32$1 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  HEAP32[(($3 + 32 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  HEAP32[($3 + 32 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
  HEAP32[($3 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert__h75cac002114ac4d4($3 | 0, $3 + 32 | 0 | 0, $2 | 0);
  $2 = HEAP32[($3 + 12 | 0) >> 2] | 0;
  $1 = HEAP32[($3 + 8 | 0) >> 2] | 0;
  $4 = HEAP32[($3 + 4 | 0) >> 2] | 0;
  $5 = HEAP32[($3 + 24 | 0) >> 2] | 0;
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    HEAP32[($0 + 24 | 0) >> 2] = $5;
    HEAP32[($0 + 4 | 0) >> 2] = $4;
    HEAP32[$0 >> 2] = 0;
    HEAP32[($0 + 12 | 0) >> 2] = $2;
    HEAP32[($0 + 8 | 0) >> 2] = $1;
    break label$1;
   }
   $6 = HEAP32[($3 + 20 | 0) >> 2] | 0;
   $7 = HEAP32[($3 + 16 | 0) >> 2] | 0;
   label$3 : {
    $8 = HEAP32[$1 >> 2] | 0;
    if (!$8) {
     break label$3
    }
    label$4 : while (1) {
     HEAP32[($3 + 40 | 0) >> 2] = HEAPU16[($1 + 48 | 0) >> 1] | 0;
     HEAP32[($3 + 36 | 0) >> 2] = $8;
     HEAP32[($3 + 32 | 0) >> 2] = $4 + 1 | 0;
     alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert__haab97383f97b0b0d($3 | 0, $3 + 32 | 0 | 0, $2 | 0, $7 | 0, $6 | 0);
     $2 = HEAP32[($3 + 12 | 0) >> 2] | 0;
     $1 = HEAP32[($3 + 8 | 0) >> 2] | 0;
     $4 = HEAP32[($3 + 4 | 0) >> 2] | 0;
     label$5 : {
      if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
       break label$5
      }
      HEAP32[($0 + 24 | 0) >> 2] = $5;
      HEAP32[($0 + 4 | 0) >> 2] = $4;
      HEAP32[$0 >> 2] = 0;
      HEAP32[($0 + 12 | 0) >> 2] = $2;
      HEAP32[($0 + 8 | 0) >> 2] = $1;
      break label$1;
     }
     $6 = HEAP32[($3 + 20 | 0) >> 2] | 0;
     $7 = HEAP32[($3 + 16 | 0) >> 2] | 0;
     $8 = HEAP32[$1 >> 2] | 0;
     if ($8) {
      continue label$4
     }
     break label$4;
    };
   }
   HEAP32[($0 + 24 | 0) >> 2] = $5;
   HEAP32[($0 + 4 | 0) >> 2] = $4;
   HEAP32[$0 >> 2] = 1;
   HEAP32[($0 + 20 | 0) >> 2] = $6;
   HEAP32[($0 + 16 | 0) >> 2] = $7;
   HEAP32[($0 + 12 | 0) >> 2] = $2;
   HEAP32[($0 + 8 | 0) >> 2] = $1;
  }
  global$0 = $3 + 48 | 0;
 }
 
 function compiler_builtins__math__libm__log2__log2__hdd4a3a03f0936a68($0) {
  $0 = +$0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $3 = 0, $3$hi = 0, $1 = 0, $7 = 0.0, $5 = 0.0, $6 = 0.0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $2 = 0, $23 = 0, $24 = 0, $25 = 0, $26 = 0, $27 = 0, $8 = 0.0, $9 = 0.0, $50$hi = 0, $80 = 0.0, $85 = 0.0, $90 = 0.0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      wasm2js_scratch_store_f64(+$0);
      i64toi32_i32$0 = wasm2js_scratch_load_i32(1 | 0) | 0;
      $3 = wasm2js_scratch_load_i32(0 | 0) | 0;
      $3$hi = i64toi32_i32$0;
      i64toi32_i32$2 = $3;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 0;
      if ((i64toi32_i32$0 | 0) < (i64toi32_i32$1 | 0)) {
       $19 = 1
      } else {
       if ((i64toi32_i32$0 | 0) <= (i64toi32_i32$1 | 0)) {
        if (i64toi32_i32$2 >>> 0 >= i64toi32_i32$3 >>> 0) {
         $20 = 0
        } else {
         $20 = 1
        }
        $21 = $20;
       } else {
        $21 = 0
       }
       $19 = $21;
      }
      if ($19) {
       break label$4
      }
      i64toi32_i32$2 = $3$hi;
      i64toi32_i32$3 = $3;
      i64toi32_i32$0 = 0;
      i64toi32_i32$1 = 32;
      i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
       i64toi32_i32$0 = 0;
       $22 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
      } else {
       i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
       $22 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$4 | 0) | 0;
      }
      $1 = $22;
      if ($1 >>> 0 < 1048576 >>> 0) {
       break label$4
      }
      if ($1 >>> 0 > 2146435071 >>> 0) {
       break label$2
      }
      $2 = -1023;
      i64toi32_i32$0 = $3$hi;
      i64toi32_i32$2 = $3;
      i64toi32_i32$3 = 0;
      i64toi32_i32$1 = -1;
      i64toi32_i32$3 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
      $3 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
      $3$hi = i64toi32_i32$3;
      i64toi32_i32$0 = $3;
      i64toi32_i32$2 = 0;
      i64toi32_i32$1 = 0;
      if ((i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$3 | 0) != (i64toi32_i32$2 | 0) | 0) {
       break label$3
      }
      $0 = 0.0;
      if (($1 | 0) != (1072693248 | 0)) {
       break label$3
      }
      break label$2;
     }
     label$5 : {
      i64toi32_i32$0 = $3$hi;
      i64toi32_i32$1 = $3;
      i64toi32_i32$3 = 2147483647;
      i64toi32_i32$2 = -1;
      i64toi32_i32$3 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
      i64toi32_i32$0 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
      i64toi32_i32$1 = 0;
      i64toi32_i32$2 = 0;
      if ((i64toi32_i32$0 | 0) != (i64toi32_i32$2 | 0) | (i64toi32_i32$3 | 0) != (i64toi32_i32$1 | 0) | 0) {
       break label$5
      }
      return +(-1.0 / ($0 * $0));
     }
     i64toi32_i32$0 = $3$hi;
     i64toi32_i32$2 = $3;
     i64toi32_i32$3 = 0;
     i64toi32_i32$1 = 0;
     if ((i64toi32_i32$0 | 0) < (i64toi32_i32$3 | 0)) {
      $23 = 1
     } else {
      if ((i64toi32_i32$0 | 0) <= (i64toi32_i32$3 | 0)) {
       if (i64toi32_i32$2 >>> 0 >= i64toi32_i32$1 >>> 0) {
        $24 = 0
       } else {
        $24 = 1
       }
       $25 = $24;
      } else {
       $25 = 0
      }
      $23 = $25;
     }
     if ($23) {
      break label$1
     }
     wasm2js_scratch_store_f64(+($0 * 18014398509481984.0));
     i64toi32_i32$2 = wasm2js_scratch_load_i32(1 | 0) | 0;
     i64toi32_i32$1 = wasm2js_scratch_load_i32(0 | 0) | 0;
     i64toi32_i32$0 = 0;
     i64toi32_i32$3 = -1;
     i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
     $3 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
     $3$hi = i64toi32_i32$0;
     i64toi32_i32$0 = i64toi32_i32$2;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$1 = 0;
     i64toi32_i32$3 = 32;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$1 = 0;
      $26 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
     } else {
      i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
      $26 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
     }
     $1 = $26;
     $2 = -1077;
    }
    $1 = $1 + 614242 | 0;
    i64toi32_i32$1 = 0;
    i64toi32_i32$0 = ($1 & 1048575 | 0) + 1072079006 | 0;
    i64toi32_i32$2 = 0;
    i64toi32_i32$3 = 32;
    i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
     $27 = 0;
    } else {
     i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
     $27 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
    }
    $50$hi = i64toi32_i32$2;
    i64toi32_i32$2 = $3$hi;
    i64toi32_i32$2 = $50$hi;
    i64toi32_i32$1 = $27;
    i64toi32_i32$0 = $3$hi;
    i64toi32_i32$3 = $3;
    i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
    wasm2js_scratch_store_i32(0 | 0, i64toi32_i32$1 | i64toi32_i32$3 | 0 | 0);
    wasm2js_scratch_store_i32(1 | 0, i64toi32_i32$0 | 0);
    $0 = +wasm2js_scratch_load_f64() + -1.0;
    $5 = $0 * ($0 * .5);
    wasm2js_scratch_store_f64(+($0 - $5));
    i64toi32_i32$0 = wasm2js_scratch_load_i32(1 | 0) | 0;
    i64toi32_i32$2 = wasm2js_scratch_load_i32(0 | 0) | 0;
    i64toi32_i32$1 = -1;
    i64toi32_i32$3 = 0;
    i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
    wasm2js_scratch_store_i32(0 | 0, i64toi32_i32$2 & i64toi32_i32$3 | 0 | 0);
    wasm2js_scratch_store_i32(1 | 0, i64toi32_i32$1 | 0);
    $6 = +wasm2js_scratch_load_f64();
    $7 = $6 * 1.4426950407214463;
    $8 = +(($1 >>> 20 | 0) + $2 | 0 | 0);
    $9 = $7 + $8;
    $80 = $7 + ($8 - $9);
    $85 = $0 - $6 - $5;
    $0 = $0 / ($0 + 2.0);
    $90 = $0;
    $7 = $0 * $0;
    $0 = $7 * $7;
    $0 = $85 + $90 * ($5 + ($0 * ($0 * ($0 * .15313837699209373 + .22222198432149784) + .3999999999940942) + $7 * ($0 * ($0 * ($0 * .14798198605116586 + .1818357216161805) + .2857142874366239) + .6666666666666735)));
    $0 = $9 + ($80 + ($0 * 1.4426950407214463 + ($0 + $6) * 1.6751713164886512e-10));
   }
   return +$0;
  }
  return +(($0 - $0) / 0.0);
 }
 
 function cardano_serialization_lib__NativeScript__hash__hb812a54d2c7bdca2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $3 = 0, $12 = 0, $13 = 0, $14 = 0, $15 = 0, $16 = 0, $4 = 0, $19 = 0, $90 = 0, $94 = 0, $97 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  cardano_serialization_lib__NativeScript__to_bytes__hcf189ce9571cef2e($2 + 48 | 0 | 0, $1 | 0);
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 + 24 | 0 | 0, (HEAP32[($2 + 56 | 0) >> 2] | 0) + 1 | 0 | 0, 0 | 0);
  HEAP32[($2 + 40 | 0) >> 2] = 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $19 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $19;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 48 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 48 | 0 | 0);
  label$1 : {
   $3 = __rust_alloc(1 | 0, 1 | 0) | 0;
   if ($3) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(1 | 0, 1 | 0);
   abort();
  }
  HEAP8[$3 >> 0] = 0;
  alloc__slice__hack__into_vec__h7c95d082cf6730ee($2 + 48 | 0 | 0, $3 | 0, 1 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($2 + 32 | 0 | 0, HEAP32[($2 + 16 | 0) >> 2] | 0 | 0, HEAP32[($2 + 20 | 0) >> 2] | 0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 48 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 48 | 0 | 0);
  cardano_serialization_lib__NativeScript__to_bytes__hcf189ce9571cef2e($2 + 48 | 0 | 0, $1 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $2 + 48 | 0 | 0);
  alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($2 + 32 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 48 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 48 | 0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 | 0, $2 + 32 | 0 | 0);
  $1 = ($2 + 48 | 0) + 8 | 0;
  i64toi32_i32$0 = $1;
  i64toi32_i32$1 = 0;
  HEAP32[i64toi32_i32$0 >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $3 = ($2 + 48 | 0) + 16 | 0;
  i64toi32_i32$0 = $3;
  i64toi32_i32$1 = 0;
  HEAP32[i64toi32_i32$0 >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $4 = ($2 + 48 | 0) + 24 | 0;
  HEAP32[$4 >> 2] = 0;
  i64toi32_i32$0 = $2;
  i64toi32_i32$1 = 0;
  HEAP32[($2 + 48 | 0) >> 2] = 0;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cryptoxide__blake2b__Blake2b__blake2b__hfbfc741a485cb529($2 + 48 | 0 | 0, 28 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 1066228 | 0, 0 | 0);
  $12 = $0 + 24 | 0;
  $13 = HEAP32[$4 >> 2] | 0;
  HEAP8[$12 >> 0] = $13;
  HEAP8[($12 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[($12 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[($12 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $90 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 16 | 0;
  $14 = $90;
  HEAP8[i64toi32_i32$1 >> 0] = $14;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $14 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $14 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $14 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $94 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 8 | 0;
  $15 = $94;
  HEAP8[i64toi32_i32$0 >> 0] = $15;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $15 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $15 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $15 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $97 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  $16 = $97;
  HEAP8[i64toi32_i32$1 >> 0] = $16;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $16 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 32 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 32 | 0 | 0);
  global$0 = $2 + 80 | 0;
 }
 
 function cardano_serialization_lib__utils__make_icarus_bootstrap_witness__h3e3e2f5db19a8349($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, $17 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $39 = 0, $44 = 0, $49 = 0, $54 = 0, $80 = 0, $89 = 0, $95 = 0, $101 = 0, $104 = 0;
  $4 = global$0 - 224 | 0;
  global$0 = $4;
  cardano_serialization_lib__crypto__Bip32PrivateKey__chaincode__h32cbffafab5e64aa($4 + 24 | 0 | 0, $3 | 0);
  memset($4 + 160 | 0 | 0, 0 | 0, 64 | 0) | 0;
  ed25519_bip32__key__XPrv__get_extended_mut__h396b8224008dfa18($3 | 0, $4 + 160 | 0 | 0);
  memcpy($4 + 40 | 0 | 1 | 0 | 0, $4 + 160 | 0 | 0, 64 | 0) | 0;
  HEAP8[($4 + 40 | 0) >> 0] = 0;
  cardano_serialization_lib__impl_mockchain__key__EitherEd25519SecretKey__to_public__hd7cd5c1f2cabbdb8($4 + 112 | 0 | 0, $4 + 40 | 0 | 0);
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($4 + 16 | 0 | 0, 32 | 0, 0 | 0);
  HEAP32[($4 + 148 | 0) >> 2] = HEAP32[($4 + 20 | 0) >> 2] | 0;
  $3 = HEAP32[($4 + 16 | 0) >> 2] | 0;
  HEAP32[($4 + 144 | 0) >> 2] = $3;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $39 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  $17 = $39;
  HEAP8[i64toi32_i32$0 >> 0] = $17;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $17 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $17 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $17 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $44 = i64toi32_i32$1;
  i64toi32_i32$1 = $3 + 8 | 0;
  $18 = $44;
  HEAP8[i64toi32_i32$1 >> 0] = $18;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $18 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $18 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $18 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $49 = i64toi32_i32$0;
  i64toi32_i32$0 = $3 + 16 | 0;
  $19 = $49;
  HEAP8[i64toi32_i32$0 >> 0] = $19;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $19 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $19 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $19 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 24 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $54 = i64toi32_i32$1;
  i64toi32_i32$1 = $3 + 24 | 0;
  $20 = $54;
  HEAP8[i64toi32_i32$1 >> 0] = $20;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $20 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $20 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $20 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP32[($4 + 152 | 0) >> 2] = 32;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($4 + 8 | 0 | 0, $4 + 144 | 0 | 0);
  cardano_serialization_lib__crypto__PrivateKey__sign__habe0df84ae280136($4 + 160 | 0 | 0, $4 + 40 | 0 | 0, HEAP32[($4 + 8 | 0) >> 2] | 0 | 0, HEAP32[($4 + 12 | 0) >> 2] | 0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($4 + 144 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($4 + 144 | 0 | 0);
  HEAP32[($0 + 8 | 0) >> 2] = HEAP32[(($4 + 24 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $80 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $80;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__address__ByronAddress__attributes__hedb23cddc1880465(i64toi32_i32$0 + 12 | 0 | 0, $2 | 0);
  i64toi32_i32$2 = (i64toi32_i32$2 + 112 | 0) + 24 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $89 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 48 | 0;
  $21 = $89;
  HEAP8[i64toi32_i32$1 >> 0] = $21;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $21 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $21 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $21 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = ($4 + 112 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $95 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 40 | 0;
  $22 = $95;
  HEAP8[i64toi32_i32$0 >> 0] = $22;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $22 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $22 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $22 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = ($4 + 112 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $101 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 32 | 0;
  $23 = $101;
  HEAP8[i64toi32_i32$1 >> 0] = $23;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $23 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $23 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $23 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 112 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 113 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 114 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 115 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 116 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 117 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 118 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 119 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $104 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  $24 = $104;
  HEAP8[(i64toi32_i32$0 + 24 | 0) >> 0] = $24;
  HEAP8[(i64toi32_i32$0 + 25 | 0) >> 0] = $24 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 26 | 0) >> 0] = $24 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 27 | 0) >> 0] = $24 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 28 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 29 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 30 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 31 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  memcpy(i64toi32_i32$0 + 56 | 0 | 0, i64toi32_i32$2 + 160 | 0 | 0, 64 | 0) | 0;
  global$0 = i64toi32_i32$2 + 224 | 0;
 }
 
 function bootstrapwitness_new($0, $1, $2, $3, $4, $5) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  $5 = $5 | 0;
  var i64toi32_i32$2 = 0, $6 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $7 = 0, $8 = 0, $65 = 0, $70 = 0, $75 = 0, $78 = 0, $98 = 0, $101 = 0;
  $6 = global$0 - 288 | 0;
  global$0 = $6;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h38603c546ca761f2($6 + 24 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $7 = HEAP32[($6 + 28 | 0) >> 2] | 0;
   $0 = HEAP32[($6 + 24 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hd6fdee4274fe58a2($6 + 16 | 0 | 0, $1 | 0);
   $1 = HEAP32[($6 + 20 | 0) >> 2] | 0;
   $8 = HEAP32[($6 + 16 | 0) >> 2] | 0;
   HEAP32[($6 + 176 | 0) >> 2] = $3;
   HEAP32[($6 + 172 | 0) >> 2] = $3;
   HEAP32[($6 + 168 | 0) >> 2] = $2;
   alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($6 + 8 | 0 | 0, $6 + 168 | 0 | 0);
   $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($6 + 152 | 0 | 0, HEAP32[($6 + 8 | 0) >> 2] | 0 | 0, HEAP32[($6 + 12 | 0) >> 2] | 0 | 0);
   HEAP32[($6 + 176 | 0) >> 2] = $5;
   HEAP32[($6 + 172 | 0) >> 2] = $5;
   HEAP32[($6 + 168 | 0) >> 2] = $4;
   alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($6 | 0, $6 + 168 | 0 | 0);
   $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($6 + 168 | 0 | 0, HEAP32[$6 >> 2] | 0 | 0, HEAP32[($6 + 4 | 0) >> 2] | 0 | 0);
   i64toi32_i32$2 = $0 + 24 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $65 = i64toi32_i32$0;
   i64toi32_i32$0 = $6 + 80 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $65;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $0 + 16 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $70 = i64toi32_i32$1;
   i64toi32_i32$1 = $6 + 72 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $70;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $0 + 8 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $75 = i64toi32_i32$0;
   i64toi32_i32$0 = $6 + 64 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $75;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $78 = i64toi32_i32$1;
   i64toi32_i32$1 = $6;
   HEAP32[($6 + 56 | 0) >> 2] = $78;
   HEAP32[($6 + 60 | 0) >> 2] = i64toi32_i32$0;
   memcpy($6 + 88 | 0 | 0, $8 | 0, 64 | 0) | 0;
   HEAP32[(($6 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($6 + 152 | 0) + 8 | 0) >> 2] | 0;
   HEAP32[($6 + 52 | 0) >> 2] = HEAP32[(($6 + 168 | 0) + 8 | 0) >> 2] | 0;
   i64toi32_i32$2 = $6;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 152 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 156 | 0) >> 2] | 0;
   $98 = i64toi32_i32$0;
   i64toi32_i32$0 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] = $98;
   HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 168 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 172 | 0) >> 2] | 0;
   $101 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] = $101;
   HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = i64toi32_i32$0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($7 | 0, (HEAP32[$7 >> 2] | 0) + -1 | 0 | 0) | 0;
   memcpy(i64toi32_i32$2 + 168 | 0 | 0, i64toi32_i32$2 + 32 | 0 | 0, 120 | 0) | 0;
   $0 = $cardano_serialization_lib__crypto__BootstrapWitness_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hcc8c8e7beca3e936(i64toi32_i32$2 + 168 | 0 | 0) | 0;
   global$0 = i64toi32_i32$2 + 288 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function cryptoxide__curve25519__ge__GePartial__double_p1p1__hf684fc70b9440336($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$3 = 0, $2 = 0, $7 = 0, $7$hi = 0, $4 = 0, $3 = 0, $5 = 0, $62 = 0, $65 = 0, $66 = 0, $67 = 0, $68 = 0, $71 = 0, $27 = 0, $43 = 0, $45 = 0, $45$hi = 0, $47 = 0, $47$hi = 0, $48 = 0, $48$hi = 0, $50 = 0, $50$hi = 0, $52 = 0, $52$hi = 0, $6 = 0, $6$hi = 0, $55$hi = 0, $58 = 0, $59 = 0, $61 = 0, $61$hi = 0, $63 = 0, $63$hi = 0, $64 = 0, $64$hi = 0, $66$hi = 0, $69 = 0, $70 = 0, $72 = 0, $72$hi = 0, $74 = 0, $74$hi = 0, $75 = 0, $75$hi = 0, $77$hi = 0, $81 = 0, $83 = 0, $83$hi = 0, $85 = 0, $85$hi = 0, $86 = 0, $86$hi = 0, $88$hi = 0, $91 = 0, $92 = 0, $95 = 0, $95$hi = 0, $97 = 0, $97$hi = 0;
  $2 = global$0 - 288 | 0;
  global$0 = $2;
  cryptoxide__curve25519__fe__fe64__Fe__square__h72fd8a55cd006328($2 + 8 | 0 | 0, $1 | 0);
  $3 = $1 + 40 | 0;
  cryptoxide__curve25519__fe__fe64__Fe__square__h72fd8a55cd006328($2 + 48 | 0 | 0, $3 | 0);
  cryptoxide__curve25519__fe__fe64__Fe__square__h72fd8a55cd006328($2 + 88 | 0 | 0, $1 + 80 | 0 | 0);
  $4 = 0;
  label$1 : while (1) {
   $5 = ($2 + 88 | 0) + $4 | 0;
   $27 = $5;
   i64toi32_i32$2 = $5;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   i64toi32_i32$2 = i64toi32_i32$0;
   i64toi32_i32$0 = 0;
   i64toi32_i32$3 = 1;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
    $62 = 0;
   } else {
    i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
    $62 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   }
   i64toi32_i32$2 = $27;
   HEAP32[i64toi32_i32$2 >> 2] = $62;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
   $4 = $4 + 8 | 0;
   if (($4 | 0) != (40 | 0)) {
    continue label$1
   }
   break label$1;
  };
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Add___add__he826ef0e90fce416($2 + 128 | 0 | 0, $1 | 0, $3 | 0);
  cryptoxide__curve25519__fe__fe64__Fe__square__h72fd8a55cd006328($2 + 168 | 0 | 0, $2 + 128 | 0 | 0);
  $43 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] | 0;
  $45 = i64toi32_i32$0;
  $45$hi = i64toi32_i32$2;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 56 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 60 | 0) >> 2] | 0;
  $47 = i64toi32_i32$2;
  $47$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $45$hi;
  i64toi32_i32$1 = $45;
  i64toi32_i32$2 = $47$hi;
  i64toi32_i32$3 = $47;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $48 = i64toi32_i32$4;
  $48$hi = i64toi32_i32$5;
  i64toi32_i32$0 = $2;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] | 0;
  $50 = i64toi32_i32$5;
  $50$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 48 | 0) >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 52 | 0) >> 2] | 0;
  $52 = i64toi32_i32$1;
  $52$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $50$hi;
  i64toi32_i32$0 = $50;
  i64toi32_i32$1 = $52$hi;
  i64toi32_i32$3 = $52;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $6 = i64toi32_i32$2;
  $6$hi = i64toi32_i32$4;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$1 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $65 = i64toi32_i32$4 >>> i64toi32_i32$1 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$4 >>> i64toi32_i32$1 | 0;
   $65 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$1 | 0) | 0;
  }
  $55$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $48$hi;
  i64toi32_i32$4 = $48;
  i64toi32_i32$5 = $55$hi;
  i64toi32_i32$3 = $65;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$1;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$4 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$4 = i64toi32_i32$2 & i64toi32_i32$4 | 0;
  $58 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $43;
  HEAP32[(i64toi32_i32$0 + 216 | 0) >> 2] = $58;
  HEAP32[(i64toi32_i32$0 + 220 | 0) >> 2] = i64toi32_i32$4;
  $59 = $2;
  i64toi32_i32$2 = $2;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $61 = i64toi32_i32$4;
  $61$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
  $63 = i64toi32_i32$0;
  $63$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $61$hi;
  i64toi32_i32$2 = $61;
  i64toi32_i32$0 = $63$hi;
  i64toi32_i32$3 = $63;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $64 = i64toi32_i32$5;
  $64$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$4 = $7;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$0 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $66 = i64toi32_i32$1 >>> i64toi32_i32$0 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$0 | 0;
   $66 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$0 | 0) | 0;
  }
  $66$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $64$hi;
  i64toi32_i32$1 = $64;
  i64toi32_i32$4 = $66$hi;
  i64toi32_i32$3 = $66;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$5;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$1 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$1 = i64toi32_i32$5 & i64toi32_i32$1 | 0;
  $69 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $59;
  HEAP32[(i64toi32_i32$2 + 224 | 0) >> 2] = $69;
  HEAP32[(i64toi32_i32$2 + 228 | 0) >> 2] = i64toi32_i32$1;
  $70 = $2;
  i64toi32_i32$5 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 32 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 36 | 0) >> 2] | 0;
  $72 = i64toi32_i32$1;
  $72$hi = i64toi32_i32$2;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 72 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 76 | 0) >> 2] | 0;
  $74 = i64toi32_i32$2;
  $74$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $72$hi;
  i64toi32_i32$5 = $72;
  i64toi32_i32$2 = $74$hi;
  i64toi32_i32$3 = $74;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $75 = i64toi32_i32$4;
  $75$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$1 = $7;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$2 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$5 = 0;
   $67 = i64toi32_i32$0 >>> i64toi32_i32$2 | 0;
  } else {
   i64toi32_i32$5 = i64toi32_i32$0 >>> i64toi32_i32$2 | 0;
   $67 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$2 | 0) | 0;
  }
  $77$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $75$hi;
  i64toi32_i32$0 = $75;
  i64toi32_i32$1 = $77$hi;
  i64toi32_i32$3 = $67;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $7 = i64toi32_i32$2;
  $7$hi = i64toi32_i32$4;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$0 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$0 = i64toi32_i32$4 & i64toi32_i32$0 | 0;
  i64toi32_i32$5 = $70;
  HEAP32[(i64toi32_i32$5 + 232 | 0) >> 2] = i64toi32_i32$2 & i64toi32_i32$3 | 0;
  HEAP32[(i64toi32_i32$5 + 236 | 0) >> 2] = i64toi32_i32$0;
  $81 = $2;
  i64toi32_i32$4 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 40 | 0) >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 44 | 0) >> 2] | 0;
  $83 = i64toi32_i32$0;
  $83$hi = i64toi32_i32$5;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 80 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 84 | 0) >> 2] | 0;
  $85 = i64toi32_i32$5;
  $85$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $83$hi;
  i64toi32_i32$4 = $83;
  i64toi32_i32$5 = $85$hi;
  i64toi32_i32$3 = $85;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $86 = i64toi32_i32$1;
  $86$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$0 = $7;
  i64toi32_i32$4 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$4 = 0;
   $68 = i64toi32_i32$2 >>> i64toi32_i32$5 | 0;
  } else {
   i64toi32_i32$4 = i64toi32_i32$2 >>> i64toi32_i32$5 | 0;
   $68 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$5 | 0) | 0;
  }
  $88$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $86$hi;
  i64toi32_i32$2 = $86;
  i64toi32_i32$0 = $88$hi;
  i64toi32_i32$3 = $68;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $7 = i64toi32_i32$5;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$2 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
  $91 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
  i64toi32_i32$4 = $81;
  HEAP32[(i64toi32_i32$4 + 240 | 0) >> 2] = $91;
  HEAP32[(i64toi32_i32$4 + 244 | 0) >> 2] = i64toi32_i32$2;
  $92 = $2;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$4 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$0 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$4 = 0;
   $71 = i64toi32_i32$2 >>> i64toi32_i32$0 | 0;
  } else {
   i64toi32_i32$4 = i64toi32_i32$2 >>> i64toi32_i32$0 | 0;
   $71 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$0 | 0) | 0;
  }
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_i64_mul($71 | 0, i64toi32_i32$4 | 0, 19 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $95 = i64toi32_i32$1;
  $95$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $6$hi;
  i64toi32_i32$2 = $6;
  i64toi32_i32$1 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$1 = i64toi32_i32$4 & i64toi32_i32$1 | 0;
  $97 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
  $97$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $95$hi;
  i64toi32_i32$4 = $95;
  i64toi32_i32$2 = $97$hi;
  i64toi32_i32$3 = $97;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  i64toi32_i32$4 = $92;
  HEAP32[(i64toi32_i32$4 + 208 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$4 + 212 | 0) >> 2] = i64toi32_i32$5;
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Sub___sub__h676cb1e5fa77fb70($2 + 248 | 0 | 0, $2 + 48 | 0 | 0, $2 + 8 | 0 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Sub___sub__h676cb1e5fa77fb70($0 | 0, $2 + 168 | 0 | 0, $2 + 208 | 0 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Sub___sub__h676cb1e5fa77fb70($0 + 120 | 0 | 0, $2 + 88 | 0 | 0, $2 + 248 | 0 | 0);
  memcpy($0 + 40 | 0 | 0, $2 + 208 | 0 | 0, 40 | 0) | 0;
  memcpy($0 + 80 | 0 | 0, $2 + 248 | 0 | 0, 40 | 0) | 0;
  global$0 = $2 + 288 | 0;
 }
 
 function cryptoxide__curve25519__ge__Ge__double_p1p1__h995b1d78634e10e5($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$3 = 0, $2 = 0, $7 = 0, $7$hi = 0, $4 = 0, $3 = 0, $5 = 0, $62 = 0, $65 = 0, $66 = 0, $67 = 0, $68 = 0, $71 = 0, $27 = 0, $43 = 0, $45 = 0, $45$hi = 0, $47 = 0, $47$hi = 0, $48 = 0, $48$hi = 0, $50 = 0, $50$hi = 0, $52 = 0, $52$hi = 0, $6 = 0, $6$hi = 0, $55$hi = 0, $58 = 0, $59 = 0, $61 = 0, $61$hi = 0, $63 = 0, $63$hi = 0, $64 = 0, $64$hi = 0, $66$hi = 0, $69 = 0, $70 = 0, $72 = 0, $72$hi = 0, $74 = 0, $74$hi = 0, $75 = 0, $75$hi = 0, $77$hi = 0, $81 = 0, $83 = 0, $83$hi = 0, $85 = 0, $85$hi = 0, $86 = 0, $86$hi = 0, $88$hi = 0, $91 = 0, $92 = 0, $95 = 0, $95$hi = 0, $97 = 0, $97$hi = 0;
  $2 = global$0 - 288 | 0;
  global$0 = $2;
  cryptoxide__curve25519__fe__fe64__Fe__square__h72fd8a55cd006328($2 + 8 | 0 | 0, $1 | 0);
  $3 = $1 + 40 | 0;
  cryptoxide__curve25519__fe__fe64__Fe__square__h72fd8a55cd006328($2 + 48 | 0 | 0, $3 | 0);
  cryptoxide__curve25519__fe__fe64__Fe__square__h72fd8a55cd006328($2 + 88 | 0 | 0, $1 + 80 | 0 | 0);
  $4 = 0;
  label$1 : while (1) {
   $5 = ($2 + 88 | 0) + $4 | 0;
   $27 = $5;
   i64toi32_i32$2 = $5;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   i64toi32_i32$2 = i64toi32_i32$0;
   i64toi32_i32$0 = 0;
   i64toi32_i32$3 = 1;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
    $62 = 0;
   } else {
    i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
    $62 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   }
   i64toi32_i32$2 = $27;
   HEAP32[i64toi32_i32$2 >> 2] = $62;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
   $4 = $4 + 8 | 0;
   if (($4 | 0) != (40 | 0)) {
    continue label$1
   }
   break label$1;
  };
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Add___add__he826ef0e90fce416($2 + 128 | 0 | 0, $1 | 0, $3 | 0);
  cryptoxide__curve25519__fe__fe64__Fe__square__h72fd8a55cd006328($2 + 168 | 0 | 0, $2 + 128 | 0 | 0);
  $43 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] | 0;
  $45 = i64toi32_i32$0;
  $45$hi = i64toi32_i32$2;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 56 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 60 | 0) >> 2] | 0;
  $47 = i64toi32_i32$2;
  $47$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $45$hi;
  i64toi32_i32$1 = $45;
  i64toi32_i32$2 = $47$hi;
  i64toi32_i32$3 = $47;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $48 = i64toi32_i32$4;
  $48$hi = i64toi32_i32$5;
  i64toi32_i32$0 = $2;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] | 0;
  $50 = i64toi32_i32$5;
  $50$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 48 | 0) >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 52 | 0) >> 2] | 0;
  $52 = i64toi32_i32$1;
  $52$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $50$hi;
  i64toi32_i32$0 = $50;
  i64toi32_i32$1 = $52$hi;
  i64toi32_i32$3 = $52;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $6 = i64toi32_i32$2;
  $6$hi = i64toi32_i32$4;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$1 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $65 = i64toi32_i32$4 >>> i64toi32_i32$1 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$4 >>> i64toi32_i32$1 | 0;
   $65 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$1 | 0) | 0;
  }
  $55$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $48$hi;
  i64toi32_i32$4 = $48;
  i64toi32_i32$5 = $55$hi;
  i64toi32_i32$3 = $65;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $7 = i64toi32_i32$1;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$4 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$4 = i64toi32_i32$2 & i64toi32_i32$4 | 0;
  $58 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $43;
  HEAP32[(i64toi32_i32$0 + 216 | 0) >> 2] = $58;
  HEAP32[(i64toi32_i32$0 + 220 | 0) >> 2] = i64toi32_i32$4;
  $59 = $2;
  i64toi32_i32$2 = $2;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $61 = i64toi32_i32$4;
  $61$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
  $63 = i64toi32_i32$0;
  $63$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $61$hi;
  i64toi32_i32$2 = $61;
  i64toi32_i32$0 = $63$hi;
  i64toi32_i32$3 = $63;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $64 = i64toi32_i32$5;
  $64$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$4 = $7;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$0 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $66 = i64toi32_i32$1 >>> i64toi32_i32$0 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$0 | 0;
   $66 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$0 | 0) | 0;
  }
  $66$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $64$hi;
  i64toi32_i32$1 = $64;
  i64toi32_i32$4 = $66$hi;
  i64toi32_i32$3 = $66;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$5;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$1 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$1 = i64toi32_i32$5 & i64toi32_i32$1 | 0;
  $69 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $59;
  HEAP32[(i64toi32_i32$2 + 224 | 0) >> 2] = $69;
  HEAP32[(i64toi32_i32$2 + 228 | 0) >> 2] = i64toi32_i32$1;
  $70 = $2;
  i64toi32_i32$5 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 32 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 36 | 0) >> 2] | 0;
  $72 = i64toi32_i32$1;
  $72$hi = i64toi32_i32$2;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 72 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 76 | 0) >> 2] | 0;
  $74 = i64toi32_i32$2;
  $74$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $72$hi;
  i64toi32_i32$5 = $72;
  i64toi32_i32$2 = $74$hi;
  i64toi32_i32$3 = $74;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $75 = i64toi32_i32$4;
  $75$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$1 = $7;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$2 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$5 = 0;
   $67 = i64toi32_i32$0 >>> i64toi32_i32$2 | 0;
  } else {
   i64toi32_i32$5 = i64toi32_i32$0 >>> i64toi32_i32$2 | 0;
   $67 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$2 | 0) | 0;
  }
  $77$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $75$hi;
  i64toi32_i32$0 = $75;
  i64toi32_i32$1 = $77$hi;
  i64toi32_i32$3 = $67;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $7 = i64toi32_i32$2;
  $7$hi = i64toi32_i32$4;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$0 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$0 = i64toi32_i32$4 & i64toi32_i32$0 | 0;
  i64toi32_i32$5 = $70;
  HEAP32[(i64toi32_i32$5 + 232 | 0) >> 2] = i64toi32_i32$2 & i64toi32_i32$3 | 0;
  HEAP32[(i64toi32_i32$5 + 236 | 0) >> 2] = i64toi32_i32$0;
  $81 = $2;
  i64toi32_i32$4 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 40 | 0) >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 44 | 0) >> 2] | 0;
  $83 = i64toi32_i32$0;
  $83$hi = i64toi32_i32$5;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 80 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 84 | 0) >> 2] | 0;
  $85 = i64toi32_i32$5;
  $85$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $83$hi;
  i64toi32_i32$4 = $83;
  i64toi32_i32$5 = $85$hi;
  i64toi32_i32$3 = $85;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $86 = i64toi32_i32$1;
  $86$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$0 = $7;
  i64toi32_i32$4 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$4 = 0;
   $68 = i64toi32_i32$2 >>> i64toi32_i32$5 | 0;
  } else {
   i64toi32_i32$4 = i64toi32_i32$2 >>> i64toi32_i32$5 | 0;
   $68 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$5 | 0) | 0;
  }
  $88$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $86$hi;
  i64toi32_i32$2 = $86;
  i64toi32_i32$0 = $88$hi;
  i64toi32_i32$3 = $68;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $7 = i64toi32_i32$5;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$2 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
  $91 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
  i64toi32_i32$4 = $81;
  HEAP32[(i64toi32_i32$4 + 240 | 0) >> 2] = $91;
  HEAP32[(i64toi32_i32$4 + 244 | 0) >> 2] = i64toi32_i32$2;
  $92 = $2;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$4 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$0 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$4 = 0;
   $71 = i64toi32_i32$2 >>> i64toi32_i32$0 | 0;
  } else {
   i64toi32_i32$4 = i64toi32_i32$2 >>> i64toi32_i32$0 | 0;
   $71 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$0 | 0) | 0;
  }
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_i64_mul($71 | 0, i64toi32_i32$4 | 0, 19 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $95 = i64toi32_i32$1;
  $95$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $6$hi;
  i64toi32_i32$2 = $6;
  i64toi32_i32$1 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$1 = i64toi32_i32$4 & i64toi32_i32$1 | 0;
  $97 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
  $97$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $95$hi;
  i64toi32_i32$4 = $95;
  i64toi32_i32$2 = $97$hi;
  i64toi32_i32$3 = $97;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  i64toi32_i32$4 = $92;
  HEAP32[(i64toi32_i32$4 + 208 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$4 + 212 | 0) >> 2] = i64toi32_i32$5;
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Sub___sub__h676cb1e5fa77fb70($2 + 248 | 0 | 0, $2 + 48 | 0 | 0, $2 + 8 | 0 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Sub___sub__h676cb1e5fa77fb70($0 | 0, $2 + 168 | 0 | 0, $2 + 208 | 0 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Sub___sub__h676cb1e5fa77fb70($0 + 120 | 0 | 0, $2 + 88 | 0 | 0, $2 + 248 | 0 | 0);
  memcpy($0 + 40 | 0 | 0, $2 + 208 | 0 | 0, 40 | 0) | 0;
  memcpy($0 + 80 | 0 | 0, $2 + 248 | 0 | 0, 40 | 0) | 0;
  global$0 = $2 + 288 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__h3e94917fd4a0d3ab($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $7 = 0, $3 = 0, $4 = 0, $6 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $5 = 0, $36 = 0, $41 = 0, $45 = 0, $59 = 0, $93 = 0, $98 = 0, $103 = 0, $111 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = HEAPU16[($4 + 138 | 0) >> 1] | 0;
  $1 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $6 = $5 + ($1 ^ -1 | 0) | 0;
  HEAP16[($2 + 138 | 0) >> 1] = $6;
  $7 = $4 + Math_imul($1, 28) | 0;
  $19 = $7 + 164 | 0;
  HEAP32[($3 + 24 | 0) >> 2] = HEAPU8[$19 >> 0] | 0 | ((HEAPU8[($19 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($19 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($19 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $7 + 156 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $36 = i64toi32_i32$0;
  i64toi32_i32$0 = $3 + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $36;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $7 + 148 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $41 = i64toi32_i32$1;
  i64toi32_i32$1 = $3 + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $41;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $7 + 140 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $45 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $45;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $7 = $4 + Math_imul($1, 12) | 0;
  HEAP32[((i64toi32_i32$0 + 32 | 0) + 8 | 0) >> 2] = HEAP32[($7 + 12 | 0) >> 2] | 0;
  i64toi32_i32$2 = $7 + 4 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $59 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[(i64toi32_i32$1 + 32 | 0) >> 2] = $59;
  HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    if ($6 >>> 0 >= 12 >>> 0) {
     break label$2
    }
    $7 = $1 + 1 | 0;
    if (($5 - $7 | 0 | 0) != ($6 | 0)) {
     break label$1
    }
    memcpy($2 + 140 | 0 | 0, ($4 + Math_imul($7, 28) | 0) + 140 | 0 | 0, Math_imul($6, 28) | 0) | 0;
    memcpy($2 + 4 | 0 | 0, ($4 + Math_imul($7, 12) | 0) + 4 | 0 | 0, Math_imul($6, 12) | 0) | 0;
    HEAP16[($4 + 138 | 0) >> 1] = $1;
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $93 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    $20 = $93;
    HEAP8[i64toi32_i32$0 >> 0] = $20;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $20 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $20 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $20 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $98 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 8 | 0;
    $21 = $98;
    HEAP8[i64toi32_i32$1 >> 0] = $21;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $21 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $21 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $21 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$2 = $3 + 16 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $103 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 16 | 0;
    $22 = $103;
    HEAP8[i64toi32_i32$0 >> 0] = $22;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $22 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $22 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $22 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    $23 = $0 + 24 | 0;
    $24 = HEAP32[($3 + 24 | 0) >> 2] | 0;
    HEAP8[$23 >> 0] = $24;
    HEAP8[($23 + 1 | 0) >> 0] = $24 >>> 8 | 0;
    HEAP8[($23 + 2 | 0) >> 0] = $24 >>> 16 | 0;
    HEAP8[($23 + 3 | 0) >> 0] = $24 >>> 24 | 0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
    $111 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = $111;
    HEAP32[(i64toi32_i32$1 + 32 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] = HEAP32[((i64toi32_i32$2 + 32 | 0) + 8 | 0) >> 2] | 0;
    global$0 = i64toi32_i32$2 + 48 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($6 | 0, 11 | 0, 1049044 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1048988 | 0, 40 | 0, 1049028 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__h94ef26d698df746a($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $7 = 0, $3 = 0, $4 = 0, $6 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $5 = 0, $36 = 0, $41 = 0, $45 = 0, $59 = 0, $93 = 0, $98 = 0, $103 = 0, $111 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = HEAPU16[($4 + 138 | 0) >> 1] | 0;
  $1 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $6 = $5 + ($1 ^ -1 | 0) | 0;
  HEAP16[($2 + 138 | 0) >> 1] = $6;
  $7 = $4 + Math_imul($1, 28) | 0;
  $19 = $7 + 164 | 0;
  HEAP32[($3 + 24 | 0) >> 2] = HEAPU8[$19 >> 0] | 0 | ((HEAPU8[($19 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($19 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($19 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $7 + 156 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $36 = i64toi32_i32$0;
  i64toi32_i32$0 = $3 + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $36;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $7 + 148 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $41 = i64toi32_i32$1;
  i64toi32_i32$1 = $3 + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $41;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $7 + 140 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $45 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $45;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $7 = $4 + Math_imul($1, 12) | 0;
  HEAP32[((i64toi32_i32$0 + 32 | 0) + 8 | 0) >> 2] = HEAP32[($7 + 12 | 0) >> 2] | 0;
  i64toi32_i32$2 = $7 + 4 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $59 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[(i64toi32_i32$1 + 32 | 0) >> 2] = $59;
  HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    if ($6 >>> 0 >= 12 >>> 0) {
     break label$2
    }
    $7 = $1 + 1 | 0;
    if (($5 - $7 | 0 | 0) != ($6 | 0)) {
     break label$1
    }
    memcpy($2 + 140 | 0 | 0, ($4 + Math_imul($7, 28) | 0) + 140 | 0 | 0, Math_imul($6, 28) | 0) | 0;
    memcpy($2 + 4 | 0 | 0, ($4 + Math_imul($7, 12) | 0) + 4 | 0 | 0, Math_imul($6, 12) | 0) | 0;
    HEAP16[($4 + 138 | 0) >> 1] = $1;
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $93 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    $20 = $93;
    HEAP8[i64toi32_i32$0 >> 0] = $20;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $20 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $20 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $20 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $98 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 8 | 0;
    $21 = $98;
    HEAP8[i64toi32_i32$1 >> 0] = $21;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $21 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $21 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $21 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$2 = $3 + 16 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $103 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 16 | 0;
    $22 = $103;
    HEAP8[i64toi32_i32$0 >> 0] = $22;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $22 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $22 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $22 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    $23 = $0 + 24 | 0;
    $24 = HEAP32[($3 + 24 | 0) >> 2] | 0;
    HEAP8[$23 >> 0] = $24;
    HEAP8[($23 + 1 | 0) >> 0] = $24 >>> 8 | 0;
    HEAP8[($23 + 2 | 0) >> 0] = $24 >>> 16 | 0;
    HEAP8[($23 + 3 | 0) >> 0] = $24 >>> 24 | 0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
    $111 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = $111;
    HEAP32[(i64toi32_i32$1 + 32 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] = HEAP32[((i64toi32_i32$2 + 32 | 0) + 8 | 0) >> 2] | 0;
    global$0 = i64toi32_i32$2 + 48 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($6 | 0, 11 | 0, 1049044 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1048988 | 0, 40 | 0, 1049028 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__hbe6afb4723f1cfdb($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $7 = 0, $3 = 0, $4 = 0, $6 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $5 = 0, $36 = 0, $41 = 0, $45 = 0, $59 = 0, $93 = 0, $98 = 0, $103 = 0, $111 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = HEAPU16[($4 + 138 | 0) >> 1] | 0;
  $1 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $6 = $5 + ($1 ^ -1 | 0) | 0;
  HEAP16[($2 + 138 | 0) >> 1] = $6;
  $7 = $4 + Math_imul($1, 28) | 0;
  $19 = $7 + 164 | 0;
  HEAP32[($3 + 24 | 0) >> 2] = HEAPU8[$19 >> 0] | 0 | ((HEAPU8[($19 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($19 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($19 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $7 + 156 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $36 = i64toi32_i32$0;
  i64toi32_i32$0 = $3 + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $36;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $7 + 148 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $41 = i64toi32_i32$1;
  i64toi32_i32$1 = $3 + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $41;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $7 + 140 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $45 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $45;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $7 = $4 + Math_imul($1, 12) | 0;
  HEAP32[((i64toi32_i32$0 + 32 | 0) + 8 | 0) >> 2] = HEAP32[($7 + 12 | 0) >> 2] | 0;
  i64toi32_i32$2 = $7 + 4 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $59 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[(i64toi32_i32$1 + 32 | 0) >> 2] = $59;
  HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    if ($6 >>> 0 >= 12 >>> 0) {
     break label$2
    }
    $7 = $1 + 1 | 0;
    if (($5 - $7 | 0 | 0) != ($6 | 0)) {
     break label$1
    }
    memcpy($2 + 140 | 0 | 0, ($4 + Math_imul($7, 28) | 0) + 140 | 0 | 0, Math_imul($6, 28) | 0) | 0;
    memcpy($2 + 4 | 0 | 0, ($4 + Math_imul($7, 12) | 0) + 4 | 0 | 0, Math_imul($6, 12) | 0) | 0;
    HEAP16[($4 + 138 | 0) >> 1] = $1;
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $93 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    $20 = $93;
    HEAP8[i64toi32_i32$0 >> 0] = $20;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $20 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $20 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $20 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $98 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 8 | 0;
    $21 = $98;
    HEAP8[i64toi32_i32$1 >> 0] = $21;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $21 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $21 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $21 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$2 = $3 + 16 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $103 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 16 | 0;
    $22 = $103;
    HEAP8[i64toi32_i32$0 >> 0] = $22;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $22 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $22 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $22 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    $23 = $0 + 24 | 0;
    $24 = HEAP32[($3 + 24 | 0) >> 2] | 0;
    HEAP8[$23 >> 0] = $24;
    HEAP8[($23 + 1 | 0) >> 0] = $24 >>> 8 | 0;
    HEAP8[($23 + 2 | 0) >> 0] = $24 >>> 16 | 0;
    HEAP8[($23 + 3 | 0) >> 0] = $24 >>> 24 | 0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
    $111 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = $111;
    HEAP32[(i64toi32_i32$1 + 32 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] = HEAP32[((i64toi32_i32$2 + 32 | 0) + 8 | 0) >> 2] | 0;
    global$0 = i64toi32_i32$2 + 48 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($6 | 0, 11 | 0, 1049044 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1048988 | 0, 40 | 0, 1049028 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__hf867250b9f689ec3($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $7 = 0, $3 = 0, $4 = 0, $6 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $5 = 0, $36 = 0, $41 = 0, $45 = 0, $59 = 0, $93 = 0, $98 = 0, $103 = 0, $111 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = HEAPU16[($4 + 138 | 0) >> 1] | 0;
  $1 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $6 = $5 + ($1 ^ -1 | 0) | 0;
  HEAP16[($2 + 138 | 0) >> 1] = $6;
  $7 = $4 + Math_imul($1, 28) | 0;
  $19 = $7 + 164 | 0;
  HEAP32[($3 + 24 | 0) >> 2] = HEAPU8[$19 >> 0] | 0 | ((HEAPU8[($19 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($19 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($19 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $7 + 156 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $36 = i64toi32_i32$0;
  i64toi32_i32$0 = $3 + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $36;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $7 + 148 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $41 = i64toi32_i32$1;
  i64toi32_i32$1 = $3 + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $41;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $7 + 140 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $45 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $45;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $7 = $4 + Math_imul($1, 12) | 0;
  HEAP32[((i64toi32_i32$0 + 32 | 0) + 8 | 0) >> 2] = HEAP32[($7 + 12 | 0) >> 2] | 0;
  i64toi32_i32$2 = $7 + 4 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $59 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[(i64toi32_i32$1 + 32 | 0) >> 2] = $59;
  HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    if ($6 >>> 0 >= 12 >>> 0) {
     break label$2
    }
    $7 = $1 + 1 | 0;
    if (($5 - $7 | 0 | 0) != ($6 | 0)) {
     break label$1
    }
    memcpy($2 + 140 | 0 | 0, ($4 + Math_imul($7, 28) | 0) + 140 | 0 | 0, Math_imul($6, 28) | 0) | 0;
    memcpy($2 + 4 | 0 | 0, ($4 + Math_imul($7, 12) | 0) + 4 | 0 | 0, Math_imul($6, 12) | 0) | 0;
    HEAP16[($4 + 138 | 0) >> 1] = $1;
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $93 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    $20 = $93;
    HEAP8[i64toi32_i32$0 >> 0] = $20;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $20 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $20 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $20 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $98 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 8 | 0;
    $21 = $98;
    HEAP8[i64toi32_i32$1 >> 0] = $21;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $21 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $21 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $21 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$2 = $3 + 16 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $103 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 16 | 0;
    $22 = $103;
    HEAP8[i64toi32_i32$0 >> 0] = $22;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $22 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $22 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $22 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    $23 = $0 + 24 | 0;
    $24 = HEAP32[($3 + 24 | 0) >> 2] | 0;
    HEAP8[$23 >> 0] = $24;
    HEAP8[($23 + 1 | 0) >> 0] = $24 >>> 8 | 0;
    HEAP8[($23 + 2 | 0) >> 0] = $24 >>> 16 | 0;
    HEAP8[($23 + 3 | 0) >> 0] = $24 >>> 24 | 0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
    $111 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = $111;
    HEAP32[(i64toi32_i32$1 + 32 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] = HEAP32[((i64toi32_i32$2 + 32 | 0) + 8 | 0) >> 2] | 0;
    global$0 = i64toi32_i32$2 + 48 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($6 | 0, 11 | 0, 1049044 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1048988 | 0, 40 | 0, 1049028 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert_fit__h22bde63da6884187($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $6 = 0, $5 = 0, $7 = 0, $8 = 0, $9 = 0, $10 = 0;
  $5 = global$0 - 48 | 0;
  global$0 = $5;
  $6 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  $7 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $0 = HEAPU16[($7 + 1062 | 0) >> 1] | 0;
  $5 = memcpy($5 | 0, $1 | 0, 48 | 0) | 0;
  label$1 : {
   $1 = $6 + 1 | 0;
   $8 = $1 >>> 0 > $0 >>> 0;
   if ($8) {
    break label$1
   }
   memmove($7 + Math_imul($1, 48) | 0 | 0, $7 + Math_imul($6, 48) | 0 | 0, Math_imul($0 - $6 | 0, 48) | 0) | 0;
  }
  memcpy($7 + Math_imul($6, 48) | 0 | 0, $5 | 0, 48 | 0) | 0;
  $2 = memcpy($5 | 0, $2 | 0, 48 | 0) | 0;
  label$2 : {
   if ($8) {
    break label$2
   }
   $5 = $7 + 528 | 0;
   memmove($5 + Math_imul($1, 48) | 0 | 0, $5 + Math_imul($6, 48) | 0 | 0, Math_imul($0 - $6 | 0, 48) | 0) | 0;
  }
  $5 = $0 + 1 | 0;
  memcpy(($7 + Math_imul($6, 48) | 0) + 528 | 0 | 0, $2 | 0, 48 | 0) | 0;
  label$3 : {
   $9 = $6 + 2 | 0;
   $8 = $0 + 2 | 0;
   if ($9 >>> 0 >= $8 >>> 0) {
    break label$3
   }
   $10 = $7 + 1064 | 0;
   memmove($10 + ($9 << 2 | 0) | 0 | 0, $10 + ($1 << 2 | 0) | 0 | 0, ($0 - $6 | 0) << 2 | 0 | 0) | 0;
  }
  HEAP32[(($7 + ($1 << 2 | 0) | 0) + 1064 | 0) >> 2] = $4;
  HEAP16[($7 + 1062 | 0) >> 1] = $5;
  label$4 : {
   if ($1 >>> 0 >= $8 >>> 0) {
    break label$4
   }
   $5 = $0 + 1 | 0;
   $0 = (($6 << 2 | 0) + $7 | 0) + 1068 | 0;
   label$5 : while (1) {
    $1 = HEAP32[$0 >> 2] | 0;
    $6 = $6 + 1 | 0;
    HEAP16[($1 + 1060 | 0) >> 1] = $6;
    HEAP32[($1 + 1056 | 0) >> 2] = $7;
    $0 = $0 + 4 | 0;
    if (($5 | 0) != ($6 | 0)) {
     continue label$5
    }
    break label$5;
   };
  }
  global$0 = $2 + 48 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert_fit__hb02d547895893d1c($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $6 = 0, $7 = 0, $5 = 0, $8 = 0, $9 = 0, $10 = 0;
  $5 = global$0 - 96 | 0;
  global$0 = $5;
  $6 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  $7 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $0 = HEAPU16[($7 + 1458 | 0) >> 1] | 0;
  $5 = memcpy($5 | 0, $1 | 0, 36 | 0) | 0;
  label$1 : {
   $1 = $6 + 1 | 0;
   $8 = $1 >>> 0 > $0 >>> 0;
   if ($8) {
    break label$1
   }
   $9 = $7 + 1060 | 0;
   memmove($9 + Math_imul($1, 36) | 0 | 0, $9 + Math_imul($6, 36) | 0 | 0, Math_imul($0 - $6 | 0, 36) | 0) | 0;
  }
  memcpy(($7 + Math_imul($6, 36) | 0) + 1060 | 0 | 0, $5 | 0, 36 | 0) | 0;
  $2 = memcpy($5 | 0, $2 | 0, 96 | 0) | 0;
  label$2 : {
   if ($8) {
    break label$2
   }
   memmove($7 + Math_imul($1, 96) | 0 | 0, $7 + Math_imul($6, 96) | 0 | 0, Math_imul($0 - $6 | 0, 96) | 0) | 0;
  }
  $5 = $0 + 1 | 0;
  memcpy($7 + Math_imul($6, 96) | 0 | 0, $2 | 0, 96 | 0) | 0;
  label$3 : {
   $9 = $6 + 2 | 0;
   $8 = $0 + 2 | 0;
   if ($9 >>> 0 >= $8 >>> 0) {
    break label$3
   }
   $10 = $7 + 1464 | 0;
   memmove($10 + ($9 << 2 | 0) | 0 | 0, $10 + ($1 << 2 | 0) | 0 | 0, ($0 - $6 | 0) << 2 | 0 | 0) | 0;
  }
  HEAP32[(($7 + ($1 << 2 | 0) | 0) + 1464 | 0) >> 2] = $4;
  HEAP16[($7 + 1458 | 0) >> 1] = $5;
  label$4 : {
   if ($1 >>> 0 >= $8 >>> 0) {
    break label$4
   }
   $5 = $0 + 1 | 0;
   $0 = (($6 << 2 | 0) + $7 | 0) + 1468 | 0;
   label$5 : while (1) {
    $1 = HEAP32[$0 >> 2] | 0;
    $6 = $6 + 1 | 0;
    HEAP16[($1 + 1456 | 0) >> 1] = $6;
    HEAP32[($1 + 1056 | 0) >> 2] = $7;
    $0 = $0 + 4 | 0;
    if (($5 | 0) != ($6 | 0)) {
     continue label$5
    }
    break label$5;
   };
  }
  global$0 = $2 + 96 | 0;
 }
 
 function cardano_serialization_lib__crypto__Ed25519KeyHash__from_bytes__hd3490b826cff55ec($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $3 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $4 = 0, $5 = 0, $5$hi = 0, $6 = 0, $6$hi = 0, $7 = 0, $7$hi = 0;
  $2 = global$0 - 224 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     if (($3 | 0) != (28 | 0)) {
      break label$3
     }
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $1 | 0);
     $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
     if ($3 >>> 0 <= 27 >>> 0) {
      break label$1
     }
     $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
     $14 = $3 + 24 | 0;
     $4 = HEAPU8[$14 >> 0] | 0 | ((HEAPU8[($14 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($14 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($14 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$2 = $3 + 16 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $5 = i64toi32_i32$0;
     $5$hi = i64toi32_i32$1;
     i64toi32_i32$2 = $3;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $6 = i64toi32_i32$1;
     $6$hi = i64toi32_i32$0;
     i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $7 = i64toi32_i32$0;
     $7$hi = i64toi32_i32$1;
     i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $7;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $5$hi;
     i64toi32_i32$0 = ($2 + 16 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $5;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[(($2 + 16 | 0) + 24 | 0) >> 2] = $4;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$0 = $2;
     HEAP32[($2 + 16 | 0) >> 2] = $6;
     HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$1;
     $15 = $0 + 25 | 0;
     $16 = $4;
     HEAP8[$15 >> 0] = $16;
     HEAP8[($15 + 1 | 0) >> 0] = $16 >>> 8 | 0;
     HEAP8[($15 + 2 | 0) >> 0] = $16 >>> 16 | 0;
     HEAP8[($15 + 3 | 0) >> 0] = $16 >>> 24 | 0;
     i64toi32_i32$1 = $5$hi;
     i64toi32_i32$0 = $0 + 17 | 0;
     $17 = $5;
     HEAP8[i64toi32_i32$0 >> 0] = $17;
     HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $17 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $17 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $17 >>> 24 | 0;
     HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
     HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$0 = $0 + 9 | 0;
     $18 = $7;
     HEAP8[i64toi32_i32$0 >> 0] = $18;
     HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $18 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $18 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $18 >>> 24 | 0;
     HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
     HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$0 = $0;
     $19 = $6;
     HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $19;
     HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $19 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $19 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = $19 >>> 24 | 0;
     HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1;
     HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 8 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
     HEAP8[i64toi32_i32$0 >> 0] = 0;
     break label$2;
    }
    alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($2 + 208 | 0 | 0, 1066780 | 0, 14 | 0);
    i64toi32_i32$1 = 0;
    i64toi32_i32$0 = $2 + 200 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $3;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$0 = $2 + 192 | 0;
    i64toi32_i32$1 = 0;
    HEAP32[i64toi32_i32$0 >> 2] = 1;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$0 = $2 + 184 | 0;
    i64toi32_i32$1 = 0;
    HEAP32[i64toi32_i32$0 >> 2] = 28;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($2 + 176 | 0) >> 2] = 11;
    HEAP32[($2 + 172 | 0) >> 2] = 1066390;
    HEAP8[($2 + 168 | 0) >> 0] = 13;
    HEAP8[($2 + 160 | 0) >> 0] = 2;
    memcpy($2 + 88 | 0 | 0, memcpy(($2 + 16 | 0) + 7 | 0 | 0, memcpy(($2 + 88 | 0) + 7 | 0 | 0, $2 + 160 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
    $3 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 88 | 0 | 0) | 0;
    HEAP8[$0 >> 0] = 1;
    HEAP32[($0 + 4 | 0) >> 2] = $3;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
   global$0 = $2 + 224 | 0;
   return;
  }
  core__slice__index__slice_end_index_len_fail__h192505a15ac4b345(28 | 0, $3 | 0, 1066764 | 0);
  abort();
 }
 
 function cardano_serialization_lib__crypto__ScriptHash__from_bytes__heb261e3c2077a8e6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $3 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $4 = 0, $5 = 0, $5$hi = 0, $6 = 0, $6$hi = 0, $7 = 0, $7$hi = 0;
  $2 = global$0 - 224 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     if (($3 | 0) != (28 | 0)) {
      break label$3
     }
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $1 | 0);
     $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
     if ($3 >>> 0 <= 27 >>> 0) {
      break label$1
     }
     $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
     $14 = $3 + 24 | 0;
     $4 = HEAPU8[$14 >> 0] | 0 | ((HEAPU8[($14 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($14 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($14 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$2 = $3 + 16 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $5 = i64toi32_i32$0;
     $5$hi = i64toi32_i32$1;
     i64toi32_i32$2 = $3;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $6 = i64toi32_i32$1;
     $6$hi = i64toi32_i32$0;
     i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $7 = i64toi32_i32$0;
     $7$hi = i64toi32_i32$1;
     i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $7;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $5$hi;
     i64toi32_i32$0 = ($2 + 16 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $5;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[(($2 + 16 | 0) + 24 | 0) >> 2] = $4;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$0 = $2;
     HEAP32[($2 + 16 | 0) >> 2] = $6;
     HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$1;
     $15 = $0 + 25 | 0;
     $16 = $4;
     HEAP8[$15 >> 0] = $16;
     HEAP8[($15 + 1 | 0) >> 0] = $16 >>> 8 | 0;
     HEAP8[($15 + 2 | 0) >> 0] = $16 >>> 16 | 0;
     HEAP8[($15 + 3 | 0) >> 0] = $16 >>> 24 | 0;
     i64toi32_i32$1 = $5$hi;
     i64toi32_i32$0 = $0 + 17 | 0;
     $17 = $5;
     HEAP8[i64toi32_i32$0 >> 0] = $17;
     HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $17 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $17 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $17 >>> 24 | 0;
     HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
     HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$0 = $0 + 9 | 0;
     $18 = $7;
     HEAP8[i64toi32_i32$0 >> 0] = $18;
     HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $18 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $18 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $18 >>> 24 | 0;
     HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
     HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$0 = $0;
     $19 = $6;
     HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $19;
     HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $19 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $19 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = $19 >>> 24 | 0;
     HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1;
     HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 8 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
     HEAP8[i64toi32_i32$0 >> 0] = 0;
     break label$2;
    }
    alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($2 + 208 | 0 | 0, 1066812 | 0, 10 | 0);
    i64toi32_i32$1 = 0;
    i64toi32_i32$0 = $2 + 200 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $3;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$0 = $2 + 192 | 0;
    i64toi32_i32$1 = 0;
    HEAP32[i64toi32_i32$0 >> 2] = 1;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$0 = $2 + 184 | 0;
    i64toi32_i32$1 = 0;
    HEAP32[i64toi32_i32$0 >> 2] = 28;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($2 + 176 | 0) >> 2] = 11;
    HEAP32[($2 + 172 | 0) >> 2] = 1066390;
    HEAP8[($2 + 168 | 0) >> 0] = 13;
    HEAP8[($2 + 160 | 0) >> 0] = 2;
    memcpy($2 + 88 | 0 | 0, memcpy(($2 + 16 | 0) + 7 | 0 | 0, memcpy(($2 + 88 | 0) + 7 | 0 | 0, $2 + 160 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
    $3 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 88 | 0 | 0) | 0;
    HEAP8[$0 >> 0] = 1;
    HEAP32[($0 + 4 | 0) >> 2] = $3;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
   global$0 = $2 + 224 | 0;
   return;
  }
  core__slice__index__slice_end_index_len_fail__h192505a15ac4b345(28 | 0, $3 | 0, 1066796 | 0);
  abort();
 }
 
 function cardano_serialization_lib__crypto__GenesisDelegateHash__from_bytes__hc6d86e4470d3551a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $3 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $4 = 0, $5 = 0, $5$hi = 0, $6 = 0, $6$hi = 0, $7 = 0, $7$hi = 0;
  $2 = global$0 - 224 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     if (($3 | 0) != (28 | 0)) {
      break label$3
     }
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $1 | 0);
     $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
     if ($3 >>> 0 <= 27 >>> 0) {
      break label$1
     }
     $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
     $14 = $3 + 24 | 0;
     $4 = HEAPU8[$14 >> 0] | 0 | ((HEAPU8[($14 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($14 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($14 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$2 = $3 + 16 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $5 = i64toi32_i32$0;
     $5$hi = i64toi32_i32$1;
     i64toi32_i32$2 = $3;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $6 = i64toi32_i32$1;
     $6$hi = i64toi32_i32$0;
     i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $7 = i64toi32_i32$0;
     $7$hi = i64toi32_i32$1;
     i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $7;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $5$hi;
     i64toi32_i32$0 = ($2 + 16 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $5;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[(($2 + 16 | 0) + 24 | 0) >> 2] = $4;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$0 = $2;
     HEAP32[($2 + 16 | 0) >> 2] = $6;
     HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$1;
     $15 = $0 + 25 | 0;
     $16 = $4;
     HEAP8[$15 >> 0] = $16;
     HEAP8[($15 + 1 | 0) >> 0] = $16 >>> 8 | 0;
     HEAP8[($15 + 2 | 0) >> 0] = $16 >>> 16 | 0;
     HEAP8[($15 + 3 | 0) >> 0] = $16 >>> 24 | 0;
     i64toi32_i32$1 = $5$hi;
     i64toi32_i32$0 = $0 + 17 | 0;
     $17 = $5;
     HEAP8[i64toi32_i32$0 >> 0] = $17;
     HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $17 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $17 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $17 >>> 24 | 0;
     HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
     HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$0 = $0 + 9 | 0;
     $18 = $7;
     HEAP8[i64toi32_i32$0 >> 0] = $18;
     HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $18 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $18 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $18 >>> 24 | 0;
     HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
     HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$0 = $0;
     $19 = $6;
     HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $19;
     HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $19 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $19 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = $19 >>> 24 | 0;
     HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1;
     HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 8 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
     HEAP8[i64toi32_i32$0 >> 0] = 0;
     break label$2;
    }
    alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($2 + 208 | 0 | 0, 1066872 | 0, 19 | 0);
    i64toi32_i32$1 = 0;
    i64toi32_i32$0 = $2 + 200 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $3;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$0 = $2 + 192 | 0;
    i64toi32_i32$1 = 0;
    HEAP32[i64toi32_i32$0 >> 2] = 1;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$0 = $2 + 184 | 0;
    i64toi32_i32$1 = 0;
    HEAP32[i64toi32_i32$0 >> 2] = 28;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($2 + 176 | 0) >> 2] = 11;
    HEAP32[($2 + 172 | 0) >> 2] = 1066390;
    HEAP8[($2 + 168 | 0) >> 0] = 13;
    HEAP8[($2 + 160 | 0) >> 0] = 2;
    memcpy($2 + 88 | 0 | 0, memcpy(($2 + 16 | 0) + 7 | 0 | 0, memcpy(($2 + 88 | 0) + 7 | 0 | 0, $2 + 160 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
    $3 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 88 | 0 | 0) | 0;
    HEAP8[$0 >> 0] = 1;
    HEAP32[($0 + 4 | 0) >> 2] = $3;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
   global$0 = $2 + 224 | 0;
   return;
  }
  core__slice__index__slice_end_index_len_fail__h192505a15ac4b345(28 | 0, $3 | 0, 1066856 | 0);
  abort();
 }
 
 function cardano_serialization_lib__crypto__GenesisHash__from_bytes__he8377b8a376c1d46($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $3 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $4 = 0, $5 = 0, $5$hi = 0, $6 = 0, $6$hi = 0, $7 = 0, $7$hi = 0;
  $2 = global$0 - 224 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     if (($3 | 0) != (28 | 0)) {
      break label$3
     }
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $1 | 0);
     $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
     if ($3 >>> 0 <= 27 >>> 0) {
      break label$1
     }
     $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
     $14 = $3 + 24 | 0;
     $4 = HEAPU8[$14 >> 0] | 0 | ((HEAPU8[($14 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($14 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($14 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$2 = $3 + 16 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $5 = i64toi32_i32$0;
     $5$hi = i64toi32_i32$1;
     i64toi32_i32$2 = $3;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $6 = i64toi32_i32$1;
     $6$hi = i64toi32_i32$0;
     i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $7 = i64toi32_i32$0;
     $7$hi = i64toi32_i32$1;
     i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $7;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $5$hi;
     i64toi32_i32$0 = ($2 + 16 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $5;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[(($2 + 16 | 0) + 24 | 0) >> 2] = $4;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$0 = $2;
     HEAP32[($2 + 16 | 0) >> 2] = $6;
     HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$1;
     $15 = $0 + 25 | 0;
     $16 = $4;
     HEAP8[$15 >> 0] = $16;
     HEAP8[($15 + 1 | 0) >> 0] = $16 >>> 8 | 0;
     HEAP8[($15 + 2 | 0) >> 0] = $16 >>> 16 | 0;
     HEAP8[($15 + 3 | 0) >> 0] = $16 >>> 24 | 0;
     i64toi32_i32$1 = $5$hi;
     i64toi32_i32$0 = $0 + 17 | 0;
     $17 = $5;
     HEAP8[i64toi32_i32$0 >> 0] = $17;
     HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $17 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $17 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $17 >>> 24 | 0;
     HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
     HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$0 = $0 + 9 | 0;
     $18 = $7;
     HEAP8[i64toi32_i32$0 >> 0] = $18;
     HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $18 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $18 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $18 >>> 24 | 0;
     HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
     HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$0 = $0;
     $19 = $6;
     HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $19;
     HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $19 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $19 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = $19 >>> 24 | 0;
     HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1;
     HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 8 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
     HEAP8[i64toi32_i32$0 >> 0] = 0;
     break label$2;
    }
    alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($2 + 208 | 0 | 0, 1066908 | 0, 11 | 0);
    i64toi32_i32$1 = 0;
    i64toi32_i32$0 = $2 + 200 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $3;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$0 = $2 + 192 | 0;
    i64toi32_i32$1 = 0;
    HEAP32[i64toi32_i32$0 >> 2] = 1;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$0 = $2 + 184 | 0;
    i64toi32_i32$1 = 0;
    HEAP32[i64toi32_i32$0 >> 2] = 28;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($2 + 176 | 0) >> 2] = 11;
    HEAP32[($2 + 172 | 0) >> 2] = 1066390;
    HEAP8[($2 + 168 | 0) >> 0] = 13;
    HEAP8[($2 + 160 | 0) >> 0] = 2;
    memcpy($2 + 88 | 0 | 0, memcpy(($2 + 16 | 0) + 7 | 0 | 0, memcpy(($2 + 88 | 0) + 7 | 0 | 0, $2 + 160 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
    $3 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 88 | 0 | 0) | 0;
    HEAP8[$0 >> 0] = 1;
    HEAP32[($0 + 4 | 0) >> 2] = $3;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
   global$0 = $2 + 224 | 0;
   return;
  }
  core__slice__index__slice_end_index_len_fail__h192505a15ac4b345(28 | 0, $3 | 0, 1066892 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert_fit__h83b48ec730131fda($0, $1, $2, $2$hi, $3, $3$hi, $4, $5) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  $4 = $4 | 0;
  $5 = $5 | 0;
  var $8 = 0, $6 = 0, $9 = 0, $10 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $7 = 0, $11 = 0, $12 = 0, $32 = 0, $61 = 0;
  $6 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $0 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  $7 = Math_imul($0, 12);
  $8 = ($6 + $7 | 0) + 180 | 0;
  label$1 : {
   label$2 : {
    $9 = $0 + 1 | 0;
    $10 = HEAPU16[($6 + 314 | 0) >> 1] | 0;
    if ($9 >>> 0 <= $10 >>> 0) {
     break label$2
    }
    i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $32 = i64toi32_i32$0;
    i64toi32_i32$0 = $8;
    HEAP32[$8 >> 2] = $32;
    HEAP32[($8 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($8 + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
    break label$1;
   }
   $11 = $6 + 180 | 0;
   $12 = $10 - $0 | 0;
   memmove($11 + Math_imul($9, 12) | 0 | 0, $8 | 0, Math_imul($12, 12) | 0) | 0;
   $8 = $11 + $7 | 0;
   HEAP32[($8 + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   $61 = i64toi32_i32$1;
   i64toi32_i32$1 = $8;
   HEAP32[$8 >> 2] = $61;
   HEAP32[($8 + 4 | 0) >> 2] = i64toi32_i32$0;
   memmove($6 + ($9 << 4 | 0) | 0 | 0, $6 + ($0 << 4 | 0) | 0 | 0, $12 << 4 | 0 | 0) | 0;
  }
  $1 = $10 + 1 | 0;
  $8 = $6 + ($0 << 4 | 0) | 0;
  i64toi32_i32$0 = $3$hi;
  i64toi32_i32$1 = $8;
  HEAP32[($8 + 8 | 0) >> 2] = $3;
  HEAP32[($8 + 12 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $2$hi;
  i64toi32_i32$1 = $8;
  HEAP32[$8 >> 2] = $2;
  HEAP32[($8 + 4 | 0) >> 2] = i64toi32_i32$0;
  label$3 : {
   $7 = $0 + 2 | 0;
   $8 = $10 + 2 | 0;
   if ($7 >>> 0 >= $8 >>> 0) {
    break label$3
   }
   $11 = $6 + 320 | 0;
   memmove($11 + ($7 << 2 | 0) | 0 | 0, $11 + ($9 << 2 | 0) | 0 | 0, ($10 - $0 | 0) << 2 | 0 | 0) | 0;
  }
  HEAP32[(($6 + ($9 << 2 | 0) | 0) + 320 | 0) >> 2] = $5;
  HEAP16[($6 + 314 | 0) >> 1] = $1;
  label$4 : {
   if ($9 >>> 0 >= $8 >>> 0) {
    break label$4
   }
   $1 = $10 + 1 | 0;
   $9 = (($0 << 2 | 0) + $6 | 0) + 324 | 0;
   label$5 : while (1) {
    $10 = HEAP32[$9 >> 2] | 0;
    $0 = $0 + 1 | 0;
    HEAP16[($10 + 312 | 0) >> 1] = $0;
    HEAP32[($10 + 176 | 0) >> 2] = $6;
    $9 = $9 + 4 | 0;
    if (($1 | 0) != ($0 | 0)) {
     continue label$5
    }
    break label$5;
   };
  }
 }
 
 function alloc__collections__btree__remove___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__KV____remove_internal_kv__h6f3d9ab2a7082b8f($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $4 = 0, $3 = 0, $6 = 0, $7 = 0, $5 = 0, $8 = 0;
  $3 = global$0 - 32 | 0;
  global$0 = $3;
  $4 = HEAP32[(((HEAP32[($1 + 4 | 0) >> 2] | 0) + ((HEAP32[($1 + 8 | 0) >> 2] | 0) << 2 | 0) | 0) + 52 | 0) >> 2] | 0;
  label$1 : {
   $1 = (HEAP32[$1 >> 2] | 0) + -1 | 0;
   if (!$1) {
    break label$1
   }
   label$2 : while (1) {
    $4 = HEAP32[(($4 + ((HEAPU16[($4 + 50 | 0) >> 1] | 0) << 2 | 0) | 0) + 52 | 0) >> 2] | 0;
    $1 = $1 + -1 | 0;
    if ($1) {
     continue label$2
    }
    break label$2;
   };
  }
  $1 = HEAPU16[($4 + 50 | 0) >> 1] | 0;
  HEAP32[($3 + 16 | 0) >> 2] = 0;
  HEAP32[($3 + 24 | 0) >> 2] = $1 ? $1 + -1 | 0 : 0;
  HEAP32[($3 + 20 | 0) >> 2] = $1 ? $4 : 0;
  alloc__collections__btree__remove___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__KV____remove_leaf_kv__hb724496be72afff3($3 | 0, $3 + 16 | 0 | 0, $2 | 0);
  $5 = HEAP32[$3 >> 2] | 0;
  $2 = HEAP32[($3 + 4 | 0) >> 2] | 0;
  label$3 : {
   label$4 : {
    $6 = HEAP32[($3 + 12 | 0) >> 2] | 0;
    $1 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if ($6 >>> 0 >= (HEAPU16[($1 + 50 | 0) >> 1] | 0) >>> 0) {
     break label$4
    }
    $4 = $1;
    break label$3;
   }
   label$5 : while (1) {
    label$6 : {
     $4 = HEAP32[$1 >> 2] | 0;
     if ($4) {
      break label$6
     }
     $4 = 0;
     break label$3;
    }
    $2 = $2 + 1 | 0;
    $6 = HEAPU16[($1 + 48 | 0) >> 1] | 0;
    $1 = $4;
    if ($6 >>> 0 >= (HEAPU16[($1 + 50 | 0) >> 1] | 0) >>> 0) {
     continue label$5
    }
    break label$5;
   };
  }
  $7 = $4 + ($6 << 2 | 0) | 0;
  $1 = $7 + 4 | 0;
  $8 = HEAP32[$1 >> 2] | 0;
  HEAP32[$1 >> 2] = $5;
  label$7 : {
   label$8 : {
    if ($2) {
     break label$8
    }
    $1 = $6 + 1 | 0;
    break label$7;
   }
   $4 = HEAP32[($7 + 56 | 0) >> 2] | 0;
   label$9 : {
    $1 = $2 + -1 | 0;
    if (!$1) {
     break label$9
    }
    label$10 : while (1) {
     $4 = HEAP32[($4 + 52 | 0) >> 2] | 0;
     $1 = $1 + -1 | 0;
     if ($1) {
      continue label$10
     }
     break label$10;
    };
   }
   $1 = 0;
  }
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  HEAP32[$0 >> 2] = $8;
  HEAP32[($0 + 12 | 0) >> 2] = $1;
  HEAP32[($0 + 8 | 0) >> 2] = $4;
  global$0 = $3 + 32 | 0;
 }
 
 function genesiskeydelegation_new($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $19 = 0, $20 = 0, $4 = 0, $5 = 0, $43 = 0, $49 = 0, $52 = 0, $62 = 0, $67 = 0, $70 = 0, $77 = 0, $82 = 0, $87 = 0, $90 = 0;
  $3 = global$0 - 208 | 0;
  global$0 = $3;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h7b8fe8d9d71033fc($3 + 24 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $4 = HEAP32[($3 + 28 | 0) >> 2] | 0;
   $0 = HEAP32[($3 + 24 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h72d8bcf0a652eb89($3 + 16 | 0 | 0, $1 | 0);
   if (!$2) {
    break label$1
   }
   $5 = HEAP32[($3 + 20 | 0) >> 2] | 0;
   $1 = HEAP32[($3 + 16 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb2360c57549df4d5($3 + 8 | 0 | 0, $2 | 0);
   $19 = $0 + 24 | 0;
   HEAP32[(($3 + 32 | 0) + 24 | 0) >> 2] = HEAPU8[$19 >> 0] | 0 | ((HEAPU8[($19 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($19 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($19 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$2 = $0 + 16 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $43 = i64toi32_i32$0;
   i64toi32_i32$0 = ($3 + 32 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $43;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $0 + 8 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $49 = i64toi32_i32$1;
   i64toi32_i32$1 = ($3 + 32 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $49;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $52 = i64toi32_i32$0;
   i64toi32_i32$0 = $3;
   HEAP32[($3 + 32 | 0) >> 2] = $52;
   HEAP32[($3 + 36 | 0) >> 2] = i64toi32_i32$1;
   $20 = $1 + 24 | 0;
   HEAP32[($3 + 84 | 0) >> 2] = HEAPU8[$20 >> 0] | 0 | ((HEAPU8[($20 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($20 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($20 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$2 = $1 + 16 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $62 = i64toi32_i32$1;
   i64toi32_i32$1 = $3 + 76 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $62;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $1 + 8 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $67 = i64toi32_i32$0;
   i64toi32_i32$0 = $3 + 68 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $67;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $70 = i64toi32_i32$1;
   i64toi32_i32$1 = $3;
   HEAP32[($3 + 60 | 0) >> 2] = $70;
   HEAP32[($3 + 64 | 0) >> 2] = i64toi32_i32$0;
   $0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
   i64toi32_i32$2 = $0 + 16 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $77 = i64toi32_i32$0;
   i64toi32_i32$0 = $3 + 104 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $77;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $0 + 8 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $82 = i64toi32_i32$1;
   i64toi32_i32$1 = $3 + 96 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $82;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $0 + 24 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $87 = i64toi32_i32$0;
   i64toi32_i32$0 = $3 + 112 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $87;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $90 = i64toi32_i32$1;
   i64toi32_i32$1 = $3;
   HEAP32[($3 + 88 | 0) >> 2] = $90;
   HEAP32[($3 + 92 | 0) >> 2] = i64toi32_i32$0;
   $0 = HEAP32[($3 + 12 | 0) >> 2] | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($5 | 0, (HEAP32[$5 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($4 | 0, (HEAP32[$4 >> 2] | 0) + -1 | 0 | 0) | 0;
   memcpy($3 + 120 | 0 | 0, $3 + 32 | 0 | 0, 88 | 0) | 0;
   $0 = $cardano_serialization_lib__GenesisKeyDelegation_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h6614a0688d3f0486($3 + 120 | 0 | 0) | 0;
   global$0 = $3 + 208 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function cardano_serialization_lib__tx_builder__TransactionBuilder__calc_script_data_hash__hd107dcfcd329e3ab($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $3 = 0, $4 = 0, $24 = 0, $35 = 0, $38 = 0, $48 = 0, $57 = 0, $60 = 0, $72 = 0, $78 = 0, $83 = 0, $88 = 0;
  $2 = global$0 - 128 | 0;
  global$0 = $2;
  cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__get_plutus_input_scripts__h7e973282eea0f34a($2 + 8 | 0 | 0, $0 + 96 | 0 | 0);
  label$1 : {
   if (!(HEAP32[($2 + 8 | 0) >> 2] | 0)) {
    break label$1
   }
   HEAP32[(($2 + 24 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $24 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   HEAP32[($2 + 24 | 0) >> 2] = $24;
   HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$1;
   cardano_serialization_lib__tx_builder__tx_inputs_builder__PlutusWitnesses__collect__h298b5e0ce4f6a5da($2 + 72 | 0 | 0, $2 + 24 | 0 | 0);
   $3 = ($2 + 40 | 0) + 8 | 0;
   i64toi32_i32$2 = $2 + 92 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $35 = i64toi32_i32$1;
   i64toi32_i32$1 = $3;
   HEAP32[i64toi32_i32$1 >> 2] = $35;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[($2 + 84 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 88 | 0) >> 2] | 0;
   $38 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   HEAP32[($2 + 40 | 0) >> 2] = $38;
   HEAP32[($2 + 44 | 0) >> 2] = i64toi32_i32$1;
   $4 = ($2 + 56 | 0) + 8 | 0;
   HEAP32[$4 >> 2] = HEAP32[($2 + 108 | 0) >> 2] | 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = HEAP32[($2 + 100 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 104 | 0) >> 2] | 0;
   $48 = i64toi32_i32$1;
   i64toi32_i32$1 = $2;
   HEAP32[($2 + 56 | 0) >> 2] = $48;
   HEAP32[($2 + 60 | 0) >> 2] = i64toi32_i32$0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd4b44cb226d8311d($2 + 72 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h3633100df9c96e1e($2 + 72 | 0 | 0);
   i64toi32_i32$2 = $3;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $57 = i64toi32_i32$0;
   i64toi32_i32$0 = ($2 + 112 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $57;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = HEAP32[($2 + 40 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 44 | 0) >> 2] | 0;
   $60 = i64toi32_i32$1;
   i64toi32_i32$1 = $2;
   HEAP32[($2 + 112 | 0) >> 2] = $60;
   HEAP32[($2 + 116 | 0) >> 2] = i64toi32_i32$0;
   cardano_serialization_lib__utils__hash_script_data__h3bfd14619c9a5014($2 + 72 | 0 | 0, $2 + 56 | 0 | 0, $1 | 0, $2 + 112 | 0 | 0);
   HEAP8[($0 + 480 | 0) >> 0] = 1;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAPU8[($2 + 72 | 0) >> 0] | 0 | ((HEAPU8[($2 + 73 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 74 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 75 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[($2 + 76 | 0) >> 0] | 0 | ((HEAPU8[($2 + 77 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 78 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 79 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $72 = i64toi32_i32$0;
   i64toi32_i32$0 = $0 + 481 | 0;
   $18 = $72;
   HEAP8[i64toi32_i32$0 >> 0] = $18;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $18 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $18 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $18 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = ($2 + 72 | 0) + 8 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $78 = i64toi32_i32$1;
   i64toi32_i32$1 = $0 + 489 | 0;
   $19 = $78;
   HEAP8[i64toi32_i32$1 >> 0] = $19;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $19 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $19 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $19 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $2 + 88 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $83 = i64toi32_i32$0;
   i64toi32_i32$0 = $0 + 497 | 0;
   $20 = $83;
   HEAP8[i64toi32_i32$0 >> 0] = $20;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $20 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $20 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $20 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = $2 + 96 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $88 = i64toi32_i32$1;
   i64toi32_i32$1 = $0 + 505 | 0;
   $21 = $88;
   HEAP8[i64toi32_i32$1 >> 0] = $21;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $21 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $21 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $21 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   label$2 : {
    $0 = HEAP32[$4 >> 2] | 0;
    if (!$0) {
     break label$2
    }
    $1 = Math_imul($0, 80);
    $0 = (HEAP32[($2 + 56 | 0) >> 2] | 0) + 8 | 0;
    label$3 : while (1) {
     core__ptr__drop_in_place_cardano_serialization_lib__plutus__PlutusData___hfab843e66e0f9428_2($0 | 0);
     $0 = $0 + 80 | 0;
     $1 = $1 + -80 | 0;
     if ($1) {
      continue label$3
     }
     break label$3;
    };
   }
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h4c688d2d7e8a61fa($2 + 56 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h1bbffe174ae872d8($2 + 24 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h9b1d3bb47b46eeb8($2 + 24 | 0 | 0);
  }
  global$0 = $2 + 128 | 0;
 }
 
 function alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___choose_parent_kv__h24a9cf471103309d($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, $6 = 0, i64toi32_i32$0 = 0, $7 = 0, $5 = 0, i64toi32_i32$1 = 0, $91 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     $4 = HEAP32[$2 >> 2] | 0;
     if (!$4) {
      break label$3
     }
     $5 = $1 + 1 | 0;
     $6 = HEAPU16[($2 + 136 | 0) >> 1] | 0;
     if (!$6) {
      break label$2
     }
     $7 = 0;
     HEAP32[($0 + 4 | 0) >> 2] = 0;
     HEAP32[($0 + 28 | 0) >> 2] = $1;
     HEAP32[($0 + 20 | 0) >> 2] = $1;
     $1 = $6 + -1 | 0;
     HEAP32[($0 + 16 | 0) >> 2] = $1;
     HEAP32[($0 + 12 | 0) >> 2] = $4;
     HEAP32[($0 + 8 | 0) >> 2] = $5;
     HEAP32[($0 + 24 | 0) >> 2] = HEAP32[(($4 + ($1 << 2 | 0) | 0) + 448 | 0) >> 2] | 0;
     $1 = $0 + 32 | 0;
     break label$1;
    }
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    $1 = $0 + 8 | 0;
    $7 = 1;
    break label$1;
   }
   label$4 : {
    if (!(HEAPU16[($4 + 138 | 0) >> 1] | 0)) {
     break label$4
    }
    HEAP32[($0 + 4 | 0) >> 2] = 1;
    HEAP32[($0 + 28 | 0) >> 2] = $1;
    HEAP32[($0 + 24 | 0) >> 2] = $2;
    HEAP32[($0 + 20 | 0) >> 2] = $1;
    HEAP32[($0 + 16 | 0) >> 2] = $6;
    HEAP32[($0 + 12 | 0) >> 2] = $4;
    HEAP32[($0 + 8 | 0) >> 2] = $5;
    $1 = $0 + 32 | 0;
    $2 = HEAP32[((($6 << 2 | 0) + $4 | 0) + 452 | 0) >> 2] | 0;
    $7 = 0;
    break label$1;
   }
   core__fmt__ArgumentV1__new__hbd2b9e6635c55d43($3 + 8 | 0 | 0, 1048912 | 0, 1 | 0);
   HEAP32[($3 + 36 | 0) >> 2] = 1;
   i64toi32_i32$1 = $3;
   i64toi32_i32$0 = 0;
   HEAP32[($3 + 20 | 0) >> 2] = 1;
   HEAP32[($3 + 24 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($3 + 16 | 0) >> 2] = 1048884;
   i64toi32_i32$0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
   $91 = i64toi32_i32$0;
   i64toi32_i32$0 = $3;
   HEAP32[($3 + 40 | 0) >> 2] = $91;
   HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($3 + 32 | 0) >> 2] = $3 + 40 | 0;
   core__panicking__panic_fmt__hbf21a3d4bbb82bf8($3 + 16 | 0 | 0, 1048920 | 0);
   abort();
  }
  HEAP32[$0 >> 2] = $7;
  HEAP32[$1 >> 2] = $2;
  global$0 = $3 + 48 | 0;
 }
 
 function alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___choose_parent_kv__hffff788951b41f8b($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, $6 = 0, i64toi32_i32$0 = 0, $7 = 0, $5 = 0, i64toi32_i32$1 = 0, $91 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     $4 = HEAP32[$2 >> 2] | 0;
     if (!$4) {
      break label$3
     }
     $5 = $1 + 1 | 0;
     $6 = HEAPU16[($2 + 48 | 0) >> 1] | 0;
     if (!$6) {
      break label$2
     }
     $7 = 0;
     HEAP32[($0 + 4 | 0) >> 2] = 0;
     HEAP32[($0 + 28 | 0) >> 2] = $1;
     HEAP32[($0 + 20 | 0) >> 2] = $1;
     $1 = $6 + -1 | 0;
     HEAP32[($0 + 16 | 0) >> 2] = $1;
     HEAP32[($0 + 12 | 0) >> 2] = $4;
     HEAP32[($0 + 8 | 0) >> 2] = $5;
     HEAP32[($0 + 24 | 0) >> 2] = HEAP32[(($4 + ($1 << 2 | 0) | 0) + 52 | 0) >> 2] | 0;
     $1 = $0 + 32 | 0;
     break label$1;
    }
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    $1 = $0 + 8 | 0;
    $7 = 1;
    break label$1;
   }
   label$4 : {
    if (!(HEAPU16[($4 + 50 | 0) >> 1] | 0)) {
     break label$4
    }
    HEAP32[($0 + 4 | 0) >> 2] = 1;
    HEAP32[($0 + 28 | 0) >> 2] = $1;
    HEAP32[($0 + 24 | 0) >> 2] = $2;
    HEAP32[($0 + 20 | 0) >> 2] = $1;
    HEAP32[($0 + 16 | 0) >> 2] = $6;
    HEAP32[($0 + 12 | 0) >> 2] = $4;
    HEAP32[($0 + 8 | 0) >> 2] = $5;
    $1 = $0 + 32 | 0;
    $2 = HEAP32[((($6 << 2 | 0) + $4 | 0) + 56 | 0) >> 2] | 0;
    $7 = 0;
    break label$1;
   }
   core__fmt__ArgumentV1__new__hbd2b9e6635c55d43($3 + 8 | 0 | 0, 1048912 | 0, 1 | 0);
   HEAP32[($3 + 36 | 0) >> 2] = 1;
   i64toi32_i32$1 = $3;
   i64toi32_i32$0 = 0;
   HEAP32[($3 + 20 | 0) >> 2] = 1;
   HEAP32[($3 + 24 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($3 + 16 | 0) >> 2] = 1048884;
   i64toi32_i32$0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
   $91 = i64toi32_i32$0;
   i64toi32_i32$0 = $3;
   HEAP32[($3 + 40 | 0) >> 2] = $91;
   HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($3 + 32 | 0) >> 2] = $3 + 40 | 0;
   core__panicking__panic_fmt__hbf21a3d4bbb82bf8($3 + 16 | 0 | 0, 1048920 | 0);
   abort();
  }
  HEAP32[$0 >> 2] = $7;
  HEAP32[$1 >> 2] = $2;
  global$0 = $3 + 48 | 0;
 }
 
 function alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___choose_parent_kv__hcc0b8d6ea18560ad($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, $6 = 0, i64toi32_i32$0 = 0, $7 = 0, $5 = 0, i64toi32_i32$1 = 0, $91 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     $4 = HEAP32[($2 + 88 | 0) >> 2] | 0;
     if (!$4) {
      break label$3
     }
     $5 = $1 + 1 | 0;
     $6 = HEAPU16[($2 + 224 | 0) >> 1] | 0;
     if (!$6) {
      break label$2
     }
     $7 = 0;
     HEAP32[($0 + 4 | 0) >> 2] = 0;
     HEAP32[($0 + 28 | 0) >> 2] = $1;
     HEAP32[($0 + 20 | 0) >> 2] = $1;
     $1 = $6 + -1 | 0;
     HEAP32[($0 + 16 | 0) >> 2] = $1;
     HEAP32[($0 + 12 | 0) >> 2] = $4;
     HEAP32[($0 + 8 | 0) >> 2] = $5;
     HEAP32[($0 + 24 | 0) >> 2] = HEAP32[(($4 + ($1 << 2 | 0) | 0) + 232 | 0) >> 2] | 0;
     $1 = $0 + 32 | 0;
     break label$1;
    }
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    $1 = $0 + 8 | 0;
    $7 = 1;
    break label$1;
   }
   label$4 : {
    if (!(HEAPU16[($4 + 226 | 0) >> 1] | 0)) {
     break label$4
    }
    HEAP32[($0 + 4 | 0) >> 2] = 1;
    HEAP32[($0 + 28 | 0) >> 2] = $1;
    HEAP32[($0 + 24 | 0) >> 2] = $2;
    HEAP32[($0 + 20 | 0) >> 2] = $1;
    HEAP32[($0 + 16 | 0) >> 2] = $6;
    HEAP32[($0 + 12 | 0) >> 2] = $4;
    HEAP32[($0 + 8 | 0) >> 2] = $5;
    $1 = $0 + 32 | 0;
    $2 = HEAP32[((($6 << 2 | 0) + $4 | 0) + 236 | 0) >> 2] | 0;
    $7 = 0;
    break label$1;
   }
   core__fmt__ArgumentV1__new__hbd2b9e6635c55d43($3 + 8 | 0 | 0, 1048912 | 0, 1 | 0);
   HEAP32[($3 + 36 | 0) >> 2] = 1;
   i64toi32_i32$1 = $3;
   i64toi32_i32$0 = 0;
   HEAP32[($3 + 20 | 0) >> 2] = 1;
   HEAP32[($3 + 24 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($3 + 16 | 0) >> 2] = 1048884;
   i64toi32_i32$0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
   $91 = i64toi32_i32$0;
   i64toi32_i32$0 = $3;
   HEAP32[($3 + 40 | 0) >> 2] = $91;
   HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($3 + 32 | 0) >> 2] = $3 + 40 | 0;
   core__panicking__panic_fmt__hbf21a3d4bbb82bf8($3 + 16 | 0 | 0, 1048920 | 0);
   abort();
  }
  HEAP32[$0 >> 2] = $7;
  HEAP32[$1 >> 2] = $2;
  global$0 = $3 + 48 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert__h26d5afec67d4e9d8($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $6 = 0, $7 = 0, $54 = 0, $87 = 0, $103 = 0, $108 = 0, $111 = 0;
  $5 = global$0 - 64 | 0;
  global$0 = $5;
  label$1 : {
   label$2 : {
    $6 = HEAP32[$1 >> 2] | 0;
    if (($6 + -1 | 0 | 0) != ($3 | 0)) {
     break label$2
    }
    label$3 : {
     label$4 : {
      label$5 : {
       $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
       if ((HEAPU16[($3 + 138 | 0) >> 1] | 0) >>> 0 < 11 >>> 0) {
        break label$5
       }
       alloc__collections__btree__node__splitpoint__h8424344594b4deb1($5 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
       $1 = HEAP32[($5 + 8 | 0) >> 2] | 0;
       $7 = HEAP32[($5 + 4 | 0) >> 2] | 0;
       HEAP32[($5 + 56 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
       HEAP32[($5 + 52 | 0) >> 2] = $3;
       HEAP32[($5 + 48 | 0) >> 2] = $6;
       alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__KV___split__hf664e68985110f8b($5 | 0, $5 + 48 | 0 | 0);
       if (($7 | 0) == (1 | 0)) {
        break label$4
       }
       HEAP32[($5 + 32 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
       $3 = HEAP32[($5 + 4 | 0) >> 2] | 0;
       break label$3;
      }
      HEAP32[($5 + 8 | 0) >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
      i64toi32_i32$2 = $2;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $54 = i64toi32_i32$0;
      i64toi32_i32$0 = $5;
      HEAP32[$5 >> 2] = $54;
      HEAP32[($5 + 4 | 0) >> 2] = i64toi32_i32$1;
      alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert_fit__h873df3a9555bbba9($1 | 0, $5 | 0, $5 | 0, $4 | 0);
      HEAP32[($0 + 8 | 0) >> 2] = $3;
      HEAP32[($0 + 4 | 0) >> 2] = $6;
      HEAP32[$0 >> 2] = 0;
      HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
      break label$1;
     }
     HEAP32[($5 + 32 | 0) >> 2] = HEAP32[($5 + 20 | 0) >> 2] | 0;
     $3 = HEAP32[($5 + 24 | 0) >> 2] | 0;
    }
    HEAP32[($5 + 40 | 0) >> 2] = $1;
    HEAP32[($5 + 36 | 0) >> 2] = $3;
    HEAP32[(($5 + 48 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $87 = i64toi32_i32$1;
    i64toi32_i32$1 = $5;
    HEAP32[($5 + 48 | 0) >> 2] = $87;
    HEAP32[($5 + 52 | 0) >> 2] = i64toi32_i32$0;
    alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert_fit__h873df3a9555bbba9($5 + 32 | 0 | 0, $5 + 48 | 0 | 0, $5 | 0, $4 | 0);
    HEAP32[($0 + 28 | 0) >> 2] = HEAP32[($5 + 24 | 0) >> 2] | 0;
    i64toi32_i32$2 = $5 + 16 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $103 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 20 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $103;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $5 + 8 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $108 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 12 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $108;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $5;
    i64toi32_i32$0 = HEAP32[$5 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($5 + 4 | 0) >> 2] | 0;
    $111 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $111;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[i64toi32_i32$0 >> 2] = 1;
    break label$1;
   }
   core__panicking__panic__h2fd385a887c8bf13(1049076 | 0, 53 | 0, 1049132 | 0);
   abort();
  }
  global$0 = $5 + 64 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert__h79a822cb48d5a02c($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $6 = 0, $7 = 0, $54 = 0, $87 = 0, $103 = 0, $108 = 0, $111 = 0;
  $5 = global$0 - 64 | 0;
  global$0 = $5;
  label$1 : {
   label$2 : {
    $6 = HEAP32[$1 >> 2] | 0;
    if (($6 + -1 | 0 | 0) != ($3 | 0)) {
     break label$2
    }
    label$3 : {
     label$4 : {
      label$5 : {
       $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
       if ((HEAPU16[($3 + 138 | 0) >> 1] | 0) >>> 0 < 11 >>> 0) {
        break label$5
       }
       alloc__collections__btree__node__splitpoint__h8424344594b4deb1($5 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
       $1 = HEAP32[($5 + 8 | 0) >> 2] | 0;
       $7 = HEAP32[($5 + 4 | 0) >> 2] | 0;
       HEAP32[($5 + 56 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
       HEAP32[($5 + 52 | 0) >> 2] = $3;
       HEAP32[($5 + 48 | 0) >> 2] = $6;
       alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__KV___split__hf7ac7d2b027c0d7d($5 | 0, $5 + 48 | 0 | 0);
       if (($7 | 0) == (1 | 0)) {
        break label$4
       }
       HEAP32[($5 + 32 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
       $3 = HEAP32[($5 + 4 | 0) >> 2] | 0;
       break label$3;
      }
      HEAP32[($5 + 8 | 0) >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
      i64toi32_i32$2 = $2;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $54 = i64toi32_i32$0;
      i64toi32_i32$0 = $5;
      HEAP32[$5 >> 2] = $54;
      HEAP32[($5 + 4 | 0) >> 2] = i64toi32_i32$1;
      alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert_fit__h288101fa3069cc9c($1 | 0, $5 | 0, $5 | 0, $4 | 0);
      HEAP32[($0 + 8 | 0) >> 2] = $3;
      HEAP32[($0 + 4 | 0) >> 2] = $6;
      HEAP32[$0 >> 2] = 0;
      HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
      break label$1;
     }
     HEAP32[($5 + 32 | 0) >> 2] = HEAP32[($5 + 20 | 0) >> 2] | 0;
     $3 = HEAP32[($5 + 24 | 0) >> 2] | 0;
    }
    HEAP32[($5 + 40 | 0) >> 2] = $1;
    HEAP32[($5 + 36 | 0) >> 2] = $3;
    HEAP32[(($5 + 48 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $87 = i64toi32_i32$1;
    i64toi32_i32$1 = $5;
    HEAP32[($5 + 48 | 0) >> 2] = $87;
    HEAP32[($5 + 52 | 0) >> 2] = i64toi32_i32$0;
    alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert_fit__h288101fa3069cc9c($5 + 32 | 0 | 0, $5 + 48 | 0 | 0, $5 | 0, $4 | 0);
    HEAP32[($0 + 28 | 0) >> 2] = HEAP32[($5 + 24 | 0) >> 2] | 0;
    i64toi32_i32$2 = $5 + 16 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $103 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 20 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $103;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $5 + 8 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $108 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 12 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $108;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $5;
    i64toi32_i32$0 = HEAP32[$5 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($5 + 4 | 0) >> 2] | 0;
    $111 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $111;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[i64toi32_i32$0 >> 2] = 1;
    break label$1;
   }
   core__panicking__panic__h2fd385a887c8bf13(1049076 | 0, 53 | 0, 1049132 | 0);
   abort();
  }
  global$0 = $5 + 64 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert__hfc67a1d82ed9fc5c($0, $1, $2, $3, $4, $5) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  $5 = $5 | 0;
  var $6 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $7 = 0, $8 = 0, $60 = 0, $99 = 0;
  $6 = global$0 - 320 | 0;
  global$0 = $6;
  label$1 : {
   label$2 : {
    $7 = HEAP32[$1 >> 2] | 0;
    if (($7 + -1 | 0 | 0) != ($4 | 0)) {
     break label$2
    }
    label$3 : {
     label$4 : {
      label$5 : {
       $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
       if ((HEAPU16[($4 + 1546 | 0) >> 1] | 0) >>> 0 < 11 >>> 0) {
        break label$5
       }
       alloc__collections__btree__node__splitpoint__h8424344594b4deb1($6 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
       $1 = HEAP32[($6 + 8 | 0) >> 2] | 0;
       $8 = HEAP32[($6 + 4 | 0) >> 2] | 0;
       HEAP32[($6 + 184 | 0) >> 2] = HEAP32[$6 >> 2] | 0;
       HEAP32[($6 + 180 | 0) >> 2] = $4;
       HEAP32[($6 + 176 | 0) >> 2] = $7;
       alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__KV___split__h520fcc98c2e1fbd6($6 | 0, $6 + 176 | 0 | 0);
       if (($8 | 0) == (1 | 0)) {
        break label$4
       }
       HEAP32[($6 + 160 | 0) >> 2] = HEAP32[($6 + 144 | 0) >> 2] | 0;
       $4 = HEAP32[($6 + 148 | 0) >> 2] | 0;
       break label$3;
      }
      $2 = memcpy($6 | 0, $2 | 0, 128 | 0) | 0;
      HEAP32[(($2 + 176 | 0) + 8 | 0) >> 2] = HEAP32[($3 + 8 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[$3 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($3 + 4 | 0) >> 2] | 0;
      $60 = i64toi32_i32$0;
      i64toi32_i32$0 = $2;
      HEAP32[($2 + 176 | 0) >> 2] = $60;
      HEAP32[($2 + 180 | 0) >> 2] = i64toi32_i32$1;
      alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert_fit__h0f5adcefcac0e336($1 | 0, $2 | 0, $2 + 176 | 0 | 0, $6 | 0, $5 | 0);
      HEAP32[($0 + 8 | 0) >> 2] = $4;
      HEAP32[($0 + 4 | 0) >> 2] = $7;
      HEAP32[$0 >> 2] = 0;
      HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
      break label$1;
     }
     HEAP32[($6 + 160 | 0) >> 2] = HEAP32[($6 + 152 | 0) >> 2] | 0;
     $4 = HEAP32[($6 + 156 | 0) >> 2] | 0;
    }
    HEAP32[($6 + 168 | 0) >> 2] = $1;
    HEAP32[($6 + 164 | 0) >> 2] = $4;
    memcpy($6 + 176 | 0 | 0, $2 | 0, 128 | 0) | 0;
    HEAP32[(($6 + 304 | 0) + 8 | 0) >> 2] = HEAP32[($3 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[$3 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($3 + 4 | 0) >> 2] | 0;
    $99 = i64toi32_i32$1;
    i64toi32_i32$1 = $6;
    HEAP32[($6 + 304 | 0) >> 2] = $99;
    HEAP32[($6 + 308 | 0) >> 2] = i64toi32_i32$0;
    alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert_fit__h0f5adcefcac0e336($6 + 160 | 0 | 0, $6 + 176 | 0 | 0, $6 + 304 | 0 | 0, $6 | 0, $5 | 0);
    memcpy($0 + 8 | 0 | 0, $6 | 0, 160 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    break label$1;
   }
   core__panicking__panic__h2fd385a887c8bf13(1049076 | 0, 53 | 0, 1049132 | 0);
   abort();
  }
  global$0 = $6 + 320 | 0;
 }
 
 function cardano_serialization_lib__crypto__PrivateKey__generate_ed25519extended__he466dab7ccdf64b2($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, $2 = 0, i64toi32_i32$1 = 0, $12 = 0, $13 = 0, i64toi32_i32$2 = 0, $14 = 0, $4 = 0, $4$hi = 0, $5 = 0, $5$hi = 0, $75 = 0, $3 = 0;
  $1 = global$0 - 256 | 0;
  global$0 = $1;
  rand_os__OsRng__new__hc49e74e2fe75aed3($1 + 224 | 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[($1 + 224 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $2 = $1 + 152 | 0 | 1 | 0;
    $cardano_serialization_lib__chain_crypto__algorithms__ed25519_extended__Ed25519Extended_20as_20cardano_serialization_lib__chain_crypto__key__AsymmetricKey___generate__h9fbbb0ee2f5762c3($2 | 0, HEAP32[($1 + 228 | 0) >> 2] | 0 | 0, HEAP32[($1 + 232 | 0) >> 2] | 0 | 0);
    memcpy($1 + 88 | 0 | 0, $2 | 0, 64 | 0) | 0;
    memcpy($1 + 24 | 0 | 0, $1 + 88 | 0 | 0, 64 | 0) | 0;
    $2 = 0;
    HEAP8[($0 + 1 | 0) >> 0] = 0;
    memcpy($0 + 2 | 0 | 0, $1 + 24 | 0 | 0, 64 | 0) | 0;
    break label$1;
   }
   i64toi32_i32$2 = $1 + 236 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $4 = i64toi32_i32$0;
   $4$hi = i64toi32_i32$1;
   i64toi32_i32$0 = $1 + 34 | 0;
   $12 = $4;
   HEAP8[i64toi32_i32$0 >> 0] = $12;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $12 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $12 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $12 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   $2 = HEAP32[(($1 + 224 | 0) + 20 | 0) >> 2] | 0;
   $14 = $1 + 42 | 0;
   HEAP8[$14 >> 0] = $2;
   HEAP8[($14 + 1 | 0) >> 0] = $2 >>> 8 | 0;
   HEAP8[($14 + 2 | 0) >> 0] = $2 >>> 16 | 0;
   HEAP8[($14 + 3 | 0) >> 0] = $2 >>> 24 | 0;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[($1 + 228 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($1 + 232 | 0) >> 2] | 0;
   $5 = i64toi32_i32$1;
   $5$hi = i64toi32_i32$0;
   i64toi32_i32$1 = $1;
   $13 = $5;
   HEAP8[($1 + 26 | 0) >> 0] = $13;
   HEAP8[($1 + 27 | 0) >> 0] = $13 >>> 8 | 0;
   HEAP8[($1 + 28 | 0) >> 0] = $13 >>> 16 | 0;
   HEAP8[($1 + 29 | 0) >> 0] = $13 >>> 24 | 0;
   HEAP8[($1 + 30 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[($1 + 31 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[($1 + 32 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[($1 + 33 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   HEAP32[($1 + 104 | 0) >> 2] = $2;
   $2 = $1 + 96 | 0;
   i64toi32_i32$0 = $4$hi;
   i64toi32_i32$1 = $2;
   HEAP32[i64toi32_i32$1 >> 2] = $12;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $5$hi;
   i64toi32_i32$1 = $1;
   HEAP32[($1 + 88 | 0) >> 2] = $13;
   HEAP32[($1 + 92 | 0) >> 2] = i64toi32_i32$0;
   core__fmt__ArgumentV1__new__hc180267ccf44df88($1 + 16 | 0 | 0, $1 + 88 | 0 | 0, 109 | 0);
   HEAP32[(($1 + 152 | 0) + 20 | 0) >> 2] = 1;
   i64toi32_i32$1 = $1;
   i64toi32_i32$0 = 0;
   HEAP32[($1 + 156 | 0) >> 2] = 1;
   HEAP32[($1 + 160 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($1 + 152 | 0) >> 2] = 1066504;
   i64toi32_i32$2 = $1;
   i64toi32_i32$0 = HEAP32[($1 + 16 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
   $75 = i64toi32_i32$0;
   i64toi32_i32$0 = $1;
   HEAP32[($1 + 248 | 0) >> 2] = $75;
   HEAP32[($1 + 252 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($1 + 168 | 0) >> 2] = $1 + 248 | 0;
   alloc__fmt__format__h6e9e003a52c07309($1 + 224 | 0 | 0, $1 + 152 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($1 + 8 | 0 | 0, $1 + 224 | 0 | 0);
   $3 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($1 + 8 | 0) >> 2] | 0 | 0, HEAP32[($1 + 12 | 0) >> 2] | 0 | 0) | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 + 224 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 + 224 | 0 | 0);
   label$3 : {
    if (!(HEAP32[$2 >> 2] | 0)) {
     break label$3
    }
    core__ptr__drop_in_place_alloc__boxed__Box_dyn_20std__error__Error_core__marker__Sync_core__marker__Send____h3635675e5a953b32($2 | 0);
   }
   HEAP32[($0 + 4 | 0) >> 2] = $3;
   $2 = 1;
  }
  HEAP8[$0 >> 0] = $2;
  global$0 = $1 + 256 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert__hcdc4e5bf5bce6141($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $5 = 0, $6 = 0, $7 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $4 = global$0 - 304 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $5 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      if ((HEAPU16[($5 + 1062 | 0) >> 1] | 0) >>> 0 < 11 >>> 0) {
       break label$4
      }
      alloc__collections__btree__node__splitpoint__h8424344594b4deb1($4 + 184 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
      $6 = HEAP32[($4 + 192 | 0) >> 2] | 0;
      $7 = HEAP32[($4 + 188 | 0) >> 2] | 0;
      $1 = HEAP32[$1 >> 2] | 0;
      HEAP32[($4 + 192 | 0) >> 2] = HEAP32[($4 + 184 | 0) >> 2] | 0;
      HEAP32[($4 + 188 | 0) >> 2] = $5;
      HEAP32[($4 + 184 | 0) >> 2] = $1;
      alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__KV___split__h844f4553f76d2c88($4 + 8 | 0 | 0, $4 + 184 | 0 | 0);
      if (($7 | 0) == (1 | 0)) {
       break label$3
      }
      HEAP32[($4 + 120 | 0) >> 2] = HEAP32[($4 + 104 | 0) >> 2] | 0;
      $1 = HEAP32[($4 + 108 | 0) >> 2] | 0;
      break label$2;
     }
     memcpy($4 + 8 | 0 | 0, $2 | 0, 48 | 0) | 0;
     memcpy($4 + 184 | 0 | 0, $3 | 0, 48 | 0) | 0;
     (wasm2js_i32$0 = $0, wasm2js_i32$1 = alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_fit__hc0e2ba3df5c2c24e($1 | 0, $4 + 8 | 0 | 0, $4 + 184 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 120 | 0) >> 2] = wasm2js_i32$1;
     HEAP32[($0 + 8 | 0) >> 2] = $5;
     HEAP32[$0 >> 2] = 0;
     HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
     HEAP32[($0 + 4 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
     break label$1;
    }
    HEAP32[($4 + 120 | 0) >> 2] = HEAP32[($4 + 112 | 0) >> 2] | 0;
    $1 = HEAP32[($4 + 116 | 0) >> 2] | 0;
   }
   HEAP32[($4 + 128 | 0) >> 2] = $6;
   HEAP32[($4 + 124 | 0) >> 2] = $1;
   memcpy($4 + 136 | 0 | 0, $2 | 0, 48 | 0) | 0;
   memcpy($4 + 184 | 0 | 0, $3 | 0, 48 | 0) | 0;
   $1 = alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_fit__hc0e2ba3df5c2c24e($4 + 120 | 0 | 0, $4 + 136 | 0 | 0, $4 + 184 | 0 | 0) | 0;
   memcpy(($4 + 184 | 0) + 4 | 0 | 0, $4 + 8 | 0 | 0, 112 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
   memcpy($0 + 4 | 0 | 0, $4 + 184 | 0 | 0, 116 | 0) | 0;
   HEAP32[($0 + 120 | 0) >> 2] = $1;
  }
  global$0 = $4 + 304 | 0;
 }
 
 function core__fmt__builders__DebugStruct__field__hec833bfe02704935($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, $8 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $6 = 0, $7 = 0, $69 = 0, $9 = 0, $9$hi = 0, $81 = 0, $86 = 0;
  $5 = global$0 - 64 | 0;
  global$0 = $5;
  $6 = 1;
  label$1 : {
   if (HEAPU8[($0 + 4 | 0) >> 0] | 0) {
    break label$1
   }
   $7 = HEAPU8[($0 + 5 | 0) >> 0] | 0;
   label$2 : {
    $8 = HEAP32[$0 >> 2] | 0;
    if ((HEAPU8[$8 >> 0] | 0) & 4 | 0) {
     break label$2
    }
    $6 = 1;
    $7 = $7 & 255 | 0;
    if (FUNCTION_TABLE[HEAP32[((HEAP32[($8 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($8 + 24 | 0) >> 2] | 0, $7 ? 1149869 : 1149871, $7 ? 2 : 3) | 0) {
     break label$1
    }
    $6 = 1;
    if (FUNCTION_TABLE[HEAP32[((HEAP32[($8 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($8 + 24 | 0) >> 2] | 0, $1, $2) | 0) {
     break label$1
    }
    $6 = 1;
    if (FUNCTION_TABLE[HEAP32[((HEAP32[($8 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($8 + 24 | 0) >> 2] | 0, 1149752, 2) | 0) {
     break label$1
    }
    $6 = FUNCTION_TABLE[HEAP32[($4 + 12 | 0) >> 2] | 0 | 0]($3, $8) | 0;
    break label$1;
   }
   label$3 : {
    if ($7 & 255 | 0) {
     break label$3
    }
    $6 = 1;
    if (FUNCTION_TABLE[HEAP32[((HEAP32[($8 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($8 + 24 | 0) >> 2] | 0, 1149864, 3) | 0) {
     break label$1
    }
   }
   $6 = 1;
   HEAP8[($5 + 23 | 0) >> 0] = 1;
   HEAP32[($5 + 52 | 0) >> 2] = 1149804;
   i64toi32_i32$0 = HEAP32[($8 + 24 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($8 + 28 | 0) >> 2] | 0;
   $69 = i64toi32_i32$0;
   i64toi32_i32$0 = $5;
   HEAP32[($5 + 8 | 0) >> 2] = $69;
   HEAP32[($5 + 12 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($5 + 16 | 0) >> 2] = $5 + 23 | 0;
   i64toi32_i32$1 = HEAP32[($8 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($8 + 12 | 0) >> 2] | 0;
   $9 = i64toi32_i32$1;
   $9$hi = i64toi32_i32$0;
   i64toi32_i32$0 = HEAP32[($8 + 16 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($8 + 20 | 0) >> 2] | 0;
   HEAP8[($5 + 56 | 0) >> 0] = HEAPU8[($8 + 32 | 0) >> 0] | 0;
   $81 = i64toi32_i32$0;
   i64toi32_i32$0 = $5;
   HEAP32[($5 + 40 | 0) >> 2] = $81;
   HEAP32[($5 + 44 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $9$hi;
   i64toi32_i32$0 = $5;
   HEAP32[($5 + 32 | 0) >> 2] = $9;
   HEAP32[($5 + 36 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = HEAP32[$8 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($8 + 4 | 0) >> 2] | 0;
   $86 = i64toi32_i32$1;
   i64toi32_i32$1 = $5;
   HEAP32[($5 + 24 | 0) >> 2] = $86;
   HEAP32[($5 + 28 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($5 + 48 | 0) >> 2] = $5 + 8 | 0;
   if ($core__fmt__builders__PadAdapter_20as_20core__fmt__Write___write_str__h2104fbe324f8507b($5 + 8 | 0 | 0, $1 | 0, $2 | 0) | 0) {
    break label$1
   }
   if ($core__fmt__builders__PadAdapter_20as_20core__fmt__Write___write_str__h2104fbe324f8507b($5 + 8 | 0 | 0, 1149752 | 0, 2 | 0) | 0) {
    break label$1
   }
   if (FUNCTION_TABLE[HEAP32[($4 + 12 | 0) >> 2] | 0 | 0]($3, $5 + 24 | 0) | 0) {
    break label$1
   }
   $6 = FUNCTION_TABLE[HEAP32[((HEAP32[($5 + 52 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($5 + 48 | 0) >> 2] | 0, 1149867, 2) | 0;
  }
  HEAP8[($0 + 5 | 0) >> 0] = 1;
  HEAP8[($0 + 4 | 0) >> 0] = $6;
  global$0 = $5 + 64 | 0;
  return $0 | 0;
 }
 
 function core__unicode__unicode_data__grapheme_extend__lookup__hff46536597365d27($0) {
  $0 = $0 | 0;
  var $2 = 0, $3 = 0, $4 = 0, $1 = 0, $5 = 0;
  $1 = $0 << 11 | 0;
  $2 = 0;
  $3 = 31;
  $4 = 31;
  label$1 : {
   label$2 : {
    label$3 : while (1) {
     label$4 : {
      label$5 : {
       $3 = ($3 >>> 1 | 0) + $2 | 0;
       $5 = (HEAP32[(($3 << 2 | 0) + 1154620 | 0) >> 2] | 0) << 11 | 0;
       if ($5 >>> 0 < $1 >>> 0) {
        break label$5
       }
       if (($5 | 0) == ($1 | 0)) {
        break label$2
       }
       $4 = $3;
       break label$4;
      }
      $2 = $3 + 1 | 0;
     }
     $3 = $4 - $2 | 0;
     if ($4 >>> 0 > $2 >>> 0) {
      continue label$3
     }
     break label$1;
    };
   }
   $2 = $3 + 1 | 0;
  }
  label$6 : {
   label$7 : {
    label$8 : {
     if ($2 >>> 0 > 30 >>> 0) {
      break label$8
     }
     $3 = $2 << 2 | 0;
     $4 = 689;
     label$9 : {
      if (($2 | 0) == (30 | 0)) {
       break label$9
      }
      $4 = (HEAP32[($3 + 1154624 | 0) >> 2] | 0) >>> 21 | 0;
     }
     $5 = 0;
     label$10 : {
      $1 = $2 + -1 | 0;
      if ($1 >>> 0 > $2 >>> 0) {
       break label$10
      }
      if ($1 >>> 0 >= 31 >>> 0) {
       break label$7
      }
      $5 = (HEAP32[(($1 << 2 | 0) + 1154620 | 0) >> 2] | 0) & 2097151 | 0;
     }
     label$11 : {
      $2 = (HEAP32[($3 + 1154620 | 0) >> 2] | 0) >>> 21 | 0;
      if (($4 | 0) == ($2 + 1 | 0 | 0)) {
       break label$11
      }
      $1 = $0 - $5 | 0;
      $3 = $2 >>> 0 > 689 >>> 0 ? $2 : 689;
      $5 = $4 + -1 | 0;
      $4 = 0;
      label$12 : while (1) {
       if (($3 | 0) == ($2 | 0)) {
        break label$6
       }
       $4 = $4 + (HEAPU8[($2 + 1154744 | 0) >> 0] | 0) | 0;
       if ($4 >>> 0 > $1 >>> 0) {
        break label$11
       }
       $2 = $2 + 1 | 0;
       if (($5 | 0) != ($2 | 0)) {
        continue label$12
       }
       break label$12;
      };
      $2 = $5;
     }
     return $2 & 1 | 0 | 0;
    }
    core__panicking__panic_bounds_check__h808b524af17640b1($2 | 0, 31 | 0, 1152940 | 0);
    abort();
   }
   core__panicking__panic_bounds_check__h808b524af17640b1($1 | 0, 31 | 0, 1152972 | 0);
   abort();
  }
  core__panicking__panic_bounds_check__h808b524af17640b1($3 | 0, 689 | 0, 1152956 | 0);
  abort();
 }
 
 function core__unicode__unicode_data__case_ignorable__lookup__heab570bcd49c0edc($0) {
  $0 = $0 | 0;
  var $2 = 0, $3 = 0, $4 = 0, $1 = 0, $5 = 0;
  $1 = $0 << 11 | 0;
  $2 = 0;
  $3 = 32;
  $4 = 32;
  label$1 : {
   label$2 : {
    label$3 : while (1) {
     label$4 : {
      label$5 : {
       $3 = ($3 >>> 1 | 0) + $2 | 0;
       $5 = (HEAP32[(($3 << 2 | 0) + 1153308 | 0) >> 2] | 0) << 11 | 0;
       if ($5 >>> 0 < $1 >>> 0) {
        break label$5
       }
       if (($5 | 0) == ($1 | 0)) {
        break label$2
       }
       $4 = $3;
       break label$4;
      }
      $2 = $3 + 1 | 0;
     }
     $3 = $4 - $2 | 0;
     if ($4 >>> 0 > $2 >>> 0) {
      continue label$3
     }
     break label$1;
    };
   }
   $2 = $3 + 1 | 0;
  }
  label$6 : {
   label$7 : {
    label$8 : {
     if ($2 >>> 0 > 31 >>> 0) {
      break label$8
     }
     $3 = $2 << 2 | 0;
     $4 = 821;
     label$9 : {
      if (($2 | 0) == (31 | 0)) {
       break label$9
      }
      $4 = (HEAP32[($3 + 1153312 | 0) >> 2] | 0) >>> 21 | 0;
     }
     $5 = 0;
     label$10 : {
      $1 = $2 + -1 | 0;
      if ($1 >>> 0 > $2 >>> 0) {
       break label$10
      }
      if ($1 >>> 0 >= 32 >>> 0) {
       break label$7
      }
      $5 = (HEAP32[(($1 << 2 | 0) + 1153308 | 0) >> 2] | 0) & 2097151 | 0;
     }
     label$11 : {
      $2 = (HEAP32[($3 + 1153308 | 0) >> 2] | 0) >>> 21 | 0;
      if (($4 | 0) == ($2 + 1 | 0 | 0)) {
       break label$11
      }
      $1 = $0 - $5 | 0;
      $3 = $2 >>> 0 > 821 >>> 0 ? $2 : 821;
      $5 = $4 + -1 | 0;
      $4 = 0;
      label$12 : while (1) {
       if (($3 | 0) == ($2 | 0)) {
        break label$6
       }
       $4 = $4 + (HEAPU8[($2 + 1153436 | 0) >> 0] | 0) | 0;
       if ($4 >>> 0 > $1 >>> 0) {
        break label$11
       }
       $2 = $2 + 1 | 0;
       if (($5 | 0) != ($2 | 0)) {
        continue label$12
       }
       break label$12;
      };
      $2 = $5;
     }
     return $2 & 1 | 0 | 0;
    }
    core__panicking__panic_bounds_check__h808b524af17640b1($2 | 0, 32 | 0, 1152940 | 0);
    abort();
   }
   core__panicking__panic_bounds_check__h808b524af17640b1($1 | 0, 32 | 0, 1152972 | 0);
   abort();
  }
  core__panicking__panic_bounds_check__h808b524af17640b1($3 | 0, 821 | 0, 1152956 | 0);
  abort();
 }
 
 function core__unicode__unicode_data__cased__lookup__hc09fca0edcae4c58($0) {
  $0 = $0 | 0;
  var $2 = 0, $3 = 0, $4 = 0, $1 = 0, $5 = 0;
  $1 = $0 << 11 | 0;
  $2 = 0;
  $3 = 19;
  $4 = 19;
  label$1 : {
   label$2 : {
    label$3 : while (1) {
     label$4 : {
      label$5 : {
       $3 = ($3 >>> 1 | 0) + $2 | 0;
       $5 = (HEAP32[(($3 << 2 | 0) + 1154260 | 0) >> 2] | 0) << 11 | 0;
       if ($5 >>> 0 < $1 >>> 0) {
        break label$5
       }
       if (($5 | 0) == ($1 | 0)) {
        break label$2
       }
       $4 = $3;
       break label$4;
      }
      $2 = $3 + 1 | 0;
     }
     $3 = $4 - $2 | 0;
     if ($4 >>> 0 > $2 >>> 0) {
      continue label$3
     }
     break label$1;
    };
   }
   $2 = $3 + 1 | 0;
  }
  label$6 : {
   label$7 : {
    label$8 : {
     if ($2 >>> 0 > 18 >>> 0) {
      break label$8
     }
     $3 = $2 << 2 | 0;
     $4 = 283;
     label$9 : {
      if (($2 | 0) == (18 | 0)) {
       break label$9
      }
      $4 = (HEAP32[($3 + 1154264 | 0) >> 2] | 0) >>> 21 | 0;
     }
     $5 = 0;
     label$10 : {
      $1 = $2 + -1 | 0;
      if ($1 >>> 0 > $2 >>> 0) {
       break label$10
      }
      if ($1 >>> 0 >= 19 >>> 0) {
       break label$7
      }
      $5 = (HEAP32[(($1 << 2 | 0) + 1154260 | 0) >> 2] | 0) & 2097151 | 0;
     }
     label$11 : {
      $2 = (HEAP32[($3 + 1154260 | 0) >> 2] | 0) >>> 21 | 0;
      if (($4 | 0) == ($2 + 1 | 0 | 0)) {
       break label$11
      }
      $1 = $0 - $5 | 0;
      $3 = $2 >>> 0 > 283 >>> 0 ? $2 : 283;
      $5 = $4 + -1 | 0;
      $4 = 0;
      label$12 : while (1) {
       if (($3 | 0) == ($2 | 0)) {
        break label$6
       }
       $4 = $4 + (HEAPU8[($2 + 1154336 | 0) >> 0] | 0) | 0;
       if ($4 >>> 0 > $1 >>> 0) {
        break label$11
       }
       $2 = $2 + 1 | 0;
       if (($5 | 0) != ($2 | 0)) {
        continue label$12
       }
       break label$12;
      };
      $2 = $5;
     }
     return $2 & 1 | 0 | 0;
    }
    core__panicking__panic_bounds_check__h808b524af17640b1($2 | 0, 19 | 0, 1152940 | 0);
    abort();
   }
   core__panicking__panic_bounds_check__h808b524af17640b1($1 | 0, 19 | 0, 1152972 | 0);
   abort();
  }
  core__panicking__panic_bounds_check__h808b524af17640b1($3 | 0, 283 | 0, 1152956 | 0);
  abort();
 }
 
 function alloc__collections__btree__map__entry__VacantEntry_K_2cV___insert__hf8bedac3dc581ec2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $5 = 0, $8 = 0, $4 = 0, i64toi32_i32$1 = 0, $3 = 0, $6 = 0, $7 = 0;
  $2 = global$0 - 336 | 0;
  global$0 = $2;
  HEAP32[(($2 + 240 | 0) + 8 | 0) >> 2] = HEAP32[($0 + 56 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($0 + 52 | 0) >> 2] | 0;
  HEAP32[($2 + 240 | 0) >> 2] = HEAP32[($0 + 48 | 0) >> 2] | 0;
  HEAP32[($2 + 244 | 0) >> 2] = i64toi32_i32$1;
  memcpy($2 + 288 | 0 | 0, $0 | 0, 48 | 0) | 0;
  memcpy($2 + 136 | 0 | 0, $1 | 0, 48 | 0) | 0;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_recursing__h8f240b47fb2e4ef5($2 + 8 | 0 | 0, $2 + 240 | 0 | 0, $2 + 288 | 0 | 0, $2 + 136 | 0 | 0);
  $3 = HEAP32[($2 + 128 | 0) >> 2] | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     $0 = HEAP32[($0 + 60 | 0) >> 2] | 0;
     HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
     break label$2;
    }
    $4 = ($2 + 8 | 0) + 8 | 0;
    memcpy($2 + 136 | 0 | 0, $4 | 0, 96 | 0) | 0;
    $0 = HEAP32[($0 + 60 | 0) >> 2] | 0;
    $5 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    if (!$5) {
     break label$1
    }
    $6 = HEAP32[($2 + 124 | 0) >> 2] | 0;
    $7 = HEAP32[($2 + 120 | 0) >> 2] | 0;
    $8 = HEAP32[$0 >> 2] | 0;
    $1 = alloc__boxed__Box_T_2cA___new_uninit_in__hf8493d13156d19ba() | 0;
    HEAP32[($1 + 1064 | 0) >> 2] = $5;
    HEAP16[($1 + 1062 | 0) >> 1] = 0;
    HEAP32[($1 + 1056 | 0) >> 2] = 0;
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    $8 = $8 + 1 | 0;
    HEAP32[$0 >> 2] = $8;
    HEAP16[($5 + 1060 | 0) >> 1] = 0;
    HEAP32[($5 + 1056 | 0) >> 2] = $1;
    HEAP32[($2 + 236 | 0) >> 2] = $1;
    HEAP32[($2 + 232 | 0) >> 2] = $8;
    memcpy($2 + 240 | 0 | 0, $4 | 0, 48 | 0) | 0;
    memcpy($2 + 288 | 0 | 0, ($2 + 136 | 0) + 48 | 0 | 0, 48 | 0) | 0;
    alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal___push__h8e97906a7bbaaf79($2 + 232 | 0 | 0, $2 + 240 | 0 | 0, $2 + 288 | 0 | 0, $7 | 0, $6 | 0);
    HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
   }
   global$0 = $2 + 336 | 0;
   return $3 | 0;
  }
  core__panicking__panic__h2fd385a887c8bf13(1072048 | 0, 43 | 0, 1072248 | 0);
  abort();
 }
 
 function $_mut_20W_20as_20core__fmt__Write___write_char__h69954a901e174650($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $0 = HEAP32[$0 >> 2] | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ($1 >>> 0 < 128 >>> 0) {
       break label$4
      }
      HEAP32[($2 + 12 | 0) >> 2] = 0;
      if ($1 >>> 0 >= 2048 >>> 0) {
       break label$3
      }
      HEAP8[($2 + 13 | 0) >> 0] = $1 & 63 | 0 | 128 | 0;
      HEAP8[($2 + 12 | 0) >> 0] = $1 >>> 6 | 0 | 192 | 0;
      $1 = 2;
      break label$2;
     }
     label$5 : {
      $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
      if (($3 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
       break label$5
      }
      alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hc5a84431bcb0aafc($0 | 0, $3 | 0, 1 | 0);
      $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
     }
     HEAP32[($0 + 8 | 0) >> 2] = $3 + 1 | 0;
     HEAP8[((HEAP32[$0 >> 2] | 0) + $3 | 0) >> 0] = $1;
     break label$1;
    }
    label$6 : {
     if ($1 >>> 0 < 65536 >>> 0) {
      break label$6
     }
     HEAP8[($2 + 15 | 0) >> 0] = $1 & 63 | 0 | 128 | 0;
     HEAP8[($2 + 12 | 0) >> 0] = $1 >>> 18 | 0 | 240 | 0;
     HEAP8[($2 + 14 | 0) >> 0] = ($1 >>> 6 | 0) & 63 | 0 | 128 | 0;
     HEAP8[($2 + 13 | 0) >> 0] = ($1 >>> 12 | 0) & 63 | 0 | 128 | 0;
     $1 = 4;
     break label$2;
    }
    HEAP8[($2 + 14 | 0) >> 0] = $1 & 63 | 0 | 128 | 0;
    HEAP8[($2 + 12 | 0) >> 0] = $1 >>> 12 | 0 | 224 | 0;
    HEAP8[($2 + 13 | 0) >> 0] = ($1 >>> 6 | 0) & 63 | 0 | 128 | 0;
    $1 = 3;
   }
   label$7 : {
    $4 = $0 + 8 | 0;
    $3 = HEAP32[$4 >> 2] | 0;
    if (((HEAP32[($0 + 4 | 0) >> 2] | 0) - $3 | 0) >>> 0 >= $1 >>> 0) {
     break label$7
    }
    alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hc5a84431bcb0aafc($0 | 0, $3 | 0, $1 | 0);
    $3 = HEAP32[$4 >> 2] | 0;
   }
   memcpy((HEAP32[$0 >> 2] | 0) + $3 | 0 | 0, $2 + 12 | 0 | 0, $1 | 0) | 0;
   HEAP32[$4 >> 2] = $3 + $1 | 0;
  }
  global$0 = $2 + 16 | 0;
  return 0 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert__h60bbba19db10f7c2($0, $1, $2, $3, $3$hi, $4, $4$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  $4 = $4 | 0;
  $4$hi = $4$hi | 0;
  var $5 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $6 = 0, $7 = 0, $8 = 0, $55 = 0, $92 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $5 = global$0 - 128 | 0;
  global$0 = $5;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $6 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      if ((HEAPU16[($6 + 314 | 0) >> 1] | 0) >>> 0 < 11 >>> 0) {
       break label$4
      }
      alloc__collections__btree__node__splitpoint__h8424344594b4deb1($5 + 72 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
      $7 = HEAP32[($5 + 80 | 0) >> 2] | 0;
      $8 = HEAP32[($5 + 76 | 0) >> 2] | 0;
      $1 = HEAP32[$1 >> 2] | 0;
      HEAP32[($5 + 80 | 0) >> 2] = HEAP32[($5 + 72 | 0) >> 2] | 0;
      HEAP32[($5 + 76 | 0) >> 2] = $6;
      HEAP32[($5 + 72 | 0) >> 2] = $1;
      alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__KV___split__hf19ab977dedf2ecc($5 + 8 | 0 | 0, $5 + 72 | 0 | 0);
      if (($8 | 0) == (1 | 0)) {
       break label$3
      }
      HEAP32[($5 + 56 | 0) >> 2] = HEAP32[($5 + 40 | 0) >> 2] | 0;
      $1 = HEAP32[($5 + 44 | 0) >> 2] | 0;
      break label$2;
     }
     HEAP32[(($5 + 72 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
     $55 = i64toi32_i32$0;
     i64toi32_i32$0 = $5;
     HEAP32[($5 + 72 | 0) >> 2] = $55;
     HEAP32[($5 + 76 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $3$hi;
     i64toi32_i32$1 = $4$hi;
     i64toi32_i32$1 = $3$hi;
     i64toi32_i32$0 = $4$hi;
     (wasm2js_i32$0 = $0, wasm2js_i32$1 = alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_fit__hd4852592681d8c60($1 | 0, $5 + 72 | 0 | 0, $3 | 0, i64toi32_i32$1 | 0, $4 | 0, i64toi32_i32$0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 56 | 0) >> 2] = wasm2js_i32$1;
     HEAP32[($0 + 8 | 0) >> 2] = $6;
     HEAP32[$0 >> 2] = 0;
     HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
     HEAP32[($0 + 4 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
     break label$1;
    }
    HEAP32[($5 + 56 | 0) >> 2] = HEAP32[($5 + 48 | 0) >> 2] | 0;
    $1 = HEAP32[($5 + 52 | 0) >> 2] | 0;
   }
   HEAP32[($5 + 64 | 0) >> 2] = $7;
   HEAP32[($5 + 60 | 0) >> 2] = $1;
   HEAP32[(($5 + 72 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $92 = i64toi32_i32$0;
   i64toi32_i32$0 = $5;
   HEAP32[($5 + 72 | 0) >> 2] = $92;
   HEAP32[($5 + 76 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $3$hi;
   i64toi32_i32$1 = $4$hi;
   i64toi32_i32$1 = $3$hi;
   i64toi32_i32$0 = $4$hi;
   $1 = alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_fit__hd4852592681d8c60($5 + 56 | 0 | 0, $5 + 72 | 0 | 0, $3 | 0, i64toi32_i32$1 | 0, $4 | 0, $4$hi | 0) | 0;
   memcpy(($5 + 72 | 0) + 4 | 0 | 0, $5 + 8 | 0 | 0, 48 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
   memcpy($0 + 4 | 0 | 0, $5 + 72 | 0 | 0, 52 | 0) | 0;
   HEAP32[($0 + 56 | 0) >> 2] = $1;
  }
  global$0 = $5 + 128 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert_fit__h37f60ac01916eff0($0, $1, $2, $2$hi, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $7 = 0, $5 = 0, $8 = 0, $9 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $6 = 0, $10 = 0, $11 = 0, $31 = 0, $60 = 0;
  $5 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $0 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  $6 = Math_imul($0, 12);
  $7 = ($5 + $6 | 0) + 92 | 0;
  label$1 : {
   label$2 : {
    $8 = $0 + 1 | 0;
    $9 = HEAPU16[($5 + 226 | 0) >> 1] | 0;
    if ($8 >>> 0 <= $9 >>> 0) {
     break label$2
    }
    i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $31 = i64toi32_i32$0;
    i64toi32_i32$0 = $7;
    HEAP32[$7 >> 2] = $31;
    HEAP32[($7 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($7 + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
    break label$1;
   }
   $10 = $5 + 92 | 0;
   $11 = $9 - $0 | 0;
   memmove($10 + Math_imul($8, 12) | 0 | 0, $7 | 0, Math_imul($11, 12) | 0) | 0;
   $7 = $10 + $6 | 0;
   HEAP32[($7 + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   $60 = i64toi32_i32$1;
   i64toi32_i32$1 = $7;
   HEAP32[$7 >> 2] = $60;
   HEAP32[($7 + 4 | 0) >> 2] = i64toi32_i32$0;
   memmove($5 + ($8 << 3 | 0) | 0 | 0, $5 + ($0 << 3 | 0) | 0 | 0, $11 << 3 | 0 | 0) | 0;
  }
  $1 = $9 + 1 | 0;
  i64toi32_i32$0 = $2$hi;
  i64toi32_i32$1 = $5 + ($0 << 3 | 0) | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $2;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  label$3 : {
   $6 = $0 + 2 | 0;
   $7 = $9 + 2 | 0;
   if ($6 >>> 0 >= $7 >>> 0) {
    break label$3
   }
   $10 = $5 + 232 | 0;
   memmove($10 + ($6 << 2 | 0) | 0 | 0, $10 + ($8 << 2 | 0) | 0 | 0, ($9 - $0 | 0) << 2 | 0 | 0) | 0;
  }
  HEAP32[(($5 + ($8 << 2 | 0) | 0) + 232 | 0) >> 2] = $4;
  HEAP16[($5 + 226 | 0) >> 1] = $1;
  label$4 : {
   if ($8 >>> 0 >= $7 >>> 0) {
    break label$4
   }
   $1 = $9 + 1 | 0;
   $8 = (($0 << 2 | 0) + $5 | 0) + 236 | 0;
   label$5 : while (1) {
    $9 = HEAP32[$8 >> 2] | 0;
    $0 = $0 + 1 | 0;
    HEAP16[($9 + 224 | 0) >> 1] = $0;
    HEAP32[($9 + 88 | 0) >> 2] = $5;
    $8 = $8 + 4 | 0;
    if (($1 | 0) != ($0 | 0)) {
     continue label$5
    }
    break label$5;
   };
  }
 }
 
 function cryptoxide__curve25519__fe__fe64__Fe__to_bytes__h64ae4f7608fd99b8($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, $3 = 0, $3$hi = 0, $4 = 0, $4$hi = 0, $5 = 0, $5$hi = 0, $6 = 0, $6$hi = 0, $2 = 0, $44 = 0, $45 = 0, $47 = 0, $48 = 0, $50 = 0, $51 = 0, $53 = 0, $54 = 0, $56 = 0, $57 = 0, $59 = 0, $60 = 0, $62 = 0, $63 = 0, $64 = 0, $65 = 0, $67 = 0, $68 = 0, $70 = 0, $71 = 0, $73 = 0, $74 = 0, $76 = 0, $77 = 0, $79 = 0, $80 = 0, $82 = 0, $83 = 0, $18 = 0, $23 = 0, $26 = 0, $29 = 0, $32 = 0, $35 = 0, $38 = 0, $43 = 0, $46 = 0, $49 = 0, $52 = 0, $55 = 0, $58 = 0, $61 = 0, $66 = 0, $69 = 0, $72 = 0, $75 = 0, $78 = 0, $81 = 0, $84 = 0, $89 = 0, $92 = 0, $95 = 0, $98 = 0, $101 = 0, $104 = 0, $107 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  cryptoxide__curve25519__fe__fe64__Fe__to_packed__h856c6b32110c5ed6($2 | 0, $1 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $3 = i64toi32_i32$0;
  $3$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $4 = i64toi32_i32$1;
  $4$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$1;
  $18 = $0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $6 = i64toi32_i32$1;
  $6$hi = i64toi32_i32$0;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $44 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $44 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($18 + 31 | 0) >> 0] = $44;
  $23 = $0;
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$0 = $6;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 48;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $45 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   $45 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($23 + 30 | 0) >> 0] = $45;
  $26 = $0;
  i64toi32_i32$2 = $6$hi;
  i64toi32_i32$1 = $6;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 40;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $47 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   $47 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($26 + 29 | 0) >> 0] = $47;
  $29 = $0;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$2 = $6;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $48 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $48 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($29 + 28 | 0) >> 0] = $48;
  $32 = $0;
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$0 = $6;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 24;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $50 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   $50 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($32 + 27 | 0) >> 0] = $50;
  $35 = $0;
  i64toi32_i32$2 = $6$hi;
  i64toi32_i32$1 = $6;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 16;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $51 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   $51 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($35 + 26 | 0) >> 0] = $51;
  $38 = $0;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$2 = $6;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 8;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $53 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $53 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($38 + 25 | 0) >> 0] = $53;
  i64toi32_i32$1 = $6$hi;
  HEAP8[($0 + 24 | 0) >> 0] = $6;
  $43 = $0;
  i64toi32_i32$1 = $5$hi;
  i64toi32_i32$0 = $5;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $54 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   $54 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($43 + 23 | 0) >> 0] = $54;
  $46 = $0;
  i64toi32_i32$2 = $5$hi;
  i64toi32_i32$1 = $5;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 48;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $56 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   $56 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($46 + 22 | 0) >> 0] = $56;
  $49 = $0;
  i64toi32_i32$0 = $5$hi;
  i64toi32_i32$2 = $5;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 40;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $57 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $57 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($49 + 21 | 0) >> 0] = $57;
  $52 = $0;
  i64toi32_i32$1 = $5$hi;
  i64toi32_i32$0 = $5;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $59 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   $59 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($52 + 20 | 0) >> 0] = $59;
  $55 = $0;
  i64toi32_i32$2 = $5$hi;
  i64toi32_i32$1 = $5;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 24;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $60 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   $60 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($55 + 19 | 0) >> 0] = $60;
  $58 = $0;
  i64toi32_i32$0 = $5$hi;
  i64toi32_i32$2 = $5;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 16;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $62 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $62 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($58 + 18 | 0) >> 0] = $62;
  $61 = $0;
  i64toi32_i32$1 = $5$hi;
  i64toi32_i32$0 = $5;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 8;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $63 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   $63 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($61 + 17 | 0) >> 0] = $63;
  i64toi32_i32$2 = $5$hi;
  HEAP8[($0 + 16 | 0) >> 0] = $5;
  $66 = $0;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$1 = $4;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $64 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   $64 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($66 + 15 | 0) >> 0] = $64;
  $69 = $0;
  i64toi32_i32$0 = $4$hi;
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 48;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $65 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $65 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($69 + 14 | 0) >> 0] = $65;
  $72 = $0;
  i64toi32_i32$1 = $4$hi;
  i64toi32_i32$0 = $4;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 40;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $67 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   $67 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($72 + 13 | 0) >> 0] = $67;
  $75 = $0;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$1 = $4;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $68 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   $68 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($75 + 12 | 0) >> 0] = $68;
  $78 = $0;
  i64toi32_i32$0 = $4$hi;
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 24;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $70 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $70 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($78 + 11 | 0) >> 0] = $70;
  $81 = $0;
  i64toi32_i32$1 = $4$hi;
  i64toi32_i32$0 = $4;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 16;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $71 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   $71 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($81 + 10 | 0) >> 0] = $71;
  $84 = $0;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$1 = $4;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 8;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $73 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   $73 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($84 + 9 | 0) >> 0] = $73;
  i64toi32_i32$0 = $4$hi;
  HEAP8[($0 + 8 | 0) >> 0] = $4;
  $89 = $0;
  i64toi32_i32$0 = $3$hi;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $74 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $74 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($89 + 7 | 0) >> 0] = $74;
  $92 = $0;
  i64toi32_i32$1 = $3$hi;
  i64toi32_i32$0 = $3;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 48;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $76 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   $76 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($92 + 6 | 0) >> 0] = $76;
  $95 = $0;
  i64toi32_i32$2 = $3$hi;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 40;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $77 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   $77 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($95 + 5 | 0) >> 0] = $77;
  $98 = $0;
  i64toi32_i32$0 = $3$hi;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $79 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $79 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($98 + 4 | 0) >> 0] = $79;
  $101 = $0;
  i64toi32_i32$1 = $3$hi;
  i64toi32_i32$0 = $3;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 24;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $80 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   $80 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($101 + 3 | 0) >> 0] = $80;
  $104 = $0;
  i64toi32_i32$2 = $3$hi;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 16;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $82 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   $82 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($104 + 2 | 0) >> 0] = $82;
  $107 = $0;
  i64toi32_i32$0 = $3$hi;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 8;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $83 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $83 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  HEAP8[($107 + 1 | 0) >> 0] = $83;
  i64toi32_i32$1 = $3$hi;
  HEAP8[$0 >> 0] = $3;
  global$0 = $2 + 32 | 0;
 }
 
 function cardano_serialization_lib__metadata__MetadataMap__get__hfdac1fad098610ea($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $24 = 0, $30 = 0;
  $3 = global$0 - 96 | 0;
  global$0 = $3;
  HEAP32[($3 + 20 | 0) >> 2] = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $2 = linked_hash_map__LinkedHashMap_K_2cV_2cS___get__hcef7f07b6e3b104a($1 | 0, $2 | 0) | 0;
      if (!$2) {
       break label$4
      }
      label$5 : {
       switch (HEAP32[$2 >> 2] | 0 | 0) {
       case 1:
        $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hf69db734dd831996($3 + 24 | 0 | 4 | 0 | 0, $2 + 4 | 0 | 0);
        $1 = 1;
        break label$2;
       case 2:
        i64toi32_i32$2 = $2;
        i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
        $24 = i64toi32_i32$0;
        i64toi32_i32$0 = $3 + 32 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $24;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$2 = $2 + 16 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $30 = i64toi32_i32$1;
        i64toi32_i32$1 = ($3 + 24 | 0) + 16 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $30;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        $1 = 2;
        break label$2;
       case 3:
        $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($3 + 24 | 0 | 4 | 0 | 0, $2 + 4 | 0 | 0);
        $1 = 3;
        break label$2;
       case 4:
        break label$5;
       default:
        break label$3;
       };
      }
      $1 = 4;
      $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($3 + 24 | 0 | 4 | 0 | 0, $2 + 4 | 0 | 0);
      break label$2;
     }
     $2 = 1;
     HEAP32[($3 + 44 | 0) >> 2] = 1;
     i64toi32_i32$1 = $3;
     i64toi32_i32$0 = 0;
     HEAP32[($3 + 28 | 0) >> 2] = 2;
     HEAP32[($3 + 32 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($3 + 24 | 0) >> 2] = 1060164;
     HEAP32[($3 + 92 | 0) >> 2] = 64;
     HEAP32[($3 + 40 | 0) >> 2] = $3 + 88 | 0;
     HEAP32[($3 + 88 | 0) >> 2] = $3 + 20 | 0;
     alloc__fmt__format__h6e9e003a52c07309($3 + 72 | 0 | 0, $3 + 24 | 0 | 0);
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $3 + 72 | 0 | 0);
     $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($3 + 8 | 0) >> 2] | 0 | 0, HEAP32[($3 + 12 | 0) >> 2] | 0 | 0) | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 72 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 72 | 0 | 0);
     HEAP32[($0 + 4 | 0) >> 2] = $1;
     break label$1;
    }
    $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__hdeea20968268d729(($3 + 24 | 0) + 8 | 0 | 0, $2 + 8 | 0 | 0);
    $1 = 0;
   }
   memcpy($0 + 12 | 0 | 0, $3 + 24 | 0 | 4 | 0 | 0, 44 | 0) | 0;
   HEAP32[($0 + 8 | 0) >> 2] = $1;
   $2 = 0;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $3 + 96 | 0;
 }
 
 function $cardano_serialization_lib__chain_crypto__sign__Signature_T_2cA__20as_20core__str__traits__FromStr___from_str__h0b50509d65ede561($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $7 = 0, $8 = 0, $9 = 0, $73 = 0;
  $3 = global$0 - 144 | 0;
  global$0 = $3;
  $alloc__vec__Vec_u8__20as_20hex__FromHex___from_hex__h4bc81c912cf347f6($3 + 80 | 0 | 0, $1 | 0, $2 | 0);
  $1 = HEAP32[(($3 + 80 | 0) + 8 | 0) >> 2] | 0;
  $2 = HEAP32[($3 + 84 | 0) >> 2] | 0;
  label$1 : {
   label$2 : {
    if ((HEAP32[($3 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    HEAP32[($3 + 20 | 0) >> 2] = $1;
    HEAP32[($3 + 16 | 0) >> 2] = $2;
    HEAP32[($3 + 24 | 0) >> 2] = HEAP32[(($3 + 80 | 0) + 12 | 0) >> 2] | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $3 + 16 | 0 | 0);
    label$3 : {
     label$4 : {
      $1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
      if (($1 | 0) != (64 | 0)) {
       break label$4
      }
      $2 = HEAP32[($3 + 8 | 0) >> 2] | 0;
      $1 = 0;
      memset($3 + 80 | 0 | 0, 0 | 0, 64 | 0) | 0;
      core__slice___impl_20_5bT_5d___clone_from_slice__h1742dfbd5d5d9efd($3 + 80 | 0 | 0, 64 | 0, $2 | 0, 64 | 0);
      HEAP8[($0 + 3 | 0) >> 0] = HEAPU8[($3 + 82 | 0) >> 0] | 0;
      $9 = HEAPU8[($3 + 80 | 0) >> 0] | 0 | ((HEAPU8[($3 + 81 | 0) >> 0] | 0) << 8 | 0) | 0;
      HEAP8[($0 + 1 | 0) >> 0] = $9;
      HEAP8[($0 + 2 | 0) >> 0] = $9 >>> 8 | 0;
      i64toi32_i32$0 = HEAPU8[($3 + 83 | 0) >> 0] | 0 | ((HEAPU8[($3 + 84 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 85 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 86 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[($3 + 87 | 0) >> 0] | 0 | ((HEAPU8[($3 + 88 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 89 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 90 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $2 = HEAPU8[($3 + 91 | 0) >> 0] | 0 | ((HEAPU8[($3 + 92 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 93 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 94 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      memcpy($3 + 28 | 0 | 0, $3 + 95 | 0 | 0, 49 | 0) | 0;
      memcpy($0 + 16 | 0 | 0, $3 + 28 | 0 | 0, 49 | 0) | 0;
      $7 = $0 + 12 | 0;
      HEAP8[$7 >> 0] = $2;
      HEAP8[($7 + 1 | 0) >> 0] = $2 >>> 8 | 0;
      HEAP8[($7 + 2 | 0) >> 0] = $2 >>> 16 | 0;
      HEAP8[($7 + 3 | 0) >> 0] = $2 >>> 24 | 0;
      $73 = i64toi32_i32$0;
      i64toi32_i32$0 = $0 + 4 | 0;
      $8 = $73;
      HEAP8[i64toi32_i32$0 >> 0] = $8;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $8 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $8 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $8 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      break label$3;
     }
     HEAP32[($0 + 16 | 0) >> 2] = $1;
     HEAP32[($0 + 12 | 0) >> 2] = 64;
     i64toi32_i32$0 = $0 + 4 | 0;
     i64toi32_i32$1 = 0;
     HEAP32[i64toi32_i32$0 >> 2] = 1;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     $1 = 1;
    }
    HEAP8[$0 >> 0] = $1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 16 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 16 | 0 | 0);
    break label$1;
   }
   HEAP8[$0 >> 0] = 1;
   HEAP32[($0 + 12 | 0) >> 2] = $1;
   HEAP32[($0 + 8 | 0) >> 2] = $2;
   HEAP32[($0 + 4 | 0) >> 2] = 0;
  }
  global$0 = $3 + 144 | 0;
 }
 
 function core__slice__memchr__memrchr__h18f8a2030f79e6f7($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $5 = 0, $7 = 0, $6 = 0, $8 = 0, $9 = 0, $10 = 0;
  $4 = 0;
  $5 = (($2 + 3 | 0) & -4 | 0) - $2 | 0;
  $6 = $3 >>> 0 < $5 >>> 0;
  $7 = $6 ? 0 : ($3 - $5 | 0) & 7 | 0;
  $8 = $3 - $7 | 0;
  label$1 : {
   label$2 : {
    if ($3 >>> 0 < $7 >>> 0) {
     break label$2
    }
    $9 = $6 ? $3 : $5;
    $6 = ($3 + $2 | 0) + -1 | 0;
    $10 = $1 & 255 | 0;
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : while (1) {
        if (!($7 + $4 | 0)) {
         break label$5
        }
        $5 = $6 + $4 | 0;
        $4 = $4 + -1 | 0;
        if ((HEAPU8[$5 >> 0] | 0 | 0) != ($10 | 0)) {
         continue label$6
        }
        break label$6;
       };
       $4 = $3 + $4 | 0;
       break label$4;
      }
      $5 = Math_imul($1 & 255 | 0, 16843009);
      label$7 : {
       label$8 : while (1) {
        $4 = $8;
        if ($4 >>> 0 <= $9 >>> 0) {
         break label$7
        }
        $8 = $4 + -8 | 0;
        $7 = $2 + $4 | 0;
        $6 = (HEAP32[($7 + -4 | 0) >> 2] | 0) ^ $5 | 0;
        $7 = (HEAP32[($7 + -8 | 0) >> 2] | 0) ^ $5 | 0;
        if (!((($6 ^ -1 | 0) & ($6 + -16843009 | 0) | 0 | (($7 ^ -1 | 0) & ($7 + -16843009 | 0) | 0) | 0) & -2139062144 | 0)) {
         continue label$8
        }
        break label$8;
       };
      }
      if ($4 >>> 0 > $3 >>> 0) {
       break label$1
      }
      $7 = $2 + -1 | 0;
      $8 = $1 & 255 | 0;
      label$9 : while (1) {
       label$10 : {
        if ($4) {
         break label$10
        }
        $5 = 0;
        break label$3;
       }
       $5 = $7 + $4 | 0;
       $4 = $4 + -1 | 0;
       if ((HEAPU8[$5 >> 0] | 0 | 0) != ($8 | 0)) {
        continue label$9
       }
       break label$9;
      };
     }
     $5 = 1;
    }
    HEAP32[($0 + 4 | 0) >> 2] = $4;
    HEAP32[$0 >> 2] = $5;
    return;
   }
   core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($8 | 0, $3 | 0, 1150672 | 0);
   abort();
  }
  core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($4 | 0, $3 | 0, 1150688 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert__h1ee3485b018e040d($0, $1, $2, $3, $3$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $5 = 0, $6 = 0, $7 = 0, $54 = 0, $90 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $4 = global$0 - 112 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $5 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      if ((HEAPU16[($5 + 226 | 0) >> 1] | 0) >>> 0 < 11 >>> 0) {
       break label$4
      }
      alloc__collections__btree__node__splitpoint__h8424344594b4deb1($4 + 64 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
      $6 = HEAP32[($4 + 72 | 0) >> 2] | 0;
      $7 = HEAP32[($4 + 68 | 0) >> 2] | 0;
      $1 = HEAP32[$1 >> 2] | 0;
      HEAP32[($4 + 72 | 0) >> 2] = HEAP32[($4 + 64 | 0) >> 2] | 0;
      HEAP32[($4 + 68 | 0) >> 2] = $5;
      HEAP32[($4 + 64 | 0) >> 2] = $1;
      alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__KV___split__hba48e584646231bf($4 + 8 | 0 | 0, $4 + 64 | 0 | 0);
      if (($7 | 0) == (1 | 0)) {
       break label$3
      }
      HEAP32[($4 + 48 | 0) >> 2] = HEAP32[($4 + 32 | 0) >> 2] | 0;
      $1 = HEAP32[($4 + 36 | 0) >> 2] | 0;
      break label$2;
     }
     HEAP32[(($4 + 64 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
     $54 = i64toi32_i32$0;
     i64toi32_i32$0 = $4;
     HEAP32[($4 + 64 | 0) >> 2] = $54;
     HEAP32[($4 + 68 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $3$hi;
     (wasm2js_i32$0 = $0, wasm2js_i32$1 = alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_fit__hce777c9c912093df($1 | 0, $4 + 64 | 0 | 0, $3 | 0, i64toi32_i32$1 | 0) | 0), HEAP32[(wasm2js_i32$0 + 48 | 0) >> 2] = wasm2js_i32$1;
     HEAP32[($0 + 8 | 0) >> 2] = $5;
     HEAP32[$0 >> 2] = 0;
     HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
     HEAP32[($0 + 4 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
     break label$1;
    }
    HEAP32[($4 + 48 | 0) >> 2] = HEAP32[($4 + 40 | 0) >> 2] | 0;
    $1 = HEAP32[($4 + 44 | 0) >> 2] | 0;
   }
   HEAP32[($4 + 56 | 0) >> 2] = $6;
   HEAP32[($4 + 52 | 0) >> 2] = $1;
   HEAP32[(($4 + 64 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $90 = i64toi32_i32$1;
   i64toi32_i32$1 = $4;
   HEAP32[($4 + 64 | 0) >> 2] = $90;
   HEAP32[($4 + 68 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $3$hi;
   $1 = alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_fit__hce777c9c912093df($4 + 48 | 0 | 0, $4 + 64 | 0 | 0, $3 | 0, i64toi32_i32$0 | 0) | 0;
   memcpy(($4 + 64 | 0) + 4 | 0 | 0, $4 + 8 | 0 | 0, 40 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
   memcpy($0 + 4 | 0 | 0, $4 + 64 | 0 | 0, 44 | 0) | 0;
   HEAP32[($0 + 48 | 0) >> 2] = $1;
  }
  global$0 = $4 + 112 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__UnitInterval___deserialize_as_embedded_group__hd6b16b3f4b8f1ba1($0, $1, $2, $2$hi, $3, $3$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  var $4 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $5 = 0, $5$hi = 0, $6 = 0, $6$hi = 0;
  $4 = global$0 - 256 | 0;
  global$0 = $4;
  $cardano_serialization_lib__utils__BigNum_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h29637bb571dceb02($4 + 184 | 0 | 0, $1 | 0);
  i64toi32_i32$0 = 0;
  $5 = 1;
  $5$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[($4 + 192 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($4 + 196 | 0) >> 2] | 0;
  $6 = i64toi32_i32$0;
  $6$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 184 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($4 + 188 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    i64toi32_i32$3 = 1;
    if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
     break label$2
    }
    $cardano_serialization_lib__utils__BigNum_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h29637bb571dceb02($4 + 184 | 0 | 0, $1 | 0);
    i64toi32_i32$3 = $4;
    i64toi32_i32$2 = HEAP32[($4 + 192 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($4 + 196 | 0) >> 2] | 0;
    $5 = i64toi32_i32$2;
    $5$hi = i64toi32_i32$0;
    label$3 : {
     i64toi32_i32$3 = $4;
     i64toi32_i32$0 = HEAP32[($4 + 184 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[($4 + 188 | 0) >> 2] | 0;
     i64toi32_i32$3 = i64toi32_i32$0;
     i64toi32_i32$0 = 0;
     i64toi32_i32$1 = 1;
     if ((i64toi32_i32$3 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) | 0) {
      break label$3
     }
     i64toi32_i32$3 = $5$hi;
     i64toi32_i32$2 = $0 + 16 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $5;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$3 = $6$hi;
     i64toi32_i32$2 = $0;
     HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $6;
     HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$3 = 0;
     $5 = 0;
     $5$hi = i64toi32_i32$3;
     break label$1;
    }
    memcpy($4 + 128 | 0 | 0, ($4 + 184 | 0) + 16 | 0 | 0, 56 | 0) | 0;
    memcpy($4 + 72 | 0 | 0, $4 + 128 | 0 | 0, 56 | 0) | 0;
    i64toi32_i32$3 = $5$hi;
    i64toi32_i32$2 = $4;
    HEAP32[($4 + 184 | 0) >> 2] = $5;
    HEAP32[($4 + 188 | 0) >> 2] = i64toi32_i32$3;
    memcpy(($4 + 184 | 0) + 8 | 0 | 0, $4 + 72 | 0 | 0, 56 | 0) | 0;
    cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($4 + 8 | 0 | 0, $4 + 184 | 0 | 0, 1050249 | 0, 11 | 0);
    i64toi32_i32$1 = $4;
    i64toi32_i32$3 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    $5 = i64toi32_i32$3;
    $5$hi = i64toi32_i32$2;
    memcpy($0 + 16 | 0 | 0, $4 + 16 | 0 | 0, 56 | 0) | 0;
    i64toi32_i32$3 = $0;
    HEAP32[(i64toi32_i32$3 + 8 | 0) >> 2] = $5;
    HEAP32[(i64toi32_i32$3 + 12 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = 0;
    $5 = 1;
    $5$hi = i64toi32_i32$2;
    break label$1;
   }
   memcpy($4 + 128 | 0 | 0, ($4 + 184 | 0) + 16 | 0 | 0, 56 | 0) | 0;
   memcpy($4 + 72 | 0 | 0, $4 + 128 | 0 | 0, 56 | 0) | 0;
   i64toi32_i32$2 = $6$hi;
   i64toi32_i32$3 = $4;
   HEAP32[($4 + 184 | 0) >> 2] = $6;
   HEAP32[($4 + 188 | 0) >> 2] = i64toi32_i32$2;
   memcpy(($4 + 184 | 0) + 8 | 0 | 0, $4 + 72 | 0 | 0, 56 | 0) | 0;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($4 + 8 | 0 | 0, $4 + 184 | 0 | 0, 1050240 | 0, 9 | 0);
   i64toi32_i32$1 = $4;
   i64toi32_i32$2 = HEAP32[($4 + 8 | 0) >> 2] | 0;
   i64toi32_i32$3 = HEAP32[($4 + 12 | 0) >> 2] | 0;
   $6 = i64toi32_i32$2;
   $6$hi = i64toi32_i32$3;
   memcpy($0 + 16 | 0 | 0, $4 + 16 | 0 | 0, 56 | 0) | 0;
   i64toi32_i32$2 = $0;
   HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $6;
   HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$3;
  }
  i64toi32_i32$3 = $5$hi;
  i64toi32_i32$2 = $0;
  HEAP32[i64toi32_i32$2 >> 2] = $5;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
  global$0 = $4 + 256 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__Assets___serialize__hdca9801c50eb469f($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $4 = 0, $32 = 0, $39 = 0, $42 = 0;
  $3 = global$0 - 128 | 0;
  global$0 = $3;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 + 80 | 0 | 0, $2 | 0, 5 | 0, i64toi32_i32$0 | 0, i64toi32_i32$1 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ((HEAP32[($3 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
        break label$5
       }
       alloc__collections__btree__map__BTreeMap_K_2cV___iter__ha89c9458aca0228d($3 + 16 | 0 | 0, $1 | 0);
       HEAP32[(($3 + 48 | 0) + 24 | 0) >> 2] = HEAP32[(($3 + 16 | 0) + 24 | 0) >> 2] | 0;
       i64toi32_i32$2 = ($3 + 16 | 0) + 16 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $32 = i64toi32_i32$1;
       i64toi32_i32$1 = ($3 + 48 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $32;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = ($3 + 16 | 0) + 8 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $39 = i64toi32_i32$0;
       i64toi32_i32$0 = ($3 + 48 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $39;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $3;
       i64toi32_i32$1 = HEAP32[($3 + 16 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[($3 + 20 | 0) >> 2] | 0;
       $42 = i64toi32_i32$1;
       i64toi32_i32$1 = $3;
       HEAP32[($3 + 48 | 0) >> 2] = $42;
       HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$0;
       $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h36ca092f81b9a0fa($3 + 8 | 0 | 0, $3 + 48 | 0 | 0);
       label$6 : {
        $1 = HEAP32[($3 + 8 | 0) >> 2] | 0;
        if (!$1) {
         break label$6
        }
        $4 = HEAP32[($3 + 12 | 0) >> 2] | 0;
        label$7 : while (1) {
         cbor_event__se__Serializer_W___write_bytes__hdbf95a6224c8b5b8($3 + 80 | 0 | 0, $2 | 0, $1 | 0);
         if ((HEAP32[($3 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
          break label$4
         }
         i64toi32_i32$2 = $4;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 + 80 | 0 | 0, $2 | 0, 0 | 0, i64toi32_i32$0 | 0, i64toi32_i32$1 | 0);
         if ((HEAP32[($3 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
          break label$3
         }
         $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h36ca092f81b9a0fa($3 | 0, $3 + 48 | 0 | 0);
         $4 = HEAP32[($3 + 4 | 0) >> 2] | 0;
         $1 = HEAP32[$3 >> 2] | 0;
         if ($1) {
          continue label$7
         }
         break label$7;
        };
       }
       HEAP32[$0 >> 2] = 0;
       HEAP32[($0 + 4 | 0) >> 2] = $2;
       break label$1;
      }
      memcpy($0 + 8 | 0 | 0, ($3 + 80 | 0) + 8 | 0 | 0, 40 | 0) | 0;
      HEAP32[$0 >> 2] = 1;
      break label$1;
     }
     memcpy($0 + 8 | 0 | 0, ($3 + 80 | 0) + 8 | 0 | 0, 40 | 0) | 0;
     break label$2;
    }
    memcpy($0 + 8 | 0 | 0, ($3 + 80 | 0) + 8 | 0 | 0, 40 | 0) | 0;
   }
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $3 + 128 | 0;
 }
 
 function $cardano_serialization_lib__utils__Value_20as_20core__cmp__PartialOrd___partial_cmp__hb371960dec6e8a81($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, $3 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $5 = 0, $4 = 0, $6 = 0, $7 = 0, $6$hi = 0, $7$hi = 0, $65 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  $3 = 0;
  label$1 : {
   $4 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (($4 | 0) != (1 | 0)) {
    break label$1
   }
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($2 | 4 | 0 | 0, $0 + 12 | 0 | 0);
   $3 = 1;
  }
  HEAP32[$2 >> 2] = $3;
  label$2 : {
   label$3 : {
    label$4 : {
     label$5 : {
      label$6 : {
       if ((HEAP32[($1 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
        break label$6
       }
       $3 = $2 + 16 | 0 | 4 | 0;
       $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($3 | 0, $1 + 12 | 0 | 0);
       HEAP32[($2 + 16 | 0) >> 2] = 1;
       if ((HEAP32[$2 >> 2] | 0 | 0) != (1 | 0)) {
        break label$5
       }
       $5 = $cardano_serialization_lib__MultiAsset_20as_20core__cmp__PartialOrd___partial_cmp__h767e68b80e51259d($2 | 4 | 0 | 0, $3 | 0) | 0;
       break label$4;
      }
      $5 = 0;
      HEAP32[($2 + 16 | 0) >> 2] = 0;
      if (!$4) {
       break label$3
      }
      i64toi32_i32$1 = $2;
      i64toi32_i32$0 = 0;
      HEAP32[($2 + 36 | 0) >> 2] = 0;
      HEAP32[($2 + 40 | 0) >> 2] = i64toi32_i32$0;
      $5 = $cardano_serialization_lib__MultiAsset_20as_20core__cmp__PartialOrd___partial_cmp__h767e68b80e51259d($2 | 4 | 0 | 0, $2 + 32 | 0 | 0) | 0;
      $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 32 | 0 | 0);
      break label$4;
     }
     i64toi32_i32$1 = $2;
     i64toi32_i32$0 = 0;
     HEAP32[($2 + 36 | 0) >> 2] = 0;
     HEAP32[($2 + 40 | 0) >> 2] = i64toi32_i32$0;
     $5 = $cardano_serialization_lib__MultiAsset_20as_20core__cmp__PartialOrd___partial_cmp__h767e68b80e51259d($2 + 32 | 0 | 0, $3 | 0) | 0;
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 32 | 0 | 0);
    }
    $3 = 2;
    if (($5 & 255 | 0 | 0) == (2 | 0)) {
     break label$2
    }
   }
   i64toi32_i32$2 = $0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $6 = i64toi32_i32$0;
   $6$hi = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $7 = i64toi32_i32$1;
   $7$hi = i64toi32_i32$0;
   i64toi32_i32$0 = $6$hi;
   i64toi32_i32$2 = $6;
   i64toi32_i32$1 = $7$hi;
   $65 = (i64toi32_i32$2 | 0) != ($7 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | 0;
   i64toi32_i32$2 = i64toi32_i32$0;
   i64toi32_i32$2 = i64toi32_i32$1;
   i64toi32_i32$2 = i64toi32_i32$0;
   i64toi32_i32$0 = i64toi32_i32$1;
   i64toi32_i32$1 = $7;
   $1 = i64toi32_i32$2 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) & $6 >>> 0 < i64toi32_i32$1 >>> 0 | 0) | 0 ? -1 : $65;
   $3 = 2;
   label$7 : {
    label$8 : {
     switch ((($5 << 24 | 0) >> 24 | 0) + 1 | 0 | 0) {
     case 0:
      switch ($1 + 1 | 0 | 0) {
      case 0:
      case 1:
       break label$7;
      default:
       break label$2;
      };
     case 1:
      $3 = $1;
      break label$2;
     case 2:
      break label$8;
     default:
      break label$2;
     };
    }
    label$11 : {
     switch ($1 | 0) {
     case 0:
     case 1:
      break label$11;
     default:
      break label$2;
     };
    }
    $3 = 1;
    break label$2;
   }
   $3 = 255;
  }
  label$12 : {
   if (!(HEAP32[($2 + 16 | 0) >> 2] | 0)) {
    break label$12
   }
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 16 | 0 | 4 | 0 | 0);
  }
  label$13 : {
   if (!(HEAP32[$2 >> 2] | 0)) {
    break label$13
   }
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 | 4 | 0 | 0);
  }
  global$0 = $2 + 48 | 0;
  return $3 | 0;
 }
 
 function $cardano_serialization_lib__metadata__TransactionMetadatumEnum_20as_20core__hash__Hash___hash__hfff2aa722e4e1880($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, $4$hi = 0, $52 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    switch (HEAP32[$0 >> 2] | 0 | 0) {
    default:
     HEAP32[($2 + 16 | 0) >> 2] = 0;
     $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_1($1 | 0, $2 + 16 | 0 | 0, 4 | 0);
     $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__hash__Hash___hash__had3058f1af5ae20b($0 + 8 | 0 | 0, $1 | 0);
     break label$1;
    case 1:
     HEAP32[($2 + 16 | 0) >> 2] = 1;
     $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_1($1 | 0, $2 + 16 | 0 | 0, 4 | 0);
     $3 = HEAP32[($0 + 4 | 0) >> 2] | 0;
     $0 = HEAP32[($0 + 12 | 0) >> 2] | 0;
     HEAP32[($2 + 16 | 0) >> 2] = $0;
     $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_1($1 | 0, $2 + 16 | 0 | 0, 4 | 0);
     if (!$0) {
      break label$1
     }
     $0 = Math_imul($0, 48);
     label$7 : while (1) {
      $cardano_serialization_lib__metadata__TransactionMetadatumEnum_20as_20core__hash__Hash___hash__hfff2aa722e4e1880($3 | 0, $1 | 0);
      $3 = $3 + 48 | 0;
      $0 = $0 + -48 | 0;
      if ($0) {
       continue label$7
      }
      break label$1;
     };
    case 2:
     HEAP32[($2 + 16 | 0) >> 2] = 2;
     $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_1($1 | 0, $2 + 16 | 0 | 0, 4 | 0);
     i64toi32_i32$2 = $0 + 8 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $4 = i64toi32_i32$0;
     $4$hi = i64toi32_i32$1;
     i64toi32_i32$2 = $0 + 16 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $52 = i64toi32_i32$1;
     i64toi32_i32$1 = $2;
     HEAP32[($2 + 24 | 0) >> 2] = $52;
     HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$0 = $4$hi;
     i64toi32_i32$1 = $2;
     HEAP32[($2 + 16 | 0) >> 2] = $4;
     HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
     $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5($1 | 0, $2 + 16 | 0 | 0, 16 | 0);
     break label$1;
    case 3:
     HEAP32[($2 + 16 | 0) >> 2] = 3;
     $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_1($1 | 0, $2 + 16 | 0 | 0, 4 | 0);
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 | 0, $0 + 4 | 0 | 0);
     $3 = HEAP32[$2 >> 2] | 0;
     $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
     HEAP32[($2 + 16 | 0) >> 2] = $0;
     $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_1($1 | 0, $2 + 16 | 0 | 0, 4 | 0);
     $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_1($1 | 0, $3 | 0, $0 | 0);
     break label$1;
    case 4:
     break label$2;
    };
   }
   HEAP32[($2 + 16 | 0) >> 2] = 4;
   $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_1($1 | 0, $2 + 16 | 0 | 0, 4 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $0 + 4 | 0 | 0);
   $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_1($1 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
   HEAP8[($2 + 16 | 0) >> 0] = 255;
   $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_1($1 | 0, $2 + 16 | 0 | 0, 1 | 0);
  }
  global$0 = $2 + 32 | 0;
 }
 
 function certificate_new_genesis_key_delegation($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $1 = 0, $21 = 0, $22 = 0, $2 = 0, $30 = 0, $36 = 0, $3 = 0, $4 = 0, $4$hi = 0, $5 = 0, $5$hi = 0, $6 = 0, $6$hi = 0, $7 = 0, $7$hi = 0, $55 = 0, $61 = 0, $67 = 0, $84 = 0;
  $1 = global$0 - 304 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h96a5bfd90503076d($1 + 8 | 0 | 0, $0 | 0);
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $21 = $0 + 24 | 0;
  HEAP32[(($1 + 104 | 0) + 24 | 0) >> 2] = HEAPU8[$21 >> 0] | 0 | ((HEAPU8[($21 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($21 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($21 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $0 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 104 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $30;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $0 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 104 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $22 = $0 + 52 | 0;
  $3 = HEAPU8[$22 >> 0] | 0 | ((HEAPU8[($22 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($22 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($22 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $0 + 44 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $0 + 36 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $5 = i64toi32_i32$1;
  $5$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 28 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 29 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 30 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 31 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 32 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 33 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 34 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 35 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $6 = i64toi32_i32$0;
  $6$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $7 = i64toi32_i32$1;
  $7$hi = i64toi32_i32$0;
  i64toi32_i32$2 = i64toi32_i32$2 + 64 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $55 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 104 | 0) + 64 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $55;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $0 + 72 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $61 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 104 | 0) + 72 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $61;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $0 + 80 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $67 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 104 | 0) + 80 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $67;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $5$hi;
  i64toi32_i32$0 = ($1 + 104 | 0) + 36 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $5;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $4$hi;
  i64toi32_i32$0 = ($1 + 104 | 0) + 44 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $4;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(($1 + 104 | 0) + 52 | 0) >> 2] = $3;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$0 = $1;
  HEAP32[(i64toi32_i32$0 + 104 | 0) >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 108 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 56 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 57 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 58 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 59 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 60 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 61 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 62 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 63 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $84 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[(i64toi32_i32$1 + 160 | 0) >> 2] = $84;
  HEAP32[(i64toi32_i32$1 + 164 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $6$hi;
  HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] = $6;
  HEAP32[(i64toi32_i32$1 + 136 | 0) >> 2] = i64toi32_i32$0;
  memcpy(i64toi32_i32$1 + 16 | 0 | 0, i64toi32_i32$1 + 104 | 0 | 0, 88 | 0) | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP8[(i64toi32_i32$1 + 104 | 0) >> 0] = 5;
  memcpy(i64toi32_i32$1 + 104 | 0 | 1 | 0 | 0, i64toi32_i32$1 + 16 | 0 | 0, 88 | 0) | 0;
  $0 = $cardano_serialization_lib__Certificate_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hd9e6ef3cbd15ff20(i64toi32_i32$1 + 104 | 0 | 0) | 0;
  global$0 = i64toi32_i32$1 + 304 | 0;
  return $0 | 0;
 }
 
 function certificate_as_genesis_key_delegation($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $1 = 0, $2 = 0, $21 = 0, $22 = 0, $32 = 0, $37 = 0, $4 = 0, $4$hi = 0, $3 = 0, $5 = 0, $5$hi = 0, $6 = 0, $6$hi = 0, $7 = 0, $7$hi = 0, $56 = 0, $61 = 0, $66 = 0, $81 = 0;
  $1 = global$0 - 192 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h3b62e22150831bdc($1 + 8 | 0 | 0, $0 | 0);
   $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   label$2 : {
    label$3 : {
     $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     if ((HEAPU8[$0 >> 0] | 0 | 0) != (5 | 0)) {
      break label$3
     }
     $21 = $0 + 25 | 0;
     HEAP32[($1 + 128 | 0) >> 2] = HEAPU8[$21 >> 0] | 0 | ((HEAPU8[($21 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($21 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($21 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$2 = $0 + 17 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $32 = i64toi32_i32$0;
     i64toi32_i32$0 = $1 + 120 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $32;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $0 + 9 | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $37 = i64toi32_i32$1;
     i64toi32_i32$1 = $1 + 112 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $37;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $0 + 29 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $4 = i64toi32_i32$0;
     $4$hi = i64toi32_i32$1;
     $22 = $0 + 53 | 0;
     $3 = HEAPU8[$22 >> 0] | 0 | ((HEAPU8[($22 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($22 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($22 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$2 = $0 + 45 | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $5 = i64toi32_i32$1;
     $5$hi = i64toi32_i32$0;
     i64toi32_i32$2 = $0 + 37 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $6 = i64toi32_i32$0;
     $6$hi = i64toi32_i32$1;
     i64toi32_i32$2 = $0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $7 = i64toi32_i32$1;
     $7$hi = i64toi32_i32$0;
     i64toi32_i32$2 = i64toi32_i32$2 + 65 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $56 = i64toi32_i32$0;
     i64toi32_i32$0 = $1 + 168 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $56;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $0 + 73 | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $61 = i64toi32_i32$1;
     i64toi32_i32$1 = $1 + 176 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $61;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $0 + 81 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $66 = i64toi32_i32$0;
     i64toi32_i32$0 = $1 + 184 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $66;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$0 = $1 + 140 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $6;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $5$hi;
     i64toi32_i32$0 = $1 + 148 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $5;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($1 + 156 | 0) >> 2] = $3;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$0 = $1;
     HEAP32[(i64toi32_i32$0 + 104 | 0) >> 2] = $7;
     HEAP32[(i64toi32_i32$0 + 108 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $0 + 57 | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $81 = i64toi32_i32$1;
     i64toi32_i32$1 = $1;
     HEAP32[(i64toi32_i32$1 + 160 | 0) >> 2] = $81;
     HEAP32[(i64toi32_i32$1 + 164 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$0 = $4$hi;
     HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] = $4;
     HEAP32[(i64toi32_i32$1 + 136 | 0) >> 2] = i64toi32_i32$0;
     memcpy(i64toi32_i32$1 + 16 | 0 | 0, i64toi32_i32$1 + 104 | 0 | 0, 88 | 0) | 0;
     core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
     memcpy(i64toi32_i32$1 + 104 | 0 | 0, i64toi32_i32$1 + 16 | 0 | 0, 88 | 0) | 0;
     $0 = $cardano_serialization_lib__GenesisKeyDelegation_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h6614a0688d3f0486(i64toi32_i32$1 + 104 | 0 | 0) | 0;
     break label$2;
    }
    core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
    $0 = 0;
   }
   global$0 = $1 + 192 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__h1871782aef98277c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $4 = 0, $2 = 0, $3 = 0, $24 = 0, $25 = 0, $5 = 0, $26 = 0, $27 = 0, $28 = 0, $29 = 0, $30 = 0, $31 = 0, $32 = 0, $6 = 0, $7 = 0, $8 = 0, $34 = 0, $40 = 0, $43 = 0, $9 = 0, $9$hi = 0, $10 = 0, $10$hi = 0, $68 = 0, $96 = 0, $102 = 0, $105 = 0, $116 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__hbd7038216761c388($2 + 8 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    if ($3) {
     break label$2
    }
    i64toi32_i32$1 = $0;
    i64toi32_i32$0 = 0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = 0;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[i64toi32_i32$1 >> 2] = HEAP32[(0 + 1067616 | 0) >> 2] | 0;
    break label$1;
   }
   $4 = $2 + 57 | 0;
   $24 = $3 + 24 | 0;
   $25 = HEAPU8[$24 >> 0] | 0 | ((HEAPU8[($24 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($24 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($24 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[$4 >> 0] = $25;
   HEAP8[($4 + 1 | 0) >> 0] = $25 >>> 8 | 0;
   HEAP8[($4 + 2 | 0) >> 0] = $25 >>> 16 | 0;
   HEAP8[($4 + 3 | 0) >> 0] = $25 >>> 24 | 0;
   $5 = $2 + 49 | 0;
   i64toi32_i32$2 = $3 + 16 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $34 = i64toi32_i32$0;
   i64toi32_i32$0 = $5;
   $26 = $34;
   HEAP8[i64toi32_i32$0 >> 0] = $26;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $26 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $26 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $26 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   $6 = $2 + 41 | 0;
   i64toi32_i32$2 = $3 + 8 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $40 = i64toi32_i32$1;
   i64toi32_i32$1 = $6;
   $27 = $40;
   HEAP8[i64toi32_i32$1 >> 0] = $27;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $27 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $27 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $27 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $3;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $43 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   $28 = $43;
   HEAP8[(i64toi32_i32$0 + 33 | 0) >> 0] = $28;
   HEAP8[(i64toi32_i32$0 + 34 | 0) >> 0] = $28 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 35 | 0) >> 0] = $28 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 36 | 0) >> 0] = $28 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 37 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 38 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 39 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 40 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   $7 = $1 + 24 | 0;
   $3 = HEAP32[$7 >> 2] | 0;
   $8 = $3 + 1 | 0;
   alloc__raw_vec__RawVec_T_2cA___allocate_in__hd795b89d8892a0fd(i64toi32_i32$0 | 0, ($8 >>> 0 < $3 >>> 0 ? -1 : $8) | 0, 0 | 0);
   i64toi32_i32$2 = $6;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $9 = i64toi32_i32$1;
   $9$hi = i64toi32_i32$0;
   i64toi32_i32$2 = $5;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $10 = i64toi32_i32$0;
   $10$hi = i64toi32_i32$1;
   $4 = HEAPU8[$4 >> 0] | 0 | ((HEAPU8[($4 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $5 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $3 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 33 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 34 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 35 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 36 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 37 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 38 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 39 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 40 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $68 = i64toi32_i32$1;
   i64toi32_i32$1 = $3;
   $29 = $68;
   HEAP8[i64toi32_i32$1 >> 0] = $29;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $29 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $29 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $29 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   $30 = i64toi32_i32$1 + 24 | 0;
   HEAP8[$30 >> 0] = $4;
   HEAP8[($30 + 1 | 0) >> 0] = $4 >>> 8 | 0;
   HEAP8[($30 + 2 | 0) >> 0] = $4 >>> 16 | 0;
   HEAP8[($30 + 3 | 0) >> 0] = $4 >>> 24 | 0;
   i64toi32_i32$0 = $10$hi;
   i64toi32_i32$1 = i64toi32_i32$1 + 16 | 0;
   $31 = $10;
   HEAP8[i64toi32_i32$1 >> 0] = $31;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $31 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $31 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $31 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$0 = $9$hi;
   i64toi32_i32$1 = $3 + 8 | 0;
   $32 = $9;
   HEAP8[i64toi32_i32$1 >> 0] = $32;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $32 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $32 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $32 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   $4 = (i64toi32_i32$2 + 16 | 0) + 8 | 0;
   HEAP32[$4 >> 2] = 1;
   HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] = $5;
   HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] = $3;
   HEAP32[((i64toi32_i32$2 + 32 | 0) + 24 | 0) >> 2] = HEAP32[$7 >> 2] | 0;
   i64toi32_i32$2 = $1 + 16 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $96 = i64toi32_i32$0;
   i64toi32_i32$0 = ($2 + 32 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $96;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1 + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $102 = i64toi32_i32$1;
   i64toi32_i32$1 = ($2 + 32 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $102;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $1;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $105 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] = $105;
   HEAP32[(i64toi32_i32$0 + 36 | 0) >> 2] = i64toi32_i32$1;
   alloc__vec__Vec_T_2cA___extend_desugared__ha05bcb03e1072897(i64toi32_i32$0 + 16 | 0 | 0, i64toi32_i32$0 + 32 | 0 | 0);
   HEAP32[($0 + 8 | 0) >> 2] = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$2 = i64toi32_i32$0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
   $116 = i64toi32_i32$1;
   i64toi32_i32$1 = $0;
   HEAP32[i64toi32_i32$1 >> 2] = $116;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  }
  global$0 = $2 + 64 | 0;
 }
 
 function $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__h35bbe9f0640c90cc($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $4 = 0, $2 = 0, $3 = 0, $24 = 0, $25 = 0, $5 = 0, $26 = 0, $27 = 0, $28 = 0, $29 = 0, $30 = 0, $31 = 0, $32 = 0, $6 = 0, $7 = 0, $8 = 0, $34 = 0, $40 = 0, $43 = 0, $9 = 0, $9$hi = 0, $10 = 0, $10$hi = 0, $68 = 0, $96 = 0, $102 = 0, $105 = 0, $116 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h03cc330b7b1e4522($2 + 8 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    if ($3) {
     break label$2
    }
    i64toi32_i32$1 = $0;
    i64toi32_i32$0 = 0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = 0;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[i64toi32_i32$1 >> 2] = HEAP32[(0 + 1067616 | 0) >> 2] | 0;
    break label$1;
   }
   $4 = $2 + 57 | 0;
   $24 = $3 + 24 | 0;
   $25 = HEAPU8[$24 >> 0] | 0 | ((HEAPU8[($24 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($24 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($24 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[$4 >> 0] = $25;
   HEAP8[($4 + 1 | 0) >> 0] = $25 >>> 8 | 0;
   HEAP8[($4 + 2 | 0) >> 0] = $25 >>> 16 | 0;
   HEAP8[($4 + 3 | 0) >> 0] = $25 >>> 24 | 0;
   $5 = $2 + 49 | 0;
   i64toi32_i32$2 = $3 + 16 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $34 = i64toi32_i32$0;
   i64toi32_i32$0 = $5;
   $26 = $34;
   HEAP8[i64toi32_i32$0 >> 0] = $26;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $26 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $26 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $26 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   $6 = $2 + 41 | 0;
   i64toi32_i32$2 = $3 + 8 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $40 = i64toi32_i32$1;
   i64toi32_i32$1 = $6;
   $27 = $40;
   HEAP8[i64toi32_i32$1 >> 0] = $27;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $27 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $27 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $27 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $3;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $43 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   $28 = $43;
   HEAP8[(i64toi32_i32$0 + 33 | 0) >> 0] = $28;
   HEAP8[(i64toi32_i32$0 + 34 | 0) >> 0] = $28 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 35 | 0) >> 0] = $28 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 36 | 0) >> 0] = $28 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 37 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 38 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 39 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 40 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   $7 = $1 + 24 | 0;
   $3 = HEAP32[$7 >> 2] | 0;
   $8 = $3 + 1 | 0;
   alloc__raw_vec__RawVec_T_2cA___allocate_in__ha2ff5298d92d8db5(i64toi32_i32$0 | 0, ($8 >>> 0 < $3 >>> 0 ? -1 : $8) | 0, 0 | 0);
   i64toi32_i32$2 = $6;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $9 = i64toi32_i32$1;
   $9$hi = i64toi32_i32$0;
   i64toi32_i32$2 = $5;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $10 = i64toi32_i32$0;
   $10$hi = i64toi32_i32$1;
   $4 = HEAPU8[$4 >> 0] | 0 | ((HEAPU8[($4 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $5 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $3 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 33 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 34 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 35 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 36 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 37 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 38 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 39 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 40 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $68 = i64toi32_i32$1;
   i64toi32_i32$1 = $3;
   $29 = $68;
   HEAP8[i64toi32_i32$1 >> 0] = $29;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $29 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $29 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $29 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   $30 = i64toi32_i32$1 + 24 | 0;
   HEAP8[$30 >> 0] = $4;
   HEAP8[($30 + 1 | 0) >> 0] = $4 >>> 8 | 0;
   HEAP8[($30 + 2 | 0) >> 0] = $4 >>> 16 | 0;
   HEAP8[($30 + 3 | 0) >> 0] = $4 >>> 24 | 0;
   i64toi32_i32$0 = $10$hi;
   i64toi32_i32$1 = i64toi32_i32$1 + 16 | 0;
   $31 = $10;
   HEAP8[i64toi32_i32$1 >> 0] = $31;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $31 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $31 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $31 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$0 = $9$hi;
   i64toi32_i32$1 = $3 + 8 | 0;
   $32 = $9;
   HEAP8[i64toi32_i32$1 >> 0] = $32;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $32 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $32 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $32 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   $4 = (i64toi32_i32$2 + 16 | 0) + 8 | 0;
   HEAP32[$4 >> 2] = 1;
   HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] = $5;
   HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] = $3;
   HEAP32[((i64toi32_i32$2 + 32 | 0) + 24 | 0) >> 2] = HEAP32[$7 >> 2] | 0;
   i64toi32_i32$2 = $1 + 16 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $96 = i64toi32_i32$0;
   i64toi32_i32$0 = ($2 + 32 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $96;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1 + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $102 = i64toi32_i32$1;
   i64toi32_i32$1 = ($2 + 32 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $102;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $1;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $105 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] = $105;
   HEAP32[(i64toi32_i32$0 + 36 | 0) >> 2] = i64toi32_i32$1;
   alloc__vec__Vec_T_2cA___extend_desugared__h6803022990c07d6f(i64toi32_i32$0 + 16 | 0 | 0, i64toi32_i32$0 + 32 | 0 | 0);
   HEAP32[($0 + 8 | 0) >> 2] = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$2 = i64toi32_i32$0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
   $116 = i64toi32_i32$1;
   i64toi32_i32$1 = $0;
   HEAP32[i64toi32_i32$1 >> 2] = $116;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  }
  global$0 = $2 + 64 | 0;
 }
 
 function $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__h3acc6a814a137cd3($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $4 = 0, $2 = 0, $3 = 0, $24 = 0, $25 = 0, $5 = 0, $26 = 0, $27 = 0, $28 = 0, $29 = 0, $30 = 0, $31 = 0, $32 = 0, $6 = 0, $7 = 0, $8 = 0, $34 = 0, $40 = 0, $43 = 0, $9 = 0, $9$hi = 0, $10 = 0, $10$hi = 0, $68 = 0, $96 = 0, $102 = 0, $105 = 0, $116 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h32d71c96a3c9fef9($2 + 8 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    if ($3) {
     break label$2
    }
    i64toi32_i32$1 = $0;
    i64toi32_i32$0 = 0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = 0;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[i64toi32_i32$1 >> 2] = HEAP32[(0 + 1067616 | 0) >> 2] | 0;
    break label$1;
   }
   $4 = $2 + 57 | 0;
   $24 = $3 + 24 | 0;
   $25 = HEAPU8[$24 >> 0] | 0 | ((HEAPU8[($24 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($24 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($24 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[$4 >> 0] = $25;
   HEAP8[($4 + 1 | 0) >> 0] = $25 >>> 8 | 0;
   HEAP8[($4 + 2 | 0) >> 0] = $25 >>> 16 | 0;
   HEAP8[($4 + 3 | 0) >> 0] = $25 >>> 24 | 0;
   $5 = $2 + 49 | 0;
   i64toi32_i32$2 = $3 + 16 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $34 = i64toi32_i32$0;
   i64toi32_i32$0 = $5;
   $26 = $34;
   HEAP8[i64toi32_i32$0 >> 0] = $26;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $26 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $26 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $26 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   $6 = $2 + 41 | 0;
   i64toi32_i32$2 = $3 + 8 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $40 = i64toi32_i32$1;
   i64toi32_i32$1 = $6;
   $27 = $40;
   HEAP8[i64toi32_i32$1 >> 0] = $27;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $27 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $27 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $27 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $3;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $43 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   $28 = $43;
   HEAP8[(i64toi32_i32$0 + 33 | 0) >> 0] = $28;
   HEAP8[(i64toi32_i32$0 + 34 | 0) >> 0] = $28 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 35 | 0) >> 0] = $28 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 36 | 0) >> 0] = $28 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 37 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 38 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 39 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 40 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   $7 = $1 + 24 | 0;
   $3 = HEAP32[$7 >> 2] | 0;
   $8 = $3 + 1 | 0;
   alloc__raw_vec__RawVec_T_2cA___allocate_in__ha2ff5298d92d8db5(i64toi32_i32$0 | 0, ($8 >>> 0 < $3 >>> 0 ? -1 : $8) | 0, 0 | 0);
   i64toi32_i32$2 = $6;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $9 = i64toi32_i32$1;
   $9$hi = i64toi32_i32$0;
   i64toi32_i32$2 = $5;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $10 = i64toi32_i32$0;
   $10$hi = i64toi32_i32$1;
   $4 = HEAPU8[$4 >> 0] | 0 | ((HEAPU8[($4 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $5 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $3 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 33 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 34 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 35 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 36 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 37 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 38 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 39 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 40 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $68 = i64toi32_i32$1;
   i64toi32_i32$1 = $3;
   $29 = $68;
   HEAP8[i64toi32_i32$1 >> 0] = $29;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $29 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $29 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $29 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   $30 = i64toi32_i32$1 + 24 | 0;
   HEAP8[$30 >> 0] = $4;
   HEAP8[($30 + 1 | 0) >> 0] = $4 >>> 8 | 0;
   HEAP8[($30 + 2 | 0) >> 0] = $4 >>> 16 | 0;
   HEAP8[($30 + 3 | 0) >> 0] = $4 >>> 24 | 0;
   i64toi32_i32$0 = $10$hi;
   i64toi32_i32$1 = i64toi32_i32$1 + 16 | 0;
   $31 = $10;
   HEAP8[i64toi32_i32$1 >> 0] = $31;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $31 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $31 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $31 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$0 = $9$hi;
   i64toi32_i32$1 = $3 + 8 | 0;
   $32 = $9;
   HEAP8[i64toi32_i32$1 >> 0] = $32;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $32 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $32 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $32 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   $4 = (i64toi32_i32$2 + 16 | 0) + 8 | 0;
   HEAP32[$4 >> 2] = 1;
   HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] = $5;
   HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] = $3;
   HEAP32[((i64toi32_i32$2 + 32 | 0) + 24 | 0) >> 2] = HEAP32[$7 >> 2] | 0;
   i64toi32_i32$2 = $1 + 16 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $96 = i64toi32_i32$0;
   i64toi32_i32$0 = ($2 + 32 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $96;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1 + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $102 = i64toi32_i32$1;
   i64toi32_i32$1 = ($2 + 32 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $102;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $1;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $105 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] = $105;
   HEAP32[(i64toi32_i32$0 + 36 | 0) >> 2] = i64toi32_i32$1;
   alloc__vec__Vec_T_2cA___extend_desugared__hc08b504a96d15531(i64toi32_i32$0 + 16 | 0 | 0, i64toi32_i32$0 + 32 | 0 | 0);
   HEAP32[($0 + 8 | 0) >> 2] = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$2 = i64toi32_i32$0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
   $116 = i64toi32_i32$1;
   i64toi32_i32$1 = $0;
   HEAP32[i64toi32_i32$1 >> 2] = $116;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  }
  global$0 = $2 + 64 | 0;
 }
 
 function alloc__string__String__push__hfac6e344dab69dd1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ($1 >>> 0 < 128 >>> 0) {
        break label$5
       }
       HEAP32[($2 + 12 | 0) >> 2] = 0;
       if ($1 >>> 0 < 2048 >>> 0) {
        break label$4
       }
       if ($1 >>> 0 >= 65536 >>> 0) {
        break label$3
       }
       HEAP8[($2 + 14 | 0) >> 0] = $1 & 63 | 0 | 128 | 0;
       HEAP8[($2 + 12 | 0) >> 0] = $1 >>> 12 | 0 | 224 | 0;
       HEAP8[($2 + 13 | 0) >> 0] = ($1 >>> 6 | 0) & 63 | 0 | 128 | 0;
       $1 = 3;
       break label$2;
      }
      label$6 : {
       $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
       if (($3 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
        break label$6
       }
       alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h306b444aaeb5adc5($0 | 0, $3 | 0, 1 | 0);
       $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
      }
      HEAP32[($0 + 8 | 0) >> 2] = $3 + 1 | 0;
      HEAP8[((HEAP32[$0 >> 2] | 0) + $3 | 0) >> 0] = $1;
      break label$1;
     }
     HEAP8[($2 + 13 | 0) >> 0] = $1 & 63 | 0 | 128 | 0;
     HEAP8[($2 + 12 | 0) >> 0] = $1 >>> 6 | 0 | 192 | 0;
     $1 = 2;
     break label$2;
    }
    HEAP8[($2 + 15 | 0) >> 0] = $1 & 63 | 0 | 128 | 0;
    HEAP8[($2 + 12 | 0) >> 0] = $1 >>> 18 | 0 | 240 | 0;
    HEAP8[($2 + 14 | 0) >> 0] = ($1 >>> 6 | 0) & 63 | 0 | 128 | 0;
    HEAP8[($2 + 13 | 0) >> 0] = ($1 >>> 12 | 0) & 63 | 0 | 128 | 0;
    $1 = 4;
   }
   label$7 : {
    $4 = $0 + 8 | 0;
    $3 = HEAP32[$4 >> 2] | 0;
    if (((HEAP32[($0 + 4 | 0) >> 2] | 0) - $3 | 0) >>> 0 >= $1 >>> 0) {
     break label$7
    }
    alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h306b444aaeb5adc5($0 | 0, $3 | 0, $1 | 0);
    $3 = HEAP32[$4 >> 2] | 0;
   }
   memcpy((HEAP32[$0 >> 2] | 0) + $3 | 0 | 0, $2 + 12 | 0 | 0, $1 | 0) | 0;
   HEAP32[$4 >> 2] = $3 + $1 | 0;
  }
  global$0 = $2 + 16 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert__ha71355666283c225($0, $1, $2, $3, $3$hi, $4, $5) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  $4 = $4 | 0;
  $5 = $5 | 0;
  var $6 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $7 = 0, $8 = 0, $59 = 0, $94 = 0;
  $6 = global$0 - 80 | 0;
  global$0 = $6;
  label$1 : {
   label$2 : {
    $7 = HEAP32[$1 >> 2] | 0;
    if (($7 + -1 | 0 | 0) != ($4 | 0)) {
     break label$2
    }
    label$3 : {
     label$4 : {
      label$5 : {
       $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
       if ((HEAPU16[($4 + 226 | 0) >> 1] | 0) >>> 0 < 11 >>> 0) {
        break label$5
       }
       alloc__collections__btree__node__splitpoint__h8424344594b4deb1($6 + 8 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
       $1 = HEAP32[($6 + 16 | 0) >> 2] | 0;
       $8 = HEAP32[($6 + 12 | 0) >> 2] | 0;
       HEAP32[($6 + 72 | 0) >> 2] = HEAP32[($6 + 8 | 0) >> 2] | 0;
       HEAP32[($6 + 68 | 0) >> 2] = $4;
       HEAP32[($6 + 64 | 0) >> 2] = $7;
       alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__KV___split__hd298a51c17ba56b1($6 + 8 | 0 | 0, $6 + 64 | 0 | 0);
       if (($8 | 0) == (1 | 0)) {
        break label$4
       }
       HEAP32[($6 + 48 | 0) >> 2] = HEAP32[($6 + 32 | 0) >> 2] | 0;
       $4 = HEAP32[($6 + 36 | 0) >> 2] | 0;
       break label$3;
      }
      HEAP32[(($6 + 8 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
      $59 = i64toi32_i32$0;
      i64toi32_i32$0 = $6;
      HEAP32[($6 + 8 | 0) >> 2] = $59;
      HEAP32[($6 + 12 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$1 = $3$hi;
      alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert_fit__h37f60ac01916eff0($1 | 0, $6 + 8 | 0 | 0, $3 | 0, i64toi32_i32$1 | 0, $6 | 0, $5 | 0);
      HEAP32[($0 + 8 | 0) >> 2] = $4;
      HEAP32[($0 + 4 | 0) >> 2] = $7;
      HEAP32[$0 >> 2] = 0;
      HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
      break label$1;
     }
     HEAP32[($6 + 48 | 0) >> 2] = HEAP32[($6 + 40 | 0) >> 2] | 0;
     $4 = HEAP32[($6 + 44 | 0) >> 2] | 0;
    }
    HEAP32[($6 + 56 | 0) >> 2] = $1;
    HEAP32[($6 + 52 | 0) >> 2] = $4;
    HEAP32[(($6 + 64 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
    $94 = i64toi32_i32$1;
    i64toi32_i32$1 = $6;
    HEAP32[($6 + 64 | 0) >> 2] = $94;
    HEAP32[($6 + 68 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = $3$hi;
    alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert_fit__h37f60ac01916eff0($6 + 48 | 0 | 0, $6 + 64 | 0 | 0, $3 | 0, i64toi32_i32$0 | 0, $6 | 0, $5 | 0);
    memcpy($0 + 8 | 0 | 0, $6 + 8 | 0 | 0, 40 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    break label$1;
   }
   core__panicking__panic__h2fd385a887c8bf13(1049076 | 0, 53 | 0, 1049132 | 0);
   abort();
  }
  global$0 = $6 + 80 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__MintAssets___serialize__h141cb87b41b2b47f($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $4 = 0, $32 = 0, $39 = 0, $42 = 0;
  $3 = global$0 - 128 | 0;
  global$0 = $3;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 + 80 | 0 | 0, $2 | 0, 5 | 0, i64toi32_i32$0 | 0, i64toi32_i32$1 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ((HEAP32[($3 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
        break label$5
       }
       alloc__collections__btree__map__BTreeMap_K_2cV___iter__h3ab6a151beb58e6b($3 + 16 | 0 | 0, $1 | 0);
       HEAP32[(($3 + 48 | 0) + 24 | 0) >> 2] = HEAP32[(($3 + 16 | 0) + 24 | 0) >> 2] | 0;
       i64toi32_i32$2 = ($3 + 16 | 0) + 16 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $32 = i64toi32_i32$1;
       i64toi32_i32$1 = ($3 + 48 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $32;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = ($3 + 16 | 0) + 8 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $39 = i64toi32_i32$0;
       i64toi32_i32$0 = ($3 + 48 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $39;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $3;
       i64toi32_i32$1 = HEAP32[($3 + 16 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[($3 + 20 | 0) >> 2] | 0;
       $42 = i64toi32_i32$1;
       i64toi32_i32$1 = $3;
       HEAP32[($3 + 48 | 0) >> 2] = $42;
       HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$0;
       $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__hce9499edf49fdc37($3 + 8 | 0 | 0, $3 + 48 | 0 | 0);
       label$6 : {
        $1 = HEAP32[($3 + 8 | 0) >> 2] | 0;
        if (!$1) {
         break label$6
        }
        $4 = HEAP32[($3 + 12 | 0) >> 2] | 0;
        label$7 : while (1) {
         cbor_event__se__Serializer_W___write_bytes__hdbf95a6224c8b5b8($3 + 80 | 0 | 0, $2 | 0, $1 | 0);
         if ((HEAP32[($3 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
          break label$4
         }
         $cardano_serialization_lib__utils__Int_20as_20cbor_event__se__Serialize___serialize__h52978cec14c40013($3 + 80 | 0 | 0, $4 | 0, $2 | 0);
         if ((HEAP32[($3 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
          break label$3
         }
         $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__hce9499edf49fdc37($3 | 0, $3 + 48 | 0 | 0);
         $4 = HEAP32[($3 + 4 | 0) >> 2] | 0;
         $1 = HEAP32[$3 >> 2] | 0;
         if ($1) {
          continue label$7
         }
         break label$7;
        };
       }
       HEAP32[$0 >> 2] = 0;
       HEAP32[($0 + 4 | 0) >> 2] = $2;
       break label$1;
      }
      memcpy($0 + 8 | 0 | 0, ($3 + 80 | 0) + 8 | 0 | 0, 40 | 0) | 0;
      HEAP32[$0 >> 2] = 1;
      break label$1;
     }
     memcpy($0 + 8 | 0 | 0, ($3 + 80 | 0) + 8 | 0 | 0, 40 | 0) | 0;
     break label$2;
    }
    memcpy($0 + 8 | 0 | 0, ($3 + 80 | 0) + 8 | 0 | 0, 40 | 0) | 0;
   }
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $3 + 128 | 0;
 }
 
 function $cardano_serialization_lib__plutus__PlutusMap_20as_20cbor_event__se__Serialize___serialize__h43e688f33521e457($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $4 = 0, $32 = 0, $39 = 0, $42 = 0;
  $3 = global$0 - 128 | 0;
  global$0 = $3;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 + 80 | 0 | 0, $2 | 0, 5 | 0, i64toi32_i32$0 | 0, i64toi32_i32$1 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ((HEAP32[($3 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
        break label$5
       }
       alloc__collections__btree__map__BTreeMap_K_2cV___iter__h1146c826d3183069($3 + 16 | 0 | 0, $1 | 0);
       HEAP32[(($3 + 48 | 0) + 24 | 0) >> 2] = HEAP32[(($3 + 16 | 0) + 24 | 0) >> 2] | 0;
       i64toi32_i32$2 = ($3 + 16 | 0) + 16 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $32 = i64toi32_i32$1;
       i64toi32_i32$1 = ($3 + 48 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $32;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = ($3 + 16 | 0) + 8 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $39 = i64toi32_i32$0;
       i64toi32_i32$0 = ($3 + 48 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $39;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $3;
       i64toi32_i32$1 = HEAP32[($3 + 16 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[($3 + 20 | 0) >> 2] | 0;
       $42 = i64toi32_i32$1;
       i64toi32_i32$1 = $3;
       HEAP32[($3 + 48 | 0) >> 2] = $42;
       HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$0;
       $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__hf8baa7262b1cd562($3 + 8 | 0 | 0, $3 + 48 | 0 | 0);
       label$6 : {
        $1 = HEAP32[($3 + 8 | 0) >> 2] | 0;
        if (!$1) {
         break label$6
        }
        $4 = HEAP32[($3 + 12 | 0) >> 2] | 0;
        label$7 : while (1) {
         $cardano_serialization_lib__plutus__PlutusData_20as_20cbor_event__se__Serialize___serialize__hbd5d6a191345a7d0($3 + 80 | 0 | 0, $1 | 0, $2 | 0);
         if ((HEAP32[($3 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
          break label$4
         }
         $cardano_serialization_lib__plutus__PlutusData_20as_20cbor_event__se__Serialize___serialize__hbd5d6a191345a7d0($3 + 80 | 0 | 0, $4 | 0, $2 | 0);
         if ((HEAP32[($3 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
          break label$3
         }
         $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__hf8baa7262b1cd562($3 | 0, $3 + 48 | 0 | 0);
         $4 = HEAP32[($3 + 4 | 0) >> 2] | 0;
         $1 = HEAP32[$3 >> 2] | 0;
         if ($1) {
          continue label$7
         }
         break label$7;
        };
       }
       HEAP32[$0 >> 2] = 0;
       HEAP32[($0 + 4 | 0) >> 2] = $2;
       break label$1;
      }
      memcpy($0 + 8 | 0 | 0, ($3 + 80 | 0) + 8 | 0 | 0, 40 | 0) | 0;
      HEAP32[$0 >> 2] = 1;
      break label$1;
     }
     memcpy($0 + 8 | 0 | 0, ($3 + 80 | 0) + 8 | 0 | 0, 40 | 0) | 0;
     break label$2;
    }
    memcpy($0 + 8 | 0 | 0, ($3 + 80 | 0) + 8 | 0 | 0, 40 | 0) | 0;
   }
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $3 + 128 | 0;
 }
 
 function alloc__fmt__format__h6e9e003a52c07309($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $5 = 0, $2 = 0, i64toi32_i32$0 = 0, $6 = 0, i64toi32_i32$1 = 0, $4 = 0, $7 = 0, i64toi32_i32$2 = 0, $3 = 0, $67 = 0, $73 = 0, $76 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  $3 = HEAP32[$1 >> 2] | 0;
  label$1 : {
   label$2 : {
    $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $5 = $4 << 3 | 0;
    if ($5) {
     break label$2
    }
    $6 = 0;
    break label$1;
   }
   $7 = $3 + 4 | 0;
   $6 = 0;
   label$3 : while (1) {
    $6 = (HEAP32[$7 >> 2] | 0) + $6 | 0;
    $7 = $7 + 8 | 0;
    $5 = $5 + -8 | 0;
    if ($5) {
     continue label$3
    }
    break label$3;
   };
  }
  label$4 : {
   label$5 : {
    label$6 : {
     label$7 : {
      label$8 : {
       label$9 : {
        if (HEAP32[($1 + 20 | 0) >> 2] | 0) {
         break label$9
        }
        $5 = $6;
        break label$8;
       }
       if (!$4) {
        break label$6
       }
       $7 = 0;
       $4 = 1;
       label$10 : {
        if ($6 >>> 0 > 15 >>> 0) {
         break label$10
        }
        if (!(HEAP32[($3 + 4 | 0) >> 2] | 0)) {
         break label$7
        }
       }
       $5 = $6 + $6 | 0;
       if ($5 >>> 0 < $6 >>> 0) {
        break label$7
       }
      }
      $7 = 0;
      label$11 : {
       label$12 : {
        if (($5 | 0) < (0 | 0)) {
         break label$12
        }
        if ($5) {
         break label$11
        }
        $4 = 1;
        break label$7;
       }
       alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
       abort();
      }
      $7 = $5;
      $4 = __rust_alloc($5 | 0, 1 | 0) | 0;
      if (!$4) {
       break label$4
      }
     }
     HEAP32[($0 + 8 | 0) >> 2] = 0;
     HEAP32[$0 >> 2] = $4;
     HEAP32[($0 + 4 | 0) >> 2] = $7;
     HEAP32[($2 + 4 | 0) >> 2] = $0;
     i64toi32_i32$2 = $1 + 16 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $67 = i64toi32_i32$0;
     i64toi32_i32$0 = ($2 + 8 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $67;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $1 + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $73 = i64toi32_i32$1;
     i64toi32_i32$1 = ($2 + 8 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $73;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $1;
     i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $76 = i64toi32_i32$0;
     i64toi32_i32$0 = $2;
     HEAP32[($2 + 8 | 0) >> 2] = $76;
     HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
     if (core__fmt__write__h9b9aa23e7d35702c($2 + 4 | 0 | 0, 1145644 | 0, $2 + 8 | 0 | 0) | 0) {
      break label$5
     }
     global$0 = $2 + 32 | 0;
     return;
    }
    core__panicking__panic_bounds_check__h808b524af17640b1(0 | 0, 0 | 0, 1145760 | 0);
    abort();
   }
   core__result__unwrap_failed__h27f43d993c3864a1(1145792 | 0, 51 | 0, $2 + 8 | 0 | 0, 1145776 | 0, 1145868 | 0);
   abort();
  }
  alloc__alloc__handle_alloc_error__he269d8f1bff90960($5 | 0, 1 | 0);
  abort();
 }
 
 function cardano_serialization_lib__TransactionOutputs__get__h4e92212d3597b354($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $3 = 0, $4 = 0, $26 = 0, $27 = 0, $28 = 0, $29 = 0, $8 = 0, $5 = 0, $6 = 0, $7 = 0, $9 = 0, $9$hi = 0, $45 = 0, $50 = 0, $62 = 0, $67 = 0, $71 = 0, $75 = 0, $86 = 0, $90 = 0, $94 = 0, $98 = 0, $103 = 0, $108 = 0;
  $3 = global$0 - 112 | 0;
  global$0 = $3;
  label$1 : {
   $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   if ($4 >>> 0 <= $2 >>> 0) {
    break label$1
   }
   $5 = HEAP32[$1 >> 2] | 0;
   $1 = $5 + ($2 << 7 | 0) | 0;
   $cardano_serialization_lib__address__Address_20as_20core__clone__Clone___clone__h0eb465a6e349d507($3 | 0, $1 | 0);
   i64toi32_i32$2 = $1;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
   $9 = i64toi32_i32$0;
   $9$hi = i64toi32_i32$1;
   $4 = 0;
   $6 = 0;
   label$2 : {
    if ((HEAP32[(i64toi32_i32$2 + 72 | 0) >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($3 + 80 | 0 | 4 | 0 | 0, $1 + 76 | 0 | 0);
    $6 = 1;
   }
   $7 = ($3 + 64 | 0) + 8 | 0;
   $8 = ($3 + 80 | 0) + 8 | 0;
   i64toi32_i32$2 = $8;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $45 = i64toi32_i32$1;
   i64toi32_i32$1 = $7;
   HEAP32[i64toi32_i32$1 >> 2] = $45;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($3 + 80 | 0) >> 2] = $6;
   i64toi32_i32$2 = $3;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 80 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 84 | 0) >> 2] | 0;
   $50 = i64toi32_i32$0;
   i64toi32_i32$0 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$0 + 64 | 0) >> 2] = $50;
   HEAP32[(i64toi32_i32$0 + 68 | 0) >> 2] = i64toi32_i32$1;
   label$3 : {
    if ((HEAPU8[($1 + 88 | 0) >> 0] | 0 | 0) != (1 | 0)) {
     break label$3
    }
    $1 = $5 + ($2 << 7 | 0) | 0;
    i64toi32_i32$2 = $1 + 113 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $62 = i64toi32_i32$1;
    i64toi32_i32$1 = $3 + 104 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $62;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $1 + 105 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $67 = i64toi32_i32$0;
    i64toi32_i32$0 = $3 + 96 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $67;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $1 + 97 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $71 = i64toi32_i32$1;
    i64toi32_i32$1 = $8;
    HEAP32[i64toi32_i32$1 >> 2] = $71;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $1 + 89 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $75 = i64toi32_i32$0;
    i64toi32_i32$0 = $3;
    HEAP32[(i64toi32_i32$0 + 80 | 0) >> 2] = $75;
    HEAP32[(i64toi32_i32$0 + 84 | 0) >> 2] = i64toi32_i32$1;
    $4 = 1;
   }
   $1 = memcpy($0 | 0, $3 | 0, 64 | 0) | 0;
   i64toi32_i32$1 = $9$hi;
   i64toi32_i32$0 = $1;
   HEAP32[(i64toi32_i32$0 + 64 | 0) >> 2] = $9;
   HEAP32[(i64toi32_i32$0 + 68 | 0) >> 2] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 88 | 0) >> 0] = $4;
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
   $86 = i64toi32_i32$1;
   i64toi32_i32$1 = $1 + 72 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $86;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $7;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $90 = i64toi32_i32$0;
   i64toi32_i32$0 = $1 + 80 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $90;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 80 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 84 | 0) >> 2] | 0;
   $94 = i64toi32_i32$1;
   i64toi32_i32$1 = $1 + 89 | 0;
   $26 = $94;
   HEAP8[i64toi32_i32$1 >> 0] = $26;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $26 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $26 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $26 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $8;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $98 = i64toi32_i32$0;
   i64toi32_i32$0 = $1 + 97 | 0;
   $27 = $98;
   HEAP8[i64toi32_i32$0 >> 0] = $27;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $27 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $27 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $27 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = $3 + 96 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $103 = i64toi32_i32$1;
   i64toi32_i32$1 = $1 + 105 | 0;
   $28 = $103;
   HEAP8[i64toi32_i32$1 >> 0] = $28;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $28 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $28 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $28 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $3 + 104 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $108 = i64toi32_i32$0;
   i64toi32_i32$0 = $1 + 113 | 0;
   $29 = $108;
   HEAP8[i64toi32_i32$0 >> 0] = $29;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $29 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $29 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $29 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   global$0 = $3 + 112 | 0;
   return;
  }
  core__panicking__panic_bounds_check__h808b524af17640b1($2 | 0, $4 | 0, 1053208 | 0);
  abort();
 }
 
 function transactionbody_new_tx_body($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $7 = 0, $4 = 0, $5 = 0, $6 = 0, $8 = 0, $8$hi = 0, $70 = 0, $74 = 0, $92 = 0;
  $3 = global$0 - 336 | 0;
  global$0 = $3;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hf2abefb15e68f011($3 + 16 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($3 + 20 | 0) >> 2] | 0;
   $4 = HEAP32[($3 + 16 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h6185b44b866d43f0($3 + 8 | 0 | 0, $1 | 0);
   if (!$2) {
    break label$1
   }
   $1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
   $5 = HEAP32[($3 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($3 | 0, $2 | 0);
   $6 = HEAP32[$3 >> 2] | 0;
   $2 = HEAP32[($3 + 4 | 0) >> 2] | 0;
   $7 = ($3 + 40 | 0) + 8 | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hfe677107e1954f8f($7 | 0, $4 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h699bb0f3db607312($3 + 24 | 0 | 0, $5 | 0);
   i64toi32_i32$2 = $6;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $8 = i64toi32_i32$0;
   $8$hi = i64toi32_i32$1;
   core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   HEAP32[($3 + 148 | 0) >> 2] = 0;
   HEAP32[($3 + 108 | 0) >> 2] = 0;
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[($3 + 40 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($3 + 44 | 0) >> 2] | 0;
   $70 = i64toi32_i32$1;
   i64toi32_i32$1 = $3 + 184 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $70;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $7;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $74 = i64toi32_i32$0;
   i64toi32_i32$0 = $3 + 192 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $74;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($3 + 200 | 0) >> 2] = HEAP32[($3 + 56 | 0) >> 2] | 0;
   HEAP32[($3 + 212 | 0) >> 2] = HEAP32[(($3 + 24 | 0) + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = $3;
   i64toi32_i32$1 = 0;
   HEAP32[($3 + 176 | 0) >> 2] = 0;
   HEAP32[($3 + 180 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$0 = $3;
   i64toi32_i32$1 = 0;
   HEAP32[($3 + 72 | 0) >> 2] = 0;
   HEAP32[($3 + 76 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $8$hi;
   i64toi32_i32$0 = $3;
   HEAP32[($3 + 64 | 0) >> 2] = $8;
   HEAP32[($3 + 68 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[($3 + 24 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($3 + 28 | 0) >> 2] | 0;
   $92 = i64toi32_i32$1;
   i64toi32_i32$1 = $3;
   HEAP32[($3 + 204 | 0) >> 2] = $92;
   HEAP32[($3 + 208 | 0) >> 2] = i64toi32_i32$0;
   HEAP8[($3 + 334 | 0) >> 0] = 2;
   HEAP8[($3 + 301 | 0) >> 0] = 0;
   HEAP8[($3 + 268 | 0) >> 0] = 0;
   HEAP32[($3 + 256 | 0) >> 2] = 0;
   HEAP32[($3 + 244 | 0) >> 2] = 0;
   HEAP32[($3 + 228 | 0) >> 2] = 0;
   HEAP32[($3 + 216 | 0) >> 2] = 0;
   $0 = $cardano_serialization_lib__TransactionBody_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h5f9023ed5f5fb82c($3 + 64 | 0 | 0) | 0;
   global$0 = $3 + 336 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function certificate_new_stake_delegation($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $27 = 0, $3 = 0, $28 = 0, $2 = 0, $5 = 0, $6 = 0, $7 = 0, $8 = 0, $9 = 0, $29 = 0, $30 = 0, $31 = 0, $32 = 0, $33 = 0, $34 = 0, $35 = 0, $36 = 0, $37 = 0, $39 = 0, $10 = 0, $10$hi = 0, $4 = 0, $11 = 0, $11$hi = 0, $38 = 0, $57 = 0, $64 = 0, $74 = 0, $83 = 0, $87 = 0, $95 = 0, $99 = 0, $103 = 0, $113 = 0;
  $1 = global$0 - 304 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hfc784c950a3a2da2($1 | 0, $0 | 0);
  $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $0 = HEAP32[$1 >> 2] | 0;
  $27 = $0 + 25 | 0;
  $3 = HEAPU8[$27 >> 0] | 0 | ((HEAPU8[($27 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($27 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($27 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $0 + 17 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  $4 = HEAPU8[$0 >> 0] | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$0;
  $5 = ($1 + 40 | 0) + 8 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 9 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $38 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[i64toi32_i32$0 >> 2] = $38;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $6 = ($1 + 40 | 0) + 16 | 0;
  i64toi32_i32$1 = $10$hi;
  i64toi32_i32$0 = $6;
  HEAP32[i64toi32_i32$0 >> 2] = $10;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $7 = ($1 + 40 | 0) + 24 | 0;
  HEAP32[$7 >> 2] = $3;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$0 = $1;
  HEAP32[(i64toi32_i32$0 + 40 | 0) >> 2] = $11;
  HEAP32[(i64toi32_i32$0 + 44 | 0) >> 2] = i64toi32_i32$1;
  $3 = (i64toi32_i32$0 + 8 | 0) + 8 | 0;
  i64toi32_i32$2 = $0 + 37 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $57 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[i64toi32_i32$1 >> 2] = $57;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $8 = ($1 + 8 | 0) + 16 | 0;
  i64toi32_i32$2 = $0 + 45 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $64 = i64toi32_i32$0;
  i64toi32_i32$0 = $8;
  HEAP32[i64toi32_i32$0 >> 2] = $64;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $9 = ($1 + 8 | 0) + 24 | 0;
  $28 = $0 + 53 | 0;
  HEAP32[$9 >> 2] = HEAPU8[$28 >> 0] | 0 | ((HEAPU8[($28 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($28 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($28 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 29 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 30 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 31 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 32 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 33 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 34 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 35 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 36 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $74 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $74;
  HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $83 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 114 | 0;
  $29 = $83;
  HEAP16[i64toi32_i32$0 >> 1] = $29;
  HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $29 >>> 16 | 0;
  HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$1;
  HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
  i64toi32_i32$2 = $6;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $87 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 122 | 0;
  $30 = $87;
  HEAP16[i64toi32_i32$1 >> 1] = $30;
  HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $30 >>> 16 | 0;
  HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = i64toi32_i32$0;
  HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
  $31 = $1 + 130 | 0;
  $32 = HEAP32[$7 >> 2] | 0;
  HEAP16[$31 >> 1] = $32;
  HEAP16[($31 + 2 | 0) >> 1] = $32 >>> 16 | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $95 = i64toi32_i32$0;
  i64toi32_i32$0 = i64toi32_i32$2 + 134 | 0;
  $33 = $95;
  HEAP16[i64toi32_i32$0 >> 1] = $33;
  HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $33 >>> 16 | 0;
  HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$1;
  HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $99 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 142 | 0;
  $34 = $99;
  HEAP16[i64toi32_i32$1 >> 1] = $34;
  HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $34 >>> 16 | 0;
  HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = i64toi32_i32$0;
  HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
  i64toi32_i32$2 = $8;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $103 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 150 | 0;
  $35 = $103;
  HEAP16[i64toi32_i32$0 >> 1] = $35;
  HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $35 >>> 16 | 0;
  HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$1;
  HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
  $36 = $1 + 158 | 0;
  $37 = HEAP32[$9 >> 2] | 0;
  HEAP16[$36 >> 1] = $37;
  HEAP16[($36 + 2 | 0) >> 1] = $37 >>> 16 | 0;
  HEAP8[($1 + 105 | 0) >> 0] = $4;
  HEAP8[($1 + 104 | 0) >> 0] = 2;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] | 0;
  $113 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  $39 = $113;
  HEAP16[(i64toi32_i32$2 + 106 | 0) >> 1] = $39;
  HEAP16[(i64toi32_i32$2 + 108 | 0) >> 1] = $39 >>> 16 | 0;
  HEAP16[(i64toi32_i32$2 + 110 | 0) >> 1] = i64toi32_i32$0;
  HEAP16[(i64toi32_i32$2 + 112 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
  $0 = $cardano_serialization_lib__Certificate_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hd9e6ef3cbd15ff20(i64toi32_i32$2 + 104 | 0 | 0) | 0;
  global$0 = i64toi32_i32$2 + 304 | 0;
  return $0 | 0;
 }
 
 function cardano_serialization_lib__crypto__Ed25519KeyHash__to_bech32__hac17e963a06e4032($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, $6 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $20 = 0, $5 = 0, $21 = 0, $26 = 0, $31 = 0, $56 = 0, $64 = 0;
  $4 = global$0 - 112 | 0;
  global$0 = $4;
  $5 = 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($4 + 16 | 0 | 0, 28 | 0, 0 | 0);
  HEAP32[($4 + 44 | 0) >> 2] = HEAP32[($4 + 20 | 0) >> 2] | 0;
  $6 = HEAP32[($4 + 16 | 0) >> 2] | 0;
  HEAP32[($4 + 40 | 0) >> 2] = $6;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $21 = i64toi32_i32$0;
  i64toi32_i32$0 = $6;
  $15 = $21;
  HEAP8[i64toi32_i32$0 >> 0] = $15;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $15 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $15 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $15 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $26 = i64toi32_i32$1;
  i64toi32_i32$1 = $6 + 8 | 0;
  $16 = $26;
  HEAP8[i64toi32_i32$1 >> 0] = $16;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $16 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $6 + 16 | 0;
  $17 = $31;
  HEAP8[i64toi32_i32$0 >> 0] = $17;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $17 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $17 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $17 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $18 = $1 + 24 | 0;
  $19 = $6 + 24 | 0;
  $20 = HEAPU8[$18 >> 0] | 0 | ((HEAPU8[($18 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($18 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($18 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  HEAP8[$19 >> 0] = $20;
  HEAP8[($19 + 1 | 0) >> 0] = $20 >>> 8 | 0;
  HEAP8[($19 + 2 | 0) >> 0] = $20 >>> 16 | 0;
  HEAP8[($19 + 3 | 0) >> 0] = $20 >>> 24 | 0;
  HEAP32[($4 + 48 | 0) >> 2] = 28;
  bech32__ToBase32__to_base32__h098342a721ba9592($4 + 80 | 0 | 0, $4 + 40 | 0 | 0);
  bech32__encode__h3845e4a9162a8761($4 + 24 | 0 | 0, $2 | 0, $3 | 0, $4 + 80 | 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[($4 + 24 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = $4 + 24 | 0 | 4 | 0;
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $56 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $56;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
    break label$1;
   }
   i64toi32_i32$2 = $4;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
   $64 = i64toi32_i32$0;
   i64toi32_i32$0 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] = $64;
   HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[(i64toi32_i32$2 + 100 | 0) >> 2] = 1;
   i64toi32_i32$0 = i64toi32_i32$2;
   i64toi32_i32$1 = 0;
   HEAP32[(i64toi32_i32$2 + 84 | 0) >> 2] = 1;
   HEAP32[(i64toi32_i32$2 + 88 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[(i64toi32_i32$2 + 80 | 0) >> 2] = 1066504;
   HEAP32[(i64toi32_i32$2 + 108 | 0) >> 2] = 113;
   HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] = i64toi32_i32$2 + 104 | 0;
   HEAP32[(i64toi32_i32$2 + 104 | 0) >> 2] = i64toi32_i32$2 + 56 | 0;
   alloc__fmt__format__h6e9e003a52c07309(i64toi32_i32$2 + 64 | 0 | 0, i64toi32_i32$2 + 80 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e(i64toi32_i32$2 + 8 | 0 | 0, i64toi32_i32$2 + 64 | 0 | 0);
   $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0 | 0, HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0 | 0) | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7(i64toi32_i32$2 + 64 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2(i64toi32_i32$2 + 64 | 0 | 0);
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   $5 = 1;
  }
  HEAP32[$0 >> 2] = $5;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($4 + 40 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($4 + 40 | 0 | 0);
  global$0 = $4 + 112 | 0;
 }
 
 function cardano_serialization_lib__crypto__ScriptHash__to_bech32__h3d04a5600baac36e($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, $6 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $20 = 0, $5 = 0, $21 = 0, $26 = 0, $31 = 0, $56 = 0, $64 = 0;
  $4 = global$0 - 112 | 0;
  global$0 = $4;
  $5 = 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($4 + 16 | 0 | 0, 28 | 0, 0 | 0);
  HEAP32[($4 + 44 | 0) >> 2] = HEAP32[($4 + 20 | 0) >> 2] | 0;
  $6 = HEAP32[($4 + 16 | 0) >> 2] | 0;
  HEAP32[($4 + 40 | 0) >> 2] = $6;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $21 = i64toi32_i32$0;
  i64toi32_i32$0 = $6;
  $15 = $21;
  HEAP8[i64toi32_i32$0 >> 0] = $15;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $15 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $15 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $15 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $26 = i64toi32_i32$1;
  i64toi32_i32$1 = $6 + 8 | 0;
  $16 = $26;
  HEAP8[i64toi32_i32$1 >> 0] = $16;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $16 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $6 + 16 | 0;
  $17 = $31;
  HEAP8[i64toi32_i32$0 >> 0] = $17;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $17 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $17 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $17 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $18 = $1 + 24 | 0;
  $19 = $6 + 24 | 0;
  $20 = HEAPU8[$18 >> 0] | 0 | ((HEAPU8[($18 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($18 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($18 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  HEAP8[$19 >> 0] = $20;
  HEAP8[($19 + 1 | 0) >> 0] = $20 >>> 8 | 0;
  HEAP8[($19 + 2 | 0) >> 0] = $20 >>> 16 | 0;
  HEAP8[($19 + 3 | 0) >> 0] = $20 >>> 24 | 0;
  HEAP32[($4 + 48 | 0) >> 2] = 28;
  bech32__ToBase32__to_base32__h098342a721ba9592($4 + 80 | 0 | 0, $4 + 40 | 0 | 0);
  bech32__encode__h3845e4a9162a8761($4 + 24 | 0 | 0, $2 | 0, $3 | 0, $4 + 80 | 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[($4 + 24 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = $4 + 24 | 0 | 4 | 0;
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $56 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $56;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
    break label$1;
   }
   i64toi32_i32$2 = $4;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
   $64 = i64toi32_i32$0;
   i64toi32_i32$0 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] = $64;
   HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[(i64toi32_i32$2 + 100 | 0) >> 2] = 1;
   i64toi32_i32$0 = i64toi32_i32$2;
   i64toi32_i32$1 = 0;
   HEAP32[(i64toi32_i32$2 + 84 | 0) >> 2] = 1;
   HEAP32[(i64toi32_i32$2 + 88 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[(i64toi32_i32$2 + 80 | 0) >> 2] = 1066504;
   HEAP32[(i64toi32_i32$2 + 108 | 0) >> 2] = 113;
   HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] = i64toi32_i32$2 + 104 | 0;
   HEAP32[(i64toi32_i32$2 + 104 | 0) >> 2] = i64toi32_i32$2 + 56 | 0;
   alloc__fmt__format__h6e9e003a52c07309(i64toi32_i32$2 + 64 | 0 | 0, i64toi32_i32$2 + 80 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e(i64toi32_i32$2 + 8 | 0 | 0, i64toi32_i32$2 + 64 | 0 | 0);
   $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0 | 0, HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0 | 0) | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7(i64toi32_i32$2 + 64 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2(i64toi32_i32$2 + 64 | 0 | 0);
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   $5 = 1;
  }
  HEAP32[$0 >> 2] = $5;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($4 + 40 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($4 + 40 | 0 | 0);
  global$0 = $4 + 112 | 0;
 }
 
 function cardano_serialization_lib__crypto__TransactionHash__to_bech32__hfed6c3e9814189d4($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, $6 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $5 = 0, $21 = 0, $26 = 0, $31 = 0, $36 = 0, $56 = 0, $64 = 0;
  $4 = global$0 - 112 | 0;
  global$0 = $4;
  $5 = 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($4 + 16 | 0 | 0, 32 | 0, 0 | 0);
  HEAP32[($4 + 44 | 0) >> 2] = HEAP32[($4 + 20 | 0) >> 2] | 0;
  $6 = HEAP32[($4 + 16 | 0) >> 2] | 0;
  HEAP32[($4 + 40 | 0) >> 2] = $6;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $21 = i64toi32_i32$0;
  i64toi32_i32$0 = $6;
  $16 = $21;
  HEAP8[i64toi32_i32$0 >> 0] = $16;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $16 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $26 = i64toi32_i32$1;
  i64toi32_i32$1 = $6 + 8 | 0;
  $17 = $26;
  HEAP8[i64toi32_i32$1 >> 0] = $17;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $6 + 16 | 0;
  $18 = $31;
  HEAP8[i64toi32_i32$0 >> 0] = $18;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $18 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $18 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $18 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 24 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $6 + 24 | 0;
  $19 = $36;
  HEAP8[i64toi32_i32$1 >> 0] = $19;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $19 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $19 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $19 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP32[($4 + 48 | 0) >> 2] = 32;
  bech32__ToBase32__to_base32__h098342a721ba9592($4 + 80 | 0 | 0, $4 + 40 | 0 | 0);
  bech32__encode__h3845e4a9162a8761($4 + 24 | 0 | 0, $2 | 0, $3 | 0, $4 + 80 | 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[($4 + 24 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = $4 + 24 | 0 | 4 | 0;
    i64toi32_i32$2 = $1;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $56 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $56;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
    break label$1;
   }
   i64toi32_i32$2 = $4;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
   $64 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] = $64;
   HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[(i64toi32_i32$2 + 100 | 0) >> 2] = 1;
   i64toi32_i32$1 = i64toi32_i32$2;
   i64toi32_i32$0 = 0;
   HEAP32[(i64toi32_i32$2 + 84 | 0) >> 2] = 1;
   HEAP32[(i64toi32_i32$2 + 88 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[(i64toi32_i32$2 + 80 | 0) >> 2] = 1066504;
   HEAP32[(i64toi32_i32$2 + 108 | 0) >> 2] = 113;
   HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] = i64toi32_i32$2 + 104 | 0;
   HEAP32[(i64toi32_i32$2 + 104 | 0) >> 2] = i64toi32_i32$2 + 56 | 0;
   alloc__fmt__format__h6e9e003a52c07309(i64toi32_i32$2 + 64 | 0 | 0, i64toi32_i32$2 + 80 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e(i64toi32_i32$2 + 8 | 0 | 0, i64toi32_i32$2 + 64 | 0 | 0);
   $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0 | 0, HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0 | 0) | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7(i64toi32_i32$2 + 64 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2(i64toi32_i32$2 + 64 | 0 | 0);
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   $5 = 1;
  }
  HEAP32[$0 >> 2] = $5;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($4 + 40 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($4 + 40 | 0 | 0);
  global$0 = $4 + 112 | 0;
 }
 
 function cardano_serialization_lib__crypto__GenesisDelegateHash__to_bech32__hd0d2ed4f98116dad($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, $6 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $20 = 0, $5 = 0, $21 = 0, $26 = 0, $31 = 0, $56 = 0, $64 = 0;
  $4 = global$0 - 112 | 0;
  global$0 = $4;
  $5 = 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($4 + 16 | 0 | 0, 28 | 0, 0 | 0);
  HEAP32[($4 + 44 | 0) >> 2] = HEAP32[($4 + 20 | 0) >> 2] | 0;
  $6 = HEAP32[($4 + 16 | 0) >> 2] | 0;
  HEAP32[($4 + 40 | 0) >> 2] = $6;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $21 = i64toi32_i32$0;
  i64toi32_i32$0 = $6;
  $15 = $21;
  HEAP8[i64toi32_i32$0 >> 0] = $15;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $15 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $15 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $15 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $26 = i64toi32_i32$1;
  i64toi32_i32$1 = $6 + 8 | 0;
  $16 = $26;
  HEAP8[i64toi32_i32$1 >> 0] = $16;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $16 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $6 + 16 | 0;
  $17 = $31;
  HEAP8[i64toi32_i32$0 >> 0] = $17;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $17 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $17 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $17 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $18 = $1 + 24 | 0;
  $19 = $6 + 24 | 0;
  $20 = HEAPU8[$18 >> 0] | 0 | ((HEAPU8[($18 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($18 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($18 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  HEAP8[$19 >> 0] = $20;
  HEAP8[($19 + 1 | 0) >> 0] = $20 >>> 8 | 0;
  HEAP8[($19 + 2 | 0) >> 0] = $20 >>> 16 | 0;
  HEAP8[($19 + 3 | 0) >> 0] = $20 >>> 24 | 0;
  HEAP32[($4 + 48 | 0) >> 2] = 28;
  bech32__ToBase32__to_base32__h098342a721ba9592($4 + 80 | 0 | 0, $4 + 40 | 0 | 0);
  bech32__encode__h3845e4a9162a8761($4 + 24 | 0 | 0, $2 | 0, $3 | 0, $4 + 80 | 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[($4 + 24 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = $4 + 24 | 0 | 4 | 0;
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $56 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $56;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
    break label$1;
   }
   i64toi32_i32$2 = $4;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
   $64 = i64toi32_i32$0;
   i64toi32_i32$0 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] = $64;
   HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[(i64toi32_i32$2 + 100 | 0) >> 2] = 1;
   i64toi32_i32$0 = i64toi32_i32$2;
   i64toi32_i32$1 = 0;
   HEAP32[(i64toi32_i32$2 + 84 | 0) >> 2] = 1;
   HEAP32[(i64toi32_i32$2 + 88 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[(i64toi32_i32$2 + 80 | 0) >> 2] = 1066504;
   HEAP32[(i64toi32_i32$2 + 108 | 0) >> 2] = 113;
   HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] = i64toi32_i32$2 + 104 | 0;
   HEAP32[(i64toi32_i32$2 + 104 | 0) >> 2] = i64toi32_i32$2 + 56 | 0;
   alloc__fmt__format__h6e9e003a52c07309(i64toi32_i32$2 + 64 | 0 | 0, i64toi32_i32$2 + 80 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e(i64toi32_i32$2 + 8 | 0 | 0, i64toi32_i32$2 + 64 | 0 | 0);
   $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0 | 0, HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0 | 0) | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7(i64toi32_i32$2 + 64 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2(i64toi32_i32$2 + 64 | 0 | 0);
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   $5 = 1;
  }
  HEAP32[$0 >> 2] = $5;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($4 + 40 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($4 + 40 | 0 | 0);
  global$0 = $4 + 112 | 0;
 }
 
 function cardano_serialization_lib__crypto__GenesisHash__to_bech32__hf37c9f3a6fa6385d($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, $6 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $20 = 0, $5 = 0, $21 = 0, $26 = 0, $31 = 0, $56 = 0, $64 = 0;
  $4 = global$0 - 112 | 0;
  global$0 = $4;
  $5 = 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($4 + 16 | 0 | 0, 28 | 0, 0 | 0);
  HEAP32[($4 + 44 | 0) >> 2] = HEAP32[($4 + 20 | 0) >> 2] | 0;
  $6 = HEAP32[($4 + 16 | 0) >> 2] | 0;
  HEAP32[($4 + 40 | 0) >> 2] = $6;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $21 = i64toi32_i32$0;
  i64toi32_i32$0 = $6;
  $15 = $21;
  HEAP8[i64toi32_i32$0 >> 0] = $15;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $15 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $15 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $15 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $26 = i64toi32_i32$1;
  i64toi32_i32$1 = $6 + 8 | 0;
  $16 = $26;
  HEAP8[i64toi32_i32$1 >> 0] = $16;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $16 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $6 + 16 | 0;
  $17 = $31;
  HEAP8[i64toi32_i32$0 >> 0] = $17;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $17 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $17 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $17 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $18 = $1 + 24 | 0;
  $19 = $6 + 24 | 0;
  $20 = HEAPU8[$18 >> 0] | 0 | ((HEAPU8[($18 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($18 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($18 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  HEAP8[$19 >> 0] = $20;
  HEAP8[($19 + 1 | 0) >> 0] = $20 >>> 8 | 0;
  HEAP8[($19 + 2 | 0) >> 0] = $20 >>> 16 | 0;
  HEAP8[($19 + 3 | 0) >> 0] = $20 >>> 24 | 0;
  HEAP32[($4 + 48 | 0) >> 2] = 28;
  bech32__ToBase32__to_base32__h098342a721ba9592($4 + 80 | 0 | 0, $4 + 40 | 0 | 0);
  bech32__encode__h3845e4a9162a8761($4 + 24 | 0 | 0, $2 | 0, $3 | 0, $4 + 80 | 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[($4 + 24 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = $4 + 24 | 0 | 4 | 0;
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $56 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $56;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
    break label$1;
   }
   i64toi32_i32$2 = $4;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
   $64 = i64toi32_i32$0;
   i64toi32_i32$0 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] = $64;
   HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[(i64toi32_i32$2 + 100 | 0) >> 2] = 1;
   i64toi32_i32$0 = i64toi32_i32$2;
   i64toi32_i32$1 = 0;
   HEAP32[(i64toi32_i32$2 + 84 | 0) >> 2] = 1;
   HEAP32[(i64toi32_i32$2 + 88 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[(i64toi32_i32$2 + 80 | 0) >> 2] = 1066504;
   HEAP32[(i64toi32_i32$2 + 108 | 0) >> 2] = 113;
   HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] = i64toi32_i32$2 + 104 | 0;
   HEAP32[(i64toi32_i32$2 + 104 | 0) >> 2] = i64toi32_i32$2 + 56 | 0;
   alloc__fmt__format__h6e9e003a52c07309(i64toi32_i32$2 + 64 | 0 | 0, i64toi32_i32$2 + 80 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e(i64toi32_i32$2 + 8 | 0 | 0, i64toi32_i32$2 + 64 | 0 | 0);
   $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0 | 0, HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0 | 0) | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7(i64toi32_i32$2 + 64 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2(i64toi32_i32$2 + 64 | 0 | 0);
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   $5 = 1;
  }
  HEAP32[$0 >> 2] = $5;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($4 + 40 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($4 + 40 | 0 | 0);
  global$0 = $4 + 112 | 0;
 }
 
 function cardano_serialization_lib__crypto__AuxiliaryDataHash__to_bech32__hb41828f08d68318b($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, $6 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $5 = 0, $21 = 0, $26 = 0, $31 = 0, $36 = 0, $56 = 0, $64 = 0;
  $4 = global$0 - 112 | 0;
  global$0 = $4;
  $5 = 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($4 + 16 | 0 | 0, 32 | 0, 0 | 0);
  HEAP32[($4 + 44 | 0) >> 2] = HEAP32[($4 + 20 | 0) >> 2] | 0;
  $6 = HEAP32[($4 + 16 | 0) >> 2] | 0;
  HEAP32[($4 + 40 | 0) >> 2] = $6;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $21 = i64toi32_i32$0;
  i64toi32_i32$0 = $6;
  $16 = $21;
  HEAP8[i64toi32_i32$0 >> 0] = $16;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $16 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $26 = i64toi32_i32$1;
  i64toi32_i32$1 = $6 + 8 | 0;
  $17 = $26;
  HEAP8[i64toi32_i32$1 >> 0] = $17;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $6 + 16 | 0;
  $18 = $31;
  HEAP8[i64toi32_i32$0 >> 0] = $18;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $18 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $18 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $18 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 24 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $6 + 24 | 0;
  $19 = $36;
  HEAP8[i64toi32_i32$1 >> 0] = $19;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $19 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $19 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $19 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP32[($4 + 48 | 0) >> 2] = 32;
  bech32__ToBase32__to_base32__h098342a721ba9592($4 + 80 | 0 | 0, $4 + 40 | 0 | 0);
  bech32__encode__h3845e4a9162a8761($4 + 24 | 0 | 0, $2 | 0, $3 | 0, $4 + 80 | 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[($4 + 24 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = $4 + 24 | 0 | 4 | 0;
    i64toi32_i32$2 = $1;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $56 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $56;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
    break label$1;
   }
   i64toi32_i32$2 = $4;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
   $64 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] = $64;
   HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[(i64toi32_i32$2 + 100 | 0) >> 2] = 1;
   i64toi32_i32$1 = i64toi32_i32$2;
   i64toi32_i32$0 = 0;
   HEAP32[(i64toi32_i32$2 + 84 | 0) >> 2] = 1;
   HEAP32[(i64toi32_i32$2 + 88 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[(i64toi32_i32$2 + 80 | 0) >> 2] = 1066504;
   HEAP32[(i64toi32_i32$2 + 108 | 0) >> 2] = 113;
   HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] = i64toi32_i32$2 + 104 | 0;
   HEAP32[(i64toi32_i32$2 + 104 | 0) >> 2] = i64toi32_i32$2 + 56 | 0;
   alloc__fmt__format__h6e9e003a52c07309(i64toi32_i32$2 + 64 | 0 | 0, i64toi32_i32$2 + 80 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e(i64toi32_i32$2 + 8 | 0 | 0, i64toi32_i32$2 + 64 | 0 | 0);
   $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0 | 0, HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0 | 0) | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7(i64toi32_i32$2 + 64 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2(i64toi32_i32$2 + 64 | 0 | 0);
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   $5 = 1;
  }
  HEAP32[$0 >> 2] = $5;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($4 + 40 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($4 + 40 | 0 | 0);
  global$0 = $4 + 112 | 0;
 }
 
 function cardano_serialization_lib__crypto__PoolMetadataHash__to_bech32__h104255386e83c6a6($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, $6 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $5 = 0, $21 = 0, $26 = 0, $31 = 0, $36 = 0, $56 = 0, $64 = 0;
  $4 = global$0 - 112 | 0;
  global$0 = $4;
  $5 = 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($4 + 16 | 0 | 0, 32 | 0, 0 | 0);
  HEAP32[($4 + 44 | 0) >> 2] = HEAP32[($4 + 20 | 0) >> 2] | 0;
  $6 = HEAP32[($4 + 16 | 0) >> 2] | 0;
  HEAP32[($4 + 40 | 0) >> 2] = $6;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $21 = i64toi32_i32$0;
  i64toi32_i32$0 = $6;
  $16 = $21;
  HEAP8[i64toi32_i32$0 >> 0] = $16;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $16 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $26 = i64toi32_i32$1;
  i64toi32_i32$1 = $6 + 8 | 0;
  $17 = $26;
  HEAP8[i64toi32_i32$1 >> 0] = $17;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $6 + 16 | 0;
  $18 = $31;
  HEAP8[i64toi32_i32$0 >> 0] = $18;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $18 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $18 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $18 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 24 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $6 + 24 | 0;
  $19 = $36;
  HEAP8[i64toi32_i32$1 >> 0] = $19;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $19 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $19 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $19 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP32[($4 + 48 | 0) >> 2] = 32;
  bech32__ToBase32__to_base32__h098342a721ba9592($4 + 80 | 0 | 0, $4 + 40 | 0 | 0);
  bech32__encode__h3845e4a9162a8761($4 + 24 | 0 | 0, $2 | 0, $3 | 0, $4 + 80 | 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[($4 + 24 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = $4 + 24 | 0 | 4 | 0;
    i64toi32_i32$2 = $1;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $56 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $56;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
    break label$1;
   }
   i64toi32_i32$2 = $4;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
   $64 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] = $64;
   HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[(i64toi32_i32$2 + 100 | 0) >> 2] = 1;
   i64toi32_i32$1 = i64toi32_i32$2;
   i64toi32_i32$0 = 0;
   HEAP32[(i64toi32_i32$2 + 84 | 0) >> 2] = 1;
   HEAP32[(i64toi32_i32$2 + 88 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[(i64toi32_i32$2 + 80 | 0) >> 2] = 1066504;
   HEAP32[(i64toi32_i32$2 + 108 | 0) >> 2] = 113;
   HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] = i64toi32_i32$2 + 104 | 0;
   HEAP32[(i64toi32_i32$2 + 104 | 0) >> 2] = i64toi32_i32$2 + 56 | 0;
   alloc__fmt__format__h6e9e003a52c07309(i64toi32_i32$2 + 64 | 0 | 0, i64toi32_i32$2 + 80 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e(i64toi32_i32$2 + 8 | 0 | 0, i64toi32_i32$2 + 64 | 0 | 0);
   $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0 | 0, HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0 | 0) | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7(i64toi32_i32$2 + 64 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2(i64toi32_i32$2 + 64 | 0 | 0);
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   $5 = 1;
  }
  HEAP32[$0 >> 2] = $5;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($4 + 40 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($4 + 40 | 0 | 0);
  global$0 = $4 + 112 | 0;
 }
 
 function cardano_serialization_lib__crypto__VRFKeyHash__to_bech32__h2782bba247e4ff4a($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, $6 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $5 = 0, $21 = 0, $26 = 0, $31 = 0, $36 = 0, $56 = 0, $64 = 0;
  $4 = global$0 - 112 | 0;
  global$0 = $4;
  $5 = 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($4 + 16 | 0 | 0, 32 | 0, 0 | 0);
  HEAP32[($4 + 44 | 0) >> 2] = HEAP32[($4 + 20 | 0) >> 2] | 0;
  $6 = HEAP32[($4 + 16 | 0) >> 2] | 0;
  HEAP32[($4 + 40 | 0) >> 2] = $6;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $21 = i64toi32_i32$0;
  i64toi32_i32$0 = $6;
  $16 = $21;
  HEAP8[i64toi32_i32$0 >> 0] = $16;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $16 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $26 = i64toi32_i32$1;
  i64toi32_i32$1 = $6 + 8 | 0;
  $17 = $26;
  HEAP8[i64toi32_i32$1 >> 0] = $17;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $6 + 16 | 0;
  $18 = $31;
  HEAP8[i64toi32_i32$0 >> 0] = $18;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $18 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $18 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $18 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 24 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $6 + 24 | 0;
  $19 = $36;
  HEAP8[i64toi32_i32$1 >> 0] = $19;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $19 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $19 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $19 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP32[($4 + 48 | 0) >> 2] = 32;
  bech32__ToBase32__to_base32__h098342a721ba9592($4 + 80 | 0 | 0, $4 + 40 | 0 | 0);
  bech32__encode__h3845e4a9162a8761($4 + 24 | 0 | 0, $2 | 0, $3 | 0, $4 + 80 | 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[($4 + 24 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = $4 + 24 | 0 | 4 | 0;
    i64toi32_i32$2 = $1;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $56 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $56;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
    break label$1;
   }
   i64toi32_i32$2 = $4;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
   $64 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] = $64;
   HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[(i64toi32_i32$2 + 100 | 0) >> 2] = 1;
   i64toi32_i32$1 = i64toi32_i32$2;
   i64toi32_i32$0 = 0;
   HEAP32[(i64toi32_i32$2 + 84 | 0) >> 2] = 1;
   HEAP32[(i64toi32_i32$2 + 88 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[(i64toi32_i32$2 + 80 | 0) >> 2] = 1066504;
   HEAP32[(i64toi32_i32$2 + 108 | 0) >> 2] = 113;
   HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] = i64toi32_i32$2 + 104 | 0;
   HEAP32[(i64toi32_i32$2 + 104 | 0) >> 2] = i64toi32_i32$2 + 56 | 0;
   alloc__fmt__format__h6e9e003a52c07309(i64toi32_i32$2 + 64 | 0 | 0, i64toi32_i32$2 + 80 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e(i64toi32_i32$2 + 8 | 0 | 0, i64toi32_i32$2 + 64 | 0 | 0);
   $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0 | 0, HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0 | 0) | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7(i64toi32_i32$2 + 64 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2(i64toi32_i32$2 + 64 | 0 | 0);
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   $5 = 1;
  }
  HEAP32[$0 >> 2] = $5;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($4 + 40 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($4 + 40 | 0 | 0);
  global$0 = $4 + 112 | 0;
 }
 
 function cardano_serialization_lib__crypto__BlockHash__to_bech32__h6e6c8be6807230d3($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, $6 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $5 = 0, $21 = 0, $26 = 0, $31 = 0, $36 = 0, $56 = 0, $64 = 0;
  $4 = global$0 - 112 | 0;
  global$0 = $4;
  $5 = 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($4 + 16 | 0 | 0, 32 | 0, 0 | 0);
  HEAP32[($4 + 44 | 0) >> 2] = HEAP32[($4 + 20 | 0) >> 2] | 0;
  $6 = HEAP32[($4 + 16 | 0) >> 2] | 0;
  HEAP32[($4 + 40 | 0) >> 2] = $6;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $21 = i64toi32_i32$0;
  i64toi32_i32$0 = $6;
  $16 = $21;
  HEAP8[i64toi32_i32$0 >> 0] = $16;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $16 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $26 = i64toi32_i32$1;
  i64toi32_i32$1 = $6 + 8 | 0;
  $17 = $26;
  HEAP8[i64toi32_i32$1 >> 0] = $17;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $6 + 16 | 0;
  $18 = $31;
  HEAP8[i64toi32_i32$0 >> 0] = $18;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $18 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $18 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $18 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 24 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $6 + 24 | 0;
  $19 = $36;
  HEAP8[i64toi32_i32$1 >> 0] = $19;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $19 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $19 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $19 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP32[($4 + 48 | 0) >> 2] = 32;
  bech32__ToBase32__to_base32__h098342a721ba9592($4 + 80 | 0 | 0, $4 + 40 | 0 | 0);
  bech32__encode__h3845e4a9162a8761($4 + 24 | 0 | 0, $2 | 0, $3 | 0, $4 + 80 | 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[($4 + 24 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = $4 + 24 | 0 | 4 | 0;
    i64toi32_i32$2 = $1;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $56 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $56;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
    break label$1;
   }
   i64toi32_i32$2 = $4;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
   $64 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] = $64;
   HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[(i64toi32_i32$2 + 100 | 0) >> 2] = 1;
   i64toi32_i32$1 = i64toi32_i32$2;
   i64toi32_i32$0 = 0;
   HEAP32[(i64toi32_i32$2 + 84 | 0) >> 2] = 1;
   HEAP32[(i64toi32_i32$2 + 88 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[(i64toi32_i32$2 + 80 | 0) >> 2] = 1066504;
   HEAP32[(i64toi32_i32$2 + 108 | 0) >> 2] = 113;
   HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] = i64toi32_i32$2 + 104 | 0;
   HEAP32[(i64toi32_i32$2 + 104 | 0) >> 2] = i64toi32_i32$2 + 56 | 0;
   alloc__fmt__format__h6e9e003a52c07309(i64toi32_i32$2 + 64 | 0 | 0, i64toi32_i32$2 + 80 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e(i64toi32_i32$2 + 8 | 0 | 0, i64toi32_i32$2 + 64 | 0 | 0);
   $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0 | 0, HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0 | 0) | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7(i64toi32_i32$2 + 64 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2(i64toi32_i32$2 + 64 | 0 | 0);
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   $5 = 1;
  }
  HEAP32[$0 >> 2] = $5;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($4 + 40 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($4 + 40 | 0 | 0);
  global$0 = $4 + 112 | 0;
 }
 
 function cardano_serialization_lib__crypto__DataHash__to_bech32__h80ffb4e1c54d9836($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, $6 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $5 = 0, $21 = 0, $26 = 0, $31 = 0, $36 = 0, $56 = 0, $64 = 0;
  $4 = global$0 - 112 | 0;
  global$0 = $4;
  $5 = 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($4 + 16 | 0 | 0, 32 | 0, 0 | 0);
  HEAP32[($4 + 44 | 0) >> 2] = HEAP32[($4 + 20 | 0) >> 2] | 0;
  $6 = HEAP32[($4 + 16 | 0) >> 2] | 0;
  HEAP32[($4 + 40 | 0) >> 2] = $6;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $21 = i64toi32_i32$0;
  i64toi32_i32$0 = $6;
  $16 = $21;
  HEAP8[i64toi32_i32$0 >> 0] = $16;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $16 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $26 = i64toi32_i32$1;
  i64toi32_i32$1 = $6 + 8 | 0;
  $17 = $26;
  HEAP8[i64toi32_i32$1 >> 0] = $17;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $6 + 16 | 0;
  $18 = $31;
  HEAP8[i64toi32_i32$0 >> 0] = $18;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $18 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $18 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $18 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 24 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $6 + 24 | 0;
  $19 = $36;
  HEAP8[i64toi32_i32$1 >> 0] = $19;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $19 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $19 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $19 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP32[($4 + 48 | 0) >> 2] = 32;
  bech32__ToBase32__to_base32__h098342a721ba9592($4 + 80 | 0 | 0, $4 + 40 | 0 | 0);
  bech32__encode__h3845e4a9162a8761($4 + 24 | 0 | 0, $2 | 0, $3 | 0, $4 + 80 | 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[($4 + 24 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = $4 + 24 | 0 | 4 | 0;
    i64toi32_i32$2 = $1;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $56 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $56;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
    break label$1;
   }
   i64toi32_i32$2 = $4;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
   $64 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] = $64;
   HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[(i64toi32_i32$2 + 100 | 0) >> 2] = 1;
   i64toi32_i32$1 = i64toi32_i32$2;
   i64toi32_i32$0 = 0;
   HEAP32[(i64toi32_i32$2 + 84 | 0) >> 2] = 1;
   HEAP32[(i64toi32_i32$2 + 88 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[(i64toi32_i32$2 + 80 | 0) >> 2] = 1066504;
   HEAP32[(i64toi32_i32$2 + 108 | 0) >> 2] = 113;
   HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] = i64toi32_i32$2 + 104 | 0;
   HEAP32[(i64toi32_i32$2 + 104 | 0) >> 2] = i64toi32_i32$2 + 56 | 0;
   alloc__fmt__format__h6e9e003a52c07309(i64toi32_i32$2 + 64 | 0 | 0, i64toi32_i32$2 + 80 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e(i64toi32_i32$2 + 8 | 0 | 0, i64toi32_i32$2 + 64 | 0 | 0);
   $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0 | 0, HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0 | 0) | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7(i64toi32_i32$2 + 64 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2(i64toi32_i32$2 + 64 | 0 | 0);
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   $5 = 1;
  }
  HEAP32[$0 >> 2] = $5;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($4 + 40 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($4 + 40 | 0 | 0);
  global$0 = $4 + 112 | 0;
 }
 
 function cardano_serialization_lib__crypto__ScriptDataHash__to_bech32__h3992687932b4f633($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, $6 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $5 = 0, $21 = 0, $26 = 0, $31 = 0, $36 = 0, $56 = 0, $64 = 0;
  $4 = global$0 - 112 | 0;
  global$0 = $4;
  $5 = 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($4 + 16 | 0 | 0, 32 | 0, 0 | 0);
  HEAP32[($4 + 44 | 0) >> 2] = HEAP32[($4 + 20 | 0) >> 2] | 0;
  $6 = HEAP32[($4 + 16 | 0) >> 2] | 0;
  HEAP32[($4 + 40 | 0) >> 2] = $6;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $21 = i64toi32_i32$0;
  i64toi32_i32$0 = $6;
  $16 = $21;
  HEAP8[i64toi32_i32$0 >> 0] = $16;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $16 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $26 = i64toi32_i32$1;
  i64toi32_i32$1 = $6 + 8 | 0;
  $17 = $26;
  HEAP8[i64toi32_i32$1 >> 0] = $17;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $6 + 16 | 0;
  $18 = $31;
  HEAP8[i64toi32_i32$0 >> 0] = $18;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $18 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $18 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $18 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 24 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $6 + 24 | 0;
  $19 = $36;
  HEAP8[i64toi32_i32$1 >> 0] = $19;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $19 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $19 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $19 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP32[($4 + 48 | 0) >> 2] = 32;
  bech32__ToBase32__to_base32__h098342a721ba9592($4 + 80 | 0 | 0, $4 + 40 | 0 | 0);
  bech32__encode__h3845e4a9162a8761($4 + 24 | 0 | 0, $2 | 0, $3 | 0, $4 + 80 | 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[($4 + 24 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = $4 + 24 | 0 | 4 | 0;
    i64toi32_i32$2 = $1;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $56 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $56;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
    break label$1;
   }
   i64toi32_i32$2 = $4;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
   $64 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] = $64;
   HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[(i64toi32_i32$2 + 100 | 0) >> 2] = 1;
   i64toi32_i32$1 = i64toi32_i32$2;
   i64toi32_i32$0 = 0;
   HEAP32[(i64toi32_i32$2 + 84 | 0) >> 2] = 1;
   HEAP32[(i64toi32_i32$2 + 88 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[(i64toi32_i32$2 + 80 | 0) >> 2] = 1066504;
   HEAP32[(i64toi32_i32$2 + 108 | 0) >> 2] = 113;
   HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] = i64toi32_i32$2 + 104 | 0;
   HEAP32[(i64toi32_i32$2 + 104 | 0) >> 2] = i64toi32_i32$2 + 56 | 0;
   alloc__fmt__format__h6e9e003a52c07309(i64toi32_i32$2 + 64 | 0 | 0, i64toi32_i32$2 + 80 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e(i64toi32_i32$2 + 8 | 0 | 0, i64toi32_i32$2 + 64 | 0 | 0);
   $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0 | 0, HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0 | 0) | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7(i64toi32_i32$2 + 64 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2(i64toi32_i32$2 + 64 | 0 | 0);
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   $5 = 1;
  }
  HEAP32[$0 >> 2] = $5;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($4 + 40 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($4 + 40 | 0 | 0);
  global$0 = $4 + 112 | 0;
 }
 
 function cardano_serialization_lib__crypto__VRFVKey__to_bech32__h19adebd14626c989($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, $6 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $5 = 0, $21 = 0, $26 = 0, $31 = 0, $36 = 0, $56 = 0, $64 = 0;
  $4 = global$0 - 112 | 0;
  global$0 = $4;
  $5 = 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($4 + 16 | 0 | 0, 32 | 0, 0 | 0);
  HEAP32[($4 + 44 | 0) >> 2] = HEAP32[($4 + 20 | 0) >> 2] | 0;
  $6 = HEAP32[($4 + 16 | 0) >> 2] | 0;
  HEAP32[($4 + 40 | 0) >> 2] = $6;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $21 = i64toi32_i32$0;
  i64toi32_i32$0 = $6;
  $16 = $21;
  HEAP8[i64toi32_i32$0 >> 0] = $16;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $16 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $26 = i64toi32_i32$1;
  i64toi32_i32$1 = $6 + 8 | 0;
  $17 = $26;
  HEAP8[i64toi32_i32$1 >> 0] = $17;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $6 + 16 | 0;
  $18 = $31;
  HEAP8[i64toi32_i32$0 >> 0] = $18;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $18 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $18 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $18 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 24 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $6 + 24 | 0;
  $19 = $36;
  HEAP8[i64toi32_i32$1 >> 0] = $19;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $19 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $19 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $19 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP32[($4 + 48 | 0) >> 2] = 32;
  bech32__ToBase32__to_base32__h098342a721ba9592($4 + 80 | 0 | 0, $4 + 40 | 0 | 0);
  bech32__encode__h3845e4a9162a8761($4 + 24 | 0 | 0, $2 | 0, $3 | 0, $4 + 80 | 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[($4 + 24 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = $4 + 24 | 0 | 4 | 0;
    i64toi32_i32$2 = $1;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $56 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $56;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
    break label$1;
   }
   i64toi32_i32$2 = $4;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
   $64 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] = $64;
   HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[(i64toi32_i32$2 + 100 | 0) >> 2] = 1;
   i64toi32_i32$1 = i64toi32_i32$2;
   i64toi32_i32$0 = 0;
   HEAP32[(i64toi32_i32$2 + 84 | 0) >> 2] = 1;
   HEAP32[(i64toi32_i32$2 + 88 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[(i64toi32_i32$2 + 80 | 0) >> 2] = 1066504;
   HEAP32[(i64toi32_i32$2 + 108 | 0) >> 2] = 113;
   HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] = i64toi32_i32$2 + 104 | 0;
   HEAP32[(i64toi32_i32$2 + 104 | 0) >> 2] = i64toi32_i32$2 + 56 | 0;
   alloc__fmt__format__h6e9e003a52c07309(i64toi32_i32$2 + 64 | 0 | 0, i64toi32_i32$2 + 80 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e(i64toi32_i32$2 + 8 | 0 | 0, i64toi32_i32$2 + 64 | 0 | 0);
   $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0 | 0, HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0 | 0) | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7(i64toi32_i32$2 + 64 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2(i64toi32_i32$2 + 64 | 0 | 0);
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   $5 = 1;
  }
  HEAP32[$0 >> 2] = $5;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($4 + 40 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($4 + 40 | 0 | 0);
  global$0 = $4 + 112 | 0;
 }
 
 function cardano_serialization_lib__crypto__KESVKey__to_bech32__h403d0a9a0cfb94ca($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, $6 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $5 = 0, $21 = 0, $26 = 0, $31 = 0, $36 = 0, $56 = 0, $64 = 0;
  $4 = global$0 - 112 | 0;
  global$0 = $4;
  $5 = 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($4 + 16 | 0 | 0, 32 | 0, 0 | 0);
  HEAP32[($4 + 44 | 0) >> 2] = HEAP32[($4 + 20 | 0) >> 2] | 0;
  $6 = HEAP32[($4 + 16 | 0) >> 2] | 0;
  HEAP32[($4 + 40 | 0) >> 2] = $6;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $21 = i64toi32_i32$0;
  i64toi32_i32$0 = $6;
  $16 = $21;
  HEAP8[i64toi32_i32$0 >> 0] = $16;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $16 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $26 = i64toi32_i32$1;
  i64toi32_i32$1 = $6 + 8 | 0;
  $17 = $26;
  HEAP8[i64toi32_i32$1 >> 0] = $17;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $6 + 16 | 0;
  $18 = $31;
  HEAP8[i64toi32_i32$0 >> 0] = $18;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $18 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $18 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $18 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 24 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $6 + 24 | 0;
  $19 = $36;
  HEAP8[i64toi32_i32$1 >> 0] = $19;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $19 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $19 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $19 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP32[($4 + 48 | 0) >> 2] = 32;
  bech32__ToBase32__to_base32__h098342a721ba9592($4 + 80 | 0 | 0, $4 + 40 | 0 | 0);
  bech32__encode__h3845e4a9162a8761($4 + 24 | 0 | 0, $2 | 0, $3 | 0, $4 + 80 | 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[($4 + 24 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = $4 + 24 | 0 | 4 | 0;
    i64toi32_i32$2 = $1;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $56 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $56;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
    break label$1;
   }
   i64toi32_i32$2 = $4;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
   $64 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] = $64;
   HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[(i64toi32_i32$2 + 100 | 0) >> 2] = 1;
   i64toi32_i32$1 = i64toi32_i32$2;
   i64toi32_i32$0 = 0;
   HEAP32[(i64toi32_i32$2 + 84 | 0) >> 2] = 1;
   HEAP32[(i64toi32_i32$2 + 88 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[(i64toi32_i32$2 + 80 | 0) >> 2] = 1066504;
   HEAP32[(i64toi32_i32$2 + 108 | 0) >> 2] = 113;
   HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] = i64toi32_i32$2 + 104 | 0;
   HEAP32[(i64toi32_i32$2 + 104 | 0) >> 2] = i64toi32_i32$2 + 56 | 0;
   alloc__fmt__format__h6e9e003a52c07309(i64toi32_i32$2 + 64 | 0 | 0, i64toi32_i32$2 + 80 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e(i64toi32_i32$2 + 8 | 0 | 0, i64toi32_i32$2 + 64 | 0 | 0);
   $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0 | 0, HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0 | 0) | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7(i64toi32_i32$2 + 64 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2(i64toi32_i32$2 + 64 | 0 | 0);
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   $5 = 1;
  }
  HEAP32[$0 >> 2] = $5;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($4 + 40 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($4 + 40 | 0 | 0);
  global$0 = $4 + 112 | 0;
 }
 
 function $cardano_serialization_lib__plutus__PlutusDataEnum_20as_20core__clone__Clone___clone__h7a95fc7c6f531f3b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $4 = 0, $4$hi = 0, $5 = 0, $23 = 0, $44 = 0, $52 = 0, $59 = 0, $3 = 0, $5$hi = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    switch (HEAP32[$1 >> 2] | 0 | 0) {
    default:
     i64toi32_i32$2 = $1 + 8 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $4 = i64toi32_i32$0;
     $4$hi = i64toi32_i32$1;
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hc831120dea694494($0 + 16 | 0 | 0, $1 + 16 | 0 | 0);
     i64toi32_i32$0 = $0 + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $4;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[$0 >> 2] = 0;
     $23 = $0 + 28 | 0;
     $0 = HEAPU8[($1 + 28 | 0) >> 0] | 0;
     HEAP8[$23 >> 0] = ($0 | 0) == (2 | 0) ? 2 : ($0 | 0) != (0 | 0);
     break label$1;
    case 1:
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__hf4eb1bac8cecd8c9($2 + 16 | 0 | 0, $1 + 4 | 0 | 0);
     HEAP32[$0 >> 2] = 1;
     HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($2 + 24 | 0) >> 2] | 0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
     $44 = i64toi32_i32$1;
     i64toi32_i32$1 = $0;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $44;
     HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
     break label$1;
    case 2:
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hc831120dea694494($2 + 16 | 0 | 0, $1 + 4 | 0 | 0);
     HEAP32[$0 >> 2] = 2;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
     $52 = i64toi32_i32$0;
     i64toi32_i32$0 = $0;
     HEAP32[($0 + 4 | 0) >> 2] = $52;
     HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($2 + 24 | 0) >> 2] | 0;
     $59 = $0 + 16 | 0;
     $0 = HEAPU8[($1 + 16 | 0) >> 0] | 0;
     HEAP8[$59 >> 0] = ($0 | 0) == (2 | 0) ? 2 : ($0 | 0) != (0 | 0);
     break label$1;
    case 3:
     $3 = HEAPU8[($1 + 16 | 0) >> 0] | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hd36b5d149e6fd98b($2 + 16 | 0 | 0, $1 + 4 | 0 | 0);
     HEAP8[($2 + 28 | 0) >> 0] = $3;
     i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $4 = i64toi32_i32$1;
     $4$hi = i64toi32_i32$0;
     i64toi32_i32$1 = $2 + 8 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $4;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
     $5 = i64toi32_i32$0;
     $5$hi = i64toi32_i32$1;
     i64toi32_i32$0 = $2;
     HEAP32[$2 >> 2] = $5;
     HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $4$hi;
     i64toi32_i32$0 = $0 + 12 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $4;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $5$hi;
     i64toi32_i32$0 = $0;
     HEAP32[($0 + 4 | 0) >> 2] = $5;
     HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[$0 >> 2] = 3;
     break label$1;
    case 4:
     break label$2;
    };
   }
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($0 + 4 | 0 | 0, $1 + 4 | 0 | 0);
   HEAP32[$0 >> 2] = 4;
  }
  global$0 = $2 + 32 | 0;
 }
 
 function hashbrown__map__HashMap_K_2cV_2cS_2cA___insert__h106f59cab43fe932($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, $5 = 0, $16 = 0, $17 = 0, $3 = 0, $6 = 0, $7 = 0, $8 = 0, $8$hi = 0, $101 = 0, $105 = 0, $108 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  i64toi32_i32$0 = hashbrown__map__make_insert_hash__hb67cad89ed6c0ea0($0 | 0, $1 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  $3 = i64toi32_i32$0;
  $4 = (HEAP32[($0 + 16 | 0) >> 2] | 0) & i64toi32_i32$0 | 0;
  $16 = (HEAP32[($0 + 20 | 0) >> 2] | 0) + $4 | 0;
  $5 = HEAPU8[$16 >> 0] | 0 | ((HEAPU8[($16 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($16 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($16 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $6 = 0;
  $7 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[$7 >> 2] = 0;
  HEAP32[($2 + 28 | 0) >> 2] = $5;
  HEAP32[($2 + 20 | 0) >> 2] = $4;
  $4 = $0 + 16 | 0;
  HEAP32[($2 + 16 | 0) >> 2] = $4;
  $3 = i64toi32_i32$0 >>> 25 | 0;
  HEAP8[($2 + 36 | 0) >> 0] = $3;
  $5 = $5 ^ Math_imul($3, 16843009) | 0;
  HEAP32[($2 + 32 | 0) >> 2] = (($5 ^ -1 | 0) & ($5 + -16843009 | 0) | 0) & -2139062144 | 0;
  $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  label$1 : {
   label$2 : {
    if (!(HEAP32[($2 + 8 | 0) >> 2] | 0)) {
     break label$2
    }
    label$3 : {
     if (!(memcmp($1 | 0, ((HEAP32[((HEAP32[($2 + 16 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) + Math_imul(0 - (HEAP32[($2 + 12 | 0) >> 2] | 0) | 0, 28) | 0) + -28 | 0 | 0, 28 | 0) | 0)) {
      break label$3
     }
     label$4 : while (1) {
      $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($2 | 0, $2 + 16 | 0 | 0);
      if (!(HEAP32[$2 >> 2] | 0)) {
       break label$2
      }
      if (memcmp($1 | 0, ((HEAP32[((HEAP32[($2 + 16 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) + Math_imul(0 - (HEAP32[($2 + 4 | 0) >> 2] | 0) | 0, 28) | 0) + -28 | 0 | 0, 28 | 0) | 0) {
       continue label$4
      }
      break label$4;
     };
    }
    $6 = 1;
    break label$1;
   }
   $17 = $1 + 24 | 0;
   HEAP32[(($2 + 16 | 0) + 24 | 0) >> 2] = HEAPU8[$17 >> 0] | 0 | ((HEAPU8[($17 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($17 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($17 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$2 = $1 + 16 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $101 = i64toi32_i32$1;
   i64toi32_i32$1 = ($2 + 16 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $101;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $1 + 8 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $105 = i64toi32_i32$0;
   i64toi32_i32$0 = $7;
   HEAP32[i64toi32_i32$0 >> 2] = $105;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $108 = i64toi32_i32$1;
   i64toi32_i32$1 = $2;
   HEAP32[($2 + 16 | 0) >> 2] = $108;
   HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $8$hi;
   hashbrown__raw__RawTable_T_2cA___insert__hf300f52f075b064e($4 | 0, $8 | 0, i64toi32_i32$0 | 0, $2 + 16 | 0 | 0, $0 | 0) | 0;
  }
  global$0 = $2 + 48 | 0;
  return $6 | 0;
 }
 
 function $cardano_serialization_lib__plutus__Costmdls_20as_20cbor_event__se__Serialize___serialize__h651d2db00a62edc7($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $31 = 0, $38 = 0, $41 = 0;
  $3 = global$0 - 128 | 0;
  global$0 = $3;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 + 80 | 0 | 0, $2 | 0, 5 | 0, i64toi32_i32$0 | 0, i64toi32_i32$1 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ((HEAP32[($3 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
        break label$5
       }
       alloc__collections__btree__map__BTreeMap_K_2cV___iter__h351d422ab5212013($3 + 16 | 0 | 0, $1 | 0);
       HEAP32[(($3 + 48 | 0) + 24 | 0) >> 2] = HEAP32[(($3 + 16 | 0) + 24 | 0) >> 2] | 0;
       i64toi32_i32$2 = ($3 + 16 | 0) + 16 | 0;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $31 = i64toi32_i32$1;
       i64toi32_i32$1 = ($3 + 48 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $31;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = ($3 + 16 | 0) + 8 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $38 = i64toi32_i32$0;
       i64toi32_i32$0 = ($3 + 48 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $38;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $3;
       i64toi32_i32$1 = HEAP32[($3 + 16 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[($3 + 20 | 0) >> 2] | 0;
       $41 = i64toi32_i32$1;
       i64toi32_i32$1 = $3;
       HEAP32[($3 + 48 | 0) >> 2] = $41;
       HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$0;
       $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__ha538daa28fd542ac($3 + 8 | 0 | 0, $3 + 48 | 0 | 0);
       label$6 : {
        if (!(HEAP32[($3 + 8 | 0) >> 2] | 0)) {
         break label$6
        }
        $1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
        label$7 : while (1) {
         i64toi32_i32$0 = 0;
         cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 + 80 | 0 | 0, $2 | 0, 0 | 0, 0 | 0, i64toi32_i32$0 | 0);
         if ((HEAP32[($3 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
          break label$4
         }
         $cardano_serialization_lib__plutus__CostModel_20as_20cbor_event__se__Serialize___serialize__h29052229a88c8bb1($3 + 80 | 0 | 0, $1 | 0, $2 | 0);
         if ((HEAP32[($3 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
          break label$3
         }
         $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__ha538daa28fd542ac($3 | 0, $3 + 48 | 0 | 0);
         $1 = HEAP32[($3 + 4 | 0) >> 2] | 0;
         if (HEAP32[$3 >> 2] | 0) {
          continue label$7
         }
         break label$7;
        };
       }
       HEAP32[$0 >> 2] = 0;
       HEAP32[($0 + 4 | 0) >> 2] = $2;
       break label$1;
      }
      memcpy($0 + 8 | 0 | 0, ($3 + 80 | 0) + 8 | 0 | 0, 40 | 0) | 0;
      HEAP32[$0 >> 2] = 1;
      break label$1;
     }
     memcpy($0 + 8 | 0 | 0, ($3 + 80 | 0) + 8 | 0 | 0, 40 | 0) | 0;
     break label$2;
    }
    memcpy($0 + 8 | 0 | 0, ($3 + 80 | 0) + 8 | 0 | 0, 40 | 0) | 0;
   }
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $3 + 128 | 0;
 }
 
 function alloc__collections__btree__map__entry__VacantEntry_K_2cV___insert__h01793c8bfa88cb39($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $5 = 0, $8 = 0, $4 = 0, i64toi32_i32$1 = 0, $3 = 0, $6 = 0, $7 = 0;
  $2 = global$0 - 448 | 0;
  global$0 = $2;
  HEAP32[(($2 + 312 | 0) + 8 | 0) >> 2] = HEAP32[($0 + 44 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($0 + 40 | 0) >> 2] | 0;
  HEAP32[($2 + 312 | 0) >> 2] = HEAP32[($0 + 36 | 0) >> 2] | 0;
  HEAP32[($2 + 316 | 0) >> 2] = i64toi32_i32$1;
  memcpy($2 + 352 | 0 | 0, $0 | 0, 36 | 0) | 0;
  memcpy($2 + 168 | 0 | 0, $1 | 0, 96 | 0) | 0;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_recursing__hadedfb0a053ce437($2 | 0, $2 + 312 | 0 | 0, $2 + 352 | 0 | 0, $2 + 168 | 0 | 0);
  $3 = HEAP32[($2 + 160 | 0) >> 2] | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[$2 >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     $0 = HEAP32[($0 + 48 | 0) >> 2] | 0;
     HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
     break label$2;
    }
    $4 = $2 + 8 | 0;
    memcpy($2 + 168 | 0 | 0, $4 | 0, 136 | 0) | 0;
    $0 = HEAP32[($0 + 48 | 0) >> 2] | 0;
    $5 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    if (!$5) {
     break label$1
    }
    $6 = HEAP32[($2 + 156 | 0) >> 2] | 0;
    $7 = HEAP32[($2 + 152 | 0) >> 2] | 0;
    $8 = HEAP32[$0 >> 2] | 0;
    $1 = alloc__boxed__Box_T_2cA___new_uninit_in__h3c49993511c7b2e3() | 0;
    HEAP32[($1 + 1464 | 0) >> 2] = $5;
    HEAP16[($1 + 1458 | 0) >> 1] = 0;
    HEAP32[($1 + 1056 | 0) >> 2] = 0;
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    $8 = $8 + 1 | 0;
    HEAP32[$0 >> 2] = $8;
    HEAP16[($5 + 1456 | 0) >> 1] = 0;
    HEAP32[($5 + 1056 | 0) >> 2] = $1;
    HEAP32[($2 + 308 | 0) >> 2] = $1;
    HEAP32[($2 + 304 | 0) >> 2] = $8;
    memcpy($2 + 312 | 0 | 0, $4 | 0, 36 | 0) | 0;
    memcpy($2 + 352 | 0 | 0, $2 + 208 | 0 | 0, 96 | 0) | 0;
    alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal___push__h1a08f428e14b4c52($2 + 304 | 0 | 0, $2 + 312 | 0 | 0, $2 + 352 | 0 | 0, $7 | 0, $6 | 0);
    HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
   }
   global$0 = $2 + 448 | 0;
   return $3 | 0;
  }
  core__panicking__panic__h2fd385a887c8bf13(1072048 | 0, 43 | 0, 1072248 | 0);
  abort();
 }
 
 function $cardano_serialization_lib__metadata__TransactionMetadatum_20as_20core__cmp__PartialEq___eq__h3bd33dd828bf70c0($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $3 = 0, i64toi32_i32$3 = 0, $4 = 0, $5 = 0, $54 = 0, $54$hi = 0, $57 = 0, $57$hi = 0, $58 = 0, $58$hi = 0, $61 = 0, $61$hi = 0, $64 = 0, $64$hi = 0, $65 = 0, $65$hi = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  $3 = 0;
  label$1 : {
   $4 = HEAP32[$0 >> 2] | 0;
   if (($4 | 0) != (HEAP32[$1 >> 2] | 0 | 0)) {
    break label$1
   }
   label$2 : {
    switch ($4 | 0) {
    default:
     $3 = $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__cmp__PartialEq___eq__h47be0878df6ae947($0 + 8 | 0 | 0, $1 + 8 | 0 | 0) | 0;
     break label$1;
    case 1:
     $5 = HEAP32[($0 + 12 | 0) >> 2] | 0;
     if (($5 | 0) != (HEAP32[($1 + 12 | 0) >> 2] | 0 | 0)) {
      break label$1
     }
     $1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $3 = HEAP32[($0 + 4 | 0) >> 2] | 0;
     $0 = 0;
     label$7 : {
      label$8 : while (1) {
       label$9 : {
        if (($5 | 0) != ($0 | 0)) {
         break label$9
        }
        $0 = $5;
        break label$7;
       }
       $0 = $0 + 1 | 0;
       $4 = $cardano_serialization_lib__metadata__TransactionMetadatumEnum_20as_20core__cmp__PartialEq___eq__h1b9ad18ad9a7fd9d($3 | 0, $1 | 0) | 0;
       $3 = $3 + 48 | 0;
       $1 = $1 + 48 | 0;
       if ($4) {
        continue label$8
       }
       break label$8;
      };
      $0 = $0 + -1 | 0;
     }
     $3 = $0 >>> 0 >= $5 >>> 0;
     break label$1;
    case 2:
     i64toi32_i32$2 = $0 + 8 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $54 = i64toi32_i32$0;
     $54$hi = i64toi32_i32$1;
     i64toi32_i32$2 = $1 + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $57 = i64toi32_i32$1;
     $57$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $54$hi;
     i64toi32_i32$2 = $54;
     i64toi32_i32$1 = $57$hi;
     i64toi32_i32$3 = $57;
     i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
     $58 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $58$hi = i64toi32_i32$1;
     i64toi32_i32$0 = $0 + 16 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $61 = i64toi32_i32$1;
     $61$hi = i64toi32_i32$2;
     i64toi32_i32$0 = $1 + 16 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $64 = i64toi32_i32$2;
     $64$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $61$hi;
     i64toi32_i32$0 = $61;
     i64toi32_i32$2 = $64$hi;
     i64toi32_i32$3 = $64;
     i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
     $65 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $65$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $58$hi;
     i64toi32_i32$1 = $58;
     i64toi32_i32$0 = $65$hi;
     i64toi32_i32$3 = $65;
     i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
     $3 = !(i64toi32_i32$1 | i64toi32_i32$3 | 0 | i64toi32_i32$0 | 0);
     break label$1;
    case 3:
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $0 + 4 | 0 | 0);
     $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
     $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 | 0, $1 + 4 | 0 | 0);
     $3 = core__slice__cmp___impl_20core__cmp__PartialEq__5bB_5d__20for_20_5bA_5d___eq__hc3de93b036fcc30b($3 | 0, $0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0) | 0;
     break label$1;
    case 4:
     break label$2;
    };
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 24 | 0 | 0, $0 + 4 | 0 | 0);
   $0 = HEAP32[($2 + 28 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 24 | 0) >> 2] | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 16 | 0 | 0, $1 + 4 | 0 | 0);
   $3 = core__slice__cmp___impl_20core__cmp__PartialEq__5bB_5d__20for_20_5bA_5d___eq__hc3de93b036fcc30b($3 | 0, $0 | 0, HEAP32[($2 + 16 | 0) >> 2] | 0 | 0, HEAP32[($2 + 20 | 0) >> 2] | 0 | 0) | 0;
  }
  global$0 = $2 + 32 | 0;
  return $3 | 0;
 }
 
 function ryu__d2s_intrinsics__mul_shift_all_64__h708821f1b5e45ccf($0, $0$hi, $1, $2, $3, $4, $5) {
  $0 = $0 | 0;
  $0$hi = $0$hi | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  $5 = $5 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, i64toi32_i32$5 = 0, $6 = 0, $8$hi = 0, $8 = 0, $7$hi = 0, $9$hi = 0, $10$hi = 0, $7 = 0, $9 = 0, $61 = 0, $15 = 0, $18 = 0, $18$hi = 0, $30 = 0, $37 = 0, $37$hi = 0, $39 = 0, $39$hi = 0, $43 = 0, $43$hi = 0, $46 = 0, $47$hi = 0, $48$hi = 0, $55 = 0, $57 = 0, $58 = 0, $58$hi = 0, $62 = 0, $62$hi = 0, $70 = 0, $77 = 0, $77$hi = 0, $79 = 0, $79$hi = 0, $83 = 0, $83$hi = 0, $86 = 0, $87$hi = 0, $88$hi = 0, $92 = 0, $102 = 0, $109 = 0, $109$hi = 0, $111 = 0, $111$hi = 0, $115 = 0, $115$hi = 0, $118 = 0, $119$hi = 0, $120$hi = 0;
  $6 = global$0 - 144 | 0;
  global$0 = $6;
  $15 = $6 + 16 | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  $18 = i64toi32_i32$0;
  $18$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $0$hi;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 2;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $61 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $61 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $0 = $61;
  $0$hi = i64toi32_i32$0;
  i64toi32_i32$1 = $0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 2;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  $8 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  $8$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $18$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$3 = 0;
  __multi3($15 | 0, $18 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$1 | 0, $8 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$3 | 0);
  i64toi32_i32$1 = $1;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] | 0;
  $9 = i64toi32_i32$3;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$3 = 0;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$2 = 0;
  __multi3($6 + 96 | 0 | 0, $9 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$3 | 0, $8 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$2 | 0);
  $30 = $6;
  i64toi32_i32$3 = ($6 + 16 | 0) + 8 | 0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$2;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$3 = $6;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 96 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 100 | 0) >> 2] | 0;
  $37 = i64toi32_i32$1;
  $37$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$1 = $37$hi;
  i64toi32_i32$0 = $37;
  i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $10$hi = i64toi32_i32$5;
  $39 = i64toi32_i32$4;
  $39$hi = i64toi32_i32$5;
  i64toi32_i32$2 = ($6 + 96 | 0) + 8 | 0;
  i64toi32_i32$5 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $43 = i64toi32_i32$5;
  $43$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $10$hi;
  i64toi32_i32$3 = $8$hi;
  i64toi32_i32$3 = $10$hi;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$5 = $8$hi;
  i64toi32_i32$0 = $8;
  $46 = i64toi32_i32$3 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$0 >>> 0 | 0) | 0;
  i64toi32_i32$2 = 0;
  $47$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $43$hi;
  i64toi32_i32$0 = $43;
  i64toi32_i32$3 = $47$hi;
  i64toi32_i32$5 = $46;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $48$hi = i64toi32_i32$4;
  $1 = ($2 + 64 | 0) & 127 | 0;
  i64toi32_i32$4 = $39$hi;
  i64toi32_i32$0 = $48$hi;
  __lshrti3($30 | 0, $39 | 0, i64toi32_i32$4 | 0, i64toi32_i32$1 | 0, i64toi32_i32$0 | 0, $1 | 0);
  i64toi32_i32$2 = $6;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $55 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $55;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$4;
  $57 = i64toi32_i32$2 + 48 | 0;
  i64toi32_i32$4 = $7$hi;
  $58 = $7;
  $58$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $0$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = -1;
  i64toi32_i32$5 = -1;
  i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
  $62 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $62$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $0$hi;
  i64toi32_i32$4 = $0;
  i64toi32_i32$2 = $62$hi;
  i64toi32_i32$5 = $62;
  i64toi32_i32$3 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$3 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $8 = i64toi32_i32$3;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $58$hi;
  i64toi32_i32$4 = 0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$5 = 0;
  __multi3($57 | 0, $58 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$4 | 0, i64toi32_i32$3 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$5 | 0);
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$5 = i64toi32_i32$0;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$1 = 0;
  __multi3($6 + 112 | 0 | 0, $9 | 0, i64toi32_i32$5 | 0, 0 | 0, i64toi32_i32$0 | 0, i64toi32_i32$3 | 0, i64toi32_i32$4 | 0, 0 | 0, i64toi32_i32$1 | 0);
  $70 = $6 + 32 | 0;
  i64toi32_i32$0 = ($6 + 48 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$1;
  $8$hi = i64toi32_i32$4;
  i64toi32_i32$0 = $6;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 112 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 116 | 0) >> 2] | 0;
  $77 = i64toi32_i32$4;
  $77$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = $8;
  i64toi32_i32$4 = $77$hi;
  i64toi32_i32$5 = $77;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  i64toi32_i32$3 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$3 = i64toi32_i32$3 + 1 | 0
  }
  $10$hi = i64toi32_i32$3;
  $79 = i64toi32_i32$2;
  $79$hi = i64toi32_i32$3;
  i64toi32_i32$1 = ($6 + 112 | 0) + 8 | 0;
  i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $83 = i64toi32_i32$3;
  $83$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$3 = $8$hi;
  i64toi32_i32$5 = $8;
  $86 = i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$5 >>> 0 | 0) | 0;
  i64toi32_i32$1 = 0;
  $87$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $83$hi;
  i64toi32_i32$5 = $83;
  i64toi32_i32$0 = $87$hi;
  i64toi32_i32$3 = $86;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $88$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $79$hi;
  i64toi32_i32$5 = $88$hi;
  __lshrti3($70 | 0, $79 | 0, i64toi32_i32$2 | 0, i64toi32_i32$4 | 0, i64toi32_i32$5 | 0, $1 | 0);
  i64toi32_i32$1 = $6;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 32 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] | 0;
  $92 = i64toi32_i32$5;
  i64toi32_i32$5 = $4;
  HEAP32[i64toi32_i32$5 >> 2] = $92;
  HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$2 = $0$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$1 = $0$hi;
  i64toi32_i32$3 = 0;
  __multi3($6 + 80 | 0 | 0, $7 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$5 | 0, $0 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$3 | 0);
  i64toi32_i32$3 = $9$hi;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$3 = $9$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$5 = $0$hi;
  i64toi32_i32$2 = 0;
  __multi3($6 + 128 | 0 | 0, $9 | 0, i64toi32_i32$3 | 0, 0 | 0, i64toi32_i32$1 | 0, $0 | 0, i64toi32_i32$5 | 0, 0 | 0, i64toi32_i32$2 | 0);
  $102 = $6 + 64 | 0;
  i64toi32_i32$1 = ($6 + 80 | 0) + 8 | 0;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $0 = i64toi32_i32$2;
  $0$hi = i64toi32_i32$5;
  i64toi32_i32$1 = $6;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 128 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 132 | 0) >> 2] | 0;
  $109 = i64toi32_i32$5;
  $109$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $0$hi;
  i64toi32_i32$1 = $0;
  i64toi32_i32$5 = $109$hi;
  i64toi32_i32$3 = $109;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$4;
  $111 = i64toi32_i32$0;
  $111$hi = i64toi32_i32$4;
  i64toi32_i32$2 = ($6 + 128 | 0) + 8 | 0;
  i64toi32_i32$4 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $115 = i64toi32_i32$4;
  $115$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$1 = $0$hi;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$4 = $0$hi;
  i64toi32_i32$3 = $0;
  $118 = i64toi32_i32$1 >>> 0 < i64toi32_i32$4 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$4 | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
  i64toi32_i32$2 = 0;
  $119$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $115$hi;
  i64toi32_i32$3 = $115;
  i64toi32_i32$1 = $119$hi;
  i64toi32_i32$4 = $118;
  i64toi32_i32$5 = i64toi32_i32$3 + i64toi32_i32$4 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$4 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $120$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $111$hi;
  i64toi32_i32$3 = $120$hi;
  __lshrti3($102 | 0, $111 | 0, i64toi32_i32$0 | 0, i64toi32_i32$5 | 0, i64toi32_i32$3 | 0, $1 | 0);
  i64toi32_i32$2 = $6;
  i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
  $0 = i64toi32_i32$3;
  $0$hi = i64toi32_i32$0;
  global$0 = i64toi32_i32$2 + 144 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$0;
  return i64toi32_i32$3 | 0;
 }
 
 function $_cryptoxide__curve25519__ge__Ge_20as_20core__ops__arith__Add__cryptoxide__curve25519__ge__GeCached____add__hdb98361e5d861211($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, i64toi32_i32$5 = 0, $3 = 0, $4 = 0, $35 = 0, $36 = 0, $37 = 0, $38 = 0, $39 = 0, $40 = 0, $41 = 0, $42 = 0, $44 = 0, $45 = 0, $43 = 0, $46 = 0, $46$hi = 0, $5 = 0, $5$hi = 0, $51 = 0, $51$hi = 0, $55 = 0, $57 = 0, $57$hi = 0, $60$hi = 0, $64 = 0, $66 = 0, $66$hi = 0, $69$hi = 0, $73 = 0, $75 = 0, $75$hi = 0, $78$hi = 0, $82 = 0, $85 = 0, $85$hi = 0, $88 = 0, $88$hi = 0;
  $3 = global$0 - 288 | 0;
  global$0 = $3;
  $4 = $1 + 40 | 0;
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Add___add__he826ef0e90fce416($3 + 8 | 0 | 0, $4 | 0, $1 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Sub___sub__h676cb1e5fa77fb70($3 + 48 | 0 | 0, $4 | 0, $1 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($3 + 88 | 0 | 0, $3 + 8 | 0 | 0, $2 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($3 + 128 | 0 | 0, $3 + 48 | 0 | 0, $2 + 40 | 0 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($3 + 168 | 0 | 0, $2 + 120 | 0 | 0, $1 + 120 | 0 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($3 + 208 | 0 | 0, $1 + 80 | 0 | 0, $2 + 80 | 0 | 0);
  $43 = $3;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 216 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 220 | 0) >> 2] | 0;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 1;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $35 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $35 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $46 = $35;
  $46$hi = i64toi32_i32$0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 208 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 212 | 0) >> 2] | 0;
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$2;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 50;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $36 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   $36 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
  }
  i64toi32_i32$2 = $36;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 8191;
  i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
  $51 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
  $51$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $46$hi;
  i64toi32_i32$0 = $46;
  i64toi32_i32$2 = $51$hi;
  i64toi32_i32$3 = $51;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$0 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$0 = i64toi32_i32$5 & i64toi32_i32$0 | 0;
  i64toi32_i32$1 = $43;
  HEAP32[(i64toi32_i32$1 + 256 | 0) >> 2] = i64toi32_i32$4 & i64toi32_i32$3 | 0;
  HEAP32[(i64toi32_i32$1 + 260 | 0) >> 2] = i64toi32_i32$0;
  $55 = $3;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$2 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $37 = i64toi32_i32$0 >>> i64toi32_i32$2 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$2 | 0;
   $37 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$2 | 0) | 0;
  }
  $57 = $37;
  $57$hi = i64toi32_i32$1;
  i64toi32_i32$0 = $3;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 224 | 0) >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 228 | 0) >> 2] | 0;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 1;
  i64toi32_i32$2 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$2 | 0;
   $38 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$2 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$2 | 0) | 0) | 0 | (i64toi32_i32$5 << i64toi32_i32$2 | 0) | 0;
   $38 = i64toi32_i32$0 << i64toi32_i32$2 | 0;
  }
  $60$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $57$hi;
  i64toi32_i32$5 = $57;
  i64toi32_i32$0 = $60$hi;
  i64toi32_i32$3 = $38;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$5 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$5 = i64toi32_i32$4 & i64toi32_i32$5 | 0;
  i64toi32_i32$1 = $55;
  HEAP32[(i64toi32_i32$1 + 264 | 0) >> 2] = i64toi32_i32$2 & i64toi32_i32$3 | 0;
  HEAP32[(i64toi32_i32$1 + 268 | 0) >> 2] = i64toi32_i32$5;
  $64 = $3;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$4 = i64toi32_i32$2;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$0 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $39 = i64toi32_i32$5 >>> i64toi32_i32$0 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$5 >>> i64toi32_i32$0 | 0;
   $39 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$0 | 0) | 0;
  }
  $66 = $39;
  $66$hi = i64toi32_i32$1;
  i64toi32_i32$5 = $3;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 232 | 0) >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 236 | 0) >> 2] | 0;
  i64toi32_i32$5 = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 1;
  i64toi32_i32$0 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$5 << i64toi32_i32$0 | 0;
   $40 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$0 | 0) - 1 | 0) & (i64toi32_i32$5 >>> (32 - i64toi32_i32$0 | 0) | 0) | 0 | (i64toi32_i32$4 << i64toi32_i32$0 | 0) | 0;
   $40 = i64toi32_i32$5 << i64toi32_i32$0 | 0;
  }
  $69$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $66$hi;
  i64toi32_i32$4 = $66;
  i64toi32_i32$5 = $69$hi;
  i64toi32_i32$3 = $40;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$4 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$4 = i64toi32_i32$2 & i64toi32_i32$4 | 0;
  i64toi32_i32$1 = $64;
  HEAP32[(i64toi32_i32$1 + 272 | 0) >> 2] = i64toi32_i32$0 & i64toi32_i32$3 | 0;
  HEAP32[(i64toi32_i32$1 + 276 | 0) >> 2] = i64toi32_i32$4;
  $73 = $3;
  i64toi32_i32$4 = i64toi32_i32$2;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $41 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
   $41 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$5 | 0) | 0;
  }
  $75 = $41;
  $75$hi = i64toi32_i32$1;
  i64toi32_i32$4 = $3;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$4 + 240 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 244 | 0) >> 2] | 0;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 1;
  i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$4 << i64toi32_i32$5 | 0;
   $42 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$5 | 0) - 1 | 0) & (i64toi32_i32$4 >>> (32 - i64toi32_i32$5 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$5 | 0) | 0;
   $42 = i64toi32_i32$4 << i64toi32_i32$5 | 0;
  }
  $78$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $75$hi;
  i64toi32_i32$2 = $75;
  i64toi32_i32$4 = $78$hi;
  i64toi32_i32$3 = $42;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$2 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
  i64toi32_i32$1 = $73;
  HEAP32[(i64toi32_i32$1 + 280 | 0) >> 2] = i64toi32_i32$5 & i64toi32_i32$3 | 0;
  HEAP32[(i64toi32_i32$1 + 284 | 0) >> 2] = i64toi32_i32$2;
  $82 = $3;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $44 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   $44 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
  }
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_i64_mul($44 | 0, i64toi32_i32$1 | 0, 19 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $85 = i64toi32_i32$0;
  $85$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $5$hi;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 1;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $45 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $45 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  i64toi32_i32$1 = $45;
  i64toi32_i32$2 = 524287;
  i64toi32_i32$3 = -2;
  i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
  $88 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
  $88$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $85$hi;
  i64toi32_i32$0 = $85;
  i64toi32_i32$1 = $88$hi;
  i64toi32_i32$3 = $88;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  i64toi32_i32$0 = $82;
  HEAP32[(i64toi32_i32$0 + 248 | 0) >> 2] = i64toi32_i32$4;
  HEAP32[(i64toi32_i32$0 + 252 | 0) >> 2] = i64toi32_i32$5;
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Sub___sub__h676cb1e5fa77fb70($0 | 0, $3 + 88 | 0 | 0, $3 + 128 | 0 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Add___add__he826ef0e90fce416($0 + 40 | 0 | 0, $3 + 88 | 0 | 0, $3 + 128 | 0 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Add___add__he826ef0e90fce416($0 + 80 | 0 | 0, $3 + 248 | 0 | 0, $3 + 168 | 0 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Sub___sub__h676cb1e5fa77fb70($0 + 120 | 0 | 0, $3 + 248 | 0 | 0, $3 + 168 | 0 | 0);
  global$0 = $3 + 288 | 0;
 }
 
 function $_cryptoxide__curve25519__ge__Ge_20as_20core__ops__arith__Sub__cryptoxide__curve25519__ge__GeCached____sub__ha1434480d6586320($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, i64toi32_i32$5 = 0, $3 = 0, $4 = 0, $35 = 0, $36 = 0, $37 = 0, $38 = 0, $39 = 0, $40 = 0, $41 = 0, $42 = 0, $44 = 0, $45 = 0, $43 = 0, $46 = 0, $46$hi = 0, $5 = 0, $5$hi = 0, $51 = 0, $51$hi = 0, $55 = 0, $57 = 0, $57$hi = 0, $60$hi = 0, $64 = 0, $66 = 0, $66$hi = 0, $69$hi = 0, $73 = 0, $75 = 0, $75$hi = 0, $78$hi = 0, $82 = 0, $85 = 0, $85$hi = 0, $88 = 0, $88$hi = 0;
  $3 = global$0 - 288 | 0;
  global$0 = $3;
  $4 = $1 + 40 | 0;
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Add___add__he826ef0e90fce416($3 + 8 | 0 | 0, $4 | 0, $1 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Sub___sub__h676cb1e5fa77fb70($3 + 48 | 0 | 0, $4 | 0, $1 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($3 + 88 | 0 | 0, $3 + 8 | 0 | 0, $2 + 40 | 0 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($3 + 128 | 0 | 0, $3 + 48 | 0 | 0, $2 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($3 + 168 | 0 | 0, $2 + 120 | 0 | 0, $1 + 120 | 0 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($3 + 208 | 0 | 0, $1 + 80 | 0 | 0, $2 + 80 | 0 | 0);
  $43 = $3;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 216 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 220 | 0) >> 2] | 0;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 1;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $35 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $35 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $46 = $35;
  $46$hi = i64toi32_i32$0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 208 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 212 | 0) >> 2] | 0;
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$2;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 50;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $36 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   $36 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
  }
  i64toi32_i32$2 = $36;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 8191;
  i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
  $51 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
  $51$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $46$hi;
  i64toi32_i32$0 = $46;
  i64toi32_i32$2 = $51$hi;
  i64toi32_i32$3 = $51;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$0 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$0 = i64toi32_i32$5 & i64toi32_i32$0 | 0;
  i64toi32_i32$1 = $43;
  HEAP32[(i64toi32_i32$1 + 256 | 0) >> 2] = i64toi32_i32$4 & i64toi32_i32$3 | 0;
  HEAP32[(i64toi32_i32$1 + 260 | 0) >> 2] = i64toi32_i32$0;
  $55 = $3;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$2 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $37 = i64toi32_i32$0 >>> i64toi32_i32$2 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$2 | 0;
   $37 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$2 | 0) | 0;
  }
  $57 = $37;
  $57$hi = i64toi32_i32$1;
  i64toi32_i32$0 = $3;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 224 | 0) >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 228 | 0) >> 2] | 0;
  i64toi32_i32$0 = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 1;
  i64toi32_i32$2 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$2 | 0;
   $38 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$2 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$2 | 0) | 0) | 0 | (i64toi32_i32$5 << i64toi32_i32$2 | 0) | 0;
   $38 = i64toi32_i32$0 << i64toi32_i32$2 | 0;
  }
  $60$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $57$hi;
  i64toi32_i32$5 = $57;
  i64toi32_i32$0 = $60$hi;
  i64toi32_i32$3 = $38;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$5 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$5 = i64toi32_i32$4 & i64toi32_i32$5 | 0;
  i64toi32_i32$1 = $55;
  HEAP32[(i64toi32_i32$1 + 264 | 0) >> 2] = i64toi32_i32$2 & i64toi32_i32$3 | 0;
  HEAP32[(i64toi32_i32$1 + 268 | 0) >> 2] = i64toi32_i32$5;
  $64 = $3;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$4 = i64toi32_i32$2;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$0 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $39 = i64toi32_i32$5 >>> i64toi32_i32$0 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$5 >>> i64toi32_i32$0 | 0;
   $39 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$0 | 0) | 0;
  }
  $66 = $39;
  $66$hi = i64toi32_i32$1;
  i64toi32_i32$5 = $3;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 232 | 0) >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 236 | 0) >> 2] | 0;
  i64toi32_i32$5 = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 1;
  i64toi32_i32$0 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$5 << i64toi32_i32$0 | 0;
   $40 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$0 | 0) - 1 | 0) & (i64toi32_i32$5 >>> (32 - i64toi32_i32$0 | 0) | 0) | 0 | (i64toi32_i32$4 << i64toi32_i32$0 | 0) | 0;
   $40 = i64toi32_i32$5 << i64toi32_i32$0 | 0;
  }
  $69$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $66$hi;
  i64toi32_i32$4 = $66;
  i64toi32_i32$5 = $69$hi;
  i64toi32_i32$3 = $40;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$4 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$4 = i64toi32_i32$2 & i64toi32_i32$4 | 0;
  i64toi32_i32$1 = $64;
  HEAP32[(i64toi32_i32$1 + 272 | 0) >> 2] = i64toi32_i32$0 & i64toi32_i32$3 | 0;
  HEAP32[(i64toi32_i32$1 + 276 | 0) >> 2] = i64toi32_i32$4;
  $73 = $3;
  i64toi32_i32$4 = i64toi32_i32$2;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $41 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
   $41 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$5 | 0) | 0;
  }
  $75 = $41;
  $75$hi = i64toi32_i32$1;
  i64toi32_i32$4 = $3;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$4 + 240 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$4 + 244 | 0) >> 2] | 0;
  i64toi32_i32$4 = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 1;
  i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$4 << i64toi32_i32$5 | 0;
   $42 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$5 | 0) - 1 | 0) & (i64toi32_i32$4 >>> (32 - i64toi32_i32$5 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$5 | 0) | 0;
   $42 = i64toi32_i32$4 << i64toi32_i32$5 | 0;
  }
  $78$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $75$hi;
  i64toi32_i32$2 = $75;
  i64toi32_i32$4 = $78$hi;
  i64toi32_i32$3 = $42;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$2 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
  i64toi32_i32$1 = $73;
  HEAP32[(i64toi32_i32$1 + 280 | 0) >> 2] = i64toi32_i32$5 & i64toi32_i32$3 | 0;
  HEAP32[(i64toi32_i32$1 + 284 | 0) >> 2] = i64toi32_i32$2;
  $82 = $3;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $44 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   $44 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
  }
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_i64_mul($44 | 0, i64toi32_i32$1 | 0, 19 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $85 = i64toi32_i32$0;
  $85$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $5$hi;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 1;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $45 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $45 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  i64toi32_i32$1 = $45;
  i64toi32_i32$2 = 524287;
  i64toi32_i32$3 = -2;
  i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
  $88 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
  $88$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $85$hi;
  i64toi32_i32$0 = $85;
  i64toi32_i32$1 = $88$hi;
  i64toi32_i32$3 = $88;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  i64toi32_i32$0 = $82;
  HEAP32[(i64toi32_i32$0 + 248 | 0) >> 2] = i64toi32_i32$4;
  HEAP32[(i64toi32_i32$0 + 252 | 0) >> 2] = i64toi32_i32$5;
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Sub___sub__h676cb1e5fa77fb70($0 | 0, $3 + 88 | 0 | 0, $3 + 128 | 0 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Add___add__he826ef0e90fce416($0 + 40 | 0 | 0, $3 + 88 | 0 | 0, $3 + 128 | 0 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Sub___sub__h676cb1e5fa77fb70($0 + 80 | 0 | 0, $3 + 248 | 0 | 0, $3 + 168 | 0 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Add___add__he826ef0e90fce416($0 + 120 | 0 | 0, $3 + 248 | 0 | 0, $3 + 168 | 0 | 0);
  global$0 = $3 + 288 | 0;
 }
 
 function core__fmt__builders__DebugMap__key__h5f98dea42a0b977d($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $6 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, $5 = 0, $69 = 0, $7 = 0, $7$hi = 0, $78 = 0, $83 = 0;
  $3 = global$0 - 64 | 0;
  global$0 = $3;
  $4 = 1;
  label$1 : {
   label$2 : {
    if (HEAPU8[($0 + 4 | 0) >> 0] | 0) {
     break label$2
    }
    if (HEAPU8[($0 + 6 | 0) >> 0] | 0) {
     break label$1
    }
    $5 = HEAPU8[($0 + 5 | 0) >> 0] | 0;
    label$3 : {
     label$4 : {
      $6 = HEAP32[$0 >> 2] | 0;
      if ((HEAPU8[$6 >> 0] | 0) & 4 | 0) {
       break label$4
      }
      label$5 : {
       if (!($5 & 255 | 0)) {
        break label$5
       }
       if (FUNCTION_TABLE[HEAP32[((HEAP32[($6 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($6 + 24 | 0) >> 2] | 0, 1149869, 2) | 0) {
        break label$2
       }
       $6 = HEAP32[$0 >> 2] | 0;
      }
      if (FUNCTION_TABLE[HEAP32[($2 + 12 | 0) >> 2] | 0 | 0]($1, $6) | 0) {
       break label$2
      }
      $6 = HEAP32[$0 >> 2] | 0;
      if (!(FUNCTION_TABLE[HEAP32[((HEAP32[($6 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($6 + 24 | 0) >> 2] | 0, 1149752, 2) | 0)) {
       break label$3
      }
      break label$2;
     }
     label$6 : {
      if ($5 & 255 | 0) {
       break label$6
      }
      $4 = 1;
      if (FUNCTION_TABLE[HEAP32[((HEAP32[($6 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($6 + 24 | 0) >> 2] | 0, 1149898, 1) | 0) {
       break label$2
      }
      $6 = HEAP32[$0 >> 2] | 0;
     }
     $4 = 1;
     HEAP8[($0 + 7 | 0) >> 0] = 1;
     HEAP32[($3 + 52 | 0) >> 2] = 1149804;
     HEAP32[($3 + 16 | 0) >> 2] = $0 + 7 | 0;
     i64toi32_i32$0 = HEAP32[($6 + 24 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($6 + 28 | 0) >> 2] | 0;
     $69 = i64toi32_i32$0;
     i64toi32_i32$0 = $3;
     HEAP32[($3 + 8 | 0) >> 2] = $69;
     HEAP32[($3 + 12 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = HEAP32[($6 + 8 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($6 + 12 | 0) >> 2] | 0;
     $7 = i64toi32_i32$1;
     $7$hi = i64toi32_i32$0;
     i64toi32_i32$0 = HEAP32[($6 + 16 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($6 + 20 | 0) >> 2] | 0;
     HEAP8[($3 + 56 | 0) >> 0] = HEAPU8[($6 + 32 | 0) >> 0] | 0;
     $78 = i64toi32_i32$0;
     i64toi32_i32$0 = $3;
     HEAP32[($3 + 40 | 0) >> 2] = $78;
     HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$0 = $3;
     HEAP32[($3 + 32 | 0) >> 2] = $7;
     HEAP32[($3 + 36 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = HEAP32[$6 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($6 + 4 | 0) >> 2] | 0;
     $83 = i64toi32_i32$1;
     i64toi32_i32$1 = $3;
     HEAP32[($3 + 24 | 0) >> 2] = $83;
     HEAP32[($3 + 28 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($3 + 48 | 0) >> 2] = $3 + 8 | 0;
     if (FUNCTION_TABLE[HEAP32[($2 + 12 | 0) >> 2] | 0 | 0]($1, $3 + 24 | 0) | 0) {
      break label$2
     }
     if (FUNCTION_TABLE[HEAP32[((HEAP32[($3 + 52 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($3 + 48 | 0) >> 2] | 0, 1149752, 2) | 0) {
      break label$2
     }
    }
    HEAP8[($0 + 6 | 0) >> 0] = 1;
    $4 = 0;
   }
   HEAP8[($0 + 4 | 0) >> 0] = $4;
   global$0 = $3 + 64 | 0;
   return $0 | 0;
  }
  core__panicking__panic__h2fd385a887c8bf13(1149921 | 0, 70 | 0, 1149992 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert__ha6efcd690a85c850($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $5 = 0, $6 = 0, $7 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $4 = global$0 - 368 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $5 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      if ((HEAPU16[($5 + 1458 | 0) >> 1] | 0) >>> 0 < 11 >>> 0) {
       break label$4
      }
      alloc__collections__btree__node__splitpoint__h8424344594b4deb1($4 + 208 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
      $6 = HEAP32[($4 + 216 | 0) >> 2] | 0;
      $7 = HEAP32[($4 + 212 | 0) >> 2] | 0;
      $1 = HEAP32[$1 >> 2] | 0;
      HEAP32[($4 + 216 | 0) >> 2] = HEAP32[($4 + 208 | 0) >> 2] | 0;
      HEAP32[($4 + 212 | 0) >> 2] = $5;
      HEAP32[($4 + 208 | 0) >> 2] = $1;
      alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__KV___split__h58fcbc0b41995e56($4 | 0, $4 + 208 | 0 | 0);
      if (($7 | 0) == (1 | 0)) {
       break label$3
      }
      HEAP32[($4 + 152 | 0) >> 2] = HEAP32[($4 + 136 | 0) >> 2] | 0;
      $1 = HEAP32[($4 + 140 | 0) >> 2] | 0;
      break label$2;
     }
     $2 = memcpy($4 | 0, $2 | 0, 36 | 0) | 0;
     memcpy($2 + 208 | 0 | 0, $3 | 0, 96 | 0) | 0;
     (wasm2js_i32$0 = $0, wasm2js_i32$1 = alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_fit__h0e480b7891ac4aea($1 | 0, $2 | 0, $2 + 208 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 160 | 0) >> 2] = wasm2js_i32$1;
     HEAP32[($0 + 8 | 0) >> 2] = $5;
     HEAP32[$0 >> 2] = 0;
     HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
     HEAP32[($0 + 4 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
     break label$1;
    }
    HEAP32[($4 + 152 | 0) >> 2] = HEAP32[($4 + 144 | 0) >> 2] | 0;
    $1 = HEAP32[($4 + 148 | 0) >> 2] | 0;
   }
   HEAP32[($4 + 160 | 0) >> 2] = $6;
   HEAP32[($4 + 156 | 0) >> 2] = $1;
   memcpy($4 + 168 | 0 | 0, $2 | 0, 36 | 0) | 0;
   memcpy($4 + 208 | 0 | 0, $3 | 0, 96 | 0) | 0;
   $1 = alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_fit__h0e480b7891ac4aea($4 + 152 | 0 | 0, $4 + 168 | 0 | 0, $4 + 208 | 0 | 0) | 0;
   memcpy(($4 + 208 | 0) + 4 | 0 | 0, $4 | 0, 152 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
   memcpy($0 + 4 | 0 | 0, $4 + 208 | 0 | 0, 156 | 0) | 0;
   HEAP32[($0 + 160 | 0) >> 2] = $1;
  }
  global$0 = $4 + 368 | 0;
 }
 
 function core__ops__function__impls___impl_20core__ops__function__FnOnce_A__20for_20_mut_20F___call_once__h16f3e4a987a7f931($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $4 = 0, $6 = 0, $6$hi = 0, $7 = 0, $7$hi = 0, $5 = 0, $5$hi = 0, $23 = 0, $28 = 0, $31 = 0, $70 = 0, $75 = 0, $80 = 0;
  $4 = global$0 - 64 | 0;
  global$0 = $4;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    switch (HEAP32[$3 >> 2] | 0 | 0) {
    default:
     $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__hdeea20968268d729($4 + 24 | 0 | 0, $3 + 8 | 0 | 0);
     i64toi32_i32$2 = $4 + 48 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $23 = i64toi32_i32$1;
     i64toi32_i32$1 = $4 + 8 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $23;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $4 + 56 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $28 = i64toi32_i32$0;
     i64toi32_i32$0 = $4 + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $28;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $4;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] | 0;
     $31 = i64toi32_i32$1;
     i64toi32_i32$1 = i64toi32_i32$2;
     HEAP32[i64toi32_i32$1 >> 2] = $31;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = (i64toi32_i32$1 + 24 | 0) + 8 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $6 = i64toi32_i32$0;
     $6$hi = i64toi32_i32$1;
     i64toi32_i32$2 = $4;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
     $7 = i64toi32_i32$1;
     $7$hi = i64toi32_i32$0;
     $2 = 0;
     break label$1;
    case 1:
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hf69db734dd831996($4 + 24 | 0 | 0, $3 + 4 | 0 | 0);
     i64toi32_i32$2 = $4;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
     $7 = i64toi32_i32$0;
     $7$hi = i64toi32_i32$1;
     $3 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
     i64toi32_i32$1 = 0;
     $6 = 0;
     $6$hi = i64toi32_i32$1;
     $2 = 1;
     break label$1;
    case 2:
     i64toi32_i32$2 = $3 + 16 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $6 = i64toi32_i32$1;
     $6$hi = i64toi32_i32$0;
     i64toi32_i32$2 = $3;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
     $7 = i64toi32_i32$0;
     $7$hi = i64toi32_i32$1;
     $2 = 2;
     break label$1;
    case 3:
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($4 + 24 | 0 | 0, $3 + 4 | 0 | 0);
     i64toi32_i32$2 = $4;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
     $7 = i64toi32_i32$1;
     $7$hi = i64toi32_i32$0;
     $3 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
     i64toi32_i32$0 = 0;
     $6 = 0;
     $6$hi = i64toi32_i32$0;
     $2 = 3;
     break label$1;
    case 4:
     break label$2;
    };
   }
   $2 = 4;
   $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($4 + 24 | 0 | 0, $3 + 4 | 0 | 0);
   i64toi32_i32$2 = $4;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
   $7 = i64toi32_i32$0;
   $7$hi = i64toi32_i32$1;
   $3 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
   i64toi32_i32$1 = 0;
   $6 = 0;
   $6$hi = i64toi32_i32$1;
  }
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $70 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 32 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $70;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = i64toi32_i32$2 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $75 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 48 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $75;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $4 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $80 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 40 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $80;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$1 = $0 + 24 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $6;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$1 = $0 + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $7;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($0 + 12 | 0) >> 2] = $3;
  HEAP32[($0 + 8 | 0) >> 2] = $2;
  i64toi32_i32$0 = $5$hi;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $5;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $4 + 64 | 0;
 }
 
 function alloc__slice__merge__h77a350cbd049521d($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, i64toi32_i32$0 = 0, $6 = 0, $7 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, $8 = 0, $9 = 0, $50 = 0, $50$hi = 0, $53 = 0, $53$hi = 0, $96 = 0, $96$hi = 0, $99 = 0, $99$hi = 0;
  $5 = $2 << 2 | 0;
  $6 = $0 + $5 | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     $7 = $1 - $2 | 0;
     if ($7 >>> 0 >= $2 >>> 0) {
      break label$3
     }
     $5 = $7 << 2 | 0;
     $8 = memcpy($3 | 0, $6 | 0, $5 | 0) | 0;
     $5 = $8 + $5 | 0;
     if (($2 | 0) < (1 | 0)) {
      break label$2
     }
     if (($7 | 0) < (1 | 0)) {
      break label$2
     }
     $7 = (($1 << 2 | 0) + $0 | 0) + -4 | 0;
     $9 = HEAP32[$4 >> 2] | 0;
     label$4 : while (1) {
      $2 = $6 + -4 | 0;
      $1 = $5 + -4 | 0;
      i64toi32_i32$0 = cardano_serialization_lib__tx_builder__TransactionBuilder__cip2_largest_first_by___7b_7bclosure_7d_7d__hb6689e866bcf147a($9 | 0, $1 | 0) | 0;
      i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
      $50 = i64toi32_i32$0;
      $50$hi = i64toi32_i32$1;
      i64toi32_i32$1 = cardano_serialization_lib__tx_builder__TransactionBuilder__cip2_largest_first_by___7b_7bclosure_7d_7d__hb6689e866bcf147a($9 | 0, $2 | 0) | 0;
      i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
      $53 = i64toi32_i32$1;
      $53$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $50$hi;
      i64toi32_i32$2 = $50;
      i64toi32_i32$1 = $53$hi;
      i64toi32_i32$3 = $53;
      $4 = i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
      HEAP32[$7 >> 2] = HEAP32[($4 ? $2 : $1) >> 2] | 0;
      $5 = $4 ? $5 : $1;
      $6 = $4 ? $2 : $6;
      if ($0 >>> 0 >= $6 >>> 0) {
       break label$2
      }
      $7 = $7 + -4 | 0;
      if ($5 >>> 0 <= $8 >>> 0) {
       break label$2
      }
      continue label$4;
     };
    }
    $5 = (memcpy($3 | 0, $0 | 0, $5 | 0) | 0) + $5 | 0;
    if (($1 | 0) <= ($2 | 0)) {
     break label$1
    }
    if (($2 | 0) < (1 | 0)) {
     break label$1
    }
    $7 = $0 + ($1 << 2 | 0) | 0;
    $1 = HEAP32[$4 >> 2] | 0;
    label$5 : while (1) {
     i64toi32_i32$2 = cardano_serialization_lib__tx_builder__TransactionBuilder__cip2_largest_first_by___7b_7bclosure_7d_7d__hb6689e866bcf147a($1 | 0, $6 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $96 = i64toi32_i32$2;
     $96$hi = i64toi32_i32$0;
     i64toi32_i32$0 = cardano_serialization_lib__tx_builder__TransactionBuilder__cip2_largest_first_by___7b_7bclosure_7d_7d__hb6689e866bcf147a($1 | 0, $3 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $99 = i64toi32_i32$0;
     $99$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $96$hi;
     i64toi32_i32$3 = $96;
     i64toi32_i32$0 = $99$hi;
     i64toi32_i32$1 = $99;
     $2 = i64toi32_i32$2 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0 | 0) | 0;
     HEAP32[$0 >> 2] = HEAP32[($2 ? $6 : $3) >> 2] | 0;
     $3 = $2 ? $3 : $3 + 4 | 0;
     $0 = $0 + 4 | 0;
     $6 = $2 ? $6 + 4 | 0 : $6;
     if ($6 >>> 0 >= $7 >>> 0) {
      break label$1
     }
     if ($3 >>> 0 < $5 >>> 0) {
      continue label$5
     }
     break label$1;
    };
   }
   $0 = $6;
  }
  memcpy($0 | 0, $3 | 0, ($5 - $3 | 0) & -4 | 0 | 0) | 0;
 }
 
 function js_sys__global__GLOBAL____init__h9ff3096551d06feb() {
  var $0 = 0, $1 = 0, $3 = 0, $2 = 0, $4 = 0, $5 = 0, $6 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0, wasm2js_i32$2 = 0;
  $0 = global$0 - 48 | 0;
  global$0 = $0;
  $1 = js_sys__global__get_global_object__Global__get_self____wbg_self_bb69a836a72ec6e9__hab2f593d29e5290f() | 0;
  wasm_bindgen____rt__take_last_exception__h00302a7bf129f841($0 + 40 | 0 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     if (!(HEAP32[($0 + 40 | 0) >> 2] | 0)) {
      break label$3
     }
     $2 = HEAP32[($0 + 44 | 0) >> 2] | 0;
     $1 = js_sys__global__get_global_object__Global__get_window____wbg_window_3304fc4b414c9693__h28126c6ba54fe93c() | 0;
     wasm_bindgen____rt__take_last_exception__h00302a7bf129f841($0 + 32 | 0 | 0);
     $3 = HEAP32[($0 + 32 | 0) >> 2] | 0;
     $4 = HEAP32[($0 + 36 | 0) >> 2] | 0;
     label$4 : {
      if ($2 >>> 0 < 36 >>> 0) {
       break label$4
      }
      wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($2 | 0);
     }
     if (!$3) {
      break label$3
     }
     $2 = $3 ? $4 : $1;
     $1 = js_sys__global__get_global_object__Global__get_global_this____wbg_globalThis_e0d21cabc6630763__he5b75e175a333dd0() | 0;
     wasm_bindgen____rt__take_last_exception__h00302a7bf129f841($0 + 24 | 0 | 0);
     $3 = HEAP32[($0 + 24 | 0) >> 2] | 0;
     $4 = HEAP32[($0 + 28 | 0) >> 2] | 0;
     label$5 : {
      if ($2 >>> 0 < 36 >>> 0) {
       break label$5
      }
      wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($2 | 0);
     }
     if (!$3) {
      break label$3
     }
     $3 = $3 ? $4 : $1;
     $1 = js_sys__global__get_global_object__Global__get_global____wbg_global_8463719227271676__h39c679b75424de91() | 0;
     wasm_bindgen____rt__take_last_exception__h00302a7bf129f841($0 + 16 | 0 | 0);
     $2 = HEAP32[($0 + 20 | 0) >> 2] | 0;
     $4 = HEAP32[($0 + 16 | 0) >> 2] | 0;
     label$6 : {
      if ($3 >>> 0 < 36 >>> 0) {
       break label$6
      }
      wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($3 | 0);
     }
     $5 = 1;
     if ($4) {
      break label$2
     }
    }
    if ((wasm_bindgen____wbindgen_is_undefined__h5ac6d522a5572e68($1 | 0) | 0 | 0) != (1 | 0)) {
     break label$1
    }
    $5 = 0;
    label$7 : {
     if ($1 >>> 0 < 36 >>> 0) {
      break label$7
     }
     wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($1 | 0);
    }
    $2 = $1;
   }
   $4 = js_sys__Function__new_no_args____wbg_newnoargs_9fdd8f3961dd1bee__hc36cbac083d07783(1076072 | 0, 11 | 0) | 0;
   $1 = js_sys__Function__call0____wbg_call_ba36642bd901572b__h933f412500003ba9($4 | 0, 32 | 0) | 0;
   wasm_bindgen____rt__take_last_exception__h00302a7bf129f841($0 + 8 | 0 | 0);
   label$8 : {
    $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
    if (!$3) {
     break label$8
    }
    $6 = (wasm2js_i32$0 = HEAP32[($0 + 12 | 0) >> 2] | 0, wasm2js_i32$1 = $1, wasm2js_i32$2 = $3, wasm2js_i32$2 ? wasm2js_i32$0 : wasm2js_i32$1);
    if ($6 >>> 0 < 36 >>> 0) {
     break label$8
    }
    wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($6 | 0);
   }
   label$9 : {
    if ($4 >>> 0 < 36 >>> 0) {
     break label$9
    }
    wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($4 | 0);
   }
   $1 = $3 ? 32 : $1;
   if (!($5 & $2 >>> 0 > 35 >>> 0 | 0)) {
    break label$1
   }
   wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($2 | 0);
  }
  global$0 = $0 + 48 | 0;
  return $1 | 0;
 }
 
 function $itertools__unique_impl__UniqueBy_I_2cV_2cF__20as_20core__iter__traits__iterator__Iterator___next__h5db2cd474a34beda($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, $6 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $4 = 0, $5 = 0, $2 = 0, $3 = 0, $45 = 0, $50 = 0, $55 = 0, $83 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  $2 = $0 + 100 | 0;
  $3 = $0 + 36 | 0;
  $4 = $0 + 68 | 0;
  $5 = $1 + 48 | 0 | 4 | 0;
  label$1 : while (1) {
   label$2 : {
    label$3 : {
     if ((HEAP32[($0 + 64 | 0) >> 2] | 0 | 0) != (1 | 0)) {
      break label$3
     }
     $6 = 0;
     break label$2;
    }
    $6 = 1;
   }
   label$4 : while (1) {
    label$5 : {
     label$6 : {
      label$7 : {
       label$8 : {
        switch ($6 | 0) {
        case 0:
         $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h36ca092f81b9a0fa($1 + 24 | 0 | 0, $4 | 0);
         $6 = HEAP32[($1 + 24 | 0) >> 2] | 0;
         if ($6) {
          break label$7
         }
         HEAP32[($0 + 64 | 0) >> 2] = 0;
         $6 = 1;
         continue label$4;
        default:
         break label$8;
        };
       }
       label$10 : {
        if ((HEAP32[($0 + 32 | 0) >> 2] | 0 | 0) != (1 | 0)) {
         break label$10
        }
        $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h03cc330b7b1e4522($1 + 16 | 0 | 0, $3 | 0);
        if (!(HEAP32[($1 + 16 | 0) >> 2] | 0)) {
         break label$10
        }
        alloc__collections__btree__map__BTreeMap_K_2cV___iter__ha89c9458aca0228d($5 | 0, HEAP32[($1 + 20 | 0) >> 2] | 0 | 0);
        HEAP32[($0 + 64 | 0) >> 2] = 1;
        i64toi32_i32$2 = $5;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $45 = i64toi32_i32$0;
        i64toi32_i32$0 = $4;
        HEAP32[i64toi32_i32$0 >> 2] = $45;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $50 = i64toi32_i32$1;
        i64toi32_i32$1 = $4 + 8 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $50;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = $5 + 16 | 0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $55 = i64toi32_i32$0;
        i64toi32_i32$0 = $4 + 16 | 0;
        HEAP32[i64toi32_i32$0 >> 2] = $55;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        HEAP32[($4 + 24 | 0) >> 2] = HEAP32[($5 + 24 | 0) >> 2] | 0;
        break label$5;
       }
       label$11 : {
        if ((HEAP32[($0 + 96 | 0) >> 2] | 0 | 0) != (1 | 0)) {
         break label$11
        }
        $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h36ca092f81b9a0fa($1 + 8 | 0 | 0, $2 | 0);
        $6 = HEAP32[($1 + 8 | 0) >> 2] | 0;
        if ($6) {
         break label$7
        }
        HEAP32[($0 + 96 | 0) >> 2] = 0;
       }
       $6 = 0;
       break label$6;
      }
      $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($1 + 32 | 0 | 0, $6 | 0);
      HEAP32[(($1 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($1 + 32 | 0) + 8 | 0) >> 2] | 0;
      i64toi32_i32$2 = $1;
      i64toi32_i32$1 = HEAP32[($1 + 32 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($1 + 36 | 0) >> 2] | 0;
      $83 = i64toi32_i32$1;
      i64toi32_i32$1 = $1;
      HEAP32[($1 + 48 | 0) >> 2] = $83;
      HEAP32[($1 + 52 | 0) >> 2] = i64toi32_i32$0;
      if (hashbrown__map__HashMap_K_2cV_2cS_2cA___insert__h9da49301f604c3c8($0 | 0, $1 + 48 | 0 | 0) | 0) {
       continue label$1
      }
     }
     global$0 = $1 + 80 | 0;
     return $6 | 0;
    }
    $6 = 0;
    continue label$4;
   };
  };
 }
 
 function $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__h6190af30aaed5e17($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $2 = 0, $5 = 0, $6 = 0, $23 = 0, $24 = 0, $25 = 0, $26 = 0, $27 = 0, $28 = 0, $4 = 0, $8 = 0, $9 = 0, $10 = 0, $7 = 0, $40 = 0, $46 = 0, $56 = 0, $11 = 0, $77 = 0, $81 = 0, $85 = 0, $103 = 0, $114 = 0;
  $2 = global$0 - 96 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    $3 = HEAP32[$1 >> 2] | 0;
    if (($3 | 0) == (HEAP32[($1 + 4 | 0) >> 2] | 0 | 0)) {
     break label$2
    }
    HEAP32[$1 >> 2] = HEAP32[($3 + 12 | 0) >> 2] | 0;
    $4 = $1 + 8 | 0;
    $5 = HEAP32[$4 >> 2] | 0;
    $6 = $5 + -1 | 0;
    HEAP32[$4 >> 2] = $6;
    $7 = HEAPU8[($3 + 16 | 0) >> 0] | 0;
    $8 = ($2 + 32 | 0) + 8 | 0;
    i64toi32_i32$2 = $3 + 26 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $40 = i64toi32_i32$0;
    i64toi32_i32$0 = $8;
    HEAP32[i64toi32_i32$0 >> 2] = $40;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    $9 = $2 + 48 | 0;
    i64toi32_i32$2 = $3 + 34 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $46 = i64toi32_i32$1;
    i64toi32_i32$1 = $9;
    HEAP32[i64toi32_i32$1 >> 2] = $46;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    $10 = $2 + 56 | 0;
    $23 = $3 + 42 | 0;
    HEAP32[$10 >> 2] = HEAPU8[$23 >> 0] | 0 | ((HEAPU8[($23 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($23 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($23 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$2 = $3 + 18 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $56 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] = $56;
    HEAP32[(i64toi32_i32$0 + 36 | 0) >> 2] = i64toi32_i32$1;
    $11 = HEAPU8[($3 + 17 | 0) >> 0] | 0;
    alloc__raw_vec__RawVec_T_2cA___allocate_in__hadc977b10ff8afa2(i64toi32_i32$0 + 8 | 0 | 0, ($5 >>> 0 < $6 >>> 0 ? -1 : $5) | 0, 0 | 0);
    $5 = HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] | 0;
    $3 = HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] | 0;
    HEAP8[($3 + 1 | 0) >> 0] = $11;
    HEAP8[$3 >> 0] = $7;
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
    $77 = i64toi32_i32$1;
    i64toi32_i32$1 = $3;
    $24 = $77;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $24;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $24 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = $24 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = $24 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 8 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 9 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$2 = $8;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $81 = i64toi32_i32$0;
    i64toi32_i32$0 = $3 + 10 | 0;
    $25 = $81;
    HEAP8[i64toi32_i32$0 >> 0] = $25;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $25 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $25 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $25 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$2 = $9;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $85 = i64toi32_i32$1;
    i64toi32_i32$1 = $3 + 18 | 0;
    $26 = $85;
    HEAP8[i64toi32_i32$1 >> 0] = $26;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $26 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $26 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $26 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    $27 = $3 + 26 | 0;
    $28 = HEAP32[$10 >> 2] | 0;
    HEAP8[$27 >> 0] = $28;
    HEAP8[($27 + 1 | 0) >> 0] = $28 >>> 8 | 0;
    HEAP8[($27 + 2 | 0) >> 0] = $28 >>> 16 | 0;
    HEAP8[($27 + 3 | 0) >> 0] = $28 >>> 24 | 0;
    $6 = ($2 + 16 | 0) + 8 | 0;
    HEAP32[$6 >> 2] = 1;
    HEAP32[($2 + 20 | 0) >> 2] = $5;
    HEAP32[($2 + 16 | 0) >> 2] = $3;
    HEAP32[$8 >> 2] = HEAP32[$4 >> 2] | 0;
    i64toi32_i32$2 = $1;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $103 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] = $103;
    HEAP32[(i64toi32_i32$0 + 36 | 0) >> 2] = i64toi32_i32$1;
    alloc__vec__Vec_T_2cA___extend_desugared__hc27dc4ae999dc1e4(i64toi32_i32$0 + 16 | 0 | 0, i64toi32_i32$0 + 32 | 0 | 0);
    HEAP32[($0 + 8 | 0) >> 2] = HEAP32[$6 >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] | 0;
    $114 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[i64toi32_i32$1 >> 2] = $114;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    break label$1;
   }
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = 0;
   HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[i64toi32_i32$1 >> 2] = HEAP32[(0 + 1067616 | 0) >> 2] | 0;
  }
  global$0 = $2 + 96 | 0;
 }
 
 function $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__h699867d552ef4144($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $3 = 0, i64toi32_i32$1 = 0, $2 = 0, $5 = 0, $4 = 0, i64toi32_i32$4 = 0, $6 = 0, $7$hi = 0, i64toi32_i32$3 = 0, $7 = 0, $17 = 0, $43$hi = 0, $92 = 0, $103 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     if (!$3) {
      break label$3
     }
     $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     $5 = $3 >>> 0 > $4 >>> 0 ? $4 : $3;
     $6 = $3 - $5 | 0;
     HEAP32[($1 + 4 | 0) >> 2] = $6;
     $3 = HEAP32[$1 >> 2] | 0;
     HEAP32[$1 >> 2] = $3 + ($5 << 2 | 0) | 0;
     label$4 : {
      if (!$5) {
       break label$4
      }
      i64toi32_i32$2 = $3;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = 0;
      $7 = i64toi32_i32$0;
      $7$hi = i64toi32_i32$1;
      label$5 : {
       if (($5 | 0) == (1 | 0)) {
        break label$5
       }
       i64toi32_i32$2 = $3;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$2 = i64toi32_i32$1;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $17 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
        $17 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       $43$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $7$hi;
       i64toi32_i32$1 = $43$hi;
       i64toi32_i32$0 = $17;
       i64toi32_i32$2 = $7$hi;
       i64toi32_i32$3 = $7;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
       $7 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
       $7$hi = i64toi32_i32$2;
      }
      $3 = 0;
      label$6 : {
       if (!$6) {
        break label$6
       }
       if (!$4) {
        break label$2
       }
       $3 = ($6 >>> 0) / ($4 >>> 0) | 0;
       $3 = $3 + (($6 - Math_imul($3, $4) | 0 | 0) != (0 | 0)) | 0;
      }
      $5 = $3 + 1 | 0;
      alloc__raw_vec__RawVec_T_2cA___allocate_in__h59f4452607d575ba($2 + 8 | 0 | 0, ($5 >>> 0 < $3 >>> 0 ? -1 : $5) | 0, 0 | 0);
      $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
      $5 = HEAP32[($2 + 8 | 0) >> 2] | 0;
      i64toi32_i32$2 = $7$hi;
      i64toi32_i32$0 = $5;
      HEAP32[i64toi32_i32$0 >> 2] = $7;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
      $4 = ($2 + 16 | 0) + 8 | 0;
      HEAP32[$4 >> 2] = 1;
      HEAP32[($2 + 20 | 0) >> 2] = $3;
      HEAP32[($2 + 16 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
      i64toi32_i32$1 = $1;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $92 = i64toi32_i32$2;
      i64toi32_i32$2 = $2;
      HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] = $92;
      HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] = i64toi32_i32$0;
      alloc__vec__Vec_T_2cA___extend_desugared__h98ceb10030e010bd(i64toi32_i32$2 + 16 | 0 | 0, i64toi32_i32$2 + 32 | 0 | 0);
      HEAP32[($0 + 8 | 0) >> 2] = HEAP32[$4 >> 2] | 0;
      i64toi32_i32$1 = i64toi32_i32$2;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
      $103 = i64toi32_i32$0;
      i64toi32_i32$0 = $0;
      HEAP32[i64toi32_i32$0 >> 2] = $103;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
      break label$1;
     }
     core__panicking__panic_bounds_check__h808b524af17640b1(0 | 0, 0 | 0, 1067352 | 0);
     abort();
    }
    i64toi32_i32$0 = $0;
    i64toi32_i32$2 = 0;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = 0;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$2;
    HEAP32[i64toi32_i32$0 >> 2] = HEAP32[(0 + 1067624 | 0) >> 2] | 0;
    break label$1;
   }
   core__panicking__panic__h2fd385a887c8bf13(1068032 | 0, 25 | 0, 1068004 | 0);
   abort();
  }
  global$0 = $2 + 48 | 0;
 }
 
 function $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__he4e09da31a8bd115($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $4 = 0, $2 = 0, $7 = 0, $9 = 0, $5 = 0, $6 = 0, $3 = 0, $8 = 0, $29 = 0, $36 = 0, $43 = 0, $46 = 0, $69 = 0, $73 = 0, $77 = 0, $81 = 0, $96 = 0, $100 = 0, $103 = 0, $114 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h7135048eb51d6b68($2 + 8 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    if (HEAP32[($2 + 8 | 0) >> 2] | 0) {
     break label$2
    }
    i64toi32_i32$1 = $0;
    i64toi32_i32$0 = 0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = 0;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[i64toi32_i32$1 >> 2] = HEAP32[(0 + 1067632 | 0) >> 2] | 0;
    break label$1;
   }
   $3 = ($2 + 32 | 0) + 24 | 0;
   $4 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   i64toi32_i32$2 = $4 + 52 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $29 = i64toi32_i32$0;
   i64toi32_i32$0 = $3;
   HEAP32[i64toi32_i32$0 >> 2] = $29;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   $5 = ($2 + 32 | 0) + 16 | 0;
   i64toi32_i32$2 = $4 + 44 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $36 = i64toi32_i32$1;
   i64toi32_i32$1 = $5;
   HEAP32[i64toi32_i32$1 >> 2] = $36;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   $6 = ($2 + 32 | 0) + 8 | 0;
   i64toi32_i32$2 = $4 + 36 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $43 = i64toi32_i32$0;
   i64toi32_i32$0 = $6;
   HEAP32[i64toi32_i32$0 >> 2] = $43;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $4;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
   $46 = i64toi32_i32$1;
   i64toi32_i32$1 = $2;
   HEAP32[(i64toi32_i32$1 + 32 | 0) >> 2] = $46;
   HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] = i64toi32_i32$0;
   $7 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
   $8 = $1 + 24 | 0;
   $4 = HEAP32[$8 >> 2] | 0;
   $9 = $4 + 1 | 0;
   alloc__raw_vec__RawVec_T_2cA___allocate_in__h8bef2550156a85eb(i64toi32_i32$1 | 0, ($9 >>> 0 < $4 >>> 0 ? -1 : $9) | 0, 0 | 0);
   $9 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $4 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   HEAP32[$4 >> 2] = $7;
   i64toi32_i32$2 = i64toi32_i32$1;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 32 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] | 0;
   $69 = i64toi32_i32$0;
   i64toi32_i32$0 = $4;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $69;
   HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $6;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $73 = i64toi32_i32$1;
   i64toi32_i32$1 = $4 + 12 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $73;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $5;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $77 = i64toi32_i32$0;
   i64toi32_i32$0 = $4 + 20 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $77;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $81 = i64toi32_i32$1;
   i64toi32_i32$1 = $4 + 28 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $81;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   $7 = ($2 + 16 | 0) + 8 | 0;
   HEAP32[$7 >> 2] = 1;
   HEAP32[($2 + 16 | 0) >> 2] = $4;
   HEAP32[($2 + 20 | 0) >> 2] = $9;
   HEAP32[i64toi32_i32$2 >> 2] = HEAP32[$8 >> 2] | 0;
   i64toi32_i32$2 = $1 + 16 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $96 = i64toi32_i32$0;
   i64toi32_i32$0 = $5;
   HEAP32[i64toi32_i32$0 >> 2] = $96;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1 + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $100 = i64toi32_i32$1;
   i64toi32_i32$1 = $6;
   HEAP32[i64toi32_i32$1 >> 2] = $100;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $1;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $103 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] = $103;
   HEAP32[(i64toi32_i32$0 + 36 | 0) >> 2] = i64toi32_i32$1;
   alloc__vec__Vec_T_2cA___extend_desugared__h1d4e76ec6089b795(i64toi32_i32$0 + 16 | 0 | 0, i64toi32_i32$0 + 32 | 0 | 0);
   HEAP32[($0 + 8 | 0) >> 2] = HEAP32[$7 >> 2] | 0;
   i64toi32_i32$2 = i64toi32_i32$0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] | 0;
   $114 = i64toi32_i32$1;
   i64toi32_i32$1 = $0;
   HEAP32[i64toi32_i32$1 >> 2] = $114;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  }
  global$0 = $2 + 64 | 0;
 }
 
 function cardano_serialization_lib__address__ByronAddress__from_bytes__h9704f398e56b45f1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, $3 = 0, i64toi32_i32$1 = 0, $4 = 0, $16 = 0;
  $2 = global$0 - 288 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 8 | 0) >> 2] = 0;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $16 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $16;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__legacy_address__address__ExtendedAddr_20as_20cbor_event__de__Deserialize___deserialize__h960edb2a7588f7b4($2 + 176 | 0 | 0, $2 + 8 | 0 | 0);
  $3 = 1;
  $1 = ($2 + 8 | 0) + 8 | 0;
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 176 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $3 = HEAPU8[(($2 + 176 | 0) + 8 | 0) >> 0] | 0;
    $4 = HEAP32[($2 + 180 | 0) >> 2] | 0;
    memcpy($2 + 129 | 0 | 0, ($2 + 176 | 0) + 9 | 0 | 0, 47 | 0) | 0;
    memcpy($2 + 82 | 0 | 0, $2 + 129 | 0 | 0, 47 | 0) | 0;
    memcpy($2 + 35 | 0 | 0, $2 + 82 | 0 | 0, 47 | 0) | 0;
    HEAP8[($0 + 8 | 0) >> 0] = $3;
    memcpy($0 + 9 | 0 | 0, $2 + 35 | 0 | 0, 47 | 0) | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
    $3 = 0;
    break label$1;
   }
   memcpy($2 + 248 | 0 | 0, ($2 + 176 | 0) + 8 | 0 | 0, 40 | 0) | 0;
   memcpy($2 + 129 | 0 | 0, $2 + 241 | 0 | 0, 47 | 0) | 0;
   memcpy($2 + 82 | 0 | 0, $2 + 129 | 0 | 0, 47 | 0) | 0;
   HEAP8[($2 + 176 | 0) >> 0] = 2;
   memcpy($2 + 176 | 0 | 1 | 0 | 0, $2 + 82 | 0 | 0, 47 | 0) | 0;
   HEAP32[($2 + 224 | 0) >> 2] = 0;
   $4 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 176 | 0 | 0) | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  }
  HEAP32[$0 >> 2] = $3;
  HEAP32[($0 + 4 | 0) >> 2] = $4;
  global$0 = $2 + 288 | 0;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__h735bfebae1d8ccce($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$4 = 0, $3 = 0, i64toi32_i32$2 = 0, $4 = 0, i64toi32_i32$3 = 0, $2 = 0, $4$hi = 0, $11 = 0, $12 = 0;
  $2 = global$0 - 128 | 0;
  global$0 = $2;
  $0 = HEAP32[$0 >> 2] | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       $3 = HEAP32[$1 >> 2] | 0;
       if ($3 & 16 | 0) {
        break label$5
       }
       if ($3 & 32 | 0) {
        break label$4
       }
       i64toi32_i32$2 = $0;
       i64toi32_i32$0 = HEAP32[$0 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
       $0 = core__fmt__num__imp__fmt_u64__hf0469431dace4046(i64toi32_i32$0 | 0, i64toi32_i32$1 | 0, 1 | 0, $1 | 0) | 0;
       break label$3;
      }
      i64toi32_i32$2 = $0;
      i64toi32_i32$1 = HEAP32[$0 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
      $4 = i64toi32_i32$1;
      $4$hi = i64toi32_i32$0;
      $0 = 128;
      label$6 : {
       label$7 : while (1) {
        label$8 : {
         if ($0) {
          break label$8
         }
         $0 = 0;
         break label$6;
        }
        i64toi32_i32$0 = $4$hi;
        $3 = $4 & 15 | 0;
        HEAP8[(($2 + $0 | 0) + -1 | 0) >> 0] = $3 >>> 0 < 10 >>> 0 ? $3 | 48 | 0 : $3 + 87 | 0;
        $0 = $0 + -1 | 0;
        i64toi32_i32$2 = $4;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 4;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$1 = 0;
         $11 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
        } else {
         i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
         $11 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
        }
        $4 = $11;
        $4$hi = i64toi32_i32$1;
        i64toi32_i32$0 = $4;
        i64toi32_i32$2 = 0;
        i64toi32_i32$3 = 0;
        if ((i64toi32_i32$0 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$2 | 0) | 0) {
         continue label$7
        }
        break label$7;
       };
       if ($0 >>> 0 >= 129 >>> 0) {
        break label$2
       }
      }
      $0 = core__fmt__Formatter__pad_integral__h08e3e53a0de517a1($1 | 0, 1 | 0, 1150180 | 0, 2 | 0, $2 + $0 | 0 | 0, 128 - $0 | 0 | 0) | 0;
      break label$3;
     }
     i64toi32_i32$3 = $0;
     i64toi32_i32$0 = HEAP32[$0 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
     $4 = i64toi32_i32$0;
     $4$hi = i64toi32_i32$1;
     $0 = 128;
     label$9 : {
      label$10 : while (1) {
       label$11 : {
        if ($0) {
         break label$11
        }
        $0 = 0;
        break label$9;
       }
       i64toi32_i32$1 = $4$hi;
       $3 = $4 & 15 | 0;
       HEAP8[(($2 + $0 | 0) + -1 | 0) >> 0] = $3 >>> 0 < 10 >>> 0 ? $3 | 48 | 0 : $3 + 55 | 0;
       $0 = $0 + -1 | 0;
       i64toi32_i32$3 = $4;
       i64toi32_i32$0 = 0;
       i64toi32_i32$2 = 4;
       i64toi32_i32$4 = i64toi32_i32$2 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$2 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = 0;
        $12 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
        $12 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$4 | 0) | 0;
       }
       $4 = $12;
       $4$hi = i64toi32_i32$0;
       i64toi32_i32$1 = $4;
       i64toi32_i32$3 = 0;
       i64toi32_i32$2 = 0;
       if ((i64toi32_i32$1 | 0) != (i64toi32_i32$2 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$3 | 0) | 0) {
        continue label$10
       }
       break label$10;
      };
      if ($0 >>> 0 >= 129 >>> 0) {
       break label$1
      }
     }
     $0 = core__fmt__Formatter__pad_integral__h08e3e53a0de517a1($1 | 0, 1 | 0, 1150180 | 0, 2 | 0, $2 + $0 | 0 | 0, 128 - $0 | 0 | 0) | 0;
    }
    global$0 = $2 + 128 | 0;
    return $0 | 0;
   }
   core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($0 | 0, 128 | 0, 1150164 | 0);
   abort();
  }
  core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($0 | 0, 128 | 0, 1150164 | 0);
  abort();
 }
 
 function cardano_serialization_lib__tx_builder__TransactionBuilder__get_combined_plutus_scripts__he342d6c2d4187ac3($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, $5 = 0, $5$hi = 0, $89 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 4 | 0) >> 2] = 0;
  HEAP32[($2 + 8 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[$2 >> 2] = HEAP32[(0 + 1069056 | 0) >> 2] | 0;
  cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__get_plutus_input_scripts__h7e973282eea0f34a($2 + 16 | 0 | 0, $1 + 96 | 0 | 0);
  label$1 : {
   if (!(HEAP32[($2 + 16 | 0) >> 2] | 0)) {
    break label$1
   }
   $3 = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
   HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = $3;
   i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   $5 = i64toi32_i32$0;
   $5$hi = i64toi32_i32$1;
   i64toi32_i32$0 = $2;
   HEAP32[($2 + 32 | 0) >> 2] = $5;
   HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
   label$2 : {
    if (!$3) {
     break label$2
    }
    i64toi32_i32$1 = $5$hi;
    $4 = $5;
    $3 = Math_imul($3, 144);
    label$3 : while (1) {
     cardano_serialization_lib__tx_builder__tx_inputs_builder__PlutusWitnesses__add__hec4d4aff8ce90d4a($2 | 0, $4 | 0);
     $4 = $4 + 144 | 0;
     $3 = $3 + -144 | 0;
     if ($3) {
      continue label$3
     }
     break label$3;
    };
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h1bbffe174ae872d8($2 + 32 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h9b1d3bb47b46eeb8($2 + 32 | 0 | 0);
  }
  cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__get_plutus_input_scripts__h7e973282eea0f34a($2 + 16 | 0 | 0, $1 + 176 | 0 | 0);
  label$4 : {
   if (!(HEAP32[($2 + 16 | 0) >> 2] | 0)) {
    break label$4
   }
   $3 = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
   HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = $3;
   i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   $5 = i64toi32_i32$1;
   $5$hi = i64toi32_i32$0;
   i64toi32_i32$1 = $2;
   HEAP32[($2 + 32 | 0) >> 2] = $5;
   HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$0;
   label$5 : {
    if (!$3) {
     break label$5
    }
    i64toi32_i32$0 = $5$hi;
    $4 = $5;
    $3 = Math_imul($3, 144);
    label$6 : while (1) {
     cardano_serialization_lib__tx_builder__tx_inputs_builder__PlutusWitnesses__add__hec4d4aff8ce90d4a($2 | 0, $4 | 0);
     $4 = $4 + 144 | 0;
     $3 = $3 + -144 | 0;
     if ($3) {
      continue label$6
     }
     break label$6;
    };
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h1bbffe174ae872d8($2 + 32 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h9b1d3bb47b46eeb8($2 + 32 | 0 | 0);
  }
  label$7 : {
   label$8 : {
    if (!(HEAP32[($2 + 8 | 0) >> 2] | 0)) {
     break label$8
    }
    i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
    $89 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[i64toi32_i32$0 >> 2] = $89;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
    break label$7;
   }
   HEAP32[$0 >> 2] = 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h1bbffe174ae872d8($2 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h9b1d3bb47b46eeb8($2 | 0);
  }
  global$0 = $2 + 48 | 0;
 }
 
 function cardano_serialization_lib__crypto__Bip32PrivateKey__generate_ed25519_bip32__h93952b584c86e584($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, $2 = 0, i64toi32_i32$1 = 0, $12 = 0, $13 = 0, i64toi32_i32$2 = 0, $14 = 0, $4 = 0, $4$hi = 0, $5 = 0, $5$hi = 0, $69 = 0, $3 = 0;
  $1 = global$0 - 272 | 0;
  global$0 = $1;
  rand_os__OsRng__new__hc49e74e2fe75aed3($1 + 224 | 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[($1 + 224 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $2 = $1 + 120 | 0 | 1 | 0;
    $cardano_serialization_lib__chain_crypto__algorithms__ed25519_derive__Ed25519Bip32_20as_20cardano_serialization_lib__chain_crypto__key__AsymmetricKey___generate__h3f0728b57fe14151($2 | 0, HEAP32[($1 + 228 | 0) >> 2] | 0 | 0, HEAP32[($1 + 232 | 0) >> 2] | 0 | 0);
    memcpy($1 + 24 | 0 | 0, $2 | 0, 96 | 0) | 0;
    memcpy($0 + 1 | 0 | 0, $1 + 24 | 0 | 0, 96 | 0) | 0;
    $2 = 0;
    break label$1;
   }
   i64toi32_i32$2 = $1 + 236 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $4 = i64toi32_i32$0;
   $4$hi = i64toi32_i32$1;
   i64toi32_i32$0 = $1 + 35 | 0;
   $12 = $4;
   HEAP8[i64toi32_i32$0 >> 0] = $12;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $12 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $12 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $12 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   $2 = HEAP32[(($1 + 224 | 0) + 20 | 0) >> 2] | 0;
   $14 = $1 + 43 | 0;
   HEAP8[$14 >> 0] = $2;
   HEAP8[($14 + 1 | 0) >> 0] = $2 >>> 8 | 0;
   HEAP8[($14 + 2 | 0) >> 0] = $2 >>> 16 | 0;
   HEAP8[($14 + 3 | 0) >> 0] = $2 >>> 24 | 0;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[($1 + 228 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($1 + 232 | 0) >> 2] | 0;
   $5 = i64toi32_i32$1;
   $5$hi = i64toi32_i32$0;
   i64toi32_i32$1 = $1;
   $13 = $5;
   HEAP8[($1 + 27 | 0) >> 0] = $13;
   HEAP8[($1 + 28 | 0) >> 0] = $13 >>> 8 | 0;
   HEAP8[($1 + 29 | 0) >> 0] = $13 >>> 16 | 0;
   HEAP8[($1 + 30 | 0) >> 0] = $13 >>> 24 | 0;
   HEAP8[($1 + 31 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[($1 + 32 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[($1 + 33 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[($1 + 34 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   HEAP32[($1 + 240 | 0) >> 2] = $2;
   $2 = $1 + 232 | 0;
   i64toi32_i32$0 = $4$hi;
   i64toi32_i32$1 = $2;
   HEAP32[i64toi32_i32$1 >> 2] = $12;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $5$hi;
   i64toi32_i32$1 = $1;
   HEAP32[($1 + 224 | 0) >> 2] = $13;
   HEAP32[($1 + 228 | 0) >> 2] = i64toi32_i32$0;
   core__fmt__ArgumentV1__new__hc180267ccf44df88($1 + 16 | 0 | 0, $1 + 224 | 0 | 0, 109 | 0);
   HEAP32[(($1 + 120 | 0) + 20 | 0) >> 2] = 1;
   i64toi32_i32$1 = $1;
   i64toi32_i32$0 = 0;
   HEAP32[($1 + 124 | 0) >> 2] = 1;
   HEAP32[($1 + 128 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($1 + 120 | 0) >> 2] = 1066504;
   i64toi32_i32$2 = $1;
   i64toi32_i32$0 = HEAP32[($1 + 16 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
   $69 = i64toi32_i32$0;
   i64toi32_i32$0 = $1;
   HEAP32[($1 + 264 | 0) >> 2] = $69;
   HEAP32[($1 + 268 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($1 + 136 | 0) >> 2] = $1 + 264 | 0;
   alloc__fmt__format__h6e9e003a52c07309($1 + 248 | 0 | 0, $1 + 120 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($1 + 8 | 0 | 0, $1 + 248 | 0 | 0);
   $3 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($1 + 8 | 0) >> 2] | 0 | 0, HEAP32[($1 + 12 | 0) >> 2] | 0 | 0) | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 + 248 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 + 248 | 0 | 0);
   label$3 : {
    if (!(HEAP32[$2 >> 2] | 0)) {
     break label$3
    }
    core__ptr__drop_in_place_alloc__boxed__Box_dyn_20std__error__Error_core__marker__Sync_core__marker__Send____h3635675e5a953b32($2 | 0);
   }
   HEAP32[($0 + 4 | 0) >> 2] = $3;
   $2 = 1;
  }
  HEAP8[$0 >> 0] = $2;
  global$0 = $1 + 272 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_fit__h3ff3b3a963f2e253($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $3 = 0, $4 = 0, $5 = 0, $22 = 0, $23 = 0, $24 = 0, $25 = 0, $26 = 0, $27 = 0, $8 = 0, $9 = 0, $6 = 0, $7 = 0, $10 = 0, $31 = 0, $37 = 0, $40 = 0, $73 = 0, $77 = 0, $81 = 0, $88 = 0, $118 = 0;
  $3 = global$0 - 32 | 0;
  global$0 = $3;
  $4 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $5 = HEAPU16[($4 + 138 | 0) >> 1] | 0;
  $0 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  $6 = $3 + 24 | 0;
  $22 = $1 + 24 | 0;
  HEAP32[$6 >> 2] = HEAPU8[$22 >> 0] | 0 | ((HEAPU8[($22 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($22 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($22 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $7 = $3 + 16 | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $7;
  HEAP32[i64toi32_i32$0 >> 2] = $31;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $8 = $3 + 8 | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $37 = i64toi32_i32$1;
  i64toi32_i32$1 = $8;
  HEAP32[i64toi32_i32$1 >> 2] = $37;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $40 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $40;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   $9 = $0 + 1 | 0;
   $10 = $9 >>> 0 > $5 >>> 0;
   if ($10) {
    break label$1
   }
   $1 = $4 + 140 | 0;
   memmove($1 + Math_imul($9, 28) | 0 | 0, $1 + Math_imul($0, 28) | 0 | 0, Math_imul($5 - $0 | 0, 28) | 0) | 0;
  }
  $1 = $4 + Math_imul($0, 28) | 0;
  $23 = $1 + 164 | 0;
  $24 = HEAP32[$6 >> 2] | 0;
  HEAP8[$23 >> 0] = $24;
  HEAP8[($23 + 1 | 0) >> 0] = $24 >>> 8 | 0;
  HEAP8[($23 + 2 | 0) >> 0] = $24 >>> 16 | 0;
  HEAP8[($23 + 3 | 0) >> 0] = $24 >>> 24 | 0;
  i64toi32_i32$2 = $7;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $73 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 156 | 0;
  $25 = $73;
  HEAP8[i64toi32_i32$1 >> 0] = $25;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $25 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $25 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $25 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $8;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $77 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 148 | 0;
  $26 = $77;
  HEAP8[i64toi32_i32$0 >> 0] = $26;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $26 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $26 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $26 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $81 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 140 | 0;
  $27 = $81;
  HEAP8[i64toi32_i32$1 >> 0] = $27;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $27 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $27 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $27 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP32[$8 >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $88 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $88;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  label$2 : {
   if ($10) {
    break label$2
   }
   $1 = $4 + 4 | 0;
   memmove($1 + Math_imul($9, 12) | 0 | 0, $1 + Math_imul($0, 12) | 0 | 0, Math_imul($5 - $0 | 0, 12) | 0) | 0;
  }
  $0 = $4 + Math_imul($0, 12) | 0;
  HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($3 + 8 | 0) >> 2] | 0;
  $0 = $0 + 4 | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $118 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $118;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP16[($4 + 138 | 0) >> 1] = $5 + 1 | 0;
  global$0 = i64toi32_i32$2 + 32 | 0;
  return i64toi32_i32$1 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_fit__he0b77dcf0cf8e7bd($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $3 = 0, $4 = 0, $5 = 0, $22 = 0, $23 = 0, $24 = 0, $25 = 0, $26 = 0, $27 = 0, $8 = 0, $9 = 0, $6 = 0, $7 = 0, $10 = 0, $31 = 0, $37 = 0, $40 = 0, $73 = 0, $77 = 0, $81 = 0, $88 = 0, $118 = 0;
  $3 = global$0 - 32 | 0;
  global$0 = $3;
  $4 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $5 = HEAPU16[($4 + 138 | 0) >> 1] | 0;
  $0 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  $6 = $3 + 24 | 0;
  $22 = $1 + 24 | 0;
  HEAP32[$6 >> 2] = HEAPU8[$22 >> 0] | 0 | ((HEAPU8[($22 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($22 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($22 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $7 = $3 + 16 | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $7;
  HEAP32[i64toi32_i32$0 >> 2] = $31;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $8 = $3 + 8 | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $37 = i64toi32_i32$1;
  i64toi32_i32$1 = $8;
  HEAP32[i64toi32_i32$1 >> 2] = $37;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $40 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $40;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   $9 = $0 + 1 | 0;
   $10 = $9 >>> 0 > $5 >>> 0;
   if ($10) {
    break label$1
   }
   $1 = $4 + 140 | 0;
   memmove($1 + Math_imul($9, 28) | 0 | 0, $1 + Math_imul($0, 28) | 0 | 0, Math_imul($5 - $0 | 0, 28) | 0) | 0;
  }
  $1 = $4 + Math_imul($0, 28) | 0;
  $23 = $1 + 164 | 0;
  $24 = HEAP32[$6 >> 2] | 0;
  HEAP8[$23 >> 0] = $24;
  HEAP8[($23 + 1 | 0) >> 0] = $24 >>> 8 | 0;
  HEAP8[($23 + 2 | 0) >> 0] = $24 >>> 16 | 0;
  HEAP8[($23 + 3 | 0) >> 0] = $24 >>> 24 | 0;
  i64toi32_i32$2 = $7;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $73 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 156 | 0;
  $25 = $73;
  HEAP8[i64toi32_i32$1 >> 0] = $25;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $25 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $25 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $25 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $8;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $77 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 148 | 0;
  $26 = $77;
  HEAP8[i64toi32_i32$0 >> 0] = $26;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $26 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $26 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $26 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $81 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 140 | 0;
  $27 = $81;
  HEAP8[i64toi32_i32$1 >> 0] = $27;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $27 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $27 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $27 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP32[$8 >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $88 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $88;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  label$2 : {
   if ($10) {
    break label$2
   }
   $1 = $4 + 4 | 0;
   memmove($1 + Math_imul($9, 12) | 0 | 0, $1 + Math_imul($0, 12) | 0 | 0, Math_imul($5 - $0 | 0, 12) | 0) | 0;
  }
  $0 = $4 + Math_imul($0, 12) | 0;
  HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($3 + 8 | 0) >> 2] | 0;
  $0 = $0 + 4 | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $118 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $118;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP16[($4 + 138 | 0) >> 1] = $5 + 1 | 0;
  global$0 = i64toi32_i32$2 + 32 | 0;
  return i64toi32_i32$1 | 0;
 }
 
 function cbor_event__de__Deserializer_R___u32__h46f77234696376fa($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $2 = 0, $3 = 0, $4 = 0, $5 = 0, $5$hi = 0, $36 = 0, $37 = 0, $38 = 0, $39 = 0, $40 = 0, $41 = 0, $42 = 0, $6 = 0, $6$hi = 0, $7 = 0, $7$hi = 0, $60 = 0, $62 = 0, $62$hi = 0, $64$hi = 0, $65 = 0, $65$hi = 0, $67$hi = 0, $68 = 0, $68$hi = 0, $70 = 0, $70$hi = 0, $71 = 0, $74 = 0, $78 = 0, $81 = 0, $85 = 0, $88 = 0, $92 = 0, $95 = 0, $99 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 24 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       $3 = HEAP32[($2 + 28 | 0) >> 2] | 0;
       if ($3 >>> 0 < 2 >>> 0) {
        break label$5
       }
       $4 = HEAP32[($2 + 24 | 0) >> 2] | 0;
       if (!$4) {
        break label$5
       }
       i64toi32_i32$2 = $4;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0;
       i64toi32_i32$1 = 0;
       $5 = i64toi32_i32$0;
       $5$hi = i64toi32_i32$1;
       std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 16 | 0 | 0, $1 | 0);
       $3 = HEAP32[($2 + 20 | 0) >> 2] | 0;
       if ($3 >>> 0 < 3 >>> 0) {
        break label$4
       }
       $4 = HEAP32[($2 + 16 | 0) >> 2] | 0;
       if (!$4) {
        break label$4
       }
       i64toi32_i32$2 = $4;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0;
       i64toi32_i32$0 = 0;
       $6 = i64toi32_i32$1;
       $6$hi = i64toi32_i32$0;
       std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 8 | 0 | 0, $1 | 0);
       $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
       if ($3 >>> 0 < 4 >>> 0) {
        break label$3
       }
       $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
       if (!$4) {
        break label$3
       }
       i64toi32_i32$2 = $4;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0;
       i64toi32_i32$1 = 0;
       $7 = i64toi32_i32$0;
       $7$hi = i64toi32_i32$1;
       std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 | 0, $1 | 0);
       label$6 : {
        $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
        if ($1 >>> 0 < 5 >>> 0) {
         break label$6
        }
        $3 = HEAP32[$2 >> 2] | 0;
        if (!$3) {
         break label$6
        }
        $60 = $0;
        i64toi32_i32$1 = $6$hi;
        i64toi32_i32$2 = $6;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 16;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
         $36 = 0;
        } else {
         i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
         $36 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        }
        $62 = $36;
        $62$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $5$hi;
        i64toi32_i32$1 = $5;
        i64toi32_i32$2 = 0;
        i64toi32_i32$3 = 24;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
         $37 = 0;
        } else {
         i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
         $37 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        }
        $64$hi = i64toi32_i32$2;
        i64toi32_i32$2 = $62$hi;
        i64toi32_i32$0 = $62;
        i64toi32_i32$1 = $64$hi;
        i64toi32_i32$3 = $37;
        i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
        $65 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
        $65$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $7$hi;
        i64toi32_i32$2 = $7;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 8;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
         $38 = 0;
        } else {
         i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
         $38 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        }
        $67$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $65$hi;
        i64toi32_i32$1 = $65;
        i64toi32_i32$2 = $67$hi;
        i64toi32_i32$3 = $38;
        i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
        $68 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
        $68$hi = i64toi32_i32$2;
        i64toi32_i32$0 = $3;
        i64toi32_i32$2 = HEAPU8[(i64toi32_i32$0 + 4 | 0) >> 0] | 0;
        i64toi32_i32$1 = 0;
        $70 = i64toi32_i32$2;
        $70$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $68$hi;
        i64toi32_i32$0 = $68;
        i64toi32_i32$2 = $70$hi;
        i64toi32_i32$3 = $70;
        i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
        $71 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
        i64toi32_i32$0 = $60;
        HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $71;
        HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
        i64toi32_i32$2 = 0;
        $5 = 0;
        $5$hi = i64toi32_i32$2;
        break label$1;
       }
       HEAP32[($0 + 16 | 0) >> 2] = 4;
       $74 = $0;
       i64toi32_i32$2 = 0;
       i64toi32_i32$1 = $1;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        $39 = 0;
       } else {
        i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
        $39 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       }
       i64toi32_i32$2 = $39;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 8;
       i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
       $78 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       i64toi32_i32$2 = $74;
       HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $78;
       HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$1;
       break label$2;
      }
      HEAP32[($0 + 16 | 0) >> 2] = 1;
      $81 = $0;
      i64toi32_i32$1 = 0;
      i64toi32_i32$0 = $3;
      i64toi32_i32$2 = 0;
      i64toi32_i32$3 = 32;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
       $40 = 0;
      } else {
       i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
       $40 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
      }
      i64toi32_i32$1 = $40;
      i64toi32_i32$0 = 0;
      i64toi32_i32$3 = 8;
      i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
      $85 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
      i64toi32_i32$1 = $81;
      HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $85;
      HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
      break label$2;
     }
     HEAP32[($0 + 16 | 0) >> 2] = 2;
     $88 = $0;
     i64toi32_i32$0 = 0;
     i64toi32_i32$2 = $3;
     i64toi32_i32$1 = 0;
     i64toi32_i32$3 = 32;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
      $41 = 0;
     } else {
      i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
      $41 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
     }
     i64toi32_i32$0 = $41;
     i64toi32_i32$2 = 0;
     i64toi32_i32$3 = 8;
     i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
     $92 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
     i64toi32_i32$0 = $88;
     HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $92;
     HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
     break label$2;
    }
    HEAP32[($0 + 16 | 0) >> 2] = 3;
    $95 = $0;
    i64toi32_i32$2 = 0;
    i64toi32_i32$1 = $3;
    i64toi32_i32$0 = 0;
    i64toi32_i32$3 = 32;
    i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
     $42 = 0;
    } else {
     i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
     $42 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
    }
    i64toi32_i32$2 = $42;
    i64toi32_i32$1 = 0;
    i64toi32_i32$3 = 8;
    i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
    $99 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
    i64toi32_i32$2 = $95;
    HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $99;
    HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$1;
   }
   i64toi32_i32$1 = 0;
   $5 = 1;
   $5$hi = i64toi32_i32$1;
  }
  i64toi32_i32$1 = $5$hi;
  i64toi32_i32$2 = $0;
  HEAP32[i64toi32_i32$2 >> 2] = $5;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $2 + 32 | 0;
 }
 
 function cardano_serialization_lib__plutus__PlutusData__new_empty_constr_plutus_data__h775dcd2e87db4a95($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $6 = 0, $6$hi = 0, $3 = 0, $4 = 0, $5 = 0, $36 = 0, $41 = 0, $51 = 0, $64 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 36 | 0) >> 2] = 0;
  HEAP32[($2 + 40 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 32 | 0) >> 2] = HEAP32[(0 + 1070736 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $6 = i64toi32_i32$0;
  $6$hi = i64toi32_i32$1;
  HEAP8[($2 + 44 | 0) >> 0] = 2;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hc831120dea694494($2 + 48 | 0 | 0, $2 + 32 | 0 | 0);
  $1 = HEAPU8[($2 + 44 | 0) >> 0] | 0;
  HEAP8[($2 + 60 | 0) >> 0] = ($1 | 0) == (2 | 0) ? 2 : ($1 | 0) != (0 | 0);
  $1 = ($2 + 8 | 0) + 16 | 0;
  $3 = ($2 + 48 | 0) + 8 | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $6;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $41 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $41;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$1;
  $4 = ($2 + 8 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hc831120dea694494($2 + 48 | 0 | 0, $4 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $51 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $51;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $5 = HEAPU8[($2 + 28 | 0) >> 0] | 0;
  HEAP8[($2 + 60 | 0) >> 0] = ($5 | 0) == (2 | 0) ? 2 : ($5 | 0) != (0 | 0);
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $64 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 24 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $64;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($0 + 32 | 0) >> 2] = 0;
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$0 = $0 + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $6;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[$0 >> 2] = 0;
  label$1 : {
   $1 = HEAP32[$1 >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
   $1 = Math_imul($1, 48);
   label$2 : while (1) {
    core__ptr__drop_in_place_cardano_serialization_lib__plutus__PlutusData___hfab843e66e0f9428_2($0 | 0);
    $0 = $0 + 48 | 0;
    $1 = $1 + -48 | 0;
    if ($1) {
     continue label$2
    }
    break label$2;
   };
  }
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h36e817e704f6f25e($4 | 0);
  label$3 : {
   $1 = HEAP32[($2 + 40 | 0) >> 2] | 0;
   if (!$1) {
    break label$3
   }
   $0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
   $1 = Math_imul($1, 48);
   label$4 : while (1) {
    core__ptr__drop_in_place_cardano_serialization_lib__plutus__PlutusData___hfab843e66e0f9428_2($0 | 0);
    $0 = $0 + 48 | 0;
    $1 = $1 + -48 | 0;
    if ($1) {
     continue label$4
    }
    break label$4;
   };
  }
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h36e817e704f6f25e($2 + 32 | 0 | 0);
  global$0 = $2 + 64 | 0;
 }
 
 function cardano_serialization_lib__legacy_address__address__ExtendedAddr__to_address__hf1649f2dced0034f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $9 = 0, $10 = 0, $11 = 0, $12 = 0, $14 = 0, $13 = 0, $40 = 0, $4 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 + 8 | 0 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 64 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $13 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 56 | 0) >> 2] = $13;
  HEAP32[($2 + 60 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__legacy_address__address__ExtendedAddr_20as_20cbor_event__se__Serialize___serialize__hab4aa0fda5dfbd1b($2 + 112 | 0 | 0, $1 | 0, $2 + 56 | 0 | 0);
  $1 = 19;
  label$1 : {
   if ((HEAP32[($2 + 112 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   $1 = HEAPU8[($2 + 120 | 0) >> 0] | 0;
   memcpy($2 + 73 | 0 | 0, $2 + 121 | 0 | 0, 39 | 0) | 0;
  }
  $3 = ($2 + 112 | 0) + 8 | 0;
  HEAP32[$3 >> 2] = HEAP32[(($2 + 56 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 56 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 60 | 0) >> 2] | 0;
  $40 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 112 | 0) >> 2] = $40;
  HEAP32[($2 + 116 | 0) >> 2] = i64toi32_i32$0;
  label$2 : {
   label$3 : {
    if (($1 & 255 | 0 | 0) != (19 | 0)) {
     break label$3
    }
    HEAP32[($2 + 16 | 0) >> 2] = HEAPU8[($2 + 117 | 0) >> 0] | 0 | ((HEAPU8[($2 + 118 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 119 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 120 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $9 = HEAPU8[$3 >> 0] | 0 | ((HEAPU8[($3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    HEAP8[($2 + 19 | 0) >> 0] = $9;
    HEAP8[($2 + 20 | 0) >> 0] = $9 >>> 8 | 0;
    HEAP8[($2 + 21 | 0) >> 0] = $9 >>> 16 | 0;
    HEAP8[($2 + 22 | 0) >> 0] = $9 >>> 24 | 0;
    $3 = HEAPU8[($2 + 116 | 0) >> 0] | 0;
    $4 = HEAP32[($2 + 112 | 0) >> 2] | 0;
    break label$2;
   }
   memcpy($2 + 16 | 0 | 0, $2 + 73 | 0 | 0, 39 | 0) | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 112 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 112 | 0 | 0);
   $3 = $1;
  }
  label$4 : {
   if (($1 & 255 | 0 | 0) == (19 | 0)) {
    break label$4
   }
   HEAP8[($2 + 112 | 0) >> 0] = $3;
   memcpy($2 + 112 | 0 | 1 | 0 | 0, $2 + 16 | 0 | 0, 39 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1072108 | 0, 43 | 0, $2 + 112 | 0 | 0, 1072092 | 0, 1072704 | 0);
   abort();
  }
  $10 = HEAPU8[($2 + 19 | 0) >> 0] | 0 | ((HEAPU8[($2 + 20 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 21 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 22 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  HEAP8[($2 + 115 | 0) >> 0] = $10;
  HEAP8[($2 + 116 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[($2 + 117 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[($2 + 118 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP32[($2 + 112 | 0) >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
  HEAP8[($0 + 4 | 0) >> 0] = $3;
  HEAP32[$0 >> 2] = $4;
  $11 = HEAP32[($2 + 112 | 0) >> 2] | 0;
  HEAP8[($0 + 5 | 0) >> 0] = $11;
  HEAP8[($0 + 6 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[($0 + 7 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[($0 + 8 | 0) >> 0] = $11 >>> 24 | 0;
  $12 = $0 + 8 | 0;
  $14 = HEAPU8[($2 + 115 | 0) >> 0] | 0 | ((HEAPU8[($2 + 116 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 117 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 118 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  HEAP8[$12 >> 0] = $14;
  HEAP8[($12 + 1 | 0) >> 0] = $14 >>> 8 | 0;
  HEAP8[($12 + 2 | 0) >> 0] = $14 >>> 16 | 0;
  HEAP8[($12 + 3 | 0) >> 0] = $14 >>> 24 | 0;
  global$0 = $2 + 160 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert__h17bb893a58beb336($0, $1, $2, $3, $4, $5) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  $5 = $5 | 0;
  var $6 = 0, $7 = 0, $8 = 0;
  $6 = global$0 - 224 | 0;
  global$0 = $6;
  label$1 : {
   label$2 : {
    $7 = HEAP32[$1 >> 2] | 0;
    if (($7 + -1 | 0 | 0) != ($4 | 0)) {
     break label$2
    }
    label$3 : {
     label$4 : {
      label$5 : {
       $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
       if ((HEAPU16[($4 + 1062 | 0) >> 1] | 0) >>> 0 < 11 >>> 0) {
        break label$5
       }
       alloc__collections__btree__node__splitpoint__h8424344594b4deb1($6 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
       $1 = HEAP32[($6 + 8 | 0) >> 2] | 0;
       $8 = HEAP32[($6 + 4 | 0) >> 2] | 0;
       HEAP32[($6 + 184 | 0) >> 2] = HEAP32[$6 >> 2] | 0;
       HEAP32[($6 + 180 | 0) >> 2] = $4;
       HEAP32[($6 + 176 | 0) >> 2] = $7;
       alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__KV___split__h8533c651584e4f97($6 | 0, $6 + 176 | 0 | 0);
       if (($8 | 0) == (1 | 0)) {
        break label$4
       }
       HEAP32[($6 + 112 | 0) >> 2] = HEAP32[($6 + 96 | 0) >> 2] | 0;
       $4 = HEAP32[($6 + 100 | 0) >> 2] | 0;
       break label$3;
      }
      memcpy($6 + 176 | 0 | 0, $2 | 0, 48 | 0) | 0;
      $2 = memcpy($6 | 0, $3 | 0, 48 | 0) | 0;
      alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert_fit__h22bde63da6884187($1 | 0, $2 + 176 | 0 | 0, $2 | 0, $6 | 0, $5 | 0);
      HEAP32[($0 + 8 | 0) >> 2] = $4;
      HEAP32[($0 + 4 | 0) >> 2] = $7;
      HEAP32[$0 >> 2] = 0;
      HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
      break label$1;
     }
     HEAP32[($6 + 112 | 0) >> 2] = HEAP32[($6 + 104 | 0) >> 2] | 0;
     $4 = HEAP32[($6 + 108 | 0) >> 2] | 0;
    }
    HEAP32[($6 + 120 | 0) >> 2] = $1;
    HEAP32[($6 + 116 | 0) >> 2] = $4;
    memcpy($6 + 128 | 0 | 0, $2 | 0, 48 | 0) | 0;
    memcpy($6 + 176 | 0 | 0, $3 | 0, 48 | 0) | 0;
    alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert_fit__h22bde63da6884187($6 + 112 | 0 | 0, $6 + 128 | 0 | 0, $6 + 176 | 0 | 0, $6 | 0, $5 | 0);
    memcpy($0 + 8 | 0 | 0, $6 | 0, 112 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    break label$1;
   }
   core__panicking__panic__h2fd385a887c8bf13(1049076 | 0, 53 | 0, 1049132 | 0);
   abort();
  }
  global$0 = $6 + 224 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert__h34faf8766169445f($0, $1, $2, $3, $4, $5) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  $5 = $5 | 0;
  var $6 = 0, $7 = 0, $8 = 0;
  $6 = global$0 - 304 | 0;
  global$0 = $6;
  label$1 : {
   label$2 : {
    $7 = HEAP32[$1 >> 2] | 0;
    if (($7 + -1 | 0 | 0) != ($4 | 0)) {
     break label$2
    }
    label$3 : {
     label$4 : {
      label$5 : {
       $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
       if ((HEAPU16[($4 + 1458 | 0) >> 1] | 0) >>> 0 < 11 >>> 0) {
        break label$5
       }
       alloc__collections__btree__node__splitpoint__h8424344594b4deb1($6 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
       $1 = HEAP32[($6 + 8 | 0) >> 2] | 0;
       $8 = HEAP32[($6 + 4 | 0) >> 2] | 0;
       HEAP32[($6 + 216 | 0) >> 2] = HEAP32[$6 >> 2] | 0;
       HEAP32[($6 + 212 | 0) >> 2] = $4;
       HEAP32[($6 + 208 | 0) >> 2] = $7;
       alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__KV___split__h865d4c501f09fe2c($6 | 0, $6 + 208 | 0 | 0);
       if (($8 | 0) == (1 | 0)) {
        break label$4
       }
       HEAP32[($6 + 152 | 0) >> 2] = HEAP32[($6 + 136 | 0) >> 2] | 0;
       $4 = HEAP32[($6 + 140 | 0) >> 2] | 0;
       break label$3;
      }
      memcpy($6 + 208 | 0 | 0, $2 | 0, 36 | 0) | 0;
      $2 = memcpy($6 | 0, $3 | 0, 96 | 0) | 0;
      alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert_fit__hb02d547895893d1c($1 | 0, $2 + 208 | 0 | 0, $2 | 0, $6 | 0, $5 | 0);
      HEAP32[($0 + 8 | 0) >> 2] = $4;
      HEAP32[($0 + 4 | 0) >> 2] = $7;
      HEAP32[$0 >> 2] = 0;
      HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
      break label$1;
     }
     HEAP32[($6 + 152 | 0) >> 2] = HEAP32[($6 + 144 | 0) >> 2] | 0;
     $4 = HEAP32[($6 + 148 | 0) >> 2] | 0;
    }
    HEAP32[($6 + 160 | 0) >> 2] = $1;
    HEAP32[($6 + 156 | 0) >> 2] = $4;
    memcpy($6 + 168 | 0 | 0, $2 | 0, 36 | 0) | 0;
    memcpy($6 + 208 | 0 | 0, $3 | 0, 96 | 0) | 0;
    alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert_fit__hb02d547895893d1c($6 + 152 | 0 | 0, $6 + 168 | 0 | 0, $6 + 208 | 0 | 0, $6 | 0, $5 | 0);
    memcpy($0 + 8 | 0 | 0, $6 | 0, 152 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    break label$1;
   }
   core__panicking__panic__h2fd385a887c8bf13(1049076 | 0, 53 | 0, 1049132 | 0);
   abort();
  }
  global$0 = $6 + 304 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__SerializeEmbeddedGroup_20for_20cardano_serialization_lib__SingleHostAddr___serialize_as_embedded_group__h051b24778a87dc4d($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0;
  $3 = global$0 - 64 | 0;
  global$0 = $3;
  i64toi32_i32$0 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 0 | 0, i64toi32_i32$0 | 0);
  $4 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      if ((HEAPU16[$1 >> 1] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      HEAP8[($3 + 48 | 0) >> 0] = 1;
      cbor_event__se__Serializer_W___write_special__had0377f4ca98c84d($3 | 0, $2 | 0, $3 + 48 | 0 | 0);
      break label$2;
     }
     memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
     break label$1;
    }
    i64toi32_i32$0 = HEAPU16[($1 + 2 | 0) >> 1] | 0;
    i64toi32_i32$1 = 0;
    cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, i64toi32_i32$0 | 0, i64toi32_i32$1 | 0);
   }
   $4 = 1;
   label$5 : {
    label$6 : {
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$6
     }
     label$7 : {
      label$8 : {
       if ((HEAPU8[($1 + 4 | 0) >> 0] | 0 | 0) == (1 | 0)) {
        break label$8
       }
       HEAP8[($3 + 48 | 0) >> 0] = 1;
       cbor_event__se__Serializer_W___write_special__had0377f4ca98c84d($3 | 0, $2 | 0, $3 + 48 | 0 | 0);
       break label$7;
      }
      cbor_event__se__Serializer_W___write_bytes__h54e6fef2108c8b37($3 | 0, $2 | 0, $1 + 5 | 0 | 0);
     }
     $4 = 1;
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$5
     }
     label$9 : {
      label$10 : {
       if ((HEAPU8[($1 + 9 | 0) >> 0] | 0 | 0) == (1 | 0)) {
        break label$10
       }
       HEAP8[($3 + 48 | 0) >> 0] = 1;
       cbor_event__se__Serializer_W___write_special__had0377f4ca98c84d($3 | 0, $2 | 0, $3 + 48 | 0 | 0);
       break label$9;
      }
      cbor_event__se__Serializer_W___write_bytes__hd39fb27319ed5f2d($3 | 0, $2 | 0, $1 + 10 | 0 | 0);
     }
     $4 = 1;
     label$11 : {
      if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
       break label$11
      }
      HEAP32[($0 + 4 | 0) >> 2] = $2;
      $4 = 0;
      break label$1;
     }
     memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
  }
  HEAP32[$0 >> 2] = $4;
  global$0 = $3 + 64 | 0;
 }
 
 function $core__iter__adapters__map__Map_I_2cF__20as_20core__iter__traits__iterator__Iterator___try_fold__h995a63110091bbf7($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $8 = 0, $18 = 0, $25 = 0, $28 = 0, $7 = 0, $46 = 0, $52 = 0, $55 = 0, $73 = 0, $77 = 0, $80 = 0, $92 = 0, $96 = 0, $100 = 0;
  $3 = global$0 - 112 | 0;
  global$0 = $3;
  $4 = ($3 + 24 | 0) + 16 | 0;
  i64toi32_i32$2 = $2 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $5 = ($3 + 24 | 0) + 8 | 0;
  i64toi32_i32$2 = $2 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $25 = i64toi32_i32$1;
  i64toi32_i32$1 = $5;
  HEAP32[i64toi32_i32$1 >> 2] = $25;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $28 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = $28;
  HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = i64toi32_i32$1;
  $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h7135048eb51d6b68(i64toi32_i32$0 + 16 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     if (!(HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] | 0)) {
      break label$3
     }
     $2 = HEAP32[($3 + 20 | 0) >> 2] | 0;
     $6 = ($3 + 48 | 0) + 8 | 0;
     $7 = $3 + 92 | 0;
     label$4 : while (1) {
      i64toi32_i32$2 = $4;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $46 = i64toi32_i32$1;
      i64toi32_i32$1 = ($3 + 80 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $46;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      $8 = ($3 + 80 | 0) + 8 | 0;
      i64toi32_i32$2 = $5;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $52 = i64toi32_i32$0;
      i64toi32_i32$0 = $8;
      HEAP32[i64toi32_i32$0 >> 2] = $52;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $3;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
      $55 = i64toi32_i32$1;
      i64toi32_i32$1 = i64toi32_i32$2;
      HEAP32[(i64toi32_i32$1 + 80 | 0) >> 2] = $55;
      HEAP32[(i64toi32_i32$1 + 84 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[(i64toi32_i32$1 + 104 | 0) >> 2] = $2;
      cardano_serialization_lib__utils__Value__checked_add__h5184687782847801(i64toi32_i32$1 + 48 | 0 | 0, i64toi32_i32$1 + 80 | 0 | 0, $2 | 0);
      label$5 : {
       if (!(HEAP32[$8 >> 2] | 0)) {
        break label$5
       }
       $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($7 | 0);
      }
      if ((HEAP32[($3 + 48 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$2
      }
      i64toi32_i32$2 = $6 + 16 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $73 = i64toi32_i32$0;
      i64toi32_i32$0 = $4;
      HEAP32[i64toi32_i32$0 >> 2] = $73;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $6 + 8 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $77 = i64toi32_i32$1;
      i64toi32_i32$1 = $5;
      HEAP32[i64toi32_i32$1 >> 2] = $77;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $6;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $80 = i64toi32_i32$0;
      i64toi32_i32$0 = $3;
      HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = $80;
      HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = i64toi32_i32$1;
      $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h7135048eb51d6b68(i64toi32_i32$0 + 8 | 0 | 0, $1 | 0);
      $2 = HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] | 0;
      if (HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] | 0) {
       continue label$4
      }
      break label$4;
     };
    }
    HEAP32[$0 >> 2] = 0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
    $92 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $92;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $4;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $96 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 24 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $96;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $5;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $100 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 16 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $100;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    break label$1;
   }
   $2 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($3 + 52 | 0) >> 2] | 0 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
   HEAP32[($0 + 4 | 0) >> 2] = $2;
  }
  global$0 = $3 + 112 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__h632fd5c0346b3032($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $7 = 0, $3 = 0, $4 = 0, $6 = 0, $5 = 0, $36 = 0, $46 = 0, $52 = 0, $55 = 0, $87 = 0, $96 = 0, $102 = 0, $107 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = HEAPU16[($4 + 402 | 0) >> 1] | 0;
  $1 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $6 = $5 + ($1 ^ -1 | 0) | 0;
  HEAP16[($2 + 402 | 0) >> 1] = $6;
  $7 = $4 + Math_imul($1, 12) | 0;
  HEAP32[(($3 + 8 | 0) + 8 | 0) >> 2] = HEAP32[($7 + 276 | 0) >> 2] | 0;
  i64toi32_i32$2 = $7 + 268 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $36;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
  $7 = $4 + Math_imul($1, 24) | 0;
  i64toi32_i32$2 = $7 + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = ($3 + 24 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $46;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $7 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $52 = i64toi32_i32$0;
  i64toi32_i32$0 = ($3 + 24 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $52;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $7;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $55 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = $55;
  HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    if ($6 >>> 0 >= 12 >>> 0) {
     break label$2
    }
    $7 = $1 + 1 | 0;
    if (($5 - $7 | 0 | 0) != ($6 | 0)) {
     break label$1
    }
    memcpy($2 + 268 | 0 | 0, ($4 + Math_imul($7, 12) | 0) + 268 | 0 | 0, Math_imul($6, 12) | 0) | 0;
    memcpy($2 | 0, $4 + Math_imul($7, 24) | 0 | 0, Math_imul($6, 24) | 0) | 0;
    HEAP16[($4 + 402 | 0) >> 1] = $1;
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
    $87 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[i64toi32_i32$0 >> 2] = $87;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[((i64toi32_i32$2 + 8 | 0) + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
    $96 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $96;
    HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = (i64toi32_i32$2 + 24 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $102 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 24 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $102;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $3 + 40 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $107 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 32 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $107;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    global$0 = $3 + 48 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($6 | 0, 11 | 0, 1084532 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1084476 | 0, 40 | 0, 1084516 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__h8872afc6f83eb16f($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $7 = 0, $3 = 0, $4 = 0, $6 = 0, $5 = 0, $36 = 0, $46 = 0, $52 = 0, $55 = 0, $87 = 0, $96 = 0, $102 = 0, $107 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = HEAPU16[($4 + 402 | 0) >> 1] | 0;
  $1 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $6 = $5 + ($1 ^ -1 | 0) | 0;
  HEAP16[($2 + 402 | 0) >> 1] = $6;
  $7 = $4 + Math_imul($1, 12) | 0;
  HEAP32[(($3 + 8 | 0) + 8 | 0) >> 2] = HEAP32[($7 + 276 | 0) >> 2] | 0;
  i64toi32_i32$2 = $7 + 268 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $36;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
  $7 = $4 + Math_imul($1, 24) | 0;
  i64toi32_i32$2 = $7 + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = ($3 + 24 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $46;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $7 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $52 = i64toi32_i32$0;
  i64toi32_i32$0 = ($3 + 24 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $52;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $7;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $55 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = $55;
  HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    if ($6 >>> 0 >= 12 >>> 0) {
     break label$2
    }
    $7 = $1 + 1 | 0;
    if (($5 - $7 | 0 | 0) != ($6 | 0)) {
     break label$1
    }
    memcpy($2 + 268 | 0 | 0, ($4 + Math_imul($7, 12) | 0) + 268 | 0 | 0, Math_imul($6, 12) | 0) | 0;
    memcpy($2 | 0, $4 + Math_imul($7, 24) | 0 | 0, Math_imul($6, 24) | 0) | 0;
    HEAP16[($4 + 402 | 0) >> 1] = $1;
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
    $87 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[i64toi32_i32$0 >> 2] = $87;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[((i64toi32_i32$2 + 8 | 0) + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
    $96 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $96;
    HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = (i64toi32_i32$2 + 24 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $102 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 24 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $102;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $3 + 40 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $107 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 32 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $107;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    global$0 = $3 + 48 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($6 | 0, 11 | 0, 1084532 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1084476 | 0, 40 | 0, 1084516 | 0);
  abort();
 }
 
 function core__slice__memchr__memchr_general_case__hc8de6bab13ee8435($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $5 = 0, $6 = 0, $7 = 0, $8 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       $4 = (($2 + 3 | 0) & -4 | 0) - $2 | 0;
       if (!$4) {
        break label$5
       }
       $4 = $4 >>> 0 > $3 >>> 0 ? $3 : $4;
       if (!$4) {
        break label$5
       }
       $5 = 0;
       $6 = $1 & 255 | 0;
       label$6 : while (1) {
        if ((HEAPU8[($2 + $5 | 0) >> 0] | 0 | 0) == ($6 | 0)) {
         break label$2
        }
        $5 = $5 + 1 | 0;
        if (($4 | 0) != ($5 | 0)) {
         continue label$6
        }
        break label$6;
       };
       $7 = $3 + -8 | 0;
       if ($4 >>> 0 > $7 >>> 0) {
        break label$3
       }
       break label$4;
      }
      $7 = $3 + -8 | 0;
      $4 = 0;
     }
     $5 = Math_imul($1 & 255 | 0, 16843009);
     label$7 : {
      label$8 : while (1) {
       $6 = $2 + $4 | 0;
       $8 = (HEAP32[($6 + 4 | 0) >> 2] | 0) ^ $5 | 0;
       $6 = (HEAP32[$6 >> 2] | 0) ^ $5 | 0;
       if ((($8 ^ -1 | 0) & ($8 + -16843009 | 0) | 0 | (($6 ^ -1 | 0) & ($6 + -16843009 | 0) | 0) | 0) & -2139062144 | 0) {
        break label$7
       }
       $4 = $4 + 8 | 0;
       if ($4 >>> 0 <= $7 >>> 0) {
        continue label$8
       }
       break label$8;
      };
     }
     if ($4 >>> 0 <= $3 >>> 0) {
      break label$3
     }
     core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($4 | 0, $3 | 0, 1150656 | 0);
     abort();
    }
    label$9 : {
     label$10 : {
      if (($4 | 0) == ($3 | 0)) {
       break label$10
      }
      $7 = $3 - $4 | 0;
      $6 = $2 + $4 | 0;
      $5 = 0;
      $8 = $1 & 255 | 0;
      label$11 : while (1) {
       if ((HEAPU8[($6 + $5 | 0) >> 0] | 0 | 0) == ($8 | 0)) {
        break label$9
       }
       $5 = $5 + 1 | 0;
       if (($7 | 0) != ($5 | 0)) {
        continue label$11
       }
       break label$11;
      };
     }
     $4 = 0;
     break label$1;
    }
    $5 = $4 + $5 | 0;
   }
   $4 = 1;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $5;
  HEAP32[$0 >> 2] = $4;
 }
 
 function core__fmt__num__imp__fmt_u64__hf0469431dace4046($0, $0$hi, $1, $2) {
  $0 = $0 | 0;
  $0$hi = $0$hi | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, $4 = 0, $5 = 0, i64toi32_i32$0 = 0, $3 = 0, i64toi32_i32$1 = 0, $8 = 0, i64toi32_i32$3 = 0, $8$hi = 0, i64toi32_i32$5 = 0, $6 = 0, $7 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $26 = 0, $27 = 0, $28 = 0, $29 = 0, $30 = 0, $25 = 0, $25$hi = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  $4 = 39;
  label$1 : {
   label$2 : {
    i64toi32_i32$0 = $0$hi;
    i64toi32_i32$2 = $0;
    i64toi32_i32$1 = 0;
    i64toi32_i32$3 = 1e4;
    if (i64toi32_i32$0 >>> 0 > i64toi32_i32$1 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$2 >>> 0 >= i64toi32_i32$3 >>> 0 | 0) | 0) {
     break label$2
    }
    i64toi32_i32$2 = $0$hi;
    $8 = $0;
    $8$hi = i64toi32_i32$2;
    break label$1;
   }
   $4 = 39;
   label$3 : while (1) {
    $5 = ($3 + 9 | 0) + $4 | 0;
    i64toi32_i32$2 = $0$hi;
    i64toi32_i32$0 = 0;
    i64toi32_i32$0 = __wasm_i64_udiv($0 | 0, i64toi32_i32$2 | 0, 1e4 | 0, i64toi32_i32$0 | 0) | 0;
    i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
    $8 = i64toi32_i32$0;
    $8$hi = i64toi32_i32$2;
    i64toi32_i32$0 = 0;
    i64toi32_i32$0 = __wasm_i64_mul($8 | 0, i64toi32_i32$2 | 0, 1e4 | 0, i64toi32_i32$0 | 0) | 0;
    i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
    $25 = i64toi32_i32$0;
    $25$hi = i64toi32_i32$2;
    i64toi32_i32$2 = $0$hi;
    i64toi32_i32$3 = $0;
    i64toi32_i32$0 = $25$hi;
    i64toi32_i32$1 = $25;
    i64toi32_i32$5 = ($0 >>> 0 < i64toi32_i32$1 >>> 0) + i64toi32_i32$0 | 0;
    i64toi32_i32$5 = i64toi32_i32$2 - i64toi32_i32$5 | 0;
    $6 = $0 - i64toi32_i32$1 | 0;
    $7 = (($6 & 65535 | 0) >>> 0) / (100 >>> 0) | 0;
    $18 = ($7 << 1 | 0) + 1150184 | 0;
    $19 = $5 + -4 | 0;
    $20 = HEAPU8[$18 >> 0] | 0 | ((HEAPU8[($18 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
    HEAP8[$19 >> 0] = $20;
    HEAP8[($19 + 1 | 0) >> 0] = $20 >>> 8 | 0;
    $21 = ((($6 - Math_imul($7, 100) | 0) & 65535 | 0) << 1 | 0) + 1150184 | 0;
    $22 = $5 + -2 | 0;
    $23 = HEAPU8[$21 >> 0] | 0 | ((HEAPU8[($21 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
    HEAP8[$22 >> 0] = $23;
    HEAP8[($22 + 1 | 0) >> 0] = $23 >>> 8 | 0;
    $4 = $4 + -4 | 0;
    i64toi32_i32$5 = i64toi32_i32$2;
    i64toi32_i32$5 = i64toi32_i32$2;
    i64toi32_i32$2 = $0;
    i64toi32_i32$3 = 0;
    i64toi32_i32$1 = 99999999;
    $5 = $0$hi >>> 0 > i64toi32_i32$3 >>> 0 | (($0$hi | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$2 >>> 0 > i64toi32_i32$1 >>> 0 | 0) | 0;
    i64toi32_i32$2 = $8$hi;
    $0 = $8;
    $0$hi = i64toi32_i32$2;
    if ($5) {
     continue label$3
    }
    break label$3;
   };
  }
  label$4 : {
   i64toi32_i32$2 = $8$hi;
   $5 = $8;
   if (($5 | 0) <= (99 | 0)) {
    break label$4
   }
   $4 = $4 + -2 | 0;
   i64toi32_i32$2 = $8$hi;
   $5 = $8;
   $5 = (($5 & 65535 | 0) >>> 0) / (100 >>> 0) | 0;
   $24 = ((($8 - Math_imul($5, 100) | 0) & 65535 | 0) << 1 | 0) + 1150184 | 0;
   $26 = ($3 + 9 | 0) + $4 | 0;
   $27 = HEAPU8[$24 >> 0] | 0 | ((HEAPU8[($24 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
   HEAP8[$26 >> 0] = $27;
   HEAP8[($26 + 1 | 0) >> 0] = $27 >>> 8 | 0;
  }
  label$5 : {
   label$6 : {
    if (($5 | 0) < (10 | 0)) {
     break label$6
    }
    $4 = $4 + -2 | 0;
    $28 = ($5 << 1 | 0) + 1150184 | 0;
    $29 = ($3 + 9 | 0) + $4 | 0;
    $30 = HEAPU8[$28 >> 0] | 0 | ((HEAPU8[($28 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
    HEAP8[$29 >> 0] = $30;
    HEAP8[($29 + 1 | 0) >> 0] = $30 >>> 8 | 0;
    break label$5;
   }
   $4 = $4 + -1 | 0;
   HEAP8[(($3 + 9 | 0) + $4 | 0) >> 0] = $5 + 48 | 0;
  }
  $4 = core__fmt__Formatter__pad_integral__h08e3e53a0de517a1($2 | 0, $1 | 0, 1149204 | 0, 0 | 0, ($3 + 9 | 0) + $4 | 0 | 0, 39 - $4 | 0 | 0) | 0;
  global$0 = $3 + 48 | 0;
  return $4 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert__hea09a6888ea80fc7($0, $1, $2, $3, $3$hi, $4, $4$hi, $5, $6) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  $4 = $4 | 0;
  $4$hi = $4$hi | 0;
  $5 = $5 | 0;
  $6 = $6 | 0;
  var $7 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $8 = 0, $9 = 0, $57 = 0, $92 = 0;
  $7 = global$0 - 80 | 0;
  global$0 = $7;
  label$1 : {
   label$2 : {
    $8 = HEAP32[$1 >> 2] | 0;
    if (($8 + -1 | 0 | 0) != ($5 | 0)) {
     break label$2
    }
    label$3 : {
     label$4 : {
      label$5 : {
       $5 = HEAP32[($1 + 4 | 0) >> 2] | 0;
       if ((HEAPU16[($5 + 314 | 0) >> 1] | 0) >>> 0 < 11 >>> 0) {
        break label$5
       }
       alloc__collections__btree__node__splitpoint__h8424344594b4deb1($7 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
       $1 = HEAP32[($7 + 8 | 0) >> 2] | 0;
       $9 = HEAP32[($7 + 4 | 0) >> 2] | 0;
       HEAP32[($7 + 72 | 0) >> 2] = HEAP32[$7 >> 2] | 0;
       HEAP32[($7 + 68 | 0) >> 2] = $5;
       HEAP32[($7 + 64 | 0) >> 2] = $8;
       alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__KV___split__h84cc36f25422cc7b($7 | 0, $7 + 64 | 0 | 0);
       if (($9 | 0) == (1 | 0)) {
        break label$4
       }
       HEAP32[($7 + 48 | 0) >> 2] = HEAP32[($7 + 32 | 0) >> 2] | 0;
       $5 = HEAP32[($7 + 36 | 0) >> 2] | 0;
       break label$3;
      }
      HEAP32[($7 + 8 | 0) >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
      $57 = i64toi32_i32$0;
      i64toi32_i32$0 = $7;
      HEAP32[$7 >> 2] = $57;
      HEAP32[($7 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$1 = $3$hi;
      i64toi32_i32$1 = $4$hi;
      i64toi32_i32$1 = $3$hi;
      i64toi32_i32$0 = $4$hi;
      alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert_fit__h83b48ec730131fda($1 | 0, $7 | 0, $3 | 0, i64toi32_i32$1 | 0, $4 | 0, i64toi32_i32$0 | 0, $7 | 0, $6 | 0);
      HEAP32[($0 + 8 | 0) >> 2] = $5;
      HEAP32[($0 + 4 | 0) >> 2] = $8;
      HEAP32[$0 >> 2] = 0;
      HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
      break label$1;
     }
     HEAP32[($7 + 48 | 0) >> 2] = HEAP32[($7 + 40 | 0) >> 2] | 0;
     $5 = HEAP32[($7 + 44 | 0) >> 2] | 0;
    }
    HEAP32[($7 + 56 | 0) >> 2] = $1;
    HEAP32[($7 + 52 | 0) >> 2] = $5;
    HEAP32[(($7 + 64 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
    $92 = i64toi32_i32$0;
    i64toi32_i32$0 = $7;
    HEAP32[($7 + 64 | 0) >> 2] = $92;
    HEAP32[($7 + 68 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $3$hi;
    i64toi32_i32$1 = $4$hi;
    i64toi32_i32$1 = $3$hi;
    i64toi32_i32$0 = $4$hi;
    alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert_fit__h83b48ec730131fda($7 + 48 | 0 | 0, $7 + 64 | 0 | 0, $3 | 0, i64toi32_i32$1 | 0, $4 | 0, $4$hi | 0, $7 | 0, $6 | 0);
    memcpy($0 + 8 | 0 | 0, $7 | 0, 48 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    break label$1;
   }
   core__panicking__panic__h2fd385a887c8bf13(1049076 | 0, 53 | 0, 1049132 | 0);
   abort();
  }
  global$0 = $7 + 80 | 0;
 }
 
 function protocolparamupdate_extra_entropy($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $2 = 0, $3 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $4 = 0, $26 = 0, $31 = 0, $36 = 0, $40 = 0, $47 = 0, $54 = 0, $61 = 0, $64 = 0, $76 = 0, $81 = 0, $86 = 0, $91 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hd84cc8f720a3dada($1 | 0, $0 | 0);
   $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   $0 = 2;
   label$2 : {
    $3 = HEAP32[$1 >> 2] | 0;
    $4 = HEAPU8[($3 + 372 | 0) >> 0] | 0;
    if (($4 | 0) == (2 | 0)) {
     break label$2
    }
    $0 = 0;
    label$3 : {
     if (($4 | 0) != (1 | 0)) {
      break label$3
     }
     i64toi32_i32$2 = $3 + 397 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $26 = i64toi32_i32$0;
     i64toi32_i32$0 = $1 + 64 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $26;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $3 + 389 | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $31 = i64toi32_i32$1;
     i64toi32_i32$1 = $1 + 56 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $31;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $3 + 381 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $36 = i64toi32_i32$0;
     i64toi32_i32$0 = $1 + 48 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $36;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $3 + 373 | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $40 = i64toi32_i32$1;
     i64toi32_i32$1 = $1;
     HEAP32[(i64toi32_i32$1 + 40 | 0) >> 2] = $40;
     HEAP32[(i64toi32_i32$1 + 44 | 0) >> 2] = i64toi32_i32$0;
     $0 = 1;
    }
    i64toi32_i32$2 = ($1 + 40 | 0) + 24 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $47 = i64toi32_i32$0;
    i64toi32_i32$0 = ($1 + 8 | 0) + 24 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $47;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = ($1 + 40 | 0) + 16 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $54 = i64toi32_i32$1;
    i64toi32_i32$1 = ($1 + 8 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $54;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = ($1 + 40 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $61 = i64toi32_i32$0;
    i64toi32_i32$0 = ($1 + 8 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $61;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] | 0;
    $64 = i64toi32_i32$1;
    i64toi32_i32$1 = i64toi32_i32$2;
    HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $64;
    HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$0;
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
   $2 = 0;
   label$4 : {
    if (($0 | 0) == (2 | 0)) {
     break label$4
    }
    i64toi32_i32$2 = $1 + 16 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $76 = i64toi32_i32$0;
    i64toi32_i32$0 = $1 + 49 | 0;
    $20 = $76;
    HEAP8[i64toi32_i32$0 >> 0] = $20;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $20 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $20 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $20 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$2 = $1 + 24 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $81 = i64toi32_i32$1;
    i64toi32_i32$1 = $1 + 57 | 0;
    $21 = $81;
    HEAP8[i64toi32_i32$1 >> 0] = $21;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $21 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $21 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $21 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$2 = $1 + 32 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $86 = i64toi32_i32$0;
    i64toi32_i32$0 = $1 + 65 | 0;
    $22 = $86;
    HEAP8[i64toi32_i32$0 >> 0] = $22;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $22 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $22 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $22 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    HEAP8[($1 + 40 | 0) >> 0] = $0;
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
    $91 = i64toi32_i32$1;
    i64toi32_i32$1 = i64toi32_i32$2;
    $23 = $91;
    HEAP8[(i64toi32_i32$2 + 41 | 0) >> 0] = $23;
    HEAP8[(i64toi32_i32$2 + 42 | 0) >> 0] = $23 >>> 8 | 0;
    HEAP8[(i64toi32_i32$2 + 43 | 0) >> 0] = $23 >>> 16 | 0;
    HEAP8[(i64toi32_i32$2 + 44 | 0) >> 0] = $23 >>> 24 | 0;
    HEAP8[(i64toi32_i32$2 + 45 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$2 + 46 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$2 + 47 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$2 + 48 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    $2 = $cardano_serialization_lib__crypto__Nonce_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h3e2dae3d5c688227(i64toi32_i32$2 + 40 | 0 | 0) | 0;
   }
   global$0 = $1 + 80 | 0;
   return $2 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function alloc__collections__btree__map__entry__VacantEntry_K_2cV___insert__h81bd2d8e70cdae36($0, $1, $1$hi, $2, $2$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $1$hi = $1$hi | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $9 = 0, $5 = 0, $8 = 0, $21 = 0, $30 = 0, $4 = 0, $6 = 0, $7 = 0, $92 = 0;
  $3 = global$0 - 96 | 0;
  global$0 = $3;
  HEAP32[(($3 + 64 | 0) + 8 | 0) >> 2] = HEAP32[($0 + 20 | 0) >> 2] | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[($0 + 12 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($0 + 16 | 0) >> 2] | 0;
  $21 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[($3 + 64 | 0) >> 2] = $21;
  HEAP32[($3 + 68 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(($3 + 80 | 0) + 8 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$1 = HEAP32[$0 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[($3 + 80 | 0) >> 2] = $30;
  HEAP32[($3 + 84 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $1$hi;
  i64toi32_i32$0 = $2$hi;
  i64toi32_i32$0 = $1$hi;
  i64toi32_i32$1 = $2$hi;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_recursing__hd04c34fee68d848e($3 | 0, $3 + 64 | 0 | 0, $3 + 80 | 0 | 0, $1 | 0, i64toi32_i32$0 | 0, $2 | 0, i64toi32_i32$1 | 0);
  $4 = HEAP32[($3 + 56 | 0) >> 2] | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     $0 = HEAP32[($0 + 24 | 0) >> 2] | 0;
     break label$2;
    }
    $0 = HEAP32[($0 + 24 | 0) >> 2] | 0;
    $5 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    if (!$5) {
     break label$1
    }
    i64toi32_i32$2 = $3 + 32 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $1 = i64toi32_i32$1;
    $1$hi = i64toi32_i32$0;
    i64toi32_i32$2 = $3 + 24 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $2 = i64toi32_i32$0;
    $2$hi = i64toi32_i32$1;
    $6 = HEAP32[($3 + 52 | 0) >> 2] | 0;
    $7 = HEAP32[($3 + 48 | 0) >> 2] | 0;
    $8 = HEAP32[$0 >> 2] | 0;
    $9 = alloc__boxed__Box_T_2cA___new_uninit_in__h0285c5e433c8dfa2() | 0;
    HEAP32[($9 + 320 | 0) >> 2] = $5;
    HEAP16[($9 + 314 | 0) >> 1] = 0;
    HEAP32[($9 + 176 | 0) >> 2] = 0;
    HEAP32[($0 + 4 | 0) >> 2] = $9;
    $8 = $8 + 1 | 0;
    HEAP32[$0 >> 2] = $8;
    HEAP16[($5 + 312 | 0) >> 1] = 0;
    HEAP32[($5 + 176 | 0) >> 2] = $9;
    HEAP32[($3 + 68 | 0) >> 2] = $9;
    HEAP32[($3 + 64 | 0) >> 2] = $8;
    HEAP32[(($3 + 80 | 0) + 8 | 0) >> 2] = HEAP32[($3 + 16 | 0) >> 2] | 0;
    i64toi32_i32$2 = $3 + 8 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $92 = i64toi32_i32$1;
    i64toi32_i32$1 = $3;
    HEAP32[($3 + 80 | 0) >> 2] = $92;
    HEAP32[($3 + 84 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = $2$hi;
    i64toi32_i32$0 = $1$hi;
    i64toi32_i32$0 = $2$hi;
    i64toi32_i32$1 = $1$hi;
    alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal___push__h5a800884cf869f03($3 + 64 | 0 | 0, $3 + 80 | 0 | 0, $2 | 0, i64toi32_i32$0 | 0, $1 | 0, i64toi32_i32$1 | 0, $7 | 0, $6 | 0);
   }
   HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
   global$0 = $3 + 96 | 0;
   return $4 | 0;
  }
  core__panicking__panic__h2fd385a887c8bf13(1072048 | 0, 43 | 0, 1072248 | 0);
  abort();
 }
 
 function itoa__Buffer__format__hed7b710a49053b67($0, $1, $2, $2$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  var i64toi32_i32$5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, $3 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, $4 = 0, $7$hi = 0, $7 = 0, $8 = 0, i64toi32_i32$2 = 0, $8$hi = 0, $22 = 0, $6 = 0, $23 = 0, $24 = 0, $25 = 0, $26 = 0, $27 = 0, $29 = 0, $30 = 0, $31 = 0, $32 = 0, $33 = 0, $34 = 0, $35 = 0, $36 = 0, $37 = 0, $38 = 0, $9 = 0, $9$hi = 0, $13$hi = 0, $28 = 0, $28$hi = 0;
  $3 = 20;
  label$1 : {
   label$2 : {
    i64toi32_i32$0 = $2$hi;
    $9 = $2;
    $9$hi = i64toi32_i32$0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = 0;
    i64toi32_i32$3 = 63;
    i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$1 = i64toi32_i32$0 >> 31 | 0;
     $22 = i64toi32_i32$0 >> i64toi32_i32$4 | 0;
    } else {
     i64toi32_i32$1 = i64toi32_i32$0 >> i64toi32_i32$4 | 0;
     $22 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
    }
    $7 = $22;
    $7$hi = i64toi32_i32$1;
    i64toi32_i32$1 = $9$hi;
    i64toi32_i32$0 = $9;
    i64toi32_i32$2 = $7$hi;
    i64toi32_i32$3 = $7;
    i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
    i64toi32_i32$5 = i64toi32_i32$1 + $7$hi | 0;
    if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
     i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
    }
    $13$hi = i64toi32_i32$5;
    i64toi32_i32$5 = $7$hi;
    i64toi32_i32$5 = $13$hi;
    i64toi32_i32$1 = i64toi32_i32$4;
    i64toi32_i32$0 = $7$hi;
    i64toi32_i32$3 = $7;
    i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
    $7 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
    $7$hi = i64toi32_i32$0;
    i64toi32_i32$5 = $7;
    i64toi32_i32$1 = 0;
    i64toi32_i32$3 = 1e4;
    if (i64toi32_i32$0 >>> 0 > i64toi32_i32$1 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$5 >>> 0 >= i64toi32_i32$3 >>> 0 | 0) | 0) {
     break label$2
    }
    i64toi32_i32$5 = $7$hi;
    $8 = $7;
    $8$hi = i64toi32_i32$5;
    break label$1;
   }
   $3 = 20;
   label$3 : while (1) {
    $4 = $1 + $3 | 0;
    i64toi32_i32$5 = $7$hi;
    i64toi32_i32$0 = 0;
    i64toi32_i32$0 = __wasm_i64_udiv($7 | 0, i64toi32_i32$5 | 0, 1e4 | 0, i64toi32_i32$0 | 0) | 0;
    i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
    $8 = i64toi32_i32$0;
    $8$hi = i64toi32_i32$5;
    i64toi32_i32$0 = 0;
    i64toi32_i32$0 = __wasm_i64_mul($8 | 0, i64toi32_i32$5 | 0, 1e4 | 0, i64toi32_i32$0 | 0) | 0;
    i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
    $28 = i64toi32_i32$0;
    $28$hi = i64toi32_i32$5;
    i64toi32_i32$5 = $7$hi;
    i64toi32_i32$3 = $7;
    i64toi32_i32$0 = $28$hi;
    i64toi32_i32$1 = $28;
    i64toi32_i32$2 = i64toi32_i32$3 - i64toi32_i32$1 | 0;
    i64toi32_i32$4 = (i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0) + i64toi32_i32$0 | 0;
    i64toi32_i32$4 = i64toi32_i32$5 - i64toi32_i32$4 | 0;
    $6 = ((i64toi32_i32$2 & 65535 | 0) >>> 0) / (100 >>> 0) | 0;
    $23 = ($6 << 1 | 0) + 1087292 | 0;
    $24 = $4 + -4 | 0;
    $25 = HEAPU8[$23 >> 0] | 0 | ((HEAPU8[($23 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
    HEAP8[$24 >> 0] = $25;
    HEAP8[($24 + 1 | 0) >> 0] = $25 >>> 8 | 0;
    $26 = (((i64toi32_i32$2 - Math_imul($6, 100) | 0) & 65535 | 0) << 1 | 0) + 1087292 | 0;
    $27 = $4 + -2 | 0;
    $29 = HEAPU8[$26 >> 0] | 0 | ((HEAPU8[($26 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
    HEAP8[$27 >> 0] = $29;
    HEAP8[($27 + 1 | 0) >> 0] = $29 >>> 8 | 0;
    $3 = $3 + -4 | 0;
    i64toi32_i32$4 = i64toi32_i32$5;
    i64toi32_i32$4 = i64toi32_i32$5;
    i64toi32_i32$5 = i64toi32_i32$3;
    i64toi32_i32$3 = 0;
    i64toi32_i32$1 = 99999999;
    $4 = i64toi32_i32$4 >>> 0 > i64toi32_i32$3 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$5 >>> 0 > i64toi32_i32$1 >>> 0 | 0) | 0;
    i64toi32_i32$5 = $8$hi;
    $7 = $8;
    $7$hi = i64toi32_i32$5;
    if ($4) {
     continue label$3
    }
    break label$3;
   };
  }
  label$4 : {
   i64toi32_i32$5 = $8$hi;
   $4 = $8;
   if (($4 | 0) < (100 | 0)) {
    break label$4
   }
   $3 = $3 + -2 | 0;
   i64toi32_i32$5 = $8$hi;
   $4 = $8;
   $4 = (($4 & 65535 | 0) >>> 0) / (100 >>> 0) | 0;
   $30 = ((($8 - Math_imul($4, 100) | 0) & 65535 | 0) << 1 | 0) + 1087292 | 0;
   $31 = $1 + $3 | 0;
   $32 = HEAPU8[$30 >> 0] | 0 | ((HEAPU8[($30 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
   HEAP8[$31 >> 0] = $32;
   HEAP8[($31 + 1 | 0) >> 0] = $32 >>> 8 | 0;
  }
  label$5 : {
   label$6 : {
    if (($4 | 0) < (10 | 0)) {
     break label$6
    }
    $3 = $3 + -2 | 0;
    $33 = ($4 << 1 | 0) + 1087292 | 0;
    $34 = $1 + $3 | 0;
    $35 = HEAPU8[$33 >> 0] | 0 | ((HEAPU8[($33 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
    HEAP8[$34 >> 0] = $35;
    HEAP8[($34 + 1 | 0) >> 0] = $35 >>> 8 | 0;
    break label$5;
   }
   $3 = $3 + -1 | 0;
   HEAP8[($1 + $3 | 0) >> 0] = $4 + 48 | 0;
  }
  label$7 : {
   i64toi32_i32$5 = $2$hi;
   i64toi32_i32$1 = $2;
   i64toi32_i32$4 = -1;
   i64toi32_i32$3 = -1;
   if ((i64toi32_i32$5 | 0) > (i64toi32_i32$4 | 0)) {
    $36 = 1
   } else {
    if ((i64toi32_i32$5 | 0) >= (i64toi32_i32$4 | 0)) {
     if (i64toi32_i32$1 >>> 0 <= i64toi32_i32$3 >>> 0) {
      $37 = 0
     } else {
      $37 = 1
     }
     $38 = $37;
    } else {
     $38 = 0
    }
    $36 = $38;
   }
   if ($36) {
    break label$7
   }
   $3 = $3 + -1 | 0;
   HEAP8[($1 + $3 | 0) >> 0] = 45;
  }
  HEAP32[($0 + 4 | 0) >> 2] = 20 - $3 | 0;
  HEAP32[$0 >> 2] = $1 + $3 | 0;
 }
 
 function cryptoxide__cryptoutil__FixedBuffer_____input__h45eb77880e071f02($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $5 = 0, $6 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           label$10 : {
            $4 = HEAP32[$0 >> 2] | 0;
            if ($4) {
             break label$10
            }
            $5 = 0;
            break label$9;
           }
           label$11 : {
            $5 = 128 - $4 | 0;
            if ($5 >>> 0 <= $2 >>> 0) {
             break label$11
            }
            $5 = $4 + $2 | 0;
            if ($5 >>> 0 < $4 >>> 0) {
             break label$8
            }
            if ($5 >>> 0 > 128 >>> 0) {
             break label$7
            }
            memcpy(($0 + $4 | 0) + 4 | 0 | 0, $1 | 0, $2 | 0) | 0;
            break label$1;
           }
           if ($4 >>> 0 >= 129 >>> 0) {
            break label$6
           }
           $6 = $0 + 4 | 0;
           memcpy($6 + $4 | 0 | 0, $1 | 0, $5 | 0) | 0;
           HEAP32[$0 >> 2] = 0;
           cryptoxide__hashing__sha2__impl512__reference__digest_block__h5deb88f07cb6a5e7(HEAP32[$3 >> 2] | 0 | 0, $6 | 0, 128 | 0);
          }
          label$12 : {
           $4 = $2 - $5 | 0;
           if ($4 >>> 0 <= 127 >>> 0) {
            break label$12
           }
           $4 = $4 & -128 | 0;
           $6 = $4 + $5 | 0;
           if ($6 >>> 0 < $4 >>> 0) {
            break label$5
           }
           if ($6 >>> 0 > $2 >>> 0) {
            break label$4
           }
           cryptoxide__hashing__sha2__eng512__Engine__blocks__h91a1f80841db786c(HEAP32[$3 >> 2] | 0 | 0, $1 + $5 | 0 | 0, $4 | 0);
           $4 = $2 - $6 | 0;
           if ($4 >>> 0 >= 129 >>> 0) {
            break label$3
           }
           $5 = $6;
          }
          if ($5 >>> 0 > $2 >>> 0) {
           break label$2
          }
          memcpy($0 + 4 | 0 | 0, $1 + $5 | 0 | 0, $4 | 0) | 0;
          $2 = $4;
          break label$1;
         }
         core__slice__index__slice_index_order_fail__h71e247dec3f266ff($4 | 0, $5 | 0, 1102672 | 0);
         abort();
        }
        core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($5 | 0, 128 | 0, 1102672 | 0);
        abort();
       }
       core__slice__index__slice_index_order_fail__h71e247dec3f266ff($4 | 0, 128 | 0, 1102656 | 0);
       abort();
      }
      core__slice__index__slice_index_order_fail__h71e247dec3f266ff($5 | 0, $6 | 0, 1102688 | 0);
      abort();
     }
     core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($6 | 0, $2 | 0, 1102688 | 0);
     abort();
    }
    core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($4 | 0, 128 | 0, 1102704 | 0);
    abort();
   }
   core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($5 | 0, $2 | 0, 1102720 | 0);
   abort();
  }
  HEAP32[$0 >> 2] = (HEAP32[$0 >> 2] | 0) + $2 | 0;
 }
 
 function cbor_event__de__Deserializer_R___tag__ha0ca0c99f1ceb558($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$3 = 0, i64toi32_i32$5 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $3 = 0, $7 = 0, $7$hi = 0, $4 = 0, $5 = 0, $6 = 0, $8 = 0, $8$hi = 0, $9 = 0, $9$hi = 0, i64toi32_i32$4 = 0, $50 = 0, $52$hi = 0, $55$hi = 0, $62 = 0, $68 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 8 | 0 | 0, $1 | 0);
  $3 = 8;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $4 = HEAP32[($2 + 12 | 0) >> 2] | 0;
      if ($4) {
       break label$4
      }
      break label$3;
     }
     $5 = HEAP32[($2 + 8 | 0) >> 2] | 0;
     if (!$5) {
      break label$3
     }
     $3 = 9;
     $6 = ($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[$5 >> 0] | 0 | 0) | 0) & 255 | 0;
     if (($6 | 0) != (6 | 0)) {
      break label$3
     }
     cbor_event__de__Deserializer_R___cbor_len__h852681e444aca076_1($2 + 16 | 0 | 0, $1 | 0);
     i64toi32_i32$0 = 0;
     $7 = 1;
     $7$hi = i64toi32_i32$0;
     $3 = HEAP32[(($2 + 16 | 0) + 24 | 0) >> 2] | 0;
     i64toi32_i32$2 = ($2 + 16 | 0) + 16 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $8 = i64toi32_i32$0;
     $8$hi = i64toi32_i32$1;
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 28 | 0) >> 2] | 0;
     $9 = i64toi32_i32$1;
     $9$hi = i64toi32_i32$0;
     label$5 : {
      i64toi32_i32$2 = $2;
      i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
      i64toi32_i32$2 = i64toi32_i32$0;
      i64toi32_i32$0 = 0;
      i64toi32_i32$3 = 1;
      if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
       break label$5
      }
      label$6 : {
       i64toi32_i32$2 = $9$hi;
       if ($9) {
        break label$6
       }
       HEAP16[($0 + 8 | 0) >> 1] = 1548;
       break label$2;
      }
      i64toi32_i32$2 = $8$hi;
      i64toi32_i32$1 = $0;
      HEAP32[($0 + 8 | 0) >> 2] = $8;
      HEAP32[($0 + 12 | 0) >> 2] = i64toi32_i32$2;
      $50 = $1;
      i64toi32_i32$3 = $1;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $52$hi = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      $55$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $52$hi;
      i64toi32_i32$3 = i64toi32_i32$2;
      i64toi32_i32$2 = $55$hi;
      i64toi32_i32$0 = $3 + 1 | 0;
      i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
      i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
      if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
       i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
      }
      i64toi32_i32$3 = $50;
      HEAP32[i64toi32_i32$3 >> 2] = i64toi32_i32$4;
      HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
      i64toi32_i32$5 = 0;
      $7 = 0;
      $7$hi = i64toi32_i32$5;
      break label$1;
     }
     i64toi32_i32$1 = ($2 + 16 | 0) + 32 | 0;
     i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $62 = i64toi32_i32$5;
     i64toi32_i32$5 = $0 + 32 | 0;
     HEAP32[i64toi32_i32$5 >> 2] = $62;
     HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$1 = ($2 + 16 | 0) + 40 | 0;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $68 = i64toi32_i32$3;
     i64toi32_i32$3 = $0 + 40 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $68;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
     HEAP32[($0 + 28 | 0) >> 2] = HEAP32[($2 + 44 | 0) >> 2] | 0;
     HEAP32[($0 + 24 | 0) >> 2] = $3;
     i64toi32_i32$5 = $8$hi;
     i64toi32_i32$3 = $0 + 16 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $8;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
     i64toi32_i32$5 = $9$hi;
     i64toi32_i32$3 = $0;
     HEAP32[(i64toi32_i32$3 + 8 | 0) >> 2] = $9;
     HEAP32[(i64toi32_i32$3 + 12 | 0) >> 2] = i64toi32_i32$5;
     break label$1;
    }
    HEAP8[($0 + 8 | 0) >> 0] = $3;
    HEAP32[($0 + 16 | 0) >> 2] = 0;
    HEAP32[($0 + 12 | 0) >> 2] = $4;
    HEAP8[($0 + 10 | 0) >> 0] = $6;
    HEAP8[($0 + 9 | 0) >> 0] = 6;
   }
   i64toi32_i32$5 = 0;
   $7 = 1;
   $7$hi = i64toi32_i32$5;
  }
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$3 = $0;
  HEAP32[i64toi32_i32$3 >> 2] = $7;
  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
  global$0 = $2 + 64 | 0;
 }
 
 function cbor_event__de__Deserializer_R___tag__hae6ff5633a28f977($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$3 = 0, i64toi32_i32$5 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $3 = 0, $7 = 0, $7$hi = 0, $4 = 0, $5 = 0, $6 = 0, $8 = 0, $8$hi = 0, $9 = 0, $9$hi = 0, i64toi32_i32$4 = 0, $50 = 0, $52$hi = 0, $55$hi = 0, $62 = 0, $68 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  std__io__cursor__Cursor_T___remaining_slice__h5de2a0dd397eef35($2 + 8 | 0 | 0, $1 | 0);
  $3 = 8;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $4 = HEAP32[($2 + 12 | 0) >> 2] | 0;
      if ($4) {
       break label$4
      }
      break label$3;
     }
     $5 = HEAP32[($2 + 8 | 0) >> 2] | 0;
     if (!$5) {
      break label$3
     }
     $3 = 9;
     $6 = ($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[$5 >> 0] | 0 | 0) | 0) & 255 | 0;
     if (($6 | 0) != (6 | 0)) {
      break label$3
     }
     cbor_event__de__Deserializer_R___cbor_len__hc68764db78e73af0($2 + 16 | 0 | 0, $1 | 0);
     i64toi32_i32$0 = 0;
     $7 = 1;
     $7$hi = i64toi32_i32$0;
     $3 = HEAP32[(($2 + 16 | 0) + 24 | 0) >> 2] | 0;
     i64toi32_i32$2 = ($2 + 16 | 0) + 16 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $8 = i64toi32_i32$0;
     $8$hi = i64toi32_i32$1;
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 28 | 0) >> 2] | 0;
     $9 = i64toi32_i32$1;
     $9$hi = i64toi32_i32$0;
     label$5 : {
      i64toi32_i32$2 = $2;
      i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
      i64toi32_i32$2 = i64toi32_i32$0;
      i64toi32_i32$0 = 0;
      i64toi32_i32$3 = 1;
      if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
       break label$5
      }
      label$6 : {
       i64toi32_i32$2 = $9$hi;
       if ($9) {
        break label$6
       }
       HEAP16[($0 + 8 | 0) >> 1] = 1548;
       break label$2;
      }
      i64toi32_i32$2 = $8$hi;
      i64toi32_i32$1 = $0;
      HEAP32[($0 + 8 | 0) >> 2] = $8;
      HEAP32[($0 + 12 | 0) >> 2] = i64toi32_i32$2;
      $50 = $1;
      i64toi32_i32$3 = $1;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $52$hi = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      $55$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $52$hi;
      i64toi32_i32$3 = i64toi32_i32$2;
      i64toi32_i32$2 = $55$hi;
      i64toi32_i32$0 = $3 + 1 | 0;
      i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
      i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
      if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
       i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
      }
      i64toi32_i32$3 = $50;
      HEAP32[i64toi32_i32$3 >> 2] = i64toi32_i32$4;
      HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
      i64toi32_i32$5 = 0;
      $7 = 0;
      $7$hi = i64toi32_i32$5;
      break label$1;
     }
     i64toi32_i32$1 = ($2 + 16 | 0) + 32 | 0;
     i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $62 = i64toi32_i32$5;
     i64toi32_i32$5 = $0 + 32 | 0;
     HEAP32[i64toi32_i32$5 >> 2] = $62;
     HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$1 = ($2 + 16 | 0) + 40 | 0;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $68 = i64toi32_i32$3;
     i64toi32_i32$3 = $0 + 40 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $68;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
     HEAP32[($0 + 28 | 0) >> 2] = HEAP32[($2 + 44 | 0) >> 2] | 0;
     HEAP32[($0 + 24 | 0) >> 2] = $3;
     i64toi32_i32$5 = $8$hi;
     i64toi32_i32$3 = $0 + 16 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $8;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
     i64toi32_i32$5 = $9$hi;
     i64toi32_i32$3 = $0;
     HEAP32[(i64toi32_i32$3 + 8 | 0) >> 2] = $9;
     HEAP32[(i64toi32_i32$3 + 12 | 0) >> 2] = i64toi32_i32$5;
     break label$1;
    }
    HEAP8[($0 + 8 | 0) >> 0] = $3;
    HEAP32[($0 + 16 | 0) >> 2] = 0;
    HEAP32[($0 + 12 | 0) >> 2] = $4;
    HEAP8[($0 + 10 | 0) >> 0] = $6;
    HEAP8[($0 + 9 | 0) >> 0] = 6;
   }
   i64toi32_i32$5 = 0;
   $7 = 1;
   $7$hi = i64toi32_i32$5;
  }
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$3 = $0;
  HEAP32[i64toi32_i32$3 >> 2] = $7;
  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
  global$0 = $2 + 64 | 0;
 }
 
 function cardano_serialization_lib__utils__internal_get_implicit_input__h61eaf21c0f86e6a4($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, $8$hi = 0, $6$hi = 0, $5 = 0, $8 = 0, $6 = 0, $7$hi = 0, $7 = 0, $9$hi = 0, $10$hi = 0, $25 = 0, $25$hi = 0, $9 = 0, $10 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  i64toi32_i32$0 = 0;
  $6 = 0;
  $6$hi = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  $7 = 0;
  $7$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if (!(HEAP32[($1 + 20 | 0) >> 2] | 0)) {
       break label$4
      }
      label$5 : {
       label$6 : {
        $5 = HEAP32[($1 + 32 | 0) >> 2] | 0;
        if ($5) {
         break label$6
        }
        $1 = 0;
        break label$5;
       }
       $1 = HEAP32[($5 + 12 | 0) >> 2] | 0;
      }
      i64toi32_i32$0 = 0;
      $7 = 0;
      $7$hi = i64toi32_i32$0;
      if (($1 | 0) == ($5 | 0)) {
       break label$4
      }
      i64toi32_i32$0 = 0;
      $8 = 0;
      $8$hi = i64toi32_i32$0;
      label$7 : while (1) {
       i64toi32_i32$0 = $8$hi;
       i64toi32_i32$2 = $1;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $25 = i64toi32_i32$0;
       $25$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $8$hi;
       i64toi32_i32$2 = $8;
       i64toi32_i32$0 = $25$hi;
       i64toi32_i32$3 = $25;
       i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
       i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
       if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
        i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
       }
       $7 = i64toi32_i32$4;
       $7$hi = i64toi32_i32$5;
       i64toi32_i32$5 = $8$hi;
       i64toi32_i32$5 = $7$hi;
       i64toi32_i32$1 = i64toi32_i32$4;
       i64toi32_i32$2 = $8$hi;
       i64toi32_i32$3 = $8;
       if (i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0) {
        break label$3
       }
       i64toi32_i32$1 = $7$hi;
       $8 = $7;
       $8$hi = i64toi32_i32$1;
       $1 = HEAP32[($1 + 12 | 0) >> 2] | 0;
       if (($1 | 0) != ($5 | 0)) {
        continue label$7
       }
       break label$7;
      };
     }
     label$8 : {
      label$9 : {
       label$10 : {
        $1 = HEAP32[$2 >> 2] | 0;
        if (!$1) {
         break label$10
        }
        $5 = HEAP32[($2 + 8 | 0) >> 2] | 0;
        if (!$5) {
         break label$10
        }
        $5 = Math_imul($5, 200);
        i64toi32_i32$3 = $4;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $9 = i64toi32_i32$1;
        $9$hi = i64toi32_i32$5;
        i64toi32_i32$3 = $3;
        i64toi32_i32$5 = HEAP32[i64toi32_i32$3 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
        $10 = i64toi32_i32$5;
        $10$hi = i64toi32_i32$1;
        i64toi32_i32$1 = 0;
        $6 = 0;
        $6$hi = i64toi32_i32$1;
        label$11 : while (1) {
         label$12 : {
          label$13 : {
           switch ((HEAPU8[$1 >> 0] | 0) + -1 | 0 | 0) {
           case 0:
            i64toi32_i32$1 = $6$hi;
            i64toi32_i32$1 = $9$hi;
            i64toi32_i32$1 = $6$hi;
            i64toi32_i32$3 = $6;
            i64toi32_i32$5 = $9$hi;
            i64toi32_i32$2 = $9;
            i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
            i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
            if (i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0) {
             i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
            }
            $8 = i64toi32_i32$0;
            $8$hi = i64toi32_i32$4;
            i64toi32_i32$4 = $6$hi;
            i64toi32_i32$4 = $8$hi;
            i64toi32_i32$1 = i64toi32_i32$0;
            i64toi32_i32$3 = $6$hi;
            i64toi32_i32$2 = $6;
            if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0) {
             break label$9
            }
            i64toi32_i32$1 = $8$hi;
            $6 = $8;
            $6$hi = i64toi32_i32$1;
            break label$12;
           case 3:
            break label$13;
           default:
            break label$12;
           };
          }
          i64toi32_i32$1 = $6$hi;
          i64toi32_i32$1 = $10$hi;
          i64toi32_i32$1 = $6$hi;
          i64toi32_i32$2 = $6;
          i64toi32_i32$4 = $10$hi;
          i64toi32_i32$3 = $10;
          i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
          i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
          if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
           i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
          }
          $8 = i64toi32_i32$5;
          $8$hi = i64toi32_i32$0;
          i64toi32_i32$0 = $6$hi;
          i64toi32_i32$0 = $8$hi;
          i64toi32_i32$1 = i64toi32_i32$5;
          i64toi32_i32$2 = $6$hi;
          i64toi32_i32$3 = $6;
          if (i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0) {
           break label$9
          }
          i64toi32_i32$1 = $8$hi;
          $6 = $8;
          $6$hi = i64toi32_i32$1;
         }
         $1 = $1 + 200 | 0;
         $5 = $5 + -200 | 0;
         if ($5) {
          continue label$11
         }
         break label$11;
        };
       }
       i64toi32_i32$1 = $7$hi;
       i64toi32_i32$1 = $6$hi;
       i64toi32_i32$1 = $7$hi;
       i64toi32_i32$3 = $7;
       i64toi32_i32$0 = $6$hi;
       i64toi32_i32$2 = $6;
       i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
       i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
       if (i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0) {
        i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
       }
       $8 = i64toi32_i32$4;
       $8$hi = i64toi32_i32$5;
       i64toi32_i32$5 = $7$hi;
       i64toi32_i32$5 = $8$hi;
       i64toi32_i32$1 = i64toi32_i32$4;
       i64toi32_i32$3 = $7$hi;
       i64toi32_i32$2 = $7;
       if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0) {
        break label$8
       }
       $1 = 0;
       HEAP32[($0 + 16 | 0) >> 2] = 0;
       i64toi32_i32$1 = $8$hi;
       i64toi32_i32$5 = $0 + 8 | 0;
       HEAP32[i64toi32_i32$5 >> 2] = $8;
       HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$1;
       break label$1;
      }
      (wasm2js_i32$0 = $0, wasm2js_i32$1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1058732 | 0, 8 | 0) | 0 | 0) | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
      break label$2;
     }
     (wasm2js_i32$0 = $0, wasm2js_i32$1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1058732 | 0, 8 | 0) | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
     break label$2;
    }
    (wasm2js_i32$0 = $0, wasm2js_i32$1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1058732 | 0, 8 | 0) | 0 | 0) | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
   }
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
 }
 
 function alloc__slice__merge__h4a8708c943dcbe36($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, $6 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $7 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $8 = 0, $9 = 0, $48 = 0, $48$hi = 0, $51 = 0, $51$hi = 0, $90 = 0, $90$hi = 0, $92 = 0, $92$hi = 0;
  $5 = $2 << 7 | 0;
  $6 = $0 + $5 | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     $7 = $1 - $2 | 0;
     if ($7 >>> 0 >= $2 >>> 0) {
      break label$3
     }
     $5 = $7 << 7 | 0;
     $8 = memcpy($3 | 0, $6 | 0, $5 | 0) | 0;
     $5 = $8 + $5 | 0;
     if (($2 | 0) < (1 | 0)) {
      break label$2
     }
     if (($7 | 0) < (1 | 0)) {
      break label$2
     }
     $1 = (($1 << 7 | 0) + $0 | 0) + -128 | 0;
     label$4 : while (1) {
      $7 = $6 + -128 | 0;
      $9 = $5 + -128 | 0;
      i64toi32_i32$2 = $5 + -64 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $48 = i64toi32_i32$0;
      $48$hi = i64toi32_i32$1;
      i64toi32_i32$2 = $6 + -64 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $51 = i64toi32_i32$1;
      $51$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $48$hi;
      i64toi32_i32$2 = $48;
      i64toi32_i32$1 = $51$hi;
      i64toi32_i32$3 = $51;
      $2 = i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
      $1 = memcpy($1 | 0, ($2 ? $7 : $9) | 0, 128 | 0) | 0;
      $5 = $2 ? $5 : $9;
      $6 = $2 ? $7 : $6;
      if ($0 >>> 0 >= $6 >>> 0) {
       break label$2
      }
      $1 = $1 + -128 | 0;
      if ($5 >>> 0 <= $8 >>> 0) {
       break label$2
      }
      continue label$4;
     };
    }
    $5 = (memcpy($3 | 0, $0 | 0, $5 | 0) | 0) + $5 | 0;
    if (($1 | 0) <= ($2 | 0)) {
     break label$1
    }
    if (($2 | 0) < (1 | 0)) {
     break label$1
    }
    $7 = $0 + ($1 << 7 | 0) | 0;
    label$5 : while (1) {
     i64toi32_i32$3 = $6;
     i64toi32_i32$2 = HEAP32[($6 + 64 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($6 + 68 | 0) >> 2] | 0;
     $90 = i64toi32_i32$2;
     $90$hi = i64toi32_i32$0;
     i64toi32_i32$3 = $3;
     i64toi32_i32$0 = HEAP32[($3 + 64 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[($3 + 68 | 0) >> 2] | 0;
     $92 = i64toi32_i32$0;
     $92$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $90$hi;
     i64toi32_i32$3 = $90;
     i64toi32_i32$0 = $92$hi;
     i64toi32_i32$1 = $92;
     $2 = i64toi32_i32$2 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0 | 0) | 0;
     $1 = $2 ? $6 : $3;
     $3 = $2 ? $3 : $3 + 128 | 0;
     $0 = (memcpy($0 | 0, $1 | 0, 128 | 0) | 0) + 128 | 0;
     $6 = $2 ? $6 + 128 | 0 : $6;
     if ($6 >>> 0 >= $7 >>> 0) {
      break label$1
     }
     if ($3 >>> 0 < $5 >>> 0) {
      continue label$5
     }
     break label$1;
    };
   }
   $0 = $6;
  }
  memcpy($0 | 0, $3 | 0, ($5 - $3 | 0) & -128 | 0 | 0) | 0;
 }
 
 function alloc__slice__merge__h7d79a9efe92f6589($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, $6 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $7 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $8 = 0, $9 = 0, $48 = 0, $48$hi = 0, $51 = 0, $51$hi = 0, $90 = 0, $90$hi = 0, $92 = 0, $92$hi = 0;
  $5 = $2 << 7 | 0;
  $6 = $0 + $5 | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     $7 = $1 - $2 | 0;
     if ($7 >>> 0 >= $2 >>> 0) {
      break label$3
     }
     $5 = $7 << 7 | 0;
     $8 = memcpy($3 | 0, $6 | 0, $5 | 0) | 0;
     $5 = $8 + $5 | 0;
     if (($2 | 0) < (1 | 0)) {
      break label$2
     }
     if (($7 | 0) < (1 | 0)) {
      break label$2
     }
     $1 = (($1 << 7 | 0) + $0 | 0) + -128 | 0;
     label$4 : while (1) {
      $7 = $6 + -128 | 0;
      $9 = $5 + -128 | 0;
      i64toi32_i32$2 = $5 + -64 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $48 = i64toi32_i32$0;
      $48$hi = i64toi32_i32$1;
      i64toi32_i32$2 = $6 + -64 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $51 = i64toi32_i32$1;
      $51$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $48$hi;
      i64toi32_i32$2 = $48;
      i64toi32_i32$1 = $51$hi;
      i64toi32_i32$3 = $51;
      $2 = i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
      $1 = memcpy($1 | 0, ($2 ? $7 : $9) | 0, 128 | 0) | 0;
      $5 = $2 ? $5 : $9;
      $6 = $2 ? $7 : $6;
      if ($0 >>> 0 >= $6 >>> 0) {
       break label$2
      }
      $1 = $1 + -128 | 0;
      if ($5 >>> 0 <= $8 >>> 0) {
       break label$2
      }
      continue label$4;
     };
    }
    $5 = (memcpy($3 | 0, $0 | 0, $5 | 0) | 0) + $5 | 0;
    if (($1 | 0) <= ($2 | 0)) {
     break label$1
    }
    if (($2 | 0) < (1 | 0)) {
     break label$1
    }
    $7 = $0 + ($1 << 7 | 0) | 0;
    label$5 : while (1) {
     i64toi32_i32$3 = $6;
     i64toi32_i32$2 = HEAP32[($6 + 64 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($6 + 68 | 0) >> 2] | 0;
     $90 = i64toi32_i32$2;
     $90$hi = i64toi32_i32$0;
     i64toi32_i32$3 = $3;
     i64toi32_i32$0 = HEAP32[($3 + 64 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[($3 + 68 | 0) >> 2] | 0;
     $92 = i64toi32_i32$0;
     $92$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $90$hi;
     i64toi32_i32$3 = $90;
     i64toi32_i32$0 = $92$hi;
     i64toi32_i32$1 = $92;
     $2 = i64toi32_i32$2 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0 | 0) | 0;
     $1 = $2 ? $6 : $3;
     $3 = $2 ? $3 : $3 + 128 | 0;
     $0 = (memcpy($0 | 0, $1 | 0, 128 | 0) | 0) + 128 | 0;
     $6 = $2 ? $6 + 128 | 0 : $6;
     if ($6 >>> 0 >= $7 >>> 0) {
      break label$1
     }
     if ($3 >>> 0 < $5 >>> 0) {
      continue label$5
     }
     break label$1;
    };
   }
   $0 = $6;
  }
  memcpy($0 | 0, $3 | 0, ($5 - $3 | 0) & -128 | 0 | 0) | 0;
 }
 
 function std__thread__local__LocalKey_T___with__ha120a3da9e0d1836($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0, $6 = 0, $5 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     $3 = FUNCTION_TABLE[HEAP32[$0 >> 2] | 0 | 0]() | 0;
     if (!$3) {
      break label$3
     }
     $0 = HEAP32[($3 + 4 | 0) >> 2] | 0;
     if (HEAP32[$3 >> 2] | 0) {
      break label$1
     }
     $4 = $3 + 8 | 0;
     label$4 : {
      if (($0 | 0) == (1 | 0)) {
       break label$4
      }
      getrandom__imp__NodeCrypto__random_fill_sync__h449b39f067aa8fea($2 + 16 | 0 | 0, $4 | 0, HEAP32[$1 >> 2] | 0 | 0, HEAP32[($1 + 4 | 0) >> 2] | 0 | 0);
      label$5 : {
       $0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
       if (!$0) {
        break label$5
       }
       $3 = HEAP32[($2 + 20 | 0) >> 2] | 0;
       if ($3 >>> 0 < 36 >>> 0) {
        break label$5
       }
       wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($3 | 0);
      }
      $0 = $0 ? -2147483635 : 0;
      break label$1;
     }
     $0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     if (!$0) {
      break label$2
     }
     $5 = $3 + 12 | 0;
     $1 = HEAP32[$1 >> 2] | 0;
     label$6 : while (1) {
      $3 = $0 >>> 0 < 256 >>> 0 ? $0 : 256;
      (wasm2js_i32$0 = $2, wasm2js_i32$1 = js_sys__Uint8Array__subarray__h61dedba10f10fd0e($5 | 0, 0 | 0, $3 | 0) | 0), HEAP32[(wasm2js_i32$0 + 24 | 0) >> 2] = wasm2js_i32$1;
      getrandom__imp__BrowserCrypto__get_random_values__hc9121ab79959a6fc($2 + 8 | 0 | 0, $4 | 0, $2 + 24 | 0 | 0);
      label$7 : {
       if (!(HEAP32[($2 + 8 | 0) >> 2] | 0)) {
        break label$7
       }
       label$8 : {
        $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
        if ($0 >>> 0 < 36 >>> 0) {
         break label$8
        }
        wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($0 | 0);
       }
       label$9 : {
        $0 = HEAP32[($2 + 24 | 0) >> 2] | 0;
        if ($0 >>> 0 < 36 >>> 0) {
         break label$9
        }
        wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($0 | 0);
       }
       $0 = -2147483640;
       break label$1;
      }
      $0 = $0 - $3 | 0;
      js_sys__Uint8Array__copy_to__h427146d9baad4940($2 + 24 | 0 | 0, $1 | 0, $3 | 0);
      label$10 : {
       $6 = HEAP32[($2 + 24 | 0) >> 2] | 0;
       if ($6 >>> 0 < 36 >>> 0) {
        break label$10
       }
       wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($6 | 0);
      }
      $1 = $1 + $3 | 0;
      if (!$0) {
       break label$2
      }
      continue label$6;
     };
    }
    $T_20as_20core__convert__From_T____from__h03d182df15dd7aa6();
    core__result__unwrap_failed__h27f43d993c3864a1(1075872 | 0, 70 | 0, $2 + 24 | 0 | 0, 1076040 | 0, 1076024 | 0);
    abort();
   }
   $0 = 0;
  }
  global$0 = $2 + 32 | 0;
  return $0 | 0;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__h97cfc1079bb46c17($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $3 = 0, $4 = 0, $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 128 | 0;
  global$0 = $2;
  $0 = HEAP32[$0 >> 2] | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       $3 = HEAP32[$1 >> 2] | 0;
       if ($3 & 16 | 0) {
        break label$5
       }
       if ($3 & 32 | 0) {
        break label$4
       }
       i64toi32_i32$1 = 0;
       $0 = core__fmt__num__imp__fmt_u64__hf0469431dace4046(HEAPU8[$0 >> 0] | 0 | 0, i64toi32_i32$1 | 0, 1 | 0, $1 | 0) | 0;
       break label$3;
      }
      $3 = HEAPU8[$0 >> 0] | 0;
      $0 = 0;
      label$6 : while (1) {
       $4 = $3 & 15 | 0;
       HEAP8[(($2 + $0 | 0) + 127 | 0) >> 0] = $4 >>> 0 < 10 >>> 0 ? $4 | 48 | 0 : $4 + 87 | 0;
       $0 = $0 + -1 | 0;
       $3 = ($3 >>> 4 | 0) & 15 | 0;
       if ($3) {
        continue label$6
       }
       break label$6;
      };
      $3 = $0 + 128 | 0;
      if ($3 >>> 0 >= 129 >>> 0) {
       break label$2
      }
      $0 = core__fmt__Formatter__pad_integral__h08e3e53a0de517a1($1 | 0, 1 | 0, 1150180 | 0, 2 | 0, ($2 + $0 | 0) + 128 | 0 | 0, 0 - $0 | 0 | 0) | 0;
      break label$3;
     }
     $3 = HEAPU8[$0 >> 0] | 0;
     $0 = 0;
     label$7 : while (1) {
      $4 = $3 & 15 | 0;
      HEAP8[(($2 + $0 | 0) + 127 | 0) >> 0] = $4 >>> 0 < 10 >>> 0 ? $4 | 48 | 0 : $4 + 55 | 0;
      $0 = $0 + -1 | 0;
      $3 = ($3 >>> 4 | 0) & 15 | 0;
      if ($3) {
       continue label$7
      }
      break label$7;
     };
     $3 = $0 + 128 | 0;
     if ($3 >>> 0 >= 129 >>> 0) {
      break label$1
     }
     $0 = core__fmt__Formatter__pad_integral__h08e3e53a0de517a1($1 | 0, 1 | 0, 1150180 | 0, 2 | 0, ($2 + $0 | 0) + 128 | 0 | 0, 0 - $0 | 0 | 0) | 0;
    }
    global$0 = $2 + 128 | 0;
    return $0 | 0;
   }
   core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($3 | 0, 128 | 0, 1150164 | 0);
   abort();
  }
  core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($3 | 0, 128 | 0, 1150164 | 0);
  abort();
 }
 
 function cbor_event__de__Deserializer_R___unsigned_integer__h1ed99c0b7fe7eea1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$3 = 0, i64toi32_i32$5 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $3 = 0, $7 = 0, $7$hi = 0, $4 = 0, $5 = 0, $6 = 0, $8 = 0, $8$hi = 0, $9 = 0, $9$hi = 0, i64toi32_i32$4 = 0, $49 = 0, $51$hi = 0, $54$hi = 0, $61 = 0, $67 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 8 | 0 | 0, $1 | 0);
  $3 = 8;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $4 = HEAP32[($2 + 12 | 0) >> 2] | 0;
      if ($4) {
       break label$4
      }
      break label$3;
     }
     $5 = HEAP32[($2 + 8 | 0) >> 2] | 0;
     if (!$5) {
      break label$3
     }
     $3 = 9;
     $6 = ($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[$5 >> 0] | 0 | 0) | 0) & 255 | 0;
     if ($6) {
      break label$3
     }
     cbor_event__de__Deserializer_R___cbor_len__h852681e444aca076_1($2 + 16 | 0 | 0, $1 | 0);
     i64toi32_i32$0 = 0;
     $7 = 1;
     $7$hi = i64toi32_i32$0;
     $3 = HEAP32[(($2 + 16 | 0) + 24 | 0) >> 2] | 0;
     i64toi32_i32$2 = ($2 + 16 | 0) + 16 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $8 = i64toi32_i32$0;
     $8$hi = i64toi32_i32$1;
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 28 | 0) >> 2] | 0;
     $9 = i64toi32_i32$1;
     $9$hi = i64toi32_i32$0;
     label$5 : {
      i64toi32_i32$2 = $2;
      i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
      i64toi32_i32$2 = i64toi32_i32$0;
      i64toi32_i32$0 = 0;
      i64toi32_i32$3 = 1;
      if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
       break label$5
      }
      label$6 : {
       i64toi32_i32$2 = $9$hi;
       if ($9) {
        break label$6
       }
       HEAP16[($0 + 8 | 0) >> 1] = 12;
       break label$2;
      }
      i64toi32_i32$2 = $8$hi;
      i64toi32_i32$1 = $0;
      HEAP32[($0 + 8 | 0) >> 2] = $8;
      HEAP32[($0 + 12 | 0) >> 2] = i64toi32_i32$2;
      $49 = $1;
      i64toi32_i32$3 = $1;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $51$hi = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      $54$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $51$hi;
      i64toi32_i32$3 = i64toi32_i32$2;
      i64toi32_i32$2 = $54$hi;
      i64toi32_i32$0 = $3 + 1 | 0;
      i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
      i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
      if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
       i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
      }
      i64toi32_i32$3 = $49;
      HEAP32[i64toi32_i32$3 >> 2] = i64toi32_i32$4;
      HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
      i64toi32_i32$5 = 0;
      $7 = 0;
      $7$hi = i64toi32_i32$5;
      break label$1;
     }
     i64toi32_i32$1 = ($2 + 16 | 0) + 32 | 0;
     i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $61 = i64toi32_i32$5;
     i64toi32_i32$5 = $0 + 32 | 0;
     HEAP32[i64toi32_i32$5 >> 2] = $61;
     HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$1 = ($2 + 16 | 0) + 40 | 0;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $67 = i64toi32_i32$3;
     i64toi32_i32$3 = $0 + 40 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $67;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
     HEAP32[($0 + 28 | 0) >> 2] = HEAP32[($2 + 44 | 0) >> 2] | 0;
     HEAP32[($0 + 24 | 0) >> 2] = $3;
     i64toi32_i32$5 = $8$hi;
     i64toi32_i32$3 = $0 + 16 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $8;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
     i64toi32_i32$5 = $9$hi;
     i64toi32_i32$3 = $0;
     HEAP32[(i64toi32_i32$3 + 8 | 0) >> 2] = $9;
     HEAP32[(i64toi32_i32$3 + 12 | 0) >> 2] = i64toi32_i32$5;
     break label$1;
    }
    HEAP8[($0 + 8 | 0) >> 0] = $3;
    HEAP32[($0 + 16 | 0) >> 2] = 0;
    HEAP32[($0 + 12 | 0) >> 2] = $4;
    HEAP8[($0 + 10 | 0) >> 0] = $6;
    HEAP8[($0 + 9 | 0) >> 0] = 0;
   }
   i64toi32_i32$5 = 0;
   $7 = 1;
   $7$hi = i64toi32_i32$5;
  }
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$3 = $0;
  HEAP32[i64toi32_i32$3 >> 2] = $7;
  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
  global$0 = $2 + 64 | 0;
 }
 
 function cbor_event__de__Deserializer_R___unsigned_integer__h6e8a066f7fcdccf2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$3 = 0, i64toi32_i32$5 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $3 = 0, $7 = 0, $7$hi = 0, $4 = 0, $5 = 0, $6 = 0, $8 = 0, $8$hi = 0, $9 = 0, $9$hi = 0, i64toi32_i32$4 = 0, $49 = 0, $51$hi = 0, $54$hi = 0, $61 = 0, $67 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  std__io__cursor__Cursor_T___remaining_slice__h5de2a0dd397eef35($2 + 8 | 0 | 0, $1 | 0);
  $3 = 8;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $4 = HEAP32[($2 + 12 | 0) >> 2] | 0;
      if ($4) {
       break label$4
      }
      break label$3;
     }
     $5 = HEAP32[($2 + 8 | 0) >> 2] | 0;
     if (!$5) {
      break label$3
     }
     $3 = 9;
     $6 = ($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[$5 >> 0] | 0 | 0) | 0) & 255 | 0;
     if ($6) {
      break label$3
     }
     cbor_event__de__Deserializer_R___cbor_len__hc68764db78e73af0($2 + 16 | 0 | 0, $1 | 0);
     i64toi32_i32$0 = 0;
     $7 = 1;
     $7$hi = i64toi32_i32$0;
     $3 = HEAP32[(($2 + 16 | 0) + 24 | 0) >> 2] | 0;
     i64toi32_i32$2 = ($2 + 16 | 0) + 16 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $8 = i64toi32_i32$0;
     $8$hi = i64toi32_i32$1;
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 28 | 0) >> 2] | 0;
     $9 = i64toi32_i32$1;
     $9$hi = i64toi32_i32$0;
     label$5 : {
      i64toi32_i32$2 = $2;
      i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
      i64toi32_i32$2 = i64toi32_i32$0;
      i64toi32_i32$0 = 0;
      i64toi32_i32$3 = 1;
      if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
       break label$5
      }
      label$6 : {
       i64toi32_i32$2 = $9$hi;
       if ($9) {
        break label$6
       }
       HEAP16[($0 + 8 | 0) >> 1] = 12;
       break label$2;
      }
      i64toi32_i32$2 = $8$hi;
      i64toi32_i32$1 = $0;
      HEAP32[($0 + 8 | 0) >> 2] = $8;
      HEAP32[($0 + 12 | 0) >> 2] = i64toi32_i32$2;
      $49 = $1;
      i64toi32_i32$3 = $1;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $51$hi = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      $54$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $51$hi;
      i64toi32_i32$3 = i64toi32_i32$2;
      i64toi32_i32$2 = $54$hi;
      i64toi32_i32$0 = $3 + 1 | 0;
      i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
      i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
      if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
       i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
      }
      i64toi32_i32$3 = $49;
      HEAP32[i64toi32_i32$3 >> 2] = i64toi32_i32$4;
      HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
      i64toi32_i32$5 = 0;
      $7 = 0;
      $7$hi = i64toi32_i32$5;
      break label$1;
     }
     i64toi32_i32$1 = ($2 + 16 | 0) + 32 | 0;
     i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $61 = i64toi32_i32$5;
     i64toi32_i32$5 = $0 + 32 | 0;
     HEAP32[i64toi32_i32$5 >> 2] = $61;
     HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$3;
     i64toi32_i32$1 = ($2 + 16 | 0) + 40 | 0;
     i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
     i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
     $67 = i64toi32_i32$3;
     i64toi32_i32$3 = $0 + 40 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $67;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
     HEAP32[($0 + 28 | 0) >> 2] = HEAP32[($2 + 44 | 0) >> 2] | 0;
     HEAP32[($0 + 24 | 0) >> 2] = $3;
     i64toi32_i32$5 = $8$hi;
     i64toi32_i32$3 = $0 + 16 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $8;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
     i64toi32_i32$5 = $9$hi;
     i64toi32_i32$3 = $0;
     HEAP32[(i64toi32_i32$3 + 8 | 0) >> 2] = $9;
     HEAP32[(i64toi32_i32$3 + 12 | 0) >> 2] = i64toi32_i32$5;
     break label$1;
    }
    HEAP8[($0 + 8 | 0) >> 0] = $3;
    HEAP32[($0 + 16 | 0) >> 2] = 0;
    HEAP32[($0 + 12 | 0) >> 2] = $4;
    HEAP8[($0 + 10 | 0) >> 0] = $6;
    HEAP8[($0 + 9 | 0) >> 0] = 0;
   }
   i64toi32_i32$5 = 0;
   $7 = 1;
   $7$hi = i64toi32_i32$5;
  }
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$3 = $0;
  HEAP32[i64toi32_i32$3 >> 2] = $7;
  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
  global$0 = $2 + 64 | 0;
 }
 
 function cardano_serialization_lib__metadata__encode_json_str_to_metadatum__h4a5979815eae04ac($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $4 = 0, $5 = 0, $6 = 0, $4$hi = 0, $5$hi = 0, $6$hi = 0;
  $3 = global$0 - 144 | 0;
  global$0 = $3;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $1 | 0);
  serde_json__de__from_str__h84312e5dc76b40c6($3 + 40 | 0 | 0, HEAP32[($3 + 8 | 0) >> 2] | 0 | 0, HEAP32[($3 + 12 | 0) >> 2] | 0 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[($3 + 40 | 0) >> 2] | 0 | 0) != (1 | 0)) {
      break label$3
     }
     HEAP32[($3 + 76 | 0) >> 2] = HEAP32[($3 + 44 | 0) >> 2] | 0;
     i64toi32_i32$1 = $3;
     i64toi32_i32$0 = 0;
     HEAP32[($3 + 84 | 0) >> 2] = 0;
     HEAP32[($3 + 88 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($3 + 80 | 0) >> 2] = HEAP32[(0 + 1059260 | 0) >> 2] | 0;
     core__fmt__Formatter__new__he219faf25326051b($3 + 96 | 0 | 0, $3 + 80 | 0 | 0, 1058944 | 0);
     if (!($serde_json__error__Error_20as_20core__fmt__Display___fmt__h9e9840cbd4820f76($3 + 76 | 0 | 0, $3 + 96 | 0 | 0) | 0)) {
      break label$2
     }
     core__result__unwrap_failed__h27f43d993c3864a1(1058968 | 0, 55 | 0, $3 + 136 | 0 | 0, 1059160 | 0, 1059100 | 0);
     abort();
    }
    i64toi32_i32$2 = $3 + 64 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $4 = i64toi32_i32$0;
    $4$hi = i64toi32_i32$1;
    i64toi32_i32$0 = ($3 + 16 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $4;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = ($3 + 40 | 0) + 16 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $5 = i64toi32_i32$1;
    $5$hi = i64toi32_i32$0;
    i64toi32_i32$1 = ($3 + 16 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $5;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = ($3 + 40 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $6 = i64toi32_i32$0;
    $6$hi = i64toi32_i32$1;
    i64toi32_i32$0 = $3;
    HEAP32[($3 + 16 | 0) >> 2] = $6;
    HEAP32[($3 + 20 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $4$hi;
    i64toi32_i32$0 = ($3 + 96 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $4;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $5$hi;
    i64toi32_i32$0 = ($3 + 96 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $5;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $6$hi;
    i64toi32_i32$0 = $3;
    HEAP32[($3 + 96 | 0) >> 2] = $6;
    HEAP32[($3 + 100 | 0) >> 2] = i64toi32_i32$1;
    cardano_serialization_lib__metadata__encode_json_value_to_metadatum__h64667ed57b92baeb($0 | 0, $3 + 96 | 0 | 0, $2 | 0);
    break label$1;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 | 0, $3 + 80 | 0 | 0);
   $2 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[$3 >> 2] | 0 | 0, HEAP32[($3 + 4 | 0) >> 2] | 0 | 0) | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 80 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 80 | 0 | 0);
   core__ptr__drop_in_place_serde_json__error__Error___h074362a9a9c9d71d($3 + 76 | 0 | 0);
   $2 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($2 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
   HEAP32[($0 + 4 | 0) >> 2] = $2;
  }
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  global$0 = $3 + 144 | 0;
 }
 
 function cardano_serialization_lib__tx_builder__TransactionBuilderConfigBuilder__prefer_pure_change__h671ffdf7d905da3e($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $7 = 0, $7$hi = 0, $8 = 0, $8$hi = 0, $3 = 0, $4 = 0, $9 = 0, $9$hi = 0, $10 = 0, $10$hi = 0, $11 = 0, $11$hi = 0, $12 = 0, $12$hi = 0, $5 = 0, $6 = 0, $13 = 0, $13$hi = 0, $14 = 0, $14$hi = 0, $15 = 0, $15$hi = 0, $16 = 0, $16$hi = 0, $17 = 0, $17$hi = 0, $18 = 0, $18$hi = 0, $19 = 0, $19$hi = 0, $20 = 0, $20$hi = 0;
  i64toi32_i32$0 = 0;
  $7 = 1;
  $7$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $1 + 64 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  $3 = HEAP32[($1 + 124 | 0) >> 2] | 0;
  $4 = HEAP32[($1 + 116 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1 + 48 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $1 + 32 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
  $12 = i64toi32_i32$0;
  $12$hi = i64toi32_i32$1;
  $5 = HEAP32[(i64toi32_i32$2 + 120 | 0) >> 2] | 0;
  $6 = HEAP32[(i64toi32_i32$2 + 112 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] | 0;
  $13 = i64toi32_i32$1;
  $13$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  $14$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $15 = i64toi32_i32$1;
  $15$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $16 = i64toi32_i32$0;
  $16$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 72 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 76 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    i64toi32_i32$3 = 1;
    if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
     break label$2
    }
    i64toi32_i32$2 = 0;
    $7 = 0;
    $7$hi = i64toi32_i32$2;
    break label$1;
   }
   i64toi32_i32$3 = $1 + 104 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $17 = i64toi32_i32$2;
   $17$hi = i64toi32_i32$0;
   i64toi32_i32$3 = $1 + 96 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $18 = i64toi32_i32$0;
   $18$hi = i64toi32_i32$2;
   i64toi32_i32$3 = $1 + 88 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $19 = i64toi32_i32$2;
   $19$hi = i64toi32_i32$0;
   i64toi32_i32$3 = $1 + 80 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $20 = i64toi32_i32$0;
   $20$hi = i64toi32_i32$2;
  }
  HEAP32[($0 + 120 | 0) >> 2] = $5;
  HEAP32[($0 + 112 | 0) >> 2] = $6;
  i64toi32_i32$2 = $13$hi;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 40 | 0) >> 2] = $13;
  HEAP32[(i64toi32_i32$0 + 44 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $14$hi;
  HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = $14;
  HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $15$hi;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $15;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $16$hi;
  HEAP32[i64toi32_i32$0 >> 2] = $16;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  HEAP8[(i64toi32_i32$0 + 128 | 0) >> 0] = $2;
  i64toi32_i32$2 = $7$hi;
  HEAP32[(i64toi32_i32$0 + 72 | 0) >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 76 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $12$hi;
  HEAP32[(i64toi32_i32$0 + 56 | 0) >> 2] = $12;
  HEAP32[(i64toi32_i32$0 + 60 | 0) >> 2] = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$0 + 124 | 0) >> 2] = $3;
  HEAP32[(i64toi32_i32$0 + 116 | 0) >> 2] = $4;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$0 = i64toi32_i32$0 + 48 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $9;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$0 = $0 + 32 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $10;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$0 = $0 + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $11;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $17$hi;
  i64toi32_i32$0 = $0 + 104 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $17;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $18$hi;
  i64toi32_i32$0 = $0 + 96 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $19$hi;
  i64toi32_i32$0 = $0 + 88 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $19;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $20$hi;
  i64toi32_i32$0 = $0 + 80 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $20;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$0 = $0 + 64 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
 }
 
 function cardano_serialization_lib__tx_builder__TransactionBuilder__add_mint_asset_and_output__h403fdf9453eb886a($0, $1, $2, $3, $4, $4$hi, $5, $5$hi, $6, $7) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  $4$hi = $4$hi | 0;
  $5 = $5 | 0;
  $5$hi = $5$hi | 0;
  $6 = $6 | 0;
  $7 = $7 | 0;
  var $8 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $15 = 0, $16 = 0, $17 = 0, i64toi32_i32$3 = 0;
  $8 = global$0 - 480 | 0;
  global$0 = $8;
  label$1 : {
   label$2 : {
    label$3 : {
     i64toi32_i32$0 = $5$hi;
     i64toi32_i32$2 = $5;
     i64toi32_i32$1 = 0;
     i64toi32_i32$3 = 0;
     if ((i64toi32_i32$0 | 0) < (i64toi32_i32$1 | 0)) {
      $15 = 1
     } else {
      if ((i64toi32_i32$0 | 0) <= (i64toi32_i32$1 | 0)) {
       if (i64toi32_i32$2 >>> 0 >= i64toi32_i32$3 >>> 0) {
        $16 = 0
       } else {
        $16 = 1
       }
       $17 = $16;
      } else {
       $17 = 0
      }
      $15 = $17;
     }
     if ($15) {
      break label$3
     }
     cardano_serialization_lib__NativeScript__hash__hb812a54d2c7bdca2($8 + 40 | 0 | 0, $2 | 0);
     i64toi32_i32$2 = $4$hi;
     i64toi32_i32$2 = $5$hi;
     i64toi32_i32$2 = $4$hi;
     i64toi32_i32$0 = $5$hi;
     cardano_serialization_lib__tx_builder__TransactionBuilder___add_mint_asset__h060e64edb838acae($1 | 0, $8 + 40 | 0 | 0, $2 | 0, $3 | 0, $4 | 0, i64toi32_i32$2 | 0, $5 | 0, i64toi32_i32$0 | 0);
     i64toi32_i32$2 = $8;
     i64toi32_i32$0 = 0;
     HEAP32[($8 + 356 | 0) >> 2] = 0;
     HEAP32[($8 + 360 | 0) >> 2] = i64toi32_i32$0;
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($8 + 216 | 0 | 0, $3 | 0);
     i64toi32_i32$0 = $4$hi;
     i64toi32_i32$0 = $5$hi;
     i64toi32_i32$0 = $4$hi;
     i64toi32_i32$2 = $5$hi;
     alloc__collections__btree__map__BTreeMap_K_2cV___insert__h9d3a28073b5db74d($8 + 16 | 0 | 0, $8 + 352 | 0 | 0, $8 + 216 | 0 | 0, $4 | 0, i64toi32_i32$0 | 0, $5 | 0, $5$hi | 0);
     cardano_serialization_lib__Mint__new_from_entry__hae31aeb23b43a89f($8 + 216 | 0 | 0, $8 + 40 | 0 | 0, $8 + 352 | 0 | 0);
     $2 = 1;
     cardano_serialization_lib__Mint__as_multiasset__hfae7c36e40af3e22($8 + 72 | 0 | 0, $8 + 216 | 0 | 0, 1 | 0);
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h3981a4152bf24dd0($8 + 216 | 0 | 0);
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h0265580a5be10b66($8 + 352 | 0 | 0);
     cardano_serialization_lib__output_builder__TransactionOutputAmountBuilder__with_coin_and_asset__h3912d48b40d60b51($8 + 352 | 0 | 0, $6 | 0, $7 | 0, $8 + 72 | 0 | 0);
     cardano_serialization_lib__output_builder__TransactionOutputAmountBuilder__build__he57d4fcb648faafd($8 + 216 | 0 | 0, $8 + 352 | 0 | 0);
     if ((HEAP32[($8 + 216 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$2
     }
     memcpy($8 + 88 | 0 | 0, $8 + 224 | 0 | 0, 128 | 0) | 0;
     cardano_serialization_lib__tx_builder__TransactionBuilder__add_output__h626cdf41f713b689($8 + 8 | 0 | 0, $1 | 0, $8 + 88 | 0 | 0);
     $3 = HEAP32[($8 + 12 | 0) >> 2] | 0;
     $2 = HEAP32[($8 + 8 | 0) >> 2] | 0;
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($8 + 72 | 0 | 0);
     core__ptr__drop_in_place_cardano_serialization_lib__TransactionOutput___h632b3a99817e6ac5($8 + 88 | 0 | 0);
     core__ptr__drop_in_place_cardano_serialization_lib__output_builder__TransactionOutputAmountBuilder___h4d21635c56401178($8 + 352 | 0 | 0);
     break label$1;
    }
    $2 = 1;
    $3 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1065200 | 0, 30 | 0) | 0;
    break label$1;
   }
   $3 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($8 + 220 | 0) >> 2] | 0 | 0) | 0;
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($8 + 72 | 0 | 0);
   core__ptr__drop_in_place_cardano_serialization_lib__output_builder__TransactionOutputAmountBuilder___h4d21635c56401178($8 + 352 | 0 | 0);
  }
  HEAP32[($0 + 4 | 0) >> 2] = $3;
  HEAP32[$0 >> 2] = $2;
  global$0 = $8 + 480 | 0;
 }
 
 function alloc__collections__btree__map__entry__VacantEntry_K_2cV___insert__h1331755557d851e2($0, $1, $1$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $1$hi = $1$hi | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $8 = 0, $4 = 0, $7 = 0, $20 = 0, $29 = 0, $3 = 0, $5 = 0, $6 = 0, $89 = 0;
  $2 = global$0 - 96 | 0;
  global$0 = $2;
  HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] = HEAP32[($0 + 20 | 0) >> 2] | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[($0 + 12 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($0 + 16 | 0) >> 2] | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 64 | 0) >> 2] = $20;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(($2 + 80 | 0) + 8 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$1 = HEAP32[$0 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $29 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 80 | 0) >> 2] = $29;
  HEAP32[($2 + 84 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $1$hi;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_recursing__h39267185ba07887a($2 + 8 | 0 | 0, $2 + 64 | 0 | 0, $2 + 80 | 0 | 0, $1 | 0, i64toi32_i32$0 | 0);
  $3 = HEAP32[($2 + 56 | 0) >> 2] | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     $0 = HEAP32[($0 + 24 | 0) >> 2] | 0;
     break label$2;
    }
    $0 = HEAP32[($0 + 24 | 0) >> 2] | 0;
    $4 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    if (!$4) {
     break label$1
    }
    $5 = HEAP32[($2 + 52 | 0) >> 2] | 0;
    $6 = HEAP32[($2 + 48 | 0) >> 2] | 0;
    i64toi32_i32$2 = $2 + 32 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $1 = i64toi32_i32$0;
    $1$hi = i64toi32_i32$1;
    $7 = HEAP32[$0 >> 2] | 0;
    $8 = alloc__boxed__Box_T_2cA___new_uninit_in__h2752ff92eca24da1() | 0;
    HEAP32[($8 + 232 | 0) >> 2] = $4;
    HEAP16[($8 + 226 | 0) >> 1] = 0;
    HEAP32[($8 + 88 | 0) >> 2] = 0;
    HEAP32[($0 + 4 | 0) >> 2] = $8;
    $7 = $7 + 1 | 0;
    HEAP32[$0 >> 2] = $7;
    HEAP16[($4 + 224 | 0) >> 1] = 0;
    HEAP32[($4 + 88 | 0) >> 2] = $8;
    HEAP32[($2 + 68 | 0) >> 2] = $8;
    HEAP32[($2 + 64 | 0) >> 2] = $7;
    HEAP32[(($2 + 80 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 24 | 0) >> 2] | 0;
    i64toi32_i32$2 = ($2 + 8 | 0) + 8 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $89 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 80 | 0) >> 2] = $89;
    HEAP32[($2 + 84 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = $1$hi;
    alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal___push__h6e96e9816acb473b($2 + 64 | 0 | 0, $2 + 80 | 0 | 0, $1 | 0, i64toi32_i32$0 | 0, $6 | 0, $5 | 0);
   }
   HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
   global$0 = $2 + 96 | 0;
   return $3 | 0;
  }
  core__panicking__panic__h2fd385a887c8bf13(1072048 | 0, 43 | 0, 1072248 | 0);
  abort();
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___insert__h676f968c46c3ef24($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $4 = 0, $6 = 0, $6$hi = 0, $5 = 0, $19 = 0, $38 = 0, $42 = 0, $45 = 0, $51 = 0, $57 = 0, $60 = 0, $80 = 0, $90 = 0, $101 = 0;
  $4 = global$0 - 96 | 0;
  global$0 = $4;
  $5 = ($4 + 40 | 0) + 8 | 0;
  HEAP32[$5 >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[(i64toi32_i32$0 + 40 | 0) >> 2] = $19;
  HEAP32[(i64toi32_i32$0 + 44 | 0) >> 2] = i64toi32_i32$1;
  alloc__collections__btree__map__BTreeMap_K_2cV___entry__he15124f74c251d46(i64toi32_i32$0 + 8 | 0 | 0, $1 | 0, i64toi32_i32$0 + 40 | 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    HEAP32[($4 + 64 | 0) >> 2] = HEAP32[($4 + 36 | 0) >> 2] | 0;
    i64toi32_i32$2 = $4 + 28 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $38 = i64toi32_i32$1;
    i64toi32_i32$1 = ($4 + 40 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $38;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $4 + 20 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $42 = i64toi32_i32$0;
    i64toi32_i32$0 = $5;
    HEAP32[i64toi32_i32$0 >> 2] = $42;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
    $45 = i64toi32_i32$1;
    i64toi32_i32$1 = i64toi32_i32$2;
    HEAP32[(i64toi32_i32$1 + 40 | 0) >> 2] = $45;
    HEAP32[(i64toi32_i32$1 + 44 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $3 + 16 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $51 = i64toi32_i32$0;
    i64toi32_i32$0 = ($4 + 72 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $51;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $3 + 8 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $57 = i64toi32_i32$1;
    i64toi32_i32$1 = ($4 + 72 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $57;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $60 = i64toi32_i32$0;
    i64toi32_i32$0 = $4;
    HEAP32[(i64toi32_i32$0 + 72 | 0) >> 2] = $60;
    HEAP32[(i64toi32_i32$0 + 76 | 0) >> 2] = i64toi32_i32$1;
    alloc__collections__btree__map__entry__VacantEntry_K_2cV___insert__h0ed6cc8b755d44e5(i64toi32_i32$0 + 40 | 0 | 0, i64toi32_i32$0 + 72 | 0 | 0) | 0;
    HEAP8[$0 >> 0] = 6;
    break label$1;
   }
   $2 = (HEAP32[(($4 + 8 | 0) + 8 | 0) >> 2] | 0) + Math_imul(HEAP32[($4 + 20 | 0) >> 2] | 0, 24) | 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $6 = i64toi32_i32$1;
   $6$hi = i64toi32_i32$0;
   i64toi32_i32$2 = $3;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $80 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   HEAP32[i64toi32_i32$0 >> 2] = $80;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $6$hi;
   i64toi32_i32$0 = $0;
   HEAP32[i64toi32_i32$0 >> 2] = $6;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   $1 = $2 + 8 | 0;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $6 = i64toi32_i32$1;
   $6$hi = i64toi32_i32$0;
   i64toi32_i32$2 = $3 + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $90 = i64toi32_i32$0;
   i64toi32_i32$0 = $1;
   HEAP32[i64toi32_i32$0 >> 2] = $90;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $6$hi;
   i64toi32_i32$0 = $0 + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $6;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   $2 = $2 + 16 | 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $6 = i64toi32_i32$1;
   $6$hi = i64toi32_i32$0;
   i64toi32_i32$2 = $3 + 16 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $101 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   HEAP32[i64toi32_i32$0 >> 2] = $101;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $6$hi;
   i64toi32_i32$0 = $0 + 16 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $6;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  }
  global$0 = $4 + 96 | 0;
 }
 
 function std__ffi__c_str__CString__from_vec_unchecked__h59e10776c8f9e277($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $4 = 0, $2 = 0, $3 = 0, $5 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
        $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
        if (($3 | 0) != ($4 | 0)) {
         break label$6
        }
        $3 = $4 + 1 | 0;
        if ($3 >>> 0 < $4 >>> 0) {
         break label$2
        }
        label$7 : {
         label$8 : {
          if (!$4) {
           break label$8
          }
          HEAP32[($2 + 24 | 0) >> 2] = 1;
          HEAP32[($2 + 20 | 0) >> 2] = $4;
          HEAP32[($2 + 16 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
          break label$7;
         }
         HEAP32[($2 + 16 | 0) >> 2] = 0;
        }
        alloc__raw_vec__finish_grow__h4140f8b73d3423e5($2 | 0, $3 | 0, 1 | 0, $2 + 16 | 0 | 0);
        if ((HEAP32[$2 >> 2] | 0 | 0) == (1 | 0)) {
         break label$5
        }
        $5 = HEAP32[($2 + 4 | 0) >> 2] | 0;
        $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
        HEAP32[($1 + 4 | 0) >> 2] = $3;
        HEAP32[$1 >> 2] = $5;
       }
       label$9 : {
        if (($4 | 0) != ($3 | 0)) {
         break label$9
        }
        alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hc5a84431bcb0aafc($1 | 0, $4 | 0, 1 | 0);
        $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
        $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
       }
       $5 = $4 + 1 | 0;
       HEAP32[($1 + 8 | 0) >> 2] = $5;
       $1 = HEAP32[$1 >> 2] | 0;
       HEAP8[($1 + $4 | 0) >> 0] = 0;
       if ($3 >>> 0 > $5 >>> 0) {
        break label$4
       }
       $4 = $1;
       break label$3;
      }
      $1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
      if (!$1) {
       break label$2
      }
      alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, $1 | 0);
      abort();
     }
     label$10 : {
      if ($5) {
       break label$10
      }
      $4 = 1;
      __rust_dealloc($1 | 0, $3 | 0, 1 | 0);
      break label$3;
     }
     $4 = __rust_realloc($1 | 0, $3 | 0, 1 | 0, $5 | 0) | 0;
     if (!$4) {
      break label$1
     }
    }
    HEAP32[($0 + 4 | 0) >> 2] = $5;
    HEAP32[$0 >> 2] = $4;
    global$0 = $2 + 32 | 0;
    return;
   }
   alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
   abort();
  }
  alloc__alloc__handle_alloc_error__he269d8f1bff90960($5 | 0, 1 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert_fit__h288101fa3069cc9c($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $5 = 0, $4 = 0, $6 = 0, i64toi32_i32$1 = 0, $7 = 0, $9 = 0, i64toi32_i32$0 = 0, $8 = 0, $10 = 0, $28 = 0, $62 = 0;
  $4 = global$0 - 16 | 0;
  global$0 = $4;
  $5 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  $6 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $0 = HEAPU16[($6 + 138 | 0) >> 1] | 0;
  $7 = $4 + 8 | 0;
  HEAP32[$7 >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $28 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[$4 >> 2] = $28;
  HEAP32[($4 + 4 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   $1 = $5 + 1 | 0;
   if ($1 >>> 0 > $0 >>> 0) {
    break label$1
   }
   $8 = $6 + 4 | 0;
   memmove($8 + Math_imul($1, 12) | 0 | 0, $8 + Math_imul($5, 12) | 0 | 0, Math_imul($0 - $5 | 0, 12) | 0) | 0;
  }
  $8 = $0 + 1 | 0;
  $9 = $6 + Math_imul($5, 12) | 0;
  HEAP32[($9 + 12 | 0) >> 2] = HEAP32[$7 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[$4 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($4 + 4 | 0) >> 2] | 0;
  $62 = i64toi32_i32$1;
  i64toi32_i32$1 = $9 + 4 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $62;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  label$2 : {
   $9 = $5 + 2 | 0;
   $7 = $0 + 2 | 0;
   if ($9 >>> 0 >= $7 >>> 0) {
    break label$2
   }
   $10 = $6 + 140 | 0;
   memmove($10 + ($9 << 2 | 0) | 0 | 0, $10 + ($1 << 2 | 0) | 0 | 0, ($0 - $5 | 0) << 2 | 0 | 0) | 0;
  }
  HEAP32[(($6 + ($1 << 2 | 0) | 0) + 140 | 0) >> 2] = $3;
  HEAP16[($6 + 138 | 0) >> 1] = $8;
  label$3 : {
   if ($1 >>> 0 >= $7 >>> 0) {
    break label$3
   }
   $3 = $0 + 1 | 0;
   $0 = ($6 + ($5 << 2 | 0) | 0) + 144 | 0;
   label$4 : while (1) {
    $1 = HEAP32[$0 >> 2] | 0;
    $5 = $5 + 1 | 0;
    HEAP16[($1 + 136 | 0) >> 1] = $5;
    HEAP32[$1 >> 2] = $6;
    $0 = $0 + 4 | 0;
    if (($3 | 0) != ($5 | 0)) {
     continue label$4
    }
    break label$4;
   };
  }
  global$0 = $4 + 16 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert_fit__h873df3a9555bbba9($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $5 = 0, $4 = 0, $6 = 0, i64toi32_i32$1 = 0, $7 = 0, $9 = 0, i64toi32_i32$0 = 0, $8 = 0, $10 = 0, $28 = 0, $62 = 0;
  $4 = global$0 - 16 | 0;
  global$0 = $4;
  $5 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  $6 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $0 = HEAPU16[($6 + 138 | 0) >> 1] | 0;
  $7 = $4 + 8 | 0;
  HEAP32[$7 >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $28 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[$4 >> 2] = $28;
  HEAP32[($4 + 4 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   $1 = $5 + 1 | 0;
   if ($1 >>> 0 > $0 >>> 0) {
    break label$1
   }
   $8 = $6 + 4 | 0;
   memmove($8 + Math_imul($1, 12) | 0 | 0, $8 + Math_imul($5, 12) | 0 | 0, Math_imul($0 - $5 | 0, 12) | 0) | 0;
  }
  $8 = $0 + 1 | 0;
  $9 = $6 + Math_imul($5, 12) | 0;
  HEAP32[($9 + 12 | 0) >> 2] = HEAP32[$7 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[$4 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($4 + 4 | 0) >> 2] | 0;
  $62 = i64toi32_i32$1;
  i64toi32_i32$1 = $9 + 4 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $62;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  label$2 : {
   $9 = $5 + 2 | 0;
   $7 = $0 + 2 | 0;
   if ($9 >>> 0 >= $7 >>> 0) {
    break label$2
   }
   $10 = $6 + 140 | 0;
   memmove($10 + ($9 << 2 | 0) | 0 | 0, $10 + ($1 << 2 | 0) | 0 | 0, ($0 - $5 | 0) << 2 | 0 | 0) | 0;
  }
  HEAP32[(($6 + ($1 << 2 | 0) | 0) + 140 | 0) >> 2] = $3;
  HEAP16[($6 + 138 | 0) >> 1] = $8;
  label$3 : {
   if ($1 >>> 0 >= $7 >>> 0) {
    break label$3
   }
   $3 = $0 + 1 | 0;
   $0 = ($6 + ($5 << 2 | 0) | 0) + 144 | 0;
   label$4 : while (1) {
    $1 = HEAP32[$0 >> 2] | 0;
    $5 = $5 + 1 | 0;
    HEAP16[($1 + 136 | 0) >> 1] = $5;
    HEAP32[$1 >> 2] = $6;
    $0 = $0 + 4 | 0;
    if (($3 | 0) != ($5 | 0)) {
     continue label$4
    }
    break label$4;
   };
  }
  global$0 = $4 + 16 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__Transaction___serialize__h727dde48672e8d9f($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0;
  $3 = global$0 - 64 | 0;
  global$0 = $3;
  i64toi32_i32$0 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, 4 | 0, i64toi32_i32$0 | 0);
  $4 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
          break label$7
         }
         cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__TransactionBody___serialize__h766748b3e983f577($3 | 0, $1 | 0, $2 | 0);
         if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
          break label$6
         }
         cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__TransactionWitnessSet___serialize__ha4e0dd8fca4a45ce($3 | 0, $1 + 344 | 0 | 0, $2 | 0);
         $4 = 1;
         if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
          break label$5
         }
         HEAP8[($3 + 48 | 0) >> 0] = 0;
         HEAP8[($3 + 49 | 0) >> 0] = HEAPU8[($1 + 420 | 0) >> 0] | 0;
         cbor_event__se__Serializer_W___write_special__had0377f4ca98c84d($3 | 0, $2 | 0, $3 + 48 | 0 | 0);
         if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
          break label$4
         }
         i64toi32_i32$0 = HEAP32[($1 + 272 | 0) >> 2] | 0;
         i64toi32_i32$1 = HEAP32[($1 + 276 | 0) >> 2] | 0;
         i64toi32_i32$2 = i64toi32_i32$0;
         i64toi32_i32$0 = 0;
         if ((i64toi32_i32$2 | 0) == (1 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
          break label$3
         }
         HEAP8[($3 + 48 | 0) >> 0] = 1;
         cbor_event__se__Serializer_W___write_special__had0377f4ca98c84d($3 | 0, $2 | 0, $3 + 48 | 0 | 0);
         break label$2;
        }
        memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
        break label$1;
       }
       memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
       $4 = 1;
       break label$1;
      }
      memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
      break label$1;
     }
     memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
     $4 = 1;
     break label$1;
    }
    $cardano_serialization_lib__metadata__AuxiliaryData_20as_20cbor_event__se__Serialize___serialize__h6e246ec2e95d27d5($3 | 0, $1 + 280 | 0 | 0, $2 | 0);
   }
   $4 = 1;
   label$8 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
     break label$8
    }
    HEAP32[($0 + 4 | 0) >> 2] = $2;
    $4 = 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
  }
  HEAP32[$0 >> 2] = $4;
  global$0 = $3 + 64 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__TransactionOutput___serialize__h958522c662d822ef($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$4 = 0, $3 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, $4 = 0, $40 = 0, $45 = 0, $51 = 0, $55 = 0;
  $3 = global$0 - 80 | 0;
  global$0 = $3;
  i64toi32_i32$4 = HEAPU8[($1 + 88 | 0) >> 0] | 0;
  i64toi32_i32$3 = i64toi32_i32$4 ? 3 : 2;
  i64toi32_i32$2 = i64toi32_i32$4 ? 0 : 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, i64toi32_i32$3 | 0, i64toi32_i32$2 | 0);
  $4 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
        break label$5
       }
       cardano_serialization_lib__address__Address__to_bytes__h301d351bd02ea9f1($3 + 48 | 0 | 0, $1 | 0);
       cbor_event__se__Serializer_W___write_bytes__h935c22261c9a8184($3 | 0, $2 | 0, $3 + 48 | 0 | 0);
       if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
        break label$4
       }
       $cardano_serialization_lib__utils__Value_20as_20cbor_event__se__Serialize___serialize__hc37da84fe085e7b6($3 | 0, $1 + 64 | 0 | 0, $2 | 0);
       $4 = 1;
       if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
        break label$3
       }
       label$6 : {
        if (!(HEAPU8[($1 + 88 | 0) >> 0] | 0)) {
         break label$6
        }
        i64toi32_i32$4 = $1 + 113 | 0;
        i64toi32_i32$2 = HEAPU8[i64toi32_i32$4 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$4 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$4 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$4 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$3 = HEAPU8[(i64toi32_i32$4 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$4 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$4 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$4 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $40 = i64toi32_i32$2;
        i64toi32_i32$2 = $3 + 72 | 0;
        HEAP32[i64toi32_i32$2 >> 2] = $40;
        HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
        i64toi32_i32$4 = $1 + 105 | 0;
        i64toi32_i32$3 = HEAPU8[i64toi32_i32$4 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$4 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$4 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$4 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$2 = HEAPU8[(i64toi32_i32$4 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$4 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$4 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$4 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $45 = i64toi32_i32$3;
        i64toi32_i32$3 = $3 + 64 | 0;
        HEAP32[i64toi32_i32$3 >> 2] = $45;
        HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
        i64toi32_i32$4 = $1 + 97 | 0;
        i64toi32_i32$2 = HEAPU8[i64toi32_i32$4 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$4 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$4 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$4 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$3 = HEAPU8[(i64toi32_i32$4 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$4 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$4 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$4 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $51 = i64toi32_i32$2;
        i64toi32_i32$2 = ($3 + 48 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$2 >> 2] = $51;
        HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
        i64toi32_i32$4 = $1 + 89 | 0;
        i64toi32_i32$3 = HEAPU8[i64toi32_i32$4 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$4 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$4 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$4 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$2 = HEAPU8[(i64toi32_i32$4 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$4 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$4 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$4 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $55 = i64toi32_i32$3;
        i64toi32_i32$3 = $3;
        HEAP32[($3 + 48 | 0) >> 2] = $55;
        HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$2;
        cbor_event__se__Serializer_W___write_bytes__h85f4434ac9a8a060($3 | 0, $2 | 0, $3 + 48 | 0 | 0);
        $4 = 1;
        if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
         break label$2
        }
       }
       HEAP32[($0 + 4 | 0) >> 2] = $2;
       $4 = 0;
       break label$1;
      }
      memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
      break label$1;
     }
     memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
     $4 = 1;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
  }
  HEAP32[$0 >> 2] = $4;
  global$0 = $3 + 80 | 0;
 }
 
 function transactionoutputbuilder_with_data_hash($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $4 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $3 = 0, $5 = 0, $6 = 0, $46 = 0, $53 = 0, $60 = 0, $63 = 0, $82 = 0, $86 = 0, $90 = 0, $94 = 0;
  $2 = global$0 - 224 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hc81980191b5e557a($2 + 16 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 16 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hf03f8ea4201fce5b($2 + 8 | 0 | 0, $1 | 0);
   $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   label$2 : {
    label$3 : {
     if ((HEAPU8[$4 >> 0] | 0 | 0) != (5 | 0)) {
      break label$3
     }
     HEAP8[($2 + 120 | 0) >> 0] = 5;
     break label$2;
    }
    $cardano_serialization_lib__address__Address_20as_20core__clone__Clone___clone__h0eb465a6e349d507_1($2 + 120 | 0 | 0, $4 | 0);
   }
   memcpy($2 + 56 | 0 | 0, $2 + 120 | 0 | 0, 64 | 0) | 0;
   $4 = ($2 + 24 | 0) + 8 | 0;
   i64toi32_i32$2 = $0 + 8 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $46 = i64toi32_i32$0;
   i64toi32_i32$0 = $4;
   HEAP32[i64toi32_i32$0 >> 2] = $46;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   $5 = ($2 + 24 | 0) + 16 | 0;
   i64toi32_i32$2 = $0 + 16 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $53 = i64toi32_i32$1;
   i64toi32_i32$1 = $5;
   HEAP32[i64toi32_i32$1 >> 2] = $53;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   $6 = ($2 + 24 | 0) + 24 | 0;
   i64toi32_i32$2 = $0 + 24 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $60 = i64toi32_i32$0;
   i64toi32_i32$0 = $6;
   HEAP32[i64toi32_i32$0 >> 2] = $60;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $63 = i64toi32_i32$1;
   i64toi32_i32$1 = $2;
   HEAP32[($2 + 24 | 0) >> 2] = $63;
   HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
   memcpy($2 + 120 | 0 | 0, $2 + 56 | 0 | 0, 64 | 0) | 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
   $82 = i64toi32_i32$0;
   i64toi32_i32$0 = i64toi32_i32$2 + 185 | 0;
   $18 = $82;
   HEAP8[i64toi32_i32$0 >> 0] = $18;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $18 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $18 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $18 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = $4;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $86 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 193 | 0;
   $19 = $86;
   HEAP8[i64toi32_i32$1 >> 0] = $19;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $19 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $19 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $19 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $5;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $90 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 201 | 0;
   $20 = $90;
   HEAP8[i64toi32_i32$0 >> 0] = $20;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $20 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $20 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $20 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = $6;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $94 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 209 | 0;
   $21 = $94;
   HEAP8[i64toi32_i32$1 >> 0] = $21;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $21 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $21 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $21 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   HEAP8[($2 + 184 | 0) >> 0] = 1;
   $0 = $cardano_serialization_lib__output_builder__TransactionOutputBuilder_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h6f606fcbcfa27636($2 + 120 | 0 | 0) | 0;
   global$0 = $2 + 224 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__h79b90f2b969c0793($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $2 = 0, $5 = 0, $6 = 0, $22 = 0, $23 = 0, $24 = 0, $25 = 0, $26 = 0, $27 = 0, $4 = 0, $7 = 0, $8 = 0, $9 = 0, $37 = 0, $43 = 0, $53 = 0, $10 = 0, $71 = 0, $75 = 0, $79 = 0, $97 = 0, $108 = 0;
  $2 = global$0 - 96 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    $3 = HEAP32[$1 >> 2] | 0;
    if (($3 | 0) == (HEAP32[($1 + 4 | 0) >> 2] | 0 | 0)) {
     break label$2
    }
    HEAP32[$1 >> 2] = HEAP32[($3 + 20 | 0) >> 2] | 0;
    $4 = $1 + 8 | 0;
    $5 = HEAP32[$4 >> 2] | 0;
    $6 = $5 + -1 | 0;
    HEAP32[$4 >> 2] = $6;
    $7 = ($2 + 32 | 0) + 8 | 0;
    i64toi32_i32$2 = $3 + 33 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $37 = i64toi32_i32$0;
    i64toi32_i32$0 = $7;
    HEAP32[i64toi32_i32$0 >> 2] = $37;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    $8 = $2 + 48 | 0;
    i64toi32_i32$2 = $3 + 41 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $43 = i64toi32_i32$1;
    i64toi32_i32$1 = $8;
    HEAP32[i64toi32_i32$1 >> 2] = $43;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    $9 = $2 + 56 | 0;
    $22 = $3 + 49 | 0;
    HEAP32[$9 >> 2] = HEAPU8[$22 >> 0] | 0 | ((HEAPU8[($22 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($22 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($22 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$2 = $3 + 25 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $53 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] = $53;
    HEAP32[(i64toi32_i32$0 + 36 | 0) >> 2] = i64toi32_i32$1;
    $10 = HEAPU8[($3 + 24 | 0) >> 0] | 0;
    alloc__raw_vec__RawVec_T_2cA___allocate_in__h9fa2ec00e0b754b8(i64toi32_i32$0 + 8 | 0 | 0, ($5 >>> 0 < $6 >>> 0 ? -1 : $5) | 0, 0 | 0);
    $5 = HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] | 0;
    $3 = HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] | 0;
    HEAP8[$3 >> 0] = $10;
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
    $71 = i64toi32_i32$1;
    i64toi32_i32$1 = $3;
    $23 = $71;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $23;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $23 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $23 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = $23 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 8 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$2 = $7;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $75 = i64toi32_i32$0;
    i64toi32_i32$0 = $3 + 9 | 0;
    $24 = $75;
    HEAP8[i64toi32_i32$0 >> 0] = $24;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $24 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $24 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $24 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$2 = $8;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $79 = i64toi32_i32$1;
    i64toi32_i32$1 = $3 + 17 | 0;
    $25 = $79;
    HEAP8[i64toi32_i32$1 >> 0] = $25;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $25 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $25 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $25 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    $26 = $3 + 25 | 0;
    $27 = HEAP32[$9 >> 2] | 0;
    HEAP8[$26 >> 0] = $27;
    HEAP8[($26 + 1 | 0) >> 0] = $27 >>> 8 | 0;
    HEAP8[($26 + 2 | 0) >> 0] = $27 >>> 16 | 0;
    HEAP8[($26 + 3 | 0) >> 0] = $27 >>> 24 | 0;
    $6 = ($2 + 16 | 0) + 8 | 0;
    HEAP32[$6 >> 2] = 1;
    HEAP32[($2 + 20 | 0) >> 2] = $5;
    HEAP32[($2 + 16 | 0) >> 2] = $3;
    HEAP32[$7 >> 2] = HEAP32[$4 >> 2] | 0;
    i64toi32_i32$2 = $1;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $97 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] = $97;
    HEAP32[(i64toi32_i32$0 + 36 | 0) >> 2] = i64toi32_i32$1;
    alloc__vec__Vec_T_2cA___extend_desugared__he85f3b4fea67ba8b(i64toi32_i32$0 + 16 | 0 | 0, i64toi32_i32$0 + 32 | 0 | 0);
    HEAP32[($0 + 8 | 0) >> 2] = HEAP32[$6 >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] | 0;
    $108 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[i64toi32_i32$1 >> 2] = $108;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    break label$1;
   }
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = 0;
   HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[i64toi32_i32$1 >> 2] = HEAP32[(0 + 1067616 | 0) >> 2] | 0;
  }
  global$0 = $2 + 96 | 0;
 }
 
 function $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__hd8dacdd56da3a201($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $8 = 0, $2 = 0, $3 = 0, $22 = 0, $4 = 0, $23 = 0, $24 = 0, $25 = 0, $26 = 0, $27 = 0, $28 = 0, $29 = 0, $30 = 0, $31 = 0, $7 = 0, $5 = 0, $9 = 0, $32 = 0, $38 = 0, $55 = 0, $10 = 0, $10$hi = 0, $11 = 0, $11$hi = 0, $75 = 0, $100 = 0, $111 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    $3 = HEAP32[$1 >> 2] | 0;
    if (($3 | 0) != (HEAP32[($1 + 4 | 0) >> 2] | 0 | 0)) {
     break label$2
    }
    i64toi32_i32$1 = $0;
    i64toi32_i32$0 = 0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = 0;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[i64toi32_i32$1 >> 2] = HEAP32[(0 + 1067616 | 0) >> 2] | 0;
    break label$1;
   }
   HEAP32[$1 >> 2] = HEAP32[($3 + 412 | 0) >> 2] | 0;
   $4 = $2 + 41 | 0;
   i64toi32_i32$2 = $3 + 424 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $32 = i64toi32_i32$0;
   i64toi32_i32$0 = $4;
   $23 = $32;
   HEAP8[i64toi32_i32$0 >> 0] = $23;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $23 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $23 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $23 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   $5 = $2 + 49 | 0;
   i64toi32_i32$2 = $3 + 432 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $38 = i64toi32_i32$1;
   i64toi32_i32$1 = $5;
   $24 = $38;
   HEAP8[i64toi32_i32$1 >> 0] = $24;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $24 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $24 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $24 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   $25 = $3 + 440 | 0;
   $22 = $2 + 57 | 0;
   $26 = HEAPU8[$25 >> 0] | 0 | ((HEAPU8[($25 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($25 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($25 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[$22 >> 0] = $26;
   HEAP8[($22 + 1 | 0) >> 0] = $26 >>> 8 | 0;
   HEAP8[($22 + 2 | 0) >> 0] = $26 >>> 16 | 0;
   HEAP8[($22 + 3 | 0) >> 0] = $26 >>> 24 | 0;
   $7 = $1 + 8 | 0;
   $8 = HEAP32[$7 >> 2] | 0;
   $9 = $8 + -1 | 0;
   HEAP32[$7 >> 2] = $9;
   i64toi32_i32$2 = $3;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 416 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 417 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 418 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 419 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 420 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 421 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 422 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 423 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $55 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   $27 = $55;
   HEAP8[(i64toi32_i32$0 + 33 | 0) >> 0] = $27;
   HEAP8[(i64toi32_i32$0 + 34 | 0) >> 0] = $27 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 35 | 0) >> 0] = $27 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 36 | 0) >> 0] = $27 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 37 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 38 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 39 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 40 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   alloc__raw_vec__RawVec_T_2cA___allocate_in__h9cab6ad20a8290a4(i64toi32_i32$0 + 8 | 0 | 0, ($8 >>> 0 < $9 >>> 0 ? -1 : $8) | 0, 0 | 0);
   i64toi32_i32$2 = $4;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $10 = i64toi32_i32$1;
   $10$hi = i64toi32_i32$0;
   i64toi32_i32$2 = $5;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $11 = i64toi32_i32$0;
   $11$hi = i64toi32_i32$1;
   $8 = HEAPU8[$22 >> 0] | 0 | ((HEAPU8[($22 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($22 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($22 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $4 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 33 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 34 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 35 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 36 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 37 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 38 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 39 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 40 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $75 = i64toi32_i32$1;
   i64toi32_i32$1 = $3;
   $28 = $75;
   HEAP8[i64toi32_i32$1 >> 0] = $28;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $28 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $28 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $28 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   $29 = i64toi32_i32$1 + 24 | 0;
   HEAP8[$29 >> 0] = $8;
   HEAP8[($29 + 1 | 0) >> 0] = $8 >>> 8 | 0;
   HEAP8[($29 + 2 | 0) >> 0] = $8 >>> 16 | 0;
   HEAP8[($29 + 3 | 0) >> 0] = $8 >>> 24 | 0;
   i64toi32_i32$0 = $11$hi;
   i64toi32_i32$1 = i64toi32_i32$1 + 16 | 0;
   $30 = $11;
   HEAP8[i64toi32_i32$1 >> 0] = $30;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $30 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $30 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $30 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$0 = $10$hi;
   i64toi32_i32$1 = $3 + 8 | 0;
   $31 = $10;
   HEAP8[i64toi32_i32$1 >> 0] = $31;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $31 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $31 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $31 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   $8 = (i64toi32_i32$2 + 16 | 0) + 8 | 0;
   HEAP32[$8 >> 2] = 1;
   HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] = $4;
   HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] = $3;
   HEAP32[((i64toi32_i32$2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[$7 >> 2] | 0;
   i64toi32_i32$2 = $1;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $100 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] = $100;
   HEAP32[(i64toi32_i32$0 + 36 | 0) >> 2] = i64toi32_i32$1;
   alloc__vec__Vec_T_2cA___extend_desugared__hd6899c42a6b1599a(i64toi32_i32$0 + 16 | 0 | 0, i64toi32_i32$0 + 32 | 0 | 0);
   HEAP32[($0 + 8 | 0) >> 2] = HEAP32[$8 >> 2] | 0;
   i64toi32_i32$2 = i64toi32_i32$0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
   $111 = i64toi32_i32$1;
   i64toi32_i32$1 = $0;
   HEAP32[i64toi32_i32$1 >> 2] = $111;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  }
  global$0 = $2 + 64 | 0;
 }
 
 function dlmalloc__dlmalloc__Dlmalloc_A___release_unused_segments__h6fd37e9ed5a3fc9c() {
  var $4 = 0, $7 = 0, $1 = 0, $0 = 0, $3 = 0, $5 = 0, $6 = 0, $2 = 0, $8 = 0, $9 = 0, $10 = 0, $11 = 0, $12 = 0;
  label$1 : {
   $0 = HEAP32[(0 + 1178316 | 0) >> 2] | 0;
   if ($0) {
    break label$1
   }
   HEAP32[(0 + 1178332 | 0) >> 2] = 4095;
   return 0 | 0;
  }
  $1 = 1178308;
  $2 = 0;
  $3 = 0;
  label$2 : while (1) {
   $4 = $0;
   $0 = HEAP32[($4 + 8 | 0) >> 2] | 0;
   $5 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   $6 = HEAP32[$4 >> 2] | 0;
   label$3 : {
    label$4 : {
     if ($dlmalloc__sys__System_20as_20dlmalloc__Allocator___can_release_part__h23e00ec9580583cb(1177884 | 0, (HEAP32[($4 + 12 | 0) >> 2] | 0) >>> 1 | 0 | 0) | 0) {
      break label$4
     }
     $1 = $4;
     break label$3;
    }
    label$5 : {
     if (!(dlmalloc__dlmalloc__Segment__is_extern__hebd3849795a5a7f4($4 | 0) | 0)) {
      break label$5
     }
     $1 = $4;
     break label$3;
    }
    $7 = dlmalloc__dlmalloc__Chunk__to_mem__he3242996ca597cec($6 | 0) | 0;
    $7 = $6 + ((dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2($7 | 0, 8 | 0) | 0) - $7 | 0) | 0;
    $8 = dlmalloc__dlmalloc__Chunk__size__hbcf51483386243e4($7 | 0) | 0;
    $9 = dlmalloc__dlmalloc__Chunk__to_mem__he3242996ca597cec(0 | 0) | 0;
    $10 = dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2($9 | 0, 8 | 0) | 0;
    $11 = dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2(20 | 0, 8 | 0) | 0;
    $12 = dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2(16 | 0, 8 | 0) | 0;
    label$6 : {
     if (!(dlmalloc__dlmalloc__Chunk__inuse__h180ffa176be4dba6($7 | 0) | 0)) {
      break label$6
     }
     $1 = $4;
     break label$3;
    }
    label$7 : {
     if (($7 + $8 | 0) >>> 0 >= ($6 + (((($5 + $9 | 0) - $10 | 0) - $11 | 0) - $12 | 0) | 0) >>> 0) {
      break label$7
     }
     $1 = $4;
     break label$3;
    }
    label$8 : {
     label$9 : {
      if ((HEAP32[(0 + 1178292 | 0) >> 2] | 0 | 0) == ($7 | 0)) {
       break label$9
      }
      dlmalloc__dlmalloc__Dlmalloc_A___unlink_large_chunk__h107571aa99375aaf($7 | 0);
      break label$8;
     }
     HEAP32[(0 + 1178284 | 0) >> 2] = 0;
     HEAP32[(0 + 1178292 | 0) >> 2] = 0;
    }
    label$10 : {
     if ($dlmalloc__sys__System_20as_20dlmalloc__Allocator___free__h820779abf265185e(1177884 | 0, $6 | 0, $5 | 0) | 0) {
      break label$10
     }
     dlmalloc__dlmalloc__Dlmalloc_A___insert_large_chunk__h524840f32df7e3d2($7 | 0, $8 | 0);
     $1 = $4;
     break label$3;
    }
    HEAP32[(0 + 1178300 | 0) >> 2] = (HEAP32[(0 + 1178300 | 0) >> 2] | 0) - $5 | 0;
    HEAP32[($1 + 8 | 0) >> 2] = $0;
    $2 = $5 + $2 | 0;
   }
   $3 = $3 + 1 | 0;
   if ($0) {
    continue label$2
   }
   break label$2;
  };
  HEAP32[(0 + 1178332 | 0) >> 2] = $3 >>> 0 > 4095 >>> 0 ? $3 : 4095;
  return $2 | 0;
 }
 
 function block_new($0, $1, $2, $3, $4, $5) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  $5 = $5 | 0;
  var $6 = 0, $7 = 0, $8 = 0, $9 = 0, $10 = 0, i64toi32_i32$1 = 0;
  $6 = global$0 - 864 | 0;
  global$0 = $6;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h60ca34959655b0d6($6 + 24 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($6 + 28 | 0) >> 2] | 0;
   $7 = HEAP32[($6 + 24 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hfefec6c3ca92202d($6 + 16 | 0 | 0, $1 | 0);
   if (!$2) {
    break label$1
   }
   $1 = HEAP32[($6 + 20 | 0) >> 2] | 0;
   $8 = HEAP32[($6 + 16 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h0fe7af65622a319f($6 + 8 | 0 | 0, $2 | 0);
   if (!$3) {
    break label$1
   }
   $2 = HEAP32[($6 + 12 | 0) >> 2] | 0;
   $9 = HEAP32[($6 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h786c2d78691f35ff($6 | 0, $3 | 0);
   $3 = HEAP32[($6 + 4 | 0) >> 2] | 0;
   $10 = HEAP32[$6 >> 2] | 0;
   HEAP32[($6 + 464 | 0) >> 2] = $5;
   HEAP32[($6 + 460 | 0) >> 2] = $5;
   HEAP32[($6 + 456 | 0) >> 2] = $4;
   alloc__vec__Vec_T_2cA___shrink_to_fit__ha42fb43b13607cf8($6 + 456 | 0 | 0);
   alloc__slice__hack__into_vec__h7117771ce47e6987($6 + 440 | 0 | 0, HEAP32[($6 + 456 | 0) >> 2] | 0 | 0, HEAP32[($6 + 464 | 0) >> 2] | 0 | 0);
   HEAP32[(($6 + 456 | 0) + 8 | 0) >> 2] = HEAP32[(($6 + 440 | 0) + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($6 + 444 | 0) >> 2] | 0;
   HEAP32[($6 + 456 | 0) >> 2] = HEAP32[($6 + 440 | 0) >> 2] | 0;
   HEAP32[($6 + 460 | 0) >> 2] = i64toi32_i32$1;
   cardano_serialization_lib__Block__new__h40a5a6312a819cab($6 + 32 | 0 | 0, $7 | 0, $8 | 0, $9 | 0, $10 | 0, $6 + 456 | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   memcpy($6 + 456 | 0 | 0, $6 + 32 | 0 | 0, 408 | 0) | 0;
   $0 = $cardano_serialization_lib__Block_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h2c5c321414f91af3($6 + 456 | 0 | 0) | 0;
   global$0 = $6 + 864 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function cbor_event__de__Deserializer_R___map__h7c2a4e830d885a05($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$5 = 0, $3 = 0, $7 = 0, $7$hi = 0, $4 = 0, $5 = 0, $6 = 0, $8 = 0, $8$hi = 0, $9 = 0, $9$hi = 0, i64toi32_i32$4 = 0, $50 = 0, $56 = 0, $74 = 0, $76$hi = 0, $79$hi = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 8 | 0 | 0, $1 | 0);
  $3 = 8;
  label$1 : {
   label$2 : {
    label$3 : {
     $4 = HEAP32[($2 + 12 | 0) >> 2] | 0;
     if ($4) {
      break label$3
     }
     break label$2;
    }
    $5 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    if (!$5) {
     break label$2
    }
    $3 = 9;
    $6 = ($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[$5 >> 0] | 0 | 0) | 0) & 255 | 0;
    if (($6 | 0) != (5 | 0)) {
     break label$2
    }
    cbor_event__de__Deserializer_R___cbor_len__h852681e444aca076_1($2 + 16 | 0 | 0, $1 | 0);
    i64toi32_i32$0 = 0;
    $7 = 1;
    $7$hi = i64toi32_i32$0;
    $3 = HEAP32[(($2 + 16 | 0) + 24 | 0) >> 2] | 0;
    i64toi32_i32$2 = ($2 + 16 | 0) + 16 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $8 = i64toi32_i32$0;
    $8$hi = i64toi32_i32$1;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
    $9 = i64toi32_i32$1;
    $9$hi = i64toi32_i32$0;
    label$4 : {
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
     i64toi32_i32$2 = i64toi32_i32$0;
     i64toi32_i32$0 = 0;
     i64toi32_i32$3 = 1;
     if ((i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$0 | 0) | 0) {
      break label$4
     }
     i64toi32_i32$3 = ($2 + 16 | 0) + 32 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $50 = i64toi32_i32$2;
     i64toi32_i32$2 = $0 + 32 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $50;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$3 = ($2 + 16 | 0) + 40 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $56 = i64toi32_i32$1;
     i64toi32_i32$1 = $0 + 40 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $56;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
     HEAP32[($0 + 28 | 0) >> 2] = HEAP32[($2 + 44 | 0) >> 2] | 0;
     HEAP32[($0 + 24 | 0) >> 2] = $3;
     i64toi32_i32$2 = $8$hi;
     i64toi32_i32$1 = $0 + 16 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $8;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$2 = $9$hi;
     i64toi32_i32$1 = $0;
     HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $9;
     HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$2;
     break label$1;
    }
    i64toi32_i32$2 = $9$hi;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $9;
    HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $8$hi;
    i64toi32_i32$1 = i64toi32_i32$1 + 16 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $8;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
    $74 = $1;
    i64toi32_i32$3 = $1;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $76$hi = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    $79$hi = i64toi32_i32$1;
    i64toi32_i32$1 = $76$hi;
    i64toi32_i32$3 = i64toi32_i32$2;
    i64toi32_i32$2 = $79$hi;
    i64toi32_i32$0 = $3 + 1 | 0;
    i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
    i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
    if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
     i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
    }
    i64toi32_i32$3 = $74;
    HEAP32[i64toi32_i32$3 >> 2] = i64toi32_i32$4;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
    i64toi32_i32$5 = 0;
    $7 = 0;
    $7$hi = i64toi32_i32$5;
    break label$1;
   }
   HEAP8[($0 + 8 | 0) >> 0] = $3;
   HEAP32[($0 + 16 | 0) >> 2] = 0;
   HEAP32[($0 + 12 | 0) >> 2] = $4;
   HEAP8[($0 + 10 | 0) >> 0] = $6;
   HEAP8[($0 + 9 | 0) >> 0] = 5;
   i64toi32_i32$5 = 0;
   $7 = 1;
   $7$hi = i64toi32_i32$5;
  }
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$3 = $0;
  HEAP32[$0 >> 2] = $7;
  HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$5;
  global$0 = $2 + 64 | 0;
 }
 
 function cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$5 = 0, $3 = 0, $7 = 0, $7$hi = 0, $4 = 0, $5 = 0, $6 = 0, $8 = 0, $8$hi = 0, $9 = 0, $9$hi = 0, i64toi32_i32$4 = 0, $50 = 0, $56 = 0, $74 = 0, $76$hi = 0, $79$hi = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($2 + 8 | 0 | 0, $1 | 0);
  $3 = 8;
  label$1 : {
   label$2 : {
    label$3 : {
     $4 = HEAP32[($2 + 12 | 0) >> 2] | 0;
     if ($4) {
      break label$3
     }
     break label$2;
    }
    $5 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    if (!$5) {
     break label$2
    }
    $3 = 9;
    $6 = ($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[$5 >> 0] | 0 | 0) | 0) & 255 | 0;
    if (($6 | 0) != (4 | 0)) {
     break label$2
    }
    cbor_event__de__Deserializer_R___cbor_len__h852681e444aca076_1($2 + 16 | 0 | 0, $1 | 0);
    i64toi32_i32$0 = 0;
    $7 = 1;
    $7$hi = i64toi32_i32$0;
    $3 = HEAP32[(($2 + 16 | 0) + 24 | 0) >> 2] | 0;
    i64toi32_i32$2 = ($2 + 16 | 0) + 16 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $8 = i64toi32_i32$0;
    $8$hi = i64toi32_i32$1;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
    $9 = i64toi32_i32$1;
    $9$hi = i64toi32_i32$0;
    label$4 : {
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
     i64toi32_i32$2 = i64toi32_i32$0;
     i64toi32_i32$0 = 0;
     i64toi32_i32$3 = 1;
     if ((i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$0 | 0) | 0) {
      break label$4
     }
     i64toi32_i32$3 = ($2 + 16 | 0) + 32 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $50 = i64toi32_i32$2;
     i64toi32_i32$2 = $0 + 32 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $50;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$3 = ($2 + 16 | 0) + 40 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $56 = i64toi32_i32$1;
     i64toi32_i32$1 = $0 + 40 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $56;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
     HEAP32[($0 + 28 | 0) >> 2] = HEAP32[($2 + 44 | 0) >> 2] | 0;
     HEAP32[($0 + 24 | 0) >> 2] = $3;
     i64toi32_i32$2 = $8$hi;
     i64toi32_i32$1 = $0 + 16 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $8;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$2 = $9$hi;
     i64toi32_i32$1 = $0;
     HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $9;
     HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$2;
     break label$1;
    }
    i64toi32_i32$2 = $9$hi;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $9;
    HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $8$hi;
    i64toi32_i32$1 = i64toi32_i32$1 + 16 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $8;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
    $74 = $1;
    i64toi32_i32$3 = $1;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $76$hi = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    $79$hi = i64toi32_i32$1;
    i64toi32_i32$1 = $76$hi;
    i64toi32_i32$3 = i64toi32_i32$2;
    i64toi32_i32$2 = $79$hi;
    i64toi32_i32$0 = $3 + 1 | 0;
    i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
    i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
    if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
     i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
    }
    i64toi32_i32$3 = $74;
    HEAP32[i64toi32_i32$3 >> 2] = i64toi32_i32$4;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
    i64toi32_i32$5 = 0;
    $7 = 0;
    $7$hi = i64toi32_i32$5;
    break label$1;
   }
   HEAP8[($0 + 8 | 0) >> 0] = $3;
   HEAP32[($0 + 16 | 0) >> 2] = 0;
   HEAP32[($0 + 12 | 0) >> 2] = $4;
   HEAP8[($0 + 10 | 0) >> 0] = $6;
   HEAP8[($0 + 9 | 0) >> 0] = 4;
   i64toi32_i32$5 = 0;
   $7 = 1;
   $7$hi = i64toi32_i32$5;
  }
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$3 = $0;
  HEAP32[$0 >> 2] = $7;
  HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$5;
  global$0 = $2 + 64 | 0;
 }
 
 function cbor_event__de__Deserializer_R___array__h65719d950308186c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$5 = 0, $3 = 0, $7 = 0, $7$hi = 0, $4 = 0, $5 = 0, $6 = 0, $8 = 0, $8$hi = 0, $9 = 0, $9$hi = 0, i64toi32_i32$4 = 0, $50 = 0, $56 = 0, $74 = 0, $76$hi = 0, $79$hi = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  std__io__cursor__Cursor_T___remaining_slice__h5de2a0dd397eef35($2 + 8 | 0 | 0, $1 | 0);
  $3 = 8;
  label$1 : {
   label$2 : {
    label$3 : {
     $4 = HEAP32[($2 + 12 | 0) >> 2] | 0;
     if ($4) {
      break label$3
     }
     break label$2;
    }
    $5 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    if (!$5) {
     break label$2
    }
    $3 = 9;
    $6 = ($cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be(HEAPU8[$5 >> 0] | 0 | 0) | 0) & 255 | 0;
    if (($6 | 0) != (4 | 0)) {
     break label$2
    }
    cbor_event__de__Deserializer_R___cbor_len__hc68764db78e73af0($2 + 16 | 0 | 0, $1 | 0);
    i64toi32_i32$0 = 0;
    $7 = 1;
    $7$hi = i64toi32_i32$0;
    $3 = HEAP32[(($2 + 16 | 0) + 24 | 0) >> 2] | 0;
    i64toi32_i32$2 = ($2 + 16 | 0) + 16 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $8 = i64toi32_i32$0;
    $8$hi = i64toi32_i32$1;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
    $9 = i64toi32_i32$1;
    $9$hi = i64toi32_i32$0;
    label$4 : {
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
     i64toi32_i32$2 = i64toi32_i32$0;
     i64toi32_i32$0 = 0;
     i64toi32_i32$3 = 1;
     if ((i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$0 | 0) | 0) {
      break label$4
     }
     i64toi32_i32$3 = ($2 + 16 | 0) + 32 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $50 = i64toi32_i32$2;
     i64toi32_i32$2 = $0 + 32 | 0;
     HEAP32[i64toi32_i32$2 >> 2] = $50;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$3 = ($2 + 16 | 0) + 40 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $56 = i64toi32_i32$1;
     i64toi32_i32$1 = $0 + 40 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $56;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
     HEAP32[($0 + 28 | 0) >> 2] = HEAP32[($2 + 44 | 0) >> 2] | 0;
     HEAP32[($0 + 24 | 0) >> 2] = $3;
     i64toi32_i32$2 = $8$hi;
     i64toi32_i32$1 = $0 + 16 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $8;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$2 = $9$hi;
     i64toi32_i32$1 = $0;
     HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $9;
     HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$2;
     break label$1;
    }
    i64toi32_i32$2 = $9$hi;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $9;
    HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $8$hi;
    i64toi32_i32$1 = i64toi32_i32$1 + 16 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $8;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
    $74 = $1;
    i64toi32_i32$3 = $1;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $76$hi = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    $79$hi = i64toi32_i32$1;
    i64toi32_i32$1 = $76$hi;
    i64toi32_i32$3 = i64toi32_i32$2;
    i64toi32_i32$2 = $79$hi;
    i64toi32_i32$0 = $3 + 1 | 0;
    i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
    i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
    if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
     i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
    }
    i64toi32_i32$3 = $74;
    HEAP32[i64toi32_i32$3 >> 2] = i64toi32_i32$4;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$5;
    i64toi32_i32$5 = 0;
    $7 = 0;
    $7$hi = i64toi32_i32$5;
    break label$1;
   }
   HEAP8[($0 + 8 | 0) >> 0] = $3;
   HEAP32[($0 + 16 | 0) >> 2] = 0;
   HEAP32[($0 + 12 | 0) >> 2] = $4;
   HEAP8[($0 + 10 | 0) >> 0] = $6;
   HEAP8[($0 + 9 | 0) >> 0] = 4;
   i64toi32_i32$5 = 0;
   $7 = 1;
   $7$hi = i64toi32_i32$5;
  }
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$3 = $0;
  HEAP32[$0 >> 2] = $7;
  HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$5;
  global$0 = $2 + 64 | 0;
 }
 
 function alloc__slice__merge__ha271ef597e06aa80($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, $6 = 0, $7 = 0, $9 = 0, $8 = 0;
  $5 = $2 << 7 | 0;
  $6 = $0 + $5 | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     $7 = $1 - $2 | 0;
     if ($7 >>> 0 >= $2 >>> 0) {
      break label$3
     }
     $5 = $7 << 7 | 0;
     $8 = memcpy($3 | 0, $6 | 0, $5 | 0) | 0;
     $5 = $8 + $5 | 0;
     if (($2 | 0) < (1 | 0)) {
      break label$2
     }
     if (($7 | 0) < (1 | 0)) {
      break label$2
     }
     $9 = (($1 << 7 | 0) + $0 | 0) + -128 | 0;
     label$4 : while (1) {
      $2 = $6 + -128 | 0;
      $1 = $5 + -128 | 0;
      $7 = alloc__slice___impl_20_5bT_5d___sort_by_key___7b_7bclosure_7d_7d__h5570c792610ff4df($4 | 0, $1 | 0, $2 | 0) | 0;
      $9 = memcpy($9 | 0, ($7 ? $2 : $1) | 0, 128 | 0) | 0;
      $5 = $7 ? $5 : $1;
      $6 = $7 ? $2 : $6;
      if ($0 >>> 0 >= $6 >>> 0) {
       break label$2
      }
      $9 = $9 + -128 | 0;
      if ($5 >>> 0 <= $8 >>> 0) {
       break label$2
      }
      continue label$4;
     };
    }
    $5 = (memcpy($3 | 0, $0 | 0, $5 | 0) | 0) + $5 | 0;
    if (($1 | 0) <= ($2 | 0)) {
     break label$1
    }
    if (($2 | 0) < (1 | 0)) {
     break label$1
    }
    $7 = $0 + ($1 << 7 | 0) | 0;
    label$5 : while (1) {
     $2 = alloc__slice___impl_20_5bT_5d___sort_by_key___7b_7bclosure_7d_7d__h5570c792610ff4df($4 | 0, $6 | 0, $3 | 0) | 0;
     $1 = $2 ? $6 : $3;
     $3 = $2 ? $3 : $3 + 128 | 0;
     $0 = (memcpy($0 | 0, $1 | 0, 128 | 0) | 0) + 128 | 0;
     $6 = $2 ? $6 + 128 | 0 : $6;
     if ($6 >>> 0 >= $7 >>> 0) {
      break label$1
     }
     if ($3 >>> 0 < $5 >>> 0) {
      continue label$5
     }
     break label$1;
    };
   }
   $0 = $6;
  }
  memcpy($0 | 0, $3 | 0, ($5 - $3 | 0) & -128 | 0 | 0) | 0;
 }
 
 function $cardano_serialization_lib__plutus__PlutusList_20as_20cbor_event__se__Serialize___serialize__h4fb04398ef3c9f58($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, $5 = 0, i64toi32_i32$0 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $3 = global$0 - 64 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         $4 = HEAPU8[($1 + 12 | 0) >> 0] | 0;
         if (($4 & 3 | 0 | 0) == (3 | 0)) {
          break label$7
         }
         switch ($4 | 0) {
         case 2:
          break label$6;
         case 1:
          break label$7;
         default:
          break label$4;
         };
        }
        $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
        break label$5;
       }
       $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
       if ($4) {
        break label$3
       }
       $4 = 0;
      }
      i64toi32_i32$0 = 0;
      cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, $4 | 0, i64toi32_i32$0 | 0);
      $5 = 1;
      if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
       break label$2
      }
      memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
      $1 = 1;
      break label$1;
     }
     $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    }
    (wasm2js_i32$0 = $3, wasm2js_i32$1 = cbor_event__types__Type__to_byte__h30363627277739c1(4 | 0, 31 | 0) | 0), HEAP8[wasm2js_i32$0 >> 0] = wasm2js_i32$1;
    alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($2 | 0, $3 | 0, 1 | 0);
    $5 = 0;
   }
   label$8 : {
    label$9 : {
     label$10 : {
      label$11 : {
       if (!$4) {
        break label$11
       }
       $1 = HEAP32[$1 >> 2] | 0;
       $4 = Math_imul($4, 48);
       label$12 : while (1) {
        $cardano_serialization_lib__plutus__PlutusData_20as_20cbor_event__se__Serialize___serialize__hbd5d6a191345a7d0($3 | 0, $1 | 0, $2 | 0);
        if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
         break label$10
        }
        $1 = $1 + 48 | 0;
        $4 = $4 + -48 | 0;
        if ($4) {
         continue label$12
        }
        break label$12;
       };
      }
      if (!$5) {
       break label$9
      }
      break label$8;
     }
     memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
     $1 = 1;
     break label$1;
    }
    HEAP8[($3 + 48 | 0) >> 0] = 5;
    cbor_event__se__Serializer_W___write_special__had0377f4ca98c84d($3 | 0, $2 | 0, $3 + 48 | 0 | 0);
    $1 = 1;
    if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
     break label$8
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    break label$1;
   }
   HEAP32[($0 + 4 | 0) >> 2] = $2;
   $1 = 0;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $3 + 64 | 0;
 }
 
 function $cryptoxide__poly1305__Poly1305_20as_20cryptoxide__mac__Mac___input__h2055bc09e473001f($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $4 = 0, i64toi32_i32$2 = 0, $5 = 0, $3 = 0, i64toi32_i32$0 = 0, $6 = 0, i64toi32_i32$1 = 0, $7 = 0, $64 = 0, $67 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     if (HEAPU8[($0 + 76 | 0) >> 0] | 0) {
      break label$3
     }
     label$4 : {
      label$5 : {
       $4 = HEAP32[($0 + 56 | 0) >> 2] | 0;
       if (!$4) {
        break label$5
       }
       label$6 : {
        $5 = 16 - $4 | 0;
        $6 = $5 >>> 0 > $2 >>> 0 ? $2 : $5;
        if (!$6) {
         break label$6
        }
        $7 = $0 + 60 | 0;
        $4 = 0;
        label$7 : while (1) {
         if (($2 | 0) == ($4 | 0)) {
          break label$2
         }
         $5 = $4 + (HEAP32[($0 + 56 | 0) >> 2] | 0) | 0;
         if ($5 >>> 0 >= 16 >>> 0) {
          break label$1
         }
         HEAP8[($7 + $5 | 0) >> 0] = HEAPU8[($1 + $4 | 0) >> 0] | 0;
         $5 = $4 + 1 | 0;
         $4 = $5;
         if (($6 | 0) != ($4 | 0)) {
          continue label$7
         }
         break label$7;
        };
        $4 = HEAP32[($0 + 56 | 0) >> 2] | 0;
       }
       $4 = $4 + $6 | 0;
       HEAP32[($0 + 56 | 0) >> 2] = $4;
       if ($4 >>> 0 < 16 >>> 0) {
        break label$4
       }
       i64toi32_i32$2 = $0 + 68 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $64 = i64toi32_i32$0;
       i64toi32_i32$0 = $3 + 8 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $64;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $0;
       i64toi32_i32$1 = HEAPU8[($0 + 60 | 0) >> 0] | 0 | ((HEAPU8[($0 + 61 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($0 + 62 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($0 + 63 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[($0 + 64 | 0) >> 0] | 0 | ((HEAPU8[($0 + 65 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($0 + 66 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($0 + 67 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $67 = i64toi32_i32$1;
       i64toi32_i32$1 = $3;
       HEAP32[$3 >> 2] = $67;
       HEAP32[($3 + 4 | 0) >> 2] = i64toi32_i32$0;
       cryptoxide__poly1305__Poly1305__block__h169ca472edf19e75($0 | 0, $3 | 0, 16 | 0);
       HEAP32[($0 + 56 | 0) >> 2] = 0;
       $2 = $2 - $6 | 0;
       $1 = $1 + $6 | 0;
      }
      label$8 : {
       if ($2 >>> 0 < 16 >>> 0) {
        break label$8
       }
       label$9 : while (1) {
        cryptoxide__poly1305__Poly1305__block__h169ca472edf19e75($0 | 0, $1 | 0, 16 | 0);
        $1 = $1 + 16 | 0;
        $2 = $2 + -16 | 0;
        if ($2 >>> 0 > 15 >>> 0) {
         continue label$9
        }
        break label$9;
       };
      }
      memcpy($0 + 60 | 0 | 0, $1 | 0, $2 | 0) | 0;
      HEAP32[($0 + 56 | 0) >> 2] = $2;
     }
     global$0 = $3 + 16 | 0;
     return;
    }
    core__panicking__panic__h2fd385a887c8bf13(1137580 | 0, 33 | 0, 1137616 | 0);
    abort();
   }
   core__panicking__panic_bounds_check__h808b524af17640b1($2 | 0, $2 | 0, 1137632 | 0);
   abort();
  }
  core__panicking__panic_bounds_check__h808b524af17640b1($5 | 0, 16 | 0, 1137648 | 0);
  abort();
 }
 
 function cardano_serialization_lib__tx_builder__TransactionBuilder__build__h1126ee00e4941d94($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $58 = 0, $63 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 624 | 0;
  global$0 = $2;
  cardano_serialization_lib__tx_builder__TransactionBuilder__build_and_size__h9094c1e3b4ead95a($2 + 304 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ((HEAP32[($2 + 304 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      memcpy($2 + 32 | 0 | 0, ($2 + 304 | 0) + 8 | 0 | 0, 272 | 0) | 0;
      $3 = HEAP32[($2 + 584 | 0) >> 2] | 0;
      memcpy($2 + 304 | 0 | 0, $2 + 32 | 0 | 0, 272 | 0) | 0;
      HEAP32[($2 + 28 | 0) >> 2] = $3;
      if ($3 >>> 0 > (HEAP32[($1 + 84 | 0) >> 2] | 0) >>> 0) {
       break label$3
      }
      memcpy($0 + 8 | 0 | 0, $2 + 304 | 0 | 0, 272 | 0) | 0;
      $1 = 0;
      break label$2;
     }
     $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($2 + 308 | 0) >> 2] | 0 | 0) | 0;
     HEAP32[$0 >> 2] = 1;
     HEAP32[($0 + 4 | 0) >> 2] = $1;
     break label$1;
    }
    core__fmt__ArgumentV1__new__hfe8bfc123be7fc32($2 + 16 | 0 | 0, $1 + 84 | 0 | 0, 46 | 0);
    i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
    core__fmt__ArgumentV1__new__h5702524f4c8ddc75($2 + 8 | 0 | 0, $2 + 28 | 0 | 0, 46 | 0);
    HEAP32[($2 + 52 | 0) >> 2] = 2;
    $58 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[($2 + 608 | 0) >> 2] = $58;
    HEAP32[($2 + 612 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$0 = $2;
    i64toi32_i32$1 = 0;
    HEAP32[($2 + 36 | 0) >> 2] = 2;
    HEAP32[($2 + 40 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($2 + 32 | 0) >> 2] = 1065660;
    i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $63 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 616 | 0) >> 2] = $63;
    HEAP32[($2 + 620 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($2 + 48 | 0) >> 2] = $2 + 608 | 0;
    alloc__fmt__format__h6e9e003a52c07309($2 + 592 | 0 | 0, $2 + 32 | 0 | 0);
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 | 0, $2 + 592 | 0 | 0);
    (wasm2js_i32$0 = $0, wasm2js_i32$1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 592 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 592 | 0 | 0);
    core__ptr__drop_in_place_cardano_serialization_lib__TransactionBody___h9274013021a1d568($2 + 304 | 0 | 0);
    $1 = 1;
   }
   HEAP32[$0 >> 2] = $1;
  }
  global$0 = $2 + 624 | 0;
 }
 
 function pointeraddress_to_address($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $21 = 0, $8 = 0, $3 = 0, $4 = 0, $5 = 0, $8$hi = 0, $7 = 0, $22 = 0, $23 = 0, $24 = 0, $25 = 0, $26 = 0, $2 = 0, $30 = 0, $37 = 0, $6 = 0, $9 = 0, $9$hi = 0, $72 = 0, $85 = 0, $90 = 0, $95 = 0;
  $1 = global$0 - 144 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h8caae7a957e11e51($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $2 = HEAPU8[($0 + 24 | 0) >> 0] | 0;
  $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $4 = ($1 + 16 | 0) + 8 | 0;
  i64toi32_i32$2 = $0 + 34 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[i64toi32_i32$0 >> 2] = $30;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $5 = ($1 + 16 | 0) + 16 | 0;
  i64toi32_i32$2 = $0 + 42 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $37 = i64toi32_i32$1;
  i64toi32_i32$1 = $5;
  HEAP32[i64toi32_i32$1 >> 2] = $37;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $0 + 26 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  $6 = HEAPU8[($0 + 25 | 0) >> 0] | 0;
  $7 = ($1 + 16 | 0) + 24 | 0;
  $21 = $0 + 50 | 0;
  HEAP32[$7 >> 2] = HEAPU8[$21 >> 0] | 0 | ((HEAPU8[($21 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($21 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($21 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = $1;
  HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$1;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $9 = i64toi32_i32$0;
  $9$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP8[($1 + 113 | 0) >> 0] = $6;
  HEAP8[($1 + 112 | 0) >> 0] = $2;
  $72 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 80 | 0) + 24 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $72;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$1 = ($1 + 80 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $9;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$1 = ($1 + 80 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $8;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $85 = i64toi32_i32$0;
  i64toi32_i32$0 = (i64toi32_i32$2 + 80 | 0) + 34 | 0;
  $22 = $85;
  HEAP16[i64toi32_i32$0 >> 1] = $22;
  HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $22 >>> 16 | 0;
  HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$1;
  HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $90 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 80 | 0) + 42 | 0;
  $23 = $90;
  HEAP16[i64toi32_i32$1 >> 1] = $23;
  HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $23 >>> 16 | 0;
  HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = i64toi32_i32$0;
  HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $95 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 80 | 0) + 50 | 0;
  $24 = $95;
  HEAP16[i64toi32_i32$0 >> 1] = $24;
  HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $24 >>> 16 | 0;
  HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$1;
  HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
  $25 = $1 + 138 | 0;
  $26 = HEAP32[$7 >> 2] | 0;
  HEAP16[$25 >> 1] = $26;
  HEAP16[($25 + 2 | 0) >> 1] = $26 >>> 16 | 0;
  HEAP8[($1 + 80 | 0) >> 0] = 1;
  $0 = $cardano_serialization_lib__address__Address_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8ce30e61cf34786e($1 + 80 | 0 | 0) | 0;
  global$0 = $1 + 144 | 0;
  return $0 | 0;
 }
 
 function dlmalloc__dlmalloc__Dlmalloc_A___insert_large_chunk__h524840f32df7e3d2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0;
  $2 = 0;
  label$1 : {
   $3 = $1 >>> 8 | 0;
   if (!$3) {
    break label$1
   }
   $2 = 31;
   if ($1 >>> 0 > 16777215 >>> 0) {
    break label$1
   }
   $2 = Math_clz32($3);
   $2 = ((($1 >>> ((6 - $2 | 0) & 31 | 0) | 0) & 1 | 0) - ($2 << 1 | 0) | 0) + 62 | 0;
  }
  HEAP32[($0 + 16 | 0) >> 2] = 0;
  HEAP32[($0 + 20 | 0) >> 2] = 0;
  HEAP32[($0 + 28 | 0) >> 2] = $2;
  $3 = ($2 << 2 | 0) + 1178156 | 0;
  $4 = dlmalloc__dlmalloc__TreeChunk__chunk__h93f52b5b19dc8e79($0 | 0) | 0;
  label$2 : {
   label$3 : {
    label$4 : {
     label$5 : {
      label$6 : {
       $5 = HEAP32[(0 + 1177888 | 0) >> 2] | 0;
       $6 = 1 << ($2 & 31 | 0) | 0;
       if (!($5 & $6 | 0)) {
        break label$6
       }
       $5 = HEAP32[$3 >> 2] | 0;
       $2 = dlmalloc__dlmalloc__leftshift_for_tree_index__hd82124830437cc05($2 | 0) | 0;
       if ((dlmalloc__dlmalloc__Chunk__size__hbcf51483386243e4(dlmalloc__dlmalloc__TreeChunk__chunk__h93f52b5b19dc8e79($5 | 0) | 0 | 0) | 0 | 0) != ($1 | 0)) {
        break label$5
       }
       $2 = $5;
       break label$4;
      }
      HEAP32[(0 + 1177888 | 0) >> 2] = $5 | $6 | 0;
      HEAP32[$3 >> 2] = $0;
      HEAP32[($0 + 24 | 0) >> 2] = $3;
      break label$2;
     }
     $3 = $1 << ($2 & 31 | 0) | 0;
     label$7 : while (1) {
      $6 = ($5 + (($3 >>> 29 | 0) & 4 | 0) | 0) + 16 | 0;
      $2 = HEAP32[$6 >> 2] | 0;
      if (!$2) {
       break label$3
      }
      $3 = $3 << 1 | 0;
      $5 = $2;
      if ((dlmalloc__dlmalloc__Chunk__size__hbcf51483386243e4(dlmalloc__dlmalloc__TreeChunk__chunk__h93f52b5b19dc8e79($2 | 0) | 0 | 0) | 0 | 0) != ($1 | 0)) {
       continue label$7
      }
      break label$7;
     };
    }
    $2 = dlmalloc__dlmalloc__TreeChunk__chunk__h93f52b5b19dc8e79($2 | 0) | 0;
    $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    HEAP32[($3 + 12 | 0) >> 2] = $4;
    HEAP32[($2 + 8 | 0) >> 2] = $4;
    HEAP32[($4 + 12 | 0) >> 2] = $2;
    HEAP32[($4 + 8 | 0) >> 2] = $3;
    HEAP32[($0 + 24 | 0) >> 2] = 0;
    return;
   }
   HEAP32[$6 >> 2] = $0;
   HEAP32[($0 + 24 | 0) >> 2] = $5;
  }
  HEAP32[($4 + 8 | 0) >> 2] = $4;
  HEAP32[($4 + 12 | 0) >> 2] = $4;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert__h8e1c603097dda825($0, $1, $2, $3, $3$hi, $4, $5) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  $4 = $4 | 0;
  $5 = $5 | 0;
  var $6 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $7 = 0, $8 = 0, $85 = 0, $90 = 0, $95 = 0, $99 = 0;
  $6 = global$0 - 48 | 0;
  global$0 = $6;
  label$1 : {
   label$2 : {
    $7 = HEAP32[$1 >> 2] | 0;
    if (($7 + -1 | 0 | 0) != ($4 | 0)) {
     break label$2
    }
    label$3 : {
     label$4 : {
      label$5 : {
       $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
       if ((HEAPU16[($4 + 138 | 0) >> 1] | 0) >>> 0 < 11 >>> 0) {
        break label$5
       }
       alloc__collections__btree__node__splitpoint__h8424344594b4deb1($6 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
       $1 = HEAP32[($6 + 8 | 0) >> 2] | 0;
       $8 = HEAP32[($6 + 4 | 0) >> 2] | 0;
       HEAP32[($6 + 40 | 0) >> 2] = HEAP32[$6 >> 2] | 0;
       HEAP32[($6 + 36 | 0) >> 2] = $4;
       HEAP32[($6 + 32 | 0) >> 2] = $7;
       alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__KV___split__hc11226674436e4b6($6 | 0, $6 + 32 | 0 | 0);
       if (($8 | 0) == (1 | 0)) {
        break label$4
       }
       HEAP32[($6 + 32 | 0) >> 2] = HEAP32[($6 + 16 | 0) >> 2] | 0;
       $4 = HEAP32[($6 + 20 | 0) >> 2] | 0;
       break label$3;
      }
      i64toi32_i32$0 = $3$hi;
      alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert_fit__hf761376107f46326($1 | 0, $2 | 0, $3 | 0, i64toi32_i32$0 | 0, $6 | 0, $5 | 0);
      HEAP32[($0 + 8 | 0) >> 2] = $4;
      HEAP32[($0 + 4 | 0) >> 2] = $7;
      HEAP32[$0 >> 2] = 0;
      HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
      break label$1;
     }
     HEAP32[($6 + 32 | 0) >> 2] = HEAP32[($6 + 24 | 0) >> 2] | 0;
     $4 = HEAP32[($6 + 28 | 0) >> 2] | 0;
    }
    HEAP32[($6 + 40 | 0) >> 2] = $1;
    HEAP32[($6 + 36 | 0) >> 2] = $4;
    i64toi32_i32$0 = $3$hi;
    alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert_fit__hf761376107f46326($6 + 32 | 0 | 0, $2 | 0, $3 | 0, i64toi32_i32$0 | 0, $6 | 0, $5 | 0);
    HEAP32[$0 >> 2] = 1;
    i64toi32_i32$2 = $6 + 24 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $85 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 32 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $85;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $6 + 16 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $90 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 24 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $90;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $6 + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $95 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $95;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $6;
    i64toi32_i32$1 = HEAP32[$6 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($6 + 4 | 0) >> 2] | 0;
    $99 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $99;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    break label$1;
   }
   core__panicking__panic__h2fd385a887c8bf13(1049076 | 0, 53 | 0, 1049132 | 0);
   abort();
  }
  global$0 = $6 + 48 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert_fit__hf761376107f46326($0, $1, $2, $2$hi, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, $8 = 0, $9 = 0, $6 = 0, $7 = 0, $10 = 0, $11 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0;
  $5 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $0 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  $6 = $0 << 2 | 0;
  $7 = ($5 + $6 | 0) + 92 | 0;
  label$1 : {
   label$2 : {
    $8 = $0 + 1 | 0;
    $9 = HEAPU16[($5 + 138 | 0) >> 1] | 0;
    if ($8 >>> 0 <= $9 >>> 0) {
     break label$2
    }
    HEAP32[$7 >> 2] = $1;
    break label$1;
   }
   $10 = $5 + 92 | 0;
   $11 = $9 - $0 | 0;
   memmove($10 + ($8 << 2 | 0) | 0 | 0, $7 | 0, $11 << 2 | 0 | 0) | 0;
   HEAP32[($10 + $6 | 0) >> 2] = $1;
   memmove($5 + ($8 << 3 | 0) | 0 | 0, $5 + ($0 << 3 | 0) | 0 | 0, $11 << 3 | 0 | 0) | 0;
  }
  $1 = $9 + 1 | 0;
  i64toi32_i32$0 = $2$hi;
  i64toi32_i32$1 = $5 + ($0 << 3 | 0) | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $2;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  label$3 : {
   $6 = $0 + 2 | 0;
   $7 = $9 + 2 | 0;
   if ($6 >>> 0 >= $7 >>> 0) {
    break label$3
   }
   $10 = $5 + 144 | 0;
   memmove($10 + ($6 << 2 | 0) | 0 | 0, $10 + ($8 << 2 | 0) | 0 | 0, ($9 - $0 | 0) << 2 | 0 | 0) | 0;
  }
  HEAP32[(($5 + ($8 << 2 | 0) | 0) + 144 | 0) >> 2] = $4;
  HEAP16[($5 + 138 | 0) >> 1] = $1;
  label$4 : {
   if ($8 >>> 0 >= $7 >>> 0) {
    break label$4
   }
   $1 = $9 + 1 | 0;
   $8 = (($0 << 2 | 0) + $5 | 0) + 148 | 0;
   label$5 : while (1) {
    $9 = HEAP32[$8 >> 2] | 0;
    $0 = $0 + 1 | 0;
    HEAP16[($9 + 136 | 0) >> 1] = $0;
    HEAP32[($9 + 88 | 0) >> 2] = $5;
    $8 = $8 + 4 | 0;
    if (($1 | 0) != ($0 | 0)) {
     continue label$5
    }
    break label$5;
   };
  }
 }
 
 function alloc__vec__Vec_T_2cA___extend_desugared__he85f3b4fea67ba8b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $3 = 0, $5 = 0, $2 = 0, $6 = 0, $7 = 0, $22 = 0, $23 = 0, $24 = 0, $25 = 0, $26 = 0, $27 = 0, $4 = 0, $8 = 0, $9 = 0, $10 = 0, $12 = 0, $45 = 0, $49 = 0, $11 = 0, $60 = 0, $85 = 0, $91 = 0, $95 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  label$1 : {
   $3 = HEAP32[$1 >> 2] | 0;
   $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   if (($3 | 0) == ($4 | 0)) {
    break label$1
   }
   $5 = HEAP32[($3 + 20 | 0) >> 2] | 0;
   HEAP32[$1 >> 2] = $5;
   $6 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   HEAP32[($1 + 8 | 0) >> 2] = $6 + -1 | 0;
   $7 = $6 + -2 | 0;
   $8 = $2 + 8 | 0;
   $9 = $2 + 16 | 0;
   $10 = $2 + 24 | 0;
   label$2 : while (1) {
    $6 = $5;
    i64toi32_i32$2 = $3 + 33 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $45 = i64toi32_i32$0;
    i64toi32_i32$0 = $8;
    HEAP32[i64toi32_i32$0 >> 2] = $45;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $3 + 41 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $49 = i64toi32_i32$1;
    i64toi32_i32$1 = $9;
    HEAP32[i64toi32_i32$1 >> 2] = $49;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $3 + 25 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $11 = HEAPU8[($3 + 24 | 0) >> 0] | 0;
    $22 = $3 + 49 | 0;
    HEAP32[$10 >> 2] = HEAPU8[$22 >> 0] | 0 | ((HEAPU8[($22 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($22 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($22 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $60 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[i64toi32_i32$0 >> 2] = $60;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    label$3 : {
     $5 = HEAP32[($0 + 8 | 0) >> 2] | 0;
     if ((HEAP32[($0 + 4 | 0) >> 2] | 0 | 0) != ($5 | 0)) {
      break label$3
     }
     $3 = $7 + 1 | 0;
     $12 = $3 + 1 | 0;
     alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__ha457b0dea7cc7a33($0 | 0, $5 | 0, ($12 >>> 0 < $3 >>> 0 ? -1 : $12) | 0);
    }
    $3 = (HEAP32[$0 >> 2] | 0) + Math_imul($5, 29) | 0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $85 = i64toi32_i32$1;
    i64toi32_i32$1 = $3;
    $23 = $85;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $23;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $23 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $23 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = $23 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 8 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    HEAP8[i64toi32_i32$1 >> 0] = $11;
    i64toi32_i32$2 = $8;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $91 = i64toi32_i32$0;
    i64toi32_i32$0 = $3 + 9 | 0;
    $24 = $91;
    HEAP8[i64toi32_i32$0 >> 0] = $24;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $24 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $24 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $24 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$2 = $9;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $95 = i64toi32_i32$1;
    i64toi32_i32$1 = $3 + 17 | 0;
    $25 = $95;
    HEAP8[i64toi32_i32$1 >> 0] = $25;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $25 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $25 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $25 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    $26 = $3 + 25 | 0;
    $27 = HEAP32[$10 >> 2] | 0;
    HEAP8[$26 >> 0] = $27;
    HEAP8[($26 + 1 | 0) >> 0] = $27 >>> 8 | 0;
    HEAP8[($26 + 2 | 0) >> 0] = $27 >>> 16 | 0;
    HEAP8[($26 + 3 | 0) >> 0] = $27 >>> 24 | 0;
    HEAP32[($0 + 8 | 0) >> 2] = $5 + 1 | 0;
    if (($6 | 0) == ($4 | 0)) {
     break label$1
    }
    HEAP32[($1 + 8 | 0) >> 2] = $7;
    $5 = HEAP32[($6 + 20 | 0) >> 2] | 0;
    HEAP32[$1 >> 2] = $5;
    $7 = $7 + -1 | 0;
    $3 = $6;
    continue label$2;
   };
  }
  global$0 = $2 + 64 | 0;
 }
 
 function alloc__vec__Vec_T_2cA___extend_desugared__hd6899c42a6b1599a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $3 = 0, $5 = 0, $6 = 0, $7 = 0, $10 = 0, $9 = 0, $23 = 0, $24 = 0, $25 = 0, $26 = 0, $27 = 0, $28 = 0, $29 = 0, $30 = 0, $31 = 0, $32 = 0, $33 = 0, $34 = 0, $2 = 0, $8 = 0, $4 = 0, $11 = 0, $12 = 0, $13 = 0, $50 = 0, $58 = 0, $62 = 0, $84 = 0, $92 = 0, $96 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   $3 = HEAP32[$1 >> 2] | 0;
   $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   if (($3 | 0) == ($4 | 0)) {
    break label$1
   }
   $5 = HEAP32[($3 + 412 | 0) >> 2] | 0;
   HEAP32[$1 >> 2] = $5;
   $6 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   HEAP32[($1 + 8 | 0) >> 2] = $6 + -1 | 0;
   $7 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   $8 = Math_imul($7, 28);
   $9 = $6 + -2 | 0;
   $10 = $2 | 1 | 0;
   $11 = $10 + 24 | 0;
   $12 = $10 + 16 | 0;
   $13 = $10 + 8 | 0;
   label$2 : while (1) {
    $6 = $5;
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAPU8[($3 + 416 | 0) >> 0] | 0 | ((HEAPU8[($3 + 417 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 418 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 419 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[($3 + 420 | 0) >> 0] | 0 | ((HEAPU8[($3 + 421 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 422 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 423 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $50 = i64toi32_i32$0;
    i64toi32_i32$0 = $10;
    $23 = $50;
    HEAP8[i64toi32_i32$0 >> 0] = $23;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $23 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $23 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $23 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    $24 = $3 + 440 | 0;
    $25 = $11;
    $26 = HEAPU8[$24 >> 0] | 0 | ((HEAPU8[($24 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($24 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($24 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    HEAP8[$25 >> 0] = $26;
    HEAP8[($25 + 1 | 0) >> 0] = $26 >>> 8 | 0;
    HEAP8[($25 + 2 | 0) >> 0] = $26 >>> 16 | 0;
    HEAP8[($25 + 3 | 0) >> 0] = $26 >>> 24 | 0;
    i64toi32_i32$2 = $3 + 432 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $58 = i64toi32_i32$1;
    i64toi32_i32$1 = $12;
    $27 = $58;
    HEAP8[i64toi32_i32$1 >> 0] = $27;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $27 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $27 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $27 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$2 = $3 + 424 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $62 = i64toi32_i32$0;
    i64toi32_i32$0 = $13;
    $28 = $62;
    HEAP8[i64toi32_i32$0 >> 0] = $28;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $28 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $28 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $28 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    label$3 : {
     if (($7 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
      break label$3
     }
     $3 = $9 + 1 | 0;
     $5 = $3 + 1 | 0;
     alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h60072695517d08a3($0 | 0, $7 | 0, ($5 >>> 0 < $3 >>> 0 ? -1 : $5) | 0);
    }
    $3 = (HEAP32[$0 >> 2] | 0) + $8 | 0;
    i64toi32_i32$2 = $10;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $84 = i64toi32_i32$1;
    i64toi32_i32$1 = $3;
    $29 = $84;
    HEAP8[i64toi32_i32$1 >> 0] = $29;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $29 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $29 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $29 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    $30 = $11;
    $31 = i64toi32_i32$1 + 24 | 0;
    $32 = HEAPU8[$30 >> 0] | 0 | ((HEAPU8[($30 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($30 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($30 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    HEAP8[$31 >> 0] = $32;
    HEAP8[($31 + 1 | 0) >> 0] = $32 >>> 8 | 0;
    HEAP8[($31 + 2 | 0) >> 0] = $32 >>> 16 | 0;
    HEAP8[($31 + 3 | 0) >> 0] = $32 >>> 24 | 0;
    i64toi32_i32$2 = $12;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $92 = i64toi32_i32$0;
    i64toi32_i32$0 = $3 + 16 | 0;
    $33 = $92;
    HEAP8[i64toi32_i32$0 >> 0] = $33;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $33 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $33 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $33 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$2 = $13;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $96 = i64toi32_i32$1;
    i64toi32_i32$1 = $3 + 8 | 0;
    $34 = $96;
    HEAP8[i64toi32_i32$1 >> 0] = $34;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $34 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $34 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $34 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    $7 = $7 + 1 | 0;
    HEAP32[($0 + 8 | 0) >> 2] = $7;
    if (($6 | 0) == ($4 | 0)) {
     break label$1
    }
    HEAP32[($1 + 8 | 0) >> 2] = $9;
    $5 = HEAP32[($6 + 412 | 0) >> 2] | 0;
    HEAP32[$1 >> 2] = $5;
    $8 = $8 + 28 | 0;
    $9 = $9 + -1 | 0;
    $3 = $6;
    continue label$2;
   };
  }
  global$0 = $2 + 32 | 0;
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hc831120dea694494($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $7 = 0, $8 = 0, $53 = 0, $60 = 0, $67 = 0, $74 = 0, $83 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  $3 = HEAP32[$1 >> 2] | 0;
  $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h9244f1b241188454($2 + 8 | 0 | 0, $4 | 0, 0 | 0);
  $5 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[$0 >> 2] = $5;
  label$1 : {
   if (!$1) {
    break label$1
   }
   $6 = $3 + 32 | 0;
   $7 = Math_imul($4, 48);
   $8 = ($2 + 16 | 0) + 32 | 0;
   label$2 : while (1) {
    if (!$7) {
     break label$1
    }
    $1 = $1 + -1 | 0;
    $cardano_serialization_lib__plutus__PlutusDataEnum_20as_20core__clone__Clone___clone__h7a95fc7c6f531f3b($2 + 64 | 0 | 0, $3 | 0);
    label$3 : {
     label$4 : {
      if (HEAP32[($3 + 32 | 0) >> 2] | 0) {
       break label$4
      }
      HEAP32[($2 + 96 | 0) >> 2] = 0;
      break label$3;
     }
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($2 + 96 | 0 | 0, $6 | 0);
    }
    $3 = $3 + 48 | 0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[($2 + 96 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 100 | 0) >> 2] | 0;
    $53 = i64toi32_i32$0;
    i64toi32_i32$0 = $8;
    HEAP32[i64toi32_i32$0 >> 2] = $53;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = ($2 + 64 | 0) + 24 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $60 = i64toi32_i32$1;
    i64toi32_i32$1 = ($2 + 16 | 0) + 24 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $60;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = ($2 + 64 | 0) + 16 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $67 = i64toi32_i32$0;
    i64toi32_i32$0 = ($2 + 16 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $67;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = ($2 + 64 | 0) + 8 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $74 = i64toi32_i32$1;
    i64toi32_i32$1 = ($2 + 16 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $74;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($8 + 8 | 0) >> 2] = HEAP32[(($2 + 96 | 0) + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[($2 + 64 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 68 | 0) >> 2] | 0;
    $83 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[($2 + 16 | 0) >> 2] = $83;
    HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$1;
    $5 = (memcpy($5 | 0, $2 + 16 | 0 | 0, 48 | 0) | 0) + 48 | 0;
    $6 = $6 + 48 | 0;
    $7 = $7 + -48 | 0;
    if ($1) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 8 | 0) >> 2] = $4;
  global$0 = $2 + 112 | 0;
 }
 
 function hashbrown__map__HashMap_K_2cV_2cS_2cA___insert__h7f5a811fd689cb87($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, $7 = 0, $6 = 0, $23 = 0, $5 = 0, $8 = 0, $9 = 0, $9$hi = 0, $64 = 0, $64$hi = 0, $75 = 0, $75$hi = 0, $84 = 0, $84$hi = 0, $95 = 0, $95$hi = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  HEAP32[($4 + 20 | 0) >> 2] = $2;
  i64toi32_i32$0 = hashbrown__map__make_insert_hash__hb313f57dc55aac55($1 | 0, $4 + 20 | 0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $9 = i64toi32_i32$0;
  $9$hi = i64toi32_i32$1;
  $5 = i64toi32_i32$0;
  $6 = (HEAP32[($1 + 16 | 0) >> 2] | 0) & i64toi32_i32$0 | 0;
  $23 = (HEAP32[($1 + 20 | 0) >> 2] | 0) + $6 | 0;
  $7 = HEAPU8[$23 >> 0] | 0 | ((HEAPU8[($23 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($23 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($23 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $8 = 0;
  HEAP32[($4 + 32 | 0) >> 2] = 0;
  HEAP32[($4 + 36 | 0) >> 2] = $7;
  HEAP32[($4 + 28 | 0) >> 2] = $6;
  $6 = $1 + 16 | 0;
  HEAP32[($4 + 24 | 0) >> 2] = $6;
  $5 = i64toi32_i32$0 >>> 25 | 0;
  HEAP8[($4 + 44 | 0) >> 0] = $5;
  $7 = $7 ^ Math_imul($5, 16843009) | 0;
  HEAP32[($4 + 40 | 0) >> 2] = (($7 ^ -1 | 0) & ($7 + -16843009 | 0) | 0) & -2139062144 | 0;
  $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($4 + 8 | 0 | 0, $4 + 24 | 0 | 0);
  label$1 : {
   label$2 : {
    if (!(HEAP32[($4 + 8 | 0) >> 2] | 0)) {
     break label$2
    }
    label$3 : {
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $64 = i64toi32_i32$1;
     $64$hi = i64toi32_i32$0;
     $7 = (HEAP32[((HEAP32[($4 + 24 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) - ((HEAP32[($4 + 12 | 0) >> 2] | 0) << 3 | 0) | 0;
     i64toi32_i32$2 = HEAP32[($7 + -8 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $75 = i64toi32_i32$0;
     $75$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $64$hi;
     i64toi32_i32$2 = $64;
     i64toi32_i32$0 = $75$hi;
     i64toi32_i32$3 = $75;
     if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
      break label$3
     }
     label$4 : while (1) {
      $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($4 | 0, $4 + 24 | 0 | 0);
      if (!(HEAP32[$4 >> 2] | 0)) {
       break label$2
      }
      i64toi32_i32$3 = $2;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $84 = i64toi32_i32$2;
      $84$hi = i64toi32_i32$1;
      $7 = (HEAP32[((HEAP32[($4 + 24 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) - ((HEAP32[($4 + 4 | 0) >> 2] | 0) << 3 | 0) | 0;
      i64toi32_i32$3 = HEAP32[($7 + -8 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $95 = i64toi32_i32$1;
      $95$hi = i64toi32_i32$2;
      i64toi32_i32$2 = $84$hi;
      i64toi32_i32$3 = $84;
      i64toi32_i32$1 = $95$hi;
      i64toi32_i32$0 = $95;
      if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
       continue label$4
      }
      break label$4;
     };
    }
    $2 = $7 + -4 | 0;
    $1 = HEAP32[$2 >> 2] | 0;
    HEAP32[$2 >> 2] = $3;
    $8 = 1;
    break label$1;
   }
   i64toi32_i32$3 = $9$hi;
   hashbrown__raw__RawTable_T_2cA___insert__h06f681ead2656f7c($6 | 0, $9 | 0, i64toi32_i32$3 | 0, $2 | 0, $3 | 0, $1 | 0) | 0;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[$0 >> 2] = $8;
  global$0 = $4 + 48 | 0;
 }
 
 function hashbrown__map__HashMap_K_2cV_2cS_2cA___insert__hb3103c1d05371979($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $7 = 0, $5 = 0, $6 = 0, $13 = 0, i64toi32_i32$1 = 0, $9 = 0, $8 = 0, i64toi32_i32$0 = 0, $9$hi = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  HEAP32[($4 + 20 | 0) >> 2] = $2;
  i64toi32_i32$0 = hashbrown__map__make_insert_hash__he623a39a8b84cb13($1 | 0, $4 + 20 | 0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $9 = i64toi32_i32$0;
  $9$hi = i64toi32_i32$1;
  $5 = $9;
  $6 = (HEAP32[($1 + 16 | 0) >> 2] | 0) & $5 | 0;
  $13 = (HEAP32[($1 + 20 | 0) >> 2] | 0) + $6 | 0;
  $7 = HEAPU8[$13 >> 0] | 0 | ((HEAPU8[($13 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($13 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($13 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $8 = 0;
  HEAP32[($4 + 32 | 0) >> 2] = 0;
  HEAP32[($4 + 36 | 0) >> 2] = $7;
  HEAP32[($4 + 28 | 0) >> 2] = $6;
  $6 = $1 + 16 | 0;
  HEAP32[($4 + 24 | 0) >> 2] = $6;
  $5 = $5 >>> 25 | 0;
  HEAP8[($4 + 44 | 0) >> 0] = $5;
  $7 = $7 ^ Math_imul($5, 16843009) | 0;
  HEAP32[($4 + 40 | 0) >> 2] = (($7 ^ -1 | 0) & ($7 + -16843009 | 0) | 0) & -2139062144 | 0;
  $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($4 + 8 | 0 | 0, $4 + 24 | 0 | 0);
  label$1 : {
   label$2 : {
    if (!(HEAP32[($4 + 8 | 0) >> 2] | 0)) {
     break label$2
    }
    label$3 : {
     $7 = (HEAP32[((HEAP32[($4 + 24 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) - ((HEAP32[($4 + 12 | 0) >> 2] | 0) << 3 | 0) | 0;
     if ((HEAP32[$2 >> 2] | 0 | 0) == (HEAP32[(HEAP32[($7 + -8 | 0) >> 2] | 0) >> 2] | 0 | 0)) {
      break label$3
     }
     label$4 : while (1) {
      $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($4 | 0, $4 + 24 | 0 | 0);
      if (!(HEAP32[$4 >> 2] | 0)) {
       break label$2
      }
      $7 = (HEAP32[((HEAP32[($4 + 24 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) - ((HEAP32[($4 + 4 | 0) >> 2] | 0) << 3 | 0) | 0;
      if ((HEAP32[$2 >> 2] | 0 | 0) != (HEAP32[(HEAP32[($7 + -8 | 0) >> 2] | 0) >> 2] | 0 | 0)) {
       continue label$4
      }
      break label$4;
     };
    }
    $2 = $7 + -4 | 0;
    $1 = HEAP32[$2 >> 2] | 0;
    HEAP32[$2 >> 2] = $3;
    $8 = 1;
    break label$1;
   }
   i64toi32_i32$1 = $9$hi;
   hashbrown__raw__RawTable_T_2cA___insert__hbcad5b3968423033($6 | 0, $9 | 0, i64toi32_i32$1 | 0, $2 | 0, $3 | 0, $1 | 0) | 0;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[$0 >> 2] = $8;
  global$0 = $4 + 48 | 0;
 }
 
 function num_bigint__biguint__convert__from_bitwise_digits_le__h1211a4b63ce79885($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $5 = 0, $6 = 0, $6$hi = 0, $82 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  HEAP8[($4 + 7 | 0) >> 0] = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $3 = $3 & 255 | 0;
      if (!$3) {
       break label$4
      }
      $5 = (32 >>> 0) / ($3 >>> 0) | 0;
      HEAP32[($4 + 8 | 0) >> 2] = $5;
      if ($3 >>> 0 >= 33 >>> 0) {
       break label$3
      }
      HEAP32[($4 + 32 | 0) >> 2] = $5;
      HEAP32[($4 + 28 | 0) >> 2] = $2;
      HEAP32[($4 + 24 | 0) >> 2] = $1;
      HEAP32[($4 + 36 | 0) >> 2] = $4 + 7 | 0;
      $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__hca5504019fd14046($4 + 8 | 0 | 0, $4 + 24 | 0 | 0);
      $1 = HEAP32[(($4 + 8 | 0) + 8 | 0) >> 2] | 0;
      HEAP32[(($4 + 24 | 0) + 8 | 0) >> 2] = $1;
      i64toi32_i32$0 = HEAP32[($4 + 8 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($4 + 12 | 0) >> 2] | 0;
      $6 = i64toi32_i32$0;
      $6$hi = i64toi32_i32$1;
      i64toi32_i32$0 = $4;
      HEAP32[($4 + 24 | 0) >> 2] = $6;
      HEAP32[($4 + 28 | 0) >> 2] = i64toi32_i32$1;
      label$5 : {
       if ($1) {
        break label$5
       }
       $1 = 0;
       break label$1;
      }
      i64toi32_i32$1 = $6$hi;
      $3 = (($1 << 2 | 0) + $6 | 0) + -4 | 0;
      label$6 : while (1) {
       if (HEAP32[$3 >> 2] | 0) {
        break label$2
       }
       $3 = $3 + -4 | 0;
       $1 = $1 + -1 | 0;
       if ($1) {
        continue label$6
       }
       break label$6;
      };
      $1 = 0;
      break label$2;
     }
     core__panicking__panic__h2fd385a887c8bf13(1077952 | 0, 25 | 0, 1078300 | 0);
     abort();
    }
    HEAP32[($4 + 24 | 0) >> 2] = 0;
    core__panicking__assert_failed__h4abb29051d76b03f(1 | 0, $4 + 8 | 0 | 0, 1078044 | 0, $4 + 24 | 0 | 0, 1078128 | 0);
    abort();
   }
   HEAP32[($4 + 32 | 0) >> 2] = $1;
  }
  label$7 : {
   $3 = HEAP32[($4 + 28 | 0) >> 2] | 0;
   if ($1 >>> 0 >= ($3 >>> 2 | 0) >>> 0) {
    break label$7
   }
   if ($3 >>> 0 <= $1 >>> 0) {
    break label$7
   }
   alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($4 + 24 | 0 | 0, $1 | 0);
  }
  i64toi32_i32$1 = HEAP32[($4 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($4 + 28 | 0) >> 2] | 0;
  $82 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $82;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($4 + 24 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $4 + 48 | 0;
 }
 
 function hashbrown__map__HashMap_K_2cV_2cS_2cA___insert__h329a9f5fa6dfcbd2($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $7 = 0, $5 = 0, $6 = 0, $13 = 0, i64toi32_i32$1 = 0, $9 = 0, $8 = 0, i64toi32_i32$0 = 0, $9$hi = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  HEAP32[($4 + 20 | 0) >> 2] = $2;
  i64toi32_i32$0 = hashbrown__map__make_insert_hash__hde48453e54123393($1 | 0, $4 + 20 | 0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $9 = i64toi32_i32$0;
  $9$hi = i64toi32_i32$1;
  $5 = $9;
  $6 = (HEAP32[($1 + 16 | 0) >> 2] | 0) & $5 | 0;
  $13 = (HEAP32[($1 + 20 | 0) >> 2] | 0) + $6 | 0;
  $7 = HEAPU8[$13 >> 0] | 0 | ((HEAPU8[($13 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($13 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($13 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $8 = 0;
  HEAP32[($4 + 32 | 0) >> 2] = 0;
  HEAP32[($4 + 36 | 0) >> 2] = $7;
  HEAP32[($4 + 28 | 0) >> 2] = $6;
  $6 = $1 + 16 | 0;
  HEAP32[($4 + 24 | 0) >> 2] = $6;
  $5 = $5 >>> 25 | 0;
  HEAP8[($4 + 44 | 0) >> 0] = $5;
  $7 = $7 ^ Math_imul($5, 16843009) | 0;
  HEAP32[($4 + 40 | 0) >> 2] = (($7 ^ -1 | 0) & ($7 + -16843009 | 0) | 0) & -2139062144 | 0;
  $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($4 + 8 | 0 | 0, $4 + 24 | 0 | 0);
  label$1 : {
   label$2 : {
    if (!(HEAP32[($4 + 8 | 0) >> 2] | 0)) {
     break label$2
    }
    label$3 : {
     $7 = (HEAP32[((HEAP32[($4 + 24 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) - ((HEAP32[($4 + 12 | 0) >> 2] | 0) << 3 | 0) | 0;
     if ($linked_hash_map__KeyRef_K__20as_20core__cmp__PartialEq___eq__h969d25de4a7a4343($4 + 20 | 0 | 0, $7 + -8 | 0 | 0) | 0) {
      break label$3
     }
     label$4 : while (1) {
      $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($4 | 0, $4 + 24 | 0 | 0);
      if (!(HEAP32[$4 >> 2] | 0)) {
       break label$2
      }
      $7 = (HEAP32[((HEAP32[($4 + 24 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) - ((HEAP32[($4 + 4 | 0) >> 2] | 0) << 3 | 0) | 0;
      if (!($linked_hash_map__KeyRef_K__20as_20core__cmp__PartialEq___eq__h969d25de4a7a4343($4 + 20 | 0 | 0, $7 + -8 | 0 | 0) | 0)) {
       continue label$4
      }
      break label$4;
     };
    }
    $7 = $7 + -4 | 0;
    $1 = HEAP32[$7 >> 2] | 0;
    HEAP32[$7 >> 2] = $3;
    $8 = 1;
    break label$1;
   }
   i64toi32_i32$1 = $9$hi;
   hashbrown__raw__RawTable_T_2cA___insert__h9e114b5bd533aa2a($6 | 0, $9 | 0, i64toi32_i32$1 | 0, $2 | 0, $3 | 0, $1 | 0) | 0;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[$0 >> 2] = $8;
  global$0 = $4 + 48 | 0;
 }
 
 function hashbrown__map__HashMap_K_2cV_2cS_2cA___insert__h73bc0b2d4216f700($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $7 = 0, $5 = 0, $6 = 0, $13 = 0, i64toi32_i32$1 = 0, $9 = 0, $8 = 0, i64toi32_i32$0 = 0, $9$hi = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  HEAP32[($4 + 20 | 0) >> 2] = $2;
  i64toi32_i32$0 = hashbrown__map__make_insert_hash__h652c972165b1bbd6($1 | 0, $4 + 20 | 0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $9 = i64toi32_i32$0;
  $9$hi = i64toi32_i32$1;
  $5 = $9;
  $6 = (HEAP32[($1 + 16 | 0) >> 2] | 0) & $5 | 0;
  $13 = (HEAP32[($1 + 20 | 0) >> 2] | 0) + $6 | 0;
  $7 = HEAPU8[$13 >> 0] | 0 | ((HEAPU8[($13 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($13 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($13 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $8 = 0;
  HEAP32[($4 + 32 | 0) >> 2] = 0;
  HEAP32[($4 + 36 | 0) >> 2] = $7;
  HEAP32[($4 + 28 | 0) >> 2] = $6;
  $6 = $1 + 16 | 0;
  HEAP32[($4 + 24 | 0) >> 2] = $6;
  $5 = $5 >>> 25 | 0;
  HEAP8[($4 + 44 | 0) >> 0] = $5;
  $7 = $7 ^ Math_imul($5, 16843009) | 0;
  HEAP32[($4 + 40 | 0) >> 2] = (($7 ^ -1 | 0) & ($7 + -16843009 | 0) | 0) & -2139062144 | 0;
  $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($4 + 8 | 0 | 0, $4 + 24 | 0 | 0);
  label$1 : {
   label$2 : {
    if (!(HEAP32[($4 + 8 | 0) >> 2] | 0)) {
     break label$2
    }
    label$3 : {
     $7 = (HEAP32[((HEAP32[($4 + 24 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) - ((HEAP32[($4 + 12 | 0) >> 2] | 0) << 3 | 0) | 0;
     if ($linked_hash_map__KeyRef_K__20as_20core__cmp__PartialEq___eq__h384b914ed9be434a($4 + 20 | 0 | 0, $7 + -8 | 0 | 0) | 0) {
      break label$3
     }
     label$4 : while (1) {
      $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($4 | 0, $4 + 24 | 0 | 0);
      if (!(HEAP32[$4 >> 2] | 0)) {
       break label$2
      }
      $7 = (HEAP32[((HEAP32[($4 + 24 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) - ((HEAP32[($4 + 4 | 0) >> 2] | 0) << 3 | 0) | 0;
      if (!($linked_hash_map__KeyRef_K__20as_20core__cmp__PartialEq___eq__h384b914ed9be434a($4 + 20 | 0 | 0, $7 + -8 | 0 | 0) | 0)) {
       continue label$4
      }
      break label$4;
     };
    }
    $7 = $7 + -4 | 0;
    $1 = HEAP32[$7 >> 2] | 0;
    HEAP32[$7 >> 2] = $3;
    $8 = 1;
    break label$1;
   }
   i64toi32_i32$1 = $9$hi;
   hashbrown__raw__RawTable_T_2cA___insert__ha3d899634fbcfa25($6 | 0, $9 | 0, i64toi32_i32$1 | 0, $2 | 0, $3 | 0, $1 | 0) | 0;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[$0 >> 2] = $8;
  global$0 = $4 + 48 | 0;
 }
 
 function hashbrown__map__HashMap_K_2cV_2cS_2cA___insert__hbcfd3ef1bdc4d2e0($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $7 = 0, $5 = 0, $6 = 0, $13 = 0, i64toi32_i32$1 = 0, $9 = 0, $8 = 0, i64toi32_i32$0 = 0, $9$hi = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  HEAP32[($4 + 20 | 0) >> 2] = $2;
  i64toi32_i32$0 = hashbrown__map__make_insert_hash__h2b8264a344d2c281($1 | 0, $4 + 20 | 0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $9 = i64toi32_i32$0;
  $9$hi = i64toi32_i32$1;
  $5 = $9;
  $6 = (HEAP32[($1 + 16 | 0) >> 2] | 0) & $5 | 0;
  $13 = (HEAP32[($1 + 20 | 0) >> 2] | 0) + $6 | 0;
  $7 = HEAPU8[$13 >> 0] | 0 | ((HEAPU8[($13 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($13 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($13 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $8 = 0;
  HEAP32[($4 + 32 | 0) >> 2] = 0;
  HEAP32[($4 + 36 | 0) >> 2] = $7;
  HEAP32[($4 + 28 | 0) >> 2] = $6;
  $6 = $1 + 16 | 0;
  HEAP32[($4 + 24 | 0) >> 2] = $6;
  $5 = $5 >>> 25 | 0;
  HEAP8[($4 + 44 | 0) >> 0] = $5;
  $7 = $7 ^ Math_imul($5, 16843009) | 0;
  HEAP32[($4 + 40 | 0) >> 2] = (($7 ^ -1 | 0) & ($7 + -16843009 | 0) | 0) & -2139062144 | 0;
  $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($4 + 8 | 0 | 0, $4 + 24 | 0 | 0);
  label$1 : {
   label$2 : {
    if (!(HEAP32[($4 + 8 | 0) >> 2] | 0)) {
     break label$2
    }
    label$3 : {
     $7 = (HEAP32[((HEAP32[($4 + 24 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) - ((HEAP32[($4 + 12 | 0) >> 2] | 0) << 3 | 0) | 0;
     if (!(memcmp($2 | 0, HEAP32[($7 + -8 | 0) >> 2] | 0 | 0, 28 | 0) | 0)) {
      break label$3
     }
     label$4 : while (1) {
      $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($4 | 0, $4 + 24 | 0 | 0);
      if (!(HEAP32[$4 >> 2] | 0)) {
       break label$2
      }
      $7 = (HEAP32[((HEAP32[($4 + 24 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) - ((HEAP32[($4 + 4 | 0) >> 2] | 0) << 3 | 0) | 0;
      if (memcmp($2 | 0, HEAP32[($7 + -8 | 0) >> 2] | 0 | 0, 28 | 0) | 0) {
       continue label$4
      }
      break label$4;
     };
    }
    $2 = $7 + -4 | 0;
    $1 = HEAP32[$2 >> 2] | 0;
    HEAP32[$2 >> 2] = $3;
    $8 = 1;
    break label$1;
   }
   i64toi32_i32$1 = $9$hi;
   hashbrown__raw__RawTable_T_2cA___insert__h6db614c9d789f2e1($6 | 0, $9 | 0, i64toi32_i32$1 | 0, $2 | 0, $3 | 0, $1 | 0) | 0;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[$0 >> 2] = $8;
  global$0 = $4 + 48 | 0;
 }
 
 function hashbrown__map__HashMap_K_2cV_2cS_2cA___insert__he00a034bc59fe2c2($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $7 = 0, $5 = 0, $6 = 0, $13 = 0, i64toi32_i32$1 = 0, $9 = 0, $8 = 0, i64toi32_i32$0 = 0, $9$hi = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  HEAP32[($4 + 20 | 0) >> 2] = $2;
  i64toi32_i32$0 = hashbrown__map__make_insert_hash__h1511e6cd27b8f68b($1 | 0, $4 + 20 | 0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $9 = i64toi32_i32$0;
  $9$hi = i64toi32_i32$1;
  $5 = $9;
  $6 = (HEAP32[($1 + 16 | 0) >> 2] | 0) & $5 | 0;
  $13 = (HEAP32[($1 + 20 | 0) >> 2] | 0) + $6 | 0;
  $7 = HEAPU8[$13 >> 0] | 0 | ((HEAPU8[($13 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($13 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($13 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $8 = 0;
  HEAP32[($4 + 32 | 0) >> 2] = 0;
  HEAP32[($4 + 36 | 0) >> 2] = $7;
  HEAP32[($4 + 28 | 0) >> 2] = $6;
  $6 = $1 + 16 | 0;
  HEAP32[($4 + 24 | 0) >> 2] = $6;
  $5 = $5 >>> 25 | 0;
  HEAP8[($4 + 44 | 0) >> 0] = $5;
  $7 = $7 ^ Math_imul($5, 16843009) | 0;
  HEAP32[($4 + 40 | 0) >> 2] = (($7 ^ -1 | 0) & ($7 + -16843009 | 0) | 0) & -2139062144 | 0;
  $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($4 + 8 | 0 | 0, $4 + 24 | 0 | 0);
  label$1 : {
   label$2 : {
    if (!(HEAP32[($4 + 8 | 0) >> 2] | 0)) {
     break label$2
    }
    label$3 : {
     $7 = (HEAP32[((HEAP32[($4 + 24 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) - ((HEAP32[($4 + 12 | 0) >> 2] | 0) << 3 | 0) | 0;
     if (!(memcmp($2 | 0, HEAP32[($7 + -8 | 0) >> 2] | 0 | 0, 28 | 0) | 0)) {
      break label$3
     }
     label$4 : while (1) {
      $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($4 | 0, $4 + 24 | 0 | 0);
      if (!(HEAP32[$4 >> 2] | 0)) {
       break label$2
      }
      $7 = (HEAP32[((HEAP32[($4 + 24 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) - ((HEAP32[($4 + 4 | 0) >> 2] | 0) << 3 | 0) | 0;
      if (memcmp($2 | 0, HEAP32[($7 + -8 | 0) >> 2] | 0 | 0, 28 | 0) | 0) {
       continue label$4
      }
      break label$4;
     };
    }
    $2 = $7 + -4 | 0;
    $1 = HEAP32[$2 >> 2] | 0;
    HEAP32[$2 >> 2] = $3;
    $8 = 1;
    break label$1;
   }
   i64toi32_i32$1 = $9$hi;
   hashbrown__raw__RawTable_T_2cA___insert__he0ddabc3bc476eee($6 | 0, $9 | 0, i64toi32_i32$1 | 0, $2 | 0, $3 | 0, $1 | 0) | 0;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[$0 >> 2] = $8;
  global$0 = $4 + 48 | 0;
 }
 
 function serde_json__de__from_trait__h0ba18435786ef501($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $18 = 0, $34 = 0, $41 = 0, $44 = 0, $53 = 0, $59 = 0, $65 = 0;
  $2 = global$0 - 96 | 0;
  global$0 = $2;
  i64toi32_i32$1 = ($2 + 8 | 0) + 16 | 0;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  HEAP8[($2 + 32 | 0) >> 0] = 128;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $18;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($2 + 20 | 0) >> 2] = HEAP32[(0 + 1084764 | 0) >> 2] | 0;
  $_mut_20serde_json__de__Deserializer_R__20as_20serde__de__Deserializer___deserialize_any__hd0def79dc4acfc54($2 + 64 | 0 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ((HEAP32[($2 + 64 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      i64toi32_i32$2 = ($2 + 64 | 0) + 24 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $34 = i64toi32_i32$1;
      i64toi32_i32$1 = ($2 + 40 | 0) + 16 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $34;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = ($2 + 64 | 0) + 16 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $41 = i64toi32_i32$0;
      i64toi32_i32$0 = ($2 + 40 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $41;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $2;
      i64toi32_i32$1 = HEAP32[($2 + 72 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($2 + 76 | 0) >> 2] | 0;
      $44 = i64toi32_i32$1;
      i64toi32_i32$1 = $2;
      HEAP32[($2 + 40 | 0) >> 2] = $44;
      HEAP32[($2 + 44 | 0) >> 2] = i64toi32_i32$0;
      $1 = serde_json__de__Deserializer_R___end__hae34e82a28b172cb($2 + 8 | 0 | 0) | 0;
      if ($1) {
       break label$3
      }
      HEAP32[$0 >> 2] = 0;
      i64toi32_i32$2 = $2;
      i64toi32_i32$0 = HEAP32[($2 + 40 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($2 + 44 | 0) >> 2] | 0;
      $53 = i64toi32_i32$0;
      i64toi32_i32$0 = $0 + 8 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $53;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = ($2 + 40 | 0) + 16 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $59 = i64toi32_i32$1;
      i64toi32_i32$1 = $0 + 24 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $59;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = ($2 + 40 | 0) + 8 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $65 = i64toi32_i32$0;
      i64toi32_i32$0 = $0 + 16 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $65;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      $0 = HEAP32[($2 + 24 | 0) >> 2] | 0;
      if (!$0) {
       break label$1
      }
      __rust_dealloc(HEAP32[($2 + 20 | 0) >> 2] | 0 | 0, $0 | 0, 1 | 0);
      break label$1;
     }
     HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($2 + 68 | 0) >> 2] | 0;
     HEAP32[$0 >> 2] = 1;
     break label$2;
    }
    HEAP32[$0 >> 2] = 1;
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    core__ptr__drop_in_place_serde_json__value__Value___hb5131c85f9c77304($2 + 40 | 0 | 0);
   }
   $0 = HEAP32[($2 + 24 | 0) >> 2] | 0;
   if (!$0) {
    break label$1
   }
   __rust_dealloc(HEAP32[($2 + 20 | 0) >> 2] | 0 | 0, $0 | 0, 1 | 0);
  }
  global$0 = $2 + 96 | 0;
 }
 
 function proposedprotocolparameterupdates_insert($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $15 = 0, $4 = 0, $5 = 0, $6 = 0, $49 = 0, $55 = 0, $58 = 0, $7 = 0, $7$hi = 0;
  $3 = global$0 - 880 | 0;
  global$0 = $3;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h5343c37ad06efd21($3 + 24 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $4 = HEAP32[($3 + 28 | 0) >> 2] | 0;
   $5 = HEAP32[($3 + 24 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h7b8fe8d9d71033fc($3 + 16 | 0 | 0, $1 | 0);
   if (!$2) {
    break label$1
   }
   $1 = HEAP32[($3 + 20 | 0) >> 2] | 0;
   $0 = HEAP32[($3 + 16 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hd84cc8f720a3dada($3 + 8 | 0 | 0, $2 | 0);
   $2 = HEAP32[($3 + 12 | 0) >> 2] | 0;
   $6 = HEAP32[($3 + 8 | 0) >> 2] | 0;
   $15 = $0 + 24 | 0;
   HEAP32[(($3 + 440 | 0) + 24 | 0) >> 2] = HEAPU8[$15 >> 0] | 0 | ((HEAPU8[($15 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($15 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($15 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$2 = $0 + 16 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $49 = i64toi32_i32$0;
   i64toi32_i32$0 = ($3 + 440 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $49;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $0 + 8 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $55 = i64toi32_i32$1;
   i64toi32_i32$1 = ($3 + 440 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $55;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $58 = i64toi32_i32$0;
   i64toi32_i32$0 = $3;
   HEAP32[($3 + 440 | 0) >> 2] = $58;
   HEAP32[($3 + 444 | 0) >> 2] = i64toi32_i32$1;
   $cardano_serialization_lib__ProtocolParamUpdate_20as_20core__clone__Clone___clone__h79b368642b010c69($3 + 472 | 0 | 0, $6 | 0);
   linked_hash_map__LinkedHashMap_K_2cV_2cS___insert__hfa80207d641c294d($3 + 32 | 0 | 0, $5 | 0, $3 + 440 | 0 | 0, $3 + 472 | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   $0 = 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($4 | 0, 0 | 0) | 0;
   label$2 : {
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
    $7 = i64toi32_i32$1;
    $7$hi = i64toi32_i32$0;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    if ((i64toi32_i32$2 | 0) == (2 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
     break label$2
    }
    i64toi32_i32$2 = $7$hi;
    i64toi32_i32$0 = $3;
    HEAP32[($3 + 472 | 0) >> 2] = $7;
    HEAP32[($3 + 476 | 0) >> 2] = i64toi32_i32$2;
    memcpy(($3 + 472 | 0) + 8 | 0 | 0, ($3 + 32 | 0) + 8 | 0 | 0, 400 | 0) | 0;
    $0 = $cardano_serialization_lib__ProtocolParamUpdate_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hd784927b58be35b6($3 + 472 | 0 | 0) | 0;
   }
   global$0 = $3 + 880 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function num_bigint__bigint__BigInt__from_bytes_be__h2ccfcd4424e804e6($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, $4 = 0, i64toi32_i32$1 = 0, $5 = 0, $87 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $3 = global$0 - 64 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    if (!$2) {
     break label$2
    }
    alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($3 + 24 | 0 | 0, $2 | 0, 0 | 0);
    HEAP32[($3 + 52 | 0) >> 2] = HEAP32[($3 + 28 | 0) >> 2] | 0;
    $4 = HEAP32[($3 + 24 | 0) >> 2] | 0;
    HEAP32[($3 + 48 | 0) >> 2] = $4;
    memcpy($4 | 0, $1 | 0, $2 | 0) | 0;
    HEAP32[($3 + 56 | 0) >> 2] = $2;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__DerefMut___deref_mut__h1882e042320a120c($3 + 16 | 0 | 0, $3 + 48 | 0 | 0);
    label$3 : {
     $1 = HEAP32[($3 + 20 | 0) >> 2] | 0;
     $4 = $1 >>> 1 | 0;
     if (!$4) {
      break label$3
     }
     $2 = HEAP32[($3 + 16 | 0) >> 2] | 0;
     $1 = ($1 + $2 | 0) + -1 | 0;
     label$4 : while (1) {
      $5 = HEAPU8[$2 >> 0] | 0;
      HEAP8[$2 >> 0] = HEAPU8[$1 >> 0] | 0;
      HEAP8[$1 >> 0] = $5;
      $2 = $2 + 1 | 0;
      $1 = $1 + -1 | 0;
      $4 = $4 + -1 | 0;
      if ($4) {
       continue label$4
      }
      break label$4;
     };
    }
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $3 + 48 | 0 | 0);
    label$5 : {
     label$6 : {
      $2 = HEAP32[($3 + 12 | 0) >> 2] | 0;
      if (!$2) {
       break label$6
      }
      num_bigint__biguint__convert__from_bitwise_digits_le__h1211a4b63ce79885($3 + 32 | 0 | 0, HEAP32[($3 + 8 | 0) >> 2] | 0 | 0, $2 | 0, 8 | 0);
      break label$5;
     }
     i64toi32_i32$1 = $3;
     i64toi32_i32$0 = 0;
     HEAP32[($3 + 36 | 0) >> 2] = 0;
     HEAP32[($3 + 40 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($3 + 32 | 0) >> 2] = HEAP32[(0 + 1057660 | 0) >> 2] | 0;
    }
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 48 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 48 | 0 | 0);
    break label$1;
   }
   i64toi32_i32$1 = $3;
   i64toi32_i32$0 = 0;
   HEAP32[($3 + 36 | 0) >> 2] = 0;
   HEAP32[($3 + 40 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($3 + 32 | 0) >> 2] = HEAP32[(0 + 1057660 | 0) >> 2] | 0;
  }
  (wasm2js_i32$0 = $0, wasm2js_i32$1 = alloc__vec__Vec_T_2cA___is_empty__h144b76bbfc7433d3($3 + 32 | 0 | 0) | 0 ? 1 : 2), HEAP8[(wasm2js_i32$0 + 12 | 0) >> 0] = wasm2js_i32$1;
  i64toi32_i32$0 = HEAP32[($3 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($3 + 36 | 0) >> 2] | 0;
  $87 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $87;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[(($3 + 32 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $3 + 64 | 0;
 }
 
 function cardano_serialization_lib__tx_builder__TransactionBuilderConfigBuilder__fee_algo__h03e1f492080db5e6($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, $7 = 0, $7$hi = 0, $13 = 0, $13$hi = 0, $3 = 0, $4 = 0, $8 = 0, $8$hi = 0, $9 = 0, $9$hi = 0, $10 = 0, $10$hi = 0, $5 = 0, $6 = 0, $11 = 0, $11$hi = 0, $12 = 0, $12$hi = 0, $14 = 0, $14$hi = 0, $15 = 0, $15$hi = 0, $16 = 0, $16$hi = 0, $17 = 0, $17$hi = 0, $105 = 0;
  i64toi32_i32$2 = $1 + 64 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  $3 = HEAP32[($1 + 124 | 0) >> 2] | 0;
  $4 = HEAP32[($1 + 116 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1 + 48 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$1;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $1 + 32 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $9 = i64toi32_i32$0;
  $9$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
  $10 = i64toi32_i32$1;
  $10$hi = i64toi32_i32$0;
  $5 = HEAP32[(i64toi32_i32$2 + 120 | 0) >> 2] | 0;
  $6 = HEAP32[(i64toi32_i32$2 + 112 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] | 0;
  $11 = i64toi32_i32$0;
  $11$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $12 = i64toi32_i32$1;
  $12$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 72 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 76 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    i64toi32_i32$3 = 1;
    if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
     break label$2
    }
    i64toi32_i32$2 = 0;
    $13 = 0;
    $13$hi = i64toi32_i32$2;
    break label$1;
   }
   i64toi32_i32$3 = $1 + 104 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $14 = i64toi32_i32$2;
   $14$hi = i64toi32_i32$1;
   i64toi32_i32$3 = $1 + 96 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $15 = i64toi32_i32$1;
   $15$hi = i64toi32_i32$2;
   i64toi32_i32$3 = $1 + 88 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $16 = i64toi32_i32$2;
   $16$hi = i64toi32_i32$1;
   i64toi32_i32$3 = $1 + 80 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $17 = i64toi32_i32$1;
   $17$hi = i64toi32_i32$2;
   i64toi32_i32$2 = 0;
   $13 = 1;
   $13$hi = i64toi32_i32$2;
  }
  HEAP32[($0 + 120 | 0) >> 2] = $5;
  HEAP32[($0 + 112 | 0) >> 2] = $6;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$1 = $0;
  HEAP32[(i64toi32_i32$1 + 40 | 0) >> 2] = $11;
  HEAP32[(i64toi32_i32$1 + 44 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $12$hi;
  HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = $12;
  HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $13$hi;
  HEAP32[(i64toi32_i32$1 + 72 | 0) >> 2] = $13;
  HEAP32[(i64toi32_i32$1 + 76 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  HEAP32[(i64toi32_i32$1 + 56 | 0) >> 2] = $10;
  HEAP32[(i64toi32_i32$1 + 60 | 0) >> 2] = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$1 + 124 | 0) >> 2] = $3;
  HEAP32[(i64toi32_i32$1 + 116 | 0) >> 2] = $4;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$1 = i64toi32_i32$1 + 48 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $8;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$1 = $0 + 32 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $9;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  HEAP8[($0 + 128 | 0) >> 0] = HEAPU8[($1 + 128 | 0) >> 0] | 0;
  i64toi32_i32$2 = $14$hi;
  i64toi32_i32$1 = $0 + 104 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $14;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $15$hi;
  i64toi32_i32$1 = $0 + 96 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $15;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $16$hi;
  i64toi32_i32$1 = $0 + 88 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $16;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $17$hi;
  i64toi32_i32$1 = $0 + 80 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $17;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$1 = $0 + 64 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $7;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$3 = $2;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$2;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 12 | 0) >> 2] | 0;
  $105 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $105;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$1 = $0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $7;
  HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 1;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
 }
 
 function cardano_serialization_lib__tx_builder__TransactionBuilderConfigBuilder__coins_per_utxo_word__hf5d1cdcac9071bfd($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $14 = 0, $14$hi = 0, $3 = 0, $4 = 0, $7 = 0, $7$hi = 0, $8 = 0, $8$hi = 0, $9 = 0, $9$hi = 0, $5 = 0, $6 = 0, $10 = 0, $10$hi = 0, $11 = 0, $11$hi = 0, $12 = 0, $12$hi = 0, $13 = 0, $13$hi = 0, $15 = 0, $15$hi = 0, $16 = 0, $16$hi = 0, $17 = 0, $17$hi = 0, $18 = 0, $18$hi = 0, $108 = 0;
  $3 = HEAP32[($1 + 124 | 0) >> 2] | 0;
  $4 = HEAP32[($1 + 116 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1 + 48 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 32 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$1;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $9 = i64toi32_i32$0;
  $9$hi = i64toi32_i32$1;
  $5 = HEAP32[($1 + 120 | 0) >> 2] | 0;
  $6 = HEAP32[($1 + 112 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] | 0;
  $10 = i64toi32_i32$1;
  $10$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $11 = i64toi32_i32$0;
  $11$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $12 = i64toi32_i32$1;
  $12$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $13 = i64toi32_i32$0;
  $13$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 72 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 76 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    i64toi32_i32$3 = 1;
    if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
     break label$2
    }
    i64toi32_i32$2 = 0;
    $14 = 0;
    $14$hi = i64toi32_i32$2;
    break label$1;
   }
   i64toi32_i32$3 = $1 + 104 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $15 = i64toi32_i32$2;
   $15$hi = i64toi32_i32$0;
   i64toi32_i32$3 = $1 + 96 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $16 = i64toi32_i32$0;
   $16$hi = i64toi32_i32$2;
   i64toi32_i32$3 = $1 + 88 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $17 = i64toi32_i32$2;
   $17$hi = i64toi32_i32$0;
   i64toi32_i32$3 = $1 + 80 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $18 = i64toi32_i32$0;
   $18$hi = i64toi32_i32$2;
   i64toi32_i32$2 = 0;
   $14 = 1;
   $14$hi = i64toi32_i32$2;
  }
  HEAP32[($0 + 120 | 0) >> 2] = $5;
  HEAP32[($0 + 112 | 0) >> 2] = $6;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 40 | 0) >> 2] = $10;
  HEAP32[(i64toi32_i32$0 + 44 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $11$hi;
  HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = $11;
  HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $12$hi;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $12;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $13$hi;
  HEAP32[i64toi32_i32$0 >> 2] = $13;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $14$hi;
  HEAP32[(i64toi32_i32$0 + 72 | 0) >> 2] = $14;
  HEAP32[(i64toi32_i32$0 + 76 | 0) >> 2] = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$0 + 124 | 0) >> 2] = $3;
  HEAP32[(i64toi32_i32$0 + 116 | 0) >> 2] = $4;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$0 = i64toi32_i32$0 + 48 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$0 = $0 + 32 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$0 = $0 + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $9;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  HEAP8[($0 + 128 | 0) >> 0] = HEAPU8[($1 + 128 | 0) >> 0] | 0;
  i64toi32_i32$2 = $15$hi;
  i64toi32_i32$0 = $0 + 104 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $15;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $16$hi;
  i64toi32_i32$0 = $0 + 96 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $16;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $17$hi;
  i64toi32_i32$0 = $0 + 88 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $17;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $18$hi;
  i64toi32_i32$0 = $0 + 80 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$3 = $2;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
  $108 = i64toi32_i32$2;
  i64toi32_i32$2 = $0 + 64 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $108;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = 0;
  HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] = 1;
  HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] = i64toi32_i32$0;
 }
 
 function cardano_serialization_lib__tx_builder__TransactionBuilderConfigBuilder__pool_deposit__hbdae78e370aa38b6($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $14 = 0, $14$hi = 0, $7 = 0, $7$hi = 0, $3 = 0, $4 = 0, $8 = 0, $8$hi = 0, $9 = 0, $9$hi = 0, $10 = 0, $10$hi = 0, $5 = 0, $6 = 0, $11 = 0, $11$hi = 0, $12 = 0, $12$hi = 0, $13 = 0, $13$hi = 0, $15 = 0, $15$hi = 0, $16 = 0, $16$hi = 0, $17 = 0, $17$hi = 0, $18 = 0, $18$hi = 0, $108 = 0;
  i64toi32_i32$2 = $1 + 64 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  $3 = HEAP32[($1 + 124 | 0) >> 2] | 0;
  $4 = HEAP32[($1 + 116 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1 + 48 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$1;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $9 = i64toi32_i32$0;
  $9$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
  $10 = i64toi32_i32$1;
  $10$hi = i64toi32_i32$0;
  $5 = HEAP32[(i64toi32_i32$2 + 120 | 0) >> 2] | 0;
  $6 = HEAP32[(i64toi32_i32$2 + 112 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] | 0;
  $11 = i64toi32_i32$0;
  $11$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $12 = i64toi32_i32$1;
  $12$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $13 = i64toi32_i32$0;
  $13$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 72 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 76 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    i64toi32_i32$3 = 1;
    if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
     break label$2
    }
    i64toi32_i32$2 = 0;
    $14 = 0;
    $14$hi = i64toi32_i32$2;
    break label$1;
   }
   i64toi32_i32$3 = $1 + 104 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $15 = i64toi32_i32$2;
   $15$hi = i64toi32_i32$0;
   i64toi32_i32$3 = $1 + 96 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $16 = i64toi32_i32$0;
   $16$hi = i64toi32_i32$2;
   i64toi32_i32$3 = $1 + 88 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $17 = i64toi32_i32$2;
   $17$hi = i64toi32_i32$0;
   i64toi32_i32$3 = $1 + 80 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $18 = i64toi32_i32$0;
   $18$hi = i64toi32_i32$2;
   i64toi32_i32$2 = 0;
   $14 = 1;
   $14$hi = i64toi32_i32$2;
  }
  HEAP32[($0 + 120 | 0) >> 2] = $5;
  HEAP32[($0 + 112 | 0) >> 2] = $6;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 40 | 0) >> 2] = $11;
  HEAP32[(i64toi32_i32$0 + 44 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $12$hi;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $12;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $13$hi;
  HEAP32[i64toi32_i32$0 >> 2] = $13;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $14$hi;
  HEAP32[(i64toi32_i32$0 + 72 | 0) >> 2] = $14;
  HEAP32[(i64toi32_i32$0 + 76 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  HEAP32[(i64toi32_i32$0 + 56 | 0) >> 2] = $10;
  HEAP32[(i64toi32_i32$0 + 60 | 0) >> 2] = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$0 + 124 | 0) >> 2] = $3;
  HEAP32[(i64toi32_i32$0 + 116 | 0) >> 2] = $4;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$0 = i64toi32_i32$0 + 48 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$0 = $0 + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $9;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  HEAP8[($0 + 128 | 0) >> 0] = HEAPU8[($1 + 128 | 0) >> 0] | 0;
  i64toi32_i32$2 = $15$hi;
  i64toi32_i32$0 = $0 + 104 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $15;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $16$hi;
  i64toi32_i32$0 = $0 + 96 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $16;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $17$hi;
  i64toi32_i32$0 = $0 + 88 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $17;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $18$hi;
  i64toi32_i32$0 = $0 + 80 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$0 = $0 + 64 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$3 = $2;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
  $108 = i64toi32_i32$2;
  i64toi32_i32$2 = $0 + 32 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $108;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = 0;
  HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] = 1;
  HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] = i64toi32_i32$0;
 }
 
 function cardano_serialization_lib__tx_builder__TransactionBuilderConfigBuilder__key_deposit__h5629eb2f970b40c9($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $14 = 0, $14$hi = 0, $7 = 0, $7$hi = 0, $3 = 0, $4 = 0, $8 = 0, $8$hi = 0, $9 = 0, $9$hi = 0, $10 = 0, $10$hi = 0, $5 = 0, $6 = 0, $11 = 0, $11$hi = 0, $12 = 0, $12$hi = 0, $13 = 0, $13$hi = 0, $15 = 0, $15$hi = 0, $16 = 0, $16$hi = 0, $17 = 0, $17$hi = 0, $18 = 0, $18$hi = 0, $108 = 0;
  i64toi32_i32$2 = $1 + 64 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  $3 = HEAP32[($1 + 124 | 0) >> 2] | 0;
  $4 = HEAP32[($1 + 116 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1 + 32 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$1;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $9 = i64toi32_i32$0;
  $9$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
  $10 = i64toi32_i32$1;
  $10$hi = i64toi32_i32$0;
  $5 = HEAP32[(i64toi32_i32$2 + 120 | 0) >> 2] | 0;
  $6 = HEAP32[(i64toi32_i32$2 + 112 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $11 = i64toi32_i32$0;
  $11$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $12 = i64toi32_i32$1;
  $12$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $13 = i64toi32_i32$0;
  $13$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 72 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 76 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    i64toi32_i32$3 = 1;
    if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
     break label$2
    }
    i64toi32_i32$2 = 0;
    $14 = 0;
    $14$hi = i64toi32_i32$2;
    break label$1;
   }
   i64toi32_i32$3 = $1 + 104 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $15 = i64toi32_i32$2;
   $15$hi = i64toi32_i32$0;
   i64toi32_i32$3 = $1 + 96 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $16 = i64toi32_i32$0;
   $16$hi = i64toi32_i32$2;
   i64toi32_i32$3 = $1 + 88 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $17 = i64toi32_i32$2;
   $17$hi = i64toi32_i32$0;
   i64toi32_i32$3 = $1 + 80 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $18 = i64toi32_i32$0;
   $18$hi = i64toi32_i32$2;
   i64toi32_i32$2 = 0;
   $14 = 1;
   $14$hi = i64toi32_i32$2;
  }
  HEAP32[($0 + 120 | 0) >> 2] = $5;
  HEAP32[($0 + 112 | 0) >> 2] = $6;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = $11;
  HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $12$hi;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $12;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $13$hi;
  HEAP32[i64toi32_i32$0 >> 2] = $13;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $14$hi;
  HEAP32[(i64toi32_i32$0 + 72 | 0) >> 2] = $14;
  HEAP32[(i64toi32_i32$0 + 76 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  HEAP32[(i64toi32_i32$0 + 56 | 0) >> 2] = $10;
  HEAP32[(i64toi32_i32$0 + 60 | 0) >> 2] = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$0 + 124 | 0) >> 2] = $3;
  HEAP32[(i64toi32_i32$0 + 116 | 0) >> 2] = $4;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$0 = i64toi32_i32$0 + 32 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$0 = $0 + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $9;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  HEAP8[($0 + 128 | 0) >> 0] = HEAPU8[($1 + 128 | 0) >> 0] | 0;
  i64toi32_i32$2 = $15$hi;
  i64toi32_i32$0 = $0 + 104 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $15;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $16$hi;
  i64toi32_i32$0 = $0 + 96 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $16;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $17$hi;
  i64toi32_i32$0 = $0 + 88 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $17;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $18$hi;
  i64toi32_i32$0 = $0 + 80 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$0 = $0 + 64 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$3 = $2;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
  $108 = i64toi32_i32$2;
  i64toi32_i32$2 = $0 + 48 | 0;
  HEAP32[i64toi32_i32$2 >> 2] = $108;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = 0;
  HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] = 1;
  HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] = i64toi32_i32$0;
 }
 
 function cardano_serialization_lib__plutus__PlutusScript__hash__hf798a55ecc919284($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $3 = 0, $12 = 0, $13 = 0, $14 = 0, $15 = 0, $17 = 0, $4 = 0, $16 = 0, $75 = 0, $79 = 0, $82 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 + 24 | 0 | 0, (HEAP32[($1 + 8 | 0) >> 2] | 0) + 1 | 0 | 0, 0 | 0);
  HEAP32[($2 + 40 | 0) >> 2] = 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $16 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $16;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   $3 = __rust_alloc(1 | 0, 1 | 0) | 0;
   if ($3) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(1 | 0, 1 | 0);
   abort();
  }
  HEAP8[$3 >> 0] = 1;
  alloc__slice__hack__into_vec__h7c95d082cf6730ee($2 + 48 | 0 | 0, $3 | 0, 1 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($2 + 32 | 0 | 0, HEAP32[($2 + 16 | 0) >> 2] | 0 | 0, HEAP32[($2 + 20 | 0) >> 2] | 0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 48 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 48 | 0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $1 | 0);
  alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($2 + 32 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 | 0, $2 + 32 | 0 | 0);
  $1 = ($2 + 48 | 0) + 8 | 0;
  i64toi32_i32$0 = $1;
  i64toi32_i32$1 = 0;
  HEAP32[i64toi32_i32$0 >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $3 = ($2 + 48 | 0) + 16 | 0;
  i64toi32_i32$0 = $3;
  i64toi32_i32$1 = 0;
  HEAP32[i64toi32_i32$0 >> 2] = 0;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $4 = ($2 + 48 | 0) + 24 | 0;
  HEAP32[$4 >> 2] = 0;
  i64toi32_i32$0 = $2;
  i64toi32_i32$1 = 0;
  HEAP32[($2 + 48 | 0) >> 2] = 0;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cryptoxide__blake2b__Blake2b__blake2b__hfbfc741a485cb529($2 + 48 | 0 | 0, 28 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 1066228 | 0, 0 | 0);
  $12 = $0 + 24 | 0;
  $13 = HEAP32[$4 >> 2] | 0;
  HEAP8[$12 >> 0] = $13;
  HEAP8[($12 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[($12 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[($12 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $75 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 16 | 0;
  $14 = $75;
  HEAP8[i64toi32_i32$1 >> 0] = $14;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $14 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $14 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $14 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $79 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 8 | 0;
  $15 = $79;
  HEAP8[i64toi32_i32$0 >> 0] = $15;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $15 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $15 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $15 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $82 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  $17 = $82;
  HEAP8[i64toi32_i32$1 >> 0] = $17;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 32 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 32 | 0 | 0);
  global$0 = $2 + 80 | 0;
 }
 
 function $_mut_20W_20as_20core__fmt__Write___write_char__h71890a50e5130dc8($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $0 = HEAP32[$0 >> 2] | 0;
  HEAP32[($2 + 12 | 0) >> 2] = 0;
  label$1 : {
   label$2 : {
    if ($1 >>> 0 < 128 >>> 0) {
     break label$2
    }
    label$3 : {
     if ($1 >>> 0 < 2048 >>> 0) {
      break label$3
     }
     label$4 : {
      if ($1 >>> 0 < 65536 >>> 0) {
       break label$4
      }
      HEAP8[($2 + 15 | 0) >> 0] = $1 & 63 | 0 | 128 | 0;
      HEAP8[($2 + 12 | 0) >> 0] = $1 >>> 18 | 0 | 240 | 0;
      HEAP8[($2 + 14 | 0) >> 0] = ($1 >>> 6 | 0) & 63 | 0 | 128 | 0;
      HEAP8[($2 + 13 | 0) >> 0] = ($1 >>> 12 | 0) & 63 | 0 | 128 | 0;
      $1 = 4;
      break label$1;
     }
     HEAP8[($2 + 14 | 0) >> 0] = $1 & 63 | 0 | 128 | 0;
     HEAP8[($2 + 12 | 0) >> 0] = $1 >>> 12 | 0 | 224 | 0;
     HEAP8[($2 + 13 | 0) >> 0] = ($1 >>> 6 | 0) & 63 | 0 | 128 | 0;
     $1 = 3;
     break label$1;
    }
    HEAP8[($2 + 13 | 0) >> 0] = $1 & 63 | 0 | 128 | 0;
    HEAP8[($2 + 12 | 0) >> 0] = $1 >>> 6 | 0 | 192 | 0;
    $1 = 2;
    break label$1;
   }
   HEAP8[($2 + 12 | 0) >> 0] = $1;
   $1 = 1;
  }
  label$5 : {
   $3 = HEAP32[$0 >> 2] | 0;
   $4 = $3 + 8 | 0;
   $0 = HEAP32[$4 >> 2] | 0;
   if (((HEAP32[($3 + 4 | 0) >> 2] | 0) - $0 | 0) >>> 0 >= $1 >>> 0) {
    break label$5
   }
   alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hc5a84431bcb0aafc($3 | 0, $0 | 0, $1 | 0);
   $0 = HEAP32[$4 >> 2] | 0;
  }
  memcpy((HEAP32[$3 >> 2] | 0) + $0 | 0 | 0, $2 + 12 | 0 | 0, $1 | 0) | 0;
  HEAP32[$4 >> 2] = $0 + $1 | 0;
  global$0 = $2 + 16 | 0;
  return 0 | 0;
 }
 
 function core__fmt__num___impl_20core__fmt__Debug_20for_20usize___fmt__h57d075c2d6ce4f59($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $3 = 0, $4 = 0, $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 128 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       $3 = HEAP32[$1 >> 2] | 0;
       if ($3 & 16 | 0) {
        break label$5
       }
       if ($3 & 32 | 0) {
        break label$4
       }
       i64toi32_i32$1 = 0;
       $0 = core__fmt__num__imp__fmt_u64__hf0469431dace4046(HEAP32[$0 >> 2] | 0 | 0, i64toi32_i32$1 | 0, 1 | 0, $1 | 0) | 0;
       break label$1;
      }
      $3 = HEAP32[$0 >> 2] | 0;
      $0 = 0;
      label$6 : while (1) {
       $4 = $3 & 15 | 0;
       HEAP8[(($2 + $0 | 0) + 127 | 0) >> 0] = $4 >>> 0 < 10 >>> 0 ? $4 | 48 | 0 : $4 + 87 | 0;
       $0 = $0 + -1 | 0;
       $3 = $3 >>> 4 | 0;
       if ($3) {
        continue label$6
       }
       break label$6;
      };
      $3 = $0 + 128 | 0;
      if ($3 >>> 0 >= 129 >>> 0) {
       break label$3
      }
      $0 = core__fmt__Formatter__pad_integral__h08e3e53a0de517a1($1 | 0, 1 | 0, 1150180 | 0, 2 | 0, ($2 + $0 | 0) + 128 | 0 | 0, 0 - $0 | 0 | 0) | 0;
      break label$1;
     }
     $3 = HEAP32[$0 >> 2] | 0;
     $0 = 0;
     label$7 : while (1) {
      $4 = $3 & 15 | 0;
      HEAP8[(($2 + $0 | 0) + 127 | 0) >> 0] = $4 >>> 0 < 10 >>> 0 ? $4 | 48 | 0 : $4 + 55 | 0;
      $0 = $0 + -1 | 0;
      $3 = $3 >>> 4 | 0;
      if ($3) {
       continue label$7
      }
      break label$7;
     };
     $3 = $0 + 128 | 0;
     if ($3 >>> 0 >= 129 >>> 0) {
      break label$2
     }
     $0 = core__fmt__Formatter__pad_integral__h08e3e53a0de517a1($1 | 0, 1 | 0, 1150180 | 0, 2 | 0, ($2 + $0 | 0) + 128 | 0 | 0, 0 - $0 | 0 | 0) | 0;
     break label$1;
    }
    core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($3 | 0, 128 | 0, 1150164 | 0);
    abort();
   }
   core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($3 | 0, 128 | 0, 1150164 | 0);
   abort();
  }
  global$0 = $2 + 128 | 0;
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__chain_crypto__key__SecretKey_A__20as_20cardano_serialization_lib__chain_crypto__bech32__Bech32___try_from_bech32_str__h16428d5ee4f524c4($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $4 = 0, $5 = 0, $6 = 0, $28 = 0, $4$hi = 0, $5$hi = 0, $6$hi = 0;
  $3 = global$0 - 112 | 0;
  global$0 = $3;
  cardano_serialization_lib__chain_crypto__bech32__try_from_bech32_to_bytes__h3f2ab2a8146239be($3 + 48 | 0 | 0, $1 | 0, $2 | 0);
  $1 = $3 + 48 | 0 | 4 | 0;
  label$1 : {
   label$2 : {
    if ((HEAP32[($3 + 48 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    HEAP32[(($3 + 8 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $1;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $28 = i64toi32_i32$0;
    i64toi32_i32$0 = $3;
    HEAP32[($3 + 8 | 0) >> 2] = $28;
    HEAP32[($3 + 12 | 0) >> 2] = i64toi32_i32$1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 | 0, $3 + 8 | 0 | 0);
    label$3 : {
     label$4 : {
      if ((HEAP32[($3 + 4 | 0) >> 2] | 0 | 0) != (64 | 0)) {
       break label$4
      }
      $2 = HEAP32[$3 >> 2] | 0;
      $1 = 0;
      memset($3 + 48 | 0 | 0, 0 | 0, 64 | 0) | 0;
      core__slice___impl_20_5bT_5d___clone_from_slice__h1742dfbd5d5d9efd($3 + 48 | 0 | 0, 64 | 0, $2 | 0, 64 | 0);
      $2 = HEAPU8[($3 + 48 | 0) >> 0] | 0;
      memcpy($0 + 2 | 0 | 0, $3 + 49 | 0 | 0, 63 | 0) | 0;
      HEAP8[($0 + 1 | 0) >> 0] = $2;
      break label$3;
     }
     cardano_serialization_lib__chain_crypto__bech32__Error__data_invalid__he819388589c1a4db($0 + 4 | 0 | 0, 0 | 0);
     $1 = 1;
    }
    HEAP8[$0 >> 0] = $1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 8 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 8 | 0 | 0);
    break label$1;
   }
   i64toi32_i32$2 = $1 + 16 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $4 = i64toi32_i32$1;
   $4$hi = i64toi32_i32$0;
   i64toi32_i32$1 = ($3 + 24 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $4;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $1 + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $5 = i64toi32_i32$0;
   $5$hi = i64toi32_i32$1;
   i64toi32_i32$0 = ($3 + 24 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $5;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $6 = i64toi32_i32$1;
   $6$hi = i64toi32_i32$0;
   i64toi32_i32$1 = $3;
   HEAP32[($3 + 24 | 0) >> 2] = $6;
   HEAP32[($3 + 28 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $4$hi;
   i64toi32_i32$1 = $0 + 20 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $4;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $5$hi;
   i64toi32_i32$1 = $0 + 12 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $5;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $6$hi;
   i64toi32_i32$1 = $0 + 4 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $6;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP8[$0 >> 0] = 1;
  }
  global$0 = $3 + 112 | 0;
 }
 
 function cardano_serialization_lib__tx_builder__TransactionBuilderConfigBuilder__max_value_size__hd6015462fc9a24a1($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $5 = 0, $5$hi = 0, $6 = 0, $6$hi = 0, $3 = 0, $7 = 0, $7$hi = 0, $8 = 0, $8$hi = 0, $9 = 0, $9$hi = 0, $10 = 0, $10$hi = 0, $4 = 0, $11 = 0, $11$hi = 0, $12 = 0, $12$hi = 0, $13 = 0, $13$hi = 0, $14 = 0, $14$hi = 0, $15 = 0, $15$hi = 0, $16 = 0, $16$hi = 0, $17 = 0, $17$hi = 0, $18 = 0, $18$hi = 0;
  i64toi32_i32$0 = 0;
  $5 = 1;
  $5$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $1 + 64 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $6 = i64toi32_i32$0;
  $6$hi = i64toi32_i32$1;
  $3 = HEAP32[($1 + 124 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1 + 48 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$1;
  $7$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $1 + 32 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  $4 = HEAP32[(i64toi32_i32$2 + 120 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] | 0;
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $12 = i64toi32_i32$0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $13 = i64toi32_i32$1;
  $13$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  $14$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 72 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 76 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    i64toi32_i32$3 = 1;
    if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
     break label$2
    }
    i64toi32_i32$2 = 0;
    $5 = 0;
    $5$hi = i64toi32_i32$2;
    break label$1;
   }
   i64toi32_i32$3 = $1 + 104 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $15 = i64toi32_i32$2;
   $15$hi = i64toi32_i32$0;
   i64toi32_i32$3 = $1 + 96 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $16 = i64toi32_i32$0;
   $16$hi = i64toi32_i32$2;
   i64toi32_i32$3 = $1 + 88 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $17 = i64toi32_i32$2;
   $17$hi = i64toi32_i32$0;
   i64toi32_i32$3 = $1 + 80 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $18 = i64toi32_i32$0;
   $18$hi = i64toi32_i32$2;
  }
  HEAP32[($0 + 120 | 0) >> 2] = $4;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 40 | 0) >> 2] = $11;
  HEAP32[(i64toi32_i32$0 + 44 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $12$hi;
  HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = $12;
  HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $13$hi;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $13;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $14$hi;
  HEAP32[i64toi32_i32$0 >> 2] = $14;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $5$hi;
  HEAP32[(i64toi32_i32$0 + 72 | 0) >> 2] = $5;
  HEAP32[(i64toi32_i32$0 + 76 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  HEAP32[(i64toi32_i32$0 + 56 | 0) >> 2] = $10;
  HEAP32[(i64toi32_i32$0 + 60 | 0) >> 2] = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$0 + 112 | 0) >> 2] = 1;
  HEAP32[(i64toi32_i32$0 + 124 | 0) >> 2] = $3;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$0 = i64toi32_i32$0 + 48 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$0 = $0 + 32 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$0 = $0 + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $9;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  HEAP8[($0 + 128 | 0) >> 0] = HEAPU8[($1 + 128 | 0) >> 0] | 0;
  i64toi32_i32$2 = $15$hi;
  i64toi32_i32$0 = $0 + 104 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $15;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $16$hi;
  i64toi32_i32$0 = $0 + 96 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $16;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $17$hi;
  i64toi32_i32$0 = $0 + 88 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $17;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $18$hi;
  i64toi32_i32$0 = $0 + 80 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $6$hi;
  i64toi32_i32$0 = $0 + 64 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $6;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  HEAP32[($0 + 116 | 0) >> 2] = $2;
 }
 
 function cardano_serialization_lib__tx_builder__TransactionBuilderConfigBuilder__max_tx_size__h97befc95fd4e5f5a($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $5 = 0, $5$hi = 0, $6 = 0, $6$hi = 0, $3 = 0, $7 = 0, $7$hi = 0, $8 = 0, $8$hi = 0, $9 = 0, $9$hi = 0, $10 = 0, $10$hi = 0, $4 = 0, $11 = 0, $11$hi = 0, $12 = 0, $12$hi = 0, $13 = 0, $13$hi = 0, $14 = 0, $14$hi = 0, $15 = 0, $15$hi = 0, $16 = 0, $16$hi = 0, $17 = 0, $17$hi = 0, $18 = 0, $18$hi = 0;
  i64toi32_i32$0 = 0;
  $5 = 1;
  $5$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $1 + 64 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $6 = i64toi32_i32$0;
  $6$hi = i64toi32_i32$1;
  $3 = HEAP32[($1 + 116 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1 + 48 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$1;
  $7$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $1 + 32 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  $4 = HEAP32[(i64toi32_i32$2 + 112 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] | 0;
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $12 = i64toi32_i32$0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $13 = i64toi32_i32$1;
  $13$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  $14$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 72 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 76 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    i64toi32_i32$3 = 1;
    if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
     break label$2
    }
    i64toi32_i32$2 = 0;
    $5 = 0;
    $5$hi = i64toi32_i32$2;
    break label$1;
   }
   i64toi32_i32$3 = $1 + 104 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $15 = i64toi32_i32$2;
   $15$hi = i64toi32_i32$0;
   i64toi32_i32$3 = $1 + 96 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $16 = i64toi32_i32$0;
   $16$hi = i64toi32_i32$2;
   i64toi32_i32$3 = $1 + 88 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $17 = i64toi32_i32$2;
   $17$hi = i64toi32_i32$0;
   i64toi32_i32$3 = $1 + 80 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $18 = i64toi32_i32$0;
   $18$hi = i64toi32_i32$2;
  }
  HEAP32[($0 + 112 | 0) >> 2] = $4;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 40 | 0) >> 2] = $11;
  HEAP32[(i64toi32_i32$0 + 44 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $12$hi;
  HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = $12;
  HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $13$hi;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $13;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $14$hi;
  HEAP32[i64toi32_i32$0 >> 2] = $14;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $5$hi;
  HEAP32[(i64toi32_i32$0 + 72 | 0) >> 2] = $5;
  HEAP32[(i64toi32_i32$0 + 76 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  HEAP32[(i64toi32_i32$0 + 56 | 0) >> 2] = $10;
  HEAP32[(i64toi32_i32$0 + 60 | 0) >> 2] = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$0 + 120 | 0) >> 2] = 1;
  HEAP32[(i64toi32_i32$0 + 116 | 0) >> 2] = $3;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$0 = i64toi32_i32$0 + 48 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$0 = $0 + 32 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$0 = $0 + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $9;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  HEAP8[($0 + 128 | 0) >> 0] = HEAPU8[($1 + 128 | 0) >> 0] | 0;
  i64toi32_i32$2 = $15$hi;
  i64toi32_i32$0 = $0 + 104 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $15;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $16$hi;
  i64toi32_i32$0 = $0 + 96 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $16;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $17$hi;
  i64toi32_i32$0 = $0 + 88 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $17;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $18$hi;
  i64toi32_i32$0 = $0 + 80 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $6$hi;
  i64toi32_i32$0 = $0 + 64 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $6;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  HEAP32[($0 + 124 | 0) >> 2] = $2;
 }
 
 function hashbrown__map__HashMap_K_2cV_2cS_2cA___insert__h7cbfd3192332bd8d($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $7 = 0, $5 = 0, $6 = 0, $13 = 0, i64toi32_i32$1 = 0, $9 = 0, $8 = 0, i64toi32_i32$0 = 0, $9$hi = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  HEAP32[($4 + 20 | 0) >> 2] = $2;
  i64toi32_i32$0 = hashbrown__map__make_insert_hash__he686a9e564c69811($1 | 0, $4 + 20 | 0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $9 = i64toi32_i32$0;
  $9$hi = i64toi32_i32$1;
  $5 = $9;
  $6 = (HEAP32[($1 + 16 | 0) >> 2] | 0) & $5 | 0;
  $13 = (HEAP32[($1 + 20 | 0) >> 2] | 0) + $6 | 0;
  $7 = HEAPU8[$13 >> 0] | 0 | ((HEAPU8[($13 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($13 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($13 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $8 = 0;
  HEAP32[($4 + 32 | 0) >> 2] = 0;
  HEAP32[($4 + 36 | 0) >> 2] = $7;
  HEAP32[($4 + 28 | 0) >> 2] = $6;
  $6 = $1 + 16 | 0;
  HEAP32[($4 + 24 | 0) >> 2] = $6;
  $5 = $5 >>> 25 | 0;
  HEAP8[($4 + 44 | 0) >> 0] = $5;
  $7 = $7 ^ Math_imul($5, 16843009) | 0;
  HEAP32[($4 + 40 | 0) >> 2] = (($7 ^ -1 | 0) & ($7 + -16843009 | 0) | 0) & -2139062144 | 0;
  $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($4 + 8 | 0 | 0, $4 + 24 | 0 | 0);
  label$1 : {
   label$2 : {
    if (!(HEAP32[($4 + 8 | 0) >> 2] | 0)) {
     break label$2
    }
    label$3 : {
     $7 = (HEAP32[((HEAP32[($4 + 24 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) - ((HEAP32[($4 + 12 | 0) >> 2] | 0) << 3 | 0) | 0;
     if ($cardano_serialization_lib__metadata__TransactionMetadatum_20as_20core__cmp__PartialEq___eq__h3bd33dd828bf70c0($2 | 0, HEAP32[($7 + -8 | 0) >> 2] | 0 | 0) | 0) {
      break label$3
     }
     label$4 : while (1) {
      $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($4 | 0, $4 + 24 | 0 | 0);
      if (!(HEAP32[$4 >> 2] | 0)) {
       break label$2
      }
      $7 = (HEAP32[((HEAP32[($4 + 24 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) - ((HEAP32[($4 + 4 | 0) >> 2] | 0) << 3 | 0) | 0;
      if (!($cardano_serialization_lib__metadata__TransactionMetadatum_20as_20core__cmp__PartialEq___eq__h3bd33dd828bf70c0($2 | 0, HEAP32[($7 + -8 | 0) >> 2] | 0 | 0) | 0)) {
       continue label$4
      }
      break label$4;
     };
    }
    $2 = $7 + -4 | 0;
    $1 = HEAP32[$2 >> 2] | 0;
    HEAP32[$2 >> 2] = $3;
    $8 = 1;
    break label$1;
   }
   i64toi32_i32$1 = $9$hi;
   hashbrown__raw__RawTable_T_2cA___insert__h418758a7d461f33b($6 | 0, $9 | 0, i64toi32_i32$1 | 0, $2 | 0, $3 | 0, $1 | 0) | 0;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[$0 >> 2] = $8;
  global$0 = $4 + 48 | 0;
 }
 
 function cryptoxide__hashing__sha2__Engine512__finish__h18b5152b4b76c624($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $4 = 0, $4$hi = 0, $3 = 0, $1 = 0, $76 = 0, $77 = 0, $2 = 0, $79 = 0, $80 = 0, $83 = 0, $84 = 0, $86 = 0, $87 = 0, $91 = 0, $92 = 0, $93 = 0, $94 = 0, $95 = 0, $96 = 0, $97 = 0, $98 = 0, $99 = 0, $100 = 0, $101 = 0, $102 = 0, $103 = 0, $5 = 0, $5$hi = 0, $25 = 0, $27 = 0, $27$hi = 0, $30 = 0, $30$hi = 0, $31 = 0, $31$hi = 0, $34 = 0, $34$hi = 0, $37 = 0, $37$hi = 0, $38 = 0, $38$hi = 0, $39 = 0, $39$hi = 0, $42 = 0, $42$hi = 0, $45 = 0, $45$hi = 0, $46 = 0, $46$hi = 0, $49 = 0, $49$hi = 0, $52$hi = 0, $53 = 0, $53$hi = 0, $54 = 0, $54$hi = 0, $55 = 0, $56 = 0, $58 = 0, $58$hi = 0, $60$hi = 0, $63 = 0, $63$hi = 0, $66 = 0, $66$hi = 0, $67 = 0, $67$hi = 0, $70 = 0, $70$hi = 0, $73 = 0, $73$hi = 0, $74 = 0, $74$hi = 0, $75 = 0, $75$hi = 0, $78 = 0, $78$hi = 0, $81 = 0, $81$hi = 0, $82 = 0, $82$hi = 0, $85 = 0, $85$hi = 0, $87$hi = 0, $88 = 0, $88$hi = 0, $89 = 0, $89$hi = 0, $90 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $2 = $0 + 16 | 0;
  HEAP32[($1 + 12 | 0) >> 2] = $2;
  $3 = $0 + 80 | 0;
  cryptoxide__cryptoutil__FixedBuffer_____standard_padding__h5ee4664d1cf7fba4($3 | 0, 16 | 0, $1 + 12 | 0 | 0);
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $5 = i64toi32_i32$1;
  $5$hi = i64toi32_i32$0;
  $3 = cryptoxide__cryptoutil__FixedBuffer_____next__h1344043422db2ab6($3 | 0) | 0;
  $25 = $3;
  i64toi32_i32$0 = $4$hi;
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 59;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $79 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $79 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $27 = $79;
  $27$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $4$hi;
  i64toi32_i32$0 = $4;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 43;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   $80 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $80 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
  }
  i64toi32_i32$1 = $80;
  i64toi32_i32$0 = 16711680;
  i64toi32_i32$3 = 0;
  i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
  $30 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
  $30$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $27$hi;
  i64toi32_i32$2 = $27;
  i64toi32_i32$1 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
  $31 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  $31$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $4$hi;
  i64toi32_i32$0 = $4;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 27;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   $83 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $83 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
  }
  i64toi32_i32$1 = $83;
  i64toi32_i32$0 = 65280;
  i64toi32_i32$3 = 0;
  i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
  $34 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
  $34$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $4$hi;
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 11;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $84 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $84 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  i64toi32_i32$0 = $84;
  i64toi32_i32$2 = 255;
  i64toi32_i32$3 = 0;
  i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
  $37 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
  $37$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $34$hi;
  i64toi32_i32$1 = $34;
  i64toi32_i32$0 = $37$hi;
  i64toi32_i32$3 = $37;
  i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
  $38 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  $38$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $31$hi;
  i64toi32_i32$2 = $31;
  i64toi32_i32$1 = $38$hi;
  i64toi32_i32$3 = $38;
  i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
  $39 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  $39$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $4$hi;
  i64toi32_i32$0 = $4;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 5;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $86 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   $86 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
  }
  i64toi32_i32$1 = $86;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = -16777216;
  i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
  $42 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
  $42$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $4$hi;
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 21;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $87 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $87 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  i64toi32_i32$0 = $87;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 16711680;
  i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
  $45 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
  $45$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $42$hi;
  i64toi32_i32$1 = $42;
  i64toi32_i32$0 = $45$hi;
  i64toi32_i32$3 = $45;
  i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
  $46 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  $46$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $4$hi;
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 37;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $91 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $91 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  i64toi32_i32$0 = $91;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 65280;
  i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
  $49 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
  $49$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$1 = $4;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 3;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
   $92 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
   $92 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
  }
  i64toi32_i32$2 = $92;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $93 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $93 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  $52$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $49$hi;
  i64toi32_i32$0 = $49;
  i64toi32_i32$2 = $52$hi;
  i64toi32_i32$3 = $93;
  i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
  $53 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $53$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $46$hi;
  i64toi32_i32$1 = $46;
  i64toi32_i32$0 = $53$hi;
  i64toi32_i32$3 = $53;
  i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
  $54 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  $54$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $39$hi;
  i64toi32_i32$2 = $39;
  i64toi32_i32$1 = $54$hi;
  i64toi32_i32$3 = $54;
  i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
  $55 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $25;
  $76 = $55;
  HEAP8[(i64toi32_i32$2 + 8 | 0) >> 0] = $76;
  HEAP8[(i64toi32_i32$2 + 9 | 0) >> 0] = $76 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 10 | 0) >> 0] = $76 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 11 | 0) >> 0] = $76 >>> 24 | 0;
  HEAP8[(i64toi32_i32$2 + 12 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$2 + 13 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 14 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 15 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $56 = $3;
  i64toi32_i32$1 = $5$hi;
  i64toi32_i32$0 = $5;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 3;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   $94 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $94 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
  }
  $58 = $94;
  $58$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$1 = $4;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 61;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $95 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   $95 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
  }
  $60$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $58$hi;
  i64toi32_i32$2 = $58;
  i64toi32_i32$1 = $60$hi;
  i64toi32_i32$3 = $95;
  i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
  $4 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  $4$hi = i64toi32_i32$1;
  i64toi32_i32$0 = $4;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   $96 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $96 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
  }
  $63 = $96;
  $63$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$1 = $4;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 40;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
   $97 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
   $97 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
  }
  i64toi32_i32$2 = $97;
  i64toi32_i32$1 = 16711680;
  i64toi32_i32$3 = 0;
  i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
  $66 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
  $66$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $63$hi;
  i64toi32_i32$0 = $63;
  i64toi32_i32$2 = $66$hi;
  i64toi32_i32$3 = $66;
  i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
  $67 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $67$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$1 = $4;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 24;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
   $98 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
   $98 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
  }
  i64toi32_i32$2 = $98;
  i64toi32_i32$1 = 65280;
  i64toi32_i32$3 = 0;
  i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
  $70 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
  $70$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $4$hi;
  i64toi32_i32$0 = $4;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 8;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   $99 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $99 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
  }
  i64toi32_i32$1 = $99;
  i64toi32_i32$0 = 255;
  i64toi32_i32$3 = 0;
  i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
  $73 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
  $73$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $70$hi;
  i64toi32_i32$2 = $70;
  i64toi32_i32$1 = $73$hi;
  i64toi32_i32$3 = $73;
  i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
  $74 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  $74$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $67$hi;
  i64toi32_i32$0 = $67;
  i64toi32_i32$2 = $74$hi;
  i64toi32_i32$3 = $74;
  i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
  $75 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $75$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$1 = $4;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 8;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $100 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   $100 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
  }
  i64toi32_i32$2 = $100;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = -16777216;
  i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
  $78 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
  $78$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $4$hi;
  i64toi32_i32$0 = $4;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 24;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $101 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   $101 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
  }
  i64toi32_i32$1 = $101;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 16711680;
  i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
  $81 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
  $81$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $78$hi;
  i64toi32_i32$2 = $78;
  i64toi32_i32$1 = $81$hi;
  i64toi32_i32$3 = $81;
  i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
  $82 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  $82$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $4$hi;
  i64toi32_i32$0 = $4;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 40;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $102 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   $102 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
  }
  i64toi32_i32$1 = $102;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 65280;
  i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
  $85 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
  $85$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $4$hi;
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $103 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $103 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  $87$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $85$hi;
  i64toi32_i32$0 = $85;
  i64toi32_i32$2 = $87$hi;
  i64toi32_i32$3 = $103;
  i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
  $88 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $88$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $82$hi;
  i64toi32_i32$1 = $82;
  i64toi32_i32$0 = $88$hi;
  i64toi32_i32$3 = $88;
  i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
  $89 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  $89$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $75$hi;
  i64toi32_i32$2 = $75;
  i64toi32_i32$1 = $89$hi;
  i64toi32_i32$3 = $89;
  i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
  $90 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $56;
  $77 = $90;
  HEAP8[i64toi32_i32$2 >> 0] = $77;
  HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $77 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $77 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $77 >>> 24 | 0;
  HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  label$1 : {
   if ((HEAP32[($0 + 80 | 0) >> 2] | 0 | 0) == (128 | 0)) {
    break label$1
   }
   core__panicking__panic__h2fd385a887c8bf13(1102824 | 0, 38 | 0, 1102864 | 0);
   abort();
  }
  HEAP32[($0 + 80 | 0) >> 2] = 0;
  cryptoxide__hashing__sha2__impl512__reference__digest_block__h5deb88f07cb6a5e7($2 | 0, $0 + 84 | 0 | 0, 128 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function $cardano_serialization_lib__chain_crypto__key__SecretKey_A__20as_20cardano_serialization_lib__chain_crypto__bech32__Bech32___try_from_bech32_str__h660bc6248fcb5d5a($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $4 = 0, $5 = 0, $6 = 0, $28 = 0, $4$hi = 0, $5$hi = 0, $6$hi = 0;
  $3 = global$0 - 160 | 0;
  global$0 = $3;
  cardano_serialization_lib__chain_crypto__bech32__try_from_bech32_to_bytes__h34c47fd00c9fc177($3 + 56 | 0 | 0, $1 | 0, $2 | 0);
  $1 = $3 + 56 | 0 | 4 | 0;
  label$1 : {
   label$2 : {
    if ((HEAP32[($3 + 56 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    HEAP32[(($3 + 16 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $1;
    i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $28 = i64toi32_i32$0;
    i64toi32_i32$0 = $3;
    HEAP32[($3 + 16 | 0) >> 2] = $28;
    HEAP32[($3 + 20 | 0) >> 2] = i64toi32_i32$1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $3 + 16 | 0 | 0);
    $cardano_serialization_lib__chain_crypto__algorithms__ed25519_derive__Ed25519Bip32_20as_20cardano_serialization_lib__chain_crypto__key__AsymmetricKey___secret_from_binary__h88d2302397adf84f($3 + 56 | 0 | 0, HEAP32[($3 + 8 | 0) >> 2] | 0 | 0, HEAP32[($3 + 12 | 0) >> 2] | 0 | 0);
    $1 = HEAPU8[($3 + 57 | 0) >> 0] | 0;
    label$3 : {
     label$4 : {
      if ((HEAPU8[($3 + 56 | 0) >> 0] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      memcpy($0 + 2 | 0 | 0, $3 + 56 | 0 | 2 | 0 | 0, 95 | 0) | 0;
      HEAP8[($0 + 1 | 0) >> 0] = $1;
      $1 = 0;
      break label$3;
     }
     cardano_serialization_lib__chain_crypto__bech32__Error__data_invalid__he819388589c1a4db($0 + 4 | 0 | 0, ($1 & 255 | 0 | 0) != (0 | 0) | 0);
     $1 = 1;
    }
    HEAP8[$0 >> 0] = $1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 16 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 16 | 0 | 0);
    break label$1;
   }
   i64toi32_i32$2 = $1 + 16 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $4 = i64toi32_i32$1;
   $4$hi = i64toi32_i32$0;
   i64toi32_i32$1 = ($3 + 32 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $4;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $1 + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $5 = i64toi32_i32$0;
   $5$hi = i64toi32_i32$1;
   i64toi32_i32$0 = ($3 + 32 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $5;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   $6 = i64toi32_i32$1;
   $6$hi = i64toi32_i32$0;
   i64toi32_i32$1 = $3;
   HEAP32[($3 + 32 | 0) >> 2] = $6;
   HEAP32[($3 + 36 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $4$hi;
   i64toi32_i32$1 = $0 + 20 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $4;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $5$hi;
   i64toi32_i32$1 = $0 + 12 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $5;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $6$hi;
   i64toi32_i32$1 = $0 + 4 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $6;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP8[$0 >> 0] = 1;
  }
  global$0 = $3 + 160 | 0;
 }
 
 function serde_json__de__Deserializer_R___parse_decimal__he7ea9ce3065727b6($0, $1, $2, $3, $3$hi, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  $4 = $4 | 0;
  var i64toi32_i32$2 = 0, $7 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$5 = 0, i64toi32_i32$1 = 0, $5 = 0, $6 = 0, $8 = 0, $11 = 0, $12 = 0, i64toi32_i32$4 = 0, $9 = 0, $10 = 0, $66 = 0, $66$hi = 0, $69 = 0, $69$hi = 0;
  $5 = global$0 - 16 | 0;
  global$0 = $5;
  $6 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $7 = $6 + 1 | 0;
  HEAP32[($1 + 8 | 0) >> 2] = $7;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        $8 = HEAP32[($1 + 4 | 0) >> 2] | 0;
        if ($7 >>> 0 >= $8 >>> 0) {
         break label$6
        }
        $9 = HEAP32[$1 >> 2] | 0;
        $10 = (($6 + $4 | 0) - $8 | 0) + 1 | 0;
        label$7 : while (1) {
         label$8 : {
          $11 = HEAPU8[($9 + $7 | 0) >> 0] | 0;
          $6 = $11 + -48 | 0;
          $12 = $6 & 255 | 0;
          if ($12 >>> 0 < 10 >>> 0) {
           break label$8
          }
          if ($4) {
           break label$4
          }
          HEAP32[$5 >> 2] = 12;
          $7 = serde_json__de__Deserializer_R___peek_error__hf8794e102c1db2df($1 | 0, $5 | 0) | 0;
          HEAP32[$0 >> 2] = 1;
          HEAP32[($0 + 4 | 0) >> 2] = $7;
          break label$1;
         }
         label$9 : {
          i64toi32_i32$0 = $3$hi;
          i64toi32_i32$2 = $3;
          i64toi32_i32$1 = 429496729;
          i64toi32_i32$3 = -1717986919;
          if (i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0) {
           break label$9
          }
          i64toi32_i32$2 = $3$hi;
          i64toi32_i32$3 = $3;
          i64toi32_i32$0 = 429496729;
          i64toi32_i32$1 = -1717986919;
          if ((i64toi32_i32$3 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$0 | 0) | 0) {
           break label$5
          }
          if ($12 >>> 0 > 5 >>> 0) {
           break label$5
          }
         }
         $7 = $7 + 1 | 0;
         HEAP32[($1 + 8 | 0) >> 2] = $7;
         $4 = $4 + -1 | 0;
         i64toi32_i32$3 = $3$hi;
         i64toi32_i32$2 = 0;
         i64toi32_i32$2 = __wasm_i64_mul($3 | 0, i64toi32_i32$3 | 0, 10 | 0, i64toi32_i32$2 | 0) | 0;
         i64toi32_i32$3 = i64toi32_i32$HIGH_BITS;
         $66 = i64toi32_i32$2;
         $66$hi = i64toi32_i32$3;
         i64toi32_i32$3 = 0;
         i64toi32_i32$1 = $6;
         i64toi32_i32$2 = 0;
         i64toi32_i32$0 = 255;
         i64toi32_i32$2 = i64toi32_i32$3 & i64toi32_i32$2 | 0;
         $69 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
         $69$hi = i64toi32_i32$2;
         i64toi32_i32$2 = $66$hi;
         i64toi32_i32$3 = $66;
         i64toi32_i32$1 = $69$hi;
         i64toi32_i32$0 = $69;
         i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
         i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
         if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
          i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
         }
         $3 = i64toi32_i32$4;
         $3$hi = i64toi32_i32$5;
         if (($8 | 0) != ($7 | 0)) {
          continue label$7
         }
         break label$7;
        };
        $4 = $10;
       }
       if ($4) {
        break label$3
       }
       HEAP32[$5 >> 2] = 5;
       $7 = serde_json__de__Deserializer_R___peek_error__hf8794e102c1db2df($1 | 0, $5 | 0) | 0;
       HEAP32[$0 >> 2] = 1;
       HEAP32[($0 + 4 | 0) >> 2] = $7;
       break label$1;
      }
      i64toi32_i32$5 = $3$hi;
      serde_json__de__Deserializer_R___parse_decimal_overflow__hd3815d0f881bb26e($0 | 0, $1 | 0, $2 | 0, $3 | 0, i64toi32_i32$5 | 0, $4 | 0);
      break label$1;
     }
     if (($11 | 32 | 0 | 0) == (101 | 0)) {
      break label$2
     }
    }
    i64toi32_i32$5 = $3$hi;
    serde_json__de__Deserializer_R___f64_from_parts__hb0108f153aa5786e($0 | 0, $1 | 0, $2 | 0, $3 | 0, i64toi32_i32$5 | 0, $4 | 0);
    break label$1;
   }
   i64toi32_i32$5 = $3$hi;
   serde_json__de__Deserializer_R___parse_exponent__h64f12a2a919bb245($0 | 0, $1 | 0, $2 | 0, $3 | 0, i64toi32_i32$5 | 0, $4 | 0);
  }
  global$0 = $5 + 16 | 0;
 }
 
 function serde_json__de__Deserializer_R___end_seq__hdf0197abf68bf866($0) {
  $0 = $0 | 0;
  var $2 = 0, $1 = 0, $6 = 0, $3 = 0, $7 = 0, $4 = 0, $5 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $2 = HEAP32[($0 + 8 | 0) >> 2] | 0;
      $3 = HEAP32[($0 + 4 | 0) >> 2] | 0;
      if ($2 >>> 0 >= $3 >>> 0) {
       break label$4
      }
      $4 = HEAP32[$0 >> 2] | 0;
      $5 = 1;
      label$5 : {
       label$6 : while (1) {
        $6 = HEAPU8[($4 + $2 | 0) >> 0] | 0;
        $7 = $6 + -9 | 0;
        if ($7 >>> 0 > 23 >>> 0) {
         break label$5
        }
        if (!((1 << $7 | 0) & 8388627 | 0)) {
         break label$5
        }
        $2 = $2 + 1 | 0;
        HEAP32[($0 + 8 | 0) >> 2] = $2;
        $5 = $2 >>> 0 < $3 >>> 0;
        if (($3 | 0) != ($2 | 0)) {
         continue label$6
        }
        break label$6;
       };
       $6 = 0;
       $2 = $3;
      }
      if ($5 & 1 | 0) {
       break label$3
      }
     }
     HEAP32[$1 >> 2] = 2;
     break label$2;
    }
    label$7 : {
     label$8 : {
      if (($6 | 0) == (93 | 0)) {
       break label$8
      }
      if (($6 | 0) == (44 | 0)) {
       break label$7
      }
      HEAP32[$1 >> 2] = 19;
      break label$2;
     }
     HEAP32[($0 + 8 | 0) >> 2] = $2 + 1 | 0;
     $2 = 0;
     break label$1;
    }
    $2 = $2 + 1 | 0;
    HEAP32[($0 + 8 | 0) >> 2] = $2;
    label$9 : {
     if ($2 >>> 0 >= $3 >>> 0) {
      break label$9
     }
     label$10 : {
      label$11 : while (1) {
       $6 = HEAPU8[($4 + $2 | 0) >> 0] | 0;
       $7 = $6 + -9 | 0;
       if ($7 >>> 0 > 23 >>> 0) {
        break label$10
       }
       if (!((1 << $7 | 0) & 8388627 | 0)) {
        break label$10
       }
       $2 = $2 + 1 | 0;
       HEAP32[($0 + 8 | 0) >> 2] = $2;
       if (($3 | 0) != ($2 | 0)) {
        continue label$11
       }
       break label$9;
      };
     }
     if (($6 | 0) != (93 | 0)) {
      break label$9
     }
     HEAP32[$1 >> 2] = 18;
     break label$2;
    }
    HEAP32[$1 >> 2] = 19;
   }
   $2 = serde_json__de__Deserializer_R___peek_error__hf8794e102c1db2df($0 | 0, $1 | 0) | 0;
  }
  global$0 = $1 + 16 | 0;
  return $2 | 0;
 }
 
 function cryptoxide__hashing__sha3__Engine___2c____process__ha763ada6c2b386e3($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $7 = 0, $6 = 0, $3 = 0, $5 = 0, $8 = 0, $9 = 0, $4 = 0, $10 = 0, $11 = 0, $12 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        if (!(HEAPU8[($0 + 204 | 0) >> 0] | 0)) {
         break label$6
        }
        $3 = HEAP32[$0 >> 2] | 0;
        if ($3 >>> 0 > 135 >>> 0) {
         break label$5
        }
        if (!$2) {
         break label$3
        }
        $4 = $0 + 4 | 0;
        $5 = 0;
        label$7 : while (1) {
         label$8 : {
          $6 = $2 - $5 | 0;
          $7 = 136 - $3 | 0;
          $8 = $7 >>> 0 > $6 >>> 0 ? $6 : $7;
          if (!$8) {
           break label$8
          }
          $7 = 0;
          $9 = 200 - $3 | 0;
          $10 = $9 >>> 0 > 200 >>> 0 ? 0 : $9;
          $9 = $6 >>> 0 > $2 >>> 0 ? 0 : $6;
          $11 = $1 + $5 | 0;
          $12 = $4 + $3 | 0;
          label$9 : while (1) {
           if (($9 | 0) == ($7 | 0)) {
            break label$2
           }
           if (($10 | 0) == ($7 | 0)) {
            break label$1
           }
           $6 = $12 + $7 | 0;
           HEAP8[$6 >> 0] = (HEAPU8[$6 >> 0] | 0) ^ (HEAPU8[($11 + $7 | 0) >> 0] | 0) | 0;
           $6 = $7 + 1 | 0;
           $7 = $6;
           if (($8 | 0) != ($7 | 0)) {
            continue label$9
           }
           break label$9;
          };
         }
         if (($8 + $3 | 0 | 0) != (136 | 0)) {
          break label$4
         }
         HEAP32[$0 >> 2] = 0;
         cryptoxide__hashing__sha3__keccak_f__h42acb6232c3b5d0f($4 | 0);
         $5 = $8 + $5 | 0;
         if ($5 >>> 0 >= $2 >>> 0) {
          break label$3
         }
         $3 = HEAP32[$0 >> 2] | 0;
         continue label$7;
        };
       }
       core__panicking__panic__h2fd385a887c8bf13(1136988 | 0, 46 | 0, 1137036 | 0);
       abort();
      }
      core__panicking__panic__h2fd385a887c8bf13(1137052 | 0, 33 | 0, 1137088 | 0);
      abort();
     }
     HEAP32[$0 >> 2] = (HEAP32[$0 >> 2] | 0) + $8 | 0;
    }
    return;
   }
   core__panicking__panic_bounds_check__h808b524af17640b1($5 + $7 | 0 | 0, $2 | 0, 1137104 | 0);
   abort();
  }
  core__panicking__panic_bounds_check__h808b524af17640b1($3 + $7 | 0 | 0, 200 | 0, 1137120 | 0);
  abort();
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__ProposedProtocolParameterUpdates___serialize__h327aa0190f949245($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, $3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $4 = 0, $5 = 0, $15 = 0, $6 = 0, $7 = 0, $8 = 0, $43 = 0, $47 = 0, $50 = 0;
  $3 = global$0 - 80 | 0;
  global$0 = $3;
  i64toi32_i32$2 = $1 + 28 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 5 | 0, i64toi32_i32$0 | 0, i64toi32_i32$1 | 0);
  $4 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      label$5 : {
       label$6 : {
        $5 = HEAP32[($1 + 32 | 0) >> 2] | 0;
        if ($5) {
         break label$6
        }
        $1 = 0;
        break label$5;
       }
       $1 = HEAP32[($5 + 412 | 0) >> 2] | 0;
      }
      label$7 : {
       if (($1 | 0) == ($5 | 0)) {
        break label$7
       }
       $6 = $3 + 72 | 0;
       $7 = $3 + 64 | 0;
       $8 = $3 + 56 | 0;
       label$8 : while (1) {
        $4 = HEAP32[($1 + 412 | 0) >> 2] | 0;
        $15 = $1 + 440 | 0;
        HEAP32[$6 >> 2] = HEAPU8[$15 >> 0] | 0 | ((HEAPU8[($15 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($15 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($15 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$2 = $1 + 432 | 0;
        i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $43 = i64toi32_i32$1;
        i64toi32_i32$1 = $7;
        HEAP32[i64toi32_i32$1 >> 2] = $43;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = $1 + 424 | 0;
        i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $47 = i64toi32_i32$0;
        i64toi32_i32$0 = $8;
        HEAP32[i64toi32_i32$0 >> 2] = $47;
        HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
        i64toi32_i32$2 = $1;
        i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 416 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 417 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 418 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 419 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 420 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 421 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 422 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 423 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $50 = i64toi32_i32$1;
        i64toi32_i32$1 = $3;
        HEAP32[($3 + 48 | 0) >> 2] = $50;
        HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$0;
        cbor_event__se__Serializer_W___write_bytes__h5e3534de30c993f9($3 | 0, $2 | 0, $3 + 48 | 0 | 0);
        if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
         break label$2
        }
        cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__ProtocolParamUpdate___serialize__h38e4d9be5dcfac79($3 | 0, $1 | 0, $2 | 0);
        if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
         break label$3
        }
        $1 = $4;
        if (($1 | 0) != ($5 | 0)) {
         continue label$8
        }
        break label$8;
       };
      }
      HEAP32[($0 + 4 | 0) >> 2] = $2;
      $4 = 0;
      break label$1;
     }
     memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    $4 = 1;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $4 = 1;
  }
  HEAP32[$0 >> 2] = $4;
  global$0 = $3 + 80 | 0;
 }
 
 function cryptoxide__hashing__blake2b__Context_____update_mut__h8d795a2d8187ae8e($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, $3 = 0, i64toi32_i32$4 = 0, $4 = 0, $6 = 0, $6$hi = 0, $5 = 0, $27 = 0, $34 = 0, $36 = 0, $36$hi = 0, $38 = 0, $39$hi = 0, $54 = 0, $59 = 0, $61 = 0, $61$hi = 0, $63 = 0, $64$hi = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if (!$2) {
       break label$4
      }
      label$5 : {
       $3 = HEAP32[($0 + 96 | 0) >> 2] | 0;
       $4 = 128 - $3 | 0;
       if ($4 >>> 0 >= $2 >>> 0) {
        break label$5
       }
       if ($3 >>> 0 >= 129 >>> 0) {
        break label$3
       }
       $5 = $0 + 100 | 0;
       memcpy($5 + $3 | 0 | 0, $1 | 0, $4 | 0) | 0;
       HEAP32[($0 + 96 | 0) >> 2] = 0;
       $27 = $0;
       i64toi32_i32$2 = $0;
       i64toi32_i32$0 = HEAP32[($0 + 64 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($0 + 68 | 0) >> 2] | 0;
       $6 = i64toi32_i32$0;
       $6$hi = i64toi32_i32$1;
       i64toi32_i32$2 = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 128;
       i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
       i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
       if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
        i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
       }
       i64toi32_i32$2 = $27;
       HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] = i64toi32_i32$4;
       HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] = i64toi32_i32$5;
       $3 = $0 + 72 | 0;
       $34 = $3;
       i64toi32_i32$1 = $3;
       i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $36 = i64toi32_i32$5;
       $36$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $6$hi;
       i64toi32_i32$1 = $6;
       i64toi32_i32$5 = -1;
       i64toi32_i32$3 = -129;
       $38 = i64toi32_i32$2 >>> 0 > i64toi32_i32$5 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$1 >>> 0 > i64toi32_i32$3 >>> 0 | 0) | 0;
       i64toi32_i32$1 = 0;
       $39$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $36$hi;
       i64toi32_i32$3 = $36;
       i64toi32_i32$2 = $39$hi;
       i64toi32_i32$5 = $38;
       i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
       i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
       if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
        i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
       }
       i64toi32_i32$3 = $34;
       HEAP32[i64toi32_i32$3 >> 2] = i64toi32_i32$0;
       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$4;
       $3 = $0 + 64 | 0;
       cryptoxide__hashing__blake2__reference__compress_b__h50335d8cd58c3d7d($0 | 0, $3 | 0, $5 | 0, 128 | 0, 1 | 0);
       $1 = $1 + $4 | 0;
       $2 = $2 - $4 | 0;
       if ($2 >>> 0 < 129 >>> 0) {
        break label$5
       }
       label$6 : while (1) {
        $54 = $0;
        i64toi32_i32$1 = $0;
        i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] | 0;
        $6 = i64toi32_i32$4;
        $6$hi = i64toi32_i32$3;
        i64toi32_i32$1 = i64toi32_i32$4;
        i64toi32_i32$4 = 0;
        i64toi32_i32$5 = 128;
        i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
        i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$4 | 0;
        if (i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0) {
         i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
        }
        i64toi32_i32$1 = $54;
        HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] = i64toi32_i32$2;
        HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] = i64toi32_i32$0;
        $59 = $0;
        i64toi32_i32$3 = $0;
        i64toi32_i32$0 = HEAP32[($0 + 72 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($0 + 76 | 0) >> 2] | 0;
        $61 = i64toi32_i32$0;
        $61$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $6$hi;
        i64toi32_i32$3 = $6;
        i64toi32_i32$0 = -1;
        i64toi32_i32$5 = -129;
        $63 = i64toi32_i32$1 >>> 0 > i64toi32_i32$0 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$3 >>> 0 > i64toi32_i32$5 >>> 0 | 0) | 0;
        i64toi32_i32$3 = 0;
        $64$hi = i64toi32_i32$3;
        i64toi32_i32$3 = $61$hi;
        i64toi32_i32$5 = $61;
        i64toi32_i32$1 = $64$hi;
        i64toi32_i32$0 = $63;
        i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
        i64toi32_i32$2 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
        if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
         i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
        }
        i64toi32_i32$5 = $59;
        HEAP32[(i64toi32_i32$5 + 72 | 0) >> 2] = i64toi32_i32$4;
        HEAP32[(i64toi32_i32$5 + 76 | 0) >> 2] = i64toi32_i32$2;
        cryptoxide__hashing__blake2__reference__compress_b__h50335d8cd58c3d7d($0 | 0, $3 | 0, $1 | 0, 128 | 0, 1 | 0);
        $1 = $1 + 128 | 0;
        $2 = $2 + -128 | 0;
        if ($2 >>> 0 > 128 >>> 0) {
         continue label$6
        }
        break label$6;
       };
      }
      $3 = HEAP32[($0 + 96 | 0) >> 2] | 0;
      $4 = $3 + $2 | 0;
      if ($4 >>> 0 < $3 >>> 0) {
       break label$2
      }
      if ($4 >>> 0 > 128 >>> 0) {
       break label$1
      }
      memcpy(($0 + $3 | 0) + 100 | 0 | 0, $1 | 0, $2 | 0) | 0;
      HEAP32[($0 + 96 | 0) >> 2] = (HEAP32[($0 + 96 | 0) >> 2] | 0) + $2 | 0;
     }
     return;
    }
    core__slice__index__slice_index_order_fail__h71e247dec3f266ff($3 | 0, 128 | 0, 1136144 | 0);
    abort();
   }
   core__slice__index__slice_index_order_fail__h71e247dec3f266ff($3 | 0, $4 | 0, 1136160 | 0);
   abort();
  }
  core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($4 | 0, 128 | 0, 1136160 | 0);
  abort();
 }
 
 function cryptoxide__hashing__blake2b__Context_____update_mut__h977239665a489a29($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, $3 = 0, i64toi32_i32$4 = 0, $4 = 0, $6 = 0, $6$hi = 0, $5 = 0, $27 = 0, $34 = 0, $36 = 0, $36$hi = 0, $38 = 0, $39$hi = 0, $54 = 0, $59 = 0, $61 = 0, $61$hi = 0, $63 = 0, $64$hi = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if (!$2) {
       break label$4
      }
      label$5 : {
       $3 = HEAP32[($0 + 96 | 0) >> 2] | 0;
       $4 = 128 - $3 | 0;
       if ($4 >>> 0 >= $2 >>> 0) {
        break label$5
       }
       if ($3 >>> 0 >= 129 >>> 0) {
        break label$3
       }
       $5 = $0 + 100 | 0;
       memcpy($5 + $3 | 0 | 0, $1 | 0, $4 | 0) | 0;
       HEAP32[($0 + 96 | 0) >> 2] = 0;
       $27 = $0;
       i64toi32_i32$2 = $0;
       i64toi32_i32$0 = HEAP32[($0 + 64 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($0 + 68 | 0) >> 2] | 0;
       $6 = i64toi32_i32$0;
       $6$hi = i64toi32_i32$1;
       i64toi32_i32$2 = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 128;
       i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
       i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
       if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
        i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
       }
       i64toi32_i32$2 = $27;
       HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] = i64toi32_i32$4;
       HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] = i64toi32_i32$5;
       $3 = $0 + 72 | 0;
       $34 = $3;
       i64toi32_i32$1 = $3;
       i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $36 = i64toi32_i32$5;
       $36$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $6$hi;
       i64toi32_i32$1 = $6;
       i64toi32_i32$5 = -1;
       i64toi32_i32$3 = -129;
       $38 = i64toi32_i32$2 >>> 0 > i64toi32_i32$5 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$1 >>> 0 > i64toi32_i32$3 >>> 0 | 0) | 0;
       i64toi32_i32$1 = 0;
       $39$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $36$hi;
       i64toi32_i32$3 = $36;
       i64toi32_i32$2 = $39$hi;
       i64toi32_i32$5 = $38;
       i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
       i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
       if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
        i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
       }
       i64toi32_i32$3 = $34;
       HEAP32[i64toi32_i32$3 >> 2] = i64toi32_i32$0;
       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$4;
       $3 = $0 + 64 | 0;
       cryptoxide__hashing__blake2__reference__compress_b__h50335d8cd58c3d7d($0 | 0, $3 | 0, $5 | 0, 128 | 0, 1 | 0);
       $1 = $1 + $4 | 0;
       $2 = $2 - $4 | 0;
       if ($2 >>> 0 < 129 >>> 0) {
        break label$5
       }
       label$6 : while (1) {
        $54 = $0;
        i64toi32_i32$1 = $0;
        i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] | 0;
        $6 = i64toi32_i32$4;
        $6$hi = i64toi32_i32$3;
        i64toi32_i32$1 = i64toi32_i32$4;
        i64toi32_i32$4 = 0;
        i64toi32_i32$5 = 128;
        i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
        i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$4 | 0;
        if (i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0) {
         i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
        }
        i64toi32_i32$1 = $54;
        HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] = i64toi32_i32$2;
        HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] = i64toi32_i32$0;
        $59 = $0;
        i64toi32_i32$3 = $0;
        i64toi32_i32$0 = HEAP32[($0 + 72 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($0 + 76 | 0) >> 2] | 0;
        $61 = i64toi32_i32$0;
        $61$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $6$hi;
        i64toi32_i32$3 = $6;
        i64toi32_i32$0 = -1;
        i64toi32_i32$5 = -129;
        $63 = i64toi32_i32$1 >>> 0 > i64toi32_i32$0 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$3 >>> 0 > i64toi32_i32$5 >>> 0 | 0) | 0;
        i64toi32_i32$3 = 0;
        $64$hi = i64toi32_i32$3;
        i64toi32_i32$3 = $61$hi;
        i64toi32_i32$5 = $61;
        i64toi32_i32$1 = $64$hi;
        i64toi32_i32$0 = $63;
        i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
        i64toi32_i32$2 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
        if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
         i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
        }
        i64toi32_i32$5 = $59;
        HEAP32[(i64toi32_i32$5 + 72 | 0) >> 2] = i64toi32_i32$4;
        HEAP32[(i64toi32_i32$5 + 76 | 0) >> 2] = i64toi32_i32$2;
        cryptoxide__hashing__blake2__reference__compress_b__h50335d8cd58c3d7d($0 | 0, $3 | 0, $1 | 0, 128 | 0, 1 | 0);
        $1 = $1 + 128 | 0;
        $2 = $2 + -128 | 0;
        if ($2 >>> 0 > 128 >>> 0) {
         continue label$6
        }
        break label$6;
       };
      }
      $3 = HEAP32[($0 + 96 | 0) >> 2] | 0;
      $4 = $3 + $2 | 0;
      if ($4 >>> 0 < $3 >>> 0) {
       break label$2
      }
      if ($4 >>> 0 > 128 >>> 0) {
       break label$1
      }
      memcpy(($0 + $3 | 0) + 100 | 0 | 0, $1 | 0, $2 | 0) | 0;
      HEAP32[($0 + 96 | 0) >> 2] = (HEAP32[($0 + 96 | 0) >> 2] | 0) + $2 | 0;
     }
     return;
    }
    core__slice__index__slice_index_order_fail__h71e247dec3f266ff($3 | 0, 128 | 0, 1136144 | 0);
    abort();
   }
   core__slice__index__slice_index_order_fail__h71e247dec3f266ff($3 | 0, $4 | 0, 1136160 | 0);
   abort();
  }
  core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($4 | 0, 128 | 0, 1136160 | 0);
  abort();
 }
 
 function cryptoxide__hashing__blake2b__Context_____update_mut__hf1adca8e4c0075bf($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, $3 = 0, i64toi32_i32$4 = 0, $4 = 0, $6 = 0, $6$hi = 0, $5 = 0, $27 = 0, $34 = 0, $36 = 0, $36$hi = 0, $38 = 0, $39$hi = 0, $54 = 0, $59 = 0, $61 = 0, $61$hi = 0, $63 = 0, $64$hi = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if (!$2) {
       break label$4
      }
      label$5 : {
       $3 = HEAP32[($0 + 96 | 0) >> 2] | 0;
       $4 = 128 - $3 | 0;
       if ($4 >>> 0 >= $2 >>> 0) {
        break label$5
       }
       if ($3 >>> 0 >= 129 >>> 0) {
        break label$3
       }
       $5 = $0 + 100 | 0;
       memcpy($5 + $3 | 0 | 0, $1 | 0, $4 | 0) | 0;
       HEAP32[($0 + 96 | 0) >> 2] = 0;
       $27 = $0;
       i64toi32_i32$2 = $0;
       i64toi32_i32$0 = HEAP32[($0 + 64 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($0 + 68 | 0) >> 2] | 0;
       $6 = i64toi32_i32$0;
       $6$hi = i64toi32_i32$1;
       i64toi32_i32$2 = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 128;
       i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
       i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
       if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
        i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
       }
       i64toi32_i32$2 = $27;
       HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] = i64toi32_i32$4;
       HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] = i64toi32_i32$5;
       $3 = $0 + 72 | 0;
       $34 = $3;
       i64toi32_i32$1 = $3;
       i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $36 = i64toi32_i32$5;
       $36$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $6$hi;
       i64toi32_i32$1 = $6;
       i64toi32_i32$5 = -1;
       i64toi32_i32$3 = -129;
       $38 = i64toi32_i32$2 >>> 0 > i64toi32_i32$5 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$1 >>> 0 > i64toi32_i32$3 >>> 0 | 0) | 0;
       i64toi32_i32$1 = 0;
       $39$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $36$hi;
       i64toi32_i32$3 = $36;
       i64toi32_i32$2 = $39$hi;
       i64toi32_i32$5 = $38;
       i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
       i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
       if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
        i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
       }
       i64toi32_i32$3 = $34;
       HEAP32[i64toi32_i32$3 >> 2] = i64toi32_i32$0;
       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$4;
       $3 = $0 + 64 | 0;
       cryptoxide__hashing__blake2__reference__compress_b__h50335d8cd58c3d7d($0 | 0, $3 | 0, $5 | 0, 128 | 0, 1 | 0);
       $1 = $1 + $4 | 0;
       $2 = $2 - $4 | 0;
       if ($2 >>> 0 < 129 >>> 0) {
        break label$5
       }
       label$6 : while (1) {
        $54 = $0;
        i64toi32_i32$1 = $0;
        i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] | 0;
        $6 = i64toi32_i32$4;
        $6$hi = i64toi32_i32$3;
        i64toi32_i32$1 = i64toi32_i32$4;
        i64toi32_i32$4 = 0;
        i64toi32_i32$5 = 128;
        i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
        i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$4 | 0;
        if (i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0) {
         i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
        }
        i64toi32_i32$1 = $54;
        HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] = i64toi32_i32$2;
        HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] = i64toi32_i32$0;
        $59 = $0;
        i64toi32_i32$3 = $0;
        i64toi32_i32$0 = HEAP32[($0 + 72 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($0 + 76 | 0) >> 2] | 0;
        $61 = i64toi32_i32$0;
        $61$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $6$hi;
        i64toi32_i32$3 = $6;
        i64toi32_i32$0 = -1;
        i64toi32_i32$5 = -129;
        $63 = i64toi32_i32$1 >>> 0 > i64toi32_i32$0 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$3 >>> 0 > i64toi32_i32$5 >>> 0 | 0) | 0;
        i64toi32_i32$3 = 0;
        $64$hi = i64toi32_i32$3;
        i64toi32_i32$3 = $61$hi;
        i64toi32_i32$5 = $61;
        i64toi32_i32$1 = $64$hi;
        i64toi32_i32$0 = $63;
        i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
        i64toi32_i32$2 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
        if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
         i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
        }
        i64toi32_i32$5 = $59;
        HEAP32[(i64toi32_i32$5 + 72 | 0) >> 2] = i64toi32_i32$4;
        HEAP32[(i64toi32_i32$5 + 76 | 0) >> 2] = i64toi32_i32$2;
        cryptoxide__hashing__blake2__reference__compress_b__h50335d8cd58c3d7d($0 | 0, $3 | 0, $1 | 0, 128 | 0, 1 | 0);
        $1 = $1 + 128 | 0;
        $2 = $2 + -128 | 0;
        if ($2 >>> 0 > 128 >>> 0) {
         continue label$6
        }
        break label$6;
       };
      }
      $3 = HEAP32[($0 + 96 | 0) >> 2] | 0;
      $4 = $3 + $2 | 0;
      if ($4 >>> 0 < $3 >>> 0) {
       break label$2
      }
      if ($4 >>> 0 > 128 >>> 0) {
       break label$1
      }
      memcpy(($0 + $3 | 0) + 100 | 0 | 0, $1 | 0, $2 | 0) | 0;
      HEAP32[($0 + 96 | 0) >> 2] = (HEAP32[($0 + 96 | 0) >> 2] | 0) + $2 | 0;
     }
     return;
    }
    core__slice__index__slice_index_order_fail__h71e247dec3f266ff($3 | 0, 128 | 0, 1136144 | 0);
    abort();
   }
   core__slice__index__slice_index_order_fail__h71e247dec3f266ff($3 | 0, $4 | 0, 1136160 | 0);
   abort();
  }
  core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($4 | 0, 128 | 0, 1136160 | 0);
  abort();
 }
 
 function cryptoxide__hashing__blake2b__Context_____update_mut__h4c294f56fe72d50d($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, $3 = 0, i64toi32_i32$4 = 0, $4 = 0, $6 = 0, $6$hi = 0, $5 = 0, $27 = 0, $34 = 0, $36 = 0, $36$hi = 0, $38 = 0, $39$hi = 0, $54 = 0, $59 = 0, $61 = 0, $61$hi = 0, $63 = 0, $64$hi = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if (!$2) {
       break label$4
      }
      label$5 : {
       $3 = HEAP32[($0 + 96 | 0) >> 2] | 0;
       $4 = 128 - $3 | 0;
       if ($4 >>> 0 >= $2 >>> 0) {
        break label$5
       }
       if ($3 >>> 0 >= 129 >>> 0) {
        break label$3
       }
       $5 = $0 + 100 | 0;
       memcpy($5 + $3 | 0 | 0, $1 | 0, $4 | 0) | 0;
       HEAP32[($0 + 96 | 0) >> 2] = 0;
       $27 = $0;
       i64toi32_i32$2 = $0;
       i64toi32_i32$0 = HEAP32[($0 + 64 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($0 + 68 | 0) >> 2] | 0;
       $6 = i64toi32_i32$0;
       $6$hi = i64toi32_i32$1;
       i64toi32_i32$2 = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 128;
       i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
       i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
       if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
        i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
       }
       i64toi32_i32$2 = $27;
       HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] = i64toi32_i32$4;
       HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] = i64toi32_i32$5;
       $3 = $0 + 72 | 0;
       $34 = $3;
       i64toi32_i32$1 = $3;
       i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $36 = i64toi32_i32$5;
       $36$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $6$hi;
       i64toi32_i32$1 = $6;
       i64toi32_i32$5 = -1;
       i64toi32_i32$3 = -129;
       $38 = i64toi32_i32$2 >>> 0 > i64toi32_i32$5 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$1 >>> 0 > i64toi32_i32$3 >>> 0 | 0) | 0;
       i64toi32_i32$1 = 0;
       $39$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $36$hi;
       i64toi32_i32$3 = $36;
       i64toi32_i32$2 = $39$hi;
       i64toi32_i32$5 = $38;
       i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
       i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
       if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
        i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
       }
       i64toi32_i32$3 = $34;
       HEAP32[i64toi32_i32$3 >> 2] = i64toi32_i32$0;
       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$4;
       $3 = $0 + 64 | 0;
       cryptoxide__hashing__blake2__reference__compress_b__h50335d8cd58c3d7d($0 | 0, $3 | 0, $5 | 0, 128 | 0, 1 | 0);
       $1 = $1 + $4 | 0;
       $2 = $2 - $4 | 0;
       if ($2 >>> 0 < 129 >>> 0) {
        break label$5
       }
       label$6 : while (1) {
        $54 = $0;
        i64toi32_i32$1 = $0;
        i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] | 0;
        $6 = i64toi32_i32$4;
        $6$hi = i64toi32_i32$3;
        i64toi32_i32$1 = i64toi32_i32$4;
        i64toi32_i32$4 = 0;
        i64toi32_i32$5 = 128;
        i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
        i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$4 | 0;
        if (i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0) {
         i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
        }
        i64toi32_i32$1 = $54;
        HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] = i64toi32_i32$2;
        HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] = i64toi32_i32$0;
        $59 = $0;
        i64toi32_i32$3 = $0;
        i64toi32_i32$0 = HEAP32[($0 + 72 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($0 + 76 | 0) >> 2] | 0;
        $61 = i64toi32_i32$0;
        $61$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $6$hi;
        i64toi32_i32$3 = $6;
        i64toi32_i32$0 = -1;
        i64toi32_i32$5 = -129;
        $63 = i64toi32_i32$1 >>> 0 > i64toi32_i32$0 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$3 >>> 0 > i64toi32_i32$5 >>> 0 | 0) | 0;
        i64toi32_i32$3 = 0;
        $64$hi = i64toi32_i32$3;
        i64toi32_i32$3 = $61$hi;
        i64toi32_i32$5 = $61;
        i64toi32_i32$1 = $64$hi;
        i64toi32_i32$0 = $63;
        i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
        i64toi32_i32$2 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
        if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
         i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
        }
        i64toi32_i32$5 = $59;
        HEAP32[(i64toi32_i32$5 + 72 | 0) >> 2] = i64toi32_i32$4;
        HEAP32[(i64toi32_i32$5 + 76 | 0) >> 2] = i64toi32_i32$2;
        cryptoxide__hashing__blake2__reference__compress_b__h50335d8cd58c3d7d($0 | 0, $3 | 0, $1 | 0, 128 | 0, 1 | 0);
        $1 = $1 + 128 | 0;
        $2 = $2 + -128 | 0;
        if ($2 >>> 0 > 128 >>> 0) {
         continue label$6
        }
        break label$6;
       };
      }
      $3 = HEAP32[($0 + 96 | 0) >> 2] | 0;
      $4 = $3 + $2 | 0;
      if ($4 >>> 0 < $3 >>> 0) {
       break label$2
      }
      if ($4 >>> 0 > 128 >>> 0) {
       break label$1
      }
      memcpy(($0 + $3 | 0) + 100 | 0 | 0, $1 | 0, $2 | 0) | 0;
      HEAP32[($0 + 96 | 0) >> 2] = (HEAP32[($0 + 96 | 0) >> 2] | 0) + $2 | 0;
     }
     return;
    }
    core__slice__index__slice_index_order_fail__h71e247dec3f266ff($3 | 0, 128 | 0, 1136144 | 0);
    abort();
   }
   core__slice__index__slice_index_order_fail__h71e247dec3f266ff($3 | 0, $4 | 0, 1136160 | 0);
   abort();
  }
  core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($4 | 0, 128 | 0, 1136160 | 0);
  abort();
 }
 
 function cryptoxide__hashing__blake2b__Context_____update_mut__h027361fea5294bdb($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, $3 = 0, i64toi32_i32$4 = 0, $4 = 0, $6 = 0, $6$hi = 0, $5 = 0, $27 = 0, $34 = 0, $36 = 0, $36$hi = 0, $38 = 0, $39$hi = 0, $54 = 0, $59 = 0, $61 = 0, $61$hi = 0, $63 = 0, $64$hi = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if (!$2) {
       break label$4
      }
      label$5 : {
       $3 = HEAP32[($0 + 96 | 0) >> 2] | 0;
       $4 = 128 - $3 | 0;
       if ($4 >>> 0 >= $2 >>> 0) {
        break label$5
       }
       if ($3 >>> 0 >= 129 >>> 0) {
        break label$3
       }
       $5 = $0 + 100 | 0;
       memcpy($5 + $3 | 0 | 0, $1 | 0, $4 | 0) | 0;
       HEAP32[($0 + 96 | 0) >> 2] = 0;
       $27 = $0;
       i64toi32_i32$2 = $0;
       i64toi32_i32$0 = HEAP32[($0 + 64 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($0 + 68 | 0) >> 2] | 0;
       $6 = i64toi32_i32$0;
       $6$hi = i64toi32_i32$1;
       i64toi32_i32$2 = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 128;
       i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
       i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
       if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
        i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
       }
       i64toi32_i32$2 = $27;
       HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] = i64toi32_i32$4;
       HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] = i64toi32_i32$5;
       $3 = $0 + 72 | 0;
       $34 = $3;
       i64toi32_i32$1 = $3;
       i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $36 = i64toi32_i32$5;
       $36$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $6$hi;
       i64toi32_i32$1 = $6;
       i64toi32_i32$5 = -1;
       i64toi32_i32$3 = -129;
       $38 = i64toi32_i32$2 >>> 0 > i64toi32_i32$5 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$1 >>> 0 > i64toi32_i32$3 >>> 0 | 0) | 0;
       i64toi32_i32$1 = 0;
       $39$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $36$hi;
       i64toi32_i32$3 = $36;
       i64toi32_i32$2 = $39$hi;
       i64toi32_i32$5 = $38;
       i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
       i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
       if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
        i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
       }
       i64toi32_i32$3 = $34;
       HEAP32[i64toi32_i32$3 >> 2] = i64toi32_i32$0;
       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$4;
       $3 = $0 + 64 | 0;
       cryptoxide__hashing__blake2__reference__compress_b__h50335d8cd58c3d7d($0 | 0, $3 | 0, $5 | 0, 128 | 0, 1 | 0);
       $1 = $1 + $4 | 0;
       $2 = $2 - $4 | 0;
       if ($2 >>> 0 < 129 >>> 0) {
        break label$5
       }
       label$6 : while (1) {
        $54 = $0;
        i64toi32_i32$1 = $0;
        i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] | 0;
        $6 = i64toi32_i32$4;
        $6$hi = i64toi32_i32$3;
        i64toi32_i32$1 = i64toi32_i32$4;
        i64toi32_i32$4 = 0;
        i64toi32_i32$5 = 128;
        i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
        i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$4 | 0;
        if (i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0) {
         i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
        }
        i64toi32_i32$1 = $54;
        HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] = i64toi32_i32$2;
        HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] = i64toi32_i32$0;
        $59 = $0;
        i64toi32_i32$3 = $0;
        i64toi32_i32$0 = HEAP32[($0 + 72 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($0 + 76 | 0) >> 2] | 0;
        $61 = i64toi32_i32$0;
        $61$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $6$hi;
        i64toi32_i32$3 = $6;
        i64toi32_i32$0 = -1;
        i64toi32_i32$5 = -129;
        $63 = i64toi32_i32$1 >>> 0 > i64toi32_i32$0 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$3 >>> 0 > i64toi32_i32$5 >>> 0 | 0) | 0;
        i64toi32_i32$3 = 0;
        $64$hi = i64toi32_i32$3;
        i64toi32_i32$3 = $61$hi;
        i64toi32_i32$5 = $61;
        i64toi32_i32$1 = $64$hi;
        i64toi32_i32$0 = $63;
        i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
        i64toi32_i32$2 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
        if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
         i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
        }
        i64toi32_i32$5 = $59;
        HEAP32[(i64toi32_i32$5 + 72 | 0) >> 2] = i64toi32_i32$4;
        HEAP32[(i64toi32_i32$5 + 76 | 0) >> 2] = i64toi32_i32$2;
        cryptoxide__hashing__blake2__reference__compress_b__h50335d8cd58c3d7d($0 | 0, $3 | 0, $1 | 0, 128 | 0, 1 | 0);
        $1 = $1 + 128 | 0;
        $2 = $2 + -128 | 0;
        if ($2 >>> 0 > 128 >>> 0) {
         continue label$6
        }
        break label$6;
       };
      }
      $3 = HEAP32[($0 + 96 | 0) >> 2] | 0;
      $4 = $3 + $2 | 0;
      if ($4 >>> 0 < $3 >>> 0) {
       break label$2
      }
      if ($4 >>> 0 > 128 >>> 0) {
       break label$1
      }
      memcpy(($0 + $3 | 0) + 100 | 0 | 0, $1 | 0, $2 | 0) | 0;
      HEAP32[($0 + 96 | 0) >> 2] = (HEAP32[($0 + 96 | 0) >> 2] | 0) + $2 | 0;
     }
     return;
    }
    core__slice__index__slice_index_order_fail__h71e247dec3f266ff($3 | 0, 128 | 0, 1136144 | 0);
    abort();
   }
   core__slice__index__slice_index_order_fail__h71e247dec3f266ff($3 | 0, $4 | 0, 1136160 | 0);
   abort();
  }
  core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($4 | 0, 128 | 0, 1136160 | 0);
  abort();
 }
 
 function cryptoxide__hashing__blake2b__Context_____update_mut__h1a06f4ff4884cc19($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, $3 = 0, i64toi32_i32$4 = 0, $4 = 0, $6 = 0, $6$hi = 0, $5 = 0, $27 = 0, $34 = 0, $36 = 0, $36$hi = 0, $38 = 0, $39$hi = 0, $54 = 0, $59 = 0, $61 = 0, $61$hi = 0, $63 = 0, $64$hi = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if (!$2) {
       break label$4
      }
      label$5 : {
       $3 = HEAP32[($0 + 96 | 0) >> 2] | 0;
       $4 = 128 - $3 | 0;
       if ($4 >>> 0 >= $2 >>> 0) {
        break label$5
       }
       if ($3 >>> 0 >= 129 >>> 0) {
        break label$3
       }
       $5 = $0 + 100 | 0;
       memcpy($5 + $3 | 0 | 0, $1 | 0, $4 | 0) | 0;
       HEAP32[($0 + 96 | 0) >> 2] = 0;
       $27 = $0;
       i64toi32_i32$2 = $0;
       i64toi32_i32$0 = HEAP32[($0 + 64 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($0 + 68 | 0) >> 2] | 0;
       $6 = i64toi32_i32$0;
       $6$hi = i64toi32_i32$1;
       i64toi32_i32$2 = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 128;
       i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
       i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
       if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
        i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
       }
       i64toi32_i32$2 = $27;
       HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] = i64toi32_i32$4;
       HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] = i64toi32_i32$5;
       $3 = $0 + 72 | 0;
       $34 = $3;
       i64toi32_i32$1 = $3;
       i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $36 = i64toi32_i32$5;
       $36$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $6$hi;
       i64toi32_i32$1 = $6;
       i64toi32_i32$5 = -1;
       i64toi32_i32$3 = -129;
       $38 = i64toi32_i32$2 >>> 0 > i64toi32_i32$5 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$1 >>> 0 > i64toi32_i32$3 >>> 0 | 0) | 0;
       i64toi32_i32$1 = 0;
       $39$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $36$hi;
       i64toi32_i32$3 = $36;
       i64toi32_i32$2 = $39$hi;
       i64toi32_i32$5 = $38;
       i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
       i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
       if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
        i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
       }
       i64toi32_i32$3 = $34;
       HEAP32[i64toi32_i32$3 >> 2] = i64toi32_i32$0;
       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$4;
       $3 = $0 + 64 | 0;
       cryptoxide__hashing__blake2__reference__compress_b__h50335d8cd58c3d7d($0 | 0, $3 | 0, $5 | 0, 128 | 0, 1 | 0);
       $1 = $1 + $4 | 0;
       $2 = $2 - $4 | 0;
       if ($2 >>> 0 < 129 >>> 0) {
        break label$5
       }
       label$6 : while (1) {
        $54 = $0;
        i64toi32_i32$1 = $0;
        i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] | 0;
        $6 = i64toi32_i32$4;
        $6$hi = i64toi32_i32$3;
        i64toi32_i32$1 = i64toi32_i32$4;
        i64toi32_i32$4 = 0;
        i64toi32_i32$5 = 128;
        i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
        i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$4 | 0;
        if (i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0) {
         i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
        }
        i64toi32_i32$1 = $54;
        HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] = i64toi32_i32$2;
        HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] = i64toi32_i32$0;
        $59 = $0;
        i64toi32_i32$3 = $0;
        i64toi32_i32$0 = HEAP32[($0 + 72 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($0 + 76 | 0) >> 2] | 0;
        $61 = i64toi32_i32$0;
        $61$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $6$hi;
        i64toi32_i32$3 = $6;
        i64toi32_i32$0 = -1;
        i64toi32_i32$5 = -129;
        $63 = i64toi32_i32$1 >>> 0 > i64toi32_i32$0 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$3 >>> 0 > i64toi32_i32$5 >>> 0 | 0) | 0;
        i64toi32_i32$3 = 0;
        $64$hi = i64toi32_i32$3;
        i64toi32_i32$3 = $61$hi;
        i64toi32_i32$5 = $61;
        i64toi32_i32$1 = $64$hi;
        i64toi32_i32$0 = $63;
        i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
        i64toi32_i32$2 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
        if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
         i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
        }
        i64toi32_i32$5 = $59;
        HEAP32[(i64toi32_i32$5 + 72 | 0) >> 2] = i64toi32_i32$4;
        HEAP32[(i64toi32_i32$5 + 76 | 0) >> 2] = i64toi32_i32$2;
        cryptoxide__hashing__blake2__reference__compress_b__h50335d8cd58c3d7d($0 | 0, $3 | 0, $1 | 0, 128 | 0, 1 | 0);
        $1 = $1 + 128 | 0;
        $2 = $2 + -128 | 0;
        if ($2 >>> 0 > 128 >>> 0) {
         continue label$6
        }
        break label$6;
       };
      }
      $3 = HEAP32[($0 + 96 | 0) >> 2] | 0;
      $4 = $3 + $2 | 0;
      if ($4 >>> 0 < $3 >>> 0) {
       break label$2
      }
      if ($4 >>> 0 > 128 >>> 0) {
       break label$1
      }
      memcpy(($0 + $3 | 0) + 100 | 0 | 0, $1 | 0, $2 | 0) | 0;
      HEAP32[($0 + 96 | 0) >> 2] = (HEAP32[($0 + 96 | 0) >> 2] | 0) + $2 | 0;
     }
     return;
    }
    core__slice__index__slice_index_order_fail__h71e247dec3f266ff($3 | 0, 128 | 0, 1136144 | 0);
    abort();
   }
   core__slice__index__slice_index_order_fail__h71e247dec3f266ff($3 | 0, $4 | 0, 1136160 | 0);
   abort();
  }
  core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($4 | 0, 128 | 0, 1136160 | 0);
  abort();
 }
 
 function cryptoxide__hashing__blake2b__Context_____update_mut__h7ace2e2bc9f5516f($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, $3 = 0, i64toi32_i32$4 = 0, $4 = 0, $6 = 0, $6$hi = 0, $5 = 0, $27 = 0, $34 = 0, $36 = 0, $36$hi = 0, $38 = 0, $39$hi = 0, $54 = 0, $59 = 0, $61 = 0, $61$hi = 0, $63 = 0, $64$hi = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if (!$2) {
       break label$4
      }
      label$5 : {
       $3 = HEAP32[($0 + 96 | 0) >> 2] | 0;
       $4 = 128 - $3 | 0;
       if ($4 >>> 0 >= $2 >>> 0) {
        break label$5
       }
       if ($3 >>> 0 >= 129 >>> 0) {
        break label$3
       }
       $5 = $0 + 100 | 0;
       memcpy($5 + $3 | 0 | 0, $1 | 0, $4 | 0) | 0;
       HEAP32[($0 + 96 | 0) >> 2] = 0;
       $27 = $0;
       i64toi32_i32$2 = $0;
       i64toi32_i32$0 = HEAP32[($0 + 64 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($0 + 68 | 0) >> 2] | 0;
       $6 = i64toi32_i32$0;
       $6$hi = i64toi32_i32$1;
       i64toi32_i32$2 = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 128;
       i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
       i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
       if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
        i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
       }
       i64toi32_i32$2 = $27;
       HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] = i64toi32_i32$4;
       HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] = i64toi32_i32$5;
       $3 = $0 + 72 | 0;
       $34 = $3;
       i64toi32_i32$1 = $3;
       i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $36 = i64toi32_i32$5;
       $36$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $6$hi;
       i64toi32_i32$1 = $6;
       i64toi32_i32$5 = -1;
       i64toi32_i32$3 = -129;
       $38 = i64toi32_i32$2 >>> 0 > i64toi32_i32$5 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$1 >>> 0 > i64toi32_i32$3 >>> 0 | 0) | 0;
       i64toi32_i32$1 = 0;
       $39$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $36$hi;
       i64toi32_i32$3 = $36;
       i64toi32_i32$2 = $39$hi;
       i64toi32_i32$5 = $38;
       i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
       i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
       if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
        i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
       }
       i64toi32_i32$3 = $34;
       HEAP32[i64toi32_i32$3 >> 2] = i64toi32_i32$0;
       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$4;
       $3 = $0 + 64 | 0;
       cryptoxide__hashing__blake2__reference__compress_b__h50335d8cd58c3d7d($0 | 0, $3 | 0, $5 | 0, 128 | 0, 1 | 0);
       $1 = $1 + $4 | 0;
       $2 = $2 - $4 | 0;
       if ($2 >>> 0 < 129 >>> 0) {
        break label$5
       }
       label$6 : while (1) {
        $54 = $0;
        i64toi32_i32$1 = $0;
        i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] | 0;
        $6 = i64toi32_i32$4;
        $6$hi = i64toi32_i32$3;
        i64toi32_i32$1 = i64toi32_i32$4;
        i64toi32_i32$4 = 0;
        i64toi32_i32$5 = 128;
        i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
        i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$4 | 0;
        if (i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0) {
         i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
        }
        i64toi32_i32$1 = $54;
        HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] = i64toi32_i32$2;
        HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] = i64toi32_i32$0;
        $59 = $0;
        i64toi32_i32$3 = $0;
        i64toi32_i32$0 = HEAP32[($0 + 72 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($0 + 76 | 0) >> 2] | 0;
        $61 = i64toi32_i32$0;
        $61$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $6$hi;
        i64toi32_i32$3 = $6;
        i64toi32_i32$0 = -1;
        i64toi32_i32$5 = -129;
        $63 = i64toi32_i32$1 >>> 0 > i64toi32_i32$0 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$3 >>> 0 > i64toi32_i32$5 >>> 0 | 0) | 0;
        i64toi32_i32$3 = 0;
        $64$hi = i64toi32_i32$3;
        i64toi32_i32$3 = $61$hi;
        i64toi32_i32$5 = $61;
        i64toi32_i32$1 = $64$hi;
        i64toi32_i32$0 = $63;
        i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
        i64toi32_i32$2 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
        if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
         i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
        }
        i64toi32_i32$5 = $59;
        HEAP32[(i64toi32_i32$5 + 72 | 0) >> 2] = i64toi32_i32$4;
        HEAP32[(i64toi32_i32$5 + 76 | 0) >> 2] = i64toi32_i32$2;
        cryptoxide__hashing__blake2__reference__compress_b__h50335d8cd58c3d7d($0 | 0, $3 | 0, $1 | 0, 128 | 0, 1 | 0);
        $1 = $1 + 128 | 0;
        $2 = $2 + -128 | 0;
        if ($2 >>> 0 > 128 >>> 0) {
         continue label$6
        }
        break label$6;
       };
      }
      $3 = HEAP32[($0 + 96 | 0) >> 2] | 0;
      $4 = $3 + $2 | 0;
      if ($4 >>> 0 < $3 >>> 0) {
       break label$2
      }
      if ($4 >>> 0 > 128 >>> 0) {
       break label$1
      }
      memcpy(($0 + $3 | 0) + 100 | 0 | 0, $1 | 0, $2 | 0) | 0;
      HEAP32[($0 + 96 | 0) >> 2] = (HEAP32[($0 + 96 | 0) >> 2] | 0) + $2 | 0;
     }
     return;
    }
    core__slice__index__slice_index_order_fail__h71e247dec3f266ff($3 | 0, 128 | 0, 1136144 | 0);
    abort();
   }
   core__slice__index__slice_index_order_fail__h71e247dec3f266ff($3 | 0, $4 | 0, 1136160 | 0);
   abort();
  }
  core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($4 | 0, 128 | 0, 1136160 | 0);
  abort();
 }
 
 function cryptoxide__hashing__blake2b__Context_____update_mut__hbfdae3c7eea3288e($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, $3 = 0, i64toi32_i32$4 = 0, $4 = 0, $6 = 0, $6$hi = 0, $5 = 0, $27 = 0, $34 = 0, $36 = 0, $36$hi = 0, $38 = 0, $39$hi = 0, $54 = 0, $59 = 0, $61 = 0, $61$hi = 0, $63 = 0, $64$hi = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if (!$2) {
       break label$4
      }
      label$5 : {
       $3 = HEAP32[($0 + 96 | 0) >> 2] | 0;
       $4 = 128 - $3 | 0;
       if ($4 >>> 0 >= $2 >>> 0) {
        break label$5
       }
       if ($3 >>> 0 >= 129 >>> 0) {
        break label$3
       }
       $5 = $0 + 100 | 0;
       memcpy($5 + $3 | 0 | 0, $1 | 0, $4 | 0) | 0;
       HEAP32[($0 + 96 | 0) >> 2] = 0;
       $27 = $0;
       i64toi32_i32$2 = $0;
       i64toi32_i32$0 = HEAP32[($0 + 64 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($0 + 68 | 0) >> 2] | 0;
       $6 = i64toi32_i32$0;
       $6$hi = i64toi32_i32$1;
       i64toi32_i32$2 = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 128;
       i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
       i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
       if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
        i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
       }
       i64toi32_i32$2 = $27;
       HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] = i64toi32_i32$4;
       HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] = i64toi32_i32$5;
       $3 = $0 + 72 | 0;
       $34 = $3;
       i64toi32_i32$1 = $3;
       i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $36 = i64toi32_i32$5;
       $36$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $6$hi;
       i64toi32_i32$1 = $6;
       i64toi32_i32$5 = -1;
       i64toi32_i32$3 = -129;
       $38 = i64toi32_i32$2 >>> 0 > i64toi32_i32$5 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$1 >>> 0 > i64toi32_i32$3 >>> 0 | 0) | 0;
       i64toi32_i32$1 = 0;
       $39$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $36$hi;
       i64toi32_i32$3 = $36;
       i64toi32_i32$2 = $39$hi;
       i64toi32_i32$5 = $38;
       i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
       i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
       if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
        i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
       }
       i64toi32_i32$3 = $34;
       HEAP32[i64toi32_i32$3 >> 2] = i64toi32_i32$0;
       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$4;
       $3 = $0 + 64 | 0;
       cryptoxide__hashing__blake2__reference__compress_b__h50335d8cd58c3d7d($0 | 0, $3 | 0, $5 | 0, 128 | 0, 1 | 0);
       $1 = $1 + $4 | 0;
       $2 = $2 - $4 | 0;
       if ($2 >>> 0 < 129 >>> 0) {
        break label$5
       }
       label$6 : while (1) {
        $54 = $0;
        i64toi32_i32$1 = $0;
        i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] | 0;
        $6 = i64toi32_i32$4;
        $6$hi = i64toi32_i32$3;
        i64toi32_i32$1 = i64toi32_i32$4;
        i64toi32_i32$4 = 0;
        i64toi32_i32$5 = 128;
        i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
        i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$4 | 0;
        if (i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0) {
         i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
        }
        i64toi32_i32$1 = $54;
        HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] = i64toi32_i32$2;
        HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] = i64toi32_i32$0;
        $59 = $0;
        i64toi32_i32$3 = $0;
        i64toi32_i32$0 = HEAP32[($0 + 72 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($0 + 76 | 0) >> 2] | 0;
        $61 = i64toi32_i32$0;
        $61$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $6$hi;
        i64toi32_i32$3 = $6;
        i64toi32_i32$0 = -1;
        i64toi32_i32$5 = -129;
        $63 = i64toi32_i32$1 >>> 0 > i64toi32_i32$0 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$3 >>> 0 > i64toi32_i32$5 >>> 0 | 0) | 0;
        i64toi32_i32$3 = 0;
        $64$hi = i64toi32_i32$3;
        i64toi32_i32$3 = $61$hi;
        i64toi32_i32$5 = $61;
        i64toi32_i32$1 = $64$hi;
        i64toi32_i32$0 = $63;
        i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
        i64toi32_i32$2 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
        if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
         i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
        }
        i64toi32_i32$5 = $59;
        HEAP32[(i64toi32_i32$5 + 72 | 0) >> 2] = i64toi32_i32$4;
        HEAP32[(i64toi32_i32$5 + 76 | 0) >> 2] = i64toi32_i32$2;
        cryptoxide__hashing__blake2__reference__compress_b__h50335d8cd58c3d7d($0 | 0, $3 | 0, $1 | 0, 128 | 0, 1 | 0);
        $1 = $1 + 128 | 0;
        $2 = $2 + -128 | 0;
        if ($2 >>> 0 > 128 >>> 0) {
         continue label$6
        }
        break label$6;
       };
      }
      $3 = HEAP32[($0 + 96 | 0) >> 2] | 0;
      $4 = $3 + $2 | 0;
      if ($4 >>> 0 < $3 >>> 0) {
       break label$2
      }
      if ($4 >>> 0 > 128 >>> 0) {
       break label$1
      }
      memcpy(($0 + $3 | 0) + 100 | 0 | 0, $1 | 0, $2 | 0) | 0;
      HEAP32[($0 + 96 | 0) >> 2] = (HEAP32[($0 + 96 | 0) >> 2] | 0) + $2 | 0;
     }
     return;
    }
    core__slice__index__slice_index_order_fail__h71e247dec3f266ff($3 | 0, 128 | 0, 1136144 | 0);
    abort();
   }
   core__slice__index__slice_index_order_fail__h71e247dec3f266ff($3 | 0, $4 | 0, 1136160 | 0);
   abort();
  }
  core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($4 | 0, 128 | 0, 1136160 | 0);
  abort();
 }
 
 function cryptoxide__hashing__blake2b__Context_____update_mut__hd6ae89215701b7de($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, $3 = 0, i64toi32_i32$4 = 0, $4 = 0, $6 = 0, $6$hi = 0, $5 = 0, $27 = 0, $34 = 0, $36 = 0, $36$hi = 0, $38 = 0, $39$hi = 0, $54 = 0, $59 = 0, $61 = 0, $61$hi = 0, $63 = 0, $64$hi = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if (!$2) {
       break label$4
      }
      label$5 : {
       $3 = HEAP32[($0 + 96 | 0) >> 2] | 0;
       $4 = 128 - $3 | 0;
       if ($4 >>> 0 >= $2 >>> 0) {
        break label$5
       }
       if ($3 >>> 0 >= 129 >>> 0) {
        break label$3
       }
       $5 = $0 + 100 | 0;
       memcpy($5 + $3 | 0 | 0, $1 | 0, $4 | 0) | 0;
       HEAP32[($0 + 96 | 0) >> 2] = 0;
       $27 = $0;
       i64toi32_i32$2 = $0;
       i64toi32_i32$0 = HEAP32[($0 + 64 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($0 + 68 | 0) >> 2] | 0;
       $6 = i64toi32_i32$0;
       $6$hi = i64toi32_i32$1;
       i64toi32_i32$2 = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 128;
       i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
       i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
       if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
        i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
       }
       i64toi32_i32$2 = $27;
       HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] = i64toi32_i32$4;
       HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] = i64toi32_i32$5;
       $3 = $0 + 72 | 0;
       $34 = $3;
       i64toi32_i32$1 = $3;
       i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $36 = i64toi32_i32$5;
       $36$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $6$hi;
       i64toi32_i32$1 = $6;
       i64toi32_i32$5 = -1;
       i64toi32_i32$3 = -129;
       $38 = i64toi32_i32$2 >>> 0 > i64toi32_i32$5 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$1 >>> 0 > i64toi32_i32$3 >>> 0 | 0) | 0;
       i64toi32_i32$1 = 0;
       $39$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $36$hi;
       i64toi32_i32$3 = $36;
       i64toi32_i32$2 = $39$hi;
       i64toi32_i32$5 = $38;
       i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
       i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
       if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
        i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
       }
       i64toi32_i32$3 = $34;
       HEAP32[i64toi32_i32$3 >> 2] = i64toi32_i32$0;
       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$4;
       $3 = $0 + 64 | 0;
       cryptoxide__hashing__blake2__reference__compress_b__h50335d8cd58c3d7d($0 | 0, $3 | 0, $5 | 0, 128 | 0, 1 | 0);
       $1 = $1 + $4 | 0;
       $2 = $2 - $4 | 0;
       if ($2 >>> 0 < 129 >>> 0) {
        break label$5
       }
       label$6 : while (1) {
        $54 = $0;
        i64toi32_i32$1 = $0;
        i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] | 0;
        $6 = i64toi32_i32$4;
        $6$hi = i64toi32_i32$3;
        i64toi32_i32$1 = i64toi32_i32$4;
        i64toi32_i32$4 = 0;
        i64toi32_i32$5 = 128;
        i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
        i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$4 | 0;
        if (i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0) {
         i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
        }
        i64toi32_i32$1 = $54;
        HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] = i64toi32_i32$2;
        HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] = i64toi32_i32$0;
        $59 = $0;
        i64toi32_i32$3 = $0;
        i64toi32_i32$0 = HEAP32[($0 + 72 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($0 + 76 | 0) >> 2] | 0;
        $61 = i64toi32_i32$0;
        $61$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $6$hi;
        i64toi32_i32$3 = $6;
        i64toi32_i32$0 = -1;
        i64toi32_i32$5 = -129;
        $63 = i64toi32_i32$1 >>> 0 > i64toi32_i32$0 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$3 >>> 0 > i64toi32_i32$5 >>> 0 | 0) | 0;
        i64toi32_i32$3 = 0;
        $64$hi = i64toi32_i32$3;
        i64toi32_i32$3 = $61$hi;
        i64toi32_i32$5 = $61;
        i64toi32_i32$1 = $64$hi;
        i64toi32_i32$0 = $63;
        i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
        i64toi32_i32$2 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
        if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
         i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
        }
        i64toi32_i32$5 = $59;
        HEAP32[(i64toi32_i32$5 + 72 | 0) >> 2] = i64toi32_i32$4;
        HEAP32[(i64toi32_i32$5 + 76 | 0) >> 2] = i64toi32_i32$2;
        cryptoxide__hashing__blake2__reference__compress_b__h50335d8cd58c3d7d($0 | 0, $3 | 0, $1 | 0, 128 | 0, 1 | 0);
        $1 = $1 + 128 | 0;
        $2 = $2 + -128 | 0;
        if ($2 >>> 0 > 128 >>> 0) {
         continue label$6
        }
        break label$6;
       };
      }
      $3 = HEAP32[($0 + 96 | 0) >> 2] | 0;
      $4 = $3 + $2 | 0;
      if ($4 >>> 0 < $3 >>> 0) {
       break label$2
      }
      if ($4 >>> 0 > 128 >>> 0) {
       break label$1
      }
      memcpy(($0 + $3 | 0) + 100 | 0 | 0, $1 | 0, $2 | 0) | 0;
      HEAP32[($0 + 96 | 0) >> 2] = (HEAP32[($0 + 96 | 0) >> 2] | 0) + $2 | 0;
     }
     return;
    }
    core__slice__index__slice_index_order_fail__h71e247dec3f266ff($3 | 0, 128 | 0, 1136144 | 0);
    abort();
   }
   core__slice__index__slice_index_order_fail__h71e247dec3f266ff($3 | 0, $4 | 0, 1136160 | 0);
   abort();
  }
  core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($4 | 0, 128 | 0, 1136160 | 0);
  abort();
 }
 
 function cryptoxide__hashing__blake2b__Context_____update_mut__hd7b17262761d9f43($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, $3 = 0, i64toi32_i32$4 = 0, $4 = 0, $6 = 0, $6$hi = 0, $5 = 0, $27 = 0, $34 = 0, $36 = 0, $36$hi = 0, $38 = 0, $39$hi = 0, $54 = 0, $59 = 0, $61 = 0, $61$hi = 0, $63 = 0, $64$hi = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if (!$2) {
       break label$4
      }
      label$5 : {
       $3 = HEAP32[($0 + 96 | 0) >> 2] | 0;
       $4 = 128 - $3 | 0;
       if ($4 >>> 0 >= $2 >>> 0) {
        break label$5
       }
       if ($3 >>> 0 >= 129 >>> 0) {
        break label$3
       }
       $5 = $0 + 100 | 0;
       memcpy($5 + $3 | 0 | 0, $1 | 0, $4 | 0) | 0;
       HEAP32[($0 + 96 | 0) >> 2] = 0;
       $27 = $0;
       i64toi32_i32$2 = $0;
       i64toi32_i32$0 = HEAP32[($0 + 64 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($0 + 68 | 0) >> 2] | 0;
       $6 = i64toi32_i32$0;
       $6$hi = i64toi32_i32$1;
       i64toi32_i32$2 = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 128;
       i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
       i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
       if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
        i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
       }
       i64toi32_i32$2 = $27;
       HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] = i64toi32_i32$4;
       HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] = i64toi32_i32$5;
       $3 = $0 + 72 | 0;
       $34 = $3;
       i64toi32_i32$1 = $3;
       i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $36 = i64toi32_i32$5;
       $36$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $6$hi;
       i64toi32_i32$1 = $6;
       i64toi32_i32$5 = -1;
       i64toi32_i32$3 = -129;
       $38 = i64toi32_i32$2 >>> 0 > i64toi32_i32$5 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$1 >>> 0 > i64toi32_i32$3 >>> 0 | 0) | 0;
       i64toi32_i32$1 = 0;
       $39$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $36$hi;
       i64toi32_i32$3 = $36;
       i64toi32_i32$2 = $39$hi;
       i64toi32_i32$5 = $38;
       i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
       i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
       if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
        i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
       }
       i64toi32_i32$3 = $34;
       HEAP32[i64toi32_i32$3 >> 2] = i64toi32_i32$0;
       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$4;
       $3 = $0 + 64 | 0;
       cryptoxide__hashing__blake2__reference__compress_b__h50335d8cd58c3d7d($0 | 0, $3 | 0, $5 | 0, 128 | 0, 1 | 0);
       $1 = $1 + $4 | 0;
       $2 = $2 - $4 | 0;
       if ($2 >>> 0 < 129 >>> 0) {
        break label$5
       }
       label$6 : while (1) {
        $54 = $0;
        i64toi32_i32$1 = $0;
        i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] | 0;
        $6 = i64toi32_i32$4;
        $6$hi = i64toi32_i32$3;
        i64toi32_i32$1 = i64toi32_i32$4;
        i64toi32_i32$4 = 0;
        i64toi32_i32$5 = 128;
        i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
        i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$4 | 0;
        if (i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0) {
         i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
        }
        i64toi32_i32$1 = $54;
        HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] = i64toi32_i32$2;
        HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] = i64toi32_i32$0;
        $59 = $0;
        i64toi32_i32$3 = $0;
        i64toi32_i32$0 = HEAP32[($0 + 72 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($0 + 76 | 0) >> 2] | 0;
        $61 = i64toi32_i32$0;
        $61$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $6$hi;
        i64toi32_i32$3 = $6;
        i64toi32_i32$0 = -1;
        i64toi32_i32$5 = -129;
        $63 = i64toi32_i32$1 >>> 0 > i64toi32_i32$0 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$3 >>> 0 > i64toi32_i32$5 >>> 0 | 0) | 0;
        i64toi32_i32$3 = 0;
        $64$hi = i64toi32_i32$3;
        i64toi32_i32$3 = $61$hi;
        i64toi32_i32$5 = $61;
        i64toi32_i32$1 = $64$hi;
        i64toi32_i32$0 = $63;
        i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
        i64toi32_i32$2 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
        if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
         i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
        }
        i64toi32_i32$5 = $59;
        HEAP32[(i64toi32_i32$5 + 72 | 0) >> 2] = i64toi32_i32$4;
        HEAP32[(i64toi32_i32$5 + 76 | 0) >> 2] = i64toi32_i32$2;
        cryptoxide__hashing__blake2__reference__compress_b__h50335d8cd58c3d7d($0 | 0, $3 | 0, $1 | 0, 128 | 0, 1 | 0);
        $1 = $1 + 128 | 0;
        $2 = $2 + -128 | 0;
        if ($2 >>> 0 > 128 >>> 0) {
         continue label$6
        }
        break label$6;
       };
      }
      $3 = HEAP32[($0 + 96 | 0) >> 2] | 0;
      $4 = $3 + $2 | 0;
      if ($4 >>> 0 < $3 >>> 0) {
       break label$2
      }
      if ($4 >>> 0 > 128 >>> 0) {
       break label$1
      }
      memcpy(($0 + $3 | 0) + 100 | 0 | 0, $1 | 0, $2 | 0) | 0;
      HEAP32[($0 + 96 | 0) >> 2] = (HEAP32[($0 + 96 | 0) >> 2] | 0) + $2 | 0;
     }
     return;
    }
    core__slice__index__slice_index_order_fail__h71e247dec3f266ff($3 | 0, 128 | 0, 1136144 | 0);
    abort();
   }
   core__slice__index__slice_index_order_fail__h71e247dec3f266ff($3 | 0, $4 | 0, 1136160 | 0);
   abort();
  }
  core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($4 | 0, 128 | 0, 1136160 | 0);
  abort();
 }
 
 function cryptoxide__hashing__blake2b__Context_____update_mut__hd8132cf488b8b01a($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, $3 = 0, i64toi32_i32$4 = 0, $4 = 0, $6 = 0, $6$hi = 0, $5 = 0, $27 = 0, $34 = 0, $36 = 0, $36$hi = 0, $38 = 0, $39$hi = 0, $54 = 0, $59 = 0, $61 = 0, $61$hi = 0, $63 = 0, $64$hi = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if (!$2) {
       break label$4
      }
      label$5 : {
       $3 = HEAP32[($0 + 96 | 0) >> 2] | 0;
       $4 = 128 - $3 | 0;
       if ($4 >>> 0 >= $2 >>> 0) {
        break label$5
       }
       if ($3 >>> 0 >= 129 >>> 0) {
        break label$3
       }
       $5 = $0 + 100 | 0;
       memcpy($5 + $3 | 0 | 0, $1 | 0, $4 | 0) | 0;
       HEAP32[($0 + 96 | 0) >> 2] = 0;
       $27 = $0;
       i64toi32_i32$2 = $0;
       i64toi32_i32$0 = HEAP32[($0 + 64 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($0 + 68 | 0) >> 2] | 0;
       $6 = i64toi32_i32$0;
       $6$hi = i64toi32_i32$1;
       i64toi32_i32$2 = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 128;
       i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
       i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
       if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
        i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
       }
       i64toi32_i32$2 = $27;
       HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] = i64toi32_i32$4;
       HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] = i64toi32_i32$5;
       $3 = $0 + 72 | 0;
       $34 = $3;
       i64toi32_i32$1 = $3;
       i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $36 = i64toi32_i32$5;
       $36$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $6$hi;
       i64toi32_i32$1 = $6;
       i64toi32_i32$5 = -1;
       i64toi32_i32$3 = -129;
       $38 = i64toi32_i32$2 >>> 0 > i64toi32_i32$5 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$1 >>> 0 > i64toi32_i32$3 >>> 0 | 0) | 0;
       i64toi32_i32$1 = 0;
       $39$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $36$hi;
       i64toi32_i32$3 = $36;
       i64toi32_i32$2 = $39$hi;
       i64toi32_i32$5 = $38;
       i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
       i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
       if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
        i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
       }
       i64toi32_i32$3 = $34;
       HEAP32[i64toi32_i32$3 >> 2] = i64toi32_i32$0;
       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$4;
       $3 = $0 + 64 | 0;
       cryptoxide__hashing__blake2__reference__compress_b__h50335d8cd58c3d7d($0 | 0, $3 | 0, $5 | 0, 128 | 0, 1 | 0);
       $1 = $1 + $4 | 0;
       $2 = $2 - $4 | 0;
       if ($2 >>> 0 < 129 >>> 0) {
        break label$5
       }
       label$6 : while (1) {
        $54 = $0;
        i64toi32_i32$1 = $0;
        i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] | 0;
        $6 = i64toi32_i32$4;
        $6$hi = i64toi32_i32$3;
        i64toi32_i32$1 = i64toi32_i32$4;
        i64toi32_i32$4 = 0;
        i64toi32_i32$5 = 128;
        i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
        i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$4 | 0;
        if (i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0) {
         i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
        }
        i64toi32_i32$1 = $54;
        HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] = i64toi32_i32$2;
        HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] = i64toi32_i32$0;
        $59 = $0;
        i64toi32_i32$3 = $0;
        i64toi32_i32$0 = HEAP32[($0 + 72 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($0 + 76 | 0) >> 2] | 0;
        $61 = i64toi32_i32$0;
        $61$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $6$hi;
        i64toi32_i32$3 = $6;
        i64toi32_i32$0 = -1;
        i64toi32_i32$5 = -129;
        $63 = i64toi32_i32$1 >>> 0 > i64toi32_i32$0 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$3 >>> 0 > i64toi32_i32$5 >>> 0 | 0) | 0;
        i64toi32_i32$3 = 0;
        $64$hi = i64toi32_i32$3;
        i64toi32_i32$3 = $61$hi;
        i64toi32_i32$5 = $61;
        i64toi32_i32$1 = $64$hi;
        i64toi32_i32$0 = $63;
        i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
        i64toi32_i32$2 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
        if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
         i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
        }
        i64toi32_i32$5 = $59;
        HEAP32[(i64toi32_i32$5 + 72 | 0) >> 2] = i64toi32_i32$4;
        HEAP32[(i64toi32_i32$5 + 76 | 0) >> 2] = i64toi32_i32$2;
        cryptoxide__hashing__blake2__reference__compress_b__h50335d8cd58c3d7d($0 | 0, $3 | 0, $1 | 0, 128 | 0, 1 | 0);
        $1 = $1 + 128 | 0;
        $2 = $2 + -128 | 0;
        if ($2 >>> 0 > 128 >>> 0) {
         continue label$6
        }
        break label$6;
       };
      }
      $3 = HEAP32[($0 + 96 | 0) >> 2] | 0;
      $4 = $3 + $2 | 0;
      if ($4 >>> 0 < $3 >>> 0) {
       break label$2
      }
      if ($4 >>> 0 > 128 >>> 0) {
       break label$1
      }
      memcpy(($0 + $3 | 0) + 100 | 0 | 0, $1 | 0, $2 | 0) | 0;
      HEAP32[($0 + 96 | 0) >> 2] = (HEAP32[($0 + 96 | 0) >> 2] | 0) + $2 | 0;
     }
     return;
    }
    core__slice__index__slice_index_order_fail__h71e247dec3f266ff($3 | 0, 128 | 0, 1136144 | 0);
    abort();
   }
   core__slice__index__slice_index_order_fail__h71e247dec3f266ff($3 | 0, $4 | 0, 1136160 | 0);
   abort();
  }
  core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($4 | 0, 128 | 0, 1136160 | 0);
  abort();
 }
 
 function cryptoxide__hashing__blake2b__Context_____update_mut__hdf71b0ccb149f090($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, $3 = 0, i64toi32_i32$4 = 0, $4 = 0, $6 = 0, $6$hi = 0, $5 = 0, $27 = 0, $34 = 0, $36 = 0, $36$hi = 0, $38 = 0, $39$hi = 0, $54 = 0, $59 = 0, $61 = 0, $61$hi = 0, $63 = 0, $64$hi = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if (!$2) {
       break label$4
      }
      label$5 : {
       $3 = HEAP32[($0 + 96 | 0) >> 2] | 0;
       $4 = 128 - $3 | 0;
       if ($4 >>> 0 >= $2 >>> 0) {
        break label$5
       }
       if ($3 >>> 0 >= 129 >>> 0) {
        break label$3
       }
       $5 = $0 + 100 | 0;
       memcpy($5 + $3 | 0 | 0, $1 | 0, $4 | 0) | 0;
       HEAP32[($0 + 96 | 0) >> 2] = 0;
       $27 = $0;
       i64toi32_i32$2 = $0;
       i64toi32_i32$0 = HEAP32[($0 + 64 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($0 + 68 | 0) >> 2] | 0;
       $6 = i64toi32_i32$0;
       $6$hi = i64toi32_i32$1;
       i64toi32_i32$2 = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 128;
       i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
       i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
       if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
        i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
       }
       i64toi32_i32$2 = $27;
       HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] = i64toi32_i32$4;
       HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] = i64toi32_i32$5;
       $3 = $0 + 72 | 0;
       $34 = $3;
       i64toi32_i32$1 = $3;
       i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $36 = i64toi32_i32$5;
       $36$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $6$hi;
       i64toi32_i32$1 = $6;
       i64toi32_i32$5 = -1;
       i64toi32_i32$3 = -129;
       $38 = i64toi32_i32$2 >>> 0 > i64toi32_i32$5 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$1 >>> 0 > i64toi32_i32$3 >>> 0 | 0) | 0;
       i64toi32_i32$1 = 0;
       $39$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $36$hi;
       i64toi32_i32$3 = $36;
       i64toi32_i32$2 = $39$hi;
       i64toi32_i32$5 = $38;
       i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
       i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
       if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
        i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
       }
       i64toi32_i32$3 = $34;
       HEAP32[i64toi32_i32$3 >> 2] = i64toi32_i32$0;
       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$4;
       $3 = $0 + 64 | 0;
       cryptoxide__hashing__blake2__reference__compress_b__h50335d8cd58c3d7d($0 | 0, $3 | 0, $5 | 0, 128 | 0, 1 | 0);
       $1 = $1 + $4 | 0;
       $2 = $2 - $4 | 0;
       if ($2 >>> 0 < 129 >>> 0) {
        break label$5
       }
       label$6 : while (1) {
        $54 = $0;
        i64toi32_i32$1 = $0;
        i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] | 0;
        $6 = i64toi32_i32$4;
        $6$hi = i64toi32_i32$3;
        i64toi32_i32$1 = i64toi32_i32$4;
        i64toi32_i32$4 = 0;
        i64toi32_i32$5 = 128;
        i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
        i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$4 | 0;
        if (i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0) {
         i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
        }
        i64toi32_i32$1 = $54;
        HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] = i64toi32_i32$2;
        HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] = i64toi32_i32$0;
        $59 = $0;
        i64toi32_i32$3 = $0;
        i64toi32_i32$0 = HEAP32[($0 + 72 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($0 + 76 | 0) >> 2] | 0;
        $61 = i64toi32_i32$0;
        $61$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $6$hi;
        i64toi32_i32$3 = $6;
        i64toi32_i32$0 = -1;
        i64toi32_i32$5 = -129;
        $63 = i64toi32_i32$1 >>> 0 > i64toi32_i32$0 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$3 >>> 0 > i64toi32_i32$5 >>> 0 | 0) | 0;
        i64toi32_i32$3 = 0;
        $64$hi = i64toi32_i32$3;
        i64toi32_i32$3 = $61$hi;
        i64toi32_i32$5 = $61;
        i64toi32_i32$1 = $64$hi;
        i64toi32_i32$0 = $63;
        i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
        i64toi32_i32$2 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
        if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
         i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
        }
        i64toi32_i32$5 = $59;
        HEAP32[(i64toi32_i32$5 + 72 | 0) >> 2] = i64toi32_i32$4;
        HEAP32[(i64toi32_i32$5 + 76 | 0) >> 2] = i64toi32_i32$2;
        cryptoxide__hashing__blake2__reference__compress_b__h50335d8cd58c3d7d($0 | 0, $3 | 0, $1 | 0, 128 | 0, 1 | 0);
        $1 = $1 + 128 | 0;
        $2 = $2 + -128 | 0;
        if ($2 >>> 0 > 128 >>> 0) {
         continue label$6
        }
        break label$6;
       };
      }
      $3 = HEAP32[($0 + 96 | 0) >> 2] | 0;
      $4 = $3 + $2 | 0;
      if ($4 >>> 0 < $3 >>> 0) {
       break label$2
      }
      if ($4 >>> 0 > 128 >>> 0) {
       break label$1
      }
      memcpy(($0 + $3 | 0) + 100 | 0 | 0, $1 | 0, $2 | 0) | 0;
      HEAP32[($0 + 96 | 0) >> 2] = (HEAP32[($0 + 96 | 0) >> 2] | 0) + $2 | 0;
     }
     return;
    }
    core__slice__index__slice_index_order_fail__h71e247dec3f266ff($3 | 0, 128 | 0, 1136144 | 0);
    abort();
   }
   core__slice__index__slice_index_order_fail__h71e247dec3f266ff($3 | 0, $4 | 0, 1136160 | 0);
   abort();
  }
  core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($4 | 0, 128 | 0, 1136160 | 0);
  abort();
 }
 
 function cryptoxide__hashing__blake2b__Context_____update_mut__hf14c329a0514a0fb($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, $3 = 0, i64toi32_i32$4 = 0, $4 = 0, $6 = 0, $6$hi = 0, $5 = 0, $27 = 0, $34 = 0, $36 = 0, $36$hi = 0, $38 = 0, $39$hi = 0, $54 = 0, $59 = 0, $61 = 0, $61$hi = 0, $63 = 0, $64$hi = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if (!$2) {
       break label$4
      }
      label$5 : {
       $3 = HEAP32[($0 + 96 | 0) >> 2] | 0;
       $4 = 128 - $3 | 0;
       if ($4 >>> 0 >= $2 >>> 0) {
        break label$5
       }
       if ($3 >>> 0 >= 129 >>> 0) {
        break label$3
       }
       $5 = $0 + 100 | 0;
       memcpy($5 + $3 | 0 | 0, $1 | 0, $4 | 0) | 0;
       HEAP32[($0 + 96 | 0) >> 2] = 0;
       $27 = $0;
       i64toi32_i32$2 = $0;
       i64toi32_i32$0 = HEAP32[($0 + 64 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($0 + 68 | 0) >> 2] | 0;
       $6 = i64toi32_i32$0;
       $6$hi = i64toi32_i32$1;
       i64toi32_i32$2 = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 128;
       i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
       i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
       if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
        i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
       }
       i64toi32_i32$2 = $27;
       HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] = i64toi32_i32$4;
       HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] = i64toi32_i32$5;
       $3 = $0 + 72 | 0;
       $34 = $3;
       i64toi32_i32$1 = $3;
       i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
       $36 = i64toi32_i32$5;
       $36$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $6$hi;
       i64toi32_i32$1 = $6;
       i64toi32_i32$5 = -1;
       i64toi32_i32$3 = -129;
       $38 = i64toi32_i32$2 >>> 0 > i64toi32_i32$5 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$1 >>> 0 > i64toi32_i32$3 >>> 0 | 0) | 0;
       i64toi32_i32$1 = 0;
       $39$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $36$hi;
       i64toi32_i32$3 = $36;
       i64toi32_i32$2 = $39$hi;
       i64toi32_i32$5 = $38;
       i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
       i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
       if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
        i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
       }
       i64toi32_i32$3 = $34;
       HEAP32[i64toi32_i32$3 >> 2] = i64toi32_i32$0;
       HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$4;
       $3 = $0 + 64 | 0;
       cryptoxide__hashing__blake2__reference__compress_b__h50335d8cd58c3d7d($0 | 0, $3 | 0, $5 | 0, 128 | 0, 1 | 0);
       $1 = $1 + $4 | 0;
       $2 = $2 - $4 | 0;
       if ($2 >>> 0 < 129 >>> 0) {
        break label$5
       }
       label$6 : while (1) {
        $54 = $0;
        i64toi32_i32$1 = $0;
        i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] | 0;
        i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] | 0;
        $6 = i64toi32_i32$4;
        $6$hi = i64toi32_i32$3;
        i64toi32_i32$1 = i64toi32_i32$4;
        i64toi32_i32$4 = 0;
        i64toi32_i32$5 = 128;
        i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
        i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$4 | 0;
        if (i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0) {
         i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
        }
        i64toi32_i32$1 = $54;
        HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] = i64toi32_i32$2;
        HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] = i64toi32_i32$0;
        $59 = $0;
        i64toi32_i32$3 = $0;
        i64toi32_i32$0 = HEAP32[($0 + 72 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($0 + 76 | 0) >> 2] | 0;
        $61 = i64toi32_i32$0;
        $61$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $6$hi;
        i64toi32_i32$3 = $6;
        i64toi32_i32$0 = -1;
        i64toi32_i32$5 = -129;
        $63 = i64toi32_i32$1 >>> 0 > i64toi32_i32$0 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$3 >>> 0 > i64toi32_i32$5 >>> 0 | 0) | 0;
        i64toi32_i32$3 = 0;
        $64$hi = i64toi32_i32$3;
        i64toi32_i32$3 = $61$hi;
        i64toi32_i32$5 = $61;
        i64toi32_i32$1 = $64$hi;
        i64toi32_i32$0 = $63;
        i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
        i64toi32_i32$2 = i64toi32_i32$3 + i64toi32_i32$1 | 0;
        if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
         i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
        }
        i64toi32_i32$5 = $59;
        HEAP32[(i64toi32_i32$5 + 72 | 0) >> 2] = i64toi32_i32$4;
        HEAP32[(i64toi32_i32$5 + 76 | 0) >> 2] = i64toi32_i32$2;
        cryptoxide__hashing__blake2__reference__compress_b__h50335d8cd58c3d7d($0 | 0, $3 | 0, $1 | 0, 128 | 0, 1 | 0);
        $1 = $1 + 128 | 0;
        $2 = $2 + -128 | 0;
        if ($2 >>> 0 > 128 >>> 0) {
         continue label$6
        }
        break label$6;
       };
      }
      $3 = HEAP32[($0 + 96 | 0) >> 2] | 0;
      $4 = $3 + $2 | 0;
      if ($4 >>> 0 < $3 >>> 0) {
       break label$2
      }
      if ($4 >>> 0 > 128 >>> 0) {
       break label$1
      }
      memcpy(($0 + $3 | 0) + 100 | 0 | 0, $1 | 0, $2 | 0) | 0;
      HEAP32[($0 + 96 | 0) >> 2] = (HEAP32[($0 + 96 | 0) >> 2] | 0) + $2 | 0;
     }
     return;
    }
    core__slice__index__slice_index_order_fail__h71e247dec3f266ff($3 | 0, 128 | 0, 1136144 | 0);
    abort();
   }
   core__slice__index__slice_index_order_fail__h71e247dec3f266ff($3 | 0, $4 | 0, 1136160 | 0);
   abort();
  }
  core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($4 | 0, 128 | 0, 1136160 | 0);
  abort();
 }
 
 function core__fmt__Write__write_char__hc23b8976fd50d3f8($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  HEAP32[($2 + 12 | 0) >> 2] = 0;
  label$1 : {
   label$2 : {
    if ($1 >>> 0 < 128 >>> 0) {
     break label$2
    }
    label$3 : {
     if ($1 >>> 0 < 2048 >>> 0) {
      break label$3
     }
     label$4 : {
      if ($1 >>> 0 < 65536 >>> 0) {
       break label$4
      }
      HEAP8[($2 + 15 | 0) >> 0] = $1 & 63 | 0 | 128 | 0;
      HEAP8[($2 + 12 | 0) >> 0] = $1 >>> 18 | 0 | 240 | 0;
      HEAP8[($2 + 14 | 0) >> 0] = ($1 >>> 6 | 0) & 63 | 0 | 128 | 0;
      HEAP8[($2 + 13 | 0) >> 0] = ($1 >>> 12 | 0) & 63 | 0 | 128 | 0;
      $1 = 4;
      break label$1;
     }
     HEAP8[($2 + 14 | 0) >> 0] = $1 & 63 | 0 | 128 | 0;
     HEAP8[($2 + 12 | 0) >> 0] = $1 >>> 12 | 0 | 224 | 0;
     HEAP8[($2 + 13 | 0) >> 0] = ($1 >>> 6 | 0) & 63 | 0 | 128 | 0;
     $1 = 3;
     break label$1;
    }
    HEAP8[($2 + 13 | 0) >> 0] = $1 & 63 | 0 | 128 | 0;
    HEAP8[($2 + 12 | 0) >> 0] = $1 >>> 6 | 0 | 192 | 0;
    $1 = 2;
    break label$1;
   }
   HEAP8[($2 + 12 | 0) >> 0] = $1;
   $1 = 1;
  }
  label$5 : {
   $3 = HEAP32[$0 >> 2] | 0;
   $4 = $3 + 8 | 0;
   $0 = HEAP32[$4 >> 2] | 0;
   if (((HEAP32[($3 + 4 | 0) >> 2] | 0) - $0 | 0) >>> 0 >= $1 >>> 0) {
    break label$5
   }
   alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hc5a84431bcb0aafc($3 | 0, $0 | 0, $1 | 0);
   $0 = HEAP32[$4 >> 2] | 0;
  }
  memcpy((HEAP32[$3 >> 2] | 0) + $0 | 0 | 0, $2 + 12 | 0 | 0, $1 | 0) | 0;
  HEAP32[$4 >> 2] = $0 + $1 | 0;
  global$0 = $2 + 16 | 0;
  return 0 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert__hfa2ea511a82b92c9($0, $1, $2, $3, $3$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  var $4 = 0, i64toi32_i32$1 = 0, $5 = 0, $6 = 0, i64toi32_i32$0 = 0, $8 = 0, $7 = 0, $9 = 0, $10$hi = 0, $81 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $4 = global$0 - 32 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    $5 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if ((HEAPU16[($5 + 138 | 0) >> 1] | 0) >>> 0 < 11 >>> 0) {
     break label$2
    }
    alloc__collections__btree__node__splitpoint__h8424344594b4deb1($4 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
    $6 = HEAP32[(($4 + 16 | 0) + 8 | 0) >> 2] | 0;
    $7 = HEAP32[($4 + 20 | 0) >> 2] | 0;
    $8 = HEAP32[$1 >> 2] | 0;
    HEAP32[($4 + 24 | 0) >> 2] = HEAP32[($4 + 16 | 0) >> 2] | 0;
    HEAP32[($4 + 20 | 0) >> 2] = $5;
    HEAP32[($4 + 16 | 0) >> 2] = $8;
    $1 = alloc__boxed__Box_T_2cA___new_uninit_in__h78d744dfd1820fc4() | 0;
    HEAP16[($1 + 138 | 0) >> 1] = 0;
    HEAP32[($1 + 88 | 0) >> 2] = 0;
    alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__h34e2ad51d8d58ed5($4 | 0, $4 + 16 | 0 | 0, $1 | 0);
    $9 = HEAP32[$4 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    $10$hi = i64toi32_i32$1;
    HEAP32[($4 + 24 | 0) >> 2] = $6;
    $6 = ($7 | 0) == (1 | 0);
    HEAP32[($4 + 20 | 0) >> 2] = $6 ? $1 : $5;
    HEAP32[($4 + 16 | 0) >> 2] = $6 ? 0 : $8;
    i64toi32_i32$1 = $3$hi;
    (wasm2js_i32$0 = $0, wasm2js_i32$1 = alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_fit__hd71c9bcee1c629bd($4 + 16 | 0 | 0, $2 | 0, $3 | 0, i64toi32_i32$1 | 0) | 0), HEAP32[(wasm2js_i32$0 + 40 | 0) >> 2] = wasm2js_i32$1;
    HEAP32[($0 + 36 | 0) >> 2] = $1;
    HEAP32[($0 + 32 | 0) >> 2] = 0;
    HEAP32[($0 + 28 | 0) >> 2] = $5;
    HEAP32[($0 + 24 | 0) >> 2] = $8;
    i64toi32_i32$1 = $10$hi;
    $81 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $81;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($0 + 8 | 0) >> 2] = $9;
    HEAP32[$0 >> 2] = 1;
    break label$1;
   }
   i64toi32_i32$1 = $3$hi;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_fit__hd71c9bcee1c629bd($1 | 0, $2 | 0, $3 | 0, i64toi32_i32$1 | 0) | 0), HEAP32[(wasm2js_i32$0 + 40 | 0) >> 2] = wasm2js_i32$1;
   HEAP32[($0 + 8 | 0) >> 2] = $5;
   HEAP32[$0 >> 2] = 0;
   HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
   HEAP32[($0 + 4 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
  }
  global$0 = $4 + 32 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_fit__h0a283f3f7809721f($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $8 = 0, $4 = 0, $5 = 0, $6 = 0, $7 = 0, $27 = 0, $60 = 0, $67 = 0, $71 = 0, $74 = 0, $95 = 0, $99 = 0, $105 = 0;
  $3 = global$0 - 32 | 0;
  global$0 = $3;
  $4 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $5 = HEAPU16[($4 + 402 | 0) >> 1] | 0;
  $0 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  $6 = ($3 + 8 | 0) + 8 | 0;
  HEAP32[$6 >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $27 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $27;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   $1 = $0 + 1 | 0;
   $7 = $1 >>> 0 > $5 >>> 0;
   if ($7) {
    break label$1
   }
   $8 = $4 + 268 | 0;
   memmove($8 + Math_imul($1, 12) | 0 | 0, $8 + Math_imul($0, 12) | 0 | 0, Math_imul($5 - $0 | 0, 12) | 0) | 0;
  }
  $8 = $4 + Math_imul($0, 12) | 0;
  HEAP32[($8 + 276 | 0) >> 2] = HEAP32[$6 >> 2] | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $60 = i64toi32_i32$1;
  i64toi32_i32$1 = $8 + 268 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $60;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $8 = (i64toi32_i32$2 + 8 | 0) + 16 | 0;
  i64toi32_i32$2 = $2 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $67 = i64toi32_i32$0;
  i64toi32_i32$0 = $8;
  HEAP32[i64toi32_i32$0 >> 2] = $67;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $71 = i64toi32_i32$1;
  i64toi32_i32$1 = $6;
  HEAP32[i64toi32_i32$1 >> 2] = $71;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $74 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $74;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
  label$2 : {
   if ($7) {
    break label$2
   }
   memmove($4 + Math_imul($1, 24) | 0 | 0, $4 + Math_imul($0, 24) | 0 | 0, Math_imul($5 - $0 | 0, 24) | 0) | 0;
  }
  $0 = $4 + Math_imul($0, 24) | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $95 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $95;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $8;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $99 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $99;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = ($3 + 8 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $105 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $105;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP16[($4 + 402 | 0) >> 1] = $5 + 1 | 0;
  global$0 = $3 + 32 | 0;
  return $0 | 0;
 }
 
 function $rand_os__OsRng_20as_20rand_core__RngCore___fill_bytes__h6a20d3c9ee8171ca($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, i64toi32_i32$2 = 0, $5 = 0, $27 = 0, $30 = 0;
  $3 = global$0 - 80 | 0;
  global$0 = $3;
  $rand_os__OsRng_20as_20rand_core__RngCore___try_fill_bytes__hc4399e14db3c3fde($3 | 0, $0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   if ((HEAPU8[($3 + 16 | 0) >> 0] | 0 | 0) == (5 | 0)) {
    break label$1
   }
   $4 = 0;
   label$2 : while (1) {
    HEAP32[(($3 + 24 | 0) + 16 | 0) >> 2] = HEAP32[($3 + 16 | 0) >> 2] | 0;
    i64toi32_i32$2 = $3 + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $27 = i64toi32_i32$0;
    i64toi32_i32$0 = ($3 + 24 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $27;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAP32[$3 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($3 + 4 | 0) >> 2] | 0;
    $30 = i64toi32_i32$1;
    i64toi32_i32$1 = $3;
    HEAP32[($3 + 24 | 0) >> 2] = $30;
    HEAP32[($3 + 28 | 0) >> 2] = i64toi32_i32$0;
    label$3 : {
     label$4 : {
      if ($4 >>> 0 > 99 >>> 0) {
       break label$4
      }
      label$5 : {
       label$6 : {
        $5 = HEAPU8[($3 + 40 | 0) >> 0] | 0;
        if (rand_core__error__ErrorKind__should_wait__hbe6d5f14d015f403($5 | 0) | 0) {
         break label$6
        }
        if (rand_core__error__ErrorKind__should_retry__h9bc202e7c0f6515a($5 | 0) | 0) {
         break label$5
        }
        HEAP32[($3 + 68 | 0) >> 2] = 1;
        i64toi32_i32$1 = $3;
        i64toi32_i32$0 = 0;
        HEAP32[($3 + 52 | 0) >> 2] = 1;
        HEAP32[($3 + 56 | 0) >> 2] = i64toi32_i32$0;
        HEAP32[($3 + 48 | 0) >> 2] = 1100700;
        HEAP32[($3 + 76 | 0) >> 2] = 109;
        HEAP32[($3 + 64 | 0) >> 2] = $3 + 72 | 0;
        HEAP32[($3 + 72 | 0) >> 2] = $3 + 24 | 0;
        std__panicking__begin_panic_fmt__h3dc1b0b65bbd6c17($3 + 48 | 0 | 0, 1100708 | 0);
        abort();
       }
       i64toi32_i32$0 = 0;
       std__thread__sleep__h640fd39e45b76d4c(0 | 0, i64toi32_i32$0 | 0, 1e8 | 0);
       $4 = $4 + 1 | 0;
       break label$3;
      }
      $4 = $4 + 13 | 0;
      break label$3;
     }
     HEAP32[($3 + 68 | 0) >> 2] = 1;
     i64toi32_i32$1 = $3;
     i64toi32_i32$0 = 0;
     HEAP32[($3 + 52 | 0) >> 2] = 1;
     HEAP32[($3 + 56 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($3 + 48 | 0) >> 2] = 1100656;
     HEAP32[($3 + 76 | 0) >> 2] = 109;
     HEAP32[($3 + 64 | 0) >> 2] = $3 + 72 | 0;
     HEAP32[($3 + 72 | 0) >> 2] = $3 + 24 | 0;
     std__panicking__begin_panic_fmt__h3dc1b0b65bbd6c17($3 + 48 | 0 | 0, 1100664 | 0);
     abort();
    }
    core__ptr__drop_in_place_rand_core__error__Error___h93f554cc6cc9aba6($3 + 24 | 0 | 0);
    $rand_os__OsRng_20as_20rand_core__RngCore___try_fill_bytes__hc4399e14db3c3fde($3 | 0, $0 | 0, $1 | 0, $2 | 0);
    if ((HEAPU8[($3 + 16 | 0) >> 0] | 0 | 0) != (5 | 0)) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $3 + 80 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__SerializeEmbeddedGroup_20for_20cardano_serialization_lib__OperationalCert___serialize_as_embedded_group__he54340275d75ae4f($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, $13 = 0, $19 = 0, $25 = 0, $28 = 0;
  $3 = global$0 - 80 | 0;
  global$0 = $3;
  i64toi32_i32$2 = $1 + 32 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $13 = i64toi32_i32$0;
  i64toi32_i32$0 = ($3 + 48 | 0) + 24 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $13;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 24 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $19 = i64toi32_i32$1;
  i64toi32_i32$1 = ($3 + 48 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $19;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $25 = i64toi32_i32$0;
  i64toi32_i32$0 = ($3 + 48 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $25;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 9 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 10 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 11 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 12 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 13 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 14 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 15 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[($3 + 48 | 0) >> 2] = $28;
  HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$0;
  cbor_event__se__Serializer_W___write_bytes__h85f4434ac9a8a060($3 | 0, $2 | 0, $3 + 48 | 0 | 0);
  $4 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
        break label$5
       }
       i64toi32_i32$2 = $1;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = 0;
       cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, i64toi32_i32$0 | 0, i64toi32_i32$1 | 0);
       if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
        break label$4
       }
       i64toi32_i32$2 = $1;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       i64toi32_i32$0 = 0;
       cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, i64toi32_i32$1 | 0, i64toi32_i32$0 | 0);
       $4 = 1;
       if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
        break label$3
       }
       cbor_event__se__Serializer_W___write_bytes__h1ecbe6b3316bc5ff($3 | 0, $2 | 0, $1 + 40 | 0 | 0, 64 | 0);
       if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
        break label$2
       }
       HEAP32[($0 + 4 | 0) >> 2] = $2;
       $4 = 0;
       break label$1;
      }
      memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
      break label$1;
     }
     memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
     $4 = 1;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $4 = 1;
  }
  HEAP32[$0 >> 2] = $4;
  global$0 = $3 + 80 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___grow_amortized__h23ae81209ad91ffa($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $5 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $16 = 0, $7 = 0, $7$hi = 0, $6 = 0, $82 = 0, $87 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    $3 = $2 + $3 | 0;
    if ($3 >>> 0 < $2 >>> 0) {
     break label$2
    }
    label$3 : {
     label$4 : {
      $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      $5 = $2 << 1 | 0;
      $3 = $5 >>> 0 > $3 >>> 0 ? $5 : $3;
      i64toi32_i32$0 = 0;
      i64toi32_i32$1 = 0;
      i64toi32_i32$1 = __wasm_i64_mul(($3 >>> 0 > 4 >>> 0 ? $3 : 4) | 0, i64toi32_i32$0 | 0, 48 | 0, i64toi32_i32$1 | 0) | 0;
      i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
      $7 = i64toi32_i32$1;
      $7$hi = i64toi32_i32$0;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 32;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$1 = 0;
       $16 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
      } else {
       i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       $16 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
      }
      if ($16) {
       break label$4
      }
      i64toi32_i32$1 = $7$hi;
      $3 = $7;
      $5 = 8;
      break label$3;
     }
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $5 = 0;
    }
    label$5 : {
     label$6 : {
      if (!$2) {
       break label$6
      }
      $6 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$1 >> 2] | 0 | 0) | 0;
      HEAP32[(($4 + 32 | 0) + 8 | 0) >> 2] = 8;
      HEAP32[($4 + 36 | 0) >> 2] = Math_imul($2, 48);
      HEAP32[($4 + 32 | 0) >> 2] = $6;
      break label$5;
     }
     HEAP32[($4 + 32 | 0) >> 2] = 0;
    }
    alloc__raw_vec__finish_grow__h9cca7d8a9459b8aa($4 + 16 | 0 | 0, $3 | 0, $5 | 0, $4 + 32 | 0 | 0, $1 | 0);
    $2 = 1;
    label$7 : {
     if ((HEAP32[($4 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$7
     }
     $2 = HEAP32[($4 + 20 | 0) >> 2] | 0;
     HEAP32[($1 + 4 | 0) >> 2] = ((HEAP32[($4 + 24 | 0) >> 2] | 0) >>> 0) / (48 >>> 0) | 0;
     HEAP32[$1 >> 2] = $2;
     $2 = 0;
     break label$1;
    }
    $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 + 8 | 0 | 0, HEAP32[($4 + 20 | 0) >> 2] | 0 | 0, HEAP32[($4 + 24 | 0) >> 2] | 0 | 0);
    i64toi32_i32$0 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    $82 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $82;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$2;
    break label$1;
   }
   $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 | 0, $3 | 0, 0 | 0);
   i64toi32_i32$0 = $4;
   i64toi32_i32$2 = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   $87 = i64toi32_i32$2;
   i64toi32_i32$2 = $0;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = $87;
   HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = i64toi32_i32$1;
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $4 + 48 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___grow_amortized__h64daf95aea34d613($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $5 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $16 = 0, $7 = 0, $7$hi = 0, $6 = 0, $82 = 0, $87 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    $3 = $2 + $3 | 0;
    if ($3 >>> 0 < $2 >>> 0) {
     break label$2
    }
    label$3 : {
     label$4 : {
      $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      $5 = $2 << 1 | 0;
      $3 = $5 >>> 0 > $3 >>> 0 ? $5 : $3;
      i64toi32_i32$0 = 0;
      i64toi32_i32$1 = 0;
      i64toi32_i32$1 = __wasm_i64_mul(($3 >>> 0 > 4 >>> 0 ? $3 : 4) | 0, i64toi32_i32$0 | 0, 168 | 0, i64toi32_i32$1 | 0) | 0;
      i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
      $7 = i64toi32_i32$1;
      $7$hi = i64toi32_i32$0;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 32;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$1 = 0;
       $16 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
      } else {
       i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       $16 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
      }
      if ($16) {
       break label$4
      }
      i64toi32_i32$1 = $7$hi;
      $3 = $7;
      $5 = 8;
      break label$3;
     }
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $5 = 0;
    }
    label$5 : {
     label$6 : {
      if (!$2) {
       break label$6
      }
      $6 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$1 >> 2] | 0 | 0) | 0;
      HEAP32[(($4 + 32 | 0) + 8 | 0) >> 2] = 8;
      HEAP32[($4 + 36 | 0) >> 2] = Math_imul($2, 168);
      HEAP32[($4 + 32 | 0) >> 2] = $6;
      break label$5;
     }
     HEAP32[($4 + 32 | 0) >> 2] = 0;
    }
    alloc__raw_vec__finish_grow__h9cca7d8a9459b8aa($4 + 16 | 0 | 0, $3 | 0, $5 | 0, $4 + 32 | 0 | 0, $1 | 0);
    $2 = 1;
    label$7 : {
     if ((HEAP32[($4 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$7
     }
     $2 = HEAP32[($4 + 20 | 0) >> 2] | 0;
     HEAP32[($1 + 4 | 0) >> 2] = ((HEAP32[($4 + 24 | 0) >> 2] | 0) >>> 0) / (168 >>> 0) | 0;
     HEAP32[$1 >> 2] = $2;
     $2 = 0;
     break label$1;
    }
    $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 + 8 | 0 | 0, HEAP32[($4 + 20 | 0) >> 2] | 0 | 0, HEAP32[($4 + 24 | 0) >> 2] | 0 | 0);
    i64toi32_i32$0 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    $82 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $82;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$2;
    break label$1;
   }
   $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 | 0, $3 | 0, 0 | 0);
   i64toi32_i32$0 = $4;
   i64toi32_i32$2 = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   $87 = i64toi32_i32$2;
   i64toi32_i32$2 = $0;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = $87;
   HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = i64toi32_i32$1;
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $4 + 48 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___grow_amortized__h6c689e449b3b3a5d($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $5 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $16 = 0, $7 = 0, $7$hi = 0, $6 = 0, $82 = 0, $87 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    $3 = $2 + $3 | 0;
    if ($3 >>> 0 < $2 >>> 0) {
     break label$2
    }
    label$3 : {
     label$4 : {
      $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      $5 = $2 << 1 | 0;
      $3 = $5 >>> 0 > $3 >>> 0 ? $5 : $3;
      i64toi32_i32$0 = 0;
      i64toi32_i32$1 = 0;
      i64toi32_i32$1 = __wasm_i64_mul(($3 >>> 0 > 4 >>> 0 ? $3 : 4) | 0, i64toi32_i32$0 | 0, 48 | 0, i64toi32_i32$1 | 0) | 0;
      i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
      $7 = i64toi32_i32$1;
      $7$hi = i64toi32_i32$0;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 32;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$1 = 0;
       $16 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
      } else {
       i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       $16 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
      }
      if ($16) {
       break label$4
      }
      i64toi32_i32$1 = $7$hi;
      $3 = $7;
      $5 = 8;
      break label$3;
     }
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $5 = 0;
    }
    label$5 : {
     label$6 : {
      if (!$2) {
       break label$6
      }
      $6 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$1 >> 2] | 0 | 0) | 0;
      HEAP32[(($4 + 32 | 0) + 8 | 0) >> 2] = 8;
      HEAP32[($4 + 36 | 0) >> 2] = Math_imul($2, 48);
      HEAP32[($4 + 32 | 0) >> 2] = $6;
      break label$5;
     }
     HEAP32[($4 + 32 | 0) >> 2] = 0;
    }
    alloc__raw_vec__finish_grow__h9cca7d8a9459b8aa($4 + 16 | 0 | 0, $3 | 0, $5 | 0, $4 + 32 | 0 | 0, $1 | 0);
    $2 = 1;
    label$7 : {
     if ((HEAP32[($4 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$7
     }
     $2 = HEAP32[($4 + 20 | 0) >> 2] | 0;
     HEAP32[($1 + 4 | 0) >> 2] = ((HEAP32[($4 + 24 | 0) >> 2] | 0) >>> 0) / (48 >>> 0) | 0;
     HEAP32[$1 >> 2] = $2;
     $2 = 0;
     break label$1;
    }
    $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 + 8 | 0 | 0, HEAP32[($4 + 20 | 0) >> 2] | 0 | 0, HEAP32[($4 + 24 | 0) >> 2] | 0 | 0);
    i64toi32_i32$0 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    $82 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $82;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$2;
    break label$1;
   }
   $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 | 0, $3 | 0, 0 | 0);
   i64toi32_i32$0 = $4;
   i64toi32_i32$2 = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   $87 = i64toi32_i32$2;
   i64toi32_i32$2 = $0;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = $87;
   HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = i64toi32_i32$1;
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $4 + 48 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___grow_amortized__h7137ddcde3a63efa($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $5 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $16 = 0, $7 = 0, $7$hi = 0, $6 = 0, $82 = 0, $87 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    $3 = $2 + $3 | 0;
    if ($3 >>> 0 < $2 >>> 0) {
     break label$2
    }
    label$3 : {
     label$4 : {
      $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      $5 = $2 << 1 | 0;
      $3 = $5 >>> 0 > $3 >>> 0 ? $5 : $3;
      i64toi32_i32$0 = 0;
      i64toi32_i32$1 = 0;
      i64toi32_i32$1 = __wasm_i64_mul(($3 >>> 0 > 4 >>> 0 ? $3 : 4) | 0, i64toi32_i32$0 | 0, 80 | 0, i64toi32_i32$1 | 0) | 0;
      i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
      $7 = i64toi32_i32$1;
      $7$hi = i64toi32_i32$0;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 32;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$1 = 0;
       $16 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
      } else {
       i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       $16 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
      }
      if ($16) {
       break label$4
      }
      i64toi32_i32$1 = $7$hi;
      $3 = $7;
      $5 = 8;
      break label$3;
     }
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $5 = 0;
    }
    label$5 : {
     label$6 : {
      if (!$2) {
       break label$6
      }
      $6 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$1 >> 2] | 0 | 0) | 0;
      HEAP32[(($4 + 32 | 0) + 8 | 0) >> 2] = 8;
      HEAP32[($4 + 36 | 0) >> 2] = Math_imul($2, 80);
      HEAP32[($4 + 32 | 0) >> 2] = $6;
      break label$5;
     }
     HEAP32[($4 + 32 | 0) >> 2] = 0;
    }
    alloc__raw_vec__finish_grow__h9cca7d8a9459b8aa($4 + 16 | 0 | 0, $3 | 0, $5 | 0, $4 + 32 | 0 | 0, $1 | 0);
    $2 = 1;
    label$7 : {
     if ((HEAP32[($4 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$7
     }
     $2 = HEAP32[($4 + 20 | 0) >> 2] | 0;
     HEAP32[($1 + 4 | 0) >> 2] = ((HEAP32[($4 + 24 | 0) >> 2] | 0) >>> 0) / (80 >>> 0) | 0;
     HEAP32[$1 >> 2] = $2;
     $2 = 0;
     break label$1;
    }
    $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 + 8 | 0 | 0, HEAP32[($4 + 20 | 0) >> 2] | 0 | 0, HEAP32[($4 + 24 | 0) >> 2] | 0 | 0);
    i64toi32_i32$0 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    $82 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $82;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$2;
    break label$1;
   }
   $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 | 0, $3 | 0, 0 | 0);
   i64toi32_i32$0 = $4;
   i64toi32_i32$2 = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   $87 = i64toi32_i32$2;
   i64toi32_i32$2 = $0;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = $87;
   HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = i64toi32_i32$1;
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $4 + 48 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___grow_amortized__ha9fba2eac8dec5ba($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $5 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $16 = 0, $7 = 0, $7$hi = 0, $6 = 0, $82 = 0, $87 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    $3 = $2 + $3 | 0;
    if ($3 >>> 0 < $2 >>> 0) {
     break label$2
    }
    label$3 : {
     label$4 : {
      $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      $5 = $2 << 1 | 0;
      $3 = $5 >>> 0 > $3 >>> 0 ? $5 : $3;
      i64toi32_i32$0 = 0;
      i64toi32_i32$1 = 0;
      i64toi32_i32$1 = __wasm_i64_mul(($3 >>> 0 > 4 >>> 0 ? $3 : 4) | 0, i64toi32_i32$0 | 0, 272 | 0, i64toi32_i32$1 | 0) | 0;
      i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
      $7 = i64toi32_i32$1;
      $7$hi = i64toi32_i32$0;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 32;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$1 = 0;
       $16 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
      } else {
       i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       $16 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
      }
      if ($16) {
       break label$4
      }
      i64toi32_i32$1 = $7$hi;
      $3 = $7;
      $5 = 8;
      break label$3;
     }
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $5 = 0;
    }
    label$5 : {
     label$6 : {
      if (!$2) {
       break label$6
      }
      $6 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$1 >> 2] | 0 | 0) | 0;
      HEAP32[(($4 + 32 | 0) + 8 | 0) >> 2] = 8;
      HEAP32[($4 + 36 | 0) >> 2] = Math_imul($2, 272);
      HEAP32[($4 + 32 | 0) >> 2] = $6;
      break label$5;
     }
     HEAP32[($4 + 32 | 0) >> 2] = 0;
    }
    alloc__raw_vec__finish_grow__h9cca7d8a9459b8aa($4 + 16 | 0 | 0, $3 | 0, $5 | 0, $4 + 32 | 0 | 0, $1 | 0);
    $2 = 1;
    label$7 : {
     if ((HEAP32[($4 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$7
     }
     $2 = HEAP32[($4 + 20 | 0) >> 2] | 0;
     HEAP32[($1 + 4 | 0) >> 2] = ((HEAP32[($4 + 24 | 0) >> 2] | 0) >>> 0) / (272 >>> 0) | 0;
     HEAP32[$1 >> 2] = $2;
     $2 = 0;
     break label$1;
    }
    $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 + 8 | 0 | 0, HEAP32[($4 + 20 | 0) >> 2] | 0 | 0, HEAP32[($4 + 24 | 0) >> 2] | 0 | 0);
    i64toi32_i32$0 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    $82 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $82;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$2;
    break label$1;
   }
   $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 | 0, $3 | 0, 0 | 0);
   i64toi32_i32$0 = $4;
   i64toi32_i32$2 = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   $87 = i64toi32_i32$2;
   i64toi32_i32$2 = $0;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = $87;
   HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = i64toi32_i32$1;
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $4 + 48 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___grow_amortized__hc4ed24c3b0b077ea($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $5 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $16 = 0, $7 = 0, $7$hi = 0, $6 = 0, $82 = 0, $87 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    $3 = $2 + $3 | 0;
    if ($3 >>> 0 < $2 >>> 0) {
     break label$2
    }
    label$3 : {
     label$4 : {
      $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      $5 = $2 << 1 | 0;
      $3 = $5 >>> 0 > $3 >>> 0 ? $5 : $3;
      i64toi32_i32$0 = 0;
      i64toi32_i32$1 = 0;
      i64toi32_i32$1 = __wasm_i64_mul(($3 >>> 0 > 4 >>> 0 ? $3 : 4) | 0, i64toi32_i32$0 | 0, 200 | 0, i64toi32_i32$1 | 0) | 0;
      i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
      $7 = i64toi32_i32$1;
      $7$hi = i64toi32_i32$0;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 32;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$1 = 0;
       $16 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
      } else {
       i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       $16 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
      }
      if ($16) {
       break label$4
      }
      i64toi32_i32$1 = $7$hi;
      $3 = $7;
      $5 = 8;
      break label$3;
     }
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $5 = 0;
    }
    label$5 : {
     label$6 : {
      if (!$2) {
       break label$6
      }
      $6 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$1 >> 2] | 0 | 0) | 0;
      HEAP32[(($4 + 32 | 0) + 8 | 0) >> 2] = 8;
      HEAP32[($4 + 36 | 0) >> 2] = Math_imul($2, 200);
      HEAP32[($4 + 32 | 0) >> 2] = $6;
      break label$5;
     }
     HEAP32[($4 + 32 | 0) >> 2] = 0;
    }
    alloc__raw_vec__finish_grow__h9cca7d8a9459b8aa($4 + 16 | 0 | 0, $3 | 0, $5 | 0, $4 + 32 | 0 | 0, $1 | 0);
    $2 = 1;
    label$7 : {
     if ((HEAP32[($4 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$7
     }
     $2 = HEAP32[($4 + 20 | 0) >> 2] | 0;
     HEAP32[($1 + 4 | 0) >> 2] = ((HEAP32[($4 + 24 | 0) >> 2] | 0) >>> 0) / (200 >>> 0) | 0;
     HEAP32[$1 >> 2] = $2;
     $2 = 0;
     break label$1;
    }
    $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 + 8 | 0 | 0, HEAP32[($4 + 20 | 0) >> 2] | 0 | 0, HEAP32[($4 + 24 | 0) >> 2] | 0 | 0);
    i64toi32_i32$0 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    $82 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $82;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$2;
    break label$1;
   }
   $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 | 0, $3 | 0, 0 | 0);
   i64toi32_i32$0 = $4;
   i64toi32_i32$2 = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   $87 = i64toi32_i32$2;
   i64toi32_i32$2 = $0;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = $87;
   HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = i64toi32_i32$1;
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $4 + 48 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___grow_amortized__hd6ed9bb1c7c89037($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $5 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $16 = 0, $7 = 0, $7$hi = 0, $6 = 0, $82 = 0, $87 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    $3 = $2 + $3 | 0;
    if ($3 >>> 0 < $2 >>> 0) {
     break label$2
    }
    label$3 : {
     label$4 : {
      $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      $5 = $2 << 1 | 0;
      $3 = $5 >>> 0 > $3 >>> 0 ? $5 : $3;
      i64toi32_i32$0 = 0;
      i64toi32_i32$1 = 0;
      i64toi32_i32$1 = __wasm_i64_mul(($3 >>> 0 > 4 >>> 0 ? $3 : 4) | 0, i64toi32_i32$0 | 0, 96 | 0, i64toi32_i32$1 | 0) | 0;
      i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
      $7 = i64toi32_i32$1;
      $7$hi = i64toi32_i32$0;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 32;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$1 = 0;
       $16 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
      } else {
       i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       $16 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
      }
      if ($16) {
       break label$4
      }
      i64toi32_i32$1 = $7$hi;
      $3 = $7;
      $5 = 8;
      break label$3;
     }
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $5 = 0;
    }
    label$5 : {
     label$6 : {
      if (!$2) {
       break label$6
      }
      $6 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$1 >> 2] | 0 | 0) | 0;
      HEAP32[(($4 + 32 | 0) + 8 | 0) >> 2] = 8;
      HEAP32[($4 + 36 | 0) >> 2] = Math_imul($2, 96);
      HEAP32[($4 + 32 | 0) >> 2] = $6;
      break label$5;
     }
     HEAP32[($4 + 32 | 0) >> 2] = 0;
    }
    alloc__raw_vec__finish_grow__h9cca7d8a9459b8aa($4 + 16 | 0 | 0, $3 | 0, $5 | 0, $4 + 32 | 0 | 0, $1 | 0);
    $2 = 1;
    label$7 : {
     if ((HEAP32[($4 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$7
     }
     $2 = HEAP32[($4 + 20 | 0) >> 2] | 0;
     HEAP32[($1 + 4 | 0) >> 2] = ((HEAP32[($4 + 24 | 0) >> 2] | 0) >>> 0) / (96 >>> 0) | 0;
     HEAP32[$1 >> 2] = $2;
     $2 = 0;
     break label$1;
    }
    $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 + 8 | 0 | 0, HEAP32[($4 + 20 | 0) >> 2] | 0 | 0, HEAP32[($4 + 24 | 0) >> 2] | 0 | 0);
    i64toi32_i32$0 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    $82 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $82;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$2;
    break label$1;
   }
   $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 | 0, $3 | 0, 0 | 0);
   i64toi32_i32$0 = $4;
   i64toi32_i32$2 = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   $87 = i64toi32_i32$2;
   i64toi32_i32$2 = $0;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = $87;
   HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = i64toi32_i32$1;
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $4 + 48 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___grow_amortized__he020c2f1582e1252($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $5 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $16 = 0, $7 = 0, $7$hi = 0, $6 = 0, $82 = 0, $87 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    $3 = $2 + $3 | 0;
    if ($3 >>> 0 < $2 >>> 0) {
     break label$2
    }
    label$3 : {
     label$4 : {
      $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      $5 = $2 << 1 | 0;
      $3 = $5 >>> 0 > $3 >>> 0 ? $5 : $3;
      i64toi32_i32$0 = 0;
      i64toi32_i32$1 = 0;
      i64toi32_i32$1 = __wasm_i64_mul(($3 >>> 0 > 4 >>> 0 ? $3 : 4) | 0, i64toi32_i32$0 | 0, 144 | 0, i64toi32_i32$1 | 0) | 0;
      i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
      $7 = i64toi32_i32$1;
      $7$hi = i64toi32_i32$0;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 32;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$1 = 0;
       $16 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
      } else {
       i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       $16 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
      }
      if ($16) {
       break label$4
      }
      i64toi32_i32$1 = $7$hi;
      $3 = $7;
      $5 = 8;
      break label$3;
     }
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $5 = 0;
    }
    label$5 : {
     label$6 : {
      if (!$2) {
       break label$6
      }
      $6 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$1 >> 2] | 0 | 0) | 0;
      HEAP32[(($4 + 32 | 0) + 8 | 0) >> 2] = 8;
      HEAP32[($4 + 36 | 0) >> 2] = Math_imul($2, 144);
      HEAP32[($4 + 32 | 0) >> 2] = $6;
      break label$5;
     }
     HEAP32[($4 + 32 | 0) >> 2] = 0;
    }
    alloc__raw_vec__finish_grow__h9cca7d8a9459b8aa($4 + 16 | 0 | 0, $3 | 0, $5 | 0, $4 + 32 | 0 | 0, $1 | 0);
    $2 = 1;
    label$7 : {
     if ((HEAP32[($4 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$7
     }
     $2 = HEAP32[($4 + 20 | 0) >> 2] | 0;
     HEAP32[($1 + 4 | 0) >> 2] = ((HEAP32[($4 + 24 | 0) >> 2] | 0) >>> 0) / (144 >>> 0) | 0;
     HEAP32[$1 >> 2] = $2;
     $2 = 0;
     break label$1;
    }
    $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 + 8 | 0 | 0, HEAP32[($4 + 20 | 0) >> 2] | 0 | 0, HEAP32[($4 + 24 | 0) >> 2] | 0 | 0);
    i64toi32_i32$0 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    $82 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $82;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$2;
    break label$1;
   }
   $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 | 0, $3 | 0, 0 | 0);
   i64toi32_i32$0 = $4;
   i64toi32_i32$2 = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   $87 = i64toi32_i32$2;
   i64toi32_i32$2 = $0;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = $87;
   HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = i64toi32_i32$1;
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $4 + 48 | 0;
 }
 
 function alloc__vec__Vec_T_2cA___extend_desugared__h1a058c7bd5b87d07($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $9 = 0, $4 = 0, $6 = 0, $3 = 0, $5 = 0, $7 = 0, $8 = 0, $27 = 0, $35 = 0, $46 = 0, $49 = 0, $52 = 0, $67 = 0, $71 = 0, $75 = 0, $88 = 0, $91 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  $core__iter__adapters__ResultShunt_I_2cE__20as_20core__iter__traits__iterator__Iterator___try_fold__h31a0d674d945c00d($2 + 24 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    if ((HEAPU8[($2 + 24 | 0) >> 0] | 0 | 0) != (6 | 0)) {
     break label$2
    }
    HEAP8[$2 >> 0] = 6;
    break label$1;
   }
   $3 = $2 + 16 | 0;
   $4 = ($2 + 24 | 0) + 16 | 0;
   i64toi32_i32$2 = $4;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $27 = i64toi32_i32$0;
   i64toi32_i32$0 = $3;
   HEAP32[i64toi32_i32$0 >> 2] = $27;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   $5 = $2 + 8 | 0;
   $6 = ($2 + 24 | 0) + 8 | 0;
   i64toi32_i32$2 = $6;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $35 = i64toi32_i32$1;
   i64toi32_i32$1 = $5;
   HEAP32[i64toi32_i32$1 >> 2] = $35;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
   $9 = i64toi32_i32$0;
   i64toi32_i32$0 = i64toi32_i32$2;
   HEAP32[i64toi32_i32$0 >> 2] = $9;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   if (($9 & 255 | 0 | 0) == (6 | 0)) {
    break label$1
   }
   label$3 : while (1) {
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $46 = i64toi32_i32$1;
    i64toi32_i32$1 = $4;
    HEAP32[i64toi32_i32$1 >> 2] = $46;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $5;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $49 = i64toi32_i32$0;
    i64toi32_i32$0 = $6;
    HEAP32[i64toi32_i32$0 >> 2] = $49;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $52 = i64toi32_i32$1;
    i64toi32_i32$1 = i64toi32_i32$2;
    HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = $52;
    HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = i64toi32_i32$0;
    label$4 : {
     $7 = HEAP32[($0 + 8 | 0) >> 2] | 0;
     if (($7 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
      break label$4
     }
     alloc__vec__Vec_T_2cA___reserve__hd1fc8182517f0f4e($0 | 0, 1 | 0);
    }
    $8 = (HEAP32[$0 >> 2] | 0) + Math_imul($7, 24) | 0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
    $67 = i64toi32_i32$0;
    i64toi32_i32$0 = $8;
    HEAP32[i64toi32_i32$0 >> 2] = $67;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $71 = i64toi32_i32$1;
    i64toi32_i32$1 = $8 + 16 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $71;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $6;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $75 = i64toi32_i32$0;
    i64toi32_i32$0 = $8 + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $75;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($0 + 8 | 0) >> 2] = $7 + 1 | 0;
    $core__iter__adapters__ResultShunt_I_2cE__20as_20core__iter__traits__iterator__Iterator___try_fold__h31a0d674d945c00d($2 + 24 | 0 | 0, $1 | 0);
    label$5 : {
     if ((HEAPU8[($2 + 24 | 0) >> 0] | 0 | 0) != (6 | 0)) {
      break label$5
     }
     HEAP8[$2 >> 0] = 6;
     break label$1;
    }
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $88 = i64toi32_i32$1;
    i64toi32_i32$1 = $3;
    HEAP32[i64toi32_i32$1 >> 2] = $88;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $6;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $91 = i64toi32_i32$0;
    i64toi32_i32$0 = $5;
    HEAP32[i64toi32_i32$0 >> 2] = $91;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
    $9 = i64toi32_i32$1;
    i64toi32_i32$1 = i64toi32_i32$2;
    HEAP32[i64toi32_i32$1 >> 2] = $9;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    if (($9 & 255 | 0 | 0) != (6 | 0)) {
     continue label$3
    }
    break label$3;
   };
  }
  core__ptr__drop_in_place_core__option__Option_serde_json__value__Value____h71c6802ef4477f6d($2 | 0);
  global$0 = $2 + 48 | 0;
 }
 
 function alloc__vec__Vec_T_2cA___extend_desugared__hda27c1fc0d14adaa($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $9 = 0, $4 = 0, $6 = 0, $3 = 0, $5 = 0, $7 = 0, $8 = 0, $27 = 0, $35 = 0, $46 = 0, $49 = 0, $52 = 0, $67 = 0, $71 = 0, $75 = 0, $88 = 0, $91 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  $core__iter__adapters__ResultShunt_I_2cE__20as_20core__iter__traits__iterator__Iterator___try_fold__h240dbae8a1f4011e($2 + 24 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    if ((HEAPU8[($2 + 24 | 0) >> 0] | 0 | 0) != (6 | 0)) {
     break label$2
    }
    HEAP8[$2 >> 0] = 6;
    break label$1;
   }
   $3 = $2 + 16 | 0;
   $4 = ($2 + 24 | 0) + 16 | 0;
   i64toi32_i32$2 = $4;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $27 = i64toi32_i32$0;
   i64toi32_i32$0 = $3;
   HEAP32[i64toi32_i32$0 >> 2] = $27;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   $5 = $2 + 8 | 0;
   $6 = ($2 + 24 | 0) + 8 | 0;
   i64toi32_i32$2 = $6;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $35 = i64toi32_i32$1;
   i64toi32_i32$1 = $5;
   HEAP32[i64toi32_i32$1 >> 2] = $35;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
   $9 = i64toi32_i32$0;
   i64toi32_i32$0 = i64toi32_i32$2;
   HEAP32[i64toi32_i32$0 >> 2] = $9;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   if (($9 & 255 | 0 | 0) == (6 | 0)) {
    break label$1
   }
   label$3 : while (1) {
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $46 = i64toi32_i32$1;
    i64toi32_i32$1 = $4;
    HEAP32[i64toi32_i32$1 >> 2] = $46;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $5;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $49 = i64toi32_i32$0;
    i64toi32_i32$0 = $6;
    HEAP32[i64toi32_i32$0 >> 2] = $49;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $52 = i64toi32_i32$1;
    i64toi32_i32$1 = i64toi32_i32$2;
    HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = $52;
    HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = i64toi32_i32$0;
    label$4 : {
     $7 = HEAP32[($0 + 8 | 0) >> 2] | 0;
     if (($7 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
      break label$4
     }
     alloc__vec__Vec_T_2cA___reserve__hd1fc8182517f0f4e($0 | 0, 1 | 0);
    }
    $8 = (HEAP32[$0 >> 2] | 0) + Math_imul($7, 24) | 0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
    $67 = i64toi32_i32$0;
    i64toi32_i32$0 = $8;
    HEAP32[i64toi32_i32$0 >> 2] = $67;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $71 = i64toi32_i32$1;
    i64toi32_i32$1 = $8 + 16 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $71;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $6;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $75 = i64toi32_i32$0;
    i64toi32_i32$0 = $8 + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $75;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($0 + 8 | 0) >> 2] = $7 + 1 | 0;
    $core__iter__adapters__ResultShunt_I_2cE__20as_20core__iter__traits__iterator__Iterator___try_fold__h240dbae8a1f4011e($2 + 24 | 0 | 0, $1 | 0);
    label$5 : {
     if ((HEAPU8[($2 + 24 | 0) >> 0] | 0 | 0) != (6 | 0)) {
      break label$5
     }
     HEAP8[$2 >> 0] = 6;
     break label$1;
    }
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $88 = i64toi32_i32$1;
    i64toi32_i32$1 = $3;
    HEAP32[i64toi32_i32$1 >> 2] = $88;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $6;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $91 = i64toi32_i32$0;
    i64toi32_i32$0 = $5;
    HEAP32[i64toi32_i32$0 >> 2] = $91;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
    $9 = i64toi32_i32$1;
    i64toi32_i32$1 = i64toi32_i32$2;
    HEAP32[i64toi32_i32$1 >> 2] = $9;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    if (($9 & 255 | 0 | 0) != (6 | 0)) {
     continue label$3
    }
    break label$3;
   };
  }
  core__ptr__drop_in_place_core__option__Option_serde_json__value__Value____h71c6802ef4477f6d($2 | 0);
  global$0 = $2 + 48 | 0;
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h50c1f6d5a01d91ba($0) {
  $0 = $0 | 0;
  var $2 = 0, $1 = 0, $4 = 0, $3 = 0, $5 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $2 = HEAP32[$0 >> 2] | 0;
   $3 = $2 + Math_imul($1, 76) | 0;
   label$2 : while (1) {
    label$3 : {
     if (!(HEAP32[$2 >> 2] | 0)) {
      break label$3
     }
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hdd0c057252922c46($2 | 0);
    }
    label$4 : {
     if (!(HEAP32[($2 + 12 | 0) >> 2] | 0)) {
      break label$4
     }
     $0 = $2 + 12 | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc3d6ec99c05cee40($0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h0f78886c344617d4($0 | 0);
    }
    label$5 : {
     if (!(HEAP32[($2 + 24 | 0) >> 2] | 0)) {
      break label$5
     }
     $0 = $2 + 24 | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h28dc4dde55fe2f07($0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h79e8c51775f4d5f8($0 | 0);
    }
    label$6 : {
     if (!(HEAP32[($2 + 36 | 0) >> 2] | 0)) {
      break label$6
     }
     $0 = $2 + 36 | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd4b44cb226d8311d($0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h3633100df9c96e1e($0 | 0);
    }
    label$7 : {
     if ((HEAPU8[($2 + 60 | 0) >> 0] | 0 | 0) == (3 | 0)) {
      break label$7
     }
     $4 = $2 + 48 | 0;
     label$8 : {
      $1 = HEAP32[($2 + 56 | 0) >> 2] | 0;
      if (!$1) {
       break label$8
      }
      $0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
      $1 = Math_imul($1, 48);
      label$9 : while (1) {
       core__ptr__drop_in_place_cardano_serialization_lib__plutus__PlutusData___hfab843e66e0f9428_2($0 | 0);
       $0 = $0 + 48 | 0;
       $1 = $1 + -48 | 0;
       if ($1) {
        continue label$9
       }
       break label$9;
      };
     }
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h36e817e704f6f25e($4 | 0);
    }
    $4 = $2 + 76 | 0;
    label$10 : {
     $0 = HEAP32[($2 + 64 | 0) >> 2] | 0;
     if (!$0) {
      break label$10
     }
     $5 = $2 + 64 | 0;
     label$11 : {
      $1 = HEAP32[($2 + 72 | 0) >> 2] | 0;
      if (!$1) {
       break label$11
      }
      $1 = Math_imul($1, 80);
      $0 = $0 + 8 | 0;
      label$12 : while (1) {
       core__ptr__drop_in_place_cardano_serialization_lib__plutus__PlutusData___hfab843e66e0f9428_2($0 | 0);
       $0 = $0 + 80 | 0;
       $1 = $1 + -80 | 0;
       if ($1) {
        continue label$12
       }
       break label$12;
      };
     }
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h4c688d2d7e8a61fa($5 | 0);
    }
    $2 = $4;
    if (($2 | 0) != ($3 | 0)) {
     continue label$2
    }
    break label$2;
   };
  }
 }
 
 function pointeraddress_new($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $3 = 0, $23 = 0, $10 = 0, $10$hi = 0, $11 = 0, $11$hi = 0, $4 = 0, $5 = 0, $8 = 0, $9 = 0, $24 = 0, $25 = 0, $26 = 0, $27 = 0, $28 = 0, $6 = 0, $7 = 0, $49 = 0, $12 = 0, $12$hi = 0, $79 = 0, $83 = 0, $87 = 0;
  $3 = global$0 - 144 | 0;
  global$0 = $3;
  label$1 : {
   if (!$1) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h7d8a0640f2deb41e($3 + 16 | 0 | 0, $1 | 0);
   if (!$2) {
    break label$1
   }
   $4 = HEAP32[($3 + 20 | 0) >> 2] | 0;
   $1 = HEAP32[($3 + 16 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h7b63d9df2a892a8b($3 + 8 | 0 | 0, $2 | 0);
   $2 = HEAP32[($3 + 8 | 0) >> 2] | 0;
   $5 = HEAP32[($3 + 12 | 0) >> 2] | 0;
   $23 = $1 + 25 | 0;
   $6 = HEAPU8[$23 >> 0] | 0 | ((HEAPU8[($23 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($23 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($23 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$2 = $1 + 17 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $10 = i64toi32_i32$0;
   $10$hi = i64toi32_i32$1;
   $7 = HEAPU8[$1 >> 0] | 0;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $11 = i64toi32_i32$1;
   $11$hi = i64toi32_i32$0;
   $8 = $3 + 32 | 0;
   i64toi32_i32$2 = i64toi32_i32$2 + 9 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $49 = i64toi32_i32$0;
   i64toi32_i32$0 = $8;
   HEAP32[i64toi32_i32$0 >> 2] = $49;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   $1 = $3 + 40 | 0;
   i64toi32_i32$1 = $10$hi;
   i64toi32_i32$0 = $1;
   HEAP32[i64toi32_i32$0 >> 2] = $10;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   $9 = $3 + 48 | 0;
   HEAP32[$9 >> 2] = $6;
   i64toi32_i32$1 = $11$hi;
   i64toi32_i32$0 = $3;
   HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = $11;
   HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $10 = i64toi32_i32$1;
   $10$hi = i64toi32_i32$0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
   $11 = i64toi32_i32$0;
   $11$hi = i64toi32_i32$1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
   $12 = i64toi32_i32$1;
   $12$hi = i64toi32_i32$0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($5 | 0, (HEAP32[$5 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($4 | 0, (HEAP32[$4 >> 2] | 0) + -1 | 0 | 0) | 0;
   i64toi32_i32$2 = $3;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
   $79 = i64toi32_i32$0;
   i64toi32_i32$0 = i64toi32_i32$2 + 82 | 0;
   $24 = $79;
   HEAP16[i64toi32_i32$0 >> 1] = $24;
   HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $24 >>> 16 | 0;
   HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$1;
   HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
   i64toi32_i32$2 = $8;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $83 = i64toi32_i32$1;
   i64toi32_i32$1 = $3 + 90 | 0;
   $25 = $83;
   HEAP16[i64toi32_i32$1 >> 1] = $25;
   HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $25 >>> 16 | 0;
   HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = i64toi32_i32$0;
   HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
   i64toi32_i32$2 = $1;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $87 = i64toi32_i32$0;
   i64toi32_i32$0 = $3 + 98 | 0;
   $26 = $87;
   HEAP16[i64toi32_i32$0 >> 1] = $26;
   HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $26 >>> 16 | 0;
   HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$1;
   HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
   $27 = $3 + 106 | 0;
   $28 = HEAP32[$9 >> 2] | 0;
   HEAP16[$27 >> 1] = $28;
   HEAP16[($27 + 2 | 0) >> 1] = $28 >>> 16 | 0;
   HEAP8[($3 + 81 | 0) >> 0] = $7;
   HEAP8[($3 + 80 | 0) >> 0] = $0;
   i64toi32_i32$1 = $12$hi;
   i64toi32_i32$0 = $3;
   HEAP32[(i64toi32_i32$0 + 72 | 0) >> 2] = $12;
   HEAP32[(i64toi32_i32$0 + 76 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $11$hi;
   HEAP32[(i64toi32_i32$0 + 64 | 0) >> 2] = $11;
   HEAP32[(i64toi32_i32$0 + 68 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $10$hi;
   HEAP32[(i64toi32_i32$0 + 56 | 0) >> 2] = $10;
   HEAP32[(i64toi32_i32$0 + 60 | 0) >> 2] = i64toi32_i32$1;
   $1 = $cardano_serialization_lib__address__PointerAddress_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h1cd671f5d15881dc(i64toi32_i32$0 + 56 | 0 | 0) | 0;
   global$0 = i64toi32_i32$0 + 144 | 0;
   return $1 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function alloc__collections__btree__map__entry__VacantEntry_K_2cV___insert__h47d509ec02473685($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $4 = 0, $7 = 0, $19 = 0, $28 = 0, $3 = 0, $5 = 0, $6 = 0, $82 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[$0 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $19;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 64 | 0) >> 2] = $28;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$0;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_recursing__h638ded5d44315e91($2 + 8 | 0 | 0, $2 + 48 | 0 | 0, $2 + 64 | 0 | 0);
  $3 = HEAP32[($2 + 40 | 0) >> 2] | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     $0 = HEAP32[($0 + 12 | 0) >> 2] | 0;
     break label$2;
    }
    $0 = HEAP32[($0 + 12 | 0) >> 2] | 0;
    $4 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    if (!$4) {
     break label$1
    }
    $5 = HEAP32[($2 + 36 | 0) >> 2] | 0;
    $6 = HEAP32[($2 + 32 | 0) >> 2] | 0;
    $7 = HEAP32[$0 >> 2] | 0;
    $1 = alloc__boxed__Box_T_2cA___new_uninit_in__hbee8ec47f689ab87() | 0;
    HEAP32[($1 + 140 | 0) >> 2] = $4;
    HEAP16[($1 + 138 | 0) >> 1] = 0;
    HEAP32[$1 >> 2] = 0;
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    $7 = $7 + 1 | 0;
    HEAP32[$0 >> 2] = $7;
    HEAP16[($4 + 136 | 0) >> 1] = 0;
    HEAP32[$4 >> 2] = $1;
    HEAP32[($2 + 52 | 0) >> 2] = $1;
    HEAP32[($2 + 48 | 0) >> 2] = $7;
    HEAP32[($2 + 72 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
    i64toi32_i32$2 = $2 + 20 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $82 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[($2 + 64 | 0) >> 2] = $82;
    HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$1;
    alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal___push__h04f226b3ef6139db($2 + 48 | 0 | 0, $2 + 64 | 0 | 0, $6 | 0, $5 | 0);
   }
   HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
   global$0 = $2 + 80 | 0;
   return $3 | 0;
  }
  core__panicking__panic__h2fd385a887c8bf13(1072048 | 0, 43 | 0, 1072248 | 0);
  abort();
 }
 
 function alloc__collections__btree__map__entry__VacantEntry_K_2cV___insert__hdd82dbc7f856274f($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $7 = 0, i64toi32_i32$2 = 0, $3 = 0, $6 = 0, $19 = 0, $28 = 0, $2 = 0, $4 = 0, $5 = 0, $82 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  HEAP32[(($1 + 48 | 0) + 8 | 0) >> 2] = HEAP32[($0 + 20 | 0) >> 2] | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[($0 + 12 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($0 + 16 | 0) >> 2] | 0;
  $19 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 48 | 0) >> 2] = $19;
  HEAP32[($1 + 52 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(($1 + 64 | 0) + 8 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$1 = HEAP32[$0 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[($1 + 64 | 0) >> 2] = $28;
  HEAP32[($1 + 68 | 0) >> 2] = i64toi32_i32$0;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_recursing__h600b32a439386d31($1 + 8 | 0 | 0, $1 + 48 | 0 | 0, $1 + 64 | 0 | 0);
  $2 = HEAP32[($1 + 40 | 0) >> 2] | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[($1 + 8 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     $0 = HEAP32[($0 + 24 | 0) >> 2] | 0;
     break label$2;
    }
    $0 = HEAP32[($0 + 24 | 0) >> 2] | 0;
    $3 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    if (!$3) {
     break label$1
    }
    $4 = HEAP32[($1 + 36 | 0) >> 2] | 0;
    $5 = HEAP32[($1 + 32 | 0) >> 2] | 0;
    $6 = HEAP32[$0 >> 2] | 0;
    $7 = alloc__boxed__Box_T_2cA___new_uninit_in__he0c425f8ad462f5a() | 0;
    HEAP32[($7 + 140 | 0) >> 2] = $3;
    HEAP16[($7 + 138 | 0) >> 1] = 0;
    HEAP32[$7 >> 2] = 0;
    HEAP32[($0 + 4 | 0) >> 2] = $7;
    $6 = $6 + 1 | 0;
    HEAP32[$0 >> 2] = $6;
    HEAP16[($3 + 136 | 0) >> 1] = 0;
    HEAP32[$3 >> 2] = $7;
    HEAP32[($1 + 52 | 0) >> 2] = $7;
    HEAP32[($1 + 48 | 0) >> 2] = $6;
    HEAP32[($1 + 72 | 0) >> 2] = HEAP32[($1 + 28 | 0) >> 2] | 0;
    i64toi32_i32$2 = $1 + 20 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $82 = i64toi32_i32$0;
    i64toi32_i32$0 = $1;
    HEAP32[($1 + 64 | 0) >> 2] = $82;
    HEAP32[($1 + 68 | 0) >> 2] = i64toi32_i32$1;
    alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal___push__ha06be0cc1af1dc69($1 + 48 | 0 | 0, $1 + 64 | 0 | 0, $5 | 0, $4 | 0);
   }
   HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
   global$0 = $1 + 80 | 0;
   return $2 | 0;
  }
  core__panicking__panic__h2fd385a887c8bf13(1072048 | 0, 43 | 0, 1072248 | 0);
  abort();
 }
 
 function dlmalloc__dlmalloc__Dlmalloc_A___unlink_large_chunk__h107571aa99375aaf($0) {
  $0 = $0 | 0;
  var $4 = 0, $3 = 0, $2 = 0, $1 = 0, $5 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $1 = HEAP32[($0 + 24 | 0) >> 2] | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((dlmalloc__dlmalloc__TreeChunk__next__h44ce6eba75e44ecf($0 | 0) | 0 | 0) != ($0 | 0)) {
      break label$3
     }
     $2 = $0 + 20 | 0;
     $3 = HEAP32[$2 >> 2] | 0;
     $4 = HEAP32[($0 + ($3 ? 20 : 16) | 0) >> 2] | 0;
     if ($4) {
      break label$2
     }
     $3 = 0;
     break label$1;
    }
    $4 = dlmalloc__dlmalloc__TreeChunk__prev__h4f72cebc901507fb($0 | 0) | 0;
    $3 = dlmalloc__dlmalloc__TreeChunk__next__h44ce6eba75e44ecf($0 | 0) | 0;
    (wasm2js_i32$0 = $4, wasm2js_i32$1 = dlmalloc__dlmalloc__TreeChunk__chunk__h93f52b5b19dc8e79($3 | 0) | 0), HEAP32[(wasm2js_i32$0 + 12 | 0) >> 2] = wasm2js_i32$1;
    (wasm2js_i32$0 = $3, wasm2js_i32$1 = dlmalloc__dlmalloc__TreeChunk__chunk__h93f52b5b19dc8e79($4 | 0) | 0), HEAP32[(wasm2js_i32$0 + 8 | 0) >> 2] = wasm2js_i32$1;
    break label$1;
   }
   $2 = $3 ? $2 : $0 + 16 | 0;
   label$4 : while (1) {
    $5 = $2;
    label$5 : {
     $3 = $4;
     $2 = $3 + 20 | 0;
     $4 = HEAP32[$2 >> 2] | 0;
     if ($4) {
      break label$5
     }
     $2 = $3 + 16 | 0;
     $4 = HEAP32[($3 + 16 | 0) >> 2] | 0;
    }
    if ($4) {
     continue label$4
    }
    break label$4;
   };
   HEAP32[$5 >> 2] = 0;
  }
  label$6 : {
   if (!$1) {
    break label$6
   }
   label$7 : {
    label$8 : {
     $4 = ((HEAP32[($0 + 28 | 0) >> 2] | 0) << 2 | 0) + 1178156 | 0;
     if ((HEAP32[$4 >> 2] | 0 | 0) == ($0 | 0)) {
      break label$8
     }
     HEAP32[($1 + ((HEAP32[($1 + 16 | 0) >> 2] | 0 | 0) == ($0 | 0) ? 16 : 20) | 0) >> 2] = $3;
     if ($3) {
      break label$7
     }
     break label$6;
    }
    HEAP32[$4 >> 2] = $3;
    if ($3) {
     break label$7
    }
    (wasm2js_i32$0 = 0, wasm2js_i32$1 = (HEAP32[(0 + 1177888 | 0) >> 2] | 0) & (__wasm_rotl_i32(-2 | 0, HEAP32[($0 + 28 | 0) >> 2] | 0 | 0) | 0) | 0), HEAP32[(wasm2js_i32$0 + 1177888 | 0) >> 2] = wasm2js_i32$1;
    return;
   }
   HEAP32[($3 + 24 | 0) >> 2] = $1;
   label$9 : {
    $4 = HEAP32[($0 + 16 | 0) >> 2] | 0;
    if (!$4) {
     break label$9
    }
    HEAP32[($3 + 16 | 0) >> 2] = $4;
    HEAP32[($4 + 24 | 0) >> 2] = $3;
   }
   $4 = HEAP32[($0 + 20 | 0) >> 2] | 0;
   if (!$4) {
    break label$6
   }
   HEAP32[($3 + 20 | 0) >> 2] = $4;
   HEAP32[($4 + 24 | 0) >> 2] = $3;
   return;
  }
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__NetworkId___deserialize__h50b68885855d805d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $3$hi = 0, $40 = 0, $47 = 0, $54 = 0, $60 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___unsigned_integer__h1ed99c0b7fe7eea1($2 + 112 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 120 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 124 | 0) >> 2] | 0;
  $3 = i64toi32_i32$0;
  $3$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAP32[($2 + 112 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 116 | 0) >> 2] | 0;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$1 = 0;
     i64toi32_i32$3 = 1;
     if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
      break label$3
     }
     label$4 : {
      label$5 : {
       label$6 : {
        i64toi32_i32$2 = $3$hi;
        i64toi32_i32$3 = $3;
        i64toi32_i32$0 = 0;
        i64toi32_i32$1 = 1;
        if (i64toi32_i32$2 >>> 0 > i64toi32_i32$0 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$3 >>> 0 > i64toi32_i32$1 >>> 0 | 0) | 0) {
         break label$6
        }
        $1 = 0;
        i64toi32_i32$3 = $3$hi;
        switch ($3 | 0) {
        case 1:
         break label$5;
        default:
         break label$4;
        };
       }
       alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($2 + 64 | 0 | 0, 1053108 | 0, 9 | 0);
       HEAP8[($2 + 16 | 0) >> 0] = 11;
       break label$2;
      }
      $1 = 1;
      HEAP8[($2 + 9 | 0) >> 0] = 1;
     }
     HEAP8[($0 + 1 | 0) >> 0] = $1;
     $1 = 0;
     break label$1;
    }
    HEAP32[($2 + 64 | 0) >> 2] = 0;
    HEAP8[($2 + 16 | 0) >> 0] = 2;
    i64toi32_i32$3 = $3$hi;
    i64toi32_i32$2 = ($2 + 8 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $3;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
    i64toi32_i32$1 = ($2 + 112 | 0) + 16 | 0;
    i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
    $40 = i64toi32_i32$3;
    i64toi32_i32$3 = ($2 + 8 | 0) + 24 | 0;
    HEAP32[i64toi32_i32$3 >> 2] = $40;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$1 = ($2 + 112 | 0) + 24 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
    $47 = i64toi32_i32$2;
    i64toi32_i32$2 = ($2 + 8 | 0) + 32 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $47;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
    i64toi32_i32$1 = ($2 + 112 | 0) + 32 | 0;
    i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
    $54 = i64toi32_i32$3;
    i64toi32_i32$3 = ($2 + 8 | 0) + 40 | 0;
    HEAP32[i64toi32_i32$3 >> 2] = $54;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$1 = ($2 + 112 | 0) + 40 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
    $60 = i64toi32_i32$2;
    i64toi32_i32$2 = $2 + 56 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $60;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
   }
   memcpy($2 + 112 | 0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 64 | 0) | 0;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 + 112 | 0 | 0, 1053108 | 0, 9 | 0);
   $1 = 1;
  }
  HEAP8[$0 >> 0] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function multiasset_insert($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $15 = 0, $7 = 0, $4 = 0, $5 = 0, $6 = 0, $49 = 0, $56 = 0, $59 = 0, $91 = 0;
  $3 = global$0 - 96 | 0;
  global$0 = $3;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hbb430c180f3ec4b2($3 + 24 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $4 = HEAP32[($3 + 28 | 0) >> 2] | 0;
   $5 = HEAP32[($3 + 24 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h27da893e95dd15cf($3 + 16 | 0 | 0, $1 | 0);
   if (!$2) {
    break label$1
   }
   $1 = HEAP32[($3 + 20 | 0) >> 2] | 0;
   $0 = HEAP32[($3 + 16 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h91e3d4f7af3d2ccd($3 + 8 | 0 | 0, $2 | 0);
   $2 = HEAP32[($3 + 12 | 0) >> 2] | 0;
   $6 = HEAP32[($3 + 8 | 0) >> 2] | 0;
   $15 = $0 + 24 | 0;
   HEAP32[(($3 + 48 | 0) + 24 | 0) >> 2] = HEAPU8[$15 >> 0] | 0 | ((HEAPU8[($15 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($15 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($15 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$2 = $0 + 16 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $49 = i64toi32_i32$0;
   i64toi32_i32$0 = ($3 + 48 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $49;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   $7 = ($3 + 48 | 0) + 8 | 0;
   i64toi32_i32$2 = $0 + 8 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $56 = i64toi32_i32$1;
   i64toi32_i32$1 = $7;
   HEAP32[i64toi32_i32$1 >> 2] = $56;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $59 = i64toi32_i32$0;
   i64toi32_i32$0 = $3;
   HEAP32[($3 + 48 | 0) >> 2] = $59;
   HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$1;
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h3f0faaa5740c6934($3 + 80 | 0 | 0, $6 | 0);
   alloc__collections__btree__map__BTreeMap_K_2cV___insert__ha211f93f5765e42b($3 + 32 | 0 | 0, $5 | 0, $3 + 48 | 0 | 0, $3 + 80 | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   $0 = 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($4 | 0, 0 | 0) | 0;
   label$2 : {
    if ((HEAP32[($3 + 32 | 0) >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    HEAP32[$7 >> 2] = HEAP32[($3 + 44 | 0) >> 2] | 0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
    $91 = i64toi32_i32$1;
    i64toi32_i32$1 = i64toi32_i32$2;
    HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = $91;
    HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = i64toi32_i32$0;
    $0 = $cardano_serialization_lib__Assets_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hf61728444da3586d(i64toi32_i32$2 + 48 | 0 | 0) | 0;
   }
   global$0 = $3 + 96 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function mint_insert($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $15 = 0, $7 = 0, $4 = 0, $5 = 0, $6 = 0, $49 = 0, $56 = 0, $59 = 0, $91 = 0;
  $3 = global$0 - 96 | 0;
  global$0 = $3;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h17bb811378ba5c0a($3 + 24 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $4 = HEAP32[($3 + 28 | 0) >> 2] | 0;
   $5 = HEAP32[($3 + 24 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h27da893e95dd15cf($3 + 16 | 0 | 0, $1 | 0);
   if (!$2) {
    break label$1
   }
   $1 = HEAP32[($3 + 20 | 0) >> 2] | 0;
   $0 = HEAP32[($3 + 16 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h59b9713b6e595a95($3 + 8 | 0 | 0, $2 | 0);
   $2 = HEAP32[($3 + 12 | 0) >> 2] | 0;
   $6 = HEAP32[($3 + 8 | 0) >> 2] | 0;
   $15 = $0 + 24 | 0;
   HEAP32[(($3 + 48 | 0) + 24 | 0) >> 2] = HEAPU8[$15 >> 0] | 0 | ((HEAPU8[($15 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($15 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($15 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$2 = $0 + 16 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $49 = i64toi32_i32$0;
   i64toi32_i32$0 = ($3 + 48 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $49;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   $7 = ($3 + 48 | 0) + 8 | 0;
   i64toi32_i32$2 = $0 + 8 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $56 = i64toi32_i32$1;
   i64toi32_i32$1 = $7;
   HEAP32[i64toi32_i32$1 >> 2] = $56;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $59 = i64toi32_i32$0;
   i64toi32_i32$0 = $3;
   HEAP32[($3 + 48 | 0) >> 2] = $59;
   HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$1;
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h4a35d7ddb2264390($3 + 80 | 0 | 0, $6 | 0);
   alloc__collections__btree__map__BTreeMap_K_2cV___insert__h42468afb2d22301b($3 + 32 | 0 | 0, $5 | 0, $3 + 48 | 0 | 0, $3 + 80 | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   $0 = 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($4 | 0, 0 | 0) | 0;
   label$2 : {
    if ((HEAP32[($3 + 32 | 0) >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    HEAP32[$7 >> 2] = HEAP32[($3 + 44 | 0) >> 2] | 0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
    $91 = i64toi32_i32$1;
    i64toi32_i32$1 = i64toi32_i32$2;
    HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = $91;
    HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = i64toi32_i32$0;
    $0 = $cardano_serialization_lib__MintAssets_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h828d55d3b5b95763(i64toi32_i32$2 + 48 | 0 | 0) | 0;
   }
   global$0 = $3 + 96 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function alloc__raw_vec__RawVec_T_2cA___grow_amortized__h2b1b6a490e812ad2($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $5 = 0, $6 = 0, $80 = 0, $85 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    $3 = $2 + $3 | 0;
    if ($3 >>> 0 < $2 >>> 0) {
     break label$2
    }
    label$3 : {
     label$4 : {
      $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      $5 = $2 << 1 | 0;
      $3 = $5 >>> 0 > $3 >>> 0 ? $5 : $3;
      $3 = $3 >>> 0 > 4 >>> 0 ? $3 : 4;
      if (($3 & 536870911 | 0 | 0) != ($3 | 0)) {
       break label$4
      }
      $3 = $3 << 3 | 0;
      $5 = 8;
      break label$3;
     }
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $5 = 0;
    }
    label$5 : {
     label$6 : {
      if (!$2) {
       break label$6
      }
      $6 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$1 >> 2] | 0 | 0) | 0;
      HEAP32[(($4 + 32 | 0) + 8 | 0) >> 2] = 8;
      HEAP32[($4 + 36 | 0) >> 2] = $2 << 3 | 0;
      HEAP32[($4 + 32 | 0) >> 2] = $6;
      break label$5;
     }
     HEAP32[($4 + 32 | 0) >> 2] = 0;
    }
    alloc__raw_vec__finish_grow__h9cca7d8a9459b8aa($4 + 16 | 0 | 0, $3 | 0, $5 | 0, $4 + 32 | 0 | 0, $1 | 0);
    $2 = 1;
    label$7 : {
     if ((HEAP32[($4 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$7
     }
     $2 = HEAP32[($4 + 20 | 0) >> 2] | 0;
     HEAP32[($1 + 4 | 0) >> 2] = (HEAP32[($4 + 24 | 0) >> 2] | 0) >>> 3 | 0;
     HEAP32[$1 >> 2] = $2;
     $2 = 0;
     break label$1;
    }
    $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 + 8 | 0 | 0, HEAP32[($4 + 20 | 0) >> 2] | 0 | 0, HEAP32[($4 + 24 | 0) >> 2] | 0 | 0);
    i64toi32_i32$0 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    $80 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $80;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
    break label$1;
   }
   $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 | 0, $3 | 0, 0 | 0);
   i64toi32_i32$1 = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   $85 = i64toi32_i32$1;
   i64toi32_i32$1 = $0;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $85;
   HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $4 + 48 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___grow_amortized__h44d2d41be11f46e0($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $5 = 0, $6 = 0, $80 = 0, $85 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    $3 = $2 + $3 | 0;
    if ($3 >>> 0 < $2 >>> 0) {
     break label$2
    }
    label$3 : {
     label$4 : {
      $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      $5 = $2 << 1 | 0;
      $3 = $5 >>> 0 > $3 >>> 0 ? $5 : $3;
      $3 = $3 >>> 0 > 4 >>> 0 ? $3 : 4;
      if (($3 & 268435455 | 0 | 0) != ($3 | 0)) {
       break label$4
      }
      $3 = $3 << 4 | 0;
      $5 = 8;
      break label$3;
     }
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $5 = 0;
    }
    label$5 : {
     label$6 : {
      if (!$2) {
       break label$6
      }
      $6 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$1 >> 2] | 0 | 0) | 0;
      HEAP32[(($4 + 32 | 0) + 8 | 0) >> 2] = 8;
      HEAP32[($4 + 36 | 0) >> 2] = $2 << 4 | 0;
      HEAP32[($4 + 32 | 0) >> 2] = $6;
      break label$5;
     }
     HEAP32[($4 + 32 | 0) >> 2] = 0;
    }
    alloc__raw_vec__finish_grow__h9cca7d8a9459b8aa($4 + 16 | 0 | 0, $3 | 0, $5 | 0, $4 + 32 | 0 | 0, $1 | 0);
    $2 = 1;
    label$7 : {
     if ((HEAP32[($4 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$7
     }
     $2 = HEAP32[($4 + 20 | 0) >> 2] | 0;
     HEAP32[($1 + 4 | 0) >> 2] = (HEAP32[($4 + 24 | 0) >> 2] | 0) >>> 4 | 0;
     HEAP32[$1 >> 2] = $2;
     $2 = 0;
     break label$1;
    }
    $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 + 8 | 0 | 0, HEAP32[($4 + 20 | 0) >> 2] | 0 | 0, HEAP32[($4 + 24 | 0) >> 2] | 0 | 0);
    i64toi32_i32$0 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    $80 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $80;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
    break label$1;
   }
   $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 | 0, $3 | 0, 0 | 0);
   i64toi32_i32$1 = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   $85 = i64toi32_i32$1;
   i64toi32_i32$1 = $0;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $85;
   HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $4 + 48 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___grow_amortized__hd69331eb690e9c9d($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $5 = 0, $6 = 0, $80 = 0, $85 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    $3 = $2 + $3 | 0;
    if ($3 >>> 0 < $2 >>> 0) {
     break label$2
    }
    label$3 : {
     label$4 : {
      $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      $5 = $2 << 1 | 0;
      $3 = $5 >>> 0 > $3 >>> 0 ? $5 : $3;
      $3 = $3 >>> 0 > 4 >>> 0 ? $3 : 4;
      if (($3 & 33554431 | 0 | 0) != ($3 | 0)) {
       break label$4
      }
      $3 = $3 << 7 | 0;
      $5 = 8;
      break label$3;
     }
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $5 = 0;
    }
    label$5 : {
     label$6 : {
      if (!$2) {
       break label$6
      }
      $6 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$1 >> 2] | 0 | 0) | 0;
      HEAP32[(($4 + 32 | 0) + 8 | 0) >> 2] = 8;
      HEAP32[($4 + 36 | 0) >> 2] = $2 << 7 | 0;
      HEAP32[($4 + 32 | 0) >> 2] = $6;
      break label$5;
     }
     HEAP32[($4 + 32 | 0) >> 2] = 0;
    }
    alloc__raw_vec__finish_grow__h9cca7d8a9459b8aa($4 + 16 | 0 | 0, $3 | 0, $5 | 0, $4 + 32 | 0 | 0, $1 | 0);
    $2 = 1;
    label$7 : {
     if ((HEAP32[($4 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$7
     }
     $2 = HEAP32[($4 + 20 | 0) >> 2] | 0;
     HEAP32[($1 + 4 | 0) >> 2] = (HEAP32[($4 + 24 | 0) >> 2] | 0) >>> 7 | 0;
     HEAP32[$1 >> 2] = $2;
     $2 = 0;
     break label$1;
    }
    $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 + 8 | 0 | 0, HEAP32[($4 + 20 | 0) >> 2] | 0 | 0, HEAP32[($4 + 24 | 0) >> 2] | 0 | 0);
    i64toi32_i32$0 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    $80 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $80;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
    break label$1;
   }
   $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 | 0, $3 | 0, 0 | 0);
   i64toi32_i32$1 = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   $85 = i64toi32_i32$1;
   i64toi32_i32$1 = $0;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $85;
   HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $4 + 48 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___grow_amortized__he8b3d9e2a5705505($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $5 = 0, $6 = 0, $80 = 0, $85 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    $3 = $2 + $3 | 0;
    if ($3 >>> 0 < $2 >>> 0) {
     break label$2
    }
    label$3 : {
     label$4 : {
      $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      $5 = $2 << 1 | 0;
      $3 = $5 >>> 0 > $3 >>> 0 ? $5 : $3;
      $3 = $3 >>> 0 > 4 >>> 0 ? $3 : 4;
      if (($3 & 536870911 | 0 | 0) != ($3 | 0)) {
       break label$4
      }
      $3 = $3 << 3 | 0;
      $5 = 8;
      break label$3;
     }
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $5 = 0;
    }
    label$5 : {
     label$6 : {
      if (!$2) {
       break label$6
      }
      $6 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$1 >> 2] | 0 | 0) | 0;
      HEAP32[(($4 + 32 | 0) + 8 | 0) >> 2] = 8;
      HEAP32[($4 + 36 | 0) >> 2] = $2 << 3 | 0;
      HEAP32[($4 + 32 | 0) >> 2] = $6;
      break label$5;
     }
     HEAP32[($4 + 32 | 0) >> 2] = 0;
    }
    alloc__raw_vec__finish_grow__h9cca7d8a9459b8aa($4 + 16 | 0 | 0, $3 | 0, $5 | 0, $4 + 32 | 0 | 0, $1 | 0);
    $2 = 1;
    label$7 : {
     if ((HEAP32[($4 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$7
     }
     $2 = HEAP32[($4 + 20 | 0) >> 2] | 0;
     HEAP32[($1 + 4 | 0) >> 2] = (HEAP32[($4 + 24 | 0) >> 2] | 0) >>> 3 | 0;
     HEAP32[$1 >> 2] = $2;
     $2 = 0;
     break label$1;
    }
    $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 + 8 | 0 | 0, HEAP32[($4 + 20 | 0) >> 2] | 0 | 0, HEAP32[($4 + 24 | 0) >> 2] | 0 | 0);
    i64toi32_i32$0 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    $80 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $80;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
    break label$1;
   }
   $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 | 0, $3 | 0, 0 | 0);
   i64toi32_i32$1 = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   $85 = i64toi32_i32$1;
   i64toi32_i32$1 = $0;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $85;
   HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $4 + 48 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___grow_amortized__hfdd08e37da3a4f23($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $5 = 0, $6 = 0, $80 = 0, $85 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    $3 = $2 + $3 | 0;
    if ($3 >>> 0 < $2 >>> 0) {
     break label$2
    }
    label$3 : {
     label$4 : {
      $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      $5 = $2 << 1 | 0;
      $3 = $5 >>> 0 > $3 >>> 0 ? $5 : $3;
      $3 = $3 >>> 0 > 4 >>> 0 ? $3 : 4;
      if (($3 & 134217727 | 0 | 0) != ($3 | 0)) {
       break label$4
      }
      $3 = $3 << 5 | 0;
      $5 = 8;
      break label$3;
     }
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $5 = 0;
    }
    label$5 : {
     label$6 : {
      if (!$2) {
       break label$6
      }
      $6 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$1 >> 2] | 0 | 0) | 0;
      HEAP32[(($4 + 32 | 0) + 8 | 0) >> 2] = 8;
      HEAP32[($4 + 36 | 0) >> 2] = $2 << 5 | 0;
      HEAP32[($4 + 32 | 0) >> 2] = $6;
      break label$5;
     }
     HEAP32[($4 + 32 | 0) >> 2] = 0;
    }
    alloc__raw_vec__finish_grow__h9cca7d8a9459b8aa($4 + 16 | 0 | 0, $3 | 0, $5 | 0, $4 + 32 | 0 | 0, $1 | 0);
    $2 = 1;
    label$7 : {
     if ((HEAP32[($4 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$7
     }
     $2 = HEAP32[($4 + 20 | 0) >> 2] | 0;
     HEAP32[($1 + 4 | 0) >> 2] = (HEAP32[($4 + 24 | 0) >> 2] | 0) >>> 5 | 0;
     HEAP32[$1 >> 2] = $2;
     $2 = 0;
     break label$1;
    }
    $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 + 8 | 0 | 0, HEAP32[($4 + 20 | 0) >> 2] | 0 | 0, HEAP32[($4 + 24 | 0) >> 2] | 0 | 0);
    i64toi32_i32$0 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    $80 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $80;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
    break label$1;
   }
   $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 | 0, $3 | 0, 0 | 0);
   i64toi32_i32$1 = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   $85 = i64toi32_i32$1;
   i64toi32_i32$1 = $0;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $85;
   HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $4 + 48 | 0;
 }
 
 function cardano_serialization_lib__crypto__Ed25519Signature__from_bytes__hf5afe24ffdbd3318($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $11 = 0, $12 = 0, $13 = 0, $14 = 0, $15 = 0, $3 = 0, $4 = 0, $47 = 0, $56 = 0, $63 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 320 | 0;
  global$0 = $2;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $1 | 0);
  cardano_serialization_lib__chain_crypto__sign__Signature_T_2cA___from_binary__h127c757dae4cedbd($2 + 232 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  $3 = 1;
  label$1 : {
   label$2 : {
    if ((HEAPU8[($2 + 232 | 0) >> 0] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    memcpy($2 + 89 | 0 | 0, memcpy($2 + 160 | 0 | 1 | 0 | 0, $2 + 232 | 0 | 1 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
    memcpy($2 + 18 | 0 | 0, $2 + 89 | 0 | 0, 64 | 0) | 0;
    memcpy($0 + 1 | 0 | 0, $2 + 18 | 0 | 0, 64 | 0) | 0;
    $3 = 0;
    break label$1;
   }
   $11 = $2 + 316 | 0;
   $12 = HEAP32[($2 + 244 | 0) >> 2] | 0;
   HEAP8[$11 >> 0] = $12;
   HEAP8[($11 + 1 | 0) >> 0] = $12 >>> 8 | 0;
   HEAP8[($11 + 2 | 0) >> 0] = $12 >>> 16 | 0;
   HEAP8[($11 + 3 | 0) >> 0] = $12 >>> 24 | 0;
   i64toi32_i32$0 = HEAP32[($2 + 236 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 240 | 0) >> 2] | 0;
   $47 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   $13 = $47;
   HEAP8[($2 + 308 | 0) >> 0] = $13;
   HEAP8[($2 + 309 | 0) >> 0] = $13 >>> 8 | 0;
   HEAP8[($2 + 310 | 0) >> 0] = $13 >>> 16 | 0;
   HEAP8[($2 + 311 | 0) >> 0] = $13 >>> 24 | 0;
   HEAP8[($2 + 312 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[($2 + 313 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[($2 + 314 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[($2 + 315 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($2 + 216 | 0 | 0, 1066748 | 0, 16 | 0);
   $4 = $2 + 168 | 0;
   HEAP8[$4 >> 0] = 14;
   i64toi32_i32$1 = HEAPU8[($2 + 305 | 0) >> 0] | 0 | ((HEAPU8[($2 + 306 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 307 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 308 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[($2 + 309 | 0) >> 0] | 0 | ((HEAPU8[($2 + 310 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 311 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 312 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $56 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 169 | 0;
   $14 = $56;
   HEAP8[i64toi32_i32$1 >> 0] = $14;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $14 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $14 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $14 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   $10 = ($2 + 305 | 0) + 7 | 0;
   i64toi32_i32$0 = HEAPU8[$10 >> 0] | 0 | ((HEAPU8[($10 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($10 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($10 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[($10 + 4 | 0) >> 0] | 0 | ((HEAPU8[($10 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($10 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($10 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $63 = i64toi32_i32$0;
   i64toi32_i32$0 = ($2 + 160 | 0) + 16 | 0;
   $15 = $63;
   HEAP8[i64toi32_i32$0 >> 0] = $15;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $15 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $15 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $15 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   memcpy($2 + 160 | 0 | 0, memcpy(($2 + 18 | 0) + 7 | 0 | 0, memcpy(($2 + 89 | 0) + 7 | 0 | 0, $4 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0 + 4 | 0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 160 | 0 | 0) | 0), HEAP32[wasm2js_i32$0 >> 2] = wasm2js_i32$1;
  }
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  HEAP8[$0 >> 0] = $3;
  global$0 = $2 + 320 | 0;
 }
 
 function cardano_serialization_lib__crypto__VRFCert__new__h6ceef7098f5961a1($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $4 = 0, $28 = 0, $31 = 0, $35 = 0, $40 = 0, $54 = 0, $59 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $3 = global$0 - 96 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    if (($4 | 0) != (80 | 0)) {
     break label$2
    }
    $4 = ($3 + 72 | 0) + 8 | 0;
    HEAP32[$4 >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
    HEAP32[(($3 + 72 | 0) + 20 | 0) >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $1;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $28 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $28;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $31 = i64toi32_i32$1;
    i64toi32_i32$1 = $3;
    HEAP32[($3 + 84 | 0) >> 2] = $31;
    HEAP32[($3 + 88 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $4;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $35 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 12 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $35;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $3 + 88 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $40 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 20 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $40;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    $2 = 0;
    break label$1;
   }
   HEAP32[($3 + 68 | 0) >> 2] = $4;
   core__fmt__ArgumentV1__new__h5702524f4c8ddc75($3 + 24 | 0 | 0, 1067252 | 0, 46 | 0);
   i64toi32_i32$2 = $3;
   i64toi32_i32$0 = HEAP32[($3 + 24 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($3 + 28 | 0) >> 2] | 0;
   core__fmt__ArgumentV1__new__h5702524f4c8ddc75($3 + 16 | 0 | 0, $3 + 68 | 0 | 0, 46 | 0);
   HEAP32[($3 + 92 | 0) >> 2] = 2;
   $54 = i64toi32_i32$0;
   i64toi32_i32$0 = $3;
   HEAP32[($3 + 48 | 0) >> 2] = $54;
   HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$0 = $3;
   i64toi32_i32$1 = 0;
   HEAP32[($3 + 76 | 0) >> 2] = 2;
   HEAP32[($3 + 80 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($3 + 72 | 0) >> 2] = 1067236;
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[($3 + 16 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($3 + 20 | 0) >> 2] | 0;
   $59 = i64toi32_i32$1;
   i64toi32_i32$1 = $3;
   HEAP32[($3 + 56 | 0) >> 2] = $59;
   HEAP32[($3 + 60 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($3 + 88 | 0) >> 2] = $3 + 48 | 0;
   alloc__fmt__format__h6e9e003a52c07309($3 + 32 | 0 | 0, $3 + 72 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $3 + 32 | 0 | 0);
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($3 + 8 | 0) >> 2] | 0 | 0, HEAP32[($3 + 12 | 0) >> 2] | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 32 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 32 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $3 + 96 | 0;
 }
 
 function pointeraddress_from_address($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $20 = 0, $3 = 0, $2 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $25 = 0, $4 = 0, $28 = 0, $33 = 0, $42 = 0, $5 = 0, $5$hi = 0, $6 = 0, $6$hi = 0, $7 = 0, $7$hi = 0, $63 = 0, $68 = 0, $73 = 0;
  $1 = global$0 - 128 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hab2c0cbdcb539b91($1 | 0, $0 | 0);
   $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   label$2 : {
    label$3 : {
     $0 = HEAP32[$1 >> 2] | 0;
     if ((HEAPU8[$0 >> 0] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     $3 = 2;
     break label$2;
    }
    $4 = HEAPU8[($0 + 32 | 0) >> 0] | 0;
    i64toi32_i32$2 = $0 + 42 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $28 = i64toi32_i32$0;
    i64toi32_i32$0 = $1 + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $28;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $0 + 50 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $33 = i64toi32_i32$1;
    i64toi32_i32$1 = $1 + 24 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $33;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    $20 = $0 + 58 | 0;
    HEAP32[($1 + 32 | 0) >> 2] = HEAPU8[$20 >> 0] | 0 | ((HEAPU8[($20 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($20 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($20 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$2 = $0 + 34 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $42 = i64toi32_i32$0;
    i64toi32_i32$0 = $1;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $42;
    HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
    $3 = HEAPU8[($0 + 33 | 0) >> 0] | 0;
    i64toi32_i32$2 = $0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
    $5 = i64toi32_i32$1;
    $5$hi = i64toi32_i32$0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
    $6 = i64toi32_i32$0;
    $6$hi = i64toi32_i32$1;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
    $7 = i64toi32_i32$1;
    $7$hi = i64toi32_i32$0;
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
   $0 = 0;
   label$4 : {
    if (($3 & 255 | 0 | 0) == (2 | 0)) {
     break label$4
    }
    i64toi32_i32$2 = $1;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
    $63 = i64toi32_i32$0;
    i64toi32_i32$0 = i64toi32_i32$2 + 98 | 0;
    $21 = $63;
    HEAP16[i64toi32_i32$0 >> 1] = $21;
    HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $21 >>> 16 | 0;
    HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$1;
    HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
    i64toi32_i32$2 = i64toi32_i32$2 + 16 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $68 = i64toi32_i32$1;
    i64toi32_i32$1 = $1 + 106 | 0;
    $22 = $68;
    HEAP16[i64toi32_i32$1 >> 1] = $22;
    HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $22 >>> 16 | 0;
    HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = i64toi32_i32$0;
    HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
    i64toi32_i32$2 = $1 + 24 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $73 = i64toi32_i32$0;
    i64toi32_i32$0 = $1 + 114 | 0;
    $23 = $73;
    HEAP16[i64toi32_i32$0 >> 1] = $23;
    HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $23 >>> 16 | 0;
    HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$1;
    HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
    $24 = $1 + 122 | 0;
    $25 = HEAP32[($1 + 32 | 0) >> 2] | 0;
    HEAP16[$24 >> 1] = $25;
    HEAP16[($24 + 2 | 0) >> 1] = $25 >>> 16 | 0;
    HEAP8[($1 + 97 | 0) >> 0] = $3;
    HEAP8[($1 + 96 | 0) >> 0] = $4;
    i64toi32_i32$1 = $5$hi;
    i64toi32_i32$0 = $1;
    HEAP32[(i64toi32_i32$0 + 88 | 0) >> 2] = $5;
    HEAP32[(i64toi32_i32$0 + 92 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $6$hi;
    HEAP32[(i64toi32_i32$0 + 80 | 0) >> 2] = $6;
    HEAP32[(i64toi32_i32$0 + 84 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $7$hi;
    HEAP32[(i64toi32_i32$0 + 72 | 0) >> 2] = $7;
    HEAP32[(i64toi32_i32$0 + 76 | 0) >> 2] = i64toi32_i32$1;
    $0 = $cardano_serialization_lib__address__PointerAddress_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h1cd671f5d15881dc(i64toi32_i32$0 + 72 | 0 | 0) | 0;
   }
   global$0 = $1 + 128 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function $_mut_20W_20as_20core__fmt__Write___write_char__h305d306f7f73d864($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $0 = HEAP32[$0 >> 2] | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ($1 >>> 0 < 128 >>> 0) {
        break label$5
       }
       HEAP32[($2 + 12 | 0) >> 2] = 0;
       if ($1 >>> 0 < 2048 >>> 0) {
        break label$4
       }
       if ($1 >>> 0 >= 65536 >>> 0) {
        break label$3
       }
       HEAP8[($2 + 14 | 0) >> 0] = $1 & 63 | 0 | 128 | 0;
       HEAP8[($2 + 12 | 0) >> 0] = $1 >>> 12 | 0 | 224 | 0;
       HEAP8[($2 + 13 | 0) >> 0] = ($1 >>> 6 | 0) & 63 | 0 | 128 | 0;
       $1 = 3;
       break label$2;
      }
      label$6 : {
       $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
       if (($3 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
        break label$6
       }
       alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__he90fb3a4f4cd283b($0 | 0, $3 | 0, 1 | 0);
       $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
      }
      HEAP8[((HEAP32[$0 >> 2] | 0) + $3 | 0) >> 0] = $1;
      HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
      break label$1;
     }
     HEAP8[($2 + 13 | 0) >> 0] = $1 & 63 | 0 | 128 | 0;
     HEAP8[($2 + 12 | 0) >> 0] = $1 >>> 6 | 0 | 192 | 0;
     $1 = 2;
     break label$2;
    }
    HEAP8[($2 + 15 | 0) >> 0] = $1 & 63 | 0 | 128 | 0;
    HEAP8[($2 + 12 | 0) >> 0] = $1 >>> 18 | 0 | 240 | 0;
    HEAP8[($2 + 14 | 0) >> 0] = ($1 >>> 6 | 0) & 63 | 0 | 128 | 0;
    HEAP8[($2 + 13 | 0) >> 0] = ($1 >>> 12 | 0) & 63 | 0 | 128 | 0;
    $1 = 4;
   }
   $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend__T_2ccore__slice__iter__Iter_T_____spec_extend__hbd860717b01c36cd($0 | 0, $2 + 12 | 0 | 0, ($2 + 12 | 0) + $1 | 0 | 0);
  }
  global$0 = $2 + 16 | 0;
  return 0 | 0;
 }
 
 function core__fmt__builders__DebugTuple__field__h5e7e3e19ad5aa557($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $6 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, $5 = 0, $54 = 0, $7 = 0, $7$hi = 0, $66 = 0, $71 = 0;
  $3 = global$0 - 64 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    if (!(HEAPU8[($0 + 8 | 0) >> 0] | 0)) {
     break label$2
    }
    $4 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    $5 = 1;
    break label$1;
   }
   $4 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   label$3 : {
    $6 = HEAP32[$0 >> 2] | 0;
    if ((HEAPU8[$6 >> 0] | 0) & 4 | 0) {
     break label$3
    }
    $5 = 1;
    if (FUNCTION_TABLE[HEAP32[((HEAP32[($6 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($6 + 24 | 0) >> 2] | 0, $4 ? 1149869 : 1149895, $4 ? 2 : 1) | 0) {
     break label$1
    }
    $5 = FUNCTION_TABLE[HEAP32[($2 + 12 | 0) >> 2] | 0 | 0]($1, $6) | 0;
    break label$1;
   }
   label$4 : {
    if ($4) {
     break label$4
    }
    if (!(FUNCTION_TABLE[HEAP32[((HEAP32[($6 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($6 + 24 | 0) >> 2] | 0, 1149893, 2) | 0)) {
     break label$4
    }
    $5 = 1;
    $4 = 0;
    break label$1;
   }
   $5 = 1;
   HEAP8[($3 + 23 | 0) >> 0] = 1;
   HEAP32[($3 + 52 | 0) >> 2] = 1149804;
   i64toi32_i32$0 = HEAP32[($6 + 24 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($6 + 28 | 0) >> 2] | 0;
   $54 = i64toi32_i32$0;
   i64toi32_i32$0 = $3;
   HEAP32[($3 + 8 | 0) >> 2] = $54;
   HEAP32[($3 + 12 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($3 + 16 | 0) >> 2] = $3 + 23 | 0;
   i64toi32_i32$1 = HEAP32[($6 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($6 + 12 | 0) >> 2] | 0;
   $7 = i64toi32_i32$1;
   $7$hi = i64toi32_i32$0;
   i64toi32_i32$0 = HEAP32[($6 + 16 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($6 + 20 | 0) >> 2] | 0;
   HEAP8[($3 + 56 | 0) >> 0] = HEAPU8[($6 + 32 | 0) >> 0] | 0;
   $66 = i64toi32_i32$0;
   i64toi32_i32$0 = $3;
   HEAP32[($3 + 40 | 0) >> 2] = $66;
   HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $7$hi;
   i64toi32_i32$0 = $3;
   HEAP32[($3 + 32 | 0) >> 2] = $7;
   HEAP32[($3 + 36 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = HEAP32[$6 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($6 + 4 | 0) >> 2] | 0;
   $71 = i64toi32_i32$1;
   i64toi32_i32$1 = $3;
   HEAP32[($3 + 24 | 0) >> 2] = $71;
   HEAP32[($3 + 28 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($3 + 48 | 0) >> 2] = $3 + 8 | 0;
   if (FUNCTION_TABLE[HEAP32[($2 + 12 | 0) >> 2] | 0 | 0]($1, $3 + 24 | 0) | 0) {
    break label$1
   }
   $5 = FUNCTION_TABLE[HEAP32[((HEAP32[($3 + 52 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($3 + 48 | 0) >> 2] | 0, 1149867, 2) | 0;
  }
  HEAP8[($0 + 8 | 0) >> 0] = $5;
  HEAP32[($0 + 4 | 0) >> 2] = $4 + 1 | 0;
  global$0 = $3 + 64 | 0;
  return $0 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__DeserializeEmbeddedGroup_20for_20cardano_serialization_lib__ProtocolVersion___deserialize_as_embedded_group__h2c31b2815aa7e5c5($0, $1, $2, $2$hi, $3, $3$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  var $4 = 0, $5 = 0;
  $4 = global$0 - 272 | 0;
  global$0 = $4;
  $T_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hf422f9333a8bbafa($4 + 200 | 0 | 0, $1 | 0);
  $5 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($4 + 200 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $5 = HEAP32[($4 + 204 | 0) >> 2] | 0;
    $T_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hf422f9333a8bbafa($4 + 200 | 0 | 0, $1 | 0);
    label$3 : {
     if ((HEAP32[($4 + 200 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     HEAP32[($0 + 8 | 0) >> 2] = HEAP32[($4 + 204 | 0) >> 2] | 0;
     HEAP32[($0 + 4 | 0) >> 2] = $5;
     $5 = 0;
     break label$1;
    }
    memcpy($4 + 136 | 0 | 0, ($4 + 200 | 0) + 8 | 0 | 0, 64 | 0) | 0;
    memcpy($4 + 72 | 0 | 0, $4 + 136 | 0 | 0, 64 | 0) | 0;
    memcpy($4 + 200 | 0 | 0, $4 + 72 | 0 | 0, 64 | 0) | 0;
    $1 = $4 + 8 | 0;
    cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 200 | 0 | 0, 1052168 | 0, 5 | 0);
    memcpy($0 + 8 | 0 | 0, $1 | 0, 64 | 0) | 0;
    $5 = 1;
    break label$1;
   }
   memcpy($4 + 136 | 0 | 0, ($4 + 200 | 0) + 8 | 0 | 0, 64 | 0) | 0;
   memcpy($4 + 72 | 0 | 0, $4 + 136 | 0 | 0, 64 | 0) | 0;
   memcpy($4 + 200 | 0 | 0, $4 + 72 | 0 | 0, 64 | 0) | 0;
   $1 = $4 + 8 | 0;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($1 | 0, $4 + 200 | 0 | 0, 1052163 | 0, 5 | 0);
   memcpy($0 + 8 | 0 | 0, $1 | 0, 64 | 0) | 0;
  }
  HEAP32[$0 >> 2] = $5;
  global$0 = $4 + 272 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___grow_amortized__h0e109e6593d2a7b4($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, $6 = 0, $5 = 0, i64toi32_i32$3 = 0, $16 = 0, $7 = 0, $7$hi = 0, $81 = 0, $86 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    $3 = $2 + $3 | 0;
    if ($3 >>> 0 < $2 >>> 0) {
     break label$2
    }
    $5 = 4;
    label$3 : {
     label$4 : {
      $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      $6 = $2 << 1 | 0;
      $3 = $6 >>> 0 > $3 >>> 0 ? $6 : $3;
      i64toi32_i32$0 = 0;
      i64toi32_i32$1 = 0;
      i64toi32_i32$1 = __wasm_i64_mul(($3 >>> 0 > 4 >>> 0 ? $3 : 4) | 0, i64toi32_i32$0 | 0, 12 | 0, i64toi32_i32$1 | 0) | 0;
      i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
      $7 = i64toi32_i32$1;
      $7$hi = i64toi32_i32$0;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 32;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$1 = 0;
       $16 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
      } else {
       i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       $16 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
      }
      if ($16) {
       break label$4
      }
      i64toi32_i32$1 = $7$hi;
      $3 = $7;
      break label$3;
     }
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $5 = 0;
    }
    label$5 : {
     label$6 : {
      if (!$2) {
       break label$6
      }
      $6 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$1 >> 2] | 0 | 0) | 0;
      HEAP32[($4 + 40 | 0) >> 2] = 4;
      HEAP32[($4 + 36 | 0) >> 2] = Math_imul($2, 12);
      HEAP32[($4 + 32 | 0) >> 2] = $6;
      break label$5;
     }
     HEAP32[($4 + 32 | 0) >> 2] = 0;
    }
    alloc__raw_vec__finish_grow__h9cca7d8a9459b8aa($4 + 16 | 0 | 0, $3 | 0, $5 | 0, $4 + 32 | 0 | 0, $1 | 0);
    $2 = 1;
    label$7 : {
     if ((HEAP32[($4 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$7
     }
     $2 = HEAP32[($4 + 20 | 0) >> 2] | 0;
     HEAP32[($1 + 4 | 0) >> 2] = ((HEAP32[($4 + 24 | 0) >> 2] | 0) >>> 0) / (12 >>> 0) | 0;
     HEAP32[$1 >> 2] = $2;
     $2 = 0;
     break label$1;
    }
    $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 + 8 | 0 | 0, HEAP32[($4 + 20 | 0) >> 2] | 0 | 0, HEAP32[($4 + 24 | 0) >> 2] | 0 | 0);
    i64toi32_i32$0 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    $81 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $81;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$2;
    break label$1;
   }
   $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 | 0, $3 | 0, 0 | 0);
   i64toi32_i32$0 = $4;
   i64toi32_i32$2 = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   $86 = i64toi32_i32$2;
   i64toi32_i32$2 = $0;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = $86;
   HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = i64toi32_i32$1;
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $4 + 48 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___grow_amortized__h134b30d55f098eb6($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, $6 = 0, $5 = 0, i64toi32_i32$3 = 0, $16 = 0, $7 = 0, $7$hi = 0, $81 = 0, $86 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    $3 = $2 + $3 | 0;
    if ($3 >>> 0 < $2 >>> 0) {
     break label$2
    }
    $5 = 4;
    label$3 : {
     label$4 : {
      $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      $6 = $2 << 1 | 0;
      $3 = $6 >>> 0 > $3 >>> 0 ? $6 : $3;
      i64toi32_i32$0 = 0;
      i64toi32_i32$1 = 0;
      i64toi32_i32$1 = __wasm_i64_mul(($3 >>> 0 > 4 >>> 0 ? $3 : 4) | 0, i64toi32_i32$0 | 0, 36 | 0, i64toi32_i32$1 | 0) | 0;
      i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
      $7 = i64toi32_i32$1;
      $7$hi = i64toi32_i32$0;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 32;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$1 = 0;
       $16 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
      } else {
       i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       $16 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
      }
      if ($16) {
       break label$4
      }
      i64toi32_i32$1 = $7$hi;
      $3 = $7;
      break label$3;
     }
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $5 = 0;
    }
    label$5 : {
     label$6 : {
      if (!$2) {
       break label$6
      }
      $6 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$1 >> 2] | 0 | 0) | 0;
      HEAP32[($4 + 40 | 0) >> 2] = 4;
      HEAP32[($4 + 36 | 0) >> 2] = Math_imul($2, 36);
      HEAP32[($4 + 32 | 0) >> 2] = $6;
      break label$5;
     }
     HEAP32[($4 + 32 | 0) >> 2] = 0;
    }
    alloc__raw_vec__finish_grow__h9cca7d8a9459b8aa($4 + 16 | 0 | 0, $3 | 0, $5 | 0, $4 + 32 | 0 | 0, $1 | 0);
    $2 = 1;
    label$7 : {
     if ((HEAP32[($4 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$7
     }
     $2 = HEAP32[($4 + 20 | 0) >> 2] | 0;
     HEAP32[($1 + 4 | 0) >> 2] = ((HEAP32[($4 + 24 | 0) >> 2] | 0) >>> 0) / (36 >>> 0) | 0;
     HEAP32[$1 >> 2] = $2;
     $2 = 0;
     break label$1;
    }
    $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 + 8 | 0 | 0, HEAP32[($4 + 20 | 0) >> 2] | 0 | 0, HEAP32[($4 + 24 | 0) >> 2] | 0 | 0);
    i64toi32_i32$0 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    $81 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $81;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$2;
    break label$1;
   }
   $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 | 0, $3 | 0, 0 | 0);
   i64toi32_i32$0 = $4;
   i64toi32_i32$2 = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   $86 = i64toi32_i32$2;
   i64toi32_i32$2 = $0;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = $86;
   HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = i64toi32_i32$1;
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $4 + 48 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___grow_amortized__h1c6aed9a0f471094($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, $6 = 0, $5 = 0, i64toi32_i32$3 = 0, $16 = 0, $7 = 0, $7$hi = 0, $81 = 0, $86 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    $3 = $2 + $3 | 0;
    if ($3 >>> 0 < $2 >>> 0) {
     break label$2
    }
    $5 = 4;
    label$3 : {
     label$4 : {
      $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      $6 = $2 << 1 | 0;
      $3 = $6 >>> 0 > $3 >>> 0 ? $6 : $3;
      i64toi32_i32$0 = 0;
      i64toi32_i32$1 = 0;
      i64toi32_i32$1 = __wasm_i64_mul(($3 >>> 0 > 4 >>> 0 ? $3 : 4) | 0, i64toi32_i32$0 | 0, 12 | 0, i64toi32_i32$1 | 0) | 0;
      i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
      $7 = i64toi32_i32$1;
      $7$hi = i64toi32_i32$0;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 32;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$1 = 0;
       $16 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
      } else {
       i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       $16 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
      }
      if ($16) {
       break label$4
      }
      i64toi32_i32$1 = $7$hi;
      $3 = $7;
      break label$3;
     }
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $5 = 0;
    }
    label$5 : {
     label$6 : {
      if (!$2) {
       break label$6
      }
      $6 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$1 >> 2] | 0 | 0) | 0;
      HEAP32[($4 + 40 | 0) >> 2] = 4;
      HEAP32[($4 + 36 | 0) >> 2] = Math_imul($2, 12);
      HEAP32[($4 + 32 | 0) >> 2] = $6;
      break label$5;
     }
     HEAP32[($4 + 32 | 0) >> 2] = 0;
    }
    alloc__raw_vec__finish_grow__h9cca7d8a9459b8aa($4 + 16 | 0 | 0, $3 | 0, $5 | 0, $4 + 32 | 0 | 0, $1 | 0);
    $2 = 1;
    label$7 : {
     if ((HEAP32[($4 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$7
     }
     $2 = HEAP32[($4 + 20 | 0) >> 2] | 0;
     HEAP32[($1 + 4 | 0) >> 2] = ((HEAP32[($4 + 24 | 0) >> 2] | 0) >>> 0) / (12 >>> 0) | 0;
     HEAP32[$1 >> 2] = $2;
     $2 = 0;
     break label$1;
    }
    $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 + 8 | 0 | 0, HEAP32[($4 + 20 | 0) >> 2] | 0 | 0, HEAP32[($4 + 24 | 0) >> 2] | 0 | 0);
    i64toi32_i32$0 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    $81 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $81;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$2;
    break label$1;
   }
   $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 | 0, $3 | 0, 0 | 0);
   i64toi32_i32$0 = $4;
   i64toi32_i32$2 = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   $86 = i64toi32_i32$2;
   i64toi32_i32$2 = $0;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = $86;
   HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = i64toi32_i32$1;
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $4 + 48 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___grow_amortized__h32cf64aa38e43a13($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, $6 = 0, $5 = 0, i64toi32_i32$3 = 0, $16 = 0, $7 = 0, $7$hi = 0, $81 = 0, $86 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    $3 = $2 + $3 | 0;
    if ($3 >>> 0 < $2 >>> 0) {
     break label$2
    }
    $5 = 1;
    label$3 : {
     label$4 : {
      $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      $6 = $2 << 1 | 0;
      $3 = $6 >>> 0 > $3 >>> 0 ? $6 : $3;
      i64toi32_i32$0 = 0;
      i64toi32_i32$1 = 0;
      i64toi32_i32$1 = __wasm_i64_mul(($3 >>> 0 > 4 >>> 0 ? $3 : 4) | 0, i64toi32_i32$0 | 0, 30 | 0, i64toi32_i32$1 | 0) | 0;
      i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
      $7 = i64toi32_i32$1;
      $7$hi = i64toi32_i32$0;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 32;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$1 = 0;
       $16 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
      } else {
       i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       $16 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
      }
      if ($16) {
       break label$4
      }
      i64toi32_i32$1 = $7$hi;
      $3 = $7;
      break label$3;
     }
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $5 = 0;
    }
    label$5 : {
     label$6 : {
      if (!$2) {
       break label$6
      }
      $6 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$1 >> 2] | 0 | 0) | 0;
      HEAP32[($4 + 40 | 0) >> 2] = 1;
      HEAP32[($4 + 36 | 0) >> 2] = Math_imul($2, 30);
      HEAP32[($4 + 32 | 0) >> 2] = $6;
      break label$5;
     }
     HEAP32[($4 + 32 | 0) >> 2] = 0;
    }
    alloc__raw_vec__finish_grow__h9cca7d8a9459b8aa($4 + 16 | 0 | 0, $3 | 0, $5 | 0, $4 + 32 | 0 | 0, $1 | 0);
    $2 = 1;
    label$7 : {
     if ((HEAP32[($4 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$7
     }
     $2 = HEAP32[($4 + 20 | 0) >> 2] | 0;
     HEAP32[($1 + 4 | 0) >> 2] = ((HEAP32[($4 + 24 | 0) >> 2] | 0) >>> 0) / (30 >>> 0) | 0;
     HEAP32[$1 >> 2] = $2;
     $2 = 0;
     break label$1;
    }
    $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 + 8 | 0 | 0, HEAP32[($4 + 20 | 0) >> 2] | 0 | 0, HEAP32[($4 + 24 | 0) >> 2] | 0 | 0);
    i64toi32_i32$0 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    $81 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $81;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$2;
    break label$1;
   }
   $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 | 0, $3 | 0, 0 | 0);
   i64toi32_i32$0 = $4;
   i64toi32_i32$2 = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   $86 = i64toi32_i32$2;
   i64toi32_i32$2 = $0;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = $86;
   HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = i64toi32_i32$1;
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $4 + 48 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___grow_amortized__h561ad47c477d4529($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, $6 = 0, $5 = 0, i64toi32_i32$3 = 0, $16 = 0, $7 = 0, $7$hi = 0, $81 = 0, $86 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    $3 = $2 + $3 | 0;
    if ($3 >>> 0 < $2 >>> 0) {
     break label$2
    }
    $5 = 4;
    label$3 : {
     label$4 : {
      $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      $6 = $2 << 1 | 0;
      $3 = $6 >>> 0 > $3 >>> 0 ? $6 : $3;
      i64toi32_i32$0 = 0;
      i64toi32_i32$1 = 0;
      i64toi32_i32$1 = __wasm_i64_mul(($3 >>> 0 > 4 >>> 0 ? $3 : 4) | 0, i64toi32_i32$0 | 0, 120 | 0, i64toi32_i32$1 | 0) | 0;
      i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
      $7 = i64toi32_i32$1;
      $7$hi = i64toi32_i32$0;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 32;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$1 = 0;
       $16 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
      } else {
       i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       $16 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
      }
      if ($16) {
       break label$4
      }
      i64toi32_i32$1 = $7$hi;
      $3 = $7;
      break label$3;
     }
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $5 = 0;
    }
    label$5 : {
     label$6 : {
      if (!$2) {
       break label$6
      }
      $6 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$1 >> 2] | 0 | 0) | 0;
      HEAP32[($4 + 40 | 0) >> 2] = 4;
      HEAP32[($4 + 36 | 0) >> 2] = Math_imul($2, 120);
      HEAP32[($4 + 32 | 0) >> 2] = $6;
      break label$5;
     }
     HEAP32[($4 + 32 | 0) >> 2] = 0;
    }
    alloc__raw_vec__finish_grow__h9cca7d8a9459b8aa($4 + 16 | 0 | 0, $3 | 0, $5 | 0, $4 + 32 | 0 | 0, $1 | 0);
    $2 = 1;
    label$7 : {
     if ((HEAP32[($4 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$7
     }
     $2 = HEAP32[($4 + 20 | 0) >> 2] | 0;
     HEAP32[($1 + 4 | 0) >> 2] = ((HEAP32[($4 + 24 | 0) >> 2] | 0) >>> 0) / (120 >>> 0) | 0;
     HEAP32[$1 >> 2] = $2;
     $2 = 0;
     break label$1;
    }
    $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 + 8 | 0 | 0, HEAP32[($4 + 20 | 0) >> 2] | 0 | 0, HEAP32[($4 + 24 | 0) >> 2] | 0 | 0);
    i64toi32_i32$0 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    $81 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $81;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$2;
    break label$1;
   }
   $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 | 0, $3 | 0, 0 | 0);
   i64toi32_i32$0 = $4;
   i64toi32_i32$2 = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   $86 = i64toi32_i32$2;
   i64toi32_i32$2 = $0;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = $86;
   HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = i64toi32_i32$1;
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $4 + 48 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___grow_amortized__h695c1ff0a843d246($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, $6 = 0, $5 = 0, i64toi32_i32$3 = 0, $16 = 0, $7 = 0, $7$hi = 0, $81 = 0, $86 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    $3 = $2 + $3 | 0;
    if ($3 >>> 0 < $2 >>> 0) {
     break label$2
    }
    $5 = 4;
    label$3 : {
     label$4 : {
      $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      $6 = $2 << 1 | 0;
      $3 = $6 >>> 0 > $3 >>> 0 ? $6 : $3;
      i64toi32_i32$0 = 0;
      i64toi32_i32$1 = 0;
      i64toi32_i32$1 = __wasm_i64_mul(($3 >>> 0 > 4 >>> 0 ? $3 : 4) | 0, i64toi32_i32$0 | 0, 28 | 0, i64toi32_i32$1 | 0) | 0;
      i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
      $7 = i64toi32_i32$1;
      $7$hi = i64toi32_i32$0;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 32;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$1 = 0;
       $16 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
      } else {
       i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       $16 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
      }
      if ($16) {
       break label$4
      }
      i64toi32_i32$1 = $7$hi;
      $3 = $7;
      break label$3;
     }
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $5 = 0;
    }
    label$5 : {
     label$6 : {
      if (!$2) {
       break label$6
      }
      $6 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$1 >> 2] | 0 | 0) | 0;
      HEAP32[($4 + 40 | 0) >> 2] = 4;
      HEAP32[($4 + 36 | 0) >> 2] = Math_imul($2, 28);
      HEAP32[($4 + 32 | 0) >> 2] = $6;
      break label$5;
     }
     HEAP32[($4 + 32 | 0) >> 2] = 0;
    }
    alloc__raw_vec__finish_grow__h9cca7d8a9459b8aa($4 + 16 | 0 | 0, $3 | 0, $5 | 0, $4 + 32 | 0 | 0, $1 | 0);
    $2 = 1;
    label$7 : {
     if ((HEAP32[($4 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$7
     }
     $2 = HEAP32[($4 + 20 | 0) >> 2] | 0;
     HEAP32[($1 + 4 | 0) >> 2] = ((HEAP32[($4 + 24 | 0) >> 2] | 0) >>> 0) / (28 >>> 0) | 0;
     HEAP32[$1 >> 2] = $2;
     $2 = 0;
     break label$1;
    }
    $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 + 8 | 0 | 0, HEAP32[($4 + 20 | 0) >> 2] | 0 | 0, HEAP32[($4 + 24 | 0) >> 2] | 0 | 0);
    i64toi32_i32$0 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    $81 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $81;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$2;
    break label$1;
   }
   $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 | 0, $3 | 0, 0 | 0);
   i64toi32_i32$0 = $4;
   i64toi32_i32$2 = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   $86 = i64toi32_i32$2;
   i64toi32_i32$2 = $0;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = $86;
   HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = i64toi32_i32$1;
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $4 + 48 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___grow_amortized__h7a7e330561a9918e($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, $6 = 0, $5 = 0, i64toi32_i32$3 = 0, $16 = 0, $7 = 0, $7$hi = 0, $81 = 0, $86 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    $3 = $2 + $3 | 0;
    if ($3 >>> 0 < $2 >>> 0) {
     break label$2
    }
    $5 = 4;
    label$3 : {
     label$4 : {
      $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      $6 = $2 << 1 | 0;
      $3 = $6 >>> 0 > $3 >>> 0 ? $6 : $3;
      i64toi32_i32$0 = 0;
      i64toi32_i32$1 = 0;
      i64toi32_i32$1 = __wasm_i64_mul(($3 >>> 0 > 4 >>> 0 ? $3 : 4) | 0, i64toi32_i32$0 | 0, 12 | 0, i64toi32_i32$1 | 0) | 0;
      i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
      $7 = i64toi32_i32$1;
      $7$hi = i64toi32_i32$0;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 32;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$1 = 0;
       $16 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
      } else {
       i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       $16 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
      }
      if ($16) {
       break label$4
      }
      i64toi32_i32$1 = $7$hi;
      $3 = $7;
      break label$3;
     }
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $5 = 0;
    }
    label$5 : {
     label$6 : {
      if (!$2) {
       break label$6
      }
      $6 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$1 >> 2] | 0 | 0) | 0;
      HEAP32[($4 + 40 | 0) >> 2] = 4;
      HEAP32[($4 + 36 | 0) >> 2] = Math_imul($2, 12);
      HEAP32[($4 + 32 | 0) >> 2] = $6;
      break label$5;
     }
     HEAP32[($4 + 32 | 0) >> 2] = 0;
    }
    alloc__raw_vec__finish_grow__h9cca7d8a9459b8aa($4 + 16 | 0 | 0, $3 | 0, $5 | 0, $4 + 32 | 0 | 0, $1 | 0);
    $2 = 1;
    label$7 : {
     if ((HEAP32[($4 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$7
     }
     $2 = HEAP32[($4 + 20 | 0) >> 2] | 0;
     HEAP32[($1 + 4 | 0) >> 2] = ((HEAP32[($4 + 24 | 0) >> 2] | 0) >>> 0) / (12 >>> 0) | 0;
     HEAP32[$1 >> 2] = $2;
     $2 = 0;
     break label$1;
    }
    $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 + 8 | 0 | 0, HEAP32[($4 + 20 | 0) >> 2] | 0 | 0, HEAP32[($4 + 24 | 0) >> 2] | 0 | 0);
    i64toi32_i32$0 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    $81 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $81;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$2;
    break label$1;
   }
   $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 | 0, $3 | 0, 0 | 0);
   i64toi32_i32$0 = $4;
   i64toi32_i32$2 = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   $86 = i64toi32_i32$2;
   i64toi32_i32$2 = $0;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = $86;
   HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = i64toi32_i32$1;
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $4 + 48 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___grow_amortized__h8252dde40401b41c($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, $6 = 0, $5 = 0, i64toi32_i32$3 = 0, $16 = 0, $7 = 0, $7$hi = 0, $81 = 0, $86 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    $3 = $2 + $3 | 0;
    if ($3 >>> 0 < $2 >>> 0) {
     break label$2
    }
    $5 = 4;
    label$3 : {
     label$4 : {
      $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      $6 = $2 << 1 | 0;
      $3 = $6 >>> 0 > $3 >>> 0 ? $6 : $3;
      i64toi32_i32$0 = 0;
      i64toi32_i32$1 = 0;
      i64toi32_i32$1 = __wasm_i64_mul(($3 >>> 0 > 4 >>> 0 ? $3 : 4) | 0, i64toi32_i32$0 | 0, 76 | 0, i64toi32_i32$1 | 0) | 0;
      i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
      $7 = i64toi32_i32$1;
      $7$hi = i64toi32_i32$0;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 32;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$1 = 0;
       $16 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
      } else {
       i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       $16 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
      }
      if ($16) {
       break label$4
      }
      i64toi32_i32$1 = $7$hi;
      $3 = $7;
      break label$3;
     }
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $5 = 0;
    }
    label$5 : {
     label$6 : {
      if (!$2) {
       break label$6
      }
      $6 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$1 >> 2] | 0 | 0) | 0;
      HEAP32[($4 + 40 | 0) >> 2] = 4;
      HEAP32[($4 + 36 | 0) >> 2] = Math_imul($2, 76);
      HEAP32[($4 + 32 | 0) >> 2] = $6;
      break label$5;
     }
     HEAP32[($4 + 32 | 0) >> 2] = 0;
    }
    alloc__raw_vec__finish_grow__h9cca7d8a9459b8aa($4 + 16 | 0 | 0, $3 | 0, $5 | 0, $4 + 32 | 0 | 0, $1 | 0);
    $2 = 1;
    label$7 : {
     if ((HEAP32[($4 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$7
     }
     $2 = HEAP32[($4 + 20 | 0) >> 2] | 0;
     HEAP32[($1 + 4 | 0) >> 2] = ((HEAP32[($4 + 24 | 0) >> 2] | 0) >>> 0) / (76 >>> 0) | 0;
     HEAP32[$1 >> 2] = $2;
     $2 = 0;
     break label$1;
    }
    $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 + 8 | 0 | 0, HEAP32[($4 + 20 | 0) >> 2] | 0 | 0, HEAP32[($4 + 24 | 0) >> 2] | 0 | 0);
    i64toi32_i32$0 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    $81 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $81;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$2;
    break label$1;
   }
   $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 | 0, $3 | 0, 0 | 0);
   i64toi32_i32$0 = $4;
   i64toi32_i32$2 = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   $86 = i64toi32_i32$2;
   i64toi32_i32$2 = $0;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = $86;
   HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = i64toi32_i32$1;
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $4 + 48 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___grow_amortized__h8582ea6381964946($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, $6 = 0, $5 = 0, i64toi32_i32$3 = 0, $16 = 0, $7 = 0, $7$hi = 0, $81 = 0, $86 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    $3 = $2 + $3 | 0;
    if ($3 >>> 0 < $2 >>> 0) {
     break label$2
    }
    $5 = 1;
    label$3 : {
     label$4 : {
      $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      $6 = $2 << 1 | 0;
      $3 = $6 >>> 0 > $3 >>> 0 ? $6 : $3;
      i64toi32_i32$0 = 0;
      i64toi32_i32$1 = 0;
      i64toi32_i32$1 = __wasm_i64_mul(($3 >>> 0 > 4 >>> 0 ? $3 : 4) | 0, i64toi32_i32$0 | 0, 28 | 0, i64toi32_i32$1 | 0) | 0;
      i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
      $7 = i64toi32_i32$1;
      $7$hi = i64toi32_i32$0;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 32;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$1 = 0;
       $16 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
      } else {
       i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       $16 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
      }
      if ($16) {
       break label$4
      }
      i64toi32_i32$1 = $7$hi;
      $3 = $7;
      break label$3;
     }
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $5 = 0;
    }
    label$5 : {
     label$6 : {
      if (!$2) {
       break label$6
      }
      $6 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$1 >> 2] | 0 | 0) | 0;
      HEAP32[($4 + 40 | 0) >> 2] = 1;
      HEAP32[($4 + 36 | 0) >> 2] = Math_imul($2, 28);
      HEAP32[($4 + 32 | 0) >> 2] = $6;
      break label$5;
     }
     HEAP32[($4 + 32 | 0) >> 2] = 0;
    }
    alloc__raw_vec__finish_grow__h9cca7d8a9459b8aa($4 + 16 | 0 | 0, $3 | 0, $5 | 0, $4 + 32 | 0 | 0, $1 | 0);
    $2 = 1;
    label$7 : {
     if ((HEAP32[($4 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$7
     }
     $2 = HEAP32[($4 + 20 | 0) >> 2] | 0;
     HEAP32[($1 + 4 | 0) >> 2] = ((HEAP32[($4 + 24 | 0) >> 2] | 0) >>> 0) / (28 >>> 0) | 0;
     HEAP32[$1 >> 2] = $2;
     $2 = 0;
     break label$1;
    }
    $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 + 8 | 0 | 0, HEAP32[($4 + 20 | 0) >> 2] | 0 | 0, HEAP32[($4 + 24 | 0) >> 2] | 0 | 0);
    i64toi32_i32$0 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    $81 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $81;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$2;
    break label$1;
   }
   $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 | 0, $3 | 0, 0 | 0);
   i64toi32_i32$0 = $4;
   i64toi32_i32$2 = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   $86 = i64toi32_i32$2;
   i64toi32_i32$2 = $0;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = $86;
   HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = i64toi32_i32$1;
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $4 + 48 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___grow_amortized__ha9461a9a8b4163ea($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, $6 = 0, $5 = 0, i64toi32_i32$3 = 0, $16 = 0, $7 = 0, $7$hi = 0, $81 = 0, $86 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    $3 = $2 + $3 | 0;
    if ($3 >>> 0 < $2 >>> 0) {
     break label$2
    }
    $5 = 1;
    label$3 : {
     label$4 : {
      $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      $6 = $2 << 1 | 0;
      $3 = $6 >>> 0 > $3 >>> 0 ? $6 : $3;
      i64toi32_i32$0 = 0;
      i64toi32_i32$1 = 0;
      i64toi32_i32$1 = __wasm_i64_mul(($3 >>> 0 > 4 >>> 0 ? $3 : 4) | 0, i64toi32_i32$0 | 0, 28 | 0, i64toi32_i32$1 | 0) | 0;
      i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
      $7 = i64toi32_i32$1;
      $7$hi = i64toi32_i32$0;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 32;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$1 = 0;
       $16 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
      } else {
       i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       $16 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
      }
      if ($16) {
       break label$4
      }
      i64toi32_i32$1 = $7$hi;
      $3 = $7;
      break label$3;
     }
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $5 = 0;
    }
    label$5 : {
     label$6 : {
      if (!$2) {
       break label$6
      }
      $6 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$1 >> 2] | 0 | 0) | 0;
      HEAP32[($4 + 40 | 0) >> 2] = 1;
      HEAP32[($4 + 36 | 0) >> 2] = Math_imul($2, 28);
      HEAP32[($4 + 32 | 0) >> 2] = $6;
      break label$5;
     }
     HEAP32[($4 + 32 | 0) >> 2] = 0;
    }
    alloc__raw_vec__finish_grow__h9cca7d8a9459b8aa($4 + 16 | 0 | 0, $3 | 0, $5 | 0, $4 + 32 | 0 | 0, $1 | 0);
    $2 = 1;
    label$7 : {
     if ((HEAP32[($4 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$7
     }
     $2 = HEAP32[($4 + 20 | 0) >> 2] | 0;
     HEAP32[($1 + 4 | 0) >> 2] = ((HEAP32[($4 + 24 | 0) >> 2] | 0) >>> 0) / (28 >>> 0) | 0;
     HEAP32[$1 >> 2] = $2;
     $2 = 0;
     break label$1;
    }
    $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 + 8 | 0 | 0, HEAP32[($4 + 20 | 0) >> 2] | 0 | 0, HEAP32[($4 + 24 | 0) >> 2] | 0 | 0);
    i64toi32_i32$0 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    $81 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $81;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$2;
    break label$1;
   }
   $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 | 0, $3 | 0, 0 | 0);
   i64toi32_i32$0 = $4;
   i64toi32_i32$2 = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   $86 = i64toi32_i32$2;
   i64toi32_i32$2 = $0;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = $86;
   HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = i64toi32_i32$1;
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $4 + 48 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___grow_amortized__had972e909c97e38b($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, $6 = 0, $5 = 0, i64toi32_i32$3 = 0, $16 = 0, $7 = 0, $7$hi = 0, $81 = 0, $86 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    $3 = $2 + $3 | 0;
    if ($3 >>> 0 < $2 >>> 0) {
     break label$2
    }
    $5 = 1;
    label$3 : {
     label$4 : {
      $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      $6 = $2 << 1 | 0;
      $3 = $6 >>> 0 > $3 >>> 0 ? $6 : $3;
      i64toi32_i32$0 = 0;
      i64toi32_i32$1 = 0;
      i64toi32_i32$1 = __wasm_i64_mul(($3 >>> 0 > 4 >>> 0 ? $3 : 4) | 0, i64toi32_i32$0 | 0, 96 | 0, i64toi32_i32$1 | 0) | 0;
      i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
      $7 = i64toi32_i32$1;
      $7$hi = i64toi32_i32$0;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 32;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$1 = 0;
       $16 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
      } else {
       i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       $16 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
      }
      if ($16) {
       break label$4
      }
      i64toi32_i32$1 = $7$hi;
      $3 = $7;
      break label$3;
     }
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $5 = 0;
    }
    label$5 : {
     label$6 : {
      if (!$2) {
       break label$6
      }
      $6 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$1 >> 2] | 0 | 0) | 0;
      HEAP32[($4 + 40 | 0) >> 2] = 1;
      HEAP32[($4 + 36 | 0) >> 2] = Math_imul($2, 96);
      HEAP32[($4 + 32 | 0) >> 2] = $6;
      break label$5;
     }
     HEAP32[($4 + 32 | 0) >> 2] = 0;
    }
    alloc__raw_vec__finish_grow__h9cca7d8a9459b8aa($4 + 16 | 0 | 0, $3 | 0, $5 | 0, $4 + 32 | 0 | 0, $1 | 0);
    $2 = 1;
    label$7 : {
     if ((HEAP32[($4 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$7
     }
     $2 = HEAP32[($4 + 20 | 0) >> 2] | 0;
     HEAP32[($1 + 4 | 0) >> 2] = ((HEAP32[($4 + 24 | 0) >> 2] | 0) >>> 0) / (96 >>> 0) | 0;
     HEAP32[$1 >> 2] = $2;
     $2 = 0;
     break label$1;
    }
    $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 + 8 | 0 | 0, HEAP32[($4 + 20 | 0) >> 2] | 0 | 0, HEAP32[($4 + 24 | 0) >> 2] | 0 | 0);
    i64toi32_i32$0 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    $81 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $81;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$2;
    break label$1;
   }
   $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 | 0, $3 | 0, 0 | 0);
   i64toi32_i32$0 = $4;
   i64toi32_i32$2 = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   $86 = i64toi32_i32$2;
   i64toi32_i32$2 = $0;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = $86;
   HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = i64toi32_i32$1;
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $4 + 48 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___grow_amortized__hc292e6e349fedcda($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, $6 = 0, $5 = 0, i64toi32_i32$3 = 0, $16 = 0, $7 = 0, $7$hi = 0, $81 = 0, $86 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    $3 = $2 + $3 | 0;
    if ($3 >>> 0 < $2 >>> 0) {
     break label$2
    }
    $5 = 4;
    label$3 : {
     label$4 : {
      $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      $6 = $2 << 1 | 0;
      $3 = $6 >>> 0 > $3 >>> 0 ? $6 : $3;
      i64toi32_i32$0 = 0;
      i64toi32_i32$1 = 0;
      i64toi32_i32$1 = __wasm_i64_mul(($3 >>> 0 > 4 >>> 0 ? $3 : 4) | 0, i64toi32_i32$0 | 0, 12 | 0, i64toi32_i32$1 | 0) | 0;
      i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
      $7 = i64toi32_i32$1;
      $7$hi = i64toi32_i32$0;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 32;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$1 = 0;
       $16 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
      } else {
       i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       $16 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
      }
      if ($16) {
       break label$4
      }
      i64toi32_i32$1 = $7$hi;
      $3 = $7;
      break label$3;
     }
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $5 = 0;
    }
    label$5 : {
     label$6 : {
      if (!$2) {
       break label$6
      }
      $6 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$1 >> 2] | 0 | 0) | 0;
      HEAP32[($4 + 40 | 0) >> 2] = 4;
      HEAP32[($4 + 36 | 0) >> 2] = Math_imul($2, 12);
      HEAP32[($4 + 32 | 0) >> 2] = $6;
      break label$5;
     }
     HEAP32[($4 + 32 | 0) >> 2] = 0;
    }
    alloc__raw_vec__finish_grow__h9cca7d8a9459b8aa($4 + 16 | 0 | 0, $3 | 0, $5 | 0, $4 + 32 | 0 | 0, $1 | 0);
    $2 = 1;
    label$7 : {
     if ((HEAP32[($4 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$7
     }
     $2 = HEAP32[($4 + 20 | 0) >> 2] | 0;
     HEAP32[($1 + 4 | 0) >> 2] = ((HEAP32[($4 + 24 | 0) >> 2] | 0) >>> 0) / (12 >>> 0) | 0;
     HEAP32[$1 >> 2] = $2;
     $2 = 0;
     break label$1;
    }
    $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 + 8 | 0 | 0, HEAP32[($4 + 20 | 0) >> 2] | 0 | 0, HEAP32[($4 + 24 | 0) >> 2] | 0 | 0);
    i64toi32_i32$0 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    $81 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $81;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$2;
    break label$1;
   }
   $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 | 0, $3 | 0, 0 | 0);
   i64toi32_i32$0 = $4;
   i64toi32_i32$2 = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   $86 = i64toi32_i32$2;
   i64toi32_i32$2 = $0;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = $86;
   HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = i64toi32_i32$1;
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $4 + 48 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___grow_amortized__he7ea3f4f2a47815e($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, $6 = 0, $5 = 0, i64toi32_i32$3 = 0, $16 = 0, $7 = 0, $7$hi = 0, $81 = 0, $86 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    $3 = $2 + $3 | 0;
    if ($3 >>> 0 < $2 >>> 0) {
     break label$2
    }
    $5 = 1;
    label$3 : {
     label$4 : {
      $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      $6 = $2 << 1 | 0;
      $3 = $6 >>> 0 > $3 >>> 0 ? $6 : $3;
      i64toi32_i32$0 = 0;
      i64toi32_i32$1 = 0;
      i64toi32_i32$1 = __wasm_i64_mul(($3 >>> 0 > 4 >>> 0 ? $3 : 4) | 0, i64toi32_i32$0 | 0, 29 | 0, i64toi32_i32$1 | 0) | 0;
      i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
      $7 = i64toi32_i32$1;
      $7$hi = i64toi32_i32$0;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 32;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$1 = 0;
       $16 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
      } else {
       i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       $16 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
      }
      if ($16) {
       break label$4
      }
      i64toi32_i32$1 = $7$hi;
      $3 = $7;
      break label$3;
     }
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $5 = 0;
    }
    label$5 : {
     label$6 : {
      if (!$2) {
       break label$6
      }
      $6 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$1 >> 2] | 0 | 0) | 0;
      HEAP32[($4 + 40 | 0) >> 2] = 1;
      HEAP32[($4 + 36 | 0) >> 2] = Math_imul($2, 29);
      HEAP32[($4 + 32 | 0) >> 2] = $6;
      break label$5;
     }
     HEAP32[($4 + 32 | 0) >> 2] = 0;
    }
    alloc__raw_vec__finish_grow__h9cca7d8a9459b8aa($4 + 16 | 0 | 0, $3 | 0, $5 | 0, $4 + 32 | 0 | 0, $1 | 0);
    $2 = 1;
    label$7 : {
     if ((HEAP32[($4 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$7
     }
     $2 = HEAP32[($4 + 20 | 0) >> 2] | 0;
     HEAP32[($1 + 4 | 0) >> 2] = ((HEAP32[($4 + 24 | 0) >> 2] | 0) >>> 0) / (29 >>> 0) | 0;
     HEAP32[$1 >> 2] = $2;
     $2 = 0;
     break label$1;
    }
    $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 + 8 | 0 | 0, HEAP32[($4 + 20 | 0) >> 2] | 0 | 0, HEAP32[($4 + 24 | 0) >> 2] | 0 | 0);
    i64toi32_i32$0 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    $81 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $81;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$2;
    break label$1;
   }
   $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 | 0, $3 | 0, 0 | 0);
   i64toi32_i32$0 = $4;
   i64toi32_i32$2 = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   $86 = i64toi32_i32$2;
   i64toi32_i32$2 = $0;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = $86;
   HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = i64toi32_i32$1;
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $4 + 48 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___grow_amortized__he88d25d865ea9535($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, $6 = 0, $5 = 0, i64toi32_i32$3 = 0, $16 = 0, $7 = 0, $7$hi = 0, $81 = 0, $86 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    $3 = $2 + $3 | 0;
    if ($3 >>> 0 < $2 >>> 0) {
     break label$2
    }
    $5 = 4;
    label$3 : {
     label$4 : {
      $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      $6 = $2 << 1 | 0;
      $3 = $6 >>> 0 > $3 >>> 0 ? $6 : $3;
      i64toi32_i32$0 = 0;
      i64toi32_i32$1 = 0;
      i64toi32_i32$1 = __wasm_i64_mul(($3 >>> 0 > 4 >>> 0 ? $3 : 4) | 0, i64toi32_i32$0 | 0, 12 | 0, i64toi32_i32$1 | 0) | 0;
      i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
      $7 = i64toi32_i32$1;
      $7$hi = i64toi32_i32$0;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 32;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$1 = 0;
       $16 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
      } else {
       i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       $16 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
      }
      if ($16) {
       break label$4
      }
      i64toi32_i32$1 = $7$hi;
      $3 = $7;
      break label$3;
     }
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $5 = 0;
    }
    label$5 : {
     label$6 : {
      if (!$2) {
       break label$6
      }
      $6 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$1 >> 2] | 0 | 0) | 0;
      HEAP32[($4 + 40 | 0) >> 2] = 4;
      HEAP32[($4 + 36 | 0) >> 2] = Math_imul($2, 12);
      HEAP32[($4 + 32 | 0) >> 2] = $6;
      break label$5;
     }
     HEAP32[($4 + 32 | 0) >> 2] = 0;
    }
    alloc__raw_vec__finish_grow__h9cca7d8a9459b8aa($4 + 16 | 0 | 0, $3 | 0, $5 | 0, $4 + 32 | 0 | 0, $1 | 0);
    $2 = 1;
    label$7 : {
     if ((HEAP32[($4 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$7
     }
     $2 = HEAP32[($4 + 20 | 0) >> 2] | 0;
     HEAP32[($1 + 4 | 0) >> 2] = ((HEAP32[($4 + 24 | 0) >> 2] | 0) >>> 0) / (12 >>> 0) | 0;
     HEAP32[$1 >> 2] = $2;
     $2 = 0;
     break label$1;
    }
    $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 + 8 | 0 | 0, HEAP32[($4 + 20 | 0) >> 2] | 0 | 0, HEAP32[($4 + 24 | 0) >> 2] | 0 | 0);
    i64toi32_i32$0 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    $81 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $81;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$2;
    break label$1;
   }
   $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 | 0, $3 | 0, 0 | 0);
   i64toi32_i32$0 = $4;
   i64toi32_i32$2 = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   $86 = i64toi32_i32$2;
   i64toi32_i32$2 = $0;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = $86;
   HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = i64toi32_i32$1;
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $4 + 48 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___grow_amortized__heaf262243daf937e($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, $6 = 0, $5 = 0, i64toi32_i32$3 = 0, $16 = 0, $7 = 0, $7$hi = 0, $81 = 0, $86 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    $3 = $2 + $3 | 0;
    if ($3 >>> 0 < $2 >>> 0) {
     break label$2
    }
    $5 = 1;
    label$3 : {
     label$4 : {
      $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      $6 = $2 << 1 | 0;
      $3 = $6 >>> 0 > $3 >>> 0 ? $6 : $3;
      i64toi32_i32$0 = 0;
      i64toi32_i32$1 = 0;
      i64toi32_i32$1 = __wasm_i64_mul(($3 >>> 0 > 4 >>> 0 ? $3 : 4) | 0, i64toi32_i32$0 | 0, 28 | 0, i64toi32_i32$1 | 0) | 0;
      i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
      $7 = i64toi32_i32$1;
      $7$hi = i64toi32_i32$0;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      i64toi32_i32$3 = 32;
      i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$1 = 0;
       $16 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
      } else {
       i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       $16 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
      }
      if ($16) {
       break label$4
      }
      i64toi32_i32$1 = $7$hi;
      $3 = $7;
      break label$3;
     }
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $5 = 0;
    }
    label$5 : {
     label$6 : {
      if (!$2) {
       break label$6
      }
      $6 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$1 >> 2] | 0 | 0) | 0;
      HEAP32[($4 + 40 | 0) >> 2] = 1;
      HEAP32[($4 + 36 | 0) >> 2] = Math_imul($2, 28);
      HEAP32[($4 + 32 | 0) >> 2] = $6;
      break label$5;
     }
     HEAP32[($4 + 32 | 0) >> 2] = 0;
    }
    alloc__raw_vec__finish_grow__h9cca7d8a9459b8aa($4 + 16 | 0 | 0, $3 | 0, $5 | 0, $4 + 32 | 0 | 0, $1 | 0);
    $2 = 1;
    label$7 : {
     if ((HEAP32[($4 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$7
     }
     $2 = HEAP32[($4 + 20 | 0) >> 2] | 0;
     HEAP32[($1 + 4 | 0) >> 2] = ((HEAP32[($4 + 24 | 0) >> 2] | 0) >>> 0) / (28 >>> 0) | 0;
     HEAP32[$1 >> 2] = $2;
     $2 = 0;
     break label$1;
    }
    $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 + 8 | 0 | 0, HEAP32[($4 + 20 | 0) >> 2] | 0 | 0, HEAP32[($4 + 24 | 0) >> 2] | 0 | 0);
    i64toi32_i32$0 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    $81 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $81;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$2;
    break label$1;
   }
   $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 | 0, $3 | 0, 0 | 0);
   i64toi32_i32$0 = $4;
   i64toi32_i32$2 = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   $86 = i64toi32_i32$2;
   i64toi32_i32$2 = $0;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = $86;
   HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = i64toi32_i32$1;
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $4 + 48 | 0;
 }
 
 function encode_json_str_to_native_script($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $6 = 0, $67 = 0, $74 = 0, $81 = 0, $86 = 0;
  $5 = global$0 - 96 | 0;
  global$0 = $5;
  HEAP32[($5 + 24 | 0) >> 2] = $1;
  HEAP32[($5 + 20 | 0) >> 2] = $1;
  HEAP32[($5 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($5 + 8 | 0 | 0, $5 + 16 | 0 | 0);
  $1 = HEAP32[($5 + 12 | 0) >> 2] | 0;
  HEAP32[($5 + 60 | 0) >> 2] = $1;
  $0 = HEAP32[($5 + 8 | 0) >> 2] | 0;
  HEAP32[($5 + 56 | 0) >> 2] = $0;
  HEAP32[($5 + 24 | 0) >> 2] = $3;
  HEAP32[($5 + 20 | 0) >> 2] = $3;
  HEAP32[($5 + 16 | 0) >> 2] = $2;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($5 | 0, $5 + 16 | 0 | 0);
  $2 = HEAP32[($5 + 4 | 0) >> 2] | 0;
  HEAP32[($5 + 68 | 0) >> 2] = $2;
  $6 = HEAP32[$5 >> 2] | 0;
  HEAP32[($5 + 64 | 0) >> 2] = $6;
  $3 = 0;
  label$1 : {
   switch ($4 | 0) {
   default:
    wasm_bindgen__throw_str__h40ff0247f6a635d7(1058868 | 0, 25 | 0);
    abort();
   case 1:
    $3 = 1;
    break;
   case 0:
    break label$1;
   };
  }
  cardano_serialization_lib__utils__encode_json_str_to_native_script__hac20d59c89b6b1bb($5 + 16 | 0 | 0, $0 | 0, $1 | 0, $6 | 0, $2 | 0, $3 | 0);
  core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0($5 + 64 | 0 | 0);
  core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0($5 + 56 | 0 | 0);
  label$4 : {
   if ((HEAP32[($5 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$4
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($5 + 20 | 0) >> 2] | 0 | 0);
   abort();
  }
  i64toi32_i32$2 = $5 + 48 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $67 = i64toi32_i32$0;
  i64toi32_i32$0 = ($5 + 64 | 0) + 24 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $67;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = ($5 + 16 | 0) + 24 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $74 = i64toi32_i32$1;
  i64toi32_i32$1 = ($5 + 64 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $74;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = ($5 + 16 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $81 = i64toi32_i32$0;
  i64toi32_i32$0 = ($5 + 64 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $81;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = ($5 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $86 = i64toi32_i32$1;
  i64toi32_i32$1 = $5;
  HEAP32[($5 + 64 | 0) >> 2] = $86;
  HEAP32[($5 + 68 | 0) >> 2] = i64toi32_i32$0;
  $3 = $cardano_serialization_lib__NativeScript_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h345d8ecbe77ecc63($5 + 64 | 0 | 0) | 0;
  global$0 = $5 + 96 | 0;
  return $3 | 0;
 }
 
 function transactionbuilder_add_mint_asset_and_output($0, $1, $2, $3, $4, $5) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  $5 = $5 | 0;
  var $6 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $11$hi = 0, $12$hi = 0, $7 = 0, $8 = 0, $9 = 0, $10 = 0, $11 = 0, $12 = 0;
  $6 = global$0 - 64 | 0;
  global$0 = $6;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h5566e1c7d4aafe35($6 + 56 | 0 | 0, $0 | 0);
    if (!$1) {
     break label$2
    }
    $7 = HEAP32[($6 + 60 | 0) >> 2] | 0;
    $8 = HEAP32[($6 + 56 | 0) >> 2] | 0;
    wasm_bindgen____rt__WasmRefCell_T___borrow__h6ed0b6b043905434($6 + 48 | 0 | 0, $1 | 0);
    if (!$2) {
     break label$2
    }
    $0 = HEAP32[($6 + 52 | 0) >> 2] | 0;
    $9 = HEAP32[($6 + 48 | 0) >> 2] | 0;
    wasm_bindgen____rt__WasmRefCell_T___borrow__h9c68abd5a6a78973($6 + 40 | 0 | 0, $2 | 0);
    $1 = HEAP32[($6 + 44 | 0) >> 2] | 0;
    $10 = HEAP32[($6 + 40 | 0) >> 2] | 0;
    $cardano_serialization_lib__utils__Int_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h465ce6bea3371e5b($6 + 24 | 0 | 0, $3 | 0);
    if (!$4) {
     break label$2
    }
    i64toi32_i32$2 = $6 + 32 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $11 = i64toi32_i32$0;
    $11$hi = i64toi32_i32$1;
    i64toi32_i32$2 = $6;
    i64toi32_i32$1 = HEAP32[($6 + 24 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($6 + 28 | 0) >> 2] | 0;
    $12 = i64toi32_i32$1;
    $12$hi = i64toi32_i32$0;
    wasm_bindgen____rt__WasmRefCell_T___borrow__h1cb96e7b1dabbc55($6 + 16 | 0 | 0, $4 | 0);
    if (!$5) {
     break label$2
    }
    $2 = HEAP32[($6 + 20 | 0) >> 2] | 0;
    $3 = HEAP32[($6 + 16 | 0) >> 2] | 0;
    wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($6 + 8 | 0 | 0, $5 | 0);
    $4 = HEAP32[($6 + 12 | 0) >> 2] | 0;
    i64toi32_i32$0 = $12$hi;
    i64toi32_i32$0 = $11$hi;
    i64toi32_i32$0 = $12$hi;
    i64toi32_i32$1 = $11$hi;
    cardano_serialization_lib__tx_builder__TransactionBuilder__add_mint_asset_and_output__h403fdf9453eb886a($6 | 0, $8 | 0, $9 | 0, $10 | 0, $12 | 0, i64toi32_i32$0 | 0, $11 | 0, i64toi32_i32$1 | 0, $3 | 0, HEAP32[($6 + 8 | 0) >> 2] | 0 | 0);
    $3 = HEAP32[($6 + 4 | 0) >> 2] | 0;
    $5 = HEAP32[$6 >> 2] | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($4 | 0, (HEAP32[$4 >> 2] | 0) + -1 | 0 | 0) | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($7 | 0, 0 | 0) | 0;
    if ($5) {
     break label$1
    }
    global$0 = $6 + 64 | 0;
    return;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472($3 | 0);
  abort();
 }
 
 function $char_20as_20core__fmt__Display___fmt__h3e8fd736f5ac7261($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[($1 + 8 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     if ((HEAP32[($1 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
      break label$2
     }
    }
    $0 = HEAP32[$0 >> 2] | 0;
    HEAP32[($2 + 12 | 0) >> 2] = 0;
    label$4 : {
     label$5 : {
      label$6 : {
       label$7 : {
        if ($0 >>> 0 < 128 >>> 0) {
         break label$7
        }
        if ($0 >>> 0 < 2048 >>> 0) {
         break label$6
        }
        if ($0 >>> 0 >= 65536 >>> 0) {
         break label$5
        }
        HEAP8[($2 + 14 | 0) >> 0] = $0 & 63 | 0 | 128 | 0;
        HEAP8[($2 + 12 | 0) >> 0] = $0 >>> 12 | 0 | 224 | 0;
        HEAP8[($2 + 13 | 0) >> 0] = ($0 >>> 6 | 0) & 63 | 0 | 128 | 0;
        $0 = 3;
        break label$4;
       }
       HEAP8[($2 + 12 | 0) >> 0] = $0;
       $0 = 1;
       break label$4;
      }
      HEAP8[($2 + 13 | 0) >> 0] = $0 & 63 | 0 | 128 | 0;
      HEAP8[($2 + 12 | 0) >> 0] = $0 >>> 6 | 0 | 192 | 0;
      $0 = 2;
      break label$4;
     }
     HEAP8[($2 + 15 | 0) >> 0] = $0 & 63 | 0 | 128 | 0;
     HEAP8[($2 + 12 | 0) >> 0] = $0 >>> 18 | 0 | 240 | 0;
     HEAP8[($2 + 14 | 0) >> 0] = ($0 >>> 6 | 0) & 63 | 0 | 128 | 0;
     HEAP8[($2 + 13 | 0) >> 0] = ($0 >>> 12 | 0) & 63 | 0 | 128 | 0;
     $0 = 4;
    }
    $1 = core__fmt__Formatter__pad__h381b7c9eef015e8b($1 | 0, $2 + 12 | 0 | 0, $0 | 0) | 0;
    break label$1;
   }
   $1 = FUNCTION_TABLE[HEAP32[((HEAP32[($1 + 28 | 0) >> 2] | 0) + 16 | 0) >> 2] | 0 | 0](HEAP32[($1 + 24 | 0) >> 2] | 0, HEAP32[$0 >> 2] | 0) | 0;
  }
  global$0 = $2 + 16 | 0;
  return $1 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert__haab97383f97b0b0d($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $6 = 0, i64toi32_i32$2 = 0, $7 = 0, $88 = 0, $91 = 0;
  $5 = global$0 - 48 | 0;
  global$0 = $5;
  label$1 : {
   label$2 : {
    $6 = HEAP32[$1 >> 2] | 0;
    if (($6 + -1 | 0 | 0) != ($3 | 0)) {
     break label$2
    }
    label$3 : {
     label$4 : {
      label$5 : {
       $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
       if ((HEAPU16[($3 + 50 | 0) >> 1] | 0) >>> 0 < 11 >>> 0) {
        break label$5
       }
       alloc__collections__btree__node__splitpoint__h8424344594b4deb1($5 + 8 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
       $1 = HEAP32[($5 + 16 | 0) >> 2] | 0;
       $7 = HEAP32[($5 + 12 | 0) >> 2] | 0;
       HEAP32[($5 + 40 | 0) >> 2] = HEAP32[($5 + 8 | 0) >> 2] | 0;
       HEAP32[($5 + 36 | 0) >> 2] = $3;
       HEAP32[($5 + 32 | 0) >> 2] = $6;
       alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__KV___split__h09d046c5ede2959b($5 + 8 | 0 | 0, $5 + 32 | 0 | 0);
       if (($7 | 0) == (1 | 0)) {
        break label$4
       }
       HEAP32[($5 + 32 | 0) >> 2] = HEAP32[($5 + 8 | 0) >> 2] | 0;
       $3 = HEAP32[($5 + 12 | 0) >> 2] | 0;
       break label$3;
      }
      alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert_fit__h6793817b02ed58e7($1 | 0, $2 | 0, $5 | 0, $4 | 0);
      HEAP32[($0 + 8 | 0) >> 2] = $3;
      HEAP32[($0 + 4 | 0) >> 2] = $6;
      HEAP32[$0 >> 2] = 0;
      HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
      break label$1;
     }
     HEAP32[($5 + 32 | 0) >> 2] = HEAP32[($5 + 20 | 0) >> 2] | 0;
     $3 = HEAP32[($5 + 24 | 0) >> 2] | 0;
    }
    HEAP32[($5 + 40 | 0) >> 2] = $1;
    HEAP32[($5 + 36 | 0) >> 2] = $3;
    alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert_fit__h6793817b02ed58e7($5 + 32 | 0 | 0, $2 | 0, $5 | 0, $4 | 0);
    HEAP32[$0 >> 2] = 1;
    HEAP32[($0 + 20 | 0) >> 2] = HEAP32[($5 + 24 | 0) >> 2] | 0;
    i64toi32_i32$2 = $5 + 16 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $88 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 12 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $88;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $5;
    i64toi32_i32$1 = HEAP32[($5 + 8 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($5 + 12 | 0) >> 2] | 0;
    $91 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[($0 + 4 | 0) >> 2] = $91;
    HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$0;
    break label$1;
   }
   core__panicking__panic__h2fd385a887c8bf13(1049076 | 0, 53 | 0, 1049132 | 0);
   abort();
  }
  global$0 = $5 + 48 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__KV___split__h84cc36f25422cc7b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $7 = 0, $5 = 0, $2 = 0, $4 = 0, $6 = 0, $3 = 0, $8 = 0, $71 = 0, $79 = 0, $84 = 0, $89 = 0, $94 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $4 = HEAPU16[($3 + 314 | 0) >> 1] | 0;
  $5 = alloc__boxed__Box_T_2cA___new_uninit_in__h0285c5e433c8dfa2() | 0;
  HEAP16[($5 + 314 | 0) >> 1] = 0;
  HEAP32[($5 + 176 | 0) >> 2] = 0;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__h70a172de854ccbbf($2 | 0, $1 | 0, $5 | 0);
  $6 = HEAPU16[($5 + 314 | 0) >> 1] | 0;
  $7 = $6 + 1 | 0;
  label$1 : {
   label$2 : {
    if ($6 >>> 0 >= 12 >>> 0) {
     break label$2
    }
    $8 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    $4 = $4 - $8 | 0;
    if (($4 | 0) != ($7 | 0)) {
     break label$1
    }
    memcpy($5 + 320 | 0 | 0, (($8 << 2 | 0) + $3 | 0) + 324 | 0 | 0, $4 << 2 | 0 | 0) | 0;
    $3 = HEAP32[$1 >> 2] | 0;
    $7 = 0;
    label$3 : {
     label$4 : while (1) {
      $4 = HEAP32[(($5 + ($7 << 2 | 0) | 0) + 320 | 0) >> 2] | 0;
      HEAP16[($4 + 312 | 0) >> 1] = $7;
      HEAP32[($4 + 176 | 0) >> 2] = $5;
      if ($7 >>> 0 >= $6 >>> 0) {
       break label$3
      }
      $7 = $7 + ($7 >>> 0 < $6 >>> 0) | 0;
      if ($7 >>> 0 <= $6 >>> 0) {
       continue label$4
      }
      break label$4;
     };
    }
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $71 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[i64toi32_i32$0 >> 2] = $71;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(i64toi32_i32$0 + 40 | 0) >> 2] = $3;
    HEAP32[(i64toi32_i32$0 + 44 | 0) >> 2] = $5;
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $79 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 32 | 0) >> 2] = $79;
    HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $2 + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $84 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $84;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $2 + 16 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $89 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 16 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $89;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $2 + 24 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $94 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 24 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $94;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    global$0 = $2 + 32 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($7 | 0, 12 | 0, 1049060 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1048988 | 0, 40 | 0, 1049028 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__KV___split__h9b427b91ab57d92a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $7 = 0, $5 = 0, $2 = 0, $4 = 0, $6 = 0, $3 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $20 = 0, $8 = 0, $71 = 0, $79 = 0, $84 = 0, $89 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $4 = HEAPU16[($3 + 6 | 0) >> 1] | 0;
  $5 = alloc__boxed__Box_T_2cA___new_uninit_in__hef877667b5cd207e() | 0;
  HEAP16[($5 + 6 | 0) >> 1] = 0;
  HEAP32[$5 >> 2] = 0;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__h103237ba0f156f09($2 | 0, $1 | 0, $5 | 0);
  $6 = HEAPU16[($5 + 6 | 0) >> 1] | 0;
  $7 = $6 + 1 | 0;
  label$1 : {
   label$2 : {
    if ($6 >>> 0 >= 12 >>> 0) {
     break label$2
    }
    $8 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    $4 = $4 - $8 | 0;
    if (($4 | 0) != ($7 | 0)) {
     break label$1
    }
    memcpy($5 + 316 | 0 | 0, (($8 << 2 | 0) + $3 | 0) + 320 | 0 | 0, $4 << 2 | 0 | 0) | 0;
    $3 = HEAP32[$1 >> 2] | 0;
    $7 = 0;
    label$3 : {
     label$4 : while (1) {
      $4 = HEAP32[(($5 + ($7 << 2 | 0) | 0) + 316 | 0) >> 2] | 0;
      HEAP16[($4 + 4 | 0) >> 1] = $7;
      HEAP32[$4 >> 2] = $5;
      if ($7 >>> 0 >= $6 >>> 0) {
       break label$3
      }
      $7 = $7 + ($7 >>> 0 < $6 >>> 0) | 0;
      if ($7 >>> 0 <= $6 >>> 0) {
       continue label$4
      }
      break label$4;
     };
    }
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $71 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    $16 = $71;
    HEAP8[(i64toi32_i32$0 + 16 | 0) >> 0] = $16;
    HEAP8[(i64toi32_i32$0 + 17 | 0) >> 0] = $16 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 18 | 0) >> 0] = $16 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 19 | 0) >> 0] = $16 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 20 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 21 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 22 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 23 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $3;
    HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = $5;
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $79 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[i64toi32_i32$1 >> 2] = $79;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $2 + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $84 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 24 | 0;
    $17 = $84;
    HEAP8[i64toi32_i32$0 >> 0] = $17;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $17 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $17 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $17 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$2 = $2 + 16 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $89 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 32 | 0;
    $18 = $89;
    HEAP8[i64toi32_i32$1 >> 0] = $18;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $18 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $18 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $18 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    $19 = $0 + 40 | 0;
    $20 = HEAP32[($2 + 24 | 0) >> 2] | 0;
    HEAP8[$19 >> 0] = $20;
    HEAP8[($19 + 1 | 0) >> 0] = $20 >>> 8 | 0;
    HEAP8[($19 + 2 | 0) >> 0] = $20 >>> 16 | 0;
    HEAP8[($19 + 3 | 0) >> 0] = $20 >>> 24 | 0;
    global$0 = $2 + 32 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($7 | 0, 12 | 0, 1049060 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1048988 | 0, 40 | 0, 1049028 | 0);
  abort();
 }
 
 function alloc__raw_vec__RawVec_T_2cA___grow_amortized__h8ebbaf323e52c4c9($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $6 = 0, $5 = 0, $79 = 0, $84 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    $3 = $2 + $3 | 0;
    if ($3 >>> 0 < $2 >>> 0) {
     break label$2
    }
    $5 = 4;
    label$3 : {
     label$4 : {
      $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      $6 = $2 << 1 | 0;
      $3 = $6 >>> 0 > $3 >>> 0 ? $6 : $3;
      $3 = $3 >>> 0 > 4 >>> 0 ? $3 : 4;
      if (($3 & 536870911 | 0 | 0) != ($3 | 0)) {
       break label$4
      }
      $3 = $3 << 3 | 0;
      break label$3;
     }
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $5 = 0;
    }
    label$5 : {
     label$6 : {
      if (!$2) {
       break label$6
      }
      $6 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$1 >> 2] | 0 | 0) | 0;
      HEAP32[($4 + 40 | 0) >> 2] = 4;
      HEAP32[($4 + 36 | 0) >> 2] = $2 << 3 | 0;
      HEAP32[($4 + 32 | 0) >> 2] = $6;
      break label$5;
     }
     HEAP32[($4 + 32 | 0) >> 2] = 0;
    }
    alloc__raw_vec__finish_grow__h9cca7d8a9459b8aa($4 + 16 | 0 | 0, $3 | 0, $5 | 0, $4 + 32 | 0 | 0, $1 | 0);
    $2 = 1;
    label$7 : {
     if ((HEAP32[($4 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$7
     }
     $2 = HEAP32[($4 + 20 | 0) >> 2] | 0;
     HEAP32[($1 + 4 | 0) >> 2] = (HEAP32[($4 + 24 | 0) >> 2] | 0) >>> 3 | 0;
     HEAP32[$1 >> 2] = $2;
     $2 = 0;
     break label$1;
    }
    $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 + 8 | 0 | 0, HEAP32[($4 + 20 | 0) >> 2] | 0 | 0, HEAP32[($4 + 24 | 0) >> 2] | 0 | 0);
    i64toi32_i32$0 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    $79 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $79;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
    break label$1;
   }
   $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 | 0, $3 | 0, 0 | 0);
   i64toi32_i32$1 = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   $84 = i64toi32_i32$1;
   i64toi32_i32$1 = $0;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $84;
   HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $4 + 48 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___grow_amortized__hbf2698c49cdae023($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $6 = 0, $5 = 0, $79 = 0, $84 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    $3 = $2 + $3 | 0;
    if ($3 >>> 0 < $2 >>> 0) {
     break label$2
    }
    $5 = 4;
    label$3 : {
     label$4 : {
      $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      $6 = $2 << 1 | 0;
      $3 = $6 >>> 0 > $3 >>> 0 ? $6 : $3;
      $3 = $3 >>> 0 > 4 >>> 0 ? $3 : 4;
      if (($3 & 536870911 | 0 | 0) != ($3 | 0)) {
       break label$4
      }
      $3 = $3 << 3 | 0;
      break label$3;
     }
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $5 = 0;
    }
    label$5 : {
     label$6 : {
      if (!$2) {
       break label$6
      }
      $6 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$1 >> 2] | 0 | 0) | 0;
      HEAP32[($4 + 40 | 0) >> 2] = 4;
      HEAP32[($4 + 36 | 0) >> 2] = $2 << 3 | 0;
      HEAP32[($4 + 32 | 0) >> 2] = $6;
      break label$5;
     }
     HEAP32[($4 + 32 | 0) >> 2] = 0;
    }
    alloc__raw_vec__finish_grow__h9cca7d8a9459b8aa($4 + 16 | 0 | 0, $3 | 0, $5 | 0, $4 + 32 | 0 | 0, $1 | 0);
    $2 = 1;
    label$7 : {
     if ((HEAP32[($4 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$7
     }
     $2 = HEAP32[($4 + 20 | 0) >> 2] | 0;
     HEAP32[($1 + 4 | 0) >> 2] = (HEAP32[($4 + 24 | 0) >> 2] | 0) >>> 3 | 0;
     HEAP32[$1 >> 2] = $2;
     $2 = 0;
     break label$1;
    }
    $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 + 8 | 0 | 0, HEAP32[($4 + 20 | 0) >> 2] | 0 | 0, HEAP32[($4 + 24 | 0) >> 2] | 0 | 0);
    i64toi32_i32$0 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    $79 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $79;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
    break label$1;
   }
   $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 | 0, $3 | 0, 0 | 0);
   i64toi32_i32$1 = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   $84 = i64toi32_i32$1;
   i64toi32_i32$1 = $0;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $84;
   HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $4 + 48 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___grow_amortized__hc23632b2480b7636($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $6 = 0, $5 = 0, $79 = 0, $84 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    $3 = $2 + $3 | 0;
    if ($3 >>> 0 < $2 >>> 0) {
     break label$2
    }
    $5 = 1;
    label$3 : {
     label$4 : {
      $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      $6 = $2 << 1 | 0;
      $3 = $6 >>> 0 > $3 >>> 0 ? $6 : $3;
      $3 = $3 >>> 0 > 4 >>> 0 ? $3 : 4;
      if (($3 & 134217727 | 0 | 0) != ($3 | 0)) {
       break label$4
      }
      $3 = $3 << 5 | 0;
      break label$3;
     }
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $5 = 0;
    }
    label$5 : {
     label$6 : {
      if (!$2) {
       break label$6
      }
      $6 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$1 >> 2] | 0 | 0) | 0;
      HEAP32[($4 + 40 | 0) >> 2] = 1;
      HEAP32[($4 + 36 | 0) >> 2] = $2 << 5 | 0;
      HEAP32[($4 + 32 | 0) >> 2] = $6;
      break label$5;
     }
     HEAP32[($4 + 32 | 0) >> 2] = 0;
    }
    alloc__raw_vec__finish_grow__h9cca7d8a9459b8aa($4 + 16 | 0 | 0, $3 | 0, $5 | 0, $4 + 32 | 0 | 0, $1 | 0);
    $2 = 1;
    label$7 : {
     if ((HEAP32[($4 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$7
     }
     $2 = HEAP32[($4 + 20 | 0) >> 2] | 0;
     HEAP32[($1 + 4 | 0) >> 2] = (HEAP32[($4 + 24 | 0) >> 2] | 0) >>> 5 | 0;
     HEAP32[$1 >> 2] = $2;
     $2 = 0;
     break label$1;
    }
    $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 + 8 | 0 | 0, HEAP32[($4 + 20 | 0) >> 2] | 0 | 0, HEAP32[($4 + 24 | 0) >> 2] | 0 | 0);
    i64toi32_i32$0 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    $79 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $79;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
    break label$1;
   }
   $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 | 0, $3 | 0, 0 | 0);
   i64toi32_i32$1 = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   $84 = i64toi32_i32$1;
   i64toi32_i32$1 = $0;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $84;
   HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $4 + 48 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___grow_amortized__hc5a3a0cf02455e39($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $6 = 0, $5 = 0, $79 = 0, $84 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    $3 = $2 + $3 | 0;
    if ($3 >>> 0 < $2 >>> 0) {
     break label$2
    }
    $5 = 1;
    label$3 : {
     label$4 : {
      $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      $6 = $2 << 1 | 0;
      $3 = $6 >>> 0 > $3 >>> 0 ? $6 : $3;
      $3 = $3 >>> 0 > 4 >>> 0 ? $3 : 4;
      if (($3 & 134217727 | 0 | 0) != ($3 | 0)) {
       break label$4
      }
      $3 = $3 << 5 | 0;
      break label$3;
     }
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $T_20as_20core__convert__From_T____from__h76063bbf12759602();
     $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $5 = 0;
    }
    label$5 : {
     label$6 : {
      if (!$2) {
       break label$6
      }
      $6 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$1 >> 2] | 0 | 0) | 0;
      HEAP32[($4 + 40 | 0) >> 2] = 1;
      HEAP32[($4 + 36 | 0) >> 2] = $2 << 5 | 0;
      HEAP32[($4 + 32 | 0) >> 2] = $6;
      break label$5;
     }
     HEAP32[($4 + 32 | 0) >> 2] = 0;
    }
    alloc__raw_vec__finish_grow__h9cca7d8a9459b8aa($4 + 16 | 0 | 0, $3 | 0, $5 | 0, $4 + 32 | 0 | 0, $1 | 0);
    $2 = 1;
    label$7 : {
     if ((HEAP32[($4 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$7
     }
     $2 = HEAP32[($4 + 20 | 0) >> 2] | 0;
     HEAP32[($1 + 4 | 0) >> 2] = (HEAP32[($4 + 24 | 0) >> 2] | 0) >>> 5 | 0;
     HEAP32[$1 >> 2] = $2;
     $2 = 0;
     break label$1;
    }
    $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 + 8 | 0 | 0, HEAP32[($4 + 20 | 0) >> 2] | 0 | 0, HEAP32[($4 + 24 | 0) >> 2] | 0 | 0);
    i64toi32_i32$0 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    $79 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $79;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
    break label$1;
   }
   $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($4 | 0, $3 | 0, 0 | 0);
   i64toi32_i32$1 = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   $84 = i64toi32_i32$1;
   i64toi32_i32$1 = $0;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $84;
   HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $4 + 48 | 0;
 }
 
 function linked_hash_map__LinkedHashMap_K_2cV_2cS___get__hbcb063be5677d464($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $5 = 0, $3 = 0, $9 = 0, $4 = 0, $6 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  i64toi32_i32$0 = hashbrown__map__make_hash__hd0c0e50f69c097de($0 | 0, $1 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $3 = i64toi32_i32$0;
  $4 = (HEAP32[($0 + 16 | 0) >> 2] | 0) & $3 | 0;
  $9 = (HEAP32[($0 + 20 | 0) >> 2] | 0) + $4 | 0;
  $5 = HEAPU8[$9 >> 0] | 0 | ((HEAPU8[($9 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($9 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($9 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $6 = 0;
  HEAP32[($2 + 32 | 0) >> 2] = 0;
  HEAP32[($2 + 36 | 0) >> 2] = $5;
  HEAP32[($2 + 28 | 0) >> 2] = $4;
  HEAP32[($2 + 24 | 0) >> 2] = $0 + 16 | 0;
  $0 = $3 >>> 25 | 0;
  HEAP8[($2 + 44 | 0) >> 0] = $0;
  $0 = $5 ^ Math_imul($0, 16843009) | 0;
  HEAP32[($2 + 40 | 0) >> 2] = (($0 ^ -1 | 0) & ($0 + -16843009 | 0) | 0) & -2139062144 | 0;
  $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($2 + 16 | 0 | 0, $2 + 24 | 0 | 0);
  label$1 : {
   if (!(HEAP32[($2 + 16 | 0) >> 2] | 0)) {
    break label$1
   }
   $3 = $1 + 2 | 0;
   $5 = (HEAP32[((HEAP32[($2 + 24 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) - ((HEAP32[($2 + 20 | 0) >> 2] | 0) << 3 | 0) | 0;
   label$2 : {
    label$3 : while (1) {
     label$4 : {
      $0 = HEAP32[($5 + -8 | 0) >> 2] | 0;
      if ((HEAPU8[$1 >> 0] | 0 | 0) != (HEAPU8[$0 >> 0] | 0 | 0)) {
       break label$4
      }
      if ((HEAPU8[($1 + 1 | 0) >> 0] | 0 | 0) != (HEAPU8[($0 + 1 | 0) >> 0] | 0 | 0)) {
       break label$4
      }
      if (!(memcmp($3 | 0, $0 + 2 | 0 | 0, 28 | 0) | 0)) {
       break label$2
      }
     }
     $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($2 + 8 | 0 | 0, $2 + 24 | 0 | 0);
     if (!(HEAP32[($2 + 8 | 0) >> 2] | 0)) {
      break label$1
     }
     $5 = (HEAP32[((HEAP32[($2 + 24 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) - ((HEAP32[($2 + 12 | 0) >> 2] | 0) << 3 | 0) | 0;
     continue label$3;
    };
   }
   $6 = HEAP32[($5 + -4 | 0) >> 2] | 0;
  }
  global$0 = $2 + 48 | 0;
  return $6 | 0;
 }
 
 function cardano_serialization_lib__tx_builder__TransactionBuilder__get_mint_as_values__hfca4f89cac3bdba6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, $4 = 0, $5 = 0, $5$hi = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  $3 = 2;
  label$1 : {
   if ((HEAP32[($1 + 440 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   $4 = $1 + 444 | 0;
   cardano_serialization_lib__Mint__as_multiasset__hfae7c36e40af3e22($2 + 96 | 0 | 0, $4 | 0, 1 | 0);
   $1 = 0;
   $3 = 0;
   label$2 : {
    if (!(HEAP32[($2 + 104 | 0) >> 2] | 0)) {
     break label$2
    }
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($2 + 60 | 0 | 0, $2 + 96 | 0 | 0);
    $3 = 1;
   }
   HEAP32[($2 + 56 | 0) >> 2] = $3;
   i64toi32_i32$1 = $2;
   i64toi32_i32$0 = 0;
   HEAP32[($2 + 48 | 0) >> 2] = 0;
   HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$0;
   cardano_serialization_lib__Mint__as_multiasset__hfae7c36e40af3e22($2 + 8 | 0 | 0, $4 | 0, 0 | 0);
   i64toi32_i32$0 = 0;
   $5 = 0;
   $5$hi = i64toi32_i32$0;
   label$3 : {
    if (!(HEAP32[($2 + 16 | 0) >> 2] | 0)) {
     break label$3
    }
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($2 + 84 | 0 | 0, $2 + 8 | 0 | 0);
    $1 = 1;
    $3 = HEAP32[($2 + 56 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 52 | 0) >> 2] | 0;
    $5 = i64toi32_i32$0;
    $5$hi = i64toi32_i32$1;
   }
   HEAP32[($2 + 80 | 0) >> 2] = $1;
   i64toi32_i32$0 = $2;
   i64toi32_i32$1 = 0;
   HEAP32[($2 + 72 | 0) >> 2] = 0;
   HEAP32[($2 + 76 | 0) >> 2] = i64toi32_i32$1;
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 8 | 0 | 0);
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 96 | 0 | 0);
   memcpy($2 + 8 | 0 | 0, $2 + 60 | 0 | 0, 36 | 0) | 0;
  }
  HEAP32[($2 + 80 | 0) >> 2] = 0;
  i64toi32_i32$0 = $2;
  i64toi32_i32$1 = 0;
  HEAP32[($2 + 72 | 0) >> 2] = 0;
  HEAP32[($2 + 76 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($2 + 56 | 0) >> 2] = 0;
  i64toi32_i32$0 = $2;
  i64toi32_i32$1 = 0;
  HEAP32[($2 + 48 | 0) >> 2] = 0;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  label$4 : {
   label$5 : {
    if (($3 | 0) != (2 | 0)) {
     break label$5
    }
    memcpy($0 | 0, $2 + 48 | 0 | 0, 48 | 0) | 0;
    break label$4;
   }
   HEAP32[($0 + 8 | 0) >> 2] = $3;
   i64toi32_i32$1 = $5$hi;
   i64toi32_i32$0 = $0;
   HEAP32[i64toi32_i32$0 >> 2] = $5;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   memcpy(i64toi32_i32$0 + 12 | 0 | 0, $2 + 8 | 0 | 0, 36 | 0) | 0;
  }
  global$0 = $2 + 112 | 0;
 }
 
 function $T_20as_20bech32__ToBase32___write_base32__h3133b77327a53204($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $5 = 0, $2 = 0, $3 = 0, $7 = 0, $4 = 0, $6 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $0 | 0);
  core__slice__iter___impl_20core__iter__traits__collect__IntoIterator_20for_20__5bT_5d___into_iter__hc96cff628f84e170($2 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  label$1 : {
   label$2 : {
    $3 = HEAP32[$2 >> 2] | 0;
    $4 = HEAP32[($2 + 4 | 0) >> 2] | 0;
    if (($3 | 0) != ($4 | 0)) {
     break label$2
    }
    $5 = 0;
    break label$1;
   }
   $5 = 0;
   $0 = 0;
   label$3 : {
    label$4 : {
     label$5 : while (1) {
      $6 = HEAPU8[$3 >> 0] | 0;
      label$6 : {
       label$7 : {
        if ($5 >>> 0 >= 5 >>> 0) {
         break label$7
        }
        $7 = $5;
        break label$6;
       }
       if ($alloc__vec__Vec_bech32__u5__20as_20bech32__WriteBase32___write_u5__hb515549aebcd01f1($1 | 0, ($0 & 248 | 0) >>> 3 | 0 | 0) | 0) {
        break label$4
       }
       $7 = $5 + -5 | 0;
       $0 = $0 << 5 | 0;
      }
      $5 = $7 + 3 | 0;
      if ($alloc__vec__Vec_bech32__u5__20as_20bech32__WriteBase32___write_u5__hb515549aebcd01f1($1 | 0, ($6 & 255 | 0) >>> ($5 & 7 | 0) | 0 | (($0 & 248 | 0) >>> 3 | 0) | 0 | 0) | 0) {
       break label$4
      }
      $0 = $6 << ((5 - $7 | 0) & 7 | 0) | 0;
      $3 = $3 + 1 | 0;
      if (($4 | 0) == ($3 | 0)) {
       break label$3
      }
      continue label$5;
     };
    }
    $5 = 1;
    break label$1;
   }
   $5 = 1;
   label$8 : {
    if ($7 >>> 0 <= 1 >>> 0) {
     break label$8
    }
    if ($alloc__vec__Vec_bech32__u5__20as_20bech32__WriteBase32___write_u5__hb515549aebcd01f1($1 | 0, ($0 & 248 | 0) >>> 3 | 0 | 0) | 0) {
     break label$1
    }
    $5 = 0;
    if (($7 | 0) == (2 | 0)) {
     break label$1
    }
    $0 = $0 << 5 | 0;
   }
   $0 = $alloc__vec__Vec_bech32__u5__20as_20bech32__WriteBase32___write_u5__hb515549aebcd01f1($1 | 0, ($0 & 248 | 0) >>> 3 | 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return $0 | 0;
  }
  global$0 = $2 + 16 | 0;
  return $5 | 0;
 }
 
 function $cardano_serialization_lib__legacy_address__address__ExtendedAddr_20as_20core__str__traits__FromStr___from_str__h32affa00e2d5d659($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$1 = 0, $4 = 0, $5 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0, wasm2js_i32$2 = 0;
  $3 = global$0 - 128 | 0;
  global$0 = $3;
  cardano_serialization_lib__legacy_address__base58__decode__h2aded2be1d6e51f0($3 + 24 | 0 | 0, $1 | 0, $2 | 0);
  $1 = (HEAP32[($3 + 24 | 0) >> 2] | 0 | 0) == (1 | 0);
  $2 = (wasm2js_i32$0 = 1, wasm2js_i32$1 = HEAP32[(($3 + 24 | 0) + 8 | 0) >> 2] | 0, wasm2js_i32$2 = $1, wasm2js_i32$2 ? wasm2js_i32$0 : wasm2js_i32$1);
  $4 = HEAP32[($3 + 28 | 0) >> 2] | 0;
  $5 = (wasm2js_i32$0 = $4, wasm2js_i32$1 = HEAP32[(($3 + 24 | 0) + 12 | 0) >> 2] | 0, wasm2js_i32$2 = $1, wasm2js_i32$2 ? wasm2js_i32$0 : wasm2js_i32$1);
  label$1 : {
   label$2 : {
    if ($1) {
     break label$2
    }
    HEAP32[($3 + 16 | 0) >> 2] = $5;
    HEAP32[($3 + 12 | 0) >> 2] = $2;
    HEAP32[($3 + 8 | 0) >> 2] = $4;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 | 0, $3 + 8 | 0 | 0);
    i64toi32_i32$1 = HEAP32[($3 + 4 | 0) >> 2] | 0;
    HEAP32[($3 + 88 | 0) >> 2] = HEAP32[$3 >> 2] | 0;
    HEAP32[($3 + 92 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    HEAP32[($3 + 80 | 0) >> 2] = 0;
    HEAP32[($3 + 84 | 0) >> 2] = i64toi32_i32$1;
    $cardano_serialization_lib__legacy_address__address__ExtendedAddr_20as_20cbor_event__de__Deserialize___deserialize__h3aca879b445064c1($3 + 24 | 0 | 0, $3 + 80 | 0 | 0);
    label$3 : {
     label$4 : {
      if ((HEAP32[($3 + 24 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      memcpy($0 + 4 | 0 | 0, $3 + 24 | 0 | 4 | 0 | 0, 52 | 0) | 0;
      $1 = 0;
      break label$3;
     }
     memcpy($3 + 84 | 0 | 0, ($3 + 24 | 0) + 8 | 0 | 0, 40 | 0) | 0;
     HEAP32[($0 + 8 | 0) >> 2] = 0;
     memcpy($0 + 12 | 0 | 0, $3 + 80 | 0 | 0, 44 | 0) | 0;
     $1 = 1;
    }
    HEAP32[$0 >> 2] = $1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 8 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 8 | 0 | 0);
    break label$1;
   }
   HEAP32[$0 >> 2] = 1;
   HEAP32[($0 + 12 | 0) >> 2] = $5;
   HEAP32[($0 + 8 | 0) >> 2] = $2;
  }
  global$0 = $3 + 128 | 0;
 }
 
 function cardano_serialization_lib__StakeRegistration__from_bytes__hdee97b658c0439d9($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $2 = 0, $16 = 0, $17 = 0, $19 = 0, $20 = 0, $21 = 0, $3 = 0, $4 = 0, $5 = 0, $18 = 0, $37 = 0, $45 = 0, $4$hi = 0, $5$hi = 0, $61 = 0, $65 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[(($2 + 152 | 0) + 16 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[(i64toi32_i32$1 + 152 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[(i64toi32_i32$0 + 160 | 0) >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 164 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__StakeRegistration___deserialize__hef7d0796e9b28850(i64toi32_i32$0 + 80 | 0 | 0, i64toi32_i32$0 + 152 | 0 | 0);
  $1 = (i64toi32_i32$0 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAPU8[(i64toi32_i32$0 + 80 | 0) >> 0] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = $2 + 29 | 0;
    i64toi32_i32$2 = ($2 + 80 | 0) + 22 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $37 = i64toi32_i32$1;
    i64toi32_i32$1 = $1;
    $16 = $37;
    HEAP8[i64toi32_i32$1 >> 0] = $16;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $16 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $16 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $16 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    $3 = ($2 + 8 | 0) + 16 | 0;
    i64toi32_i32$2 = ($2 + 80 | 0) + 17 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $45 = i64toi32_i32$0;
    i64toi32_i32$0 = $3;
    HEAP32[i64toi32_i32$0 >> 2] = $45;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = ($2 + 80 | 0) + 9 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $4 = i64toi32_i32$1;
    $4$hi = i64toi32_i32$0;
    i64toi32_i32$1 = ($2 + 8 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $4;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 81 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 82 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 83 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 84 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 85 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 86 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 87 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 88 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $5 = i64toi32_i32$0;
    $5$hi = i64toi32_i32$1;
    i64toi32_i32$0 = i64toi32_i32$2;
    HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $5;
    HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $61 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 22 | 0;
    $17 = $61;
    HEAP8[i64toi32_i32$1 >> 0] = $17;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $65 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 17 | 0;
    $19 = $65;
    HEAP8[i64toi32_i32$0 >> 0] = $19;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $19 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $19 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $19 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$1 = $4$hi;
    i64toi32_i32$0 = $0 + 9 | 0;
    $20 = $4;
    HEAP8[i64toi32_i32$0 >> 0] = $20;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $20 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $20 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $20 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$1 = $5$hi;
    i64toi32_i32$0 = $0;
    $21 = $5;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $21;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $21 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $21 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = $21 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 8 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 8 | 0 | 7 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0 + 4 | 0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[wasm2js_i32$0 >> 2] = wasm2js_i32$1;
  }
  HEAP8[$0 >> 0] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__StakeDeregistration__from_bytes__ha9403776c649dbb2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $2 = 0, $16 = 0, $17 = 0, $19 = 0, $20 = 0, $21 = 0, $3 = 0, $4 = 0, $5 = 0, $18 = 0, $37 = 0, $45 = 0, $4$hi = 0, $5$hi = 0, $61 = 0, $65 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[(($2 + 152 | 0) + 16 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[(i64toi32_i32$1 + 152 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[(i64toi32_i32$0 + 160 | 0) >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 164 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__StakeDeregistration___deserialize__h63747b9459f1aff0(i64toi32_i32$0 + 80 | 0 | 0, i64toi32_i32$0 + 152 | 0 | 0);
  $1 = (i64toi32_i32$0 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAPU8[(i64toi32_i32$0 + 80 | 0) >> 0] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = $2 + 29 | 0;
    i64toi32_i32$2 = ($2 + 80 | 0) + 22 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $37 = i64toi32_i32$1;
    i64toi32_i32$1 = $1;
    $16 = $37;
    HEAP8[i64toi32_i32$1 >> 0] = $16;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $16 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $16 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $16 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    $3 = ($2 + 8 | 0) + 16 | 0;
    i64toi32_i32$2 = ($2 + 80 | 0) + 17 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $45 = i64toi32_i32$0;
    i64toi32_i32$0 = $3;
    HEAP32[i64toi32_i32$0 >> 2] = $45;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = ($2 + 80 | 0) + 9 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $4 = i64toi32_i32$1;
    $4$hi = i64toi32_i32$0;
    i64toi32_i32$1 = ($2 + 8 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $4;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 81 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 82 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 83 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 84 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 85 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 86 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 87 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 88 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $5 = i64toi32_i32$0;
    $5$hi = i64toi32_i32$1;
    i64toi32_i32$0 = i64toi32_i32$2;
    HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $5;
    HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $61 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 22 | 0;
    $17 = $61;
    HEAP8[i64toi32_i32$1 >> 0] = $17;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $65 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 17 | 0;
    $19 = $65;
    HEAP8[i64toi32_i32$0 >> 0] = $19;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $19 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $19 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $19 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$1 = $4$hi;
    i64toi32_i32$0 = $0 + 9 | 0;
    $20 = $4;
    HEAP8[i64toi32_i32$0 >> 0] = $20;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $20 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $20 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $20 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$1 = $5$hi;
    i64toi32_i32$0 = $0;
    $21 = $5;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $21;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $21 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $21 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = $21 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 8 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 8 | 0 | 7 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0 + 4 | 0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[wasm2js_i32$0 >> 2] = wasm2js_i32$1;
  }
  HEAP8[$0 >> 0] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__metadata__encode_arbitrary_bytes_as_metadatum__hff9e33a1e55fca03($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $5 = 0, $6 = 0, $4 = 0;
  $3 = global$0 - 128 | 0;
  global$0 = $3;
  HEAP32[($3 + 12 | 0) >> 2] = 0;
  HEAP32[($3 + 16 | 0) >> 2] = 0;
  HEAP32[($3 + 8 | 0) >> 2] = HEAP32[(0 + 1059252 | 0) >> 2] | 0;
  label$1 : {
   label$2 : {
    if (!$2) {
     break label$2
    }
    $4 = $3 + 80 | 0;
    label$3 : while (1) {
     $5 = $2 >>> 0 < 64 >>> 0 ? $2 : 64;
     alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($3 | 0, $5 | 0, 0 | 0);
     HEAP32[($3 + 28 | 0) >> 2] = HEAP32[($3 + 4 | 0) >> 2] | 0;
     $6 = HEAP32[$3 >> 2] | 0;
     HEAP32[($3 + 24 | 0) >> 2] = $6;
     memcpy($6 | 0, $1 | 0, $5 | 0) | 0;
     HEAP32[($3 + 32 | 0) >> 2] = $5;
     cardano_serialization_lib__metadata__TransactionMetadatum__new_bytes__h341a06dfb4f1da88($3 + 72 | 0 | 0, $3 + 24 | 0 | 0);
     if ((HEAP32[($3 + 72 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$1
     }
     memcpy($3 + 24 | 0 | 0, $4 | 0, 48 | 0) | 0;
     $1 = $1 + $5 | 0;
     cardano_serialization_lib__metadata__MetadataList__add__h35547ae43e0f3988($3 + 8 | 0 | 0, $3 + 24 | 0 | 0);
     core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatum___headd2d1b596252cc($3 + 24 | 0 | 0);
     $2 = $2 - $5 | 0;
     if ($2) {
      continue label$3
     }
     break label$3;
    };
   }
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hf69db734dd831996($0 + 4 | 0 | 0, $3 + 8 | 0 | 0);
   HEAP32[$0 >> 2] = 1;
   label$4 : {
    $2 = HEAP32[($3 + 16 | 0) >> 2] | 0;
    if (!$2) {
     break label$4
    }
    $5 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    $2 = Math_imul($2, 48);
    label$5 : while (1) {
     core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatum___headd2d1b596252cc_2($5 | 0);
     $5 = $5 + 48 | 0;
     $2 = $2 + -48 | 0;
     if ($2) {
      continue label$5
     }
     break label$5;
    };
   }
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h81b8a37e31f2de30($3 + 8 | 0 | 0);
   global$0 = $3 + 128 | 0;
   return;
  }
  HEAP32[($3 + 24 | 0) >> 2] = HEAP32[($3 + 76 | 0) >> 2] | 0;
  core__result__unwrap_failed__h27f43d993c3864a1(1059176 | 0, 43 | 0, $3 + 24 | 0 | 0, 1059236 | 0, 1060592 | 0);
  abort();
 }
 
 function alloc__vec__Vec_T_2cA___extend_desugared__hc27dc4ae999dc1e4($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $3 = 0, i64toi32_i32$1 = 0, $2 = 0, $5 = 0, $22 = 0, $12 = 0, $23 = 0, $24 = 0, $25 = 0, $26 = 0, $27 = 0, $4 = 0, $6 = 0, $7 = 0, $8 = 0, $9 = 0, $10 = 0, $43 = 0, $47 = 0, $55 = 0, $11 = 0, $85 = 0, $89 = 0, $93 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  label$1 : {
   $3 = HEAP32[$1 >> 2] | 0;
   $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   if (($3 | 0) == ($4 | 0)) {
    break label$1
   }
   $5 = (HEAP32[($1 + 8 | 0) >> 2] | 0) + -1 | 0;
   $6 = $2 + 8 | 0;
   $7 = $2 + 16 | 0;
   $8 = $2 + 24 | 0;
   label$2 : while (1) {
    HEAP32[($1 + 8 | 0) >> 2] = $5;
    $9 = HEAP32[($3 + 12 | 0) >> 2] | 0;
    HEAP32[$1 >> 2] = $9;
    $10 = HEAPU8[($3 + 16 | 0) >> 0] | 0;
    i64toi32_i32$2 = $3 + 26 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $43 = i64toi32_i32$0;
    i64toi32_i32$0 = $6;
    HEAP32[i64toi32_i32$0 >> 2] = $43;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $3 + 34 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $47 = i64toi32_i32$1;
    i64toi32_i32$1 = $7;
    HEAP32[i64toi32_i32$1 >> 2] = $47;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    $22 = $3 + 42 | 0;
    HEAP32[$8 >> 2] = HEAPU8[$22 >> 0] | 0 | ((HEAPU8[($22 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($22 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($22 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$2 = $3 + 18 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $55 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[i64toi32_i32$0 >> 2] = $55;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    $11 = HEAPU8[($3 + 17 | 0) >> 0] | 0;
    label$3 : {
     $12 = HEAP32[($0 + 8 | 0) >> 2] | 0;
     if ((HEAP32[($0 + 4 | 0) >> 2] | 0 | 0) != ($12 | 0)) {
      break label$3
     }
     $3 = $5 + 1 | 0;
     alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hf7d7cca00a09c6e3($0 | 0, $12 | 0, ($3 >>> 0 < $5 >>> 0 ? -1 : $3) | 0);
    }
    $3 = (HEAP32[$0 >> 2] | 0) + Math_imul($12, 30) | 0;
    HEAP8[($3 + 1 | 0) >> 0] = $11;
    HEAP8[$3 >> 0] = $10;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $85 = i64toi32_i32$1;
    i64toi32_i32$1 = $3;
    $23 = $85;
    HEAP8[($3 + 2 | 0) >> 0] = $23;
    HEAP8[($3 + 3 | 0) >> 0] = $23 >>> 8 | 0;
    HEAP8[($3 + 4 | 0) >> 0] = $23 >>> 16 | 0;
    HEAP8[($3 + 5 | 0) >> 0] = $23 >>> 24 | 0;
    HEAP8[($3 + 6 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[($3 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[($3 + 8 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[($3 + 9 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$2 = $6;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $89 = i64toi32_i32$0;
    i64toi32_i32$0 = $3 + 10 | 0;
    $24 = $89;
    HEAP8[i64toi32_i32$0 >> 0] = $24;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $24 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $24 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $24 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$2 = $7;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $93 = i64toi32_i32$1;
    i64toi32_i32$1 = $3 + 18 | 0;
    $25 = $93;
    HEAP8[i64toi32_i32$1 >> 0] = $25;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $25 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $25 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $25 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    $26 = $3 + 26 | 0;
    $27 = HEAP32[$8 >> 2] | 0;
    HEAP8[$26 >> 0] = $27;
    HEAP8[($26 + 1 | 0) >> 0] = $27 >>> 8 | 0;
    HEAP8[($26 + 2 | 0) >> 0] = $27 >>> 16 | 0;
    HEAP8[($26 + 3 | 0) >> 0] = $27 >>> 24 | 0;
    HEAP32[($0 + 8 | 0) >> 2] = $12 + 1 | 0;
    $5 = $5 + -1 | 0;
    $3 = $9;
    if (($3 | 0) != ($4 | 0)) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $2 + 64 | 0;
 }
 
 function cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__add_key_input__hcbbcffc3c6e022ad($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, $6 = 0, $23 = 0, $8 = 0, $9 = 0, $7 = 0, $7$hi = 0, $5 = 0, $8$hi = 0, $9$hi = 0, $48 = 0, $53 = 0, $58 = 0, $63 = 0, $83 = 0, $87 = 0, $90 = 0;
  $4 = global$0 - 112 | 0;
  global$0 = $4;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  $5 = HEAP32[$2 >> 2] | 0;
  $6 = 0;
  label$1 : {
   if ((HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($4 + 16 | 0 | 4 | 0 | 0, $3 + 12 | 0 | 0);
   $6 = 1;
  }
  $3 = ($4 + 16 | 0) + 8 | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$1;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$1 = $4 + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $8;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($4 + 16 | 0) >> 2] = $6;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[($4 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($4 + 20 | 0) >> 2] | 0;
  $9 = i64toi32_i32$0;
  $9$hi = i64toi32_i32$1;
  i64toi32_i32$0 = $4;
  HEAP32[i64toi32_i32$0 >> 2] = $9;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $6 = (i64toi32_i32$0 + 16 | 0) + 16 | 0;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = $6;
  HEAP32[i64toi32_i32$0 >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  $48 = i64toi32_i32$1;
  i64toi32_i32$1 = ($4 + 16 | 0) + 28 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $48;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = i64toi32_i32$2 + 12 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $53 = i64toi32_i32$0;
  i64toi32_i32$0 = $4 + 52 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $53;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2 + 20 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $58 = i64toi32_i32$1;
  i64toi32_i32$1 = $4 + 60 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $58;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2 + 28 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $63 = i64toi32_i32$0;
  i64toi32_i32$0 = $4 + 68 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $63;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$0 = $4;
  HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = $9;
  HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 80 | 0) >> 0] = 0;
  HEAP32[(i64toi32_i32$0 + 40 | 0) >> 2] = $5;
  i64toi32_i32$1 = $7$hi;
  HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__push_input__h5d706b01e1a860c0($0 | 0, i64toi32_i32$0 + 16 | 0 | 0);
  $23 = $1 + 24 | 0;
  HEAP32[((i64toi32_i32$0 + 16 | 0) + 24 | 0) >> 2] = HEAPU8[$23 >> 0] | 0 | ((HEAPU8[($23 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($23 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($23 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $83 = i64toi32_i32$1;
  i64toi32_i32$1 = $6;
  HEAP32[i64toi32_i32$1 >> 2] = $83;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $87 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $87;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $90 = i64toi32_i32$1;
  i64toi32_i32$1 = $4;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $90;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  alloc__collections__btree__map__BTreeMap_K_2cV___insert__h5d8c7a7452747b0f($0 + 40 | 0 | 0, i64toi32_i32$1 + 16 | 0 | 0) | 0;
  global$0 = i64toi32_i32$1 + 112 | 0;
 }
 
 function cardano_serialization_lib__address__StakeCredential__from_bytes__h502bac6f177f7d17($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $2 = 0, $16 = 0, $17 = 0, $19 = 0, $20 = 0, $21 = 0, $3 = 0, $4 = 0, $5 = 0, $18 = 0, $37 = 0, $45 = 0, $4$hi = 0, $5$hi = 0, $61 = 0, $65 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[(($2 + 152 | 0) + 16 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[(i64toi32_i32$1 + 152 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[(i64toi32_i32$0 + 160 | 0) >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 164 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__address__StakeCredential_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__ha21a31a5230d4f02(i64toi32_i32$0 + 80 | 0 | 0, i64toi32_i32$0 + 152 | 0 | 0);
  $1 = (i64toi32_i32$0 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAPU8[(i64toi32_i32$0 + 80 | 0) >> 0] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = $2 + 29 | 0;
    i64toi32_i32$2 = ($2 + 80 | 0) + 22 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $37 = i64toi32_i32$1;
    i64toi32_i32$1 = $1;
    $16 = $37;
    HEAP8[i64toi32_i32$1 >> 0] = $16;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $16 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $16 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $16 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    $3 = ($2 + 8 | 0) + 16 | 0;
    i64toi32_i32$2 = ($2 + 80 | 0) + 17 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $45 = i64toi32_i32$0;
    i64toi32_i32$0 = $3;
    HEAP32[i64toi32_i32$0 >> 2] = $45;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = ($2 + 80 | 0) + 9 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $4 = i64toi32_i32$1;
    $4$hi = i64toi32_i32$0;
    i64toi32_i32$1 = ($2 + 8 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $4;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 81 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 82 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 83 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 84 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 85 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 86 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 87 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 88 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $5 = i64toi32_i32$0;
    $5$hi = i64toi32_i32$1;
    i64toi32_i32$0 = i64toi32_i32$2;
    HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $5;
    HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $61 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 22 | 0;
    $17 = $61;
    HEAP8[i64toi32_i32$1 >> 0] = $17;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $65 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 17 | 0;
    $19 = $65;
    HEAP8[i64toi32_i32$0 >> 0] = $19;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $19 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $19 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $19 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$1 = $4$hi;
    i64toi32_i32$0 = $0 + 9 | 0;
    $20 = $4;
    HEAP8[i64toi32_i32$0 >> 0] = $20;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $20 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $20 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $20 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$1 = $5$hi;
    i64toi32_i32$0 = $0;
    $21 = $5;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $21;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $21 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $21 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = $21 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 8 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 8 | 0 | 7 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0 + 4 | 0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[wasm2js_i32$0 >> 2] = wasm2js_i32$1;
  }
  HEAP8[$0 >> 0] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__address__ByronAddress__from_address__hda2f43a52fcf6ed4($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $2 = 0, $3 = 0, $17 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $23 = 0, $4 = 0, $22 = 0, $27 = 0, $31 = 0, $4$hi = 0, $5 = 0, $5$hi = 0, $57 = 0, $63 = 0, $69 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if ((HEAPU8[$1 >> 0] | 0 | 0) != (4 | 0)) {
     break label$2
    }
    $17 = $1 + 48 | 0;
    HEAP32[(($2 + 16 | 0) + 24 | 0) >> 2] = HEAPU8[$17 >> 0] | 0 | ((HEAPU8[($17 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($17 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($17 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$2 = $1 + 40 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $22 = i64toi32_i32$0;
    i64toi32_i32$0 = $2 + 32 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $22;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $1 + 32 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $27 = i64toi32_i32$1;
    i64toi32_i32$1 = $2 + 24 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $27;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $1 + 24 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $31 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $31;
    HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$1;
    label$3 : {
     label$4 : {
      $3 = $1 + 4 | 0;
      if (HEAP32[$3 >> 2] | 0) {
       break label$4
      }
      HEAP32[($2 + 48 | 0) >> 2] = 0;
      break label$3;
     }
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($2 + 48 | 0 | 0, $3 | 0);
    }
    $3 = HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] | 0;
    HEAP32[($2 + 8 | 0) >> 2] = $3;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] | 0;
    $4 = i64toi32_i32$1;
    $4$hi = i64toi32_i32$0;
    i64toi32_i32$1 = i64toi32_i32$2;
    HEAP32[i64toi32_i32$2 >> 2] = $4;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $1 + 16 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $5 = i64toi32_i32$0;
    $5$hi = i64toi32_i32$1;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
    $57 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 20 | 0;
    $18 = $57;
    HEAP8[i64toi32_i32$1 >> 0] = $18;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $18 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $18 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $18 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$2 = (i64toi32_i32$2 + 16 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $63 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 28 | 0;
    $19 = $63;
    HEAP8[i64toi32_i32$0 >> 0] = $19;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $19 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $19 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $19 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$2 = ($2 + 16 | 0) + 16 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $69 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 36 | 0;
    $20 = $69;
    HEAP8[i64toi32_i32$1 >> 0] = $20;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $20 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $20 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $20 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    $21 = $0 + 44 | 0;
    $23 = HEAP32[($2 + 40 | 0) >> 2] | 0;
    HEAP8[$21 >> 0] = $23;
    HEAP8[($21 + 1 | 0) >> 0] = $23 >>> 8 | 0;
    HEAP8[($21 + 2 | 0) >> 0] = $23 >>> 16 | 0;
    HEAP8[($21 + 3 | 0) >> 0] = $23 >>> 24 | 0;
    $1 = HEAPU8[($1 + 52 | 0) >> 0] | 0;
    HEAP32[($0 + 8 | 0) >> 2] = $3;
    i64toi32_i32$0 = $4$hi;
    i64toi32_i32$1 = $0;
    HEAP32[i64toi32_i32$1 >> 2] = $4;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 48 | 0) >> 0] = $1;
    i64toi32_i32$0 = $5$hi;
    HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = $5;
    HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = i64toi32_i32$0;
    break label$1;
   }
   HEAP32[($0 + 12 | 0) >> 2] = 2;
  }
  global$0 = $2 + 64 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__KV___split__hd298a51c17ba56b1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $7 = 0, $5 = 0, $4 = 0, $2 = 0, $6 = 0, $3 = 0, $8 = 0, $72 = 0, $80 = 0, $86 = 0, $92 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $4 = HEAPU16[($3 + 226 | 0) >> 1] | 0;
  $5 = alloc__boxed__Box_T_2cA___new_uninit_in__h2752ff92eca24da1() | 0;
  HEAP16[($5 + 226 | 0) >> 1] = 0;
  HEAP32[($5 + 88 | 0) >> 2] = 0;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__h950f9a694dc32efd($2 + 8 | 0 | 0, $1 | 0, $5 | 0);
  $6 = HEAPU16[($5 + 226 | 0) >> 1] | 0;
  $7 = $6 + 1 | 0;
  label$1 : {
   label$2 : {
    if ($6 >>> 0 >= 12 >>> 0) {
     break label$2
    }
    $8 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    $4 = $4 - $8 | 0;
    if (($4 | 0) != ($7 | 0)) {
     break label$1
    }
    memcpy($5 + 232 | 0 | 0, (($8 << 2 | 0) + $3 | 0) + 236 | 0 | 0, $4 << 2 | 0 | 0) | 0;
    $3 = HEAP32[$1 >> 2] | 0;
    $7 = 0;
    label$3 : {
     label$4 : while (1) {
      $4 = HEAP32[(($5 + ($7 << 2 | 0) | 0) + 232 | 0) >> 2] | 0;
      HEAP16[($4 + 224 | 0) >> 1] = $7;
      HEAP32[($4 + 88 | 0) >> 2] = $5;
      if ($7 >>> 0 >= $6 >>> 0) {
       break label$3
      }
      $7 = $7 + ($7 >>> 0 < $6 >>> 0) | 0;
      if ($7 >>> 0 <= $6 >>> 0) {
       continue label$4
      }
      break label$4;
     };
    }
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
    $72 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[i64toi32_i32$0 >> 2] = $72;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] = $3;
    HEAP32[(i64toi32_i32$0 + 36 | 0) >> 2] = $5;
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $80 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = $80;
    HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = ($2 + 8 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $86 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $86;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = ($2 + 8 | 0) + 16 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $92 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 16 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $92;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    global$0 = $2 + 32 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($7 | 0, 12 | 0, 1049060 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1048988 | 0, 40 | 0, 1049028 | 0);
  abort();
 }
 
 function operationalcert_new($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, $5 = 0, $6 = 0, $7 = 0, $31 = 0, $38 = 0, $45 = 0, $48 = 0, $70 = 0, $75 = 0, $79 = 0, $86 = 0;
  $4 = global$0 - 224 | 0;
  global$0 = $4;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h78f278b481f170f8($4 + 16 | 0 | 0, $0 | 0);
   if (!$3) {
    break label$1
   }
   $5 = HEAP32[($4 + 20 | 0) >> 2] | 0;
   $0 = HEAP32[($4 + 16 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hd6fdee4274fe58a2($4 + 8 | 0 | 0, $3 | 0);
   $3 = ($4 + 88 | 0) + 8 | 0;
   i64toi32_i32$2 = $0 + 8 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $31 = i64toi32_i32$0;
   i64toi32_i32$0 = $3;
   HEAP32[i64toi32_i32$0 >> 2] = $31;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   $6 = ($4 + 88 | 0) + 16 | 0;
   i64toi32_i32$2 = $0 + 16 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $38 = i64toi32_i32$1;
   i64toi32_i32$1 = $6;
   HEAP32[i64toi32_i32$1 >> 2] = $38;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   $7 = ($4 + 88 | 0) + 24 | 0;
   i64toi32_i32$2 = $0 + 24 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $45 = i64toi32_i32$0;
   i64toi32_i32$0 = $7;
   HEAP32[i64toi32_i32$0 >> 2] = $45;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $48 = i64toi32_i32$1;
   i64toi32_i32$1 = $4;
   HEAP32[($4 + 88 | 0) >> 2] = $48;
   HEAP32[($4 + 92 | 0) >> 2] = i64toi32_i32$0;
   $0 = HEAP32[($4 + 12 | 0) >> 2] | 0;
   memcpy($4 + 24 | 0 | 0, HEAP32[($4 + 8 | 0) >> 2] | 0 | 0, 64 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($5 | 0, (HEAP32[$5 >> 2] | 0) + -1 | 0 | 0) | 0;
   i64toi32_i32$2 = $3;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $70 = i64toi32_i32$0;
   i64toi32_i32$0 = ($4 + 120 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $70;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $6;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $75 = i64toi32_i32$1;
   i64toi32_i32$1 = ($4 + 120 | 0) + 24 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $75;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $7;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $79 = i64toi32_i32$0;
   i64toi32_i32$0 = $4 + 152 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $79;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($4 + 124 | 0) >> 2] = $2;
   HEAP32[($4 + 120 | 0) >> 2] = $1;
   i64toi32_i32$2 = $4;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 88 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 92 | 0) >> 2] | 0;
   $86 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$2 + 128 | 0) >> 2] = $86;
   HEAP32[(i64toi32_i32$2 + 132 | 0) >> 2] = i64toi32_i32$0;
   memcpy(i64toi32_i32$2 + 160 | 0 | 0, i64toi32_i32$2 + 24 | 0 | 0, 64 | 0) | 0;
   $0 = $cardano_serialization_lib__OperationalCert_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h6c0829dce15a5d37(i64toi32_i32$2 + 120 | 0 | 0) | 0;
   global$0 = i64toi32_i32$2 + 224 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function $core__iter__adapters__map__Map_I_2cF__20as_20core__iter__traits__iterator__Iterator___try_fold__h8ec3b98286b2809b($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $5 = 0, $4 = 0, $8 = 0, $9 = 0, $10 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $6 = 0, $7 = 0, $48 = 0, $54 = 0, $57 = 0, $81 = 0, $86 = 0, $91 = 0;
  $4 = global$0 - 64 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    $5 = HEAP32[$1 >> 2] | 0;
    $6 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (($5 | 0) == ($6 | 0)) {
     break label$2
    }
    $7 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    $8 = $4 + 41 | 0;
    label$3 : {
     label$4 : {
      label$5 : while (1) {
       $9 = $5 + 48 | 0;
       HEAP32[$1 >> 2] = $9;
       cardano_serialization_lib__metadata__decode_metadatum_to_json_value__h971c762f0ec03432($4 + 32 | 0 | 0, $5 | 0, HEAPU8[$7 >> 0] | 0 | 0);
       if ((HEAP32[($4 + 32 | 0) >> 2] | 0 | 0) == (1 | 0)) {
        break label$4
       }
       label$6 : {
        $10 = HEAPU8[($4 + 40 | 0) >> 0] | 0;
        $5 = $10 & 255 | 0;
        if (($5 | 0) == (6 | 0)) {
         break label$6
        }
        i64toi32_i32$2 = $8 + 15 | 0;
        i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $48 = i64toi32_i32$0;
        i64toi32_i32$0 = ($4 + 8 | 0) + 15 | 0;
        $20 = $48;
        HEAP8[i64toi32_i32$0 >> 0] = $20;
        HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $20 >>> 8 | 0;
        HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $20 >>> 16 | 0;
        HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $20 >>> 24 | 0;
        HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
        HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
        HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
        HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
        i64toi32_i32$2 = $8 + 8 | 0;
        i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $54 = i64toi32_i32$1;
        i64toi32_i32$1 = ($4 + 8 | 0) + 8 | 0;
        HEAP32[i64toi32_i32$1 >> 2] = $54;
        HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
        i64toi32_i32$2 = $8;
        i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
        $57 = i64toi32_i32$0;
        i64toi32_i32$0 = $4;
        HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $57;
        HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
        if (($5 | 0) != (7 | 0)) {
         break label$3
        }
       }
       $5 = $9;
       if (($6 | 0) == ($5 | 0)) {
        break label$2
       }
       continue label$5;
      };
     }
     $9 = HEAP32[($4 + 36 | 0) >> 2] | 0;
     label$7 : {
      $5 = HEAP32[$3 >> 2] | 0;
      if (!(HEAP32[$5 >> 2] | 0)) {
       break label$7
      }
      $8 = HEAP32[($5 + 4 | 0) >> 2] | 0;
      if ($8 >>> 0 < 36 >>> 0) {
       break label$7
      }
      wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($8 | 0);
     }
     HEAP32[($5 + 4 | 0) >> 2] = $9;
     HEAP32[$5 >> 2] = 1;
     $10 = 6;
    }
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
    $81 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    $21 = $81;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $21;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $21 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $21 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = $21 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 8 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$2 = i64toi32_i32$2 + 23 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $86 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 16 | 0;
    $22 = $86;
    HEAP8[i64toi32_i32$0 >> 0] = $22;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $22 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $22 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $22 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$2 = $4 + 16 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $91 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 9 | 0;
    $23 = $91;
    HEAP8[i64toi32_i32$1 >> 0] = $23;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $23 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $23 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $23 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    break label$1;
   }
   $10 = 7;
  }
  HEAP8[$0 >> 0] = $10;
  global$0 = $4 + 64 | 0;
 }
 
 function cardano_serialization_lib__crypto__Bip32PublicKey__from_bech32__ha71313b99f940ee4($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $13 = 0, $14 = 0, $15 = 0, $4 = 0, $4$hi = 0, $5 = 0, $5$hi = 0, $6 = 0, $6$hi = 0;
  $3 = global$0 - 192 | 0;
  global$0 = $3;
  $cardano_serialization_lib__chain_crypto__key__PublicKey_A__20as_20cardano_serialization_lib__chain_crypto__bech32__Bech32___try_from_bech32_str__h43e4355a7c74c377($3 + 72 | 0 | 0, $1 | 0, $2 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAPU8[($3 + 72 | 0) >> 0] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    memcpy($3 + 8 | 0 | 0, $3 + 72 | 0 | 1 | 0 | 0, 64 | 0) | 0;
    memcpy($0 + 1 | 0 | 0, $3 + 8 | 0 | 0, 64 | 0) | 0;
    $1 = 0;
    break label$1;
   }
   $2 = $3 + 92 | 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $4 = i64toi32_i32$0;
   $4$hi = i64toi32_i32$1;
   i64toi32_i32$0 = $3 + 27 | 0;
   $13 = $4;
   HEAP8[i64toi32_i32$0 >> 0] = $13;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $13 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $13 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $13 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = $3 + 84 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $5 = i64toi32_i32$1;
   $5$hi = i64toi32_i32$0;
   i64toi32_i32$1 = $3 + 19 | 0;
   $14 = $5;
   HEAP8[i64toi32_i32$1 >> 0] = $14;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $14 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $14 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $14 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $3;
   i64toi32_i32$0 = HEAP32[($3 + 76 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($3 + 80 | 0) >> 2] | 0;
   $6 = i64toi32_i32$0;
   $6$hi = i64toi32_i32$1;
   i64toi32_i32$0 = $3;
   $15 = $6;
   HEAP8[($3 + 11 | 0) >> 0] = $15;
   HEAP8[($3 + 12 | 0) >> 0] = $15 >>> 8 | 0;
   HEAP8[($3 + 13 | 0) >> 0] = $15 >>> 16 | 0;
   HEAP8[($3 + 14 | 0) >> 0] = $15 >>> 24 | 0;
   HEAP8[($3 + 15 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[($3 + 16 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[($3 + 17 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[($3 + 18 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$1 = $4$hi;
   i64toi32_i32$0 = $3 + 160 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $13;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $5$hi;
   i64toi32_i32$0 = $3 + 152 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $14;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $6$hi;
   i64toi32_i32$0 = $3;
   HEAP32[($3 + 144 | 0) >> 2] = $15;
   HEAP32[($3 + 148 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[$2 >> 2] = 1;
   i64toi32_i32$0 = $3;
   i64toi32_i32$1 = 0;
   HEAP32[($3 + 76 | 0) >> 2] = 1;
   HEAP32[($3 + 80 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($3 + 72 | 0) >> 2] = 1066504;
   HEAP32[($3 + 188 | 0) >> 2] = 111;
   HEAP32[($3 + 88 | 0) >> 2] = $3 + 184 | 0;
   HEAP32[($3 + 184 | 0) >> 2] = $3 + 144 | 0;
   alloc__fmt__format__h6e9e003a52c07309($3 + 168 | 0 | 0, $3 + 72 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 | 0, $3 + 168 | 0 | 0);
   $2 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[$3 >> 2] | 0 | 0, HEAP32[($3 + 4 | 0) >> 2] | 0 | 0) | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 168 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 168 | 0 | 0);
   core__ptr__drop_in_place_cardano_serialization_lib__chain_crypto__bech32__Error___hc63804c7ffa39d5a($3 + 144 | 0 | 0);
   HEAP32[($0 + 4 | 0) >> 2] = $2;
  }
  HEAP8[$0 >> 0] = $1;
  global$0 = $3 + 192 | 0;
 }
 
 function cardano_serialization_lib__crypto__Ed25519Signature__from_bech32__hf9b1aea32c1c48a1($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $13 = 0, $14 = 0, $15 = 0, $4 = 0, $4$hi = 0, $5 = 0, $5$hi = 0, $6 = 0, $6$hi = 0;
  $3 = global$0 - 192 | 0;
  global$0 = $3;
  $cardano_serialization_lib__chain_crypto__sign__Signature_T_2cA__20as_20cardano_serialization_lib__chain_crypto__bech32__Bech32___try_from_bech32_str__hb2a9289ba5b22cd2($3 + 72 | 0 | 0, $1 | 0, $2 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAPU8[($3 + 72 | 0) >> 0] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    memcpy($3 + 8 | 0 | 0, $3 + 72 | 0 | 1 | 0 | 0, 64 | 0) | 0;
    memcpy($0 + 1 | 0 | 0, $3 + 8 | 0 | 0, 64 | 0) | 0;
    $1 = 0;
    break label$1;
   }
   $2 = $3 + 92 | 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $4 = i64toi32_i32$0;
   $4$hi = i64toi32_i32$1;
   i64toi32_i32$0 = $3 + 27 | 0;
   $13 = $4;
   HEAP8[i64toi32_i32$0 >> 0] = $13;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $13 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $13 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $13 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = $3 + 84 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $5 = i64toi32_i32$1;
   $5$hi = i64toi32_i32$0;
   i64toi32_i32$1 = $3 + 19 | 0;
   $14 = $5;
   HEAP8[i64toi32_i32$1 >> 0] = $14;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $14 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $14 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $14 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $3;
   i64toi32_i32$0 = HEAP32[($3 + 76 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($3 + 80 | 0) >> 2] | 0;
   $6 = i64toi32_i32$0;
   $6$hi = i64toi32_i32$1;
   i64toi32_i32$0 = $3;
   $15 = $6;
   HEAP8[($3 + 11 | 0) >> 0] = $15;
   HEAP8[($3 + 12 | 0) >> 0] = $15 >>> 8 | 0;
   HEAP8[($3 + 13 | 0) >> 0] = $15 >>> 16 | 0;
   HEAP8[($3 + 14 | 0) >> 0] = $15 >>> 24 | 0;
   HEAP8[($3 + 15 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[($3 + 16 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[($3 + 17 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[($3 + 18 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$1 = $4$hi;
   i64toi32_i32$0 = $3 + 160 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $13;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $5$hi;
   i64toi32_i32$0 = $3 + 152 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $14;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $6$hi;
   i64toi32_i32$0 = $3;
   HEAP32[($3 + 144 | 0) >> 2] = $15;
   HEAP32[($3 + 148 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[$2 >> 2] = 1;
   i64toi32_i32$0 = $3;
   i64toi32_i32$1 = 0;
   HEAP32[($3 + 76 | 0) >> 2] = 1;
   HEAP32[($3 + 80 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($3 + 72 | 0) >> 2] = 1066504;
   HEAP32[($3 + 188 | 0) >> 2] = 111;
   HEAP32[($3 + 88 | 0) >> 2] = $3 + 184 | 0;
   HEAP32[($3 + 184 | 0) >> 2] = $3 + 144 | 0;
   alloc__fmt__format__h6e9e003a52c07309($3 + 168 | 0 | 0, $3 + 72 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 | 0, $3 + 168 | 0 | 0);
   $2 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[$3 >> 2] | 0 | 0, HEAP32[($3 + 4 | 0) >> 2] | 0 | 0) | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 168 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 168 | 0 | 0);
   core__ptr__drop_in_place_cardano_serialization_lib__chain_crypto__bech32__Error___hc63804c7ffa39d5a($3 + 144 | 0 | 0);
   HEAP32[($0 + 4 | 0) >> 2] = $2;
  }
  HEAP8[$0 >> 0] = $1;
  global$0 = $3 + 192 | 0;
 }
 
 function vrfcert_new($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $49 = 0, $59 = 0, $76 = 0, $88 = 0;
  $4 = global$0 - 128 | 0;
  global$0 = $4;
  HEAP32[($4 + 32 | 0) >> 2] = $1;
  HEAP32[($4 + 28 | 0) >> 2] = $1;
  HEAP32[($4 + 24 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($4 + 16 | 0 | 0, $4 + 24 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($4 + 56 | 0 | 0, HEAP32[($4 + 16 | 0) >> 2] | 0 | 0, HEAP32[($4 + 20 | 0) >> 2] | 0 | 0);
  HEAP32[($4 + 32 | 0) >> 2] = $3;
  HEAP32[($4 + 28 | 0) >> 2] = $3;
  HEAP32[($4 + 24 | 0) >> 2] = $2;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($4 + 8 | 0 | 0, $4 + 24 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($4 + 72 | 0 | 0, HEAP32[($4 + 8 | 0) >> 2] | 0 | 0, HEAP32[($4 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($4 + 88 | 0) + 8 | 0) >> 2] = HEAP32[(($4 + 56 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[($4 + 56 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($4 + 60 | 0) >> 2] | 0;
  $49 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[($4 + 88 | 0) >> 2] = $49;
  HEAP32[($4 + 92 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(($4 + 104 | 0) + 8 | 0) >> 2] = HEAP32[(($4 + 72 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = HEAP32[($4 + 72 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($4 + 76 | 0) >> 2] | 0;
  $59 = i64toi32_i32$1;
  i64toi32_i32$1 = $4;
  HEAP32[($4 + 104 | 0) >> 2] = $59;
  HEAP32[($4 + 108 | 0) >> 2] = i64toi32_i32$0;
  cardano_serialization_lib__crypto__VRFCert__new__h6ceef7098f5961a1($4 + 24 | 0 | 0, $4 + 88 | 0 | 0, $4 + 104 | 0 | 0);
  $3 = HEAP32[($4 + 28 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($4 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($3 | 0);
   abort();
  }
  i64toi32_i32$2 = $4 + 40 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $76 = i64toi32_i32$0;
  i64toi32_i32$0 = $4 + 116 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $76;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($4 + 124 | 0) >> 2] = HEAP32[($4 + 48 | 0) >> 2] | 0;
  HEAP32[($4 + 104 | 0) >> 2] = $3;
  i64toi32_i32$2 = ($4 + 24 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $88 = i64toi32_i32$1;
  i64toi32_i32$1 = $4;
  HEAP32[($4 + 108 | 0) >> 2] = $88;
  HEAP32[($4 + 112 | 0) >> 2] = i64toi32_i32$0;
  $3 = $cardano_serialization_lib__crypto__VRFCert_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hc597ed79f1e184d4($4 + 104 | 0 | 0) | 0;
  global$0 = $4 + 128 | 0;
  return $3 | 0;
 }
 
 function cardano_serialization_lib__plutus__CostModel__set__h749333f509e0b3de($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $6 = 0, $6$hi = 0, $5 = 0, $29 = 0, $40 = 0, $60 = 0;
  $4 = global$0 - 96 | 0;
  global$0 = $4;
  HEAP32[($4 + 36 | 0) >> 2] = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     if ($2 >>> 0 > 165 >>> 0) {
      break label$3
     }
     $5 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     if ($5 >>> 0 <= $2 >>> 0) {
      break label$1
     }
     HEAP32[$0 >> 2] = 0;
     $2 = (HEAP32[$1 >> 2] | 0) + ($2 << 4 | 0) | 0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $6 = i64toi32_i32$0;
     $6$hi = i64toi32_i32$1;
     i64toi32_i32$2 = $3;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $29 = i64toi32_i32$1;
     i64toi32_i32$1 = $2;
     HEAP32[i64toi32_i32$1 >> 2] = $29;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$1 = $0 + 8 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $6;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     $2 = $2 + 8 | 0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $6 = i64toi32_i32$0;
     $6$hi = i64toi32_i32$1;
     i64toi32_i32$2 = $3 + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $40 = i64toi32_i32$1;
     i64toi32_i32$1 = $2;
     HEAP32[i64toi32_i32$1 >> 2] = $40;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$1 = $0 + 16 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $6;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     break label$2;
    }
    core__fmt__ArgumentV1__new__h5702524f4c8ddc75($4 + 24 | 0 | 0, $4 + 36 | 0 | 0, 46 | 0);
    i64toi32_i32$2 = $4;
    i64toi32_i32$0 = HEAP32[($4 + 24 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($4 + 28 | 0) >> 2] | 0;
    $6 = i64toi32_i32$0;
    $6$hi = i64toi32_i32$1;
    core__fmt__ArgumentV1__new__h5702524f4c8ddc75($4 + 16 | 0 | 0, 1071420 | 0, 46 | 0);
    HEAP32[($4 + 76 | 0) >> 2] = 2;
    i64toi32_i32$0 = $4;
    HEAP32[($4 + 80 | 0) >> 2] = $6;
    HEAP32[($4 + 84 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$0 = $4;
    i64toi32_i32$1 = 0;
    HEAP32[($4 + 60 | 0) >> 2] = 2;
    HEAP32[($4 + 64 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($4 + 56 | 0) >> 2] = 1071404;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 16 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($4 + 20 | 0) >> 2] | 0;
    $60 = i64toi32_i32$1;
    i64toi32_i32$1 = $4;
    HEAP32[($4 + 88 | 0) >> 2] = $60;
    HEAP32[($4 + 92 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($4 + 72 | 0) >> 2] = $4 + 80 | 0;
    alloc__fmt__format__h6e9e003a52c07309($4 + 40 | 0 | 0, $4 + 56 | 0 | 0);
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($4 + 8 | 0 | 0, $4 + 40 | 0 | 0);
    $2 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($4 + 8 | 0) >> 2] | 0 | 0, HEAP32[($4 + 12 | 0) >> 2] | 0 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    HEAP32[($0 + 4 | 0) >> 2] = $2;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($4 + 40 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($4 + 40 | 0 | 0);
   }
   global$0 = $4 + 96 | 0;
   return;
  }
  core__panicking__panic_bounds_check__h808b524af17640b1($2 | 0, $5 | 0, 1071424 | 0);
  abort();
 }
 
 function cardano_serialization_lib__SingleHostAddr__from_bytes__h7fb250e664cb91aa($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $5 = 0, $18 = 0, $3$hi = 0, $4$hi = 0, $5$hi = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[(($2 + 152 | 0) + 16 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 152 | 0) >> 2] = 0;
  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 160 | 0) >> 2] = $18;
  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__SingleHostAddr___deserialize__h59dee13d71df70a3($2 + 80 | 0 | 0, $2 + 152 | 0 | 0);
  $1 = ($2 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAPU16[($2 + 80 | 0) >> 1] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAPU16[(($2 + 80 | 0) + 26 | 0) >> 1] | 0;
    HEAP16[($2 + 32 | 0) >> 1] = $1;
    i64toi32_i32$2 = ($2 + 80 | 0) + 18 | 0;
    i64toi32_i32$1 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
    i64toi32_i32$0 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
    $3 = i64toi32_i32$1;
    $3$hi = i64toi32_i32$0;
    i64toi32_i32$1 = ($2 + 8 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = ($2 + 80 | 0) + 10 | 0;
    i64toi32_i32$0 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
    i64toi32_i32$1 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
    $4 = i64toi32_i32$0;
    $4$hi = i64toi32_i32$1;
    i64toi32_i32$0 = ($2 + 8 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $4;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAPU16[($2 + 82 | 0) >> 1] | 0 | ((HEAPU16[($2 + 84 | 0) >> 1] | 0) << 16 | 0) | 0;
    i64toi32_i32$0 = HEAPU16[($2 + 86 | 0) >> 1] | 0 | ((HEAPU16[($2 + 88 | 0) >> 1] | 0) << 16 | 0) | 0;
    $5 = i64toi32_i32$1;
    $5$hi = i64toi32_i32$0;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 8 | 0) >> 2] = $5;
    HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
    HEAP16[($0 + 26 | 0) >> 1] = $1;
    i64toi32_i32$0 = $3$hi;
    i64toi32_i32$1 = $0 + 18 | 0;
    HEAP16[i64toi32_i32$1 >> 1] = $3;
    HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $3 >>> 16 | 0;
    HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = i64toi32_i32$0;
    HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
    i64toi32_i32$0 = $4$hi;
    i64toi32_i32$1 = $0 + 10 | 0;
    HEAP16[i64toi32_i32$1 >> 1] = $4;
    HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $4 >>> 16 | 0;
    HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = i64toi32_i32$0;
    HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
    i64toi32_i32$0 = $5$hi;
    i64toi32_i32$1 = $0;
    HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $5;
    HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = $5 >>> 16 | 0;
    HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$0;
    HEAP16[(i64toi32_i32$1 + 8 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 8 | 0 | 6 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0 + 4 | 0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[wasm2js_i32$0 >> 2] = wasm2js_i32$1;
  }
  HEAP16[$0 >> 1] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__ScriptPubkey__from_bytes__h5b8c574da64e96b5($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $13 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $3 = 0, $4 = 0, $5 = 0, $18 = 0, $3$hi = 0, $4$hi = 0, $5$hi = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[(($2 + 152 | 0) + 16 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 152 | 0) >> 2] = 0;
  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 160 | 0) >> 2] = $18;
  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__ScriptPubkey___deserialize__hcda45a5ae72614ec($2 + 80 | 0 | 0, $2 + 152 | 0 | 0);
  $1 = ($2 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAPU8[($2 + 80 | 0) >> 0] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $13 = ($2 + 80 | 0) + 25 | 0;
    $1 = HEAPU8[$13 >> 0] | 0 | ((HEAPU8[($13 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($13 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($13 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    HEAP32[($2 + 32 | 0) >> 2] = $1;
    i64toi32_i32$2 = ($2 + 80 | 0) + 17 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $3 = i64toi32_i32$1;
    $3$hi = i64toi32_i32$0;
    i64toi32_i32$1 = ($2 + 8 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = ($2 + 80 | 0) + 9 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $4 = i64toi32_i32$0;
    $4$hi = i64toi32_i32$1;
    i64toi32_i32$0 = ($2 + 8 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $4;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAPU8[($2 + 81 | 0) >> 0] | 0 | ((HEAPU8[($2 + 82 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 83 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 84 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[($2 + 85 | 0) >> 0] | 0 | ((HEAPU8[($2 + 86 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 87 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 88 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $5 = i64toi32_i32$1;
    $5$hi = i64toi32_i32$0;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 8 | 0) >> 2] = $5;
    HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
    $14 = $0 + 25 | 0;
    HEAP8[$14 >> 0] = $1;
    HEAP8[($14 + 1 | 0) >> 0] = $1 >>> 8 | 0;
    HEAP8[($14 + 2 | 0) >> 0] = $1 >>> 16 | 0;
    HEAP8[($14 + 3 | 0) >> 0] = $1 >>> 24 | 0;
    i64toi32_i32$0 = $3$hi;
    i64toi32_i32$1 = $0 + 17 | 0;
    $15 = $3;
    HEAP8[i64toi32_i32$1 >> 0] = $15;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $15 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $15 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $15 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$0 = $4$hi;
    i64toi32_i32$1 = $0 + 9 | 0;
    $16 = $4;
    HEAP8[i64toi32_i32$1 >> 0] = $16;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $16 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $16 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $16 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$0 = $5$hi;
    i64toi32_i32$1 = $0;
    $17 = $5;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = $17 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 8 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 8 | 0 | 7 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0 + 4 | 0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[wasm2js_i32$0 >> 2] = wasm2js_i32$1;
  }
  HEAP8[$0 >> 0] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function $cardano_serialization_lib__chain_crypto__key__PublicKey_A__20as_20cardano_serialization_lib__chain_crypto__bech32__Bech32___try_from_bech32_str__h43e4355a7c74c377($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $4 = 0, $5 = 0, $6 = 0, $28 = 0, $4$hi = 0, $5$hi = 0, $6$hi = 0;
  $3 = global$0 - 128 | 0;
  global$0 = $3;
  cardano_serialization_lib__chain_crypto__bech32__try_from_bech32_to_bytes__h872d08116783f519($3 + 56 | 0 | 0, $1 | 0, $2 | 0);
  $1 = $3 + 56 | 0 | 4 | 0;
  label$1 : {
   label$2 : {
    if ((HEAP32[($3 + 56 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    HEAP32[(($3 + 16 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $1;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $28 = i64toi32_i32$0;
    i64toi32_i32$0 = $3;
    HEAP32[($3 + 16 | 0) >> 2] = $28;
    HEAP32[($3 + 20 | 0) >> 2] = i64toi32_i32$1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $3 + 16 | 0 | 0);
    cardano_serialization_lib__chain_crypto__key__PublicKey_A___from_binary__he9697ecf8c279d37($3 + 56 | 0 | 0, HEAP32[($3 + 8 | 0) >> 2] | 0 | 0, HEAP32[($3 + 12 | 0) >> 2] | 0 | 0);
    label$3 : {
     label$4 : {
      if ((HEAPU8[($3 + 56 | 0) >> 0] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      memcpy($0 + 1 | 0 | 0, $3 + 56 | 0 | 1 | 0 | 0, 64 | 0) | 0;
      $1 = 0;
      break label$3;
     }
     cardano_serialization_lib__chain_crypto__bech32__Error__data_invalid__h845fc6de9cc87c9e($0 + 4 | 0 | 0, HEAPU8[($3 + 57 | 0) >> 0] | 0 | 0);
     $1 = 1;
    }
    HEAP8[$0 >> 0] = $1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 16 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 16 | 0 | 0);
    break label$1;
   }
   i64toi32_i32$2 = $1 + 16 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $4 = i64toi32_i32$1;
   $4$hi = i64toi32_i32$0;
   i64toi32_i32$1 = ($3 + 32 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $4;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $1 + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $5 = i64toi32_i32$0;
   $5$hi = i64toi32_i32$1;
   i64toi32_i32$0 = ($3 + 32 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $5;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $6 = i64toi32_i32$1;
   $6$hi = i64toi32_i32$0;
   i64toi32_i32$1 = $3;
   HEAP32[($3 + 32 | 0) >> 2] = $6;
   HEAP32[($3 + 36 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $4$hi;
   i64toi32_i32$1 = $0 + 20 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $4;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $5$hi;
   i64toi32_i32$1 = $0 + 12 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $5;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $6$hi;
   i64toi32_i32$1 = $0 + 4 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $6;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP8[$0 >> 0] = 1;
  }
  global$0 = $3 + 128 | 0;
 }
 
 function cardano_serialization_lib__crypto__Vkey__from_bytes__he51c649dc960455b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $2 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $19 = 0, $3$hi = 0, $4$hi = 0, $5$hi = 0, $6$hi = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[(($2 + 152 | 0) + 16 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[(i64toi32_i32$1 + 152 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[(i64toi32_i32$0 + 160 | 0) >> 2] = $19;
  HEAP32[(i64toi32_i32$0 + 164 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__crypto__Vkey_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h00a02b49be066c8c(i64toi32_i32$0 + 80 | 0 | 0, i64toi32_i32$0 + 152 | 0 | 0);
  $1 = (i64toi32_i32$0 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAPU8[(i64toi32_i32$0 + 80 | 0) >> 0] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    i64toi32_i32$2 = ($2 + 80 | 0) + 25 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $3 = i64toi32_i32$1;
    $3$hi = i64toi32_i32$0;
    i64toi32_i32$1 = $2 + 32 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = ($2 + 80 | 0) + 17 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $4 = i64toi32_i32$0;
    $4$hi = i64toi32_i32$1;
    i64toi32_i32$0 = ($2 + 8 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $4;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = ($2 + 80 | 0) + 9 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $5 = i64toi32_i32$1;
    $5$hi = i64toi32_i32$0;
    i64toi32_i32$1 = ($2 + 8 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $5;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 81 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 82 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 83 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 84 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 85 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 86 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 87 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 88 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $6 = i64toi32_i32$0;
    $6$hi = i64toi32_i32$1;
    i64toi32_i32$0 = i64toi32_i32$2;
    HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $6;
    HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $3$hi;
    i64toi32_i32$0 = $0 + 25 | 0;
    $15 = $3;
    HEAP8[i64toi32_i32$0 >> 0] = $15;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $15 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $15 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $15 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$1 = $4$hi;
    i64toi32_i32$0 = $0 + 17 | 0;
    $16 = $4;
    HEAP8[i64toi32_i32$0 >> 0] = $16;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $16 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $16 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $16 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$1 = $5$hi;
    i64toi32_i32$0 = $0 + 9 | 0;
    $17 = $5;
    HEAP8[i64toi32_i32$0 >> 0] = $17;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $17 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $17 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $17 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$1 = $6$hi;
    i64toi32_i32$0 = $0;
    $18 = $6;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $18;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $18 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $18 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = $18 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 8 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 8 | 0 | 7 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0 + 4 | 0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[wasm2js_i32$0 >> 2] = wasm2js_i32$1;
  }
  HEAP8[$0 >> 0] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function $T_20as_20bech32__ToBase32___write_base32__h672b24da1834a039($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $5 = 0, $2 = 0, $3 = 0, $7 = 0, $4 = 0, $6 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  core__slice__iter___impl_20core__iter__traits__collect__IntoIterator_20for_20__5bT_5d___into_iter__hc96cff628f84e170($2 + 8 | 0 | 0, HEAP32[$0 >> 2] | 0 | 0, HEAP32[($0 + 4 | 0) >> 2] | 0 | 0);
  label$1 : {
   label$2 : {
    $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    $4 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    if (($3 | 0) != ($4 | 0)) {
     break label$2
    }
    $5 = 0;
    break label$1;
   }
   $5 = 0;
   $0 = 0;
   label$3 : {
    label$4 : {
     label$5 : while (1) {
      $6 = HEAPU8[$3 >> 0] | 0;
      label$6 : {
       label$7 : {
        if ($5 >>> 0 >= 5 >>> 0) {
         break label$7
        }
        $7 = $5;
        break label$6;
       }
       if ($alloc__vec__Vec_bech32__u5__20as_20bech32__WriteBase32___write_u5__hb515549aebcd01f1($1 | 0, ($0 & 248 | 0) >>> 3 | 0 | 0) | 0) {
        break label$4
       }
       $7 = $5 + -5 | 0;
       $0 = $0 << 5 | 0;
      }
      $5 = $7 + 3 | 0;
      if ($alloc__vec__Vec_bech32__u5__20as_20bech32__WriteBase32___write_u5__hb515549aebcd01f1($1 | 0, ($6 & 255 | 0) >>> ($5 & 7 | 0) | 0 | (($0 & 248 | 0) >>> 3 | 0) | 0 | 0) | 0) {
       break label$4
      }
      $0 = $6 << ((5 - $7 | 0) & 7 | 0) | 0;
      $3 = $3 + 1 | 0;
      if (($4 | 0) == ($3 | 0)) {
       break label$3
      }
      continue label$5;
     };
    }
    $5 = 1;
    break label$1;
   }
   $5 = 1;
   label$8 : {
    if ($7 >>> 0 <= 1 >>> 0) {
     break label$8
    }
    if ($alloc__vec__Vec_bech32__u5__20as_20bech32__WriteBase32___write_u5__hb515549aebcd01f1($1 | 0, ($0 & 248 | 0) >>> 3 | 0 | 0) | 0) {
     break label$1
    }
    $5 = 0;
    if (($7 | 0) == (2 | 0)) {
     break label$1
    }
    $0 = $0 << 5 | 0;
   }
   $0 = $alloc__vec__Vec_bech32__u5__20as_20bech32__WriteBase32___write_u5__hb515549aebcd01f1($1 | 0, ($0 & 248 | 0) >>> 3 | 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return $0 | 0;
  }
  global$0 = $2 + 16 | 0;
  return $5 | 0;
 }
 
 function cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $5 = 0, $29 = 0, $47 = 0, $52 = 0, $73 = 0;
  $4 = global$0 - 112 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    if (HEAP32[($1 + 48 | 0) >> 2] | 0) {
     break label$2
    }
    alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($0 + 48 | 0 | 0, $2 | 0, $3 | 0);
    memcpy($0 | 0, $1 | 0, 48 | 0) | 0;
    break label$1;
   }
   $5 = $1 + 48 | 0;
   HEAP32[(($4 + 24 | 0) + 8 | 0) >> 2] = HEAP32[($5 + 8 | 0) >> 2] | 0;
   i64toi32_i32$2 = $5;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $29 = i64toi32_i32$0;
   i64toi32_i32$0 = $4;
   HEAP32[($4 + 24 | 0) >> 2] = $29;
   HEAP32[($4 + 28 | 0) >> 2] = i64toi32_i32$1;
   alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($4 + 96 | 0 | 0, $2 | 0, $3 | 0);
   core__fmt__ArgumentV1__new__h56a0e5bff2bd9085($4 + 16 | 0 | 0, $4 + 96 | 0 | 0, 89 | 0);
   i64toi32_i32$2 = $4;
   i64toi32_i32$1 = HEAP32[($4 + 16 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($4 + 20 | 0) >> 2] | 0;
   core__fmt__ArgumentV1__new__h56a0e5bff2bd9085($4 + 8 | 0 | 0, $4 + 24 | 0 | 0, 89 | 0);
   HEAP32[($4 + 76 | 0) >> 2] = 2;
   $47 = i64toi32_i32$1;
   i64toi32_i32$1 = $4;
   HEAP32[($4 + 80 | 0) >> 2] = $47;
   HEAP32[($4 + 84 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$1 = $4;
   i64toi32_i32$0 = 0;
   HEAP32[($4 + 60 | 0) >> 2] = 2;
   HEAP32[($4 + 64 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($4 + 56 | 0) >> 2] = 1061596;
   i64toi32_i32$2 = $4;
   i64toi32_i32$0 = HEAP32[($4 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($4 + 12 | 0) >> 2] | 0;
   $52 = i64toi32_i32$0;
   i64toi32_i32$0 = $4;
   HEAP32[($4 + 88 | 0) >> 2] = $52;
   HEAP32[($4 + 92 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($4 + 72 | 0) >> 2] = $4 + 80 | 0;
   alloc__fmt__format__h6e9e003a52c07309($4 + 40 | 0 | 0, $4 + 56 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($4 + 96 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($4 + 96 | 0 | 0);
   HEAP32[(($4 + 56 | 0) + 8 | 0) >> 2] = HEAP32[(($4 + 40 | 0) + 8 | 0) >> 2] | 0;
   i64toi32_i32$2 = $4;
   i64toi32_i32$1 = HEAP32[($4 + 40 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($4 + 44 | 0) >> 2] | 0;
   $73 = i64toi32_i32$1;
   i64toi32_i32$1 = $4;
   HEAP32[($4 + 56 | 0) >> 2] = $73;
   HEAP32[($4 + 60 | 0) >> 2] = i64toi32_i32$0;
   $T_20as_20core__convert__Into_U____into__hf947635aeddf134e($0 + 48 | 0 | 0, $4 + 56 | 0 | 0);
   memcpy($0 | 0, $1 | 0, 48 | 0) | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($4 + 24 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($4 + 24 | 0 | 0);
  }
  global$0 = $4 + 112 | 0;
 }
 
 function cardano_serialization_lib__tx_builder__TransactionBuilder__set_withdrawals__h04e33428bc3543ac($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $3 = 0, $14 = 0, $5 = 0, $6 = 0, $6$hi = 0, $7 = 0, $4 = 0, $5$hi = 0, $7$hi = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h8cac34049618832f($2 + 8 | 0 | 0, $1 | 0);
  $3 = $0 + 288 | 0;
  core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__Withdrawals____heaf2605773ce1c75_1($3 | 0);
  memcpy($3 | 0, $2 + 8 | 0 | 0, 40 | 0) | 0;
  label$1 : {
   label$2 : {
    $3 = HEAP32[($1 + 32 | 0) >> 2] | 0;
    if ($3) {
     break label$2
    }
    $1 = 0;
    break label$1;
   }
   $1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
  }
  label$3 : {
   label$4 : {
    if (($1 | 0) == ($3 | 0)) {
     break label$4
    }
    $4 = $0 + 136 | 0;
    label$5 : while (1) {
     if ((HEAPU8[($1 + 17 | 0) >> 0] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
     i64toi32_i32$2 = $1 + 26 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $5 = i64toi32_i32$0;
     $5$hi = i64toi32_i32$1;
     i64toi32_i32$0 = ($2 + 48 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $5;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $1 + 18 | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $6 = i64toi32_i32$1;
     $6$hi = i64toi32_i32$0;
     i64toi32_i32$2 = $1 + 34 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $7 = i64toi32_i32$0;
     $7$hi = i64toi32_i32$1;
     i64toi32_i32$0 = ($2 + 48 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $7;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     $14 = $1 + 42 | 0;
     $1 = HEAPU8[$14 >> 0] | 0 | ((HEAPU8[($14 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($14 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($14 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP32[(($2 + 48 | 0) + 24 | 0) >> 2] = $1;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$0 = $2;
     HEAP32[(i64toi32_i32$0 + 48 | 0) >> 2] = $6;
     HEAP32[(i64toi32_i32$0 + 52 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[((i64toi32_i32$0 + 8 | 0) + 24 | 0) >> 2] = $1;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$0 = (i64toi32_i32$0 + 8 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $7;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $5$hi;
     i64toi32_i32$0 = ($2 + 8 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $5;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$0 = $2;
     HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $6;
     HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
     alloc__collections__btree__map__BTreeMap_K_2cV___insert__h5d8c7a7452747b0f($4 | 0, i64toi32_i32$0 + 8 | 0 | 0) | 0;
     $1 = $0;
     if (($1 | 0) != ($3 | 0)) {
      continue label$5
     }
     break label$5;
    };
   }
   global$0 = $2 + 80 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1063668 | 0, 43 | 0, 1065184 | 0);
  abort();
 }
 
 function itoa__Buffer__format__h16c7f26094a64122($0, $1, $2, $2$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  var i64toi32_i32$2 = 0, $3 = 0, $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $7 = 0, i64toi32_i32$3 = 0, $7$hi = 0, i64toi32_i32$5 = 0, $5 = 0, $6 = 0, $17 = 0, $18 = 0, $19 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $25 = 0, $26 = 0, $27 = 0, $28 = 0, $29 = 0, $20 = 0, $20$hi = 0;
  $3 = 20;
  label$1 : {
   label$2 : {
    i64toi32_i32$0 = $2$hi;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = 0;
    i64toi32_i32$3 = 1e4;
    if (i64toi32_i32$0 >>> 0 > i64toi32_i32$1 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$2 >>> 0 >= i64toi32_i32$3 >>> 0 | 0) | 0) {
     break label$2
    }
    i64toi32_i32$2 = $2$hi;
    $7 = $2;
    $7$hi = i64toi32_i32$2;
    break label$1;
   }
   $3 = 20;
   label$3 : while (1) {
    $4 = $1 + $3 | 0;
    i64toi32_i32$2 = $2$hi;
    i64toi32_i32$0 = 0;
    i64toi32_i32$0 = __wasm_i64_udiv($2 | 0, i64toi32_i32$2 | 0, 1e4 | 0, i64toi32_i32$0 | 0) | 0;
    i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
    $7 = i64toi32_i32$0;
    $7$hi = i64toi32_i32$2;
    i64toi32_i32$0 = 0;
    i64toi32_i32$0 = __wasm_i64_mul($7 | 0, i64toi32_i32$2 | 0, 1e4 | 0, i64toi32_i32$0 | 0) | 0;
    i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
    $20 = i64toi32_i32$0;
    $20$hi = i64toi32_i32$2;
    i64toi32_i32$2 = $2$hi;
    i64toi32_i32$3 = $2;
    i64toi32_i32$0 = $20$hi;
    i64toi32_i32$1 = $20;
    i64toi32_i32$5 = ($2 >>> 0 < i64toi32_i32$1 >>> 0) + i64toi32_i32$0 | 0;
    i64toi32_i32$5 = i64toi32_i32$2 - i64toi32_i32$5 | 0;
    $5 = $2 - i64toi32_i32$1 | 0;
    $6 = (($5 & 65535 | 0) >>> 0) / (100 >>> 0) | 0;
    $17 = ($6 << 1 | 0) + 1087292 | 0;
    $18 = $4 + -4 | 0;
    $19 = HEAPU8[$17 >> 0] | 0 | ((HEAPU8[($17 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
    HEAP8[$18 >> 0] = $19;
    HEAP8[($18 + 1 | 0) >> 0] = $19 >>> 8 | 0;
    $21 = ((($5 - Math_imul($6, 100) | 0) & 65535 | 0) << 1 | 0) + 1087292 | 0;
    $22 = $4 + -2 | 0;
    $23 = HEAPU8[$21 >> 0] | 0 | ((HEAPU8[($21 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
    HEAP8[$22 >> 0] = $23;
    HEAP8[($22 + 1 | 0) >> 0] = $23 >>> 8 | 0;
    $3 = $3 + -4 | 0;
    i64toi32_i32$5 = i64toi32_i32$2;
    i64toi32_i32$5 = i64toi32_i32$2;
    i64toi32_i32$2 = $2;
    i64toi32_i32$3 = 0;
    i64toi32_i32$1 = 99999999;
    $4 = $2$hi >>> 0 > i64toi32_i32$3 >>> 0 | (($2$hi | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$2 >>> 0 > i64toi32_i32$1 >>> 0 | 0) | 0;
    i64toi32_i32$2 = $7$hi;
    $2 = $7;
    $2$hi = i64toi32_i32$2;
    if ($4) {
     continue label$3
    }
    break label$3;
   };
  }
  label$4 : {
   i64toi32_i32$2 = $7$hi;
   $4 = $7;
   if (($4 | 0) < (100 | 0)) {
    break label$4
   }
   $3 = $3 + -2 | 0;
   i64toi32_i32$2 = $7$hi;
   $4 = $7;
   $4 = (($4 & 65535 | 0) >>> 0) / (100 >>> 0) | 0;
   $24 = ((($7 - Math_imul($4, 100) | 0) & 65535 | 0) << 1 | 0) + 1087292 | 0;
   $25 = $1 + $3 | 0;
   $26 = HEAPU8[$24 >> 0] | 0 | ((HEAPU8[($24 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
   HEAP8[$25 >> 0] = $26;
   HEAP8[($25 + 1 | 0) >> 0] = $26 >>> 8 | 0;
  }
  label$5 : {
   label$6 : {
    if (($4 | 0) < (10 | 0)) {
     break label$6
    }
    $3 = $3 + -2 | 0;
    $27 = ($4 << 1 | 0) + 1087292 | 0;
    $28 = $1 + $3 | 0;
    $29 = HEAPU8[$27 >> 0] | 0 | ((HEAPU8[($27 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
    HEAP8[$28 >> 0] = $29;
    HEAP8[($28 + 1 | 0) >> 0] = $29 >>> 8 | 0;
    break label$5;
   }
   $3 = $3 + -1 | 0;
   HEAP8[($1 + $3 | 0) >> 0] = $4 + 48 | 0;
  }
  HEAP32[($0 + 4 | 0) >> 2] = 20 - $3 | 0;
  HEAP32[$0 >> 2] = $1 + $3 | 0;
 }
 
 function $std__panicking__begin_panic_handler__PanicPayload_20as_20core__panic__BoxMeUp___take_box__h93f407f6fea17636($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $2 = 0, $5 = 0, $3 = 0, $4 = 0, $30 = 0, $36 = 0, $39 = 0, $53 = 0, $70 = 0, $75 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  $3 = $1 + 4 | 0;
  label$1 : {
   label$2 : {
    if (!(HEAP32[($1 + 4 | 0) >> 2] | 0)) {
     break label$2
    }
    $4 = HEAP32[(0 + 1142628 | 0) >> 2] | 0;
    break label$1;
   }
   $5 = HEAP32[$1 >> 2] | 0;
   i64toi32_i32$1 = $2;
   i64toi32_i32$0 = 0;
   HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = 0;
   HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = i64toi32_i32$0;
   $4 = HEAP32[(0 + 1142628 | 0) >> 2] | 0;
   HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $4;
   HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$1 + 8 | 0;
   i64toi32_i32$2 = $5 + 16 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $30 = i64toi32_i32$0;
   i64toi32_i32$0 = ($2 + 24 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $30;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $5 + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $36 = i64toi32_i32$1;
   i64toi32_i32$1 = ($2 + 24 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $36;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $5;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $39 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = $39;
   HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = i64toi32_i32$1;
   core__fmt__write__h9b9aa23e7d35702c(i64toi32_i32$0 + 20 | 0 | 0, 1142220 | 0, i64toi32_i32$0 + 24 | 0 | 0) | 0;
   HEAP32[($3 + 8 | 0) >> 2] = HEAP32[((i64toi32_i32$0 + 8 | 0) + 8 | 0) >> 2] | 0;
   i64toi32_i32$2 = i64toi32_i32$0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] | 0;
   $53 = i64toi32_i32$1;
   i64toi32_i32$1 = $3;
   HEAP32[i64toi32_i32$1 >> 2] = $53;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  }
  $5 = ($2 + 24 | 0) + 8 | 0;
  HEAP32[$5 >> 2] = HEAP32[($3 + 8 | 0) >> 2] | 0;
  HEAP32[($1 + 12 | 0) >> 2] = 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = 0;
  HEAP32[($1 + 4 | 0) >> 2] = $4;
  $70 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = $70;
  HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = i64toi32_i32$1;
  label$3 : {
   $1 = __rust_alloc(12 | 0, 4 | 0) | 0;
   if ($1) {
    break label$3
   }
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(12 | 0, 4 | 0);
   abort();
  }
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $75 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[i64toi32_i32$1 >> 2] = $75;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
  HEAP32[($0 + 4 | 0) >> 2] = 1144336;
  HEAP32[$0 >> 2] = i64toi32_i32$1;
  global$0 = i64toi32_i32$2 + 48 | 0;
 }
 
 function cardano_serialization_lib__PoolRetirement__from_bytes__ha16222bdbe5d2ef6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $19 = 0, $3$hi = 0, $4$hi = 0, $5$hi = 0, $6$hi = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[(($2 + 152 | 0) + 16 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[(i64toi32_i32$1 + 152 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[(i64toi32_i32$0 + 160 | 0) >> 2] = $19;
  HEAP32[(i64toi32_i32$0 + 164 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__PoolRetirement___deserialize__h55f532dbffc17752(i64toi32_i32$0 + 80 | 0 | 0, i64toi32_i32$0 + 152 | 0 | 0);
  $1 = (i64toi32_i32$0 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[(i64toi32_i32$0 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    i64toi32_i32$2 = ($2 + 80 | 0) + 28 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $3 = i64toi32_i32$1;
    $3$hi = i64toi32_i32$0;
    i64toi32_i32$1 = $2 + 32 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = ($2 + 80 | 0) + 20 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $4 = i64toi32_i32$0;
    $4$hi = i64toi32_i32$1;
    i64toi32_i32$0 = ($2 + 8 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $4;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = ($2 + 80 | 0) + 12 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $5 = i64toi32_i32$1;
    $5$hi = i64toi32_i32$0;
    i64toi32_i32$1 = ($2 + 8 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $5;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[($2 + 84 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    $6 = i64toi32_i32$0;
    $6$hi = i64toi32_i32$1;
    i64toi32_i32$0 = $2;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $6;
    HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $3$hi;
    i64toi32_i32$0 = $0 + 28 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $3;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $4$hi;
    i64toi32_i32$0 = $0 + 20 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $4;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $5$hi;
    i64toi32_i32$0 = $0 + 12 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $5;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $6$hi;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $6;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 8 | 0 | 4 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h86cdf7dca21c8b48($0) {
  $0 = $0 | 0;
  var $2 = 0, $1 = 0, $3 = 0, $4 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $2 = HEAP32[$0 >> 2] | 0;
   $3 = $2 + Math_imul($1, 272) | 0;
   label$2 : while (1) {
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h98bad0b07702c13e($2 + 128 | 0 | 0);
    $4 = $2 + 140 | 0;
    label$3 : {
     $1 = HEAP32[($2 + 148 | 0) >> 2] | 0;
     if (!$1) {
      break label$3
     }
     $0 = HEAP32[($2 + 140 | 0) >> 2] | 0;
     $1 = $1 << 7 | 0;
     label$4 : while (1) {
      core__ptr__drop_in_place_cardano_serialization_lib__TransactionOutput___h632b3a99817e6ac5_1($0 | 0);
      $0 = $0 + 128 | 0;
      $1 = $1 + -128 | 0;
      if ($1) {
       continue label$4
      }
      break label$4;
     };
    }
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h5107e2b13c386680($4 | 0);
    label$5 : {
     if (!(HEAP32[($2 + 152 | 0) >> 2] | 0)) {
      break label$5
     }
     $0 = $2 + 152 | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h07097b699c9c8f63($0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__ha1b43c51acf8124f($0 | 0);
    }
    label$6 : {
     if (!(HEAP32[($2 + 44 | 0) >> 2] | 0)) {
      break label$6
     }
     $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__h16511d8898c4755a($2 + 24 | 0 | 0);
     $0 = $2 + 40 | 0;
     if (!(HEAP32[$0 >> 2] | 0)) {
      break label$6
     }
     hashbrown__raw__RawTable_T_2cA___free_buckets__h04a09610ca2977a1($0 | 0);
    }
    label$7 : {
     if (!(HEAP32[($2 + 84 | 0) >> 2] | 0)) {
      break label$7
     }
     $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__h88c250e8947434a9($2 + 64 | 0 | 0);
     $0 = $2 + 80 | 0;
     if (!(HEAP32[$0 >> 2] | 0)) {
      break label$7
     }
     hashbrown__raw__RawTable_T_2cA___free_buckets__ha5e2f3faac433f39($0 | 0);
    }
    label$8 : {
     if (!(HEAP32[($2 + 164 | 0) >> 2] | 0)) {
      break label$8
     }
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h3981a4152bf24dd0($2 + 168 | 0 | 0);
    }
    label$9 : {
     if (!(HEAP32[($2 + 180 | 0) >> 2] | 0)) {
      break label$9
     }
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h98bad0b07702c13e($2 + 180 | 0 | 0);
    }
    $0 = $2 + 272 | 0;
    label$10 : {
     if (!(HEAP32[($2 + 192 | 0) >> 2] | 0)) {
      break label$10
     }
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h72de9eab2f0e4669($2 + 192 | 0 | 0);
    }
    $2 = $0;
    if (($2 | 0) != ($3 | 0)) {
     continue label$2
    }
    break label$2;
   };
  }
 }
 
 function $cardano_serialization_lib__plutus__ConstrPlutusData_20as_20cbor_event__se__Serialize___serialize__h1577784212376b9e($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, $4 = 0, $4$hi = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         i64toi32_i32$2 = $1;
         i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
         i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
         $4 = i64toi32_i32$0;
         $4$hi = i64toi32_i32$1;
         i64toi32_i32$2 = i64toi32_i32$0;
         i64toi32_i32$0 = 0;
         i64toi32_i32$3 = 6;
         if (i64toi32_i32$1 >>> 0 > i64toi32_i32$0 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$2 >>> 0 > i64toi32_i32$3 >>> 0 | 0) | 0) {
          break label$7
         }
         i64toi32_i32$2 = $4$hi;
         i64toi32_i32$3 = $4;
         i64toi32_i32$1 = 0;
         i64toi32_i32$0 = 121;
         i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
         i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
         if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
          i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
         }
         $4 = i64toi32_i32$4;
         $4$hi = i64toi32_i32$5;
         break label$6;
        }
        i64toi32_i32$5 = $4$hi;
        i64toi32_i32$2 = $4;
        i64toi32_i32$3 = 0;
        i64toi32_i32$0 = 127;
        if (i64toi32_i32$5 >>> 0 > i64toi32_i32$3 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$2 >>> 0 > i64toi32_i32$0 >>> 0 | 0) | 0) {
         break label$5
        }
        i64toi32_i32$2 = $4$hi;
        i64toi32_i32$0 = $4;
        i64toi32_i32$5 = 0;
        i64toi32_i32$3 = 1273;
        i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
        i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
        if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
         i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
        }
        $4 = i64toi32_i32$1;
        $4$hi = i64toi32_i32$4;
       }
       i64toi32_i32$4 = $4$hi;
       cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 6 | 0, $4 | 0, i64toi32_i32$4 | 0);
       if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
        break label$4
       }
       $cardano_serialization_lib__plutus__PlutusList_20as_20cbor_event__se__Serialize___serialize__h4fb04398ef3c9f58($0 | 0, $1 + 8 | 0 | 0, $2 | 0);
       break label$1;
      }
      i64toi32_i32$4 = 0;
      cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 6 | 0, 102 | 0, i64toi32_i32$4 | 0);
      if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      i64toi32_i32$4 = 0;
      cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, 2 | 0, i64toi32_i32$4 | 0);
      if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
       break label$2
      }
      i64toi32_i32$4 = $4$hi;
      cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, $4 | 0, i64toi32_i32$4 | 0);
      label$8 : {
       if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
        break label$8
       }
       $cardano_serialization_lib__plutus__PlutusList_20as_20cbor_event__se__Serialize___serialize__h4fb04398ef3c9f58($0 | 0, $1 + 8 | 0 | 0, $2 | 0);
       break label$1;
      }
      memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
      HEAP32[$0 >> 2] = 1;
      break label$1;
     }
     memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
     HEAP32[$0 >> 2] = 1;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $3 + 48 | 0;
 }
 
 function cryptoxide__curve25519__scalar__scalar64__Scalar__from_bytes__hcfeedd1974a72bb6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $94 = 0, $96 = 0, $97 = 0, $99 = 0, $100 = 0, $101 = 0, $102 = 0, $107 = 0, $108 = 0, $110 = 0, $111 = 0, $112 = 0, $113 = 0, $114 = 0, $116 = 0, $117 = 0, $118 = 0, $119 = 0, $120 = 0, $121 = 0, $122 = 0, $2 = 0, $2$hi = 0, $3 = 0, $3$hi = 0, $4 = 0, $4$hi = 0, $5 = 0, $5$hi = 0, $6 = 0, $6$hi = 0, $7 = 0, $7$hi = 0, $8 = 0, $8$hi = 0, $9 = 0, $9$hi = 0, $10 = 0, $10$hi = 0, $11 = 0, $11$hi = 0, $12 = 0, $12$hi = 0, $13 = 0, $13$hi = 0, $14 = 0, $14$hi = 0, $15 = 0, $15$hi = 0, $16 = 0, $16$hi = 0, $17 = 0, $17$hi = 0, $50 = 0, $52 = 0, $52$hi = 0, $55$hi = 0, $57 = 0, $57$hi = 0, $60 = 0, $60$hi = 0, $63$hi = 0, $65$hi = 0, $66 = 0, $67 = 0, $68 = 0, $68$hi = 0, $70$hi = 0, $71 = 0, $71$hi = 0, $73$hi = 0, $74 = 0, $74$hi = 0, $76$hi = 0, $77 = 0, $78 = 0, $80 = 0, $80$hi = 0, $82$hi = 0, $83 = 0, $83$hi = 0, $85$hi = 0, $86 = 0, $86$hi = 0, $88$hi = 0, $91 = 0, $93 = 0, $93$hi = 0, $95 = 0, $95$hi = 0, $97$hi = 0, $98 = 0, $98$hi = 0, $100$hi = 0, $102$hi = 0, $103 = 0, $104 = 0, $105 = 0, $105$hi = 0, $106 = 0, $106$hi = 0, $108$hi = 0, $109 = 0, $109$hi = 0, $111$hi = 0, $113$hi = 0, $115 = 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0;
  i64toi32_i32$1 = 0;
  $2 = i64toi32_i32$0;
  $2$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 9 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 10 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 11 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = 0;
  $3 = i64toi32_i32$1;
  $3$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 12 | 0) >> 0] | 0;
  i64toi32_i32$1 = 0;
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 13 | 0) >> 0] | 0;
  i64toi32_i32$0 = 0;
  $5 = i64toi32_i32$1;
  $5$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 24 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 25 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 26 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 27 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = 0;
  $6 = i64toi32_i32$0;
  $6$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 23 | 0) >> 0] | 0;
  i64toi32_i32$0 = 0;
  $7 = i64toi32_i32$1;
  $7$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 21 | 0) >> 0] | 0;
  i64toi32_i32$1 = 0;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 22 | 0) >> 0] | 0;
  i64toi32_i32$0 = 0;
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 31 | 0) >> 0] | 0;
  i64toi32_i32$1 = 0;
  $10 = i64toi32_i32$0;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 30 | 0) >> 0] | 0;
  i64toi32_i32$0 = 0;
  $11 = i64toi32_i32$1;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 28 | 0) >> 0] | 0;
  i64toi32_i32$1 = 0;
  $12 = i64toi32_i32$0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 29 | 0) >> 0] | 0;
  i64toi32_i32$0 = 0;
  $13 = i64toi32_i32$1;
  $13$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0;
  i64toi32_i32$1 = 0;
  $14 = i64toi32_i32$0;
  $14$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = 0;
  $15 = i64toi32_i32$1;
  $15$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0;
  i64toi32_i32$1 = 0;
  $16 = i64toi32_i32$0;
  $16$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0;
  i64toi32_i32$0 = 0;
  $17 = i64toi32_i32$1;
  $17$hi = i64toi32_i32$0;
  $50 = $0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 16 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 17 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 18 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 19 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = 0;
  $52 = i64toi32_i32$0;
  $52$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 20 | 0) >> 0] | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $94 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $94 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $55$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $52$hi;
  i64toi32_i32$0 = $52;
  i64toi32_i32$2 = $55$hi;
  i64toi32_i32$3 = $94;
  i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
  i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 16;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
   $96 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
   $96 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
  }
  $57 = $96;
  $57$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 15 | 0) >> 0] | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $97 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $97 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $60 = $97;
  $60$hi = i64toi32_i32$0;
  i64toi32_i32$1 = $1;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 14 | 0) >> 0] | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 48;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
   $99 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
   $99 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
  }
  $63$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $60$hi;
  i64toi32_i32$2 = $60;
  i64toi32_i32$1 = $63$hi;
  i64toi32_i32$3 = $99;
  i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 48;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $100 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   $100 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
  }
  $65$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $57$hi;
  i64toi32_i32$1 = $57;
  i64toi32_i32$0 = $65$hi;
  i64toi32_i32$3 = $100;
  i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
  $66 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $50;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $66;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  $67 = $0;
  i64toi32_i32$0 = $15$hi;
  $68 = $15;
  $68$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $16$hi;
  i64toi32_i32$2 = $16;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $101 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $101 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $70$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $68$hi;
  i64toi32_i32$0 = $68;
  i64toi32_i32$2 = $70$hi;
  i64toi32_i32$3 = $101;
  i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
  $71 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $71$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $17$hi;
  i64toi32_i32$1 = $17;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 40;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
   $102 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
   $102 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
  }
  $73$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $71$hi;
  i64toi32_i32$2 = $71;
  i64toi32_i32$1 = $73$hi;
  i64toi32_i32$3 = $102;
  i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
  $74 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  $74$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $14$hi;
  i64toi32_i32$0 = $14;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 48;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   $107 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $107 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
  }
  $76$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $74$hi;
  i64toi32_i32$1 = $74;
  i64toi32_i32$0 = $76$hi;
  i64toi32_i32$3 = $107;
  i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
  $77 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $67;
  HEAP32[i64toi32_i32$1 >> 2] = $77;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $78 = $0;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$2 = $12;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $108 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $108 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $80 = $108;
  $80$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $13$hi;
  i64toi32_i32$0 = $13;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 40;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   $110 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $110 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
  }
  $82$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $80$hi;
  i64toi32_i32$1 = $80;
  i64toi32_i32$0 = $82$hi;
  i64toi32_i32$3 = $110;
  i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
  $83 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  $83$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $11$hi;
  i64toi32_i32$2 = $11;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 48;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $111 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $111 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $85$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $83$hi;
  i64toi32_i32$0 = $83;
  i64toi32_i32$2 = $85$hi;
  i64toi32_i32$3 = $111;
  i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
  $86 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $86$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$1 = $10;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
   $112 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
   $112 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
  }
  $88$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $86$hi;
  i64toi32_i32$2 = $86;
  i64toi32_i32$1 = $88$hi;
  i64toi32_i32$3 = $112;
  i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $113 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   $113 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
  }
  i64toi32_i32$0 = $78;
  HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] = $113;
  HEAP32[(i64toi32_i32$0 + 36 | 0) >> 2] = i64toi32_i32$2;
  $91 = $0;
  i64toi32_i32$2 = $6$hi;
  i64toi32_i32$1 = $6;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 24;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
   $114 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
   $114 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
  }
  $93 = $114;
  $93$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$2 = $8;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 40;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $116 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $116 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $95 = $116;
  $95$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$0 = $9;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 48;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   $117 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $117 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
  }
  $97$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $95$hi;
  i64toi32_i32$1 = $95;
  i64toi32_i32$0 = $97$hi;
  i64toi32_i32$3 = $117;
  i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
  $98 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  $98$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = $7;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $118 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $118 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $100$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $98$hi;
  i64toi32_i32$0 = $98;
  i64toi32_i32$2 = $100$hi;
  i64toi32_i32$3 = $118;
  i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
  i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 40;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $119 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   $119 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
  }
  $102$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $93$hi;
  i64toi32_i32$2 = $93;
  i64toi32_i32$1 = $102$hi;
  i64toi32_i32$3 = $119;
  i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
  $103 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $91;
  HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] = $103;
  HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] = i64toi32_i32$1;
  $104 = $0;
  i64toi32_i32$1 = $2$hi;
  $105 = $2;
  $105$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $3$hi;
  $106 = $3;
  $106$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $4$hi;
  i64toi32_i32$0 = $4;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   $120 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $120 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
  }
  $108$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $106$hi;
  i64toi32_i32$1 = $106;
  i64toi32_i32$0 = $108$hi;
  i64toi32_i32$3 = $120;
  i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
  $109 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  $109$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $5$hi;
  i64toi32_i32$2 = $5;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 40;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $121 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $121 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $111$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $109$hi;
  i64toi32_i32$0 = $109;
  i64toi32_i32$2 = $111$hi;
  i64toi32_i32$3 = $121;
  i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
  i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 8;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
   $122 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
   $122 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
  }
  $113$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $105$hi;
  i64toi32_i32$2 = $105;
  i64toi32_i32$1 = $113$hi;
  i64toi32_i32$3 = $122;
  i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 16777215;
  i64toi32_i32$3 = -1;
  i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
  $115 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $104;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $115;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
 }
 
 function $alloc__string__String_20as_20core__fmt__Write___write_char__hcabdf1e70d08df58($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ($1 >>> 0 < 128 >>> 0) {
        break label$5
       }
       HEAP32[($2 + 12 | 0) >> 2] = 0;
       if ($1 >>> 0 < 2048 >>> 0) {
        break label$4
       }
       if ($1 >>> 0 >= 65536 >>> 0) {
        break label$3
       }
       HEAP8[($2 + 14 | 0) >> 0] = $1 & 63 | 0 | 128 | 0;
       HEAP8[($2 + 12 | 0) >> 0] = $1 >>> 12 | 0 | 224 | 0;
       HEAP8[($2 + 13 | 0) >> 0] = ($1 >>> 6 | 0) & 63 | 0 | 128 | 0;
       $1 = 3;
       break label$2;
      }
      label$6 : {
       $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
       if (($3 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
        break label$6
       }
       alloc__vec__Vec_T_2cA___reserve__h9cf757d86af8f187($0 | 0, 1 | 0);
       $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
      }
      HEAP8[((HEAP32[$0 >> 2] | 0) + $3 | 0) >> 0] = $1;
      HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
      break label$1;
     }
     HEAP8[($2 + 13 | 0) >> 0] = $1 & 63 | 0 | 128 | 0;
     HEAP8[($2 + 12 | 0) >> 0] = $1 >>> 6 | 0 | 192 | 0;
     $1 = 2;
     break label$2;
    }
    HEAP8[($2 + 15 | 0) >> 0] = $1 & 63 | 0 | 128 | 0;
    HEAP8[($2 + 12 | 0) >> 0] = $1 >>> 18 | 0 | 240 | 0;
    HEAP8[($2 + 14 | 0) >> 0] = ($1 >>> 6 | 0) & 63 | 0 | 128 | 0;
    HEAP8[($2 + 13 | 0) >> 0] = ($1 >>> 12 | 0) & 63 | 0 | 128 | 0;
    $1 = 4;
   }
   alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($0 | 0, $2 + 12 | 0 | 0, $1 | 0);
  }
  global$0 = $2 + 16 | 0;
  return 0 | 0;
 }
 
 function $alloc__string__String_20as_20core__fmt__Write___write_char__hcabdf1e70d08df58_1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ($1 >>> 0 < 128 >>> 0) {
        break label$5
       }
       HEAP32[($2 + 12 | 0) >> 2] = 0;
       if ($1 >>> 0 < 2048 >>> 0) {
        break label$4
       }
       if ($1 >>> 0 >= 65536 >>> 0) {
        break label$3
       }
       HEAP8[($2 + 14 | 0) >> 0] = $1 & 63 | 0 | 128 | 0;
       HEAP8[($2 + 12 | 0) >> 0] = $1 >>> 12 | 0 | 224 | 0;
       HEAP8[($2 + 13 | 0) >> 0] = ($1 >>> 6 | 0) & 63 | 0 | 128 | 0;
       $1 = 3;
       break label$2;
      }
      label$6 : {
       $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
       if (($3 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
        break label$6
       }
       alloc__vec__Vec_T_2cA___reserve__h9cf757d86af8f187($0 | 0, 1 | 0);
       $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
      }
      HEAP8[((HEAP32[$0 >> 2] | 0) + $3 | 0) >> 0] = $1;
      HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
      break label$1;
     }
     HEAP8[($2 + 13 | 0) >> 0] = $1 & 63 | 0 | 128 | 0;
     HEAP8[($2 + 12 | 0) >> 0] = $1 >>> 6 | 0 | 192 | 0;
     $1 = 2;
     break label$2;
    }
    HEAP8[($2 + 15 | 0) >> 0] = $1 & 63 | 0 | 128 | 0;
    HEAP8[($2 + 12 | 0) >> 0] = $1 >>> 18 | 0 | 240 | 0;
    HEAP8[($2 + 14 | 0) >> 0] = ($1 >>> 6 | 0) & 63 | 0 | 128 | 0;
    HEAP8[($2 + 13 | 0) >> 0] = ($1 >>> 12 | 0) & 63 | 0 | 128 | 0;
    $1 = 4;
   }
   alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($0 | 0, $2 + 12 | 0 | 0, $1 | 0);
  }
  global$0 = $2 + 16 | 0;
  return 0 | 0;
 }
 
 function $alloc__string__String_20as_20core__fmt__Write___write_char__hcabdf1e70d08df58_2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ($1 >>> 0 < 128 >>> 0) {
        break label$5
       }
       HEAP32[($2 + 12 | 0) >> 2] = 0;
       if ($1 >>> 0 < 2048 >>> 0) {
        break label$4
       }
       if ($1 >>> 0 >= 65536 >>> 0) {
        break label$3
       }
       HEAP8[($2 + 14 | 0) >> 0] = $1 & 63 | 0 | 128 | 0;
       HEAP8[($2 + 12 | 0) >> 0] = $1 >>> 12 | 0 | 224 | 0;
       HEAP8[($2 + 13 | 0) >> 0] = ($1 >>> 6 | 0) & 63 | 0 | 128 | 0;
       $1 = 3;
       break label$2;
      }
      label$6 : {
       $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
       if (($3 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
        break label$6
       }
       alloc__vec__Vec_T_2cA___reserve__h9cf757d86af8f187($0 | 0, 1 | 0);
       $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
      }
      HEAP8[((HEAP32[$0 >> 2] | 0) + $3 | 0) >> 0] = $1;
      HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
      break label$1;
     }
     HEAP8[($2 + 13 | 0) >> 0] = $1 & 63 | 0 | 128 | 0;
     HEAP8[($2 + 12 | 0) >> 0] = $1 >>> 6 | 0 | 192 | 0;
     $1 = 2;
     break label$2;
    }
    HEAP8[($2 + 15 | 0) >> 0] = $1 & 63 | 0 | 128 | 0;
    HEAP8[($2 + 12 | 0) >> 0] = $1 >>> 18 | 0 | 240 | 0;
    HEAP8[($2 + 14 | 0) >> 0] = ($1 >>> 6 | 0) & 63 | 0 | 128 | 0;
    HEAP8[($2 + 13 | 0) >> 0] = ($1 >>> 12 | 0) & 63 | 0 | 128 | 0;
    $1 = 4;
   }
   alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($0 | 0, $2 + 12 | 0 | 0, $1 | 0);
  }
  global$0 = $2 + 16 | 0;
  return 0 | 0;
 }
 
 function linked_hash_map__LinkedHashMap_K_2cV_2cS___get__hd01b4479ef58cf3f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $5 = 0, $3 = 0, $9 = 0, $4 = 0, $6 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  i64toi32_i32$0 = hashbrown__map__make_hash__h4a9465e979eb9ff6($0 | 0, $1 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $3 = i64toi32_i32$0;
  $4 = (HEAP32[($0 + 16 | 0) >> 2] | 0) & $3 | 0;
  $9 = (HEAP32[($0 + 20 | 0) >> 2] | 0) + $4 | 0;
  $5 = HEAPU8[$9 >> 0] | 0 | ((HEAPU8[($9 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($9 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($9 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $6 = 0;
  HEAP32[($2 + 32 | 0) >> 2] = 0;
  HEAP32[($2 + 36 | 0) >> 2] = $5;
  HEAP32[($2 + 28 | 0) >> 2] = $4;
  HEAP32[($2 + 24 | 0) >> 2] = $0 + 16 | 0;
  $0 = $3 >>> 25 | 0;
  HEAP8[($2 + 44 | 0) >> 0] = $0;
  $0 = $5 ^ Math_imul($0, 16843009) | 0;
  HEAP32[($2 + 40 | 0) >> 2] = (($0 ^ -1 | 0) & ($0 + -16843009 | 0) | 0) & -2139062144 | 0;
  $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($2 + 16 | 0 | 0, $2 + 24 | 0 | 0);
  label$1 : {
   if (!(HEAP32[($2 + 16 | 0) >> 2] | 0)) {
    break label$1
   }
   $3 = $1 + 1 | 0;
   $0 = (HEAP32[((HEAP32[($2 + 24 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) - ((HEAP32[($2 + 20 | 0) >> 2] | 0) << 3 | 0) | 0;
   label$2 : {
    label$3 : while (1) {
     label$4 : {
      $5 = HEAP32[($0 + -8 | 0) >> 2] | 0;
      if ((HEAPU8[$1 >> 0] | 0 | 0) != (HEAPU8[$5 >> 0] | 0 | 0)) {
       break label$4
      }
      if (!(memcmp($3 | 0, $5 + 1 | 0 | 0, 28 | 0) | 0)) {
       break label$2
      }
     }
     $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($2 + 8 | 0 | 0, $2 + 24 | 0 | 0);
     if (!(HEAP32[($2 + 8 | 0) >> 2] | 0)) {
      break label$1
     }
     $0 = (HEAP32[((HEAP32[($2 + 24 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) - ((HEAP32[($2 + 12 | 0) >> 2] | 0) << 3 | 0) | 0;
     continue label$3;
    };
   }
   $6 = HEAP32[($0 + -4 | 0) >> 2] | 0;
  }
  global$0 = $2 + 48 | 0;
  return $6 | 0;
 }
 
 function $alloc__string__String_20as_20core__fmt__Write___write_char__hcabdf1e70d08df58_3($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ($1 >>> 0 < 128 >>> 0) {
        break label$5
       }
       HEAP32[($2 + 12 | 0) >> 2] = 0;
       if ($1 >>> 0 < 2048 >>> 0) {
        break label$4
       }
       if ($1 >>> 0 >= 65536 >>> 0) {
        break label$3
       }
       HEAP8[($2 + 14 | 0) >> 0] = $1 & 63 | 0 | 128 | 0;
       HEAP8[($2 + 12 | 0) >> 0] = $1 >>> 12 | 0 | 224 | 0;
       HEAP8[($2 + 13 | 0) >> 0] = ($1 >>> 6 | 0) & 63 | 0 | 128 | 0;
       $1 = 3;
       break label$2;
      }
      label$6 : {
       $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
       if (($3 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
        break label$6
       }
       alloc__vec__Vec_T_2cA___reserve__h9cf757d86af8f187($0 | 0, 1 | 0);
       $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
      }
      HEAP8[((HEAP32[$0 >> 2] | 0) + $3 | 0) >> 0] = $1;
      HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
      break label$1;
     }
     HEAP8[($2 + 13 | 0) >> 0] = $1 & 63 | 0 | 128 | 0;
     HEAP8[($2 + 12 | 0) >> 0] = $1 >>> 6 | 0 | 192 | 0;
     $1 = 2;
     break label$2;
    }
    HEAP8[($2 + 15 | 0) >> 0] = $1 & 63 | 0 | 128 | 0;
    HEAP8[($2 + 12 | 0) >> 0] = $1 >>> 18 | 0 | 240 | 0;
    HEAP8[($2 + 14 | 0) >> 0] = ($1 >>> 6 | 0) & 63 | 0 | 128 | 0;
    HEAP8[($2 + 13 | 0) >> 0] = ($1 >>> 12 | 0) & 63 | 0 | 128 | 0;
    $1 = 4;
   }
   alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($0 | 0, $2 + 12 | 0 | 0, $1 | 0);
  }
  global$0 = $2 + 16 | 0;
  return 0 | 0;
 }
 
 function cardano_serialization_lib__crypto__Nonce__new_from_hash__he3b161ea641d4ae6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $2 = 0, i64toi32_i32$2 = 0, $3 = 0, $11 = 0, $12 = 0, $13 = 0, $14 = 0, $25 = 0, $30 = 0, $35 = 0, $40 = 0;
  $2 = global$0 - 128 | 0;
  global$0 = $2;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 16 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    $3 = HEAP32[($2 + 20 | 0) >> 2] | 0;
    if ($3 >>> 0 <= 31 >>> 0) {
     break label$2
    }
    $T_20as_20core__convert__TryInto_U____try_into__ha1ac58dc74faf560($2 + 24 | 0 | 0, HEAP32[($2 + 16 | 0) >> 2] | 0 | 0, 32 | 0);
    label$3 : {
     label$4 : {
      if ((HEAPU8[($2 + 24 | 0) >> 0] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      HEAP16[$0 >> 1] = 256;
      i64toi32_i32$2 = $2;
      i64toi32_i32$0 = HEAPU8[($2 + 25 | 0) >> 0] | 0 | ((HEAPU8[($2 + 26 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 27 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 28 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[($2 + 29 | 0) >> 0] | 0 | ((HEAPU8[($2 + 30 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 31 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 32 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $25 = i64toi32_i32$0;
      i64toi32_i32$0 = $0 + 2 | 0;
      $11 = $25;
      HEAP8[i64toi32_i32$0 >> 0] = $11;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      i64toi32_i32$2 = $2 + 49 | 0;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $30 = i64toi32_i32$1;
      i64toi32_i32$1 = $0 + 26 | 0;
      $12 = $30;
      HEAP8[i64toi32_i32$1 >> 0] = $12;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $12 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $12 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $12 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      i64toi32_i32$2 = $2 + 41 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $35 = i64toi32_i32$0;
      i64toi32_i32$0 = $0 + 18 | 0;
      $13 = $35;
      HEAP8[i64toi32_i32$0 >> 0] = $13;
      HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $13 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $13 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $13 >>> 24 | 0;
      HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
      HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
      HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
      HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
      i64toi32_i32$2 = $2 + 33 | 0;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $40 = i64toi32_i32$1;
      i64toi32_i32$1 = $0 + 10 | 0;
      $14 = $40;
      HEAP8[i64toi32_i32$1 >> 0] = $14;
      HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $14 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $14 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $14 >>> 24 | 0;
      HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
      HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
      HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
      HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
      break label$3;
     }
     i64toi32_i32$1 = $2;
     i64toi32_i32$0 = 0;
     HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] = 0;
     HEAP32[(i64toi32_i32$1 + 72 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] = HEAP32[(0 + 1066212 | 0) >> 2] | 0;
     core__fmt__Formatter__new__he219faf25326051b(i64toi32_i32$1 + 80 | 0 | 0, i64toi32_i32$1 + 64 | 0 | 0, 1065900 | 0);
     if ($str_20as_20core__fmt__Display___fmt__hdd03b40cdcec1d4f(1066072 | 0, 32 | 0, i64toi32_i32$1 + 80 | 0 | 0) | 0) {
      break label$1
     }
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $2 + 64 | 0 | 0);
     $3 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0) | 0;
     HEAP8[$0 >> 0] = 1;
     HEAP32[($0 + 4 | 0) >> 2] = $3;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 64 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 64 | 0 | 0);
    }
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
    global$0 = $2 + 128 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345(32 | 0, $3 | 0, 1067176 | 0);
   abort();
  }
  core__result__unwrap_failed__h27f43d993c3864a1(1065924 | 0, 55 | 0, $2 + 120 | 0 | 0, 1066104 | 0, 1066056 | 0);
  abort();
 }
 
 function $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__hb1927774b99cfc2c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $2 = 0, $3 = 0, $8 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $4 = 0, $5 = 0, $6 = 0, $29 = 0, $37 = 0, $40 = 0, $7 = 0, $51 = 0, $55 = 0, $59 = 0, $77 = 0, $80 = 0, $91 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  $core__iter__adapters__ResultShunt_I_2cE__20as_20core__iter__traits__iterator__Iterator___try_fold__h240dbae8a1f4011e($2 + 56 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    $3 = HEAPU8[($2 + 56 | 0) >> 0] | 0;
    if (($3 | 0) != (6 | 0)) {
     break label$2
    }
    i64toi32_i32$1 = $0;
    i64toi32_i32$0 = 0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = 0;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[i64toi32_i32$1 >> 2] = HEAP32[(0 + 1067624 | 0) >> 2] | 0;
    break label$1;
   }
   $4 = $2 + 47 | 0;
   $5 = ($2 + 56 | 0) + 16 | 0;
   i64toi32_i32$2 = $5;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $29 = i64toi32_i32$0;
   i64toi32_i32$0 = $4;
   $21 = $29;
   HEAP8[i64toi32_i32$0 >> 0] = $21;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $21 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $21 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $21 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   $6 = ($2 + 32 | 0) + 8 | 0;
   i64toi32_i32$2 = ($2 + 56 | 0) + 9 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $37 = i64toi32_i32$1;
   i64toi32_i32$1 = $6;
   HEAP32[i64toi32_i32$1 >> 2] = $37;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 57 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 58 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 59 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 60 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 61 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 62 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 63 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 64 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $40 = i64toi32_i32$0;
   i64toi32_i32$0 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] = $40;
   HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] = i64toi32_i32$1;
   alloc__raw_vec__RawVec_T_2cA___allocate_in__h0e767008da1e2eac(i64toi32_i32$2 + 8 | 0 | 0, 1 | 0, 0 | 0);
   $7 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
   $8 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
   HEAP8[$8 >> 0] = $3;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
   $51 = i64toi32_i32$1;
   i64toi32_i32$1 = $8;
   $22 = $51;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $22;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $22 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $22 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = $22 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 8 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $6;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $55 = i64toi32_i32$0;
   i64toi32_i32$0 = $8 + 9 | 0;
   $23 = $55;
   HEAP8[i64toi32_i32$0 >> 0] = $23;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $23 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $23 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $23 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = $4;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $59 = i64toi32_i32$1;
   i64toi32_i32$1 = $8 + 16 | 0;
   $24 = $59;
   HEAP8[i64toi32_i32$1 >> 0] = $24;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $24 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $24 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $24 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   $3 = ($2 + 16 | 0) + 8 | 0;
   HEAP32[$3 >> 2] = 1;
   HEAP32[($2 + 20 | 0) >> 2] = $7;
   HEAP32[($2 + 16 | 0) >> 2] = $8;
   HEAP32[$5 >> 2] = HEAP32[($1 + 16 | 0) >> 2] | 0;
   i64toi32_i32$2 = $1 + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $77 = i64toi32_i32$0;
   i64toi32_i32$0 = ($2 + 56 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $77;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $80 = i64toi32_i32$1;
   i64toi32_i32$1 = $2;
   HEAP32[(i64toi32_i32$1 + 56 | 0) >> 2] = $80;
   HEAP32[(i64toi32_i32$1 + 60 | 0) >> 2] = i64toi32_i32$0;
   alloc__vec__Vec_T_2cA___extend_desugared__hda27c1fc0d14adaa(i64toi32_i32$1 + 16 | 0 | 0, i64toi32_i32$1 + 56 | 0 | 0);
   HEAP32[($0 + 8 | 0) >> 2] = HEAP32[$3 >> 2] | 0;
   i64toi32_i32$2 = i64toi32_i32$1;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
   $91 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[i64toi32_i32$0 >> 2] = $91;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  }
  global$0 = $2 + 80 | 0;
 }
 
 function $alloc__string__String_20as_20core__fmt__Write___write_char__hcabdf1e70d08df58_4($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ($1 >>> 0 < 128 >>> 0) {
       break label$4
      }
      HEAP32[($2 + 12 | 0) >> 2] = 0;
      if ($1 >>> 0 >= 2048 >>> 0) {
       break label$3
      }
      HEAP8[($2 + 13 | 0) >> 0] = $1 & 63 | 0 | 128 | 0;
      HEAP8[($2 + 12 | 0) >> 0] = $1 >>> 6 | 0 | 192 | 0;
      $1 = 2;
      break label$2;
     }
     label$5 : {
      $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
      if (($3 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
       break label$5
      }
      alloc__vec__Vec_T_2cA___reserve__h9cf757d86af8f187($0 | 0, 1 | 0);
      $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
     }
     HEAP8[((HEAP32[$0 >> 2] | 0) + $3 | 0) >> 0] = $1;
     HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
     break label$1;
    }
    label$6 : {
     if ($1 >>> 0 < 65536 >>> 0) {
      break label$6
     }
     HEAP8[($2 + 15 | 0) >> 0] = $1 & 63 | 0 | 128 | 0;
     HEAP8[($2 + 12 | 0) >> 0] = $1 >>> 18 | 0 | 240 | 0;
     HEAP8[($2 + 14 | 0) >> 0] = ($1 >>> 6 | 0) & 63 | 0 | 128 | 0;
     HEAP8[($2 + 13 | 0) >> 0] = ($1 >>> 12 | 0) & 63 | 0 | 128 | 0;
     $1 = 4;
     break label$2;
    }
    HEAP8[($2 + 14 | 0) >> 0] = $1 & 63 | 0 | 128 | 0;
    HEAP8[($2 + 12 | 0) >> 0] = $1 >>> 12 | 0 | 224 | 0;
    HEAP8[($2 + 13 | 0) >> 0] = ($1 >>> 6 | 0) & 63 | 0 | 128 | 0;
    $1 = 3;
   }
   alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($0 | 0, $2 + 12 | 0 | 0, $1 | 0);
  }
  global$0 = $2 + 16 | 0;
  return 0 | 0;
 }
 
 function alloc__slice__insert_head__hb8fe7e978f3960f6($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, $4 = 0, $3 = 0, $8$hi = 0, $8 = 0, $5 = 0, $6 = 0, $7 = 0, $17 = 0, $17$hi = 0, $40$hi = 0, $62$hi = 0;
  $3 = global$0 - 128 | 0;
  global$0 = $3;
  label$1 : {
   if ($1 >>> 0 < 2 >>> 0) {
    break label$1
   }
   i64toi32_i32$2 = $0 + 192 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $17 = i64toi32_i32$0;
   $17$hi = i64toi32_i32$1;
   i64toi32_i32$2 = $0;
   i64toi32_i32$1 = HEAP32[($0 + 64 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($0 + 68 | 0) >> 2] | 0;
   $8 = i64toi32_i32$1;
   $8$hi = i64toi32_i32$0;
   i64toi32_i32$0 = $17$hi;
   i64toi32_i32$2 = $17;
   i64toi32_i32$1 = $8$hi;
   i64toi32_i32$3 = $8;
   if (i64toi32_i32$0 >>> 0 > i64toi32_i32$1 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$2 >>> 0 >= i64toi32_i32$3 >>> 0 | 0) | 0) {
    break label$1
   }
   memcpy($3 + 64 | 0 | 0, $0 | 0, 64 | 0) | 0;
   memcpy($3 + 8 | 0 | 0, $0 + 72 | 0 | 0, 56 | 0) | 0;
   $4 = $0 + 128 | 0;
   $5 = memcpy($0 | 0, $4 | 0, 128 | 0) | 0;
   $0 = 1;
   label$2 : {
    if ($1 >>> 0 < 3 >>> 0) {
     break label$2
    }
    i64toi32_i32$3 = $5 + 320 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $40$hi = i64toi32_i32$0;
    i64toi32_i32$0 = $8$hi;
    i64toi32_i32$0 = $40$hi;
    i64toi32_i32$3 = i64toi32_i32$2;
    i64toi32_i32$2 = $8$hi;
    i64toi32_i32$1 = $8;
    if (i64toi32_i32$0 >>> 0 > i64toi32_i32$2 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$3 >>> 0 >= i64toi32_i32$1 >>> 0 | 0) | 0) {
     break label$2
    }
    $6 = $1 + -1 | 0;
    $0 = $5 + 448 | 0;
    $4 = 3;
    label$3 : {
     label$4 : while (1) {
      memcpy($0 + -320 | 0 | 0, $0 + -192 | 0 | 0, 128 | 0) | 0;
      $7 = $4;
      if (($1 | 0) == ($4 | 0)) {
       break label$3
      }
      $4 = $7 + 1 | 0;
      i64toi32_i32$1 = $0;
      i64toi32_i32$3 = HEAP32[$0 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
      $0 = $0 + 128 | 0;
      $62$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $8$hi;
      i64toi32_i32$0 = $62$hi;
      i64toi32_i32$1 = i64toi32_i32$3;
      i64toi32_i32$3 = $8$hi;
      i64toi32_i32$2 = $8;
      if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0) {
       continue label$4
      }
      break label$4;
     };
     $6 = $4 + -2 | 0;
    }
    $0 = $7 + -1 | 0;
    $4 = $5 + ($6 << 7 | 0) | 0;
   }
   memcpy($4 | 0, $3 + 64 | 0 | 0, 64 | 0) | 0;
   $0 = $5 + ($0 << 7 | 0) | 0;
   i64toi32_i32$1 = $8$hi;
   i64toi32_i32$0 = $0;
   HEAP32[(i64toi32_i32$0 + 64 | 0) >> 2] = $8;
   HEAP32[(i64toi32_i32$0 + 68 | 0) >> 2] = i64toi32_i32$1;
   memcpy(i64toi32_i32$0 + 72 | 0 | 0, $3 + 8 | 0 | 0, 56 | 0) | 0;
  }
  global$0 = $3 + 128 | 0;
 }
 
 function alloc__slice__insert_head__heaf6bc8fe9c35c8c($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, $4 = 0, $3 = 0, $8$hi = 0, $8 = 0, $5 = 0, $6 = 0, $7 = 0, $17 = 0, $17$hi = 0, $40$hi = 0, $62$hi = 0;
  $3 = global$0 - 128 | 0;
  global$0 = $3;
  label$1 : {
   if ($1 >>> 0 < 2 >>> 0) {
    break label$1
   }
   i64toi32_i32$2 = $0 + 192 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $17 = i64toi32_i32$0;
   $17$hi = i64toi32_i32$1;
   i64toi32_i32$2 = $0;
   i64toi32_i32$1 = HEAP32[($0 + 64 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($0 + 68 | 0) >> 2] | 0;
   $8 = i64toi32_i32$1;
   $8$hi = i64toi32_i32$0;
   i64toi32_i32$0 = $17$hi;
   i64toi32_i32$2 = $17;
   i64toi32_i32$1 = $8$hi;
   i64toi32_i32$3 = $8;
   if (i64toi32_i32$0 >>> 0 > i64toi32_i32$1 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$2 >>> 0 >= i64toi32_i32$3 >>> 0 | 0) | 0) {
    break label$1
   }
   memcpy($3 + 64 | 0 | 0, $0 | 0, 64 | 0) | 0;
   memcpy($3 + 8 | 0 | 0, $0 + 72 | 0 | 0, 56 | 0) | 0;
   $4 = $0 + 128 | 0;
   $5 = memcpy($0 | 0, $4 | 0, 128 | 0) | 0;
   $0 = 1;
   label$2 : {
    if ($1 >>> 0 < 3 >>> 0) {
     break label$2
    }
    i64toi32_i32$3 = $5 + 320 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $40$hi = i64toi32_i32$0;
    i64toi32_i32$0 = $8$hi;
    i64toi32_i32$0 = $40$hi;
    i64toi32_i32$3 = i64toi32_i32$2;
    i64toi32_i32$2 = $8$hi;
    i64toi32_i32$1 = $8;
    if (i64toi32_i32$0 >>> 0 > i64toi32_i32$2 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$3 >>> 0 >= i64toi32_i32$1 >>> 0 | 0) | 0) {
     break label$2
    }
    $6 = $1 + -1 | 0;
    $0 = $5 + 448 | 0;
    $4 = 3;
    label$3 : {
     label$4 : while (1) {
      memcpy($0 + -320 | 0 | 0, $0 + -192 | 0 | 0, 128 | 0) | 0;
      $7 = $4;
      if (($1 | 0) == ($4 | 0)) {
       break label$3
      }
      $4 = $7 + 1 | 0;
      i64toi32_i32$1 = $0;
      i64toi32_i32$3 = HEAP32[$0 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
      $0 = $0 + 128 | 0;
      $62$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $8$hi;
      i64toi32_i32$0 = $62$hi;
      i64toi32_i32$1 = i64toi32_i32$3;
      i64toi32_i32$3 = $8$hi;
      i64toi32_i32$2 = $8;
      if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0) {
       continue label$4
      }
      break label$4;
     };
     $6 = $4 + -2 | 0;
    }
    $0 = $7 + -1 | 0;
    $4 = $5 + ($6 << 7 | 0) | 0;
   }
   memcpy($4 | 0, $3 + 64 | 0 | 0, 64 | 0) | 0;
   $0 = $5 + ($0 << 7 | 0) | 0;
   i64toi32_i32$1 = $8$hi;
   i64toi32_i32$0 = $0;
   HEAP32[(i64toi32_i32$0 + 64 | 0) >> 2] = $8;
   HEAP32[(i64toi32_i32$0 + 68 | 0) >> 2] = i64toi32_i32$1;
   memcpy(i64toi32_i32$0 + 72 | 0 | 0, $3 + 8 | 0 | 0, 56 | 0) | 0;
  }
  global$0 = $3 + 128 | 0;
 }
 
 function $alloc__string__String_20as_20core__fmt__Write___write_char__hcabdf1e70d08df58_5($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ($1 >>> 0 < 128 >>> 0) {
        break label$5
       }
       HEAP32[($2 + 12 | 0) >> 2] = 0;
       if ($1 >>> 0 < 2048 >>> 0) {
        break label$4
       }
       if ($1 >>> 0 >= 65536 >>> 0) {
        break label$3
       }
       HEAP8[($2 + 14 | 0) >> 0] = $1 & 63 | 0 | 128 | 0;
       HEAP8[($2 + 12 | 0) >> 0] = $1 >>> 12 | 0 | 224 | 0;
       HEAP8[($2 + 13 | 0) >> 0] = ($1 >>> 6 | 0) & 63 | 0 | 128 | 0;
       $1 = 3;
       break label$2;
      }
      label$6 : {
       $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
       if (($3 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
        break label$6
       }
       alloc__vec__Vec_T_2cA___reserve__h9cf757d86af8f187($0 | 0, 1 | 0);
       $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
      }
      HEAP8[((HEAP32[$0 >> 2] | 0) + $3 | 0) >> 0] = $1;
      HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
      break label$1;
     }
     HEAP8[($2 + 13 | 0) >> 0] = $1 & 63 | 0 | 128 | 0;
     HEAP8[($2 + 12 | 0) >> 0] = $1 >>> 6 | 0 | 192 | 0;
     $1 = 2;
     break label$2;
    }
    HEAP8[($2 + 15 | 0) >> 0] = $1 & 63 | 0 | 128 | 0;
    HEAP8[($2 + 12 | 0) >> 0] = $1 >>> 18 | 0 | 240 | 0;
    HEAP8[($2 + 14 | 0) >> 0] = ($1 >>> 6 | 0) & 63 | 0 | 128 | 0;
    HEAP8[($2 + 13 | 0) >> 0] = ($1 >>> 12 | 0) & 63 | 0 | 128 | 0;
    $1 = 4;
   }
   alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($0 | 0, $2 + 12 | 0 | 0, $1 | 0);
  }
  global$0 = $2 + 16 | 0;
  return 0 | 0;
 }
 
 function cardano_serialization_lib__address__ByronAddress__to_address__h596b6d78801bce8a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $2 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $24 = 0, $25 = 0, $27 = 0, $28 = 0, $29 = 0, $30 = 0, $31 = 0, $3 = 0, $4 = 0, $18 = 0, $23 = 0, $26 = 0, $4$hi = 0, $5 = 0, $5$hi = 0, $48 = 0, $54 = 0, $60 = 0, $83 = 0, $88 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  $19 = $1 + 44 | 0;
  HEAP32[($2 + 56 | 0) >> 2] = HEAPU8[$19 >> 0] | 0 | ((HEAPU8[($19 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($19 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($19 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $1 + 36 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 48 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 28 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $23 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 40 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $23;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 20 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 21 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 22 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 23 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 24 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 25 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 26 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 27 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $26 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] = $26;
  HEAP32[(i64toi32_i32$0 + 36 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    if (HEAP32[i64toi32_i32$2 >> 2] | 0) {
     break label$2
    }
    HEAP32[$2 >> 2] = 0;
    break label$1;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($2 | 0, $1 | 0);
  }
  $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] = $3;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $4 = i64toi32_i32$1;
  $4$hi = i64toi32_i32$0;
  i64toi32_i32$1 = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] = $4;
  HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
  $48 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 24 | 0;
  $20 = $48;
  HEAP8[i64toi32_i32$1 >> 0] = $20;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $20 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $20 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $20 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = (i64toi32_i32$2 + 32 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $54 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 32 | 0;
  $21 = $54;
  HEAP8[i64toi32_i32$0 >> 0] = $21;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $21 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $21 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $21 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = ($2 + 32 | 0) + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $60 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 40 | 0;
  $22 = $60;
  HEAP8[i64toi32_i32$1 >> 0] = $22;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $22 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $22 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $22 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $24 = $0 + 48 | 0;
  $25 = HEAP32[(($2 + 32 | 0) + 24 | 0) >> 2] | 0;
  HEAP8[$24 >> 0] = $25;
  HEAP8[($24 + 1 | 0) >> 0] = $25 >>> 8 | 0;
  HEAP8[($24 + 2 | 0) >> 0] = $25 >>> 16 | 0;
  HEAP8[($24 + 3 | 0) >> 0] = $25 >>> 24 | 0;
  $27 = $2 + 11 | 0;
  $28 = $3;
  HEAP8[$27 >> 0] = $28;
  HEAP8[($27 + 1 | 0) >> 0] = $28 >>> 8 | 0;
  HEAP8[($27 + 2 | 0) >> 0] = $28 >>> 16 | 0;
  HEAP8[($27 + 3 | 0) >> 0] = $28 >>> 24 | 0;
  i64toi32_i32$0 = $4$hi;
  i64toi32_i32$1 = $2;
  $29 = $4;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $29;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = $29 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = $29 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = $29 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 8 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 9 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 10 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $1 = HEAPU8[($1 + 48 | 0) >> 0] | 0;
  HEAP8[$0 >> 0] = 4;
  HEAP8[($0 + 52 | 0) >> 0] = $1;
  i64toi32_i32$0 = $5$hi;
  i64toi32_i32$1 = $0 + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $5;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $83 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  $30 = $83;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $30;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $30 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $30 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = $30 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 8 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 7 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $88 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 8 | 0;
  $31 = $88;
  HEAP8[i64toi32_i32$1 >> 0] = $31;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $31 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $31 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $31 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  global$0 = $2 + 64 | 0;
 }
 
 function address_to_bech32($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $5 = 0, $48 = 0, $68 = 0, $80 = 0, $86 = 0;
  $4 = global$0 - 80 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    if (!$1) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__hab2c0cbdcb539b91($4 + 24 | 0 | 0, $1 | 0);
    $1 = HEAP32[($4 + 28 | 0) >> 2] | 0;
    $5 = HEAP32[($4 + 24 | 0) >> 2] | 0;
    label$3 : {
     label$4 : {
      if (!$2) {
       break label$4
      }
      HEAP32[($4 + 40 | 0) >> 2] = $3;
      HEAP32[($4 + 36 | 0) >> 2] = $3;
      HEAP32[($4 + 32 | 0) >> 2] = $2;
      alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($4 + 16 | 0 | 0, $4 + 32 | 0 | 0);
      $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($4 + 48 | 0 | 0, HEAP32[($4 + 16 | 0) >> 2] | 0 | 0, HEAP32[($4 + 20 | 0) >> 2] | 0 | 0);
      break label$3;
     }
     HEAP32[($4 + 48 | 0) >> 2] = 0;
    }
    $2 = ($4 + 64 | 0) + 8 | 0;
    $3 = ($4 + 48 | 0) + 8 | 0;
    HEAP32[$2 >> 2] = HEAP32[$3 >> 2] | 0;
    i64toi32_i32$2 = $4;
    i64toi32_i32$0 = HEAP32[($4 + 48 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($4 + 52 | 0) >> 2] | 0;
    $48 = i64toi32_i32$0;
    i64toi32_i32$0 = $4;
    HEAP32[($4 + 64 | 0) >> 2] = $48;
    HEAP32[($4 + 68 | 0) >> 2] = i64toi32_i32$1;
    cardano_serialization_lib__address__Address__to_bech32__hbfd70d34cd59700e($4 + 32 | 0 | 0, $5 | 0, $4 + 64 | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
    $1 = HEAP32[($4 + 36 | 0) >> 2] | 0;
    if ((HEAP32[($4 + 32 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    i64toi32_i32$2 = ($4 + 32 | 0) + 8 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $68 = i64toi32_i32$1;
    i64toi32_i32$1 = $4;
    HEAP32[($4 + 52 | 0) >> 2] = $68;
    HEAP32[($4 + 56 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($4 + 48 | 0) >> 2] = $1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($4 + 8 | 0 | 0, $4 + 48 | 0 | 0);
    HEAP32[$2 >> 2] = HEAP32[$3 >> 2] | 0;
    i64toi32_i32$2 = $4;
    i64toi32_i32$0 = HEAP32[($4 + 48 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($4 + 52 | 0) >> 2] | 0;
    $80 = i64toi32_i32$0;
    i64toi32_i32$0 = $4;
    HEAP32[($4 + 64 | 0) >> 2] = $80;
    HEAP32[($4 + 68 | 0) >> 2] = i64toi32_i32$1;
    alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($4 | 0, $4 + 64 | 0 | 0);
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[$4 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($4 + 4 | 0) >> 2] | 0;
    $86 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[i64toi32_i32$1 >> 2] = $86;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    global$0 = $4 + 80 | 0;
    return;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
  abort();
 }
 
 function rand__rngs__thread__THREAD_RNG_KEY____getit__h0517a5ff212241c2() {
  var $0 = 0, i64toi32_i32$1 = 0, $1 = 0, i64toi32_i32$0 = 0, $2 = 0;
  $0 = global$0 - 768 | 0;
  global$0 = $0;
  label$1 : {
   label$2 : {
    if (HEAP32[(0 + 1177752 | 0) >> 2] | 0) {
     break label$2
    }
    rand_core__SeedableRng__from_rng__h076979c7accc940d($0 + 376 | 0 | 0);
    if ((HEAP32[($0 + 376 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    memcpy($0 + 16 | 0 | 0, $0 + 384 | 0 | 0, 48 | 0) | 0;
    $rand_chacha__chacha__Array64_T__20as_20core__default__Default___default__hc22bd4d391ff716e($0 + 376 | 0 | 0);
    memcpy($0 + 720 | 0 | 0, $0 + 16 | 0 | 0, 48 | 0) | 0;
    $rand_chacha__chacha__Array64_T__20as_20core__convert__AsRef__5bT_5d____as_ref__h92537188a965f192($0 + 8 | 0 | 0, $0 + 376 | 0 | 0);
    $1 = HEAP32[($0 + 12 | 0) >> 2] | 0;
    memcpy($0 + 120 | 0 | 0, $0 + 376 | 0 | 0, 256 | 0) | 0;
    memcpy($0 + 68 | 0 | 0, $0 + 716 | 0 | 0, 52 | 0) | 0;
    memcpy($0 + 376 | 0 | 0, $0 + 120 | 0 | 0, 256 | 0) | 0;
    HEAP32[($0 + 632 | 0) >> 2] = $1;
    memcpy($0 + 636 | 0 | 0, $0 + 68 | 0 | 0, 52 | 0) | 0;
    HEAP32[($0 + 704 | 0) >> 2] = 0;
    i64toi32_i32$1 = $0 + 696 | 0;
    i64toi32_i32$0 = 0;
    HEAP32[i64toi32_i32$1 >> 2] = 65536;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$1 = $0 + 688 | 0;
    i64toi32_i32$0 = 0;
    HEAP32[i64toi32_i32$1 >> 2] = 65536;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    $2 = alloc__rc__Rc_T___new__h253fb66de434ba19($0 + 376 | 0 | 0) | 0;
    $1 = HEAP32[(0 + 1177752 | 0) >> 2] | 0;
    HEAP32[(0 + 1177752 | 0) >> 2] = $2;
    HEAP32[($0 + 376 | 0) >> 2] = $1;
    if (!$1) {
     break label$2
    }
    $alloc__rc__Rc_T__20as_20core__ops__drop__Drop___drop__h9c6f1ce9a80847e3($0 + 376 | 0 | 0);
   }
   global$0 = $0 + 768 | 0;
   return 1177752 | 0;
  }
  rand__rngs__thread__THREAD_RNG_KEY____init___7b_7bclosure_7d_7d__h3b0f67c8281ffceb(HEAP32[($0 + 380 | 0) >> 2] | 0 | 0, HEAP32[($0 + 384 | 0) >> 2] | 0 | 0);
  abort();
 }
 
 function num_bigint__biguint__multiplication__bigint_from_slice__h8cdeba7959ca8cf0($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $4 = 0, $3 = 0, $5 = 0, $6 = 0, $7 = 0;
  $3 = global$0 - 32 | 0;
  global$0 = $3;
  $4 = 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__hb0817f92bbb8999a($3 + 8 | 0 | 0, $2 | 0, 0 | 0);
  $5 = HEAP32[($3 + 12 | 0) >> 2] | 0;
  $6 = HEAP32[($3 + 8 | 0) >> 2] | 0;
  $7 = $2 << 2 | 0;
  $1 = memcpy($6 | 0, $1 | 0, $7 | 0) | 0;
  HEAP32[($3 + 24 | 0) >> 2] = $2;
  HEAP32[($3 + 20 | 0) >> 2] = $5;
  HEAP32[($3 + 16 | 0) >> 2] = $1;
  label$1 : {
   if (!$2) {
    break label$1
   }
   $4 = ($7 + $1 | 0) + -4 | 0;
   label$2 : {
    label$3 : while (1) {
     label$4 : {
      if (!(HEAP32[$4 >> 2] | 0)) {
       break label$4
      }
      $4 = $2;
      break label$2;
     }
     $4 = $4 + -4 | 0;
     $2 = $2 + -1 | 0;
     if ($2) {
      continue label$3
     }
     break label$3;
    };
    $4 = 0;
   }
   HEAP32[($3 + 24 | 0) >> 2] = $4;
  }
  label$5 : {
   if ($4 >>> 0 >= ($5 >>> 2 | 0) >>> 0) {
    break label$5
   }
   if ($5 >>> 0 <= $4 >>> 0) {
    break label$5
   }
   alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($3 + 16 | 0 | 0, $4 | 0);
   $5 = HEAP32[($3 + 20 | 0) >> 2] | 0;
   $6 = HEAP32[($3 + 16 | 0) >> 2] | 0;
   $4 = HEAP32[($3 + 24 | 0) >> 2] | 0;
  }
  label$6 : {
   label$7 : {
    if (!$4) {
     break label$7
    }
    HEAP32[($0 + 8 | 0) >> 2] = $4;
    HEAP32[($0 + 4 | 0) >> 2] = $5;
    HEAP32[$0 >> 2] = $6;
    $4 = 2;
    break label$6;
   }
   HEAP32[($0 + 4 | 0) >> 2] = 0;
   HEAP32[($0 + 8 | 0) >> 2] = 0;
   HEAP32[$0 >> 2] = HEAP32[(0 + 1082808 | 0) >> 2] | 0;
   $4 = 1;
   if (!$5) {
    break label$6
   }
   $2 = $5 << 2 | 0;
   if (!$2) {
    break label$6
   }
   __rust_dealloc($6 | 0, $2 | 0, 4 | 0);
  }
  HEAP8[($0 + 12 | 0) >> 0] = $4;
  global$0 = $3 + 32 | 0;
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___entry__he15124f74c251d46($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $4 = 0, $3 = 0, $5 = 0, $47 = 0, $53 = 0, $57 = 0, $62 = 0, $65 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$4) {
     break label$2
    }
    $5 = HEAP32[$1 >> 2] | 0;
    break label$1;
   }
   $5 = 0;
   $4 = alloc__boxed__Box_T_2cA___new_uninit_in__h8a2711313b9ea9b8() | 0;
   HEAP16[($4 + 402 | 0) >> 1] = 0;
   HEAP32[($4 + 264 | 0) >> 2] = 0;
   HEAP32[($1 + 4 | 0) >> 2] = $4;
   HEAP32[$1 >> 2] = 0;
  }
  alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__h805192557e263194($3 + 8 | 0 | 0, $5 | 0, $4 | 0, $2 | 0);
  $5 = 1;
  $4 = $3 + 8 | 0 | 4 | 0;
  label$3 : {
   label$4 : {
    if ((HEAP32[($3 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
     break label$4
    }
    $5 = ($3 + 24 | 0) + 8 | 0;
    HEAP32[$5 >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
    HEAP32[(($3 + 24 | 0) + 20 | 0) >> 2] = HEAP32[($4 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $47 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $47;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = $1;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $53 = i64toi32_i32$1;
    i64toi32_i32$1 = $3;
    HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] = $53;
    HEAP32[(i64toi32_i32$1 + 40 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $5;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $57 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 12 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $57;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $3 + 40 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $62 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 20 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $62;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    $5 = 0;
    break label$3;
   }
   i64toi32_i32$2 = $4;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $65 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $65;
   HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $1;
   HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   if (!$1) {
    break label$3
   }
   $5 = 1;
   __rust_dealloc(HEAP32[$2 >> 2] | 0 | 0, $1 | 0, 1 | 0);
  }
  HEAP32[$0 >> 2] = $5;
  global$0 = $3 + 48 | 0;
 }
 
 function $serde_json__error__ErrorCode_20as_20core__fmt__Display___fmt__h3ed16ca1538b4d8c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   switch (HEAP32[$0 >> 2] | 0 | 0) {
   default:
    return core__fmt__Formatter__write_str__h8d6b3db46091fabc($1 | 0, HEAP32[($0 + 4 | 0) >> 2] | 0 | 0, HEAP32[($0 + 8 | 0) >> 2] | 0 | 0) | 0 | 0;
   case 1:
    return $std__io__error__Error_20as_20core__fmt__Display___fmt__h141afc8863ce4203($0 + 4 | 0 | 0, $1 | 0) | 0 | 0;
   case 2:
    return core__fmt__Formatter__write_str__h8d6b3db46091fabc($1 | 0, 1088900 | 0, 24 | 0) | 0 | 0;
   case 3:
    return core__fmt__Formatter__write_str__h8d6b3db46091fabc($1 | 0, 1088873 | 0, 27 | 0) | 0 | 0;
   case 4:
    return core__fmt__Formatter__write_str__h8d6b3db46091fabc($1 | 0, 1088847 | 0, 26 | 0) | 0 | 0;
   case 5:
    return core__fmt__Formatter__write_str__h8d6b3db46091fabc($1 | 0, 1088822 | 0, 25 | 0) | 0 | 0;
   case 6:
    return core__fmt__Formatter__write_str__h8d6b3db46091fabc($1 | 0, 1088810 | 0, 12 | 0) | 0 | 0;
   case 7:
    return core__fmt__Formatter__write_str__h8d6b3db46091fabc($1 | 0, 1088791 | 0, 19 | 0) | 0 | 0;
   case 8:
    return core__fmt__Formatter__write_str__h8d6b3db46091fabc($1 | 0, 1088772 | 0, 19 | 0) | 0 | 0;
   case 9:
    return core__fmt__Formatter__write_str__h8d6b3db46091fabc($1 | 0, 1088758 | 0, 14 | 0) | 0 | 0;
   case 10:
    return core__fmt__Formatter__write_str__h8d6b3db46091fabc($1 | 0, 1088744 | 0, 14 | 0) | 0 | 0;
   case 11:
    return core__fmt__Formatter__write_str__h8d6b3db46091fabc($1 | 0, 1088730 | 0, 14 | 0) | 0 | 0;
   case 12:
    return core__fmt__Formatter__write_str__h8d6b3db46091fabc($1 | 0, 1088716 | 0, 14 | 0) | 0 | 0;
   case 13:
    return core__fmt__Formatter__write_str__h8d6b3db46091fabc($1 | 0, 1088697 | 0, 19 | 0) | 0 | 0;
   case 14:
    return core__fmt__Formatter__write_str__h8d6b3db46091fabc($1 | 0, 1088671 | 0, 26 | 0) | 0 | 0;
   case 15:
    return core__fmt__Formatter__write_str__h8d6b3db46091fabc($1 | 0, 1088609 | 0, 62 | 0) | 0 | 0;
   case 16:
    return core__fmt__Formatter__write_str__h8d6b3db46091fabc($1 | 0, 1088589 | 0, 20 | 0) | 0 | 0;
   case 17:
    return core__fmt__Formatter__write_str__h8d6b3db46091fabc($1 | 0, 1088553 | 0, 36 | 0) | 0 | 0;
   case 18:
    return core__fmt__Formatter__write_str__h8d6b3db46091fabc($1 | 0, 1088539 | 0, 14 | 0) | 0 | 0;
   case 19:
    return core__fmt__Formatter__write_str__h8d6b3db46091fabc($1 | 0, 1088520 | 0, 19 | 0) | 0 | 0;
   case 20:
    return core__fmt__Formatter__write_str__h8d6b3db46091fabc($1 | 0, 1088492 | 0, 28 | 0) | 0 | 0;
   case 21:
    break label$1;
   };
  }
  return core__fmt__Formatter__write_str__h8d6b3db46091fabc($1 | 0, 1088468 | 0, 24 | 0) | 0 | 0;
 }
 
 function $bech32__Error_20as_20core__fmt__Debug___fmt__hbaf6712a5e4c483d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    switch (HEAPU8[$0 >> 0] | 0 | 0) {
    default:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 + 16 | 0 | 0, $1 | 0, 1139068 | 0, 16 | 0);
     $0 = core__fmt__builders__DebugTuple__finish__hc3c3f1efaa75a6e2($2 + 16 | 0 | 0) | 0;
     break label$1;
    case 1:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 + 16 | 0 | 0, $1 | 0, 1139053 | 0, 15 | 0);
     $0 = core__fmt__builders__DebugTuple__finish__hc3c3f1efaa75a6e2($2 + 16 | 0 | 0) | 0;
     break label$1;
    case 2:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 + 16 | 0 | 0, $1 | 0, 1139040 | 0, 13 | 0);
     $0 = core__fmt__builders__DebugTuple__finish__hc3c3f1efaa75a6e2($2 + 16 | 0 | 0) | 0;
     break label$1;
    case 3:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 + 16 | 0 | 0, $1 | 0, 1139010 | 0, 11 | 0);
     HEAP32[($2 + 12 | 0) >> 2] = $0 + 4 | 0;
     core__fmt__builders__DebugTuple__field__h5e7e3e19ad5aa557($2 + 16 | 0 | 0, $2 + 12 | 0 | 0, 1139024 | 0) | 0;
     $0 = core__fmt__builders__DebugTuple__finish__hc3c3f1efaa75a6e2($2 + 16 | 0 | 0) | 0;
     break label$1;
    case 4:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 + 16 | 0 | 0, $1 | 0, 1138999 | 0, 11 | 0);
     HEAP32[($2 + 12 | 0) >> 2] = $0 + 1 | 0;
     core__fmt__builders__DebugTuple__field__h5e7e3e19ad5aa557($2 + 16 | 0 | 0, $2 + 12 | 0 | 0, 1138960 | 0) | 0;
     $0 = core__fmt__builders__DebugTuple__finish__hc3c3f1efaa75a6e2($2 + 16 | 0 | 0) | 0;
     break label$1;
    case 5:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 + 16 | 0 | 0, $1 | 0, 1138985 | 0, 14 | 0);
     $0 = core__fmt__builders__DebugTuple__finish__hc3c3f1efaa75a6e2($2 + 16 | 0 | 0) | 0;
     break label$1;
    case 6:
     break label$2;
    };
   }
   core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 + 16 | 0 | 0, $1 | 0, 1138976 | 0, 9 | 0);
   $0 = core__fmt__builders__DebugTuple__finish__hc3c3f1efaa75a6e2($2 + 16 | 0 | 0) | 0;
  }
  global$0 = $2 + 32 | 0;
  return $0 | 0;
 }
 
 function $cbor_event__types__Special_20as_20core__fmt__Debug___fmt__haaa42be3d895b1a3($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    switch (HEAPU8[$0 >> 0] | 0 | 0) {
    default:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 + 16 | 0 | 0, $1 | 0, 1140073 | 0, 4 | 0);
     HEAP32[($2 + 12 | 0) >> 2] = $0 + 1 | 0;
     core__fmt__builders__DebugTuple__field__h5e7e3e19ad5aa557($2 + 16 | 0 | 0, $2 + 12 | 0 | 0, 1140080 | 0) | 0;
     $0 = core__fmt__builders__DebugTuple__finish__hc3c3f1efaa75a6e2($2 + 16 | 0 | 0) | 0;
     break label$1;
    case 1:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 + 16 | 0 | 0, $1 | 0, 1140069 | 0, 4 | 0);
     $0 = core__fmt__builders__DebugTuple__finish__hc3c3f1efaa75a6e2($2 + 16 | 0 | 0) | 0;
     break label$1;
    case 2:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 + 16 | 0 | 0, $1 | 0, 1140060 | 0, 9 | 0);
     $0 = core__fmt__builders__DebugTuple__finish__hc3c3f1efaa75a6e2($2 + 16 | 0 | 0) | 0;
     break label$1;
    case 3:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 + 16 | 0 | 0, $1 | 0, 1140032 | 0, 10 | 0);
     HEAP32[($2 + 12 | 0) >> 2] = $0 + 1 | 0;
     core__fmt__builders__DebugTuple__field__h5e7e3e19ad5aa557($2 + 16 | 0 | 0, $2 + 12 | 0 | 0, 1140044 | 0) | 0;
     $0 = core__fmt__builders__DebugTuple__finish__hc3c3f1efaa75a6e2($2 + 16 | 0 | 0) | 0;
     break label$1;
    case 4:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 + 16 | 0 | 0, $1 | 0, 1140010 | 0, 5 | 0);
     HEAP32[($2 + 12 | 0) >> 2] = $0 + 8 | 0;
     core__fmt__builders__DebugTuple__field__h5e7e3e19ad5aa557($2 + 16 | 0 | 0, $2 + 12 | 0 | 0, 1140016 | 0) | 0;
     $0 = core__fmt__builders__DebugTuple__finish__hc3c3f1efaa75a6e2($2 + 16 | 0 | 0) | 0;
     break label$1;
    case 5:
     break label$2;
    };
   }
   core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 + 16 | 0 | 0, $1 | 0, 1140005 | 0, 5 | 0);
   $0 = core__fmt__builders__DebugTuple__finish__hc3c3f1efaa75a6e2($2 + 16 | 0 | 0) | 0;
  }
  global$0 = $2 + 32 | 0;
  return $0 | 0;
 }
 
 function cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__add_plutus_script_input__hdd1b935f94ddad7d($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $5 = 0, $29 = 0, $35 = 0, $38 = 0, $6 = 0, $6$hi = 0, $61 = 0, $69 = 0;
  $4 = global$0 - 368 | 0;
  global$0 = $4;
  $5 = $1 + 128 | 0;
  cardano_serialization_lib__plutus__PlutusScript__hash__hf798a55ecc919284($4 | 0, $5 | 0);
  cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__add_script_input__ha8e1111a100bff34($0 | 0, $4 | 0, $2 | 0, $3 | 0);
  HEAP32[(($4 + 184 | 0) + 24 | 0) >> 2] = HEAP32[($4 + 24 | 0) >> 2] | 0;
  i64toi32_i32$2 = $4 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $29 = i64toi32_i32$0;
  i64toi32_i32$0 = ($4 + 184 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $29;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $4 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $35 = i64toi32_i32$1;
  i64toi32_i32$1 = ($4 + 184 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $35;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[$4 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
  $38 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[($4 + 184 | 0) >> 2] = $38;
  HEAP32[($4 + 188 | 0) >> 2] = i64toi32_i32$1;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3(($4 + 32 | 0) + 128 | 0 | 0, $5 | 0);
  $cardano_serialization_lib__plutus__PlutusData_20as_20core__clone__Clone___clone__h63d1a98cc18f4609_1($4 + 32 | 0 | 0, $1 | 0);
  $2 = HEAPU8[($1 + 120 | 0) >> 0] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] | 0;
  $6 = i64toi32_i32$1;
  $6$hi = i64toi32_i32$0;
  $3 = ($4 + 216 | 0) + 8 | 0;
  $cardano_serialization_lib__plutus__PlutusData_20as_20core__clone__Clone___clone__h63d1a98cc18f4609_1($3 | 0, i64toi32_i32$2 + 56 | 0 | 0);
  i64toi32_i32$2 = i64toi32_i32$2 + 112 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $61 = i64toi32_i32$0;
  i64toi32_i32$0 = $4 + 280 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $61;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP8[($4 + 288 | 0) >> 0] = $2;
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$0 = $4;
  HEAP32[($4 + 216 | 0) >> 2] = $6;
  HEAP32[($4 + 220 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 104 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $69 = i64toi32_i32$1;
  i64toi32_i32$1 = $4;
  HEAP32[($4 + 272 | 0) >> 2] = $69;
  HEAP32[($4 + 276 | 0) >> 2] = i64toi32_i32$0;
  memcpy($4 + 80 | 0 | 0, $4 + 216 | 0 | 0, 80 | 0) | 0;
  memcpy($3 | 0, $4 + 32 | 0 | 0, 144 | 0) | 0;
  i64toi32_i32$1 = $4;
  i64toi32_i32$0 = 0;
  HEAP32[($4 + 216 | 0) >> 2] = 1;
  HEAP32[($4 + 220 | 0) >> 2] = i64toi32_i32$0;
  linked_hash_map__LinkedHashMap_K_2cV_2cS___insert__h0e2ff8a07783b7ab($4 + 32 | 0 | 0, $0 | 0, $4 + 184 | 0 | 0, $4 + 216 | 0 | 0);
  core__ptr__drop_in_place_core__option__Option_core__option__Option_cardano_serialization_lib__tx_builder__tx_inputs_builder__ScriptWitnessType_____hc1cbaf0cb4e97823($4 + 32 | 0 | 0);
  global$0 = $4 + 368 | 0;
 }
 
 function cardano_serialization_lib__metadata__encode_json_value_to_metadatum__encode_string__had75d0cd3a140bd6($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $4 = 0, $19 = 0, $61 = 0, $68 = 0;
  $3 = global$0 - 32 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     if (($2 & 255 | 0 | 0) == (1 | 0)) {
      break label$3
     }
     HEAP32[(($3 + 16 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
     i64toi32_i32$2 = $1;
     i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $19 = i64toi32_i32$0;
     i64toi32_i32$0 = $3;
     HEAP32[($3 + 16 | 0) >> 2] = $19;
     HEAP32[($3 + 20 | 0) >> 2] = i64toi32_i32$1;
     cardano_serialization_lib__metadata__TransactionMetadatum__new_text__hc705d7de2d476a57($0 | 0, $3 + 16 | 0 | 0);
     break label$2;
    }
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $1 | 0);
    label$4 : {
     label$5 : {
      $4 = HEAP32[($3 + 8 | 0) >> 2] | 0;
      $2 = HEAP32[($3 + 12 | 0) >> 2] | 0;
      if (!(core__str___impl_20str___starts_with__h83a49b4c2da4d8f5($4 | 0, $2 | 0, 1059268 | 0, 2 | 0) | 0)) {
       break label$5
      }
      label$6 : {
       label$7 : {
        if ($2 >>> 0 > 2 >>> 0) {
         break label$7
        }
        if (($2 | 0) == (2 | 0)) {
         break label$6
        }
        break label$1;
       }
       if ((HEAP8[($4 + 2 | 0) >> 0] | 0 | 0) <= (-65 | 0)) {
        break label$1
       }
      }
      $alloc__vec__Vec_u8__20as_20hex__FromHex___from_hex__h4bc81c912cf347f6($3 + 16 | 0 | 0, $4 + 2 | 0 | 0, $2 + -2 | 0 | 0);
      if ((HEAP32[($3 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$5
      }
      $2 = HEAP32[($3 + 20 | 0) >> 2] | 0;
      if ($2) {
       break label$4
      }
     }
     HEAP32[(($3 + 16 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
     i64toi32_i32$2 = $1;
     i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $61 = i64toi32_i32$1;
     i64toi32_i32$1 = $3;
     HEAP32[($3 + 16 | 0) >> 2] = $61;
     HEAP32[($3 + 20 | 0) >> 2] = i64toi32_i32$0;
     cardano_serialization_lib__metadata__TransactionMetadatum__new_text__hc705d7de2d476a57($0 | 0, $3 + 16 | 0 | 0);
     break label$2;
    }
    i64toi32_i32$2 = $3 + 24 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $68 = i64toi32_i32$0;
    i64toi32_i32$0 = $3;
    HEAP32[($3 + 20 | 0) >> 2] = $68;
    HEAP32[($3 + 24 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($3 + 16 | 0) >> 2] = $2;
    cardano_serialization_lib__metadata__TransactionMetadatum__new_bytes__h341a06dfb4f1da88($0 | 0, $3 + 16 | 0 | 0);
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
   }
   global$0 = $3 + 32 | 0;
   return;
  }
  core__str__slice_error_fail__h8a7d2e23b7bba52e($4 | 0, $2 | 0, 2 | 0, $2 | 0, 1059288 | 0);
  abort();
 }
 
 function $core__iter__adapters__map__Map_I_2cF__20as_20core__iter__traits__iterator__Iterator___try_fold__h176ab48bdb73cf0b($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $6 = 0, $4 = 0, $5 = 0, $7 = 0, $8 = 0, $9 = 0;
  $4 = global$0 - 16 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $5 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      if ($5) {
       break label$4
      }
      $5 = 2;
      break label$3;
     }
     $6 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     $6 = $5 >>> 0 > $6 >>> 0 ? $6 : $5;
     HEAP32[($1 + 4 | 0) >> 2] = $5 - $6 | 0;
     $7 = HEAP32[$1 >> 2] | 0;
     HEAP32[$1 >> 2] = $7 + $6 | 0;
     if (!$6) {
      break label$2
     }
     $8 = HEAP32[($1 + 12 | 0) >> 2] | 0;
     $9 = $8 << 1 | 0;
     hex__val__h25ac2b567437a027($4 | 0, HEAPU8[$7 >> 0] | 0 | 0, $9 | 0);
     label$5 : {
      label$6 : {
       label$7 : {
        if ((HEAPU8[$4 >> 0] | 0 | 0) == (1 | 0)) {
         break label$7
        }
        if ($6 >>> 0 <= 1 >>> 0) {
         break label$1
        }
        $6 = HEAPU8[($4 + 1 | 0) >> 0] | 0;
        $5 = 1;
        hex__val__h25ac2b567437a027($4 | 0, HEAPU8[($7 + 1 | 0) >> 0] | 0 | 0, $9 | 1 | 0 | 0);
        label$8 : {
         if ((HEAPU8[$4 >> 0] | 0 | 0) != (1 | 0)) {
          break label$8
         }
         $5 = HEAP32[($4 + 8 | 0) >> 2] | 0;
         break label$6;
        }
        $6 = HEAPU8[($4 + 1 | 0) >> 0] | 0 | ($6 << 4 | 0) | 0;
        break label$5;
       }
       $5 = HEAP32[($4 + 8 | 0) >> 2] | 0;
      }
      $6 = HEAP32[($4 + 4 | 0) >> 2] | 0;
      $7 = HEAP32[$3 >> 2] | 0;
      HEAP32[($7 + 4 | 0) >> 2] = $5;
      HEAP32[$7 >> 2] = $6;
      $5 = 0;
     }
     HEAP32[($1 + 12 | 0) >> 2] = $8 + 1 | 0;
    }
    HEAP8[($0 + 1 | 0) >> 0] = $6;
    HEAP8[$0 >> 0] = $5;
    global$0 = $4 + 16 | 0;
    return;
   }
   core__panicking__panic_bounds_check__h808b524af17640b1(0 | 0, 0 | 0, 1061304 | 0);
   abort();
  }
  core__panicking__panic_bounds_check__h808b524af17640b1(1 | 0, 1 | 0, 1061320 | 0);
  abort();
 }
 
 function $core__iter__adapters__map__Map_I_2cF__20as_20core__iter__traits__iterator__Iterator___try_fold__hb7370e67be22f2dc($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $6 = 0, $4 = 0, $5 = 0, $7 = 0, $8 = 0, $9 = 0;
  $4 = global$0 - 16 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $5 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      if ($5) {
       break label$4
      }
      $5 = 2;
      break label$3;
     }
     $6 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     $6 = $5 >>> 0 > $6 >>> 0 ? $6 : $5;
     HEAP32[($1 + 4 | 0) >> 2] = $5 - $6 | 0;
     $7 = HEAP32[$1 >> 2] | 0;
     HEAP32[$1 >> 2] = $7 + $6 | 0;
     if (!$6) {
      break label$2
     }
     $8 = HEAP32[($1 + 12 | 0) >> 2] | 0;
     $9 = $8 << 1 | 0;
     hex__val__h25ac2b567437a027($4 | 0, HEAPU8[$7 >> 0] | 0 | 0, $9 | 0);
     label$5 : {
      label$6 : {
       label$7 : {
        if ((HEAPU8[$4 >> 0] | 0 | 0) == (1 | 0)) {
         break label$7
        }
        if ($6 >>> 0 <= 1 >>> 0) {
         break label$1
        }
        $6 = HEAPU8[($4 + 1 | 0) >> 0] | 0;
        $5 = 1;
        hex__val__h25ac2b567437a027($4 | 0, HEAPU8[($7 + 1 | 0) >> 0] | 0 | 0, $9 | 1 | 0 | 0);
        label$8 : {
         if ((HEAPU8[$4 >> 0] | 0 | 0) != (1 | 0)) {
          break label$8
         }
         $5 = HEAP32[($4 + 8 | 0) >> 2] | 0;
         break label$6;
        }
        $6 = HEAPU8[($4 + 1 | 0) >> 0] | 0 | ($6 << 4 | 0) | 0;
        break label$5;
       }
       $5 = HEAP32[($4 + 8 | 0) >> 2] | 0;
      }
      $6 = HEAP32[($4 + 4 | 0) >> 2] | 0;
      $7 = HEAP32[$3 >> 2] | 0;
      HEAP32[($7 + 4 | 0) >> 2] = $5;
      HEAP32[$7 >> 2] = $6;
      $5 = 0;
     }
     HEAP32[($1 + 12 | 0) >> 2] = $8 + 1 | 0;
    }
    HEAP8[($0 + 1 | 0) >> 0] = $6;
    HEAP8[$0 >> 0] = $5;
    global$0 = $4 + 16 | 0;
    return;
   }
   core__panicking__panic_bounds_check__h808b524af17640b1(0 | 0, 0 | 0, 1061304 | 0);
   abort();
  }
  core__panicking__panic_bounds_check__h808b524af17640b1(1 | 0, 1 | 0, 1061320 | 0);
  abort();
 }
 
 function cardano_serialization_lib__tx_builder__TransactionBuilder___add_mint_asset__h060e64edb838acae($0, $1, $2, $3, $4, $4$hi, $5, $5$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  $4$hi = $4$hi | 0;
  $5 = $5 | 0;
  $5$hi = $5$hi | 0;
  var $6 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $7 = 0, $8 = 0, $41 = 0, $53 = 0, $63 = 0;
  $6 = global$0 - 80 | 0;
  global$0 = $6;
  $7 = 0;
  label$1 : {
   if ((HEAP32[($0 + 440 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   cardano_serialization_lib__Mint__get__h44e1f89db570ad02($6 + 64 | 0 | 0, $0 + 444 | 0 | 0, $1 | 0);
   $7 = 0;
   label$2 : {
    if ((HEAP32[($6 + 64 | 0) >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $8 = $6 + 64 | 0 | 4 | 0;
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h4a35d7ddb2264390($6 + 48 | 0 | 4 | 0 | 0, $8 | 0);
    $7 = 1;
    if (!(HEAP32[($6 + 64 | 0) >> 2] | 0)) {
     break label$2
    }
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h0265580a5be10b66($8 | 0);
   }
   HEAP32[($6 + 40 | 0) >> 2] = HEAP32[($6 + 60 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($6 + 52 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($6 + 56 | 0) >> 2] | 0;
   $41 = i64toi32_i32$0;
   i64toi32_i32$0 = $6;
   HEAP32[($6 + 32 | 0) >> 2] = $41;
   HEAP32[($6 + 36 | 0) >> 2] = i64toi32_i32$1;
  }
  i64toi32_i32$0 = $6;
  i64toi32_i32$1 = 0;
  HEAP32[($6 + 68 | 0) >> 2] = 0;
  HEAP32[($6 + 72 | 0) >> 2] = i64toi32_i32$1;
  label$3 : {
   label$4 : {
    if ($7) {
     break label$4
    }
    HEAP32[(($6 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($6 + 64 | 0) + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($6 + 64 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($6 + 68 | 0) >> 2] | 0;
    $53 = i64toi32_i32$1;
    i64toi32_i32$1 = $6;
    HEAP32[($6 + 48 | 0) >> 2] = $53;
    HEAP32[($6 + 52 | 0) >> 2] = i64toi32_i32$0;
    break label$3;
   }
   HEAP32[(($6 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($6 + 32 | 0) + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($6 + 32 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($6 + 36 | 0) >> 2] | 0;
   $63 = i64toi32_i32$0;
   i64toi32_i32$0 = $6;
   HEAP32[($6 + 48 | 0) >> 2] = $63;
   HEAP32[($6 + 52 | 0) >> 2] = i64toi32_i32$1;
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h0265580a5be10b66($6 + 64 | 0 | 0);
  }
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($6 + 64 | 0 | 0, $3 | 0);
  i64toi32_i32$1 = $4$hi;
  i64toi32_i32$1 = $5$hi;
  i64toi32_i32$1 = $4$hi;
  i64toi32_i32$0 = $5$hi;
  alloc__collections__btree__map__BTreeMap_K_2cV___insert__h9d3a28073b5db74d($6 + 8 | 0 | 0, $6 + 48 | 0 | 0, $6 + 64 | 0 | 0, $4 | 0, i64toi32_i32$1 | 0, $5 | 0, i64toi32_i32$0 | 0);
  cardano_serialization_lib__tx_builder__TransactionBuilder___set_mint_asset__hc476e2038680d8c6($0 | 0, $1 | 0, $2 | 0, $6 + 48 | 0 | 0);
  $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h0265580a5be10b66($6 + 48 | 0 | 0);
  global$0 = $6 + 80 | 0;
 }
 
 function cardano_serialization_lib__crypto__PublicKey__from_bech32__h7c89515135180771($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $15 = 0, $4$hi = 0, $5$hi = 0, $6$hi = 0, $7 = 0, $7$hi = 0;
  $3 = global$0 - 80 | 0;
  global$0 = $3;
  $cardano_serialization_lib__chain_crypto__key__PublicKey_A__20as_20cardano_serialization_lib__chain_crypto__bech32__Bech32___try_from_bech32_str__he17a6fbbec90bbc9($3 + 40 | 0 | 0, $1 | 0, $2 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAPU8[($3 + 40 | 0) >> 0] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    i64toi32_i32$2 = ($3 + 40 | 0) + 25 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $4 = i64toi32_i32$0;
    $4$hi = i64toi32_i32$1;
    i64toi32_i32$0 = $3 + 32 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $4;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = ($3 + 40 | 0) + 17 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $5 = i64toi32_i32$1;
    $5$hi = i64toi32_i32$0;
    i64toi32_i32$1 = $3 + 24 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $5;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = ($3 + 40 | 0) + 9 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $6 = i64toi32_i32$0;
    $6$hi = i64toi32_i32$1;
    i64toi32_i32$0 = $3 + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $6;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 41 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 42 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 43 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 44 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 45 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 46 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 47 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 48 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $7 = i64toi32_i32$1;
    $7$hi = i64toi32_i32$0;
    i64toi32_i32$1 = i64toi32_i32$2;
    HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $7;
    HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = $4$hi;
    i64toi32_i32$1 = $0 + 25 | 0;
    HEAP8[i64toi32_i32$1 >> 0] = $4;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $4 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $4 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $4 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$0 = $5$hi;
    i64toi32_i32$1 = $0 + 17 | 0;
    HEAP8[i64toi32_i32$1 >> 0] = $5;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $5 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $5 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $5 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$0 = $6$hi;
    i64toi32_i32$1 = $0 + 9 | 0;
    HEAP8[i64toi32_i32$1 >> 0] = $6;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $6 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $6 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $6 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$0 = $7$hi;
    i64toi32_i32$1 = $0;
    $15 = $7;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $15;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $15 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $15 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = $15 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 8 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    $1 = 0;
    break label$1;
   }
   i64toi32_i32$2 = ($3 + 40 | 0) + 20 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $4 = i64toi32_i32$0;
   $4$hi = i64toi32_i32$1;
   i64toi32_i32$0 = $3 + 27 | 0;
   HEAP8[i64toi32_i32$0 >> 0] = $4;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $4 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $4 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $4 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = $3 + 52 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $5 = i64toi32_i32$1;
   $5$hi = i64toi32_i32$0;
   i64toi32_i32$1 = $3 + 19 | 0;
   HEAP8[i64toi32_i32$1 >> 0] = $5;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $5 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $5 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $5 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $3;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] | 0;
   $6 = i64toi32_i32$0;
   $6$hi = i64toi32_i32$1;
   i64toi32_i32$0 = i64toi32_i32$2;
   HEAP8[(i64toi32_i32$0 + 11 | 0) >> 0] = $6;
   HEAP8[(i64toi32_i32$0 + 12 | 0) >> 0] = $6 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 13 | 0) >> 0] = $6 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 14 | 0) >> 0] = $6 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 15 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 16 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 17 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 18 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$1 = $4$hi;
   i64toi32_i32$0 = i64toi32_i32$0 + 56 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $4;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $5$hi;
   i64toi32_i32$0 = i64toi32_i32$2 + 48 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $5;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $6$hi;
   i64toi32_i32$0 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$0 + 40 | 0) >> 2] = $6;
   HEAP32[(i64toi32_i32$0 + 44 | 0) >> 2] = i64toi32_i32$1;
   $2 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1066616 | 0, 20 | 0) | 0;
   core__ptr__drop_in_place_cardano_serialization_lib__chain_crypto__bech32__Error___hc63804c7ffa39d5a(i64toi32_i32$0 + 40 | 0 | 0);
   HEAP32[($0 + 4 | 0) >> 2] = $2;
  }
  HEAP8[$0 >> 0] = $1;
  global$0 = $3 + 80 | 0;
 }
 
 function cardano_serialization_lib__crypto__Ed25519Signature__from_hex__h31c44be5043beea1($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $9 = 0, $10 = 0, i64toi32_i32$2 = 0, $11 = 0, $41 = 0, $44 = 0;
  $3 = global$0 - 192 | 0;
  global$0 = $3;
  $cardano_serialization_lib__chain_crypto__sign__Signature_T_2cA__20as_20core__str__traits__FromStr___from_str__h0b50509d65ede561($3 + 80 | 0 | 0, $1 | 0, $2 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAPU8[($3 + 80 | 0) >> 0] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $11 = HEAPU8[($3 + 81 | 0) >> 0] | 0 | ((HEAPU8[($3 + 82 | 0) >> 0] | 0) << 8 | 0) | 0;
    HEAP8[($0 + 1 | 0) >> 0] = $11;
    HEAP8[($0 + 2 | 0) >> 0] = $11 >>> 8 | 0;
    HEAP8[($0 + 3 | 0) >> 0] = HEAPU8[($3 + 83 | 0) >> 0] | 0;
    $1 = HEAP32[($3 + 84 | 0) >> 2] | 0;
    memcpy($3 + 16 | 0 | 0, ($3 + 80 | 0) + 8 | 0 | 0, 57 | 0) | 0;
    $9 = $0 + 4 | 0;
    $10 = $1;
    HEAP8[$9 >> 0] = $10;
    HEAP8[($9 + 1 | 0) >> 0] = $10 >>> 8 | 0;
    HEAP8[($9 + 2 | 0) >> 0] = $10 >>> 16 | 0;
    HEAP8[($9 + 3 | 0) >> 0] = $10 >>> 24 | 0;
    memcpy($0 + 8 | 0 | 0, $3 + 16 | 0 | 0, 57 | 0) | 0;
    $1 = 0;
    break label$1;
   }
   i64toi32_i32$2 = $3 + 92 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $41 = i64toi32_i32$0;
   i64toi32_i32$0 = $3 + 160 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $41;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[($3 + 84 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($3 + 88 | 0) >> 2] | 0;
   $44 = i64toi32_i32$1;
   i64toi32_i32$1 = $3;
   HEAP32[($3 + 152 | 0) >> 2] = $44;
   HEAP32[($3 + 156 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($3 + 36 | 0) >> 2] = 1;
   i64toi32_i32$1 = $3;
   i64toi32_i32$0 = 0;
   HEAP32[($3 + 20 | 0) >> 2] = 1;
   HEAP32[($3 + 24 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($3 + 16 | 0) >> 2] = 1066504;
   HEAP32[($3 + 188 | 0) >> 2] = 112;
   HEAP32[($3 + 32 | 0) >> 2] = $3 + 184 | 0;
   HEAP32[($3 + 184 | 0) >> 2] = $3 + 152 | 0;
   alloc__fmt__format__h6e9e003a52c07309($3 + 168 | 0 | 0, $3 + 16 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $3 + 168 | 0 | 0);
   $2 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($3 + 8 | 0) >> 2] | 0 | 0, HEAP32[($3 + 12 | 0) >> 2] | 0 | 0) | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 168 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 168 | 0 | 0);
   HEAP32[($0 + 4 | 0) >> 2] = $2;
  }
  HEAP8[$0 >> 0] = $1;
  global$0 = $3 + 192 | 0;
 }
 
 function $cardano_serialization_lib__plutus__Redeemer_20as_20cbor_event__se__Serialize___serialize__hf725a82e60523f39($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  i64toi32_i32$0 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, 4 | 0, i64toi32_i32$0 | 0);
  $4 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
         break label$6
        }
        $cardano_serialization_lib__plutus__RedeemerTagKind_20as_20cbor_event__se__Serialize___serialize__h18a0e36a2b8a390e($3 | 0, $1 + 72 | 0 | 0, $2 | 0);
        if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
         break label$5
        }
        i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
        cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, i64toi32_i32$0 | 0, i64toi32_i32$1 | 0);
        $4 = 1;
        if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
         break label$4
        }
        $cardano_serialization_lib__plutus__PlutusData_20as_20cbor_event__se__Serialize___serialize__hbd5d6a191345a7d0($3 | 0, $1 + 8 | 0 | 0, $2 | 0);
        if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
         break label$3
        }
        $cardano_serialization_lib__plutus__ExUnits_20as_20cbor_event__se__Serialize___serialize__h495dce506fba6361($3 | 0, $1 + 56 | 0 | 0, $2 | 0);
        $4 = 1;
        if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
         break label$2
        }
        HEAP32[($0 + 4 | 0) >> 2] = $2;
        $4 = 0;
        break label$1;
       }
       memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
       break label$1;
      }
      memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
      $4 = 1;
      break label$1;
     }
     memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    $4 = 1;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
  }
  HEAP32[$0 >> 2] = $4;
  global$0 = $3 + 48 | 0;
 }
 
 function redeemer_new($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $5 = 0, $6 = 0, $7 = 0, $8 = 0, $8$hi = 0, $57 = 0, $64 = 0;
  $4 = global$0 - 192 | 0;
  global$0 = $4;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h8eb054d444413163($4 + 24 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($4 + 28 | 0) >> 2] | 0;
   $5 = HEAP32[($4 + 24 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($4 + 16 | 0 | 0, $1 | 0);
   if (!$2) {
    break label$1
   }
   $1 = HEAP32[($4 + 20 | 0) >> 2] | 0;
   $6 = HEAP32[($4 + 16 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb1fd14a6870cafe2($4 + 8 | 0 | 0, $2 | 0);
   if (!$3) {
    break label$1
   }
   $2 = HEAP32[($4 + 12 | 0) >> 2] | 0;
   $7 = HEAP32[($4 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h1f4aa39af4dc2942($4 | 0, $3 | 0);
   i64toi32_i32$2 = $6;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $8 = i64toi32_i32$0;
   $8$hi = i64toi32_i32$1;
   $6 = HEAPU8[$5 >> 0] | 0;
   $3 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   $5 = HEAP32[$4 >> 2] | 0;
   $cardano_serialization_lib__plutus__PlutusData_20as_20core__clone__Clone___clone__h63d1a98cc18f4609_2($4 + 40 | 0 | 0, $7 | 0);
   i64toi32_i32$2 = $5;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
   $57 = i64toi32_i32$1;
   i64toi32_i32$1 = $4 + 96 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $57;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP8[($4 + 104 | 0) >> 0] = $6;
   i64toi32_i32$0 = $8$hi;
   i64toi32_i32$1 = $4;
   HEAP32[($4 + 32 | 0) >> 2] = $8;
   HEAP32[($4 + 36 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $64 = i64toi32_i32$0;
   i64toi32_i32$0 = $4;
   HEAP32[($4 + 88 | 0) >> 2] = $64;
   HEAP32[($4 + 92 | 0) >> 2] = i64toi32_i32$1;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   memcpy($4 + 112 | 0 | 0, $4 + 32 | 0 | 0, 80 | 0) | 0;
   $0 = $cardano_serialization_lib__plutus__Redeemer_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he2ca0b82950da3f7($4 + 112 | 0 | 0) | 0;
   global$0 = $4 + 192 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function $cardano_serialization_lib__legacy_address__address__ExtendedAddr_20as_20cbor_event__se__Serialize___serialize__hab4aa0fda5dfbd1b($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, $3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $6 = 0, $13 = 0, $14 = 0, $15 = 0, $16 = 0, $18 = 0, $19 = 0, $4 = 0, $5 = 0, $17 = 0, $22 = 0, $27 = 0;
  $3 = global$0 - 128 | 0;
  global$0 = $3;
  $4 = 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($3 | 0, 28 | 0, 0 | 0);
  $5 = HEAP32[($3 + 4 | 0) >> 2] | 0;
  $6 = HEAP32[$3 >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[($1 + 20 | 0) >> 0] | 0 | ((HEAPU8[($1 + 21 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 22 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 23 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[($1 + 24 | 0) >> 0] | 0 | ((HEAPU8[($1 + 25 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 26 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 27 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $17 = i64toi32_i32$0;
  i64toi32_i32$0 = $6;
  $13 = $17;
  HEAP8[i64toi32_i32$0 >> 0] = $13;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 36 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $22 = i64toi32_i32$1;
  i64toi32_i32$1 = $6 + 16 | 0;
  $14 = $22;
  HEAP8[i64toi32_i32$1 >> 0] = $14;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $14 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $14 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $14 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 28 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $27 = i64toi32_i32$0;
  i64toi32_i32$0 = $6 + 8 | 0;
  $15 = $27;
  HEAP8[i64toi32_i32$0 >> 0] = $15;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $15 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $15 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $15 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $16 = $1 + 44 | 0;
  $18 = $6 + 24 | 0;
  $19 = HEAPU8[$16 >> 0] | 0 | ((HEAPU8[($16 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($16 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($16 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  HEAP8[$18 >> 0] = $19;
  HEAP8[($18 + 1 | 0) >> 0] = $19 >>> 8 | 0;
  HEAP8[($18 + 2 | 0) >> 0] = $19 >>> 16 | 0;
  HEAP8[($18 + 3 | 0) >> 0] = $19 >>> 24 | 0;
  HEAP32[($3 + 20 | 0) >> 2] = 28;
  HEAP32[(($3 + 8 | 0) + 8 | 0) >> 2] = $5;
  HEAP32[($3 + 12 | 0) >> 2] = $6;
  HEAP32[($3 + 8 | 0) >> 2] = 2;
  HEAP32[($3 + 120 | 0) >> 2] = $1 + 48 | 0;
  HEAP32[($3 + 116 | 0) >> 2] = $1;
  HEAP32[($3 + 112 | 0) >> 2] = $3 + 8 | 0;
  cardano_serialization_lib__legacy_address__cbor__util__encode_with_crc32___h44cd9155717a6906($3 + 72 | 0 | 0, $3 + 112 | 0 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    $1 = HEAPU8[($3 + 72 | 0) >> 0] | 0;
    if (($1 | 0) != (19 | 0)) {
     break label$2
    }
    HEAP32[($0 + 4 | 0) >> 2] = $2;
    core__ptr__drop_in_place_cbor_event__value__Value___h203893ddc6d2104a_2($3 + 8 | 0 | 0);
    break label$1;
   }
   $4 = 1;
   memcpy($3 + 33 | 0 | 0, $3 + 72 | 0 | 1 | 0 | 0, 39 | 0) | 0;
   HEAP8[($0 + 8 | 0) >> 0] = $1;
   memcpy($0 + 9 | 0 | 0, $3 + 33 | 0 | 0, 39 | 0) | 0;
   core__ptr__drop_in_place_cbor_event__value__Value___h203893ddc6d2104a_2($3 + 8 | 0 | 0);
  }
  HEAP32[$0 >> 2] = $4;
  global$0 = $3 + 128 | 0;
 }
 
 function core__fmt__builders__DebugInner__entry__hc1bb9451bcfce59d($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, $49 = 0, $6 = 0, $6$hi = 0, $61 = 0, $66 = 0;
  $3 = global$0 - 64 | 0;
  global$0 = $3;
  $4 = 1;
  label$1 : {
   if (HEAPU8[($0 + 4 | 0) >> 0] | 0) {
    break label$1
   }
   $4 = HEAPU8[($0 + 5 | 0) >> 0] | 0;
   label$2 : {
    $5 = HEAP32[$0 >> 2] | 0;
    if ((HEAPU8[$5 >> 0] | 0) & 4 | 0) {
     break label$2
    }
    label$3 : {
     if (!($4 & 255 | 0)) {
      break label$3
     }
     $4 = 1;
     if (FUNCTION_TABLE[HEAP32[((HEAP32[($5 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($5 + 24 | 0) >> 2] | 0, 1149869, 2) | 0) {
      break label$1
     }
    }
    $4 = FUNCTION_TABLE[HEAP32[($2 + 12 | 0) >> 2] | 0 | 0]($1, $5) | 0;
    break label$1;
   }
   label$4 : {
    if ($4 & 255 | 0) {
     break label$4
    }
    $4 = 1;
    if (FUNCTION_TABLE[HEAP32[((HEAP32[($5 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($5 + 24 | 0) >> 2] | 0, 1149898, 1) | 0) {
     break label$1
    }
   }
   $4 = 1;
   HEAP8[($3 + 23 | 0) >> 0] = 1;
   HEAP32[($3 + 52 | 0) >> 2] = 1149804;
   i64toi32_i32$0 = HEAP32[($5 + 24 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($5 + 28 | 0) >> 2] | 0;
   $49 = i64toi32_i32$0;
   i64toi32_i32$0 = $3;
   HEAP32[($3 + 8 | 0) >> 2] = $49;
   HEAP32[($3 + 12 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($3 + 16 | 0) >> 2] = $3 + 23 | 0;
   i64toi32_i32$1 = HEAP32[($5 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($5 + 12 | 0) >> 2] | 0;
   $6 = i64toi32_i32$1;
   $6$hi = i64toi32_i32$0;
   i64toi32_i32$0 = HEAP32[($5 + 16 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($5 + 20 | 0) >> 2] | 0;
   HEAP8[($3 + 56 | 0) >> 0] = HEAPU8[($5 + 32 | 0) >> 0] | 0;
   $61 = i64toi32_i32$0;
   i64toi32_i32$0 = $3;
   HEAP32[($3 + 40 | 0) >> 2] = $61;
   HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $6$hi;
   i64toi32_i32$0 = $3;
   HEAP32[($3 + 32 | 0) >> 2] = $6;
   HEAP32[($3 + 36 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = HEAP32[$5 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($5 + 4 | 0) >> 2] | 0;
   $66 = i64toi32_i32$1;
   i64toi32_i32$1 = $3;
   HEAP32[($3 + 24 | 0) >> 2] = $66;
   HEAP32[($3 + 28 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($3 + 48 | 0) >> 2] = $3 + 8 | 0;
   if (FUNCTION_TABLE[HEAP32[($2 + 12 | 0) >> 2] | 0 | 0]($1, $3 + 24 | 0) | 0) {
    break label$1
   }
   $4 = FUNCTION_TABLE[HEAP32[((HEAP32[($3 + 52 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($3 + 48 | 0) >> 2] | 0, 1149867, 2) | 0;
  }
  HEAP8[($0 + 5 | 0) >> 0] = 1;
  HEAP8[($0 + 4 | 0) >> 0] = $4;
  global$0 = $3 + 64 | 0;
 }
 
 function $cardano_serialization_lib__crypto__BootstrapWitness_20as_20cbor_event__se__Serialize___serialize__hd840f2320eb792b1($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, 4 | 0, 0 | 0);
  $4 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
         break label$6
        }
        $cardano_serialization_lib__crypto__Vkey_20as_20cbor_event__se__Serialize___serialize__he0fe1f32129559ab($3 | 0, $1 + 24 | 0 | 0, $2 | 0);
        if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
         break label$5
        }
        cbor_event__se__Serializer_W___write_bytes__h1ecbe6b3316bc5ff($3 | 0, $2 | 0, $1 + 56 | 0 | 0, 64 | 0);
        $4 = 1;
        if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
         break label$4
        }
        cbor_event__se__Serializer_W___write_bytes__hdbf95a6224c8b5b8($3 | 0, $2 | 0, $1 | 0);
        if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
         break label$3
        }
        cbor_event__se__Serializer_W___write_bytes__hdbf95a6224c8b5b8($3 | 0, $2 | 0, $1 + 12 | 0 | 0);
        $4 = 1;
        if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
         break label$2
        }
        HEAP32[($0 + 4 | 0) >> 2] = $2;
        $4 = 0;
        break label$1;
       }
       memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
       break label$1;
      }
      memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
      $4 = 1;
      break label$1;
     }
     memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    $4 = 1;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
  }
  HEAP32[$0 >> 2] = $4;
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__crypto__Bip32PublicKey__from_bytes__h9e2151b5ecc26a5e($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, $5 = 0;
  $3 = global$0 - 176 | 0;
  global$0 = $3;
  cardano_serialization_lib__chain_crypto__key__PublicKey_A___from_binary__he9697ecf8c279d37($3 + 80 | 0 | 0, $1 | 0, $2 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAPU8[($3 + 80 | 0) >> 0] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = $3 + 80 | 0 | 1 | 0;
    $5 = HEAPU8[$1 >> 0] | 0 | ((HEAPU8[($1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
    HEAP8[($0 + 1 | 0) >> 0] = $5;
    HEAP8[($0 + 2 | 0) >> 0] = $5 >>> 8 | 0;
    HEAP8[($0 + 3 | 0) >> 0] = HEAPU8[($1 + 2 | 0) >> 0] | 0;
    $1 = HEAP32[($3 + 84 | 0) >> 2] | 0;
    memcpy($3 + 16 | 0 | 0, ($3 + 80 | 0) + 8 | 0 | 0, 57 | 0) | 0;
    $4 = $0 + 4 | 0;
    HEAP8[$4 >> 0] = $1;
    HEAP8[($4 + 1 | 0) >> 0] = $1 >>> 8 | 0;
    HEAP8[($4 + 2 | 0) >> 0] = $1 >>> 16 | 0;
    HEAP8[($4 + 3 | 0) >> 0] = $1 >>> 24 | 0;
    memcpy($0 + 8 | 0 | 0, $3 + 16 | 0 | 0, 57 | 0) | 0;
    $1 = 0;
    break label$1;
   }
   HEAP8[($3 + 151 | 0) >> 0] = HEAPU8[($3 + 81 | 0) >> 0] | 0;
   HEAP32[($3 + 36 | 0) >> 2] = 1;
   HEAP32[($3 + 20 | 0) >> 2] = 1;
   HEAP32[($3 + 24 | 0) >> 2] = 0;
   HEAP32[($3 + 16 | 0) >> 2] = 1066504;
   HEAP32[($3 + 172 | 0) >> 2] = 28;
   HEAP32[($3 + 32 | 0) >> 2] = $3 + 168 | 0;
   HEAP32[($3 + 168 | 0) >> 2] = $3 + 151 | 0;
   alloc__fmt__format__h6e9e003a52c07309($3 + 152 | 0 | 0, $3 + 16 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $3 + 152 | 0 | 0);
   $2 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($3 + 8 | 0) >> 2] | 0 | 0, HEAP32[($3 + 12 | 0) >> 2] | 0 | 0) | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 152 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 152 | 0 | 0);
   HEAP32[($0 + 4 | 0) >> 2] = $2;
  }
  HEAP8[$0 >> 0] = $1;
  global$0 = $3 + 176 | 0;
 }
 
 function $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__h24704ec9214d4ac9($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $5 = 0, $6 = 0, $4 = 0, $7 = 0, $49 = 0, $71 = 0, $75 = 0, $78 = 0, $89 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h36ca092f81b9a0fa($2 + 8 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
     if (!$3) {
      break label$3
     }
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($2 + 32 | 0 | 0, $3 | 0);
     if (HEAP32[($2 + 32 | 0) >> 2] | 0) {
      break label$2
     }
    }
    i64toi32_i32$1 = $0;
    i64toi32_i32$0 = 0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = 0;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[i64toi32_i32$1 >> 2] = HEAP32[(0 + 1067632 | 0) >> 2] | 0;
    break label$1;
   }
   $4 = $1 + 24 | 0;
   $3 = HEAP32[$4 >> 2] | 0;
   $5 = $3 + 1 | 0;
   alloc__raw_vec__RawVec_T_2cA___allocate_in__he66014b8a55c2ce3($2 | 0, ($5 >>> 0 < $3 >>> 0 ? -1 : $5) | 0, 0 | 0);
   $5 = ($2 + 32 | 0) + 8 | 0;
   $6 = HEAP32[$5 >> 2] | 0;
   $7 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $3 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
   $49 = i64toi32_i32$0;
   i64toi32_i32$0 = $3;
   HEAP32[i64toi32_i32$0 >> 2] = $49;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $6;
   $6 = ($2 + 16 | 0) + 8 | 0;
   HEAP32[$6 >> 2] = 1;
   HEAP32[($2 + 20 | 0) >> 2] = $7;
   HEAP32[($2 + 16 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[(($2 + 32 | 0) + 24 | 0) >> 2] = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$2 = $1 + 16 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $71 = i64toi32_i32$1;
   i64toi32_i32$1 = ($2 + 32 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $71;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $1 + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $75 = i64toi32_i32$0;
   i64toi32_i32$0 = $5;
   HEAP32[i64toi32_i32$0 >> 2] = $75;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $78 = i64toi32_i32$1;
   i64toi32_i32$1 = $2;
   HEAP32[($2 + 32 | 0) >> 2] = $78;
   HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$0;
   alloc__vec__Vec_T_2cA___extend_desugared__h1420731a5ce41003($2 + 16 | 0 | 0, $2 + 32 | 0 | 0);
   HEAP32[($0 + 8 | 0) >> 2] = HEAP32[$6 >> 2] | 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   $89 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[i64toi32_i32$0 >> 2] = $89;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  }
  global$0 = $2 + 64 | 0;
 }
 
 function $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__hc5b4bd660ee12429($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $5 = 0, $6 = 0, $4 = 0, $7 = 0, $49 = 0, $71 = 0, $75 = 0, $78 = 0, $89 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__hce9499edf49fdc37($2 + 8 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
     if (!$3) {
      break label$3
     }
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($2 + 32 | 0 | 0, $3 | 0);
     if (HEAP32[($2 + 32 | 0) >> 2] | 0) {
      break label$2
     }
    }
    i64toi32_i32$1 = $0;
    i64toi32_i32$0 = 0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = 0;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[i64toi32_i32$1 >> 2] = HEAP32[(0 + 1067632 | 0) >> 2] | 0;
    break label$1;
   }
   $4 = $1 + 24 | 0;
   $3 = HEAP32[$4 >> 2] | 0;
   $5 = $3 + 1 | 0;
   alloc__raw_vec__RawVec_T_2cA___allocate_in__he66014b8a55c2ce3($2 | 0, ($5 >>> 0 < $3 >>> 0 ? -1 : $5) | 0, 0 | 0);
   $5 = ($2 + 32 | 0) + 8 | 0;
   $6 = HEAP32[$5 >> 2] | 0;
   $7 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $3 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
   $49 = i64toi32_i32$0;
   i64toi32_i32$0 = $3;
   HEAP32[i64toi32_i32$0 >> 2] = $49;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $6;
   $6 = ($2 + 16 | 0) + 8 | 0;
   HEAP32[$6 >> 2] = 1;
   HEAP32[($2 + 20 | 0) >> 2] = $7;
   HEAP32[($2 + 16 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[(($2 + 32 | 0) + 24 | 0) >> 2] = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$2 = $1 + 16 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $71 = i64toi32_i32$1;
   i64toi32_i32$1 = ($2 + 32 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $71;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $1 + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $75 = i64toi32_i32$0;
   i64toi32_i32$0 = $5;
   HEAP32[i64toi32_i32$0 >> 2] = $75;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $78 = i64toi32_i32$1;
   i64toi32_i32$1 = $2;
   HEAP32[($2 + 32 | 0) >> 2] = $78;
   HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$0;
   alloc__vec__Vec_T_2cA___extend_desugared__he8baaa2bbd2fe744($2 + 16 | 0 | 0, $2 + 32 | 0 | 0);
   HEAP32[($0 + 8 | 0) >> 2] = HEAP32[$6 >> 2] | 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   $89 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[i64toi32_i32$0 >> 2] = $89;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  }
  global$0 = $2 + 64 | 0;
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___insert__h42468afb2d22301b($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $4 = 0, i64toi32_i32$0 = 0, $16 = 0, $5 = 0, $21 = 0, $27 = 0, $30 = 0, $51 = 0, $6 = 0, $6$hi = 0, $71 = 0;
  $4 = global$0 - 112 | 0;
  global$0 = $4;
  $16 = $2 + 24 | 0;
  HEAP32[(($4 + 48 | 0) + 24 | 0) >> 2] = HEAPU8[$16 >> 0] | 0 | ((HEAPU8[($16 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($16 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($16 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $2 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $21 = i64toi32_i32$0;
  i64toi32_i32$0 = ($4 + 48 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $21;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $27 = i64toi32_i32$1;
  i64toi32_i32$1 = ($4 + 48 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $27;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[($4 + 48 | 0) >> 2] = $30;
  HEAP32[($4 + 52 | 0) >> 2] = i64toi32_i32$1;
  alloc__collections__btree__map__BTreeMap_K_2cV___entry__hacc4ab587cdf931c($4 | 0, $1 | 0, $4 + 48 | 0 | 0);
  $2 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[$4 >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    memcpy($4 + 48 | 0 | 0, $4 | 4 | 0 | 0, 44 | 0) | 0;
    HEAP32[(($4 + 96 | 0) + 8 | 0) >> 2] = HEAP32[($3 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $51 = i64toi32_i32$1;
    i64toi32_i32$1 = $4;
    HEAP32[($4 + 96 | 0) >> 2] = $51;
    HEAP32[($4 + 100 | 0) >> 2] = i64toi32_i32$0;
    alloc__collections__btree__map__entry__VacantEntry_K_2cV___insert__hce43ba110ae6b93d($4 + 48 | 0 | 0, $4 + 96 | 0 | 0) | 0;
    $2 = 0;
    break label$1;
   }
   $1 = (HEAP32[($4 + 8 | 0) >> 2] | 0) + Math_imul(HEAP32[($4 + 12 | 0) >> 2] | 0, 12) | 0;
   $5 = $1 + 4 | 0;
   i64toi32_i32$2 = $5;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $6 = i64toi32_i32$0;
   $6$hi = i64toi32_i32$1;
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $71 = i64toi32_i32$1;
   i64toi32_i32$1 = $5;
   HEAP32[i64toi32_i32$1 >> 2] = $71;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $6$hi;
   i64toi32_i32$1 = $0;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $6;
   HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
   $1 = $1 + 12 | 0;
   $5 = HEAP32[$1 >> 2] | 0;
   HEAP32[$1 >> 2] = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
   HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = $5;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $4 + 112 | 0;
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___insert__ha211f93f5765e42b($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $4 = 0, i64toi32_i32$0 = 0, $16 = 0, $5 = 0, $21 = 0, $27 = 0, $30 = 0, $51 = 0, $6 = 0, $6$hi = 0, $71 = 0;
  $4 = global$0 - 112 | 0;
  global$0 = $4;
  $16 = $2 + 24 | 0;
  HEAP32[(($4 + 48 | 0) + 24 | 0) >> 2] = HEAPU8[$16 >> 0] | 0 | ((HEAPU8[($16 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($16 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($16 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $2 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $21 = i64toi32_i32$0;
  i64toi32_i32$0 = ($4 + 48 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $21;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $27 = i64toi32_i32$1;
  i64toi32_i32$1 = ($4 + 48 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $27;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[($4 + 48 | 0) >> 2] = $30;
  HEAP32[($4 + 52 | 0) >> 2] = i64toi32_i32$1;
  alloc__collections__btree__map__BTreeMap_K_2cV___entry__hd27d6127e1982e7e($4 | 0, $1 | 0, $4 + 48 | 0 | 0);
  $2 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[$4 >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    memcpy($4 + 48 | 0 | 0, $4 | 4 | 0 | 0, 44 | 0) | 0;
    HEAP32[(($4 + 96 | 0) + 8 | 0) >> 2] = HEAP32[($3 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $51 = i64toi32_i32$1;
    i64toi32_i32$1 = $4;
    HEAP32[($4 + 96 | 0) >> 2] = $51;
    HEAP32[($4 + 100 | 0) >> 2] = i64toi32_i32$0;
    alloc__collections__btree__map__entry__VacantEntry_K_2cV___insert__h1ccac11121812f65($4 + 48 | 0 | 0, $4 + 96 | 0 | 0) | 0;
    $2 = 0;
    break label$1;
   }
   $1 = (HEAP32[($4 + 8 | 0) >> 2] | 0) + Math_imul(HEAP32[($4 + 12 | 0) >> 2] | 0, 12) | 0;
   $5 = $1 + 4 | 0;
   i64toi32_i32$2 = $5;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $6 = i64toi32_i32$0;
   $6$hi = i64toi32_i32$1;
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $71 = i64toi32_i32$1;
   i64toi32_i32$1 = $5;
   HEAP32[i64toi32_i32$1 >> 2] = $71;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $6$hi;
   i64toi32_i32$1 = $0;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $6;
   HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
   $1 = $1 + 12 | 0;
   $5 = HEAP32[$1 >> 2] | 0;
   HEAP32[$1 >> 2] = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
   HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = $5;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $4 + 112 | 0;
 }
 
 function $serde_json__read__SliceRead_20as_20serde_json__read__Read___decode_hex_escape__h3856e4104f33707e($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $5 = 0, $1 = 0, $2 = 0, $3 = 0, $4 = 0, $10$hi = 0, $9 = 0, $9$hi = 0, $10 = 0, $8 = 0, $23 = 0, $24 = 0, $25 = 0, $6 = 0, $7 = 0, $87$hi = 0, $89 = 0, $89$hi = 0, $91 = 0, $91$hi = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   label$2 : {
    $2 = HEAP32[($0 + 8 | 0) >> 2] | 0;
    $3 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    if (($2 + 4 | 0) >>> 0 > $3 >>> 0) {
     break label$2
    }
    $4 = 0;
    $5 = $3 - $2 | 0;
    $6 = $5 >>> 0 > $3 >>> 0 ? 0 : $5;
    $7 = (HEAP32[$0 >> 2] | 0) + $2 | 0;
    $5 = 0;
    label$3 : {
     label$4 : while (1) {
      if (($6 | 0) == ($5 | 0)) {
       break label$3
      }
      HEAP32[($0 + 8 | 0) >> 2] = ($2 + $5 | 0) + 1 | 0;
      label$5 : {
       $8 = HEAPU8[((HEAPU8[($7 + $5 | 0) >> 0] | 0) + 1087940 | 0) >> 0] | 0;
       if (($8 | 0) != (255 | 0)) {
        break label$5
       }
       HEAP32[$1 >> 2] = 11;
       i64toi32_i32$0 = serde_json__read__error__hdb2fc08732a86d5b($0 | 0, $1 | 0) | 0;
       i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
       $9 = i64toi32_i32$0;
       $9$hi = i64toi32_i32$1;
       i64toi32_i32$2 = i64toi32_i32$0;
       i64toi32_i32$0 = -1;
       i64toi32_i32$3 = 0;
       i64toi32_i32$0 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
       $10 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
       $10$hi = i64toi32_i32$0;
       i64toi32_i32$0 = i64toi32_i32$1;
       i64toi32_i32$1 = i64toi32_i32$2;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 16;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = 0;
        $23 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
        $23 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
       }
       $4 = $23;
       break label$1;
      }
      $4 = ($4 << 4 | 0) + $8 | 0;
      $5 = $5 + 1 | 0;
      if (($5 | 0) != (4 | 0)) {
       continue label$4
      }
      break label$4;
     };
     i64toi32_i32$2 = 0;
     $10 = 0;
     $10$hi = i64toi32_i32$2;
     i64toi32_i32$2 = 0;
     $9 = 0;
     $9$hi = i64toi32_i32$2;
     break label$1;
    }
    core__panicking__panic_bounds_check__h808b524af17640b1($2 + $5 | 0 | 0, $3 | 0, 1087668 | 0);
    abort();
   }
   HEAP32[($0 + 8 | 0) >> 2] = $3;
   HEAP32[$1 >> 2] = 4;
   i64toi32_i32$2 = serde_json__read__error__hdb2fc08732a86d5b($0 | 0, $1 | 0) | 0;
   i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
   $9 = i64toi32_i32$2;
   $9$hi = i64toi32_i32$1;
   i64toi32_i32$0 = i64toi32_i32$2;
   i64toi32_i32$2 = -1;
   i64toi32_i32$3 = 0;
   i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
   $10 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
   $10$hi = i64toi32_i32$2;
   i64toi32_i32$2 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$0;
   i64toi32_i32$0 = 0;
   i64toi32_i32$3 = 16;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$0 = 0;
    $24 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   } else {
    i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
    $24 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
   }
   $4 = $24;
  }
  global$0 = $1 + 16 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 65535;
  i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 16;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   $25 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $25 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
  }
  $87$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$2 = $87$hi;
  i64toi32_i32$1 = $25;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$3 = $10;
  i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
  $89 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  $89$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$2 = $9;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 65535;
  i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
  $91 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
  $91$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $89$hi;
  i64toi32_i32$0 = $89;
  i64toi32_i32$2 = $91$hi;
  i64toi32_i32$3 = $91;
  i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
  i64toi32_i32$0 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$2;
  return i64toi32_i32$0 | 0;
 }
 
 function $T_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hf422f9333a8bbafa($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, $2 = 0, i64toi32_i32$0 = 0, $3$hi = 0, $3 = 0, $4$hi = 0, $4 = 0, $24 = 0, $29 = 0, $35 = 0, $40 = 0, $48 = 0, $55 = 0, $62 = 0, $67 = 0, $72 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___unsigned_integer__h1ed99c0b7fe7eea1($2 + 32 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] | 0;
  $3 = i64toi32_i32$0;
  $3$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$1 = 0;
     i64toi32_i32$3 = 1;
     if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
      break label$3
     }
     label$4 : {
      i64toi32_i32$2 = $3$hi;
      i64toi32_i32$3 = $3;
      i64toi32_i32$0 = 0;
      i64toi32_i32$1 = -1;
      if (i64toi32_i32$2 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$3 >>> 0 <= i64toi32_i32$1 >>> 0 | 0) | 0) {
       break label$4
      }
      i64toi32_i32$3 = 0;
      $4 = 2;
      $4$hi = i64toi32_i32$3;
      i64toi32_i32$3 = 0;
      $3 = 0;
      $3$hi = i64toi32_i32$3;
      break label$2;
     }
     i64toi32_i32$3 = $3$hi;
     HEAP32[($0 + 4 | 0) >> 2] = $3;
     $1 = 0;
     break label$1;
    }
    i64toi32_i32$1 = $2 + 72 | 0;
    i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
    $24 = i64toi32_i32$3;
    i64toi32_i32$3 = $2 + 24 | 0;
    HEAP32[i64toi32_i32$3 >> 2] = $24;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$1 = $2 + 64 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
    $29 = i64toi32_i32$2;
    i64toi32_i32$2 = $2 + 16 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $29;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
    i64toi32_i32$1 = ($2 + 32 | 0) + 24 | 0;
    i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
    $35 = i64toi32_i32$3;
    i64toi32_i32$3 = $2 + 8 | 0;
    HEAP32[i64toi32_i32$3 >> 2] = $35;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$1 = ($2 + 32 | 0) + 16 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
    $40 = i64toi32_i32$2;
    i64toi32_i32$2 = $2;
    HEAP32[i64toi32_i32$2 >> 2] = $40;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
    i64toi32_i32$3 = $3$hi;
    i64toi32_i32$1 = $3;
    i64toi32_i32$2 = 0;
    i64toi32_i32$0 = 255;
    i64toi32_i32$2 = i64toi32_i32$3 & i64toi32_i32$2 | 0;
    $4 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
    $4$hi = i64toi32_i32$2;
    i64toi32_i32$2 = i64toi32_i32$3;
    i64toi32_i32$3 = i64toi32_i32$1;
    i64toi32_i32$1 = -1;
    i64toi32_i32$0 = -256;
    i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
    $3 = i64toi32_i32$3 & i64toi32_i32$0 | 0;
    $3$hi = i64toi32_i32$1;
   }
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $48 = i64toi32_i32$1;
   i64toi32_i32$1 = $0 + 24 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $48;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$3;
   HEAP32[($0 + 56 | 0) >> 2] = 0;
   i64toi32_i32$3 = $4$hi;
   i64toi32_i32$3 = $3$hi;
   i64toi32_i32$3 = $4$hi;
   i64toi32_i32$2 = $4;
   i64toi32_i32$1 = $3$hi;
   i64toi32_i32$0 = $3;
   i64toi32_i32$1 = i64toi32_i32$3 | i64toi32_i32$1 | 0;
   $55 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
   i64toi32_i32$2 = $0 + 16 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $55;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP8[($0 + 8 | 0) >> 0] = 2;
   i64toi32_i32$3 = $2 + 24 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $62 = i64toi32_i32$1;
   i64toi32_i32$1 = $0 + 48 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $62;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$3 = $2 + 16 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $67 = i64toi32_i32$2;
   i64toi32_i32$2 = $0 + 40 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $67;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$3 = $2 + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
   $72 = i64toi32_i32$1;
   i64toi32_i32$1 = $0 + 32 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $72;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 80 | 0;
 }
 
 function hash_script_data($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $4 = 0, $5 = 0, $39 = 0, $42 = 0, $65 = 0, $72 = 0, $77 = 0, $80 = 0;
  $3 = global$0 - 96 | 0;
  global$0 = $3;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h6789b4b005d0c63f($3 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($3 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($3 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h0e53d0166415c79c($3 | 0, $1 | 0);
   $1 = HEAP32[($3 + 4 | 0) >> 2] | 0;
   $5 = HEAP32[$3 >> 2] | 0;
   label$2 : {
    label$3 : {
     if (!$2) {
      break label$3
     }
     $cardano_serialization_lib__plutus__PlutusList_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h152fda99fe0d4350($3 + 48 | 0 | 0, $2 | 0);
     break label$2;
    }
    HEAP8[($3 + 60 | 0) >> 0] = 3;
   }
   $2 = ($3 + 64 | 0) + 8 | 0;
   i64toi32_i32$2 = ($3 + 48 | 0) + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $39 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   HEAP32[i64toi32_i32$0 >> 2] = $39;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[($3 + 48 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($3 + 52 | 0) >> 2] | 0;
   $42 = i64toi32_i32$1;
   i64toi32_i32$1 = $3;
   HEAP32[($3 + 64 | 0) >> 2] = $42;
   HEAP32[($3 + 68 | 0) >> 2] = i64toi32_i32$0;
   cardano_serialization_lib__utils__hash_script_data__h3bfd14619c9a5014($3 + 16 | 0 | 0, $4 | 0, $5 | 0, $3 + 64 | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   i64toi32_i32$2 = ($3 + 16 | 0) + 24 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $65 = i64toi32_i32$0;
   i64toi32_i32$0 = ($3 + 64 | 0) + 24 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $65;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = ($3 + 16 | 0) + 16 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $72 = i64toi32_i32$1;
   i64toi32_i32$1 = ($3 + 64 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $72;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = ($3 + 16 | 0) + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $77 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   HEAP32[i64toi32_i32$0 >> 2] = $77;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[($3 + 16 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($3 + 20 | 0) >> 2] | 0;
   $80 = i64toi32_i32$1;
   i64toi32_i32$1 = $3;
   HEAP32[($3 + 64 | 0) >> 2] = $80;
   HEAP32[($3 + 68 | 0) >> 2] = i64toi32_i32$0;
   $0 = $cardano_serialization_lib__crypto__ScriptDataHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h4525048b15d98533($3 + 64 | 0 | 0) | 0;
   global$0 = $3 + 96 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function cardano_serialization_lib__crypto__LegacyDaedalusPrivateKey__from_bytes__ha8cc01b057292df5($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $6 = 0, $7 = 0, $8 = 0, $9 = 0, $4 = 0, $5 = 0;
  $3 = global$0 - 208 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    if (($2 | 0) != (96 | 0)) {
     break label$2
    }
    $2 = 0;
    memset($3 + 112 | 0 | 0, 0 | 0, 96 | 0) | 0;
    core__slice___impl_20_5bT_5d___clone_from_slice__h1742dfbd5d5d9efd($3 + 112 | 0 | 0, 96 | 0, $1 | 0, 96 | 0);
    $1 = HEAPU8[($3 + 112 | 0) >> 0] | 0;
    $4 = HEAPU8[($3 + 113 | 0) >> 0] | 0 | ((HEAPU8[($3 + 114 | 0) >> 0] | 0) << 8 | 0) | 0;
    $5 = HEAPU8[($3 + 115 | 0) >> 0] | 0 | ((HEAPU8[($3 + 116 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 117 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 118 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    memcpy($3 + 8 | 0 | 0, $3 + 119 | 0 | 0, 89 | 0) | 0;
    $6 = $0 + 4 | 0;
    $7 = $5;
    HEAP8[$6 >> 0] = $7;
    HEAP8[($6 + 1 | 0) >> 0] = $7 >>> 8 | 0;
    HEAP8[($6 + 2 | 0) >> 0] = $7 >>> 16 | 0;
    HEAP8[($6 + 3 | 0) >> 0] = $7 >>> 24 | 0;
    $8 = $0 + 2 | 0;
    $9 = $4;
    HEAP8[$8 >> 0] = $9;
    HEAP8[($8 + 1 | 0) >> 0] = $9 >>> 8 | 0;
    HEAP8[($0 + 1 | 0) >> 0] = $1;
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 89 | 0) | 0;
    break label$1;
   }
   HEAP8[($3 + 103 | 0) >> 0] = 0;
   $2 = 1;
   HEAP32[($3 + 132 | 0) >> 2] = 1;
   HEAP32[($3 + 116 | 0) >> 2] = 1;
   HEAP32[($3 + 120 | 0) >> 2] = 0;
   HEAP32[($3 + 112 | 0) >> 2] = 1066504;
   HEAP32[($3 + 108 | 0) >> 2] = 44;
   HEAP32[($3 + 128 | 0) >> 2] = $3 + 104 | 0;
   HEAP32[($3 + 104 | 0) >> 2] = $3 + 103 | 0;
   alloc__fmt__format__h6e9e003a52c07309($3 + 8 | 0 | 0, $3 + 112 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 | 0, $3 + 8 | 0 | 0);
   $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[$3 >> 2] | 0 | 0, HEAP32[($3 + 4 | 0) >> 2] | 0 | 0) | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 8 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 8 | 0 | 0);
   HEAP32[($0 + 4 | 0) >> 2] = $1;
  }
  HEAP8[$0 >> 0] = $2;
  global$0 = $3 + 208 | 0;
 }
 
 function $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__hd8f3cdafde636295($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $5 = 0, $4 = 0, $6 = 0, $3 = 0, $7 = 0, $48 = 0, $70 = 0, $74 = 0, $77 = 0, $88 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__ha538daa28fd542ac($2 + 8 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     if (!(HEAP32[($2 + 8 | 0) >> 2] | 0)) {
      break label$3
     }
     cardano_serialization_lib__plutus__Language__to_bytes__hfc301904eed509f1($2 + 32 | 0 | 0, $2 | 0);
     if (HEAP32[($2 + 32 | 0) >> 2] | 0) {
      break label$2
     }
    }
    i64toi32_i32$1 = $0;
    i64toi32_i32$0 = 0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = 0;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[i64toi32_i32$1 >> 2] = HEAP32[(0 + 1067632 | 0) >> 2] | 0;
    break label$1;
   }
   $3 = $1 + 24 | 0;
   $4 = HEAP32[$3 >> 2] | 0;
   $5 = $4 + 1 | 0;
   alloc__raw_vec__RawVec_T_2cA___allocate_in__h94b8afe7a3e1d5bb($2 | 0, ($5 >>> 0 < $4 >>> 0 ? -1 : $5) | 0, 0 | 0);
   $5 = ($2 + 32 | 0) + 8 | 0;
   $6 = HEAP32[$5 >> 2] | 0;
   $7 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $4 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
   $48 = i64toi32_i32$0;
   i64toi32_i32$0 = $4;
   HEAP32[i64toi32_i32$0 >> 2] = $48;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $6;
   $6 = ($2 + 16 | 0) + 8 | 0;
   HEAP32[$6 >> 2] = 1;
   HEAP32[($2 + 20 | 0) >> 2] = $7;
   HEAP32[($2 + 16 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[(($2 + 32 | 0) + 24 | 0) >> 2] = HEAP32[$3 >> 2] | 0;
   i64toi32_i32$2 = $1 + 16 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $70 = i64toi32_i32$1;
   i64toi32_i32$1 = ($2 + 32 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $70;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $1 + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $74 = i64toi32_i32$0;
   i64toi32_i32$0 = $5;
   HEAP32[i64toi32_i32$0 >> 2] = $74;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $77 = i64toi32_i32$1;
   i64toi32_i32$1 = $2;
   HEAP32[($2 + 32 | 0) >> 2] = $77;
   HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$0;
   alloc__vec__Vec_T_2cA___extend_desugared__hf66dda82fdeb0b83($2 + 16 | 0 | 0, $2 + 32 | 0 | 0);
   HEAP32[($0 + 8 | 0) >> 2] = HEAP32[$6 >> 2] | 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   $88 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[i64toi32_i32$0 >> 2] = $88;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  }
  global$0 = $2 + 64 | 0;
 }
 
 function cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__add_bootstrap_input__h233fca55423e7cf8($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $4 = 0, $6 = 0, $8 = 0, $9 = 0, $7 = 0, $7$hi = 0, $5 = 0, $8$hi = 0, $9$hi = 0, $46 = 0, $51 = 0, $56 = 0, $62 = 0, $83 = 0;
  $4 = global$0 - 128 | 0;
  global$0 = $4;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  $5 = HEAP32[$2 >> 2] | 0;
  $6 = 0;
  label$1 : {
   if ((HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($4 + 16 | 0 | 4 | 0 | 0, $3 + 12 | 0 | 0);
   $6 = 1;
  }
  $3 = ($4 + 16 | 0) + 8 | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $8 = i64toi32_i32$1;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$1 = $4 + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $8;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($4 + 16 | 0) >> 2] = $6;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[($4 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($4 + 20 | 0) >> 2] | 0;
  $9 = i64toi32_i32$0;
  $9$hi = i64toi32_i32$1;
  i64toi32_i32$0 = $4;
  HEAP32[i64toi32_i32$0 >> 2] = $9;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = i64toi32_i32$0 + 32 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = ($4 + 16 | 0) + 28 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $46;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = i64toi32_i32$2 + 12 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $51 = i64toi32_i32$0;
  i64toi32_i32$0 = $4 + 52 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $51;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2 + 20 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $56 = i64toi32_i32$1;
  i64toi32_i32$1 = $4 + 60 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $56;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2 + 28 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $62 = i64toi32_i32$0;
  i64toi32_i32$0 = ($4 + 16 | 0) + 52 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $62;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$0 = $4;
  HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = $9;
  HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 80 | 0) >> 0] = 0;
  HEAP32[(i64toi32_i32$0 + 40 | 0) >> 2] = $5;
  i64toi32_i32$1 = $7$hi;
  HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__push_input__h5d706b01e1a860c0($0 | 0, i64toi32_i32$0 + 16 | 0 | 0);
  cardano_serialization_lib__address__ByronAddress__to_bytes__h95edb62bc4a38025(i64toi32_i32$0 + 112 | 0 | 0, $1 | 0);
  HEAP32[$3 >> 2] = HEAP32[((i64toi32_i32$0 + 112 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 112 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$0 + 116 | 0) >> 2] | 0;
  $83 = i64toi32_i32$1;
  i64toi32_i32$1 = $4;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $83;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  alloc__collections__btree__map__BTreeMap_K_2cV___insert__hd977578f5a177830($0 + 52 | 0 | 0, i64toi32_i32$1 + 16 | 0 | 0) | 0;
  global$0 = i64toi32_i32$1 + 128 | 0;
 }
 
 function std__sys_common__thread_parker__generic__Parker__unpark__h3b45d170e4cad40d($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $3 = 0;
  $1 = global$0 - 32 | 0;
  global$0 = $1;
  $2 = HEAP32[$0 >> 2] | 0;
  HEAP32[$0 >> 2] = 2;
  label$1 : {
   label$2 : {
    switch ($2 | 0) {
    default:
     std__panicking__begin_panic__h7867d4da632f3661(1145164 | 0, 28 | 0, 1145192 | 0);
     abort();
    case 1:
     $2 = HEAPU8[($0 + 4 | 0) >> 0] | 0;
     HEAP8[($0 + 4 | 0) >> 0] = 1;
     $2 = $2 & 1 | 0;
     HEAP8[($1 + 7 | 0) >> 0] = $2;
     if ($2) {
      break label$1
     }
     $2 = $0 + 4 | 0;
     $3 = 0;
     label$5 : {
      label$6 : {
       label$7 : {
        label$8 : {
         label$9 : {
          if (!((HEAP32[(0 + 1177836 | 0) >> 2] | 0) & 2147483647 | 0)) {
           break label$9
          }
          $3 = std__panicking__panic_count__is_zero_slow_path__h1d20871758c70487() | 0;
          if (!(HEAPU8[($0 + 5 | 0) >> 0] | 0)) {
           break label$7
          }
          $3 = $3 ^ 1 | 0;
          break label$8;
         }
         if (!(HEAPU8[($0 + 5 | 0) >> 0] | 0)) {
          break label$6
         }
        }
        HEAP8[($1 + 12 | 0) >> 0] = $3;
        HEAP32[($1 + 8 | 0) >> 2] = $2;
        core__result__unwrap_failed__h27f43d993c3864a1(1142536 | 0, 43 | 0, $1 + 8 | 0 | 0, 1142580 | 0, 1145208 | 0);
        abort();
       }
       if (!$3) {
        break label$5
       }
      }
      if (!((HEAP32[(0 + 1177836 | 0) >> 2] | 0) & 2147483647 | 0)) {
       break label$5
      }
      if (std__panicking__panic_count__is_zero_slow_path__h1d20871758c70487() | 0) {
       break label$5
      }
      HEAP8[($0 + 5 | 0) >> 0] = 1;
     }
     HEAP8[$2 >> 0] = 0;
     break;
    case 0:
    case 2:
     break label$2;
    };
   }
   global$0 = $1 + 32 | 0;
   return;
  }
  HEAP32[($1 + 28 | 0) >> 2] = 0;
  HEAP32[($1 + 24 | 0) >> 2] = 1142260;
  HEAP32[($1 + 12 | 0) >> 2] = 1;
  HEAP32[($1 + 16 | 0) >> 2] = 0;
  HEAP32[($1 + 8 | 0) >> 2] = 1145368;
  core__panicking__assert_failed__h1e2384889c2d638e($1 + 7 | 0 | 0, $1 + 8 | 0 | 0);
  abort();
 }
 
 function linked_hash_map__LinkedHashMap_K_2cV_2cS___get__hf6a483159ed52c35($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $7$hi = 0, $16 = 0, $7 = 0, $4 = 0, $5 = 0, $6 = 0, $70 = 0, $70$hi = 0, $90 = 0, $90$hi = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  i64toi32_i32$0 = hashbrown__map__make_hash__ha89093b04cf4755b($0 | 0, $1 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  $4 = (HEAP32[($0 + 16 | 0) >> 2] | 0) & i64toi32_i32$0 | 0;
  $16 = (HEAP32[($0 + 20 | 0) >> 2] | 0) + $4 | 0;
  $5 = HEAPU8[$16 >> 0] | 0 | ((HEAPU8[($16 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($16 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($16 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $6 = 0;
  HEAP32[($2 + 32 | 0) >> 2] = 0;
  HEAP32[($2 + 36 | 0) >> 2] = $5;
  HEAP32[($2 + 28 | 0) >> 2] = $4;
  HEAP32[($2 + 24 | 0) >> 2] = $0 + 16 | 0;
  $0 = i64toi32_i32$0 >>> 25 | 0;
  HEAP8[($2 + 44 | 0) >> 0] = $0;
  $0 = $5 ^ Math_imul($0, 16843009) | 0;
  HEAP32[($2 + 40 | 0) >> 2] = (($0 ^ -1 | 0) & ($0 + -16843009 | 0) | 0) & -2139062144 | 0;
  $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($2 + 16 | 0 | 0, $2 + 24 | 0 | 0);
  label$1 : {
   if (!(HEAP32[($2 + 16 | 0) >> 2] | 0)) {
    break label$1
   }
   label$2 : {
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $7 = i64toi32_i32$1;
    $7$hi = i64toi32_i32$0;
    $0 = (HEAP32[((HEAP32[($2 + 24 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) - ((HEAP32[($2 + 20 | 0) >> 2] | 0) << 3 | 0) | 0;
    i64toi32_i32$2 = HEAP32[($0 + -8 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $70 = i64toi32_i32$0;
    $70$hi = i64toi32_i32$1;
    i64toi32_i32$1 = $7$hi;
    i64toi32_i32$2 = $7;
    i64toi32_i32$0 = $70$hi;
    i64toi32_i32$3 = $70;
    if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
     break label$2
    }
    label$3 : while (1) {
     $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($2 + 8 | 0 | 0, $2 + 24 | 0 | 0);
     if (!(HEAP32[($2 + 8 | 0) >> 2] | 0)) {
      break label$1
     }
     i64toi32_i32$2 = $7$hi;
     $0 = (HEAP32[((HEAP32[($2 + 24 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) - ((HEAP32[($2 + 12 | 0) >> 2] | 0) << 3 | 0) | 0;
     i64toi32_i32$3 = HEAP32[($0 + -8 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $90 = i64toi32_i32$2;
     $90$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$3 = $7;
     i64toi32_i32$2 = $90$hi;
     i64toi32_i32$0 = $90;
     if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$2 | 0) | 0) {
      continue label$3
     }
     break label$3;
    };
   }
   $6 = (HEAP32[($0 + -4 | 0) >> 2] | 0) + 8 | 0;
  }
  global$0 = $2 + 48 | 0;
  return $6 | 0;
 }
 
 function enterpriseaddress_from_address($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $17 = 0, $3 = 0, $2 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $4 = 0, $6 = 0, $6$hi = 0, $5 = 0, $7 = 0, $7$hi = 0, $41 = 0, $62 = 0, $67 = 0, $79 = 0;
  $1 = global$0 - 112 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hab2c0cbdcb539b91($1 + 8 | 0 | 0, $0 | 0);
   $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   $3 = 2;
   label$2 : {
    $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    if ((HEAPU8[$0 >> 0] | 0 | 0) != (2 | 0)) {
     break label$2
    }
    $4 = HEAPU8[($0 + 1 | 0) >> 0] | 0;
    $3 = HEAPU8[($0 + 2 | 0) >> 0] | 0;
    i64toi32_i32$2 = $0 + 3 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $6 = i64toi32_i32$0;
    $6$hi = i64toi32_i32$1;
    $17 = $0 + 27 | 0;
    $5 = HEAPU8[$17 >> 0] | 0 | ((HEAPU8[($17 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($17 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($17 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$2 = $0 + 19 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $7 = i64toi32_i32$1;
    $7$hi = i64toi32_i32$0;
    i64toi32_i32$2 = $0 + 11 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $41 = i64toi32_i32$0;
    i64toi32_i32$0 = $1 + 24 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $41;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $7$hi;
    i64toi32_i32$0 = $1 + 32 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $7;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($1 + 40 | 0) >> 2] = $5;
    i64toi32_i32$1 = $6$hi;
    i64toi32_i32$0 = $1;
    HEAP32[($1 + 16 | 0) >> 2] = $6;
    HEAP32[($1 + 20 | 0) >> 2] = i64toi32_i32$1;
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
   $0 = 0;
   label$3 : {
    if (($3 & 255 | 0 | 0) == (2 | 0)) {
     break label$3
    }
    i64toi32_i32$2 = $1 + 24 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $62 = i64toi32_i32$1;
    i64toi32_i32$1 = $1 + 90 | 0;
    $18 = $62;
    HEAP16[i64toi32_i32$1 >> 1] = $18;
    HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $18 >>> 16 | 0;
    HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = i64toi32_i32$0;
    HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
    i64toi32_i32$2 = $1 + 32 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $67 = i64toi32_i32$0;
    i64toi32_i32$0 = $1 + 98 | 0;
    $19 = $67;
    HEAP16[i64toi32_i32$0 >> 1] = $19;
    HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $19 >>> 16 | 0;
    HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$1;
    HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
    $20 = $1 + 106 | 0;
    $21 = HEAP32[($1 + 40 | 0) >> 2] | 0;
    HEAP16[$20 >> 1] = $21;
    HEAP16[($20 + 2 | 0) >> 1] = $21 >>> 16 | 0;
    HEAP8[($1 + 81 | 0) >> 0] = $3;
    HEAP8[($1 + 80 | 0) >> 0] = $4;
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
    $79 = i64toi32_i32$1;
    i64toi32_i32$1 = i64toi32_i32$2;
    $22 = $79;
    HEAP16[(i64toi32_i32$2 + 82 | 0) >> 1] = $22;
    HEAP16[(i64toi32_i32$2 + 84 | 0) >> 1] = $22 >>> 16 | 0;
    HEAP16[(i64toi32_i32$2 + 86 | 0) >> 1] = i64toi32_i32$0;
    HEAP16[(i64toi32_i32$2 + 88 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
    $0 = $cardano_serialization_lib__address__EnterpriseAddress_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hc6936df3a6b251b0(i64toi32_i32$2 + 80 | 0 | 0) | 0;
   }
   global$0 = $1 + 112 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function rewardaddress_from_address($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $17 = 0, $3 = 0, $2 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $4 = 0, $6 = 0, $6$hi = 0, $5 = 0, $7 = 0, $7$hi = 0, $41 = 0, $62 = 0, $67 = 0, $79 = 0;
  $1 = global$0 - 112 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hab2c0cbdcb539b91($1 + 8 | 0 | 0, $0 | 0);
   $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   $3 = 2;
   label$2 : {
    $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    if ((HEAPU8[$0 >> 0] | 0 | 0) != (3 | 0)) {
     break label$2
    }
    $4 = HEAPU8[($0 + 1 | 0) >> 0] | 0;
    $3 = HEAPU8[($0 + 2 | 0) >> 0] | 0;
    i64toi32_i32$2 = $0 + 3 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $6 = i64toi32_i32$0;
    $6$hi = i64toi32_i32$1;
    $17 = $0 + 27 | 0;
    $5 = HEAPU8[$17 >> 0] | 0 | ((HEAPU8[($17 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($17 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($17 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$2 = $0 + 19 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $7 = i64toi32_i32$1;
    $7$hi = i64toi32_i32$0;
    i64toi32_i32$2 = $0 + 11 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $41 = i64toi32_i32$0;
    i64toi32_i32$0 = $1 + 24 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $41;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $7$hi;
    i64toi32_i32$0 = $1 + 32 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $7;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($1 + 40 | 0) >> 2] = $5;
    i64toi32_i32$1 = $6$hi;
    i64toi32_i32$0 = $1;
    HEAP32[($1 + 16 | 0) >> 2] = $6;
    HEAP32[($1 + 20 | 0) >> 2] = i64toi32_i32$1;
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
   $0 = 0;
   label$3 : {
    if (($3 & 255 | 0 | 0) == (2 | 0)) {
     break label$3
    }
    i64toi32_i32$2 = $1 + 24 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $62 = i64toi32_i32$1;
    i64toi32_i32$1 = $1 + 90 | 0;
    $18 = $62;
    HEAP16[i64toi32_i32$1 >> 1] = $18;
    HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $18 >>> 16 | 0;
    HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = i64toi32_i32$0;
    HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
    i64toi32_i32$2 = $1 + 32 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $67 = i64toi32_i32$0;
    i64toi32_i32$0 = $1 + 98 | 0;
    $19 = $67;
    HEAP16[i64toi32_i32$0 >> 1] = $19;
    HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $19 >>> 16 | 0;
    HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$1;
    HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
    $20 = $1 + 106 | 0;
    $21 = HEAP32[($1 + 40 | 0) >> 2] | 0;
    HEAP16[$20 >> 1] = $21;
    HEAP16[($20 + 2 | 0) >> 1] = $21 >>> 16 | 0;
    HEAP8[($1 + 81 | 0) >> 0] = $3;
    HEAP8[($1 + 80 | 0) >> 0] = $4;
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
    $79 = i64toi32_i32$1;
    i64toi32_i32$1 = i64toi32_i32$2;
    $22 = $79;
    HEAP16[(i64toi32_i32$2 + 82 | 0) >> 1] = $22;
    HEAP16[(i64toi32_i32$2 + 84 | 0) >> 1] = $22 >>> 16 | 0;
    HEAP16[(i64toi32_i32$2 + 86 | 0) >> 1] = i64toi32_i32$0;
    HEAP16[(i64toi32_i32$2 + 88 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
    $0 = $cardano_serialization_lib__address__RewardAddress_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8b4ddbbcde95397b(i64toi32_i32$2 + 80 | 0 | 0) | 0;
   }
   global$0 = $1 + 112 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function cardano_serialization_lib__Certificate__from_bytes__hbe10ee7597a65a88($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, $3 = 0, $16 = 0, $4 = 0, $4$hi = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 832 | 0;
  global$0 = $2;
  HEAP32[($2 + 416 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 400 | 0) >> 2] = 0;
  HEAP32[($2 + 404 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $16 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 408 | 0) >> 2] = $16;
  HEAP32[($2 + 412 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__CertificateEnum___deserialize__h3059f65111c7091a($2 + 624 | 0 | 0, $2 + 400 | 0 | 0);
  $3 = ($2 + 624 | 0) + 8 | 0;
  $1 = ($2 + 400 | 0) + 8 | 0;
  label$1 : {
   label$2 : {
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[($2 + 624 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 628 | 0) >> 2] | 0;
    $4 = i64toi32_i32$1;
    $4$hi = i64toi32_i32$0;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    i64toi32_i32$3 = 1;
    if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
     break label$2
    }
    memcpy($2 + 424 | 0 | 0, $3 | 0, 200 | 0) | 0;
    memcpy($2 + 200 | 0 | 0, $2 + 424 | 0 | 0, 200 | 0) | 0;
    break label$1;
   }
   memcpy($2 + 424 | 0 | 0, $3 | 0, 64 | 0) | 0;
   memcpy($2 + 200 | 0 | 0, $2 + 424 | 0 | 0, 64 | 0) | 0;
  }
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  label$3 : {
   label$4 : {
    i64toi32_i32$2 = $4$hi;
    i64toi32_i32$3 = $4;
    i64toi32_i32$0 = 0;
    i64toi32_i32$1 = 0;
    if ((i64toi32_i32$3 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$0 | 0) | 0) {
     break label$4
    }
    memcpy($0 + 8 | 0 | 0, memcpy($2 | 0, $2 + 200 | 0 | 0, 200 | 0) | 0 | 0, 200 | 0) | 0;
    $1 = 0;
    break label$3;
   }
   $1 = memcpy($2 | 0, $2 + 200 | 0 | 0, 64 | 0) | 0;
   memcpy($1 + 624 | 0 | 0, $1 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($1 + 624 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 832 | 0;
 }
 
 function cardano_serialization_lib__metadata__TransactionMetadatum__from_bytes__hcb5aa2356703d6e1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, $3 = 0, $16 = 0, $4 = 0, $4$hi = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 288 | 0;
  global$0 = $2;
  HEAP32[($2 + 144 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 128 | 0) >> 2] = 0;
  HEAP32[($2 + 132 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $16 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 136 | 0) >> 2] = $16;
  HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__metadata__TransactionMetadatumEnum_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h6868ff659c396c1d($2 + 216 | 0 | 0, $2 + 128 | 0 | 0);
  $3 = ($2 + 216 | 0) + 8 | 0;
  $1 = ($2 + 128 | 0) + 8 | 0;
  label$1 : {
   label$2 : {
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[($2 + 216 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 220 | 0) >> 2] | 0;
    $4 = i64toi32_i32$1;
    $4$hi = i64toi32_i32$0;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    i64toi32_i32$3 = 1;
    if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
     break label$2
    }
    memcpy($2 + 152 | 0 | 0, $3 | 0, 48 | 0) | 0;
    memcpy($2 + 64 | 0 | 0, $2 + 152 | 0 | 0, 48 | 0) | 0;
    break label$1;
   }
   memcpy($2 + 152 | 0 | 0, $3 | 0, 64 | 0) | 0;
   memcpy($2 + 64 | 0 | 0, $2 + 152 | 0 | 0, 64 | 0) | 0;
  }
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  label$3 : {
   label$4 : {
    i64toi32_i32$2 = $4$hi;
    i64toi32_i32$3 = $4;
    i64toi32_i32$0 = 0;
    i64toi32_i32$1 = 0;
    if ((i64toi32_i32$3 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$0 | 0) | 0) {
     break label$4
    }
    memcpy($0 + 8 | 0 | 0, memcpy($2 | 0, $2 + 64 | 0 | 0, 48 | 0) | 0 | 0, 48 | 0) | 0;
    $1 = 0;
    break label$3;
   }
   $1 = memcpy($2 | 0, $2 + 64 | 0 | 0, 64 | 0) | 0;
   memcpy($1 + 216 | 0 | 0, $1 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($1 + 216 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 288 | 0;
 }
 
 function $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__ha556d4e8ab20831e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $2 = 0, $3 = 0, $7 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $4 = 0, $5 = 0, $27 = 0, $35 = 0, $38 = 0, $6 = 0, $49 = 0, $53 = 0, $57 = 0, $71 = 0, $74 = 0, $85 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  $core__iter__adapters__ResultShunt_I_2cE__20as_20core__iter__traits__iterator__Iterator___try_fold__h31a0d674d945c00d($2 + 56 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    $3 = HEAPU8[($2 + 56 | 0) >> 0] | 0;
    if (($3 | 0) != (6 | 0)) {
     break label$2
    }
    i64toi32_i32$1 = $0;
    i64toi32_i32$0 = 0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = 0;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[i64toi32_i32$1 >> 2] = HEAP32[(0 + 1067624 | 0) >> 2] | 0;
    break label$1;
   }
   $4 = $2 + 47 | 0;
   i64toi32_i32$2 = ($2 + 56 | 0) + 16 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $27 = i64toi32_i32$0;
   i64toi32_i32$0 = $4;
   $20 = $27;
   HEAP8[i64toi32_i32$0 >> 0] = $20;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $20 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $20 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $20 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   $5 = ($2 + 32 | 0) + 8 | 0;
   i64toi32_i32$2 = ($2 + 56 | 0) + 9 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $35 = i64toi32_i32$1;
   i64toi32_i32$1 = $5;
   HEAP32[i64toi32_i32$1 >> 2] = $35;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 57 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 58 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 59 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 60 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 61 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 62 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 63 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 64 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $38 = i64toi32_i32$0;
   i64toi32_i32$0 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] = $38;
   HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] = i64toi32_i32$1;
   alloc__raw_vec__RawVec_T_2cA___allocate_in__h0e767008da1e2eac(i64toi32_i32$2 + 8 | 0 | 0, 1 | 0, 0 | 0);
   $6 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
   $7 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
   HEAP8[$7 >> 0] = $3;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
   $49 = i64toi32_i32$1;
   i64toi32_i32$1 = $7;
   $21 = $49;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $21;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $21 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $21 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = $21 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 8 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $5;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $53 = i64toi32_i32$0;
   i64toi32_i32$0 = $7 + 9 | 0;
   $22 = $53;
   HEAP8[i64toi32_i32$0 >> 0] = $22;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $22 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $22 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $22 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = $4;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $57 = i64toi32_i32$1;
   i64toi32_i32$1 = $7 + 16 | 0;
   $23 = $57;
   HEAP8[i64toi32_i32$1 >> 0] = $23;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $23 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $23 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $23 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   $3 = ($2 + 16 | 0) + 8 | 0;
   HEAP32[$3 >> 2] = 1;
   HEAP32[($2 + 20 | 0) >> 2] = $6;
   HEAP32[($2 + 16 | 0) >> 2] = $7;
   i64toi32_i32$2 = $1 + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $71 = i64toi32_i32$0;
   i64toi32_i32$0 = ($2 + 56 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $71;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $74 = i64toi32_i32$1;
   i64toi32_i32$1 = $2;
   HEAP32[(i64toi32_i32$1 + 56 | 0) >> 2] = $74;
   HEAP32[(i64toi32_i32$1 + 60 | 0) >> 2] = i64toi32_i32$0;
   alloc__vec__Vec_T_2cA___extend_desugared__h1a058c7bd5b87d07(i64toi32_i32$1 + 16 | 0 | 0, i64toi32_i32$1 + 56 | 0 | 0);
   HEAP32[($0 + 8 | 0) >> 2] = HEAP32[$3 >> 2] | 0;
   i64toi32_i32$2 = i64toi32_i32$1;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
   $85 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[i64toi32_i32$0 >> 2] = $85;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  }
  global$0 = $2 + 80 | 0;
 }
 
 function cardano_serialization_lib__Ipv6__new__hbd44d20e73de6619($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $9 = 0, $10 = 0, $14 = 0, $24 = 0, $30 = 0;
  $2 = global$0 - 208 | 0;
  global$0 = $2;
  HEAP32[(($2 + 80 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 80 | 0) >> 2] = $14;
  HEAP32[($2 + 84 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__Ipv6__new_impl__h24a5893493c4a06f($2 + 8 | 0 | 0, $2 + 80 | 0 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAPU8[($2 + 8 | 0) >> 0] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAPU8[($2 + 9 | 0) >> 0] | 0 | ((HEAPU8[($2 + 10 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 11 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 12 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[($2 + 13 | 0) >> 0] | 0 | ((HEAPU8[($2 + 14 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 15 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 16 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $24 = i64toi32_i32$1;
     i64toi32_i32$1 = $0;
     $9 = $24;
     HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $9;
     HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $9 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $9 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = $9 >>> 24 | 0;
     HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0;
     HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
     HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
     HEAP8[(i64toi32_i32$1 + 8 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
     i64toi32_i32$2 = ($2 + 8 | 0) + 9 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $30 = i64toi32_i32$0;
     i64toi32_i32$0 = $0 + 9 | 0;
     $10 = $30;
     HEAP8[i64toi32_i32$0 >> 0] = $10;
     HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $10 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $10 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $10 >>> 24 | 0;
     HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
     HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
     HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
     HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
     $1 = 0;
     break label$2;
    }
    memcpy($2 + 80 | 0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 64 | 0) | 0;
    i64toi32_i32$0 = $2;
    i64toi32_i32$1 = 0;
    HEAP32[($2 + 148 | 0) >> 2] = 0;
    HEAP32[($2 + 152 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($2 + 144 | 0) >> 2] = HEAP32[(0 + 1050212 | 0) >> 2] | 0;
    core__fmt__Formatter__new__he219faf25326051b($2 + 160 | 0 | 0, $2 + 144 | 0 | 0, 1049880 | 0);
    if ($cardano_serialization_lib__error__DeserializeError_20as_20core__fmt__Display___fmt__h10cc598fcad2b670($2 + 80 | 0 | 0, $2 + 160 | 0 | 0) | 0) {
     break label$1
    }
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 | 0, $2 + 144 | 0 | 0);
    $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0) | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 144 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 144 | 0 | 0);
    core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9($2 + 80 | 0 | 0);
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    $1 = 1;
   }
   HEAP8[$0 >> 0] = $1;
   global$0 = $2 + 208 | 0;
   return;
  }
  core__result__unwrap_failed__h27f43d993c3864a1(1049904 | 0, 55 | 0, $2 + 200 | 0 | 0, 1050096 | 0, 1050036 | 0);
  abort();
 }
 
 function get_implicit_input($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $4 = 0, $5 = 0, $66 = 0, $73 = 0, $78 = 0;
  $3 = global$0 - 80 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h356c30395cf13adb($3 + 16 | 0 | 0, $0 | 0);
    if (!$1) {
     break label$2
    }
    $0 = HEAP32[($3 + 20 | 0) >> 2] | 0;
    $4 = HEAP32[($3 + 16 | 0) >> 2] | 0;
    wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($3 + 8 | 0 | 0, $1 | 0);
    if (!$2) {
     break label$2
    }
    $1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
    $5 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($3 | 0, $2 | 0);
    $2 = HEAP32[($3 + 4 | 0) >> 2] | 0;
    cardano_serialization_lib__utils__internal_get_implicit_input__h61eaf21c0f86e6a4($3 + 24 | 0 | 0, $4 + 24 | 0 | 0, $4 + 152 | 0 | 0, $5 | 0, HEAP32[$3 >> 2] | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    if ((HEAP32[($3 + 24 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    i64toi32_i32$2 = ($3 + 24 | 0) + 24 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $66 = i64toi32_i32$0;
    i64toi32_i32$0 = ($3 + 56 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $66;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = ($3 + 24 | 0) + 16 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $73 = i64toi32_i32$1;
    i64toi32_i32$1 = ($3 + 56 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $73;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = ($3 + 24 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $78 = i64toi32_i32$0;
    i64toi32_i32$0 = $3;
    HEAP32[($3 + 56 | 0) >> 2] = $78;
    HEAP32[($3 + 60 | 0) >> 2] = i64toi32_i32$1;
    $0 = $cardano_serialization_lib__utils__Value_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h50a1108e1e08f966($3 + 56 | 0 | 0) | 0;
    global$0 = $3 + 80 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($3 + 28 | 0) >> 2] | 0 | 0);
  abort();
 }
 
 function linked_hash_map__LinkedHashMap_K_2cV_2cS___get__had20bd8f0f401fc5($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $5 = 0, $9 = 0, $3 = 0, $4 = 0, $6 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  i64toi32_i32$0 = hashbrown__map__make_hash__hcc2c1bbb7174b1af($0 | 0, $1 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $3 = i64toi32_i32$0;
  $4 = (HEAP32[($0 + 16 | 0) >> 2] | 0) & $3 | 0;
  $9 = (HEAP32[($0 + 20 | 0) >> 2] | 0) + $4 | 0;
  $5 = HEAPU8[$9 >> 0] | 0 | ((HEAPU8[($9 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($9 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($9 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $6 = 0;
  HEAP32[($2 + 32 | 0) >> 2] = 0;
  HEAP32[($2 + 36 | 0) >> 2] = $5;
  HEAP32[($2 + 28 | 0) >> 2] = $4;
  HEAP32[($2 + 24 | 0) >> 2] = $0 + 16 | 0;
  $0 = $3 >>> 25 | 0;
  HEAP8[($2 + 44 | 0) >> 0] = $0;
  $0 = $5 ^ Math_imul($0, 16843009) | 0;
  HEAP32[($2 + 40 | 0) >> 2] = (($0 ^ -1 | 0) & ($0 + -16843009 | 0) | 0) & -2139062144 | 0;
  $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($2 + 16 | 0 | 0, $2 + 24 | 0 | 0);
  label$1 : {
   if (!(HEAP32[($2 + 16 | 0) >> 2] | 0)) {
    break label$1
   }
   label$2 : {
    $5 = HEAP32[$1 >> 2] | 0;
    $0 = (HEAP32[((HEAP32[($2 + 24 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) - ((HEAP32[($2 + 20 | 0) >> 2] | 0) << 3 | 0) | 0;
    if (($5 | 0) == (HEAP32[(HEAP32[($0 + -8 | 0) >> 2] | 0) >> 2] | 0 | 0)) {
     break label$2
    }
    label$3 : while (1) {
     $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($2 + 8 | 0 | 0, $2 + 24 | 0 | 0);
     if (!(HEAP32[($2 + 8 | 0) >> 2] | 0)) {
      break label$1
     }
     $0 = (HEAP32[((HEAP32[($2 + 24 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) - ((HEAP32[($2 + 12 | 0) >> 2] | 0) << 3 | 0) | 0;
     if (($5 | 0) != (HEAP32[(HEAP32[($0 + -8 | 0) >> 2] | 0) >> 2] | 0 | 0)) {
      continue label$3
     }
     break label$3;
    };
   }
   $6 = HEAP32[($0 + -4 | 0) >> 2] | 0;
  }
  global$0 = $2 + 48 | 0;
  return $6 | 0;
 }
 
 function cardano_serialization_lib__crypto__Bip32PrivateKey__from_bytes__hdfbc703a3728d81d($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $5 = 0, $6 = 0, $7 = 0, $4 = 0;
  $3 = global$0 - 224 | 0;
  global$0 = $3;
  $cardano_serialization_lib__chain_crypto__algorithms__ed25519_derive__Ed25519Bip32_20as_20cardano_serialization_lib__chain_crypto__key__AsymmetricKey___secret_from_binary__h88d2302397adf84f($3 + 120 | 0 | 0, $1 | 0, $2 | 0);
  $1 = 1;
  $2 = HEAPU8[($3 + 121 | 0) >> 0] | 0;
  label$1 : {
   label$2 : {
    if ((HEAPU8[($3 + 120 | 0) >> 0] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAPU16[($3 + 122 | 0) >> 1] | 0;
    $4 = HEAP32[($3 + 124 | 0) >> 2] | 0;
    memcpy($3 + 16 | 0 | 0, ($3 + 120 | 0) + 8 | 0 | 0, 89 | 0) | 0;
    $5 = $0 + 4 | 0;
    $6 = $4;
    HEAP8[$5 >> 0] = $6;
    HEAP8[($5 + 1 | 0) >> 0] = $6 >>> 8 | 0;
    HEAP8[($5 + 2 | 0) >> 0] = $6 >>> 16 | 0;
    HEAP8[($5 + 3 | 0) >> 0] = $6 >>> 24 | 0;
    $7 = $0 + 2 | 0;
    HEAP8[$7 >> 0] = $1;
    HEAP8[($7 + 1 | 0) >> 0] = $1 >>> 8 | 0;
    HEAP8[($0 + 1 | 0) >> 0] = $2;
    memcpy($0 + 8 | 0 | 0, $3 + 16 | 0 | 0, 89 | 0) | 0;
    $1 = 0;
    break label$1;
   }
   HEAP8[($3 + 111 | 0) >> 0] = $2;
   HEAP32[($3 + 140 | 0) >> 2] = 1;
   HEAP32[($3 + 124 | 0) >> 2] = 1;
   HEAP32[($3 + 128 | 0) >> 2] = 0;
   HEAP32[($3 + 120 | 0) >> 2] = 1066504;
   HEAP32[($3 + 116 | 0) >> 2] = 44;
   HEAP32[($3 + 136 | 0) >> 2] = $3 + 112 | 0;
   HEAP32[($3 + 112 | 0) >> 2] = $3 + 111 | 0;
   alloc__fmt__format__h6e9e003a52c07309($3 + 16 | 0 | 0, $3 + 120 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $3 + 16 | 0 | 0);
   $2 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($3 + 8 | 0) >> 2] | 0 | 0, HEAP32[($3 + 12 | 0) >> 2] | 0 | 0) | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 16 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 16 | 0 | 0);
   HEAP32[($0 + 4 | 0) >> 2] = $2;
  }
  HEAP8[$0 >> 0] = $1;
  global$0 = $3 + 224 | 0;
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___entry__h276688dc4fd71bb7($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $4 = 0, $3 = 0, $5 = 0, $47 = 0, $53 = 0, $57 = 0, $62 = 0, $65 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$4) {
     break label$2
    }
    $5 = HEAP32[$1 >> 2] | 0;
    break label$1;
   }
   $5 = 0;
   $4 = alloc__boxed__Box_T_2cA___new_uninit_in__h04cd43b67903c159() | 0;
   HEAP16[($4 + 138 | 0) >> 1] = 0;
   HEAP32[$4 >> 2] = 0;
   HEAP32[($1 + 4 | 0) >> 2] = $4;
   HEAP32[$1 >> 2] = 0;
  }
  alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__hb0ce81fc1958ae1e($3 + 8 | 0 | 0, $5 | 0, $4 | 0, $2 | 0);
  $5 = 1;
  $4 = $3 + 8 | 0 | 4 | 0;
  label$3 : {
   label$4 : {
    if ((HEAP32[($3 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
     break label$4
    }
    $5 = ($3 + 24 | 0) + 8 | 0;
    HEAP32[$5 >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
    HEAP32[(($3 + 24 | 0) + 20 | 0) >> 2] = HEAP32[($4 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $47 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $47;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = $1;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $53 = i64toi32_i32$1;
    i64toi32_i32$1 = $3;
    HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] = $53;
    HEAP32[(i64toi32_i32$1 + 40 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $5;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $57 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 12 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $57;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $3 + 40 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $62 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 20 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $62;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    $5 = 0;
    break label$3;
   }
   i64toi32_i32$2 = $4;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $65 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $65;
   HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $1;
   HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 | 0);
  }
  HEAP32[$0 >> 2] = $5;
  global$0 = $3 + 48 | 0;
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___entry__h66ee8f940e8766a8($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $4 = 0, $3 = 0, $5 = 0, $47 = 0, $53 = 0, $57 = 0, $62 = 0, $65 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$4) {
     break label$2
    }
    $5 = HEAP32[$1 >> 2] | 0;
    break label$1;
   }
   $5 = 0;
   $4 = alloc__boxed__Box_T_2cA___new_uninit_in__h637e1ec719c3dde5() | 0;
   HEAP16[($4 + 314 | 0) >> 1] = 0;
   HEAP32[($4 + 176 | 0) >> 2] = 0;
   HEAP32[($1 + 4 | 0) >> 2] = $4;
   HEAP32[$1 >> 2] = 0;
  }
  alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__h487fda3c5b7fd5ef($3 + 8 | 0 | 0, $5 | 0, $4 | 0, $2 | 0);
  $5 = 1;
  $4 = $3 + 8 | 0 | 4 | 0;
  label$3 : {
   label$4 : {
    if ((HEAP32[($3 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
     break label$4
    }
    $5 = ($3 + 24 | 0) + 8 | 0;
    HEAP32[$5 >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
    HEAP32[(($3 + 24 | 0) + 20 | 0) >> 2] = HEAP32[($4 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $47 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $47;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = $1;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $53 = i64toi32_i32$1;
    i64toi32_i32$1 = $3;
    HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] = $53;
    HEAP32[(i64toi32_i32$1 + 40 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $5;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $57 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 12 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $57;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $3 + 40 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $62 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 20 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $62;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    $5 = 0;
    break label$3;
   }
   i64toi32_i32$2 = $4;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $65 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $65;
   HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $1;
   HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 | 0);
  }
  HEAP32[$0 >> 2] = $5;
  global$0 = $3 + 48 | 0;
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___entry__ha969beb26eee2f30($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $4 = 0, $3 = 0, $5 = 0, $47 = 0, $53 = 0, $57 = 0, $62 = 0, $65 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$4) {
     break label$2
    }
    $5 = HEAP32[$1 >> 2] | 0;
    break label$1;
   }
   $5 = 0;
   $4 = alloc__boxed__Box_T_2cA___new_uninit_in__h0005f5c05c0883da() | 0;
   HEAP16[($4 + 226 | 0) >> 1] = 0;
   HEAP32[($4 + 88 | 0) >> 2] = 0;
   HEAP32[($1 + 4 | 0) >> 2] = $4;
   HEAP32[$1 >> 2] = 0;
  }
  alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__h7cca0af434b441f5($3 + 8 | 0 | 0, $5 | 0, $4 | 0, $2 | 0);
  $5 = 1;
  $4 = $3 + 8 | 0 | 4 | 0;
  label$3 : {
   label$4 : {
    if ((HEAP32[($3 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
     break label$4
    }
    $5 = ($3 + 24 | 0) + 8 | 0;
    HEAP32[$5 >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
    HEAP32[(($3 + 24 | 0) + 20 | 0) >> 2] = HEAP32[($4 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $47 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $47;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = $1;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $53 = i64toi32_i32$1;
    i64toi32_i32$1 = $3;
    HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] = $53;
    HEAP32[(i64toi32_i32$1 + 40 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $5;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $57 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 12 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $57;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $3 + 40 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $62 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 20 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $62;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    $5 = 0;
    break label$3;
   }
   i64toi32_i32$2 = $4;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $65 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $65;
   HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $1;
   HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 | 0);
  }
  HEAP32[$0 >> 2] = $5;
  global$0 = $3 + 48 | 0;
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h09a8331f58cd0bf4($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $2 = 0, $6 = 0, $9 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $4 = 0, $5 = 0, $7 = 0, $8 = 0, $10 = 0, $11 = 0, $50 = 0, $55 = 0, $59 = 0, $63 = 0;
  $2 = global$0 - 128 | 0;
  global$0 = $2;
  $3 = HEAP32[$1 >> 2] | 0;
  $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7713ba2200389774($2 | 0, $4 | 0, 0 | 0);
  $5 = HEAP32[$2 >> 2] | 0;
  $6 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $6;
  HEAP32[$0 >> 2] = $5;
  label$1 : {
   if (!$6) {
    break label$1
   }
   $1 = Math_imul($4, 120);
   $7 = ($2 + 8 | 0) + 12 | 0;
   $8 = ($2 + 8 | 0) + 56 | 0;
   $9 = ($2 + 8 | 0) + 24 | 0;
   $10 = $9 + 16 | 0;
   $11 = $9 + 8 | 0;
   label$2 : while (1) {
    if (!$1) {
     break label$1
    }
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAPU8[($3 + 24 | 0) >> 0] | 0 | ((HEAPU8[($3 + 25 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 26 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 27 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[($3 + 28 | 0) >> 0] | 0 | ((HEAPU8[($3 + 29 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 30 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 31 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $50 = i64toi32_i32$0;
    i64toi32_i32$0 = $9;
    $19 = $50;
    HEAP8[i64toi32_i32$0 >> 0] = $19;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $19 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $19 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $19 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$2 = $3 + 48 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $55 = i64toi32_i32$1;
    i64toi32_i32$1 = $9 + 24 | 0;
    $20 = $55;
    HEAP8[i64toi32_i32$1 >> 0] = $20;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $20 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $20 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $20 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$2 = $3 + 40 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $59 = i64toi32_i32$0;
    i64toi32_i32$0 = $10;
    $21 = $59;
    HEAP8[i64toi32_i32$0 >> 0] = $21;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $21 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $21 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $21 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$2 = $3 + 32 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $63 = i64toi32_i32$1;
    i64toi32_i32$1 = $11;
    $22 = $63;
    HEAP8[i64toi32_i32$1 >> 0] = $22;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $22 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $22 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $22 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    memcpy($8 | 0, $3 + 56 | 0 | 0, 64 | 0) | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($2 + 8 | 0 | 0, $3 | 0);
    $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($7 | 0, $3 + 12 | 0 | 0);
    $5 = (memcpy($5 | 0, $2 + 8 | 0 | 0, 120 | 0) | 0) + 120 | 0;
    $1 = $1 + -120 | 0;
    $3 = $3 + 120 | 0;
    $6 = $6 + -1 | 0;
    if ($6) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 8 | 0) >> 2] = $4;
  global$0 = $2 + 128 | 0;
 }
 
 function decrypt_with_password($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $65 = 0, $81 = 0, $87 = 0;
  $5 = global$0 - 80 | 0;
  global$0 = $5;
  HEAP32[($5 + 40 | 0) >> 2] = $2;
  HEAP32[($5 + 36 | 0) >> 2] = $2;
  HEAP32[($5 + 32 | 0) >> 2] = $1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($5 + 24 | 0 | 0, $5 + 32 | 0 | 0);
  $2 = HEAP32[($5 + 28 | 0) >> 2] | 0;
  HEAP32[($5 + 52 | 0) >> 2] = $2;
  $1 = HEAP32[($5 + 24 | 0) >> 2] | 0;
  HEAP32[($5 + 48 | 0) >> 2] = $1;
  HEAP32[($5 + 40 | 0) >> 2] = $4;
  HEAP32[($5 + 36 | 0) >> 2] = $4;
  HEAP32[($5 + 32 | 0) >> 2] = $3;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($5 + 16 | 0 | 0, $5 + 32 | 0 | 0);
  $4 = HEAP32[($5 + 20 | 0) >> 2] | 0;
  HEAP32[($5 + 68 | 0) >> 2] = $4;
  $3 = HEAP32[($5 + 16 | 0) >> 2] | 0;
  HEAP32[($5 + 64 | 0) >> 2] = $3;
  cardano_serialization_lib__emip3__decrypt_with_password__h0f29b0290b85ef37($5 + 32 | 0 | 0, $1 | 0, $2 | 0, $3 | 0, $4 | 0);
  core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_3($5 + 64 | 0 | 0);
  core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_3($5 + 48 | 0 | 0);
  $4 = HEAP32[($5 + 36 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($5 + 32 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($4 | 0);
   abort();
  }
  i64toi32_i32$2 = ($5 + 32 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $65 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[($5 + 52 | 0) >> 2] = $65;
  HEAP32[($5 + 56 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($5 + 48 | 0) >> 2] = $4;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($5 + 8 | 0 | 0, $5 + 48 | 0 | 0);
  HEAP32[(($5 + 64 | 0) + 8 | 0) >> 2] = HEAP32[(($5 + 48 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$1 = HEAP32[($5 + 48 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($5 + 52 | 0) >> 2] | 0;
  $81 = i64toi32_i32$1;
  i64toi32_i32$1 = $5;
  HEAP32[($5 + 64 | 0) >> 2] = $81;
  HEAP32[($5 + 68 | 0) >> 2] = i64toi32_i32$0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($5 | 0, $5 + 64 | 0 | 0);
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = HEAP32[$5 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($5 + 4 | 0) >> 2] | 0;
  $87 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $87;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $5 + 80 | 0;
 }
 
 function cardano_serialization_lib__plutus__ExUnitPrices__from_bytes__hee8eeb87c565067d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $19 = 0, $3$hi = 0, $4$hi = 0, $5$hi = 0, $6$hi = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  HEAP32[(($2 + 136 | 0) + 16 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 136 | 0) >> 2] = 0;
  HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[(i64toi32_i32$0 + 144 | 0) >> 2] = $19;
  HEAP32[(i64toi32_i32$0 + 148 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__plutus__ExUnitPrices_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hb43adfd468752d01(i64toi32_i32$0 + 64 | 0 | 0, i64toi32_i32$0 + 136 | 0 | 0);
  $1 = (i64toi32_i32$0 + 136 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = (i64toi32_i32$0 + 64 | 0) + 8 | 0;
  label$1 : {
   label$2 : {
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 64 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$0 + 68 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    i64toi32_i32$3 = 1;
    if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
     break label$2
    }
    i64toi32_i32$3 = $1 + 24 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $3 = i64toi32_i32$2;
    $3$hi = i64toi32_i32$0;
    i64toi32_i32$2 = $2 + 24 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $3;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$3 = $1 + 16 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $4 = i64toi32_i32$0;
    $4$hi = i64toi32_i32$2;
    i64toi32_i32$0 = $2 + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $4;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$3 = $1 + 8 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $5 = i64toi32_i32$2;
    $5$hi = i64toi32_i32$0;
    i64toi32_i32$2 = $2 + 8 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $5;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$3 = $1;
    i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $6 = i64toi32_i32$0;
    $6$hi = i64toi32_i32$2;
    i64toi32_i32$0 = $2;
    HEAP32[i64toi32_i32$0 >> 2] = $6;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $3$hi;
    i64toi32_i32$0 = $0 + 32 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $3;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $4$hi;
    i64toi32_i32$0 = $0 + 24 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $4;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $5$hi;
    i64toi32_i32$0 = $0 + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $5;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $6$hi;
    i64toi32_i32$0 = $0 + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $6;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    $1 = 0;
    break label$1;
   }
   $1 = memcpy($2 | 0, $1 | 0, 64 | 0) | 0;
   memcpy($1 + 64 | 0 | 0, $1 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($1 + 64 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 160 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__KV___split__h15f5c8143ad0ad96($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $7 = 0, $5 = 0, $4 = 0, $6 = 0, $2 = 0, $3 = 0, $8 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $84 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $4 = HEAPU16[($3 + 138 | 0) >> 1] | 0;
  $5 = alloc__boxed__Box_T_2cA___new_uninit_in__h030094152bc6ae31() | 0;
  HEAP16[($5 + 138 | 0) >> 1] = 0;
  HEAP32[$5 >> 2] = 0;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__hbe6afb4723f1cfdb($2 + 8 | 0 | 0, $1 | 0, $5 | 0);
  $6 = HEAPU16[($5 + 138 | 0) >> 1] | 0;
  $7 = $6 + 1 | 0;
  label$1 : {
   label$2 : {
    if ($6 >>> 0 >= 12 >>> 0) {
     break label$2
    }
    $8 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    $4 = $4 - $8 | 0;
    if (($4 | 0) != ($7 | 0)) {
     break label$1
    }
    memcpy($5 + 448 | 0 | 0, (($8 << 2 | 0) + $3 | 0) + 452 | 0 | 0, $4 << 2 | 0 | 0) | 0;
    $3 = HEAP32[$1 >> 2] | 0;
    $7 = 0;
    label$3 : {
     label$4 : while (1) {
      $4 = HEAP32[(($5 + ($7 << 2 | 0) | 0) + 448 | 0) >> 2] | 0;
      HEAP16[($4 + 136 | 0) >> 1] = $7;
      HEAP32[$4 >> 2] = $5;
      if ($7 >>> 0 >= $6 >>> 0) {
       break label$3
      }
      $7 = $7 + ($7 >>> 0 < $6 >>> 0) | 0;
      if ($7 >>> 0 <= $6 >>> 0) {
       continue label$4
      }
      break label$4;
     };
    }
    i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    memcpy($0 + 8 | 0 | 0, $2 + 8 | 0 | 0, 40 | 0) | 0;
    HEAP32[($0 + 52 | 0) >> 2] = $5;
    HEAP32[($0 + 48 | 0) >> 2] = $3;
    $84 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[$0 >> 2] = $84;
    HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$1;
    global$0 = $2 + 48 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($7 | 0, 12 | 0, 1049060 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1048988 | 0, 40 | 0, 1049028 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__KV___split__h2a00cf835388566b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $7 = 0, $5 = 0, $4 = 0, $6 = 0, $2 = 0, $3 = 0, $8 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $84 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $4 = HEAPU16[($3 + 138 | 0) >> 1] | 0;
  $5 = alloc__boxed__Box_T_2cA___new_uninit_in__h4be0289855654d00() | 0;
  HEAP16[($5 + 138 | 0) >> 1] = 0;
  HEAP32[$5 >> 2] = 0;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__h3e94917fd4a0d3ab($2 + 8 | 0 | 0, $1 | 0, $5 | 0);
  $6 = HEAPU16[($5 + 138 | 0) >> 1] | 0;
  $7 = $6 + 1 | 0;
  label$1 : {
   label$2 : {
    if ($6 >>> 0 >= 12 >>> 0) {
     break label$2
    }
    $8 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    $4 = $4 - $8 | 0;
    if (($4 | 0) != ($7 | 0)) {
     break label$1
    }
    memcpy($5 + 448 | 0 | 0, (($8 << 2 | 0) + $3 | 0) + 452 | 0 | 0, $4 << 2 | 0 | 0) | 0;
    $3 = HEAP32[$1 >> 2] | 0;
    $7 = 0;
    label$3 : {
     label$4 : while (1) {
      $4 = HEAP32[(($5 + ($7 << 2 | 0) | 0) + 448 | 0) >> 2] | 0;
      HEAP16[($4 + 136 | 0) >> 1] = $7;
      HEAP32[$4 >> 2] = $5;
      if ($7 >>> 0 >= $6 >>> 0) {
       break label$3
      }
      $7 = $7 + ($7 >>> 0 < $6 >>> 0) | 0;
      if ($7 >>> 0 <= $6 >>> 0) {
       continue label$4
      }
      break label$4;
     };
    }
    i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    memcpy($0 + 8 | 0 | 0, $2 + 8 | 0 | 0, 40 | 0) | 0;
    HEAP32[($0 + 52 | 0) >> 2] = $5;
    HEAP32[($0 + 48 | 0) >> 2] = $3;
    $84 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[$0 >> 2] = $84;
    HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$1;
    global$0 = $2 + 48 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($7 | 0, 12 | 0, 1049060 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1048988 | 0, 40 | 0, 1049028 | 0);
  abort();
 }
 
 function cardano_serialization_lib__Ipv4__new__h9376141a46d945db($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $3$hi = 0, $4$hi = 0, $2 = 0, $3 = 0, $4 = 0, $17 = 0, $16 = 0, $67 = 0, $67$hi = 0, $70$hi = 0;
  $1 = global$0 - 208 | 0;
  global$0 = $1;
  HEAP32[(($1 + 80 | 0) + 8 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $16 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 80 | 0) >> 2] = $16;
  HEAP32[($1 + 84 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__Ipv4__new_impl__h0051960675f6052f($1 + 8 | 0 | 0, $1 + 80 | 0 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAPU8[($1 + 8 | 0) >> 0] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     $2 = HEAPU8[($1 + 9 | 0) >> 0] | 0 | ((HEAPU8[($1 + 10 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 11 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 12 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $0 = $2 >>> 24 | 0;
     i64toi32_i32$1 = 0;
     $3 = $2 << 8 | 0;
     $3$hi = i64toi32_i32$1;
     i64toi32_i32$1 = 0;
     $4 = 0;
     $4$hi = i64toi32_i32$1;
     break label$2;
    }
    memcpy($1 + 80 | 0 | 0, ($1 + 8 | 0) + 8 | 0 | 0, 64 | 0) | 0;
    i64toi32_i32$1 = 0;
    $3 = 0;
    $3$hi = i64toi32_i32$1;
    i64toi32_i32$0 = $1;
    i64toi32_i32$1 = 0;
    HEAP32[($1 + 148 | 0) >> 2] = 0;
    HEAP32[($1 + 152 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($1 + 144 | 0) >> 2] = HEAP32[(0 + 1050212 | 0) >> 2] | 0;
    core__fmt__Formatter__new__he219faf25326051b($1 + 160 | 0 | 0, $1 + 144 | 0 | 0, 1049880 | 0);
    if ($cardano_serialization_lib__error__DeserializeError_20as_20core__fmt__Display___fmt__h10cc598fcad2b670($1 + 80 | 0 | 0, $1 + 160 | 0 | 0) | 0) {
     break label$1
    }
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($1 | 0, $1 + 144 | 0 | 0);
    $0 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[$1 >> 2] | 0 | 0, HEAP32[($1 + 4 | 0) >> 2] | 0 | 0) | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 + 144 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 + 144 | 0 | 0);
    core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9($1 + 80 | 0 | 0);
    i64toi32_i32$1 = 0;
    $4 = 1;
    $4$hi = i64toi32_i32$1;
   }
   global$0 = $1 + 208 | 0;
   i64toi32_i32$1 = $4$hi;
   i64toi32_i32$1 = $3$hi;
   i64toi32_i32$1 = $4$hi;
   i64toi32_i32$2 = $4;
   i64toi32_i32$0 = $3$hi;
   i64toi32_i32$3 = $3;
   i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
   $67 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
   $67$hi = i64toi32_i32$0;
   i64toi32_i32$0 = 0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$2 = 0;
   i64toi32_i32$3 = 32;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
    $17 = 0;
   } else {
    i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
    $17 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
   }
   $70$hi = i64toi32_i32$2;
   i64toi32_i32$2 = $67$hi;
   i64toi32_i32$0 = $67;
   i64toi32_i32$1 = $70$hi;
   i64toi32_i32$3 = $17;
   i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
   i64toi32_i32$0 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
   i64toi32_i32$HIGH_BITS = i64toi32_i32$1;
   return i64toi32_i32$0 | 0;
  }
  core__result__unwrap_failed__h27f43d993c3864a1(1049904 | 0, 55 | 0, $1 + 200 | 0 | 0, 1050096 | 0, 1050036 | 0);
  abort();
 }
 
 function cardano_serialization_lib__metadata__MetadataList__add__h35547ae43e0f3988($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $25 = 0, $31 = 0;
  $2 = global$0 - 96 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    switch (HEAP32[$1 >> 2] | 0 | 0) {
    default:
     $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__hdeea20968268d729(($2 + 48 | 0) + 8 | 0 | 0, $1 + 8 | 0 | 0);
     HEAP32[($2 + 48 | 0) >> 2] = 0;
     break label$1;
    case 1:
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hf69db734dd831996($2 + 48 | 0 | 4 | 0 | 0, $1 + 4 | 0 | 0);
     HEAP32[($2 + 48 | 0) >> 2] = 1;
     break label$1;
    case 2:
     i64toi32_i32$2 = $1 + 16 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $25 = i64toi32_i32$0;
     i64toi32_i32$0 = ($2 + 48 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $25;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $1 + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $31 = i64toi32_i32$1;
     i64toi32_i32$1 = ($2 + 48 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $31;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($2 + 48 | 0) >> 2] = 2;
     break label$1;
    case 3:
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($2 + 48 | 0 | 4 | 0 | 0, $1 + 4 | 0 | 0);
     HEAP32[($2 + 48 | 0) >> 2] = 3;
     break label$1;
    case 4:
     break label$2;
    };
   }
   $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($2 + 48 | 0 | 4 | 0 | 0, $1 + 4 | 0 | 0);
   HEAP32[($2 + 48 | 0) >> 2] = 4;
  }
  $2 = memcpy($2 | 0, $2 + 48 | 0 | 0, 48 | 0) | 0;
  label$7 : {
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (($1 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
    break label$7
   }
   alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hf0c17c80fd73868c($0 | 0, $1 | 0, 1 | 0);
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  }
  memcpy((HEAP32[$0 >> 2] | 0) + Math_imul($1, 48) | 0 | 0, $2 | 0, 48 | 0) | 0;
  HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
  global$0 = $2 + 96 | 0;
 }
 
 function linked_hash_map__LinkedHashMap_K_2cV_2cS___get__hcef7f07b6e3b104a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $9 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  i64toi32_i32$0 = hashbrown__map__make_hash__hd31a10d6b64a4e5e($0 | 0, $1 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $3 = i64toi32_i32$0;
  $4 = (HEAP32[($0 + 16 | 0) >> 2] | 0) & $3 | 0;
  $9 = (HEAP32[($0 + 20 | 0) >> 2] | 0) + $4 | 0;
  $5 = HEAPU8[$9 >> 0] | 0 | ((HEAPU8[($9 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($9 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($9 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $6 = 0;
  HEAP32[($2 + 32 | 0) >> 2] = 0;
  HEAP32[($2 + 36 | 0) >> 2] = $5;
  HEAP32[($2 + 28 | 0) >> 2] = $4;
  HEAP32[($2 + 24 | 0) >> 2] = $0 + 16 | 0;
  $0 = $3 >>> 25 | 0;
  HEAP8[($2 + 44 | 0) >> 0] = $0;
  $0 = $5 ^ Math_imul($0, 16843009) | 0;
  HEAP32[($2 + 40 | 0) >> 2] = (($0 ^ -1 | 0) & ($0 + -16843009 | 0) | 0) & -2139062144 | 0;
  $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($2 + 16 | 0 | 0, $2 + 24 | 0 | 0);
  label$1 : {
   if (!(HEAP32[($2 + 16 | 0) >> 2] | 0)) {
    break label$1
   }
   label$2 : {
    $0 = (HEAP32[((HEAP32[($2 + 24 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) - ((HEAP32[($2 + 20 | 0) >> 2] | 0) << 3 | 0) | 0;
    if ($cardano_serialization_lib__metadata__TransactionMetadatum_20as_20core__cmp__PartialEq___eq__h3bd33dd828bf70c0($1 | 0, HEAP32[($0 + -8 | 0) >> 2] | 0 | 0) | 0) {
     break label$2
    }
    label$3 : while (1) {
     $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($2 + 8 | 0 | 0, $2 + 24 | 0 | 0);
     if (!(HEAP32[($2 + 8 | 0) >> 2] | 0)) {
      break label$1
     }
     $0 = (HEAP32[((HEAP32[($2 + 24 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) - ((HEAP32[($2 + 12 | 0) >> 2] | 0) << 3 | 0) | 0;
     if (!($cardano_serialization_lib__metadata__TransactionMetadatum_20as_20core__cmp__PartialEq___eq__h3bd33dd828bf70c0($1 | 0, HEAP32[($0 + -8 | 0) >> 2] | 0 | 0) | 0)) {
      continue label$3
     }
     break label$3;
    };
   }
   $6 = (HEAP32[($0 + -4 | 0) >> 2] | 0) + 48 | 0;
  }
  global$0 = $2 + 48 | 0;
  return $6 | 0;
 }
 
 function linked_hash_map__LinkedHashMap_K_2cV_2cS___get__hd0e4323bf75041b1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $9 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  i64toi32_i32$0 = hashbrown__map__make_hash__h23b6f8362e6133c3($0 | 0, $1 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $3 = i64toi32_i32$0;
  $4 = (HEAP32[($0 + 16 | 0) >> 2] | 0) & $3 | 0;
  $9 = (HEAP32[($0 + 20 | 0) >> 2] | 0) + $4 | 0;
  $5 = HEAPU8[$9 >> 0] | 0 | ((HEAPU8[($9 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($9 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($9 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $6 = 0;
  HEAP32[($2 + 32 | 0) >> 2] = 0;
  HEAP32[($2 + 36 | 0) >> 2] = $5;
  HEAP32[($2 + 28 | 0) >> 2] = $4;
  HEAP32[($2 + 24 | 0) >> 2] = $0 + 16 | 0;
  $0 = $3 >>> 25 | 0;
  HEAP8[($2 + 44 | 0) >> 0] = $0;
  $0 = $5 ^ Math_imul($0, 16843009) | 0;
  HEAP32[($2 + 40 | 0) >> 2] = (($0 ^ -1 | 0) & ($0 + -16843009 | 0) | 0) & -2139062144 | 0;
  $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($2 + 16 | 0 | 0, $2 + 24 | 0 | 0);
  label$1 : {
   if (!(HEAP32[($2 + 16 | 0) >> 2] | 0)) {
    break label$1
   }
   label$2 : {
    $0 = (HEAP32[((HEAP32[($2 + 24 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) - ((HEAP32[($2 + 20 | 0) >> 2] | 0) << 3 | 0) | 0;
    if (!(memcmp($1 | 0, HEAP32[($0 + -8 | 0) >> 2] | 0 | 0, 28 | 0) | 0)) {
     break label$2
    }
    label$3 : while (1) {
     $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($2 + 8 | 0 | 0, $2 + 24 | 0 | 0);
     if (!(HEAP32[($2 + 8 | 0) >> 2] | 0)) {
      break label$1
     }
     $0 = (HEAP32[((HEAP32[($2 + 24 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) - ((HEAP32[($2 + 12 | 0) >> 2] | 0) << 3 | 0) | 0;
     if (memcmp($1 | 0, HEAP32[($0 + -8 | 0) >> 2] | 0 | 0, 28 | 0) | 0) {
      continue label$3
     }
     break label$3;
    };
   }
   $6 = HEAP32[($0 + -4 | 0) >> 2] | 0;
  }
  global$0 = $2 + 48 | 0;
  return $6 | 0;
 }
 
 function $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__h44f364b9545b56fe($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $63 = 0, $69 = 0, $72 = 0, $83 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__hf8baa7262b1cd562($2 + 8 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
     if (!$3) {
      break label$3
     }
     $cardano_serialization_lib__plutus__PlutusData_20as_20core__clone__Clone___clone__h63d1a98cc18f4609_2($2 + 32 | 0 | 0, $3 | 0);
     if ((HEAP32[($2 + 32 | 0) >> 2] | 0 | 0) != (5 | 0)) {
      break label$2
     }
    }
    i64toi32_i32$1 = $0;
    i64toi32_i32$0 = 0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = 0;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[i64toi32_i32$1 >> 2] = HEAP32[(0 + 1067624 | 0) >> 2] | 0;
    break label$1;
   }
   $3 = $1 + 24 | 0;
   $4 = HEAP32[$3 >> 2] | 0;
   $5 = $4 + 1 | 0;
   alloc__raw_vec__RawVec_T_2cA___allocate_in__h9244f1b241188454($2 | 0, ($5 >>> 0 < $4 >>> 0 ? -1 : $5) | 0, 0 | 0);
   $4 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $5 = memmove(HEAP32[$2 >> 2] | 0 | 0, $2 + 32 | 0 | 0, 48 | 0) | 0;
   $6 = ($2 + 16 | 0) + 8 | 0;
   HEAP32[$6 >> 2] = 1;
   HEAP32[($2 + 20 | 0) >> 2] = $4;
   HEAP32[($2 + 16 | 0) >> 2] = $5;
   HEAP32[(($2 + 32 | 0) + 24 | 0) >> 2] = HEAP32[$3 >> 2] | 0;
   i64toi32_i32$2 = $1 + 16 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $63 = i64toi32_i32$0;
   i64toi32_i32$0 = ($2 + 32 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $63;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1 + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $69 = i64toi32_i32$1;
   i64toi32_i32$1 = ($2 + 32 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $69;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $1;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $72 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   HEAP32[($2 + 32 | 0) >> 2] = $72;
   HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
   alloc__vec__Vec_T_2cA___extend_desugared__h33bb45fd23d36433($2 + 16 | 0 | 0, $2 + 32 | 0 | 0);
   HEAP32[($0 + 8 | 0) >> 2] = HEAP32[$6 >> 2] | 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   $83 = i64toi32_i32$1;
   i64toi32_i32$1 = $0;
   HEAP32[i64toi32_i32$1 >> 2] = $83;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  }
  global$0 = $2 + 80 | 0;
 }
 
 function $rand_os__wasm32_bindgen__OsRng_20as_20rand_os__OsRngImpl___new__h36d65edbabadd602($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $3 = 0, i64toi32_i32$0 = 0, $4 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $1 = rand_os____wbg_shims__Function__new____wbg_new_3a746f2619705add__h8c98d638ba9d03f8(1100724 | 0, 11 | 0) | 0;
  $2 = rand_os____wbg_shims__Function__call____wbg_call_f54d3a6dadb199ca__h958f935d1097bc3d($1 | 0, 32 | 0) | 0;
  label$1 : {
   if ($1 >>> 0 < 36 >>> 0) {
    break label$1
   }
   wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($1 | 0);
  }
  label$2 : {
   label$3 : {
    label$4 : {
     label$5 : {
      label$6 : {
       if (wasm_bindgen____wbindgen_jsval_eq__h96dce91e58c74d93($2 | 0, 32 | 0) | 0) {
        break label$6
       }
       $1 = rand_os____wbg_shims__This__self_____wbg_self_ac379e780a0d8b94__h86c21d27210df5ab($2 | 0) | 0;
       $3 = wasm_bindgen____wbindgen_jsval_eq__h96dce91e58c74d93($1 | 0, 32 | 0) | 0;
       label$7 : {
        if ($1 >>> 0 < 36 >>> 0) {
         break label$7
        }
        wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($1 | 0);
       }
       label$8 : {
        label$9 : {
         label$10 : {
          if ($3) {
           break label$10
          }
          $1 = rand_os____wbg_shims__This__crypto____wbg_crypto_1e4302b85d4f64a2__h892a87f3db5a36b1($2 | 0) | 0;
          if ((wasm_bindgen____wbindgen_is_undefined__h5ac6d522a5572e68($1 | 0) | 0 | 0) == (1 | 0)) {
           break label$8
          }
          $3 = rand_os____wbg_shims__BrowserCrypto__get_random_values_fn____wbg_getRandomValues_1b4ba144162a5c9e__h16db3aca26429713($1 | 0) | 0;
          $4 = wasm_bindgen____wbindgen_is_undefined__h5ac6d522a5572e68($3 | 0) | 0;
          label$11 : {
           if ($3 >>> 0 < 36 >>> 0) {
            break label$11
           }
           wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($3 | 0);
          }
          if (($4 | 0) == (1 | 0)) {
           break label$9
          }
          i64toi32_i32$0 = 1;
          HEAP32[$0 >> 2] = 0;
          HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$0;
          HEAP32[($0 + 8 | 0) >> 2] = $1;
          if ($2 >>> 0 >= 36 >>> 0) {
           break label$3
          }
          break label$2;
         }
         (wasm2js_i32$0 = $0 + 8 | 0, wasm2js_i32$1 = rand_os____wbg_shims__node_require____wbg_require_6461b1e9a0d7c34a__h9fba9c86ad0dcc55(1100900 | 0, 6 | 0) | 0), HEAP32[wasm2js_i32$0 >> 2] = wasm2js_i32$1;
         i64toi32_i32$0 = 0;
         HEAP32[$0 >> 2] = 0;
         HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$0;
         break label$4;
        }
        rand_core__error__Error__new__h7fdf5b19286dd417($0 + 4 | 0 | 0, 0 | 0, 1100930 | 0, 35 | 0);
        HEAP32[$0 >> 2] = 1;
        if ($1 >>> 0 < 36 >>> 0) {
         break label$4
        }
        break label$5;
       }
       rand_core__error__Error__new__h7fdf5b19286dd417($0 + 4 | 0 | 0, 0 | 0, 1100906 | 0, 24 | 0);
       HEAP32[$0 >> 2] = 1;
       if ($1 >>> 0 < 36 >>> 0) {
        break label$4
       }
       break label$5;
      }
      core__panicking__panic__h2fd385a887c8bf13(1100735 | 0, 46 | 0, 1100884 | 0);
      abort();
     }
     wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($1 | 0);
    }
    if ($2 >>> 0 < 36 >>> 0) {
     break label$2
    }
   }
   wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($2 | 0);
  }
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__h8ad292a0ec5f3382($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    $0 = HEAP32[$0 >> 2] | 0;
    if ((HEAPU8[$0 >> 0] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = FUNCTION_TABLE[HEAP32[((HEAP32[($1 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($1 + 24 | 0) >> 2] | 0, 1153251, 4) | 0;
    break label$1;
   }
   (wasm2js_i32$0 = $2, wasm2js_i32$1 = FUNCTION_TABLE[HEAP32[((HEAP32[($1 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($1 + 24 | 0) >> 2] | 0, 1153247, 4) | 0), HEAP8[(wasm2js_i32$0 + 8 | 0) >> 0] = wasm2js_i32$1;
   HEAP32[$2 >> 2] = $1;
   HEAP8[($2 + 9 | 0) >> 0] = 0;
   HEAP32[($2 + 4 | 0) >> 2] = 0;
   HEAP32[($2 + 12 | 0) >> 2] = $0 + 1 | 0;
   core__fmt__builders__DebugTuple__field__h5e7e3e19ad5aa557($2 | 0, $2 + 12 | 0 | 0, 1149904 | 0) | 0;
   $1 = HEAPU8[($2 + 8 | 0) >> 0] | 0;
   label$3 : {
    $3 = HEAP32[($2 + 4 | 0) >> 2] | 0;
    if (!$3) {
     break label$3
    }
    $0 = $1 & 255 | 0;
    $1 = 1;
    if ($0) {
     break label$3
    }
    label$4 : {
     if (($3 | 0) != (1 | 0)) {
      break label$4
     }
     if (!((HEAPU8[($2 + 9 | 0) >> 0] | 0) & 255 | 0)) {
      break label$4
     }
     $0 = HEAP32[$2 >> 2] | 0;
     if ((HEAPU8[$0 >> 0] | 0) & 4 | 0) {
      break label$4
     }
     $1 = 1;
     if (FUNCTION_TABLE[HEAP32[((HEAP32[($0 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($0 + 24 | 0) >> 2] | 0, 1149896, 1) | 0) {
      break label$3
     }
    }
    $1 = HEAP32[$2 >> 2] | 0;
    $1 = FUNCTION_TABLE[HEAP32[((HEAP32[($1 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($1 + 24 | 0) >> 2] | 0, 1149897, 1) | 0;
   }
   $1 = ($1 & 255 | 0 | 0) != (0 | 0);
  }
  global$0 = $2 + 16 | 0;
  return $1 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__h103237ba0f156f09($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $7 = 0, $4 = 0, $6 = 0, $17 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $5 = 0, $36 = 0, $41 = 0, $45 = 0, $69 = 0, $74 = 0, $79 = 0;
  $3 = global$0 - 32 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = HEAPU16[($4 + 6 | 0) >> 1] | 0;
  $6 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $7 = $5 + ($6 ^ -1 | 0) | 0;
  HEAP16[($2 + 6 | 0) >> 1] = $7;
  $1 = $4 + Math_imul($6, 28) | 0;
  $17 = $1 + 32 | 0;
  HEAP32[($3 + 24 | 0) >> 2] = HEAPU8[$17 >> 0] | 0 | ((HEAPU8[($17 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($17 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($17 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $1 + 24 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $36 = i64toi32_i32$0;
  i64toi32_i32$0 = $3 + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $36;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $41 = i64toi32_i32$1;
  i64toi32_i32$1 = $3 + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $41;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $45 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $45;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    if ($7 >>> 0 >= 12 >>> 0) {
     break label$2
    }
    $1 = $6 + 1 | 0;
    if (($5 - $1 | 0 | 0) != ($7 | 0)) {
     break label$1
    }
    memcpy($2 + 8 | 0 | 0, ($4 + Math_imul($1, 28) | 0) + 8 | 0 | 0, Math_imul($7, 28) | 0) | 0;
    HEAP16[($4 + 6 | 0) >> 1] = $6;
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $69 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    $18 = $69;
    HEAP8[i64toi32_i32$1 >> 0] = $18;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $18 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $18 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $18 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $74 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 8 | 0;
    $19 = $74;
    HEAP8[i64toi32_i32$0 >> 0] = $19;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $19 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $19 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $19 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$2 = $3 + 16 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $79 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 16 | 0;
    $20 = $79;
    HEAP8[i64toi32_i32$1 >> 0] = $20;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $20 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $20 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $20 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    $21 = $0 + 24 | 0;
    $22 = HEAP32[($3 + 24 | 0) >> 2] | 0;
    HEAP8[$21 >> 0] = $22;
    HEAP8[($21 + 1 | 0) >> 0] = $22 >>> 8 | 0;
    HEAP8[($21 + 2 | 0) >> 0] = $22 >>> 16 | 0;
    HEAP8[($21 + 3 | 0) >> 0] = $22 >>> 24 | 0;
    global$0 = $3 + 32 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($7 | 0, 11 | 0, 1049044 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1048988 | 0, 40 | 0, 1049028 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__h472347de6838beb9($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $4 = 0, $7 = 0, $5 = 0, $6 = 0, $3 = 0, $37 = 0, $8 = 0, $8$hi = 0, $9 = 0, $9$hi = 0, $83 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = HEAPU16[($4 + 314 | 0) >> 1] | 0;
  $6 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $1 = $5 + ($6 ^ -1 | 0) | 0;
  HEAP16[($2 + 314 | 0) >> 1] = $1;
  $7 = $4 + Math_imul($6, 12) | 0;
  HEAP32[($3 + 8 | 0) >> 2] = HEAP32[($7 + 188 | 0) >> 2] | 0;
  i64toi32_i32$2 = $7 + 180 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $37 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $37;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    if ($1 >>> 0 >= 12 >>> 0) {
     break label$2
    }
    $7 = $6 + 1 | 0;
    if (($5 - $7 | 0 | 0) != ($1 | 0)) {
     break label$1
    }
    $5 = $4 + ($6 << 4 | 0) | 0;
    i64toi32_i32$2 = $5 + 8 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $8 = i64toi32_i32$1;
    $8$hi = i64toi32_i32$0;
    i64toi32_i32$2 = $5;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $9 = i64toi32_i32$0;
    $9$hi = i64toi32_i32$1;
    memcpy($2 + 180 | 0 | 0, ($4 + Math_imul($7, 12) | 0) + 180 | 0 | 0, Math_imul($1, 12) | 0) | 0;
    memcpy($2 | 0, $4 + ($7 << 4 | 0) | 0 | 0, $1 << 4 | 0 | 0) | 0;
    i64toi32_i32$1 = $8$hi;
    i64toi32_i32$0 = $0 + 24 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $8;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $9$hi;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $9;
    HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$1;
    HEAP16[($4 + 314 | 0) >> 1] = $6;
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $83 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[i64toi32_i32$1 >> 2] = $83;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
    global$0 = i64toi32_i32$2 + 16 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($1 | 0, 11 | 0, 1049044 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1048988 | 0, 40 | 0, 1049028 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__h70a172de854ccbbf($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $4 = 0, $7 = 0, $5 = 0, $6 = 0, $3 = 0, $37 = 0, $8 = 0, $8$hi = 0, $9 = 0, $9$hi = 0, $83 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = HEAPU16[($4 + 314 | 0) >> 1] | 0;
  $6 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $1 = $5 + ($6 ^ -1 | 0) | 0;
  HEAP16[($2 + 314 | 0) >> 1] = $1;
  $7 = $4 + Math_imul($6, 12) | 0;
  HEAP32[($3 + 8 | 0) >> 2] = HEAP32[($7 + 188 | 0) >> 2] | 0;
  i64toi32_i32$2 = $7 + 180 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $37 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $37;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    if ($1 >>> 0 >= 12 >>> 0) {
     break label$2
    }
    $7 = $6 + 1 | 0;
    if (($5 - $7 | 0 | 0) != ($1 | 0)) {
     break label$1
    }
    $5 = $4 + ($6 << 4 | 0) | 0;
    i64toi32_i32$2 = $5 + 8 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $8 = i64toi32_i32$1;
    $8$hi = i64toi32_i32$0;
    i64toi32_i32$2 = $5;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $9 = i64toi32_i32$0;
    $9$hi = i64toi32_i32$1;
    memcpy($2 + 180 | 0 | 0, ($4 + Math_imul($7, 12) | 0) + 180 | 0 | 0, Math_imul($1, 12) | 0) | 0;
    memcpy($2 | 0, $4 + ($7 << 4 | 0) | 0 | 0, $1 << 4 | 0 | 0) | 0;
    i64toi32_i32$1 = $8$hi;
    i64toi32_i32$0 = $0 + 24 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $8;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $9$hi;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $9;
    HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$1;
    HEAP16[($4 + 314 | 0) >> 1] = $6;
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $83 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[i64toi32_i32$1 >> 2] = $83;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
    global$0 = i64toi32_i32$2 + 16 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($1 | 0, 11 | 0, 1049044 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1048988 | 0, 40 | 0, 1049028 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__h85dcc5ded7d0d8e9($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $7 = 0, $4 = 0, $6 = 0, $17 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $5 = 0, $36 = 0, $41 = 0, $45 = 0, $69 = 0, $74 = 0, $79 = 0;
  $3 = global$0 - 32 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = HEAPU16[($4 + 6 | 0) >> 1] | 0;
  $6 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $7 = $5 + ($6 ^ -1 | 0) | 0;
  HEAP16[($2 + 6 | 0) >> 1] = $7;
  $1 = $4 + Math_imul($6, 28) | 0;
  $17 = $1 + 32 | 0;
  HEAP32[($3 + 24 | 0) >> 2] = HEAPU8[$17 >> 0] | 0 | ((HEAPU8[($17 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($17 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($17 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $1 + 24 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $36 = i64toi32_i32$0;
  i64toi32_i32$0 = $3 + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $36;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $41 = i64toi32_i32$1;
  i64toi32_i32$1 = $3 + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $41;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $45 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $45;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    if ($7 >>> 0 >= 12 >>> 0) {
     break label$2
    }
    $1 = $6 + 1 | 0;
    if (($5 - $1 | 0 | 0) != ($7 | 0)) {
     break label$1
    }
    memcpy($2 + 8 | 0 | 0, ($4 + Math_imul($1, 28) | 0) + 8 | 0 | 0, Math_imul($7, 28) | 0) | 0;
    HEAP16[($4 + 6 | 0) >> 1] = $6;
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $69 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    $18 = $69;
    HEAP8[i64toi32_i32$1 >> 0] = $18;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $18 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $18 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $18 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $74 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 8 | 0;
    $19 = $74;
    HEAP8[i64toi32_i32$0 >> 0] = $19;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $19 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $19 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $19 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$2 = $3 + 16 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $79 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 16 | 0;
    $20 = $79;
    HEAP8[i64toi32_i32$1 >> 0] = $20;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $20 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $20 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $20 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    $21 = $0 + 24 | 0;
    $22 = HEAP32[($3 + 24 | 0) >> 2] | 0;
    HEAP8[$21 >> 0] = $22;
    HEAP8[($21 + 1 | 0) >> 0] = $22 >>> 8 | 0;
    HEAP8[($21 + 2 | 0) >> 0] = $22 >>> 16 | 0;
    HEAP8[($21 + 3 | 0) >> 0] = $22 >>> 24 | 0;
    global$0 = $3 + 32 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($7 | 0, 11 | 0, 1049044 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1048988 | 0, 40 | 0, 1049028 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__KV___split__hc11226674436e4b6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $7 = 0, i64toi32_i32$1 = 0, $5 = 0, $4 = 0, $2 = 0, $6 = 0, i64toi32_i32$0 = 0, $3 = 0, $8 = 0, $10 = 0, $10$hi = 0, $9 = 0, $81 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $4 = HEAPU16[($3 + 138 | 0) >> 1] | 0;
  $5 = alloc__boxed__Box_T_2cA___new_uninit_in__h7bc2e41a812e1158() | 0;
  HEAP16[($5 + 138 | 0) >> 1] = 0;
  HEAP32[($5 + 88 | 0) >> 2] = 0;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__h6b63004c30a73b30($2 | 0, $1 | 0, $5 | 0);
  $6 = HEAPU16[($5 + 138 | 0) >> 1] | 0;
  $7 = $6 + 1 | 0;
  label$1 : {
   label$2 : {
    if ($6 >>> 0 >= 12 >>> 0) {
     break label$2
    }
    $8 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    $4 = $4 - $8 | 0;
    if (($4 | 0) != ($7 | 0)) {
     break label$1
    }
    i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $10 = i64toi32_i32$0;
    $10$hi = i64toi32_i32$1;
    $9 = HEAP32[$2 >> 2] | 0;
    memcpy($5 + 144 | 0 | 0, (($8 << 2 | 0) + $3 | 0) + 148 | 0 | 0, $4 << 2 | 0 | 0) | 0;
    $3 = HEAP32[$1 >> 2] | 0;
    $7 = 0;
    label$3 : {
     label$4 : while (1) {
      $4 = HEAP32[(($5 + ($7 << 2 | 0) | 0) + 144 | 0) >> 2] | 0;
      HEAP16[($4 + 136 | 0) >> 1] = $7;
      HEAP32[($4 + 88 | 0) >> 2] = $5;
      if ($7 >>> 0 >= $6 >>> 0) {
       break label$3
      }
      $7 = $7 + ($7 >>> 0 < $6 >>> 0) | 0;
      if ($7 >>> 0 <= $6 >>> 0) {
       continue label$4
      }
      break label$4;
     };
    }
    HEAP32[($0 + 24 | 0) >> 2] = $3;
    HEAP32[$0 >> 2] = $9;
    i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $81 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $81;
    HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = $5;
    i64toi32_i32$0 = $10$hi;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $10;
    HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
    global$0 = $2 + 16 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($7 | 0, 12 | 0, 1049060 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1048988 | 0, 40 | 0, 1049028 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__KV___split__hf664e68985110f8b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $7 = 0, $5 = 0, $4 = 0, $2 = 0, $6 = 0, $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $8 = 0, $71 = 0, $76 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $4 = HEAPU16[($3 + 138 | 0) >> 1] | 0;
  $5 = alloc__boxed__Box_T_2cA___new_uninit_in__he0c425f8ad462f5a() | 0;
  HEAP16[($5 + 138 | 0) >> 1] = 0;
  HEAP32[$5 >> 2] = 0;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__h825ff1a7b9ded94b($2 | 0, $1 | 0, $5 | 0);
  $6 = HEAPU16[($5 + 138 | 0) >> 1] | 0;
  $7 = $6 + 1 | 0;
  label$1 : {
   label$2 : {
    if ($6 >>> 0 >= 12 >>> 0) {
     break label$2
    }
    $8 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    $4 = $4 - $8 | 0;
    if (($4 | 0) != ($7 | 0)) {
     break label$1
    }
    memcpy($5 + 140 | 0 | 0, (($8 << 2 | 0) + $3 | 0) + 144 | 0 | 0, $4 << 2 | 0 | 0) | 0;
    $3 = HEAP32[$1 >> 2] | 0;
    $7 = 0;
    label$3 : {
     label$4 : while (1) {
      $4 = HEAP32[(($5 + ($7 << 2 | 0) | 0) + 140 | 0) >> 2] | 0;
      HEAP16[($4 + 136 | 0) >> 1] = $7;
      HEAP32[$4 >> 2] = $5;
      if ($7 >>> 0 >= $6 >>> 0) {
       break label$3
      }
      $7 = $7 + ($7 >>> 0 < $6 >>> 0) | 0;
      if ($7 >>> 0 <= $6 >>> 0) {
       continue label$4
      }
      break label$4;
     };
    }
    i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
    $71 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[($0 + 8 | 0) >> 2] = $71;
    HEAP32[($0 + 12 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($0 + 20 | 0) >> 2] = $3;
    i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $76 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[$0 >> 2] = $76;
    HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($0 + 24 | 0) >> 2] = $5;
    HEAP32[($0 + 16 | 0) >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
    global$0 = $2 + 16 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($7 | 0, 12 | 0, 1049060 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1048988 | 0, 40 | 0, 1049028 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__KV___split__hf7ac7d2b027c0d7d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $7 = 0, $5 = 0, $4 = 0, $2 = 0, $6 = 0, $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $8 = 0, $71 = 0, $76 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $4 = HEAPU16[($3 + 138 | 0) >> 1] | 0;
  $5 = alloc__boxed__Box_T_2cA___new_uninit_in__hbee8ec47f689ab87() | 0;
  HEAP16[($5 + 138 | 0) >> 1] = 0;
  HEAP32[$5 >> 2] = 0;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__h548407c65b84dfc0($2 | 0, $1 | 0, $5 | 0);
  $6 = HEAPU16[($5 + 138 | 0) >> 1] | 0;
  $7 = $6 + 1 | 0;
  label$1 : {
   label$2 : {
    if ($6 >>> 0 >= 12 >>> 0) {
     break label$2
    }
    $8 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    $4 = $4 - $8 | 0;
    if (($4 | 0) != ($7 | 0)) {
     break label$1
    }
    memcpy($5 + 140 | 0 | 0, (($8 << 2 | 0) + $3 | 0) + 144 | 0 | 0, $4 << 2 | 0 | 0) | 0;
    $3 = HEAP32[$1 >> 2] | 0;
    $7 = 0;
    label$3 : {
     label$4 : while (1) {
      $4 = HEAP32[(($5 + ($7 << 2 | 0) | 0) + 140 | 0) >> 2] | 0;
      HEAP16[($4 + 136 | 0) >> 1] = $7;
      HEAP32[$4 >> 2] = $5;
      if ($7 >>> 0 >= $6 >>> 0) {
       break label$3
      }
      $7 = $7 + ($7 >>> 0 < $6 >>> 0) | 0;
      if ($7 >>> 0 <= $6 >>> 0) {
       continue label$4
      }
      break label$4;
     };
    }
    i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
    $71 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[($0 + 8 | 0) >> 2] = $71;
    HEAP32[($0 + 12 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($0 + 20 | 0) >> 2] = $3;
    i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $76 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[$0 >> 2] = $76;
    HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($0 + 24 | 0) >> 2] = $5;
    HEAP32[($0 + 16 | 0) >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
    global$0 = $2 + 16 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($7 | 0, 12 | 0, 1049060 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1048988 | 0, 40 | 0, 1049028 | 0);
  abort();
 }
 
 function cardano_serialization_lib__URL__new__h867b042f776d8c04($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $14 = 0, $24 = 0;
  $2 = global$0 - 208 | 0;
  global$0 = $2;
  HEAP32[(($2 + 80 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 80 | 0) >> 2] = $14;
  HEAP32[($2 + 84 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__URL__new_impl__h2bef2f0e9022dd28($2 + 8 | 0 | 0, $2 + 80 | 0 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
     $24 = i64toi32_i32$1;
     i64toi32_i32$1 = $0;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $24;
     HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 12 | 0) >> 2] | 0;
     $1 = 0;
     break label$2;
    }
    memcpy($2 + 80 | 0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 64 | 0) | 0;
    i64toi32_i32$1 = $2;
    i64toi32_i32$0 = 0;
    HEAP32[($2 + 148 | 0) >> 2] = 0;
    HEAP32[($2 + 152 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($2 + 144 | 0) >> 2] = HEAP32[(0 + 1050212 | 0) >> 2] | 0;
    core__fmt__Formatter__new__he219faf25326051b($2 + 160 | 0 | 0, $2 + 144 | 0 | 0, 1049880 | 0);
    if ($cardano_serialization_lib__error__DeserializeError_20as_20core__fmt__Display___fmt__h10cc598fcad2b670($2 + 80 | 0 | 0, $2 + 160 | 0 | 0) | 0) {
     break label$1
    }
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 | 0, $2 + 144 | 0 | 0);
    $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0) | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 144 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 144 | 0 | 0);
    core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9($2 + 80 | 0 | 0);
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    $1 = 1;
   }
   HEAP32[$0 >> 2] = $1;
   global$0 = $2 + 208 | 0;
   return;
  }
  core__result__unwrap_failed__h27f43d993c3864a1(1049904 | 0, 55 | 0, $2 + 200 | 0 | 0, 1050096 | 0, 1050036 | 0);
  abort();
 }
 
 function cardano_serialization_lib__DNSRecordAorAAAA__new__h2919837710f98b90($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $14 = 0, $24 = 0;
  $2 = global$0 - 208 | 0;
  global$0 = $2;
  HEAP32[(($2 + 80 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 80 | 0) >> 2] = $14;
  HEAP32[($2 + 84 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__DNSRecordAorAAAA__new_impl__he2de007c7a72649a($2 + 8 | 0 | 0, $2 + 80 | 0 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
     $24 = i64toi32_i32$1;
     i64toi32_i32$1 = $0;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $24;
     HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 12 | 0) >> 2] | 0;
     $1 = 0;
     break label$2;
    }
    memcpy($2 + 80 | 0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 64 | 0) | 0;
    i64toi32_i32$1 = $2;
    i64toi32_i32$0 = 0;
    HEAP32[($2 + 148 | 0) >> 2] = 0;
    HEAP32[($2 + 152 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($2 + 144 | 0) >> 2] = HEAP32[(0 + 1050212 | 0) >> 2] | 0;
    core__fmt__Formatter__new__he219faf25326051b($2 + 160 | 0 | 0, $2 + 144 | 0 | 0, 1049880 | 0);
    if ($cardano_serialization_lib__error__DeserializeError_20as_20core__fmt__Display___fmt__h10cc598fcad2b670($2 + 80 | 0 | 0, $2 + 160 | 0 | 0) | 0) {
     break label$1
    }
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 | 0, $2 + 144 | 0 | 0);
    $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0) | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 144 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 144 | 0 | 0);
    core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9($2 + 80 | 0 | 0);
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    $1 = 1;
   }
   HEAP32[$0 >> 2] = $1;
   global$0 = $2 + 208 | 0;
   return;
  }
  core__result__unwrap_failed__h27f43d993c3864a1(1049904 | 0, 55 | 0, $2 + 200 | 0 | 0, 1050096 | 0, 1050036 | 0);
  abort();
 }
 
 function cardano_serialization_lib__DNSRecordSRV__new__hb0cd799022912491($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $14 = 0, $24 = 0;
  $2 = global$0 - 208 | 0;
  global$0 = $2;
  HEAP32[(($2 + 80 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 80 | 0) >> 2] = $14;
  HEAP32[($2 + 84 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__DNSRecordSRV__new_impl__h390c8355efc834ca($2 + 8 | 0 | 0, $2 + 80 | 0 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
     $24 = i64toi32_i32$1;
     i64toi32_i32$1 = $0;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $24;
     HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 12 | 0) >> 2] | 0;
     $1 = 0;
     break label$2;
    }
    memcpy($2 + 80 | 0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 64 | 0) | 0;
    i64toi32_i32$1 = $2;
    i64toi32_i32$0 = 0;
    HEAP32[($2 + 148 | 0) >> 2] = 0;
    HEAP32[($2 + 152 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($2 + 144 | 0) >> 2] = HEAP32[(0 + 1050212 | 0) >> 2] | 0;
    core__fmt__Formatter__new__he219faf25326051b($2 + 160 | 0 | 0, $2 + 144 | 0 | 0, 1049880 | 0);
    if ($cardano_serialization_lib__error__DeserializeError_20as_20core__fmt__Display___fmt__h10cc598fcad2b670($2 + 80 | 0 | 0, $2 + 160 | 0 | 0) | 0) {
     break label$1
    }
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 | 0, $2 + 144 | 0 | 0);
    $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0) | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 144 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 144 | 0 | 0);
    core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9($2 + 80 | 0 | 0);
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    $1 = 1;
   }
   HEAP32[$0 >> 2] = $1;
   global$0 = $2 + 208 | 0;
   return;
  }
  core__result__unwrap_failed__h27f43d993c3864a1(1049904 | 0, 55 | 0, $2 + 200 | 0 | 0, 1050096 | 0, 1050036 | 0);
  abort();
 }
 
 function cardano_serialization_lib__AssetName__new__h3701d918fcb1bec2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $14 = 0, $24 = 0;
  $2 = global$0 - 208 | 0;
  global$0 = $2;
  HEAP32[(($2 + 80 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 80 | 0) >> 2] = $14;
  HEAP32[($2 + 84 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__AssetName__new_impl__h47344992a9d6e8cb($2 + 8 | 0 | 0, $2 + 80 | 0 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
     $24 = i64toi32_i32$1;
     i64toi32_i32$1 = $0;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $24;
     HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 12 | 0) >> 2] | 0;
     $1 = 0;
     break label$2;
    }
    memcpy($2 + 80 | 0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 64 | 0) | 0;
    i64toi32_i32$1 = $2;
    i64toi32_i32$0 = 0;
    HEAP32[($2 + 148 | 0) >> 2] = 0;
    HEAP32[($2 + 152 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($2 + 144 | 0) >> 2] = HEAP32[(0 + 1050212 | 0) >> 2] | 0;
    core__fmt__Formatter__new__he219faf25326051b($2 + 160 | 0 | 0, $2 + 144 | 0 | 0, 1049880 | 0);
    if ($cardano_serialization_lib__error__DeserializeError_20as_20core__fmt__Display___fmt__h10cc598fcad2b670($2 + 80 | 0 | 0, $2 + 160 | 0 | 0) | 0) {
     break label$1
    }
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 | 0, $2 + 144 | 0 | 0);
    $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0) | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 144 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 144 | 0 | 0);
    core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9($2 + 80 | 0 | 0);
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    $1 = 1;
   }
   HEAP32[$0 >> 2] = $1;
   global$0 = $2 + 208 | 0;
   return;
  }
  core__result__unwrap_failed__h27f43d993c3864a1(1049904 | 0, 55 | 0, $2 + 200 | 0 | 0, 1050096 | 0, 1050036 | 0);
  abort();
 }
 
 function $cardano_serialization_lib__legacy_address__address__AddrType_20as_20cbor_event__de__Deserialize___deserialize__ha7e97c2a9bcfdf6c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$0 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $20 = 0, $3 = 0, $3$hi = 0, $32 = 0, $38 = 0, $43 = 0, $49 = 0, $54 = 0, $59 = 0, $64 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___unsigned_integer__h1ed99c0b7fe7eea1($2 | 0, $1 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $3 = i64toi32_i32$0;
  $3$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$1 = 0;
     i64toi32_i32$3 = 1;
     if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
      break label$3
     }
     i64toi32_i32$2 = $3$hi;
     i64toi32_i32$3 = $3;
     i64toi32_i32$0 = 0;
     i64toi32_i32$1 = 3;
     if (i64toi32_i32$2 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0 | 0) | 0) {
      break label$2
     }
     HEAP32[($2 + 20 | 0) >> 2] = 0;
     HEAP32[($2 + 16 | 0) >> 2] = 1072484;
     i64toi32_i32$2 = $2;
     i64toi32_i32$3 = 0;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = 1;
     HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = i64toi32_i32$3;
     HEAP32[i64toi32_i32$2 >> 2] = 1072500;
     alloc__fmt__format__h6e9e003a52c07309(i64toi32_i32$2 + 64 | 0 | 0, i64toi32_i32$2 | 0);
     $16 = i64toi32_i32$2 + 60 | 0;
     $17 = HEAP32[((i64toi32_i32$2 + 64 | 0) + 8 | 0) >> 2] | 0;
     HEAP8[$16 >> 0] = $17;
     HEAP8[($16 + 1 | 0) >> 0] = $17 >>> 8 | 0;
     HEAP8[($16 + 2 | 0) >> 0] = $17 >>> 16 | 0;
     HEAP8[($16 + 3 | 0) >> 0] = $17 >>> 24 | 0;
     i64toi32_i32$1 = i64toi32_i32$2;
     i64toi32_i32$3 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
     $32 = i64toi32_i32$3;
     i64toi32_i32$3 = i64toi32_i32$1;
     $18 = $32;
     HEAP8[(i64toi32_i32$3 + 52 | 0) >> 0] = $18;
     HEAP8[(i64toi32_i32$3 + 53 | 0) >> 0] = $18 >>> 8 | 0;
     HEAP8[(i64toi32_i32$3 + 54 | 0) >> 0] = $18 >>> 16 | 0;
     HEAP8[(i64toi32_i32$3 + 55 | 0) >> 0] = $18 >>> 24 | 0;
     HEAP8[(i64toi32_i32$3 + 56 | 0) >> 0] = i64toi32_i32$2;
     HEAP8[(i64toi32_i32$3 + 57 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
     HEAP8[(i64toi32_i32$3 + 58 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
     HEAP8[(i64toi32_i32$3 + 59 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
     HEAP8[($0 + 8 | 0) >> 0] = 18;
     i64toi32_i32$1 = i64toi32_i32$3;
     i64toi32_i32$2 = HEAPU8[(i64toi32_i32$3 + 49 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 50 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 51 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 52 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$3 = HEAPU8[(i64toi32_i32$3 + 53 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$3 + 54 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$3 + 55 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$3 + 56 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $38 = i64toi32_i32$2;
     i64toi32_i32$2 = $0 + 9 | 0;
     $19 = $38;
     HEAP8[i64toi32_i32$2 >> 0] = $19;
     HEAP8[(i64toi32_i32$2 + 1 | 0) >> 0] = $19 >>> 8 | 0;
     HEAP8[(i64toi32_i32$2 + 2 | 0) >> 0] = $19 >>> 16 | 0;
     HEAP8[(i64toi32_i32$2 + 3 | 0) >> 0] = $19 >>> 24 | 0;
     HEAP8[(i64toi32_i32$2 + 4 | 0) >> 0] = i64toi32_i32$3;
     HEAP8[(i64toi32_i32$2 + 5 | 0) >> 0] = i64toi32_i32$3 >>> 8 | 0;
     HEAP8[(i64toi32_i32$2 + 6 | 0) >> 0] = i64toi32_i32$3 >>> 16 | 0;
     HEAP8[(i64toi32_i32$2 + 7 | 0) >> 0] = i64toi32_i32$3 >>> 24 | 0;
     i64toi32_i32$1 = i64toi32_i32$1 + 56 | 0;
     i64toi32_i32$3 = HEAPU8[i64toi32_i32$1 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$2 = HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $43 = i64toi32_i32$3;
     i64toi32_i32$3 = $0 + 16 | 0;
     $20 = $43;
     HEAP8[i64toi32_i32$3 >> 0] = $20;
     HEAP8[(i64toi32_i32$3 + 1 | 0) >> 0] = $20 >>> 8 | 0;
     HEAP8[(i64toi32_i32$3 + 2 | 0) >> 0] = $20 >>> 16 | 0;
     HEAP8[(i64toi32_i32$3 + 3 | 0) >> 0] = $20 >>> 24 | 0;
     HEAP8[(i64toi32_i32$3 + 4 | 0) >> 0] = i64toi32_i32$2;
     HEAP8[(i64toi32_i32$3 + 5 | 0) >> 0] = i64toi32_i32$2 >>> 8 | 0;
     HEAP8[(i64toi32_i32$3 + 6 | 0) >> 0] = i64toi32_i32$2 >>> 16 | 0;
     HEAP8[(i64toi32_i32$3 + 7 | 0) >> 0] = i64toi32_i32$2 >>> 24 | 0;
     HEAP8[$0 >> 0] = 1;
     break label$1;
    }
    i64toi32_i32$1 = $2 + 40 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
    $49 = i64toi32_i32$2;
    i64toi32_i32$2 = $0 + 40 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $49;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
    i64toi32_i32$1 = $2 + 32 | 0;
    i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
    $54 = i64toi32_i32$3;
    i64toi32_i32$3 = $0 + 32 | 0;
    HEAP32[i64toi32_i32$3 >> 2] = $54;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$1 = $2 + 24 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
    $59 = i64toi32_i32$2;
    i64toi32_i32$2 = $0 + 24 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $59;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
    i64toi32_i32$1 = $2 + 16 | 0;
    i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
    $64 = i64toi32_i32$3;
    i64toi32_i32$3 = $0 + 16 | 0;
    HEAP32[i64toi32_i32$3 >> 2] = $64;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
    HEAP8[$0 >> 0] = 1;
    i64toi32_i32$2 = $3$hi;
    i64toi32_i32$3 = $0 + 8 | 0;
    HEAP32[i64toi32_i32$3 >> 2] = $3;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
    break label$1;
   }
   HEAP8[$0 >> 0] = 0;
   i64toi32_i32$2 = $3$hi;
   HEAP8[($0 + 1 | 0) >> 0] = $3;
  }
  global$0 = $2 + 80 | 0;
 }
 
 function $rand_core__error__Error_20as_20core__fmt__Display___fmt__hdeea39097fd9db57($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $31 = 0, $59 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if (!(HEAP32[($0 + 8 | 0) >> 2] | 0)) {
     break label$2
    }
    HEAP32[($2 + 20 | 0) >> 2] = $0 + 8 | 0;
    rand_core__error__ErrorKind__description__h7d0a332cec477be2($2 + 8 | 0 | 0, HEAPU8[($0 + 16 | 0) >> 0] | 0 | 0);
    HEAP32[(($2 + 48 | 0) + 20 | 0) >> 2] = 218;
    HEAP32[($2 + 60 | 0) >> 2] = 219;
    HEAP32[(($2 + 24 | 0) + 20 | 0) >> 2] = 3;
    HEAP32[($2 + 52 | 0) >> 2] = 219;
    HEAP32[($2 + 48 | 0) >> 2] = $0;
    i64toi32_i32$1 = $2;
    i64toi32_i32$0 = 0;
    HEAP32[($2 + 28 | 0) >> 2] = 3;
    HEAP32[($2 + 32 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($2 + 24 | 0) >> 2] = 1101228;
    i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $31 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[($2 + 72 | 0) >> 2] = $31;
    HEAP32[($2 + 76 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($2 + 64 | 0) >> 2] = $2 + 20 | 0;
    HEAP32[($2 + 56 | 0) >> 2] = $2 + 72 | 0;
    HEAP32[($2 + 40 | 0) >> 2] = $2 + 48 | 0;
    $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 24 | 0 | 0) | 0;
    break label$1;
   }
   rand_core__error__ErrorKind__description__h7d0a332cec477be2($2 | 0, HEAPU8[($0 + 16 | 0) >> 0] | 0 | 0);
   HEAP32[($2 + 36 | 0) >> 2] = 219;
   HEAP32[($2 + 68 | 0) >> 2] = 2;
   HEAP32[($2 + 28 | 0) >> 2] = 219;
   HEAP32[($2 + 24 | 0) >> 2] = $0;
   i64toi32_i32$0 = $2;
   i64toi32_i32$1 = 0;
   HEAP32[($2 + 52 | 0) >> 2] = 3;
   HEAP32[($2 + 56 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($2 + 48 | 0) >> 2] = 1101192;
   i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $59 = i64toi32_i32$1;
   i64toi32_i32$1 = $2;
   HEAP32[($2 + 72 | 0) >> 2] = $59;
   HEAP32[($2 + 76 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($2 + 32 | 0) >> 2] = $2 + 72 | 0;
   HEAP32[($2 + 64 | 0) >> 2] = $2 + 24 | 0;
   $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 48 | 0 | 0) | 0;
  }
  global$0 = $2 + 80 | 0;
  return $0 | 0;
 }
 
 function cardano_serialization_lib__tx_builder__TransactionBuilder__set_auxiliary_data__h12006016667e6f76($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $4 = 0, $50 = 0, $53 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if (HEAP32[($1 + 20 | 0) >> 2] | 0) {
     break label$2
    }
    HEAP32[($2 + 20 | 0) >> 2] = 0;
    break label$1;
   }
   $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h44c6d4679ef9fae6($2 | 0, $1 | 0);
  }
  $3 = $1 + 52 | 0;
  label$3 : {
   label$4 : {
    $4 = HEAP32[($1 + 40 | 0) >> 2] | 0;
    if ($4) {
     break label$4
    }
    HEAP32[($2 + 128 | 0) >> 2] = 0;
    break label$3;
   }
   alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($2 + 128 | 0 | 0, $4 | 0, HEAP32[($1 + 48 | 0) >> 2] | 0 | 0);
  }
  label$5 : {
   label$6 : {
    if (HEAP32[$3 >> 2] | 0) {
     break label$6
    }
    HEAP32[($2 + 144 | 0) >> 2] = 0;
    break label$5;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hc722e22117ee5940($2 + 144 | 0 | 0, $3 | 0);
  }
  memcpy($2 + 64 | 0 | 0, $2 | 0, 40 | 0) | 0;
  HEAP32[($2 + 112 | 0) >> 2] = HEAP32[(($2 + 128 | 0) + 8 | 0) >> 2] | 0;
  HEAP32[($2 + 124 | 0) >> 2] = HEAP32[(($2 + 144 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 128 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 132 | 0) >> 2] | 0;
  $50 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 104 | 0) >> 2] = $50;
  HEAP32[($2 + 108 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[($2 + 144 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 148 | 0) >> 2] | 0;
  $53 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 116 | 0) >> 2] = $53;
  HEAP32[($2 + 120 | 0) >> 2] = i64toi32_i32$0;
  $2 = memcpy($2 | 0, $2 + 64 | 0 | 0, 64 | 0) | 0;
  label$7 : {
   i64toi32_i32$0 = HEAP32[($0 + 328 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($0 + 332 | 0) >> 2] | 0;
   if (!(i64toi32_i32$0 | i64toi32_i32$1 | 0)) {
    break label$7
   }
   core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__metadata__GeneralTransactionMetadata____h37a091753d7f028f_1($0 + 336 | 0 | 0);
   core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__NativeScripts____hdd7d461255ec800a_2($0 + 376 | 0 | 0);
   core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__plutus__PlutusScripts____h6be1d55eac328b7f_2($0 + 388 | 0 | 0);
  }
  i64toi32_i32$0 = $0;
  i64toi32_i32$1 = 0;
  HEAP32[($0 + 328 | 0) >> 2] = 1;
  HEAP32[($0 + 332 | 0) >> 2] = i64toi32_i32$1;
  memcpy($0 + 336 | 0 | 0, $2 | 0, 64 | 0) | 0;
  global$0 = $2 + 160 | 0;
 }
 
 function cardano_serialization_lib__plutus__CostModel__get__hc959a795ef212b84($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $4 = 0, $27 = 0, $32 = 0, $44 = 0, $49 = 0;
  $3 = global$0 - 96 | 0;
  global$0 = $3;
  HEAP32[($3 + 36 | 0) >> 2] = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     if ($2 >>> 0 > 165 >>> 0) {
      break label$3
     }
     $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     if ($4 >>> 0 <= $2 >>> 0) {
      break label$1
     }
     HEAP32[$0 >> 2] = 0;
     $2 = (HEAP32[$1 >> 2] | 0) + ($2 << 4 | 0) | 0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
     $27 = i64toi32_i32$0;
     i64toi32_i32$0 = $0 + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $27;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $2 + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $32 = i64toi32_i32$1;
     i64toi32_i32$1 = $0 + 16 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $32;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     break label$2;
    }
    core__fmt__ArgumentV1__new__h5702524f4c8ddc75($3 + 24 | 0 | 0, $3 + 36 | 0 | 0, 46 | 0);
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAP32[($3 + 24 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($3 + 28 | 0) >> 2] | 0;
    core__fmt__ArgumentV1__new__h5702524f4c8ddc75($3 + 16 | 0 | 0, 1071420 | 0, 46 | 0);
    HEAP32[($3 + 76 | 0) >> 2] = 2;
    $44 = i64toi32_i32$0;
    i64toi32_i32$0 = $3;
    HEAP32[($3 + 80 | 0) >> 2] = $44;
    HEAP32[($3 + 84 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$0 = $3;
    i64toi32_i32$1 = 0;
    HEAP32[($3 + 60 | 0) >> 2] = 2;
    HEAP32[($3 + 64 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($3 + 56 | 0) >> 2] = 1071404;
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAP32[($3 + 16 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($3 + 20 | 0) >> 2] | 0;
    $49 = i64toi32_i32$1;
    i64toi32_i32$1 = $3;
    HEAP32[($3 + 88 | 0) >> 2] = $49;
    HEAP32[($3 + 92 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($3 + 72 | 0) >> 2] = $3 + 80 | 0;
    alloc__fmt__format__h6e9e003a52c07309($3 + 40 | 0 | 0, $3 + 56 | 0 | 0);
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $3 + 40 | 0 | 0);
    $2 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($3 + 8 | 0) >> 2] | 0 | 0, HEAP32[($3 + 12 | 0) >> 2] | 0 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    HEAP32[($0 + 4 | 0) >> 2] = $2;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 40 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 40 | 0 | 0);
   }
   global$0 = $3 + 96 | 0;
   return;
  }
  core__panicking__panic_bounds_check__h808b524af17640b1($2 | 0, $4 | 0, 1071440 | 0);
  abort();
 }
 
 function bech32__check_hrp__h41cbe4782f1256ab($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $5 = 0, $4 = 0, $3 = 0, $25 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     if (($2 + -1 | 0) >>> 0 > 82 >>> 0) {
      break label$3
     }
     $3 = 0;
     $4 = 0;
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : while (1) {
          label$9 : {
           if ($2) {
            break label$9
           }
           if ($3 & 1 | 0) {
            break label$7
           }
           $2 = $4 & 1 | 0 ? 1 : 2;
           break label$6;
          }
          $5 = HEAPU8[$1 >> 0] | 0;
          if ((($5 + -33 | 0) & 255 | 0) >>> 0 > 93 >>> 0) {
           break label$5
          }
          $25 = (($5 + -65 | 0) & 255 | 0) >>> 0 < 26 >>> 0;
          $5 = ($5 + -97 | 0) & 255 | 0;
          $3 = $3 | ($25 & $5 >>> 0 > 25 >>> 0 | 0) | 0;
          $2 = $2 + -1 | 0;
          $1 = $1 + 1 | 0;
          $4 = $4 | $5 >>> 0 < 26 >>> 0 | 0;
          if (!($4 & 1 | 0)) {
           continue label$8
          }
          if (!($3 & 1 | 0)) {
           continue label$8
          }
          break label$8;
         };
         HEAP8[($0 + 4 | 0) >> 0] = 6;
         break label$2;
        }
        $2 = 0;
        if ($4 & 1 | 0) {
         break label$4
        }
       }
       HEAP8[($0 + 1 | 0) >> 0] = $2;
       $2 = 0;
       break label$1;
      }
      HEAP32[($0 + 8 | 0) >> 2] = $5;
      HEAP8[($0 + 4 | 0) >> 0] = 3;
      break label$2;
     }
     core__panicking__panic__h2fd385a887c8bf13(1138564 | 0, 40 | 0, 1138604 | 0);
     abort();
    }
    HEAP8[($0 + 4 | 0) >> 0] = 2;
   }
   $2 = 1;
  }
  HEAP8[$0 >> 0] = $2;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__KV___split__h865d4c501f09fe2c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $7 = 0, $5 = 0, $4 = 0, $6 = 0, $2 = 0, $3 = 0, $8 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $83 = 0;
  $2 = global$0 - 144 | 0;
  global$0 = $2;
  $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $4 = HEAPU16[($3 + 1458 | 0) >> 1] | 0;
  $5 = alloc__boxed__Box_T_2cA___new_uninit_in__h3c49993511c7b2e3() | 0;
  HEAP16[($5 + 1458 | 0) >> 1] = 0;
  HEAP32[($5 + 1056 | 0) >> 2] = 0;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__h1fe5a9016efba49b($2 + 8 | 0 | 0, $1 | 0, $5 | 0);
  $6 = HEAPU16[($5 + 1458 | 0) >> 1] | 0;
  $7 = $6 + 1 | 0;
  label$1 : {
   label$2 : {
    if ($6 >>> 0 >= 12 >>> 0) {
     break label$2
    }
    $8 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    $4 = $4 - $8 | 0;
    if (($4 | 0) != ($7 | 0)) {
     break label$1
    }
    memcpy($5 + 1464 | 0 | 0, (($8 << 2 | 0) + $3 | 0) + 1468 | 0 | 0, $4 << 2 | 0 | 0) | 0;
    $3 = HEAP32[$1 >> 2] | 0;
    $7 = 0;
    label$3 : {
     label$4 : while (1) {
      $4 = HEAP32[(($5 + ($7 << 2 | 0) | 0) + 1464 | 0) >> 2] | 0;
      HEAP16[($4 + 1456 | 0) >> 1] = $7;
      HEAP32[($4 + 1056 | 0) >> 2] = $5;
      if ($7 >>> 0 >= $6 >>> 0) {
       break label$3
      }
      $7 = $7 + ($7 >>> 0 < $6 >>> 0) | 0;
      if ($7 >>> 0 <= $6 >>> 0) {
       continue label$4
      }
      break label$4;
     };
    }
    i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $7 = memcpy($0 | 0, $2 + 8 | 0 | 0, 136 | 0) | 0;
    HEAP32[($7 + 148 | 0) >> 2] = $5;
    HEAP32[($7 + 144 | 0) >> 2] = $3;
    $83 = i64toi32_i32$0;
    i64toi32_i32$0 = $7;
    HEAP32[($7 + 136 | 0) >> 2] = $83;
    HEAP32[($7 + 140 | 0) >> 2] = i64toi32_i32$1;
    global$0 = $2 + 144 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($7 | 0, 12 | 0, 1049060 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1048988 | 0, 40 | 0, 1049028 | 0);
  abort();
 }
 
 function $cardano_serialization_lib__metadata__TransactionMetadatumEnum_20as_20core__cmp__PartialEq___eq__h1b9ad18ad9a7fd9d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $3 = 0, i64toi32_i32$3 = 0, $4 = 0, $33 = 0, $33$hi = 0, $36 = 0, $36$hi = 0, $37 = 0, $37$hi = 0, $40 = 0, $40$hi = 0, $43 = 0, $43$hi = 0, $44 = 0, $44$hi = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  $3 = 0;
  label$1 : {
   $4 = HEAP32[$0 >> 2] | 0;
   if (($4 | 0) != (HEAP32[$1 >> 2] | 0 | 0)) {
    break label$1
   }
   label$2 : {
    switch ($4 | 0) {
    default:
     $3 = $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__cmp__PartialEq___eq__h47be0878df6ae947($0 + 8 | 0 | 0, $1 + 8 | 0 | 0) | 0;
     break label$1;
    case 1:
     $3 = $_5bA_5d_20as_20core__slice__cmp__SlicePartialEq_B____equal__hf5046e4900ef6969(HEAP32[($0 + 4 | 0) >> 2] | 0 | 0, HEAP32[($0 + 12 | 0) >> 2] | 0 | 0, HEAP32[($1 + 4 | 0) >> 2] | 0 | 0, HEAP32[($1 + 12 | 0) >> 2] | 0 | 0) | 0;
     break label$1;
    case 2:
     i64toi32_i32$2 = $0 + 8 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $33 = i64toi32_i32$0;
     $33$hi = i64toi32_i32$1;
     i64toi32_i32$2 = $1 + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $36 = i64toi32_i32$1;
     $36$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $33$hi;
     i64toi32_i32$2 = $33;
     i64toi32_i32$1 = $36$hi;
     i64toi32_i32$3 = $36;
     i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
     $37 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
     $37$hi = i64toi32_i32$1;
     i64toi32_i32$0 = $0 + 16 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $40 = i64toi32_i32$1;
     $40$hi = i64toi32_i32$2;
     i64toi32_i32$0 = $1 + 16 | 0;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
     $43 = i64toi32_i32$2;
     $43$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $40$hi;
     i64toi32_i32$0 = $40;
     i64toi32_i32$2 = $43$hi;
     i64toi32_i32$3 = $43;
     i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
     $44 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
     $44$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $37$hi;
     i64toi32_i32$1 = $37;
     i64toi32_i32$0 = $44$hi;
     i64toi32_i32$3 = $44;
     i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
     $3 = !(i64toi32_i32$1 | i64toi32_i32$3 | 0 | i64toi32_i32$0 | 0);
     break label$1;
    case 3:
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $0 + 4 | 0 | 0);
     $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
     $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 | 0, $1 + 4 | 0 | 0);
     $3 = core__slice__cmp___impl_20core__cmp__PartialEq__5bB_5d__20for_20_5bA_5d___eq__hc3de93b036fcc30b($3 | 0, $0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0) | 0;
     break label$1;
    case 4:
     break label$2;
    };
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 24 | 0 | 0, $0 + 4 | 0 | 0);
   $0 = HEAP32[($2 + 28 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 24 | 0) >> 2] | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 16 | 0 | 0, $1 + 4 | 0 | 0);
   $3 = core__slice__cmp___impl_20core__cmp__PartialEq__5bB_5d__20for_20_5bA_5d___eq__hc3de93b036fcc30b($3 | 0, $0 | 0, HEAP32[($2 + 16 | 0) >> 2] | 0 | 0, HEAP32[($2 + 20 | 0) >> 2] | 0 | 0) | 0;
  }
  global$0 = $2 + 32 | 0;
  return $3 | 0;
 }
 
 function cardano_serialization_lib__crypto__PublicKey__hash__hc5c76cad9b10a59a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $3 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $25 = 0, $4 = 0, $19 = 0, $24 = 0, $29 = 0, $34 = 0, $65 = 0, $69 = 0, $72 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 + 8 | 0 | 0, 32 | 0, 0 | 0);
  HEAP32[($2 + 52 | 0) >> 2] = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  HEAP32[($2 + 48 | 0) >> 2] = $3;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $19 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  $15 = $19;
  HEAP8[i64toi32_i32$0 >> 0] = $15;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $15 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $15 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $15 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $24 = i64toi32_i32$1;
  i64toi32_i32$1 = $3 + 8 | 0;
  $16 = $24;
  HEAP8[i64toi32_i32$1 >> 0] = $16;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $16 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $29 = i64toi32_i32$0;
  i64toi32_i32$0 = $3 + 16 | 0;
  $17 = $29;
  HEAP8[i64toi32_i32$0 >> 0] = $17;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $17 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $17 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $17 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 24 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $34 = i64toi32_i32$1;
  i64toi32_i32$1 = $3 + 24 | 0;
  $18 = $34;
  HEAP8[i64toi32_i32$1 >> 0] = $18;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $18 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $18 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $18 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP32[($2 + 56 | 0) >> 2] = 32;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 | 0, $2 + 48 | 0 | 0);
  $1 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = $1;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $3 = ($2 + 16 | 0) + 16 | 0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = ($2 + 16 | 0) + 24 | 0;
  HEAP32[$4 >> 2] = 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  cryptoxide__blake2b__Blake2b__blake2b__hfbfc741a485cb529(i64toi32_i32$1 + 16 | 0 | 0, 28 | 0, HEAP32[i64toi32_i32$1 >> 2] | 0 | 0, HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0 | 0, 1066228 | 0, 0 | 0);
  $20 = $0 + 24 | 0;
  $21 = HEAP32[$4 >> 2] | 0;
  HEAP8[$20 >> 0] = $21;
  HEAP8[($20 + 1 | 0) >> 0] = $21 >>> 8 | 0;
  HEAP8[($20 + 2 | 0) >> 0] = $21 >>> 16 | 0;
  HEAP8[($20 + 3 | 0) >> 0] = $21 >>> 24 | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $65 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 16 | 0;
  $22 = $65;
  HEAP8[i64toi32_i32$0 >> 0] = $22;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $22 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $22 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $22 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $69 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 8 | 0;
  $23 = $69;
  HEAP8[i64toi32_i32$1 >> 0] = $23;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $23 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $23 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $23 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $72 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  $25 = $72;
  HEAP8[i64toi32_i32$0 >> 0] = $25;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $25 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $25 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $25 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7(i64toi32_i32$2 + 48 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2(i64toi32_i32$2 + 48 | 0 | 0);
  global$0 = i64toi32_i32$2 + 64 | 0;
 }
 
 function alloc__slice___impl_20_5bT_5d___sort_by_key___7b_7bclosure_7d_7d__h5570c792610ff4df($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4$hi = 0, $5$hi = 0, $16 = 0, $34 = 0, $4 = 0, $68 = 0, $82 = 0;
  $3 = global$0 - 32 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    if ((HEAP32[($1 + 72 | 0) >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $16 = $1 + 76 | 0;
    $0 = HEAP32[$0 >> 2] | 0;
    $1 = HEAP32[$0 >> 2] | 0;
    cardano_serialization_lib__MultiAsset__get__had0c36a2c855d776($3 + 16 | 0 | 0, $16 | 0, HEAP32[(HEAP32[$1 >> 2] | 0) >> 2] | 0 | 0);
    if ((HEAP32[($3 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    HEAP32[($3 + 8 | 0) >> 2] = HEAP32[($3 + 28 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($3 + 20 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($3 + 24 | 0) >> 2] | 0;
    $34 = i64toi32_i32$0;
    i64toi32_i32$0 = $3;
    HEAP32[$3 >> 2] = $34;
    HEAP32[($3 + 4 | 0) >> 2] = i64toi32_i32$1;
    $1 = alloc__collections__btree__map__BTreeMap_K_2cV___get__h825f34112f7eacbf($3 | 0, HEAP32[(HEAP32[($1 + 4 | 0) >> 2] | 0) >> 2] | 0 | 0) | 0;
    if ($1) {
     break label$1
    }
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h6c9f94f0f82ce2b5($3 | 0);
   }
   core__option__expect_failed__h66afff61e82fdd86(1069476 | 0, 14 | 0, 1069508 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $4 = i64toi32_i32$1;
  $4$hi = i64toi32_i32$0;
  $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h6c9f94f0f82ce2b5($3 | 0);
  label$3 : {
   label$4 : {
    if ((HEAP32[($2 + 72 | 0) >> 2] | 0 | 0) != (1 | 0)) {
     break label$4
    }
    $1 = HEAP32[$0 >> 2] | 0;
    cardano_serialization_lib__MultiAsset__get__had0c36a2c855d776($3 + 16 | 0 | 0, $2 + 76 | 0 | 0, HEAP32[(HEAP32[$1 >> 2] | 0) >> 2] | 0 | 0);
    if ((HEAP32[($3 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
     break label$4
    }
    HEAP32[($3 + 8 | 0) >> 2] = HEAP32[($3 + 28 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($3 + 20 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($3 + 24 | 0) >> 2] | 0;
    $68 = i64toi32_i32$0;
    i64toi32_i32$0 = $3;
    HEAP32[$3 >> 2] = $68;
    HEAP32[($3 + 4 | 0) >> 2] = i64toi32_i32$1;
    $1 = alloc__collections__btree__map__BTreeMap_K_2cV___get__h825f34112f7eacbf($3 | 0, HEAP32[(HEAP32[($1 + 4 | 0) >> 2] | 0) >> 2] | 0 | 0) | 0;
    if ($1) {
     break label$3
    }
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h6c9f94f0f82ce2b5($3 | 0);
   }
   core__option__expect_failed__h66afff61e82fdd86(1069476 | 0, 14 | 0, 1069508 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5$hi = i64toi32_i32$0;
  $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h6c9f94f0f82ce2b5($3 | 0);
  global$0 = $3 + 32 | 0;
  i64toi32_i32$0 = $4$hi;
  i64toi32_i32$0 = $5$hi;
  $82 = i64toi32_i32$1;
  i64toi32_i32$0 = $4$hi;
  i64toi32_i32$1 = $5$hi;
  return i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & $4 >>> 0 < $82 >>> 0 | 0) | 0 | 0;
 }
 
 function hashbrown__map__HashMap_K_2cV_2cS_2cA___contains_key__h55b3ecb4b6dda83d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $9 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  i64toi32_i32$0 = hashbrown__map__make_hash__h3827262269fc5d43($0 | 0, $1 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $3 = i64toi32_i32$0;
  $4 = (HEAP32[($0 + 16 | 0) >> 2] | 0) & $3 | 0;
  $9 = (HEAP32[($0 + 20 | 0) >> 2] | 0) + $4 | 0;
  $5 = HEAPU8[$9 >> 0] | 0 | ((HEAPU8[($9 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($9 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($9 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $6 = 0;
  HEAP32[($2 + 32 | 0) >> 2] = 0;
  HEAP32[($2 + 36 | 0) >> 2] = $5;
  HEAP32[($2 + 28 | 0) >> 2] = $4;
  HEAP32[($2 + 24 | 0) >> 2] = $0 + 16 | 0;
  $0 = $3 >>> 25 | 0;
  HEAP8[($2 + 44 | 0) >> 0] = $0;
  $0 = $5 ^ Math_imul($0, 16843009) | 0;
  HEAP32[($2 + 40 | 0) >> 2] = (($0 ^ -1 | 0) & ($0 + -16843009 | 0) | 0) & -2139062144 | 0;
  $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($2 + 16 | 0 | 0, $2 + 24 | 0 | 0);
  label$1 : {
   if (!(HEAP32[($2 + 16 | 0) >> 2] | 0)) {
    break label$1
   }
   label$2 : {
    if (!(memcmp($1 | 0, ((HEAP32[((HEAP32[($2 + 24 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) + Math_imul(0 - (HEAP32[($2 + 20 | 0) >> 2] | 0) | 0, 28) | 0) + -28 | 0 | 0, 28 | 0) | 0)) {
     break label$2
    }
    label$3 : while (1) {
     $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($2 + 8 | 0 | 0, $2 + 24 | 0 | 0);
     if (!(HEAP32[($2 + 8 | 0) >> 2] | 0)) {
      break label$1
     }
     if (memcmp($1 | 0, ((HEAP32[((HEAP32[($2 + 24 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) + Math_imul(0 - (HEAP32[($2 + 12 | 0) >> 2] | 0) | 0, 28) | 0) + -28 | 0 | 0, 28 | 0) | 0) {
      continue label$3
     }
     break label$3;
    };
   }
   $6 = 1;
  }
  global$0 = $2 + 48 | 0;
  return $6 | 0;
 }
 
 function alloc__collections__btree__map__entry__VacantEntry_K_2cV___insert__hbbb75728b458380d($0, $1, $1$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $1$hi = $1$hi | 0;
  var $2 = 0, i64toi32_i32$1 = 0, $9 = 0, i64toi32_i32$0 = 0, $4 = 0, $8 = 0, i64toi32_i32$2 = 0, $21 = 0, $3 = 0, $5 = 0, $6 = 0, $7 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[($0 + 12 | 0) >> 2] | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  $21 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $21;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $1$hi;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_recursing__had211746a3747d1e($2 | 0, $2 + 48 | 0 | 0, HEAP32[$0 >> 2] | 0 | 0, $1 | 0, i64toi32_i32$1 | 0);
  $3 = HEAP32[($2 + 40 | 0) >> 2] | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[$2 >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     $0 = HEAP32[($0 + 16 | 0) >> 2] | 0;
     break label$2;
    }
    $0 = HEAP32[($0 + 16 | 0) >> 2] | 0;
    $4 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    if (!$4) {
     break label$1
    }
    $5 = HEAP32[($2 + 36 | 0) >> 2] | 0;
    $6 = HEAP32[($2 + 32 | 0) >> 2] | 0;
    i64toi32_i32$2 = $2 + 16 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $1 = i64toi32_i32$1;
    $1$hi = i64toi32_i32$0;
    $7 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    $8 = HEAP32[$0 >> 2] | 0;
    $9 = alloc__boxed__Box_T_2cA___new_uninit_in__h7bc2e41a812e1158() | 0;
    HEAP32[($9 + 144 | 0) >> 2] = $4;
    HEAP16[($9 + 138 | 0) >> 1] = 0;
    HEAP32[($9 + 88 | 0) >> 2] = 0;
    HEAP32[($0 + 4 | 0) >> 2] = $9;
    $8 = $8 + 1 | 0;
    HEAP32[$0 >> 2] = $8;
    HEAP16[($4 + 136 | 0) >> 1] = 0;
    HEAP32[($4 + 88 | 0) >> 2] = $9;
    HEAP32[($2 + 52 | 0) >> 2] = $9;
    HEAP32[($2 + 48 | 0) >> 2] = $8;
    alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal___push__h571d2b7933db7a9d($2 + 48 | 0 | 0, $7 | 0, i64toi32_i32$1 | 0, i64toi32_i32$0 | 0, $6 | 0, $5 | 0);
   }
   HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
   global$0 = $2 + 64 | 0;
   return $3 | 0;
  }
  core__panicking__panic__h2fd385a887c8bf13(1072048 | 0, 43 | 0, 1072248 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__KV___split__h5d37aa412fb34502($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $7 = 0, $5 = 0, $4 = 0, $6 = 0, $2 = 0, $3 = 0, $8 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $83 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $4 = HEAPU16[($3 + 402 | 0) >> 1] | 0;
  $5 = alloc__boxed__Box_T_2cA___new_uninit_in__h22083d1d420f57ec() | 0;
  HEAP16[($5 + 402 | 0) >> 1] = 0;
  HEAP32[($5 + 264 | 0) >> 2] = 0;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__h8872afc6f83eb16f($2 + 8 | 0 | 0, $1 | 0, $5 | 0);
  $6 = HEAPU16[($5 + 402 | 0) >> 1] | 0;
  $7 = $6 + 1 | 0;
  label$1 : {
   label$2 : {
    if ($6 >>> 0 >= 12 >>> 0) {
     break label$2
    }
    $8 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    $4 = $4 - $8 | 0;
    if (($4 | 0) != ($7 | 0)) {
     break label$1
    }
    memcpy($5 + 408 | 0 | 0, (($8 << 2 | 0) + $3 | 0) + 412 | 0 | 0, $4 << 2 | 0 | 0) | 0;
    $3 = HEAP32[$1 >> 2] | 0;
    $7 = 0;
    label$3 : {
     label$4 : while (1) {
      $4 = HEAP32[(($5 + ($7 << 2 | 0) | 0) + 408 | 0) >> 2] | 0;
      HEAP16[($4 + 400 | 0) >> 1] = $7;
      HEAP32[($4 + 264 | 0) >> 2] = $5;
      if ($7 >>> 0 >= $6 >>> 0) {
       break label$3
      }
      $7 = $7 + ($7 >>> 0 < $6 >>> 0) | 0;
      if ($7 >>> 0 <= $6 >>> 0) {
       continue label$4
      }
      break label$4;
     };
    }
    i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $7 = memcpy($0 | 0, $2 + 8 | 0 | 0, 40 | 0) | 0;
    HEAP32[($7 + 52 | 0) >> 2] = $5;
    HEAP32[($7 + 48 | 0) >> 2] = $3;
    $83 = i64toi32_i32$0;
    i64toi32_i32$0 = $7;
    HEAP32[($7 + 40 | 0) >> 2] = $83;
    HEAP32[($7 + 44 | 0) >> 2] = i64toi32_i32$1;
    global$0 = $2 + 48 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($7 | 0, 12 | 0, 1084548 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1084476 | 0, 40 | 0, 1084516 | 0);
  abort();
 }
 
 function cryptoxide__blake2b__Blake2b__finalize__h8a0df5452d79555d($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  label$1 : {
   if (HEAPU8[($0 + 288 | 0) >> 0] | 0) {
    break label$1
   }
   label$2 : {
    label$3 : {
     switch (HEAPU8[$0 >> 0] | 0 | 0) {
     default:
      cryptoxide__hashing__blake2b__Context_____finalize_reset_at__h2d8cd859e521b13a($0 + 32 | 0 | 0, $1 | 0, $2 | 0);
      break label$2;
     case 1:
      cryptoxide__hashing__blake2b__Context_____finalize_reset_at__h01b36216b7918c0c($0 + 32 | 0 | 0, $1 | 0, $2 | 0);
      break label$2;
     case 2:
      cryptoxide__hashing__blake2b__Context_____finalize_reset_at__h65f876891ca9972a($0 + 32 | 0 | 0, $1 | 0, $2 | 0);
      break label$2;
     case 3:
      cryptoxide__hashing__blake2b__Context_____finalize_reset_at__ha5c35cb3b74565dc($0 + 32 | 0 | 0, $1 | 0, $2 | 0);
      break label$2;
     case 4:
      cryptoxide__hashing__blake2b__Context_____finalize_reset_at__hf68b8d8007a0dcdc($0 + 32 | 0 | 0, $1 | 0, $2 | 0);
      break label$2;
     case 5:
      cryptoxide__hashing__blake2b__Context_____finalize_reset_at__hf68b8d8007a0dcdc($0 + 32 | 0 | 0, $1 | 0, $2 | 0);
      break label$2;
     case 6:
      cryptoxide__hashing__blake2b__Context_____finalize_reset_at__h171ca629c0dfd129($0 + 32 | 0 | 0, $1 | 0, $2 | 0);
      break label$2;
     case 7:
      cryptoxide__hashing__blake2b__Context_____finalize_reset_at__hc67bf5d72cbf260d($0 + 32 | 0 | 0, $1 | 0, $2 | 0);
      break label$2;
     case 8:
      cryptoxide__hashing__blake2b__Context_____finalize_reset_at__h33fdf3a4d45604f9($0 + 32 | 0 | 0, $1 | 0, $2 | 0);
      break label$2;
     case 9:
      cryptoxide__hashing__blake2b__Context_____finalize_reset_at__hd64ab7961a181132($0 + 32 | 0 | 0, $1 | 0, $2 | 0);
      break label$2;
     case 10:
      cryptoxide__hashing__blake2b__Context_____finalize_reset_at__h4dc347e6007a0aca($0 + 32 | 0 | 0, $1 | 0, $2 | 0);
      break label$2;
     case 11:
      cryptoxide__hashing__blake2b__Context_____finalize_reset_at__h8d40aeec1ac6a7fd($0 + 32 | 0 | 0, $1 | 0, $2 | 0);
      break label$2;
     case 12:
      cryptoxide__hashing__blake2b__Context_____finalize_reset_at__h5ae601ceaeb89a3a($0 + 32 | 0 | 0, $1 | 0, $2 | 0);
      break label$2;
     case 13:
      break label$3;
     };
    }
    cryptoxide__hashing__blake2b__Context_____finalize_reset_at__hc0b076ac1d844c85($0 + 32 | 0 | 0, $1 | 0, $2 | 0);
   }
   HEAP8[($0 + 288 | 0) >> 0] = 1;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1135784 | 0, 41 | 0, 1135844 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___insert_fit__h6793817b02ed58e7($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $5 = 0, $6 = 0, $7 = 0, $8 = 0, $9 = 0;
  label$1 : {
   $4 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   $5 = $4 + 1 | 0;
   $6 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   $0 = HEAPU16[($6 + 50 | 0) >> 1] | 0;
   if ($5 >>> 0 > $0 >>> 0) {
    break label$1
   }
   $7 = $6 + 4 | 0;
   memmove($7 + ($5 << 2 | 0) | 0 | 0, $7 + ($4 << 2 | 0) | 0 | 0, ($0 - $4 | 0) << 2 | 0 | 0) | 0;
  }
  $7 = $0 + 1 | 0;
  HEAP32[(($6 + ($4 << 2 | 0) | 0) + 4 | 0) >> 2] = $1;
  label$2 : {
   $8 = $4 + 2 | 0;
   $1 = $0 + 2 | 0;
   if ($8 >>> 0 >= $1 >>> 0) {
    break label$2
   }
   $9 = $6 + 52 | 0;
   memmove($9 + ($8 << 2 | 0) | 0 | 0, $9 + ($5 << 2 | 0) | 0 | 0, ($0 - $4 | 0) << 2 | 0 | 0) | 0;
  }
  HEAP32[(($6 + ($5 << 2 | 0) | 0) + 52 | 0) >> 2] = $3;
  HEAP16[($6 + 50 | 0) >> 1] = $7;
  label$3 : {
   if ($5 >>> 0 >= $1 >>> 0) {
    break label$3
   }
   $1 = $0 + 1 | 0;
   $0 = ($6 + ($4 << 2 | 0) | 0) + 56 | 0;
   label$4 : while (1) {
    $5 = HEAP32[$0 >> 2] | 0;
    $4 = $4 + 1 | 0;
    HEAP16[($5 + 48 | 0) >> 1] = $4;
    HEAP32[$5 >> 2] = $6;
    $0 = $0 + 4 | 0;
    if (($1 | 0) != ($4 | 0)) {
     continue label$4
    }
    break label$4;
   };
  }
 }
 
 function cardano_serialization_lib__output_builder__TransactionOutputBuilder__with_address__h0d63b91ad5941c64($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, $4 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $21 = 0, $26 = 0, $31 = 0, $35 = 0, $44 = 0, $49 = 0, $54 = 0, $59 = 0;
  $3 = global$0 - 96 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    if ((HEAPU8[$1 >> 0] | 0 | 0) != (5 | 0)) {
     break label$2
    }
    HEAP8[$3 >> 0] = 5;
    break label$1;
   }
   $cardano_serialization_lib__address__Address_20as_20core__clone__Clone___clone__h0eb465a6e349d507_1($3 | 0, $1 | 0);
  }
  $4 = 0;
  label$3 : {
   if ((HEAPU8[($1 + 64 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$3
   }
   i64toi32_i32$2 = $1 + 89 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $21 = i64toi32_i32$0;
   i64toi32_i32$0 = $3 + 88 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $21;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1 + 81 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $26 = i64toi32_i32$1;
   i64toi32_i32$1 = $3 + 80 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $26;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $1 + 73 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $31 = i64toi32_i32$0;
   i64toi32_i32$0 = $3 + 72 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $31;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1 + 65 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $35 = i64toi32_i32$1;
   i64toi32_i32$1 = $3;
   HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] = $35;
   HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] = i64toi32_i32$0;
   $4 = 1;
  }
  $1 = memcpy($0 | 0, $3 | 0, 64 | 0) | 0;
  HEAP8[($1 + 64 | 0) >> 0] = $4;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
  $44 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 65 | 0;
  $16 = $44;
  HEAP8[i64toi32_i32$0 >> 0] = $16;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $16 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 72 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $49 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 73 | 0;
  $17 = $49;
  HEAP8[i64toi32_i32$1 >> 0] = $17;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $3 + 80 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $54 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 81 | 0;
  $18 = $54;
  HEAP8[i64toi32_i32$0 >> 0] = $18;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $18 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $18 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $18 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $3 + 88 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $59 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 89 | 0;
  $19 = $59;
  HEAP8[i64toi32_i32$1 >> 0] = $19;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $19 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $19 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $19 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $cardano_serialization_lib__address__Address_20as_20core__clone__Clone___clone__h0eb465a6e349d507_1($3 | 0, $2 | 0);
  label$4 : {
   $4 = HEAPU8[$1 >> 0] | 0;
   if ((($4 << 29 | 0) >> 29 | 0 | 0) > (-1 | 0)) {
    break label$4
   }
   if (($4 | 0) == (5 | 0)) {
    break label$4
   }
   core__ptr__drop_in_place_core__option__Option_alloc__vec__Vec_u8_____ha5300c747747c3c8($1 + 4 | 0 | 0);
  }
  memcpy($1 | 0, $3 | 0, 64 | 0) | 0;
  global$0 = $3 + 96 | 0;
 }
 
 function metadatamap_insert_str($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $5 = 0, $6 = 0;
  $4 = global$0 - 128 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h1305d160e0e385a5($4 + 16 | 0 | 0, $0 | 0);
    $5 = HEAP32[($4 + 20 | 0) >> 2] | 0;
    $6 = HEAP32[($4 + 16 | 0) >> 2] | 0;
    HEAP32[($4 + 32 | 0) >> 2] = $2;
    HEAP32[($4 + 28 | 0) >> 2] = $2;
    HEAP32[($4 + 24 | 0) >> 2] = $1;
    alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($4 + 8 | 0 | 0, $4 + 24 | 0 | 0);
    $2 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    HEAP32[($4 + 84 | 0) >> 2] = $2;
    $1 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    HEAP32[($4 + 80 | 0) >> 2] = $1;
    if (!$3) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__hc630c86c4ab6b26d($4 | 0, $3 | 0);
    $0 = HEAP32[($4 + 4 | 0) >> 2] | 0;
    cardano_serialization_lib__metadata__MetadataMap__insert_str__h919b90e1ce9180ce($4 + 24 | 0 | 0, $6 | 0, $1 | 0, $2 | 0, HEAP32[$4 >> 2] | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_1($4 + 80 | 0 | 0);
    $0 = 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($5 | 0, 0 | 0) | 0;
    if ((HEAP32[($4 + 24 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    label$3 : {
     $2 = HEAP32[($4 + 32 | 0) >> 2] | 0;
     if (($2 | 0) == (5 | 0)) {
      break label$3
     }
     HEAP32[($4 + 80 | 0) >> 2] = $2;
     memcpy($4 + 80 | 0 | 4 | 0 | 0, $4 + 36 | 0 | 0, 44 | 0) | 0;
     $0 = $cardano_serialization_lib__metadata__TransactionMetadatum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hce2feba55b67d086($4 + 80 | 0 | 0) | 0;
    }
    global$0 = $4 + 128 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($4 + 28 | 0) >> 2] | 0 | 0);
  abort();
 }
 
 function transactionbuilder_add_mint_asset_and_output_min_required_coin($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $10$hi = 0, $6 = 0, $7 = 0, $8 = 0, $9 = 0, $10 = 0, $62$hi = 0, $16 = 0;
  $5 = global$0 - 64 | 0;
  global$0 = $5;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h5566e1c7d4aafe35($5 + 56 | 0 | 0, $0 | 0);
    if (!$1) {
     break label$2
    }
    $6 = HEAP32[($5 + 60 | 0) >> 2] | 0;
    $7 = HEAP32[($5 + 56 | 0) >> 2] | 0;
    wasm_bindgen____rt__WasmRefCell_T___borrow__h6ed0b6b043905434($5 + 48 | 0 | 0, $1 | 0);
    if (!$2) {
     break label$2
    }
    $0 = HEAP32[($5 + 52 | 0) >> 2] | 0;
    $8 = HEAP32[($5 + 48 | 0) >> 2] | 0;
    wasm_bindgen____rt__WasmRefCell_T___borrow__h9c68abd5a6a78973($5 + 40 | 0 | 0, $2 | 0);
    $1 = HEAP32[($5 + 44 | 0) >> 2] | 0;
    $9 = HEAP32[($5 + 40 | 0) >> 2] | 0;
    $cardano_serialization_lib__utils__Int_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h465ce6bea3371e5b($5 + 24 | 0 | 0, $3 | 0);
    if (!$4) {
     break label$2
    }
    i64toi32_i32$2 = $5 + 32 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $10 = i64toi32_i32$0;
    $10$hi = i64toi32_i32$1;
    i64toi32_i32$2 = $5;
    i64toi32_i32$1 = HEAP32[($5 + 24 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($5 + 28 | 0) >> 2] | 0;
    wasm_bindgen____rt__WasmRefCell_T___borrow__h1cb96e7b1dabbc55($5 + 16 | 0 | 0, $4 | 0);
    $2 = HEAP32[($5 + 20 | 0) >> 2] | 0;
    $62$hi = i64toi32_i32$0;
    i64toi32_i32$0 = $10$hi;
    i64toi32_i32$0 = $62$hi;
    $16 = i64toi32_i32$1;
    i64toi32_i32$1 = $10$hi;
    cardano_serialization_lib__tx_builder__TransactionBuilder__add_mint_asset_and_output_min_required_coin__h8d75826e2c913b7c($5 + 8 | 0 | 0, $7 | 0, $8 | 0, $9 | 0, $16 | 0, i64toi32_i32$0 | 0, $10 | 0, i64toi32_i32$1 | 0, HEAP32[($5 + 16 | 0) >> 2] | 0 | 0);
    $3 = HEAP32[($5 + 12 | 0) >> 2] | 0;
    $4 = HEAP32[($5 + 8 | 0) >> 2] | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($6 | 0, 0 | 0) | 0;
    if ($4) {
     break label$1
    }
    global$0 = $5 + 64 | 0;
    return;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472($3 | 0);
  abort();
 }
 
 function alloc__vec__Vec_T_2cA___extend_desugared__h1d4e76ec6089b795($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $3 = 0, $8 = 0, $4 = 0, $5 = 0, $6 = 0, $9 = 0, $30 = 0, $34 = 0, $38 = 0, $41 = 0, $7 = 0, $68 = 0, $74 = 0, $78 = 0, $82 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h7135048eb51d6b68($2 + 8 | 0 | 0, $1 | 0);
  label$1 : {
   if (!(HEAP32[($2 + 8 | 0) >> 2] | 0)) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = $2 + 40 | 0;
   $5 = $2 + 32 | 0;
   $6 = $2 + 24 | 0;
   label$2 : while (1) {
    i64toi32_i32$2 = $3 + 52 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $30 = i64toi32_i32$0;
    i64toi32_i32$0 = $4;
    HEAP32[i64toi32_i32$0 >> 2] = $30;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $3 + 44 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $34 = i64toi32_i32$1;
    i64toi32_i32$1 = $5;
    HEAP32[i64toi32_i32$1 >> 2] = $34;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $3 + 36 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $38 = i64toi32_i32$0;
    i64toi32_i32$0 = $6;
    HEAP32[i64toi32_i32$0 >> 2] = $38;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
    $41 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $41;
    HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
    $7 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
    label$3 : {
     $8 = HEAP32[($0 + 8 | 0) >> 2] | 0;
     if ((HEAP32[($0 + 4 | 0) >> 2] | 0 | 0) != ($8 | 0)) {
      break label$3
     }
     $3 = HEAP32[($1 + 24 | 0) >> 2] | 0;
     $9 = $3 + 1 | 0;
     alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hf274e025df11641c($0 | 0, $8 | 0, ($9 >>> 0 < $3 >>> 0 ? -1 : $9) | 0);
    }
    $3 = (HEAP32[$0 >> 2] | 0) + Math_imul($8, 36) | 0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
    $68 = i64toi32_i32$0;
    i64toi32_i32$0 = $3;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $68;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[i64toi32_i32$0 >> 2] = $7;
    i64toi32_i32$2 = $6;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $74 = i64toi32_i32$1;
    i64toi32_i32$1 = $3 + 12 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $74;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $5;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $78 = i64toi32_i32$0;
    i64toi32_i32$0 = $3 + 20 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $78;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $82 = i64toi32_i32$1;
    i64toi32_i32$1 = $3 + 28 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $82;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($0 + 8 | 0) >> 2] = $8 + 1 | 0;
    $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h7135048eb51d6b68($2 | 0, $1 | 0);
    $3 = HEAP32[($2 + 4 | 0) >> 2] | 0;
    if (HEAP32[$2 >> 2] | 0) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $2 + 48 | 0;
 }
 
 function core__str___impl_20str___starts_with__h05665b83cdd3f774($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  HEAP32[($3 + 12 | 0) >> 2] = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ($2 >>> 0 < 128 >>> 0) {
       break label$4
      }
      if ($2 >>> 0 < 2048 >>> 0) {
       break label$3
      }
      if ($2 >>> 0 >= 65536 >>> 0) {
       break label$2
      }
      HEAP8[($3 + 14 | 0) >> 0] = $2 & 63 | 0 | 128 | 0;
      HEAP8[($3 + 12 | 0) >> 0] = $2 >>> 12 | 0 | 224 | 0;
      HEAP8[($3 + 13 | 0) >> 0] = ($2 >>> 6 | 0) & 63 | 0 | 128 | 0;
      $2 = 3;
      break label$1;
     }
     HEAP8[($3 + 12 | 0) >> 0] = $2;
     $2 = 1;
     break label$1;
    }
    HEAP8[($3 + 13 | 0) >> 0] = $2 & 63 | 0 | 128 | 0;
    HEAP8[($3 + 12 | 0) >> 0] = $2 >>> 6 | 0 | 192 | 0;
    $2 = 2;
    break label$1;
   }
   HEAP8[($3 + 15 | 0) >> 0] = $2 & 63 | 0 | 128 | 0;
   HEAP8[($3 + 12 | 0) >> 0] = $2 >>> 18 | 0 | 240 | 0;
   HEAP8[($3 + 14 | 0) >> 0] = ($2 >>> 6 | 0) & 63 | 0 | 128 | 0;
   HEAP8[($3 + 13 | 0) >> 0] = ($2 >>> 12 | 0) & 63 | 0 | 128 | 0;
   $2 = 4;
  }
  $4 = 0;
  label$5 : {
   if ($2 >>> 0 > $1 >>> 0) {
    break label$5
   }
   $4 = !(memcmp($3 + 12 | 0 | 0, $0 | 0, $2 | 0) | 0);
  }
  global$0 = $3 + 16 | 0;
  return $4 | 0;
 }
 
 function cardano_serialization_lib__Transaction__auxiliary_data__h15726ce4b042f21d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $4 = 0, $58 = 0, $61 = 0;
  $2 = global$0 - 144 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    i64toi32_i32$2 = $1;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 272 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 276 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    if ((i64toi32_i32$2 | 0) == (1 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
     break label$2
    }
    i64toi32_i32$1 = $0;
    i64toi32_i32$2 = 0;
    HEAP32[i64toi32_i32$1 >> 2] = 0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
    break label$1;
   }
   label$3 : {
    label$4 : {
     if (HEAP32[($1 + 300 | 0) >> 2] | 0) {
      break label$4
     }
     HEAP32[($2 + 92 | 0) >> 2] = 0;
     break label$3;
    }
    $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h44c6d4679ef9fae6($2 + 72 | 0 | 0, $1 + 280 | 0 | 0);
   }
   $3 = $1 + 332 | 0;
   label$5 : {
    label$6 : {
     $4 = HEAP32[($1 + 320 | 0) >> 2] | 0;
     if ($4) {
      break label$6
     }
     HEAP32[($2 + 112 | 0) >> 2] = 0;
     break label$5;
    }
    alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($2 + 112 | 0 | 0, $4 | 0, HEAP32[($1 + 328 | 0) >> 2] | 0 | 0);
   }
   label$7 : {
    label$8 : {
     if (HEAP32[$3 >> 2] | 0) {
      break label$8
     }
     HEAP32[($2 + 128 | 0) >> 2] = 0;
     break label$7;
    }
    $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hc722e22117ee5940($2 + 128 | 0 | 0, $3 | 0);
   }
   memcpy($2 + 8 | 0 | 0, $2 + 72 | 0 | 0, 40 | 0) | 0;
   HEAP32[($2 + 56 | 0) >> 2] = HEAP32[(($2 + 112 | 0) + 8 | 0) >> 2] | 0;
   HEAP32[($2 + 68 | 0) >> 2] = HEAP32[(($2 + 128 | 0) + 8 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($2 + 112 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 116 | 0) >> 2] | 0;
   $58 = i64toi32_i32$2;
   i64toi32_i32$2 = $2;
   HEAP32[($2 + 48 | 0) >> 2] = $58;
   HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = HEAP32[($2 + 128 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($2 + 132 | 0) >> 2] | 0;
   $61 = i64toi32_i32$1;
   i64toi32_i32$1 = $2;
   HEAP32[($2 + 60 | 0) >> 2] = $61;
   HEAP32[($2 + 64 | 0) >> 2] = i64toi32_i32$2;
   memcpy($0 + 8 | 0 | 0, $2 + 8 | 0 | 0, 64 | 0) | 0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$2 = 0;
   HEAP32[i64toi32_i32$1 >> 2] = 1;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  }
  global$0 = $2 + 144 | 0;
 }
 
 function certificate_as_stake_deregistration($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $3 = 0, $2 = 0, $5 = 0, $5$hi = 0, $4 = 0, $6 = 0, $6$hi = 0, $37 = 0, $58 = 0, $63 = 0, $73 = 0;
  $1 = global$0 - 112 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h3b62e22150831bdc($1 + 8 | 0 | 0, $0 | 0);
   $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   $3 = 2;
   label$2 : {
    $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    if ((HEAPU8[$0 >> 0] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    i64toi32_i32$2 = $0 + 2 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $5 = i64toi32_i32$0;
    $5$hi = i64toi32_i32$1;
    $16 = $0 + 26 | 0;
    $4 = HEAPU8[$16 >> 0] | 0 | ((HEAPU8[($16 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($16 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($16 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$2 = $0 + 18 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $6 = i64toi32_i32$1;
    $6$hi = i64toi32_i32$0;
    $3 = HEAPU8[($0 + 1 | 0) >> 0] | 0;
    i64toi32_i32$2 = $0 + 10 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $37 = i64toi32_i32$0;
    i64toi32_i32$0 = $1 + 24 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $37;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $6$hi;
    i64toi32_i32$0 = $1 + 32 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $6;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($1 + 40 | 0) >> 2] = $4;
    i64toi32_i32$1 = $5$hi;
    i64toi32_i32$0 = $1;
    HEAP32[($1 + 16 | 0) >> 2] = $5;
    HEAP32[($1 + 20 | 0) >> 2] = i64toi32_i32$1;
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
   $0 = 0;
   label$3 : {
    if (($3 & 255 | 0 | 0) == (2 | 0)) {
     break label$3
    }
    i64toi32_i32$2 = $1 + 24 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $58 = i64toi32_i32$1;
    i64toi32_i32$1 = $1 + 89 | 0;
    $17 = $58;
    HEAP8[i64toi32_i32$1 >> 0] = $17;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$2 = $1 + 32 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $63 = i64toi32_i32$0;
    i64toi32_i32$0 = $1 + 97 | 0;
    $18 = $63;
    HEAP8[i64toi32_i32$0 >> 0] = $18;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $18 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $18 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $18 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    $19 = $1 + 105 | 0;
    $20 = HEAP32[($1 + 40 | 0) >> 2] | 0;
    HEAP8[$19 >> 0] = $20;
    HEAP8[($19 + 1 | 0) >> 0] = $20 >>> 8 | 0;
    HEAP8[($19 + 2 | 0) >> 0] = $20 >>> 16 | 0;
    HEAP8[($19 + 3 | 0) >> 0] = $20 >>> 24 | 0;
    HEAP8[($1 + 80 | 0) >> 0] = $3;
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
    $73 = i64toi32_i32$1;
    i64toi32_i32$1 = i64toi32_i32$2;
    $21 = $73;
    HEAP8[(i64toi32_i32$2 + 81 | 0) >> 0] = $21;
    HEAP8[(i64toi32_i32$2 + 82 | 0) >> 0] = $21 >>> 8 | 0;
    HEAP8[(i64toi32_i32$2 + 83 | 0) >> 0] = $21 >>> 16 | 0;
    HEAP8[(i64toi32_i32$2 + 84 | 0) >> 0] = $21 >>> 24 | 0;
    HEAP8[(i64toi32_i32$2 + 85 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$2 + 86 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$2 + 87 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$2 + 88 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    $0 = $cardano_serialization_lib__StakeDeregistration_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hb69c7c50974f5b70(i64toi32_i32$2 + 80 | 0 | 0) | 0;
   }
   global$0 = $1 + 112 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function cardano_serialization_lib__tx_builder__TransactionBuilder__get_auxiliary_data__h643ac271599e8547($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $4 = 0, $58 = 0, $61 = 0;
  $2 = global$0 - 144 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    i64toi32_i32$2 = $1;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 328 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 332 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    if ((i64toi32_i32$2 | 0) == (1 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
     break label$2
    }
    i64toi32_i32$1 = $0;
    i64toi32_i32$2 = 0;
    HEAP32[i64toi32_i32$1 >> 2] = 0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
    break label$1;
   }
   label$3 : {
    label$4 : {
     if (HEAP32[($1 + 356 | 0) >> 2] | 0) {
      break label$4
     }
     HEAP32[($2 + 92 | 0) >> 2] = 0;
     break label$3;
    }
    $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h44c6d4679ef9fae6($2 + 72 | 0 | 0, $1 + 336 | 0 | 0);
   }
   $3 = $1 + 388 | 0;
   label$5 : {
    label$6 : {
     $4 = HEAP32[($1 + 376 | 0) >> 2] | 0;
     if ($4) {
      break label$6
     }
     HEAP32[($2 + 112 | 0) >> 2] = 0;
     break label$5;
    }
    alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($2 + 112 | 0 | 0, $4 | 0, HEAP32[($1 + 384 | 0) >> 2] | 0 | 0);
   }
   label$7 : {
    label$8 : {
     if (HEAP32[$3 >> 2] | 0) {
      break label$8
     }
     HEAP32[($2 + 128 | 0) >> 2] = 0;
     break label$7;
    }
    $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hc722e22117ee5940($2 + 128 | 0 | 0, $3 | 0);
   }
   memcpy($2 + 8 | 0 | 0, $2 + 72 | 0 | 0, 40 | 0) | 0;
   HEAP32[($2 + 56 | 0) >> 2] = HEAP32[(($2 + 112 | 0) + 8 | 0) >> 2] | 0;
   HEAP32[($2 + 68 | 0) >> 2] = HEAP32[(($2 + 128 | 0) + 8 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($2 + 112 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 116 | 0) >> 2] | 0;
   $58 = i64toi32_i32$2;
   i64toi32_i32$2 = $2;
   HEAP32[($2 + 48 | 0) >> 2] = $58;
   HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = HEAP32[($2 + 128 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($2 + 132 | 0) >> 2] | 0;
   $61 = i64toi32_i32$1;
   i64toi32_i32$1 = $2;
   HEAP32[($2 + 60 | 0) >> 2] = $61;
   HEAP32[($2 + 64 | 0) >> 2] = i64toi32_i32$2;
   memcpy($0 + 8 | 0 | 0, $2 + 8 | 0 | 0, 64 | 0) | 0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$2 = 0;
   HEAP32[i64toi32_i32$1 >> 2] = 1;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  }
  global$0 = $2 + 144 | 0;
 }
 
 function ed25519keyhash_to_bech32($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $5 = 0, $57 = 0, $73 = 0, $79 = 0;
  $4 = global$0 - 80 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    if (!$1) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__hae9c55c4e91ce40f($4 + 24 | 0 | 0, $1 | 0);
    $1 = HEAP32[($4 + 28 | 0) >> 2] | 0;
    $5 = HEAP32[($4 + 24 | 0) >> 2] | 0;
    HEAP32[($4 + 40 | 0) >> 2] = $3;
    HEAP32[($4 + 36 | 0) >> 2] = $3;
    HEAP32[($4 + 32 | 0) >> 2] = $2;
    alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($4 + 16 | 0 | 0, $4 + 32 | 0 | 0);
    $3 = HEAP32[($4 + 20 | 0) >> 2] | 0;
    HEAP32[($4 + 68 | 0) >> 2] = $3;
    $2 = HEAP32[($4 + 16 | 0) >> 2] | 0;
    HEAP32[($4 + 64 | 0) >> 2] = $2;
    cardano_serialization_lib__crypto__Ed25519KeyHash__to_bech32__hac17e963a06e4032($4 + 32 | 0 | 0, $5 | 0, $2 | 0, $3 | 0);
    core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_2($4 + 64 | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
    $1 = HEAP32[($4 + 36 | 0) >> 2] | 0;
    if ((HEAP32[($4 + 32 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    i64toi32_i32$2 = ($4 + 32 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $57 = i64toi32_i32$0;
    i64toi32_i32$0 = $4;
    HEAP32[($4 + 52 | 0) >> 2] = $57;
    HEAP32[($4 + 56 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($4 + 48 | 0) >> 2] = $1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($4 + 8 | 0 | 0, $4 + 48 | 0 | 0);
    HEAP32[(($4 + 64 | 0) + 8 | 0) >> 2] = HEAP32[(($4 + 48 | 0) + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 48 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($4 + 52 | 0) >> 2] | 0;
    $73 = i64toi32_i32$1;
    i64toi32_i32$1 = $4;
    HEAP32[($4 + 64 | 0) >> 2] = $73;
    HEAP32[($4 + 68 | 0) >> 2] = i64toi32_i32$0;
    alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($4 | 0, $4 + 64 | 0 | 0);
    i64toi32_i32$2 = $4;
    i64toi32_i32$0 = HEAP32[$4 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
    $79 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[i64toi32_i32$0 >> 2] = $79;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    global$0 = $4 + 80 | 0;
    return;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
  abort();
 }
 
 function scripthash_to_bech32($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $5 = 0, $57 = 0, $73 = 0, $79 = 0;
  $4 = global$0 - 80 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    if (!$1) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h27da893e95dd15cf($4 + 24 | 0 | 0, $1 | 0);
    $1 = HEAP32[($4 + 28 | 0) >> 2] | 0;
    $5 = HEAP32[($4 + 24 | 0) >> 2] | 0;
    HEAP32[($4 + 40 | 0) >> 2] = $3;
    HEAP32[($4 + 36 | 0) >> 2] = $3;
    HEAP32[($4 + 32 | 0) >> 2] = $2;
    alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($4 + 16 | 0 | 0, $4 + 32 | 0 | 0);
    $3 = HEAP32[($4 + 20 | 0) >> 2] | 0;
    HEAP32[($4 + 68 | 0) >> 2] = $3;
    $2 = HEAP32[($4 + 16 | 0) >> 2] | 0;
    HEAP32[($4 + 64 | 0) >> 2] = $2;
    cardano_serialization_lib__crypto__ScriptHash__to_bech32__h3d04a5600baac36e($4 + 32 | 0 | 0, $5 | 0, $2 | 0, $3 | 0);
    core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_2($4 + 64 | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
    $1 = HEAP32[($4 + 36 | 0) >> 2] | 0;
    if ((HEAP32[($4 + 32 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    i64toi32_i32$2 = ($4 + 32 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $57 = i64toi32_i32$0;
    i64toi32_i32$0 = $4;
    HEAP32[($4 + 52 | 0) >> 2] = $57;
    HEAP32[($4 + 56 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($4 + 48 | 0) >> 2] = $1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($4 + 8 | 0 | 0, $4 + 48 | 0 | 0);
    HEAP32[(($4 + 64 | 0) + 8 | 0) >> 2] = HEAP32[(($4 + 48 | 0) + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 48 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($4 + 52 | 0) >> 2] | 0;
    $73 = i64toi32_i32$1;
    i64toi32_i32$1 = $4;
    HEAP32[($4 + 64 | 0) >> 2] = $73;
    HEAP32[($4 + 68 | 0) >> 2] = i64toi32_i32$0;
    alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($4 | 0, $4 + 64 | 0 | 0);
    i64toi32_i32$2 = $4;
    i64toi32_i32$0 = HEAP32[$4 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
    $79 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[i64toi32_i32$0 >> 2] = $79;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    global$0 = $4 + 80 | 0;
    return;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
  abort();
 }
 
 function transactionhash_to_bech32($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $5 = 0, $57 = 0, $73 = 0, $79 = 0;
  $4 = global$0 - 80 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    if (!$1) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h8308bd69a8eeb68f($4 + 24 | 0 | 0, $1 | 0);
    $1 = HEAP32[($4 + 28 | 0) >> 2] | 0;
    $5 = HEAP32[($4 + 24 | 0) >> 2] | 0;
    HEAP32[($4 + 40 | 0) >> 2] = $3;
    HEAP32[($4 + 36 | 0) >> 2] = $3;
    HEAP32[($4 + 32 | 0) >> 2] = $2;
    alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($4 + 16 | 0 | 0, $4 + 32 | 0 | 0);
    $3 = HEAP32[($4 + 20 | 0) >> 2] | 0;
    HEAP32[($4 + 68 | 0) >> 2] = $3;
    $2 = HEAP32[($4 + 16 | 0) >> 2] | 0;
    HEAP32[($4 + 64 | 0) >> 2] = $2;
    cardano_serialization_lib__crypto__TransactionHash__to_bech32__hfed6c3e9814189d4($4 + 32 | 0 | 0, $5 | 0, $2 | 0, $3 | 0);
    core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_2($4 + 64 | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
    $1 = HEAP32[($4 + 36 | 0) >> 2] | 0;
    if ((HEAP32[($4 + 32 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    i64toi32_i32$2 = ($4 + 32 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $57 = i64toi32_i32$0;
    i64toi32_i32$0 = $4;
    HEAP32[($4 + 52 | 0) >> 2] = $57;
    HEAP32[($4 + 56 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($4 + 48 | 0) >> 2] = $1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($4 + 8 | 0 | 0, $4 + 48 | 0 | 0);
    HEAP32[(($4 + 64 | 0) + 8 | 0) >> 2] = HEAP32[(($4 + 48 | 0) + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 48 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($4 + 52 | 0) >> 2] | 0;
    $73 = i64toi32_i32$1;
    i64toi32_i32$1 = $4;
    HEAP32[($4 + 64 | 0) >> 2] = $73;
    HEAP32[($4 + 68 | 0) >> 2] = i64toi32_i32$0;
    alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($4 | 0, $4 + 64 | 0 | 0);
    i64toi32_i32$2 = $4;
    i64toi32_i32$0 = HEAP32[$4 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
    $79 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[i64toi32_i32$0 >> 2] = $79;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    global$0 = $4 + 80 | 0;
    return;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
  abort();
 }
 
 function genesisdelegatehash_to_bech32($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $5 = 0, $57 = 0, $73 = 0, $79 = 0;
  $4 = global$0 - 80 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    if (!$1) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h72d8bcf0a652eb89($4 + 24 | 0 | 0, $1 | 0);
    $1 = HEAP32[($4 + 28 | 0) >> 2] | 0;
    $5 = HEAP32[($4 + 24 | 0) >> 2] | 0;
    HEAP32[($4 + 40 | 0) >> 2] = $3;
    HEAP32[($4 + 36 | 0) >> 2] = $3;
    HEAP32[($4 + 32 | 0) >> 2] = $2;
    alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($4 + 16 | 0 | 0, $4 + 32 | 0 | 0);
    $3 = HEAP32[($4 + 20 | 0) >> 2] | 0;
    HEAP32[($4 + 68 | 0) >> 2] = $3;
    $2 = HEAP32[($4 + 16 | 0) >> 2] | 0;
    HEAP32[($4 + 64 | 0) >> 2] = $2;
    cardano_serialization_lib__crypto__GenesisDelegateHash__to_bech32__hd0d2ed4f98116dad($4 + 32 | 0 | 0, $5 | 0, $2 | 0, $3 | 0);
    core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_2($4 + 64 | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
    $1 = HEAP32[($4 + 36 | 0) >> 2] | 0;
    if ((HEAP32[($4 + 32 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    i64toi32_i32$2 = ($4 + 32 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $57 = i64toi32_i32$0;
    i64toi32_i32$0 = $4;
    HEAP32[($4 + 52 | 0) >> 2] = $57;
    HEAP32[($4 + 56 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($4 + 48 | 0) >> 2] = $1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($4 + 8 | 0 | 0, $4 + 48 | 0 | 0);
    HEAP32[(($4 + 64 | 0) + 8 | 0) >> 2] = HEAP32[(($4 + 48 | 0) + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 48 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($4 + 52 | 0) >> 2] | 0;
    $73 = i64toi32_i32$1;
    i64toi32_i32$1 = $4;
    HEAP32[($4 + 64 | 0) >> 2] = $73;
    HEAP32[($4 + 68 | 0) >> 2] = i64toi32_i32$0;
    alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($4 | 0, $4 + 64 | 0 | 0);
    i64toi32_i32$2 = $4;
    i64toi32_i32$0 = HEAP32[$4 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
    $79 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[i64toi32_i32$0 >> 2] = $79;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    global$0 = $4 + 80 | 0;
    return;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
  abort();
 }
 
 function genesishash_to_bech32($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $5 = 0, $57 = 0, $73 = 0, $79 = 0;
  $4 = global$0 - 80 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    if (!$1) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h7b8fe8d9d71033fc($4 + 24 | 0 | 0, $1 | 0);
    $1 = HEAP32[($4 + 28 | 0) >> 2] | 0;
    $5 = HEAP32[($4 + 24 | 0) >> 2] | 0;
    HEAP32[($4 + 40 | 0) >> 2] = $3;
    HEAP32[($4 + 36 | 0) >> 2] = $3;
    HEAP32[($4 + 32 | 0) >> 2] = $2;
    alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($4 + 16 | 0 | 0, $4 + 32 | 0 | 0);
    $3 = HEAP32[($4 + 20 | 0) >> 2] | 0;
    HEAP32[($4 + 68 | 0) >> 2] = $3;
    $2 = HEAP32[($4 + 16 | 0) >> 2] | 0;
    HEAP32[($4 + 64 | 0) >> 2] = $2;
    cardano_serialization_lib__crypto__GenesisHash__to_bech32__hf37c9f3a6fa6385d($4 + 32 | 0 | 0, $5 | 0, $2 | 0, $3 | 0);
    core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_2($4 + 64 | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
    $1 = HEAP32[($4 + 36 | 0) >> 2] | 0;
    if ((HEAP32[($4 + 32 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    i64toi32_i32$2 = ($4 + 32 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $57 = i64toi32_i32$0;
    i64toi32_i32$0 = $4;
    HEAP32[($4 + 52 | 0) >> 2] = $57;
    HEAP32[($4 + 56 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($4 + 48 | 0) >> 2] = $1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($4 + 8 | 0 | 0, $4 + 48 | 0 | 0);
    HEAP32[(($4 + 64 | 0) + 8 | 0) >> 2] = HEAP32[(($4 + 48 | 0) + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 48 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($4 + 52 | 0) >> 2] | 0;
    $73 = i64toi32_i32$1;
    i64toi32_i32$1 = $4;
    HEAP32[($4 + 64 | 0) >> 2] = $73;
    HEAP32[($4 + 68 | 0) >> 2] = i64toi32_i32$0;
    alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($4 | 0, $4 + 64 | 0 | 0);
    i64toi32_i32$2 = $4;
    i64toi32_i32$0 = HEAP32[$4 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
    $79 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[i64toi32_i32$0 >> 2] = $79;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    global$0 = $4 + 80 | 0;
    return;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
  abort();
 }
 
 function auxiliarydatahash_to_bech32($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $5 = 0, $57 = 0, $73 = 0, $79 = 0;
  $4 = global$0 - 80 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    if (!$1) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h4fe5a3e1c18388b1($4 + 24 | 0 | 0, $1 | 0);
    $1 = HEAP32[($4 + 28 | 0) >> 2] | 0;
    $5 = HEAP32[($4 + 24 | 0) >> 2] | 0;
    HEAP32[($4 + 40 | 0) >> 2] = $3;
    HEAP32[($4 + 36 | 0) >> 2] = $3;
    HEAP32[($4 + 32 | 0) >> 2] = $2;
    alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($4 + 16 | 0 | 0, $4 + 32 | 0 | 0);
    $3 = HEAP32[($4 + 20 | 0) >> 2] | 0;
    HEAP32[($4 + 68 | 0) >> 2] = $3;
    $2 = HEAP32[($4 + 16 | 0) >> 2] | 0;
    HEAP32[($4 + 64 | 0) >> 2] = $2;
    cardano_serialization_lib__crypto__AuxiliaryDataHash__to_bech32__hb41828f08d68318b($4 + 32 | 0 | 0, $5 | 0, $2 | 0, $3 | 0);
    core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_2($4 + 64 | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
    $1 = HEAP32[($4 + 36 | 0) >> 2] | 0;
    if ((HEAP32[($4 + 32 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    i64toi32_i32$2 = ($4 + 32 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $57 = i64toi32_i32$0;
    i64toi32_i32$0 = $4;
    HEAP32[($4 + 52 | 0) >> 2] = $57;
    HEAP32[($4 + 56 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($4 + 48 | 0) >> 2] = $1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($4 + 8 | 0 | 0, $4 + 48 | 0 | 0);
    HEAP32[(($4 + 64 | 0) + 8 | 0) >> 2] = HEAP32[(($4 + 48 | 0) + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 48 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($4 + 52 | 0) >> 2] | 0;
    $73 = i64toi32_i32$1;
    i64toi32_i32$1 = $4;
    HEAP32[($4 + 64 | 0) >> 2] = $73;
    HEAP32[($4 + 68 | 0) >> 2] = i64toi32_i32$0;
    alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($4 | 0, $4 + 64 | 0 | 0);
    i64toi32_i32$2 = $4;
    i64toi32_i32$0 = HEAP32[$4 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
    $79 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[i64toi32_i32$0 >> 2] = $79;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    global$0 = $4 + 80 | 0;
    return;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
  abort();
 }
 
 function poolmetadatahash_to_bech32($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $5 = 0, $57 = 0, $73 = 0, $79 = 0;
  $4 = global$0 - 80 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    if (!$1) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h6bd3a1ad9f257a81($4 + 24 | 0 | 0, $1 | 0);
    $1 = HEAP32[($4 + 28 | 0) >> 2] | 0;
    $5 = HEAP32[($4 + 24 | 0) >> 2] | 0;
    HEAP32[($4 + 40 | 0) >> 2] = $3;
    HEAP32[($4 + 36 | 0) >> 2] = $3;
    HEAP32[($4 + 32 | 0) >> 2] = $2;
    alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($4 + 16 | 0 | 0, $4 + 32 | 0 | 0);
    $3 = HEAP32[($4 + 20 | 0) >> 2] | 0;
    HEAP32[($4 + 68 | 0) >> 2] = $3;
    $2 = HEAP32[($4 + 16 | 0) >> 2] | 0;
    HEAP32[($4 + 64 | 0) >> 2] = $2;
    cardano_serialization_lib__crypto__PoolMetadataHash__to_bech32__h104255386e83c6a6($4 + 32 | 0 | 0, $5 | 0, $2 | 0, $3 | 0);
    core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_2($4 + 64 | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
    $1 = HEAP32[($4 + 36 | 0) >> 2] | 0;
    if ((HEAP32[($4 + 32 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    i64toi32_i32$2 = ($4 + 32 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $57 = i64toi32_i32$0;
    i64toi32_i32$0 = $4;
    HEAP32[($4 + 52 | 0) >> 2] = $57;
    HEAP32[($4 + 56 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($4 + 48 | 0) >> 2] = $1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($4 + 8 | 0 | 0, $4 + 48 | 0 | 0);
    HEAP32[(($4 + 64 | 0) + 8 | 0) >> 2] = HEAP32[(($4 + 48 | 0) + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 48 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($4 + 52 | 0) >> 2] | 0;
    $73 = i64toi32_i32$1;
    i64toi32_i32$1 = $4;
    HEAP32[($4 + 64 | 0) >> 2] = $73;
    HEAP32[($4 + 68 | 0) >> 2] = i64toi32_i32$0;
    alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($4 | 0, $4 + 64 | 0 | 0);
    i64toi32_i32$2 = $4;
    i64toi32_i32$0 = HEAP32[$4 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
    $79 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[i64toi32_i32$0 >> 2] = $79;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    global$0 = $4 + 80 | 0;
    return;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
  abort();
 }
 
 function vrfkeyhash_to_bech32($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $5 = 0, $57 = 0, $73 = 0, $79 = 0;
  $4 = global$0 - 80 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    if (!$1) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__hb2360c57549df4d5($4 + 24 | 0 | 0, $1 | 0);
    $1 = HEAP32[($4 + 28 | 0) >> 2] | 0;
    $5 = HEAP32[($4 + 24 | 0) >> 2] | 0;
    HEAP32[($4 + 40 | 0) >> 2] = $3;
    HEAP32[($4 + 36 | 0) >> 2] = $3;
    HEAP32[($4 + 32 | 0) >> 2] = $2;
    alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($4 + 16 | 0 | 0, $4 + 32 | 0 | 0);
    $3 = HEAP32[($4 + 20 | 0) >> 2] | 0;
    HEAP32[($4 + 68 | 0) >> 2] = $3;
    $2 = HEAP32[($4 + 16 | 0) >> 2] | 0;
    HEAP32[($4 + 64 | 0) >> 2] = $2;
    cardano_serialization_lib__crypto__VRFKeyHash__to_bech32__h2782bba247e4ff4a($4 + 32 | 0 | 0, $5 | 0, $2 | 0, $3 | 0);
    core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_2($4 + 64 | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
    $1 = HEAP32[($4 + 36 | 0) >> 2] | 0;
    if ((HEAP32[($4 + 32 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    i64toi32_i32$2 = ($4 + 32 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $57 = i64toi32_i32$0;
    i64toi32_i32$0 = $4;
    HEAP32[($4 + 52 | 0) >> 2] = $57;
    HEAP32[($4 + 56 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($4 + 48 | 0) >> 2] = $1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($4 + 8 | 0 | 0, $4 + 48 | 0 | 0);
    HEAP32[(($4 + 64 | 0) + 8 | 0) >> 2] = HEAP32[(($4 + 48 | 0) + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 48 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($4 + 52 | 0) >> 2] | 0;
    $73 = i64toi32_i32$1;
    i64toi32_i32$1 = $4;
    HEAP32[($4 + 64 | 0) >> 2] = $73;
    HEAP32[($4 + 68 | 0) >> 2] = i64toi32_i32$0;
    alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($4 | 0, $4 + 64 | 0 | 0);
    i64toi32_i32$2 = $4;
    i64toi32_i32$0 = HEAP32[$4 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
    $79 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[i64toi32_i32$0 >> 2] = $79;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    global$0 = $4 + 80 | 0;
    return;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
  abort();
 }
 
 function blockhash_to_bech32($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $5 = 0, $57 = 0, $73 = 0, $79 = 0;
  $4 = global$0 - 80 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    if (!$1) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h449d6579c00e5aca($4 + 24 | 0 | 0, $1 | 0);
    $1 = HEAP32[($4 + 28 | 0) >> 2] | 0;
    $5 = HEAP32[($4 + 24 | 0) >> 2] | 0;
    HEAP32[($4 + 40 | 0) >> 2] = $3;
    HEAP32[($4 + 36 | 0) >> 2] = $3;
    HEAP32[($4 + 32 | 0) >> 2] = $2;
    alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($4 + 16 | 0 | 0, $4 + 32 | 0 | 0);
    $3 = HEAP32[($4 + 20 | 0) >> 2] | 0;
    HEAP32[($4 + 68 | 0) >> 2] = $3;
    $2 = HEAP32[($4 + 16 | 0) >> 2] | 0;
    HEAP32[($4 + 64 | 0) >> 2] = $2;
    cardano_serialization_lib__crypto__BlockHash__to_bech32__h6e6c8be6807230d3($4 + 32 | 0 | 0, $5 | 0, $2 | 0, $3 | 0);
    core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_2($4 + 64 | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
    $1 = HEAP32[($4 + 36 | 0) >> 2] | 0;
    if ((HEAP32[($4 + 32 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    i64toi32_i32$2 = ($4 + 32 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $57 = i64toi32_i32$0;
    i64toi32_i32$0 = $4;
    HEAP32[($4 + 52 | 0) >> 2] = $57;
    HEAP32[($4 + 56 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($4 + 48 | 0) >> 2] = $1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($4 + 8 | 0 | 0, $4 + 48 | 0 | 0);
    HEAP32[(($4 + 64 | 0) + 8 | 0) >> 2] = HEAP32[(($4 + 48 | 0) + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 48 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($4 + 52 | 0) >> 2] | 0;
    $73 = i64toi32_i32$1;
    i64toi32_i32$1 = $4;
    HEAP32[($4 + 64 | 0) >> 2] = $73;
    HEAP32[($4 + 68 | 0) >> 2] = i64toi32_i32$0;
    alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($4 | 0, $4 + 64 | 0 | 0);
    i64toi32_i32$2 = $4;
    i64toi32_i32$0 = HEAP32[$4 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
    $79 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[i64toi32_i32$0 >> 2] = $79;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    global$0 = $4 + 80 | 0;
    return;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
  abort();
 }
 
 function datahash_to_bech32($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $5 = 0, $57 = 0, $73 = 0, $79 = 0;
  $4 = global$0 - 80 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    if (!$1) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__hf03f8ea4201fce5b($4 + 24 | 0 | 0, $1 | 0);
    $1 = HEAP32[($4 + 28 | 0) >> 2] | 0;
    $5 = HEAP32[($4 + 24 | 0) >> 2] | 0;
    HEAP32[($4 + 40 | 0) >> 2] = $3;
    HEAP32[($4 + 36 | 0) >> 2] = $3;
    HEAP32[($4 + 32 | 0) >> 2] = $2;
    alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($4 + 16 | 0 | 0, $4 + 32 | 0 | 0);
    $3 = HEAP32[($4 + 20 | 0) >> 2] | 0;
    HEAP32[($4 + 68 | 0) >> 2] = $3;
    $2 = HEAP32[($4 + 16 | 0) >> 2] | 0;
    HEAP32[($4 + 64 | 0) >> 2] = $2;
    cardano_serialization_lib__crypto__DataHash__to_bech32__h80ffb4e1c54d9836($4 + 32 | 0 | 0, $5 | 0, $2 | 0, $3 | 0);
    core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_2($4 + 64 | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
    $1 = HEAP32[($4 + 36 | 0) >> 2] | 0;
    if ((HEAP32[($4 + 32 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    i64toi32_i32$2 = ($4 + 32 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $57 = i64toi32_i32$0;
    i64toi32_i32$0 = $4;
    HEAP32[($4 + 52 | 0) >> 2] = $57;
    HEAP32[($4 + 56 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($4 + 48 | 0) >> 2] = $1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($4 + 8 | 0 | 0, $4 + 48 | 0 | 0);
    HEAP32[(($4 + 64 | 0) + 8 | 0) >> 2] = HEAP32[(($4 + 48 | 0) + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 48 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($4 + 52 | 0) >> 2] | 0;
    $73 = i64toi32_i32$1;
    i64toi32_i32$1 = $4;
    HEAP32[($4 + 64 | 0) >> 2] = $73;
    HEAP32[($4 + 68 | 0) >> 2] = i64toi32_i32$0;
    alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($4 | 0, $4 + 64 | 0 | 0);
    i64toi32_i32$2 = $4;
    i64toi32_i32$0 = HEAP32[$4 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
    $79 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[i64toi32_i32$0 >> 2] = $79;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    global$0 = $4 + 80 | 0;
    return;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
  abort();
 }
 
 function scriptdatahash_to_bech32($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $5 = 0, $57 = 0, $73 = 0, $79 = 0;
  $4 = global$0 - 80 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    if (!$1) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h6b7eaec1bcfb1ff8($4 + 24 | 0 | 0, $1 | 0);
    $1 = HEAP32[($4 + 28 | 0) >> 2] | 0;
    $5 = HEAP32[($4 + 24 | 0) >> 2] | 0;
    HEAP32[($4 + 40 | 0) >> 2] = $3;
    HEAP32[($4 + 36 | 0) >> 2] = $3;
    HEAP32[($4 + 32 | 0) >> 2] = $2;
    alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($4 + 16 | 0 | 0, $4 + 32 | 0 | 0);
    $3 = HEAP32[($4 + 20 | 0) >> 2] | 0;
    HEAP32[($4 + 68 | 0) >> 2] = $3;
    $2 = HEAP32[($4 + 16 | 0) >> 2] | 0;
    HEAP32[($4 + 64 | 0) >> 2] = $2;
    cardano_serialization_lib__crypto__ScriptDataHash__to_bech32__h3992687932b4f633($4 + 32 | 0 | 0, $5 | 0, $2 | 0, $3 | 0);
    core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_2($4 + 64 | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
    $1 = HEAP32[($4 + 36 | 0) >> 2] | 0;
    if ((HEAP32[($4 + 32 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    i64toi32_i32$2 = ($4 + 32 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $57 = i64toi32_i32$0;
    i64toi32_i32$0 = $4;
    HEAP32[($4 + 52 | 0) >> 2] = $57;
    HEAP32[($4 + 56 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($4 + 48 | 0) >> 2] = $1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($4 + 8 | 0 | 0, $4 + 48 | 0 | 0);
    HEAP32[(($4 + 64 | 0) + 8 | 0) >> 2] = HEAP32[(($4 + 48 | 0) + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 48 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($4 + 52 | 0) >> 2] | 0;
    $73 = i64toi32_i32$1;
    i64toi32_i32$1 = $4;
    HEAP32[($4 + 64 | 0) >> 2] = $73;
    HEAP32[($4 + 68 | 0) >> 2] = i64toi32_i32$0;
    alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($4 | 0, $4 + 64 | 0 | 0);
    i64toi32_i32$2 = $4;
    i64toi32_i32$0 = HEAP32[$4 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
    $79 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[i64toi32_i32$0 >> 2] = $79;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    global$0 = $4 + 80 | 0;
    return;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
  abort();
 }
 
 function vrfvkey_to_bech32($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $5 = 0, $57 = 0, $73 = 0, $79 = 0;
  $4 = global$0 - 80 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    if (!$1) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h358f17571789b373($4 + 24 | 0 | 0, $1 | 0);
    $1 = HEAP32[($4 + 28 | 0) >> 2] | 0;
    $5 = HEAP32[($4 + 24 | 0) >> 2] | 0;
    HEAP32[($4 + 40 | 0) >> 2] = $3;
    HEAP32[($4 + 36 | 0) >> 2] = $3;
    HEAP32[($4 + 32 | 0) >> 2] = $2;
    alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($4 + 16 | 0 | 0, $4 + 32 | 0 | 0);
    $3 = HEAP32[($4 + 20 | 0) >> 2] | 0;
    HEAP32[($4 + 68 | 0) >> 2] = $3;
    $2 = HEAP32[($4 + 16 | 0) >> 2] | 0;
    HEAP32[($4 + 64 | 0) >> 2] = $2;
    cardano_serialization_lib__crypto__VRFVKey__to_bech32__h19adebd14626c989($4 + 32 | 0 | 0, $5 | 0, $2 | 0, $3 | 0);
    core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_2($4 + 64 | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
    $1 = HEAP32[($4 + 36 | 0) >> 2] | 0;
    if ((HEAP32[($4 + 32 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    i64toi32_i32$2 = ($4 + 32 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $57 = i64toi32_i32$0;
    i64toi32_i32$0 = $4;
    HEAP32[($4 + 52 | 0) >> 2] = $57;
    HEAP32[($4 + 56 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($4 + 48 | 0) >> 2] = $1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($4 + 8 | 0 | 0, $4 + 48 | 0 | 0);
    HEAP32[(($4 + 64 | 0) + 8 | 0) >> 2] = HEAP32[(($4 + 48 | 0) + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 48 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($4 + 52 | 0) >> 2] | 0;
    $73 = i64toi32_i32$1;
    i64toi32_i32$1 = $4;
    HEAP32[($4 + 64 | 0) >> 2] = $73;
    HEAP32[($4 + 68 | 0) >> 2] = i64toi32_i32$0;
    alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($4 | 0, $4 + 64 | 0 | 0);
    i64toi32_i32$2 = $4;
    i64toi32_i32$0 = HEAP32[$4 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
    $79 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[i64toi32_i32$0 >> 2] = $79;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    global$0 = $4 + 80 | 0;
    return;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
  abort();
 }
 
 function kesvkey_to_bech32($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $5 = 0, $57 = 0, $73 = 0, $79 = 0;
  $4 = global$0 - 80 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    if (!$1) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h78f278b481f170f8($4 + 24 | 0 | 0, $1 | 0);
    $1 = HEAP32[($4 + 28 | 0) >> 2] | 0;
    $5 = HEAP32[($4 + 24 | 0) >> 2] | 0;
    HEAP32[($4 + 40 | 0) >> 2] = $3;
    HEAP32[($4 + 36 | 0) >> 2] = $3;
    HEAP32[($4 + 32 | 0) >> 2] = $2;
    alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($4 + 16 | 0 | 0, $4 + 32 | 0 | 0);
    $3 = HEAP32[($4 + 20 | 0) >> 2] | 0;
    HEAP32[($4 + 68 | 0) >> 2] = $3;
    $2 = HEAP32[($4 + 16 | 0) >> 2] | 0;
    HEAP32[($4 + 64 | 0) >> 2] = $2;
    cardano_serialization_lib__crypto__KESVKey__to_bech32__h403d0a9a0cfb94ca($4 + 32 | 0 | 0, $5 | 0, $2 | 0, $3 | 0);
    core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_2($4 + 64 | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
    $1 = HEAP32[($4 + 36 | 0) >> 2] | 0;
    if ((HEAP32[($4 + 32 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    i64toi32_i32$2 = ($4 + 32 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $57 = i64toi32_i32$0;
    i64toi32_i32$0 = $4;
    HEAP32[($4 + 52 | 0) >> 2] = $57;
    HEAP32[($4 + 56 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($4 + 48 | 0) >> 2] = $1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($4 + 8 | 0 | 0, $4 + 48 | 0 | 0);
    HEAP32[(($4 + 64 | 0) + 8 | 0) >> 2] = HEAP32[(($4 + 48 | 0) + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 48 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($4 + 52 | 0) >> 2] | 0;
    $73 = i64toi32_i32$1;
    i64toi32_i32$1 = $4;
    HEAP32[($4 + 64 | 0) >> 2] = $73;
    HEAP32[($4 + 68 | 0) >> 2] = i64toi32_i32$0;
    alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($4 | 0, $4 + 64 | 0 | 0);
    i64toi32_i32$2 = $4;
    i64toi32_i32$0 = HEAP32[$4 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
    $79 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[i64toi32_i32$0 >> 2] = $79;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    global$0 = $4 + 80 | 0;
    return;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
  abort();
 }
 
 function hashbrown__map__HashMap_K_2cV_2cS_2cA___contains_key__h0a193e832d1442fa($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $9 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  i64toi32_i32$0 = hashbrown__map__make_hash__ha12e1e34616aa6c4($0 | 0, $1 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $3 = i64toi32_i32$0;
  $4 = (HEAP32[($0 + 16 | 0) >> 2] | 0) & $3 | 0;
  $9 = (HEAP32[($0 + 20 | 0) >> 2] | 0) + $4 | 0;
  $5 = HEAPU8[$9 >> 0] | 0 | ((HEAPU8[($9 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($9 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($9 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $6 = 0;
  HEAP32[($2 + 32 | 0) >> 2] = 0;
  HEAP32[($2 + 36 | 0) >> 2] = $5;
  HEAP32[($2 + 28 | 0) >> 2] = $4;
  HEAP32[($2 + 24 | 0) >> 2] = $0 + 16 | 0;
  $0 = $3 >>> 25 | 0;
  HEAP8[($2 + 44 | 0) >> 0] = $0;
  $0 = $5 ^ Math_imul($0, 16843009) | 0;
  HEAP32[($2 + 40 | 0) >> 2] = (($0 ^ -1 | 0) & ($0 + -16843009 | 0) | 0) & -2139062144 | 0;
  $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($2 + 16 | 0 | 0, $2 + 24 | 0 | 0);
  label$1 : {
   if (!(HEAP32[($2 + 16 | 0) >> 2] | 0)) {
    break label$1
   }
   label$2 : {
    if (!(memcmp($1 | 0, HEAP32[(((HEAP32[((HEAP32[($2 + 24 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) - ((HEAP32[($2 + 20 | 0) >> 2] | 0) << 3 | 0) | 0) + -8 | 0) >> 2] | 0 | 0, 28 | 0) | 0)) {
     break label$2
    }
    label$3 : while (1) {
     $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($2 + 8 | 0 | 0, $2 + 24 | 0 | 0);
     if (!(HEAP32[($2 + 8 | 0) >> 2] | 0)) {
      break label$1
     }
     if (memcmp($1 | 0, HEAP32[(((HEAP32[((HEAP32[($2 + 24 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0) - ((HEAP32[($2 + 12 | 0) >> 2] | 0) << 3 | 0) | 0) + -8 | 0) >> 2] | 0 | 0, 28 | 0) | 0) {
      continue label$3
     }
     break label$3;
    };
   }
   $6 = 1;
  }
  global$0 = $2 + 48 | 0;
  return $6 | 0;
 }
 
 function cardano_serialization_lib__address__variable_nat_encode__ha168666c0b6604c7($0, $1, $1$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $1$hi = $1$hi | 0;
  var $3 = 0, i64toi32_i32$4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $4 = 0, $2 = 0, i64toi32_i32$3 = 0, $12 = 0, $13 = 0, $5 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   $3 = __rust_alloc(1 | 0, 1 | 0) | 0;
   if (!$3) {
    break label$1
   }
   i64toi32_i32$0 = $1$hi;
   i64toi32_i32$0 = $1$hi;
   HEAP8[$3 >> 0] = $1 & 127 | 0;
   alloc__slice__hack__into_vec__h7c95d082cf6730ee($0 | 0, $3 | 0, 1 | 0);
   label$2 : {
    i64toi32_i32$0 = $1$hi;
    i64toi32_i32$0 = $1$hi;
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = 0;
    i64toi32_i32$3 = 7;
    i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$1 = 0;
     $12 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
    } else {
     i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
     $12 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
    }
    $1 = $12;
    $1$hi = i64toi32_i32$1;
    if (!($1 | i64toi32_i32$1 | 0)) {
     break label$2
    }
    $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
    label$3 : while (1) {
     i64toi32_i32$1 = $1$hi;
     $4 = $1 | -128 | 0;
     label$4 : {
      if (($3 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
       break label$4
      }
      alloc__vec__Vec_T_2cA___reserve__h9cf757d86af8f187($0 | 0, 1 | 0);
      $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
     }
     HEAP8[((HEAP32[$0 >> 2] | 0) + $3 | 0) >> 0] = $4;
     $3 = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
     HEAP32[($0 + 8 | 0) >> 2] = $3;
     i64toi32_i32$1 = $1$hi;
     i64toi32_i32$0 = $1;
     i64toi32_i32$2 = 0;
     i64toi32_i32$3 = 7;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$2 = 0;
      $13 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
     } else {
      i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
      $13 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
     }
     $1 = $13;
     $1$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $1$hi;
     i64toi32_i32$2 = $1$hi;
     if (!!($1 | $1$hi | 0)) {
      continue label$3
     }
     break label$3;
    };
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__DerefMut___deref_mut__h1882e042320a120c($2 + 8 | 0 | 0, $0 | 0);
   label$5 : {
    $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $4 = $3 >>> 1 | 0;
    if (!$4) {
     break label$5
    }
    $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    $3 = ($3 + $0 | 0) + -1 | 0;
    label$6 : while (1) {
     $5 = HEAPU8[$0 >> 0] | 0;
     HEAP8[$0 >> 0] = HEAPU8[$3 >> 0] | 0;
     HEAP8[$3 >> 0] = $5;
     $0 = $0 + 1 | 0;
     $3 = $3 + -1 | 0;
     $4 = $4 + -1 | 0;
     if ($4) {
      continue label$6
     }
     break label$6;
    };
   }
   global$0 = $2 + 16 | 0;
   return;
  }
  $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
  alloc__alloc__handle_alloc_error__he269d8f1bff90960(1 | 0, 1 | 0);
  abort();
 }
 
 function cardano_serialization_lib__AuxiliaryDataSet__get__h06d3a8c795ea3669($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $4 = 0, $59 = 0, $62 = 0;
  $3 = global$0 - 144 | 0;
  global$0 = $3;
  HEAP32[($3 + 4 | 0) >> 2] = $2;
  label$1 : {
   label$2 : {
    $1 = linked_hash_map__LinkedHashMap_K_2cV_2cS___get__had20bd8f0f401fc5($1 | 0, $3 + 4 | 0 | 0) | 0;
    if ($1) {
     break label$2
    }
    i64toi32_i32$1 = $0;
    i64toi32_i32$0 = 0;
    HEAP32[i64toi32_i32$1 >> 2] = 0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    break label$1;
   }
   label$3 : {
    label$4 : {
     if (HEAP32[($1 + 20 | 0) >> 2] | 0) {
      break label$4
     }
     HEAP32[($3 + 92 | 0) >> 2] = 0;
     break label$3;
    }
    $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h44c6d4679ef9fae6($3 + 72 | 0 | 0, $1 | 0);
   }
   $2 = $1 + 52 | 0;
   label$5 : {
    label$6 : {
     $4 = HEAP32[($1 + 40 | 0) >> 2] | 0;
     if ($4) {
      break label$6
     }
     HEAP32[($3 + 112 | 0) >> 2] = 0;
     break label$5;
    }
    alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($3 + 112 | 0 | 0, $4 | 0, HEAP32[($1 + 48 | 0) >> 2] | 0 | 0);
   }
   label$7 : {
    label$8 : {
     if (HEAP32[$2 >> 2] | 0) {
      break label$8
     }
     HEAP32[($3 + 128 | 0) >> 2] = 0;
     break label$7;
    }
    $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hc722e22117ee5940($3 + 128 | 0 | 0, $2 | 0);
   }
   memcpy($3 + 8 | 0 | 0, $3 + 72 | 0 | 0, 40 | 0) | 0;
   HEAP32[($3 + 56 | 0) >> 2] = HEAP32[(($3 + 112 | 0) + 8 | 0) >> 2] | 0;
   HEAP32[($3 + 68 | 0) >> 2] = HEAP32[(($3 + 128 | 0) + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($3 + 112 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($3 + 116 | 0) >> 2] | 0;
   $59 = i64toi32_i32$0;
   i64toi32_i32$0 = $3;
   HEAP32[($3 + 48 | 0) >> 2] = $59;
   HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = HEAP32[($3 + 128 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($3 + 132 | 0) >> 2] | 0;
   $62 = i64toi32_i32$1;
   i64toi32_i32$1 = $3;
   HEAP32[($3 + 60 | 0) >> 2] = $62;
   HEAP32[($3 + 64 | 0) >> 2] = i64toi32_i32$0;
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 64 | 0) | 0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[i64toi32_i32$1 >> 2] = 1;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  }
  global$0 = $3 + 144 | 0;
 }
 
 function nonce_get_hash($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $2 = 0, $4 = 0, $5 = 0, $6 = 0, $6$hi = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $3 = 0, $7 = 0, $7$hi = 0, $8 = 0, $8$hi = 0, $9 = 0, $9$hi = 0, $42 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if (!$1) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h0e158f5408360d02($2 + 24 | 0 | 0, $1 | 0);
   $3 = 0;
   i64toi32_i32$0 = 32;
   $6 = 0;
   $6$hi = i64toi32_i32$0;
   $4 = HEAP32[($2 + 28 | 0) >> 2] | 0;
   $1 = 0;
   label$2 : {
    $5 = HEAP32[($2 + 24 | 0) >> 2] | 0;
    if ((HEAPU8[$5 >> 0] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 + 16 | 0 | 0, 32 | 0, 0 | 0);
    i64toi32_i32$2 = $5 + 9 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $6 = i64toi32_i32$0;
    $6$hi = i64toi32_i32$1;
    i64toi32_i32$2 = $5 + 17 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $7 = i64toi32_i32$1;
    $7$hi = i64toi32_i32$0;
    i64toi32_i32$2 = $5 + 25 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $8 = i64toi32_i32$0;
    $8$hi = i64toi32_i32$1;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
    i64toi32_i32$0 = 0;
    $9 = i64toi32_i32$1;
    $9$hi = i64toi32_i32$0;
    $1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
    i64toi32_i32$2 = $5;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $42 = i64toi32_i32$0;
    i64toi32_i32$0 = $1;
    $18 = $42;
    HEAP8[i64toi32_i32$0 >> 0] = $18;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $18 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $18 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $18 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$1 = $8$hi;
    i64toi32_i32$0 = i64toi32_i32$0 + 24 | 0;
    $19 = $8;
    HEAP8[i64toi32_i32$0 >> 0] = $19;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $19 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $19 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $19 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$1 = $7$hi;
    i64toi32_i32$0 = $1 + 16 | 0;
    $20 = $7;
    HEAP8[i64toi32_i32$0 >> 0] = $20;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $20 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $20 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $20 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$1 = $6$hi;
    i64toi32_i32$0 = $1 + 8 | 0;
    $21 = $6;
    HEAP8[i64toi32_i32$0 >> 0] = $21;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $21 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $21 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $21 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$1 = $9$hi;
    i64toi32_i32$2 = $9;
    i64toi32_i32$0 = 32;
    i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
    $6 = i64toi32_i32$2 | 0 | 0;
    $6$hi = i64toi32_i32$0;
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($4 | 0, (HEAP32[$4 >> 2] | 0) + -1 | 0 | 0) | 0;
   $4 = 0;
   label$3 : {
    if (!$1) {
     break label$3
    }
    i64toi32_i32$0 = $6$hi;
    i64toi32_i32$2 = $2;
    HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] = $6;
    HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] = $1;
    alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad(i64toi32_i32$2 + 8 | 0 | 0, i64toi32_i32$2 + 32 | 0 | 0);
    $3 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
    $4 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
   }
   HEAP32[($0 + 4 | 0) >> 2] = $3;
   HEAP32[$0 >> 2] = $4;
   global$0 = $2 + 48 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function cardano_serialization_lib__crypto__VRFCert__from_bytes__h505c8666ae31ef7b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $5 = 0, $18 = 0, $3$hi = 0, $4$hi = 0, $5$hi = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[(($2 + 152 | 0) + 16 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[(i64toi32_i32$1 + 152 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[(i64toi32_i32$0 + 160 | 0) >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 164 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__crypto__VRFCert_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__ha63b72084ea6ce59(i64toi32_i32$0 + 80 | 0 | 0, i64toi32_i32$0 + 152 | 0 | 0);
  $1 = (i64toi32_i32$0 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[(i64toi32_i32$0 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    i64toi32_i32$2 = ($2 + 80 | 0) + 20 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $3 = i64toi32_i32$1;
    $3$hi = i64toi32_i32$0;
    i64toi32_i32$1 = ($2 + 8 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = ($2 + 80 | 0) + 12 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $4 = i64toi32_i32$0;
    $4$hi = i64toi32_i32$1;
    i64toi32_i32$0 = ($2 + 8 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $4;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[($2 + 84 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    $5 = i64toi32_i32$1;
    $5$hi = i64toi32_i32$0;
    i64toi32_i32$1 = $2;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $5;
    HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = $3$hi;
    i64toi32_i32$1 = $0 + 20 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = $4$hi;
    i64toi32_i32$1 = $0 + 12 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $4;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = $5$hi;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $5;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 8 | 0 | 4 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hfe677107e1954f8f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $3 = 0, $5 = 0, $4 = 0, $6 = 0, $7 = 0, $8 = 0, $9 = 0, $43 = 0, $47 = 0, $51 = 0, $54 = 0, $61 = 0, $65 = 0, $69 = 0, $73 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  $3 = HEAP32[$1 >> 2] | 0;
  $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h8bef2550156a85eb($2 + 8 | 0 | 0, $4 | 0, 0 | 0);
  $1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  $5 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $5;
  HEAP32[$0 >> 2] = $1;
  label$1 : {
   if (!$5) {
    break label$1
   }
   $6 = Math_imul($4, 36);
   $7 = $2 + 40 | 0;
   $8 = $2 + 32 | 0;
   $9 = $2 + 24 | 0;
   label$2 : while (1) {
    if (!$6) {
     break label$1
    }
    i64toi32_i32$2 = $3 + 28 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $43 = i64toi32_i32$0;
    i64toi32_i32$0 = $7;
    HEAP32[i64toi32_i32$0 >> 2] = $43;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $3 + 20 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $47 = i64toi32_i32$1;
    i64toi32_i32$1 = $8;
    HEAP32[i64toi32_i32$1 >> 2] = $47;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $3 + 12 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $51 = i64toi32_i32$0;
    i64toi32_i32$0 = $9;
    HEAP32[i64toi32_i32$0 >> 2] = $51;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
    $54 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $54;
    HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[$1 >> 2] = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$2 = $7;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $61 = i64toi32_i32$0;
    i64toi32_i32$0 = $1 + 28 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $61;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $8;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $65 = i64toi32_i32$1;
    i64toi32_i32$1 = $1 + 20 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $65;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $9;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $69 = i64toi32_i32$0;
    i64toi32_i32$0 = $1 + 12 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $69;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
    $73 = i64toi32_i32$1;
    i64toi32_i32$1 = $1 + 4 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $73;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    $1 = $1 + 36 | 0;
    $6 = $6 + -36 | 0;
    $3 = $3 + 36 | 0;
    $5 = $5 + -1 | 0;
    if ($5) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 8 | 0) >> 2] = $4;
  global$0 = $2 + 48 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___grow_amortized__hb7acd97bd3480761($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, $5 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, $14 = 0, $6 = 0, $6$hi = 0, $71 = 0;
  $4 = global$0 - 32 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    $3 = $2 + $3 | 0;
    if ($3 >>> 0 < $2 >>> 0) {
     break label$2
    }
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $5 = $2 << 1 | 0;
    $3 = $5 >>> 0 > $3 >>> 0 ? $5 : $3;
    i64toi32_i32$0 = 0;
    i64toi32_i32$1 = 0;
    i64toi32_i32$1 = __wasm_i64_mul(($3 >>> 0 > 4 >>> 0 ? $3 : 4) | 0, i64toi32_i32$0 | 0, 24 | 0, i64toi32_i32$1 | 0) | 0;
    i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
    $6 = i64toi32_i32$1;
    $6$hi = i64toi32_i32$0;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    i64toi32_i32$3 = 32;
    i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$1 = 0;
     $14 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
    } else {
     i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
     $14 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
    }
    $3 = !$14 << 3 | 0;
    i64toi32_i32$1 = $6$hi;
    $5 = $6;
    label$3 : {
     label$4 : {
      if (!$2) {
       break label$4
      }
      HEAP32[(($4 + 16 | 0) + 8 | 0) >> 2] = 8;
      HEAP32[($4 + 20 | 0) >> 2] = Math_imul($2, 24);
      HEAP32[($4 + 16 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
      break label$3;
     }
     HEAP32[($4 + 16 | 0) >> 2] = 0;
    }
    alloc__raw_vec__finish_grow__h9cca7d8a9459b8aa($4 | 0, $5 | 0, $3 | 0, $4 + 16 | 0 | 0, $4 | 0);
    $2 = 1;
    label$5 : {
     if ((HEAP32[$4 >> 2] | 0 | 0) == (1 | 0)) {
      break label$5
     }
     $2 = HEAP32[($4 + 4 | 0) >> 2] | 0;
     HEAP32[($1 + 4 | 0) >> 2] = ((HEAP32[($4 + 8 | 0) >> 2] | 0) >>> 0) / (24 >>> 0) | 0;
     HEAP32[$1 >> 2] = $2;
     $2 = 0;
     break label$1;
    }
    i64toi32_i32$0 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    $71 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $71;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$2;
    break label$1;
   }
   HEAP32[($0 + 4 | 0) >> 2] = $3;
   HEAP32[($0 + 8 | 0) >> 2] = 0;
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $4 + 32 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__KV___split__h520fcc98c2e1fbd6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $7 = 0, $5 = 0, $4 = 0, $6 = 0, $2 = 0, $3 = 0, $8 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $81 = 0;
  $2 = global$0 - 144 | 0;
  global$0 = $2;
  $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $4 = HEAPU16[($3 + 1546 | 0) >> 1] | 0;
  $5 = alloc__boxed__Box_T_2cA___new_uninit_in__h57df8859addacc9a() | 0;
  HEAP16[($5 + 1546 | 0) >> 1] = 0;
  HEAP32[($5 + 1408 | 0) >> 2] = 0;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__h0abcb8857d38a300($2 | 0, $1 | 0, $5 | 0);
  $6 = HEAPU16[($5 + 1546 | 0) >> 1] | 0;
  $7 = $6 + 1 | 0;
  label$1 : {
   label$2 : {
    if ($6 >>> 0 >= 12 >>> 0) {
     break label$2
    }
    $8 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    $4 = $4 - $8 | 0;
    if (($4 | 0) != ($7 | 0)) {
     break label$1
    }
    memcpy($5 + 1552 | 0 | 0, (($8 << 2 | 0) + $3 | 0) + 1556 | 0 | 0, $4 << 2 | 0 | 0) | 0;
    $3 = HEAP32[$1 >> 2] | 0;
    $7 = 0;
    label$3 : {
     label$4 : while (1) {
      $4 = HEAP32[(($5 + ($7 << 2 | 0) | 0) + 1552 | 0) >> 2] | 0;
      HEAP16[($4 + 1544 | 0) >> 1] = $7;
      HEAP32[($4 + 1408 | 0) >> 2] = $5;
      if ($7 >>> 0 >= $6 >>> 0) {
       break label$3
      }
      $7 = $7 + ($7 >>> 0 < $6 >>> 0) | 0;
      if ($7 >>> 0 <= $6 >>> 0) {
       continue label$4
      }
      break label$4;
     };
    }
    i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $7 = memcpy($0 | 0, $2 | 0, 144 | 0) | 0;
    HEAP32[($7 + 156 | 0) >> 2] = $5;
    HEAP32[($7 + 152 | 0) >> 2] = $3;
    $81 = i64toi32_i32$0;
    i64toi32_i32$0 = $7;
    HEAP32[($7 + 144 | 0) >> 2] = $81;
    HEAP32[($7 + 148 | 0) >> 2] = i64toi32_i32$1;
    global$0 = $2 + 144 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($7 | 0, 12 | 0, 1049060 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1048988 | 0, 40 | 0, 1049028 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__KV___split__h8533c651584e4f97($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $7 = 0, $5 = 0, $4 = 0, $6 = 0, $2 = 0, $3 = 0, $8 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $81 = 0;
  $2 = global$0 - 96 | 0;
  global$0 = $2;
  $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $4 = HEAPU16[($3 + 1062 | 0) >> 1] | 0;
  $5 = alloc__boxed__Box_T_2cA___new_uninit_in__hf8493d13156d19ba() | 0;
  HEAP16[($5 + 1062 | 0) >> 1] = 0;
  HEAP32[($5 + 1056 | 0) >> 2] = 0;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__ha79dc2b8000a6d62($2 | 0, $1 | 0, $5 | 0);
  $6 = HEAPU16[($5 + 1062 | 0) >> 1] | 0;
  $7 = $6 + 1 | 0;
  label$1 : {
   label$2 : {
    if ($6 >>> 0 >= 12 >>> 0) {
     break label$2
    }
    $8 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    $4 = $4 - $8 | 0;
    if (($4 | 0) != ($7 | 0)) {
     break label$1
    }
    memcpy($5 + 1064 | 0 | 0, (($8 << 2 | 0) + $3 | 0) + 1068 | 0 | 0, $4 << 2 | 0 | 0) | 0;
    $3 = HEAP32[$1 >> 2] | 0;
    $7 = 0;
    label$3 : {
     label$4 : while (1) {
      $4 = HEAP32[(($5 + ($7 << 2 | 0) | 0) + 1064 | 0) >> 2] | 0;
      HEAP16[($4 + 1060 | 0) >> 1] = $7;
      HEAP32[($4 + 1056 | 0) >> 2] = $5;
      if ($7 >>> 0 >= $6 >>> 0) {
       break label$3
      }
      $7 = $7 + ($7 >>> 0 < $6 >>> 0) | 0;
      if ($7 >>> 0 <= $6 >>> 0) {
       continue label$4
      }
      break label$4;
     };
    }
    i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $7 = memcpy($0 | 0, $2 | 0, 96 | 0) | 0;
    HEAP32[($7 + 108 | 0) >> 2] = $5;
    HEAP32[($7 + 104 | 0) >> 2] = $3;
    $81 = i64toi32_i32$0;
    i64toi32_i32$0 = $7;
    HEAP32[($7 + 96 | 0) >> 2] = $81;
    HEAP32[($7 + 100 | 0) >> 2] = i64toi32_i32$1;
    global$0 = $2 + 96 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($7 | 0, 12 | 0, 1049060 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1048988 | 0, 40 | 0, 1049028 | 0);
  abort();
 }
 
 function certificate_as_stake_registration($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $3 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $2 = 0, $5 = 0, $5$hi = 0, $4 = 0, $6 = 0, $6$hi = 0, $36 = 0, $57 = 0, $62 = 0, $72 = 0;
  $1 = global$0 - 112 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h3b62e22150831bdc($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   $2 = 2;
   label$2 : {
    $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    if (HEAPU8[$3 >> 0] | 0) {
     break label$2
    }
    i64toi32_i32$2 = $3 + 2 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $5 = i64toi32_i32$0;
    $5$hi = i64toi32_i32$1;
    $16 = $3 + 26 | 0;
    $4 = HEAPU8[$16 >> 0] | 0 | ((HEAPU8[($16 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($16 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($16 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$2 = $3 + 18 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $6 = i64toi32_i32$1;
    $6$hi = i64toi32_i32$0;
    $2 = HEAPU8[($3 + 1 | 0) >> 0] | 0;
    i64toi32_i32$2 = $3 + 10 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $36 = i64toi32_i32$0;
    i64toi32_i32$0 = $1 + 24 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $36;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $6$hi;
    i64toi32_i32$0 = $1 + 32 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $6;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($1 + 40 | 0) >> 2] = $4;
    i64toi32_i32$1 = $5$hi;
    i64toi32_i32$0 = $1;
    HEAP32[($1 + 16 | 0) >> 2] = $5;
    HEAP32[($1 + 20 | 0) >> 2] = i64toi32_i32$1;
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   $0 = 0;
   label$3 : {
    if (($2 & 255 | 0 | 0) == (2 | 0)) {
     break label$3
    }
    i64toi32_i32$2 = $1 + 24 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $57 = i64toi32_i32$1;
    i64toi32_i32$1 = $1 + 89 | 0;
    $17 = $57;
    HEAP8[i64toi32_i32$1 >> 0] = $17;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$2 = $1 + 32 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $62 = i64toi32_i32$0;
    i64toi32_i32$0 = $1 + 97 | 0;
    $18 = $62;
    HEAP8[i64toi32_i32$0 >> 0] = $18;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $18 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $18 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $18 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    $19 = $1 + 105 | 0;
    $20 = HEAP32[($1 + 40 | 0) >> 2] | 0;
    HEAP8[$19 >> 0] = $20;
    HEAP8[($19 + 1 | 0) >> 0] = $20 >>> 8 | 0;
    HEAP8[($19 + 2 | 0) >> 0] = $20 >>> 16 | 0;
    HEAP8[($19 + 3 | 0) >> 0] = $20 >>> 24 | 0;
    HEAP8[($1 + 80 | 0) >> 0] = $2;
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
    $72 = i64toi32_i32$1;
    i64toi32_i32$1 = i64toi32_i32$2;
    $21 = $72;
    HEAP8[(i64toi32_i32$2 + 81 | 0) >> 0] = $21;
    HEAP8[(i64toi32_i32$2 + 82 | 0) >> 0] = $21 >>> 8 | 0;
    HEAP8[(i64toi32_i32$2 + 83 | 0) >> 0] = $21 >>> 16 | 0;
    HEAP8[(i64toi32_i32$2 + 84 | 0) >> 0] = $21 >>> 24 | 0;
    HEAP8[(i64toi32_i32$2 + 85 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$2 + 86 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$2 + 87 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$2 + 88 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    $0 = $cardano_serialization_lib__StakeRegistration_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he3fe45f8c534c1bd(i64toi32_i32$2 + 80 | 0 | 0) | 0;
   }
   global$0 = $1 + 112 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function cardano_serialization_lib__tx_builder__TransactionBuilder__fee_for_output__h1f6d4a08a7683cf9($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, $4 = 0, $4$hi = 0, $5$hi = 0, $5 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $3 = global$0 - 544 | 0;
  global$0 = $3;
  $cardano_serialization_lib__tx_builder__TransactionBuilder_20as_20core__clone__Clone___clone__h4273e58f8bc63575($3 + 8 | 0 | 0, $1 | 0);
  i64toi32_i32$1 = $3 + 272 | 0;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  HEAP32[($3 + 264 | 0) >> 2] = 1;
  HEAP32[($3 + 268 | 0) >> 2] = i64toi32_i32$0;
  cardano_serialization_lib__tx_builder__min_fee__h8bb5ab8499f01c90($3 + 528 | 0 | 0, $3 + 8 | 0 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ((HEAP32[($3 + 528 | 0) >> 2] | 0 | 0) == (1 | 0)) {
        break label$5
       }
       i64toi32_i32$2 = $3 + 536 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $4 = i64toi32_i32$0;
       $4$hi = i64toi32_i32$1;
       cardano_serialization_lib__tx_builder__TransactionBuilder__add_output__h626cdf41f713b689($3 | 0, $3 + 8 | 0 | 0, $2 | 0);
       if (HEAP32[$3 >> 2] | 0) {
        break label$4
       }
       cardano_serialization_lib__tx_builder__min_fee__h8bb5ab8499f01c90($3 + 528 | 0 | 0, $3 + 8 | 0 | 0);
       if ((HEAP32[($3 + 528 | 0) >> 2] | 0 | 0) != (1 | 0)) {
        break label$3
       }
      }
      $1 = HEAP32[($3 + 532 | 0) >> 2] | 0;
      break label$2;
     }
     $1 = HEAP32[($3 + 4 | 0) >> 2] | 0;
     break label$2;
    }
    label$6 : {
     label$7 : {
      i64toi32_i32$2 = ($3 + 528 | 0) + 8 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $5 = i64toi32_i32$1;
      $5$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $4$hi;
      i64toi32_i32$0 = $5$hi;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$1 = $4$hi;
      i64toi32_i32$5 = (i64toi32_i32$2 >>> 0 < $4 >>> 0) + i64toi32_i32$1 | 0;
      i64toi32_i32$5 = i64toi32_i32$0 - i64toi32_i32$5 | 0;
      $4 = i64toi32_i32$2 - $4 | 0;
      $4$hi = i64toi32_i32$5;
      i64toi32_i32$5 = i64toi32_i32$0;
      i64toi32_i32$5 = $4$hi;
      i64toi32_i32$0 = $4;
      i64toi32_i32$2 = $5$hi;
      if (i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$0 >>> 0 <= $5 >>> 0 | 0) | 0) {
       break label$7
      }
      (wasm2js_i32$0 = $0, wasm2js_i32$1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1058740 | 0, 9 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
      $1 = 1;
      break label$6;
     }
     i64toi32_i32$0 = $4$hi;
     i64toi32_i32$5 = $0 + 8 | 0;
     HEAP32[i64toi32_i32$5 >> 2] = $4;
     HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
     $1 = 0;
    }
    HEAP32[$0 >> 2] = $1;
    core__ptr__drop_in_place_cardano_serialization_lib__tx_builder__TransactionBuilder___h053801e638e30160($3 + 8 | 0 | 0);
    break label$1;
   }
   $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($1 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   core__ptr__drop_in_place_cardano_serialization_lib__tx_builder__TransactionBuilder___h053801e638e30160($3 + 8 | 0 | 0);
  }
  global$0 = $3 + 544 | 0;
 }
 
 function serde_json__de__Deserializer_R___parse_number__h15009467721a2ef0($0, $1, $2, $3, $3$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  var i64toi32_i32$5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, $4 = 0, i64toi32_i32$2 = 0, $5 = 0, $7 = 0, $6 = 0, $6$hi = 0, $7$hi = 0, $15 = 0, $16 = 0, $17 = 0;
  $4 = global$0 - 16 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        $5 = HEAP32[($1 + 8 | 0) >> 2] | 0;
        if ($5 >>> 0 >= (HEAP32[($1 + 4 | 0) >> 2] | 0) >>> 0) {
         break label$6
        }
        $5 = HEAPU8[((HEAP32[$1 >> 2] | 0) + $5 | 0) >> 0] | 0;
        if (($5 | 0) == (46 | 0)) {
         break label$4
        }
        if (($5 | 0) == (69 | 0)) {
         break label$5
        }
        if (($5 | 0) == (101 | 0)) {
         break label$5
        }
       }
       i64toi32_i32$0 = 0;
       $6 = 1;
       $6$hi = i64toi32_i32$0;
       label$7 : {
        if (!$2) {
         break label$7
        }
        i64toi32_i32$0 = $3$hi;
        $7 = $3;
        $7$hi = i64toi32_i32$0;
        break label$2;
       }
       i64toi32_i32$0 = 0;
       $6 = 0;
       $6$hi = i64toi32_i32$0;
       label$8 : {
        i64toi32_i32$0 = $3$hi;
        i64toi32_i32$0 = 0;
        i64toi32_i32$2 = 0;
        i64toi32_i32$3 = $3;
        i64toi32_i32$5 = (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) + $3$hi | 0;
        i64toi32_i32$5 = i64toi32_i32$0 - i64toi32_i32$5 | 0;
        $7 = i64toi32_i32$2 - i64toi32_i32$3 | 0;
        $7$hi = i64toi32_i32$5;
        i64toi32_i32$0 = $7;
        i64toi32_i32$2 = 0;
        i64toi32_i32$3 = 1;
        if ((i64toi32_i32$5 | 0) > (i64toi32_i32$2 | 0)) {
         $15 = 1
        } else {
         if ((i64toi32_i32$5 | 0) >= (i64toi32_i32$2 | 0)) {
          if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
           $16 = 0
          } else {
           $16 = 1
          }
          $17 = $16;
         } else {
          $17 = 0
         }
         $15 = $17;
        }
        if ($15) {
         break label$8
        }
        i64toi32_i32$0 = 0;
        $6 = 2;
        $6$hi = i64toi32_i32$0;
        break label$2;
       }
       i64toi32_i32$0 = $3$hi;
       i64toi32_i32$5 = $3;
       i64toi32_i32$3 = 0;
       wasm2js_scratch_store_f64(+(+(i64toi32_i32$5 >>> 0) + 4294967296.0 * +(i64toi32_i32$0 >>> 0)));
       i64toi32_i32$0 = wasm2js_scratch_load_i32(1 | 0) | 0;
       i64toi32_i32$3 = wasm2js_scratch_load_i32(0 | 0) | 0;
       i64toi32_i32$5 = -2147483648;
       i64toi32_i32$2 = 0;
       i64toi32_i32$5 = i64toi32_i32$0 ^ i64toi32_i32$5 | 0;
       $7 = i64toi32_i32$3 ^ i64toi32_i32$2 | 0;
       $7$hi = i64toi32_i32$5;
       break label$2;
      }
      i64toi32_i32$5 = $3$hi;
      serde_json__de__Deserializer_R___parse_exponent__h64f12a2a919bb245($4 | 0, $1 | 0, $2 | 0, $3 | 0, i64toi32_i32$5 | 0, 0 | 0);
      if ((HEAP32[$4 >> 2] | 0 | 0) != (1 | 0)) {
       break label$3
      }
      HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($4 + 4 | 0) >> 2] | 0;
      HEAP32[$0 >> 2] = 1;
      break label$1;
     }
     i64toi32_i32$5 = $3$hi;
     serde_json__de__Deserializer_R___parse_decimal__he7ea9ce3065727b6($4 | 0, $1 | 0, $2 | 0, $3 | 0, i64toi32_i32$5 | 0, 0 | 0);
     if ((HEAP32[$4 >> 2] | 0 | 0) != (1 | 0)) {
      break label$3
     }
     HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($4 + 4 | 0) >> 2] | 0;
     HEAP32[$0 >> 2] = 1;
     break label$1;
    }
    i64toi32_i32$0 = $4;
    i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] | 0;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] | 0;
    $7 = i64toi32_i32$5;
    $7$hi = i64toi32_i32$3;
    i64toi32_i32$3 = 0;
    $6 = 0;
    $6$hi = i64toi32_i32$3;
   }
   HEAP32[$0 >> 2] = 0;
   i64toi32_i32$3 = $7$hi;
   i64toi32_i32$5 = $0 + 16 | 0;
   HEAP32[i64toi32_i32$5 >> 2] = $7;
   HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$3;
   i64toi32_i32$3 = $6$hi;
   i64toi32_i32$5 = $0 + 8 | 0;
   HEAP32[i64toi32_i32$5 >> 2] = $6;
   HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$3;
  }
  global$0 = $4 + 16 | 0;
 }
 
 function ed25519_bip32__key__XPrv__from_slice_verified__h3a93bc2e4b6227c9($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $13 = 0, $14 = 0, $15 = 0, $16 = 0, $3 = 0, $4 = 0, $5 = 0, $31 = 0, $39 = 0, $44 = 0, $49 = 0;
  $3 = global$0 - 96 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if (($2 | 0) != (96 | 0)) {
       break label$4
      }
      $2 = memset($3 | 0, 0 | 0, 96 | 0) | 0;
      core__slice___impl_20_5bT_5d___copy_from_slice__h0f69c19ed1852955($2 | 0, 96 | 0, $1 | 0, 96 | 0);
      $1 = 1;
      $4 = HEAPU8[($2 + 31 | 0) >> 0] | 0;
      if (($4 & 192 | 0 | 0) != (64 | 0)) {
       break label$3
      }
      label$5 : {
       $5 = HEAPU8[$2 >> 0] | 0;
       if ($5 & 7 | 0) {
        break label$5
       }
       HEAP8[($0 + 1 | 0) >> 0] = $5;
       $1 = $2 + 1 | 0;
       i64toi32_i32$2 = $1;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $31 = i64toi32_i32$0;
       i64toi32_i32$0 = $0 + 2 | 0;
       $13 = $31;
       HEAP8[i64toi32_i32$0 >> 0] = $13;
       HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $13 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $13 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $13 >>> 24 | 0;
       HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
       HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
       HEAP8[($0 + 32 | 0) >> 0] = $4;
       i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $39 = i64toi32_i32$1;
       i64toi32_i32$1 = $0 + 10 | 0;
       $14 = $39;
       HEAP8[i64toi32_i32$1 >> 0] = $14;
       HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $14 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $14 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $14 >>> 24 | 0;
       HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
       HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
       i64toi32_i32$2 = $1 + 16 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $44 = i64toi32_i32$0;
       i64toi32_i32$0 = $0 + 18 | 0;
       $15 = $44;
       HEAP8[i64toi32_i32$0 >> 0] = $15;
       HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $15 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $15 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $15 >>> 24 | 0;
       HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
       HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
       i64toi32_i32$2 = $1 + 22 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $49 = i64toi32_i32$1;
       i64toi32_i32$1 = $0 + 24 | 0;
       $16 = $49;
       HEAP8[i64toi32_i32$1 >> 0] = $16;
       HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $16 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $16 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $16 >>> 24 | 0;
       HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
       HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
       HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
       HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
       memcpy($0 + 33 | 0 | 0, $2 + 32 | 0 | 0, 64 | 0) | 0;
       $1 = 0;
       break label$2;
      }
      HEAP32[($0 + 4 | 0) >> 2] = 2;
      break label$2;
     }
     HEAP8[$0 >> 0] = 1;
     HEAP32[($0 + 8 | 0) >> 2] = $2;
     HEAP32[($0 + 4 | 0) >> 2] = 0;
     break label$1;
    }
    HEAP32[($0 + 4 | 0) >> 2] = 1;
   }
   HEAP8[$0 >> 0] = $1;
  }
  global$0 = $3 + 96 | 0;
 }
 
 function cryptoxide__blake2b__Blake2b__update__hecb3567baa77731d($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  label$1 : {
   if (HEAPU8[($0 + 288 | 0) >> 0] | 0) {
    break label$1
   }
   label$2 : {
    switch (HEAPU8[$0 >> 0] | 0 | 0) {
    default:
     cryptoxide__hashing__blake2b__Context_____update_mut__hd7b17262761d9f43($0 + 32 | 0 | 0, $1 | 0, $2 | 0);
     return;
    case 1:
     cryptoxide__hashing__blake2b__Context_____update_mut__h1a06f4ff4884cc19($0 + 32 | 0 | 0, $1 | 0, $2 | 0);
     return;
    case 2:
     cryptoxide__hashing__blake2b__Context_____update_mut__hd8132cf488b8b01a($0 + 32 | 0 | 0, $1 | 0, $2 | 0);
     return;
    case 3:
     cryptoxide__hashing__blake2b__Context_____update_mut__h7ace2e2bc9f5516f($0 + 32 | 0 | 0, $1 | 0, $2 | 0);
     return;
    case 4:
     cryptoxide__hashing__blake2b__Context_____update_mut__hdf71b0ccb149f090($0 + 32 | 0 | 0, $1 | 0, $2 | 0);
     return;
    case 5:
     cryptoxide__hashing__blake2b__Context_____update_mut__hdf71b0ccb149f090($0 + 32 | 0 | 0, $1 | 0, $2 | 0);
     return;
    case 6:
     cryptoxide__hashing__blake2b__Context_____update_mut__h977239665a489a29($0 + 32 | 0 | 0, $1 | 0, $2 | 0);
     return;
    case 7:
     cryptoxide__hashing__blake2b__Context_____update_mut__h4c294f56fe72d50d($0 + 32 | 0 | 0, $1 | 0, $2 | 0);
     return;
    case 8:
     cryptoxide__hashing__blake2b__Context_____update_mut__hbfdae3c7eea3288e($0 + 32 | 0 | 0, $1 | 0, $2 | 0);
     return;
    case 9:
     cryptoxide__hashing__blake2b__Context_____update_mut__hf14c329a0514a0fb($0 + 32 | 0 | 0, $1 | 0, $2 | 0);
     return;
    case 10:
     cryptoxide__hashing__blake2b__Context_____update_mut__h027361fea5294bdb($0 + 32 | 0 | 0, $1 | 0, $2 | 0);
     return;
    case 11:
     cryptoxide__hashing__blake2b__Context_____update_mut__hd6ae89215701b7de($0 + 32 | 0 | 0, $1 | 0, $2 | 0);
     return;
    case 12:
     cryptoxide__hashing__blake2b__Context_____update_mut__h8d795a2d8187ae8e($0 + 32 | 0 | 0, $1 | 0, $2 | 0);
     return;
    case 13:
     break label$2;
    };
   }
   cryptoxide__hashing__blake2b__Context_____update_mut__hf1adca8e4c0075bf($0 + 32 | 0 | 0, $1 | 0, $2 | 0);
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1135784 | 0, 41 | 0, 1135828 | 0);
  abort();
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__Ed25519KeyHashes___serialize__h8832695f5a55a024($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, $3 = 0, i64toi32_i32$0 = 0, $5 = 0, i64toi32_i32$1 = 0, $12 = 0, $4 = 0, $35 = 0, $41 = 0, $44 = 0;
  $3 = global$0 - 80 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, $4 | 0, i64toi32_i32$0 | 0);
  $5 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     label$4 : {
      if (!$4) {
       break label$4
      }
      $5 = HEAP32[$1 >> 2] | 0;
      $1 = Math_imul($4, 28);
      label$5 : while (1) {
       $12 = $5 + 24 | 0;
       HEAP32[(($3 + 48 | 0) + 24 | 0) >> 2] = HEAPU8[$12 >> 0] | 0 | ((HEAPU8[($12 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($12 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($12 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = $5 + 16 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $35 = i64toi32_i32$0;
       i64toi32_i32$0 = ($3 + 48 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $35;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $5 + 8 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $41 = i64toi32_i32$1;
       i64toi32_i32$1 = ($3 + 48 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $41;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = $5;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $44 = i64toi32_i32$0;
       i64toi32_i32$0 = $3;
       HEAP32[($3 + 48 | 0) >> 2] = $44;
       HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$1;
       cbor_event__se__Serializer_W___write_bytes__h5e3534de30c993f9($3 | 0, $2 | 0, $3 + 48 | 0 | 0);
       if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
        break label$2
       }
       $5 = $5 + 28 | 0;
       $1 = $1 + -28 | 0;
       if ($1) {
        continue label$5
       }
       break label$5;
      };
     }
     HEAP32[($0 + 4 | 0) >> 2] = $2;
     $5 = 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $5 = 1;
  }
  HEAP32[$0 >> 2] = $5;
  global$0 = $3 + 80 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__GenesisHashes___serialize__h2f6bb366051ef57d($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, $3 = 0, i64toi32_i32$0 = 0, $5 = 0, i64toi32_i32$1 = 0, $12 = 0, $4 = 0, $35 = 0, $41 = 0, $44 = 0;
  $3 = global$0 - 80 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, $4 | 0, i64toi32_i32$0 | 0);
  $5 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     label$4 : {
      if (!$4) {
       break label$4
      }
      $5 = HEAP32[$1 >> 2] | 0;
      $1 = Math_imul($4, 28);
      label$5 : while (1) {
       $12 = $5 + 24 | 0;
       HEAP32[(($3 + 48 | 0) + 24 | 0) >> 2] = HEAPU8[$12 >> 0] | 0 | ((HEAPU8[($12 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($12 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($12 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = $5 + 16 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $35 = i64toi32_i32$0;
       i64toi32_i32$0 = ($3 + 48 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $35;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $5 + 8 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $41 = i64toi32_i32$1;
       i64toi32_i32$1 = ($3 + 48 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $41;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = $5;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $44 = i64toi32_i32$0;
       i64toi32_i32$0 = $3;
       HEAP32[($3 + 48 | 0) >> 2] = $44;
       HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$1;
       cbor_event__se__Serializer_W___write_bytes__h5e3534de30c993f9($3 | 0, $2 | 0, $3 + 48 | 0 | 0);
       if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
        break label$2
       }
       $5 = $5 + 28 | 0;
       $1 = $1 + -28 | 0;
       if ($1) {
        continue label$5
       }
       break label$5;
      };
     }
     HEAP32[($0 + 4 | 0) >> 2] = $2;
     $5 = 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $5 = 1;
  }
  HEAP32[$0 >> 2] = $5;
  global$0 = $3 + 80 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__ScriptHashes___serialize__h38600dd38b7b89cc($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, $3 = 0, i64toi32_i32$0 = 0, $5 = 0, i64toi32_i32$1 = 0, $12 = 0, $4 = 0, $35 = 0, $41 = 0, $44 = 0;
  $3 = global$0 - 80 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, $4 | 0, i64toi32_i32$0 | 0);
  $5 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     label$4 : {
      if (!$4) {
       break label$4
      }
      $5 = HEAP32[$1 >> 2] | 0;
      $1 = Math_imul($4, 28);
      label$5 : while (1) {
       $12 = $5 + 24 | 0;
       HEAP32[(($3 + 48 | 0) + 24 | 0) >> 2] = HEAPU8[$12 >> 0] | 0 | ((HEAPU8[($12 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($12 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($12 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$2 = $5 + 16 | 0;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $35 = i64toi32_i32$0;
       i64toi32_i32$0 = ($3 + 48 | 0) + 16 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $35;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$2 = $5 + 8 | 0;
       i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $41 = i64toi32_i32$1;
       i64toi32_i32$1 = ($3 + 48 | 0) + 8 | 0;
       HEAP32[i64toi32_i32$1 >> 2] = $41;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
       i64toi32_i32$2 = $5;
       i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       $44 = i64toi32_i32$0;
       i64toi32_i32$0 = $3;
       HEAP32[($3 + 48 | 0) >> 2] = $44;
       HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$1;
       cbor_event__se__Serializer_W___write_bytes__h5e3534de30c993f9($3 | 0, $2 | 0, $3 + 48 | 0 | 0);
       if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
        break label$2
       }
       $5 = $5 + 28 | 0;
       $1 = $1 + -28 | 0;
       if ($1) {
        continue label$5
       }
       break label$5;
      };
     }
     HEAP32[($0 + 4 | 0) >> 2] = $2;
     $5 = 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $5 = 1;
  }
  HEAP32[$0 >> 2] = $5;
  global$0 = $3 + 80 | 0;
 }
 
 function transactionbody_withdrawals($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $3 = 0, $4 = 0, $51 = 0, $58 = 0, $65 = 0, $68 = 0;
  $1 = global$0 - 96 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h356c30395cf13adb($1 + 8 | 0 | 0, $0 | 0);
   $2 = 0;
   $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   $0 = 0;
   label$2 : {
    $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    if (!(HEAP32[($4 + 44 | 0) >> 2] | 0)) {
     break label$2
    }
    $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h8cac34049618832f($1 + 16 | 0 | 0, $4 + 24 | 0 | 0);
    $0 = HEAP32[($1 + 36 | 0) >> 2] | 0;
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
   label$3 : {
    if (!$0) {
     break label$3
    }
    HEAP32[($1 + 76 | 0) >> 2] = $0;
    HEAP32[(($1 + 56 | 0) + 16 | 0) >> 2] = HEAP32[(($1 + 16 | 0) + 16 | 0) >> 2] | 0;
    i64toi32_i32$2 = ($1 + 16 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $51 = i64toi32_i32$0;
    i64toi32_i32$0 = ($1 + 56 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $51;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = ($1 + 16 | 0) + 24 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $58 = i64toi32_i32$1;
    i64toi32_i32$1 = ($1 + 56 | 0) + 24 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $58;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = ($1 + 16 | 0) + 32 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $65 = i64toi32_i32$0;
    i64toi32_i32$0 = ($1 + 56 | 0) + 32 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $65;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = HEAP32[($1 + 16 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($1 + 20 | 0) >> 2] | 0;
    $68 = i64toi32_i32$1;
    i64toi32_i32$1 = $1;
    HEAP32[($1 + 56 | 0) >> 2] = $68;
    HEAP32[($1 + 60 | 0) >> 2] = i64toi32_i32$0;
    $2 = $cardano_serialization_lib__Withdrawals_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8137ae41e80d8131($1 + 56 | 0 | 0) | 0;
   }
   global$0 = $1 + 96 | 0;
   return $2 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionbody_auxiliary_data_hash($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $2 = 0, $3 = 0, $4 = 0, $5 = 0, $27 = 0, $34 = 0, $41 = 0, $45 = 0, $55 = 0, $60 = 0, $65 = 0, $68 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h356c30395cf13adb($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   label$2 : {
    label$3 : {
     $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     if ((HEAPU8[($2 + 204 | 0) >> 0] | 0 | 0) != (1 | 0)) {
      break label$3
     }
     $3 = ($1 + 16 | 0) + 24 | 0;
     i64toi32_i32$2 = $2 + 229 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $27 = i64toi32_i32$0;
     i64toi32_i32$0 = $3;
     HEAP32[i64toi32_i32$0 >> 2] = $27;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     $4 = ($1 + 16 | 0) + 16 | 0;
     i64toi32_i32$2 = $2 + 221 | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $34 = i64toi32_i32$1;
     i64toi32_i32$1 = $4;
     HEAP32[i64toi32_i32$1 >> 2] = $34;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     $5 = ($1 + 16 | 0) + 8 | 0;
     i64toi32_i32$2 = $2 + 213 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $41 = i64toi32_i32$0;
     i64toi32_i32$0 = $5;
     HEAP32[i64toi32_i32$0 >> 2] = $41;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $2 + 205 | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $45 = i64toi32_i32$1;
     i64toi32_i32$1 = $1;
     HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $45;
     HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
     core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
     i64toi32_i32$2 = $3;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $55 = i64toi32_i32$0;
     i64toi32_i32$0 = ($1 + 48 | 0) + 24 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $55;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $4;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $60 = i64toi32_i32$1;
     i64toi32_i32$1 = ($1 + 48 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $60;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $5;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $65 = i64toi32_i32$0;
     i64toi32_i32$0 = ($1 + 48 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $65;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $1;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
     $68 = i64toi32_i32$1;
     i64toi32_i32$1 = i64toi32_i32$2;
     HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = $68;
     HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = i64toi32_i32$0;
     $0 = $cardano_serialization_lib__crypto__AuxiliaryDataHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__ha0bdb89a2c7c1e66(i64toi32_i32$2 + 48 | 0 | 0) | 0;
     break label$2;
    }
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    $0 = 0;
   }
   global$0 = $1 + 80 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionbody_script_data_hash($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $2 = 0, $3 = 0, $4 = 0, $5 = 0, $27 = 0, $34 = 0, $41 = 0, $45 = 0, $55 = 0, $60 = 0, $65 = 0, $68 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h356c30395cf13adb($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   label$2 : {
    label$3 : {
     $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     if ((HEAPU8[($2 + 237 | 0) >> 0] | 0 | 0) != (1 | 0)) {
      break label$3
     }
     $3 = ($1 + 16 | 0) + 24 | 0;
     i64toi32_i32$2 = $2 + 262 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $27 = i64toi32_i32$0;
     i64toi32_i32$0 = $3;
     HEAP32[i64toi32_i32$0 >> 2] = $27;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     $4 = ($1 + 16 | 0) + 16 | 0;
     i64toi32_i32$2 = $2 + 254 | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $34 = i64toi32_i32$1;
     i64toi32_i32$1 = $4;
     HEAP32[i64toi32_i32$1 >> 2] = $34;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     $5 = ($1 + 16 | 0) + 8 | 0;
     i64toi32_i32$2 = $2 + 246 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $41 = i64toi32_i32$0;
     i64toi32_i32$0 = $5;
     HEAP32[i64toi32_i32$0 >> 2] = $41;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $2 + 238 | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $45 = i64toi32_i32$1;
     i64toi32_i32$1 = $1;
     HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $45;
     HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
     core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
     i64toi32_i32$2 = $3;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $55 = i64toi32_i32$0;
     i64toi32_i32$0 = ($1 + 48 | 0) + 24 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $55;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $4;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $60 = i64toi32_i32$1;
     i64toi32_i32$1 = ($1 + 48 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $60;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $5;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $65 = i64toi32_i32$0;
     i64toi32_i32$0 = ($1 + 48 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $65;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $1;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
     $68 = i64toi32_i32$1;
     i64toi32_i32$1 = i64toi32_i32$2;
     HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = $68;
     HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = i64toi32_i32$0;
     $0 = $cardano_serialization_lib__crypto__ScriptDataHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h4525048b15d98533(i64toi32_i32$2 + 48 | 0 | 0) | 0;
     break label$2;
    }
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    $0 = 0;
   }
   global$0 = $1 + 80 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionoutput_data_hash($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $2 = 0, $3 = 0, $4 = 0, $5 = 0, $27 = 0, $34 = 0, $41 = 0, $45 = 0, $55 = 0, $60 = 0, $65 = 0, $68 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h17af7d9d2d20aa0f($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   label$2 : {
    label$3 : {
     $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     if ((HEAPU8[($2 + 88 | 0) >> 0] | 0 | 0) != (1 | 0)) {
      break label$3
     }
     $3 = ($1 + 16 | 0) + 24 | 0;
     i64toi32_i32$2 = $2 + 113 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $27 = i64toi32_i32$0;
     i64toi32_i32$0 = $3;
     HEAP32[i64toi32_i32$0 >> 2] = $27;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     $4 = ($1 + 16 | 0) + 16 | 0;
     i64toi32_i32$2 = $2 + 105 | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $34 = i64toi32_i32$1;
     i64toi32_i32$1 = $4;
     HEAP32[i64toi32_i32$1 >> 2] = $34;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     $5 = ($1 + 16 | 0) + 8 | 0;
     i64toi32_i32$2 = $2 + 97 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $41 = i64toi32_i32$0;
     i64toi32_i32$0 = $5;
     HEAP32[i64toi32_i32$0 >> 2] = $41;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $2 + 89 | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $45 = i64toi32_i32$1;
     i64toi32_i32$1 = $1;
     HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $45;
     HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
     core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
     i64toi32_i32$2 = $3;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $55 = i64toi32_i32$0;
     i64toi32_i32$0 = ($1 + 48 | 0) + 24 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $55;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $4;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $60 = i64toi32_i32$1;
     i64toi32_i32$1 = ($1 + 48 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $60;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $5;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $65 = i64toi32_i32$0;
     i64toi32_i32$0 = ($1 + 48 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $65;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $1;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
     $68 = i64toi32_i32$1;
     i64toi32_i32$1 = i64toi32_i32$2;
     HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = $68;
     HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = i64toi32_i32$0;
     $0 = $cardano_serialization_lib__crypto__DataHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hba2449530c6577ab(i64toi32_i32$2 + 48 | 0 | 0) | 0;
     break label$2;
    }
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    $0 = 0;
   }
   global$0 = $1 + 80 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function headerbody_prev_hash($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $2 = 0, $3 = 0, $4 = 0, $5 = 0, $27 = 0, $34 = 0, $41 = 0, $45 = 0, $55 = 0, $60 = 0, $65 = 0, $68 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h2ac16fcb64db16b5($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   label$2 : {
    label$3 : {
     $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     if ((HEAPU8[($2 + 176 | 0) >> 0] | 0 | 0) != (1 | 0)) {
      break label$3
     }
     $3 = ($1 + 16 | 0) + 24 | 0;
     i64toi32_i32$2 = $2 + 201 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $27 = i64toi32_i32$0;
     i64toi32_i32$0 = $3;
     HEAP32[i64toi32_i32$0 >> 2] = $27;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     $4 = ($1 + 16 | 0) + 16 | 0;
     i64toi32_i32$2 = $2 + 193 | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $34 = i64toi32_i32$1;
     i64toi32_i32$1 = $4;
     HEAP32[i64toi32_i32$1 >> 2] = $34;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     $5 = ($1 + 16 | 0) + 8 | 0;
     i64toi32_i32$2 = $2 + 185 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $41 = i64toi32_i32$0;
     i64toi32_i32$0 = $5;
     HEAP32[i64toi32_i32$0 >> 2] = $41;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $2 + 177 | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $45 = i64toi32_i32$1;
     i64toi32_i32$1 = $1;
     HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $45;
     HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
     core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
     i64toi32_i32$2 = $3;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $55 = i64toi32_i32$0;
     i64toi32_i32$0 = ($1 + 48 | 0) + 24 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $55;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $4;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $60 = i64toi32_i32$1;
     i64toi32_i32$1 = ($1 + 48 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $60;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $5;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $65 = i64toi32_i32$0;
     i64toi32_i32$0 = ($1 + 48 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $65;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $1;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
     $68 = i64toi32_i32$1;
     i64toi32_i32$1 = i64toi32_i32$2;
     HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = $68;
     HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = i64toi32_i32$0;
     $0 = $cardano_serialization_lib__crypto__BlockHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hf8ef4eaf9a4a30cf(i64toi32_i32$2 + 48 | 0 | 0) | 0;
     break label$2;
    }
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    $0 = 0;
   }
   global$0 = $1 + 80 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function hashbrown__raw__RawTableInner_A___new_uninitialized__h43f4df636ea4ff18($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $6 = 0, $5 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, $7 = 0, i64toi32_i32$3 = 0, $19 = 0, $13$hi = 0, $15$hi = 0, $8 = 0, $8$hi = 0, $46 = 0, $60 = 0;
  $5 = global$0 - 16 | 0;
  global$0 = $5;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        i64toi32_i32$0 = 0;
        $13$hi = i64toi32_i32$0;
        i64toi32_i32$0 = 0;
        $15$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $13$hi;
        i64toi32_i32$1 = $15$hi;
        i64toi32_i32$1 = __wasm_i64_mul($1 | 0, i64toi32_i32$0 | 0, $3 | 0, i64toi32_i32$1 | 0) | 0;
        i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
        $8 = i64toi32_i32$1;
        $8$hi = i64toi32_i32$0;
        i64toi32_i32$2 = i64toi32_i32$1;
        i64toi32_i32$1 = 0;
        i64toi32_i32$3 = 32;
        i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$1 = 0;
         $19 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
        } else {
         i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
         $19 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
        }
        if ($19) {
         break label$6
        }
        i64toi32_i32$1 = $8$hi;
        $1 = $8;
        $6 = ($2 + $1 | 0) + -1 | 0;
        if ($6 >>> 0 < $1 >>> 0) {
         break label$6
        }
        if (!$2) {
         break label$6
        }
        $1 = $6 & (0 - $2 | 0) | 0;
        $6 = ($3 + $1 | 0) + 4 | 0;
        if ($6 >>> 0 >= $1 >>> 0) {
         break label$5
        }
       }
       hashbrown__raw__Fallibility__capacity_overflow__hd790516fe6877097($5 | 0, $4 | 0);
       i64toi32_i32$0 = $5;
       i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
       $46 = i64toi32_i32$1;
       i64toi32_i32$1 = $0;
       HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $46;
       HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$2;
       break label$4;
      }
      if (!$6) {
       break label$3
      }
      $7 = __rust_alloc($6 | 0, $2 | 0) | 0;
      if ($7) {
       break label$2
      }
      $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
      hashbrown__raw__Fallibility__alloc_err__ha667b3bb2bd8a2c9($5 + 8 | 0 | 0, $4 | 0, $6 | 0, $2 | 0);
      i64toi32_i32$0 = $5;
      i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] | 0;
      $60 = i64toi32_i32$2;
      i64toi32_i32$2 = $0;
      HEAP32[($0 + 4 | 0) >> 2] = $60;
      HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$1;
     }
     $2 = 1;
     break label$1;
    }
    $7 = $2;
   }
   $2 = 0;
   HEAP32[($0 + 16 | 0) >> 2] = 0;
   HEAP32[($0 + 8 | 0) >> 2] = $7 + $1 | 0;
   $1 = $3 + -1 | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[($0 + 12 | 0) >> 2] = $1 >>> 0 < 8 >>> 0 ? $1 : Math_imul($3 >>> 3 | 0, 7);
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $5 + 16 | 0;
 }
 
 function $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__iter__traits__collect__Extend__28K_2cV_29____extend__h5509c9cd41af8dd9($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $3 = 0, i64toi32_i32$0 = 0, $4 = 0, $5 = 0, $47 = 0, $54 = 0, $57 = 0;
  $2 = global$0 - 560 | 0;
  global$0 = $2;
  label$1 : {
   $3 = HEAP32[$1 >> 2] | 0;
   $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   if (($3 | 0) == ($4 | 0)) {
    break label$1
   }
   $5 = $2 + 40 | 0;
   label$2 : while (1) {
    $1 = HEAP32[($3 + 156 | 0) >> 2] | 0;
    core__ops__function__impls___impl_20core__ops__function__FnOnce_A__20for_20_mut_20F___call_once__h04c7e95d494f6df8($2 + 192 | 0 | 0, $2 | 0, $3 + 160 | 0 | 0, $3 | 0);
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[($2 + 224 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 228 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    i64toi32_i32$3 = 3;
    if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
     break label$1
    }
    memcpy($2 + 8 | 0 | 0, $2 + 192 | 0 | 0, 184 | 0) | 0;
    HEAP32[(($2 + 528 | 0) + 24 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 24 | 0) >> 2] | 0;
    i64toi32_i32$3 = ($2 + 8 | 0) + 16 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $47 = i64toi32_i32$2;
    i64toi32_i32$2 = ($2 + 528 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $47;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$3 = ($2 + 8 | 0) + 8 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $54 = i64toi32_i32$1;
    i64toi32_i32$1 = ($2 + 528 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $54;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$3 = $2;
    i64toi32_i32$2 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $57 = i64toi32_i32$2;
    i64toi32_i32$2 = $2;
    HEAP32[($2 + 528 | 0) >> 2] = $57;
    HEAP32[($2 + 532 | 0) >> 2] = i64toi32_i32$1;
    memcpy($2 + 192 | 0 | 0, $5 | 0, 152 | 0) | 0;
    linked_hash_map__LinkedHashMap_K_2cV_2cS___insert__h0e2ff8a07783b7ab($2 + 376 | 0 | 0, $0 | 0, $2 + 528 | 0 | 0, $2 + 192 | 0 | 0);
    label$3 : {
     i64toi32_i32$3 = $2;
     i64toi32_i32$1 = HEAP32[($2 + 376 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[($2 + 380 | 0) >> 2] | 0;
     i64toi32_i32$3 = i64toi32_i32$1;
     i64toi32_i32$1 = 0;
     i64toi32_i32$0 = 3;
     if ((i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$1 | 0) | 0) {
      break label$3
     }
     core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__tx_builder__tx_inputs_builder__ScriptWitnessType____h04ba3cf23b50ffc0($2 + 376 | 0 | 0);
    }
    $3 = $1;
    if (($3 | 0) != ($4 | 0)) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $2 + 560 | 0;
 }
 
 function $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__iter__traits__collect__Extend__28K_2cV_29____extend__ha0dab88e5bf54460($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $3 = 0, i64toi32_i32$0 = 0, $4 = 0, $5 = 0, $47 = 0, $54 = 0, $57 = 0;
  $2 = global$0 - 1328 | 0;
  global$0 = $2;
  label$1 : {
   $3 = HEAP32[$1 >> 2] | 0;
   $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   if (($3 | 0) == ($4 | 0)) {
    break label$1
   }
   $5 = $2 + 40 | 0;
   label$2 : while (1) {
    $1 = HEAP32[($3 + 412 | 0) >> 2] | 0;
    core__ops__function__impls___impl_20core__ops__function__FnOnce_A__20for_20_mut_20F___call_once__he11c2dc02d9ec84f($2 + 448 | 0 | 0, $2 | 0, $3 + 416 | 0 | 0, $3 | 0);
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[($2 + 480 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 484 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    i64toi32_i32$3 = 2;
    if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
     break label$1
    }
    memcpy($2 + 8 | 0 | 0, $2 + 448 | 0 | 0, 440 | 0) | 0;
    HEAP32[(($2 + 1296 | 0) + 24 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 24 | 0) >> 2] | 0;
    i64toi32_i32$3 = ($2 + 8 | 0) + 16 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $47 = i64toi32_i32$2;
    i64toi32_i32$2 = ($2 + 1296 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $47;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$3 = ($2 + 8 | 0) + 8 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $54 = i64toi32_i32$1;
    i64toi32_i32$1 = ($2 + 1296 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $54;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$3 = $2;
    i64toi32_i32$2 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $57 = i64toi32_i32$2;
    i64toi32_i32$2 = $2;
    HEAP32[($2 + 1296 | 0) >> 2] = $57;
    HEAP32[($2 + 1300 | 0) >> 2] = i64toi32_i32$1;
    memcpy($2 + 448 | 0 | 0, $5 | 0, 408 | 0) | 0;
    linked_hash_map__LinkedHashMap_K_2cV_2cS___insert__hfa80207d641c294d($2 + 888 | 0 | 0, $0 | 0, $2 + 1296 | 0 | 0, $2 + 448 | 0 | 0);
    label$3 : {
     i64toi32_i32$3 = $2;
     i64toi32_i32$1 = HEAP32[($2 + 888 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[($2 + 892 | 0) >> 2] | 0;
     i64toi32_i32$3 = i64toi32_i32$1;
     i64toi32_i32$1 = 0;
     i64toi32_i32$0 = 2;
     if ((i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$1 | 0) | 0) {
      break label$3
     }
     core__ptr__drop_in_place_cardano_serialization_lib__ProtocolParamUpdate___h92eeb91cabd2847d_1($2 + 888 | 0 | 0);
    }
    $3 = $1;
    if (($3 | 0) != ($4 | 0)) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $2 + 1328 | 0;
 }
 
 function alloc__vec__Vec_T_2cA___extend_desugared__h98ceb10030e010bd($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, $3 = 0, $2 = 0, i64toi32_i32$1 = 0, $5 = 0, i64toi32_i32$0 = 0, $4 = 0, i64toi32_i32$4 = 0, $8$hi = 0, i64toi32_i32$3 = 0, $8 = 0, $6 = 0, $16 = 0, $7 = 0, $42$hi = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     if (!$2) {
      break label$3
     }
     $3 = HEAP32[$1 >> 2] | 0;
     $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     label$4 : while (1) {
      $5 = $2 >>> 0 > $4 >>> 0 ? $4 : $2;
      $2 = $2 - $5 | 0;
      HEAP32[($1 + 4 | 0) >> 2] = $2;
      $6 = $3 + ($5 << 2 | 0) | 0;
      HEAP32[$1 >> 2] = $6;
      if (!$5) {
       break label$2
      }
      i64toi32_i32$2 = $3;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = 0;
      $8 = i64toi32_i32$0;
      $8$hi = i64toi32_i32$1;
      label$5 : {
       if (($5 | 0) == (1 | 0)) {
        break label$5
       }
       i64toi32_i32$2 = $3;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$2 = i64toi32_i32$1;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 32;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $16 = 0;
       } else {
        i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
        $16 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       $42$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $8$hi;
       i64toi32_i32$1 = $42$hi;
       i64toi32_i32$0 = $16;
       i64toi32_i32$2 = $8$hi;
       i64toi32_i32$3 = $8;
       i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
       $8 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
       $8$hi = i64toi32_i32$2;
      }
      label$6 : {
       $5 = HEAP32[($0 + 8 | 0) >> 2] | 0;
       if ((HEAP32[($0 + 4 | 0) >> 2] | 0 | 0) != ($5 | 0)) {
        break label$6
       }
       $3 = 0;
       label$7 : {
        if (!$2) {
         break label$7
        }
        if (!$4) {
         break label$1
        }
        $3 = ($2 >>> 0) / ($4 >>> 0) | 0;
        $3 = $3 + (($2 - Math_imul($3, $4) | 0 | 0) != (0 | 0)) | 0;
       }
       $7 = $3 + 1 | 0;
       alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h48baae5828c84300($0 | 0, $5 | 0, ($7 >>> 0 < $3 >>> 0 ? -1 : $7) | 0);
      }
      i64toi32_i32$2 = $8$hi;
      i64toi32_i32$0 = (HEAP32[$0 >> 2] | 0) + ($5 << 3 | 0) | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $8;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
      HEAP32[($0 + 8 | 0) >> 2] = $5 + 1 | 0;
      $3 = $6;
      if ($2) {
       continue label$4
      }
      break label$4;
     };
    }
    return;
   }
   core__panicking__panic_bounds_check__h808b524af17640b1(0 | 0, 0 | 0, 1067352 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1068032 | 0, 25 | 0, 1068004 | 0);
  abort();
 }
 
 function cardano_serialization_lib__address__BaseAddress__from_address__h3190075870a36e33($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $26 = 0, $27 = 0, $28 = 0, $29 = 0, $30 = 0, $31 = 0, $32 = 0, $4 = 0, $5 = 0, $6 = 0, $3 = 0, $19 = 0, $25 = 0, $35 = 0, $7 = 0, $43 = 0, $48 = 0, $53 = 0, $69 = 0, $73 = 0, $76 = 0;
  $2 = global$0 - 64 | 0;
  label$1 : {
   if (HEAPU8[$1 >> 0] | 0) {
    break label$1
   }
   $3 = HEAPU8[($1 + 1 | 0) >> 0] | 0;
   $4 = $2 + 8 | 0;
   i64toi32_i32$2 = $1 + 11 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $19 = i64toi32_i32$0;
   i64toi32_i32$0 = $4;
   HEAP32[i64toi32_i32$0 >> 2] = $19;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   $5 = $2 + 16 | 0;
   i64toi32_i32$2 = $1 + 19 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $25 = i64toi32_i32$1;
   i64toi32_i32$1 = $5;
   HEAP32[i64toi32_i32$1 >> 2] = $25;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   $6 = $2 + 24 | 0;
   $20 = $1 + 27 | 0;
   HEAP32[$6 >> 2] = HEAPU8[$20 >> 0] | 0 | ((HEAPU8[($20 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($20 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($20 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$2 = $1 + 3 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $35 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   HEAP32[i64toi32_i32$0 >> 2] = $35;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   $7 = HEAPU8[($1 + 2 | 0) >> 0] | 0;
   i64toi32_i32$2 = $1 + 32 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $43 = i64toi32_i32$1;
   i64toi32_i32$1 = $0 + 31 | 0;
   $21 = $43;
   HEAP8[i64toi32_i32$1 >> 0] = $21;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $21 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $21 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $21 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $1 + 40 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $48 = i64toi32_i32$0;
   i64toi32_i32$0 = $0 + 39 | 0;
   $22 = $48;
   HEAP8[i64toi32_i32$0 >> 0] = $22;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $22 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $22 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $22 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = $1 + 48 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $53 = i64toi32_i32$1;
   i64toi32_i32$1 = $0 + 47 | 0;
   $23 = $53;
   HEAP8[i64toi32_i32$1 >> 0] = $23;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $23 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $23 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $23 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   $24 = $1 + 56 | 0;
   $26 = $0 + 55 | 0;
   $27 = HEAPU8[$24 >> 0] | 0 | ((HEAPU8[($24 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($24 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($24 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[$26 >> 0] = $27;
   HEAP8[($26 + 1 | 0) >> 0] = $27 >>> 8 | 0;
   HEAP8[($26 + 2 | 0) >> 0] = $27 >>> 16 | 0;
   HEAP8[($26 + 3 | 0) >> 0] = $27 >>> 24 | 0;
   $1 = HEAPU8[($1 + 31 | 0) >> 0] | 0;
   $28 = $0 + 26 | 0;
   $29 = HEAP32[$6 >> 2] | 0;
   HEAP8[$28 >> 0] = $29;
   HEAP8[($28 + 1 | 0) >> 0] = $29 >>> 8 | 0;
   HEAP8[($28 + 2 | 0) >> 0] = $29 >>> 16 | 0;
   HEAP8[($28 + 3 | 0) >> 0] = $29 >>> 24 | 0;
   i64toi32_i32$2 = $5;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $69 = i64toi32_i32$0;
   i64toi32_i32$0 = $0 + 18 | 0;
   $30 = $69;
   HEAP8[i64toi32_i32$0 >> 0] = $30;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $30 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $30 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $30 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = $4;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $73 = i64toi32_i32$1;
   i64toi32_i32$1 = $0 + 10 | 0;
   $31 = $73;
   HEAP8[i64toi32_i32$1 >> 0] = $31;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $31 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $31 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $31 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $76 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   $32 = $76;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $32;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $32 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = $32 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = $32 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 8 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 9 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 30 | 0) >> 0] = $1;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $7;
   HEAP8[i64toi32_i32$0 >> 0] = $3;
   return;
  }
  HEAP8[($0 + 1 | 0) >> 0] = 2;
 }
 
 function plutusdata_as_integer($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $3 = 0, $8 = 0, $38 = 0, $64 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb1fd14a6870cafe2($1 | 0, $0 | 0);
   $0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   $2 = 3;
   label$2 : {
    $3 = HEAP32[$1 >> 2] | 0;
    if ((HEAP32[$3 >> 2] | 0 | 0) != (3 | 0)) {
     break label$2
    }
    $2 = HEAPU8[($3 + 16 | 0) >> 0] | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hd36b5d149e6fd98b($1 + 32 | 0 | 0, $3 + 4 | 0 | 0);
    HEAP32[(($1 + 16 | 0) + 8 | 0) >> 2] = HEAP32[(($1 + 32 | 0) + 8 | 0) >> 2] | 0;
    HEAP8[($1 + 14 | 0) >> 0] = HEAPU8[($1 + 47 | 0) >> 0] | 0;
    i64toi32_i32$0 = HEAP32[($1 + 32 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 36 | 0) >> 2] | 0;
    $38 = i64toi32_i32$0;
    i64toi32_i32$0 = $1;
    HEAP32[($1 + 16 | 0) >> 2] = $38;
    HEAP32[($1 + 20 | 0) >> 2] = i64toi32_i32$1;
    HEAP16[($1 + 12 | 0) >> 1] = HEAPU8[($1 + 45 | 0) >> 0] | 0 | ((HEAPU8[($1 + 46 | 0) >> 0] | 0) << 8 | 0) | 0;
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   $0 = 0;
   label$3 : {
    if (($2 & 255 | 0 | 0) == (3 | 0)) {
     break label$3
    }
    HEAP32[(($1 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($1 + 16 | 0) + 8 | 0) >> 2] | 0;
    HEAP8[($1 + 47 | 0) >> 0] = HEAPU8[($1 + 14 | 0) >> 0] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 16 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($1 + 20 | 0) >> 2] | 0;
    $64 = i64toi32_i32$1;
    i64toi32_i32$1 = $1;
    HEAP32[($1 + 32 | 0) >> 2] = $64;
    HEAP32[($1 + 36 | 0) >> 2] = i64toi32_i32$0;
    HEAP8[($1 + 44 | 0) >> 0] = $2;
    $8 = HEAPU16[($1 + 12 | 0) >> 1] | 0;
    HEAP8[($1 + 45 | 0) >> 0] = $8;
    HEAP8[($1 + 46 | 0) >> 0] = $8 >>> 8 | 0;
    $0 = $cardano_serialization_lib__utils__BigInt_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8699e08c5b3b0a6a($1 + 32 | 0 | 0) | 0;
   }
   global$0 = $1 + 48 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function cardano_serialization_lib__plutus__RedeemerTag__from_bytes__h713c826c214713e1($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, $1 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $3$hi = 0, $3 = 0, $4$hi = 0, $5$hi = 0, $2 = 0, $16 = 0, $4 = 0, $5 = 0, $18 = 0, $17 = 0, $66$hi = 0;
  $1 = global$0 - 320 | 0;
  global$0 = $1;
  HEAP32[($1 + 168 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = 0;
  $3 = 0;
  $3$hi = i64toi32_i32$0;
  i64toi32_i32$1 = $1;
  i64toi32_i32$0 = 0;
  HEAP32[($1 + 152 | 0) >> 2] = 0;
  HEAP32[($1 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $17 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 160 | 0) >> 2] = $17;
  HEAP32[($1 + 164 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__plutus__RedeemerTagKind_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h284028eaa4294bff($1 + 248 | 0 | 0, $1 + 152 | 0 | 0);
  $0 = ($1 + 152 | 0) + 8 | 0;
  label$1 : {
   label$2 : {
    $2 = HEAPU8[($1 + 248 | 0) >> 0] | 0;
    if (($2 | 0) == (1 | 0)) {
     break label$2
    }
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = HEAPU8[($1 + 249 | 0) >> 0] | 0;
    i64toi32_i32$0 = 0;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    i64toi32_i32$3 = 8;
    i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
     $16 = 0;
    } else {
     i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
     $16 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
    }
    $3 = $16;
    $3$hi = i64toi32_i32$1;
    break label$1;
   }
   memcpy(($1 + 82 | 0) + 6 | 0 | 0, memcpy(($1 + 178 | 0) + 6 | 0 | 0, ($1 + 248 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
  }
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
  label$3 : {
   label$4 : {
    if (($2 | 0) == (1 | 0)) {
     break label$4
    }
    i64toi32_i32$1 = 0;
    $4 = 0;
    $4$hi = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    $5 = 0;
    $5$hi = i64toi32_i32$1;
    break label$3;
   }
   memcpy($1 + 248 | 0 | 0, memcpy(($1 + 12 | 0) + 6 | 0 | 0, ($1 + 82 | 0) + 6 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   i64toi32_i32$1 = 0;
   i64toi32_i32$0 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($1 + 248 | 0 | 0) | 0;
   i64toi32_i32$2 = 0;
   i64toi32_i32$3 = 32;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
    $18 = 0;
   } else {
    i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
    $18 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   }
   $4 = $18;
   $4$hi = i64toi32_i32$2;
   i64toi32_i32$2 = 0;
   $5 = 1;
   $5$hi = i64toi32_i32$2;
   i64toi32_i32$2 = 0;
   $3 = 0;
   $3$hi = i64toi32_i32$2;
  }
  global$0 = $1 + 320 | 0;
  i64toi32_i32$2 = $3$hi;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$2 = $3$hi;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = $4$hi;
  i64toi32_i32$3 = $4;
  i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
  $66$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $5$hi;
  i64toi32_i32$0 = $66$hi;
  i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $5$hi;
  i64toi32_i32$3 = $5;
  i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$1;
  return i64toi32_i32$2 | 0;
 }
 
 function ed25519keyhashes_get($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $3 = 0, $15 = 0, $4 = 0, $5 = 0, $41 = 0, $48 = 0, $51 = 0, $66 = 0, $71 = 0, $74 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h38787c785ea84973($2 + 8 | 0 | 0, $0 | 0);
    $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
    if ($3 >>> 0 <= $1 >>> 0) {
     break label$1
    }
    $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $4 = ($2 + 16 | 0) + 24 | 0;
    $0 = (HEAP32[$0 >> 2] | 0) + Math_imul($1, 28) | 0;
    $15 = $0 + 24 | 0;
    HEAP32[$4 >> 2] = HEAPU8[$15 >> 0] | 0 | ((HEAPU8[($15 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($15 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($15 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $1 = ($2 + 16 | 0) + 16 | 0;
    i64toi32_i32$2 = $0 + 16 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $41 = i64toi32_i32$0;
    i64toi32_i32$0 = $1;
    HEAP32[i64toi32_i32$0 >> 2] = $41;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    $5 = ($2 + 16 | 0) + 8 | 0;
    i64toi32_i32$2 = $0 + 8 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $48 = i64toi32_i32$1;
    i64toi32_i32$1 = $5;
    HEAP32[i64toi32_i32$1 >> 2] = $48;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $51 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[($2 + 16 | 0) >> 2] = $51;
    HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$1;
    core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
    HEAP32[(($2 + 48 | 0) + 24 | 0) >> 2] = HEAP32[$4 >> 2] | 0;
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $66 = i64toi32_i32$1;
    i64toi32_i32$1 = ($2 + 48 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $66;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $5;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $71 = i64toi32_i32$0;
    i64toi32_i32$0 = ($2 + 48 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $71;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
    $74 = i64toi32_i32$1;
    i64toi32_i32$1 = i64toi32_i32$2;
    HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = $74;
    HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = i64toi32_i32$0;
    $0 = $cardano_serialization_lib__crypto__Ed25519KeyHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hd63cf82b6a769066(i64toi32_i32$2 + 48 | 0 | 0) | 0;
    global$0 = i64toi32_i32$2 + 80 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  core__panicking__panic_bounds_check__h808b524af17640b1($1 | 0, $3 | 0, 1053368 | 0);
  abort();
 }
 
 function moveinstantaneousreward_as_to_stake_creds($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, $2 = 0, $3 = 0, $4 = 0, $50 = 0, $57 = 0, $64 = 0, $67 = 0;
  $1 = global$0 - 96 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h84b5bdabb1c1c80b($1 + 8 | 0 | 0, $0 | 0);
   $2 = 0;
   $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   $0 = 0;
   label$2 : {
    $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $4;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    i64toi32_i32$3 = 1;
    if ((i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$0 | 0) | 0) {
     break label$2
    }
    $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h7490700a7eed2994($1 + 16 | 0 | 0, $4 + 8 | 0 | 0);
    $0 = HEAP32[($1 + 36 | 0) >> 2] | 0;
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
   label$3 : {
    if (!$0) {
     break label$3
    }
    HEAP32[($1 + 76 | 0) >> 2] = $0;
    HEAP32[(($1 + 56 | 0) + 16 | 0) >> 2] = HEAP32[(($1 + 16 | 0) + 16 | 0) >> 2] | 0;
    i64toi32_i32$3 = ($1 + 16 | 0) + 8 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $50 = i64toi32_i32$2;
    i64toi32_i32$2 = ($1 + 56 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $50;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$3 = ($1 + 16 | 0) + 24 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $57 = i64toi32_i32$1;
    i64toi32_i32$1 = ($1 + 56 | 0) + 24 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $57;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$3 = ($1 + 16 | 0) + 32 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $64 = i64toi32_i32$2;
    i64toi32_i32$2 = ($1 + 56 | 0) + 32 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $64;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$3 = $1;
    i64toi32_i32$1 = HEAP32[($1 + 16 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($1 + 20 | 0) >> 2] | 0;
    $67 = i64toi32_i32$1;
    i64toi32_i32$1 = $1;
    HEAP32[($1 + 56 | 0) >> 2] = $67;
    HEAP32[($1 + 60 | 0) >> 2] = i64toi32_i32$2;
    $2 = $cardano_serialization_lib__MIRToStakeCredentials_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h1e2c02e5ebbbcce1($1 + 56 | 0 | 0) | 0;
   }
   global$0 = $1 + 96 | 0;
   return $2 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function genesishashes_get($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $3 = 0, $15 = 0, $4 = 0, $5 = 0, $41 = 0, $48 = 0, $51 = 0, $66 = 0, $71 = 0, $74 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h419753218ead1831($2 + 8 | 0 | 0, $0 | 0);
    $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
    if ($3 >>> 0 <= $1 >>> 0) {
     break label$1
    }
    $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $4 = ($2 + 16 | 0) + 24 | 0;
    $0 = (HEAP32[$0 >> 2] | 0) + Math_imul($1, 28) | 0;
    $15 = $0 + 24 | 0;
    HEAP32[$4 >> 2] = HEAPU8[$15 >> 0] | 0 | ((HEAPU8[($15 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($15 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($15 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $1 = ($2 + 16 | 0) + 16 | 0;
    i64toi32_i32$2 = $0 + 16 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $41 = i64toi32_i32$0;
    i64toi32_i32$0 = $1;
    HEAP32[i64toi32_i32$0 >> 2] = $41;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    $5 = ($2 + 16 | 0) + 8 | 0;
    i64toi32_i32$2 = $0 + 8 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $48 = i64toi32_i32$1;
    i64toi32_i32$1 = $5;
    HEAP32[i64toi32_i32$1 >> 2] = $48;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $51 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[($2 + 16 | 0) >> 2] = $51;
    HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$1;
    core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
    HEAP32[(($2 + 48 | 0) + 24 | 0) >> 2] = HEAP32[$4 >> 2] | 0;
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $66 = i64toi32_i32$1;
    i64toi32_i32$1 = ($2 + 48 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $66;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $5;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $71 = i64toi32_i32$0;
    i64toi32_i32$0 = ($2 + 48 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $71;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
    $74 = i64toi32_i32$1;
    i64toi32_i32$1 = i64toi32_i32$2;
    HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = $74;
    HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = i64toi32_i32$0;
    $0 = $cardano_serialization_lib__crypto__GenesisHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hedc49afed5ec6de0(i64toi32_i32$2 + 48 | 0 | 0) | 0;
    global$0 = i64toi32_i32$2 + 80 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  core__panicking__panic_bounds_check__h808b524af17640b1($1 | 0, $3 | 0, 1054068 | 0);
  abort();
 }
 
 function scripthashes_get($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $3 = 0, $15 = 0, $4 = 0, $5 = 0, $41 = 0, $48 = 0, $51 = 0, $66 = 0, $71 = 0, $74 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__hca2e1c7f0251c418($2 + 8 | 0 | 0, $0 | 0);
    $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
    if ($3 >>> 0 <= $1 >>> 0) {
     break label$1
    }
    $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $4 = ($2 + 16 | 0) + 24 | 0;
    $0 = (HEAP32[$0 >> 2] | 0) + Math_imul($1, 28) | 0;
    $15 = $0 + 24 | 0;
    HEAP32[$4 >> 2] = HEAPU8[$15 >> 0] | 0 | ((HEAPU8[($15 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($15 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($15 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $1 = ($2 + 16 | 0) + 16 | 0;
    i64toi32_i32$2 = $0 + 16 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $41 = i64toi32_i32$0;
    i64toi32_i32$0 = $1;
    HEAP32[i64toi32_i32$0 >> 2] = $41;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    $5 = ($2 + 16 | 0) + 8 | 0;
    i64toi32_i32$2 = $0 + 8 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $48 = i64toi32_i32$1;
    i64toi32_i32$1 = $5;
    HEAP32[i64toi32_i32$1 >> 2] = $48;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $51 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[($2 + 16 | 0) >> 2] = $51;
    HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$1;
    core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
    HEAP32[(($2 + 48 | 0) + 24 | 0) >> 2] = HEAP32[$4 >> 2] | 0;
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $66 = i64toi32_i32$1;
    i64toi32_i32$1 = ($2 + 48 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $66;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $5;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $71 = i64toi32_i32$0;
    i64toi32_i32$0 = ($2 + 48 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $71;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
    $74 = i64toi32_i32$1;
    i64toi32_i32$1 = i64toi32_i32$2;
    HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = $74;
    HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = i64toi32_i32$0;
    $0 = $cardano_serialization_lib__crypto__ScriptHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hcd9bcfbb1bcf9de7(i64toi32_i32$2 + 48 | 0 | 0) | 0;
    global$0 = i64toi32_i32$2 + 80 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  core__panicking__panic_bounds_check__h808b524af17640b1($1 | 0, $3 | 0, 1054100 | 0);
  abort();
 }
 
 function vkeys_get($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $3 = 0, $4 = 0, $5 = 0, $34 = 0, $41 = 0, $48 = 0, $51 = 0, $61 = 0, $66 = 0, $71 = 0, $74 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__hcbf9fa57042ff117($2 + 8 | 0 | 0, $0 | 0);
    $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
    if ($3 >>> 0 <= $1 >>> 0) {
     break label$1
    }
    $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $4 = ($2 + 16 | 0) + 24 | 0;
    $0 = (HEAP32[$0 >> 2] | 0) + ($1 << 5 | 0) | 0;
    i64toi32_i32$2 = $0 + 24 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $34 = i64toi32_i32$0;
    i64toi32_i32$0 = $4;
    HEAP32[i64toi32_i32$0 >> 2] = $34;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    $1 = ($2 + 16 | 0) + 16 | 0;
    i64toi32_i32$2 = $0 + 16 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $41 = i64toi32_i32$1;
    i64toi32_i32$1 = $1;
    HEAP32[i64toi32_i32$1 >> 2] = $41;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    $5 = ($2 + 16 | 0) + 8 | 0;
    i64toi32_i32$2 = $0 + 8 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $48 = i64toi32_i32$0;
    i64toi32_i32$0 = $5;
    HEAP32[i64toi32_i32$0 >> 2] = $48;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $51 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $51;
    HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
    i64toi32_i32$2 = $4;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $61 = i64toi32_i32$0;
    i64toi32_i32$0 = ($2 + 48 | 0) + 24 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $61;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $66 = i64toi32_i32$1;
    i64toi32_i32$1 = ($2 + 48 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $66;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $5;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $71 = i64toi32_i32$0;
    i64toi32_i32$0 = ($2 + 48 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $71;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
    $74 = i64toi32_i32$1;
    i64toi32_i32$1 = i64toi32_i32$2;
    HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = $74;
    HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = i64toi32_i32$0;
    $0 = $cardano_serialization_lib__crypto__Vkey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h0c56da261e90089c(i64toi32_i32$2 + 48 | 0 | 0) | 0;
    global$0 = i64toi32_i32$2 + 80 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  core__panicking__panic_bounds_check__h808b524af17640b1($1 | 0, $3 | 0, 1066652 | 0);
  abort();
 }
 
 function publickeys_get($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $3 = 0, $4 = 0, $5 = 0, $34 = 0, $41 = 0, $48 = 0, $51 = 0, $61 = 0, $66 = 0, $71 = 0, $74 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__he8e3d260cc550142($2 + 8 | 0 | 0, $0 | 0);
    $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
    if ($3 >>> 0 <= $1 >>> 0) {
     break label$1
    }
    $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $4 = ($2 + 16 | 0) + 24 | 0;
    $0 = (HEAP32[$0 >> 2] | 0) + ($1 << 5 | 0) | 0;
    i64toi32_i32$2 = $0 + 24 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $34 = i64toi32_i32$0;
    i64toi32_i32$0 = $4;
    HEAP32[i64toi32_i32$0 >> 2] = $34;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    $1 = ($2 + 16 | 0) + 16 | 0;
    i64toi32_i32$2 = $0 + 16 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $41 = i64toi32_i32$1;
    i64toi32_i32$1 = $1;
    HEAP32[i64toi32_i32$1 >> 2] = $41;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    $5 = ($2 + 16 | 0) + 8 | 0;
    i64toi32_i32$2 = $0 + 8 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $48 = i64toi32_i32$0;
    i64toi32_i32$0 = $5;
    HEAP32[i64toi32_i32$0 >> 2] = $48;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $51 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $51;
    HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
    i64toi32_i32$2 = $4;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $61 = i64toi32_i32$0;
    i64toi32_i32$0 = ($2 + 48 | 0) + 24 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $61;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $66 = i64toi32_i32$1;
    i64toi32_i32$1 = ($2 + 48 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $66;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $5;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $71 = i64toi32_i32$0;
    i64toi32_i32$0 = ($2 + 48 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $71;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
    $74 = i64toi32_i32$1;
    i64toi32_i32$1 = i64toi32_i32$2;
    HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = $74;
    HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = i64toi32_i32$0;
    $0 = $cardano_serialization_lib__crypto__PublicKey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h435bbe8dcccd675c(i64toi32_i32$2 + 48 | 0 | 0) | 0;
    global$0 = i64toi32_i32$2 + 80 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  core__panicking__panic_bounds_check__h808b524af17640b1($1 | 0, $3 | 0, 1066732 | 0);
  abort();
 }
 
 function $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__h98fa0a7e5178e672($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, $3 = 0, i64toi32_i32$0 = 0, $4 = 0, $5 = 0, $67 = 0, $78 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     $3 = HEAP32[$1 >> 2] | 0;
     if (($3 | 0) == (HEAP32[($1 + 4 | 0) >> 2] | 0 | 0)) {
      break label$3
     }
     HEAP32[$1 >> 2] = HEAP32[($3 + 100 | 0) >> 2] | 0;
     $4 = (HEAP32[($1 + 8 | 0) >> 2] | 0) + -1 | 0;
     HEAP32[($1 + 8 | 0) >> 2] = $4;
     core__ops__function__impls___impl_20core__ops__function__FnOnce_A__20for_20_mut_20F___call_once__ha9dfc67ebd737082($2 + 32 | 0 | 0, $1 | 0, $3 | 0, $3 + 48 | 0 | 0);
     if ((HEAP32[($2 + 32 | 0) >> 2] | 0 | 0) != (5 | 0)) {
      break label$2
     }
    }
    i64toi32_i32$1 = $0;
    i64toi32_i32$0 = 0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = 0;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[i64toi32_i32$1 >> 2] = HEAP32[(0 + 1067624 | 0) >> 2] | 0;
    break label$1;
   }
   $3 = $4 + 1 | 0;
   alloc__raw_vec__RawVec_T_2cA___allocate_in__hd4ae7e11703b95a3($2 + 8 | 0 | 0, ($3 >>> 0 < $4 >>> 0 ? -1 : $3) | 0, 0 | 0);
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = memmove(HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, $2 + 32 | 0 | 0, 48 | 0) | 0;
   $5 = ($2 + 16 | 0) + 8 | 0;
   HEAP32[$5 >> 2] = 1;
   HEAP32[($2 + 20 | 0) >> 2] = $3;
   HEAP32[($2 + 16 | 0) >> 2] = $4;
   HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   $67 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   HEAP32[($2 + 32 | 0) >> 2] = $67;
   HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
   alloc__vec__Vec_T_2cA___extend_desugared__h63aff0d1a950f740($2 + 16 | 0 | 0, $2 + 32 | 0 | 0);
   HEAP32[($0 + 8 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   $78 = i64toi32_i32$1;
   i64toi32_i32$1 = $0;
   HEAP32[i64toi32_i32$1 >> 2] = $78;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  }
  global$0 = $2 + 80 | 0;
 }
 
 function std__sys_common__thread_info__ThreadInfo__with___7b_7bclosure_7d_7d__h1dbe3ea3b6375635($0) {
  $0 = $0 | 0;
  var $2 = 0, $1 = 0, $3 = 0, $4 = 0;
  $1 = global$0 - 32 | 0;
  global$0 = $1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $2 = HEAP32[$0 >> 2] | 0;
      if (($2 + 1 | 0 | 0) <= (0 | 0)) {
       break label$4
      }
      label$5 : {
       $3 = HEAP32[($0 + 4 | 0) >> 2] | 0;
       if ($3) {
        break label$5
       }
       HEAP32[($1 + 8 | 0) >> 2] = 0;
       $3 = std__thread__Thread__new__h9938a1a5d62ffab4($1 + 8 | 0 | 0) | 0;
       if (HEAP32[$0 >> 2] | 0) {
        break label$3
       }
       HEAP32[$0 >> 2] = -1;
       label$6 : {
        $2 = HEAP32[($0 + 4 | 0) >> 2] | 0;
        if (!$2) {
         break label$6
        }
        $4 = HEAP32[$2 >> 2] | 0;
        HEAP32[$2 >> 2] = $4 + -1 | 0;
        if (($4 | 0) != (1 | 0)) {
         break label$6
        }
        alloc__sync__Arc_T___drop_slow__h1342fde892a03e74(HEAP32[($0 + 4 | 0) >> 2] | 0 | 0);
       }
       HEAP32[($0 + 4 | 0) >> 2] = $3;
       $2 = (HEAP32[$0 >> 2] | 0) + 1 | 0;
       HEAP32[$0 >> 2] = $2;
      }
      if ($2) {
       break label$2
      }
      HEAP32[$0 >> 2] = -1;
      $2 = HEAP32[$3 >> 2] | 0;
      HEAP32[$3 >> 2] = $2 + 1 | 0;
      if (($2 | 0) <= (-1 | 0)) {
       break label$1
      }
      HEAP32[$0 >> 2] = (HEAP32[$0 >> 2] | 0) + 1 | 0;
      global$0 = $1 + 32 | 0;
      return $3 | 0;
     }
     core__result__unwrap_failed__h27f43d993c3864a1(1142276 | 0, 24 | 0, $1 + 24 | 0 | 0, 1142520 | 0, 1144188 | 0);
     abort();
    }
    core__result__unwrap_failed__h27f43d993c3864a1(1142260 | 0, 16 | 0, $1 + 24 | 0 | 0, 1142504 | 0, 1144204 | 0);
    abort();
   }
   core__result__unwrap_failed__h27f43d993c3864a1(1142260 | 0, 16 | 0, $1 + 24 | 0 | 0, 1142504 | 0, 1144220 | 0);
   abort();
  }
  abort();
 }
 
 function $_mut_20W_20as_20core__fmt__Write___write_char__h4b23c146a3be0957($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $0 = HEAP32[$0 >> 2] | 0;
  HEAP32[($2 + 12 | 0) >> 2] = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ($1 >>> 0 < 128 >>> 0) {
       break label$4
      }
      if ($1 >>> 0 < 2048 >>> 0) {
       break label$3
      }
      if ($1 >>> 0 >= 65536 >>> 0) {
       break label$2
      }
      HEAP8[($2 + 14 | 0) >> 0] = $1 & 63 | 0 | 128 | 0;
      HEAP8[($2 + 12 | 0) >> 0] = $1 >>> 12 | 0 | 224 | 0;
      HEAP8[($2 + 13 | 0) >> 0] = ($1 >>> 6 | 0) & 63 | 0 | 128 | 0;
      $1 = 3;
      break label$1;
     }
     HEAP8[($2 + 12 | 0) >> 0] = $1;
     $1 = 1;
     break label$1;
    }
    HEAP8[($2 + 13 | 0) >> 0] = $1 & 63 | 0 | 128 | 0;
    HEAP8[($2 + 12 | 0) >> 0] = $1 >>> 6 | 0 | 192 | 0;
    $1 = 2;
    break label$1;
   }
   HEAP8[($2 + 15 | 0) >> 0] = $1 & 63 | 0 | 128 | 0;
   HEAP8[($2 + 12 | 0) >> 0] = $1 >>> 18 | 0 | 240 | 0;
   HEAP8[($2 + 14 | 0) >> 0] = ($1 >>> 6 | 0) & 63 | 0 | 128 | 0;
   HEAP8[($2 + 13 | 0) >> 0] = ($1 >>> 12 | 0) & 63 | 0 | 128 | 0;
   $1 = 4;
  }
  $1 = $core__fmt__builders__PadAdapter_20as_20core__fmt__Write___write_str__h2104fbe324f8507b($0 | 0, $2 + 12 | 0 | 0, $1 | 0) | 0;
  global$0 = $2 + 16 | 0;
  return $1 | 0;
 }
 
 function cardano_serialization_lib__MultiAsset__set_asset__hf25496807382656e($0, $1, $2, $3, $4, $4$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  $4$hi = $4$hi | 0;
  var i64toi32_i32$2 = 0, $5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $14 = 0, $20 = 0, $26 = 0, $29 = 0, $73 = 0;
  $5 = global$0 - 128 | 0;
  global$0 = $5;
  $14 = $2 + 24 | 0;
  HEAP32[(($5 + 64 | 0) + 24 | 0) >> 2] = HEAPU8[$14 >> 0] | 0 | ((HEAPU8[($14 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($14 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($14 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $2 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = ($5 + 64 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $20;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $26 = i64toi32_i32$1;
  i64toi32_i32$1 = ($5 + 64 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $26;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $29 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[($5 + 64 | 0) >> 2] = $29;
  HEAP32[($5 + 68 | 0) >> 2] = i64toi32_i32$1;
  alloc__collections__btree__map__BTreeMap_K_2cV___entry__hd27d6127e1982e7e($5 + 16 | 0 | 0, $1 | 0, $5 + 64 | 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[($5 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    memcpy($5 + 64 | 0 | 0, $5 + 16 | 0 | 4 | 0 | 0, 44 | 0) | 0;
    i64toi32_i32$0 = $5;
    i64toi32_i32$1 = 0;
    HEAP32[($5 + 116 | 0) >> 2] = 0;
    HEAP32[($5 + 120 | 0) >> 2] = i64toi32_i32$1;
    $2 = alloc__collections__btree__map__entry__VacantEntry_K_2cV___insert__h1ccac11121812f65($5 + 64 | 0 | 0, $5 + 112 | 0 | 0) | 0;
    break label$1;
   }
   $2 = ((HEAP32[(($5 + 16 | 0) + 8 | 0) >> 2] | 0) + Math_imul(HEAP32[(($5 + 16 | 0) + 12 | 0) >> 2] | 0, 12) | 0) + 4 | 0;
  }
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($5 + 16 | 0 | 0, $3 | 0);
  i64toi32_i32$1 = $4$hi;
  alloc__collections__btree__map__BTreeMap_K_2cV___insert__hc7622c6487a4ba88($5 | 0, $2 | 0, $5 + 16 | 0 | 0, $4 | 0, i64toi32_i32$1 | 0);
  i64toi32_i32$2 = $5;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $4 = i64toi32_i32$1;
  $4$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $73 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $73;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $4$hi;
  HEAP32[i64toi32_i32$0 >> 2] = $4;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = i64toi32_i32$2 + 128 | 0;
 }
 
 function transactionbuilder_add_json_metadatum_with_schema($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, $6 = 0, $7 = 0, i64toi32_i32$1 = 0;
  $5 = global$0 - 64 | 0;
  global$0 = $5;
  label$1 : {
   label$2 : {
    label$3 : {
     if (!$0) {
      break label$3
     }
     wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h5566e1c7d4aafe35($5 + 24 | 0 | 0, $0 | 0);
     if (!$1) {
      break label$3
     }
     $6 = HEAP32[($5 + 28 | 0) >> 2] | 0;
     $7 = HEAP32[($5 + 24 | 0) >> 2] | 0;
     wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($5 + 16 | 0 | 0, $1 | 0);
     $0 = HEAP32[($5 + 20 | 0) >> 2] | 0;
     $1 = HEAP32[($5 + 16 | 0) >> 2] | 0;
     HEAP32[($5 + 56 | 0) >> 2] = $3;
     HEAP32[($5 + 52 | 0) >> 2] = $3;
     HEAP32[($5 + 48 | 0) >> 2] = $2;
     alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($5 + 8 | 0 | 0, $5 + 48 | 0 | 0);
     $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($5 + 32 | 0 | 0, HEAP32[($5 + 8 | 0) >> 2] | 0 | 0, HEAP32[($5 + 12 | 0) >> 2] | 0 | 0);
     if ($4 >>> 0 >= 3 >>> 0) {
      break label$2
     }
     HEAP32[(($5 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($5 + 32 | 0) + 8 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($5 + 36 | 0) >> 2] | 0;
     HEAP32[($5 + 48 | 0) >> 2] = HEAP32[($5 + 32 | 0) >> 2] | 0;
     HEAP32[($5 + 52 | 0) >> 2] = i64toi32_i32$1;
     cardano_serialization_lib__tx_builder__TransactionBuilder__add_json_metadatum_with_schema__h378f72e2b00e53e2($5 | 0, $7 | 0, $1 | 0, $5 + 48 | 0 | 0, $4 | 0);
     $3 = HEAP32[($5 + 4 | 0) >> 2] | 0;
     $1 = HEAP32[$5 >> 2] | 0;
     core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
     core__cell__Cell_T___replace__h74ad9f426af36be8($6 | 0, 0 | 0) | 0;
     if ($1) {
      break label$1
     }
     global$0 = $5 + 64 | 0;
     return;
    }
    wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
    abort();
   }
   wasm_bindgen__throw_str__h40ff0247f6a635d7(1064279 | 0, 25 | 0);
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472($3 | 0);
  abort();
 }
 
 function stakecredential_to_keyhash($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $2 = 0, $15 = 0, $3 = 0, $4 = 0, $5 = 0, $34 = 0, $41 = 0, $44 = 0, $59 = 0, $64 = 0, $67 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h7d8a0640f2deb41e($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   label$2 : {
    label$3 : {
     $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     if ((HEAPU8[$2 >> 0] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     $3 = ($1 + 16 | 0) + 24 | 0;
     $15 = $2 + 25 | 0;
     HEAP32[$3 >> 2] = HEAPU8[$15 >> 0] | 0 | ((HEAPU8[($15 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($15 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($15 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $4 = ($1 + 16 | 0) + 16 | 0;
     i64toi32_i32$2 = $2 + 17 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $34 = i64toi32_i32$0;
     i64toi32_i32$0 = $4;
     HEAP32[i64toi32_i32$0 >> 2] = $34;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     $5 = ($1 + 16 | 0) + 8 | 0;
     i64toi32_i32$2 = $2 + 9 | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $41 = i64toi32_i32$1;
     i64toi32_i32$1 = $5;
     HEAP32[i64toi32_i32$1 >> 2] = $41;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $44 = i64toi32_i32$0;
     i64toi32_i32$0 = $1;
     HEAP32[($1 + 16 | 0) >> 2] = $44;
     HEAP32[($1 + 20 | 0) >> 2] = i64toi32_i32$1;
     core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
     HEAP32[(($1 + 48 | 0) + 24 | 0) >> 2] = HEAP32[$3 >> 2] | 0;
     i64toi32_i32$2 = $4;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $59 = i64toi32_i32$1;
     i64toi32_i32$1 = ($1 + 48 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $59;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $5;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $64 = i64toi32_i32$0;
     i64toi32_i32$0 = ($1 + 48 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $64;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $1;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
     $67 = i64toi32_i32$1;
     i64toi32_i32$1 = i64toi32_i32$2;
     HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = $67;
     HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = i64toi32_i32$0;
     $0 = $cardano_serialization_lib__crypto__Ed25519KeyHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hd63cf82b6a769066(i64toi32_i32$2 + 48 | 0 | 0) | 0;
     break label$2;
    }
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    $0 = 0;
   }
   global$0 = $1 + 80 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function stakecredential_to_scripthash($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $2 = 0, $15 = 0, $3 = 0, $4 = 0, $5 = 0, $34 = 0, $41 = 0, $44 = 0, $59 = 0, $64 = 0, $67 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h7d8a0640f2deb41e($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   label$2 : {
    label$3 : {
     $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     if ((HEAPU8[$2 >> 0] | 0 | 0) != (1 | 0)) {
      break label$3
     }
     $3 = ($1 + 16 | 0) + 24 | 0;
     $15 = $2 + 25 | 0;
     HEAP32[$3 >> 2] = HEAPU8[$15 >> 0] | 0 | ((HEAPU8[($15 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($15 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($15 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $4 = ($1 + 16 | 0) + 16 | 0;
     i64toi32_i32$2 = $2 + 17 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $34 = i64toi32_i32$0;
     i64toi32_i32$0 = $4;
     HEAP32[i64toi32_i32$0 >> 2] = $34;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     $5 = ($1 + 16 | 0) + 8 | 0;
     i64toi32_i32$2 = $2 + 9 | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $41 = i64toi32_i32$1;
     i64toi32_i32$1 = $5;
     HEAP32[i64toi32_i32$1 >> 2] = $41;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $44 = i64toi32_i32$0;
     i64toi32_i32$0 = $1;
     HEAP32[($1 + 16 | 0) >> 2] = $44;
     HEAP32[($1 + 20 | 0) >> 2] = i64toi32_i32$1;
     core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
     HEAP32[(($1 + 48 | 0) + 24 | 0) >> 2] = HEAP32[$3 >> 2] | 0;
     i64toi32_i32$2 = $4;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $59 = i64toi32_i32$1;
     i64toi32_i32$1 = ($1 + 48 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $59;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $5;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $64 = i64toi32_i32$0;
     i64toi32_i32$0 = ($1 + 48 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $64;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $1;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
     $67 = i64toi32_i32$1;
     i64toi32_i32$1 = i64toi32_i32$2;
     HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = $67;
     HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = i64toi32_i32$0;
     $0 = $cardano_serialization_lib__crypto__ScriptHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hcd9bcfbb1bcf9de7(i64toi32_i32$2 + 48 | 0 | 0) | 0;
     break label$2;
    }
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    $0 = 0;
   }
   global$0 = $1 + 80 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function num_bigint__biguint__subtraction__sub2__h0b2286b660c85b0d($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, i64toi32_i32$5 = 0, $8 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $7 = 0, $4 = 0, $6 = 0, $5 = 0, $9$hi = 0, $9 = 0, $25 = 0, $27 = 0, $29 = 0, $31 = 0, $26 = 0, $28 = 0, $28$hi = 0, $30 = 0, $30$hi = 0, $31$hi = 0, $10 = 0, $10$hi = 0;
  $4 = $1 >>> 0 > $3 >>> 0 ? $3 : $1;
  $5 = $4 << 2 | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     if (!$4) {
      break label$3
     }
     $6 = $0 + $5 | 0;
     i64toi32_i32$0 = 0;
     $9 = 0;
     $9$hi = i64toi32_i32$0;
     $7 = $4;
     $8 = $2;
     label$4 : while (1) {
      $26 = $0;
      i64toi32_i32$2 = $0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = 0;
      $28 = i64toi32_i32$0;
      $28$hi = i64toi32_i32$1;
      i64toi32_i32$2 = $8;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = 0;
      $30 = i64toi32_i32$1;
      $30$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $28$hi;
      i64toi32_i32$2 = $28;
      i64toi32_i32$1 = $30$hi;
      i64toi32_i32$3 = $30;
      i64toi32_i32$4 = i64toi32_i32$2 - i64toi32_i32$3 | 0;
      i64toi32_i32$5 = (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) + i64toi32_i32$1 | 0;
      i64toi32_i32$5 = i64toi32_i32$0 - i64toi32_i32$5 | 0;
      $31$hi = i64toi32_i32$5;
      i64toi32_i32$5 = $9$hi;
      i64toi32_i32$5 = $31$hi;
      i64toi32_i32$0 = i64toi32_i32$4;
      i64toi32_i32$2 = $9$hi;
      i64toi32_i32$3 = $9;
      i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
      i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
      if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
       i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
      }
      $10 = i64toi32_i32$1;
      $10$hi = i64toi32_i32$4;
      HEAP32[$26 >> 2] = i64toi32_i32$1;
      $0 = $0 + 4 | 0;
      $8 = $8 + 4 | 0;
      i64toi32_i32$5 = i64toi32_i32$1;
      i64toi32_i32$0 = 0;
      i64toi32_i32$3 = 63;
      i64toi32_i32$2 = i64toi32_i32$3 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
       i64toi32_i32$0 = i64toi32_i32$4 >> 31 | 0;
       $25 = i64toi32_i32$4 >> i64toi32_i32$2 | 0;
      } else {
       i64toi32_i32$0 = i64toi32_i32$4 >> i64toi32_i32$2 | 0;
       $25 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$2 | 0) | 0;
      }
      $9 = $25;
      $9$hi = i64toi32_i32$0;
      $7 = $7 + -1 | 0;
      if ($7) {
       continue label$4
      }
      break label$4;
     };
     i64toi32_i32$0 = $10$hi;
     i64toi32_i32$4 = $10;
     i64toi32_i32$5 = -1;
     i64toi32_i32$3 = -1;
     if ((i64toi32_i32$0 | 0) > (i64toi32_i32$5 | 0)) {
      $27 = 1
     } else {
      if ((i64toi32_i32$0 | 0) >= (i64toi32_i32$5 | 0)) {
       if (i64toi32_i32$4 >>> 0 <= i64toi32_i32$3 >>> 0) {
        $29 = 0
       } else {
        $29 = 1
       }
       $31 = $29;
      } else {
       $31 = 0
      }
      $27 = $31;
     }
     if ($27) {
      break label$3
     }
     $0 = ($1 << 2 | 0) - ($4 << 2 | 0) | 0;
     label$5 : while (1) {
      if (!$0) {
       break label$2
      }
      $8 = HEAP32[$6 >> 2] | 0;
      HEAP32[$6 >> 2] = $8 + -1 | 0;
      $0 = $0 + -4 | 0;
      $6 = $6 + 4 | 0;
      if (!$8) {
       continue label$5
      }
      break label$5;
     };
    }
    $8 = $2 + $5 | 0;
    $0 = ($3 << 2 | 0) - $5 | 0;
    label$6 : while (1) {
     if (!$0) {
      break label$1
     }
     $0 = $0 + -4 | 0;
     $7 = HEAP32[$8 >> 2] | 0;
     $8 = $8 + 4 | 0;
     if (!$7) {
      continue label$6
     }
     break label$6;
    };
   }
   std__panicking__begin_panic__hf55b754840077f11(1077561 | 0, 52 | 0, 1077724 | 0);
   abort();
  }
 }
 
 function alloc__raw_vec__RawVec_T_2cA___grow_amortized__hf99f6d638db950d2($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $5 = 0, i64toi32_i32$1 = 0;
  $4 = global$0 - 32 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    $3 = $2 + $3 | 0;
    if ($3 >>> 0 < $2 >>> 0) {
     break label$2
    }
    $5 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $2 = $5 << 1 | 0;
    $2 = $2 >>> 0 > $3 >>> 0 ? $2 : $3;
    $2 = $2 >>> 0 > 4 >>> 0 ? $2 : 4;
    $3 = (($2 & 1073741823 | 0 | 0) == ($2 | 0)) << 2 | 0;
    $2 = $2 << 2 | 0;
    label$3 : {
     label$4 : {
      if (!$5) {
       break label$4
      }
      HEAP32[($4 + 24 | 0) >> 2] = 4;
      HEAP32[($4 + 20 | 0) >> 2] = $5 << 2 | 0;
      HEAP32[($4 + 16 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
      break label$3;
     }
     HEAP32[($4 + 16 | 0) >> 2] = 0;
    }
    alloc__raw_vec__finish_grow__h4c09fb07da592cb2($4 | 0, $2 | 0, $3 | 0, $4 + 16 | 0 | 0, $4 | 0);
    $2 = 1;
    label$5 : {
     if ((HEAP32[$4 >> 2] | 0 | 0) == (1 | 0)) {
      break label$5
     }
     $2 = HEAP32[($4 + 4 | 0) >> 2] | 0;
     HEAP32[($1 + 4 | 0) >> 2] = (HEAP32[($4 + 8 | 0) >> 2] | 0) >>> 2 | 0;
     HEAP32[$1 >> 2] = $2;
     $2 = 0;
     break label$1;
    }
    i64toi32_i32$1 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($4 + 4 | 0) >> 2] | 0;
    HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$1;
    break label$1;
   }
   HEAP32[($0 + 4 | 0) >> 2] = $3;
   HEAP32[($0 + 8 | 0) >> 2] = 0;
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $4 + 32 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___grow_amortized__he5593839a7b4f848($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $5 = 0, i64toi32_i32$1 = 0;
  $4 = global$0 - 32 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    $3 = $2 + $3 | 0;
    if ($3 >>> 0 < $2 >>> 0) {
     break label$2
    }
    $5 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $2 = $5 << 1 | 0;
    $2 = $2 >>> 0 > $3 >>> 0 ? $2 : $3;
    $2 = $2 >>> 0 > 4 >>> 0 ? $2 : 4;
    $3 = (($2 & 1073741823 | 0 | 0) == ($2 | 0)) << 2 | 0;
    $2 = $2 << 2 | 0;
    label$3 : {
     label$4 : {
      if (!$5) {
       break label$4
      }
      HEAP32[($4 + 24 | 0) >> 2] = 4;
      HEAP32[($4 + 20 | 0) >> 2] = $5 << 2 | 0;
      HEAP32[($4 + 16 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
      break label$3;
     }
     HEAP32[($4 + 16 | 0) >> 2] = 0;
    }
    alloc__raw_vec__finish_grow__h889b166b5e37b56f($4 | 0, $2 | 0, $3 | 0, $4 + 16 | 0 | 0, $4 | 0);
    $2 = 1;
    label$5 : {
     if ((HEAP32[$4 >> 2] | 0 | 0) == (1 | 0)) {
      break label$5
     }
     $2 = HEAP32[($4 + 4 | 0) >> 2] | 0;
     HEAP32[($1 + 4 | 0) >> 2] = (HEAP32[($4 + 8 | 0) >> 2] | 0) >>> 2 | 0;
     HEAP32[$1 >> 2] = $2;
     $2 = 0;
     break label$1;
    }
    i64toi32_i32$1 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($4 + 4 | 0) >> 2] | 0;
    HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$1;
    break label$1;
   }
   HEAP32[($0 + 4 | 0) >> 2] = $3;
   HEAP32[($0 + 8 | 0) >> 2] = 0;
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $4 + 32 | 0;
 }
 
 function transactioninputs_get($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $2 = 0, $3 = 0, $4 = 0, $5 = 0, $32 = 0, $38 = 0, $44 = 0, $47 = 0, $59 = 0, $64 = 0, $69 = 0, $74 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__hf2abefb15e68f011($2 | 0, $0 | 0);
    $0 = HEAP32[$2 >> 2] | 0;
    $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
    if ($3 >>> 0 <= $1 >>> 0) {
     break label$1
    }
    $3 = HEAP32[($2 + 4 | 0) >> 2] | 0;
    $4 = $2 + 32 | 0;
    $0 = (HEAP32[$0 >> 2] | 0) + Math_imul($1, 36) | 0;
    i64toi32_i32$2 = $0 + 28 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $32 = i64toi32_i32$0;
    i64toi32_i32$0 = $4;
    HEAP32[i64toi32_i32$0 >> 2] = $32;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    $1 = $2 + 24 | 0;
    i64toi32_i32$2 = $0 + 20 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $38 = i64toi32_i32$1;
    i64toi32_i32$1 = $1;
    HEAP32[i64toi32_i32$1 >> 2] = $38;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    $5 = $2 + 16 | 0;
    i64toi32_i32$2 = $0 + 12 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $44 = i64toi32_i32$0;
    i64toi32_i32$0 = $5;
    HEAP32[i64toi32_i32$0 >> 2] = $44;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
    $47 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $47;
    HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
    $0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
    i64toi32_i32$2 = $5;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $59 = i64toi32_i32$0;
    i64toi32_i32$0 = ($2 + 40 | 0) + 12 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $59;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $64 = i64toi32_i32$1;
    i64toi32_i32$1 = ($2 + 40 | 0) + 20 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $64;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $4;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $69 = i64toi32_i32$0;
    i64toi32_i32$0 = ($2 + 40 | 0) + 28 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $69;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($2 + 40 | 0) >> 2] = $0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
    $74 = i64toi32_i32$1;
    i64toi32_i32$1 = i64toi32_i32$2;
    HEAP32[(i64toi32_i32$1 + 44 | 0) >> 2] = $74;
    HEAP32[(i64toi32_i32$1 + 48 | 0) >> 2] = i64toi32_i32$0;
    $0 = $cardano_serialization_lib__TransactionInput_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hf06f9abbcbb78385(i64toi32_i32$1 + 40 | 0 | 0) | 0;
    global$0 = i64toi32_i32$1 + 80 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  core__panicking__panic_bounds_check__h808b524af17640b1($1 | 0, $3 | 0, 1053176 | 0);
  abort();
 }
 
 function singlehostaddr_new($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, $3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $7 = 0, $8 = 0, $4 = 0, $6 = 0, $22 = 0, $9$hi = 0, $23 = 0, $5 = 0, $27 = 0, $30 = 0, $7$hi = 0, $8$hi = 0, $45 = 0, $9 = 0, $62$hi = 0;
  $3 = global$0 - 64 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    if ($1) {
     break label$2
    }
    $4 = 0;
    break label$1;
   }
   $4 = 1;
   $5 = $cardano_serialization_lib__Ipv4_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h5d10bcbd75649752($1 | 0) | 0;
  }
  label$3 : {
   label$4 : {
    if ($2) {
     break label$4
    }
    $6 = 0;
    $2 = $3 + 48 | 0;
    break label$3;
   }
   $6 = 1;
   $cardano_serialization_lib__Ipv6_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h206d9a425c1d3d2e($3 + 16 | 0 | 1 | 0 | 0, $2 | 0);
   i64toi32_i32$2 = $3 + 25 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $27 = i64toi32_i32$0;
   i64toi32_i32$0 = $3 + 56 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $27;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 17 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 18 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 19 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 20 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 21 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 22 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 23 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 24 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $30 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = $30;
   HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = i64toi32_i32$0;
   $2 = i64toi32_i32$2 + 48 | 0;
  }
  i64toi32_i32$2 = $2 + 8 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$0 = $3 + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $8 = i64toi32_i32$1;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$1 = $3;
  HEAP32[$3 >> 2] = $8;
  HEAP32[($3 + 4 | 0) >> 2] = i64toi32_i32$0;
  $45 = ($3 + 16 | 0) + 8 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 8;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $22 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $22 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  i64toi32_i32$4 = $1;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = i64toi32_i32$4 ? $22 : 0;
  i64toi32_i32$0 = i64toi32_i32$4 ? i64toi32_i32$1 : i64toi32_i32$2;
  $9 = i64toi32_i32$3;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$4 = i64toi32_i32$3;
  i64toi32_i32$3 = 0;
  i64toi32_i32$1 = 32;
  i64toi32_i32$2 = i64toi32_i32$1 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
   i64toi32_i32$3 = 0;
   $23 = i64toi32_i32$0 >>> i64toi32_i32$2 | 0;
  } else {
   i64toi32_i32$3 = i64toi32_i32$0 >>> i64toi32_i32$2 | 0;
   $23 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$2 | 0) | 0;
  }
  HEAP8[$45 >> 0] = $23;
  i64toi32_i32$3 = $8$hi;
  i64toi32_i32$4 = $3 + 26 | 0;
  HEAP16[i64toi32_i32$4 >> 1] = $8;
  HEAP16[(i64toi32_i32$4 + 2 | 0) >> 1] = $8 >>> 16 | 0;
  HEAP16[(i64toi32_i32$4 + 4 | 0) >> 1] = i64toi32_i32$3;
  HEAP16[(i64toi32_i32$4 + 6 | 0) >> 1] = i64toi32_i32$3 >>> 16 | 0;
  i64toi32_i32$3 = $7$hi;
  i64toi32_i32$4 = $3 + 34 | 0;
  HEAP16[i64toi32_i32$4 >> 1] = $7;
  HEAP16[(i64toi32_i32$4 + 2 | 0) >> 1] = $7 >>> 16 | 0;
  HEAP16[(i64toi32_i32$4 + 4 | 0) >> 1] = i64toi32_i32$3;
  HEAP16[(i64toi32_i32$4 + 6 | 0) >> 1] = i64toi32_i32$3 >>> 16 | 0;
  i64toi32_i32$3 = $9$hi;
  i64toi32_i32$3 = 0;
  $62$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $9$hi;
  i64toi32_i32$0 = $9;
  i64toi32_i32$4 = $62$hi;
  i64toi32_i32$1 = $4;
  i64toi32_i32$4 = i64toi32_i32$3 | i64toi32_i32$4 | 0;
  HEAP32[($3 + 20 | 0) >> 2] = i64toi32_i32$0 | i64toi32_i32$1 | 0;
  HEAP8[($3 + 25 | 0) >> 0] = $6;
  HEAP16[($3 + 18 | 0) >> 1] = $0;
  HEAP16[($3 + 16 | 0) >> 1] = ($0 | 0) != (16777215 | 0);
  $1 = $cardano_serialization_lib__SingleHostAddr_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h118dc31a83c6b0e2($3 + 16 | 0 | 0) | 0;
  global$0 = $3 + 64 | 0;
  return $1 | 0;
 }
 
 function protocolparamupdate_set_extra_entropy($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $5 = 0, $17 = 0, $18 = 0, $19 = 0, $20 = 0, $4 = 0, $3 = 0, $33 = 0, $38 = 0, $43 = 0, $46 = 0, $50 = 0, $55 = 0, $60 = 0, $65 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h0a71cd742026514d($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h0e158f5408360d02($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $4 = 0;
   label$2 : {
    $5 = HEAP32[$2 >> 2] | 0;
    if ((HEAPU8[$5 >> 0] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    i64toi32_i32$2 = $5 + 25 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $33 = i64toi32_i32$0;
    i64toi32_i32$0 = $2 + 40 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $33;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $5 + 17 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $38 = i64toi32_i32$1;
    i64toi32_i32$1 = $2 + 32 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $38;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $5 + 9 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $43 = i64toi32_i32$0;
    i64toi32_i32$0 = $2 + 24 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $43;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $5;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $46 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $46;
    HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
    $4 = 1;
   }
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
   $50 = i64toi32_i32$0;
   i64toi32_i32$0 = $0 + 373 | 0;
   $17 = $50;
   HEAP8[i64toi32_i32$0 >> 0] = $17;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $17 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $17 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $17 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = i64toi32_i32$2 + 40 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $55 = i64toi32_i32$1;
   i64toi32_i32$1 = $0 + 397 | 0;
   $18 = $55;
   HEAP8[i64toi32_i32$1 >> 0] = $18;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $18 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $18 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $18 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $2 + 32 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $60 = i64toi32_i32$0;
   i64toi32_i32$0 = $0 + 389 | 0;
   $19 = $60;
   HEAP8[i64toi32_i32$0 >> 0] = $19;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $19 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $19 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $19 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = $2 + 24 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $65 = i64toi32_i32$1;
   i64toi32_i32$1 = $0 + 381 | 0;
   $20 = $65;
   HEAP8[i64toi32_i32$1 >> 0] = $20;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $20 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $20 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $20 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   HEAP8[($0 + 372 | 0) >> 0] = $4;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 48 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function headerbody_operational_cert($0) {
  $0 = $0 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $1 = 0, $2 = 0, $3 = 0, $4 = 0, $5 = 0, $20 = 0, $27 = 0, $34 = 0, $37 = 0, $6 = 0, $6$hi = 0, $56 = 0, $61 = 0, $65 = 0, $70 = 0;
  $1 = global$0 - 208 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h2ac16fcb64db16b5($1 | 0, $0 | 0);
  $2 = $1 + 80 | 0;
  $0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$2 = $0 + 80 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $20;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $3 = ($1 + 72 | 0) + 16 | 0;
  i64toi32_i32$2 = $0 + 88 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $27 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[i64toi32_i32$1 >> 2] = $27;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = ($1 + 72 | 0) + 24 | 0;
  i64toi32_i32$2 = $0 + 96 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $34 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[i64toi32_i32$0 >> 2] = $34;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 72 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 76 | 0) >> 2] | 0;
  $37 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[(i64toi32_i32$1 + 72 | 0) >> 2] = $37;
  HEAP32[(i64toi32_i32$1 + 76 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
  $6 = i64toi32_i32$0;
  $6$hi = i64toi32_i32$1;
  $5 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  memcpy($1 + 8 | 0 | 0, i64toi32_i32$2 + 104 | 0 | 0, 64 | 0) | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($5 | 0, (HEAP32[$5 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $56 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 104 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $56;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $61 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 104 | 0) + 24 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $61;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $65 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 136 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $65;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$1 = $1;
  HEAP32[(i64toi32_i32$1 + 104 | 0) >> 2] = $6;
  HEAP32[(i64toi32_i32$1 + 108 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 72 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$1 + 76 | 0) >> 2] | 0;
  $70 = i64toi32_i32$0;
  i64toi32_i32$0 = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$0 + 112 | 0) >> 2] = $70;
  HEAP32[(i64toi32_i32$0 + 116 | 0) >> 2] = i64toi32_i32$1;
  memcpy(i64toi32_i32$0 + 144 | 0 | 0, i64toi32_i32$0 + 8 | 0 | 0, 64 | 0) | 0;
  $0 = $cardano_serialization_lib__OperationalCert_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h6c0829dce15a5d37(i64toi32_i32$0 + 104 | 0 | 0) | 0;
  global$0 = i64toi32_i32$0 + 208 | 0;
  return $0 | 0;
 }
 
 function cardano_serialization_lib__metadata__TransactionMetadatum__new_bytes__h341a06dfb4f1da88($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, $15 = 0, $36 = 0, $41 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 96 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    if ($3 >>> 0 > 64 >>> 0) {
     break label$2
    }
    i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $15 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 12 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $15;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($0 + 8 | 0) >> 2] = 3;
    HEAP32[($0 + 20 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
    $1 = 0;
    break label$1;
   }
   HEAP32[($2 + 92 | 0) >> 2] = $3;
   core__fmt__ArgumentV1__new__h5702524f4c8ddc75($2 + 24 | 0 | 0, $2 + 92 | 0 | 0, 46 | 0);
   i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 28 | 0) >> 2] | 0;
   core__fmt__ArgumentV1__new__h5702524f4c8ddc75($2 + 16 | 0 | 0, 1060428 | 0, 46 | 0);
   HEAP32[($2 + 68 | 0) >> 2] = 2;
   $36 = i64toi32_i32$1;
   i64toi32_i32$1 = $2;
   HEAP32[($2 + 72 | 0) >> 2] = $36;
   HEAP32[($2 + 76 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$1 = $2;
   i64toi32_i32$0 = 0;
   HEAP32[($2 + 52 | 0) >> 2] = 2;
   HEAP32[($2 + 56 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($2 + 48 | 0) >> 2] = 1060412;
   i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   $41 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   HEAP32[($2 + 80 | 0) >> 2] = $41;
   HEAP32[($2 + 84 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($2 + 64 | 0) >> 2] = $2 + 72 | 0;
   alloc__fmt__format__h6e9e003a52c07309($2 + 32 | 0 | 0, $2 + 48 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $2 + 32 | 0 | 0);
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 32 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 32 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 96 | 0;
 }
 
 function cardano_serialization_lib__metadata__TransactionMetadatum__new_text__hc705d7de2d476a57($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, $17 = 0, $36 = 0, $41 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 96 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    if ($3 >>> 0 > 64 >>> 0) {
     break label$2
    }
    HEAP32[($0 + 8 | 0) >> 2] = 4;
    i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $17 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 12 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $17;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($0 + 20 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
    $1 = 0;
    break label$1;
   }
   HEAP32[($2 + 92 | 0) >> 2] = $3;
   core__fmt__ArgumentV1__new__h5702524f4c8ddc75($2 + 24 | 0 | 0, $2 + 92 | 0 | 0, 46 | 0);
   i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 28 | 0) >> 2] | 0;
   core__fmt__ArgumentV1__new__h5702524f4c8ddc75($2 + 16 | 0 | 0, 1060428 | 0, 46 | 0);
   HEAP32[($2 + 68 | 0) >> 2] = 2;
   $36 = i64toi32_i32$1;
   i64toi32_i32$1 = $2;
   HEAP32[($2 + 72 | 0) >> 2] = $36;
   HEAP32[($2 + 76 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$1 = $2;
   i64toi32_i32$0 = 0;
   HEAP32[($2 + 52 | 0) >> 2] = 2;
   HEAP32[($2 + 56 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($2 + 48 | 0) >> 2] = 1060464;
   i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   $41 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   HEAP32[($2 + 80 | 0) >> 2] = $41;
   HEAP32[($2 + 84 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($2 + 64 | 0) >> 2] = $2 + 72 | 0;
   alloc__fmt__format__h6e9e003a52c07309($2 + 32 | 0 | 0, $2 + 48 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $2 + 32 | 0 | 0);
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 32 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 32 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 96 | 0;
 }
 
 function alloc__vec__Vec_T_2cA___extend_desugared__ha05bcb03e1072897($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $2 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $8 = 0, $26 = 0, $27 = 0, $28 = 0, $29 = 0, $30 = 0, $31 = 0, $4 = 0, $5 = 0, $6 = 0, $7 = 0, $9 = 0, $25 = 0, $37 = 0, $43 = 0, $68 = 0, $76 = 0, $80 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__hbd7038216761c388($2 + 8 | 0 | 0, $1 | 0);
  label$1 : {
   $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   if (!$3) {
    break label$1
   }
   $4 = $2 + 16 | 0 | 1 | 0;
   label$2 : while (1) {
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAPU8[$3 >> 0] | 0 | ((HEAPU8[($3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[($3 + 4 | 0) >> 0] | 0 | ((HEAPU8[($3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $25 = i64toi32_i32$0;
    i64toi32_i32$0 = $4;
    $19 = $25;
    HEAP8[i64toi32_i32$0 >> 0] = $19;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $19 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $19 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $19 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    $5 = i64toi32_i32$0 + 24 | 0;
    $20 = $3 + 24 | 0;
    $21 = $5;
    $22 = HEAPU8[$20 >> 0] | 0 | ((HEAPU8[($20 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($20 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($20 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    HEAP8[$21 >> 0] = $22;
    HEAP8[($21 + 1 | 0) >> 0] = $22 >>> 8 | 0;
    HEAP8[($21 + 2 | 0) >> 0] = $22 >>> 16 | 0;
    HEAP8[($21 + 3 | 0) >> 0] = $22 >>> 24 | 0;
    $6 = i64toi32_i32$0 + 16 | 0;
    i64toi32_i32$2 = $3 + 16 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $37 = i64toi32_i32$1;
    i64toi32_i32$1 = $6;
    $23 = $37;
    HEAP8[i64toi32_i32$1 >> 0] = $23;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $23 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $23 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $23 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    $7 = $4 + 8 | 0;
    i64toi32_i32$2 = $3 + 8 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $43 = i64toi32_i32$0;
    i64toi32_i32$0 = $7;
    $24 = $43;
    HEAP8[i64toi32_i32$0 >> 0] = $24;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $24 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $24 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $24 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    label$3 : {
     $8 = HEAP32[($0 + 8 | 0) >> 2] | 0;
     if ((HEAP32[($0 + 4 | 0) >> 2] | 0 | 0) != ($8 | 0)) {
      break label$3
     }
     $3 = HEAP32[($1 + 24 | 0) >> 2] | 0;
     $9 = $3 + 1 | 0;
     alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h75690594b6280ac0($0 | 0, $8 | 0, ($9 >>> 0 < $3 >>> 0 ? -1 : $9) | 0);
    }
    $3 = (HEAP32[$0 >> 2] | 0) + Math_imul($8, 28) | 0;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $68 = i64toi32_i32$1;
    i64toi32_i32$1 = $3;
    $26 = $68;
    HEAP8[i64toi32_i32$1 >> 0] = $26;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $26 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $26 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $26 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    $27 = $5;
    $28 = i64toi32_i32$1 + 24 | 0;
    $29 = HEAPU8[$27 >> 0] | 0 | ((HEAPU8[($27 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($27 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($27 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    HEAP8[$28 >> 0] = $29;
    HEAP8[($28 + 1 | 0) >> 0] = $29 >>> 8 | 0;
    HEAP8[($28 + 2 | 0) >> 0] = $29 >>> 16 | 0;
    HEAP8[($28 + 3 | 0) >> 0] = $29 >>> 24 | 0;
    i64toi32_i32$2 = $6;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $76 = i64toi32_i32$0;
    i64toi32_i32$0 = $3 + 16 | 0;
    $30 = $76;
    HEAP8[i64toi32_i32$0 >> 0] = $30;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $30 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $30 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $30 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$2 = $7;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $80 = i64toi32_i32$1;
    i64toi32_i32$1 = $3 + 8 | 0;
    $31 = $80;
    HEAP8[i64toi32_i32$1 >> 0] = $31;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $31 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $31 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $31 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    HEAP32[($0 + 8 | 0) >> 2] = $8 + 1 | 0;
    $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__hbd7038216761c388($2 | 0, $1 | 0);
    $3 = HEAP32[$2 >> 2] | 0;
    if ($3) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $2 + 48 | 0;
 }
 
 function alloc__vec__Vec_T_2cA___extend_desugared__h6803022990c07d6f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $2 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $8 = 0, $26 = 0, $27 = 0, $28 = 0, $29 = 0, $30 = 0, $31 = 0, $4 = 0, $5 = 0, $6 = 0, $7 = 0, $9 = 0, $25 = 0, $37 = 0, $43 = 0, $68 = 0, $76 = 0, $80 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h03cc330b7b1e4522($2 + 8 | 0 | 0, $1 | 0);
  label$1 : {
   $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   if (!$3) {
    break label$1
   }
   $4 = $2 + 16 | 0 | 1 | 0;
   label$2 : while (1) {
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAPU8[$3 >> 0] | 0 | ((HEAPU8[($3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[($3 + 4 | 0) >> 0] | 0 | ((HEAPU8[($3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $25 = i64toi32_i32$0;
    i64toi32_i32$0 = $4;
    $19 = $25;
    HEAP8[i64toi32_i32$0 >> 0] = $19;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $19 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $19 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $19 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    $5 = i64toi32_i32$0 + 24 | 0;
    $20 = $3 + 24 | 0;
    $21 = $5;
    $22 = HEAPU8[$20 >> 0] | 0 | ((HEAPU8[($20 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($20 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($20 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    HEAP8[$21 >> 0] = $22;
    HEAP8[($21 + 1 | 0) >> 0] = $22 >>> 8 | 0;
    HEAP8[($21 + 2 | 0) >> 0] = $22 >>> 16 | 0;
    HEAP8[($21 + 3 | 0) >> 0] = $22 >>> 24 | 0;
    $6 = i64toi32_i32$0 + 16 | 0;
    i64toi32_i32$2 = $3 + 16 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $37 = i64toi32_i32$1;
    i64toi32_i32$1 = $6;
    $23 = $37;
    HEAP8[i64toi32_i32$1 >> 0] = $23;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $23 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $23 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $23 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    $7 = $4 + 8 | 0;
    i64toi32_i32$2 = $3 + 8 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $43 = i64toi32_i32$0;
    i64toi32_i32$0 = $7;
    $24 = $43;
    HEAP8[i64toi32_i32$0 >> 0] = $24;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $24 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $24 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $24 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    label$3 : {
     $8 = HEAP32[($0 + 8 | 0) >> 2] | 0;
     if ((HEAP32[($0 + 4 | 0) >> 2] | 0 | 0) != ($8 | 0)) {
      break label$3
     }
     $3 = HEAP32[($1 + 24 | 0) >> 2] | 0;
     $9 = $3 + 1 | 0;
     alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h6efd3441b9caf532($0 | 0, $8 | 0, ($9 >>> 0 < $3 >>> 0 ? -1 : $9) | 0);
    }
    $3 = (HEAP32[$0 >> 2] | 0) + Math_imul($8, 28) | 0;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $68 = i64toi32_i32$1;
    i64toi32_i32$1 = $3;
    $26 = $68;
    HEAP8[i64toi32_i32$1 >> 0] = $26;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $26 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $26 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $26 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    $27 = $5;
    $28 = i64toi32_i32$1 + 24 | 0;
    $29 = HEAPU8[$27 >> 0] | 0 | ((HEAPU8[($27 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($27 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($27 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    HEAP8[$28 >> 0] = $29;
    HEAP8[($28 + 1 | 0) >> 0] = $29 >>> 8 | 0;
    HEAP8[($28 + 2 | 0) >> 0] = $29 >>> 16 | 0;
    HEAP8[($28 + 3 | 0) >> 0] = $29 >>> 24 | 0;
    i64toi32_i32$2 = $6;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $76 = i64toi32_i32$0;
    i64toi32_i32$0 = $3 + 16 | 0;
    $30 = $76;
    HEAP8[i64toi32_i32$0 >> 0] = $30;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $30 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $30 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $30 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$2 = $7;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $80 = i64toi32_i32$1;
    i64toi32_i32$1 = $3 + 8 | 0;
    $31 = $80;
    HEAP8[i64toi32_i32$1 >> 0] = $31;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $31 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $31 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $31 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    HEAP32[($0 + 8 | 0) >> 2] = $8 + 1 | 0;
    $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h03cc330b7b1e4522($2 | 0, $1 | 0);
    $3 = HEAP32[$2 >> 2] | 0;
    if ($3) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $2 + 48 | 0;
 }
 
 function alloc__vec__Vec_T_2cA___extend_desugared__hc08b504a96d15531($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $2 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $8 = 0, $26 = 0, $27 = 0, $28 = 0, $29 = 0, $30 = 0, $31 = 0, $4 = 0, $5 = 0, $6 = 0, $7 = 0, $9 = 0, $25 = 0, $37 = 0, $43 = 0, $68 = 0, $76 = 0, $80 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h32d71c96a3c9fef9($2 + 8 | 0 | 0, $1 | 0);
  label$1 : {
   $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   if (!$3) {
    break label$1
   }
   $4 = $2 + 16 | 0 | 1 | 0;
   label$2 : while (1) {
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAPU8[$3 >> 0] | 0 | ((HEAPU8[($3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[($3 + 4 | 0) >> 0] | 0 | ((HEAPU8[($3 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $25 = i64toi32_i32$0;
    i64toi32_i32$0 = $4;
    $19 = $25;
    HEAP8[i64toi32_i32$0 >> 0] = $19;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $19 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $19 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $19 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    $5 = i64toi32_i32$0 + 24 | 0;
    $20 = $3 + 24 | 0;
    $21 = $5;
    $22 = HEAPU8[$20 >> 0] | 0 | ((HEAPU8[($20 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($20 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($20 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    HEAP8[$21 >> 0] = $22;
    HEAP8[($21 + 1 | 0) >> 0] = $22 >>> 8 | 0;
    HEAP8[($21 + 2 | 0) >> 0] = $22 >>> 16 | 0;
    HEAP8[($21 + 3 | 0) >> 0] = $22 >>> 24 | 0;
    $6 = i64toi32_i32$0 + 16 | 0;
    i64toi32_i32$2 = $3 + 16 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $37 = i64toi32_i32$1;
    i64toi32_i32$1 = $6;
    $23 = $37;
    HEAP8[i64toi32_i32$1 >> 0] = $23;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $23 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $23 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $23 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    $7 = $4 + 8 | 0;
    i64toi32_i32$2 = $3 + 8 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $43 = i64toi32_i32$0;
    i64toi32_i32$0 = $7;
    $24 = $43;
    HEAP8[i64toi32_i32$0 >> 0] = $24;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $24 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $24 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $24 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    label$3 : {
     $8 = HEAP32[($0 + 8 | 0) >> 2] | 0;
     if ((HEAP32[($0 + 4 | 0) >> 2] | 0 | 0) != ($8 | 0)) {
      break label$3
     }
     $3 = HEAP32[($1 + 24 | 0) >> 2] | 0;
     $9 = $3 + 1 | 0;
     alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h6efd3441b9caf532($0 | 0, $8 | 0, ($9 >>> 0 < $3 >>> 0 ? -1 : $9) | 0);
    }
    $3 = (HEAP32[$0 >> 2] | 0) + Math_imul($8, 28) | 0;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $68 = i64toi32_i32$1;
    i64toi32_i32$1 = $3;
    $26 = $68;
    HEAP8[i64toi32_i32$1 >> 0] = $26;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $26 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $26 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $26 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    $27 = $5;
    $28 = i64toi32_i32$1 + 24 | 0;
    $29 = HEAPU8[$27 >> 0] | 0 | ((HEAPU8[($27 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($27 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($27 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    HEAP8[$28 >> 0] = $29;
    HEAP8[($28 + 1 | 0) >> 0] = $29 >>> 8 | 0;
    HEAP8[($28 + 2 | 0) >> 0] = $29 >>> 16 | 0;
    HEAP8[($28 + 3 | 0) >> 0] = $29 >>> 24 | 0;
    i64toi32_i32$2 = $6;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $76 = i64toi32_i32$0;
    i64toi32_i32$0 = $3 + 16 | 0;
    $30 = $76;
    HEAP8[i64toi32_i32$0 >> 0] = $30;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $30 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $30 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $30 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$2 = $7;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $80 = i64toi32_i32$1;
    i64toi32_i32$1 = $3 + 8 | 0;
    $31 = $80;
    HEAP8[i64toi32_i32$1 >> 0] = $31;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $31 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $31 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $31 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    HEAP32[($0 + 8 | 0) >> 2] = $8 + 1 | 0;
    $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h32d71c96a3c9fef9($2 | 0, $1 | 0);
    $3 = HEAP32[$2 >> 2] | 0;
    if ($3) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $2 + 48 | 0;
 }
 
 function core__iter__traits__iterator__Iterator__cmp_by__h9704328b732bb868($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $6$hi = 0, $7$hi = 0, $4 = 0, $6 = 0, $7 = 0, $22 = 0, $28 = 0, $31 = 0, $3 = 0, $5 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[(($2 + 32 | 0) + 24 | 0) >> 2] = HEAP32[($1 + 24 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $22 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 32 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $22;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = ($2 + 32 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $31;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   label$2 : while (1) {
    $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h36ca092f81b9a0fa($2 + 24 | 0 | 0, $0 | 0);
    label$3 : {
     $1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
     if ($1) {
      break label$3
     }
     $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h36ca092f81b9a0fa($2 + 8 | 0 | 0, $2 + 32 | 0 | 0);
     $1 = HEAP32[($2 + 8 | 0) >> 2] | 0 ? -1 : 0;
     break label$1;
    }
    $3 = HEAP32[($2 + 28 | 0) >> 2] | 0;
    $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h36ca092f81b9a0fa($2 + 16 | 0 | 0, $2 + 32 | 0 | 0);
    label$4 : {
     $4 = HEAP32[($2 + 16 | 0) >> 2] | 0;
     if ($4) {
      break label$4
     }
     $1 = 1;
     break label$1;
    }
    $5 = HEAP32[($2 + 20 | 0) >> 2] | 0;
    label$5 : {
     label$6 : {
      $1 = $cardano_serialization_lib__AssetName_20as_20core__cmp__Ord___cmp__h38864a982a475878($1 | 0, $4 | 0) | 0;
      if ($1 & 255 | 0) {
       break label$6
      }
      i64toi32_i32$2 = $3;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $6 = i64toi32_i32$1;
      $6$hi = i64toi32_i32$0;
      i64toi32_i32$2 = $5;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $7 = i64toi32_i32$0;
      $7$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $6$hi;
      i64toi32_i32$2 = $6;
      i64toi32_i32$0 = $7$hi;
      if (i64toi32_i32$1 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$2 >>> 0 < $7 >>> 0 | 0) | 0) {
       break label$5
      }
      i64toi32_i32$2 = $6$hi;
      i64toi32_i32$2 = $7$hi;
      i64toi32_i32$2 = $6$hi;
      i64toi32_i32$1 = $7$hi;
      i64toi32_i32$0 = $7;
      $1 = ($6 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0;
     }
     if (!($1 & 255 | 0)) {
      continue label$2
     }
     break label$1;
    }
    break label$2;
   };
   $1 = 255;
  }
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function serde_json__de__ParserNumber__visit__h941b1739d7b710bc($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $12 = 0, $13 = 0, $14 = 0, $15 = 0, $4 = 0.0, $3 = 0, $16 = 0, $47 = 0, $61 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    switch (HEAP32[$1 >> 2] | 0 | 0) {
    default:
     $4 = +HEAPF64[($1 + 8 | 0) >> 3];
     $1 = 0;
     HEAP8[($2 + 8 | 0) >> 0] = 0;
     label$5 : {
      label$6 : {
       wasm2js_scratch_store_f64(+$4);
       i64toi32_i32$0 = wasm2js_scratch_load_i32(1 | 0) | 0;
       i64toi32_i32$2 = wasm2js_scratch_load_i32(0 | 0) | 0;
       i64toi32_i32$1 = 2147483647;
       i64toi32_i32$3 = -1;
       i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
       wasm2js_scratch_store_i32(0 | 0, i64toi32_i32$2 & i64toi32_i32$3 | 0 | 0);
       wasm2js_scratch_store_i32(1 | 0, i64toi32_i32$1 | 0);
       if (+wasm2js_scratch_load_f64() < infinity) {
        break label$6
       }
       $12 = HEAPU8[($2 + 12 | 0) >> 0] | 0 | ((HEAPU8[($2 + 13 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 14 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 15 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       HEAP8[($2 + 3 | 0) >> 0] = $12;
       HEAP8[($2 + 4 | 0) >> 0] = $12 >>> 8 | 0;
       HEAP8[($2 + 5 | 0) >> 0] = $12 >>> 16 | 0;
       HEAP8[($2 + 6 | 0) >> 0] = $12 >>> 24 | 0;
       HEAP32[$2 >> 2] = HEAPU8[($2 + 9 | 0) >> 0] | 0 | ((HEAPU8[($2 + 10 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 11 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 12 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
       break label$5;
      }
      core__ptr__drop_in_place_serde_json__value__Value___hb5131c85f9c77304($2 + 8 | 0 | 0);
      $1 = 2;
     }
     $13 = HEAP32[$2 >> 2] | 0;
     HEAP8[($0 + 9 | 0) >> 0] = $13;
     HEAP8[($0 + 10 | 0) >> 0] = $13 >>> 8 | 0;
     HEAP8[($0 + 11 | 0) >> 0] = $13 >>> 16 | 0;
     HEAP8[($0 + 12 | 0) >> 0] = $13 >>> 24 | 0;
     HEAP32[$0 >> 2] = 0;
     HEAP8[($0 + 8 | 0) >> 0] = $1;
     $14 = $0 + 12 | 0;
     $15 = HEAPU8[($2 + 3 | 0) >> 0] | 0 | ((HEAPU8[($2 + 4 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 5 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 6 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP8[$14 >> 0] = $15;
     HEAP8[($14 + 1 | 0) >> 0] = $15 >>> 8 | 0;
     HEAP8[($14 + 2 | 0) >> 0] = $15 >>> 16 | 0;
     HEAP8[($14 + 3 | 0) >> 0] = $15 >>> 24 | 0;
     wasm2js_scratch_store_f64(+$4);
     i64toi32_i32$1 = wasm2js_scratch_load_i32(1 | 0) | 0;
     i64toi32_i32$2 = $0 + 24 | 0;
     (wasm2js_i32$0 = i64toi32_i32$2, wasm2js_i32$1 = wasm2js_scratch_load_i32(0 | 0) | 0), HEAP32[wasm2js_i32$0 >> 2] = wasm2js_i32$1;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $0 + 16 | 0;
     i64toi32_i32$1 = 0;
     HEAP32[i64toi32_i32$2 >> 2] = 2;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
     break label$1;
    case 1:
     HEAP32[$0 >> 2] = 0;
     i64toi32_i32$0 = $1;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] | 0;
     i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] | 0;
     $47 = i64toi32_i32$1;
     i64toi32_i32$1 = $0 + 24 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $47;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$1 = $0 + 16 | 0;
     i64toi32_i32$2 = 0;
     HEAP32[i64toi32_i32$1 >> 2] = 0;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
     HEAP8[($0 + 8 | 0) >> 0] = 2;
     break label$1;
    case 2:
     break label$2;
    };
   }
   HEAP32[$0 >> 2] = 0;
   i64toi32_i32$0 = $1;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] | 0;
   $3 = i64toi32_i32$2;
   i64toi32_i32$2 = $0 + 24 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $3;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP8[($0 + 8 | 0) >> 0] = 2;
   $61 = $0 + 16 | 0;
   i64toi32_i32$0 = $3;
   i64toi32_i32$2 = 0;
   i64toi32_i32$3 = 63;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$2 = 0;
    $16 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   } else {
    i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
    $16 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
   }
   i64toi32_i32$0 = $61;
   HEAP32[i64toi32_i32$0 >> 2] = $16;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  }
  global$0 = $2 + 32 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__h0abcb8857d38a300($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $4 = 0, $3 = 0, $7 = 0, $6 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $5 = 0, $41 = 0, $80 = 0;
  $3 = global$0 - 144 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = HEAPU16[($4 + 1546 | 0) >> 1] | 0;
  $6 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $7 = $5 + ($6 ^ -1 | 0) | 0;
  HEAP16[($2 + 1546 | 0) >> 1] = $7;
  $1 = memcpy($3 | 0, $4 + ($6 << 7 | 0) | 0 | 0, 128 | 0) | 0;
  $3 = $4 + Math_imul($6, 12) | 0;
  HEAP32[($1 + 136 | 0) >> 2] = HEAP32[($3 + 1420 | 0) >> 2] | 0;
  i64toi32_i32$2 = $3 + 1412 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $41 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 128 | 0) >> 2] = $41;
  HEAP32[($1 + 132 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    if ($7 >>> 0 >= 12 >>> 0) {
     break label$2
    }
    $3 = $6 + 1 | 0;
    if (($5 - $3 | 0 | 0) != ($7 | 0)) {
     break label$1
    }
    memcpy((memcpy($2 | 0, $4 + ($3 << 7 | 0) | 0 | 0, $7 << 7 | 0 | 0) | 0) + 1412 | 0 | 0, ($4 + Math_imul($3, 12) | 0) + 1412 | 0 | 0, Math_imul($7, 12) | 0) | 0;
    HEAP16[($4 + 1546 | 0) >> 1] = $6;
    $4 = memcpy($0 | 0, $1 | 0, 128 | 0) | 0;
    HEAP32[($4 + 136 | 0) >> 2] = HEAP32[($1 + 136 | 0) >> 2] | 0;
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = HEAP32[($1 + 128 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($1 + 132 | 0) >> 2] | 0;
    $80 = i64toi32_i32$1;
    i64toi32_i32$1 = $4;
    HEAP32[($4 + 128 | 0) >> 2] = $80;
    HEAP32[($4 + 132 | 0) >> 2] = i64toi32_i32$0;
    global$0 = $1 + 144 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($7 | 0, 11 | 0, 1049044 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1048988 | 0, 40 | 0, 1049028 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__h23b19134df2dd8e0($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $4 = 0, $3 = 0, $7 = 0, $6 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $5 = 0, $41 = 0, $80 = 0;
  $3 = global$0 - 144 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = HEAPU16[($4 + 1546 | 0) >> 1] | 0;
  $6 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $7 = $5 + ($6 ^ -1 | 0) | 0;
  HEAP16[($2 + 1546 | 0) >> 1] = $7;
  $1 = memcpy($3 | 0, $4 + ($6 << 7 | 0) | 0 | 0, 128 | 0) | 0;
  $3 = $4 + Math_imul($6, 12) | 0;
  HEAP32[($1 + 136 | 0) >> 2] = HEAP32[($3 + 1420 | 0) >> 2] | 0;
  i64toi32_i32$2 = $3 + 1412 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $41 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 128 | 0) >> 2] = $41;
  HEAP32[($1 + 132 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    if ($7 >>> 0 >= 12 >>> 0) {
     break label$2
    }
    $3 = $6 + 1 | 0;
    if (($5 - $3 | 0 | 0) != ($7 | 0)) {
     break label$1
    }
    memcpy((memcpy($2 | 0, $4 + ($3 << 7 | 0) | 0 | 0, $7 << 7 | 0 | 0) | 0) + 1412 | 0 | 0, ($4 + Math_imul($3, 12) | 0) + 1412 | 0 | 0, Math_imul($7, 12) | 0) | 0;
    HEAP16[($4 + 1546 | 0) >> 1] = $6;
    $4 = memcpy($0 | 0, $1 | 0, 128 | 0) | 0;
    HEAP32[($4 + 136 | 0) >> 2] = HEAP32[($1 + 136 | 0) >> 2] | 0;
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = HEAP32[($1 + 128 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($1 + 132 | 0) >> 2] | 0;
    $80 = i64toi32_i32$1;
    i64toi32_i32$1 = $4;
    HEAP32[($4 + 128 | 0) >> 2] = $80;
    HEAP32[($4 + 132 | 0) >> 2] = i64toi32_i32$0;
    global$0 = $1 + 144 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($7 | 0, 11 | 0, 1049044 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1048988 | 0, 40 | 0, 1049028 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__h950f9a694dc32efd($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, $3 = 0, i64toi32_i32$1 = 0, $4 = 0, $7 = 0, i64toi32_i32$2 = 0, $6 = 0, $5 = 0, $36 = 0, $72 = 0, $75 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = HEAPU16[($4 + 226 | 0) >> 1] | 0;
  $6 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $1 = $5 + ($6 ^ -1 | 0) | 0;
  HEAP16[($2 + 226 | 0) >> 1] = $1;
  $7 = $4 + Math_imul($6, 12) | 0;
  HEAP32[($3 + 8 | 0) >> 2] = HEAP32[($7 + 100 | 0) >> 2] | 0;
  i64toi32_i32$2 = $7 + 92 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $36;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    if ($1 >>> 0 >= 12 >>> 0) {
     break label$2
    }
    $7 = $6 + 1 | 0;
    if (($5 - $7 | 0 | 0) != ($1 | 0)) {
     break label$1
    }
    i64toi32_i32$2 = $4 + ($6 << 3 | 0) | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    memcpy($2 + 92 | 0 | 0, ($4 + Math_imul($7, 12) | 0) + 92 | 0 | 0, Math_imul($1, 12) | 0) | 0;
    memcpy($2 | 0, $4 + ($7 << 3 | 0) | 0 | 0, $1 << 3 | 0 | 0) | 0;
    HEAP16[($4 + 226 | 0) >> 1] = $6;
    $72 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $72;
    HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAP32[$3 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($3 + 4 | 0) >> 2] | 0;
    $75 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[i64toi32_i32$0 >> 2] = $75;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($3 + 8 | 0) >> 2] | 0;
    global$0 = $3 + 16 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($1 | 0, 11 | 0, 1049044 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1048988 | 0, 40 | 0, 1049028 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__he20e4b9e5ee43f9c($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, $3 = 0, i64toi32_i32$1 = 0, $4 = 0, $7 = 0, i64toi32_i32$2 = 0, $6 = 0, $5 = 0, $36 = 0, $72 = 0, $75 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = HEAPU16[($4 + 226 | 0) >> 1] | 0;
  $6 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $1 = $5 + ($6 ^ -1 | 0) | 0;
  HEAP16[($2 + 226 | 0) >> 1] = $1;
  $7 = $4 + Math_imul($6, 12) | 0;
  HEAP32[($3 + 8 | 0) >> 2] = HEAP32[($7 + 100 | 0) >> 2] | 0;
  i64toi32_i32$2 = $7 + 92 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $36;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    if ($1 >>> 0 >= 12 >>> 0) {
     break label$2
    }
    $7 = $6 + 1 | 0;
    if (($5 - $7 | 0 | 0) != ($1 | 0)) {
     break label$1
    }
    i64toi32_i32$2 = $4 + ($6 << 3 | 0) | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    memcpy($2 + 92 | 0 | 0, ($4 + Math_imul($7, 12) | 0) + 92 | 0 | 0, Math_imul($1, 12) | 0) | 0;
    memcpy($2 | 0, $4 + ($7 << 3 | 0) | 0 | 0, $1 << 3 | 0 | 0) | 0;
    HEAP16[($4 + 226 | 0) >> 1] = $6;
    $72 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $72;
    HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAP32[$3 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($3 + 4 | 0) >> 2] | 0;
    $75 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[i64toi32_i32$0 >> 2] = $75;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($3 + 8 | 0) >> 2] | 0;
    global$0 = $3 + 16 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($1 | 0, 11 | 0, 1049044 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1048988 | 0, 40 | 0, 1049028 | 0);
  abort();
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__TransactionInput___serialize__h2e92835f336b9490($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, $17 = 0, $22 = 0, $28 = 0, $31 = 0;
  $3 = global$0 - 80 | 0;
  global$0 = $3;
  i64toi32_i32$0 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, 2 | 0, i64toi32_i32$0 | 0);
  $4 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      i64toi32_i32$2 = $1 + 28 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $17 = i64toi32_i32$0;
      i64toi32_i32$0 = $3 + 72 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $17;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $1 + 20 | 0;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $22 = i64toi32_i32$1;
      i64toi32_i32$1 = $3 + 64 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $22;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $1 + 12 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $28 = i64toi32_i32$0;
      i64toi32_i32$0 = ($3 + 48 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $28;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $1;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 9 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 10 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 11 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $31 = i64toi32_i32$1;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 48 | 0) >> 2] = $31;
      HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$0;
      cbor_event__se__Serializer_W___write_bytes__h85f4434ac9a8a060($3 | 0, $2 | 0, $3 + 48 | 0 | 0);
      if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      $4 = 0;
      i64toi32_i32$2 = $1;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = 0;
      cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, i64toi32_i32$0 | 0, i64toi32_i32$1 | 0);
      if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
       break label$2
      }
      HEAP32[($0 + 4 | 0) >> 2] = $2;
      break label$1;
     }
     memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    $4 = 1;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $4 = 1;
  }
  HEAP32[$0 >> 2] = $4;
  global$0 = $3 + 80 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__Withdrawals___serialize__h776d4a70d67f4de1($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, $5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  i64toi32_i32$0 = HEAP32[($1 + 28 | 0) >> 2] | 0;
  i64toi32_i32$1 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 5 | 0, i64toi32_i32$0 | 0, i64toi32_i32$1 | 0);
  $4 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      label$5 : {
       label$6 : {
        $5 = HEAP32[($1 + 32 | 0) >> 2] | 0;
        if ($5) {
         break label$6
        }
        $1 = 0;
        break label$5;
       }
       $1 = HEAP32[($5 + 12 | 0) >> 2] | 0;
      }
      label$7 : {
       if (($1 | 0) == ($5 | 0)) {
        break label$7
       }
       label$8 : while (1) {
        $4 = HEAP32[($1 + 12 | 0) >> 2] | 0;
        $cardano_serialization_lib__address__RewardAddress_20as_20cbor_event__se__Serialize___serialize__hd22cb20e67f69432($3 | 0, $1 + 16 | 0 | 0, $2 | 0);
        if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
         break label$2
        }
        i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
        cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, i64toi32_i32$1 | 0, i64toi32_i32$0 | 0);
        if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
         break label$3
        }
        $1 = $4;
        if (($1 | 0) != ($5 | 0)) {
         continue label$8
        }
        break label$8;
       };
      }
      HEAP32[($0 + 4 | 0) >> 2] = $2;
      $4 = 0;
      break label$1;
     }
     memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    $4 = 1;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $4 = 1;
  }
  HEAP32[$0 >> 2] = $4;
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__SerializeEmbeddedGroup_20for_20cardano_serialization_lib__PoolRetirement___serialize_as_embedded_group__h70aa5e00b5f3d46d($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, $11 = 0, $22 = 0, $28 = 0, $31 = 0;
  $3 = global$0 - 80 | 0;
  global$0 = $3;
  i64toi32_i32$0 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 4 | 0, i64toi32_i32$0 | 0);
  $4 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      $11 = $1 + 28 | 0;
      HEAP32[($3 + 72 | 0) >> 2] = HEAPU8[$11 >> 0] | 0 | ((HEAPU8[($11 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($11 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($11 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$2 = $1 + 20 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $22 = i64toi32_i32$0;
      i64toi32_i32$0 = $3 + 64 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $22;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $1 + 12 | 0;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $28 = i64toi32_i32$1;
      i64toi32_i32$1 = ($3 + 48 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $28;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $1;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 9 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 10 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 11 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $31 = i64toi32_i32$0;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 48 | 0) >> 2] = $31;
      HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$1;
      cbor_event__se__Serializer_W___write_bytes__h5e3534de30c993f9($3 | 0, $2 | 0, $3 + 48 | 0 | 0);
      if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      $4 = 0;
      i64toi32_i32$2 = $1;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = 0;
      cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, i64toi32_i32$1 | 0, i64toi32_i32$0 | 0);
      if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
       break label$2
      }
      HEAP32[($0 + 4 | 0) >> 2] = $2;
      break label$1;
     }
     memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    $4 = 1;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $4 = 1;
  }
  HEAP32[$0 >> 2] = $4;
  global$0 = $3 + 80 | 0;
 }
 
 function certificate_as_pool_retirement($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $3 = 0, $32 = 0, $37 = 0, $40 = 0, $4 = 0, $54 = 0, $59 = 0, $69 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h3b62e22150831bdc($1 + 8 | 0 | 0, $0 | 0);
   $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   label$2 : {
    $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    $3 = (HEAPU8[$0 >> 0] | 0 | 0) != (4 | 0);
    if ($3) {
     break label$2
    }
    HEAP32[(($1 + 16 | 0) + 24 | 0) >> 2] = HEAP32[($0 + 32 | 0) >> 2] | 0;
    i64toi32_i32$2 = $0 + 24 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $32 = i64toi32_i32$0;
    i64toi32_i32$0 = ($1 + 16 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $32;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $0 + 16 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $37 = i64toi32_i32$1;
    i64toi32_i32$1 = $1 + 24 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $37;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
    $40 = i64toi32_i32$0;
    i64toi32_i32$0 = $1;
    HEAP32[($1 + 16 | 0) >> 2] = $40;
    HEAP32[($1 + 20 | 0) >> 2] = i64toi32_i32$1;
    $4 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
   $0 = 0;
   label$3 : {
    if ($3) {
     break label$3
    }
    i64toi32_i32$2 = $1 + 24 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $54 = i64toi32_i32$1;
    i64toi32_i32$1 = $1 + 60 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $54;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $1 + 32 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $59 = i64toi32_i32$0;
    i64toi32_i32$0 = $1 + 68 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $59;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($1 + 76 | 0) >> 2] = HEAP32[($1 + 40 | 0) >> 2] | 0;
    HEAP32[($1 + 48 | 0) >> 2] = $4;
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = HEAP32[($1 + 16 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($1 + 20 | 0) >> 2] | 0;
    $69 = i64toi32_i32$1;
    i64toi32_i32$1 = $1;
    HEAP32[($1 + 52 | 0) >> 2] = $69;
    HEAP32[($1 + 56 | 0) >> 2] = i64toi32_i32$0;
    $0 = $cardano_serialization_lib__PoolRetirement_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hc280b71a1ce0ea8e($1 + 48 | 0 | 0) | 0;
   }
   global$0 = $1 + 80 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function nativescript_as_script_pubkey($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $2 = 0, $15 = 0, $3 = 0, $4 = 0, $5 = 0, $33 = 0, $40 = 0, $43 = 0, $58 = 0, $63 = 0, $66 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h6ed0b6b043905434($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   label$2 : {
    label$3 : {
     $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     if (HEAPU8[$2 >> 0] | 0) {
      break label$3
     }
     $3 = ($1 + 16 | 0) + 24 | 0;
     $15 = $2 + 25 | 0;
     HEAP32[$3 >> 2] = HEAPU8[$15 >> 0] | 0 | ((HEAPU8[($15 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($15 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($15 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $4 = ($1 + 16 | 0) + 16 | 0;
     i64toi32_i32$2 = $2 + 17 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $33 = i64toi32_i32$0;
     i64toi32_i32$0 = $4;
     HEAP32[i64toi32_i32$0 >> 2] = $33;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     $5 = ($1 + 16 | 0) + 8 | 0;
     i64toi32_i32$2 = $2 + 9 | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $40 = i64toi32_i32$1;
     i64toi32_i32$1 = $5;
     HEAP32[i64toi32_i32$1 >> 2] = $40;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $43 = i64toi32_i32$0;
     i64toi32_i32$0 = $1;
     HEAP32[($1 + 16 | 0) >> 2] = $43;
     HEAP32[($1 + 20 | 0) >> 2] = i64toi32_i32$1;
     core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
     HEAP32[(($1 + 48 | 0) + 24 | 0) >> 2] = HEAP32[$3 >> 2] | 0;
     i64toi32_i32$2 = $4;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $58 = i64toi32_i32$1;
     i64toi32_i32$1 = ($1 + 48 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $58;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $5;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $63 = i64toi32_i32$0;
     i64toi32_i32$0 = ($1 + 48 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $63;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $1;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
     $66 = i64toi32_i32$1;
     i64toi32_i32$1 = i64toi32_i32$2;
     HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = $66;
     HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = i64toi32_i32$0;
     $0 = $cardano_serialization_lib__ScriptPubkey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he4b2ddfdd7790cb9(i64toi32_i32$2 + 48 | 0 | 0) | 0;
     break label$2;
    }
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    $0 = 0;
   }
   global$0 = $1 + 80 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function $cardano_serialization_lib__metadata__GeneralTransactionMetadata_20as_20cbor_event__se__Serialize___serialize__h54e54d8e88a77b55($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, $5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  i64toi32_i32$0 = HEAP32[($1 + 28 | 0) >> 2] | 0;
  i64toi32_i32$1 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 5 | 0, i64toi32_i32$0 | 0, i64toi32_i32$1 | 0);
  $4 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      label$5 : {
       $5 = HEAP32[($1 + 32 | 0) >> 2] | 0;
       if (!$5) {
        break label$5
       }
       $1 = HEAP32[($5 + 60 | 0) >> 2] | 0;
       if (($1 | 0) == ($5 | 0)) {
        break label$5
       }
       if (!$1) {
        break label$5
       }
       label$6 : while (1) {
        $4 = HEAP32[($1 + 60 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
        i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
        cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, i64toi32_i32$1 | 0, i64toi32_i32$0 | 0);
        if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
         break label$2
        }
        $cardano_serialization_lib__metadata__TransactionMetadatumEnum_20as_20cbor_event__se__Serialize___serialize__h4285ca14e4462f47($3 | 0, $1 + 8 | 0 | 0, $2 | 0);
        if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
         break label$3
        }
        if (($4 | 0) == ($5 | 0)) {
         break label$5
        }
        $1 = $4;
        if ($1) {
         continue label$6
        }
        break label$6;
       };
      }
      HEAP32[($0 + 4 | 0) >> 2] = $2;
      $4 = 0;
      break label$1;
     }
     memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    $4 = 1;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $4 = 1;
  }
  HEAP32[$0 >> 2] = $4;
  global$0 = $3 + 48 | 0;
 }
 
 function auxiliarydata_metadata($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $3 = 0, $4 = 0, $49 = 0, $56 = 0, $63 = 0, $66 = 0;
  $1 = global$0 - 96 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hdd9a557acdd7acfa($1 + 8 | 0 | 0, $0 | 0);
   $2 = 0;
   $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   $0 = 0;
   label$2 : {
    $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    if (!(HEAP32[($4 + 20 | 0) >> 2] | 0)) {
     break label$2
    }
    $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h44c6d4679ef9fae6($1 + 16 | 0 | 0, $4 | 0);
    $0 = HEAP32[($1 + 36 | 0) >> 2] | 0;
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
   label$3 : {
    if (!$0) {
     break label$3
    }
    HEAP32[($1 + 76 | 0) >> 2] = $0;
    HEAP32[(($1 + 56 | 0) + 16 | 0) >> 2] = HEAP32[(($1 + 16 | 0) + 16 | 0) >> 2] | 0;
    i64toi32_i32$2 = ($1 + 16 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $49 = i64toi32_i32$0;
    i64toi32_i32$0 = ($1 + 56 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $49;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = ($1 + 16 | 0) + 24 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $56 = i64toi32_i32$1;
    i64toi32_i32$1 = ($1 + 56 | 0) + 24 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $56;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = ($1 + 16 | 0) + 32 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $63 = i64toi32_i32$0;
    i64toi32_i32$0 = ($1 + 56 | 0) + 32 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $63;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = HEAP32[($1 + 16 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($1 + 20 | 0) >> 2] | 0;
    $66 = i64toi32_i32$1;
    i64toi32_i32$1 = $1;
    HEAP32[($1 + 56 | 0) >> 2] = $66;
    HEAP32[($1 + 60 | 0) >> 2] = i64toi32_i32$0;
    $2 = $cardano_serialization_lib__metadata__GeneralTransactionMetadata_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__haadefad5c9c3f4ac($1 + 56 | 0 | 0) | 0;
   }
   global$0 = $1 + 96 | 0;
   return $2 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function txinputsbuilder_add_required_signer($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $15 = 0, $5 = 0, $6 = 0, $7 = 0, $8 = 0, $3 = 0, $4 = 0, $6$hi = 0, $7$hi = 0, $8$hi = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hf277c6a2d5f089a3($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hae9c55c4e91ce40f($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $0 = HEAP32[$2 >> 2] | 0;
   $15 = $0 + 24 | 0;
   $5 = HEAPU8[$15 >> 0] | 0 | ((HEAPU8[($15 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($15 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($15 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP32[(($2 + 16 | 0) + 24 | 0) >> 2] = $5;
   i64toi32_i32$2 = $0 + 16 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $6 = i64toi32_i32$0;
   $6$hi = i64toi32_i32$1;
   i64toi32_i32$0 = ($2 + 16 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $6;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $0 + 8 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $7 = i64toi32_i32$1;
   $7$hi = i64toi32_i32$0;
   i64toi32_i32$1 = ($2 + 16 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $7;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $8 = i64toi32_i32$0;
   $8$hi = i64toi32_i32$1;
   i64toi32_i32$0 = $2;
   HEAP32[($2 + 16 | 0) >> 2] = $8;
   HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[(($2 + 48 | 0) + 24 | 0) >> 2] = $5;
   i64toi32_i32$1 = $6$hi;
   i64toi32_i32$0 = ($2 + 48 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $6;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $7$hi;
   i64toi32_i32$0 = ($2 + 48 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $7;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $8$hi;
   i64toi32_i32$0 = $2;
   HEAP32[($2 + 48 | 0) >> 2] = $8;
   HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
   alloc__collections__btree__map__BTreeMap_K_2cV___insert__h5d8c7a7452747b0f($4 + 40 | 0 | 0, $2 + 48 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 80 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function alloc__collections__btree__map__entry__VacantEntry_K_2cV___insert__ha71ca05338ace28c($0) {
  $0 = $0 | 0;
  var $1 = 0, $8 = 0, $3 = 0, $7 = 0, i64toi32_i32$1 = 0, $2 = 0, $4 = 0, $5 = 0, $6 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  HEAP32[($1 + 40 | 0) >> 2] = HEAP32[($0 + 12 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  HEAP32[($1 + 32 | 0) >> 2] = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_recursing__h92f2000fc44dc2eb($1 | 0, $1 + 32 | 0 | 0, HEAP32[$0 >> 2] | 0 | 0);
  $2 = HEAP32[($1 + 24 | 0) >> 2] | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[$1 >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     $0 = HEAP32[($0 + 16 | 0) >> 2] | 0;
     break label$2;
    }
    $0 = HEAP32[($0 + 16 | 0) >> 2] | 0;
    $3 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    if (!$3) {
     break label$1
    }
    $4 = HEAP32[($1 + 20 | 0) >> 2] | 0;
    $5 = HEAP32[($1 + 16 | 0) >> 2] | 0;
    $6 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    $7 = HEAP32[$0 >> 2] | 0;
    $8 = alloc__boxed__Box_T_2cA___new_uninit_in__ha1c9e40f84881c6f() | 0;
    HEAP32[($8 + 52 | 0) >> 2] = $3;
    HEAP16[($8 + 50 | 0) >> 1] = 0;
    HEAP32[$8 >> 2] = 0;
    HEAP32[($0 + 4 | 0) >> 2] = $8;
    $7 = $7 + 1 | 0;
    HEAP32[$0 >> 2] = $7;
    HEAP16[($3 + 48 | 0) >> 1] = 0;
    HEAP32[$3 >> 2] = $8;
    HEAP32[($1 + 36 | 0) >> 2] = $8;
    HEAP32[($1 + 32 | 0) >> 2] = $7;
    alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal___push__hcad6f2acc0614f5e($1 + 32 | 0 | 0, $6 | 0, $5 | 0, $4 | 0);
   }
   HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
   global$0 = $1 + 48 | 0;
   return $2 | 0;
  }
  core__panicking__panic__h2fd385a887c8bf13(1072048 | 0, 43 | 0, 1072248 | 0);
  abort();
 }
 
 function serde_json__de__Deserializer_R___f64_from_parts__hb0108f153aa5786e($0, $1, $2, $3, $3$hi, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  $4 = $4 | 0;
  var $7 = 0.0, $6 = 0, $5 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $8 = 0.0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $5 = global$0 - 16 | 0;
  global$0 = $5;
  i64toi32_i32$0 = $3$hi;
  i64toi32_i32$1 = $3;
  $7 = +(i64toi32_i32$1 >>> 0) + 4294967296.0 * +(i64toi32_i32$0 >>> 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       $6 = $4 >> 31 | 0;
       $6 = ($4 + $6 | 0) ^ $6 | 0;
       if ($6 >>> 0 < 309 >>> 0) {
        break label$5
       }
       label$6 : while (1) {
        if ($7 == 0.0) {
         break label$2
        }
        if (($4 | 0) > (-1 | 0)) {
         break label$4
        }
        $7 = $7 / 1.e+308;
        $4 = $4 + 308 | 0;
        $6 = $4 >> 31 | 0;
        $6 = ($4 + $6 | 0) ^ $6 | 0;
        if ($6 >>> 0 > 308 >>> 0) {
         continue label$6
        }
        break label$6;
       };
      }
      $8 = +HEAPF64[(($6 << 3 | 0) + 1084784 | 0) >> 3];
      label$7 : {
       if (($4 | 0) > (-1 | 0)) {
        break label$7
       }
       $7 = $7 / $8;
       break label$2;
      }
      $7 = $7 * $8;
      wasm2js_scratch_store_f64(+$7);
      i64toi32_i32$0 = wasm2js_scratch_load_i32(1 | 0) | 0;
      i64toi32_i32$1 = 2147483647;
      i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
      wasm2js_scratch_store_i32(0 | 0, (wasm2js_scratch_load_i32(0 | 0) | 0) & -1 | 0 | 0);
      wasm2js_scratch_store_i32(1 | 0, i64toi32_i32$1 | 0);
      if (+wasm2js_scratch_load_f64() != infinity) {
       break label$2
      }
      HEAP32[$5 >> 2] = 13;
      (wasm2js_i32$0 = $0, wasm2js_i32$1 = serde_json__de__Deserializer_R___error__h438ab94fbb97beef($1 | 0, $5 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
      break label$3;
     }
     HEAP32[$5 >> 2] = 13;
     (wasm2js_i32$0 = $0, wasm2js_i32$1 = serde_json__de__Deserializer_R___error__h438ab94fbb97beef($1 | 0, $5 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
    }
    $4 = 1;
    break label$1;
   }
   HEAPF64[($0 + 8 | 0) >> 3] = $2 ? $7 : -$7;
   $4 = 0;
  }
  HEAP32[$0 >> 2] = $4;
  global$0 = $5 + 16 | 0;
 }
 
 function cryptoxide__curve25519__scalar__scalar64__reduce256__he9e2203f350907b0($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, i64toi32_i32$6 = 0, $17$hi = 0, $3$hi = 0, $17 = 0, $2 = 0, $3 = 0, $4 = 0, $4$hi = 0, $5 = 0, $5$hi = 0, $6 = 0, $6$hi = 0, $7$hi = 0, $116 = 0, $8 = 0, $9$hi = 0, $117 = 0, $10 = 0, $11$hi = 0, $118 = 0, $12 = 0, $12$hi = 0, $13$hi = 0, $119 = 0, $14 = 0, $15$hi = 0, $120 = 0, $16 = 0, $121 = 0, $122 = 0, $123 = 0, $124 = 0, $125 = 0, $18 = 0, $2$hi = 0, $21 = 0, $21$hi = 0, $24 = 0, $24$hi = 0, $27 = 0, $27$hi = 0, $30 = 0, $30$hi = 0, $7 = 0, $8$hi = 0, $38 = 0, $38$hi = 0, $9 = 0, $10$hi = 0, $43 = 0, $43$hi = 0, $11 = 0, $13 = 0, $14$hi = 0, $52 = 0, $52$hi = 0, $15 = 0, $16$hi = 0, $58 = 0, $58$hi = 0, $60$hi = 0, $62$hi = 0, $64$hi = 0, $65$hi = 0, $67 = 0, $68 = 0, $69 = 0, $69$hi = 0, $70 = 0, $70$hi = 0, $71 = 0, $71$hi = 0, $73$hi = 0, $75$hi = 0, $76 = 0, $76$hi = 0, $77 = 0, $77$hi = 0, $78 = 0, $79 = 0, $80 = 0, $80$hi = 0, $81 = 0, $81$hi = 0, $82 = 0, $82$hi = 0, $84$hi = 0, $86$hi = 0, $87 = 0, $87$hi = 0, $88 = 0, $88$hi = 0, $89 = 0, $90 = 0, $91 = 0, $91$hi = 0, $92 = 0, $92$hi = 0, $93 = 0, $93$hi = 0, $95$hi = 0, $97$hi = 0, $98 = 0, $98$hi = 0, $99 = 0, $99$hi = 0, $100 = 0, $101 = 0, $102 = 0, $102$hi = 0, $103 = 0, $103$hi = 0, $105$hi = 0, $107$hi = 0, $108$hi = 0, $110 = 0, $110$hi = 0, $111 = 0;
  $18 = $1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
  $2 = i64toi32_i32$0;
  $2$hi = i64toi32_i32$1;
  $21 = i64toi32_i32$0;
  $21$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $3 = i64toi32_i32$1;
  $3$hi = i64toi32_i32$0;
  $24 = i64toi32_i32$1;
  $24$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$1;
  $27 = i64toi32_i32$0;
  $27$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $5 = i64toi32_i32$1;
  $5$hi = i64toi32_i32$0;
  $30 = i64toi32_i32$1;
  $30$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $6 = i64toi32_i32$0;
  $6$hi = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = -1205019;
  i64toi32_i32$3 = -1559614445;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $7 = i64toi32_i32$4;
  $7$hi = i64toi32_i32$5;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 63;
  i64toi32_i32$0 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $116 = i64toi32_i32$5 >>> i64toi32_i32$0 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$5 >>> i64toi32_i32$0 | 0;
   $116 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$0 | 0) | 0;
  }
  $8 = $116;
  $8$hi = i64toi32_i32$2;
  i64toi32_i32$5 = $8;
  i64toi32_i32$1 = 16375458;
  i64toi32_i32$3 = -140716456;
  i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
  $38 = i64toi32_i32$5 | i64toi32_i32$3 | 0;
  $38$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $30$hi;
  i64toi32_i32$2 = $30;
  i64toi32_i32$5 = $38$hi;
  i64toi32_i32$3 = $38;
  i64toi32_i32$0 = i64toi32_i32$2 - i64toi32_i32$3 | 0;
  i64toi32_i32$6 = i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0;
  i64toi32_i32$4 = i64toi32_i32$6 + i64toi32_i32$5 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 - i64toi32_i32$4 | 0;
  $9 = i64toi32_i32$0;
  $9$hi = i64toi32_i32$4;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 63;
  i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $117 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
   $117 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$5 | 0) | 0;
  }
  $10 = $117;
  $10$hi = i64toi32_i32$2;
  i64toi32_i32$4 = $10;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 5342;
  i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
  $43 = i64toi32_i32$4 | i64toi32_i32$3 | 0;
  $43$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $27$hi;
  i64toi32_i32$2 = $27;
  i64toi32_i32$4 = $43$hi;
  i64toi32_i32$3 = $43;
  i64toi32_i32$5 = i64toi32_i32$2 - i64toi32_i32$3 | 0;
  i64toi32_i32$6 = i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0;
  i64toi32_i32$0 = i64toi32_i32$6 + i64toi32_i32$4 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 - i64toi32_i32$0 | 0;
  $11 = i64toi32_i32$5;
  $11$hi = i64toi32_i32$0;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 63;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $118 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $118 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
  }
  $12 = $118;
  $12$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $24$hi;
  i64toi32_i32$0 = $24;
  i64toi32_i32$1 = $12$hi;
  i64toi32_i32$3 = $12;
  i64toi32_i32$4 = i64toi32_i32$0 - i64toi32_i32$3 | 0;
  i64toi32_i32$6 = i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0;
  i64toi32_i32$5 = i64toi32_i32$6 + i64toi32_i32$1 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 - i64toi32_i32$5 | 0;
  $13 = i64toi32_i32$4;
  $13$hi = i64toi32_i32$5;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 63;
  i64toi32_i32$1 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $119 = i64toi32_i32$5 >>> i64toi32_i32$1 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$5 >>> i64toi32_i32$1 | 0;
   $119 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$1 | 0) | 0;
  }
  $14 = $119;
  $14$hi = i64toi32_i32$0;
  i64toi32_i32$5 = $14;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 268435456;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  $52 = i64toi32_i32$5 | i64toi32_i32$3 | 0;
  $52$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $21$hi;
  i64toi32_i32$0 = $21;
  i64toi32_i32$5 = $52$hi;
  i64toi32_i32$3 = $52;
  i64toi32_i32$1 = i64toi32_i32$0 - i64toi32_i32$3 | 0;
  i64toi32_i32$6 = i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0;
  i64toi32_i32$4 = i64toi32_i32$6 + i64toi32_i32$5 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 - i64toi32_i32$4 | 0;
  $15 = i64toi32_i32$1;
  $15$hi = i64toi32_i32$4;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 63;
  i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $120 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
   $120 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$5 | 0) | 0;
  }
  $16 = $120;
  $16$hi = i64toi32_i32$0;
  i64toi32_i32$4 = $16;
  i64toi32_i32$2 = -1;
  i64toi32_i32$3 = -1;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $17 = i64toi32_i32$5;
  $17$hi = i64toi32_i32$1;
  $58 = i64toi32_i32$5;
  $58$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $14$hi;
  i64toi32_i32$0 = $14;
  i64toi32_i32$4 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$2 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$0 << i64toi32_i32$2 | 0;
   $121 = 0;
  } else {
   i64toi32_i32$4 = ((1 << i64toi32_i32$2 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$2 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$2 | 0) | 0;
   $121 = i64toi32_i32$0 << i64toi32_i32$2 | 0;
  }
  $60$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $13$hi;
  i64toi32_i32$4 = $60$hi;
  i64toi32_i32$1 = $121;
  i64toi32_i32$0 = $13$hi;
  i64toi32_i32$3 = $13;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $62$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $3$hi;
  i64toi32_i32$5 = $62$hi;
  i64toi32_i32$4 = i64toi32_i32$2;
  i64toi32_i32$1 = $3$hi;
  i64toi32_i32$3 = $3;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $64$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $58$hi;
  i64toi32_i32$5 = $58;
  i64toi32_i32$4 = $64$hi;
  i64toi32_i32$3 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 & i64toi32_i32$4 | 0;
  $65$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $3$hi;
  i64toi32_i32$4 = $65$hi;
  i64toi32_i32$1 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
  i64toi32_i32$5 = $3$hi;
  i64toi32_i32$3 = $3;
  i64toi32_i32$5 = i64toi32_i32$4 ^ i64toi32_i32$5 | 0;
  $67 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $18;
  HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = $67;
  HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = i64toi32_i32$5;
  $68 = $1;
  i64toi32_i32$5 = $4$hi;
  $69 = $4;
  $69$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $17$hi;
  $70 = $17;
  $70$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $4$hi;
  $71 = $4;
  $71$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $12$hi;
  i64toi32_i32$4 = $12;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$0 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$4 << i64toi32_i32$0 | 0;
   $122 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$0 | 0) - 1 | 0) & (i64toi32_i32$4 >>> (32 - i64toi32_i32$0 | 0) | 0) | 0 | (i64toi32_i32$5 << i64toi32_i32$0 | 0) | 0;
   $122 = i64toi32_i32$4 << i64toi32_i32$0 | 0;
  }
  $73$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $11$hi;
  i64toi32_i32$1 = $73$hi;
  i64toi32_i32$5 = $122;
  i64toi32_i32$4 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $75$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $71$hi;
  i64toi32_i32$1 = $71;
  i64toi32_i32$5 = $75$hi;
  i64toi32_i32$3 = i64toi32_i32$0;
  i64toi32_i32$5 = i64toi32_i32$2 ^ i64toi32_i32$5 | 0;
  $76 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $76$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $70$hi;
  i64toi32_i32$2 = $70;
  i64toi32_i32$1 = $76$hi;
  i64toi32_i32$3 = $76;
  i64toi32_i32$1 = i64toi32_i32$5 & i64toi32_i32$1 | 0;
  $77 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
  $77$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $69$hi;
  i64toi32_i32$5 = $69;
  i64toi32_i32$2 = $77$hi;
  i64toi32_i32$3 = $77;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $78 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = $68;
  HEAP32[(i64toi32_i32$5 + 16 | 0) >> 2] = $78;
  HEAP32[(i64toi32_i32$5 + 20 | 0) >> 2] = i64toi32_i32$2;
  $79 = $1;
  i64toi32_i32$2 = $5$hi;
  $80 = $5;
  $80$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $17$hi;
  $81 = $17;
  $81$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $5$hi;
  $82 = $5;
  $82$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $10$hi;
  i64toi32_i32$1 = $10;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
   $123 = 0;
  } else {
   i64toi32_i32$5 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
   $123 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
  }
  $84$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$5 = $84$hi;
  i64toi32_i32$2 = $123;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $86$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $82$hi;
  i64toi32_i32$5 = $82;
  i64toi32_i32$2 = $86$hi;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$2 = i64toi32_i32$0 ^ i64toi32_i32$2 | 0;
  $87 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $87$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $81$hi;
  i64toi32_i32$0 = $81;
  i64toi32_i32$5 = $87$hi;
  i64toi32_i32$3 = $87;
  i64toi32_i32$5 = i64toi32_i32$2 & i64toi32_i32$5 | 0;
  $88 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
  $88$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $80$hi;
  i64toi32_i32$2 = $80;
  i64toi32_i32$0 = $88$hi;
  i64toi32_i32$3 = $88;
  i64toi32_i32$0 = i64toi32_i32$5 ^ i64toi32_i32$0 | 0;
  $89 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $79;
  HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $89;
  HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$0;
  $90 = $1;
  i64toi32_i32$0 = $6$hi;
  $91 = $6;
  $91$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $17$hi;
  $92 = $17;
  $92$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $6$hi;
  $93 = $6;
  $93$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$5 = $8;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 56;
  i64toi32_i32$1 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$5 << i64toi32_i32$1 | 0;
   $124 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$1 | 0) - 1 | 0) & (i64toi32_i32$5 >>> (32 - i64toi32_i32$1 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$1 | 0) | 0;
   $124 = i64toi32_i32$5 << i64toi32_i32$1 | 0;
  }
  $95$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$2 = $95$hi;
  i64toi32_i32$0 = $124;
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$3 = $7;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $97$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $93$hi;
  i64toi32_i32$2 = $93;
  i64toi32_i32$0 = $97$hi;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
  $98 = i64toi32_i32$2 ^ i64toi32_i32$1 | 0;
  $98$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $92$hi;
  i64toi32_i32$4 = $92;
  i64toi32_i32$2 = $98$hi;
  i64toi32_i32$3 = $98;
  i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
  $99 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
  $99$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $91$hi;
  i64toi32_i32$0 = $91;
  i64toi32_i32$4 = $99$hi;
  i64toi32_i32$3 = $99;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$4 | 0;
  $100 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $90;
  HEAP32[i64toi32_i32$0 >> 2] = $100;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$4;
  $101 = $1;
  i64toi32_i32$4 = $2$hi;
  $102 = $2;
  $102$hi = i64toi32_i32$4;
  $103 = $2;
  $103$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $16$hi;
  i64toi32_i32$2 = $16;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$5 | 0;
   $125 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$5 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$5 | 0) | 0) | 0 | (i64toi32_i32$4 << i64toi32_i32$5 | 0) | 0;
   $125 = i64toi32_i32$2 << i64toi32_i32$5 | 0;
  }
  $105$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $15$hi;
  i64toi32_i32$0 = $105$hi;
  i64toi32_i32$4 = $125;
  i64toi32_i32$2 = $15$hi;
  i64toi32_i32$3 = $15;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $107$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $103$hi;
  i64toi32_i32$0 = $103;
  i64toi32_i32$4 = $107$hi;
  i64toi32_i32$3 = i64toi32_i32$5;
  i64toi32_i32$4 = i64toi32_i32$1 ^ i64toi32_i32$4 | 0;
  $108$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $17$hi;
  i64toi32_i32$4 = $108$hi;
  i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$5 | 0;
  i64toi32_i32$0 = $17$hi;
  i64toi32_i32$3 = $17;
  i64toi32_i32$0 = i64toi32_i32$4 & i64toi32_i32$0 | 0;
  $110 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
  $110$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $102$hi;
  i64toi32_i32$4 = $102;
  i64toi32_i32$1 = $110$hi;
  i64toi32_i32$3 = $110;
  i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
  $111 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$4 = $101;
  HEAP32[(i64toi32_i32$4 + 32 | 0) >> 2] = $111;
  HEAP32[(i64toi32_i32$4 + 36 | 0) >> 2] = i64toi32_i32$1;
  memcpy($0 | 0, $1 | 0, 40 | 0) | 0;
 }
 
 function core__fmt__Write__write_char__hc2121f3713b40ead($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  HEAP32[($2 + 12 | 0) >> 2] = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ($1 >>> 0 < 128 >>> 0) {
       break label$4
      }
      if ($1 >>> 0 < 2048 >>> 0) {
       break label$3
      }
      if ($1 >>> 0 >= 65536 >>> 0) {
       break label$2
      }
      HEAP8[($2 + 14 | 0) >> 0] = $1 & 63 | 0 | 128 | 0;
      HEAP8[($2 + 12 | 0) >> 0] = $1 >>> 12 | 0 | 224 | 0;
      HEAP8[($2 + 13 | 0) >> 0] = ($1 >>> 6 | 0) & 63 | 0 | 128 | 0;
      $1 = 3;
      break label$1;
     }
     HEAP8[($2 + 12 | 0) >> 0] = $1;
     $1 = 1;
     break label$1;
    }
    HEAP8[($2 + 13 | 0) >> 0] = $1 & 63 | 0 | 128 | 0;
    HEAP8[($2 + 12 | 0) >> 0] = $1 >>> 6 | 0 | 192 | 0;
    $1 = 2;
    break label$1;
   }
   HEAP8[($2 + 15 | 0) >> 0] = $1 & 63 | 0 | 128 | 0;
   HEAP8[($2 + 12 | 0) >> 0] = $1 >>> 18 | 0 | 240 | 0;
   HEAP8[($2 + 14 | 0) >> 0] = ($1 >>> 6 | 0) & 63 | 0 | 128 | 0;
   HEAP8[($2 + 13 | 0) >> 0] = ($1 >>> 12 | 0) & 63 | 0 | 128 | 0;
   $1 = 4;
  }
  $1 = $core__fmt__builders__PadAdapter_20as_20core__fmt__Write___write_str__h2104fbe324f8507b($0 | 0, $2 + 12 | 0 | 0, $1 | 0) | 0;
  global$0 = $2 + 16 | 0;
  return $1 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__SerializeEmbeddedGroup_20for_20cardano_serialization_lib__SingleHostName___serialize_as_embedded_group__h71b245a4188cfa7d($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0;
  $3 = global$0 - 64 | 0;
  global$0 = $3;
  i64toi32_i32$0 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 + 16 | 0 | 0, $2 | 0, 0 | 0, 1 | 0, i64toi32_i32$0 | 0);
  $4 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ((HEAP32[($3 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      if ((HEAPU16[($1 + 12 | 0) >> 1] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      HEAP8[$3 >> 0] = 1;
      cbor_event__se__Serializer_W___write_special__had0377f4ca98c84d($3 + 16 | 0 | 0, $2 | 0, $3 | 0);
      break label$2;
     }
     memcpy($0 + 8 | 0 | 0, ($3 + 16 | 0) + 8 | 0 | 0, 40 | 0) | 0;
     break label$1;
    }
    i64toi32_i32$0 = HEAPU16[($1 + 14 | 0) >> 1] | 0;
    i64toi32_i32$1 = 0;
    cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 + 16 | 0 | 0, $2 | 0, 0 | 0, i64toi32_i32$0 | 0, i64toi32_i32$1 | 0);
   }
   $4 = 1;
   label$5 : {
    if ((HEAP32[($3 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$5
    }
    cbor_event__se__Serializer_W___write_text__hb80b098c4abeea7e($3 + 16 | 0 | 0, $2 | 0, $1 | 0);
    label$6 : {
     if ((HEAP32[($3 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$6
     }
     HEAP32[($0 + 4 | 0) >> 2] = $2;
     $4 = 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, ($3 + 16 | 0) + 8 | 0 | 0, 40 | 0) | 0;
    $4 = 1;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, ($3 + 16 | 0) + 8 | 0 | 0, 40 | 0) | 0;
  }
  HEAP32[$0 >> 2] = $4;
  global$0 = $3 + 64 | 0;
 }
 
 function cardano_serialization_lib__utils__Value__from_bytes__h6b1b1ca5d42117ae($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, $3 = 0, $4 = 0, $5 = 0, $18 = 0, $3$hi = 0, $4$hi = 0, $5$hi = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  HEAP32[(($2 + 136 | 0) + 16 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 136 | 0) >> 2] = 0;
  HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[(i64toi32_i32$0 + 144 | 0) >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 148 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__utils__Value_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hfd20dfadce0ab65b(i64toi32_i32$0 + 64 | 0 | 0, i64toi32_i32$0 + 136 | 0 | 0);
  $1 = (i64toi32_i32$0 + 136 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = (i64toi32_i32$0 + 64 | 0) + 8 | 0;
  label$1 : {
   label$2 : {
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 64 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$0 + 68 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    i64toi32_i32$3 = 1;
    if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
     break label$2
    }
    i64toi32_i32$3 = $1 + 16 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $3 = i64toi32_i32$2;
    $3$hi = i64toi32_i32$0;
    i64toi32_i32$2 = $2 + 16 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $3;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$3 = $1 + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $4 = i64toi32_i32$0;
    $4$hi = i64toi32_i32$2;
    i64toi32_i32$0 = $2 + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $4;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$3 = $1;
    i64toi32_i32$2 = HEAP32[$1 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $5 = i64toi32_i32$2;
    $5$hi = i64toi32_i32$0;
    i64toi32_i32$2 = $2;
    HEAP32[i64toi32_i32$2 >> 2] = $5;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = $3$hi;
    i64toi32_i32$2 = $0 + 24 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $3;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = $4$hi;
    i64toi32_i32$2 = $0 + 16 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $4;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = $5$hi;
    i64toi32_i32$2 = $0 + 8 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $5;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
    $1 = 0;
    break label$1;
   }
   $1 = memcpy($2 | 0, $1 | 0, 64 | 0) | 0;
   memcpy($1 + 64 | 0 | 0, $1 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($1 + 64 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 160 | 0;
 }
 
 function transactionbuilder_fee_for_input($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$2 = 0, $5 = 0, $6 = 0, $7 = 0, i64toi32_i32$1 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h37dfbd2f31d951c1($4 + 24 | 0 | 0, $0 | 0);
    if (!$1) {
     break label$2
    }
    $0 = HEAP32[($4 + 28 | 0) >> 2] | 0;
    $5 = HEAP32[($4 + 24 | 0) >> 2] | 0;
    wasm_bindgen____rt__WasmRefCell_T___borrow__hab2c0cbdcb539b91($4 + 16 | 0 | 0, $1 | 0);
    if (!$2) {
     break label$2
    }
    $1 = HEAP32[($4 + 20 | 0) >> 2] | 0;
    $6 = HEAP32[($4 + 16 | 0) >> 2] | 0;
    wasm_bindgen____rt__WasmRefCell_T___borrow__hd7bc050864a8d646($4 + 8 | 0 | 0, $2 | 0);
    if (!$3) {
     break label$2
    }
    $2 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    $7 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    wasm_bindgen____rt__WasmRefCell_T___borrow__h5db5149478ec5345($4 | 0, $3 | 0);
    $3 = HEAP32[($4 + 4 | 0) >> 2] | 0;
    cardano_serialization_lib__tx_builder__TransactionBuilder__fee_for_input__ha5a0f735cbb9ab50($4 + 32 | 0 | 0, $5 | 0, $6 | 0, $7 | 0, HEAP32[$4 >> 2] | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    if ((HEAP32[($4 + 32 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    i64toi32_i32$2 = $4 + 40 | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810(HEAP32[i64toi32_i32$2 >> 2] | 0 | 0, i64toi32_i32$1 | 0) | 0;
    global$0 = $4 + 48 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($4 + 36 | 0) >> 2] | 0 | 0);
  abort();
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h5a227c01abc6e4c4($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $3 = 0, $6 = 0, $7 = 0, $4 = 0, $5 = 0, $8 = 0, $9 = 0, $10 = 0, $47 = 0, $51 = 0, $55 = 0, $59 = 0, $11 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  $3 = HEAP32[$1 >> 2] | 0;
  $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h645859b7877a3836($2 | 0, $4 | 0, 0 | 0);
  $5 = HEAP32[$2 >> 2] | 0;
  $6 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $6;
  HEAP32[$0 >> 2] = $5;
  label$1 : {
   if (!$6) {
    break label$1
   }
   $1 = Math_imul($4, 168);
   $7 = ($2 + 8 | 0) + 132 | 0;
   $8 = $7 + 24 | 0;
   $9 = $7 + 16 | 0;
   $10 = $7 + 8 | 0;
   label$2 : while (1) {
    if (!$1) {
     break label$1
    }
    i64toi32_i32$2 = $3 + 156 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $47 = i64toi32_i32$0;
    i64toi32_i32$0 = $8;
    HEAP32[i64toi32_i32$0 >> 2] = $47;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $3 + 148 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $51 = i64toi32_i32$1;
    i64toi32_i32$1 = $9;
    HEAP32[i64toi32_i32$1 >> 2] = $51;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $3 + 140 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $55 = i64toi32_i32$0;
    i64toi32_i32$0 = $10;
    HEAP32[i64toi32_i32$0 >> 2] = $55;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $3 + 132 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $59 = i64toi32_i32$1;
    i64toi32_i32$1 = $7;
    HEAP32[i64toi32_i32$1 >> 2] = $59;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    $11 = HEAP32[($3 + 128 | 0) >> 2] | 0;
    $cardano_serialization_lib__TransactionOutput_20as_20core__clone__Clone___clone__h6884f0c4818d1aeb_1($2 + 8 | 0 | 0, $3 | 0);
    HEAP32[($2 + 136 | 0) >> 2] = $11;
    $5 = (memcpy($5 | 0, $2 + 8 | 0 | 0, 168 | 0) | 0) + 168 | 0;
    $1 = $1 + -168 | 0;
    $3 = $3 + 168 | 0;
    $6 = $6 + -1 | 0;
    if ($6) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 8 | 0) >> 2] = $4;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__address__ByronAddress__from_base58__h285e6684b8ae3bde($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 160 | 0;
  global$0 = $3;
  $cardano_serialization_lib__legacy_address__address__ExtendedAddr_20as_20core__str__traits__FromStr___from_str__h32affa00e2d5d659($3 + 8 | 0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[($3 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    memcpy($3 + 64 | 0 | 0, ($3 + 8 | 0) + 8 | 0 | 0, 48 | 0) | 0;
    HEAP32[($3 + 148 | 0) >> 2] = 1;
    HEAP32[($3 + 132 | 0) >> 2] = 1;
    HEAP32[($3 + 136 | 0) >> 2] = 0;
    HEAP32[($3 + 128 | 0) >> 2] = 1070340;
    HEAP32[($3 + 156 | 0) >> 2] = 132;
    HEAP32[($3 + 144 | 0) >> 2] = $3 + 152 | 0;
    HEAP32[($3 + 152 | 0) >> 2] = $3 + 64 | 0;
    alloc__fmt__format__h6e9e003a52c07309($3 + 112 | 0 | 0, $3 + 128 | 0 | 0);
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 | 0, $3 + 112 | 0 | 0);
    $1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[$3 >> 2] | 0 | 0, HEAP32[($3 + 4 | 0) >> 2] | 0 | 0) | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 112 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 112 | 0 | 0);
    label$3 : {
     if (HEAP32[($3 + 64 | 0) >> 2] | 0) {
      break label$3
     }
     core__ptr__drop_in_place_cbor_event__error__Error___hbf0141ec70b68c45(($3 + 64 | 0) + 8 | 0 | 0);
    }
    $2 = 1;
    break label$1;
   }
   $1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
   memcpy($0 + 8 | 0 | 0, ($3 + 8 | 0) + 8 | 0 | 0, 48 | 0) | 0;
   $2 = 0;
  }
  HEAP32[$0 >> 2] = $2;
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  global$0 = $3 + 160 | 0;
 }
 
 function cardano_serialization_lib__plutus__ConstrPlutusData__from_bytes__h9f26489e8a0768bf($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, $3 = 0, $4 = 0, $5 = 0, $18 = 0, $3$hi = 0, $4$hi = 0, $5$hi = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  HEAP32[(($2 + 136 | 0) + 16 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 136 | 0) >> 2] = 0;
  HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[(i64toi32_i32$0 + 144 | 0) >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 148 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__plutus__ConstrPlutusData_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h5b3b55e53d3f2947(i64toi32_i32$0 + 64 | 0 | 0, i64toi32_i32$0 + 136 | 0 | 0);
  $1 = (i64toi32_i32$0 + 136 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = (i64toi32_i32$0 + 64 | 0) + 8 | 0;
  label$1 : {
   label$2 : {
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 64 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$0 + 68 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    i64toi32_i32$3 = 1;
    if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
     break label$2
    }
    i64toi32_i32$3 = $1 + 16 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $3 = i64toi32_i32$2;
    $3$hi = i64toi32_i32$0;
    i64toi32_i32$2 = $2 + 16 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $3;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$3 = $1 + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $4 = i64toi32_i32$0;
    $4$hi = i64toi32_i32$2;
    i64toi32_i32$0 = $2 + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $4;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$3 = $1;
    i64toi32_i32$2 = HEAP32[$1 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $5 = i64toi32_i32$2;
    $5$hi = i64toi32_i32$0;
    i64toi32_i32$2 = $2;
    HEAP32[i64toi32_i32$2 >> 2] = $5;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = $3$hi;
    i64toi32_i32$2 = $0 + 24 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $3;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = $4$hi;
    i64toi32_i32$2 = $0 + 16 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $4;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = $5$hi;
    i64toi32_i32$2 = $0 + 8 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $5;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
    $1 = 0;
    break label$1;
   }
   $1 = memcpy($2 | 0, $1 | 0, 64 | 0) | 0;
   memcpy($1 + 64 | 0 | 0, $1 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($1 + 64 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 160 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_fit__h04dba6bc5ffb39a3($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $4 = 0, $3 = 0, $5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $6 = 0, $7 = 0, $53 = 0, $82 = 0;
  $3 = global$0 - 128 | 0;
  global$0 = $3;
  $4 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $5 = HEAPU16[($4 + 1546 | 0) >> 1] | 0;
  $0 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  $1 = memcpy($3 | 0, $1 | 0, 128 | 0) | 0;
  label$1 : {
   $3 = $0 + 1 | 0;
   $6 = $3 >>> 0 > $5 >>> 0;
   if ($6) {
    break label$1
   }
   memmove($4 + ($3 << 7 | 0) | 0 | 0, $4 + ($0 << 7 | 0) | 0 | 0, ($5 - $0 | 0) << 7 | 0 | 0) | 0;
  }
  memcpy($4 + ($0 << 7 | 0) | 0 | 0, $1 | 0, 128 | 0) | 0;
  $7 = $1 + 8 | 0;
  HEAP32[$7 >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $53 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[$1 >> 2] = $53;
  HEAP32[($1 + 4 | 0) >> 2] = i64toi32_i32$1;
  label$2 : {
   if ($6) {
    break label$2
   }
   $2 = $4 + 1412 | 0;
   memmove($2 + Math_imul($3, 12) | 0 | 0, $2 + Math_imul($0, 12) | 0 | 0, Math_imul($5 - $0 | 0, 12) | 0) | 0;
  }
  $0 = $4 + Math_imul($0, 12) | 0;
  HEAP32[($0 + 1420 | 0) >> 2] = HEAP32[$7 >> 2] | 0;
  $0 = $0 + 1412 | 0;
  i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $82 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[$0 >> 2] = $82;
  HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP16[($4 + 1546 | 0) >> 1] = $5 + 1 | 0;
  global$0 = $1 + 128 | 0;
  return $0 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__SerializeEmbeddedGroup_20for_20cardano_serialization_lib__StakeDelegation___serialize_as_embedded_group__hc172ed37d82fb00e($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, $11 = 0, $28 = 0, $34 = 0, $37 = 0;
  $3 = global$0 - 80 | 0;
  global$0 = $3;
  i64toi32_i32$0 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 2 | 0, i64toi32_i32$0 | 0);
  $4 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      $cardano_serialization_lib__address__StakeCredential_20as_20cbor_event__se__Serialize___serialize__h5b8c776cf4ca6024($3 | 0, $1 | 0, $2 | 0);
      if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      $11 = $1 + 53 | 0;
      HEAP32[($3 + 72 | 0) >> 2] = HEAPU8[$11 >> 0] | 0 | ((HEAPU8[($11 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($11 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($11 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$2 = $1 + 45 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $28 = i64toi32_i32$0;
      i64toi32_i32$0 = $3 + 64 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $28;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $1 + 37 | 0;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $34 = i64toi32_i32$1;
      i64toi32_i32$1 = ($3 + 48 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $34;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $1;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 29 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 30 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 31 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 32 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 33 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 34 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 35 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 36 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $37 = i64toi32_i32$0;
      i64toi32_i32$0 = $3;
      HEAP32[($3 + 48 | 0) >> 2] = $37;
      HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$1;
      cbor_event__se__Serializer_W___write_bytes__h5e3534de30c993f9($3 | 0, $2 | 0, $3 + 48 | 0 | 0);
      $4 = 1;
      if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
       break label$2
      }
      HEAP32[($0 + 4 | 0) >> 2] = $2;
      $4 = 0;
      break label$1;
     }
     memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    $4 = 1;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
  }
  HEAP32[$0 >> 2] = $4;
  global$0 = $3 + 80 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__PoolMetadata___serialize__h4d5353f47521faee($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, $23 = 0, $28 = 0, $34 = 0, $37 = 0;
  $3 = global$0 - 80 | 0;
  global$0 = $3;
  i64toi32_i32$0 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, 2 | 0, i64toi32_i32$0 | 0);
  $4 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      cbor_event__se__Serializer_W___write_text__hb80b098c4abeea7e($3 | 0, $2 | 0, $1 | 0);
      if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      i64toi32_i32$2 = $1 + 36 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $23 = i64toi32_i32$0;
      i64toi32_i32$0 = $3 + 72 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $23;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $1 + 28 | 0;
      i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $28 = i64toi32_i32$1;
      i64toi32_i32$1 = $3 + 64 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $28;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      i64toi32_i32$2 = $1 + 20 | 0;
      i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $34 = i64toi32_i32$0;
      i64toi32_i32$0 = ($3 + 48 | 0) + 8 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $34;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $1;
      i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 12 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 13 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 14 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 15 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 16 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 17 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 18 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 19 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
      $37 = i64toi32_i32$1;
      i64toi32_i32$1 = $3;
      HEAP32[($3 + 48 | 0) >> 2] = $37;
      HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$0;
      cbor_event__se__Serializer_W___write_bytes__h85f4434ac9a8a060($3 | 0, $2 | 0, $3 + 48 | 0 | 0);
      $4 = 1;
      if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
       break label$2
      }
      HEAP32[($0 + 4 | 0) >> 2] = $2;
      $4 = 0;
      break label$1;
     }
     memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    $4 = 1;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
  }
  HEAP32[$0 >> 2] = $4;
  global$0 = $3 + 80 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__MIRToStakeCredentials___serialize__h6a8886ca50fc22cf($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, $5 = 0, i64toi32_i32$1 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  i64toi32_i32$1 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 5 | 0, HEAP32[($1 + 28 | 0) >> 2] | 0 | 0, i64toi32_i32$1 | 0);
  $4 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      label$5 : {
       label$6 : {
        $5 = HEAP32[($1 + 32 | 0) >> 2] | 0;
        if ($5) {
         break label$6
        }
        $1 = 0;
        break label$5;
       }
       $1 = HEAP32[($5 + 20 | 0) >> 2] | 0;
      }
      label$7 : {
       if (($1 | 0) == ($5 | 0)) {
        break label$7
       }
       label$8 : while (1) {
        $4 = HEAP32[($1 + 20 | 0) >> 2] | 0;
        $cardano_serialization_lib__address__StakeCredential_20as_20cbor_event__se__Serialize___serialize__h5b8c776cf4ca6024($3 | 0, $1 + 24 | 0 | 0, $2 | 0);
        if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
         break label$2
        }
        $cardano_serialization_lib__utils__Int_20as_20cbor_event__se__Serialize___serialize__h52978cec14c40013($3 | 0, $1 | 0, $2 | 0);
        if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
         break label$3
        }
        $1 = $4;
        if (($1 | 0) != ($5 | 0)) {
         continue label$8
        }
        break label$8;
       };
      }
      HEAP32[($0 + 4 | 0) >> 2] = $2;
      $4 = 0;
      break label$1;
     }
     memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    $4 = 1;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $4 = 1;
  }
  HEAP32[$0 >> 2] = $4;
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__AuxiliaryDataSet___serialize__hecb5dbb69688610a($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, $5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  i64toi32_i32$0 = HEAP32[($1 + 28 | 0) >> 2] | 0;
  i64toi32_i32$1 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 5 | 0, i64toi32_i32$0 | 0, i64toi32_i32$1 | 0);
  $4 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      label$5 : {
       label$6 : {
        $5 = HEAP32[($1 + 32 | 0) >> 2] | 0;
        if ($5) {
         break label$6
        }
        $1 = 0;
        break label$5;
       }
       $1 = HEAP32[($5 + 68 | 0) >> 2] | 0;
      }
      label$7 : {
       if (($1 | 0) == ($5 | 0)) {
        break label$7
       }
       label$8 : while (1) {
        $4 = HEAP32[($1 + 68 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($1 + 72 | 0) >> 2] | 0;
        i64toi32_i32$0 = 0;
        cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, i64toi32_i32$1 | 0, i64toi32_i32$0 | 0);
        if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
         break label$2
        }
        $cardano_serialization_lib__metadata__AuxiliaryData_20as_20cbor_event__se__Serialize___serialize__h6e246ec2e95d27d5($3 | 0, $1 | 0, $2 | 0);
        if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
         break label$3
        }
        $1 = $4;
        if (($1 | 0) != ($5 | 0)) {
         continue label$8
        }
        break label$8;
       };
      }
      HEAP32[($0 + 4 | 0) >> 2] = $2;
      $4 = 0;
      break label$1;
     }
     memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    $4 = 1;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $4 = 1;
  }
  HEAP32[$0 >> 2] = $4;
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__utils__Value__checked_sub__hadecd14ba2ae4b3b($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, $3 = 0, i64toi32_i32$2 = 0, i64toi32_i32$5 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $4 = 0, $5 = 0, $5$hi = 0, $6 = 0, $6$hi = 0, $14 = 0, $14$hi = 0, $53 = 0;
  $3 = global$0 - 32 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      i64toi32_i32$2 = $1;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $5 = i64toi32_i32$0;
      $5$hi = i64toi32_i32$1;
      i64toi32_i32$2 = $2;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $14 = i64toi32_i32$1;
      $14$hi = i64toi32_i32$0;
      i64toi32_i32$0 = $5$hi;
      i64toi32_i32$2 = $5;
      i64toi32_i32$1 = $14$hi;
      i64toi32_i32$3 = $14;
      i64toi32_i32$5 = (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) + i64toi32_i32$1 | 0;
      i64toi32_i32$5 = i64toi32_i32$0 - i64toi32_i32$5 | 0;
      $6 = i64toi32_i32$2 - i64toi32_i32$3 | 0;
      $6$hi = i64toi32_i32$5;
      i64toi32_i32$5 = i64toi32_i32$0;
      i64toi32_i32$5 = $6$hi;
      i64toi32_i32$0 = $6;
      i64toi32_i32$2 = $5$hi;
      i64toi32_i32$3 = $5;
      if (i64toi32_i32$5 >>> 0 > i64toi32_i32$2 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$0 >>> 0 > i64toi32_i32$3 >>> 0 | 0) | 0) {
       break label$4
      }
      $4 = 0;
      if ((HEAP32[($1 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
       break label$2
      }
      $1 = $1 + 12 | 0;
      if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($3 + 4 | 0 | 0, $1 | 0);
      $4 = 1;
      break label$2;
     }
     $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1058740 | 0, 9 | 0) | 0 | 0) | 0;
     HEAP32[$0 >> 2] = 1;
     HEAP32[($0 + 4 | 0) >> 2] = $1;
     break label$1;
    }
    $2 = $2 + 12 | 0;
    cardano_serialization_lib__MultiAsset__sub__h87ca73850e5358bf($3 + 16 | 0 | 0, $1 | 0, $2 | 0);
    label$5 : {
     label$6 : {
      if (HEAP32[($3 + 24 | 0) >> 2] | 0) {
       break label$6
      }
      $4 = 0;
      break label$5;
     }
     cardano_serialization_lib__MultiAsset__sub__h87ca73850e5358bf($3 + 4 | 0 | 0, $1 | 0, $2 | 0);
     $4 = 1;
    }
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($3 + 16 | 0 | 0);
   }
   HEAP32[$0 >> 2] = 0;
   i64toi32_i32$3 = $3;
   i64toi32_i32$0 = HEAP32[($3 + 4 | 0) >> 2] | 0;
   i64toi32_i32$5 = HEAP32[($3 + 8 | 0) >> 2] | 0;
   $53 = i64toi32_i32$0;
   i64toi32_i32$0 = $0 + 20 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $53;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$5;
   HEAP32[($0 + 16 | 0) >> 2] = $4;
   i64toi32_i32$5 = $6$hi;
   i64toi32_i32$0 = $0 + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $6;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$5;
   HEAP32[($0 + 28 | 0) >> 2] = HEAP32[(($3 + 4 | 0) + 8 | 0) >> 2] | 0;
  }
  global$0 = $3 + 32 | 0;
 }
 
 function $cardano_serialization_lib__metadata__MetadataMap_20as_20cbor_event__se__Serialize___serialize__h7bf88c8e5cef4c92($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, $5 = 0, i64toi32_i32$1 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  i64toi32_i32$1 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 5 | 0, HEAP32[($1 + 28 | 0) >> 2] | 0 | 0, i64toi32_i32$1 | 0);
  $4 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      label$5 : {
       $5 = HEAP32[($1 + 32 | 0) >> 2] | 0;
       if (!$5) {
        break label$5
       }
       $1 = HEAP32[($5 + 100 | 0) >> 2] | 0;
       if (($1 | 0) == ($5 | 0)) {
        break label$5
       }
       if (!$1) {
        break label$5
       }
       label$6 : while (1) {
        $4 = HEAP32[($1 + 100 | 0) >> 2] | 0;
        $cardano_serialization_lib__metadata__TransactionMetadatumEnum_20as_20cbor_event__se__Serialize___serialize__h4285ca14e4462f47($3 | 0, $1 | 0, $2 | 0);
        if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
         break label$2
        }
        $cardano_serialization_lib__metadata__TransactionMetadatumEnum_20as_20cbor_event__se__Serialize___serialize__h4285ca14e4462f47($3 | 0, $1 + 48 | 0 | 0, $2 | 0);
        if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
         break label$3
        }
        if (($4 | 0) == ($5 | 0)) {
         break label$5
        }
        $1 = $4;
        if ($1) {
         continue label$6
        }
        break label$6;
       };
      }
      HEAP32[($0 + 4 | 0) >> 2] = $2;
      $4 = 0;
      break label$1;
     }
     memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    $4 = 1;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $4 = 1;
  }
  HEAP32[$0 >> 2] = $4;
  global$0 = $3 + 48 | 0;
 }
 
 function $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__iter__traits__collect__Extend__28K_2cV_29____extend__h675e35b5920dd1f3($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $2 = 0, $3 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $25 = 0, $26 = 0, $4 = 0, $7 = 0, $8 = 0, $9 = 0, $5 = 0, $6 = 0, $34 = 0, $41 = 0, $52 = 0, $10 = 0, $10$hi = 0, $63 = 0, $67 = 0, $71 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  label$1 : {
   $3 = HEAP32[$1 >> 2] | 0;
   $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   if (($3 | 0) == ($4 | 0)) {
    break label$1
   }
   $1 = $2 + 48 | 0 | 2 | 0;
   label$2 : while (1) {
    $5 = HEAP32[($3 + 12 | 0) >> 2] | 0;
    $6 = HEAPU8[($3 + 16 | 0) >> 0] | 0;
    $7 = ($2 + 16 | 0) + 8 | 0;
    i64toi32_i32$2 = $3 + 26 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $34 = i64toi32_i32$0;
    i64toi32_i32$0 = $7;
    HEAP32[i64toi32_i32$0 >> 2] = $34;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    $8 = ($2 + 16 | 0) + 16 | 0;
    i64toi32_i32$2 = $3 + 34 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $41 = i64toi32_i32$1;
    i64toi32_i32$1 = $8;
    HEAP32[i64toi32_i32$1 >> 2] = $41;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    $9 = ($2 + 16 | 0) + 24 | 0;
    $21 = $3 + 42 | 0;
    HEAP32[$9 >> 2] = HEAPU8[$21 >> 0] | 0 | ((HEAPU8[($21 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($21 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($21 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$2 = $3 + 18 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $52 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $52;
    HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $10 = i64toi32_i32$1;
    $10$hi = i64toi32_i32$0;
    HEAP8[($2 + 49 | 0) >> 0] = HEAPU8[(i64toi32_i32$2 + 17 | 0) >> 0] | 0;
    HEAP8[($2 + 48 | 0) >> 0] = $6;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
    $63 = i64toi32_i32$0;
    i64toi32_i32$0 = $1;
    $22 = $63;
    HEAP8[i64toi32_i32$0 >> 0] = $22;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $22 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $22 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $22 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$2 = $7;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $67 = i64toi32_i32$1;
    i64toi32_i32$1 = $1 + 8 | 0;
    $23 = $67;
    HEAP8[i64toi32_i32$1 >> 0] = $23;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $23 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $23 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $23 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$2 = $8;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $71 = i64toi32_i32$0;
    i64toi32_i32$0 = $1 + 16 | 0;
    $24 = $71;
    HEAP8[i64toi32_i32$0 >> 0] = $24;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $24 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $24 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $24 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    $25 = $1 + 24 | 0;
    $26 = HEAP32[$9 >> 2] | 0;
    HEAP8[$25 >> 0] = $26;
    HEAP8[($25 + 1 | 0) >> 0] = $26 >>> 8 | 0;
    HEAP8[($25 + 2 | 0) >> 0] = $26 >>> 16 | 0;
    HEAP8[($25 + 3 | 0) >> 0] = $26 >>> 24 | 0;
    i64toi32_i32$1 = $10$hi;
    linked_hash_map__LinkedHashMap_K_2cV_2cS___insert__h654f744b7b23f305($2 | 0, $0 | 0, $2 + 48 | 0 | 0, $10 | 0, i64toi32_i32$1 | 0);
    $3 = $5;
    if (($3 | 0) != ($4 | 0)) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $2 + 112 | 0;
 }
 
 function bip32publickey_to_raw_key($0) {
  $0 = $0 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $1 = 0, $2 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $7 = 0, $40 = 0, $46 = 0, $52 = 0, $55 = 0, $63 = 0, $66 = 0, $69 = 0, $72 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hcfcf2a638924fc64($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $3 = ($1 + 48 | 0) + 24 | 0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = ($1 + 48 | 0) + 16 | 0;
  i64toi32_i32$1 = $4;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $5 = ($1 + 48 | 0) + 8 | 0;
  i64toi32_i32$1 = $5;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$1 = $1;
  i64toi32_i32$0 = 0;
  HEAP32[(i64toi32_i32$1 + 48 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 52 | 0) >> 2] = i64toi32_i32$0;
  ed25519_bip32__key__XPub__get_without_chaincode__h1b3f335862724d9d($2 | 0, i64toi32_i32$1 + 48 | 0 | 0);
  $2 = (i64toi32_i32$1 + 16 | 0) + 24 | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $40 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $40;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $6 = ($1 + 16 | 0) + 16 | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $6;
  HEAP32[i64toi32_i32$1 >> 2] = $46;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $7 = ($1 + 16 | 0) + 8 | 0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $52 = i64toi32_i32$0;
  i64toi32_i32$0 = $7;
  HEAP32[i64toi32_i32$0 >> 2] = $52;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[($1 + 48 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 52 | 0) >> 2] | 0;
  $55 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $55;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $63 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $63;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $6;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $66 = i64toi32_i32$1;
  i64toi32_i32$1 = $4;
  HEAP32[i64toi32_i32$1 >> 2] = $66;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $7;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $69 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[i64toi32_i32$0 >> 2] = $69;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[($1 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  $72 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[(i64toi32_i32$1 + 48 | 0) >> 2] = $72;
  HEAP32[(i64toi32_i32$1 + 52 | 0) >> 2] = i64toi32_i32$0;
  $0 = $cardano_serialization_lib__crypto__PublicKey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h435bbe8dcccd675c(i64toi32_i32$1 + 48 | 0 | 0) | 0;
  global$0 = i64toi32_i32$1 + 80 | 0;
  return $0 | 0;
 }
 
 function nonce_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $10 = 0, $11 = 0, $12 = 0, $13 = 0, $14 = 0, $31 = 0, $46 = 0, $51 = 0, $69 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 56 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 72 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 56 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 56 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 60 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 72 | 0) >> 2] = $31;
  HEAP32[($2 + 76 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__crypto__Nonce__from_bytes__hff37fe8e771f5387($2 + 16 | 0 | 0, $2 + 72 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 16 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = $2 + 32 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 87 | 0;
  $10 = $46;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 40 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $51 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 95 | 0;
  $11 = $51;
  HEAP8[i64toi32_i32$0 >> 0] = $11;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $13 = $2 + 103 | 0;
  $14 = HEAPU16[($2 + 48 | 0) >> 1] | 0;
  HEAP8[$13 >> 0] = $14;
  HEAP8[($13 + 1 | 0) >> 0] = $14 >>> 8 | 0;
  HEAP8[($2 + 74 | 0) >> 0] = HEAPU8[($2 + 19 | 0) >> 0] | 0;
  HEAP16[($2 + 72 | 0) >> 1] = HEAPU8[($2 + 17 | 0) >> 0] | 0 | ((HEAPU8[($2 + 18 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 75 | 0) >> 0] = $1;
  HEAP8[($2 + 76 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 77 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 78 | 0) >> 0] = $1 >>> 24 | 0;
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $69 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  $12 = $69;
  HEAP8[($2 + 79 | 0) >> 0] = $12;
  HEAP8[($2 + 80 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[($2 + 81 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[($2 + 82 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[($2 + 83 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[($2 + 84 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[($2 + 85 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[($2 + 86 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $1 = $cardano_serialization_lib__crypto__Nonce_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h3e2dae3d5c688227($2 + 72 | 0 | 0) | 0;
  global$0 = $2 + 112 | 0;
  return $1 | 0;
 }
 
 function nonce_new_from_hash($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $10 = 0, $11 = 0, $12 = 0, $13 = 0, $14 = 0, $31 = 0, $46 = 0, $51 = 0, $69 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 56 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 72 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 56 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 56 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 60 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 72 | 0) >> 2] = $31;
  HEAP32[($2 + 76 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__crypto__Nonce__new_from_hash__he3b161ea641d4ae6($2 + 16 | 0 | 0, $2 + 72 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 16 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = $2 + 32 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 87 | 0;
  $10 = $46;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 40 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $51 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 95 | 0;
  $11 = $51;
  HEAP8[i64toi32_i32$0 >> 0] = $11;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $13 = $2 + 103 | 0;
  $14 = HEAPU16[($2 + 48 | 0) >> 1] | 0;
  HEAP8[$13 >> 0] = $14;
  HEAP8[($13 + 1 | 0) >> 0] = $14 >>> 8 | 0;
  HEAP8[($2 + 74 | 0) >> 0] = HEAPU8[($2 + 19 | 0) >> 0] | 0;
  HEAP16[($2 + 72 | 0) >> 1] = HEAPU8[($2 + 17 | 0) >> 0] | 0 | ((HEAPU8[($2 + 18 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 75 | 0) >> 0] = $1;
  HEAP8[($2 + 76 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 77 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 78 | 0) >> 0] = $1 >>> 24 | 0;
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $69 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  $12 = $69;
  HEAP8[($2 + 79 | 0) >> 0] = $12;
  HEAP8[($2 + 80 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[($2 + 81 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[($2 + 82 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[($2 + 83 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[($2 + 84 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[($2 + 85 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[($2 + 86 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $1 = $cardano_serialization_lib__crypto__Nonce_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h3e2dae3d5c688227($2 + 72 | 0 | 0) | 0;
  global$0 = $2 + 112 | 0;
  return $1 | 0;
 }
 
 function core__option__Option__T___cloned__h190bc29714e10538($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $4 = 0, $53 = 0, $56 = 0;
  $2 = global$0 - 144 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if ($1) {
     break label$2
    }
    i64toi32_i32$1 = $0;
    i64toi32_i32$0 = 0;
    HEAP32[i64toi32_i32$1 >> 2] = 0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    break label$1;
   }
   label$3 : {
    label$4 : {
     if (HEAP32[($1 + 20 | 0) >> 2] | 0) {
      break label$4
     }
     HEAP32[($2 + 92 | 0) >> 2] = 0;
     break label$3;
    }
    $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h44c6d4679ef9fae6($2 + 72 | 0 | 0, $1 | 0);
   }
   $3 = $1 + 52 | 0;
   label$5 : {
    label$6 : {
     $4 = HEAP32[($1 + 40 | 0) >> 2] | 0;
     if ($4) {
      break label$6
     }
     HEAP32[($2 + 112 | 0) >> 2] = 0;
     break label$5;
    }
    alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($2 + 112 | 0 | 0, $4 | 0, HEAP32[($1 + 48 | 0) >> 2] | 0 | 0);
   }
   label$7 : {
    label$8 : {
     if (HEAP32[$3 >> 2] | 0) {
      break label$8
     }
     HEAP32[($2 + 128 | 0) >> 2] = 0;
     break label$7;
    }
    $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hc722e22117ee5940($2 + 128 | 0 | 0, $3 | 0);
   }
   memcpy($2 + 8 | 0 | 0, $2 + 72 | 0 | 0, 40 | 0) | 0;
   HEAP32[($2 + 56 | 0) >> 2] = HEAP32[(($2 + 112 | 0) + 8 | 0) >> 2] | 0;
   HEAP32[($2 + 68 | 0) >> 2] = HEAP32[(($2 + 128 | 0) + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 112 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 116 | 0) >> 2] | 0;
   $53 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   HEAP32[($2 + 48 | 0) >> 2] = $53;
   HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = HEAP32[($2 + 128 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 132 | 0) >> 2] | 0;
   $56 = i64toi32_i32$1;
   i64toi32_i32$1 = $2;
   HEAP32[($2 + 60 | 0) >> 2] = $56;
   HEAP32[($2 + 64 | 0) >> 2] = i64toi32_i32$0;
   memcpy($0 + 8 | 0 | 0, $2 + 8 | 0 | 0, 64 | 0) | 0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[i64toi32_i32$1 >> 2] = 1;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  }
  global$0 = $2 + 144 | 0;
 }
 
 function ryu__pretty__mantissa__write_mantissa__h7421817dc3be69e8($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $7 = 0, $8 = 0, $9 = 0, $10 = 0, $11 = 0, $12 = 0, $13 = 0, $14 = 0;
  label$1 : {
   label$2 : {
    if ($0 >>> 0 >= 1e4 >>> 0) {
     break label$2
    }
    $2 = $0;
    break label$1;
   }
   $1 = $1 + -4 | 0;
   label$3 : while (1) {
    $2 = ($0 >>> 0) / (1e4 >>> 0) | 0;
    $3 = Math_imul($2, -1e4) + $0 | 0;
    $4 = ($3 >>> 0) / (100 >>> 0) | 0;
    $5 = ($4 << 1 | 0) + 1100304 | 0;
    $6 = HEAPU8[$5 >> 0] | 0 | ((HEAPU8[($5 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
    HEAP8[$1 >> 0] = $6;
    HEAP8[($1 + 1 | 0) >> 0] = $6 >>> 8 | 0;
    $7 = (($3 - Math_imul($4, 100) | 0) << 1 | 0) + 1100304 | 0;
    $8 = $1 + 2 | 0;
    $9 = HEAPU8[$7 >> 0] | 0 | ((HEAPU8[($7 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
    HEAP8[$8 >> 0] = $9;
    HEAP8[($8 + 1 | 0) >> 0] = $9 >>> 8 | 0;
    $1 = $1 + -4 | 0;
    $3 = $0 >>> 0 > 99999999 >>> 0;
    $0 = $2;
    if ($3) {
     continue label$3
    }
    break label$3;
   };
   $1 = $1 + 4 | 0;
  }
  label$4 : {
   label$5 : {
    if ($2 >>> 0 > 99 >>> 0) {
     break label$5
    }
    $0 = $2;
    break label$4;
   }
   $1 = $1 + -2 | 0;
   $0 = (($2 & 65535 | 0) >>> 0) / (100 >>> 0) | 0;
   $10 = ((($2 - Math_imul($0, 100) | 0) & 65535 | 0) << 1 | 0) + 1100304 | 0;
   $11 = HEAPU8[$10 >> 0] | 0 | ((HEAPU8[($10 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
   HEAP8[$1 >> 0] = $11;
   HEAP8[($1 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  }
  label$6 : {
   if ($0 >>> 0 > 9 >>> 0) {
    break label$6
   }
   HEAP8[($1 + -1 | 0) >> 0] = $0 + 48 | 0;
   return;
  }
  $12 = ($0 << 1 | 0) + 1100304 | 0;
  $13 = $1 + -2 | 0;
  $14 = HEAPU8[$12 >> 0] | 0 | ((HEAPU8[($12 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[$13 >> 0] = $14;
  HEAP8[($13 + 1 | 0) >> 0] = $14 >>> 8 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__h1fe5a9016efba49b($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, $6 = 0, $7 = 0, $5 = 0;
  $3 = global$0 - 144 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = HEAPU16[($4 + 1458 | 0) >> 1] | 0;
  $1 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $6 = $5 + ($1 ^ -1 | 0) | 0;
  HEAP16[($2 + 1458 | 0) >> 1] = $6;
  memcpy($3 + 8 | 0 | 0, ($4 + Math_imul($1, 36) | 0) + 1060 | 0 | 0, 36 | 0) | 0;
  memcpy($3 + 48 | 0 | 0, $4 + Math_imul($1, 96) | 0 | 0, 96 | 0) | 0;
  label$1 : {
   label$2 : {
    if ($6 >>> 0 >= 12 >>> 0) {
     break label$2
    }
    $7 = $1 + 1 | 0;
    if (($5 - $7 | 0 | 0) != ($6 | 0)) {
     break label$1
    }
    memcpy($2 + 1060 | 0 | 0, ($4 + Math_imul($7, 36) | 0) + 1060 | 0 | 0, Math_imul($6, 36) | 0) | 0;
    memcpy($2 | 0, $4 + Math_imul($7, 96) | 0 | 0, Math_imul($6, 96) | 0) | 0;
    HEAP16[($4 + 1458 | 0) >> 1] = $1;
    memcpy((memcpy($0 | 0, $3 + 8 | 0 | 0, 36 | 0) | 0) + 40 | 0 | 0, $3 + 48 | 0 | 0, 96 | 0) | 0;
    global$0 = $3 + 144 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($6 | 0, 11 | 0, 1049044 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1048988 | 0, 40 | 0, 1049028 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__hacdc9191bb753809($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, $6 = 0, $7 = 0, $5 = 0;
  $3 = global$0 - 144 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = HEAPU16[($4 + 1458 | 0) >> 1] | 0;
  $1 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $6 = $5 + ($1 ^ -1 | 0) | 0;
  HEAP16[($2 + 1458 | 0) >> 1] = $6;
  memcpy($3 + 8 | 0 | 0, ($4 + Math_imul($1, 36) | 0) + 1060 | 0 | 0, 36 | 0) | 0;
  memcpy($3 + 48 | 0 | 0, $4 + Math_imul($1, 96) | 0 | 0, 96 | 0) | 0;
  label$1 : {
   label$2 : {
    if ($6 >>> 0 >= 12 >>> 0) {
     break label$2
    }
    $7 = $1 + 1 | 0;
    if (($5 - $7 | 0 | 0) != ($6 | 0)) {
     break label$1
    }
    memcpy($2 + 1060 | 0 | 0, ($4 + Math_imul($7, 36) | 0) + 1060 | 0 | 0, Math_imul($6, 36) | 0) | 0;
    memcpy($2 | 0, $4 + Math_imul($7, 96) | 0 | 0, Math_imul($6, 96) | 0) | 0;
    HEAP16[($4 + 1458 | 0) >> 1] = $1;
    memcpy((memcpy($0 | 0, $3 + 8 | 0 | 0, 36 | 0) | 0) + 40 | 0 | 0, $3 + 48 | 0 | 0, 96 | 0) | 0;
    global$0 = $3 + 144 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($6 | 0, 11 | 0, 1049044 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1048988 | 0, 40 | 0, 1049028 | 0);
  abort();
 }
 
 function core__ptr__drop_in_place_cbor_event__value__Value___h203893ddc6d2104a($0) {
  $0 = $0 | 0;
  var $2 = 0, $1 = 0;
  label$1 : {
   switch ((HEAP32[$0 >> 2] | 0) + -2 | 0 | 0) {
   case 0:
    $0 = $0 + 4 | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
    return;
   case 1:
    $0 = $0 + 4 | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
    return;
   case 2:
    $1 = $0 + 4 | 0;
    label$9 : {
     $2 = HEAP32[($0 + 12 | 0) >> 2] | 0;
     if (!$2) {
      break label$9
     }
     $0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
     $2 = Math_imul($2, 24);
     label$10 : while (1) {
      core__ptr__drop_in_place_cbor_event__value__Value___h203893ddc6d2104a_1($0 | 0);
      $0 = $0 + 24 | 0;
      $2 = $2 + -24 | 0;
      if ($2) {
       continue label$10
      }
      break label$10;
     };
    }
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h8809497f289c3544($1 | 0);
    return;
   case 3:
    $1 = $0 + 4 | 0;
    label$11 : {
     $2 = HEAP32[($0 + 12 | 0) >> 2] | 0;
     if (!$2) {
      break label$11
     }
     $0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
     $2 = Math_imul($2, 24);
     label$12 : while (1) {
      core__ptr__drop_in_place_cbor_event__value__Value___h203893ddc6d2104a_1($0 | 0);
      $0 = $0 + 24 | 0;
      $2 = $2 + -24 | 0;
      if ($2) {
       continue label$12
      }
      break label$12;
     };
    }
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h8809497f289c3544($1 | 0);
    return;
   case 4:
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__hbe15b6996cefd7cc($0 + 4 | 0 | 0);
   default:
    return;
   case 5:
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__hbe15b6996cefd7cc($0 + 4 | 0 | 0);
    return;
   case 6:
    break label$1;
   };
  }
  core__ptr__drop_in_place_cbor_event__value__Value___h203893ddc6d2104a(HEAP32[($0 + 4 | 0) >> 2] | 0 | 0);
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[($0 + 4 | 0) >> 2] | 0 | 0) | 0 | 0, 24 | 0, 8 | 0);
 }
 
 function $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__iter__traits__collect__Extend__28K_2cV_29____extend__h2844134357a5aef9($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $2 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $25 = 0, $26 = 0, $4 = 0, $8 = 0, $9 = 0, $6 = 0, $10 = 0, $11$hi = 0, $12$hi = 0, $5 = 0, $8$hi = 0, $9$hi = 0, $10$hi = 0, $7 = 0, $11 = 0, $12 = 0;
  $2 = global$0 - 128 | 0;
  global$0 = $2;
  label$1 : {
   $3 = HEAP32[$1 >> 2] | 0;
   $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   if (($3 | 0) == ($4 | 0)) {
    break label$1
   }
   $1 = $2 + 64 | 0 | 1 | 0;
   label$2 : while (1) {
    $5 = HEAP32[($3 + 20 | 0) >> 2] | 0;
    i64toi32_i32$2 = $3 + 33 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $8 = i64toi32_i32$0;
    $8$hi = i64toi32_i32$1;
    i64toi32_i32$0 = ($2 + 32 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $8;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $3 + 41 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $9 = i64toi32_i32$1;
    $9$hi = i64toi32_i32$0;
    i64toi32_i32$1 = ($2 + 32 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $9;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    $21 = $3 + 49 | 0;
    $6 = HEAPU8[$21 >> 0] | 0 | ((HEAPU8[($21 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($21 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($21 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    HEAP32[(($2 + 32 | 0) + 24 | 0) >> 2] = $6;
    i64toi32_i32$2 = $3 + 25 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $10 = i64toi32_i32$0;
    $10$hi = i64toi32_i32$1;
    i64toi32_i32$0 = $2;
    HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] = $10;
    HEAP32[(i64toi32_i32$0 + 36 | 0) >> 2] = i64toi32_i32$1;
    $7 = HEAPU8[($3 + 24 | 0) >> 0] | 0;
    i64toi32_i32$2 = $3 + 8 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $11 = i64toi32_i32$1;
    $11$hi = i64toi32_i32$0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $12 = i64toi32_i32$0;
    $12$hi = i64toi32_i32$1;
    i64toi32_i32$1 = $10$hi;
    i64toi32_i32$0 = $1;
    $22 = $10;
    HEAP8[i64toi32_i32$0 >> 0] = $22;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $22 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $22 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $22 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$1 = $8$hi;
    i64toi32_i32$0 = i64toi32_i32$0 + 8 | 0;
    $23 = $8;
    HEAP8[i64toi32_i32$0 >> 0] = $23;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $23 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $23 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $23 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$1 = $9$hi;
    i64toi32_i32$0 = $1 + 16 | 0;
    $24 = $9;
    HEAP8[i64toi32_i32$0 >> 0] = $24;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $24 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $24 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $24 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    $25 = $1 + 24 | 0;
    $26 = $6;
    HEAP8[$25 >> 0] = $26;
    HEAP8[($25 + 1 | 0) >> 0] = $26 >>> 8 | 0;
    HEAP8[($25 + 2 | 0) >> 0] = $26 >>> 16 | 0;
    HEAP8[($25 + 3 | 0) >> 0] = $26 >>> 24 | 0;
    HEAP8[($2 + 64 | 0) >> 0] = $7;
    i64toi32_i32$1 = $12$hi;
    i64toi32_i32$1 = $11$hi;
    i64toi32_i32$1 = $12$hi;
    i64toi32_i32$0 = $11$hi;
    linked_hash_map__LinkedHashMap_K_2cV_2cS___insert__h3e59fdce083c9794($2 + 8 | 0 | 0, $0 | 0, $2 + 64 | 0 | 0, $12 | 0, i64toi32_i32$1 | 0, $11 | 0, i64toi32_i32$0 | 0);
    $3 = $5;
    if (($3 | 0) != ($4 | 0)) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $2 + 128 | 0;
 }
 
 function $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__h96b8cd0b2bd03e44($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $5 = 0, $3 = 0, $4 = 0, $59 = 0, $62 = 0, $73 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  $core__iter__adapters__ResultShunt_I_2cE__20as_20core__iter__traits__iterator__Iterator___try_fold__h81e306f0b3e48011($2 + 16 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    if ((HEAPU8[($2 + 16 | 0) >> 0] | 0) & 1 | 0) {
     break label$2
    }
    i64toi32_i32$1 = $0;
    i64toi32_i32$0 = 0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = 0;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[i64toi32_i32$1 >> 2] = HEAP32[(0 + 1067616 | 0) >> 2] | 0;
    break label$1;
   }
   $3 = HEAPU8[($2 + 17 | 0) >> 0] | 0;
   $core__iter__adapters__ResultShunt_I_2cE__20as_20core__iter__traits__iterator__Iterator___size_hint__hb25e984a0df95a21($2 + 40 | 0 | 0, $1 | 0);
   $4 = HEAP32[($2 + 40 | 0) >> 2] | 0;
   $5 = $4 + 1 | 0;
   alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 + 8 | 0 | 0, ($5 >>> 0 < $4 >>> 0 ? -1 : $5) | 0, 0 | 0);
   $4 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $5 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   HEAP8[$5 >> 0] = $3;
   $3 = ($2 + 24 | 0) + 8 | 0;
   HEAP32[$3 >> 2] = 1;
   HEAP32[($2 + 28 | 0) >> 2] = $4;
   HEAP32[($2 + 24 | 0) >> 2] = $5;
   HEAP32[(($2 + 40 | 0) + 16 | 0) >> 2] = HEAP32[($1 + 16 | 0) >> 2] | 0;
   i64toi32_i32$2 = $1 + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $59 = i64toi32_i32$0;
   i64toi32_i32$0 = ($2 + 40 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $59;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $62 = i64toi32_i32$1;
   i64toi32_i32$1 = $2;
   HEAP32[($2 + 40 | 0) >> 2] = $62;
   HEAP32[($2 + 44 | 0) >> 2] = i64toi32_i32$0;
   alloc__vec__Vec_T_2cA___extend_desugared__h5c38f14e95453798($2 + 24 | 0 | 0, $2 + 40 | 0 | 0);
   HEAP32[($0 + 8 | 0) >> 2] = HEAP32[$3 >> 2] | 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[($2 + 24 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 28 | 0) >> 2] | 0;
   $73 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[i64toi32_i32$0 >> 2] = $73;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  }
  global$0 = $2 + 64 | 0;
 }
 
 function $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__hfbc1ea6d6bc089ca($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $5 = 0, $3 = 0, $4 = 0, $59 = 0, $62 = 0, $73 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  $core__iter__adapters__ResultShunt_I_2cE__20as_20core__iter__traits__iterator__Iterator___try_fold__h46f032289f335f5a($2 + 16 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    if ((HEAPU8[($2 + 16 | 0) >> 0] | 0) & 1 | 0) {
     break label$2
    }
    i64toi32_i32$1 = $0;
    i64toi32_i32$0 = 0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = 0;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[i64toi32_i32$1 >> 2] = HEAP32[(0 + 1067616 | 0) >> 2] | 0;
    break label$1;
   }
   $3 = HEAPU8[($2 + 17 | 0) >> 0] | 0;
   $core__iter__adapters__ResultShunt_I_2cE__20as_20core__iter__traits__iterator__Iterator___size_hint__h90f4fd0095433d70($2 + 40 | 0 | 0, $1 | 0);
   $4 = HEAP32[($2 + 40 | 0) >> 2] | 0;
   $5 = $4 + 1 | 0;
   alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 + 8 | 0 | 0, ($5 >>> 0 < $4 >>> 0 ? -1 : $5) | 0, 0 | 0);
   $4 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $5 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   HEAP8[$5 >> 0] = $3;
   $3 = ($2 + 24 | 0) + 8 | 0;
   HEAP32[$3 >> 2] = 1;
   HEAP32[($2 + 28 | 0) >> 2] = $4;
   HEAP32[($2 + 24 | 0) >> 2] = $5;
   HEAP32[(($2 + 40 | 0) + 16 | 0) >> 2] = HEAP32[($1 + 16 | 0) >> 2] | 0;
   i64toi32_i32$2 = $1 + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $59 = i64toi32_i32$0;
   i64toi32_i32$0 = ($2 + 40 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $59;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $62 = i64toi32_i32$1;
   i64toi32_i32$1 = $2;
   HEAP32[($2 + 40 | 0) >> 2] = $62;
   HEAP32[($2 + 44 | 0) >> 2] = i64toi32_i32$0;
   alloc__vec__Vec_T_2cA___extend_desugared__hbbdfb7be7e7f78cb($2 + 24 | 0 | 0, $2 + 40 | 0 | 0);
   HEAP32[($0 + 8 | 0) >> 2] = HEAP32[$3 >> 2] | 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[($2 + 24 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 28 | 0) >> 2] | 0;
   $73 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[i64toi32_i32$0 >> 2] = $73;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  }
  global$0 = $2 + 64 | 0;
 }
 
 function core__ptr__drop_in_place_cbor_event__value__Value___h203893ddc6d2104a_1($0) {
  $0 = $0 | 0;
  var $2 = 0, $1 = 0;
  label$1 : {
   switch ((HEAP32[$0 >> 2] | 0) + -2 | 0 | 0) {
   case 0:
    $0 = $0 + 4 | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
    return;
   case 1:
    $0 = $0 + 4 | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
    return;
   case 2:
    $1 = $0 + 4 | 0;
    label$9 : {
     $2 = HEAP32[($0 + 12 | 0) >> 2] | 0;
     if (!$2) {
      break label$9
     }
     $0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
     $2 = Math_imul($2, 24);
     label$10 : while (1) {
      core__ptr__drop_in_place_cbor_event__value__Value___h203893ddc6d2104a_1($0 | 0);
      $0 = $0 + 24 | 0;
      $2 = $2 + -24 | 0;
      if ($2) {
       continue label$10
      }
      break label$10;
     };
    }
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h8809497f289c3544($1 | 0);
    return;
   case 3:
    $1 = $0 + 4 | 0;
    label$11 : {
     $2 = HEAP32[($0 + 12 | 0) >> 2] | 0;
     if (!$2) {
      break label$11
     }
     $0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
     $2 = Math_imul($2, 24);
     label$12 : while (1) {
      core__ptr__drop_in_place_cbor_event__value__Value___h203893ddc6d2104a_1($0 | 0);
      $0 = $0 + 24 | 0;
      $2 = $2 + -24 | 0;
      if ($2) {
       continue label$12
      }
      break label$12;
     };
    }
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h8809497f289c3544($1 | 0);
    return;
   case 4:
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__hbe15b6996cefd7cc($0 + 4 | 0 | 0);
   default:
    return;
   case 5:
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__hbe15b6996cefd7cc($0 + 4 | 0 | 0);
    return;
   case 6:
    break label$1;
   };
  }
  core__ptr__drop_in_place_cbor_event__value__Value___h203893ddc6d2104a_1(HEAP32[($0 + 4 | 0) >> 2] | 0 | 0);
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[($0 + 4 | 0) >> 2] | 0 | 0) | 0 | 0, 24 | 0, 8 | 0);
 }
 
 function txinputsbuilder_add_required_signers($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $12 = 0, $4 = 0, $5 = 0, $3 = 0, $47 = 0, $53 = 0, $56 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hf277c6a2d5f089a3($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h38787c785ea84973($2 | 0, $1 | 0);
   $5 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   label$2 : {
    $0 = HEAP32[$2 >> 2] | 0;
    $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
    if (!$1) {
     break label$2
    }
    $0 = HEAP32[$0 >> 2] | 0;
    $1 = Math_imul($1, 28);
    $4 = $4 + 40 | 0;
    label$3 : while (1) {
     $12 = $0 + 24 | 0;
     HEAP32[(($2 + 16 | 0) + 24 | 0) >> 2] = HEAPU8[$12 >> 0] | 0 | ((HEAPU8[($12 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($12 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($12 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$2 = $0 + 16 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $47 = i64toi32_i32$0;
     i64toi32_i32$0 = ($2 + 16 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $47;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $0 + 8 | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $53 = i64toi32_i32$1;
     i64toi32_i32$1 = ($2 + 16 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $53;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $56 = i64toi32_i32$0;
     i64toi32_i32$0 = $2;
     HEAP32[($2 + 16 | 0) >> 2] = $56;
     HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$1;
     alloc__collections__btree__map__BTreeMap_K_2cV___insert__h5d8c7a7452747b0f($4 | 0, $2 + 16 | 0 | 0) | 0;
     $0 = i64toi32_i32$2 + 28 | 0;
     $1 = $1 + -28 | 0;
     if ($1) {
      continue label$3
     }
     break label$3;
    };
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($5 | 0, (HEAP32[$5 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 48 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function core__ptr__drop_in_place_cbor_event__value__Value___h203893ddc6d2104a_2($0) {
  $0 = $0 | 0;
  var $2 = 0, $1 = 0;
  label$1 : {
   switch ((HEAP32[$0 >> 2] | 0) + -2 | 0 | 0) {
   case 0:
    $0 = $0 + 4 | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
    return;
   case 1:
    $0 = $0 + 4 | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
    return;
   case 2:
    $1 = $0 + 4 | 0;
    label$9 : {
     $2 = HEAP32[($0 + 12 | 0) >> 2] | 0;
     if (!$2) {
      break label$9
     }
     $0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
     $2 = Math_imul($2, 24);
     label$10 : while (1) {
      core__ptr__drop_in_place_cbor_event__value__Value___h203893ddc6d2104a_1($0 | 0);
      $0 = $0 + 24 | 0;
      $2 = $2 + -24 | 0;
      if ($2) {
       continue label$10
      }
      break label$10;
     };
    }
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h8809497f289c3544($1 | 0);
    return;
   case 3:
    $1 = $0 + 4 | 0;
    label$11 : {
     $2 = HEAP32[($0 + 12 | 0) >> 2] | 0;
     if (!$2) {
      break label$11
     }
     $0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
     $2 = Math_imul($2, 24);
     label$12 : while (1) {
      core__ptr__drop_in_place_cbor_event__value__Value___h203893ddc6d2104a_1($0 | 0);
      $0 = $0 + 24 | 0;
      $2 = $2 + -24 | 0;
      if ($2) {
       continue label$12
      }
      break label$12;
     };
    }
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h8809497f289c3544($1 | 0);
    return;
   case 4:
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__hbe15b6996cefd7cc($0 + 4 | 0 | 0);
   default:
    return;
   case 5:
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__hbe15b6996cefd7cc($0 + 4 | 0 | 0);
    return;
   case 6:
    break label$1;
   };
  }
  core__ptr__drop_in_place_cbor_event__value__Value___h203893ddc6d2104a_2(HEAP32[($0 + 4 | 0) >> 2] | 0 | 0);
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[($0 + 4 | 0) >> 2] | 0 | 0) | 0 | 0, 24 | 0, 8 | 0);
 }
 
 function cryptoxide__ed25519__keypair__h6b6b782bee48c38f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $2 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $3 = 0, $4 = 0, $5 = 0, $20 = 0, $27 = 0, $34 = 0, $40 = 0, $46 = 0, $52 = 0, $55 = 0, $58 = 0, $66 = 0, $70 = 0, $74 = 0, $77 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  cryptoxide__ed25519__extended_secret__hc92aa93a99de055a($2 | 0, $1 | 0);
  cryptoxide__ed25519__extended_to_public__hb7e9895dfbf0ff6d($2 + 64 | 0 | 0, $2 | 0);
  $3 = ($2 + 64 | 0) + 8 | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 136 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $20;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $4 = ($2 + 64 | 0) + 16 | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $27 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 144 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $27;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $5 = ($2 + 64 | 0) + 24 | 0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $34 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 152 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $34;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 24 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $40 = i64toi32_i32$1;
  i64toi32_i32$1 = ($2 + 96 | 0) + 24 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $40;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $46 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 96 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $46;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $52 = i64toi32_i32$1;
  i64toi32_i32$1 = ($2 + 96 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $52;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 64 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 65 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 66 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 67 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 68 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 69 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 70 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 71 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $55 = i64toi32_i32$0;
  i64toi32_i32$0 = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$2 + 128 | 0) >> 2] = $55;
  HEAP32[(i64toi32_i32$2 + 132 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $58 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[(i64toi32_i32$1 + 96 | 0) >> 2] = $58;
  HEAP32[(i64toi32_i32$1 + 100 | 0) >> 2] = i64toi32_i32$0;
  $1 = memcpy($0 | 0, i64toi32_i32$1 + 96 | 0 | 0, 64 | 0) | 0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $66 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 88 | 0;
  $21 = $66;
  HEAP8[i64toi32_i32$0 >> 0] = $21;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $21 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $21 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $21 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $70 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 80 | 0;
  $22 = $70;
  HEAP8[i64toi32_i32$1 >> 0] = $22;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $22 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $22 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $22 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $74 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 72 | 0;
  $23 = $74;
  HEAP8[i64toi32_i32$0 >> 0] = $23;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $23 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $23 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $23 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 64 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 65 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 66 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 67 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 68 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 69 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 70 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 71 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $77 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  $24 = $77;
  HEAP8[(i64toi32_i32$1 + 64 | 0) >> 0] = $24;
  HEAP8[(i64toi32_i32$1 + 65 | 0) >> 0] = $24 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 66 | 0) >> 0] = $24 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 67 | 0) >> 0] = $24 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 68 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 69 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 70 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 71 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  global$0 = i64toi32_i32$2 + 160 | 0;
 }
 
 function poolparams_pool_metadata($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $4 = 0, $2 = 0, $3 = 0, $27 = 0, $32 = 0, $37 = 0, $41 = 0;
  $1 = global$0 - 96 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hc466bac66f8af18e($1 | 0, $0 | 0);
   $2 = 0;
   $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   $4 = 0;
   label$2 : {
    $0 = HEAP32[$1 >> 2] | 0;
    if (!(HEAP32[($0 + 56 | 0) >> 2] | 0)) {
     break label$2
    }
    $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($1 + 48 | 0 | 0, $0 + 56 | 0 | 0);
    i64toi32_i32$2 = $0 + 92 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $27 = i64toi32_i32$0;
    i64toi32_i32$0 = $1 + 84 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $27;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $0 + 84 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $32 = i64toi32_i32$1;
    i64toi32_i32$1 = $1 + 76 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $32;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $0 + 76 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $37 = i64toi32_i32$0;
    i64toi32_i32$0 = $1 + 68 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $37;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $0 + 68 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $41 = i64toi32_i32$1;
    i64toi32_i32$1 = $1;
    HEAP32[($1 + 60 | 0) >> 2] = $41;
    HEAP32[($1 + 64 | 0) >> 2] = i64toi32_i32$0;
    $4 = HEAP32[($1 + 48 | 0) >> 2] | 0;
    memcpy($1 + 8 | 0 | 0, $1 + 48 | 0 | 4 | 0 | 0, 40 | 0) | 0;
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
   label$3 : {
    if (!$4) {
     break label$3
    }
    HEAP32[($1 + 48 | 0) >> 2] = $4;
    memcpy($1 + 48 | 0 | 4 | 0 | 0, $1 + 8 | 0 | 0, 40 | 0) | 0;
    $2 = $cardano_serialization_lib__PoolMetadata_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h92fec53606437ead($1 + 48 | 0 | 0) | 0;
   }
   global$0 = $1 + 96 | 0;
   return $2 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function $cardano_serialization_lib__chain_crypto__bech32__Error_20as_20core__fmt__Display___fmt__h243421bc8287f594($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $36 = 0, $41 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    switch (HEAP32[$0 >> 2] | 0 | 0) {
    default:
     HEAP32[($2 + 60 | 0) >> 2] = 0;
     HEAP32[($2 + 56 | 0) >> 2] = 1055856;
     i64toi32_i32$1 = $2;
     i64toi32_i32$0 = 0;
     HEAP32[($2 + 44 | 0) >> 2] = 1;
     HEAP32[($2 + 48 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($2 + 40 | 0) >> 2] = 1056784;
     $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 40 | 0 | 0) | 0;
     break label$1;
    case 1:
     HEAP32[($2 + 16 | 0) >> 2] = $0 + 4 | 0;
     HEAP32[($2 + 20 | 0) >> 2] = $0 + 12 | 0;
     core__fmt__ArgumentV1__new__h3d5a6d2b66a66ab8($2 + 8 | 0 | 0, $2 + 20 | 0 | 0, 16 | 0);
     i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
     core__fmt__ArgumentV1__new__h558c4eaf8ff4cba2($2 | 0, $2 + 16 | 0 | 0, 17 | 0);
     HEAP32[($2 + 60 | 0) >> 2] = 2;
     $36 = i64toi32_i32$0;
     i64toi32_i32$0 = $2;
     HEAP32[($2 + 24 | 0) >> 2] = $36;
     HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$0 = $2;
     i64toi32_i32$1 = 0;
     HEAP32[($2 + 44 | 0) >> 2] = 3;
     HEAP32[($2 + 48 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($2 + 40 | 0) >> 2] = 1056716;
     i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
     $41 = i64toi32_i32$1;
     i64toi32_i32$1 = $2;
     HEAP32[($2 + 32 | 0) >> 2] = $41;
     HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($2 + 56 | 0) >> 2] = $2 + 24 | 0;
     $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 40 | 0 | 0) | 0;
     break label$1;
    case 2:
     break label$2;
    };
   }
   HEAP32[($2 + 60 | 0) >> 2] = 0;
   HEAP32[($2 + 56 | 0) >> 2] = 1055856;
   i64toi32_i32$1 = $2;
   i64toi32_i32$0 = 0;
   HEAP32[($2 + 44 | 0) >> 2] = 1;
   HEAP32[($2 + 48 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($2 + 40 | 0) >> 2] = 1056656;
   $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 40 | 0 | 0) | 0;
  }
  global$0 = $2 + 64 | 0;
  return $0 | 0;
 }
 
 function $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__iter__traits__collect__Extend__28K_2cV_29____extend__hc8a1fe6915e72fc0($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $7 = 0;
  $2 = global$0 - 336 | 0;
  global$0 = $2;
  label$1 : {
   $3 = HEAP32[$1 >> 2] | 0;
   $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   if (($3 | 0) == ($4 | 0)) {
    break label$1
   }
   $5 = $2 + 96 | 0 | 4 | 0;
   $6 = ($2 + 4 | 0) + 44 | 0;
   $7 = $2 + 240 | 0 | 4 | 0;
   label$2 : while (1) {
    $1 = HEAP32[($3 + 100 | 0) >> 2] | 0;
    $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone___7b_7bclosure_7d_7d__hcd96b55161ebcbf0($2 + 240 | 0 | 0, $3 | 0, $3 + 48 | 0 | 0);
    $3 = HEAP32[($2 + 240 | 0) >> 2] | 0;
    memcpy($2 + 96 | 0 | 0, $7 | 0, 92 | 0) | 0;
    if (($3 | 0) == (5 | 0)) {
     break label$1
    }
    memcpy($2 + 4 | 0 | 0, $2 + 96 | 0 | 0, 92 | 0) | 0;
    HEAP32[($2 + 96 | 0) >> 2] = $3;
    memcpy($5 | 0, $2 + 4 | 0 | 0, 44 | 0) | 0;
    memcpy($2 + 240 | 0 | 0, $6 | 0, 48 | 0) | 0;
    linked_hash_map__LinkedHashMap_K_2cV_2cS___insert__heab3194aa02f42f0($2 + 192 | 0 | 0, $0 | 0, $2 + 96 | 0 | 0, $2 + 240 | 0 | 0);
    label$3 : {
     if ((HEAP32[($2 + 192 | 0) >> 2] | 0 | 0) == (5 | 0)) {
      break label$3
     }
     core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatumEnum___h27fd15c9b26a768e($2 + 192 | 0 | 0);
    }
    $3 = $1;
    if (($3 | 0) != ($4 | 0)) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $2 + 336 | 0;
 }
 
 function vkey_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $10 = 0, $11 = 0, $12 = 0, $30 = 0, $45 = 0, $50 = 0, $68 = 0;
  $2 = global$0 - 96 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 48 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 64 | 0) >> 2] = $30;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__crypto__Vkey__from_bytes__he51c649dc960455b($2 + 8 | 0 | 0, $2 + 64 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 8 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = $2 + 24 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $45 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 79 | 0;
  $10 = $45;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 32 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $50 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 87 | 0;
  $11 = $50;
  HEAP8[i64toi32_i32$0 >> 0] = $11;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  HEAP8[($2 + 95 | 0) >> 0] = HEAPU8[($2 + 40 | 0) >> 0] | 0;
  HEAP8[($2 + 66 | 0) >> 0] = HEAPU8[($2 + 11 | 0) >> 0] | 0;
  HEAP16[($2 + 64 | 0) >> 1] = HEAPU8[($2 + 9 | 0) >> 0] | 0 | ((HEAPU8[($2 + 10 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 67 | 0) >> 0] = $1;
  HEAP8[($2 + 68 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 69 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 70 | 0) >> 0] = $1 >>> 24 | 0;
  i64toi32_i32$2 = ($2 + 8 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $68 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  $12 = $68;
  HEAP8[($2 + 71 | 0) >> 0] = $12;
  HEAP8[($2 + 72 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[($2 + 73 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[($2 + 74 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[($2 + 75 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[($2 + 76 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[($2 + 77 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[($2 + 78 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $1 = $cardano_serialization_lib__crypto__Vkey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h0c56da261e90089c($2 + 64 | 0 | 0) | 0;
  global$0 = $2 + 96 | 0;
  return $1 | 0;
 }
 
 function transactionhash_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $10 = 0, $11 = 0, $12 = 0, $30 = 0, $45 = 0, $50 = 0, $68 = 0;
  $2 = global$0 - 96 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 48 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 64 | 0) >> 2] = $30;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__crypto__TransactionHash__from_bytes__h235906d66c062ba5($2 + 8 | 0 | 0, $2 + 64 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 8 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = $2 + 24 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $45 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 79 | 0;
  $10 = $45;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 32 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $50 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 87 | 0;
  $11 = $50;
  HEAP8[i64toi32_i32$0 >> 0] = $11;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  HEAP8[($2 + 95 | 0) >> 0] = HEAPU8[($2 + 40 | 0) >> 0] | 0;
  HEAP8[($2 + 66 | 0) >> 0] = HEAPU8[($2 + 11 | 0) >> 0] | 0;
  HEAP16[($2 + 64 | 0) >> 1] = HEAPU8[($2 + 9 | 0) >> 0] | 0 | ((HEAPU8[($2 + 10 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 67 | 0) >> 0] = $1;
  HEAP8[($2 + 68 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 69 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 70 | 0) >> 0] = $1 >>> 24 | 0;
  i64toi32_i32$2 = ($2 + 8 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $68 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  $12 = $68;
  HEAP8[($2 + 71 | 0) >> 0] = $12;
  HEAP8[($2 + 72 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[($2 + 73 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[($2 + 74 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[($2 + 75 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[($2 + 76 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[($2 + 77 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[($2 + 78 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $1 = $cardano_serialization_lib__crypto__TransactionHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__ha325bfafa26d5417($2 + 64 | 0 | 0) | 0;
  global$0 = $2 + 96 | 0;
  return $1 | 0;
 }
 
 function auxiliarydatahash_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $10 = 0, $11 = 0, $12 = 0, $30 = 0, $45 = 0, $50 = 0, $68 = 0;
  $2 = global$0 - 96 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 48 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 64 | 0) >> 2] = $30;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__crypto__AuxiliaryDataHash__from_bytes__h3474e0570cc047c7($2 + 8 | 0 | 0, $2 + 64 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 8 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = $2 + 24 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $45 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 79 | 0;
  $10 = $45;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 32 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $50 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 87 | 0;
  $11 = $50;
  HEAP8[i64toi32_i32$0 >> 0] = $11;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  HEAP8[($2 + 95 | 0) >> 0] = HEAPU8[($2 + 40 | 0) >> 0] | 0;
  HEAP8[($2 + 66 | 0) >> 0] = HEAPU8[($2 + 11 | 0) >> 0] | 0;
  HEAP16[($2 + 64 | 0) >> 1] = HEAPU8[($2 + 9 | 0) >> 0] | 0 | ((HEAPU8[($2 + 10 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 67 | 0) >> 0] = $1;
  HEAP8[($2 + 68 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 69 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 70 | 0) >> 0] = $1 >>> 24 | 0;
  i64toi32_i32$2 = ($2 + 8 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $68 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  $12 = $68;
  HEAP8[($2 + 71 | 0) >> 0] = $12;
  HEAP8[($2 + 72 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[($2 + 73 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[($2 + 74 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[($2 + 75 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[($2 + 76 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[($2 + 77 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[($2 + 78 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $1 = $cardano_serialization_lib__crypto__AuxiliaryDataHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__ha0bdb89a2c7c1e66($2 + 64 | 0 | 0) | 0;
  global$0 = $2 + 96 | 0;
  return $1 | 0;
 }
 
 function poolmetadatahash_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $10 = 0, $11 = 0, $12 = 0, $30 = 0, $45 = 0, $50 = 0, $68 = 0;
  $2 = global$0 - 96 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 48 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 64 | 0) >> 2] = $30;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__crypto__PoolMetadataHash__from_bytes__hcdbbfaf467fb270a($2 + 8 | 0 | 0, $2 + 64 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 8 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = $2 + 24 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $45 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 79 | 0;
  $10 = $45;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 32 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $50 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 87 | 0;
  $11 = $50;
  HEAP8[i64toi32_i32$0 >> 0] = $11;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  HEAP8[($2 + 95 | 0) >> 0] = HEAPU8[($2 + 40 | 0) >> 0] | 0;
  HEAP8[($2 + 66 | 0) >> 0] = HEAPU8[($2 + 11 | 0) >> 0] | 0;
  HEAP16[($2 + 64 | 0) >> 1] = HEAPU8[($2 + 9 | 0) >> 0] | 0 | ((HEAPU8[($2 + 10 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 67 | 0) >> 0] = $1;
  HEAP8[($2 + 68 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 69 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 70 | 0) >> 0] = $1 >>> 24 | 0;
  i64toi32_i32$2 = ($2 + 8 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $68 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  $12 = $68;
  HEAP8[($2 + 71 | 0) >> 0] = $12;
  HEAP8[($2 + 72 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[($2 + 73 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[($2 + 74 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[($2 + 75 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[($2 + 76 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[($2 + 77 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[($2 + 78 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $1 = $cardano_serialization_lib__crypto__PoolMetadataHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__heaaf3507fd71ee00($2 + 64 | 0 | 0) | 0;
  global$0 = $2 + 96 | 0;
  return $1 | 0;
 }
 
 function vrfkeyhash_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $10 = 0, $11 = 0, $12 = 0, $30 = 0, $45 = 0, $50 = 0, $68 = 0;
  $2 = global$0 - 96 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 48 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 64 | 0) >> 2] = $30;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__crypto__VRFKeyHash__from_bytes__h124511c7aa071f43($2 + 8 | 0 | 0, $2 + 64 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 8 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = $2 + 24 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $45 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 79 | 0;
  $10 = $45;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 32 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $50 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 87 | 0;
  $11 = $50;
  HEAP8[i64toi32_i32$0 >> 0] = $11;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  HEAP8[($2 + 95 | 0) >> 0] = HEAPU8[($2 + 40 | 0) >> 0] | 0;
  HEAP8[($2 + 66 | 0) >> 0] = HEAPU8[($2 + 11 | 0) >> 0] | 0;
  HEAP16[($2 + 64 | 0) >> 1] = HEAPU8[($2 + 9 | 0) >> 0] | 0 | ((HEAPU8[($2 + 10 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 67 | 0) >> 0] = $1;
  HEAP8[($2 + 68 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 69 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 70 | 0) >> 0] = $1 >>> 24 | 0;
  i64toi32_i32$2 = ($2 + 8 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $68 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  $12 = $68;
  HEAP8[($2 + 71 | 0) >> 0] = $12;
  HEAP8[($2 + 72 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[($2 + 73 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[($2 + 74 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[($2 + 75 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[($2 + 76 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[($2 + 77 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[($2 + 78 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $1 = $cardano_serialization_lib__crypto__VRFKeyHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf9aae481fe8479f($2 + 64 | 0 | 0) | 0;
  global$0 = $2 + 96 | 0;
  return $1 | 0;
 }
 
 function blockhash_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $10 = 0, $11 = 0, $12 = 0, $30 = 0, $45 = 0, $50 = 0, $68 = 0;
  $2 = global$0 - 96 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 48 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 64 | 0) >> 2] = $30;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__crypto__BlockHash__from_bytes__ha6cff5ff44ff1071($2 + 8 | 0 | 0, $2 + 64 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 8 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = $2 + 24 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $45 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 79 | 0;
  $10 = $45;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 32 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $50 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 87 | 0;
  $11 = $50;
  HEAP8[i64toi32_i32$0 >> 0] = $11;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  HEAP8[($2 + 95 | 0) >> 0] = HEAPU8[($2 + 40 | 0) >> 0] | 0;
  HEAP8[($2 + 66 | 0) >> 0] = HEAPU8[($2 + 11 | 0) >> 0] | 0;
  HEAP16[($2 + 64 | 0) >> 1] = HEAPU8[($2 + 9 | 0) >> 0] | 0 | ((HEAPU8[($2 + 10 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 67 | 0) >> 0] = $1;
  HEAP8[($2 + 68 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 69 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 70 | 0) >> 0] = $1 >>> 24 | 0;
  i64toi32_i32$2 = ($2 + 8 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $68 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  $12 = $68;
  HEAP8[($2 + 71 | 0) >> 0] = $12;
  HEAP8[($2 + 72 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[($2 + 73 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[($2 + 74 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[($2 + 75 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[($2 + 76 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[($2 + 77 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[($2 + 78 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $1 = $cardano_serialization_lib__crypto__BlockHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hf8ef4eaf9a4a30cf($2 + 64 | 0 | 0) | 0;
  global$0 = $2 + 96 | 0;
  return $1 | 0;
 }
 
 function datahash_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $10 = 0, $11 = 0, $12 = 0, $30 = 0, $45 = 0, $50 = 0, $68 = 0;
  $2 = global$0 - 96 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 48 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 64 | 0) >> 2] = $30;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__crypto__DataHash__from_bytes__h13af91f9785cf2d4($2 + 8 | 0 | 0, $2 + 64 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 8 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = $2 + 24 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $45 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 79 | 0;
  $10 = $45;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 32 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $50 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 87 | 0;
  $11 = $50;
  HEAP8[i64toi32_i32$0 >> 0] = $11;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  HEAP8[($2 + 95 | 0) >> 0] = HEAPU8[($2 + 40 | 0) >> 0] | 0;
  HEAP8[($2 + 66 | 0) >> 0] = HEAPU8[($2 + 11 | 0) >> 0] | 0;
  HEAP16[($2 + 64 | 0) >> 1] = HEAPU8[($2 + 9 | 0) >> 0] | 0 | ((HEAPU8[($2 + 10 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 67 | 0) >> 0] = $1;
  HEAP8[($2 + 68 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 69 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 70 | 0) >> 0] = $1 >>> 24 | 0;
  i64toi32_i32$2 = ($2 + 8 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $68 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  $12 = $68;
  HEAP8[($2 + 71 | 0) >> 0] = $12;
  HEAP8[($2 + 72 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[($2 + 73 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[($2 + 74 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[($2 + 75 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[($2 + 76 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[($2 + 77 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[($2 + 78 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $1 = $cardano_serialization_lib__crypto__DataHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hba2449530c6577ab($2 + 64 | 0 | 0) | 0;
  global$0 = $2 + 96 | 0;
  return $1 | 0;
 }
 
 function scriptdatahash_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $10 = 0, $11 = 0, $12 = 0, $30 = 0, $45 = 0, $50 = 0, $68 = 0;
  $2 = global$0 - 96 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 48 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 64 | 0) >> 2] = $30;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__crypto__ScriptDataHash__from_bytes__hfbd006c5cd3f689b($2 + 8 | 0 | 0, $2 + 64 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 8 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = $2 + 24 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $45 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 79 | 0;
  $10 = $45;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 32 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $50 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 87 | 0;
  $11 = $50;
  HEAP8[i64toi32_i32$0 >> 0] = $11;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  HEAP8[($2 + 95 | 0) >> 0] = HEAPU8[($2 + 40 | 0) >> 0] | 0;
  HEAP8[($2 + 66 | 0) >> 0] = HEAPU8[($2 + 11 | 0) >> 0] | 0;
  HEAP16[($2 + 64 | 0) >> 1] = HEAPU8[($2 + 9 | 0) >> 0] | 0 | ((HEAPU8[($2 + 10 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 67 | 0) >> 0] = $1;
  HEAP8[($2 + 68 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 69 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 70 | 0) >> 0] = $1 >>> 24 | 0;
  i64toi32_i32$2 = ($2 + 8 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $68 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  $12 = $68;
  HEAP8[($2 + 71 | 0) >> 0] = $12;
  HEAP8[($2 + 72 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[($2 + 73 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[($2 + 74 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[($2 + 75 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[($2 + 76 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[($2 + 77 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[($2 + 78 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $1 = $cardano_serialization_lib__crypto__ScriptDataHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h4525048b15d98533($2 + 64 | 0 | 0) | 0;
  global$0 = $2 + 96 | 0;
  return $1 | 0;
 }
 
 function vrfvkey_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $10 = 0, $11 = 0, $12 = 0, $30 = 0, $45 = 0, $50 = 0, $68 = 0;
  $2 = global$0 - 96 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 48 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 64 | 0) >> 2] = $30;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__crypto__VRFVKey__from_bytes__hf703fd2bd6e45870($2 + 8 | 0 | 0, $2 + 64 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 8 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = $2 + 24 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $45 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 79 | 0;
  $10 = $45;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 32 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $50 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 87 | 0;
  $11 = $50;
  HEAP8[i64toi32_i32$0 >> 0] = $11;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  HEAP8[($2 + 95 | 0) >> 0] = HEAPU8[($2 + 40 | 0) >> 0] | 0;
  HEAP8[($2 + 66 | 0) >> 0] = HEAPU8[($2 + 11 | 0) >> 0] | 0;
  HEAP16[($2 + 64 | 0) >> 1] = HEAPU8[($2 + 9 | 0) >> 0] | 0 | ((HEAPU8[($2 + 10 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 67 | 0) >> 0] = $1;
  HEAP8[($2 + 68 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 69 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 70 | 0) >> 0] = $1 >>> 24 | 0;
  i64toi32_i32$2 = ($2 + 8 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $68 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  $12 = $68;
  HEAP8[($2 + 71 | 0) >> 0] = $12;
  HEAP8[($2 + 72 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[($2 + 73 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[($2 + 74 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[($2 + 75 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[($2 + 76 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[($2 + 77 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[($2 + 78 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $1 = $cardano_serialization_lib__crypto__VRFVKey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h510224eaef243251($2 + 64 | 0 | 0) | 0;
  global$0 = $2 + 96 | 0;
  return $1 | 0;
 }
 
 function kesvkey_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $10 = 0, $11 = 0, $12 = 0, $30 = 0, $45 = 0, $50 = 0, $68 = 0;
  $2 = global$0 - 96 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 48 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 64 | 0) >> 2] = $30;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__crypto__KESVKey__from_bytes__hd3afa2883ce70fa1($2 + 8 | 0 | 0, $2 + 64 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 8 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = $2 + 24 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $45 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 79 | 0;
  $10 = $45;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 32 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $50 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 87 | 0;
  $11 = $50;
  HEAP8[i64toi32_i32$0 >> 0] = $11;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  HEAP8[($2 + 95 | 0) >> 0] = HEAPU8[($2 + 40 | 0) >> 0] | 0;
  HEAP8[($2 + 66 | 0) >> 0] = HEAPU8[($2 + 11 | 0) >> 0] | 0;
  HEAP16[($2 + 64 | 0) >> 1] = HEAPU8[($2 + 9 | 0) >> 0] | 0 | ((HEAPU8[($2 + 10 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 67 | 0) >> 0] = $1;
  HEAP8[($2 + 68 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 69 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 70 | 0) >> 0] = $1 >>> 24 | 0;
  i64toi32_i32$2 = ($2 + 8 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $68 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  $12 = $68;
  HEAP8[($2 + 71 | 0) >> 0] = $12;
  HEAP8[($2 + 72 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[($2 + 73 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[($2 + 74 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[($2 + 75 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[($2 + 76 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[($2 + 77 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[($2 + 78 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $1 = $cardano_serialization_lib__crypto__KESVKey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h5c8fb7ce130dd69e($2 + 64 | 0 | 0) | 0;
  global$0 = $2 + 96 | 0;
  return $1 | 0;
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h26733a351c1d0f0b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, $6 = 0, $4 = 0, $5 = 0, $7 = 0, $40 = 0, $46 = 0, $52 = 0, $55 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  $3 = HEAP32[$1 >> 2] | 0;
  $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h436fe8d758b2781e($2 + 8 | 0 | 0, $4 | 0, 0 | 0);
  $5 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  $6 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $6;
  HEAP32[$0 >> 2] = $5;
  label$1 : {
   if (!$6) {
    break label$1
   }
   $1 = Math_imul($4, 96);
   $7 = ($2 + 16 | 0) + 32 | 0;
   label$2 : while (1) {
    if (!$1) {
     break label$1
    }
    i64toi32_i32$2 = $3 + 24 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $40 = i64toi32_i32$0;
    i64toi32_i32$0 = ($2 + 16 | 0) + 24 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $40;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $3 + 16 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $46 = i64toi32_i32$1;
    i64toi32_i32$1 = ($2 + 16 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $46;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $3 + 8 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $52 = i64toi32_i32$0;
    i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $52;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $55 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 16 | 0) >> 2] = $55;
    HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
    memcpy($7 | 0, i64toi32_i32$2 + 32 | 0 | 0, 64 | 0) | 0;
    $5 = (memcpy($5 | 0, $2 + 16 | 0 | 0, 96 | 0) | 0) + 96 | 0;
    $1 = $1 + -96 | 0;
    $3 = i64toi32_i32$2 + 96 | 0;
    $6 = $6 + -1 | 0;
    if ($6) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 8 | 0) >> 2] = $4;
  global$0 = $2 + 112 | 0;
 }
 
 function alloc__slice__insert_head__hb4e62620269819c6($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, $4 = 0, i64toi32_i32$3 = 0, $5 = 0, $6 = 0, $7$hi = 0, $7 = 0, $32 = 0, $32$hi = 0, $61$hi = 0;
  label$1 : {
   if ($1 >>> 0 < 2 >>> 0) {
    break label$1
   }
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       $3 = HEAP32[(HEAP32[((HEAP32[$2 >> 2] | 0) + 4 | 0) >> 2] | 0) >> 2] | 0;
       $4 = HEAP32[($3 + 8 | 0) >> 2] | 0;
       $2 = HEAP32[($0 + 4 | 0) >> 2] | 0;
       if ($4 >>> 0 <= $2 >>> 0) {
        break label$5
       }
       $5 = HEAP32[$0 >> 2] | 0;
       if ($4 >>> 0 <= $5 >>> 0) {
        break label$4
       }
       $6 = HEAP32[$3 >> 2] | 0;
       i64toi32_i32$2 = $6 + Math_imul($2, 168) | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
       $32 = i64toi32_i32$0;
       $32$hi = i64toi32_i32$1;
       i64toi32_i32$2 = $6 + Math_imul($5, 168) | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
       $7 = i64toi32_i32$1;
       $7$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $32$hi;
       i64toi32_i32$2 = $32;
       i64toi32_i32$1 = $7$hi;
       i64toi32_i32$3 = $7;
       if (i64toi32_i32$0 >>> 0 > i64toi32_i32$1 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$2 >>> 0 >= i64toi32_i32$3 >>> 0 | 0) | 0) {
        break label$1
       }
       HEAP32[$0 >> 2] = $2;
       label$6 : {
        if ($1 >>> 0 >= 3 >>> 0) {
         break label$6
        }
        $0 = $0 + 4 | 0;
        break label$2;
       }
       $2 = $1 + -2 | 0;
       $0 = $0 + 4 | 0;
       label$7 : while (1) {
        $3 = $0 + 4 | 0;
        $1 = HEAP32[$3 >> 2] | 0;
        if ($4 >>> 0 <= $1 >>> 0) {
         break label$3
        }
        i64toi32_i32$3 = $6 + Math_imul($1, 168) | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 64 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 68 | 0) >> 2] | 0;
        $61$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $7$hi;
        i64toi32_i32$0 = $61$hi;
        i64toi32_i32$3 = i64toi32_i32$2;
        i64toi32_i32$2 = $7$hi;
        i64toi32_i32$1 = $7;
        if (i64toi32_i32$0 >>> 0 > i64toi32_i32$2 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$3 >>> 0 >= i64toi32_i32$1 >>> 0 | 0) | 0) {
         break label$2
        }
        HEAP32[$0 >> 2] = $1;
        $0 = $3;
        $2 = $2 + -1 | 0;
        if ($2) {
         continue label$7
        }
        break label$7;
       };
       $0 = $3;
       break label$2;
      }
      core__panicking__panic_bounds_check__h808b524af17640b1($2 | 0, $4 | 0, 1069460 | 0);
      abort();
     }
     core__panicking__panic_bounds_check__h808b524af17640b1($5 | 0, $4 | 0, 1069460 | 0);
     abort();
    }
    core__panicking__panic_bounds_check__h808b524af17640b1($1 | 0, $4 | 0, 1069460 | 0);
    abort();
   }
   HEAP32[$0 >> 2] = $5;
  }
 }
 
 function alloc__slice__insert_head__hce84fe93513e7ded($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, $4 = 0, i64toi32_i32$3 = 0, $5 = 0, $6 = 0, $7$hi = 0, $7 = 0, $32 = 0, $32$hi = 0, $61$hi = 0;
  label$1 : {
   if ($1 >>> 0 < 2 >>> 0) {
    break label$1
   }
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       $3 = HEAP32[(HEAP32[((HEAP32[$2 >> 2] | 0) + 4 | 0) >> 2] | 0) >> 2] | 0;
       $4 = HEAP32[($3 + 8 | 0) >> 2] | 0;
       $2 = HEAP32[($0 + 4 | 0) >> 2] | 0;
       if ($4 >>> 0 <= $2 >>> 0) {
        break label$5
       }
       $5 = HEAP32[$0 >> 2] | 0;
       if ($4 >>> 0 <= $5 >>> 0) {
        break label$4
       }
       $6 = HEAP32[$3 >> 2] | 0;
       i64toi32_i32$2 = $6 + Math_imul($2, 168) | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
       $32 = i64toi32_i32$0;
       $32$hi = i64toi32_i32$1;
       i64toi32_i32$2 = $6 + Math_imul($5, 168) | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
       $7 = i64toi32_i32$1;
       $7$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $32$hi;
       i64toi32_i32$2 = $32;
       i64toi32_i32$1 = $7$hi;
       i64toi32_i32$3 = $7;
       if (i64toi32_i32$0 >>> 0 > i64toi32_i32$1 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$2 >>> 0 >= i64toi32_i32$3 >>> 0 | 0) | 0) {
        break label$1
       }
       HEAP32[$0 >> 2] = $2;
       label$6 : {
        if ($1 >>> 0 >= 3 >>> 0) {
         break label$6
        }
        $0 = $0 + 4 | 0;
        break label$2;
       }
       $2 = $1 + -2 | 0;
       $0 = $0 + 4 | 0;
       label$7 : while (1) {
        $3 = $0 + 4 | 0;
        $1 = HEAP32[$3 >> 2] | 0;
        if ($4 >>> 0 <= $1 >>> 0) {
         break label$3
        }
        i64toi32_i32$3 = $6 + Math_imul($1, 168) | 0;
        i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 64 | 0) >> 2] | 0;
        i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 68 | 0) >> 2] | 0;
        $61$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $7$hi;
        i64toi32_i32$0 = $61$hi;
        i64toi32_i32$3 = i64toi32_i32$2;
        i64toi32_i32$2 = $7$hi;
        i64toi32_i32$1 = $7;
        if (i64toi32_i32$0 >>> 0 > i64toi32_i32$2 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$3 >>> 0 >= i64toi32_i32$1 >>> 0 | 0) | 0) {
         break label$2
        }
        HEAP32[$0 >> 2] = $1;
        $0 = $3;
        $2 = $2 + -1 | 0;
        if ($2) {
         continue label$7
        }
        break label$7;
       };
       $0 = $3;
       break label$2;
      }
      core__panicking__panic_bounds_check__h808b524af17640b1($2 | 0, $4 | 0, 1069460 | 0);
      abort();
     }
     core__panicking__panic_bounds_check__h808b524af17640b1($5 | 0, $4 | 0, 1069460 | 0);
     abort();
    }
    core__panicking__panic_bounds_check__h808b524af17640b1($1 | 0, $4 | 0, 1069460 | 0);
    abort();
   }
   HEAP32[$0 >> 2] = $5;
  }
 }
 
 function core__num___impl_20core__str__traits__FromStr_20for_20u64___from_str__h83c4b5731bcff83f($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $3 = 0, $5 = 0, $5$hi = 0, $6$hi = 0, $4 = 0, i64toi32_i32$4 = 0, $6 = 0, $44$hi = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    if ($2) {
     break label$2
    }
    HEAP8[($0 + 1 | 0) >> 0] = 0;
    $2 = 1;
    break label$1;
   }
   label$3 : {
    label$4 : {
     label$5 : {
      switch ((HEAPU8[$1 >> 0] | 0) + -43 | 0 | 0) {
      case 2:
       if (($2 | 0) != (1 | 0)) {
        break label$4
       }
       break label$3;
      case 0:
       break label$5;
      default:
       break label$4;
      };
     }
     $2 = $2 + -1 | 0;
     if (!$2) {
      break label$3
     }
     $1 = $1 + 1 | 0;
    }
    i64toi32_i32$0 = 0;
    $5 = 0;
    $5$hi = i64toi32_i32$0;
    label$7 : {
     label$8 : while (1) {
      if (!$2) {
       break label$7
      }
      $4 = (HEAPU8[$1 >> 0] | 0) + -48 | 0;
      if ($4 >>> 0 >= 10 >>> 0) {
       break label$3
      }
      i64toi32_i32$0 = $5$hi;
      i64toi32_i32$1 = 0;
      i64toi32_i32$2 = 0;
      i64toi32_i32$3 = 0;
      __multi3($3 | 0, $5 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$1 | 0, 10 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$3 | 0);
      label$9 : {
       i64toi32_i32$1 = $3;
       i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] | 0;
       i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] | 0;
       if (!(i64toi32_i32$3 | i64toi32_i32$2 | 0)) {
        break label$9
       }
       HEAP8[($0 + 1 | 0) >> 0] = 2;
       $2 = 1;
       break label$1;
      }
      $1 = $1 + 1 | 0;
      $2 = $2 + -1 | 0;
      i64toi32_i32$1 = $3;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
      i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
      $6 = i64toi32_i32$2;
      $6$hi = i64toi32_i32$3;
      i64toi32_i32$3 = 0;
      $44$hi = i64toi32_i32$3;
      i64toi32_i32$3 = $6$hi;
      i64toi32_i32$1 = i64toi32_i32$2;
      i64toi32_i32$2 = $44$hi;
      i64toi32_i32$0 = $4;
      i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
      i64toi32_i32$5 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
      if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
       i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
      }
      $5 = i64toi32_i32$4;
      $5$hi = i64toi32_i32$5;
      i64toi32_i32$5 = $6$hi;
      i64toi32_i32$5 = $5$hi;
      i64toi32_i32$3 = $5;
      i64toi32_i32$1 = $6$hi;
      i64toi32_i32$0 = $6;
      if (i64toi32_i32$5 >>> 0 > i64toi32_i32$1 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$3 >>> 0 >= i64toi32_i32$0 >>> 0 | 0) | 0) {
       continue label$8
      }
      break label$8;
     };
     HEAP8[($0 + 1 | 0) >> 0] = 2;
     $2 = 1;
     break label$1;
    }
    i64toi32_i32$3 = $5$hi;
    i64toi32_i32$5 = $0 + 8 | 0;
    HEAP32[i64toi32_i32$5 >> 2] = $5;
    HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$3;
    $2 = 0;
    break label$1;
   }
   $2 = 1;
   HEAP8[($0 + 1 | 0) >> 0] = 1;
  }
  HEAP8[$0 >> 0] = $2;
  global$0 = $3 + 16 | 0;
 }
 
 function nativescript_new_script_n_of_k($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $3 = 0, $13 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $20 = 0, $28 = 0, $41 = 0, $49 = 0, $52 = 0, $61 = 0, $69 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__he533e1773e537fcd($1 | 0, $0 | 0);
  $0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $2 = HEAP32[$1 >> 2] | 0;
  $3 = HEAP32[$2 >> 2] | 0;
  alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($1 + 32 | 0 | 4 | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  i64toi32_i32$2 = ($1 + 32 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $28 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 59 | 0;
  $13 = $28;
  HEAP8[i64toi32_i32$0 >> 0] = $13;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $2 = ($1 + 8 | 0) + 15 | 0;
  $14 = ($1 + 48 | 0) + 15 | 0;
  $15 = HEAPU8[$14 >> 0] | 0 | ((HEAPU8[($14 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($14 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($14 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  HEAP8[$2 >> 0] = $15;
  HEAP8[($2 + 1 | 0) >> 0] = $15 >>> 8 | 0;
  HEAP8[($2 + 2 | 0) >> 0] = $15 >>> 16 | 0;
  HEAP8[($2 + 3 | 0) >> 0] = $15 >>> 24 | 0;
  HEAP32[($1 + 32 | 0) >> 2] = $3;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[($1 + 32 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 36 | 0) >> 2] | 0;
  $41 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  $16 = $41;
  HEAP8[($1 + 51 | 0) >> 0] = $16;
  HEAP8[($1 + 52 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[($1 + 53 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[($1 + 54 | 0) >> 0] = $16 >>> 24 | 0;
  HEAP8[($1 + 55 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[($1 + 56 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[($1 + 57 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[($1 + 58 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $3 = ($1 + 8 | 0) + 8 | 0;
  i64toi32_i32$2 = ($1 + 48 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $49 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $49;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAPU8[($1 + 48 | 0) >> 0] | 0 | ((HEAPU8[($1 + 49 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 50 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 51 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[($1 + 52 | 0) >> 0] | 0 | ((HEAPU8[($1 + 53 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 54 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 55 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $52 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[($1 + 8 | 0) >> 2] = $52;
  HEAP32[($1 + 12 | 0) >> 2] = i64toi32_i32$0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $61 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 57 | 0;
  $17 = $61;
  HEAP8[i64toi32_i32$0 >> 0] = $17;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $17 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $17 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $17 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $18 = $1 + 64 | 0;
  $19 = HEAPU8[$2 >> 0] | 0 | ((HEAPU8[($2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  HEAP8[$18 >> 0] = $19;
  HEAP8[($18 + 1 | 0) >> 0] = $19 >>> 8 | 0;
  HEAP8[($18 + 2 | 0) >> 0] = $19 >>> 16 | 0;
  HEAP8[($18 + 3 | 0) >> 0] = $19 >>> 24 | 0;
  HEAP8[($1 + 48 | 0) >> 0] = 3;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $69 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  $20 = $69;
  HEAP8[($1 + 49 | 0) >> 0] = $20;
  HEAP8[($1 + 50 | 0) >> 0] = $20 >>> 8 | 0;
  HEAP8[($1 + 51 | 0) >> 0] = $20 >>> 16 | 0;
  HEAP8[($1 + 52 | 0) >> 0] = $20 >>> 24 | 0;
  HEAP8[($1 + 53 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[($1 + 54 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[($1 + 55 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[($1 + 56 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $0 = $cardano_serialization_lib__NativeScript_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h345d8ecbe77ecc63($1 + 48 | 0 | 0) | 0;
  global$0 = $1 + 80 | 0;
  return $0 | 0;
 }
 
 function cardano_serialization_lib___impl_20core__convert__From__cardano_serialization_lib__Ed25519KeyHashes__20for_20alloc__collections__btree__set__BTreeSet_cardano_serialization_lib__crypto__Ed25519KeyHash____from__h2943ba4850cd87e8($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $2 = 0, $3 = 0, $4 = 0, $14 = 0, $5 = 0, $6 = 0, $29 = 0, $43 = 0, $49 = 0, $52 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  i64toi32_i32$1 = $0;
  i64toi32_i32$0 = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
  label$1 : {
   $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   if (!$3) {
    break label$1
   }
   $1 = HEAP32[$1 >> 2] | 0;
   $3 = Math_imul($3, 28);
   label$2 : while (1) {
    $4 = ($2 + 16 | 0) + 8 | 0;
    $5 = $0 + 8 | 0;
    HEAP32[$4 >> 2] = HEAP32[$5 >> 2] | 0;
    i64toi32_i32$2 = $0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $29 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $29;
    HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = $1;
    $14 = $1 + 24 | 0;
    HEAP32[((i64toi32_i32$0 + 32 | 0) + 24 | 0) >> 2] = HEAPU8[$14 >> 0] | 0 | ((HEAPU8[($14 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($14 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($14 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$2 = $1 + 16 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $43 = i64toi32_i32$1;
    i64toi32_i32$1 = ($2 + 32 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $43;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $1 + 8 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $49 = i64toi32_i32$0;
    i64toi32_i32$0 = ($2 + 32 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $49;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $52 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[(i64toi32_i32$1 + 32 | 0) >> 2] = $52;
    HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] = i64toi32_i32$0;
    alloc__collections__btree__map__BTreeMap_K_2cV___insert__h5d8c7a7452747b0f(i64toi32_i32$1 + 16 | 0 | 0, i64toi32_i32$1 + 32 | 0 | 0) | 0;
    $4 = HEAP32[$4 >> 2] | 0;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $4;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
    $6 = i64toi32_i32$0;
    i64toi32_i32$0 = i64toi32_i32$2;
    HEAP32[i64toi32_i32$2 >> 2] = $6;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[$5 >> 2] = $4;
    i64toi32_i32$0 = $0;
    HEAP32[i64toi32_i32$0 >> 2] = $6;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    $1 = $1 + 28 | 0;
    $3 = $3 + -28 | 0;
    if ($3) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $2 + 64 | 0;
 }
 
 function cardano_serialization_lib__address__ByronAddress__network_id__h46302a3365c1ef18($0) {
  $0 = $0 | 0;
  var i64toi32_i32$0 = 0, $1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $2$hi = 0, $3$hi = 0, $2 = 0, $3 = 0, $4$hi = 0, $4 = 0, $15 = 0, $31 = 0, $58$hi = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0, wasm2js_i32$2 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  $0 = (wasm2js_i32$0 = HEAP32[($0 + 16 | 0) >> 2] | 0, wasm2js_i32$1 = 764824073, wasm2js_i32$2 = (HEAP32[($0 + 12 | 0) >> 2] | 0 | 0) == (1 | 0), wasm2js_i32$2 ? wasm2js_i32$0 : wasm2js_i32$1);
  HEAP32[($1 + 28 | 0) >> 2] = $0;
  label$1 : {
   label$2 : {
    label$3 : {
     if (($0 | 0) == (1097911063 | 0)) {
      break label$3
     }
     label$4 : {
      if (($0 | 0) != (764824073 | 0)) {
       break label$4
      }
      i64toi32_i32$0 = 0;
      $2 = 256;
      $2$hi = i64toi32_i32$0;
      i64toi32_i32$0 = 0;
      $3 = 0;
      $3$hi = i64toi32_i32$0;
      break label$2;
     }
     core__fmt__ArgumentV1__new__hfe8bfc123be7fc32($1 + 16 | 0 | 0, $1 + 28 | 0 | 0, 46 | 0);
     HEAP32[($1 + 68 | 0) >> 2] = 1;
     i64toi32_i32$0 = 0;
     $4 = 1;
     $4$hi = i64toi32_i32$0;
     i64toi32_i32$1 = $1;
     i64toi32_i32$0 = 0;
     HEAP32[($1 + 52 | 0) >> 2] = 1;
     HEAP32[($1 + 56 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($1 + 48 | 0) >> 2] = 1070396;
     i64toi32_i32$2 = $1;
     i64toi32_i32$0 = HEAP32[($1 + 16 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
     $31 = i64toi32_i32$0;
     i64toi32_i32$0 = $1;
     HEAP32[($1 + 72 | 0) >> 2] = $31;
     HEAP32[($1 + 76 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($1 + 64 | 0) >> 2] = $1 + 72 | 0;
     alloc__fmt__format__h6e9e003a52c07309($1 + 32 | 0 | 0, $1 + 48 | 0 | 0);
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($1 + 8 | 0 | 0, $1 + 32 | 0 | 0);
     i64toi32_i32$1 = 0;
     i64toi32_i32$2 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($1 + 8 | 0) >> 2] | 0 | 0, HEAP32[($1 + 12 | 0) >> 2] | 0 | 0) | 0;
     i64toi32_i32$0 = 0;
     i64toi32_i32$3 = 32;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
      $15 = 0;
     } else {
      i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
      $15 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
     }
     $3 = $15;
     $3$hi = i64toi32_i32$0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 + 32 | 0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 + 32 | 0 | 0);
     i64toi32_i32$0 = 0;
     $2 = 0;
     $2$hi = i64toi32_i32$0;
     break label$1;
    }
    i64toi32_i32$0 = 0;
    $3 = 0;
    $3$hi = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    $2 = 0;
    $2$hi = i64toi32_i32$0;
   }
   i64toi32_i32$0 = 0;
   $4 = 0;
   $4$hi = i64toi32_i32$0;
  }
  global$0 = $1 + 80 | 0;
  i64toi32_i32$0 = $2$hi;
  i64toi32_i32$0 = $3$hi;
  i64toi32_i32$0 = $2$hi;
  i64toi32_i32$1 = $2;
  i64toi32_i32$2 = $3$hi;
  i64toi32_i32$3 = $3;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  $58$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$2 = $58$hi;
  i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $4$hi;
  i64toi32_i32$3 = $4;
  i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
  i64toi32_i32$0 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$1;
  return i64toi32_i32$0 | 0;
 }
 
 function alloc__collections__btree__navigate__full_range__h02c0db9addfb9664($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $6 = 0, $7 = 0, $8 = 0, $65 = 0;
  $5 = global$0 - 48 | 0;
  global$0 = $5;
  $6 = !$1;
  $7 = HEAPU16[($4 + 226 | 0) >> 1] | 0;
  label$1 : {
   label$2 : {
    if (!$3) {
     break label$2
    }
    $8 = $1 + -1 | 0;
    $1 = $1 - $3 | 0;
    label$3 : while (1) {
     if ($6 & 1 | 0) {
      break label$1
     }
     $4 = HEAP32[(($4 + ($7 << 2 | 0) | 0) + 232 | 0) >> 2] | 0;
     $7 = HEAPU16[($4 + 226 | 0) >> 1] | 0;
     $6 = !$8;
     $2 = HEAP32[($2 + 232 | 0) >> 2] | 0;
     $8 = $8 + -1 | 0;
     $3 = $3 + -1 | 0;
     if ($3) {
      continue label$3
     }
     break label$3;
    };
   }
   if (!$6) {
    break label$1
   }
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = 0;
   HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $2;
   HEAP32[i64toi32_i32$1 >> 2] = $1;
   HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = $7;
   HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $4;
   global$0 = $5 + 48 | 0;
   return;
  }
  core__fmt__ArgumentV1__new__hbd2b9e6635c55d43($5 + 8 | 0 | 0, 1072364 | 0, 1 | 0);
  HEAP32[($5 + 36 | 0) >> 2] = 1;
  i64toi32_i32$1 = $5;
  i64toi32_i32$0 = 0;
  HEAP32[($5 + 20 | 0) >> 2] = 1;
  HEAP32[($5 + 24 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($5 + 16 | 0) >> 2] = 1072324;
  i64toi32_i32$0 = HEAP32[($5 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($5 + 12 | 0) >> 2] | 0;
  $65 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[($5 + 40 | 0) >> 2] = $65;
  HEAP32[($5 + 44 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($5 + 32 | 0) >> 2] = $5 + 40 | 0;
  core__panicking__panic_fmt__hbf21a3d4bbb82bf8($5 + 16 | 0 | 0, 1072468 | 0);
  abort();
 }
 
 function alloc__collections__btree__navigate__full_range__h1f8644a2089cd237($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $6 = 0, $7 = 0, $8 = 0, $65 = 0;
  $5 = global$0 - 48 | 0;
  global$0 = $5;
  $6 = !$1;
  $7 = HEAPU16[($4 + 138 | 0) >> 1] | 0;
  label$1 : {
   label$2 : {
    if (!$3) {
     break label$2
    }
    $8 = $1 + -1 | 0;
    $1 = $1 - $3 | 0;
    label$3 : while (1) {
     if ($6 & 1 | 0) {
      break label$1
     }
     $4 = HEAP32[(($4 + ($7 << 2 | 0) | 0) + 140 | 0) >> 2] | 0;
     $7 = HEAPU16[($4 + 138 | 0) >> 1] | 0;
     $6 = !$8;
     $2 = HEAP32[($2 + 140 | 0) >> 2] | 0;
     $8 = $8 + -1 | 0;
     $3 = $3 + -1 | 0;
     if ($3) {
      continue label$3
     }
     break label$3;
    };
   }
   if (!$6) {
    break label$1
   }
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = 0;
   HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $2;
   HEAP32[i64toi32_i32$1 >> 2] = $1;
   HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = $7;
   HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $4;
   global$0 = $5 + 48 | 0;
   return;
  }
  core__fmt__ArgumentV1__new__hbd2b9e6635c55d43($5 + 8 | 0 | 0, 1072364 | 0, 1 | 0);
  HEAP32[($5 + 36 | 0) >> 2] = 1;
  i64toi32_i32$1 = $5;
  i64toi32_i32$0 = 0;
  HEAP32[($5 + 20 | 0) >> 2] = 1;
  HEAP32[($5 + 24 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($5 + 16 | 0) >> 2] = 1072324;
  i64toi32_i32$0 = HEAP32[($5 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($5 + 12 | 0) >> 2] | 0;
  $65 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[($5 + 40 | 0) >> 2] = $65;
  HEAP32[($5 + 44 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($5 + 32 | 0) >> 2] = $5 + 40 | 0;
  core__panicking__panic_fmt__hbf21a3d4bbb82bf8($5 + 16 | 0 | 0, 1072468 | 0);
  abort();
 }
 
 function alloc__collections__btree__navigate__full_range__h390d32f14d48bfae($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $6 = 0, $7 = 0, $8 = 0, $65 = 0;
  $5 = global$0 - 48 | 0;
  global$0 = $5;
  $6 = !$1;
  $7 = HEAPU16[($4 + 1458 | 0) >> 1] | 0;
  label$1 : {
   label$2 : {
    if (!$3) {
     break label$2
    }
    $8 = $1 + -1 | 0;
    $1 = $1 - $3 | 0;
    label$3 : while (1) {
     if ($6 & 1 | 0) {
      break label$1
     }
     $4 = HEAP32[(($4 + ($7 << 2 | 0) | 0) + 1464 | 0) >> 2] | 0;
     $7 = HEAPU16[($4 + 1458 | 0) >> 1] | 0;
     $6 = !$8;
     $2 = HEAP32[($2 + 1464 | 0) >> 2] | 0;
     $8 = $8 + -1 | 0;
     $3 = $3 + -1 | 0;
     if ($3) {
      continue label$3
     }
     break label$3;
    };
   }
   if (!$6) {
    break label$1
   }
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = 0;
   HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $2;
   HEAP32[i64toi32_i32$1 >> 2] = $1;
   HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = $7;
   HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $4;
   global$0 = $5 + 48 | 0;
   return;
  }
  core__fmt__ArgumentV1__new__hbd2b9e6635c55d43($5 + 8 | 0 | 0, 1072364 | 0, 1 | 0);
  HEAP32[($5 + 36 | 0) >> 2] = 1;
  i64toi32_i32$1 = $5;
  i64toi32_i32$0 = 0;
  HEAP32[($5 + 20 | 0) >> 2] = 1;
  HEAP32[($5 + 24 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($5 + 16 | 0) >> 2] = 1072324;
  i64toi32_i32$0 = HEAP32[($5 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($5 + 12 | 0) >> 2] | 0;
  $65 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[($5 + 40 | 0) >> 2] = $65;
  HEAP32[($5 + 44 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($5 + 32 | 0) >> 2] = $5 + 40 | 0;
  core__panicking__panic_fmt__hbf21a3d4bbb82bf8($5 + 16 | 0 | 0, 1072468 | 0);
  abort();
 }
 
 function alloc__collections__btree__navigate__full_range__h55a07d6b3102a73e($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $6 = 0, $7 = 0, $8 = 0, $65 = 0;
  $5 = global$0 - 48 | 0;
  global$0 = $5;
  $6 = !$1;
  $7 = HEAPU16[($4 + 6 | 0) >> 1] | 0;
  label$1 : {
   label$2 : {
    if (!$3) {
     break label$2
    }
    $8 = $1 + -1 | 0;
    $1 = $1 - $3 | 0;
    label$3 : while (1) {
     if ($6 & 1 | 0) {
      break label$1
     }
     $4 = HEAP32[(($4 + ($7 << 2 | 0) | 0) + 316 | 0) >> 2] | 0;
     $7 = HEAPU16[($4 + 6 | 0) >> 1] | 0;
     $6 = !$8;
     $2 = HEAP32[($2 + 316 | 0) >> 2] | 0;
     $8 = $8 + -1 | 0;
     $3 = $3 + -1 | 0;
     if ($3) {
      continue label$3
     }
     break label$3;
    };
   }
   if (!$6) {
    break label$1
   }
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = 0;
   HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $2;
   HEAP32[i64toi32_i32$1 >> 2] = $1;
   HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = $7;
   HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $4;
   global$0 = $5 + 48 | 0;
   return;
  }
  core__fmt__ArgumentV1__new__hbd2b9e6635c55d43($5 + 8 | 0 | 0, 1072364 | 0, 1 | 0);
  HEAP32[($5 + 36 | 0) >> 2] = 1;
  i64toi32_i32$1 = $5;
  i64toi32_i32$0 = 0;
  HEAP32[($5 + 20 | 0) >> 2] = 1;
  HEAP32[($5 + 24 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($5 + 16 | 0) >> 2] = 1072324;
  i64toi32_i32$0 = HEAP32[($5 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($5 + 12 | 0) >> 2] | 0;
  $65 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[($5 + 40 | 0) >> 2] = $65;
  HEAP32[($5 + 44 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($5 + 32 | 0) >> 2] = $5 + 40 | 0;
  core__panicking__panic_fmt__hbf21a3d4bbb82bf8($5 + 16 | 0 | 0, 1072468 | 0);
  abort();
 }
 
 function alloc__collections__btree__navigate__full_range__h5b801627b554f176($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $6 = 0, $7 = 0, $8 = 0, $65 = 0;
  $5 = global$0 - 48 | 0;
  global$0 = $5;
  $6 = !$1;
  $7 = HEAPU16[($4 + 1062 | 0) >> 1] | 0;
  label$1 : {
   label$2 : {
    if (!$3) {
     break label$2
    }
    $8 = $1 + -1 | 0;
    $1 = $1 - $3 | 0;
    label$3 : while (1) {
     if ($6 & 1 | 0) {
      break label$1
     }
     $4 = HEAP32[(($4 + ($7 << 2 | 0) | 0) + 1064 | 0) >> 2] | 0;
     $7 = HEAPU16[($4 + 1062 | 0) >> 1] | 0;
     $6 = !$8;
     $2 = HEAP32[($2 + 1064 | 0) >> 2] | 0;
     $8 = $8 + -1 | 0;
     $3 = $3 + -1 | 0;
     if ($3) {
      continue label$3
     }
     break label$3;
    };
   }
   if (!$6) {
    break label$1
   }
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = 0;
   HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $2;
   HEAP32[i64toi32_i32$1 >> 2] = $1;
   HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = $7;
   HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $4;
   global$0 = $5 + 48 | 0;
   return;
  }
  core__fmt__ArgumentV1__new__hbd2b9e6635c55d43($5 + 8 | 0 | 0, 1072364 | 0, 1 | 0);
  HEAP32[($5 + 36 | 0) >> 2] = 1;
  i64toi32_i32$1 = $5;
  i64toi32_i32$0 = 0;
  HEAP32[($5 + 20 | 0) >> 2] = 1;
  HEAP32[($5 + 24 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($5 + 16 | 0) >> 2] = 1072324;
  i64toi32_i32$0 = HEAP32[($5 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($5 + 12 | 0) >> 2] | 0;
  $65 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[($5 + 40 | 0) >> 2] = $65;
  HEAP32[($5 + 44 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($5 + 32 | 0) >> 2] = $5 + 40 | 0;
  core__panicking__panic_fmt__hbf21a3d4bbb82bf8($5 + 16 | 0 | 0, 1072468 | 0);
  abort();
 }
 
 function alloc__collections__btree__navigate__full_range__h605bcb95cf10e0c9($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $6 = 0, $7 = 0, $8 = 0, $65 = 0;
  $5 = global$0 - 48 | 0;
  global$0 = $5;
  $6 = !$1;
  $7 = HEAPU16[($4 + 314 | 0) >> 1] | 0;
  label$1 : {
   label$2 : {
    if (!$3) {
     break label$2
    }
    $8 = $1 + -1 | 0;
    $1 = $1 - $3 | 0;
    label$3 : while (1) {
     if ($6 & 1 | 0) {
      break label$1
     }
     $4 = HEAP32[(($4 + ($7 << 2 | 0) | 0) + 320 | 0) >> 2] | 0;
     $7 = HEAPU16[($4 + 314 | 0) >> 1] | 0;
     $6 = !$8;
     $2 = HEAP32[($2 + 320 | 0) >> 2] | 0;
     $8 = $8 + -1 | 0;
     $3 = $3 + -1 | 0;
     if ($3) {
      continue label$3
     }
     break label$3;
    };
   }
   if (!$6) {
    break label$1
   }
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = 0;
   HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $2;
   HEAP32[i64toi32_i32$1 >> 2] = $1;
   HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = $7;
   HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $4;
   global$0 = $5 + 48 | 0;
   return;
  }
  core__fmt__ArgumentV1__new__hbd2b9e6635c55d43($5 + 8 | 0 | 0, 1072364 | 0, 1 | 0);
  HEAP32[($5 + 36 | 0) >> 2] = 1;
  i64toi32_i32$1 = $5;
  i64toi32_i32$0 = 0;
  HEAP32[($5 + 20 | 0) >> 2] = 1;
  HEAP32[($5 + 24 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($5 + 16 | 0) >> 2] = 1072324;
  i64toi32_i32$0 = HEAP32[($5 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($5 + 12 | 0) >> 2] | 0;
  $65 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[($5 + 40 | 0) >> 2] = $65;
  HEAP32[($5 + 44 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($5 + 32 | 0) >> 2] = $5 + 40 | 0;
  core__panicking__panic_fmt__hbf21a3d4bbb82bf8($5 + 16 | 0 | 0, 1072468 | 0);
  abort();
 }
 
 function alloc__collections__btree__navigate__full_range__h627511b46f4298ce($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $6 = 0, $7 = 0, $8 = 0, $65 = 0;
  $5 = global$0 - 48 | 0;
  global$0 = $5;
  $6 = !$1;
  $7 = HEAPU16[($4 + 138 | 0) >> 1] | 0;
  label$1 : {
   label$2 : {
    if (!$3) {
     break label$2
    }
    $8 = $1 + -1 | 0;
    $1 = $1 - $3 | 0;
    label$3 : while (1) {
     if ($6 & 1 | 0) {
      break label$1
     }
     $4 = HEAP32[(($4 + ($7 << 2 | 0) | 0) + 140 | 0) >> 2] | 0;
     $7 = HEAPU16[($4 + 138 | 0) >> 1] | 0;
     $6 = !$8;
     $2 = HEAP32[($2 + 140 | 0) >> 2] | 0;
     $8 = $8 + -1 | 0;
     $3 = $3 + -1 | 0;
     if ($3) {
      continue label$3
     }
     break label$3;
    };
   }
   if (!$6) {
    break label$1
   }
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = 0;
   HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $2;
   HEAP32[i64toi32_i32$1 >> 2] = $1;
   HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = $7;
   HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $4;
   global$0 = $5 + 48 | 0;
   return;
  }
  core__fmt__ArgumentV1__new__hbd2b9e6635c55d43($5 + 8 | 0 | 0, 1072364 | 0, 1 | 0);
  HEAP32[($5 + 36 | 0) >> 2] = 1;
  i64toi32_i32$1 = $5;
  i64toi32_i32$0 = 0;
  HEAP32[($5 + 20 | 0) >> 2] = 1;
  HEAP32[($5 + 24 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($5 + 16 | 0) >> 2] = 1072324;
  i64toi32_i32$0 = HEAP32[($5 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($5 + 12 | 0) >> 2] | 0;
  $65 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[($5 + 40 | 0) >> 2] = $65;
  HEAP32[($5 + 44 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($5 + 32 | 0) >> 2] = $5 + 40 | 0;
  core__panicking__panic_fmt__hbf21a3d4bbb82bf8($5 + 16 | 0 | 0, 1072468 | 0);
  abort();
 }
 
 function alloc__collections__btree__navigate__full_range__h687ff3c975ae5f45($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $6 = 0, $7 = 0, $8 = 0, $65 = 0;
  $5 = global$0 - 48 | 0;
  global$0 = $5;
  $6 = !$1;
  $7 = HEAPU16[($4 + 6 | 0) >> 1] | 0;
  label$1 : {
   label$2 : {
    if (!$3) {
     break label$2
    }
    $8 = $1 + -1 | 0;
    $1 = $1 - $3 | 0;
    label$3 : while (1) {
     if ($6 & 1 | 0) {
      break label$1
     }
     $4 = HEAP32[(($4 + ($7 << 2 | 0) | 0) + 316 | 0) >> 2] | 0;
     $7 = HEAPU16[($4 + 6 | 0) >> 1] | 0;
     $6 = !$8;
     $2 = HEAP32[($2 + 316 | 0) >> 2] | 0;
     $8 = $8 + -1 | 0;
     $3 = $3 + -1 | 0;
     if ($3) {
      continue label$3
     }
     break label$3;
    };
   }
   if (!$6) {
    break label$1
   }
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = 0;
   HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $2;
   HEAP32[i64toi32_i32$1 >> 2] = $1;
   HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = $7;
   HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $4;
   global$0 = $5 + 48 | 0;
   return;
  }
  core__fmt__ArgumentV1__new__hbd2b9e6635c55d43($5 + 8 | 0 | 0, 1072364 | 0, 1 | 0);
  HEAP32[($5 + 36 | 0) >> 2] = 1;
  i64toi32_i32$1 = $5;
  i64toi32_i32$0 = 0;
  HEAP32[($5 + 20 | 0) >> 2] = 1;
  HEAP32[($5 + 24 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($5 + 16 | 0) >> 2] = 1072324;
  i64toi32_i32$0 = HEAP32[($5 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($5 + 12 | 0) >> 2] | 0;
  $65 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[($5 + 40 | 0) >> 2] = $65;
  HEAP32[($5 + 44 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($5 + 32 | 0) >> 2] = $5 + 40 | 0;
  core__panicking__panic_fmt__hbf21a3d4bbb82bf8($5 + 16 | 0 | 0, 1072468 | 0);
  abort();
 }
 
 function alloc__collections__btree__navigate__full_range__h7c512077c9eac29d($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $6 = 0, $7 = 0, $8 = 0, $65 = 0;
  $5 = global$0 - 48 | 0;
  global$0 = $5;
  $6 = !$1;
  $7 = HEAPU16[($4 + 138 | 0) >> 1] | 0;
  label$1 : {
   label$2 : {
    if (!$3) {
     break label$2
    }
    $8 = $1 + -1 | 0;
    $1 = $1 - $3 | 0;
    label$3 : while (1) {
     if ($6 & 1 | 0) {
      break label$1
     }
     $4 = HEAP32[(($4 + ($7 << 2 | 0) | 0) + 448 | 0) >> 2] | 0;
     $7 = HEAPU16[($4 + 138 | 0) >> 1] | 0;
     $6 = !$8;
     $2 = HEAP32[($2 + 448 | 0) >> 2] | 0;
     $8 = $8 + -1 | 0;
     $3 = $3 + -1 | 0;
     if ($3) {
      continue label$3
     }
     break label$3;
    };
   }
   if (!$6) {
    break label$1
   }
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = 0;
   HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $2;
   HEAP32[i64toi32_i32$1 >> 2] = $1;
   HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = $7;
   HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $4;
   global$0 = $5 + 48 | 0;
   return;
  }
  core__fmt__ArgumentV1__new__hbd2b9e6635c55d43($5 + 8 | 0 | 0, 1072364 | 0, 1 | 0);
  HEAP32[($5 + 36 | 0) >> 2] = 1;
  i64toi32_i32$1 = $5;
  i64toi32_i32$0 = 0;
  HEAP32[($5 + 20 | 0) >> 2] = 1;
  HEAP32[($5 + 24 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($5 + 16 | 0) >> 2] = 1072324;
  i64toi32_i32$0 = HEAP32[($5 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($5 + 12 | 0) >> 2] | 0;
  $65 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[($5 + 40 | 0) >> 2] = $65;
  HEAP32[($5 + 44 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($5 + 32 | 0) >> 2] = $5 + 40 | 0;
  core__panicking__panic_fmt__hbf21a3d4bbb82bf8($5 + 16 | 0 | 0, 1072468 | 0);
  abort();
 }
 
 function alloc__collections__btree__navigate__full_range__hd4dadfd3315a2ab8($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $6 = 0, $7 = 0, $8 = 0, $65 = 0;
  $5 = global$0 - 48 | 0;
  global$0 = $5;
  $6 = !$1;
  $7 = HEAPU16[($4 + 138 | 0) >> 1] | 0;
  label$1 : {
   label$2 : {
    if (!$3) {
     break label$2
    }
    $8 = $1 + -1 | 0;
    $1 = $1 - $3 | 0;
    label$3 : while (1) {
     if ($6 & 1 | 0) {
      break label$1
     }
     $4 = HEAP32[(($4 + ($7 << 2 | 0) | 0) + 448 | 0) >> 2] | 0;
     $7 = HEAPU16[($4 + 138 | 0) >> 1] | 0;
     $6 = !$8;
     $2 = HEAP32[($2 + 448 | 0) >> 2] | 0;
     $8 = $8 + -1 | 0;
     $3 = $3 + -1 | 0;
     if ($3) {
      continue label$3
     }
     break label$3;
    };
   }
   if (!$6) {
    break label$1
   }
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = 0;
   HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $2;
   HEAP32[i64toi32_i32$1 >> 2] = $1;
   HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = $7;
   HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $4;
   global$0 = $5 + 48 | 0;
   return;
  }
  core__fmt__ArgumentV1__new__hbd2b9e6635c55d43($5 + 8 | 0 | 0, 1072364 | 0, 1 | 0);
  HEAP32[($5 + 36 | 0) >> 2] = 1;
  i64toi32_i32$1 = $5;
  i64toi32_i32$0 = 0;
  HEAP32[($5 + 20 | 0) >> 2] = 1;
  HEAP32[($5 + 24 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($5 + 16 | 0) >> 2] = 1072324;
  i64toi32_i32$0 = HEAP32[($5 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($5 + 12 | 0) >> 2] | 0;
  $65 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[($5 + 40 | 0) >> 2] = $65;
  HEAP32[($5 + 44 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($5 + 32 | 0) >> 2] = $5 + 40 | 0;
  core__panicking__panic_fmt__hbf21a3d4bbb82bf8($5 + 16 | 0 | 0, 1072468 | 0);
  abort();
 }
 
 function alloc__collections__btree__navigate__full_range__hfcebc6cee2db4b73($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $6 = 0, $7 = 0, $8 = 0, $65 = 0;
  $5 = global$0 - 48 | 0;
  global$0 = $5;
  $6 = !$1;
  $7 = HEAPU16[($4 + 50 | 0) >> 1] | 0;
  label$1 : {
   label$2 : {
    if (!$3) {
     break label$2
    }
    $8 = $1 + -1 | 0;
    $1 = $1 - $3 | 0;
    label$3 : while (1) {
     if ($6 & 1 | 0) {
      break label$1
     }
     $4 = HEAP32[(($4 + ($7 << 2 | 0) | 0) + 52 | 0) >> 2] | 0;
     $7 = HEAPU16[($4 + 50 | 0) >> 1] | 0;
     $6 = !$8;
     $2 = HEAP32[($2 + 52 | 0) >> 2] | 0;
     $8 = $8 + -1 | 0;
     $3 = $3 + -1 | 0;
     if ($3) {
      continue label$3
     }
     break label$3;
    };
   }
   if (!$6) {
    break label$1
   }
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = 0;
   HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $2;
   HEAP32[i64toi32_i32$1 >> 2] = $1;
   HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = $7;
   HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $4;
   global$0 = $5 + 48 | 0;
   return;
  }
  core__fmt__ArgumentV1__new__hbd2b9e6635c55d43($5 + 8 | 0 | 0, 1072364 | 0, 1 | 0);
  HEAP32[($5 + 36 | 0) >> 2] = 1;
  i64toi32_i32$1 = $5;
  i64toi32_i32$0 = 0;
  HEAP32[($5 + 20 | 0) >> 2] = 1;
  HEAP32[($5 + 24 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($5 + 16 | 0) >> 2] = 1072324;
  i64toi32_i32$0 = HEAP32[($5 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($5 + 12 | 0) >> 2] | 0;
  $65 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[($5 + 40 | 0) >> 2] = $65;
  HEAP32[($5 + 44 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($5 + 32 | 0) >> 2] = $5 + 40 | 0;
  core__panicking__panic_fmt__hbf21a3d4bbb82bf8($5 + 16 | 0 | 0, 1072468 | 0);
  abort();
 }
 
 function alloc__collections__btree__navigate__full_range__h226c3274998a98b7($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $6 = 0, $7 = 0, $8 = 0, $65 = 0;
  $5 = global$0 - 48 | 0;
  global$0 = $5;
  $6 = !$1;
  $7 = HEAPU16[($4 + 402 | 0) >> 1] | 0;
  label$1 : {
   label$2 : {
    if (!$3) {
     break label$2
    }
    $8 = $1 + -1 | 0;
    $1 = $1 - $3 | 0;
    label$3 : while (1) {
     if ($6 & 1 | 0) {
      break label$1
     }
     $4 = HEAP32[(($4 + ($7 << 2 | 0) | 0) + 408 | 0) >> 2] | 0;
     $7 = HEAPU16[($4 + 402 | 0) >> 1] | 0;
     $6 = !$8;
     $2 = HEAP32[($2 + 408 | 0) >> 2] | 0;
     $8 = $8 + -1 | 0;
     $3 = $3 + -1 | 0;
     if ($3) {
      continue label$3
     }
     break label$3;
    };
   }
   if (!$6) {
    break label$1
   }
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = 0;
   HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $2;
   HEAP32[i64toi32_i32$1 >> 2] = $1;
   HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = $7;
   HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $4;
   global$0 = $5 + 48 | 0;
   return;
  }
  core__fmt__ArgumentV1__new__hbd2b9e6635c55d43($5 + 8 | 0 | 0, 1089492 | 0, 1 | 0);
  HEAP32[($5 + 36 | 0) >> 2] = 1;
  i64toi32_i32$1 = $5;
  i64toi32_i32$0 = 0;
  HEAP32[($5 + 20 | 0) >> 2] = 1;
  HEAP32[($5 + 24 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($5 + 16 | 0) >> 2] = 1089452;
  i64toi32_i32$0 = HEAP32[($5 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($5 + 12 | 0) >> 2] | 0;
  $65 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[($5 + 40 | 0) >> 2] = $65;
  HEAP32[($5 + 44 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($5 + 32 | 0) >> 2] = $5 + 40 | 0;
  core__panicking__panic_fmt__hbf21a3d4bbb82bf8($5 + 16 | 0 | 0, 1089596 | 0);
  abort();
 }
 
 function alloc__collections__btree__navigate__full_range__hfebb6510e5fdd8d2($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $6 = 0, $7 = 0, $8 = 0, $65 = 0;
  $5 = global$0 - 48 | 0;
  global$0 = $5;
  $6 = !$1;
  $7 = HEAPU16[($4 + 402 | 0) >> 1] | 0;
  label$1 : {
   label$2 : {
    if (!$3) {
     break label$2
    }
    $8 = $1 + -1 | 0;
    $1 = $1 - $3 | 0;
    label$3 : while (1) {
     if ($6 & 1 | 0) {
      break label$1
     }
     $4 = HEAP32[(($4 + ($7 << 2 | 0) | 0) + 408 | 0) >> 2] | 0;
     $7 = HEAPU16[($4 + 402 | 0) >> 1] | 0;
     $6 = !$8;
     $2 = HEAP32[($2 + 408 | 0) >> 2] | 0;
     $8 = $8 + -1 | 0;
     $3 = $3 + -1 | 0;
     if ($3) {
      continue label$3
     }
     break label$3;
    };
   }
   if (!$6) {
    break label$1
   }
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = 0;
   HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $2;
   HEAP32[i64toi32_i32$1 >> 2] = $1;
   HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = $7;
   HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $4;
   global$0 = $5 + 48 | 0;
   return;
  }
  core__fmt__ArgumentV1__new__hbd2b9e6635c55d43($5 + 8 | 0 | 0, 1089492 | 0, 1 | 0);
  HEAP32[($5 + 36 | 0) >> 2] = 1;
  i64toi32_i32$1 = $5;
  i64toi32_i32$0 = 0;
  HEAP32[($5 + 20 | 0) >> 2] = 1;
  HEAP32[($5 + 24 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($5 + 16 | 0) >> 2] = 1089452;
  i64toi32_i32$0 = HEAP32[($5 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($5 + 12 | 0) >> 2] | 0;
  $65 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[($5 + 40 | 0) >> 2] = $65;
  HEAP32[($5 + 44 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($5 + 32 | 0) >> 2] = $5 + 40 | 0;
  core__panicking__panic_fmt__hbf21a3d4bbb82bf8($5 + 16 | 0 | 0, 1089596 | 0);
  abort();
 }
 
 function cryptoxide__cryptoutil__FixedBuffer_____standard_padding__h5ee4664d1cf7fba4($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $4 = 0, $3 = 0, $5 = 0;
  $3 = HEAP32[$0 >> 2] | 0;
  $4 = $3 + 1 | 0;
  HEAP32[$0 >> 2] = $4;
  label$1 : {
   label$2 : {
    label$3 : {
     if ($4 >>> 0 < $3 >>> 0) {
      break label$3
     }
     if ($4 >>> 0 > 128 >>> 0) {
      break label$2
     }
     HEAP8[(($0 + $3 | 0) + 4 | 0) >> 0] = 128;
     label$4 : {
      $4 = HEAP32[$0 >> 2] | 0;
      $3 = 128 - $4 | 0;
      if ($3 >>> 0 >= $1 >>> 0) {
       break label$4
      }
      if ($4 >>> 0 >= 129 >>> 0) {
       break label$1
      }
      $5 = $0 + 4 | 0;
      memset($5 + $4 | 0 | 0, 0 | 0, $3 | 0) | 0;
      HEAP32[$0 >> 2] = 0;
      cryptoxide__hashing__sha2__impl512__reference__digest_block__h5deb88f07cb6a5e7(HEAP32[$2 >> 2] | 0 | 0, $5 | 0, 128 | 0);
      $4 = HEAP32[$0 >> 2] | 0;
     }
     label$5 : {
      label$6 : {
       $3 = 128 - $1 | 0;
       if ($3 >>> 0 < $4 >>> 0) {
        break label$6
       }
       if ($1 >>> 0 < 129 >>> 0) {
        break label$5
       }
       core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($3 | 0, 128 | 0, 1102792 | 0);
       abort();
      }
      core__panicking__panic__h2fd385a887c8bf13(1102736 | 0, 40 | 0, 1102776 | 0);
      abort();
     }
     memset(($0 + $4 | 0) + 4 | 0 | 0, 0 | 0, $3 - $4 | 0 | 0) | 0;
     HEAP32[$0 >> 2] = $3;
     return;
    }
    core__slice__index__slice_index_order_fail__h71e247dec3f266ff(-1 | 0, $4 | 0, 1102808 | 0);
    abort();
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($4 | 0, 128 | 0, 1102808 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1102736 | 0, 40 | 0, 1102776 | 0);
  abort();
 }
 
 function $hex__error__FromHexError_20as_20core__fmt__Display___fmt__haa62d686bf8e55c9($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, $3 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $3 = HEAP32[$0 >> 2] | 0;
      switch ((($3 & 2097150 | 0 | 0) == (1114112 | 0) ? $3 + -1114111 | 0 : 0) | 0) {
      case 2:
       break label$2;
      case 1:
       break label$3;
      default:
       break label$4;
      };
     }
     HEAP32[$2 >> 2] = $3;
     HEAP32[($2 + 4 | 0) >> 2] = HEAP32[($0 + 4 | 0) >> 2] | 0;
     HEAP32[($2 + 44 | 0) >> 2] = 2;
     HEAP32[($2 + 20 | 0) >> 2] = 46;
     i64toi32_i32$0 = 0;
     HEAP32[($2 + 28 | 0) >> 2] = 2;
     HEAP32[($2 + 32 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($2 + 24 | 0) >> 2] = 1141936;
     HEAP32[($2 + 12 | 0) >> 2] = 265;
     HEAP32[($2 + 40 | 0) >> 2] = $2 + 8 | 0;
     HEAP32[($2 + 16 | 0) >> 2] = $2 + 4 | 0;
     HEAP32[($2 + 8 | 0) >> 2] = $2;
     $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 24 | 0 | 0) | 0;
     break label$1;
    }
    HEAP32[($2 + 44 | 0) >> 2] = 0;
    HEAP32[($2 + 40 | 0) >> 2] = 1141876;
    i64toi32_i32$0 = 0;
    HEAP32[($2 + 28 | 0) >> 2] = 1;
    HEAP32[($2 + 32 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($2 + 24 | 0) >> 2] = 1141896;
    $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 24 | 0 | 0) | 0;
    break label$1;
   }
   HEAP32[($2 + 44 | 0) >> 2] = 0;
   HEAP32[($2 + 40 | 0) >> 2] = 1141876;
   i64toi32_i32$0 = 0;
   HEAP32[($2 + 28 | 0) >> 2] = 1;
   HEAP32[($2 + 32 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($2 + 24 | 0) >> 2] = 1141868;
   $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 24 | 0 | 0) | 0;
  }
  global$0 = $2 + 48 | 0;
  return $0 | 0;
 }
 
 function core__fmt__builders__DebugMap__value__h19c9df82a455cf6d($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, $5 = 0, $32 = 0, $35 = 0, $42 = 0, $45 = 0;
  $3 = global$0 - 64 | 0;
  global$0 = $3;
  $4 = 1;
  label$1 : {
   if (HEAPU8[($0 + 4 | 0) >> 0] | 0) {
    break label$1
   }
   label$2 : {
    label$3 : {
     if (!(HEAPU8[($0 + 6 | 0) >> 0] | 0)) {
      break label$3
     }
     label$4 : {
      $5 = HEAP32[$0 >> 2] | 0;
      if ((HEAPU8[$5 >> 0] | 0) & 4 | 0) {
       break label$4
      }
      $4 = 1;
      if (FUNCTION_TABLE[HEAP32[($2 + 12 | 0) >> 2] | 0 | 0]($1, $5) | 0) {
       break label$1
      }
      break label$2;
     }
     HEAP32[($3 + 52 | 0) >> 2] = 1149804;
     HEAP32[($3 + 16 | 0) >> 2] = $0 + 7 | 0;
     i64toi32_i32$2 = $5;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
     $32 = i64toi32_i32$0;
     i64toi32_i32$0 = $3;
     HEAP32[($3 + 8 | 0) >> 2] = $32;
     HEAP32[($3 + 12 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
     $35 = i64toi32_i32$1;
     i64toi32_i32$1 = $3;
     HEAP32[($3 + 40 | 0) >> 2] = $35;
     HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
     HEAP8[($3 + 56 | 0) >> 0] = HEAPU8[(i64toi32_i32$2 + 32 | 0) >> 0] | 0;
     $42 = i64toi32_i32$0;
     i64toi32_i32$0 = $3;
     HEAP32[($3 + 32 | 0) >> 2] = $42;
     HEAP32[($3 + 36 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $45 = i64toi32_i32$1;
     i64toi32_i32$1 = $3;
     HEAP32[($3 + 24 | 0) >> 2] = $45;
     HEAP32[($3 + 28 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($3 + 48 | 0) >> 2] = $3 + 8 | 0;
     label$5 : {
      if (FUNCTION_TABLE[HEAP32[($2 + 12 | 0) >> 2] | 0 | 0]($1, $3 + 24 | 0) | 0) {
       break label$5
      }
      if (!(FUNCTION_TABLE[HEAP32[((HEAP32[($3 + 52 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($3 + 48 | 0) >> 2] | 0, 1149867, 2) | 0)) {
       break label$2
      }
     }
     $4 = 1;
     break label$1;
    }
    core__panicking__panic__h2fd385a887c8bf13(1150008 | 0, 46 | 0, 1150056 | 0);
    abort();
   }
   $4 = 0;
   HEAP8[($0 + 6 | 0) >> 0] = 0;
  }
  HEAP8[($0 + 5 | 0) >> 0] = 1;
  HEAP8[($0 + 4 | 0) >> 0] = $4;
  global$0 = $3 + 64 | 0;
  return $0 | 0;
 }
 
 function cardano_serialization_lib__tx_builder__tx_inputs_builder__PlutusWitnesses__collect__h298b5e0ce4f6a5da($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, i64toi32_i32$2 = 0, $43 = 0, $46 = 0, $49 = 0, $55 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 4 | 0) >> 2] = 0;
  HEAP32[($2 + 8 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[$2 >> 2] = HEAP32[(0 + 1070728 | 0) >> 2] | 0;
  HEAP8[($2 + 28 | 0) >> 0] = 2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 20 | 0) >> 2] = 0;
  HEAP32[($2 + 24 | 0) >> 2] = i64toi32_i32$0;
  $3 = HEAP32[(0 + 1070736 | 0) >> 2] | 0;
  HEAP32[($2 + 16 | 0) >> 2] = $3;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 36 | 0) >> 2] = 0;
  HEAP32[($2 + 40 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 32 | 0) >> 2] = $3;
  label$1 : {
   $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   if (!$3) {
    break label$1
   }
   $1 = HEAP32[$1 >> 2] | 0;
   $3 = Math_imul($3, 144);
   label$2 : while (1) {
    cardano_serialization_lib__plutus__PlutusScripts__add__he3c09fbfbe0a2d17($2 | 0, $1 + 128 | 0 | 0);
    cardano_serialization_lib__plutus__PlutusList__add__ha106511326853de8($2 + 16 | 0 | 0, $1 | 0);
    cardano_serialization_lib__plutus__Redeemers__add__hd385809a7217414b($2 + 32 | 0 | 0, $1 + 48 | 0 | 0);
    $1 = $1 + 144 | 0;
    $3 = $3 + -144 | 0;
    if ($3) {
     continue label$2
    }
    break label$2;
   };
  }
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $43 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = $43;
  HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $46;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $49 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = $49;
  HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $55 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 20 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $55;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($0 + 8 | 0) >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
  HEAP32[($0 + 36 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 48 | 0;
 }
 
 function bech32__Bech32Writer__inner_finalize__h40926327c64dbb3a($0) {
  $0 = $0 | 0;
  var $1 = 0, $5 = 0, $4 = 0, $2 = 0, $6 = 0, $3 = 0;
  $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  $2 = 0;
  label$1 : while (1) {
   $3 = $1 >>> 25 | 0;
   $1 = ($1 << 5 | 0) & 1073741792 | 0;
   $4 = 1138480;
   $5 = 0;
   label$2 : while (1) {
    $6 = $5 + 1 | 0;
    label$3 : {
     if (!(($3 >>> ($5 & 255 | 0) | 0) & 1 | 0)) {
      break label$3
     }
     $1 = (HEAP32[$4 >> 2] | 0) ^ $1 | 0;
    }
    $4 = $4 + 4 | 0;
    $5 = $6;
    if (($5 | 0) != (5 | 0)) {
     continue label$2
    }
    break label$2;
   };
   $2 = $2 + 1 | 0;
   if (($2 | 0) != (6 | 0)) {
    continue label$1
   }
   break label$1;
  };
  HEAP32[($0 + 8 | 0) >> 2] = $1;
  $3 = $1 ^ 1 | 0;
  $2 = HEAP32[$0 >> 2] | 0;
  $0 = HEAP32[((HEAP32[($0 + 4 | 0) >> 2] | 0) + 16 | 0) >> 2] | 0;
  $6 = 0;
  $5 = 25;
  label$4 : {
   label$5 : while (1) {
    $4 = $6;
    if (($5 | 0) == (-5 | 0)) {
     break label$4
    }
    $6 = $4 + 1 | 0;
    $1 = $5 & 31 | 0;
    $5 = $5 + -5 | 0;
    if (!(FUNCTION_TABLE[$0 | 0]($2, HEAP32[(((($3 >>> $1 | 0) & 31 | 0) << 2 | 0) + 1138248 | 0) >> 2] | 0) | 0)) {
     continue label$5
    }
    break label$5;
   };
  }
  return $4 >>> 0 < 6 >>> 0 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__KV___split__h09d046c5ede2959b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $7 = 0, $4 = 0, $3 = 0, $6 = 0, $2 = 0, $8 = 0, $5 = 0, i64toi32_i32$1 = 0;
  $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $3 = HEAPU16[($2 + 50 | 0) >> 1] | 0;
  $4 = alloc__boxed__Box_T_2cA___new_uninit_in__ha1c9e40f84881c6f() | 0;
  HEAP16[($4 + 50 | 0) >> 1] = 0;
  HEAP32[$4 >> 2] = 0;
  $5 = alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__h57e52de3aa06ad25($1 | 0, $4 | 0) | 0;
  $6 = HEAPU16[($4 + 50 | 0) >> 1] | 0;
  $7 = $6 + 1 | 0;
  label$1 : {
   label$2 : {
    if ($6 >>> 0 >= 12 >>> 0) {
     break label$2
    }
    $8 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    $3 = $3 - $8 | 0;
    if (($3 | 0) != ($7 | 0)) {
     break label$1
    }
    memcpy($4 + 52 | 0 | 0, (($8 << 2 | 0) + $2 | 0) + 56 | 0 | 0, $3 << 2 | 0 | 0) | 0;
    $2 = HEAP32[$1 >> 2] | 0;
    $7 = 0;
    label$3 : {
     label$4 : while (1) {
      $3 = HEAP32[(($4 + ($7 << 2 | 0) | 0) + 52 | 0) >> 2] | 0;
      HEAP16[($3 + 48 | 0) >> 1] = $7;
      HEAP32[$3 >> 2] = $4;
      if ($7 >>> 0 >= $6 >>> 0) {
       break label$3
      }
      $7 = $7 + ($7 >>> 0 < $6 >>> 0) | 0;
      if ($7 >>> 0 <= $6 >>> 0) {
       continue label$4
      }
      break label$4;
     };
    }
    HEAP32[($0 + 12 | 0) >> 2] = $2;
    HEAP32[($0 + 8 | 0) >> 2] = $5;
    HEAP32[($0 + 16 | 0) >> 2] = $4;
    i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    HEAP32[$0 >> 2] = HEAP32[$1 >> 2] | 0;
    HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$1;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($7 | 0, 12 | 0, 1049060 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1048988 | 0, 40 | 0, 1049028 | 0);
  abort();
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__UnitInterval___serialize__h073d853696277759($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, $4 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  i64toi32_i32$0 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 6 | 0, 30 | 0, i64toi32_i32$0 | 0);
  $4 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
        break label$5
       }
       i64toi32_i32$0 = 0;
       cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, 2 | 0, i64toi32_i32$0 | 0);
       if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
        break label$4
       }
       i64toi32_i32$2 = $1;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, i64toi32_i32$0 | 0, i64toi32_i32$1 | 0);
       $4 = 1;
       if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
        break label$3
       }
       i64toi32_i32$2 = $1;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
       cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, i64toi32_i32$1 | 0, i64toi32_i32$0 | 0);
       if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
        break label$2
       }
       HEAP32[($0 + 4 | 0) >> 2] = $2;
       $4 = 0;
       break label$1;
      }
      memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
      break label$1;
     }
     memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
     $4 = 1;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $4 = 1;
  }
  HEAP32[$0 >> 2] = $4;
  global$0 = $3 + 48 | 0;
 }
 
 function core__ops__function__impls___impl_20core__ops__function__FnOnce_A__20for_20_mut_20F___call_once__hb66958512d8fa8c9($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $6 = 0, $5 = 0, $55 = 0, $58 = 0;
  $4 = global$0 - 144 | 0;
  global$0 = $4;
  $5 = HEAP32[$2 >> 2] | 0;
  label$1 : {
   label$2 : {
    if (HEAP32[($3 + 20 | 0) >> 2] | 0) {
     break label$2
    }
    HEAP32[($4 + 92 | 0) >> 2] = 0;
    break label$1;
   }
   $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h44c6d4679ef9fae6($4 + 72 | 0 | 0, $3 | 0);
  }
  $2 = $3 + 52 | 0;
  label$3 : {
   label$4 : {
    $6 = HEAP32[($3 + 40 | 0) >> 2] | 0;
    if ($6) {
     break label$4
    }
    HEAP32[($4 + 112 | 0) >> 2] = 0;
    break label$3;
   }
   alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($4 + 112 | 0 | 0, $6 | 0, HEAP32[($3 + 48 | 0) >> 2] | 0 | 0);
  }
  label$5 : {
   label$6 : {
    if (HEAP32[$2 >> 2] | 0) {
     break label$6
    }
    HEAP32[($4 + 128 | 0) >> 2] = 0;
    break label$5;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hc722e22117ee5940($4 + 128 | 0 | 0, $2 | 0);
  }
  memcpy($4 + 8 | 0 | 0, $4 + 72 | 0 | 0, 40 | 0) | 0;
  HEAP32[($4 + 56 | 0) >> 2] = HEAP32[(($4 + 112 | 0) + 8 | 0) >> 2] | 0;
  HEAP32[($4 + 68 | 0) >> 2] = HEAP32[(($4 + 128 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($4 + 112 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($4 + 116 | 0) >> 2] | 0;
  $55 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[($4 + 48 | 0) >> 2] = $55;
  HEAP32[($4 + 52 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[($4 + 128 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($4 + 132 | 0) >> 2] | 0;
  $58 = i64toi32_i32$1;
  i64toi32_i32$1 = $4;
  HEAP32[($4 + 60 | 0) >> 2] = $58;
  HEAP32[($4 + 64 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[$0 >> 2] = $5;
  memcpy($0 + 8 | 0 | 0, $4 + 8 | 0 | 0, 64 | 0) | 0;
  global$0 = $4 + 144 | 0;
 }
 
 function transactionbuilder_add_json_metadatum($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $5 = 0, $6 = 0, i64toi32_i32$1 = 0;
  $4 = global$0 - 64 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h5566e1c7d4aafe35($4 + 24 | 0 | 0, $0 | 0);
    if (!$1) {
     break label$2
    }
    $5 = HEAP32[($4 + 28 | 0) >> 2] | 0;
    $6 = HEAP32[($4 + 24 | 0) >> 2] | 0;
    wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($4 + 16 | 0 | 0, $1 | 0);
    $0 = HEAP32[($4 + 20 | 0) >> 2] | 0;
    $1 = HEAP32[($4 + 16 | 0) >> 2] | 0;
    HEAP32[($4 + 56 | 0) >> 2] = $3;
    HEAP32[($4 + 52 | 0) >> 2] = $3;
    HEAP32[($4 + 48 | 0) >> 2] = $2;
    alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($4 + 8 | 0 | 0, $4 + 48 | 0 | 0);
    $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($4 + 32 | 0 | 0, HEAP32[($4 + 8 | 0) >> 2] | 0 | 0, HEAP32[($4 + 12 | 0) >> 2] | 0 | 0);
    HEAP32[(($4 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($4 + 32 | 0) + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($4 + 36 | 0) >> 2] | 0;
    HEAP32[($4 + 48 | 0) >> 2] = HEAP32[($4 + 32 | 0) >> 2] | 0;
    HEAP32[($4 + 52 | 0) >> 2] = i64toi32_i32$1;
    cardano_serialization_lib__tx_builder__TransactionBuilder__add_json_metadatum_with_schema__h378f72e2b00e53e2($4 | 0, $6 | 0, $1 | 0, $4 + 48 | 0 | 0, 0 | 0);
    $3 = HEAP32[($4 + 4 | 0) >> 2] | 0;
    $1 = HEAP32[$4 >> 2] | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($5 | 0, 0 | 0) | 0;
    if ($1) {
     break label$1
    }
    global$0 = $4 + 64 | 0;
    return;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472($3 | 0);
  abort();
 }
 
 function cardano_serialization_lib__crypto__KESSignature__from_bytes__hac671a375e3a19d6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, $13 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 208 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    if (($3 | 0) != (448 | 0)) {
     break label$2
    }
    i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $13 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $13;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
    $1 = 0;
    break label$1;
   }
   alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($2 + 192 | 0 | 0, 1067147 | 0, 12 | 0);
   i64toi32_i32$1 = 0;
   i64toi32_i32$0 = $2 + 184 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $3;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$0 = $2 + 176 | 0;
   i64toi32_i32$1 = 0;
   HEAP32[i64toi32_i32$0 >> 2] = 1;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$0 = $2 + 168 | 0;
   i64toi32_i32$1 = 0;
   HEAP32[i64toi32_i32$0 >> 2] = 448;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($2 + 160 | 0) >> 2] = 11;
   HEAP32[(($2 + 144 | 0) + 12 | 0) >> 2] = 1066390;
   HEAP8[($2 + 152 | 0) >> 0] = 13;
   HEAP8[($2 + 144 | 0) >> 0] = 2;
   memcpy($2 + 72 | 0 | 0, memcpy(($2 + 4 | 0) + 4 | 0 | 0, memcpy($2 + 72 | 0 | 4 | 0 | 0, $2 + 144 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 72 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 208 | 0;
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___insert__h9d3a28073b5db74d($0, $1, $2, $3, $3$hi, $4, $4$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  $4 = $4 | 0;
  $4$hi = $4$hi | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $5 = 0, $6 = 0, $21 = 0, $38 = 0, $42 = 0, $45 = 0, $7 = 0, $7$hi = 0, $8 = 0, $8$hi = 0;
  $5 = global$0 - 64 | 0;
  global$0 = $5;
  $6 = ($5 + 32 | 0) + 8 | 0;
  HEAP32[$6 >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] = $21;
  HEAP32[(i64toi32_i32$0 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__collections__btree__map__BTreeMap_K_2cV___entry__h66ee8f940e8766a8(i64toi32_i32$0 | 0, $1 | 0, i64toi32_i32$0 + 32 | 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[i64toi32_i32$0 >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    HEAP32[($5 + 56 | 0) >> 2] = HEAP32[($5 + 28 | 0) >> 2] | 0;
    i64toi32_i32$2 = $5 + 20 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $38 = i64toi32_i32$1;
    i64toi32_i32$1 = $5 + 48 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $38;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $5 + 12 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $42 = i64toi32_i32$0;
    i64toi32_i32$0 = $6;
    HEAP32[i64toi32_i32$0 >> 2] = $42;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $5;
    i64toi32_i32$1 = HEAP32[($5 + 4 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($5 + 8 | 0) >> 2] | 0;
    $45 = i64toi32_i32$1;
    i64toi32_i32$1 = $5;
    HEAP32[(i64toi32_i32$1 + 32 | 0) >> 2] = $45;
    HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = $3$hi;
    i64toi32_i32$0 = $4$hi;
    i64toi32_i32$0 = $3$hi;
    i64toi32_i32$1 = $4$hi;
    alloc__collections__btree__map__entry__VacantEntry_K_2cV___insert__h81bd2d8e70cdae36($5 + 32 | 0 | 0, $3 | 0, i64toi32_i32$0 | 0, $4 | 0, i64toi32_i32$1 | 0) | 0;
    i64toi32_i32$1 = 0;
    $3 = 0;
    $3$hi = i64toi32_i32$1;
    break label$1;
   }
   $2 = (HEAP32[($5 + 8 | 0) >> 2] | 0) + ((HEAP32[($5 + 12 | 0) >> 2] | 0) << 4 | 0) | 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $7 = i64toi32_i32$1;
   $7$hi = i64toi32_i32$0;
   i64toi32_i32$0 = $3$hi;
   i64toi32_i32$1 = i64toi32_i32$2;
   HEAP32[i64toi32_i32$1 >> 2] = $3;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   $2 = i64toi32_i32$1 + 8 | 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $8 = i64toi32_i32$0;
   $8$hi = i64toi32_i32$1;
   i64toi32_i32$1 = $4$hi;
   i64toi32_i32$0 = i64toi32_i32$2;
   HEAP32[i64toi32_i32$0 >> 2] = $4;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = 0;
   $3 = 1;
   $3$hi = i64toi32_i32$1;
  }
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $3$hi;
  HEAP32[i64toi32_i32$0 >> 2] = $3;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = i64toi32_i32$0 + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $5 + 64 | 0;
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next__h17e50943fe483865($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $5 = 0, $2 = 0, $3 = 0, $4 = 0, $6 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $3 = HEAP32[$1 >> 2] | 0;
  label$1 : {
   label$2 : {
    $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    $1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if ($4 >>> 0 < (HEAPU16[($1 + 138 | 0) >> 1] | 0) >>> 0) {
     break label$2
    }
    label$3 : {
     label$4 : while (1) {
      alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__h538f90b035d35bbd($2 | 0, $3 | 0, $1 | 0);
      $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
      if (!$1) {
       break label$3
      }
      $3 = HEAP32[$2 >> 2] | 0;
      $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
      if ($4 >>> 0 < (HEAPU16[($1 + 138 | 0) >> 1] | 0) >>> 0) {
       break label$2
      }
      continue label$4;
     };
    }
    HEAP32[($0 + 4 | 0) >> 2] = 0;
    break label$1;
   }
   $5 = $4 + 1 | 0;
   label$5 : {
    label$6 : {
     if ($3) {
      break label$6
     }
     $6 = $1;
     break label$5;
    }
    $6 = HEAP32[(($1 + ($5 << 2 | 0) | 0) + 144 | 0) >> 2] | 0;
    label$7 : {
     $5 = $3 + -1 | 0;
     if (!$5) {
      break label$7
     }
     label$8 : while (1) {
      $6 = HEAP32[($6 + 144 | 0) >> 2] | 0;
      $5 = $5 + -1 | 0;
      if ($5) {
       continue label$8
      }
      break label$8;
     };
    }
    $5 = 0;
   }
   HEAP32[($0 + 8 | 0) >> 2] = $5;
   HEAP32[($0 + 4 | 0) >> 2] = $6;
   HEAP32[$0 >> 2] = 0;
   HEAP32[($0 + 20 | 0) >> 2] = $4;
   HEAP32[($0 + 16 | 0) >> 2] = $1;
   HEAP32[($0 + 12 | 0) >> 2] = $3;
  }
  global$0 = $2 + 16 | 0;
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next__h1f81998e00032910($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $5 = 0, $2 = 0, $3 = 0, $4 = 0, $6 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $3 = HEAP32[$1 >> 2] | 0;
  label$1 : {
   label$2 : {
    $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    $1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if ($4 >>> 0 < (HEAPU16[($1 + 50 | 0) >> 1] | 0) >>> 0) {
     break label$2
    }
    label$3 : {
     label$4 : while (1) {
      alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__hda4ef3fecbd884df($2 | 0, $3 | 0, $1 | 0);
      $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
      if (!$1) {
       break label$3
      }
      $3 = HEAP32[$2 >> 2] | 0;
      $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
      if ($4 >>> 0 < (HEAPU16[($1 + 50 | 0) >> 1] | 0) >>> 0) {
       break label$2
      }
      continue label$4;
     };
    }
    HEAP32[($0 + 4 | 0) >> 2] = 0;
    break label$1;
   }
   $5 = $4 + 1 | 0;
   label$5 : {
    label$6 : {
     if ($3) {
      break label$6
     }
     $6 = $1;
     break label$5;
    }
    $6 = HEAP32[(($1 + ($5 << 2 | 0) | 0) + 52 | 0) >> 2] | 0;
    label$7 : {
     $5 = $3 + -1 | 0;
     if (!$5) {
      break label$7
     }
     label$8 : while (1) {
      $6 = HEAP32[($6 + 52 | 0) >> 2] | 0;
      $5 = $5 + -1 | 0;
      if ($5) {
       continue label$8
      }
      break label$8;
     };
    }
    $5 = 0;
   }
   HEAP32[($0 + 8 | 0) >> 2] = $5;
   HEAP32[($0 + 4 | 0) >> 2] = $6;
   HEAP32[$0 >> 2] = 0;
   HEAP32[($0 + 20 | 0) >> 2] = $4;
   HEAP32[($0 + 16 | 0) >> 2] = $1;
   HEAP32[($0 + 12 | 0) >> 2] = $3;
  }
  global$0 = $2 + 16 | 0;
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next__h237ab4e524b6f8a6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $5 = 0, $2 = 0, $3 = 0, $4 = 0, $6 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $3 = HEAP32[$1 >> 2] | 0;
  label$1 : {
   label$2 : {
    $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    $1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if ($4 >>> 0 < (HEAPU16[($1 + 1458 | 0) >> 1] | 0) >>> 0) {
     break label$2
    }
    label$3 : {
     label$4 : while (1) {
      alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__he958d708f4ef7fcb($2 | 0, $3 | 0, $1 | 0);
      $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
      if (!$1) {
       break label$3
      }
      $3 = HEAP32[$2 >> 2] | 0;
      $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
      if ($4 >>> 0 < (HEAPU16[($1 + 1458 | 0) >> 1] | 0) >>> 0) {
       break label$2
      }
      continue label$4;
     };
    }
    HEAP32[($0 + 4 | 0) >> 2] = 0;
    break label$1;
   }
   $5 = $4 + 1 | 0;
   label$5 : {
    label$6 : {
     if ($3) {
      break label$6
     }
     $6 = $1;
     break label$5;
    }
    $6 = HEAP32[(($1 + ($5 << 2 | 0) | 0) + 1464 | 0) >> 2] | 0;
    label$7 : {
     $5 = $3 + -1 | 0;
     if (!$5) {
      break label$7
     }
     label$8 : while (1) {
      $6 = HEAP32[($6 + 1464 | 0) >> 2] | 0;
      $5 = $5 + -1 | 0;
      if ($5) {
       continue label$8
      }
      break label$8;
     };
    }
    $5 = 0;
   }
   HEAP32[($0 + 8 | 0) >> 2] = $5;
   HEAP32[($0 + 4 | 0) >> 2] = $6;
   HEAP32[$0 >> 2] = 0;
   HEAP32[($0 + 20 | 0) >> 2] = $4;
   HEAP32[($0 + 16 | 0) >> 2] = $1;
   HEAP32[($0 + 12 | 0) >> 2] = $3;
  }
  global$0 = $2 + 16 | 0;
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next__h4b13a720f1e4c62d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $5 = 0, $2 = 0, $3 = 0, $4 = 0, $6 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $3 = HEAP32[$1 >> 2] | 0;
  label$1 : {
   label$2 : {
    $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    $1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if ($4 >>> 0 < (HEAPU16[($1 + 138 | 0) >> 1] | 0) >>> 0) {
     break label$2
    }
    label$3 : {
     label$4 : while (1) {
      alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__h6b0721a0f3de48e5($2 | 0, $3 | 0, $1 | 0);
      $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
      if (!$1) {
       break label$3
      }
      $3 = HEAP32[$2 >> 2] | 0;
      $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
      if ($4 >>> 0 < (HEAPU16[($1 + 138 | 0) >> 1] | 0) >>> 0) {
       break label$2
      }
      continue label$4;
     };
    }
    HEAP32[($0 + 4 | 0) >> 2] = 0;
    break label$1;
   }
   $5 = $4 + 1 | 0;
   label$5 : {
    label$6 : {
     if ($3) {
      break label$6
     }
     $6 = $1;
     break label$5;
    }
    $6 = HEAP32[(($1 + ($5 << 2 | 0) | 0) + 448 | 0) >> 2] | 0;
    label$7 : {
     $5 = $3 + -1 | 0;
     if (!$5) {
      break label$7
     }
     label$8 : while (1) {
      $6 = HEAP32[($6 + 448 | 0) >> 2] | 0;
      $5 = $5 + -1 | 0;
      if ($5) {
       continue label$8
      }
      break label$8;
     };
    }
    $5 = 0;
   }
   HEAP32[($0 + 8 | 0) >> 2] = $5;
   HEAP32[($0 + 4 | 0) >> 2] = $6;
   HEAP32[$0 >> 2] = 0;
   HEAP32[($0 + 20 | 0) >> 2] = $4;
   HEAP32[($0 + 16 | 0) >> 2] = $1;
   HEAP32[($0 + 12 | 0) >> 2] = $3;
  }
  global$0 = $2 + 16 | 0;
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next__h54e79f130ecfd72c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $5 = 0, $2 = 0, $3 = 0, $4 = 0, $6 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $3 = HEAP32[$1 >> 2] | 0;
  label$1 : {
   label$2 : {
    $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    $1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if ($4 >>> 0 < (HEAPU16[($1 + 1546 | 0) >> 1] | 0) >>> 0) {
     break label$2
    }
    label$3 : {
     label$4 : while (1) {
      alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__h9fa0dc18db2ee8da($2 | 0, $3 | 0, $1 | 0);
      $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
      if (!$1) {
       break label$3
      }
      $3 = HEAP32[$2 >> 2] | 0;
      $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
      if ($4 >>> 0 < (HEAPU16[($1 + 1546 | 0) >> 1] | 0) >>> 0) {
       break label$2
      }
      continue label$4;
     };
    }
    HEAP32[($0 + 4 | 0) >> 2] = 0;
    break label$1;
   }
   $5 = $4 + 1 | 0;
   label$5 : {
    label$6 : {
     if ($3) {
      break label$6
     }
     $6 = $1;
     break label$5;
    }
    $6 = HEAP32[(($1 + ($5 << 2 | 0) | 0) + 1552 | 0) >> 2] | 0;
    label$7 : {
     $5 = $3 + -1 | 0;
     if (!$5) {
      break label$7
     }
     label$8 : while (1) {
      $6 = HEAP32[($6 + 1552 | 0) >> 2] | 0;
      $5 = $5 + -1 | 0;
      if ($5) {
       continue label$8
      }
      break label$8;
     };
    }
    $5 = 0;
   }
   HEAP32[($0 + 8 | 0) >> 2] = $5;
   HEAP32[($0 + 4 | 0) >> 2] = $6;
   HEAP32[$0 >> 2] = 0;
   HEAP32[($0 + 20 | 0) >> 2] = $4;
   HEAP32[($0 + 16 | 0) >> 2] = $1;
   HEAP32[($0 + 12 | 0) >> 2] = $3;
  }
  global$0 = $2 + 16 | 0;
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next__h645f0b6aed366fd0($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $5 = 0, $2 = 0, $3 = 0, $4 = 0, $6 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $3 = HEAP32[$1 >> 2] | 0;
  label$1 : {
   label$2 : {
    $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    $1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if ($4 >>> 0 < (HEAPU16[($1 + 138 | 0) >> 1] | 0) >>> 0) {
     break label$2
    }
    label$3 : {
     label$4 : while (1) {
      alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__hee9d82fa4cb1d72f($2 | 0, $3 | 0, $1 | 0);
      $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
      if (!$1) {
       break label$3
      }
      $3 = HEAP32[$2 >> 2] | 0;
      $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
      if ($4 >>> 0 < (HEAPU16[($1 + 138 | 0) >> 1] | 0) >>> 0) {
       break label$2
      }
      continue label$4;
     };
    }
    HEAP32[($0 + 4 | 0) >> 2] = 0;
    break label$1;
   }
   $5 = $4 + 1 | 0;
   label$5 : {
    label$6 : {
     if ($3) {
      break label$6
     }
     $6 = $1;
     break label$5;
    }
    $6 = HEAP32[(($1 + ($5 << 2 | 0) | 0) + 140 | 0) >> 2] | 0;
    label$7 : {
     $5 = $3 + -1 | 0;
     if (!$5) {
      break label$7
     }
     label$8 : while (1) {
      $6 = HEAP32[($6 + 140 | 0) >> 2] | 0;
      $5 = $5 + -1 | 0;
      if ($5) {
       continue label$8
      }
      break label$8;
     };
    }
    $5 = 0;
   }
   HEAP32[($0 + 8 | 0) >> 2] = $5;
   HEAP32[($0 + 4 | 0) >> 2] = $6;
   HEAP32[$0 >> 2] = 0;
   HEAP32[($0 + 20 | 0) >> 2] = $4;
   HEAP32[($0 + 16 | 0) >> 2] = $1;
   HEAP32[($0 + 12 | 0) >> 2] = $3;
  }
  global$0 = $2 + 16 | 0;
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next__h6b4a564027800c71($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $5 = 0, $2 = 0, $3 = 0, $4 = 0, $6 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $3 = HEAP32[$1 >> 2] | 0;
  label$1 : {
   label$2 : {
    $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    $1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if ($4 >>> 0 < (HEAPU16[($1 + 6 | 0) >> 1] | 0) >>> 0) {
     break label$2
    }
    label$3 : {
     label$4 : while (1) {
      alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__h43354c1ef1cf882f($2 | 0, $3 | 0, $1 | 0);
      $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
      if (!$1) {
       break label$3
      }
      $3 = HEAP32[$2 >> 2] | 0;
      $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
      if ($4 >>> 0 < (HEAPU16[($1 + 6 | 0) >> 1] | 0) >>> 0) {
       break label$2
      }
      continue label$4;
     };
    }
    HEAP32[($0 + 4 | 0) >> 2] = 0;
    break label$1;
   }
   $5 = $4 + 1 | 0;
   label$5 : {
    label$6 : {
     if ($3) {
      break label$6
     }
     $6 = $1;
     break label$5;
    }
    $6 = HEAP32[(($1 + ($5 << 2 | 0) | 0) + 316 | 0) >> 2] | 0;
    label$7 : {
     $5 = $3 + -1 | 0;
     if (!$5) {
      break label$7
     }
     label$8 : while (1) {
      $6 = HEAP32[($6 + 316 | 0) >> 2] | 0;
      $5 = $5 + -1 | 0;
      if ($5) {
       continue label$8
      }
      break label$8;
     };
    }
    $5 = 0;
   }
   HEAP32[($0 + 8 | 0) >> 2] = $5;
   HEAP32[($0 + 4 | 0) >> 2] = $6;
   HEAP32[$0 >> 2] = 0;
   HEAP32[($0 + 20 | 0) >> 2] = $4;
   HEAP32[($0 + 16 | 0) >> 2] = $1;
   HEAP32[($0 + 12 | 0) >> 2] = $3;
  }
  global$0 = $2 + 16 | 0;
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next__h7144bb1c780c1097($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $5 = 0, $2 = 0, $3 = 0, $4 = 0, $6 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $3 = HEAP32[$1 >> 2] | 0;
  label$1 : {
   label$2 : {
    $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    $1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if ($4 >>> 0 < (HEAPU16[($1 + 138 | 0) >> 1] | 0) >>> 0) {
     break label$2
    }
    label$3 : {
     label$4 : while (1) {
      alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__h7882606ec619d1fb($2 | 0, $3 | 0, $1 | 0);
      $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
      if (!$1) {
       break label$3
      }
      $3 = HEAP32[$2 >> 2] | 0;
      $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
      if ($4 >>> 0 < (HEAPU16[($1 + 138 | 0) >> 1] | 0) >>> 0) {
       break label$2
      }
      continue label$4;
     };
    }
    HEAP32[($0 + 4 | 0) >> 2] = 0;
    break label$1;
   }
   $5 = $4 + 1 | 0;
   label$5 : {
    label$6 : {
     if ($3) {
      break label$6
     }
     $6 = $1;
     break label$5;
    }
    $6 = HEAP32[(($1 + ($5 << 2 | 0) | 0) + 140 | 0) >> 2] | 0;
    label$7 : {
     $5 = $3 + -1 | 0;
     if (!$5) {
      break label$7
     }
     label$8 : while (1) {
      $6 = HEAP32[($6 + 140 | 0) >> 2] | 0;
      $5 = $5 + -1 | 0;
      if ($5) {
       continue label$8
      }
      break label$8;
     };
    }
    $5 = 0;
   }
   HEAP32[($0 + 8 | 0) >> 2] = $5;
   HEAP32[($0 + 4 | 0) >> 2] = $6;
   HEAP32[$0 >> 2] = 0;
   HEAP32[($0 + 20 | 0) >> 2] = $4;
   HEAP32[($0 + 16 | 0) >> 2] = $1;
   HEAP32[($0 + 12 | 0) >> 2] = $3;
  }
  global$0 = $2 + 16 | 0;
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next__h78d59ba4253ea06a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $5 = 0, $2 = 0, $3 = 0, $4 = 0, $6 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $3 = HEAP32[$1 >> 2] | 0;
  label$1 : {
   label$2 : {
    $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    $1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if ($4 >>> 0 < (HEAPU16[($1 + 138 | 0) >> 1] | 0) >>> 0) {
     break label$2
    }
    label$3 : {
     label$4 : while (1) {
      alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__hcf24682c7c7ea3d8($2 | 0, $3 | 0, $1 | 0);
      $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
      if (!$1) {
       break label$3
      }
      $3 = HEAP32[$2 >> 2] | 0;
      $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
      if ($4 >>> 0 < (HEAPU16[($1 + 138 | 0) >> 1] | 0) >>> 0) {
       break label$2
      }
      continue label$4;
     };
    }
    HEAP32[($0 + 4 | 0) >> 2] = 0;
    break label$1;
   }
   $5 = $4 + 1 | 0;
   label$5 : {
    label$6 : {
     if ($3) {
      break label$6
     }
     $6 = $1;
     break label$5;
    }
    $6 = HEAP32[(($1 + ($5 << 2 | 0) | 0) + 448 | 0) >> 2] | 0;
    label$7 : {
     $5 = $3 + -1 | 0;
     if (!$5) {
      break label$7
     }
     label$8 : while (1) {
      $6 = HEAP32[($6 + 448 | 0) >> 2] | 0;
      $5 = $5 + -1 | 0;
      if ($5) {
       continue label$8
      }
      break label$8;
     };
    }
    $5 = 0;
   }
   HEAP32[($0 + 8 | 0) >> 2] = $5;
   HEAP32[($0 + 4 | 0) >> 2] = $6;
   HEAP32[$0 >> 2] = 0;
   HEAP32[($0 + 20 | 0) >> 2] = $4;
   HEAP32[($0 + 16 | 0) >> 2] = $1;
   HEAP32[($0 + 12 | 0) >> 2] = $3;
  }
  global$0 = $2 + 16 | 0;
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next__h89c63cc8ceb597b8($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $5 = 0, $2 = 0, $3 = 0, $4 = 0, $6 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $3 = HEAP32[$1 >> 2] | 0;
  label$1 : {
   label$2 : {
    $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    $1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if ($4 >>> 0 < (HEAPU16[($1 + 314 | 0) >> 1] | 0) >>> 0) {
     break label$2
    }
    label$3 : {
     label$4 : while (1) {
      alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__h0fa9babfafe148cd($2 | 0, $3 | 0, $1 | 0);
      $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
      if (!$1) {
       break label$3
      }
      $3 = HEAP32[$2 >> 2] | 0;
      $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
      if ($4 >>> 0 < (HEAPU16[($1 + 314 | 0) >> 1] | 0) >>> 0) {
       break label$2
      }
      continue label$4;
     };
    }
    HEAP32[($0 + 4 | 0) >> 2] = 0;
    break label$1;
   }
   $5 = $4 + 1 | 0;
   label$5 : {
    label$6 : {
     if ($3) {
      break label$6
     }
     $6 = $1;
     break label$5;
    }
    $6 = HEAP32[(($1 + ($5 << 2 | 0) | 0) + 320 | 0) >> 2] | 0;
    label$7 : {
     $5 = $3 + -1 | 0;
     if (!$5) {
      break label$7
     }
     label$8 : while (1) {
      $6 = HEAP32[($6 + 320 | 0) >> 2] | 0;
      $5 = $5 + -1 | 0;
      if ($5) {
       continue label$8
      }
      break label$8;
     };
    }
    $5 = 0;
   }
   HEAP32[($0 + 8 | 0) >> 2] = $5;
   HEAP32[($0 + 4 | 0) >> 2] = $6;
   HEAP32[$0 >> 2] = 0;
   HEAP32[($0 + 20 | 0) >> 2] = $4;
   HEAP32[($0 + 16 | 0) >> 2] = $1;
   HEAP32[($0 + 12 | 0) >> 2] = $3;
  }
  global$0 = $2 + 16 | 0;
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next__hb30c6deedb4dc2b6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $5 = 0, $2 = 0, $3 = 0, $4 = 0, $6 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $3 = HEAP32[$1 >> 2] | 0;
  label$1 : {
   label$2 : {
    $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    $1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if ($4 >>> 0 < (HEAPU16[($1 + 1062 | 0) >> 1] | 0) >>> 0) {
     break label$2
    }
    label$3 : {
     label$4 : while (1) {
      alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__h1ca30957bd01a832($2 | 0, $3 | 0, $1 | 0);
      $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
      if (!$1) {
       break label$3
      }
      $3 = HEAP32[$2 >> 2] | 0;
      $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
      if ($4 >>> 0 < (HEAPU16[($1 + 1062 | 0) >> 1] | 0) >>> 0) {
       break label$2
      }
      continue label$4;
     };
    }
    HEAP32[($0 + 4 | 0) >> 2] = 0;
    break label$1;
   }
   $5 = $4 + 1 | 0;
   label$5 : {
    label$6 : {
     if ($3) {
      break label$6
     }
     $6 = $1;
     break label$5;
    }
    $6 = HEAP32[(($1 + ($5 << 2 | 0) | 0) + 1064 | 0) >> 2] | 0;
    label$7 : {
     $5 = $3 + -1 | 0;
     if (!$5) {
      break label$7
     }
     label$8 : while (1) {
      $6 = HEAP32[($6 + 1064 | 0) >> 2] | 0;
      $5 = $5 + -1 | 0;
      if ($5) {
       continue label$8
      }
      break label$8;
     };
    }
    $5 = 0;
   }
   HEAP32[($0 + 8 | 0) >> 2] = $5;
   HEAP32[($0 + 4 | 0) >> 2] = $6;
   HEAP32[$0 >> 2] = 0;
   HEAP32[($0 + 20 | 0) >> 2] = $4;
   HEAP32[($0 + 16 | 0) >> 2] = $1;
   HEAP32[($0 + 12 | 0) >> 2] = $3;
  }
  global$0 = $2 + 16 | 0;
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next__hcc42654374b44411($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $5 = 0, $2 = 0, $3 = 0, $4 = 0, $6 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $3 = HEAP32[$1 >> 2] | 0;
  label$1 : {
   label$2 : {
    $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    $1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if ($4 >>> 0 < (HEAPU16[($1 + 446 | 0) >> 1] | 0) >>> 0) {
     break label$2
    }
    label$3 : {
     label$4 : while (1) {
      alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__hc0a9a6c13e0b7288($2 | 0, $3 | 0, $1 | 0);
      $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
      if (!$1) {
       break label$3
      }
      $3 = HEAP32[$2 >> 2] | 0;
      $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
      if ($4 >>> 0 < (HEAPU16[($1 + 446 | 0) >> 1] | 0) >>> 0) {
       break label$2
      }
      continue label$4;
     };
    }
    HEAP32[($0 + 4 | 0) >> 2] = 0;
    break label$1;
   }
   $5 = $4 + 1 | 0;
   label$5 : {
    label$6 : {
     if ($3) {
      break label$6
     }
     $6 = $1;
     break label$5;
    }
    $6 = HEAP32[(($1 + ($5 << 2 | 0) | 0) + 448 | 0) >> 2] | 0;
    label$7 : {
     $5 = $3 + -1 | 0;
     if (!$5) {
      break label$7
     }
     label$8 : while (1) {
      $6 = HEAP32[($6 + 448 | 0) >> 2] | 0;
      $5 = $5 + -1 | 0;
      if ($5) {
       continue label$8
      }
      break label$8;
     };
    }
    $5 = 0;
   }
   HEAP32[($0 + 8 | 0) >> 2] = $5;
   HEAP32[($0 + 4 | 0) >> 2] = $6;
   HEAP32[$0 >> 2] = 0;
   HEAP32[($0 + 20 | 0) >> 2] = $4;
   HEAP32[($0 + 16 | 0) >> 2] = $1;
   HEAP32[($0 + 12 | 0) >> 2] = $3;
  }
  global$0 = $2 + 16 | 0;
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next__hd4985e8bbf244150($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $5 = 0, $2 = 0, $3 = 0, $4 = 0, $6 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $3 = HEAP32[$1 >> 2] | 0;
  label$1 : {
   label$2 : {
    $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    $1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if ($4 >>> 0 < (HEAPU16[($1 + 226 | 0) >> 1] | 0) >>> 0) {
     break label$2
    }
    label$3 : {
     label$4 : while (1) {
      alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__h0b2b0ab461f4128b($2 | 0, $3 | 0, $1 | 0);
      $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
      if (!$1) {
       break label$3
      }
      $3 = HEAP32[$2 >> 2] | 0;
      $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
      if ($4 >>> 0 < (HEAPU16[($1 + 226 | 0) >> 1] | 0) >>> 0) {
       break label$2
      }
      continue label$4;
     };
    }
    HEAP32[($0 + 4 | 0) >> 2] = 0;
    break label$1;
   }
   $5 = $4 + 1 | 0;
   label$5 : {
    label$6 : {
     if ($3) {
      break label$6
     }
     $6 = $1;
     break label$5;
    }
    $6 = HEAP32[(($1 + ($5 << 2 | 0) | 0) + 232 | 0) >> 2] | 0;
    label$7 : {
     $5 = $3 + -1 | 0;
     if (!$5) {
      break label$7
     }
     label$8 : while (1) {
      $6 = HEAP32[($6 + 232 | 0) >> 2] | 0;
      $5 = $5 + -1 | 0;
      if ($5) {
       continue label$8
      }
      break label$8;
     };
    }
    $5 = 0;
   }
   HEAP32[($0 + 8 | 0) >> 2] = $5;
   HEAP32[($0 + 4 | 0) >> 2] = $6;
   HEAP32[$0 >> 2] = 0;
   HEAP32[($0 + 20 | 0) >> 2] = $4;
   HEAP32[($0 + 16 | 0) >> 2] = $1;
   HEAP32[($0 + 12 | 0) >> 2] = $3;
  }
  global$0 = $2 + 16 | 0;
 }
 
 function $cardano_serialization_lib__metadata__TransactionMetadatumEnum_20as_20core__fmt__Debug___fmt__hc14eef2169db3178($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    switch (HEAP32[$0 >> 2] | 0 | 0) {
    default:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1059848 | 0, 11 | 0);
     HEAP32[($2 + 12 | 0) >> 2] = $0 + 8 | 0;
     core__fmt__builders__DebugTuple__field__h5e7e3e19ad5aa557($2 | 0, $2 + 12 | 0 | 0, 1060304 | 0) | 0;
     break label$1;
    case 1:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1059876 | 0, 12 | 0);
     HEAP32[($2 + 12 | 0) >> 2] = $0 + 4 | 0;
     core__fmt__builders__DebugTuple__field__h5e7e3e19ad5aa557($2 | 0, $2 + 12 | 0 | 0, 1060288 | 0) | 0;
     break label$1;
    case 2:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1060237 | 0, 3 | 0);
     HEAP32[($2 + 12 | 0) >> 2] = $0 + 8 | 0;
     core__fmt__builders__DebugTuple__field__h5e7e3e19ad5aa557($2 | 0, $2 + 12 | 0 | 0, 1060272 | 0) | 0;
     break label$1;
    case 3:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1060232 | 0, 5 | 0);
     HEAP32[($2 + 12 | 0) >> 2] = $0 + 4 | 0;
     core__fmt__builders__DebugTuple__field__h5e7e3e19ad5aa557($2 | 0, $2 + 12 | 0 | 0, 1060256 | 0) | 0;
     break label$1;
    case 4:
     break label$2;
    };
   }
   core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1060228 | 0, 4 | 0);
   HEAP32[($2 + 12 | 0) >> 2] = $0 + 4 | 0;
   core__fmt__builders__DebugTuple__field__h5e7e3e19ad5aa557($2 | 0, $2 + 12 | 0 | 0, 1060240 | 0) | 0;
  }
  $0 = core__fmt__builders__DebugTuple__finish__hc3c3f1efaa75a6e2($2 | 0) | 0;
  global$0 = $2 + 16 | 0;
  return $0 | 0;
 }
 
 function metadatamap_insert_i32($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $14 = 0, $4 = 0, $5 = 0, $28 = 0, $6 = 0, $6$hi = 0;
  $3 = global$0 - 112 | 0;
  global$0 = $3;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h1305d160e0e385a5($3 + 8 | 0 | 0, $0 | 0);
   if (!$2) {
    break label$1
   }
   $4 = HEAP32[($3 + 12 | 0) >> 2] | 0;
   $5 = HEAP32[($3 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hc630c86c4ab6b26d($3 | 0, $2 | 0);
   $0 = HEAP32[($3 + 4 | 0) >> 2] | 0;
   $2 = HEAP32[$3 >> 2] | 0;
   $28 = $3 + 80 | 0;
   i64toi32_i32$1 = $1;
   i64toi32_i32$0 = i64toi32_i32$1 >> 31 | 0;
   $6 = i64toi32_i32$1;
   $6$hi = i64toi32_i32$0;
   i64toi32_i32$2 = i64toi32_i32$1;
   i64toi32_i32$1 = 0;
   i64toi32_i32$3 = 63;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$1 = i64toi32_i32$0 >> 31 | 0;
    $14 = i64toi32_i32$0 >> i64toi32_i32$4 | 0;
   } else {
    i64toi32_i32$1 = i64toi32_i32$0 >> i64toi32_i32$4 | 0;
    $14 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
   }
   i64toi32_i32$2 = $28;
   HEAP32[i64toi32_i32$2 >> 2] = $14;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $6$hi;
   i64toi32_i32$2 = $3 + 72 | 0;
   HEAP32[i64toi32_i32$2 >> 2] = $6;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($3 + 64 | 0) >> 2] = 2;
   cardano_serialization_lib__metadata__MetadataMap__insert__hd93cf89dc2674a42($3 + 16 | 0 | 0, $5 | 0, $3 + 64 | 0 | 0, $2 | 0);
   core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatum___headd2d1b596252cc($3 + 64 | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   $0 = 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($4 | 0, 0 | 0) | 0;
   label$2 : {
    $2 = HEAP32[($3 + 16 | 0) >> 2] | 0;
    if (($2 | 0) == (5 | 0)) {
     break label$2
    }
    HEAP32[($3 + 64 | 0) >> 2] = $2;
    memcpy($3 + 64 | 0 | 4 | 0 | 0, $3 + 16 | 0 | 4 | 0 | 0, 44 | 0) | 0;
    $0 = $cardano_serialization_lib__metadata__TransactionMetadatum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hce2feba55b67d086($3 + 64 | 0 | 0) | 0;
   }
   global$0 = $3 + 112 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function vkeywitnesses_get($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, $31 = 0, $37 = 0, $43 = 0, $46 = 0;
  $2 = global$0 - 208 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h2c8b1c7122d0d2b0($2 + 8 | 0 | 0, $0 | 0);
    $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
    if ($3 >>> 0 <= $1 >>> 0) {
     break label$1
    }
    $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $0 = (HEAP32[$0 >> 2] | 0) + Math_imul($1, 96) | 0;
    i64toi32_i32$2 = $0 + 24 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $31 = i64toi32_i32$0;
    i64toi32_i32$0 = ($2 + 16 | 0) + 24 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $31;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $0 + 16 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $37 = i64toi32_i32$1;
    i64toi32_i32$1 = ($2 + 16 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $37;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $0 + 8 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $43 = i64toi32_i32$0;
    i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $43;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $46 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 16 | 0) >> 2] = $46;
    HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
    memcpy(($2 + 16 | 0) + 32 | 0 | 0, i64toi32_i32$2 + 32 | 0 | 0, 64 | 0) | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
    memcpy($2 + 112 | 0 | 0, $2 + 16 | 0 | 0, 96 | 0) | 0;
    $0 = $cardano_serialization_lib__crypto__Vkeywitness_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hffa43ed1c5f00e23($2 + 112 | 0 | 0) | 0;
    global$0 = $2 + 208 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  core__panicking__panic_bounds_check__h808b524af17640b1($1 | 0, $3 | 0, 1066684 | 0);
  abort();
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___entry__hd9178590dbb7d8f1($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $4 = 0, $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $5 = 0, $39 = 0, $52 = 0;
  $3 = global$0 - 32 | 0;
  global$0 = $3;
  HEAP32[($3 + 12 | 0) >> 2] = $2;
  label$1 : {
   label$2 : {
    $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$4) {
     break label$2
    }
    $5 = HEAP32[$1 >> 2] | 0;
    break label$1;
   }
   $5 = 0;
   $4 = alloc__boxed__Box_T_2cA___new_uninit_in__h78d744dfd1820fc4() | 0;
   HEAP16[($4 + 138 | 0) >> 1] = 0;
   HEAP32[($4 + 88 | 0) >> 2] = 0;
   HEAP32[($1 + 4 | 0) >> 2] = $4;
   HEAP32[$1 >> 2] = 0;
  }
  alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__hc3a0c63fe21f356f($3 + 16 | 0 | 0, $5 | 0, $4 | 0, $3 + 12 | 0 | 0);
  $5 = 1;
  $4 = $3 + 16 | 0 | 4 | 0;
  label$3 : {
   label$4 : {
    if ((HEAP32[($3 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$4
    }
    $2 = $0 + 4 | 0;
    i64toi32_i32$0 = HEAP32[$4 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
    $39 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[i64toi32_i32$0 >> 2] = $39;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($4 + 8 | 0) >> 2] | 0;
    $4 = $0 + 16 | 0;
    break label$3;
   }
   HEAP32[($0 + 4 | 0) >> 2] = $2;
   i64toi32_i32$1 = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   $52 = i64toi32_i32$1;
   i64toi32_i32$1 = $0 + 8 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $52;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($0 + 16 | 0) >> 2] = HEAP32[($4 + 8 | 0) >> 2] | 0;
   $4 = $0 + 20 | 0;
   $5 = 0;
  }
  HEAP32[$0 >> 2] = $5;
  HEAP32[$4 >> 2] = $1;
  global$0 = $3 + 32 | 0;
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___entry__he1839f1eb7854c94($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $4 = 0, $3 = 0, $5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $41 = 0, $52 = 0;
  $3 = global$0 - 80 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$4) {
     break label$2
    }
    $5 = HEAP32[$1 >> 2] | 0;
    break label$1;
   }
   $5 = 0;
   $4 = alloc__boxed__Box_T_2cA___new_uninit_in__h2ea6451c7ed438a4() | 0;
   HEAP16[($4 + 1062 | 0) >> 1] = 0;
   HEAP32[($4 + 1056 | 0) >> 2] = 0;
   HEAP32[($1 + 4 | 0) >> 2] = $4;
   HEAP32[$1 >> 2] = 0;
  }
  alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__h5e891db8f61b9488($3 | 0, $5 | 0, $4 | 0, $2 | 0);
  $5 = 1;
  $4 = $3 | 4 | 0;
  label$3 : {
   label$4 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
     break label$4
    }
    memcpy($3 + 16 | 0 | 0, $2 | 0, 48 | 0) | 0;
    HEAP32[($3 + 72 | 0) >> 2] = HEAP32[($4 + 8 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[$4 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
    $41 = i64toi32_i32$0;
    i64toi32_i32$0 = $3;
    HEAP32[($3 + 64 | 0) >> 2] = $41;
    HEAP32[($3 + 68 | 0) >> 2] = i64toi32_i32$1;
    memcpy($0 + 8 | 0 | 0, $3 + 16 | 0 | 0, 60 | 0) | 0;
    HEAP32[($0 + 68 | 0) >> 2] = $1;
    $5 = 0;
    break label$3;
   }
   i64toi32_i32$1 = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   $52 = i64toi32_i32$1;
   i64toi32_i32$1 = $0;
   HEAP32[($0 + 4 | 0) >> 2] = $52;
   HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($0 + 16 | 0) >> 2] = $1;
   HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($4 + 8 | 0) >> 2] | 0;
   core__ptr__drop_in_place_cardano_serialization_lib__plutus__PlutusData___hfab843e66e0f9428_2($2 | 0);
  }
  HEAP32[$0 >> 2] = $5;
  global$0 = $3 + 80 | 0;
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___entry__hf5f68610bd8a4a4c($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $4 = 0, $3 = 0, $5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $41 = 0, $52 = 0;
  $3 = global$0 - 160 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$4) {
     break label$2
    }
    $5 = HEAP32[$1 >> 2] | 0;
    break label$1;
   }
   $5 = 0;
   $4 = alloc__boxed__Box_T_2cA___new_uninit_in__h42dfd122c2fed30e() | 0;
   HEAP16[($4 + 1546 | 0) >> 1] = 0;
   HEAP32[($4 + 1408 | 0) >> 2] = 0;
   HEAP32[($1 + 4 | 0) >> 2] = $4;
   HEAP32[$1 >> 2] = 0;
  }
  alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__h804fffb548e74f27($3 | 0, $5 | 0, $4 | 0, $2 | 0);
  $5 = 1;
  $4 = $3 | 4 | 0;
  label$3 : {
   label$4 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
     break label$4
    }
    memcpy($3 + 16 | 0 | 0, $2 | 0, 128 | 0) | 0;
    HEAP32[($3 + 152 | 0) >> 2] = HEAP32[($4 + 8 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[$4 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
    $41 = i64toi32_i32$0;
    i64toi32_i32$0 = $3;
    HEAP32[($3 + 144 | 0) >> 2] = $41;
    HEAP32[($3 + 148 | 0) >> 2] = i64toi32_i32$1;
    memcpy($0 + 8 | 0 | 0, $3 + 16 | 0 | 0, 140 | 0) | 0;
    HEAP32[($0 + 148 | 0) >> 2] = $1;
    $5 = 0;
    break label$3;
   }
   i64toi32_i32$1 = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   $52 = i64toi32_i32$1;
   i64toi32_i32$1 = $0;
   HEAP32[($0 + 4 | 0) >> 2] = $52;
   HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($0 + 16 | 0) >> 2] = $1;
   HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($4 + 8 | 0) >> 2] | 0;
   core__ptr__drop_in_place_cardano_serialization_lib__TransactionOutput___h632b3a99817e6ac5_1($2 | 0);
  }
  HEAP32[$0 >> 2] = $5;
  global$0 = $3 + 160 | 0;
 }
 
 function enterpriseaddress_to_address($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $3 = 0, $6 = 0, $7 = 0, $2 = 0, $4 = 0, $8 = 0, $8$hi = 0, $5 = 0, $9 = 0, $9$hi = 0, $38 = 0, $57 = 0, $61 = 0, $73 = 0;
  $1 = global$0 - 144 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hc7fc7357c4bbb0b7($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $2 = HEAPU8[$0 >> 0] | 0;
  $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $19 = $0 + 26 | 0;
  $4 = HEAPU8[$19 >> 0] | 0 | ((HEAPU8[($19 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($19 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($19 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $0 + 18 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  $5 = HEAPU8[($0 + 1 | 0) >> 0] | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 9 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$0;
  $6 = $1 + 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 10 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $38 = i64toi32_i32$0;
  i64toi32_i32$0 = $6;
  HEAP32[i64toi32_i32$0 >> 2] = $38;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $0 = $1 + 32 | 0;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $7 = $1 + 40 | 0;
  HEAP32[$7 >> 2] = $4;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 16 | 0) >> 2] = $9;
  HEAP32[($1 + 20 | 0) >> 2] = i64toi32_i32$1;
  core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $6;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $57 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 91 | 0;
  $20 = $57;
  HEAP8[i64toi32_i32$1 >> 0] = $20;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $20 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $20 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $20 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $61 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 99 | 0;
  $21 = $61;
  HEAP8[i64toi32_i32$0 >> 0] = $21;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $21 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $21 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $21 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $22 = $1 + 107 | 0;
  $23 = HEAP32[$7 >> 2] | 0;
  HEAP8[$22 >> 0] = $23;
  HEAP8[($22 + 1 | 0) >> 0] = $23 >>> 8 | 0;
  HEAP8[($22 + 2 | 0) >> 0] = $23 >>> 16 | 0;
  HEAP8[($22 + 3 | 0) >> 0] = $23 >>> 24 | 0;
  HEAP8[($1 + 82 | 0) >> 0] = $5;
  HEAP8[($1 + 81 | 0) >> 0] = $2;
  HEAP8[($1 + 80 | 0) >> 0] = 2;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $73 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  $24 = $73;
  HEAP8[(i64toi32_i32$2 + 83 | 0) >> 0] = $24;
  HEAP8[(i64toi32_i32$2 + 84 | 0) >> 0] = $24 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 85 | 0) >> 0] = $24 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 86 | 0) >> 0] = $24 >>> 24 | 0;
  HEAP8[(i64toi32_i32$2 + 87 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$2 + 88 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 89 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 90 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $0 = $cardano_serialization_lib__address__Address_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8ce30e61cf34786e(i64toi32_i32$2 + 80 | 0 | 0) | 0;
  global$0 = i64toi32_i32$2 + 144 | 0;
  return $0 | 0;
 }
 
 function rewardaddress_to_address($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $3 = 0, $6 = 0, $7 = 0, $2 = 0, $4 = 0, $8 = 0, $8$hi = 0, $5 = 0, $9 = 0, $9$hi = 0, $38 = 0, $57 = 0, $61 = 0, $73 = 0;
  $1 = global$0 - 144 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h2338c90e0327d08b($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $2 = HEAPU8[$0 >> 0] | 0;
  $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $19 = $0 + 26 | 0;
  $4 = HEAPU8[$19 >> 0] | 0 | ((HEAPU8[($19 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($19 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($19 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $0 + 18 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  $5 = HEAPU8[($0 + 1 | 0) >> 0] | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 9 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$0;
  $6 = $1 + 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 10 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $38 = i64toi32_i32$0;
  i64toi32_i32$0 = $6;
  HEAP32[i64toi32_i32$0 >> 2] = $38;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $0 = $1 + 32 | 0;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $7 = $1 + 40 | 0;
  HEAP32[$7 >> 2] = $4;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 16 | 0) >> 2] = $9;
  HEAP32[($1 + 20 | 0) >> 2] = i64toi32_i32$1;
  core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $6;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $57 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 91 | 0;
  $20 = $57;
  HEAP8[i64toi32_i32$1 >> 0] = $20;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $20 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $20 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $20 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $61 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 99 | 0;
  $21 = $61;
  HEAP8[i64toi32_i32$0 >> 0] = $21;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $21 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $21 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $21 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $22 = $1 + 107 | 0;
  $23 = HEAP32[$7 >> 2] | 0;
  HEAP8[$22 >> 0] = $23;
  HEAP8[($22 + 1 | 0) >> 0] = $23 >>> 8 | 0;
  HEAP8[($22 + 2 | 0) >> 0] = $23 >>> 16 | 0;
  HEAP8[($22 + 3 | 0) >> 0] = $23 >>> 24 | 0;
  HEAP8[($1 + 82 | 0) >> 0] = $5;
  HEAP8[($1 + 81 | 0) >> 0] = $2;
  HEAP8[($1 + 80 | 0) >> 0] = 3;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $73 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  $24 = $73;
  HEAP8[(i64toi32_i32$2 + 83 | 0) >> 0] = $24;
  HEAP8[(i64toi32_i32$2 + 84 | 0) >> 0] = $24 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 85 | 0) >> 0] = $24 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 86 | 0) >> 0] = $24 >>> 24 | 0;
  HEAP8[(i64toi32_i32$2 + 87 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$2 + 88 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 89 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 90 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $0 = $cardano_serialization_lib__address__Address_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8ce30e61cf34786e(i64toi32_i32$2 + 80 | 0 | 0) | 0;
  global$0 = i64toi32_i32$2 + 144 | 0;
  return $0 | 0;
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next__h745dbebc378644f8($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $5 = 0, $2 = 0, $3 = 0, $4 = 0, $6 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $3 = HEAP32[$1 >> 2] | 0;
  label$1 : {
   label$2 : {
    $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    $1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if ($4 >>> 0 < (HEAPU16[($1 + 402 | 0) >> 1] | 0) >>> 0) {
     break label$2
    }
    label$3 : {
     label$4 : while (1) {
      alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__h568c725c749c3744($2 | 0, $3 | 0, $1 | 0);
      $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
      if (!$1) {
       break label$3
      }
      $3 = HEAP32[$2 >> 2] | 0;
      $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
      if ($4 >>> 0 < (HEAPU16[($1 + 402 | 0) >> 1] | 0) >>> 0) {
       break label$2
      }
      continue label$4;
     };
    }
    HEAP32[($0 + 4 | 0) >> 2] = 0;
    break label$1;
   }
   $5 = $4 + 1 | 0;
   label$5 : {
    label$6 : {
     if ($3) {
      break label$6
     }
     $6 = $1;
     break label$5;
    }
    $6 = HEAP32[(($1 + ($5 << 2 | 0) | 0) + 408 | 0) >> 2] | 0;
    label$7 : {
     $5 = $3 + -1 | 0;
     if (!$5) {
      break label$7
     }
     label$8 : while (1) {
      $6 = HEAP32[($6 + 408 | 0) >> 2] | 0;
      $5 = $5 + -1 | 0;
      if ($5) {
       continue label$8
      }
      break label$8;
     };
    }
    $5 = 0;
   }
   HEAP32[($0 + 8 | 0) >> 2] = $5;
   HEAP32[($0 + 4 | 0) >> 2] = $6;
   HEAP32[$0 >> 2] = 0;
   HEAP32[($0 + 20 | 0) >> 2] = $4;
   HEAP32[($0 + 16 | 0) >> 2] = $1;
   HEAP32[($0 + 12 | 0) >> 2] = $3;
  }
  global$0 = $2 + 16 | 0;
 }
 
 function certificate_new_pool_retirement($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $5 = 0, $2 = 0, $22 = 0, $29 = 0, $39 = 0, $51 = 0, $56 = 0, $61 = 0;
  $1 = global$0 - 240 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h77d6f4a2273f50b5($1 | 0, $0 | 0);
  $0 = HEAP32[$1 >> 2] | 0;
  $2 = HEAP32[$0 >> 2] | 0;
  $3 = ($1 + 8 | 0) + 8 | 0;
  i64toi32_i32$2 = $0 + 12 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $22 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $22;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $4 = ($1 + 8 | 0) + 16 | 0;
  i64toi32_i32$2 = $0 + 20 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $29 = i64toi32_i32$1;
  i64toi32_i32$1 = $4;
  HEAP32[i64toi32_i32$1 >> 2] = $29;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $5 = ($1 + 8 | 0) + 24 | 0;
  HEAP32[$5 >> 2] = HEAP32[($0 + 28 | 0) >> 2] | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  $39 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 8 | 0) >> 2] = $39;
  HEAP32[($1 + 12 | 0) >> 2] = i64toi32_i32$1;
  $0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $51 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 40 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $51;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $56 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 40 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $56;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $61 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 40 | 0) + 24 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $61;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($1 + 72 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
  HEAP32[($1 + 44 | 0) >> 2] = $2;
  HEAP8[($1 + 40 | 0) >> 0] = 4;
  $0 = $cardano_serialization_lib__Certificate_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hd9e6ef3cbd15ff20($1 + 40 | 0 | 0) | 0;
  global$0 = $1 + 240 | 0;
  return $0 | 0;
 }
 
 function certificate_as_pool_registration($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $10 = 0, $11 = 0, $12 = 0, $13 = 0, $38 = 0, $45 = 0, $52 = 0, $59 = 0;
  $1 = global$0 - 400 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h3b62e22150831bdc($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   cardano_serialization_lib__Certificate__as_pool_registration__h69561f00b9b1df50($1 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   $0 = 0;
   label$2 : {
    $2 = HEAPU8[($1 + 177 | 0) >> 0] | 0;
    if (($2 | 0) == (2 | 0)) {
     break label$2
    }
    memcpy($1 + 208 | 0 | 0, $1 + 16 | 0 | 0, 161 | 0) | 0;
    HEAP8[(($1 + 208 | 0) + 161 | 0) >> 0] = $2;
    i64toi32_i32$2 = $1;
    i64toi32_i32$0 = HEAPU16[($1 + 178 | 0) >> 1] | 0 | ((HEAPU16[($1 + 180 | 0) >> 1] | 0) << 16 | 0) | 0;
    i64toi32_i32$1 = HEAPU16[($1 + 182 | 0) >> 1] | 0 | ((HEAPU16[($1 + 184 | 0) >> 1] | 0) << 16 | 0) | 0;
    $38 = i64toi32_i32$0;
    i64toi32_i32$0 = $1 + 370 | 0;
    $10 = $38;
    HEAP16[i64toi32_i32$0 >> 1] = $10;
    HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $10 >>> 16 | 0;
    HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$1;
    HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
    i64toi32_i32$2 = ($1 + 16 | 0) + 170 | 0;
    i64toi32_i32$1 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
    i64toi32_i32$0 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
    $45 = i64toi32_i32$1;
    i64toi32_i32$1 = ($1 + 208 | 0) + 170 | 0;
    $11 = $45;
    HEAP16[i64toi32_i32$1 >> 1] = $11;
    HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $11 >>> 16 | 0;
    HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = i64toi32_i32$0;
    HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
    i64toi32_i32$2 = ($1 + 16 | 0) + 178 | 0;
    i64toi32_i32$0 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
    i64toi32_i32$1 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
    $52 = i64toi32_i32$0;
    i64toi32_i32$0 = ($1 + 208 | 0) + 178 | 0;
    $12 = $52;
    HEAP16[i64toi32_i32$0 >> 1] = $12;
    HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $12 >>> 16 | 0;
    HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$1;
    HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
    i64toi32_i32$2 = ($1 + 16 | 0) + 184 | 0;
    i64toi32_i32$1 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
    i64toi32_i32$0 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
    $59 = i64toi32_i32$1;
    i64toi32_i32$1 = ($1 + 208 | 0) + 184 | 0;
    $13 = $59;
    HEAP16[i64toi32_i32$1 >> 1] = $13;
    HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $13 >>> 16 | 0;
    HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = i64toi32_i32$0;
    HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
    $0 = $cardano_serialization_lib__PoolRegistration_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hba4f55f2c62f4c8d($1 + 208 | 0 | 0) | 0;
   }
   global$0 = $1 + 400 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function cardano_serialization_lib__tx_builder__TransactionBuilder__fee_for_input__ha5a0f735cbb9ab50($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, $6 = 0, $6$hi = 0, $7$hi = 0, $7 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $5 = global$0 - 544 | 0;
  global$0 = $5;
  $cardano_serialization_lib__tx_builder__TransactionBuilder_20as_20core__clone__Clone___clone__h4273e58f8bc63575($5 + 8 | 0 | 0, $1 | 0);
  i64toi32_i32$1 = $5 + 272 | 0;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$1 = $5;
  i64toi32_i32$0 = 0;
  HEAP32[($5 + 264 | 0) >> 2] = 1;
  HEAP32[($5 + 268 | 0) >> 2] = i64toi32_i32$0;
  cardano_serialization_lib__tx_builder__min_fee__h8bb5ab8499f01c90($5 + 528 | 0 | 0, $5 + 8 | 0 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[($5 + 528 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     $1 = $5 + 536 | 0;
     i64toi32_i32$2 = $1;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $6 = i64toi32_i32$0;
     $6$hi = i64toi32_i32$1;
     cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__add_input__hd22960e5a7d88824($5 + 104 | 0 | 0, $2 | 0, $3 | 0, $4 | 0);
     cardano_serialization_lib__tx_builder__min_fee__h8bb5ab8499f01c90($5 + 528 | 0 | 0, $5 + 8 | 0 | 0);
     if ((HEAP32[($5 + 528 | 0) >> 2] | 0 | 0) != (1 | 0)) {
      break label$2
     }
    }
    $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($5 + 532 | 0) >> 2] | 0 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    core__ptr__drop_in_place_cardano_serialization_lib__tx_builder__TransactionBuilder___h053801e638e30160($5 + 8 | 0 | 0);
    break label$1;
   }
   label$4 : {
    label$5 : {
     i64toi32_i32$2 = $1;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $7 = i64toi32_i32$1;
     $7$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$1 = $6$hi;
     i64toi32_i32$5 = (i64toi32_i32$2 >>> 0 < $6 >>> 0) + i64toi32_i32$1 | 0;
     i64toi32_i32$5 = i64toi32_i32$0 - i64toi32_i32$5 | 0;
     $6 = i64toi32_i32$2 - $6 | 0;
     $6$hi = i64toi32_i32$5;
     i64toi32_i32$5 = i64toi32_i32$0;
     i64toi32_i32$5 = $6$hi;
     i64toi32_i32$0 = $6;
     i64toi32_i32$2 = $7$hi;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$0 >>> 0 <= $7 >>> 0 | 0) | 0) {
      break label$5
     }
     (wasm2js_i32$0 = $0, wasm2js_i32$1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1058740 | 0, 9 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
     $1 = 1;
     break label$4;
    }
    i64toi32_i32$0 = $6$hi;
    i64toi32_i32$5 = $0 + 8 | 0;
    HEAP32[i64toi32_i32$5 >> 2] = $6;
    HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
    $1 = 0;
   }
   HEAP32[$0 >> 2] = $1;
   core__ptr__drop_in_place_cardano_serialization_lib__tx_builder__TransactionBuilder___h053801e638e30160($5 + 8 | 0 | 0);
  }
  global$0 = $5 + 544 | 0;
 }
 
 function $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__h739679d8ae9565cc($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, $3 = 0, i64toi32_i32$0 = 0, $5 = 0, $4 = 0, $53 = 0, $64 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    $3 = HEAP32[$1 >> 2] | 0;
    if (($3 | 0) != (HEAP32[($1 + 4 | 0) >> 2] | 0 | 0)) {
     break label$2
    }
    $3 = 0;
    break label$1;
   }
   HEAP32[$1 >> 2] = $3 + 128 | 0;
  }
  core__option__Option__T___cloned__h621eb297880b0347($2 + 32 | 0 | 0, $3 | 0);
  label$3 : {
   label$4 : {
    if ((HEAP32[($2 + 104 | 0) >> 2] | 0 | 0) != (2 | 0)) {
     break label$4
    }
    i64toi32_i32$1 = $0;
    i64toi32_i32$0 = 0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = 0;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[i64toi32_i32$1 >> 2] = HEAP32[(0 + 1067624 | 0) >> 2] | 0;
    break label$3;
   }
   alloc__raw_vec__RawVec_T_2cA___allocate_in__he0e25d30114cc7d7($2 + 8 | 0 | 0, 1 | 0, 0 | 0);
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = memmove(HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, $2 + 32 | 0 | 0, 128 | 0) | 0;
   $5 = ($2 + 16 | 0) + 8 | 0;
   HEAP32[$5 >> 2] = 1;
   HEAP32[($2 + 20 | 0) >> 2] = $3;
   HEAP32[($2 + 16 | 0) >> 2] = $4;
   HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   $53 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   HEAP32[($2 + 32 | 0) >> 2] = $53;
   HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
   alloc__vec__Vec_T_2cA___extend_desugared__h00e1f6afbd8990a5($2 + 16 | 0 | 0, $2 + 32 | 0 | 0);
   HEAP32[($0 + 8 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   $64 = i64toi32_i32$1;
   i64toi32_i32$1 = $0;
   HEAP32[i64toi32_i32$1 >> 2] = $64;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  }
  global$0 = $2 + 160 | 0;
 }
 
 function $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__ha2b0cca8c537833f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, $3 = 0, i64toi32_i32$0 = 0, $5 = 0, $4 = 0, $53 = 0, $64 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    $3 = HEAP32[$1 >> 2] | 0;
    if (($3 | 0) != (HEAP32[($1 + 4 | 0) >> 2] | 0 | 0)) {
     break label$2
    }
    $3 = 0;
    break label$1;
   }
   HEAP32[$1 >> 2] = $3 + 128 | 0;
  }
  core__option__Option__T___cloned__h621eb297880b0347($2 + 32 | 0 | 0, $3 | 0);
  label$3 : {
   label$4 : {
    if ((HEAP32[($2 + 104 | 0) >> 2] | 0 | 0) != (2 | 0)) {
     break label$4
    }
    i64toi32_i32$1 = $0;
    i64toi32_i32$0 = 0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = 0;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[i64toi32_i32$1 >> 2] = HEAP32[(0 + 1067624 | 0) >> 2] | 0;
    break label$3;
   }
   alloc__raw_vec__RawVec_T_2cA___allocate_in__he0e25d30114cc7d7($2 + 8 | 0 | 0, 1 | 0, 0 | 0);
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = memmove(HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, $2 + 32 | 0 | 0, 128 | 0) | 0;
   $5 = ($2 + 16 | 0) + 8 | 0;
   HEAP32[$5 >> 2] = 1;
   HEAP32[($2 + 20 | 0) >> 2] = $3;
   HEAP32[($2 + 16 | 0) >> 2] = $4;
   HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   $53 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   HEAP32[($2 + 32 | 0) >> 2] = $53;
   HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
   alloc__vec__Vec_T_2cA___extend_desugared__hcfcb64062caa1691($2 + 16 | 0 | 0, $2 + 32 | 0 | 0);
   HEAP32[($0 + 8 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   $64 = i64toi32_i32$1;
   i64toi32_i32$1 = $0;
   HEAP32[i64toi32_i32$1 >> 2] = $64;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  }
  global$0 = $2 + 160 | 0;
 }
 
 function cardano_serialization_lib__address__ByronAddress__icarus_from_key__h798b11933675c783($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $5 = 0, $4 = 0;
  $3 = global$0 - 224 | 0;
  global$0 = $3;
  memset($3 + 32 | 0 | 0, 0 | 0, 64 | 0) | 0;
  $ed25519_bip32__key__XPub_20as_20core__convert__AsRef__5bu8_5d____as_ref__h69a664c2b5ee8b25($3 + 24 | 0 | 0, $1 | 0);
  $4 = HEAP32[($3 + 24 | 0) >> 2] | 0;
  $1 = HEAP32[($3 + 28 | 0) >> 2] | 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($3 + 16 | 0 | 0, $1 | 0, 0 | 0);
  HEAP32[($3 + 164 | 0) >> 2] = HEAP32[($3 + 20 | 0) >> 2] | 0;
  $5 = HEAP32[($3 + 16 | 0) >> 2] | 0;
  HEAP32[($3 + 160 | 0) >> 2] = $5;
  memcpy($5 | 0, $4 | 0, $1 | 0) | 0;
  HEAP32[($3 + 168 | 0) >> 2] = $1;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $3 + 160 | 0 | 0);
  core__slice___impl_20_5bT_5d___clone_from_slice__h1742dfbd5d5d9efd($3 + 32 | 0 | 0, 64 | 0, HEAP32[($3 + 8 | 0) >> 2] | 0 | 0, HEAP32[($3 + 12 | 0) >> 2] | 0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 160 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 160 | 0 | 0);
  memcpy($3 + 160 | 0 | 0, $3 + 32 | 0 | 0, 64 | 0) | 0;
  ed25519_bip32__key__XPub__from_bytes__hd8f9fabe30c0d335($3 + 96 | 0 | 0, $3 + 160 | 0 | 0);
  HEAP32[($3 + 176 | 0) >> 2] = $2;
  HEAP32[($3 + 172 | 0) >> 2] = ($2 | 0) != (764824073 | 0);
  HEAP32[($3 + 160 | 0) >> 2] = 0;
  cardano_serialization_lib__legacy_address__address__ExtendedAddr__new__h78aa0057fb94bbe4($0 | 0, $3 + 96 | 0 | 0, $3 + 160 | 0 | 0);
  global$0 = $3 + 224 | 0;
 }
 
 function constrplutusdata_new($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, i64toi32_i32$2 = 0, $4 = 0, $4$hi = 0, $46 = 0, $49 = 0, $63 = 0, $68 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($2 + 16 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 16 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hd98e995abd746618($2 + 8 | 0 | 0, $1 | 0);
   i64toi32_i32$2 = $3;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $4 = i64toi32_i32$0;
   $4$hi = i64toi32_i32$1;
   $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hc831120dea694494($2 + 40 | 0 | 0, $3 | 0);
   $3 = HEAPU8[($3 + 12 | 0) >> 0] | 0;
   HEAP8[($2 + 52 | 0) >> 0] = ($3 | 0) == (2 | 0) ? 2 : ($3 | 0) != (0 | 0);
   $3 = ($2 + 24 | 0) + 8 | 0;
   i64toi32_i32$2 = ($2 + 40 | 0) + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $46 = i64toi32_i32$1;
   i64toi32_i32$1 = $3;
   HEAP32[i64toi32_i32$1 >> 2] = $46;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[($2 + 40 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 44 | 0) >> 2] | 0;
   $49 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   HEAP32[($2 + 24 | 0) >> 2] = $49;
   HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$1;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $63 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 56 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $63;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $4$hi;
   i64toi32_i32$1 = $2;
   HEAP32[($2 + 40 | 0) >> 2] = $4;
   HEAP32[($2 + 44 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[($2 + 24 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 28 | 0) >> 2] | 0;
   $68 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   HEAP32[($2 + 48 | 0) >> 2] = $68;
   HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
   $0 = $cardano_serialization_lib__plutus__ConstrPlutusData_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hd2d0c81add63de21($2 + 40 | 0 | 0) | 0;
   global$0 = $2 + 64 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__h8108469f5dd39d01($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $7 = 0, $4 = 0, $5 = 0, $10 = 0, $8 = 0, $9 = 0, $6 = 0;
  $4 = global$0 - 16 | 0;
  global$0 = $4;
  $5 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $6 = HEAPU16[($5 + 402 | 0) >> 1] | 0;
  $7 = Math_imul($3, 12);
  $1 = Math_imul($6, 12) - $7 | 0;
  $5 = ($5 + $7 | 0) + 268 | 0;
  $8 = 1;
  label$1 : {
   label$2 : while (1) {
    $9 = $3;
    label$3 : {
     if ($1) {
      break label$3
     }
     $9 = $6;
     break label$1;
    }
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($4 + 8 | 0 | 0, $2 | 0);
    $10 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    $3 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($4 | 0, $5 | 0);
    label$4 : {
     label$5 : {
      $7 = HEAP32[($4 + 4 | 0) >> 2] | 0;
      $10 = memcmp($10 | 0, HEAP32[$4 >> 2] | 0 | 0, ($3 >>> 0 > $7 >>> 0 ? $7 : $3) | 0) | 0;
      if ($10) {
       break label$5
      }
      if ($3 >>> 0 < $7 >>> 0) {
       break label$1
      }
      $7 = ($3 | 0) != ($7 | 0);
      break label$4;
     }
     $7 = 1;
     if (($10 | 0) >= (0 | 0)) {
      break label$4
     }
     $8 = 1;
     break label$1;
    }
    $5 = $5 + 12 | 0;
    $3 = $9 + 1 | 0;
    $1 = $1 + -12 | 0;
    if ($7) {
     continue label$2
    }
    break label$2;
   };
   $8 = 0;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $9;
  HEAP32[$0 >> 2] = $8;
  global$0 = $4 + 16 | 0;
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Immut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____next_unchecked__ha0bcc0e1b5871fcf($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $4 = 0, $2 = 0, $5 = 0, $3 = 0, $6 = 0;
  $2 = HEAP32[$1 >> 2] | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     if ($3 >>> 0 >= (HEAPU16[($4 + 138 | 0) >> 1] | 0) >>> 0) {
      break label$3
     }
     $5 = $4;
     break label$2;
    }
    label$4 : while (1) {
     $5 = HEAP32[$4 >> 2] | 0;
     if (!$5) {
      break label$1
     }
     $2 = $2 + 1 | 0;
     $3 = HEAPU16[($4 + 136 | 0) >> 1] | 0;
     $4 = $5;
     if ($3 >>> 0 >= (HEAPU16[($5 + 138 | 0) >> 1] | 0) >>> 0) {
      continue label$4
     }
     break label$4;
    };
   }
   $6 = $3 + 1 | 0;
   label$5 : {
    label$6 : {
     if ($2) {
      break label$6
     }
     $4 = $5;
     break label$5;
    }
    $4 = HEAP32[(($5 + ($6 << 2 | 0) | 0) + 448 | 0) >> 2] | 0;
    label$7 : {
     $2 = $2 + -1 | 0;
     if (!$2) {
      break label$7
     }
     label$8 : while (1) {
      $4 = HEAP32[($4 + 448 | 0) >> 2] | 0;
      $2 = $2 + -1 | 0;
      if ($2) {
       continue label$8
      }
      break label$8;
     };
    }
    $6 = 0;
   }
   HEAP32[($1 + 8 | 0) >> 2] = $6;
   HEAP32[($1 + 4 | 0) >> 2] = $4;
   HEAP32[$1 >> 2] = 0;
   HEAP32[($0 + 4 | 0) >> 2] = ($5 + Math_imul($3, 12) | 0) + 4 | 0;
   HEAP32[$0 >> 2] = ($5 + Math_imul($3, 28) | 0) + 140 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1048576 | 0, 43 | 0, 1049864 | 0);
  abort();
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Immut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____next_unchecked__hf8691ff1a1d3cd5d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $4 = 0, $2 = 0, $5 = 0, $3 = 0, $6 = 0;
  $2 = HEAP32[$1 >> 2] | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     if ($3 >>> 0 >= (HEAPU16[($4 + 138 | 0) >> 1] | 0) >>> 0) {
      break label$3
     }
     $5 = $4;
     break label$2;
    }
    label$4 : while (1) {
     $5 = HEAP32[$4 >> 2] | 0;
     if (!$5) {
      break label$1
     }
     $2 = $2 + 1 | 0;
     $3 = HEAPU16[($4 + 136 | 0) >> 1] | 0;
     $4 = $5;
     if ($3 >>> 0 >= (HEAPU16[($5 + 138 | 0) >> 1] | 0) >>> 0) {
      continue label$4
     }
     break label$4;
    };
   }
   $6 = $3 + 1 | 0;
   label$5 : {
    label$6 : {
     if ($2) {
      break label$6
     }
     $4 = $5;
     break label$5;
    }
    $4 = HEAP32[(($5 + ($6 << 2 | 0) | 0) + 448 | 0) >> 2] | 0;
    label$7 : {
     $2 = $2 + -1 | 0;
     if (!$2) {
      break label$7
     }
     label$8 : while (1) {
      $4 = HEAP32[($4 + 448 | 0) >> 2] | 0;
      $2 = $2 + -1 | 0;
      if ($2) {
       continue label$8
      }
      break label$8;
     };
    }
    $6 = 0;
   }
   HEAP32[($1 + 8 | 0) >> 2] = $6;
   HEAP32[($1 + 4 | 0) >> 2] = $4;
   HEAP32[$1 >> 2] = 0;
   HEAP32[($0 + 4 | 0) >> 2] = ($5 + Math_imul($3, 12) | 0) + 4 | 0;
   HEAP32[$0 >> 2] = ($5 + Math_imul($3, 28) | 0) + 140 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1048576 | 0, 43 | 0, 1049864 | 0);
  abort();
 }
 
 function transactioninput_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $31 = 0, $46 = 0, $51 = 0, $56 = 0, $63 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 56 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 72 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 56 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 56 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 60 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 72 | 0) >> 2] = $31;
  HEAP32[($2 + 76 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__TransactionInput__from_bytes__hd38041984775d7df($2 + 16 | 0 | 0, $2 + 72 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = $2 + 32 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 84 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $46;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2 + 40 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $51 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 92 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $51;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2 + 48 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $56 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 100 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $56;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 72 | 0) >> 2] = $1;
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $63 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 76 | 0) >> 2] = $63;
  HEAP32[($2 + 80 | 0) >> 2] = i64toi32_i32$1;
  $1 = $cardano_serialization_lib__TransactionInput_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hf06f9abbcbb78385($2 + 72 | 0 | 0) | 0;
  global$0 = $2 + 112 | 0;
  return $1 | 0;
 }
 
 function stakeregistration_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $10 = 0, $11 = 0, $12 = 0, $31 = 0, $46 = 0, $51 = 0, $64 = 0;
  $2 = global$0 - 96 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 48 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 64 | 0) >> 2] = $31;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__StakeRegistration__from_bytes__hdee97b658c0439d9($2 + 16 | 0 | 0, $2 + 64 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 16 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = $2 + 32 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 79 | 0;
  $10 = $46;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 38 | 0;
  i64toi32_i32$0 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
  i64toi32_i32$1 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
  $51 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 85 | 0;
  $11 = $51;
  HEAP8[i64toi32_i32$0 >> 0] = $11;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  HEAP8[($2 + 66 | 0) >> 0] = HEAPU8[($2 + 19 | 0) >> 0] | 0;
  HEAP16[($2 + 64 | 0) >> 1] = HEAPU8[($2 + 17 | 0) >> 0] | 0 | ((HEAPU8[($2 + 18 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 67 | 0) >> 0] = $1;
  HEAP8[($2 + 68 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 69 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 70 | 0) >> 0] = $1 >>> 24 | 0;
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $64 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  $12 = $64;
  HEAP8[($2 + 71 | 0) >> 0] = $12;
  HEAP8[($2 + 72 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[($2 + 73 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[($2 + 74 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[($2 + 75 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[($2 + 76 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[($2 + 77 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[($2 + 78 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $1 = $cardano_serialization_lib__StakeRegistration_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he3fe45f8c534c1bd($2 + 64 | 0 | 0) | 0;
  global$0 = $2 + 96 | 0;
  return $1 | 0;
 }
 
 function stakederegistration_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $10 = 0, $11 = 0, $12 = 0, $31 = 0, $46 = 0, $51 = 0, $64 = 0;
  $2 = global$0 - 96 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 48 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 64 | 0) >> 2] = $31;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__StakeDeregistration__from_bytes__ha9403776c649dbb2($2 + 16 | 0 | 0, $2 + 64 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 16 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = $2 + 32 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 79 | 0;
  $10 = $46;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 38 | 0;
  i64toi32_i32$0 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
  i64toi32_i32$1 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
  $51 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 85 | 0;
  $11 = $51;
  HEAP8[i64toi32_i32$0 >> 0] = $11;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  HEAP8[($2 + 66 | 0) >> 0] = HEAPU8[($2 + 19 | 0) >> 0] | 0;
  HEAP16[($2 + 64 | 0) >> 1] = HEAPU8[($2 + 17 | 0) >> 0] | 0 | ((HEAPU8[($2 + 18 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 67 | 0) >> 0] = $1;
  HEAP8[($2 + 68 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 69 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 70 | 0) >> 0] = $1 >>> 24 | 0;
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $64 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  $12 = $64;
  HEAP8[($2 + 71 | 0) >> 0] = $12;
  HEAP8[($2 + 72 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[($2 + 73 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[($2 + 74 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[($2 + 75 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[($2 + 76 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[($2 + 77 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[($2 + 78 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $1 = $cardano_serialization_lib__StakeDeregistration_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hb69c7c50974f5b70($2 + 64 | 0 | 0) | 0;
  global$0 = $2 + 96 | 0;
  return $1 | 0;
 }
 
 function scriptpubkey_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $10 = 0, $11 = 0, $12 = 0, $31 = 0, $46 = 0, $51 = 0, $64 = 0;
  $2 = global$0 - 96 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 48 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 64 | 0) >> 2] = $31;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__ScriptPubkey__from_bytes__h5b8c574da64e96b5($2 + 16 | 0 | 0, $2 + 64 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 16 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = $2 + 32 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 79 | 0;
  $10 = $46;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 37 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $51 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 84 | 0;
  $11 = $51;
  HEAP8[i64toi32_i32$0 >> 0] = $11;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  HEAP8[($2 + 66 | 0) >> 0] = HEAPU8[($2 + 19 | 0) >> 0] | 0;
  HEAP16[($2 + 64 | 0) >> 1] = HEAPU8[($2 + 17 | 0) >> 0] | 0 | ((HEAPU8[($2 + 18 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 67 | 0) >> 0] = $1;
  HEAP8[($2 + 68 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 69 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 70 | 0) >> 0] = $1 >>> 24 | 0;
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $64 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  $12 = $64;
  HEAP8[($2 + 71 | 0) >> 0] = $12;
  HEAP8[($2 + 72 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[($2 + 73 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[($2 + 74 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[($2 + 75 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[($2 + 76 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[($2 + 77 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[($2 + 78 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $1 = $cardano_serialization_lib__ScriptPubkey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he4b2ddfdd7790cb9($2 + 64 | 0 | 0) | 0;
  global$0 = $2 + 96 | 0;
  return $1 | 0;
 }
 
 function nativescript_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $31 = 0, $46 = 0, $53 = 0, $58 = 0, $63 = 0;
  $2 = global$0 - 96 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 48 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  $1 = ($2 + 64 | 0) + 8 | 0;
  HEAP32[$1 >> 2] = HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 64 | 0) >> 2] = $31;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__NativeScript__from_bytes__h15f2e6a3280a33fe($2 + 8 | 0 | 0, $2 + 64 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
   abort();
  }
  i64toi32_i32$2 = $2 + 40 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = ($2 + 64 | 0) + 24 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $46;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = ($2 + 8 | 0) + 24 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $53 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 64 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $53;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = ($2 + 8 | 0) + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $58 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[i64toi32_i32$1 >> 2] = $58;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = ($2 + 8 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $63 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 64 | 0) >> 2] = $63;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$1;
  $1 = $cardano_serialization_lib__NativeScript_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h345d8ecbe77ecc63($2 + 64 | 0 | 0) | 0;
  global$0 = $2 + 96 | 0;
  return $1 | 0;
 }
 
 function metadatamap_insert($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, $5 = 0, $6 = 0;
  $3 = global$0 - 128 | 0;
  global$0 = $3;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h1305d160e0e385a5($3 + 24 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $4 = HEAP32[($3 + 28 | 0) >> 2] | 0;
   $5 = HEAP32[($3 + 24 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hc630c86c4ab6b26d($3 + 16 | 0 | 0, $1 | 0);
   if (!$2) {
    break label$1
   }
   $0 = HEAP32[($3 + 20 | 0) >> 2] | 0;
   $6 = HEAP32[($3 + 16 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hc630c86c4ab6b26d($3 + 8 | 0 | 0, $2 | 0);
   $1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
   cardano_serialization_lib__metadata__MetadataMap__insert__hd93cf89dc2674a42($3 + 32 | 0 | 0, $5 | 0, $6 | 0, HEAP32[($3 + 8 | 0) >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   $0 = 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($4 | 0, 0 | 0) | 0;
   label$2 : {
    $1 = HEAP32[($3 + 32 | 0) >> 2] | 0;
    if (($1 | 0) == (5 | 0)) {
     break label$2
    }
    HEAP32[($3 + 80 | 0) >> 2] = $1;
    memcpy($3 + 80 | 0 | 4 | 0 | 0, $3 + 32 | 0 | 4 | 0 | 0, 44 | 0) | 0;
    $0 = $cardano_serialization_lib__metadata__TransactionMetadatum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hce2feba55b67d086($3 + 80 | 0 | 0) | 0;
   }
   global$0 = $3 + 128 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function generaltransactionmetadata_insert($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, $5 = 0, $6 = 0;
  $3 = global$0 - 128 | 0;
  global$0 = $3;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h4b93f864eaa742c0($3 + 24 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $4 = HEAP32[($3 + 28 | 0) >> 2] | 0;
   $5 = HEAP32[($3 + 24 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($3 + 16 | 0 | 0, $1 | 0);
   if (!$2) {
    break label$1
   }
   $0 = HEAP32[($3 + 20 | 0) >> 2] | 0;
   $6 = HEAP32[($3 + 16 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hc630c86c4ab6b26d($3 + 8 | 0 | 0, $2 | 0);
   $1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
   cardano_serialization_lib__metadata__GeneralTransactionMetadata__insert__h12cd6f278bd1aa86($3 + 32 | 0 | 0, $5 | 0, $6 | 0, HEAP32[($3 + 8 | 0) >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   $0 = 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($4 | 0, 0 | 0) | 0;
   label$2 : {
    $1 = HEAP32[($3 + 32 | 0) >> 2] | 0;
    if (($1 | 0) == (5 | 0)) {
     break label$2
    }
    HEAP32[($3 + 80 | 0) >> 2] = $1;
    memcpy($3 + 80 | 0 | 4 | 0 | 0, $3 + 32 | 0 | 4 | 0 | 0, 44 | 0) | 0;
    $0 = $cardano_serialization_lib__metadata__TransactionMetadatum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hce2feba55b67d086($3 + 80 | 0 | 0) | 0;
   }
   global$0 = $3 + 128 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function core__ptr__drop_in_place_cardano_serialization_lib__plutus__PlutusData___hfab843e66e0f9428($0) {
  $0 = $0 | 0;
  var $1 = 0, $3 = 0, $2 = 0;
  label$1 : {
   label$2 : {
    switch (HEAP32[$0 >> 2] | 0 | 0) {
    default:
     $1 = $0 + 4 | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
     break label$1;
    case 0:
     $2 = $0 + 16 | 0;
     label$7 : {
      $3 = HEAP32[($0 + 24 | 0) >> 2] | 0;
      if (!$3) {
       break label$7
      }
      $1 = HEAP32[$2 >> 2] | 0;
      $3 = Math_imul($3, 48);
      label$8 : while (1) {
       core__ptr__drop_in_place_cardano_serialization_lib__plutus__PlutusData___hfab843e66e0f9428_2($1 | 0);
       $1 = $1 + 48 | 0;
       $3 = $3 + -48 | 0;
       if ($3) {
        continue label$8
       }
       break label$8;
      };
     }
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h36e817e704f6f25e($2 | 0);
     break label$1;
    case 1:
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h50a5c5eb0f530455($0 + 4 | 0 | 0);
     break label$1;
    case 2:
     $2 = $0 + 4 | 0;
     label$9 : {
      $3 = HEAP32[($0 + 12 | 0) >> 2] | 0;
      if (!$3) {
       break label$9
      }
      $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
      $3 = Math_imul($3, 48);
      label$10 : while (1) {
       core__ptr__drop_in_place_cardano_serialization_lib__plutus__PlutusData___hfab843e66e0f9428_2($1 | 0);
       $1 = $1 + 48 | 0;
       $3 = $3 + -48 | 0;
       if ($3) {
        continue label$10
       }
       break label$10;
      };
     }
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h36e817e704f6f25e($2 | 0);
     break label$1;
    case 3:
     break label$2;
    };
   }
   $1 = $0 + 4 | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h19f76bdb6b4883ef($1 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h970b13f6299e0f2d($1 | 0);
  }
  label$11 : {
   if (!(HEAP32[($0 + 32 | 0) >> 2] | 0)) {
    break label$11
   }
   $1 = $0 + 32 | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  }
 }
 
 function ed25519keyhash_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $10 = 0, $11 = 0, $12 = 0, $31 = 0, $46 = 0, $51 = 0, $64 = 0;
  $2 = global$0 - 96 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 48 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 64 | 0) >> 2] = $31;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__crypto__Ed25519KeyHash__from_bytes__hd3490b826cff55ec($2 + 16 | 0 | 0, $2 + 64 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 16 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = $2 + 32 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 79 | 0;
  $10 = $46;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 37 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $51 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 84 | 0;
  $11 = $51;
  HEAP8[i64toi32_i32$0 >> 0] = $11;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  HEAP8[($2 + 66 | 0) >> 0] = HEAPU8[($2 + 19 | 0) >> 0] | 0;
  HEAP16[($2 + 64 | 0) >> 1] = HEAPU8[($2 + 17 | 0) >> 0] | 0 | ((HEAPU8[($2 + 18 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 67 | 0) >> 0] = $1;
  HEAP8[($2 + 68 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 69 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 70 | 0) >> 0] = $1 >>> 24 | 0;
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $64 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  $12 = $64;
  HEAP8[($2 + 71 | 0) >> 0] = $12;
  HEAP8[($2 + 72 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[($2 + 73 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[($2 + 74 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[($2 + 75 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[($2 + 76 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[($2 + 77 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[($2 + 78 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $1 = $cardano_serialization_lib__crypto__Ed25519KeyHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hd63cf82b6a769066($2 + 64 | 0 | 0) | 0;
  global$0 = $2 + 96 | 0;
  return $1 | 0;
 }
 
 function scripthash_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $10 = 0, $11 = 0, $12 = 0, $31 = 0, $46 = 0, $51 = 0, $64 = 0;
  $2 = global$0 - 96 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 48 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 64 | 0) >> 2] = $31;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__crypto__ScriptHash__from_bytes__heb261e3c2077a8e6($2 + 16 | 0 | 0, $2 + 64 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 16 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = $2 + 32 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 79 | 0;
  $10 = $46;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 37 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $51 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 84 | 0;
  $11 = $51;
  HEAP8[i64toi32_i32$0 >> 0] = $11;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  HEAP8[($2 + 66 | 0) >> 0] = HEAPU8[($2 + 19 | 0) >> 0] | 0;
  HEAP16[($2 + 64 | 0) >> 1] = HEAPU8[($2 + 17 | 0) >> 0] | 0 | ((HEAPU8[($2 + 18 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 67 | 0) >> 0] = $1;
  HEAP8[($2 + 68 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 69 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 70 | 0) >> 0] = $1 >>> 24 | 0;
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $64 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  $12 = $64;
  HEAP8[($2 + 71 | 0) >> 0] = $12;
  HEAP8[($2 + 72 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[($2 + 73 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[($2 + 74 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[($2 + 75 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[($2 + 76 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[($2 + 77 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[($2 + 78 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $1 = $cardano_serialization_lib__crypto__ScriptHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hcd9bcfbb1bcf9de7($2 + 64 | 0 | 0) | 0;
  global$0 = $2 + 96 | 0;
  return $1 | 0;
 }
 
 function genesisdelegatehash_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $10 = 0, $11 = 0, $12 = 0, $31 = 0, $46 = 0, $51 = 0, $64 = 0;
  $2 = global$0 - 96 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 48 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 64 | 0) >> 2] = $31;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__crypto__GenesisDelegateHash__from_bytes__hc6d86e4470d3551a($2 + 16 | 0 | 0, $2 + 64 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 16 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = $2 + 32 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 79 | 0;
  $10 = $46;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 37 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $51 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 84 | 0;
  $11 = $51;
  HEAP8[i64toi32_i32$0 >> 0] = $11;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  HEAP8[($2 + 66 | 0) >> 0] = HEAPU8[($2 + 19 | 0) >> 0] | 0;
  HEAP16[($2 + 64 | 0) >> 1] = HEAPU8[($2 + 17 | 0) >> 0] | 0 | ((HEAPU8[($2 + 18 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 67 | 0) >> 0] = $1;
  HEAP8[($2 + 68 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 69 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 70 | 0) >> 0] = $1 >>> 24 | 0;
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $64 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  $12 = $64;
  HEAP8[($2 + 71 | 0) >> 0] = $12;
  HEAP8[($2 + 72 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[($2 + 73 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[($2 + 74 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[($2 + 75 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[($2 + 76 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[($2 + 77 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[($2 + 78 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $1 = $cardano_serialization_lib__crypto__GenesisDelegateHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h829122a765b38e99($2 + 64 | 0 | 0) | 0;
  global$0 = $2 + 96 | 0;
  return $1 | 0;
 }
 
 function genesishash_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $10 = 0, $11 = 0, $12 = 0, $31 = 0, $46 = 0, $51 = 0, $64 = 0;
  $2 = global$0 - 96 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 48 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 64 | 0) >> 2] = $31;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__crypto__GenesisHash__from_bytes__he8377b8a376c1d46($2 + 16 | 0 | 0, $2 + 64 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 16 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = $2 + 32 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 79 | 0;
  $10 = $46;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 37 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $51 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 84 | 0;
  $11 = $51;
  HEAP8[i64toi32_i32$0 >> 0] = $11;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  HEAP8[($2 + 66 | 0) >> 0] = HEAPU8[($2 + 19 | 0) >> 0] | 0;
  HEAP16[($2 + 64 | 0) >> 1] = HEAPU8[($2 + 17 | 0) >> 0] | 0 | ((HEAPU8[($2 + 18 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 67 | 0) >> 0] = $1;
  HEAP8[($2 + 68 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 69 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 70 | 0) >> 0] = $1 >>> 24 | 0;
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $64 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  $12 = $64;
  HEAP8[($2 + 71 | 0) >> 0] = $12;
  HEAP8[($2 + 72 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[($2 + 73 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[($2 + 74 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[($2 + 75 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[($2 + 76 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[($2 + 77 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[($2 + 78 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $1 = $cardano_serialization_lib__crypto__GenesisHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hedc49afed5ec6de0($2 + 64 | 0 | 0) | 0;
  global$0 = $2 + 96 | 0;
  return $1 | 0;
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___entry__hb3ca8cc1c7c6c8c7($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $4 = 0, $3 = 0, $5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $32 = 0, $52 = 0;
  $3 = global$0 - 64 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$4) {
     break label$2
    }
    $5 = HEAP32[$1 >> 2] | 0;
    break label$1;
   }
   $5 = 0;
   $4 = alloc__boxed__Box_T_2cA___new_uninit_in__h1d1537549f7a0074() | 0;
   HEAP16[($4 + 1458 | 0) >> 1] = 0;
   HEAP32[($4 + 1056 | 0) >> 2] = 0;
   HEAP32[($1 + 4 | 0) >> 2] = $4;
   HEAP32[$1 >> 2] = 0;
  }
  alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__h0e9ccb4dfb3c7779($3 | 0, $5 | 0, $4 | 0, $2 | 0);
  $5 = 1;
  $4 = $3 | 4 | 0;
  label$3 : {
   label$4 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
     break label$4
    }
    i64toi32_i32$0 = HEAP32[$4 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
    $32 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[($0 + 4 | 0) >> 2] = $32;
    HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($0 + 16 | 0) >> 2] = $1;
    HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($4 + 8 | 0) >> 2] | 0;
    break label$3;
   }
   memcpy($3 + 16 | 0 | 0, $2 | 0, 36 | 0) | 0;
   HEAP32[($3 + 60 | 0) >> 2] = HEAP32[($4 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   $52 = i64toi32_i32$1;
   i64toi32_i32$1 = $3;
   HEAP32[($3 + 52 | 0) >> 2] = $52;
   HEAP32[($3 + 56 | 0) >> 2] = i64toi32_i32$0;
   memcpy($0 + 4 | 0 | 0, $3 + 16 | 0 | 0, 48 | 0) | 0;
   HEAP32[($0 + 52 | 0) >> 2] = $1;
   $5 = 0;
  }
  HEAP32[$0 >> 2] = $5;
  global$0 = $3 + 64 | 0;
 }
 
 function stakecredential_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $10 = 0, $11 = 0, $12 = 0, $31 = 0, $46 = 0, $51 = 0, $64 = 0;
  $2 = global$0 - 96 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 48 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 64 | 0) >> 2] = $31;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__address__StakeCredential__from_bytes__h502bac6f177f7d17($2 + 16 | 0 | 0, $2 + 64 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 16 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = $2 + 32 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 79 | 0;
  $10 = $46;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 38 | 0;
  i64toi32_i32$0 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
  i64toi32_i32$1 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
  $51 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 85 | 0;
  $11 = $51;
  HEAP8[i64toi32_i32$0 >> 0] = $11;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  HEAP8[($2 + 66 | 0) >> 0] = HEAPU8[($2 + 19 | 0) >> 0] | 0;
  HEAP16[($2 + 64 | 0) >> 1] = HEAPU8[($2 + 17 | 0) >> 0] | 0 | ((HEAPU8[($2 + 18 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 67 | 0) >> 0] = $1;
  HEAP8[($2 + 68 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 69 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 70 | 0) >> 0] = $1 >>> 24 | 0;
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $64 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  $12 = $64;
  HEAP8[($2 + 71 | 0) >> 0] = $12;
  HEAP8[($2 + 72 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[($2 + 73 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[($2 + 74 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[($2 + 75 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[($2 + 76 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[($2 + 77 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[($2 + 78 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $1 = $cardano_serialization_lib__address__StakeCredential_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hfe6826a4b7739a89($2 + 64 | 0 | 0) | 0;
  global$0 = $2 + 96 | 0;
  return $1 | 0;
 }
 
 function core__ptr__drop_in_place_cardano_serialization_lib__plutus__PlutusData___hfab843e66e0f9428_1($0) {
  $0 = $0 | 0;
  var $1 = 0, $3 = 0, $2 = 0;
  label$1 : {
   label$2 : {
    switch (HEAP32[$0 >> 2] | 0 | 0) {
    default:
     $1 = $0 + 4 | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
     break label$1;
    case 0:
     $2 = $0 + 16 | 0;
     label$7 : {
      $3 = HEAP32[($0 + 24 | 0) >> 2] | 0;
      if (!$3) {
       break label$7
      }
      $1 = HEAP32[$2 >> 2] | 0;
      $3 = Math_imul($3, 48);
      label$8 : while (1) {
       core__ptr__drop_in_place_cardano_serialization_lib__plutus__PlutusData___hfab843e66e0f9428_2($1 | 0);
       $1 = $1 + 48 | 0;
       $3 = $3 + -48 | 0;
       if ($3) {
        continue label$8
       }
       break label$8;
      };
     }
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h36e817e704f6f25e($2 | 0);
     break label$1;
    case 1:
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h50a5c5eb0f530455($0 + 4 | 0 | 0);
     break label$1;
    case 2:
     $2 = $0 + 4 | 0;
     label$9 : {
      $3 = HEAP32[($0 + 12 | 0) >> 2] | 0;
      if (!$3) {
       break label$9
      }
      $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
      $3 = Math_imul($3, 48);
      label$10 : while (1) {
       core__ptr__drop_in_place_cardano_serialization_lib__plutus__PlutusData___hfab843e66e0f9428_2($1 | 0);
       $1 = $1 + 48 | 0;
       $3 = $3 + -48 | 0;
       if ($3) {
        continue label$10
       }
       break label$10;
      };
     }
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h36e817e704f6f25e($2 | 0);
     break label$1;
    case 3:
     break label$2;
    };
   }
   $1 = $0 + 4 | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h19f76bdb6b4883ef($1 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h970b13f6299e0f2d($1 | 0);
  }
  label$11 : {
   if (!(HEAP32[($0 + 32 | 0) >> 2] | 0)) {
    break label$11
   }
   $1 = $0 + 32 | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  }
 }
 
 function exunitprices_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $31 = 0, $46 = 0, $53 = 0, $58 = 0, $63 = 0;
  $2 = global$0 - 96 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 48 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  $1 = ($2 + 64 | 0) + 8 | 0;
  HEAP32[$1 >> 2] = HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 64 | 0) >> 2] = $31;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__plutus__ExUnitPrices__from_bytes__hee8eeb87c565067d($2 + 8 | 0 | 0, $2 + 64 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
   abort();
  }
  i64toi32_i32$2 = $2 + 40 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = ($2 + 64 | 0) + 24 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $46;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = ($2 + 8 | 0) + 24 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $53 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 64 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $53;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = ($2 + 8 | 0) + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $58 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[i64toi32_i32$1 >> 2] = $58;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = ($2 + 8 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $63 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 64 | 0) >> 2] = $63;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$1;
  $1 = $cardano_serialization_lib__plutus__ExUnitPrices_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hb3338508b1a9ae00($2 + 64 | 0 | 0) | 0;
  global$0 = $2 + 96 | 0;
  return $1 | 0;
 }
 
 function plutusmap_insert($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, $5 = 0, $6 = 0;
  $3 = global$0 - 128 | 0;
  global$0 = $3;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h7a45263e953750b2($3 + 24 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $4 = HEAP32[($3 + 28 | 0) >> 2] | 0;
   $5 = HEAP32[($3 + 24 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb1fd14a6870cafe2($3 + 16 | 0 | 0, $1 | 0);
   if (!$2) {
    break label$1
   }
   $0 = HEAP32[($3 + 20 | 0) >> 2] | 0;
   $6 = HEAP32[($3 + 16 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb1fd14a6870cafe2($3 + 8 | 0 | 0, $2 | 0);
   $1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
   cardano_serialization_lib__plutus__PlutusMap__insert__h48ea63e22ae70233($3 + 32 | 0 | 0, $5 | 0, $6 | 0, HEAP32[($3 + 8 | 0) >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   $0 = 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($4 | 0, 0 | 0) | 0;
   label$2 : {
    $1 = HEAP32[($3 + 32 | 0) >> 2] | 0;
    if (($1 | 0) == (5 | 0)) {
     break label$2
    }
    HEAP32[($3 + 80 | 0) >> 2] = $1;
    memcpy($3 + 80 | 0 | 4 | 0 | 0, $3 + 32 | 0 | 4 | 0 | 0, 44 | 0) | 0;
    $0 = $cardano_serialization_lib__plutus__PlutusData_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h7393378a3318e0a5($3 + 80 | 0 | 0) | 0;
   }
   global$0 = $3 + 128 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function core__iter__adapters__process_results__h19ecc9ffa7017f7f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$3 = 0, $17 = 0, $19 = 0, $5 = 0, $5$hi = 0, $3 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $18 = 0, $35 = 0, $4 = 0, $49 = 0, $53 = 0, $57 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  HEAP8[($2 + 8 | 0) >> 0] = 7;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 36 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 44 | 0) >> 2] = i64toi32_i32$0 + 8 | 0;
  $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__hec0e106e73790eaa(i64toi32_i32$0 + 16 | 0 | 0, i64toi32_i32$0 + 32 | 0 | 0);
  label$1 : {
   label$2 : {
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] | 0;
    $5 = i64toi32_i32$1;
    $5$hi = i64toi32_i32$0;
    $1 = i64toi32_i32$1;
    if ((i64toi32_i32$1 & 255 | 0 | 0) != (7 | 0)) {
     break label$2
    }
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
    $35 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $35;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = HEAP32[((i64toi32_i32$2 + 16 | 0) + 8 | 0) >> 2] | 0;
    $1 = 0;
    break label$1;
   }
   $3 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 16 | 0) >> 2] | 0;
   HEAP8[($0 + 4 | 0) >> 0] = $1;
   $49 = $0 + 11 | 0;
   i64toi32_i32$1 = $5$hi;
   i64toi32_i32$2 = $5;
   i64toi32_i32$0 = 0;
   i64toi32_i32$3 = 56;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$0 = 0;
    $20 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   } else {
    i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
    $20 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
   }
   HEAP8[$49 >> 0] = $20;
   $53 = $0 + 9 | 0;
   i64toi32_i32$0 = $5$hi;
   i64toi32_i32$1 = $5;
   i64toi32_i32$2 = 0;
   i64toi32_i32$3 = 40;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$2 = 0;
    $21 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   } else {
    i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
    $21 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
   }
   $22 = $53;
   $23 = $21;
   HEAP8[$22 >> 0] = $23;
   HEAP8[($22 + 1 | 0) >> 0] = $23 >>> 8 | 0;
   $57 = $0 + 5 | 0;
   i64toi32_i32$2 = $5$hi;
   i64toi32_i32$0 = $5;
   i64toi32_i32$1 = 0;
   i64toi32_i32$3 = 8;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$1 = 0;
    $24 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   } else {
    i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
    $24 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
   }
   $17 = $57;
   $19 = $24;
   HEAP8[$17 >> 0] = $19;
   HEAP8[($17 + 1 | 0) >> 0] = $19 >>> 8 | 0;
   HEAP8[($17 + 2 | 0) >> 0] = $19 >>> 16 | 0;
   HEAP8[($17 + 3 | 0) >> 0] = $19 >>> 24 | 0;
   $1 = 1;
   if (!$3) {
    break label$1
   }
   __rust_dealloc($4 | 0, $3 | 0, 1 | 0);
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 48 | 0;
 }
 
 function stakeregistration_stake_credential($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $2 = 0, $5 = 0, $6 = 0, $3 = 0, $7 = 0, $7$hi = 0, $4 = 0, $8 = 0, $8$hi = 0, $35 = 0, $55 = 0, $60 = 0, $70 = 0;
  $1 = global$0 - 112 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h9f3eeaa31aede5c7($1 + 8 | 0 | 0, $0 | 0);
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $18 = $0 + 25 | 0;
  $3 = HEAPU8[$18 >> 0] | 0 | ((HEAPU8[($18 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($18 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($18 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $0 + 17 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  $4 = HEAPU8[$0 >> 0] | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $8 = i64toi32_i32$1;
  $8$hi = i64toi32_i32$0;
  $5 = $1 + 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 9 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $35 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[i64toi32_i32$0 >> 2] = $35;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $0 = $1 + 32 | 0;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $6 = $1 + 40 | 0;
  HEAP32[$6 >> 2] = $3;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = $1;
  HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$1;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $55 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 80 | 0) + 9 | 0;
  $19 = $55;
  HEAP8[i64toi32_i32$1 >> 0] = $19;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $19 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $19 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $19 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $60 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 80 | 0) + 17 | 0;
  $20 = $60;
  HEAP8[i64toi32_i32$0 >> 0] = $20;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $20 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $20 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $20 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $21 = ($1 + 80 | 0) + 25 | 0;
  $22 = HEAP32[$6 >> 2] | 0;
  HEAP8[$21 >> 0] = $22;
  HEAP8[($21 + 1 | 0) >> 0] = $22 >>> 8 | 0;
  HEAP8[($21 + 2 | 0) >> 0] = $22 >>> 16 | 0;
  HEAP8[($21 + 3 | 0) >> 0] = $22 >>> 24 | 0;
  HEAP8[($1 + 80 | 0) >> 0] = $4;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $70 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  $23 = $70;
  HEAP8[(i64toi32_i32$2 + 81 | 0) >> 0] = $23;
  HEAP8[(i64toi32_i32$2 + 82 | 0) >> 0] = $23 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 83 | 0) >> 0] = $23 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 84 | 0) >> 0] = $23 >>> 24 | 0;
  HEAP8[(i64toi32_i32$2 + 85 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$2 + 86 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 87 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 88 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $0 = $cardano_serialization_lib__address__StakeCredential_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hfe6826a4b7739a89(i64toi32_i32$2 + 80 | 0 | 0) | 0;
  global$0 = i64toi32_i32$2 + 112 | 0;
  return $0 | 0;
 }
 
 function stakeregistration_new($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $2 = 0, $5 = 0, $6 = 0, $3 = 0, $7 = 0, $7$hi = 0, $4 = 0, $8 = 0, $8$hi = 0, $35 = 0, $55 = 0, $60 = 0, $70 = 0;
  $1 = global$0 - 112 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h7d8a0640f2deb41e($1 + 8 | 0 | 0, $0 | 0);
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $18 = $0 + 25 | 0;
  $3 = HEAPU8[$18 >> 0] | 0 | ((HEAPU8[($18 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($18 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($18 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $0 + 17 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  $4 = HEAPU8[$0 >> 0] | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $8 = i64toi32_i32$1;
  $8$hi = i64toi32_i32$0;
  $5 = $1 + 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 9 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $35 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[i64toi32_i32$0 >> 2] = $35;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $0 = $1 + 32 | 0;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $6 = $1 + 40 | 0;
  HEAP32[$6 >> 2] = $3;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = $1;
  HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$1;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $55 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 48 | 0) + 9 | 0;
  $19 = $55;
  HEAP8[i64toi32_i32$1 >> 0] = $19;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $19 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $19 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $19 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $60 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 48 | 0) + 17 | 0;
  $20 = $60;
  HEAP8[i64toi32_i32$0 >> 0] = $20;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $20 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $20 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $20 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $21 = ($1 + 48 | 0) + 25 | 0;
  $22 = HEAP32[$6 >> 2] | 0;
  HEAP8[$21 >> 0] = $22;
  HEAP8[($21 + 1 | 0) >> 0] = $22 >>> 8 | 0;
  HEAP8[($21 + 2 | 0) >> 0] = $22 >>> 16 | 0;
  HEAP8[($21 + 3 | 0) >> 0] = $22 >>> 24 | 0;
  HEAP8[($1 + 48 | 0) >> 0] = $4;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $70 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  $23 = $70;
  HEAP8[(i64toi32_i32$2 + 49 | 0) >> 0] = $23;
  HEAP8[(i64toi32_i32$2 + 50 | 0) >> 0] = $23 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 51 | 0) >> 0] = $23 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 52 | 0) >> 0] = $23 >>> 24 | 0;
  HEAP8[(i64toi32_i32$2 + 53 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$2 + 54 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 55 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 56 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $0 = $cardano_serialization_lib__StakeRegistration_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he3fe45f8c534c1bd(i64toi32_i32$2 + 48 | 0 | 0) | 0;
  global$0 = i64toi32_i32$2 + 112 | 0;
  return $0 | 0;
 }
 
 function stakederegistration_stake_credential($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $2 = 0, $5 = 0, $6 = 0, $3 = 0, $7 = 0, $7$hi = 0, $4 = 0, $8 = 0, $8$hi = 0, $35 = 0, $55 = 0, $60 = 0, $70 = 0;
  $1 = global$0 - 112 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h415aed7c06a10866($1 + 8 | 0 | 0, $0 | 0);
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $18 = $0 + 25 | 0;
  $3 = HEAPU8[$18 >> 0] | 0 | ((HEAPU8[($18 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($18 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($18 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $0 + 17 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  $4 = HEAPU8[$0 >> 0] | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $8 = i64toi32_i32$1;
  $8$hi = i64toi32_i32$0;
  $5 = $1 + 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 9 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $35 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[i64toi32_i32$0 >> 2] = $35;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $0 = $1 + 32 | 0;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $6 = $1 + 40 | 0;
  HEAP32[$6 >> 2] = $3;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = $1;
  HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$1;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $55 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 80 | 0) + 9 | 0;
  $19 = $55;
  HEAP8[i64toi32_i32$1 >> 0] = $19;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $19 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $19 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $19 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $60 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 80 | 0) + 17 | 0;
  $20 = $60;
  HEAP8[i64toi32_i32$0 >> 0] = $20;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $20 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $20 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $20 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $21 = ($1 + 80 | 0) + 25 | 0;
  $22 = HEAP32[$6 >> 2] | 0;
  HEAP8[$21 >> 0] = $22;
  HEAP8[($21 + 1 | 0) >> 0] = $22 >>> 8 | 0;
  HEAP8[($21 + 2 | 0) >> 0] = $22 >>> 16 | 0;
  HEAP8[($21 + 3 | 0) >> 0] = $22 >>> 24 | 0;
  HEAP8[($1 + 80 | 0) >> 0] = $4;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $70 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  $23 = $70;
  HEAP8[(i64toi32_i32$2 + 81 | 0) >> 0] = $23;
  HEAP8[(i64toi32_i32$2 + 82 | 0) >> 0] = $23 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 83 | 0) >> 0] = $23 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 84 | 0) >> 0] = $23 >>> 24 | 0;
  HEAP8[(i64toi32_i32$2 + 85 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$2 + 86 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 87 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 88 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $0 = $cardano_serialization_lib__address__StakeCredential_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hfe6826a4b7739a89(i64toi32_i32$2 + 80 | 0 | 0) | 0;
  global$0 = i64toi32_i32$2 + 112 | 0;
  return $0 | 0;
 }
 
 function stakederegistration_new($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $2 = 0, $5 = 0, $6 = 0, $3 = 0, $7 = 0, $7$hi = 0, $4 = 0, $8 = 0, $8$hi = 0, $35 = 0, $55 = 0, $60 = 0, $70 = 0;
  $1 = global$0 - 112 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h7d8a0640f2deb41e($1 + 8 | 0 | 0, $0 | 0);
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $18 = $0 + 25 | 0;
  $3 = HEAPU8[$18 >> 0] | 0 | ((HEAPU8[($18 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($18 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($18 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $0 + 17 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  $4 = HEAPU8[$0 >> 0] | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $8 = i64toi32_i32$1;
  $8$hi = i64toi32_i32$0;
  $5 = $1 + 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 9 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $35 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[i64toi32_i32$0 >> 2] = $35;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $0 = $1 + 32 | 0;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $6 = $1 + 40 | 0;
  HEAP32[$6 >> 2] = $3;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = $1;
  HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$1;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $55 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 48 | 0) + 9 | 0;
  $19 = $55;
  HEAP8[i64toi32_i32$1 >> 0] = $19;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $19 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $19 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $19 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $60 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 48 | 0) + 17 | 0;
  $20 = $60;
  HEAP8[i64toi32_i32$0 >> 0] = $20;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $20 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $20 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $20 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $21 = ($1 + 48 | 0) + 25 | 0;
  $22 = HEAP32[$6 >> 2] | 0;
  HEAP8[$21 >> 0] = $22;
  HEAP8[($21 + 1 | 0) >> 0] = $22 >>> 8 | 0;
  HEAP8[($21 + 2 | 0) >> 0] = $22 >>> 16 | 0;
  HEAP8[($21 + 3 | 0) >> 0] = $22 >>> 24 | 0;
  HEAP8[($1 + 48 | 0) >> 0] = $4;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $70 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  $23 = $70;
  HEAP8[(i64toi32_i32$2 + 49 | 0) >> 0] = $23;
  HEAP8[(i64toi32_i32$2 + 50 | 0) >> 0] = $23 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 51 | 0) >> 0] = $23 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 52 | 0) >> 0] = $23 >>> 24 | 0;
  HEAP8[(i64toi32_i32$2 + 53 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$2 + 54 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 55 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 56 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $0 = $cardano_serialization_lib__StakeDeregistration_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hb69c7c50974f5b70(i64toi32_i32$2 + 48 | 0 | 0) | 0;
  global$0 = i64toi32_i32$2 + 112 | 0;
  return $0 | 0;
 }
 
 function stakedelegation_stake_credential($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $2 = 0, $5 = 0, $6 = 0, $3 = 0, $7 = 0, $7$hi = 0, $4 = 0, $8 = 0, $8$hi = 0, $35 = 0, $55 = 0, $60 = 0, $70 = 0;
  $1 = global$0 - 112 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hfc784c950a3a2da2($1 + 8 | 0 | 0, $0 | 0);
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $18 = $0 + 25 | 0;
  $3 = HEAPU8[$18 >> 0] | 0 | ((HEAPU8[($18 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($18 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($18 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $0 + 17 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  $4 = HEAPU8[$0 >> 0] | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $8 = i64toi32_i32$1;
  $8$hi = i64toi32_i32$0;
  $5 = $1 + 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 9 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $35 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[i64toi32_i32$0 >> 2] = $35;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $0 = $1 + 32 | 0;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $6 = $1 + 40 | 0;
  HEAP32[$6 >> 2] = $3;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = $1;
  HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$1;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $55 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 80 | 0) + 9 | 0;
  $19 = $55;
  HEAP8[i64toi32_i32$1 >> 0] = $19;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $19 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $19 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $19 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $60 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 80 | 0) + 17 | 0;
  $20 = $60;
  HEAP8[i64toi32_i32$0 >> 0] = $20;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $20 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $20 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $20 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $21 = ($1 + 80 | 0) + 25 | 0;
  $22 = HEAP32[$6 >> 2] | 0;
  HEAP8[$21 >> 0] = $22;
  HEAP8[($21 + 1 | 0) >> 0] = $22 >>> 8 | 0;
  HEAP8[($21 + 2 | 0) >> 0] = $22 >>> 16 | 0;
  HEAP8[($21 + 3 | 0) >> 0] = $22 >>> 24 | 0;
  HEAP8[($1 + 80 | 0) >> 0] = $4;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $70 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  $23 = $70;
  HEAP8[(i64toi32_i32$2 + 81 | 0) >> 0] = $23;
  HEAP8[(i64toi32_i32$2 + 82 | 0) >> 0] = $23 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 83 | 0) >> 0] = $23 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 84 | 0) >> 0] = $23 >>> 24 | 0;
  HEAP8[(i64toi32_i32$2 + 85 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$2 + 86 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 87 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 88 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $0 = $cardano_serialization_lib__address__StakeCredential_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hfe6826a4b7739a89(i64toi32_i32$2 + 80 | 0 | 0) | 0;
  global$0 = i64toi32_i32$2 + 112 | 0;
  return $0 | 0;
 }
 
 function relay_new_single_host_name($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $3 = 0, $14 = 0, $15 = 0, $4 = 0, $16 = 0, $17 = 0, $28 = 0, $31 = 0, $39 = 0, $50 = 0, $58 = 0, $66 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hb0365aa08561904d($1 | 0, $0 | 0);
  $0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $2 = HEAP32[$1 >> 2] | 0;
  $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($1 + 32 | 0 | 0, $2 | 0);
  HEAP32[($1 + 44 | 0) >> 2] = $3;
  $2 = $1 + 58 | 0;
  i64toi32_i32$2 = ($1 + 32 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $28 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  $14 = $28;
  HEAP16[i64toi32_i32$0 >> 1] = $14;
  HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $14 >>> 16 | 0;
  HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$1;
  HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[($1 + 32 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  $15 = $31;
  HEAP16[($1 + 50 | 0) >> 1] = $15;
  HEAP16[($1 + 52 | 0) >> 1] = $15 >>> 16 | 0;
  HEAP16[($1 + 54 | 0) >> 1] = i64toi32_i32$0;
  HEAP16[($1 + 56 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
  $3 = ($1 + 8 | 0) + 8 | 0;
  i64toi32_i32$2 = ($1 + 48 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
  i64toi32_i32$1 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
  $39 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $39;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $4 = ($1 + 8 | 0) + 16 | 0;
  HEAP16[$4 >> 1] = HEAPU16[(($1 + 48 | 0) + 16 | 0) >> 1] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAPU16[($1 + 48 | 0) >> 1] | 0 | ((HEAPU16[($1 + 50 | 0) >> 1] | 0) << 16 | 0) | 0;
  i64toi32_i32$0 = HEAPU16[($1 + 52 | 0) >> 1] | 0 | ((HEAPU16[($1 + 54 | 0) >> 1] | 0) << 16 | 0) | 0;
  $50 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[($1 + 8 | 0) >> 2] = $50;
  HEAP32[($1 + 12 | 0) >> 2] = i64toi32_i32$0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $58 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  $16 = $58;
  HEAP16[i64toi32_i32$0 >> 1] = $16;
  HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $16 >>> 16 | 0;
  HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$1;
  HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
  HEAP16[($1 + 66 | 0) >> 1] = HEAPU16[$4 >> 1] | 0;
  HEAP16[($1 + 48 | 0) >> 1] = 1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $66 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  $17 = $66;
  HEAP16[($1 + 50 | 0) >> 1] = $17;
  HEAP16[($1 + 52 | 0) >> 1] = $17 >>> 16 | 0;
  HEAP16[($1 + 54 | 0) >> 1] = i64toi32_i32$0;
  HEAP16[($1 + 56 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
  $0 = $cardano_serialization_lib__Relay_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__ha0d8781612d84a1b($1 + 48 | 0 | 0) | 0;
  global$0 = $1 + 80 | 0;
  return $0 | 0;
 }
 
 function core__ptr__drop_in_place_cardano_serialization_lib__TransactionWitnessSet___h7d278d9502f6471a($0) {
  $0 = $0 | 0;
  var $1 = 0, $3 = 0, $2 = 0;
  label$1 : {
   if (!(HEAP32[$0 >> 2] | 0)) {
    break label$1
   }
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hdd0c057252922c46($0 | 0);
  }
  core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__NativeScripts____hdd7d461255ec800a_2($0 + 12 | 0 | 0);
  label$2 : {
   if (!(HEAP32[($0 + 24 | 0) >> 2] | 0)) {
    break label$2
   }
   $1 = $0 + 24 | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h28dc4dde55fe2f07($1 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h79e8c51775f4d5f8($1 | 0);
  }
  core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__plutus__PlutusScripts____h6be1d55eac328b7f_2($0 + 36 | 0 | 0);
  label$3 : {
   if ((HEAPU8[($0 + 60 | 0) >> 0] | 0 | 0) == (3 | 0)) {
    break label$3
   }
   $2 = $0 + 48 | 0;
   label$4 : {
    $3 = HEAP32[($0 + 56 | 0) >> 2] | 0;
    if (!$3) {
     break label$4
    }
    $1 = HEAP32[($0 + 48 | 0) >> 2] | 0;
    $3 = Math_imul($3, 48);
    label$5 : while (1) {
     core__ptr__drop_in_place_cardano_serialization_lib__plutus__PlutusData___hfab843e66e0f9428_2($1 | 0);
     $1 = $1 + 48 | 0;
     $3 = $3 + -48 | 0;
     if ($3) {
      continue label$5
     }
     break label$5;
    };
   }
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h36e817e704f6f25e($2 | 0);
  }
  label$6 : {
   $1 = HEAP32[($0 + 64 | 0) >> 2] | 0;
   if (!$1) {
    break label$6
   }
   $2 = $0 + 64 | 0;
   label$7 : {
    $3 = HEAP32[($0 + 72 | 0) >> 2] | 0;
    if (!$3) {
     break label$7
    }
    $3 = Math_imul($3, 80);
    $1 = $1 + 8 | 0;
    label$8 : while (1) {
     core__ptr__drop_in_place_cardano_serialization_lib__plutus__PlutusData___hfab843e66e0f9428_2($1 | 0);
     $1 = $1 + 80 | 0;
     $3 = $3 + -80 | 0;
     if ($3) {
      continue label$8
     }
     break label$8;
    };
   }
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h4c688d2d7e8a61fa($2 | 0);
  }
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___entry__ha9f4bb92e7621409($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $4 = 0, $3 = 0, i64toi32_i32$1 = 0, $5 = 0, i64toi32_i32$0 = 0, $37 = 0, $50 = 0;
  $3 = global$0 - 32 | 0;
  global$0 = $3;
  HEAP32[($3 + 12 | 0) >> 2] = $2;
  label$1 : {
   label$2 : {
    $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$4) {
     break label$2
    }
    $5 = HEAP32[$1 >> 2] | 0;
    break label$1;
   }
   $5 = 0;
   $4 = alloc__boxed__Box_T_2cA___new_uninit_in__hf695c4eb6d2b8dd9() | 0;
   HEAP16[($4 + 50 | 0) >> 1] = 0;
   HEAP32[$4 >> 2] = 0;
   HEAP32[($1 + 4 | 0) >> 2] = $4;
   HEAP32[$1 >> 2] = 0;
  }
  alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__h69963ef43fa7a3b9($3 + 16 | 0 | 0, $5 | 0, $4 | 0, $3 + 12 | 0 | 0);
  $5 = 1;
  $4 = $3 + 16 | 0 | 4 | 0;
  label$3 : {
   label$4 : {
    if ((HEAP32[($3 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$4
    }
    i64toi32_i32$0 = HEAP32[$4 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
    $37 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[($0 + 4 | 0) >> 2] = $37;
    HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($4 + 8 | 0) >> 2] | 0;
    $4 = $0 + 16 | 0;
    break label$3;
   }
   HEAP32[($0 + 4 | 0) >> 2] = $2;
   i64toi32_i32$1 = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   $50 = i64toi32_i32$1;
   i64toi32_i32$1 = $0 + 8 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $50;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($0 + 16 | 0) >> 2] = HEAP32[($4 + 8 | 0) >> 2] | 0;
   $4 = $0 + 20 | 0;
   $5 = 0;
  }
  HEAP32[$0 >> 2] = $5;
  HEAP32[$4 >> 2] = $1;
  global$0 = $3 + 32 | 0;
 }
 
 function $cardano_serialization_lib__plutus__Language_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__ha3cda676d250cc98($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, $3 = 0, $3$hi = 0, $29 = 0, $35 = 0, $41 = 0, $47 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___unsigned_integer__h1ed99c0b7fe7eea1($2 + 96 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 104 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 108 | 0) >> 2] | 0;
  $3 = i64toi32_i32$0;
  $3$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAP32[($2 + 96 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 100 | 0) >> 2] | 0;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$1 = 0;
     i64toi32_i32$3 = 1;
     if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
      break label$3
     }
     label$4 : {
      i64toi32_i32$2 = $3$hi;
      if (!($3 | i64toi32_i32$2 | 0)) {
       break label$4
      }
      alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($2 + 48 | 0 | 0, 1070967 | 0, 8 | 0);
      HEAP8[$2 >> 0] = 11;
      break label$2;
     }
     HEAP8[$0 >> 0] = 19;
     break label$1;
    }
    i64toi32_i32$2 = $3$hi;
    i64toi32_i32$0 = $2 + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $3;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$3 = ($2 + 96 | 0) + 16 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $29 = i64toi32_i32$2;
    i64toi32_i32$2 = $2 + 16 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $29;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$3 = ($2 + 96 | 0) + 24 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $35 = i64toi32_i32$0;
    i64toi32_i32$0 = $2 + 24 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $35;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$3 = ($2 + 96 | 0) + 32 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $41 = i64toi32_i32$2;
    i64toi32_i32$2 = $2 + 32 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $41;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$3 = ($2 + 96 | 0) + 40 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $47 = i64toi32_i32$0;
    i64toi32_i32$0 = $2 + 40 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $47;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    HEAP32[($2 + 48 | 0) >> 2] = 0;
    HEAP8[$2 >> 0] = 2;
   }
   memcpy($2 + 96 | 0 | 0, $2 | 0, 64 | 0) | 0;
   cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 | 0, $2 + 96 | 0 | 0, 1070967 | 0, 8 | 0);
  }
  global$0 = $2 + 160 | 0;
 }
 
 function alloc__collections__btree__navigate__full_range__ha6ee6a591ac989ec($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, $6 = 0, $7 = 0, $8 = 0, i64toi32_i32$0 = 0;
  $5 = global$0 - 32 | 0;
  global$0 = $5;
  $6 = !$1;
  $7 = HEAPU16[($4 + 446 | 0) >> 1] | 0;
  label$1 : {
   label$2 : {
    if (!$3) {
     break label$2
    }
    $8 = $1 + -1 | 0;
    $1 = $1 - $3 | 0;
    label$3 : while (1) {
     if ($6 & 1 | 0) {
      break label$1
     }
     $4 = HEAP32[(($4 + ($7 << 2 | 0) | 0) + 448 | 0) >> 2] | 0;
     $7 = HEAPU16[($4 + 446 | 0) >> 1] | 0;
     $6 = !$8;
     $2 = HEAP32[($2 + 448 | 0) >> 2] | 0;
     $8 = $8 + -1 | 0;
     $3 = $3 + -1 | 0;
     if ($3) {
      continue label$3
     }
     break label$3;
    };
   }
   if (!$6) {
    break label$1
   }
   i64toi32_i32$0 = 0;
   HEAP32[($0 + 8 | 0) >> 2] = 0;
   HEAP32[($0 + 12 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($0 + 4 | 0) >> 2] = $2;
   HEAP32[$0 >> 2] = $1;
   HEAP32[($0 + 20 | 0) >> 2] = $7;
   HEAP32[($0 + 16 | 0) >> 2] = $4;
   global$0 = $5 + 32 | 0;
   return;
  }
  HEAP32[($5 + 20 | 0) >> 2] = 1;
  i64toi32_i32$0 = 0;
  HEAP32[($5 + 4 | 0) >> 2] = 1;
  HEAP32[($5 + 8 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[$5 >> 2] = 1139640;
  HEAP32[($5 + 28 | 0) >> 2] = 237;
  HEAP32[($5 + 24 | 0) >> 2] = 1139680;
  HEAP32[($5 + 16 | 0) >> 2] = $5 + 24 | 0;
  core__panicking__panic_fmt__hbf21a3d4bbb82bf8($5 | 0, 1139784 | 0);
  abort();
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Immut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____next_unchecked__h3f773d42bd58327f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $4 = 0, $2 = 0, $5 = 0, $3 = 0, $6 = 0;
  $2 = HEAP32[$1 >> 2] | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     if ($3 >>> 0 >= (HEAPU16[($4 + 226 | 0) >> 1] | 0) >>> 0) {
      break label$3
     }
     $5 = $4;
     break label$2;
    }
    label$4 : while (1) {
     $5 = HEAP32[($4 + 88 | 0) >> 2] | 0;
     if (!$5) {
      break label$1
     }
     $2 = $2 + 1 | 0;
     $3 = HEAPU16[($4 + 224 | 0) >> 1] | 0;
     $4 = $5;
     if ($3 >>> 0 >= (HEAPU16[($5 + 226 | 0) >> 1] | 0) >>> 0) {
      continue label$4
     }
     break label$4;
    };
   }
   $6 = $3 + 1 | 0;
   label$5 : {
    label$6 : {
     if ($2) {
      break label$6
     }
     $4 = $5;
     break label$5;
    }
    $4 = HEAP32[(($5 + ($6 << 2 | 0) | 0) + 232 | 0) >> 2] | 0;
    label$7 : {
     $2 = $2 + -1 | 0;
     if (!$2) {
      break label$7
     }
     label$8 : while (1) {
      $4 = HEAP32[($4 + 232 | 0) >> 2] | 0;
      $2 = $2 + -1 | 0;
      if ($2) {
       continue label$8
      }
      break label$8;
     };
    }
    $6 = 0;
   }
   HEAP32[($1 + 8 | 0) >> 2] = $6;
   HEAP32[($1 + 4 | 0) >> 2] = $4;
   HEAP32[$1 >> 2] = 0;
   HEAP32[($0 + 4 | 0) >> 2] = $5 + ($3 << 3 | 0) | 0;
   HEAP32[$0 >> 2] = ($5 + Math_imul($3, 12) | 0) + 92 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1048576 | 0, 43 | 0, 1049864 | 0);
  abort();
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Immut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____next_unchecked__hb38abc1b9c99c097($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $4 = 0, $2 = 0, $5 = 0, $3 = 0, $6 = 0;
  $2 = HEAP32[$1 >> 2] | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     if ($3 >>> 0 >= (HEAPU16[($4 + 1458 | 0) >> 1] | 0) >>> 0) {
      break label$3
     }
     $5 = $4;
     break label$2;
    }
    label$4 : while (1) {
     $5 = HEAP32[($4 + 1056 | 0) >> 2] | 0;
     if (!$5) {
      break label$1
     }
     $2 = $2 + 1 | 0;
     $3 = HEAPU16[($4 + 1456 | 0) >> 1] | 0;
     $4 = $5;
     if ($3 >>> 0 >= (HEAPU16[($5 + 1458 | 0) >> 1] | 0) >>> 0) {
      continue label$4
     }
     break label$4;
    };
   }
   $6 = $3 + 1 | 0;
   label$5 : {
    label$6 : {
     if ($2) {
      break label$6
     }
     $4 = $5;
     break label$5;
    }
    $4 = HEAP32[(($5 + ($6 << 2 | 0) | 0) + 1464 | 0) >> 2] | 0;
    label$7 : {
     $2 = $2 + -1 | 0;
     if (!$2) {
      break label$7
     }
     label$8 : while (1) {
      $4 = HEAP32[($4 + 1464 | 0) >> 2] | 0;
      $2 = $2 + -1 | 0;
      if ($2) {
       continue label$8
      }
      break label$8;
     };
    }
    $6 = 0;
   }
   HEAP32[($1 + 8 | 0) >> 2] = $6;
   HEAP32[($1 + 4 | 0) >> 2] = $4;
   HEAP32[$1 >> 2] = 0;
   HEAP32[($0 + 4 | 0) >> 2] = $5 + Math_imul($3, 96) | 0;
   HEAP32[$0 >> 2] = ($5 + Math_imul($3, 36) | 0) + 1060 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1048576 | 0, 43 | 0, 1049864 | 0);
  abort();
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Immut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____next_unchecked__hebec1903e6b897f2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $4 = 0, $2 = 0, $5 = 0, $3 = 0, $6 = 0;
  $2 = HEAP32[$1 >> 2] | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     if ($3 >>> 0 >= (HEAPU16[($4 + 314 | 0) >> 1] | 0) >>> 0) {
      break label$3
     }
     $5 = $4;
     break label$2;
    }
    label$4 : while (1) {
     $5 = HEAP32[($4 + 176 | 0) >> 2] | 0;
     if (!$5) {
      break label$1
     }
     $2 = $2 + 1 | 0;
     $3 = HEAPU16[($4 + 312 | 0) >> 1] | 0;
     $4 = $5;
     if ($3 >>> 0 >= (HEAPU16[($5 + 314 | 0) >> 1] | 0) >>> 0) {
      continue label$4
     }
     break label$4;
    };
   }
   $6 = $3 + 1 | 0;
   label$5 : {
    label$6 : {
     if ($2) {
      break label$6
     }
     $4 = $5;
     break label$5;
    }
    $4 = HEAP32[(($5 + ($6 << 2 | 0) | 0) + 320 | 0) >> 2] | 0;
    label$7 : {
     $2 = $2 + -1 | 0;
     if (!$2) {
      break label$7
     }
     label$8 : while (1) {
      $4 = HEAP32[($4 + 320 | 0) >> 2] | 0;
      $2 = $2 + -1 | 0;
      if ($2) {
       continue label$8
      }
      break label$8;
     };
    }
    $6 = 0;
   }
   HEAP32[($1 + 8 | 0) >> 2] = $6;
   HEAP32[($1 + 4 | 0) >> 2] = $4;
   HEAP32[$1 >> 2] = 0;
   HEAP32[($0 + 4 | 0) >> 2] = $5 + ($3 << 4 | 0) | 0;
   HEAP32[$0 >> 2] = ($5 + Math_imul($3, 12) | 0) + 180 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1048576 | 0, 43 | 0, 1049864 | 0);
  abort();
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__NativeScript___deserialize__hcd9caa6a3e1b77da($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $2 = 0, i64toi32_i32$0 = 0, $3 = 0, $3$hi = 0, $4 = 0, $5 = 0, $6 = 0, $4$hi = 0, $5$hi = 0, $6$hi = 0;
  $2 = global$0 - 144 | 0;
  global$0 = $2;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__NativeScriptEnum___deserialize__hb97d8419517d870c($2 + 72 | 0 | 0, $1 | 0);
  i64toi32_i32$0 = 0;
  $3 = 1;
  $3$hi = i64toi32_i32$0;
  $1 = ($2 + 72 | 0) + 8 | 0;
  label$1 : {
   label$2 : {
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 72 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 76 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    i64toi32_i32$3 = 1;
    if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
     break label$2
    }
    i64toi32_i32$3 = $1 + 24 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $3 = i64toi32_i32$2;
    $3$hi = i64toi32_i32$1;
    i64toi32_i32$2 = ($2 + 8 | 0) + 24 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $3;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$3 = $1 + 16 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $4 = i64toi32_i32$1;
    $4$hi = i64toi32_i32$2;
    i64toi32_i32$1 = ($2 + 8 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $4;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$3 = $1 + 8 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $5 = i64toi32_i32$2;
    $5$hi = i64toi32_i32$1;
    i64toi32_i32$2 = ($2 + 8 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $5;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$3 = $1;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $6 = i64toi32_i32$1;
    $6$hi = i64toi32_i32$2;
    i64toi32_i32$1 = $2;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $6;
    HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $3$hi;
    i64toi32_i32$1 = $0 + 32 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $4$hi;
    i64toi32_i32$1 = $0 + 24 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $4;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $5$hi;
    i64toi32_i32$1 = $0 + 16 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $5;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $6$hi;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $6;
    HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = 0;
    $3 = 0;
    $3$hi = i64toi32_i32$2;
    break label$1;
   }
   memcpy($2 + 8 | 0 | 0, $1 | 0, 64 | 0) | 0;
   memcpy($0 + 8 | 0 | 0, $2 + 8 | 0 | 0, 64 | 0) | 0;
  }
  i64toi32_i32$2 = $3$hi;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $3;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  global$0 = $2 + 144 | 0;
 }
 
 function poolretirement_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $30 = 0, $45 = 0, $50 = 0, $62 = 0;
  $2 = global$0 - 96 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 48 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 64 | 0) >> 2] = $30;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__PoolRetirement__from_bytes__ha16222bdbe5d2ef6($2 + 8 | 0 | 0, $2 + 64 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = $2 + 24 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $45 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 76 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $45;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2 + 32 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $50 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 84 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $50;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($2 + 92 | 0) >> 2] = HEAP32[($2 + 40 | 0) >> 2] | 0;
  HEAP32[($2 + 64 | 0) >> 2] = $1;
  i64toi32_i32$2 = ($2 + 8 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $62 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 68 | 0) >> 2] = $62;
  HEAP32[($2 + 72 | 0) >> 2] = i64toi32_i32$0;
  $1 = $cardano_serialization_lib__PoolRetirement_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hc280b71a1ce0ea8e($2 + 64 | 0 | 0) | 0;
  global$0 = $2 + 96 | 0;
  return $1 | 0;
 }
 
 function cardano_serialization_lib__Ipv6__from_bytes__he70f86e384c44faa($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $11 = 0, $12 = 0, $3 = 0, $4 = 0, $16 = 0, $3$hi = 0, $4$hi = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[($2 + 168 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 152 | 0) >> 2] = 0;
  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $16 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 160 | 0) >> 2] = $16;
  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__Ipv6___deserialize__hca2aa2a334ab12c8($2 + 80 | 0 | 0, $2 + 152 | 0 | 0);
  $1 = ($2 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAPU8[($2 + 80 | 0) >> 0] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    i64toi32_i32$2 = ($2 + 80 | 0) + 9 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $3 = i64toi32_i32$1;
    $3$hi = i64toi32_i32$0;
    i64toi32_i32$1 = ($2 + 8 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAPU8[($2 + 81 | 0) >> 0] | 0 | ((HEAPU8[($2 + 82 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 83 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 84 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[($2 + 85 | 0) >> 0] | 0 | ((HEAPU8[($2 + 86 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 87 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 88 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $4 = i64toi32_i32$0;
    $4$hi = i64toi32_i32$1;
    i64toi32_i32$0 = $2;
    HEAP32[($2 + 8 | 0) >> 2] = $4;
    HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $3$hi;
    i64toi32_i32$0 = $0 + 9 | 0;
    $11 = $3;
    HEAP8[i64toi32_i32$0 >> 0] = $11;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$1 = $4$hi;
    i64toi32_i32$0 = $0;
    $12 = $4;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $12;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $12 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $12 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = $12 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 8 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 8 | 0 | 7 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0 + 4 | 0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[wasm2js_i32$0 >> 2] = wasm2js_i32$1;
  }
  HEAP8[$0 >> 0] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function singlehostaddr_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $9 = 0, $10 = 0, $11 = 0, $12 = 0, $31 = 0, $48 = 0, $62 = 0;
  $2 = global$0 - 96 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 48 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 64 | 0) >> 2] = $31;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__SingleHostAddr__from_bytes__h7fb250e664cb91aa($2 + 16 | 0 | 0, $2 + 64 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU16[($2 + 16 | 0) >> 1] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  $0 = HEAPU16[($2 + 18 | 0) >> 1] | 0;
  i64toi32_i32$2 = $2 + 32 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $48 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 78 | 0;
  $9 = $48;
  HEAP16[i64toi32_i32$1 >> 1] = $9;
  HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $9 >>> 16 | 0;
  HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = i64toi32_i32$0;
  HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
  $10 = $2 + 86 | 0;
  $11 = HEAP32[($2 + 40 | 0) >> 2] | 0;
  HEAP16[$10 >> 1] = $11;
  HEAP16[($10 + 2 | 0) >> 1] = $11 >>> 16 | 0;
  HEAP16[($2 + 66 | 0) >> 1] = $1;
  HEAP16[($2 + 68 | 0) >> 1] = $1 >>> 16 | 0;
  HEAP16[($2 + 64 | 0) >> 1] = $0;
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $62 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  $12 = $62;
  HEAP16[($2 + 70 | 0) >> 1] = $12;
  HEAP16[($2 + 72 | 0) >> 1] = $12 >>> 16 | 0;
  HEAP16[($2 + 74 | 0) >> 1] = i64toi32_i32$1;
  HEAP16[($2 + 76 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
  $1 = $cardano_serialization_lib__SingleHostAddr_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h118dc31a83c6b0e2($2 + 64 | 0 | 0) | 0;
  global$0 = $2 + 96 | 0;
  return $1 | 0;
 }
 
 function cardano_serialization_lib__Relay__as_single_host_addr__h2648a96a2eee1018($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $22 = 0, $23 = 0, $24 = 0, $2 = 0, $4 = 0, $7 = 0, $25 = 0, $8$hi = 0, $26 = 0, $27 = 0, $28 = 0, $3 = 0, $5 = 0, $6 = 0, $32 = 0, $36 = 0, $40 = 0, $45 = 0, $47 = 0, $8 = 0, $62 = 0, $62$hi = 0;
  $2 = global$0 - 16 | 0;
  label$1 : {
   if (HEAPU16[$1 >> 1] | 0) {
    break label$1
   }
   $22 = $1 + 7 | 0;
   $3 = HEAPU8[$22 >> 0] | 0 | ((HEAPU8[($22 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($22 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($22 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $4 = HEAPU8[($1 + 6 | 0) >> 0] | 0;
   $5 = HEAPU16[($1 + 4 | 0) >> 1] | 0;
   $6 = HEAPU16[($1 + 2 | 0) >> 1] | 0;
   $7 = 0;
   label$2 : {
    if ((HEAPU8[($1 + 11 | 0) >> 0] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    i64toi32_i32$2 = $1 + 20 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $32 = i64toi32_i32$0;
    i64toi32_i32$0 = $2 + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $32;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $1 + 12 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $36 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[i64toi32_i32$1 >> 2] = $36;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    $7 = 1;
   }
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $40 = i64toi32_i32$0;
   i64toi32_i32$0 = $0 + 10 | 0;
   $23 = $40;
   HEAP8[i64toi32_i32$0 >> 0] = $23;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $23 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $23 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $23 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $45 = i64toi32_i32$1;
   i64toi32_i32$1 = $0 + 18 | 0;
   $24 = $45;
   HEAP8[i64toi32_i32$1 >> 0] = $24;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $24 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $24 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $24 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   $47 = $0 + 8 | 0;
   i64toi32_i32$0 = 0;
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = 0;
   i64toi32_i32$3 = 8;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
    $25 = 0;
   } else {
    i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
    $25 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   }
   i64toi32_i32$4 = ($4 & 255 | 0 | 0) == (1 | 0);
   i64toi32_i32$2 = 0;
   i64toi32_i32$3 = i64toi32_i32$4 ? $25 : 0;
   i64toi32_i32$0 = i64toi32_i32$4 ? i64toi32_i32$1 : i64toi32_i32$2;
   $8 = i64toi32_i32$3;
   $8$hi = i64toi32_i32$0;
   i64toi32_i32$4 = i64toi32_i32$3;
   i64toi32_i32$3 = 0;
   i64toi32_i32$1 = 32;
   i64toi32_i32$2 = i64toi32_i32$1 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
    i64toi32_i32$3 = 0;
    $26 = i64toi32_i32$0 >>> i64toi32_i32$2 | 0;
   } else {
    i64toi32_i32$3 = i64toi32_i32$0 >>> i64toi32_i32$2 | 0;
    $26 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$2 | 0) | 0;
   }
   HEAP8[$47 >> 0] = $26;
   i64toi32_i32$3 = $8$hi;
   i64toi32_i32$3 = 0;
   i64toi32_i32$0 = $4;
   i64toi32_i32$4 = 0;
   i64toi32_i32$1 = 255;
   i64toi32_i32$4 = i64toi32_i32$3 & i64toi32_i32$4 | 0;
   $62 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
   $62$hi = i64toi32_i32$4;
   i64toi32_i32$4 = $8$hi;
   i64toi32_i32$3 = $8;
   i64toi32_i32$0 = $62$hi;
   i64toi32_i32$1 = $62;
   i64toi32_i32$0 = i64toi32_i32$4 | i64toi32_i32$0 | 0;
   $27 = $0 + 4 | 0;
   $28 = i64toi32_i32$3 | i64toi32_i32$1 | 0;
   HEAP16[$27 >> 1] = $28;
   HEAP16[($27 + 2 | 0) >> 1] = $28 >>> 16 | 0;
   HEAP8[($0 + 9 | 0) >> 0] = $7;
   HEAP16[($0 + 2 | 0) >> 1] = $5;
   HEAP16[$0 >> 1] = $6;
   return;
  }
  HEAP16[$0 >> 1] = 2;
 }
 
 function cardano_serialization_lib__output_builder__TransactionOutputAmountBuilder__with_asset_and_min_required_coin__hf86cbfe0b07de24a($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $5 = 0, $20 = 0, $37 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  $5 = HEAPU8[($1 + 88 | 0) >> 0] | 0;
  cardano_serialization_lib__utils__min_pure_ada__had787b4590d9b7ca($4 | 0, $3 | 0, $5 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$4 >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    i64toi32_i32$2 = $4 + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $20 = i64toi32_i32$0;
    i64toi32_i32$0 = $4;
    HEAP32[$4 >> 2] = $20;
    HEAP32[($4 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($4 + 8 | 0) >> 2] = 0;
    cardano_serialization_lib__utils__Value__set_multiasset__hcffccef3fc1cfd59($4 | 0, $2 | 0);
    cardano_serialization_lib__utils__min_ada_required__hfea4b15a263723f5($4 + 32 | 0 | 0, $4 | 0, ($5 | 0) != (0 | 0) | 0, $3 | 0);
    label$3 : {
     if ((HEAP32[($4 + 32 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     i64toi32_i32$2 = ($4 + 32 | 0) + 8 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $37 = i64toi32_i32$1;
     i64toi32_i32$1 = $4;
     HEAP32[($4 + 24 | 0) >> 2] = $37;
     HEAP32[($4 + 28 | 0) >> 2] = i64toi32_i32$0;
     cardano_serialization_lib__output_builder__TransactionOutputAmountBuilder__with_coin_and_asset__h3912d48b40d60b51($0 + 8 | 0 | 0, $1 | 0, $4 + 24 | 0 | 0, $2 | 0);
     HEAP32[$0 >> 2] = 0;
     if (!(HEAP32[($4 + 8 | 0) >> 2] | 0)) {
      break label$1
     }
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($4 + 12 | 0 | 0);
     break label$1;
    }
    $3 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($4 + 36 | 0) >> 2] | 0 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    HEAP32[($0 + 4 | 0) >> 2] = $3;
    if (!(HEAP32[($4 + 8 | 0) >> 2] | 0)) {
     break label$1
    }
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($4 + 12 | 0 | 0);
    break label$1;
   }
   $3 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($4 + 4 | 0) >> 2] | 0 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
   HEAP32[($0 + 4 | 0) >> 2] = $3;
  }
  global$0 = $4 + 48 | 0;
 }
 
 function num_bigint__bigint__BigInt__from_biguint__hc8c58ec5989a4432($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, i64toi32_i32$1 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    if (($1 & 255 | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = alloc__vec__Vec_T_2cA___is_empty__h144b76bbfc7433d3($2 | 0) | 0 ? 1 : $1;
    break label$1;
   }
   alloc__vec__Vec_T_2cA___truncate__hb81c32e2ad35152a($2 | 0, 0 | 0);
   alloc__vec__Vec_T_2cA___extend_from_slice__hc94444ea46344854($2 | 0, 1057212 | 0, 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h7a0ed8a251b429e6($3 + 8 | 0 | 0, $2 | 0);
   label$3 : {
    $1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
    if (!$1) {
     break label$3
    }
    $4 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if (!$4) {
     break label$3
    }
    label$4 : while (1) {
     if (HEAP32[((($1 << 2 | 0) + $4 | 0) + -4 | 0) >> 2] | 0) {
      break label$3
     }
     label$5 : {
      $1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
      if (!$1) {
       break label$5
      }
      HEAP32[($2 + 8 | 0) >> 2] = $1 + -1 | 0;
     }
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h7a0ed8a251b429e6($3 | 0, $2 | 0);
     $1 = HEAP32[($3 + 4 | 0) >> 2] | 0;
     if (!$1) {
      break label$3
     }
     $4 = HEAP32[$3 >> 2] | 0;
     if ($4) {
      continue label$4
     }
     break label$4;
    };
   }
   $1 = 1;
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0) >>> 0 >= ((HEAP32[($2 + 4 | 0) >> 2] | 0) >>> 2 | 0) >>> 0) {
    break label$1
   }
   alloc__vec__Vec_T_2cA___shrink_to_fit__ha42fb43b13607cf8($2 | 0);
  }
  HEAP8[($0 + 12 | 0) >> 0] = $1;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  HEAP32[$0 >> 2] = HEAP32[$2 >> 2] | 0;
  HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($0 + 8 | 0) >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
  global$0 = $3 + 16 | 0;
 }
 
 function transactionunspentoutput_new($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $23 = 0, $28 = 0, $33 = 0, $38 = 0;
  $2 = global$0 - 352 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hd7bc050864a8d646($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h17af7d9d2d20aa0f($2 | 0, $1 | 0);
   i64toi32_i32$2 = $0;
   i64toi32_i32$0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   $23 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 148 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $23;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $0 + 12 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $28 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 156 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $28;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $0 + 20 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $33 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 164 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $33;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $0 + 28 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $38 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 172 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $38;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   $1 = HEAP32[$0 >> 2] | 0;
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $cardano_serialization_lib__TransactionOutput_20as_20core__clone__Clone___clone__h6884f0c4818d1aeb($2 + 16 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0);
   HEAP32[($2 + 144 | 0) >> 2] = $1;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
   memcpy($2 + 184 | 0 | 0, $2 + 16 | 0 | 0, 168 | 0) | 0;
   $0 = $cardano_serialization_lib__utils__TransactionUnspentOutput_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h241331f04367994b($2 + 184 | 0 | 0) | 0;
   global$0 = $2 + 352 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function cardano_serialization_lib__metadata__GeneralTransactionMetadata__insert__h12cd6f278bd1aa86($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $5 = 0, $5$hi = 0, $30 = 0, $36 = 0;
  $4 = global$0 - 96 | 0;
  global$0 = $4;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    switch (HEAP32[$3 >> 2] | 0 | 0) {
    default:
     $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__hdeea20968268d729(($4 + 48 | 0) + 8 | 0 | 0, $3 + 8 | 0 | 0);
     HEAP32[($4 + 48 | 0) >> 2] = 0;
     break label$1;
    case 1:
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hf69db734dd831996($4 + 48 | 0 | 4 | 0 | 0, $3 + 4 | 0 | 0);
     HEAP32[($4 + 48 | 0) >> 2] = 1;
     break label$1;
    case 2:
     i64toi32_i32$2 = $3 + 16 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $30 = i64toi32_i32$1;
     i64toi32_i32$1 = ($4 + 48 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $30;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $3 + 8 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $36 = i64toi32_i32$0;
     i64toi32_i32$0 = ($4 + 48 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $36;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($4 + 48 | 0) >> 2] = 2;
     break label$1;
    case 3:
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($4 + 48 | 0 | 4 | 0 | 0, $3 + 4 | 0 | 0);
     HEAP32[($4 + 48 | 0) >> 2] = 3;
     break label$1;
    case 4:
     break label$2;
    };
   }
   $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($4 + 48 | 0 | 4 | 0 | 0, $3 + 4 | 0 | 0);
   HEAP32[($4 + 48 | 0) >> 2] = 4;
  }
  i64toi32_i32$1 = $5$hi;
  $4 = memcpy($4 | 0, $4 + 48 | 0 | 0, 48 | 0) | 0;
  linked_hash_map__LinkedHashMap_K_2cV_2cS___insert__h48a3e36a8942b5e6($0 | 0, $1 | 0, $5 | 0, i64toi32_i32$1 | 0, $4 | 0);
  global$0 = $4 + 96 | 0;
 }
 
 function vkeywitness_new($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, $25 = 0, $31 = 0, $37 = 0, $40 = 0;
  $2 = global$0 - 208 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h38603c546ca761f2($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hd6fdee4274fe58a2($2 | 0, $1 | 0);
   i64toi32_i32$2 = $0 + 8 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $25 = i64toi32_i32$0;
   i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $25;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $0 + 16 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $31 = i64toi32_i32$1;
   i64toi32_i32$1 = ($2 + 16 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $31;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $0 + 24 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $37 = i64toi32_i32$0;
   i64toi32_i32$0 = ($2 + 16 | 0) + 24 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $37;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $40 = i64toi32_i32$1;
   i64toi32_i32$1 = $2;
   HEAP32[($2 + 16 | 0) >> 2] = $40;
   HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   memcpy($2 + 48 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, 64 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
   memcpy($2 + 112 | 0 | 0, $2 + 16 | 0 | 0, 96 | 0) | 0;
   $0 = $cardano_serialization_lib__crypto__Vkeywitness_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hffa43ed1c5f00e23($2 + 112 | 0 | 0) | 0;
   global$0 = $2 + 208 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function $alloc__vec__into_iter__IntoIter_T_2cA__20as_20core__ops__drop__Drop___drop__h8ed9ca310048d65b($0) {
  $0 = $0 | 0;
  var $4 = 0, $6 = 0, $1 = 0, $3 = 0, $2 = 0, $5 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   $2 = HEAP32[($0 + 12 | 0) >> 2] | 0;
   $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (($2 | 0) == ($3 | 0)) {
    break label$1
   }
   label$2 : while (1) {
    $4 = $3;
    $3 = $4 + 48 | 0;
    label$3 : {
     label$4 : {
      switch (HEAP32[$4 >> 2] | 0 | 0) {
      default:
       $4 = $4 + 4 | 0;
       $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($4 | 0);
       $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($4 | 0);
       break label$3;
      case 0:
       $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__hd17c55afb95953fd($4 + 8 | 0 | 0);
       $4 = $4 + 24 | 0;
       if (!(HEAP32[$4 >> 2] | 0)) {
        break label$3
       }
       hashbrown__raw__RawTable_T_2cA___free_buckets__hf5781ccef5282b02($4 | 0);
       break label$3;
      case 1:
       $5 = $4 + 4 | 0;
       label$8 : {
        $6 = HEAP32[($4 + 12 | 0) >> 2] | 0;
        if (!$6) {
         break label$8
        }
        $4 = HEAP32[($4 + 4 | 0) >> 2] | 0;
        $6 = Math_imul($6, 48);
        label$9 : while (1) {
         core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatum___headd2d1b596252cc_2($4 | 0);
         $4 = $4 + 48 | 0;
         $6 = $6 + -48 | 0;
         if ($6) {
          continue label$9
         }
         break label$9;
        };
       }
       $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h81b8a37e31f2de30($5 | 0);
       break label$3;
      case 2:
       break label$3;
      case 3:
       break label$4;
      };
     }
     $4 = $4 + 4 | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($4 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($4 | 0);
    }
    if (($3 | 0) != ($2 | 0)) {
     continue label$2
    }
    break label$2;
   };
  }
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 12 | 0) >> 2] = i64toi32_i32$1;
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h81b8a37e31f2de30($1 + 8 | 0 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Immut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____next_unchecked__h7b6621e395ccabfb($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $4 = 0, $2 = 0, $5 = 0, $3 = 0, $6 = 0;
  $2 = HEAP32[$1 >> 2] | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     if ($3 >>> 0 >= (HEAPU16[($4 + 402 | 0) >> 1] | 0) >>> 0) {
      break label$3
     }
     $5 = $4;
     break label$2;
    }
    label$4 : while (1) {
     $5 = HEAP32[($4 + 264 | 0) >> 2] | 0;
     if (!$5) {
      break label$1
     }
     $2 = $2 + 1 | 0;
     $3 = HEAPU16[($4 + 400 | 0) >> 1] | 0;
     $4 = $5;
     if ($3 >>> 0 >= (HEAPU16[($5 + 402 | 0) >> 1] | 0) >>> 0) {
      continue label$4
     }
     break label$4;
    };
   }
   $6 = $3 + 1 | 0;
   label$5 : {
    label$6 : {
     if ($2) {
      break label$6
     }
     $4 = $5;
     break label$5;
    }
    $4 = HEAP32[(($5 + ($6 << 2 | 0) | 0) + 408 | 0) >> 2] | 0;
    label$7 : {
     $2 = $2 + -1 | 0;
     if (!$2) {
      break label$7
     }
     label$8 : while (1) {
      $4 = HEAP32[($4 + 408 | 0) >> 2] | 0;
      $2 = $2 + -1 | 0;
      if ($2) {
       continue label$8
      }
      break label$8;
     };
    }
    $6 = 0;
   }
   HEAP32[($1 + 8 | 0) >> 2] = $6;
   HEAP32[($1 + 4 | 0) >> 2] = $4;
   HEAP32[$1 >> 2] = 0;
   HEAP32[($0 + 4 | 0) >> 2] = $5 + Math_imul($3, 24) | 0;
   HEAP32[$0 >> 2] = ($5 + Math_imul($3, 12) | 0) + 268 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1084228 | 0, 43 | 0, 1084748 | 0);
  abort();
 }
 
 function cryptoxide__ed25519__signature_nonce__h963937328d628fd2($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $7$hi = 0, $6 = 0, $8$hi = 0, $5 = 0, $32 = 0, $7 = 0, $37$hi = 0, $42 = 0, $44 = 0, $44$hi = 0, $47 = 0, $48$hi = 0;
  $4 = global$0 - 432 | 0;
  global$0 = $4;
  $5 = memset(($4 + 216 | 0) + 80 | 0 | 0, 0 | 0, 132 | 0) | 0;
  $6 = memcpy(($4 + 216 | 0) + 16 | 0 | 0, 1137368 | 0, 64 | 0) | 0;
  i64toi32_i32$1 = $4;
  i64toi32_i32$0 = 0;
  HEAP32[($4 + 224 | 0) >> 2] = 0;
  HEAP32[($4 + 228 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$1 = $4;
  i64toi32_i32$0 = 0;
  HEAP32[($4 + 216 | 0) >> 2] = 32;
  HEAP32[($4 + 220 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[$4 >> 2] = $6;
  cryptoxide__cryptoutil__FixedBuffer_____input__h45eb77880e071f02($5 | 0, $1 + 32 | 0 | 0, 32 | 0, $4 | 0);
  $4 = memcpy($4 | 0, $4 + 216 | 0 | 0, 216 | 0) | 0;
  $32 = $4;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[$4 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  $37$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = $37$hi;
  i64toi32_i32$3 = $3;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $8$hi = i64toi32_i32$5;
  i64toi32_i32$2 = $32;
  HEAP32[i64toi32_i32$2 >> 2] = i64toi32_i32$4;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$5;
  $1 = $4 + 8 | 0;
  $42 = $1;
  i64toi32_i32$1 = $1;
  i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $44 = i64toi32_i32$5;
  $44$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$3 = $7;
  $47 = i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
  i64toi32_i32$1 = 0;
  $48$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $44$hi;
  i64toi32_i32$3 = $44;
  i64toi32_i32$2 = $48$hi;
  i64toi32_i32$5 = $47;
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  i64toi32_i32$3 = $42;
  HEAP32[i64toi32_i32$3 >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$4;
  HEAP32[($4 + 216 | 0) >> 2] = $4 + 16 | 0;
  cryptoxide__cryptoutil__FixedBuffer_____input__h45eb77880e071f02($4 + 80 | 0 | 0, $2 | 0, $3 | 0, $4 + 216 | 0 | 0);
  memcpy($4 + 216 | 0 | 0, $4 | 0, 216 | 0) | 0;
  $4 = memset($4 | 0, 0 | 0, 64 | 0) | 0;
  cryptoxide__hashing__sha2__Engine512__finish__h18b5152b4b76c624($4 + 216 | 0 | 0);
  cryptoxide__cryptoutil__write_u64v_be__h6888df4c897d2bb4($4 | 0, 64 | 0, $6 | 0, 8 | 0);
  cryptoxide__curve25519__scalar__scalar64__Scalar__reduce_from_wide_bytes__h35529550345bd5f0($0 | 0, $4 | 0);
  global$0 = $4 + 432 | 0;
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Immut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____next_unchecked__hf8cfcc1a4fb4b5f3($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $4 = 0, $2 = 0, $5 = 0, $3 = 0, $6 = 0;
  $2 = HEAP32[$1 >> 2] | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     if ($3 >>> 0 >= (HEAPU16[($4 + 446 | 0) >> 1] | 0) >>> 0) {
      break label$3
     }
     $5 = $4;
     break label$2;
    }
    label$4 : while (1) {
     $5 = HEAP32[($4 + 440 | 0) >> 2] | 0;
     if (!$5) {
      break label$1
     }
     $2 = $2 + 1 | 0;
     $3 = HEAPU16[($4 + 444 | 0) >> 1] | 0;
     $4 = $5;
     if ($3 >>> 0 >= (HEAPU16[($5 + 446 | 0) >> 1] | 0) >>> 0) {
      continue label$4
     }
     break label$4;
    };
   }
   $6 = $3 + 1 | 0;
   label$5 : {
    label$6 : {
     if ($2) {
      break label$6
     }
     $4 = $5;
     break label$5;
    }
    $4 = HEAP32[(($5 + ($6 << 2 | 0) | 0) + 448 | 0) >> 2] | 0;
    label$7 : {
     $2 = $2 + -1 | 0;
     if (!$2) {
      break label$7
     }
     label$8 : while (1) {
      $4 = HEAP32[($4 + 448 | 0) >> 2] | 0;
      $2 = $2 + -1 | 0;
      if ($2) {
       continue label$8
      }
      break label$8;
     };
    }
    $6 = 0;
   }
   HEAP32[($1 + 8 | 0) >> 2] = $6;
   HEAP32[($1 + 4 | 0) >> 2] = $4;
   HEAP32[$1 >> 2] = 0;
   HEAP32[$0 >> 2] = $5 + ($3 << 4 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = ($5 + Math_imul($3, 24) | 0) + 176 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1139442 | 0, 43 | 0, 1139580 | 0);
  abort();
 }
 
 function poolparams_reward_account($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $16 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $17 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $2 = 0, $25 = 0, $31 = 0, $41 = 0, $53 = 0, $57 = 0, $68 = 0;
  $1 = global$0 - 112 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hc466bac66f8af18e($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $2 = HEAPU8[($0 + 160 | 0) >> 0] | 0;
  $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $4 = $1 + 24 | 0;
  i64toi32_i32$2 = $0 + 170 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $25 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[i64toi32_i32$0 >> 2] = $25;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $5 = $1 + 32 | 0;
  i64toi32_i32$2 = $0 + 178 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $31 = i64toi32_i32$1;
  i64toi32_i32$1 = $5;
  HEAP32[i64toi32_i32$1 >> 2] = $31;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $6 = $1 + 40 | 0;
  $16 = $0 + 186 | 0;
  HEAP32[$6 >> 2] = HEAPU8[$16 >> 0] | 0 | ((HEAPU8[($16 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($16 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($16 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $0 + 162 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $41 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 16 | 0) >> 2] = $41;
  HEAP32[($1 + 20 | 0) >> 2] = i64toi32_i32$1;
  $0 = HEAPU8[($0 + 161 | 0) >> 0] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $53 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 90 | 0;
  $17 = $53;
  HEAP16[i64toi32_i32$1 >> 1] = $17;
  HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $17 >>> 16 | 0;
  HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = i64toi32_i32$0;
  HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $57 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 98 | 0;
  $18 = $57;
  HEAP16[i64toi32_i32$0 >> 1] = $18;
  HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $18 >>> 16 | 0;
  HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$1;
  HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
  $19 = $1 + 106 | 0;
  $20 = HEAP32[$6 >> 2] | 0;
  HEAP16[$19 >> 1] = $20;
  HEAP16[($19 + 2 | 0) >> 1] = $20 >>> 16 | 0;
  HEAP8[($1 + 81 | 0) >> 0] = $0;
  HEAP8[($1 + 80 | 0) >> 0] = $2;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $68 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  $21 = $68;
  HEAP16[(i64toi32_i32$2 + 82 | 0) >> 1] = $21;
  HEAP16[(i64toi32_i32$2 + 84 | 0) >> 1] = $21 >>> 16 | 0;
  HEAP16[(i64toi32_i32$2 + 86 | 0) >> 1] = i64toi32_i32$0;
  HEAP16[(i64toi32_i32$2 + 88 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
  $0 = $cardano_serialization_lib__address__RewardAddress_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8b4ddbbcde95397b(i64toi32_i32$2 + 80 | 0 | 0) | 0;
  global$0 = i64toi32_i32$2 + 112 | 0;
  return $0 | 0;
 }
 
 function cardano_serialization_lib__ProtocolVersion__from_bytes__h9b8b4b32222d300b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, $3 = 0, i64toi32_i32$1 = 0, $15 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  HEAP32[($2 + 152 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 136 | 0) >> 2] = 0;
  HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 144 | 0) >> 2] = $15;
  HEAP32[($2 + 148 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__ProtocolVersion___deserialize__h3c8c85b9f2b44aff($2 + 64 | 0 | 0, $2 + 136 | 0 | 0);
  $1 = ($2 + 136 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 64 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $3 = HEAP32[($2 + 68 | 0) >> 2] | 0;
    HEAP32[($0 + 8 | 0) >> 2] = HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] | 0;
    $1 = 0;
    break label$1;
   }
   $3 = HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] | 0;
   memcpy($2 + 4 | 0 | 0, $2 + 76 | 0 | 0, 60 | 0) | 0;
   HEAP32[($2 + 64 | 0) >> 2] = $3;
   memcpy($2 + 64 | 0 | 4 | 0 | 0, $2 + 4 | 0 | 0, 60 | 0) | 0;
   $3 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 64 | 0 | 0) | 0;
  }
  HEAP32[$0 >> 2] = $1;
  HEAP32[($0 + 4 | 0) >> 2] = $3;
  global$0 = $2 + 160 | 0;
 }
 
 function cardano_serialization_lib__AuxiliaryDataSet__insert__h259df39354baaf70($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $5 = 0, $6 = 0, $54 = 0, $57 = 0;
  $4 = global$0 - 144 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    if (HEAP32[($3 + 20 | 0) >> 2] | 0) {
     break label$2
    }
    HEAP32[($4 + 92 | 0) >> 2] = 0;
    break label$1;
   }
   $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h44c6d4679ef9fae6($4 + 72 | 0 | 0, $3 | 0);
  }
  $5 = $3 + 52 | 0;
  label$3 : {
   label$4 : {
    $6 = HEAP32[($3 + 40 | 0) >> 2] | 0;
    if ($6) {
     break label$4
    }
    HEAP32[($4 + 112 | 0) >> 2] = 0;
    break label$3;
   }
   alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($4 + 112 | 0 | 0, $6 | 0, HEAP32[($3 + 48 | 0) >> 2] | 0 | 0);
  }
  label$5 : {
   label$6 : {
    if (HEAP32[$5 >> 2] | 0) {
     break label$6
    }
    HEAP32[($4 + 128 | 0) >> 2] = 0;
    break label$5;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hc722e22117ee5940($4 + 128 | 0 | 0, $5 | 0);
  }
  memcpy($4 + 8 | 0 | 0, $4 + 72 | 0 | 0, 40 | 0) | 0;
  HEAP32[($4 + 56 | 0) >> 2] = HEAP32[(($4 + 112 | 0) + 8 | 0) >> 2] | 0;
  HEAP32[($4 + 68 | 0) >> 2] = HEAP32[(($4 + 128 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($4 + 112 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($4 + 116 | 0) >> 2] | 0;
  $54 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[($4 + 48 | 0) >> 2] = $54;
  HEAP32[($4 + 52 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[($4 + 128 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($4 + 132 | 0) >> 2] | 0;
  $57 = i64toi32_i32$1;
  i64toi32_i32$1 = $4;
  HEAP32[($4 + 60 | 0) >> 2] = $57;
  HEAP32[($4 + 64 | 0) >> 2] = i64toi32_i32$0;
  linked_hash_map__LinkedHashMap_K_2cV_2cS___insert__h37110d4804766b2f($0 | 0, $1 | 0, $2 | 0, $4 + 8 | 0 | 0);
  global$0 = $4 + 144 | 0;
 }
 
 function $hashbrown__raw__RawIterHashInner_A__20as_20core__iter__traits__iterator__Iterator___next__h14c52054bdac0268($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $6 = 0, $8 = 0, $4 = 0, $7 = 0, $5 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     $2 = HEAP32[($1 + 16 | 0) >> 2] | 0;
     if (!$2) {
      break label$3
     }
     $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     $4 = HEAP32[(HEAP32[$1 >> 2] | 0) >> 2] | 0;
     break label$2;
    }
    $5 = Math_imul(HEAPU8[($1 + 20 | 0) >> 0] | 0, 16843009);
    $6 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    $7 = HEAP32[$1 >> 2] | 0;
    label$4 : while (1) {
     $3 = 0;
     if (($6 & ($6 << 1 | 0) | 0) & -2139062144 | 0) {
      break label$1
     }
     $2 = (HEAP32[($1 + 8 | 0) >> 2] | 0) + 4 | 0;
     HEAP32[($1 + 8 | 0) >> 2] = $2;
     $4 = HEAP32[$7 >> 2] | 0;
     $3 = ((HEAP32[($1 + 4 | 0) >> 2] | 0) + $2 | 0) & $4 | 0;
     HEAP32[($1 + 4 | 0) >> 2] = $3;
     $8 = (HEAP32[($7 + 4 | 0) >> 2] | 0) + $3 | 0;
     $6 = HEAPU8[$8 >> 0] | 0 | ((HEAPU8[($8 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($8 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($8 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     HEAP32[($1 + 12 | 0) >> 2] = $6;
     $2 = $6 ^ $5 | 0;
     $2 = (($2 ^ -1 | 0) & ($2 + -16843009 | 0) | 0) & -2139062144 | 0;
     HEAP32[($1 + 16 | 0) >> 2] = $2;
     if (!$2) {
      continue label$4
     }
     break label$4;
    };
   }
   HEAP32[($1 + 16 | 0) >> 2] = ($2 + -1 | 0) & $2 | 0;
   $2 = (((__wasm_ctz_i32($2 | 0) | 0) >>> 3 | 0) + $3 | 0) & $4 | 0;
   $3 = 1;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $2;
  HEAP32[$0 >> 2] = $3;
 }
 
 function int_to_str($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, $44 = 0, $56 = 0, $62 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h8f4f32b29a620a40($2 + 16 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $3 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  HEAP32[($2 + 76 | 0) >> 2] = 1;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 60 | 0) >> 2] = 1;
  HEAP32[($2 + 64 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 56 | 0) >> 2] = 1058724;
  HEAP32[($2 + 44 | 0) >> 2] = 50;
  HEAP32[($2 + 40 | 0) >> 2] = $3;
  HEAP32[($2 + 72 | 0) >> 2] = $2 + 40 | 0;
  alloc__fmt__format__h6e9e003a52c07309($2 + 24 | 0 | 0, $2 + 56 | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  $1 = ($2 + 40 | 0) + 8 | 0;
  HEAP32[$1 >> 2] = HEAP32[(($2 + 24 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $44 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 40 | 0) >> 2] = $44;
  HEAP32[($2 + 44 | 0) >> 2] = i64toi32_i32$1;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $2 + 40 | 0 | 0);
  HEAP32[(($2 + 56 | 0) + 8 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 40 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 44 | 0) >> 2] | 0;
  $56 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 56 | 0) >> 2] = $56;
  HEAP32[($2 + 60 | 0) >> 2] = i64toi32_i32$0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 56 | 0 | 0);
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $62 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $62;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $2 + 80 | 0;
 }
 
 function cardano_serialization_lib__utils__BigInt__one__h46931845af9c14ed($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, $2 = 0, i64toi32_i32$2 = 0, $3 = 0, $5 = 0, $53 = 0, $56 = 0;
  $1 = global$0 - 64 | 0;
  global$0 = $1;
  $2 = 1058816;
  $3 = 2;
  $4 = 1;
  label$1 : {
   if (!(core__str___impl_20str___starts_with__h05665b83cdd3f774(1058816 | 0, 1 | 0, 45 | 0) | 0)) {
    break label$1
   }
   $3 = 0;
   $4 = core__str___impl_20str___starts_with__h05665b83cdd3f774(1058817 | 0, 0 | 0, 43 | 0) | 0;
   $2 = $4 ? 1058816 : 1058817;
  }
  num_bigint__biguint__convert___impl_20num_traits__Num_20for_20num_bigint__biguint__BigUint___from_str_radix__ha7ce9e2a0cdf83db($1 + 8 | 0 | 0, $2 | 0, $4 | 0, 10 | 0);
  label$2 : {
   if ((HEAPU8[($1 + 8 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$2
   }
   HEAP8[($1 + 8 | 0) >> 0] = HEAPU8[($1 + 9 | 0) >> 0] | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1057568 | 0, 43 | 0, $1 + 8 | 0 | 0, 1057628 | 0, 1058820 | 0);
   abort();
  }
  $2 = $1 + 20 | 0;
  $4 = HEAP32[$2 >> 2] | 0;
  HEAP32[(($1 + 32 | 0) + 8 | 0) >> 2] = $4;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 16 | 0) >> 2] | 0;
  $5 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 32 | 0) >> 2] = $5;
  HEAP32[($1 + 36 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(($1 + 48 | 0) + 8 | 0) >> 2] = $4;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 48 | 0) >> 2] = $5;
  HEAP32[($1 + 52 | 0) >> 2] = i64toi32_i32$1;
  num_bigint__bigint__BigInt__from_biguint__hc8c58ec5989a4432($1 + 8 | 0 | 4 | 0 | 0, $3 | 0, $1 + 48 | 0 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $53 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $53;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 16 | 0) >> 2] | 0;
  $56 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $56;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $1 + 64 | 0;
 }
 
 function cardano_serialization_lib__tx_builder__TransactionBuilder__set_metadata__hf30b1ac4dad4b2e1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 208 | 0;
  global$0 = $2;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 328 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 332 | 0) >> 2] | 0;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 1;
  core__option__Option__T___cloned__h190bc29714e10538($2 + 72 | 0 | 0, ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0 ? $0 + 336 | 0 : 0) | 0);
  HEAP32[($2 + 196 | 0) >> 2] = 0;
  HEAP32[($2 + 184 | 0) >> 2] = 0;
  HEAP32[($2 + 164 | 0) >> 2] = 0;
  label$1 : {
   label$2 : {
    i64toi32_i32$3 = $2;
    i64toi32_i32$2 = HEAP32[($2 + 72 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 76 | 0) >> 2] | 0;
    i64toi32_i32$3 = i64toi32_i32$2;
    i64toi32_i32$2 = 0;
    i64toi32_i32$0 = 1;
    if ((i64toi32_i32$3 | 0) == (i64toi32_i32$0 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) | 0) {
     break label$2
    }
    memcpy($2 + 8 | 0 | 0, $2 + 144 | 0 | 0, 64 | 0) | 0;
    break label$1;
   }
   memcpy($2 + 8 | 0 | 0, $2 + 80 | 0 | 0, 64 | 0) | 0;
   core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__metadata__GeneralTransactionMetadata____h37a091753d7f028f_1($2 + 144 | 0 | 0);
   core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__NativeScripts____hdd7d461255ec800a_2($2 + 184 | 0 | 0);
   core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__plutus__PlutusScripts____h6be1d55eac328b7f_2($2 + 196 | 0 | 0);
  }
  $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h44c6d4679ef9fae6($2 + 72 | 0 | 0, $1 | 0);
  core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__metadata__GeneralTransactionMetadata____h37a091753d7f028f($2 + 8 | 0 | 0);
  memcpy($2 + 8 | 0 | 0, $2 + 72 | 0 | 0, 40 | 0) | 0;
  cardano_serialization_lib__tx_builder__TransactionBuilder__set_auxiliary_data__h12006016667e6f76($0 | 0, $2 + 8 | 0 | 0);
  core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__metadata__GeneralTransactionMetadata____h37a091753d7f028f_1($2 + 8 | 0 | 0);
  core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__NativeScripts____hdd7d461255ec800a_2(($2 + 8 | 0) + 40 | 0 | 0);
  core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__plutus__PlutusScripts____h6be1d55eac328b7f_2($2 + 60 | 0 | 0);
  global$0 = $2 + 208 | 0;
 }
 
 function $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__h54ef63b5f8737164($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, $3 = 0, i64toi32_i32$0 = 0, $5 = 0, $6 = 0, $4 = 0, $60 = 0, $71 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    $3 = HEAP32[$1 >> 2] | 0;
    if (($3 | 0) != (HEAP32[($1 + 4 | 0) >> 2] | 0 | 0)) {
     break label$2
    }
    i64toi32_i32$1 = $0;
    i64toi32_i32$0 = 0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = 0;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[i64toi32_i32$1 >> 2] = HEAP32[(0 + 1067632 | 0) >> 2] | 0;
    break label$1;
   }
   HEAP32[$1 >> 2] = HEAP32[($3 + 68 | 0) >> 2] | 0;
   $4 = $1 + 8 | 0;
   $5 = HEAP32[$4 >> 2] | 0;
   $6 = $5 + -1 | 0;
   HEAP32[$4 >> 2] = $6;
   $3 = HEAP32[($3 + 72 | 0) >> 2] | 0;
   alloc__raw_vec__RawVec_T_2cA___allocate_in__hb0817f92bbb8999a($2 + 8 | 0 | 0, ($5 >>> 0 < $6 >>> 0 ? -1 : $5) | 0, 0 | 0);
   $5 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $6 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   HEAP32[$6 >> 2] = $3;
   $3 = ($2 + 16 | 0) + 8 | 0;
   HEAP32[$3 >> 2] = 1;
   HEAP32[($2 + 20 | 0) >> 2] = $5;
   HEAP32[($2 + 16 | 0) >> 2] = $6;
   HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   $60 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   HEAP32[($2 + 32 | 0) >> 2] = $60;
   HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
   alloc__vec__Vec_T_2cA___extend_desugared__h4fb7a19e1b0f9d48($2 + 16 | 0 | 0, $2 + 32 | 0 | 0);
   HEAP32[($0 + 8 | 0) >> 2] = HEAP32[$3 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   $71 = i64toi32_i32$1;
   i64toi32_i32$1 = $0;
   HEAP32[i64toi32_i32$1 >> 2] = $71;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  }
  global$0 = $2 + 48 | 0;
 }
 
 function $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__hfd55a1b9f78bf10e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $5 = 0, $6 = 0, $4 = 0, $45 = 0, $61 = 0, $72 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    $3 = HEAP32[$1 >> 2] | 0;
    if (($3 | 0) != (HEAP32[($1 + 4 | 0) >> 2] | 0 | 0)) {
     break label$2
    }
    i64toi32_i32$1 = $0;
    i64toi32_i32$0 = 0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = 0;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[i64toi32_i32$1 >> 2] = HEAP32[(0 + 1067624 | 0) >> 2] | 0;
    break label$1;
   }
   HEAP32[$1 >> 2] = HEAP32[($3 + 60 | 0) >> 2] | 0;
   $4 = $1 + 8 | 0;
   $5 = HEAP32[$4 >> 2] | 0;
   $6 = $5 + -1 | 0;
   HEAP32[$4 >> 2] = $6;
   i64toi32_i32$2 = $3;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   alloc__raw_vec__RawVec_T_2cA___allocate_in__h21c363c09c6b25b7($2 + 8 | 0 | 0, ($5 >>> 0 < $6 >>> 0 ? -1 : $5) | 0, 0 | 0);
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $5 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   $45 = i64toi32_i32$0;
   i64toi32_i32$0 = $5;
   HEAP32[i64toi32_i32$0 >> 2] = $45;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   $6 = ($2 + 16 | 0) + 8 | 0;
   HEAP32[$6 >> 2] = 1;
   HEAP32[($2 + 20 | 0) >> 2] = $3;
   HEAP32[($2 + 16 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $61 = i64toi32_i32$1;
   i64toi32_i32$1 = $2;
   HEAP32[($2 + 32 | 0) >> 2] = $61;
   HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$0;
   alloc__vec__Vec_T_2cA___extend_desugared__h5ac61c858da663f2($2 + 16 | 0 | 0, $2 + 32 | 0 | 0);
   HEAP32[($0 + 8 | 0) >> 2] = HEAP32[$6 >> 2] | 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   $72 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[i64toi32_i32$0 >> 2] = $72;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  }
  global$0 = $2 + 48 | 0;
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___insert__h4d28978302e72baa($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $4 = 0, $20 = 0, $23 = 0, $32 = 0, $5 = 0, $5$hi = 0, $55 = 0;
  $3 = global$0 - 64 | 0;
  global$0 = $3;
  alloc__collections__btree__map__BTreeMap_K_2cV___entry__h0855ee0a9acbc700($3 + 8 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[($3 + 8 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    i64toi32_i32$2 = $3 + 20 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $20 = i64toi32_i32$0;
    i64toi32_i32$0 = ($3 + 32 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $20;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($3 + 16 | 0) >> 2] | 0;
    $23 = i64toi32_i32$1;
    i64toi32_i32$1 = $3;
    HEAP32[($3 + 32 | 0) >> 2] = $23;
    HEAP32[($3 + 36 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[(($3 + 48 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $32 = i64toi32_i32$0;
    i64toi32_i32$0 = $3;
    HEAP32[($3 + 48 | 0) >> 2] = $32;
    HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$1;
    alloc__collections__btree__map__entry__VacantEntry_K_2cV___insert__h47d509ec02473685($3 + 32 | 0 | 0, $3 + 48 | 0 | 0) | 0;
    HEAP32[$0 >> 2] = 0;
    break label$1;
   }
   $1 = (HEAP32[(($3 + 8 | 0) + 8 | 0) >> 2] | 0) + Math_imul(HEAP32[(($3 + 8 | 0) + 12 | 0) >> 2] | 0, 12) | 0;
   $4 = $1 + 4 | 0;
   i64toi32_i32$2 = $4;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $5 = i64toi32_i32$1;
   $5$hi = i64toi32_i32$0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $55 = i64toi32_i32$0;
   i64toi32_i32$0 = $4;
   HEAP32[i64toi32_i32$0 >> 2] = $55;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $5$hi;
   i64toi32_i32$0 = $0;
   HEAP32[i64toi32_i32$0 >> 2] = $5;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   $1 = $1 + 12 | 0;
   $4 = HEAP32[$1 >> 2] | 0;
   HEAP32[$1 >> 2] = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
   HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $4;
  }
  global$0 = $3 + 64 | 0;
 }
 
 function byronaddress_to_base58($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, $44 = 0, $56 = 0, $62 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h76f3e067f9139bb4($2 + 16 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $3 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  HEAP32[($2 + 76 | 0) >> 2] = 1;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 60 | 0) >> 2] = 1;
  HEAP32[($2 + 64 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 56 | 0) >> 2] = 1070340;
  HEAP32[($2 + 44 | 0) >> 2] = 131;
  HEAP32[($2 + 40 | 0) >> 2] = $3;
  HEAP32[($2 + 72 | 0) >> 2] = $2 + 40 | 0;
  alloc__fmt__format__h6e9e003a52c07309($2 + 24 | 0 | 0, $2 + 56 | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  $1 = ($2 + 40 | 0) + 8 | 0;
  HEAP32[$1 >> 2] = HEAP32[(($2 + 24 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $44 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 40 | 0) >> 2] = $44;
  HEAP32[($2 + 44 | 0) >> 2] = i64toi32_i32$1;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $2 + 40 | 0 | 0);
  HEAP32[(($2 + 56 | 0) + 8 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 40 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 44 | 0) >> 2] | 0;
  $56 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 56 | 0) >> 2] = $56;
  HEAP32[($2 + 60 | 0) >> 2] = i64toi32_i32$0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 56 | 0 | 0);
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $62 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $62;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $2 + 80 | 0;
 }
 
 function cryptoxide__cryptoutil__write_u64v_be__h6888df4c897d2bb4($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $6 = 0, $6$hi = 0, $43 = 0, $5 = 0, $44 = 0, $46 = 0, $47 = 0, $50 = 0, $51 = 0, $53 = 0, $54 = 0, $58 = 0, $4 = 0, $24 = 0, $30 = 0, $30$hi = 0, $33 = 0, $33$hi = 0, $34 = 0, $34$hi = 0, $37 = 0, $37$hi = 0, $40 = 0, $40$hi = 0, $41 = 0, $41$hi = 0, $42 = 0, $42$hi = 0, $45 = 0, $45$hi = 0, $48 = 0, $48$hi = 0, $49 = 0, $49$hi = 0, $52 = 0, $52$hi = 0, $54$hi = 0, $55 = 0, $55$hi = 0, $56 = 0, $56$hi = 0, $57 = 0;
  label$1 : {
   if (($3 << 3 | 0 | 0) != ($1 | 0)) {
    break label$1
   }
   label$2 : {
    label$3 : {
     label$4 : {
      if (!$3) {
       break label$4
      }
      $4 = $3 << 3 | 0;
      $3 = 0;
      label$5 : while (1) {
       if (($3 | 0) == (-8 | 0)) {
        break label$3
       }
       $5 = $3 + 8 | 0;
       if ($5 >>> 0 > $1 >>> 0) {
        break label$2
       }
       $24 = $0 + $3 | 0;
       i64toi32_i32$2 = $2 + $3 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $6 = i64toi32_i32$0;
       $6$hi = i64toi32_i32$1;
       i64toi32_i32$2 = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 56;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $44 = 0;
       } else {
        i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $44 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       $30 = $44;
       $30$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $6$hi;
       i64toi32_i32$1 = $6;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 40;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        $46 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
        $46 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       }
       i64toi32_i32$0 = $46;
       i64toi32_i32$1 = 16711680;
       i64toi32_i32$3 = 0;
       i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
       $33 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
       $33$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $30$hi;
       i64toi32_i32$2 = $30;
       i64toi32_i32$0 = $33$hi;
       i64toi32_i32$3 = $33;
       i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
       $34 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       $34$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $6$hi;
       i64toi32_i32$1 = $6;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 24;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
        $47 = 0;
       } else {
        i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
        $47 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
       }
       i64toi32_i32$0 = $47;
       i64toi32_i32$1 = 65280;
       i64toi32_i32$3 = 0;
       i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
       $37 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
       $37$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $6$hi;
       i64toi32_i32$2 = $6;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 8;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        $50 = 0;
       } else {
        i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
        $50 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
       }
       i64toi32_i32$1 = $50;
       i64toi32_i32$2 = 255;
       i64toi32_i32$3 = 0;
       i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
       $40 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
       $40$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $37$hi;
       i64toi32_i32$0 = $37;
       i64toi32_i32$1 = $40$hi;
       i64toi32_i32$3 = $40;
       i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
       $41 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
       $41$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $34$hi;
       i64toi32_i32$2 = $34;
       i64toi32_i32$0 = $41$hi;
       i64toi32_i32$3 = $41;
       i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
       $42 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       $42$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $6$hi;
       i64toi32_i32$1 = $6;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 8;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$2 = 0;
        $51 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
        $51 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
       }
       i64toi32_i32$0 = $51;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = -16777216;
       i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
       $45 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
       $45$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $6$hi;
       i64toi32_i32$2 = $6;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 24;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = 0;
        $53 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
        $53 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
       }
       i64toi32_i32$1 = $53;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 16711680;
       i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
       $48 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
       $48$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $45$hi;
       i64toi32_i32$0 = $45;
       i64toi32_i32$1 = $48$hi;
       i64toi32_i32$3 = $48;
       i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
       $49 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
       $49$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $6$hi;
       i64toi32_i32$2 = $6;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 40;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$0 = 0;
        $54 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
        $54 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
       }
       i64toi32_i32$1 = $54;
       i64toi32_i32$2 = 0;
       i64toi32_i32$3 = 65280;
       i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
       $52 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
       $52$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $6$hi;
       i64toi32_i32$0 = $6;
       i64toi32_i32$1 = 0;
       i64toi32_i32$3 = 56;
       i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
       if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
        i64toi32_i32$1 = 0;
        $58 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
       } else {
        i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
        $58 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
       }
       $54$hi = i64toi32_i32$1;
       i64toi32_i32$1 = $52$hi;
       i64toi32_i32$2 = $52;
       i64toi32_i32$0 = $54$hi;
       i64toi32_i32$3 = $58;
       i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
       $55 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
       $55$hi = i64toi32_i32$0;
       i64toi32_i32$0 = $49$hi;
       i64toi32_i32$1 = $49;
       i64toi32_i32$2 = $55$hi;
       i64toi32_i32$3 = $55;
       i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
       $56 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
       $56$hi = i64toi32_i32$2;
       i64toi32_i32$2 = $42$hi;
       i64toi32_i32$0 = $42;
       i64toi32_i32$1 = $56$hi;
       i64toi32_i32$3 = $56;
       i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
       $57 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
       i64toi32_i32$0 = $24;
       $43 = $57;
       HEAP8[i64toi32_i32$0 >> 0] = $43;
       HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $43 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $43 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $43 >>> 24 | 0;
       HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
       HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
       HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
       HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
       $3 = $5;
       if (($4 | 0) != ($3 | 0)) {
        continue label$5
       }
       break label$5;
      };
     }
     return;
    }
    core__slice__index__slice_index_order_fail__h71e247dec3f266ff(-8 | 0, 0 | 0, 1102944 | 0);
    abort();
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($3 + 8 | 0 | 0, $1 | 0, 1102944 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1102880 | 0, 47 | 0, 1102944 | 0);
  abort();
 }
 
 function $core__array__TryFromSliceError_20as_20core__fmt__Debug___fmt__h0fe98dc480ffbdbe($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  (wasm2js_i32$0 = $2, wasm2js_i32$1 = FUNCTION_TABLE[HEAP32[((HEAP32[($1 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($1 + 24 | 0) >> 2] | 0, 1153230, 17) | 0), HEAP8[(wasm2js_i32$0 + 8 | 0) >> 0] = wasm2js_i32$1;
  HEAP32[$2 >> 2] = $1;
  HEAP8[($2 + 9 | 0) >> 0] = 0;
  HEAP32[($2 + 4 | 0) >> 2] = 0;
  HEAP32[($2 + 12 | 0) >> 2] = $0;
  core__fmt__builders__DebugTuple__field__h5e7e3e19ad5aa557($2 | 0, $2 + 12 | 0 | 0, 1153148 | 0) | 0;
  $1 = HEAPU8[($2 + 8 | 0) >> 0] | 0;
  label$1 : {
   $3 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   if (!$3) {
    break label$1
   }
   $0 = $1 & 255 | 0;
   $1 = 1;
   if ($0) {
    break label$1
   }
   label$2 : {
    if (($3 | 0) != (1 | 0)) {
     break label$2
    }
    if (!((HEAPU8[($2 + 9 | 0) >> 0] | 0) & 255 | 0)) {
     break label$2
    }
    $0 = HEAP32[$2 >> 2] | 0;
    if ((HEAPU8[$0 >> 0] | 0) & 4 | 0) {
     break label$2
    }
    $1 = 1;
    if (FUNCTION_TABLE[HEAP32[((HEAP32[($0 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($0 + 24 | 0) >> 2] | 0, 1149896, 1) | 0) {
     break label$1
    }
   }
   $1 = HEAP32[$2 >> 2] | 0;
   $1 = FUNCTION_TABLE[HEAP32[((HEAP32[($1 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($1 + 24 | 0) >> 2] | 0, 1149897, 1) | 0;
  }
  global$0 = $2 + 16 | 0;
  return ($1 & 255 | 0 | 0) != (0 | 0) | 0;
 }
 
 function cardano_serialization_lib__UnitInterval__from_bytes__he07b579a3340b32f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $2 = 0, i64toi32_i32$1 = 0, $3 = 0, $4 = 0, $4$hi = 0, $5 = 0, $5$hi = 0, $18 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 144 | 0;
  global$0 = $2;
  HEAP32[(($2 + 120 | 0) + 16 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 120 | 0) >> 2] = 0;
  HEAP32[($2 + 124 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[(i64toi32_i32$0 + 128 | 0) >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 132 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__UnitInterval___deserialize__h50a71b45bc03a6b4(i64toi32_i32$0 + 48 | 0 | 0, i64toi32_i32$0 + 120 | 0 | 0);
  $1 = (i64toi32_i32$0 + 120 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $3 = (i64toi32_i32$0 + 48 | 0) + 16 | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $4 = i64toi32_i32$1;
  $4$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    if ((i64toi32_i32$2 | 0) == (1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
     break label$2
    }
    i64toi32_i32$2 = $4$hi;
    i64toi32_i32$0 = $0 + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $4;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $5$hi;
    i64toi32_i32$0 = $0 + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $5;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    $1 = 0;
    break label$1;
   }
   $1 = memcpy($2 | 0, $2 + 72 | 0 | 0, 48 | 0) | 0;
   i64toi32_i32$2 = $4$hi;
   i64toi32_i32$0 = ($1 + 48 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $4;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$2 = $5$hi;
   i64toi32_i32$0 = $1;
   HEAP32[(i64toi32_i32$0 + 48 | 0) >> 2] = $5;
   HEAP32[(i64toi32_i32$0 + 52 | 0) >> 2] = i64toi32_i32$2;
   memcpy($3 | 0, i64toi32_i32$0 | 0, 48 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd(i64toi32_i32$0 + 48 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 144 | 0;
 }
 
 function transaction_new($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, $6 = 0, $6$hi = 0, $4 = 0, $5 = 0;
  $3 = global$0 - 944 | 0;
  global$0 = $3;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h356c30395cf13adb($3 + 16 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($3 + 20 | 0) >> 2] | 0;
   $4 = HEAP32[($3 + 16 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__he0885d10b4548804($3 + 8 | 0 | 0, $1 | 0);
   $1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
   $5 = HEAP32[($3 + 8 | 0) >> 2] | 0;
   label$2 : {
    label$3 : {
     if ($2) {
      break label$3
     }
     i64toi32_i32$0 = 0;
     $6 = 0;
     $6$hi = i64toi32_i32$0;
     break label$2;
    }
    $cardano_serialization_lib__metadata__AuxiliaryData_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h85bc793a96c7fd5d($3 + 456 | 0 | 0, $2 | 0);
    i64toi32_i32$0 = 0;
    $6 = 1;
    $6$hi = i64toi32_i32$0;
   }
   i64toi32_i32$0 = $6$hi;
   HEAP32[($3 + 448 | 0) >> 2] = $6;
   HEAP32[($3 + 452 | 0) >> 2] = i64toi32_i32$0;
   memcpy($3 + 520 | 0 | 0, $3 + 448 | 0 | 0, 72 | 0) | 0;
   cardano_serialization_lib__Transaction__new__h1cddc40f64679f42($3 + 24 | 0 | 0, $4 | 0, $5 | 0, $3 + 520 | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   memcpy($3 + 520 | 0 | 0, $3 + 24 | 0 | 0, 424 | 0) | 0;
   $0 = $cardano_serialization_lib__Transaction_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hf1e81f974efa699a($3 + 520 | 0 | 0) | 0;
   global$0 = $3 + 944 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function cardano_serialization_lib__TransactionInputs__from_bytes__h08f00e98055eb5b9($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $15 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[($2 + 168 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 152 | 0) >> 2] = 0;
  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 160 | 0) >> 2] = $15;
  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__TransactionInputs___deserialize__hccdd71f9bd7c3281($2 + 80 | 0 | 0, $2 + 152 | 0 | 0);
  $1 = ($2 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[(($2 + 80 | 0) + 12 | 0) >> 2] | 0;
    HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] = $1;
    i64toi32_i32$1 = HEAP32[($2 + 84 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    $3 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 8 | 0) >> 2] = $3;
    HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($0 + 12 | 0) >> 2] = $1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 8 | 0 | 4 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__TransactionOutputs__from_bytes__h862a67100c360169($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $15 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[($2 + 168 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 152 | 0) >> 2] = 0;
  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 160 | 0) >> 2] = $15;
  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__TransactionOutputs___deserialize__h3f9df29df082d970($2 + 80 | 0 | 0, $2 + 152 | 0 | 0);
  $1 = ($2 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[(($2 + 80 | 0) + 12 | 0) >> 2] | 0;
    HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] = $1;
    i64toi32_i32$1 = HEAP32[($2 + 84 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    $3 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 8 | 0) >> 2] = $3;
    HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($0 + 12 | 0) >> 2] = $1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 8 | 0 | 4 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__Certificates__from_bytes__h83395de05ee7623a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $15 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[($2 + 168 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 152 | 0) >> 2] = 0;
  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 160 | 0) >> 2] = $15;
  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__Certificates___deserialize__hd24284feaee200d9($2 + 80 | 0 | 0, $2 + 152 | 0 | 0);
  $1 = ($2 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[(($2 + 80 | 0) + 12 | 0) >> 2] | 0;
    HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] = $1;
    i64toi32_i32$1 = HEAP32[($2 + 84 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    $3 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 8 | 0) >> 2] = $3;
    HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($0 + 12 | 0) >> 2] = $1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 8 | 0 | 4 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__Ed25519KeyHashes__from_bytes__h253963bde8fe7046($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $15 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[($2 + 168 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 152 | 0) >> 2] = 0;
  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 160 | 0) >> 2] = $15;
  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__Ed25519KeyHashes___deserialize__hae609f6be80519f0($2 + 80 | 0 | 0, $2 + 152 | 0 | 0);
  $1 = ($2 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[(($2 + 80 | 0) + 12 | 0) >> 2] | 0;
    HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] = $1;
    i64toi32_i32$1 = HEAP32[($2 + 84 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    $3 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 8 | 0) >> 2] = $3;
    HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($0 + 12 | 0) >> 2] = $1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 8 | 0 | 4 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__Relays__from_bytes__hceced7749b59348d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $15 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[($2 + 168 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 152 | 0) >> 2] = 0;
  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 160 | 0) >> 2] = $15;
  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__Relays___deserialize__h9918765c1fb6ecbf($2 + 80 | 0 | 0, $2 + 152 | 0 | 0);
  $1 = ($2 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[(($2 + 80 | 0) + 12 | 0) >> 2] | 0;
    HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] = $1;
    i64toi32_i32$1 = HEAP32[($2 + 84 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    $3 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 8 | 0) >> 2] = $3;
    HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($0 + 12 | 0) >> 2] = $1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 8 | 0 | 4 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__URL__from_bytes__h0d714854697691cb($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $15 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[($2 + 168 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 152 | 0) >> 2] = 0;
  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 160 | 0) >> 2] = $15;
  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__URL___deserialize__hc711c8b8b85e87e8($2 + 80 | 0 | 0, $2 + 152 | 0 | 0);
  $1 = ($2 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[(($2 + 80 | 0) + 12 | 0) >> 2] | 0;
    HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] = $1;
    i64toi32_i32$1 = HEAP32[($2 + 84 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    $3 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 8 | 0) >> 2] = $3;
    HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($0 + 12 | 0) >> 2] = $1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 8 | 0 | 4 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__DNSRecordAorAAAA__from_bytes__h2e359d2f8518fc69($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $15 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[($2 + 168 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 152 | 0) >> 2] = 0;
  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 160 | 0) >> 2] = $15;
  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__DNSRecordAorAAAA___deserialize__hd54709d96c351cb8($2 + 80 | 0 | 0, $2 + 152 | 0 | 0);
  $1 = ($2 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[(($2 + 80 | 0) + 12 | 0) >> 2] | 0;
    HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] = $1;
    i64toi32_i32$1 = HEAP32[($2 + 84 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    $3 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 8 | 0) >> 2] = $3;
    HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($0 + 12 | 0) >> 2] = $1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 8 | 0 | 4 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__DNSRecordSRV__from_bytes__hba3f0817a593a4d5($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $15 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[($2 + 168 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 152 | 0) >> 2] = 0;
  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 160 | 0) >> 2] = $15;
  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__DNSRecordSRV___deserialize__h30f1f7710b983e30($2 + 80 | 0 | 0, $2 + 152 | 0 | 0);
  $1 = ($2 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[(($2 + 80 | 0) + 12 | 0) >> 2] | 0;
    HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] = $1;
    i64toi32_i32$1 = HEAP32[($2 + 84 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    $3 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 8 | 0) >> 2] = $3;
    HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($0 + 12 | 0) >> 2] = $1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 8 | 0 | 4 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__SingleHostName__from_bytes__h1cab2c930890fb43($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $16 = 0, $3$hi = 0, $4$hi = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[($2 + 168 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 152 | 0) >> 2] = 0;
  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $16 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 160 | 0) >> 2] = $16;
  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__SingleHostName___deserialize__h69e60f7aa4500347($2 + 80 | 0 | 0, $2 + 152 | 0 | 0);
  $1 = ($2 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    i64toi32_i32$2 = ($2 + 80 | 0) + 12 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $3 = i64toi32_i32$1;
    $3$hi = i64toi32_i32$0;
    i64toi32_i32$1 = ($2 + 8 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[($2 + 84 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    $4 = i64toi32_i32$0;
    $4$hi = i64toi32_i32$1;
    i64toi32_i32$0 = $2;
    HEAP32[($2 + 8 | 0) >> 2] = $4;
    HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $3$hi;
    i64toi32_i32$0 = $0 + 12 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $3;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $4$hi;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $4;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 8 | 0 | 4 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__MultiHostName__from_bytes__h0bcafc7ebc8a45ae($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $15 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[($2 + 168 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 152 | 0) >> 2] = 0;
  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 160 | 0) >> 2] = $15;
  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__MultiHostName___deserialize__h60fdbf7365429725($2 + 80 | 0 | 0, $2 + 152 | 0 | 0);
  $1 = ($2 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[(($2 + 80 | 0) + 12 | 0) >> 2] | 0;
    HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] = $1;
    i64toi32_i32$1 = HEAP32[($2 + 84 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    $3 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 8 | 0) >> 2] = $3;
    HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($0 + 12 | 0) >> 2] = $1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 8 | 0 | 4 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__StakeCredentials__from_bytes__h753d9b0af791e159($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $15 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[($2 + 168 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 152 | 0) >> 2] = 0;
  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 160 | 0) >> 2] = $15;
  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__StakeCredentials___deserialize__hc50a371d41ef0157($2 + 80 | 0 | 0, $2 + 152 | 0 | 0);
  $1 = ($2 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[(($2 + 80 | 0) + 12 | 0) >> 2] | 0;
    HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] = $1;
    i64toi32_i32$1 = HEAP32[($2 + 84 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    $3 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 8 | 0) >> 2] = $3;
    HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($0 + 12 | 0) >> 2] = $1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 8 | 0 | 4 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__RewardAddresses__from_bytes__hf88feb2c357f0f9d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $15 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[($2 + 168 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 152 | 0) >> 2] = 0;
  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 160 | 0) >> 2] = $15;
  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__RewardAddresses___deserialize__hfc34473540a771a7($2 + 80 | 0 | 0, $2 + 152 | 0 | 0);
  $1 = ($2 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[(($2 + 80 | 0) + 12 | 0) >> 2] | 0;
    HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] = $1;
    i64toi32_i32$1 = HEAP32[($2 + 84 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    $3 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 8 | 0) >> 2] = $3;
    HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($0 + 12 | 0) >> 2] = $1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 8 | 0 | 4 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__ScriptAll__from_bytes__h6e2e7af182c0d5c6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $15 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[($2 + 168 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 152 | 0) >> 2] = 0;
  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 160 | 0) >> 2] = $15;
  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__ScriptAll___deserialize__h05fd39627d4fe528($2 + 80 | 0 | 0, $2 + 152 | 0 | 0);
  $1 = ($2 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[(($2 + 80 | 0) + 12 | 0) >> 2] | 0;
    HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] = $1;
    i64toi32_i32$1 = HEAP32[($2 + 84 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    $3 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 8 | 0) >> 2] = $3;
    HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($0 + 12 | 0) >> 2] = $1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 8 | 0 | 4 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__ScriptAny__from_bytes__h711e5dc2380171b3($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $15 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[($2 + 168 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 152 | 0) >> 2] = 0;
  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 160 | 0) >> 2] = $15;
  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__ScriptAny___deserialize__hec03b7272f1e2547($2 + 80 | 0 | 0, $2 + 152 | 0 | 0);
  $1 = ($2 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[(($2 + 80 | 0) + 12 | 0) >> 2] | 0;
    HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] = $1;
    i64toi32_i32$1 = HEAP32[($2 + 84 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    $3 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 8 | 0) >> 2] = $3;
    HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($0 + 12 | 0) >> 2] = $1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 8 | 0 | 4 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__ScriptNOfK__from_bytes__haf30bcd1e11379d4($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $16 = 0, $3$hi = 0, $4$hi = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[($2 + 168 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 152 | 0) >> 2] = 0;
  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $16 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 160 | 0) >> 2] = $16;
  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__ScriptNOfK___deserialize__hee5ff3e721c31521($2 + 80 | 0 | 0, $2 + 152 | 0 | 0);
  $1 = ($2 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    i64toi32_i32$2 = ($2 + 80 | 0) + 12 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $3 = i64toi32_i32$1;
    $3$hi = i64toi32_i32$0;
    i64toi32_i32$1 = ($2 + 8 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[($2 + 84 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    $4 = i64toi32_i32$0;
    $4$hi = i64toi32_i32$1;
    i64toi32_i32$0 = $2;
    HEAP32[($2 + 8 | 0) >> 2] = $4;
    HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $3$hi;
    i64toi32_i32$0 = $0 + 12 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $3;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $4$hi;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $4;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 8 | 0 | 4 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__GenesisHashes__from_bytes__h7408e7ced6e64cd4($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $15 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[($2 + 168 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 152 | 0) >> 2] = 0;
  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 160 | 0) >> 2] = $15;
  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__GenesisHashes___deserialize__h3dd731c61bb9d2cd($2 + 80 | 0 | 0, $2 + 152 | 0 | 0);
  $1 = ($2 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[(($2 + 80 | 0) + 12 | 0) >> 2] | 0;
    HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] = $1;
    i64toi32_i32$1 = HEAP32[($2 + 84 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    $3 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 8 | 0) >> 2] = $3;
    HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($0 + 12 | 0) >> 2] = $1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 8 | 0 | 4 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__ScriptHashes__from_bytes__h2865c01a0beedfb5($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $15 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[($2 + 168 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 152 | 0) >> 2] = 0;
  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 160 | 0) >> 2] = $15;
  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__ScriptHashes___deserialize__h02ad1484d76cb779($2 + 80 | 0 | 0, $2 + 152 | 0 | 0);
  $1 = ($2 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[(($2 + 80 | 0) + 12 | 0) >> 2] | 0;
    HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] = $1;
    i64toi32_i32$1 = HEAP32[($2 + 84 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    $3 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 8 | 0) >> 2] = $3;
    HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($0 + 12 | 0) >> 2] = $1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 8 | 0 | 4 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__ProtocolVersions__from_bytes__h8eadcdd3cf7ce117($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $15 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[($2 + 168 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 152 | 0) >> 2] = 0;
  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 160 | 0) >> 2] = $15;
  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__ProtocolVersions___deserialize__hb8264e18664de337($2 + 80 | 0 | 0, $2 + 152 | 0 | 0);
  $1 = ($2 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[(($2 + 80 | 0) + 12 | 0) >> 2] | 0;
    HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] = $1;
    i64toi32_i32$1 = HEAP32[($2 + 84 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    $3 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 8 | 0) >> 2] = $3;
    HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($0 + 12 | 0) >> 2] = $1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 8 | 0 | 4 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__TransactionBodies__from_bytes__hf1ee35799a18c3a1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $15 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[($2 + 168 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 152 | 0) >> 2] = 0;
  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 160 | 0) >> 2] = $15;
  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__TransactionBodies___deserialize__h44087f0dae966260($2 + 80 | 0 | 0, $2 + 152 | 0 | 0);
  $1 = ($2 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[(($2 + 80 | 0) + 12 | 0) >> 2] | 0;
    HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] = $1;
    i64toi32_i32$1 = HEAP32[($2 + 84 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    $3 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 8 | 0) >> 2] = $3;
    HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($0 + 12 | 0) >> 2] = $1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 8 | 0 | 4 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__TransactionWitnessSets__from_bytes__heb611ee40259505d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $15 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[($2 + 168 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 152 | 0) >> 2] = 0;
  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 160 | 0) >> 2] = $15;
  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__TransactionWitnessSets___deserialize__hdc8da232218df49c($2 + 80 | 0 | 0, $2 + 152 | 0 | 0);
  $1 = ($2 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[(($2 + 80 | 0) + 12 | 0) >> 2] | 0;
    HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] = $1;
    i64toi32_i32$1 = HEAP32[($2 + 84 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    $3 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 8 | 0) >> 2] = $3;
    HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($0 + 12 | 0) >> 2] = $1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 8 | 0 | 4 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__AssetName__from_bytes__h03d96fd184e80c73($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $15 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[($2 + 168 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 152 | 0) >> 2] = 0;
  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 160 | 0) >> 2] = $15;
  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__AssetName___deserialize__hed130337b055988b($2 + 80 | 0 | 0, $2 + 152 | 0 | 0);
  $1 = ($2 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[(($2 + 80 | 0) + 12 | 0) >> 2] | 0;
    HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] = $1;
    i64toi32_i32$1 = HEAP32[($2 + 84 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    $3 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 8 | 0) >> 2] = $3;
    HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($0 + 12 | 0) >> 2] = $1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 8 | 0 | 4 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__AssetNames__from_bytes__h3185a85ff413abc3($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $15 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[($2 + 168 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 152 | 0) >> 2] = 0;
  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 160 | 0) >> 2] = $15;
  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__AssetNames___deserialize__ha31672ab6981a455($2 + 80 | 0 | 0, $2 + 152 | 0 | 0);
  $1 = ($2 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[(($2 + 80 | 0) + 12 | 0) >> 2] | 0;
    HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] = $1;
    i64toi32_i32$1 = HEAP32[($2 + 84 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    $3 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 8 | 0) >> 2] = $3;
    HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($0 + 12 | 0) >> 2] = $1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 8 | 0 | 4 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__Assets__from_bytes__hdce3103dfbe0c848($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $15 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[($2 + 168 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 152 | 0) >> 2] = 0;
  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 160 | 0) >> 2] = $15;
  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__Assets___deserialize__h1d5e068ce9d78042($2 + 80 | 0 | 0, $2 + 152 | 0 | 0);
  $1 = ($2 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[(($2 + 80 | 0) + 12 | 0) >> 2] | 0;
    HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] = $1;
    i64toi32_i32$1 = HEAP32[($2 + 84 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    $3 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 8 | 0) >> 2] = $3;
    HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($0 + 12 | 0) >> 2] = $1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 8 | 0 | 4 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function assets_insert($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $4 = 0, $5 = 0, $6 = 0, $7 = 0, $7$hi = 0;
  $3 = global$0 - 64 | 0;
  global$0 = $3;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hf24f358605852732($3 + 40 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $4 = HEAP32[($3 + 44 | 0) >> 2] | 0;
   $5 = HEAP32[($3 + 40 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h9c68abd5a6a78973($3 + 32 | 0 | 0, $1 | 0);
   if (!$2) {
    break label$1
   }
   $0 = HEAP32[($3 + 36 | 0) >> 2] | 0;
   $6 = HEAP32[($3 + 32 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($3 + 24 | 0 | 0, $2 | 0);
   $1 = HEAP32[($3 + 28 | 0) >> 2] | 0;
   $2 = HEAP32[($3 + 24 | 0) >> 2] | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($3 + 48 | 0 | 0, $6 | 0);
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   alloc__collections__btree__map__BTreeMap_K_2cV___insert__hc7622c6487a4ba88($3 + 8 | 0 | 0, $5 | 0, $3 + 48 | 0 | 0, i64toi32_i32$0 | 0, i64toi32_i32$1 | 0);
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[($3 + 16 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($3 + 20 | 0) >> 2] | 0;
   $7 = i64toi32_i32$1;
   $7$hi = i64toi32_i32$0;
   i64toi32_i32$2 = $3;
   i64toi32_i32$0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   $0 = 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($4 | 0, 0 | 0) | 0;
   label$2 : {
    if (!i64toi32_i32$0) {
     break label$2
    }
    i64toi32_i32$1 = $7$hi;
    $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810($7 | 0, i64toi32_i32$1 | 0) | 0;
   }
   global$0 = $3 + 64 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function cardano_serialization_lib__MultiAsset__from_bytes__hb943bcc7552ea398($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $15 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[($2 + 168 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 152 | 0) >> 2] = 0;
  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 160 | 0) >> 2] = $15;
  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__MultiAsset___deserialize__h0ad8d9aa7509b889($2 + 80 | 0 | 0, $2 + 152 | 0 | 0);
  $1 = ($2 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[(($2 + 80 | 0) + 12 | 0) >> 2] | 0;
    HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] = $1;
    i64toi32_i32$1 = HEAP32[($2 + 84 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    $3 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 8 | 0) >> 2] = $3;
    HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($0 + 12 | 0) >> 2] = $1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 8 | 0 | 4 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__Mint__from_bytes__h8327d60950d2901d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $15 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[($2 + 168 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 152 | 0) >> 2] = 0;
  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 160 | 0) >> 2] = $15;
  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__Mint___deserialize__hd75757d6517eec3f($2 + 80 | 0 | 0, $2 + 152 | 0 | 0);
  $1 = ($2 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[(($2 + 80 | 0) + 12 | 0) >> 2] | 0;
    HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] = $1;
    i64toi32_i32$1 = HEAP32[($2 + 84 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    $3 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 8 | 0) >> 2] = $3;
    HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($0 + 12 | 0) >> 2] = $1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 8 | 0 | 4 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function value_checked_add($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $3 = 0, $46 = 0, $53 = 0, $58 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h5db5149478ec5345($2 + 16 | 0 | 0, $0 | 0);
    if (!$1) {
     break label$2
    }
    $0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
    $3 = HEAP32[($2 + 16 | 0) >> 2] | 0;
    wasm_bindgen____rt__WasmRefCell_T___borrow__h5db5149478ec5345($2 + 8 | 0 | 0, $1 | 0);
    $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    cardano_serialization_lib__utils__Value__checked_add__h5184687782847801($2 + 24 | 0 | 0, $3 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    i64toi32_i32$2 = $2 + 48 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $46 = i64toi32_i32$0;
    i64toi32_i32$0 = ($2 + 56 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $46;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = ($2 + 24 | 0) + 16 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $53 = i64toi32_i32$1;
    i64toi32_i32$1 = ($2 + 56 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $53;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = ($2 + 24 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $58 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[($2 + 56 | 0) >> 2] = $58;
    HEAP32[($2 + 60 | 0) >> 2] = i64toi32_i32$1;
    $0 = $cardano_serialization_lib__utils__Value_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h50a1108e1e08f966($2 + 56 | 0 | 0) | 0;
    global$0 = $2 + 80 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 28 | 0) >> 2] | 0 | 0);
  abort();
 }
 
 function value_checked_sub($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $3 = 0, $46 = 0, $53 = 0, $58 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h5db5149478ec5345($2 + 16 | 0 | 0, $0 | 0);
    if (!$1) {
     break label$2
    }
    $0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
    $3 = HEAP32[($2 + 16 | 0) >> 2] | 0;
    wasm_bindgen____rt__WasmRefCell_T___borrow__h5db5149478ec5345($2 + 8 | 0 | 0, $1 | 0);
    $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    cardano_serialization_lib__utils__Value__checked_sub__hadecd14ba2ae4b3b($2 + 24 | 0 | 0, $3 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    i64toi32_i32$2 = $2 + 48 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $46 = i64toi32_i32$0;
    i64toi32_i32$0 = ($2 + 56 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $46;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = ($2 + 24 | 0) + 16 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $53 = i64toi32_i32$1;
    i64toi32_i32$1 = ($2 + 56 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $53;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = ($2 + 24 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $58 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[($2 + 56 | 0) >> 2] = $58;
    HEAP32[($2 + 60 | 0) >> 2] = i64toi32_i32$1;
    $0 = $cardano_serialization_lib__utils__Value_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h50a1108e1e08f966($2 + 56 | 0 | 0) | 0;
    global$0 = $2 + 80 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 28 | 0) >> 2] | 0 | 0);
  abort();
 }
 
 function cardano_serialization_lib__utils__BigInt__from_bytes__hd0e437370f824683($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $16 = 0, $3$hi = 0, $4$hi = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[($2 + 168 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 152 | 0) >> 2] = 0;
  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $16 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 160 | 0) >> 2] = $16;
  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__utils__BigInt_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hebb3828b833490eb($2 + 80 | 0 | 0, $2 + 152 | 0 | 0);
  $1 = ($2 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    i64toi32_i32$2 = ($2 + 80 | 0) + 12 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $3 = i64toi32_i32$1;
    $3$hi = i64toi32_i32$0;
    i64toi32_i32$1 = ($2 + 8 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[($2 + 84 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    $4 = i64toi32_i32$0;
    $4$hi = i64toi32_i32$1;
    i64toi32_i32$0 = $2;
    HEAP32[($2 + 8 | 0) >> 2] = $4;
    HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $3$hi;
    i64toi32_i32$0 = $0 + 12 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $3;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $4$hi;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $4;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 8 | 0 | 4 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__metadata__MetadataList__from_bytes__hcd9e84ca972fee2f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $15 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[($2 + 168 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 152 | 0) >> 2] = 0;
  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 160 | 0) >> 2] = $15;
  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__metadata__MetadataList_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h6a4931784602dba8($2 + 80 | 0 | 0, $2 + 152 | 0 | 0);
  $1 = ($2 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[(($2 + 80 | 0) + 12 | 0) >> 2] | 0;
    HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] = $1;
    i64toi32_i32$1 = HEAP32[($2 + 84 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    $3 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 8 | 0) >> 2] = $3;
    HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($0 + 12 | 0) >> 2] = $1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 8 | 0 | 4 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__metadata__MetadataList__get__hc998d9826d234933($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $4 = 0, $34 = 0, $39 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  label$1 : {
   $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   if ($4 >>> 0 <= $2 >>> 0) {
    break label$1
   }
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         $2 = (HEAP32[$1 >> 2] | 0) + Math_imul($2, 48) | 0;
         switch (HEAP32[$2 >> 2] | 0 | 0) {
         case 4:
          break label$3;
         case 3:
          break label$4;
         case 2:
          break label$5;
         case 1:
          break label$6;
         default:
          break label$7;
         };
        }
        $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__hdeea20968268d729($3 + 8 | 0 | 0, $2 + 8 | 0 | 0);
        HEAP32[$3 >> 2] = 0;
        break label$2;
       }
       $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hf69db734dd831996($3 | 4 | 0 | 0, $2 + 4 | 0 | 0);
       HEAP32[$3 >> 2] = 1;
       break label$2;
      }
      i64toi32_i32$2 = $2 + 16 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $34 = i64toi32_i32$0;
      i64toi32_i32$0 = $3 + 16 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $34;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $2 + 8 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $39 = i64toi32_i32$1;
      i64toi32_i32$1 = $3 + 8 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $39;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[$3 >> 2] = 2;
      break label$2;
     }
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($3 | 4 | 0 | 0, $2 + 4 | 0 | 0);
     HEAP32[$3 >> 2] = 3;
     break label$2;
    }
    $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($3 | 4 | 0 | 0, $2 + 4 | 0 | 0);
    HEAP32[$3 >> 2] = 4;
   }
   memcpy($0 | 0, $3 | 0, 48 | 0) | 0;
   global$0 = $3 + 48 | 0;
   return;
  }
  core__panicking__panic_bounds_check__h808b524af17640b1($2 | 0, $4 | 0, 1060212 | 0);
  abort();
 }
 
 function cardano_serialization_lib__metadata__TransactionMetadatumLabels__from_bytes__h85692917aa346cbe($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $15 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[($2 + 168 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 152 | 0) >> 2] = 0;
  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 160 | 0) >> 2] = $15;
  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__metadata__TransactionMetadatumLabels_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__haad9b7d9d4089367($2 + 80 | 0 | 0, $2 + 152 | 0 | 0);
  $1 = ($2 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[(($2 + 80 | 0) + 12 | 0) >> 2] | 0;
    HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] = $1;
    i64toi32_i32$1 = HEAP32[($2 + 84 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    $3 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 8 | 0) >> 2] = $3;
    HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($0 + 12 | 0) >> 2] = $1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 8 | 0 | 4 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__crypto__Bip32PublicKey__derive__he58fcef416b54f88($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 112 | 0;
  global$0 = $3;
  ed25519_bip32__key__XPub__derive__h771befcd81af2ff6($3 + 40 | 0 | 0, $1 | 0, $2 | 0);
  $1 = 1;
  $2 = HEAPU8[($3 + 41 | 0) >> 0] | 0;
  label$1 : {
   label$2 : {
    if ((HEAPU8[($3 + 40 | 0) >> 0] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    memcpy($0 + 2 | 0 | 0, $3 + 40 | 0 | 2 | 0 | 0, 63 | 0) | 0;
    HEAP8[($0 + 1 | 0) >> 0] = $2;
    $1 = 0;
    break label$1;
   }
   HEAP8[($3 + 15 | 0) >> 0] = $2;
   HEAP32[($3 + 60 | 0) >> 2] = 1;
   HEAP32[($3 + 44 | 0) >> 2] = 1;
   HEAP32[($3 + 48 | 0) >> 2] = 0;
   HEAP32[($3 + 40 | 0) >> 2] = 1066504;
   HEAP32[($3 + 36 | 0) >> 2] = 110;
   HEAP32[($3 + 56 | 0) >> 2] = $3 + 32 | 0;
   HEAP32[($3 + 32 | 0) >> 2] = $3 + 15 | 0;
   alloc__fmt__format__h6e9e003a52c07309($3 + 16 | 0 | 0, $3 + 40 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 | 0, $3 + 16 | 0 | 0);
   $2 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[$3 >> 2] | 0 | 0, HEAP32[($3 + 4 | 0) >> 2] | 0 | 0) | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 16 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 16 | 0 | 0);
   HEAP32[($0 + 4 | 0) >> 2] = $2;
  }
  HEAP8[$0 >> 0] = $1;
  global$0 = $3 + 112 | 0;
 }
 
 function serde__ser__Serializer__collect_seq__h04407a2a911b47b3($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $4 = 0, $3 = 0, $5 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  $_alloc__vec__Vec_T_2cA__20as_20core__iter__traits__collect__IntoIterator___into_iter__h770da9f254a2d1a7($2 + 16 | 0 | 0, $1 | 0);
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  HEAP32[($2 + 24 | 0) >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
  HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$1;
  serde__ser__iterator_len_hint__h4043e0ddab155abd($2 + 8 | 0 | 0, $2 + 24 | 0 | 0);
  $1 = 1068487;
  $3 = 1;
  label$1 : {
   $4 = (HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) == (1 | 0) & !(HEAP32[($2 + 12 | 0) >> 2] | 0) | 0;
   if (($4 | 0) != (1 | 0)) {
    break label$1
   }
   alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb(HEAP32[$0 >> 2] | 0 | 0, 1068487 | 0, 1 | 0);
   $3 = 0;
   $1 = 1068505;
  }
  alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb(HEAP32[$0 >> 2] | 0 | 0, $1 | 0, 1 | 0);
  label$2 : {
   label$3 : {
    label$4 : {
     $1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
     $5 = HEAP32[($2 + 28 | 0) >> 2] | 0;
     if (($1 | 0) == ($5 | 0)) {
      break label$4
     }
     label$5 : while (1) {
      $4 = $1 + 24 | 0;
      label$6 : {
       if (($3 & 255 | 0 | 0) == (1 | 0)) {
        break label$6
       }
       alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb(HEAP32[$0 >> 2] | 0 | 0, 1068489 | 0, 1 | 0);
      }
      serde_json__value__ser___impl_20serde__ser__Serialize_20for_20serde_json__value__Value___serialize__ha2851daf0650b497($1 | 0, $0 | 0) | 0;
      $3 = 2;
      $1 = $4;
      if (($5 | 0) != ($1 | 0)) {
       continue label$5
      }
      break label$3;
     };
    }
    if ($4) {
     break label$2
    }
   }
   alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb(HEAP32[$0 >> 2] | 0 | 0, 1068505 | 0, 1 | 0);
  }
  global$0 = $2 + 32 | 0;
  return 0 | 0;
 }
 
 function $cardano_serialization_lib__address__Address_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__he3542444dd01e6b6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, $3 = 0;
  $2 = global$0 - 128 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___bytes__hc697ccccfa39fd82($2 + 80 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[($2 + 92 | 0) >> 2] | 0;
    HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = $1;
    HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] = $1;
    i64toi32_i32$1 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    $3 = HEAP32[($2 + 84 | 0) >> 2] | 0;
    HEAP32[($2 + 32 | 0) >> 2] = $3;
    HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($2 + 16 | 0) >> 2] = $3;
    HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
    cardano_serialization_lib__address__Address__from_bytes_impl__h0b2b4c3a1f339e7a($0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 16 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 16 | 0 | 0);
    break label$1;
   }
   memcpy($2 + 87 | 0 | 0, memcpy($2 + 32 | 0 | 4 | 0 | 0, $2 + 88 | 0 | 0, 40 | 0) | 0 | 0, 40 | 0) | 0;
   HEAP8[($0 + 8 | 0) >> 0] = 2;
   HEAP32[($0 + 56 | 0) >> 2] = 0;
   memcpy($0 + 9 | 0 | 0, $2 + 80 | 0 | 0, 47 | 0) | 0;
   i64toi32_i32$1 = 0;
   HEAP32[$0 >> 2] = 1;
   HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$1;
  }
  global$0 = $2 + 128 | 0;
 }
 
 function enterpriseaddress_new($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $19 = 0, $3 = 0, $6 = 0, $7 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $4 = 0, $8 = 0, $8$hi = 0, $5 = 0, $9 = 0, $9$hi = 0, $36 = 0, $55 = 0, $59 = 0, $70 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h7d8a0640f2deb41e($2 + 8 | 0 | 0, $1 | 0);
  $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  $19 = $1 + 25 | 0;
  $4 = HEAPU8[$19 >> 0] | 0 | ((HEAPU8[($19 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($19 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($19 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $1 + 17 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  $5 = HEAPU8[$1 >> 0] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$0;
  $6 = $2 + 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 9 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $36 = i64toi32_i32$0;
  i64toi32_i32$0 = $6;
  HEAP32[i64toi32_i32$0 >> 2] = $36;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $1 = $2 + 32 | 0;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = $1;
  HEAP32[i64toi32_i32$0 >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $7 = $2 + 40 | 0;
  HEAP32[$7 >> 2] = $4;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $9;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$1;
  core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $6;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $55 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 58 | 0;
  $20 = $55;
  HEAP16[i64toi32_i32$1 >> 1] = $20;
  HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $20 >>> 16 | 0;
  HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = i64toi32_i32$0;
  HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $59 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 66 | 0;
  $21 = $59;
  HEAP16[i64toi32_i32$0 >> 1] = $21;
  HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $21 >>> 16 | 0;
  HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$1;
  HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
  $22 = $2 + 74 | 0;
  $23 = HEAP32[$7 >> 2] | 0;
  HEAP16[$22 >> 1] = $23;
  HEAP16[($22 + 2 | 0) >> 1] = $23 >>> 16 | 0;
  HEAP8[($2 + 49 | 0) >> 0] = $5;
  HEAP8[($2 + 48 | 0) >> 0] = $0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $70 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  $24 = $70;
  HEAP16[(i64toi32_i32$2 + 50 | 0) >> 1] = $24;
  HEAP16[(i64toi32_i32$2 + 52 | 0) >> 1] = $24 >>> 16 | 0;
  HEAP16[(i64toi32_i32$2 + 54 | 0) >> 1] = i64toi32_i32$0;
  HEAP16[(i64toi32_i32$2 + 56 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
  $1 = $cardano_serialization_lib__address__EnterpriseAddress_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hc6936df3a6b251b0(i64toi32_i32$2 + 48 | 0 | 0) | 0;
  global$0 = i64toi32_i32$2 + 112 | 0;
  return $1 | 0;
 }
 
 function rewardaddress_new($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $19 = 0, $3 = 0, $6 = 0, $7 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $4 = 0, $8 = 0, $8$hi = 0, $5 = 0, $9 = 0, $9$hi = 0, $36 = 0, $55 = 0, $59 = 0, $70 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h7d8a0640f2deb41e($2 + 8 | 0 | 0, $1 | 0);
  $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  $19 = $1 + 25 | 0;
  $4 = HEAPU8[$19 >> 0] | 0 | ((HEAPU8[($19 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($19 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($19 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $1 + 17 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $8 = i64toi32_i32$0;
  $8$hi = i64toi32_i32$1;
  $5 = HEAPU8[$1 >> 0] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$0;
  $6 = $2 + 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 9 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $36 = i64toi32_i32$0;
  i64toi32_i32$0 = $6;
  HEAP32[i64toi32_i32$0 >> 2] = $36;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $1 = $2 + 32 | 0;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = $1;
  HEAP32[i64toi32_i32$0 >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $7 = $2 + 40 | 0;
  HEAP32[$7 >> 2] = $4;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $9;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$1;
  core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $6;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $55 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 58 | 0;
  $20 = $55;
  HEAP16[i64toi32_i32$1 >> 1] = $20;
  HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $20 >>> 16 | 0;
  HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = i64toi32_i32$0;
  HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $59 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 66 | 0;
  $21 = $59;
  HEAP16[i64toi32_i32$0 >> 1] = $21;
  HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $21 >>> 16 | 0;
  HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$1;
  HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
  $22 = $2 + 74 | 0;
  $23 = HEAP32[$7 >> 2] | 0;
  HEAP16[$22 >> 1] = $23;
  HEAP16[($22 + 2 | 0) >> 1] = $23 >>> 16 | 0;
  HEAP8[($2 + 49 | 0) >> 0] = $5;
  HEAP8[($2 + 48 | 0) >> 0] = $0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $70 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  $24 = $70;
  HEAP16[(i64toi32_i32$2 + 50 | 0) >> 1] = $24;
  HEAP16[(i64toi32_i32$2 + 52 | 0) >> 1] = $24 >>> 16 | 0;
  HEAP16[(i64toi32_i32$2 + 54 | 0) >> 1] = i64toi32_i32$0;
  HEAP16[(i64toi32_i32$2 + 56 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
  $1 = $cardano_serialization_lib__address__RewardAddress_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8b4ddbbcde95397b(i64toi32_i32$2 + 48 | 0 | 0) | 0;
  global$0 = i64toi32_i32$2 + 112 | 0;
  return $1 | 0;
 }
 
 function cardano_serialization_lib__plutus__PlutusScript__from_bytes__ha2b1436fc2e8a74c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $15 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[($2 + 168 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 152 | 0) >> 2] = 0;
  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 160 | 0) >> 2] = $15;
  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__plutus__PlutusScript_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h6cd9666f62b56459($2 + 80 | 0 | 0, $2 + 152 | 0 | 0);
  $1 = ($2 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[(($2 + 80 | 0) + 12 | 0) >> 2] | 0;
    HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] = $1;
    i64toi32_i32$1 = HEAP32[($2 + 84 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    $3 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 8 | 0) >> 2] = $3;
    HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($0 + 12 | 0) >> 2] = $1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 8 | 0 | 4 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__plutus__PlutusScripts__from_bytes__hee33110dca7bc2f8($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $15 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[($2 + 168 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 152 | 0) >> 2] = 0;
  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 160 | 0) >> 2] = $15;
  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__plutus__PlutusScripts_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h8b36940d74966a88($2 + 80 | 0 | 0, $2 + 152 | 0 | 0);
  $1 = ($2 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[(($2 + 80 | 0) + 12 | 0) >> 2] | 0;
    HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] = $1;
    i64toi32_i32$1 = HEAP32[($2 + 84 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    $3 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 8 | 0) >> 2] = $3;
    HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($0 + 12 | 0) >> 2] = $1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 8 | 0 | 4 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__plutus__CostModel__from_bytes__h4e439617ab5bc2d2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $15 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[($2 + 168 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 152 | 0) >> 2] = 0;
  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 160 | 0) >> 2] = $15;
  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__plutus__CostModel_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hfd012f99d93cadfd($2 + 80 | 0 | 0, $2 + 152 | 0 | 0);
  $1 = ($2 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[(($2 + 80 | 0) + 12 | 0) >> 2] | 0;
    HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] = $1;
    i64toi32_i32$1 = HEAP32[($2 + 84 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    $3 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 8 | 0) >> 2] = $3;
    HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($0 + 12 | 0) >> 2] = $1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 8 | 0 | 4 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__plutus__Costmdls__from_bytes__h00a7e8643f3fc4a8($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $15 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[($2 + 168 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 152 | 0) >> 2] = 0;
  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 160 | 0) >> 2] = $15;
  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__plutus__Costmdls_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hfe094af3bf4c55f1($2 + 80 | 0 | 0, $2 + 152 | 0 | 0);
  $1 = ($2 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[(($2 + 80 | 0) + 12 | 0) >> 2] | 0;
    HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] = $1;
    i64toi32_i32$1 = HEAP32[($2 + 84 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    $3 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 8 | 0) >> 2] = $3;
    HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($0 + 12 | 0) >> 2] = $1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 8 | 0 | 4 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__plutus__ExUnits__from_bytes__hc6228a0585c69836($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $2 = 0, i64toi32_i32$1 = 0, $3 = 0, $4 = 0, $4$hi = 0, $5 = 0, $5$hi = 0, $18 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 144 | 0;
  global$0 = $2;
  HEAP32[(($2 + 120 | 0) + 16 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 120 | 0) >> 2] = 0;
  HEAP32[($2 + 124 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[(i64toi32_i32$0 + 128 | 0) >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 132 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__plutus__ExUnits_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h32fa18bd273d182d(i64toi32_i32$0 + 48 | 0 | 0, i64toi32_i32$0 + 120 | 0 | 0);
  $1 = (i64toi32_i32$0 + 120 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $3 = (i64toi32_i32$0 + 48 | 0) + 16 | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $4 = i64toi32_i32$1;
  $4$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    if ((i64toi32_i32$2 | 0) == (1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
     break label$2
    }
    i64toi32_i32$2 = $4$hi;
    i64toi32_i32$0 = $0 + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $4;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $5$hi;
    i64toi32_i32$0 = $0 + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $5;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    $1 = 0;
    break label$1;
   }
   $1 = memcpy($2 | 0, $2 + 72 | 0 | 0, 48 | 0) | 0;
   i64toi32_i32$2 = $4$hi;
   i64toi32_i32$0 = ($1 + 48 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $4;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$2 = $5$hi;
   i64toi32_i32$0 = $1;
   HEAP32[(i64toi32_i32$0 + 48 | 0) >> 2] = $5;
   HEAP32[(i64toi32_i32$0 + 52 | 0) >> 2] = i64toi32_i32$2;
   memcpy($3 | 0, i64toi32_i32$0 | 0, 48 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd(i64toi32_i32$0 + 48 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 144 | 0;
 }
 
 function cardano_serialization_lib__plutus__PlutusMap__from_bytes__h05e340d90edaea31($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $15 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[($2 + 168 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 152 | 0) >> 2] = 0;
  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 160 | 0) >> 2] = $15;
  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__plutus__PlutusMap_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h76a53e332887551d($2 + 80 | 0 | 0, $2 + 152 | 0 | 0);
  $1 = ($2 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[(($2 + 80 | 0) + 12 | 0) >> 2] | 0;
    HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] = $1;
    i64toi32_i32$1 = HEAP32[($2 + 84 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    $3 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 8 | 0) >> 2] = $3;
    HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($0 + 12 | 0) >> 2] = $1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 8 | 0 | 4 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__plutus__PlutusList__from_bytes__h898b7487448006c2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $16 = 0, $3$hi = 0, $4$hi = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[($2 + 168 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 152 | 0) >> 2] = 0;
  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $16 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 160 | 0) >> 2] = $16;
  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__plutus__PlutusList_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hfdf263ce80660b6e($2 + 80 | 0 | 0, $2 + 152 | 0 | 0);
  $1 = ($2 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    i64toi32_i32$2 = ($2 + 80 | 0) + 12 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $3 = i64toi32_i32$1;
    $3$hi = i64toi32_i32$0;
    i64toi32_i32$1 = ($2 + 8 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[($2 + 84 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    $4 = i64toi32_i32$0;
    $4$hi = i64toi32_i32$1;
    i64toi32_i32$0 = $2;
    HEAP32[($2 + 8 | 0) >> 2] = $4;
    HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $3$hi;
    i64toi32_i32$0 = $0 + 12 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $3;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $4$hi;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $4;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 8 | 0 | 4 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__plutus__Redeemers__from_bytes__h565f0ada353103c2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $15 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[($2 + 168 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 152 | 0) >> 2] = 0;
  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 160 | 0) >> 2] = $15;
  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__plutus__Redeemers_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hbb30960977af731e($2 + 80 | 0 | 0, $2 + 152 | 0 | 0);
  $1 = ($2 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[(($2 + 80 | 0) + 12 | 0) >> 2] | 0;
    HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] = $1;
    i64toi32_i32$1 = HEAP32[($2 + 84 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    $3 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 8 | 0) >> 2] = $3;
    HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($0 + 12 | 0) >> 2] = $1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 8 | 0 | 4 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function cryptoxide__hashing__sha3__Engine___2c____output__h721f8fb166d534ff($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $5 = 0, $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     if (!(HEAPU8[($0 + 205 | 0) >> 0] | 0)) {
      break label$3
     }
     label$4 : {
      if (!(HEAPU8[($0 + 204 | 0) >> 0] | 0)) {
       break label$4
      }
      $3 = cryptoxide__hashing__sha3__Engine___2c____finalize__pad_len__hfab79509f3800950((HEAP32[$0 >> 2] | 0) << 3 | 0 | 0, 1088 | 0) | 0;
      alloc__raw_vec__RawVec_T_2cA___allocate_in__hce83853681ce0f55($2 + 8 | 0 | 0, $3 | 0, 1 | 0);
      if (!$3) {
       break label$2
      }
      $4 = HEAP32[($2 + 12 | 0) >> 2] | 0;
      $5 = HEAP32[($2 + 8 | 0) >> 2] | 0;
      HEAP8[$5 >> 0] = (HEAPU8[$5 >> 0] | 0) & 252 | 0 | 2 | 0;
      cryptoxide__hashing__sha3__Engine___2c____finalize__set_pad__h666a8e2c29f8bcb6($5 | 0, $3 | 0);
      cryptoxide__hashing__sha3__Engine___2c____process__ha763ada6c2b386e3($0 | 0, $5 | 0, $3 | 0);
      HEAP8[($0 + 204 | 0) >> 0] = 0;
      if (!$4) {
       break label$4
      }
      __rust_dealloc($5 | 0, $4 | 0, 1 | 0);
     }
     $5 = HEAP32[$0 >> 2] | 0;
     if ($5 >>> 0 >= 32 >>> 0) {
      break label$1
     }
     memcpy($1 | 0, ($0 + $5 | 0) + 4 | 0 | 0, 32 - $5 | 0 | 0) | 0;
     HEAP8[($0 + 205 | 0) >> 0] = 0;
     HEAP32[$0 >> 2] = 32;
     global$0 = $2 + 16 | 0;
     return;
    }
    core__panicking__panic__h2fd385a887c8bf13(1137136 | 0, 24 | 0, 1137160 | 0);
    abort();
   }
   core__panicking__panic__h2fd385a887c8bf13(1136784 | 0, 33 | 0, 1136820 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1137176 | 0, 41 | 0, 1137220 | 0);
  abort();
 }
 
 function std__panicking__rust_panic_with_hook__he9bfe03219d715ba($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $6 = 0, $4 = 0, $5 = 0, i64toi32_i32$1 = 0;
  $4 = global$0 - 32 | 0;
  global$0 = $4;
  $5 = 1;
  $6 = HEAP32[(0 + 1177836 | 0) >> 2] | 0;
  HEAP32[(0 + 1177836 | 0) >> 2] = $6 + 1 | 0;
  label$1 : {
   label$2 : {
    if ((HEAP32[(0 + 1178336 | 0) >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $5 = (HEAP32[(0 + 1178340 | 0) >> 2] | 0) + 1 | 0;
    break label$1;
   }
   HEAP32[(0 + 1178336 | 0) >> 2] = 1;
  }
  HEAP32[(0 + 1178340 | 0) >> 2] = $5;
  label$3 : {
   label$4 : {
    if (($6 | 0) < (0 | 0)) {
     break label$4
    }
    if ($5 >>> 0 > 2 >>> 0) {
     break label$4
    }
    HEAP32[($4 + 28 | 0) >> 2] = $3;
    HEAP32[($4 + 24 | 0) >> 2] = $2;
    $6 = HEAP32[(0 + 1177824 | 0) >> 2] | 0;
    if (($6 | 0) <= (-1 | 0)) {
     break label$4
    }
    $6 = $6 + 1 | 0;
    HEAP32[(0 + 1177824 | 0) >> 2] = $6;
    label$5 : {
     $2 = HEAP32[(0 + 1177832 | 0) >> 2] | 0;
     if (!$2) {
      break label$5
     }
     $6 = HEAP32[(0 + 1177828 | 0) >> 2] | 0;
     FUNCTION_TABLE[HEAP32[($1 + 16 | 0) >> 2] | 0 | 0]($4 + 8 | 0, $0);
     i64toi32_i32$1 = HEAP32[($4 + 12 | 0) >> 2] | 0;
     HEAP32[($4 + 16 | 0) >> 2] = HEAP32[($4 + 8 | 0) >> 2] | 0;
     HEAP32[($4 + 20 | 0) >> 2] = i64toi32_i32$1;
     FUNCTION_TABLE[HEAP32[($2 + 12 | 0) >> 2] | 0 | 0]($6, $4 + 16 | 0);
     $6 = HEAP32[(0 + 1177824 | 0) >> 2] | 0;
    }
    HEAP32[(0 + 1177824 | 0) >> 2] = $6 + -1 | 0;
    if ($5 >>> 0 <= 1 >>> 0) {
     break label$3
    }
   }
   abort();
  }
  rust_panic($0 | 0, $1 | 0);
  abort();
 }
 
 function $core__str__error__Utf8Error_20as_20core__fmt__Debug___fmt__h3825c569e4d83e41($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, i64toi32_i32$2 = 0, $14$hi = 0, $16$hi = 0, $17 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  i64toi32_i32$4 = FUNCTION_TABLE[HEAP32[((HEAP32[($1 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($1 + 24 | 0) >> 2] | 0, 1153260, 9) | 0;
  i64toi32_i32$3 = i64toi32_i32$4 ? 0 : 0;
  i64toi32_i32$2 = i64toi32_i32$4 ? 1 : 0;
  $14$hi = i64toi32_i32$2;
  i64toi32_i32$2 = 0;
  $16$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $14$hi;
  i64toi32_i32$4 = i64toi32_i32$3;
  i64toi32_i32$3 = $16$hi;
  i64toi32_i32$3 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  $17 = i64toi32_i32$4 | $1 | 0;
  i64toi32_i32$4 = $2;
  HEAP32[$2 >> 2] = $17;
  HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$3;
  HEAP32[($2 + 12 | 0) >> 2] = $0;
  core__fmt__builders__DebugStruct__field__hec833bfe02704935($2 | 0, 1153269 | 0, 11 | 0, $2 + 12 | 0 | 0, 1153132 | 0) | 0;
  HEAP32[($2 + 12 | 0) >> 2] = $0 + 4 | 0;
  core__fmt__builders__DebugStruct__field__hec833bfe02704935($2 | 0, 1153280 | 0, 9 | 0, $2 + 12 | 0 | 0, 1153292 | 0) | 0;
  $1 = HEAPU8[($2 + 4 | 0) >> 0] | 0;
  label$1 : {
   if (!(HEAPU8[($2 + 5 | 0) >> 0] | 0)) {
    break label$1
   }
   $0 = $1 & 255 | 0;
   $1 = 1;
   if ($0) {
    break label$1
   }
   label$2 : {
    $1 = HEAP32[$2 >> 2] | 0;
    if ((HEAPU8[$1 >> 0] | 0) & 4 | 0) {
     break label$2
    }
    $1 = FUNCTION_TABLE[HEAP32[((HEAP32[($1 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($1 + 24 | 0) >> 2] | 0, 1149891, 2) | 0;
    break label$1;
   }
   $1 = FUNCTION_TABLE[HEAP32[((HEAP32[($1 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($1 + 24 | 0) >> 2] | 0, 1149877, 1) | 0;
  }
  global$0 = $2 + 16 | 0;
  return ($1 & 255 | 0 | 0) != (0 | 0) | 0;
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Immut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____next_unchecked__h58ba42c81256a08f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $4 = 0, $5 = 0, $2 = 0, $3 = 0, $6 = 0;
  $2 = HEAP32[$1 >> 2] | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     if ($3 >>> 0 >= (HEAPU16[($4 + 1062 | 0) >> 1] | 0) >>> 0) {
      break label$3
     }
     $5 = $4;
     break label$2;
    }
    label$4 : while (1) {
     $5 = HEAP32[($4 + 1056 | 0) >> 2] | 0;
     if (!$5) {
      break label$1
     }
     $2 = $2 + 1 | 0;
     $3 = HEAPU16[($4 + 1060 | 0) >> 1] | 0;
     $4 = $5;
     if ($3 >>> 0 >= (HEAPU16[($5 + 1062 | 0) >> 1] | 0) >>> 0) {
      continue label$4
     }
     break label$4;
    };
   }
   $6 = $3 + 1 | 0;
   label$5 : {
    label$6 : {
     if ($2) {
      break label$6
     }
     $4 = $5;
     break label$5;
    }
    $4 = HEAP32[(($5 + ($6 << 2 | 0) | 0) + 1064 | 0) >> 2] | 0;
    label$7 : {
     $2 = $2 + -1 | 0;
     if (!$2) {
      break label$7
     }
     label$8 : while (1) {
      $4 = HEAP32[($4 + 1064 | 0) >> 2] | 0;
      $2 = $2 + -1 | 0;
      if ($2) {
       continue label$8
      }
      break label$8;
     };
    }
    $6 = 0;
   }
   HEAP32[($1 + 8 | 0) >> 2] = $6;
   HEAP32[($1 + 4 | 0) >> 2] = $4;
   HEAP32[$1 >> 2] = 0;
   $5 = $5 + Math_imul($3, 48) | 0;
   HEAP32[$0 >> 2] = $5;
   HEAP32[($0 + 4 | 0) >> 2] = $5 + 528 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1048576 | 0, 43 | 0, 1049864 | 0);
  abort();
 }
 
 function cardano_serialization_lib__NativeScript__get_required_signers__h9908f6a658ad9671($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $5 = 0, $4 = 0, $6 = 0, $7 = 0, $5$hi = 0, $6$hi = 0, $7$hi = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  cardano_serialization_lib___impl_20core__convert__From__cardano_serialization_lib__NativeScript__20for_20alloc__collections__btree__set__BTreeSet_cardano_serialization_lib__crypto__Ed25519KeyHash____from__h8ccce5a95eccf6e5($2 + 32 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    $1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
    if (!$1) {
     break label$2
    }
    $3 = HEAP32[($2 + 32 | 0) >> 2] | 0;
    alloc__collections__btree__navigate__full_range__h687ff3c975ae5f45($2 + 48 | 0 | 0, $3 | 0, $1 | 0, $3 | 0, $1 | 0);
    $1 = HEAP32[($2 + 40 | 0) >> 2] | 0;
    break label$1;
   }
   $1 = 0;
   HEAP32[($2 + 64 | 0) >> 2] = 0;
   HEAP32[($2 + 52 | 0) >> 2] = 0;
  }
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  $3 = ($2 + 48 | 0) + 8 | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$1;
  i64toi32_i32$0 = $2 + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $5;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $4 = ($2 + 48 | 0) + 16 | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $6 = i64toi32_i32$1;
  $6$hi = i64toi32_i32$0;
  i64toi32_i32$1 = $2 + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $6;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$0 = $2;
  HEAP32[$2 >> 2] = $7;
  HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(($2 + 48 | 0) + 24 | 0) >> 2] = $1;
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$0 = $4;
  HEAP32[i64toi32_i32$0 >> 2] = $6;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $5$hi;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $5;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $7;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__h1871782aef98277c($0 | 0, $2 + 48 | 0 | 0);
  $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h04a6b671c790649f($2 + 32 | 0 | 0);
  global$0 = $2 + 80 | 0;
 }
 
 function transactionoutputamountbuilder_with_asset_and_min_required_coin($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, $5 = 0;
  $3 = global$0 - 288 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h1cb96e7b1dabbc55($3 + 16 | 0 | 0, $0 | 0);
    if (!$1) {
     break label$2
    }
    $0 = HEAP32[($3 + 20 | 0) >> 2] | 0;
    $4 = HEAP32[($3 + 16 | 0) >> 2] | 0;
    wasm_bindgen____rt__WasmRefCell_T___borrow__h9968e42c55861cec($3 + 8 | 0 | 0, $1 | 0);
    if (!$2) {
     break label$2
    }
    $1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
    $5 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($3 | 0, $2 | 0);
    $2 = HEAP32[($3 + 4 | 0) >> 2] | 0;
    cardano_serialization_lib__output_builder__TransactionOutputAmountBuilder__with_asset_and_min_required_coin__hf86cbfe0b07de24a($3 + 24 | 0 | 0, $4 | 0, $5 | 0, HEAP32[$3 >> 2] | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    if ((HEAP32[($3 + 24 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    memcpy($3 + 160 | 0 | 0, $3 + 32 | 0 | 0, 128 | 0) | 0;
    $0 = $cardano_serialization_lib__output_builder__TransactionOutputAmountBuilder_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hafb771b944269b79($3 + 160 | 0 | 0) | 0;
    global$0 = $3 + 288 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($3 + 28 | 0) >> 2] | 0 | 0);
  abort();
 }
 
 function decode_metadatum_to_json_str($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $35 = 0, $51 = 0, $58 = 0;
  $3 = global$0 - 80 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     if (!$1) {
      break label$3
     }
     wasm_bindgen____rt__WasmRefCell_T___borrow__hc630c86c4ab6b26d($3 + 24 | 0 | 0, $1 | 0);
     if ($2 >>> 0 >= 3 >>> 0) {
      break label$2
     }
     $1 = HEAP32[($3 + 28 | 0) >> 2] | 0;
     cardano_serialization_lib__metadata__decode_metadatum_to_json_str__h637f31ff22f16dc5($3 + 32 | 0 | 0, HEAP32[($3 + 24 | 0) >> 2] | 0 | 0, $2 | 0);
     core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
     $1 = HEAP32[($3 + 36 | 0) >> 2] | 0;
     if ((HEAP32[($3 + 32 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$1
     }
     i64toi32_i32$2 = ($3 + 32 | 0) + 8 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $35 = i64toi32_i32$0;
     i64toi32_i32$0 = $3;
     HEAP32[($3 + 52 | 0) >> 2] = $35;
     HEAP32[($3 + 56 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($3 + 48 | 0) >> 2] = $1;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 16 | 0 | 0, $3 + 48 | 0 | 0);
     HEAP32[(($3 + 64 | 0) + 8 | 0) >> 2] = HEAP32[(($3 + 48 | 0) + 8 | 0) >> 2] | 0;
     i64toi32_i32$2 = $3;
     i64toi32_i32$1 = HEAP32[($3 + 48 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($3 + 52 | 0) >> 2] | 0;
     $51 = i64toi32_i32$1;
     i64toi32_i32$1 = $3;
     HEAP32[($3 + 64 | 0) >> 2] = $51;
     HEAP32[($3 + 68 | 0) >> 2] = i64toi32_i32$0;
     alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($3 + 8 | 0 | 0, $3 + 64 | 0 | 0);
     i64toi32_i32$2 = $3;
     i64toi32_i32$0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
     $58 = i64toi32_i32$0;
     i64toi32_i32$0 = $0;
     HEAP32[i64toi32_i32$0 >> 2] = $58;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     global$0 = $3 + 80 | 0;
     return;
    }
    wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
    abort();
   }
   wasm_bindgen__throw_str__h40ff0247f6a635d7(1060608 | 0, 25 | 0);
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
  abort();
 }
 
 function cryptoxide__chacha20__ChaCha_____process__h1d8c0590222f71eb($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $6 = 0, $5 = 0, $8 = 0, $7 = 0;
  label$1 : {
   if (($2 | 0) != ($4 | 0)) {
    break label$1
   }
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if (!$2) {
        break label$5
       }
       $4 = HEAP32[($0 + 64 | 0) >> 2] | 0;
       $5 = 0;
       label$6 : while (1) {
        label$7 : {
         if (($4 | 0) != (64 | 0)) {
          break label$7
         }
         cryptoxide__chacha20__ChaCha_____update__h0ad25fc73ef018e9($0 | 0);
         $4 = HEAP32[($0 + 64 | 0) >> 2] | 0;
        }
        $6 = $2 - $5 | 0;
        $7 = 64 - $4 | 0;
        $6 = $7 >>> 0 > $6 >>> 0 ? $6 : $7;
        $8 = $6 + $5 | 0;
        if ($8 >>> 0 < $6 >>> 0) {
         break label$4
        }
        if ($8 >>> 0 > $2 >>> 0) {
         break label$3
        }
        if ($4 >>> 0 >= 65 >>> 0) {
         break label$2
        }
        cryptoxide__cryptoutil__xor_keystream__h1b50be9f7ab5641d($3 + $5 | 0 | 0, $6 | 0, $1 + $5 | 0 | 0, $6 | 0, ($0 + $4 | 0) + 68 | 0 | 0, $7 | 0);
        $4 = (HEAP32[($0 + 64 | 0) >> 2] | 0) + $6 | 0;
        HEAP32[($0 + 64 | 0) >> 2] = $4;
        $5 = $8;
        if ($8 >>> 0 < $2 >>> 0) {
         continue label$6
        }
        break label$6;
       };
      }
      return;
     }
     core__slice__index__slice_index_order_fail__h71e247dec3f266ff($5 | 0, $8 | 0, 1060936 | 0);
     abort();
    }
    core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($8 | 0, $2 | 0, 1060936 | 0);
    abort();
   }
   core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($4 | 0, 64 | 0, 1060952 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1060872 | 0, 45 | 0, 1060920 | 0);
  abort();
 }
 
 function plutusmap_keys($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $2 = 0, $29 = 0, $37 = 0, $40 = 0, $55 = 0, $58 = 0;
  $1 = global$0 - 96 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hc838c9a2ed8b7fab($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  alloc__collections__btree__map__BTreeMap_K_2cV___iter__h1146c826d3183069($1 + 32 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
  HEAP32[(($1 + 64 | 0) + 24 | 0) >> 2] = HEAP32[(($1 + 32 | 0) + 24 | 0) >> 2] | 0;
  i64toi32_i32$2 = ($1 + 32 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $29 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 64 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $29;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $2 = ($1 + 64 | 0) + 8 | 0;
  i64toi32_i32$2 = ($1 + 32 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $37 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[i64toi32_i32$1 >> 2] = $37;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[($1 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 36 | 0) >> 2] | 0;
  $40 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 64 | 0) >> 2] = $40;
  HEAP32[($1 + 68 | 0) >> 2] = i64toi32_i32$1;
  $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__h44f364b9545b56fe($1 + 16 | 0 | 0, $1 + 64 | 0 | 0);
  HEAP8[($1 + 28 | 0) >> 0] = 2;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = ($1 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $55 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[i64toi32_i32$1 >> 2] = $55;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[($1 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  $58 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 64 | 0) >> 2] = $58;
  HEAP32[($1 + 68 | 0) >> 2] = i64toi32_i32$1;
  $0 = $cardano_serialization_lib__plutus__PlutusList_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h9a3fe5bcf5e2cc3a($1 + 64 | 0 | 0) | 0;
  global$0 = $1 + 96 | 0;
  return $0 | 0;
 }
 
 function num_bigint__biguint__subtraction__sub2rev__h9886869f2206b4ea($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, i64toi32_i32$5 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $4 = 0, $6 = 0, $7$hi = 0, $5 = 0, $7 = 0, $23 = 0, $25 = 0, $27 = 0, $28 = 0, $22 = 0, $24 = 0, $24$hi = 0, $26 = 0, $26$hi = 0, $27$hi = 0, $8 = 0, $8$hi = 0;
  $4 = $1 >>> 0 > $3 >>> 0 ? $3 : $1;
  $5 = $1 - $4 | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if (!$4) {
        break label$5
       }
       i64toi32_i32$0 = 0;
       $7 = 0;
       $7$hi = i64toi32_i32$0;
       $6 = $4;
       $1 = $2;
       label$6 : while (1) {
        $22 = $1;
        i64toi32_i32$2 = $0;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = 0;
        $24 = i64toi32_i32$0;
        $24$hi = i64toi32_i32$1;
        i64toi32_i32$2 = $1;
        i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$0 = 0;
        $26 = i64toi32_i32$1;
        $26$hi = i64toi32_i32$0;
        i64toi32_i32$0 = $24$hi;
        i64toi32_i32$2 = $24;
        i64toi32_i32$1 = $26$hi;
        i64toi32_i32$3 = $26;
        i64toi32_i32$4 = i64toi32_i32$2 - i64toi32_i32$3 | 0;
        i64toi32_i32$5 = (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) + i64toi32_i32$1 | 0;
        i64toi32_i32$5 = i64toi32_i32$0 - i64toi32_i32$5 | 0;
        $27$hi = i64toi32_i32$5;
        i64toi32_i32$5 = $7$hi;
        i64toi32_i32$5 = $27$hi;
        i64toi32_i32$0 = i64toi32_i32$4;
        i64toi32_i32$2 = $7$hi;
        i64toi32_i32$3 = $7;
        i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
        i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
        if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
         i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
        }
        $8 = i64toi32_i32$1;
        $8$hi = i64toi32_i32$4;
        HEAP32[$22 >> 2] = i64toi32_i32$1;
        $0 = $0 + 4 | 0;
        $1 = $1 + 4 | 0;
        i64toi32_i32$5 = i64toi32_i32$1;
        i64toi32_i32$0 = 0;
        i64toi32_i32$3 = 63;
        i64toi32_i32$2 = i64toi32_i32$3 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
         i64toi32_i32$0 = i64toi32_i32$4 >> 31 | 0;
         $23 = i64toi32_i32$4 >> i64toi32_i32$2 | 0;
        } else {
         i64toi32_i32$0 = i64toi32_i32$4 >> i64toi32_i32$2 | 0;
         $23 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$2 | 0) | 0;
        }
        $7 = $23;
        $7$hi = i64toi32_i32$0;
        $6 = $6 + -1 | 0;
        if ($6) {
         continue label$6
        }
        break label$6;
       };
       if ($5) {
        break label$1
       }
       i64toi32_i32$0 = $8$hi;
       i64toi32_i32$4 = $8;
       i64toi32_i32$5 = -1;
       i64toi32_i32$3 = -1;
       if ((i64toi32_i32$0 | 0) > (i64toi32_i32$5 | 0)) {
        $25 = 1
       } else {
        if ((i64toi32_i32$0 | 0) >= (i64toi32_i32$5 | 0)) {
         if (i64toi32_i32$4 >>> 0 <= i64toi32_i32$3 >>> 0) {
          $27 = 0
         } else {
          $27 = 1
         }
         $28 = $27;
        } else {
         $28 = 0
        }
        $25 = $28;
       }
       if ($25) {
        break label$4
       }
       break label$3;
      }
      if ($5) {
       break label$1
      }
     }
     $0 = $2 + ($4 << 2 | 0) | 0;
     $1 = ($3 << 2 | 0) - ($4 << 2 | 0) | 0;
     label$7 : while (1) {
      if (!$1) {
       break label$2
      }
      $1 = $1 + -4 | 0;
      $6 = HEAP32[$0 >> 2] | 0;
      $0 = $0 + 4 | 0;
      if (!$6) {
       continue label$7
      }
      break label$7;
     };
    }
    std__panicking__begin_panic__hf55b754840077f11(1077561 | 0, 52 | 0, 1077792 | 0);
    abort();
   }
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1077740 | 0, 33 | 0, 1077776 | 0);
  abort();
 }
 
 function num_bigint__biguint__multiplication__mul3__h007c2e75506c6ce0($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, $7 = 0, i64toi32_i32$0 = 0, $8 = 0, $9 = 0, $6 = 0, i64toi32_i32$1 = 0, $63 = 0;
  $5 = global$0 - 32 | 0;
  global$0 = $5;
  $6 = $2 + $4 | 0;
  $7 = $6 + 1 | 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__hb0817f92bbb8999a($5 + 8 | 0 | 0, $7 | 0, 1 | 0);
  $8 = HEAP32[($5 + 12 | 0) >> 2] | 0;
  $9 = HEAP32[($5 + 8 | 0) >> 2] | 0;
  num_bigint__biguint__multiplication__mac3__hfe2ae9a5dc461c1a($9 | 0, $7 | 0, $1 | 0, $2 | 0, $3 | 0, $4 | 0);
  HEAP32[($5 + 24 | 0) >> 2] = $7;
  HEAP32[($5 + 20 | 0) >> 2] = $8;
  HEAP32[($5 + 16 | 0) >> 2] = $9;
  label$1 : {
   label$2 : {
    if ($7) {
     break label$2
    }
    $7 = 0;
    break label$1;
   }
   $2 = $9 + ($6 << 2 | 0) | 0;
   label$3 : {
    label$4 : while (1) {
     if (HEAP32[$2 >> 2] | 0) {
      break label$3
     }
     $2 = $2 + -4 | 0;
     $7 = $7 + -1 | 0;
     if ($7) {
      continue label$4
     }
     break label$4;
    };
    $7 = 0;
   }
   HEAP32[($5 + 24 | 0) >> 2] = $7;
  }
  label$5 : {
   if ($7 >>> 0 >= ($8 >>> 2 | 0) >>> 0) {
    break label$5
   }
   if ($8 >>> 0 <= $7 >>> 0) {
    break label$5
   }
   alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($5 + 16 | 0 | 0, $7 | 0);
  }
  i64toi32_i32$0 = HEAP32[($5 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($5 + 20 | 0) >> 2] | 0;
  $63 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $63;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[(($5 + 16 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $5 + 32 | 0;
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Immut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____next_unchecked__h0cd6b79880fdffab($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $4 = 0, $2 = 0, $5 = 0, $3 = 0, $6 = 0;
  $2 = HEAP32[$1 >> 2] | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     if ($3 >>> 0 >= (HEAPU16[($4 + 138 | 0) >> 1] | 0) >>> 0) {
      break label$3
     }
     $5 = $4;
     break label$2;
    }
    label$4 : while (1) {
     $5 = HEAP32[$4 >> 2] | 0;
     if (!$5) {
      break label$1
     }
     $2 = $2 + 1 | 0;
     $3 = HEAPU16[($4 + 136 | 0) >> 1] | 0;
     $4 = $5;
     if ($3 >>> 0 >= (HEAPU16[($5 + 138 | 0) >> 1] | 0) >>> 0) {
      continue label$4
     }
     break label$4;
    };
   }
   $6 = $3 + 1 | 0;
   label$5 : {
    label$6 : {
     if ($2) {
      break label$6
     }
     $4 = $5;
     break label$5;
    }
    $4 = HEAP32[(($5 + ($6 << 2 | 0) | 0) + 140 | 0) >> 2] | 0;
    label$7 : {
     $2 = $2 + -1 | 0;
     if (!$2) {
      break label$7
     }
     label$8 : while (1) {
      $4 = HEAP32[($4 + 140 | 0) >> 2] | 0;
      $2 = $2 + -1 | 0;
      if ($2) {
       continue label$8
      }
      break label$8;
     };
    }
    $6 = 0;
   }
   HEAP32[($1 + 8 | 0) >> 2] = $6;
   HEAP32[($1 + 4 | 0) >> 2] = $4;
   HEAP32[$1 >> 2] = 0;
   HEAP32[$0 >> 2] = $5;
   HEAP32[($0 + 4 | 0) >> 2] = ($5 + Math_imul($3, 12) | 0) + 4 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1048576 | 0, 43 | 0, 1049864 | 0);
  abort();
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Immut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____next_unchecked__h62e84bc9d17d0099($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $4 = 0, $2 = 0, $5 = 0, $3 = 0, $6 = 0;
  $2 = HEAP32[$1 >> 2] | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     if ($3 >>> 0 >= (HEAPU16[($4 + 6 | 0) >> 1] | 0) >>> 0) {
      break label$3
     }
     $5 = $4;
     break label$2;
    }
    label$4 : while (1) {
     $5 = HEAP32[$4 >> 2] | 0;
     if (!$5) {
      break label$1
     }
     $2 = $2 + 1 | 0;
     $3 = HEAPU16[($4 + 4 | 0) >> 1] | 0;
     $4 = $5;
     if ($3 >>> 0 >= (HEAPU16[($5 + 6 | 0) >> 1] | 0) >>> 0) {
      continue label$4
     }
     break label$4;
    };
   }
   $6 = $3 + 1 | 0;
   label$5 : {
    label$6 : {
     if ($2) {
      break label$6
     }
     $4 = $5;
     break label$5;
    }
    $4 = HEAP32[(($5 + ($6 << 2 | 0) | 0) + 316 | 0) >> 2] | 0;
    label$7 : {
     $2 = $2 + -1 | 0;
     if (!$2) {
      break label$7
     }
     label$8 : while (1) {
      $4 = HEAP32[($4 + 316 | 0) >> 2] | 0;
      $2 = $2 + -1 | 0;
      if ($2) {
       continue label$8
      }
      break label$8;
     };
    }
    $6 = 0;
   }
   HEAP32[($1 + 8 | 0) >> 2] = $6;
   HEAP32[($1 + 4 | 0) >> 2] = $4;
   HEAP32[$1 >> 2] = 0;
   HEAP32[($0 + 4 | 0) >> 2] = $5;
   HEAP32[$0 >> 2] = ($5 + Math_imul($3, 28) | 0) + 8 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1048576 | 0, 43 | 0, 1049864 | 0);
  abort();
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Immut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____next_unchecked__hfa131ff1f54a70fd($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $4 = 0, $2 = 0, $5 = 0, $3 = 0, $6 = 0;
  $2 = HEAP32[$1 >> 2] | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     if ($3 >>> 0 >= (HEAPU16[($4 + 50 | 0) >> 1] | 0) >>> 0) {
      break label$3
     }
     $5 = $4;
     break label$2;
    }
    label$4 : while (1) {
     $5 = HEAP32[$4 >> 2] | 0;
     if (!$5) {
      break label$1
     }
     $2 = $2 + 1 | 0;
     $3 = HEAPU16[($4 + 48 | 0) >> 1] | 0;
     $4 = $5;
     if ($3 >>> 0 >= (HEAPU16[($5 + 50 | 0) >> 1] | 0) >>> 0) {
      continue label$4
     }
     break label$4;
    };
   }
   $6 = $3 + 1 | 0;
   label$5 : {
    label$6 : {
     if ($2) {
      break label$6
     }
     $4 = $5;
     break label$5;
    }
    $4 = HEAP32[(($5 + ($6 << 2 | 0) | 0) + 52 | 0) >> 2] | 0;
    label$7 : {
     $2 = $2 + -1 | 0;
     if (!$2) {
      break label$7
     }
     label$8 : while (1) {
      $4 = HEAP32[($4 + 52 | 0) >> 2] | 0;
      $2 = $2 + -1 | 0;
      if ($2) {
       continue label$8
      }
      break label$8;
     };
    }
    $6 = 0;
   }
   HEAP32[($1 + 8 | 0) >> 2] = $6;
   HEAP32[($1 + 4 | 0) >> 2] = $4;
   HEAP32[$1 >> 2] = 0;
   HEAP32[($0 + 4 | 0) >> 2] = $5;
   HEAP32[$0 >> 2] = ($5 + ($3 << 2 | 0) | 0) + 4 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1048576 | 0, 43 | 0, 1049864 | 0);
  abort();
 }
 
 function cardano_serialization_lib__TransactionBody__new__h54f6232177292578($0, $1, $2, $3, $4, $5) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  $5 = $5 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $6 = 0, i64toi32_i32$2 = 0, $8 = 0, $8$hi = 0, $7 = 0, $7$hi = 0, $9 = 0, $9$hi = 0, $25 = 0, $28 = 0;
  $6 = global$0 - 32 | 0;
  global$0 = $6;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hfe677107e1954f8f($6 | 0, $1 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h699bb0f3db607312($6 + 16 | 0 | 0, $2 | 0);
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    if ($4) {
     break label$2
    }
    i64toi32_i32$1 = 0;
    $8 = 0;
    $8$hi = i64toi32_i32$1;
    break label$1;
   }
   i64toi32_i32$1 = 0;
   $8 = 1;
   $8$hi = i64toi32_i32$1;
   i64toi32_i32$1 = $T_20as_20core__convert__Into_U____into__h09f19f33dddda692($5 | 0) | 0;
   i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
   $9 = i64toi32_i32$1;
   $9$hi = i64toi32_i32$0;
  }
  i64toi32_i32$2 = $6;
  i64toi32_i32$0 = HEAP32[$6 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($6 + 4 | 0) >> 2] | 0;
  $25 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[($0 + 128 | 0) >> 2] = $25;
  HEAP32[($0 + 132 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $6;
  i64toi32_i32$1 = HEAP32[($6 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($6 + 20 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[($0 + 140 | 0) >> 2] = $28;
  HEAP32[($0 + 144 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($0 + 152 | 0) >> 2] = 0;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$1 = $0;
  HEAP32[($0 + 8 | 0) >> 2] = $8;
  HEAP32[($0 + 12 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$1 = $0;
  HEAP32[$0 >> 2] = $7;
  HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP8[($0 + 204 | 0) >> 0] = 0;
  HEAP8[($0 + 237 | 0) >> 0] = 0;
  HEAP32[($0 + 164 | 0) >> 2] = 0;
  i64toi32_i32$1 = $0;
  i64toi32_i32$0 = 0;
  HEAP32[($0 + 112 | 0) >> 2] = 0;
  HEAP32[($0 + 116 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $9$hi;
  i64toi32_i32$1 = $0 + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $9;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($0 + 84 | 0) >> 2] = 0;
  HEAP32[($0 + 44 | 0) >> 2] = 0;
  HEAP32[($0 + 136 | 0) >> 2] = HEAP32[($6 + 8 | 0) >> 2] | 0;
  HEAP32[($0 + 148 | 0) >> 2] = HEAP32[(($6 + 16 | 0) + 8 | 0) >> 2] | 0;
  HEAP8[($0 + 270 | 0) >> 0] = 2;
  HEAP32[($0 + 192 | 0) >> 2] = 0;
  HEAP32[($0 + 180 | 0) >> 2] = 0;
  global$0 = $6 + 32 | 0;
 }
 
 function certificate_new_stake_registration($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $18 = 0, $2 = 0, $5 = 0, $6 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $3 = 0, $7 = 0, $7$hi = 0, $4 = 0, $8 = 0, $8$hi = 0, $34 = 0, $53 = 0, $57 = 0, $67 = 0;
  $1 = global$0 - 272 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h9f3eeaa31aede5c7($1 | 0, $0 | 0);
  $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $0 = HEAP32[$1 >> 2] | 0;
  $18 = $0 + 25 | 0;
  $3 = HEAPU8[$18 >> 0] | 0 | ((HEAPU8[($18 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($18 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($18 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $0 + 17 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  $4 = HEAPU8[$0 >> 0] | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $8 = i64toi32_i32$1;
  $8$hi = i64toi32_i32$0;
  $5 = $1 + 16 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 9 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $34 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[i64toi32_i32$0 >> 2] = $34;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $0 = $1 + 24 | 0;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $6 = $1 + 32 | 0;
  HEAP32[$6 >> 2] = $3;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 8 | 0) >> 2] = $8;
  HEAP32[($1 + 12 | 0) >> 2] = i64toi32_i32$1;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $53 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 82 | 0;
  $19 = $53;
  HEAP16[i64toi32_i32$1 >> 1] = $19;
  HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $19 >>> 16 | 0;
  HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = i64toi32_i32$0;
  HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $57 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 90 | 0;
  $20 = $57;
  HEAP16[i64toi32_i32$0 >> 1] = $20;
  HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $20 >>> 16 | 0;
  HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$1;
  HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
  $21 = $1 + 98 | 0;
  $22 = HEAP32[$6 >> 2] | 0;
  HEAP16[$21 >> 1] = $22;
  HEAP16[($21 + 2 | 0) >> 1] = $22 >>> 16 | 0;
  HEAP8[($1 + 73 | 0) >> 0] = $4;
  HEAP8[($1 + 72 | 0) >> 0] = 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $67 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  $23 = $67;
  HEAP16[(i64toi32_i32$2 + 74 | 0) >> 1] = $23;
  HEAP16[(i64toi32_i32$2 + 76 | 0) >> 1] = $23 >>> 16 | 0;
  HEAP16[(i64toi32_i32$2 + 78 | 0) >> 1] = i64toi32_i32$0;
  HEAP16[(i64toi32_i32$2 + 80 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
  $0 = $cardano_serialization_lib__Certificate_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hd9e6ef3cbd15ff20(i64toi32_i32$2 + 72 | 0 | 0) | 0;
  global$0 = i64toi32_i32$2 + 272 | 0;
  return $0 | 0;
 }
 
 function certificate_new_stake_deregistration($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $18 = 0, $2 = 0, $5 = 0, $6 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $3 = 0, $7 = 0, $7$hi = 0, $4 = 0, $8 = 0, $8$hi = 0, $34 = 0, $53 = 0, $57 = 0, $67 = 0;
  $1 = global$0 - 272 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h415aed7c06a10866($1 | 0, $0 | 0);
  $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $0 = HEAP32[$1 >> 2] | 0;
  $18 = $0 + 25 | 0;
  $3 = HEAPU8[$18 >> 0] | 0 | ((HEAPU8[($18 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($18 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($18 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $0 + 17 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  $4 = HEAPU8[$0 >> 0] | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $8 = i64toi32_i32$1;
  $8$hi = i64toi32_i32$0;
  $5 = $1 + 16 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 9 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $34 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[i64toi32_i32$0 >> 2] = $34;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $0 = $1 + 24 | 0;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $6 = $1 + 32 | 0;
  HEAP32[$6 >> 2] = $3;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 8 | 0) >> 2] = $8;
  HEAP32[($1 + 12 | 0) >> 2] = i64toi32_i32$1;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $53 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 82 | 0;
  $19 = $53;
  HEAP16[i64toi32_i32$1 >> 1] = $19;
  HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $19 >>> 16 | 0;
  HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = i64toi32_i32$0;
  HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $57 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 90 | 0;
  $20 = $57;
  HEAP16[i64toi32_i32$0 >> 1] = $20;
  HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $20 >>> 16 | 0;
  HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$1;
  HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
  $21 = $1 + 98 | 0;
  $22 = HEAP32[$6 >> 2] | 0;
  HEAP16[$21 >> 1] = $22;
  HEAP16[($21 + 2 | 0) >> 1] = $22 >>> 16 | 0;
  HEAP8[($1 + 73 | 0) >> 0] = $4;
  HEAP8[($1 + 72 | 0) >> 0] = 1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $67 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  $23 = $67;
  HEAP16[(i64toi32_i32$2 + 74 | 0) >> 1] = $23;
  HEAP16[(i64toi32_i32$2 + 76 | 0) >> 1] = $23 >>> 16 | 0;
  HEAP16[(i64toi32_i32$2 + 78 | 0) >> 1] = i64toi32_i32$0;
  HEAP16[(i64toi32_i32$2 + 80 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
  $0 = $cardano_serialization_lib__Certificate_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hd9e6ef3cbd15ff20(i64toi32_i32$2 + 72 | 0 | 0) | 0;
  global$0 = i64toi32_i32$2 + 272 | 0;
  return $0 | 0;
 }
 
 function cardano_serialization_lib__RewardAddresses__add__h26e0cac4ad42f3f2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $17 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $4 = 0, $5 = 0, $6 = 0, $3 = 0, $18 = 0, $24 = 0, $34 = 0, $7 = 0, $58 = 0, $62 = 0, $66 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  $3 = HEAPU8[$1 >> 0] | 0;
  $4 = $2 + 8 | 0;
  i64toi32_i32$2 = $1 + 10 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $5 = $2 + 16 | 0;
  i64toi32_i32$2 = $1 + 18 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $24 = i64toi32_i32$1;
  i64toi32_i32$1 = $5;
  HEAP32[i64toi32_i32$1 >> 2] = $24;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $6 = $2 + 24 | 0;
  $17 = $1 + 26 | 0;
  HEAP32[$6 >> 2] = HEAPU8[$17 >> 0] | 0 | ((HEAPU8[($17 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($17 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($17 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $1 + 2 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $34 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $34;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $7 = HEAPU8[($1 + 1 | 0) >> 0] | 0;
  label$1 : {
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (($1 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
    break label$1
   }
   alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hf7d7cca00a09c6e3($0 | 0, $1 | 0, 1 | 0);
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  }
  $1 = (HEAP32[$0 >> 2] | 0) + Math_imul($1, 30) | 0;
  HEAP8[($1 + 1 | 0) >> 0] = $7;
  HEAP8[$1 >> 0] = $3;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $58 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  $19 = $58;
  HEAP8[($1 + 2 | 0) >> 0] = $19;
  HEAP8[($1 + 3 | 0) >> 0] = $19 >>> 8 | 0;
  HEAP8[($1 + 4 | 0) >> 0] = $19 >>> 16 | 0;
  HEAP8[($1 + 5 | 0) >> 0] = $19 >>> 24 | 0;
  HEAP8[($1 + 6 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[($1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[($1 + 8 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[($1 + 9 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $62 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 10 | 0;
  $20 = $62;
  HEAP8[i64toi32_i32$0 >> 0] = $20;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $20 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $20 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $20 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $66 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 18 | 0;
  $21 = $66;
  HEAP8[i64toi32_i32$1 >> 0] = $21;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $21 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $21 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $21 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $22 = $1 + 26 | 0;
  $23 = HEAP32[$6 >> 2] | 0;
  HEAP8[$22 >> 0] = $23;
  HEAP8[($22 + 1 | 0) >> 0] = $23 >>> 8 | 0;
  HEAP8[($22 + 2 | 0) >> 0] = $23 >>> 16 | 0;
  HEAP8[($22 + 3 | 0) >> 0] = $23 >>> 24 | 0;
  HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
  global$0 = $2 + 64 | 0;
 }
 
 function mintassets_insert($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $7$hi = 0, $6$hi = 0, $7 = 0, $6 = 0, $8$hi = 0, $4 = 0, $5 = 0, $8 = 0;
  $3 = global$0 - 80 | 0;
  global$0 = $3;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h8bccc78f842f4f24($3 + 56 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $4 = HEAP32[($3 + 60 | 0) >> 2] | 0;
   $5 = HEAP32[($3 + 56 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h9c68abd5a6a78973($3 + 48 | 0 | 0, $1 | 0);
   $0 = HEAP32[($3 + 52 | 0) >> 2] | 0;
   $1 = HEAP32[($3 + 48 | 0) >> 2] | 0;
   $cardano_serialization_lib__utils__Int_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h465ce6bea3371e5b($3 + 32 | 0 | 0, $2 | 0);
   i64toi32_i32$2 = $3 + 40 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $6 = i64toi32_i32$0;
   $6$hi = i64toi32_i32$1;
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[($3 + 32 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($3 + 36 | 0) >> 2] | 0;
   $7 = i64toi32_i32$1;
   $7$hi = i64toi32_i32$0;
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($3 + 64 | 0 | 0, $1 | 0);
   i64toi32_i32$0 = $6$hi;
   i64toi32_i32$0 = $7$hi;
   i64toi32_i32$1 = $6$hi;
   alloc__collections__btree__map__BTreeMap_K_2cV___insert__h9d3a28073b5db74d($3 + 8 | 0 | 0, $5 | 0, $3 + 64 | 0 | 0, $7 | 0, i64toi32_i32$0 | 0, $6 | 0, i64toi32_i32$1 | 0);
   i64toi32_i32$2 = $3 + 24 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $7 = i64toi32_i32$1;
   $7$hi = i64toi32_i32$0;
   i64toi32_i32$2 = $3;
   i64toi32_i32$0 = HEAP32[($3 + 16 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($3 + 20 | 0) >> 2] | 0;
   $8 = i64toi32_i32$0;
   $8$hi = i64toi32_i32$1;
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[($3 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($3 + 12 | 0) >> 2] | 0;
   $6 = i64toi32_i32$1;
   $6$hi = i64toi32_i32$0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   $0 = 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($4 | 0, 0 | 0) | 0;
   label$2 : {
    if (!i64toi32_i32$1) {
     break label$2
    }
    i64toi32_i32$0 = $8$hi;
    i64toi32_i32$0 = $7$hi;
    i64toi32_i32$0 = $8$hi;
    i64toi32_i32$1 = $7$hi;
    $0 = $cardano_serialization_lib__utils__Int_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hac86427717971799($8 | 0, i64toi32_i32$0 | 0, $7 | 0, i64toi32_i32$1 | 0) | 0;
   }
   global$0 = $3 + 80 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function $alloc__collections__btree__map__IntoIter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h7fa673cac2ce5cb9($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $3 = 0, $2 = 0, $4 = 0, $29 = 0, $41 = 0, $49 = 0, $59 = 0, $64 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     $3 = HEAP32[($1 + 24 | 0) >> 2] | 0;
     if ($3) {
      break label$3
     }
     HEAP8[($0 + 16 | 0) >> 0] = 6;
     break label$2;
    }
    HEAP32[($1 + 24 | 0) >> 2] = $3 + -1 | 0;
    if (!(HEAP32[($1 + 4 | 0) >> 2] | 0)) {
     break label$1
    }
    alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next_unchecked__h1b1b91bd6bd0f0ea($2 | 0, $1 | 0);
    $1 = ($2 + 16 | 0) + 8 | 0;
    HEAP32[$1 >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $29 = i64toi32_i32$0;
    i64toi32_i32$0 = i64toi32_i32$2;
    HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $29;
    HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$1;
    $3 = alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2cType___as_leaf_dying__hb4e3fbf545555ed9(i64toi32_i32$0 + 16 | 0 | 0) | 0;
    $4 = HEAP32[$1 >> 2] | 0;
    $1 = $3 + Math_imul($4, 24) | 0;
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $41 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $41;
    HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
    $3 = $3 + Math_imul($4, 12) | 0;
    i64toi32_i32$2 = $3 + 268 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $49 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[i64toi32_i32$0 >> 2] = $49;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($3 + 276 | 0) >> 2] | 0;
    i64toi32_i32$2 = $1 + 8 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $59 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 24 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $59;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $1 + 16 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $64 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 32 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $64;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   }
   global$0 = $2 + 32 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1067386 | 0, 43 | 0, 1067584 | 0);
  abort();
 }
 
 function txinputsbuilder_inputs($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $30 = 0, $38 = 0, $41 = 0, $58 = 0;
  $1 = global$0 - 96 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h2150b2b2433b33e4($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  alloc__collections__btree__map__BTreeMap_K_2cV___iter__h721110b568622f84($1 + 32 | 0 | 0, (HEAP32[($1 + 8 | 0) >> 2] | 0) + 64 | 0 | 0);
  HEAP32[(($1 + 64 | 0) + 24 | 0) >> 2] = HEAP32[(($1 + 32 | 0) + 24 | 0) >> 2] | 0;
  i64toi32_i32$2 = ($1 + 32 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 64 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $30;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $2 = ($1 + 64 | 0) + 8 | 0;
  i64toi32_i32$2 = ($1 + 32 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $38 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[i64toi32_i32$1 >> 2] = $38;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[($1 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 36 | 0) >> 2] | 0;
  $41 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 64 | 0) >> 2] = $41;
  HEAP32[($1 + 68 | 0) >> 2] = i64toi32_i32$1;
  $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__he4e09da31a8bd115($1 + 16 | 0 | 0, $1 + 64 | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[$2 >> 2] = HEAP32[(($1 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[($1 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  $58 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[($1 + 64 | 0) >> 2] = $58;
  HEAP32[($1 + 68 | 0) >> 2] = i64toi32_i32$0;
  $0 = $cardano_serialization_lib__TransactionInputs_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__haa89884e18e43552($1 + 64 | 0 | 0) | 0;
  global$0 = $1 + 96 | 0;
  return $0 | 0;
 }
 
 function plutusdata_as_constr_plutus_data($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $8 = 0, $9 = 0, $46 = 0, $56 = 0;
  $1 = global$0 - 64 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb1fd14a6870cafe2($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   cardano_serialization_lib__plutus__PlutusData__as_constr_plutus_data__he46650f409e7849e($1 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   $0 = 0;
   label$2 : {
    $2 = HEAPU8[($1 + 36 | 0) >> 0] | 0;
    if (($2 | 0) == (3 | 0)) {
     break label$2
    }
    HEAP8[($1 + 60 | 0) >> 0] = $2;
    $8 = $1 + 61 | 0;
    $9 = HEAPU8[($1 + 37 | 0) >> 0] | 0 | ((HEAPU8[($1 + 38 | 0) >> 0] | 0) << 8 | 0) | 0;
    HEAP8[$8 >> 0] = $9;
    HEAP8[($8 + 1 | 0) >> 0] = $9 >>> 8 | 0;
    HEAP32[(($1 + 40 | 0) + 16 | 0) >> 2] = HEAP32[(($1 + 16 | 0) + 16 | 0) >> 2] | 0;
    i64toi32_i32$2 = ($1 + 16 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $46 = i64toi32_i32$0;
    i64toi32_i32$0 = ($1 + 40 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $46;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP8[(($1 + 40 | 0) + 23 | 0) >> 0] = HEAPU8[(($1 + 16 | 0) + 23 | 0) >> 0] | 0;
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = HEAP32[($1 + 16 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($1 + 20 | 0) >> 2] | 0;
    $56 = i64toi32_i32$1;
    i64toi32_i32$1 = $1;
    HEAP32[($1 + 40 | 0) >> 2] = $56;
    HEAP32[($1 + 44 | 0) >> 2] = i64toi32_i32$0;
    $0 = $cardano_serialization_lib__plutus__ConstrPlutusData_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hd2d0c81add63de21($1 + 40 | 0 | 0) | 0;
   }
   global$0 = $1 + 64 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal___push__h46c23fc0db2aa9a2($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $6 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $5 = 0, $29 = 0, $34 = 0, $39 = 0, $52 = 0;
  label$1 : {
   label$2 : {
    if (((HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) != ($3 | 0)) {
     break label$2
    }
    $0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    $3 = HEAPU16[($0 + 138 | 0) >> 1] | 0;
    if ($3 >>> 0 <= 10 >>> 0) {
     break label$1
    }
    core__panicking__panic__h2fd385a887c8bf13(1048619 | 0, 32 | 0, 1048824 | 0);
    abort();
   }
   core__panicking__panic__h2fd385a887c8bf13(1048760 | 0, 48 | 0, 1048808 | 0);
   abort();
  }
  $5 = $3 + 1 | 0;
  HEAP16[($0 + 138 | 0) >> 1] = $5;
  $6 = $0 + Math_imul($3, 28) | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $29 = i64toi32_i32$0;
  i64toi32_i32$0 = $6 + 140 | 0;
  $14 = $29;
  HEAP8[i64toi32_i32$0 >> 0] = $14;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $14 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $14 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $14 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $34 = i64toi32_i32$1;
  i64toi32_i32$1 = $6 + 148 | 0;
  $15 = $34;
  HEAP8[i64toi32_i32$1 >> 0] = $15;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $15 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $15 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $15 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $39 = i64toi32_i32$0;
  i64toi32_i32$0 = $6 + 156 | 0;
  $16 = $39;
  HEAP8[i64toi32_i32$0 >> 0] = $16;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $16 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $17 = $1 + 24 | 0;
  $18 = $6 + 164 | 0;
  $19 = HEAPU8[$17 >> 0] | 0 | ((HEAPU8[($17 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($17 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($17 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  HEAP8[$18 >> 0] = $19;
  HEAP8[($18 + 1 | 0) >> 0] = $19 >>> 8 | 0;
  HEAP8[($18 + 2 | 0) >> 0] = $19 >>> 16 | 0;
  HEAP8[($18 + 3 | 0) >> 0] = $19 >>> 24 | 0;
  $1 = $0 + Math_imul($3, 12) | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $52 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 4 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $52;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($1 + 12 | 0) >> 2] = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  HEAP32[(($0 + ($5 << 2 | 0) | 0) + 448 | 0) >> 2] = $4;
  HEAP16[($4 + 136 | 0) >> 1] = $5;
  HEAP32[$4 >> 2] = $0;
 }
 
 function alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal___push__h58c3a8a4c681696e($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $6 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $5 = 0, $29 = 0, $34 = 0, $39 = 0, $52 = 0;
  label$1 : {
   label$2 : {
    if (((HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) != ($3 | 0)) {
     break label$2
    }
    $0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    $3 = HEAPU16[($0 + 138 | 0) >> 1] | 0;
    if ($3 >>> 0 <= 10 >>> 0) {
     break label$1
    }
    core__panicking__panic__h2fd385a887c8bf13(1048619 | 0, 32 | 0, 1048824 | 0);
    abort();
   }
   core__panicking__panic__h2fd385a887c8bf13(1048760 | 0, 48 | 0, 1048808 | 0);
   abort();
  }
  $5 = $3 + 1 | 0;
  HEAP16[($0 + 138 | 0) >> 1] = $5;
  $6 = $0 + Math_imul($3, 28) | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $29 = i64toi32_i32$0;
  i64toi32_i32$0 = $6 + 140 | 0;
  $14 = $29;
  HEAP8[i64toi32_i32$0 >> 0] = $14;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $14 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $14 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $14 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $34 = i64toi32_i32$1;
  i64toi32_i32$1 = $6 + 148 | 0;
  $15 = $34;
  HEAP8[i64toi32_i32$1 >> 0] = $15;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $15 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $15 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $15 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $39 = i64toi32_i32$0;
  i64toi32_i32$0 = $6 + 156 | 0;
  $16 = $39;
  HEAP8[i64toi32_i32$0 >> 0] = $16;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $16 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $17 = $1 + 24 | 0;
  $18 = $6 + 164 | 0;
  $19 = HEAPU8[$17 >> 0] | 0 | ((HEAPU8[($17 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($17 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($17 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  HEAP8[$18 >> 0] = $19;
  HEAP8[($18 + 1 | 0) >> 0] = $19 >>> 8 | 0;
  HEAP8[($18 + 2 | 0) >> 0] = $19 >>> 16 | 0;
  HEAP8[($18 + 3 | 0) >> 0] = $19 >>> 24 | 0;
  $1 = $0 + Math_imul($3, 12) | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $52 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 4 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $52;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($1 + 12 | 0) >> 2] = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  HEAP32[(($0 + ($5 << 2 | 0) | 0) + 448 | 0) >> 2] = $4;
  HEAP16[($4 + 136 | 0) >> 1] = $5;
  HEAP32[$4 >> 2] = $0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__h4a846a71d1392aee($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $7 = 0, $3 = 0, $4 = 0, $6 = 0, $5 = 0;
  $3 = global$0 - 96 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = HEAPU16[($4 + 1062 | 0) >> 1] | 0;
  $6 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $1 = $5 + ($6 ^ -1 | 0) | 0;
  HEAP16[($2 + 1062 | 0) >> 1] = $1;
  $7 = $4 + Math_imul($6, 48) | 0;
  $3 = memcpy($3 | 0, $7 | 0, 48 | 0) | 0;
  memcpy($3 + 48 | 0 | 0, $7 + 528 | 0 | 0, 48 | 0) | 0;
  label$1 : {
   label$2 : {
    if ($1 >>> 0 >= 12 >>> 0) {
     break label$2
    }
    $7 = $6 + 1 | 0;
    if (($5 - $7 | 0 | 0) != ($1 | 0)) {
     break label$1
    }
    $7 = $4 + Math_imul($7, 48) | 0;
    $1 = Math_imul($1, 48);
    memcpy((memcpy($2 | 0, $7 | 0, $1 | 0) | 0) + 528 | 0 | 0, $7 + 528 | 0 | 0, $1 | 0) | 0;
    HEAP16[($4 + 1062 | 0) >> 1] = $6;
    memcpy((memcpy($0 | 0, $3 | 0, 48 | 0) | 0) + 48 | 0 | 0, $3 + 48 | 0 | 0, 48 | 0) | 0;
    global$0 = $3 + 96 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($1 | 0, 11 | 0, 1049044 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1048988 | 0, 40 | 0, 1049028 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__ha79dc2b8000a6d62($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $7 = 0, $3 = 0, $4 = 0, $6 = 0, $5 = 0;
  $3 = global$0 - 96 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = HEAPU16[($4 + 1062 | 0) >> 1] | 0;
  $6 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $1 = $5 + ($6 ^ -1 | 0) | 0;
  HEAP16[($2 + 1062 | 0) >> 1] = $1;
  $7 = $4 + Math_imul($6, 48) | 0;
  $3 = memcpy($3 | 0, $7 | 0, 48 | 0) | 0;
  memcpy($3 + 48 | 0 | 0, $7 + 528 | 0 | 0, 48 | 0) | 0;
  label$1 : {
   label$2 : {
    if ($1 >>> 0 >= 12 >>> 0) {
     break label$2
    }
    $7 = $6 + 1 | 0;
    if (($5 - $7 | 0 | 0) != ($1 | 0)) {
     break label$1
    }
    $7 = $4 + Math_imul($7, 48) | 0;
    $1 = Math_imul($1, 48);
    memcpy((memcpy($2 | 0, $7 | 0, $1 | 0) | 0) + 528 | 0 | 0, $7 + 528 | 0 | 0, $1 | 0) | 0;
    HEAP16[($4 + 1062 | 0) >> 1] = $6;
    memcpy((memcpy($0 | 0, $3 | 0, 48 | 0) | 0) + 48 | 0 | 0, $3 + 48 | 0 | 0, 48 | 0) | 0;
    global$0 = $3 + 96 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($1 | 0, 11 | 0, 1049044 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1048988 | 0, 40 | 0, 1049028 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_fit__h0e480b7891ac4aea($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $4 = 0, $3 = 0, $5 = 0, $6 = 0, $7 = 0;
  $3 = global$0 - 96 | 0;
  global$0 = $3;
  $4 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $5 = HEAPU16[($4 + 1458 | 0) >> 1] | 0;
  $0 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  $1 = memcpy($3 | 0, $1 | 0, 36 | 0) | 0;
  label$1 : {
   $3 = $0 + 1 | 0;
   $6 = $3 >>> 0 > $5 >>> 0;
   if ($6) {
    break label$1
   }
   $7 = $4 + 1060 | 0;
   memmove($7 + Math_imul($3, 36) | 0 | 0, $7 + Math_imul($0, 36) | 0 | 0, Math_imul($5 - $0 | 0, 36) | 0) | 0;
  }
  memcpy(($4 + Math_imul($0, 36) | 0) + 1060 | 0 | 0, $1 | 0, 36 | 0) | 0;
  $1 = memcpy($1 | 0, $2 | 0, 96 | 0) | 0;
  label$2 : {
   if ($6) {
    break label$2
   }
   memmove($4 + Math_imul($3, 96) | 0 | 0, $4 + Math_imul($0, 96) | 0 | 0, Math_imul($5 - $0 | 0, 96) | 0) | 0;
  }
  $0 = memcpy($4 + Math_imul($0, 96) | 0 | 0, $1 | 0, 96 | 0) | 0;
  HEAP16[($4 + 1458 | 0) >> 1] = $5 + 1 | 0;
  global$0 = $1 + 96 | 0;
  return $0 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_fit__hc0e2ba3df5c2c24e($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $4 = 0, $3 = 0, $5 = 0, $6 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  $4 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $5 = HEAPU16[($4 + 1062 | 0) >> 1] | 0;
  $0 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  $1 = memcpy($3 | 0, $1 | 0, 48 | 0) | 0;
  label$1 : {
   $3 = $0 + 1 | 0;
   $6 = $3 >>> 0 > $5 >>> 0;
   if ($6) {
    break label$1
   }
   memmove($4 + Math_imul($3, 48) | 0 | 0, $4 + Math_imul($0, 48) | 0 | 0, Math_imul($5 - $0 | 0, 48) | 0) | 0;
  }
  memcpy($4 + Math_imul($0, 48) | 0 | 0, $1 | 0, 48 | 0) | 0;
  $1 = memcpy($1 | 0, $2 | 0, 48 | 0) | 0;
  label$2 : {
   if ($6) {
    break label$2
   }
   $2 = $4 + 528 | 0;
   memmove($2 + Math_imul($3, 48) | 0 | 0, $2 + Math_imul($0, 48) | 0 | 0, Math_imul($5 - $0 | 0, 48) | 0) | 0;
  }
  $0 = memcpy(($4 + Math_imul($0, 48) | 0) + 528 | 0 | 0, $1 | 0, 48 | 0) | 0;
  HEAP16[($4 + 1062 | 0) >> 1] = $5 + 1 | 0;
  global$0 = $1 + 48 | 0;
  return $0 | 0;
 }
 
 function cbor_event__de__Deserializer_R___tuple__hfad22f5abd2b96b4($0, $1, $2, $2$hi, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $5 = 0, $6$hi = 0, $6 = 0, $7 = 0, $7$hi = 0, $46 = 0, $51 = 0, $56 = 0;
  $5 = global$0 - 48 | 0;
  global$0 = $5;
  cbor_event__de__Deserializer_R___array__h321bea2f515f4cd0($5 | 0, $1 | 0);
  i64toi32_i32$2 = $5 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $6 = i64toi32_i32$0;
  $6$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $5;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $7 = i64toi32_i32$1;
  $7$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     i64toi32_i32$2 = i64toi32_i32$0;
     i64toi32_i32$0 = 0;
     i64toi32_i32$3 = 1;
     if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
      break label$3
     }
     label$4 : {
      i64toi32_i32$2 = $7$hi;
      i64toi32_i32$3 = $7;
      i64toi32_i32$1 = 0;
      i64toi32_i32$0 = 1;
      if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$1 | 0) | 0) {
       break label$4
      }
      i64toi32_i32$3 = $6$hi;
      i64toi32_i32$3 = $2$hi;
      i64toi32_i32$3 = $6$hi;
      i64toi32_i32$0 = $6;
      i64toi32_i32$2 = $2$hi;
      i64toi32_i32$1 = $2;
      if ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & (i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) | 0) {
       break label$2
      }
     }
     HEAP8[$0 >> 0] = 13;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$3 = $0 + 32 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $6;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$0 = $7$hi;
     i64toi32_i32$3 = $0 + 24 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $7;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$0 = $2$hi;
     i64toi32_i32$3 = $0 + 16 | 0;
     HEAP32[i64toi32_i32$3 >> 2] = $2;
     HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[($0 + 8 | 0) >> 2] = $4;
     HEAP32[($0 + 4 | 0) >> 2] = $3;
     break label$1;
    }
    i64toi32_i32$1 = $5 + 40 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
    $46 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 32 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $46;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
    i64toi32_i32$1 = $5 + 32 | 0;
    i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
    $51 = i64toi32_i32$3;
    i64toi32_i32$3 = $0 + 24 | 0;
    HEAP32[i64toi32_i32$3 >> 2] = $51;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$1 = $5 + 24 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
    $56 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $56;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
    i64toi32_i32$3 = $6$hi;
    i64toi32_i32$0 = $0 + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $6;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
    i64toi32_i32$3 = $7$hi;
    i64toi32_i32$0 = $0;
    HEAP32[i64toi32_i32$0 >> 2] = $7;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$3;
    break label$1;
   }
   HEAP8[$0 >> 0] = 19;
  }
  global$0 = $5 + 48 | 0;
 }
 
 function publickey_from_bech32($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $9 = 0, $10 = 0, $11 = 0, $39 = 0, $44 = 0, $61 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  HEAP32[($2 + 52 | 0) >> 2] = $1;
  $0 = HEAP32[$2 >> 2] | 0;
  HEAP32[($2 + 48 | 0) >> 2] = $0;
  cardano_serialization_lib__crypto__PublicKey__from_bech32__h7c89515135180771($2 + 8 | 0 | 0, $0 | 0, $1 | 0);
  core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_2($2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 8 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = $2 + 24 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $39 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 63 | 0;
  $9 = $39;
  HEAP8[i64toi32_i32$0 >> 0] = $9;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $9 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $9 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $9 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 32 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $44 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 71 | 0;
  $10 = $44;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP8[($2 + 79 | 0) >> 0] = HEAPU8[($2 + 40 | 0) >> 0] | 0;
  HEAP8[($2 + 50 | 0) >> 0] = HEAPU8[($2 + 11 | 0) >> 0] | 0;
  HEAP16[($2 + 48 | 0) >> 1] = HEAPU8[($2 + 9 | 0) >> 0] | 0 | ((HEAPU8[($2 + 10 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 51 | 0) >> 0] = $1;
  HEAP8[($2 + 52 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 53 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 54 | 0) >> 0] = $1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $61 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  $11 = $61;
  HEAP8[($2 + 55 | 0) >> 0] = $11;
  HEAP8[($2 + 56 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[($2 + 57 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[($2 + 58 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[($2 + 59 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[($2 + 60 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[($2 + 61 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[($2 + 62 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $1 = $cardano_serialization_lib__crypto__PublicKey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h435bbe8dcccd675c($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 80 | 0;
  return $1 | 0;
 }
 
 function publickey_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $9 = 0, $10 = 0, $11 = 0, $39 = 0, $44 = 0, $61 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  HEAP32[($2 + 52 | 0) >> 2] = $1;
  $0 = HEAP32[$2 >> 2] | 0;
  HEAP32[($2 + 48 | 0) >> 2] = $0;
  cardano_serialization_lib__crypto__PublicKey__from_bytes__hb62a5cda8a087ae0($2 + 8 | 0 | 0, $0 | 0, $1 | 0);
  core__ptr__drop_in_place_alloc__boxed__Box__5bu8_5d____h1049615268b5f7c4($2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 8 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = $2 + 24 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $39 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 63 | 0;
  $9 = $39;
  HEAP8[i64toi32_i32$0 >> 0] = $9;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $9 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $9 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $9 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 32 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $44 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 71 | 0;
  $10 = $44;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP8[($2 + 79 | 0) >> 0] = HEAPU8[($2 + 40 | 0) >> 0] | 0;
  HEAP8[($2 + 50 | 0) >> 0] = HEAPU8[($2 + 11 | 0) >> 0] | 0;
  HEAP16[($2 + 48 | 0) >> 1] = HEAPU8[($2 + 9 | 0) >> 0] | 0 | ((HEAPU8[($2 + 10 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 51 | 0) >> 0] = $1;
  HEAP8[($2 + 52 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 53 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 54 | 0) >> 0] = $1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $61 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  $11 = $61;
  HEAP8[($2 + 55 | 0) >> 0] = $11;
  HEAP8[($2 + 56 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[($2 + 57 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[($2 + 58 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[($2 + 59 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[($2 + 60 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[($2 + 61 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[($2 + 62 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $1 = $cardano_serialization_lib__crypto__PublicKey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h435bbe8dcccd675c($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 80 | 0;
  return $1 | 0;
 }
 
 function transactionhash_from_bech32($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $9 = 0, $10 = 0, $11 = 0, $39 = 0, $44 = 0, $61 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  HEAP32[($2 + 52 | 0) >> 2] = $1;
  $0 = HEAP32[$2 >> 2] | 0;
  HEAP32[($2 + 48 | 0) >> 2] = $0;
  cardano_serialization_lib__crypto__TransactionHash__from_bech32__h61a79be54ec7891b($2 + 8 | 0 | 0, $0 | 0, $1 | 0);
  core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_2($2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 8 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = $2 + 24 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $39 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 63 | 0;
  $9 = $39;
  HEAP8[i64toi32_i32$0 >> 0] = $9;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $9 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $9 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $9 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 32 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $44 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 71 | 0;
  $10 = $44;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP8[($2 + 79 | 0) >> 0] = HEAPU8[($2 + 40 | 0) >> 0] | 0;
  HEAP8[($2 + 50 | 0) >> 0] = HEAPU8[($2 + 11 | 0) >> 0] | 0;
  HEAP16[($2 + 48 | 0) >> 1] = HEAPU8[($2 + 9 | 0) >> 0] | 0 | ((HEAPU8[($2 + 10 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 51 | 0) >> 0] = $1;
  HEAP8[($2 + 52 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 53 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 54 | 0) >> 0] = $1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $61 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  $11 = $61;
  HEAP8[($2 + 55 | 0) >> 0] = $11;
  HEAP8[($2 + 56 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[($2 + 57 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[($2 + 58 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[($2 + 59 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[($2 + 60 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[($2 + 61 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[($2 + 62 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $1 = $cardano_serialization_lib__crypto__TransactionHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__ha325bfafa26d5417($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 80 | 0;
  return $1 | 0;
 }
 
 function auxiliarydatahash_from_bech32($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $9 = 0, $10 = 0, $11 = 0, $39 = 0, $44 = 0, $61 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  HEAP32[($2 + 52 | 0) >> 2] = $1;
  $0 = HEAP32[$2 >> 2] | 0;
  HEAP32[($2 + 48 | 0) >> 2] = $0;
  cardano_serialization_lib__crypto__AuxiliaryDataHash__from_bech32__h96d109034c059913($2 + 8 | 0 | 0, $0 | 0, $1 | 0);
  core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_2($2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 8 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = $2 + 24 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $39 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 63 | 0;
  $9 = $39;
  HEAP8[i64toi32_i32$0 >> 0] = $9;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $9 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $9 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $9 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 32 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $44 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 71 | 0;
  $10 = $44;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP8[($2 + 79 | 0) >> 0] = HEAPU8[($2 + 40 | 0) >> 0] | 0;
  HEAP8[($2 + 50 | 0) >> 0] = HEAPU8[($2 + 11 | 0) >> 0] | 0;
  HEAP16[($2 + 48 | 0) >> 1] = HEAPU8[($2 + 9 | 0) >> 0] | 0 | ((HEAPU8[($2 + 10 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 51 | 0) >> 0] = $1;
  HEAP8[($2 + 52 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 53 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 54 | 0) >> 0] = $1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $61 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  $11 = $61;
  HEAP8[($2 + 55 | 0) >> 0] = $11;
  HEAP8[($2 + 56 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[($2 + 57 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[($2 + 58 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[($2 + 59 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[($2 + 60 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[($2 + 61 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[($2 + 62 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $1 = $cardano_serialization_lib__crypto__AuxiliaryDataHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__ha0bdb89a2c7c1e66($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 80 | 0;
  return $1 | 0;
 }
 
 function poolmetadatahash_from_bech32($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $9 = 0, $10 = 0, $11 = 0, $39 = 0, $44 = 0, $61 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  HEAP32[($2 + 52 | 0) >> 2] = $1;
  $0 = HEAP32[$2 >> 2] | 0;
  HEAP32[($2 + 48 | 0) >> 2] = $0;
  cardano_serialization_lib__crypto__PoolMetadataHash__from_bech32__h09c287ec559a2479($2 + 8 | 0 | 0, $0 | 0, $1 | 0);
  core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_2($2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 8 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = $2 + 24 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $39 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 63 | 0;
  $9 = $39;
  HEAP8[i64toi32_i32$0 >> 0] = $9;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $9 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $9 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $9 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 32 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $44 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 71 | 0;
  $10 = $44;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP8[($2 + 79 | 0) >> 0] = HEAPU8[($2 + 40 | 0) >> 0] | 0;
  HEAP8[($2 + 50 | 0) >> 0] = HEAPU8[($2 + 11 | 0) >> 0] | 0;
  HEAP16[($2 + 48 | 0) >> 1] = HEAPU8[($2 + 9 | 0) >> 0] | 0 | ((HEAPU8[($2 + 10 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 51 | 0) >> 0] = $1;
  HEAP8[($2 + 52 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 53 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 54 | 0) >> 0] = $1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $61 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  $11 = $61;
  HEAP8[($2 + 55 | 0) >> 0] = $11;
  HEAP8[($2 + 56 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[($2 + 57 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[($2 + 58 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[($2 + 59 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[($2 + 60 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[($2 + 61 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[($2 + 62 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $1 = $cardano_serialization_lib__crypto__PoolMetadataHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__heaaf3507fd71ee00($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 80 | 0;
  return $1 | 0;
 }
 
 function vrfkeyhash_from_bech32($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $9 = 0, $10 = 0, $11 = 0, $39 = 0, $44 = 0, $61 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  HEAP32[($2 + 52 | 0) >> 2] = $1;
  $0 = HEAP32[$2 >> 2] | 0;
  HEAP32[($2 + 48 | 0) >> 2] = $0;
  cardano_serialization_lib__crypto__VRFKeyHash__from_bech32__h81f854309374c8be($2 + 8 | 0 | 0, $0 | 0, $1 | 0);
  core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_2($2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 8 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = $2 + 24 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $39 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 63 | 0;
  $9 = $39;
  HEAP8[i64toi32_i32$0 >> 0] = $9;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $9 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $9 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $9 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 32 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $44 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 71 | 0;
  $10 = $44;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP8[($2 + 79 | 0) >> 0] = HEAPU8[($2 + 40 | 0) >> 0] | 0;
  HEAP8[($2 + 50 | 0) >> 0] = HEAPU8[($2 + 11 | 0) >> 0] | 0;
  HEAP16[($2 + 48 | 0) >> 1] = HEAPU8[($2 + 9 | 0) >> 0] | 0 | ((HEAPU8[($2 + 10 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 51 | 0) >> 0] = $1;
  HEAP8[($2 + 52 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 53 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 54 | 0) >> 0] = $1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $61 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  $11 = $61;
  HEAP8[($2 + 55 | 0) >> 0] = $11;
  HEAP8[($2 + 56 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[($2 + 57 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[($2 + 58 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[($2 + 59 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[($2 + 60 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[($2 + 61 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[($2 + 62 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $1 = $cardano_serialization_lib__crypto__VRFKeyHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf9aae481fe8479f($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 80 | 0;
  return $1 | 0;
 }
 
 function blockhash_from_bech32($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $9 = 0, $10 = 0, $11 = 0, $39 = 0, $44 = 0, $61 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  HEAP32[($2 + 52 | 0) >> 2] = $1;
  $0 = HEAP32[$2 >> 2] | 0;
  HEAP32[($2 + 48 | 0) >> 2] = $0;
  cardano_serialization_lib__crypto__BlockHash__from_bech32__he52434727cf154a3($2 + 8 | 0 | 0, $0 | 0, $1 | 0);
  core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_2($2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 8 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = $2 + 24 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $39 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 63 | 0;
  $9 = $39;
  HEAP8[i64toi32_i32$0 >> 0] = $9;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $9 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $9 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $9 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 32 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $44 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 71 | 0;
  $10 = $44;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP8[($2 + 79 | 0) >> 0] = HEAPU8[($2 + 40 | 0) >> 0] | 0;
  HEAP8[($2 + 50 | 0) >> 0] = HEAPU8[($2 + 11 | 0) >> 0] | 0;
  HEAP16[($2 + 48 | 0) >> 1] = HEAPU8[($2 + 9 | 0) >> 0] | 0 | ((HEAPU8[($2 + 10 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 51 | 0) >> 0] = $1;
  HEAP8[($2 + 52 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 53 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 54 | 0) >> 0] = $1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $61 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  $11 = $61;
  HEAP8[($2 + 55 | 0) >> 0] = $11;
  HEAP8[($2 + 56 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[($2 + 57 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[($2 + 58 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[($2 + 59 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[($2 + 60 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[($2 + 61 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[($2 + 62 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $1 = $cardano_serialization_lib__crypto__BlockHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hf8ef4eaf9a4a30cf($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 80 | 0;
  return $1 | 0;
 }
 
 function datahash_from_bech32($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $9 = 0, $10 = 0, $11 = 0, $39 = 0, $44 = 0, $61 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  HEAP32[($2 + 52 | 0) >> 2] = $1;
  $0 = HEAP32[$2 >> 2] | 0;
  HEAP32[($2 + 48 | 0) >> 2] = $0;
  cardano_serialization_lib__crypto__DataHash__from_bech32__h3c968bd64fb7d698($2 + 8 | 0 | 0, $0 | 0, $1 | 0);
  core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_2($2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 8 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = $2 + 24 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $39 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 63 | 0;
  $9 = $39;
  HEAP8[i64toi32_i32$0 >> 0] = $9;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $9 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $9 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $9 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 32 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $44 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 71 | 0;
  $10 = $44;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP8[($2 + 79 | 0) >> 0] = HEAPU8[($2 + 40 | 0) >> 0] | 0;
  HEAP8[($2 + 50 | 0) >> 0] = HEAPU8[($2 + 11 | 0) >> 0] | 0;
  HEAP16[($2 + 48 | 0) >> 1] = HEAPU8[($2 + 9 | 0) >> 0] | 0 | ((HEAPU8[($2 + 10 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 51 | 0) >> 0] = $1;
  HEAP8[($2 + 52 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 53 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 54 | 0) >> 0] = $1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $61 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  $11 = $61;
  HEAP8[($2 + 55 | 0) >> 0] = $11;
  HEAP8[($2 + 56 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[($2 + 57 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[($2 + 58 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[($2 + 59 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[($2 + 60 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[($2 + 61 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[($2 + 62 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $1 = $cardano_serialization_lib__crypto__DataHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hba2449530c6577ab($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 80 | 0;
  return $1 | 0;
 }
 
 function scriptdatahash_from_bech32($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $9 = 0, $10 = 0, $11 = 0, $39 = 0, $44 = 0, $61 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  HEAP32[($2 + 52 | 0) >> 2] = $1;
  $0 = HEAP32[$2 >> 2] | 0;
  HEAP32[($2 + 48 | 0) >> 2] = $0;
  cardano_serialization_lib__crypto__ScriptDataHash__from_bech32__hf10a40565f031ab7($2 + 8 | 0 | 0, $0 | 0, $1 | 0);
  core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_2($2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 8 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = $2 + 24 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $39 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 63 | 0;
  $9 = $39;
  HEAP8[i64toi32_i32$0 >> 0] = $9;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $9 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $9 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $9 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 32 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $44 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 71 | 0;
  $10 = $44;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP8[($2 + 79 | 0) >> 0] = HEAPU8[($2 + 40 | 0) >> 0] | 0;
  HEAP8[($2 + 50 | 0) >> 0] = HEAPU8[($2 + 11 | 0) >> 0] | 0;
  HEAP16[($2 + 48 | 0) >> 1] = HEAPU8[($2 + 9 | 0) >> 0] | 0 | ((HEAPU8[($2 + 10 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 51 | 0) >> 0] = $1;
  HEAP8[($2 + 52 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 53 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 54 | 0) >> 0] = $1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $61 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  $11 = $61;
  HEAP8[($2 + 55 | 0) >> 0] = $11;
  HEAP8[($2 + 56 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[($2 + 57 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[($2 + 58 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[($2 + 59 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[($2 + 60 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[($2 + 61 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[($2 + 62 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $1 = $cardano_serialization_lib__crypto__ScriptDataHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h4525048b15d98533($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 80 | 0;
  return $1 | 0;
 }
 
 function vrfvkey_from_bech32($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $9 = 0, $10 = 0, $11 = 0, $39 = 0, $44 = 0, $61 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  HEAP32[($2 + 52 | 0) >> 2] = $1;
  $0 = HEAP32[$2 >> 2] | 0;
  HEAP32[($2 + 48 | 0) >> 2] = $0;
  cardano_serialization_lib__crypto__VRFVKey__from_bech32__h0908331f30976677($2 + 8 | 0 | 0, $0 | 0, $1 | 0);
  core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_2($2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 8 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = $2 + 24 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $39 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 63 | 0;
  $9 = $39;
  HEAP8[i64toi32_i32$0 >> 0] = $9;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $9 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $9 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $9 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 32 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $44 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 71 | 0;
  $10 = $44;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP8[($2 + 79 | 0) >> 0] = HEAPU8[($2 + 40 | 0) >> 0] | 0;
  HEAP8[($2 + 50 | 0) >> 0] = HEAPU8[($2 + 11 | 0) >> 0] | 0;
  HEAP16[($2 + 48 | 0) >> 1] = HEAPU8[($2 + 9 | 0) >> 0] | 0 | ((HEAPU8[($2 + 10 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 51 | 0) >> 0] = $1;
  HEAP8[($2 + 52 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 53 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 54 | 0) >> 0] = $1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $61 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  $11 = $61;
  HEAP8[($2 + 55 | 0) >> 0] = $11;
  HEAP8[($2 + 56 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[($2 + 57 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[($2 + 58 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[($2 + 59 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[($2 + 60 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[($2 + 61 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[($2 + 62 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $1 = $cardano_serialization_lib__crypto__VRFVKey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h510224eaef243251($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 80 | 0;
  return $1 | 0;
 }
 
 function kesvkey_from_bech32($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $9 = 0, $10 = 0, $11 = 0, $39 = 0, $44 = 0, $61 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  HEAP32[($2 + 52 | 0) >> 2] = $1;
  $0 = HEAP32[$2 >> 2] | 0;
  HEAP32[($2 + 48 | 0) >> 2] = $0;
  cardano_serialization_lib__crypto__KESVKey__from_bech32__hc8825be559d40be0($2 + 8 | 0 | 0, $0 | 0, $1 | 0);
  core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_2($2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 8 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = $2 + 24 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $39 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 63 | 0;
  $9 = $39;
  HEAP8[i64toi32_i32$0 >> 0] = $9;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $9 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $9 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $9 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 32 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $44 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 71 | 0;
  $10 = $44;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP8[($2 + 79 | 0) >> 0] = HEAPU8[($2 + 40 | 0) >> 0] | 0;
  HEAP8[($2 + 50 | 0) >> 0] = HEAPU8[($2 + 11 | 0) >> 0] | 0;
  HEAP16[($2 + 48 | 0) >> 1] = HEAPU8[($2 + 9 | 0) >> 0] | 0 | ((HEAPU8[($2 + 10 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 51 | 0) >> 0] = $1;
  HEAP8[($2 + 52 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 53 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 54 | 0) >> 0] = $1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $61 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  $11 = $61;
  HEAP8[($2 + 55 | 0) >> 0] = $11;
  HEAP8[($2 + 56 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[($2 + 57 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[($2 + 58 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[($2 + 59 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[($2 + 60 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[($2 + 61 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[($2 + 62 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $1 = $cardano_serialization_lib__crypto__KESVKey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h5c8fb7ce130dd69e($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 80 | 0;
  return $1 | 0;
 }
 
 function baseaddress_payment_cred($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $2 = 0, $5 = 0, $6 = 0, $3 = 0, $7 = 0, $7$hi = 0, $4 = 0, $8 = 0, $8$hi = 0, $35 = 0, $54 = 0, $58 = 0, $67 = 0;
  $1 = global$0 - 112 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h41e273aed1ab619e($1 + 8 | 0 | 0, $0 | 0);
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $18 = $0 + 26 | 0;
  $3 = HEAPU8[$18 >> 0] | 0 | ((HEAPU8[($18 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($18 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($18 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $0 + 18 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  $4 = HEAPU8[($0 + 1 | 0) >> 0] | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 9 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $8 = i64toi32_i32$1;
  $8$hi = i64toi32_i32$0;
  $5 = $1 + 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 10 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $35 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[i64toi32_i32$0 >> 2] = $35;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $0 = $1 + 32 | 0;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $6 = $1 + 40 | 0;
  HEAP32[$6 >> 2] = $3;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = $1;
  HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$1;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $54 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 89 | 0;
  $19 = $54;
  HEAP8[i64toi32_i32$1 >> 0] = $19;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $19 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $19 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $19 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $58 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 97 | 0;
  $20 = $58;
  HEAP8[i64toi32_i32$0 >> 0] = $20;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $20 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $20 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $20 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $21 = $1 + 105 | 0;
  $22 = HEAP32[$6 >> 2] | 0;
  HEAP8[$21 >> 0] = $22;
  HEAP8[($21 + 1 | 0) >> 0] = $22 >>> 8 | 0;
  HEAP8[($21 + 2 | 0) >> 0] = $22 >>> 16 | 0;
  HEAP8[($21 + 3 | 0) >> 0] = $22 >>> 24 | 0;
  HEAP8[($1 + 80 | 0) >> 0] = $4;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $67 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  $23 = $67;
  HEAP8[(i64toi32_i32$2 + 81 | 0) >> 0] = $23;
  HEAP8[(i64toi32_i32$2 + 82 | 0) >> 0] = $23 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 83 | 0) >> 0] = $23 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 84 | 0) >> 0] = $23 >>> 24 | 0;
  HEAP8[(i64toi32_i32$2 + 85 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$2 + 86 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 87 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 88 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $0 = $cardano_serialization_lib__address__StakeCredential_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hfe6826a4b7739a89(i64toi32_i32$2 + 80 | 0 | 0) | 0;
  global$0 = i64toi32_i32$2 + 112 | 0;
  return $0 | 0;
 }
 
 function enterpriseaddress_payment_cred($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $2 = 0, $5 = 0, $6 = 0, $3 = 0, $7 = 0, $7$hi = 0, $4 = 0, $8 = 0, $8$hi = 0, $35 = 0, $54 = 0, $58 = 0, $67 = 0;
  $1 = global$0 - 112 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hc7fc7357c4bbb0b7($1 + 8 | 0 | 0, $0 | 0);
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $18 = $0 + 26 | 0;
  $3 = HEAPU8[$18 >> 0] | 0 | ((HEAPU8[($18 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($18 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($18 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $0 + 18 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  $4 = HEAPU8[($0 + 1 | 0) >> 0] | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 9 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $8 = i64toi32_i32$1;
  $8$hi = i64toi32_i32$0;
  $5 = $1 + 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 10 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $35 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[i64toi32_i32$0 >> 2] = $35;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $0 = $1 + 32 | 0;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $6 = $1 + 40 | 0;
  HEAP32[$6 >> 2] = $3;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = $1;
  HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$1;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $54 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 89 | 0;
  $19 = $54;
  HEAP8[i64toi32_i32$1 >> 0] = $19;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $19 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $19 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $19 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $58 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 97 | 0;
  $20 = $58;
  HEAP8[i64toi32_i32$0 >> 0] = $20;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $20 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $20 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $20 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $21 = $1 + 105 | 0;
  $22 = HEAP32[$6 >> 2] | 0;
  HEAP8[$21 >> 0] = $22;
  HEAP8[($21 + 1 | 0) >> 0] = $22 >>> 8 | 0;
  HEAP8[($21 + 2 | 0) >> 0] = $22 >>> 16 | 0;
  HEAP8[($21 + 3 | 0) >> 0] = $22 >>> 24 | 0;
  HEAP8[($1 + 80 | 0) >> 0] = $4;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $67 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  $23 = $67;
  HEAP8[(i64toi32_i32$2 + 81 | 0) >> 0] = $23;
  HEAP8[(i64toi32_i32$2 + 82 | 0) >> 0] = $23 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 83 | 0) >> 0] = $23 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 84 | 0) >> 0] = $23 >>> 24 | 0;
  HEAP8[(i64toi32_i32$2 + 85 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$2 + 86 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 87 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 88 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $0 = $cardano_serialization_lib__address__StakeCredential_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hfe6826a4b7739a89(i64toi32_i32$2 + 80 | 0 | 0) | 0;
  global$0 = i64toi32_i32$2 + 112 | 0;
  return $0 | 0;
 }
 
 function rewardaddress_payment_cred($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $2 = 0, $5 = 0, $6 = 0, $3 = 0, $7 = 0, $7$hi = 0, $4 = 0, $8 = 0, $8$hi = 0, $35 = 0, $54 = 0, $58 = 0, $67 = 0;
  $1 = global$0 - 112 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h2338c90e0327d08b($1 + 8 | 0 | 0, $0 | 0);
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $18 = $0 + 26 | 0;
  $3 = HEAPU8[$18 >> 0] | 0 | ((HEAPU8[($18 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($18 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($18 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $0 + 18 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  $4 = HEAPU8[($0 + 1 | 0) >> 0] | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 9 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $8 = i64toi32_i32$1;
  $8$hi = i64toi32_i32$0;
  $5 = $1 + 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 10 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $35 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[i64toi32_i32$0 >> 2] = $35;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $0 = $1 + 32 | 0;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $6 = $1 + 40 | 0;
  HEAP32[$6 >> 2] = $3;
  i64toi32_i32$1 = $8$hi;
  i64toi32_i32$0 = $1;
  HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $8;
  HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$1;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $54 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 89 | 0;
  $19 = $54;
  HEAP8[i64toi32_i32$1 >> 0] = $19;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $19 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $19 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $19 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $58 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 97 | 0;
  $20 = $58;
  HEAP8[i64toi32_i32$0 >> 0] = $20;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $20 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $20 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $20 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $21 = $1 + 105 | 0;
  $22 = HEAP32[$6 >> 2] | 0;
  HEAP8[$21 >> 0] = $22;
  HEAP8[($21 + 1 | 0) >> 0] = $22 >>> 8 | 0;
  HEAP8[($21 + 2 | 0) >> 0] = $22 >>> 16 | 0;
  HEAP8[($21 + 3 | 0) >> 0] = $22 >>> 24 | 0;
  HEAP8[($1 + 80 | 0) >> 0] = $4;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $67 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  $23 = $67;
  HEAP8[(i64toi32_i32$2 + 81 | 0) >> 0] = $23;
  HEAP8[(i64toi32_i32$2 + 82 | 0) >> 0] = $23 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 83 | 0) >> 0] = $23 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 84 | 0) >> 0] = $23 >>> 24 | 0;
  HEAP8[(i64toi32_i32$2 + 85 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$2 + 86 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 87 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 88 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $0 = $cardano_serialization_lib__address__StakeCredential_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hfe6826a4b7739a89(i64toi32_i32$2 + 80 | 0 | 0) | 0;
  global$0 = i64toi32_i32$2 + 112 | 0;
  return $0 | 0;
 }
 
 function costmdls_insert($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, $5 = 0, i64toi32_i32$1 = 0;
  $3 = global$0 - 64 | 0;
  global$0 = $3;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h01f36213dd513b30($3 + 24 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $4 = HEAP32[($3 + 28 | 0) >> 2] | 0;
   $5 = HEAP32[($3 + 24 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hfa98d20552a22c6d($3 + 16 | 0 | 0, $1 | 0);
   if (!$2) {
    break label$1
   }
   $0 = HEAP32[($3 + 20 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h63771635114e9ad4($3 + 8 | 0 | 0, $2 | 0);
   $1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h614c9de21e58255d($3 + 48 | 0 | 0, HEAP32[($3 + 8 | 0) >> 2] | 0 | 0);
   alloc__collections__btree__map__BTreeMap_K_2cV___insert__h4d28978302e72baa($3 + 32 | 0 | 0, $5 | 0, $3 + 48 | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   $0 = 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($4 | 0, 0 | 0) | 0;
   label$2 : {
    $1 = HEAP32[($3 + 32 | 0) >> 2] | 0;
    if (!$1) {
     break label$2
    }
    i64toi32_i32$1 = HEAP32[($3 + 40 | 0) >> 2] | 0;
    HEAP32[($3 + 52 | 0) >> 2] = HEAP32[($3 + 36 | 0) >> 2] | 0;
    HEAP32[($3 + 56 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($3 + 48 | 0) >> 2] = $1;
    $0 = $cardano_serialization_lib__plutus__CostModel_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h131279c16539114c($3 + 48 | 0 | 0) | 0;
   }
   global$0 = $3 + 64 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function $getrandom__error__Error_20as_20core__fmt__Debug___fmt__h34a0039dca79e077($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $9 = 0, $3 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  i64toi32_i32$0 = core__fmt__Formatter__debug_struct__h873400a11fe69724($1 | 0, 1075156 | 0, 5 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $9 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $9;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    $0 = HEAP32[$0 >> 2] | 0;
    if (($0 | 0) < (0 | 0)) {
     break label$2
    }
    HEAP32[($2 + 16 | 0) >> 2] = $0;
    core__fmt__builders__DebugStruct__field__hec833bfe02704935($2 + 8 | 0 | 0, 1075232 | 0, 8 | 0, $2 + 16 | 0 | 0, 1075240 | 0) | 0;
    break label$1;
   }
   getrandom__error__internal_desc__h19dfc27a2698807d($2 | 0, $0 | 0);
   label$3 : {
    $1 = HEAP32[$2 >> 2] | 0;
    if (!$1) {
     break label$3
    }
    $3 = HEAP32[($2 + 4 | 0) >> 2] | 0;
    HEAP32[($2 + 16 | 0) >> 2] = $1;
    HEAP32[($2 + 20 | 0) >> 2] = $3;
    HEAP32[($2 + 28 | 0) >> 2] = $0;
    core__fmt__builders__DebugStruct__field__hec833bfe02704935($2 + 8 | 0 | 0, 1075192 | 0, 13 | 0, $2 + 28 | 0 | 0, 1075176 | 0) | 0;
    core__fmt__builders__DebugStruct__field__hec833bfe02704935($2 + 8 | 0 | 0, 1075205 | 0, 11 | 0, $2 + 16 | 0 | 0, 1075216 | 0) | 0;
    break label$1;
   }
   HEAP32[($2 + 16 | 0) >> 2] = $0;
   core__fmt__builders__DebugStruct__field__hec833bfe02704935($2 + 8 | 0 | 0, 1075161 | 0, 12 | 0, $2 + 16 | 0 | 0, 1075176 | 0) | 0;
  }
  $0 = core__fmt__builders__DebugStruct__finish__hb1eae1aa0e288840($2 + 8 | 0 | 0) | 0;
  global$0 = $2 + 32 | 0;
  return $0 | 0;
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend_T_2cI____spec_extend__h60be40d0f8090820($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, i64toi32_i32$0 = 0, $6 = 0, i64toi32_i32$1 = 0, $5 = 0, i64toi32_i32$2 = 0, $4 = 0, $7 = 0, $52 = 0, $55 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      if ($3) {
       break label$4
      }
      $4 = $0 + 8 | 0;
      break label$3;
     }
     $5 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     if (!$5) {
      break label$1
     }
     $4 = $0 + 8 | 0;
     $6 = HEAP32[($0 + 8 | 0) >> 2] | 0;
     $7 = ($3 >>> 0) / ($5 >>> 0) | 0;
     $3 = $7 + (($3 - Math_imul($7, $5) | 0 | 0) != (0 | 0)) | 0;
     if (((HEAP32[($0 + 4 | 0) >> 2] | 0) - $6 | 0) >>> 0 >= $3 >>> 0) {
      break label$2
     }
     alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h90c9768825cdae1b($0 | 0, $6 | 0, $3 | 0);
    }
    $6 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   }
   $0 = HEAP32[$0 >> 2] | 0;
   i64toi32_i32$2 = $1 + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $52 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $52;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   $55 = i64toi32_i32$1;
   i64toi32_i32$1 = $2;
   HEAP32[$2 >> 2] = $55;
   HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] = $6;
   HEAP32[($2 + 20 | 0) >> 2] = $4;
   HEAP32[($2 + 16 | 0) >> 2] = $0 + ($6 << 2 | 0) | 0;
   $core__iter__adapters__map__Map_I_2cF__20as_20core__iter__traits__iterator__Iterator___fold__h7fe3f1b6aba6eb47($2 | 0, $2 + 16 | 0 | 0);
   global$0 = $2 + 32 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1083600 | 0, 25 | 0, 1083576 | 0);
  abort();
 }
 
 function serde_json__de__Deserializer_R___end_map__h445abe9350b38011($0) {
  $0 = $0 | 0;
  var $2 = 0, $1 = 0, $3 = 0, $6 = 0, $5 = 0, $7 = 0, $4 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $2 = HEAP32[($0 + 8 | 0) >> 2] | 0;
      $3 = HEAP32[($0 + 4 | 0) >> 2] | 0;
      if ($2 >>> 0 >= $3 >>> 0) {
       break label$4
      }
      $4 = HEAP32[$0 >> 2] | 0;
      $5 = 1;
      label$5 : {
       label$6 : while (1) {
        $6 = HEAPU8[($4 + $2 | 0) >> 0] | 0;
        $7 = $6 + -9 | 0;
        if ($7 >>> 0 > 23 >>> 0) {
         break label$5
        }
        if (!((1 << $7 | 0) & 8388627 | 0)) {
         break label$5
        }
        $2 = $2 + 1 | 0;
        HEAP32[($0 + 8 | 0) >> 2] = $2;
        $5 = $2 >>> 0 < $3 >>> 0;
        if (($3 | 0) != ($2 | 0)) {
         continue label$6
        }
        break label$6;
       };
       $6 = 0;
       $2 = $3;
      }
      if ($5 & 1 | 0) {
       break label$3
      }
     }
     HEAP32[$1 >> 2] = 3;
     break label$2;
    }
    label$7 : {
     label$8 : {
      if (($6 | 0) == (125 | 0)) {
       break label$8
      }
      if (($6 | 0) == (44 | 0)) {
       break label$7
      }
      HEAP32[$1 >> 2] = 19;
      break label$2;
     }
     HEAP32[($0 + 8 | 0) >> 2] = $2 + 1 | 0;
     $2 = 0;
     break label$1;
    }
    HEAP32[$1 >> 2] = 18;
   }
   $2 = serde_json__de__Deserializer_R___peek_error__hf8794e102c1db2df($0 | 0, $1 | 0) | 0;
  }
  global$0 = $1 + 16 | 0;
  return $2 | 0;
 }
 
 function serde__de__impls___impl_20serde__de__Deserialize_20for_20alloc__string__String___deserialize__ha8d5ac457296ae8f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $5 = 0, $4 = 0, $3 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  HEAP32[($1 + 20 | 0) >> 2] = 0;
  HEAP32[($1 + 8 | 0) >> 2] = (HEAP32[($1 + 8 | 0) >> 2] | 0) + 1 | 0;
  $serde_json__read__StrRead_20as_20serde_json__read__Read___parse_str__h09f2a2399a6a37b5($2 + 16 | 0 | 0, $1 | 0, $1 + 12 | 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[(($2 + 16 | 0) + 12 | 0) >> 2] | 0;
    $3 = HEAP32[($2 + 24 | 0) >> 2] | 0;
    label$3 : {
     label$4 : {
      if (HEAP32[($2 + 20 | 0) >> 2] | 0) {
       break label$4
      }
      alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, $1 | 0, 0 | 0);
      $4 = HEAP32[($2 + 4 | 0) >> 2] | 0;
      $5 = HEAP32[$2 >> 2] | 0;
      break label$3;
     }
     alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 + 8 | 0 | 0, $1 | 0, 0 | 0);
     $4 = HEAP32[($2 + 12 | 0) >> 2] | 0;
     $5 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    }
    HEAP32[($0 + 4 | 0) >> 2] = $5;
    memcpy($5 | 0, $3 | 0, $1 | 0) | 0;
    HEAP32[($0 + 12 | 0) >> 2] = $1;
    HEAP32[($0 + 8 | 0) >> 2] = $4;
    HEAP32[$0 >> 2] = 0;
    break label$1;
   }
   HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($2 + 20 | 0) >> 2] | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $2 + 32 | 0;
 }
 
 function $rand_os__OsRng_20as_20rand_core__RngCore___try_fill_bytes__hc4399e14db3c3fde($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $6 = 0, i64toi32_i32$2 = 0, $5 = 0, $7 = 0, $15 = 0, $8 = 0, $9 = 0, $8$hi = 0, $9$hi = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    if ($3) {
     break label$2
    }
    HEAP8[($0 + 16 | 0) >> 0] = 5;
    break label$1;
   }
   $5 = (HEAP32[$1 >> 2] | 0 | 0) == (1 | 0) ? 65536 : -1;
   label$3 : {
    label$4 : while (1) {
     $6 = $3 >>> 0 > $5 >>> 0 ? $5 : $3;
     $rand_os__wasm32_bindgen__OsRng_20as_20rand_os__OsRngImpl___fill_chunk__h6e9ee6e95d64d1a6($4 + 24 | 0 | 0, $1 | 0, $2 | 0, $6 | 0);
     $7 = HEAPU8[($4 + 40 | 0) >> 0] | 0;
     if (($7 | 0) != (5 | 0)) {
      break label$3
     }
     $2 = $2 + $6 | 0;
     $3 = $3 - $6 | 0;
     if ($3) {
      continue label$4
     }
     break label$4;
    };
    HEAP8[($0 + 16 | 0) >> 0] = 5;
    break label$1;
   }
   $15 = HEAPU8[($4 + 41 | 0) >> 0] | 0 | ((HEAPU8[($4 + 42 | 0) >> 0] | 0) << 8 | 0) | 0;
   HEAP8[($0 + 17 | 0) >> 0] = $15;
   HEAP8[($0 + 18 | 0) >> 0] = $15 >>> 8 | 0;
   i64toi32_i32$2 = ($4 + 24 | 0) + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $8 = i64toi32_i32$0;
   $8$hi = i64toi32_i32$1;
   i64toi32_i32$0 = ($4 + 8 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $8;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP8[($0 + 19 | 0) >> 0] = HEAPU8[(($4 + 24 | 0) + 19 | 0) >> 0] | 0;
   i64toi32_i32$2 = $4;
   i64toi32_i32$1 = HEAP32[($4 + 24 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($4 + 28 | 0) >> 2] | 0;
   $9 = i64toi32_i32$1;
   $9$hi = i64toi32_i32$0;
   i64toi32_i32$1 = $4;
   HEAP32[($4 + 8 | 0) >> 2] = $9;
   HEAP32[($4 + 12 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $8$hi;
   i64toi32_i32$1 = $0 + 8 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $8;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $9$hi;
   i64toi32_i32$1 = $0;
   HEAP32[i64toi32_i32$1 >> 2] = $9;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 16 | 0) >> 0] = $7;
  }
  global$0 = $4 + 48 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_fit__hd4852592681d8c60($0, $1, $2, $2$hi, $3, $3$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, $6 = 0, $7 = 0, $8 = 0, $5 = 0, $9 = 0, $10 = 0, $30 = 0, $59 = 0;
  $4 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $0 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  $5 = Math_imul($0, 12);
  $6 = ($4 + $5 | 0) + 180 | 0;
  label$1 : {
   label$2 : {
    $7 = $0 + 1 | 0;
    $8 = HEAPU16[($4 + 314 | 0) >> 1] | 0;
    if ($7 >>> 0 <= $8 >>> 0) {
     break label$2
    }
    i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $30 = i64toi32_i32$0;
    i64toi32_i32$0 = $6;
    HEAP32[i64toi32_i32$0 >> 2] = $30;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
    break label$1;
   }
   $9 = $4 + 180 | 0;
   $10 = $8 - $0 | 0;
   memmove($9 + Math_imul($7, 12) | 0 | 0, $6 | 0, Math_imul($10, 12) | 0) | 0;
   $6 = $9 + $5 | 0;
   HEAP32[($6 + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   $59 = i64toi32_i32$1;
   i64toi32_i32$1 = $6;
   HEAP32[i64toi32_i32$1 >> 2] = $59;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   memmove($4 + ($7 << 4 | 0) | 0 | 0, $4 + ($0 << 4 | 0) | 0 | 0, $10 << 4 | 0 | 0) | 0;
  }
  $0 = $4 + ($0 << 4 | 0) | 0;
  i64toi32_i32$0 = $3$hi;
  i64toi32_i32$1 = $0;
  HEAP32[($0 + 8 | 0) >> 2] = $3;
  HEAP32[($0 + 12 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $2$hi;
  i64toi32_i32$1 = $0;
  HEAP32[$0 >> 2] = $2;
  HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP16[($4 + 314 | 0) >> 1] = $8 + 1 | 0;
  return $0 | 0;
 }
 
 function transactioninput_transaction_id($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $2 = 0, $3 = 0, $4 = 0, $20 = 0, $27 = 0, $34 = 0, $37 = 0, $49 = 0, $54 = 0, $59 = 0, $62 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hd7bc050864a8d646($1 + 8 | 0 | 0, $0 | 0);
  $2 = ($1 + 16 | 0) + 8 | 0;
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $0 + 12 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $20;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $3 = ($1 + 16 | 0) + 16 | 0;
  i64toi32_i32$2 = $0 + 20 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $27 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[i64toi32_i32$1 >> 2] = $27;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = ($1 + 16 | 0) + 24 | 0;
  i64toi32_i32$2 = $0 + 28 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $34 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[i64toi32_i32$0 >> 2] = $34;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 9 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 10 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 11 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $37 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $37;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  $0 = HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $49 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 48 | 0) + 24 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $49;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $54 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 48 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $54;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $59 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 48 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $59;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $62 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = $62;
  HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = i64toi32_i32$0;
  $0 = $cardano_serialization_lib__crypto__TransactionHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__ha325bfafa26d5417(i64toi32_i32$2 + 48 | 0 | 0) | 0;
  global$0 = i64toi32_i32$2 + 80 | 0;
  return $0 | 0;
 }
 
 function stakedelegation_pool_keyhash($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $14 = 0, $2 = 0, $3 = 0, $4 = 0, $20 = 0, $27 = 0, $37 = 0, $54 = 0, $59 = 0, $62 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hfc784c950a3a2da2($1 + 8 | 0 | 0, $0 | 0);
  $2 = ($1 + 16 | 0) + 8 | 0;
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $0 + 37 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $20;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $3 = ($1 + 16 | 0) + 16 | 0;
  i64toi32_i32$2 = $0 + 45 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $27 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[i64toi32_i32$1 >> 2] = $27;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = ($1 + 16 | 0) + 24 | 0;
  $14 = $0 + 53 | 0;
  HEAP32[$4 >> 2] = HEAPU8[$14 >> 0] | 0 | ((HEAPU8[($14 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($14 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($14 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 29 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 30 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 31 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 32 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 33 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 34 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 35 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 36 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $37 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 16 | 0) >> 2] = $37;
  HEAP32[($1 + 20 | 0) >> 2] = i64toi32_i32$1;
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($1 + 48 | 0) + 24 | 0) >> 2] = HEAP32[$4 >> 2] | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $54 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 48 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $54;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $59 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 48 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $59;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $62 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = $62;
  HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = i64toi32_i32$0;
  $0 = $cardano_serialization_lib__crypto__Ed25519KeyHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hd63cf82b6a769066(i64toi32_i32$2 + 48 | 0 | 0) | 0;
  global$0 = i64toi32_i32$2 + 80 | 0;
  return $0 | 0;
 }
 
 function poolparams_operator($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $14 = 0, $2 = 0, $3 = 0, $4 = 0, $20 = 0, $27 = 0, $37 = 0, $54 = 0, $59 = 0, $62 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hc466bac66f8af18e($1 + 8 | 0 | 0, $0 | 0);
  $2 = ($1 + 16 | 0) + 8 | 0;
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $0 + 108 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $20;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $3 = ($1 + 16 | 0) + 16 | 0;
  i64toi32_i32$2 = $0 + 116 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $27 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[i64toi32_i32$1 >> 2] = $27;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = ($1 + 16 | 0) + 24 | 0;
  $14 = $0 + 124 | 0;
  HEAP32[$4 >> 2] = HEAPU8[$14 >> 0] | 0 | ((HEAPU8[($14 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($14 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($14 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 100 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 101 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 102 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 103 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 104 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 105 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 106 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 107 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $37 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 16 | 0) >> 2] = $37;
  HEAP32[($1 + 20 | 0) >> 2] = i64toi32_i32$1;
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($1 + 48 | 0) + 24 | 0) >> 2] = HEAP32[$4 >> 2] | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $54 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 48 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $54;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $59 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 48 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $59;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $62 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = $62;
  HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = i64toi32_i32$0;
  $0 = $cardano_serialization_lib__crypto__Ed25519KeyHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hd63cf82b6a769066(i64toi32_i32$2 + 48 | 0 | 0) | 0;
  global$0 = i64toi32_i32$2 + 80 | 0;
  return $0 | 0;
 }
 
 function poolparams_vrf_keyhash($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $2 = 0, $3 = 0, $4 = 0, $20 = 0, $27 = 0, $34 = 0, $37 = 0, $49 = 0, $54 = 0, $59 = 0, $62 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hc466bac66f8af18e($1 + 8 | 0 | 0, $0 | 0);
  $2 = ($1 + 16 | 0) + 8 | 0;
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $0 + 136 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $20;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $3 = ($1 + 16 | 0) + 16 | 0;
  i64toi32_i32$2 = $0 + 144 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $27 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[i64toi32_i32$1 >> 2] = $27;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = ($1 + 16 | 0) + 24 | 0;
  i64toi32_i32$2 = $0 + 152 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $34 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[i64toi32_i32$0 >> 2] = $34;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 128 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 129 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 130 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 131 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 132 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 133 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 134 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 135 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $37 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $37;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  $0 = HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $49 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 48 | 0) + 24 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $49;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $54 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 48 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $54;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $59 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 48 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $59;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $62 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = $62;
  HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = i64toi32_i32$0;
  $0 = $cardano_serialization_lib__crypto__VRFKeyHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf9aae481fe8479f(i64toi32_i32$2 + 48 | 0 | 0) | 0;
  global$0 = i64toi32_i32$2 + 80 | 0;
  return $0 | 0;
 }
 
 function poolretirement_pool_keyhash($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $14 = 0, $2 = 0, $3 = 0, $4 = 0, $20 = 0, $27 = 0, $37 = 0, $54 = 0, $59 = 0, $62 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h77d6f4a2273f50b5($1 + 8 | 0 | 0, $0 | 0);
  $2 = ($1 + 16 | 0) + 8 | 0;
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $0 + 12 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $20;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $3 = ($1 + 16 | 0) + 16 | 0;
  i64toi32_i32$2 = $0 + 20 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $27 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[i64toi32_i32$1 >> 2] = $27;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = ($1 + 16 | 0) + 24 | 0;
  $14 = $0 + 28 | 0;
  HEAP32[$4 >> 2] = HEAPU8[$14 >> 0] | 0 | ((HEAPU8[($14 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($14 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($14 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 9 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 10 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 11 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $37 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 16 | 0) >> 2] = $37;
  HEAP32[($1 + 20 | 0) >> 2] = i64toi32_i32$1;
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($1 + 48 | 0) + 24 | 0) >> 2] = HEAP32[$4 >> 2] | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $54 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 48 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $54;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $59 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 48 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $59;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $62 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = $62;
  HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = i64toi32_i32$0;
  $0 = $cardano_serialization_lib__crypto__Ed25519KeyHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hd63cf82b6a769066(i64toi32_i32$2 + 48 | 0 | 0) | 0;
  global$0 = i64toi32_i32$2 + 80 | 0;
  return $0 | 0;
 }
 
 function genesiskeydelegation_genesishash($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $14 = 0, $2 = 0, $3 = 0, $4 = 0, $20 = 0, $27 = 0, $37 = 0, $54 = 0, $59 = 0, $62 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h96a5bfd90503076d($1 + 8 | 0 | 0, $0 | 0);
  $2 = ($1 + 16 | 0) + 8 | 0;
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $0 + 8 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $20;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $3 = ($1 + 16 | 0) + 16 | 0;
  i64toi32_i32$2 = $0 + 16 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $27 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[i64toi32_i32$1 >> 2] = $27;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = ($1 + 16 | 0) + 24 | 0;
  $14 = $0 + 24 | 0;
  HEAP32[$4 >> 2] = HEAPU8[$14 >> 0] | 0 | ((HEAPU8[($14 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($14 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($14 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $37 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 16 | 0) >> 2] = $37;
  HEAP32[($1 + 20 | 0) >> 2] = i64toi32_i32$1;
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($1 + 48 | 0) + 24 | 0) >> 2] = HEAP32[$4 >> 2] | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $54 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 48 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $54;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $59 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 48 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $59;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $62 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = $62;
  HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = i64toi32_i32$0;
  $0 = $cardano_serialization_lib__crypto__GenesisHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hedc49afed5ec6de0(i64toi32_i32$2 + 48 | 0 | 0) | 0;
  global$0 = i64toi32_i32$2 + 80 | 0;
  return $0 | 0;
 }
 
 function genesiskeydelegation_genesis_delegate_hash($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $14 = 0, $2 = 0, $3 = 0, $4 = 0, $20 = 0, $27 = 0, $37 = 0, $54 = 0, $59 = 0, $62 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h96a5bfd90503076d($1 + 8 | 0 | 0, $0 | 0);
  $2 = ($1 + 16 | 0) + 8 | 0;
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $0 + 36 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $20;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $3 = ($1 + 16 | 0) + 16 | 0;
  i64toi32_i32$2 = $0 + 44 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $27 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[i64toi32_i32$1 >> 2] = $27;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = ($1 + 16 | 0) + 24 | 0;
  $14 = $0 + 52 | 0;
  HEAP32[$4 >> 2] = HEAPU8[$14 >> 0] | 0 | ((HEAPU8[($14 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($14 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($14 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 28 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 29 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 30 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 31 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 32 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 33 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 34 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 35 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $37 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 16 | 0) >> 2] = $37;
  HEAP32[($1 + 20 | 0) >> 2] = i64toi32_i32$1;
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($1 + 48 | 0) + 24 | 0) >> 2] = HEAP32[$4 >> 2] | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $54 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 48 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $54;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $59 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 48 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $59;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $62 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = $62;
  HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = i64toi32_i32$0;
  $0 = $cardano_serialization_lib__crypto__GenesisDelegateHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h829122a765b38e99(i64toi32_i32$2 + 48 | 0 | 0) | 0;
  global$0 = i64toi32_i32$2 + 80 | 0;
  return $0 | 0;
 }
 
 function genesiskeydelegation_vrf_keyhash($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $2 = 0, $3 = 0, $4 = 0, $20 = 0, $27 = 0, $34 = 0, $37 = 0, $49 = 0, $54 = 0, $59 = 0, $62 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h96a5bfd90503076d($1 + 8 | 0 | 0, $0 | 0);
  $2 = ($1 + 16 | 0) + 8 | 0;
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $0 + 64 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $20;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $3 = ($1 + 16 | 0) + 16 | 0;
  i64toi32_i32$2 = $0 + 72 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $27 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[i64toi32_i32$1 >> 2] = $27;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = ($1 + 16 | 0) + 24 | 0;
  i64toi32_i32$2 = $0 + 80 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $34 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[i64toi32_i32$0 >> 2] = $34;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 56 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 57 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 58 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 59 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 60 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 61 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 62 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 63 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $37 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $37;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  $0 = HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $49 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 48 | 0) + 24 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $49;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $54 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 48 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $54;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $59 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 48 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $59;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $62 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = $62;
  HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = i64toi32_i32$0;
  $0 = $cardano_serialization_lib__crypto__VRFKeyHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf9aae481fe8479f(i64toi32_i32$2 + 48 | 0 | 0) | 0;
  global$0 = i64toi32_i32$2 + 80 | 0;
  return $0 | 0;
 }
 
 function relay_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $31 = 0, $46 = 0, $51 = 0, $58 = 0;
  $2 = global$0 - 96 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 48 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 64 | 0) >> 2] = $31;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__Relay__from_bytes__h5151689bf24e15be($2 + 16 | 0 | 0, $2 + 64 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = $2 + 32 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 76 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $46;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2 + 40 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $51 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 84 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $51;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($2 + 64 | 0) >> 2] = $1;
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $58 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 68 | 0) >> 2] = $58;
  HEAP32[($2 + 72 | 0) >> 2] = i64toi32_i32$0;
  $1 = $cardano_serialization_lib__Relay_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__ha0d8781612d84a1b($2 + 64 | 0 | 0) | 0;
  global$0 = $2 + 96 | 0;
  return $1 | 0;
 }
 
 function poolmetadata_pool_metadata_hash($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $2 = 0, $3 = 0, $4 = 0, $20 = 0, $27 = 0, $34 = 0, $37 = 0, $49 = 0, $54 = 0, $59 = 0, $62 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h451504312a4b72d0($1 + 8 | 0 | 0, $0 | 0);
  $2 = ($1 + 16 | 0) + 8 | 0;
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $0 + 20 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $20;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $3 = ($1 + 16 | 0) + 16 | 0;
  i64toi32_i32$2 = $0 + 28 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $27 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[i64toi32_i32$1 >> 2] = $27;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = ($1 + 16 | 0) + 24 | 0;
  i64toi32_i32$2 = $0 + 36 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $34 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[i64toi32_i32$0 >> 2] = $34;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 12 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 13 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 14 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 15 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 16 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 17 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 18 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 19 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $37 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $37;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  $0 = HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $49 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 48 | 0) + 24 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $49;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $54 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 48 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $54;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $59 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 48 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $59;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $62 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = $62;
  HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = i64toi32_i32$0;
  $0 = $cardano_serialization_lib__crypto__PoolMetadataHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__heaaf3507fd71ee00(i64toi32_i32$2 + 48 | 0 | 0) | 0;
  global$0 = i64toi32_i32$2 + 80 | 0;
  return $0 | 0;
 }
 
 function poolmetadata_new($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, $4 = 0, $32 = 0, $37 = 0, $42 = 0, $45 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hd2a6d676353c0b6c($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h6bd3a1ad9f257a81($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $0 = HEAP32[$2 >> 2] | 0;
   $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($2 + 16 | 0 | 0, $4 | 0);
   i64toi32_i32$2 = $0 + 24 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $32 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 52 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $32;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $0 + 16 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $37 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 44 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $37;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $0 + 8 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $42 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 36 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $42;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $45 = i64toi32_i32$1;
   i64toi32_i32$1 = $2;
   HEAP32[($2 + 28 | 0) >> 2] = $45;
   HEAP32[($2 + 32 | 0) >> 2] = i64toi32_i32$0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
   memcpy($2 + 64 | 0 | 0, $2 + 16 | 0 | 0, 44 | 0) | 0;
   $0 = $cardano_serialization_lib__PoolMetadata_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h92fec53606437ead($2 + 64 | 0 | 0) | 0;
   global$0 = $2 + 112 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function scriptpubkey_addr_keyhash($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $14 = 0, $2 = 0, $3 = 0, $4 = 0, $20 = 0, $27 = 0, $37 = 0, $54 = 0, $59 = 0, $62 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h5bcc7e1da6f9ff93($1 + 8 | 0 | 0, $0 | 0);
  $2 = ($1 + 16 | 0) + 8 | 0;
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $0 + 8 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $20;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $3 = ($1 + 16 | 0) + 16 | 0;
  i64toi32_i32$2 = $0 + 16 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $27 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[i64toi32_i32$1 >> 2] = $27;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = ($1 + 16 | 0) + 24 | 0;
  $14 = $0 + 24 | 0;
  HEAP32[$4 >> 2] = HEAPU8[$14 >> 0] | 0 | ((HEAPU8[($14 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($14 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($14 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $37 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 16 | 0) >> 2] = $37;
  HEAP32[($1 + 20 | 0) >> 2] = i64toi32_i32$1;
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($1 + 48 | 0) + 24 | 0) >> 2] = HEAP32[$4 >> 2] | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $54 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 48 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $54;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $59 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 48 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $59;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $62 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = $62;
  HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = i64toi32_i32$0;
  $0 = $cardano_serialization_lib__crypto__Ed25519KeyHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hd63cf82b6a769066(i64toi32_i32$2 + 48 | 0 | 0) | 0;
  global$0 = i64toi32_i32$2 + 80 | 0;
  return $0 | 0;
 }
 
 function scriptpubkey_new($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $14 = 0, $2 = 0, $3 = 0, $4 = 0, $20 = 0, $27 = 0, $37 = 0, $54 = 0, $59 = 0, $62 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hae9c55c4e91ce40f($1 + 8 | 0 | 0, $0 | 0);
  $2 = ($1 + 16 | 0) + 8 | 0;
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $0 + 8 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $20;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $3 = ($1 + 16 | 0) + 16 | 0;
  i64toi32_i32$2 = $0 + 16 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $27 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[i64toi32_i32$1 >> 2] = $27;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = ($1 + 16 | 0) + 24 | 0;
  $14 = $0 + 24 | 0;
  HEAP32[$4 >> 2] = HEAPU8[$14 >> 0] | 0 | ((HEAPU8[($14 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($14 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($14 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $37 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 16 | 0) >> 2] = $37;
  HEAP32[($1 + 20 | 0) >> 2] = i64toi32_i32$1;
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($1 + 48 | 0) + 24 | 0) >> 2] = HEAP32[$4 >> 2] | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $54 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 48 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $54;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $59 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 48 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $59;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $62 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = $62;
  HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = i64toi32_i32$0;
  $0 = $cardano_serialization_lib__ScriptPubkey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he4b2ddfdd7790cb9(i64toi32_i32$2 + 48 | 0 | 0) | 0;
  global$0 = i64toi32_i32$2 + 80 | 0;
  return $0 | 0;
 }
 
 function operationalcert_hot_vkey($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $2 = 0, $3 = 0, $4 = 0, $20 = 0, $27 = 0, $34 = 0, $37 = 0, $49 = 0, $54 = 0, $59 = 0, $62 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h4b15d475a6cbc138($1 + 8 | 0 | 0, $0 | 0);
  $2 = ($1 + 16 | 0) + 8 | 0;
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $0 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $20;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $3 = ($1 + 16 | 0) + 16 | 0;
  i64toi32_i32$2 = $0 + 24 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $27 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[i64toi32_i32$1 >> 2] = $27;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = ($1 + 16 | 0) + 24 | 0;
  i64toi32_i32$2 = $0 + 32 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $34 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[i64toi32_i32$0 >> 2] = $34;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 9 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 10 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 11 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 12 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 13 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 14 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 15 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $37 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $37;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  $0 = HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $49 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 48 | 0) + 24 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $49;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $54 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 48 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $54;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $59 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 48 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $59;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $62 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = $62;
  HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = i64toi32_i32$0;
  $0 = $cardano_serialization_lib__crypto__KESVKey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h5c8fb7ce130dd69e(i64toi32_i32$2 + 48 | 0 | 0) | 0;
  global$0 = i64toi32_i32$2 + 80 | 0;
  return $0 | 0;
 }
 
 function headerbody_issuer_vkey($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $2 = 0, $3 = 0, $4 = 0, $20 = 0, $27 = 0, $34 = 0, $37 = 0, $49 = 0, $54 = 0, $59 = 0, $62 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h2ac16fcb64db16b5($1 + 8 | 0 | 0, $0 | 0);
  $2 = ($1 + 16 | 0) + 8 | 0;
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $0 + 217 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $20;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $3 = ($1 + 16 | 0) + 16 | 0;
  i64toi32_i32$2 = $0 + 225 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $27 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[i64toi32_i32$1 >> 2] = $27;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = ($1 + 16 | 0) + 24 | 0;
  i64toi32_i32$2 = $0 + 233 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $34 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[i64toi32_i32$0 >> 2] = $34;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 209 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 210 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 211 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 212 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 213 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 214 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 215 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 216 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $37 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $37;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  $0 = HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $49 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 48 | 0) + 24 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $49;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $54 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 48 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $54;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $59 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 48 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $59;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $62 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = $62;
  HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = i64toi32_i32$0;
  $0 = $cardano_serialization_lib__crypto__Vkey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h0c56da261e90089c(i64toi32_i32$2 + 48 | 0 | 0) | 0;
  global$0 = i64toi32_i32$2 + 80 | 0;
  return $0 | 0;
 }
 
 function headerbody_vrf_vkey($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $2 = 0, $3 = 0, $4 = 0, $20 = 0, $27 = 0, $34 = 0, $37 = 0, $49 = 0, $54 = 0, $59 = 0, $62 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h2ac16fcb64db16b5($1 + 8 | 0 | 0, $0 | 0);
  $2 = ($1 + 16 | 0) + 8 | 0;
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $0 + 249 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $20;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $3 = ($1 + 16 | 0) + 16 | 0;
  i64toi32_i32$2 = $0 + 257 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $27 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[i64toi32_i32$1 >> 2] = $27;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = ($1 + 16 | 0) + 24 | 0;
  i64toi32_i32$2 = $0 + 265 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $34 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[i64toi32_i32$0 >> 2] = $34;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 241 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 242 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 243 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 244 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 245 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 246 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 247 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 248 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $37 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $37;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  $0 = HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $49 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 48 | 0) + 24 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $49;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $54 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 48 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $54;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $59 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 48 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $59;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $62 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = $62;
  HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = i64toi32_i32$0;
  $0 = $cardano_serialization_lib__crypto__VRFVKey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h510224eaef243251(i64toi32_i32$2 + 48 | 0 | 0) | 0;
  global$0 = i64toi32_i32$2 + 80 | 0;
  return $0 | 0;
 }
 
 function headerbody_block_body_hash($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $2 = 0, $3 = 0, $4 = 0, $20 = 0, $27 = 0, $34 = 0, $37 = 0, $49 = 0, $54 = 0, $59 = 0, $62 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h2ac16fcb64db16b5($1 + 8 | 0 | 0, $0 | 0);
  $2 = ($1 + 16 | 0) + 8 | 0;
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $0 + 281 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $20;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $3 = ($1 + 16 | 0) + 16 | 0;
  i64toi32_i32$2 = $0 + 289 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $27 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[i64toi32_i32$1 >> 2] = $27;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = ($1 + 16 | 0) + 24 | 0;
  i64toi32_i32$2 = $0 + 297 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $34 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[i64toi32_i32$0 >> 2] = $34;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 273 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 274 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 275 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 276 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 277 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 278 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 279 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 280 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $37 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $37;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  $0 = HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $49 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 48 | 0) + 24 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $49;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $54 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 48 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $54;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $59 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 48 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $59;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $62 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = $62;
  HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = i64toi32_i32$0;
  $0 = $cardano_serialization_lib__crypto__BlockHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hf8ef4eaf9a4a30cf(i64toi32_i32$2 + 48 | 0 | 0) | 0;
  global$0 = i64toi32_i32$2 + 80 | 0;
  return $0 | 0;
 }
 
 function assets_keys($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $29 = 0, $37 = 0, $40 = 0, $57 = 0;
  $1 = global$0 - 96 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h91e3d4f7af3d2ccd($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  alloc__collections__btree__map__BTreeMap_K_2cV___iter__ha89c9458aca0228d($1 + 32 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
  HEAP32[(($1 + 64 | 0) + 24 | 0) >> 2] = HEAP32[(($1 + 32 | 0) + 24 | 0) >> 2] | 0;
  i64toi32_i32$2 = ($1 + 32 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $29 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 64 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $29;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $2 = ($1 + 64 | 0) + 8 | 0;
  i64toi32_i32$2 = ($1 + 32 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $37 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[i64toi32_i32$1 >> 2] = $37;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[($1 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 36 | 0) >> 2] | 0;
  $40 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 64 | 0) >> 2] = $40;
  HEAP32[($1 + 68 | 0) >> 2] = i64toi32_i32$1;
  $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__h24704ec9214d4ac9($1 + 16 | 0 | 0, $1 + 64 | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[$2 >> 2] = HEAP32[(($1 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[($1 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  $57 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[($1 + 64 | 0) >> 2] = $57;
  HEAP32[($1 + 68 | 0) >> 2] = i64toi32_i32$0;
  $0 = $cardano_serialization_lib__AssetNames_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h88f81c8607449c6b($1 + 64 | 0 | 0) | 0;
  global$0 = $1 + 96 | 0;
  return $0 | 0;
 }
 
 function multiasset_keys($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $29 = 0, $37 = 0, $40 = 0, $57 = 0;
  $1 = global$0 - 96 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h9968e42c55861cec($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  alloc__collections__btree__map__BTreeMap_K_2cV___iter__h677e802ff7e211c3($1 + 32 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
  HEAP32[(($1 + 64 | 0) + 24 | 0) >> 2] = HEAP32[(($1 + 32 | 0) + 24 | 0) >> 2] | 0;
  i64toi32_i32$2 = ($1 + 32 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $29 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 64 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $29;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $2 = ($1 + 64 | 0) + 8 | 0;
  i64toi32_i32$2 = ($1 + 32 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $37 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[i64toi32_i32$1 >> 2] = $37;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[($1 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 36 | 0) >> 2] | 0;
  $40 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 64 | 0) >> 2] = $40;
  HEAP32[($1 + 68 | 0) >> 2] = i64toi32_i32$1;
  $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__h35bbe9f0640c90cc($1 + 16 | 0 | 0, $1 + 64 | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[$2 >> 2] = HEAP32[(($1 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[($1 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  $57 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[($1 + 64 | 0) >> 2] = $57;
  HEAP32[($1 + 68 | 0) >> 2] = i64toi32_i32$0;
  $0 = $cardano_serialization_lib__ScriptHashes_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__ha80e71a64db891b6($1 + 64 | 0 | 0) | 0;
  global$0 = $1 + 96 | 0;
  return $0 | 0;
 }
 
 function mintassets_keys($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $29 = 0, $37 = 0, $40 = 0, $57 = 0;
  $1 = global$0 - 96 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h59b9713b6e595a95($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  alloc__collections__btree__map__BTreeMap_K_2cV___iter__h3ab6a151beb58e6b($1 + 32 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
  HEAP32[(($1 + 64 | 0) + 24 | 0) >> 2] = HEAP32[(($1 + 32 | 0) + 24 | 0) >> 2] | 0;
  i64toi32_i32$2 = ($1 + 32 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $29 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 64 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $29;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $2 = ($1 + 64 | 0) + 8 | 0;
  i64toi32_i32$2 = ($1 + 32 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $37 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[i64toi32_i32$1 >> 2] = $37;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[($1 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 36 | 0) >> 2] | 0;
  $40 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 64 | 0) >> 2] = $40;
  HEAP32[($1 + 68 | 0) >> 2] = i64toi32_i32$1;
  $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__hc5b4bd660ee12429($1 + 16 | 0 | 0, $1 + 64 | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[$2 >> 2] = HEAP32[(($1 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[($1 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  $57 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[($1 + 64 | 0) >> 2] = $57;
  HEAP32[($1 + 68 | 0) >> 2] = i64toi32_i32$0;
  $0 = $cardano_serialization_lib__AssetNames_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h88f81c8607449c6b($1 + 64 | 0 | 0) | 0;
  global$0 = $1 + 96 | 0;
  return $0 | 0;
 }
 
 function mint_keys($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $29 = 0, $37 = 0, $40 = 0, $57 = 0;
  $1 = global$0 - 96 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h8348e40d8f63e5f1($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  alloc__collections__btree__map__BTreeMap_K_2cV___iter__hbe8f4ddb910904b5($1 + 32 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
  HEAP32[(($1 + 64 | 0) + 24 | 0) >> 2] = HEAP32[(($1 + 32 | 0) + 24 | 0) >> 2] | 0;
  i64toi32_i32$2 = ($1 + 32 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $29 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 64 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $29;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $2 = ($1 + 64 | 0) + 8 | 0;
  i64toi32_i32$2 = ($1 + 32 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $37 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[i64toi32_i32$1 >> 2] = $37;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[($1 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 36 | 0) >> 2] | 0;
  $40 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 64 | 0) >> 2] = $40;
  HEAP32[($1 + 68 | 0) >> 2] = i64toi32_i32$1;
  $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__h3acc6a814a137cd3($1 + 16 | 0 | 0, $1 + 64 | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[$2 >> 2] = HEAP32[(($1 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[($1 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  $57 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[($1 + 64 | 0) >> 2] = $57;
  HEAP32[($1 + 68 | 0) >> 2] = i64toi32_i32$0;
  $0 = $cardano_serialization_lib__ScriptHashes_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__ha80e71a64db891b6($1 + 64 | 0 | 0) | 0;
  global$0 = $1 + 96 | 0;
  return $0 | 0;
 }
 
 function cardano_serialization_lib__utils___impl_20core__convert__TryFrom_cardano_serialization_lib__utils__BigNum__20for_20u32___try_from__h480b087dada7bb26($0, $1, $1$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $1$hi = $1$hi | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $3 = 0, $4 = 0, $10$hi = 0, $31 = 0;
  $2 = global$0 - 96 | 0;
  global$0 = $2;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $1;
  HEAP32[($2 + 36 | 0) >> 2] = $1$hi;
  label$1 : {
   label$2 : {
    i64toi32_i32$0 = $T_20as_20core__convert__Into_U____into__h09f19f33dddda692(-1 | 0) | 0;
    i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
    $10$hi = i64toi32_i32$1;
    i64toi32_i32$1 = $1$hi;
    i64toi32_i32$1 = $10$hi;
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$0 = $1$hi;
    if (i64toi32_i32$1 >>> 0 < $1$hi >>> 0 | ((i64toi32_i32$1 | 0) == ($1$hi | 0) & i64toi32_i32$2 >>> 0 < $1 >>> 0 | 0) | 0) {
     break label$2
    }
    i64toi32_i32$2 = $1$hi;
    $3 = $1;
    $4 = 0;
    break label$1;
   }
   core__fmt__ArgumentV1__new__h021aa801e74cb4b6($2 + 24 | 0 | 0, $2 + 32 | 0 | 0, 20 | 0);
   i64toi32_i32$2 = HEAP32[($2 + 24 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 28 | 0) >> 2] | 0;
   $1 = i64toi32_i32$2;
   $1$hi = i64toi32_i32$1;
   core__fmt__ArgumentV1__new__hfe8bfc123be7fc32($2 + 16 | 0 | 0, 1057768 | 0, 46 | 0);
   HEAP32[($2 + 76 | 0) >> 2] = 2;
   i64toi32_i32$2 = $2;
   HEAP32[($2 + 80 | 0) >> 2] = $1;
   HEAP32[($2 + 84 | 0) >> 2] = $1$hi;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = 0;
   HEAP32[($2 + 60 | 0) >> 2] = 2;
   HEAP32[($2 + 64 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($2 + 56 | 0) >> 2] = 1057752;
   i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   $31 = i64toi32_i32$1;
   i64toi32_i32$1 = $2;
   HEAP32[($2 + 88 | 0) >> 2] = $31;
   HEAP32[($2 + 92 | 0) >> 2] = i64toi32_i32$2;
   HEAP32[($2 + 72 | 0) >> 2] = $2 + 80 | 0;
   alloc__fmt__format__h6e9e003a52c07309($2 + 40 | 0 | 0, $2 + 56 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $2 + 40 | 0 | 0);
   $3 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0) | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 40 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 40 | 0 | 0);
   $4 = 1;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $3;
  HEAP32[$0 >> 2] = $4;
  global$0 = $2 + 96 | 0;
 }
 
 function cardano_serialization_lib__utils__Int__from_bytes__h393d1058ebb4f592($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $2 = 0, i64toi32_i32$1 = 0, $3 = 0, $4 = 0, $4$hi = 0, $5 = 0, $5$hi = 0, $18 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 144 | 0;
  global$0 = $2;
  HEAP32[(($2 + 120 | 0) + 16 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 120 | 0) >> 2] = 0;
  HEAP32[($2 + 124 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[(i64toi32_i32$0 + 128 | 0) >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 132 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__utils__Int_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h5b6b41ff800f0b26(i64toi32_i32$0 + 48 | 0 | 0, i64toi32_i32$0 + 120 | 0 | 0);
  $1 = (i64toi32_i32$0 + 120 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $3 = (i64toi32_i32$0 + 48 | 0) + 16 | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $4 = i64toi32_i32$1;
  $4$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    if ((i64toi32_i32$2 | 0) == (1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
     break label$2
    }
    i64toi32_i32$2 = $4$hi;
    i64toi32_i32$0 = $0 + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $4;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $5$hi;
    i64toi32_i32$0 = $0 + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $5;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    $1 = 0;
    break label$1;
   }
   $1 = memcpy($2 | 0, $2 + 72 | 0 | 0, 48 | 0) | 0;
   i64toi32_i32$2 = $4$hi;
   i64toi32_i32$0 = $1;
   HEAP32[(i64toi32_i32$0 + 56 | 0) >> 2] = $4;
   HEAP32[(i64toi32_i32$0 + 60 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$2 = $5$hi;
   HEAP32[(i64toi32_i32$0 + 48 | 0) >> 2] = $5;
   HEAP32[(i64toi32_i32$0 + 52 | 0) >> 2] = i64toi32_i32$2;
   memcpy($3 | 0, i64toi32_i32$0 | 0, 48 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd(i64toi32_i32$0 + 48 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 144 | 0;
 }
 
 function vkey_new($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $2 = 0, $3 = 0, $4 = 0, $20 = 0, $27 = 0, $34 = 0, $37 = 0, $49 = 0, $54 = 0, $59 = 0, $62 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h67eb974eba5bb4b0($1 + 8 | 0 | 0, $0 | 0);
  $2 = ($1 + 16 | 0) + 8 | 0;
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $0 + 8 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $20;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $3 = ($1 + 16 | 0) + 16 | 0;
  i64toi32_i32$2 = $0 + 16 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $27 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[i64toi32_i32$1 >> 2] = $27;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = ($1 + 16 | 0) + 24 | 0;
  i64toi32_i32$2 = $0 + 24 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $34 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[i64toi32_i32$0 >> 2] = $34;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $37 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $37;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  $0 = HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $49 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 48 | 0) + 24 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $49;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $54 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 48 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $54;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $59 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 48 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $59;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $62 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = $62;
  HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = i64toi32_i32$0;
  $0 = $cardano_serialization_lib__crypto__Vkey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h0c56da261e90089c(i64toi32_i32$2 + 48 | 0 | 0) | 0;
  global$0 = i64toi32_i32$2 + 80 | 0;
  return $0 | 0;
 }
 
 function vkey_public_key($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $2 = 0, $3 = 0, $4 = 0, $20 = 0, $27 = 0, $34 = 0, $37 = 0, $49 = 0, $54 = 0, $59 = 0, $62 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h38603c546ca761f2($1 + 8 | 0 | 0, $0 | 0);
  $2 = ($1 + 16 | 0) + 8 | 0;
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $0 + 8 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $20;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $3 = ($1 + 16 | 0) + 16 | 0;
  i64toi32_i32$2 = $0 + 16 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $27 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[i64toi32_i32$1 >> 2] = $27;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = ($1 + 16 | 0) + 24 | 0;
  i64toi32_i32$2 = $0 + 24 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $34 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[i64toi32_i32$0 >> 2] = $34;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $37 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $37;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  $0 = HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $49 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 48 | 0) + 24 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $49;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $54 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 48 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $54;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $59 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 48 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $59;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $62 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = $62;
  HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = i64toi32_i32$0;
  $0 = $cardano_serialization_lib__crypto__PublicKey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h435bbe8dcccd675c(i64toi32_i32$2 + 48 | 0 | 0) | 0;
  global$0 = i64toi32_i32$2 + 80 | 0;
  return $0 | 0;
 }
 
 function vkeywitness_vkey($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $2 = 0, $3 = 0, $4 = 0, $20 = 0, $27 = 0, $34 = 0, $37 = 0, $49 = 0, $54 = 0, $59 = 0, $62 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h9c2d3a72ebf4d25f($1 + 8 | 0 | 0, $0 | 0);
  $2 = ($1 + 16 | 0) + 8 | 0;
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $0 + 8 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $20;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $3 = ($1 + 16 | 0) + 16 | 0;
  i64toi32_i32$2 = $0 + 16 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $27 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[i64toi32_i32$1 >> 2] = $27;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = ($1 + 16 | 0) + 24 | 0;
  i64toi32_i32$2 = $0 + 24 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $34 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[i64toi32_i32$0 >> 2] = $34;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $37 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $37;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  $0 = HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $49 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 48 | 0) + 24 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $49;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $54 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 48 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $54;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $59 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 48 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $59;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $62 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = $62;
  HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = i64toi32_i32$0;
  $0 = $cardano_serialization_lib__crypto__Vkey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h0c56da261e90089c(i64toi32_i32$2 + 48 | 0 | 0) | 0;
  global$0 = i64toi32_i32$2 + 80 | 0;
  return $0 | 0;
 }
 
 function bootstrapwitness_vkey($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $2 = 0, $3 = 0, $4 = 0, $20 = 0, $27 = 0, $34 = 0, $37 = 0, $49 = 0, $54 = 0, $59 = 0, $62 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h76a11b605f70ebd5($1 + 8 | 0 | 0, $0 | 0);
  $2 = ($1 + 16 | 0) + 8 | 0;
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $0 + 32 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $20;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $3 = ($1 + 16 | 0) + 16 | 0;
  i64toi32_i32$2 = $0 + 40 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $27 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[i64toi32_i32$1 >> 2] = $27;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = ($1 + 16 | 0) + 24 | 0;
  i64toi32_i32$2 = $0 + 48 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $34 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[i64toi32_i32$0 >> 2] = $34;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 24 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 25 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 26 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 27 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 28 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 29 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 30 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 31 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $37 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $37;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  $0 = HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $49 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 48 | 0) + 24 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $49;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $54 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 48 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $54;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $59 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 48 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $59;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $62 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = $62;
  HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = i64toi32_i32$0;
  $0 = $cardano_serialization_lib__crypto__Vkey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h0c56da261e90089c(i64toi32_i32$2 + 48 | 0 | 0) | 0;
  global$0 = i64toi32_i32$2 + 80 | 0;
  return $0 | 0;
 }
 
 function cardano_serialization_lib__crypto__BootstrapWitnesses__add__h053adaa5938ec849($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $11 = 0, $17 = 0, $23 = 0, $26 = 0;
  $2 = global$0 - 128 | 0;
  global$0 = $2;
  i64toi32_i32$2 = $1 + 48 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $11 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 8 | 0) + 48 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $11;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 40 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $17 = i64toi32_i32$1;
  i64toi32_i32$1 = ($2 + 8 | 0) + 40 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $17;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1 + 32 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $23 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 8 | 0) + 32 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $23;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[($1 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 28 | 0) >> 2] | 0;
  $26 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $26;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$0;
  memcpy(($2 + 8 | 0) + 56 | 0 | 0, $1 + 56 | 0 | 0, 64 | 0) | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($2 + 8 | 0 | 0, $1 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3(($2 + 8 | 0) + 12 | 0 | 0, $1 + 12 | 0 | 0);
  label$1 : {
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (($1 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
    break label$1
   }
   alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h4d4877c8b8eb1e24($0 | 0, $1 | 0, 1 | 0);
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  }
  memcpy((HEAP32[$0 >> 2] | 0) + Math_imul($1, 120) | 0 | 0, $2 + 8 | 0 | 0, 120 | 0) | 0;
  HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
  global$0 = $2 + 128 | 0;
 }
 
 function core__ptr__drop_in_place_cardano_serialization_lib__plutus__PlutusData___hfab843e66e0f9428_2($0) {
  $0 = $0 | 0;
  var $1 = 0, $3 = 0, $2 = 0;
  label$1 : {
   label$2 : {
    switch (HEAP32[$0 >> 2] | 0 | 0) {
    default:
     $1 = $0 + 4 | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
     break label$1;
    case 0:
     $2 = $0 + 16 | 0;
     label$7 : {
      $3 = HEAP32[($0 + 24 | 0) >> 2] | 0;
      if (!$3) {
       break label$7
      }
      $1 = HEAP32[$2 >> 2] | 0;
      $3 = Math_imul($3, 48);
      label$8 : while (1) {
       core__ptr__drop_in_place_cardano_serialization_lib__plutus__PlutusData___hfab843e66e0f9428_2($1 | 0);
       $1 = $1 + 48 | 0;
       $3 = $3 + -48 | 0;
       if ($3) {
        continue label$8
       }
       break label$8;
      };
     }
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h36e817e704f6f25e($2 | 0);
     break label$1;
    case 1:
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h50a5c5eb0f530455($0 + 4 | 0 | 0);
     break label$1;
    case 2:
     $2 = $0 + 4 | 0;
     label$9 : {
      $3 = HEAP32[($0 + 12 | 0) >> 2] | 0;
      if (!$3) {
       break label$9
      }
      $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
      $3 = Math_imul($3, 48);
      label$10 : while (1) {
       core__ptr__drop_in_place_cardano_serialization_lib__plutus__PlutusData___hfab843e66e0f9428_2($1 | 0);
       $1 = $1 + 48 | 0;
       $3 = $3 + -48 | 0;
       if ($3) {
        continue label$10
       }
       break label$10;
      };
     }
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h36e817e704f6f25e($2 | 0);
     break label$1;
    case 3:
     break label$2;
    };
   }
   $1 = $0 + 4 | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h19f76bdb6b4883ef($1 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h970b13f6299e0f2d($1 | 0);
  }
  core__ptr__drop_in_place_core__option__Option_alloc__vec__Vec_u8_____ha5300c747747c3c8_1($0 + 32 | 0 | 0);
 }
 
 function core__ptr__drop_in_place_cardano_serialization_lib__plutus__PlutusData___hfab843e66e0f9428_3($0) {
  $0 = $0 | 0;
  var $1 = 0, $3 = 0, $2 = 0;
  label$1 : {
   label$2 : {
    switch (HEAP32[$0 >> 2] | 0 | 0) {
    default:
     $1 = $0 + 4 | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
     break label$1;
    case 0:
     $2 = $0 + 16 | 0;
     label$7 : {
      $3 = HEAP32[($0 + 24 | 0) >> 2] | 0;
      if (!$3) {
       break label$7
      }
      $1 = HEAP32[$2 >> 2] | 0;
      $3 = Math_imul($3, 48);
      label$8 : while (1) {
       core__ptr__drop_in_place_cardano_serialization_lib__plutus__PlutusData___hfab843e66e0f9428_2($1 | 0);
       $1 = $1 + 48 | 0;
       $3 = $3 + -48 | 0;
       if ($3) {
        continue label$8
       }
       break label$8;
      };
     }
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h36e817e704f6f25e($2 | 0);
     break label$1;
    case 1:
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h50a5c5eb0f530455($0 + 4 | 0 | 0);
     break label$1;
    case 2:
     $2 = $0 + 4 | 0;
     label$9 : {
      $3 = HEAP32[($0 + 12 | 0) >> 2] | 0;
      if (!$3) {
       break label$9
      }
      $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
      $3 = Math_imul($3, 48);
      label$10 : while (1) {
       core__ptr__drop_in_place_cardano_serialization_lib__plutus__PlutusData___hfab843e66e0f9428_2($1 | 0);
       $1 = $1 + 48 | 0;
       $3 = $3 + -48 | 0;
       if ($3) {
        continue label$10
       }
       break label$10;
      };
     }
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h36e817e704f6f25e($2 | 0);
     break label$1;
    case 3:
     break label$2;
    };
   }
   $1 = $0 + 4 | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h19f76bdb6b4883ef($1 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h970b13f6299e0f2d($1 | 0);
  }
  core__ptr__drop_in_place_core__option__Option_alloc__vec__Vec_u8_____ha5300c747747c3c8_2($0 + 32 | 0 | 0);
 }
 
 function costmdls_keys($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $29 = 0, $37 = 0, $40 = 0, $57 = 0;
  $1 = global$0 - 96 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h0e53d0166415c79c($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  alloc__collections__btree__map__BTreeMap_K_2cV___iter__h351d422ab5212013($1 + 32 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
  HEAP32[(($1 + 64 | 0) + 24 | 0) >> 2] = HEAP32[(($1 + 32 | 0) + 24 | 0) >> 2] | 0;
  i64toi32_i32$2 = ($1 + 32 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $29 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 64 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $29;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $2 = ($1 + 64 | 0) + 8 | 0;
  i64toi32_i32$2 = ($1 + 32 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $37 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[i64toi32_i32$1 >> 2] = $37;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[($1 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 36 | 0) >> 2] | 0;
  $40 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 64 | 0) >> 2] = $40;
  HEAP32[($1 + 68 | 0) >> 2] = i64toi32_i32$1;
  $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__he32bf0f16720a611($1 + 16 | 0 | 0, $1 + 64 | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[$2 >> 2] = HEAP32[(($1 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[($1 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  $57 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[($1 + 64 | 0) >> 2] = $57;
  HEAP32[($1 + 68 | 0) >> 2] = i64toi32_i32$0;
  $0 = $cardano_serialization_lib__plutus__Languages_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h685771a5e09c75ed($1 + 64 | 0 | 0) | 0;
  global$0 = $1 + 96 | 0;
  return $0 | 0;
 }
 
 function $getrandom__error__Error_20as_20core__fmt__Display___fmt__hb78b9a6fe25169c3($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, $3 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    $0 = HEAP32[$0 >> 2] | 0;
    if (($0 | 0) < (0 | 0)) {
     break label$2
    }
    HEAP32[($2 + 44 | 0) >> 2] = $0;
    HEAP32[($2 + 28 | 0) >> 2] = 1;
    i64toi32_i32$0 = 0;
    HEAP32[($2 + 12 | 0) >> 2] = 1;
    HEAP32[($2 + 16 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($2 + 8 | 0) >> 2] = 1075292;
    HEAP32[($2 + 36 | 0) >> 2] = 167;
    HEAP32[($2 + 24 | 0) >> 2] = $2 + 32 | 0;
    HEAP32[($2 + 32 | 0) >> 2] = $2 + 44 | 0;
    $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 8 | 0 | 0) | 0;
    break label$1;
   }
   getrandom__error__internal_desc__h19dfc27a2698807d($2 | 0, $0 | 0);
   label$3 : {
    $3 = HEAP32[$2 >> 2] | 0;
    if (!$3) {
     break label$3
    }
    $0 = core__fmt__Formatter__write_str__h8d6b3db46091fabc($1 | 0, $3 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0) | 0;
    break label$1;
   }
   HEAP32[($2 + 28 | 0) >> 2] = 1;
   i64toi32_i32$0 = 0;
   HEAP32[($2 + 12 | 0) >> 2] = 1;
   HEAP32[($2 + 16 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($2 + 8 | 0) >> 2] = 1075272;
   HEAP32[($2 + 36 | 0) >> 2] = 46;
   HEAP32[($2 + 44 | 0) >> 2] = $0;
   HEAP32[($2 + 24 | 0) >> 2] = $2 + 32 | 0;
   HEAP32[($2 + 32 | 0) >> 2] = $2 + 44 | 0;
   $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 8 | 0 | 0) | 0;
  }
  global$0 = $2 + 48 | 0;
  return $0 | 0;
 }
 
 function alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__hc39010d35e6d6adc($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $6 = 0, $8 = 0, $5 = 0, $9 = 0, $7 = 0, $10 = 0, $11 = 0;
  $5 = global$0 - 16 | 0;
  global$0 = $5;
  $6 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $7 = HEAPU16[($6 + 402 | 0) >> 1] | 0;
  $8 = Math_imul($4, 12);
  $1 = Math_imul($7, 12) - $8 | 0;
  $6 = ($6 + $8 | 0) + 268 | 0;
  $9 = 1;
  label$1 : {
   label$2 : while (1) {
    $8 = $4;
    label$3 : {
     if ($1) {
      break label$3
     }
     $8 = $7;
     break label$1;
    }
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($5 + 8 | 0 | 0, $6 | 0);
    label$4 : {
     label$5 : {
      $4 = HEAP32[($5 + 12 | 0) >> 2] | 0;
      $10 = memcmp($2 | 0, HEAP32[($5 + 8 | 0) >> 2] | 0 | 0, ($4 >>> 0 < $3 >>> 0 ? $4 : $3) | 0) | 0;
      if ($10) {
       break label$5
      }
      if ($4 >>> 0 > $3 >>> 0) {
       break label$1
      }
      $11 = ($4 | 0) != ($3 | 0);
      break label$4;
     }
     $11 = 1;
     if (($10 | 0) >= (0 | 0)) {
      break label$4
     }
     $9 = 1;
     break label$1;
    }
    $6 = $6 + 12 | 0;
    $4 = $8 + 1 | 0;
    $1 = $1 + -12 | 0;
    if ($11) {
     continue label$2
    }
    break label$2;
   };
   $9 = 0;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $8;
  HEAP32[$0 >> 2] = $9;
  global$0 = $5 + 16 | 0;
 }
 
 function transactionbody_new($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, $6 = 0, $7 = 0;
  $5 = global$0 - 576 | 0;
  global$0 = $5;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hf2abefb15e68f011($5 + 24 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($5 + 28 | 0) >> 2] | 0;
   $6 = HEAP32[($5 + 24 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h6185b44b866d43f0($5 + 16 | 0 | 0, $1 | 0);
   if (!$2) {
    break label$1
   }
   $1 = HEAP32[($5 + 20 | 0) >> 2] | 0;
   $7 = HEAP32[($5 + 16 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($5 + 8 | 0 | 0, $2 | 0);
   $2 = HEAP32[($5 + 12 | 0) >> 2] | 0;
   cardano_serialization_lib__TransactionBody__new__h54f6232177292578($5 + 32 | 0 | 0, $6 | 0, $7 | 0, HEAP32[($5 + 8 | 0) >> 2] | 0 | 0, ($3 | 0) != (0 | 0) | 0, $4 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   memcpy($5 + 304 | 0 | 0, $5 + 32 | 0 | 0, 272 | 0) | 0;
   $0 = $cardano_serialization_lib__TransactionBody_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h5f9023ed5f5fb82c($5 + 304 | 0 | 0) | 0;
   global$0 = $5 + 576 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function $std__io__cursor__Cursor_T__20as_20std__io__Seek___seek__h4fe82da83d4d5304($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$4 = 0, i64toi32_i32$5 = 0, $5$hi = 0, $5 = 0, $6$hi = 0, $6 = 0, $3 = 0, $17 = 0, $18 = 0, $19 = 0, $4 = 0, $20 = 0, $48 = 0, $51 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      switch (HEAP32[$2 >> 2] | 0 | 0) {
      default:
       i64toi32_i32$2 = $2;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
       $5 = i64toi32_i32$0;
       $5$hi = i64toi32_i32$1;
       i64toi32_i32$0 = $1;
       HEAP32[i64toi32_i32$0 >> 2] = $5;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       i64toi32_i32$0 = $0 + 8 | 0;
       HEAP32[i64toi32_i32$0 >> 2] = $5;
       HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
       break label$2;
      case 1:
       i64toi32_i32$2 = $2;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
       $5 = i64toi32_i32$1;
       $5$hi = i64toi32_i32$0;
       $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $1 + 8 | 0 | 0);
       i64toi32_i32$2 = $3;
       i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
       i64toi32_i32$1 = 0;
       $6 = i64toi32_i32$0;
       $6$hi = i64toi32_i32$1;
       break label$3;
      case 2:
       break label$4;
      };
     }
     i64toi32_i32$2 = $1;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $6 = i64toi32_i32$1;
     $6$hi = i64toi32_i32$0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
     $5 = i64toi32_i32$0;
     $5$hi = i64toi32_i32$1;
    }
    label$7 : {
     label$8 : {
      i64toi32_i32$1 = $5$hi;
      i64toi32_i32$2 = $5;
      i64toi32_i32$0 = -1;
      i64toi32_i32$3 = -1;
      if ((i64toi32_i32$1 | 0) > (i64toi32_i32$0 | 0)) {
       $17 = 1
      } else {
       if ((i64toi32_i32$1 | 0) >= (i64toi32_i32$0 | 0)) {
        if (i64toi32_i32$2 >>> 0 <= i64toi32_i32$3 >>> 0) {
         $18 = 0
        } else {
         $18 = 1
        }
        $19 = $18;
       } else {
        $19 = 0
       }
       $17 = $19;
      }
      if ($17) {
       break label$8
      }
      i64toi32_i32$2 = $6$hi;
      i64toi32_i32$2 = $5$hi;
      i64toi32_i32$2 = $6$hi;
      i64toi32_i32$3 = $6;
      i64toi32_i32$1 = $5$hi;
      i64toi32_i32$0 = $5;
      i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
      i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
      if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
       i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
      }
      $5 = i64toi32_i32$4;
      $5$hi = i64toi32_i32$5;
      i64toi32_i32$5 = $6$hi;
      i64toi32_i32$5 = $5$hi;
      i64toi32_i32$2 = i64toi32_i32$4;
      i64toi32_i32$3 = $6$hi;
      i64toi32_i32$0 = $6;
      $4 = i64toi32_i32$5 >>> 0 > i64toi32_i32$3 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$2 >>> 0 > i64toi32_i32$0 >>> 0 | 0) | 0;
      break label$7;
     }
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$2 = $5$hi;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$0 = $6;
     i64toi32_i32$5 = $5$hi;
     i64toi32_i32$3 = $5;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $5 = i64toi32_i32$1;
     $5$hi = i64toi32_i32$4;
     i64toi32_i32$4 = $6$hi;
     i64toi32_i32$4 = $5$hi;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$3 = $6;
     $4 = i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
    }
    $2 = 1;
    label$9 : {
     if (!($4 & 1 | 0)) {
      break label$9
     }
     $48 = $0;
     i64toi32_i32$2 = 0;
     i64toi32_i32$3 = 1056044;
     i64toi32_i32$4 = 0;
     i64toi32_i32$0 = 32;
     i64toi32_i32$5 = i64toi32_i32$0 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$3 << i64toi32_i32$5 | 0;
      $20 = 0;
     } else {
      i64toi32_i32$4 = ((1 << i64toi32_i32$5 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$5 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$5 | 0) | 0;
      $20 = i64toi32_i32$3 << i64toi32_i32$5 | 0;
     }
     i64toi32_i32$2 = $20;
     i64toi32_i32$3 = 0;
     i64toi32_i32$0 = 5122;
     i64toi32_i32$3 = i64toi32_i32$4 | i64toi32_i32$3 | 0;
     $51 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
     i64toi32_i32$2 = $48;
     HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = $51;
     HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = i64toi32_i32$3;
     break label$1;
    }
    i64toi32_i32$3 = $5$hi;
    i64toi32_i32$2 = $1;
    HEAP32[i64toi32_i32$2 >> 2] = $5;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
    i64toi32_i32$2 = $0 + 8 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $5;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
   }
   $2 = 0;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $3 + 16 | 0;
 }
 
 function get_deposit($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$2 = 0, $4 = 0, $5 = 0, i64toi32_i32$1 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h356c30395cf13adb($3 + 24 | 0 | 0, $0 | 0);
    if (!$1) {
     break label$2
    }
    $0 = HEAP32[($3 + 28 | 0) >> 2] | 0;
    $4 = HEAP32[($3 + 24 | 0) >> 2] | 0;
    wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($3 + 16 | 0 | 0, $1 | 0);
    if (!$2) {
     break label$2
    }
    $1 = HEAP32[($3 + 20 | 0) >> 2] | 0;
    $5 = HEAP32[($3 + 16 | 0) >> 2] | 0;
    wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($3 + 8 | 0 | 0, $2 | 0);
    $2 = HEAP32[($3 + 12 | 0) >> 2] | 0;
    cardano_serialization_lib__utils__internal_get_deposit__h544d8f4f3a980a59($3 + 32 | 0 | 0, $4 + 152 | 0 | 0, $5 | 0, HEAP32[($3 + 8 | 0) >> 2] | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    if ((HEAP32[($3 + 32 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    i64toi32_i32$2 = $3 + 40 | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810(HEAP32[i64toi32_i32$2 >> 2] | 0 | 0, i64toi32_i32$1 | 0) | 0;
    global$0 = $3 + 48 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($3 + 36 | 0) >> 2] | 0 | 0);
  abort();
 }
 
 function transactionbuilder_add_mint_asset($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $8$hi = 0, $5 = 0, $6 = 0, $7 = 0, $8 = 0, $56$hi = 0, $14 = 0;
  $4 = global$0 - 80 | 0;
  global$0 = $4;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h5566e1c7d4aafe35($4 + 40 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $5 = HEAP32[($4 + 44 | 0) >> 2] | 0;
   $6 = HEAP32[($4 + 40 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h6ed0b6b043905434($4 + 32 | 0 | 0, $1 | 0);
   if (!$2) {
    break label$1
   }
   $0 = HEAP32[($4 + 36 | 0) >> 2] | 0;
   $1 = HEAP32[($4 + 32 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h9c68abd5a6a78973($4 + 24 | 0 | 0, $2 | 0);
   $2 = HEAP32[($4 + 28 | 0) >> 2] | 0;
   $7 = HEAP32[($4 + 24 | 0) >> 2] | 0;
   $cardano_serialization_lib__utils__Int_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h465ce6bea3371e5b($4 + 8 | 0 | 0, $3 | 0);
   i64toi32_i32$2 = $4 + 16 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $8 = i64toi32_i32$0;
   $8$hi = i64toi32_i32$1;
   i64toi32_i32$2 = $4;
   i64toi32_i32$1 = HEAP32[($4 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($4 + 12 | 0) >> 2] | 0;
   cardano_serialization_lib__NativeScript__hash__hb812a54d2c7bdca2($4 + 48 | 0 | 0, $1 | 0);
   $56$hi = i64toi32_i32$0;
   i64toi32_i32$0 = $8$hi;
   i64toi32_i32$0 = $56$hi;
   $14 = i64toi32_i32$1;
   i64toi32_i32$1 = $8$hi;
   cardano_serialization_lib__tx_builder__TransactionBuilder___add_mint_asset__h060e64edb838acae($6 | 0, $4 + 48 | 0 | 0, $1 | 0, $7 | 0, $14 | 0, i64toi32_i32$0 | 0, $8 | 0, i64toi32_i32$1 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($5 | 0, 0 | 0) | 0;
   global$0 = $4 + 80 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function $cardano_serialization_lib__crypto__Nonce_20as_20cbor_event__se__Serialize___serialize__hd28efbdff8e194e3($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ((HEAPU8[$1 >> 0] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      i64toi32_i32$0 = 0;
      cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, 1 | 0, i64toi32_i32$0 | 0);
      if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      i64toi32_i32$0 = 0;
      cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($0 | 0, $2 | 0, 0 | 0, 0 | 0, i64toi32_i32$0 | 0);
      break label$1;
     }
     i64toi32_i32$0 = 0;
     cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, 2 | 0, i64toi32_i32$0 | 0);
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$2
     }
     i64toi32_i32$0 = 0;
     cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 1 | 0, i64toi32_i32$0 | 0);
     label$5 : {
      if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
       break label$5
      }
      cbor_event__se__Serializer_W___write_bytes__h330049db39307944($0 | 0, $2 | 0, $1 + 1 | 0 | 0);
      break label$1;
     }
     memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
     HEAP32[$0 >> 2] = 1;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $3 + 48 | 0;
 }
 
 function alloc__vec__Vec_T_2cA___extend_desugared__h00e1f6afbd8990a5($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $5 = 0, $3 = 0, $2 = 0, $6 = 0, $4 = 0;
  $2 = global$0 - 128 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    $3 = HEAP32[$1 >> 2] | 0;
    $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (($3 | 0) != ($4 | 0)) {
     break label$2
    }
    $5 = 0;
    break label$1;
   }
   $6 = $3 + 128 | 0;
   HEAP32[$1 >> 2] = $6;
   $5 = $3;
   $3 = $6;
  }
  core__option__Option__T___cloned__h621eb297880b0347($2 | 0, $5 | 0);
  label$3 : {
   if ((HEAP32[($2 + 72 | 0) >> 2] | 0 | 0) == (2 | 0)) {
    break label$3
   }
   label$4 : while (1) {
    label$5 : {
     $5 = HEAP32[($0 + 8 | 0) >> 2] | 0;
     if ((HEAP32[($0 + 4 | 0) >> 2] | 0 | 0) != ($5 | 0)) {
      break label$5
     }
     alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hf135acf924159ceb($0 | 0, $5 | 0, 1 | 0);
    }
    memcpy((HEAP32[$0 >> 2] | 0) + ($5 << 7 | 0) | 0 | 0, $2 | 0, 128 | 0) | 0;
    HEAP32[($0 + 8 | 0) >> 2] = $5 + 1 | 0;
    label$6 : {
     label$7 : {
      if (($3 | 0) != ($4 | 0)) {
       break label$7
      }
      $5 = 0;
      $3 = $4;
      break label$6;
     }
     $6 = $3 + 128 | 0;
     HEAP32[$1 >> 2] = $6;
     $5 = $3;
     $3 = $6;
    }
    core__option__Option__T___cloned__h621eb297880b0347($2 | 0, $5 | 0);
    if ((HEAP32[($2 + 72 | 0) >> 2] | 0 | 0) != (2 | 0)) {
     continue label$4
    }
    break label$4;
   };
  }
  global$0 = $2 + 128 | 0;
 }
 
 function alloc__vec__Vec_T_2cA___extend_desugared__hcfcb64062caa1691($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $5 = 0, $3 = 0, $2 = 0, $6 = 0, $4 = 0;
  $2 = global$0 - 128 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    $3 = HEAP32[$1 >> 2] | 0;
    $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (($3 | 0) != ($4 | 0)) {
     break label$2
    }
    $5 = 0;
    break label$1;
   }
   $6 = $3 + 128 | 0;
   HEAP32[$1 >> 2] = $6;
   $5 = $3;
   $3 = $6;
  }
  core__option__Option__T___cloned__h621eb297880b0347($2 | 0, $5 | 0);
  label$3 : {
   if ((HEAP32[($2 + 72 | 0) >> 2] | 0 | 0) == (2 | 0)) {
    break label$3
   }
   label$4 : while (1) {
    label$5 : {
     $5 = HEAP32[($0 + 8 | 0) >> 2] | 0;
     if ((HEAP32[($0 + 4 | 0) >> 2] | 0 | 0) != ($5 | 0)) {
      break label$5
     }
     alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hf135acf924159ceb($0 | 0, $5 | 0, 1 | 0);
    }
    memcpy((HEAP32[$0 >> 2] | 0) + ($5 << 7 | 0) | 0 | 0, $2 | 0, 128 | 0) | 0;
    HEAP32[($0 + 8 | 0) >> 2] = $5 + 1 | 0;
    label$6 : {
     label$7 : {
      if (($3 | 0) != ($4 | 0)) {
       break label$7
      }
      $5 = 0;
      $3 = $4;
      break label$6;
     }
     $6 = $3 + 128 | 0;
     HEAP32[$1 >> 2] = $6;
     $5 = $3;
     $3 = $6;
    }
    core__option__Option__T___cloned__h621eb297880b0347($2 | 0, $5 | 0);
    if ((HEAP32[($2 + 72 | 0) >> 2] | 0 | 0) != (2 | 0)) {
     continue label$4
    }
    break label$4;
   };
  }
  global$0 = $2 + 128 | 0;
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___entry__h5b0f4a3d2f0d57d5($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, $3 = 0, $13 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $5 = 0, $31 = 0, $41 = 0, $46 = 0, $49 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$4) {
     break label$2
    }
    $5 = HEAP32[$1 >> 2] | 0;
    break label$1;
   }
   $5 = 0;
   $4 = alloc__boxed__Box_T_2cA___new_uninit_in__h0c9edbef1faf0ccf() | 0;
   HEAP16[($4 + 6 | 0) >> 1] = 0;
   HEAP32[$4 >> 2] = 0;
   HEAP32[($1 + 4 | 0) >> 2] = $4;
   HEAP32[$1 >> 2] = 0;
  }
  alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__h98b098e6271053bd($3 | 0, $5 | 0, $4 | 0, $2 | 0);
  $4 = 1;
  label$3 : {
   if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
    break label$3
   }
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $31 = i64toi32_i32$0;
   i64toi32_i32$0 = $0 + 20 | 0;
   $13 = $31;
   HEAP8[i64toi32_i32$0 >> 0] = $13;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $13 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $13 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $13 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   $14 = i64toi32_i32$2 + 24 | 0;
   $15 = $0 + 44 | 0;
   $16 = HEAPU8[$14 >> 0] | 0 | ((HEAPU8[($14 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($14 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($14 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[$15 >> 0] = $16;
   HEAP8[($15 + 1 | 0) >> 0] = $16 >>> 8 | 0;
   HEAP8[($15 + 2 | 0) >> 0] = $16 >>> 16 | 0;
   HEAP8[($15 + 3 | 0) >> 0] = $16 >>> 24 | 0;
   i64toi32_i32$2 = i64toi32_i32$2 + 16 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $41 = i64toi32_i32$1;
   i64toi32_i32$1 = $0 + 36 | 0;
   $17 = $41;
   HEAP8[i64toi32_i32$1 >> 0] = $17;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $2 + 8 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $46 = i64toi32_i32$0;
   i64toi32_i32$0 = $0 + 28 | 0;
   $18 = $46;
   HEAP8[i64toi32_i32$0 >> 0] = $18;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $18 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $18 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $18 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   $4 = 0;
  }
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  $49 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $49;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[i64toi32_i32$1 >> 2] = $4;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $1;
  HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  global$0 = i64toi32_i32$2 + 16 | 0;
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___entry__hacc4ab587cdf931c($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, $3 = 0, $13 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $5 = 0, $31 = 0, $41 = 0, $46 = 0, $49 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$4) {
     break label$2
    }
    $5 = HEAP32[$1 >> 2] | 0;
    break label$1;
   }
   $5 = 0;
   $4 = alloc__boxed__Box_T_2cA___new_uninit_in__h8bd6a5af2b5d8b6d() | 0;
   HEAP16[($4 + 138 | 0) >> 1] = 0;
   HEAP32[$4 >> 2] = 0;
   HEAP32[($1 + 4 | 0) >> 2] = $4;
   HEAP32[$1 >> 2] = 0;
  }
  alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__h6a813680d458244c($3 | 0, $5 | 0, $4 | 0, $2 | 0);
  $4 = 1;
  label$3 : {
   if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
    break label$3
   }
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $31 = i64toi32_i32$0;
   i64toi32_i32$0 = $0 + 20 | 0;
   $13 = $31;
   HEAP8[i64toi32_i32$0 >> 0] = $13;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $13 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $13 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $13 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   $14 = i64toi32_i32$2 + 24 | 0;
   $15 = $0 + 44 | 0;
   $16 = HEAPU8[$14 >> 0] | 0 | ((HEAPU8[($14 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($14 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($14 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[$15 >> 0] = $16;
   HEAP8[($15 + 1 | 0) >> 0] = $16 >>> 8 | 0;
   HEAP8[($15 + 2 | 0) >> 0] = $16 >>> 16 | 0;
   HEAP8[($15 + 3 | 0) >> 0] = $16 >>> 24 | 0;
   i64toi32_i32$2 = i64toi32_i32$2 + 16 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $41 = i64toi32_i32$1;
   i64toi32_i32$1 = $0 + 36 | 0;
   $17 = $41;
   HEAP8[i64toi32_i32$1 >> 0] = $17;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $2 + 8 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $46 = i64toi32_i32$0;
   i64toi32_i32$0 = $0 + 28 | 0;
   $18 = $46;
   HEAP8[i64toi32_i32$0 >> 0] = $18;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $18 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $18 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $18 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   $4 = 0;
  }
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  $49 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $49;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[i64toi32_i32$1 >> 2] = $4;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $1;
  HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  global$0 = i64toi32_i32$2 + 16 | 0;
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___entry__hd27d6127e1982e7e($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, $3 = 0, $13 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $5 = 0, $31 = 0, $41 = 0, $46 = 0, $49 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$4) {
     break label$2
    }
    $5 = HEAP32[$1 >> 2] | 0;
    break label$1;
   }
   $5 = 0;
   $4 = alloc__boxed__Box_T_2cA___new_uninit_in__hcce3eeaf87129ab3() | 0;
   HEAP16[($4 + 138 | 0) >> 1] = 0;
   HEAP32[$4 >> 2] = 0;
   HEAP32[($1 + 4 | 0) >> 2] = $4;
   HEAP32[$1 >> 2] = 0;
  }
  alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__h05f65203dc6f97ae($3 | 0, $5 | 0, $4 | 0, $2 | 0);
  $4 = 1;
  label$3 : {
   if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
    break label$3
   }
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $31 = i64toi32_i32$0;
   i64toi32_i32$0 = $0 + 20 | 0;
   $13 = $31;
   HEAP8[i64toi32_i32$0 >> 0] = $13;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $13 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $13 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $13 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   $14 = i64toi32_i32$2 + 24 | 0;
   $15 = $0 + 44 | 0;
   $16 = HEAPU8[$14 >> 0] | 0 | ((HEAPU8[($14 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($14 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($14 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[$15 >> 0] = $16;
   HEAP8[($15 + 1 | 0) >> 0] = $16 >>> 8 | 0;
   HEAP8[($15 + 2 | 0) >> 0] = $16 >>> 16 | 0;
   HEAP8[($15 + 3 | 0) >> 0] = $16 >>> 24 | 0;
   i64toi32_i32$2 = i64toi32_i32$2 + 16 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $41 = i64toi32_i32$1;
   i64toi32_i32$1 = $0 + 36 | 0;
   $17 = $41;
   HEAP8[i64toi32_i32$1 >> 0] = $17;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $2 + 8 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $46 = i64toi32_i32$0;
   i64toi32_i32$0 = $0 + 28 | 0;
   $18 = $46;
   HEAP8[i64toi32_i32$0 >> 0] = $18;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $18 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $18 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $18 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   $4 = 0;
  }
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  $49 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $49;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[i64toi32_i32$1 >> 2] = $4;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $1;
  HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  global$0 = i64toi32_i32$2 + 16 | 0;
 }
 
 function pointeraddress_payment_cred($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $2 = 0, $3 = 0, $4 = 0, $6 = 0, $24 = 0, $30 = 0, $5 = 0, $43 = 0, $52 = 0, $56 = 0, $65 = 0;
  $1 = global$0 - 112 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h8caae7a957e11e51($1 + 8 | 0 | 0, $0 | 0);
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $3 = $1 + 24 | 0;
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $0 + 34 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $4 = $1 + 32 | 0;
  i64toi32_i32$2 = $0 + 42 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $30 = i64toi32_i32$1;
  i64toi32_i32$1 = $4;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $0 + 26 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $5 = HEAPU8[($0 + 25 | 0) >> 0] | 0;
  $6 = $1 + 40 | 0;
  $16 = $0 + 50 | 0;
  HEAP32[$6 >> 2] = HEAPU8[$16 >> 0] | 0 | ((HEAPU8[($16 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($16 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($16 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $43 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 16 | 0) >> 2] = $43;
  HEAP32[($1 + 20 | 0) >> 2] = i64toi32_i32$1;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $52 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 89 | 0;
  $17 = $52;
  HEAP8[i64toi32_i32$1 >> 0] = $17;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $56 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 97 | 0;
  $18 = $56;
  HEAP8[i64toi32_i32$0 >> 0] = $18;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $18 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $18 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $18 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $19 = $1 + 105 | 0;
  $20 = HEAP32[$6 >> 2] | 0;
  HEAP8[$19 >> 0] = $20;
  HEAP8[($19 + 1 | 0) >> 0] = $20 >>> 8 | 0;
  HEAP8[($19 + 2 | 0) >> 0] = $20 >>> 16 | 0;
  HEAP8[($19 + 3 | 0) >> 0] = $20 >>> 24 | 0;
  HEAP8[($1 + 80 | 0) >> 0] = $5;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $65 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  $21 = $65;
  HEAP8[(i64toi32_i32$2 + 81 | 0) >> 0] = $21;
  HEAP8[(i64toi32_i32$2 + 82 | 0) >> 0] = $21 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 83 | 0) >> 0] = $21 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 84 | 0) >> 0] = $21 >>> 24 | 0;
  HEAP8[(i64toi32_i32$2 + 85 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$2 + 86 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 87 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 88 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $0 = $cardano_serialization_lib__address__StakeCredential_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hfe6826a4b7739a89(i64toi32_i32$2 + 80 | 0 | 0) | 0;
  global$0 = i64toi32_i32$2 + 112 | 0;
  return $0 | 0;
 }
 
 function plutusdata_new_constr_plutus_data($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $2 = 0, $3 = 0, $4 = 0, $4$hi = 0, $39 = 0, $42 = 0, $53 = 0, $57 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h2f574964f7dad662($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[$0 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$1;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hc831120dea694494($1 + 32 | 0 | 0, $0 + 8 | 0 | 0);
  $0 = HEAPU8[($0 + 20 | 0) >> 0] | 0;
  HEAP8[($1 + 44 | 0) >> 0] = ($0 | 0) == (2 | 0) ? 2 : ($0 | 0) != (0 | 0);
  $0 = ($1 + 16 | 0) + 8 | 0;
  $3 = ($1 + 32 | 0) + 8 | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $39 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $39;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[($1 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 36 | 0) >> 2] | 0;
  $42 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 16 | 0) >> 2] = $42;
  HEAP32[($1 + 20 | 0) >> 2] = i64toi32_i32$1;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$1 = $4$hi;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $4;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[($1 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  $53 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 48 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $53;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[$0 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $57 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 56 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $57;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 32 | 0) >> 2] = 0;
  HEAP32[($1 + 64 | 0) >> 2] = 0;
  $0 = $cardano_serialization_lib__plutus__PlutusData_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h7393378a3318e0a5($1 + 32 | 0 | 0) | 0;
  global$0 = $1 + 80 | 0;
  return $0 | 0;
 }
 
 function cardano_serialization_lib__plutus__Redeemers__total_ex_units__h8d7844499459197f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$5 = 0, i64toi32_i32$4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, $6$hi = 0, $7$hi = 0, $2 = 0, $4$hi = 0, $5$hi = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $7 = 0, $19 = 0, $19$hi = 0, $27 = 0, $27$hi = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     if ($2) {
      break label$3
     }
     i64toi32_i32$0 = 0;
     $4 = 0;
     $4$hi = i64toi32_i32$0;
     i64toi32_i32$0 = 0;
     $5 = 0;
     $5$hi = i64toi32_i32$0;
     break label$2;
    }
    $1 = (HEAP32[$1 >> 2] | 0) + 56 | 0;
    i64toi32_i32$0 = 0;
    $6 = 0;
    $6$hi = i64toi32_i32$0;
    $3 = $2;
    i64toi32_i32$0 = 0;
    $7 = 0;
    $7$hi = i64toi32_i32$0;
    label$4 : {
     label$5 : {
      label$6 : {
       label$7 : while (1) {
        if (!$3) {
         break label$6
        }
        i64toi32_i32$0 = $7$hi;
        i64toi32_i32$2 = $1;
        i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
        i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
        $19 = i64toi32_i32$0;
        $19$hi = i64toi32_i32$1;
        i64toi32_i32$1 = $7$hi;
        i64toi32_i32$2 = $7;
        i64toi32_i32$0 = $19$hi;
        i64toi32_i32$3 = $19;
        i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
        i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
        if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
         i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
        }
        $5 = i64toi32_i32$4;
        $5$hi = i64toi32_i32$5;
        i64toi32_i32$5 = $7$hi;
        i64toi32_i32$5 = $5$hi;
        i64toi32_i32$1 = i64toi32_i32$4;
        i64toi32_i32$2 = $7$hi;
        i64toi32_i32$3 = $7;
        if (i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0) {
         break label$5
        }
        label$8 : {
         i64toi32_i32$1 = $6$hi;
         i64toi32_i32$3 = $1 + 8 | 0;
         i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
         i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
         $27 = i64toi32_i32$1;
         $27$hi = i64toi32_i32$5;
         i64toi32_i32$5 = $6$hi;
         i64toi32_i32$3 = $6;
         i64toi32_i32$1 = $27$hi;
         i64toi32_i32$2 = $27;
         i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
         i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$1 | 0;
         if (i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0) {
          i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
         }
         $4 = i64toi32_i32$0;
         $4$hi = i64toi32_i32$4;
         i64toi32_i32$4 = $6$hi;
         i64toi32_i32$4 = $4$hi;
         i64toi32_i32$5 = i64toi32_i32$0;
         i64toi32_i32$3 = $6$hi;
         i64toi32_i32$2 = $6;
         if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0) {
          break label$8
         }
         $1 = $1 + 80 | 0;
         i64toi32_i32$5 = $4$hi;
         $6 = $4;
         $6$hi = i64toi32_i32$5;
         i64toi32_i32$5 = $5$hi;
         $7 = $5;
         $7$hi = i64toi32_i32$5;
         $3 = $3 + -1 | 0;
         if (!$3) {
          break label$2
         }
         continue label$7;
        }
        break label$7;
       };
       (wasm2js_i32$0 = $0, wasm2js_i32$1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1058732 | 0, 8 | 0) | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
       break label$4;
      }
      core__panicking__panic_bounds_check__h808b524af17640b1($2 | 0, $2 | 0, 1071796 | 0);
      abort();
     }
     (wasm2js_i32$0 = $0, wasm2js_i32$1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1058732 | 0, 8 | 0) | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
    }
    $1 = 1;
    break label$1;
   }
   i64toi32_i32$5 = $4$hi;
   i64toi32_i32$4 = $0 + 16 | 0;
   HEAP32[i64toi32_i32$4 >> 2] = $4;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$5 = $5$hi;
   i64toi32_i32$4 = $0 + 8 | 0;
   HEAP32[i64toi32_i32$4 >> 2] = $5;
   HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
   $1 = 0;
  }
  HEAP32[$0 >> 2] = $1;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___grow_amortized__h7088b8fc2d40299b($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $5 = 0, $50 = 0, $53 = 0;
  $4 = global$0 - 32 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    $3 = $2 + $3 | 0;
    if ($3 >>> 0 < $2 >>> 0) {
     break label$2
    }
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $5 = $2 << 1 | 0;
    $3 = $5 >>> 0 > $3 >>> 0 ? $5 : $3;
    $3 = $3 >>> 0 > 8 >>> 0 ? $3 : 8;
    label$3 : {
     label$4 : {
      if (!$2) {
       break label$4
      }
      HEAP32[(($4 + 16 | 0) + 8 | 0) >> 2] = 1;
      HEAP32[($4 + 20 | 0) >> 2] = $2;
      HEAP32[($4 + 16 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
      break label$3;
     }
     HEAP32[($4 + 16 | 0) >> 2] = 0;
    }
    $2 = 1;
    alloc__raw_vec__finish_grow__h4c09fb07da592cb2($4 | 0, $3 | 0, 1 | 0, $4 + 16 | 0 | 0, $4 | 0);
    label$5 : {
     if ((HEAP32[$4 >> 2] | 0 | 0) == (1 | 0)) {
      break label$5
     }
     i64toi32_i32$0 = HEAP32[($4 + 4 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($4 + 8 | 0) >> 2] | 0;
     $50 = i64toi32_i32$0;
     i64toi32_i32$0 = $1;
     HEAP32[i64toi32_i32$0 >> 2] = $50;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     $2 = 0;
     break label$1;
    }
    i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    $53 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $53;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    break label$1;
   }
   HEAP32[($0 + 4 | 0) >> 2] = $3;
   HEAP32[($0 + 8 | 0) >> 2] = 0;
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $4 + 32 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___grow_amortized__h37c25786904aedf0($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $5 = 0, $50 = 0, $53 = 0;
  $4 = global$0 - 32 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    $3 = $2 + $3 | 0;
    if ($3 >>> 0 < $2 >>> 0) {
     break label$2
    }
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $5 = $2 << 1 | 0;
    $3 = $5 >>> 0 > $3 >>> 0 ? $5 : $3;
    $3 = $3 >>> 0 > 8 >>> 0 ? $3 : 8;
    label$3 : {
     label$4 : {
      if (!$2) {
       break label$4
      }
      HEAP32[(($4 + 16 | 0) + 8 | 0) >> 2] = 1;
      HEAP32[($4 + 20 | 0) >> 2] = $2;
      HEAP32[($4 + 16 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
      break label$3;
     }
     HEAP32[($4 + 16 | 0) >> 2] = 0;
    }
    $2 = 1;
    alloc__raw_vec__finish_grow__h9cca7d8a9459b8aa($4 | 0, $3 | 0, 1 | 0, $4 + 16 | 0 | 0, $4 | 0);
    label$5 : {
     if ((HEAP32[$4 >> 2] | 0 | 0) == (1 | 0)) {
      break label$5
     }
     i64toi32_i32$0 = HEAP32[($4 + 4 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($4 + 8 | 0) >> 2] | 0;
     $50 = i64toi32_i32$0;
     i64toi32_i32$0 = $1;
     HEAP32[i64toi32_i32$0 >> 2] = $50;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     $2 = 0;
     break label$1;
    }
    i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    $53 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $53;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    break label$1;
   }
   HEAP32[($0 + 4 | 0) >> 2] = $3;
   HEAP32[($0 + 8 | 0) >> 2] = 0;
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $4 + 32 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___grow_amortized__h2f5e280bbc8649ed($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $5 = 0, $50 = 0, $53 = 0;
  $4 = global$0 - 32 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    $3 = $2 + $3 | 0;
    if ($3 >>> 0 < $2 >>> 0) {
     break label$2
    }
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $5 = $2 << 1 | 0;
    $3 = $5 >>> 0 > $3 >>> 0 ? $5 : $3;
    $3 = $3 >>> 0 > 8 >>> 0 ? $3 : 8;
    label$3 : {
     label$4 : {
      if (!$2) {
       break label$4
      }
      HEAP32[(($4 + 16 | 0) + 8 | 0) >> 2] = 1;
      HEAP32[($4 + 20 | 0) >> 2] = $2;
      HEAP32[($4 + 16 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
      break label$3;
     }
     HEAP32[($4 + 16 | 0) >> 2] = 0;
    }
    $2 = 1;
    alloc__raw_vec__finish_grow__hb156cf8e568fdb60($4 | 0, $3 | 0, 1 | 0, $4 + 16 | 0 | 0, $4 | 0);
    label$5 : {
     if ((HEAP32[$4 >> 2] | 0 | 0) == (1 | 0)) {
      break label$5
     }
     i64toi32_i32$0 = HEAP32[($4 + 4 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($4 + 8 | 0) >> 2] | 0;
     $50 = i64toi32_i32$0;
     i64toi32_i32$0 = $1;
     HEAP32[i64toi32_i32$0 >> 2] = $50;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     $2 = 0;
     break label$1;
    }
    i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    $53 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $53;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    break label$1;
   }
   HEAP32[($0 + 4 | 0) >> 2] = $3;
   HEAP32[($0 + 8 | 0) >> 2] = 0;
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $4 + 32 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___grow_amortized__hb18dc3da0fa4253f($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $5 = 0, $50 = 0, $53 = 0;
  $4 = global$0 - 32 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    $3 = $2 + $3 | 0;
    if ($3 >>> 0 < $2 >>> 0) {
     break label$2
    }
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $5 = $2 << 1 | 0;
    $3 = $5 >>> 0 > $3 >>> 0 ? $5 : $3;
    $3 = $3 >>> 0 > 8 >>> 0 ? $3 : 8;
    label$3 : {
     label$4 : {
      if (!$2) {
       break label$4
      }
      HEAP32[(($4 + 16 | 0) + 8 | 0) >> 2] = 1;
      HEAP32[($4 + 20 | 0) >> 2] = $2;
      HEAP32[($4 + 16 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
      break label$3;
     }
     HEAP32[($4 + 16 | 0) >> 2] = 0;
    }
    $2 = 1;
    alloc__raw_vec__finish_grow__h5a30504ab9b31c2c($4 | 0, $3 | 0, 1 | 0, $4 + 16 | 0 | 0, $4 | 0);
    label$5 : {
     if ((HEAP32[$4 >> 2] | 0 | 0) == (1 | 0)) {
      break label$5
     }
     i64toi32_i32$0 = HEAP32[($4 + 4 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($4 + 8 | 0) >> 2] | 0;
     $50 = i64toi32_i32$0;
     i64toi32_i32$0 = $1;
     HEAP32[i64toi32_i32$0 >> 2] = $50;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     $2 = 0;
     break label$1;
    }
    i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    $53 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $53;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    break label$1;
   }
   HEAP32[($0 + 4 | 0) >> 2] = $3;
   HEAP32[($0 + 8 | 0) >> 2] = 0;
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $4 + 32 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___grow_amortized__hc340e5268af1101d($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $5 = 0, $50 = 0, $53 = 0;
  $4 = global$0 - 32 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    $3 = $2 + $3 | 0;
    if ($3 >>> 0 < $2 >>> 0) {
     break label$2
    }
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $5 = $2 << 1 | 0;
    $3 = $5 >>> 0 > $3 >>> 0 ? $5 : $3;
    $3 = $3 >>> 0 > 8 >>> 0 ? $3 : 8;
    label$3 : {
     label$4 : {
      if (!$2) {
       break label$4
      }
      HEAP32[(($4 + 16 | 0) + 8 | 0) >> 2] = 1;
      HEAP32[($4 + 20 | 0) >> 2] = $2;
      HEAP32[($4 + 16 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
      break label$3;
     }
     HEAP32[($4 + 16 | 0) >> 2] = 0;
    }
    $2 = 1;
    alloc__raw_vec__finish_grow__h5a30504ab9b31c2c($4 | 0, $3 | 0, 1 | 0, $4 + 16 | 0 | 0, $4 | 0);
    label$5 : {
     if ((HEAP32[$4 >> 2] | 0 | 0) == (1 | 0)) {
      break label$5
     }
     i64toi32_i32$0 = HEAP32[($4 + 4 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($4 + 8 | 0) >> 2] | 0;
     $50 = i64toi32_i32$0;
     i64toi32_i32$0 = $1;
     HEAP32[i64toi32_i32$0 >> 2] = $50;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     $2 = 0;
     break label$1;
    }
    i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    $53 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $53;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    break label$1;
   }
   HEAP32[($0 + 4 | 0) >> 2] = $3;
   HEAP32[($0 + 8 | 0) >> 2] = 0;
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $4 + 32 | 0;
 }
 
 function alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__haa5df25eb520025e($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $5 = 0, $7 = 0, $8 = 0, $9 = 0, $6 = 0;
  $4 = global$0 - 16 | 0;
  global$0 = $4;
  $5 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $6 = HEAPU16[($5 + 138 | 0) >> 1] | 0;
  $7 = Math_imul($3, 12);
  $1 = Math_imul($6, 12) - $7 | 0;
  $8 = $3 + -1 | 0;
  $3 = ($5 + $7 | 0) + 4 | 0;
  $9 = 1;
  label$1 : {
   label$2 : while (1) {
    label$3 : {
     if ($1) {
      break label$3
     }
     $8 = $6;
     break label$1;
    }
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($4 + 8 | 0 | 0, $2 | 0);
    $5 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    $7 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($4 | 0, $3 | 0);
    $8 = $8 + 1 | 0;
    $1 = $1 + -12 | 0;
    $3 = $3 + 12 | 0;
    $5 = core__slice__cmp___impl_20core__cmp__Ord_20for_20_5bT_5d___cmp__h1f2092e0ba2f27ea($7 | 0, $5 | 0, HEAP32[$4 >> 2] | 0 | 0, HEAP32[($4 + 4 | 0) >> 2] | 0 | 0) | 0;
    if (($5 & 255 | 0 | 0) == (1 | 0)) {
     continue label$2
    }
    break label$2;
   };
   label$4 : {
    $9 = ($5 << 24 | 0) >> 24 | 0;
    switch ($9 + 1 | 0 | 0) {
    case 1:
     break label$1;
    default:
     break label$4;
    };
   }
   $9 = 1;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $8;
  HEAP32[$0 >> 2] = $9;
  global$0 = $4 + 16 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__SerializeEmbeddedGroup_20for_20cardano_serialization_lib__ScriptPubkey___serialize_as_embedded_group__h1b6a4a5cfee24716($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $11 = 0, $4 = 0, $24 = 0, $30 = 0, $33 = 0;
  $3 = global$0 - 80 | 0;
  global$0 = $3;
  i64toi32_i32$0 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 0 | 0, i64toi32_i32$0 | 0);
  $4 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     $11 = $1 + 24 | 0;
     HEAP32[(($3 + 48 | 0) + 24 | 0) >> 2] = HEAPU8[$11 >> 0] | 0 | ((HEAPU8[($11 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($11 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($11 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$2 = $1 + 16 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $24 = i64toi32_i32$0;
     i64toi32_i32$0 = ($3 + 48 | 0) + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $24;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $1 + 8 | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $30 = i64toi32_i32$1;
     i64toi32_i32$1 = ($3 + 48 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $30;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $1;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $33 = i64toi32_i32$0;
     i64toi32_i32$0 = $3;
     HEAP32[($3 + 48 | 0) >> 2] = $33;
     HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$1;
     cbor_event__se__Serializer_W___write_bytes__h5e3534de30c993f9($3 | 0, $2 | 0, $3 + 48 | 0 | 0);
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$2
     }
     HEAP32[($0 + 4 | 0) >> 2] = $2;
     $4 = 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $4 = 1;
  }
  HEAP32[$0 >> 2] = $4;
  global$0 = $3 + 80 | 0;
 }
 
 function cardano_serialization_lib__StakeDelegation__from_bytes__h040a0b769a54f011($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $14 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[($2 + 168 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 152 | 0) >> 2] = 0;
  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 160 | 0) >> 2] = $14;
  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__StakeDelegation___deserialize__h6b9919e2fbcd8be7($2 + 80 | 0 | 0, $2 + 152 | 0 | 0);
  $1 = ($2 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAPU8[($2 + 80 | 0) >> 0] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    memcpy($2 + 9 | 0 | 0, $2 + 80 | 0 | 1 | 0 | 0, 57 | 0) | 0;
    memcpy($0 + 1 | 0 | 0, $2 + 9 | 0 | 0, 57 | 0) | 0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 16 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0 + 4 | 0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[wasm2js_i32$0 >> 2] = wasm2js_i32$1;
  }
  HEAP8[$0 >> 0] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function mirtostakecredentials_insert($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $7$hi = 0, $8$hi = 0, $4 = 0, $5 = 0, $6 = 0, $7 = 0, $8 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hc5dfe90718757ef2($3 + 40 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $4 = HEAP32[($3 + 44 | 0) >> 2] | 0;
   $5 = HEAP32[($3 + 40 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h7d8a0640f2deb41e($3 + 32 | 0 | 0, $1 | 0);
   if (!$2) {
    break label$1
   }
   $0 = HEAP32[($3 + 36 | 0) >> 2] | 0;
   $6 = HEAP32[($3 + 32 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h8f4f32b29a620a40($3 + 24 | 0 | 0, $2 | 0);
   $1 = HEAP32[($3 + 28 | 0) >> 2] | 0;
   cardano_serialization_lib__MIRToStakeCredentials__insert__h359d09a35f3dc818($3 | 0, $5 | 0, $6 | 0, HEAP32[($3 + 24 | 0) >> 2] | 0 | 0);
   i64toi32_i32$2 = $3 + 16 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $7 = i64toi32_i32$0;
   $7$hi = i64toi32_i32$1;
   i64toi32_i32$2 = $3;
   i64toi32_i32$1 = HEAP32[($3 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($3 + 12 | 0) >> 2] | 0;
   $8 = i64toi32_i32$1;
   $8$hi = i64toi32_i32$0;
   i64toi32_i32$2 = $3;
   i64toi32_i32$0 = HEAP32[$3 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($3 + 4 | 0) >> 2] | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   $0 = 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($4 | 0, 0 | 0) | 0;
   label$2 : {
    if (!i64toi32_i32$0) {
     break label$2
    }
    i64toi32_i32$1 = $8$hi;
    i64toi32_i32$1 = $7$hi;
    i64toi32_i32$1 = $8$hi;
    i64toi32_i32$0 = $7$hi;
    $0 = $cardano_serialization_lib__utils__Int_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hac86427717971799($8 | 0, i64toi32_i32$1 | 0, $7 | 0, i64toi32_i32$0 | 0) | 0;
   }
   global$0 = $3 + 48 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function ipv6_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $8 = 0, $9 = 0, i64toi32_i32$2 = 0, $30 = 0, $58 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $30;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__Ipv6__from_bytes__he70f86e384c44faa($2 + 8 | 0 | 0, $2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 8 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  HEAP8[($2 + 63 | 0) >> 0] = HEAPU8[($2 + 24 | 0) >> 0] | 0;
  HEAP8[($2 + 50 | 0) >> 0] = HEAPU8[($2 + 11 | 0) >> 0] | 0;
  HEAP16[($2 + 48 | 0) >> 1] = HEAPU8[($2 + 9 | 0) >> 0] | 0 | ((HEAPU8[($2 + 10 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 51 | 0) >> 0] = $1;
  HEAP8[($2 + 52 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 53 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 54 | 0) >> 0] = $1 >>> 24 | 0;
  i64toi32_i32$2 = ($2 + 8 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $58 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  $8 = $58;
  HEAP8[($2 + 55 | 0) >> 0] = $8;
  HEAP8[($2 + 56 | 0) >> 0] = $8 >>> 8 | 0;
  HEAP8[($2 + 57 | 0) >> 0] = $8 >>> 16 | 0;
  HEAP8[($2 + 58 | 0) >> 0] = $8 >>> 24 | 0;
  $9 = i64toi32_i32$0;
  HEAP8[($2 + 59 | 0) >> 0] = $9;
  HEAP8[($2 + 60 | 0) >> 0] = $9 >>> 8 | 0;
  HEAP8[($2 + 61 | 0) >> 0] = $9 >>> 16 | 0;
  HEAP8[($2 + 62 | 0) >> 0] = $9 >>> 24 | 0;
  $1 = $cardano_serialization_lib__Ipv6_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h2867aea60f7881bf($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function ipv6_new($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $8 = 0, $9 = 0, i64toi32_i32$2 = 0, $30 = 0, $58 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $30;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__Ipv6__new__hbd44d20e73de6619($2 + 8 | 0 | 0, $2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 8 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  HEAP8[($2 + 63 | 0) >> 0] = HEAPU8[($2 + 24 | 0) >> 0] | 0;
  HEAP8[($2 + 50 | 0) >> 0] = HEAPU8[($2 + 11 | 0) >> 0] | 0;
  HEAP16[($2 + 48 | 0) >> 1] = HEAPU8[($2 + 9 | 0) >> 0] | 0 | ((HEAPU8[($2 + 10 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 51 | 0) >> 0] = $1;
  HEAP8[($2 + 52 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 53 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 54 | 0) >> 0] = $1 >>> 24 | 0;
  i64toi32_i32$2 = ($2 + 8 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $58 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  $8 = $58;
  HEAP8[($2 + 55 | 0) >> 0] = $8;
  HEAP8[($2 + 56 | 0) >> 0] = $8 >>> 8 | 0;
  HEAP8[($2 + 57 | 0) >> 0] = $8 >>> 16 | 0;
  HEAP8[($2 + 58 | 0) >> 0] = $8 >>> 24 | 0;
  $9 = i64toi32_i32$0;
  HEAP8[($2 + 59 | 0) >> 0] = $9;
  HEAP8[($2 + 60 | 0) >> 0] = $9 >>> 8 | 0;
  HEAP8[($2 + 61 | 0) >> 0] = $9 >>> 16 | 0;
  HEAP8[($2 + 62 | 0) >> 0] = $9 >>> 24 | 0;
  $1 = $cardano_serialization_lib__Ipv6_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h2867aea60f7881bf($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function core__mem__maybe_uninit__MaybeUninit_T___assume_init_drop__h4f9e4f10fdacfcee($0) {
  $0 = $0 | 0;
  var $1 = 0, $3 = 0, $2 = 0;
  label$1 : {
   label$2 : {
    switch (HEAP32[$0 >> 2] | 0 | 0) {
    default:
     $1 = $0 + 4 | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
     break label$1;
    case 0:
     $2 = $0 + 16 | 0;
     label$7 : {
      $3 = HEAP32[($0 + 24 | 0) >> 2] | 0;
      if (!$3) {
       break label$7
      }
      $1 = HEAP32[($0 + 16 | 0) >> 2] | 0;
      $3 = Math_imul($3, 48);
      label$8 : while (1) {
       core__ptr__drop_in_place_cardano_serialization_lib__plutus__PlutusData___hfab843e66e0f9428_2($1 | 0);
       $1 = $1 + 48 | 0;
       $3 = $3 + -48 | 0;
       if ($3) {
        continue label$8
       }
       break label$8;
      };
     }
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h36e817e704f6f25e($2 | 0);
     break label$1;
    case 1:
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h50a5c5eb0f530455($0 + 4 | 0 | 0);
     break label$1;
    case 2:
     $2 = $0 + 4 | 0;
     label$9 : {
      $3 = HEAP32[($0 + 12 | 0) >> 2] | 0;
      if (!$3) {
       break label$9
      }
      $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
      $3 = Math_imul($3, 48);
      label$10 : while (1) {
       core__ptr__drop_in_place_cardano_serialization_lib__plutus__PlutusData___hfab843e66e0f9428_2($1 | 0);
       $1 = $1 + 48 | 0;
       $3 = $3 + -48 | 0;
       if ($3) {
        continue label$10
       }
       break label$10;
      };
     }
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h36e817e704f6f25e($2 | 0);
     break label$1;
    case 3:
     break label$2;
    };
   }
   $1 = $0 + 4 | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h19f76bdb6b4883ef($1 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h970b13f6299e0f2d($1 | 0);
  }
  core__ptr__drop_in_place_core__option__Option_alloc__vec__Vec_u8_____ha5300c747747c3c8($0 + 32 | 0 | 0);
 }
 
 function transactionbuilder_get_explicit_input($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $37 = 0, $44 = 0, $49 = 0;
  $1 = global$0 - 96 | 0;
  global$0 = $1;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h37dfbd2f31d951c1($1 | 0, $0 | 0);
    $0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    alloc__collections__btree__map__BTreeMap_K_2cV___iter__h721110b568622f84($1 + 40 | 0 | 0, (HEAP32[$1 >> 2] | 0) + 160 | 0 | 0);
    HEAP32[($1 + 80 | 0) >> 2] = 0;
    i64toi32_i32$1 = $1;
    i64toi32_i32$0 = 0;
    HEAP32[($1 + 72 | 0) >> 2] = 0;
    HEAP32[($1 + 76 | 0) >> 2] = i64toi32_i32$0;
    $core__iter__adapters__map__Map_I_2cF__20as_20core__iter__traits__iterator__Iterator___try_fold__h995a63110091bbf7($1 + 8 | 0 | 0, $1 + 40 | 0 | 0, $1 + 72 | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    if ((HEAP32[($1 + 8 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    i64toi32_i32$2 = $1 + 32 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $37 = i64toi32_i32$0;
    i64toi32_i32$0 = ($1 + 40 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $37;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = ($1 + 8 | 0) + 16 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $44 = i64toi32_i32$1;
    i64toi32_i32$1 = ($1 + 40 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $44;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = ($1 + 8 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $49 = i64toi32_i32$0;
    i64toi32_i32$0 = $1;
    HEAP32[($1 + 40 | 0) >> 2] = $49;
    HEAP32[($1 + 44 | 0) >> 2] = i64toi32_i32$1;
    $0 = $cardano_serialization_lib__utils__Value_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h50a1108e1e08f966($1 + 40 | 0 | 0) | 0;
    global$0 = $1 + 96 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($1 + 12 | 0) >> 2] | 0 | 0);
  abort();
 }
 
 function cardano_serialization_lib__crypto__Bip32PrivateKey__from_bech32__hd3cda4d92126cdfa($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, i64toi32_i32$2 = 0, $13 = 0, $14 = 0, $15 = 0, $4 = 0, $4$hi = 0, $5 = 0, $5$hi = 0, $6 = 0, $6$hi = 0;
  $3 = global$0 - 208 | 0;
  global$0 = $3;
  $cardano_serialization_lib__chain_crypto__key__SecretKey_A__20as_20cardano_serialization_lib__chain_crypto__bech32__Bech32___try_from_bech32_str__h660bc6248fcb5d5a($3 + 104 | 0 | 0, $1 | 0, $2 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAPU8[($3 + 104 | 0) >> 0] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    memcpy($3 + 8 | 0 | 0, $3 + 104 | 0 | 1 | 0 | 0, 96 | 0) | 0;
    memcpy($0 + 1 | 0 | 0, $3 + 8 | 0 | 0, 96 | 0) | 0;
    $1 = 0;
    break label$1;
   }
   i64toi32_i32$2 = $3 + 124 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $4 = i64toi32_i32$0;
   $4$hi = i64toi32_i32$1;
   i64toi32_i32$0 = $3 + 27 | 0;
   $13 = $4;
   HEAP8[i64toi32_i32$0 >> 0] = $13;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $13 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $13 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $13 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = $3 + 116 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $5 = i64toi32_i32$1;
   $5$hi = i64toi32_i32$0;
   i64toi32_i32$1 = $3 + 19 | 0;
   $14 = $5;
   HEAP8[i64toi32_i32$1 >> 0] = $14;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $14 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $14 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $14 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $3;
   i64toi32_i32$0 = HEAP32[($3 + 108 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($3 + 112 | 0) >> 2] | 0;
   $6 = i64toi32_i32$0;
   $6$hi = i64toi32_i32$1;
   i64toi32_i32$0 = $3;
   $15 = $6;
   HEAP8[(i64toi32_i32$0 + 11 | 0) >> 0] = $15;
   HEAP8[(i64toi32_i32$0 + 12 | 0) >> 0] = $15 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 13 | 0) >> 0] = $15 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 14 | 0) >> 0] = $15 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 15 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 16 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 17 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 18 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$1 = $4$hi;
   i64toi32_i32$0 = i64toi32_i32$0 + 120 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $13;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $5$hi;
   i64toi32_i32$0 = $3 + 112 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $14;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $6$hi;
   i64toi32_i32$0 = $3;
   HEAP32[(i64toi32_i32$0 + 104 | 0) >> 2] = $15;
   HEAP32[(i64toi32_i32$0 + 108 | 0) >> 2] = i64toi32_i32$1;
   $2 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1066512 | 0, 18 | 0) | 0;
   core__ptr__drop_in_place_cardano_serialization_lib__chain_crypto__bech32__Error___hc63804c7ffa39d5a(i64toi32_i32$0 + 104 | 0 | 0);
   HEAP32[($0 + 4 | 0) >> 2] = $2;
  }
  HEAP8[$0 >> 0] = $1;
  global$0 = $3 + 208 | 0;
 }
 
 function cardano_serialization_lib__crypto__Nonce__from_bytes__hff37fe8e771f5387($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $14 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[($2 + 168 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 152 | 0) >> 2] = 0;
  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 160 | 0) >> 2] = $14;
  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__crypto__Nonce_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h5cb63bdaa73c6bd6($2 + 80 | 0 | 0, $2 + 152 | 0 | 0);
  $1 = ($2 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAPU8[($2 + 80 | 0) >> 0] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    memcpy($2 + 9 | 0 | 0, $2 + 80 | 0 | 1 | 0 | 0, 33 | 0) | 0;
    memcpy($0 + 1 | 0 | 0, $2 + 9 | 0 | 0, 33 | 0) | 0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 16 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0 + 4 | 0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[wasm2js_i32$0 >> 2] = wasm2js_i32$1;
  }
  HEAP8[$0 >> 0] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function vrfcert_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $30 = 0, $45 = 0, $57 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 40 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 56 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 40 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 40 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 44 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 56 | 0) >> 2] = $30;
  HEAP32[($2 + 60 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__crypto__VRFCert__from_bytes__h505c8666ae31ef7b($2 + 8 | 0 | 0, $2 + 56 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = $2 + 24 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $45 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 68 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $45;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 76 | 0) >> 2] = HEAP32[($2 + 32 | 0) >> 2] | 0;
  HEAP32[($2 + 56 | 0) >> 2] = $1;
  i64toi32_i32$2 = ($2 + 8 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $57 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 60 | 0) >> 2] = $57;
  HEAP32[($2 + 64 | 0) >> 2] = i64toi32_i32$1;
  $1 = $cardano_serialization_lib__crypto__VRFCert_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hc597ed79f1e184d4($2 + 56 | 0 | 0) | 0;
  global$0 = $2 + 80 | 0;
  return $1 | 0;
 }
 
 function ryu__d2s__decimal_length17__h8f99f1fcbf14e8a2($0, $0$hi) {
  $0 = $0 | 0;
  $0$hi = $0$hi | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $1 = 0;
  $1 = 17;
  label$1 : {
   i64toi32_i32$0 = $0$hi;
   i64toi32_i32$2 = $0;
   i64toi32_i32$1 = 2328306;
   i64toi32_i32$3 = 1874919423;
   if (i64toi32_i32$0 >>> 0 > i64toi32_i32$1 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$2 >>> 0 > i64toi32_i32$3 >>> 0 | 0) | 0) {
    break label$1
   }
   $1 = 16;
   i64toi32_i32$2 = $0$hi;
   i64toi32_i32$3 = $0;
   i64toi32_i32$0 = 232830;
   i64toi32_i32$1 = -1530494976;
   if (i64toi32_i32$2 >>> 0 > i64toi32_i32$0 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$3 >>> 0 >= i64toi32_i32$1 >>> 0 | 0) | 0) {
    break label$1
   }
   $1 = 15;
   i64toi32_i32$3 = $0$hi;
   i64toi32_i32$1 = $0;
   i64toi32_i32$2 = 23283;
   i64toi32_i32$0 = 276447231;
   if (i64toi32_i32$3 >>> 0 > i64toi32_i32$2 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$1 >>> 0 > i64toi32_i32$0 >>> 0 | 0) | 0) {
    break label$1
   }
   $1 = 14;
   i64toi32_i32$1 = $0$hi;
   i64toi32_i32$0 = $0;
   i64toi32_i32$3 = 2328;
   i64toi32_i32$2 = 1316134911;
   if (i64toi32_i32$1 >>> 0 > i64toi32_i32$3 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$0 >>> 0 > i64toi32_i32$2 >>> 0 | 0) | 0) {
    break label$1
   }
   $1 = 13;
   i64toi32_i32$0 = $0$hi;
   i64toi32_i32$2 = $0;
   i64toi32_i32$1 = 232;
   i64toi32_i32$3 = -727379969;
   if (i64toi32_i32$0 >>> 0 > i64toi32_i32$1 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$2 >>> 0 > i64toi32_i32$3 >>> 0 | 0) | 0) {
    break label$1
   }
   $1 = 12;
   i64toi32_i32$2 = $0$hi;
   i64toi32_i32$3 = $0;
   i64toi32_i32$0 = 23;
   i64toi32_i32$1 = 1215752191;
   if (i64toi32_i32$2 >>> 0 > i64toi32_i32$0 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$3 >>> 0 > i64toi32_i32$1 >>> 0 | 0) | 0) {
    break label$1
   }
   $1 = 11;
   i64toi32_i32$3 = $0$hi;
   i64toi32_i32$1 = $0;
   i64toi32_i32$2 = 2;
   i64toi32_i32$0 = 1410065407;
   if (i64toi32_i32$3 >>> 0 > i64toi32_i32$2 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$1 >>> 0 > i64toi32_i32$0 >>> 0 | 0) | 0) {
    break label$1
   }
   $1 = 10;
   i64toi32_i32$1 = $0$hi;
   i64toi32_i32$0 = $0;
   i64toi32_i32$3 = 0;
   i64toi32_i32$2 = 999999999;
   if (i64toi32_i32$1 >>> 0 > i64toi32_i32$3 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$0 >>> 0 > i64toi32_i32$2 >>> 0 | 0) | 0) {
    break label$1
   }
   $1 = 9;
   i64toi32_i32$0 = $0$hi;
   i64toi32_i32$2 = $0;
   i64toi32_i32$1 = 0;
   i64toi32_i32$3 = 99999999;
   if (i64toi32_i32$0 >>> 0 > i64toi32_i32$1 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$2 >>> 0 > i64toi32_i32$3 >>> 0 | 0) | 0) {
    break label$1
   }
   $1 = 8;
   i64toi32_i32$2 = $0$hi;
   i64toi32_i32$3 = $0;
   i64toi32_i32$0 = 0;
   i64toi32_i32$1 = 9999999;
   if (i64toi32_i32$2 >>> 0 > i64toi32_i32$0 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$3 >>> 0 > i64toi32_i32$1 >>> 0 | 0) | 0) {
    break label$1
   }
   $1 = 7;
   i64toi32_i32$3 = $0$hi;
   i64toi32_i32$1 = $0;
   i64toi32_i32$2 = 0;
   i64toi32_i32$0 = 999999;
   if (i64toi32_i32$3 >>> 0 > i64toi32_i32$2 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$1 >>> 0 > i64toi32_i32$0 >>> 0 | 0) | 0) {
    break label$1
   }
   $1 = 6;
   i64toi32_i32$1 = $0$hi;
   i64toi32_i32$0 = $0;
   i64toi32_i32$3 = 0;
   i64toi32_i32$2 = 99999;
   if (i64toi32_i32$1 >>> 0 > i64toi32_i32$3 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$0 >>> 0 > i64toi32_i32$2 >>> 0 | 0) | 0) {
    break label$1
   }
   $1 = 5;
   i64toi32_i32$0 = $0$hi;
   i64toi32_i32$2 = $0;
   i64toi32_i32$1 = 0;
   i64toi32_i32$3 = 9999;
   if (i64toi32_i32$0 >>> 0 > i64toi32_i32$1 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$2 >>> 0 > i64toi32_i32$3 >>> 0 | 0) | 0) {
    break label$1
   }
   $1 = 4;
   i64toi32_i32$2 = $0$hi;
   i64toi32_i32$3 = $0;
   i64toi32_i32$0 = 0;
   i64toi32_i32$1 = 999;
   if (i64toi32_i32$2 >>> 0 > i64toi32_i32$0 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$3 >>> 0 > i64toi32_i32$1 >>> 0 | 0) | 0) {
    break label$1
   }
   $1 = 3;
   i64toi32_i32$3 = $0$hi;
   i64toi32_i32$1 = $0;
   i64toi32_i32$2 = 0;
   i64toi32_i32$0 = 99;
   if (i64toi32_i32$3 >>> 0 > i64toi32_i32$2 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$1 >>> 0 > i64toi32_i32$0 >>> 0 | 0) | 0) {
    break label$1
   }
   i64toi32_i32$1 = $0$hi;
   i64toi32_i32$0 = $0;
   i64toi32_i32$3 = 0;
   i64toi32_i32$2 = 9;
   return (i64toi32_i32$1 >>> 0 > i64toi32_i32$3 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$0 >>> 0 > i64toi32_i32$2 >>> 0 | 0) | 0 ? 2 : 1) | 0;
  }
  return $1 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__h548407c65b84dfc0($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$1 = 0, $7 = 0, $4 = 0, $6 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $5 = 0, $35 = 0, $59 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = HEAPU16[($4 + 138 | 0) >> 1] | 0;
  $6 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $1 = $5 + ($6 ^ -1 | 0) | 0;
  HEAP16[($2 + 138 | 0) >> 1] = $1;
  $7 = $4 + Math_imul($6, 12) | 0;
  HEAP32[($3 + 8 | 0) >> 2] = HEAP32[($7 + 12 | 0) >> 2] | 0;
  i64toi32_i32$2 = $7 + 4 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $35 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[$3 >> 2] = $35;
  HEAP32[($3 + 4 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    if ($1 >>> 0 >= 12 >>> 0) {
     break label$2
    }
    $7 = $6 + 1 | 0;
    if (($5 - $7 | 0 | 0) != ($1 | 0)) {
     break label$1
    }
    memcpy($2 + 4 | 0 | 0, ($4 + Math_imul($7, 12) | 0) + 4 | 0 | 0, Math_imul($1, 12) | 0) | 0;
    HEAP16[($4 + 138 | 0) >> 1] = $6;
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAP32[$3 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($3 + 4 | 0) >> 2] | 0;
    $59 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[i64toi32_i32$1 >> 2] = $59;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[($3 + 8 | 0) >> 2] | 0;
    global$0 = $3 + 16 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($1 | 0, 11 | 0, 1049044 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1048988 | 0, 40 | 0, 1049028 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__h7f55eb089e806801($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$1 = 0, $7 = 0, $4 = 0, $6 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $5 = 0, $35 = 0, $59 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = HEAPU16[($4 + 138 | 0) >> 1] | 0;
  $6 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $1 = $5 + ($6 ^ -1 | 0) | 0;
  HEAP16[($2 + 138 | 0) >> 1] = $1;
  $7 = $4 + Math_imul($6, 12) | 0;
  HEAP32[($3 + 8 | 0) >> 2] = HEAP32[($7 + 12 | 0) >> 2] | 0;
  i64toi32_i32$2 = $7 + 4 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $35 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[$3 >> 2] = $35;
  HEAP32[($3 + 4 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    if ($1 >>> 0 >= 12 >>> 0) {
     break label$2
    }
    $7 = $6 + 1 | 0;
    if (($5 - $7 | 0 | 0) != ($1 | 0)) {
     break label$1
    }
    memcpy($2 + 4 | 0 | 0, ($4 + Math_imul($7, 12) | 0) + 4 | 0 | 0, Math_imul($1, 12) | 0) | 0;
    HEAP16[($4 + 138 | 0) >> 1] = $6;
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAP32[$3 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($3 + 4 | 0) >> 2] | 0;
    $59 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[i64toi32_i32$1 >> 2] = $59;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[($3 + 8 | 0) >> 2] | 0;
    global$0 = $3 + 16 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($1 | 0, 11 | 0, 1049044 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1048988 | 0, 40 | 0, 1049028 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__h825ff1a7b9ded94b($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$1 = 0, $7 = 0, $4 = 0, $6 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $5 = 0, $35 = 0, $59 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = HEAPU16[($4 + 138 | 0) >> 1] | 0;
  $6 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $1 = $5 + ($6 ^ -1 | 0) | 0;
  HEAP16[($2 + 138 | 0) >> 1] = $1;
  $7 = $4 + Math_imul($6, 12) | 0;
  HEAP32[($3 + 8 | 0) >> 2] = HEAP32[($7 + 12 | 0) >> 2] | 0;
  i64toi32_i32$2 = $7 + 4 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $35 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[$3 >> 2] = $35;
  HEAP32[($3 + 4 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    if ($1 >>> 0 >= 12 >>> 0) {
     break label$2
    }
    $7 = $6 + 1 | 0;
    if (($5 - $7 | 0 | 0) != ($1 | 0)) {
     break label$1
    }
    memcpy($2 + 4 | 0 | 0, ($4 + Math_imul($7, 12) | 0) + 4 | 0 | 0, Math_imul($1, 12) | 0) | 0;
    HEAP16[($4 + 138 | 0) >> 1] = $6;
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAP32[$3 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($3 + 4 | 0) >> 2] | 0;
    $59 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[i64toi32_i32$1 >> 2] = $59;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[($3 + 8 | 0) >> 2] | 0;
    global$0 = $3 + 16 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($1 | 0, 11 | 0, 1049044 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1048988 | 0, 40 | 0, 1049028 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__hfcd0ac642c531a4c($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$1 = 0, $7 = 0, $4 = 0, $6 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $5 = 0, $35 = 0, $59 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = HEAPU16[($4 + 138 | 0) >> 1] | 0;
  $6 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $1 = $5 + ($6 ^ -1 | 0) | 0;
  HEAP16[($2 + 138 | 0) >> 1] = $1;
  $7 = $4 + Math_imul($6, 12) | 0;
  HEAP32[($3 + 8 | 0) >> 2] = HEAP32[($7 + 12 | 0) >> 2] | 0;
  i64toi32_i32$2 = $7 + 4 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $35 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[$3 >> 2] = $35;
  HEAP32[($3 + 4 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    if ($1 >>> 0 >= 12 >>> 0) {
     break label$2
    }
    $7 = $6 + 1 | 0;
    if (($5 - $7 | 0 | 0) != ($1 | 0)) {
     break label$1
    }
    memcpy($2 + 4 | 0 | 0, ($4 + Math_imul($7, 12) | 0) + 4 | 0 | 0, Math_imul($1, 12) | 0) | 0;
    HEAP16[($4 + 138 | 0) >> 1] = $6;
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAP32[$3 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($3 + 4 | 0) >> 2] | 0;
    $59 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[i64toi32_i32$1 >> 2] = $59;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[($3 + 8 | 0) >> 2] | 0;
    global$0 = $3 + 16 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($1 | 0, 11 | 0, 1049044 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1048988 | 0, 40 | 0, 1049028 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_fit__hce777c9c912093df($0, $1, $2, $2$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  var i64toi32_i32$0 = 0, $3 = 0, i64toi32_i32$1 = 0, $5 = 0, $6 = 0, $7 = 0, $4 = 0, $8 = 0, $9 = 0, $29 = 0, $58 = 0;
  $3 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $0 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  $4 = Math_imul($0, 12);
  $5 = ($3 + $4 | 0) + 92 | 0;
  label$1 : {
   label$2 : {
    $6 = $0 + 1 | 0;
    $7 = HEAPU16[($3 + 226 | 0) >> 1] | 0;
    if ($6 >>> 0 <= $7 >>> 0) {
     break label$2
    }
    i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $29 = i64toi32_i32$0;
    i64toi32_i32$0 = $5;
    HEAP32[i64toi32_i32$0 >> 2] = $29;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
    break label$1;
   }
   $8 = $3 + 92 | 0;
   $9 = $7 - $0 | 0;
   memmove($8 + Math_imul($6, 12) | 0 | 0, $5 | 0, Math_imul($9, 12) | 0) | 0;
   $5 = $8 + $4 | 0;
   HEAP32[($5 + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   $58 = i64toi32_i32$1;
   i64toi32_i32$1 = $5;
   HEAP32[i64toi32_i32$1 >> 2] = $58;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   memmove($3 + ($6 << 3 | 0) | 0 | 0, $3 + ($0 << 3 | 0) | 0 | 0, $9 << 3 | 0 | 0) | 0;
  }
  $0 = $3 + ($0 << 3 | 0) | 0;
  i64toi32_i32$0 = $2$hi;
  i64toi32_i32$1 = $0;
  HEAP32[$0 >> 2] = $2;
  HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP16[($3 + 226 | 0) >> 1] = $7 + 1 | 0;
  return $0 | 0;
 }
 
 function alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__h81af513058d3de2b($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $6 = 0, $7 = 0, $9 = 0, $5 = 0, $8 = 0;
  $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = HEAPU16[($4 + 1458 | 0) >> 1] | 0;
  $6 = Math_imul($3, 36);
  $1 = Math_imul($5, 36) - $6 | 0;
  $7 = $3 + -1 | 0;
  $8 = $2 + 4 | 0;
  $3 = ($4 + $6 | 0) + 1060 | 0;
  $9 = 1;
  label$1 : {
   label$2 : while (1) {
    label$3 : {
     if ($1) {
      break label$3
     }
     $7 = $5;
     break label$1;
    }
    label$4 : {
     $4 = core__slice__cmp___impl_20core__cmp__Ord_20for_20_5bT_5d___cmp__h1f2092e0ba2f27ea($8 | 0, 32 | 0, $3 + 4 | 0 | 0, 32 | 0) | 0;
     if ($4 & 255 | 0) {
      break label$4
     }
     $4 = HEAP32[$2 >> 2] | 0;
     $6 = HEAP32[$3 >> 2] | 0;
     $4 = $4 >>> 0 < $6 >>> 0 ? -1 : ($4 | 0) != ($6 | 0);
    }
    $3 = $3 + 36 | 0;
    $7 = $7 + 1 | 0;
    $1 = $1 + -36 | 0;
    if (($4 & 255 | 0 | 0) == (1 | 0)) {
     continue label$2
    }
    break label$2;
   };
   label$5 : {
    $9 = ($4 << 24 | 0) >> 24 | 0;
    switch ($9 + 1 | 0 | 0) {
    case 1:
     break label$1;
    default:
     break label$5;
    };
   }
   $9 = 1;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $7;
  HEAP32[$0 >> 2] = $9;
 }
 
 function stakedelegation_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 80 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 96 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 80 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 84 | 0) >> 2] | 0;
  HEAP32[($2 + 96 | 0) >> 2] = HEAP32[($2 + 80 | 0) >> 2] | 0;
  HEAP32[($2 + 100 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__StakeDelegation__from_bytes__h040a0b769a54f011($2 + 16 | 0 | 0, $2 + 96 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 16 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  HEAP8[($2 + 98 | 0) >> 0] = HEAPU8[($2 + 19 | 0) >> 0] | 0;
  HEAP16[($2 + 96 | 0) >> 1] = HEAPU8[($2 + 17 | 0) >> 0] | 0 | ((HEAPU8[($2 + 18 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 99 | 0) >> 0] = $1;
  HEAP8[($2 + 100 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 101 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 102 | 0) >> 0] = $1 >>> 24 | 0;
  memcpy($2 + 96 | 0 | 7 | 0 | 0, ($2 + 16 | 0) + 8 | 0 | 0, 50 | 0) | 0;
  $1 = $cardano_serialization_lib__StakeDelegation_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hfbbb778a4aa15e31($2 + 96 | 0 | 0) | 0;
  global$0 = $2 + 160 | 0;
  return $1 | 0;
 }
 
 function poolretirement_new($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $15 = 0, $3 = 0, $4 = 0, $5 = 0, $21 = 0, $28 = 0, $38 = 0, $49 = 0, $53 = 0, $62 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hae9c55c4e91ce40f($2 + 8 | 0 | 0, $0 | 0);
  $3 = ($2 + 16 | 0) + 8 | 0;
  $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $0 + 8 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $21 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $21;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $4 = ($2 + 16 | 0) + 16 | 0;
  i64toi32_i32$2 = $0 + 16 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $4;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $5 = ($2 + 16 | 0) + 24 | 0;
  $15 = $0 + 24 | 0;
  HEAP32[$5 >> 2] = HEAPU8[$15 >> 0] | 0 | ((HEAPU8[($15 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($15 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($15 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $38 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $38;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$1;
  $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $49 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 60 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $49;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $53 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 68 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $53;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($2 + 76 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
  HEAP32[($2 + 48 | 0) >> 2] = $1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $62 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = $62;
  HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] = i64toi32_i32$0;
  $0 = $cardano_serialization_lib__PoolRetirement_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hc280b71a1ce0ea8e(i64toi32_i32$2 + 48 | 0 | 0) | 0;
  global$0 = i64toi32_i32$2 + 80 | 0;
  return $0 | 0;
 }
 
 function cardano_serialization_lib__Relay__new_single_host_addr__h6e0bfeec124ad2be($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $22 = 0, $23 = 0, $24 = 0, $2 = 0, $4 = 0, $7 = 0, $25 = 0, $8$hi = 0, $26 = 0, $28 = 0, $29 = 0, $3 = 0, $5 = 0, $6 = 0, $27 = 0, $31 = 0, $35 = 0, $40 = 0, $42 = 0, $8 = 0, $57 = 0, $57$hi = 0;
  $2 = global$0 - 16 | 0;
  $22 = $1 + 5 | 0;
  $3 = HEAPU8[$22 >> 0] | 0 | ((HEAPU8[($22 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($22 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($22 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $4 = HEAPU8[($1 + 4 | 0) >> 0] | 0;
  $5 = HEAPU16[($1 + 2 | 0) >> 1] | 0;
  $6 = HEAPU16[$1 >> 1] | 0;
  $7 = 0;
  label$1 : {
   if ((HEAPU8[($1 + 9 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   i64toi32_i32$2 = $1 + 18 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $27 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $27;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1 + 10 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $31 = i64toi32_i32$1;
   i64toi32_i32$1 = $2;
   HEAP32[i64toi32_i32$1 >> 2] = $31;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   $7 = 1;
  }
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $35 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 12 | 0;
  $23 = $35;
  HEAP8[i64toi32_i32$0 >> 0] = $23;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $23 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $23 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $23 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $40 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 20 | 0;
  $24 = $40;
  HEAP8[i64toi32_i32$1 >> 0] = $24;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $24 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $24 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $24 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $42 = $0 + 10 | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 8;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $25 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $25 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  i64toi32_i32$4 = ($4 & 255 | 0 | 0) == (1 | 0);
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = i64toi32_i32$4 ? $25 : 0;
  i64toi32_i32$0 = i64toi32_i32$4 ? i64toi32_i32$1 : i64toi32_i32$2;
  $8 = i64toi32_i32$3;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$4 = i64toi32_i32$3;
  i64toi32_i32$3 = 0;
  i64toi32_i32$1 = 32;
  i64toi32_i32$2 = i64toi32_i32$1 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
   i64toi32_i32$3 = 0;
   $26 = i64toi32_i32$0 >>> i64toi32_i32$2 | 0;
  } else {
   i64toi32_i32$3 = i64toi32_i32$0 >>> i64toi32_i32$2 | 0;
   $26 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$2 | 0) | 0;
  }
  HEAP8[$42 >> 0] = $26;
  i64toi32_i32$3 = $8$hi;
  i64toi32_i32$3 = 0;
  i64toi32_i32$0 = $4;
  i64toi32_i32$4 = 0;
  i64toi32_i32$1 = 255;
  i64toi32_i32$4 = i64toi32_i32$3 & i64toi32_i32$4 | 0;
  $57 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
  $57$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$3 = $8;
  i64toi32_i32$0 = $57$hi;
  i64toi32_i32$1 = $57;
  i64toi32_i32$0 = i64toi32_i32$4 | i64toi32_i32$0 | 0;
  $28 = $0 + 6 | 0;
  $29 = i64toi32_i32$3 | i64toi32_i32$1 | 0;
  HEAP16[$28 >> 1] = $29;
  HEAP16[($28 + 2 | 0) >> 1] = $29 >>> 16 | 0;
  HEAP8[($0 + 11 | 0) >> 0] = $7;
  HEAP16[($0 + 4 | 0) >> 1] = $5;
  HEAP16[($0 + 2 | 0) >> 1] = $6;
  HEAP16[$0 >> 1] = 0;
 }
 
 function nativescript_new_script_pubkey($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $2 = 0, $3 = 0, $4 = 0, $20 = 0, $27 = 0, $37 = 0, $48 = 0, $52 = 0, $60 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h5bcc7e1da6f9ff93($1 + 8 | 0 | 0, $0 | 0);
  $2 = ($1 + 16 | 0) + 8 | 0;
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $0 + 8 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $20;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $3 = ($1 + 16 | 0) + 16 | 0;
  i64toi32_i32$2 = $0 + 16 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $27 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[i64toi32_i32$1 >> 2] = $27;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = ($1 + 16 | 0) + 24 | 0;
  $14 = $0 + 24 | 0;
  HEAP32[$4 >> 2] = HEAPU8[$14 >> 0] | 0 | ((HEAPU8[($14 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($14 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($14 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $37 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 16 | 0) >> 2] = $37;
  HEAP32[($1 + 20 | 0) >> 2] = i64toi32_i32$1;
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $48 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 57 | 0;
  $15 = $48;
  HEAP8[i64toi32_i32$1 >> 0] = $15;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $15 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $15 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $15 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $52 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 65 | 0;
  $16 = $52;
  HEAP8[i64toi32_i32$0 >> 0] = $16;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $16 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $17 = $1 + 73 | 0;
  $18 = HEAP32[$4 >> 2] | 0;
  HEAP8[$17 >> 0] = $18;
  HEAP8[($17 + 1 | 0) >> 0] = $18 >>> 8 | 0;
  HEAP8[($17 + 2 | 0) >> 0] = $18 >>> 16 | 0;
  HEAP8[($17 + 3 | 0) >> 0] = $18 >>> 24 | 0;
  HEAP8[($1 + 48 | 0) >> 0] = 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $60 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  $19 = $60;
  HEAP8[(i64toi32_i32$2 + 49 | 0) >> 0] = $19;
  HEAP8[(i64toi32_i32$2 + 50 | 0) >> 0] = $19 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 51 | 0) >> 0] = $19 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 52 | 0) >> 0] = $19 >>> 24 | 0;
  HEAP8[(i64toi32_i32$2 + 53 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$2 + 54 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 55 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 56 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $0 = $cardano_serialization_lib__NativeScript_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h345d8ecbe77ecc63(i64toi32_i32$2 + 48 | 0 | 0) | 0;
  global$0 = i64toi32_i32$2 + 80 | 0;
  return $0 | 0;
 }
 
 function $_28_A_2c_B_2c_C_29_20as_20cbor_event__se__Serialize___serialize__h1186f7f09544497e($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 144 | 0;
  global$0 = $3;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 + 96 | 0 | 0, $2 | 0, 4 | 0, 3 | 0, 0 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[($3 + 96 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     $cbor_event__value__Value_20as_20cbor_event__se__Serialize___serialize__h3484ce8083eba035($3 + 48 | 0 | 0, HEAP32[$1 >> 2] | 0 | 0, HEAP32[($3 + 100 | 0) >> 2] | 0 | 0);
     if ((HEAP32[($3 + 48 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$2
     }
     $cardano_serialization_lib__legacy_address__address__Attributes_20as_20cbor_event__se__Serialize___serialize__haf99c3c1d66b9efa($3 | 0, HEAP32[($1 + 4 | 0) >> 2] | 0 | 0, HEAP32[($3 + 52 | 0) >> 2] | 0 | 0);
     label$4 : {
      if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      $cardano_serialization_lib__legacy_address__address__AddrType_20as_20cbor_event__se__Serialize___serialize__hfd384f59239299b2($0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0, HEAP32[($3 + 4 | 0) >> 2] | 0 | 0);
      break label$1;
     }
     memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
     HEAP32[$0 >> 2] = 1;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, ($3 + 96 | 0) + 8 | 0 | 0, 40 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, ($3 + 48 | 0) + 8 | 0 | 0, 40 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $3 + 144 | 0;
 }
 
 function cardano_serialization_lib__utils__Value__clamped_sub__haa8c5f6481344bb0($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, i64toi32_i32$5 = 0, i64toi32_i32$3 = 0, $5 = 0, $5$hi = 0, $4 = 0, $6$hi = 0, $6 = 0, $44 = 0, $58 = 0;
  $3 = global$0 - 32 | 0;
  global$0 = $3;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $6 = i64toi32_i32$1;
  $6$hi = i64toi32_i32$0;
  $4 = 0;
  label$1 : {
   if ((HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   $1 = $1 + 12 | 0;
   label$2 : {
    if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($3 + 4 | 0 | 0, $1 | 0);
    $4 = 1;
    break label$1;
   }
   $2 = $2 + 12 | 0;
   cardano_serialization_lib__MultiAsset__sub__h87ca73850e5358bf($3 + 16 | 0 | 0, $1 | 0, $2 | 0);
   label$3 : {
    label$4 : {
     if (HEAP32[($3 + 24 | 0) >> 2] | 0) {
      break label$4
     }
     $4 = 0;
     break label$3;
    }
    cardano_serialization_lib__MultiAsset__sub__h87ca73850e5358bf($3 + 4 | 0 | 0, $1 | 0, $2 | 0);
    $4 = 1;
   }
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($3 + 16 | 0 | 0);
  }
  HEAP32[($0 + 8 | 0) >> 2] = $4;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  $44 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 12 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $44;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($0 + 20 | 0) >> 2] = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$1 = $5$hi;
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$2 = $6;
  i64toi32_i32$0 = $5$hi;
  i64toi32_i32$3 = $5;
  i64toi32_i32$5 = (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) + i64toi32_i32$0 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 - i64toi32_i32$5 | 0;
  $5 = i64toi32_i32$2 - i64toi32_i32$3 | 0;
  $5$hi = i64toi32_i32$5;
  i64toi32_i32$5 = i64toi32_i32$1;
  i64toi32_i32$5 = $5$hi;
  i64toi32_i32$1 = $5;
  i64toi32_i32$2 = $6$hi;
  i64toi32_i32$3 = $6;
  i64toi32_i32$0 = i64toi32_i32$5 >>> 0 > i64toi32_i32$2 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$1 >>> 0 > i64toi32_i32$3 >>> 0 | 0) | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$2 = i64toi32_i32$0 ? 0 : $5;
  i64toi32_i32$3 = i64toi32_i32$0 ? i64toi32_i32$1 : i64toi32_i32$5;
  $58 = i64toi32_i32$2;
  i64toi32_i32$2 = $0;
  HEAP32[i64toi32_i32$2 >> 2] = $58;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
  global$0 = $3 + 32 | 0;
 }
 
 function stakecredential_from_keyhash($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $2 = 0, $3 = 0, $4 = 0, $20 = 0, $27 = 0, $37 = 0, $48 = 0, $52 = 0, $60 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hae9c55c4e91ce40f($1 + 8 | 0 | 0, $0 | 0);
  $2 = ($1 + 16 | 0) + 8 | 0;
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $0 + 8 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $20;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $3 = ($1 + 16 | 0) + 16 | 0;
  i64toi32_i32$2 = $0 + 16 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $27 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[i64toi32_i32$1 >> 2] = $27;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = ($1 + 16 | 0) + 24 | 0;
  $14 = $0 + 24 | 0;
  HEAP32[$4 >> 2] = HEAPU8[$14 >> 0] | 0 | ((HEAPU8[($14 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($14 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($14 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $37 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 16 | 0) >> 2] = $37;
  HEAP32[($1 + 20 | 0) >> 2] = i64toi32_i32$1;
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $48 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 57 | 0;
  $15 = $48;
  HEAP8[i64toi32_i32$1 >> 0] = $15;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $15 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $15 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $15 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $52 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 65 | 0;
  $16 = $52;
  HEAP8[i64toi32_i32$0 >> 0] = $16;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $16 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $17 = $1 + 73 | 0;
  $18 = HEAP32[$4 >> 2] | 0;
  HEAP8[$17 >> 0] = $18;
  HEAP8[($17 + 1 | 0) >> 0] = $18 >>> 8 | 0;
  HEAP8[($17 + 2 | 0) >> 0] = $18 >>> 16 | 0;
  HEAP8[($17 + 3 | 0) >> 0] = $18 >>> 24 | 0;
  HEAP8[($1 + 48 | 0) >> 0] = 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $60 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  $19 = $60;
  HEAP8[(i64toi32_i32$2 + 49 | 0) >> 0] = $19;
  HEAP8[(i64toi32_i32$2 + 50 | 0) >> 0] = $19 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 51 | 0) >> 0] = $19 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 52 | 0) >> 0] = $19 >>> 24 | 0;
  HEAP8[(i64toi32_i32$2 + 53 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$2 + 54 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 55 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 56 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $0 = $cardano_serialization_lib__address__StakeCredential_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hfe6826a4b7739a89(i64toi32_i32$2 + 48 | 0 | 0) | 0;
  global$0 = i64toi32_i32$2 + 80 | 0;
  return $0 | 0;
 }
 
 function stakecredential_from_scripthash($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $2 = 0, $3 = 0, $4 = 0, $20 = 0, $27 = 0, $37 = 0, $48 = 0, $52 = 0, $60 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h27da893e95dd15cf($1 + 8 | 0 | 0, $0 | 0);
  $2 = ($1 + 16 | 0) + 8 | 0;
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $0 + 8 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $20;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $3 = ($1 + 16 | 0) + 16 | 0;
  i64toi32_i32$2 = $0 + 16 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $27 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[i64toi32_i32$1 >> 2] = $27;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = ($1 + 16 | 0) + 24 | 0;
  $14 = $0 + 24 | 0;
  HEAP32[$4 >> 2] = HEAPU8[$14 >> 0] | 0 | ((HEAPU8[($14 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($14 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($14 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $37 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 16 | 0) >> 2] = $37;
  HEAP32[($1 + 20 | 0) >> 2] = i64toi32_i32$1;
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $48 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 57 | 0;
  $15 = $48;
  HEAP8[i64toi32_i32$1 >> 0] = $15;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $15 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $15 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $15 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $52 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 65 | 0;
  $16 = $52;
  HEAP8[i64toi32_i32$0 >> 0] = $16;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $16 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $17 = $1 + 73 | 0;
  $18 = HEAP32[$4 >> 2] | 0;
  HEAP8[$17 >> 0] = $18;
  HEAP8[($17 + 1 | 0) >> 0] = $18 >>> 8 | 0;
  HEAP8[($17 + 2 | 0) >> 0] = $18 >>> 16 | 0;
  HEAP8[($17 + 3 | 0) >> 0] = $18 >>> 24 | 0;
  HEAP8[($1 + 48 | 0) >> 0] = 1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $60 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  $19 = $60;
  HEAP8[(i64toi32_i32$2 + 49 | 0) >> 0] = $19;
  HEAP8[(i64toi32_i32$2 + 50 | 0) >> 0] = $19 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 51 | 0) >> 0] = $19 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 52 | 0) >> 0] = $19 >>> 24 | 0;
  HEAP8[(i64toi32_i32$2 + 53 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$2 + 54 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 55 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 56 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $0 = $cardano_serialization_lib__address__StakeCredential_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hfe6826a4b7739a89(i64toi32_i32$2 + 48 | 0 | 0) | 0;
  global$0 = i64toi32_i32$2 + 80 | 0;
  return $0 | 0;
 }
 
 function cardano_serialization_lib__TransactionInput__from_bytes__hd38041984775d7df($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $14 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[($2 + 168 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 152 | 0) >> 2] = 0;
  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 160 | 0) >> 2] = $14;
  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__TransactionInput___deserialize__h84b981706980e1e2($2 + 80 | 0 | 0, $2 + 152 | 0 | 0);
  $1 = ($2 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    memcpy($2 + 12 | 0 | 0, $2 + 80 | 0 | 4 | 0 | 0, 36 | 0) | 0;
    memcpy($0 + 4 | 0 | 0, $2 + 12 | 0 | 0, 36 | 0) | 0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 16 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__PoolMetadata__from_bytes__hd10a01972756859e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $14 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  HEAP32[($2 + 168 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 152 | 0) >> 2] = 0;
  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 160 | 0) >> 2] = $14;
  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__PoolMetadata___deserialize__hc2aeb10cf56b6b31($2 + 80 | 0 | 0, $2 + 152 | 0 | 0);
  $1 = ($2 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 80 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    memcpy($2 + 12 | 0 | 0, $2 + 80 | 0 | 4 | 0 | 0, 44 | 0) | 0;
    memcpy($0 + 4 | 0 | 0, $2 + 12 | 0 | 0, 44 | 0) | 0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 80 | 0 | 0, memcpy($2 + 16 | 0 | 0, ($2 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 80 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__TransactionWitnessSet__from_bytes__hd4b3c7c29ab9e1f0($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $14 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 192 | 0;
  global$0 = $2;
  HEAP32[($2 + 184 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 168 | 0) >> 2] = 0;
  HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 176 | 0) >> 2] = $14;
  HEAP32[($2 + 180 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__TransactionWitnessSet___deserialize__h9deaf1b9ab40fbb6($2 + 88 | 0 | 0, $2 + 168 | 0 | 0);
  $1 = ($2 + 168 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 88 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    memcpy($2 + 12 | 0 | 0, $2 + 88 | 0 | 4 | 0 | 0, 76 | 0) | 0;
    memcpy($0 + 4 | 0 | 0, $2 + 12 | 0 | 0, 76 | 0) | 0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 88 | 0 | 0, memcpy($2 + 16 | 0 | 0, ($2 + 88 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 88 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 192 | 0;
 }
 
 function multiasset_set_asset($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $5 = 0, $6 = 0, $7 = 0, $43 = 0, $8 = 0, $8$hi = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hbb430c180f3ec4b2($4 + 40 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $5 = HEAP32[($4 + 44 | 0) >> 2] | 0;
   $6 = HEAP32[($4 + 40 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h27da893e95dd15cf($4 + 32 | 0 | 0, $1 | 0);
   if (!$2) {
    break label$1
   }
   $0 = HEAP32[($4 + 36 | 0) >> 2] | 0;
   $7 = HEAP32[($4 + 32 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h9c68abd5a6a78973($4 + 24 | 0 | 0, $2 | 0);
   $1 = HEAP32[($4 + 28 | 0) >> 2] | 0;
   $43 = HEAP32[($4 + 24 | 0) >> 2] | 0;
   i64toi32_i32$0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hf909e98cc9547671($3 | 0) | 0;
   i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
   cardano_serialization_lib__MultiAsset__set_asset__hf25496807382656e($4 + 8 | 0 | 0, $6 | 0, $7 | 0, $43 | 0, i64toi32_i32$0 | 0, i64toi32_i32$1 | 0);
   i64toi32_i32$1 = HEAP32[($4 + 16 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($4 + 20 | 0) >> 2] | 0;
   $8 = i64toi32_i32$1;
   $8$hi = i64toi32_i32$0;
   i64toi32_i32$0 = HEAP32[($4 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($4 + 12 | 0) >> 2] | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   $0 = 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($5 | 0, 0 | 0) | 0;
   label$2 : {
    if (!i64toi32_i32$0) {
     break label$2
    }
    i64toi32_i32$1 = $8$hi;
    $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810($8 | 0, i64toi32_i32$1 | 0) | 0;
   }
   global$0 = $4 + 48 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function alloc__raw_vec__RawVec_T_2cA___shrink__h8bbb3d095485e93b($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, $5 = 0, $6 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $52 = 0;
  $3 = global$0 - 32 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[($1 + 4 | 0) >> 2] | 0) >>> 0 < $2 >>> 0) {
      break label$3
     }
     alloc__raw_vec__RawVec_T_2cA___current_memory__hca02c4a219cdf810($3 + 16 | 0 | 0, $1 | 0);
     label$4 : {
      $4 = HEAP32[($3 + 16 | 0) >> 2] | 0;
      if (!$4) {
       break label$4
      }
      $5 = HEAP32[($3 + 24 | 0) >> 2] | 0;
      $6 = HEAP32[($3 + 20 | 0) >> 2] | 0;
      label$5 : {
       label$6 : {
        $2 = $2 << 2 | 0;
        if ($2) {
         break label$6
        }
        label$7 : {
         if (!$6) {
          break label$7
         }
         __rust_dealloc($4 | 0, $6 | 0, $5 | 0);
        }
        $4 = $5;
        if (!$4) {
         break label$5
        }
        break label$2;
       }
       $4 = __rust_realloc($4 | 0, $6 | 0, $5 | 0, $2 | 0) | 0;
       if ($4) {
        break label$2
       }
       $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
      }
      $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($3 + 8 | 0 | 0, $2 | 0, $5 | 0);
      i64toi32_i32$0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
      HEAP32[$0 >> 2] = 1;
      $52 = i64toi32_i32$0;
      i64toi32_i32$0 = $0;
      HEAP32[($0 + 4 | 0) >> 2] = $52;
      HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$1;
      break label$1;
     }
     HEAP32[$0 >> 2] = 0;
     break label$1;
    }
    core__panicking__panic__h2fd385a887c8bf13(1054540 | 0, 36 | 0, 1054576 | 0);
    abort();
   }
   alloc__raw_vec__RawVec_T_2cA___set_ptr__hd0068d6c1847a835($1 | 0, $4 | 0, $2 | 0);
   HEAP32[$0 >> 2] = 0;
  }
  global$0 = $3 + 32 | 0;
 }
 
 function cardano_serialization_lib__utils__BigNum__from_str__h35d4d8383c8139e0($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $19 = 0;
  $3 = global$0 - 80 | 0;
  global$0 = $3;
  core__num___impl_20core__str__traits__FromStr_20for_20u64___from_str__h83c4b5731bcff83f($3 + 8 | 0 | 0, $1 | 0, $2 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAPU8[($3 + 8 | 0) >> 0] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    i64toi32_i32$2 = ($3 + 8 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $19 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $19;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    $1 = 0;
    break label$1;
   }
   HEAP8[($3 + 31 | 0) >> 0] = HEAPU8[($3 + 9 | 0) >> 0] | 0;
   HEAP32[($3 + 68 | 0) >> 2] = 1;
   i64toi32_i32$0 = $3;
   i64toi32_i32$1 = 0;
   HEAP32[($3 + 52 | 0) >> 2] = 1;
   HEAP32[($3 + 56 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($3 + 48 | 0) >> 2] = 1058724;
   HEAP32[($3 + 76 | 0) >> 2] = 48;
   HEAP32[($3 + 64 | 0) >> 2] = $3 + 72 | 0;
   HEAP32[($3 + 72 | 0) >> 2] = $3 + 31 | 0;
   alloc__fmt__format__h6e9e003a52c07309($3 + 32 | 0 | 0, $3 + 48 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 | 0, $3 + 32 | 0 | 0);
   $2 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[$3 >> 2] | 0 | 0, HEAP32[($3 + 4 | 0) >> 2] | 0 | 0) | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 32 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 32 | 0 | 0);
   HEAP32[($0 + 4 | 0) >> 2] = $2;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $3 + 80 | 0;
 }
 
 function value_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $31 = 0, $46 = 0, $51 = 0, $56 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 40 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  $1 = ($2 + 56 | 0) + 8 | 0;
  HEAP32[$1 >> 2] = HEAP32[(($2 + 40 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 40 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 44 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 56 | 0) >> 2] = $31;
  HEAP32[($2 + 60 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__utils__Value__from_bytes__h6b1b1ca5d42117ae($2 + 8 | 0 | 0, $2 + 56 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
   abort();
  }
  i64toi32_i32$2 = $2 + 32 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = ($2 + 56 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $46;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = ($2 + 8 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $51 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[i64toi32_i32$0 >> 2] = $51;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = ($2 + 8 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $56 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 56 | 0) >> 2] = $56;
  HEAP32[($2 + 60 | 0) >> 2] = i64toi32_i32$0;
  $1 = $cardano_serialization_lib__utils__Value_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h50a1108e1e08f966($2 + 56 | 0 | 0) | 0;
  global$0 = $2 + 80 | 0;
  return $1 | 0;
 }
 
 function cardano_serialization_lib__utils__Int__as_i32_or_fail__hd4590d09e3c5f338($0) {
  $0 = $0 | 0;
  var i64toi32_i32$4 = 0, $1 = 0, i64toi32_i32$3 = 0, i64toi32_i32$5 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $2$hi = 0, $2 = 0, $3$hi = 0, $17 = 0, $12 = 0, $15 = 0, $15$hi = 0, $18 = 0, $19$hi = 0, $57$hi = 0;
  $1 = global$0 - 64 | 0;
  global$0 = $1;
  label$1 : {
   label$2 : {
    i64toi32_i32$2 = $0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $2 = i64toi32_i32$0;
    $2$hi = i64toi32_i32$1;
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    i64toi32_i32$3 = -2147483648;
    i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
    i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
    if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
     i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
    }
    $3$hi = i64toi32_i32$5;
    i64toi32_i32$1 = i64toi32_i32$4;
    i64toi32_i32$2 = 1;
    i64toi32_i32$3 = 0;
    $12 = i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
    i64toi32_i32$3 = $0 + 8 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$3 >> 2] | 0;
    i64toi32_i32$5 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
    $15 = i64toi32_i32$1;
    $15$hi = i64toi32_i32$5;
    i64toi32_i32$5 = $3$hi;
    i64toi32_i32$5 = $2$hi;
    i64toi32_i32$5 = $3$hi;
    i64toi32_i32$3 = i64toi32_i32$4;
    i64toi32_i32$1 = $2$hi;
    i64toi32_i32$2 = $2;
    $18 = i64toi32_i32$5 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0;
    i64toi32_i32$3 = 0;
    $19$hi = i64toi32_i32$3;
    i64toi32_i32$3 = $15$hi;
    i64toi32_i32$2 = $15;
    i64toi32_i32$5 = $19$hi;
    i64toi32_i32$1 = $18;
    i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
    i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
    if (i64toi32_i32$0 >>> 0 < i64toi32_i32$1 >>> 0) {
     i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
    }
    if (!(!(i64toi32_i32$0 | i64toi32_i32$4 | 0) ? $12 : 0)) {
     break label$2
    }
    i64toi32_i32$4 = $2$hi;
    $0 = $2;
    i64toi32_i32$4 = 0;
    $2 = 0;
    $2$hi = i64toi32_i32$4;
    break label$1;
   }
   HEAP32[($1 + 44 | 0) >> 2] = 1;
   i64toi32_i32$4 = 0;
   $2 = 1;
   $2$hi = i64toi32_i32$4;
   i64toi32_i32$2 = $1;
   i64toi32_i32$4 = 0;
   HEAP32[($1 + 28 | 0) >> 2] = 1;
   HEAP32[($1 + 32 | 0) >> 2] = i64toi32_i32$4;
   HEAP32[($1 + 24 | 0) >> 2] = 1058724;
   HEAP32[($1 + 52 | 0) >> 2] = 49;
   HEAP32[($1 + 40 | 0) >> 2] = $1 + 48 | 0;
   HEAP32[($1 + 48 | 0) >> 2] = $1 + 56 | 0;
   alloc__fmt__format__h6e9e003a52c07309($1 + 8 | 0 | 0, $1 + 24 | 0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($1 | 0, $1 + 8 | 0 | 0);
   $0 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[$1 >> 2] | 0 | 0, HEAP32[($1 + 4 | 0) >> 2] | 0 | 0) | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 + 8 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 + 8 | 0 | 0);
  }
  global$0 = $1 + 64 | 0;
  i64toi32_i32$4 = 0;
  i64toi32_i32$3 = $0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$1 = 32;
  i64toi32_i32$5 = i64toi32_i32$1 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$3 << i64toi32_i32$5 | 0;
   $17 = 0;
  } else {
   i64toi32_i32$2 = ((1 << i64toi32_i32$5 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$5 | 0) | 0) | 0 | (i64toi32_i32$4 << i64toi32_i32$5 | 0) | 0;
   $17 = i64toi32_i32$3 << i64toi32_i32$5 | 0;
  }
  $57$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $2$hi;
  i64toi32_i32$2 = $57$hi;
  i64toi32_i32$4 = $17;
  i64toi32_i32$3 = $2$hi;
  i64toi32_i32$1 = $2;
  i64toi32_i32$3 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$4 | i64toi32_i32$1 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$3;
  return i64toi32_i32$4 | 0;
 }
 
 function cardano_serialization_lib__tx_builder__TransactionBuilderConfigBuilder__ex_unit_prices__h9d2c41c6e3a24742($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $7 = 0, $10 = 0, $13 = 0, $16 = 0, $19 = 0, $22 = 0, $27 = 0, $32 = 0, $37 = 0, $3 = 0, $3$hi = 0, $4 = 0, $4$hi = 0, $55 = 0, $59 = 0, $63 = 0, $68 = 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 120 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 124 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 120 | 0) >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 124 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 112 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 116 | 0) >> 2] | 0;
  $10 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[(i64toi32_i32$1 + 112 | 0) >> 2] = $10;
  HEAP32[(i64toi32_i32$1 + 116 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] | 0;
  $13 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 40 | 0) >> 2] = $13;
  HEAP32[(i64toi32_i32$0 + 44 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $16 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = $16;
  HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $19 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $19;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $22 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $22;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = i64toi32_i32$2 + 48 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $27 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 48 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $27;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 32 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $32 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 32 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $32;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $37 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $37;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 64 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $3 = i64toi32_i32$1;
  $3$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$1;
  HEAP8[($0 + 128 | 0) >> 0] = HEAPU8[(i64toi32_i32$2 + 128 | 0) >> 0] | 0;
  i64toi32_i32$1 = $3$hi;
  i64toi32_i32$0 = $0 + 64 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $3;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $4$hi;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 56 | 0) >> 2] = $4;
  HEAP32[(i64toi32_i32$0 + 60 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  HEAP32[(i64toi32_i32$0 + 72 | 0) >> 2] = 1;
  HEAP32[(i64toi32_i32$0 + 76 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $55 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 80 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $55;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $59 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 88 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $59;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $63 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 96 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $63;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = i64toi32_i32$2 + 24 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $68 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 104 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $68;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
 }
 
 function transactionbuilder_add_key_input($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $5 = 0, $6 = 0, $7 = 0, $8 = 0;
  $4 = global$0 - 32 | 0;
  global$0 = $4;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h5566e1c7d4aafe35($4 + 24 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $5 = HEAP32[($4 + 28 | 0) >> 2] | 0;
   $6 = HEAP32[($4 + 24 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hae9c55c4e91ce40f($4 + 16 | 0 | 0, $1 | 0);
   if (!$2) {
    break label$1
   }
   $0 = HEAP32[($4 + 20 | 0) >> 2] | 0;
   $7 = HEAP32[($4 + 16 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hd7bc050864a8d646($4 + 8 | 0 | 0, $2 | 0);
   if (!$3) {
    break label$1
   }
   $1 = HEAP32[($4 + 12 | 0) >> 2] | 0;
   $8 = HEAP32[($4 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h5db5149478ec5345($4 | 0, $3 | 0);
   $2 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__add_key_input__hcbbcffc3c6e022ad($6 + 96 | 0 | 0, $7 | 0, $8 | 0, HEAP32[$4 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($5 | 0, 0 | 0) | 0;
   global$0 = $4 + 32 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionbuilder_add_script_input($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $5 = 0, $6 = 0, $7 = 0, $8 = 0;
  $4 = global$0 - 32 | 0;
  global$0 = $4;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h5566e1c7d4aafe35($4 + 24 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $5 = HEAP32[($4 + 28 | 0) >> 2] | 0;
   $6 = HEAP32[($4 + 24 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h27da893e95dd15cf($4 + 16 | 0 | 0, $1 | 0);
   if (!$2) {
    break label$1
   }
   $0 = HEAP32[($4 + 20 | 0) >> 2] | 0;
   $7 = HEAP32[($4 + 16 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hd7bc050864a8d646($4 + 8 | 0 | 0, $2 | 0);
   if (!$3) {
    break label$1
   }
   $1 = HEAP32[($4 + 12 | 0) >> 2] | 0;
   $8 = HEAP32[($4 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h5db5149478ec5345($4 | 0, $3 | 0);
   $2 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__add_script_input__ha8e1111a100bff34($6 + 96 | 0 | 0, $7 | 0, $8 | 0, HEAP32[$4 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($5 | 0, 0 | 0) | 0;
   global$0 = $4 + 32 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionbuilder_add_native_script_input($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $5 = 0, $6 = 0, $7 = 0, $8 = 0;
  $4 = global$0 - 32 | 0;
  global$0 = $4;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h5566e1c7d4aafe35($4 + 24 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $5 = HEAP32[($4 + 28 | 0) >> 2] | 0;
   $6 = HEAP32[($4 + 24 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h6ed0b6b043905434($4 + 16 | 0 | 0, $1 | 0);
   if (!$2) {
    break label$1
   }
   $0 = HEAP32[($4 + 20 | 0) >> 2] | 0;
   $7 = HEAP32[($4 + 16 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hd7bc050864a8d646($4 + 8 | 0 | 0, $2 | 0);
   if (!$3) {
    break label$1
   }
   $1 = HEAP32[($4 + 12 | 0) >> 2] | 0;
   $8 = HEAP32[($4 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h5db5149478ec5345($4 | 0, $3 | 0);
   $2 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__add_native_script_input__h3e7dddcfb342ebab($6 + 96 | 0 | 0, $7 | 0, $8 | 0, HEAP32[$4 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($5 | 0, 0 | 0) | 0;
   global$0 = $4 + 32 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionbuilder_add_plutus_script_input($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $5 = 0, $6 = 0, $7 = 0, $8 = 0;
  $4 = global$0 - 32 | 0;
  global$0 = $4;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h5566e1c7d4aafe35($4 + 24 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $5 = HEAP32[($4 + 28 | 0) >> 2] | 0;
   $6 = HEAP32[($4 + 24 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hbec83ebdd86caafd($4 + 16 | 0 | 0, $1 | 0);
   if (!$2) {
    break label$1
   }
   $0 = HEAP32[($4 + 20 | 0) >> 2] | 0;
   $7 = HEAP32[($4 + 16 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hd7bc050864a8d646($4 + 8 | 0 | 0, $2 | 0);
   if (!$3) {
    break label$1
   }
   $1 = HEAP32[($4 + 12 | 0) >> 2] | 0;
   $8 = HEAP32[($4 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h5db5149478ec5345($4 | 0, $3 | 0);
   $2 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__add_plutus_script_input__hdd1b935f94ddad7d($6 + 96 | 0 | 0, $7 | 0, $8 | 0, HEAP32[$4 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($5 | 0, 0 | 0) | 0;
   global$0 = $4 + 32 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionbuilder_add_bootstrap_input($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $5 = 0, $6 = 0, $7 = 0, $8 = 0;
  $4 = global$0 - 32 | 0;
  global$0 = $4;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h5566e1c7d4aafe35($4 + 24 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $5 = HEAP32[($4 + 28 | 0) >> 2] | 0;
   $6 = HEAP32[($4 + 24 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h76f3e067f9139bb4($4 + 16 | 0 | 0, $1 | 0);
   if (!$2) {
    break label$1
   }
   $0 = HEAP32[($4 + 20 | 0) >> 2] | 0;
   $7 = HEAP32[($4 + 16 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hd7bc050864a8d646($4 + 8 | 0 | 0, $2 | 0);
   if (!$3) {
    break label$1
   }
   $1 = HEAP32[($4 + 12 | 0) >> 2] | 0;
   $8 = HEAP32[($4 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h5db5149478ec5345($4 | 0, $3 | 0);
   $2 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__add_bootstrap_input__h233fca55423e7cf8($6 + 96 | 0 | 0, $7 | 0, $8 | 0, HEAP32[$4 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($5 | 0, 0 | 0) | 0;
   global$0 = $4 + 32 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionbuilder_add_input($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $5 = 0, $6 = 0, $7 = 0, $8 = 0;
  $4 = global$0 - 32 | 0;
  global$0 = $4;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h5566e1c7d4aafe35($4 + 24 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $5 = HEAP32[($4 + 28 | 0) >> 2] | 0;
   $6 = HEAP32[($4 + 24 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hab2c0cbdcb539b91($4 + 16 | 0 | 0, $1 | 0);
   if (!$2) {
    break label$1
   }
   $0 = HEAP32[($4 + 20 | 0) >> 2] | 0;
   $7 = HEAP32[($4 + 16 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hd7bc050864a8d646($4 + 8 | 0 | 0, $2 | 0);
   if (!$3) {
    break label$1
   }
   $1 = HEAP32[($4 + 12 | 0) >> 2] | 0;
   $8 = HEAP32[($4 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h5db5149478ec5345($4 | 0, $3 | 0);
   $2 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__add_input__hd22960e5a7d88824($6 + 96 | 0 | 0, $7 | 0, $8 | 0, HEAP32[$4 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($5 | 0, 0 | 0) | 0;
   global$0 = $4 + 32 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function ed25519signature_to_hex($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, $40 = 0, $52 = 0, $59 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hd6fdee4274fe58a2($2 + 24 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $3 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  HEAP32[($2 + 68 | 0) >> 2] = 64;
  HEAP32[($2 + 64 | 0) >> 2] = $3;
  HEAP32[($2 + 48 | 0) >> 2] = $2 + 64 | 0;
  $T_20as_20hex__ToHex___encode_hex__hc3cf64eab3db6a3a($2 + 32 | 0 | 0, $2 + 48 | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  $1 = ($2 + 48 | 0) + 8 | 0;
  HEAP32[$1 >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $40 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $40;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $52 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 64 | 0) >> 2] = $52;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 64 | 0 | 0);
  i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $59 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $59;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $2 + 80 | 0;
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___insert__hc7622c6487a4ba88($0, $1, $2, $3, $3$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, i64toi32_i32$2 = 0, $5 = 0, $19 = 0, $36 = 0, $40 = 0, $43 = 0, $6 = 0, $6$hi = 0;
  $4 = global$0 - 64 | 0;
  global$0 = $4;
  $5 = ($4 + 32 | 0) + 8 | 0;
  HEAP32[$5 >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[(i64toi32_i32$0 + 32 | 0) >> 2] = $19;
  HEAP32[(i64toi32_i32$0 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__collections__btree__map__BTreeMap_K_2cV___entry__ha969beb26eee2f30(i64toi32_i32$0 | 0, $1 | 0, i64toi32_i32$0 + 32 | 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[i64toi32_i32$0 >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    HEAP32[($4 + 56 | 0) >> 2] = HEAP32[($4 + 28 | 0) >> 2] | 0;
    i64toi32_i32$2 = $4 + 20 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $36 = i64toi32_i32$1;
    i64toi32_i32$1 = $4 + 48 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $36;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $4 + 12 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $40 = i64toi32_i32$0;
    i64toi32_i32$0 = $5;
    HEAP32[i64toi32_i32$0 >> 2] = $40;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    $43 = i64toi32_i32$1;
    i64toi32_i32$1 = $4;
    HEAP32[(i64toi32_i32$1 + 32 | 0) >> 2] = $43;
    HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = $3$hi;
    alloc__collections__btree__map__entry__VacantEntry_K_2cV___insert__h1331755557d851e2(i64toi32_i32$1 + 32 | 0 | 0, $3 | 0, i64toi32_i32$0 | 0) | 0;
    i64toi32_i32$0 = 0;
    $3 = 0;
    $3$hi = i64toi32_i32$0;
    break label$1;
   }
   $2 = (HEAP32[($4 + 8 | 0) >> 2] | 0) + ((HEAP32[($4 + 12 | 0) >> 2] | 0) << 3 | 0) | 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $6 = i64toi32_i32$0;
   $6$hi = i64toi32_i32$1;
   i64toi32_i32$1 = $3$hi;
   i64toi32_i32$0 = i64toi32_i32$2;
   HEAP32[i64toi32_i32$0 >> 2] = $3;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = 0;
   $3 = 1;
   $3$hi = i64toi32_i32$1;
  }
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $6;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $3$hi;
  HEAP32[i64toi32_i32$0 >> 2] = $3;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $4 + 64 | 0;
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h25db889dc58a550d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $2 = 0, $5 = 0, $3 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $4 = 0, $6 = 0, $7 = 0, $7$hi = 0, $8 = 0, $8$hi = 0, $9 = 0, $9$hi = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $3 = HEAP32[$1 >> 2] | 0;
  $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__hd795b89d8892a0fd($2 + 8 | 0 | 0, $4 | 0, 0 | 0);
  $1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  $5 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $5;
  HEAP32[$0 >> 2] = $1;
  label$1 : {
   if (!$5) {
    break label$1
   }
   $6 = Math_imul($4, 28);
   label$2 : while (1) {
    if (!$6) {
     break label$1
    }
    i64toi32_i32$2 = $3 + 8 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $7 = i64toi32_i32$0;
    $7$hi = i64toi32_i32$1;
    i64toi32_i32$2 = $3 + 16 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $8 = i64toi32_i32$1;
    $8$hi = i64toi32_i32$0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $9 = i64toi32_i32$0;
    $9$hi = i64toi32_i32$1;
    $16 = i64toi32_i32$2 + 24 | 0;
    $17 = $1 + 24 | 0;
    $18 = HEAPU8[$16 >> 0] | 0 | ((HEAPU8[($16 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($16 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($16 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    HEAP8[$17 >> 0] = $18;
    HEAP8[($17 + 1 | 0) >> 0] = $18 >>> 8 | 0;
    HEAP8[($17 + 2 | 0) >> 0] = $18 >>> 16 | 0;
    HEAP8[($17 + 3 | 0) >> 0] = $18 >>> 24 | 0;
    i64toi32_i32$1 = $8$hi;
    i64toi32_i32$0 = $1 + 16 | 0;
    $19 = $8;
    HEAP8[i64toi32_i32$0 >> 0] = $19;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $19 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $19 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $19 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$1 = $7$hi;
    i64toi32_i32$0 = $1 + 8 | 0;
    $20 = $7;
    HEAP8[i64toi32_i32$0 >> 0] = $20;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $20 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $20 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $20 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$1 = $9$hi;
    i64toi32_i32$0 = $1;
    $21 = $9;
    HEAP8[i64toi32_i32$0 >> 0] = $21;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $21 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $21 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $21 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    $1 = i64toi32_i32$0 + 28 | 0;
    $6 = $6 + -28 | 0;
    $3 = i64toi32_i32$2 + 28 | 0;
    $5 = $5 + -1 | 0;
    if ($5) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 8 | 0) >> 2] = $4;
  global$0 = $2 + 16 | 0;
 }
 
 function constrplutusdata_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $31 = 0, $46 = 0, $51 = 0, $56 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 40 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  $1 = ($2 + 56 | 0) + 8 | 0;
  HEAP32[$1 >> 2] = HEAP32[(($2 + 40 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 40 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 44 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 56 | 0) >> 2] = $31;
  HEAP32[($2 + 60 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__plutus__ConstrPlutusData__from_bytes__h9f26489e8a0768bf($2 + 8 | 0 | 0, $2 + 56 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
   abort();
  }
  i64toi32_i32$2 = $2 + 32 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = ($2 + 56 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $46;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = ($2 + 8 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $51 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[i64toi32_i32$0 >> 2] = $51;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = ($2 + 8 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $56 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 56 | 0) >> 2] = $56;
  HEAP32[($2 + 60 | 0) >> 2] = i64toi32_i32$0;
  $1 = $cardano_serialization_lib__plutus__ConstrPlutusData_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hd2d0c81add63de21($2 + 56 | 0 | 0) | 0;
  global$0 = $2 + 80 | 0;
  return $1 | 0;
 }
 
 function transactioninput_new($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $3 = 0, $4 = 0, $5 = 0, $20 = 0, $27 = 0, $34 = 0, $37 = 0, $48 = 0, $52 = 0, $56 = 0, $61 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h8308bd69a8eeb68f($2 | 0, $0 | 0);
  $3 = ($2 + 8 | 0) + 8 | 0;
  $0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$2 = $0 + 8 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $20;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $4 = ($2 + 8 | 0) + 16 | 0;
  i64toi32_i32$2 = $0 + 16 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $27 = i64toi32_i32$1;
  i64toi32_i32$1 = $4;
  HEAP32[i64toi32_i32$1 >> 2] = $27;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $5 = ($2 + 8 | 0) + 24 | 0;
  i64toi32_i32$2 = $0 + 24 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $34 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[i64toi32_i32$0 >> 2] = $34;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $37 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $37;
  HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
  $0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $48 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 52 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $48;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $52 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 60 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $52;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $56 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 68 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $56;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($2 + 40 | 0) >> 2] = $1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $61 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] = $61;
  HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = i64toi32_i32$0;
  $0 = $cardano_serialization_lib__TransactionInput_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hf06f9abbcbb78385(i64toi32_i32$2 + 40 | 0 | 0) | 0;
  global$0 = i64toi32_i32$2 + 80 | 0;
  return $0 | 0;
 }
 
 function genesiskeydelegation_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 208 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 104 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 120 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 104 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 108 | 0) >> 2] | 0;
  HEAP32[($2 + 120 | 0) >> 2] = HEAP32[($2 + 104 | 0) >> 2] | 0;
  HEAP32[($2 + 124 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__GenesisKeyDelegation__from_bytes__haf8140e0613d2ea5($2 + 8 | 0 | 0, $2 + 120 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 8 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  HEAP8[($2 + 122 | 0) >> 0] = HEAPU8[($2 + 11 | 0) >> 0] | 0;
  HEAP16[($2 + 120 | 0) >> 1] = HEAPU8[($2 + 9 | 0) >> 0] | 0 | ((HEAPU8[($2 + 10 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 123 | 0) >> 0] = $1;
  HEAP8[($2 + 124 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 125 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 126 | 0) >> 0] = $1 >>> 24 | 0;
  memcpy($2 + 120 | 0 | 7 | 0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 81 | 0) | 0;
  $1 = $cardano_serialization_lib__GenesisKeyDelegation_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h6614a0688d3f0486($2 + 120 | 0 | 0) | 0;
  global$0 = $2 + 208 | 0;
  return $1 | 0;
 }
 
 function cardano_serialization_lib__Ipv4__from_bytes__h105107d460ccfdd6($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $3$hi = 0, $4$hi = 0, $3 = 0, $4 = 0, $2 = 0, $17 = 0, $18 = 0, $16 = 0, $53 = 0, $53$hi = 0, $56$hi = 0;
  $1 = global$0 - 176 | 0;
  global$0 = $1;
  HEAP32[($1 + 168 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = 0;
  $3 = 0;
  $3$hi = i64toi32_i32$0;
  i64toi32_i32$1 = $1;
  i64toi32_i32$0 = 0;
  HEAP32[($1 + 152 | 0) >> 2] = 0;
  HEAP32[($1 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $16 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 160 | 0) >> 2] = $16;
  HEAP32[($1 + 164 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__Ipv4___deserialize__he9338b7b9f2de34e($1 + 80 | 0 | 0, $1 + 152 | 0 | 0);
  $0 = ($1 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAPU8[($1 + 80 | 0) >> 0] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $0 = HEAPU8[($1 + 81 | 0) >> 0] | 0 | ((HEAPU8[($1 + 82 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 83 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 84 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = 0;
    $4 = 0;
    $4$hi = i64toi32_i32$1;
    break label$1;
   }
   memcpy($1 + 80 | 0 | 0, memcpy($1 + 16 | 0 | 0, ($1 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   $2 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($1 + 80 | 0 | 0) | 0;
   $0 = $2 << 24 | 0;
   i64toi32_i32$1 = 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = 0;
   i64toi32_i32$3 = 32;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
    $17 = 0;
   } else {
    i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
    $17 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   }
   i64toi32_i32$1 = $17;
   i64toi32_i32$2 = -256;
   i64toi32_i32$3 = 0;
   i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
   $3 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
   $3$hi = i64toi32_i32$2;
   i64toi32_i32$2 = 0;
   $4 = 1;
   $4$hi = i64toi32_i32$2;
  }
  global$0 = $1 + 176 | 0;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$2 = $3$hi;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$0 = $4;
  i64toi32_i32$1 = $3$hi;
  i64toi32_i32$3 = $3;
  i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
  $53 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  $53$hi = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 8;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $18 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $18 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $56$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $53$hi;
  i64toi32_i32$1 = $53;
  i64toi32_i32$2 = $56$hi;
  i64toi32_i32$3 = $18;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  i64toi32_i32$1 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$2;
  return i64toi32_i32$1 | 0;
 }
 
 function cardano_serialization_lib__TimelockStart__from_bytes__h14a276d00223ecc6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $3 = 0, $3$hi = 0, $16 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  HEAP32[(($2 + 136 | 0) + 16 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 136 | 0) >> 2] = 0;
  HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $16 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 144 | 0) >> 2] = $16;
  HEAP32[($2 + 148 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__TimelockStart___deserialize__h0421432721709e93($2 + 64 | 0 | 0, $2 + 136 | 0 | 0);
  $1 = ($2 + 136 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 72 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 76 | 0) >> 2] | 0;
  $3 = i64toi32_i32$1;
  $3$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[($2 + 64 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 68 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    if ((i64toi32_i32$2 | 0) == (1 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
     break label$2
    }
    i64toi32_i32$2 = $3$hi;
    i64toi32_i32$1 = $0 + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 8 | 0 | 0, ($2 + 64 | 0) + 16 | 0 | 0, 56 | 0) | 0;
   i64toi32_i32$2 = $3$hi;
   i64toi32_i32$1 = $2;
   HEAP32[($2 + 64 | 0) >> 2] = $3;
   HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$2;
   memcpy(($2 + 64 | 0) + 8 | 0 | 0, $2 + 8 | 0 | 0, 56 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 64 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 160 | 0;
 }
 
 function cardano_serialization_lib__TimelockExpiry__from_bytes__hb5c64ca74cc30b66($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $3 = 0, $3$hi = 0, $16 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  HEAP32[(($2 + 136 | 0) + 16 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 136 | 0) >> 2] = 0;
  HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $16 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 144 | 0) >> 2] = $16;
  HEAP32[($2 + 148 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__TimelockExpiry___deserialize__hb3d0c85b881e4488($2 + 64 | 0 | 0, $2 + 136 | 0 | 0);
  $1 = ($2 + 136 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 72 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 76 | 0) >> 2] | 0;
  $3 = i64toi32_i32$1;
  $3$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[($2 + 64 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 68 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    if ((i64toi32_i32$2 | 0) == (1 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
     break label$2
    }
    i64toi32_i32$2 = $3$hi;
    i64toi32_i32$1 = $0 + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 8 | 0 | 0, ($2 + 64 | 0) + 16 | 0 | 0, 56 | 0) | 0;
   i64toi32_i32$2 = $3$hi;
   i64toi32_i32$1 = $2;
   HEAP32[($2 + 64 | 0) >> 2] = $3;
   HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$2;
   memcpy(($2 + 64 | 0) + 8 | 0 | 0, $2 + 8 | 0 | 0, 56 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 64 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 160 | 0;
 }
 
 function core__iter__adapters__process_results__h200f16721825da5a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $3 = 0, $5 = 0, $16 = 0, $19 = 0, $4 = 0, $38 = 0, $43 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  HEAP32[$2 >> 2] = 1114114;
  $3 = ($2 + 24 | 0) + 8 | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $16 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $16;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $19;
  HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 40 | 0) >> 2] = $2;
  $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__hfbc1ea6d6bc089ca($2 + 8 | 0 | 0, $2 + 24 | 0 | 0);
  $4 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $1 = HEAP32[$2 >> 2] | 0;
  $5 = ($2 + 8 | 0) + 8 | 0;
  HEAP32[$3 >> 2] = HEAP32[$5 >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $38 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $38;
  HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    if (($1 | 0) != (1114114 | 0)) {
     break label$2
    }
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $43 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $43;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
    $1 = 0;
    break label$1;
   }
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[($0 + 8 | 0) >> 2] = $4;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 24 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 24 | 0 | 0);
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 48 | 0;
 }
 
 function core__iter__adapters__process_results__ha88025cbb18edab5($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $3 = 0, $5 = 0, $16 = 0, $19 = 0, $4 = 0, $38 = 0, $43 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  HEAP32[$2 >> 2] = 1114114;
  $3 = ($2 + 24 | 0) + 8 | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $16 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $16;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $19;
  HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 40 | 0) >> 2] = $2;
  $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__h96b8cd0b2bd03e44($2 + 8 | 0 | 0, $2 + 24 | 0 | 0);
  $4 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $1 = HEAP32[$2 >> 2] | 0;
  $5 = ($2 + 8 | 0) + 8 | 0;
  HEAP32[$3 >> 2] = HEAP32[$5 >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $38 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $38;
  HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    if (($1 | 0) != (1114114 | 0)) {
     break label$2
    }
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $43 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $43;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
    $1 = 0;
    break label$1;
   }
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[($0 + 8 | 0) >> 2] = $4;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 24 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 24 | 0 | 0);
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 48 | 0;
 }
 
 function transactionoutputamountbuilder_with_coin_and_asset($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, $5 = 0;
  $3 = global$0 - 288 | 0;
  global$0 = $3;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h1cb96e7b1dabbc55($3 + 24 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($3 + 28 | 0) >> 2] | 0;
   $4 = HEAP32[($3 + 24 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($3 + 16 | 0 | 0, $1 | 0);
   if (!$2) {
    break label$1
   }
   $1 = HEAP32[($3 + 20 | 0) >> 2] | 0;
   $5 = HEAP32[($3 + 16 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h9968e42c55861cec($3 + 8 | 0 | 0, $2 | 0);
   $2 = HEAP32[($3 + 12 | 0) >> 2] | 0;
   cardano_serialization_lib__output_builder__TransactionOutputAmountBuilder__with_coin_and_asset__h3912d48b40d60b51($3 + 32 | 0 | 0, $4 | 0, $5 | 0, HEAP32[($3 + 8 | 0) >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   memcpy($3 + 160 | 0 | 0, $3 + 32 | 0 | 0, 128 | 0) | 0;
   $0 = $cardano_serialization_lib__output_builder__TransactionOutputAmountBuilder_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hafb771b944269b79($3 + 160 | 0 | 0) | 0;
   global$0 = $3 + 288 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function cardano_serialization_lib__utils__BigNum__from_bytes__h6da2ace6f7be6864($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $3 = 0, $3$hi = 0, $16 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  HEAP32[(($2 + 136 | 0) + 16 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 136 | 0) >> 2] = 0;
  HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $16 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 144 | 0) >> 2] = $16;
  HEAP32[($2 + 148 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__utils__BigNum_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h29637bb571dceb02($2 + 64 | 0 | 0, $2 + 136 | 0 | 0);
  $1 = ($2 + 136 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 72 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 76 | 0) >> 2] | 0;
  $3 = i64toi32_i32$1;
  $3$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[($2 + 64 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 68 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    if ((i64toi32_i32$2 | 0) == (1 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
     break label$2
    }
    i64toi32_i32$2 = $3$hi;
    i64toi32_i32$1 = $0 + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 8 | 0 | 0, ($2 + 64 | 0) + 16 | 0 | 0, 56 | 0) | 0;
   i64toi32_i32$2 = $3$hi;
   i64toi32_i32$1 = $2;
   HEAP32[($2 + 64 | 0) >> 2] = $3;
   HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$2;
   memcpy(($2 + 64 | 0) + 8 | 0 | 0, $2 + 8 | 0 | 0, 56 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 64 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 160 | 0;
 }
 
 function make_daedalus_bootstrap_witness($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, $5 = 0;
  $3 = global$0 - 272 | 0;
  global$0 = $3;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h8308bd69a8eeb68f($3 + 24 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($3 + 28 | 0) >> 2] | 0;
   $4 = HEAP32[($3 + 24 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h76f3e067f9139bb4($3 + 16 | 0 | 0, $1 | 0);
   if (!$2) {
    break label$1
   }
   $1 = HEAP32[($3 + 20 | 0) >> 2] | 0;
   $5 = HEAP32[($3 + 16 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h6e50d398ad665042($3 + 8 | 0 | 0, $2 | 0);
   $2 = HEAP32[($3 + 12 | 0) >> 2] | 0;
   cardano_serialization_lib__utils__make_daedalus_bootstrap_witness__h7e21e4ecf8b27efa($3 + 32 | 0 | 0, $4 | 0, $5 | 0, HEAP32[($3 + 8 | 0) >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   memcpy($3 + 152 | 0 | 0, $3 + 32 | 0 | 0, 120 | 0) | 0;
   $0 = $cardano_serialization_lib__crypto__BootstrapWitness_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hcc8c8e7beca3e936($3 + 152 | 0 | 0) | 0;
   global$0 = $3 + 272 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function make_icarus_bootstrap_witness($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, $5 = 0;
  $3 = global$0 - 272 | 0;
  global$0 = $3;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h8308bd69a8eeb68f($3 + 24 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($3 + 28 | 0) >> 2] | 0;
   $4 = HEAP32[($3 + 24 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h76f3e067f9139bb4($3 + 16 | 0 | 0, $1 | 0);
   if (!$2) {
    break label$1
   }
   $1 = HEAP32[($3 + 20 | 0) >> 2] | 0;
   $5 = HEAP32[($3 + 16 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h30021c0122a7c8e6($3 + 8 | 0 | 0, $2 | 0);
   $2 = HEAP32[($3 + 12 | 0) >> 2] | 0;
   cardano_serialization_lib__utils__make_icarus_bootstrap_witness__h3e3e2f5db19a8349($3 + 32 | 0 | 0, $4 | 0, $5 | 0, HEAP32[($3 + 8 | 0) >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   memcpy($3 + 152 | 0 | 0, $3 + 32 | 0 | 0, 120 | 0) | 0;
   $0 = $cardano_serialization_lib__crypto__BootstrapWitness_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hcc8c8e7beca3e936($3 + 152 | 0 | 0) | 0;
   global$0 = $3 + 272 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function metadatamap_get_str($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0;
  $3 = global$0 - 128 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h74f2437fd791f127($3 + 16 | 0 | 0, $0 | 0);
    $0 = HEAP32[($3 + 20 | 0) >> 2] | 0;
    $4 = HEAP32[($3 + 16 | 0) >> 2] | 0;
    HEAP32[($3 + 32 | 0) >> 2] = $2;
    HEAP32[($3 + 28 | 0) >> 2] = $2;
    HEAP32[($3 + 24 | 0) >> 2] = $1;
    alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($3 + 8 | 0 | 0, $3 + 24 | 0 | 0);
    $2 = HEAP32[($3 + 12 | 0) >> 2] | 0;
    HEAP32[($3 + 84 | 0) >> 2] = $2;
    $1 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    HEAP32[($3 + 80 | 0) >> 2] = $1;
    cardano_serialization_lib__metadata__MetadataMap__get_str__h590bed663a42477e($3 + 24 | 0 | 0, $4 | 0, $1 | 0, $2 | 0);
    core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_1($3 + 80 | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    if ((HEAP32[($3 + 24 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    memcpy($3 + 80 | 0 | 0, $3 + 32 | 0 | 0, 48 | 0) | 0;
    $0 = $cardano_serialization_lib__metadata__TransactionMetadatum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hce2feba55b67d086($3 + 80 | 0 | 0) | 0;
    global$0 = $3 + 128 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($3 + 28 | 0) >> 2] | 0 | 0);
  abort();
 }
 
 function $cardano_serialization_lib__error__Key_20as_20core__fmt__Display___fmt__hebab90d6fb84080f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $22 = 0, $43 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if ((HEAP32[$0 >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    HEAP32[($2 + 28 | 0) >> 2] = $0 + 4 | 0;
    core__fmt__ArgumentV1__new__h3d5a6d2b66a66ab8($2 + 16 | 0 | 0, $2 + 28 | 0 | 0, 16 | 0);
    HEAP32[($2 + 52 | 0) >> 2] = 1;
    i64toi32_i32$1 = $2;
    i64toi32_i32$0 = 0;
    HEAP32[($2 + 36 | 0) >> 2] = 2;
    HEAP32[($2 + 40 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($2 + 32 | 0) >> 2] = 1061576;
    i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
    $22 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[($2 + 56 | 0) >> 2] = $22;
    HEAP32[($2 + 60 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($2 + 48 | 0) >> 2] = $2 + 56 | 0;
    $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 32 | 0 | 0) | 0;
    break label$1;
   }
   HEAP32[($2 + 28 | 0) >> 2] = $0 + 8 | 0;
   core__fmt__ArgumentV1__new__h67b517e324fc8963($2 + 8 | 0 | 0, $2 + 28 | 0 | 0, 87 | 0);
   HEAP32[($2 + 52 | 0) >> 2] = 1;
   i64toi32_i32$0 = $2;
   i64toi32_i32$1 = 0;
   HEAP32[($2 + 36 | 0) >> 2] = 1;
   HEAP32[($2 + 40 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($2 + 32 | 0) >> 2] = 1061564;
   i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $43 = i64toi32_i32$1;
   i64toi32_i32$1 = $2;
   HEAP32[($2 + 56 | 0) >> 2] = $43;
   HEAP32[($2 + 60 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($2 + 48 | 0) >> 2] = $2 + 56 | 0;
   $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 32 | 0 | 0) | 0;
  }
  global$0 = $2 + 64 | 0;
  return $0 | 0;
 }
 
 function vkeywitness_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 224 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 112 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 128 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 112 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 116 | 0) >> 2] | 0;
  HEAP32[($2 + 128 | 0) >> 2] = HEAP32[($2 + 112 | 0) >> 2] | 0;
  HEAP32[($2 + 132 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__crypto__Vkeywitness__from_bytes__hef4aeeaa38070cc1($2 + 8 | 0 | 0, $2 + 128 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 8 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  HEAP8[($2 + 130 | 0) >> 0] = HEAPU8[($2 + 11 | 0) >> 0] | 0;
  HEAP16[($2 + 128 | 0) >> 1] = HEAPU8[($2 + 9 | 0) >> 0] | 0 | ((HEAPU8[($2 + 10 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 131 | 0) >> 0] = $1;
  HEAP8[($2 + 132 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 133 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 134 | 0) >> 0] = $1 >>> 24 | 0;
  memcpy($2 + 128 | 0 | 7 | 0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 89 | 0) | 0;
  $1 = $cardano_serialization_lib__crypto__Vkeywitness_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hffa43ed1c5f00e23($2 + 128 | 0 | 0) | 0;
  global$0 = $2 + 224 | 0;
  return $1 | 0;
 }
 
 function ed25519signature_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 80 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 96 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 80 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 84 | 0) >> 2] | 0;
  HEAP32[($2 + 96 | 0) >> 2] = HEAP32[($2 + 80 | 0) >> 2] | 0;
  HEAP32[($2 + 100 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__crypto__Ed25519Signature__from_bytes__hf5afe24ffdbd3318($2 + 8 | 0 | 0, $2 + 96 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 8 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  HEAP8[($2 + 98 | 0) >> 0] = HEAPU8[($2 + 11 | 0) >> 0] | 0;
  HEAP16[($2 + 96 | 0) >> 1] = HEAPU8[($2 + 9 | 0) >> 0] | 0 | ((HEAPU8[($2 + 10 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 99 | 0) >> 0] = $1;
  HEAP8[($2 + 100 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 101 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 102 | 0) >> 0] = $1 >>> 24 | 0;
  memcpy($2 + 96 | 0 | 7 | 0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 57 | 0) | 0;
  $1 = $cardano_serialization_lib__crypto__Ed25519Signature_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h20d7210aa6eb2b19($2 + 96 | 0 | 0) | 0;
  global$0 = $2 + 160 | 0;
  return $1 | 0;
 }
 
 function ed25519keyhash_from_bech32($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $9 = 0, $10 = 0, $11 = 0, $40 = 0, $45 = 0, $57 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  HEAP32[($2 + 52 | 0) >> 2] = $1;
  $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  HEAP32[($2 + 48 | 0) >> 2] = $0;
  cardano_serialization_lib__crypto__Ed25519KeyHash__from_bech32__h8e5db0771bf3fadc($2 + 16 | 0 | 0, $0 | 0, $1 | 0);
  core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_2($2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 16 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = $2 + 32 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $40 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 63 | 0;
  $9 = $40;
  HEAP8[i64toi32_i32$0 >> 0] = $9;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $9 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $9 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $9 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 37 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $45 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 68 | 0;
  $10 = $45;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP8[($2 + 50 | 0) >> 0] = HEAPU8[($2 + 19 | 0) >> 0] | 0;
  HEAP16[($2 + 48 | 0) >> 1] = HEAPU8[($2 + 17 | 0) >> 0] | 0 | ((HEAPU8[($2 + 18 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 51 | 0) >> 0] = $1;
  HEAP8[($2 + 52 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 53 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 54 | 0) >> 0] = $1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 24 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $57 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  $11 = $57;
  HEAP8[($2 + 55 | 0) >> 0] = $11;
  HEAP8[($2 + 56 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[($2 + 57 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[($2 + 58 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[($2 + 59 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[($2 + 60 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[($2 + 61 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[($2 + 62 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $1 = $cardano_serialization_lib__crypto__Ed25519KeyHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hd63cf82b6a769066($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 80 | 0;
  return $1 | 0;
 }
 
 function scripthash_from_bech32($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $9 = 0, $10 = 0, $11 = 0, $40 = 0, $45 = 0, $57 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  HEAP32[($2 + 52 | 0) >> 2] = $1;
  $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  HEAP32[($2 + 48 | 0) >> 2] = $0;
  cardano_serialization_lib__crypto__ScriptHash__from_bech32__hefbc370370a0c52a($2 + 16 | 0 | 0, $0 | 0, $1 | 0);
  core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_2($2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 16 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = $2 + 32 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $40 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 63 | 0;
  $9 = $40;
  HEAP8[i64toi32_i32$0 >> 0] = $9;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $9 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $9 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $9 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 37 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $45 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 68 | 0;
  $10 = $45;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP8[($2 + 50 | 0) >> 0] = HEAPU8[($2 + 19 | 0) >> 0] | 0;
  HEAP16[($2 + 48 | 0) >> 1] = HEAPU8[($2 + 17 | 0) >> 0] | 0 | ((HEAPU8[($2 + 18 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 51 | 0) >> 0] = $1;
  HEAP8[($2 + 52 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 53 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 54 | 0) >> 0] = $1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 24 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $57 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  $11 = $57;
  HEAP8[($2 + 55 | 0) >> 0] = $11;
  HEAP8[($2 + 56 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[($2 + 57 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[($2 + 58 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[($2 + 59 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[($2 + 60 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[($2 + 61 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[($2 + 62 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $1 = $cardano_serialization_lib__crypto__ScriptHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hcd9bcfbb1bcf9de7($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 80 | 0;
  return $1 | 0;
 }
 
 function genesisdelegatehash_from_bech32($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $9 = 0, $10 = 0, $11 = 0, $40 = 0, $45 = 0, $57 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  HEAP32[($2 + 52 | 0) >> 2] = $1;
  $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  HEAP32[($2 + 48 | 0) >> 2] = $0;
  cardano_serialization_lib__crypto__GenesisDelegateHash__from_bech32__hbb851a692b2f068b($2 + 16 | 0 | 0, $0 | 0, $1 | 0);
  core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_2($2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 16 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = $2 + 32 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $40 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 63 | 0;
  $9 = $40;
  HEAP8[i64toi32_i32$0 >> 0] = $9;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $9 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $9 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $9 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 37 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $45 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 68 | 0;
  $10 = $45;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP8[($2 + 50 | 0) >> 0] = HEAPU8[($2 + 19 | 0) >> 0] | 0;
  HEAP16[($2 + 48 | 0) >> 1] = HEAPU8[($2 + 17 | 0) >> 0] | 0 | ((HEAPU8[($2 + 18 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 51 | 0) >> 0] = $1;
  HEAP8[($2 + 52 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 53 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 54 | 0) >> 0] = $1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 24 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $57 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  $11 = $57;
  HEAP8[($2 + 55 | 0) >> 0] = $11;
  HEAP8[($2 + 56 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[($2 + 57 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[($2 + 58 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[($2 + 59 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[($2 + 60 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[($2 + 61 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[($2 + 62 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $1 = $cardano_serialization_lib__crypto__GenesisDelegateHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h829122a765b38e99($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 80 | 0;
  return $1 | 0;
 }
 
 function genesishash_from_bech32($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $9 = 0, $10 = 0, $11 = 0, $40 = 0, $45 = 0, $57 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  HEAP32[($2 + 52 | 0) >> 2] = $1;
  $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  HEAP32[($2 + 48 | 0) >> 2] = $0;
  cardano_serialization_lib__crypto__GenesisHash__from_bech32__hf73e448ecc0e7f72($2 + 16 | 0 | 0, $0 | 0, $1 | 0);
  core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_2($2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 16 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = $2 + 32 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $40 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 63 | 0;
  $9 = $40;
  HEAP8[i64toi32_i32$0 >> 0] = $9;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $9 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $9 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $9 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 37 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $45 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 68 | 0;
  $10 = $45;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP8[($2 + 50 | 0) >> 0] = HEAPU8[($2 + 19 | 0) >> 0] | 0;
  HEAP16[($2 + 48 | 0) >> 1] = HEAPU8[($2 + 17 | 0) >> 0] | 0 | ((HEAPU8[($2 + 18 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 51 | 0) >> 0] = $1;
  HEAP8[($2 + 52 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 53 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 54 | 0) >> 0] = $1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 24 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $57 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  $11 = $57;
  HEAP8[($2 + 55 | 0) >> 0] = $11;
  HEAP8[($2 + 56 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[($2 + 57 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[($2 + 58 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[($2 + 59 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[($2 + 60 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[($2 + 61 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[($2 + 62 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $1 = $cardano_serialization_lib__crypto__GenesisHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hedc49afed5ec6de0($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 80 | 0;
  return $1 | 0;
 }
 
 function plutuswitness_new($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, $5 = 0;
  $3 = global$0 - 320 | 0;
  global$0 = $3;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hf3651990986a0e62($3 + 24 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($3 + 28 | 0) >> 2] | 0;
   $4 = HEAP32[($3 + 24 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb1fd14a6870cafe2($3 + 16 | 0 | 0, $1 | 0);
   if (!$2) {
    break label$1
   }
   $1 = HEAP32[($3 + 20 | 0) >> 2] | 0;
   $5 = HEAP32[($3 + 16 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h388263144730eb6a($3 + 8 | 0 | 0, $2 | 0);
   $2 = HEAP32[($3 + 12 | 0) >> 2] | 0;
   cardano_serialization_lib__tx_builder__tx_inputs_builder__PlutusWitness__new__h08627c59068b8908($3 + 32 | 0 | 0, $4 | 0, $5 | 0, HEAP32[($3 + 8 | 0) >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   memcpy($3 + 176 | 0 | 0, $3 + 32 | 0 | 0, 144 | 0) | 0;
   $0 = $cardano_serialization_lib__tx_builder__tx_inputs_builder__PlutusWitness_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h43043aa66f99997b($3 + 176 | 0 | 0) | 0;
   global$0 = $3 + 320 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function baseaddress_stake_cred($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $20 = 0, $2 = 0, $3 = 0, $4 = 0, $5 = 0, $22 = 0, $28 = 0, $37 = 0, $48 = 0, $52 = 0, $61 = 0;
  $1 = global$0 - 112 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h41e273aed1ab619e($1 + 8 | 0 | 0, $0 | 0);
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $3 = $1 + 24 | 0;
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $0 + 39 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $22 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $22;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $4 = $1 + 32 | 0;
  i64toi32_i32$2 = $0 + 47 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $4;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $5 = $1 + 40 | 0;
  $15 = $0 + 55 | 0;
  HEAP32[$5 >> 2] = HEAPU8[$15 >> 0] | 0 | ((HEAPU8[($15 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($15 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($15 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 31 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 32 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 33 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 34 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 35 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 36 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 37 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 38 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $37 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 16 | 0) >> 2] = $37;
  HEAP32[($1 + 20 | 0) >> 2] = i64toi32_i32$1;
  $0 = HEAPU8[(i64toi32_i32$2 + 30 | 0) >> 0] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $48 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 89 | 0;
  $16 = $48;
  HEAP8[i64toi32_i32$1 >> 0] = $16;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $16 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $52 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 97 | 0;
  $17 = $52;
  HEAP8[i64toi32_i32$0 >> 0] = $17;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $17 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $17 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $17 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $18 = $1 + 105 | 0;
  $19 = HEAP32[$5 >> 2] | 0;
  HEAP8[$18 >> 0] = $19;
  HEAP8[($18 + 1 | 0) >> 0] = $19 >>> 8 | 0;
  HEAP8[($18 + 2 | 0) >> 0] = $19 >>> 16 | 0;
  HEAP8[($18 + 3 | 0) >> 0] = $19 >>> 24 | 0;
  HEAP8[($1 + 80 | 0) >> 0] = $0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $61 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  $20 = $61;
  HEAP8[(i64toi32_i32$2 + 81 | 0) >> 0] = $20;
  HEAP8[(i64toi32_i32$2 + 82 | 0) >> 0] = $20 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 83 | 0) >> 0] = $20 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 84 | 0) >> 0] = $20 >>> 24 | 0;
  HEAP8[(i64toi32_i32$2 + 85 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$2 + 86 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$2 + 87 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$2 + 88 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $0 = $cardano_serialization_lib__address__StakeCredential_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hfe6826a4b7739a89(i64toi32_i32$2 + 80 | 0 | 0) | 0;
  global$0 = i64toi32_i32$2 + 112 | 0;
  return $0 | 0;
 }
 
 function num_bigint__biguint__convert__to_str_radix_reversed__h8137d6cf34f7ce10($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, $3 = 0, i64toi32_i32$1 = 0, $4 = 0, $38 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    if (($2 + -2 | 0) >>> 0 > 34 >>> 0) {
     break label$2
    }
    label$3 : {
     label$4 : {
      if (!(HEAP32[($1 + 8 | 0) >> 2] | 0)) {
       break label$4
      }
      num_bigint__biguint__convert__to_radix_le__h73e11ba14c242b2c($3 | 0, $1 | 0, $2 | 0);
      label$5 : {
       $1 = HEAP32[($3 + 8 | 0) >> 2] | 0;
       if (!$1) {
        break label$5
       }
       $2 = HEAP32[$3 >> 2] | 0;
       label$6 : while (1) {
        $4 = HEAPU8[$2 >> 0] | 0;
        HEAP8[$2 >> 0] = ($4 >>> 0 < 10 >>> 0 ? 48 : 87) + $4 | 0;
        $2 = $2 + 1 | 0;
        $1 = $1 + -1 | 0;
        if ($1) {
         continue label$6
        }
        break label$6;
       };
      }
      i64toi32_i32$0 = HEAP32[$3 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($3 + 4 | 0) >> 2] | 0;
      $38 = i64toi32_i32$0;
      i64toi32_i32$0 = $0;
      HEAP32[i64toi32_i32$0 >> 2] = $38;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($3 + 8 | 0) >> 2] | 0;
      break label$3;
     }
     $2 = __rust_alloc(1 | 0, 1 | 0) | 0;
     if (!$2) {
      break label$1
     }
     i64toi32_i32$0 = $0;
     i64toi32_i32$1 = 1;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = 1;
     HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[i64toi32_i32$0 >> 2] = $2;
     HEAP8[$2 >> 0] = 48;
    }
    global$0 = $3 + 16 | 0;
    return;
   }
   std__panicking__begin_panic__hf55b754840077f11(1078428 | 0, 31 | 0, 1078460 | 0);
   abort();
  }
  alloc__alloc__handle_alloc_error__he269d8f1bff90960(1 | 0, 1 | 0);
  abort();
 }
 
 function ryu__pretty__mantissa__write_mantissa_long__h41cacf0fc85ea93b($0, $0$hi, $1) {
  $0 = $0 | 0;
  $0$hi = $0$hi | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $3 = 0, $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $2 = 0, $7 = 0, i64toi32_i32$5 = 0, $7$hi = 0, i64toi32_i32$4 = 0, $5 = 0, $6 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $23 = 0, $24 = 0, $25 = 0, $26 = 0, $27 = 0, $28 = 0, $29 = 0, $14 = 0, $18$hi = 0;
  label$1 : {
   label$2 : {
    i64toi32_i32$0 = $0$hi;
    i64toi32_i32$2 = $0;
    i64toi32_i32$1 = 1;
    i64toi32_i32$3 = 0;
    if (i64toi32_i32$0 >>> 0 > i64toi32_i32$1 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$2 >>> 0 >= i64toi32_i32$3 >>> 0 | 0) | 0) {
     break label$2
    }
    $2 = $1;
    i64toi32_i32$2 = $0$hi;
    $7 = $0;
    $7$hi = i64toi32_i32$2;
    break label$1;
   }
   $2 = $1 + -8 | 0;
   $14 = $2;
   i64toi32_i32$2 = $0$hi;
   i64toi32_i32$0 = 0;
   i64toi32_i32$0 = __wasm_i64_udiv($0 | 0, i64toi32_i32$2 | 0, 1e8 | 0, i64toi32_i32$0 | 0) | 0;
   i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
   $7 = i64toi32_i32$0;
   $7$hi = i64toi32_i32$2;
   i64toi32_i32$0 = -1;
   i64toi32_i32$0 = __wasm_i64_mul($7 | 0, i64toi32_i32$2 | 0, -1e8 | 0, i64toi32_i32$0 | 0) | 0;
   i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
   $18$hi = i64toi32_i32$2;
   i64toi32_i32$2 = $0$hi;
   i64toi32_i32$2 = $18$hi;
   i64toi32_i32$3 = i64toi32_i32$0;
   i64toi32_i32$0 = $0$hi;
   i64toi32_i32$1 = $0;
   i64toi32_i32$4 = i64toi32_i32$3 + $0 | 0;
   i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
   if (i64toi32_i32$4 >>> 0 < $0 >>> 0) {
    i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
   }
   $3 = i64toi32_i32$4;
   $4 = ($3 >>> 0) / (1e4 >>> 0) | 0;
   $5 = ($4 >>> 0) % (1e4 >>> 0) | 0;
   $6 = ($5 >>> 0) / (100 >>> 0) | 0;
   $18 = ($6 << 1 | 0) + 1100304 | 0;
   $19 = $14;
   $20 = HEAPU8[$18 >> 0] | 0 | ((HEAPU8[($18 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
   HEAP8[$19 >> 0] = $20;
   HEAP8[($19 + 1 | 0) >> 0] = $20 >>> 8 | 0;
   $3 = $3 - Math_imul($4, 1e4) | 0;
   $4 = (($3 & 65535 | 0) >>> 0) / (100 >>> 0) | 0;
   $21 = ($4 << 1 | 0) + 1100304 | 0;
   $22 = $1 + -4 | 0;
   $23 = HEAPU8[$21 >> 0] | 0 | ((HEAPU8[($21 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
   HEAP8[$22 >> 0] = $23;
   HEAP8[($22 + 1 | 0) >> 0] = $23 >>> 8 | 0;
   $24 = ((($5 - Math_imul($6, 100) | 0) & 65535 | 0) << 1 | 0) + 1100304 | 0;
   $25 = $1 + -6 | 0;
   $26 = HEAPU8[$24 >> 0] | 0 | ((HEAPU8[($24 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
   HEAP8[$25 >> 0] = $26;
   HEAP8[($25 + 1 | 0) >> 0] = $26 >>> 8 | 0;
   $27 = ((($3 - Math_imul($4, 100) | 0) & 65535 | 0) << 1 | 0) + 1100304 | 0;
   $28 = $1 + -2 | 0;
   $29 = HEAPU8[$27 >> 0] | 0 | ((HEAPU8[($27 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
   HEAP8[$28 >> 0] = $29;
   HEAP8[($28 + 1 | 0) >> 0] = $29 >>> 8 | 0;
  }
  i64toi32_i32$5 = $7$hi;
  ryu__pretty__mantissa__write_mantissa__h7421817dc3be69e8($7 | 0, $2 | 0);
 }
 
 function cardano_serialization_lib__TransactionInputs__add__hd344995baacebe36($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $3 = 0, $4 = 0, $5 = 0, $15 = 0, $21 = 0, $27 = 0, $30 = 0, $6 = 0, $50 = 0, $56 = 0, $60 = 0, $64 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  $3 = $2 + 24 | 0;
  i64toi32_i32$2 = $1 + 28 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $15;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $4 = $2 + 16 | 0;
  i64toi32_i32$2 = $1 + 20 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $4;
  HEAP32[i64toi32_i32$1 >> 2] = $21;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $5 = $2 + 8 | 0;
  i64toi32_i32$2 = $1 + 12 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $27 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[i64toi32_i32$0 >> 2] = $27;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  $30 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $6 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  label$1 : {
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (($1 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
    break label$1
   }
   alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hf274e025df11641c($0 | 0, $1 | 0, 1 | 0);
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  }
  $1 = (HEAP32[$0 >> 2] | 0) + Math_imul($1, 36) | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $50 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $50;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[i64toi32_i32$0 >> 2] = $6;
  i64toi32_i32$2 = $5;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $56 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 12 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $56;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $60 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 20 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $60;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $64 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 28 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $64;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
  global$0 = $2 + 32 | 0;
 }
 
 function cardano_serialization_lib__StakeCredentials__add__hbdfa8a13eb787e70($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $2 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $20 = 0, $22 = 0, $3 = 0, $4 = 0, $5 = 0, $15 = 0, $21 = 0, $30 = 0, $6 = 0, $50 = 0, $56 = 0, $60 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  $3 = $2 + 8 | 0;
  i64toi32_i32$2 = $1 + 9 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $15;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $4 = $2 + 16 | 0;
  i64toi32_i32$2 = $1 + 17 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $4;
  HEAP32[i64toi32_i32$1 >> 2] = $21;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $5 = $2 + 24 | 0;
  $16 = $1 + 25 | 0;
  HEAP32[$5 >> 2] = HEAPU8[$16 >> 0] | 0 | ((HEAPU8[($16 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($16 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($16 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $30;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $6 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
  label$1 : {
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (($1 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
    break label$1
   }
   alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__ha457b0dea7cc7a33($0 | 0, $1 | 0, 1 | 0);
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  }
  $1 = (HEAP32[$0 >> 2] | 0) + Math_imul($1, 29) | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $50 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  $17 = $50;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = $17 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 8 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP8[i64toi32_i32$1 >> 0] = $6;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $56 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 9 | 0;
  $18 = $56;
  HEAP8[i64toi32_i32$0 >> 0] = $18;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $18 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $18 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $18 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $60 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 17 | 0;
  $19 = $60;
  HEAP8[i64toi32_i32$1 >> 0] = $19;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $19 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $19 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $19 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $20 = $1 + 25 | 0;
  $22 = HEAP32[$5 >> 2] | 0;
  HEAP8[$20 >> 0] = $22;
  HEAP8[($20 + 1 | 0) >> 0] = $22 >>> 8 | 0;
  HEAP8[($20 + 2 | 0) >> 0] = $22 >>> 16 | 0;
  HEAP8[($20 + 3 | 0) >> 0] = $22 >>> 24 | 0;
  HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
  global$0 = $2 + 64 | 0;
 }
 
 function withdrawals_insert($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, $5 = 0, $6 = 0, $7 = 0, $7$hi = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h93c478ef73ae4bb6($3 + 40 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $4 = HEAP32[($3 + 44 | 0) >> 2] | 0;
   $5 = HEAP32[($3 + 40 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h2338c90e0327d08b($3 + 32 | 0 | 0, $1 | 0);
   if (!$2) {
    break label$1
   }
   $0 = HEAP32[($3 + 36 | 0) >> 2] | 0;
   $6 = HEAP32[($3 + 32 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($3 + 24 | 0 | 0, $2 | 0);
   $1 = HEAP32[($3 + 28 | 0) >> 2] | 0;
   cardano_serialization_lib__Withdrawals__insert__h7293d9cdbbe52c19($3 + 8 | 0 | 0, $5 | 0, $6 | 0, HEAP32[($3 + 24 | 0) >> 2] | 0 | 0);
   i64toi32_i32$0 = HEAP32[($3 + 16 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($3 + 20 | 0) >> 2] | 0;
   $7 = i64toi32_i32$0;
   $7$hi = i64toi32_i32$1;
   i64toi32_i32$1 = HEAP32[($3 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($3 + 12 | 0) >> 2] | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   $0 = 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($4 | 0, 0 | 0) | 0;
   label$2 : {
    if (!i64toi32_i32$1) {
     break label$2
    }
    i64toi32_i32$0 = $7$hi;
    $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810($7 | 0, i64toi32_i32$0 | 0) | 0;
   }
   global$0 = $3 + 48 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function auxiliarydataset_indices($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $4 = 0, $3 = 0, $5 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if (!$1) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h786c2d78691f35ff($2 + 8 | 0 | 0, $1 | 0);
   $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   label$2 : {
    label$3 : {
     $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
     $4 = HEAP32[($3 + 32 | 0) >> 2] | 0;
     if ($4) {
      break label$3
     }
     $5 = 0;
     break label$2;
    }
    $5 = HEAP32[($4 + 68 | 0) >> 2] | 0;
   }
   HEAP32[($2 + 40 | 0) >> 2] = HEAP32[($3 + 28 | 0) >> 2] | 0;
   HEAP32[($2 + 36 | 0) >> 2] = $4;
   HEAP32[($2 + 32 | 0) >> 2] = $5;
   $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__h54ef63b5f8737164($2 + 16 | 0 | 0, $2 + 32 | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   $1 = ($2 + 32 | 0) + 8 | 0;
   HEAP32[$1 >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   HEAP32[($2 + 32 | 0) >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
   HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
   alloc__vec__Vec_T_2cA___shrink_to_fit__ha42fb43b13607cf8($2 + 32 | 0 | 0);
   $4 = HEAP32[($2 + 32 | 0) >> 2] | 0;
   HEAP32[($0 + 4 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
   HEAP32[$0 >> 2] = $4;
   global$0 = $2 + 48 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function cardano_serialization_lib__NetworkId__from_bytes__h178037d1c177e3ad($0) {
  $0 = $0 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $1 = 0, $2 = 0, $2$hi = 0, $4$hi = 0, $3 = 0, $3$hi = 0, $4 = 0, $18 = 0, $19 = 0, $20 = 0, $16 = 0, $52 = 0, $52$hi = 0, $55 = 0, $55$hi = 0;
  $1 = global$0 - 176 | 0;
  global$0 = $1;
  HEAP32[($1 + 168 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = 0;
  $2 = 0;
  $2$hi = i64toi32_i32$0;
  i64toi32_i32$1 = $1;
  i64toi32_i32$0 = 0;
  HEAP32[($1 + 152 | 0) >> 2] = 0;
  HEAP32[($1 + 156 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $16 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[(i64toi32_i32$0 + 160 | 0) >> 2] = $16;
  HEAP32[(i64toi32_i32$0 + 164 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__NetworkId___deserialize__h50b68885855d805d(i64toi32_i32$0 + 80 | 0 | 0, i64toi32_i32$0 + 152 | 0 | 0);
  $0 = (i64toi32_i32$0 + 152 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAPU8[(i64toi32_i32$0 + 80 | 0) >> 0] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 81 | 0) >> 0] | 0;
    i64toi32_i32$0 = 0;
    $3 = i64toi32_i32$1;
    $3$hi = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    $4 = 0;
    $4$hi = i64toi32_i32$0;
    break label$1;
   }
   memcpy($1 + 80 | 0 | 0, memcpy($1 + 16 | 0 | 0, ($1 + 80 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   i64toi32_i32$0 = 0;
   $2 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($1 + 80 | 0 | 0) | 0;
   $2$hi = i64toi32_i32$0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = 0;
   i64toi32_i32$3 = 24;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
    $18 = 0;
   } else {
    i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
    $18 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   }
   $3 = $18;
   $3$hi = i64toi32_i32$1;
   i64toi32_i32$1 = $2$hi;
   i64toi32_i32$0 = $2;
   i64toi32_i32$2 = 0;
   i64toi32_i32$3 = 32;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
    $19 = 0;
   } else {
    i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
    $19 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   }
   $2 = $19;
   $2$hi = i64toi32_i32$2;
   i64toi32_i32$2 = 0;
   $4 = 1;
   $4$hi = i64toi32_i32$2;
  }
  global$0 = $1 + 176 | 0;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$2 = $2$hi;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$1 = $4;
  i64toi32_i32$0 = $2$hi;
  i64toi32_i32$3 = $2;
  i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
  $52 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  $52$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $3$hi;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 8;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $20 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $20 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  i64toi32_i32$0 = $20;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 65280;
  i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
  $55 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
  $55$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $52$hi;
  i64toi32_i32$1 = $52;
  i64toi32_i32$0 = $55$hi;
  i64toi32_i32$3 = $55;
  i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
  i64toi32_i32$1 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$0;
  return i64toi32_i32$1 | 0;
 }
 
 function cryptoxide__chacha20poly1305__Context_____new__h0cc47d548a2f122a($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0;
  $5 = global$0 - 272 | 0;
  global$0 = $5;
  label$1 : {
   label$2 : {
    label$3 : {
     if (($2 | 0) == (32 | 0)) {
      break label$3
     }
     if (($2 | 0) != (16 | 0)) {
      break label$2
     }
    }
    if (($4 & -5 | 0 | 0) == (8 | 0)) {
     break label$1
    }
    core__panicking__panic__h2fd385a887c8bf13(1055048 | 0, 55 | 0, 1055104 | 0);
    abort();
   }
   core__panicking__panic__h2fd385a887c8bf13(1054977 | 0, 52 | 0, 1055032 | 0);
   abort();
  }
  cryptoxide__chacha20__ChaCha_____new__h5f52927ec1f00d74($5 + 8 | 0 | 0, $1 | 0, $2 | 0, $3 | 0, $4 | 0);
  memset($5 + 144 | 0 | 0, 0 | 0, 64 | 0) | 0;
  memset($5 + 208 | 0 | 0, 0 | 0, 64 | 0) | 0;
  cryptoxide__chacha20__ChaCha_____process__h1d8c0590222f71eb($5 + 8 | 0 | 0, $5 + 208 | 0 | 0, 64 | 0, $5 + 144 | 0 | 0, 64 | 0);
  cryptoxide__poly1305__Poly1305__new__haf9648a01e3507f3($0 + 148 | 0 | 0, $5 + 144 | 0 | 0, 32 | 0);
  memcpy($0 + 16 | 0 | 0, $5 + 8 | 0 | 0, 132 | 0) | 0;
  i64toi32_i32$1 = $0 + 8 | 0;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$1 = $0;
  i64toi32_i32$0 = 0;
  HEAP32[$0 >> 2] = 0;
  HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $5 + 272 | 0;
 }
 
 function transactionunspentoutput_input($0) {
  $0 = $0 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $1 = 0, $2 = 0, $3 = 0, $4 = 0, $5 = 0, $19 = 0, $25 = 0, $31 = 0, $35 = 0, $48 = 0, $52 = 0, $56 = 0, $61 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hbebd755b3868aed3($1 | 0, $0 | 0);
  $2 = $1 + 16 | 0;
  $0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$2 = $0 + 140 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $19;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $3 = $1 + 24 | 0;
  i64toi32_i32$2 = $0 + 148 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $25 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[i64toi32_i32$1 >> 2] = $25;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = $1 + 32 | 0;
  i64toi32_i32$2 = $0 + 156 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[i64toi32_i32$0 >> 2] = $31;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $0 + 132 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $35 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $35;
  HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
  $0 = HEAP32[($0 + 128 | 0) >> 2] | 0;
  $5 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($5 | 0, (HEAP32[$5 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $48 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 52 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $48;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $52 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 60 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $52;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $56 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 68 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $56;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 40 | 0) >> 2] = $0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $61 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$1 + 44 | 0) >> 2] = $61;
  HEAP32[(i64toi32_i32$1 + 48 | 0) >> 2] = i64toi32_i32$0;
  $0 = $cardano_serialization_lib__TransactionInput_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hf06f9abbcbb78385(i64toi32_i32$1 + 40 | 0 | 0) | 0;
  global$0 = i64toi32_i32$1 + 80 | 0;
  return $0 | 0;
 }
 
 function cardano_serialization_lib__metadata__GeneralTransactionMetadata__get__h0ea75f89e237b87a($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $27 = 0, $32 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    $1 = linked_hash_map__LinkedHashMap_K_2cV_2cS___get__hf6a483159ed52c35($1 | 0, $2 | 0) | 0;
    if ($1) {
     break label$2
    }
    HEAP32[$0 >> 2] = 5;
    break label$1;
   }
   label$3 : {
    label$4 : {
     switch (HEAP32[$1 >> 2] | 0 | 0) {
     default:
      $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__hdeea20968268d729($3 + 8 | 0 | 0, $1 + 8 | 0 | 0);
      HEAP32[$3 >> 2] = 0;
      break label$3;
     case 1:
      $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hf69db734dd831996($3 | 4 | 0 | 0, $1 + 4 | 0 | 0);
      HEAP32[$3 >> 2] = 1;
      break label$3;
     case 2:
      i64toi32_i32$2 = $1;
      i64toi32_i32$0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($1 + 12 | 0) >> 2] | 0;
      $27 = i64toi32_i32$0;
      i64toi32_i32$0 = $3 + 8 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $27;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$2 = $1 + 16 | 0;
      i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $32 = i64toi32_i32$1;
      i64toi32_i32$1 = $3 + 16 | 0;
      HEAP32[i64toi32_i32$1 >> 2] = $32;
      HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
      HEAP32[$3 >> 2] = 2;
      break label$3;
     case 3:
      $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($3 | 4 | 0 | 0, $1 + 4 | 0 | 0);
      HEAP32[$3 >> 2] = 3;
      break label$3;
     case 4:
      break label$4;
     };
    }
    $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($3 | 4 | 0 | 0, $1 + 4 | 0 | 0);
    HEAP32[$3 >> 2] = 4;
   }
   memcpy($0 | 0, $3 | 0, 48 | 0) | 0;
  }
  global$0 = $3 + 48 | 0;
 }
 
 function transactionbuilder_get_implicit_input($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $2 = 0, $38 = 0, $45 = 0, $50 = 0;
  $1 = global$0 - 64 | 0;
  global$0 = $1;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h37dfbd2f31d951c1($1 | 0, $0 | 0);
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $0 = HEAP32[$1 >> 2] | 0;
    cardano_serialization_lib__utils__internal_get_implicit_input__h61eaf21c0f86e6a4($1 + 8 | 0 | 0, $0 + 288 | 0 | 0, $0 + 428 | 0 | 0, $0 + 16 | 0 | 0, $0 + 24 | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
    if ((HEAP32[($1 + 8 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    i64toi32_i32$2 = ($1 + 8 | 0) + 24 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $38 = i64toi32_i32$0;
    i64toi32_i32$0 = ($1 + 40 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $38;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = ($1 + 8 | 0) + 16 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $45 = i64toi32_i32$1;
    i64toi32_i32$1 = ($1 + 40 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $45;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = ($1 + 8 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $50 = i64toi32_i32$0;
    i64toi32_i32$0 = $1;
    HEAP32[($1 + 40 | 0) >> 2] = $50;
    HEAP32[($1 + 44 | 0) >> 2] = i64toi32_i32$1;
    $0 = $cardano_serialization_lib__utils__Value_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h50a1108e1e08f966($1 + 40 | 0 | 0) | 0;
    global$0 = $1 + 64 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($1 + 12 | 0) >> 2] | 0 | 0);
  abort();
 }
 
 function txinputsbuilder_add_key_input($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $5 = 0, $6 = 0, $7 = 0, $8 = 0;
  $4 = global$0 - 32 | 0;
  global$0 = $4;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hf277c6a2d5f089a3($4 + 24 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $5 = HEAP32[($4 + 28 | 0) >> 2] | 0;
   $6 = HEAP32[($4 + 24 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hae9c55c4e91ce40f($4 + 16 | 0 | 0, $1 | 0);
   if (!$2) {
    break label$1
   }
   $0 = HEAP32[($4 + 20 | 0) >> 2] | 0;
   $7 = HEAP32[($4 + 16 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hd7bc050864a8d646($4 + 8 | 0 | 0, $2 | 0);
   if (!$3) {
    break label$1
   }
   $1 = HEAP32[($4 + 12 | 0) >> 2] | 0;
   $8 = HEAP32[($4 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h5db5149478ec5345($4 | 0, $3 | 0);
   $2 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__add_key_input__hcbbcffc3c6e022ad($6 | 0, $7 | 0, $8 | 0, HEAP32[$4 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($5 | 0, 0 | 0) | 0;
   global$0 = $4 + 32 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function txinputsbuilder_add_script_input($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $5 = 0, $6 = 0, $7 = 0, $8 = 0;
  $4 = global$0 - 32 | 0;
  global$0 = $4;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hf277c6a2d5f089a3($4 + 24 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $5 = HEAP32[($4 + 28 | 0) >> 2] | 0;
   $6 = HEAP32[($4 + 24 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h27da893e95dd15cf($4 + 16 | 0 | 0, $1 | 0);
   if (!$2) {
    break label$1
   }
   $0 = HEAP32[($4 + 20 | 0) >> 2] | 0;
   $7 = HEAP32[($4 + 16 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hd7bc050864a8d646($4 + 8 | 0 | 0, $2 | 0);
   if (!$3) {
    break label$1
   }
   $1 = HEAP32[($4 + 12 | 0) >> 2] | 0;
   $8 = HEAP32[($4 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h5db5149478ec5345($4 | 0, $3 | 0);
   $2 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__add_script_input__ha8e1111a100bff34($6 | 0, $7 | 0, $8 | 0, HEAP32[$4 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($5 | 0, 0 | 0) | 0;
   global$0 = $4 + 32 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function txinputsbuilder_add_native_script_input($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $5 = 0, $6 = 0, $7 = 0, $8 = 0;
  $4 = global$0 - 32 | 0;
  global$0 = $4;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hf277c6a2d5f089a3($4 + 24 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $5 = HEAP32[($4 + 28 | 0) >> 2] | 0;
   $6 = HEAP32[($4 + 24 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h6ed0b6b043905434($4 + 16 | 0 | 0, $1 | 0);
   if (!$2) {
    break label$1
   }
   $0 = HEAP32[($4 + 20 | 0) >> 2] | 0;
   $7 = HEAP32[($4 + 16 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hd7bc050864a8d646($4 + 8 | 0 | 0, $2 | 0);
   if (!$3) {
    break label$1
   }
   $1 = HEAP32[($4 + 12 | 0) >> 2] | 0;
   $8 = HEAP32[($4 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h5db5149478ec5345($4 | 0, $3 | 0);
   $2 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__add_native_script_input__h3e7dddcfb342ebab($6 | 0, $7 | 0, $8 | 0, HEAP32[$4 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($5 | 0, 0 | 0) | 0;
   global$0 = $4 + 32 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function txinputsbuilder_add_plutus_script_input($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $5 = 0, $6 = 0, $7 = 0, $8 = 0;
  $4 = global$0 - 32 | 0;
  global$0 = $4;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hf277c6a2d5f089a3($4 + 24 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $5 = HEAP32[($4 + 28 | 0) >> 2] | 0;
   $6 = HEAP32[($4 + 24 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hbec83ebdd86caafd($4 + 16 | 0 | 0, $1 | 0);
   if (!$2) {
    break label$1
   }
   $0 = HEAP32[($4 + 20 | 0) >> 2] | 0;
   $7 = HEAP32[($4 + 16 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hd7bc050864a8d646($4 + 8 | 0 | 0, $2 | 0);
   if (!$3) {
    break label$1
   }
   $1 = HEAP32[($4 + 12 | 0) >> 2] | 0;
   $8 = HEAP32[($4 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h5db5149478ec5345($4 | 0, $3 | 0);
   $2 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__add_plutus_script_input__hdd1b935f94ddad7d($6 | 0, $7 | 0, $8 | 0, HEAP32[$4 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($5 | 0, 0 | 0) | 0;
   global$0 = $4 + 32 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function txinputsbuilder_add_bootstrap_input($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $5 = 0, $6 = 0, $7 = 0, $8 = 0;
  $4 = global$0 - 32 | 0;
  global$0 = $4;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hf277c6a2d5f089a3($4 + 24 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $5 = HEAP32[($4 + 28 | 0) >> 2] | 0;
   $6 = HEAP32[($4 + 24 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h76f3e067f9139bb4($4 + 16 | 0 | 0, $1 | 0);
   if (!$2) {
    break label$1
   }
   $0 = HEAP32[($4 + 20 | 0) >> 2] | 0;
   $7 = HEAP32[($4 + 16 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hd7bc050864a8d646($4 + 8 | 0 | 0, $2 | 0);
   if (!$3) {
    break label$1
   }
   $1 = HEAP32[($4 + 12 | 0) >> 2] | 0;
   $8 = HEAP32[($4 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h5db5149478ec5345($4 | 0, $3 | 0);
   $2 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__add_bootstrap_input__h233fca55423e7cf8($6 | 0, $7 | 0, $8 | 0, HEAP32[$4 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($5 | 0, 0 | 0) | 0;
   global$0 = $4 + 32 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function txinputsbuilder_add_input($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $5 = 0, $6 = 0, $7 = 0, $8 = 0;
  $4 = global$0 - 32 | 0;
  global$0 = $4;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hf277c6a2d5f089a3($4 + 24 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $5 = HEAP32[($4 + 28 | 0) >> 2] | 0;
   $6 = HEAP32[($4 + 24 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hab2c0cbdcb539b91($4 + 16 | 0 | 0, $1 | 0);
   if (!$2) {
    break label$1
   }
   $0 = HEAP32[($4 + 20 | 0) >> 2] | 0;
   $7 = HEAP32[($4 + 16 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hd7bc050864a8d646($4 + 8 | 0 | 0, $2 | 0);
   if (!$3) {
    break label$1
   }
   $1 = HEAP32[($4 + 12 | 0) >> 2] | 0;
   $8 = HEAP32[($4 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h5db5149478ec5345($4 | 0, $3 | 0);
   $2 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__add_input__hd22960e5a7d88824($6 | 0, $7 | 0, $8 | 0, HEAP32[$4 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($5 | 0, 0 | 0) | 0;
   global$0 = $4 + 32 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function pointer_new_pointer($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $4 = 0, $5 = 0, $6 = 0, $6$hi = 0, $7 = 0, $7$hi = 0, $59 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($3 + 16 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($3 + 20 | 0) >> 2] | 0;
   $4 = HEAP32[($3 + 16 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($3 + 8 | 0 | 0, $1 | 0);
   if (!$2) {
    break label$1
   }
   $1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
   $5 = HEAP32[($3 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($3 | 0, $2 | 0);
   i64toi32_i32$2 = $4;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $6 = i64toi32_i32$0;
   $6$hi = i64toi32_i32$1;
   i64toi32_i32$2 = $5;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $7 = i64toi32_i32$1;
   $7$hi = i64toi32_i32$0;
   i64toi32_i32$2 = HEAP32[$3 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $2 = HEAP32[($3 + 4 | 0) >> 2] | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   $59 = i64toi32_i32$0;
   i64toi32_i32$0 = $3;
   HEAP32[($3 + 40 | 0) >> 2] = $59;
   HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $7$hi;
   i64toi32_i32$0 = $3;
   HEAP32[($3 + 32 | 0) >> 2] = $7;
   HEAP32[($3 + 36 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $6$hi;
   i64toi32_i32$0 = $3;
   HEAP32[($3 + 24 | 0) >> 2] = $6;
   HEAP32[($3 + 28 | 0) >> 2] = i64toi32_i32$1;
   $0 = $cardano_serialization_lib__address__Pointer_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hce108dee3b07a283($3 + 24 | 0 | 0) | 0;
   global$0 = $3 + 48 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function $_cryptoxide__curve25519__ge__Ge_20as_20core__ops__arith__Add__cryptoxide__curve25519__ge__GePrecomp____add__h13dac0ca0b70905e($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0;
  $3 = global$0 - 240 | 0;
  global$0 = $3;
  $4 = $1 + 40 | 0;
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Add___add__he826ef0e90fce416($3 | 0, $4 | 0, $1 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Sub___sub__h676cb1e5fa77fb70($3 + 40 | 0 | 0, $4 | 0, $1 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($3 + 80 | 0 | 0, $3 | 0, $2 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($3 + 120 | 0 | 0, $3 + 40 | 0 | 0, $2 + 40 | 0 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($3 + 160 | 0 | 0, $2 + 80 | 0 | 0, $1 + 120 | 0 | 0);
  $1 = $1 + 80 | 0;
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Add___add__he826ef0e90fce416($3 + 200 | 0 | 0, $1 | 0, $1 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Sub___sub__h676cb1e5fa77fb70($0 | 0, $3 + 80 | 0 | 0, $3 + 120 | 0 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Add___add__he826ef0e90fce416($0 + 40 | 0 | 0, $3 + 80 | 0 | 0, $3 + 120 | 0 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Add___add__he826ef0e90fce416($0 + 80 | 0 | 0, $3 + 200 | 0 | 0, $3 + 160 | 0 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Sub___sub__h676cb1e5fa77fb70($0 + 120 | 0 | 0, $3 + 200 | 0 | 0, $3 + 160 | 0 | 0);
  global$0 = $3 + 240 | 0;
 }
 
 function $_cryptoxide__curve25519__ge__Ge_20as_20core__ops__arith__Sub__cryptoxide__curve25519__ge__GePrecomp____sub__h7efe15664f698169($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0;
  $3 = global$0 - 240 | 0;
  global$0 = $3;
  $4 = $1 + 40 | 0;
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Add___add__he826ef0e90fce416($3 | 0, $4 | 0, $1 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Sub___sub__h676cb1e5fa77fb70($3 + 40 | 0 | 0, $4 | 0, $1 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($3 + 80 | 0 | 0, $3 | 0, $2 + 40 | 0 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($3 + 120 | 0 | 0, $3 + 40 | 0 | 0, $2 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($3 + 160 | 0 | 0, $2 + 80 | 0 | 0, $1 + 120 | 0 | 0);
  $1 = $1 + 80 | 0;
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Add___add__he826ef0e90fce416($3 + 200 | 0 | 0, $1 | 0, $1 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Sub___sub__h676cb1e5fa77fb70($0 | 0, $3 + 80 | 0 | 0, $3 + 120 | 0 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Add___add__he826ef0e90fce416($0 + 40 | 0 | 0, $3 + 80 | 0 | 0, $3 + 120 | 0 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Sub___sub__h676cb1e5fa77fb70($0 + 80 | 0 | 0, $3 + 200 | 0 | 0, $3 + 160 | 0 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Add___add__he826ef0e90fce416($0 + 120 | 0 | 0, $3 + 200 | 0 | 0, $3 + 160 | 0 | 0);
  global$0 = $3 + 240 | 0;
 }
 
 function transactionmetadatum_as_text($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $31 = 0, $47 = 0, $54 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if (!$1) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__hc630c86c4ab6b26d($2 + 24 | 0 | 0, $1 | 0);
    $1 = HEAP32[($2 + 28 | 0) >> 2] | 0;
    cardano_serialization_lib__metadata__TransactionMetadatum__as_text__h4e821204929e96f1($2 + 32 | 0 | 0, HEAP32[($2 + 24 | 0) >> 2] | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
    $1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
    if ((HEAP32[($2 + 32 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    i64toi32_i32$2 = ($2 + 32 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $31 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[($2 + 52 | 0) >> 2] = $31;
    HEAP32[($2 + 56 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($2 + 48 | 0) >> 2] = $1;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
    HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[($2 + 48 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 52 | 0) >> 2] | 0;
    $47 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 64 | 0) >> 2] = $47;
    HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$0;
    alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 64 | 0 | 0);
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $54 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[i64toi32_i32$0 >> 2] = $54;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    global$0 = $2 + 80 | 0;
    return;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
  abort();
 }
 
 function $cardano_serialization_lib__chain_crypto__sign__SignatureError_20as_20core__fmt__Display___fmt__hc1e2bc8a8ccd1f41($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $28 = 0, $33 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if ((HEAP32[$0 >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    HEAP32[($2 + 16 | 0) >> 2] = $0 + 4 | 0;
    HEAP32[($2 + 20 | 0) >> 2] = $0 + 8 | 0;
    core__fmt__ArgumentV1__new__ha12055661e6add2a($2 + 8 | 0 | 0, $2 + 16 | 0 | 0, 88 | 0);
    i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    core__fmt__ArgumentV1__new__ha12055661e6add2a($2 | 0, $2 + 20 | 0 | 0, 88 | 0);
    HEAP32[($2 + 60 | 0) >> 2] = 2;
    $28 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[($2 + 24 | 0) >> 2] = $28;
    HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$0 = $2;
    i64toi32_i32$1 = 0;
    HEAP32[($2 + 44 | 0) >> 2] = 2;
    HEAP32[($2 + 48 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($2 + 40 | 0) >> 2] = 1061412;
    i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
    $33 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 32 | 0) >> 2] = $33;
    HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($2 + 56 | 0) >> 2] = $2 + 24 | 0;
    $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 40 | 0 | 0) | 0;
    break label$1;
   }
   HEAP32[($2 + 60 | 0) >> 2] = 0;
   HEAP32[($2 + 56 | 0) >> 2] = 1061336;
   i64toi32_i32$1 = $2;
   i64toi32_i32$0 = 0;
   HEAP32[($2 + 44 | 0) >> 2] = 1;
   HEAP32[($2 + 48 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($2 + 40 | 0) >> 2] = 1061364;
   $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 40 | 0 | 0) | 0;
  }
  global$0 = $2 + 64 | 0;
  return $0 | 0;
 }
 
 function alloc__vec__Vec_T_2cA___extend_desugared__h1420731a5ce41003($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $5 = 0, $4 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h36ca092f81b9a0fa($2 + 8 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    if (!$3) {
     break label$2
    }
    label$3 : while (1) {
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($2 + 16 | 0 | 0, $3 | 0);
     if (!(HEAP32[($2 + 16 | 0) >> 2] | 0)) {
      break label$1
     }
     label$4 : {
      $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
      if ((HEAP32[($0 + 4 | 0) >> 2] | 0 | 0) != ($3 | 0)) {
       break label$4
      }
      $4 = HEAP32[($1 + 24 | 0) >> 2] | 0;
      $5 = $4 + 1 | 0;
      alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hd40e78aa171f606d($0 | 0, $3 | 0, ($5 >>> 0 < $4 >>> 0 ? -1 : $5) | 0);
     }
     $4 = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
     $5 = (HEAP32[$0 >> 2] | 0) + Math_imul($3, 12) | 0;
     i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
     HEAP32[$5 >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
     HEAP32[($5 + 4 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($5 + 8 | 0) >> 2] = $4;
     HEAP32[($0 + 8 | 0) >> 2] = $3 + 1 | 0;
     $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h36ca092f81b9a0fa($2 | 0, $1 | 0);
     $3 = HEAP32[$2 >> 2] | 0;
     if ($3) {
      continue label$3
     }
     break label$3;
    };
   }
   HEAP32[($2 + 16 | 0) >> 2] = 0;
  }
  core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__AssetName____h5e309155feaabc90($2 + 16 | 0 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function alloc__vec__Vec_T_2cA___extend_desugared__he8baaa2bbd2fe744($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $5 = 0, $4 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__hce9499edf49fdc37($2 + 8 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    if (!$3) {
     break label$2
    }
    label$3 : while (1) {
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($2 + 16 | 0 | 0, $3 | 0);
     if (!(HEAP32[($2 + 16 | 0) >> 2] | 0)) {
      break label$1
     }
     label$4 : {
      $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
      if ((HEAP32[($0 + 4 | 0) >> 2] | 0 | 0) != ($3 | 0)) {
       break label$4
      }
      $4 = HEAP32[($1 + 24 | 0) >> 2] | 0;
      $5 = $4 + 1 | 0;
      alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hd40e78aa171f606d($0 | 0, $3 | 0, ($5 >>> 0 < $4 >>> 0 ? -1 : $5) | 0);
     }
     $4 = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
     $5 = (HEAP32[$0 >> 2] | 0) + Math_imul($3, 12) | 0;
     i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
     HEAP32[$5 >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
     HEAP32[($5 + 4 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($5 + 8 | 0) >> 2] = $4;
     HEAP32[($0 + 8 | 0) >> 2] = $3 + 1 | 0;
     $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__hce9499edf49fdc37($2 | 0, $1 | 0);
     $3 = HEAP32[$2 >> 2] | 0;
     if ($3) {
      continue label$3
     }
     break label$3;
    };
   }
   HEAP32[($2 + 16 | 0) >> 2] = 0;
  }
  core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__AssetName____h5e309155feaabc90($2 + 16 | 0 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function $cardano_serialization_lib__chain_crypto__algorithms__ed25519__Ed25519_20as_20cardano_serialization_lib__chain_crypto__key__AsymmetricKey___generate__hb6bca437408c7cb9($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, i64toi32_i32$2 = 0, $12 = 0, $13 = 0, $14 = 0, $15 = 0, $4 = 0, $32 = 0, $36 = 0, $40 = 0, $43 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  HEAP32[($3 + 12 | 0) >> 2] = $2;
  HEAP32[($3 + 8 | 0) >> 2] = $1;
  $1 = ($3 + 16 | 0) + 24 | 0;
  i64toi32_i32$1 = $1;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $2 = ($3 + 16 | 0) + 16 | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = ($3 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = $4;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  $rand_os__OsRng_20as_20rand_core__RngCore___fill_bytes__h6a20d3c9ee8171ca(i64toi32_i32$1 + 8 | 0 | 0, i64toi32_i32$1 + 16 | 0 | 0, 32 | 0);
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $32 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 24 | 0;
  $12 = $32;
  HEAP8[i64toi32_i32$0 >> 0] = $12;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 16 | 0;
  $13 = $36;
  HEAP8[i64toi32_i32$1 >> 0] = $13;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $40 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 8 | 0;
  $14 = $40;
  HEAP8[i64toi32_i32$0 >> 0] = $14;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $14 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $14 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $14 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[($3 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($3 + 20 | 0) >> 2] | 0;
  $43 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  $15 = $43;
  HEAP8[i64toi32_i32$1 >> 0] = $15;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $15 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $15 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $15 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  label$1 : {
   label$2 : {
    if (HEAP32[($3 + 8 | 0) >> 2] | 0) {
     break label$2
    }
    $0 = HEAP32[($3 + 12 | 0) >> 2] | 0;
    if ($0 >>> 0 < 36 >>> 0) {
     break label$1
    }
    wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($0 | 0);
    break label$1;
   }
   $0 = HEAP32[($3 + 12 | 0) >> 2] | 0;
   if ($0 >>> 0 < 36 >>> 0) {
    break label$1
   }
   wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($0 | 0);
  }
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__tx_builder__tx_inputs_builder__PlutusWitnesses__add__hec4d4aff8ce90d4a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $4$hi = 0, $27 = 0, $35 = 0;
  $2 = global$0 - 224 | 0;
  global$0 = $2;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($2 + 128 | 0 | 0, $1 + 128 | 0 | 0);
  $cardano_serialization_lib__plutus__PlutusData_20as_20core__clone__Clone___clone__h63d1a98cc18f4609_1($2 | 0, $1 | 0);
  $3 = HEAPU8[($1 + 120 | 0) >> 0] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[($1 + 48 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 52 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$1;
  $cardano_serialization_lib__plutus__PlutusData_20as_20core__clone__Clone___clone__h63d1a98cc18f4609_1($2 + 152 | 0 | 0, $1 + 56 | 0 | 0);
  i64toi32_i32$2 = $1 + 112 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $27 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 208 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $27;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP8[($2 + 216 | 0) >> 0] = $3;
  i64toi32_i32$0 = $4$hi;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 144 | 0) >> 2] = $4;
  HEAP32[($2 + 148 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1 + 104 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $35 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 200 | 0) >> 2] = $35;
  HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$1;
  memcpy($2 + 48 | 0 | 0, $2 + 144 | 0 | 0, 80 | 0) | 0;
  label$1 : {
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (($1 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
    break label$1
   }
   alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hc7c237c6ae92ed14($0 | 0, $1 | 0, 1 | 0);
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  }
  memcpy((HEAP32[$0 >> 2] | 0) + Math_imul($1, 144) | 0 | 0, $2 | 0, 144 | 0) | 0;
  HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
  global$0 = $2 + 224 | 0;
 }
 
 function $hex__error__FromHexError_20as_20core__fmt__Debug___fmt__ha7d55c24ed9afcca($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $17 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $3 = HEAP32[$0 >> 2] | 0;
      switch ((($3 & 2097150 | 0 | 0) == (1114112 | 0) ? $3 + -1114111 | 0 : 0) | 0) {
      case 2:
       break label$2;
      case 1:
       break label$3;
      default:
       break label$4;
      };
     }
     i64toi32_i32$0 = core__fmt__Formatter__debug_struct__h873400a11fe69724($1 | 0, 1141980 | 0, 19 | 0) | 0;
     i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
     $17 = i64toi32_i32$0;
     i64toi32_i32$0 = $2;
     HEAP32[($2 + 16 | 0) >> 2] = $17;
     HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($2 + 12 | 0) >> 2] = $0;
     core__fmt__builders__DebugStruct__field__hec833bfe02704935($2 + 16 | 0 | 0, 1141999 | 0, 1 | 0, $2 + 12 | 0 | 0, 1142e3 | 0) | 0;
     HEAP32[($2 + 12 | 0) >> 2] = $0 + 4 | 0;
     core__fmt__builders__DebugStruct__field__hec833bfe02704935($2 + 16 | 0 | 0, 1142016 | 0, 5 | 0, $2 + 12 | 0 | 0, 1142024 | 0) | 0;
     $0 = core__fmt__builders__DebugStruct__finish__hb1eae1aa0e288840($2 + 16 | 0 | 0) | 0;
     break label$1;
    }
    core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 + 16 | 0 | 0, $1 | 0, 1141971 | 0, 9 | 0);
    $0 = core__fmt__builders__DebugTuple__finish__hc3c3f1efaa75a6e2($2 + 16 | 0 | 0) | 0;
    break label$1;
   }
   core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 + 16 | 0 | 0, $1 | 0, 1141952 | 0, 19 | 0);
   $0 = core__fmt__builders__DebugTuple__finish__hc3c3f1efaa75a6e2($2 + 16 | 0 | 0) | 0;
  }
  global$0 = $2 + 32 | 0;
  return $0 | 0;
 }
 
 function cardano_serialization_lib__Ipv6__new_impl__h24a5893493c4a06f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $2 = 0, $3 = 0, $10 = 0, $11 = 0, $4 = 0, $4$hi = 0, $22 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 12 | 0) >> 2] | 0 | 0) != (16 | 0)) {
     break label$2
    }
    $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $4 = i64toi32_i32$0;
    $4$hi = i64toi32_i32$1;
    i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $22 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 9 | 0;
    $10 = $22;
    HEAP8[i64toi32_i32$1 >> 0] = $10;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$0 = $4$hi;
    i64toi32_i32$1 = $0;
    $11 = $4;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $11;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $11 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $11 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = $11 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 8 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    $3 = 0;
    break label$1;
   }
   i64toi32_i32$2 = $1;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = 0;
   $4 = i64toi32_i32$0;
   $4$hi = i64toi32_i32$1;
   alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($0 + 56 | 0 | 0, 1053611 | 0, 4 | 0);
   i64toi32_i32$0 = $0 + 48 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $4;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$0 = $0 + 40 | 0;
   i64toi32_i32$1 = 0;
   HEAP32[i64toi32_i32$0 >> 2] = 1;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$0 = $0 + 32 | 0;
   i64toi32_i32$1 = 0;
   HEAP32[i64toi32_i32$0 >> 2] = 16;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($0 + 24 | 0) >> 2] = 19;
   HEAP32[($0 + 20 | 0) >> 2] = 1053632;
   HEAP8[($0 + 16 | 0) >> 0] = 13;
   HEAP8[($0 + 8 | 0) >> 0] = 2;
   $3 = 1;
  }
  HEAP8[$0 >> 0] = $3;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  global$0 = $2 + 16 | 0;
 }
 
 function cardano_serialization_lib__GenesisKeyDelegation__from_bytes__haf8140e0613d2ea5($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $14 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 208 | 0;
  global$0 = $2;
  HEAP32[($2 + 200 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 184 | 0) >> 2] = 0;
  HEAP32[($2 + 188 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 192 | 0) >> 2] = $14;
  HEAP32[($2 + 196 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__GenesisKeyDelegation___deserialize__h3a48f9f97f9ab4bf($2 + 88 | 0 | 0, $2 + 184 | 0 | 0);
  $1 = ($2 + 184 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAPU8[($2 + 88 | 0) >> 0] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    memcpy($0 + 1 | 0 | 0, memcpy($2 | 0, $2 + 88 | 0 | 1 | 0 | 0, 88 | 0) | 0 | 0, 88 | 0) | 0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 88 | 0 | 0, memcpy($2 + 7 | 0 | 0, ($2 + 88 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0 + 4 | 0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 88 | 0 | 0) | 0), HEAP32[wasm2js_i32$0 >> 2] = wasm2js_i32$1;
  }
  HEAP8[$0 >> 0] = $1;
  global$0 = $2 + 208 | 0;
 }
 
 function cardano_serialization_lib__utils__TransactionUnspentOutputs__add__h1bd134bb2a6bf667($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $12 = 0, $18 = 0, $24 = 0, $30 = 0, $3 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  i64toi32_i32$2 = $1 + 156 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $12 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 8 | 0) + 156 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $12;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 148 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$1;
  i64toi32_i32$1 = ($2 + 8 | 0) + 148 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $18;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1 + 140 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 8 | 0) + 140 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 132 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$1;
  i64toi32_i32$1 = ($2 + 8 | 0) + 132 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $3 = HEAP32[($1 + 128 | 0) >> 2] | 0;
  $cardano_serialization_lib__TransactionOutput_20as_20core__clone__Clone___clone__h6884f0c4818d1aeb($2 + 8 | 0 | 0, $1 | 0);
  HEAP32[($2 + 136 | 0) >> 2] = $3;
  label$1 : {
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (($1 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
    break label$1
   }
   alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h8d0aff87097f011d($0 | 0, $1 | 0, 1 | 0);
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  }
  memcpy((HEAP32[$0 >> 2] | 0) + Math_imul($1, 168) | 0 | 0, $2 + 8 | 0 | 0, 168 | 0) | 0;
  HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
  global$0 = $2 + 176 | 0;
 }
 
 function cardano_serialization_lib__chain_crypto__sign__Signature_T_2cA___from_binary__h127c757dae4cedbd($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $7 = 0, $8 = 0, $9 = 0, $10 = 0, $43 = 0;
  $3 = global$0 - 128 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    if (($2 | 0) != (64 | 0)) {
     break label$2
    }
    $2 = 0;
    memset($3 + 64 | 0 | 0, 0 | 0, 64 | 0) | 0;
    core__slice___impl_20_5bT_5d___clone_from_slice__h1742dfbd5d5d9efd($3 + 64 | 0 | 0, 64 | 0, $1 | 0, 64 | 0);
    HEAP8[($0 + 3 | 0) >> 0] = HEAPU8[($3 + 66 | 0) >> 0] | 0;
    $10 = HEAPU8[($3 + 64 | 0) >> 0] | 0 | ((HEAPU8[($3 + 65 | 0) >> 0] | 0) << 8 | 0) | 0;
    HEAP8[($0 + 1 | 0) >> 0] = $10;
    HEAP8[($0 + 2 | 0) >> 0] = $10 >>> 8 | 0;
    i64toi32_i32$0 = HEAPU8[($3 + 67 | 0) >> 0] | 0 | ((HEAPU8[($3 + 68 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 69 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 70 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[($3 + 71 | 0) >> 0] | 0 | ((HEAPU8[($3 + 72 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 73 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 74 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $1 = HEAPU8[($3 + 75 | 0) >> 0] | 0 | ((HEAPU8[($3 + 76 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 77 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 78 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    memcpy($3 + 12 | 0 | 0, $3 + 79 | 0 | 0, 49 | 0) | 0;
    memcpy($0 + 16 | 0 | 0, $3 + 12 | 0 | 0, 49 | 0) | 0;
    $7 = $0 + 12 | 0;
    $8 = $1;
    HEAP8[$7 >> 0] = $8;
    HEAP8[($7 + 1 | 0) >> 0] = $8 >>> 8 | 0;
    HEAP8[($7 + 2 | 0) >> 0] = $8 >>> 16 | 0;
    HEAP8[($7 + 3 | 0) >> 0] = $8 >>> 24 | 0;
    $43 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 4 | 0;
    $9 = $43;
    HEAP8[i64toi32_i32$0 >> 0] = $9;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $9 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $9 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $9 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    break label$1;
   }
   HEAP32[($0 + 12 | 0) >> 2] = $2;
   i64toi32_i32$0 = $0 + 4 | 0;
   i64toi32_i32$1 = 64;
   HEAP32[i64toi32_i32$0 >> 2] = 0;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   $2 = 1;
  }
  HEAP8[$0 >> 0] = $2;
  global$0 = $3 + 128 | 0;
 }
 
 function cardano_serialization_lib__crypto__PrivateKey__from_normal_bytes__h44894894715cde61($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $3 = 0, $11 = 0, $12 = 0, $13 = 0, $14 = 0, $22 = 0, $27 = 0, $32 = 0, $36 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $3 = global$0 - 32 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    if (($2 | 0) != (32 | 0)) {
     break label$2
    }
    $2 = $3 + 24 | 0;
    i64toi32_i32$1 = $2;
    i64toi32_i32$0 = 0;
    HEAP32[i64toi32_i32$1 >> 2] = 0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$1 = $3 + 16 | 0;
    i64toi32_i32$0 = 0;
    HEAP32[i64toi32_i32$1 >> 2] = 0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$1 = $3 + 8 | 0;
    i64toi32_i32$0 = 0;
    HEAP32[i64toi32_i32$1 >> 2] = 0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$1 = $3;
    i64toi32_i32$0 = 0;
    HEAP32[i64toi32_i32$1 >> 2] = 0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    core__slice___impl_20_5bT_5d___clone_from_slice__h1742dfbd5d5d9efd(i64toi32_i32$1 | 0, 32 | 0, $1 | 0, 32 | 0);
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$1 + 1 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 2 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 3 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 4 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$1 + 5 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$1 + 6 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$1 + 7 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$1 + 8 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $22 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 3 | 0;
    $11 = $22;
    HEAP8[i64toi32_i32$0 >> 0] = $11;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$2 = $3 + 9 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $27 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 11 | 0;
    $12 = $27;
    HEAP8[i64toi32_i32$1 >> 0] = $12;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $12 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $12 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $12 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$2 = $3 + 17 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $32 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 19 | 0;
    $13 = $32;
    HEAP8[i64toi32_i32$0 >> 0] = $13;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $13 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $13 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $13 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $36 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 26 | 0;
    $14 = $36;
    HEAP8[i64toi32_i32$1 >> 0] = $14;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $14 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $14 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $14 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    $2 = HEAPU8[$3 >> 0] | 0;
    HEAP8[($0 + 1 | 0) >> 0] = 1;
    HEAP8[($0 + 2 | 0) >> 0] = $2;
    $2 = 0;
    break label$1;
   }
   (wasm2js_i32$0 = $0 + 4 | 0, wasm2js_i32$1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1066591 | 0, 25 | 0) | 0), HEAP32[wasm2js_i32$0 >> 2] = wasm2js_i32$1;
   $2 = 1;
  }
  HEAP8[$0 >> 0] = $2;
  global$0 = $3 + 32 | 0;
 }
 
 function cardano_serialization_lib__crypto__Vkeywitness__from_bytes__hef4aeeaa38070cc1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $14 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 224 | 0;
  global$0 = $2;
  HEAP32[($2 + 216 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 200 | 0) >> 2] = 0;
  HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 208 | 0) >> 2] = $14;
  HEAP32[($2 + 212 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__crypto__Vkeywitness_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h37c9c40e98008804($2 + 96 | 0 | 0, $2 + 200 | 0 | 0);
  $1 = ($2 + 200 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAPU8[($2 + 96 | 0) >> 0] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    memcpy($0 + 1 | 0 | 0, memcpy($2 | 0, $2 + 96 | 0 | 1 | 0 | 0, 96 | 0) | 0 | 0, 96 | 0) | 0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 96 | 0 | 0, memcpy($2 + 7 | 0 | 0, ($2 + 96 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0 + 4 | 0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 96 | 0 | 0) | 0), HEAP32[wasm2js_i32$0 >> 2] = wasm2js_i32$1;
  }
  HEAP8[$0 >> 0] = $1;
  global$0 = $2 + 224 | 0;
 }
 
 function $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__hfa703853cabd0820($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $5 = 0, $3 = 0, $4 = 0, $44 = 0, $55 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  $core__iter__adapters__cloned__Cloned_I__20as_20core__iter__traits__iterator__Iterator___next__h2e192ec8b52ada0a($2 + 32 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 104 | 0) >> 2] | 0 | 0) != (2 | 0)) {
     break label$2
    }
    i64toi32_i32$1 = $0;
    i64toi32_i32$0 = 0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = 0;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[i64toi32_i32$1 >> 2] = HEAP32[(0 + 1067624 | 0) >> 2] | 0;
    break label$1;
   }
   alloc__raw_vec__RawVec_T_2cA___allocate_in__he0e25d30114cc7d7($2 + 8 | 0 | 0, 1 | 0, 0 | 0);
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = memmove(HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, $2 + 32 | 0 | 0, 128 | 0) | 0;
   $5 = ($2 + 16 | 0) + 8 | 0;
   HEAP32[$5 >> 2] = 1;
   HEAP32[($2 + 20 | 0) >> 2] = $3;
   HEAP32[($2 + 16 | 0) >> 2] = $4;
   HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
   i64toi32_i32$2 = $1;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $44 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   HEAP32[($2 + 32 | 0) >> 2] = $44;
   HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
   alloc__vec__Vec_T_2cA___extend_desugared__hcde58f85dd1ec03b($2 + 16 | 0 | 0, $2 + 32 | 0 | 0);
   HEAP32[($0 + 8 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   $55 = i64toi32_i32$1;
   i64toi32_i32$1 = $0;
   HEAP32[i64toi32_i32$1 >> 2] = $55;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  }
  global$0 = $2 + 160 | 0;
 }
 
 function alloc__vec__Vec_T_2cA___extend_desugared__h5ac61c858da663f2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $4 = 0, $5 = 0, $6 = 0, $8 = 0, i64toi32_i32$0 = 0, $7 = 0, i64toi32_i32$1 = 0, $3 = 0, $9 = 0, $9$hi = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   if (($2 | 0) == ($3 | 0)) {
    break label$1
   }
   $4 = HEAP32[($2 + 60 | 0) >> 2] | 0;
   HEAP32[$1 >> 2] = $4;
   $5 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   HEAP32[($1 + 8 | 0) >> 2] = $5 + -1 | 0;
   $6 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   $7 = $6 << 3 | 0;
   $8 = $5 + -2 | 0;
   label$2 : while (1) {
    $5 = $4;
    i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
    $9 = i64toi32_i32$0;
    $9$hi = i64toi32_i32$1;
    label$3 : {
     if (($6 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
      break label$3
     }
     $2 = $8 + 1 | 0;
     $4 = $2 + 1 | 0;
     alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h747ed10c49fb1468($0 | 0, $6 | 0, ($4 >>> 0 < $2 >>> 0 ? -1 : $4) | 0);
    }
    i64toi32_i32$1 = $9$hi;
    i64toi32_i32$0 = (HEAP32[$0 >> 2] | 0) + $7 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $9;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    $6 = $6 + 1 | 0;
    HEAP32[($0 + 8 | 0) >> 2] = $6;
    if (($5 | 0) == ($3 | 0)) {
     break label$1
    }
    HEAP32[($1 + 8 | 0) >> 2] = $8;
    $4 = HEAP32[($5 + 60 | 0) >> 2] | 0;
    HEAP32[$1 >> 2] = $4;
    $7 = $7 + 8 | 0;
    $8 = $8 + -1 | 0;
    $2 = $5;
    continue label$2;
   };
  }
 }
 
 function alloc__slice__insert_head__h77ad8b617951af0c($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $4 = 0, $3 = 0, $5 = 0, $6 = 0, $7 = 0;
  $3 = global$0 - 128 | 0;
  global$0 = $3;
  label$1 : {
   if ($1 >>> 0 < 2 >>> 0) {
    break label$1
   }
   $4 = $0 + 128 | 0;
   if (!(alloc__slice___impl_20_5bT_5d___sort_by_key___7b_7bclosure_7d_7d__h5570c792610ff4df($2 | 0, $4 | 0, $0 | 0) | 0)) {
    break label$1
   }
   $5 = memcpy($3 | 0, $0 | 0, 128 | 0) | 0;
   $6 = memcpy($0 | 0, $4 | 0, 128 | 0) | 0;
   label$2 : {
    if ($1 >>> 0 < 3 >>> 0) {
     break label$2
    }
    $0 = $6 + 256 | 0;
    if (!(alloc__slice___impl_20_5bT_5d___sort_by_key___7b_7bclosure_7d_7d__h5570c792610ff4df($2 | 0, $0 | 0, $5 | 0) | 0)) {
     break label$2
    }
    $7 = $1 + -1 | 0;
    $4 = 3;
    label$3 : {
     label$4 : while (1) {
      memcpy($0 + -128 | 0 | 0, $0 | 0, 128 | 0) | 0;
      if (($1 | 0) == ($4 | 0)) {
       break label$3
      }
      $4 = $4 + 1 | 0;
      $0 = $0 + 128 | 0;
      if (alloc__slice___impl_20_5bT_5d___sort_by_key___7b_7bclosure_7d_7d__h5570c792610ff4df($2 | 0, $0 | 0, $5 | 0) | 0) {
       continue label$4
      }
      break label$4;
     };
     $7 = $4 + -2 | 0;
    }
    $4 = $6 + ($7 << 7 | 0) | 0;
   }
   memcpy($4 | 0, $5 | 0, 128 | 0) | 0;
  }
  global$0 = $3 + 128 | 0;
 }
 
 function cardano_serialization_lib__plutus__CostModel__new__h4b1e476f7ee71636($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, $2 = 0, $3 = 0, i64toi32_i32$1 = 0, $4 = 0, $5 = 0, $48 = 0;
  $1 = global$0 - 32 | 0;
  global$0 = $1;
  $2 = 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h404b2b8ae2314e41($1 + 8 | 0 | 0, 166 | 0, 0 | 0);
  HEAP32[($1 + 24 | 0) >> 2] = 0;
  $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  HEAP32[($1 + 20 | 0) >> 2] = $3;
  $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  HEAP32[($1 + 16 | 0) >> 2] = $4;
  $5 = 165;
  label$1 : while (1) {
   label$2 : {
    if (($3 | 0) != ($2 | 0)) {
     break label$2
    }
    alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h3bf5a6cd2f3fdf29($1 + 16 | 0 | 0, $3 | 0, 1 | 0);
    $4 = HEAP32[($1 + 16 | 0) >> 2] | 0;
    $2 = HEAP32[($1 + 24 | 0) >> 2] | 0;
   }
   $3 = $4 + ($2 << 4 | 0) | 0;
   i64toi32_i32$1 = $3;
   i64toi32_i32$0 = 0;
   HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = 0;
   HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = 0;
   HEAP32[i64toi32_i32$1 >> 2] = 0;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   $2 = $2 + 1 | 0;
   HEAP32[($1 + 24 | 0) >> 2] = $2;
   label$3 : {
    if (!$5) {
     break label$3
    }
    $5 = $5 + -1 | 0;
    $3 = HEAP32[($1 + 20 | 0) >> 2] | 0;
    continue label$1;
   }
   break label$1;
  };
  i64toi32_i32$0 = HEAP32[($1 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  $48 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $48;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[(($1 + 16 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $1 + 32 | 0;
 }
 
 function num_bigint__biguint__addition__add2__h85496cf5b0a143eb($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, i64toi32_i32$5 = 0, i64toi32_i32$3 = 0, $6$hi = 0, $6 = 0, $4 = 0, $5 = 0, $26 = 0, $18 = 0, $20 = 0, $20$hi = 0, $22 = 0, $22$hi = 0, $23$hi = 0, $25 = 0, $25$hi = 0, $46 = 0, $49 = 0, $49$hi = 0, $7$hi = 0;
  label$1 : {
   if ($1 >>> 0 < $3 >>> 0) {
    break label$1
   }
   label$2 : {
    if (!$3) {
     break label$2
    }
    $4 = $0 + ($3 << 2 | 0) | 0;
    i64toi32_i32$0 = 0;
    $6 = 0;
    $6$hi = i64toi32_i32$0;
    $5 = $3;
    label$3 : while (1) {
     $18 = $0;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$2 = $6;
     i64toi32_i32$1 = 0;
     i64toi32_i32$3 = 255;
     i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
     $20 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
     $20$hi = i64toi32_i32$1;
     i64toi32_i32$0 = $0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$0 >> 2] | 0;
     i64toi32_i32$2 = 0;
     $22 = i64toi32_i32$1;
     $22$hi = i64toi32_i32$2;
     i64toi32_i32$2 = $20$hi;
     i64toi32_i32$0 = $20;
     i64toi32_i32$1 = $22$hi;
     i64toi32_i32$3 = $22;
     i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
     i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
     if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
     }
     $23$hi = i64toi32_i32$5;
     i64toi32_i32$2 = $2;
     i64toi32_i32$5 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = 0;
     $25 = i64toi32_i32$5;
     $25$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $23$hi;
     i64toi32_i32$2 = i64toi32_i32$4;
     i64toi32_i32$5 = $25$hi;
     i64toi32_i32$3 = $25;
     i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
     if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
     }
     $6 = i64toi32_i32$1;
     $6$hi = i64toi32_i32$4;
     HEAP32[$18 >> 2] = i64toi32_i32$1;
     $0 = $0 + 4 | 0;
     $2 = $2 + 4 | 0;
     i64toi32_i32$0 = i64toi32_i32$1;
     i64toi32_i32$2 = 0;
     i64toi32_i32$3 = 32;
     i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$2 = 0;
      $26 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
     } else {
      i64toi32_i32$2 = i64toi32_i32$4 >>> i64toi32_i32$5 | 0;
      $26 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$5 | 0) | 0;
     }
     $6 = $26;
     $6$hi = i64toi32_i32$2;
     $5 = $5 + -1 | 0;
     if ($5) {
      continue label$3
     }
     break label$3;
    };
    i64toi32_i32$2 = $6$hi;
    if (!($6 | i64toi32_i32$2 | 0)) {
     break label$2
    }
    $0 = ($1 << 2 | 0) - ($3 << 2 | 0) | 0;
    label$4 : while (1) {
     if (!$0) {
      break label$2
     }
     $46 = $4;
     i64toi32_i32$2 = $6$hi;
     i64toi32_i32$4 = $4;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$4 >> 2] | 0;
     i64toi32_i32$0 = 0;
     $49 = i64toi32_i32$2;
     $49$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$4 = $6;
     i64toi32_i32$2 = $49$hi;
     i64toi32_i32$3 = $49;
     i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
     i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
     if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
      i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
     }
     $7$hi = i64toi32_i32$1;
     HEAP32[$46 >> 2] = i64toi32_i32$5;
     $0 = $0 + -4 | 0;
     $4 = $4 + 4 | 0;
     i64toi32_i32$1 = 0;
     $6 = 1;
     $6$hi = i64toi32_i32$1;
     i64toi32_i32$1 = $7$hi;
     i64toi32_i32$0 = i64toi32_i32$5;
     i64toi32_i32$4 = 1;
     i64toi32_i32$3 = 0;
     i64toi32_i32$4 = i64toi32_i32$1 & i64toi32_i32$4 | 0;
     i64toi32_i32$1 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
     i64toi32_i32$0 = 0;
     i64toi32_i32$3 = 0;
     if ((i64toi32_i32$1 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$4 | 0) != (i64toi32_i32$0 | 0) | 0) {
      continue label$4
     }
     break label$4;
    };
   }
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1077297 | 0, 35 | 0, 1077332 | 0);
  abort();
 }
 
 function alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__h5bc9976a94462f29($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, $7 = 0, $6 = 0;
  $5 = global$0 - 32 | 0;
  global$0 = $5;
  HEAP32[($5 + 28 | 0) >> 2] = $2;
  HEAP32[($5 + 24 | 0) >> 2] = $1;
  $6 = 0;
  alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__hc39010d35e6d6adc($5 + 16 | 0 | 0, $5 + 24 | 0 | 0, $3 | 0, $4 | 0, 0 | 0);
  $7 = HEAP32[($5 + 20 | 0) >> 2] | 0;
  label$1 : {
   if (!(HEAP32[($5 + 16 | 0) >> 2] | 0)) {
    break label$1
   }
   label$2 : while (1) {
    label$3 : {
     if ($1) {
      break label$3
     }
     $6 = 1;
     $1 = 0;
     break label$1;
    }
    $2 = HEAP32[(($2 + ($7 << 2 | 0) | 0) + 408 | 0) >> 2] | 0;
    HEAP32[($5 + 28 | 0) >> 2] = $2;
    $1 = $1 + -1 | 0;
    HEAP32[($5 + 24 | 0) >> 2] = $1;
    alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__hc39010d35e6d6adc($5 + 8 | 0 | 0, $5 + 24 | 0 | 0, $3 | 0, $4 | 0, 0 | 0);
    $7 = HEAP32[($5 + 12 | 0) >> 2] | 0;
    if (HEAP32[($5 + 8 | 0) >> 2] | 0) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[$0 >> 2] = $6;
  HEAP32[($0 + 12 | 0) >> 2] = $7;
  HEAP32[($0 + 8 | 0) >> 2] = $2;
  global$0 = $5 + 32 | 0;
 }
 
 function transactionoutput_amount($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $2 = 0, $3 = 0, $4 = 0, $4$hi = 0, $33 = 0, $38 = 0, $47 = 0, $52 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h17af7d9d2d20aa0f($1 | 0, $0 | 0);
   $2 = HEAP32[$1 >> 2] | 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
   $4 = i64toi32_i32$0;
   $4$hi = i64toi32_i32$1;
   $0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   $3 = 0;
   label$2 : {
    if ((HEAP32[(i64toi32_i32$2 + 72 | 0) >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($1 + 24 | 0 | 4 | 0 | 0, $2 + 76 | 0 | 0);
    $3 = 1;
   }
   $2 = ($1 + 8 | 0) + 8 | 0;
   i64toi32_i32$2 = ($1 + 24 | 0) + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $33 = i64toi32_i32$1;
   i64toi32_i32$1 = $2;
   HEAP32[i64toi32_i32$1 >> 2] = $33;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($1 + 24 | 0) >> 2] = $3;
   i64toi32_i32$2 = $1;
   i64toi32_i32$0 = HEAP32[($1 + 24 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($1 + 28 | 0) >> 2] | 0;
   $38 = i64toi32_i32$0;
   i64toi32_i32$0 = $1;
   HEAP32[($1 + 8 | 0) >> 2] = $38;
   HEAP32[($1 + 12 | 0) >> 2] = i64toi32_i32$1;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $47 = i64toi32_i32$1;
   i64toi32_i32$1 = $1 + 40 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $47;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $4$hi;
   i64toi32_i32$1 = $1;
   HEAP32[($1 + 24 | 0) >> 2] = $4;
   HEAP32[($1 + 28 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $1;
   i64toi32_i32$0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   $52 = i64toi32_i32$0;
   i64toi32_i32$0 = $1;
   HEAP32[($1 + 32 | 0) >> 2] = $52;
   HEAP32[($1 + 36 | 0) >> 2] = i64toi32_i32$1;
   $0 = $cardano_serialization_lib__utils__Value_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h50a1108e1e08f966($1 + 24 | 0 | 0) | 0;
   global$0 = $1 + 48 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function encode_json_str_to_metadatum($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$1 = 0;
  $3 = global$0 - 128 | 0;
  global$0 = $3;
  HEAP32[($3 + 16 | 0) >> 2] = $1;
  HEAP32[($3 + 12 | 0) >> 2] = $1;
  HEAP32[($3 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($3 | 0, $3 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($3 + 64 | 0 | 0, HEAP32[$3 >> 2] | 0 | 0, HEAP32[($3 + 4 | 0) >> 2] | 0 | 0);
  label$1 : {
   label$2 : {
    if ($2 >>> 0 >= 3 >>> 0) {
     break label$2
    }
    HEAP32[(($3 + 80 | 0) + 8 | 0) >> 2] = HEAP32[(($3 + 64 | 0) + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($3 + 68 | 0) >> 2] | 0;
    HEAP32[($3 + 80 | 0) >> 2] = HEAP32[($3 + 64 | 0) >> 2] | 0;
    HEAP32[($3 + 84 | 0) >> 2] = i64toi32_i32$1;
    cardano_serialization_lib__metadata__encode_json_str_to_metadatum__h4a5979815eae04ac($3 + 8 | 0 | 0, $3 + 80 | 0 | 0, $2 | 0);
    if ((HEAP32[($3 + 8 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    memcpy($3 + 80 | 0 | 0, ($3 + 8 | 0) + 8 | 0 | 0, 48 | 0) | 0;
    $1 = $cardano_serialization_lib__metadata__TransactionMetadatum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hce2feba55b67d086($3 + 80 | 0 | 0) | 0;
    global$0 = $3 + 128 | 0;
    return $1 | 0;
   }
   wasm_bindgen__throw_str__h40ff0247f6a635d7(1060608 | 0, 25 | 0);
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($3 + 12 | 0) >> 2] | 0 | 0);
  abort();
 }
 
 function core__ptr__drop_in_place_cardano_serialization_lib__TransactionBody___h9274013021a1d568($0) {
  $0 = $0 | 0;
  var $2 = 0, $3 = 0, $1 = 0;
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h98bad0b07702c13e($0 + 128 | 0 | 0);
  $1 = $0 + 140 | 0;
  label$1 : {
   $2 = HEAP32[($0 + 148 | 0) >> 2] | 0;
   if (!$2) {
    break label$1
   }
   $3 = HEAP32[($0 + 140 | 0) >> 2] | 0;
   $2 = $2 << 7 | 0;
   label$2 : while (1) {
    core__ptr__drop_in_place_cardano_serialization_lib__TransactionOutput___h632b3a99817e6ac5_1($3 | 0);
    $3 = $3 + 128 | 0;
    $2 = $2 + -128 | 0;
    if ($2) {
     continue label$2
    }
    break label$2;
   };
  }
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h5107e2b13c386680($1 | 0);
  core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__Certificates____h3bab90286ab8bbb4_1($0 + 152 | 0 | 0);
  core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__Withdrawals____heaf2605773ce1c75_1($0 + 24 | 0 | 0);
  label$3 : {
   if (!(HEAP32[($0 + 84 | 0) >> 2] | 0)) {
    break label$3
   }
   $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__h88c250e8947434a9($0 + 64 | 0 | 0);
   $3 = $0 + 80 | 0;
   if (!(HEAP32[$3 >> 2] | 0)) {
    break label$3
   }
   hashbrown__raw__RawTable_T_2cA___free_buckets__ha5e2f3faac433f39($3 | 0);
  }
  label$4 : {
   if (!(HEAP32[($0 + 164 | 0) >> 2] | 0)) {
    break label$4
   }
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h3981a4152bf24dd0($0 + 168 | 0 | 0);
  }
  label$5 : {
   if (!(HEAP32[($0 + 180 | 0) >> 2] | 0)) {
    break label$5
   }
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h98bad0b07702c13e($0 + 180 | 0 | 0);
  }
  label$6 : {
   if (!(HEAP32[($0 + 192 | 0) >> 2] | 0)) {
    break label$6
   }
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h72de9eab2f0e4669($0 + 192 | 0 | 0);
  }
 }
 
 function alloc__vec__Vec_T_2cA___extend_desugared__h4fb7a19e1b0f9d48($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $4 = 0, $2 = 0, $5 = 0, $6 = 0, $8 = 0, $7 = 0, $3 = 0, $9 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   if (($2 | 0) == ($3 | 0)) {
    break label$1
   }
   $4 = HEAP32[($2 + 68 | 0) >> 2] | 0;
   HEAP32[$1 >> 2] = $4;
   $5 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   HEAP32[($1 + 8 | 0) >> 2] = $5 + -1 | 0;
   $6 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   $7 = $6 << 2 | 0;
   $8 = $5 + -2 | 0;
   label$2 : while (1) {
    $5 = $4;
    $2 = HEAP32[($2 + 72 | 0) >> 2] | 0;
    label$3 : {
     if (($6 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
      break label$3
     }
     $4 = $8 + 1 | 0;
     $9 = $4 + 1 | 0;
     alloc__vec__Vec_T_2cA___reserve__hd6ffa03575bd5508($0 | 0, ($9 >>> 0 < $4 >>> 0 ? -1 : $9) | 0);
    }
    HEAP32[((HEAP32[$0 >> 2] | 0) + $7 | 0) >> 2] = $2;
    $6 = $6 + 1 | 0;
    HEAP32[($0 + 8 | 0) >> 2] = $6;
    if (($5 | 0) == ($3 | 0)) {
     break label$1
    }
    HEAP32[($1 + 8 | 0) >> 2] = $8;
    $4 = HEAP32[($5 + 68 | 0) >> 2] | 0;
    HEAP32[$1 >> 2] = $4;
    $7 = $7 + 4 | 0;
    $8 = $8 + -1 | 0;
    $2 = $5;
    continue label$2;
   };
  }
 }
 
 function bech32__encode__h3845e4a9162a8761($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $20 = 0, $35 = 0, $47 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  i64toi32_i32$1 = $4;
  i64toi32_i32$0 = 0;
  HEAP32[($4 + 4 | 0) >> 2] = 0;
  HEAP32[($4 + 8 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[$4 >> 2] = HEAP32[(0 + 1069072 | 0) >> 2] | 0;
  HEAP32[(($4 + 32 | 0) + 8 | 0) >> 2] = HEAP32[($3 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[($4 + 32 | 0) >> 2] = $20;
  HEAP32[($4 + 36 | 0) >> 2] = i64toi32_i32$1;
  bech32__encode_to_fmt__ha4485a0f4323c83a($4 + 16 | 0 | 0, $4 | 0, 1068692 | 0, $1 | 0, $2 | 0, $4 + 32 | 0 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAPU8[($4 + 16 | 0) >> 0] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     if (HEAPU8[($4 + 17 | 0) >> 0] | 0) {
      break label$1
     }
     i64toi32_i32$2 = $4;
     i64toi32_i32$1 = HEAP32[$4 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($4 + 4 | 0) >> 2] | 0;
     $35 = i64toi32_i32$1;
     i64toi32_i32$1 = $0;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $35;
     HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[i64toi32_i32$1 >> 2] = 0;
     HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = HEAP32[($4 + 8 | 0) >> 2] | 0;
     break label$2;
    }
    i64toi32_i32$2 = $4;
    i64toi32_i32$0 = HEAP32[($4 + 20 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($4 + 24 | 0) >> 2] | 0;
    i64toi32_i32$1 = $T_20as_20core__convert__From_T____from__h4de36f70570b7473(i64toi32_i32$0 | 0, i64toi32_i32$1 | 0) | 0;
    i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
    HEAP32[$0 >> 2] = 1;
    $47 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $47;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($4 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($4 | 0);
   }
   global$0 = $4 + 48 | 0;
   return;
  }
  core__result__unwrap_failed__h27f43d993c3864a1(1068996 | 0, 43 | 0, $4 + 32 | 0 | 0, 1068980 | 0, 1069356 | 0);
  abort();
 }
 
 function $core__iter__adapters__map__Map_I_2cF__20as_20core__iter__traits__iterator__Iterator___fold__h7fe3f1b6aba6eb47($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $4 = 0, $9 = 0, $2 = 0, $7 = 0, $8 = 0, $6 = 0, $3 = 0, $5 = 0, $10 = 0, $11 = 0;
  $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  label$1 : {
   $4 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if (!$4) {
    break label$1
   }
   $5 = HEAP32[($0 + 12 | 0) >> 2] | 0;
   $6 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   $7 = HEAP32[$0 >> 2] | 0;
   $8 = HEAP32[$1 >> 2] | 0;
   label$2 : while (1) {
    $9 = $4 >>> 0 > $6 >>> 0 ? $6 : $4;
    $4 = $4 - $9 | 0;
    label$3 : {
     label$4 : {
      if ($9) {
       break label$4
      }
      $1 = 0;
      break label$3;
     }
     $10 = $7 + -1 | 0;
     $11 = (HEAPU8[$5 >> 0] | 0) & 31 | 0;
     $1 = 0;
     $0 = $9;
     label$5 : while (1) {
      $1 = $1 << $11 | 0 | (HEAPU8[($10 + $0 | 0) >> 0] | 0) | 0;
      $0 = $0 + -1 | 0;
      if ($0) {
       continue label$5
      }
      break label$5;
     };
    }
    $7 = $7 + $9 | 0;
    HEAP32[$8 >> 2] = $1;
    $2 = $2 + 1 | 0;
    $8 = $8 + 4 | 0;
    if ($4) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[$3 >> 2] = $2;
 }
 
 function alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal___push__h92c515d208d4f729($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $5 = 0, $6 = 0, $34 = 0, $43 = 0, $48 = 0, $51 = 0;
  label$1 : {
   label$2 : {
    if (((HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) != ($3 | 0)) {
     break label$2
    }
    $0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    $3 = HEAPU16[($0 + 402 | 0) >> 1] | 0;
    if ($3 >>> 0 <= 10 >>> 0) {
     break label$1
    }
    core__panicking__panic__h2fd385a887c8bf13(1084428 | 0, 32 | 0, 1084460 | 0);
    abort();
   }
   core__panicking__panic__h2fd385a887c8bf13(1084271 | 0, 48 | 0, 1084412 | 0);
   abort();
  }
  $5 = $3 + 1 | 0;
  HEAP16[($0 + 402 | 0) >> 1] = $5;
  $6 = $0 + Math_imul($3, 12) | 0;
  HEAP32[($6 + 276 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $34 = i64toi32_i32$0;
  i64toi32_i32$0 = $6 + 268 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $34;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $3 = $0 + Math_imul($3, 24) | 0;
  i64toi32_i32$2 = $2 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $43 = i64toi32_i32$1;
  i64toi32_i32$1 = $3 + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $43;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $48 = i64toi32_i32$0;
  i64toi32_i32$0 = $3 + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $48;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $51 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[i64toi32_i32$1 >> 2] = $51;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(($0 + ($5 << 2 | 0) | 0) + 408 | 0) >> 2] = $4;
  HEAP16[($4 + 400 | 0) >> 1] = $5;
  HEAP32[($4 + 264 | 0) >> 2] = $0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hc5a84431bcb0aafc($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, i64toi32_i32$1 = 0;
  $3 = global$0 - 32 | 0;
  global$0 = $3;
  label$1 : {
   $2 = $1 + $2 | 0;
   if ($2 >>> 0 < $1 >>> 0) {
    break label$1
   }
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   $4 = $1 << 1 | 0;
   $2 = $4 >>> 0 > $2 >>> 0 ? $4 : $2;
   $2 = $2 >>> 0 > 8 >>> 0 ? $2 : 8;
   label$2 : {
    label$3 : {
     if (!$1) {
      break label$3
     }
     HEAP32[(($3 + 16 | 0) + 8 | 0) >> 2] = 1;
     HEAP32[($3 + 20 | 0) >> 2] = $1;
     HEAP32[($3 + 16 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
     break label$2;
    }
    HEAP32[($3 + 16 | 0) >> 2] = 0;
   }
   alloc__raw_vec__finish_grow__h4140f8b73d3423e5($3 | 0, $2 | 0, 1 | 0, $3 + 16 | 0 | 0);
   label$4 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
     break label$4
    }
    $0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($3 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    abort();
   }
   i64toi32_i32$1 = HEAP32[($3 + 8 | 0) >> 2] | 0;
   HEAP32[$0 >> 2] = HEAP32[($3 + 4 | 0) >> 2] | 0;
   HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$1;
   global$0 = $3 + 32 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h306b444aaeb5adc5($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, i64toi32_i32$1 = 0;
  $3 = global$0 - 32 | 0;
  global$0 = $3;
  label$1 : {
   $2 = $1 + $2 | 0;
   if ($2 >>> 0 < $1 >>> 0) {
    break label$1
   }
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   $4 = $1 << 1 | 0;
   $2 = $4 >>> 0 > $2 >>> 0 ? $4 : $2;
   $2 = $2 >>> 0 > 8 >>> 0 ? $2 : 8;
   label$2 : {
    label$3 : {
     if (!$1) {
      break label$3
     }
     HEAP32[(($3 + 16 | 0) + 8 | 0) >> 2] = 1;
     HEAP32[($3 + 20 | 0) >> 2] = $1;
     HEAP32[($3 + 16 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
     break label$2;
    }
    HEAP32[($3 + 16 | 0) >> 2] = 0;
   }
   alloc__raw_vec__finish_grow__hff6a2247ebb21735($3 | 0, $2 | 0, 1 | 0, $3 + 16 | 0 | 0);
   label$4 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
     break label$4
    }
    $0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($3 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    abort();
   }
   i64toi32_i32$1 = HEAP32[($3 + 8 | 0) >> 2] | 0;
   HEAP32[$0 >> 2] = HEAP32[($3 + 4 | 0) >> 2] | 0;
   HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$1;
   global$0 = $3 + 32 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__h34e2ad51d8d58ed5($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $5 = 0, i64toi32_i32$0 = 0, $4 = 0, $6 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $61 = 0;
  $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $4 = HEAPU16[($3 + 138 | 0) >> 1] | 0;
  $5 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $1 = $4 + ($5 ^ -1 | 0) | 0;
  HEAP16[($2 + 138 | 0) >> 1] = $1;
  label$1 : {
   label$2 : {
    if ($1 >>> 0 >= 12 >>> 0) {
     break label$2
    }
    $6 = $5 + 1 | 0;
    if (($4 - $6 | 0 | 0) != ($1 | 0)) {
     break label$1
    }
    i64toi32_i32$2 = $3 + ($5 << 3 | 0) | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $4 = HEAP32[(($3 + ($5 << 2 | 0) | 0) + 92 | 0) >> 2] | 0;
    memcpy($2 + 92 | 0 | 0, ($3 + ($6 << 2 | 0) | 0) + 92 | 0 | 0, $1 << 2 | 0 | 0) | 0;
    memcpy($2 | 0, $3 + ($6 << 3 | 0) | 0 | 0, $1 << 3 | 0 | 0) | 0;
    HEAP16[($3 + 138 | 0) >> 1] = $5;
    $61 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $61;
    HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[i64toi32_i32$0 >> 2] = $4;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($1 | 0, 11 | 0, 1049044 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1048988 | 0, 40 | 0, 1049028 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__h6b63004c30a73b30($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $5 = 0, i64toi32_i32$0 = 0, $4 = 0, $6 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $61 = 0;
  $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $4 = HEAPU16[($3 + 138 | 0) >> 1] | 0;
  $5 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $1 = $4 + ($5 ^ -1 | 0) | 0;
  HEAP16[($2 + 138 | 0) >> 1] = $1;
  label$1 : {
   label$2 : {
    if ($1 >>> 0 >= 12 >>> 0) {
     break label$2
    }
    $6 = $5 + 1 | 0;
    if (($4 - $6 | 0 | 0) != ($1 | 0)) {
     break label$1
    }
    i64toi32_i32$2 = $3 + ($5 << 3 | 0) | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $4 = HEAP32[(($3 + ($5 << 2 | 0) | 0) + 92 | 0) >> 2] | 0;
    memcpy($2 + 92 | 0 | 0, ($3 + ($6 << 2 | 0) | 0) + 92 | 0 | 0, $1 << 2 | 0 | 0) | 0;
    memcpy($2 | 0, $3 + ($6 << 3 | 0) | 0 | 0, $1 << 3 | 0 | 0) | 0;
    HEAP16[($3 + 138 | 0) >> 1] = $5;
    $61 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $61;
    HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[i64toi32_i32$0 >> 2] = $4;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($1 | 0, 11 | 0, 1049044 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1048988 | 0, 40 | 0, 1049028 | 0);
  abort();
 }
 
 function alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__h05f65203dc6f97ae($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $6 = 0, $5 = 0;
  $4 = global$0 - 32 | 0;
  global$0 = $4;
  HEAP32[($4 + 28 | 0) >> 2] = $2;
  HEAP32[($4 + 24 | 0) >> 2] = $1;
  $5 = 0;
  alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__h61e2c78385a28c9d($4 + 16 | 0 | 0, $4 + 24 | 0 | 0, $3 | 0, 0 | 0);
  $6 = HEAP32[($4 + 20 | 0) >> 2] | 0;
  label$1 : {
   if (!(HEAP32[($4 + 16 | 0) >> 2] | 0)) {
    break label$1
   }
   label$2 : while (1) {
    label$3 : {
     if ($1) {
      break label$3
     }
     $5 = 1;
     $1 = 0;
     break label$1;
    }
    $2 = HEAP32[(($2 + ($6 << 2 | 0) | 0) + 448 | 0) >> 2] | 0;
    HEAP32[($4 + 28 | 0) >> 2] = $2;
    $1 = $1 + -1 | 0;
    HEAP32[($4 + 24 | 0) >> 2] = $1;
    alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__h61e2c78385a28c9d($4 + 8 | 0 | 0, $4 + 24 | 0 | 0, $3 | 0, 0 | 0);
    $6 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    if (HEAP32[($4 + 8 | 0) >> 2] | 0) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[$0 >> 2] = $5;
  HEAP32[($0 + 12 | 0) >> 2] = $6;
  HEAP32[($0 + 8 | 0) >> 2] = $2;
  global$0 = $4 + 32 | 0;
 }
 
 function alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__h060f30fd852e1b1d($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $6 = 0, $5 = 0;
  $4 = global$0 - 32 | 0;
  global$0 = $4;
  HEAP32[($4 + 28 | 0) >> 2] = $2;
  HEAP32[($4 + 24 | 0) >> 2] = $1;
  $5 = 0;
  alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__hfa0487299a0eb2b6($4 + 16 | 0 | 0, $4 + 24 | 0 | 0, $3 | 0, 0 | 0);
  $6 = HEAP32[($4 + 20 | 0) >> 2] | 0;
  label$1 : {
   if (!(HEAP32[($4 + 16 | 0) >> 2] | 0)) {
    break label$1
   }
   label$2 : while (1) {
    label$3 : {
     if ($1) {
      break label$3
     }
     $5 = 1;
     $1 = 0;
     break label$1;
    }
    $2 = HEAP32[(($2 + ($6 << 2 | 0) | 0) + 232 | 0) >> 2] | 0;
    HEAP32[($4 + 28 | 0) >> 2] = $2;
    $1 = $1 + -1 | 0;
    HEAP32[($4 + 24 | 0) >> 2] = $1;
    alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__hfa0487299a0eb2b6($4 + 8 | 0 | 0, $4 + 24 | 0 | 0, $3 | 0, 0 | 0);
    $6 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    if (HEAP32[($4 + 8 | 0) >> 2] | 0) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[$0 >> 2] = $5;
  HEAP32[($0 + 12 | 0) >> 2] = $6;
  HEAP32[($0 + 8 | 0) >> 2] = $2;
  global$0 = $4 + 32 | 0;
 }
 
 function alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__h0e9ccb4dfb3c7779($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $6 = 0, $5 = 0;
  $4 = global$0 - 32 | 0;
  global$0 = $4;
  HEAP32[($4 + 28 | 0) >> 2] = $2;
  HEAP32[($4 + 24 | 0) >> 2] = $1;
  $5 = 0;
  alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__h81af513058d3de2b($4 + 16 | 0 | 0, $4 + 24 | 0 | 0, $3 | 0, 0 | 0);
  $6 = HEAP32[($4 + 20 | 0) >> 2] | 0;
  label$1 : {
   if (!(HEAP32[($4 + 16 | 0) >> 2] | 0)) {
    break label$1
   }
   label$2 : while (1) {
    label$3 : {
     if ($1) {
      break label$3
     }
     $5 = 1;
     $1 = 0;
     break label$1;
    }
    $2 = HEAP32[(($2 + ($6 << 2 | 0) | 0) + 1464 | 0) >> 2] | 0;
    HEAP32[($4 + 28 | 0) >> 2] = $2;
    $1 = $1 + -1 | 0;
    HEAP32[($4 + 24 | 0) >> 2] = $1;
    alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__h81af513058d3de2b($4 + 8 | 0 | 0, $4 + 24 | 0 | 0, $3 | 0, 0 | 0);
    $6 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    if (HEAP32[($4 + 8 | 0) >> 2] | 0) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[$0 >> 2] = $5;
  HEAP32[($0 + 12 | 0) >> 2] = $6;
  HEAP32[($0 + 8 | 0) >> 2] = $2;
  global$0 = $4 + 32 | 0;
 }
 
 function alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__h487fda3c5b7fd5ef($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $6 = 0, $5 = 0;
  $4 = global$0 - 32 | 0;
  global$0 = $4;
  HEAP32[($4 + 28 | 0) >> 2] = $2;
  HEAP32[($4 + 24 | 0) >> 2] = $1;
  $5 = 0;
  alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__h2a96d0c76ba9da6b($4 + 16 | 0 | 0, $4 + 24 | 0 | 0, $3 | 0, 0 | 0);
  $6 = HEAP32[($4 + 20 | 0) >> 2] | 0;
  label$1 : {
   if (!(HEAP32[($4 + 16 | 0) >> 2] | 0)) {
    break label$1
   }
   label$2 : while (1) {
    label$3 : {
     if ($1) {
      break label$3
     }
     $5 = 1;
     $1 = 0;
     break label$1;
    }
    $2 = HEAP32[(($2 + ($6 << 2 | 0) | 0) + 320 | 0) >> 2] | 0;
    HEAP32[($4 + 28 | 0) >> 2] = $2;
    $1 = $1 + -1 | 0;
    HEAP32[($4 + 24 | 0) >> 2] = $1;
    alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__h2a96d0c76ba9da6b($4 + 8 | 0 | 0, $4 + 24 | 0 | 0, $3 | 0, 0 | 0);
    $6 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    if (HEAP32[($4 + 8 | 0) >> 2] | 0) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[$0 >> 2] = $5;
  HEAP32[($0 + 12 | 0) >> 2] = $6;
  HEAP32[($0 + 8 | 0) >> 2] = $2;
  global$0 = $4 + 32 | 0;
 }
 
 function alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__h53d3f5d723fce848($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $6 = 0, $5 = 0;
  $4 = global$0 - 32 | 0;
  global$0 = $4;
  HEAP32[($4 + 28 | 0) >> 2] = $2;
  HEAP32[($4 + 24 | 0) >> 2] = $1;
  $5 = 0;
  alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__h00b00e731f071e0e($4 + 16 | 0 | 0, $4 + 24 | 0 | 0, $3 | 0, 0 | 0);
  $6 = HEAP32[($4 + 20 | 0) >> 2] | 0;
  label$1 : {
   if (!(HEAP32[($4 + 16 | 0) >> 2] | 0)) {
    break label$1
   }
   label$2 : while (1) {
    label$3 : {
     if ($1) {
      break label$3
     }
     $5 = 1;
     $1 = 0;
     break label$1;
    }
    $2 = HEAP32[(($2 + ($6 << 2 | 0) | 0) + 448 | 0) >> 2] | 0;
    HEAP32[($4 + 28 | 0) >> 2] = $2;
    $1 = $1 + -1 | 0;
    HEAP32[($4 + 24 | 0) >> 2] = $1;
    alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__h00b00e731f071e0e($4 + 8 | 0 | 0, $4 + 24 | 0 | 0, $3 | 0, 0 | 0);
    $6 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    if (HEAP32[($4 + 8 | 0) >> 2] | 0) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[$0 >> 2] = $5;
  HEAP32[($0 + 12 | 0) >> 2] = $6;
  HEAP32[($0 + 8 | 0) >> 2] = $2;
  global$0 = $4 + 32 | 0;
 }
 
 function alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__h5e891db8f61b9488($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $6 = 0, $5 = 0;
  $4 = global$0 - 32 | 0;
  global$0 = $4;
  HEAP32[($4 + 28 | 0) >> 2] = $2;
  HEAP32[($4 + 24 | 0) >> 2] = $1;
  $5 = 0;
  alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__h2aab8de7f66bfb86($4 + 16 | 0 | 0, $4 + 24 | 0 | 0, $3 | 0, 0 | 0);
  $6 = HEAP32[($4 + 20 | 0) >> 2] | 0;
  label$1 : {
   if (!(HEAP32[($4 + 16 | 0) >> 2] | 0)) {
    break label$1
   }
   label$2 : while (1) {
    label$3 : {
     if ($1) {
      break label$3
     }
     $5 = 1;
     $1 = 0;
     break label$1;
    }
    $2 = HEAP32[(($2 + ($6 << 2 | 0) | 0) + 1064 | 0) >> 2] | 0;
    HEAP32[($4 + 28 | 0) >> 2] = $2;
    $1 = $1 + -1 | 0;
    HEAP32[($4 + 24 | 0) >> 2] = $1;
    alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__h2aab8de7f66bfb86($4 + 8 | 0 | 0, $4 + 24 | 0 | 0, $3 | 0, 0 | 0);
    $6 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    if (HEAP32[($4 + 8 | 0) >> 2] | 0) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[$0 >> 2] = $5;
  HEAP32[($0 + 12 | 0) >> 2] = $6;
  HEAP32[($0 + 8 | 0) >> 2] = $2;
  global$0 = $4 + 32 | 0;
 }
 
 function alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__h69963ef43fa7a3b9($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $6 = 0, $5 = 0;
  $4 = global$0 - 32 | 0;
  global$0 = $4;
  HEAP32[($4 + 28 | 0) >> 2] = $2;
  HEAP32[($4 + 24 | 0) >> 2] = $1;
  $5 = 0;
  alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__hb21438687147b7bc($4 + 16 | 0 | 0, $4 + 24 | 0 | 0, $3 | 0, 0 | 0);
  $6 = HEAP32[($4 + 20 | 0) >> 2] | 0;
  label$1 : {
   if (!(HEAP32[($4 + 16 | 0) >> 2] | 0)) {
    break label$1
   }
   label$2 : while (1) {
    label$3 : {
     if ($1) {
      break label$3
     }
     $5 = 1;
     $1 = 0;
     break label$1;
    }
    $2 = HEAP32[(($2 + ($6 << 2 | 0) | 0) + 52 | 0) >> 2] | 0;
    HEAP32[($4 + 28 | 0) >> 2] = $2;
    $1 = $1 + -1 | 0;
    HEAP32[($4 + 24 | 0) >> 2] = $1;
    alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__hb21438687147b7bc($4 + 8 | 0 | 0, $4 + 24 | 0 | 0, $3 | 0, 0 | 0);
    $6 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    if (HEAP32[($4 + 8 | 0) >> 2] | 0) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[$0 >> 2] = $5;
  HEAP32[($0 + 12 | 0) >> 2] = $6;
  HEAP32[($0 + 8 | 0) >> 2] = $2;
  global$0 = $4 + 32 | 0;
 }
 
 function alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__h6a50e69eb0c61fee($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $6 = 0, $5 = 0;
  $4 = global$0 - 32 | 0;
  global$0 = $4;
  HEAP32[($4 + 28 | 0) >> 2] = $2;
  HEAP32[($4 + 24 | 0) >> 2] = $1;
  $5 = 0;
  alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__h764a533569784781($4 + 16 | 0 | 0, $4 + 24 | 0 | 0, $3 | 0, 0 | 0);
  $6 = HEAP32[($4 + 20 | 0) >> 2] | 0;
  label$1 : {
   if (!(HEAP32[($4 + 16 | 0) >> 2] | 0)) {
    break label$1
   }
   label$2 : while (1) {
    label$3 : {
     if ($1) {
      break label$3
     }
     $5 = 1;
     $1 = 0;
     break label$1;
    }
    $2 = HEAP32[(($2 + ($6 << 2 | 0) | 0) + 320 | 0) >> 2] | 0;
    HEAP32[($4 + 28 | 0) >> 2] = $2;
    $1 = $1 + -1 | 0;
    HEAP32[($4 + 24 | 0) >> 2] = $1;
    alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__h764a533569784781($4 + 8 | 0 | 0, $4 + 24 | 0 | 0, $3 | 0, 0 | 0);
    $6 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    if (HEAP32[($4 + 8 | 0) >> 2] | 0) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[$0 >> 2] = $5;
  HEAP32[($0 + 12 | 0) >> 2] = $6;
  HEAP32[($0 + 8 | 0) >> 2] = $2;
  global$0 = $4 + 32 | 0;
 }
 
 function alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__h6a813680d458244c($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $6 = 0, $5 = 0;
  $4 = global$0 - 32 | 0;
  global$0 = $4;
  HEAP32[($4 + 28 | 0) >> 2] = $2;
  HEAP32[($4 + 24 | 0) >> 2] = $1;
  $5 = 0;
  alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__h36882228e88da32b($4 + 16 | 0 | 0, $4 + 24 | 0 | 0, $3 | 0, 0 | 0);
  $6 = HEAP32[($4 + 20 | 0) >> 2] | 0;
  label$1 : {
   if (!(HEAP32[($4 + 16 | 0) >> 2] | 0)) {
    break label$1
   }
   label$2 : while (1) {
    label$3 : {
     if ($1) {
      break label$3
     }
     $5 = 1;
     $1 = 0;
     break label$1;
    }
    $2 = HEAP32[(($2 + ($6 << 2 | 0) | 0) + 448 | 0) >> 2] | 0;
    HEAP32[($4 + 28 | 0) >> 2] = $2;
    $1 = $1 + -1 | 0;
    HEAP32[($4 + 24 | 0) >> 2] = $1;
    alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__h36882228e88da32b($4 + 8 | 0 | 0, $4 + 24 | 0 | 0, $3 | 0, 0 | 0);
    $6 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    if (HEAP32[($4 + 8 | 0) >> 2] | 0) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[$0 >> 2] = $5;
  HEAP32[($0 + 12 | 0) >> 2] = $6;
  HEAP32[($0 + 8 | 0) >> 2] = $2;
  global$0 = $4 + 32 | 0;
 }
 
 function alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__h6fa0f6109e8ad24d($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $6 = 0, $5 = 0;
  $4 = global$0 - 32 | 0;
  global$0 = $4;
  HEAP32[($4 + 28 | 0) >> 2] = $2;
  HEAP32[($4 + 24 | 0) >> 2] = $1;
  $5 = 0;
  alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__h95d3836825c8de7a($4 + 16 | 0 | 0, $4 + 24 | 0 | 0, $3 | 0, 0 | 0);
  $6 = HEAP32[($4 + 20 | 0) >> 2] | 0;
  label$1 : {
   if (!(HEAP32[($4 + 16 | 0) >> 2] | 0)) {
    break label$1
   }
   label$2 : while (1) {
    label$3 : {
     if ($1) {
      break label$3
     }
     $5 = 1;
     $1 = 0;
     break label$1;
    }
    $2 = HEAP32[(($2 + ($6 << 2 | 0) | 0) + 1552 | 0) >> 2] | 0;
    HEAP32[($4 + 28 | 0) >> 2] = $2;
    $1 = $1 + -1 | 0;
    HEAP32[($4 + 24 | 0) >> 2] = $1;
    alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__h95d3836825c8de7a($4 + 8 | 0 | 0, $4 + 24 | 0 | 0, $3 | 0, 0 | 0);
    $6 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    if (HEAP32[($4 + 8 | 0) >> 2] | 0) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[$0 >> 2] = $5;
  HEAP32[($0 + 12 | 0) >> 2] = $6;
  HEAP32[($0 + 8 | 0) >> 2] = $2;
  global$0 = $4 + 32 | 0;
 }
 
 function alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__h7a535ed0615a3476($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $6 = 0, $5 = 0;
  $4 = global$0 - 32 | 0;
  global$0 = $4;
  HEAP32[($4 + 28 | 0) >> 2] = $2;
  HEAP32[($4 + 24 | 0) >> 2] = $1;
  $5 = 0;
  alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__h552b67ac5806e190($4 + 16 | 0 | 0, $4 + 24 | 0 | 0, $3 | 0, 0 | 0);
  $6 = HEAP32[($4 + 20 | 0) >> 2] | 0;
  label$1 : {
   if (!(HEAP32[($4 + 16 | 0) >> 2] | 0)) {
    break label$1
   }
   label$2 : while (1) {
    label$3 : {
     if ($1) {
      break label$3
     }
     $5 = 1;
     $1 = 0;
     break label$1;
    }
    $2 = HEAP32[(($2 + ($6 << 2 | 0) | 0) + 1064 | 0) >> 2] | 0;
    HEAP32[($4 + 28 | 0) >> 2] = $2;
    $1 = $1 + -1 | 0;
    HEAP32[($4 + 24 | 0) >> 2] = $1;
    alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__h552b67ac5806e190($4 + 8 | 0 | 0, $4 + 24 | 0 | 0, $3 | 0, 0 | 0);
    $6 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    if (HEAP32[($4 + 8 | 0) >> 2] | 0) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[$0 >> 2] = $5;
  HEAP32[($0 + 12 | 0) >> 2] = $6;
  HEAP32[($0 + 8 | 0) >> 2] = $2;
  global$0 = $4 + 32 | 0;
 }
 
 function alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__h7cca0af434b441f5($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $6 = 0, $5 = 0;
  $4 = global$0 - 32 | 0;
  global$0 = $4;
  HEAP32[($4 + 28 | 0) >> 2] = $2;
  HEAP32[($4 + 24 | 0) >> 2] = $1;
  $5 = 0;
  alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__hdf3d9c2a56594c01($4 + 16 | 0 | 0, $4 + 24 | 0 | 0, $3 | 0, 0 | 0);
  $6 = HEAP32[($4 + 20 | 0) >> 2] | 0;
  label$1 : {
   if (!(HEAP32[($4 + 16 | 0) >> 2] | 0)) {
    break label$1
   }
   label$2 : while (1) {
    label$3 : {
     if ($1) {
      break label$3
     }
     $5 = 1;
     $1 = 0;
     break label$1;
    }
    $2 = HEAP32[(($2 + ($6 << 2 | 0) | 0) + 232 | 0) >> 2] | 0;
    HEAP32[($4 + 28 | 0) >> 2] = $2;
    $1 = $1 + -1 | 0;
    HEAP32[($4 + 24 | 0) >> 2] = $1;
    alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__hdf3d9c2a56594c01($4 + 8 | 0 | 0, $4 + 24 | 0 | 0, $3 | 0, 0 | 0);
    $6 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    if (HEAP32[($4 + 8 | 0) >> 2] | 0) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[$0 >> 2] = $5;
  HEAP32[($0 + 12 | 0) >> 2] = $6;
  HEAP32[($0 + 8 | 0) >> 2] = $2;
  global$0 = $4 + 32 | 0;
 }
 
 function alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__h802fdd2e37b8965b($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $6 = 0, $5 = 0;
  $4 = global$0 - 32 | 0;
  global$0 = $4;
  HEAP32[($4 + 28 | 0) >> 2] = $2;
  HEAP32[($4 + 24 | 0) >> 2] = $1;
  $5 = 0;
  alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__hf773ebee3f7d1881($4 + 16 | 0 | 0, $4 + 24 | 0 | 0, $3 | 0, 0 | 0);
  $6 = HEAP32[($4 + 20 | 0) >> 2] | 0;
  label$1 : {
   if (!(HEAP32[($4 + 16 | 0) >> 2] | 0)) {
    break label$1
   }
   label$2 : while (1) {
    label$3 : {
     if ($1) {
      break label$3
     }
     $5 = 1;
     $1 = 0;
     break label$1;
    }
    $2 = HEAP32[(($2 + ($6 << 2 | 0) | 0) + 144 | 0) >> 2] | 0;
    HEAP32[($4 + 28 | 0) >> 2] = $2;
    $1 = $1 + -1 | 0;
    HEAP32[($4 + 24 | 0) >> 2] = $1;
    alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__hf773ebee3f7d1881($4 + 8 | 0 | 0, $4 + 24 | 0 | 0, $3 | 0, 0 | 0);
    $6 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    if (HEAP32[($4 + 8 | 0) >> 2] | 0) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[$0 >> 2] = $5;
  HEAP32[($0 + 12 | 0) >> 2] = $6;
  HEAP32[($0 + 8 | 0) >> 2] = $2;
  global$0 = $4 + 32 | 0;
 }
 
 function alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__h804fffb548e74f27($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $6 = 0, $5 = 0;
  $4 = global$0 - 32 | 0;
  global$0 = $4;
  HEAP32[($4 + 28 | 0) >> 2] = $2;
  HEAP32[($4 + 24 | 0) >> 2] = $1;
  $5 = 0;
  alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__h53de2975e7d4f713($4 + 16 | 0 | 0, $4 + 24 | 0 | 0, $3 | 0, 0 | 0);
  $6 = HEAP32[($4 + 20 | 0) >> 2] | 0;
  label$1 : {
   if (!(HEAP32[($4 + 16 | 0) >> 2] | 0)) {
    break label$1
   }
   label$2 : while (1) {
    label$3 : {
     if ($1) {
      break label$3
     }
     $5 = 1;
     $1 = 0;
     break label$1;
    }
    $2 = HEAP32[(($2 + ($6 << 2 | 0) | 0) + 1552 | 0) >> 2] | 0;
    HEAP32[($4 + 28 | 0) >> 2] = $2;
    $1 = $1 + -1 | 0;
    HEAP32[($4 + 24 | 0) >> 2] = $1;
    alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__h53de2975e7d4f713($4 + 8 | 0 | 0, $4 + 24 | 0 | 0, $3 | 0, 0 | 0);
    $6 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    if (HEAP32[($4 + 8 | 0) >> 2] | 0) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[$0 >> 2] = $5;
  HEAP32[($0 + 12 | 0) >> 2] = $6;
  HEAP32[($0 + 8 | 0) >> 2] = $2;
  global$0 = $4 + 32 | 0;
 }
 
 function alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__h98b098e6271053bd($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $6 = 0, $5 = 0;
  $4 = global$0 - 32 | 0;
  global$0 = $4;
  HEAP32[($4 + 28 | 0) >> 2] = $2;
  HEAP32[($4 + 24 | 0) >> 2] = $1;
  $5 = 0;
  alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__h3b17f34c380171fa($4 + 16 | 0 | 0, $4 + 24 | 0 | 0, $3 | 0, 0 | 0);
  $6 = HEAP32[($4 + 20 | 0) >> 2] | 0;
  label$1 : {
   if (!(HEAP32[($4 + 16 | 0) >> 2] | 0)) {
    break label$1
   }
   label$2 : while (1) {
    label$3 : {
     if ($1) {
      break label$3
     }
     $5 = 1;
     $1 = 0;
     break label$1;
    }
    $2 = HEAP32[(($2 + ($6 << 2 | 0) | 0) + 316 | 0) >> 2] | 0;
    HEAP32[($4 + 28 | 0) >> 2] = $2;
    $1 = $1 + -1 | 0;
    HEAP32[($4 + 24 | 0) >> 2] = $1;
    alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__h3b17f34c380171fa($4 + 8 | 0 | 0, $4 + 24 | 0 | 0, $3 | 0, 0 | 0);
    $6 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    if (HEAP32[($4 + 8 | 0) >> 2] | 0) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[$0 >> 2] = $5;
  HEAP32[($0 + 12 | 0) >> 2] = $6;
  HEAP32[($0 + 8 | 0) >> 2] = $2;
  global$0 = $4 + 32 | 0;
 }
 
 function alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__hac6e0923ca1aecc1($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $6 = 0, $5 = 0;
  $4 = global$0 - 32 | 0;
  global$0 = $4;
  HEAP32[($4 + 28 | 0) >> 2] = $2;
  HEAP32[($4 + 24 | 0) >> 2] = $1;
  $5 = 0;
  alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__hb74a59103735e676($4 + 16 | 0 | 0, $4 + 24 | 0 | 0, $3 | 0, 0 | 0);
  $6 = HEAP32[($4 + 20 | 0) >> 2] | 0;
  label$1 : {
   if (!(HEAP32[($4 + 16 | 0) >> 2] | 0)) {
    break label$1
   }
   label$2 : while (1) {
    label$3 : {
     if ($1) {
      break label$3
     }
     $5 = 1;
     $1 = 0;
     break label$1;
    }
    $2 = HEAP32[(($2 + ($6 << 2 | 0) | 0) + 448 | 0) >> 2] | 0;
    HEAP32[($4 + 28 | 0) >> 2] = $2;
    $1 = $1 + -1 | 0;
    HEAP32[($4 + 24 | 0) >> 2] = $1;
    alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__hb74a59103735e676($4 + 8 | 0 | 0, $4 + 24 | 0 | 0, $3 | 0, 0 | 0);
    $6 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    if (HEAP32[($4 + 8 | 0) >> 2] | 0) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[$0 >> 2] = $5;
  HEAP32[($0 + 12 | 0) >> 2] = $6;
  HEAP32[($0 + 8 | 0) >> 2] = $2;
  global$0 = $4 + 32 | 0;
 }
 
 function alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__hb0ce81fc1958ae1e($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $6 = 0, $5 = 0;
  $4 = global$0 - 32 | 0;
  global$0 = $4;
  HEAP32[($4 + 28 | 0) >> 2] = $2;
  HEAP32[($4 + 24 | 0) >> 2] = $1;
  $5 = 0;
  alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__haa5df25eb520025e($4 + 16 | 0 | 0, $4 + 24 | 0 | 0, $3 | 0, 0 | 0);
  $6 = HEAP32[($4 + 20 | 0) >> 2] | 0;
  label$1 : {
   if (!(HEAP32[($4 + 16 | 0) >> 2] | 0)) {
    break label$1
   }
   label$2 : while (1) {
    label$3 : {
     if ($1) {
      break label$3
     }
     $5 = 1;
     $1 = 0;
     break label$1;
    }
    $2 = HEAP32[(($2 + ($6 << 2 | 0) | 0) + 140 | 0) >> 2] | 0;
    HEAP32[($4 + 28 | 0) >> 2] = $2;
    $1 = $1 + -1 | 0;
    HEAP32[($4 + 24 | 0) >> 2] = $1;
    alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__haa5df25eb520025e($4 + 8 | 0 | 0, $4 + 24 | 0 | 0, $3 | 0, 0 | 0);
    $6 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    if (HEAP32[($4 + 8 | 0) >> 2] | 0) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[$0 >> 2] = $5;
  HEAP32[($0 + 12 | 0) >> 2] = $6;
  HEAP32[($0 + 8 | 0) >> 2] = $2;
  global$0 = $4 + 32 | 0;
 }
 
 function alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__hc3a0c63fe21f356f($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $6 = 0, $5 = 0;
  $4 = global$0 - 32 | 0;
  global$0 = $4;
  HEAP32[($4 + 28 | 0) >> 2] = $2;
  HEAP32[($4 + 24 | 0) >> 2] = $1;
  $5 = 0;
  alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__h8c834b0d29bdf3d8($4 + 16 | 0 | 0, $4 + 24 | 0 | 0, $3 | 0, 0 | 0);
  $6 = HEAP32[($4 + 20 | 0) >> 2] | 0;
  label$1 : {
   if (!(HEAP32[($4 + 16 | 0) >> 2] | 0)) {
    break label$1
   }
   label$2 : while (1) {
    label$3 : {
     if ($1) {
      break label$3
     }
     $5 = 1;
     $1 = 0;
     break label$1;
    }
    $2 = HEAP32[(($2 + ($6 << 2 | 0) | 0) + 144 | 0) >> 2] | 0;
    HEAP32[($4 + 28 | 0) >> 2] = $2;
    $1 = $1 + -1 | 0;
    HEAP32[($4 + 24 | 0) >> 2] = $1;
    alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__h8c834b0d29bdf3d8($4 + 8 | 0 | 0, $4 + 24 | 0 | 0, $3 | 0, 0 | 0);
    $6 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    if (HEAP32[($4 + 8 | 0) >> 2] | 0) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[$0 >> 2] = $5;
  HEAP32[($0 + 12 | 0) >> 2] = $6;
  HEAP32[($0 + 8 | 0) >> 2] = $2;
  global$0 = $4 + 32 | 0;
 }
 
 function moveinstantaneousrewardscert_move_instantaneous_reward($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, $2 = 0, $4 = 0, $5 = 0, $5$hi = 0, $3 = 0, $26 = 0;
  $1 = global$0 - 112 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h0350daea3c8d0cce($1 | 0, $0 | 0);
   $0 = HEAP32[$1 >> 2] | 0;
   $2 = $0 + 8 | 0;
   $3 = HEAPU8[($0 + 48 | 0) >> 0] | 0;
   $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   i64toi32_i32$0 = 0;
   $5 = 1;
   $5$hi = i64toi32_i32$0;
   label$2 : {
    label$3 : {
     i64toi32_i32$2 = $0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     i64toi32_i32$2 = i64toi32_i32$0;
     i64toi32_i32$0 = 0;
     i64toi32_i32$3 = 1;
     if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
      break label$3
     }
     i64toi32_i32$3 = $2;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $26 = i64toi32_i32$2;
     i64toi32_i32$2 = $1;
     HEAP32[($1 + 64 | 0) >> 2] = $26;
     HEAP32[($1 + 68 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = 0;
     $5 = 0;
     $5$hi = i64toi32_i32$1;
     break label$2;
    }
    $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h7490700a7eed2994(($1 + 56 | 0) + 8 | 0 | 0, $2 | 0);
   }
   i64toi32_i32$1 = $5$hi;
   i64toi32_i32$2 = $1;
   HEAP32[($1 + 56 | 0) >> 2] = $5;
   HEAP32[($1 + 60 | 0) >> 2] = i64toi32_i32$1;
   memcpy($1 + 8 | 0 | 0, $1 + 56 | 0 | 0, 48 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($4 | 0, (HEAP32[$4 >> 2] | 0) + -1 | 0 | 0) | 0;
   memcpy($1 + 56 | 0 | 0, $1 + 8 | 0 | 0, 48 | 0) | 0;
   HEAP8[($1 + 104 | 0) >> 0] = $3;
   $0 = $cardano_serialization_lib__MoveInstantaneousReward_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hf9455bc13311e72d($1 + 56 | 0 | 0) | 0;
   global$0 = $1 + 112 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function moveinstantaneousrewardscert_new($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, $2 = 0, $4 = 0, $5 = 0, $5$hi = 0, $3 = 0, $26 = 0;
  $1 = global$0 - 112 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h84b5bdabb1c1c80b($1 | 0, $0 | 0);
   $0 = HEAP32[$1 >> 2] | 0;
   $2 = $0 + 8 | 0;
   $3 = HEAPU8[($0 + 48 | 0) >> 0] | 0;
   $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   i64toi32_i32$0 = 0;
   $5 = 1;
   $5$hi = i64toi32_i32$0;
   label$2 : {
    label$3 : {
     i64toi32_i32$2 = $0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     i64toi32_i32$2 = i64toi32_i32$0;
     i64toi32_i32$0 = 0;
     i64toi32_i32$3 = 1;
     if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
      break label$3
     }
     i64toi32_i32$3 = $2;
     i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
     $26 = i64toi32_i32$2;
     i64toi32_i32$2 = $1;
     HEAP32[($1 + 64 | 0) >> 2] = $26;
     HEAP32[($1 + 68 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$1 = 0;
     $5 = 0;
     $5$hi = i64toi32_i32$1;
     break label$2;
    }
    $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h7490700a7eed2994(($1 + 56 | 0) + 8 | 0 | 0, $2 | 0);
   }
   i64toi32_i32$1 = $5$hi;
   i64toi32_i32$2 = $1;
   HEAP32[($1 + 56 | 0) >> 2] = $5;
   HEAP32[($1 + 60 | 0) >> 2] = i64toi32_i32$1;
   memcpy($1 + 8 | 0 | 0, $1 + 56 | 0 | 0, 48 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($4 | 0, (HEAP32[$4 >> 2] | 0) + -1 | 0 | 0) | 0;
   memcpy($1 + 56 | 0 | 0, $1 + 8 | 0 | 0, 48 | 0) | 0;
   HEAP8[($1 + 104 | 0) >> 0] = $3;
   $0 = $cardano_serialization_lib__MoveInstantaneousRewardsCert_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8b59c9ac999ad03b($1 + 56 | 0 | 0) | 0;
   global$0 = $1 + 112 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function $cardano_serialization_lib__SingleHostAddr_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h9b7c6207b2d568f8($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $13 = 0, $14 = 0, $15 = 0, $18 = 0, $24 = 0, $30 = 0, $33 = 0, $36 = 0, $41 = 0, $46 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__ha4e1a799acccbfd2($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $24 = i64toi32_i32$1;
  i64toi32_i32$1 = ($2 + 16 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $24;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1 + 24 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 24 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $30;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $33 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $33;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] | 0;
  $36 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  $13 = $36;
  HEAP16[i64toi32_i32$0 >> 1] = $13;
  HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $13 >>> 16 | 0;
  HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$1;
  HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 28 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $41 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 8 | 0;
  $14 = $41;
  HEAP16[i64toi32_i32$1 >> 1] = $14;
  HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $14 >>> 16 | 0;
  HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = i64toi32_i32$0;
  HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
  i64toi32_i32$2 = $2 + 36 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 16 | 0;
  $15 = $46;
  HEAP16[i64toi32_i32$0 >> 1] = $15;
  HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $15 >>> 16 | 0;
  HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$1;
  HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
  HEAP16[($0 + 24 | 0) >> 1] = HEAPU16[($2 + 44 | 0) >> 1] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 32 | 0, 4 | 0);
  global$0 = $2 + 48 | 0;
 }
 
 function singlehostname_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $30 = 0, $52 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $30;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__SingleHostName__from_bytes__h1cab2c930890fb43($2 + 8 | 0 | 0, $2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  HEAP32[($2 + 60 | 0) >> 2] = HEAP32[($2 + 24 | 0) >> 2] | 0;
  HEAP32[($2 + 48 | 0) >> 2] = $1;
  i64toi32_i32$2 = ($2 + 8 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $52 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 52 | 0) >> 2] = $52;
  HEAP32[($2 + 56 | 0) >> 2] = i64toi32_i32$0;
  $1 = $cardano_serialization_lib__SingleHostName_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hc318333b1b61f10d($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__Relay_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__haa46af776723fcc2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $18 = 0, $24 = 0, $30 = 0, $33 = 0, $36 = 0, $41 = 0, $46 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hc62850cdf82b67ee($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $24 = i64toi32_i32$1;
  i64toi32_i32$1 = ($2 + 16 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $24;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1 + 24 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 24 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $30;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $33 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $33;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] | 0;
  $36 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $36;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$2 + 28 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $41 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $41;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2 + 36 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $46;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($0 + 24 | 0) >> 2] = HEAP32[($2 + 44 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 32 | 0, 4 | 0);
  global$0 = $2 + 48 | 0;
 }
 
 function $cardano_serialization_lib__ScriptPubkey_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h11ae1eec7d920302($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $13 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $24 = 0, $30 = 0, $33 = 0, $36 = 0, $41 = 0, $46 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h7b938c611a49001e($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $24 = i64toi32_i32$1;
  i64toi32_i32$1 = ($2 + 16 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $24;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1 + 24 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 24 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $30;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $33 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $33;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] | 0;
  $36 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  $13 = $36;
  HEAP8[i64toi32_i32$0 >> 0] = $13;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 28 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $41 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 8 | 0;
  $14 = $41;
  HEAP8[i64toi32_i32$1 >> 0] = $14;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $14 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $14 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $14 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 36 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 16 | 0;
  $15 = $46;
  HEAP8[i64toi32_i32$0 >> 0] = $15;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $15 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $15 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $15 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $16 = $0 + 24 | 0;
  $17 = HEAP32[($2 + 44 | 0) >> 2] | 0;
  HEAP8[$16 >> 0] = $17;
  HEAP8[($16 + 1 | 0) >> 0] = $17 >>> 8 | 0;
  HEAP8[($16 + 2 | 0) >> 0] = $17 >>> 16 | 0;
  HEAP8[($16 + 3 | 0) >> 0] = $17 >>> 24 | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 32 | 0, 4 | 0);
  global$0 = $2 + 48 | 0;
 }
 
 function scriptnofk_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $30 = 0, $52 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $30;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__ScriptNOfK__from_bytes__haf30bcd1e11379d4($2 + 8 | 0 | 0, $2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  HEAP32[($2 + 60 | 0) >> 2] = HEAP32[($2 + 24 | 0) >> 2] | 0;
  HEAP32[($2 + 48 | 0) >> 2] = $1;
  i64toi32_i32$2 = ($2 + 8 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $52 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 52 | 0) >> 2] = $52;
  HEAP32[($2 + 56 | 0) >> 2] = i64toi32_i32$0;
  $1 = $cardano_serialization_lib__ScriptNOfK_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h0db7a3b086405587($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function cardano_serialization_lib__OperationalCert__from_bytes__hcdb92a2779b09d56($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $14 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 240 | 0;
  global$0 = $2;
  HEAP32[($2 + 232 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 216 | 0) >> 2] = 0;
  HEAP32[($2 + 220 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 224 | 0) >> 2] = $14;
  HEAP32[($2 + 228 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__OperationalCert___deserialize__he0f26523763e73af($2 + 104 | 0 | 0, $2 + 216 | 0 | 0);
  $1 = ($2 + 216 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 104 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    memcpy($0 + 4 | 0 | 0, memcpy($2 | 0, $2 + 104 | 0 | 4 | 0 | 0, 104 | 0) | 0 | 0, 104 | 0) | 0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 104 | 0 | 0, memcpy($2 + 4 | 0 | 0, ($2 + 104 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 104 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 240 | 0;
 }
 
 function hashbrown__raw__RawTable_T_2cA___drop_elements__h5fa5723d63f72f04($0) {
  $0 = $0 | 0;
  var $2 = 0, $3 = 0, $1 = 0, $5 = 0, $4 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if (!(HEAP32[($0 + 12 | 0) >> 2] | 0)) {
    break label$1
   }
   $2 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   $3 = $2 + 4 | 0;
   $4 = ((HEAP32[$0 >> 2] | 0) + $2 | 0) + 1 | 0;
   $0 = ((HEAP32[$2 >> 2] | 0) ^ -1 | 0) & -2139062144 | 0;
   label$2 : while (1) {
    label$3 : {
     if ($0) {
      break label$3
     }
     label$4 : while (1) {
      if ($3 >>> 0 >= $4 >>> 0) {
       break label$1
      }
      $2 = $2 + -96 | 0;
      $0 = HEAP32[$3 >> 2] | 0;
      $5 = $3 + 4 | 0;
      $3 = $5;
      $0 = $0 & -2139062144 | 0;
      if (($0 | 0) == (-2139062144 | 0)) {
       continue label$4
      }
      break label$4;
     };
     $0 = $0 ^ -2139062144 | 0;
     $3 = $5;
    }
    (wasm2js_i32$0 = $1, wasm2js_i32$1 = $2 + Math_imul(0 - ((__wasm_ctz_i32($0 | 0) | 0) >>> 3 | 0) | 0, 24) | 0), HEAP32[(wasm2js_i32$0 + 12 | 0) >> 2] = wasm2js_i32$1;
    $0 = ($0 + -1 | 0) & $0 | 0;
    hashbrown__raw__Bucket_T___drop__ha8e556007b2a95eb($1 + 12 | 0 | 0);
    continue label$2;
   };
  }
  global$0 = $1 + 16 | 0;
 }
 
 function core__iter__adapters__process_results__h7123a39a50c5e464($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $6 = 0, $20 = 0, $5 = 0, $40 = 0, $44 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  $3 = 0;
  HEAP32[($2 + 8 | 0) >> 2] = 0;
  $4 = ($2 + 32 | 0) + 8 | 0;
  HEAP32[$4 >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $20;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($2 + 44 | 0) >> 2] = $2 + 8 | 0;
  $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__ha556d4e8ab20831e($2 + 16 | 0 | 0, $2 + 32 | 0 | 0);
  $1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  $5 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $6 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[$4 >> 2] = HEAP32[$6 >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $40 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $40;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    if ($1) {
     break label$2
    }
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
    $44 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $44;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = HEAP32[$6 >> 2] | 0;
    break label$1;
   }
   HEAP32[($0 + 4 | 0) >> 2] = $5;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h2d454d4f9b2e44f3($2 + 32 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h55384607e9cf45ad($2 + 32 | 0 | 0);
   $3 = 1;
  }
  HEAP32[$0 >> 2] = $3;
  global$0 = $2 + 48 | 0;
 }
 
 function cardano_serialization_lib___impl_20core__convert__From__cardano_serialization_lib__NativeScript__20for_20alloc__collections__btree__set__BTreeSet_cardano_serialization_lib__crypto__Ed25519KeyHash____from__h8ccce5a95eccf6e5($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $10 = 0, $19 = 0, $25 = 0, $28 = 0, $40 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    switch (HEAPU8[$1 >> 0] | 0 | 0) {
    default:
     i64toi32_i32$1 = $0;
     i64toi32_i32$0 = 0;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = 0;
     HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
     break label$1;
    case 0:
     i64toi32_i32$1 = $2;
     i64toi32_i32$0 = 0;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = 0;
     HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
     $10 = $1 + 25 | 0;
     HEAP32[(i64toi32_i32$1 + 40 | 0) >> 2] = HEAPU8[$10 >> 0] | 0 | ((HEAPU8[($10 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($10 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($10 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$2 = $1 + 17 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $19 = i64toi32_i32$0;
     i64toi32_i32$0 = $2 + 32 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $19;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $1 + 9 | 0;
     i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $25 = i64toi32_i32$1;
     i64toi32_i32$1 = ($2 + 16 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $25;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     i64toi32_i32$2 = $1;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $28 = i64toi32_i32$0;
     i64toi32_i32$0 = $2;
     HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $28;
     HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$1;
     alloc__collections__btree__map__BTreeMap_K_2cV___insert__h5d8c7a7452747b0f(i64toi32_i32$0 | 0, i64toi32_i32$0 + 16 | 0 | 0) | 0;
     HEAP32[($0 + 8 | 0) >> 2] = HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] | 0;
     i64toi32_i32$2 = i64toi32_i32$0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $40 = i64toi32_i32$1;
     i64toi32_i32$1 = $0;
     HEAP32[i64toi32_i32$1 >> 2] = $40;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     break label$1;
    case 1:
     cardano_serialization_lib___impl_20core__convert__From__cardano_serialization_lib__NativeScripts__20for_20alloc__collections__btree__set__BTreeSet_cardano_serialization_lib__crypto__Ed25519KeyHash____from__h8d3ffd91703d691f($0 | 0, $1 + 4 | 0 | 0);
     break label$1;
    case 2:
     cardano_serialization_lib___impl_20core__convert__From__cardano_serialization_lib__NativeScripts__20for_20alloc__collections__btree__set__BTreeSet_cardano_serialization_lib__crypto__Ed25519KeyHash____from__h8d3ffd91703d691f($0 | 0, $1 + 4 | 0 | 0);
     break label$1;
    case 3:
     break label$2;
    };
   }
   cardano_serialization_lib___impl_20core__convert__From__cardano_serialization_lib__NativeScripts__20for_20alloc__collections__btree__set__BTreeSet_cardano_serialization_lib__crypto__Ed25519KeyHash____from__h8d3ffd91703d691f($0 | 0, $1 + 8 | 0 | 0);
  }
  global$0 = $2 + 48 | 0;
 }
 
 function value_clamped_sub($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $43 = 0, $50 = 0, $53 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h5db5149478ec5345($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h5db5149478ec5345($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__utils__Value__clamped_sub__haa8c5f6481344bb0($2 + 16 | 0 | 0, $3 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   i64toi32_i32$2 = ($2 + 16 | 0) + 16 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $43 = i64toi32_i32$0;
   i64toi32_i32$0 = ($2 + 40 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $43;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $50 = i64toi32_i32$1;
   i64toi32_i32$1 = ($2 + 40 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $50;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   $53 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   HEAP32[($2 + 40 | 0) >> 2] = $53;
   HEAP32[($2 + 44 | 0) >> 2] = i64toi32_i32$1;
   $0 = $cardano_serialization_lib__utils__Value_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h50a1108e1e08f966($2 + 40 | 0 | 0) | 0;
   global$0 = $2 + 64 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function bigint_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $30 = 0, $52 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $30;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__utils__BigInt__from_bytes__hd0e437370f824683($2 + 8 | 0 | 0, $2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  HEAP32[($2 + 60 | 0) >> 2] = HEAP32[($2 + 24 | 0) >> 2] | 0;
  HEAP32[($2 + 48 | 0) >> 2] = $1;
  i64toi32_i32$2 = ($2 + 8 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $52 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 52 | 0) >> 2] = $52;
  HEAP32[($2 + 56 | 0) >> 2] = i64toi32_i32$0;
  $1 = $cardano_serialization_lib__utils__BigInt_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8699e08c5b3b0a6a($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function publickey_as_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $5 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $3 = 0, $4 = 0, $25 = 0, $30 = 0, $35 = 0, $40 = 0, $57 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h67eb974eba5bb4b0($2 + 24 | 0 | 0, $1 | 0);
  $3 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 + 16 | 0 | 0, 32 | 0, 0 | 0);
  $4 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $5 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $25 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  $14 = $25;
  HEAP8[i64toi32_i32$0 >> 0] = $14;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $14 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $14 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $14 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 24 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $30 = i64toi32_i32$1;
  i64toi32_i32$1 = $5 + 24 | 0;
  $15 = $30;
  HEAP8[i64toi32_i32$1 >> 0] = $15;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $15 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $15 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $15 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $35 = i64toi32_i32$0;
  i64toi32_i32$0 = $5 + 16 | 0;
  $16 = $35;
  HEAP8[i64toi32_i32$0 >> 0] = $16;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $16 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $40 = i64toi32_i32$1;
  i64toi32_i32$1 = $5 + 8 | 0;
  $17 = $40;
  HEAP8[i64toi32_i32$1 >> 0] = $17;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[($2 + 40 | 0) >> 2] = 32;
  HEAP32[($2 + 36 | 0) >> 2] = $4;
  HEAP32[($2 + 32 | 0) >> 2] = $5;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $57 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $57;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = i64toi32_i32$2 + 48 | 0;
 }
 
 function cardano_serialization_lib__crypto__BootstrapWitness__from_bytes__h8e912dadc9ea1fd5($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $14 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 272 | 0;
  global$0 = $2;
  HEAP32[($2 + 264 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 248 | 0) >> 2] = 0;
  HEAP32[($2 + 252 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 256 | 0) >> 2] = $14;
  HEAP32[($2 + 260 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__crypto__BootstrapWitness_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__haabcdaf43d31e3da($2 + 120 | 0 | 0, $2 + 248 | 0 | 0);
  $1 = ($2 + 248 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 120 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    memcpy($0 + 4 | 0 | 0, memcpy($2 | 0, $2 + 120 | 0 | 4 | 0 | 0, 120 | 0) | 0 | 0, 120 | 0) | 0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 120 | 0 | 0, memcpy($2 + 4 | 0 | 0, ($2 + 120 | 0) + 8 | 0 | 0, 64 | 0) | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 120 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 272 | 0;
 }
 
 function legacydaedalusprivatekey_chaincode($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $5 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $3 = 0, $4 = 0, $25 = 0, $30 = 0, $35 = 0, $40 = 0, $57 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h6e50d398ad665042($2 + 24 | 0 | 0, $1 | 0);
  $3 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 + 16 | 0 | 0, 32 | 0, 0 | 0);
  $4 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $5 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 64 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 65 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 66 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 67 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 68 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 69 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 70 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 71 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $25 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  $14 = $25;
  HEAP8[i64toi32_i32$0 >> 0] = $14;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $14 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $14 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $14 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 88 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $30 = i64toi32_i32$1;
  i64toi32_i32$1 = $5 + 24 | 0;
  $15 = $30;
  HEAP8[i64toi32_i32$1 >> 0] = $15;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $15 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $15 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $15 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 80 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $35 = i64toi32_i32$0;
  i64toi32_i32$0 = $5 + 16 | 0;
  $16 = $35;
  HEAP8[i64toi32_i32$0 >> 0] = $16;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $16 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 72 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $40 = i64toi32_i32$1;
  i64toi32_i32$1 = $5 + 8 | 0;
  $17 = $40;
  HEAP8[i64toi32_i32$1 >> 0] = $17;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[($2 + 40 | 0) >> 2] = 32;
  HEAP32[($2 + 36 | 0) >> 2] = $4;
  HEAP32[($2 + 32 | 0) >> 2] = $5;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $57 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $57;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = i64toi32_i32$2 + 48 | 0;
 }
 
 function $cardano_serialization_lib__crypto__Ed25519KeyHash_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hb04c1864cf0fd335($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $13 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $24 = 0, $30 = 0, $33 = 0, $36 = 0, $41 = 0, $46 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__ha0a883bb3aca536a($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $24 = i64toi32_i32$1;
  i64toi32_i32$1 = ($2 + 16 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $24;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1 + 24 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 24 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $30;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $33 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $33;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] | 0;
  $36 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  $13 = $36;
  HEAP8[i64toi32_i32$0 >> 0] = $13;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 28 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $41 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 8 | 0;
  $14 = $41;
  HEAP8[i64toi32_i32$1 >> 0] = $14;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $14 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $14 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $14 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 36 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 16 | 0;
  $15 = $46;
  HEAP8[i64toi32_i32$0 >> 0] = $15;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $15 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $15 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $15 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $16 = $0 + 24 | 0;
  $17 = HEAP32[($2 + 44 | 0) >> 2] | 0;
  HEAP8[$16 >> 0] = $17;
  HEAP8[($16 + 1 | 0) >> 0] = $17 >>> 8 | 0;
  HEAP8[($16 + 2 | 0) >> 0] = $17 >>> 16 | 0;
  HEAP8[($16 + 3 | 0) >> 0] = $17 >>> 24 | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 32 | 0, 4 | 0);
  global$0 = $2 + 48 | 0;
 }
 
 function ed25519keyhash_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $5 = 0, $13 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $3 = 0, $4 = 0, $25 = 0, $35 = 0, $40 = 0, $57 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hae9c55c4e91ce40f($2 + 24 | 0 | 0, $1 | 0);
  $3 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 + 16 | 0 | 0, 28 | 0, 0 | 0);
  $4 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $5 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $25 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  $13 = $25;
  HEAP8[i64toi32_i32$0 >> 0] = $13;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $14 = i64toi32_i32$2 + 24 | 0;
  $15 = i64toi32_i32$0 + 24 | 0;
  $16 = HEAPU8[$14 >> 0] | 0 | ((HEAPU8[($14 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($14 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($14 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  HEAP8[$15 >> 0] = $16;
  HEAP8[($15 + 1 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[($15 + 2 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[($15 + 3 | 0) >> 0] = $16 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 16 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $35 = i64toi32_i32$1;
  i64toi32_i32$1 = $5 + 16 | 0;
  $17 = $35;
  HEAP8[i64toi32_i32$1 >> 0] = $17;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $40 = i64toi32_i32$0;
  i64toi32_i32$0 = $5 + 8 | 0;
  $18 = $40;
  HEAP8[i64toi32_i32$0 >> 0] = $18;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $18 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $18 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $18 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[($2 + 40 | 0) >> 2] = 28;
  HEAP32[($2 + 36 | 0) >> 2] = $4;
  HEAP32[($2 + 32 | 0) >> 2] = $5;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $57 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $57;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = i64toi32_i32$2 + 48 | 0;
 }
 
 function $cardano_serialization_lib__crypto__ScriptHash_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h841a5f1b153ab9b0($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $13 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $24 = 0, $30 = 0, $33 = 0, $36 = 0, $41 = 0, $46 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hfbdb71482669dd0b($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $24 = i64toi32_i32$1;
  i64toi32_i32$1 = ($2 + 16 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $24;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1 + 24 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 24 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $30;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $33 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $33;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] | 0;
  $36 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  $13 = $36;
  HEAP8[i64toi32_i32$0 >> 0] = $13;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 28 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $41 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 8 | 0;
  $14 = $41;
  HEAP8[i64toi32_i32$1 >> 0] = $14;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $14 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $14 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $14 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 36 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 16 | 0;
  $15 = $46;
  HEAP8[i64toi32_i32$0 >> 0] = $15;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $15 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $15 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $15 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $16 = $0 + 24 | 0;
  $17 = HEAP32[($2 + 44 | 0) >> 2] | 0;
  HEAP8[$16 >> 0] = $17;
  HEAP8[($16 + 1 | 0) >> 0] = $17 >>> 8 | 0;
  HEAP8[($16 + 2 | 0) >> 0] = $17 >>> 16 | 0;
  HEAP8[($16 + 3 | 0) >> 0] = $17 >>> 24 | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 32 | 0, 4 | 0);
  global$0 = $2 + 48 | 0;
 }
 
 function scripthash_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $5 = 0, $13 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $3 = 0, $4 = 0, $25 = 0, $35 = 0, $40 = 0, $57 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h27da893e95dd15cf($2 + 24 | 0 | 0, $1 | 0);
  $3 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 + 16 | 0 | 0, 28 | 0, 0 | 0);
  $4 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $5 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $25 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  $13 = $25;
  HEAP8[i64toi32_i32$0 >> 0] = $13;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $14 = i64toi32_i32$2 + 24 | 0;
  $15 = i64toi32_i32$0 + 24 | 0;
  $16 = HEAPU8[$14 >> 0] | 0 | ((HEAPU8[($14 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($14 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($14 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  HEAP8[$15 >> 0] = $16;
  HEAP8[($15 + 1 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[($15 + 2 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[($15 + 3 | 0) >> 0] = $16 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 16 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $35 = i64toi32_i32$1;
  i64toi32_i32$1 = $5 + 16 | 0;
  $17 = $35;
  HEAP8[i64toi32_i32$1 >> 0] = $17;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $40 = i64toi32_i32$0;
  i64toi32_i32$0 = $5 + 8 | 0;
  $18 = $40;
  HEAP8[i64toi32_i32$0 >> 0] = $18;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $18 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $18 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $18 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[($2 + 40 | 0) >> 2] = 28;
  HEAP32[($2 + 36 | 0) >> 2] = $4;
  HEAP32[($2 + 32 | 0) >> 2] = $5;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $57 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $57;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = i64toi32_i32$2 + 48 | 0;
 }
 
 function transactionhash_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $5 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $3 = 0, $4 = 0, $25 = 0, $30 = 0, $35 = 0, $40 = 0, $57 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h8308bd69a8eeb68f($2 + 24 | 0 | 0, $1 | 0);
  $3 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 + 16 | 0 | 0, 32 | 0, 0 | 0);
  $4 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $5 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $25 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  $14 = $25;
  HEAP8[i64toi32_i32$0 >> 0] = $14;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $14 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $14 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $14 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 24 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $30 = i64toi32_i32$1;
  i64toi32_i32$1 = $5 + 24 | 0;
  $15 = $30;
  HEAP8[i64toi32_i32$1 >> 0] = $15;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $15 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $15 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $15 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $35 = i64toi32_i32$0;
  i64toi32_i32$0 = $5 + 16 | 0;
  $16 = $35;
  HEAP8[i64toi32_i32$0 >> 0] = $16;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $16 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $40 = i64toi32_i32$1;
  i64toi32_i32$1 = $5 + 8 | 0;
  $17 = $40;
  HEAP8[i64toi32_i32$1 >> 0] = $17;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[($2 + 40 | 0) >> 2] = 32;
  HEAP32[($2 + 36 | 0) >> 2] = $4;
  HEAP32[($2 + 32 | 0) >> 2] = $5;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $57 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $57;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = i64toi32_i32$2 + 48 | 0;
 }
 
 function $cardano_serialization_lib__crypto__GenesisDelegateHash_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h1f0ee653cb696cda($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $13 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $24 = 0, $30 = 0, $33 = 0, $36 = 0, $41 = 0, $46 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h434e5e29ad9f2783($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $24 = i64toi32_i32$1;
  i64toi32_i32$1 = ($2 + 16 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $24;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1 + 24 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 24 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $30;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $33 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $33;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] | 0;
  $36 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  $13 = $36;
  HEAP8[i64toi32_i32$0 >> 0] = $13;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 28 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $41 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 8 | 0;
  $14 = $41;
  HEAP8[i64toi32_i32$1 >> 0] = $14;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $14 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $14 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $14 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 36 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 16 | 0;
  $15 = $46;
  HEAP8[i64toi32_i32$0 >> 0] = $15;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $15 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $15 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $15 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $16 = $0 + 24 | 0;
  $17 = HEAP32[($2 + 44 | 0) >> 2] | 0;
  HEAP8[$16 >> 0] = $17;
  HEAP8[($16 + 1 | 0) >> 0] = $17 >>> 8 | 0;
  HEAP8[($16 + 2 | 0) >> 0] = $17 >>> 16 | 0;
  HEAP8[($16 + 3 | 0) >> 0] = $17 >>> 24 | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 32 | 0, 4 | 0);
  global$0 = $2 + 48 | 0;
 }
 
 function genesisdelegatehash_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $5 = 0, $13 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $3 = 0, $4 = 0, $25 = 0, $35 = 0, $40 = 0, $57 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h72d8bcf0a652eb89($2 + 24 | 0 | 0, $1 | 0);
  $3 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 + 16 | 0 | 0, 28 | 0, 0 | 0);
  $4 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $5 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $25 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  $13 = $25;
  HEAP8[i64toi32_i32$0 >> 0] = $13;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $14 = i64toi32_i32$2 + 24 | 0;
  $15 = i64toi32_i32$0 + 24 | 0;
  $16 = HEAPU8[$14 >> 0] | 0 | ((HEAPU8[($14 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($14 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($14 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  HEAP8[$15 >> 0] = $16;
  HEAP8[($15 + 1 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[($15 + 2 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[($15 + 3 | 0) >> 0] = $16 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 16 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $35 = i64toi32_i32$1;
  i64toi32_i32$1 = $5 + 16 | 0;
  $17 = $35;
  HEAP8[i64toi32_i32$1 >> 0] = $17;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $40 = i64toi32_i32$0;
  i64toi32_i32$0 = $5 + 8 | 0;
  $18 = $40;
  HEAP8[i64toi32_i32$0 >> 0] = $18;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $18 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $18 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $18 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[($2 + 40 | 0) >> 2] = 28;
  HEAP32[($2 + 36 | 0) >> 2] = $4;
  HEAP32[($2 + 32 | 0) >> 2] = $5;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $57 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $57;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = i64toi32_i32$2 + 48 | 0;
 }
 
 function $cardano_serialization_lib__crypto__GenesisHash_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h54f8e4796f67f1b1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $13 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $24 = 0, $30 = 0, $33 = 0, $36 = 0, $41 = 0, $46 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h2148bae0d331f5e4($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $24 = i64toi32_i32$1;
  i64toi32_i32$1 = ($2 + 16 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $24;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1 + 24 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 24 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $30;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $33 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $33;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] | 0;
  $36 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  $13 = $36;
  HEAP8[i64toi32_i32$0 >> 0] = $13;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 28 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $41 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 8 | 0;
  $14 = $41;
  HEAP8[i64toi32_i32$1 >> 0] = $14;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $14 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $14 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $14 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 36 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 16 | 0;
  $15 = $46;
  HEAP8[i64toi32_i32$0 >> 0] = $15;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $15 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $15 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $15 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $16 = $0 + 24 | 0;
  $17 = HEAP32[($2 + 44 | 0) >> 2] | 0;
  HEAP8[$16 >> 0] = $17;
  HEAP8[($16 + 1 | 0) >> 0] = $17 >>> 8 | 0;
  HEAP8[($16 + 2 | 0) >> 0] = $17 >>> 16 | 0;
  HEAP8[($16 + 3 | 0) >> 0] = $17 >>> 24 | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 32 | 0, 4 | 0);
  global$0 = $2 + 48 | 0;
 }
 
 function genesishash_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $5 = 0, $13 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $3 = 0, $4 = 0, $25 = 0, $35 = 0, $40 = 0, $57 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h7b8fe8d9d71033fc($2 + 24 | 0 | 0, $1 | 0);
  $3 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 + 16 | 0 | 0, 28 | 0, 0 | 0);
  $4 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $5 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $25 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  $13 = $25;
  HEAP8[i64toi32_i32$0 >> 0] = $13;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $14 = i64toi32_i32$2 + 24 | 0;
  $15 = i64toi32_i32$0 + 24 | 0;
  $16 = HEAPU8[$14 >> 0] | 0 | ((HEAPU8[($14 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($14 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($14 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  HEAP8[$15 >> 0] = $16;
  HEAP8[($15 + 1 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[($15 + 2 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[($15 + 3 | 0) >> 0] = $16 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 16 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $35 = i64toi32_i32$1;
  i64toi32_i32$1 = $5 + 16 | 0;
  $17 = $35;
  HEAP8[i64toi32_i32$1 >> 0] = $17;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $40 = i64toi32_i32$0;
  i64toi32_i32$0 = $5 + 8 | 0;
  $18 = $40;
  HEAP8[i64toi32_i32$0 >> 0] = $18;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $18 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $18 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $18 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[($2 + 40 | 0) >> 2] = 28;
  HEAP32[($2 + 36 | 0) >> 2] = $4;
  HEAP32[($2 + 32 | 0) >> 2] = $5;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $57 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $57;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = i64toi32_i32$2 + 48 | 0;
 }
 
 function auxiliarydatahash_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $5 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $3 = 0, $4 = 0, $25 = 0, $30 = 0, $35 = 0, $40 = 0, $57 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h4fe5a3e1c18388b1($2 + 24 | 0 | 0, $1 | 0);
  $3 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 + 16 | 0 | 0, 32 | 0, 0 | 0);
  $4 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $5 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $25 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  $14 = $25;
  HEAP8[i64toi32_i32$0 >> 0] = $14;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $14 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $14 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $14 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 24 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $30 = i64toi32_i32$1;
  i64toi32_i32$1 = $5 + 24 | 0;
  $15 = $30;
  HEAP8[i64toi32_i32$1 >> 0] = $15;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $15 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $15 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $15 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $35 = i64toi32_i32$0;
  i64toi32_i32$0 = $5 + 16 | 0;
  $16 = $35;
  HEAP8[i64toi32_i32$0 >> 0] = $16;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $16 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $40 = i64toi32_i32$1;
  i64toi32_i32$1 = $5 + 8 | 0;
  $17 = $40;
  HEAP8[i64toi32_i32$1 >> 0] = $17;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[($2 + 40 | 0) >> 2] = 32;
  HEAP32[($2 + 36 | 0) >> 2] = $4;
  HEAP32[($2 + 32 | 0) >> 2] = $5;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $57 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $57;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = i64toi32_i32$2 + 48 | 0;
 }
 
 function poolmetadatahash_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $5 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $3 = 0, $4 = 0, $25 = 0, $30 = 0, $35 = 0, $40 = 0, $57 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h6bd3a1ad9f257a81($2 + 24 | 0 | 0, $1 | 0);
  $3 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 + 16 | 0 | 0, 32 | 0, 0 | 0);
  $4 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $5 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $25 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  $14 = $25;
  HEAP8[i64toi32_i32$0 >> 0] = $14;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $14 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $14 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $14 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 24 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $30 = i64toi32_i32$1;
  i64toi32_i32$1 = $5 + 24 | 0;
  $15 = $30;
  HEAP8[i64toi32_i32$1 >> 0] = $15;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $15 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $15 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $15 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $35 = i64toi32_i32$0;
  i64toi32_i32$0 = $5 + 16 | 0;
  $16 = $35;
  HEAP8[i64toi32_i32$0 >> 0] = $16;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $16 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $40 = i64toi32_i32$1;
  i64toi32_i32$1 = $5 + 8 | 0;
  $17 = $40;
  HEAP8[i64toi32_i32$1 >> 0] = $17;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[($2 + 40 | 0) >> 2] = 32;
  HEAP32[($2 + 36 | 0) >> 2] = $4;
  HEAP32[($2 + 32 | 0) >> 2] = $5;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $57 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $57;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = i64toi32_i32$2 + 48 | 0;
 }
 
 function vrfkeyhash_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $5 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $3 = 0, $4 = 0, $25 = 0, $30 = 0, $35 = 0, $40 = 0, $57 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hb2360c57549df4d5($2 + 24 | 0 | 0, $1 | 0);
  $3 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 + 16 | 0 | 0, 32 | 0, 0 | 0);
  $4 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $5 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $25 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  $14 = $25;
  HEAP8[i64toi32_i32$0 >> 0] = $14;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $14 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $14 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $14 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 24 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $30 = i64toi32_i32$1;
  i64toi32_i32$1 = $5 + 24 | 0;
  $15 = $30;
  HEAP8[i64toi32_i32$1 >> 0] = $15;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $15 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $15 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $15 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $35 = i64toi32_i32$0;
  i64toi32_i32$0 = $5 + 16 | 0;
  $16 = $35;
  HEAP8[i64toi32_i32$0 >> 0] = $16;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $16 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $40 = i64toi32_i32$1;
  i64toi32_i32$1 = $5 + 8 | 0;
  $17 = $40;
  HEAP8[i64toi32_i32$1 >> 0] = $17;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[($2 + 40 | 0) >> 2] = 32;
  HEAP32[($2 + 36 | 0) >> 2] = $4;
  HEAP32[($2 + 32 | 0) >> 2] = $5;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $57 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $57;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = i64toi32_i32$2 + 48 | 0;
 }
 
 function blockhash_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $5 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $3 = 0, $4 = 0, $25 = 0, $30 = 0, $35 = 0, $40 = 0, $57 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h449d6579c00e5aca($2 + 24 | 0 | 0, $1 | 0);
  $3 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 + 16 | 0 | 0, 32 | 0, 0 | 0);
  $4 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $5 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $25 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  $14 = $25;
  HEAP8[i64toi32_i32$0 >> 0] = $14;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $14 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $14 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $14 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 24 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $30 = i64toi32_i32$1;
  i64toi32_i32$1 = $5 + 24 | 0;
  $15 = $30;
  HEAP8[i64toi32_i32$1 >> 0] = $15;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $15 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $15 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $15 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $35 = i64toi32_i32$0;
  i64toi32_i32$0 = $5 + 16 | 0;
  $16 = $35;
  HEAP8[i64toi32_i32$0 >> 0] = $16;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $16 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $40 = i64toi32_i32$1;
  i64toi32_i32$1 = $5 + 8 | 0;
  $17 = $40;
  HEAP8[i64toi32_i32$1 >> 0] = $17;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[($2 + 40 | 0) >> 2] = 32;
  HEAP32[($2 + 36 | 0) >> 2] = $4;
  HEAP32[($2 + 32 | 0) >> 2] = $5;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $57 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $57;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = i64toi32_i32$2 + 48 | 0;
 }
 
 function datahash_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $5 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $3 = 0, $4 = 0, $25 = 0, $30 = 0, $35 = 0, $40 = 0, $57 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hf03f8ea4201fce5b($2 + 24 | 0 | 0, $1 | 0);
  $3 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 + 16 | 0 | 0, 32 | 0, 0 | 0);
  $4 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $5 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $25 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  $14 = $25;
  HEAP8[i64toi32_i32$0 >> 0] = $14;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $14 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $14 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $14 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 24 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $30 = i64toi32_i32$1;
  i64toi32_i32$1 = $5 + 24 | 0;
  $15 = $30;
  HEAP8[i64toi32_i32$1 >> 0] = $15;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $15 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $15 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $15 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $35 = i64toi32_i32$0;
  i64toi32_i32$0 = $5 + 16 | 0;
  $16 = $35;
  HEAP8[i64toi32_i32$0 >> 0] = $16;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $16 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $40 = i64toi32_i32$1;
  i64toi32_i32$1 = $5 + 8 | 0;
  $17 = $40;
  HEAP8[i64toi32_i32$1 >> 0] = $17;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[($2 + 40 | 0) >> 2] = 32;
  HEAP32[($2 + 36 | 0) >> 2] = $4;
  HEAP32[($2 + 32 | 0) >> 2] = $5;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $57 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $57;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = i64toi32_i32$2 + 48 | 0;
 }
 
 function scriptdatahash_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $5 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $3 = 0, $4 = 0, $25 = 0, $30 = 0, $35 = 0, $40 = 0, $57 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h6b7eaec1bcfb1ff8($2 + 24 | 0 | 0, $1 | 0);
  $3 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 + 16 | 0 | 0, 32 | 0, 0 | 0);
  $4 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $5 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $25 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  $14 = $25;
  HEAP8[i64toi32_i32$0 >> 0] = $14;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $14 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $14 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $14 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 24 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $30 = i64toi32_i32$1;
  i64toi32_i32$1 = $5 + 24 | 0;
  $15 = $30;
  HEAP8[i64toi32_i32$1 >> 0] = $15;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $15 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $15 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $15 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $35 = i64toi32_i32$0;
  i64toi32_i32$0 = $5 + 16 | 0;
  $16 = $35;
  HEAP8[i64toi32_i32$0 >> 0] = $16;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $16 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $40 = i64toi32_i32$1;
  i64toi32_i32$1 = $5 + 8 | 0;
  $17 = $40;
  HEAP8[i64toi32_i32$1 >> 0] = $17;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[($2 + 40 | 0) >> 2] = 32;
  HEAP32[($2 + 36 | 0) >> 2] = $4;
  HEAP32[($2 + 32 | 0) >> 2] = $5;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $57 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $57;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = i64toi32_i32$2 + 48 | 0;
 }
 
 function vrfvkey_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $5 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $3 = 0, $4 = 0, $25 = 0, $30 = 0, $35 = 0, $40 = 0, $57 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h358f17571789b373($2 + 24 | 0 | 0, $1 | 0);
  $3 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 + 16 | 0 | 0, 32 | 0, 0 | 0);
  $4 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $5 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $25 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  $14 = $25;
  HEAP8[i64toi32_i32$0 >> 0] = $14;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $14 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $14 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $14 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 24 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $30 = i64toi32_i32$1;
  i64toi32_i32$1 = $5 + 24 | 0;
  $15 = $30;
  HEAP8[i64toi32_i32$1 >> 0] = $15;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $15 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $15 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $15 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $35 = i64toi32_i32$0;
  i64toi32_i32$0 = $5 + 16 | 0;
  $16 = $35;
  HEAP8[i64toi32_i32$0 >> 0] = $16;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $16 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $40 = i64toi32_i32$1;
  i64toi32_i32$1 = $5 + 8 | 0;
  $17 = $40;
  HEAP8[i64toi32_i32$1 >> 0] = $17;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[($2 + 40 | 0) >> 2] = 32;
  HEAP32[($2 + 36 | 0) >> 2] = $4;
  HEAP32[($2 + 32 | 0) >> 2] = $5;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $57 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $57;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = i64toi32_i32$2 + 48 | 0;
 }
 
 function kesvkey_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $5 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $3 = 0, $4 = 0, $25 = 0, $30 = 0, $35 = 0, $40 = 0, $57 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h78f278b481f170f8($2 + 24 | 0 | 0, $1 | 0);
  $3 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 + 16 | 0 | 0, 32 | 0, 0 | 0);
  $4 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $5 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $25 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  $14 = $25;
  HEAP8[i64toi32_i32$0 >> 0] = $14;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $14 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $14 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $14 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 24 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $30 = i64toi32_i32$1;
  i64toi32_i32$1 = $5 + 24 | 0;
  $15 = $30;
  HEAP8[i64toi32_i32$1 >> 0] = $15;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $15 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $15 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $15 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $35 = i64toi32_i32$0;
  i64toi32_i32$0 = $5 + 16 | 0;
  $16 = $35;
  HEAP8[i64toi32_i32$0 >> 0] = $16;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $16 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $40 = i64toi32_i32$1;
  i64toi32_i32$1 = $5 + 8 | 0;
  $17 = $40;
  HEAP8[i64toi32_i32$1 >> 0] = $17;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[($2 + 40 | 0) >> 2] = 32;
  HEAP32[($2 + 36 | 0) >> 2] = $4;
  HEAP32[($2 + 32 | 0) >> 2] = $5;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $57 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $57;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = i64toi32_i32$2 + 48 | 0;
 }
 
 function cardano_serialization_lib__tx_builder__TransactionBuilder__cip2_largest_first_by___7b_7bclosure_7d_7d__hb6689e866bcf147a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, $4 = 0, $47 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   $3 = HEAP32[(HEAP32[($0 + 4 | 0) >> 2] | 0) >> 2] | 0;
   $4 = HEAP32[($3 + 8 | 0) >> 2] | 0;
   $1 = HEAP32[$1 >> 2] | 0;
   if ($4 >>> 0 <= $1 >>> 0) {
    break label$1
   }
   label$2 : {
    label$3 : {
     $1 = (HEAP32[$3 >> 2] | 0) + Math_imul($1, 168) | 0;
     if ((HEAP32[($1 + 72 | 0) >> 2] | 0 | 0) != (1 | 0)) {
      break label$3
     }
     $0 = HEAP32[$0 >> 2] | 0;
     cardano_serialization_lib__MultiAsset__get__had0c36a2c855d776($2 + 16 | 0 | 0, $1 + 76 | 0 | 0, HEAP32[(HEAP32[$0 >> 2] | 0) >> 2] | 0 | 0);
     if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
      break label$3
     }
     HEAP32[($2 + 8 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
     $47 = i64toi32_i32$0;
     i64toi32_i32$0 = $2;
     HEAP32[$2 >> 2] = $47;
     HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$1;
     $0 = alloc__collections__btree__map__BTreeMap_K_2cV___get__h825f34112f7eacbf($2 | 0, HEAP32[(HEAP32[($0 + 4 | 0) >> 2] | 0) >> 2] | 0 | 0) | 0;
     if ($0) {
      break label$2
     }
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h6c9f94f0f82ce2b5($2 | 0);
    }
    core__option__expect_failed__h66afff61e82fdd86(1069476 | 0, 14 | 0, 1069492 | 0);
    abort();
   }
   i64toi32_i32$1 = HEAP32[$0 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h6c9f94f0f82ce2b5($2 | 0);
   global$0 = $2 + 32 | 0;
   i64toi32_i32$HIGH_BITS = i64toi32_i32$0;
   return i64toi32_i32$1 | 0;
  }
  core__panicking__panic_bounds_check__h808b524af17640b1($1 | 0, $4 | 0, 1069460 | 0);
  abort();
 }
 
 function plutuslist_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $30 = 0, $52 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $30;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__plutus__PlutusList__from_bytes__h898b7487448006c2($2 + 8 | 0 | 0, $2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  HEAP32[($2 + 60 | 0) >> 2] = HEAP32[($2 + 24 | 0) >> 2] | 0;
  HEAP32[($2 + 48 | 0) >> 2] = $1;
  i64toi32_i32$2 = ($2 + 8 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $52 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 52 | 0) >> 2] = $52;
  HEAP32[($2 + 56 | 0) >> 2] = i64toi32_i32$0;
  $1 = $cardano_serialization_lib__plutus__PlutusList_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h9a3fe5bcf5e2cc3a($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__chain_crypto__algorithms__legacy_daedalus__LegacyDaedalus_20as_20cardano_serialization_lib__chain_crypto__key__AsymmetricKey___compute_public__h784e6c837b0c7a87($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0;
  $2 = global$0 - 256 | 0;
  global$0 = $2;
  $2 = memset($2 | 0, 0 | 0, 64 | 0) | 0;
  core__slice___impl_20_5bT_5d___clone_from_slice__h1742dfbd5d5d9efd($2 | 0, 64 | 0, $1 | 0, 64 | 0);
  cryptoxide__ed25519__extended_to_public__hb7e9895dfbf0ff6d($2 + 64 | 0 | 0, $2 | 0);
  i64toi32_i32$1 = $2 + 120 | 0;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$1 = $2 + 112 | 0;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$1 = $2 + 104 | 0;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 96 | 0) >> 2] = 0;
  HEAP32[($2 + 100 | 0) >> 2] = i64toi32_i32$0;
  core__slice___impl_20_5bT_5d___clone_from_slice__h1742dfbd5d5d9efd($2 + 96 | 0 | 0, 32 | 0, $1 + 64 | 0 | 0, 32 | 0);
  memset($2 + 128 | 0 | 0, 0 | 0, 64 | 0) | 0;
  core__slice___impl_20_5bT_5d___clone_from_slice__h1742dfbd5d5d9efd($2 + 128 | 0 | 0, 32 | 0, $2 + 64 | 0 | 0, 32 | 0);
  core__slice___impl_20_5bT_5d___clone_from_slice__h1742dfbd5d5d9efd(($2 + 128 | 0) + 32 | 0 | 0, 32 | 0, $2 + 96 | 0 | 0, 32 | 0);
  memcpy($2 + 192 | 0 | 0, $2 + 128 | 0 | 0, 64 | 0) | 0;
  ed25519_bip32__key__XPub__from_bytes__hd8f9fabe30c0d335($0 | 0, $2 + 192 | 0 | 0);
  global$0 = $2 + 256 | 0;
 }
 
 function alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__h805192557e263194($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $6 = 0, $5 = 0;
  $4 = global$0 - 32 | 0;
  global$0 = $4;
  HEAP32[($4 + 28 | 0) >> 2] = $2;
  HEAP32[($4 + 24 | 0) >> 2] = $1;
  $5 = 0;
  alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__h8108469f5dd39d01($4 + 16 | 0 | 0, $4 + 24 | 0 | 0, $3 | 0, 0 | 0);
  $6 = HEAP32[($4 + 20 | 0) >> 2] | 0;
  label$1 : {
   if (!(HEAP32[($4 + 16 | 0) >> 2] | 0)) {
    break label$1
   }
   label$2 : while (1) {
    label$3 : {
     if ($1) {
      break label$3
     }
     $5 = 1;
     $1 = 0;
     break label$1;
    }
    $2 = HEAP32[(($2 + ($6 << 2 | 0) | 0) + 408 | 0) >> 2] | 0;
    HEAP32[($4 + 28 | 0) >> 2] = $2;
    $1 = $1 + -1 | 0;
    HEAP32[($4 + 24 | 0) >> 2] = $1;
    alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__h8108469f5dd39d01($4 + 8 | 0 | 0, $4 + 24 | 0 | 0, $3 | 0, 0 | 0);
    $6 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    if (HEAP32[($4 + 8 | 0) >> 2] | 0) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[$0 >> 2] = $5;
  HEAP32[($0 + 12 | 0) >> 2] = $6;
  HEAP32[($0 + 8 | 0) >> 2] = $2;
  global$0 = $4 + 32 | 0;
 }
 
 function cryptoxide__poly1305__Poly1305__new__haf9648a01e3507f3($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $6 = 0, $49 = 0;
  label$1 : {
   if (($2 | 0) != (32 | 0)) {
    break label$1
   }
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[($0 + 20 | 0) >> 2] = 0;
   HEAP32[($0 + 24 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[($0 + 56 | 0) >> 2] = 0;
   HEAP32[($0 + 60 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($0 + 36 | 0) >> 2] = 0;
   i64toi32_i32$1 = $0 + 28 | 0;
   i64toi32_i32$0 = 0;
   HEAP32[i64toi32_i32$1 >> 2] = 0;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$1 = $0 + 64 | 0;
   i64toi32_i32$0 = 0;
   HEAP32[i64toi32_i32$1 >> 2] = 0;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$1 = $0 + 69 | 0;
   i64toi32_i32$0 = 0;
   $6 = 0;
   HEAP8[i64toi32_i32$1 >> 0] = $6;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $6 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $6 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $6 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   HEAP32[$0 >> 2] = (HEAPU8[$1 >> 0] | 0 | ((HEAPU8[($1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) & 67108863 | 0;
   HEAP32[($0 + 4 | 0) >> 2] = ((HEAPU8[($1 + 3 | 0) >> 0] | 0 | ((HEAPU8[($1 + 4 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 5 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 6 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) >>> 2 | 0) & 67108611 | 0;
   HEAP32[($0 + 8 | 0) >> 2] = ((HEAPU8[($1 + 6 | 0) >> 0] | 0 | ((HEAPU8[($1 + 7 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 8 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 9 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) >>> 4 | 0) & 67092735 | 0;
   HEAP32[($0 + 12 | 0) >> 2] = ((HEAPU8[($1 + 9 | 0) >> 0] | 0 | ((HEAPU8[($1 + 10 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 11 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 12 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) >>> 6 | 0) & 66076671 | 0;
   HEAP32[($0 + 16 | 0) >> 2] = ((HEAPU8[($1 + 12 | 0) >> 0] | 0 | ((HEAPU8[($1 + 13 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 14 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 15 | 0) >> 0] | 0) << 24 | 0) | 0) | 0) >>> 8 | 0) & 1048575 | 0;
   HEAP32[($0 + 40 | 0) >> 2] = HEAPU8[($1 + 16 | 0) >> 0] | 0 | ((HEAPU8[($1 + 17 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 18 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 19 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP32[($0 + 44 | 0) >> 2] = HEAPU8[($1 + 20 | 0) >> 0] | 0 | ((HEAPU8[($1 + 21 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 22 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 23 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[($1 + 24 | 0) >> 0] | 0 | ((HEAPU8[($1 + 25 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 26 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 27 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[($1 + 28 | 0) >> 0] | 0 | ((HEAPU8[($1 + 29 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 30 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 31 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $49 = i64toi32_i32$0;
   i64toi32_i32$0 = $0 + 48 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $49;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1137432 | 0, 33 | 0, 1137564 | 0);
  abort();
 }
 
 function $core__num__error__ParseIntError_20as_20core__fmt__Debug___fmt__h5fe67e0978fadfb5($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, i64toi32_i32$2 = 0, $14$hi = 0, $16$hi = 0, $17 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  i64toi32_i32$4 = FUNCTION_TABLE[HEAP32[((HEAP32[($1 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($1 + 24 | 0) >> 2] | 0, 1153164, 13) | 0;
  i64toi32_i32$3 = i64toi32_i32$4 ? 0 : 0;
  i64toi32_i32$2 = i64toi32_i32$4 ? 1 : 0;
  $14$hi = i64toi32_i32$2;
  i64toi32_i32$2 = 0;
  $16$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $14$hi;
  i64toi32_i32$4 = i64toi32_i32$3;
  i64toi32_i32$3 = $16$hi;
  i64toi32_i32$3 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  $17 = i64toi32_i32$4 | $1 | 0;
  i64toi32_i32$4 = $2;
  HEAP32[$2 >> 2] = $17;
  HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$3;
  HEAP32[($2 + 12 | 0) >> 2] = $0;
  core__fmt__builders__DebugStruct__field__hec833bfe02704935($2 | 0, 1153118 | 0, 4 | 0, $2 + 12 | 0 | 0, 1153180 | 0) | 0;
  $1 = HEAPU8[($2 + 4 | 0) >> 0] | 0;
  label$1 : {
   if (!(HEAPU8[($2 + 5 | 0) >> 0] | 0)) {
    break label$1
   }
   $0 = $1 & 255 | 0;
   $1 = 1;
   if ($0) {
    break label$1
   }
   label$2 : {
    $1 = HEAP32[$2 >> 2] | 0;
    if ((HEAPU8[$1 >> 0] | 0) & 4 | 0) {
     break label$2
    }
    $1 = FUNCTION_TABLE[HEAP32[((HEAP32[($1 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($1 + 24 | 0) >> 2] | 0, 1149891, 2) | 0;
    break label$1;
   }
   $1 = FUNCTION_TABLE[HEAP32[((HEAP32[($1 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($1 + 24 | 0) >> 2] | 0, 1149877, 1) | 0;
  }
  global$0 = $2 + 16 | 0;
  return ($1 & 255 | 0 | 0) != (0 | 0) | 0;
 }
 
 function alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__hb21438687147b7bc($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $5 = 0, $6 = 0, $7 = 0;
  $4 = global$0 - 16 | 0;
  global$0 = $4;
  $1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = $1 + 4 | 0;
  $6 = HEAPU16[($1 + 50 | 0) >> 1] | 0;
  core__iter__adapters__enumerate__Enumerate_I___new__hc289053b3fd6bbd7($4 | 0, $5 + ($3 << 2 | 0) | 0 | 0, $5 + ($6 << 2 | 0) | 0 | 0);
  $1 = ((HEAP32[($4 + 8 | 0) >> 2] | 0) + $3 | 0) + -1 | 0;
  $7 = HEAP32[($4 + 4 | 0) >> 2] | 0;
  $3 = HEAP32[$4 >> 2] | 0;
  $5 = HEAP32[$2 >> 2] | 0;
  label$1 : {
   label$2 : {
    label$3 : while (1) {
     label$4 : {
      if (($7 | 0) != ($3 | 0)) {
       break label$4
      }
      $1 = $6;
      break label$2;
     }
     $2 = HEAP32[$3 >> 2] | 0;
     $1 = $1 + 1 | 0;
     $3 = $3 + 4 | 0;
     $2 = $5 >>> 0 < $2 >>> 0 ? -1 : ($5 | 0) != ($2 | 0);
     if (($2 | 0) == (1 | 0)) {
      continue label$3
     }
     break label$3;
    };
    switch ($2 + 1 | 0 | 0) {
    case 1:
     break label$1;
    default:
     break label$2;
    };
   }
   $2 = 1;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[$0 >> 2] = $2;
  global$0 = $4 + 16 | 0;
 }
 
 function poolmetadata_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 128 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 64 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 80 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 68 | 0) >> 2] | 0;
  HEAP32[($2 + 80 | 0) >> 2] = HEAP32[($2 + 64 | 0) >> 2] | 0;
  HEAP32[($2 + 84 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__PoolMetadata__from_bytes__hd10a01972756859e($2 + 16 | 0 | 0, $2 + 80 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  HEAP32[($2 + 80 | 0) >> 2] = $1;
  memcpy($2 + 80 | 0 | 4 | 0 | 0, ($2 + 16 | 0) + 8 | 0 | 0, 40 | 0) | 0;
  $1 = $cardano_serialization_lib__PoolMetadata_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h92fec53606437ead($2 + 80 | 0 | 0) | 0;
  global$0 = $2 + 128 | 0;
  return $1 | 0;
 }
 
 function transactionwitnessset_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 192 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 96 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 112 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 96 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 100 | 0) >> 2] | 0;
  HEAP32[($2 + 112 | 0) >> 2] = HEAP32[($2 + 96 | 0) >> 2] | 0;
  HEAP32[($2 + 116 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__TransactionWitnessSet__from_bytes__hd4b3c7c29ab9e1f0($2 + 16 | 0 | 0, $2 + 112 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  HEAP32[($2 + 112 | 0) >> 2] = $1;
  memcpy($2 + 112 | 0 | 4 | 0 | 0, ($2 + 16 | 0) + 8 | 0 | 0, 72 | 0) | 0;
  $1 = $cardano_serialization_lib__TransactionWitnessSet_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h15af3a22f8db3dff($2 + 112 | 0 | 0) | 0;
  global$0 = $2 + 192 | 0;
  return $1 | 0;
 }
 
 function bignum_checked_mul($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, $3 = 0, $5 = 0, $5$hi = 0, $25 = 0, $25$hi = 0, $28 = 0, $28$hi = 0, $4 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($2 + 24 | 0 | 0, $0 | 0);
    if (!$1) {
     break label$2
    }
    $0 = HEAP32[($2 + 28 | 0) >> 2] | 0;
    $3 = HEAP32[($2 + 24 | 0) >> 2] | 0;
    wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($2 + 16 | 0 | 0, $1 | 0);
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $25 = i64toi32_i32$0;
    $25$hi = i64toi32_i32$1;
    i64toi32_i32$2 = HEAP32[($2 + 16 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $28 = i64toi32_i32$1;
    $28$hi = i64toi32_i32$0;
    i64toi32_i32$0 = $25$hi;
    i64toi32_i32$1 = 0;
    i64toi32_i32$2 = $28$hi;
    i64toi32_i32$3 = 0;
    __multi3($2 | 0, $25 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$1 | 0, $28 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$3 | 0);
    i64toi32_i32$1 = $2;
    i64toi32_i32$3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $5 = i64toi32_i32$3;
    $5$hi = i64toi32_i32$2;
    i64toi32_i32$1 = i64toi32_i32$3;
    i64toi32_i32$3 = 0;
    i64toi32_i32$0 = 0;
    $3 = (i64toi32_i32$1 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | 0;
    $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
    label$3 : {
     label$4 : {
      i64toi32_i32$1 = i64toi32_i32$2;
      i64toi32_i32$1 = i64toi32_i32$2;
      if (!($5 | i64toi32_i32$2 | 0)) {
       break label$4
      }
      $4 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1058732 | 0, 8 | 0) | 0;
      break label$3;
     }
     i64toi32_i32$0 = $2;
     i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
     i64toi32_i32$2 = HEAP32[($2 + 4 | 0) >> 2] | 0;
     $5 = i64toi32_i32$1;
     $5$hi = i64toi32_i32$2;
    }
    core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    if ($3) {
     break label$1
    }
    i64toi32_i32$2 = $5$hi;
    $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810($5 | 0, i64toi32_i32$2 | 0) | 0;
    global$0 = $2 + 32 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472($4 | 0);
  abort();
 }
 
 function make_vkey_witness($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $4 = 0, $3 = 0;
  $2 = global$0 - 208 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h8308bd69a8eeb68f($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h09a25d0fa720925e($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $4 = HEAP32[$2 >> 2] | 0;
   cardano_serialization_lib__crypto__PrivateKey__sign__habe0df84ae280136($2 + 112 | 0 | 0, $4 | 0, $3 | 0, 32 | 0);
   cardano_serialization_lib__impl_mockchain__key__EitherEd25519SecretKey__to_public__hd7cd5c1f2cabbdb8($2 + 16 | 0 | 0, $4 | 0);
   memcpy(($2 + 16 | 0) + 32 | 0 | 0, $2 + 112 | 0 | 0, 64 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   memcpy($2 + 112 | 0 | 0, $2 + 16 | 0 | 0, 96 | 0) | 0;
   $0 = $cardano_serialization_lib__crypto__Vkeywitness_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hffa43ed1c5f00e23($2 + 112 | 0 | 0) | 0;
   global$0 = $2 + 208 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function metadatamap_get_i32($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $12 = 0, $3 = 0, $17 = 0, $4 = 0, $4$hi = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h74f2437fd791f127($2 | 0, $0 | 0);
    $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
    $3 = HEAP32[$2 >> 2] | 0;
    $17 = $2 + 80 | 0;
    i64toi32_i32$1 = $1;
    i64toi32_i32$0 = i64toi32_i32$1 >> 31 | 0;
    $4 = i64toi32_i32$1;
    $4$hi = i64toi32_i32$0;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    i64toi32_i32$3 = 63;
    i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$1 = i64toi32_i32$0 >> 31 | 0;
     $12 = i64toi32_i32$0 >> i64toi32_i32$4 | 0;
    } else {
     i64toi32_i32$1 = i64toi32_i32$0 >> i64toi32_i32$4 | 0;
     $12 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
    }
    i64toi32_i32$2 = $17;
    HEAP32[i64toi32_i32$2 >> 2] = $12;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $4$hi;
    i64toi32_i32$2 = ($2 + 64 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $4;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($2 + 64 | 0) >> 2] = 2;
    cardano_serialization_lib__metadata__MetadataMap__get__hfdac1fad098610ea($2 + 8 | 0 | 0, $3 | 0, $2 + 64 | 0 | 0);
    core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatum___headd2d1b596252cc($2 + 64 | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    memcpy($2 + 64 | 0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 48 | 0) | 0;
    $0 = $cardano_serialization_lib__metadata__TransactionMetadatum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hce2feba55b67d086($2 + 64 | 0 | 0) | 0;
    global$0 = $2 + 112 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  abort();
 }
 
 function cardano_serialization_lib__tx_builder__TransactionBuilder__build_tx__h70ea5d3a852f88d4($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $3 = 0, $2 = 0, $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0;
  label$1 : {
   label$2 : {
    $2 = HEAP32[($1 + 128 | 0) >> 2] | 0;
    if ($2) {
     break label$2
    }
    $3 = 0;
    break label$1;
   }
   $3 = HEAP32[($2 + 156 | 0) >> 2] | 0;
  }
  label$3 : {
   label$4 : {
    label$5 : {
     label$6 : {
      if (($3 | 0) == ($2 | 0)) {
       break label$6
      }
      $4 = 0;
      label$7 : while (1) {
       i64toi32_i32$0 = HEAP32[$3 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($3 + 4 | 0) >> 2] | 0;
       i64toi32_i32$2 = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       $4 = $4 + ((i64toi32_i32$2 | 0) == (2 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) | 0;
       $3 = HEAP32[($3 + 156 | 0) >> 2] | 0;
       if (($3 | 0) != ($2 | 0)) {
        continue label$7
       }
       break label$7;
      };
      if ($4) {
       break label$5
      }
     }
     if (cardano_serialization_lib__tx_builder__TransactionBuilder__has_plutus_inputs__h1b9c6897141f0331($1 | 0) | 0) {
      break label$4
     }
     break label$3;
    }
    $3 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1065676 | 0, 98 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    HEAP32[($0 + 4 | 0) >> 2] = $3;
    return;
   }
   label$8 : {
    if (!(HEAPU8[($1 + 480 | 0) >> 0] | 0)) {
     break label$8
    }
    if (HEAP32[($1 + 248 | 0) >> 2] | 0) {
     break label$3
    }
    $3 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1065838 | 0, 61 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    HEAP32[($0 + 4 | 0) >> 2] = $3;
    return;
   }
   $3 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1065774 | 0, 64 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
   HEAP32[($0 + 4 | 0) >> 2] = $3;
   return;
  }
  cardano_serialization_lib__tx_builder__TransactionBuilder__build_tx_unsafe__hd84bd9af0364abde($0 | 0, $1 | 0);
 }
 
 function bip32privatekey_from_bip39_entropy($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0;
  $4 = global$0 - 224 | 0;
  global$0 = $4;
  HEAP32[($4 + 136 | 0) >> 2] = $1;
  HEAP32[($4 + 132 | 0) >> 2] = $1;
  HEAP32[($4 + 128 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($4 + 8 | 0 | 0, $4 + 128 | 0 | 0);
  $1 = HEAP32[($4 + 12 | 0) >> 2] | 0;
  HEAP32[($4 + 116 | 0) >> 2] = $1;
  $0 = HEAP32[($4 + 8 | 0) >> 2] | 0;
  HEAP32[($4 + 112 | 0) >> 2] = $0;
  HEAP32[($4 + 136 | 0) >> 2] = $3;
  HEAP32[($4 + 132 | 0) >> 2] = $3;
  HEAP32[($4 + 128 | 0) >> 2] = $2;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($4 | 0, $4 + 128 | 0 | 0);
  $3 = HEAP32[($4 + 4 | 0) >> 2] | 0;
  HEAP32[($4 + 124 | 0) >> 2] = $3;
  $2 = HEAP32[$4 >> 2] | 0;
  HEAP32[($4 + 120 | 0) >> 2] = $2;
  cardano_serialization_lib__chain_crypto__derive__from_bip39_entropy__hf32cb3895f4a2aa4($4 + 16 | 0 | 0, $0 | 0, $1 | 0, $2 | 0, $3 | 0);
  core__ptr__drop_in_place_alloc__boxed__Box__5bu8_5d____h1049615268b5f7c4($4 + 120 | 0 | 0);
  core__ptr__drop_in_place_alloc__boxed__Box__5bu8_5d____h1049615268b5f7c4($4 + 112 | 0 | 0);
  memcpy($4 + 128 | 0 | 0, $4 + 16 | 0 | 0, 96 | 0) | 0;
  $3 = $cardano_serialization_lib__crypto__Bip32PrivateKey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h3aa14ad8597a0206($4 + 128 | 0 | 0) | 0;
  global$0 = $4 + 224 | 0;
  return $3 | 0;
 }
 
 function byronaddress_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 144 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 72 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 88 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 72 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 76 | 0) >> 2] | 0;
  HEAP32[($2 + 88 | 0) >> 2] = HEAP32[($2 + 72 | 0) >> 2] | 0;
  HEAP32[($2 + 92 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__address__ByronAddress__from_bytes__h9704f398e56b45f1($2 + 16 | 0 | 0, $2 + 88 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  HEAP32[($2 + 88 | 0) >> 2] = $1;
  memcpy($2 + 88 | 0 | 4 | 0 | 0, ($2 + 16 | 0) + 8 | 0 | 0, 48 | 0) | 0;
  $1 = $cardano_serialization_lib__address__ByronAddress_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbc0eb32d6a95f2a3($2 + 88 | 0 | 0) | 0;
  global$0 = $2 + 144 | 0;
  return $1 | 0;
 }
 
 function serde_json__de__Deserializer_R___parse_object_colon__h753bf1256f280e80($0) {
  $0 = $0 | 0;
  var $2 = 0, $1 = 0, $3 = 0, $5 = 0, $6 = 0, $7 = 0, $4 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $2 = HEAP32[($0 + 8 | 0) >> 2] | 0;
      $3 = HEAP32[($0 + 4 | 0) >> 2] | 0;
      if ($2 >>> 0 >= $3 >>> 0) {
       break label$4
      }
      $4 = HEAP32[$0 >> 2] | 0;
      $5 = 1;
      label$5 : {
       label$6 : while (1) {
        $6 = HEAPU8[($4 + $2 | 0) >> 0] | 0;
        $7 = $6 + -9 | 0;
        if ($7 >>> 0 > 23 >>> 0) {
         break label$5
        }
        if (!((1 << $7 | 0) & 8388627 | 0)) {
         break label$5
        }
        $2 = $2 + 1 | 0;
        HEAP32[($0 + 8 | 0) >> 2] = $2;
        $5 = $2 >>> 0 < $3 >>> 0;
        if (($3 | 0) != ($2 | 0)) {
         continue label$6
        }
        break label$4;
       };
      }
      if ($5 & 1 | 0) {
       break label$3
      }
     }
     HEAP32[$1 >> 2] = 3;
     break label$2;
    }
    label$7 : {
     if (($6 | 0) != (58 | 0)) {
      break label$7
     }
     HEAP32[($0 + 8 | 0) >> 2] = $2 + 1 | 0;
     $2 = 0;
     break label$1;
    }
    HEAP32[$1 >> 2] = 6;
   }
   $2 = serde_json__de__Deserializer_R___peek_error__hf8794e102c1db2df($0 | 0, $1 | 0) | 0;
  }
  global$0 = $1 + 16 | 0;
  return $2 | 0;
 }
 
 function cryptoxide__hmac__expand_key__hfd815745270a99ae($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $5 = 0;
  $4 = global$0 - 32 | 0;
  global$0 = $4;
  $5 = $cryptoxide__sha2__Sha512_20as_20cryptoxide__digest__Digest___block_size__hdb82b30d40298b84($1 | 0) | 0;
  core__iter__adapters__take__Take_I___new__h57f06669aa0e5753($4 + 24 | 0 | 0, 0 | 0, $5 | 0);
  $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter__SpecFromIter_T_2cI____from_iter__hd9e424f0851c7545($0 | 0, HEAP32[($4 + 24 | 0) >> 2] | 0 | 0, HEAPU8[($4 + 28 | 0) >> 0] | 0 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ($5 >>> 0 >= $3 >>> 0) {
       break label$4
      }
      $5 = $cryptoxide__sha2__Sha512_20as_20cryptoxide__digest__Digest___output_bits__h3225a21b01e3cca9($1 | 0) | 0;
      $cryptoxide__sha2__Sha512_20as_20cryptoxide__digest__Digest___input__h63322ce5a02a233a($1 | 0, $2 | 0, $3 | 0);
      $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__DerefMut___deref_mut__h1882e042320a120c($4 + 8 | 0 | 0, $0 | 0);
      $0 = HEAP32[($4 + 12 | 0) >> 2] | 0;
      $3 = ($5 + 7 | 0) >>> 3 | 0;
      if ($0 >>> 0 < $3 >>> 0) {
       break label$2
      }
      $cryptoxide__sha2__Sha512_20as_20cryptoxide__digest__Digest___result__h84e92e596fb82544($1 | 0, HEAP32[($4 + 8 | 0) >> 2] | 0 | 0, $3 | 0);
      $cryptoxide__sha2__Sha512_20as_20cryptoxide__digest__Digest___reset__h100e33024dbb0407($1 | 0);
      break label$3;
     }
     $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__DerefMut___deref_mut__h1882e042320a120c($4 + 16 | 0 | 0, $0 | 0);
     $1 = HEAP32[($4 + 20 | 0) >> 2] | 0;
     if ($1 >>> 0 < $3 >>> 0) {
      break label$1
     }
     core__slice___impl_20_5bT_5d___copy_from_slice__h0f69c19ed1852955(HEAP32[($4 + 16 | 0) >> 2] | 0 | 0, $3 | 0, $2 | 0, $3 | 0);
    }
    global$0 = $4 + 32 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($3 | 0, $0 | 0, 1101700 | 0);
   abort();
  }
  core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($3 | 0, $1 | 0, 1101684 | 0);
  abort();
 }
 
 function core__unicode__unicode_data__conversions__to_lower__ha1d2dd3b09e52a1a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, i64toi32_i32$0 = 0, $4 = 0, i64toi32_i32$1 = 0, $5 = 0, i64toi32_i32$2 = 0, $53 = 0;
  label$1 : {
   label$2 : {
    if ($1 >>> 0 < 128 >>> 0) {
     break label$2
    }
    $2 = 0;
    $3 = 1393;
    $4 = 1393;
    label$3 : while (1) {
     label$4 : {
      label$5 : {
       $3 = ($3 >>> 1 | 0) + $2 | 0;
       $5 = HEAP32[(($3 << 4 | 0) + 1155436 | 0) >> 2] | 0;
       if ($5 >>> 0 < $1 >>> 0) {
        break label$5
       }
       if (($5 | 0) == ($1 | 0)) {
        break label$1
       }
       $4 = $3;
       break label$4;
      }
      $2 = $3 + 1 | 0;
     }
     $3 = $4 - $2 | 0;
     if ($4 >>> 0 > $2 >>> 0) {
      continue label$3
     }
     break label$3;
    };
    i64toi32_i32$1 = $0;
    i64toi32_i32$0 = 0;
    HEAP32[($0 + 4 | 0) >> 2] = 0;
    HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[$0 >> 2] = $1;
    return;
   }
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[($0 + 4 | 0) >> 2] = 0;
   HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[$0 >> 2] = ((($1 + -65 | 0) & 255 | 0) >>> 0 < 26 >>> 0) << 5 | 0 | $1 | 0;
   return;
  }
  $2 = $3 << 4 | 0;
  HEAP32[($0 + 8 | 0) >> 2] = HEAP32[($2 + 1155448 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2 + 1155440 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $53 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[$0 >> 2] = $53;
  HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$1;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__Ipv4___deserialize__he9338b7b9f2de34e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, $3 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___bytes__hc697ccccfa39fd82($2 + 64 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 64 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[($2 + 76 | 0) >> 2] | 0;
    HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] = $1;
    HEAP32[($2 + 8 | 0) >> 2] = $1;
    i64toi32_i32$1 = HEAP32[($2 + 72 | 0) >> 2] | 0;
    $3 = HEAP32[($2 + 68 | 0) >> 2] | 0;
    HEAP32[($2 + 16 | 0) >> 2] = $3;
    HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[$2 >> 2] = $3;
    HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$1;
    cardano_serialization_lib__Ipv4__new_impl__h0051960675f6052f($0 | 0, $2 | 0);
    break label$1;
   }
   memcpy($2 + 71 | 0 | 0, memcpy($2 + 16 | 0 | 4 | 0 | 0, ($2 + 64 | 0) + 8 | 0 | 0, 40 | 0) | 0 | 0, 40 | 0) | 0;
   HEAP8[($0 + 8 | 0) >> 0] = 2;
   HEAP32[($0 + 56 | 0) >> 2] = 0;
   memcpy($0 + 9 | 0 | 0, $2 + 64 | 0 | 0, 47 | 0) | 0;
   HEAP8[$0 >> 0] = 1;
  }
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__Ipv6___deserialize__hca2aa2a334ab12c8($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, $3 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___bytes__hc697ccccfa39fd82($2 + 64 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 64 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[($2 + 76 | 0) >> 2] | 0;
    HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] = $1;
    HEAP32[($2 + 8 | 0) >> 2] = $1;
    i64toi32_i32$1 = HEAP32[($2 + 72 | 0) >> 2] | 0;
    $3 = HEAP32[($2 + 68 | 0) >> 2] | 0;
    HEAP32[($2 + 16 | 0) >> 2] = $3;
    HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[$2 >> 2] = $3;
    HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$1;
    cardano_serialization_lib__Ipv6__new_impl__h24a5893493c4a06f($0 | 0, $2 | 0);
    break label$1;
   }
   memcpy($2 + 71 | 0 | 0, memcpy($2 + 16 | 0 | 4 | 0 | 0, ($2 + 64 | 0) + 8 | 0 | 0, 40 | 0) | 0 | 0, 40 | 0) | 0;
   HEAP8[($0 + 8 | 0) >> 0] = 2;
   HEAP32[($0 + 56 | 0) >> 2] = 0;
   memcpy($0 + 9 | 0 | 0, $2 + 64 | 0 | 0, 47 | 0) | 0;
   HEAP8[$0 >> 0] = 1;
  }
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__DNSRecordAorAAAA___deserialize__hd54709d96c351cb8($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, $3 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___text__h764f26557f652908($2 + 64 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 64 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[($2 + 76 | 0) >> 2] | 0;
    HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] = $1;
    HEAP32[($2 + 8 | 0) >> 2] = $1;
    i64toi32_i32$1 = HEAP32[($2 + 72 | 0) >> 2] | 0;
    $3 = HEAP32[($2 + 68 | 0) >> 2] | 0;
    HEAP32[($2 + 16 | 0) >> 2] = $3;
    HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[$2 >> 2] = $3;
    HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$1;
    cardano_serialization_lib__DNSRecordAorAAAA__new_impl__he2de007c7a72649a($0 | 0, $2 | 0);
    break label$1;
   }
   memcpy($2 + 71 | 0 | 0, memcpy($2 + 16 | 0 | 4 | 0 | 0, ($2 + 64 | 0) + 8 | 0 | 0, 40 | 0) | 0 | 0, 40 | 0) | 0;
   HEAP8[($0 + 8 | 0) >> 0] = 2;
   HEAP32[($0 + 56 | 0) >> 2] = 0;
   memcpy($0 + 9 | 0 | 0, $2 + 64 | 0 | 0, 47 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__DNSRecordSRV___deserialize__h30f1f7710b983e30($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, $3 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___text__h764f26557f652908($2 + 64 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 64 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[($2 + 76 | 0) >> 2] | 0;
    HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] = $1;
    HEAP32[($2 + 8 | 0) >> 2] = $1;
    i64toi32_i32$1 = HEAP32[($2 + 72 | 0) >> 2] | 0;
    $3 = HEAP32[($2 + 68 | 0) >> 2] | 0;
    HEAP32[($2 + 16 | 0) >> 2] = $3;
    HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[$2 >> 2] = $3;
    HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$1;
    cardano_serialization_lib__DNSRecordSRV__new_impl__h390c8355efc834ca($0 | 0, $2 | 0);
    break label$1;
   }
   memcpy($2 + 71 | 0 | 0, memcpy($2 + 16 | 0 | 4 | 0 | 0, ($2 + 64 | 0) + 8 | 0 | 0, 40 | 0) | 0 | 0, 40 | 0) | 0;
   HEAP8[($0 + 8 | 0) >> 0] = 2;
   HEAP32[($0 + 56 | 0) >> 2] = 0;
   memcpy($0 + 9 | 0 | 0, $2 + 64 | 0 | 0, 47 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__URL___deserialize__hc711c8b8b85e87e8($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, $3 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___text__h764f26557f652908($2 + 64 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 64 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[($2 + 76 | 0) >> 2] | 0;
    HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] = $1;
    HEAP32[($2 + 8 | 0) >> 2] = $1;
    i64toi32_i32$1 = HEAP32[($2 + 72 | 0) >> 2] | 0;
    $3 = HEAP32[($2 + 68 | 0) >> 2] | 0;
    HEAP32[($2 + 16 | 0) >> 2] = $3;
    HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[$2 >> 2] = $3;
    HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$1;
    cardano_serialization_lib__URL__new_impl__h2bef2f0e9022dd28($0 | 0, $2 | 0);
    break label$1;
   }
   memcpy($2 + 71 | 0 | 0, memcpy($2 + 16 | 0 | 4 | 0 | 0, ($2 + 64 | 0) + 8 | 0 | 0, 40 | 0) | 0 | 0, 40 | 0) | 0;
   HEAP8[($0 + 8 | 0) >> 0] = 2;
   HEAP32[($0 + 56 | 0) >> 2] = 0;
   memcpy($0 + 9 | 0 | 0, $2 + 64 | 0 | 0, 47 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__SerializeEmbeddedGroup_20for_20cardano_serialization_lib__ScriptNOfK___serialize_as_embedded_group__ha49ffad7178be19f($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  i64toi32_i32$0 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 3 | 0, i64toi32_i32$0 | 0);
  $4 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
      i64toi32_i32$1 = 0;
      cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, i64toi32_i32$0 | 0, i64toi32_i32$1 | 0);
      if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__NativeScripts___serialize__hecc991a2909139b7($3 | 0, $1 + 4 | 0 | 0, $2 | 0);
      $4 = 1;
      if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
       break label$2
      }
      HEAP32[($0 + 4 | 0) >> 2] = $2;
      $4 = 0;
      break label$1;
     }
     memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    $4 = 1;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
  }
  HEAP32[$0 >> 2] = $4;
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__AssetName___deserialize__hed130337b055988b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, $3 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___bytes__hc697ccccfa39fd82($2 + 64 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 64 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[($2 + 76 | 0) >> 2] | 0;
    HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] = $1;
    HEAP32[($2 + 8 | 0) >> 2] = $1;
    i64toi32_i32$1 = HEAP32[($2 + 72 | 0) >> 2] | 0;
    $3 = HEAP32[($2 + 68 | 0) >> 2] | 0;
    HEAP32[($2 + 16 | 0) >> 2] = $3;
    HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[$2 >> 2] = $3;
    HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$1;
    cardano_serialization_lib__AssetName__new_impl__h47344992a9d6e8cb($0 | 0, $2 | 0);
    break label$1;
   }
   memcpy($2 + 71 | 0 | 0, memcpy($2 + 16 | 0 | 4 | 0 | 0, ($2 + 64 | 0) + 8 | 0 | 0, 40 | 0) | 0 | 0, 40 | 0) | 0;
   HEAP8[($0 + 8 | 0) >> 0] = 2;
   HEAP32[($0 + 56 | 0) >> 2] = 0;
   memcpy($0 + 9 | 0 | 0, $2 + 64 | 0 | 0, 47 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__Ed25519KeyHashes__add__h0c425be96292307f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $2 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $21 = 0, $3 = 0, $4 = 0, $5 = 0, $20 = 0, $26 = 0, $29 = 0, $47 = 0, $55 = 0, $59 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  $3 = $2 + 24 | 0;
  $15 = $1 + 24 | 0;
  HEAP32[$3 >> 2] = HEAPU8[$15 >> 0] | 0 | ((HEAPU8[($15 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($15 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($15 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $4 = $2 + 16 | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[i64toi32_i32$0 >> 2] = $20;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $5 = $2 + 8 | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $26 = i64toi32_i32$1;
  i64toi32_i32$1 = $5;
  HEAP32[i64toi32_i32$1 >> 2] = $26;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $29 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $29;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (($1 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
    break label$1
   }
   alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h75690594b6280ac0($0 | 0, $1 | 0, 1 | 0);
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  }
  $1 = (HEAP32[$0 >> 2] | 0) + Math_imul($1, 28) | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $47 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  $16 = $47;
  HEAP8[i64toi32_i32$1 >> 0] = $16;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $16 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $17 = i64toi32_i32$1 + 24 | 0;
  $18 = HEAP32[$3 >> 2] | 0;
  HEAP8[$17 >> 0] = $18;
  HEAP8[($17 + 1 | 0) >> 0] = $18 >>> 8 | 0;
  HEAP8[($17 + 2 | 0) >> 0] = $18 >>> 16 | 0;
  HEAP8[($17 + 3 | 0) >> 0] = $18 >>> 24 | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $55 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 16 | 0;
  $19 = $55;
  HEAP8[i64toi32_i32$0 >> 0] = $19;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $19 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $19 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $19 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $59 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 8 | 0;
  $21 = $59;
  HEAP8[i64toi32_i32$1 >> 0] = $21;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $21 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $21 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $21 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
  global$0 = $2 + 32 | 0;
 }
 
 function nativescript_as_script_n_of_k($0) {
  $0 = $0 | 0;
  var $1 = 0, $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$2 = 0, $4 = 0, $5 = 0, $5$hi = 0;
  $1 = global$0 - 32 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h6ed0b6b043905434($1 + 8 | 0 | 0, $0 | 0);
   $2 = 0;
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   label$2 : {
    label$3 : {
     $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     if ((HEAPU8[$3 >> 0] | 0 | 0) == (3 | 0)) {
      break label$3
     }
     $3 = 0;
     break label$2;
    }
    $4 = HEAP32[($3 + 4 | 0) >> 2] | 0;
    alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($1 + 16 | 0 | 4 | 0 | 0, HEAP32[($3 + 8 | 0) >> 2] | 0 | 0, HEAP32[($3 + 16 | 0) >> 2] | 0 | 0);
    i64toi32_i32$2 = $1 + 24 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $5 = i64toi32_i32$0;
    $5$hi = i64toi32_i32$1;
    $3 = HEAP32[($1 + 20 | 0) >> 2] | 0;
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   label$4 : {
    if (!$3) {
     break label$4
    }
    i64toi32_i32$1 = $5$hi;
    i64toi32_i32$0 = $1 + 24 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $5;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($1 + 20 | 0) >> 2] = $3;
    HEAP32[($1 + 16 | 0) >> 2] = $4;
    $2 = $cardano_serialization_lib__ScriptNOfK_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h0db7a3b086405587($1 + 16 | 0 | 0) | 0;
   }
   global$0 = $1 + 32 | 0;
   return $2 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function cardano_serialization_lib__GenesisHashes__add__hdde2164103102faf($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $2 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $21 = 0, $3 = 0, $4 = 0, $5 = 0, $20 = 0, $26 = 0, $29 = 0, $47 = 0, $55 = 0, $59 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  $3 = $2 + 24 | 0;
  $15 = $1 + 24 | 0;
  HEAP32[$3 >> 2] = HEAPU8[$15 >> 0] | 0 | ((HEAPU8[($15 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($15 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($15 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $4 = $2 + 16 | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[i64toi32_i32$0 >> 2] = $20;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $5 = $2 + 8 | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $26 = i64toi32_i32$1;
  i64toi32_i32$1 = $5;
  HEAP32[i64toi32_i32$1 >> 2] = $26;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $29 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $29;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (($1 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
    break label$1
   }
   alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h60072695517d08a3($0 | 0, $1 | 0, 1 | 0);
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  }
  $1 = (HEAP32[$0 >> 2] | 0) + Math_imul($1, 28) | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $47 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  $16 = $47;
  HEAP8[i64toi32_i32$1 >> 0] = $16;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $16 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $17 = i64toi32_i32$1 + 24 | 0;
  $18 = HEAP32[$3 >> 2] | 0;
  HEAP8[$17 >> 0] = $18;
  HEAP8[($17 + 1 | 0) >> 0] = $18 >>> 8 | 0;
  HEAP8[($17 + 2 | 0) >> 0] = $18 >>> 16 | 0;
  HEAP8[($17 + 3 | 0) >> 0] = $18 >>> 24 | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $55 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 16 | 0;
  $19 = $55;
  HEAP8[i64toi32_i32$0 >> 0] = $19;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $19 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $19 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $19 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $59 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 8 | 0;
  $21 = $59;
  HEAP8[i64toi32_i32$1 >> 0] = $21;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $21 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $21 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $21 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
  global$0 = $2 + 32 | 0;
 }
 
 function cardano_serialization_lib__ScriptHashes__add__h9e978044766aa310($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $2 = 0, $15 = 0, $16 = 0, $17 = 0, $18 = 0, $19 = 0, $21 = 0, $3 = 0, $4 = 0, $5 = 0, $20 = 0, $26 = 0, $29 = 0, $47 = 0, $55 = 0, $59 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  $3 = $2 + 24 | 0;
  $15 = $1 + 24 | 0;
  HEAP32[$3 >> 2] = HEAPU8[$15 >> 0] | 0 | ((HEAPU8[($15 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($15 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($15 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $4 = $2 + 16 | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[i64toi32_i32$0 >> 2] = $20;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $5 = $2 + 8 | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $26 = i64toi32_i32$1;
  i64toi32_i32$1 = $5;
  HEAP32[i64toi32_i32$1 >> 2] = $26;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $29 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $29;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (($1 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
    break label$1
   }
   alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h6efd3441b9caf532($0 | 0, $1 | 0, 1 | 0);
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  }
  $1 = (HEAP32[$0 >> 2] | 0) + Math_imul($1, 28) | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $47 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  $16 = $47;
  HEAP8[i64toi32_i32$1 >> 0] = $16;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $16 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $17 = i64toi32_i32$1 + 24 | 0;
  $18 = HEAP32[$3 >> 2] | 0;
  HEAP8[$17 >> 0] = $18;
  HEAP8[($17 + 1 | 0) >> 0] = $18 >>> 8 | 0;
  HEAP8[($17 + 2 | 0) >> 0] = $18 >>> 16 | 0;
  HEAP8[($17 + 3 | 0) >> 0] = $18 >>> 24 | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $55 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 16 | 0;
  $19 = $55;
  HEAP8[i64toi32_i32$0 >> 0] = $19;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $19 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $19 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $19 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $59 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 8 | 0;
  $21 = $59;
  HEAP8[i64toi32_i32$1 >> 0] = $21;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $21 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $21 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $21 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
  global$0 = $2 + 32 | 0;
 }
 
 function core__iter__adapters__process_results__hc60f8edd7805cc59($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $6 = 0, $17 = 0, $20 = 0, $5 = 0, $39 = 0, $43 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  $3 = 0;
  HEAP32[$2 >> 2] = 0;
  $4 = ($2 + 24 | 0) + 8 | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $17 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[i64toi32_i32$0 >> 2] = $17;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $20 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $20;
  HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 40 | 0) >> 2] = $2;
  $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__hb1927774b99cfc2c($2 + 8 | 0 | 0, $2 + 24 | 0 | 0);
  $1 = HEAP32[$2 >> 2] | 0;
  $5 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $6 = ($2 + 8 | 0) + 8 | 0;
  HEAP32[$4 >> 2] = HEAP32[$6 >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $39 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $39;
  HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    if ($1) {
     break label$2
    }
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $43 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $43;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = HEAP32[$6 >> 2] | 0;
    break label$1;
   }
   HEAP32[($0 + 4 | 0) >> 2] = $5;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h2d454d4f9b2e44f3($2 + 24 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h55384607e9cf45ad($2 + 24 | 0 | 0);
   $3 = 1;
  }
  HEAP32[$0 >> 2] = $3;
  global$0 = $2 + 48 | 0;
 }
 
 function value_new_from_assets($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $3 = 0, $38 = 0, $43 = 0, $46 = 0;
  $1 = global$0 - 64 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h9968e42c55861cec($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   label$2 : {
    label$3 : {
     $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     if (HEAP32[($2 + 8 | 0) >> 2] | 0) {
      break label$3
     }
     $3 = 0;
     break label$2;
    }
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($1 + 28 | 0 | 0, $2 | 0);
    $3 = 1;
   }
   $2 = ($1 + 16 | 0) + 8 | 0;
   HEAP32[$2 >> 2] = $3;
   i64toi32_i32$1 = $1;
   i64toi32_i32$0 = 0;
   HEAP32[($1 + 16 | 0) >> 2] = 0;
   HEAP32[($1 + 20 | 0) >> 2] = i64toi32_i32$0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   i64toi32_i32$2 = ($1 + 16 | 0) + 16 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $38 = i64toi32_i32$0;
   i64toi32_i32$0 = ($1 + 40 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $38;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $43 = i64toi32_i32$1;
   i64toi32_i32$1 = ($1 + 40 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $43;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $1;
   i64toi32_i32$0 = HEAP32[($1 + 16 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
   $46 = i64toi32_i32$0;
   i64toi32_i32$0 = $1;
   HEAP32[($1 + 40 | 0) >> 2] = $46;
   HEAP32[($1 + 44 | 0) >> 2] = i64toi32_i32$1;
   $0 = $cardano_serialization_lib__utils__Value_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h50a1108e1e08f966($1 + 40 | 0 | 0) | 0;
   global$0 = $1 + 64 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function cardano_serialization_lib__utils__hash_auxiliary_data__h70df64c2596a1cad($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $2 = 0, i64toi32_i32$2 = 0, $12 = 0, $13 = 0, $14 = 0, $15 = 0, $3 = 0, $4 = 0, $37 = 0, $41 = 0, $45 = 0, $48 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  cardano_serialization_lib__metadata__AuxiliaryData__to_bytes__hfa2015a3201786ee($2 + 48 | 0 | 0, $1 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $2 + 48 | 0 | 0);
  $1 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = $1;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $3 = ($2 + 16 | 0) + 16 | 0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = ($2 + 16 | 0) + 24 | 0;
  i64toi32_i32$1 = $4;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  cryptoxide__blake2b__Blake2b__blake2b__hfbfc741a485cb529(i64toi32_i32$1 + 16 | 0 | 0, 32 | 0, HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] | 0 | 0, HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] | 0 | 0, 1066228 | 0, 0 | 0);
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $37 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 24 | 0;
  $12 = $37;
  HEAP8[i64toi32_i32$0 >> 0] = $12;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $41 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 16 | 0;
  $13 = $41;
  HEAP8[i64toi32_i32$1 >> 0] = $13;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $45 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 8 | 0;
  $14 = $45;
  HEAP8[i64toi32_i32$0 >> 0] = $14;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $14 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $14 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $14 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $48 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  $15 = $48;
  HEAP8[i64toi32_i32$1 >> 0] = $15;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $15 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $15 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $15 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 48 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 48 | 0 | 0);
  global$0 = $2 + 64 | 0;
 }
 
 function cardano_serialization_lib__utils__hash_transaction__hf44530f726c579d0($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $2 = 0, i64toi32_i32$2 = 0, $12 = 0, $13 = 0, $14 = 0, $15 = 0, $3 = 0, $4 = 0, $37 = 0, $41 = 0, $45 = 0, $48 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  cardano_serialization_lib__TransactionBody__to_bytes__h03479aa95ace09cb($2 + 48 | 0 | 0, $1 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $2 + 48 | 0 | 0);
  $1 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = $1;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $3 = ($2 + 16 | 0) + 16 | 0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = ($2 + 16 | 0) + 24 | 0;
  i64toi32_i32$1 = $4;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  cryptoxide__blake2b__Blake2b__blake2b__hfbfc741a485cb529(i64toi32_i32$1 + 16 | 0 | 0, 32 | 0, HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] | 0 | 0, HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] | 0 | 0, 1066228 | 0, 0 | 0);
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $37 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 24 | 0;
  $12 = $37;
  HEAP8[i64toi32_i32$0 >> 0] = $12;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $41 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 16 | 0;
  $13 = $41;
  HEAP8[i64toi32_i32$1 >> 0] = $13;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $45 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 8 | 0;
  $14 = $45;
  HEAP8[i64toi32_i32$0 >> 0] = $14;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $14 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $14 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $14 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $48 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  $15 = $48;
  HEAP8[i64toi32_i32$1 >> 0] = $15;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $15 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $15 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $15 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 48 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 48 | 0 | 0);
  global$0 = $2 + 64 | 0;
 }
 
 function cardano_serialization_lib__utils__hash_plutus_data__h0579fc1ddbe281cf($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $2 = 0, i64toi32_i32$2 = 0, $12 = 0, $13 = 0, $14 = 0, $15 = 0, $3 = 0, $4 = 0, $37 = 0, $41 = 0, $45 = 0, $48 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  cardano_serialization_lib__plutus__PlutusData__to_bytes__h3eb50f620e6d8905($2 + 48 | 0 | 0, $1 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $2 + 48 | 0 | 0);
  $1 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = $1;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $3 = ($2 + 16 | 0) + 16 | 0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $4 = ($2 + 16 | 0) + 24 | 0;
  i64toi32_i32$1 = $4;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  cryptoxide__blake2b__Blake2b__blake2b__hfbfc741a485cb529(i64toi32_i32$1 + 16 | 0 | 0, 32 | 0, HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] | 0 | 0, HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] | 0 | 0, 1066228 | 0, 0 | 0);
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $37 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 24 | 0;
  $12 = $37;
  HEAP8[i64toi32_i32$0 >> 0] = $12;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $41 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 16 | 0;
  $13 = $41;
  HEAP8[i64toi32_i32$1 >> 0] = $13;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $45 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 8 | 0;
  $14 = $45;
  HEAP8[i64toi32_i32$0 >> 0] = $14;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $14 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $14 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $14 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $48 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  $15 = $48;
  HEAP8[i64toi32_i32$1 >> 0] = $15;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $15 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $15 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $15 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 48 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 48 | 0 | 0);
  global$0 = $2 + 64 | 0;
 }
 
 function $cardano_serialization_lib__metadata__TransactionMetadatumLabels_20as_20cbor_event__se__Serialize___serialize__h4a74450283306885($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $5 = 0, $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, $4 | 0, i64toi32_i32$0 | 0);
  $5 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     label$4 : {
      if (!$4) {
       break label$4
      }
      $5 = HEAP32[$1 >> 2] | 0;
      $1 = $4 << 3 | 0;
      label$5 : while (1) {
       i64toi32_i32$0 = HEAP32[$5 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($5 + 4 | 0) >> 2] | 0;
       cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, i64toi32_i32$0 | 0, i64toi32_i32$1 | 0);
       if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
        break label$2
       }
       $5 = $5 + 8 | 0;
       $1 = $1 + -8 | 0;
       if ($1) {
        continue label$5
       }
       break label$5;
      };
     }
     HEAP32[($0 + 4 | 0) >> 2] = $2;
     $5 = 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $5 = 1;
  }
  HEAP32[$0 >> 2] = $5;
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__crypto__Vkeys__add__hdd65d2d54d857e12($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $17 = 0, $18 = 0, $19 = 0, $21 = 0, $3 = 0, $4 = 0, $5 = 0, $14 = 0, $20 = 0, $26 = 0, $29 = 0, $47 = 0, $51 = 0, $55 = 0, $59 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  $3 = $2 + 24 | 0;
  i64toi32_i32$2 = $1 + 24 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $14 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $14;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $4 = $2 + 16 | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $20 = i64toi32_i32$1;
  i64toi32_i32$1 = $4;
  HEAP32[i64toi32_i32$1 >> 2] = $20;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $5 = $2 + 8 | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $26 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[i64toi32_i32$0 >> 2] = $26;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $29 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[i64toi32_i32$1 >> 2] = $29;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  label$1 : {
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (($1 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
    break label$1
   }
   alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h8a2ac49eb7d7d958($0 | 0, $1 | 0, 1 | 0);
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  }
  $1 = (HEAP32[$0 >> 2] | 0) + ($1 << 5 | 0) | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $47 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  $17 = $47;
  HEAP8[i64toi32_i32$0 >> 0] = $17;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $17 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $17 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $17 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $51 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 24 | 0;
  $18 = $51;
  HEAP8[i64toi32_i32$1 >> 0] = $18;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $18 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $18 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $18 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $55 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 16 | 0;
  $19 = $55;
  HEAP8[i64toi32_i32$0 >> 0] = $19;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $19 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $19 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $19 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $59 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 8 | 0;
  $21 = $59;
  HEAP8[i64toi32_i32$1 >> 0] = $21;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $21 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $21 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $21 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
  global$0 = $2 + 32 | 0;
 }
 
 function cardano_serialization_lib__crypto__PublicKeys__add__h9cce03ece08311fd($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $17 = 0, $18 = 0, $19 = 0, $21 = 0, $3 = 0, $4 = 0, $5 = 0, $14 = 0, $20 = 0, $26 = 0, $29 = 0, $47 = 0, $51 = 0, $55 = 0, $59 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  $3 = $2 + 24 | 0;
  i64toi32_i32$2 = $1 + 24 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $14 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $14;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $4 = $2 + 16 | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $20 = i64toi32_i32$1;
  i64toi32_i32$1 = $4;
  HEAP32[i64toi32_i32$1 >> 2] = $20;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $5 = $2 + 8 | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $26 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[i64toi32_i32$0 >> 2] = $26;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $29 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[i64toi32_i32$1 >> 2] = $29;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  label$1 : {
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (($1 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
    break label$1
   }
   alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h627fa3c45b4de56f($0 | 0, $1 | 0, 1 | 0);
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  }
  $1 = (HEAP32[$0 >> 2] | 0) + ($1 << 5 | 0) | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $47 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  $17 = $47;
  HEAP8[i64toi32_i32$0 >> 0] = $17;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $17 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $17 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $17 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $51 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 24 | 0;
  $18 = $51;
  HEAP8[i64toi32_i32$1 >> 0] = $18;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $18 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $18 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $18 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $55 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 16 | 0;
  $19 = $55;
  HEAP8[i64toi32_i32$0 >> 0] = $19;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $19 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $19 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $19 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $5;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $59 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 8 | 0;
  $21 = $59;
  HEAP8[i64toi32_i32$1 >> 0] = $21;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $21 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $21 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $21 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
  global$0 = $2 + 32 | 0;
 }
 
 function alloc__vec__Vec_T_2cA___extend_desugared__h63aff0d1a950f740($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $3 = 0, $2 = 0, $5 = 0, $4 = 0, $6 = 0, $7 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   $3 = HEAP32[$1 >> 2] | 0;
   $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   if (($3 | 0) == ($4 | 0)) {
    break label$1
   }
   $5 = (HEAP32[($1 + 8 | 0) >> 2] | 0) + -1 | 0;
   label$2 : while (1) {
    HEAP32[($1 + 8 | 0) >> 2] = $5;
    $6 = HEAP32[($3 + 100 | 0) >> 2] | 0;
    HEAP32[$1 >> 2] = $6;
    core__ops__function__impls___impl_20core__ops__function__FnOnce_A__20for_20_mut_20F___call_once__ha9dfc67ebd737082($2 | 0, $1 | 0, $3 | 0, $3 + 48 | 0 | 0);
    if ((HEAP32[$2 >> 2] | 0 | 0) == (5 | 0)) {
     break label$1
    }
    label$3 : {
     $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
     if ((HEAP32[($0 + 4 | 0) >> 2] | 0 | 0) != ($3 | 0)) {
      break label$3
     }
     $7 = $5 + 1 | 0;
     alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hf0c17c80fd73868c($0 | 0, $3 | 0, ($7 >>> 0 < $5 >>> 0 ? -1 : $7) | 0);
    }
    memcpy((HEAP32[$0 >> 2] | 0) + Math_imul($3, 48) | 0 | 0, $2 | 0, 48 | 0) | 0;
    HEAP32[($0 + 8 | 0) >> 2] = $3 + 1 | 0;
    $5 = $5 + -1 | 0;
    $3 = $6;
    if (($3 | 0) != ($4 | 0)) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $2 + 48 | 0;
 }
 
 function $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__he32bf0f16720a611($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $3 = 0, $31 = 0, $37 = 0, $40 = 0, $51 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__ha538daa28fd542ac($2 + 8 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    if (HEAP32[($2 + 8 | 0) >> 2] | 0) {
     break label$2
    }
    i64toi32_i32$1 = $0;
    i64toi32_i32$0 = 0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = 0;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[i64toi32_i32$1 >> 2] = HEAP32[(0 + 1067616 | 0) >> 2] | 0;
    break label$1;
   }
   $3 = ($2 + 16 | 0) + 8 | 0;
   HEAP32[$3 >> 2] = 1;
   i64toi32_i32$1 = $2;
   i64toi32_i32$0 = 0;
   HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = 1;
   HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[((i64toi32_i32$1 + 32 | 0) + 24 | 0) >> 2] = HEAP32[($1 + 24 | 0) >> 2] | 0;
   i64toi32_i32$2 = $1 + 16 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $31 = i64toi32_i32$0;
   i64toi32_i32$0 = ($2 + 32 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $31;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1 + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $37 = i64toi32_i32$1;
   i64toi32_i32$1 = ($2 + 32 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $37;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $1;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $40 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   HEAP32[($2 + 32 | 0) >> 2] = $40;
   HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
   alloc__vec__Vec_T_2cA___extend_desugared__h206af6674e992ec7($2 + 16 | 0 | 0, $2 + 32 | 0 | 0);
   HEAP32[($0 + 8 | 0) >> 2] = HEAP32[$3 >> 2] | 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   $51 = i64toi32_i32$1;
   i64toi32_i32$1 = $0;
   HEAP32[i64toi32_i32$1 >> 2] = $51;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  }
  global$0 = $2 + 64 | 0;
 }
 
 function alloc__slice__insert_head__hc4f7fbe6474bcab2($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $4 = 0, $3 = 0, $5 = 0, $17 = 0, $17$hi = 0, $20 = 0, $20$hi = 0, $35 = 0, $35$hi = 0, $39 = 0, $39$hi = 0, $56 = 0, $56$hi = 0, $60 = 0, $60$hi = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  label$1 : {
   if ($1 >>> 0 < 2 >>> 0) {
    break label$1
   }
   $4 = HEAP32[$2 >> 2] | 0;
   $2 = $0 + 4 | 0;
   i64toi32_i32$0 = cardano_serialization_lib__tx_builder__TransactionBuilder__cip2_largest_first_by___7b_7bclosure_7d_7d__hb6689e866bcf147a($4 | 0, $2 | 0) | 0;
   i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
   $17 = i64toi32_i32$0;
   $17$hi = i64toi32_i32$1;
   i64toi32_i32$1 = cardano_serialization_lib__tx_builder__TransactionBuilder__cip2_largest_first_by___7b_7bclosure_7d_7d__hb6689e866bcf147a($4 | 0, $0 | 0) | 0;
   i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
   $20 = i64toi32_i32$1;
   $20$hi = i64toi32_i32$0;
   i64toi32_i32$0 = $17$hi;
   i64toi32_i32$2 = $17;
   i64toi32_i32$1 = $20$hi;
   i64toi32_i32$3 = $20;
   if (i64toi32_i32$0 >>> 0 > i64toi32_i32$1 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$2 >>> 0 >= i64toi32_i32$3 >>> 0 | 0) | 0) {
    break label$1
   }
   $5 = HEAP32[$0 >> 2] | 0;
   HEAP32[$0 >> 2] = HEAP32[($0 + 4 | 0) >> 2] | 0;
   HEAP32[($3 + 12 | 0) >> 2] = $5;
   label$2 : {
    if ($1 >>> 0 < 3 >>> 0) {
     break label$2
    }
    $0 = $0 + 8 | 0;
    i64toi32_i32$2 = cardano_serialization_lib__tx_builder__TransactionBuilder__cip2_largest_first_by___7b_7bclosure_7d_7d__hb6689e866bcf147a($4 | 0, $0 | 0) | 0;
    i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
    $35 = i64toi32_i32$2;
    $35$hi = i64toi32_i32$0;
    i64toi32_i32$0 = cardano_serialization_lib__tx_builder__TransactionBuilder__cip2_largest_first_by___7b_7bclosure_7d_7d__hb6689e866bcf147a($4 | 0, $3 + 12 | 0 | 0) | 0;
    i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
    $39 = i64toi32_i32$0;
    $39$hi = i64toi32_i32$2;
    i64toi32_i32$2 = $35$hi;
    i64toi32_i32$3 = $35;
    i64toi32_i32$0 = $39$hi;
    i64toi32_i32$1 = $39;
    if (i64toi32_i32$2 >>> 0 > i64toi32_i32$0 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$3 >>> 0 >= i64toi32_i32$1 >>> 0 | 0) | 0) {
     break label$2
    }
    $1 = $1 + -2 | 0;
    label$3 : while (1) {
     $2 = $0;
     HEAP32[($0 + -4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
     $1 = $1 + -1 | 0;
     if (!$1) {
      break label$2
     }
     $0 = $2 + 4 | 0;
     i64toi32_i32$3 = cardano_serialization_lib__tx_builder__TransactionBuilder__cip2_largest_first_by___7b_7bclosure_7d_7d__hb6689e866bcf147a($4 | 0, $0 | 0) | 0;
     i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
     $56 = i64toi32_i32$3;
     $56$hi = i64toi32_i32$2;
     i64toi32_i32$2 = cardano_serialization_lib__tx_builder__TransactionBuilder__cip2_largest_first_by___7b_7bclosure_7d_7d__hb6689e866bcf147a($4 | 0, $3 + 12 | 0 | 0) | 0;
     i64toi32_i32$3 = i64toi32_i32$HIGH_BITS;
     $60 = i64toi32_i32$2;
     $60$hi = i64toi32_i32$3;
     i64toi32_i32$3 = $56$hi;
     i64toi32_i32$1 = $56;
     i64toi32_i32$2 = $60$hi;
     i64toi32_i32$0 = $60;
     if (i64toi32_i32$3 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$3 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$0 >>> 0 | 0) | 0) {
      continue label$3
     }
     break label$3;
    };
   }
   HEAP32[$2 >> 2] = $5;
  }
  global$0 = $3 + 16 | 0;
 }
 
 function cardano_serialization_lib__address__variable_nat_decode__heeba208d8c3d5da7($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, i64toi32_i32$1 = 0, $3 = 0, $6 = 0, $6$hi = 0, $7 = 0, $8 = 0, $8$hi = 0, $4 = 0, $7$hi = 0, $22 = 0, $23 = 0, $24 = 0, $5 = 0, $26 = 0, $26$hi = 0, $28$hi = 0, $33$hi = 0, $40$hi = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  core__slice__iter___impl_20core__iter__traits__collect__IntoIterator_20for_20__5bT_5d___into_iter__hc96cff628f84e170($3 + 8 | 0 | 0, $1 | 0, $2 | 0);
  $4 = HEAP32[($3 + 8 | 0) >> 2] | 0;
  $5 = (HEAP32[($3 + 12 | 0) >> 2] | 0) - $4 | 0;
  i64toi32_i32$0 = 0;
  $6 = 0;
  $6$hi = i64toi32_i32$0;
  $1 = 0;
  i64toi32_i32$0 = 0;
  $7 = 0;
  $7$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : while (1) {
    label$3 : {
     if (($5 | 0) != ($1 | 0)) {
      break label$3
     }
     i64toi32_i32$0 = 0;
     $8 = 0;
     $8$hi = i64toi32_i32$0;
     break label$1;
    }
    i64toi32_i32$0 = 0;
    $8 = 0;
    $8$hi = i64toi32_i32$0;
    i64toi32_i32$0 = $7$hi;
    i64toi32_i32$2 = $7;
    i64toi32_i32$1 = 0;
    i64toi32_i32$3 = 7;
    i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
     $22 = 0;
    } else {
     i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
     $22 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
    }
    $26 = $22;
    $26$hi = i64toi32_i32$1;
    i64toi32_i32$1 = $6$hi;
    i64toi32_i32$0 = $6;
    i64toi32_i32$2 = 0;
    i64toi32_i32$3 = 57;
    i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$2 = 0;
     $23 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
    } else {
     i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
     $23 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
    }
    $28$hi = i64toi32_i32$2;
    i64toi32_i32$2 = $26$hi;
    i64toi32_i32$1 = $26;
    i64toi32_i32$0 = $28$hi;
    i64toi32_i32$3 = $23;
    i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
    $7 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
    $7$hi = i64toi32_i32$0;
    i64toi32_i32$2 = $7;
    i64toi32_i32$1 = 0;
    i64toi32_i32$3 = 0;
    if ((i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | 0) {
     break label$1
    }
    i64toi32_i32$2 = $6$hi;
    i64toi32_i32$3 = $6;
    i64toi32_i32$0 = 0;
    i64toi32_i32$1 = 7;
    i64toi32_i32$4 = i64toi32_i32$1 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$1 & 63 | 0) >>> 0) {
     i64toi32_i32$0 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
     $24 = 0;
    } else {
     i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
     $24 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
    }
    $33$hi = i64toi32_i32$0;
    $2 = HEAPU8[($4 + $1 | 0) >> 0] | 0;
    i64toi32_i32$0 = 0;
    $40$hi = i64toi32_i32$0;
    i64toi32_i32$0 = $33$hi;
    i64toi32_i32$2 = $24;
    i64toi32_i32$3 = $40$hi;
    i64toi32_i32$1 = $2 & 127 | 0;
    i64toi32_i32$3 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
    $6 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
    $6$hi = i64toi32_i32$3;
    $1 = $1 + 1 | 0;
    if ((($2 << 24 | 0) >> 24 | 0 | 0) < (0 | 0)) {
     continue label$2
    }
    break label$2;
   };
   i64toi32_i32$3 = $6$hi;
   i64toi32_i32$2 = $0;
   HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $6;
   HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$3;
   HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] = $1;
   i64toi32_i32$3 = 0;
   $8 = 1;
   $8$hi = i64toi32_i32$3;
  }
  i64toi32_i32$3 = $8$hi;
  i64toi32_i32$2 = $0;
  HEAP32[i64toi32_i32$2 >> 2] = $8;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
  global$0 = $3 + 16 | 0;
 }
 
 function $cardano_serialization_lib__plutus__ExUnits_20as_20cbor_event__se__Serialize___serialize__h495dce506fba6361($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $4 = 0, i64toi32_i32$1 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  i64toi32_i32$0 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, 2 | 0, i64toi32_i32$0 | 0);
  $4 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      i64toi32_i32$2 = $1;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, i64toi32_i32$0 | 0, i64toi32_i32$1 | 0);
      if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      i64toi32_i32$2 = $1;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
      cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, i64toi32_i32$1 | 0, i64toi32_i32$0 | 0);
      $4 = 1;
      if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
       break label$2
      }
      HEAP32[($0 + 4 | 0) >> 2] = $2;
      $4 = 0;
      break label$1;
     }
     memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    $4 = 1;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
  }
  HEAP32[$0 >> 2] = $4;
  global$0 = $3 + 48 | 0;
 }
 
 function ed25519_bip32__derivation__v2__add_28_mul8_v2__hbec4c73081377038($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $4 = 0, $3 = 0, $7 = 0, $8 = 0, $9 = 0, $10 = 0;
  i64toi32_i32$1 = $0;
  i64toi32_i32$0 = 0;
  $7 = 0;
  HEAP8[i64toi32_i32$1 >> 0] = $7;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $7 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $7 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $7 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$1 = i64toi32_i32$1 + 24 | 0;
  i64toi32_i32$0 = 0;
  $8 = 0;
  HEAP8[i64toi32_i32$1 >> 0] = $8;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $8 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $8 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $8 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$1 = $0 + 16 | 0;
  i64toi32_i32$0 = 0;
  $9 = 0;
  HEAP8[i64toi32_i32$1 >> 0] = $9;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $9 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $9 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $9 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$1 = $0 + 8 | 0;
  i64toi32_i32$0 = 0;
  $10 = 0;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $3 = 0;
  $4 = 0;
  label$1 : while (1) {
   $3 = ($3 + (HEAPU8[($1 + $4 | 0) >> 0] | 0) | 0) + ((HEAPU8[($2 + $4 | 0) >> 0] | 0) << 3 | 0) | 0;
   HEAP8[($0 + $4 | 0) >> 0] = $3;
   $3 = ($3 & 65280 | 0) >>> 8 | 0;
   $4 = $4 + 1 | 0;
   if (($4 | 0) != (28 | 0)) {
    continue label$1
   }
   break label$1;
  };
  $1 = $1 + 28 | 0;
  $0 = $0 + 28 | 0;
  $4 = 0;
  label$2 : while (1) {
   $3 = $3 + (HEAPU8[($1 + $4 | 0) >> 0] | 0) | 0;
   HEAP8[($0 + $4 | 0) >> 0] = $3;
   $3 = ($3 & 65280 | 0) >>> 8 | 0;
   $4 = $4 + 1 | 0;
   if (($4 | 0) != (4 | 0)) {
    continue label$2
   }
   break label$2;
  };
 }
 
 function $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__hec0e106e73790eaa($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $5 = 0, $4 = 0, $40 = 0, $43 = 0, $54 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  $core__iter__adapters__ResultShunt_I_2cE__20as_20core__iter__traits__iterator__Iterator___try_fold__haf6fbe5f8305961d($2 + 8 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    if ((HEAPU8[($2 + 8 | 0) >> 0] | 0) & 1 | 0) {
     break label$2
    }
    i64toi32_i32$1 = $0;
    i64toi32_i32$0 = 0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = 0;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[i64toi32_i32$1 >> 2] = HEAP32[(0 + 1139084 | 0) >> 2] | 0;
    break label$1;
   }
   $3 = HEAPU8[($2 + 9 | 0) >> 0] | 0;
   alloc__raw_vec__RawVec_T_2cA___allocate_in__h0b672ee83bdda79c($2 | 0, 1 | 0, 0 | 0);
   $4 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $5 = HEAP32[$2 >> 2] | 0;
   HEAP8[$5 >> 0] = $3;
   $3 = ($2 + 16 | 0) + 8 | 0;
   HEAP32[$3 >> 2] = 1;
   HEAP32[($2 + 20 | 0) >> 2] = $4;
   HEAP32[($2 + 16 | 0) >> 2] = $5;
   i64toi32_i32$2 = $1 + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $40 = i64toi32_i32$0;
   i64toi32_i32$0 = ($2 + 32 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $40;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $43 = i64toi32_i32$1;
   i64toi32_i32$1 = $2;
   HEAP32[($2 + 32 | 0) >> 2] = $43;
   HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$0;
   alloc__vec__Vec_T_2cA___extend_desugared__h4a95415290b3063b($2 + 16 | 0 | 0, $2 + 32 | 0 | 0);
   HEAP32[($0 + 8 | 0) >> 2] = HEAP32[$3 >> 2] | 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   $54 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[i64toi32_i32$0 >> 2] = $54;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  }
  global$0 = $2 + 48 | 0;
 }
 
 function core__fmt__num___impl_20core__fmt__LowerHex_20for_20i128___fmt__h7d7478473e163f7b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $2 = 0, $4 = 0, $4$hi = 0, $5 = 0, $3 = 0, $5$hi = 0, $18 = 0, $19 = 0, $20 = 0, $32 = 0, $32$hi = 0, $34$hi = 0, $36 = 0, $36$hi = 0;
  $2 = global$0 - 128 | 0;
  global$0 = $2;
  i64toi32_i32$2 = $0 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $5 = i64toi32_i32$1;
  $5$hi = i64toi32_i32$0;
  $0 = 128;
  label$1 : {
   label$2 : while (1) {
    label$3 : {
     if ($0) {
      break label$3
     }
     $0 = 0;
     break label$1;
    }
    i64toi32_i32$0 = $5$hi;
    $3 = $5 & 15 | 0;
    HEAP8[(($2 + $0 | 0) + -1 | 0) >> 0] = $3 >>> 0 < 10 >>> 0 ? $3 | 48 | 0 : $3 + 87 | 0;
    $0 = $0 + -1 | 0;
    i64toi32_i32$2 = $5;
    i64toi32_i32$1 = 0;
    i64toi32_i32$3 = 4;
    i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$1 = 0;
     $18 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
    } else {
     i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
     $18 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
    }
    $32 = $18;
    $32$hi = i64toi32_i32$1;
    i64toi32_i32$1 = $4$hi;
    i64toi32_i32$0 = $4;
    i64toi32_i32$2 = 0;
    i64toi32_i32$3 = 60;
    i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
     $19 = 0;
    } else {
     i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
     $19 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
    }
    $34$hi = i64toi32_i32$2;
    i64toi32_i32$2 = $32$hi;
    i64toi32_i32$1 = $32;
    i64toi32_i32$0 = $34$hi;
    i64toi32_i32$3 = $19;
    i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
    $5 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
    $5$hi = i64toi32_i32$0;
    $36 = $5;
    $36$hi = i64toi32_i32$0;
    i64toi32_i32$0 = $4$hi;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = 0;
    i64toi32_i32$3 = 4;
    i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$1 = 0;
     $20 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
    } else {
     i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
     $20 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
    }
    $4 = $20;
    $4$hi = i64toi32_i32$1;
    i64toi32_i32$1 = $36$hi;
    i64toi32_i32$0 = $36;
    i64toi32_i32$2 = $4$hi;
    i64toi32_i32$3 = $4;
    i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
    i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
    i64toi32_i32$0 = 0;
    i64toi32_i32$3 = 0;
    if ((i64toi32_i32$1 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$0 | 0) | 0) {
     continue label$2
    }
    break label$2;
   };
   if ($0 >>> 0 < 129 >>> 0) {
    break label$1
   }
   core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($0 | 0, 128 | 0, 1150164 | 0);
   abort();
  }
  $0 = core__fmt__Formatter__pad_integral__h08e3e53a0de517a1($1 | 0, 1 | 0, 1150180 | 0, 2 | 0, $2 + $0 | 0 | 0, 128 - $0 | 0 | 0) | 0;
  global$0 = $2 + 128 | 0;
  return $0 | 0;
 }
 
 function core__fmt__num___impl_20core__fmt__UpperHex_20for_20i128___fmt__hdc303003e4e4722e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $2 = 0, $4 = 0, $4$hi = 0, $5 = 0, $3 = 0, $5$hi = 0, $18 = 0, $19 = 0, $20 = 0, $32 = 0, $32$hi = 0, $34$hi = 0, $36 = 0, $36$hi = 0;
  $2 = global$0 - 128 | 0;
  global$0 = $2;
  i64toi32_i32$2 = $0 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $5 = i64toi32_i32$1;
  $5$hi = i64toi32_i32$0;
  $0 = 128;
  label$1 : {
   label$2 : while (1) {
    label$3 : {
     if ($0) {
      break label$3
     }
     $0 = 0;
     break label$1;
    }
    i64toi32_i32$0 = $5$hi;
    $3 = $5 & 15 | 0;
    HEAP8[(($2 + $0 | 0) + -1 | 0) >> 0] = $3 >>> 0 < 10 >>> 0 ? $3 | 48 | 0 : $3 + 55 | 0;
    $0 = $0 + -1 | 0;
    i64toi32_i32$2 = $5;
    i64toi32_i32$1 = 0;
    i64toi32_i32$3 = 4;
    i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$1 = 0;
     $18 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
    } else {
     i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
     $18 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
    }
    $32 = $18;
    $32$hi = i64toi32_i32$1;
    i64toi32_i32$1 = $4$hi;
    i64toi32_i32$0 = $4;
    i64toi32_i32$2 = 0;
    i64toi32_i32$3 = 60;
    i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$2 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
     $19 = 0;
    } else {
     i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
     $19 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
    }
    $34$hi = i64toi32_i32$2;
    i64toi32_i32$2 = $32$hi;
    i64toi32_i32$1 = $32;
    i64toi32_i32$0 = $34$hi;
    i64toi32_i32$3 = $19;
    i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
    $5 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
    $5$hi = i64toi32_i32$0;
    $36 = $5;
    $36$hi = i64toi32_i32$0;
    i64toi32_i32$0 = $4$hi;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = 0;
    i64toi32_i32$3 = 4;
    i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$1 = 0;
     $20 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
    } else {
     i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
     $20 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
    }
    $4 = $20;
    $4$hi = i64toi32_i32$1;
    i64toi32_i32$1 = $36$hi;
    i64toi32_i32$0 = $36;
    i64toi32_i32$2 = $4$hi;
    i64toi32_i32$3 = $4;
    i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
    i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
    i64toi32_i32$0 = 0;
    i64toi32_i32$3 = 0;
    if ((i64toi32_i32$1 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$0 | 0) | 0) {
     continue label$2
    }
    break label$2;
   };
   if ($0 >>> 0 < 129 >>> 0) {
    break label$1
   }
   core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($0 | 0, 128 | 0, 1150164 | 0);
   abort();
  }
  $0 = core__fmt__Formatter__pad_integral__h08e3e53a0de517a1($1 | 0, 1 | 0, 1150180 | 0, 2 | 0, $2 + $0 | 0 | 0, 128 - $0 | 0 | 0) | 0;
  global$0 = $2 + 128 | 0;
  return $0 | 0;
 }
 
 function cardano_serialization_lib__Transaction__from_bytes__hd46665f26e2ad93c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $14 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 880 | 0;
  global$0 = $2;
  HEAP32[($2 + 872 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 856 | 0) >> 2] = 0;
  HEAP32[($2 + 860 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 864 | 0) >> 2] = $14;
  HEAP32[($2 + 868 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__Transaction___deserialize__hb4f9215300fe97ce($2 + 424 | 0 | 0, $2 + 856 | 0 | 0);
  $1 = ($2 + 856 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = ($2 + 424 | 0) + 8 | 0;
  label$1 : {
   label$2 : {
    i64toi32_i32$1 = HEAP32[($2 + 424 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 428 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    if ((i64toi32_i32$2 | 0) == (1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
     break label$2
    }
    memcpy($0 + 8 | 0 | 0, memcpy($2 | 0, $1 | 0, 424 | 0) | 0 | 0, 424 | 0) | 0;
    $1 = 0;
    break label$1;
   }
   $1 = memcpy($2 | 0, $1 | 0, 64 | 0) | 0;
   memcpy($1 + 424 | 0 | 0, $1 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($1 + 424 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 880 | 0;
 }
 
 function cardano_serialization_lib__TransactionBody__from_bytes__h92ca3c4cb5458ef2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $14 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 576 | 0;
  global$0 = $2;
  HEAP32[($2 + 568 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 552 | 0) >> 2] = 0;
  HEAP32[($2 + 556 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 560 | 0) >> 2] = $14;
  HEAP32[($2 + 564 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__TransactionBody___deserialize__h3099fdd842acebc9($2 + 272 | 0 | 0, $2 + 552 | 0 | 0);
  $1 = ($2 + 552 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = ($2 + 272 | 0) + 8 | 0;
  label$1 : {
   label$2 : {
    i64toi32_i32$1 = HEAP32[($2 + 272 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 276 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    if ((i64toi32_i32$2 | 0) == (1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
     break label$2
    }
    memcpy($0 + 8 | 0 | 0, memcpy($2 | 0, $1 | 0, 272 | 0) | 0 | 0, 272 | 0) | 0;
    $1 = 0;
    break label$1;
   }
   $1 = memcpy($2 | 0, $1 | 0, 64 | 0) | 0;
   memcpy($1 + 272 | 0 | 0, $1 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($1 + 272 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 576 | 0;
 }
 
 function transactionbody_set_auxiliary_data_hash($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $2 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $4 = 0, $3 = 0, $31 = 0, $5 = 0, $5$hi = 0, $6 = 0, $6$hi = 0, $44 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h238818d95bb6c551($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h4fe5a3e1c18388b1($2 | 0, $1 | 0);
   $4 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $1 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$2 = $1;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $31 = i64toi32_i32$0;
   i64toi32_i32$0 = $0 + 205 | 0;
   $14 = $31;
   HEAP8[i64toi32_i32$0 >> 0] = $14;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $14 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $14 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $14 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $5 = i64toi32_i32$1;
   $5$hi = i64toi32_i32$0;
   i64toi32_i32$2 = $1 + 16 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $6 = i64toi32_i32$0;
   $6$hi = i64toi32_i32$1;
   i64toi32_i32$2 = $1 + 24 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[($0 + 204 | 0) >> 0] = 1;
   $44 = i64toi32_i32$1;
   i64toi32_i32$1 = $0 + 229 | 0;
   $15 = $44;
   HEAP8[i64toi32_i32$1 >> 0] = $15;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $15 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $15 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $15 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$0 = $6$hi;
   i64toi32_i32$1 = $0 + 221 | 0;
   $16 = $6;
   HEAP8[i64toi32_i32$1 >> 0] = $16;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $16 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $16 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $16 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$0 = $5$hi;
   i64toi32_i32$1 = $0 + 213 | 0;
   $17 = $5;
   HEAP8[i64toi32_i32$1 >> 0] = $17;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($4 | 0, (HEAP32[$4 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionbody_set_script_data_hash($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $2 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $4 = 0, $3 = 0, $31 = 0, $5 = 0, $5$hi = 0, $6 = 0, $6$hi = 0, $44 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h238818d95bb6c551($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h6b7eaec1bcfb1ff8($2 | 0, $1 | 0);
   $4 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $1 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$2 = $1;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $31 = i64toi32_i32$0;
   i64toi32_i32$0 = $0 + 238 | 0;
   $14 = $31;
   HEAP8[i64toi32_i32$0 >> 0] = $14;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $14 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $14 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $14 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $5 = i64toi32_i32$1;
   $5$hi = i64toi32_i32$0;
   i64toi32_i32$2 = $1 + 16 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $6 = i64toi32_i32$0;
   $6$hi = i64toi32_i32$1;
   i64toi32_i32$2 = $1 + 24 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[($0 + 237 | 0) >> 0] = 1;
   $44 = i64toi32_i32$1;
   i64toi32_i32$1 = $0 + 262 | 0;
   $15 = $44;
   HEAP8[i64toi32_i32$1 >> 0] = $15;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $15 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $15 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $15 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$0 = $6$hi;
   i64toi32_i32$1 = $0 + 254 | 0;
   $16 = $6;
   HEAP8[i64toi32_i32$1 >> 0] = $16;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $16 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $16 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $16 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$0 = $5$hi;
   i64toi32_i32$1 = $0 + 246 | 0;
   $17 = $5;
   HEAP8[i64toi32_i32$1 >> 0] = $17;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($4 | 0, (HEAP32[$4 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function cardano_serialization_lib__TransactionOutput__from_bytes__h950ec06a10b92037($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $14 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 288 | 0;
  global$0 = $2;
  HEAP32[($2 + 280 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 264 | 0) >> 2] = 0;
  HEAP32[($2 + 268 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 272 | 0) >> 2] = $14;
  HEAP32[($2 + 276 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__TransactionOutput___deserialize__haabae074445f3776($2 + 128 | 0 | 0, $2 + 264 | 0 | 0);
  $1 = ($2 + 264 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = ($2 + 128 | 0) + 8 | 0;
  label$1 : {
   label$2 : {
    i64toi32_i32$1 = HEAP32[($2 + 128 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 132 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    if ((i64toi32_i32$2 | 0) == (1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
     break label$2
    }
    memcpy($0 + 8 | 0 | 0, memcpy($2 | 0, $1 | 0, 128 | 0) | 0 | 0, 128 | 0) | 0;
    $1 = 0;
    break label$1;
   }
   $1 = memcpy($2 | 0, $1 | 0, 64 | 0) | 0;
   memcpy($1 + 128 | 0 | 0, $1 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($1 + 128 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 288 | 0;
 }
 
 function transactionoutput_set_data_hash($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $2 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $4 = 0, $3 = 0, $31 = 0, $5 = 0, $5$hi = 0, $6 = 0, $6$hi = 0, $44 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h2e0ce7a7ba945683($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hf03f8ea4201fce5b($2 | 0, $1 | 0);
   $4 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $1 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$2 = $1;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $31 = i64toi32_i32$0;
   i64toi32_i32$0 = $0 + 89 | 0;
   $14 = $31;
   HEAP8[i64toi32_i32$0 >> 0] = $14;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $14 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $14 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $14 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $5 = i64toi32_i32$1;
   $5$hi = i64toi32_i32$0;
   i64toi32_i32$2 = $1 + 16 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $6 = i64toi32_i32$0;
   $6$hi = i64toi32_i32$1;
   i64toi32_i32$2 = $1 + 24 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[($0 + 88 | 0) >> 0] = 1;
   $44 = i64toi32_i32$1;
   i64toi32_i32$1 = $0 + 113 | 0;
   $15 = $44;
   HEAP8[i64toi32_i32$1 >> 0] = $15;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $15 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $15 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $15 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$0 = $6$hi;
   i64toi32_i32$1 = $0 + 105 | 0;
   $16 = $6;
   HEAP8[i64toi32_i32$1 >> 0] = $16;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $16 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $16 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $16 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$0 = $5$hi;
   i64toi32_i32$1 = $0 + 97 | 0;
   $17 = $5;
   HEAP8[i64toi32_i32$1 >> 0] = $17;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($4 | 0, (HEAP32[$4 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function cardano_serialization_lib__PoolParams__from_bytes__h0470afe27db1126a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $14 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 416 | 0;
  global$0 = $2;
  HEAP32[($2 + 408 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 392 | 0) >> 2] = 0;
  HEAP32[($2 + 396 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 400 | 0) >> 2] = $14;
  HEAP32[($2 + 404 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__PoolParams___deserialize__h06f7cbac47e8a2a7($2 + 192 | 0 | 0, $2 + 392 | 0 | 0);
  $1 = ($2 + 392 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = ($2 + 192 | 0) + 8 | 0;
  label$1 : {
   label$2 : {
    i64toi32_i32$1 = HEAP32[($2 + 192 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 196 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    if ((i64toi32_i32$2 | 0) == (1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
     break label$2
    }
    memcpy($0 + 8 | 0 | 0, memcpy($2 | 0, $1 | 0, 192 | 0) | 0 | 0, 192 | 0) | 0;
    $1 = 0;
    break label$1;
   }
   $1 = memcpy($2 | 0, $1 | 0, 64 | 0) | 0;
   memcpy($1 + 192 | 0 | 0, $1 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($1 + 192 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 416 | 0;
 }
 
 function cardano_serialization_lib__PoolRegistration__from_bytes__h21d577eb7247b80d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $14 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 416 | 0;
  global$0 = $2;
  HEAP32[($2 + 408 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 392 | 0) >> 2] = 0;
  HEAP32[($2 + 396 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 400 | 0) >> 2] = $14;
  HEAP32[($2 + 404 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__PoolRegistration___deserialize__h3eddb2951658b6f3($2 + 192 | 0 | 0, $2 + 392 | 0 | 0);
  $1 = ($2 + 392 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = ($2 + 192 | 0) + 8 | 0;
  label$1 : {
   label$2 : {
    i64toi32_i32$1 = HEAP32[($2 + 192 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 196 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    if ((i64toi32_i32$2 | 0) == (1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
     break label$2
    }
    memcpy($0 + 8 | 0 | 0, memcpy($2 | 0, $1 | 0, 192 | 0) | 0 | 0, 192 | 0) | 0;
    $1 = 0;
    break label$1;
   }
   $1 = memcpy($2 | 0, $1 | 0, 64 | 0) | 0;
   memcpy($1 + 192 | 0 | 0, $1 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($1 + 192 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 416 | 0;
 }
 
 function cardano_serialization_lib__MoveInstantaneousRewardsCert__from_bytes__hf98f7f9887bd6e00($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $14 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  HEAP32[($2 + 152 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 136 | 0) >> 2] = 0;
  HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 144 | 0) >> 2] = $14;
  HEAP32[($2 + 148 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__MoveInstantaneousRewardsCert___deserialize__h5080adfd24aaf632($2 + 64 | 0 | 0, $2 + 136 | 0 | 0);
  $1 = ($2 + 136 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = ($2 + 64 | 0) + 8 | 0;
  label$1 : {
   label$2 : {
    i64toi32_i32$1 = HEAP32[($2 + 64 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 68 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    if ((i64toi32_i32$2 | 0) == (1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
     break label$2
    }
    memcpy($0 + 8 | 0 | 0, memcpy($2 | 0, $1 | 0, 56 | 0) | 0 | 0, 56 | 0) | 0;
    $1 = 0;
    break label$1;
   }
   $1 = memcpy($2 | 0, $1 | 0, 64 | 0) | 0;
   memcpy($1 + 64 | 0 | 0, $1 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($1 + 64 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 160 | 0;
 }
 
 function cardano_serialization_lib__MIRToStakeCredentials__from_bytes__h131d0cb12d9cfeb8($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $14 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  HEAP32[($2 + 152 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 136 | 0) >> 2] = 0;
  HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 144 | 0) >> 2] = $14;
  HEAP32[($2 + 148 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__MIRToStakeCredentials___deserialize__h4513cde789c99a1f($2 + 64 | 0 | 0, $2 + 136 | 0 | 0);
  $1 = ($2 + 136 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = ($2 + 64 | 0) + 8 | 0;
  label$1 : {
   label$2 : {
    i64toi32_i32$1 = HEAP32[($2 + 64 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 68 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    if ((i64toi32_i32$2 | 0) == (1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
     break label$2
    }
    memcpy($0 + 8 | 0 | 0, memcpy($2 | 0, $1 | 0, 40 | 0) | 0 | 0, 40 | 0) | 0;
    $1 = 0;
    break label$1;
   }
   $1 = memcpy($2 | 0, $1 | 0, 64 | 0) | 0;
   memcpy($1 + 64 | 0 | 0, $1 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($1 + 64 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 160 | 0;
 }
 
 function cardano_serialization_lib__MoveInstantaneousReward__from_bytes__h85f8bfaa9b536645($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $14 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  HEAP32[($2 + 152 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 136 | 0) >> 2] = 0;
  HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 144 | 0) >> 2] = $14;
  HEAP32[($2 + 148 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__MoveInstantaneousReward___deserialize__h01d321bfaafb2a23($2 + 64 | 0 | 0, $2 + 136 | 0 | 0);
  $1 = ($2 + 136 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = ($2 + 64 | 0) + 8 | 0;
  label$1 : {
   label$2 : {
    i64toi32_i32$1 = HEAP32[($2 + 64 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 68 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    if ((i64toi32_i32$2 | 0) == (1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
     break label$2
    }
    memcpy($0 + 8 | 0 | 0, memcpy($2 | 0, $1 | 0, 56 | 0) | 0 | 0, 56 | 0) | 0;
    $1 = 0;
    break label$1;
   }
   $1 = memcpy($2 | 0, $1 | 0, 64 | 0) | 0;
   memcpy($1 + 64 | 0 | 0, $1 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($1 + 64 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 160 | 0;
 }
 
 function cardano_serialization_lib__Withdrawals__from_bytes__h7372f1b0a0627994($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $14 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  HEAP32[($2 + 152 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 136 | 0) >> 2] = 0;
  HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 144 | 0) >> 2] = $14;
  HEAP32[($2 + 148 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__Withdrawals___deserialize__h7582bde99e83c579($2 + 64 | 0 | 0, $2 + 136 | 0 | 0);
  $1 = ($2 + 136 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = ($2 + 64 | 0) + 8 | 0;
  label$1 : {
   label$2 : {
    i64toi32_i32$1 = HEAP32[($2 + 64 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 68 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    if ((i64toi32_i32$2 | 0) == (1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
     break label$2
    }
    memcpy($0 + 8 | 0 | 0, memcpy($2 | 0, $1 | 0, 40 | 0) | 0 | 0, 40 | 0) | 0;
    $1 = 0;
    break label$1;
   }
   $1 = memcpy($2 | 0, $1 | 0, 64 | 0) | 0;
   memcpy($1 + 64 | 0 | 0, $1 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($1 + 64 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 160 | 0;
 }
 
 function cardano_serialization_lib__Update__from_bytes__haadf389624051209($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $14 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  HEAP32[($2 + 152 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 136 | 0) >> 2] = 0;
  HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 144 | 0) >> 2] = $14;
  HEAP32[($2 + 148 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__Update___deserialize__h5a4f342350ad0ea2($2 + 64 | 0 | 0, $2 + 136 | 0 | 0);
  $1 = ($2 + 136 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = ($2 + 64 | 0) + 8 | 0;
  label$1 : {
   label$2 : {
    i64toi32_i32$1 = HEAP32[($2 + 64 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 68 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    if ((i64toi32_i32$2 | 0) == (1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
     break label$2
    }
    memcpy($0 + 8 | 0 | 0, memcpy($2 | 0, $1 | 0, 48 | 0) | 0 | 0, 48 | 0) | 0;
    $1 = 0;
    break label$1;
   }
   $1 = memcpy($2 | 0, $1 | 0, 64 | 0) | 0;
   memcpy($1 + 64 | 0 | 0, $1 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($1 + 64 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 160 | 0;
 }
 
 function cardano_serialization_lib__ProposedProtocolParameterUpdates__from_bytes__h490fdca9254b1788($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $14 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  HEAP32[($2 + 152 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 136 | 0) >> 2] = 0;
  HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 144 | 0) >> 2] = $14;
  HEAP32[($2 + 148 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__ProposedProtocolParameterUpdates___deserialize__heb1e36bac95b3b52($2 + 64 | 0 | 0, $2 + 136 | 0 | 0);
  $1 = ($2 + 136 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = ($2 + 64 | 0) + 8 | 0;
  label$1 : {
   label$2 : {
    i64toi32_i32$1 = HEAP32[($2 + 64 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 68 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    if ((i64toi32_i32$2 | 0) == (1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
     break label$2
    }
    memcpy($0 + 8 | 0 | 0, memcpy($2 | 0, $1 | 0, 40 | 0) | 0 | 0, 40 | 0) | 0;
    $1 = 0;
    break label$1;
   }
   $1 = memcpy($2 | 0, $1 | 0, 64 | 0) | 0;
   memcpy($1 + 64 | 0 | 0, $1 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($1 + 64 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 160 | 0;
 }
 
 function proposedprotocolparameterupdates_get($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, $4 = 0, $4$hi = 0;
  $2 = global$0 - 832 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h2d6285fb6a1d44f8($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h7b8fe8d9d71033fc($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__ProposedProtocolParameterUpdates__get__h44ec3d3b4f1a7a88($2 + 16 | 0 | 0, $3 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   $0 = 0;
   label$2 : {
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
    $4 = i64toi32_i32$0;
    $4$hi = i64toi32_i32$1;
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    if ((i64toi32_i32$2 | 0) == (2 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
     break label$2
    }
    i64toi32_i32$2 = $4$hi;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 424 | 0) >> 2] = $4;
    HEAP32[($2 + 428 | 0) >> 2] = i64toi32_i32$2;
    memcpy(($2 + 424 | 0) + 8 | 0 | 0, ($2 + 16 | 0) + 8 | 0 | 0, 400 | 0) | 0;
    $0 = $cardano_serialization_lib__ProtocolParamUpdate_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hd784927b58be35b6($2 + 424 | 0 | 0) | 0;
   }
   global$0 = $2 + 832 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function cardano_serialization_lib__ProtocolParamUpdate__from_bytes__h21b4eb9c10beb44b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $14 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 848 | 0;
  global$0 = $2;
  HEAP32[($2 + 840 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 824 | 0) >> 2] = 0;
  HEAP32[($2 + 828 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 832 | 0) >> 2] = $14;
  HEAP32[($2 + 836 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__ProtocolParamUpdate___deserialize__hcf5b8de9802712c3($2 + 408 | 0 | 0, $2 + 824 | 0 | 0);
  $1 = ($2 + 824 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = ($2 + 408 | 0) + 8 | 0;
  label$1 : {
   label$2 : {
    i64toi32_i32$1 = HEAP32[($2 + 408 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 412 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    if ((i64toi32_i32$2 | 0) == (1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
     break label$2
    }
    memcpy($0 + 8 | 0 | 0, memcpy($2 | 0, $1 | 0, 408 | 0) | 0 | 0, 408 | 0) | 0;
    $1 = 0;
    break label$1;
   }
   $1 = memcpy($2 | 0, $1 | 0, 64 | 0) | 0;
   memcpy($1 + 408 | 0 | 0, $1 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($1 + 408 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 848 | 0;
 }
 
 function cardano_serialization_lib__Block__from_bytes__ha89b6920433bc7f2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $14 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 848 | 0;
  global$0 = $2;
  HEAP32[($2 + 840 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 824 | 0) >> 2] = 0;
  HEAP32[($2 + 828 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 832 | 0) >> 2] = $14;
  HEAP32[($2 + 836 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__Block___deserialize__hff84de1840b80cac($2 + 408 | 0 | 0, $2 + 824 | 0 | 0);
  $1 = ($2 + 824 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = ($2 + 408 | 0) + 8 | 0;
  label$1 : {
   label$2 : {
    i64toi32_i32$1 = HEAP32[($2 + 408 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 412 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    if ((i64toi32_i32$2 | 0) == (1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
     break label$2
    }
    memcpy($0 + 8 | 0 | 0, memcpy($2 | 0, $1 | 0, 408 | 0) | 0 | 0, 408 | 0) | 0;
    $1 = 0;
    break label$1;
   }
   $1 = memcpy($2 | 0, $1 | 0, 64 | 0) | 0;
   memcpy($1 + 408 | 0 | 0, $1 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($1 + 408 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 848 | 0;
 }
 
 function cardano_serialization_lib__Header__from_bytes__hbe7b02e3b3b339ad($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $14 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 688 | 0;
  global$0 = $2;
  HEAP32[($2 + 680 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 664 | 0) >> 2] = 0;
  HEAP32[($2 + 668 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 672 | 0) >> 2] = $14;
  HEAP32[($2 + 676 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__Header___deserialize__hdf156fa217230f38($2 + 328 | 0 | 0, $2 + 664 | 0 | 0);
  $1 = ($2 + 664 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = ($2 + 328 | 0) + 8 | 0;
  label$1 : {
   label$2 : {
    i64toi32_i32$1 = HEAP32[($2 + 328 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 332 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    if ((i64toi32_i32$2 | 0) == (1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
     break label$2
    }
    memcpy($0 + 8 | 0 | 0, memcpy($2 | 0, $1 | 0, 328 | 0) | 0 | 0, 328 | 0) | 0;
    $1 = 0;
    break label$1;
   }
   $1 = memcpy($2 | 0, $1 | 0, 64 | 0) | 0;
   memcpy($1 + 328 | 0 | 0, $1 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($1 + 328 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 688 | 0;
 }
 
 function operationalcert_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 240 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 120 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 120 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 124 | 0) >> 2] | 0;
  HEAP32[($2 + 136 | 0) >> 2] = HEAP32[($2 + 120 | 0) >> 2] | 0;
  HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__OperationalCert__from_bytes__hcdb92a2779b09d56($2 + 8 | 0 | 0, $2 + 136 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  HEAP32[($2 + 136 | 0) >> 2] = $1;
  memcpy($2 + 136 | 0 | 4 | 0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 100 | 0) | 0;
  $1 = $cardano_serialization_lib__OperationalCert_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h6c0829dce15a5d37($2 + 136 | 0 | 0) | 0;
  global$0 = $2 + 240 | 0;
  return $1 | 0;
 }
 
 function cardano_serialization_lib__HeaderBody__from_bytes__h3a4e292fbb6b6511($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $14 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 656 | 0;
  global$0 = $2;
  HEAP32[($2 + 648 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 632 | 0) >> 2] = 0;
  HEAP32[($2 + 636 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 640 | 0) >> 2] = $14;
  HEAP32[($2 + 644 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__Deserialize_20for_20cardano_serialization_lib__HeaderBody___deserialize__hca688f096fd630fa($2 + 312 | 0 | 0, $2 + 632 | 0 | 0);
  $1 = ($2 + 632 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = ($2 + 312 | 0) + 8 | 0;
  label$1 : {
   label$2 : {
    i64toi32_i32$1 = HEAP32[($2 + 312 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 316 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    if ((i64toi32_i32$2 | 0) == (1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
     break label$2
    }
    memcpy($0 + 8 | 0 | 0, memcpy($2 | 0, $1 | 0, 312 | 0) | 0 | 0, 312 | 0) | 0;
    $1 = 0;
    break label$1;
   }
   $1 = memcpy($2 | 0, $1 | 0, 64 | 0) | 0;
   memcpy($1 + 312 | 0 | 0, $1 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($1 + 312 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 656 | 0;
 }
 
 function cardano_serialization_lib__utils__TransactionUnspentOutput__from_bytes__h28c90e81bd2fe0dc($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $14 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 368 | 0;
  global$0 = $2;
  HEAP32[($2 + 360 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 344 | 0) >> 2] = 0;
  HEAP32[($2 + 348 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 352 | 0) >> 2] = $14;
  HEAP32[($2 + 356 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__utils__TransactionUnspentOutput_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h529cf0452d59832b($2 + 168 | 0 | 0, $2 + 344 | 0 | 0);
  $1 = ($2 + 344 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = ($2 + 168 | 0) + 8 | 0;
  label$1 : {
   label$2 : {
    i64toi32_i32$1 = HEAP32[($2 + 168 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 172 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    if ((i64toi32_i32$2 | 0) == (1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
     break label$2
    }
    memcpy($0 + 8 | 0 | 0, memcpy($2 | 0, $1 | 0, 168 | 0) | 0 | 0, 168 | 0) | 0;
    $1 = 0;
    break label$1;
   }
   $1 = memcpy($2 | 0, $1 | 0, 64 | 0) | 0;
   memcpy($1 + 168 | 0 | 0, $1 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($1 + 168 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 368 | 0;
 }
 
 function cardano_serialization_lib__utils__BigInt__as_u64__h39047f01ff5b286b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, $4$hi = 0, i64toi32_i32$2 = 0, $5 = 0, $5$hi = 0, $3 = 0, $31 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  $3 = HEAPU8[($1 + 12 | 0) >> 0] | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h7a0ed8a251b429e6($2 + 8 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$1;
  HEAP32[($2 + 40 | 0) >> 2] = 2;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $4;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__h699867d552ef4144($2 + 16 | 0 | 4 | 0 | 0, $2 + 32 | 0 | 0);
  HEAP32[($2 + 40 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  $31 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $31;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if (!$3) {
        break label$5
       }
       i64toi32_i32$0 = 0;
       $4 = 0;
       $4$hi = i64toi32_i32$0;
       switch (HEAP32[($2 + 40 | 0) >> 2] | 0 | 0) {
       case 1:
        break label$3;
       case 0:
        break label$4;
       default:
        break label$2;
       };
      }
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hbadab170a9e9861d($2 + 32 | 0 | 0);
      i64toi32_i32$0 = 0;
      $4 = 0;
      $4$hi = i64toi32_i32$0;
      break label$1;
     }
     i64toi32_i32$0 = 0;
     $4 = 1;
     $4$hi = i64toi32_i32$0;
     i64toi32_i32$0 = 0;
     $5 = 0;
     $5$hi = i64toi32_i32$0;
     break label$2;
    }
    i64toi32_i32$2 = HEAP32[($2 + 32 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $5 = i64toi32_i32$0;
    $5$hi = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    $4 = 1;
    $4$hi = i64toi32_i32$1;
   }
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hbadab170a9e9861d($2 + 32 | 0 | 0);
  }
  i64toi32_i32$1 = $5$hi;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $5;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $4$hi;
  HEAP32[i64toi32_i32$0 >> 2] = $4;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $2 + 48 | 0;
 }
 
 function cardano_serialization_lib__metadata__MetadataMap__from_bytes__h7e94b112c87f5db5($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $14 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  HEAP32[($2 + 152 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 136 | 0) >> 2] = 0;
  HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 144 | 0) >> 2] = $14;
  HEAP32[($2 + 148 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__metadata__MetadataMap_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h8f4b3182d8f5ec31($2 + 64 | 0 | 0, $2 + 136 | 0 | 0);
  $1 = ($2 + 136 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = ($2 + 64 | 0) + 8 | 0;
  label$1 : {
   label$2 : {
    i64toi32_i32$1 = HEAP32[($2 + 64 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 68 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    if ((i64toi32_i32$2 | 0) == (1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
     break label$2
    }
    memcpy($0 + 8 | 0 | 0, memcpy($2 | 0, $1 | 0, 40 | 0) | 0 | 0, 40 | 0) | 0;
    $1 = 0;
    break label$1;
   }
   $1 = memcpy($2 | 0, $1 | 0, 64 | 0) | 0;
   memcpy($1 + 64 | 0 | 0, $1 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($1 + 64 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 160 | 0;
 }
 
 function cardano_serialization_lib__metadata__GeneralTransactionMetadata__from_bytes__hb0b811957e7d516c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $14 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  HEAP32[($2 + 152 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 136 | 0) >> 2] = 0;
  HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 144 | 0) >> 2] = $14;
  HEAP32[($2 + 148 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__metadata__GeneralTransactionMetadata_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h2cbfe28ae9769528($2 + 64 | 0 | 0, $2 + 136 | 0 | 0);
  $1 = ($2 + 136 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = ($2 + 64 | 0) + 8 | 0;
  label$1 : {
   label$2 : {
    i64toi32_i32$1 = HEAP32[($2 + 64 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 68 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    if ((i64toi32_i32$2 | 0) == (1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
     break label$2
    }
    memcpy($0 + 8 | 0 | 0, memcpy($2 | 0, $1 | 0, 40 | 0) | 0 | 0, 40 | 0) | 0;
    $1 = 0;
    break label$1;
   }
   $1 = memcpy($2 | 0, $1 | 0, 64 | 0) | 0;
   memcpy($1 + 64 | 0 | 0, $1 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($1 + 64 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 160 | 0;
 }
 
 function generaltransactionmetadata_get($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h670b86b1bfb2242f($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__metadata__GeneralTransactionMetadata__get__h0ea75f89e237b87a($2 + 16 | 0 | 0, $3 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   $0 = 0;
   label$2 : {
    $1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
    if (($1 | 0) == (5 | 0)) {
     break label$2
    }
    HEAP32[($2 + 64 | 0) >> 2] = $1;
    memcpy($2 + 64 | 0 | 4 | 0 | 0, $2 + 16 | 0 | 4 | 0 | 0, 44 | 0) | 0;
    $0 = $cardano_serialization_lib__metadata__TransactionMetadatum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hce2feba55b67d086($2 + 64 | 0 | 0) | 0;
   }
   global$0 = $2 + 112 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function core__ops__function__impls___impl_20core__ops__function__FnMut_A__20for_20_mut_20F___call_mut__h0861d99072db3ec1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0, $5 = 0, $34 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   $3 = HEAP32[$0 >> 2] | 0;
   $4 = HEAP32[(HEAP32[($3 + 4 | 0) >> 2] | 0) >> 2] | 0;
   $5 = HEAP32[($4 + 8 | 0) >> 2] | 0;
   $0 = HEAP32[(HEAP32[$1 >> 2] | 0) >> 2] | 0;
   if ($5 >>> 0 <= $0 >>> 0) {
    break label$1
   }
   label$2 : {
    label$3 : {
     $0 = (HEAP32[$4 >> 2] | 0) + Math_imul($0, 168) | 0;
     if ((HEAP32[($0 + 72 | 0) >> 2] | 0 | 0) != (1 | 0)) {
      break label$3
     }
     $34 = $0 + 76 | 0;
     $0 = HEAP32[$3 >> 2] | 0;
     cardano_serialization_lib__MultiAsset__get__had0c36a2c855d776($2 + 16 | 0 | 0, $34 | 0, HEAP32[(HEAP32[$0 >> 2] | 0) >> 2] | 0 | 0);
     if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
      break label$3
     }
     HEAP32[($2 + 8 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
     HEAP32[$2 >> 2] = HEAP32[($2 + 20 | 0) >> 2] | 0;
     HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$1;
     $0 = (alloc__collections__btree__map__BTreeMap_K_2cV___get__h825f34112f7eacbf($2 | 0, HEAP32[(HEAP32[($0 + 4 | 0) >> 2] | 0) >> 2] | 0 | 0) | 0 | 0) != (0 | 0);
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h6c9f94f0f82ce2b5($2 | 0);
     break label$2;
    }
    $0 = 0;
   }
   global$0 = $2 + 32 | 0;
   return $0 | 0;
  }
  core__panicking__panic_bounds_check__h808b524af17640b1($0 | 0, $5 | 0, 1065056 | 0);
  abort();
 }
 
 function transactionbuilder_set_mint($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $5 = 0, $4 = 0, $6 = 0;
  $3 = global$0 - 32 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h5566e1c7d4aafe35($3 + 24 | 0 | 0, $0 | 0);
    if (!$1) {
     break label$2
    }
    $4 = HEAP32[($3 + 28 | 0) >> 2] | 0;
    $5 = HEAP32[($3 + 24 | 0) >> 2] | 0;
    wasm_bindgen____rt__WasmRefCell_T___borrow__h8348e40d8f63e5f1($3 + 16 | 0 | 0, $1 | 0);
    if (!$2) {
     break label$2
    }
    $0 = HEAP32[($3 + 20 | 0) >> 2] | 0;
    $6 = HEAP32[($3 + 16 | 0) >> 2] | 0;
    wasm_bindgen____rt__WasmRefCell_T___borrow__hbfc7b2ba05921680($3 + 8 | 0 | 0, $2 | 0);
    $1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
    cardano_serialization_lib__tx_builder__TransactionBuilder__set_mint__hd1a253bf30504cb0($3 | 0, $5 | 0, $6 | 0, HEAP32[($3 + 8 | 0) >> 2] | 0 | 0);
    $5 = HEAP32[($3 + 4 | 0) >> 2] | 0;
    $2 = HEAP32[$3 >> 2] | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($4 | 0, 0 | 0) | 0;
    if ($2) {
     break label$1
    }
    global$0 = $3 + 32 | 0;
    return;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472($5 | 0);
  abort();
 }
 
 function transactionbuilder_set_script_data_hash($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $2 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $4 = 0, $3 = 0, $31 = 0, $5 = 0, $5$hi = 0, $6 = 0, $6$hi = 0, $44 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h5566e1c7d4aafe35($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h6b7eaec1bcfb1ff8($2 | 0, $1 | 0);
   $4 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $1 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$2 = $1;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $31 = i64toi32_i32$0;
   i64toi32_i32$0 = $0 + 481 | 0;
   $14 = $31;
   HEAP8[i64toi32_i32$0 >> 0] = $14;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $14 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $14 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $14 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $5 = i64toi32_i32$1;
   $5$hi = i64toi32_i32$0;
   i64toi32_i32$2 = $1 + 16 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $6 = i64toi32_i32$0;
   $6$hi = i64toi32_i32$1;
   i64toi32_i32$2 = $1 + 24 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[($0 + 480 | 0) >> 0] = 1;
   $44 = i64toi32_i32$1;
   i64toi32_i32$1 = $0 + 505 | 0;
   $15 = $44;
   HEAP8[i64toi32_i32$1 >> 0] = $15;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $15 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $15 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $15 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$0 = $6$hi;
   i64toi32_i32$1 = $0 + 497 | 0;
   $16 = $6;
   HEAP8[i64toi32_i32$1 >> 0] = $16;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $16 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $16 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $16 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$0 = $5$hi;
   i64toi32_i32$1 = $0 + 489 | 0;
   $17 = $5;
   HEAP8[i64toi32_i32$1 >> 0] = $17;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($4 | 0, (HEAP32[$4 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function cardano_serialization_lib__crypto__PrivateKey__as_bytes__ha195925edbe0b49d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $5 = 0, $13 = 0, $14 = 0, $15 = 0, $16 = 0, $3 = 0, $4 = 0, $35 = 0, $40 = 0, $45 = 0, $48 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if ((HEAPU8[$1 >> 0] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $3 = 64;
    alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 + 8 | 0 | 0, 64 | 0, 0 | 0);
    $4 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $5 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    HEAP32[$0 >> 2] = $5;
    memcpy($5 | 0, $1 + 1 | 0 | 0, 64 | 0) | 0;
    break label$1;
   }
   $3 = 32;
   alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 32 | 0, 0 | 0);
   $4 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $5 = HEAP32[$2 >> 2] | 0;
   HEAP32[$0 >> 2] = $5;
   i64toi32_i32$2 = $1 + 9 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $35 = i64toi32_i32$0;
   i64toi32_i32$0 = $5 + 8 | 0;
   $13 = $35;
   HEAP8[i64toi32_i32$0 >> 0] = $13;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $13 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $13 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $13 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = $1 + 17 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $40 = i64toi32_i32$1;
   i64toi32_i32$1 = $5 + 16 | 0;
   $14 = $40;
   HEAP8[i64toi32_i32$1 >> 0] = $14;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $14 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $14 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $14 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $1 + 25 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $45 = i64toi32_i32$0;
   i64toi32_i32$0 = $5 + 24 | 0;
   $15 = $45;
   HEAP8[i64toi32_i32$0 >> 0] = $15;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $15 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $15 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $15 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $48 = i64toi32_i32$1;
   i64toi32_i32$1 = $5;
   $16 = $48;
   HEAP8[i64toi32_i32$1 >> 0] = $16;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $16 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $16 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $16 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  }
  HEAP32[($0 + 8 | 0) >> 2] = $3;
  HEAP32[($0 + 4 | 0) >> 2] = $4;
  global$0 = $2 + 16 | 0;
 }
 
 function bip32privatekey_to_bech32($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $37 = 0, $49 = 0, $55 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h30021c0122a7c8e6($2 + 24 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $ed25519_bip32__key__XPrv_20as_20core__convert__AsRef__5bu8_5d____as_ref__h44c8f06901e0335a($2 + 16 | 0 | 0, HEAP32[($2 + 24 | 0) >> 2] | 0 | 0);
  cardano_serialization_lib__chain_crypto__bech32__to_bech32_from_bytes__hd3bebea1c04f6297($2 + 32 | 0 | 0, HEAP32[($2 + 16 | 0) >> 2] | 0 | 0, HEAP32[($2 + 20 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  $1 = ($2 + 48 | 0) + 8 | 0;
  HEAP32[$1 >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $37 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $37;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $2 + 48 | 0 | 0);
  HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $49 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 64 | 0) >> 2] = $49;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 64 | 0 | 0);
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $55 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $55;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $2 + 80 | 0;
 }
 
 function bip32publickey_to_bech32($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $37 = 0, $49 = 0, $55 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hcfcf2a638924fc64($2 + 24 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $ed25519_bip32__key__XPub_20as_20core__convert__AsRef__5bu8_5d____as_ref__h69a664c2b5ee8b25($2 + 16 | 0 | 0, HEAP32[($2 + 24 | 0) >> 2] | 0 | 0);
  cardano_serialization_lib__chain_crypto__bech32__to_bech32_from_bytes__hd6d2d8f511656726($2 + 32 | 0 | 0, HEAP32[($2 + 16 | 0) >> 2] | 0 | 0, HEAP32[($2 + 20 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  $1 = ($2 + 48 | 0) + 8 | 0;
  HEAP32[$1 >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $37 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $37;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $2 + 48 | 0 | 0);
  HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $49 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 64 | 0) >> 2] = $49;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 64 | 0 | 0);
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $55 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $55;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $2 + 80 | 0;
 }
 
 function publickey_verify($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $6 = 0, $5 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h67eb974eba5bb4b0($4 + 16 | 0 | 0, $0 | 0);
   $0 = HEAP32[($4 + 20 | 0) >> 2] | 0;
   $5 = HEAP32[($4 + 16 | 0) >> 2] | 0;
   HEAP32[($4 + 40 | 0) >> 2] = $2;
   HEAP32[($4 + 36 | 0) >> 2] = $2;
   HEAP32[($4 + 32 | 0) >> 2] = $1;
   alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($4 + 8 | 0 | 0, $4 + 32 | 0 | 0);
   $1 = HEAP32[($4 + 12 | 0) >> 2] | 0;
   HEAP32[($4 + 28 | 0) >> 2] = $1;
   $6 = HEAP32[($4 + 8 | 0) >> 2] | 0;
   HEAP32[($4 + 24 | 0) >> 2] = $6;
   if (!$3) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hd6fdee4274fe58a2($4 | 0, $3 | 0);
   $2 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   $3 = cryptoxide__ed25519__verify__h8af691346ab1c748($6 | 0, $1 | 0, $5 | 0, HEAP32[$4 >> 2] | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__ptr__drop_in_place_alloc__boxed__Box__5bu8_5d____h1049615268b5f7c4($4 + 24 | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   global$0 = $4 + 48 | 0;
   return $3 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function bootstrapwitness_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 272 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 136 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 152 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 136 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 140 | 0) >> 2] | 0;
  HEAP32[($2 + 152 | 0) >> 2] = HEAP32[($2 + 136 | 0) >> 2] | 0;
  HEAP32[($2 + 156 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__crypto__BootstrapWitness__from_bytes__h8e912dadc9ea1fd5($2 + 8 | 0 | 0, $2 + 152 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  HEAP32[($2 + 152 | 0) >> 2] = $1;
  memcpy($2 + 152 | 0 | 4 | 0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 116 | 0) | 0;
  $1 = $cardano_serialization_lib__crypto__BootstrapWitness_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hcc8c8e7beca3e936($2 + 152 | 0 | 0) | 0;
  global$0 = $2 + 272 | 0;
  return $1 | 0;
 }
 
 function alloc__vec__source_iter_marker___impl_20alloc__vec__spec_from_iter__SpecFromIter_T_2cI__20for_20alloc__vec__Vec_T____from_iter__hd552edaa5a6894ae($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, $5 = 0, i64toi32_i32$1 = 0, $4 = 0, i64toi32_i32$2 = 0, $3 = 0, $6 = 0, $2 = 0, $8 = 0, $8$hi = 0, $9 = 0, $9$hi = 0, $35 = 0;
  $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $3 = HEAP32[$1 >> 2] | 0;
  $4 = $3;
  label$1 : {
   $5 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   $6 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   if (($5 | 0) == ($6 | 0)) {
    break label$1
   }
   $4 = $3;
   label$2 : {
    label$3 : {
     label$4 : while (1) {
      if ((HEAPU8[$5 >> 0] | 0 | 0) == (6 | 0)) {
       break label$3
      }
      i64toi32_i32$2 = $5 + 8 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $8 = i64toi32_i32$0;
      $8$hi = i64toi32_i32$1;
      i64toi32_i32$2 = $5;
      i64toi32_i32$1 = HEAP32[$5 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($5 + 4 | 0) >> 2] | 0;
      $9 = i64toi32_i32$1;
      $9$hi = i64toi32_i32$0;
      i64toi32_i32$2 = $5 + 16 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      $35 = i64toi32_i32$0;
      i64toi32_i32$0 = $4 + 16 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $35;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$1 = $8$hi;
      i64toi32_i32$0 = $4 + 8 | 0;
      HEAP32[i64toi32_i32$0 >> 2] = $8;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$1 = $9$hi;
      i64toi32_i32$0 = $4;
      HEAP32[i64toi32_i32$0 >> 2] = $9;
      HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
      $4 = i64toi32_i32$0 + 24 | 0;
      $5 = $5 + 24 | 0;
      if (($6 | 0) != ($5 | 0)) {
       continue label$4
      }
      break label$2;
     };
    }
    $6 = $5 + 24 | 0;
   }
   HEAP32[($1 + 8 | 0) >> 2] = $6;
  }
  alloc__vec__into_iter__IntoIter_T_2cA___forget_allocation_drop_remaining__hb86bfc3064fd3d0f($1 | 0);
  HEAP32[($0 + 4 | 0) >> 2] = $2;
  HEAP32[$0 >> 2] = $3;
  HEAP32[($0 + 8 | 0) >> 2] = ($4 - $3 | 0 | 0) / (24 | 0) | 0;
  $alloc__vec__into_iter__IntoIter_T_2cA__20as_20core__ops__drop__Drop___drop__hc4501e140b1d6e18($1 | 0);
 }
 
 function $cardano_serialization_lib__plutus__PlutusScript_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h6cd9666f62b56459($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, $3 = 0;
  $2 = global$0 - 96 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___bytes__hc697ccccfa39fd82($2 + 48 | 0 | 0, $1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 48 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[(($2 + 48 | 0) + 12 | 0) >> 2] | 0;
    HEAP32[($2 + 8 | 0) >> 2] = $1;
    i64toi32_i32$1 = HEAP32[($2 + 56 | 0) >> 2] | 0;
    $3 = HEAP32[($2 + 52 | 0) >> 2] | 0;
    HEAP32[$2 >> 2] = $3;
    HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($0 + 12 | 0) >> 2] = $1;
    HEAP32[($0 + 4 | 0) >> 2] = $3;
    HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$1;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 55 | 0 | 0, memcpy($2 | 4 | 0 | 0, ($2 + 48 | 0) + 8 | 0 | 0, 40 | 0) | 0 | 0, 40 | 0) | 0;
   HEAP8[($0 + 8 | 0) >> 0] = 2;
   HEAP32[($0 + 56 | 0) >> 2] = 0;
   memcpy($0 + 9 | 0 | 0, $2 + 48 | 0 | 0, 47 | 0) | 0;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 96 | 0;
 }
 
 function $cardano_serialization_lib__plutus__CostModel_20as_20cbor_event__se__Serialize___serialize__h29052229a88c8bb1($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, $5 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, 166 | 0, 0 | 0);
  $4 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     label$4 : {
      $5 = HEAP32[($1 + 8 | 0) >> 2] | 0;
      if (!($5 << 4 | 0)) {
       break label$4
      }
      $4 = HEAP32[$1 >> 2] | 0;
      $1 = $5 << 4 | 0;
      label$5 : while (1) {
       $cardano_serialization_lib__utils__Int_20as_20cbor_event__se__Serialize___serialize__h52978cec14c40013($3 | 0, $4 | 0, $2 | 0);
       if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
        break label$2
       }
       $4 = $4 + 16 | 0;
       $1 = $1 + -16 | 0;
       if ($1) {
        continue label$5
       }
       break label$5;
      };
     }
     HEAP32[($0 + 4 | 0) >> 2] = $2;
     $4 = 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $4 = 1;
  }
  HEAP32[$0 >> 2] = $4;
  global$0 = $3 + 48 | 0;
 }
 
 function plutusmap_get($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hc838c9a2ed8b7fab($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb1fd14a6870cafe2($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__plutus__PlutusMap__get__hbb93cba378f24205($2 + 16 | 0 | 0, $3 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   $0 = 0;
   label$2 : {
    $1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
    if (($1 | 0) == (5 | 0)) {
     break label$2
    }
    HEAP32[($2 + 64 | 0) >> 2] = $1;
    memcpy($2 + 64 | 0 | 4 | 0 | 0, $2 + 16 | 0 | 4 | 0 | 0, 44 | 0) | 0;
    $0 = $cardano_serialization_lib__plutus__PlutusData_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h7393378a3318e0a5($2 + 64 | 0 | 0) | 0;
   }
   global$0 = $2 + 112 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function cardano_serialization_lib__plutus__PlutusData__from_bytes__hd00076d7310249c6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $14 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  HEAP32[($2 + 152 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 136 | 0) >> 2] = 0;
  HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 144 | 0) >> 2] = $14;
  HEAP32[($2 + 148 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__plutus__PlutusData_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__haa2b047fc7012f29($2 + 64 | 0 | 0, $2 + 136 | 0 | 0);
  $1 = ($2 + 136 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = ($2 + 64 | 0) + 8 | 0;
  label$1 : {
   label$2 : {
    i64toi32_i32$1 = HEAP32[($2 + 64 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 68 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    if ((i64toi32_i32$2 | 0) == (1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
     break label$2
    }
    memcpy($0 + 8 | 0 | 0, memcpy($2 | 0, $1 | 0, 48 | 0) | 0 | 0, 48 | 0) | 0;
    $1 = 0;
    break label$1;
   }
   $1 = memcpy($2 | 0, $1 | 0, 64 | 0) | 0;
   memcpy($1 + 64 | 0 | 0, $1 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($1 + 64 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 160 | 0;
 }
 
 function cardano_serialization_lib__plutus__Redeemer__from_bytes__hb7dd5e3124e925ff($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $14 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 192 | 0;
  global$0 = $2;
  HEAP32[($2 + 184 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 168 | 0) >> 2] = 0;
  HEAP32[($2 + 172 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 176 | 0) >> 2] = $14;
  HEAP32[($2 + 180 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__plutus__Redeemer_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h50e886ac76690234($2 + 80 | 0 | 0, $2 + 168 | 0 | 0);
  $1 = ($2 + 168 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = ($2 + 80 | 0) + 8 | 0;
  label$1 : {
   label$2 : {
    i64toi32_i32$1 = HEAP32[($2 + 80 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 84 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    if ((i64toi32_i32$2 | 0) == (1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
     break label$2
    }
    memcpy($0 + 8 | 0 | 0, memcpy($2 | 0, $1 | 0, 80 | 0) | 0 | 0, 80 | 0) | 0;
    $1 = 0;
    break label$1;
   }
   $1 = memcpy($2 | 0, $1 | 0, 64 | 0) | 0;
   memcpy($1 + 80 | 0 | 0, $1 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($1 + 80 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 192 | 0;
 }
 
 function serde_json__de__Deserializer_R___parse_long_integer__hf2c70827599d3466($0, $1, $2, $3, $3$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  var $4 = 0, $6 = 0, $5 = 0, i64toi32_i32$0 = 0, $7 = 0, $8 = 0;
  $4 = 0;
  label$1 : {
   label$2 : {
    $5 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $6 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    if ($5 >>> 0 <= $6 >>> 0) {
     break label$2
    }
    $7 = (HEAP32[$1 >> 2] | 0) + $6 | 0;
    $8 = $6 + 1 | 0;
    $5 = $5 - $6 | 0;
    $4 = 0;
    label$3 : while (1) {
     label$4 : {
      $6 = HEAPU8[($7 + $4 | 0) >> 0] | 0;
      if ((($6 + -48 | 0) & 255 | 0) >>> 0 < 10 >>> 0) {
       break label$4
      }
      if (($6 | 0) == (46 | 0)) {
       break label$1
      }
      label$5 : {
       if (($6 | 0) == (69 | 0)) {
        break label$5
       }
       if (($6 | 0) != (101 | 0)) {
        break label$2
       }
      }
      i64toi32_i32$0 = $3$hi;
      serde_json__de__Deserializer_R___parse_exponent__h64f12a2a919bb245($0 | 0, $1 | 0, $2 | 0, $3 | 0, i64toi32_i32$0 | 0, $4 | 0);
      return;
     }
     HEAP32[($1 + 8 | 0) >> 2] = $8 + $4 | 0;
     $4 = $4 + 1 | 0;
     if (($5 | 0) != ($4 | 0)) {
      continue label$3
     }
     break label$3;
    };
    $4 = $5;
   }
   i64toi32_i32$0 = $3$hi;
   serde_json__de__Deserializer_R___f64_from_parts__hb0108f153aa5786e($0 | 0, $1 | 0, $2 | 0, $3 | 0, i64toi32_i32$0 | 0, $4 | 0);
   return;
  }
  i64toi32_i32$0 = $3$hi;
  serde_json__de__Deserializer_R___parse_decimal__he7ea9ce3065727b6($0 | 0, $1 | 0, $2 | 0, $3 | 0, i64toi32_i32$0 | 0, $4 | 0);
 }
 
 function alloc__collections__btree__node__BalancingContext_K_2cV___merge_tracking_child_edge__h4d67870504cb06f4($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $4 = 0, $5 = 0, $6 = 0, $7 = 0, $36 = 0, $42 = 0, $45 = 0, $60 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0, wasm2js_i32$2 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  label$1 : {
   $5 = $1 + 24 | 0;
   $6 = $1 + 16 | 0;
   $7 = HEAPU16[((HEAP32[$6 >> 2] | 0) + 226 | 0) >> 1] | 0;
   if ((wasm2js_i32$0 = HEAPU16[((HEAP32[$5 >> 2] | 0) + 226 | 0) >> 1] | 0, wasm2js_i32$1 = $7, wasm2js_i32$2 = $2, wasm2js_i32$2 ? wasm2js_i32$0 : wasm2js_i32$1) >>> 0 < $3 >>> 0) {
    break label$1
   }
   HEAP32[(($4 + 16 | 0) + 24 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
   i64toi32_i32$2 = $6;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $36 = i64toi32_i32$0;
   i64toi32_i32$0 = ($4 + 16 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $36;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1 + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $42 = i64toi32_i32$1;
   i64toi32_i32$1 = ($4 + 16 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $42;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $1;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $45 = i64toi32_i32$0;
   i64toi32_i32$0 = $4;
   HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $45;
   HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$1;
   alloc__collections__btree__node__BalancingContext_K_2cV___do_merge__head87d19f7482344(i64toi32_i32$0 + 8 | 0 | 0, i64toi32_i32$0 + 16 | 0 | 0);
   i64toi32_i32$2 = i64toi32_i32$0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] | 0;
   HEAP32[($0 + 8 | 0) >> 2] = ($2 ? $7 + 1 | 0 : 0) + $3 | 0;
   $60 = i64toi32_i32$1;
   i64toi32_i32$1 = $0;
   HEAP32[i64toi32_i32$1 >> 2] = $60;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   global$0 = i64toi32_i32$2 + 48 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1049528 | 0, 145 | 0, 1049676 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__BalancingContext_K_2cV___merge_tracking_child_edge__hce68ab54ee2d92c2($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $4 = 0, $5 = 0, $6 = 0, $7 = 0, $36 = 0, $42 = 0, $45 = 0, $60 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0, wasm2js_i32$2 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  label$1 : {
   $5 = $1 + 24 | 0;
   $6 = $1 + 16 | 0;
   $7 = HEAPU16[((HEAP32[$6 >> 2] | 0) + 50 | 0) >> 1] | 0;
   if ((wasm2js_i32$0 = HEAPU16[((HEAP32[$5 >> 2] | 0) + 50 | 0) >> 1] | 0, wasm2js_i32$1 = $7, wasm2js_i32$2 = $2, wasm2js_i32$2 ? wasm2js_i32$0 : wasm2js_i32$1) >>> 0 < $3 >>> 0) {
    break label$1
   }
   HEAP32[(($4 + 16 | 0) + 24 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
   i64toi32_i32$2 = $6;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $36 = i64toi32_i32$0;
   i64toi32_i32$0 = ($4 + 16 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $36;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1 + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $42 = i64toi32_i32$1;
   i64toi32_i32$1 = ($4 + 16 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $42;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $1;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $45 = i64toi32_i32$0;
   i64toi32_i32$0 = $4;
   HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $45;
   HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$1;
   alloc__collections__btree__node__BalancingContext_K_2cV___do_merge__hc2870ff7477356f5(i64toi32_i32$0 + 8 | 0 | 0, i64toi32_i32$0 + 16 | 0 | 0);
   i64toi32_i32$2 = i64toi32_i32$0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] | 0;
   HEAP32[($0 + 8 | 0) >> 2] = ($2 ? $7 + 1 | 0 : 0) + $3 | 0;
   $60 = i64toi32_i32$1;
   i64toi32_i32$1 = $0;
   HEAP32[i64toi32_i32$1 >> 2] = $60;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   global$0 = i64toi32_i32$2 + 48 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1049528 | 0, 145 | 0, 1049676 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__BalancingContext_K_2cV___merge_tracking_child_edge__hd992b4e84bd3c8df($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $4 = 0, $5 = 0, $6 = 0, $7 = 0, $36 = 0, $42 = 0, $45 = 0, $60 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0, wasm2js_i32$2 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  label$1 : {
   $5 = $1 + 24 | 0;
   $6 = $1 + 16 | 0;
   $7 = HEAPU16[((HEAP32[$6 >> 2] | 0) + 138 | 0) >> 1] | 0;
   if ((wasm2js_i32$0 = HEAPU16[((HEAP32[$5 >> 2] | 0) + 138 | 0) >> 1] | 0, wasm2js_i32$1 = $7, wasm2js_i32$2 = $2, wasm2js_i32$2 ? wasm2js_i32$0 : wasm2js_i32$1) >>> 0 < $3 >>> 0) {
    break label$1
   }
   HEAP32[(($4 + 16 | 0) + 24 | 0) >> 2] = HEAP32[$5 >> 2] | 0;
   i64toi32_i32$2 = $6;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $36 = i64toi32_i32$0;
   i64toi32_i32$0 = ($4 + 16 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $36;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1 + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $42 = i64toi32_i32$1;
   i64toi32_i32$1 = ($4 + 16 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $42;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $1;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $45 = i64toi32_i32$0;
   i64toi32_i32$0 = $4;
   HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $45;
   HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$1;
   alloc__collections__btree__node__BalancingContext_K_2cV___do_merge__ha68544c15fd893a2(i64toi32_i32$0 + 8 | 0 | 0, i64toi32_i32$0 + 16 | 0 | 0);
   i64toi32_i32$2 = i64toi32_i32$0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] | 0;
   HEAP32[($0 + 8 | 0) >> 2] = ($2 ? $7 + 1 | 0 : 0) + $3 | 0;
   $60 = i64toi32_i32$1;
   i64toi32_i32$1 = $0;
   HEAP32[i64toi32_i32$1 >> 2] = $60;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   global$0 = i64toi32_i32$2 + 48 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1049528 | 0, 145 | 0, 1049676 | 0);
  abort();
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__TransactionInputs___serialize__h5d5370eb2688b5ac($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $5 = 0, $4 = 0, i64toi32_i32$0 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, $4 | 0, i64toi32_i32$0 | 0);
  $5 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     label$4 : {
      if (!$4) {
       break label$4
      }
      $5 = HEAP32[$1 >> 2] | 0;
      $1 = Math_imul($4, 36);
      label$5 : while (1) {
       cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__TransactionInput___serialize__h2e92835f336b9490($3 | 0, $5 | 0, $2 | 0);
       if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
        break label$2
       }
       $5 = $5 + 36 | 0;
       $1 = $1 + -36 | 0;
       if ($1) {
        continue label$5
       }
       break label$5;
      };
     }
     HEAP32[($0 + 4 | 0) >> 2] = $2;
     $5 = 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $5 = 1;
  }
  HEAP32[$0 >> 2] = $5;
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__TransactionOutputs___serialize__he3bf8aa07ee2fe6d($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $5 = 0, $4 = 0, i64toi32_i32$0 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, $4 | 0, i64toi32_i32$0 | 0);
  $5 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     label$4 : {
      if (!$4) {
       break label$4
      }
      $5 = HEAP32[$1 >> 2] | 0;
      $1 = $4 << 7 | 0;
      label$5 : while (1) {
       cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__TransactionOutput___serialize__h958522c662d822ef($3 | 0, $5 | 0, $2 | 0);
       if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
        break label$2
       }
       $5 = $5 + 128 | 0;
       $1 = $1 + -128 | 0;
       if ($1) {
        continue label$5
       }
       break label$5;
      };
     }
     HEAP32[($0 + 4 | 0) >> 2] = $2;
     $5 = 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $5 = 1;
  }
  HEAP32[$0 >> 2] = $5;
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__Certificates___serialize__h4f1f9d7f05159b8e($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $5 = 0, $4 = 0, i64toi32_i32$0 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, $4 | 0, i64toi32_i32$0 | 0);
  $5 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     label$4 : {
      if (!$4) {
       break label$4
      }
      $5 = HEAP32[$1 >> 2] | 0;
      $1 = Math_imul($4, 200);
      label$5 : while (1) {
       cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__CertificateEnum___serialize__ha9753fa38519654b($3 | 0, $5 | 0, $2 | 0);
       if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
        break label$2
       }
       $5 = $5 + 200 | 0;
       $1 = $1 + -200 | 0;
       if ($1) {
        continue label$5
       }
       break label$5;
      };
     }
     HEAP32[($0 + 4 | 0) >> 2] = $2;
     $5 = 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $5 = 1;
  }
  HEAP32[$0 >> 2] = $5;
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__Update___serialize__h3b16321a799d449a($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  i64toi32_i32$0 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, 2 | 0, i64toi32_i32$0 | 0);
  $4 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__ProposedProtocolParameterUpdates___serialize__h327aa0190f949245($3 | 0, $1 | 0, $2 | 0);
      if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      $4 = 0;
      i64toi32_i32$0 = HEAP32[($1 + 40 | 0) >> 2] | 0;
      i64toi32_i32$1 = 0;
      cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, i64toi32_i32$0 | 0, i64toi32_i32$1 | 0);
      if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
       break label$2
      }
      HEAP32[($0 + 4 | 0) >> 2] = $2;
      break label$1;
     }
     memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    $4 = 1;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $4 = 1;
  }
  HEAP32[$0 >> 2] = $4;
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__Relays___serialize__ha6bdc6309ff8ff6a($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $5 = 0, $4 = 0, i64toi32_i32$0 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, $4 | 0, i64toi32_i32$0 | 0);
  $5 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     label$4 : {
      if (!$4) {
       break label$4
      }
      $5 = HEAP32[$1 >> 2] | 0;
      $1 = Math_imul($4, 28);
      label$5 : while (1) {
       cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__RelayEnum___serialize__h742c43d428b38e2a($3 | 0, $5 | 0, $2 | 0);
       if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
        break label$2
       }
       $5 = $5 + 28 | 0;
       $1 = $1 + -28 | 0;
       if ($1) {
        continue label$5
       }
       break label$5;
      };
     }
     HEAP32[($0 + 4 | 0) >> 2] = $2;
     $5 = 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $5 = 1;
  }
  HEAP32[$0 >> 2] = $5;
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__StakeCredentials___serialize__h4796a750e6290b16($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $5 = 0, $4 = 0, i64toi32_i32$0 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, $4 | 0, i64toi32_i32$0 | 0);
  $5 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     label$4 : {
      if (!$4) {
       break label$4
      }
      $5 = HEAP32[$1 >> 2] | 0;
      $1 = Math_imul($4, 29);
      label$5 : while (1) {
       $cardano_serialization_lib__address__StakeCredential_20as_20cbor_event__se__Serialize___serialize__h5b8c776cf4ca6024($3 | 0, $5 | 0, $2 | 0);
       if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
        break label$2
       }
       $5 = $5 + 29 | 0;
       $1 = $1 + -29 | 0;
       if ($1) {
        continue label$5
       }
       break label$5;
      };
     }
     HEAP32[($0 + 4 | 0) >> 2] = $2;
     $5 = 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $5 = 1;
  }
  HEAP32[$0 >> 2] = $5;
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__RewardAddresses___serialize__h56cb54f274358354($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $5 = 0, $4 = 0, i64toi32_i32$0 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, $4 | 0, i64toi32_i32$0 | 0);
  $5 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     label$4 : {
      if (!$4) {
       break label$4
      }
      $5 = HEAP32[$1 >> 2] | 0;
      $1 = Math_imul($4, 30);
      label$5 : while (1) {
       $cardano_serialization_lib__address__RewardAddress_20as_20cbor_event__se__Serialize___serialize__hd22cb20e67f69432($3 | 0, $5 | 0, $2 | 0);
       if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
        break label$2
       }
       $5 = $5 + 30 | 0;
       $1 = $1 + -30 | 0;
       if ($1) {
        continue label$5
       }
       break label$5;
      };
     }
     HEAP32[($0 + 4 | 0) >> 2] = $2;
     $5 = 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $5 = 1;
  }
  HEAP32[$0 >> 2] = $5;
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__NativeScripts___serialize__hecc991a2909139b7($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $5 = 0, $4 = 0, i64toi32_i32$0 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, $4 | 0, i64toi32_i32$0 | 0);
  $5 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     label$4 : {
      if (!$4) {
       break label$4
      }
      $5 = HEAP32[$1 >> 2] | 0;
      $1 = $4 << 5 | 0;
      label$5 : while (1) {
       cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__NativeScriptEnum___serialize__hdc3a49a10a4c617a($3 | 0, $5 | 0, $2 | 0);
       if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
        break label$2
       }
       $5 = $5 + 32 | 0;
       $1 = $1 + -32 | 0;
       if ($1) {
        continue label$5
       }
       break label$5;
      };
     }
     HEAP32[($0 + 4 | 0) >> 2] = $2;
     $5 = 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $5 = 1;
  }
  HEAP32[$0 >> 2] = $5;
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__ProtocolVersions___serialize__h93b9b5b740a5eb75($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $5 = 0, $4 = 0, i64toi32_i32$0 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, $4 | 0, i64toi32_i32$0 | 0);
  $5 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     label$4 : {
      if (!$4) {
       break label$4
      }
      $5 = HEAP32[$1 >> 2] | 0;
      $1 = $4 << 3 | 0;
      label$5 : while (1) {
       cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__SerializeEmbeddedGroup_20for_20cardano_serialization_lib__ProtocolVersion___serialize_as_embedded_group__hf0a424996c64ec05($3 | 0, $5 | 0, $2 | 0);
       if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
        break label$2
       }
       $5 = $5 + 8 | 0;
       $1 = $1 + -8 | 0;
       if ($1) {
        continue label$5
       }
       break label$5;
      };
     }
     HEAP32[($0 + 4 | 0) >> 2] = $2;
     $5 = 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $5 = 1;
  }
  HEAP32[$0 >> 2] = $5;
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__TransactionBodies___serialize__h8db917846eff3001($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $5 = 0, $4 = 0, i64toi32_i32$0 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, $4 | 0, i64toi32_i32$0 | 0);
  $5 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     label$4 : {
      if (!$4) {
       break label$4
      }
      $5 = HEAP32[$1 >> 2] | 0;
      $1 = Math_imul($4, 272);
      label$5 : while (1) {
       cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__TransactionBody___serialize__h766748b3e983f577($3 | 0, $5 | 0, $2 | 0);
       if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
        break label$2
       }
       $5 = $5 + 272 | 0;
       $1 = $1 + -272 | 0;
       if ($1) {
        continue label$5
       }
       break label$5;
      };
     }
     HEAP32[($0 + 4 | 0) >> 2] = $2;
     $5 = 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $5 = 1;
  }
  HEAP32[$0 >> 2] = $5;
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__TransactionWitnessSets___serialize__hdd6edfd8e35c0d96($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $5 = 0, $4 = 0, i64toi32_i32$0 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, $4 | 0, i64toi32_i32$0 | 0);
  $5 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     label$4 : {
      if (!$4) {
       break label$4
      }
      $5 = HEAP32[$1 >> 2] | 0;
      $1 = Math_imul($4, 76);
      label$5 : while (1) {
       cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__TransactionWitnessSet___serialize__ha4e0dd8fca4a45ce($3 | 0, $5 | 0, $2 | 0);
       if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
        break label$2
       }
       $5 = $5 + 76 | 0;
       $1 = $1 + -76 | 0;
       if ($1) {
        continue label$5
       }
       break label$5;
      };
     }
     HEAP32[($0 + 4 | 0) >> 2] = $2;
     $5 = 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $5 = 1;
  }
  HEAP32[$0 >> 2] = $5;
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__Header___serialize__hd43c55fb578bdd92($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, 2 | 0, 0 | 0);
  $4 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__HeaderBody___serialize__hbb751f3982bde43a($3 | 0, $1 | 0, $2 | 0);
      if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      cbor_event__se__Serializer_W___write_bytes__hdbf95a6224c8b5b8($3 | 0, $2 | 0, $1 + 312 | 0 | 0);
      $4 = 1;
      if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
       break label$2
      }
      HEAP32[($0 + 4 | 0) >> 2] = $2;
      $4 = 0;
      break label$1;
     }
     memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    $4 = 1;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
  }
  HEAP32[$0 >> 2] = $4;
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__AssetNames___serialize__h9819ebbf21c28384($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $5 = 0, $4 = 0, i64toi32_i32$0 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, $4 | 0, i64toi32_i32$0 | 0);
  $5 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     label$4 : {
      if (!$4) {
       break label$4
      }
      $5 = HEAP32[$1 >> 2] | 0;
      $1 = Math_imul($4, 12);
      label$5 : while (1) {
       cbor_event__se__Serializer_W___write_bytes__hdbf95a6224c8b5b8($3 | 0, $2 | 0, $5 | 0);
       if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
        break label$2
       }
       $5 = $5 + 12 | 0;
       $1 = $1 + -12 | 0;
       if ($1) {
        continue label$5
       }
       break label$5;
      };
     }
     HEAP32[($0 + 4 | 0) >> 2] = $2;
     $5 = 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $5 = 1;
  }
  HEAP32[$0 >> 2] = $5;
  global$0 = $3 + 48 | 0;
 }
 
 function transactionwitnessset_plutus_data($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $4 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__he0885d10b4548804($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   cardano_serialization_lib__TransactionWitnessSet__plutus_data__h6be2d910efb0e7a2($1 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   $0 = 0;
   label$2 : {
    $2 = HEAPU8[($1 + 28 | 0) >> 0] | 0;
    if (($2 | 0) == (3 | 0)) {
     break label$2
    }
    HEAP32[(($1 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($1 + 16 | 0) + 8 | 0) >> 2] | 0;
    HEAP8[(($1 + 32 | 0) + 15 | 0) >> 0] = HEAPU8[(($1 + 16 | 0) + 15 | 0) >> 0] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
    HEAP32[($1 + 32 | 0) >> 2] = HEAP32[($1 + 16 | 0) >> 2] | 0;
    HEAP32[($1 + 36 | 0) >> 2] = i64toi32_i32$1;
    HEAP8[($1 + 44 | 0) >> 0] = $2;
    $4 = HEAPU8[($1 + 29 | 0) >> 0] | 0 | ((HEAPU8[($1 + 30 | 0) >> 0] | 0) << 8 | 0) | 0;
    HEAP8[($1 + 45 | 0) >> 0] = $4;
    HEAP8[($1 + 46 | 0) >> 0] = $4 >>> 8 | 0;
    $0 = $cardano_serialization_lib__plutus__PlutusList_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h9a3fe5bcf5e2cc3a($1 + 32 | 0 | 0) | 0;
   }
   global$0 = $1 + 48 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function protocolparamupdate_new() {
  var $0 = 0, i64toi32_i32$0 = 0, $1 = 0;
  $0 = global$0 - 416 | 0;
  global$0 = $0;
  HEAP8[($0 + 380 | 0) >> 0] = 2;
  HEAP32[($0 + 372 | 0) >> 2] = 0;
  HEAP32[($0 + 364 | 0) >> 2] = 0;
  HEAP32[($0 + 356 | 0) >> 2] = 0;
  HEAP32[($0 + 340 | 0) >> 2] = 0;
  HEAP32[($0 + 328 | 0) >> 2] = 0;
  HEAP32[($0 + 320 | 0) >> 2] = 0;
  HEAP32[($0 + 312 | 0) >> 2] = 0;
  HEAP32[($0 + 304 | 0) >> 2] = 0;
  HEAP32[($0 + 296 | 0) >> 2] = 0;
  HEAP32[($0 + 288 | 0) >> 2] = 0;
  i64toi32_i32$0 = 0;
  HEAP32[($0 + 264 | 0) >> 2] = 0;
  HEAP32[($0 + 268 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  HEAP32[($0 + 240 | 0) >> 2] = 0;
  HEAP32[($0 + 244 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  HEAP32[($0 + 200 | 0) >> 2] = 0;
  HEAP32[($0 + 204 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  HEAP32[($0 + 184 | 0) >> 2] = 0;
  HEAP32[($0 + 188 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  HEAP32[($0 + 168 | 0) >> 2] = 0;
  HEAP32[($0 + 172 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  HEAP32[($0 + 144 | 0) >> 2] = 0;
  HEAP32[($0 + 148 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  HEAP32[($0 + 120 | 0) >> 2] = 0;
  HEAP32[($0 + 124 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  HEAP32[($0 + 96 | 0) >> 2] = 0;
  HEAP32[($0 + 100 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  HEAP32[($0 + 72 | 0) >> 2] = 0;
  HEAP32[($0 + 76 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  HEAP32[($0 + 56 | 0) >> 2] = 0;
  HEAP32[($0 + 60 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  HEAP32[($0 + 40 | 0) >> 2] = 0;
  HEAP32[($0 + 44 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  HEAP32[($0 + 24 | 0) >> 2] = 0;
  HEAP32[($0 + 28 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[($0 + 12 | 0) >> 2] = i64toi32_i32$0;
  $1 = $cardano_serialization_lib__ProtocolParamUpdate_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hd784927b58be35b6($0 + 8 | 0 | 0) | 0;
  global$0 = $0 + 416 | 0;
  return $1 | 0;
 }
 
 function mintassets_new_from_entry($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $4$hi = 0, $3 = 0, $4 = 0, $35$hi = 0, $11 = 0, $51 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h9c68abd5a6a78973($2 + 40 | 0 | 0, $0 | 0);
  $0 = HEAP32[($2 + 44 | 0) >> 2] | 0;
  $3 = HEAP32[($2 + 40 | 0) >> 2] | 0;
  $cardano_serialization_lib__utils__Int_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h465ce6bea3371e5b($2 + 24 | 0 | 0, $1 | 0);
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 52 | 0) >> 2] = 0;
  HEAP32[($2 + 56 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = ($2 + 24 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($2 + 64 | 0 | 0, $3 | 0);
  $35$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $4$hi;
  i64toi32_i32$0 = $35$hi;
  $11 = i64toi32_i32$1;
  i64toi32_i32$1 = $4$hi;
  alloc__collections__btree__map__BTreeMap_K_2cV___insert__h9d3a28073b5db74d($2 | 0, $2 + 48 | 0 | 0, $2 + 64 | 0 | 0, $11 | 0, i64toi32_i32$0 | 0, $4 | 0, i64toi32_i32$1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $51 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 64 | 0) >> 2] = $51;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$0;
  $0 = $cardano_serialization_lib__MintAssets_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h828d55d3b5b95763($2 + 64 | 0 | 0) | 0;
  global$0 = $2 + 80 | 0;
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__metadata__MetadataList_20as_20cbor_event__se__Serialize___serialize__h338522090b280ca8($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $5 = 0, $4 = 0, i64toi32_i32$0 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, $4 | 0, i64toi32_i32$0 | 0);
  $5 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     label$4 : {
      if (!$4) {
       break label$4
      }
      $5 = HEAP32[$1 >> 2] | 0;
      $1 = Math_imul($4, 48);
      label$5 : while (1) {
       $cardano_serialization_lib__metadata__TransactionMetadatumEnum_20as_20cbor_event__se__Serialize___serialize__h4285ca14e4462f47($3 | 0, $5 | 0, $2 | 0);
       if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
        break label$2
       }
       $5 = $5 + 48 | 0;
       $1 = $1 + -48 | 0;
       if ($1) {
        continue label$5
       }
       break label$5;
      };
     }
     HEAP32[($0 + 4 | 0) >> 2] = $2;
     $5 = 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $5 = 1;
  }
  HEAP32[$0 >> 2] = $5;
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__fees__min_fee__hf0827db8ce69035c($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$5 = 0, $4$hi = 0, i64toi32_i32$4 = 0, $4 = 0, $5$hi = 0, $14 = 0, $14$hi = 0, $16 = 0, $16$hi = 0, $24 = 0, $24$hi = 0, $5 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $3 = global$0 - 32 | 0;
  global$0 = $3;
  cardano_serialization_lib__Transaction__to_bytes__h3fc3ee53046075af($3 + 16 | 0 | 0, $1 | 0);
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[($3 + 24 | 0) >> 2] | 0;
  i64toi32_i32$1 = 0;
  $14 = i64toi32_i32$0;
  $14$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $16 = i64toi32_i32$1;
  $16$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $14$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$2 = $16$hi;
  i64toi32_i32$3 = 0;
  __multi3($3 | 0, $14 | 0, i64toi32_i32$0 | 0, 0 | 0, i64toi32_i32$1 | 0, $16 | 0, i64toi32_i32$2 | 0, 0 | 0, i64toi32_i32$3 | 0);
  label$1 : {
   label$2 : {
    i64toi32_i32$1 = $3;
    i64toi32_i32$3 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($3 + 12 | 0) >> 2] | 0;
    i64toi32_i32$1 = i64toi32_i32$3;
    i64toi32_i32$3 = 0;
    i64toi32_i32$0 = 0;
    if ((i64toi32_i32$1 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | 0) {
     break label$2
    }
    label$3 : {
     label$4 : {
      i64toi32_i32$0 = $3;
      i64toi32_i32$1 = HEAP32[$3 >> 2] | 0;
      i64toi32_i32$2 = HEAP32[($3 + 4 | 0) >> 2] | 0;
      $4 = i64toi32_i32$1;
      $4$hi = i64toi32_i32$2;
      i64toi32_i32$0 = $2;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
      $24 = i64toi32_i32$2;
      $24$hi = i64toi32_i32$1;
      i64toi32_i32$1 = $4$hi;
      i64toi32_i32$0 = $4;
      i64toi32_i32$2 = $24$hi;
      i64toi32_i32$3 = $24;
      i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
      i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
      if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
       i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
      }
      $5 = i64toi32_i32$4;
      $5$hi = i64toi32_i32$5;
      i64toi32_i32$5 = $4$hi;
      i64toi32_i32$5 = $5$hi;
      i64toi32_i32$1 = i64toi32_i32$4;
      i64toi32_i32$0 = $4$hi;
      i64toi32_i32$3 = $4;
      if (i64toi32_i32$5 >>> 0 > i64toi32_i32$0 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$1 >>> 0 >= i64toi32_i32$3 >>> 0 | 0) | 0) {
       break label$4
      }
      (wasm2js_i32$0 = $0, wasm2js_i32$1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1058732 | 0, 8 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
      $2 = 1;
      break label$3;
     }
     i64toi32_i32$1 = $5$hi;
     i64toi32_i32$5 = $0 + 8 | 0;
     HEAP32[i64toi32_i32$5 >> 2] = $5;
     HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$1;
     $2 = 0;
    }
    HEAP32[$0 >> 2] = $2;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 16 | 0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 16 | 0 | 0);
    break label$1;
   }
   $2 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1058732 | 0, 8 | 0) | 0 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
   HEAP32[($0 + 4 | 0) >> 2] = $2;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 16 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 16 | 0 | 0);
  }
  global$0 = $3 + 32 | 0;
 }
 
 function $cardano_serialization_lib__crypto__Vkeywitnesses_20as_20cbor_event__se__Serialize___serialize__h32c03934e8035b48($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $5 = 0, $4 = 0, i64toi32_i32$0 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, $4 | 0, i64toi32_i32$0 | 0);
  $5 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     label$4 : {
      if (!$4) {
       break label$4
      }
      $5 = HEAP32[$1 >> 2] | 0;
      $1 = Math_imul($4, 96);
      label$5 : while (1) {
       $cardano_serialization_lib__crypto__Vkeywitness_20as_20cbor_event__se__Serialize___serialize__h5cf30721c029e59b($3 | 0, $5 | 0, $2 | 0);
       if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
        break label$2
       }
       $5 = $5 + 96 | 0;
       $1 = $1 + -96 | 0;
       if ($1) {
        continue label$5
       }
       break label$5;
      };
     }
     HEAP32[($0 + 4 | 0) >> 2] = $2;
     $5 = 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $5 = 1;
  }
  HEAP32[$0 >> 2] = $5;
  global$0 = $3 + 48 | 0;
 }
 
 function $cardano_serialization_lib__crypto__BootstrapWitnesses_20as_20cbor_event__se__Serialize___serialize__h9f508575b17573f7($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $5 = 0, $4 = 0, i64toi32_i32$0 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, $4 | 0, i64toi32_i32$0 | 0);
  $5 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     label$4 : {
      if (!$4) {
       break label$4
      }
      $5 = HEAP32[$1 >> 2] | 0;
      $1 = Math_imul($4, 120);
      label$5 : while (1) {
       $cardano_serialization_lib__crypto__BootstrapWitness_20as_20cbor_event__se__Serialize___serialize__hd840f2320eb792b1($3 | 0, $5 | 0, $2 | 0);
       if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
        break label$2
       }
       $5 = $5 + 120 | 0;
       $1 = $1 + -120 | 0;
       if ($1) {
        continue label$5
       }
       break label$5;
      };
     }
     HEAP32[($0 + 4 | 0) >> 2] = $2;
     $5 = 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $5 = 1;
  }
  HEAP32[$0 >> 2] = $5;
  global$0 = $3 + 48 | 0;
 }
 
 function $cardano_serialization_lib__crypto__VRFCert_20as_20cbor_event__se__Serialize___serialize__hc36d047369e93edb($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, 2 | 0, 0 | 0);
  $4 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      cbor_event__se__Serializer_W___write_bytes__hdbf95a6224c8b5b8($3 | 0, $2 | 0, $1 | 0);
      if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      cbor_event__se__Serializer_W___write_bytes__hdbf95a6224c8b5b8($3 | 0, $2 | 0, $1 + 12 | 0 | 0);
      $4 = 1;
      if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
       break label$2
      }
      HEAP32[($0 + 4 | 0) >> 2] = $2;
      $4 = 0;
      break label$1;
     }
     memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    $4 = 1;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
  }
  HEAP32[$0 >> 2] = $4;
  global$0 = $3 + 48 | 0;
 }
 
 function $cardano_serialization_lib__plutus__PlutusScripts_20as_20cbor_event__se__Serialize___serialize__h460b1286d3728f21($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $5 = 0, $4 = 0, i64toi32_i32$0 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, $4 | 0, i64toi32_i32$0 | 0);
  $5 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     label$4 : {
      if (!$4) {
       break label$4
      }
      $5 = HEAP32[$1 >> 2] | 0;
      $1 = Math_imul($4, 12);
      label$5 : while (1) {
       cbor_event__se__Serializer_W___write_bytes__hdbf95a6224c8b5b8($3 | 0, $2 | 0, $5 | 0);
       if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
        break label$2
       }
       $5 = $5 + 12 | 0;
       $1 = $1 + -12 | 0;
       if ($1) {
        continue label$5
       }
       break label$5;
      };
     }
     HEAP32[($0 + 4 | 0) >> 2] = $2;
     $5 = 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $5 = 1;
  }
  HEAP32[$0 >> 2] = $5;
  global$0 = $3 + 48 | 0;
 }
 
 function $cardano_serialization_lib__plutus__ExUnitPrices_20as_20cbor_event__se__Serialize___serialize__h10c0ac919a9d373a($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, 2 | 0, 0 | 0);
  $4 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__UnitInterval___serialize__h073d853696277759($3 | 0, $1 | 0, $2 | 0);
      if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__UnitInterval___serialize__h073d853696277759($3 | 0, $1 + 16 | 0 | 0, $2 | 0);
      $4 = 1;
      if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
       break label$2
      }
      HEAP32[($0 + 4 | 0) >> 2] = $2;
      $4 = 0;
      break label$1;
     }
     memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    $4 = 1;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
  }
  HEAP32[$0 >> 2] = $4;
  global$0 = $3 + 48 | 0;
 }
 
 function $cardano_serialization_lib__plutus__Redeemers_20as_20cbor_event__se__Serialize___serialize__h3e0a2f954a4fc936($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $5 = 0, $4 = 0, i64toi32_i32$0 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, $4 | 0, i64toi32_i32$0 | 0);
  $5 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     label$4 : {
      if (!$4) {
       break label$4
      }
      $5 = HEAP32[$1 >> 2] | 0;
      $1 = Math_imul($4, 80);
      label$5 : while (1) {
       $cardano_serialization_lib__plutus__Redeemer_20as_20cbor_event__se__Serialize___serialize__hf725a82e60523f39($3 | 0, $5 | 0, $2 | 0);
       if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
        break label$2
       }
       $5 = $5 + 80 | 0;
       $1 = $1 + -80 | 0;
       if ($1) {
        continue label$5
       }
       break label$5;
      };
     }
     HEAP32[($0 + 4 | 0) >> 2] = $2;
     $5 = 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $5 = 1;
  }
  HEAP32[$0 >> 2] = $5;
  global$0 = $3 + 48 | 0;
 }
 
 function plutusdata_new_list($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $32 = 0, $35 = 0, $44 = 0, $48 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hd98e995abd746618($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hc831120dea694494($1 + 32 | 0 | 0, $2 | 0);
  $2 = HEAPU8[($2 + 12 | 0) >> 0] | 0;
  HEAP8[($1 + 44 | 0) >> 0] = ($2 | 0) == (2 | 0) ? 2 : ($2 | 0) != (0 | 0);
  $2 = ($1 + 16 | 0) + 8 | 0;
  i64toi32_i32$2 = ($1 + 32 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $32 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $32;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[($1 + 32 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 36 | 0) >> 2] | 0;
  $35 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[($1 + 16 | 0) >> 2] = $35;
  HEAP32[($1 + 20 | 0) >> 2] = i64toi32_i32$0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $44 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 44 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $44;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 32 | 0) >> 2] = 2;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[($1 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  $48 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[($1 + 36 | 0) >> 2] = $48;
  HEAP32[($1 + 40 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($1 + 64 | 0) >> 2] = 0;
  $0 = $cardano_serialization_lib__plutus__PlutusData_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h7393378a3318e0a5($1 + 32 | 0 | 0) | 0;
  global$0 = $1 + 80 | 0;
  return $0 | 0;
 }
 
 function plutusdata_as_list($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $4 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb1fd14a6870cafe2($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   cardano_serialization_lib__plutus__PlutusData__as_list__h5406319792508a75($1 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   $0 = 0;
   label$2 : {
    $2 = HEAPU8[($1 + 28 | 0) >> 0] | 0;
    if (($2 | 0) == (3 | 0)) {
     break label$2
    }
    HEAP32[(($1 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($1 + 16 | 0) + 8 | 0) >> 2] | 0;
    HEAP8[(($1 + 32 | 0) + 15 | 0) >> 0] = HEAPU8[(($1 + 16 | 0) + 15 | 0) >> 0] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
    HEAP32[($1 + 32 | 0) >> 2] = HEAP32[($1 + 16 | 0) >> 2] | 0;
    HEAP32[($1 + 36 | 0) >> 2] = i64toi32_i32$1;
    HEAP8[($1 + 44 | 0) >> 0] = $2;
    $4 = HEAPU8[($1 + 29 | 0) >> 0] | 0 | ((HEAPU8[($1 + 30 | 0) >> 0] | 0) << 8 | 0) | 0;
    HEAP8[($1 + 45 | 0) >> 0] = $4;
    HEAP8[($1 + 46 | 0) >> 0] = $4 >>> 8 | 0;
    $0 = $cardano_serialization_lib__plutus__PlutusList_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h9a3fe5bcf5e2cc3a($1 + 32 | 0 | 0) | 0;
   }
   global$0 = $1 + 48 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function mirtostakecredentials_keys($0) {
  $0 = $0 | 0;
  var $1 = 0, $3 = 0, $2 = 0, $4 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h74054450d591b36f($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   label$2 : {
    label$3 : {
     $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     $3 = HEAP32[($2 + 32 | 0) >> 2] | 0;
     if ($3) {
      break label$3
     }
     $4 = 0;
     break label$2;
    }
    $4 = HEAP32[($3 + 20 | 0) >> 2] | 0;
   }
   HEAP32[($1 + 40 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
   HEAP32[($1 + 36 | 0) >> 2] = $3;
   HEAP32[($1 + 32 | 0) >> 2] = $4;
   $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__h79b90f2b969c0793($1 + 16 | 0 | 0, $1 + 32 | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   HEAP32[(($1 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($1 + 16 | 0) + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
   HEAP32[($1 + 32 | 0) >> 2] = HEAP32[($1 + 16 | 0) >> 2] | 0;
   HEAP32[($1 + 36 | 0) >> 2] = i64toi32_i32$1;
   $0 = $cardano_serialization_lib__StakeCredentials_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h4e7a6ae850e16266($1 + 32 | 0 | 0) | 0;
   global$0 = $1 + 48 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function withdrawals_keys($0) {
  $0 = $0 | 0;
  var $1 = 0, $3 = 0, $2 = 0, $4 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h000099354d5ff519($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   label$2 : {
    label$3 : {
     $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     $3 = HEAP32[($2 + 32 | 0) >> 2] | 0;
     if ($3) {
      break label$3
     }
     $4 = 0;
     break label$2;
    }
    $4 = HEAP32[($3 + 12 | 0) >> 2] | 0;
   }
   HEAP32[($1 + 40 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
   HEAP32[($1 + 36 | 0) >> 2] = $3;
   HEAP32[($1 + 32 | 0) >> 2] = $4;
   $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__h6190af30aaed5e17($1 + 16 | 0 | 0, $1 + 32 | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   HEAP32[(($1 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($1 + 16 | 0) + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
   HEAP32[($1 + 32 | 0) >> 2] = HEAP32[($1 + 16 | 0) >> 2] | 0;
   HEAP32[($1 + 36 | 0) >> 2] = i64toi32_i32$1;
   $0 = $cardano_serialization_lib__RewardAddresses_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hd844bb3a1f8d93b5($1 + 32 | 0 | 0) | 0;
   global$0 = $1 + 48 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function proposedprotocolparameterupdates_keys($0) {
  $0 = $0 | 0;
  var $1 = 0, $3 = 0, $2 = 0, $4 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h2d6285fb6a1d44f8($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   label$2 : {
    label$3 : {
     $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     $3 = HEAP32[($2 + 32 | 0) >> 2] | 0;
     if ($3) {
      break label$3
     }
     $4 = 0;
     break label$2;
    }
    $4 = HEAP32[($3 + 412 | 0) >> 2] | 0;
   }
   HEAP32[($1 + 40 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
   HEAP32[($1 + 36 | 0) >> 2] = $3;
   HEAP32[($1 + 32 | 0) >> 2] = $4;
   $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__hd8dacdd56da3a201($1 + 16 | 0 | 0, $1 + 32 | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   HEAP32[(($1 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($1 + 16 | 0) + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
   HEAP32[($1 + 32 | 0) >> 2] = HEAP32[($1 + 16 | 0) >> 2] | 0;
   HEAP32[($1 + 36 | 0) >> 2] = i64toi32_i32$1;
   $0 = $cardano_serialization_lib__GenesisHashes_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h78a61e795f735d84($1 + 32 | 0 | 0) | 0;
   global$0 = $1 + 48 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function metadatamap_keys($0) {
  $0 = $0 | 0;
  var $1 = 0, $3 = 0, $2 = 0, $4 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h74f2437fd791f127($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   label$2 : {
    label$3 : {
     $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     $3 = HEAP32[($2 + 32 | 0) >> 2] | 0;
     if ($3) {
      break label$3
     }
     $4 = 0;
     break label$2;
    }
    $4 = HEAP32[($3 + 100 | 0) >> 2] | 0;
   }
   HEAP32[($1 + 40 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
   HEAP32[($1 + 36 | 0) >> 2] = $3;
   HEAP32[($1 + 32 | 0) >> 2] = $4;
   $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__h98fa0a7e5178e672($1 + 16 | 0 | 0, $1 + 32 | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   HEAP32[(($1 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($1 + 16 | 0) + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
   HEAP32[($1 + 32 | 0) >> 2] = HEAP32[($1 + 16 | 0) >> 2] | 0;
   HEAP32[($1 + 36 | 0) >> 2] = i64toi32_i32$1;
   $0 = $cardano_serialization_lib__metadata__MetadataList_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h726a255338699014($1 + 32 | 0 | 0) | 0;
   global$0 = $1 + 48 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function generaltransactionmetadata_keys($0) {
  $0 = $0 | 0;
  var $1 = 0, $3 = 0, $2 = 0, $4 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h670b86b1bfb2242f($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   label$2 : {
    label$3 : {
     $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     $3 = HEAP32[($2 + 32 | 0) >> 2] | 0;
     if ($3) {
      break label$3
     }
     $4 = 0;
     break label$2;
    }
    $4 = HEAP32[($3 + 60 | 0) >> 2] | 0;
   }
   HEAP32[($1 + 40 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
   HEAP32[($1 + 36 | 0) >> 2] = $3;
   HEAP32[($1 + 32 | 0) >> 2] = $4;
   $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__hfd55a1b9f78bf10e($1 + 16 | 0 | 0, $1 + 32 | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   HEAP32[(($1 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($1 + 16 | 0) + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
   HEAP32[($1 + 32 | 0) >> 2] = HEAP32[($1 + 16 | 0) >> 2] | 0;
   HEAP32[($1 + 36 | 0) >> 2] = i64toi32_i32$1;
   $0 = $cardano_serialization_lib__metadata__TransactionMetadatumLabels_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h90a9618967dafb91($1 + 32 | 0 | 0) | 0;
   global$0 = $1 + 48 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function cardano_serialization_lib__metadata__AuxiliaryData__from_bytes__h000def947847cc64($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $15 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  HEAP32[($2 + 152 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 136 | 0) >> 2] = 0;
  HEAP32[($2 + 140 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 144 | 0) >> 2] = $15;
  HEAP32[($2 + 148 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__metadata__AuxiliaryData_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hca865c989495a465($2 + 64 | 0 | 0, $2 + 136 | 0 | 0);
  $1 = ($2 + 136 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 64 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 68 | 0) >> 2] | 0;
  $2 = memcpy($2 | 0, ($2 + 64 | 0) + 8 | 0 | 0, 64 | 0) | 0;
  label$1 : {
   label$2 : {
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    if ((i64toi32_i32$2 | 0) == (1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
     break label$2
    }
    memcpy($0 + 8 | 0 | 0, $2 | 0, 64 | 0) | 0;
    $1 = 0;
    break label$1;
   }
   memcpy($2 + 64 | 0 | 0, $2 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 64 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 160 | 0;
 }
 
 function $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__iter__traits__collect__Extend__28K_2cV_29____extend__h8816371e9eef4d29($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0, $5 = 0, i64toi32_i32$1 = 0, $6 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  label$1 : {
   $3 = HEAP32[$1 >> 2] | 0;
   $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   if (($3 | 0) == ($4 | 0)) {
    break label$1
   }
   $5 = ($2 + 56 | 0) + 8 | 0;
   label$2 : while (1) {
    $1 = HEAP32[($3 + 60 | 0) >> 2] | 0;
    core__ops__function__impls___impl_20core__ops__function__FnOnce_A__20for_20_mut_20F___call_once__h16f3e4a987a7f931($2 + 56 | 0 | 0, $2 | 0, $3 | 0, $3 + 8 | 0 | 0);
    if ((HEAP32[($2 + 64 | 0) >> 2] | 0 | 0) == (5 | 0)) {
     break label$1
    }
    i64toi32_i32$1 = HEAP32[($2 + 60 | 0) >> 2] | 0;
    $6 = HEAP32[($2 + 56 | 0) >> 2] | 0;
    memcpy($2 + 8 | 0 | 0, $5 | 0, 48 | 0) | 0;
    memcpy($2 + 56 | 0 | 0, $2 + 8 | 0 | 0, 48 | 0) | 0;
    linked_hash_map__LinkedHashMap_K_2cV_2cS___insert__h48a3e36a8942b5e6($2 + 112 | 0 | 0, $0 | 0, $6 | 0, i64toi32_i32$1 | 0, $2 + 56 | 0 | 0);
    label$3 : {
     if ((HEAP32[($2 + 112 | 0) >> 2] | 0 | 0) == (5 | 0)) {
      break label$3
     }
     core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatumEnum___h27fd15c9b26a768e($2 + 112 | 0 | 0);
    }
    $3 = $1;
    if (($3 | 0) != ($4 | 0)) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $2 + 160 | 0;
 }
 
 function transactionbuilder_output_sizes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if (!$1) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h37dfbd2f31d951c1($2 + 8 | 0 | 0, $1 | 0);
   $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   $4 = HEAP32[($3 + 416 | 0) >> 2] | 0;
   $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__h5612307da16e6eb2($2 + 16 | 0 | 0, $4 | 0, $4 + ((HEAP32[($3 + 424 | 0) >> 2] | 0) << 7 | 0) | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   $1 = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
   HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = $1;
   i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   HEAP32[($2 + 32 | 0) >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
   HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
   label$2 : {
    if ((HEAP32[($2 + 36 | 0) >> 2] | 0) >>> 0 <= $1 >>> 0) {
     break label$2
    }
    alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h9bee2257dca46f01($2 + 32 | 0 | 0, $1 | 0);
    $1 = HEAP32[($2 + 40 | 0) >> 2] | 0;
   }
   $3 = HEAP32[($2 + 32 | 0) >> 2] | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $3;
   global$0 = $2 + 48 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function cardano_serialization_lib__plutus__Language__from_bytes__hc4c1cf8990ed25c0($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, $3 = 0, i64toi32_i32$1 = 0, $4 = 0, $16 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  HEAP32[($2 + 88 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 72 | 0) >> 2] = 0;
  HEAP32[($2 + 76 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $16 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 80 | 0) >> 2] = $16;
  HEAP32[($2 + 84 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__plutus__Language_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__ha3cda676d250cc98($2 + 96 | 0 | 0, $2 + 72 | 0 | 0);
  $1 = ($2 + 72 | 0) + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  label$1 : {
   label$2 : {
    $3 = HEAPU8[($2 + 96 | 0) >> 0] | 0;
    if (($3 | 0) != (19 | 0)) {
     break label$2
    }
    $1 = 0;
    break label$1;
   }
   $1 = 1;
   $4 = $2 + 96 | 0 | 1 | 0;
   memcpy($2 + 9 | 0 | 0, $4 | 0, 63 | 0) | 0;
   HEAP8[($2 + 96 | 0) >> 0] = $3;
   memcpy($4 | 0, $2 + 9 | 0 | 0, 63 | 0) | 0;
   $3 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 96 | 0 | 0) | 0;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $3;
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 160 | 0;
 }
 
 function alloc__collections__btree__map__entry__OccupiedEntry_K_2cV___remove_kv__hdf50ae66bbd838a5($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $15 = 0, $27 = 0, $33 = 0, $36 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP8[($2 + 7 | 0) >> 0] = 0;
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $15;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  alloc__collections__btree__remove___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal__2calloc__collections__btree__node__marker__KV____remove_kv_tracking__ha7e0ee7959bef5ef($2 + 8 | 0 | 0, $2 + 48 | 0 | 0, $2 + 7 | 0 | 0);
  i64toi32_i32$2 = ($2 + 8 | 0) + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $27 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $27;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = ($2 + 8 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $33 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $33;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + -1 | 0;
  label$1 : {
   label$2 : {
    if (!(HEAPU8[($2 + 7 | 0) >> 0] | 0)) {
     break label$2
    }
    if (!(HEAP32[($0 + 4 | 0) >> 2] | 0)) {
     break label$1
    }
    alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Owned_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___pop_internal_level__hd8f9679535721f0f($0 | 0);
   }
   global$0 = $2 + 64 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1072048 | 0, 43 | 0, 1072264 | 0);
  abort();
 }
 
 function $cryptoxide__sha3__Sha3_256_20as_20cryptoxide__digest__Digest___result__hacd163af1c76f2fe($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $3 = 0, $14 = 0, $15 = 0, $16 = 0, $17 = 0, $4 = 0, $5 = 0, $6 = 0, $32 = 0, $36 = 0, $40 = 0, $44 = 0;
  $3 = global$0 - 32 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    if (HEAPU8[($0 + 208 | 0) >> 0] | 0) {
     break label$2
    }
    HEAP8[($0 + 208 | 0) >> 0] = 1;
    $4 = $3 + 24 | 0;
    i64toi32_i32$1 = $4;
    i64toi32_i32$0 = 0;
    HEAP32[i64toi32_i32$1 >> 2] = 0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    $5 = $3 + 16 | 0;
    i64toi32_i32$1 = $5;
    i64toi32_i32$0 = 0;
    HEAP32[i64toi32_i32$1 >> 2] = 0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    $6 = $3 + 8 | 0;
    i64toi32_i32$1 = $6;
    i64toi32_i32$0 = 0;
    HEAP32[i64toi32_i32$1 >> 2] = 0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$1 = $3;
    i64toi32_i32$0 = 0;
    HEAP32[i64toi32_i32$1 >> 2] = 0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    cryptoxide__hashing__sha3__Engine___2c____output__h721f8fb166d534ff($0 | 0, i64toi32_i32$1 | 0);
    HEAP16[($0 + 204 | 0) >> 1] = 257;
    memset($0 | 0, 0 | 0, 204 | 0) | 0;
    if (($2 | 0) != (32 | 0)) {
     break label$1
    }
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $32 = i64toi32_i32$0;
    i64toi32_i32$0 = $1;
    $14 = $32;
    HEAP8[i64toi32_i32$0 >> 0] = $14;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $14 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $14 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $14 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $36 = i64toi32_i32$1;
    i64toi32_i32$1 = $1 + 24 | 0;
    $15 = $36;
    HEAP8[i64toi32_i32$1 >> 0] = $15;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $15 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $15 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $15 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$2 = $5;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $40 = i64toi32_i32$0;
    i64toi32_i32$0 = $1 + 16 | 0;
    $16 = $40;
    HEAP8[i64toi32_i32$0 >> 0] = $16;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $16 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $16 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $16 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$2 = $6;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $44 = i64toi32_i32$1;
    i64toi32_i32$1 = $1 + 8 | 0;
    $17 = $44;
    HEAP8[i64toi32_i32$1 >> 0] = $17;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $17 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $17 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $17 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    global$0 = $3 + 32 | 0;
    return;
   }
   core__panicking__panic__h2fd385a887c8bf13(1135784 | 0, 41 | 0, 1135956 | 0);
   abort();
  }
  core__slice___impl_20_5bT_5d___copy_from_slice__len_mismatch_fail__h13bf5a0e1407b14d($2 | 0, 32 | 0, 1103120 | 0);
  abort();
 }
 
 function transactioninputs_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $31 = 0, $46 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__TransactionInputs__from_bytes__h08f00e98055eb5b9($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 52 | 0) >> 2] = $46;
  HEAP32[($2 + 56 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 48 | 0) >> 2] = $1;
  $1 = $cardano_serialization_lib__TransactionInputs_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__haa89884e18e43552($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function transactionoutputs_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $31 = 0, $46 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__TransactionOutputs__from_bytes__h862a67100c360169($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 52 | 0) >> 2] = $46;
  HEAP32[($2 + 56 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 48 | 0) >> 2] = $1;
  $1 = $cardano_serialization_lib__TransactionOutputs_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8e1ecfa37411bb92($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function certificates_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $31 = 0, $46 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__Certificates__from_bytes__h83395de05ee7623a($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 52 | 0) >> 2] = $46;
  HEAP32[($2 + 56 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 48 | 0) >> 2] = $1;
  $1 = $cardano_serialization_lib__Certificates_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h2d4d31bc412465af($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function ed25519keyhashes_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $31 = 0, $46 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__Ed25519KeyHashes__from_bytes__h253963bde8fe7046($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 52 | 0) >> 2] = $46;
  HEAP32[($2 + 56 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 48 | 0) >> 2] = $1;
  $1 = $cardano_serialization_lib__Ed25519KeyHashes_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h2ef8a4685b78a9d8($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function relays_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $31 = 0, $46 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__Relays__from_bytes__hceced7749b59348d($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 52 | 0) >> 2] = $46;
  HEAP32[($2 + 56 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 48 | 0) >> 2] = $1;
  $1 = $cardano_serialization_lib__Relays_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hf76c9eea02151e5d($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function url_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $31 = 0, $46 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__URL__from_bytes__h0d714854697691cb($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 52 | 0) >> 2] = $46;
  HEAP32[($2 + 56 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 48 | 0) >> 2] = $1;
  $1 = $cardano_serialization_lib__URL_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h2e80070c22b420a7($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function url_new($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $31 = 0, $46 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__URL__new__h867b042f776d8c04($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 52 | 0) >> 2] = $46;
  HEAP32[($2 + 56 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 48 | 0) >> 2] = $1;
  $1 = $cardano_serialization_lib__URL_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h2e80070c22b420a7($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function dnsrecordaoraaaa_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $31 = 0, $46 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__DNSRecordAorAAAA__from_bytes__h2e359d2f8518fc69($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 52 | 0) >> 2] = $46;
  HEAP32[($2 + 56 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 48 | 0) >> 2] = $1;
  $1 = $cardano_serialization_lib__DNSRecordAorAAAA_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__ha728e434ce197f30($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function dnsrecordaoraaaa_new($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $31 = 0, $46 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__DNSRecordAorAAAA__new__h2919837710f98b90($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 52 | 0) >> 2] = $46;
  HEAP32[($2 + 56 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 48 | 0) >> 2] = $1;
  $1 = $cardano_serialization_lib__DNSRecordAorAAAA_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__ha728e434ce197f30($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function dnsrecordsrv_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $31 = 0, $46 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__DNSRecordSRV__from_bytes__hba3f0817a593a4d5($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 52 | 0) >> 2] = $46;
  HEAP32[($2 + 56 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 48 | 0) >> 2] = $1;
  $1 = $cardano_serialization_lib__DNSRecordSRV_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h86e52234694c0af8($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function dnsrecordsrv_new($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $31 = 0, $46 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__DNSRecordSRV__new__hb0cd799022912491($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 52 | 0) >> 2] = $46;
  HEAP32[($2 + 56 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 48 | 0) >> 2] = $1;
  $1 = $cardano_serialization_lib__DNSRecordSRV_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h86e52234694c0af8($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function multihostname_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $31 = 0, $46 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__MultiHostName__from_bytes__h0bcafc7ebc8a45ae($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 52 | 0) >> 2] = $46;
  HEAP32[($2 + 56 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 48 | 0) >> 2] = $1;
  $1 = $cardano_serialization_lib__MultiHostName_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h36c70b81dbc68c79($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function stakecredentials_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $31 = 0, $46 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__StakeCredentials__from_bytes__h753d9b0af791e159($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 52 | 0) >> 2] = $46;
  HEAP32[($2 + 56 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 48 | 0) >> 2] = $1;
  $1 = $cardano_serialization_lib__StakeCredentials_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h4e7a6ae850e16266($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function rewardaddresses_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $31 = 0, $46 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__RewardAddresses__from_bytes__hf88feb2c357f0f9d($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 52 | 0) >> 2] = $46;
  HEAP32[($2 + 56 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 48 | 0) >> 2] = $1;
  $1 = $cardano_serialization_lib__RewardAddresses_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hd844bb3a1f8d93b5($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function scriptall_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $31 = 0, $46 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__ScriptAll__from_bytes__h6e2e7af182c0d5c6($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 52 | 0) >> 2] = $46;
  HEAP32[($2 + 56 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 48 | 0) >> 2] = $1;
  $1 = $cardano_serialization_lib__ScriptAll_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hef80bd8099d14009($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function scriptany_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $31 = 0, $46 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__ScriptAny__from_bytes__h711e5dc2380171b3($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 52 | 0) >> 2] = $46;
  HEAP32[($2 + 56 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 48 | 0) >> 2] = $1;
  $1 = $cardano_serialization_lib__ScriptAny_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hee8cbd3c8c833493($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function genesishashes_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $31 = 0, $46 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__GenesisHashes__from_bytes__h7408e7ced6e64cd4($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 52 | 0) >> 2] = $46;
  HEAP32[($2 + 56 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 48 | 0) >> 2] = $1;
  $1 = $cardano_serialization_lib__GenesisHashes_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h78a61e795f735d84($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function scripthashes_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $31 = 0, $46 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__ScriptHashes__from_bytes__h2865c01a0beedfb5($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 52 | 0) >> 2] = $46;
  HEAP32[($2 + 56 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 48 | 0) >> 2] = $1;
  $1 = $cardano_serialization_lib__ScriptHashes_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__ha80e71a64db891b6($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function protocolversions_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $31 = 0, $46 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__ProtocolVersions__from_bytes__h8eadcdd3cf7ce117($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 52 | 0) >> 2] = $46;
  HEAP32[($2 + 56 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 48 | 0) >> 2] = $1;
  $1 = $cardano_serialization_lib__ProtocolVersions_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h22db0982b5b147a5($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function transactionbodies_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $31 = 0, $46 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__TransactionBodies__from_bytes__hf1ee35799a18c3a1($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 52 | 0) >> 2] = $46;
  HEAP32[($2 + 56 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 48 | 0) >> 2] = $1;
  $1 = $cardano_serialization_lib__TransactionBodies_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h13219c098e12494e($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function transactionwitnesssets_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $31 = 0, $46 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__TransactionWitnessSets__from_bytes__heb611ee40259505d($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 52 | 0) >> 2] = $46;
  HEAP32[($2 + 56 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 48 | 0) >> 2] = $1;
  $1 = $cardano_serialization_lib__TransactionWitnessSets_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h7db91b5cba584e3a($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function assetname_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $31 = 0, $46 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__AssetName__from_bytes__h03d96fd184e80c73($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 52 | 0) >> 2] = $46;
  HEAP32[($2 + 56 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 48 | 0) >> 2] = $1;
  $1 = $cardano_serialization_lib__AssetName_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__haddaee8282ead41b($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function assetname_new($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $31 = 0, $46 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__AssetName__new__h3701d918fcb1bec2($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 52 | 0) >> 2] = $46;
  HEAP32[($2 + 56 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 48 | 0) >> 2] = $1;
  $1 = $cardano_serialization_lib__AssetName_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__haddaee8282ead41b($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function assetnames_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $31 = 0, $46 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__AssetNames__from_bytes__h3185a85ff413abc3($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 52 | 0) >> 2] = $46;
  HEAP32[($2 + 56 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 48 | 0) >> 2] = $1;
  $1 = $cardano_serialization_lib__AssetNames_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h88f81c8607449c6b($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function assets_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $31 = 0, $46 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__Assets__from_bytes__hdce3103dfbe0c848($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 52 | 0) >> 2] = $46;
  HEAP32[($2 + 56 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 48 | 0) >> 2] = $1;
  $1 = $cardano_serialization_lib__Assets_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hf61728444da3586d($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function multiasset_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $31 = 0, $46 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__MultiAsset__from_bytes__hb943bcc7552ea398($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 52 | 0) >> 2] = $46;
  HEAP32[($2 + 56 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 48 | 0) >> 2] = $1;
  $1 = $cardano_serialization_lib__MultiAsset_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he6031c139f7594ac($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function mint_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $31 = 0, $46 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__Mint__from_bytes__h8327d60950d2901d($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 52 | 0) >> 2] = $46;
  HEAP32[($2 + 56 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 48 | 0) >> 2] = $1;
  $1 = $cardano_serialization_lib__Mint_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8fa2adeb6e27a027($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function metadatalist_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $31 = 0, $46 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__metadata__MetadataList__from_bytes__hcd9e84ca972fee2f($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 52 | 0) >> 2] = $46;
  HEAP32[($2 + 56 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 48 | 0) >> 2] = $1;
  $1 = $cardano_serialization_lib__metadata__MetadataList_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h726a255338699014($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function transactionmetadatumlabels_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $31 = 0, $46 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__metadata__TransactionMetadatumLabels__from_bytes__h85692917aa346cbe($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 52 | 0) >> 2] = $46;
  HEAP32[($2 + 56 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 48 | 0) >> 2] = $1;
  $1 = $cardano_serialization_lib__metadata__TransactionMetadatumLabels_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h90a9618967dafb91($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function transactionbuilder_set_mint_asset($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, $5 = 0, $6 = 0;
  $3 = global$0 - 64 | 0;
  global$0 = $3;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h5566e1c7d4aafe35($3 + 24 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $4 = HEAP32[($3 + 28 | 0) >> 2] | 0;
   $5 = HEAP32[($3 + 24 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h6ed0b6b043905434($3 + 16 | 0 | 0, $1 | 0);
   if (!$2) {
    break label$1
   }
   $0 = HEAP32[($3 + 20 | 0) >> 2] | 0;
   $1 = HEAP32[($3 + 16 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h59b9713b6e595a95($3 + 8 | 0 | 0, $2 | 0);
   $2 = HEAP32[($3 + 12 | 0) >> 2] | 0;
   $6 = HEAP32[($3 + 8 | 0) >> 2] | 0;
   cardano_serialization_lib__NativeScript__hash__hb812a54d2c7bdca2($3 + 32 | 0 | 0, $1 | 0);
   cardano_serialization_lib__tx_builder__TransactionBuilder___set_mint_asset__hc476e2038680d8c6($5 | 0, $3 + 32 | 0 | 0, $1 | 0, $6 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($4 | 0, 0 | 0) | 0;
   global$0 = $3 + 64 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function privatekey_from_bech32($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  HEAP32[($2 + 92 | 0) >> 2] = $1;
  $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  HEAP32[($2 + 88 | 0) >> 2] = $0;
  cardano_serialization_lib__crypto__PrivateKey__from_bech32__h8decae3edee07559($2 + 16 | 0 | 0, $0 | 0, $1 | 0);
  core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_2($2 + 88 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 16 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  HEAP8[($2 + 90 | 0) >> 0] = HEAPU8[($2 + 19 | 0) >> 0] | 0;
  HEAP16[($2 + 88 | 0) >> 1] = HEAPU8[($2 + 17 | 0) >> 0] | 0 | ((HEAPU8[($2 + 18 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 91 | 0) >> 0] = $1;
  HEAP8[($2 + 92 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 93 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 94 | 0) >> 0] = $1 >>> 24 | 0;
  memcpy($2 + 88 | 0 | 7 | 0 | 0, $2 + 24 | 0 | 0, 58 | 0) | 0;
  $1 = $cardano_serialization_lib__crypto__PrivateKey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h7ffc55fb5b040fec($2 + 88 | 0 | 0) | 0;
  global$0 = $2 + 160 | 0;
  return $1 | 0;
 }
 
 function privatekey_from_extended_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  HEAP32[($2 + 92 | 0) >> 2] = $1;
  $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  HEAP32[($2 + 88 | 0) >> 2] = $0;
  cardano_serialization_lib__crypto__PrivateKey__from_extended_bytes__h462fe7830092bddc($2 + 16 | 0 | 0, $0 | 0, $1 | 0);
  core__ptr__drop_in_place_alloc__boxed__Box__5bu8_5d____h1049615268b5f7c4($2 + 88 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 16 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  HEAP8[($2 + 90 | 0) >> 0] = HEAPU8[($2 + 19 | 0) >> 0] | 0;
  HEAP16[($2 + 88 | 0) >> 1] = HEAPU8[($2 + 17 | 0) >> 0] | 0 | ((HEAPU8[($2 + 18 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 91 | 0) >> 0] = $1;
  HEAP8[($2 + 92 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 93 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 94 | 0) >> 0] = $1 >>> 24 | 0;
  memcpy($2 + 88 | 0 | 7 | 0 | 0, $2 + 24 | 0 | 0, 58 | 0) | 0;
  $1 = $cardano_serialization_lib__crypto__PrivateKey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h7ffc55fb5b040fec($2 + 88 | 0 | 0) | 0;
  global$0 = $2 + 160 | 0;
  return $1 | 0;
 }
 
 function privatekey_from_normal_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  HEAP32[($2 + 92 | 0) >> 2] = $1;
  $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  HEAP32[($2 + 88 | 0) >> 2] = $0;
  cardano_serialization_lib__crypto__PrivateKey__from_normal_bytes__h44894894715cde61($2 + 16 | 0 | 0, $0 | 0, $1 | 0);
  core__ptr__drop_in_place_alloc__boxed__Box__5bu8_5d____h1049615268b5f7c4($2 + 88 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 16 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  HEAP8[($2 + 90 | 0) >> 0] = HEAPU8[($2 + 19 | 0) >> 0] | 0;
  HEAP16[($2 + 88 | 0) >> 1] = HEAPU8[($2 + 17 | 0) >> 0] | 0 | ((HEAPU8[($2 + 18 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 91 | 0) >> 0] = $1;
  HEAP8[($2 + 92 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 93 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 94 | 0) >> 0] = $1 >>> 24 | 0;
  memcpy($2 + 88 | 0 | 7 | 0 | 0, $2 + 24 | 0 | 0, 58 | 0) | 0;
  $1 = $cardano_serialization_lib__crypto__PrivateKey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h7ffc55fb5b040fec($2 + 88 | 0 | 0) | 0;
  global$0 = $2 + 160 | 0;
  return $1 | 0;
 }
 
 function kessignature_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $31 = 0, $46 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__crypto__KESSignature__from_bytes__hac671a375e3a19d6($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 52 | 0) >> 2] = $46;
  HEAP32[($2 + 56 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 48 | 0) >> 2] = $1;
  $1 = $cardano_serialization_lib__crypto__KESSignature_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he0b1c3c8b6958e2e($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function plutusscript_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $31 = 0, $46 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__plutus__PlutusScript__from_bytes__ha2b1436fc2e8a74c($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 52 | 0) >> 2] = $46;
  HEAP32[($2 + 56 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 48 | 0) >> 2] = $1;
  $1 = $cardano_serialization_lib__plutus__PlutusScript_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h588df014a764c544($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function plutusscripts_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $31 = 0, $46 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__plutus__PlutusScripts__from_bytes__hee33110dca7bc2f8($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 52 | 0) >> 2] = $46;
  HEAP32[($2 + 56 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 48 | 0) >> 2] = $1;
  $1 = $cardano_serialization_lib__plutus__PlutusScripts_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hca65427e7f610652($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function costmodel_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $31 = 0, $46 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__plutus__CostModel__from_bytes__h4e439617ab5bc2d2($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 52 | 0) >> 2] = $46;
  HEAP32[($2 + 56 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 48 | 0) >> 2] = $1;
  $1 = $cardano_serialization_lib__plutus__CostModel_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h131279c16539114c($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function costmdls_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $31 = 0, $46 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__plutus__Costmdls__from_bytes__h00a7e8643f3fc4a8($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 52 | 0) >> 2] = $46;
  HEAP32[($2 + 56 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 48 | 0) >> 2] = $1;
  $1 = $cardano_serialization_lib__plutus__Costmdls_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8003415a0e008f0e($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function plutusmap_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $31 = 0, $46 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__plutus__PlutusMap__from_bytes__h05e340d90edaea31($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 52 | 0) >> 2] = $46;
  HEAP32[($2 + 56 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 48 | 0) >> 2] = $1;
  $1 = $cardano_serialization_lib__plutus__PlutusMap_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hc959583e66b458a0($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function redeemers_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $31 = 0, $46 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__plutus__Redeemers__from_bytes__h565f0ada353103c2($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 52 | 0) >> 2] = $46;
  HEAP32[($2 + 56 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 48 | 0) >> 2] = $1;
  $1 = $cardano_serialization_lib__plutus__Redeemers_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hb4f0431e16335b87($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function $serde_json__value__de__KeyClassifier_20as_20serde__de__DeserializeSeed___deserialize__h8d10a2630f030965($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  HEAP32[($1 + 20 | 0) >> 2] = 0;
  HEAP32[($1 + 8 | 0) >> 2] = (HEAP32[($1 + 8 | 0) >> 2] | 0) + 1 | 0;
  $serde_json__read__StrRead_20as_20serde_json__read__Read___parse_str__h09f2a2399a6a37b5($2 + 16 | 0 | 0, $1 | 0, $1 + 12 | 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $3 = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
    $1 = HEAP32[(($2 + 16 | 0) + 12 | 0) >> 2] | 0;
    alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 + 8 | 0 | 0, $1 | 0, 0 | 0);
    $4 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $3 = memcpy(HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, $3 | 0, $1 | 0) | 0;
    HEAP32[($0 + 12 | 0) >> 2] = $1;
    HEAP32[($0 + 8 | 0) >> 2] = $4;
    HEAP32[($0 + 4 | 0) >> 2] = $3;
    HEAP32[$0 >> 2] = 0;
    break label$1;
   }
   HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($2 + 20 | 0) >> 2] | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $2 + 32 | 0;
 }
 
 function $std__panicking__begin_panic_handler__PanicPayload_20as_20core__panic__BoxMeUp___get__h7b8b2eb260312b34($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $3 = 0, $24 = 0, $30 = 0, $33 = 0, $47 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  $3 = $1 + 4 | 0;
  label$1 : {
   if (HEAP32[($1 + 4 | 0) >> 2] | 0) {
    break label$1
   }
   $1 = HEAP32[$1 >> 2] | 0;
   i64toi32_i32$1 = $2;
   i64toi32_i32$0 = 0;
   HEAP32[($2 + 12 | 0) >> 2] = 0;
   HEAP32[($2 + 16 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($2 + 8 | 0) >> 2] = HEAP32[(0 + 1142628 | 0) >> 2] | 0;
   HEAP32[($2 + 20 | 0) >> 2] = $2 + 8 | 0;
   i64toi32_i32$2 = $1 + 16 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $24 = i64toi32_i32$0;
   i64toi32_i32$0 = ($2 + 24 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $24;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1 + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $30 = i64toi32_i32$1;
   i64toi32_i32$1 = ($2 + 24 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $30;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $1;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $33 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   HEAP32[($2 + 24 | 0) >> 2] = $33;
   HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$1;
   core__fmt__write__h9b9aa23e7d35702c($2 + 20 | 0 | 0, 1142220 | 0, $2 + 24 | 0 | 0) | 0;
   HEAP32[($3 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $47 = i64toi32_i32$1;
   i64toi32_i32$1 = $3;
   HEAP32[i64toi32_i32$1 >> 2] = $47;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  }
  HEAP32[($0 + 4 | 0) >> 2] = 1144336;
  HEAP32[$0 >> 2] = $3;
  global$0 = $2 + 48 | 0;
 }
 
 function core__fmt__builders__DebugStruct__finish_non_exhaustive__h85bef67279d23f66($0) {
  $0 = $0 | 0;
  var $2 = 0, $1 = 0, $3 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $2 = 1;
  label$1 : {
   if (HEAPU8[($0 + 4 | 0) >> 0] | 0) {
    break label$1
   }
   label$2 : {
    if (HEAPU8[($0 + 5 | 0) >> 0] | 0) {
     break label$2
    }
    $2 = HEAP32[$0 >> 2] | 0;
    $2 = FUNCTION_TABLE[HEAP32[((HEAP32[($2 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($2 + 24 | 0) >> 2] | 0, 1149884, 7) | 0;
    break label$1;
   }
   label$3 : {
    $3 = HEAP32[$0 >> 2] | 0;
    if ((HEAPU8[$3 >> 0] | 0) & 4 | 0) {
     break label$3
    }
    $2 = FUNCTION_TABLE[HEAP32[((HEAP32[($3 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($3 + 24 | 0) >> 2] | 0, 1149878, 6) | 0;
    break label$1;
   }
   $2 = 1;
   HEAP8[($1 + 15 | 0) >> 0] = 1;
   i64toi32_i32$1 = HEAP32[($3 + 28 | 0) >> 2] | 0;
   HEAP32[$1 >> 2] = HEAP32[($3 + 24 | 0) >> 2] | 0;
   HEAP32[($1 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($1 + 8 | 0) >> 2] = $1 + 15 | 0;
   if ($core__fmt__builders__PadAdapter_20as_20core__fmt__Write___write_str__h2104fbe324f8507b($1 | 0, 1149874 | 0, 3 | 0) | 0) {
    break label$1
   }
   $2 = FUNCTION_TABLE[HEAP32[((HEAP32[($3 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($3 + 24 | 0) >> 2] | 0, 1149877, 1) | 0;
  }
  HEAP8[($0 + 4 | 0) >> 0] = $2;
  global$0 = $1 + 16 | 0;
  return $2 | 0;
 }
 
 function cardano_serialization_lib__Ipv4__new_impl__h0051960675f6052f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, $2 = 0, $3 = 0, i64toi32_i32$1 = 0, $7 = 0, $8 = 0, $27 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    $3 = core__array___impl_20core__convert__TryFrom___5bT_5d__20for_20__5bT_3b_20N_5d___try_from__hcd1b24c5ed929e22(HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0) | 0;
    if (!$3) {
     break label$2
    }
    $7 = $3;
    $8 = HEAPU8[$7 >> 0] | 0 | ((HEAPU8[($7 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($7 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($7 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    HEAP8[($0 + 1 | 0) >> 0] = $8;
    HEAP8[($0 + 2 | 0) >> 0] = $8 >>> 8 | 0;
    HEAP8[($0 + 3 | 0) >> 0] = $8 >>> 16 | 0;
    HEAP8[($0 + 4 | 0) >> 0] = $8 >>> 24 | 0;
    $3 = 0;
    break label$1;
   }
   i64toi32_i32$0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = 0;
   alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($0 + 56 | 0 | 0, 1053572 | 0, 4 | 0);
   $27 = i64toi32_i32$0;
   i64toi32_i32$0 = $0 + 48 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $27;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$0 = $0 + 40 | 0;
   i64toi32_i32$1 = 0;
   HEAP32[i64toi32_i32$0 >> 2] = 1;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$0 = $0 + 32 | 0;
   i64toi32_i32$1 = 0;
   HEAP32[i64toi32_i32$0 >> 2] = 4;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($0 + 24 | 0) >> 2] = 19;
   HEAP32[($0 + 20 | 0) >> 2] = 1053592;
   HEAP8[($0 + 16 | 0) >> 0] = 13;
   HEAP8[($0 + 8 | 0) >> 0] = 2;
   $3 = 1;
  }
  HEAP8[$0 >> 0] = $3;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  global$0 = $2 + 16 | 0;
 }
 
 function nativescript_new_script_all($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $11 = 0, $12 = 0, $13 = 0, $14 = 0, $15 = 0, $16 = 0, $2 = 0, $28 = 0, $31 = 0, $35 = 0, $45 = 0, $49 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hcc9e595588038ff3($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($1 + 32 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  $11 = $1 + 59 | 0;
  $12 = HEAP32[(($1 + 32 | 0) + 8 | 0) >> 2] | 0;
  HEAP8[$11 >> 0] = $12;
  HEAP8[($11 + 1 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[($11 + 2 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[($11 + 3 | 0) >> 0] = $12 >>> 24 | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[($1 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 36 | 0) >> 2] | 0;
  $28 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  $13 = $28;
  HEAP8[($1 + 51 | 0) >> 0] = $13;
  HEAP8[($1 + 52 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[($1 + 53 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[($1 + 54 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[($1 + 55 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[($1 + 56 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[($1 + 57 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[($1 + 58 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAPU8[($1 + 48 | 0) >> 0] | 0 | ((HEAPU8[($1 + 49 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 50 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 51 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[($1 + 52 | 0) >> 0] | 0 | ((HEAPU8[($1 + 53 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 54 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 55 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $31 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[($1 + 16 | 0) >> 2] = $31;
  HEAP32[($1 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1 + 55 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $35 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  $14 = $35;
  HEAP8[($1 + 23 | 0) >> 0] = $14;
  HEAP8[($1 + 24 | 0) >> 0] = $14 >>> 8 | 0;
  HEAP8[($1 + 25 | 0) >> 0] = $14 >>> 16 | 0;
  HEAP8[($1 + 26 | 0) >> 0] = $14 >>> 24 | 0;
  HEAP8[($1 + 27 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[($1 + 28 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[($1 + 29 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[($1 + 30 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAPU8[($1 + 23 | 0) >> 0] | 0 | ((HEAPU8[($1 + 24 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 25 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 26 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[($1 + 27 | 0) >> 0] | 0 | ((HEAPU8[($1 + 28 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 29 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 30 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $45 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 48 | 0) + 8 | 0;
  $15 = $45;
  HEAP8[i64toi32_i32$1 >> 0] = $15;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $15 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $15 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $15 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP8[($1 + 48 | 0) >> 0] = 1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[($1 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  $49 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  $16 = $49;
  HEAP8[($1 + 49 | 0) >> 0] = $16;
  HEAP8[($1 + 50 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[($1 + 51 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[($1 + 52 | 0) >> 0] = $16 >>> 24 | 0;
  HEAP8[($1 + 53 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[($1 + 54 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[($1 + 55 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[($1 + 56 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $0 = $cardano_serialization_lib__NativeScript_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h345d8ecbe77ecc63($1 + 48 | 0 | 0) | 0;
  global$0 = $1 + 80 | 0;
  return $0 | 0;
 }
 
 function nativescript_new_script_any($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $11 = 0, $12 = 0, $13 = 0, $14 = 0, $15 = 0, $16 = 0, $2 = 0, $28 = 0, $31 = 0, $35 = 0, $45 = 0, $49 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hc49defd7d95949da($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($1 + 32 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  $11 = $1 + 59 | 0;
  $12 = HEAP32[(($1 + 32 | 0) + 8 | 0) >> 2] | 0;
  HEAP8[$11 >> 0] = $12;
  HEAP8[($11 + 1 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[($11 + 2 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[($11 + 3 | 0) >> 0] = $12 >>> 24 | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[($1 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 36 | 0) >> 2] | 0;
  $28 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  $13 = $28;
  HEAP8[($1 + 51 | 0) >> 0] = $13;
  HEAP8[($1 + 52 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[($1 + 53 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[($1 + 54 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[($1 + 55 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[($1 + 56 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[($1 + 57 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[($1 + 58 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAPU8[($1 + 48 | 0) >> 0] | 0 | ((HEAPU8[($1 + 49 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 50 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 51 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[($1 + 52 | 0) >> 0] | 0 | ((HEAPU8[($1 + 53 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 54 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 55 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $31 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[($1 + 16 | 0) >> 2] = $31;
  HEAP32[($1 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1 + 55 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $35 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  $14 = $35;
  HEAP8[($1 + 23 | 0) >> 0] = $14;
  HEAP8[($1 + 24 | 0) >> 0] = $14 >>> 8 | 0;
  HEAP8[($1 + 25 | 0) >> 0] = $14 >>> 16 | 0;
  HEAP8[($1 + 26 | 0) >> 0] = $14 >>> 24 | 0;
  HEAP8[($1 + 27 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[($1 + 28 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[($1 + 29 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[($1 + 30 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAPU8[($1 + 23 | 0) >> 0] | 0 | ((HEAPU8[($1 + 24 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 25 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 26 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[($1 + 27 | 0) >> 0] | 0 | ((HEAPU8[($1 + 28 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 29 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 30 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $45 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 48 | 0) + 8 | 0;
  $15 = $45;
  HEAP8[i64toi32_i32$1 >> 0] = $15;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $15 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $15 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $15 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP8[($1 + 48 | 0) >> 0] = 2;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[($1 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  $49 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  $16 = $49;
  HEAP8[($1 + 49 | 0) >> 0] = $16;
  HEAP8[($1 + 50 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[($1 + 51 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[($1 + 52 | 0) >> 0] = $16 >>> 24 | 0;
  HEAP8[($1 + 53 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[($1 + 54 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[($1 + 55 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[($1 + 56 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $0 = $cardano_serialization_lib__NativeScript_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h345d8ecbe77ecc63($1 + 48 | 0 | 0) | 0;
  global$0 = $1 + 80 | 0;
  return $0 | 0;
 }
 
 function cardano_serialization_lib__utils__internal_get_deposit__h544d8f4f3a980a59($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $5$hi = 0, i64toi32_i32$4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, $5 = 0, $4 = 0, i64toi32_i32$3 = 0, $8$hi = 0, $8 = 0, $6$hi = 0, $7$hi = 0, $6 = 0, $7 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  i64toi32_i32$0 = 0;
  $5 = 0;
  $5$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    label$3 : {
     $4 = HEAP32[$1 >> 2] | 0;
     if (!$4) {
      break label$3
     }
     $1 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     if (!$1) {
      break label$3
     }
     $1 = Math_imul($1, 200);
     i64toi32_i32$2 = $3;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $6 = i64toi32_i32$0;
     $6$hi = i64toi32_i32$1;
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $7 = i64toi32_i32$1;
     $7$hi = i64toi32_i32$0;
     i64toi32_i32$0 = 0;
     $5 = 0;
     $5$hi = i64toi32_i32$0;
     label$4 : while (1) {
      label$5 : {
       label$6 : {
        switch (HEAPU8[$4 >> 0] | 0 | 0) {
        case 0:
         i64toi32_i32$0 = $5$hi;
         i64toi32_i32$0 = $6$hi;
         i64toi32_i32$0 = $5$hi;
         i64toi32_i32$2 = $5;
         i64toi32_i32$1 = $6$hi;
         i64toi32_i32$3 = $6;
         i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
         i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
         if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
          i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
         }
         $8 = i64toi32_i32$4;
         $8$hi = i64toi32_i32$5;
         i64toi32_i32$5 = $5$hi;
         i64toi32_i32$5 = $8$hi;
         i64toi32_i32$0 = i64toi32_i32$4;
         i64toi32_i32$2 = $5$hi;
         i64toi32_i32$3 = $5;
         if (i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0) {
          break label$2
         }
         i64toi32_i32$0 = $8$hi;
         $5 = $8;
         $5$hi = i64toi32_i32$0;
         break label$5;
        case 3:
         break label$6;
        default:
         break label$5;
        };
       }
       i64toi32_i32$0 = $5$hi;
       i64toi32_i32$0 = $7$hi;
       i64toi32_i32$0 = $5$hi;
       i64toi32_i32$3 = $5;
       i64toi32_i32$5 = $7$hi;
       i64toi32_i32$2 = $7;
       i64toi32_i32$1 = i64toi32_i32$3 + i64toi32_i32$2 | 0;
       i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
       if (i64toi32_i32$1 >>> 0 < i64toi32_i32$2 >>> 0) {
        i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
       }
       $8 = i64toi32_i32$1;
       $8$hi = i64toi32_i32$4;
       i64toi32_i32$4 = $5$hi;
       i64toi32_i32$4 = $8$hi;
       i64toi32_i32$0 = i64toi32_i32$1;
       i64toi32_i32$3 = $5$hi;
       i64toi32_i32$2 = $5;
       if (i64toi32_i32$4 >>> 0 < $5$hi >>> 0 | ((i64toi32_i32$4 | 0) == ($5$hi | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0) {
        break label$2
       }
       i64toi32_i32$0 = $8$hi;
       $5 = $8;
       $5$hi = i64toi32_i32$0;
      }
      $4 = $4 + 200 | 0;
      $1 = $1 + -200 | 0;
      if ($1) {
       continue label$4
      }
      break label$4;
     };
    }
    i64toi32_i32$0 = $5$hi;
    i64toi32_i32$4 = $0 + 8 | 0;
    HEAP32[i64toi32_i32$4 >> 2] = $5;
    HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$0;
    $4 = 0;
    break label$1;
   }
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1058732 | 0, 8 | 0) | 0 | 0) | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
   $4 = 1;
  }
  HEAP32[$0 >> 2] = $4;
 }
 
 function core__ops__function__impls___impl_20core__ops__function__FnOnce_A__20for_20_mut_20F___call_once__ha9dfc67ebd737082($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $23 = 0, $28 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    switch (HEAP32[$2 >> 2] | 0 | 0) {
    default:
     $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__hdeea20968268d729($4 + 8 | 0 | 0, $2 + 8 | 0 | 0);
     HEAP32[$4 >> 2] = 0;
     break label$1;
    case 1:
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hf69db734dd831996($4 | 4 | 0 | 0, $2 + 4 | 0 | 0);
     HEAP32[$4 >> 2] = 1;
     break label$1;
    case 2:
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
     $23 = i64toi32_i32$0;
     i64toi32_i32$0 = $4 + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $23;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $2 + 16 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $28 = i64toi32_i32$1;
     i64toi32_i32$1 = $4 + 16 | 0;
     HEAP32[i64toi32_i32$1 >> 2] = $28;
     HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
     HEAP32[$4 >> 2] = 2;
     break label$1;
    case 3:
     $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($4 | 4 | 0 | 0, $2 + 4 | 0 | 0);
     HEAP32[$4 >> 2] = 3;
     break label$1;
    case 4:
     break label$2;
    };
   }
   $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($4 | 4 | 0 | 0, $2 + 4 | 0 | 0);
   HEAP32[$4 >> 2] = 4;
  }
  memcpy($0 | 0, $4 | 0, 48 | 0) | 0;
  global$0 = $4 + 48 | 0;
 }
 
 function metadatamap_get($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 128 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h74f2437fd791f127($2 + 16 | 0 | 0, $0 | 0);
    if (!$1) {
     break label$2
    }
    $0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
    $3 = HEAP32[($2 + 16 | 0) >> 2] | 0;
    wasm_bindgen____rt__WasmRefCell_T___borrow__hc630c86c4ab6b26d($2 + 8 | 0 | 0, $1 | 0);
    $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    cardano_serialization_lib__metadata__MetadataMap__get__hfdac1fad098610ea($2 + 24 | 0 | 0, $3 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    memcpy($2 + 80 | 0 | 0, $2 + 32 | 0 | 0, 48 | 0) | 0;
    $0 = $cardano_serialization_lib__metadata__TransactionMetadatum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hce2feba55b67d086($2 + 80 | 0 | 0) | 0;
    global$0 = $2 + 128 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 28 | 0) >> 2] | 0 | 0);
  abort();
 }
 
 function privatekey_sign($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0;
  $3 = global$0 - 160 | 0;
  global$0 = $3;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h09a25d0fa720925e($3 + 16 | 0 | 0, $0 | 0);
  $0 = HEAP32[($3 + 20 | 0) >> 2] | 0;
  $4 = HEAP32[($3 + 16 | 0) >> 2] | 0;
  HEAP32[($3 + 104 | 0) >> 2] = $2;
  HEAP32[($3 + 100 | 0) >> 2] = $2;
  HEAP32[($3 + 96 | 0) >> 2] = $1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($3 + 8 | 0 | 0, $3 + 96 | 0 | 0);
  $2 = HEAP32[($3 + 12 | 0) >> 2] | 0;
  HEAP32[($3 + 92 | 0) >> 2] = $2;
  $1 = HEAP32[($3 + 8 | 0) >> 2] | 0;
  HEAP32[($3 + 88 | 0) >> 2] = $1;
  cardano_serialization_lib__crypto__PrivateKey__sign__habe0df84ae280136($3 + 24 | 0 | 0, $4 | 0, $1 | 0, $2 | 0);
  core__ptr__drop_in_place_alloc__boxed__Box__5bu8_5d____h1049615268b5f7c4($3 + 88 | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  memcpy($3 + 96 | 0 | 0, $3 + 24 | 0 | 0, 64 | 0) | 0;
  $0 = $cardano_serialization_lib__crypto__Ed25519Signature_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h20d7210aa6eb2b19($3 + 96 | 0 | 0) | 0;
  global$0 = $3 + 160 | 0;
  return $0 | 0;
 }
 
 function byronaddress_from_address($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 128 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hab2c0cbdcb539b91($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   cardano_serialization_lib__address__ByronAddress__from_address__hda2f43a52fcf6ed4($1 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   $0 = 0;
   label$2 : {
    $2 = HEAP32[($1 + 28 | 0) >> 2] | 0;
    if (($2 | 0) == (2 | 0)) {
     break label$2
    }
    HEAP32[(($1 + 72 | 0) + 8 | 0) >> 2] = HEAP32[(($1 + 16 | 0) + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
    HEAP32[($1 + 72 | 0) >> 2] = HEAP32[($1 + 16 | 0) >> 2] | 0;
    HEAP32[($1 + 76 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($1 + 84 | 0) >> 2] = $2;
    memcpy(($1 + 72 | 0) + 16 | 0 | 0, ($1 + 16 | 0) + 16 | 0 | 0, 36 | 0) | 0;
    $0 = $cardano_serialization_lib__address__ByronAddress_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbc0eb32d6a95f2a3($1 + 72 | 0 | 0) | 0;
   }
   global$0 = $1 + 128 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function $_28_A_2c_B_2c_C_29_20as_20cbor_event__se__Serialize___serialize__h6e5b7c5a6d89b7b1($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $3 = global$0 - 112 | 0;
  global$0 = $3;
  (wasm2js_i32$0 = $3, wasm2js_i32$1 = cbor_event__types__Type__to_byte__h30363627277739c1(4 | 0, 3 | 0) | 0), HEAP8[(wasm2js_i32$0 + 111 | 0) >> 0] = wasm2js_i32$1;
  alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($2 | 0, $3 + 111 | 0 | 0, 1 | 0);
  $cardano_serialization_lib__legacy_address__address__AddrType_20as_20cbor_event__se__Serialize___serialize__hfd384f59239299b2($3 + 56 | 0 | 0, HEAP32[$1 >> 2] | 0 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[($3 + 56 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $cardano_serialization_lib__legacy_address__address__SpendingData_20as_20cbor_event__se__Serialize___serialize__h35a1209176b0e5ef($3 + 8 | 0 | 0, HEAP32[($1 + 4 | 0) >> 2] | 0 | 0, HEAP32[($3 + 60 | 0) >> 2] | 0 | 0);
    label$3 : {
     if ((HEAP32[($3 + 8 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     $cardano_serialization_lib__legacy_address__address__Attributes_20as_20cbor_event__se__Serialize___serialize__haf99c3c1d66b9efa($0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0, HEAP32[($3 + 12 | 0) >> 2] | 0 | 0);
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, ($3 + 8 | 0) + 8 | 0 | 0, 40 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, ($3 + 56 | 0) + 8 | 0 | 0, 40 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $3 + 112 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___shrink__h45d229397ea2ceca($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $4 = 0, $3 = 0, i64toi32_i32$0 = 0, $7 = 0, $8 = 0, $5 = 0, $6 = 0, i64toi32_i32$1 = 0, $41 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     if ($4 >>> 0 < $2 >>> 0) {
      break label$3
     }
     $5 = 0;
     if (!$4) {
      break label$1
     }
     $4 = $4 << 2 | 0;
     $6 = $T_20as_20core__convert__Into_U____into__h6ba7948e905b65a3(HEAP32[$1 >> 2] | 0 | 0) | 0;
     label$4 : {
      $7 = $2 << 2 | 0;
      if ($7) {
       break label$4
      }
      $8 = 4;
      if (!$4) {
       break label$2
      }
      __rust_dealloc($6 | 0, $4 | 0, 4 | 0);
      break label$2;
     }
     $8 = __rust_realloc($6 | 0, $4 | 0, 4 | 0, $7 | 0) | 0;
     if ($8) {
      break label$2
     }
     $T_20as_20core__convert__From_T____from__h649eab7147d45d59();
     $T_20as_20core__convert__From_T____from__habe767dd23f4ed05($3 + 8 | 0 | 0, $7 | 0, 4 | 0);
     i64toi32_i32$0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
     $41 = i64toi32_i32$0;
     i64toi32_i32$0 = $0;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $41;
     HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
     $5 = 1;
     break label$1;
    }
    core__panicking__panic__h2fd385a887c8bf13(1076264 | 0, 36 | 0, 1076300 | 0);
    abort();
   }
   HEAP32[$1 >> 2] = $8;
   HEAP32[($1 + 4 | 0) >> 2] = $2 & 1073741823 | 0;
  }
  HEAP32[$0 >> 2] = $5;
  global$0 = $3 + 16 | 0;
 }
 
 function $num_bigint__bigint__BigInt_20as_20core__fmt__Display___fmt__h1c76768a124ae632($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $7 = 0, $4 = 0, $6 = 0, $5 = 0, $3 = 0, $8 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $3 = HEAPU8[($0 + 12 | 0) >> 0] | 0;
  num_bigint__biguint__convert__to_str_radix_reversed__h8137d6cf34f7ce10($2 | 0, $0 | 0, 10 | 0);
  $4 = HEAP32[$2 >> 2] | 0;
  label$1 : {
   $5 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   $6 = $5 >>> 1 | 0;
   if (!$6) {
    break label$1
   }
   $0 = ($5 + $4 | 0) + -1 | 0;
   $7 = $4;
   label$2 : while (1) {
    $8 = HEAPU8[$7 >> 0] | 0;
    HEAP8[$7 >> 0] = HEAPU8[$0 >> 0] | 0;
    HEAP8[$0 >> 0] = $8;
    $7 = $7 + 1 | 0;
    $0 = $0 + -1 | 0;
    $6 = $6 + -1 | 0;
    if ($6) {
     continue label$2
    }
    break label$2;
   };
  }
  $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $7 = core__fmt__Formatter__pad_integral__h08e3e53a0de517a1($1 | 0, ($3 & 255 | 0 | 0) != (0 | 0) | 0, 1083404 | 0, 0 | 0, $4 | 0, $5 | 0) | 0;
  label$3 : {
   if (!$0) {
    break label$3
   }
   __rust_dealloc($4 | 0, $0 | 0, 1 | 0);
  }
  global$0 = $2 + 16 | 0;
  return $7 | 0;
 }
 
 function alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal___push__hc0dce87587d46cdc($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $11 = 0, $12 = 0, $13 = 0, $14 = 0, $15 = 0, $16 = 0, $4 = 0, $23 = 0, $28 = 0, $33 = 0;
  label$1 : {
   label$2 : {
    if (((HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) != ($2 | 0)) {
     break label$2
    }
    $0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    $4 = HEAPU16[($0 + 6 | 0) >> 1] | 0;
    if ($4 >>> 0 <= 10 >>> 0) {
     break label$1
    }
    core__panicking__panic__h2fd385a887c8bf13(1048619 | 0, 32 | 0, 1048824 | 0);
    abort();
   }
   core__panicking__panic__h2fd385a887c8bf13(1048760 | 0, 48 | 0, 1048808 | 0);
   abort();
  }
  $2 = $0 + Math_imul($4, 28) | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[$1 >> 0] | 0 | ((HEAPU8[($1 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[($1 + 4 | 0) >> 0] | 0 | ((HEAPU8[($1 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($1 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($1 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $23 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 8 | 0;
  $11 = $23;
  HEAP8[i64toi32_i32$0 >> 0] = $11;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 16 | 0;
  $12 = $28;
  HEAP8[i64toi32_i32$1 >> 0] = $12;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $33 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 24 | 0;
  $13 = $33;
  HEAP8[i64toi32_i32$0 >> 0] = $13;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $14 = $1 + 24 | 0;
  $15 = $2 + 32 | 0;
  $16 = HEAPU8[$14 >> 0] | 0 | ((HEAPU8[($14 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($14 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($14 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  HEAP8[$15 >> 0] = $16;
  HEAP8[($15 + 1 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[($15 + 2 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[($15 + 3 | 0) >> 0] = $16 >>> 24 | 0;
  $1 = $4 + 1 | 0;
  HEAP16[($0 + 6 | 0) >> 1] = $1;
  HEAP32[(($0 + ($1 << 2 | 0) | 0) + 316 | 0) >> 2] = $3;
  HEAP16[($3 + 4 | 0) >> 1] = $1;
  HEAP32[$3 >> 2] = $0;
 }
 
 function cardano_serialization_lib__MIRToStakeCredentials__insert__h359d09a35f3dc818($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $4 = 0, $20 = 0, $22 = 0, $23 = 0, $24 = 0, $25 = 0, $26 = 0, $15 = 0, $21 = 0, $33 = 0, $40 = 0, $40$hi = 0, $43 = 0, $43$hi = 0, $5 = 0, $5$hi = 0, $6 = 0, $6$hi = 0, $53 = 0;
  $4 = global$0 - 96 | 0;
  global$0 = $4;
  i64toi32_i32$2 = $2 + 9 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = ($4 + 32 | 0) + 9 | 0;
  $20 = $15;
  HEAP8[i64toi32_i32$0 >> 0] = $20;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $20 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $20 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $20 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 17 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = ($4 + 32 | 0) + 17 | 0;
  $22 = $21;
  HEAP8[i64toi32_i32$1 >> 0] = $22;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $22 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $22 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $22 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $23 = $2 + 25 | 0;
  $24 = ($4 + 32 | 0) + 25 | 0;
  $25 = HEAPU8[$23 >> 0] | 0 | ((HEAPU8[($23 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($23 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($23 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  HEAP8[$24 >> 0] = $25;
  HEAP8[($24 + 1 | 0) >> 0] = $25 >>> 8 | 0;
  HEAP8[($24 + 2 | 0) >> 0] = $25 >>> 16 | 0;
  HEAP8[($24 + 3 | 0) >> 0] = $25 >>> 24 | 0;
  HEAP8[($4 + 32 | 0) >> 0] = HEAPU8[$2 >> 0] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $33 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  $26 = $33;
  HEAP8[(i64toi32_i32$0 + 33 | 0) >> 0] = $26;
  HEAP8[(i64toi32_i32$0 + 34 | 0) >> 0] = $26 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 35 | 0) >> 0] = $26 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 36 | 0) >> 0] = $26 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 37 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 38 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 39 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 40 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $40 = i64toi32_i32$1;
  $40$hi = i64toi32_i32$0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $43 = i64toi32_i32$0;
  $43$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $40$hi;
  i64toi32_i32$0 = $43$hi;
  linked_hash_map__LinkedHashMap_K_2cV_2cS___insert__h3e59fdce083c9794($4 + 8 | 0 | 0, $1 | 0, $4 + 32 | 0 | 0, $40 | 0, i64toi32_i32$1 | 0, $43 | 0, i64toi32_i32$0 | 0);
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $6 = i64toi32_i32$1;
  $6$hi = i64toi32_i32$0;
  i64toi32_i32$2 = (i64toi32_i32$2 + 8 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $53 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $53;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $6;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $5$hi;
  HEAP32[i64toi32_i32$0 >> 2] = $5;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $4 + 96 | 0;
 }
 
 function singlehostaddr_ipv6($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $1 = 0, i64toi32_i32$1 = 0, $2 = 0, $3 = 0, $25 = 0, $28 = 0, $38 = 0, $41 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h7fe2cd68d7de412a($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   label$2 : {
    label$3 : {
     $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     if ((HEAPU8[($2 + 9 | 0) >> 0] | 0 | 0) != (1 | 0)) {
      break label$3
     }
     $3 = ($1 + 16 | 0) + 8 | 0;
     i64toi32_i32$2 = $2 + 18 | 0;
     i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $25 = i64toi32_i32$0;
     i64toi32_i32$0 = $3;
     HEAP32[i64toi32_i32$0 >> 2] = $25;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 10 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 11 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 12 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 13 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 14 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 15 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 16 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 17 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
     $28 = i64toi32_i32$1;
     i64toi32_i32$1 = $1;
     HEAP32[($1 + 16 | 0) >> 2] = $28;
     HEAP32[($1 + 20 | 0) >> 2] = i64toi32_i32$0;
     core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
     i64toi32_i32$2 = $3;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $38 = i64toi32_i32$0;
     i64toi32_i32$0 = ($1 + 32 | 0) + 8 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $38;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $1;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
     $41 = i64toi32_i32$1;
     i64toi32_i32$1 = i64toi32_i32$2;
     HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] = $41;
     HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] = i64toi32_i32$0;
     $0 = $cardano_serialization_lib__Ipv6_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h2867aea60f7881bf(i64toi32_i32$2 + 32 | 0 | 0) | 0;
     break label$2;
    }
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    $0 = 0;
   }
   global$0 = $1 + 48 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function relay_as_single_host_addr($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $9 = 0, $10 = 0, $11 = 0, $32 = 0, $39 = 0, $44 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb17ff77b9b324998($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   cardano_serialization_lib__Relay__as_single_host_addr__h2648a96a2eee1018($1 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   $0 = 0;
   label$2 : {
    $2 = HEAPU16[($1 + 16 | 0) >> 1] | 0;
    if (($2 | 0) == (2 | 0)) {
     break label$2
    }
    i64toi32_i32$2 = ($1 + 16 | 0) + 10 | 0;
    i64toi32_i32$0 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
    i64toi32_i32$1 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
    $32 = i64toi32_i32$0;
    i64toi32_i32$0 = ($1 + 48 | 0) + 10 | 0;
    $9 = $32;
    HEAP16[i64toi32_i32$0 >> 1] = $9;
    HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $9 >>> 16 | 0;
    HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$1;
    HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
    i64toi32_i32$2 = ($1 + 16 | 0) + 18 | 0;
    i64toi32_i32$1 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
    i64toi32_i32$0 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
    $39 = i64toi32_i32$1;
    i64toi32_i32$1 = ($1 + 48 | 0) + 18 | 0;
    $10 = $39;
    HEAP16[i64toi32_i32$1 >> 1] = $10;
    HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $10 >>> 16 | 0;
    HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = i64toi32_i32$0;
    HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
    HEAP16[($1 + 48 | 0) >> 1] = $2;
    i64toi32_i32$2 = $1;
    i64toi32_i32$0 = HEAPU16[($1 + 18 | 0) >> 1] | 0 | ((HEAPU16[($1 + 20 | 0) >> 1] | 0) << 16 | 0) | 0;
    i64toi32_i32$1 = HEAPU16[($1 + 22 | 0) >> 1] | 0 | ((HEAPU16[($1 + 24 | 0) >> 1] | 0) << 16 | 0) | 0;
    $44 = i64toi32_i32$0;
    i64toi32_i32$0 = $1;
    $11 = $44;
    HEAP16[($1 + 50 | 0) >> 1] = $11;
    HEAP16[($1 + 52 | 0) >> 1] = $11 >>> 16 | 0;
    HEAP16[($1 + 54 | 0) >> 1] = i64toi32_i32$1;
    HEAP16[($1 + 56 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
    $0 = $cardano_serialization_lib__SingleHostAddr_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h118dc31a83c6b0e2($1 + 48 | 0 | 0) | 0;
   }
   global$0 = $1 + 80 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function multiasset_get($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h9968e42c55861cec($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h27da893e95dd15cf($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__MultiAsset__get__had0c36a2c855d776($2 + 16 | 0 | 0, $3 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   $0 = 0;
   label$2 : {
    if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    HEAP32[($2 + 40 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
    HEAP32[($2 + 32 | 0) >> 2] = HEAP32[($2 + 20 | 0) >> 2] | 0;
    HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
    $0 = $cardano_serialization_lib__Assets_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hf61728444da3586d($2 + 32 | 0 | 0) | 0;
   }
   global$0 = $2 + 48 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function multiasset_get_asset($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, $5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0;
  $3 = global$0 - 32 | 0;
  global$0 = $3;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h9968e42c55861cec($3 + 24 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($3 + 28 | 0) >> 2] | 0;
   $4 = HEAP32[($3 + 24 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h27da893e95dd15cf($3 + 16 | 0 | 0, $1 | 0);
   if (!$2) {
    break label$1
   }
   $1 = HEAP32[($3 + 20 | 0) >> 2] | 0;
   $5 = HEAP32[($3 + 16 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h9c68abd5a6a78973($3 + 8 | 0 | 0, $2 | 0);
   $2 = HEAP32[($3 + 12 | 0) >> 2] | 0;
   i64toi32_i32$0 = cardano_serialization_lib__MultiAsset__get_asset__h0abde100680c5c0a($4 | 0, $5 | 0, HEAP32[($3 + 8 | 0) >> 2] | 0 | 0) | 0;
   i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
   core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810(i64toi32_i32$0 | 0, i64toi32_i32$1 | 0) | 0;
   global$0 = $3 + 32 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function mint_get($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h8348e40d8f63e5f1($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h27da893e95dd15cf($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__Mint__get__h44e1f89db570ad02($2 + 16 | 0 | 0, $3 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   $0 = 0;
   label$2 : {
    if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    HEAP32[($2 + 40 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
    HEAP32[($2 + 32 | 0) >> 2] = HEAP32[($2 + 20 | 0) >> 2] | 0;
    HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
    $0 = $cardano_serialization_lib__MintAssets_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h828d55d3b5b95763($2 + 32 | 0 | 0) | 0;
   }
   global$0 = $2 + 48 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function $u16_20as_20cbor_event__de__Deserialize___deserialize__h16dd941998750727($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$0 = 0, $3 = 0, $3$hi = 0, $22 = 0, $27 = 0, $32 = 0, $37 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___unsigned_integer__h1ed99c0b7fe7eea1($2 | 0, $1 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $3 = i64toi32_i32$0;
  $3$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$1 = 0;
     i64toi32_i32$3 = 1;
     if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
      break label$3
     }
     i64toi32_i32$2 = $3$hi;
     i64toi32_i32$3 = $3;
     i64toi32_i32$0 = 0;
     i64toi32_i32$1 = 65535;
     if (i64toi32_i32$2 >>> 0 > i64toi32_i32$0 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$3 >>> 0 > i64toi32_i32$1 >>> 0 | 0) | 0) {
      break label$2
     }
     i64toi32_i32$3 = $3$hi;
     HEAP16[($0 + 2 | 0) >> 1] = $3;
     $1 = 0;
     break label$1;
    }
    i64toi32_i32$1 = $2 + 40 | 0;
    i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
    $22 = i64toi32_i32$3;
    i64toi32_i32$3 = $0 + 40 | 0;
    HEAP32[i64toi32_i32$3 >> 2] = $22;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$1 = $2 + 32 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
    $27 = i64toi32_i32$2;
    i64toi32_i32$2 = $0 + 32 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $27;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
    i64toi32_i32$1 = $2 + 24 | 0;
    i64toi32_i32$3 = HEAP32[i64toi32_i32$1 >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
    $32 = i64toi32_i32$3;
    i64toi32_i32$3 = $0 + 24 | 0;
    HEAP32[i64toi32_i32$3 >> 2] = $32;
    HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$1 = $2 + 16 | 0;
    i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
    i64toi32_i32$3 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
    $37 = i64toi32_i32$2;
    i64toi32_i32$2 = $0 + 16 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $37;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
    i64toi32_i32$3 = $3$hi;
    i64toi32_i32$2 = $0 + 8 | 0;
    HEAP32[i64toi32_i32$2 >> 2] = $3;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$3;
    $1 = 1;
    break label$1;
   }
   $1 = 1;
   HEAP8[($0 + 8 | 0) >> 0] = 1;
  }
  HEAP16[$0 >> 1] = $1;
  global$0 = $2 + 48 | 0;
 }
 
 function core__ptr__drop_in_place_cardano_serialization_lib__tx_builder__TransactionBuilder___h053801e638e30160($0) {
  $0 = $0 | 0;
  var $2 = 0, $3 = 0, $1 = 0, i64toi32_i32$1 = 0;
  core__ptr__drop_in_place_cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder___h60f2b953eb0eea7f($0 + 96 | 0 | 0);
  core__ptr__drop_in_place_cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder___h60f2b953eb0eea7f($0 + 176 | 0 | 0);
  $1 = $0 + 416 | 0;
  label$1 : {
   $2 = HEAP32[($0 + 424 | 0) >> 2] | 0;
   if (!$2) {
    break label$1
   }
   $3 = HEAP32[($0 + 416 | 0) >> 2] | 0;
   $2 = $2 << 7 | 0;
   label$2 : while (1) {
    core__ptr__drop_in_place_cardano_serialization_lib__TransactionOutput___h632b3a99817e6ac5_1($3 | 0);
    $3 = $3 + 128 | 0;
    $2 = $2 + -128 | 0;
    if ($2) {
     continue label$2
    }
    break label$2;
   };
  }
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h5107e2b13c386680($1 | 0);
  core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__Certificates____h3bab90286ab8bbb4_1($0 + 428 | 0 | 0);
  core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__Withdrawals____heaf2605773ce1c75_1($0 + 288 | 0 | 0);
  label$3 : {
   i64toi32_i32$1 = HEAP32[($0 + 332 | 0) >> 2] | 0;
   if (!(HEAP32[($0 + 328 | 0) >> 2] | 0 | i64toi32_i32$1 | 0)) {
    break label$3
   }
   core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__metadata__GeneralTransactionMetadata____h37a091753d7f028f_1($0 + 336 | 0 | 0);
   core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__NativeScripts____hdd7d461255ec800a_2($0 + 376 | 0 | 0);
   core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__plutus__PlutusScripts____h6be1d55eac328b7f_2($0 + 388 | 0 | 0);
  }
  label$4 : {
   if (!(HEAP32[($0 + 440 | 0) >> 2] | 0)) {
    break label$4
   }
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h3981a4152bf24dd0($0 + 444 | 0 | 0);
  }
  core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__NativeScripts____hdd7d461255ec800a_2($0 + 456 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h72de9eab2f0e4669($0 + 468 | 0 | 0);
 }
 
 function bip32privatekey_from_128_xprv($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 208 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  HEAP32[($2 + 116 | 0) >> 2] = $1;
  $0 = HEAP32[$2 >> 2] | 0;
  HEAP32[($2 + 112 | 0) >> 2] = $0;
  cardano_serialization_lib__crypto__Bip32PrivateKey__from_128_xprv__hf41833a6bbe46312($2 + 8 | 0 | 0, $0 | 0, $1 | 0);
  core__ptr__drop_in_place_alloc__boxed__Box__5bu8_5d____h1049615268b5f7c4($2 + 112 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 8 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  HEAP8[($2 + 114 | 0) >> 0] = HEAPU8[($2 + 11 | 0) >> 0] | 0;
  HEAP16[($2 + 112 | 0) >> 1] = HEAPU8[($2 + 9 | 0) >> 0] | 0 | ((HEAPU8[($2 + 10 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 115 | 0) >> 0] = $1;
  HEAP8[($2 + 116 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 117 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 118 | 0) >> 0] = $1 >>> 24 | 0;
  memcpy($2 + 112 | 0 | 7 | 0 | 0, $2 + 16 | 0 | 0, 89 | 0) | 0;
  $1 = $cardano_serialization_lib__crypto__Bip32PrivateKey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h3aa14ad8597a0206($2 + 112 | 0 | 0) | 0;
  global$0 = $2 + 208 | 0;
  return $1 | 0;
 }
 
 function bip32privatekey_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 208 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  HEAP32[($2 + 116 | 0) >> 2] = $1;
  $0 = HEAP32[$2 >> 2] | 0;
  HEAP32[($2 + 112 | 0) >> 2] = $0;
  cardano_serialization_lib__crypto__Bip32PrivateKey__from_bytes__hdfbc703a3728d81d($2 + 8 | 0 | 0, $0 | 0, $1 | 0);
  core__ptr__drop_in_place_alloc__boxed__Box__5bu8_5d____h1049615268b5f7c4($2 + 112 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 8 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  HEAP8[($2 + 114 | 0) >> 0] = HEAPU8[($2 + 11 | 0) >> 0] | 0;
  HEAP16[($2 + 112 | 0) >> 1] = HEAPU8[($2 + 9 | 0) >> 0] | 0 | ((HEAPU8[($2 + 10 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 115 | 0) >> 0] = $1;
  HEAP8[($2 + 116 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 117 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 118 | 0) >> 0] = $1 >>> 24 | 0;
  memcpy($2 + 112 | 0 | 7 | 0 | 0, $2 + 16 | 0 | 0, 89 | 0) | 0;
  $1 = $cardano_serialization_lib__crypto__Bip32PrivateKey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h3aa14ad8597a0206($2 + 112 | 0 | 0) | 0;
  global$0 = $2 + 208 | 0;
  return $1 | 0;
 }
 
 function bip32privatekey_from_bech32($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 208 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  HEAP32[($2 + 116 | 0) >> 2] = $1;
  $0 = HEAP32[$2 >> 2] | 0;
  HEAP32[($2 + 112 | 0) >> 2] = $0;
  cardano_serialization_lib__crypto__Bip32PrivateKey__from_bech32__hd3cda4d92126cdfa($2 + 8 | 0 | 0, $0 | 0, $1 | 0);
  core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_2($2 + 112 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 8 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  HEAP8[($2 + 114 | 0) >> 0] = HEAPU8[($2 + 11 | 0) >> 0] | 0;
  HEAP16[($2 + 112 | 0) >> 1] = HEAPU8[($2 + 9 | 0) >> 0] | 0 | ((HEAPU8[($2 + 10 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 115 | 0) >> 0] = $1;
  HEAP8[($2 + 116 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 117 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 118 | 0) >> 0] = $1 >>> 24 | 0;
  memcpy($2 + 112 | 0 | 7 | 0 | 0, $2 + 16 | 0 | 0, 89 | 0) | 0;
  $1 = $cardano_serialization_lib__crypto__Bip32PrivateKey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h3aa14ad8597a0206($2 + 112 | 0 | 0) | 0;
  global$0 = $2 + 208 | 0;
  return $1 | 0;
 }
 
 function bip32publickey_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 144 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  HEAP32[($2 + 84 | 0) >> 2] = $1;
  $0 = HEAP32[$2 >> 2] | 0;
  HEAP32[($2 + 80 | 0) >> 2] = $0;
  cardano_serialization_lib__crypto__Bip32PublicKey__from_bytes__h9e2151b5ecc26a5e($2 + 8 | 0 | 0, $0 | 0, $1 | 0);
  core__ptr__drop_in_place_alloc__boxed__Box__5bu8_5d____h1049615268b5f7c4($2 + 80 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 8 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  HEAP8[($2 + 82 | 0) >> 0] = HEAPU8[($2 + 11 | 0) >> 0] | 0;
  HEAP16[($2 + 80 | 0) >> 1] = HEAPU8[($2 + 9 | 0) >> 0] | 0 | ((HEAPU8[($2 + 10 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 83 | 0) >> 0] = $1;
  HEAP8[($2 + 84 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 85 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 86 | 0) >> 0] = $1 >>> 24 | 0;
  memcpy($2 + 80 | 0 | 7 | 0 | 0, $2 + 16 | 0 | 0, 57 | 0) | 0;
  $1 = $cardano_serialization_lib__crypto__Bip32PublicKey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h56f6677bb959345b($2 + 80 | 0 | 0) | 0;
  global$0 = $2 + 144 | 0;
  return $1 | 0;
 }
 
 function bip32publickey_from_bech32($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 144 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  HEAP32[($2 + 84 | 0) >> 2] = $1;
  $0 = HEAP32[$2 >> 2] | 0;
  HEAP32[($2 + 80 | 0) >> 2] = $0;
  cardano_serialization_lib__crypto__Bip32PublicKey__from_bech32__ha71313b99f940ee4($2 + 8 | 0 | 0, $0 | 0, $1 | 0);
  core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_2($2 + 80 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 8 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  HEAP8[($2 + 82 | 0) >> 0] = HEAPU8[($2 + 11 | 0) >> 0] | 0;
  HEAP16[($2 + 80 | 0) >> 1] = HEAPU8[($2 + 9 | 0) >> 0] | 0 | ((HEAPU8[($2 + 10 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 83 | 0) >> 0] = $1;
  HEAP8[($2 + 84 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 85 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 86 | 0) >> 0] = $1 >>> 24 | 0;
  memcpy($2 + 80 | 0 | 7 | 0 | 0, $2 + 16 | 0 | 0, 57 | 0) | 0;
  $1 = $cardano_serialization_lib__crypto__Bip32PublicKey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h56f6677bb959345b($2 + 80 | 0 | 0) | 0;
  global$0 = $2 + 144 | 0;
  return $1 | 0;
 }
 
 function publickey_to_bech32($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $31 = 0, $43 = 0, $50 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h67eb974eba5bb4b0($2 + 24 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  cardano_serialization_lib__chain_crypto__bech32__to_bech32_from_bytes__he42916b6d7c4e1c6($2 + 32 | 0 | 0, HEAP32[($2 + 24 | 0) >> 2] | 0 | 0, 32 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  $1 = ($2 + 48 | 0) + 8 | 0;
  HEAP32[$1 >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $43 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 64 | 0) >> 2] = $43;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 64 | 0 | 0);
  i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $50 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $50;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $2 + 80 | 0;
 }
 
 function ed25519signature_to_bech32($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $31 = 0, $43 = 0, $50 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hd6fdee4274fe58a2($2 + 24 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  cardano_serialization_lib__chain_crypto__bech32__to_bech32_from_bytes__he23d494655eee107($2 + 32 | 0 | 0, HEAP32[($2 + 24 | 0) >> 2] | 0 | 0, 64 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  $1 = ($2 + 48 | 0) + 8 | 0;
  HEAP32[$1 >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $43 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 64 | 0) >> 2] = $43;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 64 | 0 | 0);
  i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $50 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $50;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $2 + 80 | 0;
 }
 
 function ed25519signature_from_bech32($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 144 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  HEAP32[($2 + 84 | 0) >> 2] = $1;
  $0 = HEAP32[$2 >> 2] | 0;
  HEAP32[($2 + 80 | 0) >> 2] = $0;
  cardano_serialization_lib__crypto__Ed25519Signature__from_bech32__hf9b1aea32c1c48a1($2 + 8 | 0 | 0, $0 | 0, $1 | 0);
  core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_2($2 + 80 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 8 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  HEAP8[($2 + 82 | 0) >> 0] = HEAPU8[($2 + 11 | 0) >> 0] | 0;
  HEAP16[($2 + 80 | 0) >> 1] = HEAPU8[($2 + 9 | 0) >> 0] | 0 | ((HEAPU8[($2 + 10 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 83 | 0) >> 0] = $1;
  HEAP8[($2 + 84 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 85 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 86 | 0) >> 0] = $1 >>> 24 | 0;
  memcpy($2 + 80 | 0 | 7 | 0 | 0, $2 + 16 | 0 | 0, 57 | 0) | 0;
  $1 = $cardano_serialization_lib__crypto__Ed25519Signature_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h20d7210aa6eb2b19($2 + 80 | 0 | 0) | 0;
  global$0 = $2 + 144 | 0;
  return $1 | 0;
 }
 
 function ed25519signature_from_hex($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 144 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  HEAP32[($2 + 84 | 0) >> 2] = $1;
  $0 = HEAP32[$2 >> 2] | 0;
  HEAP32[($2 + 80 | 0) >> 2] = $0;
  cardano_serialization_lib__crypto__Ed25519Signature__from_hex__h31c44be5043beea1($2 + 8 | 0 | 0, $0 | 0, $1 | 0);
  core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_2($2 + 80 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 8 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  HEAP8[($2 + 82 | 0) >> 0] = HEAPU8[($2 + 11 | 0) >> 0] | 0;
  HEAP16[($2 + 80 | 0) >> 1] = HEAPU8[($2 + 9 | 0) >> 0] | 0 | ((HEAPU8[($2 + 10 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 83 | 0) >> 0] = $1;
  HEAP8[($2 + 84 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 85 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 86 | 0) >> 0] = $1 >>> 24 | 0;
  memcpy($2 + 80 | 0 | 7 | 0 | 0, $2 + 16 | 0 | 0, 57 | 0) | 0;
  $1 = $cardano_serialization_lib__crypto__Ed25519Signature_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h20d7210aa6eb2b19($2 + 80 | 0 | 0) | 0;
  global$0 = $2 + 144 | 0;
  return $1 | 0;
 }
 
 function legacydaedalusprivatekey_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 208 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  HEAP32[($2 + 116 | 0) >> 2] = $1;
  $0 = HEAP32[$2 >> 2] | 0;
  HEAP32[($2 + 112 | 0) >> 2] = $0;
  cardano_serialization_lib__crypto__LegacyDaedalusPrivateKey__from_bytes__ha8cc01b057292df5($2 + 8 | 0 | 0, $0 | 0, $1 | 0);
  core__ptr__drop_in_place_alloc__boxed__Box__5bu8_5d____h1049615268b5f7c4($2 + 112 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($2 + 8 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  HEAP8[($2 + 114 | 0) >> 0] = HEAPU8[($2 + 11 | 0) >> 0] | 0;
  HEAP16[($2 + 112 | 0) >> 1] = HEAPU8[($2 + 9 | 0) >> 0] | 0 | ((HEAPU8[($2 + 10 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[($2 + 115 | 0) >> 0] = $1;
  HEAP8[($2 + 116 | 0) >> 0] = $1 >>> 8 | 0;
  HEAP8[($2 + 117 | 0) >> 0] = $1 >>> 16 | 0;
  HEAP8[($2 + 118 | 0) >> 0] = $1 >>> 24 | 0;
  memcpy($2 + 112 | 0 | 7 | 0 | 0, $2 + 16 | 0 | 0, 89 | 0) | 0;
  $1 = $cardano_serialization_lib__crypto__LegacyDaedalusPrivateKey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hb45e7bb29384ab7c($2 + 112 | 0 | 0) | 0;
  global$0 = $2 + 208 | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__crypto__VRFCert_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h98a7ab3de8a7dd6b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $18 = 0, $24 = 0, $33 = 0, $36 = 0, $41 = 0, $46 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hfedafe972002c954($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $24 = i64toi32_i32$1;
  i64toi32_i32$1 = ($2 + 16 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $24;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(($2 + 16 | 0) + 24 | 0) >> 2] = HEAP32[($1 + 24 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $33 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $33;
  HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = i64toi32_i32$2 + 28 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $41 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $41;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2 + 36 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $46;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 28 | 0, 4 | 0);
  global$0 = $2 + 48 | 0;
 }
 
 function core__ptr__drop_in_place_cbor_event__error__Error___hbf0141ec70b68c45($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $3 = 0;
  label$1 : {
   $1 = HEAPU8[$0 >> 0] | 0;
   if ($1 >>> 0 < 14 >>> 0) {
    break label$1
   }
   label$2 : {
    switch ($1 + -14 | 0 | 0) {
    default:
     $0 = $0 + 4 | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
     break label$1;
    case 0:
     $0 = $0 + 4 | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
     return;
    case 1:
     $0 = $0 + 4 | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
     return;
    case 3:
     break label$1;
    case 2:
     break label$2;
    };
   }
   if ((HEAPU8[($0 + 4 | 0) >> 0] | 0 | 0) != (3 | 0)) {
    break label$1
   }
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   FUNCTION_TABLE[HEAP32[(HEAP32[($1 + 4 | 0) >> 2] | 0) >> 2] | 0 | 0](HEAP32[$1 >> 2] | 0);
   $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   $2 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $1 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$1 >> 2] | 0 | 0) | 0;
   label$6 : {
    if (!$2) {
     break label$6
    }
    __rust_dealloc($1 | 0, $2 | 0, $3 | 0);
   }
   __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[($0 + 8 | 0) >> 2] | 0 | 0) | 0 | 0, 12 | 0, 4 | 0);
   return;
  }
 }
 
 function exunitprices_new($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $2 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $4$hi = 0, $5 = 0, $5$hi = 0, $6 = 0, $6$hi = 0, $48 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h98bfbcc994df632c($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h98bfbcc994df632c($2 | 0, $1 | 0);
   i64toi32_i32$2 = $3;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $4 = i64toi32_i32$0;
   $4$hi = i64toi32_i32$1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
   $5 = i64toi32_i32$1;
   $5$hi = i64toi32_i32$0;
   $1 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$2 = $1;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $6 = i64toi32_i32$0;
   $6$hi = i64toi32_i32$1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   $48 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 40 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $48;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $6$hi;
   i64toi32_i32$1 = $2;
   HEAP32[(i64toi32_i32$1 + 32 | 0) >> 2] = $6;
   HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $5$hi;
   HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = $5;
   HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = $4$hi;
   HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $4;
   HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
   $0 = $cardano_serialization_lib__plutus__ExUnitPrices_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hb3338508b1a9ae00(i64toi32_i32$1 + 16 | 0 | 0) | 0;
   global$0 = i64toi32_i32$1 + 48 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function plutusdata_as_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $4 = 0, $3 = 0, $5 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if (!$1) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb1fd14a6870cafe2($2 + 8 | 0 | 0, $1 | 0);
   $3 = 0;
   $4 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $1 = 0;
   label$2 : {
    $5 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    if ((HEAP32[$5 >> 2] | 0 | 0) != (4 | 0)) {
     break label$2
    }
    $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($2 + 16 | 0 | 0, $5 + 4 | 0 | 0);
    $1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($4 | 0, (HEAP32[$4 >> 2] | 0) + -1 | 0 | 0) | 0;
   $4 = 0;
   label$3 : {
    if (!$1) {
     break label$3
    }
    i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
    HEAP32[($2 + 36 | 0) >> 2] = HEAP32[($2 + 20 | 0) >> 2] | 0;
    HEAP32[($2 + 40 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($2 + 32 | 0) >> 2] = $1;
    alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
    $3 = HEAP32[($2 + 4 | 0) >> 2] | 0;
    $4 = HEAP32[$2 >> 2] | 0;
   }
   HEAP32[($0 + 4 | 0) >> 2] = $3;
   HEAP32[$0 >> 2] = $4;
   global$0 = $2 + 48 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function strings_get($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $33 = 0, $45 = 0, $52 = 0;
  $3 = global$0 - 80 | 0;
  global$0 = $3;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h60bb016b22d9de75($3 + 24 | 0 | 0, $1 | 0);
  $1 = HEAP32[($3 + 28 | 0) >> 2] | 0;
  cardano_serialization_lib__plutus__Strings__get__h79dff2673a5e7187($3 + 32 | 0 | 0, HEAP32[($3 + 24 | 0) >> 2] | 0 | 0, $2 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  $1 = ($3 + 48 | 0) + 8 | 0;
  HEAP32[$1 >> 2] = HEAP32[(($3 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($3 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($3 + 36 | 0) >> 2] | 0;
  $33 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[($3 + 48 | 0) >> 2] = $33;
  HEAP32[($3 + 52 | 0) >> 2] = i64toi32_i32$1;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 16 | 0 | 0, $3 + 48 | 0 | 0);
  HEAP32[(($3 + 64 | 0) + 8 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($3 + 48 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($3 + 52 | 0) >> 2] | 0;
  $45 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[($3 + 64 | 0) >> 2] = $45;
  HEAP32[($3 + 68 | 0) >> 2] = i64toi32_i32$0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($3 + 8 | 0 | 0, $3 + 64 | 0 | 0);
  i64toi32_i32$0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
  $52 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $52;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $3 + 80 | 0;
 }
 
 function core__ptr__drop_in_place_cbor_event__error__Error___hbf0141ec70b68c45_1($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $3 = 0;
  label$1 : {
   $1 = HEAPU8[$0 >> 0] | 0;
   if ($1 >>> 0 < 14 >>> 0) {
    break label$1
   }
   label$2 : {
    switch ($1 + -14 | 0 | 0) {
    default:
     $0 = $0 + 4 | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
     break label$1;
    case 0:
     $0 = $0 + 4 | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
     return;
    case 1:
     $0 = $0 + 4 | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
     return;
    case 3:
     break label$1;
    case 2:
     break label$2;
    };
   }
   if ((HEAPU8[($0 + 4 | 0) >> 0] | 0 | 0) != (3 | 0)) {
    break label$1
   }
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   FUNCTION_TABLE[HEAP32[(HEAP32[($1 + 4 | 0) >> 2] | 0) >> 2] | 0 | 0](HEAP32[$1 >> 2] | 0);
   $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   $2 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $1 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$1 >> 2] | 0 | 0) | 0;
   label$6 : {
    if (!$2) {
     break label$6
    }
    __rust_dealloc($1 | 0, $2 | 0, $3 | 0);
   }
   __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[($0 + 8 | 0) >> 2] | 0 | 0) | 0 | 0, 12 | 0, 4 | 0);
   return;
  }
 }
 
 function alloc__raw_vec__finish_grow__h4140f8b73d3423e5($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $5 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          if (!$2) {
           break label$8
          }
          $4 = 0;
          $5 = 1;
          if (($1 | 0) < (0 | 0)) {
           break label$1
          }
          $4 = HEAP32[$3 >> 2] | 0;
          if (!$4) {
           break label$6
          }
          $3 = HEAP32[($3 + 4 | 0) >> 2] | 0;
          if ($3) {
           break label$7
          }
          if ($1) {
           break label$5
          }
          break label$3;
         }
         HEAP32[($0 + 4 | 0) >> 2] = $1;
         $5 = 1;
         $4 = 0;
         break label$1;
        }
        $3 = __rust_realloc($4 | 0, $3 | 0, $2 | 0, $1 | 0) | 0;
        break label$4;
       }
       if (!$1) {
        break label$3
       }
      }
      $3 = __rust_alloc($1 | 0, $2 | 0) | 0;
     }
     $4 = $1;
     break label$2;
    }
    $4 = 0;
    $3 = $2;
   }
   label$9 : {
    if (!$3) {
     break label$9
    }
    HEAP32[($0 + 4 | 0) >> 2] = $3;
    $5 = 0;
    break label$1;
   }
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   $4 = $2;
  }
  HEAP32[$0 >> 2] = $5;
  HEAP32[($0 + 8 | 0) >> 2] = $4;
 }
 
 function alloc__raw_vec__finish_grow__hff6a2247ebb21735($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $5 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          if (!$2) {
           break label$8
          }
          $4 = 0;
          $5 = 1;
          if (($1 | 0) < (0 | 0)) {
           break label$1
          }
          $4 = HEAP32[$3 >> 2] | 0;
          if (!$4) {
           break label$6
          }
          $3 = HEAP32[($3 + 4 | 0) >> 2] | 0;
          if ($3) {
           break label$7
          }
          if ($1) {
           break label$5
          }
          break label$3;
         }
         HEAP32[($0 + 4 | 0) >> 2] = $1;
         $5 = 1;
         $4 = 0;
         break label$1;
        }
        $3 = __rust_realloc($4 | 0, $3 | 0, $2 | 0, $1 | 0) | 0;
        break label$4;
       }
       if (!$1) {
        break label$3
       }
      }
      $3 = __rust_alloc($1 | 0, $2 | 0) | 0;
     }
     $4 = $1;
     break label$2;
    }
    $4 = 0;
    $3 = $2;
   }
   label$9 : {
    if (!$3) {
     break label$9
    }
    HEAP32[($0 + 4 | 0) >> 2] = $3;
    $5 = 0;
    break label$1;
   }
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   $4 = $2;
  }
  HEAP32[$0 >> 2] = $5;
  HEAP32[($0 + 8 | 0) >> 2] = $4;
 }
 
 function relays_get($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $35 = 0, $42 = 0, $45 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hdcd31189477e1360($2 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__Relays__get__hee627f454c994fde($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 48 | 0) + 24 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 24 | 0) >> 2] | 0;
  i64toi32_i32$2 = ($2 + 16 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $35 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 48 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $35;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $42 = i64toi32_i32$1;
  i64toi32_i32$1 = ($2 + 48 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $42;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $45 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $45;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  $0 = $cardano_serialization_lib__Relay_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__ha0d8781612d84a1b($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 80 | 0;
  return $0 | 0;
 }
 
 function url_url($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $31 = 0, $43 = 0, $50 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hd2a6d676353c0b6c($2 + 24 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($2 + 32 | 0 | 0, HEAP32[($2 + 24 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  $1 = ($2 + 48 | 0) + 8 | 0;
  HEAP32[$1 >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $43 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 64 | 0) >> 2] = $43;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 64 | 0 | 0);
  i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $50 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $50;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $2 + 80 | 0;
 }
 
 function dnsrecordaoraaaa_record($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $31 = 0, $43 = 0, $50 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h1715449b8810f0c1($2 + 24 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($2 + 32 | 0 | 0, HEAP32[($2 + 24 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  $1 = ($2 + 48 | 0) + 8 | 0;
  HEAP32[$1 >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $43 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 64 | 0) >> 2] = $43;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 64 | 0 | 0);
  i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $50 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $50;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $2 + 80 | 0;
 }
 
 function dnsrecordsrv_record($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $31 = 0, $43 = 0, $50 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h8aa27fc1f3f1159b($2 + 24 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($2 + 32 | 0 | 0, HEAP32[($2 + 24 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  $1 = ($2 + 48 | 0) + 8 | 0;
  HEAP32[$1 >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $43 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 64 | 0) >> 2] = $43;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 64 | 0 | 0);
  i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $50 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $50;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $2 + 80 | 0;
 }
 
 function stakecredentials_get($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $10 = 0, $28 = 0, $35 = 0, $42 = 0, $45 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h99bd8393a0065b1d($2 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__StakeCredentials__get__hc1a49e487d0bcf79($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = ($2 + 16 | 0) + 21 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $28 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 48 | 0) + 21 | 0;
  $10 = $28;
  HEAP8[i64toi32_i32$0 >> 0] = $10;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = ($2 + 16 | 0) + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $35 = i64toi32_i32$1;
  i64toi32_i32$1 = ($2 + 48 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $35;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $42 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 48 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $42;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $45 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = $45;
  HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = i64toi32_i32$0;
  $0 = $cardano_serialization_lib__address__StakeCredential_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hfe6826a4b7739a89(i64toi32_i32$2 + 48 | 0 | 0) | 0;
  global$0 = i64toi32_i32$2 + 80 | 0;
  return $0 | 0;
 }
 
 function rewardaddresses_get($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $10 = 0, $28 = 0, $35 = 0, $42 = 0, $45 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h18a4570cc8a3407a($2 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__RewardAddresses__get__h0d82acc0fadea368($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = ($2 + 16 | 0) + 22 | 0;
  i64toi32_i32$0 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
  i64toi32_i32$1 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
  $28 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 48 | 0) + 22 | 0;
  $10 = $28;
  HEAP16[i64toi32_i32$0 >> 1] = $10;
  HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $10 >>> 16 | 0;
  HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$1;
  HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
  i64toi32_i32$2 = ($2 + 16 | 0) + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $35 = i64toi32_i32$1;
  i64toi32_i32$1 = ($2 + 48 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $35;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $42 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 48 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $42;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $45 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $45;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$0;
  $0 = $cardano_serialization_lib__address__RewardAddress_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8b4ddbbcde95397b($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 80 | 0;
  return $0 | 0;
 }
 
 function nativescripts_get($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $28 = 0, $35 = 0, $42 = 0, $45 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hbfc7b2ba05921680($2 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__NativeScripts__get__h1c4b6c833053ec03($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = ($2 + 16 | 0) + 24 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $28 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 48 | 0) + 24 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $28;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = ($2 + 16 | 0) + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $35 = i64toi32_i32$1;
  i64toi32_i32$1 = ($2 + 48 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $35;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $42 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 48 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $42;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $45 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $45;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$0;
  $0 = $cardano_serialization_lib__NativeScript_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h345d8ecbe77ecc63($2 + 48 | 0 | 0) | 0;
  global$0 = $2 + 80 | 0;
  return $0 | 0;
 }
 
 function protocolparamupdate_execution_costs($0) {
  $0 = $0 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, $1 = 0, i64toi32_i32$0 = 0, $2 = 0, $3 = 0, $3$hi = 0, $4 = 0, $4$hi = 0, $5 = 0, $5$hi = 0, $42 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hd84cc8f720a3dada($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   label$2 : {
    label$3 : {
     $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 192 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 196 | 0) >> 2] | 0;
     i64toi32_i32$2 = i64toi32_i32$0;
     i64toi32_i32$0 = 0;
     i64toi32_i32$3 = 1;
     if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
      break label$3
     }
     core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
     $0 = 0;
     break label$2;
    }
    i64toi32_i32$3 = $2;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 200 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 204 | 0) >> 2] | 0;
    $3 = i64toi32_i32$2;
    $3$hi = i64toi32_i32$1;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 208 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 212 | 0) >> 2] | 0;
    $4 = i64toi32_i32$1;
    $4$hi = i64toi32_i32$2;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 216 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 220 | 0) >> 2] | 0;
    $5 = i64toi32_i32$2;
    $5$hi = i64toi32_i32$1;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 224 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 228 | 0) >> 2] | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    $42 = i64toi32_i32$1;
    i64toi32_i32$1 = $1 + 40 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $42;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $5$hi;
    i64toi32_i32$1 = $1;
    HEAP32[(i64toi32_i32$1 + 32 | 0) >> 2] = $5;
    HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $4$hi;
    HEAP32[(i64toi32_i32$1 + 24 | 0) >> 2] = $4;
    HEAP32[(i64toi32_i32$1 + 28 | 0) >> 2] = i64toi32_i32$2;
    i64toi32_i32$2 = $3$hi;
    HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $3;
    HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$2;
    $0 = $cardano_serialization_lib__plutus__ExUnitPrices_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hb3338508b1a9ae00(i64toi32_i32$1 + 16 | 0 | 0) | 0;
   }
   global$0 = $1 + 48 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function hashbrown__raw__RawTable_T_2cA___drop_elements__h9bc6ee4fef8cdf88($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $4 = 0, $3 = 0;
  label$1 : {
   if (!(HEAP32[($0 + 12 | 0) >> 2] | 0)) {
    break label$1
   }
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   $2 = $1 + 4 | 0;
   $3 = ((HEAP32[$0 >> 2] | 0) + $1 | 0) + 1 | 0;
   $0 = ((HEAP32[$1 >> 2] | 0) ^ -1 | 0) & -2139062144 | 0;
   label$2 : while (1) {
    label$3 : {
     if ($0) {
      break label$3
     }
     label$4 : while (1) {
      if ($2 >>> 0 >= $3 >>> 0) {
       break label$1
      }
      $1 = $1 + -48 | 0;
      $0 = HEAP32[$2 >> 2] | 0;
      $4 = $2 + 4 | 0;
      $2 = $4;
      $0 = $0 & -2139062144 | 0;
      if (($0 | 0) == (-2139062144 | 0)) {
       continue label$4
      }
      break label$4;
     };
     $0 = $0 ^ -2139062144 | 0;
     $2 = $4;
    }
    $4 = ($1 + Math_imul(0 - ((__wasm_ctz_i32($0 | 0) | 0) >>> 3 | 0) | 0, 12) | 0) + -12 | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($4 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($4 | 0);
    $0 = ($0 + -1 | 0) & $0 | 0;
    continue label$2;
   };
  }
 }
 
 function bignum_to_str($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $31 = 0, $43 = 0, $50 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($2 + 24 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  cardano_serialization_lib__utils__BigNum__to_str__h5b9769c85af10e21($2 + 32 | 0 | 0, HEAP32[($2 + 24 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  $1 = ($2 + 48 | 0) + 8 | 0;
  HEAP32[$1 >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $43 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 64 | 0) >> 2] = $43;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 64 | 0 | 0);
  i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $50 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $50;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $2 + 80 | 0;
 }
 
 function bignum_checked_add($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$5 = 0, $2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, $3 = 0, $5 = 0, $5$hi = 0, $6 = 0, i64toi32_i32$4 = 0, $6$hi = 0, $28 = 0, $28$hi = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($2 + 8 | 0 | 0, $0 | 0);
    if (!$1) {
     break label$2
    }
    $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($2 | 0, $1 | 0);
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $5 = i64toi32_i32$0;
    $5$hi = i64toi32_i32$1;
    i64toi32_i32$2 = HEAP32[$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $28 = i64toi32_i32$1;
    $28$hi = i64toi32_i32$0;
    i64toi32_i32$0 = $5$hi;
    i64toi32_i32$2 = $5;
    i64toi32_i32$1 = $28$hi;
    i64toi32_i32$3 = $28;
    i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
    i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
    if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
     i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
    }
    $6 = i64toi32_i32$4;
    $6$hi = i64toi32_i32$5;
    i64toi32_i32$5 = $5$hi;
    i64toi32_i32$5 = $6$hi;
    i64toi32_i32$0 = $6;
    i64toi32_i32$2 = $5$hi;
    i64toi32_i32$3 = $5;
    $3 = i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
    $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
    label$3 : {
     label$4 : {
      i64toi32_i32$0 = i64toi32_i32$5;
      i64toi32_i32$0 = i64toi32_i32$2;
      i64toi32_i32$0 = i64toi32_i32$5;
      i64toi32_i32$3 = $6;
      i64toi32_i32$5 = i64toi32_i32$2;
      i64toi32_i32$2 = $5;
      if (i64toi32_i32$0 >>> 0 > i64toi32_i32$5 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$3 >>> 0 >= i64toi32_i32$2 >>> 0 | 0) | 0) {
       break label$4
      }
      $4 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1058732 | 0, 8 | 0) | 0;
      break label$3;
     }
    }
    core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    if ($3) {
     break label$1
    }
    i64toi32_i32$3 = $6$hi;
    $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810($6 | 0, i64toi32_i32$3 | 0) | 0;
    global$0 = $2 + 16 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472($4 | 0);
  abort();
 }
 
 function bignum_checked_sub($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$5 = 0, $2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, $3 = 0, $5 = 0, $6 = 0, $5$hi = 0, $6$hi = 0, $28 = 0, $28$hi = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($2 + 8 | 0 | 0, $0 | 0);
    if (!$1) {
     break label$2
    }
    $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($2 | 0, $1 | 0);
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $5 = i64toi32_i32$0;
    $5$hi = i64toi32_i32$1;
    i64toi32_i32$2 = HEAP32[$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $28 = i64toi32_i32$1;
    $28$hi = i64toi32_i32$0;
    i64toi32_i32$0 = $5$hi;
    i64toi32_i32$2 = $5;
    i64toi32_i32$1 = $28$hi;
    i64toi32_i32$3 = $28;
    i64toi32_i32$5 = (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) + i64toi32_i32$1 | 0;
    i64toi32_i32$5 = i64toi32_i32$0 - i64toi32_i32$5 | 0;
    $6 = i64toi32_i32$2 - i64toi32_i32$3 | 0;
    $6$hi = i64toi32_i32$5;
    i64toi32_i32$5 = i64toi32_i32$0;
    i64toi32_i32$5 = $6$hi;
    i64toi32_i32$0 = $6;
    i64toi32_i32$2 = $5$hi;
    i64toi32_i32$3 = $5;
    $3 = i64toi32_i32$5 >>> 0 > i64toi32_i32$2 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$0 >>> 0 > i64toi32_i32$3 >>> 0 | 0) | 0;
    $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
    label$3 : {
     label$4 : {
      i64toi32_i32$0 = i64toi32_i32$5;
      i64toi32_i32$0 = i64toi32_i32$2;
      i64toi32_i32$0 = i64toi32_i32$5;
      i64toi32_i32$3 = $6;
      i64toi32_i32$5 = i64toi32_i32$2;
      i64toi32_i32$2 = $5;
      if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$3 >>> 0 <= i64toi32_i32$2 >>> 0 | 0) | 0) {
       break label$4
      }
      $4 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1058740 | 0, 9 | 0) | 0;
      break label$3;
     }
    }
    core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    if ($3) {
     break label$1
    }
    i64toi32_i32$3 = $6$hi;
    $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810($6 | 0, i64toi32_i32$3 | 0) | 0;
    global$0 = $2 + 16 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472($4 | 0);
  abort();
 }
 
 function bigint_to_str($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $31 = 0, $43 = 0, $50 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hb4a7701b5bc2a87c($2 + 24 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  cardano_serialization_lib__utils__BigInt__to_str__h54985d40d9e183db($2 + 32 | 0 | 0, HEAP32[($2 + 24 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  $1 = ($2 + 48 | 0) + 8 | 0;
  HEAP32[$1 >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $43 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 64 | 0) >> 2] = $43;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 64 | 0 | 0);
  i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $50 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $50;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $2 + 80 | 0;
 }
 
 function privatekey_to_bech32($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $31 = 0, $43 = 0, $50 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h09a25d0fa720925e($2 + 24 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  cardano_serialization_lib__crypto__PrivateKey__to_bech32__haf9748b54338b452($2 + 32 | 0 | 0, HEAP32[($2 + 24 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  $1 = ($2 + 48 | 0) + 8 | 0;
  HEAP32[$1 >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $43 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 64 | 0) >> 2] = $43;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 64 | 0 | 0);
  i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $50 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $50;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $2 + 80 | 0;
 }
 
 function $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__h25f3281440c3e21a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, $3 = 0, i64toi32_i32$1 = 0, $5 = 0, $4 = 0, $49 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  $core__iter__adapters__cloned__Cloned_I__20as_20core__iter__traits__iterator__Iterator___next__h491a5ec4cfc71a30($2 + 16 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    if (HEAP32[($2 + 16 | 0) >> 2] | 0) {
     break label$2
    }
    i64toi32_i32$1 = $0;
    i64toi32_i32$0 = 0;
    HEAP32[($0 + 4 | 0) >> 2] = 0;
    HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[$0 >> 2] = HEAP32[(0 + 1067632 | 0) >> 2] | 0;
    break label$1;
   }
   $3 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   alloc__raw_vec__RawVec_T_2cA___allocate_in__h5dada854c892eb3e($2 + 8 | 0 | 0, 1 | 0, 0 | 0);
   $4 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $5 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   HEAP32[$5 >> 2] = $3;
   $3 = ($2 + 24 | 0) + 8 | 0;
   HEAP32[$3 >> 2] = 1;
   HEAP32[($2 + 28 | 0) >> 2] = $4;
   HEAP32[($2 + 24 | 0) >> 2] = $5;
   memcpy($2 + 40 | 0 | 0, $1 | 0, 36 | 0) | 0;
   alloc__vec__Vec_T_2cA___extend_desugared__ha20ef78c23693913($2 + 24 | 0 | 0, $2 + 40 | 0 | 0);
   HEAP32[($0 + 8 | 0) >> 2] = HEAP32[$3 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 24 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 28 | 0) >> 2] | 0;
   $49 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[$0 >> 2] = $49;
   HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$1;
  }
  global$0 = $2 + 80 | 0;
 }
 
 function $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__h4f76cb21839b1a36($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, $3 = 0, i64toi32_i32$1 = 0, $5 = 0, $4 = 0, $49 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  $core__iter__adapters__cloned__Cloned_I__20as_20core__iter__traits__iterator__Iterator___next__h63ed0f17c69cc296($2 + 16 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    if (HEAP32[($2 + 16 | 0) >> 2] | 0) {
     break label$2
    }
    i64toi32_i32$1 = $0;
    i64toi32_i32$0 = 0;
    HEAP32[($0 + 4 | 0) >> 2] = 0;
    HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[$0 >> 2] = HEAP32[(0 + 1067632 | 0) >> 2] | 0;
    break label$1;
   }
   $3 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   alloc__raw_vec__RawVec_T_2cA___allocate_in__h5dada854c892eb3e($2 + 8 | 0 | 0, 1 | 0, 0 | 0);
   $4 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $5 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   HEAP32[$5 >> 2] = $3;
   $3 = ($2 + 24 | 0) + 8 | 0;
   HEAP32[$3 >> 2] = 1;
   HEAP32[($2 + 28 | 0) >> 2] = $4;
   HEAP32[($2 + 24 | 0) >> 2] = $5;
   memcpy($2 + 40 | 0 | 0, $1 | 0, 36 | 0) | 0;
   alloc__vec__Vec_T_2cA___extend_desugared__h76b8d3f5752e53b4($2 + 24 | 0 | 0, $2 + 40 | 0 | 0);
   HEAP32[($0 + 8 | 0) >> 2] = HEAP32[$3 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 24 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 28 | 0) >> 2] | 0;
   $49 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[$0 >> 2] = $49;
   HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$1;
  }
  global$0 = $2 + 80 | 0;
 }
 
 function alloc__vec__Vec_T_2cA___extend_desugared__hf66dda82fdeb0b83($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $4 = 0, $3 = 0, $5 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__ha538daa28fd542ac($2 + 8 | 0 | 0, $1 | 0);
  label$1 : {
   if (!(HEAP32[($2 + 8 | 0) >> 2] | 0)) {
    break label$1
   }
   label$2 : while (1) {
    cardano_serialization_lib__plutus__Language__to_bytes__hfc301904eed509f1($2 + 16 | 0 | 0, $2 | 0);
    if (!(HEAP32[($2 + 16 | 0) >> 2] | 0)) {
     break label$1
    }
    label$3 : {
     $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
     if ((HEAP32[($0 + 4 | 0) >> 2] | 0 | 0) != ($3 | 0)) {
      break label$3
     }
     $4 = HEAP32[($1 + 24 | 0) >> 2] | 0;
     $5 = $4 + 1 | 0;
     alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hf63e6be5be3c26c2($0 | 0, $3 | 0, ($5 >>> 0 < $4 >>> 0 ? -1 : $5) | 0);
    }
    $4 = (HEAP32[$0 >> 2] | 0) + Math_imul($3, 12) | 0;
    i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
    HEAP32[$4 >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
    HEAP32[($4 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($4 + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
    HEAP32[($0 + 8 | 0) >> 2] = $3 + 1 | 0;
    $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__ha538daa28fd542ac($2 | 0, $1 | 0);
    if (HEAP32[$2 >> 2] | 0) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $2 + 32 | 0;
 }
 
 function $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__he7cc99f5dd5f1b16($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, $3 = 0, i64toi32_i32$1 = 0, $5 = 0, $4 = 0, $49 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  $core__iter__adapters__cloned__Cloned_I__20as_20core__iter__traits__iterator__Iterator___next__h9b1225c14b74e98d($2 + 16 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    if (HEAP32[($2 + 16 | 0) >> 2] | 0) {
     break label$2
    }
    i64toi32_i32$1 = $0;
    i64toi32_i32$0 = 0;
    HEAP32[($0 + 4 | 0) >> 2] = 0;
    HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[$0 >> 2] = HEAP32[(0 + 1067632 | 0) >> 2] | 0;
    break label$1;
   }
   $3 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   alloc__raw_vec__RawVec_T_2cA___allocate_in__h5dada854c892eb3e($2 + 8 | 0 | 0, 1 | 0, 0 | 0);
   $4 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $5 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   HEAP32[$5 >> 2] = $3;
   $3 = ($2 + 24 | 0) + 8 | 0;
   HEAP32[$3 >> 2] = 1;
   HEAP32[($2 + 28 | 0) >> 2] = $4;
   HEAP32[($2 + 24 | 0) >> 2] = $5;
   memcpy($2 + 40 | 0 | 0, $1 | 0, 36 | 0) | 0;
   alloc__vec__Vec_T_2cA___extend_desugared__hea5a477b78fb1943($2 + 24 | 0 | 0, $2 + 40 | 0 | 0);
   HEAP32[($0 + 8 | 0) >> 2] = HEAP32[$3 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 24 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 28 | 0) >> 2] | 0;
   $49 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[$0 >> 2] = $49;
   HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$1;
  }
  global$0 = $2 + 80 | 0;
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hc722e22117ee5940($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $5 = 0, $3 = 0, $4 = 0, $6 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  $3 = HEAP32[$1 >> 2] | 0;
  $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h5a1370a6bc6e89cb($2 + 8 | 0 | 0, $4 | 0, 0 | 0);
  $1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  $5 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $5;
  HEAP32[$0 >> 2] = $1;
  label$1 : {
   if (!$5) {
    break label$1
   }
   $6 = Math_imul($4, 12);
   label$2 : while (1) {
    if (!$6) {
     break label$1
    }
    $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($2 + 16 | 0 | 0, $3 | 0);
    HEAP32[($1 + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
    HEAP32[$1 >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
    HEAP32[($1 + 4 | 0) >> 2] = i64toi32_i32$1;
    $1 = $1 + 12 | 0;
    $6 = $6 + -12 | 0;
    $3 = $3 + 12 | 0;
    $5 = $5 + -1 | 0;
    if ($5) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 8 | 0) >> 2] = $4;
  global$0 = $2 + 32 | 0;
 }
 
 function $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Sub___sub__h676cb1e5fa77fb70($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, i64toi32_i32$6 = 0, $4 = 0, $4$hi = 0, $57 = 0, $58 = 0, $60 = 0, $61 = 0, $63 = 0, $5 = 0, $7 = 0, $7$hi = 0, $9 = 0, $9$hi = 0, $10 = 0, $10$hi = 0, $12 = 0, $12$hi = 0, $14 = 0, $14$hi = 0, $3 = 0, $3$hi = 0, $18$hi = 0, $22 = 0, $23 = 0, $25 = 0, $25$hi = 0, $27 = 0, $27$hi = 0, $28 = 0, $28$hi = 0, $30$hi = 0, $34 = 0, $35 = 0, $37 = 0, $37$hi = 0, $39 = 0, $39$hi = 0, $40 = 0, $40$hi = 0, $42$hi = 0, $47 = 0, $49 = 0, $49$hi = 0, $51 = 0, $51$hi = 0, $52 = 0, $52$hi = 0, $54$hi = 0, $59 = 0, $62 = 0, $62$hi = 0, $64 = 0, $64$hi = 0;
  $5 = $0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = $7;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$4 = i64toi32_i32$2 - i64toi32_i32$3 | 0;
  i64toi32_i32$6 = i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0;
  i64toi32_i32$5 = i64toi32_i32$6 + i64toi32_i32$1 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 - i64toi32_i32$5 | 0;
  $10 = i64toi32_i32$4;
  $10$hi = i64toi32_i32$5;
  i64toi32_i32$0 = $1;
  i64toi32_i32$5 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $12 = i64toi32_i32$5;
  $12$hi = i64toi32_i32$2;
  i64toi32_i32$0 = $2;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$2;
  $14$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $12$hi;
  i64toi32_i32$0 = $12;
  i64toi32_i32$2 = $14$hi;
  i64toi32_i32$3 = $14;
  i64toi32_i32$1 = i64toi32_i32$0 - i64toi32_i32$3 | 0;
  i64toi32_i32$6 = i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0;
  i64toi32_i32$4 = i64toi32_i32$6 + i64toi32_i32$2 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 - i64toi32_i32$4 | 0;
  i64toi32_i32$5 = i64toi32_i32$1;
  i64toi32_i32$0 = 2097151;
  i64toi32_i32$3 = -76;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $3 = i64toi32_i32$2;
  $3$hi = i64toi32_i32$1;
  i64toi32_i32$4 = i64toi32_i32$2;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$0 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$5 = 0;
   $57 = i64toi32_i32$1 >>> i64toi32_i32$0 | 0;
  } else {
   i64toi32_i32$5 = i64toi32_i32$1 >>> i64toi32_i32$0 | 0;
   $57 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$0 | 0) | 0;
  }
  $18$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$1 = $10;
  i64toi32_i32$4 = $18$hi;
  i64toi32_i32$3 = $57;
  i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  i64toi32_i32$5 = i64toi32_i32$0;
  i64toi32_i32$1 = 2097151;
  i64toi32_i32$3 = -4;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $4 = i64toi32_i32$4;
  $4$hi = i64toi32_i32$0;
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$5 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$5 = i64toi32_i32$0 & i64toi32_i32$5 | 0;
  $22 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $5;
  HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $22;
  HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$5;
  $23 = $0;
  i64toi32_i32$0 = $1;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] | 0;
  $25 = i64toi32_i32$5;
  $25$hi = i64toi32_i32$2;
  i64toi32_i32$0 = $2;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] | 0;
  $27 = i64toi32_i32$2;
  $27$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $25$hi;
  i64toi32_i32$0 = $25;
  i64toi32_i32$2 = $27$hi;
  i64toi32_i32$3 = $27;
  i64toi32_i32$1 = i64toi32_i32$0 - i64toi32_i32$3 | 0;
  i64toi32_i32$6 = i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0;
  i64toi32_i32$4 = i64toi32_i32$6 + i64toi32_i32$2 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 - i64toi32_i32$4 | 0;
  $28 = i64toi32_i32$1;
  $28$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $4$hi;
  i64toi32_i32$5 = $4;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$2 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $58 = i64toi32_i32$4 >>> i64toi32_i32$2 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$4 >>> i64toi32_i32$2 | 0;
   $58 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$2 | 0) | 0;
  }
  $30$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $28$hi;
  i64toi32_i32$4 = $28;
  i64toi32_i32$5 = $30$hi;
  i64toi32_i32$3 = $58;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$4 = 2097151;
  i64toi32_i32$3 = -4;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $4 = i64toi32_i32$5;
  $4$hi = i64toi32_i32$2;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$0 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
  $34 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $23;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $34;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  $35 = $0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $37 = i64toi32_i32$0;
  $37$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
  $39 = i64toi32_i32$1;
  $39$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $37$hi;
  i64toi32_i32$2 = $37;
  i64toi32_i32$1 = $39$hi;
  i64toi32_i32$3 = $39;
  i64toi32_i32$4 = i64toi32_i32$2 - i64toi32_i32$3 | 0;
  i64toi32_i32$6 = i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0;
  i64toi32_i32$5 = i64toi32_i32$6 + i64toi32_i32$1 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 - i64toi32_i32$5 | 0;
  $40 = i64toi32_i32$4;
  $40$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $4$hi;
  i64toi32_i32$0 = $4;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$1 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $60 = i64toi32_i32$5 >>> i64toi32_i32$1 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$5 >>> i64toi32_i32$1 | 0;
   $60 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$1 | 0) | 0;
  }
  $42$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $40$hi;
  i64toi32_i32$5 = $40;
  i64toi32_i32$0 = $42$hi;
  i64toi32_i32$3 = $60;
  i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$5 = 2097151;
  i64toi32_i32$3 = -4;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$1;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$2 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
  i64toi32_i32$4 = $35;
  HEAP32[(i64toi32_i32$4 + 24 | 0) >> 2] = i64toi32_i32$0 & i64toi32_i32$3 | 0;
  HEAP32[(i64toi32_i32$4 + 28 | 0) >> 2] = i64toi32_i32$2;
  $47 = $0;
  i64toi32_i32$1 = $1;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 32 | 0) >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] | 0;
  $49 = i64toi32_i32$2;
  $49$hi = i64toi32_i32$4;
  i64toi32_i32$1 = $2;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 32 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] | 0;
  $51 = i64toi32_i32$4;
  $51$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $49$hi;
  i64toi32_i32$1 = $49;
  i64toi32_i32$4 = $51$hi;
  i64toi32_i32$3 = $51;
  i64toi32_i32$5 = i64toi32_i32$1 - i64toi32_i32$3 | 0;
  i64toi32_i32$6 = i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0;
  i64toi32_i32$0 = i64toi32_i32$6 + i64toi32_i32$4 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 - i64toi32_i32$0 | 0;
  $52 = i64toi32_i32$5;
  $52$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $4$hi;
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $61 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $61 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  $54$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $52$hi;
  i64toi32_i32$0 = $52;
  i64toi32_i32$2 = $54$hi;
  i64toi32_i32$3 = $61;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$0 = 2097151;
  i64toi32_i32$3 = -4;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $4 = i64toi32_i32$2;
  $4$hi = i64toi32_i32$4;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$1 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$1 = i64toi32_i32$4 & i64toi32_i32$1 | 0;
  i64toi32_i32$5 = $47;
  HEAP32[(i64toi32_i32$5 + 32 | 0) >> 2] = i64toi32_i32$2 & i64toi32_i32$3 | 0;
  HEAP32[(i64toi32_i32$5 + 36 | 0) >> 2] = i64toi32_i32$1;
  $59 = $0;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$4 = i64toi32_i32$2;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$0 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$5 = 0;
   $63 = i64toi32_i32$1 >>> i64toi32_i32$0 | 0;
  } else {
   i64toi32_i32$5 = i64toi32_i32$1 >>> i64toi32_i32$0 | 0;
   $63 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$0 | 0) | 0;
  }
  i64toi32_i32$4 = 0;
  i64toi32_i32$4 = __wasm_i64_mul($63 | 0, i64toi32_i32$5 | 0, 19 | 0, i64toi32_i32$4 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $62 = i64toi32_i32$4;
  $62$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $3$hi;
  i64toi32_i32$1 = $3;
  i64toi32_i32$4 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$4 = i64toi32_i32$5 & i64toi32_i32$4 | 0;
  $64 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
  $64$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $62$hi;
  i64toi32_i32$5 = $62;
  i64toi32_i32$1 = $64$hi;
  i64toi32_i32$3 = $64;
  i64toi32_i32$0 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  i64toi32_i32$5 = $59;
  HEAP32[i64toi32_i32$5 >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$2;
 }
 
 function transaction_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 880 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 440 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 456 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 440 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 444 | 0) >> 2] | 0;
  HEAP32[($2 + 456 | 0) >> 2] = HEAP32[($2 + 440 | 0) >> 2] | 0;
  HEAP32[($2 + 460 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__Transaction__from_bytes__hd46665f26e2ad93c($2 + 8 | 0 | 0, $2 + 456 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
   abort();
  }
  memcpy($2 + 456 | 0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 424 | 0) | 0;
  $1 = $cardano_serialization_lib__Transaction_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hf1e81f974efa699a($2 + 456 | 0 | 0) | 0;
  global$0 = $2 + 880 | 0;
  return $1 | 0;
 }
 
 function transactionbody_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 576 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 288 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 304 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 288 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 292 | 0) >> 2] | 0;
  HEAP32[($2 + 304 | 0) >> 2] = HEAP32[($2 + 288 | 0) >> 2] | 0;
  HEAP32[($2 + 308 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__TransactionBody__from_bytes__h92ca3c4cb5458ef2($2 + 8 | 0 | 0, $2 + 304 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
   abort();
  }
  memcpy($2 + 304 | 0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 272 | 0) | 0;
  $1 = $cardano_serialization_lib__TransactionBody_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h5f9023ed5f5fb82c($2 + 304 | 0 | 0) | 0;
  global$0 = $2 + 576 | 0;
  return $1 | 0;
 }
 
 function transactionoutput_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 288 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 144 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 160 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 144 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 148 | 0) >> 2] | 0;
  HEAP32[($2 + 160 | 0) >> 2] = HEAP32[($2 + 144 | 0) >> 2] | 0;
  HEAP32[($2 + 164 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__TransactionOutput__from_bytes__h950ec06a10b92037($2 + 8 | 0 | 0, $2 + 160 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
   abort();
  }
  memcpy($2 + 160 | 0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 128 | 0) | 0;
  $1 = $cardano_serialization_lib__TransactionOutput_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h4b9395cffb8a7c47($2 + 160 | 0 | 0) | 0;
  global$0 = $2 + 288 | 0;
  return $1 | 0;
 }
 
 function poolparams_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 416 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 208 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 224 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 208 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 212 | 0) >> 2] | 0;
  HEAP32[($2 + 224 | 0) >> 2] = HEAP32[($2 + 208 | 0) >> 2] | 0;
  HEAP32[($2 + 228 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__PoolParams__from_bytes__h0470afe27db1126a($2 + 8 | 0 | 0, $2 + 224 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
   abort();
  }
  memcpy($2 + 224 | 0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 192 | 0) | 0;
  $1 = $cardano_serialization_lib__PoolParams_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he83d156438296832($2 + 224 | 0 | 0) | 0;
  global$0 = $2 + 416 | 0;
  return $1 | 0;
 }
 
 function poolregistration_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 416 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 208 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 224 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 208 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 212 | 0) >> 2] | 0;
  HEAP32[($2 + 224 | 0) >> 2] = HEAP32[($2 + 208 | 0) >> 2] | 0;
  HEAP32[($2 + 228 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__PoolRegistration__from_bytes__h21d577eb7247b80d($2 + 8 | 0 | 0, $2 + 224 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
   abort();
  }
  memcpy($2 + 224 | 0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 192 | 0) | 0;
  $1 = $cardano_serialization_lib__PoolRegistration_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hba4f55f2c62f4c8d($2 + 224 | 0 | 0) | 0;
  global$0 = $2 + 416 | 0;
  return $1 | 0;
 }
 
 function moveinstantaneousrewardscert_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 144 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 72 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 88 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 72 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 76 | 0) >> 2] | 0;
  HEAP32[($2 + 88 | 0) >> 2] = HEAP32[($2 + 72 | 0) >> 2] | 0;
  HEAP32[($2 + 92 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__MoveInstantaneousRewardsCert__from_bytes__hf98f7f9887bd6e00($2 + 8 | 0 | 0, $2 + 88 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
   abort();
  }
  memcpy($2 + 88 | 0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 56 | 0) | 0;
  $1 = $cardano_serialization_lib__MoveInstantaneousRewardsCert_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8b59c9ac999ad03b($2 + 88 | 0 | 0) | 0;
  global$0 = $2 + 144 | 0;
  return $1 | 0;
 }
 
 function certificate_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 432 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 216 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 232 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 216 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 220 | 0) >> 2] | 0;
  HEAP32[($2 + 232 | 0) >> 2] = HEAP32[($2 + 216 | 0) >> 2] | 0;
  HEAP32[($2 + 236 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__Certificate__from_bytes__hbe10ee7597a65a88($2 + 8 | 0 | 0, $2 + 232 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
   abort();
  }
  memcpy($2 + 232 | 0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 200 | 0) | 0;
  $1 = $cardano_serialization_lib__Certificate_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hd9e6ef3cbd15ff20($2 + 232 | 0 | 0) | 0;
  global$0 = $2 + 432 | 0;
  return $1 | 0;
 }
 
 function mirtostakecredentials_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 56 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 72 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 56 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 60 | 0) >> 2] | 0;
  HEAP32[($2 + 72 | 0) >> 2] = HEAP32[($2 + 56 | 0) >> 2] | 0;
  HEAP32[($2 + 76 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__MIRToStakeCredentials__from_bytes__h131d0cb12d9cfeb8($2 + 8 | 0 | 0, $2 + 72 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
   abort();
  }
  memcpy($2 + 72 | 0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 40 | 0) | 0;
  $1 = $cardano_serialization_lib__MIRToStakeCredentials_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h1e2c02e5ebbbcce1($2 + 72 | 0 | 0) | 0;
  global$0 = $2 + 112 | 0;
  return $1 | 0;
 }
 
 function moveinstantaneousreward_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 144 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 72 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 88 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 72 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 76 | 0) >> 2] | 0;
  HEAP32[($2 + 88 | 0) >> 2] = HEAP32[($2 + 72 | 0) >> 2] | 0;
  HEAP32[($2 + 92 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__MoveInstantaneousReward__from_bytes__h85f8bfaa9b536645($2 + 8 | 0 | 0, $2 + 88 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
   abort();
  }
  memcpy($2 + 88 | 0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 56 | 0) | 0;
  $1 = $cardano_serialization_lib__MoveInstantaneousReward_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hf9455bc13311e72d($2 + 88 | 0 | 0) | 0;
  global$0 = $2 + 144 | 0;
  return $1 | 0;
 }
 
 function relay_new_single_host_addr($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $33 = 0, $40 = 0, $43 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h7fe2cd68d7de412a($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__Relay__new_single_host_addr__h6e0bfeec124ad2be($1 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($1 + 48 | 0) + 24 | 0) >> 2] = HEAP32[(($1 + 16 | 0) + 24 | 0) >> 2] | 0;
  i64toi32_i32$2 = ($1 + 16 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $33 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 48 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $33;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = ($1 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $40 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 48 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $40;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[($1 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  $43 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 48 | 0) >> 2] = $43;
  HEAP32[($1 + 52 | 0) >> 2] = i64toi32_i32$1;
  $0 = $cardano_serialization_lib__Relay_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__ha0d8781612d84a1b($1 + 48 | 0 | 0) | 0;
  global$0 = $1 + 80 | 0;
  return $0 | 0;
 }
 
 function withdrawals_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 56 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 72 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 56 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 60 | 0) >> 2] | 0;
  HEAP32[($2 + 72 | 0) >> 2] = HEAP32[($2 + 56 | 0) >> 2] | 0;
  HEAP32[($2 + 76 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__Withdrawals__from_bytes__h7372f1b0a0627994($2 + 8 | 0 | 0, $2 + 72 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
   abort();
  }
  memcpy($2 + 72 | 0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 40 | 0) | 0;
  $1 = $cardano_serialization_lib__Withdrawals_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8137ae41e80d8131($2 + 72 | 0 | 0) | 0;
  global$0 = $2 + 112 | 0;
  return $1 | 0;
 }
 
 function nativescript_hash($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $33 = 0, $40 = 0, $43 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h6ed0b6b043905434($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__NativeScript__hash__hb812a54d2c7bdca2($1 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($1 + 48 | 0) + 24 | 0) >> 2] = HEAP32[(($1 + 16 | 0) + 24 | 0) >> 2] | 0;
  i64toi32_i32$2 = ($1 + 16 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $33 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 48 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $33;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = ($1 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $40 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 48 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $40;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[($1 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  $43 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 48 | 0) >> 2] = $43;
  HEAP32[($1 + 52 | 0) >> 2] = i64toi32_i32$1;
  $0 = $cardano_serialization_lib__crypto__ScriptHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hcd9bcfbb1bcf9de7($1 + 48 | 0 | 0) | 0;
  global$0 = $1 + 80 | 0;
  return $0 | 0;
 }
 
 function update_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 128 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 64 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 80 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 68 | 0) >> 2] | 0;
  HEAP32[($2 + 80 | 0) >> 2] = HEAP32[($2 + 64 | 0) >> 2] | 0;
  HEAP32[($2 + 84 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__Update__from_bytes__haadf389624051209($2 + 8 | 0 | 0, $2 + 80 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
   abort();
  }
  memcpy($2 + 80 | 0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 48 | 0) | 0;
  $1 = $cardano_serialization_lib__Update_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__heaf0e9524107f139($2 + 80 | 0 | 0) | 0;
  global$0 = $2 + 128 | 0;
  return $1 | 0;
 }
 
 function proposedprotocolparameterupdates_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 56 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 72 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 56 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 60 | 0) >> 2] | 0;
  HEAP32[($2 + 72 | 0) >> 2] = HEAP32[($2 + 56 | 0) >> 2] | 0;
  HEAP32[($2 + 76 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__ProposedProtocolParameterUpdates__from_bytes__h490fdca9254b1788($2 + 8 | 0 | 0, $2 + 72 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
   abort();
  }
  memcpy($2 + 72 | 0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 40 | 0) | 0;
  $1 = $cardano_serialization_lib__ProposedProtocolParameterUpdates_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he29d4b6136a4f24f($2 + 72 | 0 | 0) | 0;
  global$0 = $2 + 112 | 0;
  return $1 | 0;
 }
 
 function protocolparamupdate_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 848 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 424 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 440 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 424 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 428 | 0) >> 2] | 0;
  HEAP32[($2 + 440 | 0) >> 2] = HEAP32[($2 + 424 | 0) >> 2] | 0;
  HEAP32[($2 + 444 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__ProtocolParamUpdate__from_bytes__h21b4eb9c10beb44b($2 + 8 | 0 | 0, $2 + 440 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
   abort();
  }
  memcpy($2 + 440 | 0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 408 | 0) | 0;
  $1 = $cardano_serialization_lib__ProtocolParamUpdate_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hd784927b58be35b6($2 + 440 | 0 | 0) | 0;
  global$0 = $2 + 848 | 0;
  return $1 | 0;
 }
 
 function block_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 848 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 424 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 440 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 424 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 428 | 0) >> 2] | 0;
  HEAP32[($2 + 440 | 0) >> 2] = HEAP32[($2 + 424 | 0) >> 2] | 0;
  HEAP32[($2 + 444 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__Block__from_bytes__ha89b6920433bc7f2($2 + 8 | 0 | 0, $2 + 440 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
   abort();
  }
  memcpy($2 + 440 | 0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 408 | 0) | 0;
  $1 = $cardano_serialization_lib__Block_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h2c5c321414f91af3($2 + 440 | 0 | 0) | 0;
  global$0 = $2 + 848 | 0;
  return $1 | 0;
 }
 
 function header_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 688 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 344 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 360 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 344 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 348 | 0) >> 2] | 0;
  HEAP32[($2 + 360 | 0) >> 2] = HEAP32[($2 + 344 | 0) >> 2] | 0;
  HEAP32[($2 + 364 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__Header__from_bytes__hbe7b02e3b3b339ad($2 + 8 | 0 | 0, $2 + 360 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
   abort();
  }
  memcpy($2 + 360 | 0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 328 | 0) | 0;
  $1 = $cardano_serialization_lib__Header_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h7c5802dbd37296c4($2 + 360 | 0 | 0) | 0;
  global$0 = $2 + 688 | 0;
  return $1 | 0;
 }
 
 function headerbody_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 656 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 328 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 344 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 328 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 332 | 0) >> 2] | 0;
  HEAP32[($2 + 344 | 0) >> 2] = HEAP32[($2 + 328 | 0) >> 2] | 0;
  HEAP32[($2 + 348 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__HeaderBody__from_bytes__h3a4e292fbb6b6511($2 + 8 | 0 | 0, $2 + 344 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
   abort();
  }
  memcpy($2 + 344 | 0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 312 | 0) | 0;
  $1 = $cardano_serialization_lib__HeaderBody_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he5de7ce2c4403ed1($2 + 344 | 0 | 0) | 0;
  global$0 = $2 + 656 | 0;
  return $1 | 0;
 }
 
 function headerbody_nonce_vrf($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $34 = 0, $41 = 0, $44 = 0;
  $1 = global$0 - 64 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h2ac16fcb64db16b5($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($1 + 16 | 0 | 0, $2 + 12 | 0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3(($1 + 16 | 0) + 12 | 0 | 0, $2 + 24 | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = ($1 + 16 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $34 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 40 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $34;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = ($1 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $41 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 40 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $41;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[($1 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  $44 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 40 | 0) >> 2] = $44;
  HEAP32[($1 + 44 | 0) >> 2] = i64toi32_i32$1;
  $0 = $cardano_serialization_lib__crypto__VRFCert_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hc597ed79f1e184d4($1 + 40 | 0 | 0) | 0;
  global$0 = $1 + 64 | 0;
  return $0 | 0;
 }
 
 function transactionunspentoutput_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 368 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 184 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 200 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 184 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 188 | 0) >> 2] | 0;
  HEAP32[($2 + 200 | 0) >> 2] = HEAP32[($2 + 184 | 0) >> 2] | 0;
  HEAP32[($2 + 204 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__utils__TransactionUnspentOutput__from_bytes__h28c90e81bd2fe0dc($2 + 8 | 0 | 0, $2 + 200 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
   abort();
  }
  memcpy($2 + 200 | 0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 168 | 0) | 0;
  $1 = $cardano_serialization_lib__utils__TransactionUnspentOutput_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h241331f04367994b($2 + 200 | 0 | 0) | 0;
  global$0 = $2 + 368 | 0;
  return $1 | 0;
 }
 
 function hash_auxiliary_data($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $26 = 0, $33 = 0, $40 = 0, $43 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hdd9a557acdd7acfa($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__utils__hash_auxiliary_data__h70df64c2596a1cad($1 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = ($1 + 16 | 0) + 24 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $26 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 48 | 0) + 24 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $26;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = ($1 + 16 | 0) + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $33 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 48 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $33;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = ($1 + 16 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $40 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 48 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $40;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[($1 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  $43 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[($1 + 48 | 0) >> 2] = $43;
  HEAP32[($1 + 52 | 0) >> 2] = i64toi32_i32$0;
  $0 = $cardano_serialization_lib__crypto__AuxiliaryDataHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__ha0bdb89a2c7c1e66($1 + 48 | 0 | 0) | 0;
  global$0 = $1 + 80 | 0;
  return $0 | 0;
 }
 
 function hash_transaction($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $26 = 0, $33 = 0, $40 = 0, $43 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h356c30395cf13adb($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__utils__hash_transaction__hf44530f726c579d0($1 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = ($1 + 16 | 0) + 24 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $26 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 48 | 0) + 24 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $26;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = ($1 + 16 | 0) + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $33 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 48 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $33;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = ($1 + 16 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $40 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 48 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $40;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[($1 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  $43 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[($1 + 48 | 0) >> 2] = $43;
  HEAP32[($1 + 52 | 0) >> 2] = i64toi32_i32$0;
  $0 = $cardano_serialization_lib__crypto__TransactionHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__ha325bfafa26d5417($1 + 48 | 0 | 0) | 0;
  global$0 = $1 + 80 | 0;
  return $0 | 0;
 }
 
 function hash_plutus_data($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $26 = 0, $33 = 0, $40 = 0, $43 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hb1fd14a6870cafe2($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__utils__hash_plutus_data__h0579fc1ddbe281cf($1 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = ($1 + 16 | 0) + 24 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $26 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 48 | 0) + 24 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $26;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = ($1 + 16 | 0) + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $33 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 48 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $33;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = ($1 + 16 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $40 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 48 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $40;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[($1 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  $43 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[($1 + 48 | 0) >> 2] = $43;
  HEAP32[($1 + 52 | 0) >> 2] = i64toi32_i32$0;
  $0 = $cardano_serialization_lib__crypto__DataHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hba2449530c6577ab($1 + 48 | 0 | 0) | 0;
  global$0 = $1 + 80 | 0;
  return $0 | 0;
 }
 
 function metadatamap_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 56 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 72 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 56 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 60 | 0) >> 2] | 0;
  HEAP32[($2 + 72 | 0) >> 2] = HEAP32[($2 + 56 | 0) >> 2] | 0;
  HEAP32[($2 + 76 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__metadata__MetadataMap__from_bytes__h7e94b112c87f5db5($2 + 8 | 0 | 0, $2 + 72 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
   abort();
  }
  memcpy($2 + 72 | 0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 40 | 0) | 0;
  $1 = $cardano_serialization_lib__metadata__MetadataMap_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hf2098e6c815f1680($2 + 72 | 0 | 0) | 0;
  global$0 = $2 + 112 | 0;
  return $1 | 0;
 }
 
 function transactionmetadatum_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 128 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 64 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 80 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 68 | 0) >> 2] | 0;
  HEAP32[($2 + 80 | 0) >> 2] = HEAP32[($2 + 64 | 0) >> 2] | 0;
  HEAP32[($2 + 84 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__metadata__TransactionMetadatum__from_bytes__hcb5aa2356703d6e1($2 + 8 | 0 | 0, $2 + 80 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
   abort();
  }
  memcpy($2 + 80 | 0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 48 | 0) | 0;
  $1 = $cardano_serialization_lib__metadata__TransactionMetadatum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hce2feba55b67d086($2 + 80 | 0 | 0) | 0;
  global$0 = $2 + 128 | 0;
  return $1 | 0;
 }
 
 function transactionmetadatum_new_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 128 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 64 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 80 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 68 | 0) >> 2] | 0;
  HEAP32[($2 + 80 | 0) >> 2] = HEAP32[($2 + 64 | 0) >> 2] | 0;
  HEAP32[($2 + 84 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__metadata__TransactionMetadatum__new_bytes__h341a06dfb4f1da88($2 + 8 | 0 | 0, $2 + 80 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
   abort();
  }
  memcpy($2 + 80 | 0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 48 | 0) | 0;
  $1 = $cardano_serialization_lib__metadata__TransactionMetadatum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hce2feba55b67d086($2 + 80 | 0 | 0) | 0;
  global$0 = $2 + 128 | 0;
  return $1 | 0;
 }
 
 function transactionmetadatum_new_text($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 128 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 64 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 80 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 68 | 0) >> 2] | 0;
  HEAP32[($2 + 80 | 0) >> 2] = HEAP32[($2 + 64 | 0) >> 2] | 0;
  HEAP32[($2 + 84 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__metadata__TransactionMetadatum__new_text__hc705d7de2d476a57($2 + 8 | 0 | 0, $2 + 80 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
   abort();
  }
  memcpy($2 + 80 | 0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 48 | 0) | 0;
  $1 = $cardano_serialization_lib__metadata__TransactionMetadatum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hce2feba55b67d086($2 + 80 | 0 | 0) | 0;
  global$0 = $2 + 128 | 0;
  return $1 | 0;
 }
 
 function generaltransactionmetadata_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 56 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 72 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 56 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 60 | 0) >> 2] | 0;
  HEAP32[($2 + 72 | 0) >> 2] = HEAP32[($2 + 56 | 0) >> 2] | 0;
  HEAP32[($2 + 76 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__metadata__GeneralTransactionMetadata__from_bytes__hb0b811957e7d516c($2 + 8 | 0 | 0, $2 + 72 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
   abort();
  }
  memcpy($2 + 72 | 0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 40 | 0) | 0;
  $1 = $cardano_serialization_lib__metadata__GeneralTransactionMetadata_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__haadefad5c9c3f4ac($2 + 72 | 0 | 0) | 0;
  global$0 = $2 + 112 | 0;
  return $1 | 0;
 }
 
 function auxiliarydata_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 80 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 96 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 80 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 84 | 0) >> 2] | 0;
  HEAP32[($2 + 96 | 0) >> 2] = HEAP32[($2 + 80 | 0) >> 2] | 0;
  HEAP32[($2 + 100 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__metadata__AuxiliaryData__from_bytes__h000def947847cc64($2 + 8 | 0 | 0, $2 + 96 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
   abort();
  }
  memcpy($2 + 96 | 0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 64 | 0) | 0;
  $1 = $cardano_serialization_lib__metadata__AuxiliaryData_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h48191cd5277961b5($2 + 96 | 0 | 0) | 0;
  global$0 = $2 + 160 | 0;
  return $1 | 0;
 }
 
 function transactionbuilder_get_total_input($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $28 = 0, $35 = 0, $40 = 0;
  $1 = global$0 - 64 | 0;
  global$0 = $1;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h37dfbd2f31d951c1($1 | 0, $0 | 0);
    $0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    cardano_serialization_lib__tx_builder__TransactionBuilder__get_total_input__hf80aba4988a4a524($1 + 8 | 0 | 0, HEAP32[$1 >> 2] | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    if ((HEAP32[($1 + 8 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    i64toi32_i32$2 = $1 + 32 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $28 = i64toi32_i32$0;
    i64toi32_i32$0 = ($1 + 40 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $28;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = ($1 + 8 | 0) + 16 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $35 = i64toi32_i32$1;
    i64toi32_i32$1 = ($1 + 40 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $35;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = ($1 + 8 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $40 = i64toi32_i32$0;
    i64toi32_i32$0 = $1;
    HEAP32[($1 + 40 | 0) >> 2] = $40;
    HEAP32[($1 + 44 | 0) >> 2] = i64toi32_i32$1;
    $0 = $cardano_serialization_lib__utils__Value_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h50a1108e1e08f966($1 + 40 | 0 | 0) | 0;
    global$0 = $1 + 64 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($1 + 12 | 0) >> 2] | 0 | 0);
  abort();
 }
 
 function transactionbuilder_get_total_output($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $28 = 0, $35 = 0, $40 = 0;
  $1 = global$0 - 64 | 0;
  global$0 = $1;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h37dfbd2f31d951c1($1 | 0, $0 | 0);
    $0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    cardano_serialization_lib__tx_builder__TransactionBuilder__get_total_output__h93b375eebf85cbd8($1 + 8 | 0 | 0, HEAP32[$1 >> 2] | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    if ((HEAP32[($1 + 8 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    i64toi32_i32$2 = $1 + 32 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $28 = i64toi32_i32$0;
    i64toi32_i32$0 = ($1 + 40 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $28;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = ($1 + 8 | 0) + 16 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $35 = i64toi32_i32$1;
    i64toi32_i32$1 = ($1 + 40 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $35;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = ($1 + 8 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $40 = i64toi32_i32$0;
    i64toi32_i32$0 = $1;
    HEAP32[($1 + 40 | 0) >> 2] = $40;
    HEAP32[($1 + 44 | 0) >> 2] = i64toi32_i32$1;
    $0 = $cardano_serialization_lib__utils__Value_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h50a1108e1e08f966($1 + 40 | 0 | 0) | 0;
    global$0 = $1 + 64 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($1 + 12 | 0) >> 2] | 0 | 0);
  abort();
 }
 
 function transactionbuilder_get_explicit_output($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $28 = 0, $35 = 0, $40 = 0;
  $1 = global$0 - 64 | 0;
  global$0 = $1;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h37dfbd2f31d951c1($1 | 0, $0 | 0);
    $0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    cardano_serialization_lib__tx_builder__TransactionBuilder__get_explicit_output__h759c362a670068a6($1 + 8 | 0 | 0, HEAP32[$1 >> 2] | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    if ((HEAP32[($1 + 8 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    i64toi32_i32$2 = $1 + 32 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $28 = i64toi32_i32$0;
    i64toi32_i32$0 = ($1 + 40 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $28;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = ($1 + 8 | 0) + 16 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $35 = i64toi32_i32$1;
    i64toi32_i32$1 = ($1 + 40 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $35;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = ($1 + 8 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $40 = i64toi32_i32$0;
    i64toi32_i32$0 = $1;
    HEAP32[($1 + 40 | 0) >> 2] = $40;
    HEAP32[($1 + 44 | 0) >> 2] = i64toi32_i32$1;
    $0 = $cardano_serialization_lib__utils__Value_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h50a1108e1e08f966($1 + 40 | 0 | 0) | 0;
    global$0 = $1 + 64 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($1 + 12 | 0) >> 2] | 0 | 0);
  abort();
 }
 
 function privatekey_to_public($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $1 = 0, i64toi32_i32$1 = 0, $26 = 0, $33 = 0, $40 = 0, $43 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h09a25d0fa720925e($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__impl_mockchain__key__EitherEd25519SecretKey__to_public__hd7cd5c1f2cabbdb8($1 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = ($1 + 16 | 0) + 24 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $26 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 48 | 0) + 24 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $26;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = ($1 + 16 | 0) + 16 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $33 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 48 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $33;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = ($1 + 16 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $40 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 48 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $40;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 16 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 17 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 18 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 19 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 20 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 21 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 22 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 23 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $43 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] = $43;
  HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] = i64toi32_i32$0;
  $0 = $cardano_serialization_lib__crypto__PublicKey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h435bbe8dcccd675c(i64toi32_i32$2 + 48 | 0 | 0) | 0;
  global$0 = i64toi32_i32$2 + 80 | 0;
  return $0 | 0;
 }
 
 function publickey_hash($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $33 = 0, $40 = 0, $43 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h67eb974eba5bb4b0($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__crypto__PublicKey__hash__hc5c76cad9b10a59a($1 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($1 + 48 | 0) + 24 | 0) >> 2] = HEAP32[(($1 + 16 | 0) + 24 | 0) >> 2] | 0;
  i64toi32_i32$2 = ($1 + 16 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $33 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 48 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $33;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = ($1 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $40 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 48 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $40;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[($1 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  $43 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 48 | 0) >> 2] = $43;
  HEAP32[($1 + 52 | 0) >> 2] = i64toi32_i32$1;
  $0 = $cardano_serialization_lib__crypto__Ed25519KeyHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hd63cf82b6a769066($1 + 48 | 0 | 0) | 0;
  global$0 = $1 + 80 | 0;
  return $0 | 0;
 }
 
 function address_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 80 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 96 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 80 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 84 | 0) >> 2] | 0;
  HEAP32[($2 + 96 | 0) >> 2] = HEAP32[($2 + 80 | 0) >> 2] | 0;
  HEAP32[($2 + 100 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__address__Address__from_bytes__he11c10ad6d995a7b($2 + 8 | 0 | 0, $2 + 96 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
   abort();
  }
  memcpy($2 + 96 | 0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 64 | 0) | 0;
  $1 = $cardano_serialization_lib__address__Address_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8ce30e61cf34786e($2 + 96 | 0 | 0) | 0;
  global$0 = $2 + 160 | 0;
  return $1 | 0;
 }
 
 function plutusscript_hash($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $33 = 0, $40 = 0, $43 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hf3651990986a0e62($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__plutus__PlutusScript__hash__hf798a55ecc919284($1 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($1 + 48 | 0) + 24 | 0) >> 2] = HEAP32[(($1 + 16 | 0) + 24 | 0) >> 2] | 0;
  i64toi32_i32$2 = ($1 + 16 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $33 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 48 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $33;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = ($1 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $40 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 48 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $40;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[($1 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  $43 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 48 | 0) >> 2] = $43;
  HEAP32[($1 + 52 | 0) >> 2] = i64toi32_i32$1;
  $0 = $cardano_serialization_lib__crypto__ScriptHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hcd9bcfbb1bcf9de7($1 + 48 | 0 | 0) | 0;
  global$0 = $1 + 80 | 0;
  return $0 | 0;
 }
 
 function plutusdata_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 128 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 64 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 80 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 68 | 0) >> 2] | 0;
  HEAP32[($2 + 80 | 0) >> 2] = HEAP32[($2 + 64 | 0) >> 2] | 0;
  HEAP32[($2 + 84 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__plutus__PlutusData__from_bytes__hd00076d7310249c6($2 + 8 | 0 | 0, $2 + 80 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
   abort();
  }
  memcpy($2 + 80 | 0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 48 | 0) | 0;
  $1 = $cardano_serialization_lib__plutus__PlutusData_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h7393378a3318e0a5($2 + 80 | 0 | 0) | 0;
  global$0 = $2 + 128 | 0;
  return $1 | 0;
 }
 
 function plutusdata_new_integer($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $3 = 0, $29 = 0, $32 = 0, $41 = 0, $45 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hb4a7701b5bc2a87c($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $3 = HEAPU8[($2 + 12 | 0) >> 0] | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hd36b5d149e6fd98b($1 + 32 | 0 | 0, $2 | 0);
  HEAP8[($1 + 44 | 0) >> 0] = $3;
  $2 = ($1 + 16 | 0) + 8 | 0;
  i64toi32_i32$2 = ($1 + 32 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $29 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $29;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[($1 + 32 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 36 | 0) >> 2] | 0;
  $32 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[($1 + 16 | 0) >> 2] = $32;
  HEAP32[($1 + 20 | 0) >> 2] = i64toi32_i32$0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $41 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 44 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $41;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 32 | 0) >> 2] = 3;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[($1 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  $45 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[($1 + 36 | 0) >> 2] = $45;
  HEAP32[($1 + 40 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($1 + 64 | 0) >> 2] = 0;
  $0 = $cardano_serialization_lib__plutus__PlutusData_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h7393378a3318e0a5($1 + 32 | 0 | 0) | 0;
  global$0 = $1 + 80 | 0;
  return $0 | 0;
 }
 
 function redeemer_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 192 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 96 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 112 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 96 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 100 | 0) >> 2] | 0;
  HEAP32[($2 + 112 | 0) >> 2] = HEAP32[($2 + 96 | 0) >> 2] | 0;
  HEAP32[($2 + 116 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__plutus__Redeemer__from_bytes__hb7dd5e3124e925ff($2 + 8 | 0 | 0, $2 + 112 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
   abort();
  }
  memcpy($2 + 112 | 0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 80 | 0) | 0;
  $1 = $cardano_serialization_lib__plutus__Redeemer_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he2ca0b82950da3f7($2 + 112 | 0 | 0) | 0;
  global$0 = $2 + 192 | 0;
  return $1 | 0;
 }
 
 function alloc__raw_vec__finish_grow__h9cca7d8a9459b8aa($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, $6 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if (!$2) {
       break label$4
      }
      $5 = 1;
      if (($1 | 0) >= (0 | 0)) {
       break label$3
      }
      break label$2;
     }
     HEAP32[($0 + 4 | 0) >> 2] = $1;
     $5 = 1;
     break label$2;
    }
    label$5 : {
     label$6 : {
      label$7 : {
       label$8 : {
        label$9 : {
         label$10 : {
          $6 = HEAP32[$3 >> 2] | 0;
          if (!$6) {
           break label$10
          }
          $3 = HEAP32[($3 + 4 | 0) >> 2] | 0;
          if ($3) {
           break label$8
          }
          if (!$1) {
           break label$9
          }
          break label$7;
         }
         if ($1) {
          break label$7
         }
        }
        $3 = $2;
        break label$6;
       }
       $3 = __rust_realloc($6 | 0, $3 | 0, $2 | 0, $1 | 0) | 0;
       if ($3) {
        break label$6
       }
       break label$5;
      }
      $3 = __rust_alloc($1 | 0, $2 | 0) | 0;
      if (!$3) {
       break label$5
      }
     }
     HEAP32[($0 + 4 | 0) >> 2] = $3;
     $5 = 0;
     break label$1;
    }
    $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    $1 = $2;
    break label$1;
   }
   $1 = 0;
  }
  HEAP32[$0 >> 2] = $5;
  HEAP32[($0 + 8 | 0) >> 2] = $1;
 }
 
 function alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__hf773ebee3f7d1881($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $6 = 0, $4 = 0, $7 = 0, $5 = 0;
  $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = HEAPU16[($4 + 138 | 0) >> 1] | 0;
  $6 = $3 << 2 | 0;
  $1 = ($5 << 2 | 0) - $6 | 0;
  $7 = $3 + -1 | 0;
  $3 = ($4 + $6 | 0) + 92 | 0;
  $4 = HEAP32[$2 >> 2] | 0;
  $6 = 1;
  label$1 : {
   label$2 : while (1) {
    label$3 : {
     if ($1) {
      break label$3
     }
     $7 = $5;
     break label$1;
    }
    $2 = HEAP32[$3 >> 2] | 0;
    $7 = $7 + 1 | 0;
    $1 = $1 + -4 | 0;
    $3 = $3 + 4 | 0;
    $2 = core__slice__cmp___impl_20core__cmp__Ord_20for_20_5bT_5d___cmp__h1f2092e0ba2f27ea($4 | 0, 28 | 0, $2 | 0, 28 | 0) | 0;
    if (($2 & 255 | 0 | 0) == (1 | 0)) {
     continue label$2
    }
    break label$2;
   };
   label$4 : {
    $6 = ($2 << 24 | 0) >> 24 | 0;
    switch ($6 + 1 | 0 | 0) {
    case 1:
     break label$1;
    default:
     break label$4;
    };
   }
   $6 = 1;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $7;
  HEAP32[$0 >> 2] = $6;
 }
 
 function alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__h8c834b0d29bdf3d8($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $6 = 0, $4 = 0, $7 = 0, $5 = 0;
  $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = HEAPU16[($4 + 138 | 0) >> 1] | 0;
  $6 = $3 << 2 | 0;
  $1 = ($5 << 2 | 0) - $6 | 0;
  $7 = $3 + -1 | 0;
  $3 = ($4 + $6 | 0) + 92 | 0;
  $4 = HEAP32[$2 >> 2] | 0;
  $6 = 1;
  label$1 : {
   label$2 : while (1) {
    label$3 : {
     if ($1) {
      break label$3
     }
     $7 = $5;
     break label$1;
    }
    $2 = HEAP32[$3 >> 2] | 0;
    $7 = $7 + 1 | 0;
    $1 = $1 + -4 | 0;
    $3 = $3 + 4 | 0;
    $2 = core__slice__cmp___impl_20core__cmp__Ord_20for_20_5bT_5d___cmp__h1f2092e0ba2f27ea($4 | 0, 28 | 0, $2 | 0, 28 | 0) | 0;
    if (($2 & 255 | 0 | 0) == (1 | 0)) {
     continue label$2
    }
    break label$2;
   };
   label$4 : {
    $6 = ($2 << 24 | 0) >> 24 | 0;
    switch ($6 + 1 | 0 | 0) {
    case 1:
     break label$1;
    default:
     break label$4;
    };
   }
   $6 = 1;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $7;
  HEAP32[$0 >> 2] = $6;
 }
 
 function relay_new_multi_host_name($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $10 = 0, $11 = 0, $12 = 0, $13 = 0, $14 = 0, $15 = 0, $23 = 0, $26 = 0, $30 = 0, $40 = 0, $44 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__ha28b58697d2aa221($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($1 + 32 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
  $10 = $1 + 58 | 0;
  $11 = HEAP32[(($1 + 32 | 0) + 8 | 0) >> 2] | 0;
  HEAP16[$10 >> 1] = $11;
  HEAP16[($10 + 2 | 0) >> 1] = $11 >>> 16 | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[($1 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 36 | 0) >> 2] | 0;
  $23 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  $12 = $23;
  HEAP16[($1 + 50 | 0) >> 1] = $12;
  HEAP16[($1 + 52 | 0) >> 1] = $12 >>> 16 | 0;
  HEAP16[($1 + 54 | 0) >> 1] = i64toi32_i32$1;
  HEAP16[($1 + 56 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAPU16[($1 + 48 | 0) >> 1] | 0 | ((HEAPU16[($1 + 50 | 0) >> 1] | 0) << 16 | 0) | 0;
  i64toi32_i32$0 = HEAPU16[($1 + 52 | 0) >> 1] | 0 | ((HEAPU16[($1 + 54 | 0) >> 1] | 0) << 16 | 0) | 0;
  $26 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[($1 + 16 | 0) >> 2] = $26;
  HEAP32[($1 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1 + 54 | 0;
  i64toi32_i32$0 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
  i64toi32_i32$1 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  $13 = $30;
  HEAP16[($1 + 22 | 0) >> 1] = $13;
  HEAP16[($1 + 24 | 0) >> 1] = $13 >>> 16 | 0;
  HEAP16[($1 + 26 | 0) >> 1] = i64toi32_i32$1;
  HEAP16[($1 + 28 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAPU16[($1 + 22 | 0) >> 1] | 0 | ((HEAPU16[($1 + 24 | 0) >> 1] | 0) << 16 | 0) | 0;
  i64toi32_i32$0 = HEAPU16[($1 + 26 | 0) >> 1] | 0 | ((HEAPU16[($1 + 28 | 0) >> 1] | 0) << 16 | 0) | 0;
  $40 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 48 | 0) + 8 | 0;
  $14 = $40;
  HEAP16[i64toi32_i32$1 >> 1] = $14;
  HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $14 >>> 16 | 0;
  HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = i64toi32_i32$0;
  HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
  HEAP16[($1 + 48 | 0) >> 1] = 2;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[($1 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  $44 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  $15 = $44;
  HEAP16[($1 + 50 | 0) >> 1] = $15;
  HEAP16[($1 + 52 | 0) >> 1] = $15 >>> 16 | 0;
  HEAP16[($1 + 54 | 0) >> 1] = i64toi32_i32$1;
  HEAP16[($1 + 56 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
  $0 = $cardano_serialization_lib__Relay_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__ha0d8781612d84a1b($1 + 48 | 0 | 0) | 0;
  global$0 = $1 + 80 | 0;
  return $0 | 0;
 }
 
 function auxiliarydataset_insert($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, $4 = 0, $5 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0;
  $3 = global$0 - 160 | 0;
  global$0 = $3;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h94807ac56e362a92($3 + 16 | 0 | 0, $0 | 0);
   if (!$2) {
    break label$1
   }
   $4 = HEAP32[($3 + 20 | 0) >> 2] | 0;
   $5 = HEAP32[($3 + 16 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hdd9a557acdd7acfa($3 + 8 | 0 | 0, $2 | 0);
   $0 = HEAP32[($3 + 12 | 0) >> 2] | 0;
   cardano_serialization_lib__AuxiliaryDataSet__insert__h259df39354baaf70($3 + 24 | 0 | 0, $5 | 0, $1 | 0, HEAP32[($3 + 8 | 0) >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   $0 = 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($4 | 0, 0 | 0) | 0;
   label$2 : {
    i64toi32_i32$0 = HEAP32[($3 + 24 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($3 + 28 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    if ((i64toi32_i32$2 | 0) != (1 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$0 | 0) | 0) {
     break label$2
    }
    memcpy($3 + 96 | 0 | 0, $3 + 32 | 0 | 0, 64 | 0) | 0;
    $0 = $cardano_serialization_lib__metadata__AuxiliaryData_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h48191cd5277961b5($3 + 96 | 0 | 0) | 0;
   }
   global$0 = $3 + 160 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function $cardano_serialization_lib__utils__Value_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h50a1108e1e08f966($0) {
  $0 = $0 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $1 = 0, $10 = 0, $16 = 0, $19 = 0, $25 = 0, $31 = 0, $37 = 0;
  $1 = global$0 - 32 | 0;
  global$0 = $1;
  i64toi32_i32$2 = $0 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 4 | 0) + 20 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $10;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $0 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $16 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 4 | 0) + 12 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $16;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $19;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   $0 = __rust_alloc(32 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(32 | 0, 8 | 0);
   abort();
  }
  HEAP32[$0 >> 2] = 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  $25 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $25;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = (i64toi32_i32$2 + 4 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 12 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $31;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = ($1 + 4 | 0) + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $37 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 20 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $37;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($0 + 28 | 0) >> 2] = HEAP32[($1 + 28 | 0) >> 2] | 0;
  global$0 = $1 + 32 | 0;
  return $0 | 0;
 }
 
 function $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__iter__traits__collect__Extend__28K_2cV_29____extend__hf141c664ff96472c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $7 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 224 | 0;
  global$0 = $2;
  label$1 : {
   $3 = HEAP32[$1 >> 2] | 0;
   $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   if (($3 | 0) == ($4 | 0)) {
    break label$1
   }
   $5 = $2 + 88 | 0;
   $6 = $2 + 16 | 0;
   $7 = $2 + 92 | 0;
   label$2 : while (1) {
    $1 = HEAP32[($3 + 68 | 0) >> 2] | 0;
    core__ops__function__impls___impl_20core__ops__function__FnOnce_A__20for_20_mut_20F___call_once__hb66958512d8fa8c9($5 | 0, $2 | 0, $3 + 72 | 0 | 0, $3 | 0);
    $3 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    memcpy($2 + 12 | 0 | 0, $7 | 0, 68 | 0) | 0;
    memcpy($2 + 160 | 0 | 0, $6 | 0, 64 | 0) | 0;
    linked_hash_map__LinkedHashMap_K_2cV_2cS___insert__h37110d4804766b2f($2 + 80 | 0 | 0, $0 | 0, $3 | 0, $2 + 160 | 0 | 0);
    label$3 : {
     i64toi32_i32$1 = HEAP32[($2 + 84 | 0) >> 2] | 0;
     if (!(HEAP32[($2 + 80 | 0) >> 2] | 0 | i64toi32_i32$1 | 0)) {
      break label$3
     }
     core__ptr__drop_in_place_cardano_serialization_lib__metadata__AuxiliaryData___hdde6d009d300f71d($5 | 0);
    }
    $3 = $1;
    if (($3 | 0) != ($4 | 0)) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $2 + 224 | 0;
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___insert__hb14f14f8e669d8cf($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0;
  $4 = global$0 - 192 | 0;
  global$0 = $4;
  memcpy($4 + 80 | 0 | 0, $2 | 0, 48 | 0) | 0;
  alloc__collections__btree__map__BTreeMap_K_2cV___entry__he1839f1eb7854c94($4 + 8 | 0 | 0, $1 | 0, $4 + 80 | 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[($4 + 8 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    memcpy($4 + 80 | 0 | 0, $4 + 16 | 0 | 0, 64 | 0) | 0;
    memcpy($4 + 144 | 0 | 0, $3 | 0, 48 | 0) | 0;
    alloc__collections__btree__map__entry__VacantEntry_K_2cV___insert__hf8bedac3dc581ec2($4 + 80 | 0 | 0, $4 + 144 | 0 | 0) | 0;
    HEAP32[$0 >> 2] = 5;
    break label$1;
   }
   $1 = ((HEAP32[($4 + 16 | 0) >> 2] | 0) + Math_imul(HEAP32[($4 + 20 | 0) >> 2] | 0, 48) | 0) + 528 | 0;
   memcpy($0 | 0, $1 | 0, 48 | 0) | 0;
   memcpy($1 | 0, $3 | 0, 48 | 0) | 0;
  }
  global$0 = $4 + 192 | 0;
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h07097b699c9c8f63($0) {
  $0 = $0 | 0;
  var $1 = 0, $4 = 0, i64toi32_i32$2 = 0, $2 = 0, $3 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $2 = HEAP32[$0 >> 2] | 0;
   $3 = Math_imul($1, 200);
   $0 = 0;
   label$2 : while (1) {
    label$3 : {
     label$4 : {
      $4 = $2 + $0 | 0;
      $1 = HEAPU8[$4 >> 0] | 0;
      if ($1 >>> 0 > 5 >>> 0) {
       break label$4
      }
      if (($1 | 0) != (3 | 0)) {
       break label$3
      }
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h72de9eab2f0e4669($4 + 40 | 0 | 0);
      $1 = $4 + 52 | 0;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hb600accf9d1c2a17($1 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h96b3170d440e3692($1 | 0);
      $1 = $4 + 64 | 0;
      if (!(HEAP32[$1 >> 2] | 0)) {
       break label$3
      }
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
      break label$3;
     }
     i64toi32_i32$2 = $4 + 8 | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     if (!(HEAP32[i64toi32_i32$2 >> 2] | 0 | i64toi32_i32$1 | 0)) {
      break label$3
     }
     $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__hddd2979ebb13db27($4 + 16 | 0 | 0);
     $1 = $4 + 32 | 0;
     if (!(HEAP32[$1 >> 2] | 0)) {
      break label$3
     }
     hashbrown__raw__RawTable_T_2cA___free_buckets__h78477753a901af0e($1 | 0);
    }
    $0 = $0 + 200 | 0;
    if (($3 | 0) != ($0 | 0)) {
     continue label$2
    }
    break label$2;
   };
  }
 }
 
 function $cardano_serialization_lib__address__Pointer_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hce108dee3b07a283($0) {
  $0 = $0 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $1 = 0, $10 = 0, $16 = 0, $19 = 0, $25 = 0, $31 = 0, $37 = 0;
  $1 = global$0 - 32 | 0;
  global$0 = $1;
  i64toi32_i32$2 = $0 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 4 | 0) + 20 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $10;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $0 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $16 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 4 | 0) + 12 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $16;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $19;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   $0 = __rust_alloc(32 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(32 | 0, 8 | 0);
   abort();
  }
  HEAP32[$0 >> 2] = 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  $25 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $25;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = (i64toi32_i32$2 + 4 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 12 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $31;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = ($1 + 4 | 0) + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $37 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 20 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $37;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($0 + 28 | 0) >> 2] = HEAP32[($1 + 28 | 0) >> 2] | 0;
  global$0 = $1 + 32 | 0;
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__plutus__ConstrPlutusData_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hd2d0c81add63de21($0) {
  $0 = $0 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $1 = 0, $10 = 0, $16 = 0, $19 = 0, $25 = 0, $31 = 0, $37 = 0;
  $1 = global$0 - 32 | 0;
  global$0 = $1;
  i64toi32_i32$2 = $0 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 4 | 0) + 20 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $10;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $0 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $16 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 4 | 0) + 12 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $16;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $19;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   $0 = __rust_alloc(32 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(32 | 0, 8 | 0);
   abort();
  }
  HEAP32[$0 >> 2] = 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  $25 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $25;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = (i64toi32_i32$2 + 4 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 12 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $31;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = ($1 + 4 | 0) + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $37 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 20 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $37;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($0 + 28 | 0) >> 2] = HEAP32[($1 + 28 | 0) >> 2] | 0;
  global$0 = $1 + 32 | 0;
  return $0 | 0;
 }
 
 function ppv_lite86__generic__omap2__ha0f66afdd187b7fb($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, i64toi32_i32$3 = 0, $5$hi = 0, $6$hi = 0, $16 = 0, $19 = 0, $5 = 0, $6 = 0, $33 = 0, $36 = 0, $44 = 0, $44$hi = 0, $45 = 0, $45$hi = 0, $49 = 0, $49$hi = 0, $50 = 0, $50$hi = 0, $54 = 0, $57 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  $4 = ($3 + 32 | 0) + 8 | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $16 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[i64toi32_i32$0 >> 2] = $16;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[(i64toi32_i32$1 + 32 | 0) >> 2] = $19;
  HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] = i64toi32_i32$0;
  ppv_lite86__generic__o_of_q__hb8b715d2ffb8bacd(i64toi32_i32$1 + 16 | 0 | 0, i64toi32_i32$1 + 32 | 0 | 0);
  i64toi32_i32$2 = (i64toi32_i32$1 + 16 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $6 = i64toi32_i32$1;
  $6$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $2 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $33 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[i64toi32_i32$0 >> 2] = $33;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[(i64toi32_i32$1 + 32 | 0) >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] = i64toi32_i32$0;
  ppv_lite86__generic__o_of_q__hb8b715d2ffb8bacd(i64toi32_i32$1 | 0, i64toi32_i32$1 + 32 | 0 | 0);
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $44 = i64toi32_i32$0;
  $44$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$2 = $6;
  i64toi32_i32$0 = $44$hi;
  i64toi32_i32$3 = $44;
  i64toi32_i32$0 = i64toi32_i32$1 ^ i64toi32_i32$0 | 0;
  $45 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $45$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $5$hi;
  i64toi32_i32$1 = $3 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $49 = i64toi32_i32$0;
  $49$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $5$hi;
  i64toi32_i32$1 = $5;
  i64toi32_i32$0 = $49$hi;
  i64toi32_i32$3 = $49;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $50 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $50$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $45$hi;
  i64toi32_i32$1 = $50$hi;
  ppv_lite86__generic__q_of_o__h249a42d67ddc4145($3 + 32 | 0 | 0, $45 | 0, i64toi32_i32$0 | 0, $50 | 0, i64toi32_i32$1 | 0);
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $54 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $54;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] | 0;
  $57 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $57;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = i64toi32_i32$2 + 48 | 0;
 }
 
 function alloc__raw_vec__finish_grow__h4c09fb07da592cb2($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, $6 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if (!$2) {
       break label$4
      }
      $5 = 1;
      if (($1 | 0) >= (0 | 0)) {
       break label$3
      }
      break label$2;
     }
     HEAP32[($0 + 4 | 0) >> 2] = $1;
     $5 = 1;
     break label$2;
    }
    label$5 : {
     label$6 : {
      label$7 : {
       label$8 : {
        label$9 : {
         label$10 : {
          $6 = HEAP32[$3 >> 2] | 0;
          if (!$6) {
           break label$10
          }
          $3 = HEAP32[($3 + 4 | 0) >> 2] | 0;
          if ($3) {
           break label$8
          }
          if (!$1) {
           break label$9
          }
          break label$7;
         }
         if ($1) {
          break label$7
         }
        }
        $3 = $2;
        break label$6;
       }
       $3 = __rust_realloc($6 | 0, $3 | 0, $2 | 0, $1 | 0) | 0;
       if ($3) {
        break label$6
       }
       break label$5;
      }
      $3 = __rust_alloc($1 | 0, $2 | 0) | 0;
      if (!$3) {
       break label$5
      }
     }
     HEAP32[($0 + 4 | 0) >> 2] = $3;
     $5 = 0;
     break label$1;
    }
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    $1 = $2;
    break label$1;
   }
   $1 = 0;
  }
  HEAP32[$0 >> 2] = $5;
  HEAP32[($0 + 8 | 0) >> 2] = $1;
 }
 
 function alloc__raw_vec__finish_grow__h889b166b5e37b56f($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, $6 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if (!$2) {
       break label$4
      }
      $5 = 1;
      if (($1 | 0) >= (0 | 0)) {
       break label$3
      }
      break label$2;
     }
     HEAP32[($0 + 4 | 0) >> 2] = $1;
     $5 = 1;
     break label$2;
    }
    label$5 : {
     label$6 : {
      label$7 : {
       label$8 : {
        label$9 : {
         label$10 : {
          $6 = HEAP32[$3 >> 2] | 0;
          if (!$6) {
           break label$10
          }
          $3 = HEAP32[($3 + 4 | 0) >> 2] | 0;
          if ($3) {
           break label$8
          }
          if (!$1) {
           break label$9
          }
          break label$7;
         }
         if ($1) {
          break label$7
         }
        }
        $3 = $2;
        break label$6;
       }
       $3 = __rust_realloc($6 | 0, $3 | 0, $2 | 0, $1 | 0) | 0;
       if ($3) {
        break label$6
       }
       break label$5;
      }
      $3 = __rust_alloc($1 | 0, $2 | 0) | 0;
      if (!$3) {
       break label$5
      }
     }
     HEAP32[($0 + 4 | 0) >> 2] = $3;
     $5 = 0;
     break label$1;
    }
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    $1 = $2;
    break label$1;
   }
   $1 = 0;
  }
  HEAP32[$0 >> 2] = $5;
  HEAP32[($0 + 8 | 0) >> 2] = $1;
 }
 
 function ryu__pretty__exponent__write_exponent3__hca613cb8347b0028($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $7 = 0;
  label$1 : {
   label$2 : {
    if (($0 | 0) <= (-1 | 0)) {
     break label$2
    }
    $2 = $0;
    break label$1;
   }
   HEAP8[$1 >> 0] = 45;
   $2 = 0 - $0 | 0;
   $1 = $1 + 1 | 0;
  }
  label$3 : {
   label$4 : {
    if (($2 | 0) > (99 | 0)) {
     break label$4
    }
    if (($2 | 0) > (9 | 0)) {
     break label$3
    }
    HEAP8[$1 >> 0] = $2 + 48 | 0;
    return ($0 >>> 31 | 0) + 1 | 0 | 0;
   }
   $3 = ($2 >>> 0) / (100 >>> 0) | 0;
   HEAP8[$1 >> 0] = $3 + 48 | 0;
   $4 = (($2 - Math_imul($3, 100) | 0) << 1 | 0) + 1100304 | 0;
   $5 = HEAPU8[$4 >> 0] | 0 | ((HEAPU8[($4 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
   HEAP8[($1 + 1 | 0) >> 0] = $5;
   HEAP8[($1 + 2 | 0) >> 0] = $5 >>> 8 | 0;
   return ($0 >>> 31 | 0) + 3 | 0 | 0;
  }
  $6 = ($2 << 1 | 0) + 1100304 | 0;
  $7 = HEAPU8[$6 >> 0] | 0 | ((HEAPU8[($6 + 1 | 0) >> 0] | 0) << 8 | 0) | 0;
  HEAP8[$1 >> 0] = $7;
  HEAP8[($1 + 1 | 0) >> 0] = $7 >>> 8 | 0;
  return $0 >>> 31 | 0 | 2 | 0 | 0;
 }
 
 function alloc__raw_vec__finish_grow__hb156cf8e568fdb60($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, $6 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if (!$2) {
       break label$4
      }
      $5 = 1;
      if (($1 | 0) >= (0 | 0)) {
       break label$3
      }
      break label$2;
     }
     HEAP32[($0 + 4 | 0) >> 2] = $1;
     $5 = 1;
     break label$2;
    }
    label$5 : {
     label$6 : {
      label$7 : {
       label$8 : {
        label$9 : {
         label$10 : {
          $6 = HEAP32[$3 >> 2] | 0;
          if (!$6) {
           break label$10
          }
          $3 = HEAP32[($3 + 4 | 0) >> 2] | 0;
          if ($3) {
           break label$8
          }
          if (!$1) {
           break label$9
          }
          break label$7;
         }
         if ($1) {
          break label$7
         }
        }
        $3 = $2;
        break label$6;
       }
       $3 = __rust_realloc($6 | 0, $3 | 0, $2 | 0, $1 | 0) | 0;
       if ($3) {
        break label$6
       }
       break label$5;
      }
      $3 = __rust_alloc($1 | 0, $2 | 0) | 0;
      if (!$3) {
       break label$5
      }
     }
     HEAP32[($0 + 4 | 0) >> 2] = $3;
     $5 = 0;
     break label$1;
    }
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    $1 = $2;
    break label$1;
   }
   $1 = 0;
  }
  HEAP32[$0 >> 2] = $5;
  HEAP32[($0 + 8 | 0) >> 2] = $1;
 }
 
 function $bech32__Bech32Writer_20as_20bech32__WriteBase32___write_u5__h939535a14b4513fd($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $4 = 0, $3 = 0, $6 = 0, $5 = 0, $7 = 0;
  $2 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  $3 = $1 & 255 | 0;
  $4 = (($2 << 5 | 0) & 1073741792 | 0) ^ $3 | 0;
  HEAP32[($0 + 8 | 0) >> 2] = $4;
  $5 = $2 >>> 25 | 0;
  $2 = 0;
  $6 = 1138480;
  label$1 : while (1) {
   $7 = $2 + 1 | 0;
   label$2 : {
    if (!(($5 >>> ($2 & 255 | 0) | 0) & 1 | 0)) {
     break label$2
    }
    $4 = (HEAP32[$6 >> 2] | 0) ^ $4 | 0;
    HEAP32[($0 + 8 | 0) >> 2] = $4;
   }
   $6 = $6 + 4 | 0;
   $2 = $7;
   if (($2 | 0) != (5 | 0)) {
    continue label$1
   }
   break label$1;
  };
  label$3 : {
   if (($1 & 255 | 0) >>> 0 >= 32 >>> 0) {
    break label$3
   }
   return FUNCTION_TABLE[HEAP32[((HEAP32[($0 + 4 | 0) >> 2] | 0) + 16 | 0) >> 2] | 0 | 0](HEAP32[$0 >> 2] | 0, HEAP32[(($3 << 2 | 0) + 1138248 | 0) >> 2] | 0) | 0 | 0;
  }
  core__panicking__panic_bounds_check__h808b524af17640b1($3 | 0, 32 | 0, 1138464 | 0);
  abort();
 }
 
 function alloc__raw_vec__finish_grow__h5a30504ab9b31c2c($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, $6 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if (!$2) {
       break label$4
      }
      $5 = 1;
      if (($1 | 0) >= (0 | 0)) {
       break label$3
      }
      break label$2;
     }
     HEAP32[($0 + 4 | 0) >> 2] = $1;
     $5 = 1;
     break label$2;
    }
    label$5 : {
     label$6 : {
      label$7 : {
       label$8 : {
        label$9 : {
         label$10 : {
          $6 = HEAP32[$3 >> 2] | 0;
          if (!$6) {
           break label$10
          }
          $3 = HEAP32[($3 + 4 | 0) >> 2] | 0;
          if ($3) {
           break label$8
          }
          if (!$1) {
           break label$9
          }
          break label$7;
         }
         if ($1) {
          break label$7
         }
        }
        $3 = $2;
        break label$6;
       }
       $3 = __rust_realloc($6 | 0, $3 | 0, $2 | 0, $1 | 0) | 0;
       if ($3) {
        break label$6
       }
       break label$5;
      }
      $3 = __rust_alloc($1 | 0, $2 | 0) | 0;
      if (!$3) {
       break label$5
      }
     }
     HEAP32[($0 + 4 | 0) >> 2] = $3;
     $5 = 0;
     break label$1;
    }
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    $1 = $2;
    break label$1;
   }
   $1 = 0;
  }
  HEAP32[$0 >> 2] = $5;
  HEAP32[($0 + 8 | 0) >> 2] = $1;
 }
 
 function $_mut_20W_20as_20core__fmt__Write___write_str__haaed28c7ba29a6da($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $6 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, $6$hi = 0, $3 = 0, $15 = 0, $16 = 0, $4 = 0, $5 = 0, $17 = 0, $18 = 0, $19 = 0, $20 = 0, $48 = 0, $52 = 0;
  label$1 : {
   $0 = HEAP32[$0 >> 2] | 0;
   i64toi32_i32$0 = $std__io__stdio__StdoutLock_20as_20std__io__Write___write_all__ha8d32e9dac01e4a2(HEAP32[$0 >> 2] | 0 | 0, $1 | 0, $2 | 0) | 0;
   i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
   $6 = i64toi32_i32$0;
   $6$hi = i64toi32_i32$1;
   $2 = i64toi32_i32$0;
   $1 = i64toi32_i32$0 & 255 | 0;
   if (($1 | 0) == (4 | 0)) {
    break label$1
   }
   i64toi32_i32$1 = $6$hi;
   i64toi32_i32$2 = $6;
   i64toi32_i32$0 = 0;
   i64toi32_i32$3 = 8;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$0 = 0;
    $16 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   } else {
    i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
    $16 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
   }
   $6 = $16;
   $6$hi = i64toi32_i32$0;
   label$2 : {
    if ((HEAPU8[($0 + 4 | 0) >> 0] | 0 | 0) != (3 | 0)) {
     break label$2
    }
    $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
    FUNCTION_TABLE[HEAP32[(HEAP32[($3 + 4 | 0) >> 2] | 0) >> 2] | 0 | 0](HEAP32[$3 >> 2] | 0);
    label$3 : {
     $4 = HEAP32[($3 + 4 | 0) >> 2] | 0;
     $5 = HEAP32[($4 + 4 | 0) >> 2] | 0;
     if (!$5) {
      break label$3
     }
     __rust_dealloc(HEAP32[$3 >> 2] | 0 | 0, $5 | 0, HEAP32[($4 + 8 | 0) >> 2] | 0 | 0);
    }
    __rust_dealloc($3 | 0, 12 | 0, 4 | 0);
   }
   HEAP8[($0 + 4 | 0) >> 0] = $2;
   $48 = $0 + 11 | 0;
   i64toi32_i32$0 = $6$hi;
   i64toi32_i32$1 = $6;
   i64toi32_i32$2 = 0;
   i64toi32_i32$3 = 48;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$2 = 0;
    $17 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   } else {
    i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
    $17 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
   }
   HEAP8[$48 >> 0] = $17;
   $52 = $0 + 9 | 0;
   i64toi32_i32$2 = $6$hi;
   i64toi32_i32$0 = $6;
   i64toi32_i32$1 = 0;
   i64toi32_i32$3 = 32;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$1 = 0;
    $18 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   } else {
    i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
    $18 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
   }
   $19 = $52;
   $20 = $18;
   HEAP8[$19 >> 0] = $20;
   HEAP8[($19 + 1 | 0) >> 0] = $20 >>> 8 | 0;
   i64toi32_i32$1 = $6$hi;
   $15 = $0 + 5 | 0;
   HEAP8[$15 >> 0] = $6;
   HEAP8[($15 + 1 | 0) >> 0] = $6 >>> 8 | 0;
   HEAP8[($15 + 2 | 0) >> 0] = $6 >>> 16 | 0;
   HEAP8[($15 + 3 | 0) >> 0] = $6 >>> 24 | 0;
  }
  return ($1 | 0) != (4 | 0) | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge___insert_fit__hd71c9bcee1c629bd($0, $1, $2, $2$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  var $3 = 0, $6 = 0, $7 = 0, $4 = 0, $5 = 0, $8 = 0, $9 = 0, i64toi32_i32$0 = 0;
  $3 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $0 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  $4 = $0 << 2 | 0;
  $5 = ($3 + $4 | 0) + 92 | 0;
  label$1 : {
   label$2 : {
    $6 = $0 + 1 | 0;
    $7 = HEAPU16[($3 + 138 | 0) >> 1] | 0;
    if ($6 >>> 0 <= $7 >>> 0) {
     break label$2
    }
    HEAP32[$5 >> 2] = $1;
    break label$1;
   }
   $8 = $3 + 92 | 0;
   $9 = $7 - $0 | 0;
   memmove($8 + ($6 << 2 | 0) | 0 | 0, $5 | 0, $9 << 2 | 0 | 0) | 0;
   HEAP32[($8 + $4 | 0) >> 2] = $1;
   memmove($3 + ($6 << 3 | 0) | 0 | 0, $3 + ($0 << 3 | 0) | 0 | 0, $9 << 3 | 0 | 0) | 0;
  }
  $0 = $3 + ($0 << 3 | 0) | 0;
  i64toi32_i32$0 = $2$hi;
  HEAP32[$0 >> 2] = $2;
  HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP16[($3 + 138 | 0) >> 1] = $7 + 1 | 0;
  return $0 | 0;
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next_unchecked__h1fe8f7644bb12cc0($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $19 = 0, $30 = 0, $5$hi = 0, $6$hi = 0, $47 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  $3 = $2 + 8 | 0;
  $4 = $1 + 8 | 0;
  HEAP32[$3 >> 2] = HEAP32[$4 >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $19;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next__h78d59ba4253ea06a(i64toi32_i32$0 + 24 | 0 | 0, i64toi32_i32$0 | 0);
  label$1 : {
   if (HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] | 0) {
    break label$1
   }
   core__panicking__panic__h2fd385a887c8bf13(1048576 | 0, 43 | 0, 1049848 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 24 | 0) + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = ($2 + 24 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$1;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $5;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $6 = i64toi32_i32$1;
  $6$hi = i64toi32_i32$0;
  i64toi32_i32$1 = $2;
  HEAP32[i64toi32_i32$1 >> 2] = $6;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $5$hi;
  HEAP32[$4 >> 2] = $5;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$1 = $1;
  HEAP32[i64toi32_i32$1 >> 2] = $6;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  $47 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $47;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 20 | 0) >> 2] | 0;
  global$0 = $2 + 48 | 0;
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next_unchecked__h59e89313562fc348($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $19 = 0, $30 = 0, $5$hi = 0, $6$hi = 0, $47 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  $3 = $2 + 8 | 0;
  $4 = $1 + 8 | 0;
  HEAP32[$3 >> 2] = HEAP32[$4 >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $19;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next__h17e50943fe483865(i64toi32_i32$0 + 24 | 0 | 0, i64toi32_i32$0 | 0);
  label$1 : {
   if (HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] | 0) {
    break label$1
   }
   core__panicking__panic__h2fd385a887c8bf13(1048576 | 0, 43 | 0, 1049848 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 24 | 0) + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = ($2 + 24 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$1;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $5;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $6 = i64toi32_i32$1;
  $6$hi = i64toi32_i32$0;
  i64toi32_i32$1 = $2;
  HEAP32[i64toi32_i32$1 >> 2] = $6;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $5$hi;
  HEAP32[$4 >> 2] = $5;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$1 = $1;
  HEAP32[i64toi32_i32$1 >> 2] = $6;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  $47 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $47;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 20 | 0) >> 2] | 0;
  global$0 = $2 + 48 | 0;
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next_unchecked__h5e1ce7ff4b058b50($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $19 = 0, $30 = 0, $5$hi = 0, $6$hi = 0, $47 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  $3 = $2 + 8 | 0;
  $4 = $1 + 8 | 0;
  HEAP32[$3 >> 2] = HEAP32[$4 >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $19;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next__hd4985e8bbf244150(i64toi32_i32$0 + 24 | 0 | 0, i64toi32_i32$0 | 0);
  label$1 : {
   if (HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] | 0) {
    break label$1
   }
   core__panicking__panic__h2fd385a887c8bf13(1048576 | 0, 43 | 0, 1049848 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 24 | 0) + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = ($2 + 24 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$1;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $5;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $6 = i64toi32_i32$1;
  $6$hi = i64toi32_i32$0;
  i64toi32_i32$1 = $2;
  HEAP32[i64toi32_i32$1 >> 2] = $6;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $5$hi;
  HEAP32[$4 >> 2] = $5;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$1 = $1;
  HEAP32[i64toi32_i32$1 >> 2] = $6;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  $47 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $47;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 20 | 0) >> 2] | 0;
  global$0 = $2 + 48 | 0;
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next_unchecked__h6b52d79e857351fc($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $19 = 0, $30 = 0, $5$hi = 0, $6$hi = 0, $47 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  $3 = $2 + 8 | 0;
  $4 = $1 + 8 | 0;
  HEAP32[$3 >> 2] = HEAP32[$4 >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $19;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next__h89c63cc8ceb597b8(i64toi32_i32$0 + 24 | 0 | 0, i64toi32_i32$0 | 0);
  label$1 : {
   if (HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] | 0) {
    break label$1
   }
   core__panicking__panic__h2fd385a887c8bf13(1048576 | 0, 43 | 0, 1049848 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 24 | 0) + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = ($2 + 24 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$1;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $5;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $6 = i64toi32_i32$1;
  $6$hi = i64toi32_i32$0;
  i64toi32_i32$1 = $2;
  HEAP32[i64toi32_i32$1 >> 2] = $6;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $5$hi;
  HEAP32[$4 >> 2] = $5;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$1 = $1;
  HEAP32[i64toi32_i32$1 >> 2] = $6;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  $47 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $47;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 20 | 0) >> 2] | 0;
  global$0 = $2 + 48 | 0;
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next_unchecked__h6c9193d27088bb22($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $19 = 0, $30 = 0, $5$hi = 0, $6$hi = 0, $47 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  $3 = $2 + 8 | 0;
  $4 = $1 + 8 | 0;
  HEAP32[$3 >> 2] = HEAP32[$4 >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $19;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next__h1f81998e00032910(i64toi32_i32$0 + 24 | 0 | 0, i64toi32_i32$0 | 0);
  label$1 : {
   if (HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] | 0) {
    break label$1
   }
   core__panicking__panic__h2fd385a887c8bf13(1048576 | 0, 43 | 0, 1049848 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 24 | 0) + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = ($2 + 24 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$1;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $5;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $6 = i64toi32_i32$1;
  $6$hi = i64toi32_i32$0;
  i64toi32_i32$1 = $2;
  HEAP32[i64toi32_i32$1 >> 2] = $6;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $5$hi;
  HEAP32[$4 >> 2] = $5;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$1 = $1;
  HEAP32[i64toi32_i32$1 >> 2] = $6;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  $47 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $47;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 20 | 0) >> 2] | 0;
  global$0 = $2 + 48 | 0;
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next_unchecked__h7492034f6287f1a2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $19 = 0, $30 = 0, $5$hi = 0, $6$hi = 0, $47 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  $3 = $2 + 8 | 0;
  $4 = $1 + 8 | 0;
  HEAP32[$3 >> 2] = HEAP32[$4 >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $19;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next__h54e79f130ecfd72c(i64toi32_i32$0 + 24 | 0 | 0, i64toi32_i32$0 | 0);
  label$1 : {
   if (HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] | 0) {
    break label$1
   }
   core__panicking__panic__h2fd385a887c8bf13(1048576 | 0, 43 | 0, 1049848 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 24 | 0) + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = ($2 + 24 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$1;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $5;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $6 = i64toi32_i32$1;
  $6$hi = i64toi32_i32$0;
  i64toi32_i32$1 = $2;
  HEAP32[i64toi32_i32$1 >> 2] = $6;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $5$hi;
  HEAP32[$4 >> 2] = $5;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$1 = $1;
  HEAP32[i64toi32_i32$1 >> 2] = $6;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  $47 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $47;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 20 | 0) >> 2] | 0;
  global$0 = $2 + 48 | 0;
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next_unchecked__h8cb7963d986f8ec1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $19 = 0, $30 = 0, $5$hi = 0, $6$hi = 0, $47 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  $3 = $2 + 8 | 0;
  $4 = $1 + 8 | 0;
  HEAP32[$3 >> 2] = HEAP32[$4 >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $19;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next__hcc42654374b44411(i64toi32_i32$0 + 24 | 0 | 0, i64toi32_i32$0 | 0);
  label$1 : {
   if (HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] | 0) {
    break label$1
   }
   core__panicking__panic__h2fd385a887c8bf13(1048576 | 0, 43 | 0, 1049848 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 24 | 0) + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = ($2 + 24 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$1;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $5;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $6 = i64toi32_i32$1;
  $6$hi = i64toi32_i32$0;
  i64toi32_i32$1 = $2;
  HEAP32[i64toi32_i32$1 >> 2] = $6;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $5$hi;
  HEAP32[$4 >> 2] = $5;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$1 = $1;
  HEAP32[i64toi32_i32$1 >> 2] = $6;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  $47 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $47;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 20 | 0) >> 2] | 0;
  global$0 = $2 + 48 | 0;
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next_unchecked__h92c0497bccfa2889($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $19 = 0, $30 = 0, $5$hi = 0, $6$hi = 0, $47 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  $3 = $2 + 8 | 0;
  $4 = $1 + 8 | 0;
  HEAP32[$3 >> 2] = HEAP32[$4 >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $19;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next__h645f0b6aed366fd0(i64toi32_i32$0 + 24 | 0 | 0, i64toi32_i32$0 | 0);
  label$1 : {
   if (HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] | 0) {
    break label$1
   }
   core__panicking__panic__h2fd385a887c8bf13(1048576 | 0, 43 | 0, 1049848 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 24 | 0) + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = ($2 + 24 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$1;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $5;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $6 = i64toi32_i32$1;
  $6$hi = i64toi32_i32$0;
  i64toi32_i32$1 = $2;
  HEAP32[i64toi32_i32$1 >> 2] = $6;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $5$hi;
  HEAP32[$4 >> 2] = $5;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$1 = $1;
  HEAP32[i64toi32_i32$1 >> 2] = $6;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  $47 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $47;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 20 | 0) >> 2] | 0;
  global$0 = $2 + 48 | 0;
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next_unchecked__ha23488fe1f8687d2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $19 = 0, $30 = 0, $5$hi = 0, $6$hi = 0, $47 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  $3 = $2 + 8 | 0;
  $4 = $1 + 8 | 0;
  HEAP32[$3 >> 2] = HEAP32[$4 >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $19;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next__hb30c6deedb4dc2b6(i64toi32_i32$0 + 24 | 0 | 0, i64toi32_i32$0 | 0);
  label$1 : {
   if (HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] | 0) {
    break label$1
   }
   core__panicking__panic__h2fd385a887c8bf13(1048576 | 0, 43 | 0, 1049848 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 24 | 0) + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = ($2 + 24 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$1;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $5;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $6 = i64toi32_i32$1;
  $6$hi = i64toi32_i32$0;
  i64toi32_i32$1 = $2;
  HEAP32[i64toi32_i32$1 >> 2] = $6;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $5$hi;
  HEAP32[$4 >> 2] = $5;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$1 = $1;
  HEAP32[i64toi32_i32$1 >> 2] = $6;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  $47 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $47;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 20 | 0) >> 2] | 0;
  global$0 = $2 + 48 | 0;
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next_unchecked__ha621262545c111a1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $19 = 0, $30 = 0, $5$hi = 0, $6$hi = 0, $47 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  $3 = $2 + 8 | 0;
  $4 = $1 + 8 | 0;
  HEAP32[$3 >> 2] = HEAP32[$4 >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $19;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next__h7144bb1c780c1097(i64toi32_i32$0 + 24 | 0 | 0, i64toi32_i32$0 | 0);
  label$1 : {
   if (HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] | 0) {
    break label$1
   }
   core__panicking__panic__h2fd385a887c8bf13(1048576 | 0, 43 | 0, 1049848 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 24 | 0) + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = ($2 + 24 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$1;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $5;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $6 = i64toi32_i32$1;
  $6$hi = i64toi32_i32$0;
  i64toi32_i32$1 = $2;
  HEAP32[i64toi32_i32$1 >> 2] = $6;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $5$hi;
  HEAP32[$4 >> 2] = $5;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$1 = $1;
  HEAP32[i64toi32_i32$1 >> 2] = $6;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  $47 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $47;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 20 | 0) >> 2] | 0;
  global$0 = $2 + 48 | 0;
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next_unchecked__he1ff1347c7a67a8c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $19 = 0, $30 = 0, $5$hi = 0, $6$hi = 0, $47 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  $3 = $2 + 8 | 0;
  $4 = $1 + 8 | 0;
  HEAP32[$3 >> 2] = HEAP32[$4 >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $19;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next__h6b4a564027800c71(i64toi32_i32$0 + 24 | 0 | 0, i64toi32_i32$0 | 0);
  label$1 : {
   if (HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] | 0) {
    break label$1
   }
   core__panicking__panic__h2fd385a887c8bf13(1048576 | 0, 43 | 0, 1049848 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 24 | 0) + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = ($2 + 24 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$1;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $5;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $6 = i64toi32_i32$1;
  $6$hi = i64toi32_i32$0;
  i64toi32_i32$1 = $2;
  HEAP32[i64toi32_i32$1 >> 2] = $6;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $5$hi;
  HEAP32[$4 >> 2] = $5;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$1 = $1;
  HEAP32[i64toi32_i32$1 >> 2] = $6;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  $47 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $47;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 20 | 0) >> 2] | 0;
  global$0 = $2 + 48 | 0;
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next_unchecked__hf1f377269bbabf11($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $19 = 0, $30 = 0, $5$hi = 0, $6$hi = 0, $47 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  $3 = $2 + 8 | 0;
  $4 = $1 + 8 | 0;
  HEAP32[$3 >> 2] = HEAP32[$4 >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $19;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next__h237ab4e524b6f8a6(i64toi32_i32$0 + 24 | 0 | 0, i64toi32_i32$0 | 0);
  label$1 : {
   if (HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] | 0) {
    break label$1
   }
   core__panicking__panic__h2fd385a887c8bf13(1048576 | 0, 43 | 0, 1049848 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 24 | 0) + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = ($2 + 24 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$1;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $5;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $6 = i64toi32_i32$1;
  $6$hi = i64toi32_i32$0;
  i64toi32_i32$1 = $2;
  HEAP32[i64toi32_i32$1 >> 2] = $6;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $5$hi;
  HEAP32[$4 >> 2] = $5;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$1 = $1;
  HEAP32[i64toi32_i32$1 >> 2] = $6;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  $47 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $47;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 20 | 0) >> 2] | 0;
  global$0 = $2 + 48 | 0;
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next_unchecked__hf23e11a68049cb85($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $19 = 0, $30 = 0, $5$hi = 0, $6$hi = 0, $47 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  $3 = $2 + 8 | 0;
  $4 = $1 + 8 | 0;
  HEAP32[$3 >> 2] = HEAP32[$4 >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $19;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next__h4b13a720f1e4c62d(i64toi32_i32$0 + 24 | 0 | 0, i64toi32_i32$0 | 0);
  label$1 : {
   if (HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] | 0) {
    break label$1
   }
   core__panicking__panic__h2fd385a887c8bf13(1048576 | 0, 43 | 0, 1049848 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 24 | 0) + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = ($2 + 24 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$1;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $5;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $6 = i64toi32_i32$1;
  $6$hi = i64toi32_i32$0;
  i64toi32_i32$1 = $2;
  HEAP32[i64toi32_i32$1 >> 2] = $6;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $5$hi;
  HEAP32[$4 >> 2] = $5;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$1 = $1;
  HEAP32[i64toi32_i32$1 >> 2] = $6;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  $47 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $47;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 20 | 0) >> 2] | 0;
  global$0 = $2 + 48 | 0;
 }
 
 function transactionbody_set_update($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h238818d95bb6c551($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h20ee1b39869b5e8f($2 | 0, $1 | 0);
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $1 = HEAP32[$2 >> 2] | 0;
   $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h847b9d84e24adaa5($2 + 64 | 0 | 0, $1 | 0);
   HEAP32[($2 + 104 | 0) >> 2] = HEAP32[($1 + 40 | 0) >> 2] | 0;
   memcpy($2 + 16 | 0 | 0, $2 + 64 | 0 | 0, 48 | 0) | 0;
   $1 = $4 + 64 | 0;
   core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__Update____hc1ce6150a8713009($1 | 0);
   memcpy($1 | 0, $2 + 16 | 0 | 0, 48 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 112 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function mirtostakecredentials_get($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $4$hi = 0, $5$hi = 0, $4 = 0, $5 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h74054450d591b36f($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h7d8a0640f2deb41e($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   label$2 : {
    label$3 : {
     $0 = linked_hash_map__LinkedHashMap_K_2cV_2cS___get__hd01b4479ef58cf3f($0 | 0, HEAP32[$2 >> 2] | 0 | 0) | 0;
     if ($0) {
      break label$3
     }
     break label$2;
    }
    i64toi32_i32$2 = $0 + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $4 = i64toi32_i32$0;
    $4$hi = i64toi32_i32$1;
    i64toi32_i32$2 = $0;
    i64toi32_i32$1 = HEAP32[$0 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    $5 = i64toi32_i32$1;
    $5$hi = i64toi32_i32$0;
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
   label$4 : {
    label$5 : {
     if ($0) {
      break label$5
     }
     $0 = 0;
     break label$4;
    }
    i64toi32_i32$0 = $5$hi;
    i64toi32_i32$0 = $4$hi;
    i64toi32_i32$0 = $5$hi;
    i64toi32_i32$1 = $4$hi;
    $0 = $cardano_serialization_lib__utils__Int_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hac86427717971799($5 | 0, i64toi32_i32$0 | 0, $4 | 0, i64toi32_i32$1 | 0) | 0;
   }
   global$0 = $2 + 16 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function ipv4_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $3 = 0, $3$hi = 0, $13 = 0, $4 = 0, $4$hi = 0, $33 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  HEAP32[($2 + 40 | 0) >> 2] = $1;
  HEAP32[($2 + 36 | 0) >> 2] = $1;
  HEAP32[($2 + 32 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 32 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $33 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $33;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = cardano_serialization_lib__Ipv4__from_bytes__h105107d460ccfdd6($2 + 32 | 0 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $3 = i64toi32_i32$1;
  $3$hi = i64toi32_i32$0;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $13 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $13 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  $4 = $13;
  $4$hi = i64toi32_i32$1;
  label$1 : {
   i64toi32_i32$1 = $3$hi;
   i64toi32_i32$0 = $3;
   i64toi32_i32$2 = 0;
   i64toi32_i32$3 = 1;
   i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
   if (!(i64toi32_i32$0 & i64toi32_i32$3 | 0 | i64toi32_i32$2 | 0)) {
    break label$1
   }
   i64toi32_i32$2 = $4$hi;
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($4 | 0);
   abort();
  }
  i64toi32_i32$2 = $3$hi;
  i64toi32_i32$2 = $4$hi;
  $1 = $cardano_serialization_lib__Ipv4_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h260bfd99906fbe36($3 >>> 8 | 0 | ($4 << 24 | 0) | 0 | 0) | 0;
  global$0 = $2 + 48 | 0;
  return $1 | 0;
 }
 
 function ipv4_new($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $3 = 0, $3$hi = 0, $13 = 0, $4 = 0, $4$hi = 0, $33 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  HEAP32[($2 + 40 | 0) >> 2] = $1;
  HEAP32[($2 + 36 | 0) >> 2] = $1;
  HEAP32[($2 + 32 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 32 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $33 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $33;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = cardano_serialization_lib__Ipv4__new__h9376141a46d945db($2 + 32 | 0 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $3 = i64toi32_i32$1;
  $3$hi = i64toi32_i32$0;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $13 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $13 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  $4 = $13;
  $4$hi = i64toi32_i32$1;
  label$1 : {
   i64toi32_i32$1 = $3$hi;
   i64toi32_i32$0 = $3;
   i64toi32_i32$2 = 0;
   i64toi32_i32$3 = 1;
   i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
   if (!(i64toi32_i32$0 & i64toi32_i32$3 | 0 | i64toi32_i32$2 | 0)) {
    break label$1
   }
   i64toi32_i32$2 = $4$hi;
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($4 | 0);
   abort();
  }
  i64toi32_i32$2 = $3$hi;
  i64toi32_i32$2 = $4$hi;
  $1 = $cardano_serialization_lib__Ipv4_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h260bfd99906fbe36($3 >>> 8 | 0 | ($4 << 24 | 0) | 0 | 0) | 0;
  global$0 = $2 + 48 | 0;
  return $1 | 0;
 }
 
 function headerbody_leader_vrf($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $33 = 0, $40 = 0, $43 = 0;
  $1 = global$0 - 64 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h2ac16fcb64db16b5($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($1 + 16 | 0 | 0, $2 + 36 | 0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($1 + 28 | 0 | 0, $2 + 48 | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = ($1 + 16 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $33 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 40 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $33;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = ($1 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $40 = i64toi32_i32$1;
  i64toi32_i32$1 = ($1 + 40 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $40;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[($1 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  $43 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 40 | 0) >> 2] = $43;
  HEAP32[($1 + 44 | 0) >> 2] = i64toi32_i32$1;
  $0 = $cardano_serialization_lib__crypto__VRFCert_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hc597ed79f1e184d4($1 + 40 | 0 | 0) | 0;
  global$0 = $1 + 64 | 0;
  return $0 | 0;
 }
 
 function multiasset_sub($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h9968e42c55861cec($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h9968e42c55861cec($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__MultiAsset__sub__h87ca73850e5358bf($2 + 16 | 0 | 0, $3 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   HEAP32[($2 + 32 | 0) >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
   HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
   $0 = $cardano_serialization_lib__MultiAsset_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he6031c139f7594ac($2 + 32 | 0 | 0) | 0;
   global$0 = $2 + 48 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function mintassets_get($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $4$hi = 0, $5$hi = 0, $4 = 0, $5 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h59b9713b6e595a95($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h9c68abd5a6a78973($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   label$2 : {
    label$3 : {
     $0 = alloc__collections__btree__map__BTreeMap_K_2cV___get__h9e6a7b6dbfee6453($0 | 0, HEAP32[$2 >> 2] | 0 | 0) | 0;
     if ($0) {
      break label$3
     }
     break label$2;
    }
    i64toi32_i32$2 = $0 + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $4 = i64toi32_i32$0;
    $4$hi = i64toi32_i32$1;
    i64toi32_i32$2 = $0;
    i64toi32_i32$1 = HEAP32[$0 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    $5 = i64toi32_i32$1;
    $5$hi = i64toi32_i32$0;
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
   label$4 : {
    label$5 : {
     if ($0) {
      break label$5
     }
     $0 = 0;
     break label$4;
    }
    i64toi32_i32$0 = $5$hi;
    i64toi32_i32$0 = $4$hi;
    i64toi32_i32$0 = $5$hi;
    i64toi32_i32$1 = $4$hi;
    $0 = $cardano_serialization_lib__utils__Int_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hac86427717971799($5 | 0, i64toi32_i32$0 | 0, $4 | 0, i64toi32_i32$1 | 0) | 0;
   }
   global$0 = $2 + 16 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function mint_new_from_entry($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h27da893e95dd15cf($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h59b9713b6e595a95($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__Mint__new_from_entry__hae31aeb23b43a89f($2 + 16 | 0 | 0, $3 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   HEAP32[($2 + 32 | 0) >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
   HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
   $0 = $cardano_serialization_lib__Mint_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8fa2adeb6e27a027($2 + 32 | 0 | 0) | 0;
   global$0 = $2 + 48 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function value_multiasset($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h5db5149478ec5345($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   label$2 : {
    label$3 : {
     $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
      break label$3
     }
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($1 + 16 | 0 | 4 | 0 | 0, $2 + 12 | 0 | 0);
     core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
     HEAP32[($1 + 40 | 0) >> 2] = HEAP32[(($1 + 16 | 0) + 12 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($1 + 24 | 0) >> 2] | 0;
     HEAP32[($1 + 32 | 0) >> 2] = HEAP32[($1 + 20 | 0) >> 2] | 0;
     HEAP32[($1 + 36 | 0) >> 2] = i64toi32_i32$1;
     $0 = $cardano_serialization_lib__MultiAsset_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he6031c139f7594ac($1 + 32 | 0 | 0) | 0;
     break label$2;
    }
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    $0 = 0;
   }
   global$0 = $1 + 48 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function bigint_add($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $43 = 0, $46 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb4a7701b5bc2a87c($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb4a7701b5bc2a87c($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   num_bigint__bigint__addition___impl_20core__ops__arith__Add__num_bigint__bigint__BigInt__20for_20_num_bigint__bigint__BigInt___add__h354544d3f4ae9625_1($2 + 16 | 0 | 0, $3 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $43 = i64toi32_i32$0;
   i64toi32_i32$0 = ($2 + 32 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $43;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   $46 = i64toi32_i32$1;
   i64toi32_i32$1 = $2;
   HEAP32[($2 + 32 | 0) >> 2] = $46;
   HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$0;
   $0 = $cardano_serialization_lib__utils__BigInt_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8699e08c5b3b0a6a($2 + 32 | 0 | 0) | 0;
   global$0 = $2 + 48 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function bigint_mul($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $43 = 0, $46 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb4a7701b5bc2a87c($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb4a7701b5bc2a87c($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__utils__BigInt__mul__h31545dc99f4f564b($2 + 16 | 0 | 0, $3 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $43 = i64toi32_i32$0;
   i64toi32_i32$0 = ($2 + 32 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $43;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   $46 = i64toi32_i32$1;
   i64toi32_i32$1 = $2;
   HEAP32[($2 + 32 | 0) >> 2] = $46;
   HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$0;
   $0 = $cardano_serialization_lib__utils__BigInt_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8699e08c5b3b0a6a($2 + 32 | 0 | 0) | 0;
   global$0 = $2 + 48 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function bigint_div_ceil($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $43 = 0, $46 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb4a7701b5bc2a87c($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb4a7701b5bc2a87c($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__utils__BigInt__div_ceil__h1921bbe0a71d04cb($2 + 16 | 0 | 0, $3 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $43 = i64toi32_i32$0;
   i64toi32_i32$0 = ($2 + 32 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $43;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   $46 = i64toi32_i32$1;
   i64toi32_i32$1 = $2;
   HEAP32[($2 + 32 | 0) >> 2] = $46;
   HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$0;
   $0 = $cardano_serialization_lib__utils__BigInt_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8699e08c5b3b0a6a($2 + 32 | 0 | 0) | 0;
   global$0 = $2 + 48 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function cardano_serialization_lib__tx_builder__tx_inputs_builder__PlutusWitnesses__get__hc445cb787af5ae82($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $4 = 0, $5 = 0, $5$hi = 0, $40 = 0, $48 = 0;
  $3 = global$0 - 80 | 0;
  global$0 = $3;
  label$1 : {
   $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   if ($4 >>> 0 > $2 >>> 0) {
    break label$1
   }
   core__panicking__panic_bounds_check__h808b524af17640b1($2 | 0, $4 | 0, 1069424 | 0);
   abort();
  }
  $2 = (HEAP32[$1 >> 2] | 0) + Math_imul($2, 144) | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($0 + 128 | 0 | 0, $2 + 128 | 0 | 0);
  $cardano_serialization_lib__plutus__PlutusData_20as_20core__clone__Clone___clone__h63d1a98cc18f4609_1($0 | 0, $2 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$1;
  $1 = HEAPU8[($2 + 120 | 0) >> 0] | 0;
  $cardano_serialization_lib__plutus__PlutusData_20as_20core__clone__Clone___clone__h63d1a98cc18f4609_1($3 + 8 | 0 | 0, $2 + 56 | 0 | 0);
  i64toi32_i32$2 = $2 + 112 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $40 = i64toi32_i32$1;
  i64toi32_i32$1 = $3 + 64 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $40;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP8[($3 + 72 | 0) >> 0] = $1;
  i64toi32_i32$0 = $5$hi;
  i64toi32_i32$1 = $3;
  HEAP32[i64toi32_i32$1 >> 2] = $5;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2 + 104 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $48 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[($3 + 56 | 0) >> 2] = $48;
  HEAP32[($3 + 60 | 0) >> 2] = i64toi32_i32$1;
  memcpy($0 + 48 | 0 | 0, $3 | 0, 80 | 0) | 0;
  global$0 = $3 + 80 | 0;
 }
 
 function costmdls_get($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h0e53d0166415c79c($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hfa98d20552a22c6d($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__plutus__Costmdls__get__hfda0a473e7b5be66($2 + 16 | 0 | 0, $3 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   label$2 : {
    label$3 : {
     $0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
     if ($0) {
      break label$3
     }
     $0 = 0;
     break label$2;
    }
    i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
    HEAP32[($2 + 36 | 0) >> 2] = HEAP32[($2 + 20 | 0) >> 2] | 0;
    HEAP32[($2 + 40 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($2 + 32 | 0) >> 2] = $0;
    $0 = $cardano_serialization_lib__plutus__CostModel_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h131279c16539114c($2 + 32 | 0 | 0) | 0;
   }
   global$0 = $2 + 48 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next_unchecked__h1b1b91bd6bd0f0ea($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $5 = 0, $6 = 0, $19 = 0, $30 = 0, $5$hi = 0, $6$hi = 0, $47 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  $3 = $2 + 8 | 0;
  $4 = $1 + 8 | 0;
  HEAP32[$3 >> 2] = HEAP32[$4 >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[i64toi32_i32$0 >> 2] = $19;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next__h745dbebc378644f8(i64toi32_i32$0 + 24 | 0 | 0, i64toi32_i32$0 | 0);
  label$1 : {
   if (HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] | 0) {
    break label$1
   }
   core__panicking__panic__h2fd385a887c8bf13(1084228 | 0, 43 | 0, 1084732 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 24 | 0) + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = ($2 + 24 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$1;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $5;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $6 = i64toi32_i32$1;
  $6$hi = i64toi32_i32$0;
  i64toi32_i32$1 = $2;
  HEAP32[i64toi32_i32$1 >> 2] = $6;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $5$hi;
  HEAP32[$4 >> 2] = $5;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$1 = $1;
  HEAP32[i64toi32_i32$1 >> 2] = $6;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  $47 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $47;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 20 | 0) >> 2] | 0;
  global$0 = $2 + 48 | 0;
 }
 
 function alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal___push__h5a800884cf869f03($0, $1, $2, $2$hi, $3, $3$hi, $4, $5) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  $4 = $4 | 0;
  $5 = $5 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $6 = 0, $7 = 0, $35 = 0;
  label$1 : {
   label$2 : {
    if (((HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) != ($4 | 0)) {
     break label$2
    }
    $0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    $4 = HEAPU16[($0 + 314 | 0) >> 1] | 0;
    if ($4 >>> 0 <= 10 >>> 0) {
     break label$1
    }
    core__panicking__panic__h2fd385a887c8bf13(1048619 | 0, 32 | 0, 1048824 | 0);
    abort();
   }
   core__panicking__panic__h2fd385a887c8bf13(1048760 | 0, 48 | 0, 1048808 | 0);
   abort();
  }
  $6 = $4 + 1 | 0;
  HEAP16[($0 + 314 | 0) >> 1] = $6;
  $7 = $0 + Math_imul($4, 12) | 0;
  HEAP32[($7 + 188 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $35 = i64toi32_i32$0;
  i64toi32_i32$0 = $7 + 180 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $35;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $4 = $0 + ($4 << 4 | 0) | 0;
  i64toi32_i32$1 = $3$hi;
  i64toi32_i32$0 = $4;
  HEAP32[($4 + 8 | 0) >> 2] = $3;
  HEAP32[($4 + 12 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $2$hi;
  i64toi32_i32$0 = $4;
  HEAP32[$4 >> 2] = $2;
  HEAP32[($4 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(($0 + ($6 << 2 | 0) | 0) + 320 | 0) >> 2] = $5;
  HEAP16[($5 + 312 | 0) >> 1] = $6;
  HEAP32[($5 + 176 | 0) >> 2] = $0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__MoveInstantaneousReward___serialize__hc9e545ed3c236536($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  i64toi32_i32$0 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, 2 | 0, i64toi32_i32$0 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
       break label$4
      }
      i64toi32_i32$2 = $1;
      i64toi32_i32$0 = HEAPU8[($1 + 48 | 0) >> 0] | 0;
      i64toi32_i32$1 = 0;
      cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, i64toi32_i32$0 | 0, i64toi32_i32$1 | 0);
      if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
       break label$3
      }
      i64toi32_i32$2 = $1;
      i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
      i64toi32_i32$2 = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      if ((i64toi32_i32$2 | 0) == (1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
       break label$2
      }
      i64toi32_i32$2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
      i64toi32_i32$0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
      cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($0 | 0, $2 | 0, 0 | 0, i64toi32_i32$2 | 0, i64toi32_i32$0 | 0);
      break label$1;
     }
     memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
     HEAP32[$0 >> 2] = 1;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    break label$1;
   }
   cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__MIRToStakeCredentials___serialize__h6a8886ca50fc22cf($0 | 0, $1 + 8 | 0 | 0, $2 | 0);
  }
  global$0 = $3 + 48 | 0;
 }
 
 function transactionbody_set_collateral($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $4 = 0, $3 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h238818d95bb6c551($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hf2abefb15e68f011($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hfe677107e1954f8f($2 + 16 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0);
   $0 = $4 + 180 | 0;
   label$2 : {
    if (!(HEAP32[($4 + 180 | 0) >> 2] | 0)) {
     break label$2
    }
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h98bad0b07702c13e($0 | 0);
   }
   i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   HEAP32[$0 >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
   HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($0 + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 32 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionbody_set_required_signers($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $4 = 0, $3 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h238818d95bb6c551($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h38787c785ea84973($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h25db889dc58a550d($2 + 16 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0);
   $0 = $4 + 192 | 0;
   label$2 : {
    if (!(HEAP32[($4 + 192 | 0) >> 2] | 0)) {
     break label$2
    }
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h72de9eab2f0e4669($0 | 0);
   }
   i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   HEAP32[$0 >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
   HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($0 + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 32 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function protocolversion_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 56 | 0) >> 2] = $1;
  HEAP32[($2 + 52 | 0) >> 2] = $1;
  HEAP32[($2 + 48 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 48 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  HEAP32[($2 + 48 | 0) >> 2] = HEAP32[($2 + 32 | 0) >> 2] | 0;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__ProtocolVersion__from_bytes__h9b8b4b32222d300b($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  $1 = $cardano_serialization_lib__ProtocolVersion_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h721fdbbf560ad7f4($1 | 0, HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function protocolparamupdate_set_protocol_version($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $4 = 0, $3 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h0a71cd742026514d($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__ha45853a045a59ee7($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h36101af4d9989b58($2 + 16 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0);
   $0 = $4 + 320 | 0;
   label$2 : {
    if (!(HEAP32[($4 + 320 | 0) >> 2] | 0)) {
     break label$2
    }
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h1737752c75bae0f3($0 | 0);
   }
   i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   HEAP32[$0 >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
   HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($0 + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 32 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function cryptoxide__chacha20poly1305__finalize_raw__ha8a88c220a2fbc52($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $2 = 0, $10 = 0, $11 = 0, $12 = 0, $13 = 0, $4 = 0, $6 = 0, $6$hi = 0, $3 = 0, $5 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  i64toi32_i32$1 = $0;
  i64toi32_i32$0 = 0;
  $10 = 0;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $3 = i64toi32_i32$1 + 8 | 0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  $11 = 0;
  HEAP8[i64toi32_i32$1 >> 0] = $11;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $4 = $1 + 148 | 0;
  i64toi32_i32$0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  cryptoxide__chacha20poly1305__pad16__hc43355684cd75a45($4 | 0, i64toi32_i32$0 | 0, i64toi32_i32$1 | 0);
  i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $6 = i64toi32_i32$1;
  $6$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    $5 = core__array___impl_20core__convert__TryFrom__mut_20_5bT_5d__20for_20_mut_20_5bT_3b_20N_5d___try_from__hec62152834a951b6($0 | 0, 8 | 0) | 0;
    if (!$5) {
     break label$2
    }
    i64toi32_i32$0 = $6$hi;
    i64toi32_i32$1 = $5;
    $12 = $6;
    HEAP8[i64toi32_i32$1 >> 0] = $12;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $12 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $12 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $12 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    $6 = i64toi32_i32$0;
    $6$hi = i64toi32_i32$1;
    $1 = core__array___impl_20core__convert__TryFrom__mut_20_5bT_5d__20for_20_mut_20_5bT_3b_20N_5d___try_from__hec62152834a951b6($3 | 0, 8 | 0) | 0;
    if (!$1) {
     break label$1
    }
    i64toi32_i32$1 = $6$hi;
    i64toi32_i32$0 = $1;
    $13 = $6;
    HEAP8[i64toi32_i32$0 >> 0] = $13;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $13 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $13 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $13 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    $cryptoxide__poly1305__Poly1305_20as_20cryptoxide__mac__Mac___input__h2055bc09e473001f($4 | 0, $0 | 0, 16 | 0);
    $cryptoxide__poly1305__Poly1305_20as_20cryptoxide__mac__Mac___raw_result__hdd61081e0bdedce3($4 | 0, $0 | 0, 16 | 0);
    global$0 = $2 + 16 | 0;
    return;
   }
   core__result__unwrap_failed__h27f43d993c3864a1(1055796 | 0, 43 | 0, $2 + 8 | 0 | 0, 1055840 | 0, 1054856 | 0);
   abort();
  }
  core__result__unwrap_failed__h27f43d993c3864a1(1055796 | 0, 43 | 0, $2 + 8 | 0 | 0, 1055840 | 0, 1054856 | 0);
  abort();
 }
 
 function $cardano_serialization_lib__utils__Value_20as_20cbor_event__se__Serialize___serialize__hc37da84fe085e7b6($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    if ((HEAP32[($1 + 8 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($0 | 0, $2 | 0, 0 | 0, i64toi32_i32$0 | 0, i64toi32_i32$1 | 0);
    break label$1;
   }
   i64toi32_i32$1 = 0;
   cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, 2 | 0, i64toi32_i32$1 | 0);
   label$3 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
     break label$3
    }
    i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, i64toi32_i32$1 | 0, i64toi32_i32$0 | 0);
    label$4 : {
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$4
     }
     cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__MultiAsset___serialize__h8befd5a1b9cac25b($0 | 0, $1 + 12 | 0 | 0, $2 | 0);
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $3 + 48 | 0;
 }
 
 function bigint_from_str($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  HEAP32[($2 + 36 | 0) >> 2] = $1;
  $0 = HEAP32[$2 >> 2] | 0;
  HEAP32[($2 + 32 | 0) >> 2] = $0;
  cardano_serialization_lib__utils__BigInt__from_str__h6032a095d77ac3d9($2 + 8 | 0 | 0, $0 | 0, $1 | 0);
  core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0($2 + 32 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  HEAP32[($2 + 44 | 0) >> 2] = HEAP32[($2 + 24 | 0) >> 2] | 0;
  HEAP32[($2 + 32 | 0) >> 2] = $1;
  i64toi32_i32$2 = $2 + 16 | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  HEAP32[($2 + 36 | 0) >> 2] = HEAP32[i64toi32_i32$2 >> 2] | 0;
  HEAP32[($2 + 40 | 0) >> 2] = i64toi32_i32$1;
  $1 = $cardano_serialization_lib__utils__BigInt_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8699e08c5b3b0a6a($2 + 32 | 0 | 0) | 0;
  global$0 = $2 + 48 | 0;
  return $1 | 0;
 }
 
 function $std__io__Take_T__20as_20std__io__Read___read__h7d727131765c43bf($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$4 = 0, i64toi32_i32$5 = 0, $4 = 0, i64toi32_i32$3 = 0, $6$hi = 0, $6 = 0, $19$hi = 0, $5 = 0, $43$hi = 0, $47 = 0;
  $4 = global$0 - 16 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    label$3 : {
     i64toi32_i32$2 = $1;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $6 = i64toi32_i32$0;
     $6$hi = i64toi32_i32$1;
     i64toi32_i32$2 = i64toi32_i32$0;
     i64toi32_i32$0 = 0;
     i64toi32_i32$3 = 0;
     if ((i64toi32_i32$2 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$0 | 0) | 0) {
      break label$3
     }
     $3 = 0;
     HEAP32[($0 + 4 | 0) >> 2] = 0;
     break label$2;
    }
    i64toi32_i32$2 = $6$hi;
    i64toi32_i32$2 = 0;
    $19$hi = i64toi32_i32$2;
    i64toi32_i32$2 = $6$hi;
    i64toi32_i32$2 = $19$hi;
    i64toi32_i32$2 = $6$hi;
    i64toi32_i32$3 = $6;
    i64toi32_i32$1 = $19$hi;
    i64toi32_i32$0 = $3;
    i64toi32_i32$4 = i64toi32_i32$2 >>> 0 < i64toi32_i32$1 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$3 >>> 0 < i64toi32_i32$0 >>> 0 | 0) | 0;
    i64toi32_i32$3 = i64toi32_i32$2;
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$1 = i64toi32_i32$4 ? $6 : i64toi32_i32$0;
    i64toi32_i32$0 = i64toi32_i32$4 ? i64toi32_i32$3 : i64toi32_i32$2;
    $5 = i64toi32_i32$1;
    if (i64toi32_i32$1 >>> 0 > $3 >>> 0) {
     break label$1
    }
    $std__io__cursor__Cursor_T__20as_20std__io__Read___read__h40f2bf5423b60e92($4 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0, $2 | 0, $5 | 0);
    $3 = 1;
    label$4 : {
     if ((HEAP32[$4 >> 2] | 0 | 0) == (1 | 0)) {
      break label$4
     }
     $3 = HEAP32[($4 + 4 | 0) >> 2] | 0;
     HEAP32[($0 + 4 | 0) >> 2] = $3;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$0 = 0;
     $43$hi = i64toi32_i32$0;
     i64toi32_i32$0 = $6$hi;
     i64toi32_i32$4 = $6;
     i64toi32_i32$1 = $43$hi;
     i64toi32_i32$3 = $3;
     i64toi32_i32$2 = i64toi32_i32$4 - $3 | 0;
     i64toi32_i32$5 = (i64toi32_i32$4 >>> 0 < $3 >>> 0) + i64toi32_i32$1 | 0;
     i64toi32_i32$5 = i64toi32_i32$0 - i64toi32_i32$5 | 0;
     i64toi32_i32$4 = $1;
     HEAP32[i64toi32_i32$4 >> 2] = i64toi32_i32$2;
     HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
     $3 = 0;
     break label$2;
    }
    i64toi32_i32$0 = $4;
    i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
    i64toi32_i32$4 = HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] | 0;
    $47 = i64toi32_i32$5;
    i64toi32_i32$5 = $0;
    HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = $47;
    HEAP32[(i64toi32_i32$5 + 8 | 0) >> 2] = i64toi32_i32$4;
   }
   HEAP32[$0 >> 2] = $3;
   global$0 = $4 + 16 | 0;
   return;
  }
  core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($5 | 0, $3 | 0, 1061200 | 0);
  abort();
 }
 
 function transactionbuilder_add_inputs_from($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, $5 = 0;
  $3 = global$0 - 32 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     if (!$0) {
      break label$3
     }
     wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h5566e1c7d4aafe35($3 + 24 | 0 | 0, $0 | 0);
     if (!$1) {
      break label$3
     }
     $4 = HEAP32[($3 + 28 | 0) >> 2] | 0;
     $5 = HEAP32[($3 + 24 | 0) >> 2] | 0;
     wasm_bindgen____rt__WasmRefCell_T___borrow__h2b38e1d613820f8e($3 + 16 | 0 | 0, $1 | 0);
     if ($2 >>> 0 >= 4 >>> 0) {
      break label$2
     }
     $0 = HEAP32[($3 + 20 | 0) >> 2] | 0;
     cardano_serialization_lib__tx_builder__TransactionBuilder__add_inputs_from__hcbc35da9d29fe71b($3 + 8 | 0 | 0, $5 | 0, HEAP32[($3 + 16 | 0) >> 2] | 0 | 0, $2 | 0);
     $2 = HEAP32[($3 + 12 | 0) >> 2] | 0;
     $1 = HEAP32[($3 + 8 | 0) >> 2] | 0;
     core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
     core__cell__Cell_T___replace__h74ad9f426af36be8($4 | 0, 0 | 0) | 0;
     if ($1) {
      break label$1
     }
     global$0 = $3 + 32 | 0;
     return;
    }
    wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
    abort();
   }
   wasm_bindgen__throw_str__h40ff0247f6a635d7(1064279 | 0, 25 | 0);
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472($2 | 0);
  abort();
 }
 
 function $alloc__collections__btree__map__IntoIter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h8343c8d1ae260056($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $10 = 0, $11 = 0, $12 = 0, $13 = 0, $14 = 0, $15 = 0, $3 = 0, $29 = 0, $34 = 0, $39 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     $3 = HEAP32[($1 + 24 | 0) >> 2] | 0;
     if ($3) {
      break label$3
     }
     HEAP8[$0 >> 0] = 0;
     break label$2;
    }
    HEAP32[($1 + 24 | 0) >> 2] = $3 + -1 | 0;
    if (!(HEAP32[($1 + 4 | 0) >> 2] | 0)) {
     break label$1
    }
    alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next_unchecked__he1ff1347c7a67a8c($2 | 0, $1 | 0);
    HEAP8[$0 >> 0] = 1;
    $1 = (HEAP32[($2 + 4 | 0) >> 2] | 0) + Math_imul(HEAP32[($2 + 8 | 0) >> 2] | 0, 28) | 0;
    i64toi32_i32$2 = $1 + 8 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $29 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    $10 = $29;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $10;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $10 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $10 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = $10 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 8 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    i64toi32_i32$2 = $1 + 16 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $34 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 9 | 0;
    $11 = $34;
    HEAP8[i64toi32_i32$1 >> 0] = $11;
    HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $11 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $11 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $11 >>> 24 | 0;
    HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
    HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
    HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
    HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
    i64toi32_i32$2 = $1 + 24 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $39 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 17 | 0;
    $12 = $39;
    HEAP8[i64toi32_i32$0 >> 0] = $12;
    HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $12 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $12 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $12 >>> 24 | 0;
    HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    $13 = $1 + 32 | 0;
    $14 = $0 + 25 | 0;
    $15 = HEAPU8[$13 >> 0] | 0 | ((HEAPU8[($13 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($13 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($13 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    HEAP8[$14 >> 0] = $15;
    HEAP8[($14 + 1 | 0) >> 0] = $15 >>> 8 | 0;
    HEAP8[($14 + 2 | 0) >> 0] = $15 >>> 16 | 0;
    HEAP8[($14 + 3 | 0) >> 0] = $15 >>> 24 | 0;
   }
   global$0 = $2 + 16 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1067386 | 0, 43 | 0, 1067584 | 0);
  abort();
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___insert__hb205f765e31092f7($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0;
  $4 = global$0 - 208 | 0;
  global$0 = $4;
  memcpy($4 + 112 | 0 | 0, $2 | 0, 36 | 0) | 0;
  alloc__collections__btree__map__BTreeMap_K_2cV___entry__hb3ca8cc1c7c6c8c7($4 | 0, $1 | 0, $4 + 112 | 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$4 >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    memcpy($4 + 56 | 0 | 0, $4 | 4 | 0 | 0, 52 | 0) | 0;
    memcpy($4 + 112 | 0 | 0, $3 | 0, 96 | 0) | 0;
    alloc__collections__btree__map__entry__VacantEntry_K_2cV___insert__h01793c8bfa88cb39($4 + 56 | 0 | 0, $4 + 112 | 0 | 0) | 0;
    HEAP32[($0 + 8 | 0) >> 2] = 2;
    break label$1;
   }
   $1 = (HEAP32[($4 + 8 | 0) >> 2] | 0) + Math_imul(HEAP32[($4 + 12 | 0) >> 2] | 0, 96) | 0;
   memcpy($0 | 0, $1 | 0, 96 | 0) | 0;
   memcpy($1 | 0, $3 | 0, 96 | 0) | 0;
  }
  global$0 = $4 + 208 | 0;
 }
 
 function cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__push_input__h5d706b01e1a860c0($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $11 = 0, $16 = 0, $22 = 0, $26 = 0;
  $2 = global$0 - 240 | 0;
  global$0 = $2;
  i64toi32_i32$2 = $1 + 52 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $11 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 104 | 0) + 28 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $11;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 44 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $16 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 124 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $16;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1 + 36 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $22 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 104 | 0) + 12 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $22;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 28 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $26 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 108 | 0) >> 2] = $26;
  HEAP32[($2 + 112 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 104 | 0) >> 2] = HEAP32[($1 + 24 | 0) >> 2] | 0;
  memcpy($2 + 144 | 0 | 0, $1 | 0, 96 | 0) | 0;
  alloc__collections__btree__map__BTreeMap_K_2cV___insert__hb205f765e31092f7($2 + 8 | 0 | 0, $0 + 64 | 0 | 0, $2 + 104 | 0 | 0, $2 + 144 | 0 | 0);
  label$1 : {
   switch (HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) {
   default:
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28(($2 + 8 | 0) + 12 | 0 | 0);
    break;
   case 0:
   case 2:
    break label$1;
   };
  }
  global$0 = $2 + 240 | 0;
 }
 
 function cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__get_native_input_scripts__h533aaa6e57788da7($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$2 = 0, $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, $37 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 4 | 0) >> 2] = 0;
  HEAP32[($2 + 8 | 0) >> 2] = i64toi32_i32$0;
  $3 = 0;
  HEAP32[$2 >> 2] = HEAP32[(0 + 1050204 | 0) >> 2] | 0;
  label$1 : {
   $4 = HEAP32[($1 + 32 | 0) >> 2] | 0;
   if (!$4) {
    break label$1
   }
   $3 = HEAP32[($4 + 156 | 0) >> 2] | 0;
  }
  label$2 : {
   label$3 : {
    if (($3 | 0) == ($4 | 0)) {
     break label$3
    }
    label$4 : while (1) {
     $1 = HEAP32[($3 + 156 | 0) >> 2] | 0;
     label$5 : {
      i64toi32_i32$2 = $3;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      i64toi32_i32$2 = i64toi32_i32$0;
      i64toi32_i32$0 = 0;
      if ((i64toi32_i32$2 | 0) != (0 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$0 | 0) | 0) {
       break label$5
      }
      cardano_serialization_lib__NativeScripts__add__h12de25bf2c37f302($2 | 0, $3 + 8 | 0 | 0);
     }
     $3 = $1;
     if (($3 | 0) != ($4 | 0)) {
      continue label$4
     }
     break label$4;
    };
    if (!(HEAP32[($2 + 8 | 0) >> 2] | 0)) {
     break label$3
    }
    i64toi32_i32$2 = HEAP32[$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
    $37 = i64toi32_i32$2;
    i64toi32_i32$2 = $0;
    HEAP32[i64toi32_i32$2 >> 2] = $37;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
    break label$2;
   }
   HEAP32[$0 >> 2] = 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc3d6ec99c05cee40($2 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h0f78886c344617d4($2 | 0);
  }
  global$0 = $2 + 16 | 0;
 }
 
 function $cardano_serialization_lib__plutus__RedeemerTagKind_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h284028eaa4294bff($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, $3$hi = 0, $4 = 0, $4$hi = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___unsigned_integer__h1ed99c0b7fe7eea1($2 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       i64toi32_i32$2 = $2;
       i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
       $3 = i64toi32_i32$0;
       $3$hi = i64toi32_i32$1;
       i64toi32_i32$2 = i64toi32_i32$0;
       i64toi32_i32$0 = 0;
       i64toi32_i32$3 = 1;
       if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
        break label$5
       }
       label$6 : {
        i64toi32_i32$3 = $2;
        i64toi32_i32$2 = HEAP32[($2 + 8 | 0) >> 2] | 0;
        i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
        $4 = i64toi32_i32$2;
        $4$hi = i64toi32_i32$1;
        i64toi32_i32$3 = i64toi32_i32$2;
        i64toi32_i32$2 = 0;
        i64toi32_i32$0 = 3;
        if (i64toi32_i32$1 >>> 0 > i64toi32_i32$2 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$3 >>> 0 > i64toi32_i32$0 >>> 0 | 0) | 0) {
         break label$6
        }
        label$7 : {
         label$8 : {
          label$9 : {
           i64toi32_i32$3 = $4$hi;
           switch ($4 | 0) {
           case 3:
            break label$7;
           case 2:
            break label$8;
           case 1:
            break label$9;
           default:
            break label$3;
           };
          }
          $1 = 1;
          break label$2;
         }
         $1 = 2;
         break label$2;
        }
        $1 = 3;
        break label$2;
       }
       i64toi32_i32$3 = $3$hi;
       if (!($3 | i64toi32_i32$3 | 0)) {
        break label$4
       }
      }
      core__ptr__drop_in_place_cbor_event__error__Error___hbf0141ec70b68c45_6($2 + 8 | 0 | 0);
     }
     HEAP32[($2 + 48 | 0) >> 2] = 0;
     HEAP8[$2 >> 0] = 11;
     cardano_serialization_lib__error__DeserializeError__annotate__h7c2af0c7908d796e($0 + 8 | 0 | 0, $2 | 0, 1071234 | 0, 15 | 0);
     $1 = 1;
     break label$1;
    }
    $1 = 0;
   }
   HEAP8[($0 + 1 | 0) >> 0] = $1;
   $1 = 0;
  }
  HEAP8[$0 >> 0] = $1;
  global$0 = $2 + 64 | 0;
 }
 
 function costmodel_set($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, $5 = 0, $43 = 0, $43$hi = 0, $46 = 0, $46$hi = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hbe92ab119edf5148($3 + 16 | 0 | 0, $0 | 0);
    if (!$2) {
     break label$2
    }
    $4 = HEAP32[($3 + 20 | 0) >> 2] | 0;
    $5 = HEAP32[($3 + 16 | 0) >> 2] | 0;
    wasm_bindgen____rt__WasmRefCell_T___borrow__h8f4f32b29a620a40($3 + 8 | 0 | 0, $2 | 0);
    $0 = HEAP32[($3 + 12 | 0) >> 2] | 0;
    cardano_serialization_lib__plutus__CostModel__set__h749333f509e0b3de($3 + 24 | 0 | 0, $5 | 0, $1 | 0, HEAP32[($3 + 8 | 0) >> 2] | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($4 | 0, 0 | 0) | 0;
    if ((HEAP32[($3 + 24 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    i64toi32_i32$2 = $3 + 32 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $43 = i64toi32_i32$0;
    $43$hi = i64toi32_i32$1;
    i64toi32_i32$2 = $3 + 40 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $46 = i64toi32_i32$1;
    $46$hi = i64toi32_i32$0;
    i64toi32_i32$0 = $43$hi;
    i64toi32_i32$1 = $46$hi;
    $0 = $cardano_serialization_lib__utils__Int_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hac86427717971799($43 | 0, i64toi32_i32$0 | 0, $46 | 0, i64toi32_i32$1 | 0) | 0;
    global$0 = $3 + 48 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($3 + 28 | 0) >> 2] | 0 | 0);
  abort();
 }
 
 function $std__io__Write__write_fmt__Adaptor_T__20as_20core__fmt__Write___write_str__h58faaa242d229e31($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $6 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, $6$hi = 0, $3 = 0, $15 = 0, $16 = 0, $4 = 0, $5 = 0, $17 = 0, $18 = 0, $19 = 0, $20 = 0, $46 = 0, $50 = 0;
  label$1 : {
   i64toi32_i32$0 = $std__io__stdio__StdoutLock_20as_20std__io__Write___write_all__ha8d32e9dac01e4a2(HEAP32[$0 >> 2] | 0 | 0, $1 | 0, $2 | 0) | 0;
   i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
   $6 = i64toi32_i32$0;
   $6$hi = i64toi32_i32$1;
   $2 = i64toi32_i32$0;
   $1 = i64toi32_i32$0 & 255 | 0;
   if (($1 | 0) == (4 | 0)) {
    break label$1
   }
   i64toi32_i32$1 = $6$hi;
   i64toi32_i32$2 = $6;
   i64toi32_i32$0 = 0;
   i64toi32_i32$3 = 8;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$0 = 0;
    $16 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   } else {
    i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
    $16 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
   }
   $6 = $16;
   $6$hi = i64toi32_i32$0;
   label$2 : {
    if ((HEAPU8[($0 + 4 | 0) >> 0] | 0 | 0) != (3 | 0)) {
     break label$2
    }
    $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
    FUNCTION_TABLE[HEAP32[(HEAP32[($3 + 4 | 0) >> 2] | 0) >> 2] | 0 | 0](HEAP32[$3 >> 2] | 0);
    label$3 : {
     $4 = HEAP32[($3 + 4 | 0) >> 2] | 0;
     $5 = HEAP32[($4 + 4 | 0) >> 2] | 0;
     if (!$5) {
      break label$3
     }
     __rust_dealloc(HEAP32[$3 >> 2] | 0 | 0, $5 | 0, HEAP32[($4 + 8 | 0) >> 2] | 0 | 0);
    }
    __rust_dealloc($3 | 0, 12 | 0, 4 | 0);
   }
   HEAP8[($0 + 4 | 0) >> 0] = $2;
   $46 = $0 + 11 | 0;
   i64toi32_i32$0 = $6$hi;
   i64toi32_i32$1 = $6;
   i64toi32_i32$2 = 0;
   i64toi32_i32$3 = 48;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$2 = 0;
    $17 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   } else {
    i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
    $17 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
   }
   HEAP8[$46 >> 0] = $17;
   $50 = $0 + 9 | 0;
   i64toi32_i32$2 = $6$hi;
   i64toi32_i32$0 = $6;
   i64toi32_i32$1 = 0;
   i64toi32_i32$3 = 32;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$1 = 0;
    $18 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   } else {
    i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
    $18 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
   }
   $19 = $50;
   $20 = $18;
   HEAP8[$19 >> 0] = $20;
   HEAP8[($19 + 1 | 0) >> 0] = $20 >>> 8 | 0;
   i64toi32_i32$1 = $6$hi;
   $15 = $0 + 5 | 0;
   HEAP8[$15 >> 0] = $6;
   HEAP8[($15 + 1 | 0) >> 0] = $6 >>> 8 | 0;
   HEAP8[($15 + 2 | 0) >> 0] = $6 >>> 16 | 0;
   HEAP8[($15 + 3 | 0) >> 0] = $6 >>> 24 | 0;
  }
  return ($1 | 0) != (4 | 0) | 0;
 }
 
 function unitinterval_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $30 = 0, $43 = 0, $43$hi = 0, $46 = 0, $46$hi = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $30;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__UnitInterval__from_bytes__he07b579a3340b32f($2 + 8 | 0 | 0, $2 + 48 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 8 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $43 = i64toi32_i32$1;
  $43$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $2 + 24 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$0;
  $46$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $43$hi;
  i64toi32_i32$0 = $46$hi;
  $1 = $cardano_serialization_lib__UnitInterval_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he6b97f3f09608ed8($43 | 0, i64toi32_i32$1 | 0, $46 | 0, i64toi32_i32$0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function transactionbody_mint($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h356c30395cf13adb($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   label$2 : {
    label$3 : {
     $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     if ((HEAP32[($2 + 164 | 0) >> 2] | 0 | 0) != (1 | 0)) {
      break label$3
     }
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h3d696390b8f8d3c9($1 + 16 | 0 | 4 | 0 | 0, $2 + 168 | 0 | 0);
     core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
     HEAP32[($1 + 40 | 0) >> 2] = HEAP32[($1 + 28 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($1 + 24 | 0) >> 2] | 0;
     HEAP32[($1 + 32 | 0) >> 2] = HEAP32[($1 + 20 | 0) >> 2] | 0;
     HEAP32[($1 + 36 | 0) >> 2] = i64toi32_i32$1;
     $0 = $cardano_serialization_lib__Mint_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8fa2adeb6e27a027($1 + 32 | 0 | 0) | 0;
     break label$2;
    }
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    $0 = 0;
   }
   global$0 = $1 + 48 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionbody_multiassets($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h356c30395cf13adb($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   label$2 : {
    label$3 : {
     $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     if ((HEAP32[($2 + 164 | 0) >> 2] | 0 | 0) != (1 | 0)) {
      break label$3
     }
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h3d696390b8f8d3c9($1 + 16 | 0 | 4 | 0 | 0, $2 + 168 | 0 | 0);
     core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
     HEAP32[($1 + 40 | 0) >> 2] = HEAP32[($1 + 28 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($1 + 24 | 0) >> 2] | 0;
     HEAP32[($1 + 32 | 0) >> 2] = HEAP32[($1 + 20 | 0) >> 2] | 0;
     HEAP32[($1 + 36 | 0) >> 2] = i64toi32_i32$1;
     $0 = $cardano_serialization_lib__Mint_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8fa2adeb6e27a027($1 + 32 | 0 | 0) | 0;
     break label$2;
    }
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    $0 = 0;
   }
   global$0 = $1 + 48 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function relay_as_single_host_name($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb17ff77b9b324998($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   cardano_serialization_lib__Relay__as_single_host_name__he974066e21c2b4b5($1 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   $0 = 0;
   label$2 : {
    $2 = HEAPU16[($1 + 28 | 0) >> 1] | 0;
    if (($2 | 0) == (2 | 0)) {
     break label$2
    }
    HEAP16[($1 + 46 | 0) >> 1] = HEAPU16[($1 + 30 | 0) >> 1] | 0;
    HEAP32[(($1 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($1 + 16 | 0) + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
    HEAP32[($1 + 32 | 0) >> 2] = HEAP32[($1 + 16 | 0) >> 2] | 0;
    HEAP32[($1 + 36 | 0) >> 2] = i64toi32_i32$1;
    HEAP16[($1 + 44 | 0) >> 1] = $2;
    $0 = $cardano_serialization_lib__SingleHostName_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hc318333b1b61f10d($1 + 32 | 0 | 0) | 0;
   }
   global$0 = $1 + 48 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function protocolparamupdate_cost_models($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hd84cc8f720a3dada($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   label$2 : {
    label$3 : {
     $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     if ((HEAP32[($2 + 332 | 0) >> 2] | 0 | 0) != (1 | 0)) {
      break label$3
     }
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h663a668224e1772a($1 + 16 | 0 | 4 | 0 | 0, $2 + 336 | 0 | 0);
     core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
     HEAP32[($1 + 40 | 0) >> 2] = HEAP32[($1 + 28 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($1 + 24 | 0) >> 2] | 0;
     HEAP32[($1 + 32 | 0) >> 2] = HEAP32[($1 + 20 | 0) >> 2] | 0;
     HEAP32[($1 + 36 | 0) >> 2] = i64toi32_i32$1;
     $0 = $cardano_serialization_lib__plutus__Costmdls_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8003415a0e008f0e($1 + 32 | 0 | 0) | 0;
     break label$2;
    }
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    $0 = 0;
   }
   global$0 = $1 + 48 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function hashbrown__raw__RawTable_T_2cA___reserve_rehash__h1afcba29aa7ee604($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $6 = 0, $5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $26 = 0;
  $5 = global$0 - 16 | 0;
  global$0 = $5;
  label$1 : {
   label$2 : {
    $6 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    $2 = $6 + $2 | 0;
    if ($2 >>> 0 >= $6 >>> 0) {
     break label$2
    }
    hashbrown__raw__Fallibility__capacity_overflow__hd790516fe6877097($5 + 8 | 0 | 0, $4 | 0);
    i64toi32_i32$0 = HEAP32[($5 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($5 + 12 | 0) >> 2] | 0;
    HEAP32[$0 >> 2] = 1;
    $26 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[($0 + 4 | 0) >> 2] = $26;
    HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$1;
    break label$1;
   }
   label$3 : {
    $6 = HEAP32[$1 >> 2] | 0;
    $6 = $6 >>> 0 < 8 >>> 0 ? $6 : Math_imul(($6 + 1 | 0) >>> 3 | 0, 7);
    if ($2 >>> 0 <= ($6 >>> 1 | 0) >>> 0) {
     break label$3
    }
    $6 = $6 + 1 | 0;
    hashbrown__raw__RawTable_T_2cA___resize__h6f95ebb722f91bc1($0 | 0, $1 | 0, ($2 >>> 0 > $6 >>> 0 ? $2 : $6) | 0, $3 | 0, $4 | 0);
    break label$1;
   }
   hashbrown__raw__RawTable_T_2cA___rehash_in_place__h7ea6576ba60d582c($1 | 0, $3 | 0);
   HEAP32[$0 >> 2] = 0;
  }
  global$0 = $5 + 16 | 0;
 }
 
 function hashbrown__raw__RawTable_T_2cA___reserve_rehash__h3683e854426b5d78($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $6 = 0, $5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $26 = 0;
  $5 = global$0 - 16 | 0;
  global$0 = $5;
  label$1 : {
   label$2 : {
    $6 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    $2 = $6 + $2 | 0;
    if ($2 >>> 0 >= $6 >>> 0) {
     break label$2
    }
    hashbrown__raw__Fallibility__capacity_overflow__hd790516fe6877097($5 + 8 | 0 | 0, $4 | 0);
    i64toi32_i32$0 = HEAP32[($5 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($5 + 12 | 0) >> 2] | 0;
    HEAP32[$0 >> 2] = 1;
    $26 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[($0 + 4 | 0) >> 2] = $26;
    HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$1;
    break label$1;
   }
   label$3 : {
    $6 = HEAP32[$1 >> 2] | 0;
    $6 = $6 >>> 0 < 8 >>> 0 ? $6 : Math_imul(($6 + 1 | 0) >>> 3 | 0, 7);
    if ($2 >>> 0 <= ($6 >>> 1 | 0) >>> 0) {
     break label$3
    }
    $6 = $6 + 1 | 0;
    hashbrown__raw__RawTable_T_2cA___resize__hecbd0329c16f7177($0 | 0, $1 | 0, ($2 >>> 0 > $6 >>> 0 ? $2 : $6) | 0, $3 | 0, $4 | 0);
    break label$1;
   }
   hashbrown__raw__RawTable_T_2cA___rehash_in_place__hedd38d2062614323($1 | 0, $3 | 0);
   HEAP32[$0 >> 2] = 0;
  }
  global$0 = $5 + 16 | 0;
 }
 
 function hashbrown__raw__RawTable_T_2cA___reserve_rehash__h36f8e08ecb372107($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $6 = 0, $5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $26 = 0;
  $5 = global$0 - 16 | 0;
  global$0 = $5;
  label$1 : {
   label$2 : {
    $6 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    $2 = $6 + $2 | 0;
    if ($2 >>> 0 >= $6 >>> 0) {
     break label$2
    }
    hashbrown__raw__Fallibility__capacity_overflow__hd790516fe6877097($5 + 8 | 0 | 0, $4 | 0);
    i64toi32_i32$0 = HEAP32[($5 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($5 + 12 | 0) >> 2] | 0;
    HEAP32[$0 >> 2] = 1;
    $26 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[($0 + 4 | 0) >> 2] = $26;
    HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$1;
    break label$1;
   }
   label$3 : {
    $6 = HEAP32[$1 >> 2] | 0;
    $6 = $6 >>> 0 < 8 >>> 0 ? $6 : Math_imul(($6 + 1 | 0) >>> 3 | 0, 7);
    if ($2 >>> 0 <= ($6 >>> 1 | 0) >>> 0) {
     break label$3
    }
    $6 = $6 + 1 | 0;
    hashbrown__raw__RawTable_T_2cA___resize__h1555572ec1565477($0 | 0, $1 | 0, ($2 >>> 0 > $6 >>> 0 ? $2 : $6) | 0, $3 | 0, $4 | 0);
    break label$1;
   }
   hashbrown__raw__RawTable_T_2cA___rehash_in_place__haec697783d339c16($1 | 0, $3 | 0);
   HEAP32[$0 >> 2] = 0;
  }
  global$0 = $5 + 16 | 0;
 }
 
 function hashbrown__raw__RawTable_T_2cA___reserve_rehash__h6f0b6bcc2f29bdb2($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $6 = 0, $5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $26 = 0;
  $5 = global$0 - 16 | 0;
  global$0 = $5;
  label$1 : {
   label$2 : {
    $6 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    $2 = $6 + $2 | 0;
    if ($2 >>> 0 >= $6 >>> 0) {
     break label$2
    }
    hashbrown__raw__Fallibility__capacity_overflow__hd790516fe6877097($5 + 8 | 0 | 0, $4 | 0);
    i64toi32_i32$0 = HEAP32[($5 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($5 + 12 | 0) >> 2] | 0;
    HEAP32[$0 >> 2] = 1;
    $26 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[($0 + 4 | 0) >> 2] = $26;
    HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$1;
    break label$1;
   }
   label$3 : {
    $6 = HEAP32[$1 >> 2] | 0;
    $6 = $6 >>> 0 < 8 >>> 0 ? $6 : Math_imul(($6 + 1 | 0) >>> 3 | 0, 7);
    if ($2 >>> 0 <= ($6 >>> 1 | 0) >>> 0) {
     break label$3
    }
    $6 = $6 + 1 | 0;
    hashbrown__raw__RawTable_T_2cA___resize__hba39572a23a8b6a3($0 | 0, $1 | 0, ($2 >>> 0 > $6 >>> 0 ? $2 : $6) | 0, $3 | 0, $4 | 0);
    break label$1;
   }
   hashbrown__raw__RawTable_T_2cA___rehash_in_place__hf0998e6c04e02483($1 | 0, $3 | 0);
   HEAP32[$0 >> 2] = 0;
  }
  global$0 = $5 + 16 | 0;
 }
 
 function hashbrown__raw__RawTable_T_2cA___reserve_rehash__h8272927323c5743e($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $6 = 0, $5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $26 = 0;
  $5 = global$0 - 16 | 0;
  global$0 = $5;
  label$1 : {
   label$2 : {
    $6 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    $2 = $6 + $2 | 0;
    if ($2 >>> 0 >= $6 >>> 0) {
     break label$2
    }
    hashbrown__raw__Fallibility__capacity_overflow__hd790516fe6877097($5 + 8 | 0 | 0, $4 | 0);
    i64toi32_i32$0 = HEAP32[($5 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($5 + 12 | 0) >> 2] | 0;
    HEAP32[$0 >> 2] = 1;
    $26 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[($0 + 4 | 0) >> 2] = $26;
    HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$1;
    break label$1;
   }
   label$3 : {
    $6 = HEAP32[$1 >> 2] | 0;
    $6 = $6 >>> 0 < 8 >>> 0 ? $6 : Math_imul(($6 + 1 | 0) >>> 3 | 0, 7);
    if ($2 >>> 0 <= ($6 >>> 1 | 0) >>> 0) {
     break label$3
    }
    $6 = $6 + 1 | 0;
    hashbrown__raw__RawTable_T_2cA___resize__h98a159c00cc226ef($0 | 0, $1 | 0, ($2 >>> 0 > $6 >>> 0 ? $2 : $6) | 0, $3 | 0, $4 | 0);
    break label$1;
   }
   hashbrown__raw__RawTable_T_2cA___rehash_in_place__hb19b3af64e2051bd($1 | 0, $3 | 0);
   HEAP32[$0 >> 2] = 0;
  }
  global$0 = $5 + 16 | 0;
 }
 
 function hashbrown__raw__RawTable_T_2cA___reserve_rehash__h9a8b2e47a9b8fcec($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $6 = 0, $5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $26 = 0;
  $5 = global$0 - 16 | 0;
  global$0 = $5;
  label$1 : {
   label$2 : {
    $6 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    $2 = $6 + $2 | 0;
    if ($2 >>> 0 >= $6 >>> 0) {
     break label$2
    }
    hashbrown__raw__Fallibility__capacity_overflow__hd790516fe6877097($5 + 8 | 0 | 0, $4 | 0);
    i64toi32_i32$0 = HEAP32[($5 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($5 + 12 | 0) >> 2] | 0;
    HEAP32[$0 >> 2] = 1;
    $26 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[($0 + 4 | 0) >> 2] = $26;
    HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$1;
    break label$1;
   }
   label$3 : {
    $6 = HEAP32[$1 >> 2] | 0;
    $6 = $6 >>> 0 < 8 >>> 0 ? $6 : Math_imul(($6 + 1 | 0) >>> 3 | 0, 7);
    if ($2 >>> 0 <= ($6 >>> 1 | 0) >>> 0) {
     break label$3
    }
    $6 = $6 + 1 | 0;
    hashbrown__raw__RawTable_T_2cA___resize__h272f5993ec3ece2b($0 | 0, $1 | 0, ($2 >>> 0 > $6 >>> 0 ? $2 : $6) | 0, $3 | 0, $4 | 0);
    break label$1;
   }
   hashbrown__raw__RawTable_T_2cA___rehash_in_place__h221d94fac61a9274($1 | 0, $3 | 0);
   HEAP32[$0 >> 2] = 0;
  }
  global$0 = $5 + 16 | 0;
 }
 
 function hashbrown__raw__RawTable_T_2cA___reserve_rehash__hd1aa58e6d9f62a6c($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $6 = 0, $5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $26 = 0;
  $5 = global$0 - 16 | 0;
  global$0 = $5;
  label$1 : {
   label$2 : {
    $6 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    $2 = $6 + $2 | 0;
    if ($2 >>> 0 >= $6 >>> 0) {
     break label$2
    }
    hashbrown__raw__Fallibility__capacity_overflow__hd790516fe6877097($5 + 8 | 0 | 0, $4 | 0);
    i64toi32_i32$0 = HEAP32[($5 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($5 + 12 | 0) >> 2] | 0;
    HEAP32[$0 >> 2] = 1;
    $26 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[($0 + 4 | 0) >> 2] = $26;
    HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$1;
    break label$1;
   }
   label$3 : {
    $6 = HEAP32[$1 >> 2] | 0;
    $6 = $6 >>> 0 < 8 >>> 0 ? $6 : Math_imul(($6 + 1 | 0) >>> 3 | 0, 7);
    if ($2 >>> 0 <= ($6 >>> 1 | 0) >>> 0) {
     break label$3
    }
    $6 = $6 + 1 | 0;
    hashbrown__raw__RawTable_T_2cA___resize__hc18bdde8d939a846($0 | 0, $1 | 0, ($2 >>> 0 > $6 >>> 0 ? $2 : $6) | 0, $3 | 0, $4 | 0);
    break label$1;
   }
   hashbrown__raw__RawTable_T_2cA___rehash_in_place__h848e040d15a86367($1 | 0, $3 | 0);
   HEAP32[$0 >> 2] = 0;
  }
  global$0 = $5 + 16 | 0;
 }
 
 function hashbrown__raw__RawTable_T_2cA___reserve_rehash__he1b34538bf0de034($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $6 = 0, $5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $26 = 0;
  $5 = global$0 - 16 | 0;
  global$0 = $5;
  label$1 : {
   label$2 : {
    $6 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    $2 = $6 + $2 | 0;
    if ($2 >>> 0 >= $6 >>> 0) {
     break label$2
    }
    hashbrown__raw__Fallibility__capacity_overflow__hd790516fe6877097($5 + 8 | 0 | 0, $4 | 0);
    i64toi32_i32$0 = HEAP32[($5 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($5 + 12 | 0) >> 2] | 0;
    HEAP32[$0 >> 2] = 1;
    $26 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[($0 + 4 | 0) >> 2] = $26;
    HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$1;
    break label$1;
   }
   label$3 : {
    $6 = HEAP32[$1 >> 2] | 0;
    $6 = $6 >>> 0 < 8 >>> 0 ? $6 : Math_imul(($6 + 1 | 0) >>> 3 | 0, 7);
    if ($2 >>> 0 <= ($6 >>> 1 | 0) >>> 0) {
     break label$3
    }
    $6 = $6 + 1 | 0;
    hashbrown__raw__RawTable_T_2cA___resize__hdc7ba59faabe2921($0 | 0, $1 | 0, ($2 >>> 0 > $6 >>> 0 ? $2 : $6) | 0, $3 | 0, $4 | 0);
    break label$1;
   }
   hashbrown__raw__RawTable_T_2cA___rehash_in_place__hdaa6605ef49d78a4($1 | 0, $3 | 0);
   HEAP32[$0 >> 2] = 0;
  }
  global$0 = $5 + 16 | 0;
 }
 
 function hashbrown__raw__RawTable_T_2cA___reserve_rehash__he1deefcf95f72348($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $6 = 0, $5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $26 = 0;
  $5 = global$0 - 16 | 0;
  global$0 = $5;
  label$1 : {
   label$2 : {
    $6 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    $2 = $6 + $2 | 0;
    if ($2 >>> 0 >= $6 >>> 0) {
     break label$2
    }
    hashbrown__raw__Fallibility__capacity_overflow__hd790516fe6877097($5 + 8 | 0 | 0, $4 | 0);
    i64toi32_i32$0 = HEAP32[($5 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($5 + 12 | 0) >> 2] | 0;
    HEAP32[$0 >> 2] = 1;
    $26 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[($0 + 4 | 0) >> 2] = $26;
    HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$1;
    break label$1;
   }
   label$3 : {
    $6 = HEAP32[$1 >> 2] | 0;
    $6 = $6 >>> 0 < 8 >>> 0 ? $6 : Math_imul(($6 + 1 | 0) >>> 3 | 0, 7);
    if ($2 >>> 0 <= ($6 >>> 1 | 0) >>> 0) {
     break label$3
    }
    $6 = $6 + 1 | 0;
    hashbrown__raw__RawTable_T_2cA___resize__hedba9ac6008c9926($0 | 0, $1 | 0, ($2 >>> 0 > $6 >>> 0 ? $2 : $6) | 0, $3 | 0, $4 | 0);
    break label$1;
   }
   hashbrown__raw__RawTable_T_2cA___rehash_in_place__he20b6634c1b2e53a($1 | 0, $3 | 0);
   HEAP32[$0 >> 2] = 0;
  }
  global$0 = $5 + 16 | 0;
 }
 
 function hashbrown__raw__RawTable_T_2cA___reserve_rehash__hec1cc27e6be9d875($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $6 = 0, $5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $26 = 0;
  $5 = global$0 - 16 | 0;
  global$0 = $5;
  label$1 : {
   label$2 : {
    $6 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    $2 = $6 + $2 | 0;
    if ($2 >>> 0 >= $6 >>> 0) {
     break label$2
    }
    hashbrown__raw__Fallibility__capacity_overflow__hd790516fe6877097($5 + 8 | 0 | 0, $4 | 0);
    i64toi32_i32$0 = HEAP32[($5 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($5 + 12 | 0) >> 2] | 0;
    HEAP32[$0 >> 2] = 1;
    $26 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[($0 + 4 | 0) >> 2] = $26;
    HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$1;
    break label$1;
   }
   label$3 : {
    $6 = HEAP32[$1 >> 2] | 0;
    $6 = $6 >>> 0 < 8 >>> 0 ? $6 : Math_imul(($6 + 1 | 0) >>> 3 | 0, 7);
    if ($2 >>> 0 <= ($6 >>> 1 | 0) >>> 0) {
     break label$3
    }
    $6 = $6 + 1 | 0;
    hashbrown__raw__RawTable_T_2cA___resize__h5eaf2f7565587360($0 | 0, $1 | 0, ($2 >>> 0 > $6 >>> 0 ? $2 : $6) | 0, $3 | 0, $4 | 0);
    break label$1;
   }
   hashbrown__raw__RawTable_T_2cA___rehash_in_place__h5635ef5f6440afeb($1 | 0, $3 | 0);
   HEAP32[$0 >> 2] = 0;
  }
  global$0 = $5 + 16 | 0;
 }
 
 function int_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $30 = 0, $43 = 0, $43$hi = 0, $46 = 0, $46$hi = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $30;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__utils__Int__from_bytes__h393d1058ebb4f592($2 + 8 | 0 | 0, $2 + 48 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 8 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $43 = i64toi32_i32$1;
  $43$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $2 + 24 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$0;
  $46$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $43$hi;
  i64toi32_i32$0 = $46$hi;
  $1 = $cardano_serialization_lib__utils__Int_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hac86427717971799($43 | 0, i64toi32_i32$1 | 0, $46 | 0, i64toi32_i32$0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function min_ada_required($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$2 = 0, $4 = 0, i64toi32_i32$1 = 0;
  $3 = global$0 - 32 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h5db5149478ec5345($3 + 8 | 0 | 0, $0 | 0);
    if (!$2) {
     break label$2
    }
    $0 = HEAP32[($3 + 12 | 0) >> 2] | 0;
    $4 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($3 | 0, $2 | 0);
    $2 = HEAP32[($3 + 4 | 0) >> 2] | 0;
    cardano_serialization_lib__utils__min_ada_required__hfea4b15a263723f5($3 + 16 | 0 | 0, $4 | 0, ($1 | 0) != (0 | 0) | 0, HEAP32[$3 >> 2] | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    if ((HEAP32[($3 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    i64toi32_i32$2 = $3 + 24 | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810(HEAP32[i64toi32_i32$2 >> 2] | 0 | 0, i64toi32_i32$1 | 0) | 0;
    global$0 = $3 + 32 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($3 + 20 | 0) >> 2] | 0 | 0);
  abort();
 }
 
 function transactionbuilder_get_mint($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h37dfbd2f31d951c1($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   label$2 : {
    label$3 : {
     $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     if ((HEAP32[($2 + 440 | 0) >> 2] | 0 | 0) != (1 | 0)) {
      break label$3
     }
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h3d696390b8f8d3c9($1 + 16 | 0 | 4 | 0 | 0, $2 + 444 | 0 | 0);
     core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
     HEAP32[($1 + 40 | 0) >> 2] = HEAP32[($1 + 28 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($1 + 24 | 0) >> 2] | 0;
     HEAP32[($1 + 32 | 0) >> 2] = HEAP32[($1 + 20 | 0) >> 2] | 0;
     HEAP32[($1 + 36 | 0) >> 2] = i64toi32_i32$1;
     $0 = $cardano_serialization_lib__Mint_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8fa2adeb6e27a027($1 + 32 | 0 | 0) | 0;
     break label$2;
    }
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    $0 = 0;
   }
   global$0 = $1 + 48 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function cardano_serialization_lib__crypto__Vkeywitnesses__add__he21d7a30d5c7de68($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $2 = 0, $10 = 0, $15 = 0, $20 = 0, $23 = 0;
  $2 = global$0 - 96 | 0;
  global$0 = $2;
  i64toi32_i32$2 = $1 + 24 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 24 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $10;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $15 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $15;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $20;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $23 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[i64toi32_i32$1 >> 2] = $23;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  memcpy(i64toi32_i32$1 + 32 | 0 | 0, i64toi32_i32$2 + 32 | 0 | 0, 64 | 0) | 0;
  label$1 : {
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (($1 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
    break label$1
   }
   alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hf92fb44e4fe7e929($0 | 0, $1 | 0, 1 | 0);
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  }
  memcpy((HEAP32[$0 >> 2] | 0) + Math_imul($1, 96) | 0 | 0, $2 | 0, 96 | 0) | 0;
  HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
  global$0 = $2 + 96 | 0;
 }
 
 function alloc__vec__Vec_T_2cA___extend_desugared__h33bb45fd23d36433($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0, $5 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__hf8baa7262b1cd562($2 + 8 | 0 | 0, $1 | 0);
  label$1 : {
   $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   if (!$3) {
    break label$1
   }
   label$2 : while (1) {
    $cardano_serialization_lib__plutus__PlutusData_20as_20core__clone__Clone___clone__h63d1a98cc18f4609_2($2 + 16 | 0 | 0, $3 | 0);
    if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) == (5 | 0)) {
     break label$1
    }
    label$3 : {
     $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
     if ((HEAP32[($0 + 4 | 0) >> 2] | 0 | 0) != ($3 | 0)) {
      break label$3
     }
     $4 = HEAP32[($1 + 24 | 0) >> 2] | 0;
     $5 = $4 + 1 | 0;
     alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h1a6fd20a90c96048($0 | 0, $3 | 0, ($5 >>> 0 < $4 >>> 0 ? -1 : $5) | 0);
    }
    memcpy((HEAP32[$0 >> 2] | 0) + Math_imul($3, 48) | 0 | 0, $2 + 16 | 0 | 0, 48 | 0) | 0;
    HEAP32[($0 + 8 | 0) >> 2] = $3 + 1 | 0;
    $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__hf8baa7262b1cd562($2 | 0, $1 | 0);
    $3 = HEAP32[$2 >> 2] | 0;
    if ($3) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $2 + 64 | 0;
 }
 
 function byronaddress_from_base58($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 128 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  HEAP32[($2 + 76 | 0) >> 2] = $1;
  $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  HEAP32[($2 + 72 | 0) >> 2] = $0;
  cardano_serialization_lib__address__ByronAddress__from_base58__h285e6684b8ae3bde($2 + 16 | 0 | 0, $0 | 0, $1 | 0);
  core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_4($2 + 72 | 0 | 0);
  $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  HEAP32[($2 + 72 | 0) >> 2] = $1;
  memcpy($2 + 72 | 0 | 4 | 0 | 0, $2 + 24 | 0 | 0, 48 | 0) | 0;
  $1 = $cardano_serialization_lib__address__ByronAddress_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbc0eb32d6a95f2a3($2 + 72 | 0 | 0) | 0;
  global$0 = $2 + 128 | 0;
  return $1 | 0;
 }
 
 function exunits_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $30 = 0, $43 = 0, $43$hi = 0, $46 = 0, $46$hi = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $30;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__plutus__ExUnits__from_bytes__hc6228a0585c69836($2 + 8 | 0 | 0, $2 + 48 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 8 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $43 = i64toi32_i32$1;
  $43$hi = i64toi32_i32$0;
  i64toi32_i32$2 = $2 + 24 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $46 = i64toi32_i32$0;
  $46$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $43$hi;
  i64toi32_i32$0 = $46$hi;
  $1 = $cardano_serialization_lib__plutus__ExUnits_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h4867c49ddc624134($43 | 0, i64toi32_i32$1 | 0, $46 | 0, i64toi32_i32$0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function plutusdata_as_map($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb1fd14a6870cafe2($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   label$2 : {
    label$3 : {
     $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     if ((HEAP32[$2 >> 2] | 0 | 0) != (1 | 0)) {
      break label$3
     }
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__hf4eb1bac8cecd8c9($1 + 16 | 0 | 4 | 0 | 0, $2 + 4 | 0 | 0);
     core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
     HEAP32[($1 + 40 | 0) >> 2] = HEAP32[($1 + 28 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($1 + 24 | 0) >> 2] | 0;
     HEAP32[($1 + 32 | 0) >> 2] = HEAP32[($1 + 20 | 0) >> 2] | 0;
     HEAP32[($1 + 36 | 0) >> 2] = i64toi32_i32$1;
     $0 = $cardano_serialization_lib__plutus__PlutusMap_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hc959583e66b458a0($1 + 32 | 0 | 0) | 0;
     break label$2;
    }
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    $0 = 0;
   }
   global$0 = $1 + 48 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal___push__h7628a10c0a82fa84($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var i64toi32_i32$0 = 0, $5 = 0, i64toi32_i32$1 = 0, $39 = 0;
  label$1 : {
   label$2 : {
    if (((HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) != ($3 | 0)) {
     break label$2
    }
    $0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    $3 = HEAPU16[($0 + 1546 | 0) >> 1] | 0;
    if ($3 >>> 0 <= 10 >>> 0) {
     break label$1
    }
    core__panicking__panic__h2fd385a887c8bf13(1048619 | 0, 32 | 0, 1048824 | 0);
    abort();
   }
   core__panicking__panic__h2fd385a887c8bf13(1048760 | 0, 48 | 0, 1048808 | 0);
   abort();
  }
  $5 = $3 + 1 | 0;
  HEAP16[($0 + 1546 | 0) >> 1] = $5;
  memcpy($0 + ($3 << 7 | 0) | 0 | 0, $1 | 0, 128 | 0) | 0;
  $3 = $0 + Math_imul($3, 12) | 0;
  HEAP32[($3 + 1420 | 0) >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $39 = i64toi32_i32$0;
  i64toi32_i32$0 = $3 + 1412 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $39;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(($0 + ($5 << 2 | 0) | 0) + 1552 | 0) >> 2] = $4;
  HEAP16[($4 + 1544 | 0) >> 1] = $5;
  HEAP32[($4 + 1408 | 0) >> 2] = $0;
 }
 
 function core__ptr__drop_in_place_cardano_serialization_lib__TransactionBody___h9274013021a1d568_1($0) {
  $0 = $0 | 0;
  var $2 = 0, $3 = 0, $1 = 0;
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h98bad0b07702c13e($0 + 128 | 0 | 0);
  $1 = $0 + 140 | 0;
  label$1 : {
   $2 = HEAP32[($0 + 148 | 0) >> 2] | 0;
   if (!$2) {
    break label$1
   }
   $3 = HEAP32[($0 + 140 | 0) >> 2] | 0;
   $2 = $2 << 7 | 0;
   label$2 : while (1) {
    core__ptr__drop_in_place_cardano_serialization_lib__TransactionOutput___h632b3a99817e6ac5_1($3 | 0);
    $3 = $3 + 128 | 0;
    $2 = $2 + -128 | 0;
    if ($2) {
     continue label$2
    }
    break label$2;
   };
  }
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h5107e2b13c386680($1 | 0);
  core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__Certificates____h3bab90286ab8bbb4($0 + 152 | 0 | 0);
  core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__Withdrawals____heaf2605773ce1c75($0 + 24 | 0 | 0);
  core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__Update____hc1ce6150a8713009($0 + 64 | 0 | 0);
  label$3 : {
   if (!(HEAP32[($0 + 164 | 0) >> 2] | 0)) {
    break label$3
   }
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h3981a4152bf24dd0($0 + 168 | 0 | 0);
  }
  label$4 : {
   if (!(HEAP32[($0 + 180 | 0) >> 2] | 0)) {
    break label$4
   }
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h98bad0b07702c13e($0 + 180 | 0 | 0);
  }
  label$5 : {
   if (!(HEAP32[($0 + 192 | 0) >> 2] | 0)) {
    break label$5
   }
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h72de9eab2f0e4669($0 + 192 | 0 | 0);
  }
 }
 
 function bip32publickey_derive($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 144 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__hcfcf2a638924fc64($2 | 0, $0 | 0);
    $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
    cardano_serialization_lib__crypto__Bip32PublicKey__derive__he58fcef416b54f88($2 + 8 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, $1 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    if ((HEAPU8[($2 + 8 | 0) >> 0] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    HEAP8[($2 + 82 | 0) >> 0] = HEAPU8[($2 + 11 | 0) >> 0] | 0;
    HEAP16[($2 + 80 | 0) >> 1] = HEAPU8[($2 + 9 | 0) >> 0] | 0 | ((HEAPU8[($2 + 10 | 0) >> 0] | 0) << 8 | 0) | 0;
    HEAP8[($2 + 83 | 0) >> 0] = $0;
    HEAP8[($2 + 84 | 0) >> 0] = $0 >>> 8 | 0;
    HEAP8[($2 + 85 | 0) >> 0] = $0 >>> 16 | 0;
    HEAP8[($2 + 86 | 0) >> 0] = $0 >>> 24 | 0;
    memcpy($2 + 80 | 0 | 7 | 0 | 0, $2 + 16 | 0 | 0, 57 | 0) | 0;
    $0 = $cardano_serialization_lib__crypto__Bip32PublicKey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h56f6677bb959345b($2 + 80 | 0 | 0) | 0;
    global$0 = $2 + 144 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472($0 | 0);
  abort();
 }
 
 function cardano_serialization_lib__address__Address__from_bytes__he11c10ad6d995a7b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, $3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 144 | 0;
  global$0 = $2;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 | 0, $1 | 0);
  cardano_serialization_lib__address__Address__from_bytes_impl__h0b2b4c3a1f339e7a($2 + 72 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
  i64toi32_i32$0 = HEAP32[($2 + 72 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 76 | 0) >> 2] | 0;
  memcpy($2 + 8 | 0 | 0, ($2 + 72 | 0) + 8 | 0 | 0, 64 | 0) | 0;
  label$1 : {
   label$2 : {
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    if ((i64toi32_i32$2 | 0) == (1 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
     break label$2
    }
    memcpy($0 + 8 | 0 | 0, $2 + 8 | 0 | 0, 64 | 0) | 0;
    $3 = 0;
    break label$1;
   }
   memcpy($2 + 72 | 0 | 0, $2 + 8 | 0 | 0, 64 | 0) | 0;
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($2 + 72 | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
   $3 = 1;
  }
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  HEAP32[$0 >> 2] = $3;
  global$0 = $2 + 144 | 0;
 }
 
 function $T_20as_20core__convert__Into_U____into__h7f4f73dcbb1683ac($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $14 = 0, $20 = 0, $26 = 0, $32 = 0, $35 = 0, $38 = 0, $41 = 0, $44 = 0;
  $2 = global$0 - 128 | 0;
  global$0 = $2;
  $2 = memcpy($2 | 0, $1 | 0, 64 | 0) | 0;
  i64toi32_i32$2 = $2 + 24 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 64 | 0) + 24 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $14;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2 + 40 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $20 = i64toi32_i32$1;
  i64toi32_i32$1 = ($2 + 64 | 0) + 40 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $20;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2 + 56 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $26 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 64 | 0) + 56 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $26;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $32 = i64toi32_i32$1;
  i64toi32_i32$1 = ($2 + 64 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $32;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $35 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 80 | 0) >> 2] = $35;
  HEAP32[($2 + 84 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $38 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 96 | 0) >> 2] = $38;
  HEAP32[($2 + 100 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 52 | 0) >> 2] | 0;
  $41 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 112 | 0) >> 2] = $41;
  HEAP32[($2 + 116 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $44 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 64 | 0) >> 2] = $44;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$0;
  memcpy($0 | 0, $2 + 64 | 0 | 0, 64 | 0) | 0;
  global$0 = $2 + 128 | 0;
 }
 
 function $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__hca5504019fd14046($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, i64toi32_i32$2 = 0, $4 = 0, $5 = 0, $36 = 0, $42 = 0, $45 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  $3 = 0;
  label$1 : {
   label$2 : {
    $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$4) {
     break label$2
    }
    $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    if (!$3) {
     break label$1
    }
    $5 = ($4 >>> 0) / ($3 >>> 0) | 0;
    $3 = $5 + (($4 - Math_imul($5, $3) | 0 | 0) != (0 | 0)) | 0;
   }
   alloc__raw_vec__RawVec_T_2cA___allocate_in__hb0817f92bbb8999a($2 + 8 | 0 | 0, $3 | 0, 0 | 0);
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   HEAP32[($0 + 8 | 0) >> 2] = 0;
   $36 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[i64toi32_i32$0 >> 2] = $36;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $1 + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $42 = i64toi32_i32$1;
   i64toi32_i32$1 = ($2 + 16 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $42;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $1;
   i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   $45 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   HEAP32[($2 + 16 | 0) >> 2] = $45;
   HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$1;
   $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend_T_2cI____spec_extend__h60be40d0f8090820($0 | 0, $2 + 16 | 0 | 0);
   global$0 = $2 + 32 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1083600 | 0, 25 | 0, 1083576 | 0);
  abort();
 }
 
 function alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__h61e2c78385a28c9d($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $6 = 0, $4 = 0, $7 = 0, $5 = 0;
  $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = HEAPU16[($4 + 138 | 0) >> 1] | 0;
  $6 = Math_imul($3, 28);
  $1 = Math_imul($5, 28) - $6 | 0;
  $7 = $3 + -1 | 0;
  $3 = ($4 + $6 | 0) + 140 | 0;
  $6 = 1;
  label$1 : {
   label$2 : while (1) {
    label$3 : {
     if ($1) {
      break label$3
     }
     $7 = $5;
     break label$1;
    }
    $4 = core__slice__cmp___impl_20core__cmp__Ord_20for_20_5bT_5d___cmp__h1f2092e0ba2f27ea($2 | 0, 28 | 0, $3 | 0, 28 | 0) | 0;
    $7 = $7 + 1 | 0;
    $1 = $1 + -28 | 0;
    $3 = $3 + 28 | 0;
    if (($4 & 255 | 0 | 0) == (1 | 0)) {
     continue label$2
    }
    break label$2;
   };
   label$4 : {
    $6 = ($4 << 24 | 0) >> 24 | 0;
    switch ($6 + 1 | 0 | 0) {
    case 1:
     break label$1;
    default:
     break label$4;
    };
   }
   $6 = 1;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $7;
  HEAP32[$0 >> 2] = $6;
 }
 
 function alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__h00b00e731f071e0e($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $6 = 0, $4 = 0, $7 = 0, $5 = 0;
  $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = HEAPU16[($4 + 138 | 0) >> 1] | 0;
  $6 = Math_imul($3, 28);
  $1 = Math_imul($5, 28) - $6 | 0;
  $7 = $3 + -1 | 0;
  $3 = ($4 + $6 | 0) + 140 | 0;
  $6 = 1;
  label$1 : {
   label$2 : while (1) {
    label$3 : {
     if ($1) {
      break label$3
     }
     $7 = $5;
     break label$1;
    }
    $4 = core__slice__cmp___impl_20core__cmp__Ord_20for_20_5bT_5d___cmp__h1f2092e0ba2f27ea($2 | 0, 28 | 0, $3 | 0, 28 | 0) | 0;
    $7 = $7 + 1 | 0;
    $1 = $1 + -28 | 0;
    $3 = $3 + 28 | 0;
    if (($4 & 255 | 0 | 0) == (1 | 0)) {
     continue label$2
    }
    break label$2;
   };
   label$4 : {
    $6 = ($4 << 24 | 0) >> 24 | 0;
    switch ($6 + 1 | 0 | 0) {
    case 1:
     break label$1;
    default:
     break label$4;
    };
   }
   $6 = 1;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $7;
  HEAP32[$0 >> 2] = $6;
 }
 
 function alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__h36882228e88da32b($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $6 = 0, $4 = 0, $7 = 0, $5 = 0;
  $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = HEAPU16[($4 + 138 | 0) >> 1] | 0;
  $6 = Math_imul($3, 28);
  $1 = Math_imul($5, 28) - $6 | 0;
  $7 = $3 + -1 | 0;
  $3 = ($4 + $6 | 0) + 140 | 0;
  $6 = 1;
  label$1 : {
   label$2 : while (1) {
    label$3 : {
     if ($1) {
      break label$3
     }
     $7 = $5;
     break label$1;
    }
    $4 = core__slice__cmp___impl_20core__cmp__Ord_20for_20_5bT_5d___cmp__h1f2092e0ba2f27ea($2 | 0, 28 | 0, $3 | 0, 28 | 0) | 0;
    $7 = $7 + 1 | 0;
    $1 = $1 + -28 | 0;
    $3 = $3 + 28 | 0;
    if (($4 & 255 | 0 | 0) == (1 | 0)) {
     continue label$2
    }
    break label$2;
   };
   label$4 : {
    $6 = ($4 << 24 | 0) >> 24 | 0;
    switch ($6 + 1 | 0 | 0) {
    case 1:
     break label$1;
    default:
     break label$4;
    };
   }
   $6 = 1;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $7;
  HEAP32[$0 >> 2] = $6;
 }
 
 function alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__h3b17f34c380171fa($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $6 = 0, $4 = 0, $7 = 0, $5 = 0;
  $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = HEAPU16[($4 + 6 | 0) >> 1] | 0;
  $6 = Math_imul($3, 28);
  $1 = Math_imul($5, 28) - $6 | 0;
  $7 = $3 + -1 | 0;
  $3 = ($4 + $6 | 0) + 8 | 0;
  $6 = 1;
  label$1 : {
   label$2 : while (1) {
    label$3 : {
     if ($1) {
      break label$3
     }
     $7 = $5;
     break label$1;
    }
    $4 = core__slice__cmp___impl_20core__cmp__Ord_20for_20_5bT_5d___cmp__h1f2092e0ba2f27ea($2 | 0, 28 | 0, $3 | 0, 28 | 0) | 0;
    $7 = $7 + 1 | 0;
    $1 = $1 + -28 | 0;
    $3 = $3 + 28 | 0;
    if (($4 & 255 | 0 | 0) == (1 | 0)) {
     continue label$2
    }
    break label$2;
   };
   label$4 : {
    $6 = ($4 << 24 | 0) >> 24 | 0;
    switch ($6 + 1 | 0 | 0) {
    case 1:
     break label$1;
    default:
     break label$4;
    };
   }
   $6 = 1;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $7;
  HEAP32[$0 >> 2] = $6;
 }
 
 function alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__hb74a59103735e676($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $6 = 0, $4 = 0, $7 = 0, $5 = 0;
  $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = HEAPU16[($4 + 138 | 0) >> 1] | 0;
  $6 = Math_imul($3, 28);
  $1 = Math_imul($5, 28) - $6 | 0;
  $7 = $3 + -1 | 0;
  $3 = ($4 + $6 | 0) + 140 | 0;
  $6 = 1;
  label$1 : {
   label$2 : while (1) {
    label$3 : {
     if ($1) {
      break label$3
     }
     $7 = $5;
     break label$1;
    }
    $4 = core__slice__cmp___impl_20core__cmp__Ord_20for_20_5bT_5d___cmp__h1f2092e0ba2f27ea($2 | 0, 28 | 0, $3 | 0, 28 | 0) | 0;
    $7 = $7 + 1 | 0;
    $1 = $1 + -28 | 0;
    $3 = $3 + 28 | 0;
    if (($4 & 255 | 0 | 0) == (1 | 0)) {
     continue label$2
    }
    break label$2;
   };
   label$4 : {
    $6 = ($4 << 24 | 0) >> 24 | 0;
    switch ($6 + 1 | 0 | 0) {
    case 1:
     break label$1;
    default:
     break label$4;
    };
   }
   $6 = 1;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $7;
  HEAP32[$0 >> 2] = $6;
 }
 
 function transactionbody_validity_start_interval($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, $4$hi = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if (!$1) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h356c30395cf13adb($2 + 16 | 0 | 0, $1 | 0);
    $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
    HEAP32[($2 + 28 | 0) >> 2] = $1;
    $3 = HEAP32[($2 + 16 | 0) >> 2] | 0;
    HEAP32[($2 + 24 | 0) >> 2] = $3;
    label$3 : {
     label$4 : {
      i64toi32_i32$0 = HEAP32[($3 + 112 | 0) >> 2] | 0;
      i64toi32_i32$1 = HEAP32[($3 + 116 | 0) >> 2] | 0;
      $4 = i64toi32_i32$0;
      $4$hi = i64toi32_i32$1;
      if (!!(i64toi32_i32$0 | i64toi32_i32$1 | 0)) {
       break label$4
      }
      $3 = 0;
      break label$3;
     }
     i64toi32_i32$1 = HEAP32[($3 + 120 | 0) >> 2] | 0;
     i64toi32_i32$0 = HEAP32[($3 + 124 | 0) >> 2] | 0;
     cardano_serialization_lib__utils___impl_20core__convert__TryFrom_cardano_serialization_lib__utils__BigNum__20for_20u32___try_from__h480b087dada7bb26($2 + 8 | 0 | 0, i64toi32_i32$1 | 0, i64toi32_i32$0 | 0);
     $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
     if (HEAP32[($2 + 8 | 0) >> 2] | 0) {
      break label$1
     }
    }
    core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
    HEAP32[($0 + 4 | 0) >> 2] = $3;
    i64toi32_i32$0 = $4$hi;
    HEAP32[$0 >> 2] = $4;
    global$0 = $2 + 32 | 0;
    return;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  $wasm_bindgen____rt__Ref_T__20as_20core__ops__drop__Drop___drop__h692d78b609edc7c6($2 + 24 | 0 | 0);
  wasm_bindgen__throw_val__hcf1b5c929d6fa472($3 | 0);
  abort();
 }
 
 function cardano_serialization_lib__Certificate__new_move_instantaneous_rewards_cert__ha7dd5e672abc62f6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $4 = 0, $4$hi = 0, $3 = 0, $15 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  $3 = HEAPU8[($1 + 48 | 0) >> 0] | 0;
  i64toi32_i32$0 = 0;
  $4 = 1;
  $4$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    i64toi32_i32$2 = $1;
    i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    if ((i64toi32_i32$2 | 0) == (1 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
     break label$2
    }
    i64toi32_i32$2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    $15 = i64toi32_i32$2;
    i64toi32_i32$2 = $2;
    HEAP32[($2 + 16 | 0) >> 2] = $15;
    HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    $4 = 0;
    $4$hi = i64toi32_i32$1;
    break label$1;
   }
   $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h7490700a7eed2994(($2 + 8 | 0) + 8 | 0 | 0, $1 + 8 | 0 | 0);
  }
  i64toi32_i32$1 = $4$hi;
  i64toi32_i32$2 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $4;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  memcpy($2 + 64 | 0 | 0, $2 + 8 | 0 | 0, 48 | 0) | 0;
  memcpy($2 + 15 | 0 | 0, $2 + 64 | 0 | 0, 48 | 0) | 0;
  HEAP8[$0 >> 0] = 6;
  memcpy($0 + 1 | 0 | 0, $2 + 8 | 0 | 0, 55 | 0) | 0;
  HEAP8[($0 + 56 | 0) >> 0] = $3;
  global$0 = $2 + 112 | 0;
 }
 
 function ipv6_ip($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $12 = 0, $13 = 0, $5 = 0, $3 = 0, $4 = 0, $25 = 0, $30 = 0, $47 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h9606b27f8e88a40d($2 + 24 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $3 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 + 16 | 0 | 0, 16 | 0, 0 | 0);
  $4 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $5 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $25 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  $12 = $25;
  HEAP8[i64toi32_i32$0 >> 0] = $12;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $30 = i64toi32_i32$1;
  i64toi32_i32$1 = $5 + 8 | 0;
  $13 = $30;
  HEAP8[i64toi32_i32$1 >> 0] = $13;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[($2 + 40 | 0) >> 2] = 16;
  HEAP32[($2 + 36 | 0) >> 2] = $4;
  HEAP32[($2 + 32 | 0) >> 2] = $5;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $47 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $47;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = i64toi32_i32$2 + 48 | 0;
 }
 
 function timelockstart_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $31 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__TimelockStart__from_bytes__h14a276d00223ecc6($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 20 | 0) >> 2] | 0 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $1 = $cardano_serialization_lib__TimelockStart_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h71f9779b79ae2a49(i64toi32_i32$1 | 0, i64toi32_i32$0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function timelockexpiry_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $31 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__TimelockExpiry__from_bytes__hb5c64ca74cc30b66($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 20 | 0) >> 2] | 0 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $1 = $cardano_serialization_lib__TimelockExpiry_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h701c0b7035bdc4b4(i64toi32_i32$1 | 0, i64toi32_i32$0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function nativescript_as_script_all($0) {
  $0 = $0 | 0;
  var $1 = 0, $4 = 0, $2 = 0, $3 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h6ed0b6b043905434($1 + 8 | 0 | 0, $0 | 0);
   $2 = 0;
   $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   $0 = 0;
   label$2 : {
    $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    if ((HEAPU8[$4 >> 0] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($1 + 16 | 0 | 0, HEAP32[($4 + 4 | 0) >> 2] | 0 | 0, HEAP32[($4 + 12 | 0) >> 2] | 0 | 0);
    $0 = HEAP32[($1 + 16 | 0) >> 2] | 0;
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
   label$3 : {
    if (!$0) {
     break label$3
    }
    i64toi32_i32$1 = HEAP32[($1 + 24 | 0) >> 2] | 0;
    HEAP32[($1 + 36 | 0) >> 2] = HEAP32[($1 + 20 | 0) >> 2] | 0;
    HEAP32[($1 + 40 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($1 + 32 | 0) >> 2] = $0;
    $2 = $cardano_serialization_lib__ScriptAll_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hef80bd8099d14009($1 + 32 | 0 | 0) | 0;
   }
   global$0 = $1 + 48 | 0;
   return $2 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function nativescript_as_script_any($0) {
  $0 = $0 | 0;
  var $1 = 0, $4 = 0, $2 = 0, $3 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h6ed0b6b043905434($1 + 8 | 0 | 0, $0 | 0);
   $2 = 0;
   $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   $0 = 0;
   label$2 : {
    $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    if ((HEAPU8[$4 >> 0] | 0 | 0) != (2 | 0)) {
     break label$2
    }
    alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($1 + 16 | 0 | 0, HEAP32[($4 + 4 | 0) >> 2] | 0 | 0, HEAP32[($4 + 12 | 0) >> 2] | 0 | 0);
    $0 = HEAP32[($1 + 16 | 0) >> 2] | 0;
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
   label$3 : {
    if (!$0) {
     break label$3
    }
    i64toi32_i32$1 = HEAP32[($1 + 24 | 0) >> 2] | 0;
    HEAP32[($1 + 36 | 0) >> 2] = HEAP32[($1 + 20 | 0) >> 2] | 0;
    HEAP32[($1 + 40 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($1 + 32 | 0) >> 2] = $0;
    $2 = $cardano_serialization_lib__ScriptAny_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hee8cbd3c8c833493($1 + 32 | 0 | 0) | 0;
   }
   global$0 = $1 + 48 | 0;
   return $2 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function bignum_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $31 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 16 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 32 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 48 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 36 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $31;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__utils__BigNum__from_bytes__h6da2ace6f7be6864($2 + 16 | 0 | 0, $2 + 48 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 20 | 0) >> 2] | 0 | 0);
   abort();
  }
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $1 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810(i64toi32_i32$1 | 0, i64toi32_i32$0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function transactionmetadatum_new_map($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 112 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h74f2437fd791f127($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__hdeea20968268d729($1 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
  memcpy(($1 + 64 | 0) + 4 | 0 | 0, $1 + 16 | 0 | 0, 40 | 0) | 0;
  memcpy($1 + 16 | 0 | 0, $1 + 64 | 0 | 0, 44 | 0) | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[($1 + 64 | 0) >> 2] = 0;
  memcpy($1 + 64 | 0 | 4 | 0 | 0, $1 + 16 | 0 | 0, 44 | 0) | 0;
  $0 = $cardano_serialization_lib__metadata__TransactionMetadatum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hce2feba55b67d086($1 + 64 | 0 | 0) | 0;
  global$0 = $1 + 112 | 0;
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__chain_crypto__algorithms__ed25519_extended__Ed25519Extended_20as_20cardano_serialization_lib__chain_crypto__key__AsymmetricKey___generate__h9fbbb0ee2f5762c3($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 304 | 0;
  global$0 = $3;
  HEAP32[($3 + 12 | 0) >> 2] = $2;
  HEAP32[($3 + 8 | 0) >> 2] = $1;
  memset($3 + 16 | 0 | 0, 0 | 0, 96 | 0) | 0;
  $rand_os__OsRng_20as_20rand_core__RngCore___fill_bytes__h6a20d3c9ee8171ca($3 + 8 | 0 | 0, $3 + 16 | 0 | 0, 96 | 0);
  memcpy($3 + 208 | 0 | 0, $3 + 16 | 0 | 0, 96 | 0) | 0;
  ed25519_bip32__key__XPrv__normalize_bytes_force3rd__hc83616bc3d9dd3b6($3 + 112 | 0 | 0, $3 + 208 | 0 | 0);
  memset($3 + 208 | 0 | 0, 0 | 0, 64 | 0) | 0;
  ed25519_bip32__key__XPrv__get_extended_mut__h396b8224008dfa18($3 + 112 | 0 | 0, $3 + 208 | 0 | 0);
  memcpy($0 | 0, $3 + 208 | 0 | 0, 64 | 0) | 0;
  $ed25519_bip32__key__XPrv_20as_20core__ops__drop__Drop___drop__h041b586f91562314($3 + 112 | 0 | 0);
  core__ptr__drop_in_place_rand_os__OsRng___hfc4c0aad05eeb2e1($3 + 8 | 0 | 0);
  global$0 = $3 + 304 | 0;
 }
 
 function transactionbuilder_add_metadatum($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, $5 = 0, $6 = 0;
  $3 = global$0 - 32 | 0;
  global$0 = $3;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h5566e1c7d4aafe35($3 + 24 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $4 = HEAP32[($3 + 28 | 0) >> 2] | 0;
   $5 = HEAP32[($3 + 24 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($3 + 16 | 0 | 0, $1 | 0);
   if (!$2) {
    break label$1
   }
   $0 = HEAP32[($3 + 20 | 0) >> 2] | 0;
   $6 = HEAP32[($3 + 16 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hc630c86c4ab6b26d($3 + 8 | 0 | 0, $2 | 0);
   $1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
   cardano_serialization_lib__tx_builder__TransactionBuilder__add_metadatum__hc8424e4cee001d9e($5 | 0, $6 | 0, HEAP32[($3 + 8 | 0) >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($4 | 0, 0 | 0) | 0;
   global$0 = $3 + 32 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h614c9de21e58255d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $5 = 0, i64toi32_i32$0 = 0, $3 = 0, $4 = 0, $6 = 0, $7 = 0, $7$hi = 0, $37 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $3 = HEAP32[$1 >> 2] | 0;
  $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h404b2b8ae2314e41($2 + 8 | 0 | 0, $4 | 0, 0 | 0);
  $1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  $5 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $5;
  HEAP32[$0 >> 2] = $1;
  label$1 : {
   if (!$5) {
    break label$1
   }
   $6 = $4 << 4 | 0;
   label$2 : while (1) {
    if (!$6) {
     break label$1
    }
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $7 = i64toi32_i32$0;
    $7$hi = i64toi32_i32$1;
    i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $37 = i64toi32_i32$1;
    i64toi32_i32$1 = $1;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $37;
    HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = $7$hi;
    HEAP32[i64toi32_i32$1 >> 2] = $7;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    $1 = i64toi32_i32$1 + 16 | 0;
    $6 = $6 + -16 | 0;
    $3 = $3 + 16 | 0;
    $5 = $5 + -1 | 0;
    if ($5) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 8 | 0) >> 2] = $4;
  global$0 = $2 + 16 | 0;
 }
 
 function plutuswitness_redeemer($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $4 = 0, $4$hi = 0, $2 = 0, $27 = 0, $34 = 0;
  $1 = global$0 - 176 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hbec83ebdd86caafd($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($0 + 48 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($0 + 52 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$1;
  $2 = HEAPU8[($0 + 120 | 0) >> 0] | 0;
  $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $cardano_serialization_lib__plutus__PlutusData_20as_20core__clone__Clone___clone__h63d1a98cc18f4609_1($1 + 24 | 0 | 0, $0 + 56 | 0 | 0);
  i64toi32_i32$1 = HEAP32[($0 + 112 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($0 + 116 | 0) >> 2] | 0;
  $27 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 80 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $27;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP8[($1 + 88 | 0) >> 0] = $2;
  i64toi32_i32$0 = $4$hi;
  i64toi32_i32$1 = $1;
  HEAP32[($1 + 16 | 0) >> 2] = $4;
  HEAP32[($1 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[($0 + 104 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($0 + 108 | 0) >> 2] | 0;
  $34 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 72 | 0) >> 2] = $34;
  HEAP32[($1 + 76 | 0) >> 2] = i64toi32_i32$1;
  core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
  memcpy($1 + 96 | 0 | 0, $1 + 16 | 0 | 0, 80 | 0) | 0;
  $0 = $cardano_serialization_lib__plutus__Redeemer_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he2ca0b82950da3f7($1 + 96 | 0 | 0) | 0;
  global$0 = $1 + 176 | 0;
  return $0 | 0;
 }
 
 function serde_json__de__Deserializer_R___parse_exponent_overflow__hfb467b8d7cf5b1c5($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, $6 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $5 = global$0 - 16 | 0;
  global$0 = $5;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      if ($3) {
       break label$4
      }
      if ($4) {
       break label$3
      }
     }
     $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     if ($3 >>> 0 >= $4 >>> 0) {
      break label$2
     }
     $6 = HEAP32[$1 >> 2] | 0;
     label$5 : while (1) {
      if ((((HEAPU8[($6 + $3 | 0) >> 0] | 0) + -48 | 0) & 255 | 0) >>> 0 >= 10 >>> 0) {
       break label$2
      }
      $3 = $3 + 1 | 0;
      HEAP32[($1 + 8 | 0) >> 2] = $3;
      if (($4 | 0) != ($3 | 0)) {
       continue label$5
      }
      break label$2;
     };
    }
    HEAP32[$5 >> 2] = 13;
    (wasm2js_i32$0 = $0, wasm2js_i32$1 = serde_json__de__Deserializer_R___error__h438ab94fbb97beef($1 | 0, $5 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
    $3 = 1;
    break label$1;
   }
   HEAPF64[($0 + 8 | 0) >> 3] = $2 ? 0.0 : -0.0;
   $3 = 0;
  }
  HEAP32[$0 >> 2] = $3;
  global$0 = $5 + 16 | 0;
 }
 
 function cryptoxide__hmac__create_keys__hb120d19dc48fb687($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $40 = 0, $43 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  cryptoxide__hmac__expand_key__hfd815745270a99ae($4 + 16 | 0 | 0, $1 | 0, $2 | 0, $3 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($4 + 32 | 0 | 0, $4 + 16 | 0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__DerefMut___deref_mut__h1882e042320a120c($4 + 8 | 0 | 0, $4 + 16 | 0 | 0);
  cryptoxide__hmac__derive_key__h8cbec42a702c5a3a(HEAP32[($4 + 8 | 0) >> 2] | 0 | 0, HEAP32[($4 + 12 | 0) >> 2] | 0 | 0, 54 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__DerefMut___deref_mut__h1882e042320a120c($4 | 0, $4 + 32 | 0 | 0);
  cryptoxide__hmac__derive_key__h8cbec42a702c5a3a(HEAP32[$4 >> 2] | 0 | 0, HEAP32[($4 + 4 | 0) >> 2] | 0 | 0, 92 | 0);
  HEAP32[($0 + 8 | 0) >> 2] = HEAP32[(($4 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($4 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($4 + 20 | 0) >> 2] | 0;
  $40 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $40;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[($4 + 32 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($4 + 36 | 0) >> 2] | 0;
  $43 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = $43;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = HEAP32[(($4 + 32 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $4 + 48 | 0;
 }
 
 function core__fmt__num___impl_20core__fmt__LowerHex_20for_20i64___fmt__h68614c2d2fa4b444($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, $2 = 0, i64toi32_i32$2 = 0, $4 = 0, i64toi32_i32$3 = 0, $3 = 0, $4$hi = 0, $11 = 0;
  $2 = global$0 - 128 | 0;
  global$0 = $2;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[$0 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$1;
  $0 = 128;
  label$1 : {
   label$2 : while (1) {
    label$3 : {
     if ($0) {
      break label$3
     }
     $0 = 0;
     break label$1;
    }
    i64toi32_i32$1 = $4$hi;
    $3 = $4 & 15 | 0;
    HEAP8[(($2 + $0 | 0) + -1 | 0) >> 0] = $3 >>> 0 < 10 >>> 0 ? $3 | 48 | 0 : $3 + 87 | 0;
    $0 = $0 + -1 | 0;
    i64toi32_i32$2 = $4;
    i64toi32_i32$0 = 0;
    i64toi32_i32$3 = 4;
    i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$0 = 0;
     $11 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
    } else {
     i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
     $11 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
    }
    $4 = $11;
    $4$hi = i64toi32_i32$0;
    i64toi32_i32$1 = $4;
    i64toi32_i32$2 = 0;
    i64toi32_i32$3 = 0;
    if ((i64toi32_i32$1 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$2 | 0) | 0) {
     continue label$2
    }
    break label$2;
   };
   if ($0 >>> 0 < 129 >>> 0) {
    break label$1
   }
   core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($0 | 0, 128 | 0, 1150164 | 0);
   abort();
  }
  $0 = core__fmt__Formatter__pad_integral__h08e3e53a0de517a1($1 | 0, 1 | 0, 1150180 | 0, 2 | 0, $2 + $0 | 0 | 0, 128 - $0 | 0 | 0) | 0;
  global$0 = $2 + 128 | 0;
  return $0 | 0;
 }
 
 function core__fmt__num___impl_20core__fmt__UpperHex_20for_20i64___fmt__h5a4e72e53e968338($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, $2 = 0, i64toi32_i32$2 = 0, $4 = 0, i64toi32_i32$3 = 0, $3 = 0, $4$hi = 0, $11 = 0;
  $2 = global$0 - 128 | 0;
  global$0 = $2;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[$0 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$1;
  $0 = 128;
  label$1 : {
   label$2 : while (1) {
    label$3 : {
     if ($0) {
      break label$3
     }
     $0 = 0;
     break label$1;
    }
    i64toi32_i32$1 = $4$hi;
    $3 = $4 & 15 | 0;
    HEAP8[(($2 + $0 | 0) + -1 | 0) >> 0] = $3 >>> 0 < 10 >>> 0 ? $3 | 48 | 0 : $3 + 55 | 0;
    $0 = $0 + -1 | 0;
    i64toi32_i32$2 = $4;
    i64toi32_i32$0 = 0;
    i64toi32_i32$3 = 4;
    i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$0 = 0;
     $11 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
    } else {
     i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
     $11 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
    }
    $4 = $11;
    $4$hi = i64toi32_i32$0;
    i64toi32_i32$1 = $4;
    i64toi32_i32$2 = 0;
    i64toi32_i32$3 = 0;
    if ((i64toi32_i32$1 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$2 | 0) | 0) {
     continue label$2
    }
    break label$2;
   };
   if ($0 >>> 0 < 129 >>> 0) {
    break label$1
   }
   core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($0 | 0, 128 | 0, 1150164 | 0);
   abort();
  }
  $0 = core__fmt__Formatter__pad_integral__h08e3e53a0de517a1($1 | 0, 1 | 0, 1150180 | 0, 2 | 0, $2 + $0 | 0 | 0, 128 - $0 | 0 | 0) | 0;
  global$0 = $2 + 128 | 0;
  return $0 | 0;
 }
 
 function alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal___push__h6e96e9816acb473b($0, $1, $2, $2$hi, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $5 = 0, $38 = 0;
  label$1 : {
   label$2 : {
    if (((HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) != ($3 | 0)) {
     break label$2
    }
    $0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    $3 = HEAPU16[($0 + 226 | 0) >> 1] | 0;
    if ($3 >>> 0 <= 10 >>> 0) {
     break label$1
    }
    core__panicking__panic__h2fd385a887c8bf13(1048619 | 0, 32 | 0, 1048824 | 0);
    abort();
   }
   core__panicking__panic__h2fd385a887c8bf13(1048760 | 0, 48 | 0, 1048808 | 0);
   abort();
  }
  $5 = $3 + 1 | 0;
  HEAP16[($0 + 226 | 0) >> 1] = $5;
  i64toi32_i32$0 = $2$hi;
  i64toi32_i32$1 = $0 + ($3 << 3 | 0) | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $2;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $3 = $0 + Math_imul($3, 12) | 0;
  HEAP32[($3 + 100 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $38 = i64toi32_i32$0;
  i64toi32_i32$0 = $3 + 92 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $38;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(($0 + ($5 << 2 | 0) | 0) + 232 | 0) >> 2] = $4;
  HEAP16[($4 + 224 | 0) >> 1] = $5;
  HEAP32[($4 + 88 | 0) >> 2] = $0;
 }
 
 function transactionwitnessset_set_vkeys($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h1cc4e67284701531($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h2c8b1c7122d0d2b0($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h26733a351c1d0f0b($2 + 16 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0);
   label$2 : {
    if (!(HEAP32[$0 >> 2] | 0)) {
     break label$2
    }
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hdd0c057252922c46($0 | 0);
   }
   i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   HEAP32[$0 >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
   HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($0 + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 32 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function networkid_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, $3 = 0, $3$hi = 0, $11 = 0, $12 = 0, $32 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  HEAP32[($2 + 40 | 0) >> 2] = $1;
  HEAP32[($2 + 36 | 0) >> 2] = $1;
  HEAP32[($2 + 32 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 32 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $32 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $32;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   i64toi32_i32$1 = cardano_serialization_lib__NetworkId__from_bytes__h178037d1c177e3ad($2 + 32 | 0 | 0) | 0;
   i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
   $3 = i64toi32_i32$1;
   $3$hi = i64toi32_i32$0;
   i64toi32_i32$2 = i64toi32_i32$1;
   i64toi32_i32$1 = 0;
   i64toi32_i32$3 = 1;
   i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
   if (!(i64toi32_i32$2 & i64toi32_i32$3 | 0 | i64toi32_i32$1 | 0)) {
    break label$1
   }
   i64toi32_i32$1 = $3$hi;
   i64toi32_i32$0 = $3;
   i64toi32_i32$2 = 0;
   i64toi32_i32$3 = 32;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$2 = 0;
    $11 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   } else {
    i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
    $11 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($11 | 0);
   abort();
  }
  i64toi32_i32$2 = $3$hi;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 256;
  i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 8;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $12 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $12 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  $1 = $cardano_serialization_lib__NetworkId_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hf6f78a05c9fd49e7($12 | 0) | 0;
  global$0 = $2 + 48 | 0;
  return $1 | 0;
 }
 
 function cardano_serialization_lib__chain_crypto__key__PublicKey_A___from_binary__he9697ecf8c279d37($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $5 = 0, $6 = 0, $7 = 0, $4 = 0;
  $3 = global$0 - 144 | 0;
  global$0 = $3;
  ed25519_bip32__key__XPub__from_slice__hd93ec341c444a89b($3 + 72 | 0 | 0, $1 | 0, $2 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAPU8[($3 + 72 | 0) >> 0] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $2 = HEAPU8[($3 + 73 | 0) >> 0] | 0;
    $1 = HEAPU16[($3 + 74 | 0) >> 1] | 0;
    $4 = HEAP32[($3 + 76 | 0) >> 2] | 0;
    memcpy($3 + 12 | 0 | 0, ($3 + 72 | 0) + 8 | 0 | 0, 57 | 0) | 0;
    memcpy($0 + 8 | 0 | 0, $3 + 12 | 0 | 0, 57 | 0) | 0;
    $5 = $0 + 4 | 0;
    $6 = $4;
    HEAP8[$5 >> 0] = $6;
    HEAP8[($5 + 1 | 0) >> 0] = $6 >>> 8 | 0;
    HEAP8[($5 + 2 | 0) >> 0] = $6 >>> 16 | 0;
    HEAP8[($5 + 3 | 0) >> 0] = $6 >>> 24 | 0;
    $7 = $0 + 2 | 0;
    HEAP8[$7 >> 0] = $1;
    HEAP8[($7 + 1 | 0) >> 0] = $1 >>> 8 | 0;
    $1 = 0;
    break label$1;
   }
   $2 = 0;
  }
  HEAP8[$0 >> 0] = $1;
  HEAP8[($0 + 1 | 0) >> 0] = $2;
  global$0 = $3 + 144 | 0;
 }
 
 function min_fee($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$2 = 0, $3 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h70df86682e940485($2 + 8 | 0 | 0, $0 | 0);
    if (!$1) {
     break label$2
    }
    $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    wasm_bindgen____rt__WasmRefCell_T___borrow__haac84d0387ff0446($2 | 0, $1 | 0);
    $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
    cardano_serialization_lib__fees__min_fee__hf0827db8ce69035c($2 + 16 | 0 | 0, $3 | 0, HEAP32[$2 >> 2] | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    i64toi32_i32$2 = $2 + 24 | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810(HEAP32[i64toi32_i32$2 >> 2] | 0 | 0, i64toi32_i32$1 | 0) | 0;
    global$0 = $2 + 32 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 20 | 0) >> 2] | 0 | 0);
  abort();
 }
 
 function calculate_ex_units_ceil_cost($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$2 = 0, $3 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h1f4aa39af4dc2942($2 + 8 | 0 | 0, $0 | 0);
    if (!$1) {
     break label$2
    }
    $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    wasm_bindgen____rt__WasmRefCell_T___borrow__h0a3b5f1cc5dc7523($2 | 0, $1 | 0);
    $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
    cardano_serialization_lib__fees__calculate_ex_units_ceil_cost__hd623ac7a5f7d8d0f($2 + 16 | 0 | 0, $3 | 0, HEAP32[$2 >> 2] | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    i64toi32_i32$2 = $2 + 24 | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810(HEAP32[i64toi32_i32$2 >> 2] | 0 | 0, i64toi32_i32$1 | 0) | 0;
    global$0 = $2 + 32 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 20 | 0) >> 2] | 0 | 0);
  abort();
 }
 
 function min_script_fee($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$2 = 0, $3 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h70df86682e940485($2 + 8 | 0 | 0, $0 | 0);
    if (!$1) {
     break label$2
    }
    $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    wasm_bindgen____rt__WasmRefCell_T___borrow__h0a3b5f1cc5dc7523($2 | 0, $1 | 0);
    $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
    cardano_serialization_lib__fees__min_script_fee__h862c5f4fcf338926($2 + 16 | 0 | 0, $3 | 0, HEAP32[$2 >> 2] | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    i64toi32_i32$2 = $2 + 24 | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810(HEAP32[i64toi32_i32$2 >> 2] | 0 | 0, i64toi32_i32$1 | 0) | 0;
    global$0 = $2 + 32 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 20 | 0) >> 2] | 0 | 0);
  abort();
 }
 
 function transactionbuilder_fee_for_output($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$2 = 0, $3 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h37dfbd2f31d951c1($2 + 8 | 0 | 0, $0 | 0);
    if (!$1) {
     break label$2
    }
    $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    wasm_bindgen____rt__WasmRefCell_T___borrow__h17af7d9d2d20aa0f($2 | 0, $1 | 0);
    $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
    cardano_serialization_lib__tx_builder__TransactionBuilder__fee_for_output__h1f6d4a08a7683cf9($2 + 16 | 0 | 0, $3 | 0, HEAP32[$2 >> 2] | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    i64toi32_i32$2 = $2 + 24 | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810(HEAP32[i64toi32_i32$2 >> 2] | 0 | 0, i64toi32_i32$1 | 0) | 0;
    global$0 = $2 + 32 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 20 | 0) >> 2] | 0 | 0);
  abort();
 }
 
 function cardano_serialization_lib__tx_builder__TransactionBuilder__add_json_metadatum_with_schema__h378f72e2b00e53e2($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, i64toi32_i32$1 = 0;
  $5 = global$0 - 128 | 0;
  global$0 = $5;
  HEAP32[(($5 + 112 | 0) + 8 | 0) >> 2] = HEAP32[($3 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($3 + 4 | 0) >> 2] | 0;
  HEAP32[($5 + 112 | 0) >> 2] = HEAP32[$3 >> 2] | 0;
  HEAP32[($5 + 116 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__metadata__encode_json_str_to_metadatum__h4a5979815eae04ac($5 + 56 | 0 | 0, $5 + 112 | 0 | 0, $4 | 0);
  $3 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($5 + 56 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    memcpy($5 + 8 | 0 | 0, ($5 + 56 | 0) + 8 | 0 | 0, 48 | 0) | 0;
    cardano_serialization_lib__tx_builder__TransactionBuilder__add_metadatum__hc8424e4cee001d9e($1 | 0, $2 | 0, $5 + 8 | 0 | 0);
    core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatum___headd2d1b596252cc_1($5 + 8 | 0 | 0);
    $3 = 0;
    break label$1;
   }
   $4 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($5 + 60 | 0) >> 2] | 0 | 0) | 0;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $4;
  HEAP32[$0 >> 2] = $3;
  global$0 = $5 + 128 | 0;
 }
 
 function cardano_serialization_lib__crypto__Bip32PrivateKey__chaincode__h32cbffafab5e64aa($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $11 = 0, $12 = 0, $13 = 0, $14 = 0, $3 = 0, $27 = 0, $32 = 0, $37 = 0, $42 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $ed25519_bip32__key__XPrv_20as_20core__convert__AsRef__5bu8_5d____as_ref__h44c8f06901e0335a($2 + 8 | 0 | 0, $1 | 0);
  label$1 : {
   $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   if ($1 >>> 0 > 95 >>> 0) {
    break label$1
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345(96 | 0, $1 | 0, 1066532 | 0);
   abort();
  }
  $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 32 | 0, 0 | 0);
  $1 = HEAP32[$2 >> 2] | 0;
  HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($2 + 4 | 0) >> 2] | 0;
  HEAP32[$0 >> 2] = $1;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 64 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 65 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 66 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 67 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 68 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 69 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 70 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 71 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $27 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  $11 = $27;
  HEAP8[i64toi32_i32$0 >> 0] = $11;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 72 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $32 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 8 | 0;
  $12 = $32;
  HEAP8[i64toi32_i32$1 >> 0] = $12;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $3 + 80 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $37 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 16 | 0;
  $13 = $37;
  HEAP8[i64toi32_i32$0 >> 0] = $13;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $3 + 88 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $42 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 24 | 0;
  $14 = $42;
  HEAP8[i64toi32_i32$1 >> 0] = $14;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $14 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $14 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $14 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP32[($0 + 8 | 0) >> 2] = 32;
  global$0 = $2 + 16 | 0;
 }
 
 function cardano_serialization_lib__crypto__Bip32PublicKey__chaincode__h7bf6aed92ab50cb8($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $11 = 0, $12 = 0, $13 = 0, $14 = 0, $3 = 0, $27 = 0, $32 = 0, $37 = 0, $42 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $ed25519_bip32__key__XPub_20as_20core__convert__AsRef__5bu8_5d____as_ref__h69a664c2b5ee8b25($2 + 8 | 0 | 0, $1 | 0);
  label$1 : {
   $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   if ($1 >>> 0 > 63 >>> 0) {
    break label$1
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345(64 | 0, $1 | 0, 1066548 | 0);
   abort();
  }
  $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 32 | 0, 0 | 0);
  $1 = HEAP32[$2 >> 2] | 0;
  HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($2 + 4 | 0) >> 2] | 0;
  HEAP32[$0 >> 2] = $1;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 32 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 33 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 34 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 35 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 36 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 37 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 38 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 39 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $27 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  $11 = $27;
  HEAP8[i64toi32_i32$0 >> 0] = $11;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 40 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $32 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 8 | 0;
  $12 = $32;
  HEAP8[i64toi32_i32$1 >> 0] = $12;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $3 + 48 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $37 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 16 | 0;
  $13 = $37;
  HEAP8[i64toi32_i32$0 >> 0] = $13;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $3 + 56 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $42 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 24 | 0;
  $14 = $42;
  HEAP8[i64toi32_i32$1 >> 0] = $14;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $14 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $14 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $14 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP32[($0 + 8 | 0) >> 2] = 32;
  global$0 = $2 + 16 | 0;
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___insert__h1d253d1db198de85($0, $1, $2, $3, $3$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  var i64toi32_i32$0 = 0, $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $24 = 0, $27 = 0, $5 = 0, $5$hi = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  alloc__collections__btree__map__BTreeMap_K_2cV___entry__hd9178590dbb7d8f1($4 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$4 >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    HEAP32[($4 + 40 | 0) >> 2] = HEAP32[($4 + 20 | 0) >> 2] | 0;
    i64toi32_i32$2 = $4 + 12 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $24 = i64toi32_i32$0;
    i64toi32_i32$0 = $4 + 32 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $24;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $4;
    i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($4 + 8 | 0) >> 2] | 0;
    $27 = i64toi32_i32$1;
    i64toi32_i32$1 = $4;
    HEAP32[($4 + 24 | 0) >> 2] = $27;
    HEAP32[($4 + 28 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = $3$hi;
    alloc__collections__btree__map__entry__VacantEntry_K_2cV___insert__hbbb75728b458380d($4 + 24 | 0 | 0, $3 | 0, i64toi32_i32$0 | 0) | 0;
    i64toi32_i32$0 = 0;
    $3 = 0;
    $3$hi = i64toi32_i32$0;
    break label$1;
   }
   $1 = (HEAP32[($4 + 8 | 0) >> 2] | 0) + ((HEAP32[($4 + 12 | 0) >> 2] | 0) << 3 | 0) | 0;
   i64toi32_i32$2 = $1;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $5 = i64toi32_i32$0;
   $5$hi = i64toi32_i32$1;
   i64toi32_i32$1 = $3$hi;
   i64toi32_i32$0 = i64toi32_i32$2;
   HEAP32[i64toi32_i32$0 >> 2] = $3;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = 0;
   $3 = 1;
   $3$hi = i64toi32_i32$1;
  }
  i64toi32_i32$1 = $5$hi;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $5;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $3$hi;
  HEAP32[i64toi32_i32$0 >> 2] = $3;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $4 + 48 | 0;
 }
 
 function baseaddress_from_address($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 144 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hab2c0cbdcb539b91($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   cardano_serialization_lib__address__BaseAddress__from_address__h3190075870a36e33($1 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   $0 = 0;
   label$2 : {
    $2 = HEAPU8[($1 + 17 | 0) >> 0] | 0;
    if (($2 | 0) == (2 | 0)) {
     break label$2
    }
    $0 = HEAPU8[($1 + 16 | 0) >> 0] | 0;
    HEAP8[($1 + 81 | 0) >> 0] = $2;
    HEAP8[($1 + 80 | 0) >> 0] = $0;
    memcpy($1 + 80 | 0 | 2 | 0 | 0, $1 + 16 | 0 | 2 | 0 | 0, 57 | 0) | 0;
    $0 = $cardano_serialization_lib__address__BaseAddress_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h9cfaf9e675023555($1 + 80 | 0 | 0) | 0;
   }
   global$0 = $1 + 144 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function constrplutusdata_data($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $38 = 0, $41 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h2f574964f7dad662($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hc831120dea694494($1 + 16 | 0 | 0, $2 + 8 | 0 | 0);
  $2 = HEAPU8[($2 + 20 | 0) >> 0] | 0;
  HEAP8[($1 + 28 | 0) >> 0] = ($2 | 0) == (2 | 0) ? 2 : ($2 | 0) != (0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = ($1 + 16 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $38 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 32 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $38;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[($1 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  $41 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[($1 + 32 | 0) >> 2] = $41;
  HEAP32[($1 + 36 | 0) >> 2] = i64toi32_i32$0;
  $0 = $cardano_serialization_lib__plutus__PlutusList_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h9a3fe5bcf5e2cc3a($1 + 32 | 0 | 0) | 0;
  global$0 = $1 + 48 | 0;
  return $0 | 0;
 }
 
 function cryptoxide__ed25519__extended_secret__hc92aa93a99de055a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 432 | 0;
  global$0 = $2;
  $3 = memset($2 + 296 | 0 | 0, 0 | 0, 132 | 0) | 0;
  $4 = memcpy(($2 + 216 | 0) + 16 | 0 | 0, 1137368 | 0, 64 | 0) | 0;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 224 | 0) >> 2] = 0;
  HEAP32[($2 + 228 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 216 | 0) >> 2] = 32;
  HEAP32[($2 + 220 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[$2 >> 2] = $4;
  cryptoxide__cryptoutil__FixedBuffer_____input__h45eb77880e071f02($3 | 0, $1 | 0, 32 | 0, $2 | 0);
  $1 = memcpy($2 | 0, $2 + 216 | 0 | 0, 216 | 0) | 0;
  $2 = memset($0 | 0, 0 | 0, 64 | 0) | 0;
  cryptoxide__hashing__sha2__Engine512__finish__h18b5152b4b76c624($1 | 0);
  cryptoxide__cryptoutil__write_u64v_be__h6888df4c897d2bb4($2 | 0, 64 | 0, $1 + 16 | 0 | 0, 8 | 0);
  HEAP8[$2 >> 0] = (HEAPU8[$2 >> 0] | 0) & 248 | 0;
  HEAP8[($2 + 31 | 0) >> 0] = (HEAPU8[($2 + 31 | 0) >> 0] | 0) & 63 | 0 | 64 | 0;
  global$0 = $1 + 432 | 0;
 }
 
 function alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__hfa0487299a0eb2b6($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $6 = 0, $4 = 0, $7 = 0, $5 = 0;
  $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = HEAPU16[($4 + 226 | 0) >> 1] | 0;
  $6 = Math_imul($3, 12);
  $1 = Math_imul($5, 12) - $6 | 0;
  $7 = $3 + -1 | 0;
  $3 = ($4 + $6 | 0) + 92 | 0;
  $6 = 1;
  label$1 : {
   label$2 : while (1) {
    label$3 : {
     if ($1) {
      break label$3
     }
     $7 = $5;
     break label$1;
    }
    $7 = $7 + 1 | 0;
    $1 = $1 + -12 | 0;
    $4 = $cardano_serialization_lib__AssetName_20as_20core__cmp__Ord___cmp__h38864a982a475878($2 | 0, $3 | 0) | 0;
    $3 = $3 + 12 | 0;
    if (($4 & 255 | 0 | 0) == (1 | 0)) {
     continue label$2
    }
    break label$2;
   };
   label$4 : {
    $6 = ($4 << 24 | 0) >> 24 | 0;
    switch ($6 + 1 | 0 | 0) {
    case 1:
     break label$1;
    default:
     break label$4;
    };
   }
   $6 = 1;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $7;
  HEAP32[$0 >> 2] = $6;
 }
 
 function alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__h2a96d0c76ba9da6b($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $6 = 0, $4 = 0, $7 = 0, $5 = 0;
  $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = HEAPU16[($4 + 314 | 0) >> 1] | 0;
  $6 = Math_imul($3, 12);
  $1 = Math_imul($5, 12) - $6 | 0;
  $7 = $3 + -1 | 0;
  $3 = ($4 + $6 | 0) + 180 | 0;
  $6 = 1;
  label$1 : {
   label$2 : while (1) {
    label$3 : {
     if ($1) {
      break label$3
     }
     $7 = $5;
     break label$1;
    }
    $7 = $7 + 1 | 0;
    $1 = $1 + -12 | 0;
    $4 = $cardano_serialization_lib__AssetName_20as_20core__cmp__Ord___cmp__h38864a982a475878($2 | 0, $3 | 0) | 0;
    $3 = $3 + 12 | 0;
    if (($4 & 255 | 0 | 0) == (1 | 0)) {
     continue label$2
    }
    break label$2;
   };
   label$4 : {
    $6 = ($4 << 24 | 0) >> 24 | 0;
    switch ($6 + 1 | 0 | 0) {
    case 1:
     break label$1;
    default:
     break label$4;
    };
   }
   $6 = 1;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $7;
  HEAP32[$0 >> 2] = $6;
 }
 
 function alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__h764a533569784781($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $6 = 0, $4 = 0, $7 = 0, $5 = 0;
  $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = HEAPU16[($4 + 314 | 0) >> 1] | 0;
  $6 = Math_imul($3, 12);
  $1 = Math_imul($5, 12) - $6 | 0;
  $7 = $3 + -1 | 0;
  $3 = ($4 + $6 | 0) + 180 | 0;
  $6 = 1;
  label$1 : {
   label$2 : while (1) {
    label$3 : {
     if ($1) {
      break label$3
     }
     $7 = $5;
     break label$1;
    }
    $7 = $7 + 1 | 0;
    $1 = $1 + -12 | 0;
    $4 = $cardano_serialization_lib__AssetName_20as_20core__cmp__Ord___cmp__h38864a982a475878($2 | 0, $3 | 0) | 0;
    $3 = $3 + 12 | 0;
    if (($4 & 255 | 0 | 0) == (1 | 0)) {
     continue label$2
    }
    break label$2;
   };
   label$4 : {
    $6 = ($4 << 24 | 0) >> 24 | 0;
    switch ($6 + 1 | 0 | 0) {
    case 1:
     break label$1;
    default:
     break label$4;
    };
   }
   $6 = 1;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $7;
  HEAP32[$0 >> 2] = $6;
 }
 
 function alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__hdf3d9c2a56594c01($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $6 = 0, $4 = 0, $7 = 0, $5 = 0;
  $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = HEAPU16[($4 + 226 | 0) >> 1] | 0;
  $6 = Math_imul($3, 12);
  $1 = Math_imul($5, 12) - $6 | 0;
  $7 = $3 + -1 | 0;
  $3 = ($4 + $6 | 0) + 92 | 0;
  $6 = 1;
  label$1 : {
   label$2 : while (1) {
    label$3 : {
     if ($1) {
      break label$3
     }
     $7 = $5;
     break label$1;
    }
    $7 = $7 + 1 | 0;
    $1 = $1 + -12 | 0;
    $4 = $cardano_serialization_lib__AssetName_20as_20core__cmp__Ord___cmp__h38864a982a475878($2 | 0, $3 | 0) | 0;
    $3 = $3 + 12 | 0;
    if (($4 & 255 | 0 | 0) == (1 | 0)) {
     continue label$2
    }
    break label$2;
   };
   label$4 : {
    $6 = ($4 << 24 | 0) >> 24 | 0;
    switch ($6 + 1 | 0 | 0) {
    case 1:
     break label$1;
    default:
     break label$4;
    };
   }
   $6 = 1;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $7;
  HEAP32[$0 >> 2] = $6;
 }
 
 function transactionbody_ttl($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $4 = 0, $5 = 0, $5$hi = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if (!$1) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h356c30395cf13adb($2 + 16 | 0 | 0, $1 | 0);
    $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
    HEAP32[($2 + 28 | 0) >> 2] = $1;
    $3 = HEAP32[($2 + 16 | 0) >> 2] | 0;
    HEAP32[($2 + 24 | 0) >> 2] = $3;
    $4 = 0;
    label$3 : {
     i64toi32_i32$2 = $3;
     i64toi32_i32$0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
     $5 = i64toi32_i32$0;
     $5$hi = i64toi32_i32$1;
     i64toi32_i32$2 = i64toi32_i32$0;
     i64toi32_i32$0 = 0;
     if ((i64toi32_i32$2 | 0) != (1 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$0 | 0) | 0) {
      break label$3
     }
     i64toi32_i32$2 = HEAP32[($3 + 16 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($3 + 20 | 0) >> 2] | 0;
     cardano_serialization_lib__utils___impl_20core__convert__TryFrom_cardano_serialization_lib__utils__BigNum__20for_20u32___try_from__h480b087dada7bb26($2 + 8 | 0 | 0, i64toi32_i32$2 | 0, i64toi32_i32$1 | 0);
     $4 = HEAP32[($2 + 12 | 0) >> 2] | 0;
     if (HEAP32[($2 + 8 | 0) >> 2] | 0) {
      break label$1
     }
    }
    core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
    HEAP32[($0 + 4 | 0) >> 2] = $4;
    i64toi32_i32$1 = $5$hi;
    HEAP32[$0 >> 2] = $5;
    global$0 = $2 + 32 | 0;
    return;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  $wasm_bindgen____rt__Ref_T__20as_20core__ops__drop__Drop___drop__h692d78b609edc7c6($2 + 24 | 0 | 0);
  wasm_bindgen__throw_val__hcf1b5c929d6fa472($4 | 0);
  abort();
 }
 
 function cardano_serialization_lib__Withdrawals__insert__h7293d9cdbbe52c19($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, $15 = 0, $16 = 0, $18 = 0, $19 = 0, $20 = 0, $21 = 0, $5 = 0, $17 = 0, $23 = 0, $33 = 0, $6 = 0, $6$hi = 0, $49 = 0;
  $4 = global$0 - 80 | 0;
  global$0 = $4;
  $5 = HEAPU8[$2 >> 0] | 0;
  i64toi32_i32$2 = $2 + 10 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $17 = i64toi32_i32$0;
  i64toi32_i32$0 = ($4 + 16 | 0) + 10 | 0;
  $16 = $17;
  HEAP16[i64toi32_i32$0 >> 1] = $16;
  HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $16 >>> 16 | 0;
  HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$1;
  HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
  i64toi32_i32$2 = $2 + 18 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $23 = i64toi32_i32$1;
  i64toi32_i32$1 = ($4 + 16 | 0) + 18 | 0;
  $18 = $23;
  HEAP16[i64toi32_i32$1 >> 1] = $18;
  HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $18 >>> 16 | 0;
  HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = i64toi32_i32$0;
  HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
  $15 = $2 + 26 | 0;
  $19 = ($4 + 16 | 0) + 26 | 0;
  $20 = HEAPU8[$15 >> 0] | 0 | ((HEAPU8[($15 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($15 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($15 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  HEAP16[$19 >> 1] = $20;
  HEAP16[($19 + 2 | 0) >> 1] = $20 >>> 16 | 0;
  i64toi32_i32$2 = $2 + 2 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $33 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  $21 = $33;
  HEAP16[(i64toi32_i32$0 + 18 | 0) >> 1] = $21;
  HEAP16[(i64toi32_i32$0 + 20 | 0) >> 1] = $21 >>> 16 | 0;
  HEAP16[(i64toi32_i32$0 + 22 | 0) >> 1] = i64toi32_i32$1;
  HEAP16[(i64toi32_i32$0 + 24 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 16 | 0) >> 0] = $5;
  HEAP8[(i64toi32_i32$0 + 17 | 0) >> 0] = HEAPU8[($2 + 1 | 0) >> 0] | 0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  linked_hash_map__LinkedHashMap_K_2cV_2cS___insert__h654f744b7b23f305($4 | 0, $1 | 0, $4 + 16 | 0 | 0, i64toi32_i32$1 | 0, i64toi32_i32$0 | 0);
  i64toi32_i32$2 = $4;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $6 = i64toi32_i32$0;
  $6$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $49 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $49;
  HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $6$hi;
  HEAP32[i64toi32_i32$1 >> 2] = $6;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = i64toi32_i32$2 + 80 | 0;
 }
 
 function withdrawals_get($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, i64toi32_i32$1 = 0, $4 = 0, $4$hi = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h000099354d5ff519($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h2338c90e0327d08b($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   label$2 : {
    label$3 : {
     $3 = linked_hash_map__LinkedHashMap_K_2cV_2cS___get__hbcb063be5677d464($3 | 0, HEAP32[$2 >> 2] | 0 | 0) | 0;
     if ($3) {
      break label$3
     }
     break label$2;
    }
    i64toi32_i32$1 = HEAP32[($3 + 4 | 0) >> 2] | 0;
    $4 = HEAP32[$3 >> 2] | 0;
    $4$hi = i64toi32_i32$1;
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   label$4 : {
    label$5 : {
     if ($3) {
      break label$5
     }
     $0 = 0;
     break label$4;
    }
    i64toi32_i32$1 = $4$hi;
    $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810($4 | 0, i64toi32_i32$1 | 0) | 0;
   }
   global$0 = $2 + 16 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionwitnessset_set_native_scripts($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $4 = 0, $3 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h1cc4e67284701531($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hbfc7b2ba05921680($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $4 = HEAP32[$2 >> 2] | 0;
   alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($2 + 16 | 0 | 0, HEAP32[$4 >> 2] | 0 | 0, HEAP32[($4 + 8 | 0) >> 2] | 0 | 0);
   core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__NativeScripts____hdd7d461255ec800a($0 + 12 | 0 | 0);
   HEAP32[($0 + 20 | 0) >> 2] = HEAP32[($2 + 24 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
   HEAP32[($0 + 16 | 0) >> 2] = i64toi32_i32$1;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 32 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function assets_get($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, i64toi32_i32$1 = 0, $4 = 0, $4$hi = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h91e3d4f7af3d2ccd($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h9c68abd5a6a78973($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   label$2 : {
    label$3 : {
     $3 = alloc__collections__btree__map__BTreeMap_K_2cV___get__h825f34112f7eacbf($3 | 0, HEAP32[$2 >> 2] | 0 | 0) | 0;
     if ($3) {
      break label$3
     }
     break label$2;
    }
    i64toi32_i32$1 = HEAP32[($3 + 4 | 0) >> 2] | 0;
    $4 = HEAP32[$3 >> 2] | 0;
    $4$hi = i64toi32_i32$1;
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   label$4 : {
    label$5 : {
     if ($3) {
      break label$5
     }
     $0 = 0;
     break label$4;
    }
    i64toi32_i32$1 = $4$hi;
    $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810($4 | 0, i64toi32_i32$1 | 0) | 0;
   }
   global$0 = $2 + 16 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function cardano_serialization_lib__chain_crypto__bech32__to_bech32_from_bytes__h58a287ff323357c6($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $35 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  HEAP32[($3 + 12 | 0) >> 2] = $2;
  HEAP32[($3 + 8 | 0) >> 2] = $1;
  bech32__ToBase32__to_base32__h2c09e619bc088feb($3 + 32 | 0 | 0, $3 + 8 | 0 | 0);
  bech32__encode__h3845e4a9162a8761($3 + 16 | 0 | 0, 1056368 | 0, 11 | 0, $3 + 32 | 0 | 0);
  label$1 : {
   if ((HEAP32[($3 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   i64toi32_i32$0 = HEAP32[($3 + 20 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($3 + 24 | 0) >> 2] | 0;
   cardano_serialization_lib__chain_crypto__bech32__to_bech32_from_bytes___7b_7bclosure_7d_7d__h9b94b0cce47b6578(i64toi32_i32$0 | 0, i64toi32_i32$1 | 0);
   abort();
  }
  $1 = $3 + 16 | 0 | 4 | 0;
  HEAP32[(($3 + 32 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $35 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[($3 + 32 | 0) >> 2] = $35;
  HEAP32[($3 + 36 | 0) >> 2] = i64toi32_i32$0;
  $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($0 | 0, $3 + 32 | 0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 32 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 32 | 0 | 0);
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__chain_crypto__bech32__to_bech32_from_bytes__hb1c1076c8140bfd9($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $35 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  HEAP32[($3 + 12 | 0) >> 2] = $2;
  HEAP32[($3 + 8 | 0) >> 2] = $1;
  bech32__ToBase32__to_base32__h2c09e619bc088feb($3 + 32 | 0 | 0, $3 + 8 | 0 | 0);
  bech32__encode__h3845e4a9162a8761($3 + 16 | 0 | 0, 1056379 | 0, 10 | 0, $3 + 32 | 0 | 0);
  label$1 : {
   if ((HEAP32[($3 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   i64toi32_i32$0 = HEAP32[($3 + 20 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($3 + 24 | 0) >> 2] | 0;
   cardano_serialization_lib__chain_crypto__bech32__to_bech32_from_bytes___7b_7bclosure_7d_7d__hb3434fc4c85e20c7(i64toi32_i32$0 | 0, i64toi32_i32$1 | 0);
   abort();
  }
  $1 = $3 + 16 | 0 | 4 | 0;
  HEAP32[(($3 + 32 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $35 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[($3 + 32 | 0) >> 2] = $35;
  HEAP32[($3 + 36 | 0) >> 2] = i64toi32_i32$0;
  $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($0 | 0, $3 + 32 | 0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 32 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 32 | 0 | 0);
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__chain_crypto__bech32__to_bech32_from_bytes__hd3bebea1c04f6297($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $35 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  HEAP32[($3 + 12 | 0) >> 2] = $2;
  HEAP32[($3 + 8 | 0) >> 2] = $1;
  bech32__ToBase32__to_base32__h2c09e619bc088feb($3 + 32 | 0 | 0, $3 + 8 | 0 | 0);
  bech32__encode__h3845e4a9162a8761($3 + 16 | 0 | 0, 1056389 | 0, 4 | 0, $3 + 32 | 0 | 0);
  label$1 : {
   if ((HEAP32[($3 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   i64toi32_i32$0 = HEAP32[($3 + 20 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($3 + 24 | 0) >> 2] | 0;
   cardano_serialization_lib__chain_crypto__bech32__to_bech32_from_bytes___7b_7bclosure_7d_7d__hb0fd1859c13ba56e(i64toi32_i32$0 | 0, i64toi32_i32$1 | 0);
   abort();
  }
  $1 = $3 + 16 | 0 | 4 | 0;
  HEAP32[(($3 + 32 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $35 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[($3 + 32 | 0) >> 2] = $35;
  HEAP32[($3 + 36 | 0) >> 2] = i64toi32_i32$0;
  $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($0 | 0, $3 + 32 | 0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 32 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 32 | 0 | 0);
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__chain_crypto__bech32__to_bech32_from_bytes__hd6d2d8f511656726($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $35 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  HEAP32[($3 + 12 | 0) >> 2] = $2;
  HEAP32[($3 + 8 | 0) >> 2] = $1;
  bech32__ToBase32__to_base32__h2c09e619bc088feb($3 + 32 | 0 | 0, $3 + 8 | 0 | 0);
  bech32__encode__h3845e4a9162a8761($3 + 16 | 0 | 0, 1056393 | 0, 4 | 0, $3 + 32 | 0 | 0);
  label$1 : {
   if ((HEAP32[($3 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   i64toi32_i32$0 = HEAP32[($3 + 20 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($3 + 24 | 0) >> 2] | 0;
   cardano_serialization_lib__chain_crypto__bech32__to_bech32_from_bytes___7b_7bclosure_7d_7d__h5c413ffd7f293a6f(i64toi32_i32$0 | 0, i64toi32_i32$1 | 0);
   abort();
  }
  $1 = $3 + 16 | 0 | 4 | 0;
  HEAP32[(($3 + 32 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $35 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[($3 + 32 | 0) >> 2] = $35;
  HEAP32[($3 + 36 | 0) >> 2] = i64toi32_i32$0;
  $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($0 | 0, $3 + 32 | 0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 32 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 32 | 0 | 0);
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__chain_crypto__bech32__to_bech32_from_bytes__he23d494655eee107($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $35 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  HEAP32[($3 + 12 | 0) >> 2] = $2;
  HEAP32[($3 + 8 | 0) >> 2] = $1;
  bech32__ToBase32__to_base32__h2c09e619bc088feb($3 + 32 | 0 | 0, $3 + 8 | 0 | 0);
  bech32__encode__h3845e4a9162a8761($3 + 16 | 0 | 0, 1056397 | 0, 11 | 0, $3 + 32 | 0 | 0);
  label$1 : {
   if ((HEAP32[($3 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   i64toi32_i32$0 = HEAP32[($3 + 20 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($3 + 24 | 0) >> 2] | 0;
   cardano_serialization_lib__chain_crypto__bech32__to_bech32_from_bytes___7b_7bclosure_7d_7d__hfc58d423fd6ff4c6(i64toi32_i32$0 | 0, i64toi32_i32$1 | 0);
   abort();
  }
  $1 = $3 + 16 | 0 | 4 | 0;
  HEAP32[(($3 + 32 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $35 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[($3 + 32 | 0) >> 2] = $35;
  HEAP32[($3 + 36 | 0) >> 2] = i64toi32_i32$0;
  $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($0 | 0, $3 + 32 | 0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 32 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 32 | 0 | 0);
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__chain_crypto__bech32__to_bech32_from_bytes__he42916b6d7c4e1c6($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $35 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  HEAP32[($3 + 12 | 0) >> 2] = $2;
  HEAP32[($3 + 8 | 0) >> 2] = $1;
  bech32__ToBase32__to_base32__h2c09e619bc088feb($3 + 32 | 0 | 0, $3 + 8 | 0 | 0);
  bech32__encode__h3845e4a9162a8761($3 + 16 | 0 | 0, 1056408 | 0, 10 | 0, $3 + 32 | 0 | 0);
  label$1 : {
   if ((HEAP32[($3 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   i64toi32_i32$0 = HEAP32[($3 + 20 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($3 + 24 | 0) >> 2] | 0;
   cardano_serialization_lib__chain_crypto__bech32__to_bech32_from_bytes___7b_7bclosure_7d_7d__hb6ea2d45cd0a5a90(i64toi32_i32$0 | 0, i64toi32_i32$1 | 0);
   abort();
  }
  $1 = $3 + 16 | 0 | 4 | 0;
  HEAP32[(($3 + 32 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $35 = i64toi32_i32$1;
  i64toi32_i32$1 = $3;
  HEAP32[($3 + 32 | 0) >> 2] = $35;
  HEAP32[($3 + 36 | 0) >> 2] = i64toi32_i32$0;
  $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($0 | 0, $3 + 32 | 0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 32 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 32 | 0 | 0);
  global$0 = $3 + 48 | 0;
 }
 
 function auxiliarydata_set_native_scripts($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $4 = 0, $3 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h55a9e62aded28c25($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hbfc7b2ba05921680($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $4 = HEAP32[$2 >> 2] | 0;
   alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($2 + 16 | 0 | 0, HEAP32[$4 >> 2] | 0 | 0, HEAP32[($4 + 8 | 0) >> 2] | 0 | 0);
   core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__NativeScripts____hdd7d461255ec800a_1($0 + 40 | 0 | 0);
   HEAP32[($0 + 48 | 0) >> 2] = HEAP32[($2 + 24 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   HEAP32[($0 + 40 | 0) >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
   HEAP32[($0 + 44 | 0) >> 2] = i64toi32_i32$1;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 32 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function $core__iter__adapters__map__Map_I_2cF__20as_20core__iter__traits__iterator__Iterator___fold__hb74bf4e511c9ae65($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $10 = 0, $26 = 0, $33 = 0, $36 = 0;
  $3 = global$0 - 64 | 0;
  global$0 = $3;
  label$1 : {
   if (($0 | 0) == ($1 | 0)) {
    break label$1
   }
   label$2 : while (1) {
    cardano_serialization_lib__NativeScript__hash__hb812a54d2c7bdca2($3 + 4 | 0 | 0, $0 | 0);
    $10 = ($3 + 4 | 0) + 24 | 0;
    HEAP32[(($3 + 32 | 0) + 24 | 0) >> 2] = HEAPU8[$10 >> 0] | 0 | ((HEAPU8[($10 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($10 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($10 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$2 = ($3 + 4 | 0) + 16 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $26 = i64toi32_i32$0;
    i64toi32_i32$0 = ($3 + 32 | 0) + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $26;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = ($3 + 4 | 0) + 8 | 0;
    i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $33 = i64toi32_i32$1;
    i64toi32_i32$1 = ($3 + 32 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $33;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$2 = $3;
    i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 9 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 10 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 11 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
    $36 = i64toi32_i32$0;
    i64toi32_i32$0 = i64toi32_i32$2;
    HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] = $36;
    HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] = i64toi32_i32$1;
    hashbrown__map__HashMap_K_2cV_2cS_2cA___insert__h106f59cab43fe932($2 | 0, i64toi32_i32$2 + 32 | 0 | 0) | 0;
    $0 = $0 + 32 | 0;
    if (($1 | 0) != ($0 | 0)) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $3 + 64 | 0;
 }
 
 function $cardano_serialization_lib__chain_crypto__sign__SignatureError_20as_20core__fmt__Debug___fmt__ha48c9453b982befc($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $11 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if ((HEAP32[$0 >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    i64toi32_i32$0 = core__fmt__Formatter__debug_struct__h873400a11fe69724($1 | 0, 1063548 | 0, 11 | 0) | 0;
    i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
    $11 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[($2 + 16 | 0) >> 2] = $11;
    HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($2 + 12 | 0) >> 2] = $0 + 4 | 0;
    core__fmt__builders__DebugStruct__field__hec833bfe02704935($2 + 16 | 0 | 0, 1063559 | 0, 8 | 0, $2 + 12 | 0 | 0, 1063516 | 0) | 0;
    HEAP32[($2 + 12 | 0) >> 2] = $0 + 8 | 0;
    core__fmt__builders__DebugStruct__field__hec833bfe02704935($2 + 16 | 0 | 0, 1063567 | 0, 3 | 0, $2 + 12 | 0 | 0, 1063516 | 0) | 0;
    $0 = core__fmt__builders__DebugStruct__finish__hb1eae1aa0e288840($2 + 16 | 0 | 0) | 0;
    break label$1;
   }
   core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 + 16 | 0 | 0, $1 | 0, 1063498 | 0, 16 | 0);
   $0 = core__fmt__builders__DebugTuple__finish__hc3c3f1efaa75a6e2($2 + 16 | 0 | 0) | 0;
  }
  global$0 = $2 + 32 | 0;
  return $0 | 0;
 }
 
 function bip32privatekey_as_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, $3 = 0, $4 = 0, $5 = 0, i64toi32_i32$1 = 0, $49 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h30021c0122a7c8e6($2 + 24 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $ed25519_bip32__key__XPrv_20as_20core__convert__AsRef__5bu8_5d____as_ref__h44c8f06901e0335a($2 + 16 | 0 | 0, HEAP32[($2 + 24 | 0) >> 2] | 0 | 0);
  $3 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  $4 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 + 8 | 0 | 0, $4 | 0, 0 | 0);
  $5 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $3 = memcpy(HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, $3 | 0, $4 | 0) | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[($2 + 40 | 0) >> 2] = $4;
  HEAP32[($2 + 36 | 0) >> 2] = $5;
  HEAP32[($2 + 32 | 0) >> 2] = $3;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $49 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $49;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $2 + 48 | 0;
 }
 
 function bip32publickey_as_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, $3 = 0, $4 = 0, $5 = 0, i64toi32_i32$1 = 0, $49 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hcfcf2a638924fc64($2 + 24 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $ed25519_bip32__key__XPub_20as_20core__convert__AsRef__5bu8_5d____as_ref__h69a664c2b5ee8b25($2 + 16 | 0 | 0, HEAP32[($2 + 24 | 0) >> 2] | 0 | 0);
  $3 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  $4 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 + 8 | 0 | 0, $4 | 0, 0 | 0);
  $5 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $3 = memcpy(HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, $3 | 0, $4 | 0) | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[($2 + 40 | 0) >> 2] = $4;
  HEAP32[($2 + 36 | 0) >> 2] = $5;
  HEAP32[($2 + 32 | 0) >> 2] = $3;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $49 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $49;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $2 + 48 | 0;
 }
 
 function alloc__vec__Vec_T_2cA___extend_desugared__h5c38f14e95453798($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $4 = 0, $3 = 0, $5 = 0, $6 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  $core__iter__adapters__ResultShunt_I_2cE__20as_20core__iter__traits__iterator__Iterator___try_fold__h81e306f0b3e48011($2 + 8 | 0 | 0, $1 | 0);
  label$1 : {
   if (!((HEAPU8[($2 + 8 | 0) >> 0] | 0) & 1 | 0)) {
    break label$1
   }
   $3 = HEAPU8[($2 + 9 | 0) >> 0] | 0;
   label$2 : while (1) {
    label$3 : {
     $4 = HEAP32[($0 + 8 | 0) >> 2] | 0;
     if (($4 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
      break label$3
     }
     $core__iter__adapters__ResultShunt_I_2cE__20as_20core__iter__traits__iterator__Iterator___size_hint__hb25e984a0df95a21($2 + 16 | 0 | 0, $1 | 0);
     $5 = HEAP32[($2 + 16 | 0) >> 2] | 0;
     $6 = $5 + 1 | 0;
     alloc__vec__Vec_T_2cA___reserve__h9cf757d86af8f187($0 | 0, ($6 >>> 0 < $5 >>> 0 ? -1 : $6) | 0);
    }
    HEAP8[((HEAP32[$0 >> 2] | 0) + $4 | 0) >> 0] = $3;
    HEAP32[($0 + 8 | 0) >> 2] = $4 + 1 | 0;
    $core__iter__adapters__ResultShunt_I_2cE__20as_20core__iter__traits__iterator__Iterator___try_fold__h81e306f0b3e48011($2 | 0, $1 | 0);
    $3 = HEAPU8[($2 + 1 | 0) >> 0] | 0;
    if ((HEAPU8[$2 >> 0] | 0) & 1 | 0) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $2 + 32 | 0;
 }
 
 function alloc__vec__Vec_T_2cA___extend_desugared__hbbdfb7be7e7f78cb($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $4 = 0, $3 = 0, $5 = 0, $6 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  $core__iter__adapters__ResultShunt_I_2cE__20as_20core__iter__traits__iterator__Iterator___try_fold__h46f032289f335f5a($2 + 8 | 0 | 0, $1 | 0);
  label$1 : {
   if (!((HEAPU8[($2 + 8 | 0) >> 0] | 0) & 1 | 0)) {
    break label$1
   }
   $3 = HEAPU8[($2 + 9 | 0) >> 0] | 0;
   label$2 : while (1) {
    label$3 : {
     $4 = HEAP32[($0 + 8 | 0) >> 2] | 0;
     if (($4 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
      break label$3
     }
     $core__iter__adapters__ResultShunt_I_2cE__20as_20core__iter__traits__iterator__Iterator___size_hint__h90f4fd0095433d70($2 + 16 | 0 | 0, $1 | 0);
     $5 = HEAP32[($2 + 16 | 0) >> 2] | 0;
     $6 = $5 + 1 | 0;
     alloc__vec__Vec_T_2cA___reserve__h9cf757d86af8f187($0 | 0, ($6 >>> 0 < $5 >>> 0 ? -1 : $6) | 0);
    }
    HEAP8[((HEAP32[$0 >> 2] | 0) + $4 | 0) >> 0] = $3;
    HEAP32[($0 + 8 | 0) >> 2] = $4 + 1 | 0;
    $core__iter__adapters__ResultShunt_I_2cE__20as_20core__iter__traits__iterator__Iterator___try_fold__h46f032289f335f5a($2 | 0, $1 | 0);
    $3 = HEAPU8[($2 + 1 | 0) >> 0] | 0;
    if ((HEAPU8[$2 >> 0] | 0) & 1 | 0) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $2 + 32 | 0;
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h699bb0f3db607312($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $6 = 0, $3 = 0, $4 = 0, $5 = 0;
  $2 = global$0 - 144 | 0;
  global$0 = $2;
  $3 = HEAP32[$1 >> 2] | 0;
  $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__he0e25d30114cc7d7($2 + 8 | 0 | 0, $4 | 0, 0 | 0);
  $5 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  $6 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $6;
  HEAP32[$0 >> 2] = $5;
  label$1 : {
   if (!$6) {
    break label$1
   }
   $1 = $4 << 7 | 0;
   label$2 : while (1) {
    if (!$1) {
     break label$1
    }
    $cardano_serialization_lib__TransactionOutput_20as_20core__clone__Clone___clone__h6884f0c4818d1aeb_1($2 + 16 | 0 | 0, $3 | 0);
    $5 = (memcpy($5 | 0, $2 + 16 | 0 | 0, 128 | 0) | 0) + 128 | 0;
    $1 = $1 + -128 | 0;
    $3 = $3 + 128 | 0;
    $6 = $6 + -1 | 0;
    if ($6) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 8 | 0) >> 2] = $4;
  global$0 = $2 + 144 | 0;
 }
 
 function $cardano_serialization_lib__address__RewardAddress_20as_20cbor_event__se__Serialize___serialize__hd22cb20e67f69432($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $3 = 0, $11 = 0, $12 = 0, $13 = 0, $15 = 0, $16 = 0, $17 = 0, $4 = 0, $14 = 0, $19 = 0, $28 = 0;
  $3 = global$0 - 112 | 0;
  global$0 = $3;
  $4 = HEAPU8[$1 >> 0] | 0;
  i64toi32_i32$2 = $1 + 10 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $14 = i64toi32_i32$0;
  i64toi32_i32$0 = $3 + 11 | 0;
  $11 = $14;
  HEAP8[i64toi32_i32$0 >> 0] = $11;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 18 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $19 = i64toi32_i32$1;
  i64toi32_i32$1 = $3 + 19 | 0;
  $12 = $19;
  HEAP8[i64toi32_i32$1 >> 0] = $12;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  $13 = $1 + 26 | 0;
  $15 = $3 + 27 | 0;
  $16 = HEAPU8[$13 >> 0] | 0 | ((HEAPU8[($13 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($13 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($13 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  HEAP8[$15 >> 0] = $16;
  HEAP8[($15 + 1 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[($15 + 2 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[($15 + 3 | 0) >> 0] = $16 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 2 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $28 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  $17 = $28;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $17;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = $17 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = $17 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = $17 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 8 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 9 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 10 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  HEAP8[i64toi32_i32$0 >> 0] = 3;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $4;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = HEAPU8[($1 + 1 | 0) >> 0] | 0;
  cardano_serialization_lib__address__Address__to_bytes__h301d351bd02ea9f1(i64toi32_i32$0 + 96 | 0 | 0, i64toi32_i32$0 | 0);
  cbor_event__se__Serializer_W___write_bytes__h935c22261c9a8184($0 | 0, $2 | 0, i64toi32_i32$0 + 96 | 0 | 0);
  label$1 : {
   if ((HEAPU8[i64toi32_i32$0 >> 0] | 0) >>> 0 < 4 >>> 0) {
    break label$1
   }
   core__ptr__drop_in_place_cardano_serialization_lib__legacy_address__address__ExtendedAddr___h2c1a18aefeee766f($3 | 4 | 0 | 0);
  }
  global$0 = $3 + 112 | 0;
 }
 
 function cryptoxide__hmac__Hmac_D___new__h10c18a5661f5ecf6($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $23 = 0, $31 = 0, $50 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  cryptoxide__hmac__create_keys__hb120d19dc48fb687($4 + 24 | 0 | 0, $1 | 0, $2 | 0, $3 | 0);
  $2 = ($4 + 8 | 0) + 8 | 0;
  HEAP32[$2 >> 2] = HEAP32[(($4 + 24 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($4 + 36 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($4 + 40 | 0) >> 2] | 0;
  $23 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 236 | 0) >> 2] = $23;
  HEAP32[(i64toi32_i32$0 + 240 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 244 | 0) >> 2] = HEAP32[($4 + 44 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($4 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($4 + 28 | 0) >> 2] | 0;
  $31 = i64toi32_i32$1;
  i64toi32_i32$1 = $4;
  HEAP32[($4 + 8 | 0) >> 2] = $31;
  HEAP32[($4 + 12 | 0) >> 2] = i64toi32_i32$0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h12ac465cd2b9ef75($4 | 0, $4 + 8 | 0 | 0);
  $cryptoxide__sha2__Sha512_20as_20cryptoxide__digest__Digest___input__h63322ce5a02a233a($1 | 0, HEAP32[$4 >> 2] | 0 | 0, HEAP32[($4 + 4 | 0) >> 2] | 0 | 0);
  $0 = memcpy($0 | 0, $1 | 0, 224 | 0) | 0;
  HEAP8[($0 + 248 | 0) >> 0] = 0;
  HEAP32[($0 + 232 | 0) >> 2] = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($4 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($4 + 12 | 0) >> 2] | 0;
  $50 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 224 | 0) >> 2] = $50;
  HEAP32[(i64toi32_i32$0 + 228 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $4 + 48 | 0;
 }
 
 function core__fmt__num___impl_20core__fmt__LowerHex_20for_20i8___fmt__ha166b2b4b979058e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $3 = 0, $2 = 0, $4 = 0;
  $2 = global$0 - 128 | 0;
  global$0 = $2;
  $3 = HEAPU8[$0 >> 0] | 0;
  $0 = 0;
  label$1 : while (1) {
   $4 = $3 & 15 | 0;
   HEAP8[(($2 + $0 | 0) + 127 | 0) >> 0] = $4 >>> 0 < 10 >>> 0 ? $4 | 48 | 0 : $4 + 87 | 0;
   $0 = $0 + -1 | 0;
   $3 = ($3 >>> 4 | 0) & 15 | 0;
   if ($3) {
    continue label$1
   }
   break label$1;
  };
  label$2 : {
   $3 = $0 + 128 | 0;
   if ($3 >>> 0 < 129 >>> 0) {
    break label$2
   }
   core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($3 | 0, 128 | 0, 1150164 | 0);
   abort();
  }
  $0 = core__fmt__Formatter__pad_integral__h08e3e53a0de517a1($1 | 0, 1 | 0, 1150180 | 0, 2 | 0, ($2 + $0 | 0) + 128 | 0 | 0, 0 - $0 | 0 | 0) | 0;
  global$0 = $2 + 128 | 0;
  return $0 | 0;
 }
 
 function core__fmt__num___impl_20core__fmt__UpperHex_20for_20i8___fmt__h1e32f8c7db908eda($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $3 = 0, $2 = 0, $4 = 0;
  $2 = global$0 - 128 | 0;
  global$0 = $2;
  $3 = HEAPU8[$0 >> 0] | 0;
  $0 = 0;
  label$1 : while (1) {
   $4 = $3 & 15 | 0;
   HEAP8[(($2 + $0 | 0) + 127 | 0) >> 0] = $4 >>> 0 < 10 >>> 0 ? $4 | 48 | 0 : $4 + 55 | 0;
   $0 = $0 + -1 | 0;
   $3 = ($3 >>> 4 | 0) & 15 | 0;
   if ($3) {
    continue label$1
   }
   break label$1;
  };
  label$2 : {
   $3 = $0 + 128 | 0;
   if ($3 >>> 0 < 129 >>> 0) {
    break label$2
   }
   core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($3 | 0, 128 | 0, 1150164 | 0);
   abort();
  }
  $0 = core__fmt__Formatter__pad_integral__h08e3e53a0de517a1($1 | 0, 1 | 0, 1150180 | 0, 2 | 0, ($2 + $0 | 0) + 128 | 0 | 0, 0 - $0 | 0 | 0) | 0;
  global$0 = $2 + 128 | 0;
  return $0 | 0;
 }
 
 function transactionoutput_new($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 272 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hab2c0cbdcb539b91($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h5db5149478ec5345($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__TransactionOutput__new__h3c6ccbf8a30c4d79($2 + 16 | 0 | 0, $3 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   memcpy($2 + 144 | 0 | 0, $2 + 16 | 0 | 0, 128 | 0) | 0;
   $0 = $cardano_serialization_lib__TransactionOutput_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h4b9395cffb8a7c47($2 + 144 | 0 | 0) | 0;
   global$0 = $2 + 272 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionoutputbuilder_with_address($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 224 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hc81980191b5e557a($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hab2c0cbdcb539b91($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__output_builder__TransactionOutputBuilder__with_address__h0d63b91ad5941c64($2 + 16 | 0 | 0, $3 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   memcpy($2 + 120 | 0 | 0, $2 + 16 | 0 | 0, 104 | 0) | 0;
   $0 = $cardano_serialization_lib__output_builder__TransactionOutputBuilder_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h6f606fcbcfa27636($2 + 120 | 0 | 0) | 0;
   global$0 = $2 + 224 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionoutputamountbuilder_with_value($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 272 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h1cb96e7b1dabbc55($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h5db5149478ec5345($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__output_builder__TransactionOutputAmountBuilder__with_value__he6ce3f9f499f4b2f($2 + 16 | 0 | 0, $3 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   memcpy($2 + 144 | 0 | 0, $2 + 16 | 0 | 0, 128 | 0) | 0;
   $0 = $cardano_serialization_lib__output_builder__TransactionOutputAmountBuilder_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hafb771b944269b79($2 + 144 | 0 | 0) | 0;
   global$0 = $2 + 272 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionoutputamountbuilder_with_coin($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 272 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h1cb96e7b1dabbc55($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__output_builder__TransactionOutputAmountBuilder__with_coin__hed72e8bd0c479163($2 + 16 | 0 | 0, $3 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   memcpy($2 + 144 | 0 | 0, $2 + 16 | 0 | 0, 128 | 0) | 0;
   $0 = $cardano_serialization_lib__output_builder__TransactionOutputAmountBuilder_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hafb771b944269b79($2 + 144 | 0 | 0) | 0;
   global$0 = $2 + 272 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function cardano_serialization_lib__utils__write_bounded_bytes__h9cfd6d74fa4c49a9($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $5 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  label$1 : {
   label$2 : {
    if ($3 >>> 0 > 64 >>> 0) {
     break label$2
    }
    cbor_event__se__Serializer_W___write_bytes__h1ecbe6b3316bc5ff($0 | 0, $1 | 0, $2 | 0, $3 | 0);
    break label$1;
   }
   alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($1 | 0, 1057812 | 0, 1 | 0);
   label$3 : {
    label$4 : while (1) {
     $5 = $3 >>> 0 < 64 >>> 0 ? $3 : 64;
     cbor_event__se__Serializer_W___write_bytes__h1ecbe6b3316bc5ff($4 | 0, $1 | 0, $2 | 0, $5 | 0);
     if ((HEAP32[$4 >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     $2 = $2 + $5 | 0;
     $3 = $3 - $5 | 0;
     if ($3) {
      continue label$4
     }
     break label$4;
    };
    HEAP8[$4 >> 0] = 5;
    cbor_event__se__Serializer_W___write_special__had0377f4ca98c84d($0 | 0, $1 | 0, $4 | 0);
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $4 + 8 | 0 | 0, 40 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $4 + 48 | 0;
 }
 
 function core__iter__traits__iterator__Iterator__eq_by__h46111545684c8f23($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $3 = 0, $2 = 0, $5 = 0, $4 = 0, $6 = 0, $7 = 0, $8 = 0;
  label$1 : {
   label$2 : {
    $2 = HEAP32[($1 + 32 | 0) >> 2] | 0;
    if ($2) {
     break label$2
    }
    $1 = 0;
    break label$1;
   }
   $1 = HEAP32[($2 + 100 | 0) >> 2] | 0;
  }
  $3 = HEAP32[$0 >> 2] | 0;
  $4 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  label$3 : while (1) {
   label$4 : {
    if (($3 | 0) != ($4 | 0)) {
     break label$4
    }
    return ($1 | 0) == ($2 | 0) | !$1 | 0 | 0;
   }
   $5 = HEAP32[($3 + 100 | 0) >> 2] | 0;
   HEAP32[$0 >> 2] = $5;
   HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + -1 | 0;
   label$5 : {
    if (($1 | 0) == ($2 | 0)) {
     break label$5
    }
    $6 = HEAP32[($1 + 100 | 0) >> 2] | 0;
    if (!($cardano_serialization_lib__metadata__TransactionMetadatum_20as_20core__cmp__PartialEq___eq__h3bd33dd828bf70c0($3 | 0, $1 | 0) | 0)) {
     break label$5
    }
    $7 = $3 + 48 | 0;
    $8 = $1 + 48 | 0;
    $3 = $5;
    $1 = $6;
    if ($cardano_serialization_lib__metadata__TransactionMetadatum_20as_20core__cmp__PartialEq___eq__h3bd33dd828bf70c0($7 | 0, $8 | 0) | 0) {
     continue label$3
    }
   }
   break label$3;
  };
  return 0 | 0;
 }
 
 function transactionbuilderconfigbuilder_fee_algo($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 288 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h274f52f9a26a0dc8($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__haac84d0387ff0446($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__tx_builder__TransactionBuilderConfigBuilder__fee_algo__h03e1f492080db5e6($2 + 16 | 0 | 0, $3 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   memcpy($2 + 152 | 0 | 0, $2 + 16 | 0 | 0, 136 | 0) | 0;
   $0 = $cardano_serialization_lib__tx_builder__TransactionBuilderConfigBuilder_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h65182e4c6d5621d4($2 + 152 | 0 | 0) | 0;
   global$0 = $2 + 288 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionbuilderconfigbuilder_coins_per_utxo_word($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 288 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h274f52f9a26a0dc8($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__tx_builder__TransactionBuilderConfigBuilder__coins_per_utxo_word__hf5d1cdcac9071bfd($2 + 16 | 0 | 0, $3 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   memcpy($2 + 152 | 0 | 0, $2 + 16 | 0 | 0, 136 | 0) | 0;
   $0 = $cardano_serialization_lib__tx_builder__TransactionBuilderConfigBuilder_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h65182e4c6d5621d4($2 + 152 | 0 | 0) | 0;
   global$0 = $2 + 288 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionbuilderconfigbuilder_ex_unit_prices($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 288 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h274f52f9a26a0dc8($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h0a3b5f1cc5dc7523($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__tx_builder__TransactionBuilderConfigBuilder__ex_unit_prices__h9d2c41c6e3a24742($2 + 16 | 0 | 0, $3 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   memcpy($2 + 152 | 0 | 0, $2 + 16 | 0 | 0, 136 | 0) | 0;
   $0 = $cardano_serialization_lib__tx_builder__TransactionBuilderConfigBuilder_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h65182e4c6d5621d4($2 + 152 | 0 | 0) | 0;
   global$0 = $2 + 288 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionbuilderconfigbuilder_pool_deposit($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 288 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h274f52f9a26a0dc8($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__tx_builder__TransactionBuilderConfigBuilder__pool_deposit__hbdae78e370aa38b6($2 + 16 | 0 | 0, $3 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   memcpy($2 + 152 | 0 | 0, $2 + 16 | 0 | 0, 136 | 0) | 0;
   $0 = $cardano_serialization_lib__tx_builder__TransactionBuilderConfigBuilder_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h65182e4c6d5621d4($2 + 152 | 0 | 0) | 0;
   global$0 = $2 + 288 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionbuilderconfigbuilder_key_deposit($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 288 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h274f52f9a26a0dc8($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__tx_builder__TransactionBuilderConfigBuilder__key_deposit__h5629eb2f970b40c9($2 + 16 | 0 | 0, $3 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   memcpy($2 + 152 | 0 | 0, $2 + 16 | 0 | 0, 136 | 0) | 0;
   $0 = $cardano_serialization_lib__tx_builder__TransactionBuilderConfigBuilder_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h65182e4c6d5621d4($2 + 152 | 0 | 0) | 0;
   global$0 = $2 + 288 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function redeemertag_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, $3 = 0, $3$hi = 0, $11 = 0, $12 = 0, $32 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  HEAP32[($2 + 40 | 0) >> 2] = $1;
  HEAP32[($2 + 36 | 0) >> 2] = $1;
  HEAP32[($2 + 32 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 32 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $32 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $32;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   i64toi32_i32$1 = cardano_serialization_lib__plutus__RedeemerTag__from_bytes__h713c826c214713e1($2 + 32 | 0 | 0) | 0;
   i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
   $3 = i64toi32_i32$1;
   $3$hi = i64toi32_i32$0;
   i64toi32_i32$2 = i64toi32_i32$1;
   i64toi32_i32$1 = 0;
   i64toi32_i32$3 = 1;
   i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
   if (!(i64toi32_i32$2 & i64toi32_i32$3 | 0 | i64toi32_i32$1 | 0)) {
    break label$1
   }
   i64toi32_i32$1 = $3$hi;
   i64toi32_i32$0 = $3;
   i64toi32_i32$2 = 0;
   i64toi32_i32$3 = 32;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$2 = 0;
    $11 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   } else {
    i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
    $11 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($11 | 0);
   abort();
  }
  i64toi32_i32$2 = $3$hi;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 8;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $12 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   $12 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
  }
  $1 = $cardano_serialization_lib__plutus__RedeemerTag_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h6e4777f9244e5b69($12 | 0) | 0;
  global$0 = $2 + 48 | 0;
  return $1 | 0;
 }
 
 function strings_add($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, i64toi32_i32$1 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hbc201b8ccd6b711d($3 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($3 + 12 | 0) >> 2] | 0;
  $4 = HEAP32[($3 + 8 | 0) >> 2] | 0;
  HEAP32[($3 + 40 | 0) >> 2] = $2;
  HEAP32[($3 + 36 | 0) >> 2] = $2;
  HEAP32[($3 + 32 | 0) >> 2] = $1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($3 | 0, $3 + 32 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($3 + 16 | 0 | 0, HEAP32[$3 >> 2] | 0 | 0, HEAP32[($3 + 4 | 0) >> 2] | 0 | 0);
  HEAP32[(($3 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($3 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($3 + 20 | 0) >> 2] | 0;
  HEAP32[($3 + 32 | 0) >> 2] = HEAP32[($3 + 16 | 0) >> 2] | 0;
  HEAP32[($3 + 36 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__plutus__Strings__add__h8f3270c51963220e($4 | 0, $3 + 32 | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, 0 | 0) | 0;
  global$0 = $3 + 48 | 0;
 }
 
 function serde_json__de__Deserializer_R___end__hae34e82a28b172cb($0) {
  $0 = $0 | 0;
  var $3 = 0, $1 = 0, $4 = 0, $2 = 0, $6 = 0, $7 = 0, $5 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $2 = 0;
  label$1 : {
   $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   $4 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if ($3 >>> 0 >= $4 >>> 0) {
    break label$1
   }
   $5 = HEAP32[$0 >> 2] | 0;
   $6 = 1;
   label$2 : {
    label$3 : while (1) {
     $7 = (HEAPU8[($5 + $3 | 0) >> 0] | 0) + -9 | 0;
     if ($7 >>> 0 > 23 >>> 0) {
      break label$2
     }
     if (!((1 << $7 | 0) & 8388627 | 0)) {
      break label$2
     }
     $3 = $3 + 1 | 0;
     HEAP32[($0 + 8 | 0) >> 2] = $3;
     $6 = $3 >>> 0 < $4 >>> 0;
     if (($4 | 0) != ($3 | 0)) {
      continue label$3
     }
     break label$1;
    };
   }
   if (!($6 & 1 | 0)) {
    break label$1
   }
   HEAP32[$1 >> 2] = 19;
   $2 = serde_json__de__Deserializer_R___peek_error__hf8794e102c1db2df($0 | 0, $1 | 0) | 0;
  }
  global$0 = $1 + 16 | 0;
  return $2 | 0;
 }
 
 function $serde_json__error__ErrorImpl_20as_20core__fmt__Display___fmt__h871d3b80149707c3($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $24 = 0, $32 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if (HEAP32[($0 + 12 | 0) >> 2] | 0) {
     break label$2
    }
    $0 = $serde_json__error__ErrorCode_20as_20core__fmt__Display___fmt__h3ed16ca1538b4d8c($0 | 0, $1 | 0) | 0;
    break label$1;
   }
   core__fmt__ArgumentV1__new__h5702524f4c8ddc75($2 + 8 | 0 | 0, $0 + 12 | 0 | 0, 46 | 0);
   i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   core__fmt__ArgumentV1__new__h5702524f4c8ddc75($2 | 0, $0 + 16 | 0 | 0, 46 | 0);
   HEAP32[($2 + 36 | 0) >> 2] = 3;
   $24 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   HEAP32[($2 + 48 | 0) >> 2] = $24;
   HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($2 + 44 | 0) >> 2] = 215;
   HEAP32[($2 + 40 | 0) >> 2] = $0;
   i64toi32_i32$0 = $2;
   i64toi32_i32$1 = 0;
   HEAP32[($2 + 20 | 0) >> 2] = 3;
   HEAP32[($2 + 24 | 0) >> 2] = i64toi32_i32$1;
   HEAP32[($2 + 16 | 0) >> 2] = 1088944;
   i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $32 = i64toi32_i32$1;
   i64toi32_i32$1 = $2;
   HEAP32[($2 + 56 | 0) >> 2] = $32;
   HEAP32[($2 + 60 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($2 + 32 | 0) >> 2] = $2 + 40 | 0;
   $0 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 16 | 0 | 0) | 0;
  }
  global$0 = $2 + 64 | 0;
  return $0 | 0;
 }
 
 function $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Add___add__he826ef0e90fce416($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, i64toi32_i32$5 = 0, i64toi32_i32$3 = 0, $4 = 0, $4$hi = 0, $56 = 0, $58 = 0, $60 = 0, $61 = 0, $62 = 0, $5 = 0, $7 = 0, $7$hi = 0, $9 = 0, $9$hi = 0, $10 = 0, $10$hi = 0, $12 = 0, $12$hi = 0, $14 = 0, $14$hi = 0, $3 = 0, $3$hi = 0, $17$hi = 0, $20 = 0, $21 = 0, $23 = 0, $23$hi = 0, $25 = 0, $25$hi = 0, $26 = 0, $26$hi = 0, $28$hi = 0, $32 = 0, $34 = 0, $34$hi = 0, $36 = 0, $36$hi = 0, $37 = 0, $37$hi = 0, $39$hi = 0, $43 = 0, $45 = 0, $45$hi = 0, $47 = 0, $47$hi = 0, $48 = 0, $48$hi = 0, $50$hi = 0, $53 = 0, $54 = 0, $57 = 0, $57$hi = 0, $59 = 0, $59$hi = 0;
  $5 = $0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $9 = i64toi32_i32$1;
  $9$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$2 = $7;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$3 = $9;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $10 = i64toi32_i32$4;
  $10$hi = i64toi32_i32$5;
  i64toi32_i32$0 = $2;
  i64toi32_i32$5 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $12 = i64toi32_i32$5;
  $12$hi = i64toi32_i32$2;
  i64toi32_i32$0 = $1;
  i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$2;
  $14$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $12$hi;
  i64toi32_i32$0 = $12;
  i64toi32_i32$2 = $14$hi;
  i64toi32_i32$3 = $14;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $3 = i64toi32_i32$1;
  $3$hi = i64toi32_i32$4;
  i64toi32_i32$5 = i64toi32_i32$1;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$2 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $56 = i64toi32_i32$4 >>> i64toi32_i32$2 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$4 >>> i64toi32_i32$2 | 0;
   $56 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$2 | 0) | 0;
  }
  $17$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$4 = $10;
  i64toi32_i32$5 = $17$hi;
  i64toi32_i32$3 = $56;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $4 = i64toi32_i32$2;
  $4$hi = i64toi32_i32$1;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$4 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$4 = i64toi32_i32$1 & i64toi32_i32$4 | 0;
  $20 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
  i64toi32_i32$0 = $5;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $20;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$4;
  $21 = $0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] | 0;
  $23 = i64toi32_i32$4;
  $23$hi = i64toi32_i32$0;
  i64toi32_i32$1 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] | 0;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] | 0;
  $25 = i64toi32_i32$0;
  $25$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $23$hi;
  i64toi32_i32$1 = $23;
  i64toi32_i32$0 = $25$hi;
  i64toi32_i32$3 = $25;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $26 = i64toi32_i32$5;
  $26$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$4 = $4;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$0 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $58 = i64toi32_i32$2 >>> i64toi32_i32$0 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$0 | 0;
   $58 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$0 | 0) | 0;
  }
  $28$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $26$hi;
  i64toi32_i32$2 = $26;
  i64toi32_i32$4 = $28$hi;
  i64toi32_i32$3 = $58;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$5;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$2 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$2 = i64toi32_i32$5 & i64toi32_i32$2 | 0;
  i64toi32_i32$1 = $21;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = i64toi32_i32$0 & i64toi32_i32$3 | 0;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$2;
  $32 = $0;
  i64toi32_i32$5 = $2;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 24 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 28 | 0) >> 2] | 0;
  $34 = i64toi32_i32$2;
  $34$hi = i64toi32_i32$1;
  i64toi32_i32$5 = $1;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 24 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 28 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  $36$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $34$hi;
  i64toi32_i32$5 = $34;
  i64toi32_i32$1 = $36$hi;
  i64toi32_i32$3 = $36;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $37 = i64toi32_i32$4;
  $37$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $4$hi;
  i64toi32_i32$2 = $4;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$1 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$5 = 0;
   $60 = i64toi32_i32$0 >>> i64toi32_i32$1 | 0;
  } else {
   i64toi32_i32$5 = i64toi32_i32$0 >>> i64toi32_i32$1 | 0;
   $60 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$1 | 0) | 0;
  }
  $39$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $37$hi;
  i64toi32_i32$0 = $37;
  i64toi32_i32$2 = $39$hi;
  i64toi32_i32$3 = $60;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $4 = i64toi32_i32$1;
  $4$hi = i64toi32_i32$4;
  i64toi32_i32$5 = i64toi32_i32$1;
  i64toi32_i32$0 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$0 = i64toi32_i32$4 & i64toi32_i32$0 | 0;
  i64toi32_i32$5 = $32;
  HEAP32[(i64toi32_i32$5 + 24 | 0) >> 2] = i64toi32_i32$1 & i64toi32_i32$3 | 0;
  HEAP32[(i64toi32_i32$5 + 28 | 0) >> 2] = i64toi32_i32$0;
  $43 = $0;
  i64toi32_i32$4 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 32 | 0) >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 36 | 0) >> 2] | 0;
  $45 = i64toi32_i32$0;
  $45$hi = i64toi32_i32$5;
  i64toi32_i32$4 = $1;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$4 + 32 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$4 + 36 | 0) >> 2] | 0;
  $47 = i64toi32_i32$5;
  $47$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $45$hi;
  i64toi32_i32$4 = $45;
  i64toi32_i32$5 = $47$hi;
  i64toi32_i32$3 = $47;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $48 = i64toi32_i32$2;
  $48$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $4$hi;
  i64toi32_i32$0 = $4;
  i64toi32_i32$4 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$4 = 0;
   $61 = i64toi32_i32$1 >>> i64toi32_i32$5 | 0;
  } else {
   i64toi32_i32$4 = i64toi32_i32$1 >>> i64toi32_i32$5 | 0;
   $61 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$5 | 0) | 0;
  }
  $50$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $48$hi;
  i64toi32_i32$1 = $48;
  i64toi32_i32$0 = $50$hi;
  i64toi32_i32$3 = $61;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $4 = i64toi32_i32$5;
  $4$hi = i64toi32_i32$2;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$1 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$1 = i64toi32_i32$2 & i64toi32_i32$1 | 0;
  $53 = i64toi32_i32$4 & i64toi32_i32$3 | 0;
  i64toi32_i32$4 = $43;
  HEAP32[(i64toi32_i32$4 + 32 | 0) >> 2] = $53;
  HEAP32[(i64toi32_i32$4 + 36 | 0) >> 2] = i64toi32_i32$1;
  $54 = $0;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$2 = i64toi32_i32$5;
  i64toi32_i32$4 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$0 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$4 = 0;
   $62 = i64toi32_i32$1 >>> i64toi32_i32$0 | 0;
  } else {
   i64toi32_i32$4 = i64toi32_i32$1 >>> i64toi32_i32$0 | 0;
   $62 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$0 | 0) | 0;
  }
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_i64_mul($62 | 0, i64toi32_i32$4 | 0, 19 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $57 = i64toi32_i32$2;
  $57$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $3$hi;
  i64toi32_i32$1 = $3;
  i64toi32_i32$2 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$2 = i64toi32_i32$4 & i64toi32_i32$2 | 0;
  $59 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
  $59$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $57$hi;
  i64toi32_i32$4 = $57;
  i64toi32_i32$1 = $59$hi;
  i64toi32_i32$3 = $59;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  i64toi32_i32$4 = $54;
  HEAP32[i64toi32_i32$4 >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$4 + 4 | 0) >> 2] = i64toi32_i32$5;
 }
 
 function $cbor_event__types__Type_20as_20core__fmt__Debug___fmt__h132a3b04c55ccbc0($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    switch (HEAPU8[$0 >> 0] | 0 | 0) {
    default:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1139990 | 0, 15 | 0);
     break label$1;
    case 1:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1139975 | 0, 15 | 0);
     break label$1;
    case 2:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1139970 | 0, 5 | 0);
     break label$1;
    case 3:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1139966 | 0, 4 | 0);
     break label$1;
    case 4:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1139961 | 0, 5 | 0);
     break label$1;
    case 5:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1139958 | 0, 3 | 0);
     break label$1;
    case 6:
     core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1139955 | 0, 3 | 0);
     break label$1;
    case 7:
     break label$2;
    };
   }
   core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1139948 | 0, 7 | 0);
  }
  $1 = core__fmt__builders__DebugTuple__finish__hc3c3f1efaa75a6e2($2 | 0) | 0;
  global$0 = $2 + 16 | 0;
  return $1 | 0;
 }
 
 function $wasm_bindgen__JsValue_20as_20core__fmt__Debug___fmt__h609da9eb26b4fcb6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 56 | 0) >> 2] = 0;
  HEAP32[($2 + 60 | 0) >> 2] = i64toi32_i32$0;
  wasm_bindgen____wbindgen_debug_string__haec7489361e91b07($2 + 56 | 0 | 0, HEAP32[$0 >> 2] | 0 | 0);
  HEAP32[($2 + 28 | 0) >> 2] = 1;
  $0 = HEAP32[($2 + 60 | 0) >> 2] | 0;
  HEAP32[($2 + 48 | 0) >> 2] = $0;
  HEAP32[($2 + 44 | 0) >> 2] = $0;
  HEAP32[($2 + 40 | 0) >> 2] = HEAP32[($2 + 56 | 0) >> 2] | 0;
  HEAP32[($2 + 36 | 0) >> 2] = 264;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 12 | 0) >> 2] = 2;
  HEAP32[($2 + 16 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 8 | 0) >> 2] = 1141712;
  HEAP32[($2 + 32 | 0) >> 2] = $2 + 40 | 0;
  HEAP32[($2 + 24 | 0) >> 2] = $2 + 32 | 0;
  $1 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 8 | 0 | 0) | 0;
  label$1 : {
   $0 = HEAP32[($2 + 44 | 0) >> 2] | 0;
   if (!$0) {
    break label$1
   }
   __rust_dealloc(HEAP32[($2 + 40 | 0) >> 2] | 0 | 0, $0 | 0, 1 | 0);
  }
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__h2aab8de7f66bfb86($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $6 = 0, $4 = 0, $7 = 0, $5 = 0;
  $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = HEAPU16[($4 + 1062 | 0) >> 1] | 0;
  $6 = Math_imul($3, 48);
  $1 = Math_imul($5, 48) - $6 | 0;
  $7 = $3 + -1 | 0;
  $3 = $4 + $6 | 0;
  $6 = 1;
  label$1 : {
   label$2 : while (1) {
    label$3 : {
     if ($1) {
      break label$3
     }
     $7 = $5;
     break label$1;
    }
    $7 = $7 + 1 | 0;
    $1 = $1 + -48 | 0;
    $4 = $cardano_serialization_lib__plutus__PlutusData_20as_20core__cmp__Ord___cmp__h6cbb090e8f573f89($2 | 0, $3 | 0) | 0;
    $3 = $3 + 48 | 0;
    if (($4 & 255 | 0 | 0) == (1 | 0)) {
     continue label$2
    }
    break label$2;
   };
   label$4 : {
    $6 = ($4 << 24 | 0) >> 24 | 0;
    switch ($6 + 1 | 0 | 0) {
    case 1:
     break label$1;
    default:
     break label$4;
    };
   }
   $6 = 1;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $7;
  HEAP32[$0 >> 2] = $6;
 }
 
 function alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__h95d3836825c8de7a($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $6 = 0, $4 = 0, $7 = 0, $5 = 0;
  $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = HEAPU16[($4 + 1546 | 0) >> 1] | 0;
  $6 = $3 << 7 | 0;
  $1 = ($5 << 7 | 0) - $6 | 0;
  $7 = $3 + -1 | 0;
  $3 = $4 + $6 | 0;
  $6 = 1;
  label$1 : {
   label$2 : while (1) {
    label$3 : {
     if ($1) {
      break label$3
     }
     $7 = $5;
     break label$1;
    }
    $7 = $7 + 1 | 0;
    $1 = $1 + -128 | 0;
    $4 = $cardano_serialization_lib__TransactionOutput_20as_20core__cmp__Ord___cmp__hb8f43680ab4bb508($2 | 0, $3 | 0) | 0;
    $3 = $3 + 128 | 0;
    if (($4 & 255 | 0 | 0) == (1 | 0)) {
     continue label$2
    }
    break label$2;
   };
   label$4 : {
    $6 = ($4 << 24 | 0) >> 24 | 0;
    switch ($6 + 1 | 0 | 0) {
    case 1:
     break label$1;
    default:
     break label$4;
    };
   }
   $6 = 1;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $7;
  HEAP32[$0 >> 2] = $6;
 }
 
 function alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__h552b67ac5806e190($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $6 = 0, $4 = 0, $7 = 0, $5 = 0;
  $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = HEAPU16[($4 + 1062 | 0) >> 1] | 0;
  $6 = Math_imul($3, 48);
  $1 = Math_imul($5, 48) - $6 | 0;
  $7 = $3 + -1 | 0;
  $3 = $4 + $6 | 0;
  $6 = 1;
  label$1 : {
   label$2 : while (1) {
    label$3 : {
     if ($1) {
      break label$3
     }
     $7 = $5;
     break label$1;
    }
    $7 = $7 + 1 | 0;
    $1 = $1 + -48 | 0;
    $4 = $cardano_serialization_lib__plutus__PlutusData_20as_20core__cmp__Ord___cmp__h6cbb090e8f573f89($2 | 0, $3 | 0) | 0;
    $3 = $3 + 48 | 0;
    if (($4 & 255 | 0 | 0) == (1 | 0)) {
     continue label$2
    }
    break label$2;
   };
   label$4 : {
    $6 = ($4 << 24 | 0) >> 24 | 0;
    switch ($6 + 1 | 0 | 0) {
    case 1:
     break label$1;
    default:
     break label$4;
    };
   }
   $6 = 1;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $7;
  HEAP32[$0 >> 2] = $6;
 }
 
 function alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType____find_key_index__h53de2975e7d4f713($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $6 = 0, $4 = 0, $7 = 0, $5 = 0;
  $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = HEAPU16[($4 + 1546 | 0) >> 1] | 0;
  $6 = $3 << 7 | 0;
  $1 = ($5 << 7 | 0) - $6 | 0;
  $7 = $3 + -1 | 0;
  $3 = $4 + $6 | 0;
  $6 = 1;
  label$1 : {
   label$2 : while (1) {
    label$3 : {
     if ($1) {
      break label$3
     }
     $7 = $5;
     break label$1;
    }
    $7 = $7 + 1 | 0;
    $1 = $1 + -128 | 0;
    $4 = $cardano_serialization_lib__TransactionOutput_20as_20core__cmp__Ord___cmp__hb8f43680ab4bb508($2 | 0, $3 | 0) | 0;
    $3 = $3 + 128 | 0;
    if (($4 & 255 | 0 | 0) == (1 | 0)) {
     continue label$2
    }
    break label$2;
   };
   label$4 : {
    $6 = ($4 << 24 | 0) >> 24 | 0;
    switch ($6 + 1 | 0 | 0) {
    case 1:
     break label$1;
    default:
     break label$4;
    };
   }
   $6 = 1;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $7;
  HEAP32[$0 >> 2] = $6;
 }
 
 function value_compare($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h5db5149478ec5345($2 + 24 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($2 + 28 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 24 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h5db5149478ec5345($2 + 16 | 0 | 0, $1 | 0);
   $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   cardano_serialization_lib__utils__Value__compare__h76fa82c3757f53d2($2 + 8 | 0 | 0, $3 | 0, HEAP32[($2 + 16 | 0) >> 2] | 0 | 0);
   $3 = HEAP8[($2 + 9 | 0) >> 0] | 0;
   $4 = HEAPU8[($2 + 8 | 0) >> 0] | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   global$0 = $2 + 32 | 0;
   return ($4 & 1 | 0 ? $3 : 16777215) | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function int_as_i32($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, i64toi32_i32$5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, $2 = 0, $3$hi = 0, $4$hi = 0, $3 = 0, $4 = 0, $27 = 0, $5 = 0, $5$hi = 0, $31 = 0, $35 = 0, $36$hi = 0, $46 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h8f4f32b29a620a40($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $3 = i64toi32_i32$0;
  $3$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $4 = i64toi32_i32$1;
  $4$hi = i64toi32_i32$0;
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  $27 = $0;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = -2147483648;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $5 = i64toi32_i32$4;
  $5$hi = i64toi32_i32$5;
  i64toi32_i32$0 = i64toi32_i32$4;
  i64toi32_i32$2 = 1;
  i64toi32_i32$3 = 0;
  $31 = i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
  i64toi32_i32$0 = $3$hi;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$0 = $4$hi;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$5 = $4$hi;
  i64toi32_i32$2 = $4;
  $35 = i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0;
  i64toi32_i32$3 = 0;
  $36$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $3$hi;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = $36$hi;
  i64toi32_i32$5 = $35;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $3 = i64toi32_i32$1;
  $3$hi = i64toi32_i32$4;
  $1 = !(i64toi32_i32$1 | i64toi32_i32$4 | 0);
  HEAP32[$27 >> 2] = $1 ? $31 : 0;
  i64toi32_i32$4 = $4$hi;
  i64toi32_i32$4 = $5$hi;
  i64toi32_i32$3 = $5;
  i64toi32_i32$2 = 0;
  i64toi32_i32$5 = -1;
  $46 = i64toi32_i32$4 >>> 0 > i64toi32_i32$2 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$3 >>> 0 > i64toi32_i32$5 >>> 0 | 0) | 0;
  i64toi32_i32$3 = $3$hi;
  i64toi32_i32$5 = i64toi32_i32$1;
  i64toi32_i32$4 = 0;
  i64toi32_i32$2 = 0;
  HEAP32[($0 + 4 | 0) >> 2] = ($1 ? $46 : (i64toi32_i32$5 | 0) != (i64toi32_i32$2 | 0) | (i64toi32_i32$3 | 0) != (i64toi32_i32$4 | 0) | 0) ? 0 : $4;
  global$0 = $2 + 16 | 0;
 }
 
 function int_as_i32_or_nothing($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, i64toi32_i32$5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, $2 = 0, $3$hi = 0, $4$hi = 0, $3 = 0, $4 = 0, $27 = 0, $5 = 0, $5$hi = 0, $31 = 0, $35 = 0, $36$hi = 0, $46 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h8f4f32b29a620a40($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $3 = i64toi32_i32$0;
  $3$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $4 = i64toi32_i32$1;
  $4$hi = i64toi32_i32$0;
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  $27 = $0;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = -2147483648;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $5 = i64toi32_i32$4;
  $5$hi = i64toi32_i32$5;
  i64toi32_i32$0 = i64toi32_i32$4;
  i64toi32_i32$2 = 1;
  i64toi32_i32$3 = 0;
  $31 = i64toi32_i32$5 >>> 0 < i64toi32_i32$2 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
  i64toi32_i32$0 = $3$hi;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$0 = $4$hi;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$3 = i64toi32_i32$4;
  i64toi32_i32$5 = $4$hi;
  i64toi32_i32$2 = $4;
  $35 = i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$4 >>> 0 < i64toi32_i32$2 >>> 0 | 0) | 0;
  i64toi32_i32$3 = 0;
  $36$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $3$hi;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = $36$hi;
  i64toi32_i32$5 = $35;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  i64toi32_i32$4 = i64toi32_i32$3 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $3 = i64toi32_i32$1;
  $3$hi = i64toi32_i32$4;
  $1 = !(i64toi32_i32$1 | i64toi32_i32$4 | 0);
  HEAP32[$27 >> 2] = $1 ? $31 : 0;
  i64toi32_i32$4 = $4$hi;
  i64toi32_i32$4 = $5$hi;
  i64toi32_i32$3 = $5;
  i64toi32_i32$2 = 0;
  i64toi32_i32$5 = -1;
  $46 = i64toi32_i32$4 >>> 0 > i64toi32_i32$2 >>> 0 | ((i64toi32_i32$4 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$3 >>> 0 > i64toi32_i32$5 >>> 0 | 0) | 0;
  i64toi32_i32$3 = $3$hi;
  i64toi32_i32$5 = i64toi32_i32$1;
  i64toi32_i32$4 = 0;
  i64toi32_i32$2 = 0;
  HEAP32[($0 + 4 | 0) >> 2] = ($1 ? $46 : (i64toi32_i32$5 | 0) != (i64toi32_i32$2 | 0) | (i64toi32_i32$3 | 0) != (i64toi32_i32$4 | 0) | 0) ? 0 : $4;
  global$0 = $2 + 16 | 0;
 }
 
 function core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatum___headd2d1b596252cc($0) {
  $0 = $0 | 0;
  var $2 = 0, $1 = 0;
  label$1 : {
   label$2 : {
    switch (HEAP32[$0 >> 2] | 0 | 0) {
    default:
     $0 = $0 + 4 | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
     return;
    case 0:
     $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__hd17c55afb95953fd($0 + 8 | 0 | 0);
     $0 = $0 + 24 | 0;
     if (!(HEAP32[$0 >> 2] | 0)) {
      break label$1
     }
     hashbrown__raw__RawTable_T_2cA___free_buckets__hf5781ccef5282b02($0 | 0);
     return;
    case 1:
     $1 = $0 + 4 | 0;
     label$6 : {
      $2 = HEAP32[($0 + 12 | 0) >> 2] | 0;
      if (!$2) {
       break label$6
      }
      $0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
      $2 = Math_imul($2, 48);
      label$7 : while (1) {
       core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatum___headd2d1b596252cc_2($0 | 0);
       $0 = $0 + 48 | 0;
       $2 = $2 + -48 | 0;
       if ($2) {
        continue label$7
       }
       break label$7;
      };
     }
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h81b8a37e31f2de30($1 | 0);
     return;
    case 2:
     break label$1;
    case 3:
     break label$2;
    };
   }
   $0 = $0 + 4 | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
  }
 }
 
 function core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatumEnum___h27fd15c9b26a768e($0) {
  $0 = $0 | 0;
  var $2 = 0, $1 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     switch (HEAP32[$0 >> 2] | 0 | 0) {
     default:
      $0 = $0 + 4 | 0;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
      return;
     case 0:
      $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__hd17c55afb95953fd($0 + 8 | 0 | 0);
      $0 = $0 + 24 | 0;
      if (!(HEAP32[$0 >> 2] | 0)) {
       break label$2
      }
      hashbrown__raw__RawTable_T_2cA___free_buckets__hf5781ccef5282b02($0 | 0);
      return;
     case 3:
      break label$1;
     case 2:
      break label$2;
     case 1:
      break label$3;
     };
    }
    $1 = $0 + 4 | 0;
    label$6 : {
     $2 = HEAP32[($0 + 12 | 0) >> 2] | 0;
     if (!$2) {
      break label$6
     }
     $0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
     $2 = Math_imul($2, 48);
     label$7 : while (1) {
      core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatum___headd2d1b596252cc_2($0 | 0);
      $0 = $0 + 48 | 0;
      $2 = $2 + -48 | 0;
      if ($2) {
       continue label$7
      }
      break label$7;
     };
    }
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h81b8a37e31f2de30($1 | 0);
   }
   return;
  }
  $0 = $0 + 4 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
 }
 
 function $cardano_serialization_lib__chain_crypto__algorithms__ed25519_derive__Ed25519Bip32_20as_20cardano_serialization_lib__chain_crypto__key__AsymmetricKey___secret_from_binary__h88d2302397adf84f($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $7 = 0, i64toi32_i32$1 = 0, $8 = 0, i64toi32_i32$0 = 0, $9 = 0, $34 = 0;
  $3 = global$0 - 192 | 0;
  global$0 = $3;
  ed25519_bip32__key__XPrv__from_slice_verified__h3a93bc2e4b6227c9($3 + 88 | 0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    if ((HEAPU8[($3 + 88 | 0) >> 0] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $9 = HEAPU8[($3 + 89 | 0) >> 0] | 0 | ((HEAPU8[($3 + 90 | 0) >> 0] | 0) << 8 | 0) | 0;
    HEAP8[($0 + 1 | 0) >> 0] = $9;
    HEAP8[($0 + 2 | 0) >> 0] = $9 >>> 8 | 0;
    HEAP8[($0 + 3 | 0) >> 0] = HEAPU8[($3 + 91 | 0) >> 0] | 0;
    i64toi32_i32$0 = HEAP32[($3 + 92 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($3 + 96 | 0) >> 2] | 0;
    memcpy($0 + 12 | 0 | 0, memcpy($3 | 0, ($3 + 88 | 0) + 12 | 0 | 0, 85 | 0) | 0 | 0, 85 | 0) | 0;
    $34 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 4 | 0;
    $7 = i64toi32_i32$0;
    $8 = $34;
    HEAP8[$7 >> 0] = $8;
    HEAP8[($7 + 1 | 0) >> 0] = $8 >>> 8 | 0;
    HEAP8[($7 + 2 | 0) >> 0] = $8 >>> 16 | 0;
    HEAP8[($7 + 3 | 0) >> 0] = $8 >>> 24 | 0;
    HEAP8[($7 + 4 | 0) >> 0] = i64toi32_i32$1;
    HEAP8[($7 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
    HEAP8[($7 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
    HEAP8[($7 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
    HEAP8[$0 >> 0] = 0;
    break label$1;
   }
   $1 = HEAPU8[($3 + 92 | 0) >> 0] | 0;
   HEAP8[$0 >> 0] = 1;
   HEAP8[($0 + 1 | 0) >> 0] = (6 >>> $1 | 0) & 1 | 0;
  }
  global$0 = $3 + 192 | 0;
 }
 
 function core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatum___headd2d1b596252cc_1($0) {
  $0 = $0 | 0;
  var $2 = 0, $1 = 0;
  label$1 : {
   label$2 : {
    switch (HEAP32[$0 >> 2] | 0 | 0) {
    default:
     $0 = $0 + 4 | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
     return;
    case 0:
     $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__hd17c55afb95953fd($0 + 8 | 0 | 0);
     $0 = $0 + 24 | 0;
     if (!(HEAP32[$0 >> 2] | 0)) {
      break label$1
     }
     hashbrown__raw__RawTable_T_2cA___free_buckets__hf5781ccef5282b02($0 | 0);
     return;
    case 1:
     $1 = $0 + 4 | 0;
     label$6 : {
      $2 = HEAP32[($0 + 12 | 0) >> 2] | 0;
      if (!$2) {
       break label$6
      }
      $0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
      $2 = Math_imul($2, 48);
      label$7 : while (1) {
       core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatum___headd2d1b596252cc_2($0 | 0);
       $0 = $0 + 48 | 0;
       $2 = $2 + -48 | 0;
       if ($2) {
        continue label$7
       }
       break label$7;
      };
     }
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h81b8a37e31f2de30($1 | 0);
     return;
    case 2:
     break label$1;
    case 3:
     break label$2;
    };
   }
   $0 = $0 + 4 | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
  }
 }
 
 function transactionbuilder_add_change_if_needed($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, $2 = 0, i64toi32_i32$4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $5 = 0, i64toi32_i32$2 = 0, $5$hi = 0, $12 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h5566e1c7d4aafe35($2 + 8 | 0 | 0, $0 | 0);
    if (!$1) {
     break label$2
    }
    $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    wasm_bindgen____rt__WasmRefCell_T___borrow__hab2c0cbdcb539b91($2 | 0, $1 | 0);
    $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
    i64toi32_i32$0 = cardano_serialization_lib__tx_builder__TransactionBuilder__add_change_if_needed__h087f11a5756166a6($4 | 0, HEAP32[$2 >> 2] | 0 | 0) | 0;
    i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
    $5 = i64toi32_i32$0;
    $5$hi = i64toi32_i32$1;
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    i64toi32_i32$3 = 1;
    i64toi32_i32$0 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
    if (!!($5 & i64toi32_i32$3 | 0 | i64toi32_i32$0 | 0)) {
     break label$1
    }
    global$0 = $2 + 16 | 0;
    i64toi32_i32$0 = $5$hi;
    return ($5 >>> 8 | 0) & 1 | 0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  i64toi32_i32$0 = $5$hi;
  i64toi32_i32$1 = $5;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $12 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $12 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472($12 | 0);
  abort();
 }
 
 function bip32privatekey_to_raw_key($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 144 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h30021c0122a7c8e6($1 | 0, $0 | 0);
  $0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $2 = HEAP32[$1 >> 2] | 0;
  memset($1 + 72 | 0 | 0, 0 | 0, 64 | 0) | 0;
  ed25519_bip32__key__XPrv__get_extended_mut__h396b8224008dfa18($2 | 0, $1 + 72 | 0 | 0);
  memcpy($1 + 8 | 0 | 0, $1 + 72 | 0 | 0, 64 | 0) | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP8[($1 + 72 | 0) >> 0] = 0;
  memcpy($1 + 72 | 0 | 1 | 0 | 0, $1 + 8 | 0 | 0, 64 | 0) | 0;
  $0 = $cardano_serialization_lib__crypto__PrivateKey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h7ffc55fb5b040fec($1 + 72 | 0 | 0) | 0;
  global$0 = $1 + 144 | 0;
  return $0 | 0;
 }
 
 function core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatum___headd2d1b596252cc_2($0) {
  $0 = $0 | 0;
  var $2 = 0, $1 = 0;
  label$1 : {
   label$2 : {
    switch (HEAP32[$0 >> 2] | 0 | 0) {
    default:
     $0 = $0 + 4 | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
     return;
    case 0:
     $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__hd17c55afb95953fd($0 + 8 | 0 | 0);
     $0 = $0 + 24 | 0;
     if (!(HEAP32[$0 >> 2] | 0)) {
      break label$1
     }
     hashbrown__raw__RawTable_T_2cA___free_buckets__hf5781ccef5282b02($0 | 0);
     return;
    case 1:
     $1 = $0 + 4 | 0;
     label$6 : {
      $2 = HEAP32[($0 + 12 | 0) >> 2] | 0;
      if (!$2) {
       break label$6
      }
      $0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
      $2 = Math_imul($2, 48);
      label$7 : while (1) {
       core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatum___headd2d1b596252cc_2($0 | 0);
       $0 = $0 + 48 | 0;
       $2 = $2 + -48 | 0;
       if ($2) {
        continue label$7
       }
       break label$7;
      };
     }
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h81b8a37e31f2de30($1 | 0);
     return;
    case 2:
     break label$1;
    case 3:
     break label$2;
    };
   }
   $0 = $0 + 4 | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
  }
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___insert__h5d8c7a7452747b0f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $9 = 0, $17 = 0, $23 = 0, $26 = 0;
  $2 = global$0 - 96 | 0;
  global$0 = $2;
  $9 = $1 + 24 | 0;
  HEAP32[(($2 + 48 | 0) + 24 | 0) >> 2] = HEAPU8[$9 >> 0] | 0 | ((HEAPU8[($9 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($9 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($9 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $17 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 48 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $17;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $23 = i64toi32_i32$1;
  i64toi32_i32$1 = ($2 + 48 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $23;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $26 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 48 | 0) >> 2] = $26;
  HEAP32[($2 + 52 | 0) >> 2] = i64toi32_i32$1;
  alloc__collections__btree__map__BTreeMap_K_2cV___entry__h5b0f4a3d2f0d57d5($2 | 0, $0 | 0, $2 + 48 | 0 | 0);
  label$1 : {
   $1 = HEAP32[$2 >> 2] | 0;
   if (($1 | 0) == (1 | 0)) {
    break label$1
   }
   memcpy($2 + 48 | 0 | 0, $2 | 4 | 0 | 0, 44 | 0) | 0;
   alloc__collections__btree__map__entry__VacantEntry_K_2cV___insert__ha11e6229b9b858b3($2 + 48 | 0 | 0) | 0;
  }
  global$0 = $2 + 96 | 0;
  return $1 | 0;
 }
 
 function cardano_serialization_lib__plutus__Redeemers__add__hd385809a7217414b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $4 = 0, $4$hi = 0, $3 = 0, $20 = 0, $27 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$1;
  $3 = HEAPU8[($1 + 72 | 0) >> 0] | 0;
  $cardano_serialization_lib__plutus__PlutusData_20as_20core__clone__Clone___clone__h63d1a98cc18f4609_2($2 + 8 | 0 | 0, $1 + 8 | 0 | 0);
  i64toi32_i32$2 = $1 + 64 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $20 = i64toi32_i32$1;
  i64toi32_i32$1 = $2 + 64 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $20;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP8[($2 + 72 | 0) >> 0] = $3;
  i64toi32_i32$0 = $4$hi;
  i64toi32_i32$1 = $2;
  HEAP32[i64toi32_i32$1 >> 2] = $4;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[($1 + 56 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 60 | 0) >> 2] | 0;
  $27 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 56 | 0) >> 2] = $27;
  HEAP32[($2 + 60 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (($1 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
    break label$1
   }
   alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hf4e46fc64716925d($0 | 0, $1 | 0, 1 | 0);
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  }
  memcpy((HEAP32[$0 >> 2] | 0) + Math_imul($1, 80) | 0 | 0, $2 | 0, 80 | 0) | 0;
  HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
  global$0 = $2 + 80 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___shrink__h9d96a5e710402ac8($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $6 = 0, $7 = 0, $4 = 0, $5 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     if ($3 >>> 0 < $2 >>> 0) {
      break label$3
     }
     $4 = 0;
     if (!$3) {
      break label$1
     }
     $3 = $3 << 2 | 0;
     $5 = HEAP32[$1 >> 2] | 0;
     label$4 : {
      $6 = $2 << 2 | 0;
      if ($6) {
       break label$4
      }
      $7 = 4;
      if (!$3) {
       break label$2
      }
      __rust_dealloc($5 | 0, $3 | 0, 4 | 0);
      break label$2;
     }
     $7 = __rust_realloc($5 | 0, $3 | 0, 4 | 0, $6 | 0) | 0;
     if ($7) {
      break label$2
     }
     HEAP32[($0 + 4 | 0) >> 2] = $6;
     HEAP32[($0 + 8 | 0) >> 2] = 4;
     $4 = 1;
     break label$1;
    }
    core__panicking__panic__h2fd385a887c8bf13(1083352 | 0, 36 | 0, 1083388 | 0);
    abort();
   }
   HEAP32[$1 >> 2] = $7;
   HEAP32[($1 + 4 | 0) >> 2] = $2 & 1073741823 | 0;
  }
  HEAP32[$0 >> 2] = $4;
 }
 
 function cryptoxide__constant_time__ct_array64_maybe_set__h78feb940adce935a($0, $1, $2, $2$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$5 = 0, i64toi32_i32$0 = 0, $4 = 0, i64toi32_i32$3 = 0, $3 = 0, $20 = 0, $20$hi = 0, $24 = 0, $24$hi = 0, $25$hi = 0, $27 = 0, $37 = 0, $37$hi = 0, $42 = 0, $42$hi = 0, $43 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  $4 = 0;
  memset($3 + 8 | 0 | 0, 0 | 0, 40 | 0) | 0;
  i64toi32_i32$0 = $2$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = $2;
  i64toi32_i32$5 = (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) + $2$hi | 0;
  i64toi32_i32$5 = i64toi32_i32$0 - i64toi32_i32$5 | 0;
  $2 = i64toi32_i32$2 - i64toi32_i32$3 | 0;
  $2$hi = i64toi32_i32$5;
  label$1 : while (1) {
   i64toi32_i32$0 = $1 + $4 | 0;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $20 = i64toi32_i32$5;
   $20$hi = i64toi32_i32$2;
   i64toi32_i32$0 = $0 + $4 | 0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$0 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] | 0;
   $24 = i64toi32_i32$2;
   $24$hi = i64toi32_i32$5;
   i64toi32_i32$5 = $20$hi;
   i64toi32_i32$0 = $20;
   i64toi32_i32$2 = $24$hi;
   i64toi32_i32$3 = $24;
   i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
   $25$hi = i64toi32_i32$2;
   i64toi32_i32$2 = $2$hi;
   i64toi32_i32$2 = $25$hi;
   i64toi32_i32$5 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
   i64toi32_i32$0 = $2$hi;
   i64toi32_i32$3 = $2;
   i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
   $27 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
   i64toi32_i32$5 = ($3 + 8 | 0) + $4 | 0;
   HEAP32[i64toi32_i32$5 >> 2] = $27;
   HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$0;
   $4 = $4 + 8 | 0;
   if (($4 | 0) != (40 | 0)) {
    continue label$1
   }
   break label$1;
  };
  $4 = 0;
  label$2 : while (1) {
   $1 = $0 + $4 | 0;
   i64toi32_i32$2 = $1;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$5 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $37 = i64toi32_i32$0;
   $37$hi = i64toi32_i32$5;
   i64toi32_i32$2 = ($3 + 8 | 0) + $4 | 0;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $42 = i64toi32_i32$5;
   $42$hi = i64toi32_i32$0;
   i64toi32_i32$0 = $37$hi;
   i64toi32_i32$2 = $37;
   i64toi32_i32$5 = $42$hi;
   i64toi32_i32$3 = $42;
   i64toi32_i32$5 = i64toi32_i32$0 ^ i64toi32_i32$5 | 0;
   $43 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
   i64toi32_i32$2 = $1;
   HEAP32[i64toi32_i32$2 >> 2] = $43;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$5;
   $4 = $4 + 8 | 0;
   if (($4 | 0) != (40 | 0)) {
    continue label$2
   }
   break label$2;
  };
  global$0 = $3 + 48 | 0;
 }
 
 function cryptoxide__hashing__blake2b__Context_____new_keyed__h0020be505a449ec3($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $3 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, $4 = 0, $12 = 0, $18 = 0, $22 = 0;
  $3 = global$0 - 128 | 0;
  global$0 = $3;
  label$1 : {
   if ($2 >>> 0 > 64 >>> 0) {
    break label$1
   }
   $4 = 0;
   $3 = memset($3 | 0, 0 | 0, 128 | 0) | 0;
   label$2 : {
    if (!$2) {
     break label$2
    }
    memcpy($3 | 0, $1 | 0, $2 | 0) | 0;
    $4 = 128;
   }
   $18 = $0;
   i64toi32_i32$0 = 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = 0;
   i64toi32_i32$3 = 8;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
    $12 = 0;
   } else {
    i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
    $12 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   }
   i64toi32_i32$0 = $12;
   i64toi32_i32$2 = 1779033703;
   i64toi32_i32$3 = -222443240;
   i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
   $22 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
   i64toi32_i32$0 = $18;
   HEAP32[i64toi32_i32$0 >> 2] = $22;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   memcpy($0 + 8 | 0 | 0, 1137376 | 0, 56 | 0) | 0;
   i64toi32_i32$0 = $0 + 72 | 0;
   i64toi32_i32$2 = 0;
   HEAP32[i64toi32_i32$0 >> 2] = 0;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = $0;
   i64toi32_i32$2 = 0;
   HEAP32[(i64toi32_i32$0 + 64 | 0) >> 2] = 0;
   HEAP32[(i64toi32_i32$0 + 68 | 0) >> 2] = i64toi32_i32$2;
   memcpy(i64toi32_i32$0 + 100 | 0 | 0, $3 | 0, 128 | 0) | 0;
   HEAP32[(i64toi32_i32$0 + 96 | 0) >> 2] = $4;
   global$0 = $3 + 128 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1136076 | 0, 49 | 0, 1136128 | 0);
  abort();
 }
 
 function cryptoxide__hashing__blake2b__Context_____new_keyed__h0aac9808807e4fc4($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $3 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, $4 = 0, $12 = 0, $18 = 0, $22 = 0;
  $3 = global$0 - 128 | 0;
  global$0 = $3;
  label$1 : {
   if ($2 >>> 0 > 64 >>> 0) {
    break label$1
   }
   $4 = 0;
   $3 = memset($3 | 0, 0 | 0, 128 | 0) | 0;
   label$2 : {
    if (!$2) {
     break label$2
    }
    memcpy($3 | 0, $1 | 0, $2 | 0) | 0;
    $4 = 128;
   }
   $18 = $0;
   i64toi32_i32$0 = 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = 0;
   i64toi32_i32$3 = 8;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
    $12 = 0;
   } else {
    i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
    $12 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   }
   i64toi32_i32$0 = $12;
   i64toi32_i32$2 = 1779033703;
   i64toi32_i32$3 = -222443228;
   i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
   $22 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
   i64toi32_i32$0 = $18;
   HEAP32[i64toi32_i32$0 >> 2] = $22;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   memcpy($0 + 8 | 0 | 0, 1137376 | 0, 56 | 0) | 0;
   i64toi32_i32$0 = $0 + 72 | 0;
   i64toi32_i32$2 = 0;
   HEAP32[i64toi32_i32$0 >> 2] = 0;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = $0;
   i64toi32_i32$2 = 0;
   HEAP32[(i64toi32_i32$0 + 64 | 0) >> 2] = 0;
   HEAP32[(i64toi32_i32$0 + 68 | 0) >> 2] = i64toi32_i32$2;
   memcpy(i64toi32_i32$0 + 100 | 0 | 0, $3 | 0, 128 | 0) | 0;
   HEAP32[(i64toi32_i32$0 + 96 | 0) >> 2] = $4;
   global$0 = $3 + 128 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1136076 | 0, 49 | 0, 1136128 | 0);
  abort();
 }
 
 function cryptoxide__hashing__blake2b__Context_____new_keyed__h13601b381cfa4335($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $3 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, $4 = 0, $12 = 0, $18 = 0, $22 = 0;
  $3 = global$0 - 128 | 0;
  global$0 = $3;
  label$1 : {
   if ($2 >>> 0 > 64 >>> 0) {
    break label$1
   }
   $4 = 0;
   $3 = memset($3 | 0, 0 | 0, 128 | 0) | 0;
   label$2 : {
    if (!$2) {
     break label$2
    }
    memcpy($3 | 0, $1 | 0, $2 | 0) | 0;
    $4 = 128;
   }
   $18 = $0;
   i64toi32_i32$0 = 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = 0;
   i64toi32_i32$3 = 8;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
    $12 = 0;
   } else {
    i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
    $12 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   }
   i64toi32_i32$0 = $12;
   i64toi32_i32$2 = 1779033703;
   i64toi32_i32$3 = -222443244;
   i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
   $22 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
   i64toi32_i32$0 = $18;
   HEAP32[i64toi32_i32$0 >> 2] = $22;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   memcpy($0 + 8 | 0 | 0, 1137376 | 0, 56 | 0) | 0;
   i64toi32_i32$0 = $0 + 72 | 0;
   i64toi32_i32$2 = 0;
   HEAP32[i64toi32_i32$0 >> 2] = 0;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = $0;
   i64toi32_i32$2 = 0;
   HEAP32[(i64toi32_i32$0 + 64 | 0) >> 2] = 0;
   HEAP32[(i64toi32_i32$0 + 68 | 0) >> 2] = i64toi32_i32$2;
   memcpy(i64toi32_i32$0 + 100 | 0 | 0, $3 | 0, 128 | 0) | 0;
   HEAP32[(i64toi32_i32$0 + 96 | 0) >> 2] = $4;
   global$0 = $3 + 128 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1136076 | 0, 49 | 0, 1136128 | 0);
  abort();
 }
 
 function cryptoxide__hashing__blake2b__Context_____new_keyed__h2236c20e723d151b($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $3 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, $4 = 0, $12 = 0, $18 = 0, $22 = 0;
  $3 = global$0 - 128 | 0;
  global$0 = $3;
  label$1 : {
   if ($2 >>> 0 > 64 >>> 0) {
    break label$1
   }
   $4 = 0;
   $3 = memset($3 | 0, 0 | 0, 128 | 0) | 0;
   label$2 : {
    if (!$2) {
     break label$2
    }
    memcpy($3 | 0, $1 | 0, $2 | 0) | 0;
    $4 = 128;
   }
   $18 = $0;
   i64toi32_i32$0 = 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = 0;
   i64toi32_i32$3 = 8;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
    $12 = 0;
   } else {
    i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
    $12 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   }
   i64toi32_i32$0 = $12;
   i64toi32_i32$2 = 1779033703;
   i64toi32_i32$3 = -222443208;
   i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
   $22 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
   i64toi32_i32$0 = $18;
   HEAP32[i64toi32_i32$0 >> 2] = $22;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   memcpy($0 + 8 | 0 | 0, 1137376 | 0, 56 | 0) | 0;
   i64toi32_i32$0 = $0 + 72 | 0;
   i64toi32_i32$2 = 0;
   HEAP32[i64toi32_i32$0 >> 2] = 0;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = $0;
   i64toi32_i32$2 = 0;
   HEAP32[(i64toi32_i32$0 + 64 | 0) >> 2] = 0;
   HEAP32[(i64toi32_i32$0 + 68 | 0) >> 2] = i64toi32_i32$2;
   memcpy(i64toi32_i32$0 + 100 | 0 | 0, $3 | 0, 128 | 0) | 0;
   HEAP32[(i64toi32_i32$0 + 96 | 0) >> 2] = $4;
   global$0 = $3 + 128 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1136076 | 0, 49 | 0, 1136128 | 0);
  abort();
 }
 
 function cryptoxide__hashing__blake2b__Context_____new_keyed__h3e2bc284cc15c72f($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $3 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, $4 = 0, $12 = 0, $18 = 0, $22 = 0;
  $3 = global$0 - 128 | 0;
  global$0 = $3;
  label$1 : {
   if ($2 >>> 0 > 64 >>> 0) {
    break label$1
   }
   $4 = 0;
   $3 = memset($3 | 0, 0 | 0, 128 | 0) | 0;
   label$2 : {
    if (!$2) {
     break label$2
    }
    memcpy($3 | 0, $1 | 0, $2 | 0) | 0;
    $4 = 128;
   }
   $18 = $0;
   i64toi32_i32$0 = 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = 0;
   i64toi32_i32$3 = 8;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
    $12 = 0;
   } else {
    i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
    $12 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   }
   i64toi32_i32$0 = $12;
   i64toi32_i32$2 = 1779033703;
   i64toi32_i32$3 = -222443192;
   i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
   $22 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
   i64toi32_i32$0 = $18;
   HEAP32[i64toi32_i32$0 >> 2] = $22;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   memcpy($0 + 8 | 0 | 0, 1137376 | 0, 56 | 0) | 0;
   i64toi32_i32$0 = $0 + 72 | 0;
   i64toi32_i32$2 = 0;
   HEAP32[i64toi32_i32$0 >> 2] = 0;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = $0;
   i64toi32_i32$2 = 0;
   HEAP32[(i64toi32_i32$0 + 64 | 0) >> 2] = 0;
   HEAP32[(i64toi32_i32$0 + 68 | 0) >> 2] = i64toi32_i32$2;
   memcpy(i64toi32_i32$0 + 100 | 0 | 0, $3 | 0, 128 | 0) | 0;
   HEAP32[(i64toi32_i32$0 + 96 | 0) >> 2] = $4;
   global$0 = $3 + 128 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1136076 | 0, 49 | 0, 1136128 | 0);
  abort();
 }
 
 function cryptoxide__hashing__blake2b__Context_____new_keyed__h4eadb007ddfc845f($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $3 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, $4 = 0, $12 = 0, $18 = 0, $22 = 0;
  $3 = global$0 - 128 | 0;
  global$0 = $3;
  label$1 : {
   if ($2 >>> 0 > 64 >>> 0) {
    break label$1
   }
   $4 = 0;
   $3 = memset($3 | 0, 0 | 0, 128 | 0) | 0;
   label$2 : {
    if (!$2) {
     break label$2
    }
    memcpy($3 | 0, $1 | 0, $2 | 0) | 0;
    $4 = 128;
   }
   $18 = $0;
   i64toi32_i32$0 = 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = 0;
   i64toi32_i32$3 = 8;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
    $12 = 0;
   } else {
    i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
    $12 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   }
   i64toi32_i32$0 = $12;
   i64toi32_i32$2 = 1779033703;
   i64toi32_i32$3 = -222443220;
   i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
   $22 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
   i64toi32_i32$0 = $18;
   HEAP32[i64toi32_i32$0 >> 2] = $22;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   memcpy($0 + 8 | 0 | 0, 1137376 | 0, 56 | 0) | 0;
   i64toi32_i32$0 = $0 + 72 | 0;
   i64toi32_i32$2 = 0;
   HEAP32[i64toi32_i32$0 >> 2] = 0;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = $0;
   i64toi32_i32$2 = 0;
   HEAP32[(i64toi32_i32$0 + 64 | 0) >> 2] = 0;
   HEAP32[(i64toi32_i32$0 + 68 | 0) >> 2] = i64toi32_i32$2;
   memcpy(i64toi32_i32$0 + 100 | 0 | 0, $3 | 0, 128 | 0) | 0;
   HEAP32[(i64toi32_i32$0 + 96 | 0) >> 2] = $4;
   global$0 = $3 + 128 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1136076 | 0, 49 | 0, 1136128 | 0);
  abort();
 }
 
 function cryptoxide__hashing__blake2b__Context_____new_keyed__h61ab3f6f390b3877($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $3 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, $4 = 0, $12 = 0, $18 = 0, $22 = 0;
  $3 = global$0 - 128 | 0;
  global$0 = $3;
  label$1 : {
   if ($2 >>> 0 > 64 >>> 0) {
    break label$1
   }
   $4 = 0;
   $3 = memset($3 | 0, 0 | 0, 128 | 0) | 0;
   label$2 : {
    if (!$2) {
     break label$2
    }
    memcpy($3 | 0, $1 | 0, $2 | 0) | 0;
    $4 = 128;
   }
   $18 = $0;
   i64toi32_i32$0 = 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = 0;
   i64toi32_i32$3 = 8;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
    $12 = 0;
   } else {
    i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
    $12 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   }
   i64toi32_i32$0 = $12;
   i64toi32_i32$2 = 1779033703;
   i64toi32_i32$3 = -222443254;
   i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
   $22 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
   i64toi32_i32$0 = $18;
   HEAP32[i64toi32_i32$0 >> 2] = $22;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   memcpy($0 + 8 | 0 | 0, 1137376 | 0, 56 | 0) | 0;
   i64toi32_i32$0 = $0 + 72 | 0;
   i64toi32_i32$2 = 0;
   HEAP32[i64toi32_i32$0 >> 2] = 0;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = $0;
   i64toi32_i32$2 = 0;
   HEAP32[(i64toi32_i32$0 + 64 | 0) >> 2] = 0;
   HEAP32[(i64toi32_i32$0 + 68 | 0) >> 2] = i64toi32_i32$2;
   memcpy(i64toi32_i32$0 + 100 | 0 | 0, $3 | 0, 128 | 0) | 0;
   HEAP32[(i64toi32_i32$0 + 96 | 0) >> 2] = $4;
   global$0 = $3 + 128 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1136076 | 0, 49 | 0, 1136128 | 0);
  abort();
 }
 
 function cryptoxide__hashing__blake2b__Context_____new_keyed__h61c8c37774cd350f($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $3 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, $4 = 0, $12 = 0, $18 = 0, $22 = 0;
  $3 = global$0 - 128 | 0;
  global$0 = $3;
  label$1 : {
   if ($2 >>> 0 > 64 >>> 0) {
    break label$1
   }
   $4 = 0;
   $3 = memset($3 | 0, 0 | 0, 128 | 0) | 0;
   label$2 : {
    if (!$2) {
     break label$2
    }
    memcpy($3 | 0, $1 | 0, $2 | 0) | 0;
    $4 = 128;
   }
   $18 = $0;
   i64toi32_i32$0 = 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = 0;
   i64toi32_i32$3 = 8;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
    $12 = 0;
   } else {
    i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
    $12 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   }
   i64toi32_i32$0 = $12;
   i64toi32_i32$2 = 1779033703;
   i64toi32_i32$3 = -222443255;
   i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
   $22 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
   i64toi32_i32$0 = $18;
   HEAP32[i64toi32_i32$0 >> 2] = $22;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   memcpy($0 + 8 | 0 | 0, 1137376 | 0, 56 | 0) | 0;
   i64toi32_i32$0 = $0 + 72 | 0;
   i64toi32_i32$2 = 0;
   HEAP32[i64toi32_i32$0 >> 2] = 0;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = $0;
   i64toi32_i32$2 = 0;
   HEAP32[(i64toi32_i32$0 + 64 | 0) >> 2] = 0;
   HEAP32[(i64toi32_i32$0 + 68 | 0) >> 2] = i64toi32_i32$2;
   memcpy(i64toi32_i32$0 + 100 | 0 | 0, $3 | 0, 128 | 0) | 0;
   HEAP32[(i64toi32_i32$0 + 96 | 0) >> 2] = $4;
   global$0 = $3 + 128 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1136076 | 0, 49 | 0, 1136128 | 0);
  abort();
 }
 
 function cryptoxide__hashing__blake2b__Context_____new_keyed__h69bf216b6ea6caf9($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $3 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, $4 = 0, $12 = 0, $18 = 0, $22 = 0;
  $3 = global$0 - 128 | 0;
  global$0 = $3;
  label$1 : {
   if ($2 >>> 0 > 64 >>> 0) {
    break label$1
   }
   $4 = 0;
   $3 = memset($3 | 0, 0 | 0, 128 | 0) | 0;
   label$2 : {
    if (!$2) {
     break label$2
    }
    memcpy($3 | 0, $1 | 0, $2 | 0) | 0;
    $4 = 128;
   }
   $18 = $0;
   i64toi32_i32$0 = 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = 0;
   i64toi32_i32$3 = 8;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
    $12 = 0;
   } else {
    i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
    $12 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   }
   i64toi32_i32$0 = $12;
   i64toi32_i32$2 = 1779033703;
   i64toi32_i32$3 = -222443224;
   i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
   $22 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
   i64toi32_i32$0 = $18;
   HEAP32[i64toi32_i32$0 >> 2] = $22;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   memcpy($0 + 8 | 0 | 0, 1137376 | 0, 56 | 0) | 0;
   i64toi32_i32$0 = $0 + 72 | 0;
   i64toi32_i32$2 = 0;
   HEAP32[i64toi32_i32$0 >> 2] = 0;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = $0;
   i64toi32_i32$2 = 0;
   HEAP32[(i64toi32_i32$0 + 64 | 0) >> 2] = 0;
   HEAP32[(i64toi32_i32$0 + 68 | 0) >> 2] = i64toi32_i32$2;
   memcpy(i64toi32_i32$0 + 100 | 0 | 0, $3 | 0, 128 | 0) | 0;
   HEAP32[(i64toi32_i32$0 + 96 | 0) >> 2] = $4;
   global$0 = $3 + 128 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1136076 | 0, 49 | 0, 1136128 | 0);
  abort();
 }
 
 function cryptoxide__hashing__blake2b__Context_____new_keyed__h8dffec56a0f93183($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $3 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, $4 = 0, $12 = 0, $18 = 0, $22 = 0;
  $3 = global$0 - 128 | 0;
  global$0 = $3;
  label$1 : {
   if ($2 >>> 0 > 64 >>> 0) {
    break label$1
   }
   $4 = 0;
   $3 = memset($3 | 0, 0 | 0, 128 | 0) | 0;
   label$2 : {
    if (!$2) {
     break label$2
    }
    memcpy($3 | 0, $1 | 0, $2 | 0) | 0;
    $4 = 128;
   }
   $18 = $0;
   i64toi32_i32$0 = 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = 0;
   i64toi32_i32$3 = 8;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
    $12 = 0;
   } else {
    i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
    $12 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   }
   i64toi32_i32$0 = $12;
   i64toi32_i32$2 = 1779033703;
   i64toi32_i32$3 = -222443264;
   i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
   $22 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
   i64toi32_i32$0 = $18;
   HEAP32[i64toi32_i32$0 >> 2] = $22;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   memcpy($0 + 8 | 0 | 0, 1137376 | 0, 56 | 0) | 0;
   i64toi32_i32$0 = $0 + 72 | 0;
   i64toi32_i32$2 = 0;
   HEAP32[i64toi32_i32$0 >> 2] = 0;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = $0;
   i64toi32_i32$2 = 0;
   HEAP32[(i64toi32_i32$0 + 64 | 0) >> 2] = 0;
   HEAP32[(i64toi32_i32$0 + 68 | 0) >> 2] = i64toi32_i32$2;
   memcpy(i64toi32_i32$0 + 100 | 0 | 0, $3 | 0, 128 | 0) | 0;
   HEAP32[(i64toi32_i32$0 + 96 | 0) >> 2] = $4;
   global$0 = $3 + 128 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1136076 | 0, 49 | 0, 1136128 | 0);
  abort();
 }
 
 function cryptoxide__hashing__blake2b__Context_____new_keyed__had6d6d435e04cb52($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $3 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, $4 = 0, $12 = 0, $18 = 0, $22 = 0;
  $3 = global$0 - 128 | 0;
  global$0 = $3;
  label$1 : {
   if ($2 >>> 0 > 64 >>> 0) {
    break label$1
   }
   $4 = 0;
   $3 = memset($3 | 0, 0 | 0, 128 | 0) | 0;
   label$2 : {
    if (!$2) {
     break label$2
    }
    memcpy($3 | 0, $1 | 0, $2 | 0) | 0;
    $4 = 128;
   }
   $18 = $0;
   i64toi32_i32$0 = 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = 0;
   i64toi32_i32$3 = 8;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
    $12 = 0;
   } else {
    i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
    $12 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   }
   i64toi32_i32$0 = $12;
   i64toi32_i32$2 = 1779033703;
   i64toi32_i32$3 = -222443223;
   i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
   $22 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
   i64toi32_i32$0 = $18;
   HEAP32[i64toi32_i32$0 >> 2] = $22;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   memcpy($0 + 8 | 0 | 0, 1137376 | 0, 56 | 0) | 0;
   i64toi32_i32$0 = $0 + 72 | 0;
   i64toi32_i32$2 = 0;
   HEAP32[i64toi32_i32$0 >> 2] = 0;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = $0;
   i64toi32_i32$2 = 0;
   HEAP32[(i64toi32_i32$0 + 64 | 0) >> 2] = 0;
   HEAP32[(i64toi32_i32$0 + 68 | 0) >> 2] = i64toi32_i32$2;
   memcpy(i64toi32_i32$0 + 100 | 0 | 0, $3 | 0, 128 | 0) | 0;
   HEAP32[(i64toi32_i32$0 + 96 | 0) >> 2] = $4;
   global$0 = $3 + 128 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1136076 | 0, 49 | 0, 1136128 | 0);
  abort();
 }
 
 function cryptoxide__hashing__blake2b__Context_____new_keyed__hcb22d04e84ffb126($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $3 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, $4 = 0, $12 = 0, $18 = 0, $22 = 0;
  $3 = global$0 - 128 | 0;
  global$0 = $3;
  label$1 : {
   if ($2 >>> 0 > 64 >>> 0) {
    break label$1
   }
   $4 = 0;
   $3 = memset($3 | 0, 0 | 0, 128 | 0) | 0;
   label$2 : {
    if (!$2) {
     break label$2
    }
    memcpy($3 | 0, $1 | 0, $2 | 0) | 0;
    $4 = 128;
   }
   $18 = $0;
   i64toi32_i32$0 = 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = 0;
   i64toi32_i32$3 = 8;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
    $12 = 0;
   } else {
    i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
    $12 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   }
   i64toi32_i32$0 = $12;
   i64toi32_i32$2 = 1779033703;
   i64toi32_i32$3 = -222443252;
   i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
   $22 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
   i64toi32_i32$0 = $18;
   HEAP32[i64toi32_i32$0 >> 2] = $22;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   memcpy($0 + 8 | 0 | 0, 1137376 | 0, 56 | 0) | 0;
   i64toi32_i32$0 = $0 + 72 | 0;
   i64toi32_i32$2 = 0;
   HEAP32[i64toi32_i32$0 >> 2] = 0;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = $0;
   i64toi32_i32$2 = 0;
   HEAP32[(i64toi32_i32$0 + 64 | 0) >> 2] = 0;
   HEAP32[(i64toi32_i32$0 + 68 | 0) >> 2] = i64toi32_i32$2;
   memcpy(i64toi32_i32$0 + 100 | 0 | 0, $3 | 0, 128 | 0) | 0;
   HEAP32[(i64toi32_i32$0 + 96 | 0) >> 2] = $4;
   global$0 = $3 + 128 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1136076 | 0, 49 | 0, 1136128 | 0);
  abort();
 }
 
 function cryptoxide__hashing__blake2b__Context_____new_keyed__hdc22e70268b93c53($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $3 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, $4 = 0, $12 = 0, $18 = 0, $22 = 0;
  $3 = global$0 - 128 | 0;
  global$0 = $3;
  label$1 : {
   if ($2 >>> 0 > 64 >>> 0) {
    break label$1
   }
   $4 = 0;
   $3 = memset($3 | 0, 0 | 0, 128 | 0) | 0;
   label$2 : {
    if (!$2) {
     break label$2
    }
    memcpy($3 | 0, $1 | 0, $2 | 0) | 0;
    $4 = 128;
   }
   $18 = $0;
   i64toi32_i32$0 = 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = 0;
   i64toi32_i32$3 = 8;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
    $12 = 0;
   } else {
    i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
    $12 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   }
   i64toi32_i32$0 = $12;
   i64toi32_i32$2 = 1779033703;
   i64toi32_i32$3 = -222443232;
   i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
   $22 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
   i64toi32_i32$0 = $18;
   HEAP32[i64toi32_i32$0 >> 2] = $22;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   memcpy($0 + 8 | 0 | 0, 1137376 | 0, 56 | 0) | 0;
   i64toi32_i32$0 = $0 + 72 | 0;
   i64toi32_i32$2 = 0;
   HEAP32[i64toi32_i32$0 >> 2] = 0;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$0 = $0;
   i64toi32_i32$2 = 0;
   HEAP32[(i64toi32_i32$0 + 64 | 0) >> 2] = 0;
   HEAP32[(i64toi32_i32$0 + 68 | 0) >> 2] = i64toi32_i32$2;
   memcpy(i64toi32_i32$0 + 100 | 0 | 0, $3 | 0, 128 | 0) | 0;
   HEAP32[(i64toi32_i32$0 + 96 | 0) >> 2] = $4;
   global$0 = $3 + 128 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1136076 | 0, 49 | 0, 1136128 | 0);
  abort();
 }
 
 function core__fmt__num___impl_20core__fmt__LowerHex_20for_20i32___fmt__h9723d6e56c381fda($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $3 = 0, $2 = 0, $4 = 0;
  $2 = global$0 - 128 | 0;
  global$0 = $2;
  $3 = HEAP32[$0 >> 2] | 0;
  $0 = 0;
  label$1 : while (1) {
   $4 = $3 & 15 | 0;
   HEAP8[(($2 + $0 | 0) + 127 | 0) >> 0] = $4 >>> 0 < 10 >>> 0 ? $4 | 48 | 0 : $4 + 87 | 0;
   $0 = $0 + -1 | 0;
   $3 = $3 >>> 4 | 0;
   if ($3) {
    continue label$1
   }
   break label$1;
  };
  label$2 : {
   $3 = $0 + 128 | 0;
   if ($3 >>> 0 < 129 >>> 0) {
    break label$2
   }
   core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($3 | 0, 128 | 0, 1150164 | 0);
   abort();
  }
  $0 = core__fmt__Formatter__pad_integral__h08e3e53a0de517a1($1 | 0, 1 | 0, 1150180 | 0, 2 | 0, ($2 + $0 | 0) + 128 | 0 | 0, 0 - $0 | 0 | 0) | 0;
  global$0 = $2 + 128 | 0;
  return $0 | 0;
 }
 
 function core__fmt__num___impl_20core__fmt__UpperHex_20for_20i32___fmt__h135eeaf75c8aff9c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $3 = 0, $2 = 0, $4 = 0;
  $2 = global$0 - 128 | 0;
  global$0 = $2;
  $3 = HEAP32[$0 >> 2] | 0;
  $0 = 0;
  label$1 : while (1) {
   $4 = $3 & 15 | 0;
   HEAP8[(($2 + $0 | 0) + 127 | 0) >> 0] = $4 >>> 0 < 10 >>> 0 ? $4 | 48 | 0 : $4 + 55 | 0;
   $0 = $0 + -1 | 0;
   $3 = $3 >>> 4 | 0;
   if ($3) {
    continue label$1
   }
   break label$1;
  };
  label$2 : {
   $3 = $0 + 128 | 0;
   if ($3 >>> 0 < 129 >>> 0) {
    break label$2
   }
   core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($3 | 0, 128 | 0, 1150164 | 0);
   abort();
  }
  $0 = core__fmt__Formatter__pad_integral__h08e3e53a0de517a1($1 | 0, 1 | 0, 1150180 | 0, 2 | 0, ($2 + $0 | 0) + 128 | 0 | 0, 0 - $0 | 0 | 0) | 0;
  global$0 = $2 + 128 | 0;
  return $0 | 0;
 }
 
 function relay_as_multi_host_name($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $3 = 0, $4 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb17ff77b9b324998($1 + 8 | 0 | 0, $0 | 0);
   $2 = 0;
   $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   $0 = 0;
   label$2 : {
    $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    if ((HEAPU16[$4 >> 1] | 0 | 0) != (2 | 0)) {
     break label$2
    }
    $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($1 + 16 | 0 | 0, $4 + 4 | 0 | 0);
    $0 = HEAP32[($1 + 16 | 0) >> 2] | 0;
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
   label$3 : {
    if (!$0) {
     break label$3
    }
    i64toi32_i32$1 = HEAP32[($1 + 24 | 0) >> 2] | 0;
    HEAP32[($1 + 36 | 0) >> 2] = HEAP32[($1 + 20 | 0) >> 2] | 0;
    HEAP32[($1 + 40 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($1 + 32 | 0) >> 2] = $0;
    $2 = $cardano_serialization_lib__MultiHostName_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h36c70b81dbc68c79($1 + 32 | 0 | 0) | 0;
   }
   global$0 = $1 + 48 | 0;
   return $2 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionwitnessset_native_scripts($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $3 = 0, $4 = 0, $5 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__he0885d10b4548804($1 + 8 | 0 | 0, $0 | 0);
   $2 = 0;
   $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   $0 = 0;
   label$2 : {
    $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    $5 = HEAP32[($4 + 12 | 0) >> 2] | 0;
    if (!$5) {
     break label$2
    }
    alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($1 + 16 | 0 | 0, $5 | 0, HEAP32[($4 + 20 | 0) >> 2] | 0 | 0);
    $0 = HEAP32[($1 + 16 | 0) >> 2] | 0;
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
   label$3 : {
    if (!$0) {
     break label$3
    }
    i64toi32_i32$1 = HEAP32[($1 + 24 | 0) >> 2] | 0;
    HEAP32[($1 + 36 | 0) >> 2] = HEAP32[($1 + 20 | 0) >> 2] | 0;
    HEAP32[($1 + 40 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($1 + 32 | 0) >> 2] = $0;
    $2 = $cardano_serialization_lib__NativeScripts_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hd952f91bbdbbead8($1 + 32 | 0 | 0) | 0;
   }
   global$0 = $1 + 48 | 0;
   return $2 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function auxiliarydata_native_scripts($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $3 = 0, $4 = 0, $5 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hdd9a557acdd7acfa($1 + 8 | 0 | 0, $0 | 0);
   $2 = 0;
   $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   $0 = 0;
   label$2 : {
    $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    $5 = HEAP32[($4 + 40 | 0) >> 2] | 0;
    if (!$5) {
     break label$2
    }
    alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($1 + 16 | 0 | 0, $5 | 0, HEAP32[($4 + 48 | 0) >> 2] | 0 | 0);
    $0 = HEAP32[($1 + 16 | 0) >> 2] | 0;
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
   label$3 : {
    if (!$0) {
     break label$3
    }
    i64toi32_i32$1 = HEAP32[($1 + 24 | 0) >> 2] | 0;
    HEAP32[($1 + 36 | 0) >> 2] = HEAP32[($1 + 20 | 0) >> 2] | 0;
    HEAP32[($1 + 40 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($1 + 32 | 0) >> 2] = $0;
    $2 = $cardano_serialization_lib__NativeScripts_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hd952f91bbdbbead8($1 + 32 | 0 | 0) | 0;
   }
   global$0 = $1 + 48 | 0;
   return $2 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionbuilder_get_mint_scripts($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $3 = 0, $4 = 0, $5 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h37dfbd2f31d951c1($1 + 8 | 0 | 0, $0 | 0);
   $2 = 0;
   $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   $0 = 0;
   label$2 : {
    $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    $5 = HEAP32[($4 + 456 | 0) >> 2] | 0;
    if (!$5) {
     break label$2
    }
    alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($1 + 16 | 0 | 0, $5 | 0, HEAP32[($4 + 464 | 0) >> 2] | 0 | 0);
    $0 = HEAP32[($1 + 16 | 0) >> 2] | 0;
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
   label$3 : {
    if (!$0) {
     break label$3
    }
    i64toi32_i32$1 = HEAP32[($1 + 24 | 0) >> 2] | 0;
    HEAP32[($1 + 36 | 0) >> 2] = HEAP32[($1 + 20 | 0) >> 2] | 0;
    HEAP32[($1 + 40 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($1 + 32 | 0) >> 2] = $0;
    $2 = $cardano_serialization_lib__NativeScripts_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hd952f91bbdbbead8($1 + 32 | 0 | 0) | 0;
   }
   global$0 = $1 + 48 | 0;
   return $2 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h2d454d4f9b2e44f3($0) {
  $0 = $0 | 0;
  var $2 = 0, $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $1 = Math_imul($1, 24);
   $0 = (HEAP32[$0 >> 2] | 0) + 4 | 0;
   label$2 : while (1) {
    label$3 : {
     label$4 : {
      switch (HEAPU8[($0 + -4 | 0) >> 0] | 0 | 0) {
      default:
       $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h0198cfc402357e50($0 | 0);
       break label$3;
      case 3:
       $2 = HEAP32[($0 + 4 | 0) >> 2] | 0;
       if (!$2) {
        break label$3
       }
       __rust_dealloc(HEAP32[$0 >> 2] | 0 | 0, $2 | 0, 1 | 0);
       break label$3;
      case 0:
      case 1:
      case 2:
       break label$3;
      case 4:
       break label$4;
      };
     }
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h2d454d4f9b2e44f3($0 | 0);
     $2 = HEAP32[($0 + 4 | 0) >> 2] | 0;
     if (!$2) {
      break label$3
     }
     $2 = Math_imul($2, 24);
     if (!$2) {
      break label$3
     }
     __rust_dealloc(HEAP32[$0 >> 2] | 0 | 0, $2 | 0, 8 | 0);
    }
    $0 = $0 + 24 | 0;
    $1 = $1 + -24 | 0;
    if ($1) {
     continue label$2
    }
    break label$2;
   };
  }
 }
 
 function transactionbody_set_certs($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h238818d95bb6c551($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h0d8537c364f480d5($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h965baa5031061a2e($2 + 16 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__Certificates____h3bab90286ab8bbb4($0 + 152 | 0 | 0);
   HEAP32[($0 + 160 | 0) >> 2] = HEAP32[($2 + 24 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   HEAP32[($0 + 152 | 0) >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
   HEAP32[($0 + 156 | 0) >> 2] = i64toi32_i32$1;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 32 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionbody_certs($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $3 = 0, $4 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h356c30395cf13adb($1 + 8 | 0 | 0, $0 | 0);
   $2 = 0;
   $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   $0 = 0;
   label$2 : {
    $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    if (!(HEAP32[($4 + 152 | 0) >> 2] | 0)) {
     break label$2
    }
    $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h965baa5031061a2e($1 + 16 | 0 | 0, $4 + 152 | 0 | 0);
    $0 = HEAP32[($1 + 16 | 0) >> 2] | 0;
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
   label$3 : {
    if (!$0) {
     break label$3
    }
    i64toi32_i32$1 = HEAP32[($1 + 24 | 0) >> 2] | 0;
    HEAP32[($1 + 36 | 0) >> 2] = HEAP32[($1 + 20 | 0) >> 2] | 0;
    HEAP32[($1 + 40 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($1 + 32 | 0) >> 2] = $0;
    $2 = $cardano_serialization_lib__Certificates_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h2d4d31bc412465af($1 + 32 | 0 | 0) | 0;
   }
   global$0 = $1 + 48 | 0;
   return $2 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionbody_collateral($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $3 = 0, $4 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h356c30395cf13adb($1 + 8 | 0 | 0, $0 | 0);
   $2 = 0;
   $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   $0 = 0;
   label$2 : {
    $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    if (!(HEAP32[($4 + 180 | 0) >> 2] | 0)) {
     break label$2
    }
    $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hfe677107e1954f8f($1 + 16 | 0 | 0, $4 + 180 | 0 | 0);
    $0 = HEAP32[($1 + 16 | 0) >> 2] | 0;
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
   label$3 : {
    if (!$0) {
     break label$3
    }
    i64toi32_i32$1 = HEAP32[($1 + 24 | 0) >> 2] | 0;
    HEAP32[($1 + 36 | 0) >> 2] = HEAP32[($1 + 20 | 0) >> 2] | 0;
    HEAP32[($1 + 40 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($1 + 32 | 0) >> 2] = $0;
    $2 = $cardano_serialization_lib__TransactionInputs_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__haa89884e18e43552($1 + 32 | 0 | 0) | 0;
   }
   global$0 = $1 + 48 | 0;
   return $2 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionbody_required_signers($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $3 = 0, $4 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h356c30395cf13adb($1 + 8 | 0 | 0, $0 | 0);
   $2 = 0;
   $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   $0 = 0;
   label$2 : {
    $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    if (!(HEAP32[($4 + 192 | 0) >> 2] | 0)) {
     break label$2
    }
    $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h25db889dc58a550d($1 + 16 | 0 | 0, $4 + 192 | 0 | 0);
    $0 = HEAP32[($1 + 16 | 0) >> 2] | 0;
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
   label$3 : {
    if (!$0) {
     break label$3
    }
    i64toi32_i32$1 = HEAP32[($1 + 24 | 0) >> 2] | 0;
    HEAP32[($1 + 36 | 0) >> 2] = HEAP32[($1 + 20 | 0) >> 2] | 0;
    HEAP32[($1 + 40 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($1 + 32 | 0) >> 2] = $0;
    $2 = $cardano_serialization_lib__Ed25519KeyHashes_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h2ef8a4685b78a9d8($1 + 32 | 0 | 0) | 0;
   }
   global$0 = $1 + 48 | 0;
   return $2 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function moveinstantaneousreward_new_to_stake_creds($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 128 | 0;
  global$0 = $2;
  $3 = 0;
  label$1 : {
   switch ($0 | 0) {
   default:
    wasm_bindgen__throw_str__h40ff0247f6a635d7(1053512 | 0, 25 | 0);
    abort();
   case 1:
    $3 = 1;
    break;
   case 0:
    break label$1;
   };
  }
  label$4 : {
   if ($1) {
    break label$4
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h74054450d591b36f($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h7490700a7eed2994($2 + 24 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 1;
  HEAP32[($2 + 20 | 0) >> 2] = 0;
  HEAP8[($2 + 64 | 0) >> 0] = $3;
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  memcpy($2 + 72 | 0 | 0, $2 + 16 | 0 | 0, 56 | 0) | 0;
  $1 = $cardano_serialization_lib__MoveInstantaneousReward_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hf9455bc13311e72d($2 + 72 | 0 | 0) | 0;
  global$0 = $2 + 128 | 0;
  return $1 | 0;
 }
 
 function cardano_serialization_lib__RewardAddresses__get__h0d82acc0fadea368($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $11 = 0, $12 = 0, $13 = 0, $14 = 0, $15 = 0, $16 = 0, $3 = 0, $4 = 0, $26 = 0, $31 = 0, $36 = 0;
  $3 = global$0 - 32 | 0;
  global$0 = $3;
  label$1 : {
   $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   if ($4 >>> 0 > $2 >>> 0) {
    break label$1
   }
   core__panicking__panic_bounds_check__h808b524af17640b1($2 | 0, $4 | 0, 1053860 | 0);
   abort();
  }
  $2 = (HEAP32[$1 >> 2] | 0) + Math_imul($2, 30) | 0;
  $1 = HEAPU8[$2 >> 0] | 0;
  i64toi32_i32$2 = $2 + 2 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $26 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 2 | 0;
  $11 = $26;
  HEAP8[i64toi32_i32$0 >> 0] = $11;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 10 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $31 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 10 | 0;
  $12 = $31;
  HEAP8[i64toi32_i32$1 >> 0] = $12;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 18 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $36 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 18 | 0;
  $13 = $36;
  HEAP8[i64toi32_i32$0 >> 0] = $13;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $14 = $2 + 26 | 0;
  $15 = $0 + 26 | 0;
  $16 = HEAPU8[$14 >> 0] | 0 | ((HEAPU8[($14 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($14 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($14 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  HEAP8[$15 >> 0] = $16;
  HEAP8[($15 + 1 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[($15 + 2 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[($15 + 3 | 0) >> 0] = $16 >>> 24 | 0;
  HEAP8[($0 + 1 | 0) >> 0] = HEAPU8[($2 + 1 | 0) >> 0] | 0;
  HEAP8[$0 >> 0] = $1;
  global$0 = $3 + 32 | 0;
 }
 
 function transactionwitnessset_set_bootstraps($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h1cc4e67284701531($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hab914e4e14c49c39($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h09a8331f58cd0bf4($2 + 16 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__crypto__BootstrapWitnesses____h365708acbcf06e1e($0 + 24 | 0 | 0);
   HEAP32[($0 + 32 | 0) >> 2] = HEAP32[($2 + 24 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   HEAP32[($0 + 24 | 0) >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
   HEAP32[($0 + 28 | 0) >> 2] = i64toi32_i32$1;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 32 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionwitnessset_bootstraps($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $3 = 0, $4 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__he0885d10b4548804($1 + 8 | 0 | 0, $0 | 0);
   $2 = 0;
   $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   $0 = 0;
   label$2 : {
    $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    if (!(HEAP32[($4 + 24 | 0) >> 2] | 0)) {
     break label$2
    }
    $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h09a8331f58cd0bf4($1 + 16 | 0 | 0, $4 + 24 | 0 | 0);
    $0 = HEAP32[($1 + 16 | 0) >> 2] | 0;
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
   label$3 : {
    if (!$0) {
     break label$3
    }
    i64toi32_i32$1 = HEAP32[($1 + 24 | 0) >> 2] | 0;
    HEAP32[($1 + 36 | 0) >> 2] = HEAP32[($1 + 20 | 0) >> 2] | 0;
    HEAP32[($1 + 40 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($1 + 32 | 0) >> 2] = $0;
    $2 = $cardano_serialization_lib__crypto__BootstrapWitnesses_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__ha47785b575a14436($1 + 32 | 0 | 0) | 0;
   }
   global$0 = $1 + 48 | 0;
   return $2 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionwitnessset_set_plutus_scripts($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h1cc4e67284701531($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hbb8371c94476a171($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hc722e22117ee5940($2 + 16 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__plutus__PlutusScripts____h6be1d55eac328b7f($0 + 36 | 0 | 0);
   HEAP32[($0 + 44 | 0) >> 2] = HEAP32[($2 + 24 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   HEAP32[($0 + 36 | 0) >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
   HEAP32[($0 + 40 | 0) >> 2] = i64toi32_i32$1;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 32 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionwitnessset_plutus_scripts($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $3 = 0, $4 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__he0885d10b4548804($1 + 8 | 0 | 0, $0 | 0);
   $2 = 0;
   $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   $0 = 0;
   label$2 : {
    $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    if (!(HEAP32[($4 + 36 | 0) >> 2] | 0)) {
     break label$2
    }
    $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hc722e22117ee5940($1 + 16 | 0 | 0, $4 + 36 | 0 | 0);
    $0 = HEAP32[($1 + 16 | 0) >> 2] | 0;
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
   label$3 : {
    if (!$0) {
     break label$3
    }
    i64toi32_i32$1 = HEAP32[($1 + 24 | 0) >> 2] | 0;
    HEAP32[($1 + 36 | 0) >> 2] = HEAP32[($1 + 20 | 0) >> 2] | 0;
    HEAP32[($1 + 40 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($1 + 32 | 0) >> 2] = $0;
    $2 = $cardano_serialization_lib__plutus__PlutusScripts_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hca65427e7f610652($1 + 32 | 0 | 0) | 0;
   }
   global$0 = $1 + 48 | 0;
   return $2 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionwitnessset_set_redeemers($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h1cc4e67284701531($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h6789b4b005d0c63f($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h1b9d2509f9812649($2 + 16 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__plutus__Redeemers____hd7679bbdd61edccb($0 + 64 | 0 | 0);
   HEAP32[($0 + 72 | 0) >> 2] = HEAP32[($2 + 24 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   HEAP32[($0 + 64 | 0) >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
   HEAP32[($0 + 68 | 0) >> 2] = i64toi32_i32$1;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 32 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionwitnessset_redeemers($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $3 = 0, $4 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__he0885d10b4548804($1 + 8 | 0 | 0, $0 | 0);
   $2 = 0;
   $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   $0 = 0;
   label$2 : {
    $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    if (!(HEAP32[($4 + 64 | 0) >> 2] | 0)) {
     break label$2
    }
    $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h1b9d2509f9812649($1 + 16 | 0 | 0, $4 + 64 | 0 | 0);
    $0 = HEAP32[($1 + 16 | 0) >> 2] | 0;
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
   label$3 : {
    if (!$0) {
     break label$3
    }
    i64toi32_i32$1 = HEAP32[($1 + 24 | 0) >> 2] | 0;
    HEAP32[($1 + 36 | 0) >> 2] = HEAP32[($1 + 20 | 0) >> 2] | 0;
    HEAP32[($1 + 40 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($1 + 32 | 0) >> 2] = $0;
    $2 = $cardano_serialization_lib__plutus__Redeemers_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hb4f0431e16335b87($1 + 32 | 0 | 0) | 0;
   }
   global$0 = $1 + 48 | 0;
   return $2 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function protocolparamupdate_protocol_version($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $3 = 0, $4 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hd84cc8f720a3dada($1 + 8 | 0 | 0, $0 | 0);
   $2 = 0;
   $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   $0 = 0;
   label$2 : {
    $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    if (!(HEAP32[($4 + 320 | 0) >> 2] | 0)) {
     break label$2
    }
    $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h36101af4d9989b58($1 + 16 | 0 | 0, $4 + 320 | 0 | 0);
    $0 = HEAP32[($1 + 16 | 0) >> 2] | 0;
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
   label$3 : {
    if (!$0) {
     break label$3
    }
    i64toi32_i32$1 = HEAP32[($1 + 24 | 0) >> 2] | 0;
    HEAP32[($1 + 36 | 0) >> 2] = HEAP32[($1 + 20 | 0) >> 2] | 0;
    HEAP32[($1 + 40 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($1 + 32 | 0) >> 2] = $0;
    $2 = $cardano_serialization_lib__ProtocolVersions_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h22db0982b5b147a5($1 + 32 | 0 | 0) | 0;
   }
   global$0 = $1 + 48 | 0;
   return $2 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function protocolparamupdate_set_execution_costs($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $2 = 0, i64toi32_i32$2 = 0, $4 = 0, $3 = 0, $28 = 0, $31 = 0, $34 = 0, $37 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h0a71cd742026514d($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h0a3b5f1cc5dc7523($2 | 0, $1 | 0);
   $4 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $1 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[(i64toi32_i32$1 + 192 | 0) >> 2] = 1;
   HEAP32[(i64toi32_i32$1 + 196 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $1;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
   $28 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[(i64toi32_i32$0 + 224 | 0) >> 2] = $28;
   HEAP32[(i64toi32_i32$0 + 228 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
   $31 = i64toi32_i32$1;
   i64toi32_i32$1 = $0;
   HEAP32[(i64toi32_i32$1 + 216 | 0) >> 2] = $31;
   HEAP32[(i64toi32_i32$1 + 220 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
   $34 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[(i64toi32_i32$0 + 208 | 0) >> 2] = $34;
   HEAP32[(i64toi32_i32$0 + 212 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $37 = i64toi32_i32$1;
   i64toi32_i32$1 = $0;
   HEAP32[(i64toi32_i32$1 + 200 | 0) >> 2] = $37;
   HEAP32[(i64toi32_i32$1 + 204 | 0) >> 2] = i64toi32_i32$0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($4 | 0, (HEAP32[$4 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function cardano_serialization_lib__Mint__new_from_entry__hae31aeb23b43a89f($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, $3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $19 = 0, $25 = 0, $28 = 0;
  $3 = global$0 - 64 | 0;
  global$0 = $3;
  i64toi32_i32$1 = $0;
  i64toi32_i32$0 = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
  $10 = $1 + 24 | 0;
  HEAP32[(($3 + 16 | 0) + 24 | 0) >> 2] = HEAPU8[$10 >> 0] | 0 | ((HEAPU8[($10 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($10 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($10 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $19 = i64toi32_i32$0;
  i64toi32_i32$0 = ($3 + 16 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $19;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $25 = i64toi32_i32$1;
  i64toi32_i32$1 = ($3 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $25;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $28 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[($3 + 16 | 0) >> 2] = $28;
  HEAP32[($3 + 20 | 0) >> 2] = i64toi32_i32$1;
  $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h4a35d7ddb2264390($3 + 48 | 0 | 0, $2 | 0);
  alloc__collections__btree__map__BTreeMap_K_2cV___insert__h42468afb2d22301b($3 | 0, $0 | 0, $3 + 16 | 0 | 0, $3 + 48 | 0 | 0);
  label$1 : {
   if (!(HEAP32[$3 >> 2] | 0)) {
    break label$1
   }
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h0265580a5be10b66($3 | 4 | 0 | 0);
  }
  global$0 = $3 + 64 | 0;
 }
 
 function auxiliarydata_plutus_scripts($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $3 = 0, $4 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hdd9a557acdd7acfa($1 + 8 | 0 | 0, $0 | 0);
   $2 = 0;
   $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   $0 = 0;
   label$2 : {
    $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    if (!(HEAP32[($4 + 52 | 0) >> 2] | 0)) {
     break label$2
    }
    $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hc722e22117ee5940($1 + 16 | 0 | 0, $4 + 52 | 0 | 0);
    $0 = HEAP32[($1 + 16 | 0) >> 2] | 0;
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
   label$3 : {
    if (!$0) {
     break label$3
    }
    i64toi32_i32$1 = HEAP32[($1 + 24 | 0) >> 2] | 0;
    HEAP32[($1 + 36 | 0) >> 2] = HEAP32[($1 + 20 | 0) >> 2] | 0;
    HEAP32[($1 + 40 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($1 + 32 | 0) >> 2] = $0;
    $2 = $cardano_serialization_lib__plutus__PlutusScripts_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hca65427e7f610652($1 + 32 | 0 | 0) | 0;
   }
   global$0 = $1 + 48 | 0;
   return $2 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function auxiliarydata_set_plutus_scripts($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h55a9e62aded28c25($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hbb8371c94476a171($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hc722e22117ee5940($2 + 16 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__plutus__PlutusScripts____h6be1d55eac328b7f_1($0 + 52 | 0 | 0);
   HEAP32[($0 + 60 | 0) >> 2] = HEAP32[($2 + 24 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   HEAP32[($0 + 52 | 0) >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
   HEAP32[($0 + 56 | 0) >> 2] = i64toi32_i32$1;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 32 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function $cardano_serialization_lib__crypto__Vkey_20as_20cbor_event__se__Serialize___serialize__he0fe1f32129559ab($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, $4 = 0, $12 = 0, $13 = 0, $14 = 0, $15 = 0, $19 = 0, $24 = 0, $29 = 0, $34 = 0;
  $3 = global$0 - 32 | 0;
  global$0 = $3;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($3 + 8 | 0 | 0, 32 | 0, 0 | 0);
  HEAP32[($3 + 20 | 0) >> 2] = HEAP32[($3 + 12 | 0) >> 2] | 0;
  $4 = HEAP32[($3 + 8 | 0) >> 2] | 0;
  HEAP32[($3 + 16 | 0) >> 2] = $4;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $19 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  $12 = $19;
  HEAP8[i64toi32_i32$0 >> 0] = $12;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $24 = i64toi32_i32$1;
  i64toi32_i32$1 = $4 + 8 | 0;
  $13 = $24;
  HEAP8[i64toi32_i32$1 >> 0] = $13;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $29 = i64toi32_i32$0;
  i64toi32_i32$0 = $4 + 16 | 0;
  $14 = $29;
  HEAP8[i64toi32_i32$0 >> 0] = $14;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $14 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $14 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $14 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 24 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $34 = i64toi32_i32$1;
  i64toi32_i32$1 = $4 + 24 | 0;
  $15 = $34;
  HEAP8[i64toi32_i32$1 >> 0] = $15;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $15 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $15 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $15 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  HEAP32[($3 + 24 | 0) >> 2] = 32;
  cbor_event__se__Serializer_W___write_bytes__hdbf95a6224c8b5b8($0 | 0, $2 | 0, $3 + 16 | 0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 16 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 16 | 0 | 0);
  global$0 = $3 + 32 | 0;
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___entry__h0855ee0a9acbc700($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$3) {
     break label$2
    }
    $4 = HEAP32[$1 >> 2] | 0;
    break label$1;
   }
   $4 = 0;
   $3 = alloc__boxed__Box_T_2cA___new_uninit_in__h3d7406b043db0321() | 0;
   HEAP16[($3 + 138 | 0) >> 1] = 0;
   HEAP32[$3 >> 2] = 0;
   HEAP32[($1 + 4 | 0) >> 2] = $3;
   HEAP32[$1 >> 2] = 0;
  }
  alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__ha66650412de8b037($2 + 8 | 0 | 0, $4 | 0, $3 | 0, $2 + 24 | 0 | 0);
  HEAP32[($0 + 16 | 0) >> 2] = $1;
  i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($2 + 12 | 0) >> 2] | 0;
  HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($0 + 12 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 12 | 0) >> 2] | 0;
  HEAP32[$0 >> 2] = (HEAP32[($2 + 8 | 0) >> 2] | 0) ^ 1 | 0;
  global$0 = $2 + 32 | 0;
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___insert__hd977578f5a177830($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $16 = 0, $34 = 0, $38 = 0, $41 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  $3 = ($2 + 32 | 0) + 8 | 0;
  HEAP32[$3 >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $16 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $16;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__collections__btree__map__BTreeMap_K_2cV___entry__h276688dc4fd71bb7($2 | 0, $0 | 0, $2 + 32 | 0 | 0);
  label$1 : {
   $1 = HEAP32[$2 >> 2] | 0;
   if (($1 | 0) == (1 | 0)) {
    break label$1
   }
   HEAP32[($2 + 56 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
   i64toi32_i32$2 = $2 + 20 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $34 = i64toi32_i32$1;
   i64toi32_i32$1 = $2 + 48 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $34;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $2 + 12 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $38 = i64toi32_i32$0;
   i64toi32_i32$0 = $3;
   HEAP32[i64toi32_i32$0 >> 2] = $38;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   $41 = i64toi32_i32$1;
   i64toi32_i32$1 = $2;
   HEAP32[($2 + 32 | 0) >> 2] = $41;
   HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$0;
   alloc__collections__btree__map__entry__VacantEntry_K_2cV___insert__hdd82dbc7f856274f($2 + 32 | 0 | 0) | 0;
  }
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function alloc__collections__btree__map__entry__OccupiedEntry_K_2cV___remove_kv__h6e6a6e92c8be056b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  HEAP8[($2 + 7 | 0) >> 0] = 0;
  HEAP32[(($2 + 64 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  HEAP32[($2 + 64 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
  HEAP32[($2 + 68 | 0) >> 2] = i64toi32_i32$1;
  alloc__collections__btree__remove___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal__2calloc__collections__btree__node__marker__KV____remove_kv_tracking__hfecb0546c62fca7a($2 + 8 | 0 | 0, $2 + 64 | 0 | 0, $2 + 7 | 0 | 0);
  memcpy($0 | 0, $2 + 8 | 0 | 0, 40 | 0) | 0;
  $1 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = (HEAP32[($1 + 8 | 0) >> 2] | 0) + -1 | 0;
  label$1 : {
   label$2 : {
    if (!(HEAPU8[($2 + 7 | 0) >> 0] | 0)) {
     break label$2
    }
    if (!(HEAP32[($1 + 4 | 0) >> 2] | 0)) {
     break label$1
    }
    alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Owned_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___pop_internal_level__h42385d1b71db96f4($1 | 0);
   }
   global$0 = $2 + 80 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1072048 | 0, 43 | 0, 1072264 | 0);
  abort();
 }
 
 function serde_json__read__next_or_eof__h08ccb81e81cc75b2($0) {
  $0 = $0 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $1 = 0, $2 = 0, $3 = 0, $3$hi = 0, $4$hi = 0, $5$hi = 0, $6$hi = 0, $21 = 0, $4 = 0, $5 = 0, $6 = 0, $41 = 0, $41$hi = 0, $43 = 0, $43$hi = 0, $44$hi = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   label$2 : {
    $2 = HEAP32[($0 + 8 | 0) >> 2] | 0;
    if ($2 >>> 0 >= (HEAP32[($0 + 4 | 0) >> 2] | 0) >>> 0) {
     break label$2
    }
    HEAP32[($0 + 8 | 0) >> 2] = $2 + 1 | 0;
    i64toi32_i32$2 = (HEAP32[$0 >> 2] | 0) + $2 | 0;
    i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0;
    i64toi32_i32$1 = 0;
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    i64toi32_i32$3 = 8;
    i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
     $21 = 0;
    } else {
     i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
     $21 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
    }
    $3 = $21;
    $3$hi = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    $4 = 0;
    $4$hi = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    $5 = 0;
    $5$hi = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    $6 = 0;
    $6$hi = i64toi32_i32$0;
    break label$1;
   }
   HEAP32[$1 >> 2] = 4;
   i64toi32_i32$0 = serde_json__read__error__hbb7920fc00b2536f($0 | 0, $1 | 0) | 0;
   i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
   $3 = i64toi32_i32$0;
   $3$hi = i64toi32_i32$2;
   i64toi32_i32$1 = i64toi32_i32$0;
   i64toi32_i32$0 = 0;
   i64toi32_i32$3 = 255;
   i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
   $6 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
   $6$hi = i64toi32_i32$0;
   i64toi32_i32$0 = i64toi32_i32$2;
   i64toi32_i32$2 = i64toi32_i32$1;
   i64toi32_i32$1 = 0;
   i64toi32_i32$3 = -65536;
   i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
   $4 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
   $4$hi = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$0;
   i64toi32_i32$1 = i64toi32_i32$0;
   i64toi32_i32$0 = i64toi32_i32$2;
   i64toi32_i32$2 = -1;
   i64toi32_i32$3 = 0;
   i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
   $5 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
   $5$hi = i64toi32_i32$2;
   i64toi32_i32$2 = i64toi32_i32$1;
   i64toi32_i32$1 = i64toi32_i32$0;
   i64toi32_i32$0 = -1;
   i64toi32_i32$3 = -256;
   i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
   $3 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
   $3$hi = i64toi32_i32$0;
  }
  global$0 = $1 + 16 | 0;
  i64toi32_i32$0 = $5$hi;
  i64toi32_i32$0 = $4$hi;
  i64toi32_i32$0 = $5$hi;
  i64toi32_i32$2 = $5;
  i64toi32_i32$1 = $4$hi;
  i64toi32_i32$3 = $4;
  i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
  $41 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  $41$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $3$hi;
  i64toi32_i32$0 = $3;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 65280;
  i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
  $43 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
  $43$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $41$hi;
  i64toi32_i32$1 = $41;
  i64toi32_i32$0 = $43$hi;
  i64toi32_i32$3 = $43;
  i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
  $44$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$0 = $44$hi;
  i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$3 = $6;
  i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$1;
  return i64toi32_i32$2 | 0;
 }
 
 function alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal___push__h1a08f428e14b4c52($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0;
  label$1 : {
   label$2 : {
    if (((HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) != ($3 | 0)) {
     break label$2
    }
    $0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    $3 = HEAPU16[($0 + 1458 | 0) >> 1] | 0;
    if ($3 >>> 0 <= 10 >>> 0) {
     break label$1
    }
    core__panicking__panic__h2fd385a887c8bf13(1048619 | 0, 32 | 0, 1048824 | 0);
    abort();
   }
   core__panicking__panic__h2fd385a887c8bf13(1048760 | 0, 48 | 0, 1048808 | 0);
   abort();
  }
  $5 = $3 + 1 | 0;
  HEAP16[($0 + 1458 | 0) >> 1] = $5;
  memcpy(($0 + Math_imul($3, 36) | 0) + 1060 | 0 | 0, $1 | 0, 36 | 0) | 0;
  memcpy($0 + Math_imul($3, 96) | 0 | 0, $2 | 0, 96 | 0) | 0;
  HEAP32[(($0 + ($5 << 2 | 0) | 0) + 1464 | 0) >> 2] = $4;
  HEAP16[($4 + 1456 | 0) >> 1] = $5;
  HEAP32[($4 + 1056 | 0) >> 2] = $0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__h57e52de3aa06ad25($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0, $5 = 0;
  $2 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $3 = HEAPU16[($2 + 50 | 0) >> 1] | 0;
  $4 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  $0 = $3 + ($4 ^ -1 | 0) | 0;
  HEAP16[($1 + 50 | 0) >> 1] = $0;
  label$1 : {
   label$2 : {
    if ($0 >>> 0 >= 12 >>> 0) {
     break label$2
    }
    $5 = $4 + 1 | 0;
    if (($3 - $5 | 0 | 0) != ($0 | 0)) {
     break label$1
    }
    $3 = HEAP32[(($2 + ($4 << 2 | 0) | 0) + 4 | 0) >> 2] | 0;
    memcpy($1 + 4 | 0 | 0, ($2 + ($5 << 2 | 0) | 0) + 4 | 0 | 0, $0 << 2 | 0 | 0) | 0;
    HEAP16[($2 + 50 | 0) >> 1] = $4;
    return $3 | 0;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($0 | 0, 11 | 0, 1049044 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1048988 | 0, 40 | 0, 1049028 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__h5a312e4369260a49($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0, $5 = 0;
  $2 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $3 = HEAPU16[($2 + 50 | 0) >> 1] | 0;
  $4 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  $0 = $3 + ($4 ^ -1 | 0) | 0;
  HEAP16[($1 + 50 | 0) >> 1] = $0;
  label$1 : {
   label$2 : {
    if ($0 >>> 0 >= 12 >>> 0) {
     break label$2
    }
    $5 = $4 + 1 | 0;
    if (($3 - $5 | 0 | 0) != ($0 | 0)) {
     break label$1
    }
    $3 = HEAP32[(($2 + ($4 << 2 | 0) | 0) + 4 | 0) >> 2] | 0;
    memcpy($1 + 4 | 0 | 0, ($2 + ($5 << 2 | 0) | 0) + 4 | 0 | 0, $0 << 2 | 0 | 0) | 0;
    HEAP16[($2 + 50 | 0) >> 1] = $4;
    return $3 | 0;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($0 | 0, 11 | 0, 1049044 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1048988 | 0, 40 | 0, 1049028 | 0);
  abort();
 }
 
 function certificate_as_move_instantaneous_rewards_cert($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $2$hi = 0;
  $1 = global$0 - 128 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h3b62e22150831bdc($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   cardano_serialization_lib__Certificate__as_move_instantaneous_rewards_cert__hf41f99e42b5f0eff($1 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   $0 = 0;
   label$2 : {
    i64toi32_i32$2 = $1;
    i64toi32_i32$0 = HEAP32[($1 + 16 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
    $2 = i64toi32_i32$0;
    $2$hi = i64toi32_i32$1;
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    if ((i64toi32_i32$2 | 0) == (2 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
     break label$2
    }
    i64toi32_i32$2 = $2$hi;
    i64toi32_i32$1 = $1;
    HEAP32[($1 + 72 | 0) >> 2] = $2;
    HEAP32[($1 + 76 | 0) >> 2] = i64toi32_i32$2;
    memcpy(($1 + 72 | 0) + 8 | 0 | 0, ($1 + 16 | 0) + 8 | 0 | 0, 48 | 0) | 0;
    $0 = $cardano_serialization_lib__MoveInstantaneousRewardsCert_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8b59c9ac999ad03b($1 + 72 | 0 | 0) | 0;
   }
   global$0 = $1 + 128 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function block_invalid_transactions($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, $3 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hdd2a3d9c2413fc4e($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hd36b5d149e6fd98b($2 + 16 | 0 | 0, (HEAP32[($2 + 8 | 0) >> 2] | 0) + 392 | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  $1 = ($2 + 32 | 0) + 8 | 0;
  HEAP32[$1 >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  HEAP32[($2 + 32 | 0) >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___shrink_to_fit__ha42fb43b13607cf8($2 + 32 | 0 | 0);
  $3 = HEAP32[($2 + 32 | 0) >> 2] | 0;
  HEAP32[($0 + 4 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
  HEAP32[$0 >> 2] = $3;
  global$0 = $2 + 48 | 0;
 }
 
 function cardano_serialization_lib__utils__BigNum__to_bytes__he8f0322f5990eba0($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $10 = 0, $29 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($2 + 24 | 0 | 0, $2 + 8 | 0 | 0, 0 | 0, i64toi32_i32$1 | 0, i64toi32_i32$0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1057568 | 0, 43 | 0, $2 + 72 | 0 | 0, 1057644 | 0, 1058708 | 0);
   abort();
  }
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $29 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $29;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function bignum_clamped_sub($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$3 = 0, $5 = 0, $5$hi = 0, $4$hi = 0, $4 = 0, $3 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($2 | 0, $1 | 0);
   i64toi32_i32$2 = $3;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $4 = i64toi32_i32$0;
   $4$hi = i64toi32_i32$1;
   i64toi32_i32$2 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $5 = i64toi32_i32$1;
   $5$hi = i64toi32_i32$0;
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   i64toi32_i32$0 = $4$hi;
   i64toi32_i32$0 = $5$hi;
   i64toi32_i32$0 = $4$hi;
   i64toi32_i32$2 = $4;
   i64toi32_i32$1 = $5$hi;
   i64toi32_i32$3 = $5;
   i64toi32_i32$5 = (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) + i64toi32_i32$1 | 0;
   i64toi32_i32$5 = i64toi32_i32$0 - i64toi32_i32$5 | 0;
   $5 = i64toi32_i32$2 - i64toi32_i32$3 | 0;
   $5$hi = i64toi32_i32$5;
   i64toi32_i32$5 = i64toi32_i32$0;
   i64toi32_i32$5 = $5$hi;
   i64toi32_i32$0 = $5;
   i64toi32_i32$2 = $4$hi;
   i64toi32_i32$3 = $4;
   i64toi32_i32$1 = i64toi32_i32$5 >>> 0 > i64toi32_i32$2 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$2 | 0) & i64toi32_i32$0 >>> 0 > i64toi32_i32$3 >>> 0 | 0) | 0;
   i64toi32_i32$0 = 0;
   i64toi32_i32$2 = i64toi32_i32$1 ? 0 : $5;
   i64toi32_i32$3 = i64toi32_i32$1 ? i64toi32_i32$0 : i64toi32_i32$5;
   $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810(i64toi32_i32$2 | 0, i64toi32_i32$3 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionbuilder_add_output($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $4 = 0, $3 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h5566e1c7d4aafe35($2 + 24 | 0 | 0, $0 | 0);
    if (!$1) {
     break label$2
    }
    $3 = HEAP32[($2 + 28 | 0) >> 2] | 0;
    $4 = HEAP32[($2 + 24 | 0) >> 2] | 0;
    wasm_bindgen____rt__WasmRefCell_T___borrow__h17af7d9d2d20aa0f($2 + 16 | 0 | 0, $1 | 0);
    $0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
    cardano_serialization_lib__tx_builder__TransactionBuilder__add_output__h626cdf41f713b689($2 + 8 | 0 | 0, $4 | 0, HEAP32[($2 + 16 | 0) >> 2] | 0 | 0);
    $4 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
    if ($1) {
     break label$1
    }
    global$0 = $2 + 32 | 0;
    return;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472($4 | 0);
  abort();
 }
 
 function address_from_bech32($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 144 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  HEAP32[($2 + 84 | 0) >> 2] = $1;
  $0 = HEAP32[$2 >> 2] | 0;
  HEAP32[($2 + 80 | 0) >> 2] = $0;
  cardano_serialization_lib__address__Address__from_bech32__h23213bc9f9149b82($2 + 8 | 0 | 0, $0 | 0, $1 | 0);
  core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_4($2 + 80 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
   abort();
  }
  memcpy($2 + 80 | 0 | 0, $2 + 16 | 0 | 0, 64 | 0) | 0;
  $1 = $cardano_serialization_lib__address__Address_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8ce30e61cf34786e($2 + 80 | 0 | 0) | 0;
  global$0 = $2 + 144 | 0;
  return $1 | 0;
 }
 
 function $_alloc__vec__drain__Drain_T_2cA__20as_20core__ops__drop__Drop___drop__DropGuard_T_2cA__20as_20core__ops__drop__Drop___drop__h68f792ed4e68d59e($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $4 = 0, $3 = 0, $5 = 0;
  label$1 : {
   $0 = HEAP32[$0 >> 2] | 0;
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   $2 = HEAP32[($0 + 12 | 0) >> 2] | 0;
   if (($1 | 0) == ($2 | 0)) {
    break label$1
   }
   HEAP32[($0 + 8 | 0) >> 2] = (((($2 - $1 | 0) + -4 | 0) & -4 | 0) + $1 | 0) + 4 | 0;
  }
  label$2 : {
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if (!$1) {
    break label$2
   }
   label$3 : {
    $3 = HEAP32[$0 >> 2] | 0;
    $2 = HEAP32[($0 + 16 | 0) >> 2] | 0;
    $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    if (($3 | 0) == ($4 | 0)) {
     break label$3
    }
    $5 = HEAP32[$2 >> 2] | 0;
    memmove($5 + ($4 << 2 | 0) | 0 | 0, $5 + ($3 << 2 | 0) | 0 | 0, $1 << 2 | 0 | 0) | 0;
    $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   }
   HEAP32[($2 + 8 | 0) >> 2] = $1 + $4 | 0;
  }
 }
 
 function core__fmt__builders__DebugTuple__finish__hc3c3f1efaa75a6e2($0) {
  $0 = $0 | 0;
  var $1 = 0, $3 = 0, $2 = 0;
  $1 = HEAPU8[($0 + 8 | 0) >> 0] | 0;
  label$1 : {
   $2 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if (!$2) {
    break label$1
   }
   $3 = $1 & 255 | 0;
   $1 = 1;
   label$2 : {
    if ($3) {
     break label$2
    }
    label$3 : {
     if (($2 | 0) != (1 | 0)) {
      break label$3
     }
     if (!(HEAPU8[($0 + 9 | 0) >> 0] | 0)) {
      break label$3
     }
     $3 = HEAP32[$0 >> 2] | 0;
     if ((HEAPU8[$3 >> 0] | 0) & 4 | 0) {
      break label$3
     }
     $1 = 1;
     if (FUNCTION_TABLE[HEAP32[((HEAP32[($3 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($3 + 24 | 0) >> 2] | 0, 1149896, 1) | 0) {
      break label$2
     }
    }
    $1 = HEAP32[$0 >> 2] | 0;
    $1 = FUNCTION_TABLE[HEAP32[((HEAP32[($1 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($1 + 24 | 0) >> 2] | 0, 1149897, 1) | 0;
   }
   HEAP8[($0 + 8 | 0) >> 0] = $1;
  }
  return ($1 & 255 | 0 | 0) != (0 | 0) | 0;
 }
 
 function alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal___push__h04f226b3ef6139db($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$0 = 0, $4 = 0, i64toi32_i32$1 = 0, $32 = 0;
  label$1 : {
   label$2 : {
    if (((HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) != ($2 | 0)) {
     break label$2
    }
    $0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    $2 = HEAPU16[($0 + 138 | 0) >> 1] | 0;
    if ($2 >>> 0 <= 10 >>> 0) {
     break label$1
    }
    core__panicking__panic__h2fd385a887c8bf13(1048619 | 0, 32 | 0, 1048824 | 0);
    abort();
   }
   core__panicking__panic__h2fd385a887c8bf13(1048760 | 0, 48 | 0, 1048808 | 0);
   abort();
  }
  $4 = $2 + 1 | 0;
  HEAP16[($0 + 138 | 0) >> 1] = $4;
  $2 = $0 + Math_imul($2, 12) | 0;
  HEAP32[($2 + 12 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $32 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 4 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $32;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(($0 + ($4 << 2 | 0) | 0) + 140 | 0) >> 2] = $3;
  HEAP16[($3 + 136 | 0) >> 1] = $4;
  HEAP32[$3 >> 2] = $0;
 }
 
 function alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal___push__ha06be0cc1af1dc69($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$0 = 0, $4 = 0, i64toi32_i32$1 = 0, $32 = 0;
  label$1 : {
   label$2 : {
    if (((HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) != ($2 | 0)) {
     break label$2
    }
    $0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    $2 = HEAPU16[($0 + 138 | 0) >> 1] | 0;
    if ($2 >>> 0 <= 10 >>> 0) {
     break label$1
    }
    core__panicking__panic__h2fd385a887c8bf13(1048619 | 0, 32 | 0, 1048824 | 0);
    abort();
   }
   core__panicking__panic__h2fd385a887c8bf13(1048760 | 0, 48 | 0, 1048808 | 0);
   abort();
  }
  $4 = $2 + 1 | 0;
  HEAP16[($0 + 138 | 0) >> 1] = $4;
  $2 = $0 + Math_imul($2, 12) | 0;
  HEAP32[($2 + 12 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $32 = i64toi32_i32$0;
  i64toi32_i32$0 = $2 + 4 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $32;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(($0 + ($4 << 2 | 0) | 0) + 140 | 0) >> 2] = $3;
  HEAP16[($3 + 136 | 0) >> 1] = $4;
  HEAP32[$3 >> 2] = $0;
 }
 
 function transactionbody_set_withdrawals($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h238818d95bb6c551($2 + 16 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 16 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h000099354d5ff519($2 + 8 | 0 | 0, $1 | 0);
   $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h8cac34049618832f($2 + 24 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
   $1 = $4 + 24 | 0;
   core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__Withdrawals____heaf2605773ce1c75($1 | 0);
   memcpy($1 | 0, $2 + 24 | 0 | 0, 40 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 64 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function ed25519keyhashes_to_option($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $3 = 0, $4 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h38787c785ea84973($1 + 8 | 0 | 0, $0 | 0);
   $2 = 0;
   $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   $0 = 0;
   label$2 : {
    $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    if (!(HEAP32[($4 + 8 | 0) >> 2] | 0)) {
     break label$2
    }
    $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h25db889dc58a550d($1 + 16 | 0 | 0, $4 | 0);
    $0 = HEAP32[($1 + 16 | 0) >> 2] | 0;
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
   label$3 : {
    if (!$0) {
     break label$3
    }
    i64toi32_i32$1 = HEAP32[($1 + 24 | 0) >> 2] | 0;
    HEAP32[($1 + 36 | 0) >> 2] = HEAP32[($1 + 20 | 0) >> 2] | 0;
    HEAP32[($1 + 40 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($1 + 32 | 0) >> 2] = $0;
    $2 = $cardano_serialization_lib__Ed25519KeyHashes_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h2ef8a4685b78a9d8($1 + 32 | 0 | 0) | 0;
   }
   global$0 = $1 + 48 | 0;
   return $2 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function ipv4_ip($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $8 = 0, $9 = 0, $10 = 0, i64toi32_i32$0 = 0, $3 = 0, $4 = 0, i64toi32_i32$1 = 0, $42 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h8e1034a64e070b53($2 + 24 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $3 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 + 16 | 0 | 0, 4 | 0, 0 | 0);
  $4 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $9 = $3;
  $8 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  $10 = HEAPU8[$9 >> 0] | 0 | ((HEAPU8[($9 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($9 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($9 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  HEAP8[$8 >> 0] = $10;
  HEAP8[($8 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[($8 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[($8 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[($2 + 40 | 0) >> 2] = 4;
  HEAP32[($2 + 36 | 0) >> 2] = $4;
  HEAP32[($2 + 32 | 0) >> 2] = $8;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $42 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $42;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $2 + 48 | 0;
 }
 
 function singlehostname_new($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $33 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h1715449b8810f0c1($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  HEAP16[($2 + 30 | 0) >> 1] = $0;
  HEAP16[($2 + 28 | 0) >> 1] = ($0 | 0) != (16777215 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $33 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 32 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $33;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $36;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$0;
  $1 = $cardano_serialization_lib__SingleHostName_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hc318333b1b61f10d($2 + 32 | 0 | 0) | 0;
  global$0 = $2 + 48 | 0;
  return $1 | 0;
 }
 
 function transactionwitnessset_vkeys($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $3 = 0, $4 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__he0885d10b4548804($1 + 8 | 0 | 0, $0 | 0);
   $2 = 0;
   $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   $0 = 0;
   label$2 : {
    $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    if (!(HEAP32[$4 >> 2] | 0)) {
     break label$2
    }
    $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h26733a351c1d0f0b($1 + 16 | 0 | 0, $4 | 0);
    $0 = HEAP32[($1 + 16 | 0) >> 2] | 0;
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
   label$3 : {
    if (!$0) {
     break label$3
    }
    i64toi32_i32$1 = HEAP32[($1 + 24 | 0) >> 2] | 0;
    HEAP32[($1 + 36 | 0) >> 2] = HEAP32[($1 + 20 | 0) >> 2] | 0;
    HEAP32[($1 + 40 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($1 + 32 | 0) >> 2] = $0;
    $2 = $cardano_serialization_lib__crypto__Vkeywitnesses_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h27fd70dd9b21a645($1 + 32 | 0 | 0) | 0;
   }
   global$0 = $1 + 48 | 0;
   return $2 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function cardano_serialization_lib__metadata__encode_json_value_to_metadatum__encode_number__h31f9bcd9af2979cd($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $2 = 0, i64toi32_i32$5 = 0, $2$hi = 0, $3 = 0, $3$hi = 0, $27 = 0, $28$hi = 0, $29 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $2 = i64toi32_i32$0;
  $2$hi = i64toi32_i32$1;
  label$1 : {
   label$2 : {
    label$3 : {
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $3 = i64toi32_i32$1;
     $3$hi = i64toi32_i32$0;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$1 = 0;
     i64toi32_i32$3 = 2;
     if (i64toi32_i32$0 >>> 0 > i64toi32_i32$1 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & i64toi32_i32$2 >>> 0 > i64toi32_i32$3 >>> 0 | 0) | 0) {
      break label$3
     }
     label$4 : {
      i64toi32_i32$2 = $3$hi;
      switch ($3 | 0) {
      case 2:
       break label$2;
      case 1:
       break label$3;
      default:
       break label$4;
      };
     }
     i64toi32_i32$0 = $0 + 24 | 0;
     i64toi32_i32$2 = 0;
     HEAP32[i64toi32_i32$0 >> 2] = 0;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
     i64toi32_i32$2 = $2$hi;
     i64toi32_i32$0 = $0 + 16 | 0;
     HEAP32[i64toi32_i32$0 >> 2] = $2;
     HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
     HEAP32[($0 + 8 | 0) >> 2] = 2;
     $1 = 0;
     break label$1;
    }
    i64toi32_i32$2 = $2$hi;
    i64toi32_i32$0 = $0 + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $2;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
    HEAP32[($0 + 8 | 0) >> 2] = 2;
    i64toi32_i32$3 = $2;
    i64toi32_i32$0 = 0;
    i64toi32_i32$1 = 0;
    $27 = (i64toi32_i32$3 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$2 | 0) != (i64toi32_i32$0 | 0) | 0;
    i64toi32_i32$3 = 0;
    $28$hi = i64toi32_i32$3;
    i64toi32_i32$3 = 0;
    i64toi32_i32$1 = 0;
    i64toi32_i32$2 = $28$hi;
    i64toi32_i32$0 = $27;
    i64toi32_i32$5 = (i64toi32_i32$1 >>> 0 < i64toi32_i32$0 >>> 0) + i64toi32_i32$2 | 0;
    i64toi32_i32$5 = i64toi32_i32$3 - i64toi32_i32$5 | 0;
    $29 = i64toi32_i32$1 - i64toi32_i32$0 | 0;
    i64toi32_i32$1 = $0 + 24 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $29;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$5;
    $1 = 0;
    break label$1;
   }
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1059549 | 0, 30 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
 }
 
 function $cardano_serialization_lib__metadata__TransactionMetadatum_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__hc82759b9ba0db2d8($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, $3$hi = 0;
  $2 = global$0 - 144 | 0;
  global$0 = $2;
  $cardano_serialization_lib__metadata__TransactionMetadatumEnum_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h6868ff659c396c1d($2 + 72 | 0 | 0, $1 | 0);
  i64toi32_i32$0 = 0;
  $3 = 1;
  $3$hi = i64toi32_i32$0;
  $1 = ($2 + 72 | 0) + 8 | 0;
  label$1 : {
   label$2 : {
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[($2 + 72 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 76 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    if ((i64toi32_i32$2 | 0) == (1 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
     break label$2
    }
    memcpy($2 + 8 | 0 | 0, $1 | 0, 48 | 0) | 0;
    memcpy($0 + 8 | 0 | 0, $2 + 8 | 0 | 0, 48 | 0) | 0;
    i64toi32_i32$2 = 0;
    $3 = 0;
    $3$hi = i64toi32_i32$2;
    break label$1;
   }
   memcpy($2 + 8 | 0 | 0, $1 | 0, 64 | 0) | 0;
   memcpy($0 + 8 | 0 | 0, $2 + 8 | 0 | 0, 64 | 0) | 0;
  }
  i64toi32_i32$2 = $3$hi;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $3;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$2;
  global$0 = $2 + 144 | 0;
 }
 
 function transactionmetadatum_as_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $30 = 0, $38 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if (!$1) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__hc630c86c4ab6b26d($2 + 8 | 0 | 0, $1 | 0);
    $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    cardano_serialization_lib__metadata__TransactionMetadatum__as_bytes__h9a588a46ad56b3fa($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
    $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
    if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    i64toi32_i32$2 = $2 + 24 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $30 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[($2 + 36 | 0) >> 2] = $30;
    HEAP32[($2 + 40 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($2 + 32 | 0) >> 2] = $1;
    alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
    $38 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[i64toi32_i32$1 >> 2] = $38;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    global$0 = $2 + 48 | 0;
    return;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
  abort();
 }
 
 function decode_arbitrary_bytes_from_metadatum($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $30 = 0, $38 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if (!$1) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__hc630c86c4ab6b26d($2 + 8 | 0 | 0, $1 | 0);
    $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    cardano_serialization_lib__metadata__decode_arbitrary_bytes_from_metadatum__h90421dc360c70547($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
    $1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
    if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    i64toi32_i32$2 = $2 + 24 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $30 = i64toi32_i32$0;
    i64toi32_i32$0 = $2;
    HEAP32[($2 + 36 | 0) >> 2] = $30;
    HEAP32[($2 + 40 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($2 + 32 | 0) >> 2] = $1;
    alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
    $38 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[i64toi32_i32$1 >> 2] = $38;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    global$0 = $2 + 48 | 0;
    return;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
  abort();
 }
 
 function cardano_serialization_lib__fees__min_script_fee__h862c5f4fcf338926($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $21 = 0, $25 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     $1 = $1 + 408 | 0;
     if (!(HEAP32[$1 >> 2] | 0)) {
      break label$3
     }
     cardano_serialization_lib__plutus__Redeemers__total_ex_units__h8d7844499459197f($3 + 24 | 0 | 0, $1 | 0);
     if ((HEAP32[($3 + 24 | 0) >> 2] | 0 | 0) == (1 | 0)) {
      break label$2
     }
     i64toi32_i32$2 = $3 + 40 | 0;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $21 = i64toi32_i32$0;
     i64toi32_i32$0 = $3;
     HEAP32[($3 + 16 | 0) >> 2] = $21;
     HEAP32[($3 + 20 | 0) >> 2] = i64toi32_i32$1;
     i64toi32_i32$2 = $3 + 32 | 0;
     i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     $25 = i64toi32_i32$1;
     i64toi32_i32$1 = $3;
     HEAP32[($3 + 8 | 0) >> 2] = $25;
     HEAP32[($3 + 12 | 0) >> 2] = i64toi32_i32$0;
     cardano_serialization_lib__fees__calculate_ex_units_ceil_cost__hd623ac7a5f7d8d0f($0 | 0, $3 + 8 | 0 | 0, $2 | 0);
     break label$1;
    }
    HEAP32[$0 >> 2] = 0;
    i64toi32_i32$1 = $0 + 8 | 0;
    i64toi32_i32$0 = 0;
    HEAP32[i64toi32_i32$1 >> 2] = 0;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    break label$1;
   }
   $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($3 + 28 | 0) >> 2] | 0 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
  }
  global$0 = $3 + 48 | 0;
 }
 
 function transactionbuilder_count_missing_input_scripts($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $3 = 0, i64toi32_i32$0 = 0, $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h37dfbd2f31d951c1($1 + 8 | 0 | 0, $0 | 0);
   $2 = 0;
   $0 = 0;
   label$2 : {
    $3 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 128 | 0) >> 2] | 0;
    if (!$3) {
     break label$2
    }
    $0 = HEAP32[($3 + 156 | 0) >> 2] | 0;
   }
   $4 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   label$3 : {
    if (($0 | 0) == ($3 | 0)) {
     break label$3
    }
    $2 = 0;
    label$4 : while (1) {
     i64toi32_i32$0 = HEAP32[$0 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
     i64toi32_i32$2 = i64toi32_i32$0;
     i64toi32_i32$0 = 0;
     $2 = $2 + ((i64toi32_i32$2 | 0) == (2 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) | 0;
     $0 = HEAP32[($0 + 156 | 0) >> 2] | 0;
     if (($0 | 0) != ($3 | 0)) {
      continue label$4
     }
     break label$4;
    };
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($4 | 0, (HEAP32[$4 >> 2] | 0) + -1 | 0 | 0) | 0;
   global$0 = $1 + 16 | 0;
   return $2 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function ed25519signature_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, $3 = 0, $4 = 0, i64toi32_i32$1 = 0, $40 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hd6fdee4274fe58a2($2 + 24 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $3 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 + 16 | 0 | 0, 64 | 0, 0 | 0);
  $4 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $3 = memcpy(HEAP32[($2 + 16 | 0) >> 2] | 0 | 0, $3 | 0, 64 | 0) | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[($2 + 40 | 0) >> 2] = 64;
  HEAP32[($2 + 36 | 0) >> 2] = $4;
  HEAP32[($2 + 32 | 0) >> 2] = $3;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $40 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $40;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $2 + 48 | 0;
 }
 
 function legacydaedalusprivatekey_as_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, $3 = 0, $4 = 0, i64toi32_i32$1 = 0, $40 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h6e50d398ad665042($2 + 24 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 28 | 0) >> 2] | 0;
  $3 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 + 16 | 0 | 0, 96 | 0, 0 | 0);
  $4 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $3 = memcpy(HEAP32[($2 + 16 | 0) >> 2] | 0 | 0, $3 | 0, 96 | 0) | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[($2 + 40 | 0) >> 2] = 96;
  HEAP32[($2 + 36 | 0) >> 2] = $4;
  HEAP32[($2 + 32 | 0) >> 2] = $3;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $40 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $40;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $2 + 48 | 0;
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h36101af4d9989b58($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $5 = 0, $3 = 0, $4 = 0, $6 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $3 = HEAP32[$1 >> 2] | 0;
  $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__heaa994c249e1f8a4($2 + 8 | 0 | 0, $4 | 0, 0 | 0);
  $1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  $5 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $5;
  HEAP32[$0 >> 2] = $1;
  label$1 : {
   if (!$5) {
    break label$1
   }
   $6 = $4 << 3 | 0;
   label$2 : while (1) {
    if (!$6) {
     break label$1
    }
    i64toi32_i32$1 = HEAP32[($3 + 4 | 0) >> 2] | 0;
    HEAP32[$1 >> 2] = HEAP32[$3 >> 2] | 0;
    HEAP32[($1 + 4 | 0) >> 2] = i64toi32_i32$1;
    $1 = $1 + 8 | 0;
    $6 = $6 + -8 | 0;
    $3 = $3 + 8 | 0;
    $5 = $5 + -1 | 0;
    if ($5) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 8 | 0) >> 2] = $4;
  global$0 = $2 + 16 | 0;
 }
 
 function txinputsbuilder_count_missing_input_scripts($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $3 = 0, i64toi32_i32$0 = 0, $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h2150b2b2433b33e4($1 + 8 | 0 | 0, $0 | 0);
   $2 = 0;
   $0 = 0;
   label$2 : {
    $3 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 32 | 0) >> 2] | 0;
    if (!$3) {
     break label$2
    }
    $0 = HEAP32[($3 + 156 | 0) >> 2] | 0;
   }
   $4 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   label$3 : {
    if (($0 | 0) == ($3 | 0)) {
     break label$3
    }
    $2 = 0;
    label$4 : while (1) {
     i64toi32_i32$0 = HEAP32[$0 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
     i64toi32_i32$2 = i64toi32_i32$0;
     i64toi32_i32$0 = 0;
     $2 = $2 + ((i64toi32_i32$2 | 0) == (2 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) | 0;
     $0 = HEAP32[($0 + 156 | 0) >> 2] | 0;
     if (($0 | 0) != ($3 | 0)) {
      continue label$4
     }
     break label$4;
    };
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($4 | 0, (HEAP32[$4 >> 2] | 0) + -1 | 0 | 0) | 0;
   global$0 = $1 + 16 | 0;
   return $2 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function cardano_serialization_lib__plutus__Language__to_bytes__hfc301904eed509f1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $27 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($2 + 24 | 0 | 0, $2 + 8 | 0 | 0, 0 | 0, 0 | 0, i64toi32_i32$1 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1070651 | 0, 43 | 0, $2 + 72 | 0 | 0, 1070712 | 0, 1071636 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $27 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $27;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Neg___neg__h2304cb0016645bc0($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, i64toi32_i32$6 = 0, $36 = 0, $37 = 0, $39 = 0, $40 = 0, $41 = 0, $4 = 0, $6 = 0, $6$hi = 0, $2 = 0, $2$hi = 0, $9$hi = 0, $11 = 0, $11$hi = 0, $16 = 0, $18$hi = 0, $20 = 0, $20$hi = 0, $24 = 0, $25 = 0, $27$hi = 0, $29 = 0, $29$hi = 0, $34 = 0, $36$hi = 0, $38 = 0, $38$hi = 0, $42 = 0, $43 = 0, $46 = 0, $46$hi = 0, $48 = 0, $48$hi = 0;
  $4 = $0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $6 = i64toi32_i32$0;
  $6$hi = i64toi32_i32$1;
  i64toi32_i32$1 = 2097151;
  i64toi32_i32$2 = -76;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$3 = $6;
  i64toi32_i32$4 = i64toi32_i32$2 - i64toi32_i32$3 | 0;
  i64toi32_i32$6 = i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0;
  i64toi32_i32$5 = i64toi32_i32$6 + i64toi32_i32$0 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 - i64toi32_i32$5 | 0;
  $2 = i64toi32_i32$4;
  $2$hi = i64toi32_i32$5;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$0 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $36 = i64toi32_i32$5 >>> i64toi32_i32$0 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$5 >>> i64toi32_i32$0 | 0;
   $36 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$0 | 0) | 0;
  }
  $9$hi = i64toi32_i32$2;
  i64toi32_i32$5 = $1;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 12 | 0) >> 2] | 0;
  $11 = i64toi32_i32$2;
  $11$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $9$hi;
  i64toi32_i32$5 = $36;
  i64toi32_i32$2 = $11$hi;
  i64toi32_i32$3 = $11;
  i64toi32_i32$0 = i64toi32_i32$5 - i64toi32_i32$3 | 0;
  i64toi32_i32$6 = i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0;
  i64toi32_i32$4 = i64toi32_i32$6 + i64toi32_i32$2 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 - i64toi32_i32$4 | 0;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$5 = 2097151;
  i64toi32_i32$3 = -4;
  i64toi32_i32$2 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  i64toi32_i32$4 = i64toi32_i32$2;
  i64toi32_i32$1 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
  i64toi32_i32$4 = $4;
  HEAP32[(i64toi32_i32$4 + 8 | 0) >> 2] = i64toi32_i32$2 & i64toi32_i32$3 | 0;
  HEAP32[(i64toi32_i32$4 + 12 | 0) >> 2] = i64toi32_i32$1;
  $16 = $0;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$0 = i64toi32_i32$2;
  i64toi32_i32$4 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$4 = 0;
   $37 = i64toi32_i32$1 >>> i64toi32_i32$5 | 0;
  } else {
   i64toi32_i32$4 = i64toi32_i32$1 >>> i64toi32_i32$5 | 0;
   $37 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$5 | 0) | 0;
  }
  $18$hi = i64toi32_i32$4;
  i64toi32_i32$1 = $1;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] | 0;
  $20 = i64toi32_i32$4;
  $20$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $18$hi;
  i64toi32_i32$1 = $37;
  i64toi32_i32$4 = $20$hi;
  i64toi32_i32$3 = $20;
  i64toi32_i32$5 = i64toi32_i32$1 - i64toi32_i32$3 | 0;
  i64toi32_i32$6 = i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0;
  i64toi32_i32$2 = i64toi32_i32$6 + i64toi32_i32$4 | 0;
  i64toi32_i32$2 = i64toi32_i32$0 - i64toi32_i32$2 | 0;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$1 = 2097151;
  i64toi32_i32$3 = -4;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$0 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$0 = i64toi32_i32$5 & i64toi32_i32$0 | 0;
  $24 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $16;
  HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] = $24;
  HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] = i64toi32_i32$0;
  $25 = $0;
  i64toi32_i32$0 = i64toi32_i32$5;
  i64toi32_i32$5 = i64toi32_i32$4;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$1 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $39 = i64toi32_i32$0 >>> i64toi32_i32$1 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$1 | 0;
   $39 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$1 | 0) | 0;
  }
  $27$hi = i64toi32_i32$2;
  i64toi32_i32$0 = $1;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] | 0;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] | 0;
  $29 = i64toi32_i32$2;
  $29$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $27$hi;
  i64toi32_i32$0 = $39;
  i64toi32_i32$2 = $29$hi;
  i64toi32_i32$3 = $29;
  i64toi32_i32$1 = i64toi32_i32$0 - i64toi32_i32$3 | 0;
  i64toi32_i32$6 = i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0;
  i64toi32_i32$4 = i64toi32_i32$6 + i64toi32_i32$2 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 - i64toi32_i32$4 | 0;
  i64toi32_i32$5 = i64toi32_i32$1;
  i64toi32_i32$0 = 2097151;
  i64toi32_i32$3 = -4;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  i64toi32_i32$4 = i64toi32_i32$2;
  i64toi32_i32$5 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$5 = i64toi32_i32$1 & i64toi32_i32$5 | 0;
  i64toi32_i32$4 = $25;
  HEAP32[(i64toi32_i32$4 + 24 | 0) >> 2] = i64toi32_i32$2 & i64toi32_i32$3 | 0;
  HEAP32[(i64toi32_i32$4 + 28 | 0) >> 2] = i64toi32_i32$5;
  $34 = $0;
  i64toi32_i32$5 = i64toi32_i32$1;
  i64toi32_i32$1 = i64toi32_i32$2;
  i64toi32_i32$4 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$0 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$4 = 0;
   $40 = i64toi32_i32$5 >>> i64toi32_i32$0 | 0;
  } else {
   i64toi32_i32$4 = i64toi32_i32$5 >>> i64toi32_i32$0 | 0;
   $40 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$0 | 0) | 0;
  }
  $36$hi = i64toi32_i32$4;
  i64toi32_i32$5 = $1;
  i64toi32_i32$4 = HEAP32[(i64toi32_i32$5 + 32 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$5 + 36 | 0) >> 2] | 0;
  $38 = i64toi32_i32$4;
  $38$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $36$hi;
  i64toi32_i32$5 = $40;
  i64toi32_i32$4 = $38$hi;
  i64toi32_i32$3 = $38;
  i64toi32_i32$0 = i64toi32_i32$5 - i64toi32_i32$3 | 0;
  i64toi32_i32$6 = i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0;
  i64toi32_i32$2 = i64toi32_i32$6 + i64toi32_i32$4 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 - i64toi32_i32$2 | 0;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$5 = 2097151;
  i64toi32_i32$3 = -4;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  i64toi32_i32$2 = i64toi32_i32$4;
  i64toi32_i32$1 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
  $42 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $34;
  HEAP32[(i64toi32_i32$2 + 32 | 0) >> 2] = $42;
  HEAP32[(i64toi32_i32$2 + 36 | 0) >> 2] = i64toi32_i32$1;
  $43 = $0;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$0 = i64toi32_i32$4;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 51;
  i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $41 = i64toi32_i32$1 >>> i64toi32_i32$5 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$5 | 0;
   $41 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$5 | 0) | 0;
  }
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_i64_mul($41 | 0, i64toi32_i32$2 | 0, 19 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $46 = i64toi32_i32$0;
  $46$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $2$hi;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 524287;
  i64toi32_i32$3 = -1;
  i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
  $48 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
  $48$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $46$hi;
  i64toi32_i32$2 = $46;
  i64toi32_i32$1 = $48$hi;
  i64toi32_i32$3 = $48;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  i64toi32_i32$2 = $43;
  HEAP32[i64toi32_i32$2 >> 2] = i64toi32_i32$5;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$4;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__SerializeEmbeddedGroup_20for_20cardano_serialization_lib__ProtocolVersion___serialize_as_embedded_group__hf0a424996c64ec05($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, i64toi32_i32$0 | 0, i64toi32_i32$1 | 0);
  $4 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     i64toi32_i32$0 = 0;
     cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, i64toi32_i32$1 | 0, i64toi32_i32$0 | 0);
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$2
     }
     HEAP32[($0 + 4 | 0) >> 2] = $2;
     $4 = 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $4 = 1;
  }
  HEAP32[$0 >> 2] = $4;
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__UnitInterval__to_bytes__h9df20c16a600f727($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__UnitInterval___serialize__h073d853696277759($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1053128 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__Transaction__to_bytes__h3fc3ee53046075af($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__Transaction___serialize__h727dde48672e8d9f($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1053144 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__TransactionInputs__to_bytes__hd570da57611ad9c1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__TransactionInputs___serialize__h5d5370eb2688b5ac($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1053160 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__TransactionOutputs__to_bytes__h71c3708b4ae29f22($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__TransactionOutputs___serialize__he3bf8aa07ee2fe6d($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1053192 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__Certificates__to_bytes__h85d1a5d50f830822($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__Certificates___serialize__h4f1f9d7f05159b8e($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1053224 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__TransactionBody__to_bytes__h03479aa95ace09cb($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__TransactionBody___serialize__h766748b3e983f577($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1053256 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__TransactionInput__to_bytes__hc67ef454d348f684($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__TransactionInput___serialize__h2e92835f336b9490($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1053272 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__TransactionOutput__to_bytes__h39917cb4ac582524($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__TransactionOutput___serialize__h958522c662d822ef($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1053288 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__StakeRegistration__to_bytes__hc38bdcdcd6c2f24e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__StakeRegistration___serialize__h001173245c759d8c($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1053304 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__StakeDeregistration__to_bytes__hc35fedbd4c7f4cd2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__StakeDeregistration___serialize__h6386e70539f9aacd($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1053320 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__StakeDelegation__to_bytes__h336a11b444c754e5($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__StakeDelegation___serialize__h12819bfe98da8ca7($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1053336 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__Ed25519KeyHashes__to_bytes__h8a16b826e8a207d6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__Ed25519KeyHashes___serialize__h8832695f5a55a024($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1053352 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__Relays__to_bytes__hf7c1ddf28786d418($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__Relays___serialize__ha6bdc6309ff8ff6a($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1053384 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__PoolParams__to_bytes__h3f5f15e73f68a0e0($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__PoolParams___serialize__hb9e5313debf5456f($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1053416 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__PoolRegistration__to_bytes__h8fe885d6b7b5e324($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__PoolRegistration___serialize__hca14ce2a34bdba0f($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1053432 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__PoolRetirement__to_bytes__h69dfd17fa6d8ec26($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__PoolRetirement___serialize__ha2a3c174a4e94da0($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1053448 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__GenesisKeyDelegation__to_bytes__h0b4d65632f035de9($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__GenesisKeyDelegation___serialize__h5da745d5a246d9be($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1053464 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__MoveInstantaneousRewardsCert__to_bytes__hac4aaf2ebea8a123($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__MoveInstantaneousRewardsCert___serialize__h6257e6687133e8c5($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1053480 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__Certificate__to_bytes__hfc049ba855c56bb2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__CertificateEnum___serialize__ha9753fa38519654b($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1053496 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__MIRToStakeCredentials__to_bytes__hdbe8603d366668dc($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__MIRToStakeCredentials___serialize__h6a8886ca50fc22cf($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1053540 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__MoveInstantaneousReward__to_bytes__h4c0e3fd55594e560($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__MoveInstantaneousReward___serialize__hc9e545ed3c236536($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1053556 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__Ipv4__to_bytes__h148c2ae3c924146c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cbor_event__se__Serializer_W___write_bytes__h54e6fef2108c8b37($2 + 24 | 0 | 0, $2 + 8 | 0 | 0, $1 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1053576 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__Ipv6__to_bytes__h608d664f8fb0476d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cbor_event__se__Serializer_W___write_bytes__hd39fb27319ed5f2d($2 + 24 | 0 | 0, $2 + 8 | 0 | 0, $1 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1053616 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__URL__to_bytes__h139008b509d93c58($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cbor_event__se__Serializer_W___write_text__hb80b098c4abeea7e($2 + 24 | 0 | 0, $2 + 8 | 0 | 0, $1 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1053656 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__DNSRecordAorAAAA__to_bytes__hea531de37c5d48da($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cbor_event__se__Serializer_W___write_text__hb80b098c4abeea7e($2 + 24 | 0 | 0, $2 + 8 | 0 | 0, $1 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1053688 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__DNSRecordSRV__to_bytes__h80601c27a90b1551($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cbor_event__se__Serializer_W___write_text__hb80b098c4abeea7e($2 + 24 | 0 | 0, $2 + 8 | 0 | 0, $1 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1053716 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__SingleHostAddr__to_bytes__h798fa7218db0c453($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__SingleHostAddr___serialize__h544b90ba79e7b7c9($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1053732 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__SingleHostName__to_bytes__hdbbe3c97d4e95860($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__SingleHostName___serialize__h1ca1f820778507e6($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1053748 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__MultiHostName__to_bytes__ha4b24eb98359d25d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__MultiHostName___serialize__h22530ddd6dac0df6($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1053764 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__Relay__to_bytes__h5006319aa84b4c2c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__RelayEnum___serialize__h742c43d428b38e2a($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1053780 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__PoolMetadata__to_bytes__hc3ee30d77ef1dd1f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__PoolMetadata___serialize__h4d5353f47521faee($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1053796 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__StakeCredentials__to_bytes__hd74a84d639ebfe2a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__StakeCredentials___serialize__h4796a750e6290b16($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1053812 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__RewardAddresses__to_bytes__h30e2feda80dac1c1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__RewardAddresses___serialize__h56cb54f274358354($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1053844 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__Withdrawals__to_bytes__hc4107deca626561a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__Withdrawals___serialize__h776d4a70d67f4de1($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1053876 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__TransactionWitnessSet__to_bytes__h3711bb2082c424f0($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__TransactionWitnessSet___serialize__ha4e0dd8fca4a45ce($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1053892 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__ScriptPubkey__to_bytes__h52b71fff51f25275($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__ScriptPubkey___serialize__h0f3da940961ea792($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1053908 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__ScriptAll__to_bytes__he5644ba95ff57d44($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__ScriptAll___serialize__h8f58ae8444303044($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1053924 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__ScriptAny__to_bytes__hab17863024842704($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__ScriptAny___serialize__haa07f6b291e86618($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1053940 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__ScriptNOfK__to_bytes__h70f77eac2944ab8f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__ScriptNOfK___serialize__ha6a5cba50bbb5ead($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1053956 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function scriptnofk_new($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $35 = 0, $38 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hbfc7b2ba05921680($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($2 + 16 | 0 | 4 | 0 | 0, HEAP32[$3 >> 2] | 0 | 0, HEAP32[($3 + 8 | 0) >> 2] | 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $35 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 32 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $35;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $38 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $38;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$0;
  $1 = $cardano_serialization_lib__ScriptNOfK_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h0db7a3b086405587($2 + 32 | 0 | 0) | 0;
  global$0 = $2 + 48 | 0;
  return $1 | 0;
 }
 
 function cardano_serialization_lib__TimelockStart__to_bytes__h36bcaaaa1f976a4a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__TimelockStart___serialize__h9a60d7f0e1ad71af($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1053972 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__TimelockExpiry__to_bytes__h29eb471aab61c2bc($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__TimelockExpiry___serialize__h9881f5a9c78a9c8e($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1053988 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function $cardano_serialization_lib__NativeScript_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h5737abd968aea6f3($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$2 = 0, $20 = 0, $26 = 0, $32 = 0, $35 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h7c125373284ebadf($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 8 | 0 | 0, $1 | 0, 40 | 0) | 0;
  i64toi32_i32$2 = $2 + 40 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 24 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $20;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = ($2 + 8 | 0) + 24 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $26 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $26;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = ($2 + 8 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $32 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $32;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $35 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $35;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 40 | 0, 8 | 0);
  global$0 = $2 + 48 | 0;
 }
 
 function cardano_serialization_lib__NativeScript__to_bytes__hcf189ce9571cef2e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__NativeScriptEnum___serialize__hdc3a49a10a4c617a($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1054004 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__Update__to_bytes__h72d5ee85321808c5($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__Update___serialize__h3b16321a799d449a($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1054036 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__GenesisHashes__to_bytes__h827d775bd46a2964($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__GenesisHashes___serialize__h2f6bb366051ef57d($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1054052 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__ScriptHashes__to_bytes__he0e9f5150c313220($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__ScriptHashes___serialize__h38600dd38b7b89cc($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1054084 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__ProposedProtocolParameterUpdates__to_bytes__h9b4f42f191ec0d06($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__ProposedProtocolParameterUpdates___serialize__h327aa0190f949245($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1054116 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__ProtocolVersion__to_bytes__h324d7d99a7cab8b1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__ProtocolVersion___serialize__hc63f637e9607aaf8($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1054132 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__ProtocolVersions__to_bytes__h07477e989b774f62($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__ProtocolVersions___serialize__h93b9b5b740a5eb75($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1054148 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__ProtocolParamUpdate__to_bytes__hc1048d3d73304000($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__ProtocolParamUpdate___serialize__h38e4d9be5dcfac79($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1054180 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__TransactionBodies__to_bytes__h189d4c4984c313dd($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__TransactionBodies___serialize__h8db917846eff3001($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1054196 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__TransactionWitnessSets__to_bytes__h5b17d6ec436644b5($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__TransactionWitnessSets___serialize__hdd6edfd8e35c0d96($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1054228 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__Block__to_bytes__h60d66d271942e6ea($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__Block___serialize__h5b93dd14758cd2d8($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1054260 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__Header__to_bytes__h389fdc932589ea6d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__Header___serialize__hd43c55fb578bdd92($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1054276 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__OperationalCert__to_bytes__h2714f634a9e19c45($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__OperationalCert___serialize__h98f44149faf21e78($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1054292 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__HeaderBody__to_bytes__h9eb66f63562cbb2f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__HeaderBody___serialize__hbb751f3982bde43a($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1054308 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__AssetName__to_bytes__h70fec91c0b019338($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cbor_event__se__Serializer_W___write_bytes__hdbf95a6224c8b5b8($2 + 24 | 0 | 0, $2 + 8 | 0 | 0, $1 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1054336 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__AssetNames__to_bytes__hded76ea985a97c6d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__AssetNames___serialize__h9819ebbf21c28384($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1054352 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__Assets__to_bytes__h53030351e03948ee($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__Assets___serialize__hdca9801c50eb469f($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1054384 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__MultiAsset__to_bytes__h37389a4eb9c05123($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__MultiAsset___serialize__h8befd5a1b9cac25b($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1054400 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__Mint__to_bytes__hae180b99104de643($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__Mint___serialize__h19eae2b7c2c53b1d($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1054416 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__NetworkId__to_bytes__hbf6df6fc195f7ada($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__NetworkId___serialize__h73892ae14f8b751c($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1050112 | 0, 43 | 0, $2 + 72 | 0 | 0, 1050172 | 0, 1054448 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__utils__TransactionUnspentOutput__to_bytes__h7f3a90b5c6f7d805($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__utils__TransactionUnspentOutput_20as_20cbor_event__se__Serialize___serialize__h991f225e7eae04ba($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1057568 | 0, 43 | 0, $2 + 72 | 0 | 0, 1057644 | 0, 1058676 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__utils__Value__to_bytes__h2820e7e1b4035910($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__utils__Value_20as_20cbor_event__se__Serialize___serialize__hc37da84fe085e7b6($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1057568 | 0, 43 | 0, $2 + 72 | 0 | 0, 1057644 | 0, 1058752 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__utils__Int__to_bytes__hbe8e1a87c2e0df42($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__utils__Int_20as_20cbor_event__se__Serialize___serialize__h52978cec14c40013($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1057568 | 0, 43 | 0, $2 + 72 | 0 | 0, 1057644 | 0, 1058784 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__utils__BigInt__to_bytes__h27caedab347e4c69($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__utils__BigInt_20as_20cbor_event__se__Serialize___serialize__hd7ec7393d73149ff($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1057568 | 0, 43 | 0, $2 + 72 | 0 | 0, 1057644 | 0, 1058800 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__metadata__MetadataMap__to_bytes__h3333dbf6e1c657eb($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__metadata__MetadataMap_20as_20cbor_event__se__Serialize___serialize__h7bf88c8e5cef4c92($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1059176 | 0, 43 | 0, $2 + 72 | 0 | 0, 1059220 | 0, 1060132 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__metadata__MetadataMap__insert_str__h919b90e1ce9180ce($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $5 = global$0 - 128 | 0;
  global$0 = $5;
  alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($5 + 112 | 0 | 0, $2 | 0, $3 | 0);
  cardano_serialization_lib__metadata__TransactionMetadatum__new_text__hc705d7de2d476a57($5 + 56 | 0 | 0, $5 + 112 | 0 | 0);
  $2 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($5 + 56 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    memcpy($5 + 8 | 0 | 0, ($5 + 56 | 0) + 8 | 0 | 0, 48 | 0) | 0;
    cardano_serialization_lib__metadata__MetadataMap__insert__hd93cf89dc2674a42($0 + 8 | 0 | 0, $1 | 0, $5 + 8 | 0 | 0, $4 | 0);
    core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatum___headd2d1b596252cc($5 + 8 | 0 | 0);
    $2 = 0;
    break label$1;
   }
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($5 + 60 | 0) >> 2] | 0 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $5 + 128 | 0;
 }
 
 function cardano_serialization_lib__metadata__MetadataList__to_bytes__h4fde069daead55c0($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__metadata__MetadataList_20as_20cbor_event__se__Serialize___serialize__h338522090b280ca8($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1059176 | 0, 43 | 0, $2 + 72 | 0 | 0, 1059220 | 0, 1060196 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__metadata__TransactionMetadatum__to_bytes__h71c4a73ff0ebaa5f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__metadata__TransactionMetadatumEnum_20as_20cbor_event__se__Serialize___serialize__h4285ca14e4462f47($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1059176 | 0, 43 | 0, $2 + 72 | 0 | 0, 1059220 | 0, 1060356 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function transactionmetadatum_as_int($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$2 = 0, $3$hi = 0, $3 = 0, $33$hi = 0, $9 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__hc630c86c4ab6b26d($1 | 0, $0 | 0);
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    HEAP32[($1 + 12 | 0) >> 2] = $2;
    $0 = HEAP32[$1 >> 2] | 0;
    HEAP32[($1 + 8 | 0) >> 2] = $0;
    if ((HEAP32[$0 >> 2] | 0 | 0) != (2 | 0)) {
     break label$1
    }
    i64toi32_i32$2 = $0 + 16 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $3 = i64toi32_i32$0;
    $3$hi = i64toi32_i32$1;
    i64toi32_i32$2 = $0;
    i64toi32_i32$1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($0 + 12 | 0) >> 2] | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
    $33$hi = i64toi32_i32$0;
    i64toi32_i32$0 = $3$hi;
    i64toi32_i32$0 = $33$hi;
    $9 = i64toi32_i32$1;
    i64toi32_i32$1 = $3$hi;
    $0 = $cardano_serialization_lib__utils__Int_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hac86427717971799($9 | 0, i64toi32_i32$0 | 0, $3 | 0, i64toi32_i32$1 | 0) | 0;
    global$0 = $1 + 16 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  $0 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1060499 | 0, 10 | 0) | 0;
  $wasm_bindgen____rt__Ref_T__20as_20core__ops__drop__Drop___drop__h2f35f6c2409f0658($1 + 8 | 0 | 0);
  wasm_bindgen__throw_val__hcf1b5c929d6fa472($0 | 0);
  abort();
 }
 
 function cardano_serialization_lib__metadata__TransactionMetadatumLabels__to_bytes__h9a2fd336532078dc($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__metadata__TransactionMetadatumLabels_20as_20cbor_event__se__Serialize___serialize__h4a74450283306885($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1059176 | 0, 43 | 0, $2 + 72 | 0 | 0, 1059220 | 0, 1060528 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__metadata__GeneralTransactionMetadata__to_bytes__h714c66bad4d9e4ed($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__metadata__GeneralTransactionMetadata_20as_20cbor_event__se__Serialize___serialize__h54e54d8e88a77b55($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1059176 | 0, 43 | 0, $2 + 72 | 0 | 0, 1059220 | 0, 1060560 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__metadata__AuxiliaryData__to_bytes__hfa2015a3201786ee($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__metadata__AuxiliaryData_20as_20cbor_event__se__Serialize___serialize__h6e246ec2e95d27d5($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1059176 | 0, 43 | 0, $2 + 72 | 0 | 0, 1059220 | 0, 1060576 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__crypto__Vkey__to_bytes__h6b2510585c6bda80($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__crypto__Vkey_20as_20cbor_event__se__Serialize___serialize__he0fe1f32129559ab($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1066120 | 0, 43 | 0, $2 + 72 | 0 | 0, 1066196 | 0, 1066636 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__crypto__Vkeywitness__to_bytes__h3ecaa54a159a7f68($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__crypto__Vkeywitness_20as_20cbor_event__se__Serialize___serialize__h5cf30721c029e59b($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1066120 | 0, 43 | 0, $2 + 72 | 0 | 0, 1066196 | 0, 1066668 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__crypto__BootstrapWitness__to_bytes__hbab231c2f97d497f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__crypto__BootstrapWitness_20as_20cbor_event__se__Serialize___serialize__hd840f2320eb792b1($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1066120 | 0, 43 | 0, $2 + 72 | 0 | 0, 1066196 | 0, 1066700 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__crypto__Nonce__to_bytes__h4ae263ae7fba54e3($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__crypto__Nonce_20as_20cbor_event__se__Serialize___serialize__hd28efbdff8e194e3($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1066120 | 0, 43 | 0, $2 + 72 | 0 | 0, 1066196 | 0, 1067160 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__crypto__VRFCert__to_bytes__hf92f71ef8605e2ea($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__crypto__VRFCert_20as_20cbor_event__se__Serialize___serialize__hc36d047369e93edb($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1066120 | 0, 43 | 0, $2 + 72 | 0 | 0, 1066196 | 0, 1067192 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function $alloc__vec__Vec_u8__20as_20hex__FromHex___from_hex__hb06fe9f77c382902($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $31 = 0, $34 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    if ($1 & 1 | 0) {
     break label$2
    }
    $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    HEAP32[($2 + 40 | 0) >> 2] = 2;
    HEAP32[($2 + 36 | 0) >> 2] = $1;
    HEAP32[($2 + 32 | 0) >> 2] = $3;
    core__iter__adapters__enumerate__Enumerate_I___new__h104ad29fe8f300cf($2 + 16 | 0 | 0, $2 + 32 | 0 | 0);
    i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $31 = i64toi32_i32$0;
    i64toi32_i32$0 = ($2 + 32 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $31;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
    $34 = i64toi32_i32$1;
    i64toi32_i32$1 = $2;
    HEAP32[($2 + 32 | 0) >> 2] = $34;
    HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$0;
    core__iter__adapters__process_results__ha88025cbb18edab5($0 | 0, $2 + 32 | 0 | 0);
    break label$1;
   }
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 1114112;
   HEAP32[i64toi32_i32$1 >> 2] = 1;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  }
  global$0 = $2 + 48 | 0;
 }
 
 function cardano_serialization_lib__address__StakeCredential__to_bytes__h1e8f5a9dedbab360($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__address__StakeCredential_20as_20cbor_event__se__Serialize___serialize__h5b8c776cf4ca6024($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1069956 | 0, 43 | 0, $2 + 72 | 0 | 0, 1070032 | 0, 1070324 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__address__ByronAddress__to_bytes__h95edb62bc4a38025($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__legacy_address__address__ExtendedAddr_20as_20cbor_event__se__Serialize___serialize__hab4aa0fda5dfbd1b($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1069956 | 0, 43 | 0, $2 + 72 | 0 | 0, 1070032 | 0, 1070348 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__address__ByronAddress__attributes__hedb23cddc1880465($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__legacy_address__address__Attributes_20as_20cbor_event__se__Serialize___serialize__haf99c3c1d66b9efa($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1069956 | 0, 43 | 0, $2 + 72 | 0 | 0, 1070032 | 0, 1070364 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__plutus__PlutusScript__to_bytes__h4adacfd5fc205b4c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  cbor_event__se__Serializer_W___write_bytes__hdbf95a6224c8b5b8($2 + 24 | 0 | 0, $2 + 8 | 0 | 0, $1 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1070651 | 0, 43 | 0, $2 + 72 | 0 | 0, 1070712 | 0, 1071280 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__plutus__PlutusScripts__to_bytes__hba3de06a31d540f0($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__plutus__PlutusScripts_20as_20cbor_event__se__Serialize___serialize__h460b1286d3728f21($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1070651 | 0, 43 | 0, $2 + 72 | 0 | 0, 1070712 | 0, 1071296 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__plutus__ConstrPlutusData__to_bytes__h9d9c05e1eee49b9d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__plutus__ConstrPlutusData_20as_20cbor_event__se__Serialize___serialize__h1577784212376b9e($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1070651 | 0, 43 | 0, $2 + 72 | 0 | 0, 1070712 | 0, 1071328 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__plutus__CostModel__to_bytes__h24a2e606b34519d6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__plutus__CostModel_20as_20cbor_event__se__Serialize___serialize__h29052229a88c8bb1($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1070651 | 0, 43 | 0, $2 + 72 | 0 | 0, 1070712 | 0, 1071344 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__plutus__Costmdls__to_bytes__h89ce5b6a343e5d35($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__plutus__Costmdls_20as_20cbor_event__se__Serialize___serialize__h651d2db00a62edc7($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1070651 | 0, 43 | 0, $2 + 72 | 0 | 0, 1070712 | 0, 1071456 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function $cardano_serialization_lib__plutus__ExUnitPrices_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h5866688a6fa9afcf($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$2 = 0, $20 = 0, $26 = 0, $32 = 0, $35 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hed421792766cbc07($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 8 | 0 | 0, $1 | 0, 40 | 0) | 0;
  i64toi32_i32$2 = $2 + 40 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 24 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $20;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = ($2 + 8 | 0) + 24 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $26 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $26;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = ($2 + 8 | 0) + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $32 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $32;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $35 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $35;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 40 | 0, 8 | 0);
  global$0 = $2 + 48 | 0;
 }
 
 function cardano_serialization_lib__plutus__ExUnitPrices__to_bytes__hedf1008b0af8a3a6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__plutus__ExUnitPrices_20as_20cbor_event__se__Serialize___serialize__h10c0ac919a9d373a($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1070651 | 0, 43 | 0, $2 + 72 | 0 | 0, 1070712 | 0, 1071604 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__plutus__ExUnits__to_bytes__hb014ea1e403fd35b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__plutus__ExUnits_20as_20cbor_event__se__Serialize___serialize__h495dce506fba6361($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1070651 | 0, 43 | 0, $2 + 72 | 0 | 0, 1070712 | 0, 1071620 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function language_from_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  HEAP32[($2 + 40 | 0) >> 2] = $1;
  HEAP32[($2 + 36 | 0) >> 2] = $1;
  HEAP32[($2 + 32 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 32 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  HEAP32[($2 + 32 | 0) >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  cardano_serialization_lib__plutus__Language__from_bytes__hc4c1cf8990ed25c0($2 | 0, $2 + 32 | 0 | 0);
  label$1 : {
   if (!(HEAP32[$2 >> 2] | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0);
   abort();
  }
  $1 = $cardano_serialization_lib__plutus__Language_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h686a48dad777e160() | 0;
  global$0 = $2 + 48 | 0;
  return $1 | 0;
 }
 
 function cardano_serialization_lib__plutus__PlutusMap__to_bytes__h20d006e99276c59e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__plutus__PlutusMap_20as_20cbor_event__se__Serialize___serialize__h43e688f33521e457($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1070651 | 0, 43 | 0, $2 + 72 | 0 | 0, 1070712 | 0, 1071668 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__plutus__PlutusData__to_bytes__h3eb50f620e6d8905($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__plutus__PlutusData_20as_20cbor_event__se__Serialize___serialize__hbd5d6a191345a7d0($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1070651 | 0, 43 | 0, $2 + 72 | 0 | 0, 1070712 | 0, 1071684 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__plutus__PlutusList__to_bytes__h13c74980ee8c70aa($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__plutus__PlutusList_20as_20cbor_event__se__Serialize___serialize__h4fb04398ef3c9f58($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1070651 | 0, 43 | 0, $2 + 72 | 0 | 0, 1070712 | 0, 1071700 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__plutus__Redeemer__to_bytes__hc8fe4986b772e208($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__plutus__Redeemer_20as_20cbor_event__se__Serialize___serialize__hf725a82e60523f39($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1070651 | 0, 43 | 0, $2 + 72 | 0 | 0, 1070712 | 0, 1071732 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__plutus__RedeemerTag__to_bytes__h1ed886466625aa33($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__plutus__RedeemerTagKind_20as_20cbor_event__se__Serialize___serialize__h18a0e36a2b8a390e($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1070651 | 0, 43 | 0, $2 + 72 | 0 | 0, 1070712 | 0, 1071748 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cardano_serialization_lib__plutus__Redeemers__to_bytes__hc16c7b4820f3e155($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $10 = 0, $28 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 | 0, 512 | 0, 0 | 0);
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $10 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $10;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  $cardano_serialization_lib__plutus__Redeemers_20as_20cbor_event__se__Serialize___serialize__h3e0a2f954a4fc936($2 + 24 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 24 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   memcpy($2 + 72 | 0 | 0, $2 + 32 | 0 | 0, 40 | 0) | 0;
   core__result__unwrap_failed__h27f43d993c3864a1(1070651 | 0, 43 | 0, $2 + 72 | 0 | 0, 1070712 | 0, 1071764 | 0);
   abort();
  }
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $28 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $28;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = HEAP32[(($2 + 8 | 0) + 8 | 0) >> 2] | 0;
  global$0 = $2 + 112 | 0;
 }
 
 function cbor_event__se__Serializer_W___write_bytes__h935c22261c9a8184($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $5 = 0, $4 = 0, i64toi32_i32$0 = 0;
  $3 = global$0 - 64 | 0;
  global$0 = $3;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $2 | 0);
  $4 = HEAP32[($3 + 8 | 0) >> 2] | 0;
  $5 = HEAP32[($3 + 12 | 0) >> 2] | 0;
  i64toi32_i32$0 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 + 16 | 0 | 0, $1 | 0, 2 | 0, $5 | 0, i64toi32_i32$0 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($3 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[($3 + 20 | 0) >> 2] | 0;
    alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($1 | 0, $4 | 0, $5 | 0);
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    $1 = 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, ($3 + 16 | 0) + 8 | 0 | 0, 40 | 0) | 0;
  }
  HEAP32[$0 >> 2] = $1;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 | 0);
  global$0 = $3 + 64 | 0;
 }
 
 function alloc__collections__btree__map__entry__OccupiedEntry_K_2cV___remove_kv__hcfc9f18b14708d93($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0, $2 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  HEAP8[($1 + 15 | 0) >> 0] = 0;
  HEAP32[(($1 + 32 | 0) + 8 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 32 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__collections__btree__remove___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal__2calloc__collections__btree__node__marker__KV____remove_kv_tracking__hc9b884ef6fef5efe($1 + 16 | 0 | 0, $1 + 32 | 0 | 0, $1 + 15 | 0 | 0);
  $2 = HEAP32[($1 + 16 | 0) >> 2] | 0;
  $0 = HEAP32[($0 + 12 | 0) >> 2] | 0;
  HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + -1 | 0;
  label$1 : {
   label$2 : {
    if (!(HEAPU8[($1 + 15 | 0) >> 0] | 0)) {
     break label$2
    }
    if (!(HEAP32[($0 + 4 | 0) >> 2] | 0)) {
     break label$1
    }
    alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Owned_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___pop_internal_level__hec5f5ba8681137fd($0 | 0);
   }
   global$0 = $1 + 48 | 0;
   return $2 | 0;
  }
  core__panicking__panic__h2fd385a887c8bf13(1072048 | 0, 43 | 0, 1072264 | 0);
  abort();
 }
 
 function std__thread__local__lazy__LazyKeyInner_T___initialize__hf3fcc641c491085f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $6 = 0, i64toi32_i32$2 = 0, $4 = 0, $5 = 0, $3 = 0, $18 = 0, $29 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  FUNCTION_TABLE[$1 | 0]($2);
  $3 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $1 = HEAP32[$0 >> 2] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[$0 >> 2] = $18;
  HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $4 = HEAP32[($0 + 12 | 0) >> 2] | 0;
  $5 = $0 + 8 | 0;
  $6 = HEAP32[$5 >> 2] | 0;
  i64toi32_i32$2 = $2 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $29 = i64toi32_i32$1;
  i64toi32_i32$1 = $5;
  HEAP32[i64toi32_i32$1 >> 2] = $29;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  label$1 : {
   if ($1) {
    break label$1
   }
   label$2 : {
    if ($3) {
     break label$2
    }
    if ($6 >>> 0 < 36 >>> 0) {
     break label$1
    }
    wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($6 | 0);
    break label$1;
   }
   label$3 : {
    if ($6 >>> 0 < 36 >>> 0) {
     break label$3
    }
    wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($6 | 0);
   }
   if ($4 >>> 0 < 36 >>> 0) {
    break label$1
   }
   wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($4 | 0);
  }
  global$0 = $2 + 16 | 0;
  return $0 | 0;
 }
 
 function alloc__vec__Vec_T_2cA___extend_with__hc50aa39afa7f1d36($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, $5 = 0;
  label$1 : {
   $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (((HEAP32[($0 + 4 | 0) >> 2] | 0) - $3 | 0) >>> 0 >= $1 >>> 0) {
    break label$1
   }
   alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h90c9768825cdae1b($0 | 0, $3 | 0, $1 | 0);
   $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  }
  $4 = (HEAP32[$0 >> 2] | 0) + ($3 << 2 | 0) | 0;
  label$2 : {
   if ($1 >>> 0 < 2 >>> 0) {
    break label$2
   }
   $5 = $1 + -1 | 0;
   label$3 : while (1) {
    HEAP32[$4 >> 2] = $2;
    $4 = $4 + 4 | 0;
    $5 = $5 + -1 | 0;
    if ($5) {
     continue label$3
    }
    break label$3;
   };
   $3 = ($1 + $3 | 0) + -1 | 0;
  }
  label$4 : {
   if (!$1) {
    break label$4
   }
   HEAP32[$4 >> 2] = $2;
   $3 = $3 + 1 | 0;
  }
  HEAP32[($0 + 8 | 0) >> 2] = $3;
 }
 
 function serde_json__de__Deserializer_R___parse_ident__h2a4ea507f5458eed($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $6 = 0, $4 = 0, $5 = 0, $7 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  $4 = HEAP32[$0 >> 2] | 0;
  $5 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  label$1 : {
   label$2 : {
    label$3 : while (1) {
     label$4 : {
      if ($2) {
       break label$4
      }
      $2 = 0;
      break label$1;
     }
     label$5 : {
      $6 = HEAP32[($0 + 8 | 0) >> 2] | 0;
      if ($6 >>> 0 < $5 >>> 0) {
       break label$5
      }
      HEAP32[$3 >> 2] = 5;
      break label$2;
     }
     HEAP32[($0 + 8 | 0) >> 2] = $6 + 1 | 0;
     $2 = $2 + -1 | 0;
     $7 = HEAPU8[$1 >> 0] | 0;
     $1 = $1 + 1 | 0;
     if (($7 | 0) == (HEAPU8[($4 + $6 | 0) >> 0] | 0 | 0)) {
      continue label$3
     }
     break label$3;
    };
    HEAP32[$3 >> 2] = 9;
   }
   $2 = serde_json__de__Deserializer_R___error__h438ab94fbb97beef($0 | 0, $3 | 0) | 0;
  }
  global$0 = $3 + 16 | 0;
  return $2 | 0;
 }
 
 function $cryptoxide__sha2__Sha512_20as_20cryptoxide__digest__Digest___result__h84e92e596fb82544($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, $4 = 0;
  $3 = global$0 - 64 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    if (HEAPU8[($0 + 216 | 0) >> 0] | 0) {
     break label$2
    }
    HEAP8[($0 + 216 | 0) >> 0] = 1;
    $3 = memset($3 | 0, 0 | 0, 64 | 0) | 0;
    cryptoxide__hashing__sha2__Engine512__finish__h18b5152b4b76c624($0 | 0);
    $4 = $0 + 16 | 0;
    cryptoxide__cryptoutil__write_u64v_be__h6888df4c897d2bb4($3 | 0, 64 | 0, $4 | 0, 8 | 0);
    i64toi32_i32$0 = 0;
    HEAP32[($0 + 8 | 0) >> 2] = 0;
    HEAP32[($0 + 12 | 0) >> 2] = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    HEAP32[$0 >> 2] = 0;
    HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($0 + 80 | 0) >> 2] = 0;
    memcpy($4 | 0, 1137368 | 0, 64 | 0) | 0;
    if (($2 | 0) != (64 | 0)) {
     break label$1
    }
    memcpy($1 | 0, $3 | 0, 64 | 0) | 0;
    global$0 = $3 + 64 | 0;
    return;
   }
   core__panicking__panic__h2fd385a887c8bf13(1137812 | 0, 41 | 0, 1137948 | 0);
   abort();
  }
  core__slice___impl_20_5bT_5d___copy_from_slice__len_mismatch_fail__h13bf5a0e1407b14d($2 | 0, 64 | 0, 1103120 | 0);
  abort();
 }
 
 function std__panicking__begin_panic_handler___7b_7bclosure_7d_7d__h3e6db7c674e79203($0) {
  $0 = $0 | 0;
  var $2 = 0, $1 = 0, $3 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $2 = HEAP32[$0 >> 2] | 0;
  $3 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     switch (HEAP32[($2 + 4 | 0) >> 2] | 0 | 0) {
     case 0:
      if ($3) {
       break label$1
      }
      $2 = 1142260;
      $3 = 0;
      break label$2;
     case 1:
      break label$3;
     default:
      break label$1;
     };
    }
    if ($3) {
     break label$1
    }
    $2 = HEAP32[$2 >> 2] | 0;
    $3 = HEAP32[($2 + 4 | 0) >> 2] | 0;
    $2 = HEAP32[$2 >> 2] | 0;
   }
   HEAP32[($1 + 4 | 0) >> 2] = $3;
   HEAP32[$1 >> 2] = $2;
   std__panicking__rust_panic_with_hook__he9bfe03219d715ba($1 | 0, 1144316 | 0, core__panic__PanicInfo__message__hf990209c674102c0(HEAP32[($0 + 4 | 0) >> 2] | 0 | 0) | 0 | 0, HEAP32[($0 + 8 | 0) >> 2] | 0 | 0);
   abort();
  }
  HEAP32[($1 + 4 | 0) >> 2] = 0;
  HEAP32[$1 >> 2] = $2;
  std__panicking__rust_panic_with_hook__he9bfe03219d715ba($1 | 0, 1144296 | 0, core__panic__PanicInfo__message__hf990209c674102c0(HEAP32[($0 + 4 | 0) >> 2] | 0 | 0) | 0 | 0, HEAP32[($0 + 8 | 0) >> 2] | 0 | 0);
  abort();
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__SerializeEmbeddedGroup_20for_20cardano_serialization_lib__TimelockStart___serialize_as_embedded_group__hbaad639201a53fec($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, $4 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  i64toi32_i32$0 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 4 | 0, i64toi32_i32$0 | 0);
  $4 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     i64toi32_i32$2 = $1;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, i64toi32_i32$0 | 0, i64toi32_i32$1 | 0);
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$2
     }
     HEAP32[($0 + 4 | 0) >> 2] = $2;
     $4 = 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $4 = 1;
  }
  HEAP32[$0 >> 2] = $4;
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__SerializeEmbeddedGroup_20for_20cardano_serialization_lib__TimelockExpiry___serialize_as_embedded_group__h02f1140254eab00b($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, $4 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  i64toi32_i32$0 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 5 | 0, i64toi32_i32$0 | 0);
  $4 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     i64toi32_i32$2 = $1;
     i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
     cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, i64toi32_i32$0 | 0, i64toi32_i32$1 | 0);
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$2
     }
     HEAP32[($0 + 4 | 0) >> 2] = $2;
     $4 = 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $4 = 1;
  }
  HEAP32[$0 >> 2] = $4;
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__utils__BigInt__mul__h31545dc99f4f564b($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $5 = 0, $4 = 0;
  $3 = global$0 - 32 | 0;
  global$0 = $3;
  $4 = 1;
  label$1 : {
   $5 = HEAPU8[($1 + 12 | 0) >> 0] | 0;
   if (($5 | 0) == (1 | 0)) {
    break label$1
   }
   label$2 : {
    label$3 : {
     switch (HEAPU8[($2 + 12 | 0) >> 0] | 0 | 0) {
     case 2:
      if ($5) {
       break label$2
      }
      $4 = 0;
      break label$1;
     case 1:
      break label$1;
     default:
      break label$3;
     };
    }
    $4 = 0;
    if ($5) {
     break label$1
    }
   }
   $4 = 2;
  }
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h7a0ed8a251b429e6($3 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
  $5 = HEAP32[($3 + 8 | 0) >> 2] | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h7a0ed8a251b429e6($3 | 0, $2 | 0);
  num_bigint__biguint__multiplication__mul3__h007c2e75506c6ce0($3 + 16 | 0 | 0, $5 | 0, $1 | 0, HEAP32[$3 >> 2] | 0 | 0, HEAP32[($3 + 4 | 0) >> 2] | 0 | 0);
  num_bigint__bigint__BigInt__from_biguint__hc8c58ec5989a4432($0 | 0, $4 | 0, $3 + 16 | 0 | 0);
  global$0 = $3 + 32 | 0;
 }
 
 function $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__hdeea20968268d729($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $2 = 0, $3 = 0, $4 = 0, $5 = 0, $5$hi = 0, $6 = 0, $6$hi = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $6 = i64toi32_i32$1;
  $6$hi = i64toi32_i32$0;
  $3 = hashbrown__raw__generic__Group__static_empty__hc5a7932fe1bdb1f1() | 0;
  i64toi32_i32$1 = $0 + 24 | 0;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($0 + 20 | 0) >> 2] = $3;
  $3 = 0;
  HEAP32[($0 + 16 | 0) >> 2] = 0;
  i64toi32_i32$1 = $0;
  i64toi32_i32$0 = 0;
  HEAP32[(i64toi32_i32$1 + 32 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $6$hi;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $6;
  HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $5$hi;
  HEAP32[i64toi32_i32$1 >> 2] = $5;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  label$1 : {
   $4 = HEAP32[($1 + 32 | 0) >> 2] | 0;
   if (!$4) {
    break label$1
   }
   $3 = HEAP32[($4 + 100 | 0) >> 2] | 0;
  }
  HEAP32[($2 + 4 | 0) >> 2] = $4;
  HEAP32[$2 >> 2] = $3;
  HEAP32[($2 + 8 | 0) >> 2] = HEAP32[($1 + 28 | 0) >> 2] | 0;
  $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__iter__traits__collect__Extend__28K_2cV_29____extend__hc8a1fe6915e72fc0($0 | 0, $2 | 0);
  global$0 = $2 + 16 | 0;
 }
 
 function $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h44c6d4679ef9fae6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $2 = 0, $3 = 0, $4 = 0, $5 = 0, $5$hi = 0, $6 = 0, $6$hi = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $6 = i64toi32_i32$1;
  $6$hi = i64toi32_i32$0;
  $3 = hashbrown__raw__generic__Group__static_empty__hc5a7932fe1bdb1f1() | 0;
  i64toi32_i32$1 = $0 + 24 | 0;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($0 + 20 | 0) >> 2] = $3;
  $3 = 0;
  HEAP32[($0 + 16 | 0) >> 2] = 0;
  i64toi32_i32$1 = $0;
  i64toi32_i32$0 = 0;
  HEAP32[(i64toi32_i32$1 + 32 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $6$hi;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $6;
  HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $5$hi;
  HEAP32[i64toi32_i32$1 >> 2] = $5;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  label$1 : {
   $4 = HEAP32[($1 + 32 | 0) >> 2] | 0;
   if (!$4) {
    break label$1
   }
   $3 = HEAP32[($4 + 60 | 0) >> 2] | 0;
  }
  HEAP32[($2 + 4 | 0) >> 2] = $4;
  HEAP32[$2 >> 2] = $3;
  HEAP32[($2 + 8 | 0) >> 2] = HEAP32[($1 + 28 | 0) >> 2] | 0;
  $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__iter__traits__collect__Extend__28K_2cV_29____extend__h8816371e9eef4d29($0 | 0, $2 | 0);
  global$0 = $2 + 16 | 0;
 }
 
 function $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h023fc265abc510b5($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $2 = 0, $3 = 0, $4 = 0, $5 = 0, $5$hi = 0, $6 = 0, $6$hi = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $6 = i64toi32_i32$1;
  $6$hi = i64toi32_i32$0;
  $3 = hashbrown__raw__generic__Group__static_empty__hc5a7932fe1bdb1f1() | 0;
  i64toi32_i32$1 = $0 + 24 | 0;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($0 + 20 | 0) >> 2] = $3;
  $3 = 0;
  HEAP32[($0 + 16 | 0) >> 2] = 0;
  i64toi32_i32$1 = $0;
  i64toi32_i32$0 = 0;
  HEAP32[(i64toi32_i32$1 + 32 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $6$hi;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $6;
  HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $5$hi;
  HEAP32[i64toi32_i32$1 >> 2] = $5;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  label$1 : {
   $4 = HEAP32[($1 + 32 | 0) >> 2] | 0;
   if (!$4) {
    break label$1
   }
   $3 = HEAP32[($4 + 156 | 0) >> 2] | 0;
  }
  HEAP32[($2 + 4 | 0) >> 2] = $4;
  HEAP32[$2 >> 2] = $3;
  HEAP32[($2 + 8 | 0) >> 2] = HEAP32[($1 + 28 | 0) >> 2] | 0;
  $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__iter__traits__collect__Extend__28K_2cV_29____extend__h5509c9cd41af8dd9($0 | 0, $2 | 0);
  global$0 = $2 + 16 | 0;
 }
 
 function $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h145f71b95ce2a2a5($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $2 = 0, $3 = 0, $4 = 0, $5 = 0, $5$hi = 0, $6 = 0, $6$hi = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $6 = i64toi32_i32$1;
  $6$hi = i64toi32_i32$0;
  $3 = hashbrown__raw__generic__Group__static_empty__hc5a7932fe1bdb1f1() | 0;
  i64toi32_i32$1 = $0 + 24 | 0;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($0 + 20 | 0) >> 2] = $3;
  $3 = 0;
  HEAP32[($0 + 16 | 0) >> 2] = 0;
  i64toi32_i32$1 = $0;
  i64toi32_i32$0 = 0;
  HEAP32[(i64toi32_i32$1 + 32 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $6$hi;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $6;
  HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $5$hi;
  HEAP32[i64toi32_i32$1 >> 2] = $5;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  label$1 : {
   $4 = HEAP32[($1 + 32 | 0) >> 2] | 0;
   if (!$4) {
    break label$1
   }
   $3 = HEAP32[($4 + 68 | 0) >> 2] | 0;
  }
  HEAP32[($2 + 4 | 0) >> 2] = $4;
  HEAP32[$2 >> 2] = $3;
  HEAP32[($2 + 8 | 0) >> 2] = HEAP32[($1 + 28 | 0) >> 2] | 0;
  $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__iter__traits__collect__Extend__28K_2cV_29____extend__hf141c664ff96472c($0 | 0, $2 | 0);
  global$0 = $2 + 16 | 0;
 }
 
 function $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h7490700a7eed2994($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $2 = 0, $3 = 0, $4 = 0, $5 = 0, $5$hi = 0, $6 = 0, $6$hi = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $6 = i64toi32_i32$1;
  $6$hi = i64toi32_i32$0;
  $3 = hashbrown__raw__generic__Group__static_empty__hc5a7932fe1bdb1f1() | 0;
  i64toi32_i32$1 = $0 + 24 | 0;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($0 + 20 | 0) >> 2] = $3;
  $3 = 0;
  HEAP32[($0 + 16 | 0) >> 2] = 0;
  i64toi32_i32$1 = $0;
  i64toi32_i32$0 = 0;
  HEAP32[(i64toi32_i32$1 + 32 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $6$hi;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $6;
  HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $5$hi;
  HEAP32[i64toi32_i32$1 >> 2] = $5;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  label$1 : {
   $4 = HEAP32[($1 + 32 | 0) >> 2] | 0;
   if (!$4) {
    break label$1
   }
   $3 = HEAP32[($4 + 20 | 0) >> 2] | 0;
  }
  HEAP32[($2 + 4 | 0) >> 2] = $4;
  HEAP32[$2 >> 2] = $3;
  HEAP32[($2 + 8 | 0) >> 2] = HEAP32[($1 + 28 | 0) >> 2] | 0;
  $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__iter__traits__collect__Extend__28K_2cV_29____extend__h2844134357a5aef9($0 | 0, $2 | 0);
  global$0 = $2 + 16 | 0;
 }
 
 function $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h847b9d84e24adaa5($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $2 = 0, $3 = 0, $4 = 0, $5 = 0, $5$hi = 0, $6 = 0, $6$hi = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $6 = i64toi32_i32$1;
  $6$hi = i64toi32_i32$0;
  $3 = hashbrown__raw__generic__Group__static_empty__hc5a7932fe1bdb1f1() | 0;
  i64toi32_i32$1 = $0 + 24 | 0;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($0 + 20 | 0) >> 2] = $3;
  $3 = 0;
  HEAP32[($0 + 16 | 0) >> 2] = 0;
  i64toi32_i32$1 = $0;
  i64toi32_i32$0 = 0;
  HEAP32[(i64toi32_i32$1 + 32 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $6$hi;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $6;
  HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $5$hi;
  HEAP32[i64toi32_i32$1 >> 2] = $5;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  label$1 : {
   $4 = HEAP32[($1 + 32 | 0) >> 2] | 0;
   if (!$4) {
    break label$1
   }
   $3 = HEAP32[($4 + 412 | 0) >> 2] | 0;
  }
  HEAP32[($2 + 4 | 0) >> 2] = $4;
  HEAP32[$2 >> 2] = $3;
  HEAP32[($2 + 8 | 0) >> 2] = HEAP32[($1 + 28 | 0) >> 2] | 0;
  $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__iter__traits__collect__Extend__28K_2cV_29____extend__ha0dab88e5bf54460($0 | 0, $2 | 0);
  global$0 = $2 + 16 | 0;
 }
 
 function $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h8cac34049618832f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $2 = 0, $3 = 0, $4 = 0, $5 = 0, $5$hi = 0, $6 = 0, $6$hi = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $6 = i64toi32_i32$1;
  $6$hi = i64toi32_i32$0;
  $3 = hashbrown__raw__generic__Group__static_empty__hc5a7932fe1bdb1f1() | 0;
  i64toi32_i32$1 = $0 + 24 | 0;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($0 + 20 | 0) >> 2] = $3;
  $3 = 0;
  HEAP32[($0 + 16 | 0) >> 2] = 0;
  i64toi32_i32$1 = $0;
  i64toi32_i32$0 = 0;
  HEAP32[(i64toi32_i32$1 + 32 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 36 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $6$hi;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $6;
  HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $5$hi;
  HEAP32[i64toi32_i32$1 >> 2] = $5;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  label$1 : {
   $4 = HEAP32[($1 + 32 | 0) >> 2] | 0;
   if (!$4) {
    break label$1
   }
   $3 = HEAP32[($4 + 12 | 0) >> 2] | 0;
  }
  HEAP32[($2 + 4 | 0) >> 2] = $4;
  HEAP32[$2 >> 2] = $3;
  HEAP32[($2 + 8 | 0) >> 2] = HEAP32[($1 + 28 | 0) >> 2] | 0;
  $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__iter__traits__collect__Extend__28K_2cV_29____extend__h675e35b5920dd1f3($0 | 0, $2 | 0);
  global$0 = $2 + 16 | 0;
 }
 
 function cardano_serialization_lib__crypto__BootstrapWitnesses__get__hbea43679996fcd34($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $11 = 0, $12 = 0, $13 = 0, $14 = 0, $3 = 0, $18 = 0, $23 = 0, $28 = 0, $33 = 0;
  label$1 : {
   $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   if ($3 >>> 0 > $2 >>> 0) {
    break label$1
   }
   core__panicking__panic_bounds_check__h808b524af17640b1($2 | 0, $3 | 0, 1066716 | 0);
   abort();
  }
  $2 = (HEAP32[$1 >> 2] | 0) + Math_imul($2, 120) | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAPU8[($2 + 24 | 0) >> 0] | 0 | ((HEAPU8[($2 + 25 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 26 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 27 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[($2 + 28 | 0) >> 0] | 0 | ((HEAPU8[($2 + 29 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 30 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 31 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  $11 = $18;
  HEAP8[(i64toi32_i32$0 + 24 | 0) >> 0] = $11;
  HEAP8[(i64toi32_i32$0 + 25 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 26 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 27 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 28 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 29 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 30 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 31 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 48 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $23 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 48 | 0;
  $12 = $23;
  HEAP8[i64toi32_i32$1 >> 0] = $12;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 40 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $28 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 40 | 0;
  $13 = $28;
  HEAP8[i64toi32_i32$0 >> 0] = $13;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 32 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $33 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 32 | 0;
  $14 = $33;
  HEAP8[i64toi32_i32$1 >> 0] = $14;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $14 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $14 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $14 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  memcpy($0 + 56 | 0 | 0, $2 + 56 | 0 | 0, 64 | 0) | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($0 | 0, $2 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($0 + 12 | 0 | 0, $2 + 12 | 0 | 0);
 }
 
 function txinputsbuilder_new() {
  var $0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $1 = 0, $2 = 0, $2$hi = 0, $3 = 0, $3$hi = 0;
  $0 = global$0 - 96 | 0;
  global$0 = $0;
  std__thread__local__LocalKey_T___with__h4cd07b14a44a727e($0 | 0, 1060968 | 0);
  i64toi32_i32$0 = HEAP32[$0 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $2 = i64toi32_i32$0;
  $2$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($0 + 12 | 0) >> 2] | 0;
  $3 = i64toi32_i32$1;
  $3$hi = i64toi32_i32$0;
  $1 = hashbrown__raw__generic__Group__static_empty__hc5a7932fe1bdb1f1() | 0;
  i64toi32_i32$1 = $0 + 40 | 0;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($0 + 36 | 0) >> 2] = $1;
  i64toi32_i32$1 = $0 + 48 | 0;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$1 = $0 + 84 | 0;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$1 = $0 + 72 | 0;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$1 = $0 + 60 | 0;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($0 + 32 | 0) >> 2] = 0;
  i64toi32_i32$0 = $3$hi;
  i64toi32_i32$1 = $0;
  HEAP32[($0 + 24 | 0) >> 2] = $3;
  HEAP32[($0 + 28 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $2$hi;
  i64toi32_i32$1 = $0;
  HEAP32[($0 + 16 | 0) >> 2] = $2;
  HEAP32[($0 + 20 | 0) >> 2] = i64toi32_i32$0;
  $1 = $cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hb3357880063a5222($0 + 16 | 0 | 0) | 0;
  global$0 = $0 + 96 | 0;
  return $1 | 0;
 }
 
 function cardano_serialization_lib__error___impl_20core__convert__From_cardano_serialization_lib__error__DeserializeError__20for_20wasm_bindgen__JsValue___from__he1b076baa9554dfd($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  HEAP32[($1 + 20 | 0) >> 2] = 0;
  HEAP32[($1 + 24 | 0) >> 2] = 0;
  HEAP32[($1 + 16 | 0) >> 2] = HEAP32[(0 + 1070048 | 0) >> 2] | 0;
  core__fmt__Formatter__new__he219faf25326051b($1 + 32 | 0 | 0, $1 + 16 | 0 | 0, 1069768 | 0);
  label$1 : {
   if (!($cardano_serialization_lib__error__DeserializeError_20as_20core__fmt__Display___fmt__h10cc598fcad2b670($0 | 0, $1 + 32 | 0 | 0) | 0)) {
    break label$1
   }
   core__result__unwrap_failed__h27f43d993c3864a1(1069792 | 0, 55 | 0, $1 + 72 | 0 | 0, 1069940 | 0, 1069924 | 0);
   abort();
  }
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($1 + 8 | 0 | 0, $1 + 16 | 0 | 0);
  $2 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(HEAP32[($1 + 8 | 0) >> 2] | 0 | 0, HEAP32[($1 + 12 | 0) >> 2] | 0 | 0) | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 + 16 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 + 16 | 0 | 0);
  core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9_2($0 | 0);
  global$0 = $1 + 80 | 0;
  return $2 | 0;
 }
 
 function hex__val__h25ac2b567437a027($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       if ((($1 + -65 | 0) & 255 | 0) >>> 0 < 6 >>> 0) {
        break label$5
       }
       if ((($1 + -97 | 0) & 255 | 0) >>> 0 < 6 >>> 0) {
        break label$4
       }
       $3 = $1 + -48 | 0;
       if (($3 & 255 | 0) >>> 0 < 10 >>> 0) {
        break label$3
       }
       HEAP32[($0 + 8 | 0) >> 2] = $2;
       HEAP32[($0 + 4 | 0) >> 2] = $1 & 255 | 0;
       $1 = 1;
       break label$1;
      }
      HEAP8[($0 + 1 | 0) >> 0] = $1 + -55 | 0;
      break label$2;
     }
     HEAP8[($0 + 1 | 0) >> 0] = $1 + -87 | 0;
     break label$2;
    }
    HEAP8[($0 + 1 | 0) >> 0] = $3;
   }
   $1 = 0;
  }
  HEAP8[$0 >> 0] = $1;
 }
 
 function core__fmt__num___impl_20core__fmt__Binary_20for_20i8___fmt__h95e145d0c624e1be($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $3 = 0, $2 = 0;
  $2 = global$0 - 128 | 0;
  global$0 = $2;
  $3 = HEAPU8[$0 >> 0] | 0;
  $0 = 0;
  label$1 : while (1) {
   HEAP8[(($2 + $0 | 0) + 127 | 0) >> 0] = $3 & 1 | 0 | 48 | 0;
   $0 = $0 + -1 | 0;
   $3 = ($3 >>> 1 | 0) & 127 | 0;
   if ($3) {
    continue label$1
   }
   break label$1;
  };
  label$2 : {
   $3 = $0 + 128 | 0;
   if ($3 >>> 0 < 129 >>> 0) {
    break label$2
   }
   core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($3 | 0, 128 | 0, 1150164 | 0);
   abort();
  }
  $0 = core__fmt__Formatter__pad_integral__h08e3e53a0de517a1($1 | 0, 1 | 0, 1150182 | 0, 2 | 0, ($2 + $0 | 0) + 128 | 0 | 0, 0 - $0 | 0 | 0) | 0;
  global$0 = $2 + 128 | 0;
  return $0 | 0;
 }
 
 function alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal___push__h571d2b7933db7a9d($0, $1, $2, $2$hi, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0;
  label$1 : {
   label$2 : {
    if (((HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) != ($3 | 0)) {
     break label$2
    }
    $0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    $3 = HEAPU16[($0 + 138 | 0) >> 1] | 0;
    if ($3 >>> 0 <= 10 >>> 0) {
     break label$1
    }
    core__panicking__panic__h2fd385a887c8bf13(1048619 | 0, 32 | 0, 1048824 | 0);
    abort();
   }
   core__panicking__panic__h2fd385a887c8bf13(1048760 | 0, 48 | 0, 1048808 | 0);
   abort();
  }
  $5 = $3 + 1 | 0;
  HEAP16[($0 + 138 | 0) >> 1] = $5;
  HEAP32[(($0 + ($3 << 2 | 0) | 0) + 92 | 0) >> 2] = $1;
  i64toi32_i32$0 = $2$hi;
  i64toi32_i32$1 = $0 + ($3 << 3 | 0) | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $2;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[(($0 + ($5 << 2 | 0) | 0) + 144 | 0) >> 2] = $4;
  HEAP16[($4 + 136 | 0) >> 1] = $5;
  HEAP32[($4 + 88 | 0) >> 2] = $0;
 }
 
 function $std__io__cursor__Cursor_T__20as_20std__io__Read___read_exact__h9623dbdca04d0b37($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$5 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $3 = 0, $5$hi = 0, $6$hi = 0, $18 = 0, $5 = 0, $6 = 0, $4 = 0, $31 = 0, $33$hi = 0, $35$hi = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($3 + 8 | 0 | 0, $0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[($3 + 12 | 0) >> 2] | 0) >>> 0 >= $2 >>> 0) {
     break label$2
    }
    i64toi32_i32$0 = 0;
    i64toi32_i32$2 = 1055604;
    i64toi32_i32$1 = 0;
    i64toi32_i32$3 = 32;
    i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
     $18 = 0;
    } else {
     i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
     $18 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
    }
    i64toi32_i32$0 = $18;
    i64toi32_i32$2 = 0;
    i64toi32_i32$3 = 9472;
    i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
    $5 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
    $5$hi = i64toi32_i32$2;
    i64toi32_i32$2 = 0;
    $6 = 2;
    $6$hi = i64toi32_i32$2;
    break label$1;
   }
   $4 = HEAP32[($3 + 8 | 0) >> 2] | 0;
   label$3 : {
    label$4 : {
     if (($2 | 0) == (1 | 0)) {
      break label$4
     }
     core__slice___impl_20_5bT_5d___copy_from_slice__h0f69c19ed1852955($1 | 0, $2 | 0, $4 | 0, $2 | 0);
     break label$3;
    }
    HEAP8[$1 >> 0] = HEAPU8[$4 >> 0] | 0;
   }
   $31 = $0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $33$hi = i64toi32_i32$0;
   i64toi32_i32$0 = 0;
   $35$hi = i64toi32_i32$0;
   i64toi32_i32$0 = $33$hi;
   i64toi32_i32$1 = i64toi32_i32$2;
   i64toi32_i32$2 = $35$hi;
   i64toi32_i32$3 = $2;
   i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
   i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
   if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
    i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
   }
   i64toi32_i32$1 = $31;
   HEAP32[i64toi32_i32$1 >> 2] = i64toi32_i32$4;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$5 = 0;
   $6 = 4;
   $6$hi = i64toi32_i32$5;
   i64toi32_i32$5 = 0;
   $5 = 0;
   $5$hi = i64toi32_i32$5;
  }
  global$0 = $3 + 16 | 0;
  i64toi32_i32$5 = $6$hi;
  i64toi32_i32$5 = $5$hi;
  i64toi32_i32$5 = $6$hi;
  i64toi32_i32$0 = $6;
  i64toi32_i32$1 = $5$hi;
  i64toi32_i32$3 = $5;
  i64toi32_i32$1 = i64toi32_i32$5 | i64toi32_i32$1 | 0;
  i64toi32_i32$0 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$1;
  return i64toi32_i32$0 | 0;
 }
 
 function $std__io__cursor__Cursor_T__20as_20std__io__Read___read_exact__hbd2417346db3632b($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$5 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $3 = 0, $5$hi = 0, $6$hi = 0, $18 = 0, $5 = 0, $6 = 0, $4 = 0, $31 = 0, $33$hi = 0, $35$hi = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  std__io__cursor__Cursor_T___remaining_slice__h5de2a0dd397eef35($3 + 8 | 0 | 0, $0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[($3 + 12 | 0) >> 2] | 0) >>> 0 >= $2 >>> 0) {
     break label$2
    }
    i64toi32_i32$0 = 0;
    i64toi32_i32$2 = 1055604;
    i64toi32_i32$1 = 0;
    i64toi32_i32$3 = 32;
    i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
     $18 = 0;
    } else {
     i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
     $18 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
    }
    i64toi32_i32$0 = $18;
    i64toi32_i32$2 = 0;
    i64toi32_i32$3 = 9472;
    i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
    $5 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
    $5$hi = i64toi32_i32$2;
    i64toi32_i32$2 = 0;
    $6 = 2;
    $6$hi = i64toi32_i32$2;
    break label$1;
   }
   $4 = HEAP32[($3 + 8 | 0) >> 2] | 0;
   label$3 : {
    label$4 : {
     if (($2 | 0) == (1 | 0)) {
      break label$4
     }
     core__slice___impl_20_5bT_5d___copy_from_slice__h0f69c19ed1852955($1 | 0, $2 | 0, $4 | 0, $2 | 0);
     break label$3;
    }
    HEAP8[$1 >> 0] = HEAPU8[$4 >> 0] | 0;
   }
   $31 = $0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$2 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $33$hi = i64toi32_i32$0;
   i64toi32_i32$0 = 0;
   $35$hi = i64toi32_i32$0;
   i64toi32_i32$0 = $33$hi;
   i64toi32_i32$1 = i64toi32_i32$2;
   i64toi32_i32$2 = $35$hi;
   i64toi32_i32$3 = $2;
   i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
   i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
   if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
    i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
   }
   i64toi32_i32$1 = $31;
   HEAP32[i64toi32_i32$1 >> 2] = i64toi32_i32$4;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$5;
   i64toi32_i32$5 = 0;
   $6 = 4;
   $6$hi = i64toi32_i32$5;
   i64toi32_i32$5 = 0;
   $5 = 0;
   $5$hi = i64toi32_i32$5;
  }
  global$0 = $3 + 16 | 0;
  i64toi32_i32$5 = $6$hi;
  i64toi32_i32$5 = $5$hi;
  i64toi32_i32$5 = $6$hi;
  i64toi32_i32$0 = $6;
  i64toi32_i32$1 = $5$hi;
  i64toi32_i32$3 = $5;
  i64toi32_i32$1 = i64toi32_i32$5 | i64toi32_i32$1 | 0;
  i64toi32_i32$0 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$1;
  return i64toi32_i32$0 | 0;
 }
 
 function $std__io__cursor__Cursor_T__20as_20std__io__Read___read__h40f2bf5423b60e92($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $6 = 0, i64toi32_i32$2 = 0, $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$5 = 0, $5 = 0, i64toi32_i32$4 = 0, $37 = 0, $39$hi = 0, $41$hi = 0;
  $4 = global$0 - 16 | 0;
  global$0 = $4;
  std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($4 + 8 | 0 | 0, $1 | 0);
  $5 = HEAP32[($4 + 8 | 0) >> 2] | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     $6 = HEAP32[($4 + 12 | 0) >> 2] | 0;
     $6 = $6 >>> 0 < $3 >>> 0 ? $6 : $3;
     if (($6 | 0) == (1 | 0)) {
      break label$3
     }
     core__slice___impl_20_5bT_5d___copy_from_slice__h0f69c19ed1852955($2 | 0, $6 | 0, $5 | 0, $6 | 0);
     break label$2;
    }
    if (!$3) {
     break label$1
    }
    HEAP8[$2 >> 0] = HEAPU8[$5 >> 0] | 0;
   }
   HEAP32[($0 + 4 | 0) >> 2] = $6;
   HEAP32[$0 >> 2] = 0;
   $37 = $1;
   i64toi32_i32$2 = $1;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $39$hi = i64toi32_i32$1;
   i64toi32_i32$1 = 0;
   $41$hi = i64toi32_i32$1;
   i64toi32_i32$1 = $39$hi;
   i64toi32_i32$2 = i64toi32_i32$0;
   i64toi32_i32$0 = $41$hi;
   i64toi32_i32$4 = i64toi32_i32$2 + $6 | 0;
   i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
   if (i64toi32_i32$4 >>> 0 < $6 >>> 0) {
    i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
   }
   i64toi32_i32$2 = $37;
   HEAP32[i64toi32_i32$2 >> 2] = i64toi32_i32$4;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$5;
   global$0 = $4 + 16 | 0;
   return;
  }
  core__panicking__panic_bounds_check__h808b524af17640b1(0 | 0, 0 | 0, 1055688 | 0);
  abort();
 }
 
 function bignum_compare($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $4 = 0, $4$hi = 0, $5 = 0, $5$hi = 0, $3 = 0, $43 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($2 | 0, $1 | 0);
   i64toi32_i32$2 = $3;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $4 = i64toi32_i32$0;
   $4$hi = i64toi32_i32$1;
   i64toi32_i32$2 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $5 = i64toi32_i32$1;
   $5$hi = i64toi32_i32$0;
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   i64toi32_i32$0 = $4$hi;
   i64toi32_i32$0 = $5$hi;
   i64toi32_i32$0 = $4$hi;
   i64toi32_i32$2 = $4;
   i64toi32_i32$1 = $5$hi;
   $43 = (i64toi32_i32$2 | 0) != ($5 | 0) | (i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | 0;
   i64toi32_i32$2 = i64toi32_i32$0;
   i64toi32_i32$2 = i64toi32_i32$1;
   i64toi32_i32$2 = i64toi32_i32$0;
   i64toi32_i32$0 = i64toi32_i32$1;
   i64toi32_i32$1 = $5;
   return (i64toi32_i32$2 >>> 0 < i64toi32_i32$0 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) & $4 >>> 0 < i64toi32_i32$1 >>> 0 | 0) | 0 ? -1 : $43) | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionmetadatum_as_list($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__hc630c86c4ab6b26d($1 + 8 | 0 | 0, $0 | 0);
    $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    cardano_serialization_lib__metadata__TransactionMetadatum__as_list__he0dbba76ab1128da($1 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    $0 = HEAP32[($1 + 20 | 0) >> 2] | 0;
    if ((HEAP32[($1 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    i64toi32_i32$2 = $1 + 24 | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    HEAP32[($1 + 36 | 0) >> 2] = HEAP32[i64toi32_i32$2 >> 2] | 0;
    HEAP32[($1 + 40 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($1 + 32 | 0) >> 2] = $0;
    $0 = $cardano_serialization_lib__metadata__MetadataList_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h726a255338699014($1 + 32 | 0 | 0) | 0;
    global$0 = $1 + 48 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472($0 | 0);
  abort();
 }
 
 function auxiliarydata_set_metadata($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h55a9e62aded28c25($2 + 16 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   $0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h670b86b1bfb2242f($2 + 8 | 0 | 0, $1 | 0);
   $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h44c6d4679ef9fae6($2 + 24 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
   core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__metadata__GeneralTransactionMetadata____h37a091753d7f028f($0 | 0);
   memcpy($0 | 0, $2 + 24 | 0 | 0, 40 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 64 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function core__ops__function__impls___impl_20core__ops__function__FnMut_A__20for_20_mut_20F___call_mut__he41f5047aba19e56($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $15 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    $1 = HEAP32[$1 >> 2] | 0;
    if ((HEAP32[($1 + 72 | 0) >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $15 = $1 + 76 | 0;
    $1 = HEAP32[(HEAP32[$0 >> 2] | 0) >> 2] | 0;
    cardano_serialization_lib__MultiAsset__get__had0c36a2c855d776($2 + 16 | 0 | 0, $15 | 0, HEAP32[(HEAP32[$1 >> 2] | 0) >> 2] | 0 | 0);
    if ((HEAP32[($2 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    HEAP32[($2 + 8 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
    HEAP32[$2 >> 2] = HEAP32[($2 + 20 | 0) >> 2] | 0;
    HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$1;
    $1 = (alloc__collections__btree__map__BTreeMap_K_2cV___get__h825f34112f7eacbf($2 | 0, HEAP32[(HEAP32[($1 + 4 | 0) >> 2] | 0) >> 2] | 0 | 0) | 0 | 0) != (0 | 0);
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h6c9f94f0f82ce2b5($2 | 0);
    break label$1;
   }
   $1 = 0;
  }
  global$0 = $2 + 32 | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__crypto__Vkeywitness_20as_20cbor_event__se__Serialize___serialize__h5cf30721c029e59b($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, 2 | 0, 0 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     $cardano_serialization_lib__crypto__Vkey_20as_20cbor_event__se__Serialize___serialize__he0fe1f32129559ab($3 | 0, $1 | 0, $2 | 0);
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$2
     }
     cbor_event__se__Serializer_W___write_bytes__h1ecbe6b3316bc5ff($0 | 0, $2 | 0, $1 + 32 | 0 | 0, 64 | 0);
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__inputs_option__hcc9a5caf03e37d78($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $24 = 0, $30 = 0, $33 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if (HEAP32[($1 + 72 | 0) >> 2] | 0) {
     break label$2
    }
    HEAP32[$0 >> 2] = 0;
    break label$1;
   }
   alloc__collections__btree__map__BTreeMap_K_2cV___iter__h721110b568622f84($2 | 0, $1 + 64 | 0 | 0);
   HEAP32[(($2 + 32 | 0) + 24 | 0) >> 2] = HEAP32[($2 + 24 | 0) >> 2] | 0;
   i64toi32_i32$2 = $2 + 16 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $24 = i64toi32_i32$0;
   i64toi32_i32$0 = ($2 + 32 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $24;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $2 + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $30 = i64toi32_i32$1;
   i64toi32_i32$1 = ($2 + 32 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $30;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $33 = i64toi32_i32$0;
   i64toi32_i32$0 = $2;
   HEAP32[($2 + 32 | 0) >> 2] = $33;
   HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
   $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__he4e09da31a8bd115($0 | 0, $2 + 32 | 0 | 0);
  }
  global$0 = $2 + 64 | 0;
 }
 
 function wasm_bindgen__convert__closures__invoke3_mut__hc2deb07f81cdeff0($0, $1, $2, $3, $4, $5) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  $5 = $5 | 0;
  var $6 = 0, i64toi32_i32$1 = 0;
  $6 = global$0 - 32 | 0;
  global$0 = $6;
  label$1 : {
   if (!$1) {
    break label$1
   }
   FUNCTION_TABLE[HEAP32[($2 + 12 | 0) >> 2] | 0 | 0]($6, $1, $3, $4, $5);
   $1 = HEAP32[($6 + 8 | 0) >> 2] | 0;
   HEAP32[(($6 + 16 | 0) + 8 | 0) >> 2] = $1;
   i64toi32_i32$1 = HEAP32[($6 + 4 | 0) >> 2] | 0;
   HEAP32[($6 + 16 | 0) >> 2] = HEAP32[$6 >> 2] | 0;
   HEAP32[($6 + 20 | 0) >> 2] = i64toi32_i32$1;
   label$2 : {
    if ((HEAP32[($6 + 20 | 0) >> 2] | 0) >>> 0 <= $1 >>> 0) {
     break label$2
    }
    alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h2f0517af2eff7407($6 + 16 | 0 | 0, $1 | 0);
    $1 = HEAP32[($6 + 24 | 0) >> 2] | 0;
   }
   $2 = HEAP32[($6 + 16 | 0) >> 2] | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $2;
   global$0 = $6 + 32 | 0;
   return;
  }
  wasm_bindgen__throw_str__h40ff0247f6a635d7(1076516 | 0, 48 | 0);
  abort();
 }
 
 function cryptoxide__curve25519__scalar__scalar64__Scalar__from_bytes_canonical__hf5699d4fb7c90b32($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, $2 = 0, $3 = 0, $3$hi = 0, $23 = 0, $24 = 0, $25 = 0, $26 = 0, $28 = 0, $29 = 0, $30 = 0, $11 = 0, $11$hi = 0, $13 = 0, $13$hi = 0, $15 = 0, $15$hi = 0, $19$hi = 0, $22$hi = 0, $25$hi = 0, $27 = 0, $27$hi = 0, $29$hi = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  cryptoxide__curve25519__scalar__scalar64__Scalar__from_bytes__hcfeedd1974a72bb6($2 + 8 | 0 | 0, $1 | 0);
  i64toi32_i32$0 = 0;
  $3 = 0;
  $3$hi = i64toi32_i32$0;
  label$1 : {
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 40 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 44 | 0) >> 2] | 0;
   $11 = i64toi32_i32$0;
   $11$hi = i64toi32_i32$1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 24 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 28 | 0) >> 2] | 0;
   $13 = i64toi32_i32$1;
   $13$hi = i64toi32_i32$0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
   $15 = i64toi32_i32$0;
   $15$hi = i64toi32_i32$1;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
   i64toi32_i32$2 = i64toi32_i32$1;
   i64toi32_i32$1 = -1205019;
   i64toi32_i32$3 = -1559614445;
   i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
   i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
   if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
    i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
   }
   i64toi32_i32$0 = i64toi32_i32$4;
   i64toi32_i32$2 = 0;
   i64toi32_i32$3 = 63;
   i64toi32_i32$1 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$2 = i64toi32_i32$5 >> 31 | 0;
    $23 = i64toi32_i32$5 >> i64toi32_i32$1 | 0;
   } else {
    i64toi32_i32$2 = i64toi32_i32$5 >> i64toi32_i32$1 | 0;
    $23 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$1 | 0) | 0;
   }
   $19$hi = i64toi32_i32$2;
   i64toi32_i32$2 = $15$hi;
   i64toi32_i32$5 = $15;
   i64toi32_i32$0 = $19$hi;
   i64toi32_i32$3 = $23;
   i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
   i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
   if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
    i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
   }
   i64toi32_i32$2 = i64toi32_i32$1;
   i64toi32_i32$5 = -16375459;
   i64toi32_i32$3 = 140716456;
   i64toi32_i32$0 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
   i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
   if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
    i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
   }
   i64toi32_i32$4 = i64toi32_i32$0;
   i64toi32_i32$2 = 0;
   i64toi32_i32$3 = 63;
   i64toi32_i32$5 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$2 = i64toi32_i32$1 >> 31 | 0;
    $24 = i64toi32_i32$1 >> i64toi32_i32$5 | 0;
   } else {
    i64toi32_i32$2 = i64toi32_i32$1 >> i64toi32_i32$5 | 0;
    $24 = (((1 << i64toi32_i32$5 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$5 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$5 | 0) | 0;
   }
   $22$hi = i64toi32_i32$2;
   i64toi32_i32$2 = $13$hi;
   i64toi32_i32$1 = $13;
   i64toi32_i32$4 = $22$hi;
   i64toi32_i32$3 = $24;
   i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
   i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
   if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
    i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
   }
   i64toi32_i32$2 = i64toi32_i32$5;
   i64toi32_i32$1 = -1;
   i64toi32_i32$3 = -5342;
   i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
   i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
   if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
    i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
   }
   i64toi32_i32$0 = i64toi32_i32$4;
   i64toi32_i32$2 = 0;
   i64toi32_i32$3 = 63;
   i64toi32_i32$1 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$2 = i64toi32_i32$5 >> 31 | 0;
    $25 = i64toi32_i32$5 >> i64toi32_i32$1 | 0;
   } else {
    i64toi32_i32$2 = i64toi32_i32$5 >> i64toi32_i32$1 | 0;
    $25 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$1 | 0) | 0;
   }
   $25$hi = i64toi32_i32$2;
   i64toi32_i32$5 = $2;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$5 + 32 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$5 + 36 | 0) >> 2] | 0;
   $27 = i64toi32_i32$2;
   $27$hi = i64toi32_i32$0;
   i64toi32_i32$0 = $25$hi;
   i64toi32_i32$5 = $25;
   i64toi32_i32$2 = $27$hi;
   i64toi32_i32$3 = $27;
   i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
   i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
   if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
    i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
   }
   i64toi32_i32$0 = i64toi32_i32$1;
   i64toi32_i32$5 = 0;
   i64toi32_i32$3 = 63;
   i64toi32_i32$2 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$5 = i64toi32_i32$4 >> 31 | 0;
    $26 = i64toi32_i32$4 >> i64toi32_i32$2 | 0;
   } else {
    i64toi32_i32$5 = i64toi32_i32$4 >> i64toi32_i32$2 | 0;
    $26 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$2 | 0) | 0;
   }
   $29$hi = i64toi32_i32$5;
   i64toi32_i32$5 = $11$hi;
   i64toi32_i32$4 = $11;
   i64toi32_i32$0 = $29$hi;
   i64toi32_i32$3 = $26;
   i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
   i64toi32_i32$1 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
   if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
    i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
   }
   i64toi32_i32$5 = i64toi32_i32$2;
   i64toi32_i32$4 = -1;
   i64toi32_i32$3 = -268435456;
   i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
   i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$4 | 0;
   if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
    i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
   }
   i64toi32_i32$1 = i64toi32_i32$0;
   i64toi32_i32$5 = -1;
   i64toi32_i32$3 = -1;
   if ((i64toi32_i32$2 | 0) > (i64toi32_i32$5 | 0)) {
    $28 = 1
   } else {
    if ((i64toi32_i32$2 | 0) >= (i64toi32_i32$5 | 0)) {
     if (i64toi32_i32$1 >>> 0 <= i64toi32_i32$3 >>> 0) {
      $29 = 0
     } else {
      $29 = 1
     }
     $30 = $29;
    } else {
     $30 = 0
    }
    $28 = $30;
   }
   if ($28) {
    break label$1
   }
   memcpy($0 + 8 | 0 | 0, $2 + 8 | 0 | 0, 40 | 0) | 0;
   i64toi32_i32$1 = 0;
   $3 = 1;
   $3$hi = i64toi32_i32$1;
  }
  i64toi32_i32$1 = $3$hi;
  i64toi32_i32$2 = $0;
  HEAP32[i64toi32_i32$2 >> 2] = $3;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $2 + 48 | 0;
 }
 
 function core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   if (!(HEAP32[($0 + 48 | 0) >> 2] | 0)) {
    break label$1
   }
   $1 = $0 + 48 | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  }
  label$2 : {
   label$3 : {
    switch ((HEAPU8[$0 >> 0] | 0) + -2 | 0 | 0) {
    case 0:
     core__ptr__drop_in_place_cbor_event__error__Error___hbf0141ec70b68c45_3($0 + 8 | 0 | 0);
     return;
    case 2:
     core__ptr__drop_in_place_cardano_serialization_lib__error__Key___h6509e27f4cf6a188($0 + 8 | 0 | 0);
     return;
    case 6:
     core__ptr__drop_in_place_cardano_serialization_lib__error__Key___h6509e27f4cf6a188($0 + 8 | 0 | 0);
     core__ptr__drop_in_place_cardano_serialization_lib__error__Key___h6509e27f4cf6a188($0 + 24 | 0 | 0);
     return;
    case 7:
     core__ptr__drop_in_place_cardano_serialization_lib__error__Key___h6509e27f4cf6a188($0 + 8 | 0 | 0);
     return;
    case 8:
     $0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
     if ($0 >>> 0 < 36 >>> 0) {
      break label$2
     }
     wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($0 | 0);
     return;
    case 14:
     break label$3;
    default:
     break label$2;
    };
   }
   core__ptr__drop_in_place_cardano_serialization_lib__error__Key___h6509e27f4cf6a188($0 + 8 | 0 | 0);
  }
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__SerializeEmbeddedGroup_20for_20cardano_serialization_lib__StakeRegistration___serialize_as_embedded_group__he397bae1b05c31fd($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 0 | 0, 0 | 0);
  $4 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     $cardano_serialization_lib__address__StakeCredential_20as_20cbor_event__se__Serialize___serialize__h5b8c776cf4ca6024($3 | 0, $1 | 0, $2 | 0);
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$2
     }
     HEAP32[($0 + 4 | 0) >> 2] = $2;
     $4 = 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $4 = 1;
  }
  HEAP32[$0 >> 2] = $4;
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__SerializeEmbeddedGroup_20for_20cardano_serialization_lib__StakeDeregistration___serialize_as_embedded_group__h8b7f27e940fa4d76($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 1 | 0, 0 | 0);
  $4 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     $cardano_serialization_lib__address__StakeCredential_20as_20cbor_event__se__Serialize___serialize__h5b8c776cf4ca6024($3 | 0, $1 | 0, $2 | 0);
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$2
     }
     HEAP32[($0 + 4 | 0) >> 2] = $2;
     $4 = 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $4 = 1;
  }
  HEAP32[$0 >> 2] = $4;
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__SerializeEmbeddedGroup_20for_20cardano_serialization_lib__PoolRegistration___serialize_as_embedded_group__hfc4829d058526c4d($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 3 | 0, 0 | 0);
  $4 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__SerializeEmbeddedGroup_20for_20cardano_serialization_lib__PoolParams___serialize_as_embedded_group__h6dc6f400e7f8e6e4($3 | 0, $1 | 0, $2 | 0);
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$2
     }
     HEAP32[($0 + 4 | 0) >> 2] = $2;
     $4 = 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $4 = 1;
  }
  HEAP32[$0 >> 2] = $4;
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__SerializeEmbeddedGroup_20for_20cardano_serialization_lib__MoveInstantaneousRewardsCert___serialize_as_embedded_group__h85726fc7bbd0a5c4($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 6 | 0, 0 | 0);
  $4 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__MoveInstantaneousReward___serialize__hc9e545ed3c236536($3 | 0, $1 | 0, $2 | 0);
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$2
     }
     HEAP32[($0 + 4 | 0) >> 2] = $2;
     $4 = 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $4 = 1;
  }
  HEAP32[$0 >> 2] = $4;
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__SerializeEmbeddedGroup_20for_20cardano_serialization_lib__MultiHostName___serialize_as_embedded_group__h66ca7f110fbbc19d($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 2 | 0, 0 | 0);
  $4 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     cbor_event__se__Serializer_W___write_text__hb80b098c4abeea7e($3 | 0, $2 | 0, $1 | 0);
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$2
     }
     HEAP32[($0 + 4 | 0) >> 2] = $2;
     $4 = 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $4 = 1;
  }
  HEAP32[$0 >> 2] = $4;
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__SerializeEmbeddedGroup_20for_20cardano_serialization_lib__ScriptAll___serialize_as_embedded_group__h0d66eab23a74dee9($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 1 | 0, 0 | 0);
  $4 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__NativeScripts___serialize__hecc991a2909139b7($3 | 0, $1 | 0, $2 | 0);
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$2
     }
     HEAP32[($0 + 4 | 0) >> 2] = $2;
     $4 = 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $4 = 1;
  }
  HEAP32[$0 >> 2] = $4;
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__SerializeEmbeddedGroup_20for_20cardano_serialization_lib__ScriptAny___serialize_as_embedded_group__h230bdd7ffa07f6dd($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 0 | 0, 2 | 0, 0 | 0);
  $4 = 1;
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__NativeScripts___serialize__hecc991a2909139b7($3 | 0, $1 | 0, $2 | 0);
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$2
     }
     HEAP32[($0 + 4 | 0) >> 2] = $2;
     $4 = 0;
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   $4 = 1;
  }
  HEAP32[$0 >> 2] = $4;
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__Certificate__as_move_instantaneous_rewards_cert__hf41f99e42b5f0eff($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, $3 = 0, $5 = 0, $5$hi = 0, $4 = 0, $23 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if ((HEAPU8[$1 >> 0] | 0 | 0) != (6 | 0)) {
     break label$2
    }
    $3 = $1 + 16 | 0;
    $4 = HEAPU8[($1 + 56 | 0) >> 0] | 0;
    i64toi32_i32$0 = 0;
    $5 = 1;
    $5$hi = i64toi32_i32$0;
    label$3 : {
     label$4 : {
      i64toi32_i32$2 = $1 + 8 | 0;
      i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
      i64toi32_i32$2 = i64toi32_i32$0;
      i64toi32_i32$0 = 0;
      i64toi32_i32$3 = 1;
      if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
       break label$4
      }
      i64toi32_i32$3 = $3;
      i64toi32_i32$2 = HEAP32[i64toi32_i32$3 >> 2] | 0;
      i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] | 0;
      $23 = i64toi32_i32$2;
      i64toi32_i32$2 = $2;
      HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $23;
      HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$1;
      i64toi32_i32$1 = 0;
      $5 = 0;
      $5$hi = i64toi32_i32$1;
      break label$3;
     }
     $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h7490700a7eed2994($2 + 8 | 0 | 0, $3 | 0);
    }
    i64toi32_i32$1 = $5$hi;
    i64toi32_i32$2 = $2;
    HEAP32[i64toi32_i32$2 >> 2] = $5;
    HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
    (wasm2js_i32$0 = (memcpy($0 | 0, i64toi32_i32$2 | 0, 48 | 0) | 0) + 48 | 0, wasm2js_i32$1 = $4), HEAP8[wasm2js_i32$0 >> 0] = wasm2js_i32$1;
    break label$1;
   }
   i64toi32_i32$2 = $0;
   i64toi32_i32$1 = 0;
   HEAP32[i64toi32_i32$2 >> 2] = 2;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
  }
  global$0 = $2 + 48 | 0;
 }
 
 function $cardano_serialization_lib__Ipv6_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h206d9a425c1d3d2e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $2 = 0, $10 = 0, $11 = 0, $17 = 0, $26 = 0, $29 = 0, $34 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h52c8cf155a794094($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $17 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 8 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $17;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(($2 + 8 | 0) + 16 | 0) >> 2] = HEAP32[($1 + 16 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $26 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $26;
  HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] | 0;
  $29 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  $10 = $29;
  HEAP8[i64toi32_i32$0 >> 0] = $10;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 20 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $34 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 8 | 0;
  $11 = $34;
  HEAP8[i64toi32_i32$1 >> 0] = $11;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 20 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function $cardano_serialization_lib__SingleHostName_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h59b8927a0bd593b1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $2 = 0, $17 = 0, $26 = 0, $29 = 0, $34 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h4b2375a8f3b1678d($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $17 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 8 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $17;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(($2 + 8 | 0) + 16 | 0) >> 2] = HEAP32[($1 + 16 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $26 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $26;
  HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] | 0;
  $29 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $29;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2 + 20 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $34 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $34;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 20 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function $cardano_serialization_lib__ScriptNOfK_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h805aa8e4c47b1131($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $2 = 0, $17 = 0, $26 = 0, $29 = 0, $34 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h122253d178bb0a3d($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $17 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 8 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $17;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(($2 + 8 | 0) + 16 | 0) >> 2] = HEAP32[($1 + 16 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $26 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $26;
  HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] | 0;
  $29 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $29;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2 + 20 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $34 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $34;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 20 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function $cardano_serialization_lib__utils__TransactionUnspentOutput_20as_20cbor_event__se__Serialize___serialize__h991f225e7eae04ba($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, 2 | 0, 0 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__TransactionInput___serialize__h2e92835f336b9490($3 | 0, $1 + 128 | 0 | 0, $2 | 0);
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$2
     }
     cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__TransactionOutput___serialize__h958522c662d822ef($0 | 0, $1 | 0, $2 | 0);
     break label$1;
    }
    memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
    HEAP32[$0 >> 2] = 1;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $3 + 48 | 0;
 }
 
 function $cardano_serialization_lib__utils__BigInt_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h357e7bbb28b1e3e1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $2 = 0, $17 = 0, $26 = 0, $29 = 0, $34 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__ha58eebd50d56cad2($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $17 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 8 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $17;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(($2 + 8 | 0) + 16 | 0) >> 2] = HEAP32[($1 + 16 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $26 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $26;
  HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] | 0;
  $29 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $29;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2 + 20 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $34 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $34;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 20 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function cardano_serialization_lib__metadata__bytes_to_hex_string__hd72671f689198069($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $25 = 0;
  $3 = global$0 - 64 | 0;
  global$0 = $3;
  HEAP32[($3 + 20 | 0) >> 2] = $2;
  HEAP32[($3 + 16 | 0) >> 2] = $1;
  $T_20as_20hex__ToHex___encode_hex__h20f23e9f96075940($3 + 48 | 0 | 0, $3 + 16 | 0 | 0);
  core__fmt__ArgumentV1__new__h56a0e5bff2bd9085($3 + 8 | 0 | 0, $3 + 48 | 0 | 0, 62 | 0);
  HEAP32[($3 + 36 | 0) >> 2] = 1;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  HEAP32[($3 + 20 | 0) >> 2] = 1;
  HEAP32[($3 + 24 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($3 + 16 | 0) >> 2] = 1059304;
  i64toi32_i32$0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
  $25 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[($3 + 40 | 0) >> 2] = $25;
  HEAP32[($3 + 44 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($3 + 32 | 0) >> 2] = $3 + 40 | 0;
  alloc__fmt__format__h6e9e003a52c07309($0 | 0, $3 + 16 | 0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 + 48 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 + 48 | 0 | 0);
  global$0 = $3 + 64 | 0;
 }
 
 function core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__tx_builder__tx_inputs_builder__ScriptWitnessType____h04ba3cf23b50ffc0($0) {
  $0 = $0 | 0;
  var i64toi32_i32$0 = 0, $1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $2 = 0, $2$hi = 0;
  label$1 : {
   i64toi32_i32$2 = $0;
   i64toi32_i32$0 = HEAP32[$0 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   $2 = i64toi32_i32$0;
   $2$hi = i64toi32_i32$1;
   i64toi32_i32$2 = i64toi32_i32$0;
   i64toi32_i32$0 = 0;
   if (i64toi32_i32$1 >>> 0 > i64toi32_i32$0 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$2 >>> 0 > 2 >>> 0 | 0) | 0) {
    break label$1
   }
   label$2 : {
    label$3 : {
     label$4 : {
      i64toi32_i32$2 = $2$hi;
      switch ($2 | 0) {
      case 1:
       break label$1;
      case 2:
       break label$3;
      default:
       break label$4;
      };
     }
     $1 = $0 + 8 | 0;
     label$5 : {
      switch ((HEAPU8[($0 + 8 | 0) >> 0] | 0) + -1 | 0 | 0) {
      case 0:
       $0 = $1 + 4 | 0;
       $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc3d6ec99c05cee40($0 | 0);
       $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h0f78886c344617d4($0 | 0);
       return;
      case 2:
       break label$2;
      case 1:
       break label$5;
      default:
       break label$3;
      };
     }
     $0 = $1 + 4 | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc3d6ec99c05cee40($0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h0f78886c344617d4($0 | 0);
    }
    return;
   }
   $0 = $0 + 16 | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc3d6ec99c05cee40($0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h0f78886c344617d4($0 | 0);
   return;
  }
  $1 = $0 + 136 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  core__ptr__drop_in_place_cardano_serialization_lib__plutus__PlutusData___hfab843e66e0f9428($0 + 8 | 0 | 0);
  core__ptr__drop_in_place_cardano_serialization_lib__plutus__PlutusData___hfab843e66e0f9428($0 + 64 | 0 | 0);
 }
 
 function transactionbuilder_get_deposit($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 32 | 0;
  global$0 = $1;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h37dfbd2f31d951c1($1 + 8 | 0 | 0, $0 | 0);
    $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    cardano_serialization_lib__utils__internal_get_deposit__h544d8f4f3a980a59($1 + 16 | 0 | 0, $2 + 428 | 0 | 0, $2 + 16 | 0 | 0, $2 + 24 | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    if ((HEAP32[($1 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    i64toi32_i32$2 = $1 + 24 | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810(HEAP32[i64toi32_i32$2 >> 2] | 0 | 0, i64toi32_i32$1 | 0) | 0;
    global$0 = $1 + 32 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($1 + 20 | 0) >> 2] | 0 | 0);
  abort();
 }
 
 function core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9_1($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   if (!(HEAP32[($0 + 48 | 0) >> 2] | 0)) {
    break label$1
   }
   $1 = $0 + 48 | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  }
  label$2 : {
   label$3 : {
    switch ((HEAPU8[$0 >> 0] | 0) + -2 | 0 | 0) {
    case 0:
     core__ptr__drop_in_place_cbor_event__error__Error___hbf0141ec70b68c45_2($0 + 8 | 0 | 0);
     return;
    case 2:
     core__ptr__drop_in_place_cardano_serialization_lib__error__Key___h6509e27f4cf6a188_2($0 + 8 | 0 | 0);
     return;
    case 6:
     core__ptr__drop_in_place_cardano_serialization_lib__error__Key___h6509e27f4cf6a188_2($0 + 8 | 0 | 0);
     core__ptr__drop_in_place_cardano_serialization_lib__error__Key___h6509e27f4cf6a188_2($0 + 24 | 0 | 0);
     return;
    case 7:
     core__ptr__drop_in_place_cardano_serialization_lib__error__Key___h6509e27f4cf6a188_2($0 + 8 | 0 | 0);
     return;
    case 8:
     $0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
     if ($0 >>> 0 < 36 >>> 0) {
      break label$2
     }
     wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($0 | 0);
     return;
    case 14:
     break label$3;
    default:
     break label$2;
    };
   }
   core__ptr__drop_in_place_cardano_serialization_lib__error__Key___h6509e27f4cf6a188_2($0 + 8 | 0 | 0);
  }
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend_T_2cI____spec_extend__hbaad8954f24f14f7($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, $3 = 0, $4 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$4 = 0, $5 = 0, i64toi32_i32$3 = 0, $12 = 0, $35 = 0;
  label$1 : {
   $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   $4 = ($2 - $1 | 0) >>> 2 | 0;
   if (((HEAP32[($0 + 4 | 0) >> 2] | 0) - $3 | 0) >>> 0 >= $4 >>> 0) {
    break label$1
   }
   alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h3bf5a6cd2f3fdf29($0 | 0, $3 | 0, $4 | 0);
   $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  }
  label$2 : {
   if (($1 | 0) == ($2 | 0)) {
    break label$2
   }
   $4 = (HEAP32[$0 >> 2] | 0) + ($3 << 4 | 0) | 0;
   label$3 : while (1) {
    i64toi32_i32$2 = $1;
    i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
    i64toi32_i32$1 = i64toi32_i32$0 >> 31 | 0;
    $5 = i64toi32_i32$0;
    i64toi32_i32$0 = $4;
    HEAP32[i64toi32_i32$0 >> 2] = $5;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    $35 = i64toi32_i32$0;
    i64toi32_i32$2 = $5;
    i64toi32_i32$0 = 0;
    i64toi32_i32$3 = 63;
    i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$0 = i64toi32_i32$1 >> 31 | 0;
     $12 = i64toi32_i32$1 >> i64toi32_i32$4 | 0;
    } else {
     i64toi32_i32$0 = i64toi32_i32$1 >> i64toi32_i32$4 | 0;
     $12 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
    }
    i64toi32_i32$2 = $35;
    HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $12;
    HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$0;
    $3 = $3 + 1 | 0;
    $4 = $4 + 16 | 0;
    $1 = $1 + 4 | 0;
    if (($2 | 0) != ($1 | 0)) {
     continue label$3
    }
    break label$3;
   };
  }
  HEAP32[($0 + 8 | 0) >> 2] = $3;
 }
 
 function core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9_2($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   if (!(HEAP32[($0 + 48 | 0) >> 2] | 0)) {
    break label$1
   }
   $1 = $0 + 48 | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  }
  label$2 : {
   label$3 : {
    switch ((HEAPU8[$0 >> 0] | 0) + -2 | 0 | 0) {
    case 0:
     core__ptr__drop_in_place_cbor_event__error__Error___hbf0141ec70b68c45($0 + 8 | 0 | 0);
     return;
    case 2:
     core__ptr__drop_in_place_cardano_serialization_lib__error__Key___h6509e27f4cf6a188_3($0 + 8 | 0 | 0);
     return;
    case 6:
     core__ptr__drop_in_place_cardano_serialization_lib__error__Key___h6509e27f4cf6a188_3($0 + 8 | 0 | 0);
     core__ptr__drop_in_place_cardano_serialization_lib__error__Key___h6509e27f4cf6a188_3($0 + 24 | 0 | 0);
     return;
    case 7:
     core__ptr__drop_in_place_cardano_serialization_lib__error__Key___h6509e27f4cf6a188_3($0 + 8 | 0 | 0);
     return;
    case 8:
     $0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
     if ($0 >>> 0 < 36 >>> 0) {
      break label$2
     }
     wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($0 | 0);
     return;
    case 14:
     break label$3;
    default:
     break label$2;
    };
   }
   core__ptr__drop_in_place_cardano_serialization_lib__error__Key___h6509e27f4cf6a188_3($0 + 8 | 0 | 0);
  }
 }
 
 function core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9_3($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   if (!(HEAP32[($0 + 48 | 0) >> 2] | 0)) {
    break label$1
   }
   $1 = $0 + 48 | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  }
  label$2 : {
   label$3 : {
    switch ((HEAPU8[$0 >> 0] | 0) + -2 | 0 | 0) {
    case 0:
     core__ptr__drop_in_place_cbor_event__error__Error___hbf0141ec70b68c45_6($0 + 8 | 0 | 0);
     return;
    case 2:
     core__ptr__drop_in_place_cardano_serialization_lib__error__Key___h6509e27f4cf6a188_4($0 + 8 | 0 | 0);
     return;
    case 6:
     core__ptr__drop_in_place_cardano_serialization_lib__error__Key___h6509e27f4cf6a188_4($0 + 8 | 0 | 0);
     core__ptr__drop_in_place_cardano_serialization_lib__error__Key___h6509e27f4cf6a188_4($0 + 24 | 0 | 0);
     return;
    case 7:
     core__ptr__drop_in_place_cardano_serialization_lib__error__Key___h6509e27f4cf6a188_4($0 + 8 | 0 | 0);
     return;
    case 8:
     $0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
     if ($0 >>> 0 < 36 >>> 0) {
      break label$2
     }
     wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($0 | 0);
     return;
    case 14:
     break label$3;
    default:
     break label$2;
    };
   }
   core__ptr__drop_in_place_cardano_serialization_lib__error__Key___h6509e27f4cf6a188_4($0 + 8 | 0 | 0);
  }
 }
 
 function $cardano_serialization_lib__plutus__PlutusList_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h152fda99fe0d4350($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $2 = 0, $17 = 0, $26 = 0, $29 = 0, $34 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__ha76caa55a13a9b32($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $17 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 8 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $17;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(($2 + 8 | 0) + 16 | 0) >> 2] = HEAP32[($1 + 16 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $26 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $26;
  HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] | 0;
  $29 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $29;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2 + 20 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $34 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $34;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 20 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function cbor_event__se__Serializer_W___write_text__hcb04c0164b9d6627($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, i64toi32_i32$0 = 0;
  $3 = global$0 - 64 | 0;
  global$0 = $3;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0);
  $2 = HEAP32[($3 + 8 | 0) >> 2] | 0;
  $4 = HEAP32[($3 + 12 | 0) >> 2] | 0;
  i64toi32_i32$0 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 + 16 | 0 | 0, $1 | 0, 3 | 0, $4 | 0, i64toi32_i32$0 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($3 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[($3 + 20 | 0) >> 2] | 0;
    alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($1 | 0, $2 | 0, $4 | 0);
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    $1 = 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, ($3 + 16 | 0) + 8 | 0 | 0, 40 | 0) | 0;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $3 + 64 | 0;
 }
 
 function cbor_event__se__Serializer_W___write_bytes__h94a35e08d7a7d3b8($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, i64toi32_i32$0 = 0;
  $3 = global$0 - 64 | 0;
  global$0 = $3;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0);
  $2 = HEAP32[($3 + 8 | 0) >> 2] | 0;
  $4 = HEAP32[($3 + 12 | 0) >> 2] | 0;
  i64toi32_i32$0 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 + 16 | 0 | 0, $1 | 0, 2 | 0, $4 | 0, i64toi32_i32$0 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($3 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[($3 + 20 | 0) >> 2] | 0;
    alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($1 | 0, $2 | 0, $4 | 0);
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    $1 = 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, ($3 + 16 | 0) + 8 | 0 | 0, 40 | 0) | 0;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $3 + 64 | 0;
 }
 
 function $cardano_serialization_lib__legacy_address__address__Addr_20as_20core__fmt__Display___fmt__ha492d7f37bd81963($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $24 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $0 | 0);
  cardano_serialization_lib__legacy_address__base58__encode__h4779b5c745dedf73($2 + 48 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  core__fmt__ArgumentV1__new__h56a0e5bff2bd9085($2 | 0, $2 + 48 | 0 | 0, 148 | 0);
  HEAP32[($2 + 36 | 0) >> 2] = 1;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 20 | 0) >> 2] = 1;
  HEAP32[($2 + 24 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 16 | 0) >> 2] = 1072696;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 40 | 0) >> 2] = $24;
  HEAP32[($2 + 44 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($2 + 32 | 0) >> 2] = $2 + 40 | 0;
  $1 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 16 | 0 | 0) | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 48 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 48 | 0 | 0);
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function rand__rngs__adapter__reseeding__ReseedingCore_R_2cRsdr___reseed_and_generate__h54ecaa5e8d7f0526($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, $3 = 0, $6 = 0, $5 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$5 = 0, i64toi32_i32$3 = 0, $4 = 0, $7 = 0, $42$hi = 0, $45$hi = 0, $46 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  $rand_chacha__chacha__Array64_T__20as_20core__convert__AsRef__5bT_5d____as_ref__h92537188a965f192($3 + 8 | 0 | 0, $1 | 0);
  $4 = HEAP32[($3 + 12 | 0) >> 2] | 0;
  rand__rngs__adapter__reseeding__ReseedingCore_R_2cRsdr___reseed__h63283490f2a6b10f($3 | 0, $0 | 0);
  label$1 : {
   $5 = HEAP32[$3 >> 2] | 0;
   if (!$5) {
    break label$1
   }
   $6 = HEAP32[($3 + 4 | 0) >> 2] | 0;
   FUNCTION_TABLE[HEAP32[$6 >> 2] | 0 | 0]($5);
   $7 = HEAP32[($6 + 8 | 0) >> 2] | 0;
   $6 = HEAP32[($6 + 4 | 0) >> 2] | 0;
   $5 = $T_20as_20core__convert__Into_U____into__h6ba7948e905b65a3($5 | 0) | 0;
   if (!$6) {
    break label$1
   }
   __rust_dealloc($5 | 0, $6 | 0, $7 | 0);
  }
  HEAP32[($0 + 64 | 0) >> 2] = $2;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 48 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 52 | 0) >> 2] | 0;
  $42$hi = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  $45$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $42$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = $45$hi;
  i64toi32_i32$3 = $4 << 2 | 0;
  i64toi32_i32$5 = (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) + i64toi32_i32$0 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 - i64toi32_i32$5 | 0;
  $46 = i64toi32_i32$2 - i64toi32_i32$3 | 0;
  i64toi32_i32$2 = $0;
  HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] = $46;
  HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] = i64toi32_i32$5;
  $rand_chacha__chacha__ChaCha12Core_20as_20rand_core__block__BlockRngCore___generate__h177e060232a47155(i64toi32_i32$2 | 0, $1 | 0);
  global$0 = $3 + 16 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___shrink__h4ebe6754097b6904($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $6 = 0, $4 = 0, $5 = 0;
  label$1 : {
   $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   if ($3 >>> 0 < $2 >>> 0) {
    break label$1
   }
   $4 = 0;
   label$2 : {
    if (!$3) {
     break label$2
    }
    $5 = HEAP32[$1 >> 2] | 0;
    label$3 : {
     label$4 : {
      label$5 : {
       if ($2) {
        break label$5
       }
       $6 = 1;
       __rust_dealloc($5 | 0, $3 | 0, 1 | 0);
       break label$4;
      }
      $6 = __rust_realloc($5 | 0, $3 | 0, 1 | 0, $2 | 0) | 0;
      if (!$6) {
       break label$3
      }
     }
     HEAP32[($1 + 4 | 0) >> 2] = $2;
     HEAP32[$1 >> 2] = $6;
     break label$2;
    }
    $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
    HEAP32[($0 + 4 | 0) >> 2] = $2;
    HEAP32[($0 + 8 | 0) >> 2] = 1;
    $4 = 1;
   }
   HEAP32[$0 >> 2] = $4;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1089044 | 0, 36 | 0, 1089080 | 0);
  abort();
 }
 
 function cryptoxide__cryptoutil__write_u64v_le__h74de04db912254e4($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $10 = 0, $11 = 0, $12 = 0, i64toi32_i32$0 = 0, $5 = 0, i64toi32_i32$2 = 0, $4 = 0, i64toi32_i32$1 = 0, $27 = 0;
  label$1 : {
   if (($3 << 3 | 0 | 0) != ($1 | 0)) {
    break label$1
   }
   label$2 : {
    label$3 : {
     label$4 : {
      if (!$3) {
       break label$4
      }
      $4 = $3 << 3 | 0;
      $3 = 0;
      label$5 : while (1) {
       if (($3 | 0) == (-8 | 0)) {
        break label$3
       }
       $5 = $3 + 8 | 0;
       if ($5 >>> 0 > $1 >>> 0) {
        break label$2
       }
       i64toi32_i32$2 = $2 + $3 | 0;
       i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
       i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
       $27 = i64toi32_i32$0;
       i64toi32_i32$0 = $0 + $3 | 0;
       $10 = i64toi32_i32$0;
       $11 = $27;
       HEAP8[$10 >> 0] = $11;
       HEAP8[($10 + 1 | 0) >> 0] = $11 >>> 8 | 0;
       HEAP8[($10 + 2 | 0) >> 0] = $11 >>> 16 | 0;
       HEAP8[($10 + 3 | 0) >> 0] = $11 >>> 24 | 0;
       $12 = i64toi32_i32$1;
       HEAP8[($10 + 4 | 0) >> 0] = $12;
       HEAP8[($10 + 5 | 0) >> 0] = $12 >>> 8 | 0;
       HEAP8[($10 + 6 | 0) >> 0] = $12 >>> 16 | 0;
       HEAP8[($10 + 7 | 0) >> 0] = $12 >>> 24 | 0;
       $3 = $5;
       if (($4 | 0) != ($3 | 0)) {
        continue label$5
       }
       break label$5;
      };
     }
     return;
    }
    core__slice__index__slice_index_order_fail__h71e247dec3f266ff(-8 | 0, 0 | 0, 1102928 | 0);
    abort();
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($3 + 8 | 0 | 0, $1 | 0, 1102928 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1102880 | 0, 47 | 0, 1102928 | 0);
  abort();
 }
 
 function cryptoxide__cryptoutil__write_u32v_le__h0de82ea513fa1e39($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $6 = 0, $7 = 0, $5 = 0, $4 = 0;
  label$1 : {
   if (($3 << 2 | 0 | 0) != ($1 | 0)) {
    break label$1
   }
   label$2 : {
    label$3 : {
     label$4 : {
      if (!$3) {
       break label$4
      }
      $4 = $3 << 2 | 0;
      $3 = 0;
      label$5 : while (1) {
       if (($3 | 0) == (-4 | 0)) {
        break label$3
       }
       $5 = $3 + 4 | 0;
       if ($5 >>> 0 > $1 >>> 0) {
        break label$2
       }
       $6 = $0 + $3 | 0;
       $7 = HEAP32[($2 + $3 | 0) >> 2] | 0;
       HEAP8[$6 >> 0] = $7;
       HEAP8[($6 + 1 | 0) >> 0] = $7 >>> 8 | 0;
       HEAP8[($6 + 2 | 0) >> 0] = $7 >>> 16 | 0;
       HEAP8[($6 + 3 | 0) >> 0] = $7 >>> 24 | 0;
       $3 = $5;
       if (($4 | 0) != ($3 | 0)) {
        continue label$5
       }
       break label$5;
      };
     }
     return;
    }
    core__slice__index__slice_index_order_fail__h71e247dec3f266ff(-4 | 0, 0 | 0, 1102960 | 0);
    abort();
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($3 + 4 | 0 | 0, $1 | 0, 1102960 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1102880 | 0, 47 | 0, 1102960 | 0);
  abort();
 }
 
 function cryptoxide__hashing__blake2b__Context_____finalize_reset_at__h171ca629c0dfd129($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $9 = 0, $10 = 0, $11 = 0, $12 = 0, $13 = 0, $14 = 0, $15 = 0, $20 = 0, $23 = 0;
  label$1 : {
   if (($2 | 0) != (28 | 0)) {
    break label$1
   }
   cryptoxide__hashing__blake2b__Context_____internal_final__h9e3075aeb620108a($0 | 0);
   $9 = $0 + 124 | 0;
   $10 = $1 + 24 | 0;
   $11 = HEAPU8[$9 >> 0] | 0 | ((HEAPU8[($9 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($9 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($9 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   HEAP8[$10 >> 0] = $11;
   HEAP8[($10 + 1 | 0) >> 0] = $11 >>> 8 | 0;
   HEAP8[($10 + 2 | 0) >> 0] = $11 >>> 16 | 0;
   HEAP8[($10 + 3 | 0) >> 0] = $11 >>> 24 | 0;
   i64toi32_i32$2 = $0 + 116 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $15 = i64toi32_i32$0;
   i64toi32_i32$0 = $1 + 16 | 0;
   $12 = $15;
   HEAP8[i64toi32_i32$0 >> 0] = $12;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $12 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $12 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $12 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = $0 + 108 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $20 = i64toi32_i32$1;
   i64toi32_i32$1 = $1 + 8 | 0;
   $13 = $20;
   HEAP8[i64toi32_i32$1 >> 0] = $13;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $13 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $13 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $13 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 100 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 101 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 102 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 103 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 104 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 105 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 106 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 107 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $23 = i64toi32_i32$0;
   i64toi32_i32$0 = $1;
   $14 = $23;
   HEAP8[i64toi32_i32$0 >> 0] = $14;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $14 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $14 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $14 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   $0 = memcpy(i64toi32_i32$2 | 0, 1137368 | 0, 64 | 0) | 0;
   i64toi32_i32$0 = $0;
   i64toi32_i32$1 = 0;
   HEAP32[(i64toi32_i32$0 + 64 | 0) >> 2] = 0;
   HEAP32[(i64toi32_i32$0 + 68 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = 1779033703;
   HEAP32[i64toi32_i32$0 >> 2] = -222443244;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$0 = i64toi32_i32$0 + 72 | 0;
   i64toi32_i32$1 = 0;
   HEAP32[i64toi32_i32$0 >> 2] = 0;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   memset($0 + 96 | 0 | 0, 0 | 0, 132 | 0) | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1136192 | 0, 47 | 0, 1136240 | 0);
  abort();
 }
 
 function cryptoxide__hashing__blake2b__Context_____finalize_reset_at__hc67bf5d72cbf260d($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $11 = 0, $12 = 0, $13 = 0, $14 = 0, $10 = 0, $15 = 0, $20 = 0, $23 = 0;
  label$1 : {
   if (($2 | 0) != (32 | 0)) {
    break label$1
   }
   cryptoxide__hashing__blake2b__Context_____internal_final__hc238b331d1e0298a($0 | 0);
   i64toi32_i32$2 = $0 + 124 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $10 = i64toi32_i32$0;
   i64toi32_i32$0 = $1 + 24 | 0;
   $11 = $10;
   HEAP8[i64toi32_i32$0 >> 0] = $11;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = $0 + 116 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $15 = i64toi32_i32$1;
   i64toi32_i32$1 = $1 + 16 | 0;
   $12 = $15;
   HEAP8[i64toi32_i32$1 >> 0] = $12;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $12 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $12 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $12 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $0 + 108 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $20 = i64toi32_i32$0;
   i64toi32_i32$0 = $1 + 8 | 0;
   $13 = $20;
   HEAP8[i64toi32_i32$0 >> 0] = $13;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $13 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $13 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $13 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = $0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 100 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 101 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 102 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 103 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 104 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 105 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 106 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 107 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $23 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   $14 = $23;
   HEAP8[i64toi32_i32$1 >> 0] = $14;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $14 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $14 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $14 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   $0 = memcpy(i64toi32_i32$2 | 0, 1137368 | 0, 64 | 0) | 0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] = 0;
   HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = 1779033703;
   HEAP32[i64toi32_i32$1 >> 2] = -222443224;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$1 = i64toi32_i32$1 + 72 | 0;
   i64toi32_i32$0 = 0;
   HEAP32[i64toi32_i32$1 >> 2] = 0;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   memset($0 + 96 | 0 | 0, 0 | 0, 132 | 0) | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1136192 | 0, 47 | 0, 1136240 | 0);
  abort();
 }
 
 function cryptoxide__hashing__sha3__Engine___2c____finalize__set_pad__h666a8e2c29f8bcb6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $3 = 0, $2 = 0;
  label$1 : {
   if (!$1) {
    break label$1
   }
   $2 = HEAPU8[$0 >> 0] | 0 | 4 | 0;
   $3 = 3;
   label$2 : while (1) {
    $2 = $2 & (__wasm_rotl_i32(-2 | 0, $3 | 0) | 0) | 0;
    $3 = $3 + 1 | 0;
    if (($3 | 0) != (8 | 0)) {
     continue label$2
    }
    break label$2;
   };
   HEAP8[$0 >> 0] = $2;
   $3 = 0;
   label$3 : {
    if (($1 | 0) == (1 | 0)) {
     break label$3
    }
    $3 = $1 + -1 | 0;
    memset($0 + 1 | 0 | 0, 0 | 0, $3 | 0) | 0;
    $2 = HEAPU8[($0 + $3 | 0) >> 0] | 0;
   }
   HEAP8[($0 + $3 | 0) >> 0] = $2 | 128 | 0;
   return;
  }
  core__panicking__panic_bounds_check__h808b524af17640b1(0 | 0, 0 | 0, 1136972 | 0);
  abort();
 }
 
 function alloc__vec__Vec_T_2cA___extend_desugared__h4a95415290b3063b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $4 = 0, $3 = 0, $5 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $core__iter__adapters__ResultShunt_I_2cE__20as_20core__iter__traits__iterator__Iterator___try_fold__haf6fbe5f8305961d($2 + 8 | 0 | 0, $1 | 0);
  label$1 : {
   if (!((HEAPU8[($2 + 8 | 0) >> 0] | 0) & 1 | 0)) {
    break label$1
   }
   $3 = HEAPU8[($2 + 9 | 0) >> 0] | 0;
   $4 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   label$2 : while (1) {
    label$3 : {
     if (($4 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
      break label$3
     }
     alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hace6da240d5ba1ef($0 | 0, $4 | 0, 1 | 0);
    }
    $5 = $4 + 1 | 0;
    HEAP32[($0 + 8 | 0) >> 2] = $5;
    HEAP8[((HEAP32[$0 >> 2] | 0) + $4 | 0) >> 0] = $3;
    $core__iter__adapters__ResultShunt_I_2cE__20as_20core__iter__traits__iterator__Iterator___try_fold__haf6fbe5f8305961d($2 | 0, $1 | 0);
    $3 = HEAPU8[($2 + 1 | 0) >> 0] | 0;
    $4 = $5;
    if ((HEAPU8[$2 >> 0] | 0) & 1 | 0) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $2 + 16 | 0;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__h7e0917d2cb8c0358($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   switch (HEAPU8[(HEAP32[$0 >> 2] | 0) >> 0] | 0 | 0) {
   default:
    return FUNCTION_TABLE[HEAP32[((HEAP32[($1 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($1 + 24 | 0) >> 2] | 0, 1153122, 5) | 0 | 0;
   case 1:
    return FUNCTION_TABLE[HEAP32[((HEAP32[($1 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($1 + 24 | 0) >> 2] | 0, 1153218, 12) | 0 | 0;
   case 2:
    return FUNCTION_TABLE[HEAP32[((HEAP32[($1 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($1 + 24 | 0) >> 2] | 0, 1153207, 11) | 0 | 0;
   case 3:
    return FUNCTION_TABLE[HEAP32[((HEAP32[($1 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($1 + 24 | 0) >> 2] | 0, 1153196, 11) | 0 | 0;
   case 4:
    break label$1;
   };
  }
  return FUNCTION_TABLE[HEAP32[((HEAP32[($1 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($1 + 24 | 0) >> 2] | 0, 1153127, 4) | 0 | 0;
 }
 
 function alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal___push__h8e97906a7bbaaf79($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0;
  label$1 : {
   label$2 : {
    if (((HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) != ($3 | 0)) {
     break label$2
    }
    $0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    $3 = HEAPU16[($0 + 1062 | 0) >> 1] | 0;
    if ($3 >>> 0 <= 10 >>> 0) {
     break label$1
    }
    core__panicking__panic__h2fd385a887c8bf13(1048619 | 0, 32 | 0, 1048824 | 0);
    abort();
   }
   core__panicking__panic__h2fd385a887c8bf13(1048760 | 0, 48 | 0, 1048808 | 0);
   abort();
  }
  $5 = $3 + 1 | 0;
  HEAP16[($0 + 1062 | 0) >> 1] = $5;
  memcpy((memcpy($0 + Math_imul($3, 48) | 0 | 0, $1 | 0, 48 | 0) | 0) + 528 | 0 | 0, $2 | 0, 48 | 0) | 0;
  HEAP32[(($0 + ($5 << 2 | 0) | 0) + 1064 | 0) >> 2] = $4;
  HEAP16[($4 + 1060 | 0) >> 1] = $5;
  HEAP32[($4 + 1056 | 0) >> 2] = $0;
 }
 
 function $cardano_serialization_lib__StakeRegistration_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h1d642bd792942469($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $10 = 0, $11 = 0, $12 = 0, $13 = 0, $20 = 0, $25 = 0, $30 = 0, $33 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h504db7e111ee10e7($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 8 | 0 | 0, $1 | 0, 36 | 0) | 0;
  i64toi32_i32$2 = $2 + 33 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 21 | 0;
  $10 = $20;
  HEAP8[i64toi32_i32$0 >> 0] = $10;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 28 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $25 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 16 | 0;
  $11 = $25;
  HEAP8[i64toi32_i32$1 >> 0] = $11;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 20 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 8 | 0;
  $12 = $30;
  HEAP8[i64toi32_i32$0 >> 0] = $12;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  $33 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  $13 = $33;
  HEAP8[i64toi32_i32$1 >> 0] = $13;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 36 | 0, 4 | 0);
  global$0 = i64toi32_i32$2 + 48 | 0;
 }
 
 function $cardano_serialization_lib__StakeDeregistration_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h7390bf7641b86627($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $10 = 0, $11 = 0, $12 = 0, $13 = 0, $20 = 0, $25 = 0, $30 = 0, $33 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h0118f8f5f8658202($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 8 | 0 | 0, $1 | 0, 36 | 0) | 0;
  i64toi32_i32$2 = $2 + 33 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 21 | 0;
  $10 = $20;
  HEAP8[i64toi32_i32$0 >> 0] = $10;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 28 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $25 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 16 | 0;
  $11 = $25;
  HEAP8[i64toi32_i32$1 >> 0] = $11;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 20 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 8 | 0;
  $12 = $30;
  HEAP8[i64toi32_i32$0 >> 0] = $12;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  $33 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  $13 = $33;
  HEAP8[i64toi32_i32$1 >> 0] = $13;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 36 | 0, 4 | 0);
  global$0 = i64toi32_i32$2 + 48 | 0;
 }
 
 function $cardano_serialization_lib__PoolRetirement_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h16155183867eb2ad($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$2 = 0, $20 = 0, $25 = 0, $30 = 0, $33 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h524388c903ba8fc4($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 8 | 0 | 0, $1 | 0, 36 | 0) | 0;
  i64toi32_i32$2 = $2 + 36 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 24 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $20;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2 + 28 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $25 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $25;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2 + 20 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $30;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  $33 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $33;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 36 | 0, 4 | 0);
  global$0 = $2 + 48 | 0;
 }
 
 function $cardano_serialization_lib__metadata__TransactionMetadatumEnum_20as_20cbor_event__se__Serialize___serialize__h4285ca14e4462f47($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    switch (HEAP32[$1 >> 2] | 0 | 0) {
    default:
     $cardano_serialization_lib__metadata__MetadataMap_20as_20cbor_event__se__Serialize___serialize__h7bf88c8e5cef4c92($0 | 0, $1 + 8 | 0 | 0, $2 | 0);
     break label$1;
    case 1:
     $cardano_serialization_lib__metadata__MetadataList_20as_20cbor_event__se__Serialize___serialize__h338522090b280ca8($0 | 0, $1 + 4 | 0 | 0, $2 | 0);
     break label$1;
    case 2:
     $cardano_serialization_lib__utils__Int_20as_20cbor_event__se__Serialize___serialize__h52978cec14c40013($0 | 0, $1 + 8 | 0 | 0, $2 | 0);
     break label$1;
    case 3:
     HEAP32[($3 + 8 | 0) >> 2] = $1 + 4 | 0;
     cbor_event__se__Serializer_W___write_bytes__h94a35e08d7a7d3b8($0 | 0, $2 | 0, $3 + 8 | 0 | 0);
     break label$1;
    case 4:
     break label$2;
    };
   }
   HEAP32[($3 + 12 | 0) >> 2] = $1 + 4 | 0;
   cbor_event__se__Serializer_W___write_text__hcb04c0164b9d6627($0 | 0, $2 | 0, $3 + 12 | 0 | 0);
  }
  global$0 = $3 + 16 | 0;
 }
 
 function $cardano_serialization_lib__crypto__PublicKey_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h5170c950d068b816($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$2 = 0, $10 = 0, $11 = 0, $12 = 0, $13 = 0, $20 = 0, $25 = 0, $30 = 0, $33 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h678179fab295364a($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 8 | 0 | 0, $1 | 0, 36 | 0) | 0;
  i64toi32_i32$2 = $2 + 36 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 24 | 0;
  $10 = $20;
  HEAP8[i64toi32_i32$0 >> 0] = $10;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 28 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $25 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 16 | 0;
  $11 = $25;
  HEAP8[i64toi32_i32$1 >> 0] = $11;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 20 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 8 | 0;
  $12 = $30;
  HEAP8[i64toi32_i32$0 >> 0] = $12;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  $33 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  $13 = $33;
  HEAP8[i64toi32_i32$1 >> 0] = $13;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 36 | 0, 4 | 0);
  global$0 = $2 + 48 | 0;
 }
 
 function $cardano_serialization_lib__crypto__Vkey_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hdce46b231f1d8799($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$2 = 0, $10 = 0, $11 = 0, $12 = 0, $13 = 0, $20 = 0, $25 = 0, $30 = 0, $33 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h998daf6406896aba($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 8 | 0 | 0, $1 | 0, 36 | 0) | 0;
  i64toi32_i32$2 = $2 + 36 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 24 | 0;
  $10 = $20;
  HEAP8[i64toi32_i32$0 >> 0] = $10;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 28 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $25 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 16 | 0;
  $11 = $25;
  HEAP8[i64toi32_i32$1 >> 0] = $11;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 20 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 8 | 0;
  $12 = $30;
  HEAP8[i64toi32_i32$0 >> 0] = $12;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  $33 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  $13 = $33;
  HEAP8[i64toi32_i32$1 >> 0] = $13;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 36 | 0, 4 | 0);
  global$0 = $2 + 48 | 0;
 }
 
 function bootstrapwitness_attributes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $31 = 0, $37 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h76a11b605f70ebd5($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($2 + 16 | 0 | 0, (HEAP32[($2 + 8 | 0) >> 2] | 0) + 12 | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $31;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $37 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $37;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function $cardano_serialization_lib__crypto__TransactionHash_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h354802eb0ef8e301($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$2 = 0, $10 = 0, $11 = 0, $12 = 0, $13 = 0, $20 = 0, $25 = 0, $30 = 0, $33 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hb1904961fadb75a0($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 8 | 0 | 0, $1 | 0, 36 | 0) | 0;
  i64toi32_i32$2 = $2 + 36 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 24 | 0;
  $10 = $20;
  HEAP8[i64toi32_i32$0 >> 0] = $10;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 28 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $25 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 16 | 0;
  $11 = $25;
  HEAP8[i64toi32_i32$1 >> 0] = $11;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 20 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 8 | 0;
  $12 = $30;
  HEAP8[i64toi32_i32$0 >> 0] = $12;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  $33 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  $13 = $33;
  HEAP8[i64toi32_i32$1 >> 0] = $13;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 36 | 0, 4 | 0);
  global$0 = $2 + 48 | 0;
 }
 
 function $cardano_serialization_lib__crypto__AuxiliaryDataHash_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__ha0a8a46a2c186b22($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$2 = 0, $10 = 0, $11 = 0, $12 = 0, $13 = 0, $20 = 0, $25 = 0, $30 = 0, $33 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__he19d9eeea00abf77($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 8 | 0 | 0, $1 | 0, 36 | 0) | 0;
  i64toi32_i32$2 = $2 + 36 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 24 | 0;
  $10 = $20;
  HEAP8[i64toi32_i32$0 >> 0] = $10;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 28 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $25 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 16 | 0;
  $11 = $25;
  HEAP8[i64toi32_i32$1 >> 0] = $11;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 20 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 8 | 0;
  $12 = $30;
  HEAP8[i64toi32_i32$0 >> 0] = $12;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  $33 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  $13 = $33;
  HEAP8[i64toi32_i32$1 >> 0] = $13;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 36 | 0, 4 | 0);
  global$0 = $2 + 48 | 0;
 }
 
 function $cardano_serialization_lib__crypto__PoolMetadataHash_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h919da9d1bb69fb13($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$2 = 0, $10 = 0, $11 = 0, $12 = 0, $13 = 0, $20 = 0, $25 = 0, $30 = 0, $33 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h6c10e1bb84be99c5($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 8 | 0 | 0, $1 | 0, 36 | 0) | 0;
  i64toi32_i32$2 = $2 + 36 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 24 | 0;
  $10 = $20;
  HEAP8[i64toi32_i32$0 >> 0] = $10;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 28 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $25 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 16 | 0;
  $11 = $25;
  HEAP8[i64toi32_i32$1 >> 0] = $11;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 20 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 8 | 0;
  $12 = $30;
  HEAP8[i64toi32_i32$0 >> 0] = $12;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  $33 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  $13 = $33;
  HEAP8[i64toi32_i32$1 >> 0] = $13;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 36 | 0, 4 | 0);
  global$0 = $2 + 48 | 0;
 }
 
 function $cardano_serialization_lib__crypto__VRFKeyHash_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h8eb38b87246da9fe($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$2 = 0, $10 = 0, $11 = 0, $12 = 0, $13 = 0, $20 = 0, $25 = 0, $30 = 0, $33 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hd75e174e5b45254f($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 8 | 0 | 0, $1 | 0, 36 | 0) | 0;
  i64toi32_i32$2 = $2 + 36 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 24 | 0;
  $10 = $20;
  HEAP8[i64toi32_i32$0 >> 0] = $10;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 28 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $25 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 16 | 0;
  $11 = $25;
  HEAP8[i64toi32_i32$1 >> 0] = $11;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 20 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 8 | 0;
  $12 = $30;
  HEAP8[i64toi32_i32$0 >> 0] = $12;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  $33 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  $13 = $33;
  HEAP8[i64toi32_i32$1 >> 0] = $13;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 36 | 0, 4 | 0);
  global$0 = $2 + 48 | 0;
 }
 
 function $cardano_serialization_lib__crypto__BlockHash_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hb6c73b3486e647eb($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$2 = 0, $10 = 0, $11 = 0, $12 = 0, $13 = 0, $20 = 0, $25 = 0, $30 = 0, $33 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h407e866bc710507b($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 8 | 0 | 0, $1 | 0, 36 | 0) | 0;
  i64toi32_i32$2 = $2 + 36 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 24 | 0;
  $10 = $20;
  HEAP8[i64toi32_i32$0 >> 0] = $10;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 28 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $25 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 16 | 0;
  $11 = $25;
  HEAP8[i64toi32_i32$1 >> 0] = $11;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 20 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 8 | 0;
  $12 = $30;
  HEAP8[i64toi32_i32$0 >> 0] = $12;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  $33 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  $13 = $33;
  HEAP8[i64toi32_i32$1 >> 0] = $13;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 36 | 0, 4 | 0);
  global$0 = $2 + 48 | 0;
 }
 
 function $cardano_serialization_lib__crypto__DataHash_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h73047049c9205097($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$2 = 0, $10 = 0, $11 = 0, $12 = 0, $13 = 0, $20 = 0, $25 = 0, $30 = 0, $33 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h82db26eaf8d53cff($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 8 | 0 | 0, $1 | 0, 36 | 0) | 0;
  i64toi32_i32$2 = $2 + 36 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 24 | 0;
  $10 = $20;
  HEAP8[i64toi32_i32$0 >> 0] = $10;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 28 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $25 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 16 | 0;
  $11 = $25;
  HEAP8[i64toi32_i32$1 >> 0] = $11;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 20 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 8 | 0;
  $12 = $30;
  HEAP8[i64toi32_i32$0 >> 0] = $12;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  $33 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  $13 = $33;
  HEAP8[i64toi32_i32$1 >> 0] = $13;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 36 | 0, 4 | 0);
  global$0 = $2 + 48 | 0;
 }
 
 function $cardano_serialization_lib__crypto__ScriptDataHash_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hf6e21216d0c6c529($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$2 = 0, $10 = 0, $11 = 0, $12 = 0, $13 = 0, $20 = 0, $25 = 0, $30 = 0, $33 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h73abe51fb1a6aa1e($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 8 | 0 | 0, $1 | 0, 36 | 0) | 0;
  i64toi32_i32$2 = $2 + 36 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 24 | 0;
  $10 = $20;
  HEAP8[i64toi32_i32$0 >> 0] = $10;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 28 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $25 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 16 | 0;
  $11 = $25;
  HEAP8[i64toi32_i32$1 >> 0] = $11;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 20 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 8 | 0;
  $12 = $30;
  HEAP8[i64toi32_i32$0 >> 0] = $12;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  $33 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  $13 = $33;
  HEAP8[i64toi32_i32$1 >> 0] = $13;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 36 | 0, 4 | 0);
  global$0 = $2 + 48 | 0;
 }
 
 function $cardano_serialization_lib__crypto__VRFVKey_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hd1275b0a7c70790b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$2 = 0, $10 = 0, $11 = 0, $12 = 0, $13 = 0, $20 = 0, $25 = 0, $30 = 0, $33 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h57b86fe1cb305719($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 8 | 0 | 0, $1 | 0, 36 | 0) | 0;
  i64toi32_i32$2 = $2 + 36 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 24 | 0;
  $10 = $20;
  HEAP8[i64toi32_i32$0 >> 0] = $10;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 28 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $25 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 16 | 0;
  $11 = $25;
  HEAP8[i64toi32_i32$1 >> 0] = $11;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 20 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 8 | 0;
  $12 = $30;
  HEAP8[i64toi32_i32$0 >> 0] = $12;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  $33 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  $13 = $33;
  HEAP8[i64toi32_i32$1 >> 0] = $13;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 36 | 0, 4 | 0);
  global$0 = $2 + 48 | 0;
 }
 
 function $cardano_serialization_lib__crypto__KESVKey_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h2cd0f9edc6f9fec8($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$2 = 0, $10 = 0, $11 = 0, $12 = 0, $13 = 0, $20 = 0, $25 = 0, $30 = 0, $33 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h4d1a812098c80b71($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 8 | 0 | 0, $1 | 0, 36 | 0) | 0;
  i64toi32_i32$2 = $2 + 36 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 24 | 0;
  $10 = $20;
  HEAP8[i64toi32_i32$0 >> 0] = $10;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 28 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $25 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 16 | 0;
  $11 = $25;
  HEAP8[i64toi32_i32$1 >> 0] = $11;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 20 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 8 | 0;
  $12 = $30;
  HEAP8[i64toi32_i32$0 >> 0] = $12;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  $33 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  $13 = $33;
  HEAP8[i64toi32_i32$1 >> 0] = $13;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 36 | 0, 4 | 0);
  global$0 = $2 + 48 | 0;
 }
 
 function vrfcert_proof($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $31 = 0, $37 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h1a6acf099b73960c($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($2 + 16 | 0 | 0, (HEAP32[($2 + 8 | 0) >> 2] | 0) + 12 | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $31 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $31;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $37 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $37;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___remove__h0ff09e7bc29e7fcf($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, i64toi32_i32$2 = 0, $4 = 0, $4$hi = 0, $5 = 0, $19 = 0, $5$hi = 0, $29 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  alloc__collections__btree__map__BTreeMap_K_2cV___remove_entry__h0ced826aed6ac5e1($3 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    if (HEAP32[$3 >> 2] | 0) {
     break label$2
    }
    i64toi32_i32$0 = 0;
    $4 = 0;
    $4$hi = i64toi32_i32$0;
    break label$1;
   }
   i64toi32_i32$2 = $3 + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $19 = i64toi32_i32$0;
   i64toi32_i32$0 = ($3 + 24 | 0) + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $19;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $3 + 16 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $5 = i64toi32_i32$1;
   $5$hi = i64toi32_i32$0;
   i64toi32_i32$1 = ($3 + 24 | 0) + 16 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $5;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $3;
   i64toi32_i32$0 = HEAP32[$3 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($3 + 4 | 0) >> 2] | 0;
   $29 = i64toi32_i32$0;
   i64toi32_i32$0 = $3;
   HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = $29;
   HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = i64toi32_i32$1;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7(i64toi32_i32$0 + 24 | 0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2(i64toi32_i32$0 + 24 | 0 | 0);
   i64toi32_i32$1 = 0;
   $4 = 1;
   $4$hi = i64toi32_i32$1;
  }
  i64toi32_i32$1 = $5$hi;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $5;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $4$hi;
  HEAP32[i64toi32_i32$0 >> 2] = $4;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $3 + 48 | 0;
 }
 
 function $cardano_serialization_lib__address__StakeCredential_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h79ea81cd54feaf34($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $10 = 0, $11 = 0, $12 = 0, $13 = 0, $20 = 0, $25 = 0, $30 = 0, $33 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hb627015b59398c63($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 8 | 0 | 0, $1 | 0, 36 | 0) | 0;
  i64toi32_i32$2 = $2 + 33 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 21 | 0;
  $10 = $20;
  HEAP8[i64toi32_i32$0 >> 0] = $10;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 28 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $25 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 16 | 0;
  $11 = $25;
  HEAP8[i64toi32_i32$1 >> 0] = $11;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 20 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 8 | 0;
  $12 = $30;
  HEAP8[i64toi32_i32$0 >> 0] = $12;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  $33 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  $13 = $33;
  HEAP8[i64toi32_i32$1 >> 0] = $13;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 36 | 0, 4 | 0);
  global$0 = i64toi32_i32$2 + 48 | 0;
 }
 
 function $cardano_serialization_lib__address__EnterpriseAddress_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h54e74b049e3119f0($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $10 = 0, $11 = 0, $12 = 0, $13 = 0, $20 = 0, $25 = 0, $30 = 0, $33 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h3e58b4ea37ee3a12($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 8 | 0 | 0, $1 | 0, 36 | 0) | 0;
  i64toi32_i32$2 = $2 + 34 | 0;
  i64toi32_i32$0 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
  i64toi32_i32$1 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 22 | 0;
  $10 = $20;
  HEAP8[i64toi32_i32$0 >> 0] = $10;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 28 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $25 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 16 | 0;
  $11 = $25;
  HEAP8[i64toi32_i32$1 >> 0] = $11;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 20 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 8 | 0;
  $12 = $30;
  HEAP8[i64toi32_i32$0 >> 0] = $12;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  $33 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  $13 = $33;
  HEAP8[i64toi32_i32$1 >> 0] = $13;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 36 | 0, 4 | 0);
  global$0 = i64toi32_i32$2 + 48 | 0;
 }
 
 function $cardano_serialization_lib__address__RewardAddress_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__ha40e942e667fb45c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $10 = 0, $11 = 0, $12 = 0, $13 = 0, $20 = 0, $25 = 0, $30 = 0, $33 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hf1389f409abb520e($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 8 | 0 | 0, $1 | 0, 36 | 0) | 0;
  i64toi32_i32$2 = $2 + 34 | 0;
  i64toi32_i32$0 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
  i64toi32_i32$1 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 22 | 0;
  $10 = $20;
  HEAP8[i64toi32_i32$0 >> 0] = $10;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 28 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $25 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 16 | 0;
  $11 = $25;
  HEAP8[i64toi32_i32$1 >> 0] = $11;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 20 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 8 | 0;
  $12 = $30;
  HEAP8[i64toi32_i32$0 >> 0] = $12;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  $33 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  $13 = $33;
  HEAP8[i64toi32_i32$1 >> 0] = $13;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 36 | 0, 4 | 0);
  global$0 = i64toi32_i32$2 + 48 | 0;
 }
 
 function cbor_event__se__Serializer_W___write_text__hb80b098c4abeea7e($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, i64toi32_i32$0 = 0;
  $3 = global$0 - 64 | 0;
  global$0 = $3;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $2 | 0);
  $2 = HEAP32[($3 + 8 | 0) >> 2] | 0;
  $4 = HEAP32[($3 + 12 | 0) >> 2] | 0;
  i64toi32_i32$0 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 + 16 | 0 | 0, $1 | 0, 3 | 0, $4 | 0, i64toi32_i32$0 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($3 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[($3 + 20 | 0) >> 2] | 0;
    alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($1 | 0, $2 | 0, $4 | 0);
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    $1 = 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, ($3 + 16 | 0) + 8 | 0 | 0, 40 | 0) | 0;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $3 + 64 | 0;
 }
 
 function cbor_event__se__Serializer_W___write_bytes__hdbf95a6224c8b5b8($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, i64toi32_i32$0 = 0;
  $3 = global$0 - 64 | 0;
  global$0 = $3;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $2 | 0);
  $2 = HEAP32[($3 + 8 | 0) >> 2] | 0;
  $4 = HEAP32[($3 + 12 | 0) >> 2] | 0;
  i64toi32_i32$0 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 + 16 | 0 | 0, $1 | 0, 2 | 0, $4 | 0, i64toi32_i32$0 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($3 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[($3 + 20 | 0) >> 2] | 0;
    alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($1 | 0, $2 | 0, $4 | 0);
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    $1 = 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, ($3 + 16 | 0) + 8 | 0 | 0, 40 | 0) | 0;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $3 + 64 | 0;
 }
 
 function num_bigint__biguint__subtraction___impl_20core__ops__arith__SubAssign__num_bigint__biguint__BigUint__20for_20num_bigint__biguint__BigUint___sub_assign__h4ea1a97f3b7bcde9($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $3 = 0, $4 = 0, $2 = 0;
  $2 = HEAP32[$0 >> 2] | 0;
  $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  num_bigint__biguint__subtraction__sub2__h0b2286b660c85b0d($2 | 0, $3 | 0, HEAP32[$1 >> 2] | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
  $4 = 0;
  label$1 : {
   if (!$3) {
    break label$1
   }
   $1 = (($3 << 2 | 0) + $2 | 0) + -4 | 0;
   label$2 : while (1) {
    label$3 : {
     if (!(HEAP32[$1 >> 2] | 0)) {
      break label$3
     }
     $4 = $3;
     break label$1;
    }
    $3 = $3 + -1 | 0;
    HEAP32[($0 + 8 | 0) >> 2] = $3;
    $1 = $1 + -4 | 0;
    if ($3) {
     continue label$2
    }
    break label$2;
   };
  }
  label$4 : {
   $3 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if ($4 >>> 0 >= ($3 >>> 2 | 0) >>> 0) {
    break label$4
   }
   if ($3 >>> 0 <= $4 >>> 0) {
    break label$4
   }
   alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($0 | 0, $4 | 0);
  }
 }
 
 function unitinterval_new($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $4$hi = 0, $5$hi = 0, $3 = 0, $4 = 0, $40 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($2 | 0, $1 | 0);
   i64toi32_i32$2 = $3;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $4 = i64toi32_i32$0;
   $4$hi = i64toi32_i32$1;
   i64toi32_i32$2 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $5$hi = i64toi32_i32$0;
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   i64toi32_i32$0 = $4$hi;
   i64toi32_i32$0 = $5$hi;
   $40 = i64toi32_i32$1;
   i64toi32_i32$0 = $4$hi;
   i64toi32_i32$1 = $5$hi;
   $0 = $cardano_serialization_lib__UnitInterval_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he6b97f3f09608ed8($4 | 0, i64toi32_i32$0 | 0, $40 | 0, i64toi32_i32$1 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function cardano_serialization_lib__TransactionOutput__new__h3c6ccbf8a30c4d79($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, $3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $4 = 0, $4$hi = 0, $25 = 0, $30 = 0;
  $3 = global$0 - 80 | 0;
  global$0 = $3;
  $cardano_serialization_lib__address__Address_20as_20core__clone__Clone___clone__h0eb465a6e349d507($3 | 0, $1 | 0);
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$1;
  $1 = 0;
  label$1 : {
   if ((HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($3 + 64 | 0 | 4 | 0 | 0, $2 + 12 | 0 | 0);
   $1 = 1;
  }
  HEAP32[($3 + 64 | 0) >> 2] = $1;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[($3 + 64 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($3 + 68 | 0) >> 2] | 0;
  $25 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 72 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $25;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $3 + 72 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 80 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $30;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $0 = memcpy($0 | 0, $3 | 0, 64 | 0) | 0;
  HEAP8[($0 + 88 | 0) >> 0] = 0;
  i64toi32_i32$1 = $4$hi;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 64 | 0) >> 2] = $4;
  HEAP32[(i64toi32_i32$0 + 68 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $3 + 80 | 0;
 }
 
 function scriptall_native_scripts($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hcc9e595588038ff3($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($1 + 16 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($1 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($1 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  HEAP32[($1 + 32 | 0) >> 2] = HEAP32[($1 + 16 | 0) >> 2] | 0;
  HEAP32[($1 + 36 | 0) >> 2] = i64toi32_i32$1;
  $0 = $cardano_serialization_lib__NativeScripts_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hd952f91bbdbbead8($1 + 32 | 0 | 0) | 0;
  global$0 = $1 + 48 | 0;
  return $0 | 0;
 }
 
 function scriptall_new($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hbfc7b2ba05921680($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($1 + 16 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($1 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($1 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  HEAP32[($1 + 32 | 0) >> 2] = HEAP32[($1 + 16 | 0) >> 2] | 0;
  HEAP32[($1 + 36 | 0) >> 2] = i64toi32_i32$1;
  $0 = $cardano_serialization_lib__ScriptAll_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hef80bd8099d14009($1 + 32 | 0 | 0) | 0;
  global$0 = $1 + 48 | 0;
  return $0 | 0;
 }
 
 function scriptany_native_scripts($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hc49defd7d95949da($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($1 + 16 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($1 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($1 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  HEAP32[($1 + 32 | 0) >> 2] = HEAP32[($1 + 16 | 0) >> 2] | 0;
  HEAP32[($1 + 36 | 0) >> 2] = i64toi32_i32$1;
  $0 = $cardano_serialization_lib__NativeScripts_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hd952f91bbdbbead8($1 + 32 | 0 | 0) | 0;
  global$0 = $1 + 48 | 0;
  return $0 | 0;
 }
 
 function scriptany_new($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hbfc7b2ba05921680($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($1 + 16 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($1 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($1 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  HEAP32[($1 + 32 | 0) >> 2] = HEAP32[($1 + 16 | 0) >> 2] | 0;
  HEAP32[($1 + 36 | 0) >> 2] = i64toi32_i32$1;
  $0 = $cardano_serialization_lib__ScriptAny_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hee8cbd3c8c833493($1 + 32 | 0 | 0) | 0;
  global$0 = $1 + 48 | 0;
  return $0 | 0;
 }
 
 function scriptnofk_native_scripts($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__he533e1773e537fcd($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  alloc__slice___impl_20_5bT_5d___to_vec_in__h8a2ff259e68eef18($1 + 16 | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($1 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($1 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  HEAP32[($1 + 32 | 0) >> 2] = HEAP32[($1 + 16 | 0) >> 2] | 0;
  HEAP32[($1 + 36 | 0) >> 2] = i64toi32_i32$1;
  $0 = $cardano_serialization_lib__NativeScripts_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hd952f91bbdbbead8($1 + 32 | 0 | 0) | 0;
  global$0 = $1 + 48 | 0;
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__NativeScript_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h345d8ecbe77ecc63($0) {
  $0 = $0 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $1 = 0, $9 = 0, $14 = 0, $19 = 0, $22 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  i64toi32_i32$2 = $0 + 24 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $9 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 40 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $9;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $0 + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 32 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $14;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $0 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 24 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $19;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $0;
  i64toi32_i32$1 = HEAP32[$0 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $22 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $22;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  label$1 : {
   $0 = __rust_alloc(40 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(40 | 0, 8 | 0);
   abort();
  }
  HEAP32[$0 >> 2] = 0;
  memcpy($0 + 4 | 0 | 0, $1 + 12 | 0 | 0, 36 | 0) | 0;
  global$0 = $1 + 48 | 0;
  return $0 | 0;
 }
 
 function protocolparamupdate_set_pool_pledge_influence($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $28 = 0, $31 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h0a71cd742026514d($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h98bfbcc994df632c($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $4 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] = 1;
   HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $4;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
   $28 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[(i64toi32_i32$0 + 80 | 0) >> 2] = $28;
   HEAP32[(i64toi32_i32$0 + 84 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $31 = i64toi32_i32$1;
   i64toi32_i32$1 = $0;
   HEAP32[(i64toi32_i32$1 + 72 | 0) >> 2] = $31;
   HEAP32[(i64toi32_i32$1 + 76 | 0) >> 2] = i64toi32_i32$0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function protocolparamupdate_pool_pledge_influence($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $1 = 0, i64toi32_i32$0 = 0, $2 = 0, $3$hi = 0, $3 = 0, $34$hi = 0, $10 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hd84cc8f720a3dada($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   label$2 : {
    label$3 : {
     $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
     i64toi32_i32$2 = i64toi32_i32$0;
     i64toi32_i32$0 = 0;
     i64toi32_i32$3 = 1;
     if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
      break label$3
     }
     core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
     $0 = 0;
     break label$2;
    }
    i64toi32_i32$3 = $2;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 80 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 84 | 0) >> 2] | 0;
    $3 = i64toi32_i32$2;
    $3$hi = i64toi32_i32$1;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 72 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 76 | 0) >> 2] | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    $34$hi = i64toi32_i32$2;
    i64toi32_i32$2 = $3$hi;
    i64toi32_i32$2 = $34$hi;
    $10 = i64toi32_i32$1;
    i64toi32_i32$1 = $3$hi;
    $0 = $cardano_serialization_lib__UnitInterval_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he6b97f3f09608ed8($10 | 0, i64toi32_i32$2 | 0, $3 | 0, i64toi32_i32$1 | 0) | 0;
   }
   global$0 = $1 + 16 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function protocolparamupdate_set_expansion_rate($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $28 = 0, $31 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h0a71cd742026514d($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h98bfbcc994df632c($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $4 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[(i64toi32_i32$1 + 88 | 0) >> 2] = 1;
   HEAP32[(i64toi32_i32$1 + 92 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $4;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
   $28 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[(i64toi32_i32$0 + 104 | 0) >> 2] = $28;
   HEAP32[(i64toi32_i32$0 + 108 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $31 = i64toi32_i32$1;
   i64toi32_i32$1 = $0;
   HEAP32[(i64toi32_i32$1 + 96 | 0) >> 2] = $31;
   HEAP32[(i64toi32_i32$1 + 100 | 0) >> 2] = i64toi32_i32$0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function protocolparamupdate_expansion_rate($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $1 = 0, i64toi32_i32$0 = 0, $2 = 0, $3$hi = 0, $3 = 0, $34$hi = 0, $10 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hd84cc8f720a3dada($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   label$2 : {
    label$3 : {
     $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 88 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 92 | 0) >> 2] | 0;
     i64toi32_i32$2 = i64toi32_i32$0;
     i64toi32_i32$0 = 0;
     i64toi32_i32$3 = 1;
     if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
      break label$3
     }
     core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
     $0 = 0;
     break label$2;
    }
    i64toi32_i32$3 = $2;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 104 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 108 | 0) >> 2] | 0;
    $3 = i64toi32_i32$2;
    $3$hi = i64toi32_i32$1;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 96 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 100 | 0) >> 2] | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    $34$hi = i64toi32_i32$2;
    i64toi32_i32$2 = $3$hi;
    i64toi32_i32$2 = $34$hi;
    $10 = i64toi32_i32$1;
    i64toi32_i32$1 = $3$hi;
    $0 = $cardano_serialization_lib__UnitInterval_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he6b97f3f09608ed8($10 | 0, i64toi32_i32$2 | 0, $3 | 0, i64toi32_i32$1 | 0) | 0;
   }
   global$0 = $1 + 16 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function protocolparamupdate_set_treasury_growth_rate($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $28 = 0, $31 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h0a71cd742026514d($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h98bfbcc994df632c($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $4 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[(i64toi32_i32$1 + 112 | 0) >> 2] = 1;
   HEAP32[(i64toi32_i32$1 + 116 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $4;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
   $28 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[(i64toi32_i32$0 + 128 | 0) >> 2] = $28;
   HEAP32[(i64toi32_i32$0 + 132 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $31 = i64toi32_i32$1;
   i64toi32_i32$1 = $0;
   HEAP32[(i64toi32_i32$1 + 120 | 0) >> 2] = $31;
   HEAP32[(i64toi32_i32$1 + 124 | 0) >> 2] = i64toi32_i32$0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function protocolparamupdate_treasury_growth_rate($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $1 = 0, i64toi32_i32$0 = 0, $2 = 0, $3$hi = 0, $3 = 0, $34$hi = 0, $10 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hd84cc8f720a3dada($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   label$2 : {
    label$3 : {
     $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 112 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 116 | 0) >> 2] | 0;
     i64toi32_i32$2 = i64toi32_i32$0;
     i64toi32_i32$0 = 0;
     i64toi32_i32$3 = 1;
     if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
      break label$3
     }
     core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
     $0 = 0;
     break label$2;
    }
    i64toi32_i32$3 = $2;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 128 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 132 | 0) >> 2] | 0;
    $3 = i64toi32_i32$2;
    $3$hi = i64toi32_i32$1;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 120 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 124 | 0) >> 2] | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    $34$hi = i64toi32_i32$2;
    i64toi32_i32$2 = $3$hi;
    i64toi32_i32$2 = $34$hi;
    $10 = i64toi32_i32$1;
    i64toi32_i32$1 = $3$hi;
    $0 = $cardano_serialization_lib__UnitInterval_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he6b97f3f09608ed8($10 | 0, i64toi32_i32$2 | 0, $3 | 0, i64toi32_i32$1 | 0) | 0;
   }
   global$0 = $1 + 16 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function protocolparamupdate_set_d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $28 = 0, $31 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h0a71cd742026514d($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h98bfbcc994df632c($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $4 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[(i64toi32_i32$1 + 136 | 0) >> 2] = 1;
   HEAP32[(i64toi32_i32$1 + 140 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $4;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
   $28 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[(i64toi32_i32$0 + 152 | 0) >> 2] = $28;
   HEAP32[(i64toi32_i32$0 + 156 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $31 = i64toi32_i32$1;
   i64toi32_i32$1 = $0;
   HEAP32[(i64toi32_i32$1 + 144 | 0) >> 2] = $31;
   HEAP32[(i64toi32_i32$1 + 148 | 0) >> 2] = i64toi32_i32$0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function protocolparamupdate_d($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $1 = 0, i64toi32_i32$0 = 0, $2 = 0, $3$hi = 0, $3 = 0, $34$hi = 0, $10 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hd84cc8f720a3dada($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   label$2 : {
    label$3 : {
     $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 136 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 140 | 0) >> 2] | 0;
     i64toi32_i32$2 = i64toi32_i32$0;
     i64toi32_i32$0 = 0;
     i64toi32_i32$3 = 1;
     if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
      break label$3
     }
     core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
     $0 = 0;
     break label$2;
    }
    i64toi32_i32$3 = $2;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 152 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 156 | 0) >> 2] | 0;
    $3 = i64toi32_i32$2;
    $3$hi = i64toi32_i32$1;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 144 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 148 | 0) >> 2] | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    $34$hi = i64toi32_i32$2;
    i64toi32_i32$2 = $3$hi;
    i64toi32_i32$2 = $34$hi;
    $10 = i64toi32_i32$1;
    i64toi32_i32$1 = $3$hi;
    $0 = $cardano_serialization_lib__UnitInterval_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he6b97f3f09608ed8($10 | 0, i64toi32_i32$2 | 0, $3 | 0, i64toi32_i32$1 | 0) | 0;
   }
   global$0 = $1 + 16 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function protocolparamupdate_set_max_tx_ex_units($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $28 = 0, $31 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h0a71cd742026514d($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h1f4aa39af4dc2942($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $4 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[(i64toi32_i32$1 + 232 | 0) >> 2] = 1;
   HEAP32[(i64toi32_i32$1 + 236 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $4;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
   $28 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[(i64toi32_i32$0 + 248 | 0) >> 2] = $28;
   HEAP32[(i64toi32_i32$0 + 252 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $31 = i64toi32_i32$1;
   i64toi32_i32$1 = $0;
   HEAP32[(i64toi32_i32$1 + 240 | 0) >> 2] = $31;
   HEAP32[(i64toi32_i32$1 + 244 | 0) >> 2] = i64toi32_i32$0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function protocolparamupdate_max_tx_ex_units($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $1 = 0, i64toi32_i32$0 = 0, $2 = 0, $3$hi = 0, $3 = 0, $34$hi = 0, $10 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hd84cc8f720a3dada($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   label$2 : {
    label$3 : {
     $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 232 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 236 | 0) >> 2] | 0;
     i64toi32_i32$2 = i64toi32_i32$0;
     i64toi32_i32$0 = 0;
     i64toi32_i32$3 = 1;
     if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
      break label$3
     }
     core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
     $0 = 0;
     break label$2;
    }
    i64toi32_i32$3 = $2;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 248 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 252 | 0) >> 2] | 0;
    $3 = i64toi32_i32$2;
    $3$hi = i64toi32_i32$1;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 240 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 244 | 0) >> 2] | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    $34$hi = i64toi32_i32$2;
    i64toi32_i32$2 = $3$hi;
    i64toi32_i32$2 = $34$hi;
    $10 = i64toi32_i32$1;
    i64toi32_i32$1 = $3$hi;
    $0 = $cardano_serialization_lib__plutus__ExUnits_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h4867c49ddc624134($10 | 0, i64toi32_i32$2 | 0, $3 | 0, i64toi32_i32$1 | 0) | 0;
   }
   global$0 = $1 + 16 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function protocolparamupdate_set_max_block_ex_units($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $28 = 0, $31 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h0a71cd742026514d($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h1f4aa39af4dc2942($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $4 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[(i64toi32_i32$1 + 256 | 0) >> 2] = 1;
   HEAP32[(i64toi32_i32$1 + 260 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $4;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
   $28 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[(i64toi32_i32$0 + 272 | 0) >> 2] = $28;
   HEAP32[(i64toi32_i32$0 + 276 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $31 = i64toi32_i32$1;
   i64toi32_i32$1 = $0;
   HEAP32[(i64toi32_i32$1 + 264 | 0) >> 2] = $31;
   HEAP32[(i64toi32_i32$1 + 268 | 0) >> 2] = i64toi32_i32$0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function protocolparamupdate_max_block_ex_units($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $1 = 0, i64toi32_i32$0 = 0, $2 = 0, $3$hi = 0, $3 = 0, $34$hi = 0, $10 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hd84cc8f720a3dada($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   label$2 : {
    label$3 : {
     $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     i64toi32_i32$2 = $2;
     i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 256 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 260 | 0) >> 2] | 0;
     i64toi32_i32$2 = i64toi32_i32$0;
     i64toi32_i32$0 = 0;
     i64toi32_i32$3 = 1;
     if ((i64toi32_i32$2 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
      break label$3
     }
     core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
     $0 = 0;
     break label$2;
    }
    i64toi32_i32$3 = $2;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 272 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 276 | 0) >> 2] | 0;
    $3 = i64toi32_i32$2;
    $3$hi = i64toi32_i32$1;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$3 + 264 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[(i64toi32_i32$3 + 268 | 0) >> 2] | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    $34$hi = i64toi32_i32$2;
    i64toi32_i32$2 = $3$hi;
    i64toi32_i32$2 = $34$hi;
    $10 = i64toi32_i32$1;
    i64toi32_i32$1 = $3$hi;
    $0 = $cardano_serialization_lib__plutus__ExUnits_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h4867c49ddc624134($10 | 0, i64toi32_i32$2 | 0, $3 | 0, i64toi32_i32$1 | 0) | 0;
   }
   global$0 = $1 + 16 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function alloc__raw_vec__RawVec_T_2cA___allocate_in__h0b609c68c6c57291($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $10 = 0, $3 = 0, $3$hi = 0, i64toi32_i32$2 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         i64toi32_i32$0 = 0;
         i64toi32_i32$1 = 0;
         i64toi32_i32$1 = __wasm_i64_mul($1 | 0, i64toi32_i32$0 | 0, 272 | 0, i64toi32_i32$1 | 0) | 0;
         i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
         $3 = i64toi32_i32$1;
         $3$hi = i64toi32_i32$0;
         i64toi32_i32$2 = i64toi32_i32$1;
         i64toi32_i32$1 = 0;
         i64toi32_i32$3 = 32;
         i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
          i64toi32_i32$1 = 0;
          $10 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
         } else {
          i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
          $10 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
         }
         if ($10) {
          break label$7
         }
         i64toi32_i32$1 = $3$hi;
         $1 = $3;
         if (($1 | 0) < (0 | 0)) {
          break label$6
         }
         if ($2) {
          break label$5
         }
         if ($1) {
          break label$4
         }
         break label$2;
        }
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
       }
       alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
       abort();
      }
      if (!$1) {
       break label$2
      }
      $2 = __rust_alloc_zeroed($1 | 0, 8 | 0) | 0;
      if (!$2) {
       break label$3
      }
      break label$1;
     }
     $2 = __rust_alloc($1 | 0, 8 | 0) | 0;
     if ($2) {
      break label$1
     }
    }
    $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
    alloc__alloc__handle_alloc_error__he269d8f1bff90960($1 | 0, 8 | 0);
    abort();
   }
   $2 = 8;
  }
  HEAP32[$0 >> 2] = $2;
  HEAP32[($0 + 4 | 0) >> 2] = ($1 >>> 0) / (272 >>> 0) | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___allocate_in__h436fe8d758b2781e($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $10 = 0, $3 = 0, $3$hi = 0, i64toi32_i32$2 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         i64toi32_i32$0 = 0;
         i64toi32_i32$1 = 0;
         i64toi32_i32$1 = __wasm_i64_mul($1 | 0, i64toi32_i32$0 | 0, 96 | 0, i64toi32_i32$1 | 0) | 0;
         i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
         $3 = i64toi32_i32$1;
         $3$hi = i64toi32_i32$0;
         i64toi32_i32$2 = i64toi32_i32$1;
         i64toi32_i32$1 = 0;
         i64toi32_i32$3 = 32;
         i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
          i64toi32_i32$1 = 0;
          $10 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
         } else {
          i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
          $10 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
         }
         if ($10) {
          break label$7
         }
         i64toi32_i32$1 = $3$hi;
         $1 = $3;
         if (($1 | 0) < (0 | 0)) {
          break label$6
         }
         if ($2) {
          break label$5
         }
         if ($1) {
          break label$4
         }
         break label$2;
        }
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
       }
       alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
       abort();
      }
      if (!$1) {
       break label$2
      }
      $2 = __rust_alloc_zeroed($1 | 0, 1 | 0) | 0;
      if (!$2) {
       break label$3
      }
      break label$1;
     }
     $2 = __rust_alloc($1 | 0, 1 | 0) | 0;
     if ($2) {
      break label$1
     }
    }
    $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
    alloc__alloc__handle_alloc_error__he269d8f1bff90960($1 | 0, 1 | 0);
    abort();
   }
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  HEAP32[($0 + 4 | 0) >> 2] = ($1 >>> 0) / (96 >>> 0) | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___allocate_in__h5a1370a6bc6e89cb($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $10 = 0, $3 = 0, $3$hi = 0, i64toi32_i32$2 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         i64toi32_i32$0 = 0;
         i64toi32_i32$1 = 0;
         i64toi32_i32$1 = __wasm_i64_mul($1 | 0, i64toi32_i32$0 | 0, 12 | 0, i64toi32_i32$1 | 0) | 0;
         i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
         $3 = i64toi32_i32$1;
         $3$hi = i64toi32_i32$0;
         i64toi32_i32$2 = i64toi32_i32$1;
         i64toi32_i32$1 = 0;
         i64toi32_i32$3 = 32;
         i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
          i64toi32_i32$1 = 0;
          $10 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
         } else {
          i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
          $10 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
         }
         if ($10) {
          break label$7
         }
         i64toi32_i32$1 = $3$hi;
         $1 = $3;
         if (($1 | 0) < (0 | 0)) {
          break label$6
         }
         if ($2) {
          break label$5
         }
         if ($1) {
          break label$4
         }
         break label$2;
        }
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
       }
       alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
       abort();
      }
      if (!$1) {
       break label$2
      }
      $2 = __rust_alloc_zeroed($1 | 0, 4 | 0) | 0;
      if (!$2) {
       break label$3
      }
      break label$1;
     }
     $2 = __rust_alloc($1 | 0, 4 | 0) | 0;
     if ($2) {
      break label$1
     }
    }
    $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
    alloc__alloc__handle_alloc_error__he269d8f1bff90960($1 | 0, 4 | 0);
    abort();
   }
   $2 = 4;
  }
  HEAP32[$0 >> 2] = $2;
  HEAP32[($0 + 4 | 0) >> 2] = ($1 >>> 0) / (12 >>> 0) | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___allocate_in__h645859b7877a3836($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $10 = 0, $3 = 0, $3$hi = 0, i64toi32_i32$2 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         i64toi32_i32$0 = 0;
         i64toi32_i32$1 = 0;
         i64toi32_i32$1 = __wasm_i64_mul($1 | 0, i64toi32_i32$0 | 0, 168 | 0, i64toi32_i32$1 | 0) | 0;
         i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
         $3 = i64toi32_i32$1;
         $3$hi = i64toi32_i32$0;
         i64toi32_i32$2 = i64toi32_i32$1;
         i64toi32_i32$1 = 0;
         i64toi32_i32$3 = 32;
         i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
          i64toi32_i32$1 = 0;
          $10 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
         } else {
          i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
          $10 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
         }
         if ($10) {
          break label$7
         }
         i64toi32_i32$1 = $3$hi;
         $1 = $3;
         if (($1 | 0) < (0 | 0)) {
          break label$6
         }
         if ($2) {
          break label$5
         }
         if ($1) {
          break label$4
         }
         break label$2;
        }
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
       }
       alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
       abort();
      }
      if (!$1) {
       break label$2
      }
      $2 = __rust_alloc_zeroed($1 | 0, 8 | 0) | 0;
      if (!$2) {
       break label$3
      }
      break label$1;
     }
     $2 = __rust_alloc($1 | 0, 8 | 0) | 0;
     if ($2) {
      break label$1
     }
    }
    $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
    alloc__alloc__handle_alloc_error__he269d8f1bff90960($1 | 0, 8 | 0);
    abort();
   }
   $2 = 8;
  }
  HEAP32[$0 >> 2] = $2;
  HEAP32[($0 + 4 | 0) >> 2] = ($1 >>> 0) / (168 >>> 0) | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___allocate_in__h7713ba2200389774($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $10 = 0, $3 = 0, $3$hi = 0, i64toi32_i32$2 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         i64toi32_i32$0 = 0;
         i64toi32_i32$1 = 0;
         i64toi32_i32$1 = __wasm_i64_mul($1 | 0, i64toi32_i32$0 | 0, 120 | 0, i64toi32_i32$1 | 0) | 0;
         i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
         $3 = i64toi32_i32$1;
         $3$hi = i64toi32_i32$0;
         i64toi32_i32$2 = i64toi32_i32$1;
         i64toi32_i32$1 = 0;
         i64toi32_i32$3 = 32;
         i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
          i64toi32_i32$1 = 0;
          $10 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
         } else {
          i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
          $10 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
         }
         if ($10) {
          break label$7
         }
         i64toi32_i32$1 = $3$hi;
         $1 = $3;
         if (($1 | 0) < (0 | 0)) {
          break label$6
         }
         if ($2) {
          break label$5
         }
         if ($1) {
          break label$4
         }
         break label$2;
        }
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
       }
       alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
       abort();
      }
      if (!$1) {
       break label$2
      }
      $2 = __rust_alloc_zeroed($1 | 0, 4 | 0) | 0;
      if (!$2) {
       break label$3
      }
      break label$1;
     }
     $2 = __rust_alloc($1 | 0, 4 | 0) | 0;
     if ($2) {
      break label$1
     }
    }
    $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
    alloc__alloc__handle_alloc_error__he269d8f1bff90960($1 | 0, 4 | 0);
    abort();
   }
   $2 = 4;
  }
  HEAP32[$0 >> 2] = $2;
  HEAP32[($0 + 4 | 0) >> 2] = ($1 >>> 0) / (120 >>> 0) | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___allocate_in__h8bef2550156a85eb($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $10 = 0, $3 = 0, $3$hi = 0, i64toi32_i32$2 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         i64toi32_i32$0 = 0;
         i64toi32_i32$1 = 0;
         i64toi32_i32$1 = __wasm_i64_mul($1 | 0, i64toi32_i32$0 | 0, 36 | 0, i64toi32_i32$1 | 0) | 0;
         i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
         $3 = i64toi32_i32$1;
         $3$hi = i64toi32_i32$0;
         i64toi32_i32$2 = i64toi32_i32$1;
         i64toi32_i32$1 = 0;
         i64toi32_i32$3 = 32;
         i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
          i64toi32_i32$1 = 0;
          $10 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
         } else {
          i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
          $10 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
         }
         if ($10) {
          break label$7
         }
         i64toi32_i32$1 = $3$hi;
         $1 = $3;
         if (($1 | 0) < (0 | 0)) {
          break label$6
         }
         if ($2) {
          break label$5
         }
         if ($1) {
          break label$4
         }
         break label$2;
        }
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
       }
       alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
       abort();
      }
      if (!$1) {
       break label$2
      }
      $2 = __rust_alloc_zeroed($1 | 0, 4 | 0) | 0;
      if (!$2) {
       break label$3
      }
      break label$1;
     }
     $2 = __rust_alloc($1 | 0, 4 | 0) | 0;
     if ($2) {
      break label$1
     }
    }
    $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
    alloc__alloc__handle_alloc_error__he269d8f1bff90960($1 | 0, 4 | 0);
    abort();
   }
   $2 = 4;
  }
  HEAP32[$0 >> 2] = $2;
  HEAP32[($0 + 4 | 0) >> 2] = ($1 >>> 0) / (36 >>> 0) | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___allocate_in__h9244f1b241188454($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $10 = 0, $3 = 0, $3$hi = 0, i64toi32_i32$2 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         i64toi32_i32$0 = 0;
         i64toi32_i32$1 = 0;
         i64toi32_i32$1 = __wasm_i64_mul($1 | 0, i64toi32_i32$0 | 0, 48 | 0, i64toi32_i32$1 | 0) | 0;
         i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
         $3 = i64toi32_i32$1;
         $3$hi = i64toi32_i32$0;
         i64toi32_i32$2 = i64toi32_i32$1;
         i64toi32_i32$1 = 0;
         i64toi32_i32$3 = 32;
         i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
          i64toi32_i32$1 = 0;
          $10 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
         } else {
          i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
          $10 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
         }
         if ($10) {
          break label$7
         }
         i64toi32_i32$1 = $3$hi;
         $1 = $3;
         if (($1 | 0) < (0 | 0)) {
          break label$6
         }
         if ($2) {
          break label$5
         }
         if ($1) {
          break label$4
         }
         break label$2;
        }
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
       }
       alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
       abort();
      }
      if (!$1) {
       break label$2
      }
      $2 = __rust_alloc_zeroed($1 | 0, 8 | 0) | 0;
      if (!$2) {
       break label$3
      }
      break label$1;
     }
     $2 = __rust_alloc($1 | 0, 8 | 0) | 0;
     if ($2) {
      break label$1
     }
    }
    $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
    alloc__alloc__handle_alloc_error__he269d8f1bff90960($1 | 0, 8 | 0);
    abort();
   }
   $2 = 8;
  }
  HEAP32[$0 >> 2] = $2;
  HEAP32[($0 + 4 | 0) >> 2] = ($1 >>> 0) / (48 >>> 0) | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___allocate_in__h94b8afe7a3e1d5bb($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $10 = 0, $3 = 0, $3$hi = 0, i64toi32_i32$2 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         i64toi32_i32$0 = 0;
         i64toi32_i32$1 = 0;
         i64toi32_i32$1 = __wasm_i64_mul($1 | 0, i64toi32_i32$0 | 0, 12 | 0, i64toi32_i32$1 | 0) | 0;
         i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
         $3 = i64toi32_i32$1;
         $3$hi = i64toi32_i32$0;
         i64toi32_i32$2 = i64toi32_i32$1;
         i64toi32_i32$1 = 0;
         i64toi32_i32$3 = 32;
         i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
          i64toi32_i32$1 = 0;
          $10 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
         } else {
          i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
          $10 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
         }
         if ($10) {
          break label$7
         }
         i64toi32_i32$1 = $3$hi;
         $1 = $3;
         if (($1 | 0) < (0 | 0)) {
          break label$6
         }
         if ($2) {
          break label$5
         }
         if ($1) {
          break label$4
         }
         break label$2;
        }
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
       }
       alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
       abort();
      }
      if (!$1) {
       break label$2
      }
      $2 = __rust_alloc_zeroed($1 | 0, 4 | 0) | 0;
      if (!$2) {
       break label$3
      }
      break label$1;
     }
     $2 = __rust_alloc($1 | 0, 4 | 0) | 0;
     if ($2) {
      break label$1
     }
    }
    $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
    alloc__alloc__handle_alloc_error__he269d8f1bff90960($1 | 0, 4 | 0);
    abort();
   }
   $2 = 4;
  }
  HEAP32[$0 >> 2] = $2;
  HEAP32[($0 + 4 | 0) >> 2] = ($1 >>> 0) / (12 >>> 0) | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___allocate_in__h9cab6ad20a8290a4($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $10 = 0, $3 = 0, $3$hi = 0, i64toi32_i32$2 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         i64toi32_i32$0 = 0;
         i64toi32_i32$1 = 0;
         i64toi32_i32$1 = __wasm_i64_mul($1 | 0, i64toi32_i32$0 | 0, 28 | 0, i64toi32_i32$1 | 0) | 0;
         i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
         $3 = i64toi32_i32$1;
         $3$hi = i64toi32_i32$0;
         i64toi32_i32$2 = i64toi32_i32$1;
         i64toi32_i32$1 = 0;
         i64toi32_i32$3 = 32;
         i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
          i64toi32_i32$1 = 0;
          $10 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
         } else {
          i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
          $10 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
         }
         if ($10) {
          break label$7
         }
         i64toi32_i32$1 = $3$hi;
         $1 = $3;
         if (($1 | 0) < (0 | 0)) {
          break label$6
         }
         if ($2) {
          break label$5
         }
         if ($1) {
          break label$4
         }
         break label$2;
        }
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
       }
       alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
       abort();
      }
      if (!$1) {
       break label$2
      }
      $2 = __rust_alloc_zeroed($1 | 0, 1 | 0) | 0;
      if (!$2) {
       break label$3
      }
      break label$1;
     }
     $2 = __rust_alloc($1 | 0, 1 | 0) | 0;
     if ($2) {
      break label$1
     }
    }
    $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
    alloc__alloc__handle_alloc_error__he269d8f1bff90960($1 | 0, 1 | 0);
    abort();
   }
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  HEAP32[($0 + 4 | 0) >> 2] = ($1 >>> 0) / (28 >>> 0) | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___allocate_in__h9fa2ec00e0b754b8($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $10 = 0, $3 = 0, $3$hi = 0, i64toi32_i32$2 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         i64toi32_i32$0 = 0;
         i64toi32_i32$1 = 0;
         i64toi32_i32$1 = __wasm_i64_mul($1 | 0, i64toi32_i32$0 | 0, 29 | 0, i64toi32_i32$1 | 0) | 0;
         i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
         $3 = i64toi32_i32$1;
         $3$hi = i64toi32_i32$0;
         i64toi32_i32$2 = i64toi32_i32$1;
         i64toi32_i32$1 = 0;
         i64toi32_i32$3 = 32;
         i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
          i64toi32_i32$1 = 0;
          $10 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
         } else {
          i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
          $10 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
         }
         if ($10) {
          break label$7
         }
         i64toi32_i32$1 = $3$hi;
         $1 = $3;
         if (($1 | 0) < (0 | 0)) {
          break label$6
         }
         if ($2) {
          break label$5
         }
         if ($1) {
          break label$4
         }
         break label$2;
        }
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
       }
       alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
       abort();
      }
      if (!$1) {
       break label$2
      }
      $2 = __rust_alloc_zeroed($1 | 0, 1 | 0) | 0;
      if (!$2) {
       break label$3
      }
      break label$1;
     }
     $2 = __rust_alloc($1 | 0, 1 | 0) | 0;
     if ($2) {
      break label$1
     }
    }
    $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
    alloc__alloc__handle_alloc_error__he269d8f1bff90960($1 | 0, 1 | 0);
    abort();
   }
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  HEAP32[($0 + 4 | 0) >> 2] = ($1 >>> 0) / (29 >>> 0) | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___allocate_in__ha2ff5298d92d8db5($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $10 = 0, $3 = 0, $3$hi = 0, i64toi32_i32$2 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         i64toi32_i32$0 = 0;
         i64toi32_i32$1 = 0;
         i64toi32_i32$1 = __wasm_i64_mul($1 | 0, i64toi32_i32$0 | 0, 28 | 0, i64toi32_i32$1 | 0) | 0;
         i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
         $3 = i64toi32_i32$1;
         $3$hi = i64toi32_i32$0;
         i64toi32_i32$2 = i64toi32_i32$1;
         i64toi32_i32$1 = 0;
         i64toi32_i32$3 = 32;
         i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
          i64toi32_i32$1 = 0;
          $10 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
         } else {
          i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
          $10 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
         }
         if ($10) {
          break label$7
         }
         i64toi32_i32$1 = $3$hi;
         $1 = $3;
         if (($1 | 0) < (0 | 0)) {
          break label$6
         }
         if ($2) {
          break label$5
         }
         if ($1) {
          break label$4
         }
         break label$2;
        }
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
       }
       alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
       abort();
      }
      if (!$1) {
       break label$2
      }
      $2 = __rust_alloc_zeroed($1 | 0, 1 | 0) | 0;
      if (!$2) {
       break label$3
      }
      break label$1;
     }
     $2 = __rust_alloc($1 | 0, 1 | 0) | 0;
     if ($2) {
      break label$1
     }
    }
    $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
    alloc__alloc__handle_alloc_error__he269d8f1bff90960($1 | 0, 1 | 0);
    abort();
   }
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  HEAP32[($0 + 4 | 0) >> 2] = ($1 >>> 0) / (28 >>> 0) | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___allocate_in__hadc977b10ff8afa2($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $10 = 0, $3 = 0, $3$hi = 0, i64toi32_i32$2 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         i64toi32_i32$0 = 0;
         i64toi32_i32$1 = 0;
         i64toi32_i32$1 = __wasm_i64_mul($1 | 0, i64toi32_i32$0 | 0, 30 | 0, i64toi32_i32$1 | 0) | 0;
         i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
         $3 = i64toi32_i32$1;
         $3$hi = i64toi32_i32$0;
         i64toi32_i32$2 = i64toi32_i32$1;
         i64toi32_i32$1 = 0;
         i64toi32_i32$3 = 32;
         i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
          i64toi32_i32$1 = 0;
          $10 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
         } else {
          i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
          $10 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
         }
         if ($10) {
          break label$7
         }
         i64toi32_i32$1 = $3$hi;
         $1 = $3;
         if (($1 | 0) < (0 | 0)) {
          break label$6
         }
         if ($2) {
          break label$5
         }
         if ($1) {
          break label$4
         }
         break label$2;
        }
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
       }
       alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
       abort();
      }
      if (!$1) {
       break label$2
      }
      $2 = __rust_alloc_zeroed($1 | 0, 1 | 0) | 0;
      if (!$2) {
       break label$3
      }
      break label$1;
     }
     $2 = __rust_alloc($1 | 0, 1 | 0) | 0;
     if ($2) {
      break label$1
     }
    }
    $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
    alloc__alloc__handle_alloc_error__he269d8f1bff90960($1 | 0, 1 | 0);
    abort();
   }
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  HEAP32[($0 + 4 | 0) >> 2] = ($1 >>> 0) / (30 >>> 0) | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___allocate_in__hc51b1e7ac9e86799($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $10 = 0, $3 = 0, $3$hi = 0, i64toi32_i32$2 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         i64toi32_i32$0 = 0;
         i64toi32_i32$1 = 0;
         i64toi32_i32$1 = __wasm_i64_mul($1 | 0, i64toi32_i32$0 | 0, 76 | 0, i64toi32_i32$1 | 0) | 0;
         i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
         $3 = i64toi32_i32$1;
         $3$hi = i64toi32_i32$0;
         i64toi32_i32$2 = i64toi32_i32$1;
         i64toi32_i32$1 = 0;
         i64toi32_i32$3 = 32;
         i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
          i64toi32_i32$1 = 0;
          $10 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
         } else {
          i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
          $10 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
         }
         if ($10) {
          break label$7
         }
         i64toi32_i32$1 = $3$hi;
         $1 = $3;
         if (($1 | 0) < (0 | 0)) {
          break label$6
         }
         if ($2) {
          break label$5
         }
         if ($1) {
          break label$4
         }
         break label$2;
        }
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
       }
       alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
       abort();
      }
      if (!$1) {
       break label$2
      }
      $2 = __rust_alloc_zeroed($1 | 0, 4 | 0) | 0;
      if (!$2) {
       break label$3
      }
      break label$1;
     }
     $2 = __rust_alloc($1 | 0, 4 | 0) | 0;
     if ($2) {
      break label$1
     }
    }
    $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
    alloc__alloc__handle_alloc_error__he269d8f1bff90960($1 | 0, 4 | 0);
    abort();
   }
   $2 = 4;
  }
  HEAP32[$0 >> 2] = $2;
  HEAP32[($0 + 4 | 0) >> 2] = ($1 >>> 0) / (76 >>> 0) | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___allocate_in__hd4ae7e11703b95a3($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $10 = 0, $3 = 0, $3$hi = 0, i64toi32_i32$2 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         i64toi32_i32$0 = 0;
         i64toi32_i32$1 = 0;
         i64toi32_i32$1 = __wasm_i64_mul($1 | 0, i64toi32_i32$0 | 0, 48 | 0, i64toi32_i32$1 | 0) | 0;
         i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
         $3 = i64toi32_i32$1;
         $3$hi = i64toi32_i32$0;
         i64toi32_i32$2 = i64toi32_i32$1;
         i64toi32_i32$1 = 0;
         i64toi32_i32$3 = 32;
         i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
          i64toi32_i32$1 = 0;
          $10 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
         } else {
          i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
          $10 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
         }
         if ($10) {
          break label$7
         }
         i64toi32_i32$1 = $3$hi;
         $1 = $3;
         if (($1 | 0) < (0 | 0)) {
          break label$6
         }
         if ($2) {
          break label$5
         }
         if ($1) {
          break label$4
         }
         break label$2;
        }
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
       }
       alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
       abort();
      }
      if (!$1) {
       break label$2
      }
      $2 = __rust_alloc_zeroed($1 | 0, 8 | 0) | 0;
      if (!$2) {
       break label$3
      }
      break label$1;
     }
     $2 = __rust_alloc($1 | 0, 8 | 0) | 0;
     if ($2) {
      break label$1
     }
    }
    $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
    alloc__alloc__handle_alloc_error__he269d8f1bff90960($1 | 0, 8 | 0);
    abort();
   }
   $2 = 8;
  }
  HEAP32[$0 >> 2] = $2;
  HEAP32[($0 + 4 | 0) >> 2] = ($1 >>> 0) / (48 >>> 0) | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___allocate_in__hd795b89d8892a0fd($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $10 = 0, $3 = 0, $3$hi = 0, i64toi32_i32$2 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         i64toi32_i32$0 = 0;
         i64toi32_i32$1 = 0;
         i64toi32_i32$1 = __wasm_i64_mul($1 | 0, i64toi32_i32$0 | 0, 28 | 0, i64toi32_i32$1 | 0) | 0;
         i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
         $3 = i64toi32_i32$1;
         $3$hi = i64toi32_i32$0;
         i64toi32_i32$2 = i64toi32_i32$1;
         i64toi32_i32$1 = 0;
         i64toi32_i32$3 = 32;
         i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
          i64toi32_i32$1 = 0;
          $10 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
         } else {
          i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
          $10 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
         }
         if ($10) {
          break label$7
         }
         i64toi32_i32$1 = $3$hi;
         $1 = $3;
         if (($1 | 0) < (0 | 0)) {
          break label$6
         }
         if ($2) {
          break label$5
         }
         if ($1) {
          break label$4
         }
         break label$2;
        }
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
       }
       alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
       abort();
      }
      if (!$1) {
       break label$2
      }
      $2 = __rust_alloc_zeroed($1 | 0, 1 | 0) | 0;
      if (!$2) {
       break label$3
      }
      break label$1;
     }
     $2 = __rust_alloc($1 | 0, 1 | 0) | 0;
     if ($2) {
      break label$1
     }
    }
    $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
    alloc__alloc__handle_alloc_error__he269d8f1bff90960($1 | 0, 1 | 0);
    abort();
   }
   $2 = 1;
  }
  HEAP32[$0 >> 2] = $2;
  HEAP32[($0 + 4 | 0) >> 2] = ($1 >>> 0) / (28 >>> 0) | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___allocate_in__hdfd3d0146c04aec1($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $10 = 0, $3 = 0, $3$hi = 0, i64toi32_i32$2 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         i64toi32_i32$0 = 0;
         i64toi32_i32$1 = 0;
         i64toi32_i32$1 = __wasm_i64_mul($1 | 0, i64toi32_i32$0 | 0, 200 | 0, i64toi32_i32$1 | 0) | 0;
         i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
         $3 = i64toi32_i32$1;
         $3$hi = i64toi32_i32$0;
         i64toi32_i32$2 = i64toi32_i32$1;
         i64toi32_i32$1 = 0;
         i64toi32_i32$3 = 32;
         i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
          i64toi32_i32$1 = 0;
          $10 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
         } else {
          i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
          $10 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
         }
         if ($10) {
          break label$7
         }
         i64toi32_i32$1 = $3$hi;
         $1 = $3;
         if (($1 | 0) < (0 | 0)) {
          break label$6
         }
         if ($2) {
          break label$5
         }
         if ($1) {
          break label$4
         }
         break label$2;
        }
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
       }
       alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
       abort();
      }
      if (!$1) {
       break label$2
      }
      $2 = __rust_alloc_zeroed($1 | 0, 8 | 0) | 0;
      if (!$2) {
       break label$3
      }
      break label$1;
     }
     $2 = __rust_alloc($1 | 0, 8 | 0) | 0;
     if ($2) {
      break label$1
     }
    }
    $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
    alloc__alloc__handle_alloc_error__he269d8f1bff90960($1 | 0, 8 | 0);
    abort();
   }
   $2 = 8;
  }
  HEAP32[$0 >> 2] = $2;
  HEAP32[($0 + 4 | 0) >> 2] = ($1 >>> 0) / (200 >>> 0) | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___allocate_in__he66014b8a55c2ce3($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $10 = 0, $3 = 0, $3$hi = 0, i64toi32_i32$2 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         i64toi32_i32$0 = 0;
         i64toi32_i32$1 = 0;
         i64toi32_i32$1 = __wasm_i64_mul($1 | 0, i64toi32_i32$0 | 0, 12 | 0, i64toi32_i32$1 | 0) | 0;
         i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
         $3 = i64toi32_i32$1;
         $3$hi = i64toi32_i32$0;
         i64toi32_i32$2 = i64toi32_i32$1;
         i64toi32_i32$1 = 0;
         i64toi32_i32$3 = 32;
         i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
          i64toi32_i32$1 = 0;
          $10 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
         } else {
          i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
          $10 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
         }
         if ($10) {
          break label$7
         }
         i64toi32_i32$1 = $3$hi;
         $1 = $3;
         if (($1 | 0) < (0 | 0)) {
          break label$6
         }
         if ($2) {
          break label$5
         }
         if ($1) {
          break label$4
         }
         break label$2;
        }
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
       }
       alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
       abort();
      }
      if (!$1) {
       break label$2
      }
      $2 = __rust_alloc_zeroed($1 | 0, 4 | 0) | 0;
      if (!$2) {
       break label$3
      }
      break label$1;
     }
     $2 = __rust_alloc($1 | 0, 4 | 0) | 0;
     if ($2) {
      break label$1
     }
    }
    $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
    alloc__alloc__handle_alloc_error__he269d8f1bff90960($1 | 0, 4 | 0);
    abort();
   }
   $2 = 4;
  }
  HEAP32[$0 >> 2] = $2;
  HEAP32[($0 + 4 | 0) >> 2] = ($1 >>> 0) / (12 >>> 0) | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___allocate_in__hf0a400f99425a834($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $10 = 0, $3 = 0, $3$hi = 0, i64toi32_i32$2 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         i64toi32_i32$0 = 0;
         i64toi32_i32$1 = 0;
         i64toi32_i32$1 = __wasm_i64_mul($1 | 0, i64toi32_i32$0 | 0, 80 | 0, i64toi32_i32$1 | 0) | 0;
         i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
         $3 = i64toi32_i32$1;
         $3$hi = i64toi32_i32$0;
         i64toi32_i32$2 = i64toi32_i32$1;
         i64toi32_i32$1 = 0;
         i64toi32_i32$3 = 32;
         i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
          i64toi32_i32$1 = 0;
          $10 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
         } else {
          i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
          $10 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
         }
         if ($10) {
          break label$7
         }
         i64toi32_i32$1 = $3$hi;
         $1 = $3;
         if (($1 | 0) < (0 | 0)) {
          break label$6
         }
         if ($2) {
          break label$5
         }
         if ($1) {
          break label$4
         }
         break label$2;
        }
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
       }
       alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
       abort();
      }
      if (!$1) {
       break label$2
      }
      $2 = __rust_alloc_zeroed($1 | 0, 8 | 0) | 0;
      if (!$2) {
       break label$3
      }
      break label$1;
     }
     $2 = __rust_alloc($1 | 0, 8 | 0) | 0;
     if ($2) {
      break label$1
     }
    }
    $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
    alloc__alloc__handle_alloc_error__he269d8f1bff90960($1 | 0, 8 | 0);
    abort();
   }
   $2 = 8;
  }
  HEAP32[$0 >> 2] = $2;
  HEAP32[($0 + 4 | 0) >> 2] = ($1 >>> 0) / (80 >>> 0) | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___allocate_in__hf8388cafa696b413($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $10 = 0, $3 = 0, $3$hi = 0, i64toi32_i32$2 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         i64toi32_i32$0 = 0;
         i64toi32_i32$1 = 0;
         i64toi32_i32$1 = __wasm_i64_mul($1 | 0, i64toi32_i32$0 | 0, 28 | 0, i64toi32_i32$1 | 0) | 0;
         i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
         $3 = i64toi32_i32$1;
         $3$hi = i64toi32_i32$0;
         i64toi32_i32$2 = i64toi32_i32$1;
         i64toi32_i32$1 = 0;
         i64toi32_i32$3 = 32;
         i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
         if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
          i64toi32_i32$1 = 0;
          $10 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
         } else {
          i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
          $10 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
         }
         if ($10) {
          break label$7
         }
         i64toi32_i32$1 = $3$hi;
         $1 = $3;
         if (($1 | 0) < (0 | 0)) {
          break label$6
         }
         if ($2) {
          break label$5
         }
         if ($1) {
          break label$4
         }
         break label$2;
        }
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
       }
       alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
       abort();
      }
      if (!$1) {
       break label$2
      }
      $2 = __rust_alloc_zeroed($1 | 0, 4 | 0) | 0;
      if (!$2) {
       break label$3
      }
      break label$1;
     }
     $2 = __rust_alloc($1 | 0, 4 | 0) | 0;
     if ($2) {
      break label$1
     }
    }
    $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
    alloc__alloc__handle_alloc_error__he269d8f1bff90960($1 | 0, 4 | 0);
    abort();
   }
   $2 = 4;
  }
  HEAP32[$0 >> 2] = $2;
  HEAP32[($0 + 4 | 0) >> 2] = ($1 >>> 0) / (28 >>> 0) | 0;
 }
 
 function cardano_serialization_lib__chain_crypto__derive__from_bip39_entropy__hf32cb3895f4a2aa4($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0;
  $5 = global$0 - 576 | 0;
  global$0 = $5;
  $5 = memset($5 | 0, 0 | 0, 96 | 0) | 0;
  cryptoxide__sha2__Sha512__new__h57eb1a61fae5dfc3($5 + 352 | 0 | 0);
  cryptoxide__hmac__Hmac_D___new__h10c18a5661f5ecf6($5 + 96 | 0 | 0, $5 + 352 | 0 | 0, $3 | 0, $4 | 0);
  cryptoxide__pbkdf2__pbkdf2__h6d76e9b9cb3d73c2($5 + 96 | 0 | 0, $1 | 0, $2 | 0, 4096 | 0, $5 | 0, 96 | 0);
  memcpy($5 + 352 | 0 | 0, $5 | 0, 96 | 0) | 0;
  ed25519_bip32__key__XPrv__normalize_bytes_force3rd__hc83616bc3d9dd3b6($0 | 0, $5 + 352 | 0 | 0);
  $0 = $5 + 320 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
  $0 = $5 + 332 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
  global$0 = $5 + 576 | 0;
 }
 
 function value_is_zero($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0, wasm2js_i32$2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h5db5149478ec5345($1 + 8 | 0 | 0, $0 | 0);
   $2 = 0;
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   label$2 : {
    $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    i64toi32_i32$0 = HEAP32[$3 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($3 + 4 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    if ((i64toi32_i32$2 | 0) != (0 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$0 | 0) | 0) {
     break label$2
    }
    $2 = (wasm2js_i32$0 = !(HEAP32[($3 + 20 | 0) >> 2] | 0), wasm2js_i32$1 = 2, wasm2js_i32$2 = (HEAP32[($3 + 8 | 0) >> 2] | 0 | 0) == (1 | 0), wasm2js_i32$2 ? wasm2js_i32$0 : wasm2js_i32$1);
    $2 = ($2 | 0) == (2 | 0) | ($2 & 1 | 0) | 0;
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   global$0 = $1 + 16 | 0;
   return $2 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function encode_arbitrary_bytes_as_metadatum($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  HEAP32[($2 + 72 | 0) >> 2] = $1;
  HEAP32[($2 + 68 | 0) >> 2] = $1;
  HEAP32[($2 + 64 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 64 | 0 | 0);
  $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__metadata__encode_arbitrary_bytes_as_metadatum__hff9e33a1e55fca03($2 + 16 | 0 | 0, $0 | 0, $1 | 0);
  $0 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($0 | 0) | 0;
  label$1 : {
   if (!$1) {
    break label$1
   }
   __rust_dealloc($0 | 0, $1 | 0, 1 | 0);
  }
  memcpy($2 + 64 | 0 | 0, $2 + 16 | 0 | 0, 48 | 0) | 0;
  $1 = $cardano_serialization_lib__metadata__TransactionMetadatum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hce2feba55b67d086($2 + 64 | 0 | 0) | 0;
  global$0 = $2 + 112 | 0;
  return $1 | 0;
 }
 
 function linearfee_new($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $4$hi = 0, $3 = 0, $4 = 0, $39$hi = 0, $10 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($2 | 0, $1 | 0);
   i64toi32_i32$2 = $3;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $4 = i64toi32_i32$0;
   $4$hi = i64toi32_i32$1;
   i64toi32_i32$2 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   $39$hi = i64toi32_i32$0;
   i64toi32_i32$0 = $4$hi;
   i64toi32_i32$0 = $39$hi;
   $10 = i64toi32_i32$1;
   i64toi32_i32$1 = $4$hi;
   $0 = $cardano_serialization_lib__fees__LinearFee_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h715b61d52c5c7394($10 | 0, i64toi32_i32$0 | 0, $4 | 0, i64toi32_i32$1 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionbuilder_get_native_input_scripts($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h37dfbd2f31d951c1($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__get_native_input_scripts__h533aaa6e57788da7($1 + 16 | 0 | 0, (HEAP32[($1 + 8 | 0) >> 2] | 0) + 96 | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   label$2 : {
    label$3 : {
     $0 = HEAP32[($1 + 16 | 0) >> 2] | 0;
     if ($0) {
      break label$3
     }
     $0 = 0;
     break label$2;
    }
    i64toi32_i32$1 = HEAP32[($1 + 24 | 0) >> 2] | 0;
    HEAP32[($1 + 36 | 0) >> 2] = HEAP32[($1 + 20 | 0) >> 2] | 0;
    HEAP32[($1 + 40 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($1 + 32 | 0) >> 2] = $0;
    $0 = $cardano_serialization_lib__NativeScripts_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hd952f91bbdbbead8($1 + 32 | 0 | 0) | 0;
   }
   global$0 = $1 + 48 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionbuilder_get_plutus_input_scripts($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h37dfbd2f31d951c1($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__get_plutus_input_scripts__h7e973282eea0f34a($1 + 16 | 0 | 0, (HEAP32[($1 + 8 | 0) >> 2] | 0) + 96 | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   label$2 : {
    label$3 : {
     $0 = HEAP32[($1 + 16 | 0) >> 2] | 0;
     if ($0) {
      break label$3
     }
     $0 = 0;
     break label$2;
    }
    i64toi32_i32$1 = HEAP32[($1 + 24 | 0) >> 2] | 0;
    HEAP32[($1 + 36 | 0) >> 2] = HEAP32[($1 + 20 | 0) >> 2] | 0;
    HEAP32[($1 + 40 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($1 + 32 | 0) >> 2] = $0;
    $0 = $cardano_serialization_lib__tx_builder__tx_inputs_builder__PlutusWitnesses_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8895bf7926c04f4f($1 + 32 | 0 | 0) | 0;
   }
   global$0 = $1 + 48 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___remove_entry__h831f61fb54926aec($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, i64toi32_i32$1 = 0;
  $3 = global$0 - 32 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$4) {
     break label$2
    }
    alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__h05f65203dc6f97ae($3 | 0, HEAP32[$1 >> 2] | 0 | 0, $4 | 0, $2 | 0);
    $2 = 0;
    label$3 : {
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$3
     }
     HEAP32[($3 + 24 | 0) >> 2] = HEAP32[($3 + 12 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($3 + 8 | 0) >> 2] | 0;
     HEAP32[($3 + 16 | 0) >> 2] = HEAP32[($3 + 4 | 0) >> 2] | 0;
     HEAP32[($3 + 20 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($3 + 28 | 0) >> 2] = $1;
     alloc__collections__btree__map__entry__OccupiedEntry_K_2cV___remove_kv__h6e6a6e92c8be056b($0 + 4 | 0 | 0, $3 + 16 | 0 | 0);
     $2 = 1;
    }
    HEAP32[$0 >> 2] = $2;
    break label$1;
   }
   HEAP32[$0 >> 2] = 0;
  }
  global$0 = $3 + 32 | 0;
 }
 
 function $cardano_serialization_lib__plutus__ExUnitPrices_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hb3338508b1a9ae00($0) {
  $0 = $0 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $1 = 0, $9 = 0, $14 = 0, $19 = 0, $22 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  i64toi32_i32$2 = $0 + 24 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $9 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 40 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $9;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $0 + 16 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 32 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $14;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $0 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 24 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $19;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $0;
  i64toi32_i32$1 = HEAP32[$0 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $22 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $22;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  label$1 : {
   $0 = __rust_alloc(40 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(40 | 0, 8 | 0);
   abort();
  }
  HEAP32[$0 >> 2] = 0;
  memcpy($0 + 4 | 0 | 0, $1 + 12 | 0 | 0, 36 | 0) | 0;
  global$0 = $1 + 48 | 0;
  return $0 | 0;
 }
 
 function exunits_new($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $4$hi = 0, $5$hi = 0, $3 = 0, $4 = 0, $40 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($2 | 0, $1 | 0);
   i64toi32_i32$2 = $3;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $4 = i64toi32_i32$0;
   $4$hi = i64toi32_i32$1;
   i64toi32_i32$2 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $5$hi = i64toi32_i32$0;
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   i64toi32_i32$0 = $4$hi;
   i64toi32_i32$0 = $5$hi;
   $40 = i64toi32_i32$1;
   i64toi32_i32$0 = $4$hi;
   i64toi32_i32$1 = $5$hi;
   $0 = $cardano_serialization_lib__plutus__ExUnits_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h4867c49ddc624134($4 | 0, i64toi32_i32$0 | 0, $40 | 0, i64toi32_i32$1 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function unitinterval_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h98bfbcc994df632c($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__UnitInterval__to_bytes__h9df20c16a600f727($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function transaction_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h70df86682e940485($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__Transaction__to_bytes__h3fc3ee53046075af($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function transactioninputs_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hf2abefb15e68f011($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__TransactionInputs__to_bytes__hd570da57611ad9c1($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function transactionoutputs_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h6185b44b866d43f0($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__TransactionOutputs__to_bytes__h71c3708b4ae29f22($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function certificates_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h0d8537c364f480d5($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__Certificates__to_bytes__h85d1a5d50f830822($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function transactionbody_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h356c30395cf13adb($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__TransactionBody__to_bytes__h03479aa95ace09cb($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function transactioninput_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hd7bc050864a8d646($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__TransactionInput__to_bytes__hc67ef454d348f684($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function transactionoutput_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h17af7d9d2d20aa0f($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__TransactionOutput__to_bytes__h39917cb4ac582524($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function stakeregistration_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h9f3eeaa31aede5c7($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__StakeRegistration__to_bytes__hc38bdcdcd6c2f24e($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function stakederegistration_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h415aed7c06a10866($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__StakeDeregistration__to_bytes__hc35fedbd4c7f4cd2($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function stakedelegation_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hfc784c950a3a2da2($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__StakeDelegation__to_bytes__h336a11b444c754e5($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function ed25519keyhashes_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h38787c785ea84973($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__Ed25519KeyHashes__to_bytes__h8a16b826e8a207d6($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function relays_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hdcd31189477e1360($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__Relays__to_bytes__hf7c1ddf28786d418($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function poolparams_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hc466bac66f8af18e($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__PoolParams__to_bytes__h3f5f15e73f68a0e0($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function poolregistration_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h78c51a186dbaf877($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__PoolRegistration__to_bytes__h8fe885d6b7b5e324($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function poolretirement_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h77d6f4a2273f50b5($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__PoolRetirement__to_bytes__h69dfd17fa6d8ec26($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function genesiskeydelegation_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h96a5bfd90503076d($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__GenesisKeyDelegation__to_bytes__h0b4d65632f035de9($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function moveinstantaneousrewardscert_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h0350daea3c8d0cce($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__MoveInstantaneousRewardsCert__to_bytes__hac4aaf2ebea8a123($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function certificate_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h3b62e22150831bdc($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__Certificate__to_bytes__hfc049ba855c56bb2($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function mirtostakecredentials_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h74054450d591b36f($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__MIRToStakeCredentials__to_bytes__hdbe8603d366668dc($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function moveinstantaneousreward_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h84b5bdabb1c1c80b($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__MoveInstantaneousReward__to_bytes__h4c0e3fd55594e560($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function ipv4_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h8e1034a64e070b53($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__Ipv4__to_bytes__h148c2ae3c924146c($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function ipv6_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h9606b27f8e88a40d($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__Ipv6__to_bytes__h608d664f8fb0476d($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function url_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hd2a6d676353c0b6c($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__URL__to_bytes__h139008b509d93c58($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function dnsrecordaoraaaa_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h1715449b8810f0c1($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__DNSRecordAorAAAA__to_bytes__hea531de37c5d48da($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function dnsrecordsrv_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h8aa27fc1f3f1159b($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__DNSRecordSRV__to_bytes__h80601c27a90b1551($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function singlehostaddr_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h7fe2cd68d7de412a($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__SingleHostAddr__to_bytes__h798fa7218db0c453($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function singlehostname_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hb0365aa08561904d($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__SingleHostName__to_bytes__hdbbe3c97d4e95860($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function multihostname_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__ha28b58697d2aa221($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__MultiHostName__to_bytes__ha4b24eb98359d25d($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function relay_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hb17ff77b9b324998($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__Relay__to_bytes__h5006319aa84b4c2c($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function poolmetadata_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h451504312a4b72d0($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__PoolMetadata__to_bytes__hc3ee30d77ef1dd1f($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function stakecredentials_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h99bd8393a0065b1d($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__StakeCredentials__to_bytes__hd74a84d639ebfe2a($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function rewardaddresses_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h18a4570cc8a3407a($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__RewardAddresses__to_bytes__h30e2feda80dac1c1($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function withdrawals_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h000099354d5ff519($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__Withdrawals__to_bytes__hc4107deca626561a($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function transactionwitnessset_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__he0885d10b4548804($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__TransactionWitnessSet__to_bytes__h3711bb2082c424f0($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function scriptpubkey_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h5bcc7e1da6f9ff93($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__ScriptPubkey__to_bytes__h52b71fff51f25275($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function scriptall_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hcc9e595588038ff3($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__ScriptAll__to_bytes__he5644ba95ff57d44($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function scriptany_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hc49defd7d95949da($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__ScriptAny__to_bytes__hab17863024842704($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function scriptnofk_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__he533e1773e537fcd($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__ScriptNOfK__to_bytes__h70f77eac2944ab8f($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function timelockstart_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h10da0fea03f0ac1d($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__TimelockStart__to_bytes__h36bcaaaa1f976a4a($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function timelockexpiry_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hd0c16785fb9ea7bd($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__TimelockExpiry__to_bytes__h29eb471aab61c2bc($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function nativescript_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h6ed0b6b043905434($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__NativeScript__to_bytes__hcf189ce9571cef2e($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function update_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h20ee1b39869b5e8f($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__Update__to_bytes__h72d5ee85321808c5($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function genesishashes_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h419753218ead1831($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__GenesisHashes__to_bytes__h827d775bd46a2964($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function scripthashes_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hca2e1c7f0251c418($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__ScriptHashes__to_bytes__he0e9f5150c313220($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function proposedprotocolparameterupdates_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h2d6285fb6a1d44f8($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__ProposedProtocolParameterUpdates__to_bytes__h9b4f42f191ec0d06($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function protocolversion_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h42c8face5b925abb($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__ProtocolVersion__to_bytes__h324d7d99a7cab8b1($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function protocolversions_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__ha45853a045a59ee7($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__ProtocolVersions__to_bytes__h07477e989b774f62($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function protocolparamupdate_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hd84cc8f720a3dada($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__ProtocolParamUpdate__to_bytes__hc1048d3d73304000($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function transactionbodies_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hfefec6c3ca92202d($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__TransactionBodies__to_bytes__h189d4c4984c313dd($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function transactionwitnesssets_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h0fe7af65622a319f($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__TransactionWitnessSets__to_bytes__h5b17d6ec436644b5($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function block_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hdd2a3d9c2413fc4e($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__Block__to_bytes__h60d66d271942e6ea($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function header_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h60ca34959655b0d6($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__Header__to_bytes__h389fdc932589ea6d($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function operationalcert_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h4b15d475a6cbc138($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__OperationalCert__to_bytes__h2714f634a9e19c45($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function headerbody_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h2ac16fcb64db16b5($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__HeaderBody__to_bytes__h9eb66f63562cbb2f($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function assetname_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h9c68abd5a6a78973($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__AssetName__to_bytes__h70fec91c0b019338($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function assetname_name($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h9c68abd5a6a78973($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function assetnames_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h38bb6325d5b407e9($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__AssetNames__to_bytes__hded76ea985a97c6d($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function assets_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h91e3d4f7af3d2ccd($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__Assets__to_bytes__h53030351e03948ee($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function multiasset_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h9968e42c55861cec($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__MultiAsset__to_bytes__h37389a4eb9c05123($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function mint_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h8348e40d8f63e5f1($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__Mint__to_bytes__hae180b99104de643($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function networkid_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h4f79d4afa0b85c1a($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__NetworkId__to_bytes__hbf6df6fc195f7ada($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function transactionoutputbuilder_next($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 272 | 0;
  global$0 = $1;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__hc81980191b5e557a($1 | 0, $0 | 0);
    $0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    cardano_serialization_lib__output_builder__TransactionOutputBuilder__next__h0f48f77be94ddfc5($1 + 8 | 0 | 0, HEAP32[$1 >> 2] | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    if ((HEAP32[($1 + 8 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    memcpy($1 + 144 | 0 | 0, $1 + 16 | 0 | 0, 128 | 0) | 0;
    $0 = $cardano_serialization_lib__output_builder__TransactionOutputAmountBuilder_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hafb771b944269b79($1 + 144 | 0 | 0) | 0;
    global$0 = $1 + 272 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($1 + 12 | 0) >> 2] | 0 | 0);
  abort();
 }
 
 function transactionoutputamountbuilder_build($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 272 | 0;
  global$0 = $1;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h1cb96e7b1dabbc55($1 | 0, $0 | 0);
    $0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    cardano_serialization_lib__output_builder__TransactionOutputAmountBuilder__build__he57d4fcb648faafd($1 + 8 | 0 | 0, HEAP32[$1 >> 2] | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    if ((HEAP32[($1 + 8 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    memcpy($1 + 144 | 0 | 0, $1 + 16 | 0 | 0, 128 | 0) | 0;
    $0 = $cardano_serialization_lib__TransactionOutput_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h4b9395cffb8a7c47($1 + 144 | 0 | 0) | 0;
    global$0 = $1 + 272 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($1 + 12 | 0) >> 2] | 0 | 0);
  abort();
 }
 
 function transactionunspentoutput_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hbebd755b3868aed3($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__utils__TransactionUnspentOutput__to_bytes__h7f3a90b5c6f7d805($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function bignum_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__utils__BigNum__to_bytes__he8f0322f5990eba0($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function bignum_from_str($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 8 | 0 | 0);
  $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  HEAP32[($2 + 28 | 0) >> 2] = $1;
  $0 = HEAP32[$2 >> 2] | 0;
  HEAP32[($2 + 24 | 0) >> 2] = $0;
  cardano_serialization_lib__utils__BigNum__from_str__h35d4d8383c8139e0($2 + 8 | 0 | 0, $0 | 0, $1 | 0);
  core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0($2 + 24 | 0 | 0);
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
   abort();
  }
  i64toi32_i32$2 = $2 + 16 | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $1 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810(HEAP32[i64toi32_i32$2 >> 2] | 0 | 0, i64toi32_i32$1 | 0) | 0;
  global$0 = $2 + 32 | 0;
  return $1 | 0;
 }
 
 function value_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h5db5149478ec5345($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__utils__Value__to_bytes__h2820e7e1b4035910($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function int_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h8f4f32b29a620a40($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__utils__Int__to_bytes__hbe8e1a87c2e0df42($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function bigint_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hb4a7701b5bc2a87c($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__utils__BigInt__to_bytes__h27caedab347e4c69($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function metadatamap_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h74f2437fd791f127($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__metadata__MetadataMap__to_bytes__h3333dbf6e1c657eb($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function metadatalist_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h14eb25306bbe3311($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__metadata__MetadataList__to_bytes__h4fde069daead55c0($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function transactionmetadatum_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hc630c86c4ab6b26d($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__metadata__TransactionMetadatum__to_bytes__h71c4a73ff0ebaa5f($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function transactionmetadatum_as_map($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 96 | 0;
  global$0 = $1;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__hc630c86c4ab6b26d($1 | 0, $0 | 0);
    $0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    cardano_serialization_lib__metadata__TransactionMetadatum__as_map__h93c64120b048faea($1 + 8 | 0 | 0, HEAP32[$1 >> 2] | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    if ((HEAP32[($1 + 8 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    memcpy($1 + 56 | 0 | 0, $1 + 16 | 0 | 0, 40 | 0) | 0;
    $0 = $cardano_serialization_lib__metadata__MetadataMap_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hf2098e6c815f1680($1 + 56 | 0 | 0) | 0;
    global$0 = $1 + 96 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($1 + 12 | 0) >> 2] | 0 | 0);
  abort();
 }
 
 function transactionmetadatumlabels_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h0497bf4a59b2a68b($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__metadata__TransactionMetadatumLabels__to_bytes__h9a2fd336532078dc($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function generaltransactionmetadata_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h670b86b1bfb2242f($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__metadata__GeneralTransactionMetadata__to_bytes__h714c66bad4d9e4ed($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function auxiliarydata_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hdd9a557acdd7acfa($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__metadata__AuxiliaryData__to_bytes__hfa2015a3201786ee($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function cardano_serialization_lib__impl_mockchain__key__EitherEd25519SecretKey__sign__h2fa85cbd16bdcfda($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $5 = 0, $4 = 0;
  $3 = global$0 - 176 | 0;
  global$0 = $3;
  $4 = HEAPU8[$1 >> 0] | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $2 | 0);
  $1 = $1 + 1 | 0;
  $2 = HEAP32[($3 + 12 | 0) >> 2] | 0;
  $5 = HEAP32[($3 + 8 | 0) >> 2] | 0;
  label$1 : {
   label$2 : {
    if (($4 | 0) == (1 | 0)) {
     break label$2
    }
    cryptoxide__ed25519__signature_extended__h26f216ae968c9eed($0 | 0, $5 | 0, $2 | 0, $1 | 0);
    break label$1;
   }
   cryptoxide__ed25519__keypair__h6b6b782bee48c38f($3 + 80 | 0 | 0, $1 | 0);
   memcpy($3 + 16 | 0 | 0, $3 + 80 | 0 | 0, 64 | 0) | 0;
   cryptoxide__ed25519__signature__hfac93186ff640827($0 | 0, $5 | 0, $2 | 0, $3 + 16 | 0 | 0);
  }
  global$0 = $3 + 176 | 0;
 }
 
 function transactionbuilderconfigbuilder_build($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 208 | 0;
  global$0 = $1;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h274f52f9a26a0dc8($1 | 0, $0 | 0);
    $0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    cardano_serialization_lib__tx_builder__TransactionBuilderConfigBuilder__build__he456ef6d8d7b112e($1 + 8 | 0 | 0, HEAP32[$1 >> 2] | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    if ((HEAP32[($1 + 8 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    memcpy($1 + 112 | 0 | 0, $1 + 16 | 0 | 0, 96 | 0) | 0;
    $0 = $cardano_serialization_lib__tx_builder__TransactionBuilderConfig_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h865ebc731340693e($1 + 112 | 0 | 0) | 0;
    global$0 = $1 + 208 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($1 + 12 | 0) >> 2] | 0 | 0);
  abort();
 }
 
 function transactionbuilder_build($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 560 | 0;
  global$0 = $1;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h37dfbd2f31d951c1($1 | 0, $0 | 0);
    $0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    cardano_serialization_lib__tx_builder__TransactionBuilder__build__h1126ee00e4941d94($1 + 8 | 0 | 0, HEAP32[$1 >> 2] | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    if ((HEAP32[($1 + 8 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    memcpy($1 + 288 | 0 | 0, $1 + 16 | 0 | 0, 272 | 0) | 0;
    $0 = $cardano_serialization_lib__TransactionBody_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h5f9023ed5f5fb82c($1 + 288 | 0 | 0) | 0;
    global$0 = $1 + 560 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($1 + 12 | 0) >> 2] | 0 | 0);
  abort();
 }
 
 function transactionbuilder_build_tx($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 864 | 0;
  global$0 = $1;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h37dfbd2f31d951c1($1 | 0, $0 | 0);
    $0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    cardano_serialization_lib__tx_builder__TransactionBuilder__build_tx__h70ea5d3a852f88d4($1 + 8 | 0 | 0, HEAP32[$1 >> 2] | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    if ((HEAP32[($1 + 8 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    memcpy($1 + 440 | 0 | 0, $1 + 16 | 0 | 0, 424 | 0) | 0;
    $0 = $cardano_serialization_lib__Transaction_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hf1e81f974efa699a($1 + 440 | 0 | 0) | 0;
    global$0 = $1 + 864 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($1 + 12 | 0) >> 2] | 0 | 0);
  abort();
 }
 
 function transactionbuilder_build_tx_unsafe($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 864 | 0;
  global$0 = $1;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h37dfbd2f31d951c1($1 | 0, $0 | 0);
    $0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    cardano_serialization_lib__tx_builder__TransactionBuilder__build_tx_unsafe__hd84bd9af0364abde($1 + 8 | 0 | 0, HEAP32[$1 >> 2] | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    if ((HEAP32[($1 + 8 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    memcpy($1 + 440 | 0 | 0, $1 + 16 | 0 | 0, 424 | 0) | 0;
    $0 = $cardano_serialization_lib__Transaction_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hf1e81f974efa699a($1 + 440 | 0 | 0) | 0;
    global$0 = $1 + 864 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($1 + 12 | 0) >> 2] | 0 | 0);
  abort();
 }
 
 function bip32privatekey_to_128_xprv($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h30021c0122a7c8e6($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__crypto__Bip32PrivateKey__to_128_xprv__he72d886a3f7cebc8($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function bip32privatekey_chaincode($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h30021c0122a7c8e6($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__crypto__Bip32PrivateKey__chaincode__h32cbffafab5e64aa($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function bip32publickey_chaincode($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hcfcf2a638924fc64($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__crypto__Bip32PublicKey__chaincode__h7bf6aed92ab50cb8($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function privatekey_as_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h09a25d0fa720925e($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__crypto__PrivateKey__as_bytes__ha195925edbe0b49d($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function vkey_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h38603c546ca761f2($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__crypto__Vkey__to_bytes__h6b2510585c6bda80($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function vkeywitness_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h9c2d3a72ebf4d25f($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__crypto__Vkeywitness__to_bytes__h3ecaa54a159a7f68($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function bootstrapwitness_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h76a11b605f70ebd5($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__crypto__BootstrapWitness__to_bytes__hbab231c2f97d497f($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function bootstrapwitness_chain_code($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h76a11b605f70ebd5($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function kessignature_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h84d192b5a1b597ea($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function nonce_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h0e158f5408360d02($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__crypto__Nonce__to_bytes__h4ae263ae7fba54e3($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function vrfcert_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h1a6acf099b73960c($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__crypto__VRFCert__to_bytes__hf92f71ef8605e2ea($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function vrfcert_output($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h1a6acf099b73960c($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function stakecredential_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h7d8a0640f2deb41e($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__address__StakeCredential__to_bytes__h1e8f5a9dedbab360($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function byronaddress_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h76f3e067f9139bb4($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__address__ByronAddress__to_bytes__h95edb62bc4a38025($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function byronaddress_attributes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h76f3e067f9139bb4($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__address__ByronAddress__attributes__hedb23cddc1880465($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function address_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hab2c0cbdcb539b91($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__address__Address__to_bytes__h301d351bd02ea9f1($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function $cardano_serialization_lib__plutus__PlutusDataEnum_20as_20cbor_event__se__Serialize___serialize__h80243bb681b5b257($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    switch (HEAP32[$1 >> 2] | 0 | 0) {
    default:
     $cardano_serialization_lib__plutus__ConstrPlutusData_20as_20cbor_event__se__Serialize___serialize__h1577784212376b9e($0 | 0, $1 + 8 | 0 | 0, $2 | 0);
     break label$1;
    case 1:
     $cardano_serialization_lib__plutus__PlutusMap_20as_20cbor_event__se__Serialize___serialize__h43e688f33521e457($0 | 0, $1 + 4 | 0 | 0, $2 | 0);
     break label$1;
    case 2:
     $cardano_serialization_lib__plutus__PlutusList_20as_20cbor_event__se__Serialize___serialize__h4fb04398ef3c9f58($0 | 0, $1 + 4 | 0 | 0, $2 | 0);
     break label$1;
    case 3:
     $cardano_serialization_lib__utils__BigInt_20as_20cbor_event__se__Serialize___serialize__hd7ec7393d73149ff($0 | 0, $1 + 4 | 0 | 0, $2 | 0);
     break label$1;
    case 4:
     break label$2;
    };
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $1 + 4 | 0 | 0);
   cardano_serialization_lib__utils__write_bounded_bytes__h9cfd6d74fa4c49a9($0 | 0, $2 | 0, HEAP32[($3 + 8 | 0) >> 2] | 0 | 0, HEAP32[($3 + 12 | 0) >> 2] | 0 | 0);
  }
  global$0 = $3 + 16 | 0;
 }
 
 function plutusscript_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hf3651990986a0e62($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__plutus__PlutusScript__to_bytes__h4adacfd5fc205b4c($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function plutusscript_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hf3651990986a0e62($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function plutusscripts_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hbb8371c94476a171($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__plutus__PlutusScripts__to_bytes__hba3de06a31d540f0($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function constrplutusdata_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h2f574964f7dad662($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__plutus__ConstrPlutusData__to_bytes__h9d9c05e1eee49b9d($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function costmodel_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h63771635114e9ad4($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__plutus__CostModel__to_bytes__h24a2e606b34519d6($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function costmdls_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h0e53d0166415c79c($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__plutus__Costmdls__to_bytes__h89ce5b6a343e5d35($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function exunitprices_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h0a3b5f1cc5dc7523($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__plutus__ExUnitPrices__to_bytes__hedf1008b0af8a3a6($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function exunits_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h1f4aa39af4dc2942($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__plutus__ExUnits__to_bytes__hb014ea1e403fd35b($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function plutusmap_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hc838c9a2ed8b7fab($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__plutus__PlutusMap__to_bytes__h20d006e99276c59e($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function plutusdata_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hb1fd14a6870cafe2($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__plutus__PlutusData__to_bytes__h3eb50f620e6d8905($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function plutuslist_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hd98e995abd746618($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__plutus__PlutusList__to_bytes__h13c74980ee8c70aa($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function redeemer_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h388263144730eb6a($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__plutus__Redeemer__to_bytes__hc8fe4986b772e208($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function redeemertag_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h8eb054d444413163($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__plutus__RedeemerTag__to_bytes__h1ed886466625aa33($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function redeemers_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $30 = 0, $36 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h6789b4b005d0c63f($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__plutus__Redeemers__to_bytes__hc16c7b4820f3e155($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $30;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $36 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $36;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend_T_2cI____spec_extend__he2a686a36d571fcb($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $5 = 0, $4 = 0;
  label$1 : {
   $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   $4 = $2 - $1 | 0;
   $5 = $4 >>> 0 > $2 >>> 0 ? 0 : $4;
   if (((HEAP32[($0 + 4 | 0) >> 2] | 0) - $3 | 0) >>> 0 >= $5 >>> 0) {
    break label$1
   }
   alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h7b0a2c1df92d7167($0 | 0, $3 | 0, $5 | 0);
   $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  }
  label$2 : {
   if ($2 >>> 0 <= $1 >>> 0) {
    break label$2
   }
   $5 = (HEAP32[$0 >> 2] | 0) + ($3 << 2 | 0) | 0;
   label$3 : while (1) {
    HEAP32[$5 >> 2] = $1;
    $5 = $5 + 4 | 0;
    $1 = $1 + 1 | 0;
    if (($2 | 0) != ($1 | 0)) {
     continue label$3
    }
    break label$3;
   };
   $3 = $4 + $3 | 0;
  }
  HEAP32[($0 + 8 | 0) >> 2] = $3;
 }
 
 function core__ptr__drop_in_place_serde_json__error__Error___h2dc4889d765400ee($0) {
  $0 = $0 | 0;
  var $2 = 0, $1 = 0, $3 = 0, $4 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     $1 = HEAP32[$0 >> 2] | 0;
     switch (HEAP32[$1 >> 2] | 0 | 0) {
     case 1:
      break label$2;
     case 0:
      break label$3;
     default:
      break label$1;
     };
    }
    $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    if (!$2) {
     break label$1
    }
    __rust_dealloc(HEAP32[($1 + 4 | 0) >> 2] | 0 | 0, $2 | 0, 1 | 0);
    break label$1;
   }
   if ((HEAPU8[($1 + 4 | 0) >> 0] | 0 | 0) != (3 | 0)) {
    break label$1
   }
   $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   FUNCTION_TABLE[HEAP32[(HEAP32[($2 + 4 | 0) >> 2] | 0) >> 2] | 0 | 0](HEAP32[$2 >> 2] | 0);
   label$4 : {
    $3 = HEAP32[($2 + 4 | 0) >> 2] | 0;
    $4 = HEAP32[($3 + 4 | 0) >> 2] | 0;
    if (!$4) {
     break label$4
    }
    __rust_dealloc(HEAP32[$2 >> 2] | 0 | 0, $4 | 0, HEAP32[($3 + 8 | 0) >> 2] | 0 | 0);
   }
   __rust_dealloc(HEAP32[($1 + 8 | 0) >> 2] | 0 | 0, 12 | 0, 4 | 0);
  }
  __rust_dealloc(HEAP32[$0 >> 2] | 0 | 0, 20 | 0, 4 | 0);
 }
 
 function serde_json__read__SliceRead__position_of_index__ha8a2610e8c8fa0b4($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, $5 = 0;
  label$1 : {
   label$2 : {
    $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if ($3 >>> 0 < $2 >>> 0) {
     break label$2
    }
    label$3 : {
     if ($2) {
      break label$3
     }
     $3 = 1;
     $4 = 0;
     break label$1;
    }
    $1 = HEAP32[$1 >> 2] | 0;
    $3 = 1;
    $4 = 0;
    label$4 : while (1) {
     $5 = (HEAPU8[$1 >> 0] | 0 | 0) == (10 | 0);
     $4 = $5 ? 0 : $4 + 1 | 0;
     $1 = $1 + 1 | 0;
     $3 = $3 + $5 | 0;
     $2 = $2 + -1 | 0;
     if ($2) {
      continue label$4
     }
     break label$1;
    };
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($2 | 0, $3 | 0, 1087588 | 0);
   abort();
  }
  HEAP32[($0 + 4 | 0) >> 2] = $4;
  HEAP32[$0 >> 2] = $3;
 }
 
 function __multi3($0, $1, $1$hi, $2, $2$hi, $3, $3$hi, $4, $4$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $1$hi = $1$hi | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  $4 = $4 | 0;
  $4$hi = $4$hi | 0;
  var i64toi32_i32$4 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$5 = 0, $5$hi = 0, $6$hi = 0, $5 = 0, $6 = 0, $8$hi = 0, $9$hi = 0, $7$hi = 0, $56 = 0, $8 = 0, $57 = 0, $9 = 0, $58 = 0, $10$hi = 0, $60 = 0, $61 = 0, $11 = 0, $7 = 0, $19 = 0, $19$hi = 0, $25 = 0, $25$hi = 0, $26 = 0, $26$hi = 0, $30 = 0, $30$hi = 0, $33$hi = 0, $10 = 0, $36 = 0, $39 = 0, $39$hi = 0, $42 = 0, $42$hi = 0, $45 = 0, $45$hi = 0, $46$hi = 0, $47 = 0, $47$hi = 0, $50 = 0, $52 = 0, $52$hi = 0, $54$hi = 0, $55 = 0, $55$hi = 0, $56$hi = 0, $59 = 0, $60$hi = 0;
  $11 = $0;
  i64toi32_i32$0 = $3$hi;
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = -1;
  i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
  $5 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
  $5$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $1$hi;
  i64toi32_i32$0 = $1;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = -1;
  i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
  $6 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
  $6$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $5$hi;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$0 = __wasm_i64_mul($5 | 0, i64toi32_i32$2 | 0, $6 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$2 = i64toi32_i32$HIGH_BITS;
  $7 = i64toi32_i32$0;
  $7$hi = i64toi32_i32$2;
  $19 = i64toi32_i32$0;
  $19$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $3$hi;
  i64toi32_i32$1 = $3;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $56 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
   $56 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
  }
  $8 = $56;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$1 = __wasm_i64_mul($8 | 0, i64toi32_i32$0 | 0, $6 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $6 = i64toi32_i32$1;
  $6$hi = i64toi32_i32$0;
  $25 = i64toi32_i32$1;
  $25$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $5$hi;
  $26 = $5;
  $26$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $1$hi;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $57 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $57 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  $9 = $57;
  $9$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $26$hi;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$2 = __wasm_i64_mul($26 | 0, i64toi32_i32$1 | 0, $9 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $30 = i64toi32_i32$2;
  $30$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $25$hi;
  i64toi32_i32$0 = $25;
  i64toi32_i32$2 = $30$hi;
  i64toi32_i32$3 = $30;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $5 = i64toi32_i32$4;
  $5$hi = i64toi32_i32$5;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$2 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$2 | 0;
   $58 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$2 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$2 | 0) | 0) | 0 | (i64toi32_i32$5 << i64toi32_i32$2 | 0) | 0;
   $58 = i64toi32_i32$1 << i64toi32_i32$2 | 0;
  }
  $33$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $19$hi;
  i64toi32_i32$5 = $19;
  i64toi32_i32$1 = $33$hi;
  i64toi32_i32$3 = $58;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $10 = i64toi32_i32$2;
  $10$hi = i64toi32_i32$4;
  i64toi32_i32$5 = $11;
  HEAP32[i64toi32_i32$5 >> 2] = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$4;
  $36 = $0;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$4 = $8$hi;
  i64toi32_i32$5 = $9$hi;
  i64toi32_i32$5 = __wasm_i64_mul($8 | 0, i64toi32_i32$4 | 0, $9 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $39 = i64toi32_i32$5;
  $39$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $4$hi;
  i64toi32_i32$4 = $1$hi;
  i64toi32_i32$4 = $4$hi;
  i64toi32_i32$5 = $1$hi;
  i64toi32_i32$5 = __wasm_i64_mul($4 | 0, i64toi32_i32$4 | 0, $1 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $42 = i64toi32_i32$5;
  $42$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $3$hi;
  i64toi32_i32$4 = $2$hi;
  i64toi32_i32$4 = $3$hi;
  i64toi32_i32$5 = $2$hi;
  i64toi32_i32$5 = __wasm_i64_mul($3 | 0, i64toi32_i32$4 | 0, $2 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $45 = i64toi32_i32$5;
  $45$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $42$hi;
  i64toi32_i32$0 = $42;
  i64toi32_i32$5 = $45$hi;
  i64toi32_i32$3 = $45;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $46$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $39$hi;
  i64toi32_i32$4 = $39;
  i64toi32_i32$0 = $46$hi;
  i64toi32_i32$3 = i64toi32_i32$1;
  i64toi32_i32$5 = i64toi32_i32$4 + i64toi32_i32$1 | 0;
  i64toi32_i32$1 = i64toi32_i32$2 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  $47 = i64toi32_i32$5;
  $47$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $5$hi;
  i64toi32_i32$1 = $6$hi;
  i64toi32_i32$1 = $5$hi;
  i64toi32_i32$2 = $5;
  i64toi32_i32$4 = $6$hi;
  i64toi32_i32$3 = $6;
  $50 = i64toi32_i32$1 >>> 0 < i64toi32_i32$4 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$4 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = $50;
  i64toi32_i32$1 = 0;
  i64toi32_i32$4 = 32;
  i64toi32_i32$0 = i64toi32_i32$4 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$4 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$3 << i64toi32_i32$0 | 0;
   $60 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$0 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$0 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$0 | 0) | 0;
   $60 = i64toi32_i32$3 << i64toi32_i32$0 | 0;
  }
  $52 = $60;
  $52$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $5$hi;
  i64toi32_i32$2 = $5;
  i64toi32_i32$3 = 0;
  i64toi32_i32$4 = 32;
  i64toi32_i32$0 = i64toi32_i32$4 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$4 & 63 | 0) >>> 0) {
   i64toi32_i32$3 = 0;
   $61 = i64toi32_i32$1 >>> i64toi32_i32$0 | 0;
  } else {
   i64toi32_i32$3 = i64toi32_i32$1 >>> i64toi32_i32$0 | 0;
   $61 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$0 | 0) | 0;
  }
  $54$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $52$hi;
  i64toi32_i32$1 = $52;
  i64toi32_i32$2 = $54$hi;
  i64toi32_i32$4 = $61;
  i64toi32_i32$2 = i64toi32_i32$3 | i64toi32_i32$2 | 0;
  $55 = i64toi32_i32$1 | i64toi32_i32$4 | 0;
  $55$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $47$hi;
  i64toi32_i32$3 = $47;
  i64toi32_i32$1 = $55$hi;
  i64toi32_i32$4 = $55;
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$4 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$4 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $56$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$5 = $7$hi;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$2 = $10;
  i64toi32_i32$3 = $7$hi;
  i64toi32_i32$4 = $7;
  $59 = i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0 | ((i64toi32_i32$5 | 0) == (i64toi32_i32$3 | 0) & i64toi32_i32$2 >>> 0 < i64toi32_i32$4 >>> 0 | 0) | 0;
  i64toi32_i32$2 = 0;
  $60$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $56$hi;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$5 = $60$hi;
  i64toi32_i32$3 = $59;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  i64toi32_i32$4 = $36;
  HEAP32[(i64toi32_i32$4 + 8 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$4 + 12 | 0) >> 2] = i64toi32_i32$0;
 }
 
 function alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__h5ebcf0b358f8c8ee($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $5 = 0, $6 = 0, $4 = 0;
  $4 = 0;
  $5 = HEAPU16[($2 + 138 | 0) >> 1] | 0;
  $6 = $5 ? 0 : $5;
  label$1 : {
   if ($5) {
    break label$1
   }
   label$2 : while (1) {
    label$3 : {
     if ($1) {
      break label$3
     }
     $4 = 1;
     $1 = 0;
     break label$1;
    }
    $1 = $1 + -1 | 0;
    $2 = HEAP32[(($2 + ($6 << 2 | 0) | 0) + 140 | 0) >> 2] | 0;
    $5 = HEAPU16[($2 + 138 | 0) >> 1] | 0;
    $6 = $5 ? 0 : $5;
    if (!$5) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[$0 >> 2] = $4;
  HEAP32[($0 + 12 | 0) >> 2] = $6;
  HEAP32[($0 + 8 | 0) >> 2] = $2;
 }
 
 function alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__ha66650412de8b037($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $5 = 0, $6 = 0, $4 = 0;
  $4 = 0;
  $5 = HEAPU16[($2 + 138 | 0) >> 1] | 0;
  $6 = $5 ? 0 : $5;
  label$1 : {
   if ($5) {
    break label$1
   }
   label$2 : while (1) {
    label$3 : {
     if ($1) {
      break label$3
     }
     $4 = 1;
     $1 = 0;
     break label$1;
    }
    $1 = $1 + -1 | 0;
    $2 = HEAP32[(($2 + ($6 << 2 | 0) | 0) + 140 | 0) >> 2] | 0;
    $5 = HEAPU16[($2 + 138 | 0) >> 1] | 0;
    $6 = $5 ? 0 : $5;
    if (!$5) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[$0 >> 2] = $4;
  HEAP32[($0 + 12 | 0) >> 2] = $6;
  HEAP32[($0 + 8 | 0) >> 2] = $2;
 }
 
 function transactionbody_inputs($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h356c30395cf13adb($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hfe677107e1954f8f($1 + 16 | 0 | 0, (HEAP32[($1 + 8 | 0) >> 2] | 0) + 128 | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($1 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($1 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  HEAP32[($1 + 32 | 0) >> 2] = HEAP32[($1 + 16 | 0) >> 2] | 0;
  HEAP32[($1 + 36 | 0) >> 2] = i64toi32_i32$1;
  $0 = $cardano_serialization_lib__TransactionInputs_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__haa89884e18e43552($1 + 32 | 0 | 0) | 0;
  global$0 = $1 + 48 | 0;
  return $0 | 0;
 }
 
 function transactionbody_outputs($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h356c30395cf13adb($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h699bb0f3db607312($1 + 16 | 0 | 0, (HEAP32[($1 + 8 | 0) >> 2] | 0) + 140 | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($1 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($1 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  HEAP32[($1 + 32 | 0) >> 2] = HEAP32[($1 + 16 | 0) >> 2] | 0;
  HEAP32[($1 + 36 | 0) >> 2] = i64toi32_i32$1;
  $0 = $cardano_serialization_lib__TransactionOutputs_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8e1ecfa37411bb92($1 + 32 | 0 | 0) | 0;
  global$0 = $1 + 48 | 0;
  return $0 | 0;
 }
 
 function poolparams_pool_owners($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hc466bac66f8af18e($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h25db889dc58a550d($1 + 16 | 0 | 0, (HEAP32[($1 + 8 | 0) >> 2] | 0) + 32 | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($1 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($1 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  HEAP32[($1 + 32 | 0) >> 2] = HEAP32[($1 + 16 | 0) >> 2] | 0;
  HEAP32[($1 + 36 | 0) >> 2] = i64toi32_i32$1;
  $0 = $cardano_serialization_lib__Ed25519KeyHashes_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h2ef8a4685b78a9d8($1 + 32 | 0 | 0) | 0;
  global$0 = $1 + 48 | 0;
  return $0 | 0;
 }
 
 function poolparams_relays($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hc466bac66f8af18e($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h3d33b90cd2011dc4($1 + 16 | 0 | 0, (HEAP32[($1 + 8 | 0) >> 2] | 0) + 44 | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($1 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($1 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  HEAP32[($1 + 32 | 0) >> 2] = HEAP32[($1 + 16 | 0) >> 2] | 0;
  HEAP32[($1 + 36 | 0) >> 2] = i64toi32_i32$1;
  $0 = $cardano_serialization_lib__Relays_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hf76c9eea02151e5d($1 + 32 | 0 | 0) | 0;
  global$0 = $1 + 48 | 0;
  return $0 | 0;
 }
 
 function cardano_serialization_lib__StakeCredentials__get__hc1a49e487d0bcf79($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $11 = 0, $12 = 0, $13 = 0, $14 = 0, $15 = 0, $16 = 0, $3 = 0, $4 = 0, $25 = 0, $30 = 0, $35 = 0;
  $3 = global$0 - 32 | 0;
  global$0 = $3;
  label$1 : {
   $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   if ($4 >>> 0 > $2 >>> 0) {
    break label$1
   }
   core__panicking__panic_bounds_check__h808b524af17640b1($2 | 0, $4 | 0, 1053828 | 0);
   abort();
  }
  $2 = (HEAP32[$1 >> 2] | 0) + Math_imul($2, 29) | 0;
  HEAP8[$0 >> 0] = HEAPU8[$2 >> 0] | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAPU8[($2 + 1 | 0) >> 0] | 0 | ((HEAPU8[($2 + 2 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 3 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 4 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[($2 + 5 | 0) >> 0] | 0 | ((HEAPU8[($2 + 6 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($2 + 7 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($2 + 8 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $25 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  $11 = $25;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 8 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 9 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $30 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 9 | 0;
  $12 = $30;
  HEAP8[i64toi32_i32$1 >> 0] = $12;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $2 + 17 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $35 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 17 | 0;
  $13 = $35;
  HEAP8[i64toi32_i32$0 >> 0] = $13;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $14 = $2 + 25 | 0;
  $15 = $0 + 25 | 0;
  $16 = HEAPU8[$14 >> 0] | 0 | ((HEAPU8[($14 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($14 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($14 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  HEAP8[$15 >> 0] = $16;
  HEAP8[($15 + 1 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[($15 + 2 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[($15 + 3 | 0) >> 0] = $16 >>> 24 | 0;
  global$0 = $3 + 32 | 0;
 }
 
 function auxiliarydataset_get($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0;
  $2 = global$0 - 144 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h786c2d78691f35ff($2 | 0, $0 | 0);
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__AuxiliaryDataSet__get__h06d3a8c795ea3669($2 + 8 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, $1 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   $0 = 0;
   label$2 : {
    i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    if ((i64toi32_i32$2 | 0) != (1 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$0 | 0) | 0) {
     break label$2
    }
    memcpy($2 + 80 | 0 | 0, $2 + 16 | 0 | 0, 64 | 0) | 0;
    $0 = $cardano_serialization_lib__metadata__AuxiliaryData_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h48191cd5277961b5($2 + 80 | 0 | 0) | 0;
   }
   global$0 = $2 + 144 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function block_transaction_bodies($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hdd2a3d9c2413fc4e($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h81140d58f8f9ef39($1 + 16 | 0 | 0, (HEAP32[($1 + 8 | 0) >> 2] | 0) + 368 | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($1 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($1 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  HEAP32[($1 + 32 | 0) >> 2] = HEAP32[($1 + 16 | 0) >> 2] | 0;
  HEAP32[($1 + 36 | 0) >> 2] = i64toi32_i32$1;
  $0 = $cardano_serialization_lib__TransactionBodies_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h13219c098e12494e($1 + 32 | 0 | 0) | 0;
  global$0 = $1 + 48 | 0;
  return $0 | 0;
 }
 
 function block_transaction_witness_sets($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hdd2a3d9c2413fc4e($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hb198082190ccba71($1 + 16 | 0 | 0, (HEAP32[($1 + 8 | 0) >> 2] | 0) + 380 | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($1 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($1 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  HEAP32[($1 + 32 | 0) >> 2] = HEAP32[($1 + 16 | 0) >> 2] | 0;
  HEAP32[($1 + 36 | 0) >> 2] = i64toi32_i32$1;
  $0 = $cardano_serialization_lib__TransactionWitnessSets_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h7db91b5cba584e3a($1 + 32 | 0 | 0) | 0;
  global$0 = $1 + 48 | 0;
  return $0 | 0;
 }
 
 function header_body_signature($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h60ca34959655b0d6($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($1 + 16 | 0 | 0, (HEAP32[($1 + 8 | 0) >> 2] | 0) + 312 | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($1 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($1 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  HEAP32[($1 + 32 | 0) >> 2] = HEAP32[($1 + 16 | 0) >> 2] | 0;
  HEAP32[($1 + 36 | 0) >> 2] = i64toi32_i32$1;
  $0 = $cardano_serialization_lib__crypto__KESSignature_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he0b1c3c8b6958e2e($1 + 32 | 0 | 0) | 0;
  global$0 = $1 + 48 | 0;
  return $0 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___allocate_in__h21c363c09c6b25b7($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         if (($1 & 536870911 | 0 | 0) != ($1 | 0)) {
          break label$7
         }
         $1 = $1 << 3 | 0;
         if (($1 | 0) < (0 | 0)) {
          break label$6
         }
         if ($2) {
          break label$5
         }
         if ($1) {
          break label$4
         }
         break label$2;
        }
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
       }
       alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
       abort();
      }
      if (!$1) {
       break label$2
      }
      $2 = __rust_alloc_zeroed($1 | 0, 8 | 0) | 0;
      if (!$2) {
       break label$3
      }
      break label$1;
     }
     $2 = __rust_alloc($1 | 0, 8 | 0) | 0;
     if ($2) {
      break label$1
     }
    }
    $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
    alloc__alloc__handle_alloc_error__he269d8f1bff90960($1 | 0, 8 | 0);
    abort();
   }
   $2 = 8;
  }
  HEAP32[$0 >> 2] = $2;
  HEAP32[($0 + 4 | 0) >> 2] = $1 >>> 3 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___allocate_in__h404b2b8ae2314e41($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         if (($1 & 268435455 | 0 | 0) != ($1 | 0)) {
          break label$7
         }
         $1 = $1 << 4 | 0;
         if (($1 | 0) < (0 | 0)) {
          break label$6
         }
         if ($2) {
          break label$5
         }
         if ($1) {
          break label$4
         }
         break label$2;
        }
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
       }
       alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
       abort();
      }
      if (!$1) {
       break label$2
      }
      $2 = __rust_alloc_zeroed($1 | 0, 8 | 0) | 0;
      if (!$2) {
       break label$3
      }
      break label$1;
     }
     $2 = __rust_alloc($1 | 0, 8 | 0) | 0;
     if ($2) {
      break label$1
     }
    }
    $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
    alloc__alloc__handle_alloc_error__he269d8f1bff90960($1 | 0, 8 | 0);
    abort();
   }
   $2 = 8;
  }
  HEAP32[$0 >> 2] = $2;
  HEAP32[($0 + 4 | 0) >> 2] = $1 >>> 4 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___allocate_in__h59f4452607d575ba($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         if (($1 & 536870911 | 0 | 0) != ($1 | 0)) {
          break label$7
         }
         $1 = $1 << 3 | 0;
         if (($1 | 0) < (0 | 0)) {
          break label$6
         }
         if ($2) {
          break label$5
         }
         if ($1) {
          break label$4
         }
         break label$2;
        }
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
       }
       alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
       abort();
      }
      if (!$1) {
       break label$2
      }
      $2 = __rust_alloc_zeroed($1 | 0, 8 | 0) | 0;
      if (!$2) {
       break label$3
      }
      break label$1;
     }
     $2 = __rust_alloc($1 | 0, 8 | 0) | 0;
     if ($2) {
      break label$1
     }
    }
    $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
    alloc__alloc__handle_alloc_error__he269d8f1bff90960($1 | 0, 8 | 0);
    abort();
   }
   $2 = 8;
  }
  HEAP32[$0 >> 2] = $2;
  HEAP32[($0 + 4 | 0) >> 2] = $1 >>> 3 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___allocate_in__h9f99f00671a57bc5($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         if (($1 & 134217727 | 0 | 0) != ($1 | 0)) {
          break label$7
         }
         $1 = $1 << 5 | 0;
         if (($1 | 0) < (0 | 0)) {
          break label$6
         }
         if ($2) {
          break label$5
         }
         if ($1) {
          break label$4
         }
         break label$2;
        }
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
       }
       alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
       abort();
      }
      if (!$1) {
       break label$2
      }
      $2 = __rust_alloc_zeroed($1 | 0, 8 | 0) | 0;
      if (!$2) {
       break label$3
      }
      break label$1;
     }
     $2 = __rust_alloc($1 | 0, 8 | 0) | 0;
     if ($2) {
      break label$1
     }
    }
    $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
    alloc__alloc__handle_alloc_error__he269d8f1bff90960($1 | 0, 8 | 0);
    abort();
   }
   $2 = 8;
  }
  HEAP32[$0 >> 2] = $2;
  HEAP32[($0 + 4 | 0) >> 2] = $1 >>> 5 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___allocate_in__he0e25d30114cc7d7($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         if (($1 & 33554431 | 0 | 0) != ($1 | 0)) {
          break label$7
         }
         $1 = $1 << 7 | 0;
         if (($1 | 0) < (0 | 0)) {
          break label$6
         }
         if ($2) {
          break label$5
         }
         if ($1) {
          break label$4
         }
         break label$2;
        }
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
       }
       alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
       abort();
      }
      if (!$1) {
       break label$2
      }
      $2 = __rust_alloc_zeroed($1 | 0, 8 | 0) | 0;
      if (!$2) {
       break label$3
      }
      break label$1;
     }
     $2 = __rust_alloc($1 | 0, 8 | 0) | 0;
     if ($2) {
      break label$1
     }
    }
    $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
    alloc__alloc__handle_alloc_error__he269d8f1bff90960($1 | 0, 8 | 0);
    abort();
   }
   $2 = 8;
  }
  HEAP32[$0 >> 2] = $2;
  HEAP32[($0 + 4 | 0) >> 2] = $1 >>> 7 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___allocate_in__heaa994c249e1f8a4($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         if (($1 & 536870911 | 0 | 0) != ($1 | 0)) {
          break label$7
         }
         $1 = $1 << 3 | 0;
         if (($1 | 0) < (0 | 0)) {
          break label$6
         }
         if ($2) {
          break label$5
         }
         if ($1) {
          break label$4
         }
         break label$2;
        }
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
        $T_20as_20core__convert__From_T____from__h76063bbf12759602();
       }
       alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
       abort();
      }
      if (!$1) {
       break label$2
      }
      $2 = __rust_alloc_zeroed($1 | 0, 4 | 0) | 0;
      if (!$2) {
       break label$3
      }
      break label$1;
     }
     $2 = __rust_alloc($1 | 0, 4 | 0) | 0;
     if ($2) {
      break label$1
     }
    }
    $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
    alloc__alloc__handle_alloc_error__he269d8f1bff90960($1 | 0, 4 | 0);
    abort();
   }
   $2 = 4;
  }
  HEAP32[$0 >> 2] = $2;
  HEAP32[($0 + 4 | 0) >> 2] = $1 >>> 3 | 0;
 }
 
 function $core__iter__adapters__ResultShunt_I_2cE__20as_20core__iter__traits__iterator__Iterator___try_fold__h31a0d674d945c00d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $22 = 0, $28 = 0, $34 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  HEAP32[($2 + 12 | 0) >> 2] = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $core__iter__adapters__map__Map_I_2cF__20as_20core__iter__traits__iterator__Iterator___try_fold__h8ec3b98286b2809b($2 + 16 | 0 | 0, $1 | 0, $2 + 40 | 0 | 0, $2 + 12 | 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAPU8[($2 + 16 | 0) >> 0] | 0 | 0) != (7 | 0)) {
     break label$2
    }
    HEAP8[$0 >> 0] = 6;
    break label$1;
   }
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   $22 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[i64toi32_i32$0 >> 2] = $22;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = ($2 + 16 | 0) + 16 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $28 = i64toi32_i32$1;
   i64toi32_i32$1 = $0 + 16 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $28;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $34 = i64toi32_i32$0;
   i64toi32_i32$0 = $0 + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $34;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  }
  global$0 = $2 + 48 | 0;
 }
 
 function $core__iter__adapters__ResultShunt_I_2cE__20as_20core__iter__traits__iterator__Iterator___try_fold__h240dbae8a1f4011e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $22 = 0, $28 = 0, $34 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  HEAP32[($2 + 12 | 0) >> 2] = HEAP32[($1 + 16 | 0) >> 2] | 0;
  $core__iter__adapters__map__Map_I_2cF__20as_20core__iter__traits__iterator__Iterator___try_fold__ha360decb24de22bf($2 + 16 | 0 | 0, $1 | 0, $2 + 40 | 0 | 0, $2 + 12 | 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAPU8[($2 + 16 | 0) >> 0] | 0 | 0) != (7 | 0)) {
     break label$2
    }
    HEAP8[$0 >> 0] = 6;
    break label$1;
   }
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
   $22 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[i64toi32_i32$0 >> 2] = $22;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = ($2 + 16 | 0) + 16 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $28 = i64toi32_i32$1;
   i64toi32_i32$1 = $0 + 16 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $28;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $34 = i64toi32_i32$0;
   i64toi32_i32$0 = $0 + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $34;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  }
  global$0 = $2 + 48 | 0;
 }
 
 function cardano_serialization_lib__utils__TransactionUnspentOutputs__get__ha53a8c5446661d93($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $20 = 0, $25 = 0, $30 = 0, $35 = 0;
  label$1 : {
   $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   if ($3 >>> 0 > $2 >>> 0) {
    break label$1
   }
   core__panicking__panic_bounds_check__h808b524af17640b1($2 | 0, $3 | 0, 1058692 | 0);
   abort();
  }
  $2 = (HEAP32[$1 >> 2] | 0) + Math_imul($2, 168) | 0;
  i64toi32_i32$2 = $2 + 156 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 156 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $20;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2 + 148 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $25 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 148 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $25;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2 + 140 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 140 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $30;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2 + 132 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $35 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 132 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $35;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $1 = HEAP32[($2 + 128 | 0) >> 2] | 0;
  $cardano_serialization_lib__TransactionOutput_20as_20core__clone__Clone___clone__h6884f0c4818d1aeb($0 | 0, $2 | 0);
  HEAP32[($0 + 128 | 0) >> 2] = $1;
 }
 
 function cardano_serialization_lib__metadata__MetadataMap__get_str__h590bed663a42477e($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0;
  $4 = global$0 - 128 | 0;
  global$0 = $4;
  alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($4 + 112 | 0 | 0, $2 | 0, $3 | 0);
  cardano_serialization_lib__metadata__TransactionMetadatum__new_text__hc705d7de2d476a57($4 + 56 | 0 | 0, $4 + 112 | 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[($4 + 56 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    memcpy($4 + 8 | 0 | 0, $4 + 64 | 0 | 0, 48 | 0) | 0;
    cardano_serialization_lib__metadata__MetadataMap__get__hfdac1fad098610ea($0 | 0, $1 | 0, $4 + 8 | 0 | 0);
    core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatum___headd2d1b596252cc($4 + 8 | 0 | 0);
    break label$1;
   }
   $2 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($4 + 60 | 0) >> 2] | 0 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
   HEAP32[($0 + 4 | 0) >> 2] = $2;
  }
  global$0 = $4 + 128 | 0;
 }
 
 function transactionmetadatum_new_int($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $2 = 0, $2$hi = 0, $3 = 0, $3$hi = 0;
  $1 = global$0 - 64 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h8f4f32b29a620a40($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $0 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $2 = i64toi32_i32$0;
  $2$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $0;
  i64toi32_i32$1 = HEAP32[$0 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $3 = i64toi32_i32$1;
  $3$hi = i64toi32_i32$0;
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$0 = $2$hi;
  i64toi32_i32$1 = $1 + 32 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $2;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $3$hi;
  i64toi32_i32$1 = ($1 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $3;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($1 + 16 | 0) >> 2] = 2;
  $0 = $cardano_serialization_lib__metadata__TransactionMetadatum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hce2feba55b67d086($1 + 16 | 0 | 0) | 0;
  global$0 = $1 + 64 | 0;
  return $0 | 0;
 }
 
 function core__ptr__drop_in_place_cbor_event__error__Error___hbf0141ec70b68c45_2($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAPU8[$0 >> 0] | 0;
   if ($1 >>> 0 < 14 >>> 0) {
    break label$1
   }
   label$2 : {
    switch ($1 + -14 | 0 | 0) {
    default:
     $0 = $0 + 4 | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
     break label$1;
    case 0:
     $0 = $0 + 4 | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
     return;
    case 1:
     $0 = $0 + 4 | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
     return;
    case 3:
     break label$1;
    case 2:
     break label$2;
    };
   }
   if ((HEAPU8[($0 + 4 | 0) >> 0] | 0 | 0) != (3 | 0)) {
    break label$1
   }
   $0 = $0 + 8 | 0;
   core__ptr__drop_in_place_alloc__boxed__Box_dyn_20std__error__Error_core__marker__Sync_core__marker__Send____h3635675e5a953b32(HEAP32[$0 >> 2] | 0 | 0);
   __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$0 >> 2] | 0 | 0) | 0 | 0, 12 | 0, 4 | 0);
   return;
  }
 }
 
 function cardano_serialization_lib__crypto__PrivateKey__from_extended_bytes__h462fe7830092bddc($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $3 = global$0 - 64 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    if (($2 | 0) != (64 | 0)) {
     break label$2
    }
    $2 = 0;
    $4 = memset($3 | 0, 0 | 0, 64 | 0) | 0;
    core__slice___impl_20_5bT_5d___clone_from_slice__h1742dfbd5d5d9efd($4 | 0, 64 | 0, $1 | 0, 64 | 0);
    $1 = HEAPU8[$4 >> 0] | 0;
    memcpy($0 + 3 | 0 | 0, $4 + 1 | 0 | 0, 63 | 0) | 0;
    HEAP8[($0 + 1 | 0) >> 0] = 0;
    HEAP8[($0 + 2 | 0) >> 0] = $1;
    break label$1;
   }
   (wasm2js_i32$0 = $0 + 4 | 0, wasm2js_i32$1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1066564 | 0, 27 | 0) | 0), HEAP32[wasm2js_i32$0 >> 2] = wasm2js_i32$1;
   $2 = 1;
  }
  HEAP8[$0 >> 0] = $2;
  global$0 = $3 + 64 | 0;
 }
 
 function alloc__vec__Vec_T_2cA___extend_desugared__ha20ef78c23693913($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $4 = 0, $3 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $core__iter__adapters__cloned__Cloned_I__20as_20core__iter__traits__iterator__Iterator___next__h491a5ec4cfc71a30($2 + 8 | 0 | 0, $1 | 0);
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   label$2 : while (1) {
    label$3 : {
     $4 = HEAP32[($0 + 8 | 0) >> 2] | 0;
     if (($4 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
      break label$3
     }
     alloc__vec__Vec_T_2cA___reserve__h71af5692fa531ae6($0 | 0, 1 | 0);
    }
    HEAP32[((HEAP32[$0 >> 2] | 0) + ($4 << 2 | 0) | 0) >> 2] = $3;
    HEAP32[($0 + 8 | 0) >> 2] = $4 + 1 | 0;
    $core__iter__adapters__cloned__Cloned_I__20as_20core__iter__traits__iterator__Iterator___next__h491a5ec4cfc71a30($2 | 0, $1 | 0);
    $3 = HEAP32[($2 + 4 | 0) >> 2] | 0;
    if ((HEAP32[$2 >> 2] | 0 | 0) == (1 | 0)) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $2 + 16 | 0;
 }
 
 function alloc__vec__Vec_T_2cA___extend_desugared__h76b8d3f5752e53b4($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $4 = 0, $3 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $core__iter__adapters__cloned__Cloned_I__20as_20core__iter__traits__iterator__Iterator___next__h63ed0f17c69cc296($2 + 8 | 0 | 0, $1 | 0);
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   label$2 : while (1) {
    label$3 : {
     $4 = HEAP32[($0 + 8 | 0) >> 2] | 0;
     if (($4 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
      break label$3
     }
     alloc__vec__Vec_T_2cA___reserve__h71af5692fa531ae6($0 | 0, 1 | 0);
    }
    HEAP32[((HEAP32[$0 >> 2] | 0) + ($4 << 2 | 0) | 0) >> 2] = $3;
    HEAP32[($0 + 8 | 0) >> 2] = $4 + 1 | 0;
    $core__iter__adapters__cloned__Cloned_I__20as_20core__iter__traits__iterator__Iterator___next__h63ed0f17c69cc296($2 | 0, $1 | 0);
    $3 = HEAP32[($2 + 4 | 0) >> 2] | 0;
    if ((HEAP32[$2 >> 2] | 0 | 0) == (1 | 0)) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $2 + 16 | 0;
 }
 
 function alloc__vec__Vec_T_2cA___extend_desugared__hea5a477b78fb1943($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $4 = 0, $3 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $core__iter__adapters__cloned__Cloned_I__20as_20core__iter__traits__iterator__Iterator___next__h9b1225c14b74e98d($2 + 8 | 0 | 0, $1 | 0);
  label$1 : {
   if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   label$2 : while (1) {
    label$3 : {
     $4 = HEAP32[($0 + 8 | 0) >> 2] | 0;
     if (($4 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
      break label$3
     }
     alloc__vec__Vec_T_2cA___reserve__h71af5692fa531ae6($0 | 0, 1 | 0);
    }
    HEAP32[((HEAP32[$0 >> 2] | 0) + ($4 << 2 | 0) | 0) >> 2] = $3;
    HEAP32[($0 + 8 | 0) >> 2] = $4 + 1 | 0;
    $core__iter__adapters__cloned__Cloned_I__20as_20core__iter__traits__iterator__Iterator___next__h9b1225c14b74e98d($2 | 0, $1 | 0);
    $3 = HEAP32[($2 + 4 | 0) >> 2] | 0;
    if ((HEAP32[$2 >> 2] | 0 | 0) == (1 | 0)) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $2 + 16 | 0;
 }
 
 function $alloc__collections__btree__map__IntoIter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__hfe05475557963367($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     $3 = HEAP32[($1 + 24 | 0) >> 2] | 0;
     if ($3) {
      break label$3
     }
     HEAP32[$0 >> 2] = 0;
     break label$2;
    }
    HEAP32[($1 + 24 | 0) >> 2] = $3 + -1 | 0;
    if (!(HEAP32[($1 + 4 | 0) >> 2] | 0)) {
     break label$1
    }
    alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next_unchecked__h92c0497bccfa2889($2 | 0, $1 | 0);
    $1 = (HEAP32[($2 + 4 | 0) >> 2] | 0) + Math_imul(HEAP32[($2 + 8 | 0) >> 2] | 0, 12) | 0;
    i64toi32_i32$2 = $1 + 4 | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    HEAP32[$0 >> 2] = HEAP32[i64toi32_i32$2 >> 2] | 0;
    HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($0 + 8 | 0) >> 2] = HEAP32[($1 + 12 | 0) >> 2] | 0;
   }
   global$0 = $2 + 16 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1067386 | 0, 43 | 0, 1067584 | 0);
  abort();
 }
 
 function plutuswitness_script($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hbec83ebdd86caafd($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($1 + 16 | 0 | 0, (HEAP32[($1 + 8 | 0) >> 2] | 0) + 128 | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($1 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($1 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  HEAP32[($1 + 32 | 0) >> 2] = HEAP32[($1 + 16 | 0) >> 2] | 0;
  HEAP32[($1 + 36 | 0) >> 2] = i64toi32_i32$1;
  $0 = $cardano_serialization_lib__plutus__PlutusScript_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h588df014a764c544($1 + 32 | 0 | 0) | 0;
  global$0 = $1 + 48 | 0;
  return $0 | 0;
 }
 
 function txinputsbuilder_get_native_input_scripts($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h2150b2b2433b33e4($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__get_native_input_scripts__h533aaa6e57788da7($1 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   label$2 : {
    label$3 : {
     $0 = HEAP32[($1 + 16 | 0) >> 2] | 0;
     if ($0) {
      break label$3
     }
     $0 = 0;
     break label$2;
    }
    i64toi32_i32$1 = HEAP32[($1 + 24 | 0) >> 2] | 0;
    HEAP32[($1 + 36 | 0) >> 2] = HEAP32[($1 + 20 | 0) >> 2] | 0;
    HEAP32[($1 + 40 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($1 + 32 | 0) >> 2] = $0;
    $0 = $cardano_serialization_lib__NativeScripts_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hd952f91bbdbbead8($1 + 32 | 0 | 0) | 0;
   }
   global$0 = $1 + 48 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function txinputsbuilder_get_plutus_input_scripts($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h2150b2b2433b33e4($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__get_plutus_input_scripts__h7e973282eea0f34a($1 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   label$2 : {
    label$3 : {
     $0 = HEAP32[($1 + 16 | 0) >> 2] | 0;
     if ($0) {
      break label$3
     }
     $0 = 0;
     break label$2;
    }
    i64toi32_i32$1 = HEAP32[($1 + 24 | 0) >> 2] | 0;
    HEAP32[($1 + 36 | 0) >> 2] = HEAP32[($1 + 20 | 0) >> 2] | 0;
    HEAP32[($1 + 40 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($1 + 32 | 0) >> 2] = $0;
    $0 = $cardano_serialization_lib__tx_builder__tx_inputs_builder__PlutusWitnesses_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8895bf7926c04f4f($1 + 32 | 0 | 0) | 0;
   }
   global$0 = $1 + 48 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function txinputsbuilder_inputs_option($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h2150b2b2433b33e4($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__inputs_option__hcc9a5caf03e37d78($1 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   label$2 : {
    label$3 : {
     $0 = HEAP32[($1 + 16 | 0) >> 2] | 0;
     if ($0) {
      break label$3
     }
     $0 = 0;
     break label$2;
    }
    i64toi32_i32$1 = HEAP32[($1 + 24 | 0) >> 2] | 0;
    HEAP32[($1 + 36 | 0) >> 2] = HEAP32[($1 + 20 | 0) >> 2] | 0;
    HEAP32[($1 + 40 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($1 + 32 | 0) >> 2] = $0;
    $0 = $cardano_serialization_lib__TransactionInputs_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__haa89884e18e43552($1 + 32 | 0 | 0) | 0;
   }
   global$0 = $1 + 48 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function $cardano_serialization_lib__address__StakeCredType_20as_20core__hash__Hash___hash__he9f79766a5c45cf6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if ((HEAPU8[$0 >> 0] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    HEAP32[($2 + 12 | 0) >> 2] = 0;
    $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_3($1 | 0, $2 + 12 | 0 | 0, 4 | 0);
    HEAP32[($2 + 12 | 0) >> 2] = 28;
    $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_2($1 | 0, $2 + 12 | 0 | 0, 4 | 0);
    break label$1;
   }
   HEAP32[($2 + 12 | 0) >> 2] = 1;
   $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_3($1 | 0, $2 + 12 | 0 | 0, 4 | 0);
   HEAP32[($2 + 12 | 0) >> 2] = 28;
   $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_2($1 | 0, $2 + 12 | 0 | 0, 4 | 0);
  }
  $std__collections__hash__map__DefaultHasher_20as_20core__hash__Hasher___write__h701fe1cdd9b43ba5_2($1 | 0, $0 + 1 | 0 | 0, 28 | 0);
  global$0 = $2 + 16 | 0;
 }
 
 function language_to_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $29 = 0, $35 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hfa98d20552a22c6d($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__plutus__Language__to_bytes__hfc301904eed509f1($2 + 16 | 0 | 0, $2 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $29 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 32 | 0) >> 2] = $29;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 32 | 0 | 0);
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $35 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $35;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 48 | 0;
 }
 
 function cardano_serialization_lib__plutus__Strings__add__h8f3270c51963220e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, $15 = 0, $33 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $3 = $2 + 8 | 0;
  HEAP32[$3 >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[$2 >> 2] = $15;
  HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (($1 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
    break label$1
   }
   alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h0dd3a7ef10a68e7f($0 | 0, $1 | 0, 1 | 0);
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  }
  $1 = (HEAP32[$0 >> 2] | 0) + Math_imul($1, 12) | 0;
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $33 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[$1 >> 2] = $33;
  HEAP32[($1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($1 + 8 | 0) >> 2] = HEAP32[$3 >> 2] | 0;
  HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
  global$0 = $2 + 16 | 0;
 }
 
 function cardano_serialization_lib__tx_builder_constants__TxBuilderConstants__plutus_default_cost_models__hedeea22bf8716716($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 704 | 0;
  global$0 = $1;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  memcpy($1 + 40 | 0 | 0, 1073776 | 0, 664 | 0) | 0;
  $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__h63a833c86dce75cf($1 + 24 | 0 | 0, $1 + 40 | 0 | 0, ($1 + 40 | 0) + 664 | 0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h614c9de21e58255d($1 + 40 | 0 | 0, $1 + 24 | 0 | 0);
  alloc__collections__btree__map__BTreeMap_K_2cV___insert__h4d28978302e72baa($1 + 8 | 0 | 0, $0 | 0, $1 + 40 | 0 | 0);
  label$1 : {
   if (!(HEAP32[($1 + 8 | 0) >> 2] | 0)) {
    break label$1
   }
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hebed8fd85cb76c41($1 + 8 | 0 | 0);
  }
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hebed8fd85cb76c41($1 + 24 | 0 | 0);
  global$0 = $1 + 704 | 0;
 }
 
 function alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf___push__hed6a81377b16396f($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $24 = 0, $32 = 0, $37 = 0, $40 = 0;
  label$1 : {
   $3 = alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cType___len_mut__h99e932b8979f4b92($0 | 0) | 0;
   $4 = HEAPU16[$3 >> 1] | 0;
   if ($4 >>> 0 > 10 >>> 0) {
    break label$1
   }
   HEAP16[$3 >> 1] = $4 + 1 | 0;
   $3 = alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cType___key_area_mut__h4543b6fc78f35b24($0 | 0, $4 | 0) | 0;
   HEAP32[($3 + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
   i64toi32_i32$2 = $1;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $24 = i64toi32_i32$0;
   i64toi32_i32$0 = $3;
   HEAP32[i64toi32_i32$0 >> 2] = $24;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   $0 = alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cType___val_area_mut__h4d6e54cf944c1a2a($0 | 0, $4 | 0) | 0;
   i64toi32_i32$2 = $2 + 16 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $32 = i64toi32_i32$1;
   i64toi32_i32$1 = $0 + 16 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $32;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $2 + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $37 = i64toi32_i32$0;
   i64toi32_i32$0 = $0 + 8 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $37;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $40 = i64toi32_i32$1;
   i64toi32_i32$1 = $0;
   HEAP32[i64toi32_i32$1 >> 2] = $40;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1048619 | 0, 32 | 0, 1048744 | 0);
  abort();
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__CertificateEnum___serialize__ha9753fa38519654b($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  label$1 : {
   switch (HEAPU8[$1 >> 0] | 0 | 0) {
   default:
    cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__StakeRegistration___serialize__h001173245c759d8c($0 | 0, $1 + 1 | 0 | 0, $2 | 0);
    return;
   case 1:
    cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__StakeDeregistration___serialize__h6386e70539f9aacd($0 | 0, $1 + 1 | 0 | 0, $2 | 0);
    return;
   case 2:
    cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__StakeDelegation___serialize__h12819bfe98da8ca7($0 | 0, $1 + 1 | 0 | 0, $2 | 0);
    return;
   case 3:
    cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__PoolRegistration___serialize__hca14ce2a34bdba0f($0 | 0, $1 + 8 | 0 | 0, $2 | 0);
    return;
   case 4:
    cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__PoolRetirement___serialize__ha2a3c174a4e94da0($0 | 0, $1 + 4 | 0 | 0, $2 | 0);
    return;
   case 5:
    cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__GenesisKeyDelegation___serialize__h5da745d5a246d9be($0 | 0, $1 + 1 | 0 | 0, $2 | 0);
    return;
   case 6:
    break label$1;
   };
  }
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__MoveInstantaneousRewardsCert___serialize__h6257e6687133e8c5($0 | 0, $1 + 8 | 0 | 0, $2 | 0);
 }
 
 function transaction_auxiliary_data($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0;
  $1 = global$0 - 144 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h70df86682e940485($1 | 0, $0 | 0);
   $0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__Transaction__auxiliary_data__h15726ce4b042f21d($1 + 8 | 0 | 0, HEAP32[$1 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   $0 = 0;
   label$2 : {
    i64toi32_i32$0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    if ((i64toi32_i32$2 | 0) != (1 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$0 | 0) | 0) {
     break label$2
    }
    memcpy($1 + 80 | 0 | 0, $1 + 16 | 0 | 0, 64 | 0) | 0;
    $0 = $cardano_serialization_lib__metadata__AuxiliaryData_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h48191cd5277961b5($1 + 80 | 0 | 0) | 0;
   }
   global$0 = $1 + 144 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function moveinstantaneousreward_new_to_other_pot($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, $3 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  $3 = 0;
  label$1 : {
   switch ($0 | 0) {
   default:
    wasm_bindgen__throw_str__h40ff0247f6a635d7(1053512 | 0, 25 | 0);
    abort();
   case 1:
    $3 = 1;
    break;
   case 0:
    break label$1;
   };
  }
  label$4 : {
   if ($1) {
    break label$4
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($2 | 0, $1 | 0);
  i64toi32_i32$2 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP8[($2 + 56 | 0) >> 0] = $3;
  HEAP32[($2 + 16 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$0 = $2;
  i64toi32_i32$1 = 0;
  HEAP32[($2 + 8 | 0) >> 2] = 0;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  $1 = $cardano_serialization_lib__MoveInstantaneousReward_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hf9455bc13311e72d($2 + 8 | 0 | 0) | 0;
  global$0 = $2 + 64 | 0;
  return $1 | 0;
 }
 
 function assetnames_get($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h38bb6325d5b407e9($2 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__AssetNames__get__hc0d49e00b9a5fbf3($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  HEAP32[($2 + 32 | 0) >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  $0 = $cardano_serialization_lib__AssetName_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__haddaee8282ead41b($2 + 32 | 0 | 0) | 0;
  global$0 = $2 + 48 | 0;
  return $0 | 0;
 }
 
 function mint_as_positive_multiasset($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h8348e40d8f63e5f1($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__Mint__as_multiasset__hfae7c36e40af3e22($1 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0, 1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($1 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($1 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  HEAP32[($1 + 32 | 0) >> 2] = HEAP32[($1 + 16 | 0) >> 2] | 0;
  HEAP32[($1 + 36 | 0) >> 2] = i64toi32_i32$1;
  $0 = $cardano_serialization_lib__MultiAsset_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he6031c139f7594ac($1 + 32 | 0 | 0) | 0;
  global$0 = $1 + 48 | 0;
  return $0 | 0;
 }
 
 function mint_as_negative_multiasset($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h8348e40d8f63e5f1($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__Mint__as_multiasset__hfae7c36e40af3e22($1 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0, 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($1 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($1 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  HEAP32[($1 + 32 | 0) >> 2] = HEAP32[($1 + 16 | 0) >> 2] | 0;
  HEAP32[($1 + 36 | 0) >> 2] = i64toi32_i32$1;
  $0 = $cardano_serialization_lib__MultiAsset_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he6031c139f7594ac($1 + 32 | 0 | 0) | 0;
  global$0 = $1 + 48 | 0;
  return $0 | 0;
 }
 
 function std__io__cursor__Cursor_T___remaining_slice__h3c8b96df05b3464c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $6 = 0, $3 = 0, $5 = 0, $5$hi = 0, $24$hi = 0, i64toi32_i32$4 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$1;
  $1 = $1 + 8 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $1 | 0);
  i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  i64toi32_i32$0 = 0;
  $6 = i64toi32_i32$1;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 | 0, $1 | 0);
  label$1 : {
   $3 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $24$hi = i64toi32_i32$0;
   i64toi32_i32$0 = $5$hi;
   i64toi32_i32$0 = $24$hi;
   i64toi32_i32$0 = $5$hi;
   i64toi32_i32$1 = $24$hi;
   i64toi32_i32$4 = i64toi32_i32$0 >>> 0 > i64toi32_i32$1 >>> 0 | ((i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) & $5 >>> 0 > $6 >>> 0 | 0) | 0;
   i64toi32_i32$1 = i64toi32_i32$4 ? $6 : $5;
   $1 = i64toi32_i32$1;
   if ($3 >>> 0 >= $1 >>> 0) {
    break label$1
   }
   core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($1 | 0, $3 | 0, 1055780 | 0);
   abort();
  }
  $4 = HEAP32[$2 >> 2] | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $3 - $1 | 0;
  HEAP32[$0 >> 2] = $4 + $1 | 0;
  global$0 = $2 + 16 | 0;
 }
 
 function $cardano_serialization_lib__utils__BigNum_20as_20cardano_serialization_lib__utils__Deserialize___deserialize__h29637bb571dceb02($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $3 = 0, $3$hi = 0, $14 = 0;
  $2 = global$0 - 96 | 0;
  global$0 = $2;
  cbor_event__de__Deserializer_R___unsigned_integer__h1ed99c0b7fe7eea1($2 | 0, $1 | 0);
  i64toi32_i32$0 = 0;
  $3 = 1;
  $3$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    if ((i64toi32_i32$2 | 0) == (1 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
     break label$2
    }
    i64toi32_i32$2 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $14 = i64toi32_i32$2;
    i64toi32_i32$2 = $0;
    HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = $14;
    HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    $3 = 0;
    $3$hi = i64toi32_i32$1;
    break label$1;
   }
   memcpy($2 + 56 | 0 | 0, $2 + 8 | 0 | 0, 40 | 0) | 0;
   alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($0 + 56 | 0 | 0, 1057772 | 0, 6 | 0);
   HEAP8[($0 + 8 | 0) >> 0] = 2;
   memcpy($0 + 9 | 0 | 0, $2 + 49 | 0 | 0, 47 | 0) | 0;
  }
  i64toi32_i32$1 = $3$hi;
  i64toi32_i32$2 = $0;
  HEAP32[i64toi32_i32$2 >> 2] = $3;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $2 + 96 | 0;
 }
 
 function $cardano_serialization_lib__chain_crypto__key__PublicKeyError_20as_20core__fmt__Display___fmt__hc004f7b5f3685acc($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if ((HEAPU8[$0 >> 0] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    HEAP32[($2 + 28 | 0) >> 2] = 0;
    HEAP32[($2 + 24 | 0) >> 2] = 1061336;
    i64toi32_i32$0 = 0;
    HEAP32[($2 + 12 | 0) >> 2] = 1;
    HEAP32[($2 + 16 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($2 + 8 | 0) >> 2] = 1061556;
    $1 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 8 | 0 | 0) | 0;
    break label$1;
   }
   HEAP32[($2 + 28 | 0) >> 2] = 0;
   HEAP32[($2 + 24 | 0) >> 2] = 1061336;
   i64toi32_i32$0 = 0;
   HEAP32[($2 + 12 | 0) >> 2] = 1;
   HEAP32[($2 + 16 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($2 + 8 | 0) >> 2] = 1061524;
   $1 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 8 | 0 | 0) | 0;
  }
  global$0 = $2 + 32 | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__chain_crypto__key__SecretKeyError_20as_20core__fmt__Display___fmt__h216c4140a265d4e0($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if ((HEAPU8[$0 >> 0] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    HEAP32[($2 + 28 | 0) >> 2] = 0;
    HEAP32[($2 + 24 | 0) >> 2] = 1061336;
    i64toi32_i32$0 = 0;
    HEAP32[($2 + 12 | 0) >> 2] = 1;
    HEAP32[($2 + 16 | 0) >> 2] = i64toi32_i32$0;
    HEAP32[($2 + 8 | 0) >> 2] = 1061488;
    $1 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 8 | 0 | 0) | 0;
    break label$1;
   }
   HEAP32[($2 + 28 | 0) >> 2] = 0;
   HEAP32[($2 + 24 | 0) >> 2] = 1061336;
   i64toi32_i32$0 = 0;
   HEAP32[($2 + 12 | 0) >> 2] = 1;
   HEAP32[($2 + 16 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[($2 + 8 | 0) >> 2] = 1061456;
   $1 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 + 8 | 0 | 0) | 0;
  }
  global$0 = $2 + 32 | 0;
  return $1 | 0;
 }
 
 function transactionbuilder_get_auxiliary_data($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0;
  $1 = global$0 - 144 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h37dfbd2f31d951c1($1 | 0, $0 | 0);
   $0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__tx_builder__TransactionBuilder__get_auxiliary_data__h643ac271599e8547($1 + 8 | 0 | 0, HEAP32[$1 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   $0 = 0;
   label$2 : {
    i64toi32_i32$0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    if ((i64toi32_i32$2 | 0) != (1 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$0 | 0) | 0) {
     break label$2
    }
    memcpy($1 + 80 | 0 | 0, $1 + 16 | 0 | 0, 64 | 0) | 0;
    $0 = $cardano_serialization_lib__metadata__AuxiliaryData_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h48191cd5277961b5($1 + 80 | 0 | 0) | 0;
   }
   global$0 = $1 + 144 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___remove_entry__haaee74feca9cfb03($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, i64toi32_i32$1 = 0;
  $3 = global$0 - 32 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$4) {
     break label$2
    }
    alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__h69963ef43fa7a3b9($3 | 0, HEAP32[$1 >> 2] | 0 | 0, $4 | 0, $2 | 0);
    $2 = 1;
    if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    HEAP32[($3 + 24 | 0) >> 2] = HEAP32[($3 + 12 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    HEAP32[($3 + 16 | 0) >> 2] = HEAP32[($3 + 4 | 0) >> 2] | 0;
    HEAP32[($3 + 20 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($3 + 28 | 0) >> 2] = $1;
    $1 = alloc__collections__btree__map__entry__OccupiedEntry_K_2cV___remove_kv__hcfc9f18b14708d93($3 + 16 | 0 | 0) | 0;
    break label$1;
   }
   $2 = 0;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[$0 >> 2] = $2;
  global$0 = $3 + 32 | 0;
 }
 
 function plutusscripts_get($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hbb8371c94476a171($2 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__plutus__PlutusScripts__get__h8b0a8416c3ca60a6($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  HEAP32[($2 + 32 | 0) >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  $0 = $cardano_serialization_lib__plutus__PlutusScript_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h588df014a764c544($2 + 32 | 0 | 0) | 0;
  global$0 = $2 + 48 | 0;
  return $0 | 0;
 }
 
 function plutusdata_new_map($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 112 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hc838c9a2ed8b7fab($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__hf4eb1bac8cecd8c9($1 + 16 | 0 | 4 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
  HEAP32[($1 + 48 | 0) >> 2] = 0;
  HEAP32[($1 + 16 | 0) >> 2] = 1;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  memcpy($1 + 64 | 0 | 0, $1 + 16 | 0 | 0, 48 | 0) | 0;
  $0 = $cardano_serialization_lib__plutus__PlutusData_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h7393378a3318e0a5($1 + 64 | 0 | 0) | 0;
  global$0 = $1 + 112 | 0;
  return $0 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___allocate_in__h0e767008da1e2eac($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $10 = 0, $3 = 0, $3$hi = 0, i64toi32_i32$2 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     i64toi32_i32$0 = 0;
     i64toi32_i32$1 = 0;
     i64toi32_i32$1 = __wasm_i64_mul($1 | 0, i64toi32_i32$0 | 0, 24 | 0, i64toi32_i32$1 | 0) | 0;
     i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
     $3 = i64toi32_i32$1;
     $3$hi = i64toi32_i32$0;
     i64toi32_i32$2 = i64toi32_i32$1;
     i64toi32_i32$1 = 0;
     i64toi32_i32$3 = 32;
     i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
     if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
      i64toi32_i32$1 = 0;
      $10 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
     } else {
      i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
      $10 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
     }
     if ($10) {
      break label$3
     }
     i64toi32_i32$1 = $3$hi;
     $1 = $3;
     if (($1 | 0) < (0 | 0)) {
      break label$3
     }
     label$4 : {
      label$5 : {
       label$6 : {
        if ($2) {
         break label$6
        }
        if ($1) {
         break label$5
        }
        break label$2;
       }
       if (!$1) {
        break label$2
       }
       $2 = __rust_alloc_zeroed($1 | 0, 8 | 0) | 0;
       if (!$2) {
        break label$4
       }
       break label$1;
      }
      $2 = __rust_alloc($1 | 0, 8 | 0) | 0;
      if ($2) {
       break label$1
      }
     }
     $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
     alloc__alloc__handle_alloc_error__he269d8f1bff90960($1 | 0, 8 | 0);
     abort();
    }
    alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
    abort();
   }
   $2 = 8;
  }
  HEAP32[$0 >> 2] = $2;
  HEAP32[($0 + 4 | 0) >> 2] = ($1 >>> 0) / (24 >>> 0) | 0;
 }
 
 function cryptoxide__hashing__blake2b__Context_____internal_final__h2dd6d9d150d91fec($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, $2 = 0, $1 = 0, $3$hi = 0, $4$hi = 0, $5 = 0, $3 = 0, $12$hi = 0, $17 = 0, $19 = 0, $19$hi = 0, $22 = 0, $23$hi = 0;
  $5 = $0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
  $3 = i64toi32_i32$0;
  $3$hi = i64toi32_i32$1;
  $1 = HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] | 0;
  i64toi32_i32$1 = 0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $3$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$3 = $1;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $4$hi = i64toi32_i32$5;
  i64toi32_i32$2 = $5;
  HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] = i64toi32_i32$4;
  HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] = i64toi32_i32$5;
  $2 = $0 + 72 | 0;
  $17 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$5;
  $19$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$2 = $3$hi;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$5 = $3$hi;
  i64toi32_i32$3 = $3;
  $22 = i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
  i64toi32_i32$1 = 0;
  $23$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $19$hi;
  i64toi32_i32$3 = $19;
  i64toi32_i32$2 = $23$hi;
  i64toi32_i32$5 = $22;
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  i64toi32_i32$3 = $17;
  HEAP32[i64toi32_i32$3 >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$4;
  label$1 : {
   if ($1 >>> 0 < 129 >>> 0) {
    break label$1
   }
   core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($1 | 0, 128 | 0, 1136176 | 0);
   abort();
  }
  $2 = $0 + 100 | 0;
  memset($2 + $1 | 0 | 0, 0 | 0, 128 - $1 | 0 | 0) | 0;
  cryptoxide__hashing__blake2__reference__compress_b__h50335d8cd58c3d7d($0 | 0, $0 + 64 | 0 | 0, $2 | 0, 128 | 0, 0 | 0);
  cryptoxide__cryptoutil__write_u64v_le__h74de04db912254e4($2 | 0, 64 | 0, $0 | 0, 8 | 0);
 }
 
 function cryptoxide__hashing__blake2b__Context_____internal_final__h681e1bb954624a60($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, $2 = 0, $1 = 0, $3$hi = 0, $4$hi = 0, $5 = 0, $3 = 0, $12$hi = 0, $17 = 0, $19 = 0, $19$hi = 0, $22 = 0, $23$hi = 0;
  $5 = $0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
  $3 = i64toi32_i32$0;
  $3$hi = i64toi32_i32$1;
  $1 = HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] | 0;
  i64toi32_i32$1 = 0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $3$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$3 = $1;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $4$hi = i64toi32_i32$5;
  i64toi32_i32$2 = $5;
  HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] = i64toi32_i32$4;
  HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] = i64toi32_i32$5;
  $2 = $0 + 72 | 0;
  $17 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$5;
  $19$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$2 = $3$hi;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$5 = $3$hi;
  i64toi32_i32$3 = $3;
  $22 = i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
  i64toi32_i32$1 = 0;
  $23$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $19$hi;
  i64toi32_i32$3 = $19;
  i64toi32_i32$2 = $23$hi;
  i64toi32_i32$5 = $22;
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  i64toi32_i32$3 = $17;
  HEAP32[i64toi32_i32$3 >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$4;
  label$1 : {
   if ($1 >>> 0 < 129 >>> 0) {
    break label$1
   }
   core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($1 | 0, 128 | 0, 1136176 | 0);
   abort();
  }
  $2 = $0 + 100 | 0;
  memset($2 + $1 | 0 | 0, 0 | 0, 128 - $1 | 0 | 0) | 0;
  cryptoxide__hashing__blake2__reference__compress_b__h50335d8cd58c3d7d($0 | 0, $0 + 64 | 0 | 0, $2 | 0, 128 | 0, 0 | 0);
  cryptoxide__cryptoutil__write_u64v_le__h74de04db912254e4($2 | 0, 64 | 0, $0 | 0, 8 | 0);
 }
 
 function cryptoxide__hashing__blake2b__Context_____internal_final__h735059caccf43fd5($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, $2 = 0, $1 = 0, $3$hi = 0, $4$hi = 0, $5 = 0, $3 = 0, $12$hi = 0, $17 = 0, $19 = 0, $19$hi = 0, $22 = 0, $23$hi = 0;
  $5 = $0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
  $3 = i64toi32_i32$0;
  $3$hi = i64toi32_i32$1;
  $1 = HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] | 0;
  i64toi32_i32$1 = 0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $3$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$3 = $1;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $4$hi = i64toi32_i32$5;
  i64toi32_i32$2 = $5;
  HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] = i64toi32_i32$4;
  HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] = i64toi32_i32$5;
  $2 = $0 + 72 | 0;
  $17 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$5;
  $19$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$2 = $3$hi;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$5 = $3$hi;
  i64toi32_i32$3 = $3;
  $22 = i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
  i64toi32_i32$1 = 0;
  $23$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $19$hi;
  i64toi32_i32$3 = $19;
  i64toi32_i32$2 = $23$hi;
  i64toi32_i32$5 = $22;
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  i64toi32_i32$3 = $17;
  HEAP32[i64toi32_i32$3 >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$4;
  label$1 : {
   if ($1 >>> 0 < 129 >>> 0) {
    break label$1
   }
   core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($1 | 0, 128 | 0, 1136176 | 0);
   abort();
  }
  $2 = $0 + 100 | 0;
  memset($2 + $1 | 0 | 0, 0 | 0, 128 - $1 | 0 | 0) | 0;
  cryptoxide__hashing__blake2__reference__compress_b__h50335d8cd58c3d7d($0 | 0, $0 + 64 | 0 | 0, $2 | 0, 128 | 0, 0 | 0);
  cryptoxide__cryptoutil__write_u64v_le__h74de04db912254e4($2 | 0, 64 | 0, $0 | 0, 8 | 0);
 }
 
 function cryptoxide__hashing__blake2b__Context_____internal_final__h9e3075aeb620108a($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, $2 = 0, $1 = 0, $3$hi = 0, $4$hi = 0, $5 = 0, $3 = 0, $12$hi = 0, $17 = 0, $19 = 0, $19$hi = 0, $22 = 0, $23$hi = 0;
  $5 = $0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
  $3 = i64toi32_i32$0;
  $3$hi = i64toi32_i32$1;
  $1 = HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] | 0;
  i64toi32_i32$1 = 0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $3$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$3 = $1;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $4$hi = i64toi32_i32$5;
  i64toi32_i32$2 = $5;
  HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] = i64toi32_i32$4;
  HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] = i64toi32_i32$5;
  $2 = $0 + 72 | 0;
  $17 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$5;
  $19$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$2 = $3$hi;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$5 = $3$hi;
  i64toi32_i32$3 = $3;
  $22 = i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
  i64toi32_i32$1 = 0;
  $23$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $19$hi;
  i64toi32_i32$3 = $19;
  i64toi32_i32$2 = $23$hi;
  i64toi32_i32$5 = $22;
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  i64toi32_i32$3 = $17;
  HEAP32[i64toi32_i32$3 >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$4;
  label$1 : {
   if ($1 >>> 0 < 129 >>> 0) {
    break label$1
   }
   core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($1 | 0, 128 | 0, 1136176 | 0);
   abort();
  }
  $2 = $0 + 100 | 0;
  memset($2 + $1 | 0 | 0, 0 | 0, 128 - $1 | 0 | 0) | 0;
  cryptoxide__hashing__blake2__reference__compress_b__h50335d8cd58c3d7d($0 | 0, $0 + 64 | 0 | 0, $2 | 0, 128 | 0, 0 | 0);
  cryptoxide__cryptoutil__write_u64v_le__h74de04db912254e4($2 | 0, 64 | 0, $0 | 0, 8 | 0);
 }
 
 function cryptoxide__hashing__blake2b__Context_____internal_final__ha1773133c9e3f685($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, $2 = 0, $1 = 0, $3$hi = 0, $4$hi = 0, $5 = 0, $3 = 0, $12$hi = 0, $17 = 0, $19 = 0, $19$hi = 0, $22 = 0, $23$hi = 0;
  $5 = $0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
  $3 = i64toi32_i32$0;
  $3$hi = i64toi32_i32$1;
  $1 = HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] | 0;
  i64toi32_i32$1 = 0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $3$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$3 = $1;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $4$hi = i64toi32_i32$5;
  i64toi32_i32$2 = $5;
  HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] = i64toi32_i32$4;
  HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] = i64toi32_i32$5;
  $2 = $0 + 72 | 0;
  $17 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$5;
  $19$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$2 = $3$hi;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$5 = $3$hi;
  i64toi32_i32$3 = $3;
  $22 = i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
  i64toi32_i32$1 = 0;
  $23$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $19$hi;
  i64toi32_i32$3 = $19;
  i64toi32_i32$2 = $23$hi;
  i64toi32_i32$5 = $22;
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  i64toi32_i32$3 = $17;
  HEAP32[i64toi32_i32$3 >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$4;
  label$1 : {
   if ($1 >>> 0 < 129 >>> 0) {
    break label$1
   }
   core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($1 | 0, 128 | 0, 1136176 | 0);
   abort();
  }
  $2 = $0 + 100 | 0;
  memset($2 + $1 | 0 | 0, 0 | 0, 128 - $1 | 0 | 0) | 0;
  cryptoxide__hashing__blake2__reference__compress_b__h50335d8cd58c3d7d($0 | 0, $0 + 64 | 0 | 0, $2 | 0, 128 | 0, 0 | 0);
  cryptoxide__cryptoutil__write_u64v_le__h74de04db912254e4($2 | 0, 64 | 0, $0 | 0, 8 | 0);
 }
 
 function cryptoxide__hashing__blake2b__Context_____internal_final__hb862d81c64ddf509($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, $2 = 0, $1 = 0, $3$hi = 0, $4$hi = 0, $5 = 0, $3 = 0, $12$hi = 0, $17 = 0, $19 = 0, $19$hi = 0, $22 = 0, $23$hi = 0;
  $5 = $0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
  $3 = i64toi32_i32$0;
  $3$hi = i64toi32_i32$1;
  $1 = HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] | 0;
  i64toi32_i32$1 = 0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $3$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$3 = $1;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $4$hi = i64toi32_i32$5;
  i64toi32_i32$2 = $5;
  HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] = i64toi32_i32$4;
  HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] = i64toi32_i32$5;
  $2 = $0 + 72 | 0;
  $17 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$5;
  $19$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$2 = $3$hi;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$5 = $3$hi;
  i64toi32_i32$3 = $3;
  $22 = i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
  i64toi32_i32$1 = 0;
  $23$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $19$hi;
  i64toi32_i32$3 = $19;
  i64toi32_i32$2 = $23$hi;
  i64toi32_i32$5 = $22;
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  i64toi32_i32$3 = $17;
  HEAP32[i64toi32_i32$3 >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$4;
  label$1 : {
   if ($1 >>> 0 < 129 >>> 0) {
    break label$1
   }
   core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($1 | 0, 128 | 0, 1136176 | 0);
   abort();
  }
  $2 = $0 + 100 | 0;
  memset($2 + $1 | 0 | 0, 0 | 0, 128 - $1 | 0 | 0) | 0;
  cryptoxide__hashing__blake2__reference__compress_b__h50335d8cd58c3d7d($0 | 0, $0 + 64 | 0 | 0, $2 | 0, 128 | 0, 0 | 0);
  cryptoxide__cryptoutil__write_u64v_le__h74de04db912254e4($2 | 0, 64 | 0, $0 | 0, 8 | 0);
 }
 
 function cryptoxide__hashing__blake2b__Context_____internal_final__hbf68fb987943c10c($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, $2 = 0, $1 = 0, $3$hi = 0, $4$hi = 0, $5 = 0, $3 = 0, $12$hi = 0, $17 = 0, $19 = 0, $19$hi = 0, $22 = 0, $23$hi = 0;
  $5 = $0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
  $3 = i64toi32_i32$0;
  $3$hi = i64toi32_i32$1;
  $1 = HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] | 0;
  i64toi32_i32$1 = 0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $3$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$3 = $1;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $4$hi = i64toi32_i32$5;
  i64toi32_i32$2 = $5;
  HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] = i64toi32_i32$4;
  HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] = i64toi32_i32$5;
  $2 = $0 + 72 | 0;
  $17 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$5;
  $19$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$2 = $3$hi;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$5 = $3$hi;
  i64toi32_i32$3 = $3;
  $22 = i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
  i64toi32_i32$1 = 0;
  $23$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $19$hi;
  i64toi32_i32$3 = $19;
  i64toi32_i32$2 = $23$hi;
  i64toi32_i32$5 = $22;
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  i64toi32_i32$3 = $17;
  HEAP32[i64toi32_i32$3 >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$4;
  label$1 : {
   if ($1 >>> 0 < 129 >>> 0) {
    break label$1
   }
   core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($1 | 0, 128 | 0, 1136176 | 0);
   abort();
  }
  $2 = $0 + 100 | 0;
  memset($2 + $1 | 0 | 0, 0 | 0, 128 - $1 | 0 | 0) | 0;
  cryptoxide__hashing__blake2__reference__compress_b__h50335d8cd58c3d7d($0 | 0, $0 + 64 | 0 | 0, $2 | 0, 128 | 0, 0 | 0);
  cryptoxide__cryptoutil__write_u64v_le__h74de04db912254e4($2 | 0, 64 | 0, $0 | 0, 8 | 0);
 }
 
 function cryptoxide__hashing__blake2b__Context_____internal_final__hc238b331d1e0298a($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, $2 = 0, $1 = 0, $3$hi = 0, $4$hi = 0, $5 = 0, $3 = 0, $12$hi = 0, $17 = 0, $19 = 0, $19$hi = 0, $22 = 0, $23$hi = 0;
  $5 = $0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
  $3 = i64toi32_i32$0;
  $3$hi = i64toi32_i32$1;
  $1 = HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] | 0;
  i64toi32_i32$1 = 0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $3$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$3 = $1;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $4$hi = i64toi32_i32$5;
  i64toi32_i32$2 = $5;
  HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] = i64toi32_i32$4;
  HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] = i64toi32_i32$5;
  $2 = $0 + 72 | 0;
  $17 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$5;
  $19$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$2 = $3$hi;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$5 = $3$hi;
  i64toi32_i32$3 = $3;
  $22 = i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
  i64toi32_i32$1 = 0;
  $23$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $19$hi;
  i64toi32_i32$3 = $19;
  i64toi32_i32$2 = $23$hi;
  i64toi32_i32$5 = $22;
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  i64toi32_i32$3 = $17;
  HEAP32[i64toi32_i32$3 >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$4;
  label$1 : {
   if ($1 >>> 0 < 129 >>> 0) {
    break label$1
   }
   core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($1 | 0, 128 | 0, 1136176 | 0);
   abort();
  }
  $2 = $0 + 100 | 0;
  memset($2 + $1 | 0 | 0, 0 | 0, 128 - $1 | 0 | 0) | 0;
  cryptoxide__hashing__blake2__reference__compress_b__h50335d8cd58c3d7d($0 | 0, $0 + 64 | 0 | 0, $2 | 0, 128 | 0, 0 | 0);
  cryptoxide__cryptoutil__write_u64v_le__h74de04db912254e4($2 | 0, 64 | 0, $0 | 0, 8 | 0);
 }
 
 function cryptoxide__hashing__blake2b__Context_____internal_final__hc78262822725c8ab($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, $2 = 0, $1 = 0, $3$hi = 0, $4$hi = 0, $5 = 0, $3 = 0, $12$hi = 0, $17 = 0, $19 = 0, $19$hi = 0, $22 = 0, $23$hi = 0;
  $5 = $0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
  $3 = i64toi32_i32$0;
  $3$hi = i64toi32_i32$1;
  $1 = HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] | 0;
  i64toi32_i32$1 = 0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $3$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$3 = $1;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $4$hi = i64toi32_i32$5;
  i64toi32_i32$2 = $5;
  HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] = i64toi32_i32$4;
  HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] = i64toi32_i32$5;
  $2 = $0 + 72 | 0;
  $17 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$5;
  $19$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$2 = $3$hi;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$5 = $3$hi;
  i64toi32_i32$3 = $3;
  $22 = i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
  i64toi32_i32$1 = 0;
  $23$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $19$hi;
  i64toi32_i32$3 = $19;
  i64toi32_i32$2 = $23$hi;
  i64toi32_i32$5 = $22;
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  i64toi32_i32$3 = $17;
  HEAP32[i64toi32_i32$3 >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$4;
  label$1 : {
   if ($1 >>> 0 < 129 >>> 0) {
    break label$1
   }
   core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($1 | 0, 128 | 0, 1136176 | 0);
   abort();
  }
  $2 = $0 + 100 | 0;
  memset($2 + $1 | 0 | 0, 0 | 0, 128 - $1 | 0 | 0) | 0;
  cryptoxide__hashing__blake2__reference__compress_b__h50335d8cd58c3d7d($0 | 0, $0 + 64 | 0 | 0, $2 | 0, 128 | 0, 0 | 0);
  cryptoxide__cryptoutil__write_u64v_le__h74de04db912254e4($2 | 0, 64 | 0, $0 | 0, 8 | 0);
 }
 
 function cryptoxide__hashing__blake2b__Context_____internal_final__hd1dfb7cf1285f8e2($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, $2 = 0, $1 = 0, $3$hi = 0, $4$hi = 0, $5 = 0, $3 = 0, $12$hi = 0, $17 = 0, $19 = 0, $19$hi = 0, $22 = 0, $23$hi = 0;
  $5 = $0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
  $3 = i64toi32_i32$0;
  $3$hi = i64toi32_i32$1;
  $1 = HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] | 0;
  i64toi32_i32$1 = 0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $3$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$3 = $1;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $4$hi = i64toi32_i32$5;
  i64toi32_i32$2 = $5;
  HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] = i64toi32_i32$4;
  HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] = i64toi32_i32$5;
  $2 = $0 + 72 | 0;
  $17 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$5;
  $19$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$2 = $3$hi;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$5 = $3$hi;
  i64toi32_i32$3 = $3;
  $22 = i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
  i64toi32_i32$1 = 0;
  $23$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $19$hi;
  i64toi32_i32$3 = $19;
  i64toi32_i32$2 = $23$hi;
  i64toi32_i32$5 = $22;
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  i64toi32_i32$3 = $17;
  HEAP32[i64toi32_i32$3 >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$4;
  label$1 : {
   if ($1 >>> 0 < 129 >>> 0) {
    break label$1
   }
   core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($1 | 0, 128 | 0, 1136176 | 0);
   abort();
  }
  $2 = $0 + 100 | 0;
  memset($2 + $1 | 0 | 0, 0 | 0, 128 - $1 | 0 | 0) | 0;
  cryptoxide__hashing__blake2__reference__compress_b__h50335d8cd58c3d7d($0 | 0, $0 + 64 | 0 | 0, $2 | 0, 128 | 0, 0 | 0);
  cryptoxide__cryptoutil__write_u64v_le__h74de04db912254e4($2 | 0, 64 | 0, $0 | 0, 8 | 0);
 }
 
 function cryptoxide__hashing__blake2b__Context_____internal_final__he45cbdade4b89e59($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, $2 = 0, $1 = 0, $3$hi = 0, $4$hi = 0, $5 = 0, $3 = 0, $12$hi = 0, $17 = 0, $19 = 0, $19$hi = 0, $22 = 0, $23$hi = 0;
  $5 = $0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
  $3 = i64toi32_i32$0;
  $3$hi = i64toi32_i32$1;
  $1 = HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] | 0;
  i64toi32_i32$1 = 0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $3$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$3 = $1;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $4$hi = i64toi32_i32$5;
  i64toi32_i32$2 = $5;
  HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] = i64toi32_i32$4;
  HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] = i64toi32_i32$5;
  $2 = $0 + 72 | 0;
  $17 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$5;
  $19$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$2 = $3$hi;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$5 = $3$hi;
  i64toi32_i32$3 = $3;
  $22 = i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
  i64toi32_i32$1 = 0;
  $23$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $19$hi;
  i64toi32_i32$3 = $19;
  i64toi32_i32$2 = $23$hi;
  i64toi32_i32$5 = $22;
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  i64toi32_i32$3 = $17;
  HEAP32[i64toi32_i32$3 >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$4;
  label$1 : {
   if ($1 >>> 0 < 129 >>> 0) {
    break label$1
   }
   core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($1 | 0, 128 | 0, 1136176 | 0);
   abort();
  }
  $2 = $0 + 100 | 0;
  memset($2 + $1 | 0 | 0, 0 | 0, 128 - $1 | 0 | 0) | 0;
  cryptoxide__hashing__blake2__reference__compress_b__h50335d8cd58c3d7d($0 | 0, $0 + 64 | 0 | 0, $2 | 0, 128 | 0, 0 | 0);
  cryptoxide__cryptoutil__write_u64v_le__h74de04db912254e4($2 | 0, 64 | 0, $0 | 0, 8 | 0);
 }
 
 function cryptoxide__hashing__blake2b__Context_____internal_final__he963a2000a7fa7a7($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, $2 = 0, $1 = 0, $3$hi = 0, $4$hi = 0, $5 = 0, $3 = 0, $12$hi = 0, $17 = 0, $19 = 0, $19$hi = 0, $22 = 0, $23$hi = 0;
  $5 = $0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
  $3 = i64toi32_i32$0;
  $3$hi = i64toi32_i32$1;
  $1 = HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] | 0;
  i64toi32_i32$1 = 0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $3$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$3 = $1;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $4$hi = i64toi32_i32$5;
  i64toi32_i32$2 = $5;
  HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] = i64toi32_i32$4;
  HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] = i64toi32_i32$5;
  $2 = $0 + 72 | 0;
  $17 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$5;
  $19$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$2 = $3$hi;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$5 = $3$hi;
  i64toi32_i32$3 = $3;
  $22 = i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
  i64toi32_i32$1 = 0;
  $23$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $19$hi;
  i64toi32_i32$3 = $19;
  i64toi32_i32$2 = $23$hi;
  i64toi32_i32$5 = $22;
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  i64toi32_i32$3 = $17;
  HEAP32[i64toi32_i32$3 >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$4;
  label$1 : {
   if ($1 >>> 0 < 129 >>> 0) {
    break label$1
   }
   core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($1 | 0, 128 | 0, 1136176 | 0);
   abort();
  }
  $2 = $0 + 100 | 0;
  memset($2 + $1 | 0 | 0, 0 | 0, 128 - $1 | 0 | 0) | 0;
  cryptoxide__hashing__blake2__reference__compress_b__h50335d8cd58c3d7d($0 | 0, $0 + 64 | 0 | 0, $2 | 0, 128 | 0, 0 | 0);
  cryptoxide__cryptoutil__write_u64v_le__h74de04db912254e4($2 | 0, 64 | 0, $0 | 0, 8 | 0);
 }
 
 function cryptoxide__hashing__blake2b__Context_____internal_final__hf5df8da38cbfe370($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, $2 = 0, $1 = 0, $3$hi = 0, $4$hi = 0, $5 = 0, $3 = 0, $12$hi = 0, $17 = 0, $19 = 0, $19$hi = 0, $22 = 0, $23$hi = 0;
  $5 = $0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
  $3 = i64toi32_i32$0;
  $3$hi = i64toi32_i32$1;
  $1 = HEAP32[(i64toi32_i32$2 + 96 | 0) >> 2] | 0;
  i64toi32_i32$1 = 0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $3$hi;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = $12$hi;
  i64toi32_i32$3 = $1;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $4$hi = i64toi32_i32$5;
  i64toi32_i32$2 = $5;
  HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] = i64toi32_i32$4;
  HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] = i64toi32_i32$5;
  $2 = $0 + 72 | 0;
  $17 = $2;
  i64toi32_i32$1 = $2;
  i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$5;
  $19$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$2 = $3$hi;
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$5 = $3$hi;
  i64toi32_i32$3 = $3;
  $22 = i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
  i64toi32_i32$1 = 0;
  $23$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $19$hi;
  i64toi32_i32$3 = $19;
  i64toi32_i32$2 = $23$hi;
  i64toi32_i32$5 = $22;
  i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  i64toi32_i32$3 = $17;
  HEAP32[i64toi32_i32$3 >> 2] = i64toi32_i32$0;
  HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$4;
  label$1 : {
   if ($1 >>> 0 < 129 >>> 0) {
    break label$1
   }
   core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($1 | 0, 128 | 0, 1136176 | 0);
   abort();
  }
  $2 = $0 + 100 | 0;
  memset($2 + $1 | 0 | 0, 0 | 0, 128 - $1 | 0 | 0) | 0;
  cryptoxide__hashing__blake2__reference__compress_b__h50335d8cd58c3d7d($0 | 0, $0 + 64 | 0 | 0, $2 | 0, 128 | 0, 0 | 0);
  cryptoxide__cryptoutil__write_u64v_le__h74de04db912254e4($2 | 0, 64 | 0, $0 | 0, 8 | 0);
 }
 
 function cryptoxide__hashing__sha2__impl512__reference__schedule_x2__hd52256e5a67097ab($0, $1, $1$hi, $2, $2$hi, $3, $3$hi, $4, $4$hi, $5, $5$hi, $6, $6$hi, $7, $7$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $1$hi = $1$hi | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  $4 = $4 | 0;
  $4$hi = $4$hi | 0;
  $5 = $5 | 0;
  $5$hi = $5$hi | 0;
  $6 = $6 | 0;
  $6$hi = $6$hi | 0;
  $7 = $7 | 0;
  $7$hi = $7$hi | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$5 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $65 = 0, $66 = 0, $67 = 0, $68 = 0, $8 = 0, $11 = 0, $11$hi = 0, $13 = 0, $13$hi = 0, $15 = 0, $15$hi = 0, $16 = 0, $16$hi = 0, $18$hi = 0, $19 = 0, $19$hi = 0, $20 = 0, $20$hi = 0, $22 = 0, $22$hi = 0, $24 = 0, $24$hi = 0, $25 = 0, $25$hi = 0, $27$hi = 0, $28 = 0, $28$hi = 0, $30 = 0, $32 = 0, $32$hi = 0, $34 = 0, $34$hi = 0, $35 = 0, $35$hi = 0, $37$hi = 0, $38$hi = 0, $40$hi = 0, $42 = 0, $42$hi = 0, $44 = 0, $44$hi = 0, $46 = 0, $46$hi = 0, $47 = 0, $47$hi = 0, $49$hi = 0, $50 = 0, $50$hi = 0;
  $8 = $0;
  i64toi32_i32$0 = $4$hi;
  i64toi32_i32$0 = $1$hi;
  i64toi32_i32$0 = $4$hi;
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = $1$hi;
  i64toi32_i32$3 = $1;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $11 = i64toi32_i32$4;
  $11$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $3$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($3 | 0, i64toi32_i32$5 | 0, 63 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $13 = i64toi32_i32$2;
  $13$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $3$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$2 = __wasm_rotl_i64($3 | 0, i64toi32_i32$5 | 0, 56 | 0, i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$5 = i64toi32_i32$HIGH_BITS;
  $15 = i64toi32_i32$2;
  $15$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $13$hi;
  i64toi32_i32$0 = $13;
  i64toi32_i32$2 = $15$hi;
  i64toi32_i32$3 = $15;
  i64toi32_i32$2 = i64toi32_i32$5 ^ i64toi32_i32$2 | 0;
  $16 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $16$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $3$hi;
  i64toi32_i32$5 = $3;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 7;
  i64toi32_i32$1 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $65 = i64toi32_i32$2 >>> i64toi32_i32$1 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$2 >>> i64toi32_i32$1 | 0;
   $65 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$1 | 0) | 0;
  }
  $18$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $16$hi;
  i64toi32_i32$2 = $16;
  i64toi32_i32$5 = $18$hi;
  i64toi32_i32$3 = $65;
  i64toi32_i32$5 = i64toi32_i32$0 ^ i64toi32_i32$5 | 0;
  $19 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $19$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $11$hi;
  i64toi32_i32$0 = $11;
  i64toi32_i32$2 = $19$hi;
  i64toi32_i32$3 = $19;
  i64toi32_i32$1 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $20 = i64toi32_i32$1;
  $20$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $6$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($6 | 0, i64toi32_i32$4 | 0, 45 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $22 = i64toi32_i32$0;
  $22$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $6$hi;
  i64toi32_i32$0 = 0;
  i64toi32_i32$0 = __wasm_rotl_i64($6 | 0, i64toi32_i32$4 | 0, 3 | 0, i64toi32_i32$0 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $24 = i64toi32_i32$0;
  $24$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $22$hi;
  i64toi32_i32$5 = $22;
  i64toi32_i32$0 = $24$hi;
  i64toi32_i32$3 = $24;
  i64toi32_i32$0 = i64toi32_i32$4 ^ i64toi32_i32$0 | 0;
  $25 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  $25$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$4 = $6;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 6;
  i64toi32_i32$2 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$5 = 0;
   $66 = i64toi32_i32$0 >>> i64toi32_i32$2 | 0;
  } else {
   i64toi32_i32$5 = i64toi32_i32$0 >>> i64toi32_i32$2 | 0;
   $66 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$4 >>> i64toi32_i32$2 | 0) | 0;
  }
  $27$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $25$hi;
  i64toi32_i32$0 = $25;
  i64toi32_i32$4 = $27$hi;
  i64toi32_i32$3 = $66;
  i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$4 | 0;
  $28 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $28$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $20$hi;
  i64toi32_i32$5 = $20;
  i64toi32_i32$0 = $28$hi;
  i64toi32_i32$3 = $28;
  i64toi32_i32$2 = i64toi32_i32$5 + i64toi32_i32$3 | 0;
  i64toi32_i32$1 = i64toi32_i32$4 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$1 + 1 | 0
  }
  i64toi32_i32$5 = $8;
  HEAP32[i64toi32_i32$5 >> 2] = i64toi32_i32$2;
  HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$1;
  $30 = $0;
  i64toi32_i32$1 = $1$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($1 | 0, i64toi32_i32$1 | 0, 63 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $32 = i64toi32_i32$5;
  $32$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $1$hi;
  i64toi32_i32$5 = 0;
  i64toi32_i32$5 = __wasm_rotl_i64($1 | 0, i64toi32_i32$1 | 0, 56 | 0, i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $34 = i64toi32_i32$5;
  $34$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $32$hi;
  i64toi32_i32$4 = $32;
  i64toi32_i32$5 = $34$hi;
  i64toi32_i32$3 = $34;
  i64toi32_i32$5 = i64toi32_i32$1 ^ i64toi32_i32$5 | 0;
  $35 = i64toi32_i32$4 ^ i64toi32_i32$3 | 0;
  $35$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $1$hi;
  i64toi32_i32$1 = $1;
  i64toi32_i32$4 = 0;
  i64toi32_i32$3 = 7;
  i64toi32_i32$0 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$4 = 0;
   $67 = i64toi32_i32$5 >>> i64toi32_i32$0 | 0;
  } else {
   i64toi32_i32$4 = i64toi32_i32$5 >>> i64toi32_i32$0 | 0;
   $67 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$0 | 0) | 0;
  }
  $37$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $35$hi;
  i64toi32_i32$5 = $35;
  i64toi32_i32$1 = $37$hi;
  i64toi32_i32$3 = $67;
  i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
  $38$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $2$hi;
  i64toi32_i32$1 = $38$hi;
  i64toi32_i32$4 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = $2$hi;
  i64toi32_i32$3 = $2;
  i64toi32_i32$0 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  if (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$2 = i64toi32_i32$2 + 1 | 0
  }
  $40$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $5$hi;
  i64toi32_i32$2 = $40$hi;
  i64toi32_i32$1 = i64toi32_i32$0;
  i64toi32_i32$4 = $5$hi;
  i64toi32_i32$3 = $5;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  i64toi32_i32$0 = i64toi32_i32$2 + i64toi32_i32$4 | 0;
  if (i64toi32_i32$5 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$0 + 1 | 0
  }
  $42 = i64toi32_i32$5;
  $42$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 45 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $44 = i64toi32_i32$1;
  $44$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $7$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$1 = __wasm_rotl_i64($7 | 0, i64toi32_i32$0 | 0, 3 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $46 = i64toi32_i32$1;
  $46$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $44$hi;
  i64toi32_i32$2 = $44;
  i64toi32_i32$1 = $46$hi;
  i64toi32_i32$3 = $46;
  i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$1 | 0;
  $47 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  $47$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$0 = $7;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 6;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $68 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   $68 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
  }
  $49$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $47$hi;
  i64toi32_i32$1 = $47;
  i64toi32_i32$0 = $49$hi;
  i64toi32_i32$3 = $68;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  $50 = i64toi32_i32$1 ^ i64toi32_i32$3 | 0;
  $50$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $42$hi;
  i64toi32_i32$2 = $42;
  i64toi32_i32$1 = $50$hi;
  i64toi32_i32$3 = $50;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  i64toi32_i32$2 = $30;
  HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = i64toi32_i32$4;
  HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$5;
 }
 
 function $core__ops__range__Range_Idx__20as_20core__fmt__Debug___fmt__h6d1aa02eafb6e5f6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if (core__fmt__num___impl_20core__fmt__Debug_20for_20usize___fmt__h57d075c2d6ce4f59($0 | 0, $1 | 0) | 0) {
     break label$2
    }
    $3 = HEAP32[($1 + 28 | 0) >> 2] | 0;
    $4 = HEAP32[($1 + 24 | 0) >> 2] | 0;
    HEAP32[($2 + 28 | 0) >> 2] = 0;
    HEAP32[($2 + 24 | 0) >> 2] = 1149204;
    HEAP32[($2 + 12 | 0) >> 2] = 1;
    HEAP32[($2 + 16 | 0) >> 2] = 0;
    HEAP32[($2 + 8 | 0) >> 2] = 1149428;
    if (!(core__fmt__write__h9b9aa23e7d35702c($4 | 0, $3 | 0, $2 + 8 | 0 | 0) | 0)) {
     break label$1
    }
   }
   global$0 = $2 + 32 | 0;
   return 1 | 0;
  }
  $1 = core__fmt__num___impl_20core__fmt__Debug_20for_20usize___fmt__h57d075c2d6ce4f59($0 + 4 | 0 | 0, $1 | 0) | 0;
  global$0 = $2 + 32 | 0;
  return $1 | 0;
 }
 
 function alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal___push__hcad6f2acc0614f5e($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0;
  label$1 : {
   label$2 : {
    if (((HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) != ($2 | 0)) {
     break label$2
    }
    $0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    $2 = HEAPU16[($0 + 50 | 0) >> 1] | 0;
    if ($2 >>> 0 <= 10 >>> 0) {
     break label$1
    }
    core__panicking__panic__h2fd385a887c8bf13(1048619 | 0, 32 | 0, 1048824 | 0);
    abort();
   }
   core__panicking__panic__h2fd385a887c8bf13(1048760 | 0, 48 | 0, 1048808 | 0);
   abort();
  }
  $4 = $2 + 1 | 0;
  HEAP16[($0 + 50 | 0) >> 1] = $4;
  HEAP32[(($0 + ($2 << 2 | 0) | 0) + 4 | 0) >> 2] = $1;
  HEAP32[(($0 + ($4 << 2 | 0) | 0) + 52 | 0) >> 2] = $3;
  HEAP16[($3 + 48 | 0) >> 1] = $4;
  HEAP32[$3 >> 2] = $0;
 }
 
 function transactionbody_set_ttl($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $28 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h238818d95bb6c551($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $4 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[($0 + 8 | 0) >> 2] = 1;
   HEAP32[($0 + 12 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $4;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $28 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[($0 + 16 | 0) >> 2] = $28;
   HEAP32[($0 + 20 | 0) >> 2] = i64toi32_i32$1;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function singlehostname_dns_name($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hb0365aa08561904d($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($1 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($1 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($1 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  HEAP32[($1 + 32 | 0) >> 2] = HEAP32[($1 + 16 | 0) >> 2] | 0;
  HEAP32[($1 + 36 | 0) >> 2] = i64toi32_i32$1;
  $0 = $cardano_serialization_lib__DNSRecordAorAAAA_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__ha728e434ce197f30($1 + 32 | 0 | 0) | 0;
  global$0 = $1 + 48 | 0;
  return $0 | 0;
 }
 
 function multihostname_dns_name($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__ha28b58697d2aa221($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($1 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($1 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($1 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  HEAP32[($1 + 32 | 0) >> 2] = HEAP32[($1 + 16 | 0) >> 2] | 0;
  HEAP32[($1 + 36 | 0) >> 2] = i64toi32_i32$1;
  $0 = $cardano_serialization_lib__DNSRecordSRV_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h86e52234694c0af8($1 + 32 | 0 | 0) | 0;
  global$0 = $1 + 48 | 0;
  return $0 | 0;
 }
 
 function multihostname_new($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h8aa27fc1f3f1159b($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($1 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($1 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($1 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  HEAP32[($1 + 32 | 0) >> 2] = HEAP32[($1 + 16 | 0) >> 2] | 0;
  HEAP32[($1 + 36 | 0) >> 2] = i64toi32_i32$1;
  $0 = $cardano_serialization_lib__MultiHostName_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h36c70b81dbc68c79($1 + 32 | 0 | 0) | 0;
  global$0 = $1 + 48 | 0;
  return $0 | 0;
 }
 
 function poolmetadata_url($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h451504312a4b72d0($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($1 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($1 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($1 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  HEAP32[($1 + 32 | 0) >> 2] = HEAP32[($1 + 16 | 0) >> 2] | 0;
  HEAP32[($1 + 36 | 0) >> 2] = i64toi32_i32$1;
  $0 = $cardano_serialization_lib__URL_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h2e80070c22b420a7($1 + 32 | 0 | 0) | 0;
  global$0 = $1 + 48 | 0;
  return $0 | 0;
 }
 
 function nativescript_get_required_signers($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h6ed0b6b043905434($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__NativeScript__get_required_signers__h9908f6a658ad9671($1 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[(($1 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($1 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  HEAP32[($1 + 32 | 0) >> 2] = HEAP32[($1 + 16 | 0) >> 2] | 0;
  HEAP32[($1 + 36 | 0) >> 2] = i64toi32_i32$1;
  $0 = $cardano_serialization_lib__Ed25519KeyHashes_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h2ef8a4685b78a9d8($1 + 32 | 0 | 0) | 0;
  global$0 = $1 + 48 | 0;
  return $0 | 0;
 }
 
 function protocolparamupdate_set_minfee_a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $28 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h0a71cd742026514d($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $4 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[$0 >> 2] = 1;
   HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $4;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $28 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[($0 + 8 | 0) >> 2] = $28;
   HEAP32[($0 + 12 | 0) >> 2] = i64toi32_i32$1;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function protocolparamupdate_set_minfee_b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $28 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h0a71cd742026514d($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $4 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[($0 + 16 | 0) >> 2] = 1;
   HEAP32[($0 + 20 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $4;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $28 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[($0 + 24 | 0) >> 2] = $28;
   HEAP32[($0 + 28 | 0) >> 2] = i64toi32_i32$1;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function protocolparamupdate_set_key_deposit($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $28 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h0a71cd742026514d($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $4 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[($0 + 32 | 0) >> 2] = 1;
   HEAP32[($0 + 36 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $4;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $28 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[($0 + 40 | 0) >> 2] = $28;
   HEAP32[($0 + 44 | 0) >> 2] = i64toi32_i32$1;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function protocolparamupdate_set_pool_deposit($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $28 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h0a71cd742026514d($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $4 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[($0 + 48 | 0) >> 2] = 1;
   HEAP32[($0 + 52 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $4;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $28 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[($0 + 56 | 0) >> 2] = $28;
   HEAP32[($0 + 60 | 0) >> 2] = i64toi32_i32$1;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function protocolparamupdate_set_min_pool_cost($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $28 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h0a71cd742026514d($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $4 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[($0 + 160 | 0) >> 2] = 1;
   HEAP32[($0 + 164 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $4;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $28 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[($0 + 168 | 0) >> 2] = $28;
   HEAP32[($0 + 172 | 0) >> 2] = i64toi32_i32$1;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function protocolparamupdate_set_ada_per_utxo_byte($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $28 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h0a71cd742026514d($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $4 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[($0 + 176 | 0) >> 2] = 1;
   HEAP32[($0 + 180 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $4;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $28 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[($0 + 184 | 0) >> 2] = $28;
   HEAP32[($0 + 188 | 0) >> 2] = i64toi32_i32$1;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function cardano_serialization_lib__utils__min_pure_ada__had787b4590d9b7ca($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  cardano_serialization_lib__utils__BigNum__from_str__h35d4d8383c8139e0($3 + 32 | 0 | 0, 1057930 | 0, 7 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[($3 + 32 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    HEAP32[($3 + 16 | 0) >> 2] = 0;
    i64toi32_i32$2 = $3 + 40 | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    HEAP32[($3 + 8 | 0) >> 2] = HEAP32[i64toi32_i32$2 >> 2] | 0;
    HEAP32[($3 + 12 | 0) >> 2] = i64toi32_i32$1;
    cardano_serialization_lib__utils__min_ada_required__hfea4b15a263723f5($0 | 0, $3 + 8 | 0 | 0, $2 | 0, $1 | 0);
    if (!(HEAP32[($3 + 16 | 0) >> 2] | 0)) {
     break label$1
    }
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($3 + 20 | 0 | 0);
    break label$1;
   }
   $1 = $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef(HEAP32[($3 + 36 | 0) >> 2] | 0 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
  }
  global$0 = $3 + 48 | 0;
 }
 
 function bigint_increment($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $26 = 0, $29 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hb4a7701b5bc2a87c($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__utils__BigInt__increment__h0dd310992170006f($1 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$2 = ($1 + 16 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $26 = i64toi32_i32$0;
  i64toi32_i32$0 = ($1 + 32 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $26;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[($1 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  $29 = i64toi32_i32$1;
  i64toi32_i32$1 = $1;
  HEAP32[($1 + 32 | 0) >> 2] = $29;
  HEAP32[($1 + 36 | 0) >> 2] = i64toi32_i32$0;
  $0 = $cardano_serialization_lib__utils__BigInt_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8699e08c5b3b0a6a($1 + 32 | 0 | 0) | 0;
  global$0 = $1 + 48 | 0;
  return $0 | 0;
 }
 
 function $core__iter__adapters__map__Map_I_2cF__20as_20core__iter__traits__iterator__Iterator___fold__ha528b5dd125884e1($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, $5 = 0, $6 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  $5 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  label$1 : {
   if (($0 | 0) == ($1 | 0)) {
    break label$1
   }
   $2 = HEAP32[$2 >> 2] | 0;
   label$2 : while (1) {
    cardano_serialization_lib__TransactionOutput__to_bytes__h39917cb4ac582524($3 | 0, $0 | 0);
    $6 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($3 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($3 | 0);
    HEAP32[$2 >> 2] = $6;
    $4 = $4 + 1 | 0;
    $2 = $2 + 4 | 0;
    $0 = $0 + 128 | 0;
    if (($1 | 0) != ($0 | 0)) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[$5 >> 2] = $4;
  global$0 = $3 + 16 | 0;
 }
 
 function transactionbuilder_set_fee($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $28 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h5566e1c7d4aafe35($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $4 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[($0 + 256 | 0) >> 2] = 1;
   HEAP32[($0 + 260 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $4;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $28 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[($0 + 264 | 0) >> 2] = $28;
   HEAP32[($0 + 268 | 0) >> 2] = i64toi32_i32$1;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionbuilder_set_ttl_bignum($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, $28 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h5566e1c7d4aafe35($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $4 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[($0 + 272 | 0) >> 2] = 1;
   HEAP32[($0 + 276 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$2 = $4;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $28 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[($0 + 280 | 0) >> 2] = $28;
   HEAP32[($0 + 284 | 0) >> 2] = i64toi32_i32$1;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function cardano_serialization_lib__address__StakeCredential__to_raw_bytes__h5ee498f6937345cd($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $4 = 0, $11 = 0, $12 = 0, $13 = 0, $14 = 0, $15 = 0, $16 = 0, $3 = 0, $18 = 0, $23 = 0, $28 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($2 + 8 | 0 | 0, 28 | 0, 0 | 0);
  $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  HEAP32[$0 >> 2] = $4;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 8 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  $11 = $18;
  HEAP8[i64toi32_i32$0 >> 0] = $11;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 9 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $23 = i64toi32_i32$1;
  i64toi32_i32$1 = $4 + 8 | 0;
  $12 = $23;
  HEAP8[i64toi32_i32$1 >> 0] = $12;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $12 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $12 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $12 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $1 + 17 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $28 = i64toi32_i32$0;
  i64toi32_i32$0 = $4 + 16 | 0;
  $13 = $28;
  HEAP8[i64toi32_i32$0 >> 0] = $13;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $14 = $1 + 25 | 0;
  $15 = $4 + 24 | 0;
  $16 = HEAPU8[$14 >> 0] | 0 | ((HEAPU8[($14 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($14 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($14 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  HEAP8[$15 >> 0] = $16;
  HEAP8[($15 + 1 | 0) >> 0] = $16 >>> 8 | 0;
  HEAP8[($15 + 2 | 0) >> 0] = $16 >>> 16 | 0;
  HEAP8[($15 + 3 | 0) >> 0] = $16 >>> 24 | 0;
  HEAP32[($0 + 8 | 0) >> 2] = 28;
  HEAP32[($0 + 4 | 0) >> 2] = $3;
  global$0 = $2 + 16 | 0;
 }
 
 function costmodel_get($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $27 = 0, $27$hi = 0, $30 = 0, $30$hi = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h63771635114e9ad4($2 | 0, $0 | 0);
    $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
    cardano_serialization_lib__plutus__CostModel__get__hc959a795ef212b84($2 + 8 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0, $1 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    i64toi32_i32$2 = $2 + 16 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $27 = i64toi32_i32$0;
    $27$hi = i64toi32_i32$1;
    i64toi32_i32$2 = $2 + 24 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $30 = i64toi32_i32$1;
    $30$hi = i64toi32_i32$0;
    i64toi32_i32$0 = $27$hi;
    i64toi32_i32$1 = $30$hi;
    $0 = $cardano_serialization_lib__utils__Int_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hac86427717971799($27 | 0, i64toi32_i32$0 | 0, $30 | 0, i64toi32_i32$1 | 0) | 0;
    global$0 = $2 + 32 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  abort();
 }
 
 function plutusdata_new_bytes($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  HEAP32[($2 + 40 | 0) >> 2] = $1;
  HEAP32[($2 + 36 | 0) >> 2] = $1;
  HEAP32[($2 + 32 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 32 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 20 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[($2 + 44 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
  HEAP32[($2 + 32 | 0) >> 2] = 4;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  HEAP32[($2 + 36 | 0) >> 2] = HEAP32[($2 + 20 | 0) >> 2] | 0;
  HEAP32[($2 + 40 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($2 + 64 | 0) >> 2] = 0;
  $1 = $cardano_serialization_lib__plutus__PlutusData_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h7393378a3318e0a5($2 + 32 | 0 | 0) | 0;
  global$0 = $2 + 80 | 0;
  return $1 | 0;
 }
 
 function cardano_serialization_lib__plutus__PlutusData__as_constr_plutus_data__he46650f409e7849e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, i64toi32_i32$2 = 0, $3 = 0, $3$hi = 0, $17 = 0, $31 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if (HEAP32[$1 >> 2] | 0) {
     break label$2
    }
    i64toi32_i32$2 = $1 + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $3 = i64toi32_i32$0;
    $3$hi = i64toi32_i32$1;
    $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hc831120dea694494($2 | 0, $1 + 16 | 0 | 0);
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
    $17 = i64toi32_i32$1;
    i64toi32_i32$1 = $0;
    HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $17;
    HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
    $1 = HEAPU8[($1 + 28 | 0) >> 0] | 0;
    HEAP8[($2 + 12 | 0) >> 0] = ($1 | 0) == (2 | 0) ? 2 : ($1 | 0) != (0 | 0);
    i64toi32_i32$2 = $2 + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $31 = i64toi32_i32$0;
    i64toi32_i32$0 = $0 + 16 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $31;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$1 = $3$hi;
    i64toi32_i32$0 = $0;
    HEAP32[i64toi32_i32$0 >> 2] = $3;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    break label$1;
   }
   HEAP8[($0 + 20 | 0) >> 0] = 3;
  }
  global$0 = $2 + 16 | 0;
 }
 
 function serde_json__de__Deserializer_R___parse_decimal_overflow__hd3815d0f881bb26e($0, $1, $2, $3, $3$hi, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $3$hi = $3$hi | 0;
  $4 = $4 | 0;
  var $5 = 0, i64toi32_i32$0 = 0, $6 = 0, $8 = 0, $7 = 0;
  label$1 : {
   label$2 : {
    $5 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    $6 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if ($5 >>> 0 >= $6 >>> 0) {
     break label$2
    }
    $7 = HEAP32[$1 >> 2] | 0;
    label$3 : {
     label$4 : while (1) {
      $8 = HEAPU8[($7 + $5 | 0) >> 0] | 0;
      if ((($8 + -48 | 0) & 255 | 0) >>> 0 >= 10 >>> 0) {
       break label$3
      }
      $5 = $5 + 1 | 0;
      HEAP32[($1 + 8 | 0) >> 2] = $5;
      if (($6 | 0) != ($5 | 0)) {
       continue label$4
      }
      break label$2;
     };
    }
    if (($8 | 32 | 0 | 0) == (101 | 0)) {
     break label$1
    }
   }
   i64toi32_i32$0 = $3$hi;
   serde_json__de__Deserializer_R___f64_from_parts__hb0108f153aa5786e($0 | 0, $1 | 0, $2 | 0, $3 | 0, i64toi32_i32$0 | 0, $4 | 0);
   return;
  }
  i64toi32_i32$0 = $3$hi;
  serde_json__de__Deserializer_R___parse_exponent__h64f12a2a919bb245($0 | 0, $1 | 0, $2 | 0, $3 | 0, i64toi32_i32$0 | 0, $4 | 0);
 }
 
 function std__io__buffered__bufwriter__BufWriter_W___write_all_cold__h38ccb137a9134dc2($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0;
  label$1 : {
   $3 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   $4 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (($3 - $4 | 0) >>> 0 >= $2 >>> 0) {
    break label$1
   }
   label$2 : {
    if ($4) {
     break label$2
    }
    $4 = 0;
    break label$1;
   }
   $4 = 0;
   HEAP8[($0 + 12 | 0) >> 0] = 0;
   HEAP32[($0 + 8 | 0) >> 2] = 0;
  }
  label$3 : {
   if ($3 >>> 0 <= $2 >>> 0) {
    break label$3
   }
   memcpy((HEAP32[$0 >> 2] | 0) + $4 | 0 | 0, $1 | 0, $2 | 0) | 0;
   HEAP32[($0 + 8 | 0) >> 2] = $4 + $2 | 0;
   i64toi32_i32$0 = 0;
   i64toi32_i32$1 = 4;
   i64toi32_i32$HIGH_BITS = i64toi32_i32$0;
   return i64toi32_i32$1 | 0;
  }
  HEAP8[($0 + 12 | 0) >> 0] = 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$0 = 4;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$1;
  return i64toi32_i32$0 | 0;
 }
 
 function core__result__unwrap_failed__h27f43d993c3864a1($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0;
  $5 = global$0 - 64 | 0;
  global$0 = $5;
  HEAP32[($5 + 12 | 0) >> 2] = $1;
  HEAP32[($5 + 8 | 0) >> 2] = $0;
  HEAP32[($5 + 20 | 0) >> 2] = $3;
  HEAP32[($5 + 16 | 0) >> 2] = $2;
  HEAP32[($5 + 44 | 0) >> 2] = 2;
  HEAP32[($5 + 60 | 0) >> 2] = 329;
  HEAP32[($5 + 28 | 0) >> 2] = 2;
  HEAP32[($5 + 32 | 0) >> 2] = 0;
  HEAP32[($5 + 24 | 0) >> 2] = 1149756;
  HEAP32[($5 + 52 | 0) >> 2] = 328;
  HEAP32[($5 + 40 | 0) >> 2] = $5 + 48 | 0;
  HEAP32[($5 + 56 | 0) >> 2] = $5 + 16 | 0;
  HEAP32[($5 + 48 | 0) >> 2] = $5 + 8 | 0;
  core__panicking__panic_fmt__hbf21a3d4bbb82bf8($5 + 24 | 0 | 0, $4 | 0);
  abort();
 }
 
 function cryptoxide__chacha20poly1305__ContextDecryption_____decrypt__h516503f3ed8845db($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$5 = 0, i64toi32_i32$4 = 0, $20 = 0, $22$hi = 0, $24$hi = 0;
  $5 = global$0 - 32 | 0;
  global$0 = $5;
  HEAP32[$5 >> 2] = $2;
  HEAP32[($5 + 4 | 0) >> 2] = $4;
  label$1 : {
   if (($2 | 0) != ($4 | 0)) {
    break label$1
   }
   $cryptoxide__poly1305__Poly1305_20as_20cryptoxide__mac__Mac___input__h2055bc09e473001f($0 + 148 | 0 | 0, $1 | 0, $2 | 0);
   $20 = $0;
   i64toi32_i32$2 = $0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
   $22$hi = i64toi32_i32$1;
   i64toi32_i32$1 = 0;
   $24$hi = i64toi32_i32$1;
   i64toi32_i32$1 = $22$hi;
   i64toi32_i32$2 = i64toi32_i32$0;
   i64toi32_i32$0 = $24$hi;
   i64toi32_i32$4 = i64toi32_i32$2 + $2 | 0;
   i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
   if (i64toi32_i32$4 >>> 0 < $2 >>> 0) {
    i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
   }
   i64toi32_i32$2 = $20;
   HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = i64toi32_i32$4;
   HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$5;
   cryptoxide__chacha20__ChaCha_____process__h1d8c0590222f71eb($0 + 16 | 0 | 0, $1 | 0, $2 | 0, $3 | 0, $2 | 0);
   global$0 = $5 + 32 | 0;
   return;
  }
  HEAP32[($5 + 8 | 0) >> 2] = 0;
  core__panicking__assert_failed__h7abe5b371cd10d8a(0 | 0, $5 | 0, $5 + 4 | 0 | 0, $5 + 8 | 0 | 0, 1055372 | 0);
  abort();
 }
 
 function cryptoxide__chacha20poly1305__ContextEncryption_____encrypt__hceb367435c4eb688($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$5 = 0, i64toi32_i32$4 = 0, $26 = 0, $28$hi = 0, $30$hi = 0;
  $5 = global$0 - 32 | 0;
  global$0 = $5;
  HEAP32[$5 >> 2] = $2;
  HEAP32[($5 + 4 | 0) >> 2] = $4;
  label$1 : {
   if (($2 | 0) != ($4 | 0)) {
    break label$1
   }
   cryptoxide__chacha20__ChaCha_____process__h1d8c0590222f71eb($0 + 16 | 0 | 0, $1 | 0, $2 | 0, $3 | 0, $2 | 0);
   $cryptoxide__poly1305__Poly1305_20as_20cryptoxide__mac__Mac___input__h2055bc09e473001f($0 + 148 | 0 | 0, $3 | 0, $2 | 0);
   $26 = $0;
   i64toi32_i32$2 = $0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
   $28$hi = i64toi32_i32$1;
   i64toi32_i32$1 = 0;
   $30$hi = i64toi32_i32$1;
   i64toi32_i32$1 = $28$hi;
   i64toi32_i32$2 = i64toi32_i32$0;
   i64toi32_i32$0 = $30$hi;
   i64toi32_i32$4 = i64toi32_i32$2 + $2 | 0;
   i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
   if (i64toi32_i32$4 >>> 0 < $2 >>> 0) {
    i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
   }
   i64toi32_i32$2 = $26;
   HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] = i64toi32_i32$4;
   HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] = i64toi32_i32$5;
   global$0 = $5 + 32 | 0;
   return;
  }
  HEAP32[($5 + 8 | 0) >> 2] = 0;
  core__panicking__assert_failed__h7abe5b371cd10d8a(0 | 0, $5 | 0, $5 + 4 | 0 | 0, $5 + 8 | 0 | 0, 1055388 | 0);
  abort();
 }
 
 function metadatamap_has($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h74f2437fd791f127($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hc630c86c4ab6b26d($2 | 0, $1 | 0);
   $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $3 = hashbrown__map__HashMap_K_2cV_2cS_2cA___contains_key__h3bb81cf90134dc7f($3 | 0, HEAP32[$2 >> 2] | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, (HEAP32[$1 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return $3 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionmetadatumlabels_get($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h0497bf4a59b2a68b($2 + 8 | 0 | 0, $0 | 0);
    $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
    if ($3 >>> 0 <= $1 >>> 0) {
     break label$1
    }
    i64toi32_i32$2 = (HEAP32[$0 >> 2] | 0) + ($1 << 3 | 0) | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $4 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810($4 | 0, i64toi32_i32$1 | 0) | 0;
    global$0 = $2 + 16 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  core__panicking__panic_bounds_check__h808b524af17640b1($1 | 0, $3 | 0, 1060544 | 0);
  abort();
 }
 
 function core__fmt__builders__DebugMap__entries__hc6ee37e6fbcec1a8($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   $3 = HEAP32[($1 + 32 | 0) >> 2] | 0;
   if (!$3) {
    break label$1
   }
   $1 = HEAP32[($3 + 100 | 0) >> 2] | 0;
   if (($1 | 0) == ($3 | 0)) {
    break label$1
   }
   if (!$1) {
    break label$1
   }
   label$2 : while (1) {
    $4 = HEAP32[($1 + 100 | 0) >> 2] | 0;
    HEAP32[($2 + 8 | 0) >> 2] = $1;
    HEAP32[($2 + 12 | 0) >> 2] = $1 + 48 | 0;
    core__fmt__builders__DebugMap__entry__he6646ea181c84a56($0 | 0, $2 + 8 | 0 | 0, 1061168 | 0, $2 + 12 | 0 | 0, 1061168 | 0) | 0;
    if (($4 | 0) == ($3 | 0)) {
     break label$1
    }
    $1 = $4;
    if ($1) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $2 + 16 | 0;
  return $0 | 0;
 }
 
 function cardano_serialization_lib__tx_builder__TransactionBuilder__set_inputs__h2784cea4137e09c9($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 144 | 0;
  global$0 = $2;
  $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__hc97a6f621815d13c($2 + 64 | 0 | 0, $1 + 64 | 0 | 0);
  $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__hf9a33b4634734bb7(($2 + 80 | 0) + 40 | 0 | 0, $1 + 40 | 0 | 0);
  $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h023fc265abc510b5($2 + 80 | 0 | 0, $1 | 0);
  $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__hf5a9da539450c63e(($2 + 80 | 0) + 52 | 0 | 0, $1 + 52 | 0 | 0);
  $2 = memcpy($2 | 0, $2 + 80 | 0 | 0, 64 | 0) | 0;
  $1 = $0 + 96 | 0;
  core__ptr__drop_in_place_cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder___h60f2b953eb0eea7f($1 | 0);
  memcpy($1 | 0, $2 | 0, 80 | 0) | 0;
  global$0 = $2 + 144 | 0;
 }
 
 function cardano_serialization_lib__tx_builder__TransactionBuilder__set_collateral__hc235465b455fdf49($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 144 | 0;
  global$0 = $2;
  $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__hc97a6f621815d13c($2 + 64 | 0 | 0, $1 + 64 | 0 | 0);
  $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__hf9a33b4634734bb7(($2 + 80 | 0) + 40 | 0 | 0, $1 + 40 | 0 | 0);
  $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h023fc265abc510b5($2 + 80 | 0 | 0, $1 | 0);
  $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__hf5a9da539450c63e(($2 + 80 | 0) + 52 | 0 | 0, $1 + 52 | 0 | 0);
  $2 = memcpy($2 | 0, $2 + 80 | 0 | 0, 64 | 0) | 0;
  $1 = $0 + 176 | 0;
  core__ptr__drop_in_place_cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder___h60f2b953eb0eea7f($1 | 0);
  memcpy($1 | 0, $2 | 0, 80 | 0) | 0;
  global$0 = $2 + 144 | 0;
 }
 
 function alloc__vec__Vec_T_2cA___extend_desugared__hcde58f85dd1ec03b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 128 | 0;
  global$0 = $2;
  $core__iter__adapters__cloned__Cloned_I__20as_20core__iter__traits__iterator__Iterator___next__h2e192ec8b52ada0a($2 | 0, $1 | 0);
  label$1 : {
   if ((HEAP32[($2 + 72 | 0) >> 2] | 0 | 0) == (2 | 0)) {
    break label$1
   }
   label$2 : while (1) {
    label$3 : {
     $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
     if ((HEAP32[($0 + 4 | 0) >> 2] | 0 | 0) != ($3 | 0)) {
      break label$3
     }
     alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hf135acf924159ceb($0 | 0, $3 | 0, 1 | 0);
    }
    memcpy((HEAP32[$0 >> 2] | 0) + ($3 << 7 | 0) | 0 | 0, $2 | 0, 128 | 0) | 0;
    HEAP32[($0 + 8 | 0) >> 2] = $3 + 1 | 0;
    $core__iter__adapters__cloned__Cloned_I__20as_20core__iter__traits__iterator__Iterator___next__h2e192ec8b52ada0a($2 | 0, $1 | 0);
    if ((HEAP32[($2 + 72 | 0) >> 2] | 0 | 0) != (2 | 0)) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $2 + 128 | 0;
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___remove_entry__h0ced826aed6ac5e1($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, i64toi32_i32$1 = 0;
  $3 = global$0 - 32 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    label$3 : {
     $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
     if (!$4) {
      break label$3
     }
     alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__h7cca0af434b441f5($3 | 0, HEAP32[$1 >> 2] | 0 | 0, $4 | 0, $2 | 0);
     if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
      break label$2
     }
     HEAP32[($3 + 24 | 0) >> 2] = HEAP32[($3 + 12 | 0) >> 2] | 0;
     i64toi32_i32$1 = HEAP32[($3 + 8 | 0) >> 2] | 0;
     HEAP32[($3 + 16 | 0) >> 2] = HEAP32[($3 + 4 | 0) >> 2] | 0;
     HEAP32[($3 + 20 | 0) >> 2] = i64toi32_i32$1;
     HEAP32[($3 + 28 | 0) >> 2] = $1;
     alloc__collections__btree__map__entry__OccupiedEntry_K_2cV___remove_kv__hdf50ae66bbd838a5($0 | 0, $3 + 16 | 0 | 0);
     break label$1;
    }
    HEAP32[$0 >> 2] = 0;
    break label$1;
   }
   HEAP32[$0 >> 2] = 0;
  }
  global$0 = $3 + 32 | 0;
 }
 
 function redeemers_total_ex_units($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $25 = 0, $25$hi = 0, $28 = 0, $28$hi = 0;
  $1 = global$0 - 32 | 0;
  global$0 = $1;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h6789b4b005d0c63f($1 | 0, $0 | 0);
    $0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    cardano_serialization_lib__plutus__Redeemers__total_ex_units__h8d7844499459197f($1 + 8 | 0 | 0, HEAP32[$1 >> 2] | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    if ((HEAP32[($1 + 8 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    i64toi32_i32$2 = $1 + 16 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $25 = i64toi32_i32$0;
    $25$hi = i64toi32_i32$1;
    i64toi32_i32$2 = $1 + 24 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $28 = i64toi32_i32$1;
    $28$hi = i64toi32_i32$0;
    i64toi32_i32$0 = $25$hi;
    i64toi32_i32$1 = $28$hi;
    $0 = $cardano_serialization_lib__plutus__ExUnits_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h4867c49ddc624134($25 | 0, i64toi32_i32$0 | 0, $28 | 0, i64toi32_i32$1 | 0) | 0;
    global$0 = $1 + 32 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($1 + 12 | 0) >> 2] | 0 | 0);
  abort();
 }
 
 function core__iter__adapters__zip__Zip_A_2cB___new__h67510e7a2d59e29c($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $4 = 0, $5 = 0, $11 = 0, $30 = 0;
  HEAP32[($0 + 36 | 0) >> 2] = 0;
  HEAP32[($0 + 28 | 0) >> 2] = $2;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $11 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[$0 >> 2] = $11;
  HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($0 + 32 | 0) >> 2] = $3;
  HEAP32[($0 + 24 | 0) >> 2] = HEAP32[($1 + 24 | 0) >> 2] | 0;
  $4 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  HEAP32[($0 + 20 | 0) >> 2] = $4;
  $5 = HEAP32[($1 + 16 | 0) >> 2] | 0;
  HEAP32[($0 + 16 | 0) >> 2] = $5;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $1 = $4 - $5 | 0;
  HEAP32[($0 + 44 | 0) >> 2] = $1;
  $3 = ($3 - $2 | 0) >>> 4 | 0;
  HEAP32[($0 + 40 | 0) >> 2] = $1 >>> 0 > $3 >>> 0 ? $3 : $1;
 }
 
 function rand_os__OsRng__new__hc49e74e2fe75aed3($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $13 = 0, $16 = 0, $28 = 0;
  $1 = global$0 - 32 | 0;
  global$0 = $1;
  $rand_os__wasm32_bindgen__OsRng_20as_20rand_os__OsRngImpl___new__h36d65edbabadd602($1 + 8 | 0 | 0);
  $2 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($1 + 8 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    i64toi32_i32$2 = $1;
    i64toi32_i32$0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 16 | 0) >> 2] | 0;
    $13 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $13;
    HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
    $2 = 0;
    break label$1;
   }
   i64toi32_i32$2 = $1;
   i64toi32_i32$1 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($1 + 16 | 0) >> 2] | 0;
   $16 = i64toi32_i32$1;
   i64toi32_i32$1 = $0;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = $16;
   HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
   HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = HEAP32[(($1 + 8 | 0) + 20 | 0) >> 2] | 0;
   i64toi32_i32$2 = ($1 + 8 | 0) + 12 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $28 = i64toi32_i32$0;
   i64toi32_i32$0 = $0 + 12 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $28;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $1 + 32 | 0;
 }
 
 function cryptoxide__curve25519__ge__Ge__to_bytes__hce32fa3f32cec513($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 128 | 0;
  global$0 = $2;
  cryptoxide__curve25519__fe___impl_20cryptoxide__curve25519__fe__fe64__Fe___invert__ha7ca879e8b04dd36($2 + 88 | 0 | 0, $1 + 80 | 0 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($2 + 8 | 0 | 0, $1 | 0, $2 + 88 | 0 | 0);
  $3 = ($2 + 8 | 0) + 40 | 0;
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($3 | 0, $1 + 40 | 0 | 0, $2 + 88 | 0 | 0);
  cryptoxide__curve25519__fe__fe64__Fe__to_bytes__h64ae4f7608fd99b8($0 | 0, $3 | 0);
  cryptoxide__curve25519__fe__fe64__Fe__to_packed__h856c6b32110c5ed6($2 + 88 | 0 | 0, $2 + 8 | 0 | 0);
  HEAP8[($0 + 31 | 0) >> 0] = (HEAPU8[($0 + 31 | 0) >> 0] | 0) ^ ((HEAPU8[($2 + 88 | 0) >> 0] | 0) << 7 | 0) | 0;
  global$0 = $2 + 128 | 0;
 }
 
 function core__fmt__builders__DebugStruct__finish__hb1eae1aa0e288840($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = HEAPU8[($0 + 4 | 0) >> 0] | 0;
  label$1 : {
   if (!(HEAPU8[($0 + 5 | 0) >> 0] | 0)) {
    break label$1
   }
   $2 = $1 & 255 | 0;
   $1 = 1;
   label$2 : {
    if ($2) {
     break label$2
    }
    label$3 : {
     $1 = HEAP32[$0 >> 2] | 0;
     if ((HEAPU8[$1 >> 0] | 0) & 4 | 0) {
      break label$3
     }
     $1 = FUNCTION_TABLE[HEAP32[((HEAP32[($1 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($1 + 24 | 0) >> 2] | 0, 1149891, 2) | 0;
     break label$2;
    }
    $1 = FUNCTION_TABLE[HEAP32[((HEAP32[($1 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($1 + 24 | 0) >> 2] | 0, 1149877, 1) | 0;
   }
   HEAP8[($0 + 4 | 0) >> 0] = $1;
  }
  return ($1 & 255 | 0 | 0) != (0 | 0) | 0;
 }
 
 function $cardano_serialization_lib__TransactionInputs_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h1c7a61cc309722a9($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $21 = 0, $24 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h7dc8ec51bf9127a6($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $21;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 16 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function $cardano_serialization_lib__TransactionOutputs_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h9d1c1bfec732029a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $21 = 0, $24 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hb231bc98a91fbbb7($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $21;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 16 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function $cardano_serialization_lib__Certificates_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h8f099e7b0499b7a3($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $21 = 0, $24 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h6e4f06a418081d49($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $21;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 16 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function $cardano_serialization_lib__Ed25519KeyHashes_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hee5d1abe59d78bf5($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $21 = 0, $24 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hcf0411f2252ca14a($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $21;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 16 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function $cardano_serialization_lib__Relays_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hd94de6e40e898f19($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $21 = 0, $24 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h7554f81066822c17($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $21;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 16 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function $cardano_serialization_lib__URL_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h0b027dceb3465fa8($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $21 = 0, $24 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h24ec40b16d3308f2($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $21;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 16 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function $cardano_serialization_lib__DNSRecordAorAAAA_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hc4f20f912382f9ac($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $21 = 0, $24 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h1ad0c5a49f4f60b7($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $21;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 16 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function $cardano_serialization_lib__DNSRecordSRV_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h8f84187837c24089($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $21 = 0, $24 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hb2fe413b90565871($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $21;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 16 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function $cardano_serialization_lib__MultiHostName_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h328453487bb71b9d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $21 = 0, $24 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h1c32993c268a4012($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $21;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 16 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function $cardano_serialization_lib__StakeCredentials_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h829ea11109d33acc($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $21 = 0, $24 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h061555eda9801069($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $21;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 16 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function $cardano_serialization_lib__RewardAddresses_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hcdf800cf37b3247e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $21 = 0, $24 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hf18176d31e9af7c8($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $21;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 16 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function cardano_serialization_lib__TransactionWitnessSet__set_plutus_data__h01fb3bfe431fcf6c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $23 = 0, $26 = 0, $32 = 0, $35 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hc831120dea694494($2 + 16 | 0 | 0, $1 | 0);
  $1 = HEAPU8[($1 + 12 | 0) >> 0] | 0;
  HEAP8[($2 + 28 | 0) >> 0] = ($1 | 0) == (2 | 0) ? 2 : ($1 | 0) != (0 | 0);
  $1 = $2 + 8 | 0;
  i64toi32_i32$2 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $23 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[i64toi32_i32$0 >> 2] = $23;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[($2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  $26 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[$2 >> 2] = $26;
  HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$0;
  core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__plutus__PlutusList____h410d2d25125e861e($0 + 48 | 0 | 0);
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $32 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 56 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $32;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $35 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[(i64toi32_i32$1 + 48 | 0) >> 2] = $35;
  HEAP32[(i64toi32_i32$1 + 52 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 32 | 0;
 }
 
 function $cardano_serialization_lib__ScriptAll_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h69640ba2c20af1f4($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $21 = 0, $24 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h009172765b98cd49($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $21;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 16 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function $cardano_serialization_lib__ScriptAny_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h860535ffc5169bd5($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $21 = 0, $24 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h9e52e116c2bb3e9f($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $21;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 16 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function $cardano_serialization_lib__NativeScripts_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h0ac513c0d46c16e0($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $21 = 0, $24 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h1227f23aa068e55a($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $21;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 16 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function $cardano_serialization_lib__GenesisHashes_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h10b95e2982532a00($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $21 = 0, $24 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h776bc08da2f877b7($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $21;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 16 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function $cardano_serialization_lib__ScriptHashes_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__ha1b6a463a08200a3($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $21 = 0, $24 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hb5d69d43b863633b($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $21;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 16 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function $cardano_serialization_lib__ProtocolVersions_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h57b06560daba22b7($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $21 = 0, $24 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h6f896cc1d65c94a7($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $21;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 16 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function $cardano_serialization_lib__TransactionBodies_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h03066b841682f9b2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $21 = 0, $24 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hb2d5e2416ce5f734($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $21;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 16 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function $cardano_serialization_lib__TransactionWitnessSets_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h47439a7417855d0d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $21 = 0, $24 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hf0272a72391b2a3a($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $21;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 16 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function $cardano_serialization_lib__AssetName_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h47e91eaa082cd83a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $21 = 0, $24 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h56eea9784c6427d6($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $21;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 16 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function $cardano_serialization_lib__AssetNames_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h4f6eb653cae27250($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $21 = 0, $24 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h35a89179297fae2a($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $21;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 16 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function $cardano_serialization_lib__Assets_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h87a1c4ff7df56b93($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $21 = 0, $24 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hf24f358605852732($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $21;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 16 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function $cardano_serialization_lib__MultiAsset_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hbbf1fa03090b6b60($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $21 = 0, $24 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hbb430c180f3ec4b2($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $21;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 16 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function $cardano_serialization_lib__MintAssets_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h346090e2c1141630($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $21 = 0, $24 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h8bccc78f842f4f24($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $21;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 16 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function $cardano_serialization_lib__Mint_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__ha22e70587b3386a3($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $21 = 0, $24 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h17bb811378ba5c0a($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $21;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 16 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function serde_json__value__from___impl_20core__convert__From_alloc__vec__Vec_T___20for_20serde_json__value__Value___from__h2b11e91c39ca0ab7($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, i64toi32_i32$1 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $3 = $2 + 8 | 0;
  HEAP32[$3 >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  HEAP32[$2 >> 2] = HEAP32[$1 >> 2] | 0;
  HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$1;
  alloc__raw_vec__RawVec_T_2cA___allocator__hac7e8c134c0e2bb4($2 | 0) | 0;
  $4 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $1 = HEAP32[$2 >> 2] | 0;
  HEAP32[($2 + 12 | 0) >> 2] = $1 + Math_imul(HEAP32[$3 >> 2] | 0, 24) | 0;
  HEAP32[($2 + 8 | 0) >> 2] = $1;
  HEAP32[($2 + 4 | 0) >> 2] = $4;
  HEAP32[$2 >> 2] = $1;
  alloc__vec__source_iter_marker___impl_20alloc__vec__spec_from_iter__SpecFromIter_T_2cI__20for_20alloc__vec__Vec_T____from_iter__hd552edaa5a6894ae($0 + 4 | 0 | 0, $2 | 0);
  HEAP8[$0 >> 0] = 4;
  global$0 = $2 + 16 | 0;
 }
 
 function core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9_4($0) {
  $0 = $0 | 0;
  core__ptr__drop_in_place_core__option__Option_alloc__string__String____h8c3a778692ea673c($0 + 48 | 0 | 0);
  label$1 : {
   label$2 : {
    switch ((HEAPU8[$0 >> 0] | 0) + -2 | 0 | 0) {
    case 0:
     core__ptr__drop_in_place_cbor_event__error__Error___hbf0141ec70b68c45_4($0 + 8 | 0 | 0);
     return;
    case 2:
     core__ptr__drop_in_place_cardano_serialization_lib__error__Key___h6509e27f4cf6a188_1($0 + 8 | 0 | 0);
     return;
    case 6:
     core__ptr__drop_in_place_cardano_serialization_lib__error__Key___h6509e27f4cf6a188_1($0 + 8 | 0 | 0);
     core__ptr__drop_in_place_cardano_serialization_lib__error__Key___h6509e27f4cf6a188_1($0 + 24 | 0 | 0);
     return;
    case 7:
     core__ptr__drop_in_place_cardano_serialization_lib__error__Key___h6509e27f4cf6a188_1($0 + 8 | 0 | 0);
     return;
    case 8:
     $0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
     if ($0 >>> 0 < 36 >>> 0) {
      break label$1
     }
     wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($0 | 0);
     return;
    case 14:
     break label$2;
    default:
     break label$1;
    };
   }
   core__ptr__drop_in_place_cardano_serialization_lib__error__Key___h6509e27f4cf6a188_1($0 + 8 | 0 | 0);
  }
 }
 
 function $cardano_serialization_lib__utils__TransactionUnspentOutputs_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hf063c6518397141d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $21 = 0, $24 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h3c331aa05f471767($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $21;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 16 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function $cardano_serialization_lib__utils__Value_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h5b82be58e99ac2f6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $2 = 0, $3 = 0, $3$hi = 0, $21 = 0, $4 = 0, $4$hi = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__ha9ddcb0fc94d348b($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $3 = i64toi32_i32$0;
  $3$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $21;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1 + 24 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $3$hi;
  i64toi32_i32$0 = $0 + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $3;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $4$hi;
  i64toi32_i32$0 = $0 + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $4;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 32 | 0, 8 | 0);
  global$0 = $2 + 48 | 0;
 }
 
 function bigint_as_u64($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $2$hi = 0;
  $1 = global$0 - 32 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb4a7701b5bc2a87c($1 + 24 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 28 | 0) >> 2] | 0;
   cardano_serialization_lib__utils__BigInt__as_u64__h39047f01ff5b286b($1 + 8 | 0 | 0, HEAP32[($1 + 24 | 0) >> 2] | 0 | 0);
   i64toi32_i32$0 = HEAP32[($1 + 16 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($1 + 20 | 0) >> 2] | 0;
   $2 = i64toi32_i32$0;
   $2$hi = i64toi32_i32$1;
   i64toi32_i32$1 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   label$2 : {
    label$3 : {
     if (i64toi32_i32$1) {
      break label$3
     }
     $0 = 0;
     break label$2;
    }
    i64toi32_i32$0 = $2$hi;
    $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810($2 | 0, i64toi32_i32$0 | 0) | 0;
   }
   global$0 = $1 + 32 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function $cardano_serialization_lib__metadata__MetadataList_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hbc03d780ecbefcca($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $21 = 0, $24 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h8fa773adf60ecc95($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $21;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 16 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function transactionmetadatum_new_list($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 112 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h14eb25306bbe3311($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hf69db734dd831996($1 + 16 | 0 | 4 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
  HEAP32[($1 + 16 | 0) >> 2] = 1;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  memcpy($1 + 64 | 0 | 0, $1 + 16 | 0 | 0, 48 | 0) | 0;
  $0 = $cardano_serialization_lib__metadata__TransactionMetadatum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hce2feba55b67d086($1 + 64 | 0 | 0) | 0;
  global$0 = $1 + 112 | 0;
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__metadata__TransactionMetadatumLabels_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hd455b80b8fa28b24($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $21 = 0, $24 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h6d906a27126b3b1d($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $21;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 16 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function cardano_serialization_lib__impl_mockchain__key__EitherEd25519SecretKey__to_public__hd7cd5c1f2cabbdb8($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $2 = 0, $11 = 0, $12 = 0, $13 = 0, $14 = 0, $3 = 0, $20 = 0, $25 = 0, $30 = 0, $33 = 0;
  $2 = global$0 - 96 | 0;
  global$0 = $2;
  $3 = $1 + 1 | 0;
  label$1 : {
   label$2 : {
    if ((HEAPU8[$1 >> 0] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    cryptoxide__ed25519__extended_to_public__hb7e9895dfbf0ff6d($0 | 0, $3 | 0);
    break label$1;
   }
   cryptoxide__ed25519__keypair__h6b6b782bee48c38f($2 | 0, $3 | 0);
   i64toi32_i32$2 = $2 + 88 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $20 = i64toi32_i32$0;
   i64toi32_i32$0 = $0 + 24 | 0;
   $11 = $20;
   HEAP8[i64toi32_i32$0 >> 0] = $11;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = $2 + 80 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $25 = i64toi32_i32$1;
   i64toi32_i32$1 = $0 + 16 | 0;
   $12 = $25;
   HEAP8[i64toi32_i32$1 >> 0] = $12;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $12 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $12 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $12 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $2 + 72 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $30 = i64toi32_i32$0;
   i64toi32_i32$0 = $0 + 8 | 0;
   $13 = $30;
   HEAP8[i64toi32_i32$0 >> 0] = $13;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $13 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $13 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $13 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 64 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 68 | 0) >> 2] | 0;
   $33 = i64toi32_i32$1;
   i64toi32_i32$1 = $0;
   $14 = $33;
   HEAP8[i64toi32_i32$1 >> 0] = $14;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $14 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $14 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $14 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  }
  global$0 = $2 + 96 | 0;
 }
 
 function $cardano_serialization_lib__chain_crypto__sign__SignatureFromStrError_20as_20core__fmt__Debug___fmt__h48c955749b11c8b6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $3 = $0 + 4 | 0;
  label$1 : {
   label$2 : {
    if ((HEAP32[$0 >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1063596 | 0, 12 | 0);
    HEAP32[($2 + 12 | 0) >> 2] = $3;
    core__fmt__builders__DebugTuple__field__h5e7e3e19ad5aa557($2 | 0, $2 + 12 | 0 | 0, 1063532 | 0) | 0;
    break label$1;
   }
   core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1063570 | 0, 7 | 0);
   HEAP32[($2 + 12 | 0) >> 2] = $3;
   core__fmt__builders__DebugTuple__field__h5e7e3e19ad5aa557($2 | 0, $2 + 12 | 0 | 0, 1063580 | 0) | 0;
  }
  $0 = core__fmt__builders__DebugTuple__finish__hc3c3f1efaa75a6e2($2 | 0) | 0;
  global$0 = $2 + 16 | 0;
  return $0 | 0;
 }
 
 function transactionbuilder_add_required_native_input_scripts($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h5566e1c7d4aafe35($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hbfc7b2ba05921680($2 | 0, $1 | 0);
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $1 = cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__add_required_native_input_scripts__h855e8fd3c83a9c4c($4 + 96 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return $1 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionbuilder_add_required_plutus_input_scripts($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h5566e1c7d4aafe35($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hff8ea54f5a18a01d($2 | 0, $1 | 0);
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $1 = cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__add_required_plutus_input_scripts__hba7e8d5bf0a2077d($4 + 96 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return $1 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function $cardano_serialization_lib__crypto__Vkeys_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h3946458ff227fb6c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $21 = 0, $24 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hc08699f22fda04d6($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $21;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 16 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function $cardano_serialization_lib__crypto__Vkeywitnesses_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hfc014afe9914e142($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $21 = 0, $24 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h1c7f0e3050b987b8($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $21;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 16 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function $cardano_serialization_lib__crypto__BootstrapWitnesses_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h2fdd75b2a1d8f23b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $21 = 0, $24 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h24c88156dad2ef97($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $21;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 16 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function $cardano_serialization_lib__crypto__PublicKeys_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h45febc60c137f200($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $21 = 0, $24 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h48ae624d339b329f($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $21;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 16 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function $cardano_serialization_lib__crypto__KESSignature_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h02d886869b7129a6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $21 = 0, $24 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h2cc4f80e3a10a5cf($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $21;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 16 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function cardano_serialization_lib__tx_builder__tx_inputs_builder__PlutusWitness__new__h08627c59068b8908($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $4 = 0, i64toi32_i32$0 = 0, $5 = 0, $5$hi = 0, $26 = 0, $33 = 0;
  $4 = global$0 - 80 | 0;
  global$0 = $4;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($0 + 128 | 0 | 0, $1 | 0);
  $cardano_serialization_lib__plutus__PlutusData_20as_20core__clone__Clone___clone__h63d1a98cc18f4609_1($0 | 0, $2 | 0);
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $5 = i64toi32_i32$0;
  $5$hi = i64toi32_i32$1;
  $2 = HEAPU8[(i64toi32_i32$2 + 72 | 0) >> 0] | 0;
  $cardano_serialization_lib__plutus__PlutusData_20as_20core__clone__Clone___clone__h63d1a98cc18f4609_1($4 + 8 | 0 | 0, i64toi32_i32$2 + 8 | 0 | 0);
  i64toi32_i32$2 = i64toi32_i32$2 + 64 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $26 = i64toi32_i32$1;
  i64toi32_i32$1 = $4 + 64 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $26;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP8[($4 + 72 | 0) >> 0] = $2;
  i64toi32_i32$0 = $5$hi;
  i64toi32_i32$1 = $4;
  HEAP32[i64toi32_i32$1 >> 2] = $5;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 56 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 60 | 0) >> 2] | 0;
  $33 = i64toi32_i32$0;
  i64toi32_i32$0 = $4;
  HEAP32[($4 + 56 | 0) >> 2] = $33;
  HEAP32[($4 + 60 | 0) >> 2] = i64toi32_i32$1;
  memcpy($0 + 48 | 0 | 0, $4 | 0, 80 | 0) | 0;
  global$0 = $4 + 80 | 0;
 }
 
 function $cardano_serialization_lib__tx_builder__tx_inputs_builder__PlutusWitnesses_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h866260b7595d8928($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $21 = 0, $24 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hd69c4b5985a5a825($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $21;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 16 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function cardano_serialization_lib__address__ByronAddress__is_valid__h820ad8424488f77c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  $cardano_serialization_lib__legacy_address__address__ExtendedAddr_20as_20core__str__traits__FromStr___from_str__h32affa00e2d5d659($2 | 0, $0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    $0 = HEAP32[$2 >> 2] | 0;
    if (($0 | 0) == (1 | 0)) {
     break label$2
    }
    memcpy($2 + 56 | 0 | 0, $2 | 4 | 0 | 0, 52 | 0) | 0;
    core__ptr__drop_in_place_cardano_serialization_lib__legacy_address__address__ExtendedAddr___h2c1a18aefeee766f($2 + 56 | 0 | 0);
    break label$1;
   }
   memcpy($2 + 56 | 0 | 0, $2 + 8 | 0 | 0, 48 | 0) | 0;
   if (HEAP32[($2 + 56 | 0) >> 2] | 0) {
    break label$1
   }
   core__ptr__drop_in_place_cbor_event__error__Error___hbf0141ec70b68c45(($2 + 56 | 0) + 8 | 0 | 0);
  }
  global$0 = $2 + 112 | 0;
  return !$0 | 0;
 }
 
 function $cardano_serialization_lib__address__Pointer_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h02e1203ff329374c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $2 = 0, $3 = 0, $3$hi = 0, $21 = 0, $4 = 0, $4$hi = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h14776c1c2f845163($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $3 = i64toi32_i32$0;
  $3$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $21;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1 + 24 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $3$hi;
  i64toi32_i32$0 = $0 + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $3;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $4$hi;
  i64toi32_i32$0 = $0 + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $4;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 32 | 0, 8 | 0);
  global$0 = $2 + 48 | 0;
 }
 
 function $cardano_serialization_lib__plutus__PlutusScript_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__he5f731d402530c18($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $21 = 0, $24 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h08b9ef3d4f949db8($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $21;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 16 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function plutusscript_new($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  HEAP32[($2 + 40 | 0) >> 2] = $1;
  HEAP32[($2 + 36 | 0) >> 2] = $1;
  HEAP32[($2 + 32 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 + 8 | 0 | 0, $2 + 32 | 0 | 0);
  $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  HEAP32[(($2 + 32 | 0) + 8 | 0) >> 2] = HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  HEAP32[($2 + 32 | 0) >> 2] = HEAP32[($2 + 16 | 0) >> 2] | 0;
  HEAP32[($2 + 36 | 0) >> 2] = i64toi32_i32$1;
  $1 = $cardano_serialization_lib__plutus__PlutusScript_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h588df014a764c544($2 + 32 | 0 | 0) | 0;
  global$0 = $2 + 48 | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__plutus__PlutusScripts_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h09ea19d5ec38c396($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $21 = 0, $24 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h60cc26adb5968dc4($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $21;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 16 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function $cardano_serialization_lib__plutus__ConstrPlutusData_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__haa86bff1ee3e442b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $2 = 0, $3 = 0, $3$hi = 0, $21 = 0, $4 = 0, $4$hi = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h5835baad1f806fc3($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $3 = i64toi32_i32$0;
  $3$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $21;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1 + 24 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $3$hi;
  i64toi32_i32$0 = $0 + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $3;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $4$hi;
  i64toi32_i32$0 = $0 + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $4;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 32 | 0, 8 | 0);
  global$0 = $2 + 48 | 0;
 }
 
 function $cardano_serialization_lib__plutus__CostModel_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h74e6f0d207e1a011($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $21 = 0, $24 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hbe92ab119edf5148($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $21;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 16 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function $cardano_serialization_lib__plutus__Costmdls_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hc9c090dbe2ba6b95($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $21 = 0, $24 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h01f36213dd513b30($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $21;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 16 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function $cardano_serialization_lib__plutus__Languages_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h3c02acc30fcff953($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $21 = 0, $24 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h3dcba3638ab0c9bc($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $21;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 16 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function $cardano_serialization_lib__plutus__PlutusMap_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hca9530ce8ba44c67($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $21 = 0, $24 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h7a45263e953750b2($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $21;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 16 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function $cardano_serialization_lib__plutus__Redeemers_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h084b0da55ab35e33($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $21 = 0, $24 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__ha681df4b192f3b9b($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $21;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 16 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function $cardano_serialization_lib__plutus__Strings_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h602d16eb9eff76e7($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $21 = 0, $24 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hbc201b8ccd6b711d($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $21;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 20 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 24 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $24;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($2 + 28 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 16 | 0, 4 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function $cardano_serialization_lib__legacy_address__address__ParseExtendedAddrError_20as_20core__fmt__Debug___fmt__hd53eb848259e4159($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if ((HEAP32[$0 >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1072792 | 0, 13 | 0);
    HEAP32[($2 + 12 | 0) >> 2] = $0 + 8 | 0;
    core__fmt__builders__DebugTuple__field__h5e7e3e19ad5aa557($2 | 0, $2 + 12 | 0 | 0, 1072808 | 0) | 0;
    break label$1;
   }
   core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1072763 | 0, 11 | 0);
   HEAP32[($2 + 12 | 0) >> 2] = $0 + 4 | 0;
   core__fmt__builders__DebugTuple__field__h5e7e3e19ad5aa557($2 | 0, $2 + 12 | 0 | 0, 1072776 | 0) | 0;
  }
  $0 = core__fmt__builders__DebugTuple__finish__hc3c3f1efaa75a6e2($2 | 0) | 0;
  global$0 = $2 + 16 | 0;
  return $0 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___allocate_in__hb0817f92bbb8999a($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     if (($1 & 1073741823 | 0 | 0) != ($1 | 0)) {
      break label$3
     }
     $1 = $1 << 2 | 0;
     if (($1 | 0) < (0 | 0)) {
      break label$3
     }
     label$4 : {
      label$5 : {
       label$6 : {
        if ($2) {
         break label$6
        }
        if ($1) {
         break label$5
        }
        break label$2;
       }
       if (!$1) {
        break label$2
       }
       $2 = __rust_alloc_zeroed($1 | 0, 4 | 0) | 0;
       if (!$2) {
        break label$4
       }
       break label$1;
      }
      $2 = __rust_alloc($1 | 0, 4 | 0) | 0;
      if ($2) {
       break label$1
      }
     }
     alloc__alloc__handle_alloc_error__he269d8f1bff90960($1 | 0, 4 | 0);
     abort();
    }
    alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
    abort();
   }
   $2 = 4;
  }
  HEAP32[$0 >> 2] = $2;
  HEAP32[($0 + 4 | 0) >> 2] = $1 >>> 2 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___allocate_in__h5dada854c892eb3e($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     if (($1 & 1073741823 | 0 | 0) != ($1 | 0)) {
      break label$3
     }
     $1 = $1 << 2 | 0;
     if (($1 | 0) < (0 | 0)) {
      break label$3
     }
     label$4 : {
      label$5 : {
       label$6 : {
        if ($2) {
         break label$6
        }
        if ($1) {
         break label$5
        }
        break label$2;
       }
       if (!$1) {
        break label$2
       }
       $2 = __rust_alloc_zeroed($1 | 0, 4 | 0) | 0;
       if (!$2) {
        break label$4
       }
       break label$1;
      }
      $2 = __rust_alloc($1 | 0, 4 | 0) | 0;
      if ($2) {
       break label$1
      }
     }
     alloc__alloc__handle_alloc_error__he269d8f1bff90960($1 | 0, 4 | 0);
     abort();
    }
    alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
    abort();
   }
   $2 = 4;
  }
  HEAP32[$0 >> 2] = $2;
  HEAP32[($0 + 4 | 0) >> 2] = $1 >>> 2 | 0;
 }
 
 function cryptoxide__curve25519__ge__GePartial__to_bytes__he4403e81f32db859($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  cryptoxide__curve25519__fe___impl_20cryptoxide__curve25519__fe__fe64__Fe___invert__ha7ca879e8b04dd36($2 + 8 | 0 | 0, $1 + 80 | 0 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($2 + 48 | 0 | 0, $1 | 0, $2 + 8 | 0 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($2 + 88 | 0 | 0, $1 + 40 | 0 | 0, $2 + 8 | 0 | 0);
  cryptoxide__curve25519__fe__fe64__Fe__to_bytes__h64ae4f7608fd99b8($0 | 0, $2 + 88 | 0 | 0);
  cryptoxide__curve25519__fe__fe64__Fe__to_packed__h856c6b32110c5ed6($2 + 128 | 0 | 0, $2 + 48 | 0 | 0);
  HEAP8[($0 + 31 | 0) >> 0] = (HEAPU8[($0 + 31 | 0) >> 0] | 0) ^ ((HEAPU8[($2 + 128 | 0) >> 0] | 0) << 7 | 0) | 0;
  global$0 = $2 + 160 | 0;
 }
 
 function memmove($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  label$1 : {
   label$2 : {
    if (($0 - $1 | 0) >>> 0 >= $2 >>> 0) {
     break label$2
    }
    $1 = $1 + -1 | 0;
    $3 = $0 + -1 | 0;
    label$3 : while (1) {
     HEAP8[($3 + $2 | 0) >> 0] = HEAPU8[($1 + $2 | 0) >> 0] | 0;
     $2 = $2 + -1 | 0;
     if ($2) {
      continue label$3
     }
     break label$1;
    };
   }
   if (!$2) {
    break label$1
   }
   $3 = $0;
   label$4 : while (1) {
    HEAP8[$3 >> 0] = HEAPU8[$1 >> 0] | 0;
    $1 = $1 + 1 | 0;
    $3 = $3 + 1 | 0;
    $2 = $2 + -1 | 0;
    if ($2) {
     continue label$4
    }
    break label$4;
   };
  }
  return $0 | 0;
 }
 
 function operationalcert_sigma($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 144 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h4b15d475a6cbc138($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  memcpy($1 + 16 | 0 | 0, (HEAP32[($1 + 8 | 0) >> 2] | 0) + 40 | 0 | 0, 64 | 0) | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  memcpy($1 + 80 | 0 | 0, $1 + 16 | 0 | 0, 64 | 0) | 0;
  $0 = $cardano_serialization_lib__crypto__Ed25519Signature_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h20d7210aa6eb2b19($1 + 80 | 0 | 0) | 0;
  global$0 = $1 + 144 | 0;
  return $0 | 0;
 }
 
 function transactionbuilder_min_fee($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 32 | 0;
  global$0 = $1;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h37dfbd2f31d951c1($1 + 8 | 0 | 0, $0 | 0);
    $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    cardano_serialization_lib__tx_builder__TransactionBuilder__min_fee__h0562480e064561ee($1 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    if ((HEAP32[($1 + 16 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$1
    }
    i64toi32_i32$2 = $1 + 24 | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810(HEAP32[i64toi32_i32$2 >> 2] | 0 | 0, i64toi32_i32$1 | 0) | 0;
    global$0 = $1 + 32 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472(HEAP32[($1 + 20 | 0) >> 2] | 0 | 0);
  abort();
 }
 
 function vkeywitness_signature($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 144 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h9c2d3a72ebf4d25f($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  memcpy($1 + 16 | 0 | 0, (HEAP32[($1 + 8 | 0) >> 2] | 0) + 32 | 0 | 0, 64 | 0) | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  memcpy($1 + 80 | 0 | 0, $1 + 16 | 0 | 0, 64 | 0) | 0;
  $0 = $cardano_serialization_lib__crypto__Ed25519Signature_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h20d7210aa6eb2b19($1 + 80 | 0 | 0) | 0;
  global$0 = $1 + 144 | 0;
  return $0 | 0;
 }
 
 function bootstrapwitness_signature($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 144 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h76a11b605f70ebd5($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  memcpy($1 + 16 | 0 | 0, (HEAP32[($1 + 8 | 0) >> 2] | 0) + 56 | 0 | 0, 64 | 0) | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  memcpy($1 + 80 | 0 | 0, $1 + 16 | 0 | 0, 64 | 0) | 0;
  $0 = $cardano_serialization_lib__crypto__Ed25519Signature_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h20d7210aa6eb2b19($1 + 80 | 0 | 0) | 0;
  global$0 = $1 + 144 | 0;
  return $0 | 0;
 }
 
 function byronaddress_network_id($0) {
  $0 = $0 | 0;
  var i64toi32_i32$0 = 0, $1 = 0, i64toi32_i32$4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $2 = 0, i64toi32_i32$2 = 0, $2$hi = 0, $9 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h76f3e067f9139bb4($1 + 8 | 0 | 0, $0 | 0);
    $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    i64toi32_i32$0 = cardano_serialization_lib__address__ByronAddress__network_id__h46302a3365c1ef18(HEAP32[($1 + 8 | 0) >> 2] | 0 | 0) | 0;
    i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
    $2 = i64toi32_i32$0;
    $2$hi = i64toi32_i32$1;
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    i64toi32_i32$3 = 1;
    i64toi32_i32$0 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
    if (!!($2 & i64toi32_i32$3 | 0 | i64toi32_i32$0 | 0)) {
     break label$1
    }
    global$0 = $1 + 16 | 0;
    i64toi32_i32$0 = $2$hi;
    return ($2 >>> 8 | 0) & 255 | 0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  i64toi32_i32$0 = $2$hi;
  i64toi32_i32$1 = $2;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $9 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $9 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472($9 | 0);
  abort();
 }
 
 function address_network_id($0) {
  $0 = $0 | 0;
  var i64toi32_i32$0 = 0, $1 = 0, i64toi32_i32$4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $2 = 0, i64toi32_i32$2 = 0, $2$hi = 0, $9 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__hab2c0cbdcb539b91($1 + 8 | 0 | 0, $0 | 0);
    $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    i64toi32_i32$0 = cardano_serialization_lib__address__Address__network_id__h6a5da16b4c596a9d(HEAP32[($1 + 8 | 0) >> 2] | 0 | 0) | 0;
    i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
    $2 = i64toi32_i32$0;
    $2$hi = i64toi32_i32$1;
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    i64toi32_i32$3 = 1;
    i64toi32_i32$0 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
    if (!!($2 & i64toi32_i32$3 | 0 | i64toi32_i32$0 | 0)) {
     break label$1
    }
    global$0 = $1 + 16 | 0;
    i64toi32_i32$0 = $2$hi;
    return ($2 >>> 8 | 0) & 255 | 0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  i64toi32_i32$0 = $2$hi;
  i64toi32_i32$1 = $2;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $9 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $9 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$4 | 0) | 0;
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472($9 | 0);
  abort();
 }
 
 function serde_json__de__Deserializer_R___peek_error__hf8794e102c1db2df($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  $3 = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
  $4 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  serde_json__read__SliceRead__position_of_index__ha8a2610e8c8fa0b4($2 + 8 | 0 | 0, $0 | 0, ($4 >>> 0 > $3 >>> 0 ? $3 : $4) | 0);
  $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  HEAP32[($2 + 16 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$1;
  $0 = serde_json__error__Error__syntax__h11c9d7f40fe522f9($2 + 16 | 0 | 0, $3 | 0, $0 | 0) | 0;
  global$0 = $2 + 32 | 0;
  return $0 | 0;
 }
 
 function $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__hdfdbc3776b972463($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $3 = 0, $4 = 0, $5 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__next_or_end__h4700cd2d9ab1e572($1 | 0, $0 | 0);
  label$1 : {
   $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   if (!$2) {
    break label$1
   }
   label$2 : while (1) {
    label$3 : {
     $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
     $4 = $2 + Math_imul($3, 12) | 0;
     $5 = HEAP32[($4 + 272 | 0) >> 2] | 0;
     if (!$5) {
      break label$3
     }
     __rust_dealloc(HEAP32[($4 + 268 | 0) >> 2] | 0 | 0, $5 | 0, 1 | 0);
    }
    core__ptr__drop_in_place_serde_json__value__Value___hb5131c85f9c77304_2($2 + Math_imul($3, 24) | 0 | 0);
    $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__next_or_end__h4700cd2d9ab1e572($1 | 0, $0 | 0);
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if ($2) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $1 + 16 | 0;
 }
 
 function $cryptoxide__sha2__Sha512_20as_20cryptoxide__digest__Digest___input__h63322ce5a02a233a($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, $3 = 0, $5$hi = 0, $6$hi = 0, $4 = 0, $12 = 0, $5 = 0, $17$hi = 0, $22 = 0, $24 = 0, $24$hi = 0, $27 = 0, $28$hi = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  label$1 : {
   if (HEAPU8[($0 + 216 | 0) >> 0] | 0) {
    break label$1
   }
   $12 = $0;
   i64toi32_i32$2 = $0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $5 = i64toi32_i32$0;
   $5$hi = i64toi32_i32$1;
   i64toi32_i32$1 = 0;
   $17$hi = i64toi32_i32$1;
   i64toi32_i32$1 = $5$hi;
   i64toi32_i32$2 = i64toi32_i32$0;
   i64toi32_i32$0 = $17$hi;
   i64toi32_i32$3 = $2;
   i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
   i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
   if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
    i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
   }
   $6$hi = i64toi32_i32$5;
   i64toi32_i32$2 = $12;
   HEAP32[i64toi32_i32$2 >> 2] = i64toi32_i32$4;
   HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$5;
   $4 = $0 + 8 | 0;
   $22 = $4;
   i64toi32_i32$1 = $4;
   i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
   $24 = i64toi32_i32$5;
   $24$hi = i64toi32_i32$2;
   i64toi32_i32$2 = $6$hi;
   i64toi32_i32$2 = $5$hi;
   i64toi32_i32$2 = $6$hi;
   i64toi32_i32$1 = i64toi32_i32$4;
   i64toi32_i32$5 = $5$hi;
   i64toi32_i32$3 = $5;
   $27 = i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$5 | 0) & i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0 | 0) | 0;
   i64toi32_i32$1 = 0;
   $28$hi = i64toi32_i32$1;
   i64toi32_i32$1 = $24$hi;
   i64toi32_i32$3 = $24;
   i64toi32_i32$2 = $28$hi;
   i64toi32_i32$5 = $27;
   i64toi32_i32$0 = i64toi32_i32$3 + i64toi32_i32$5 | 0;
   i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$2 | 0;
   if (i64toi32_i32$0 >>> 0 < i64toi32_i32$5 >>> 0) {
    i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
   }
   i64toi32_i32$3 = $22;
   HEAP32[i64toi32_i32$3 >> 2] = i64toi32_i32$0;
   HEAP32[(i64toi32_i32$3 + 4 | 0) >> 2] = i64toi32_i32$4;
   HEAP32[($3 + 12 | 0) >> 2] = $0 + 16 | 0;
   cryptoxide__cryptoutil__FixedBuffer_____input__h45eb77880e071f02($0 + 80 | 0 | 0, $1 | 0, $2 | 0, $3 + 12 | 0 | 0);
   global$0 = $3 + 16 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1137812 | 0, 41 | 0, 1137948 | 0);
  abort();
 }
 
 function cardano_serialization_lib__DNSRecordAorAAAA__new_impl__he2de007c7a72649a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $9 = 0;
  label$1 : {
   label$2 : {
    $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    if ($2 >>> 0 > 64 >>> 0) {
     break label$2
    }
    i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $9 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[($0 + 4 | 0) >> 2] = $9;
    HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
    $1 = 0;
    break label$1;
   }
   alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($0 + 56 | 0 | 0, 1053672 | 0, 16 | 0);
   HEAP32[($0 + 20 | 0) >> 2] = $2;
   i64toi32_i32$0 = $0 + 12 | 0;
   i64toi32_i32$1 = 64;
   HEAP32[i64toi32_i32$0 >> 2] = 0;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP8[($0 + 8 | 0) >> 0] = 12;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
 }
 
 function cardano_serialization_lib__DNSRecordSRV__new_impl__h390c8355efc834ca($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $9 = 0;
  label$1 : {
   label$2 : {
    $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    if ($2 >>> 0 > 64 >>> 0) {
     break label$2
    }
    i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $9 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[($0 + 4 | 0) >> 2] = $9;
    HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
    $1 = 0;
    break label$1;
   }
   alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($0 + 56 | 0 | 0, 1053704 | 0, 12 | 0);
   HEAP32[($0 + 20 | 0) >> 2] = $2;
   i64toi32_i32$0 = $0 + 12 | 0;
   i64toi32_i32$1 = 64;
   HEAP32[i64toi32_i32$0 >> 2] = 0;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP8[($0 + 8 | 0) >> 0] = 12;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
 }
 
 function cardano_serialization_lib__URL__new_impl__h2bef2f0e9022dd28($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $9 = 0;
  label$1 : {
   label$2 : {
    $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    if ($2 >>> 0 > 64 >>> 0) {
     break label$2
    }
    i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $9 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[($0 + 4 | 0) >> 2] = $9;
    HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
    $1 = 0;
    break label$1;
   }
   alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($0 + 56 | 0 | 0, 1053651 | 0, 3 | 0);
   HEAP32[($0 + 20 | 0) >> 2] = $2;
   i64toi32_i32$0 = $0 + 12 | 0;
   i64toi32_i32$1 = 64;
   HEAP32[i64toi32_i32$0 >> 2] = 0;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP8[($0 + 8 | 0) >> 0] = 12;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
 }
 
 function cardano_serialization_lib__AssetName__new_impl__h47344992a9d6e8cb($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $9 = 0;
  label$1 : {
   label$2 : {
    $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    if ($2 >>> 0 > 32 >>> 0) {
     break label$2
    }
    i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $9 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[($0 + 4 | 0) >> 2] = $9;
    HEAP32[($0 + 8 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
    $1 = 0;
    break label$1;
   }
   alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($0 + 56 | 0 | 0, 1054324 | 0, 9 | 0);
   HEAP32[($0 + 20 | 0) >> 2] = $2;
   i64toi32_i32$0 = $0 + 12 | 0;
   i64toi32_i32$1 = 32;
   HEAP32[i64toi32_i32$0 >> 2] = 0;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   HEAP8[($0 + 8 | 0) >> 0] = 12;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
 }
 
 function update_new($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h2d6285fb6a1d44f8($2 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h847b9d84e24adaa5($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
  HEAP32[($2 + 56 | 0) >> 2] = $1;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  memcpy($2 + 64 | 0 | 0, $2 + 16 | 0 | 0, 48 | 0) | 0;
  $0 = $cardano_serialization_lib__Update_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__heaf0e9524107f139($2 + 64 | 0 | 0) | 0;
  global$0 = $2 + 112 | 0;
  return $0 | 0;
 }
 
 function __wbg_block_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 416 | 0;
  global$0 = $1;
  $cardano_serialization_lib__Block_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h78d138dac3d7160d($1 + 8 | 0 | 0, $0 | 0);
  core__ptr__drop_in_place_cardano_serialization_lib__Header___h8385b81bf98ec4f1($1 + 8 | 0 | 0);
  $0 = $1 + 376 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h86cdf7dca21c8b48($0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h7ca18c2b7d174864($0 | 0);
  $0 = $1 + 388 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h50c1f6d5a01d91ba($0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h0a3e4540c50cd990($0 | 0);
  $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__h65524c00492b1305($1 + 336 | 0 | 0);
  label$1 : {
   $0 = $1 + 352 | 0;
   if (!(HEAP32[$0 >> 2] | 0)) {
    break label$1
   }
   hashbrown__raw__RawTable_T_2cA___free_buckets__h03139504252f0030($0 | 0);
  }
  $0 = $1 + 400 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h19f76bdb6b4883ef($0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h970b13f6299e0f2d($0 | 0);
  global$0 = $1 + 416 | 0;
 }
 
 function int_as_positive($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $10 = 0, $11 = 0, $12 = 0, $2 = 0, $2$hi = 0, $3 = 0, $3$hi = 0, i64toi32_i32$3 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h8f4f32b29a620a40($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   i64toi32_i32$2 = $0 + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $2 = i64toi32_i32$0;
   $2$hi = i64toi32_i32$1;
   i64toi32_i32$2 = $0;
   i64toi32_i32$1 = HEAP32[$0 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   $3 = i64toi32_i32$1;
   $3$hi = i64toi32_i32$0;
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   label$2 : {
    label$3 : {
     i64toi32_i32$0 = $2$hi;
     i64toi32_i32$2 = $2;
     i64toi32_i32$1 = 0;
     i64toi32_i32$3 = 0;
     if ((i64toi32_i32$0 | 0) > (i64toi32_i32$1 | 0)) {
      $10 = 1
     } else {
      if ((i64toi32_i32$0 | 0) >= (i64toi32_i32$1 | 0)) {
       if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
        $11 = 0
       } else {
        $11 = 1
       }
       $12 = $11;
      } else {
       $12 = 0
      }
      $10 = $12;
     }
     if ($10) {
      break label$3
     }
     $0 = 0;
     break label$2;
    }
    i64toi32_i32$2 = $3$hi;
    $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810($3 | 0, i64toi32_i32$2 | 0) | 0;
   }
   global$0 = $1 + 16 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function int_as_negative($0) {
  $0 = $0 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $1 = 0, i64toi32_i32$3 = 0, i64toi32_i32$5 = 0, $3$hi = 0, $11 = 0, $12 = 0, $13 = 0, $2 = 0, $2$hi = 0, $3 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h8f4f32b29a620a40($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   i64toi32_i32$2 = $0 + 8 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $2 = i64toi32_i32$0;
   $2$hi = i64toi32_i32$1;
   i64toi32_i32$2 = $0;
   i64toi32_i32$1 = HEAP32[$0 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   $3 = i64toi32_i32$1;
   $3$hi = i64toi32_i32$0;
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   $0 = 0;
   label$2 : {
    i64toi32_i32$0 = $2$hi;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = -1;
    i64toi32_i32$3 = -1;
    if ((i64toi32_i32$0 | 0) > (i64toi32_i32$1 | 0)) {
     $11 = 1
    } else {
     if ((i64toi32_i32$0 | 0) >= (i64toi32_i32$1 | 0)) {
      if (i64toi32_i32$2 >>> 0 <= i64toi32_i32$3 >>> 0) {
       $12 = 0
      } else {
       $12 = 1
      }
      $13 = $12;
     } else {
      $13 = 0
     }
     $11 = $13;
    }
    if ($11) {
     break label$2
    }
    i64toi32_i32$2 = $3$hi;
    i64toi32_i32$2 = 0;
    i64toi32_i32$3 = 0;
    i64toi32_i32$0 = $3$hi;
    i64toi32_i32$1 = $3;
    i64toi32_i32$5 = (i64toi32_i32$3 >>> 0 < i64toi32_i32$1 >>> 0) + i64toi32_i32$0 | 0;
    i64toi32_i32$5 = i64toi32_i32$2 - i64toi32_i32$5 | 0;
    $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810(i64toi32_i32$3 - i64toi32_i32$1 | 0 | 0, i64toi32_i32$5 | 0) | 0;
   }
   global$0 = $1 + 16 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionbuilderconfigbuilder_prefer_pure_change($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 288 | 0;
  global$0 = $2;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h274f52f9a26a0dc8($2 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__tx_builder__TransactionBuilderConfigBuilder__prefer_pure_change__h671ffdf7d905da3e($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, ($1 | 0) != (0 | 0) | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  memcpy($2 + 152 | 0 | 0, $2 + 16 | 0 | 0, 136 | 0) | 0;
  $0 = $cardano_serialization_lib__tx_builder__TransactionBuilderConfigBuilder_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h65182e4c6d5621d4($2 + 152 | 0 | 0) | 0;
  global$0 = $2 + 288 | 0;
  return $0 | 0;
 }
 
 function transactionbuilder_add_required_signer($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h5566e1c7d4aafe35($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hae9c55c4e91ce40f($2 | 0, $1 | 0);
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__Ed25519KeyHashes__add__h0c425be96292307f($4 + 468 | 0 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function cardano_serialization_lib__crypto__Bip32PrivateKey__from_128_xprv__hf41833a6bbe46312($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 96 | 0;
  global$0 = $3;
  $3 = memset($3 | 0, 0 | 0, 96 | 0) | 0;
  label$1 : {
   label$2 : {
    if ($2 >>> 0 <= 63 >>> 0) {
     break label$2
    }
    core__slice___impl_20_5bT_5d___clone_from_slice__h1742dfbd5d5d9efd($3 | 0, 64 | 0, $1 | 0, 64 | 0);
    if ($2 >>> 0 <= 127 >>> 0) {
     break label$1
    }
    core__slice___impl_20_5bT_5d___clone_from_slice__h1742dfbd5d5d9efd($3 + 64 | 0 | 0, 32 | 0, $1 + 96 | 0 | 0, 32 | 0);
    cardano_serialization_lib__crypto__Bip32PrivateKey__from_bytes__hdfbc703a3728d81d($0 | 0, $3 | 0, 96 | 0);
    global$0 = $3 + 96 | 0;
    return;
   }
   core__slice__index__slice_end_index_len_fail__h192505a15ac4b345(64 | 0, $2 | 0, 1066472 | 0);
   abort();
  }
  core__slice__index__slice_end_index_len_fail__h192505a15ac4b345(128 | 0, $2 | 0, 1066488 | 0);
  abort();
 }
 
 function bip32privatekey_generate_ed25519_bip32() {
  var $0 = 0, $1 = 0, $2 = 0;
  $0 = global$0 - 208 | 0;
  global$0 = $0;
  cardano_serialization_lib__crypto__Bip32PrivateKey__generate_ed25519_bip32__h93952b584c86e584($0 + 8 | 0 | 0);
  $1 = HEAP32[($0 + 12 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($0 + 8 | 0) >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  HEAP8[($0 + 114 | 0) >> 0] = HEAPU8[($0 + 11 | 0) >> 0] | 0;
  HEAP16[($0 + 112 | 0) >> 1] = HEAPU8[($0 + 9 | 0) >> 0] | 0 | ((HEAPU8[($0 + 10 | 0) >> 0] | 0) << 8 | 0) | 0;
  $2 = $1;
  HEAP8[($0 + 115 | 0) >> 0] = $2;
  HEAP8[($0 + 116 | 0) >> 0] = $2 >>> 8 | 0;
  HEAP8[($0 + 117 | 0) >> 0] = $2 >>> 16 | 0;
  HEAP8[($0 + 118 | 0) >> 0] = $2 >>> 24 | 0;
  memcpy($0 + 112 | 0 | 7 | 0 | 0, $0 + 16 | 0 | 0, 89 | 0) | 0;
  $1 = $cardano_serialization_lib__crypto__Bip32PrivateKey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h3aa14ad8597a0206($0 + 112 | 0 | 0) | 0;
  global$0 = $0 + 208 | 0;
  return $1 | 0;
 }
 
 function txinputsbuilder_add_required_native_input_scripts($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hf277c6a2d5f089a3($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hbfc7b2ba05921680($2 | 0, $1 | 0);
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $1 = cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__add_required_native_input_scripts__h855e8fd3c83a9c4c($4 | 0, HEAP32[$2 >> 2] | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return $1 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function txinputsbuilder_add_required_plutus_input_scripts($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hf277c6a2d5f089a3($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hff8ea54f5a18a01d($2 | 0, $1 | 0);
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $1 = cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__add_required_plutus_input_scripts__hba7e8d5bf0a2077d($4 | 0, HEAP32[$2 >> 2] | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return $1 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function $core__iter__adapters__cloned__Cloned_I__20as_20core__iter__traits__iterator__Iterator___next__h2e192ec8b52ada0a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $3 = 0, $2 = 0, $4 = 0, $5 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $1 + 8 | 0;
  label$1 : {
   label$2 : {
    $3 = HEAP32[$1 >> 2] | 0;
    $4 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (($3 | 0) == ($4 | 0)) {
     break label$2
    }
    label$3 : while (1) {
     $5 = $3 + 128 | 0;
     HEAP32[$1 >> 2] = $5;
     HEAP32[($2 + 12 | 0) >> 2] = $3;
     if (core__ops__function__impls___impl_20core__ops__function__FnMut_A__20for_20_mut_20F___call_mut__he41f5047aba19e56($2 + 8 | 0 | 0, $2 + 12 | 0 | 0) | 0) {
      break label$1
     }
     $3 = $5;
     if (($4 | 0) != ($3 | 0)) {
      continue label$3
     }
     break label$3;
    };
   }
   $3 = 0;
  }
  core__option__Option__T___cloned__h621eb297880b0347($0 | 0, $3 | 0);
  global$0 = $2 + 16 | 0;
 }
 
 function transactionbody_set_network_id($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h238818d95bb6c551($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h4f79d4afa0b85c1a($2 | 0, $1 | 0);
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   HEAP8[($4 + 270 | 0) >> 0] = HEAPU8[(HEAP32[$2 >> 2] | 0) >> 0] | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function mirtostakecredentials_new() {
  var $0 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $2 = 0, $2$hi = 0, $3 = 0, $3$hi = 0;
  $0 = global$0 - 64 | 0;
  global$0 = $0;
  std__thread__local__LocalKey_T___with__h4cd07b14a44a727e($0 + 8 | 0 | 0, 1060968 | 0);
  i64toi32_i32$0 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($0 + 12 | 0) >> 2] | 0;
  $2 = i64toi32_i32$0;
  $2$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[($0 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($0 + 20 | 0) >> 2] | 0;
  $3 = i64toi32_i32$1;
  $3$hi = i64toi32_i32$0;
  $1 = hashbrown__raw__generic__Group__static_empty__hc5a7932fe1bdb1f1() | 0;
  i64toi32_i32$1 = $0 + 48 | 0;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($0 + 44 | 0) >> 2] = $1;
  i64toi32_i32$1 = $0 + 56 | 0;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($0 + 40 | 0) >> 2] = 0;
  i64toi32_i32$0 = $3$hi;
  i64toi32_i32$1 = $0;
  HEAP32[($0 + 32 | 0) >> 2] = $3;
  HEAP32[($0 + 36 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $2$hi;
  i64toi32_i32$1 = $0;
  HEAP32[($0 + 24 | 0) >> 2] = $2;
  HEAP32[($0 + 28 | 0) >> 2] = i64toi32_i32$0;
  $1 = $cardano_serialization_lib__MIRToStakeCredentials_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h1e2c02e5ebbbcce1($0 + 24 | 0 | 0) | 0;
  global$0 = $0 + 64 | 0;
  return $1 | 0;
 }
 
 function withdrawals_new() {
  var $0 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $2 = 0, $2$hi = 0, $3 = 0, $3$hi = 0;
  $0 = global$0 - 64 | 0;
  global$0 = $0;
  std__thread__local__LocalKey_T___with__h4cd07b14a44a727e($0 + 8 | 0 | 0, 1060968 | 0);
  i64toi32_i32$0 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($0 + 12 | 0) >> 2] | 0;
  $2 = i64toi32_i32$0;
  $2$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[($0 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($0 + 20 | 0) >> 2] | 0;
  $3 = i64toi32_i32$1;
  $3$hi = i64toi32_i32$0;
  $1 = hashbrown__raw__generic__Group__static_empty__hc5a7932fe1bdb1f1() | 0;
  i64toi32_i32$1 = $0 + 48 | 0;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($0 + 44 | 0) >> 2] = $1;
  i64toi32_i32$1 = $0 + 56 | 0;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($0 + 40 | 0) >> 2] = 0;
  i64toi32_i32$0 = $3$hi;
  i64toi32_i32$1 = $0;
  HEAP32[($0 + 32 | 0) >> 2] = $3;
  HEAP32[($0 + 36 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $2$hi;
  i64toi32_i32$1 = $0;
  HEAP32[($0 + 24 | 0) >> 2] = $2;
  HEAP32[($0 + 28 | 0) >> 2] = i64toi32_i32$0;
  $1 = $cardano_serialization_lib__Withdrawals_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8137ae41e80d8131($0 + 24 | 0 | 0) | 0;
  global$0 = $0 + 64 | 0;
  return $1 | 0;
 }
 
 function proposedprotocolparameterupdates_new() {
  var $0 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $2 = 0, $2$hi = 0, $3 = 0, $3$hi = 0;
  $0 = global$0 - 64 | 0;
  global$0 = $0;
  std__thread__local__LocalKey_T___with__h4cd07b14a44a727e($0 + 8 | 0 | 0, 1060968 | 0);
  i64toi32_i32$0 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($0 + 12 | 0) >> 2] | 0;
  $2 = i64toi32_i32$0;
  $2$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[($0 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($0 + 20 | 0) >> 2] | 0;
  $3 = i64toi32_i32$1;
  $3$hi = i64toi32_i32$0;
  $1 = hashbrown__raw__generic__Group__static_empty__hc5a7932fe1bdb1f1() | 0;
  i64toi32_i32$1 = $0 + 48 | 0;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($0 + 44 | 0) >> 2] = $1;
  i64toi32_i32$1 = $0 + 56 | 0;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($0 + 40 | 0) >> 2] = 0;
  i64toi32_i32$0 = $3$hi;
  i64toi32_i32$1 = $0;
  HEAP32[($0 + 32 | 0) >> 2] = $3;
  HEAP32[($0 + 36 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $2$hi;
  i64toi32_i32$1 = $0;
  HEAP32[($0 + 24 | 0) >> 2] = $2;
  HEAP32[($0 + 28 | 0) >> 2] = i64toi32_i32$0;
  $1 = $cardano_serialization_lib__ProposedProtocolParameterUpdates_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he29d4b6136a4f24f($0 + 24 | 0 | 0) | 0;
  global$0 = $0 + 64 | 0;
  return $1 | 0;
 }
 
 function auxiliarydataset_new() {
  var $0 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $2 = 0, $2$hi = 0, $3 = 0, $3$hi = 0;
  $0 = global$0 - 64 | 0;
  global$0 = $0;
  std__thread__local__LocalKey_T___with__h4cd07b14a44a727e($0 + 8 | 0 | 0, 1060968 | 0);
  i64toi32_i32$0 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($0 + 12 | 0) >> 2] | 0;
  $2 = i64toi32_i32$0;
  $2$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[($0 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($0 + 20 | 0) >> 2] | 0;
  $3 = i64toi32_i32$1;
  $3$hi = i64toi32_i32$0;
  $1 = hashbrown__raw__generic__Group__static_empty__hc5a7932fe1bdb1f1() | 0;
  i64toi32_i32$1 = $0 + 48 | 0;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($0 + 44 | 0) >> 2] = $1;
  i64toi32_i32$1 = $0 + 56 | 0;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($0 + 40 | 0) >> 2] = 0;
  i64toi32_i32$0 = $3$hi;
  i64toi32_i32$1 = $0;
  HEAP32[($0 + 32 | 0) >> 2] = $3;
  HEAP32[($0 + 36 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $2$hi;
  i64toi32_i32$1 = $0;
  HEAP32[($0 + 24 | 0) >> 2] = $2;
  HEAP32[($0 + 28 | 0) >> 2] = i64toi32_i32$0;
  $1 = $cardano_serialization_lib__AuxiliaryDataSet_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hb494915f50e223f9($0 + 24 | 0 | 0) | 0;
  global$0 = $0 + 64 | 0;
  return $1 | 0;
 }
 
 function block_auxiliary_data_set($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 96 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hdd2a3d9c2413fc4e($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h145f71b95ce2a2a5($1 + 16 | 0 | 0, (HEAP32[($1 + 8 | 0) >> 2] | 0) + 328 | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  memcpy($1 + 56 | 0 | 0, $1 + 16 | 0 | 0, 40 | 0) | 0;
  $0 = $cardano_serialization_lib__AuxiliaryDataSet_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hb494915f50e223f9($1 + 56 | 0 | 0) | 0;
  global$0 = $1 + 96 | 0;
  return $0 | 0;
 }
 
 function value_set_coin($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $3 = 0, $4 = 0, i64toi32_i32$1 = 0, $26 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__ha9ddcb0fc94d348b($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($2 | 0, $1 | 0);
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   i64toi32_i32$2 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $26 = i64toi32_i32$0;
   i64toi32_i32$0 = $4;
   HEAP32[i64toi32_i32$0 >> 2] = $26;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function metadatamap_new() {
  var $0 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $2 = 0, $2$hi = 0, $3 = 0, $3$hi = 0;
  $0 = global$0 - 64 | 0;
  global$0 = $0;
  std__thread__local__LocalKey_T___with__h4cd07b14a44a727e($0 + 8 | 0 | 0, 1060968 | 0);
  i64toi32_i32$0 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($0 + 12 | 0) >> 2] | 0;
  $2 = i64toi32_i32$0;
  $2$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[($0 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($0 + 20 | 0) >> 2] | 0;
  $3 = i64toi32_i32$1;
  $3$hi = i64toi32_i32$0;
  $1 = hashbrown__raw__generic__Group__static_empty__hc5a7932fe1bdb1f1() | 0;
  i64toi32_i32$1 = $0 + 48 | 0;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($0 + 44 | 0) >> 2] = $1;
  i64toi32_i32$1 = $0 + 56 | 0;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($0 + 40 | 0) >> 2] = 0;
  i64toi32_i32$0 = $3$hi;
  i64toi32_i32$1 = $0;
  HEAP32[($0 + 32 | 0) >> 2] = $3;
  HEAP32[($0 + 36 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $2$hi;
  i64toi32_i32$1 = $0;
  HEAP32[($0 + 24 | 0) >> 2] = $2;
  HEAP32[($0 + 28 | 0) >> 2] = i64toi32_i32$0;
  $1 = $cardano_serialization_lib__metadata__MetadataMap_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hf2098e6c815f1680($0 + 24 | 0 | 0) | 0;
  global$0 = $0 + 64 | 0;
  return $1 | 0;
 }
 
 function generaltransactionmetadata_new() {
  var $0 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $2 = 0, $2$hi = 0, $3 = 0, $3$hi = 0;
  $0 = global$0 - 64 | 0;
  global$0 = $0;
  std__thread__local__LocalKey_T___with__h4cd07b14a44a727e($0 + 8 | 0 | 0, 1060968 | 0);
  i64toi32_i32$0 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($0 + 12 | 0) >> 2] | 0;
  $2 = i64toi32_i32$0;
  $2$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[($0 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($0 + 20 | 0) >> 2] | 0;
  $3 = i64toi32_i32$1;
  $3$hi = i64toi32_i32$0;
  $1 = hashbrown__raw__generic__Group__static_empty__hc5a7932fe1bdb1f1() | 0;
  i64toi32_i32$1 = $0 + 48 | 0;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($0 + 44 | 0) >> 2] = $1;
  i64toi32_i32$1 = $0 + 56 | 0;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($0 + 40 | 0) >> 2] = 0;
  i64toi32_i32$0 = $3$hi;
  i64toi32_i32$1 = $0;
  HEAP32[($0 + 32 | 0) >> 2] = $3;
  HEAP32[($0 + 36 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $2$hi;
  i64toi32_i32$1 = $0;
  HEAP32[($0 + 24 | 0) >> 2] = $2;
  HEAP32[($0 + 28 | 0) >> 2] = i64toi32_i32$0;
  $1 = $cardano_serialization_lib__metadata__GeneralTransactionMetadata_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__haadefad5c9c3f4ac($0 + 24 | 0 | 0) | 0;
  global$0 = $0 + 64 | 0;
  return $1 | 0;
 }
 
 function $alloc__vec__Vec_u8__20as_20hex__FromHex___from_hex__h4bc81c912cf347f6($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $22 = 0, $25 = 0;
  $3 = global$0 - 32 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    if ($2 & 1 | 0) {
     break label$2
    }
    HEAP32[($3 + 24 | 0) >> 2] = 2;
    HEAP32[($3 + 20 | 0) >> 2] = $2;
    HEAP32[($3 + 16 | 0) >> 2] = $1;
    core__iter__adapters__enumerate__Enumerate_I___new__h104ad29fe8f300cf($3 | 0, $3 + 16 | 0 | 0);
    i64toi32_i32$2 = $3 + 8 | 0;
    i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $22 = i64toi32_i32$0;
    i64toi32_i32$0 = ($3 + 16 | 0) + 8 | 0;
    HEAP32[i64toi32_i32$0 >> 2] = $22;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    i64toi32_i32$2 = $3;
    i64toi32_i32$1 = HEAP32[$3 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[($3 + 4 | 0) >> 2] | 0;
    $25 = i64toi32_i32$1;
    i64toi32_i32$1 = $3;
    HEAP32[($3 + 16 | 0) >> 2] = $25;
    HEAP32[($3 + 20 | 0) >> 2] = i64toi32_i32$0;
    core__iter__adapters__process_results__h200f16721825da5a($0 | 0, $3 + 16 | 0 | 0);
    break label$1;
   }
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 1114112;
   HEAP32[i64toi32_i32$1 >> 2] = 1;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  }
  global$0 = $3 + 32 | 0;
 }
 
 function core__ptr__drop_in_place_core__option__Option_core__option__Option_cardano_serialization_lib__tx_builder__tx_inputs_builder__ScriptWitnessType_____hc1cbaf0cb4e97823($0) {
  $0 = $0 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $1 = 0, $2 = 0, $2$hi = 0;
  label$1 : {
   i64toi32_i32$2 = $0;
   i64toi32_i32$0 = HEAP32[$0 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   $2 = i64toi32_i32$0;
   $2$hi = i64toi32_i32$1;
   i64toi32_i32$2 = i64toi32_i32$0;
   i64toi32_i32$0 = 0;
   if (i64toi32_i32$1 >>> 0 > i64toi32_i32$0 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$2 >>> 0 > 3 >>> 0 | 0) | 0) {
    break label$1
   }
   label$2 : {
    label$3 : {
     label$4 : {
      i64toi32_i32$2 = $2$hi;
      switch ($2 | 0) {
      case 1:
       break label$1;
      case 2:
      case 3:
       break label$3;
      default:
       break label$4;
      };
     }
     $1 = $0 + 8 | 0;
     label$5 : {
      switch ((HEAPU8[($0 + 8 | 0) >> 0] | 0) + -1 | 0 | 0) {
      case 0:
       $0 = $1 + 4 | 0;
       $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc3d6ec99c05cee40($0 | 0);
       $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h0f78886c344617d4($0 | 0);
       return;
      case 2:
       break label$2;
      case 1:
       break label$5;
      default:
       break label$3;
      };
     }
     $0 = $1 + 4 | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc3d6ec99c05cee40($0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h0f78886c344617d4($0 | 0);
    }
    return;
   }
   $0 = $0 + 16 | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc3d6ec99c05cee40($0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h0f78886c344617d4($0 | 0);
   return;
  }
  core__ptr__drop_in_place_cardano_serialization_lib__tx_builder__tx_inputs_builder__PlutusWitness___he0a62919c4b71e2b($0 + 8 | 0 | 0);
 }
 
 function pointeraddress_stake_pointer($0) {
  $0 = $0 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $2 = 0, $2$hi = 0, $3 = 0, $3$hi = 0, $27 = 0;
  $1 = global$0 - 32 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h8caae7a957e11e51($1 | 0, $0 | 0);
  $0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[$0 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $2 = i64toi32_i32$0;
  $2$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($0 + 12 | 0) >> 2] | 0;
  $3 = i64toi32_i32$1;
  $3$hi = i64toi32_i32$0;
  i64toi32_i32$0 = HEAP32[($0 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($0 + 20 | 0) >> 2] | 0;
  $0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  $27 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = $27;
  HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $3$hi;
  HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $3;
  HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $2$hi;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $2;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
  $0 = $cardano_serialization_lib__address__Pointer_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hce108dee3b07a283(i64toi32_i32$0 + 8 | 0 | 0) | 0;
  global$0 = i64toi32_i32$0 + 32 | 0;
  return $0 | 0;
 }
 
 function redeemer_data($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 112 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h388263144730eb6a($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $cardano_serialization_lib__plutus__PlutusData_20as_20core__clone__Clone___clone__h63d1a98cc18f4609_2($1 + 16 | 0 | 0, (HEAP32[($1 + 8 | 0) >> 2] | 0) + 8 | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  memcpy($1 + 64 | 0 | 0, $1 + 16 | 0 | 0, 48 | 0) | 0;
  $0 = $cardano_serialization_lib__plutus__PlutusData_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h7393378a3318e0a5($1 + 64 | 0 | 0) | 0;
  global$0 = $1 + 112 | 0;
  return $0 | 0;
 }
 
 function core__iter__adapters__zip__Zip_A_2cB___new__h6418d1c24875134d($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $5 = 0, $6 = 0, $4 = 0;
  $4 = HEAP32[($1 + 44 | 0) >> 2] | 0;
  $5 = HEAP32[($1 + 40 | 0) >> 2] | 0;
  $6 = HEAP32[($1 + 36 | 0) >> 2] | 0;
  $1 = memcpy($0 | 0, $1 | 0, 36 | 0) | 0;
  $0 = $5 - $6 | 0;
  HEAP32[($1 + 64 | 0) >> 2] = $0;
  HEAP32[($1 + 56 | 0) >> 2] = 0;
  HEAP32[($1 + 52 | 0) >> 2] = $3;
  HEAP32[($1 + 48 | 0) >> 2] = $2;
  HEAP32[($1 + 44 | 0) >> 2] = $4;
  HEAP32[($1 + 40 | 0) >> 2] = $5;
  HEAP32[($1 + 36 | 0) >> 2] = $6;
  $2 = ($3 - $2 | 0) >>> 4 | 0;
  HEAP32[($1 + 60 | 0) >> 2] = $0 >>> 0 > $2 >>> 0 ? $2 : $0;
 }
 
 function core__iter__adapters__zip__Zip_A_2cB___new__h6d61c6f7913ef8e9($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $5 = 0, $6 = 0, $4 = 0;
  $4 = HEAP32[($1 + 64 | 0) >> 2] | 0;
  $5 = HEAP32[($1 + 60 | 0) >> 2] | 0;
  $6 = HEAP32[($1 + 56 | 0) >> 2] | 0;
  $1 = memcpy($0 | 0, $1 | 0, 56 | 0) | 0;
  $0 = $5 - $6 | 0;
  HEAP32[($1 + 84 | 0) >> 2] = $0;
  HEAP32[($1 + 76 | 0) >> 2] = 0;
  HEAP32[($1 + 72 | 0) >> 2] = $3;
  HEAP32[($1 + 68 | 0) >> 2] = $2;
  HEAP32[($1 + 64 | 0) >> 2] = $4;
  HEAP32[($1 + 60 | 0) >> 2] = $5;
  HEAP32[($1 + 56 | 0) >> 2] = $6;
  $2 = ($3 - $2 | 0) >>> 4 | 0;
  HEAP32[($1 + 80 | 0) >> 2] = $0 >>> 0 > $2 >>> 0 ? $2 : $0;
 }
 
 function transactioninputs_add($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h7dc8ec51bf9127a6($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hd7bc050864a8d646($2 | 0, $1 | 0);
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__TransactionInputs__add__hd344995baacebe36($4 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionoutputs_get($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 272 | 0;
  global$0 = $2;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h6185b44b866d43f0($2 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__TransactionOutputs__get__h4e92212d3597b354($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  memcpy($2 + 144 | 0 | 0, $2 + 16 | 0 | 0, 128 | 0) | 0;
  $0 = $cardano_serialization_lib__TransactionOutput_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h4b9395cffb8a7c47($2 + 144 | 0 | 0) | 0;
  global$0 = $2 + 272 | 0;
  return $0 | 0;
 }
 
 function transactionoutputs_add($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hb231bc98a91fbbb7($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h17af7d9d2d20aa0f($2 | 0, $1 | 0);
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__TransactionOutputs__add__h2527e8fddfba1826($4 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function certificates_get($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 416 | 0;
  global$0 = $2;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h0d8537c364f480d5($2 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__Certificates__get__h0f5581b1344389be($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  memcpy($2 + 216 | 0 | 0, $2 + 16 | 0 | 0, 200 | 0) | 0;
  $0 = $cardano_serialization_lib__Certificate_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hd9e6ef3cbd15ff20($2 + 216 | 0 | 0) | 0;
  global$0 = $2 + 416 | 0;
  return $0 | 0;
 }
 
 function certificates_add($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h6e4f06a418081d49($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h3b62e22150831bdc($2 | 0, $1 | 0);
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__Certificates__add__h9c6c3e5f5f20a2bd($4 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionbody_ttl_bignum($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $2$hi = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h356c30395cf13adb($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($0 + 16 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($0 + 20 | 0) >> 2] | 0;
   $2 = i64toi32_i32$0;
   $2$hi = i64toi32_i32$1;
   i64toi32_i32$1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($0 + 12 | 0) >> 2] | 0;
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   label$2 : {
    label$3 : {
     if (!!(i64toi32_i32$1 | i64toi32_i32$0 | 0)) {
      break label$3
     }
     $0 = 0;
     break label$2;
    }
    i64toi32_i32$0 = $2$hi;
    $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810($2 | 0, i64toi32_i32$0 | 0) | 0;
   }
   global$0 = $1 + 16 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionbody_validity_start_interval_bignum($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $2$hi = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h356c30395cf13adb($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($0 + 120 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($0 + 124 | 0) >> 2] | 0;
   $2 = i64toi32_i32$0;
   $2$hi = i64toi32_i32$1;
   i64toi32_i32$1 = HEAP32[($0 + 112 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($0 + 116 | 0) >> 2] | 0;
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   label$2 : {
    label$3 : {
     if (!!(i64toi32_i32$1 | i64toi32_i32$0 | 0)) {
      break label$3
     }
     $0 = 0;
     break label$2;
    }
    i64toi32_i32$0 = $2$hi;
    $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810($2 | 0, i64toi32_i32$0 | 0) | 0;
   }
   global$0 = $1 + 16 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionbody_set_mint($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h238818d95bb6c551($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h8348e40d8f63e5f1($2 | 0, $1 | 0);
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__TransactionBody__set_mint__h88098ad1b8ae4466($4 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function ed25519keyhashes_add($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hcf0411f2252ca14a($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hae9c55c4e91ce40f($2 | 0, $1 | 0);
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__Ed25519KeyHashes__add__h0c425be96292307f($4 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function relays_add($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h7554f81066822c17($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb17ff77b9b324998($2 | 0, $1 | 0);
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__Relays__add__h8e92b1d7ff1b47e9($4 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function singlehostaddr_ipv4($0) {
  $0 = $0 | 0;
  var $1 = 0, $4 = 0, $3 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h7fe2cd68d7de412a($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   $4 = $0 + 5 | 0;
   $2 = HEAPU8[$4 >> 0] | 0 | ((HEAPU8[($4 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($4 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($4 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $0 = HEAPU8[($0 + 4 | 0) >> 0] | 0;
   $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
   label$2 : {
    label$3 : {
     if ($0) {
      break label$3
     }
     $0 = 0;
     break label$2;
    }
    $0 = $cardano_serialization_lib__Ipv4_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h260bfd99906fbe36($2 | 0) | 0;
   }
   global$0 = $1 + 16 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function stakecredentials_add($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h061555eda9801069($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h7d8a0640f2deb41e($2 | 0, $1 | 0);
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__StakeCredentials__add__hbdfa8a13eb787e70($4 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function rewardaddresses_add($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hf18176d31e9af7c8($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h2338c90e0327d08b($2 | 0, $1 | 0);
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__RewardAddresses__add__h26e0cac4ad42f3f2($4 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionwitnessset_set_plutus_data($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h1cc4e67284701531($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hd98e995abd746618($2 | 0, $1 | 0);
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__TransactionWitnessSet__set_plutus_data__h01fb3bfe431fcf6c($4 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function cardano_serialization_lib__TransactionWitnessSet__plutus_data__h6be2d910efb0e7a2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $16 = 0, $29 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if ((HEAPU8[($1 + 60 | 0) >> 0] | 0 | 0) != (3 | 0)) {
     break label$2
    }
    HEAP8[($0 + 12 | 0) >> 0] = 3;
    break label$1;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hc831120dea694494($2 | 0, $1 + 48 | 0 | 0);
   i64toi32_i32$2 = $2;
   i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $16 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   HEAP32[i64toi32_i32$0 >> 2] = $16;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   $1 = HEAPU8[($1 + 60 | 0) >> 0] | 0;
   HEAP8[($2 + 12 | 0) >> 0] = ($1 | 0) == (2 | 0) ? 2 : ($1 | 0) != (0 | 0);
   i64toi32_i32$2 = $2 + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $29 = i64toi32_i32$1;
   i64toi32_i32$1 = $0 + 8 | 0;
   HEAP32[i64toi32_i32$1 >> 2] = $29;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  }
  global$0 = $2 + 16 | 0;
 }
 
 function nativescripts_add($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h1227f23aa068e55a($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h6ed0b6b043905434($2 | 0, $1 | 0);
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__NativeScripts__add__h12de25bf2c37f302($4 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function genesishashes_add($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h776bc08da2f877b7($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h7b8fe8d9d71033fc($2 | 0, $1 | 0);
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__GenesisHashes__add__hdde2164103102faf($4 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function scripthashes_add($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hb5d69d43b863633b($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h27da893e95dd15cf($2 | 0, $1 | 0);
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__ScriptHashes__add__h9e978044766aa310($4 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function protocolversions_add($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h6f896cc1d65c94a7($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h42c8face5b925abb($2 | 0, $1 | 0);
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__ProtocolVersions__add__h22b1e76c158cef25($4 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function protocolparamupdate_minfee_a($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $2$hi = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hd84cc8f720a3dada($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($0 + 12 | 0) >> 2] | 0;
   $2 = i64toi32_i32$0;
   $2$hi = i64toi32_i32$1;
   i64toi32_i32$1 = HEAP32[$0 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   label$2 : {
    label$3 : {
     if (!!(i64toi32_i32$1 | i64toi32_i32$0 | 0)) {
      break label$3
     }
     $0 = 0;
     break label$2;
    }
    i64toi32_i32$0 = $2$hi;
    $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810($2 | 0, i64toi32_i32$0 | 0) | 0;
   }
   global$0 = $1 + 16 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function protocolparamupdate_minfee_b($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $2$hi = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hd84cc8f720a3dada($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($0 + 24 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($0 + 28 | 0) >> 2] | 0;
   $2 = i64toi32_i32$0;
   $2$hi = i64toi32_i32$1;
   i64toi32_i32$1 = HEAP32[($0 + 16 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($0 + 20 | 0) >> 2] | 0;
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   label$2 : {
    label$3 : {
     if (!!(i64toi32_i32$1 | i64toi32_i32$0 | 0)) {
      break label$3
     }
     $0 = 0;
     break label$2;
    }
    i64toi32_i32$0 = $2$hi;
    $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810($2 | 0, i64toi32_i32$0 | 0) | 0;
   }
   global$0 = $1 + 16 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function protocolparamupdate_key_deposit($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $2$hi = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hd84cc8f720a3dada($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($0 + 40 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($0 + 44 | 0) >> 2] | 0;
   $2 = i64toi32_i32$0;
   $2$hi = i64toi32_i32$1;
   i64toi32_i32$1 = HEAP32[($0 + 32 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($0 + 36 | 0) >> 2] | 0;
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   label$2 : {
    label$3 : {
     if (!!(i64toi32_i32$1 | i64toi32_i32$0 | 0)) {
      break label$3
     }
     $0 = 0;
     break label$2;
    }
    i64toi32_i32$0 = $2$hi;
    $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810($2 | 0, i64toi32_i32$0 | 0) | 0;
   }
   global$0 = $1 + 16 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function protocolparamupdate_pool_deposit($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $2$hi = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hd84cc8f720a3dada($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($0 + 56 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($0 + 60 | 0) >> 2] | 0;
   $2 = i64toi32_i32$0;
   $2$hi = i64toi32_i32$1;
   i64toi32_i32$1 = HEAP32[($0 + 48 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($0 + 52 | 0) >> 2] | 0;
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   label$2 : {
    label$3 : {
     if (!!(i64toi32_i32$1 | i64toi32_i32$0 | 0)) {
      break label$3
     }
     $0 = 0;
     break label$2;
    }
    i64toi32_i32$0 = $2$hi;
    $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810($2 | 0, i64toi32_i32$0 | 0) | 0;
   }
   global$0 = $1 + 16 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function protocolparamupdate_min_pool_cost($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $2$hi = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hd84cc8f720a3dada($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($0 + 168 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($0 + 172 | 0) >> 2] | 0;
   $2 = i64toi32_i32$0;
   $2$hi = i64toi32_i32$1;
   i64toi32_i32$1 = HEAP32[($0 + 160 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($0 + 164 | 0) >> 2] | 0;
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   label$2 : {
    label$3 : {
     if (!!(i64toi32_i32$1 | i64toi32_i32$0 | 0)) {
      break label$3
     }
     $0 = 0;
     break label$2;
    }
    i64toi32_i32$0 = $2$hi;
    $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810($2 | 0, i64toi32_i32$0 | 0) | 0;
   }
   global$0 = $1 + 16 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function protocolparamupdate_ada_per_utxo_byte($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $2$hi = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__hd84cc8f720a3dada($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($0 + 184 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($0 + 188 | 0) >> 2] | 0;
   $2 = i64toi32_i32$0;
   $2$hi = i64toi32_i32$1;
   i64toi32_i32$1 = HEAP32[($0 + 176 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($0 + 180 | 0) >> 2] | 0;
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   label$2 : {
    label$3 : {
     if (!!(i64toi32_i32$1 | i64toi32_i32$0 | 0)) {
      break label$3
     }
     $0 = 0;
     break label$2;
    }
    i64toi32_i32$0 = $2$hi;
    $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810($2 | 0, i64toi32_i32$0 | 0) | 0;
   }
   global$0 = $1 + 16 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function protocolparamupdate_set_cost_models($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h0a71cd742026514d($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h0e53d0166415c79c($2 | 0, $1 | 0);
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__ProtocolParamUpdate__set_cost_models__h7c39ece06d921b8b($4 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionbodies_get($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 560 | 0;
  global$0 = $2;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hfefec6c3ca92202d($2 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__TransactionBodies__get__hfcd5f03aff264f78($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  memcpy($2 + 288 | 0 | 0, $2 + 16 | 0 | 0, 272 | 0) | 0;
  $0 = $cardano_serialization_lib__TransactionBody_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h5f9023ed5f5fb82c($2 + 288 | 0 | 0) | 0;
  global$0 = $2 + 560 | 0;
  return $0 | 0;
 }
 
 function transactionbodies_add($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hb2d5e2416ce5f734($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h356c30395cf13adb($2 | 0, $1 | 0);
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__TransactionBodies__add__h685115c6f4b9c765($4 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionwitnesssets_get($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h0fe7af65622a319f($2 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__TransactionWitnessSets__get__h4ffac11a62c016aa($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  memcpy($2 + 96 | 0 | 0, $2 + 16 | 0 | 0, 76 | 0) | 0;
  $0 = $cardano_serialization_lib__TransactionWitnessSet_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h15af3a22f8db3dff($2 + 96 | 0 | 0) | 0;
  global$0 = $2 + 176 | 0;
  return $0 | 0;
 }
 
 function transactionwitnesssets_add($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hf0272a72391b2a3a($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__he0885d10b4548804($2 | 0, $1 | 0);
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__TransactionWitnessSets__add__h6acbfa8707fa525a($4 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function cardano_serialization_lib__AssetNames__add__hb71692993861a8bc($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($2 | 0, $1 | 0);
  label$1 : {
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (($1 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
    break label$1
   }
   alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hd40e78aa171f606d($0 | 0, $1 | 0, 1 | 0);
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  }
  $1 = (HEAP32[$0 >> 2] | 0) + Math_imul($1, 12) | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  HEAP32[$1 >> 2] = HEAP32[$2 >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 8 | 0) >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
  HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
  global$0 = $2 + 16 | 0;
 }
 
 function assetnames_add($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h35a89179297fae2a($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h9c68abd5a6a78973($2 | 0, $1 | 0);
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__AssetNames__add__hb71692993861a8bc($4 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionunspentoutputs_get($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 352 | 0;
  global$0 = $2;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h2b38e1d613820f8e($2 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__utils__TransactionUnspentOutputs__get__ha53a8c5446661d93($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  memcpy($2 + 184 | 0 | 0, $2 + 16 | 0 | 0, 168 | 0) | 0;
  $0 = $cardano_serialization_lib__utils__TransactionUnspentOutput_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h241331f04367994b($2 + 184 | 0 | 0) | 0;
  global$0 = $2 + 352 | 0;
  return $0 | 0;
 }
 
 function transactionunspentoutputs_add($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h3c331aa05f471767($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hbebd755b3868aed3($2 | 0, $1 | 0);
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__utils__TransactionUnspentOutputs__add__h1bd134bb2a6bf667($4 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function value_set_multiasset($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__ha9ddcb0fc94d348b($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h9968e42c55861cec($2 | 0, $1 | 0);
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__utils__Value__set_multiasset__hcffccef3fc1cfd59($4 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function metadatalist_get($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h14eb25306bbe3311($2 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__metadata__MetadataList__get__hc998d9826d234933($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  memcpy($2 + 64 | 0 | 0, $2 + 16 | 0 | 0, 48 | 0) | 0;
  $0 = $cardano_serialization_lib__metadata__TransactionMetadatum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hce2feba55b67d086($2 + 64 | 0 | 0) | 0;
  global$0 = $2 + 112 | 0;
  return $0 | 0;
 }
 
 function metadatalist_add($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h8fa773adf60ecc95($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hc630c86c4ab6b26d($2 | 0, $1 | 0);
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__metadata__MetadataList__add__h35547ae43e0f3988($4 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionmetadatumlabels_add($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h6d906a27126b3b1d($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($2 | 0, $1 | 0);
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__metadata__TransactionMetadatumLabels__add__h167a70796c770223($4 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionbuilderconfigbuilder_max_value_size($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 288 | 0;
  global$0 = $2;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h274f52f9a26a0dc8($2 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__tx_builder__TransactionBuilderConfigBuilder__max_value_size__hd6015462fc9a24a1($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  memcpy($2 + 152 | 0 | 0, $2 + 16 | 0 | 0, 136 | 0) | 0;
  $0 = $cardano_serialization_lib__tx_builder__TransactionBuilderConfigBuilder_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h65182e4c6d5621d4($2 + 152 | 0 | 0) | 0;
  global$0 = $2 + 288 | 0;
  return $0 | 0;
 }
 
 function transactionbuilderconfigbuilder_max_tx_size($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 288 | 0;
  global$0 = $2;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h274f52f9a26a0dc8($2 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__tx_builder__TransactionBuilderConfigBuilder__max_tx_size__h97befc95fd4e5f5a($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  memcpy($2 + 152 | 0 | 0, $2 + 16 | 0 | 0, 136 | 0) | 0;
  $0 = $cardano_serialization_lib__tx_builder__TransactionBuilderConfigBuilder_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h65182e4c6d5621d4($2 + 152 | 0 | 0) | 0;
  global$0 = $2 + 288 | 0;
  return $0 | 0;
 }
 
 function transactionbuilder_set_inputs($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h5566e1c7d4aafe35($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h2150b2b2433b33e4($2 | 0, $1 | 0);
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__tx_builder__TransactionBuilder__set_inputs__h2784cea4137e09c9($4 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionbuilder_set_collateral($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h5566e1c7d4aafe35($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h2150b2b2433b33e4($2 | 0, $1 | 0);
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__tx_builder__TransactionBuilder__set_collateral__hc235465b455fdf49($4 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionbuilder_set_certs($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h5566e1c7d4aafe35($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h0d8537c364f480d5($2 | 0, $1 | 0);
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__tx_builder__TransactionBuilder__set_certs__h6392865994434751($4 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionbuilder_set_withdrawals($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h5566e1c7d4aafe35($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h000099354d5ff519($2 | 0, $1 | 0);
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__tx_builder__TransactionBuilder__set_withdrawals__h04e33428bc3543ac($4 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionbuilder_set_auxiliary_data($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h5566e1c7d4aafe35($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hdd9a557acdd7acfa($2 | 0, $1 | 0);
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__tx_builder__TransactionBuilder__set_auxiliary_data__h12006016667e6f76($4 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionbuilder_set_metadata($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h5566e1c7d4aafe35($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h670b86b1bfb2242f($2 | 0, $1 | 0);
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__tx_builder__TransactionBuilder__set_metadata__hf30b1ac4dad4b2e1($4 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionbuilder_get_fee_if_set($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $2$hi = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h37dfbd2f31d951c1($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($0 + 264 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($0 + 268 | 0) >> 2] | 0;
   $2 = i64toi32_i32$0;
   $2$hi = i64toi32_i32$1;
   i64toi32_i32$1 = HEAP32[($0 + 256 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($0 + 260 | 0) >> 2] | 0;
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   label$2 : {
    label$3 : {
     if (!!(i64toi32_i32$1 | i64toi32_i32$0 | 0)) {
      break label$3
     }
     $0 = 0;
     break label$2;
    }
    i64toi32_i32$0 = $2$hi;
    $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810($2 | 0, i64toi32_i32$0 | 0) | 0;
   }
   global$0 = $1 + 16 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function transactionbuilder_calc_script_data_hash($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h5566e1c7d4aafe35($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h0e53d0166415c79c($2 | 0, $1 | 0);
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__tx_builder__TransactionBuilder__calc_script_data_hash__hd107dcfcd329e3ab($4 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function cardano_serialization_lib__tx_builder__TransactionBuilder__full_size__h547e962b6182d21b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 576 | 0;
  global$0 = $2;
  cardano_serialization_lib__tx_builder__TransactionBuilder__build_and_size__h9094c1e3b4ead95a($2 + 8 | 0 | 0, $1 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    memcpy($2 + 296 | 0 | 0, $2 + 16 | 0 | 0, 280 | 0) | 0;
    $3 = HEAP32[($2 + 568 | 0) >> 2] | 0;
    core__ptr__drop_in_place_cardano_serialization_lib__TransactionBody___h9274013021a1d568($2 + 296 | 0 | 0);
    $1 = 0;
    break label$1;
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $3;
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 576 | 0;
 }
 
 function bip32privatekey_derive($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 208 | 0;
  global$0 = $2;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h30021c0122a7c8e6($2 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  ed25519_bip32__key__XPrv__derive__h54fb92501f054667($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  memcpy($2 + 112 | 0 | 0, $2 + 16 | 0 | 0, 96 | 0) | 0;
  $0 = $cardano_serialization_lib__crypto__Bip32PrivateKey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h3aa14ad8597a0206($2 + 112 | 0 | 0) | 0;
  global$0 = $2 + 208 | 0;
  return $0 | 0;
 }
 
 function privatekey_generate_ed25519() {
  var $0 = 0, $1 = 0, $2 = 0;
  $0 = global$0 - 144 | 0;
  global$0 = $0;
  cardano_serialization_lib__crypto__PrivateKey__generate_ed25519__hc5a5464d1f4c940e($0 | 0);
  $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[$0 >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  HEAP8[($0 + 74 | 0) >> 0] = HEAPU8[($0 + 3 | 0) >> 0] | 0;
  HEAP16[($0 + 72 | 0) >> 1] = HEAPU8[($0 + 1 | 0) >> 0] | 0 | ((HEAPU8[($0 + 2 | 0) >> 0] | 0) << 8 | 0) | 0;
  $2 = $1;
  HEAP8[($0 + 75 | 0) >> 0] = $2;
  HEAP8[($0 + 76 | 0) >> 0] = $2 >>> 8 | 0;
  HEAP8[($0 + 77 | 0) >> 0] = $2 >>> 16 | 0;
  HEAP8[($0 + 78 | 0) >> 0] = $2 >>> 24 | 0;
  memcpy($0 + 72 | 0 | 7 | 0 | 0, $0 + 8 | 0 | 0, 58 | 0) | 0;
  $1 = $cardano_serialization_lib__crypto__PrivateKey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h7ffc55fb5b040fec($0 + 72 | 0 | 0) | 0;
  global$0 = $0 + 144 | 0;
  return $1 | 0;
 }
 
 function privatekey_generate_ed25519extended() {
  var $0 = 0, $1 = 0, $2 = 0;
  $0 = global$0 - 144 | 0;
  global$0 = $0;
  cardano_serialization_lib__crypto__PrivateKey__generate_ed25519extended__he466dab7ccdf64b2($0 | 0);
  $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  label$1 : {
   if ((HEAPU8[$0 >> 0] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   wasm_bindgen__throw_val__hcf1b5c929d6fa472($1 | 0);
   abort();
  }
  HEAP8[($0 + 74 | 0) >> 0] = HEAPU8[($0 + 3 | 0) >> 0] | 0;
  HEAP16[($0 + 72 | 0) >> 1] = HEAPU8[($0 + 1 | 0) >> 0] | 0 | ((HEAPU8[($0 + 2 | 0) >> 0] | 0) << 8 | 0) | 0;
  $2 = $1;
  HEAP8[($0 + 75 | 0) >> 0] = $2;
  HEAP8[($0 + 76 | 0) >> 0] = $2 >>> 8 | 0;
  HEAP8[($0 + 77 | 0) >> 0] = $2 >>> 16 | 0;
  HEAP8[($0 + 78 | 0) >> 0] = $2 >>> 24 | 0;
  memcpy($0 + 72 | 0 | 7 | 0 | 0, $0 + 8 | 0 | 0, 58 | 0) | 0;
  $1 = $cardano_serialization_lib__crypto__PrivateKey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h7ffc55fb5b040fec($0 + 72 | 0 | 0) | 0;
  global$0 = $0 + 144 | 0;
  return $1 | 0;
 }
 
 function vkeys_add($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hc08699f22fda04d6($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h38603c546ca761f2($2 | 0, $1 | 0);
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__crypto__Vkeys__add__hdd65d2d54d857e12($4 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function vkeywitnesses_add($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h1c7f0e3050b987b8($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h9c2d3a72ebf4d25f($2 | 0, $1 | 0);
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__crypto__Vkeywitnesses__add__he21d7a30d5c7de68($4 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function bootstrapwitnesses_get($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 256 | 0;
  global$0 = $2;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hab914e4e14c49c39($2 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__crypto__BootstrapWitnesses__get__hbea43679996fcd34($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  memcpy($2 + 136 | 0 | 0, $2 + 16 | 0 | 0, 120 | 0) | 0;
  $0 = $cardano_serialization_lib__crypto__BootstrapWitness_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hcc8c8e7beca3e936($2 + 136 | 0 | 0) | 0;
  global$0 = $2 + 256 | 0;
  return $0 | 0;
 }
 
 function bootstrapwitnesses_add($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h24c88156dad2ef97($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h76a11b605f70ebd5($2 | 0, $1 | 0);
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__crypto__BootstrapWitnesses__add__h053adaa5938ec849($4 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function publickeys_add($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h48ae624d339b329f($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h67eb974eba5bb4b0($2 | 0, $1 | 0);
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__crypto__PublicKeys__add__h9cce03ece08311fd($4 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h03cc330b7b1e4522($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     $3 = HEAP32[($1 + 24 | 0) >> 2] | 0;
     if ($3) {
      break label$3
     }
     $1 = 0;
     break label$2;
    }
    HEAP32[($1 + 24 | 0) >> 2] = $3 + -1 | 0;
    if (!(HEAP32[($1 + 4 | 0) >> 2] | 0)) {
     break label$1
    }
    alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Immut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____next_unchecked__ha0bcc0e1b5871fcf($2 + 8 | 0 | 0, $1 | 0);
    $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   }
   HEAP32[($0 + 4 | 0) >> 2] = $3;
   HEAP32[$0 >> 2] = $1;
   global$0 = $2 + 16 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1067386 | 0, 43 | 0, 1067600 | 0);
  abort();
 }
 
 function $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h1af0b182f7766c68($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     $3 = HEAP32[($1 + 24 | 0) >> 2] | 0;
     if ($3) {
      break label$3
     }
     $1 = 0;
     break label$2;
    }
    HEAP32[($1 + 24 | 0) >> 2] = $3 + -1 | 0;
    if (!(HEAP32[($1 + 4 | 0) >> 2] | 0)) {
     break label$1
    }
    alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Immut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____next_unchecked__hfa131ff1f54a70fd($2 + 8 | 0 | 0, $1 | 0);
    $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   }
   HEAP32[($0 + 4 | 0) >> 2] = $3;
   HEAP32[$0 >> 2] = $1;
   global$0 = $2 + 16 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1067386 | 0, 43 | 0, 1067600 | 0);
  abort();
 }
 
 function $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h32d71c96a3c9fef9($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     $3 = HEAP32[($1 + 24 | 0) >> 2] | 0;
     if ($3) {
      break label$3
     }
     $1 = 0;
     break label$2;
    }
    HEAP32[($1 + 24 | 0) >> 2] = $3 + -1 | 0;
    if (!(HEAP32[($1 + 4 | 0) >> 2] | 0)) {
     break label$1
    }
    alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Immut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____next_unchecked__hf8691ff1a1d3cd5d($2 + 8 | 0 | 0, $1 | 0);
    $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   }
   HEAP32[($0 + 4 | 0) >> 2] = $3;
   HEAP32[$0 >> 2] = $1;
   global$0 = $2 + 16 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1067386 | 0, 43 | 0, 1067600 | 0);
  abort();
 }
 
 function $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h36ca092f81b9a0fa($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     $3 = HEAP32[($1 + 24 | 0) >> 2] | 0;
     if ($3) {
      break label$3
     }
     $1 = 0;
     break label$2;
    }
    HEAP32[($1 + 24 | 0) >> 2] = $3 + -1 | 0;
    if (!(HEAP32[($1 + 4 | 0) >> 2] | 0)) {
     break label$1
    }
    alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Immut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____next_unchecked__h3f773d42bd58327f($2 + 8 | 0 | 0, $1 | 0);
    $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   }
   HEAP32[($0 + 4 | 0) >> 2] = $3;
   HEAP32[$0 >> 2] = $1;
   global$0 = $2 + 16 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1067386 | 0, 43 | 0, 1067600 | 0);
  abort();
 }
 
 function $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h7135048eb51d6b68($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     $3 = HEAP32[($1 + 24 | 0) >> 2] | 0;
     if ($3) {
      break label$3
     }
     $1 = 0;
     break label$2;
    }
    HEAP32[($1 + 24 | 0) >> 2] = $3 + -1 | 0;
    if (!(HEAP32[($1 + 4 | 0) >> 2] | 0)) {
     break label$1
    }
    alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Immut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____next_unchecked__hb38abc1b9c99c097($2 + 8 | 0 | 0, $1 | 0);
    $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   }
   HEAP32[($0 + 4 | 0) >> 2] = $3;
   HEAP32[$0 >> 2] = $1;
   global$0 = $2 + 16 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1067386 | 0, 43 | 0, 1067600 | 0);
  abort();
 }
 
 function $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__ha538daa28fd542ac($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     $3 = HEAP32[($1 + 24 | 0) >> 2] | 0;
     if ($3) {
      break label$3
     }
     $1 = 0;
     break label$2;
    }
    HEAP32[($1 + 24 | 0) >> 2] = $3 + -1 | 0;
    if (!(HEAP32[($1 + 4 | 0) >> 2] | 0)) {
     break label$1
    }
    alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Immut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____next_unchecked__h0cd6b79880fdffab($2 + 8 | 0 | 0, $1 | 0);
    $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   }
   HEAP32[($0 + 4 | 0) >> 2] = $3;
   HEAP32[$0 >> 2] = $1;
   global$0 = $2 + 16 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1067386 | 0, 43 | 0, 1067600 | 0);
  abort();
 }
 
 function $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__hbd7038216761c388($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     $3 = HEAP32[($1 + 24 | 0) >> 2] | 0;
     if ($3) {
      break label$3
     }
     $1 = 0;
     break label$2;
    }
    HEAP32[($1 + 24 | 0) >> 2] = $3 + -1 | 0;
    if (!(HEAP32[($1 + 4 | 0) >> 2] | 0)) {
     break label$1
    }
    alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Immut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____next_unchecked__h62e84bc9d17d0099($2 + 8 | 0 | 0, $1 | 0);
    $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   }
   HEAP32[($0 + 4 | 0) >> 2] = $3;
   HEAP32[$0 >> 2] = $1;
   global$0 = $2 + 16 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1067386 | 0, 43 | 0, 1067600 | 0);
  abort();
 }
 
 function $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__hce9499edf49fdc37($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     $3 = HEAP32[($1 + 24 | 0) >> 2] | 0;
     if ($3) {
      break label$3
     }
     $1 = 0;
     break label$2;
    }
    HEAP32[($1 + 24 | 0) >> 2] = $3 + -1 | 0;
    if (!(HEAP32[($1 + 4 | 0) >> 2] | 0)) {
     break label$1
    }
    alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Immut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____next_unchecked__hebec1903e6b897f2($2 + 8 | 0 | 0, $1 | 0);
    $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   }
   HEAP32[($0 + 4 | 0) >> 2] = $3;
   HEAP32[$0 >> 2] = $1;
   global$0 = $2 + 16 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1067386 | 0, 43 | 0, 1067600 | 0);
  abort();
 }
 
 function $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__hf8baa7262b1cd562($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     $3 = HEAP32[($1 + 24 | 0) >> 2] | 0;
     if ($3) {
      break label$3
     }
     $1 = 0;
     break label$2;
    }
    HEAP32[($1 + 24 | 0) >> 2] = $3 + -1 | 0;
    if (!(HEAP32[($1 + 4 | 0) >> 2] | 0)) {
     break label$1
    }
    alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Immut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____next_unchecked__h58ba42c81256a08f($2 + 8 | 0 | 0, $1 | 0);
    $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   }
   HEAP32[($0 + 4 | 0) >> 2] = $3;
   HEAP32[$0 >> 2] = $1;
   global$0 = $2 + 16 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1067386 | 0, 43 | 0, 1067600 | 0);
  abort();
 }
 
 function plutuswitnesses_get($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 304 | 0;
  global$0 = $2;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hff8ea54f5a18a01d($2 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__tx_builder__tx_inputs_builder__PlutusWitnesses__get__hc445cb787af5ae82($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  memcpy($2 + 160 | 0 | 0, $2 + 16 | 0 | 0, 144 | 0) | 0;
  $0 = $cardano_serialization_lib__tx_builder__tx_inputs_builder__PlutusWitness_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h43043aa66f99997b($2 + 160 | 0 | 0) | 0;
  global$0 = $2 + 304 | 0;
  return $0 | 0;
 }
 
 function plutuswitnesses_add($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hd69c4b5985a5a825($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hbec83ebdd86caafd($2 | 0, $1 | 0);
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__tx_builder__tx_inputs_builder__PlutusWitnesses__add__hec4d4aff8ce90d4a($4 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function byronaddress_icarus_from_key($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 128 | 0;
  global$0 = $2;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hcfcf2a638924fc64($2 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__address__ByronAddress__icarus_from_key__h798b11933675c783($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  memcpy($2 + 72 | 0 | 0, $2 + 16 | 0 | 0, 52 | 0) | 0;
  $0 = $cardano_serialization_lib__address__ByronAddress_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbc0eb32d6a95f2a3($2 + 72 | 0 | 0) | 0;
  global$0 = $2 + 128 | 0;
  return $0 | 0;
 }
 
 function cardano_serialization_lib__plutus__PlutusScripts__add__he3c09fbfbe0a2d17($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($2 | 0, $1 | 0);
  label$1 : {
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (($1 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
    break label$1
   }
   alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h558818d7c1769e53($0 | 0, $1 | 0, 1 | 0);
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  }
  $1 = (HEAP32[$0 >> 2] | 0) + Math_imul($1, 12) | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  HEAP32[$1 >> 2] = HEAP32[$2 >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 8 | 0) >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
  HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
  global$0 = $2 + 16 | 0;
 }
 
 function plutusscripts_add($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h60cc26adb5968dc4($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hf3651990986a0e62($2 | 0, $1 | 0);
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__plutus__PlutusScripts__add__he3c09fbfbe0a2d17($4 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function cardano_serialization_lib__plutus__PlutusData__as_list__h5406319792508a75($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $14 = 0, $28 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if ((HEAP32[$1 >> 2] | 0 | 0) != (2 | 0)) {
     break label$2
    }
    $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hc831120dea694494($2 | 0, $1 + 4 | 0 | 0);
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
    $14 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[i64toi32_i32$0 >> 2] = $14;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    $1 = HEAPU8[($1 + 16 | 0) >> 0] | 0;
    HEAP8[($2 + 12 | 0) >> 0] = ($1 | 0) == (2 | 0) ? 2 : ($1 | 0) != (0 | 0);
    i64toi32_i32$2 = $2 + 8 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $28 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $28;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    break label$1;
   }
   HEAP8[($0 + 12 | 0) >> 0] = 3;
  }
  global$0 = $2 + 16 | 0;
 }
 
 function plutuslist_get($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hd98e995abd746618($2 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__plutus__PlutusList__get__hc927172b428c7408($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  memcpy($2 + 64 | 0 | 0, $2 + 16 | 0 | 0, 48 | 0) | 0;
  $0 = $cardano_serialization_lib__plutus__PlutusData_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h7393378a3318e0a5($2 + 64 | 0 | 0) | 0;
  global$0 = $2 + 112 | 0;
  return $0 | 0;
 }
 
 function plutuslist_add($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__ha76caa55a13a9b32($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__hb1fd14a6870cafe2($2 | 0, $1 | 0);
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__plutus__PlutusList__add__ha106511326853de8($4 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function redeemers_get($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 176 | 0;
  global$0 = $2;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h6789b4b005d0c63f($2 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__plutus__Redeemers__get__h5deba8646dc7d1c2($2 + 16 | 0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  memcpy($2 + 96 | 0 | 0, $2 + 16 | 0 | 0, 80 | 0) | 0;
  $0 = $cardano_serialization_lib__plutus__Redeemer_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he2ca0b82950da3f7($2 + 96 | 0 | 0) | 0;
  global$0 = $2 + 176 | 0;
  return $0 | 0;
 }
 
 function redeemers_add($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow_mut__ha681df4b192f3b9b($2 + 8 | 0 | 0, $0 | 0);
   if (!$1) {
    break label$1
   }
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   wasm_bindgen____rt__WasmRefCell_T___borrow__h388263144730eb6a($2 | 0, $1 | 0);
   $0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   cardano_serialization_lib__plutus__Redeemers__add__hd385809a7217414b($4 | 0, HEAP32[$2 >> 2] | 0 | 0);
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
   global$0 = $2 + 16 | 0;
   return;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function $cardano_serialization_lib__legacy_address__address__ExtendedAddr_20as_20core__fmt__Display___fmt__he356156b8bc4225c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  cardano_serialization_lib__legacy_address__address__ExtendedAddr__to_address__hf1649f2dced0034f($2 + 32 | 0 | 0, $0 | 0);
  HEAP32[($2 + 20 | 0) >> 2] = 1;
  HEAP32[($2 + 28 | 0) >> 2] = 149;
  HEAP32[($2 + 4 | 0) >> 2] = 1;
  HEAP32[($2 + 8 | 0) >> 2] = 0;
  HEAP32[$2 >> 2] = 1072696;
  HEAP32[($2 + 24 | 0) >> 2] = $2 + 32 | 0;
  HEAP32[($2 + 16 | 0) >> 2] = $2 + 24 | 0;
  $1 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 | 0) | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 + 32 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 32 | 0 | 0);
  global$0 = $2 + 48 | 0;
  return $1 | 0;
 }
 
 function core__ptr__drop_in_place_serde_json__value__Value___hb5131c85f9c77304($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   label$2 : {
    switch (HEAPU8[$0 >> 0] | 0 | 0) {
    default:
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h0198cfc402357e50($0 + 4 | 0 | 0);
     break label$1;
    case 3:
     $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
     if (!$1) {
      break label$1
     }
     __rust_dealloc(HEAP32[($0 + 4 | 0) >> 2] | 0 | 0, $1 | 0, 1 | 0);
     return;
    case 0:
    case 1:
    case 2:
     break label$1;
    case 4:
     break label$2;
    };
   }
   $1 = $0 + 4 | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h2d454d4f9b2e44f3($1 | 0);
   $0 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (!$0) {
    break label$1
   }
   $0 = Math_imul($0, 24);
   if (!$0) {
    break label$1
   }
   __rust_dealloc(HEAP32[$1 >> 2] | 0 | 0, $0 | 0, 8 | 0);
   return;
  }
 }
 
 function core__ptr__drop_in_place_serde_json__value__Value___hb5131c85f9c77304_1($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   label$2 : {
    switch (HEAPU8[$0 >> 0] | 0 | 0) {
    default:
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h0198cfc402357e50($0 + 4 | 0 | 0);
     break label$1;
    case 3:
     $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
     if (!$1) {
      break label$1
     }
     __rust_dealloc(HEAP32[($0 + 4 | 0) >> 2] | 0 | 0, $1 | 0, 1 | 0);
     return;
    case 0:
    case 1:
    case 2:
     break label$1;
    case 4:
     break label$2;
    };
   }
   $1 = $0 + 4 | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h2d454d4f9b2e44f3($1 | 0);
   $0 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (!$0) {
    break label$1
   }
   $0 = Math_imul($0, 24);
   if (!$0) {
    break label$1
   }
   __rust_dealloc(HEAP32[$1 >> 2] | 0 | 0, $0 | 0, 8 | 0);
   return;
  }
 }
 
 function core__ptr__drop_in_place_serde_json__value__Value___hb5131c85f9c77304_2($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   label$2 : {
    switch (HEAPU8[$0 >> 0] | 0 | 0) {
    default:
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h0198cfc402357e50($0 + 4 | 0 | 0);
     break label$1;
    case 3:
     $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
     if (!$1) {
      break label$1
     }
     __rust_dealloc(HEAP32[($0 + 4 | 0) >> 2] | 0 | 0, $1 | 0, 1 | 0);
     return;
    case 0:
    case 1:
    case 2:
     break label$1;
    case 4:
     break label$2;
    };
   }
   $1 = $0 + 4 | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h2d454d4f9b2e44f3($1 | 0);
   $0 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (!$0) {
    break label$1
   }
   $0 = Math_imul($0, 24);
   if (!$0) {
    break label$1
   }
   __rust_dealloc(HEAP32[$1 >> 2] | 0 | 0, $0 | 0, 8 | 0);
   return;
  }
 }
 
 function $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h51e8e53778b7cbd1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     $3 = HEAP32[($1 + 24 | 0) >> 2] | 0;
     if ($3) {
      break label$3
     }
     $1 = 0;
     break label$2;
    }
    HEAP32[($1 + 24 | 0) >> 2] = $3 + -1 | 0;
    if (!(HEAP32[($1 + 4 | 0) >> 2] | 0)) {
     break label$1
    }
    alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Immut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____next_unchecked__h7b6621e395ccabfb($2 + 8 | 0 | 0, $1 | 0);
    $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   }
   HEAP32[($0 + 4 | 0) >> 2] = $3;
   HEAP32[$0 >> 2] = $1;
   global$0 = $2 + 16 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1089096 | 0, 43 | 0, 1089236 | 0);
  abort();
 }
 
 function alloc__vec__from_elem__hdc900c1db7c0f1ee($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $5 = 0, $4 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    if ($1 & 255 | 0) {
     break label$2
    }
    alloc__raw_vec__RawVec_T_2cA___allocate_in__hce83853681ce0f55($3 | 0, $2 | 0, 1 | 0);
    $4 = HEAP32[($3 + 4 | 0) >> 2] | 0;
    $5 = HEAP32[$3 >> 2] | 0;
    break label$1;
   }
   alloc__raw_vec__RawVec_T_2cA___allocate_in__hce83853681ce0f55($3 + 8 | 0 | 0, $2 | 0, 0 | 0);
   $4 = HEAP32[($3 + 12 | 0) >> 2] | 0;
   $5 = HEAP32[($3 + 8 | 0) >> 2] | 0;
   memset($5 | 0, $1 | 0, $2 | 0) | 0;
  }
  HEAP32[($0 + 8 | 0) >> 2] = $2;
  HEAP32[$0 >> 2] = $5;
  HEAP32[($0 + 4 | 0) >> 2] = $4;
  global$0 = $3 + 16 | 0;
 }
 
 function cryptoxide__cryptoutil__xor_keystream__h1b50be9f7ab5641d($0, $1, $2, $3, $4, $5) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  $5 = $5 | 0;
  label$1 : {
   label$2 : {
    if (($1 | 0) != ($3 | 0)) {
     break label$2
    }
    if ($1 >>> 0 > $5 >>> 0) {
     break label$1
    }
    label$3 : {
     if (($1 | 0) < (1 | 0)) {
      break label$3
     }
     label$4 : while (1) {
      HEAP8[$0 >> 0] = (HEAPU8[$4 >> 0] | 0) ^ (HEAPU8[$2 >> 0] | 0) | 0;
      $2 = $2 + 1 | 0;
      $4 = $4 + 1 | 0;
      $0 = $0 + 1 | 0;
      $1 = $1 + -1 | 0;
      if ($1) {
       continue label$4
      }
      break label$4;
     };
    }
    return;
   }
   core__panicking__panic__h2fd385a887c8bf13(1102523 | 0, 46 | 0, 1102572 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1102588 | 0, 52 | 0, 1102640 | 0);
  abort();
 }
 
 function $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h98ad7991d05240cb($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     $3 = HEAP32[($1 + 24 | 0) >> 2] | 0;
     if ($3) {
      break label$3
     }
     $1 = 0;
     break label$2;
    }
    HEAP32[($1 + 24 | 0) >> 2] = $3 + -1 | 0;
    if (!(HEAP32[($1 + 4 | 0) >> 2] | 0)) {
     break label$1
    }
    alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Immut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____next_unchecked__hf8cfcc1a4fb4b5f3($2 + 8 | 0 | 0, $1 | 0);
    $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   }
   HEAP32[($0 + 4 | 0) >> 2] = $3;
   HEAP32[$0 >> 2] = $1;
   global$0 = $2 + 16 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1139256 | 0, 43 | 0, 1139396 | 0);
  abort();
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__NativeScriptEnum___serialize__hdc3a49a10a4c617a($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  label$1 : {
   switch (HEAPU8[$1 >> 0] | 0 | 0) {
   default:
    cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__ScriptPubkey___serialize__h0f3da940961ea792($0 | 0, $1 + 1 | 0 | 0, $2 | 0);
    return;
   case 1:
    cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__ScriptAll___serialize__h8f58ae8444303044($0 | 0, $1 + 4 | 0 | 0, $2 | 0);
    return;
   case 2:
    cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__ScriptAny___serialize__haa07f6b291e86618($0 | 0, $1 + 4 | 0 | 0, $2 | 0);
    return;
   case 3:
    cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__ScriptNOfK___serialize__ha6a5cba50bbb5ead($0 | 0, $1 + 4 | 0 | 0, $2 | 0);
    return;
   case 4:
    cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__TimelockStart___serialize__h9a60d7f0e1ad71af($0 | 0, $1 + 8 | 0 | 0, $2 | 0);
    return;
   case 5:
    break label$1;
   };
  }
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__TimelockExpiry___serialize__h9881f5a9c78a9c8e($0 | 0, $1 + 8 | 0 | 0, $2 | 0);
 }
 
 function transaction_body($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 560 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h70df86682e940485($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $cardano_serialization_lib__TransactionBody_20as_20core__clone__Clone___clone__h8541427cda4fbd03($1 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  memcpy($1 + 288 | 0 | 0, $1 + 16 | 0 | 0, 272 | 0) | 0;
  $0 = $cardano_serialization_lib__TransactionBody_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h5f9023ed5f5fb82c($1 + 288 | 0 | 0) | 0;
  global$0 = $1 + 560 | 0;
  return $0 | 0;
 }
 
 function transaction_witness_set($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 176 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h70df86682e940485($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__Transaction__witness_set__h43811a4afb9511d9($1 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  memcpy($1 + 96 | 0 | 0, $1 + 16 | 0 | 0, 76 | 0) | 0;
  $0 = $cardano_serialization_lib__TransactionWitnessSet_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h15af3a22f8db3dff($1 + 96 | 0 | 0) | 0;
  global$0 = $1 + 176 | 0;
  return $0 | 0;
 }
 
 function transactionoutput_address($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 144 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h17af7d9d2d20aa0f($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $cardano_serialization_lib__address__Address_20as_20core__clone__Clone___clone__h0eb465a6e349d507($1 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  memcpy($1 + 80 | 0 | 0, $1 + 16 | 0 | 0, 64 | 0) | 0;
  $0 = $cardano_serialization_lib__address__Address_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8ce30e61cf34786e($1 + 80 | 0 | 0) | 0;
  global$0 = $1 + 144 | 0;
  return $0 | 0;
 }
 
 function poolregistration_pool_params($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 400 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h78c51a186dbaf877($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__PoolRegistration__pool_params__h9c7664cd9d439b4e($1 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  memcpy($1 + 208 | 0 | 0, $1 + 16 | 0 | 0, 192 | 0) | 0;
  $0 = $cardano_serialization_lib__PoolParams_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he83d156438296832($1 + 208 | 0 | 0) | 0;
  global$0 = $1 + 400 | 0;
  return $0 | 0;
 }
 
 function poolregistration_new($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 400 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hc466bac66f8af18e($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__PoolRegistration__new__ha06a92da84e1c24a($1 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  memcpy($1 + 208 | 0 | 0, $1 + 16 | 0 | 0, 192 | 0) | 0;
  $0 = $cardano_serialization_lib__PoolRegistration_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hba4f55f2c62f4c8d($1 + 208 | 0 | 0) | 0;
  global$0 = $1 + 400 | 0;
  return $0 | 0;
 }
 
 function certificate_new_pool_registration($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 416 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h78c51a186dbaf877($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__Certificate__new_pool_registration__h57a31bf78c202bc5($1 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  memcpy($1 + 216 | 0 | 0, $1 + 16 | 0 | 0, 200 | 0) | 0;
  $0 = $cardano_serialization_lib__Certificate_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hd9e6ef3cbd15ff20($1 + 216 | 0 | 0) | 0;
  global$0 = $1 + 416 | 0;
  return $0 | 0;
 }
 
 function certificate_new_move_instantaneous_rewards_cert($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 416 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h0350daea3c8d0cce($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__Certificate__new_move_instantaneous_rewards_cert__ha7dd5e672abc62f6($1 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  memcpy($1 + 216 | 0 | 0, $1 + 16 | 0 | 0, 200 | 0) | 0;
  $0 = $cardano_serialization_lib__Certificate_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hd9e6ef3cbd15ff20($1 + 216 | 0 | 0) | 0;
  global$0 = $1 + 416 | 0;
  return $0 | 0;
 }
 
 function update_proposed_protocol_parameter_updates($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 96 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h20ee1b39869b5e8f($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__h847b9d84e24adaa5($1 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  memcpy($1 + 56 | 0 | 0, $1 + 16 | 0 | 0, 40 | 0) | 0;
  $0 = $cardano_serialization_lib__ProposedProtocolParameterUpdates_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he29d4b6136a4f24f($1 + 56 | 0 | 0) | 0;
  global$0 = $1 + 96 | 0;
  return $0 | 0;
 }
 
 function transactionunspentoutput_output($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 272 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hbebd755b3868aed3($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $cardano_serialization_lib__TransactionOutput_20as_20core__clone__Clone___clone__h6884f0c4818d1aeb($1 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  memcpy($1 + 144 | 0 | 0, $1 + 16 | 0 | 0, 128 | 0) | 0;
  $0 = $cardano_serialization_lib__TransactionOutput_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h4b9395cffb8a7c47($1 + 144 | 0 | 0) | 0;
  global$0 = $1 + 272 | 0;
  return $0 | 0;
 }
 
 function transactionbuilder_new($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 1056 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hf668a970fcd602f3($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__tx_builder__TransactionBuilder__new__hc837de38ea518a90($1 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  memcpy($1 + 536 | 0 | 0, $1 + 16 | 0 | 0, 520 | 0) | 0;
  $0 = $cardano_serialization_lib__tx_builder__TransactionBuilder_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h055297508c0634c1($1 + 536 | 0 | 0) | 0;
  global$0 = $1 + 1056 | 0;
  return $0 | 0;
 }
 
 function bip32privatekey_to_public($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 144 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h30021c0122a7c8e6($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  ed25519_bip32__key__XPrv__public__h9a90c9dc9e5d18c6($1 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  memcpy($1 + 80 | 0 | 0, $1 + 16 | 0 | 0, 64 | 0) | 0;
  $0 = $cardano_serialization_lib__crypto__Bip32PublicKey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h56f6677bb959345b($1 + 80 | 0 | 0) | 0;
  global$0 = $1 + 144 | 0;
  return $0 | 0;
 }
 
 function plutuswitness_datum($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 112 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hbec83ebdd86caafd($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $cardano_serialization_lib__plutus__PlutusData_20as_20core__clone__Clone___clone__h63d1a98cc18f4609_1($1 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  memcpy($1 + 64 | 0 | 0, $1 + 16 | 0 | 0, 48 | 0) | 0;
  $0 = $cardano_serialization_lib__plutus__PlutusData_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h7393378a3318e0a5($1 + 64 | 0 | 0) | 0;
  global$0 = $1 + 112 | 0;
  return $0 | 0;
 }
 
 function byronaddress_to_address($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 144 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h76f3e067f9139bb4($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__address__ByronAddress__to_address__h596b6d78801bce8a($1 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  memcpy($1 + 80 | 0 | 0, $1 + 16 | 0 | 0, 64 | 0) | 0;
  $0 = $cardano_serialization_lib__address__Address_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8ce30e61cf34786e($1 + 80 | 0 | 0) | 0;
  global$0 = $1 + 144 | 0;
  return $0 | 0;
 }
 
 function cardano_serialization_lib__address__Address__network_id__h6a5da16b4c596a9d($0) {
  $0 = $0 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $2$hi = 0, $3$hi = 0, $2 = 0, $3 = 0, $13 = 0, $14 = 0, $23 = 0, $23$hi = 0, $27$hi = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     switch (HEAPU8[$0 >> 0] | 0 | 0) {
     default:
      $0 = HEAPU8[($0 + 1 | 0) >> 0] | 0;
      break label$2;
     case 1:
      $0 = HEAPU8[($0 + 32 | 0) >> 0] | 0;
      break label$2;
     case 4:
      break label$3;
     };
    }
    i64toi32_i32$0 = cardano_serialization_lib__address__ByronAddress__network_id__h46302a3365c1ef18($0 + 4 | 0 | 0) | 0;
    i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    i64toi32_i32$3 = 255;
    i64toi32_i32$0 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
    $2 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
    $2$hi = i64toi32_i32$0;
    i64toi32_i32$0 = i64toi32_i32$1;
    i64toi32_i32$1 = i64toi32_i32$2;
    i64toi32_i32$2 = -1;
    i64toi32_i32$3 = -65536;
    i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
    $3 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
    $3$hi = i64toi32_i32$2;
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$0 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    i64toi32_i32$3 = 8;
    i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$1 = 0;
     $13 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
    } else {
     i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
     $13 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
    }
    $0 = $13;
    break label$1;
   }
   i64toi32_i32$1 = 0;
   $3 = 0;
   $3$hi = i64toi32_i32$1;
   i64toi32_i32$1 = 0;
   $2 = 0;
   $2$hi = i64toi32_i32$1;
  }
  i64toi32_i32$1 = $2$hi;
  i64toi32_i32$1 = $3$hi;
  i64toi32_i32$1 = $2$hi;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = $3$hi;
  i64toi32_i32$3 = $3;
  i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
  $23 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  $23$hi = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$1 = $0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 255;
  i64toi32_i32$2 = i64toi32_i32$0 & i64toi32_i32$2 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 8;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
   $14 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$0 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
   $14 = i64toi32_i32$0 << i64toi32_i32$4 | 0;
  }
  $27$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $23$hi;
  i64toi32_i32$2 = $23;
  i64toi32_i32$0 = $27$hi;
  i64toi32_i32$3 = $14;
  i64toi32_i32$0 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$0;
  return i64toi32_i32$2 | 0;
 }
 
 function plutusdata_new_empty_constr_plutus_data($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 112 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__plutus__PlutusData__new_empty_constr_plutus_data__h775dcd2e87db4a95($1 + 16 | 0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  memcpy($1 + 64 | 0 | 0, $1 + 16 | 0 | 0, 48 | 0) | 0;
  $0 = $cardano_serialization_lib__plutus__PlutusData_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h7393378a3318e0a5($1 + 64 | 0 | 0) | 0;
  global$0 = $1 + 112 | 0;
  return $0 | 0;
 }
 
 function $core__iter__adapters__cloned__Cloned_I__20as_20core__iter__traits__iterator__Iterator___next__h9b1225c14b74e98d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $1 + 28 | 0;
  label$1 : {
   label$2 : while (1) {
    $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h1af0b182f7766c68($2 | 0, $1 | 0);
    label$3 : {
     $3 = HEAP32[$2 >> 2] | 0;
     if ($3) {
      break label$3
     }
     $3 = 0;
     break label$1;
    }
    HEAP32[($2 + 12 | 0) >> 2] = $3;
    if (!(core__ops__function__impls___impl_20core__ops__function__FnMut_A__20for_20_mut_20F___call_mut__h0861d99072db3ec1($2 + 8 | 0 | 0, $2 + 12 | 0 | 0) | 0)) {
     continue label$2
    }
    break label$2;
   };
   $1 = HEAP32[$3 >> 2] | 0;
   $3 = 1;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[$0 >> 2] = $3;
  global$0 = $2 + 16 | 0;
 }
 
 function moveinstantaneousreward_as_to_other_pot($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $2 = 0, $2$hi = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h84b5bdabb1c1c80b($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   i64toi32_i32$2 = $0;
   i64toi32_i32$0 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($0 + 12 | 0) >> 2] | 0;
   $2 = i64toi32_i32$0;
   $2$hi = i64toi32_i32$1;
   i64toi32_i32$2 = $0;
   i64toi32_i32$1 = HEAP32[$0 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   $0 = 0;
   label$2 : {
    i64toi32_i32$2 = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    if ((i64toi32_i32$2 | 0) == (1 | 0) & (i64toi32_i32$0 | 0) == (i64toi32_i32$1 | 0) | 0) {
     break label$2
    }
    i64toi32_i32$2 = $2$hi;
    $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810($2 | 0, i64toi32_i32$2 | 0) | 0;
   }
   global$0 = $1 + 16 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function timelockstart_slot($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$2 = 0, $2 = 0, i64toi32_i32$1 = 0, $3 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h10da0fea03f0ac1d($1 + 8 | 0 | 0, $0 | 0);
    $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    cardano_serialization_lib__utils___impl_20core__convert__TryFrom_cardano_serialization_lib__utils__BigNum__20for_20u32___try_from__h480b087dada7bb26($1 | 0, HEAP32[i64toi32_i32$2 >> 2] | 0 | 0, i64toi32_i32$1 | 0);
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $3 = HEAP32[$1 >> 2] | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    if ($3) {
     break label$1
    }
    global$0 = $1 + 16 | 0;
    return $2 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472($2 | 0);
  abort();
 }
 
 function timelockexpiry_slot($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$2 = 0, $2 = 0, i64toi32_i32$1 = 0, $3 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__hd0c16785fb9ea7bd($1 + 8 | 0 | 0, $0 | 0);
    $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    cardano_serialization_lib__utils___impl_20core__convert__TryFrom_cardano_serialization_lib__utils__BigNum__20for_20u32___try_from__h480b087dada7bb26($1 | 0, HEAP32[i64toi32_i32$2 >> 2] | 0 | 0, i64toi32_i32$1 | 0);
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $3 = HEAP32[$1 >> 2] | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    if ($3) {
     break label$1
    }
    global$0 = $1 + 16 | 0;
    return $2 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472($2 | 0);
  abort();
 }
 
 function nativescript_as_timelock_start($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0, $3 = 0, $3$hi = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h6ed0b6b043905434($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($0 + 12 | 0) >> 2] | 0;
   $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   $3$hi = i64toi32_i32$1;
   $2 = HEAPU8[$0 >> 0] | 0;
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   $0 = 0;
   label$2 : {
    if (($2 | 0) != (4 | 0)) {
     break label$2
    }
    i64toi32_i32$1 = $3$hi;
    $0 = $cardano_serialization_lib__TimelockStart_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h71f9779b79ae2a49($3 | 0, i64toi32_i32$1 | 0) | 0;
   }
   global$0 = $1 + 16 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function nativescript_as_timelock_expiry($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0, $3 = 0, $3$hi = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h6ed0b6b043905434($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($0 + 12 | 0) >> 2] | 0;
   $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   $3$hi = i64toi32_i32$1;
   $2 = HEAPU8[$0 >> 0] | 0;
   $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
   $0 = 0;
   label$2 : {
    if (($2 | 0) != (5 | 0)) {
     break label$2
    }
    i64toi32_i32$1 = $3$hi;
    $0 = $cardano_serialization_lib__TimelockExpiry_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h701c0b7035bdc4b4($3 | 0, i64toi32_i32$1 | 0) | 0;
   }
   global$0 = $1 + 16 | 0;
   return $0 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function headerbody_slot($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$2 = 0, $2 = 0, i64toi32_i32$1 = 0, $3 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h2ac16fcb64db16b5($1 + 8 | 0 | 0, $0 | 0);
    $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    cardano_serialization_lib__utils___impl_20core__convert__TryFrom_cardano_serialization_lib__utils__BigNum__20for_20u32___try_from__h480b087dada7bb26($1 | 0, HEAP32[i64toi32_i32$2 >> 2] | 0 | 0, i64toi32_i32$1 | 0);
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $3 = HEAP32[$1 >> 2] | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    if ($3) {
     break label$1
    }
    global$0 = $1 + 16 | 0;
    return $2 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472($2 | 0);
  abort();
 }
 
 function $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__cmp__PartialEq___eq__h47be0878df6ae947($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $3 = 0;
  label$1 : {
   $4 = HEAP32[($0 + 28 | 0) >> 2] | 0;
   if (($4 | 0) != (HEAP32[($1 + 28 | 0) >> 2] | 0 | 0)) {
    break label$1
   }
   label$2 : {
    label$3 : {
     $0 = HEAP32[($0 + 32 | 0) >> 2] | 0;
     if ($0) {
      break label$3
     }
     $3 = 0;
     break label$2;
    }
    $3 = HEAP32[($0 + 100 | 0) >> 2] | 0;
   }
   HEAP32[($2 + 8 | 0) >> 2] = $4;
   HEAP32[($2 + 4 | 0) >> 2] = $0;
   HEAP32[$2 >> 2] = $3;
   $3 = core__iter__traits__iterator__Iterator__eq_by__h46111545684c8f23($2 | 0, $1 | 0) | 0;
  }
  global$0 = $2 + 16 | 0;
  return $3 | 0;
 }
 
 function $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__hbe15b6996cefd7cc($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $3 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $2 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  label$1 : {
   if (!$2) {
    break label$1
   }
   label$2 : {
    $3 = HEAP32[$0 >> 2] | 0;
    if (!$3) {
     break label$2
    }
    label$3 : while (1) {
     $2 = HEAP32[($2 + 448 | 0) >> 2] | 0;
     $3 = $3 + -1 | 0;
     if ($3) {
      continue label$3
     }
     break label$3;
    };
   }
   HEAP32[($1 + 8 | 0) >> 2] = 0;
   HEAP32[($1 + 4 | 0) >> 2] = $2;
   HEAP32[$1 >> 2] = 0;
   HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
   $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__h61f437aecb6ab6ea($1 | 0);
  }
  global$0 = $1 + 16 | 0;
 }
 
 function $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $3 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $2 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  label$1 : {
   if (!$2) {
    break label$1
   }
   label$2 : {
    $3 = HEAP32[$0 >> 2] | 0;
    if (!$3) {
     break label$2
    }
    label$3 : while (1) {
     $2 = HEAP32[($2 + 448 | 0) >> 2] | 0;
     $3 = $3 + -1 | 0;
     if ($3) {
      continue label$3
     }
     break label$3;
    };
   }
   HEAP32[($1 + 8 | 0) >> 2] = 0;
   HEAP32[($1 + 4 | 0) >> 2] = $2;
   HEAP32[$1 >> 2] = 0;
   HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
   $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__h6efa1169fdfacf7e($1 | 0);
  }
  global$0 = $1 + 16 | 0;
 }
 
 function $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h50a5c5eb0f530455($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $3 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $2 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  label$1 : {
   if (!$2) {
    break label$1
   }
   label$2 : {
    $3 = HEAP32[$0 >> 2] | 0;
    if (!$3) {
     break label$2
    }
    label$3 : while (1) {
     $2 = HEAP32[($2 + 1064 | 0) >> 2] | 0;
     $3 = $3 + -1 | 0;
     if ($3) {
      continue label$3
     }
     break label$3;
    };
   }
   HEAP32[($1 + 8 | 0) >> 2] = 0;
   HEAP32[($1 + 4 | 0) >> 2] = $2;
   HEAP32[$1 >> 2] = 0;
   HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
   $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__h55d7b487bf88b8bd($1 | 0);
  }
  global$0 = $1 + 16 | 0;
 }
 
 function $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h6c9f94f0f82ce2b5($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $3 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $2 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  label$1 : {
   if (!$2) {
    break label$1
   }
   label$2 : {
    $3 = HEAP32[$0 >> 2] | 0;
    if (!$3) {
     break label$2
    }
    label$3 : while (1) {
     $2 = HEAP32[($2 + 232 | 0) >> 2] | 0;
     $3 = $3 + -1 | 0;
     if ($3) {
      continue label$3
     }
     break label$3;
    };
   }
   HEAP32[($1 + 8 | 0) >> 2] = 0;
   HEAP32[($1 + 4 | 0) >> 2] = $2;
   HEAP32[$1 >> 2] = 0;
   HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
   $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__h949cd00de60e473b($1 | 0);
  }
  global$0 = $1 + 16 | 0;
 }
 
 function $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h3981a4152bf24dd0($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $3 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $2 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  label$1 : {
   if (!$2) {
    break label$1
   }
   label$2 : {
    $3 = HEAP32[$0 >> 2] | 0;
    if (!$3) {
     break label$2
    }
    label$3 : while (1) {
     $2 = HEAP32[($2 + 448 | 0) >> 2] | 0;
     $3 = $3 + -1 | 0;
     if ($3) {
      continue label$3
     }
     break label$3;
    };
   }
   HEAP32[($1 + 8 | 0) >> 2] = 0;
   HEAP32[($1 + 4 | 0) >> 2] = $2;
   HEAP32[$1 >> 2] = 0;
   HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
   $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__h55ccecf13401bd6c($1 | 0);
  }
  global$0 = $1 + 16 | 0;
 }
 
 function $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h0265580a5be10b66($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $3 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $2 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  label$1 : {
   if (!$2) {
    break label$1
   }
   label$2 : {
    $3 = HEAP32[$0 >> 2] | 0;
    if (!$3) {
     break label$2
    }
    label$3 : while (1) {
     $2 = HEAP32[($2 + 320 | 0) >> 2] | 0;
     $3 = $3 + -1 | 0;
     if ($3) {
      continue label$3
     }
     break label$3;
    };
   }
   HEAP32[($1 + 8 | 0) >> 2] = 0;
   HEAP32[($1 + 4 | 0) >> 2] = $2;
   HEAP32[$1 >> 2] = 0;
   HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
   $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__h275f681e487dc2bb($1 | 0);
  }
  global$0 = $1 + 16 | 0;
 }
 
 function $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h04a6b671c790649f($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $3 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $2 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  label$1 : {
   if (!$2) {
    break label$1
   }
   label$2 : {
    $3 = HEAP32[$0 >> 2] | 0;
    if (!$3) {
     break label$2
    }
    label$3 : while (1) {
     $2 = HEAP32[($2 + 316 | 0) >> 2] | 0;
     $3 = $3 + -1 | 0;
     if ($3) {
      continue label$3
     }
     break label$3;
    };
   }
   HEAP32[($1 + 8 | 0) >> 2] = 0;
   HEAP32[($1 + 4 | 0) >> 2] = $2;
   HEAP32[$1 >> 2] = 0;
   HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
   $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__hbd56bd5c906359e6($1 | 0);
  }
  global$0 = $1 + 16 | 0;
 }
 
 function $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h315fcfacfcb22ee3($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $3 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $2 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  label$1 : {
   if (!$2) {
    break label$1
   }
   label$2 : {
    $3 = HEAP32[$0 >> 2] | 0;
    if (!$3) {
     break label$2
    }
    label$3 : while (1) {
     $2 = HEAP32[($2 + 144 | 0) >> 2] | 0;
     $3 = $3 + -1 | 0;
     if ($3) {
      continue label$3
     }
     break label$3;
    };
   }
   HEAP32[($1 + 8 | 0) >> 2] = 0;
   HEAP32[($1 + 4 | 0) >> 2] = $2;
   HEAP32[$1 >> 2] = 0;
   HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
   $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__h43bfad66db8b3ade($1 | 0);
  }
  global$0 = $1 + 16 | 0;
 }
 
 function $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h5f5dc70d320637e0($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $3 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $2 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  label$1 : {
   if (!$2) {
    break label$1
   }
   label$2 : {
    $3 = HEAP32[$0 >> 2] | 0;
    if (!$3) {
     break label$2
    }
    label$3 : while (1) {
     $2 = HEAP32[($2 + 140 | 0) >> 2] | 0;
     $3 = $3 + -1 | 0;
     if ($3) {
      continue label$3
     }
     break label$3;
    };
   }
   HEAP32[($1 + 8 | 0) >> 2] = 0;
   HEAP32[($1 + 4 | 0) >> 2] = $2;
   HEAP32[$1 >> 2] = 0;
   HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
   $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__h52f1a1239f0bb749($1 | 0);
  }
  global$0 = $1 + 16 | 0;
 }
 
 function $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h6e0c34e8fa561cb7($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $3 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $2 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  label$1 : {
   if (!$2) {
    break label$1
   }
   label$2 : {
    $3 = HEAP32[$0 >> 2] | 0;
    if (!$3) {
     break label$2
    }
    label$3 : while (1) {
     $2 = HEAP32[($2 + 52 | 0) >> 2] | 0;
     $3 = $3 + -1 | 0;
     if ($3) {
      continue label$3
     }
     break label$3;
    };
   }
   HEAP32[($1 + 8 | 0) >> 2] = 0;
   HEAP32[($1 + 4 | 0) >> 2] = $2;
   HEAP32[$1 >> 2] = 0;
   HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
   $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__h61895ab898024b72($1 | 0);
  }
  global$0 = $1 + 16 | 0;
 }
 
 function $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h7d849e3c4cfb66e1($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $3 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $2 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  label$1 : {
   if (!$2) {
    break label$1
   }
   label$2 : {
    $3 = HEAP32[$0 >> 2] | 0;
    if (!$3) {
     break label$2
    }
    label$3 : while (1) {
     $2 = HEAP32[($2 + 1464 | 0) >> 2] | 0;
     $3 = $3 + -1 | 0;
     if ($3) {
      continue label$3
     }
     break label$3;
    };
   }
   HEAP32[($1 + 8 | 0) >> 2] = 0;
   HEAP32[($1 + 4 | 0) >> 2] = $2;
   HEAP32[$1 >> 2] = 0;
   HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
   $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__ha997f3ce18a23f3f($1 | 0);
  }
  global$0 = $1 + 16 | 0;
 }
 
 function $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h903e00ab7dfc505c($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $3 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $2 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  label$1 : {
   if (!$2) {
    break label$1
   }
   label$2 : {
    $3 = HEAP32[$0 >> 2] | 0;
    if (!$3) {
     break label$2
    }
    label$3 : while (1) {
     $2 = HEAP32[($2 + 1552 | 0) >> 2] | 0;
     $3 = $3 + -1 | 0;
     if ($3) {
      continue label$3
     }
     break label$3;
    };
   }
   HEAP32[($1 + 8 | 0) >> 2] = 0;
   HEAP32[($1 + 4 | 0) >> 2] = $2;
   HEAP32[$1 >> 2] = 0;
   HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
   $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__h5b1899637bbf7049($1 | 0);
  }
  global$0 = $1 + 16 | 0;
 }
 
 function $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__hb1ec706811634e79($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $3 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $2 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  label$1 : {
   if (!$2) {
    break label$1
   }
   label$2 : {
    $3 = HEAP32[$0 >> 2] | 0;
    if (!$3) {
     break label$2
    }
    label$3 : while (1) {
     $2 = HEAP32[($2 + 140 | 0) >> 2] | 0;
     $3 = $3 + -1 | 0;
     if ($3) {
      continue label$3
     }
     break label$3;
    };
   }
   HEAP32[($1 + 8 | 0) >> 2] = 0;
   HEAP32[($1 + 4 | 0) >> 2] = $2;
   HEAP32[$1 >> 2] = 0;
   HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
   $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__hdb3d805366b8acdd($1 | 0);
  }
  global$0 = $1 + 16 | 0;
 }
 
 function serde__ser__SerializeMap__serialize_entry__h173bbbfadb8f829e($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  $4 = HEAP32[$0 >> 2] | 0;
  label$1 : {
   if ((HEAPU8[($0 + 4 | 0) >> 0] | 0 | 0) == (1 | 0)) {
    break label$1
   }
   alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb(HEAP32[$4 >> 2] | 0 | 0, 1068489 | 0, 1 | 0);
  }
  HEAP8[($0 + 4 | 0) >> 0] = 2;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $1 | 0);
  serde_json__ser__format_escaped_str__h36c322c8ecbdeb72($4 | 0, $3 | 0, HEAP32[($3 + 8 | 0) >> 2] | 0 | 0, HEAP32[($3 + 12 | 0) >> 2] | 0 | 0) | 0;
  alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb(HEAP32[$4 >> 2] | 0 | 0, 1068504 | 0, 1 | 0);
  serde_json__value__ser___impl_20serde__ser__Serialize_20for_20serde_json__value__Value___serialize__ha2851daf0650b497($2 | 0, $4 | 0) | 0;
  global$0 = $3 + 16 | 0;
  return 0 | 0;
 }
 
 function pointer_slot($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$2 = 0, $2 = 0, i64toi32_i32$1 = 0, $3 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h7b63d9df2a892a8b($1 + 8 | 0 | 0, $0 | 0);
    $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    cardano_serialization_lib__utils___impl_20core__convert__TryFrom_cardano_serialization_lib__utils__BigNum__20for_20u32___try_from__h480b087dada7bb26($1 | 0, HEAP32[i64toi32_i32$2 >> 2] | 0 | 0, i64toi32_i32$1 | 0);
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $3 = HEAP32[$1 >> 2] | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    if ($3) {
     break label$1
    }
    global$0 = $1 + 16 | 0;
    return $2 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472($2 | 0);
  abort();
 }
 
 function pointer_tx_index($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$2 = 0, $2 = 0, i64toi32_i32$1 = 0, $3 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h7b63d9df2a892a8b($1 + 8 | 0 | 0, $0 | 0);
    $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
    cardano_serialization_lib__utils___impl_20core__convert__TryFrom_cardano_serialization_lib__utils__BigNum__20for_20u32___try_from__h480b087dada7bb26($1 | 0, HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0 | 0, i64toi32_i32$1 | 0);
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $3 = HEAP32[$1 >> 2] | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    if ($3) {
     break label$1
    }
    global$0 = $1 + 16 | 0;
    return $2 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472($2 | 0);
  abort();
 }
 
 function pointer_cert_index($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$2 = 0, $2 = 0, i64toi32_i32$1 = 0, $3 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h7b63d9df2a892a8b($1 + 8 | 0 | 0, $0 | 0);
    $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    i64toi32_i32$2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
    cardano_serialization_lib__utils___impl_20core__convert__TryFrom_cardano_serialization_lib__utils__BigNum__20for_20u32___try_from__h480b087dada7bb26($1 | 0, HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0 | 0, i64toi32_i32$1 | 0);
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $3 = HEAP32[$1 >> 2] | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    if ($3) {
     break label$1
    }
    global$0 = $1 + 16 | 0;
    return $2 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472($2 | 0);
  abort();
 }
 
 function cardano_serialization_lib__plutus__Redeemers__get__h5deba8646dc7d1c2($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $28 = 0, $33 = 0, $36 = 0;
  label$1 : {
   $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   if ($3 >>> 0 > $2 >>> 0) {
    break label$1
   }
   core__panicking__panic_bounds_check__h808b524af17640b1($2 | 0, $3 | 0, 1071780 | 0);
   abort();
  }
  $2 = (HEAP32[$1 >> 2] | 0) + Math_imul($2, 80) | 0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $1 = HEAPU8[($2 + 72 | 0) >> 0] | 0;
  $cardano_serialization_lib__plutus__PlutusData_20as_20core__clone__Clone___clone__h63d1a98cc18f4609_2($0 + 8 | 0 | 0, $2 + 8 | 0 | 0);
  HEAP8[($0 + 72 | 0) >> 0] = $1;
  $28 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $28;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2 + 64 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $33 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 64 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $33;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[($2 + 56 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 60 | 0) >> 2] | 0;
  $36 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 56 | 0) >> 2] = $36;
  HEAP32[(i64toi32_i32$0 + 60 | 0) >> 2] = i64toi32_i32$1;
 }
 
 function $cardano_serialization_lib__legacy_address__address__SpendingData_20as_20cbor_event__se__Serialize___serialize__h35a1209176b0e5ef($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $3 = global$0 - 128 | 0;
  global$0 = $3;
  memcpy($3 + 64 | 0 | 0, HEAP32[$1 >> 2] | 0 | 0, 64 | 0) | 0;
  ed25519_bip32__key___impl_20core__convert__From_ed25519_bip32__key__XPub__20for_20_5bu8_3b_20__5d___from__h36378fdf85348fc4($3 | 0, $3 + 64 | 0 | 0);
  (wasm2js_i32$0 = $3, wasm2js_i32$1 = cbor_event__types__Type__to_byte__h30363627277739c1(4 | 0, 2 | 0) | 0), HEAP8[(wasm2js_i32$0 + 64 | 0) >> 0] = wasm2js_i32$1;
  alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($2 | 0, $3 + 64 | 0 | 0, 1 | 0);
  (wasm2js_i32$0 = $3, wasm2js_i32$1 = cbor_event__types__Type__to_byte__h30363627277739c1(0 | 0, 0 | 0) | 0), HEAP8[(wasm2js_i32$0 + 64 | 0) >> 0] = wasm2js_i32$1;
  alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($2 | 0, $3 + 64 | 0 | 0, 1 | 0);
  cbor_event__se__Serializer_W___write_bytes__h1ecbe6b3316bc5ff($0 | 0, $2 | 0, $3 | 0, 64 | 0);
  global$0 = $3 + 128 | 0;
 }
 
 function alloc__collections__btree__map__entry__Entry_K_2cV___or_default__h1c00ee87c8b7cd04($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 160 | 0;
  global$0 = $1;
  label$1 : {
   label$2 : {
    if ((HEAP32[$0 >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $0 = memcpy($1 | 0, $0 + 8 | 0 | 0, 144 | 0) | 0;
    HEAP32[($0 + 148 | 0) >> 2] = 0;
    HEAP32[($0 + 152 | 0) >> 2] = 0;
    HEAP32[($0 + 144 | 0) >> 2] = HEAP32[(0 + 1067632 | 0) >> 2] | 0;
    $0 = alloc__collections__btree__map__entry__VacantEntry_K_2cV___insert__h46f4eca0a6822bea($0 | 0, $0 + 144 | 0 | 0) | 0;
    break label$1;
   }
   $0 = ((HEAP32[($0 + 8 | 0) >> 2] | 0) + Math_imul(HEAP32[($0 + 12 | 0) >> 2] | 0, 12) | 0) + 1412 | 0;
  }
  global$0 = $1 + 160 | 0;
  return $0 | 0;
 }
 
 function rand__rngs__adapter__reseeding__ReseedingCore_R_2cRsdr___reseed__h63283490f2a6b10f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, $3 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  rand_core__SeedableRng__from_rng__h69fb0d629616b25c($2 + 8 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[($2 + 8 | 0) >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    i64toi32_i32$1 = HEAP32[($1 + 52 | 0) >> 2] | 0;
    HEAP32[($1 + 56 | 0) >> 2] = HEAP32[($1 + 48 | 0) >> 2] | 0;
    HEAP32[($1 + 60 | 0) >> 2] = i64toi32_i32$1;
    memcpy($1 | 0, $2 + 16 | 0 | 0, 48 | 0) | 0;
    $1 = 0;
    break label$1;
   }
   $3 = HEAP32[($2 + 16 | 0) >> 2] | 0;
   $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $3;
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 64 | 0;
 }
 
 function ppv_lite86__generic__omap__h69e9e38458647661($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $2 = 0, $3 = 0, $13 = 0, $16 = 0, $24 = 0, $24$hi = 0, $26 = 0, $26$hi = 0, $30 = 0, $33 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  $3 = ($2 + 16 | 0) + 8 | 0;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $13 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[i64toi32_i32$0 >> 2] = $13;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $16 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[(i64toi32_i32$1 + 16 | 0) >> 2] = $16;
  HEAP32[(i64toi32_i32$1 + 20 | 0) >> 2] = i64toi32_i32$0;
  ppv_lite86__generic__o_of_q__hb8b715d2ffb8bacd(i64toi32_i32$1 | 0, i64toi32_i32$1 + 16 | 0 | 0);
  i64toi32_i32$2 = i64toi32_i32$1 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  $24$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $26 = i64toi32_i32$1;
  $26$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $24$hi;
  i64toi32_i32$1 = $26$hi;
  ppv_lite86__generic__q_of_o__h249a42d67ddc4145(i64toi32_i32$2 + 16 | 0 | 0, $24 | 0, i64toi32_i32$0 | 0, $26 | 0, i64toi32_i32$1 | 0);
  i64toi32_i32$2 = $3;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $30 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $30;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $33 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $33;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = i64toi32_i32$2 + 32 | 0;
 }
 
 function serde_json__read__error__h78831bedcbd1affe($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, i64toi32_i32$1 = 0;
  $3 = global$0 - 32 | 0;
  global$0 = $3;
  serde_json__read__SliceRead__position_of_index__ha8a2610e8c8fa0b4($3 + 8 | 0 | 0, $1 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
  $1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
  $4 = HEAP32[($3 + 8 | 0) >> 2] | 0;
  HEAP32[(($3 + 16 | 0) + 8 | 0) >> 2] = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  HEAP32[($3 + 16 | 0) >> 2] = HEAP32[$2 >> 2] | 0;
  HEAP32[($3 + 20 | 0) >> 2] = i64toi32_i32$1;
  $2 = serde_json__error__Error__syntax__h11c9d7f40fe522f9($3 + 16 | 0 | 0, $4 | 0, $1 | 0) | 0;
  HEAP32[$0 >> 2] = 1;
  HEAP32[($0 + 4 | 0) >> 2] = $2;
  global$0 = $3 + 32 | 0;
 }
 
 function serde_json__read__error__hdb2fc08732a86d5b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $10 = 0, $3 = 0, $24 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  serde_json__read__SliceRead__position_of_index__ha8a2610e8c8fa0b4($2 + 8 | 0 | 0, $0 | 0, HEAP32[($0 + 8 | 0) >> 2] | 0 | 0);
  $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $24;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$1;
  $1 = serde_json__error__Error__syntax__h11c9d7f40fe522f9($2 + 16 | 0 | 0, $3 | 0, $0 | 0) | 0;
  global$0 = $2 + 32 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $10 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $10 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  i64toi32_i32$1 = $10;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 1;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  i64toi32_i32$1 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$2;
  return i64toi32_i32$1 | 0;
 }
 
 function serde_json__read__error__hbb7920fc00b2536f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, $10 = 0, $3 = 0, $24 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  serde_json__read__SliceRead__position_of_index__ha8a2610e8c8fa0b4($2 + 8 | 0 | 0, $0 | 0, HEAP32[($0 + 8 | 0) >> 2] | 0 | 0);
  $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $24;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$1;
  $1 = serde_json__error__Error__syntax__h11c9d7f40fe522f9($2 + 16 | 0 | 0, $3 | 0, $0 | 0) | 0;
  global$0 = $2 + 32 | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $10 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
   $10 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  i64toi32_i32$1 = $10;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 1;
  i64toi32_i32$2 = i64toi32_i32$0 | i64toi32_i32$2 | 0;
  i64toi32_i32$1 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$2;
  return i64toi32_i32$1 | 0;
 }
 
 function $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h0198cfc402357e50($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $3 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $2 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  label$1 : {
   if (!$2) {
    break label$1
   }
   label$2 : {
    $3 = HEAP32[$0 >> 2] | 0;
    if (!$3) {
     break label$2
    }
    label$3 : while (1) {
     $2 = HEAP32[($2 + 408 | 0) >> 2] | 0;
     $3 = $3 + -1 | 0;
     if ($3) {
      continue label$3
     }
     break label$3;
    };
   }
   HEAP32[($1 + 8 | 0) >> 2] = 0;
   HEAP32[($1 + 4 | 0) >> 2] = $2;
   HEAP32[$1 >> 2] = 0;
   HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
   $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__hdfdbc3776b972463($1 | 0);
  }
  global$0 = $1 + 16 | 0;
 }
 
 function ed25519_bip32__key__mk_xprv__h1536372bcc560835($0, $1, $2, $3, $4, $5, $6) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  $5 = $5 | 0;
  $6 = $6 | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     if (($2 | 0) != (32 | 0)) {
      break label$3
     }
     if (($4 | 0) != (32 | 0)) {
      break label$2
     }
     if (($6 | 0) == (32 | 0)) {
      break label$1
     }
     core__panicking__panic__h2fd385a887c8bf13(1101956 | 0, 45 | 0, 1102004 | 0);
     abort();
    }
    core__panicking__panic__h2fd385a887c8bf13(1101859 | 0, 32 | 0, 1101892 | 0);
    abort();
   }
   core__panicking__panic__h2fd385a887c8bf13(1101908 | 0, 32 | 0, 1101940 | 0);
   abort();
  }
  core__slice___impl_20_5bT_5d___copy_from_slice__h0f69c19ed1852955($0 | 0, 32 | 0, $1 | 0, 32 | 0);
  core__slice___impl_20_5bT_5d___copy_from_slice__h0f69c19ed1852955($0 + 32 | 0 | 0, 32 | 0, $3 | 0, 32 | 0);
  core__slice___impl_20_5bT_5d___copy_from_slice__h0f69c19ed1852955($0 + 64 | 0 | 0, 32 | 0, $5 | 0, 32 | 0);
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__h2c023f18f1e8d53c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $15 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $0 = HEAP32[$0 >> 2] | 0;
  $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  $0 = HEAP32[$0 >> 2] | 0;
  i64toi32_i32$0 = core__fmt__Formatter__debug_list__h7939d45dcba19956($1 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[$2 >> 2] = $15;
  HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   if (!$3) {
    break label$1
   }
   label$2 : while (1) {
    HEAP32[($2 + 12 | 0) >> 2] = $0;
    core__fmt__builders__DebugSet__entry__he7b13b90636ac2b8($2 | 0, $2 + 12 | 0 | 0, 1142244 | 0) | 0;
    $0 = $0 + 1 | 0;
    $3 = $3 + -1 | 0;
    if ($3) {
     continue label$2
    }
    break label$2;
   };
  }
  $0 = core__fmt__builders__DebugList__finish__h372f90da800e1030($2 | 0) | 0;
  global$0 = $2 + 16 | 0;
  return $0 | 0;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__h852d019cd14e864b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $15 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $0 = HEAP32[$0 >> 2] | 0;
  $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  $0 = HEAP32[$0 >> 2] | 0;
  i64toi32_i32$0 = core__fmt__Formatter__debug_list__h7939d45dcba19956($1 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[$2 >> 2] = $15;
  HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   if (!$3) {
    break label$1
   }
   label$2 : while (1) {
    HEAP32[($2 + 12 | 0) >> 2] = $0;
    core__fmt__builders__DebugSet__entry__he7b13b90636ac2b8($2 | 0, $2 + 12 | 0 | 0, 1145668 | 0) | 0;
    $0 = $0 + 1 | 0;
    $3 = $3 + -1 | 0;
    if ($3) {
     continue label$2
    }
    break label$2;
   };
  }
  $0 = core__fmt__builders__DebugList__finish__h372f90da800e1030($2 | 0) | 0;
  global$0 = $2 + 16 | 0;
  return $0 | 0;
 }
 
 function $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $3 = 0, $4 = 0, $2 = 0;
  $2 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
      if (($3 | 0) < (0 | 0)) {
       break label$4
      }
      $1 = HEAP32[$1 >> 2] | 0;
      if ($3) {
       break label$3
      }
      $4 = 1;
      break label$2;
     }
     alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
     abort();
    }
    $2 = $3;
    $4 = __rust_alloc($3 | 0, 1 | 0) | 0;
    if (!$4) {
     break label$1
    }
   }
   $1 = memcpy($4 | 0, $1 | 0, $3 | 0) | 0;
   HEAP32[($0 + 8 | 0) >> 2] = $3;
   HEAP32[($0 + 4 | 0) >> 2] = $2;
   HEAP32[$0 >> 2] = $1;
   return;
  }
  alloc__alloc__handle_alloc_error__he269d8f1bff90960($3 | 0, 1 | 0);
  abort();
 }
 
 function alloc__vec__Vec_T_2cA___swap_remove__assert_failed__h35befc50802f56b5($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  HEAP32[($2 + 4 | 0) >> 2] = $1;
  HEAP32[$2 >> 2] = $0;
  HEAP32[($2 + 28 | 0) >> 2] = 2;
  HEAP32[($2 + 44 | 0) >> 2] = 46;
  HEAP32[($2 + 12 | 0) >> 2] = 3;
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  HEAP32[($2 + 8 | 0) >> 2] = 1146052;
  HEAP32[($2 + 36 | 0) >> 2] = 46;
  HEAP32[($2 + 24 | 0) >> 2] = $2 + 32 | 0;
  HEAP32[($2 + 40 | 0) >> 2] = $2 + 4 | 0;
  HEAP32[($2 + 32 | 0) >> 2] = $2;
  core__panicking__panic_fmt__hbf21a3d4bbb82bf8($2 + 8 | 0 | 0, 1146104 | 0);
  abort();
 }
 
 function alloc__vec__Vec_T_2cA___remove__assert_failed__ha36a32a2e316829e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  HEAP32[($2 + 4 | 0) >> 2] = $1;
  HEAP32[$2 >> 2] = $0;
  HEAP32[($2 + 28 | 0) >> 2] = 2;
  HEAP32[($2 + 44 | 0) >> 2] = 46;
  HEAP32[($2 + 12 | 0) >> 2] = 3;
  HEAP32[($2 + 16 | 0) >> 2] = 0;
  HEAP32[($2 + 8 | 0) >> 2] = 1146140;
  HEAP32[($2 + 36 | 0) >> 2] = 46;
  HEAP32[($2 + 24 | 0) >> 2] = $2 + 32 | 0;
  HEAP32[($2 + 40 | 0) >> 2] = $2 + 4 | 0;
  HEAP32[($2 + 32 | 0) >> 2] = $2;
  core__panicking__panic_fmt__hbf21a3d4bbb82bf8($2 + 8 | 0 | 0, 1146164 | 0);
  abort();
 }
 
 function core__panicking__panic_bounds_check__h808b524af17640b1($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  HEAP32[($3 + 4 | 0) >> 2] = $1;
  HEAP32[$3 >> 2] = $0;
  HEAP32[($3 + 28 | 0) >> 2] = 2;
  HEAP32[($3 + 44 | 0) >> 2] = 46;
  HEAP32[($3 + 12 | 0) >> 2] = 2;
  HEAP32[($3 + 16 | 0) >> 2] = 0;
  HEAP32[($3 + 8 | 0) >> 2] = 1149580;
  HEAP32[($3 + 36 | 0) >> 2] = 46;
  HEAP32[($3 + 24 | 0) >> 2] = $3 + 32 | 0;
  HEAP32[($3 + 40 | 0) >> 2] = $3;
  HEAP32[($3 + 32 | 0) >> 2] = $3 + 4 | 0;
  core__panicking__panic_fmt__hbf21a3d4bbb82bf8($3 + 8 | 0 | 0, $2 | 0);
  abort();
 }
 
 function core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  HEAP32[($3 + 4 | 0) >> 2] = $1;
  HEAP32[$3 >> 2] = $0;
  HEAP32[($3 + 28 | 0) >> 2] = 2;
  HEAP32[($3 + 44 | 0) >> 2] = 46;
  HEAP32[($3 + 12 | 0) >> 2] = 2;
  HEAP32[($3 + 16 | 0) >> 2] = 0;
  HEAP32[($3 + 8 | 0) >> 2] = 1150756;
  HEAP32[($3 + 36 | 0) >> 2] = 46;
  HEAP32[($3 + 24 | 0) >> 2] = $3 + 32 | 0;
  HEAP32[($3 + 40 | 0) >> 2] = $3 + 4 | 0;
  HEAP32[($3 + 32 | 0) >> 2] = $3;
  core__panicking__panic_fmt__hbf21a3d4bbb82bf8($3 + 8 | 0 | 0, $2 | 0);
  abort();
 }
 
 function core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  HEAP32[($3 + 4 | 0) >> 2] = $1;
  HEAP32[$3 >> 2] = $0;
  HEAP32[($3 + 28 | 0) >> 2] = 2;
  HEAP32[($3 + 44 | 0) >> 2] = 46;
  HEAP32[($3 + 12 | 0) >> 2] = 2;
  HEAP32[($3 + 16 | 0) >> 2] = 0;
  HEAP32[($3 + 8 | 0) >> 2] = 1150788;
  HEAP32[($3 + 36 | 0) >> 2] = 46;
  HEAP32[($3 + 24 | 0) >> 2] = $3 + 32 | 0;
  HEAP32[($3 + 40 | 0) >> 2] = $3 + 4 | 0;
  HEAP32[($3 + 32 | 0) >> 2] = $3;
  core__panicking__panic_fmt__hbf21a3d4bbb82bf8($3 + 8 | 0 | 0, $2 | 0);
  abort();
 }
 
 function core__slice__index__slice_index_order_fail__h71e247dec3f266ff($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  HEAP32[($3 + 4 | 0) >> 2] = $1;
  HEAP32[$3 >> 2] = $0;
  HEAP32[($3 + 28 | 0) >> 2] = 2;
  HEAP32[($3 + 44 | 0) >> 2] = 46;
  HEAP32[($3 + 12 | 0) >> 2] = 2;
  HEAP32[($3 + 16 | 0) >> 2] = 0;
  HEAP32[($3 + 8 | 0) >> 2] = 1150840;
  HEAP32[($3 + 36 | 0) >> 2] = 46;
  HEAP32[($3 + 24 | 0) >> 2] = $3 + 32 | 0;
  HEAP32[($3 + 40 | 0) >> 2] = $3 + 4 | 0;
  HEAP32[($3 + 32 | 0) >> 2] = $3;
  core__panicking__panic_fmt__hbf21a3d4bbb82bf8($3 + 8 | 0 | 0, $2 | 0);
  abort();
 }
 
 function $core__fmt__Arguments_20as_20core__fmt__Display___fmt__h6f43420f70707126($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $2 = 0, $3 = 0, $17 = 0, $23 = 0, $26 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  $3 = HEAP32[($1 + 28 | 0) >> 2] | 0;
  $1 = HEAP32[($1 + 24 | 0) >> 2] | 0;
  i64toi32_i32$2 = $0 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $17 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 8 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $17;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $0 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $23 = i64toi32_i32$1;
  i64toi32_i32$1 = ($2 + 8 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $23;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $26 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $26;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
  $0 = core__fmt__write__h9b9aa23e7d35702c($1 | 0, $3 | 0, i64toi32_i32$0 + 8 | 0 | 0) | 0;
  global$0 = i64toi32_i32$0 + 32 | 0;
  return $0 | 0;
 }
 
 function core__fmt__Formatter__write_fmt__h23f06c16d035978e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $2 = 0, $3 = 0, $17 = 0, $23 = 0, $26 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  $3 = HEAP32[($0 + 28 | 0) >> 2] | 0;
  $0 = HEAP32[($0 + 24 | 0) >> 2] | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $17 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 8 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $17;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $23 = i64toi32_i32$1;
  i64toi32_i32$1 = ($2 + 8 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $23;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $26 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $26;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
  $1 = core__fmt__write__h9b9aa23e7d35702c($0 | 0, $3 | 0, i64toi32_i32$0 + 8 | 0 | 0) | 0;
  global$0 = i64toi32_i32$0 + 32 | 0;
  return $1 | 0;
 }
 
 function core__slice___impl_20_5bT_5d___copy_from_slice__len_mismatch_fail__h13bf5a0e1407b14d($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  HEAP32[($3 + 4 | 0) >> 2] = $1;
  HEAP32[$3 >> 2] = $0;
  HEAP32[($3 + 28 | 0) >> 2] = 2;
  HEAP32[($3 + 44 | 0) >> 2] = 46;
  HEAP32[($3 + 12 | 0) >> 2] = 3;
  HEAP32[($3 + 16 | 0) >> 2] = 0;
  HEAP32[($3 + 8 | 0) >> 2] = 1150920;
  HEAP32[($3 + 36 | 0) >> 2] = 46;
  HEAP32[($3 + 24 | 0) >> 2] = $3 + 32 | 0;
  HEAP32[($3 + 40 | 0) >> 2] = $3;
  HEAP32[($3 + 32 | 0) >> 2] = $3 + 4 | 0;
  core__panicking__panic_fmt__hbf21a3d4bbb82bf8($3 + 8 | 0 | 0, $2 | 0);
  abort();
 }
 
 function alloc__collections__btree__remove___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal__2calloc__collections__btree__node__marker__KV____remove_kv_tracking__ha7e0ee7959bef5ef($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, $5 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $5 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  label$1 : {
   label$2 : {
    $1 = HEAP32[$1 >> 2] | 0;
    if ($1) {
     break label$2
    }
    HEAP32[($3 + 8 | 0) >> 2] = $4;
    HEAP32[($3 + 4 | 0) >> 2] = $5;
    HEAP32[$3 >> 2] = 0;
    alloc__collections__btree__remove___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__KV____remove_leaf_kv__h27b8b726dbbf8174($0 | 0, $3 | 0, $2 | 0);
    break label$1;
   }
   HEAP32[($3 + 8 | 0) >> 2] = $4;
   HEAP32[($3 + 4 | 0) >> 2] = $5;
   HEAP32[$3 >> 2] = $1;
   alloc__collections__btree__remove___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__KV____remove_internal_kv__h16fc58c4c5b6474b($0 | 0, $3 | 0, $2 | 0);
  }
  global$0 = $3 + 16 | 0;
 }
 
 function alloc__collections__btree__remove___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal__2calloc__collections__btree__node__marker__KV____remove_kv_tracking__hc9b884ef6fef5efe($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, $5 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $5 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  label$1 : {
   label$2 : {
    $1 = HEAP32[$1 >> 2] | 0;
    if ($1) {
     break label$2
    }
    HEAP32[($3 + 8 | 0) >> 2] = $4;
    HEAP32[($3 + 4 | 0) >> 2] = $5;
    HEAP32[$3 >> 2] = 0;
    alloc__collections__btree__remove___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__KV____remove_leaf_kv__hb724496be72afff3($0 | 0, $3 | 0, $2 | 0);
    break label$1;
   }
   HEAP32[($3 + 8 | 0) >> 2] = $4;
   HEAP32[($3 + 4 | 0) >> 2] = $5;
   HEAP32[$3 >> 2] = $1;
   alloc__collections__btree__remove___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__KV____remove_internal_kv__h6f3d9ab2a7082b8f($0 | 0, $3 | 0, $2 | 0);
  }
  global$0 = $3 + 16 | 0;
 }
 
 function alloc__collections__btree__remove___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal__2calloc__collections__btree__node__marker__KV____remove_kv_tracking__hfecb0546c62fca7a($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, $5 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $5 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  label$1 : {
   label$2 : {
    $1 = HEAP32[$1 >> 2] | 0;
    if ($1) {
     break label$2
    }
    HEAP32[($3 + 8 | 0) >> 2] = $4;
    HEAP32[($3 + 4 | 0) >> 2] = $5;
    HEAP32[$3 >> 2] = 0;
    alloc__collections__btree__remove___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__KV____remove_leaf_kv__hcb9d23746722cda3($0 | 0, $3 | 0, $2 | 0);
    break label$1;
   }
   HEAP32[($3 + 8 | 0) >> 2] = $4;
   HEAP32[($3 + 4 | 0) >> 2] = $5;
   HEAP32[$3 >> 2] = $1;
   alloc__collections__btree__remove___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__KV____remove_internal_kv__hb22ff264cc4c624d($0 | 0, $3 | 0, $2 | 0);
  }
  global$0 = $3 + 16 | 0;
 }
 
 function int_as_i32_or_fail($0) {
  $0 = $0 | 0;
  var i64toi32_i32$0 = 0, $1 = 0, i64toi32_i32$4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $9 = 0, $2 = 0, $2$hi = 0, i64toi32_i32$2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h8f4f32b29a620a40($1 + 8 | 0 | 0, $0 | 0);
    $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    i64toi32_i32$0 = cardano_serialization_lib__utils__Int__as_i32_or_fail__hd4590d09e3c5f338(HEAP32[($1 + 8 | 0) >> 2] | 0 | 0) | 0;
    i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
    $2 = i64toi32_i32$0;
    $2$hi = i64toi32_i32$1;
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    i64toi32_i32$3 = 32;
    i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$0 = 0;
     $9 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
    } else {
     i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
     $9 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
    }
    $0 = $9;
    i64toi32_i32$0 = $2$hi;
    if ($2) {
     break label$1
    }
    global$0 = $1 + 16 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472($0 | 0);
  abort();
 }
 
 function core__panicking__assert_failed__h96d8431cc974b591($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $24 = 0, $27 = 0;
  $5 = global$0 - 32 | 0;
  global$0 = $5;
  HEAP32[($5 + 4 | 0) >> 2] = $2;
  HEAP32[$5 >> 2] = $1;
  i64toi32_i32$2 = $3 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($5 + 8 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $3 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $24 = i64toi32_i32$1;
  i64toi32_i32$1 = ($5 + 8 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $24;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $27 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[($5 + 8 | 0) >> 2] = $27;
  HEAP32[($5 + 12 | 0) >> 2] = i64toi32_i32$1;
  core__panicking__assert_failed_inner__h88a2a8b36b85926c($0 | 0, $5 | 0, 1061184 | 0, $5 + 4 | 0 | 0, 1061184 | 0, $5 + 8 | 0 | 0, $4 | 0);
  abort();
 }
 
 function $cardano_serialization_lib__chain_crypto__algorithms__ed25519_derive__Ed25519Bip32_20as_20cardano_serialization_lib__chain_crypto__key__AsymmetricKey___generate__h3f0728b57fe14151($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 208 | 0;
  global$0 = $3;
  HEAP32[($3 + 12 | 0) >> 2] = $2;
  HEAP32[($3 + 8 | 0) >> 2] = $1;
  memset($3 + 16 | 0 | 0, 0 | 0, 96 | 0) | 0;
  $rand_os__OsRng_20as_20rand_core__RngCore___fill_bytes__h6a20d3c9ee8171ca($3 + 8 | 0 | 0, $3 + 16 | 0 | 0, 96 | 0);
  memcpy($3 + 112 | 0 | 0, $3 + 16 | 0 | 0, 96 | 0) | 0;
  ed25519_bip32__key__XPrv__normalize_bytes_force3rd__hc83616bc3d9dd3b6($0 | 0, $3 + 112 | 0 | 0);
  core__ptr__drop_in_place_rand_os__OsRng___hfc4c0aad05eeb2e1($3 + 8 | 0 | 0);
  global$0 = $3 + 208 | 0;
 }
 
 function transactionbuilder_full_size($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $3 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h37dfbd2f31d951c1($1 + 8 | 0 | 0, $0 | 0);
    $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    cardano_serialization_lib__tx_builder__TransactionBuilder__full_size__h547e962b6182d21b($1 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0);
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $3 = HEAP32[$1 >> 2] | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    if ($3) {
     break label$1
    }
    global$0 = $1 + 16 | 0;
    return $2 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen__throw_val__hcf1b5c929d6fa472($2 | 0);
  abort();
 }
 
 function $core__iter__adapters__cloned__Cloned_I__20as_20core__iter__traits__iterator__Iterator___next__h491a5ec4cfc71a30($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0, $5 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h1af0b182f7766c68($2 + 8 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    if ($3) {
     break label$2
    }
    $4 = 0;
    break label$1;
   }
   $4 = 1;
   $5 = HEAP32[((HEAP32[(HEAP32[($1 + 32 | 0) >> 2] | 0) >> 2] | 0) + 8 | 0) >> 2] | 0;
   $1 = HEAP32[$3 >> 2] | 0;
   if ($5 >>> 0 > $1 >>> 0) {
    break label$1
   }
   core__panicking__panic_bounds_check__h808b524af17640b1($1 | 0, $5 | 0, 1065056 | 0);
   abort();
  }
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[$0 >> 2] = $4;
  global$0 = $2 + 16 | 0;
 }
 
 function $core__iter__adapters__cloned__Cloned_I__20as_20core__iter__traits__iterator__Iterator___next__h63ed0f17c69cc296($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0, $5 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__h1af0b182f7766c68($2 + 8 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    if ($3) {
     break label$2
    }
    $4 = 0;
    break label$1;
   }
   $4 = 1;
   $5 = HEAP32[((HEAP32[(HEAP32[($1 + 32 | 0) >> 2] | 0) >> 2] | 0) + 8 | 0) >> 2] | 0;
   $1 = HEAP32[$3 >> 2] | 0;
   if ($5 >>> 0 > $1 >>> 0) {
    break label$1
   }
   core__panicking__panic_bounds_check__h808b524af17640b1($1 | 0, $5 | 0, 1065056 | 0);
   abort();
  }
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[$0 >> 2] = $4;
  global$0 = $2 + 16 | 0;
 }
 
 function cbor_event__se__Serializer_W___write_bytes__h1ecbe6b3316bc5ff($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$0 = 0;
  $4 = global$0 - 48 | 0;
  global$0 = $4;
  i64toi32_i32$0 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($4 | 0, $1 | 0, 2 | 0, $3 | 0, i64toi32_i32$0 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[$4 >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
    alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($1 | 0, $2 | 0, $3 | 0);
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    $1 = 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $4 + 8 | 0 | 0, 40 | 0) | 0;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $4 + 48 | 0;
 }
 
 function core__panicking__assert_failed__h797398ab1bf2772c($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $24 = 0, $27 = 0;
  $5 = global$0 - 32 | 0;
  global$0 = $5;
  HEAP32[($5 + 4 | 0) >> 2] = $2;
  HEAP32[$5 >> 2] = $1;
  i64toi32_i32$2 = $3 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($5 + 8 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $3 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $24 = i64toi32_i32$1;
  i64toi32_i32$1 = ($5 + 8 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $24;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $27 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[($5 + 8 | 0) >> 2] = $27;
  HEAP32[($5 + 12 | 0) >> 2] = i64toi32_i32$1;
  core__panicking__assert_failed_inner__h88a2a8b36b85926c($0 | 0, $5 | 0, 1076500 | 0, $5 + 4 | 0 | 0, 1076500 | 0, $5 + 8 | 0 | 0, $4 | 0);
  abort();
 }
 
 function core__panicking__assert_failed__h4abb29051d76b03f($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $24 = 0, $27 = 0;
  $5 = global$0 - 32 | 0;
  global$0 = $5;
  HEAP32[($5 + 4 | 0) >> 2] = $2;
  HEAP32[$5 >> 2] = $1;
  i64toi32_i32$2 = $3 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($5 + 8 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $3 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $24 = i64toi32_i32$1;
  i64toi32_i32$1 = ($5 + 8 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $24;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $27 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[($5 + 8 | 0) >> 2] = $27;
  HEAP32[($5 + 12 | 0) >> 2] = i64toi32_i32$1;
  core__panicking__assert_failed_inner__h88a2a8b36b85926c($0 | 0, $5 | 0, 1077808 | 0, $5 + 4 | 0 | 0, 1077808 | 0, $5 + 8 | 0 | 0, $4 | 0);
  abort();
 }
 
 function core__panicking__assert_failed__hfac4c8f4dca80274($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $24 = 0, $27 = 0;
  $5 = global$0 - 32 | 0;
  global$0 = $5;
  HEAP32[($5 + 4 | 0) >> 2] = $2;
  HEAP32[$5 >> 2] = $1;
  i64toi32_i32$2 = $3 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($5 + 8 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $3 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $24 = i64toi32_i32$1;
  i64toi32_i32$1 = ($5 + 8 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $24;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $27 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[($5 + 8 | 0) >> 2] = $27;
  HEAP32[($5 + 12 | 0) >> 2] = i64toi32_i32$1;
  core__panicking__assert_failed_inner__h88a2a8b36b85926c($0 | 0, $5 | 0, 1077824 | 0, $5 + 4 | 0 | 0, 1077824 | 0, $5 + 8 | 0 | 0, $4 | 0);
  abort();
 }
 
 function core__panicking__assert_failed__h7abe5b371cd10d8a($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  var $5 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $18 = 0, $24 = 0, $27 = 0;
  $5 = global$0 - 32 | 0;
  global$0 = $5;
  HEAP32[($5 + 4 | 0) >> 2] = $2;
  HEAP32[$5 >> 2] = $1;
  i64toi32_i32$2 = $3 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = ($5 + 8 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $3 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $24 = i64toi32_i32$1;
  i64toi32_i32$1 = ($5 + 8 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $24;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $3;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $27 = i64toi32_i32$0;
  i64toi32_i32$0 = $5;
  HEAP32[($5 + 8 | 0) >> 2] = $27;
  HEAP32[($5 + 12 | 0) >> 2] = i64toi32_i32$1;
  core__panicking__assert_failed_inner__h88a2a8b36b85926c($0 | 0, $5 | 0, 1103136 | 0, $5 + 4 | 0 | 0, 1103136 | 0, $5 + 8 | 0 | 0, $4 | 0);
  abort();
 }
 
 function core__panicking__assert_failed__h1e2384889c2d638e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $14 = 0, $20 = 0, $23 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  HEAP32[($2 + 4 | 0) >> 2] = 1142828;
  HEAP32[$2 >> 2] = $0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 8 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $14;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $20 = i64toi32_i32$1;
  i64toi32_i32$1 = ($2 + 8 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $20;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $23 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $23;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  core__panicking__assert_failed_inner__h88a2a8b36b85926c(0 | 0, $2 | 0, 1142596 | 0, $2 + 4 | 0 | 0, 1142596 | 0, $2 + 8 | 0 | 0, 1145424 | 0);
  abort();
 }
 
 function core__panicking__assert_failed__h26fc3570a5d27733($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $15 = 0, $21 = 0, $24 = 0;
  $3 = global$0 - 32 | 0;
  global$0 = $3;
  HEAP32[($3 + 4 | 0) >> 2] = 1144100;
  HEAP32[$3 >> 2] = $0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = ($3 + 8 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $15;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$1;
  i64toi32_i32$1 = ($3 + 8 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $21;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $24 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[($3 + 8 | 0) >> 2] = $24;
  HEAP32[($3 + 12 | 0) >> 2] = i64toi32_i32$1;
  core__panicking__assert_failed_inner__h88a2a8b36b85926c(0 | 0, $3 | 0, 1142612 | 0, $3 + 4 | 0 | 0, 1142612 | 0, $3 + 8 | 0 | 0, $2 | 0);
  abort();
 }
 
 function core__panicking__assert_failed__h6f270dd8420cd02c($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $16 = 0, $22 = 0, $25 = 0;
  $3 = global$0 - 32 | 0;
  global$0 = $3;
  HEAP32[($3 + 4 | 0) >> 2] = $1;
  HEAP32[$3 >> 2] = $0;
  i64toi32_i32$2 = $2 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $16 = i64toi32_i32$0;
  i64toi32_i32$0 = ($3 + 8 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $16;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $22 = i64toi32_i32$1;
  i64toi32_i32$1 = ($3 + 8 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $22;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $2;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $25 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[($3 + 8 | 0) >> 2] = $25;
  HEAP32[($3 + 12 | 0) >> 2] = i64toi32_i32$1;
  core__panicking__assert_failed_inner__h88a2a8b36b85926c(0 | 0, $3 | 0, 1149596 | 0, $3 + 4 | 0 | 0, 1149596 | 0, $3 + 8 | 0 | 0, 1146320 | 0);
  abort();
 }
 
 function $cardano_serialization_lib__AssetName_20as_20core__cmp__Ord___cmp__h38864a982a475878($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   $3 = $3 >>> 0 < $4 >>> 0 ? -1 : ($3 | 0) != ($4 | 0);
   if ($3) {
    break label$1
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $0 | 0);
   $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 | 0, $1 | 0);
   $3 = core__slice__cmp___impl_20core__cmp__Ord_20for_20_5bT_5d___cmp__h1f2092e0ba2f27ea($3 | 0, $0 | 0, HEAP32[$2 >> 2] | 0 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0) | 0;
  }
  global$0 = $2 + 16 | 0;
  return $3 | 0;
 }
 
 function cardano_serialization_lib__Certificates__add__h9c6c3e5f5f20a2bd($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 208 | 0;
  global$0 = $2;
  $cardano_serialization_lib__Certificate_20as_20core__clone__Clone___clone__h097b7190e8dc0410($2 + 8 | 0 | 0, $1 | 0);
  label$1 : {
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (($1 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
    break label$1
   }
   alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h55956fe02300486e($0 | 0, $1 | 0, 1 | 0);
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  }
  memcpy((HEAP32[$0 >> 2] | 0) + Math_imul($1, 200) | 0 | 0, $2 + 8 | 0 | 0, 200 | 0) | 0;
  HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
  global$0 = $2 + 208 | 0;
 }
 
 function transactionbody_network_id($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if (!$0) {
    break label$1
   }
   wasm_bindgen____rt__WasmRefCell_T___borrow__h356c30395cf13adb($1 + 8 | 0 | 0, $0 | 0);
   $0 = HEAPU8[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 270 | 0) >> 0] | 0;
   $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
   $2 = 0;
   label$2 : {
    if (($0 | 0) == (2 | 0)) {
     break label$2
    }
    $2 = $cardano_serialization_lib__NetworkId_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hf6f78a05c9fd49e7(($0 | 0) != (0 | 0) | 0) | 0;
   }
   global$0 = $1 + 16 | 0;
   return $2 | 0;
  }
  wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
  abort();
 }
 
 function protocolparamupdate_max_block_body_size($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $4 = 0, $3 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hd84cc8f720a3dada($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  $3 = HEAP32[($1 + 284 | 0) >> 2] | 0;
  $1 = HEAP32[($1 + 280 | 0) >> 2] | 0;
  $4 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($4 | 0, (HEAP32[$4 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $1 ? $3 : 0;
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 16 | 0;
 }
 
 function protocolparamupdate_max_tx_size($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $4 = 0, $3 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hd84cc8f720a3dada($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  $3 = HEAP32[($1 + 292 | 0) >> 2] | 0;
  $1 = HEAP32[($1 + 288 | 0) >> 2] | 0;
  $4 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($4 | 0, (HEAP32[$4 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $1 ? $3 : 0;
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 16 | 0;
 }
 
 function protocolparamupdate_max_block_header_size($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $4 = 0, $3 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hd84cc8f720a3dada($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  $3 = HEAP32[($1 + 300 | 0) >> 2] | 0;
  $1 = HEAP32[($1 + 296 | 0) >> 2] | 0;
  $4 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($4 | 0, (HEAP32[$4 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $1 ? $3 : 0;
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 16 | 0;
 }
 
 function protocolparamupdate_max_epoch($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $4 = 0, $3 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hd84cc8f720a3dada($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  $3 = HEAP32[($1 + 308 | 0) >> 2] | 0;
  $1 = HEAP32[($1 + 304 | 0) >> 2] | 0;
  $4 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($4 | 0, (HEAP32[$4 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $1 ? $3 : 0;
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 16 | 0;
 }
 
 function protocolparamupdate_n_opt($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $4 = 0, $3 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hd84cc8f720a3dada($2 + 8 | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  $3 = HEAP32[($1 + 316 | 0) >> 2] | 0;
  $1 = HEAP32[($1 + 312 | 0) >> 2] | 0;
  $4 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($4 | 0, (HEAP32[$4 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $1 ? $3 : 0;
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 16 | 0;
 }
 
 function $core__iter__adapters__ResultShunt_I_2cE__20as_20core__iter__traits__iterator__Iterator___size_hint__h90f4fd0095433d70($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = 0;
  label$1 : {
   label$2 : {
    if ((HEAP32[(HEAP32[($1 + 16 | 0) >> 2] | 0) >> 2] | 0 | 0) != (1114114 | 0)) {
     break label$2
    }
    $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$3) {
     break label$2
    }
    $1 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    if (!$1) {
     break label$1
    }
    $2 = ($3 >>> 0) / ($1 >>> 0) | 0;
    $2 = $2 + (($3 - Math_imul($2, $1) | 0 | 0) != (0 | 0)) | 0;
   }
   HEAP32[$0 >> 2] = 0;
   HEAP32[($0 + 4 | 0) >> 2] = 1;
   HEAP32[($0 + 8 | 0) >> 2] = $2;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1056272 | 0, 25 | 0, 1056244 | 0);
  abort();
 }
 
 function $core__iter__adapters__ResultShunt_I_2cE__20as_20core__iter__traits__iterator__Iterator___size_hint__hb25e984a0df95a21($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = 0;
  label$1 : {
   label$2 : {
    if ((HEAP32[(HEAP32[($1 + 16 | 0) >> 2] | 0) >> 2] | 0 | 0) != (1114114 | 0)) {
     break label$2
    }
    $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$3) {
     break label$2
    }
    $1 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    if (!$1) {
     break label$1
    }
    $2 = ($3 >>> 0) / ($1 >>> 0) | 0;
    $2 = $2 + (($3 - Math_imul($2, $1) | 0 | 0) != (0 | 0)) | 0;
   }
   HEAP32[$0 >> 2] = 0;
   HEAP32[($0 + 4 | 0) >> 2] = 1;
   HEAP32[($0 + 8 | 0) >> 2] = $2;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1056272 | 0, 25 | 0, 1056244 | 0);
  abort();
 }
 
 function alloc__vec__Vec_T_2cA___remove__hf0ee37bb0b07dbd1($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, $4 = 0, i64toi32_i32$4 = 0, $3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $13 = 0, $5 = 0, $5$hi = 0, $30 = 0, i64toi32_i32$2 = 0;
  label$1 : {
   $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   if ($3 >>> 0 <= $2 >>> 0) {
    break label$1
   }
   $4 = (HEAP32[$1 >> 2] | 0) + ($2 << 3 | 0) | 0;
   i64toi32_i32$0 = HEAP32[$4 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($4 + 4 | 0) >> 2] | 0;
   $5 = i64toi32_i32$0;
   $5$hi = i64toi32_i32$1;
   memmove($4 | 0, $4 + 8 | 0 | 0, ($3 + ($2 ^ -1 | 0) | 0) << 3 | 0 | 0) | 0;
   HEAP32[($1 + 8 | 0) >> 2] = $3 + -1 | 0;
   $30 = $0;
   i64toi32_i32$2 = i64toi32_i32$0;
   i64toi32_i32$0 = 0;
   i64toi32_i32$3 = 32;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$0 = 0;
    $13 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   } else {
    i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
    $13 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
   }
   HEAP32[($30 + 4 | 0) >> 2] = $13;
   i64toi32_i32$0 = $5$hi;
   HEAP32[$0 >> 2] = $5;
   return;
  }
  alloc__vec__Vec_T_2cA___remove__assert_failed__ha36a32a2e316829e($2 | 0, $3 | 0);
  abort();
 }
 
 function __wbg_constrplutusdata_free($0) {
  $0 = $0 | 0;
  var $1 = 0, $3 = 0, $2 = 0;
  $1 = global$0 - 32 | 0;
  global$0 = $1;
  $cardano_serialization_lib__plutus__ConstrPlutusData_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__haa86bff1ee3e442b($1 + 8 | 0 | 0, $0 | 0);
  $2 = $1 + 16 | 0;
  label$1 : {
   $3 = HEAP32[($1 + 24 | 0) >> 2] | 0;
   if (!$3) {
    break label$1
   }
   $0 = HEAP32[($1 + 16 | 0) >> 2] | 0;
   $3 = Math_imul($3, 48);
   label$2 : while (1) {
    core__ptr__drop_in_place_cardano_serialization_lib__plutus__PlutusData___hfab843e66e0f9428_2($0 | 0);
    $0 = $0 + 48 | 0;
    $3 = $3 + -48 | 0;
    if ($3) {
     continue label$2
    }
    break label$2;
   };
  }
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h36e817e704f6f25e($2 | 0);
  global$0 = $1 + 32 | 0;
 }
 
 function languages_add($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h3dcba3638ab0c9bc($2 + 8 | 0 | 0, $0 | 0);
    $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    $cardano_serialization_lib__plutus__Language_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hb597e561887e512b($1 | 0);
    $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
    if (($1 | 0) == (-1 | 0)) {
     break label$1
    }
    HEAP32[($0 + 8 | 0) >> 2] = $1 + 1 | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
    global$0 = $2 + 16 | 0;
    return;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function cbor_event__se__Serializer_W___write_bytes__h330049db39307944($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $1 | 0, 2 | 0, 32 | 0, 0 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[($3 + 4 | 0) >> 2] | 0;
    alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($1 | 0, $2 | 0, 32 | 0);
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    $1 = 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $3 + 48 | 0;
 }
 
 function cbor_event__se__Serializer_W___write_bytes__h54e6fef2108c8b37($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $1 | 0, 2 | 0, 4 | 0, 0 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[($3 + 4 | 0) >> 2] | 0;
    alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($1 | 0, $2 | 0, 4 | 0);
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    $1 = 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $3 + 48 | 0;
 }
 
 function cbor_event__se__Serializer_W___write_bytes__hd39fb27319ed5f2d($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $1 | 0, 2 | 0, 16 | 0, 0 | 0);
  $1 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    $1 = HEAP32[($3 + 4 | 0) >> 2] | 0;
    alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($1 | 0, $2 | 0, 16 | 0);
    HEAP32[($0 + 4 | 0) >> 2] = $1;
    $1 = 0;
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
  }
  HEAP32[$0 >> 2] = $1;
  global$0 = $3 + 48 | 0;
 }
 
 function $_mut_20W_20as_20core__fmt__Write___write_fmt__hcec814b0071f5b88($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $14 = 0, $20 = 0, $23 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  HEAP32[($2 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 8 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $14;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $20 = i64toi32_i32$1;
  i64toi32_i32$1 = ($2 + 8 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $20;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $23 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $23;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  $1 = core__fmt__write__h9b9aa23e7d35702c($2 + 4 | 0 | 0, 1087268 | 0, $2 + 8 | 0 | 0) | 0;
  global$0 = $2 + 32 | 0;
  return $1 | 0;
 }
 
 function cryptoxide__hashing__blake2b__Context_____finalize_reset_at__hf68b8d8007a0dcdc($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $8 = 0, $9 = 0, $10 = 0, $13 = 0;
  label$1 : {
   if (($2 | 0) != (16 | 0)) {
    break label$1
   }
   cryptoxide__hashing__blake2b__Context_____internal_final__h681e1bb954624a60($0 | 0);
   i64toi32_i32$2 = $0 + 108 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $10 = i64toi32_i32$0;
   i64toi32_i32$0 = $1 + 8 | 0;
   $8 = $10;
   HEAP8[i64toi32_i32$0 >> 0] = $8;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $8 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $8 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $8 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = $0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 100 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 101 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 102 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 103 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 104 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 105 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 106 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 107 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $13 = i64toi32_i32$1;
   i64toi32_i32$1 = $1;
   $9 = $13;
   HEAP8[i64toi32_i32$1 >> 0] = $9;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $9 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $9 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $9 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   $0 = memcpy(i64toi32_i32$2 | 0, 1137368 | 0, 64 | 0) | 0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[(i64toi32_i32$1 + 64 | 0) >> 2] = 0;
   HEAP32[(i64toi32_i32$1 + 68 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$0 = 1779033703;
   HEAP32[i64toi32_i32$1 >> 2] = -222443240;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$1 = i64toi32_i32$1 + 72 | 0;
   i64toi32_i32$0 = 0;
   HEAP32[i64toi32_i32$1 >> 2] = 0;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   memset($0 + 96 | 0 | 0, 0 | 0, 132 | 0) | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1136192 | 0, 47 | 0, 1136240 | 0);
  abort();
 }
 
 function $_mut_20W_20as_20core__fmt__Write___write_fmt__h284de65b17e90df8($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $14 = 0, $20 = 0, $23 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  HEAP32[($2 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 8 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $14;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $20 = i64toi32_i32$1;
  i64toi32_i32$1 = ($2 + 8 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $20;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $23 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $23;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  $1 = core__fmt__write__h9b9aa23e7d35702c($2 + 4 | 0 | 0, 1142196 | 0, $2 + 8 | 0 | 0) | 0;
  global$0 = $2 + 32 | 0;
  return $1 | 0;
 }
 
 function $_mut_20W_20as_20core__fmt__Write___write_fmt__ha6d75b03e87c4ef6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $14 = 0, $20 = 0, $23 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  HEAP32[($2 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 8 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $14;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $20 = i64toi32_i32$1;
  i64toi32_i32$1 = ($2 + 8 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $20;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $23 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $23;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  $1 = core__fmt__write__h9b9aa23e7d35702c($2 + 4 | 0 | 0, 1142220 | 0, $2 + 8 | 0 | 0) | 0;
  global$0 = $2 + 32 | 0;
  return $1 | 0;
 }
 
 function $_mut_20W_20as_20core__fmt__Write___write_fmt__hf48563f50d5bcc95($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $14 = 0, $20 = 0, $23 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  HEAP32[($2 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 8 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $14;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $20 = i64toi32_i32$1;
  i64toi32_i32$1 = ($2 + 8 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $20;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $23 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $23;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  $1 = core__fmt__write__h9b9aa23e7d35702c($2 + 4 | 0 | 0, 1142172 | 0, $2 + 8 | 0 | 0) | 0;
  global$0 = $2 + 32 | 0;
  return $1 | 0;
 }
 
 function $_mut_20W_20as_20core__fmt__Write___write_fmt__hbe100d4644fc093f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $14 = 0, $20 = 0, $23 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  HEAP32[($2 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 8 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $14;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $20 = i64toi32_i32$1;
  i64toi32_i32$1 = ($2 + 8 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $20;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $23 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $23;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  $1 = core__fmt__write__h9b9aa23e7d35702c($2 + 4 | 0 | 0, 1145644 | 0, $2 + 8 | 0 | 0) | 0;
  global$0 = $2 + 32 | 0;
  return $1 | 0;
 }
 
 function $_mut_20W_20as_20core__fmt__Write___write_fmt__hc3571e849f5ab2de($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $14 = 0, $20 = 0, $23 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  HEAP32[($2 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 8 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $14;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $20 = i64toi32_i32$1;
  i64toi32_i32$1 = ($2 + 8 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $20;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $23 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $23;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  $1 = core__fmt__write__h9b9aa23e7d35702c($2 + 4 | 0 | 0, 1150428 | 0, $2 + 8 | 0 | 0) | 0;
  global$0 = $2 + 32 | 0;
  return $1 | 0;
 }
 
 function nativescript_new_timelock_start($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $22 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h10da0fea03f0ac1d($1 + 8 | 0 | 0, $0 | 0);
  i64toi32_i32$2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  $22 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 24 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $22;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP8[($1 + 16 | 0) >> 0] = 4;
  $0 = $cardano_serialization_lib__NativeScript_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h345d8ecbe77ecc63($1 + 16 | 0 | 0) | 0;
  global$0 = $1 + 48 | 0;
  return $0 | 0;
 }
 
 function nativescript_new_timelock_expiry($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $22 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hd0c16785fb9ea7bd($1 + 8 | 0 | 0, $0 | 0);
  i64toi32_i32$2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  $22 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 24 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $22;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP8[($1 + 16 | 0) >> 0] = 5;
  $0 = $cardano_serialization_lib__NativeScript_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h345d8ecbe77ecc63($1 + 16 | 0 | 0) | 0;
  global$0 = $1 + 48 | 0;
  return $0 | 0;
 }
 
 function $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__hd17c55afb95953fd($0) {
  $0 = $0 | 0;
  var $2 = 0, $3 = 0, $1 = 0, $4 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   $2 = HEAP32[($0 + 32 | 0) >> 2] | 0;
   if (!$2) {
    break label$1
   }
   label$2 : {
    $3 = HEAP32[($2 + 96 | 0) >> 2] | 0;
    if (($3 | 0) == ($2 | 0)) {
     break label$2
    }
    label$3 : while (1) {
     $4 = HEAP32[($3 + 96 | 0) >> 2] | 0;
     HEAP32[($1 + 12 | 0) >> 2] = $3;
     core__ptr__drop_in_place_alloc__boxed__Box_linked_hash_map__Node_cardano_serialization_lib__metadata__TransactionMetadatum_2ccardano_serialization_lib__metadata__TransactionMetadatum_____hb84969c3100fb85b($1 + 12 | 0 | 0);
     $3 = $4;
     if (($3 | 0) != ($2 | 0)) {
      continue label$3
     }
     break label$3;
    };
   }
   __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($2 | 0) | 0 | 0, 104 | 0, 8 | 0);
  }
  linked_hash_map__LinkedHashMap_K_2cV_2cS___clear_free_list__hc9584b5de481db28($0 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function cardano_serialization_lib__crypto__PrivateKey__sign__habe0df84ae280136($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $5 = 0;
  $4 = global$0 - 32 | 0;
  global$0 = $4;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($4 + 8 | 0 | 0, $3 | 0, 0 | 0);
  HEAP32[($4 + 20 | 0) >> 2] = HEAP32[($4 + 12 | 0) >> 2] | 0;
  $5 = HEAP32[($4 + 8 | 0) >> 2] | 0;
  HEAP32[($4 + 16 | 0) >> 2] = $5;
  memcpy($5 | 0, $2 | 0, $3 | 0) | 0;
  HEAP32[($4 + 24 | 0) >> 2] = $3;
  cardano_serialization_lib__impl_mockchain__key__EitherEd25519SecretKey__sign__h2fa85cbd16bdcfda($0 | 0, $1 | 0, $4 + 16 | 0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($4 + 16 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($4 + 16 | 0 | 0);
  global$0 = $4 + 32 | 0;
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___insert__h358bbc5e89c1a147($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $22 = 0, $25 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  alloc__collections__btree__map__BTreeMap_K_2cV___entry__ha9f4bb92e7621409($2 | 0, $0 | 0, $1 | 0);
  label$1 : {
   $0 = HEAP32[$2 >> 2] | 0;
   if (($0 | 0) == (1 | 0)) {
    break label$1
   }
   HEAP32[($2 + 40 | 0) >> 2] = HEAP32[($2 + 20 | 0) >> 2] | 0;
   i64toi32_i32$2 = $2 + 12 | 0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $22 = i64toi32_i32$0;
   i64toi32_i32$0 = $2 + 32 | 0;
   HEAP32[i64toi32_i32$0 >> 2] = $22;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   $25 = i64toi32_i32$1;
   i64toi32_i32$1 = $2;
   HEAP32[($2 + 24 | 0) >> 2] = $25;
   HEAP32[($2 + 28 | 0) >> 2] = i64toi32_i32$0;
   alloc__collections__btree__map__entry__VacantEntry_K_2cV___insert__ha71ca05338ace28c($2 + 24 | 0 | 0) | 0;
  }
  global$0 = $2 + 48 | 0;
  return $0 | 0;
 }
 
 function alloc__vec__Vec_T_2cA___retain__h9a0026799b18fd04($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, $5 = 0, $6 = 0;
  $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  label$1 : {
   if (!$3) {
    break label$1
   }
   $4 = HEAP32[$0 >> 2] | 0;
   $5 = HEAP32[((HEAP32[$2 >> 2] | 0) + 8 | 0) >> 2] | 0;
   $2 = $3;
   label$2 : {
    label$3 : while (1) {
     $6 = HEAP32[$4 >> 2] | 0;
     if ($5 >>> 0 <= $6 >>> 0) {
      break label$2
     }
     $4 = $4 + 4 | 0;
     $2 = $2 + -1 | 0;
     if (!$2) {
      break label$1
     }
     continue label$3;
    };
   }
   core__panicking__panic_bounds_check__h808b524af17640b1($6 | 0, $5 | 0, 1068076 | 0);
   abort();
  }
  HEAP32[($0 + 8 | 0) >> 2] = $3;
 }
 
 function alloc__vec__Vec_T_2cA___retain__hf8f37eb0a6dc1345($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, $5 = 0, $6 = 0;
  $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  label$1 : {
   if (!$3) {
    break label$1
   }
   $4 = HEAP32[$0 >> 2] | 0;
   $5 = HEAP32[((HEAP32[$2 >> 2] | 0) + 8 | 0) >> 2] | 0;
   $2 = $3;
   label$2 : {
    label$3 : while (1) {
     $6 = HEAP32[$4 >> 2] | 0;
     if ($5 >>> 0 <= $6 >>> 0) {
      break label$2
     }
     $4 = $4 + 4 | 0;
     $2 = $2 + -1 | 0;
     if (!$2) {
      break label$1
     }
     continue label$3;
    };
   }
   core__panicking__panic_bounds_check__h808b524af17640b1($6 | 0, $5 | 0, 1068076 | 0);
   abort();
  }
  HEAP32[($0 + 8 | 0) >> 2] = $3;
 }
 
 function alloc__vec__into_iter__IntoIter_T_2cA___forget_allocation_drop_remaining__hb86bfc3064fd3d0f($0) {
  $0 = $0 | 0;
  var $1 = 0, $4 = 0, $3 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  $2 = HEAP32[($0 + 12 | 0) >> 2] | 0;
  $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  $4 = HEAP32[(0 + 1069056 | 0) >> 2] | 0;
  HEAP32[$0 >> 2] = $4;
  HEAP32[($1 + 12 | 0) >> 2] = 0;
  HEAP32[($1 + 8 | 0) >> 2] = $4;
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h55384607e9cf45ad($1 + 8 | 0 | 0);
  HEAP32[($0 + 12 | 0) >> 2] = $4;
  HEAP32[($0 + 8 | 0) >> 2] = $4;
  core__ptr__drop_in_place__5bserde_json__value__Value_5d___h6abbb734efb35ee7($3 | 0, ($2 - $3 | 0 | 0) / (24 | 0) | 0 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function languages_get($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    wasm_bindgen____rt__WasmRefCell_T___borrow__h0848e1414118541a($2 + 8 | 0 | 0, $0 | 0);
    $0 = HEAP32[((HEAP32[($2 + 8 | 0) >> 2] | 0) + 8 | 0) >> 2] | 0;
    if ($0 >>> 0 <= $1 >>> 0) {
     break label$1
    }
    $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
    core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
    $0 = $cardano_serialization_lib__plutus__Language_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h686a48dad777e160() | 0;
    global$0 = $2 + 16 | 0;
    return $0 | 0;
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  core__panicking__panic_bounds_check__h808b524af17640b1($1 | 0, $0 | 0, 1071652 | 0);
  abort();
 }
 
 function cardano_serialization_lib__plutus__PlutusList__add__ha106511326853de8($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  $cardano_serialization_lib__plutus__PlutusData_20as_20core__clone__Clone___clone__h63d1a98cc18f4609_2($2 | 0, $1 | 0);
  label$1 : {
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (($1 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
    break label$1
   }
   alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h1a6fd20a90c96048($0 | 0, $1 | 0, 1 | 0);
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  }
  memcpy((HEAP32[$0 >> 2] | 0) + Math_imul($1, 48) | 0 | 0, $2 | 0, 48 | 0) | 0;
  HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
  HEAP8[($0 + 12 | 0) >> 0] = 2;
  global$0 = $2 + 48 | 0;
 }
 
 function core__fmt__Write__write_fmt__h3fa86b0857dbcda0($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $13 = 0, $19 = 0, $22 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  HEAP32[($2 + 4 | 0) >> 2] = $0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $13 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 8 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $13;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$1;
  i64toi32_i32$1 = ($2 + 8 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $19;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $22 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $22;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  $1 = core__fmt__write__h9b9aa23e7d35702c($2 + 4 | 0 | 0, 1087268 | 0, $2 + 8 | 0 | 0) | 0;
  global$0 = $2 + 32 | 0;
  return $1 | 0;
 }
 
 function core__fmt__Write__write_fmt__h0cbab477b9b6e09a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $13 = 0, $19 = 0, $22 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  HEAP32[($2 + 4 | 0) >> 2] = $0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $13 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 8 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $13;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$1;
  i64toi32_i32$1 = ($2 + 8 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $19;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $22 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $22;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  $1 = core__fmt__write__h9b9aa23e7d35702c($2 + 4 | 0 | 0, 1142172 | 0, $2 + 8 | 0 | 0) | 0;
  global$0 = $2 + 32 | 0;
  return $1 | 0;
 }
 
 function core__fmt__Write__write_fmt__h54eed6b3773c9bff($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $13 = 0, $19 = 0, $22 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  HEAP32[($2 + 4 | 0) >> 2] = $0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $13 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 8 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $13;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$1;
  i64toi32_i32$1 = ($2 + 8 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $19;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $22 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $22;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  $1 = core__fmt__write__h9b9aa23e7d35702c($2 + 4 | 0 | 0, 1142196 | 0, $2 + 8 | 0 | 0) | 0;
  global$0 = $2 + 32 | 0;
  return $1 | 0;
 }
 
 function core__fmt__Write__write_fmt__hc16feab8d1848af1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $13 = 0, $19 = 0, $22 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  HEAP32[($2 + 4 | 0) >> 2] = $0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $13 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 8 | 0) + 16 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $13;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $1 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$1;
  i64toi32_i32$1 = ($2 + 8 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $19;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $22 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $22;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  $1 = core__fmt__write__h9b9aa23e7d35702c($2 + 4 | 0 | 0, 1150428 | 0, $2 + 8 | 0 | 0) | 0;
  global$0 = $2 + 32 | 0;
  return $1 | 0;
 }
 
 function __lshrti3($0, $1, $1$hi, $2, $2$hi, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $1$hi = $1$hi | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  $3 = $3 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$4 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, $4$hi = 0, $18 = 0, $4 = 0, $19 = 0, $20 = 0, $21 = 0, $13$hi = 0, $14 = 0, $14$hi = 0, $20$hi = 0, $28$hi = 0;
  label$1 : {
   label$2 : {
    if ($3 & 64 | 0) {
     break label$2
    }
    if (!$3) {
     break label$1
    }
    i64toi32_i32$0 = $2$hi;
    i64toi32_i32$0 = 0;
    $13$hi = i64toi32_i32$0;
    i64toi32_i32$0 = $2$hi;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = $13$hi;
    i64toi32_i32$3 = (0 - $3 | 0) & 63 | 0;
    i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
     $18 = 0;
    } else {
     i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
     $18 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
    }
    $14 = $18;
    $14$hi = i64toi32_i32$1;
    i64toi32_i32$1 = $1$hi;
    i64toi32_i32$1 = 0;
    $4 = $3 & 63 | 0;
    $4$hi = i64toi32_i32$1;
    i64toi32_i32$1 = $1$hi;
    i64toi32_i32$0 = $1;
    i64toi32_i32$2 = $4$hi;
    i64toi32_i32$3 = $4;
    i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$2 = 0;
     $19 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
    } else {
     i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
     $19 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
    }
    $20$hi = i64toi32_i32$2;
    i64toi32_i32$2 = $14$hi;
    i64toi32_i32$1 = $14;
    i64toi32_i32$0 = $20$hi;
    i64toi32_i32$3 = $19;
    i64toi32_i32$0 = i64toi32_i32$2 | i64toi32_i32$0 | 0;
    $1 = i64toi32_i32$1 | i64toi32_i32$3 | 0;
    $1$hi = i64toi32_i32$0;
    i64toi32_i32$0 = $2$hi;
    i64toi32_i32$0 = $4$hi;
    i64toi32_i32$0 = $2$hi;
    i64toi32_i32$2 = $2;
    i64toi32_i32$1 = $4$hi;
    i64toi32_i32$3 = $4;
    i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$1 = 0;
     $20 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
    } else {
     i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
     $20 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
    }
    $2 = $20;
    $2$hi = i64toi32_i32$1;
    break label$1;
   }
   i64toi32_i32$1 = $2$hi;
   i64toi32_i32$1 = 0;
   $28$hi = i64toi32_i32$1;
   i64toi32_i32$1 = $2$hi;
   i64toi32_i32$0 = $2;
   i64toi32_i32$2 = $28$hi;
   i64toi32_i32$3 = $3 & 63 | 0;
   i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
   if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
    i64toi32_i32$2 = 0;
    $21 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   } else {
    i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
    $21 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
   }
   $1 = $21;
   $1$hi = i64toi32_i32$2;
   i64toi32_i32$2 = 0;
   $2 = 0;
   $2$hi = i64toi32_i32$2;
  }
  i64toi32_i32$2 = $1$hi;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $1;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $2$hi;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $2;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$2;
 }
 
 function $cardano_serialization_lib__Transaction_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hd805c00505bcf788($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 448 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h86c452d6d75acdae($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 16 | 0 | 0, $1 | 0, 432 | 0) | 0;
  memcpy($0 | 0, ($2 + 16 | 0) + 8 | 0 | 0, 424 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 432 | 0, 8 | 0);
  global$0 = $2 + 448 | 0;
 }
 
 function $cardano_serialization_lib__StakeDelegation_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h562eb806d5109811($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h605a8c52555cadba($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 16 | 0 | 0, $1 | 0, 64 | 0) | 0;
  memcpy($0 | 0, $2 + 16 | 0 | 4 | 0 | 0, 57 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 64 | 0, 4 | 0);
  global$0 = $2 + 80 | 0;
 }
 
 function $cardano_serialization_lib__PoolMetadata_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h21c8a276cf9d0035($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__ha65a927bae2fc7ee($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 16 | 0 | 0, $1 | 0, 48 | 0) | 0;
  memcpy($0 | 0, $2 + 16 | 0 | 4 | 0 | 0, 44 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 48 | 0, 4 | 0);
  global$0 = $2 + 64 | 0;
 }
 
 function $cardano_serialization_lib__GenesisKeyDelegation_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h999283eab0776d45($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h898a67bdbd736c3e($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 16 | 0 | 0, $1 | 0, 92 | 0) | 0;
  memcpy($0 | 0, $2 + 16 | 0 | 4 | 0 | 0, 88 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 92 | 0, 4 | 0);
  global$0 = $2 + 112 | 0;
 }
 
 function $cardano_serialization_lib__MoveInstantaneousRewardsCert_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hbde5b1f1e4006a22($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hf5b35c737998120c($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 16 | 0 | 0, $1 | 0, 64 | 0) | 0;
  memcpy($0 | 0, ($2 + 16 | 0) + 8 | 0 | 0, 56 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 64 | 0, 8 | 0);
  global$0 = $2 + 80 | 0;
 }
 
 function $cardano_serialization_lib__Certificate_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h850d5e2c1a1a2142($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 224 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hc328745336482c29($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 16 | 0 | 0, $1 | 0, 208 | 0) | 0;
  memcpy($0 | 0, ($2 + 16 | 0) + 8 | 0 | 0, 200 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 208 | 0, 8 | 0);
  global$0 = $2 + 224 | 0;
 }
 
 function $cardano_serialization_lib__MIRToStakeCredentials_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__ha70d61c6c2223e85($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hc5dfe90718757ef2($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 16 | 0 | 0, $1 | 0, 48 | 0) | 0;
  memcpy($0 | 0, ($2 + 16 | 0) + 8 | 0 | 0, 40 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 48 | 0, 8 | 0);
  global$0 = $2 + 64 | 0;
 }
 
 function $cardano_serialization_lib__MoveInstantaneousReward_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h5288a22e542b635f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h078bb85e66acd6f6($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 16 | 0 | 0, $1 | 0, 64 | 0) | 0;
  memcpy($0 | 0, ($2 + 16 | 0) + 8 | 0 | 0, 56 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 64 | 0, 8 | 0);
  global$0 = $2 + 80 | 0;
 }
 
 function cardano_serialization_lib__Relay__as_single_host_name__he974066e21c2b4b5($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $3 = 0, $18 = 0, $25 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if ((HEAPU16[$1 >> 1] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $3 = HEAP32[($1 + 16 | 0) >> 2] | 0;
    $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($2 | 0, $1 + 4 | 0 | 0);
    i64toi32_i32$2 = $2;
    i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
    $18 = i64toi32_i32$0;
    i64toi32_i32$0 = $0;
    HEAP32[i64toi32_i32$0 >> 2] = $18;
    HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
    HEAP32[($2 + 12 | 0) >> 2] = $3;
    i64toi32_i32$2 = $2 + 8 | 0;
    i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
    i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    $25 = i64toi32_i32$1;
    i64toi32_i32$1 = $0 + 8 | 0;
    HEAP32[i64toi32_i32$1 >> 2] = $25;
    HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
    break label$1;
   }
   HEAP16[($0 + 12 | 0) >> 1] = 2;
  }
  global$0 = $2 + 16 | 0;
 }
 
 function $cardano_serialization_lib__Withdrawals_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h1b951f32831f8add($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h93c478ef73ae4bb6($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 16 | 0 | 0, $1 | 0, 48 | 0) | 0;
  memcpy($0 | 0, ($2 + 16 | 0) + 8 | 0 | 0, 40 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 48 | 0, 8 | 0);
  global$0 = $2 + 64 | 0;
 }
 
 function $cardano_serialization_lib__TransactionWitnessSet_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h00e0a5bfc8cbadcd($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 96 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h1cc4e67284701531($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 16 | 0 | 0, $1 | 0, 80 | 0) | 0;
  memcpy($0 | 0, $2 + 16 | 0 | 4 | 0 | 0, 76 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 80 | 0, 4 | 0);
  global$0 = $2 + 96 | 0;
 }
 
 function $cardano_serialization_lib__ProposedProtocolParameterUpdates_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h2d93daf5bda1e920($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h5343c37ad06efd21($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 16 | 0 | 0, $1 | 0, 48 | 0) | 0;
  memcpy($0 | 0, ($2 + 16 | 0) + 8 | 0 | 0, 40 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 48 | 0, 8 | 0);
  global$0 = $2 + 64 | 0;
 }
 
 function protocolversions_get($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__ha45853a045a59ee7($2 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  cardano_serialization_lib__ProtocolVersions__get__hbee1839bc5ff0591($2 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, $1 | 0);
  $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $3 = HEAP32[$2 >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  $0 = $cardano_serialization_lib__ProtocolVersion_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h721fdbbf560ad7f4($3 | 0, $1 | 0) | 0;
  global$0 = $2 + 16 | 0;
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__ProtocolParamUpdate_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h9e574c25b3cdebb6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 432 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h0a71cd742026514d($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 16 | 0 | 0, $1 | 0, 416 | 0) | 0;
  memcpy($0 | 0, ($2 + 16 | 0) + 8 | 0 | 0, 408 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 416 | 0, 8 | 0);
  global$0 = $2 + 432 | 0;
 }
 
 function protocolparamupdate_max_value_size($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hd84cc8f720a3dada($2 + 8 | 0 | 0, $1 | 0);
  $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  $1 = HEAP32[($3 + 348 | 0) >> 2] | 0;
  $3 = HEAP32[($3 + 352 | 0) >> 2] | 0;
  $4 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($4 | 0, (HEAP32[$4 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $1 ? $3 : 0;
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 16 | 0;
 }
 
 function protocolparamupdate_collateral_percentage($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hd84cc8f720a3dada($2 + 8 | 0 | 0, $1 | 0);
  $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  $1 = HEAP32[($3 + 356 | 0) >> 2] | 0;
  $3 = HEAP32[($3 + 360 | 0) >> 2] | 0;
  $4 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($4 | 0, (HEAP32[$4 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $1 ? $3 : 0;
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 16 | 0;
 }
 
 function protocolparamupdate_max_collateral_inputs($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hd84cc8f720a3dada($2 + 8 | 0 | 0, $1 | 0);
  $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  $1 = HEAP32[($3 + 364 | 0) >> 2] | 0;
  $3 = HEAP32[($3 + 368 | 0) >> 2] | 0;
  $4 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($4 | 0, (HEAP32[$4 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $1 ? $3 : 0;
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 16 | 0;
 }
 
 function $cardano_serialization_lib__AuxiliaryDataSet_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__he211079221e925cb($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h94807ac56e362a92($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 16 | 0 | 0, $1 | 0, 48 | 0) | 0;
  memcpy($0 | 0, ($2 + 16 | 0) + 8 | 0 | 0, 40 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 48 | 0, 8 | 0);
  global$0 = $2 + 64 | 0;
 }
 
 function $cardano_serialization_lib__Block_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h78d138dac3d7160d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 432 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h0bd7a1579e3c59b4($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 16 | 0 | 0, $1 | 0, 416 | 0) | 0;
  memcpy($0 | 0, ($2 + 16 | 0) + 8 | 0 | 0, 408 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 416 | 0, 8 | 0);
  global$0 = $2 + 432 | 0;
 }
 
 function $cardano_serialization_lib__Header_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hbf99d73ed65f1411($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 352 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__he564908227ef84d7($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 16 | 0 | 0, $1 | 0, 336 | 0) | 0;
  memcpy($0 | 0, ($2 + 16 | 0) + 8 | 0 | 0, 328 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 336 | 0, 8 | 0);
  global$0 = $2 + 352 | 0;
 }
 
 function $cardano_serialization_lib__OperationalCert_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hd4431f5d7fa81d9e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 128 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__he80be601c7107d4d($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 16 | 0 | 0, $1 | 0, 108 | 0) | 0;
  memcpy($0 | 0, $2 + 16 | 0 | 4 | 0 | 0, 104 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 108 | 0, 4 | 0);
  global$0 = $2 + 128 | 0;
 }
 
 function $cardano_serialization_lib__HeaderBody_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__ha8a6c3f97f104c70($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 336 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hdb743999990312b6($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 16 | 0 | 0, $1 | 0, 320 | 0) | 0;
  memcpy($0 | 0, ($2 + 16 | 0) + 8 | 0 | 0, 312 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 320 | 0, 8 | 0);
  global$0 = $2 + 336 | 0;
 }
 
 function $cardano_serialization_lib__output_builder__TransactionOutputBuilder_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h6ef627596ed138b8($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 128 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__ha3e3459a4991b9a5($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 16 | 0 | 0, $1 | 0, 112 | 0) | 0;
  memcpy($0 | 0, ($2 + 16 | 0) + 8 | 0 | 0, 104 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 112 | 0, 8 | 0);
  global$0 = $2 + 128 | 0;
 }
 
 function $cardano_serialization_lib__utils__TransactionUnspentOutput_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h5cd26c8e164e5e75($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 192 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h809036bdef3fe4e9($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 16 | 0 | 0, $1 | 0, 176 | 0) | 0;
  memcpy($0 | 0, ($2 + 16 | 0) + 8 | 0 | 0, 168 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 176 | 0, 8 | 0);
  global$0 = $2 + 192 | 0;
 }
 
 function $_5bT_5d_20as_20core__fmt__Debug___fmt__h6163fbf76721580f($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $9 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  i64toi32_i32$0 = core__fmt__Formatter__debug_list__h7939d45dcba19956($2 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $9 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[$3 >> 2] = $9;
  HEAP32[($3 + 4 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   if (!$1) {
    break label$1
   }
   $1 = Math_imul($1, 48);
   label$2 : while (1) {
    HEAP32[($3 + 12 | 0) >> 2] = $0;
    core__fmt__builders__DebugSet__entry__he7b13b90636ac2b8($3 | 0, $3 + 12 | 0 | 0, 1061168 | 0) | 0;
    $0 = $0 + 48 | 0;
    $1 = $1 + -48 | 0;
    if ($1) {
     continue label$2
    }
    break label$2;
   };
  }
  $0 = core__fmt__builders__DebugList__finish__h372f90da800e1030($3 | 0) | 0;
  global$0 = $3 + 16 | 0;
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__metadata__MetadataMap_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hcd311523d587d60f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h1305d160e0e385a5($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 16 | 0 | 0, $1 | 0, 48 | 0) | 0;
  memcpy($0 | 0, ($2 + 16 | 0) + 8 | 0 | 0, 40 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 48 | 0, 8 | 0);
  global$0 = $2 + 64 | 0;
 }
 
 function $cardano_serialization_lib__metadata__GeneralTransactionMetadata_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hf58c486b94e2e653($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h4b93f864eaa742c0($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 16 | 0 | 0, $1 | 0, 48 | 0) | 0;
  memcpy($0 | 0, ($2 + 16 | 0) + 8 | 0 | 0, 40 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 48 | 0, 8 | 0);
  global$0 = $2 + 64 | 0;
 }
 
 function $cardano_serialization_lib__tx_builder__TransactionBuilderConfigBuilder_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h371fb401323e5a64($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h26d671c8c095c821($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 16 | 0 | 0, $1 | 0, 144 | 0) | 0;
  memcpy($0 | 0, ($2 + 16 | 0) + 8 | 0 | 0, 136 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 144 | 0, 8 | 0);
  global$0 = $2 + 160 | 0;
 }
 
 function $cardano_serialization_lib__tx_builder__TransactionBuilder_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h760cc738c646cf3e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 544 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h5566e1c7d4aafe35($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 16 | 0 | 0, $1 | 0, 528 | 0) | 0;
  memcpy($0 | 0, ($2 + 16 | 0) + 8 | 0 | 0, 520 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 528 | 0, 8 | 0);
  global$0 = $2 + 544 | 0;
 }
 
 function $cardano_serialization_lib__crypto__BootstrapWitness_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h2fc8f9db9ae71e91($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 144 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hfa9e4b95817026bf($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 16 | 0 | 0, $1 | 0, 124 | 0) | 0;
  memcpy($0 | 0, $2 + 16 | 0 | 4 | 0 | 0, 120 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 124 | 0, 4 | 0);
  global$0 = $2 + 144 | 0;
 }
 
 function alloc__vec__Vec_T_2cA___extend_desugared__h206af6674e992ec7($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__ha538daa28fd542ac($2 + 8 | 0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    if (!(HEAP32[($2 + 8 | 0) >> 2] | 0)) {
     break label$2
    }
    $3 = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
    label$3 : while (1) {
     if (!$3) {
      break label$1
     }
     HEAP32[($0 + 8 | 0) >> 2] = $3;
     $alloc__collections__btree__map__Iter_K_2cV__20as_20core__iter__traits__iterator__Iterator___next__ha538daa28fd542ac($2 | 0, $1 | 0);
     $3 = $3 + 1 | 0;
     if (HEAP32[$2 >> 2] | 0) {
      continue label$3
     }
     break label$3;
    };
   }
   global$0 = $2 + 16 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend_T_2calloc__vec__into_iter__IntoIter_T_____spec_extend__h93b6c942d0655498($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $5 = 0, $3 = 0, $4 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $4 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $5 = $3 - $4 | 0;
  alloc__vec__Vec_T_2cA___reserve__h9cf757d86af8f187($0 | 0, $5 | 0);
  memcpy((HEAP32[$0 >> 2] | 0) + (HEAP32[($0 + 8 | 0) >> 2] | 0) | 0 | 0, $4 | 0, $5 | 0) | 0;
  HEAP32[($1 + 8 | 0) >> 2] = $3;
  HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + $5 | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  HEAP32[($2 + 8 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 + 8 | 0 | 0);
  global$0 = $2 + 16 | 0;
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___get__h1cff86883863eab1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0, wasm2js_i32$2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    $3 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    if ($3) {
     break label$2
    }
    $0 = 0;
    break label$1;
   }
   alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__hac6e0923ca1aecc1($2 | 0, HEAP32[$0 >> 2] | 0 | 0, $3 | 0, $1 | 0);
   $0 = (wasm2js_i32$0 = 0, wasm2js_i32$1 = ((HEAP32[($2 + 8 | 0) >> 2] | 0) + Math_imul(HEAP32[($2 + 12 | 0) >> 2] | 0, 12) | 0) + 4 | 0, wasm2js_i32$2 = (HEAP32[$2 >> 2] | 0 | 0) == (1 | 0), wasm2js_i32$2 ? wasm2js_i32$0 : wasm2js_i32$1);
  }
  global$0 = $2 + 16 | 0;
  return $0 | 0;
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___get__h46e97faa3debbf61($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0, wasm2js_i32$2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    $3 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    if ($3) {
     break label$2
    }
    $0 = 0;
    break label$1;
   }
   alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__h6fa0f6109e8ad24d($2 | 0, HEAP32[$0 >> 2] | 0 | 0, $3 | 0, $1 | 0);
   $0 = (wasm2js_i32$0 = 0, wasm2js_i32$1 = ((HEAP32[($2 + 8 | 0) >> 2] | 0) + Math_imul(HEAP32[($2 + 12 | 0) >> 2] | 0, 12) | 0) + 1412 | 0, wasm2js_i32$2 = (HEAP32[$2 >> 2] | 0 | 0) == (1 | 0), wasm2js_i32$2 ? wasm2js_i32$0 : wasm2js_i32$1);
  }
  global$0 = $2 + 16 | 0;
  return $0 | 0;
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___get__h7872ab5b45891653($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0, wasm2js_i32$2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    $3 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    if ($3) {
     break label$2
    }
    $0 = 0;
    break label$1;
   }
   alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__h7a535ed0615a3476($2 | 0, HEAP32[$0 >> 2] | 0 | 0, $3 | 0, $1 | 0);
   $0 = (wasm2js_i32$0 = 0, wasm2js_i32$1 = ((HEAP32[($2 + 8 | 0) >> 2] | 0) + Math_imul(HEAP32[($2 + 12 | 0) >> 2] | 0, 48) | 0) + 528 | 0, wasm2js_i32$2 = (HEAP32[$2 >> 2] | 0 | 0) == (1 | 0), wasm2js_i32$2 ? wasm2js_i32$0 : wasm2js_i32$1);
  }
  global$0 = $2 + 16 | 0;
  return $0 | 0;
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___get__h84ab4aba07ccb152($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0, wasm2js_i32$2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    $3 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    if ($3) {
     break label$2
    }
    $0 = 0;
    break label$1;
   }
   alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__h5ebcf0b358f8c8ee($2 | 0, HEAP32[$0 >> 2] | 0 | 0, $3 | 0, $1 | 0);
   $0 = (wasm2js_i32$0 = 0, wasm2js_i32$1 = ((HEAP32[($2 + 8 | 0) >> 2] | 0) + Math_imul(HEAP32[($2 + 12 | 0) >> 2] | 0, 12) | 0) + 4 | 0, wasm2js_i32$2 = (HEAP32[$2 >> 2] | 0 | 0) == (1 | 0), wasm2js_i32$2 ? wasm2js_i32$0 : wasm2js_i32$1);
  }
  global$0 = $2 + 16 | 0;
  return $0 | 0;
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___get__h87541381570c4ffd($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0, wasm2js_i32$2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    $3 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    if ($3) {
     break label$2
    }
    $0 = 0;
    break label$1;
   }
   alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__h53d3f5d723fce848($2 | 0, HEAP32[$0 >> 2] | 0 | 0, $3 | 0, $1 | 0);
   $0 = (wasm2js_i32$0 = 0, wasm2js_i32$1 = ((HEAP32[($2 + 8 | 0) >> 2] | 0) + Math_imul(HEAP32[($2 + 12 | 0) >> 2] | 0, 12) | 0) + 4 | 0, wasm2js_i32$2 = (HEAP32[$2 >> 2] | 0 | 0) == (1 | 0), wasm2js_i32$2 ? wasm2js_i32$0 : wasm2js_i32$1);
  }
  global$0 = $2 + 16 | 0;
  return $0 | 0;
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___get_mut__h5afebdc50bacca04($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0, wasm2js_i32$2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    $3 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    if ($3) {
     break label$2
    }
    $0 = 0;
    break label$1;
   }
   alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__h05f65203dc6f97ae($2 | 0, HEAP32[$0 >> 2] | 0 | 0, $3 | 0, $1 | 0);
   $0 = (wasm2js_i32$0 = 0, wasm2js_i32$1 = ((HEAP32[($2 + 8 | 0) >> 2] | 0) + Math_imul(HEAP32[($2 + 12 | 0) >> 2] | 0, 12) | 0) + 4 | 0, wasm2js_i32$2 = (HEAP32[$2 >> 2] | 0 | 0) == (1 | 0), wasm2js_i32$2 ? wasm2js_i32$0 : wasm2js_i32$1);
  }
  global$0 = $2 + 16 | 0;
  return $0 | 0;
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___get_mut__hd032fad84dac0c7f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0, wasm2js_i32$2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    $3 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    if ($3) {
     break label$2
    }
    $0 = 0;
    break label$1;
   }
   alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__h804fffb548e74f27($2 | 0, HEAP32[$0 >> 2] | 0 | 0, $3 | 0, $1 | 0);
   $0 = (wasm2js_i32$0 = 0, wasm2js_i32$1 = ((HEAP32[($2 + 8 | 0) >> 2] | 0) + Math_imul(HEAP32[($2 + 12 | 0) >> 2] | 0, 12) | 0) + 1412 | 0, wasm2js_i32$2 = (HEAP32[$2 >> 2] | 0 | 0) == (1 | 0), wasm2js_i32$2 ? wasm2js_i32$0 : wasm2js_i32$1);
  }
  global$0 = $2 + 16 | 0;
  return $0 | 0;
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc3d6ec99c05cee40($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[$0 >> 2] | 0;
   $2 = $1 << 5 | 0;
   label$2 : while (1) {
    label$3 : {
     label$4 : {
      label$5 : {
       switch ((HEAPU8[$0 >> 0] | 0) + -1 | 0 | 0) {
       case 0:
       case 1:
        $1 = $0 + 4 | 0;
        break label$4;
       case 2:
        break label$5;
       default:
        break label$3;
       };
      }
      $1 = $0 + 8 | 0;
     }
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc3d6ec99c05cee40($1 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h0f78886c344617d4($1 | 0);
    }
    $0 = $0 + 32 | 0;
    $2 = $2 + -32 | 0;
    if ($2) {
     continue label$2
    }
    break label$2;
   };
  }
 }
 
 function $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__h5b1899637bbf7049($0) {
  $0 = $0 | 0;
  var $2 = 0, $1 = 0, $3 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__next_or_end__hb5913db9acd4f9a9($1 | 0, $0 | 0);
  label$1 : {
   $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   if (!$2) {
    break label$1
   }
   label$2 : while (1) {
    $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    core__mem__maybe_uninit__MaybeUninit_T___assume_init_drop__h9493df6090141cf4($2 + ($3 << 7 | 0) | 0 | 0);
    $2 = ($2 + Math_imul($3, 12) | 0) + 1412 | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hb513c626355ab1b6($2 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h515a508dccfbb69c($2 | 0);
    $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__next_or_end__hb5913db9acd4f9a9($1 | 0, $0 | 0);
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if ($2) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $1 + 16 | 0;
 }
 
 function core__ptr__drop_in_place__5bserde_json__value__Value_5d___h6abbb734efb35ee7($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   if (!$1) {
    break label$1
   }
   $1 = Math_imul($1, 24);
   label$2 : while (1) {
    label$3 : {
     label$4 : {
      switch (HEAPU8[$0 >> 0] | 0 | 0) {
      default:
       $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h0198cfc402357e50($0 + 4 | 0 | 0);
       break label$3;
      case 3:
       $2 = $0 + 4 | 0;
       $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 | 0);
       $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 | 0);
       break label$3;
      case 0:
      case 1:
      case 2:
       break label$3;
      case 4:
       break label$4;
      };
     }
     $2 = $0 + 4 | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h2d454d4f9b2e44f3($2 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h55384607e9cf45ad($2 | 0);
    }
    $0 = $0 + 24 | 0;
    $1 = $1 + -24 | 0;
    if ($1) {
     continue label$2
    }
    break label$2;
   };
  }
 }
 
 function $hashbrown__map__HashMap_K_2cV_2cS_2cA__20as_20core__iter__traits__collect__Extend__28K_2cV_29____extend__h9fa35a5044e7202b($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $4 = 0, $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  label$1 : {
   $4 = ($2 - $1 | 0) >>> 5 | 0;
   $4 = HEAP32[($0 + 28 | 0) >> 2] | 0 ? ($4 + 1 | 0) >>> 1 | 0 : $4;
   if ((HEAP32[($0 + 24 | 0) >> 2] | 0) >>> 0 >= $4 >>> 0) {
    break label$1
   }
   hashbrown__raw__RawTable_T_2cA___reserve_rehash__h6f0b6bcc2f29bdb2($3 | 0, $0 + 16 | 0 | 0, $4 | 0, $0 | 0, 1 | 0);
  }
  $core__iter__adapters__map__Map_I_2cF__20as_20core__iter__traits__iterator__Iterator___fold__hb74bf4e511c9ae65($1 | 0, $2 | 0, $0 | 0);
  global$0 = $3 + 16 | 0;
 }
 
 function $cardano_serialization_lib__address__BaseAddress_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h36ef0f3ec3fa9ba7($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hfc0a9a42b93da95d($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 16 | 0 | 0, $1 | 0, 64 | 0) | 0;
  memcpy($0 | 0, $2 + 16 | 0 | 4 | 0 | 0, 59 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 64 | 0, 4 | 0);
  global$0 = $2 + 80 | 0;
 }
 
 function $cardano_serialization_lib__address__PointerAddress_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h725d0ed5db0bdcca($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h82461377cd035a44($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 16 | 0 | 0, $1 | 0, 64 | 0) | 0;
  memcpy($0 | 0, ($2 + 16 | 0) + 8 | 0 | 0, 56 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 64 | 0, 8 | 0);
  global$0 = $2 + 80 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     if (($1 | 0) < (0 | 0)) {
      break label$3
     }
     label$4 : {
      label$5 : {
       label$6 : {
        if ($2) {
         break label$6
        }
        if ($1) {
         break label$5
        }
        break label$2;
       }
       if (!$1) {
        break label$2
       }
       $2 = __rust_alloc_zeroed($1 | 0, 1 | 0) | 0;
       if (!$2) {
        break label$4
       }
       break label$1;
      }
      $2 = __rust_alloc($1 | 0, 1 | 0) | 0;
      if ($2) {
       break label$1
      }
     }
     $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
     alloc__alloc__handle_alloc_error__he269d8f1bff90960($1 | 0, 1 | 0);
     abort();
    }
    alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
    abort();
   }
   $2 = 1;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[$0 >> 2] = $2;
 }
 
 function cryptoxide__hashing__sha3__Engine___2c____finalize__pad_len__hfab79509f3800950($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$5 = 0, $2$hi = 0, $13 = 0, $2 = 0, $10$hi = 0, $13$hi = 0, $15$hi = 0;
  label$1 : {
   label$2 : {
    if (($1 | $0 | 0) & 7 | 0) {
     break label$2
    }
    i64toi32_i32$0 = 0;
    $2 = $1;
    $2$hi = i64toi32_i32$0;
    i64toi32_i32$2 = $1;
    i64toi32_i32$1 = 0;
    i64toi32_i32$3 = 1;
    i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
     i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
     $13 = 0;
    } else {
     i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
     $13 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
    }
    $10$hi = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    $13$hi = i64toi32_i32$1;
    i64toi32_i32$1 = $10$hi;
    i64toi32_i32$0 = $13;
    i64toi32_i32$2 = $13$hi;
    i64toi32_i32$3 = $0 + 2 | 0;
    i64toi32_i32$4 = i64toi32_i32$0 - i64toi32_i32$3 | 0;
    i64toi32_i32$5 = (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) + i64toi32_i32$2 | 0;
    i64toi32_i32$5 = i64toi32_i32$1 - i64toi32_i32$5 | 0;
    i64toi32_i32$1 = i64toi32_i32$4;
    i64toi32_i32$0 = -1;
    i64toi32_i32$3 = -2;
    i64toi32_i32$2 = i64toi32_i32$4 + i64toi32_i32$3 | 0;
    i64toi32_i32$4 = i64toi32_i32$5 + i64toi32_i32$0 | 0;
    if (i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0) {
     i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
    }
    $15$hi = i64toi32_i32$4;
    i64toi32_i32$4 = $2$hi;
    i64toi32_i32$4 = $15$hi;
    i64toi32_i32$1 = $2$hi;
    i64toi32_i32$1 = __wasm_i64_srem(i64toi32_i32$2 | 0, i64toi32_i32$4 | 0, $2 | 0, i64toi32_i32$1 | 0) | 0;
    i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
    $1 = i64toi32_i32$1 + 4 | 0;
    if (!(($1 + $0 | 0) & 7 | 0)) {
     break label$1
    }
    core__panicking__panic__h2fd385a887c8bf13(1136904 | 0, 51 | 0, 1136956 | 0);
    abort();
   }
   core__panicking__panic__h2fd385a887c8bf13(1136836 | 0, 50 | 0, 1136888 | 0);
   abort();
  }
  return $1 >>> 3 | 0 | 0;
 }
 
 function $hex__BytesToHexChars_20as_20core__iter__traits__iterator__Iterator___next__hc170c11ed012196c($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = HEAP32[($0 + 12 | 0) >> 2] | 0;
  HEAP32[($0 + 12 | 0) >> 2] = 1114112;
  label$1 : {
   if (($1 | 0) != (1114112 | 0)) {
    break label$1
   }
   $1 = 1114112;
   $2 = HEAP32[$0 >> 2] | 0;
   if (($2 | 0) == (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
    break label$1
   }
   HEAP32[$0 >> 2] = $2 + 1 | 0;
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   $2 = HEAPU8[$2 >> 0] | 0;
   HEAP32[($0 + 12 | 0) >> 2] = HEAPU8[($1 + ($2 & 15 | 0) | 0) >> 0] | 0;
   $1 = HEAPU8[($1 + ($2 >>> 4 | 0) | 0) >> 0] | 0;
  }
  return $1 | 0;
 }
 
 function $alloc__string__FromUtf8Error_20as_20core__fmt__Debug___fmt__hfe44325d1a412cc5($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $8 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  i64toi32_i32$0 = core__fmt__Formatter__debug_struct__h873400a11fe69724($1 | 0, 1146180 | 0, 13 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $8 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[$2 >> 2] = $8;
  HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($2 + 12 | 0) >> 2] = $0;
  core__fmt__builders__DebugStruct__field__hec833bfe02704935($2 | 0, 1146193 | 0, 5 | 0, $2 + 12 | 0 | 0, 1146200 | 0) | 0;
  HEAP32[($2 + 12 | 0) >> 2] = $0 + 12 | 0;
  core__fmt__builders__DebugStruct__field__hec833bfe02704935($2 | 0, 1146216 | 0, 5 | 0, $2 + 12 | 0 | 0, 1146224 | 0) | 0;
  $0 = core__fmt__builders__DebugStruct__finish__hb1eae1aa0e288840($2 | 0) | 0;
  global$0 = $2 + 16 | 0;
  return $0 | 0;
 }
 
 function int_new_negative($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$1 = 0, i64toi32_i32$4 = 0, i64toi32_i32$5 = 0, i64toi32_i32$0 = 0, $1 = 0, i64toi32_i32$6 = 0, $2 = 0, $2$hi = 0, $21 = 0, $21$hi = 0, $23 = 0, $24$hi = 0, $25$hi = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($1 + 8 | 0 | 0, $0 | 0);
  i64toi32_i32$2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $2 = i64toi32_i32$0;
  $2$hi = i64toi32_i32$1;
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$0 = $2$hi;
  i64toi32_i32$3 = $2;
  i64toi32_i32$4 = i64toi32_i32$2 - i64toi32_i32$3 | 0;
  i64toi32_i32$6 = i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0;
  i64toi32_i32$5 = i64toi32_i32$6 + i64toi32_i32$0 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 - i64toi32_i32$5 | 0;
  $21 = i64toi32_i32$4;
  $21$hi = i64toi32_i32$5;
  i64toi32_i32$5 = i64toi32_i32$0;
  i64toi32_i32$1 = i64toi32_i32$3;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 0;
  $23 = (i64toi32_i32$1 | 0) != (i64toi32_i32$3 | 0) | (i64toi32_i32$5 | 0) != (i64toi32_i32$2 | 0) | 0;
  i64toi32_i32$1 = 0;
  $24$hi = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 0;
  i64toi32_i32$5 = $24$hi;
  i64toi32_i32$2 = $23;
  i64toi32_i32$0 = i64toi32_i32$3 - i64toi32_i32$2 | 0;
  i64toi32_i32$6 = i64toi32_i32$3 >>> 0 < i64toi32_i32$2 >>> 0;
  i64toi32_i32$4 = i64toi32_i32$6 + i64toi32_i32$5 | 0;
  i64toi32_i32$4 = i64toi32_i32$1 - i64toi32_i32$4 | 0;
  $25$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $21$hi;
  i64toi32_i32$3 = $25$hi;
  $0 = $cardano_serialization_lib__utils__Int_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hac86427717971799($21 | 0, i64toi32_i32$4 | 0, i64toi32_i32$0 | 0, i64toi32_i32$3 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function cryptoxide__chacha20__ChaCha_____new__h5f52927ec1f00d74($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     if (($2 | 0) == (32 | 0)) {
      break label$3
     }
     if (($2 | 0) != (16 | 0)) {
      break label$2
     }
    }
    if (($4 & -5 | 0 | 0) != (8 | 0)) {
     break label$1
    }
    cryptoxide__chacha__reference__State_____init__h907baff12ea105b6($0 | 0, $1 | 0, $2 | 0, $3 | 0, $4 | 0);
    memset($0 + 68 | 0 | 0, 0 | 0, 64 | 0) | 0;
    HEAP32[($0 + 64 | 0) >> 2] = 64;
    return;
   }
   core__panicking__panic__h2fd385a887c8bf13(1060633 | 0, 52 | 0, 1060784 | 0);
   abort();
  }
  core__panicking__panic__h2fd385a887c8bf13(1060800 | 0, 55 | 0, 1060856 | 0);
  abort();
 }
 
 function $T_20as_20hex__ToHex___encode_hex__hc3cf64eab3db6a3a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $21 = 0, $24 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  $1 = HEAP32[$1 >> 2] | 0;
  hex__BytesToHexChars__new__hd2404227bb55ee67($2 | 0, HEAP32[$1 >> 2] | 0 | 0, HEAP32[($1 + 4 | 0) >> 2] | 0 | 0, 1068506 | 0);
  i64toi32_i32$1 = $0;
  i64toi32_i32$0 = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[i64toi32_i32$1 >> 2] = HEAP32[(0 + 1055984 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $21 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $21;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $24 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $24;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  $alloc__string__String_20as_20core__iter__traits__collect__Extend_char____extend__h1cb79188832adf99($0 | 0, $2 + 16 | 0 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function $rand__rngs__adapter__reseeding__ReseedingCore_R_2cRsdr__20as_20rand_core__block__BlockRngCore___generate__h6e6be967deb36d03($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, $2 = 0, i64toi32_i32$5 = 0, $11 = 0, $12 = 0, $13 = 0, $17$hi = 0, $21$hi = 0, $22 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    i64toi32_i32$2 = $0;
    i64toi32_i32$0 = HEAP32[($0 + 56 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($0 + 60 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    i64toi32_i32$3 = 1;
    if ((i64toi32_i32$1 | 0) < (i64toi32_i32$0 | 0)) {
     $11 = 1
    } else {
     if ((i64toi32_i32$1 | 0) <= (i64toi32_i32$0 | 0)) {
      if (i64toi32_i32$2 >>> 0 >= i64toi32_i32$3 >>> 0) {
       $12 = 0
      } else {
       $12 = 1
      }
      $13 = $12;
     } else {
      $13 = 0
     }
     $11 = $13;
    }
    if ($11) {
     break label$2
    }
    if ((HEAP32[($0 + 64 | 0) >> 2] | 0 | 0) < (0 | 0)) {
     break label$2
    }
    $rand_chacha__chacha__Array64_T__20as_20core__convert__AsRef__5bT_5d____as_ref__h92537188a965f192($2 + 8 | 0 | 0, $1 | 0);
    i64toi32_i32$3 = $0;
    i64toi32_i32$2 = HEAP32[($0 + 56 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($0 + 60 | 0) >> 2] | 0;
    $17$hi = i64toi32_i32$1;
    i64toi32_i32$1 = 0;
    $21$hi = i64toi32_i32$1;
    i64toi32_i32$1 = $17$hi;
    i64toi32_i32$3 = i64toi32_i32$2;
    i64toi32_i32$2 = $21$hi;
    i64toi32_i32$0 = (HEAP32[($2 + 12 | 0) >> 2] | 0) << 2 | 0;
    i64toi32_i32$5 = (i64toi32_i32$3 >>> 0 < i64toi32_i32$0 >>> 0) + i64toi32_i32$2 | 0;
    i64toi32_i32$5 = i64toi32_i32$1 - i64toi32_i32$5 | 0;
    $22 = i64toi32_i32$3 - i64toi32_i32$0 | 0;
    i64toi32_i32$3 = $0;
    HEAP32[($0 + 56 | 0) >> 2] = $22;
    HEAP32[($0 + 60 | 0) >> 2] = i64toi32_i32$5;
    $rand_chacha__chacha__ChaCha12Core_20as_20rand_core__block__BlockRngCore___generate__h177e060232a47155($0 | 0, $1 | 0);
    break label$1;
   }
   rand__rngs__adapter__reseeding__ReseedingCore_R_2cRsdr___reseed_and_generate__h54ecaa5e8d7f0526($0 | 0, $1 | 0, 0 | 0);
  }
  global$0 = $2 + 16 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___allocate_in__h7079698aee95f1e4($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     if (($1 | 0) < (0 | 0)) {
      break label$3
     }
     label$4 : {
      label$5 : {
       label$6 : {
        if ($2) {
         break label$6
        }
        if ($1) {
         break label$5
        }
        break label$2;
       }
       if (!$1) {
        break label$2
       }
       $2 = __rust_alloc_zeroed($1 | 0, 1 | 0) | 0;
       if (!$2) {
        break label$4
       }
       break label$1;
      }
      $2 = __rust_alloc($1 | 0, 1 | 0) | 0;
      if ($2) {
       break label$1
      }
     }
     alloc__alloc__handle_alloc_error__he269d8f1bff90960($1 | 0, 1 | 0);
     abort();
    }
    alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
    abort();
   }
   $2 = 1;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[$0 >> 2] = $2;
 }
 
 function serde_json__de__Deserializer_R___error__h438ab94fbb97beef($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  serde_json__read__SliceRead__position_of_index__ha8a2610e8c8fa0b4($2 + 8 | 0 | 0, $0 | 0, HEAP32[($0 + 8 | 0) >> 2] | 0 | 0);
  $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  HEAP32[(($2 + 16 | 0) + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  HEAP32[($2 + 16 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$1;
  $1 = serde_json__error__Error__syntax__h11c9d7f40fe522f9($2 + 16 | 0 | 0, $3 | 0, $0 | 0) | 0;
  global$0 = $2 + 32 | 0;
  return $1 | 0;
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___get__h1f6710d7f87d2e37($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0, wasm2js_i32$2 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    $4 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    if ($4) {
     break label$2
    }
    $0 = 0;
    break label$1;
   }
   alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__h5bc9976a94462f29($3 | 0, HEAP32[$0 >> 2] | 0 | 0, $4 | 0, $1 | 0, $2 | 0);
   $0 = (wasm2js_i32$0 = 0, wasm2js_i32$1 = (HEAP32[($3 + 8 | 0) >> 2] | 0) + Math_imul(HEAP32[($3 + 12 | 0) >> 2] | 0, 24) | 0, wasm2js_i32$2 = (HEAP32[$3 >> 2] | 0 | 0) == (1 | 0), wasm2js_i32$2 ? wasm2js_i32$0 : wasm2js_i32$1);
  }
  global$0 = $3 + 16 | 0;
  return $0 | 0;
 }
 
 function ed25519_bip32__key__XPrv__public__h9a90c9dc9e5d18c6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 96 | 0;
  global$0 = $2;
  cryptoxide__ed25519__extended_to_public__hb7e9895dfbf0ff6d($2 | 0, $1 | 0);
  memset($2 + 32 | 0 | 0, 0 | 0, 64 | 0) | 0;
  core__slice___impl_20_5bT_5d___copy_from_slice__h0f69c19ed1852955($2 + 32 | 0 | 0, 32 | 0, $2 | 0, 32 | 0);
  core__slice___impl_20_5bT_5d___copy_from_slice__h0f69c19ed1852955(($2 + 32 | 0) + 32 | 0 | 0, 32 | 0, $1 + 64 | 0 | 0, 32 | 0);
  memcpy($0 | 0, $2 + 32 | 0 | 0, 64 | 0) | 0;
  global$0 = $2 + 96 | 0;
 }
 
 function ed25519_bip32__key__XPub__from_slice__hd93ec341c444a89b($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0;
  $3 = global$0 - 64 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    if (($2 | 0) != (64 | 0)) {
     break label$2
    }
    $2 = 0;
    $4 = memset($3 | 0, 0 | 0, 64 | 0) | 0;
    core__slice___impl_20_5bT_5d___copy_from_slice__h0f69c19ed1852955($4 | 0, 64 | 0, $1 | 0, 64 | 0);
    memcpy($0 + 1 | 0 | 0, $4 | 0, 64 | 0) | 0;
    break label$1;
   }
   HEAP32[($0 + 4 | 0) >> 2] = $2;
   $2 = 1;
  }
  HEAP8[$0 >> 0] = $2;
  global$0 = $3 + 64 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___allocate_in__hce83853681ce0f55($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     if (($1 | 0) < (0 | 0)) {
      break label$3
     }
     label$4 : {
      label$5 : {
       label$6 : {
        if ($2) {
         break label$6
        }
        if ($1) {
         break label$5
        }
        break label$2;
       }
       if (!$1) {
        break label$2
       }
       $2 = __rust_alloc_zeroed($1 | 0, 1 | 0) | 0;
       if (!$2) {
        break label$4
       }
       break label$1;
      }
      $2 = __rust_alloc($1 | 0, 1 | 0) | 0;
      if ($2) {
       break label$1
      }
     }
     alloc__alloc__handle_alloc_error__he269d8f1bff90960($1 | 0, 1 | 0);
     abort();
    }
    alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
    abort();
   }
   $2 = 1;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[$0 >> 2] = $2;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___allocate_in__h0b672ee83bdda79c($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     if (($1 | 0) < (0 | 0)) {
      break label$3
     }
     label$4 : {
      label$5 : {
       label$6 : {
        if ($2) {
         break label$6
        }
        if ($1) {
         break label$5
        }
        break label$2;
       }
       if (!$1) {
        break label$2
       }
       $2 = __rust_alloc_zeroed($1 | 0, 1 | 0) | 0;
       if (!$2) {
        break label$4
       }
       break label$1;
      }
      $2 = __rust_alloc($1 | 0, 1 | 0) | 0;
      if ($2) {
       break label$1
      }
     }
     alloc__alloc__handle_alloc_error__he269d8f1bff90960($1 | 0, 1 | 0);
     abort();
    }
    alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
    abort();
   }
   $2 = 1;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[$0 >> 2] = $2;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___allocate_in__he85a33ecfd36769f($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     if (($1 | 0) < (0 | 0)) {
      break label$3
     }
     label$4 : {
      label$5 : {
       label$6 : {
        if ($2) {
         break label$6
        }
        if ($1) {
         break label$5
        }
        break label$2;
       }
       if (!$1) {
        break label$2
       }
       $2 = __rust_alloc_zeroed($1 | 0, 1 | 0) | 0;
       if (!$2) {
        break label$4
       }
       break label$1;
      }
      $2 = __rust_alloc($1 | 0, 1 | 0) | 0;
      if ($2) {
       break label$1
      }
     }
     alloc__alloc__handle_alloc_error__he269d8f1bff90960($1 | 0, 1 | 0);
     abort();
    }
    alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
    abort();
   }
   $2 = 1;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[$0 >> 2] = $2;
 }
 
 function core__ptr__drop_in_place_cbor_event__error__Error___hbf0141ec70b68c45_3($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $1 = HEAPU8[$0 >> 0] | 0;
      if ($1 >>> 0 < 14 >>> 0) {
       break label$4
      }
      label$5 : {
       switch ($1 + -14 | 0 | 0) {
       case 2:
        break label$1;
       case 1:
        break label$2;
       case 0:
        break label$3;
       case 3:
        break label$4;
       default:
        break label$5;
       };
      }
      $0 = $0 + 4 | 0;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
     }
     return;
    }
    $0 = $0 + 4 | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
    return;
   }
   $0 = $0 + 4 | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
   return;
  }
  core__ptr__drop_in_place_std__io__error__Error___h33c863f956f9c357($0 + 4 | 0 | 0);
 }
 
 function $cardano_serialization_lib__TransactionBody_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__haffa981cfd1e3240($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 288 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h238818d95bb6c551($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 8 | 0 | 0, $1 | 0, 280 | 0) | 0;
  memcpy($0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 272 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 280 | 0, 8 | 0);
  global$0 = $2 + 288 | 0;
 }
 
 function $cardano_serialization_lib__TransactionInput_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hcada039a655d5072($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h70a9eb625118938d($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 8 | 0 | 0, $1 | 0, 40 | 0) | 0;
  memcpy($0 | 0, $2 + 8 | 0 | 4 | 0 | 0, 36 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 40 | 0, 4 | 0);
  global$0 = $2 + 48 | 0;
 }
 
 function $cardano_serialization_lib__TransactionOutput_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h4bb11caa52896e6c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 144 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h2e0ce7a7ba945683($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 8 | 0 | 0, $1 | 0, 136 | 0) | 0;
  memcpy($0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 128 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 136 | 0, 8 | 0);
  global$0 = $2 + 144 | 0;
 }
 
 function $cardano_serialization_lib__StakeRegistration_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he3fe45f8c534c1bd($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $9 = 0, $10 = 0, $11 = 0, $13 = 0, $7 = 0, $12 = 0, $17 = 0, $22 = 0;
  label$1 : {
   $1 = __rust_alloc(36 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(36 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $7 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  $9 = $7;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = $9;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = $9 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = $9 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = $9 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 8 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 9 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 10 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 11 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $12 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 12 | 0;
  $10 = $12;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $0 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $17 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 20 | 0;
  $11 = $17;
  HEAP8[i64toi32_i32$0 >> 0] = $11;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $0 + 21 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $22 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 25 | 0;
  $13 = $22;
  HEAP8[i64toi32_i32$1 >> 0] = $13;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__StakeDeregistration_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hb69c7c50974f5b70($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $9 = 0, $10 = 0, $11 = 0, $13 = 0, $7 = 0, $12 = 0, $17 = 0, $22 = 0;
  label$1 : {
   $1 = __rust_alloc(36 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(36 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $7 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  $9 = $7;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = $9;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = $9 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = $9 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = $9 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 8 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 9 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 10 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 11 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $12 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 12 | 0;
  $10 = $12;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $0 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $17 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 20 | 0;
  $11 = $17;
  HEAP8[i64toi32_i32$0 >> 0] = $11;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $0 + 21 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $22 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 25 | 0;
  $13 = $22;
  HEAP8[i64toi32_i32$1 >> 0] = $13;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__Relay_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__ha0d8781612d84a1b($0) {
  $0 = $0 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $1 = 0, $7 = 0, $12 = 0, $17 = 0;
  label$1 : {
   $1 = __rust_alloc(32 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(32 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $12 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 12 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $12;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $0 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $17 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 20 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $17;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 28 | 0) >> 2] = HEAP32[($0 + 24 | 0) >> 2] | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__PoolParams_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h7a4ff73f0e2cbbc8($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 208 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h1c3e5d7685536043($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 8 | 0 | 0, $1 | 0, 200 | 0) | 0;
  memcpy($0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 192 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 200 | 0, 8 | 0);
  global$0 = $2 + 208 | 0;
 }
 
 function $cardano_serialization_lib__PoolRegistration_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h123bf2891cf9f689($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 208 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h1ee81fd4f1a62708($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 8 | 0 | 0, $1 | 0, 200 | 0) | 0;
  memcpy($0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 192 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 200 | 0, 8 | 0);
  global$0 = $2 + 208 | 0;
 }
 
 function $cardano_serialization_lib__PoolRetirement_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hc280b71a1ce0ea8e($0) {
  $0 = $0 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $1 = 0, $7 = 0, $12 = 0, $17 = 0, $22 = 0;
  label$1 : {
   $1 = __rust_alloc(36 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(36 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $12 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 12 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $12;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $0 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $17 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 20 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $17;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $0 + 24 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $22 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 28 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $22;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__SingleHostAddr_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h118dc31a83c6b0e2($0) {
  $0 = $0 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $1 = 0, $8 = 0, $9 = 0, $10 = 0, $7 = 0, $12 = 0, $17 = 0;
  label$1 : {
   $1 = __rust_alloc(32 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(32 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
  i64toi32_i32$1 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
  $7 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  $8 = $7;
  HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = $8;
  HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = $8 >>> 16 | 0;
  HEAP16[(i64toi32_i32$0 + 8 | 0) >> 1] = i64toi32_i32$1;
  HEAP16[(i64toi32_i32$0 + 10 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
  i64toi32_i32$0 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
  $12 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 12 | 0;
  $9 = $12;
  HEAP16[i64toi32_i32$1 >> 1] = $9;
  HEAP16[(i64toi32_i32$1 + 2 | 0) >> 1] = $9 >>> 16 | 0;
  HEAP16[(i64toi32_i32$1 + 4 | 0) >> 1] = i64toi32_i32$0;
  HEAP16[(i64toi32_i32$1 + 6 | 0) >> 1] = i64toi32_i32$0 >>> 16 | 0;
  i64toi32_i32$2 = $0 + 16 | 0;
  i64toi32_i32$0 = HEAPU16[i64toi32_i32$2 >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 2 | 0) >> 1] | 0) << 16 | 0) | 0;
  i64toi32_i32$1 = HEAPU16[(i64toi32_i32$2 + 4 | 0) >> 1] | 0 | ((HEAPU16[(i64toi32_i32$2 + 6 | 0) >> 1] | 0) << 16 | 0) | 0;
  $17 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 20 | 0;
  $10 = $17;
  HEAP16[i64toi32_i32$0 >> 1] = $10;
  HEAP16[(i64toi32_i32$0 + 2 | 0) >> 1] = $10 >>> 16 | 0;
  HEAP16[(i64toi32_i32$0 + 4 | 0) >> 1] = i64toi32_i32$1;
  HEAP16[(i64toi32_i32$0 + 6 | 0) >> 1] = i64toi32_i32$1 >>> 16 | 0;
  HEAP16[($1 + 28 | 0) >> 1] = HEAPU16[($0 + 24 | 0) >> 1] | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__ScriptPubkey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he4b2ddfdd7790cb9($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $8 = 0, $9 = 0, $10 = 0, $11 = 0, $13 = 0, $14 = 0, $7 = 0, $12 = 0, $17 = 0;
  label$1 : {
   $1 = __rust_alloc(32 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(32 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $7 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  $8 = $7;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = $8;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = $8 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = $8 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = $8 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 8 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 9 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 10 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 11 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $12 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 12 | 0;
  $9 = $12;
  HEAP8[i64toi32_i32$1 >> 0] = $9;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $9 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $9 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $9 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $0 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $17 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 20 | 0;
  $10 = $17;
  HEAP8[i64toi32_i32$0 >> 0] = $10;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $11 = $0 + 24 | 0;
  $13 = $1 + 28 | 0;
  $14 = HEAPU8[$11 >> 0] | 0 | ((HEAPU8[($11 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($11 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($11 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  HEAP8[$13 >> 0] = $14;
  HEAP8[($13 + 1 | 0) >> 0] = $14 >>> 8 | 0;
  HEAP8[($13 + 2 | 0) >> 0] = $14 >>> 16 | 0;
  HEAP8[($13 + 3 | 0) >> 0] = $14 >>> 24 | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__Update_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h686ee4a4a9e58709($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__ha963d8c1f162247c($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 8 | 0 | 0, $1 | 0, 56 | 0) | 0;
  memcpy($0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 48 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 56 | 0, 8 | 0);
  global$0 = $2 + 64 | 0;
 }
 
 function cardano_serialization_lib__TransactionBodies__add__h685115c6f4b9c765($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 272 | 0;
  global$0 = $2;
  $cardano_serialization_lib__TransactionBody_20as_20core__clone__Clone___clone__h8541427cda4fbd03($2 | 0, $1 | 0);
  label$1 : {
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (($1 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
    break label$1
   }
   alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hb13b6fa50ee7b823($0 | 0, $1 | 0, 1 | 0);
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  }
  memcpy((HEAP32[$0 >> 2] | 0) + Math_imul($1, 272) | 0 | 0, $2 | 0, 272 | 0) | 0;
  HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
  global$0 = $2 + 272 | 0;
 }
 
 function headerbody_protocol_version($0) {
  $0 = $0 | 0;
  var $1 = 0, $3 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h2ac16fcb64db16b5($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $2 = HEAP32[($0 + 172 | 0) >> 2] | 0;
  $0 = HEAP32[($0 + 168 | 0) >> 2] | 0;
  $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
  $0 = $cardano_serialization_lib__ProtocolVersion_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h721fdbbf560ad7f4($0 | 0, $2 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__output_builder__TransactionOutputAmountBuilder_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__ha2e5d09f03937507($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 144 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h04da9548c44845e2($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 8 | 0 | 0, $1 | 0, 136 | 0) | 0;
  memcpy($0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 128 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 136 | 0, 8 | 0);
  global$0 = $2 + 144 | 0;
 }
 
 function core__ptr__drop_in_place_cbor_event__error__Error___hbf0141ec70b68c45_4($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $1 = HEAPU8[$0 >> 0] | 0;
      if ($1 >>> 0 < 14 >>> 0) {
       break label$4
      }
      label$5 : {
       switch ($1 + -14 | 0 | 0) {
       case 2:
        break label$1;
       case 1:
        break label$2;
       case 0:
        break label$3;
       case 3:
        break label$4;
       default:
        break label$5;
       };
      }
      $0 = $0 + 4 | 0;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
     }
     return;
    }
    $0 = $0 + 4 | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
    return;
   }
   $0 = $0 + 4 | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
   return;
  }
  core__ptr__drop_in_place_std__io__error__Error___h33c863f956f9c357_1($0 + 4 | 0 | 0);
 }
 
 function $cardano_serialization_lib__utils__Int_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h465ce6bea3371e5b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $2 = 0, i64toi32_i32$2 = 0, $3 = 0, $3$hi = 0, $4 = 0, $4$hi = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h80a1b87584d9858b($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$2 = $1 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $3 = i64toi32_i32$0;
  $3$hi = i64toi32_i32$1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $4 = i64toi32_i32$1;
  $4$hi = i64toi32_i32$0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 24 | 0, 8 | 0);
  i64toi32_i32$0 = $3$hi;
  i64toi32_i32$1 = $0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $3;
  HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $4$hi;
  HEAP32[i64toi32_i32$1 >> 2] = $4;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 16 | 0;
 }
 
 function core__ptr__drop_in_place_cbor_event__error__Error___hbf0141ec70b68c45_5($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $1 = HEAPU8[$0 >> 0] | 0;
      if ($1 >>> 0 < 14 >>> 0) {
       break label$4
      }
      label$5 : {
       switch ($1 + -14 | 0 | 0) {
       case 2:
        break label$1;
       case 1:
        break label$2;
       case 0:
        break label$3;
       case 3:
        break label$4;
       default:
        break label$5;
       };
      }
      $0 = $0 + 4 | 0;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
     }
     return;
    }
    $0 = $0 + 4 | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
    return;
   }
   $0 = $0 + 4 | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
   return;
  }
  core__ptr__drop_in_place_std__io__error__Error___h33c863f956f9c357_2($0 + 4 | 0 | 0);
 }
 
 function $cardano_serialization_lib__metadata__TransactionMetadatum_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h5fd3565fc4e8c763($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h3b236b5d1445a759($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 8 | 0 | 0, $1 | 0, 56 | 0) | 0;
  memcpy($0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 48 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 56 | 0, 8 | 0);
  global$0 = $2 + 64 | 0;
 }
 
 function $cardano_serialization_lib__metadata__AuxiliaryData_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h85bc793a96c7fd5d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h55a9e62aded28c25($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 8 | 0 | 0, $1 | 0, 72 | 0) | 0;
  memcpy($0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 64 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 72 | 0, 8 | 0);
  global$0 = $2 + 80 | 0;
 }
 
 function $cardano_serialization_lib__tx_builder__TransactionBuilderConfig_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h597719a7183e4421($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h3bcf83380d1abbd9($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 8 | 0 | 0, $1 | 0, 104 | 0) | 0;
  memcpy($0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 96 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 104 | 0, 8 | 0);
  global$0 = $2 + 112 | 0;
 }
 
 function $cardano_serialization_lib__crypto__Bip32PrivateKey_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__he08750f04da5ba39($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h3071e883f72e7ae8($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 8 | 0 | 0, $1 | 0, 100 | 0) | 0;
  memcpy($0 | 0, $2 + 8 | 0 | 4 | 0 | 0, 96 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 100 | 0, 4 | 0);
  global$0 = $2 + 112 | 0;
 }
 
 function $cardano_serialization_lib__crypto__Bip32PublicKey_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h3ce6e98e6160adf2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__ha87586f3d6cffbc3($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 8 | 0 | 0, $1 | 0, 68 | 0) | 0;
  memcpy($0 | 0, $2 + 8 | 0 | 4 | 0 | 0, 64 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 68 | 0, 4 | 0);
  global$0 = $2 + 80 | 0;
 }
 
 function $cardano_serialization_lib__crypto__PublicKey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h435bbe8dcccd675c($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $9 = 0, $10 = 0, $11 = 0, $13 = 0, $7 = 0, $12 = 0, $17 = 0, $22 = 0;
  label$1 : {
   $1 = __rust_alloc(36 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(36 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $7 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  $9 = $7;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = $9;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = $9 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = $9 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = $9 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 8 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 9 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 10 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 11 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $12 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 12 | 0;
  $10 = $12;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $0 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $17 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 20 | 0;
  $11 = $17;
  HEAP8[i64toi32_i32$0 >> 0] = $11;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $0 + 24 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $22 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 28 | 0;
  $13 = $22;
  HEAP8[i64toi32_i32$1 >> 0] = $13;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__crypto__PrivateKey_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hb039971b04c3a015($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__ha2d20d272947bf8a($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 8 | 0 | 0, $1 | 0, 72 | 0) | 0;
  memcpy($0 | 0, $2 + 8 | 0 | 4 | 0 | 0, 65 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 72 | 0, 4 | 0);
  global$0 = $2 + 80 | 0;
 }
 
 function $cardano_serialization_lib__crypto__Ed25519KeyHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hd63cf82b6a769066($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $8 = 0, $9 = 0, $10 = 0, $11 = 0, $13 = 0, $14 = 0, $7 = 0, $12 = 0, $17 = 0;
  label$1 : {
   $1 = __rust_alloc(32 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(32 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $7 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  $8 = $7;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = $8;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = $8 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = $8 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = $8 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 8 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 9 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 10 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 11 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $12 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 12 | 0;
  $9 = $12;
  HEAP8[i64toi32_i32$1 >> 0] = $9;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $9 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $9 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $9 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $0 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $17 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 20 | 0;
  $10 = $17;
  HEAP8[i64toi32_i32$0 >> 0] = $10;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $11 = $0 + 24 | 0;
  $13 = $1 + 28 | 0;
  $14 = HEAPU8[$11 >> 0] | 0 | ((HEAPU8[($11 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($11 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($11 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  HEAP8[$13 >> 0] = $14;
  HEAP8[($13 + 1 | 0) >> 0] = $14 >>> 8 | 0;
  HEAP8[($13 + 2 | 0) >> 0] = $14 >>> 16 | 0;
  HEAP8[($13 + 3 | 0) >> 0] = $14 >>> 24 | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__crypto__Vkey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h0c56da261e90089c($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $9 = 0, $10 = 0, $11 = 0, $13 = 0, $7 = 0, $12 = 0, $17 = 0, $22 = 0;
  label$1 : {
   $1 = __rust_alloc(36 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(36 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $7 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  $9 = $7;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = $9;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = $9 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = $9 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = $9 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 8 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 9 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 10 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 11 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $12 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 12 | 0;
  $10 = $12;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $0 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $17 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 20 | 0;
  $11 = $17;
  HEAP8[i64toi32_i32$0 >> 0] = $11;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $0 + 24 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $22 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 28 | 0;
  $13 = $22;
  HEAP8[i64toi32_i32$1 >> 0] = $13;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__crypto__Vkeywitness_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h410d1e7c1dfb507d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hff755cd032524cf1($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 8 | 0 | 0, $1 | 0, 100 | 0) | 0;
  memcpy($0 | 0, $2 + 8 | 0 | 4 | 0 | 0, 96 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 100 | 0, 4 | 0);
  global$0 = $2 + 112 | 0;
 }
 
 function $cardano_serialization_lib__crypto__Ed25519Signature_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h06286e958fd68507($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hf14781561558cd9c($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 8 | 0 | 0, $1 | 0, 68 | 0) | 0;
  memcpy($0 | 0, $2 + 8 | 0 | 4 | 0 | 0, 64 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 68 | 0, 4 | 0);
  global$0 = $2 + 80 | 0;
 }
 
 function $cardano_serialization_lib__crypto__LegacyDaedalusPrivateKey_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h01c57f5c14c20554($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 112 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h83c09f1ed97d5b0f($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 8 | 0 | 0, $1 | 0, 100 | 0) | 0;
  memcpy($0 | 0, $2 + 8 | 0 | 4 | 0 | 0, 96 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 100 | 0, 4 | 0);
  global$0 = $2 + 112 | 0;
 }
 
 function $cardano_serialization_lib__crypto__ScriptHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hcd9bcfbb1bcf9de7($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $8 = 0, $9 = 0, $10 = 0, $11 = 0, $13 = 0, $14 = 0, $7 = 0, $12 = 0, $17 = 0;
  label$1 : {
   $1 = __rust_alloc(32 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(32 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $7 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  $8 = $7;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = $8;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = $8 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = $8 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = $8 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 8 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 9 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 10 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 11 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $12 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 12 | 0;
  $9 = $12;
  HEAP8[i64toi32_i32$1 >> 0] = $9;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $9 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $9 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $9 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $0 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $17 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 20 | 0;
  $10 = $17;
  HEAP8[i64toi32_i32$0 >> 0] = $10;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $11 = $0 + 24 | 0;
  $13 = $1 + 28 | 0;
  $14 = HEAPU8[$11 >> 0] | 0 | ((HEAPU8[($11 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($11 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($11 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  HEAP8[$13 >> 0] = $14;
  HEAP8[($13 + 1 | 0) >> 0] = $14 >>> 8 | 0;
  HEAP8[($13 + 2 | 0) >> 0] = $14 >>> 16 | 0;
  HEAP8[($13 + 3 | 0) >> 0] = $14 >>> 24 | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__crypto__TransactionHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__ha325bfafa26d5417($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $9 = 0, $10 = 0, $11 = 0, $13 = 0, $7 = 0, $12 = 0, $17 = 0, $22 = 0;
  label$1 : {
   $1 = __rust_alloc(36 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(36 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $7 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  $9 = $7;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = $9;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = $9 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = $9 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = $9 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 8 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 9 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 10 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 11 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $12 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 12 | 0;
  $10 = $12;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $0 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $17 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 20 | 0;
  $11 = $17;
  HEAP8[i64toi32_i32$0 >> 0] = $11;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $0 + 24 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $22 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 28 | 0;
  $13 = $22;
  HEAP8[i64toi32_i32$1 >> 0] = $13;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__crypto__GenesisDelegateHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h829122a765b38e99($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $8 = 0, $9 = 0, $10 = 0, $11 = 0, $13 = 0, $14 = 0, $7 = 0, $12 = 0, $17 = 0;
  label$1 : {
   $1 = __rust_alloc(32 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(32 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $7 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  $8 = $7;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = $8;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = $8 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = $8 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = $8 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 8 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 9 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 10 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 11 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $12 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 12 | 0;
  $9 = $12;
  HEAP8[i64toi32_i32$1 >> 0] = $9;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $9 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $9 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $9 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $0 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $17 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 20 | 0;
  $10 = $17;
  HEAP8[i64toi32_i32$0 >> 0] = $10;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $11 = $0 + 24 | 0;
  $13 = $1 + 28 | 0;
  $14 = HEAPU8[$11 >> 0] | 0 | ((HEAPU8[($11 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($11 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($11 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  HEAP8[$13 >> 0] = $14;
  HEAP8[($13 + 1 | 0) >> 0] = $14 >>> 8 | 0;
  HEAP8[($13 + 2 | 0) >> 0] = $14 >>> 16 | 0;
  HEAP8[($13 + 3 | 0) >> 0] = $14 >>> 24 | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__crypto__GenesisHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hedc49afed5ec6de0($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $8 = 0, $9 = 0, $10 = 0, $11 = 0, $13 = 0, $14 = 0, $7 = 0, $12 = 0, $17 = 0;
  label$1 : {
   $1 = __rust_alloc(32 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(32 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $7 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  $8 = $7;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = $8;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = $8 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = $8 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = $8 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 8 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 9 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 10 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 11 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $12 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 12 | 0;
  $9 = $12;
  HEAP8[i64toi32_i32$1 >> 0] = $9;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $9 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $9 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $9 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $0 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $17 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 20 | 0;
  $10 = $17;
  HEAP8[i64toi32_i32$0 >> 0] = $10;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  $11 = $0 + 24 | 0;
  $13 = $1 + 28 | 0;
  $14 = HEAPU8[$11 >> 0] | 0 | ((HEAPU8[($11 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($11 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($11 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  HEAP8[$13 >> 0] = $14;
  HEAP8[($13 + 1 | 0) >> 0] = $14 >>> 8 | 0;
  HEAP8[($13 + 2 | 0) >> 0] = $14 >>> 16 | 0;
  HEAP8[($13 + 3 | 0) >> 0] = $14 >>> 24 | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__crypto__AuxiliaryDataHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__ha0bdb89a2c7c1e66($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $9 = 0, $10 = 0, $11 = 0, $13 = 0, $7 = 0, $12 = 0, $17 = 0, $22 = 0;
  label$1 : {
   $1 = __rust_alloc(36 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(36 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $7 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  $9 = $7;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = $9;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = $9 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = $9 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = $9 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 8 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 9 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 10 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 11 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $12 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 12 | 0;
  $10 = $12;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $0 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $17 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 20 | 0;
  $11 = $17;
  HEAP8[i64toi32_i32$0 >> 0] = $11;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $0 + 24 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $22 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 28 | 0;
  $13 = $22;
  HEAP8[i64toi32_i32$1 >> 0] = $13;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__crypto__PoolMetadataHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__heaaf3507fd71ee00($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $9 = 0, $10 = 0, $11 = 0, $13 = 0, $7 = 0, $12 = 0, $17 = 0, $22 = 0;
  label$1 : {
   $1 = __rust_alloc(36 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(36 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $7 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  $9 = $7;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = $9;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = $9 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = $9 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = $9 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 8 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 9 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 10 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 11 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $12 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 12 | 0;
  $10 = $12;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $0 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $17 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 20 | 0;
  $11 = $17;
  HEAP8[i64toi32_i32$0 >> 0] = $11;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $0 + 24 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $22 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 28 | 0;
  $13 = $22;
  HEAP8[i64toi32_i32$1 >> 0] = $13;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__crypto__VRFKeyHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf9aae481fe8479f($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $9 = 0, $10 = 0, $11 = 0, $13 = 0, $7 = 0, $12 = 0, $17 = 0, $22 = 0;
  label$1 : {
   $1 = __rust_alloc(36 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(36 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $7 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  $9 = $7;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = $9;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = $9 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = $9 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = $9 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 8 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 9 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 10 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 11 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $12 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 12 | 0;
  $10 = $12;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $0 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $17 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 20 | 0;
  $11 = $17;
  HEAP8[i64toi32_i32$0 >> 0] = $11;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $0 + 24 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $22 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 28 | 0;
  $13 = $22;
  HEAP8[i64toi32_i32$1 >> 0] = $13;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__crypto__BlockHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hf8ef4eaf9a4a30cf($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $9 = 0, $10 = 0, $11 = 0, $13 = 0, $7 = 0, $12 = 0, $17 = 0, $22 = 0;
  label$1 : {
   $1 = __rust_alloc(36 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(36 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $7 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  $9 = $7;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = $9;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = $9 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = $9 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = $9 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 8 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 9 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 10 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 11 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $12 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 12 | 0;
  $10 = $12;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $0 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $17 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 20 | 0;
  $11 = $17;
  HEAP8[i64toi32_i32$0 >> 0] = $11;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $0 + 24 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $22 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 28 | 0;
  $13 = $22;
  HEAP8[i64toi32_i32$1 >> 0] = $13;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__crypto__DataHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hba2449530c6577ab($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $9 = 0, $10 = 0, $11 = 0, $13 = 0, $7 = 0, $12 = 0, $17 = 0, $22 = 0;
  label$1 : {
   $1 = __rust_alloc(36 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(36 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $7 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  $9 = $7;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = $9;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = $9 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = $9 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = $9 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 8 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 9 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 10 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 11 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $12 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 12 | 0;
  $10 = $12;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $0 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $17 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 20 | 0;
  $11 = $17;
  HEAP8[i64toi32_i32$0 >> 0] = $11;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $0 + 24 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $22 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 28 | 0;
  $13 = $22;
  HEAP8[i64toi32_i32$1 >> 0] = $13;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__crypto__ScriptDataHash_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h4525048b15d98533($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $9 = 0, $10 = 0, $11 = 0, $13 = 0, $7 = 0, $12 = 0, $17 = 0, $22 = 0;
  label$1 : {
   $1 = __rust_alloc(36 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(36 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $7 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  $9 = $7;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = $9;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = $9 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = $9 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = $9 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 8 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 9 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 10 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 11 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $12 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 12 | 0;
  $10 = $12;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $0 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $17 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 20 | 0;
  $11 = $17;
  HEAP8[i64toi32_i32$0 >> 0] = $11;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $0 + 24 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $22 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 28 | 0;
  $13 = $22;
  HEAP8[i64toi32_i32$1 >> 0] = $13;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__crypto__VRFVKey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h510224eaef243251($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $9 = 0, $10 = 0, $11 = 0, $13 = 0, $7 = 0, $12 = 0, $17 = 0, $22 = 0;
  label$1 : {
   $1 = __rust_alloc(36 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(36 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $7 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  $9 = $7;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = $9;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = $9 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = $9 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = $9 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 8 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 9 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 10 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 11 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $12 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 12 | 0;
  $10 = $12;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $0 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $17 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 20 | 0;
  $11 = $17;
  HEAP8[i64toi32_i32$0 >> 0] = $11;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $0 + 24 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $22 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 28 | 0;
  $13 = $22;
  HEAP8[i64toi32_i32$1 >> 0] = $13;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__crypto__KESVKey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h5c8fb7ce130dd69e($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $9 = 0, $10 = 0, $11 = 0, $13 = 0, $7 = 0, $12 = 0, $17 = 0, $22 = 0;
  label$1 : {
   $1 = __rust_alloc(36 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(36 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $7 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  $9 = $7;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = $9;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = $9 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = $9 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = $9 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 8 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 9 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 10 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 11 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $12 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 12 | 0;
  $10 = $12;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $0 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $17 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 20 | 0;
  $11 = $17;
  HEAP8[i64toi32_i32$0 >> 0] = $11;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $0 + 24 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $22 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 28 | 0;
  $13 = $22;
  HEAP8[i64toi32_i32$1 >> 0] = $13;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__crypto__Nonce_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hbc488b6feb4e7d5f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hda4ab87d1c9ee98a($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 8 | 0 | 0, $1 | 0, 40 | 0) | 0;
  memcpy($0 | 0, $2 + 8 | 0 | 4 | 0 | 0, 33 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 40 | 0, 4 | 0);
  global$0 = $2 + 48 | 0;
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___get__h702e3889319be60e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0, wasm2js_i32$2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    $3 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    if ($3) {
     break label$2
    }
    $0 = 0;
    break label$1;
   }
   alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__h802fdd2e37b8965b($2 | 0, HEAP32[$0 >> 2] | 0 | 0, $3 | 0, $1 | 0);
   $0 = (wasm2js_i32$0 = 0, wasm2js_i32$1 = (HEAP32[($2 + 8 | 0) >> 2] | 0) + ((HEAP32[($2 + 12 | 0) >> 2] | 0) << 3 | 0) | 0, wasm2js_i32$2 = (HEAP32[$2 >> 2] | 0 | 0) == (1 | 0), wasm2js_i32$2 ? wasm2js_i32$0 : wasm2js_i32$1);
  }
  global$0 = $2 + 16 | 0;
  return $0 | 0;
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___get__h825f34112f7eacbf($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0, wasm2js_i32$2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    $3 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    if ($3) {
     break label$2
    }
    $0 = 0;
    break label$1;
   }
   alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__h060f30fd852e1b1d($2 | 0, HEAP32[$0 >> 2] | 0 | 0, $3 | 0, $1 | 0);
   $0 = (wasm2js_i32$0 = 0, wasm2js_i32$1 = (HEAP32[($2 + 8 | 0) >> 2] | 0) + ((HEAP32[($2 + 12 | 0) >> 2] | 0) << 3 | 0) | 0, wasm2js_i32$2 = (HEAP32[$2 >> 2] | 0 | 0) == (1 | 0), wasm2js_i32$2 ? wasm2js_i32$0 : wasm2js_i32$1);
  }
  global$0 = $2 + 16 | 0;
  return $0 | 0;
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___get__h9e6a7b6dbfee6453($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0, wasm2js_i32$2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    $3 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    if ($3) {
     break label$2
    }
    $0 = 0;
    break label$1;
   }
   alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__h6a50e69eb0c61fee($2 | 0, HEAP32[$0 >> 2] | 0 | 0, $3 | 0, $1 | 0);
   $0 = (wasm2js_i32$0 = 0, wasm2js_i32$1 = (HEAP32[($2 + 8 | 0) >> 2] | 0) + ((HEAP32[($2 + 12 | 0) >> 2] | 0) << 4 | 0) | 0, wasm2js_i32$2 = (HEAP32[$2 >> 2] | 0 | 0) == (1 | 0), wasm2js_i32$2 ? wasm2js_i32$0 : wasm2js_i32$1);
  }
  global$0 = $2 + 16 | 0;
  return $0 | 0;
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___get_mut__h36eb13302ff969d4($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0, wasm2js_i32$2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    $3 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    if ($3) {
     break label$2
    }
    $0 = 0;
    break label$1;
   }
   alloc__collections__btree__search___impl_20alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____search_tree__h7cca0af434b441f5($2 | 0, HEAP32[$0 >> 2] | 0 | 0, $3 | 0, $1 | 0);
   $0 = (wasm2js_i32$0 = 0, wasm2js_i32$1 = (HEAP32[($2 + 8 | 0) >> 2] | 0) + ((HEAP32[($2 + 12 | 0) >> 2] | 0) << 3 | 0) | 0, wasm2js_i32$2 = (HEAP32[$2 >> 2] | 0 | 0) == (1 | 0), wasm2js_i32$2 ? wasm2js_i32$0 : wasm2js_i32$1);
  }
  global$0 = $2 + 16 | 0;
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__tx_builder__tx_inputs_builder__PlutusWitness_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hf3febb4a8b9507dc($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 160 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hc3197a13809f41ef($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 8 | 0 | 0, $1 | 0, 152 | 0) | 0;
  memcpy($0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 144 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 152 | 0, 8 | 0);
  global$0 = $2 + 160 | 0;
 }
 
 function $cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hee313210dd0eeab7($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 96 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hf277c6a2d5f089a3($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 8 | 0 | 0, $1 | 0, 88 | 0) | 0;
  memcpy($0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 80 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 88 | 0, 8 | 0);
  global$0 = $2 + 96 | 0;
 }
 
 function $cardano_serialization_lib__address__StakeCredential_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hfe6826a4b7739a89($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $9 = 0, $10 = 0, $11 = 0, $13 = 0, $7 = 0, $12 = 0, $17 = 0, $22 = 0;
  label$1 : {
   $1 = __rust_alloc(36 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(36 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $7 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  $9 = $7;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = $9;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = $9 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = $9 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = $9 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 8 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 9 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 10 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 11 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $12 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 12 | 0;
  $10 = $12;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $0 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $17 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 20 | 0;
  $11 = $17;
  HEAP8[i64toi32_i32$0 >> 0] = $11;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $0 + 21 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $22 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 25 | 0;
  $13 = $22;
  HEAP8[i64toi32_i32$1 >> 0] = $13;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__address__ByronAddress_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h2a0117dae22798e7($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h5a93dad80b9e2f2c($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 8 | 0 | 0, $1 | 0, 56 | 0) | 0;
  memcpy($0 | 0, $2 + 8 | 0 | 4 | 0 | 0, 52 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 56 | 0, 4 | 0);
  global$0 = $2 + 64 | 0;
 }
 
 function $cardano_serialization_lib__address__Address_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h47880851d7dc8f1b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 80 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h2b41666efcf1cebf($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 8 | 0 | 0, $1 | 0, 72 | 0) | 0;
  memcpy($0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 64 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 72 | 0, 8 | 0);
  global$0 = $2 + 80 | 0;
 }
 
 function $cardano_serialization_lib__address__EnterpriseAddress_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hc6936df3a6b251b0($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $9 = 0, $10 = 0, $11 = 0, $13 = 0, $7 = 0, $12 = 0, $17 = 0, $22 = 0;
  label$1 : {
   $1 = __rust_alloc(36 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(36 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $7 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  $9 = $7;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = $9;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = $9 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = $9 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = $9 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 8 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 9 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 10 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 11 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $12 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 12 | 0;
  $10 = $12;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $0 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $17 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 20 | 0;
  $11 = $17;
  HEAP8[i64toi32_i32$0 >> 0] = $11;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $0 + 22 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $22 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 26 | 0;
  $13 = $22;
  HEAP8[i64toi32_i32$1 >> 0] = $13;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__address__RewardAddress_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8b4ddbbcde95397b($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $1 = 0, $9 = 0, $10 = 0, $11 = 0, $13 = 0, $7 = 0, $12 = 0, $17 = 0, $22 = 0;
  label$1 : {
   $1 = __rust_alloc(36 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(36 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $7 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  $9 = $7;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = $9;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = $9 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = $9 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = $9 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 8 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 9 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 10 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 11 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $12 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 12 | 0;
  $10 = $12;
  HEAP8[i64toi32_i32$1 >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $10 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  i64toi32_i32$2 = $0 + 16 | 0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $17 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 20 | 0;
  $11 = $17;
  HEAP8[i64toi32_i32$0 >> 0] = $11;
  HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 24 | 0;
  HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = $0 + 22 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $22 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 26 | 0;
  $13 = $22;
  HEAP8[i64toi32_i32$1 >> 0] = $13;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $13 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $13 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $13 >>> 24 | 0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
  return $1 | 0;
 }
 
 function core__ptr__drop_in_place_cbor_event__error__Error___hbf0141ec70b68c45_6($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      $1 = HEAPU8[$0 >> 0] | 0;
      if ($1 >>> 0 < 14 >>> 0) {
       break label$4
      }
      label$5 : {
       switch ($1 + -14 | 0 | 0) {
       case 2:
        break label$1;
       case 1:
        break label$2;
       case 0:
        break label$3;
       case 3:
        break label$4;
       default:
        break label$5;
       };
      }
      $0 = $0 + 4 | 0;
      $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
      $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
     }
     return;
    }
    $0 = $0 + 4 | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
    return;
   }
   $0 = $0 + 4 | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
   return;
  }
  core__ptr__drop_in_place_std__io__error__Error___h33c863f956f9c357_3($0 + 4 | 0 | 0);
 }
 
 function $cardano_serialization_lib__plutus__PlutusData_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h08b7da506ccf1ae6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 64 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hccc847303139d236($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 8 | 0 | 0, $1 | 0, 56 | 0) | 0;
  memcpy($0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 48 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 56 | 0, 8 | 0);
  global$0 = $2 + 64 | 0;
 }
 
 function $cardano_serialization_lib__plutus__Redeemer_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hbcdc67bff96edc1d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 96 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h635fa27cde6b95a8($2 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  memcpy($2 + 8 | 0 | 0, $1 | 0, 88 | 0) | 0;
  memcpy($0 | 0, ($2 + 8 | 0) + 8 | 0 | 0, 80 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 88 | 0, 8 | 0);
  global$0 = $2 + 96 | 0;
 }
 
 function rand__rngs__thread__THREAD_RNG_KEY____init___7b_7bclosure_7d_7d__h3b0f67c8281ffceb($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $19 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  core__fmt__ArgumentV1__new__h66761e613e2355ba($2 | 0, $2 + 8 | 0 | 0, 155 | 0);
  HEAP32[($2 + 36 | 0) >> 2] = 1;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 20 | 0) >> 2] = 1;
  HEAP32[($2 + 24 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 16 | 0) >> 2] = 1074488;
  i64toi32_i32$0 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 40 | 0) >> 2] = $19;
  HEAP32[($2 + 44 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($2 + 32 | 0) >> 2] = $2 + 40 | 0;
  core__panicking__panic_fmt__hbf21a3d4bbb82bf8($2 + 16 | 0 | 0, 1074592 | 0);
  abort();
 }
 
 function $cryptoxide__hmac__Hmac_D__20as_20cryptoxide__mac__Mac___raw_result__hac4d52a01c11d996($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  label$1 : {
   if (HEAPU8[($0 + 248 | 0) >> 0] | 0) {
    break label$1
   }
   $cryptoxide__sha2__Sha512_20as_20cryptoxide__digest__Digest___result__h84e92e596fb82544($0 | 0, $1 | 0, $2 | 0);
   $cryptoxide__sha2__Sha512_20as_20cryptoxide__digest__Digest___reset__h100e33024dbb0407($0 | 0);
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h12ac465cd2b9ef75($3 + 8 | 0 | 0, $0 + 236 | 0 | 0);
   $cryptoxide__sha2__Sha512_20as_20cryptoxide__digest__Digest___input__h63322ce5a02a233a($0 | 0, HEAP32[($3 + 8 | 0) >> 2] | 0 | 0, HEAP32[($3 + 12 | 0) >> 2] | 0 | 0);
   $cryptoxide__sha2__Sha512_20as_20cryptoxide__digest__Digest___input__h63322ce5a02a233a($0 | 0, $1 | 0, $2 | 0);
   HEAP8[($0 + 248 | 0) >> 0] = 1;
  }
  $cryptoxide__sha2__Sha512_20as_20cryptoxide__digest__Digest___result__h84e92e596fb82544($0 | 0, $1 | 0, $2 | 0);
  global$0 = $3 + 16 | 0;
 }
 
 function $cbor_event__len__Len_20as_20core__fmt__Debug___fmt__hea16dfa439f453e5($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    i64toi32_i32$0 = HEAP32[$0 >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    i64toi32_i32$2 = i64toi32_i32$0;
    i64toi32_i32$0 = 0;
    if ((i64toi32_i32$2 | 0) == (1 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
     break label$2
    }
    core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1139432 | 0, 10 | 0);
    break label$1;
   }
   core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1139412 | 0, 3 | 0);
   HEAP32[($2 + 12 | 0) >> 2] = $0 + 8 | 0;
   core__fmt__builders__DebugTuple__field__h5e7e3e19ad5aa557($2 | 0, $2 + 12 | 0 | 0, 1139416 | 0) | 0;
  }
  $0 = core__fmt__builders__DebugTuple__finish__hc3c3f1efaa75a6e2($2 | 0) | 0;
  global$0 = $2 + 16 | 0;
  return $0 | 0;
 }
 
 function core__ops__function__FnOnce__call_once_7b_7bvtable_shim_7d_7d__h6aad3a2a7975ccb8($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = HEAP32[$0 >> 2] | 0;
  $0 = HEAP32[$2 >> 2] | 0;
  HEAP32[$2 >> 2] = 0;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    $2 = __rust_alloc(1024 | 0, 1 | 0) | 0;
    if (!$2) {
     break label$1
    }
    $0 = HEAP32[$0 >> 2] | 0;
    HEAP8[($0 + 16 | 0) >> 0] = 0;
    HEAP32[($0 + 8 | 0) >> 2] = 1024;
    HEAP32[($0 + 12 | 0) >> 2] = 0;
    HEAP32[($0 + 4 | 0) >> 2] = $2;
    HEAP32[$0 >> 2] = 0;
    return;
   }
   core__panicking__panic__h2fd385a887c8bf13(1142444 | 0, 43 | 0, 1143948 | 0);
   abort();
  }
  alloc__alloc__handle_alloc_error__he269d8f1bff90960(1024 | 0, 1 | 0);
  abort();
 }
 
 function std__sync__once__Once__call_once_force___7b_7bclosure_7d_7d__h6f10d52c889f7f0f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = HEAP32[$0 >> 2] | 0;
  $0 = HEAP32[$2 >> 2] | 0;
  HEAP32[$2 >> 2] = 0;
  label$1 : {
   label$2 : {
    if (!$0) {
     break label$2
    }
    $2 = __rust_alloc(1024 | 0, 1 | 0) | 0;
    if (!$2) {
     break label$1
    }
    $0 = HEAP32[$0 >> 2] | 0;
    HEAP8[($0 + 16 | 0) >> 0] = 0;
    HEAP32[($0 + 8 | 0) >> 2] = 1024;
    HEAP32[($0 + 12 | 0) >> 2] = 0;
    HEAP32[($0 + 4 | 0) >> 2] = $2;
    HEAP32[$0 >> 2] = 0;
    return;
   }
   core__panicking__panic__h2fd385a887c8bf13(1142444 | 0, 43 | 0, 1143948 | 0);
   abort();
  }
  alloc__alloc__handle_alloc_error__he269d8f1bff90960(1024 | 0, 1 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__splitpoint__h8424344594b4deb1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $3 = 0, $2 = 0;
  $2 = 0;
  $3 = 4;
  label$1 : {
   if ($1 >>> 0 < 5 >>> 0) {
    break label$1
   }
   $3 = $1;
   label$2 : {
    switch ($1 + -5 | 0 | 0) {
    default:
     $1 = $1 + -7 | 0;
     $2 = 1;
     $3 = 6;
     break label$1;
    case 0:
     break label$1;
    case 1:
     break label$2;
    };
   }
   $1 = 0;
   $2 = 1;
   $3 = 5;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $2;
  HEAP32[$0 >> 2] = $3;
  HEAP32[($0 + 8 | 0) >> 2] = $1;
 }
 
 function core__ptr__drop_in_place_std__io__error__Error___h33c863f956f9c357($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $3 = 0;
  label$1 : {
   if ((HEAPU8[$0 >> 0] | 0 | 0) != (3 | 0)) {
    break label$1
   }
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   FUNCTION_TABLE[HEAP32[(HEAP32[($1 + 4 | 0) >> 2] | 0) >> 2] | 0 | 0](HEAP32[$1 >> 2] | 0);
   $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   $2 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $1 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$1 >> 2] | 0 | 0) | 0;
   label$2 : {
    if (!$2) {
     break label$2
    }
    __rust_dealloc($1 | 0, $2 | 0, $3 | 0);
   }
   __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[($0 + 4 | 0) >> 2] | 0 | 0) | 0 | 0, 12 | 0, 4 | 0);
  }
 }
 
 function $cardano_serialization_lib__Transaction_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hf1e81f974efa699a($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 432 | 0;
  global$0 = $1;
  memcpy(($1 + 4 | 0) + 4 | 0 | 0, $0 | 0, 424 | 0) | 0;
  label$1 : {
   $0 = __rust_alloc(432 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(432 | 0, 8 | 0);
   abort();
  }
  HEAP32[$0 >> 2] = 0;
  memcpy($0 + 4 | 0 | 0, $1 + 4 | 0 | 0, 428 | 0) | 0;
  global$0 = $1 + 432 | 0;
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__TransactionBody_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h5f9023ed5f5fb82c($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 288 | 0;
  global$0 = $1;
  memcpy(($1 + 12 | 0) + 4 | 0 | 0, $0 | 0, 272 | 0) | 0;
  label$1 : {
   $0 = __rust_alloc(280 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(280 | 0, 8 | 0);
   abort();
  }
  HEAP32[$0 >> 2] = 0;
  memcpy($0 + 4 | 0 | 0, $1 + 12 | 0 | 0, 276 | 0) | 0;
  global$0 = $1 + 288 | 0;
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__TransactionOutput_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h4b9395cffb8a7c47($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 144 | 0;
  global$0 = $1;
  memcpy(($1 + 12 | 0) + 4 | 0 | 0, $0 | 0, 128 | 0) | 0;
  label$1 : {
   $0 = __rust_alloc(136 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(136 | 0, 8 | 0);
   abort();
  }
  HEAP32[$0 >> 2] = 0;
  memcpy($0 + 4 | 0 | 0, $1 + 12 | 0 | 0, 132 | 0) | 0;
  global$0 = $1 + 144 | 0;
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__Certificate_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hd9e6ef3cbd15ff20($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 208 | 0;
  global$0 = $1;
  memcpy(($1 + 4 | 0) + 4 | 0 | 0, $0 | 0, 200 | 0) | 0;
  label$1 : {
   $0 = __rust_alloc(208 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(208 | 0, 8 | 0);
   abort();
  }
  HEAP32[$0 >> 2] = 0;
  memcpy($0 + 4 | 0 | 0, $1 + 4 | 0 | 0, 204 | 0) | 0;
  global$0 = $1 + 208 | 0;
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__Withdrawals_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8137ae41e80d8131($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  memcpy(($1 + 4 | 0) + 4 | 0 | 0, $0 | 0, 40 | 0) | 0;
  label$1 : {
   $0 = __rust_alloc(48 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(48 | 0, 8 | 0);
   abort();
  }
  HEAP32[$0 >> 2] = 0;
  memcpy($0 + 4 | 0 | 0, $1 + 4 | 0 | 0, 44 | 0) | 0;
  global$0 = $1 + 48 | 0;
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__Update_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__heaf0e9524107f139($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 64 | 0;
  global$0 = $1;
  memcpy(($1 + 12 | 0) + 4 | 0 | 0, $0 | 0, 48 | 0) | 0;
  label$1 : {
   $0 = __rust_alloc(56 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(56 | 0, 8 | 0);
   abort();
  }
  HEAP32[$0 >> 2] = 0;
  memcpy($0 + 4 | 0 | 0, $1 + 12 | 0 | 0, 52 | 0) | 0;
  global$0 = $1 + 64 | 0;
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__PoolParams_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he83d156438296832($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 208 | 0;
  global$0 = $1;
  memcpy(($1 + 12 | 0) + 4 | 0 | 0, $0 | 0, 192 | 0) | 0;
  label$1 : {
   $0 = __rust_alloc(200 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(200 | 0, 8 | 0);
   abort();
  }
  HEAP32[$0 >> 2] = 0;
  memcpy($0 + 4 | 0 | 0, $1 + 12 | 0 | 0, 196 | 0) | 0;
  global$0 = $1 + 208 | 0;
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__PoolRegistration_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hba4f55f2c62f4c8d($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 208 | 0;
  global$0 = $1;
  memcpy(($1 + 12 | 0) + 4 | 0 | 0, $0 | 0, 192 | 0) | 0;
  label$1 : {
   $0 = __rust_alloc(200 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(200 | 0, 8 | 0);
   abort();
  }
  HEAP32[$0 >> 2] = 0;
  memcpy($0 + 4 | 0 | 0, $1 + 12 | 0 | 0, 196 | 0) | 0;
  global$0 = $1 + 208 | 0;
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__MoveInstantaneousRewardsCert_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8b59c9ac999ad03b($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 64 | 0;
  global$0 = $1;
  memcpy(($1 + 4 | 0) + 4 | 0 | 0, $0 | 0, 56 | 0) | 0;
  label$1 : {
   $0 = __rust_alloc(64 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(64 | 0, 8 | 0);
   abort();
  }
  HEAP32[$0 >> 2] = 0;
  memcpy($0 + 4 | 0 | 0, $1 + 4 | 0 | 0, 60 | 0) | 0;
  global$0 = $1 + 64 | 0;
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__MoveInstantaneousReward_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hf9455bc13311e72d($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 64 | 0;
  global$0 = $1;
  memcpy(($1 + 4 | 0) + 4 | 0 | 0, $0 | 0, 56 | 0) | 0;
  label$1 : {
   $0 = __rust_alloc(64 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(64 | 0, 8 | 0);
   abort();
  }
  HEAP32[$0 >> 2] = 0;
  memcpy($0 + 4 | 0 | 0, $1 + 4 | 0 | 0, 60 | 0) | 0;
  global$0 = $1 + 64 | 0;
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__MIRToStakeCredentials_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h1e2c02e5ebbbcce1($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  memcpy(($1 + 4 | 0) + 4 | 0 | 0, $0 | 0, 40 | 0) | 0;
  label$1 : {
   $0 = __rust_alloc(48 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(48 | 0, 8 | 0);
   abort();
  }
  HEAP32[$0 >> 2] = 0;
  memcpy($0 + 4 | 0 | 0, $1 + 4 | 0 | 0, 44 | 0) | 0;
  global$0 = $1 + 48 | 0;
  return $0 | 0;
 }
 
 function singlehostname_port($0) {
  $0 = $0 | 0;
  var $1 = 0, $3 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hb0365aa08561904d($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $2 = HEAPU16[($0 + 14 | 0) >> 1] | 0;
  $0 = HEAPU16[($0 + 12 | 0) >> 1] | 0;
  $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return ($0 ? $2 : 16777215) | 0;
 }
 
 function $cardano_serialization_lib__ProposedProtocolParameterUpdates_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he29d4b6136a4f24f($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  memcpy(($1 + 4 | 0) + 4 | 0 | 0, $0 | 0, 40 | 0) | 0;
  label$1 : {
   $0 = __rust_alloc(48 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(48 | 0, 8 | 0);
   abort();
  }
  HEAP32[$0 >> 2] = 0;
  memcpy($0 + 4 | 0 | 0, $1 + 4 | 0 | 0, 44 | 0) | 0;
  global$0 = $1 + 48 | 0;
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__ProtocolParamUpdate_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hd784927b58be35b6($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 416 | 0;
  global$0 = $1;
  memcpy(($1 + 4 | 0) + 4 | 0 | 0, $0 | 0, 408 | 0) | 0;
  label$1 : {
   $0 = __rust_alloc(416 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(416 | 0, 8 | 0);
   abort();
  }
  HEAP32[$0 >> 2] = 0;
  memcpy($0 + 4 | 0 | 0, $1 + 4 | 0 | 0, 412 | 0) | 0;
  global$0 = $1 + 416 | 0;
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__AuxiliaryDataSet_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hb494915f50e223f9($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  memcpy(($1 + 4 | 0) + 4 | 0 | 0, $0 | 0, 40 | 0) | 0;
  label$1 : {
   $0 = __rust_alloc(48 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(48 | 0, 8 | 0);
   abort();
  }
  HEAP32[$0 >> 2] = 0;
  memcpy($0 + 4 | 0 | 0, $1 + 4 | 0 | 0, 44 | 0) | 0;
  global$0 = $1 + 48 | 0;
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__Block_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h2c5c321414f91af3($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 416 | 0;
  global$0 = $1;
  memcpy(($1 + 4 | 0) + 4 | 0 | 0, $0 | 0, 408 | 0) | 0;
  label$1 : {
   $0 = __rust_alloc(416 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(416 | 0, 8 | 0);
   abort();
  }
  HEAP32[$0 >> 2] = 0;
  memcpy($0 + 4 | 0 | 0, $1 + 4 | 0 | 0, 412 | 0) | 0;
  global$0 = $1 + 416 | 0;
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__Header_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h7c5802dbd37296c4($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 336 | 0;
  global$0 = $1;
  memcpy(($1 + 4 | 0) + 4 | 0 | 0, $0 | 0, 328 | 0) | 0;
  label$1 : {
   $0 = __rust_alloc(336 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(336 | 0, 8 | 0);
   abort();
  }
  HEAP32[$0 >> 2] = 0;
  memcpy($0 + 4 | 0 | 0, $1 + 4 | 0 | 0, 332 | 0) | 0;
  global$0 = $1 + 336 | 0;
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__HeaderBody_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he5de7ce2c4403ed1($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 320 | 0;
  global$0 = $1;
  memcpy(($1 + 4 | 0) + 4 | 0 | 0, $0 | 0, 312 | 0) | 0;
  label$1 : {
   $0 = __rust_alloc(320 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(320 | 0, 8 | 0);
   abort();
  }
  HEAP32[$0 >> 2] = 0;
  memcpy($0 + 4 | 0 | 0, $1 + 4 | 0 | 0, 316 | 0) | 0;
  global$0 = $1 + 320 | 0;
  return $0 | 0;
 }
 
 function __wbg_headerbody_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 320 | 0;
  global$0 = $1;
  $cardano_serialization_lib__HeaderBody_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__ha8a6c3f97f104c70($1 + 8 | 0 | 0, $0 | 0);
  $0 = $1 + 20 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
  $0 = $1 + 32 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
  $0 = $1 + 44 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
  $0 = $1 + 56 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
  global$0 = $1 + 320 | 0;
 }
 
 function $cardano_serialization_lib__output_builder__TransactionOutputBuilder_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h6f606fcbcfa27636($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 112 | 0;
  global$0 = $1;
  memcpy(($1 + 4 | 0) + 4 | 0 | 0, $0 | 0, 104 | 0) | 0;
  label$1 : {
   $0 = __rust_alloc(112 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(112 | 0, 8 | 0);
   abort();
  }
  HEAP32[$0 >> 2] = 0;
  memcpy($0 + 4 | 0 | 0, $1 + 4 | 0 | 0, 108 | 0) | 0;
  global$0 = $1 + 112 | 0;
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__output_builder__TransactionOutputAmountBuilder_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hafb771b944269b79($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 144 | 0;
  global$0 = $1;
  memcpy(($1 + 12 | 0) + 4 | 0 | 0, $0 | 0, 128 | 0) | 0;
  label$1 : {
   $0 = __rust_alloc(136 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(136 | 0, 8 | 0);
   abort();
  }
  HEAP32[$0 >> 2] = 0;
  memcpy($0 + 4 | 0 | 0, $1 + 12 | 0 | 0, 132 | 0) | 0;
  global$0 = $1 + 144 | 0;
  return $0 | 0;
 }
 
 function core__ptr__drop_in_place_std__io__error__Error___h33c863f956f9c357_1($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $3 = 0;
  label$1 : {
   if ((HEAPU8[$0 >> 0] | 0 | 0) != (3 | 0)) {
    break label$1
   }
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   FUNCTION_TABLE[HEAP32[(HEAP32[($1 + 4 | 0) >> 2] | 0) >> 2] | 0 | 0](HEAP32[$1 >> 2] | 0);
   $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   $2 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $1 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$1 >> 2] | 0 | 0) | 0;
   label$2 : {
    if (!$2) {
     break label$2
    }
    __rust_dealloc($1 | 0, $2 | 0, $3 | 0);
   }
   __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[($0 + 4 | 0) >> 2] | 0 | 0) | 0 | 0, 12 | 0, 4 | 0);
  }
 }
 
 function $cardano_serialization_lib__utils__TransactionUnspentOutput_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h241331f04367994b($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 176 | 0;
  global$0 = $1;
  memcpy(($1 + 4 | 0) + 4 | 0 | 0, $0 | 0, 168 | 0) | 0;
  label$1 : {
   $0 = __rust_alloc(176 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(176 | 0, 8 | 0);
   abort();
  }
  HEAP32[$0 >> 2] = 0;
  memcpy($0 + 4 | 0 | 0, $1 + 4 | 0 | 0, 172 | 0) | 0;
  global$0 = $1 + 176 | 0;
  return $0 | 0;
 }
 
 function value_new($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $21 = 0;
  $1 = global$0 - 32 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($1 | 0, $0 | 0);
  i64toi32_i32$2 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  HEAP32[($1 + 16 | 0) >> 2] = 0;
  $21 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 8 | 0) >> 2] = $21;
  HEAP32[($1 + 12 | 0) >> 2] = i64toi32_i32$1;
  $0 = $cardano_serialization_lib__utils__Value_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h50a1108e1e08f966($1 + 8 | 0 | 0) | 0;
  global$0 = $1 + 32 | 0;
  return $0 | 0;
 }
 
 function core__ptr__drop_in_place_std__io__error__Error___h33c863f956f9c357_2($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $3 = 0;
  label$1 : {
   if ((HEAPU8[$0 >> 0] | 0 | 0) != (3 | 0)) {
    break label$1
   }
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   FUNCTION_TABLE[HEAP32[(HEAP32[($1 + 4 | 0) >> 2] | 0) >> 2] | 0 | 0](HEAP32[$1 >> 2] | 0);
   $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   $2 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $1 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$1 >> 2] | 0 | 0) | 0;
   label$2 : {
    if (!$2) {
     break label$2
    }
    __rust_dealloc($1 | 0, $2 | 0, $3 | 0);
   }
   __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[($0 + 4 | 0) >> 2] | 0 | 0) | 0 | 0, 12 | 0, 4 | 0);
  }
 }
 
 function $cardano_serialization_lib__metadata__MetadataMap_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hf2098e6c815f1680($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  memcpy(($1 + 4 | 0) + 4 | 0 | 0, $0 | 0, 40 | 0) | 0;
  label$1 : {
   $0 = __rust_alloc(48 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(48 | 0, 8 | 0);
   abort();
  }
  HEAP32[$0 >> 2] = 0;
  memcpy($0 + 4 | 0 | 0, $1 + 4 | 0 | 0, 44 | 0) | 0;
  global$0 = $1 + 48 | 0;
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__metadata__TransactionMetadatum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hce2feba55b67d086($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 64 | 0;
  global$0 = $1;
  memcpy(($1 + 12 | 0) + 4 | 0 | 0, $0 | 0, 48 | 0) | 0;
  label$1 : {
   $0 = __rust_alloc(56 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(56 | 0, 8 | 0);
   abort();
  }
  HEAP32[$0 >> 2] = 0;
  memcpy($0 + 4 | 0 | 0, $1 + 12 | 0 | 0, 52 | 0) | 0;
  global$0 = $1 + 64 | 0;
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__metadata__GeneralTransactionMetadata_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__haadefad5c9c3f4ac($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  memcpy(($1 + 4 | 0) + 4 | 0 | 0, $0 | 0, 40 | 0) | 0;
  label$1 : {
   $0 = __rust_alloc(48 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(48 | 0, 8 | 0);
   abort();
  }
  HEAP32[$0 >> 2] = 0;
  memcpy($0 + 4 | 0 | 0, $1 + 4 | 0 | 0, 44 | 0) | 0;
  global$0 = $1 + 48 | 0;
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__metadata__AuxiliaryData_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h48191cd5277961b5($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  memcpy(($1 + 12 | 0) + 4 | 0 | 0, $0 | 0, 64 | 0) | 0;
  label$1 : {
   $0 = __rust_alloc(72 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(72 | 0, 8 | 0);
   abort();
  }
  HEAP32[$0 >> 2] = 0;
  memcpy($0 + 4 | 0 | 0, $1 + 12 | 0 | 0, 68 | 0) | 0;
  global$0 = $1 + 80 | 0;
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__tx_builder__TransactionBuilderConfig_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h865ebc731340693e($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 112 | 0;
  global$0 = $1;
  memcpy(($1 + 12 | 0) + 4 | 0 | 0, $0 | 0, 96 | 0) | 0;
  label$1 : {
   $0 = __rust_alloc(104 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(104 | 0, 8 | 0);
   abort();
  }
  HEAP32[$0 >> 2] = 0;
  memcpy($0 + 4 | 0 | 0, $1 + 12 | 0 | 0, 100 | 0) | 0;
  global$0 = $1 + 112 | 0;
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__tx_builder__TransactionBuilderConfigBuilder_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h65182e4c6d5621d4($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 144 | 0;
  global$0 = $1;
  memcpy(($1 + 4 | 0) + 4 | 0 | 0, $0 | 0, 136 | 0) | 0;
  label$1 : {
   $0 = __rust_alloc(144 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(144 | 0, 8 | 0);
   abort();
  }
  HEAP32[$0 >> 2] = 0;
  memcpy($0 + 4 | 0 | 0, $1 + 4 | 0 | 0, 140 | 0) | 0;
  global$0 = $1 + 144 | 0;
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__tx_builder__TransactionBuilder_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h055297508c0634c1($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 528 | 0;
  global$0 = $1;
  memcpy(($1 + 4 | 0) + 4 | 0 | 0, $0 | 0, 520 | 0) | 0;
  label$1 : {
   $0 = __rust_alloc(528 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(528 | 0, 8 | 0);
   abort();
  }
  HEAP32[$0 >> 2] = 0;
  memcpy($0 + 4 | 0 | 0, $1 + 4 | 0 | 0, 524 | 0) | 0;
  global$0 = $1 + 528 | 0;
  return $0 | 0;
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend_T_2cI____spec_extend__h0b164968e8398b77($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $5 = 0, $4 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  alloc__vec__Vec_T_2cA___reserve__h71af5692fa531ae6($0 | 0, ($2 - $1 | 0) >>> 7 | 0 | 0);
  $4 = HEAP32[$0 >> 2] | 0;
  $5 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  HEAP32[($3 + 8 | 0) >> 2] = $5;
  HEAP32[($3 + 4 | 0) >> 2] = $0 + 8 | 0;
  HEAP32[$3 >> 2] = $4 + ($5 << 2 | 0) | 0;
  $core__iter__adapters__map__Map_I_2cF__20as_20core__iter__traits__iterator__Iterator___fold__ha528b5dd125884e1($1 | 0, $2 | 0, $3 | 0);
  global$0 = $3 + 16 | 0;
 }
 
 function $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__h61f437aecb6ab6ea($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $3 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__next_or_end__hca2a966750cf638e($1 | 0, $0 | 0);
  label$1 : {
   $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   if (!$2) {
    break label$1
   }
   label$2 : while (1) {
    $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    core__mem__maybe_uninit__MaybeUninit_T___assume_init_drop__h2b0add0f20d62517($2 + ($3 << 4 | 0) | 0 | 0);
    core__ptr__drop_in_place_cbor_event__value__Value___h203893ddc6d2104a(($2 + Math_imul($3, 24) | 0) + 176 | 0 | 0);
    $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__next_or_end__hca2a966750cf638e($1 | 0, $0 | 0);
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if ($2) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $1 + 16 | 0;
 }
 
 function $T_20as_20hex__ToHex___encode_hex__h20f23e9f96075940($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $19 = 0, $22 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  hex__BytesToHexChars__new__hd2404227bb55ee67($2 | 0, HEAP32[$1 >> 2] | 0 | 0, HEAP32[($1 + 4 | 0) >> 2] | 0 | 0, 1068506 | 0);
  i64toi32_i32$1 = $0;
  i64toi32_i32$0 = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[i64toi32_i32$1 >> 2] = HEAP32[(0 + 1055984 | 0) >> 2] | 0;
  i64toi32_i32$2 = $2 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $19 = i64toi32_i32$0;
  i64toi32_i32$0 = ($2 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $19;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $2;
  i64toi32_i32$1 = HEAP32[$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  $22 = i64toi32_i32$1;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 16 | 0) >> 2] = $22;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  $alloc__string__String_20as_20core__iter__traits__collect__Extend_char____extend__h1cb79188832adf99($0 | 0, $2 + 16 | 0 | 0);
  global$0 = $2 + 32 | 0;
 }
 
 function bech32__WriteBase32__write__hc6853b536698e2d6($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  core__slice__iter___impl_20core__iter__traits__collect__IntoIterator_20for_20__5bT_5d___into_iter__h5de9df69b0713ffb($3 + 8 | 0 | 0, $1 | 0, $2 | 0);
  $4 = HEAP32[($3 + 12 | 0) >> 2] | 0;
  $2 = HEAP32[($3 + 8 | 0) >> 2] | 0;
  label$1 : {
   label$2 : while (1) {
    $1 = $2;
    if (($4 | 0) == ($1 | 0)) {
     break label$1
    }
    $2 = $1 + 1 | 0;
    if (!($bech32__Bech32Writer_20as_20bech32__WriteBase32___write_u5__h939535a14b4513fd($0 | 0, HEAPU8[$1 >> 0] | 0 | 0) | 0)) {
     continue label$2
    }
    break label$2;
   };
   $T_20as_20core__convert__From_T____from__h05b3d0c185eed756();
  }
  global$0 = $3 + 16 | 0;
  return ($4 | 0) != ($1 | 0) | 0;
 }
 
 function $cardano_serialization_lib__tx_builder__tx_inputs_builder__PlutusWitness_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h43043aa66f99997b($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 160 | 0;
  global$0 = $1;
  memcpy(($1 + 12 | 0) + 4 | 0 | 0, $0 | 0, 144 | 0) | 0;
  label$1 : {
   $0 = __rust_alloc(152 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(152 | 0, 8 | 0);
   abort();
  }
  HEAP32[$0 >> 2] = 0;
  memcpy($0 + 4 | 0 | 0, $1 + 12 | 0 | 0, 148 | 0) | 0;
  global$0 = $1 + 160 | 0;
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hb3357880063a5222($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 96 | 0;
  global$0 = $1;
  memcpy(($1 + 12 | 0) + 4 | 0 | 0, $0 | 0, 80 | 0) | 0;
  label$1 : {
   $0 = __rust_alloc(88 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(88 | 0, 8 | 0);
   abort();
  }
  HEAP32[$0 >> 2] = 0;
  memcpy($0 + 4 | 0 | 0, $1 + 12 | 0 | 0, 84 | 0) | 0;
  global$0 = $1 + 96 | 0;
  return $0 | 0;
 }
 
 function byronaddress_byron_protocol_magic($0) {
  $0 = $0 | 0;
  var $1 = 0, $3 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h76f3e067f9139bb4($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $2 = HEAP32[($0 + 16 | 0) >> 2] | 0;
  $0 = HEAP32[($0 + 12 | 0) >> 2] | 0;
  $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return (($0 | 0) == (1 | 0) ? $2 : 764824073) | 0;
 }
 
 function byronaddress_is_valid($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  HEAP32[($2 + 24 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = $1;
  HEAP32[($2 + 16 | 0) >> 2] = $0;
  alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($2 | 0, $2 + 16 | 0 | 0);
  $1 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  $0 = HEAP32[$2 >> 2] | 0;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  $1 = cardano_serialization_lib__address__ByronAddress__is_valid__h820ad8424488f77c($0 | 0, $1 | 0) | 0;
  core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_4($2 + 8 | 0 | 0);
  global$0 = $2 + 32 | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__address__Address_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8ce30e61cf34786e($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  memcpy(($1 + 12 | 0) + 4 | 0 | 0, $0 | 0, 64 | 0) | 0;
  label$1 : {
   $0 = __rust_alloc(72 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(72 | 0, 8 | 0);
   abort();
  }
  HEAP32[$0 >> 2] = 0;
  memcpy($0 + 4 | 0 | 0, $1 + 12 | 0 | 0, 68 | 0) | 0;
  global$0 = $1 + 80 | 0;
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__address__PointerAddress_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h1cd671f5d15881dc($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 64 | 0;
  global$0 = $1;
  memcpy(($1 + 4 | 0) + 4 | 0 | 0, $0 | 0, 56 | 0) | 0;
  label$1 : {
   $0 = __rust_alloc(64 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(64 | 0, 8 | 0);
   abort();
  }
  HEAP32[$0 >> 2] = 0;
  memcpy($0 + 4 | 0 | 0, $1 + 4 | 0 | 0, 60 | 0) | 0;
  global$0 = $1 + 64 | 0;
  return $0 | 0;
 }
 
 function core__ptr__drop_in_place_std__io__error__Error___h33c863f956f9c357_3($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $3 = 0;
  label$1 : {
   if ((HEAPU8[$0 >> 0] | 0 | 0) != (3 | 0)) {
    break label$1
   }
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   FUNCTION_TABLE[HEAP32[(HEAP32[($1 + 4 | 0) >> 2] | 0) >> 2] | 0 | 0](HEAP32[$1 >> 2] | 0);
   $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   $2 = HEAP32[($2 + 4 | 0) >> 2] | 0;
   $1 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$1 >> 2] | 0 | 0) | 0;
   label$2 : {
    if (!$2) {
     break label$2
    }
    __rust_dealloc($1 | 0, $2 | 0, $3 | 0);
   }
   __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[($0 + 4 | 0) >> 2] | 0 | 0) | 0 | 0, 12 | 0, 4 | 0);
  }
 }
 
 function $cardano_serialization_lib__plutus__PlutusData_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h7393378a3318e0a5($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 64 | 0;
  global$0 = $1;
  memcpy(($1 + 12 | 0) + 4 | 0 | 0, $0 | 0, 48 | 0) | 0;
  label$1 : {
   $0 = __rust_alloc(56 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(56 | 0, 8 | 0);
   abort();
  }
  HEAP32[$0 >> 2] = 0;
  memcpy($0 + 4 | 0 | 0, $1 + 12 | 0 | 0, 52 | 0) | 0;
  global$0 = $1 + 64 | 0;
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__plutus__Redeemer_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he2ca0b82950da3f7($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 96 | 0;
  global$0 = $1;
  memcpy(($1 + 12 | 0) + 4 | 0 | 0, $0 | 0, 80 | 0) | 0;
  label$1 : {
   $0 = __rust_alloc(88 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(88 | 0, 8 | 0);
   abort();
  }
  HEAP32[$0 >> 2] = 0;
  memcpy($0 + 4 | 0 | 0, $1 + 12 | 0 | 0, 84 | 0) | 0;
  global$0 = $1 + 96 | 0;
  return $0 | 0;
 }
 
 function std__thread__local__LocalKey_T___with__h3200a1a8d8585225($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   label$2 : {
    $0 = FUNCTION_TABLE[HEAP32[$0 >> 2] | 0 | 0]() | 0;
    if (!$0) {
     break label$2
    }
    $0 = HEAP32[$0 >> 2] | 0;
    $2 = (HEAP32[$0 >> 2] | 0) + 1 | 0;
    if ($2 >>> 0 > 1 >>> 0) {
     break label$1
    }
    abort();
   }
   $T_20as_20core__convert__From_T____from__h03d182df15dd7aa6();
   core__result__unwrap_failed__h27f43d993c3864a1(1074771 | 0, 70 | 0, $1 + 8 | 0 | 0, 1074936 | 0, 1074920 | 0);
   abort();
  }
  HEAP32[$0 >> 2] = $2;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function core__iter__traits__iterator__Iterator__cmp__he292810785df7a3c($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $5 = 0;
  label$1 : while (1) {
   label$2 : {
    if (($0 | 0) != ($1 | 0)) {
     break label$2
    }
    return (($2 | 0) != ($3 | 0) ? -1 : 0) | 0;
   }
   label$3 : {
    if (($2 | 0) != ($3 | 0)) {
     break label$3
    }
    return 1 | 0;
   }
   $1 = $1 + -4 | 0;
   $4 = HEAP32[$1 >> 2] | 0;
   $3 = $3 + -4 | 0;
   $5 = HEAP32[$3 >> 2] | 0;
   $4 = $4 >>> 0 < $5 >>> 0 ? -1 : ($4 | 0) != ($5 | 0);
   if (!$4) {
    continue label$1
   }
   break label$1;
  };
  return $4 | 0;
 }
 
 function cryptoxide__hashing__blake2b__Context_____finalize_reset_at__h33fdf3a4d45604f9($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   if (($2 | 0) != (33 | 0)) {
    break label$1
   }
   cryptoxide__hashing__blake2b__Context_____internal_final__he45cbdade4b89e59($0 | 0);
   memcpy($1 | 0, $0 + 100 | 0 | 0, 33 | 0) | 0;
   $0 = memcpy($0 | 0, 1137368 | 0, 64 | 0) | 0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[($0 + 64 | 0) >> 2] = 0;
   HEAP32[($0 + 68 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 1779033703;
   HEAP32[$0 >> 2] = -222443223;
   HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$1 = $0 + 72 | 0;
   i64toi32_i32$0 = 0;
   HEAP32[i64toi32_i32$1 >> 2] = 0;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   memset($0 + 96 | 0 | 0, 0 | 0, 132 | 0) | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1136192 | 0, 47 | 0, 1136240 | 0);
  abort();
 }
 
 function cryptoxide__hashing__blake2b__Context_____finalize_reset_at__h4dc347e6007a0aca($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   if (($2 | 0) != (40 | 0)) {
    break label$1
   }
   cryptoxide__hashing__blake2b__Context_____internal_final__hc78262822725c8ab($0 | 0);
   memcpy($1 | 0, $0 + 100 | 0 | 0, 40 | 0) | 0;
   $0 = memcpy($0 | 0, 1137368 | 0, 64 | 0) | 0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[($0 + 64 | 0) >> 2] = 0;
   HEAP32[($0 + 68 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 1779033703;
   HEAP32[$0 >> 2] = -222443232;
   HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$1 = $0 + 72 | 0;
   i64toi32_i32$0 = 0;
   HEAP32[i64toi32_i32$1 >> 2] = 0;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   memset($0 + 96 | 0 | 0, 0 | 0, 132 | 0) | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1136192 | 0, 47 | 0, 1136240 | 0);
  abort();
 }
 
 function cryptoxide__hashing__blake2b__Context_____finalize_reset_at__h5ae601ceaeb89a3a($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   if (($2 | 0) != (48 | 0)) {
    break label$1
   }
   cryptoxide__hashing__blake2b__Context_____internal_final__ha1773133c9e3f685($0 | 0);
   memcpy($1 | 0, $0 + 100 | 0 | 0, 48 | 0) | 0;
   $0 = memcpy($0 | 0, 1137368 | 0, 64 | 0) | 0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[($0 + 64 | 0) >> 2] = 0;
   HEAP32[($0 + 68 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 1779033703;
   HEAP32[$0 >> 2] = -222443208;
   HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$1 = $0 + 72 | 0;
   i64toi32_i32$0 = 0;
   HEAP32[i64toi32_i32$1 >> 2] = 0;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   memset($0 + 96 | 0 | 0, 0 | 0, 132 | 0) | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1136192 | 0, 47 | 0, 1136240 | 0);
  abort();
 }
 
 function cryptoxide__hashing__blake2b__Context_____finalize_reset_at__h8d40aeec1ac6a7fd($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   if (($2 | 0) != (44 | 0)) {
    break label$1
   }
   cryptoxide__hashing__blake2b__Context_____internal_final__h2dd6d9d150d91fec($0 | 0);
   memcpy($1 | 0, $0 + 100 | 0 | 0, 44 | 0) | 0;
   $0 = memcpy($0 | 0, 1137368 | 0, 64 | 0) | 0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[($0 + 64 | 0) >> 2] = 0;
   HEAP32[($0 + 68 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 1779033703;
   HEAP32[$0 >> 2] = -222443228;
   HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$1 = $0 + 72 | 0;
   i64toi32_i32$0 = 0;
   HEAP32[i64toi32_i32$1 >> 2] = 0;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   memset($0 + 96 | 0 | 0, 0 | 0, 132 | 0) | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1136192 | 0, 47 | 0, 1136240 | 0);
  abort();
 }
 
 function cryptoxide__hashing__blake2b__Context_____finalize_reset_at__hc0b076ac1d844c85($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   if (($2 | 0) != (64 | 0)) {
    break label$1
   }
   cryptoxide__hashing__blake2b__Context_____internal_final__hb862d81c64ddf509($0 | 0);
   memcpy($1 | 0, $0 + 100 | 0 | 0, 64 | 0) | 0;
   $0 = memcpy($0 | 0, 1137368 | 0, 64 | 0) | 0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[($0 + 64 | 0) >> 2] = 0;
   HEAP32[($0 + 68 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 1779033703;
   HEAP32[$0 >> 2] = -222443192;
   HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$1 = $0 + 72 | 0;
   i64toi32_i32$0 = 0;
   HEAP32[i64toi32_i32$1 >> 2] = 0;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   memset($0 + 96 | 0 | 0, 0 | 0, 132 | 0) | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1136192 | 0, 47 | 0, 1136240 | 0);
  abort();
 }
 
 function cryptoxide__hashing__blake2b__Context_____finalize_reset_at__hd64ab7961a181132($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   if (($2 | 0) != (36 | 0)) {
    break label$1
   }
   cryptoxide__hashing__blake2b__Context_____internal_final__hd1dfb7cf1285f8e2($0 | 0);
   memcpy($1 | 0, $0 + 100 | 0 | 0, 36 | 0) | 0;
   $0 = memcpy($0 | 0, 1137368 | 0, 64 | 0) | 0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[($0 + 64 | 0) >> 2] = 0;
   HEAP32[($0 + 68 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 1779033703;
   HEAP32[$0 >> 2] = -222443220;
   HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$1 = $0 + 72 | 0;
   i64toi32_i32$0 = 0;
   HEAP32[i64toi32_i32$1 >> 2] = 0;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   memset($0 + 96 | 0 | 0, 0 | 0, 132 | 0) | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1136192 | 0, 47 | 0, 1136240 | 0);
  abort();
 }
 
 function alloc__collections__btree__fix___impl_20alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____fix_node_and_affected_ancestors__h5cf4d5878102f95c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  alloc__collections__btree__fix___impl_20alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____fix_node_through_parent__hf092f11351db4dea($2 | 0, $0 | 0, $1 | 0);
  $1 = 0;
  label$1 : {
   if ((HEAP32[$2 >> 2] | 0 | 0) == (1 | 0)) {
    break label$1
   }
   label$2 : while (1) {
    $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    $1 = !$0;
    if (!$0) {
     break label$1
    }
    alloc__collections__btree__fix___impl_20alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____fix_node_through_parent__hf092f11351db4dea($2 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    if ((HEAP32[$2 >> 2] | 0 | 0) != (1 | 0)) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $2 + 16 | 0;
  return $1 | 0;
 }
 
 function alloc__collections__btree__fix___impl_20alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____fix_node_and_affected_ancestors__hccbf77174e1338cc($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  alloc__collections__btree__fix___impl_20alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____fix_node_through_parent__h4745793046b3af72($2 | 0, $0 | 0, $1 | 0);
  $1 = 0;
  label$1 : {
   if ((HEAP32[$2 >> 2] | 0 | 0) == (1 | 0)) {
    break label$1
   }
   label$2 : while (1) {
    $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    $1 = !$0;
    if (!$0) {
     break label$1
    }
    alloc__collections__btree__fix___impl_20alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____fix_node_through_parent__h4745793046b3af72($2 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    if ((HEAP32[$2 >> 2] | 0 | 0) != (1 | 0)) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $2 + 16 | 0;
  return $1 | 0;
 }
 
 function alloc__collections__btree__fix___impl_20alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____fix_node_and_affected_ancestors__he91a4cdc5babb35c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  alloc__collections__btree__fix___impl_20alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____fix_node_through_parent__h5a49dfd829c8a7a2($2 | 0, $0 | 0, $1 | 0);
  $1 = 0;
  label$1 : {
   if ((HEAP32[$2 >> 2] | 0 | 0) == (1 | 0)) {
    break label$1
   }
   label$2 : while (1) {
    $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    $1 = !$0;
    if (!$0) {
     break label$1
    }
    alloc__collections__btree__fix___impl_20alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal____fix_node_through_parent__h5a49dfd829c8a7a2($2 | 0, HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    if ((HEAP32[$2 >> 2] | 0 | 0) != (1 | 0)) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $2 + 16 | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__UnitInterval_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h5f35d1d54299ac98($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $2 = 0, $3 = 0, $3$hi = 0, $22 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__he31b94e8dd616f49($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $3 = i64toi32_i32$0;
  $3$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[($1 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 24 | 0, 8 | 0);
  $22 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $22;
  HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $3$hi;
  HEAP32[i64toi32_i32$1 >> 2] = $3;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 16 | 0;
 }
 
 function poolparams_margin($0) {
  $0 = $0 | 0;
  var i64toi32_i32$0 = 0, $1 = 0, i64toi32_i32$1 = 0, $2$hi = 0, $3$hi = 0, $2 = 0, $25 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hc466bac66f8af18e($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($0 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($0 + 20 | 0) >> 2] | 0;
  $2 = i64toi32_i32$0;
  $2$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[($0 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($0 + 28 | 0) >> 2] | 0;
  $3$hi = i64toi32_i32$0;
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$0 = $2$hi;
  i64toi32_i32$0 = $3$hi;
  $25 = i64toi32_i32$1;
  i64toi32_i32$0 = $2$hi;
  i64toi32_i32$1 = $3$hi;
  $0 = $cardano_serialization_lib__UnitInterval_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he6b97f3f09608ed8($2 | 0, i64toi32_i32$0 | 0, $25 | 0, i64toi32_i32$1 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function core__ptr__drop_in_place_hashbrown__scopeguard__ScopeGuard_hashbrown__raw__RawTableInner_alloc__alloc__Global__2chashbrown__raw__RawTableInner_alloc__alloc__Global___prepare_resize___7b_7bclosure_7d_7d____hf09be25679474fda($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $2 = 0, $3 = 0, $13$hi = 0, $16$hi = 0, $8 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $2 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   i64toi32_i32$0 = HEAP32[$0 >> 2] | 0;
   i64toi32_i32$1 = 0;
   $13$hi = i64toi32_i32$1;
   i64toi32_i32$1 = 0;
   $16$hi = i64toi32_i32$1;
   i64toi32_i32$1 = $13$hi;
   $8 = i64toi32_i32$0;
   i64toi32_i32$0 = $16$hi;
   i64toi32_i32$0 = __wasm_i64_mul($8 | 0, i64toi32_i32$1 | 0, $1 + 1 | 0 | 0, i64toi32_i32$0 | 0) | 0;
   i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
   $3 = (($2 + i64toi32_i32$0 | 0) + -1 | 0) & (0 - $2 | 0) | 0;
   $1 = ($1 + $3 | 0) + 5 | 0;
   if (!$1) {
    break label$1
   }
   __rust_dealloc((HEAP32[($0 + 12 | 0) >> 2] | 0) - $3 | 0 | 0, $1 | 0, $2 | 0);
  }
 }
 
 function cardano_serialization_lib__chain_crypto__sign___impl_20cardano_serialization_lib__chain_crypto__key__SecretKey_A____sign__h00427a3a04db3396($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0;
  $3 = global$0 - 80 | 0;
  global$0 = $3;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $2 | 0);
  $2 = HEAP32[($3 + 12 | 0) >> 2] | 0;
  $4 = HEAP32[($3 + 8 | 0) >> 2] | 0;
  memset($3 + 16 | 0 | 0, 0 | 0, 64 | 0) | 0;
  core__slice___impl_20_5bT_5d___clone_from_slice__h1742dfbd5d5d9efd($3 + 16 | 0 | 0, 64 | 0, $1 | 0, 64 | 0);
  cryptoxide__ed25519__signature_extended__h26f216ae968c9eed($0 | 0, $4 | 0, $2 | 0, $3 + 16 | 0 | 0);
  global$0 = $3 + 80 | 0;
 }
 
 function $cardano_serialization_lib__fees__LinearFee_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h59d19303ba276534($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $2 = 0, $3 = 0, $3$hi = 0, $22 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hcc20539835b5bb39($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $3 = i64toi32_i32$0;
  $3$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[($1 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 24 | 0, 8 | 0);
  $22 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $22;
  HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $3$hi;
  HEAP32[i64toi32_i32$1 >> 2] = $3;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 16 | 0;
 }
 
 function $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__hf249498970160004($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    label$3 : {
     if (!(alloc__collections__btree__map__BTreeMap_K_2cV___len__h9902d4fb7515c681($1 | 0) | 0)) {
      break label$3
     }
     if (!(HEAP32[($1 + 4 | 0) >> 2] | 0)) {
      break label$1
     }
     alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType___reborrow__h3203744247f22569($2 + 8 | 0 | 0, $1 | 0);
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__clone_subtree__h13f26fe92cdbb434($0 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
     break label$2;
    }
    HEAP32[($0 + 4 | 0) >> 2] = 0;
    HEAP32[($0 + 8 | 0) >> 2] = 0;
   }
   global$0 = $2 + 16 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1067386 | 0, 43 | 0, 1067908 | 0);
  abort();
 }
 
 function $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__next_or_end__h0bbd2a4d146075f9($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    if ($3) {
     break label$2
    }
    HEAP32[($2 + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    HEAP32[$2 >> 2] = HEAP32[$1 >> 2] | 0;
    HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$1;
    alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_end__h790df841eabd6eb8($2 | 0);
    HEAP32[($0 + 4 | 0) >> 2] = 0;
    break label$1;
   }
   HEAP32[($1 + 12 | 0) >> 2] = $3 + -1 | 0;
   alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next_unchecked__he1ff1347c7a67a8c($0 | 0, $1 | 0);
  }
  global$0 = $2 + 16 | 0;
 }
 
 function $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__next_or_end__h0feb06ef3fdff9f5($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    if ($3) {
     break label$2
    }
    HEAP32[($2 + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    HEAP32[$2 >> 2] = HEAP32[$1 >> 2] | 0;
    HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$1;
    alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_end__h44cd246d9b42f204($2 | 0);
    HEAP32[($0 + 4 | 0) >> 2] = 0;
    break label$1;
   }
   HEAP32[($1 + 12 | 0) >> 2] = $3 + -1 | 0;
   alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next_unchecked__hf1f377269bbabf11($0 | 0, $1 | 0);
  }
  global$0 = $2 + 16 | 0;
 }
 
 function $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__next_or_end__h3585c07afb489475($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    if ($3) {
     break label$2
    }
    HEAP32[($2 + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    HEAP32[$2 >> 2] = HEAP32[$1 >> 2] | 0;
    HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$1;
    alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_end__h7ac41c9387518bdc($2 | 0);
    HEAP32[($0 + 4 | 0) >> 2] = 0;
    break label$1;
   }
   HEAP32[($1 + 12 | 0) >> 2] = $3 + -1 | 0;
   alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next_unchecked__h5e1ce7ff4b058b50($0 | 0, $1 | 0);
  }
  global$0 = $2 + 16 | 0;
 }
 
 function $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__next_or_end__h5c37448f9f4faa59($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    if ($3) {
     break label$2
    }
    HEAP32[($2 + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    HEAP32[$2 >> 2] = HEAP32[$1 >> 2] | 0;
    HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$1;
    alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_end__h15730bdff0d297bb($2 | 0);
    HEAP32[($0 + 4 | 0) >> 2] = 0;
    break label$1;
   }
   HEAP32[($1 + 12 | 0) >> 2] = $3 + -1 | 0;
   alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next_unchecked__h6b52d79e857351fc($0 | 0, $1 | 0);
  }
  global$0 = $2 + 16 | 0;
 }
 
 function $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__next_or_end__h8f308bd6ff82c5de($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    if ($3) {
     break label$2
    }
    HEAP32[($2 + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    HEAP32[$2 >> 2] = HEAP32[$1 >> 2] | 0;
    HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$1;
    alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_end__hac5e9ece4d257bcc($2 | 0);
    HEAP32[($0 + 4 | 0) >> 2] = 0;
    break label$1;
   }
   HEAP32[($1 + 12 | 0) >> 2] = $3 + -1 | 0;
   alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next_unchecked__ha23488fe1f8687d2($0 | 0, $1 | 0);
  }
  global$0 = $2 + 16 | 0;
 }
 
 function $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__next_or_end__h91b22591aa945f46($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    if ($3) {
     break label$2
    }
    HEAP32[($2 + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    HEAP32[$2 >> 2] = HEAP32[$1 >> 2] | 0;
    HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$1;
    alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_end__hc1c221af8b4634e6($2 | 0);
    HEAP32[($0 + 4 | 0) >> 2] = 0;
    break label$1;
   }
   HEAP32[($1 + 12 | 0) >> 2] = $3 + -1 | 0;
   alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next_unchecked__h59e89313562fc348($0 | 0, $1 | 0);
  }
  global$0 = $2 + 16 | 0;
 }
 
 function $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__next_or_end__haeb0a9f36af8f317($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    if ($3) {
     break label$2
    }
    HEAP32[($2 + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    HEAP32[$2 >> 2] = HEAP32[$1 >> 2] | 0;
    HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$1;
    alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_end__h9f0e6d9903ac5e2d($2 | 0);
    HEAP32[($0 + 4 | 0) >> 2] = 0;
    break label$1;
   }
   HEAP32[($1 + 12 | 0) >> 2] = $3 + -1 | 0;
   alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next_unchecked__hf23e11a68049cb85($0 | 0, $1 | 0);
  }
  global$0 = $2 + 16 | 0;
 }
 
 function $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__next_or_end__hb2986415471d1607($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    if ($3) {
     break label$2
    }
    HEAP32[($2 + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    HEAP32[$2 >> 2] = HEAP32[$1 >> 2] | 0;
    HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$1;
    alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_end__hd9e8c7d413dbbfb4($2 | 0);
    HEAP32[($0 + 4 | 0) >> 2] = 0;
    break label$1;
   }
   HEAP32[($1 + 12 | 0) >> 2] = $3 + -1 | 0;
   alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next_unchecked__h92c0497bccfa2889($0 | 0, $1 | 0);
  }
  global$0 = $2 + 16 | 0;
 }
 
 function $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__next_or_end__hb5913db9acd4f9a9($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    if ($3) {
     break label$2
    }
    HEAP32[($2 + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    HEAP32[$2 >> 2] = HEAP32[$1 >> 2] | 0;
    HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$1;
    alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_end__ha96e9d629fd4be4f($2 | 0);
    HEAP32[($0 + 4 | 0) >> 2] = 0;
    break label$1;
   }
   HEAP32[($1 + 12 | 0) >> 2] = $3 + -1 | 0;
   alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next_unchecked__h7492034f6287f1a2($0 | 0, $1 | 0);
  }
  global$0 = $2 + 16 | 0;
 }
 
 function $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__next_or_end__hca2a966750cf638e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    if ($3) {
     break label$2
    }
    HEAP32[($2 + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    HEAP32[$2 >> 2] = HEAP32[$1 >> 2] | 0;
    HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$1;
    alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_end__hbf6fe661aa5b2d49($2 | 0);
    HEAP32[($0 + 4 | 0) >> 2] = 0;
    break label$1;
   }
   HEAP32[($1 + 12 | 0) >> 2] = $3 + -1 | 0;
   alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next_unchecked__h8cb7963d986f8ec1($0 | 0, $1 | 0);
  }
  global$0 = $2 + 16 | 0;
 }
 
 function $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__next_or_end__hf4cf31cdff93ec77($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    if ($3) {
     break label$2
    }
    HEAP32[($2 + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    HEAP32[$2 >> 2] = HEAP32[$1 >> 2] | 0;
    HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$1;
    alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_end__h994fb02303f9a4bc($2 | 0);
    HEAP32[($0 + 4 | 0) >> 2] = 0;
    break label$1;
   }
   HEAP32[($1 + 12 | 0) >> 2] = $3 + -1 | 0;
   alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next_unchecked__ha621262545c111a1($0 | 0, $1 | 0);
  }
  global$0 = $2 + 16 | 0;
 }
 
 function $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__next_or_end__hf96b0f69fdd084ea($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    if ($3) {
     break label$2
    }
    HEAP32[($2 + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    HEAP32[$2 >> 2] = HEAP32[$1 >> 2] | 0;
    HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$1;
    alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_end__hd78561ccab159031($2 | 0);
    HEAP32[($0 + 4 | 0) >> 2] = 0;
    break label$1;
   }
   HEAP32[($1 + 12 | 0) >> 2] = $3 + -1 | 0;
   alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next_unchecked__h6c9193d27088bb22($0 | 0, $1 | 0);
  }
  global$0 = $2 + 16 | 0;
 }
 
 function $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__next_or_end__hfa088ac4e38a1cd5($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    if ($3) {
     break label$2
    }
    HEAP32[($2 + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    HEAP32[$2 >> 2] = HEAP32[$1 >> 2] | 0;
    HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$1;
    alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_end__h96916ab1c061eddf($2 | 0);
    HEAP32[($0 + 4 | 0) >> 2] = 0;
    break label$1;
   }
   HEAP32[($1 + 12 | 0) >> 2] = $3 + -1 | 0;
   alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next_unchecked__h1fe8f7644bb12cc0($0 | 0, $1 | 0);
  }
  global$0 = $2 + 16 | 0;
 }
 
 function $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__ha997f3ce18a23f3f($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__next_or_end__h0feb06ef3fdff9f5($1 | 0, $0 | 0);
  label$1 : {
   $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   if (!$2) {
    break label$1
   }
   label$2 : while (1) {
    label$3 : {
     $2 = $2 + Math_imul(HEAP32[($1 + 8 | 0) >> 2] | 0, 96) | 0;
     if (!(HEAP32[($2 + 8 | 0) >> 2] | 0)) {
      break label$3
     }
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($2 + 12 | 0 | 0);
    }
    $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__next_or_end__h0feb06ef3fdff9f5($1 | 0, $0 | 0);
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if ($2) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $1 + 16 | 0;
 }
 
 function $cardano_serialization_lib__address__NetworkInfo_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h79e98087973745ca($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h0dac3591c8fddd86($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $4 = HEAPU8[($1 + 8 | 0) >> 0] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 12 | 0, 4 | 0);
  HEAP8[($0 + 4 | 0) >> 0] = $4;
  HEAP32[$0 >> 2] = $3;
  global$0 = $2 + 16 | 0;
 }
 
 function exunitprices_mem_price($0) {
  $0 = $0 | 0;
  var i64toi32_i32$0 = 0, $1 = 0, i64toi32_i32$1 = 0, $2$hi = 0, $3$hi = 0, $2 = 0, $25 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h0a3b5f1cc5dc7523($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[$0 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $2 = i64toi32_i32$0;
  $2$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($0 + 12 | 0) >> 2] | 0;
  $3$hi = i64toi32_i32$0;
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$0 = $2$hi;
  i64toi32_i32$0 = $3$hi;
  $25 = i64toi32_i32$1;
  i64toi32_i32$0 = $2$hi;
  i64toi32_i32$1 = $3$hi;
  $0 = $cardano_serialization_lib__UnitInterval_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he6b97f3f09608ed8($2 | 0, i64toi32_i32$0 | 0, $25 | 0, i64toi32_i32$1 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function exunitprices_step_price($0) {
  $0 = $0 | 0;
  var i64toi32_i32$0 = 0, $1 = 0, i64toi32_i32$1 = 0, $2$hi = 0, $3$hi = 0, $2 = 0, $25 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h0a3b5f1cc5dc7523($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($0 + 16 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($0 + 20 | 0) >> 2] | 0;
  $2 = i64toi32_i32$0;
  $2$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[($0 + 24 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($0 + 28 | 0) >> 2] | 0;
  $3$hi = i64toi32_i32$0;
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$0 = $2$hi;
  i64toi32_i32$0 = $3$hi;
  $25 = i64toi32_i32$1;
  i64toi32_i32$0 = $2$hi;
  i64toi32_i32$1 = $3$hi;
  $0 = $cardano_serialization_lib__UnitInterval_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he6b97f3f09608ed8($2 | 0, i64toi32_i32$0 | 0, $25 | 0, i64toi32_i32$1 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__plutus__ExUnits_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hee7fe190ca5421e8($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $2 = 0, $3 = 0, $3$hi = 0, $22 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h29efc310563dc83c($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $3 = i64toi32_i32$0;
  $3$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[($1 + 16 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($1 + 20 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 24 | 0, 8 | 0);
  $22 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $22;
  HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $3$hi;
  HEAP32[i64toi32_i32$1 >> 2] = $3;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  global$0 = $2 + 16 | 0;
 }
 
 function redeemer_ex_units($0) {
  $0 = $0 | 0;
  var i64toi32_i32$0 = 0, $1 = 0, i64toi32_i32$1 = 0, $2$hi = 0, $3$hi = 0, $2 = 0, $25 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h388263144730eb6a($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($0 + 56 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($0 + 60 | 0) >> 2] | 0;
  $2 = i64toi32_i32$0;
  $2$hi = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[($0 + 64 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($0 + 68 | 0) >> 2] | 0;
  $3$hi = i64toi32_i32$0;
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  i64toi32_i32$0 = $2$hi;
  i64toi32_i32$0 = $3$hi;
  $25 = i64toi32_i32$1;
  i64toi32_i32$0 = $2$hi;
  i64toi32_i32$1 = $3$hi;
  $0 = $cardano_serialization_lib__plutus__ExUnits_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h4867c49ddc624134($2 | 0, i64toi32_i32$0 | 0, $25 | 0, i64toi32_i32$1 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function __wbg_redeemers_free($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__plutus__Redeemers_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h084b0da55ab35e33($1 | 0, $0 | 0);
  label$1 : {
   $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   if (!$0) {
    break label$1
   }
   $2 = Math_imul($0, 80);
   $0 = (HEAP32[$1 >> 2] | 0) + 8 | 0;
   label$2 : while (1) {
    core__ptr__drop_in_place_cardano_serialization_lib__plutus__PlutusData___hfab843e66e0f9428_2($0 | 0);
    $0 = $0 + 80 | 0;
    $2 = $2 + -80 | 0;
    if ($2) {
     continue label$2
    }
    break label$2;
   };
  }
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h4c688d2d7e8a61fa($1 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function js_sys__Uint8Array__copy_to__h427146d9baad4940($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0;
  $3 = global$0 - 32 | 0;
  global$0 = $3;
  $4 = js_sys__Uint8Array__length____wbg_length_2d56cb37075fcfb1__h284dd29f7015605d(HEAP32[$0 >> 2] | 0 | 0) | 0;
  HEAP32[$3 >> 2] = $4;
  HEAP32[($3 + 4 | 0) >> 2] = $2;
  label$1 : {
   if (($4 | 0) != ($2 | 0)) {
    break label$1
   }
   js_sys__Uint8Array__raw_copy_to__h874a0eadd71a9314($0 | 0, $1 | 0);
   global$0 = $3 + 32 | 0;
   return;
  }
  HEAP32[($3 + 8 | 0) >> 2] = 0;
  core__panicking__assert_failed__h797398ab1bf2772c(0 | 0, $3 | 0, $3 + 4 | 0 | 0, $3 + 8 | 0 | 0, 1076172 | 0);
  abort();
 }
 
 function $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__next_or_end__h4700cd2d9ab1e572($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
    if ($3) {
     break label$2
    }
    HEAP32[($2 + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
    i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    HEAP32[$2 >> 2] = HEAP32[$1 >> 2] | 0;
    HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$1;
    alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_end__h41f43c368b12dfff($2 | 0);
    HEAP32[($0 + 4 | 0) >> 2] = 0;
    break label$1;
   }
   HEAP32[($1 + 12 | 0) >> 2] = $3 + -1 | 0;
   alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_next_unchecked__h1b1b91bd6bd0f0ea($0 | 0, $1 | 0);
  }
  global$0 = $2 + 16 | 0;
 }
 
 function $_5bT_5d_20as_20core__fmt__Debug___fmt__hf0dfc49f672cf2ca($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $9 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  i64toi32_i32$0 = core__fmt__Formatter__debug_list__h7939d45dcba19956($2 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $9 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[$3 >> 2] = $9;
  HEAP32[($3 + 4 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   if (!$1) {
    break label$1
   }
   label$2 : while (1) {
    HEAP32[($3 + 12 | 0) >> 2] = $0;
    core__fmt__builders__DebugSet__entry__he7b13b90636ac2b8($3 | 0, $3 + 12 | 0 | 0, 1100508 | 0) | 0;
    $0 = $0 + 1 | 0;
    $1 = $1 + -1 | 0;
    if ($1) {
     continue label$2
    }
    break label$2;
   };
  }
  $0 = core__fmt__builders__DebugList__finish__h372f90da800e1030($3 | 0) | 0;
  global$0 = $3 + 16 | 0;
  return $0 | 0;
 }
 
 function $_5bT_5d_20as_20core__fmt__Debug___fmt__h83014c73d1c7e7bd($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $9 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  i64toi32_i32$0 = core__fmt__Formatter__debug_list__h7939d45dcba19956($2 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $9 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[$3 >> 2] = $9;
  HEAP32[($3 + 4 | 0) >> 2] = i64toi32_i32$1;
  label$1 : {
   if (!$1) {
    break label$1
   }
   label$2 : while (1) {
    HEAP32[($3 + 12 | 0) >> 2] = $0;
    core__fmt__builders__DebugSet__entry__he7b13b90636ac2b8($3 | 0, $3 + 12 | 0 | 0, 1140096 | 0) | 0;
    $0 = $0 + 1 | 0;
    $1 = $1 + -1 | 0;
    if ($1) {
     continue label$2
    }
    break label$2;
   };
  }
  $0 = core__fmt__builders__DebugList__finish__h372f90da800e1030($3 | 0) | 0;
  global$0 = $3 + 16 | 0;
  return $0 | 0;
 }
 
 function alloc__sync__Arc_T___drop_slow__h1342fde892a03e74($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 16 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   HEAP8[$1 >> 0] = 0;
   $1 = HEAP32[($0 + 20 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   __rust_dealloc(HEAP32[($0 + 16 | 0) >> 2] | 0 | 0, $1 | 0, 1 | 0);
  }
  label$2 : {
   if (($0 | 0) == (-1 | 0)) {
    break label$2
   }
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1 + -1 | 0;
   if (($1 | 0) != (1 | 0)) {
    break label$2
   }
   __rust_dealloc($0 | 0, 32 | 0, 8 | 0);
  }
 }
 
 function core__option__expect_failed__h66afff61e82fdd86($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  HEAP32[($3 + 12 | 0) >> 2] = $1;
  HEAP32[($3 + 8 | 0) >> 2] = $0;
  HEAP32[($3 + 36 | 0) >> 2] = 1;
  HEAP32[($3 + 20 | 0) >> 2] = 1;
  HEAP32[($3 + 24 | 0) >> 2] = 0;
  HEAP32[($3 + 16 | 0) >> 2] = 1149504;
  HEAP32[($3 + 44 | 0) >> 2] = 328;
  HEAP32[($3 + 32 | 0) >> 2] = $3 + 40 | 0;
  HEAP32[($3 + 40 | 0) >> 2] = $3 + 8 | 0;
  core__panicking__panic_fmt__hbf21a3d4bbb82bf8($3 + 16 | 0 | 0, $2 | 0);
  abort();
 }
 
 function cardano_serialization_lib__TransactionBody__set_mint__h88098ad1b8ae4466($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $18 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h3d696390b8f8d3c9($2 + 4 | 0 | 0, $1 | 0);
  label$1 : {
   if (!(HEAP32[($0 + 164 | 0) >> 2] | 0)) {
    break label$1
   }
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h3981a4152bf24dd0($0 + 168 | 0 | 0);
  }
  HEAP32[($0 + 164 | 0) >> 2] = 1;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 168 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($0 + 176 | 0) >> 2] = HEAP32[($2 + 12 | 0) >> 2] | 0;
  global$0 = $2 + 16 | 0;
 }
 
 function singlehostaddr_port($0) {
  $0 = $0 | 0;
  var $1 = 0, $3 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h7fe2cd68d7de412a($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $2 = HEAPU16[$0 >> 1] | 0;
  $0 = HEAPU16[($0 + 2 | 0) >> 1] | 0;
  $3 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, (HEAP32[$3 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return ($2 ? $0 : 16777215) | 0;
 }
 
 function __wbg_nativescript_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 32 | 0;
  global$0 = $1;
  $cardano_serialization_lib__NativeScript_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h5737abd968aea6f3($1 | 0, $0 | 0);
  label$1 : {
   label$2 : {
    label$3 : {
     switch ((HEAPU8[$1 >> 0] | 0) + -1 | 0 | 0) {
     case 0:
      $0 = $1 | 4 | 0;
      break label$2;
     case 1:
      $0 = $1 | 4 | 0;
      break label$2;
     case 2:
      break label$3;
     default:
      break label$1;
     };
    }
    $0 = $1 + 8 | 0;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc3d6ec99c05cee40($0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h0f78886c344617d4($0 | 0);
  }
  global$0 = $1 + 32 | 0;
 }
 
 function cardano_serialization_lib__ProtocolParamUpdate__set_cost_models__h7c39ece06d921b8b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $18 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h663a668224e1772a($2 + 4 | 0 | 0, $1 | 0);
  label$1 : {
   if (!(HEAP32[($0 + 332 | 0) >> 2] | 0)) {
    break label$1
   }
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h5f5dc70d320637e0($0 + 336 | 0 | 0);
  }
  HEAP32[($0 + 332 | 0) >> 2] = 1;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 336 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($0 + 344 | 0) >> 2] = HEAP32[($2 + 12 | 0) >> 2] | 0;
  global$0 = $2 + 16 | 0;
 }
 
 function cardano_serialization_lib__utils__BigNum__to_str__h5b9769c85af10e21($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $15 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  core__fmt__ArgumentV1__new__h021aa801e74cb4b6($2 + 8 | 0 | 0, $1 | 0, 20 | 0);
  HEAP32[($2 + 36 | 0) >> 2] = 1;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 20 | 0) >> 2] = 1;
  HEAP32[($2 + 24 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($2 + 16 | 0) >> 2] = 1058724;
  i64toi32_i32$0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 40 | 0) >> 2] = $15;
  HEAP32[($2 + 44 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($2 + 32 | 0) >> 2] = $2 + 40 | 0;
  alloc__fmt__format__h6e9e003a52c07309($0 | 0, $2 + 16 | 0 | 0);
  global$0 = $2 + 48 | 0;
 }
 
 function cardano_serialization_lib__utils__Value__set_multiasset__hcffccef3fc1cfd59($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $18 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($2 + 4 | 0 | 0, $1 | 0);
  label$1 : {
   if (!(HEAP32[($0 + 8 | 0) >> 2] | 0)) {
    break label$1
   }
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($0 + 12 | 0 | 0);
  }
  HEAP32[($0 + 8 | 0) >> 2] = 1;
  i64toi32_i32$0 = HEAP32[($2 + 4 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 12 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $18;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($0 + 20 | 0) >> 2] = HEAP32[($2 + 12 | 0) >> 2] | 0;
  global$0 = $2 + 16 | 0;
 }
 
 function int_is_positive($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$4 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $7 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h8f4f32b29a620a40($1 + 8 | 0 | 0, $0 | 0);
  i64toi32_i32$2 = (HEAP32[($1 + 8 | 0) >> 2] | 0) + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 63;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $7 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   $7 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  return $7 ^ 1 | 0 | 0;
 }
 
 function hex__encode_to_iter__h3b9b5dcb85c2c5cd($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, $20 = 0, $23 = 0;
  $4 = global$0 - 32 | 0;
  global$0 = $4;
  hex__BytesToHexChars__new__hd2404227bb55ee67($4 | 0, $2 | 0, $3 | 0, $1 | 0);
  i64toi32_i32$1 = $0;
  i64toi32_i32$0 = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[i64toi32_i32$1 >> 2] = HEAP32[(0 + 1055984 | 0) >> 2] | 0;
  i64toi32_i32$2 = $4 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $20 = i64toi32_i32$0;
  i64toi32_i32$0 = ($4 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $20;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = HEAP32[$4 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($4 + 4 | 0) >> 2] | 0;
  $23 = i64toi32_i32$1;
  i64toi32_i32$1 = $4;
  HEAP32[($4 + 16 | 0) >> 2] = $23;
  HEAP32[($4 + 20 | 0) >> 2] = i64toi32_i32$0;
  $alloc__string__String_20as_20core__iter__traits__collect__Extend_char____extend__h1cb79188832adf99($0 | 0, $4 + 16 | 0 | 0);
  global$0 = $4 + 32 | 0;
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hd36b5d149e6fd98b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $4 = 0, $3 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $3 = HEAP32[$1 >> 2] | 0;
  $1 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__hb0817f92bbb8999a($2 + 8 | 0 | 0, $1 | 0, 0 | 0);
  $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($2 + 12 | 0) >> 2] | 0;
  HEAP32[$0 >> 2] = $4;
  memcpy($4 | 0, $3 | 0, $1 << 2 | 0 | 0) | 0;
  HEAP32[($0 + 8 | 0) >> 2] = $1;
  global$0 = $2 + 16 | 0;
 }
 
 function core__array___impl_20core__convert__TryFrom___5bT_5d__20for_20_5bT_3b_20N_5d___try_from__h6b307791003c682f($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $11 = 0, $12 = 0, $14 = 0, $15 = 0, $3 = 0, $8 = 0, $13 = 0, $18 = 0, $23 = 0;
  $3 = 1;
  label$1 : {
   if (($2 | 0) != (32 | 0)) {
    break label$1
   }
   i64toi32_i32$2 = $1;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $8 = i64toi32_i32$0;
   i64toi32_i32$0 = $0;
   $11 = $8;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $11;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $11 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $11 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = $11 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 8 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = i64toi32_i32$2 + 24 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $13 = i64toi32_i32$1;
   i64toi32_i32$1 = $0 + 25 | 0;
   $12 = $13;
   HEAP8[i64toi32_i32$1 >> 0] = $12;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $12 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $12 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $12 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   i64toi32_i32$2 = $1 + 16 | 0;
   i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $18 = i64toi32_i32$0;
   i64toi32_i32$0 = $0 + 17 | 0;
   $14 = $18;
   HEAP8[i64toi32_i32$0 >> 0] = $14;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $14 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $14 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $14 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$2 = $1 + 8 | 0;
   i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   $23 = i64toi32_i32$1;
   i64toi32_i32$1 = $0 + 9 | 0;
   $15 = $23;
   HEAP8[i64toi32_i32$1 >> 0] = $15;
   HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $15 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $15 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $15 >>> 24 | 0;
   HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = i64toi32_i32$0;
   HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = i64toi32_i32$0 >>> 8 | 0;
   HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = i64toi32_i32$0 >>> 16 | 0;
   HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = i64toi32_i32$0 >>> 24 | 0;
   $3 = 0;
  }
  HEAP8[$0 >> 0] = $3;
 }
 
 function $std__ffi__c_str__NulError_20as_20core__fmt__Debug___fmt__h0a1850afe00eee75($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1144399 | 0, 8 | 0);
  HEAP32[($2 + 12 | 0) >> 2] = $0;
  core__fmt__builders__DebugTuple__field__h5e7e3e19ad5aa557($2 | 0, $2 + 12 | 0 | 0, 1142612 | 0) | 0;
  HEAP32[($2 + 12 | 0) >> 2] = $0 + 4 | 0;
  core__fmt__builders__DebugTuple__field__h5e7e3e19ad5aa557($2 | 0, $2 + 12 | 0 | 0, 1144408 | 0) | 0;
  $0 = core__fmt__builders__DebugTuple__finish__hc3c3f1efaa75a6e2($2 | 0) | 0;
  global$0 = $2 + 16 | 0;
  return $0 | 0;
 }
 
 function __wbg_transactionoutputs_free($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__TransactionOutputs_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h9d1c1bfec732029a($1 | 0, $0 | 0);
  label$1 : {
   $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   if (!$2) {
    break label$1
   }
   $0 = HEAP32[$1 >> 2] | 0;
   $2 = $2 << 7 | 0;
   label$2 : while (1) {
    core__ptr__drop_in_place_cardano_serialization_lib__TransactionOutput___h632b3a99817e6ac5_1($0 | 0);
    $0 = $0 + 128 | 0;
    $2 = $2 + -128 | 0;
    if ($2) {
     continue label$2
    }
    break label$2;
   };
  }
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h5107e2b13c386680($1 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function cardano_serialization_lib__ProtocolVersions__add__h22b1e76c158cef25($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $3 = HEAP32[$1 >> 2] | 0;
  label$1 : {
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (($1 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
    break label$1
   }
   alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hb28826101b6ca67b($0 | 0, $1 | 0, 1 | 0);
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  }
  $1 = (HEAP32[$0 >> 2] | 0) + ($1 << 3 | 0) | 0;
  HEAP32[($1 + 4 | 0) >> 2] = $2;
  HEAP32[$1 >> 2] = $3;
  HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
 }
 
 function __wbg_transactionunspentoutputs_free($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__utils__TransactionUnspentOutputs_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hf063c6518397141d($1 | 0, $0 | 0);
  label$1 : {
   $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   if (!$2) {
    break label$1
   }
   $0 = HEAP32[$1 >> 2] | 0;
   $2 = Math_imul($2, 168);
   label$2 : while (1) {
    core__ptr__drop_in_place_cardano_serialization_lib__TransactionOutput___h632b3a99817e6ac5_1($0 | 0);
    $0 = $0 + 168 | 0;
    $2 = $2 + -168 | 0;
    if ($2) {
     continue label$2
    }
    break label$2;
   };
  }
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h48e03889c2b030fa($1 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function $_5bA_5d_20as_20core__slice__cmp__SlicePartialEq_B____equal__hf5046e4900ef6969($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0, $5 = 0;
  $4 = 0;
  label$1 : {
   if (($1 | 0) != ($3 | 0)) {
    break label$1
   }
   $4 = 0;
   label$2 : {
    label$3 : while (1) {
     $3 = $4;
     if (($1 | 0) == ($3 | 0)) {
      break label$2
     }
     $4 = $3 + 1 | 0;
     $5 = $cardano_serialization_lib__metadata__TransactionMetadatumEnum_20as_20core__cmp__PartialEq___eq__h1b9ad18ad9a7fd9d($0 | 0, $2 | 0) | 0;
     $0 = $0 + 48 | 0;
     $2 = $2 + 48 | 0;
     if ($5) {
      continue label$3
     }
     break label$3;
    };
   }
   $4 = $3 >>> 0 >= $1 >>> 0;
  }
  return $4 | 0;
 }
 
 function __wbg_metadatalist_free($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__metadata__MetadataList_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hbc03d780ecbefcca($1 | 0, $0 | 0);
  label$1 : {
   $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   if (!$2) {
    break label$1
   }
   $0 = HEAP32[$1 >> 2] | 0;
   $2 = Math_imul($2, 48);
   label$2 : while (1) {
    core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatum___headd2d1b596252cc_2($0 | 0);
    $0 = $0 + 48 | 0;
    $2 = $2 + -48 | 0;
    if ($2) {
     continue label$2
    }
    break label$2;
   };
  }
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h81b8a37e31f2de30($1 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function core__ptr__drop_in_place_cardano_serialization_lib__metadata__AuxiliaryData___hdde6d009d300f71d($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   if (!(HEAP32[($0 + 20 | 0) >> 2] | 0)) {
    break label$1
   }
   $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__he275f3eb7df08493($0 | 0);
   if (!(HEAP32[($0 + 16 | 0) >> 2] | 0)) {
    break label$1
   }
   hashbrown__raw__RawTable_T_2cA___free_buckets__hfa29170569415d6b($0 + 16 | 0 | 0);
  }
  label$2 : {
   if (!(HEAP32[($0 + 40 | 0) >> 2] | 0)) {
    break label$2
   }
   $1 = $0 + 40 | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc3d6ec99c05cee40($1 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h0f78886c344617d4($1 | 0);
  }
  label$3 : {
   if (!(HEAP32[($0 + 52 | 0) >> 2] | 0)) {
    break label$3
   }
   $0 = $0 + 52 | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd4b44cb226d8311d($0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h3633100df9c96e1e($0 | 0);
  }
 }
 
 function transactionbuilderconfigbuilder_new() {
  var $0 = 0, i64toi32_i32$0 = 0, $1 = 0;
  $0 = global$0 - 144 | 0;
  global$0 = $0;
  HEAP8[($0 + 136 | 0) >> 0] = 0;
  HEAP32[($0 + 128 | 0) >> 2] = 0;
  HEAP32[($0 + 120 | 0) >> 2] = 0;
  i64toi32_i32$0 = 0;
  HEAP32[($0 + 80 | 0) >> 2] = 0;
  HEAP32[($0 + 84 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  HEAP32[($0 + 64 | 0) >> 2] = 0;
  HEAP32[($0 + 68 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  HEAP32[($0 + 48 | 0) >> 2] = 0;
  HEAP32[($0 + 52 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  HEAP32[($0 + 32 | 0) >> 2] = 0;
  HEAP32[($0 + 36 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[($0 + 12 | 0) >> 2] = i64toi32_i32$0;
  $1 = $cardano_serialization_lib__tx_builder__TransactionBuilderConfigBuilder_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h65182e4c6d5621d4($0 + 8 | 0 | 0) | 0;
  global$0 = $0 + 144 | 0;
  return $1 | 0;
 }
 
 function std__thread__local__LocalKey_T___with__h4cd07b14a44a727e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$5 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $13 = 0, $3 = 0, $3$hi = 0, $20 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   $1 = FUNCTION_TABLE[HEAP32[$1 >> 2] | 0 | 0]() | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__h03d182df15dd7aa6();
   core__result__unwrap_failed__h27f43d993c3864a1(1068522 | 0, 70 | 0, $2 + 8 | 0 | 0, 1068964 | 0, 1068672 | 0);
   abort();
  }
  $13 = $1;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $3 = i64toi32_i32$0;
  $3$hi = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 1;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  i64toi32_i32$2 = $13;
  HEAP32[i64toi32_i32$2 >> 2] = i64toi32_i32$4;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$5;
  i64toi32_i32$1 = $1;
  i64toi32_i32$5 = HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] | 0;
  $20 = i64toi32_i32$5;
  i64toi32_i32$5 = $0;
  HEAP32[(i64toi32_i32$5 + 8 | 0) >> 2] = $20;
  HEAP32[(i64toi32_i32$5 + 12 | 0) >> 2] = i64toi32_i32$2;
  i64toi32_i32$2 = $3$hi;
  HEAP32[i64toi32_i32$5 >> 2] = $3;
  HEAP32[(i64toi32_i32$5 + 4 | 0) >> 2] = i64toi32_i32$2;
  global$0 = $2 + 16 | 0;
 }
 
 function __wbg_plutuslist_free($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__plutus__PlutusList_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h152fda99fe0d4350($1 | 0, $0 | 0);
  label$1 : {
   $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   if (!$2) {
    break label$1
   }
   $0 = HEAP32[$1 >> 2] | 0;
   $2 = Math_imul($2, 48);
   label$2 : while (1) {
    core__ptr__drop_in_place_cardano_serialization_lib__plutus__PlutusData___hfab843e66e0f9428_2($0 | 0);
    $0 = $0 + 48 | 0;
    $2 = $2 + -48 | 0;
    if ($2) {
     continue label$2
    }
    break label$2;
   };
  }
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h36e817e704f6f25e($1 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function cbor_event__se__Serializer_W___write_bytes__h5e3534de30c993f9($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  (wasm2js_i32$0 = $3, wasm2js_i32$1 = cbor_event__types__Type__to_byte__h30363627277739c1(2 | 0, 24 | 0) | 0), HEAP8[(wasm2js_i32$0 + 15 | 0) >> 0] = wasm2js_i32$1;
  alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($1 | 0, $3 + 15 | 0 | 0, 1 | 0);
  HEAP8[($3 + 15 | 0) >> 0] = 28;
  alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($1 | 0, $3 + 15 | 0 | 0, 1 | 0);
  alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($1 | 0, $2 | 0, 28 | 0);
  HEAP32[$0 >> 2] = 0;
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  global$0 = $3 + 16 | 0;
 }
 
 function cbor_event__se__Serializer_W___write_bytes__h85f4434ac9a8a060($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  (wasm2js_i32$0 = $3, wasm2js_i32$1 = cbor_event__types__Type__to_byte__h30363627277739c1(2 | 0, 24 | 0) | 0), HEAP8[(wasm2js_i32$0 + 15 | 0) >> 0] = wasm2js_i32$1;
  alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($1 | 0, $3 + 15 | 0 | 0, 1 | 0);
  HEAP8[($3 + 15 | 0) >> 0] = 32;
  alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($1 | 0, $3 + 15 | 0 | 0, 1 | 0);
  alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($1 | 0, $2 | 0, 32 | 0);
  HEAP32[$0 >> 2] = 0;
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  global$0 = $3 + 16 | 0;
 }
 
 function $std__panicking__begin_panic__PanicPayload_A__20as_20core__panic__BoxMeUp___take_box__h0d941902bf061d86($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = HEAP32[$1 >> 2] | 0;
  HEAP32[$1 >> 2] = 0;
  label$1 : {
   label$2 : {
    if (!$2) {
     break label$2
    }
    $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $1 = __rust_alloc(8 | 0, 4 | 0) | 0;
    if (!$1) {
     break label$1
    }
    HEAP32[($1 + 4 | 0) >> 2] = $3;
    HEAP32[$1 >> 2] = $2;
    HEAP32[($0 + 4 | 0) >> 2] = 1077492;
    HEAP32[$0 >> 2] = $1;
    return;
   }
   std__process__abort__h4249b49a3db9128b();
   abort();
  }
  alloc__alloc__handle_alloc_error__he269d8f1bff90960(8 | 0, 4 | 0);
  abort();
 }
 
 function serde_json__error__Error__fix_position__hf643fce3239fdaa8($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if (!(HEAP32[($0 + 12 | 0) >> 2] | 0)) {
     break label$2
    }
    $1 = $0;
    break label$1;
   }
   HEAP32[($2 + 8 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   HEAP32[$2 >> 2] = HEAP32[$0 >> 2] | 0;
   HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$1;
   $1 = serde_json__de__Deserializer_R___error__h438ab94fbb97beef($1 | 0, $2 | 0) | 0;
   __rust_dealloc($0 | 0, 20 | 0, 4 | 0);
  }
  global$0 = $2 + 16 | 0;
  return $1 | 0;
 }
 
 function cryptoxide__hashing__blake2b__Context_____finalize_reset_at__h01b36216b7918c0c($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $5 = 0, $6 = 0;
  label$1 : {
   if (($2 | 0) != (2 | 0)) {
    break label$1
   }
   cryptoxide__hashing__blake2b__Context_____internal_final__hbf68fb987943c10c($0 | 0);
   $5 = $1;
   $6 = HEAPU16[($0 + 100 | 0) >> 1] | 0;
   HEAP8[$5 >> 0] = $6;
   HEAP8[($5 + 1 | 0) >> 0] = $6 >>> 8 | 0;
   $0 = memcpy($0 | 0, 1137368 | 0, 64 | 0) | 0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[($0 + 64 | 0) >> 2] = 0;
   HEAP32[($0 + 68 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 1779033703;
   HEAP32[$0 >> 2] = -222443254;
   HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$1 = $0 + 72 | 0;
   i64toi32_i32$0 = 0;
   HEAP32[i64toi32_i32$1 >> 2] = 0;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   memset($0 + 96 | 0 | 0, 0 | 0, 132 | 0) | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1136192 | 0, 47 | 0, 1136240 | 0);
  abort();
 }
 
 function cryptoxide__hashing__blake2b__Context_____finalize_reset_at__h2d8cd859e521b13a($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   if (($2 | 0) != (1 | 0)) {
    break label$1
   }
   cryptoxide__hashing__blake2b__Context_____internal_final__hf5df8da38cbfe370($0 | 0);
   HEAP8[$1 >> 0] = HEAPU8[($0 + 100 | 0) >> 0] | 0;
   $0 = memcpy($0 | 0, 1137368 | 0, 64 | 0) | 0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[($0 + 64 | 0) >> 2] = 0;
   HEAP32[($0 + 68 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 1779033703;
   HEAP32[$0 >> 2] = -222443255;
   HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$1 = $0 + 72 | 0;
   i64toi32_i32$0 = 0;
   HEAP32[i64toi32_i32$1 >> 2] = 0;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   memset($0 + 96 | 0 | 0, 0 | 0, 132 | 0) | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1136192 | 0, 47 | 0, 1136240 | 0);
  abort();
 }
 
 function cryptoxide__hashing__blake2b__Context_____finalize_reset_at__h65f876891ca9972a($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, $5 = 0, $6 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   if (($2 | 0) != (4 | 0)) {
    break label$1
   }
   cryptoxide__hashing__blake2b__Context_____internal_final__h735059caccf43fd5($0 | 0);
   $5 = $1;
   $6 = HEAP32[($0 + 100 | 0) >> 2] | 0;
   HEAP8[$5 >> 0] = $6;
   HEAP8[($5 + 1 | 0) >> 0] = $6 >>> 8 | 0;
   HEAP8[($5 + 2 | 0) >> 0] = $6 >>> 16 | 0;
   HEAP8[($5 + 3 | 0) >> 0] = $6 >>> 24 | 0;
   $0 = memcpy($0 | 0, 1137368 | 0, 64 | 0) | 0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 0;
   HEAP32[($0 + 64 | 0) >> 2] = 0;
   HEAP32[($0 + 68 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$1 = $0;
   i64toi32_i32$0 = 1779033703;
   HEAP32[$0 >> 2] = -222443252;
   HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$0;
   i64toi32_i32$1 = $0 + 72 | 0;
   i64toi32_i32$0 = 0;
   HEAP32[i64toi32_i32$1 >> 2] = 0;
   HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
   memset($0 + 96 | 0 | 0, 0 | 0, 132 | 0) | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1136192 | 0, 47 | 0, 1136240 | 0);
  abort();
 }
 
 function cryptoxide__hashing__blake2b__Context_____finalize_reset_at__ha5c35cb3b74565dc($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $6 = 0, $8 = 0;
  label$1 : {
   if (($2 | 0) != (8 | 0)) {
    break label$1
   }
   cryptoxide__hashing__blake2b__Context_____internal_final__he963a2000a7fa7a7($0 | 0);
   i64toi32_i32$0 = HEAP32[($0 + 100 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($0 + 104 | 0) >> 2] | 0;
   $8 = i64toi32_i32$0;
   i64toi32_i32$0 = $1;
   $6 = $8;
   HEAP8[i64toi32_i32$0 >> 0] = $6;
   HEAP8[(i64toi32_i32$0 + 1 | 0) >> 0] = $6 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 2 | 0) >> 0] = $6 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 3 | 0) >> 0] = $6 >>> 24 | 0;
   HEAP8[(i64toi32_i32$0 + 4 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[(i64toi32_i32$0 + 5 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[(i64toi32_i32$0 + 6 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[(i64toi32_i32$0 + 7 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   $0 = memcpy($0 | 0, 1137368 | 0, 64 | 0) | 0;
   i64toi32_i32$0 = $0;
   i64toi32_i32$1 = 0;
   HEAP32[(i64toi32_i32$0 + 64 | 0) >> 2] = 0;
   HEAP32[(i64toi32_i32$0 + 68 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = 1779033703;
   HEAP32[i64toi32_i32$0 >> 2] = -222443264;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$0 = i64toi32_i32$0 + 72 | 0;
   i64toi32_i32$1 = 0;
   HEAP32[i64toi32_i32$0 >> 2] = 0;
   HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
   memset($0 + 96 | 0 | 0, 0 | 0, 132 | 0) | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1136192 | 0, 47 | 0, 1136240 | 0);
  abort();
 }
 
 function $std__panicking__begin_panic__PanicPayload_A__20as_20core__panic__BoxMeUp___take_box__h20a0a805c7aa4e6a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = HEAP32[$1 >> 2] | 0;
  HEAP32[$1 >> 2] = 0;
  label$1 : {
   label$2 : {
    if (!$2) {
     break label$2
    }
    $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $1 = __rust_alloc(8 | 0, 4 | 0) | 0;
    if (!$1) {
     break label$1
    }
    HEAP32[($1 + 4 | 0) >> 2] = $3;
    HEAP32[$1 >> 2] = $2;
    HEAP32[($0 + 4 | 0) >> 2] = 1139112;
    HEAP32[$0 >> 2] = $1;
    return;
   }
   std__process__abort__h4249b49a3db9128b();
   abort();
  }
  alloc__alloc__handle_alloc_error__he269d8f1bff90960(8 | 0, 4 | 0);
  abort();
 }
 
 function $_mut_20W_20as_20core__fmt__Write___write_str__h5cc7eeafff4b561c($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0;
  label$1 : {
   $3 = HEAP32[(HEAP32[$0 >> 2] | 0) >> 2] | 0;
   $4 = $3 + 8 | 0;
   $0 = HEAP32[$4 >> 2] | 0;
   if (((HEAP32[($3 + 4 | 0) >> 2] | 0) - $0 | 0) >>> 0 >= $2 >>> 0) {
    break label$1
   }
   alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hc5a84431bcb0aafc($3 | 0, $0 | 0, $2 | 0);
   $0 = HEAP32[$4 >> 2] | 0;
  }
  memcpy((HEAP32[$3 >> 2] | 0) + $0 | 0 | 0, $1 | 0, $2 | 0) | 0;
  HEAP32[$4 >> 2] = $0 + $2 | 0;
  return 0 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__StakeRegistration___serialize__h001173245c759d8c($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, 2 | 0, 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__SerializeEmbeddedGroup_20for_20cardano_serialization_lib__StakeRegistration___serialize_as_embedded_group__he397bae1b05c31fd($0 | 0, $1 | 0, $2 | 0);
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__StakeDeregistration___serialize__h6386e70539f9aacd($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, 2 | 0, 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__SerializeEmbeddedGroup_20for_20cardano_serialization_lib__StakeDeregistration___serialize_as_embedded_group__h8b7f27e940fa4d76($0 | 0, $1 | 0, $2 | 0);
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__StakeDelegation___serialize__h12819bfe98da8ca7($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, 3 | 0, 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__SerializeEmbeddedGroup_20for_20cardano_serialization_lib__StakeDelegation___serialize_as_embedded_group__hc172ed37d82fb00e($0 | 0, $1 | 0, $2 | 0);
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__PoolParams___serialize__hb9e5313debf5456f($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, 9 | 0, 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__SerializeEmbeddedGroup_20for_20cardano_serialization_lib__PoolParams___serialize_as_embedded_group__h6dc6f400e7f8e6e4($0 | 0, $1 | 0, $2 | 0);
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__PoolRegistration___serialize__hca14ce2a34bdba0f($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, 10 | 0, 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__SerializeEmbeddedGroup_20for_20cardano_serialization_lib__PoolRegistration___serialize_as_embedded_group__hfc4829d058526c4d($0 | 0, $1 | 0, $2 | 0);
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__PoolRetirement___serialize__ha2a3c174a4e94da0($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, 3 | 0, 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__SerializeEmbeddedGroup_20for_20cardano_serialization_lib__PoolRetirement___serialize_as_embedded_group__h70aa5e00b5f3d46d($0 | 0, $1 | 0, $2 | 0);
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__GenesisKeyDelegation___serialize__h5da745d5a246d9be($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, 4 | 0, 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__SerializeEmbeddedGroup_20for_20cardano_serialization_lib__GenesisKeyDelegation___serialize_as_embedded_group__h141b02d2867c596d($0 | 0, $1 | 0, $2 | 0);
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__MoveInstantaneousRewardsCert___serialize__h6257e6687133e8c5($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, 2 | 0, 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__SerializeEmbeddedGroup_20for_20cardano_serialization_lib__MoveInstantaneousRewardsCert___serialize_as_embedded_group__h85726fc7bbd0a5c4($0 | 0, $1 | 0, $2 | 0);
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__SingleHostAddr___serialize__h544b90ba79e7b7c9($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, 4 | 0, 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__SerializeEmbeddedGroup_20for_20cardano_serialization_lib__SingleHostAddr___serialize_as_embedded_group__h051b24778a87dc4d($0 | 0, $1 | 0, $2 | 0);
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__SingleHostName___serialize__h1ca1f820778507e6($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, 3 | 0, 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__SerializeEmbeddedGroup_20for_20cardano_serialization_lib__SingleHostName___serialize_as_embedded_group__h71b245a4188cfa7d($0 | 0, $1 | 0, $2 | 0);
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__MultiHostName___serialize__h22530ddd6dac0df6($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, 2 | 0, 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__SerializeEmbeddedGroup_20for_20cardano_serialization_lib__MultiHostName___serialize_as_embedded_group__h66ca7f110fbbc19d($0 | 0, $1 | 0, $2 | 0);
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__ScriptPubkey___serialize__h0f3da940961ea792($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, 2 | 0, 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__SerializeEmbeddedGroup_20for_20cardano_serialization_lib__ScriptPubkey___serialize_as_embedded_group__h1b6a4a5cfee24716($0 | 0, $1 | 0, $2 | 0);
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__ScriptAll___serialize__h8f58ae8444303044($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, 2 | 0, 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__SerializeEmbeddedGroup_20for_20cardano_serialization_lib__ScriptAll___serialize_as_embedded_group__h0d66eab23a74dee9($0 | 0, $1 | 0, $2 | 0);
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__ScriptAny___serialize__haa07f6b291e86618($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, 2 | 0, 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__SerializeEmbeddedGroup_20for_20cardano_serialization_lib__ScriptAny___serialize_as_embedded_group__h230bdd7ffa07f6dd($0 | 0, $1 | 0, $2 | 0);
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__ScriptNOfK___serialize__ha6a5cba50bbb5ead($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, 3 | 0, 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__SerializeEmbeddedGroup_20for_20cardano_serialization_lib__ScriptNOfK___serialize_as_embedded_group__ha49ffad7178be19f($0 | 0, $1 | 0, $2 | 0);
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__TimelockStart___serialize__h9a60d7f0e1ad71af($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, 2 | 0, 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__SerializeEmbeddedGroup_20for_20cardano_serialization_lib__TimelockStart___serialize_as_embedded_group__hbaad639201a53fec($0 | 0, $1 | 0, $2 | 0);
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__TimelockExpiry___serialize__h9881f5a9c78a9c8e($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, 2 | 0, 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__SerializeEmbeddedGroup_20for_20cardano_serialization_lib__TimelockExpiry___serialize_as_embedded_group__h02f1140254eab00b($0 | 0, $1 | 0, $2 | 0);
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__ProtocolVersion___serialize__hc63f637e9607aaf8($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, 2 | 0, 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__SerializeEmbeddedGroup_20for_20cardano_serialization_lib__ProtocolVersion___serialize_as_embedded_group__hf0a424996c64ec05($0 | 0, $1 | 0, $2 | 0);
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__OperationalCert___serialize__h98f44149faf21e78($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 48 | 0;
  global$0 = $3;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($3 | 0, $2 | 0, 4 | 0, 4 | 0, 0 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    cardano_serialization_lib__serialization___impl_20cardano_serialization_lib__utils__SerializeEmbeddedGroup_20for_20cardano_serialization_lib__OperationalCert___serialize_as_embedded_group__he54340275d75ae4f($0 | 0, $1 | 0, $2 | 0);
    break label$1;
   }
   memcpy($0 + 8 | 0 | 0, $3 + 8 | 0 | 0, 40 | 0) | 0;
   HEAP32[$0 >> 2] = 1;
  }
  global$0 = $3 + 48 | 0;
 }
 
 function cardano_serialization_lib__chain_crypto__bech32__to_bech32_from_bytes___7b_7bclosure_7d_7d__h9b94b0cce47b6578($0, $0$hi) {
  $0 = $0 | 0;
  $0$hi = $0$hi | 0;
  var $1 = 0, i64toi32_i32$0 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  i64toi32_i32$0 = $0$hi;
  HEAP32[($1 + 8 | 0) >> 2] = $0;
  HEAP32[($1 + 12 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($1 + 36 | 0) >> 2] = 1;
  i64toi32_i32$0 = 0;
  HEAP32[($1 + 20 | 0) >> 2] = 1;
  HEAP32[($1 + 24 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($1 + 16 | 0) >> 2] = 1056444;
  HEAP32[($1 + 44 | 0) >> 2] = 15;
  HEAP32[($1 + 32 | 0) >> 2] = $1 + 40 | 0;
  HEAP32[($1 + 40 | 0) >> 2] = $1 + 8 | 0;
  std__panicking__begin_panic_fmt__h3dc1b0b65bbd6c17($1 + 16 | 0 | 0, 1056480 | 0);
  abort();
 }
 
 function cardano_serialization_lib__chain_crypto__bech32__to_bech32_from_bytes___7b_7bclosure_7d_7d__hb3434fc4c85e20c7($0, $0$hi) {
  $0 = $0 | 0;
  $0$hi = $0$hi | 0;
  var $1 = 0, i64toi32_i32$0 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  i64toi32_i32$0 = $0$hi;
  HEAP32[($1 + 8 | 0) >> 2] = $0;
  HEAP32[($1 + 12 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($1 + 36 | 0) >> 2] = 1;
  i64toi32_i32$0 = 0;
  HEAP32[($1 + 20 | 0) >> 2] = 1;
  HEAP32[($1 + 24 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($1 + 16 | 0) >> 2] = 1056444;
  HEAP32[($1 + 44 | 0) >> 2] = 15;
  HEAP32[($1 + 32 | 0) >> 2] = $1 + 40 | 0;
  HEAP32[($1 + 40 | 0) >> 2] = $1 + 8 | 0;
  std__panicking__begin_panic_fmt__h3dc1b0b65bbd6c17($1 + 16 | 0 | 0, 1056480 | 0);
  abort();
 }
 
 function cardano_serialization_lib__chain_crypto__bech32__to_bech32_from_bytes___7b_7bclosure_7d_7d__hb0fd1859c13ba56e($0, $0$hi) {
  $0 = $0 | 0;
  $0$hi = $0$hi | 0;
  var $1 = 0, i64toi32_i32$0 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  i64toi32_i32$0 = $0$hi;
  HEAP32[($1 + 8 | 0) >> 2] = $0;
  HEAP32[($1 + 12 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($1 + 36 | 0) >> 2] = 1;
  i64toi32_i32$0 = 0;
  HEAP32[($1 + 20 | 0) >> 2] = 1;
  HEAP32[($1 + 24 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($1 + 16 | 0) >> 2] = 1056444;
  HEAP32[($1 + 44 | 0) >> 2] = 15;
  HEAP32[($1 + 32 | 0) >> 2] = $1 + 40 | 0;
  HEAP32[($1 + 40 | 0) >> 2] = $1 + 8 | 0;
  std__panicking__begin_panic_fmt__h3dc1b0b65bbd6c17($1 + 16 | 0 | 0, 1056480 | 0);
  abort();
 }
 
 function cardano_serialization_lib__chain_crypto__bech32__to_bech32_from_bytes___7b_7bclosure_7d_7d__h5c413ffd7f293a6f($0, $0$hi) {
  $0 = $0 | 0;
  $0$hi = $0$hi | 0;
  var $1 = 0, i64toi32_i32$0 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  i64toi32_i32$0 = $0$hi;
  HEAP32[($1 + 8 | 0) >> 2] = $0;
  HEAP32[($1 + 12 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($1 + 36 | 0) >> 2] = 1;
  i64toi32_i32$0 = 0;
  HEAP32[($1 + 20 | 0) >> 2] = 1;
  HEAP32[($1 + 24 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($1 + 16 | 0) >> 2] = 1056444;
  HEAP32[($1 + 44 | 0) >> 2] = 15;
  HEAP32[($1 + 32 | 0) >> 2] = $1 + 40 | 0;
  HEAP32[($1 + 40 | 0) >> 2] = $1 + 8 | 0;
  std__panicking__begin_panic_fmt__h3dc1b0b65bbd6c17($1 + 16 | 0 | 0, 1056480 | 0);
  abort();
 }
 
 function cardano_serialization_lib__chain_crypto__bech32__to_bech32_from_bytes___7b_7bclosure_7d_7d__hfc58d423fd6ff4c6($0, $0$hi) {
  $0 = $0 | 0;
  $0$hi = $0$hi | 0;
  var $1 = 0, i64toi32_i32$0 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  i64toi32_i32$0 = $0$hi;
  HEAP32[($1 + 8 | 0) >> 2] = $0;
  HEAP32[($1 + 12 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($1 + 36 | 0) >> 2] = 1;
  i64toi32_i32$0 = 0;
  HEAP32[($1 + 20 | 0) >> 2] = 1;
  HEAP32[($1 + 24 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($1 + 16 | 0) >> 2] = 1056444;
  HEAP32[($1 + 44 | 0) >> 2] = 15;
  HEAP32[($1 + 32 | 0) >> 2] = $1 + 40 | 0;
  HEAP32[($1 + 40 | 0) >> 2] = $1 + 8 | 0;
  std__panicking__begin_panic_fmt__h3dc1b0b65bbd6c17($1 + 16 | 0 | 0, 1056480 | 0);
  abort();
 }
 
 function cardano_serialization_lib__chain_crypto__bech32__to_bech32_from_bytes___7b_7bclosure_7d_7d__hb6ea2d45cd0a5a90($0, $0$hi) {
  $0 = $0 | 0;
  $0$hi = $0$hi | 0;
  var $1 = 0, i64toi32_i32$0 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  i64toi32_i32$0 = $0$hi;
  HEAP32[($1 + 8 | 0) >> 2] = $0;
  HEAP32[($1 + 12 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($1 + 36 | 0) >> 2] = 1;
  i64toi32_i32$0 = 0;
  HEAP32[($1 + 20 | 0) >> 2] = 1;
  HEAP32[($1 + 24 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($1 + 16 | 0) >> 2] = 1056444;
  HEAP32[($1 + 44 | 0) >> 2] = 15;
  HEAP32[($1 + 32 | 0) >> 2] = $1 + 40 | 0;
  HEAP32[($1 + 40 | 0) >> 2] = $1 + 8 | 0;
  std__panicking__begin_panic_fmt__h3dc1b0b65bbd6c17($1 + 16 | 0 | 0, 1056480 | 0);
  abort();
 }
 
 function $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__h275f681e487dc2bb($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__next_or_end__h5c37448f9f4faa59($1 | 0, $0 | 0);
  label$1 : {
   $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   if (!$2) {
    break label$1
   }
   label$2 : while (1) {
    $2 = ($2 + Math_imul(HEAP32[($1 + 8 | 0) >> 2] | 0, 12) | 0) + 180 | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 | 0);
    $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__next_or_end__h5c37448f9f4faa59($1 | 0, $0 | 0);
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if ($2) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $1 + 16 | 0;
 }
 
 function $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__h55d7b487bf88b8bd($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__next_or_end__h8f308bd6ff82c5de($1 | 0, $0 | 0);
  label$1 : {
   $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   if (!$2) {
    break label$1
   }
   label$2 : while (1) {
    $2 = $2 + Math_imul(HEAP32[($1 + 8 | 0) >> 2] | 0, 48) | 0;
    core__mem__maybe_uninit__MaybeUninit_T___assume_init_drop__h4f9e4f10fdacfcee($2 | 0);
    core__mem__maybe_uninit__MaybeUninit_T___assume_init_drop__h4f9e4f10fdacfcee($2 + 528 | 0 | 0);
    $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__next_or_end__h8f308bd6ff82c5de($1 | 0, $0 | 0);
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if ($2) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $1 + 16 | 0;
 }
 
 function $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__h949cd00de60e473b($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__next_or_end__h3585c07afb489475($1 | 0, $0 | 0);
  label$1 : {
   $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   if (!$2) {
    break label$1
   }
   label$2 : while (1) {
    $2 = ($2 + Math_imul(HEAP32[($1 + 8 | 0) >> 2] | 0, 12) | 0) + 92 | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 | 0);
    $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__next_or_end__h3585c07afb489475($1 | 0, $0 | 0);
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if ($2) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $1 + 16 | 0;
 }
 
 function $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__hdb3d805366b8acdd($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__next_or_end__hb2986415471d1607($1 | 0, $0 | 0);
  label$1 : {
   $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   if (!$2) {
    break label$1
   }
   label$2 : while (1) {
    $2 = ($2 + Math_imul(HEAP32[($1 + 8 | 0) >> 2] | 0, 12) | 0) + 4 | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 | 0);
    $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__next_or_end__hb2986415471d1607($1 | 0, $0 | 0);
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if ($2) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $1 + 16 | 0;
 }
 
 function $cardano_serialization_lib__plutus__PlutusData_20as_20cbor_event__se__Serialize___serialize__hbd5d6a191345a7d0($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  label$1 : {
   label$2 : {
    if (HEAP32[($1 + 32 | 0) >> 2] | 0) {
     break label$2
    }
    $cardano_serialization_lib__plutus__PlutusDataEnum_20as_20cbor_event__se__Serialize___serialize__h80243bb681b5b257($0 | 0, $1 | 0, $2 | 0);
    break label$1;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($3 + 8 | 0 | 0, $1 + 32 | 0 | 0);
   alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($2 | 0, HEAP32[($3 + 8 | 0) >> 2] | 0 | 0, HEAP32[($3 + 12 | 0) >> 2] | 0 | 0);
   HEAP32[$0 >> 2] = 0;
   HEAP32[($0 + 4 | 0) >> 2] = $2;
  }
  global$0 = $3 + 16 | 0;
 }
 
 function core__iter__adapters__zip__Zip_A_2cB___new__hb3da0149c0b41f07($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  HEAP32[($0 + 16 | 0) >> 2] = 0;
  HEAP32[($0 + 8 | 0) >> 2] = $3;
  HEAP32[($0 + 4 | 0) >> 2] = $2;
  HEAP32[$0 >> 2] = $1;
  HEAP32[($0 + 12 | 0) >> 2] = $4;
  $1 = ($2 - $1 | 0) >>> 4 | 0;
  HEAP32[($0 + 24 | 0) >> 2] = $1;
  $4 = ($4 - $3 | 0) >>> 4 | 0;
  HEAP32[($0 + 20 | 0) >> 2] = $1 >>> 0 > $4 >>> 0 ? $4 : $1;
 }
 
 function getrandom__imp__BrowserCrypto__get_random_values__hc9121ab79959a6fc($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  getrandom__imp__BrowserCrypto__get_random_values____wbg_getRandomValues_98117e9a7e993920__h513dd1919c1b7151(HEAP32[$1 >> 2] | 0 | 0, HEAP32[$2 >> 2] | 0 | 0);
  wasm_bindgen____rt__take_last_exception__h00302a7bf129f841($3 + 8 | 0 | 0);
  label$1 : {
   label$2 : {
    if (HEAP32[($3 + 8 | 0) >> 2] | 0) {
     break label$2
    }
    $1 = 0;
    break label$1;
   }
   $1 = 1;
   $2 = $T_20as_20core__convert__From_T____from__hb95de13f265c6ef4(HEAP32[($3 + 12 | 0) >> 2] | 0 | 0) | 0;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $2;
  HEAP32[$0 >> 2] = $1;
  global$0 = $3 + 16 | 0;
 }
 
 function getrandom__imp__NodeCrypto__random_fill_sync__h449b39f067aa8fea($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0;
  $4 = global$0 - 16 | 0;
  global$0 = $4;
  getrandom__imp__NodeCrypto__random_fill_sync____wbg_randomFillSync_64cc7d048f228ca8__hc4ebf80f4c684d80(HEAP32[$1 >> 2] | 0 | 0, $2 | 0, $3 | 0);
  wasm_bindgen____rt__take_last_exception__h00302a7bf129f841($4 + 8 | 0 | 0);
  label$1 : {
   label$2 : {
    if (HEAP32[($4 + 8 | 0) >> 2] | 0) {
     break label$2
    }
    $2 = 0;
    break label$1;
   }
   $2 = 1;
   $3 = $T_20as_20core__convert__From_T____from__hb95de13f265c6ef4(HEAP32[($4 + 12 | 0) >> 2] | 0 | 0) | 0;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $3;
  HEAP32[$0 >> 2] = $2;
  global$0 = $4 + 16 | 0;
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend__T_2ccore__slice__iter__Iter_T_____spec_extend__h5cdab7a667860bc4($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0;
  label$1 : {
   $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   $4 = $2 - $1 | 0;
   $2 = $4 >>> 2 | 0;
   if (((HEAP32[($0 + 4 | 0) >> 2] | 0) - $3 | 0) >>> 0 >= $2 >>> 0) {
    break label$1
   }
   alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h90c9768825cdae1b($0 | 0, $3 | 0, $2 | 0);
   $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  }
  memcpy((HEAP32[$0 >> 2] | 0) + ($3 << 2 | 0) | 0 | 0, $1 | 0, $4 | 0) | 0;
  HEAP32[($0 + 8 | 0) >> 2] = $3 + $2 | 0;
 }
 
 function serde_json__value__Value__as_str__h7324103a5967f3bf($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if ((HEAPU8[$1 >> 0] | 0 | 0) == (3 | 0)) {
     break label$2
    }
    $1 = 0;
    break label$1;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $1 + 4 | 0 | 0);
   $1 = HEAP32[($2 + 8 | 0) >> 2] | 0;
   $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $3;
  HEAP32[$0 >> 2] = $1;
  global$0 = $2 + 16 | 0;
 }
 
 function rand_core__error__ErrorKind__description__h7d0a332cec477be2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = 23;
  $3 = 1101164;
  label$1 : {
   label$2 : {
    switch ($1 & 255 | 0 | 0) {
    case 2:
     $2 = 17;
     $3 = 1101129;
     break label$1;
    case 3:
     $2 = 13;
     $3 = 1101116;
     break label$1;
    case 4:
     core__panicking__panic__h2fd385a887c8bf13(1100965 | 0, 40 | 0, 1101100 | 0);
     abort();
    case 1:
     break label$2;
    default:
     break label$1;
    };
   }
   $2 = 18;
   $3 = 1101146;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $2;
  HEAP32[$0 >> 2] = $3;
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $4 = 0, $3 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $3 = HEAP32[$1 >> 2] | 0;
  $1 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__hce83853681ce0f55($2 + 8 | 0 | 0, $1 | 0, 0 | 0);
  $4 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($2 + 12 | 0) >> 2] | 0;
  HEAP32[$0 >> 2] = $4;
  memcpy($4 | 0, $3 | 0, $1 | 0) | 0;
  HEAP32[($0 + 8 | 0) >> 2] = $1;
  global$0 = $2 + 16 | 0;
 }
 
 function $_mut_20W_20as_20core__fmt__Write___write_str__h849058aeb4ca6302($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0;
  label$1 : {
   $3 = HEAP32[$0 >> 2] | 0;
   $4 = $3 + 8 | 0;
   $0 = HEAP32[$4 >> 2] | 0;
   if (((HEAP32[($3 + 4 | 0) >> 2] | 0) - $0 | 0) >>> 0 >= $2 >>> 0) {
    break label$1
   }
   alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hc5a84431bcb0aafc($3 | 0, $0 | 0, $2 | 0);
   $0 = HEAP32[$4 >> 2] | 0;
  }
  memcpy((HEAP32[$3 >> 2] | 0) + $0 | 0 | 0, $1 | 0, $2 | 0) | 0;
  HEAP32[$4 >> 2] = $0 + $2 | 0;
  return 0 | 0;
 }
 
 function $std__io__Write__write_fmt__Adaptor_T__20as_20core__fmt__Write___write_str__hed1d803889188a6e($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0;
  label$1 : {
   $3 = HEAP32[$0 >> 2] | 0;
   $4 = $3 + 8 | 0;
   $0 = HEAP32[$4 >> 2] | 0;
   if (((HEAP32[($3 + 4 | 0) >> 2] | 0) - $0 | 0) >>> 0 >= $2 >>> 0) {
    break label$1
   }
   alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hc5a84431bcb0aafc($3 | 0, $0 | 0, $2 | 0);
   $0 = HEAP32[$4 >> 2] | 0;
  }
  memcpy((HEAP32[$3 >> 2] | 0) + $0 | 0 | 0, $1 | 0, $2 | 0) | 0;
  HEAP32[$4 >> 2] = $0 + $2 | 0;
  return 0 | 0;
 }
 
 function $std__panicking__begin_panic__PanicPayload_A__20as_20core__panic__BoxMeUp___take_box__h0a41362e8345a8e4($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = HEAP32[$1 >> 2] | 0;
  HEAP32[$1 >> 2] = 0;
  label$1 : {
   label$2 : {
    if (!$2) {
     break label$2
    }
    $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $1 = __rust_alloc(8 | 0, 4 | 0) | 0;
    if (!$1) {
     break label$1
    }
    HEAP32[($1 + 4 | 0) >> 2] = $3;
    HEAP32[$1 >> 2] = $2;
    HEAP32[($0 + 4 | 0) >> 2] = 1144352;
    HEAP32[$0 >> 2] = $1;
    return;
   }
   abort();
  }
  alloc__alloc__handle_alloc_error__he269d8f1bff90960(8 | 0, 4 | 0);
  abort();
 }
 
 function $_mut_20W_20as_20core__fmt__Write___write_str__h68b76b1f98d36d88($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0;
  label$1 : {
   $3 = HEAP32[$0 >> 2] | 0;
   $4 = $3 + 8 | 0;
   $0 = HEAP32[$4 >> 2] | 0;
   if (((HEAP32[($3 + 4 | 0) >> 2] | 0) - $0 | 0) >>> 0 >= $2 >>> 0) {
    break label$1
   }
   alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h306b444aaeb5adc5($3 | 0, $0 | 0, $2 | 0);
   $0 = HEAP32[$4 >> 2] | 0;
  }
  memcpy((HEAP32[$3 >> 2] | 0) + $0 | 0 | 0, $1 | 0, $2 | 0) | 0;
  HEAP32[$4 >> 2] = $0 + $2 | 0;
  return 0 | 0;
 }
 
 function int_new($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $5 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($1 + 8 | 0 | 0, $0 | 0);
  i64toi32_i32$2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  $5 = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  $0 = $cardano_serialization_lib__utils__Int_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hac86427717971799($5 | 0, i64toi32_i32$1 | 0, 0 | 0, i64toi32_i32$0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Owned_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___push_internal_level__h5645c5988692fce9($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $4 = 0, $2 = 0, $3 = 0;
  $2 = HEAP32[$1 >> 2] | 0;
  $3 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $4 = alloc__boxed__Box_T_2cA___new_uninit_in__h22083d1d420f57ec() | 0;
  HEAP32[($4 + 408 | 0) >> 2] = $3;
  HEAP16[($4 + 402 | 0) >> 1] = 0;
  HEAP32[($4 + 264 | 0) >> 2] = 0;
  HEAP32[($1 + 4 | 0) >> 2] = $4;
  $2 = $2 + 1 | 0;
  HEAP32[$1 >> 2] = $2;
  HEAP16[($3 + 400 | 0) >> 1] = 0;
  HEAP32[($3 + 264 | 0) >> 2] = $4;
  HEAP32[($0 + 4 | 0) >> 2] = $4;
  HEAP32[$0 >> 2] = $2;
 }
 
 function cryptoxide__hashing__sha2__eng512__Engine__blocks__h91a1f80841db786c($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0;
  $3 = global$0 - 32 | 0;
  global$0 = $3;
  $4 = $2 & 127 | 0;
  HEAP32[($3 + 4 | 0) >> 2] = $4;
  label$1 : {
   if ($4) {
    break label$1
   }
   cryptoxide__hashing__sha2__impl512__reference__digest_block__h5deb88f07cb6a5e7($0 | 0, $1 | 0, $2 | 0);
   global$0 = $3 + 32 | 0;
   return;
  }
  HEAP32[($3 + 8 | 0) >> 2] = 0;
  core__panicking__assert_failed__h7abe5b371cd10d8a(0 | 0, $3 + 4 | 0 | 0, 1102296 | 0, $3 + 8 | 0 | 0, 1102408 | 0);
  abort();
 }
 
 function $__5bu8_3b_20N_5d_20as_20cryptoxide__constant_time__CtEqual___ct_eq__hde8501fb60eb5442($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$5 = 0, $3$hi = 0, $2 = 0, $3 = 0, $4$hi = 0, $16 = 0, $4 = 0, $17 = 0, $17$hi = 0, $25 = 0, $25$hi = 0;
  i64toi32_i32$0 = 0;
  $3 = 0;
  $3$hi = i64toi32_i32$0;
  $2 = 0;
  label$1 : while (1) {
   i64toi32_i32$0 = $3$hi;
   $4 = $3;
   $4$hi = i64toi32_i32$0;
   i64toi32_i32$0 = 0;
   i64toi32_i32$2 = (HEAPU8[($1 + $2 | 0) >> 0] | 0) ^ (HEAPU8[($0 + $2 | 0) >> 0] | 0) | 0;
   i64toi32_i32$1 = 0;
   i64toi32_i32$3 = 255;
   i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
   $17 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
   $17$hi = i64toi32_i32$1;
   i64toi32_i32$1 = $3$hi;
   i64toi32_i32$0 = $3;
   i64toi32_i32$2 = $17$hi;
   i64toi32_i32$3 = $17;
   i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
   $3 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
   $3$hi = i64toi32_i32$2;
   $2 = $2 + 1 | 0;
   if (($2 | 0) != (32 | 0)) {
    continue label$1
   }
   break label$1;
  };
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$2 = $3$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$0 = $3$hi;
  i64toi32_i32$3 = $3;
  i64toi32_i32$5 = (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) + i64toi32_i32$0 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 - i64toi32_i32$5 | 0;
  $25 = i64toi32_i32$1 - i64toi32_i32$3 | 0;
  $25$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $4$hi;
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = $25$hi;
  i64toi32_i32$3 = $25;
  i64toi32_i32$1 = i64toi32_i32$5 | i64toi32_i32$1 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  i64toi32_i32$2 = -1;
  i64toi32_i32$3 = -1;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 63;
  i64toi32_i32$0 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$5 = 0;
   $16 = i64toi32_i32$2 >>> i64toi32_i32$0 | 0;
  } else {
   i64toi32_i32$5 = i64toi32_i32$2 >>> i64toi32_i32$0 | 0;
   $16 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$0 | 0) | 0;
  }
  i64toi32_i32$1 = $16;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$5;
  return i64toi32_i32$1 | 0;
 }
 
 function alloc__sync__Arc_T___drop_slow__h5db2bd229aad6626($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 12 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $2 = HEAP32[($0 + 16 | 0) >> 2] | 0;
   if (!$2) {
    break label$1
   }
   __rust_dealloc($1 | 0, $2 | 0, 1 | 0);
  }
  label$2 : {
   if (($0 | 0) == (-1 | 0)) {
    break label$2
   }
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1 + -1 | 0;
   if (($1 | 0) != (1 | 0)) {
    break label$2
   }
   __rust_dealloc($0 | 0, 24 | 0, 4 | 0);
  }
 }
 
 function core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__plutus__Redeemers____hd7679bbdd61edccb($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  label$1 : {
   $1 = HEAP32[$0 >> 2] | 0;
   if (!$1) {
    break label$1
   }
   label$2 : {
    $2 = HEAP32[($0 + 8 | 0) >> 2] | 0;
    if (!$2) {
     break label$2
    }
    $2 = Math_imul($2, 80);
    $1 = $1 + 8 | 0;
    label$3 : while (1) {
     core__ptr__drop_in_place_cardano_serialization_lib__plutus__PlutusData___hfab843e66e0f9428_2($1 | 0);
     $1 = $1 + 80 | 0;
     $2 = $2 + -80 | 0;
     if ($2) {
      continue label$3
     }
     break label$3;
    };
   }
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h4c688d2d7e8a61fa($0 | 0);
  }
 }
 
 function core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__metadata__AuxiliaryData____ha98f6c5d89b7a772($0) {
  $0 = $0 | 0;
  var i64toi32_i32$0 = 0, $1 = 0, $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0;
  label$1 : {
   i64toi32_i32$0 = HEAP32[$0 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   i64toi32_i32$2 = i64toi32_i32$0;
   i64toi32_i32$0 = 0;
   if ((i64toi32_i32$2 | 0) == (0 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
    break label$1
   }
   $1 = $0 + 8 | 0;
   label$2 : {
    if (!(HEAP32[($0 + 28 | 0) >> 2] | 0)) {
     break label$2
    }
    $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__he275f3eb7df08493($1 | 0);
    $2 = $0 + 24 | 0;
    if (!(HEAP32[$2 >> 2] | 0)) {
     break label$2
    }
    hashbrown__raw__RawTable_T_2cA___free_buckets__hfa29170569415d6b($2 | 0);
   }
   core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__NativeScripts____hdd7d461255ec800a($0 + 48 | 0 | 0);
   core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__plutus__PlutusScripts____h6be1d55eac328b7f($1 + 52 | 0 | 0);
  }
 }
 
 function unitinterval_numerator($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h98bfbcc994df632c($1 + 8 | 0 | 0, $0 | 0);
  i64toi32_i32$2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $2 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810($2 | 0, i64toi32_i32$1 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function unitinterval_denominator($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h98bfbcc994df632c($1 + 8 | 0 | 0, $0 | 0);
  i64toi32_i32$2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $2 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810($2 | 0, i64toi32_i32$1 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function transactionbody_fee($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h356c30395cf13adb($1 + 8 | 0 | 0, $0 | 0);
  i64toi32_i32$2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $2 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810($2 | 0, i64toi32_i32$1 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function poolparams_pledge($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hc466bac66f8af18e($1 + 8 | 0 | 0, $0 | 0);
  i64toi32_i32$2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $2 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810($2 | 0, i64toi32_i32$1 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function poolparams_cost($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hc466bac66f8af18e($1 + 8 | 0 | 0, $0 | 0);
  i64toi32_i32$2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $2 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810($2 | 0, i64toi32_i32$1 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function timelockstart_slot_bignum($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h10da0fea03f0ac1d($1 + 8 | 0 | 0, $0 | 0);
  i64toi32_i32$2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $2 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810($2 | 0, i64toi32_i32$1 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function timelockstart_new_timelockstart($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($1 + 8 | 0 | 0, $0 | 0);
  i64toi32_i32$2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $2 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  $0 = $cardano_serialization_lib__TimelockStart_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h71f9779b79ae2a49($2 | 0, i64toi32_i32$1 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function timelockexpiry_slot_bignum($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hd0c16785fb9ea7bd($1 + 8 | 0 | 0, $0 | 0);
  i64toi32_i32$2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $2 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810($2 | 0, i64toi32_i32$1 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function timelockexpiry_new_timelockexpiry($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($1 + 8 | 0 | 0, $0 | 0);
  i64toi32_i32$2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $2 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  $0 = $cardano_serialization_lib__TimelockExpiry_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h701c0b7035bdc4b4($2 | 0, i64toi32_i32$1 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function protocolparamupdate_set_max_block_body_size($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h0a71cd742026514d($2 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  HEAP32[($0 + 280 | 0) >> 2] = 1;
  $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  HEAP32[($0 + 284 | 0) >> 2] = $1;
  core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
  global$0 = $2 + 16 | 0;
 }
 
 function protocolparamupdate_set_max_tx_size($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h0a71cd742026514d($2 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  HEAP32[($0 + 288 | 0) >> 2] = 1;
  $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  HEAP32[($0 + 292 | 0) >> 2] = $1;
  core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
  global$0 = $2 + 16 | 0;
 }
 
 function protocolparamupdate_set_max_block_header_size($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h0a71cd742026514d($2 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  HEAP32[($0 + 296 | 0) >> 2] = 1;
  $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  HEAP32[($0 + 300 | 0) >> 2] = $1;
  core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
  global$0 = $2 + 16 | 0;
 }
 
 function protocolparamupdate_set_max_epoch($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h0a71cd742026514d($2 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  HEAP32[($0 + 304 | 0) >> 2] = 1;
  $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  HEAP32[($0 + 308 | 0) >> 2] = $1;
  core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
  global$0 = $2 + 16 | 0;
 }
 
 function protocolparamupdate_set_n_opt($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h0a71cd742026514d($2 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  HEAP32[($0 + 312 | 0) >> 2] = 1;
  $3 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  HEAP32[($0 + 316 | 0) >> 2] = $1;
  core__cell__Cell_T___replace__h74ad9f426af36be8($3 | 0, 0 | 0) | 0;
  global$0 = $2 + 16 | 0;
 }
 
 function headerbody_slot_bignum($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h2ac16fcb64db16b5($1 + 8 | 0 | 0, $0 | 0);
  i64toi32_i32$2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $2 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810($2 | 0, i64toi32_i32$1 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h0dd3a7ef10a68e7f($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  alloc__raw_vec__RawVec_T_2cA___grow_amortized__h1c6aed9a0f471094($3 | 0, $0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($3 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    abort();
   }
   global$0 = $3 + 16 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h1a6fd20a90c96048($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  alloc__raw_vec__RawVec_T_2cA___grow_amortized__h23ae81209ad91ffa($3 | 0, $0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($3 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    abort();
   }
   global$0 = $3 + 16 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h2b9e4edca640f3c0($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  alloc__raw_vec__RawVec_T_2cA___grow_amortized__h8252dde40401b41c($3 | 0, $0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($3 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    abort();
   }
   global$0 = $3 + 16 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h3bf5a6cd2f3fdf29($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  alloc__raw_vec__RawVec_T_2cA___grow_amortized__h44d2d41be11f46e0($3 | 0, $0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($3 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    abort();
   }
   global$0 = $3 + 16 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h48baae5828c84300($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  alloc__raw_vec__RawVec_T_2cA___grow_amortized__he8b3d9e2a5705505($3 | 0, $0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($3 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    abort();
   }
   global$0 = $3 + 16 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h4d4877c8b8eb1e24($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  alloc__raw_vec__RawVec_T_2cA___grow_amortized__h561ad47c477d4529($3 | 0, $0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($3 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    abort();
   }
   global$0 = $3 + 16 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h4ecdd36a3fcffeb7($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  alloc__raw_vec__RawVec_T_2cA___grow_amortized__hd6ed9bb1c7c89037($3 | 0, $0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($3 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    abort();
   }
   global$0 = $3 + 16 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h558818d7c1769e53($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  alloc__raw_vec__RawVec_T_2cA___grow_amortized__hc292e6e349fedcda($3 | 0, $0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($3 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    abort();
   }
   global$0 = $3 + 16 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h55956fe02300486e($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  alloc__raw_vec__RawVec_T_2cA___grow_amortized__hc4ed24c3b0b077ea($3 | 0, $0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($3 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    abort();
   }
   global$0 = $3 + 16 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h5af6e4677d294e82($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  alloc__raw_vec__RawVec_T_2cA___grow_amortized__hfdd08e37da3a4f23($3 | 0, $0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($3 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    abort();
   }
   global$0 = $3 + 16 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h60072695517d08a3($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  alloc__raw_vec__RawVec_T_2cA___grow_amortized__ha9461a9a8b4163ea($3 | 0, $0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($3 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    abort();
   }
   global$0 = $3 + 16 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h627fa3c45b4de56f($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  alloc__raw_vec__RawVec_T_2cA___grow_amortized__hc5a3a0cf02455e39($3 | 0, $0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($3 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    abort();
   }
   global$0 = $3 + 16 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h6efd3441b9caf532($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  alloc__raw_vec__RawVec_T_2cA___grow_amortized__h8582ea6381964946($3 | 0, $0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($3 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    abort();
   }
   global$0 = $3 + 16 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h747ed10c49fb1468($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  alloc__raw_vec__RawVec_T_2cA___grow_amortized__h2b1b6a490e812ad2($3 | 0, $0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($3 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    abort();
   }
   global$0 = $3 + 16 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h75690594b6280ac0($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  alloc__raw_vec__RawVec_T_2cA___grow_amortized__heaf262243daf937e($3 | 0, $0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($3 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    abort();
   }
   global$0 = $3 + 16 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h7f3f684dc85b8ad3($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  alloc__raw_vec__RawVec_T_2cA___grow_amortized__h695c1ff0a843d246($3 | 0, $0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($3 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    abort();
   }
   global$0 = $3 + 16 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h8a2ac49eb7d7d958($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  alloc__raw_vec__RawVec_T_2cA___grow_amortized__hc23632b2480b7636($3 | 0, $0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($3 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    abort();
   }
   global$0 = $3 + 16 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h8d0aff87097f011d($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  alloc__raw_vec__RawVec_T_2cA___grow_amortized__h64daf95aea34d613($3 | 0, $0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($3 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    abort();
   }
   global$0 = $3 + 16 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__ha457b0dea7cc7a33($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  alloc__raw_vec__RawVec_T_2cA___grow_amortized__he7ea3f4f2a47815e($3 | 0, $0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($3 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    abort();
   }
   global$0 = $3 + 16 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hb13b6fa50ee7b823($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  alloc__raw_vec__RawVec_T_2cA___grow_amortized__ha9fba2eac8dec5ba($3 | 0, $0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($3 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    abort();
   }
   global$0 = $3 + 16 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hb28826101b6ca67b($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  alloc__raw_vec__RawVec_T_2cA___grow_amortized__h8ebbaf323e52c4c9($3 | 0, $0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($3 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    abort();
   }
   global$0 = $3 + 16 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hb2d5108633ce5dd7($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  alloc__raw_vec__RawVec_T_2cA___grow_amortized__h7a7e330561a9918e($3 | 0, $0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($3 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    abort();
   }
   global$0 = $3 + 16 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hc7c237c6ae92ed14($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  alloc__raw_vec__RawVec_T_2cA___grow_amortized__he020c2f1582e1252($3 | 0, $0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($3 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    abort();
   }
   global$0 = $3 + 16 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hd40e78aa171f606d($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  alloc__raw_vec__RawVec_T_2cA___grow_amortized__h0e109e6593d2a7b4($3 | 0, $0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($3 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    abort();
   }
   global$0 = $3 + 16 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hf0c17c80fd73868c($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  alloc__raw_vec__RawVec_T_2cA___grow_amortized__h6c689e449b3b3a5d($3 | 0, $0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($3 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    abort();
   }
   global$0 = $3 + 16 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hf135acf924159ceb($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  alloc__raw_vec__RawVec_T_2cA___grow_amortized__hd69331eb690e9c9d($3 | 0, $0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($3 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    abort();
   }
   global$0 = $3 + 16 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hf274e025df11641c($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  alloc__raw_vec__RawVec_T_2cA___grow_amortized__h134b30d55f098eb6($3 | 0, $0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($3 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    abort();
   }
   global$0 = $3 + 16 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hf4e46fc64716925d($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  alloc__raw_vec__RawVec_T_2cA___grow_amortized__h7137ddcde3a63efa($3 | 0, $0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($3 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    abort();
   }
   global$0 = $3 + 16 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hf5a91d7c63e29e55($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  alloc__raw_vec__RawVec_T_2cA___grow_amortized__hbf2698c49cdae023($3 | 0, $0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($3 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    abort();
   }
   global$0 = $3 + 16 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hf63e6be5be3c26c2($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  alloc__raw_vec__RawVec_T_2cA___grow_amortized__he88d25d865ea9535($3 | 0, $0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($3 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    abort();
   }
   global$0 = $3 + 16 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hf7d7cca00a09c6e3($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  alloc__raw_vec__RawVec_T_2cA___grow_amortized__h32cf64aa38e43a13($3 | 0, $0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($3 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    abort();
   }
   global$0 = $3 + 16 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hf92fb44e4fe7e929($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  alloc__raw_vec__RawVec_T_2cA___grow_amortized__had972e909c97e38b($3 | 0, $0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($3 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    abort();
   }
   global$0 = $3 + 16 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function $core__iter__adapters__ResultShunt_I_2cE__20as_20core__iter__traits__iterator__Iterator___try_fold__h46f032289f335f5a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  HEAP32[($2 + 4 | 0) >> 2] = HEAP32[($1 + 16 | 0) >> 2] | 0;
  $core__iter__adapters__map__Map_I_2cF__20as_20core__iter__traits__iterator__Iterator___try_fold__hb7370e67be22f2dc($2 | 0, $1 | 0, $2 + 8 | 0 | 0, $2 + 4 | 0 | 0);
  $1 = HEAPU8[$2 >> 0] | 0;
  HEAP8[($0 + 1 | 0) >> 0] = HEAPU8[($2 + 1 | 0) >> 0] | 0;
  HEAP8[$0 >> 0] = $1 & ($1 | 0) != (2 | 0) | 0;
  global$0 = $2 + 16 | 0;
 }
 
 function $core__iter__adapters__ResultShunt_I_2cE__20as_20core__iter__traits__iterator__Iterator___try_fold__h81e306f0b3e48011($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  HEAP32[($2 + 4 | 0) >> 2] = HEAP32[($1 + 16 | 0) >> 2] | 0;
  $core__iter__adapters__map__Map_I_2cF__20as_20core__iter__traits__iterator__Iterator___try_fold__h176ab48bdb73cf0b($2 | 0, $1 | 0, $2 + 8 | 0 | 0, $2 + 4 | 0 | 0);
  $1 = HEAPU8[$2 >> 0] | 0;
  HEAP8[($0 + 1 | 0) >> 0] = HEAPU8[($2 + 1 | 0) >> 0] | 0;
  HEAP8[$0 >> 0] = $1 & ($1 | 0) != (2 | 0) | 0;
  global$0 = $2 + 16 | 0;
 }
 
 function std__io__cursor__Cursor_T___remaining_slice__h5de2a0dd397eef35($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, $2 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $3 = 0, $12$hi = 0, $5 = 0, $15$hi = 0, i64toi32_i32$4 = 0;
  label$1 : {
   $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
   i64toi32_i32$0 = 0;
   $12$hi = i64toi32_i32$0;
   i64toi32_i32$2 = $1;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   $5 = i64toi32_i32$0;
   $15$hi = i64toi32_i32$1;
   i64toi32_i32$1 = $12$hi;
   i64toi32_i32$1 = $15$hi;
   i64toi32_i32$2 = i64toi32_i32$0;
   i64toi32_i32$0 = $12$hi;
   i64toi32_i32$4 = i64toi32_i32$1 >>> 0 > i64toi32_i32$0 >>> 0 | ((i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$2 >>> 0 > $2 >>> 0 | 0) | 0;
   i64toi32_i32$2 = i64toi32_i32$0;
   i64toi32_i32$0 = i64toi32_i32$4 ? $2 : $5;
   $3 = i64toi32_i32$0;
   if ($2 >>> 0 >= i64toi32_i32$0 >>> 0) {
    break label$1
   }
   core__slice__index__slice_start_index_len_fail__hef3e337d6e859bb4($3 | 0, $2 | 0, 1055780 | 0);
   abort();
  }
  HEAP32[($0 + 4 | 0) >> 2] = $2 - $3 | 0;
  HEAP32[$0 >> 2] = (HEAP32[($1 + 8 | 0) >> 2] | 0) + $3 | 0;
 }
 
 function value_coin($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h5db5149478ec5345($1 + 8 | 0 | 0, $0 | 0);
  i64toi32_i32$2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $2 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810($2 | 0, i64toi32_i32$1 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function linearfee_constant($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__haac84d0387ff0446($1 + 8 | 0 | 0, $0 | 0);
  i64toi32_i32$2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $2 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810($2 | 0, i64toi32_i32$1 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function linearfee_coefficient($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__haac84d0387ff0446($1 + 8 | 0 | 0, $0 | 0);
  i64toi32_i32$2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $2 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810($2 | 0, i64toi32_i32$1 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h1bbffe174ae872d8($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[$0 >> 2] | 0;
   $1 = Math_imul($1, 144);
   label$2 : while (1) {
    $2 = $0 + 128 | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 | 0);
    core__ptr__drop_in_place_cardano_serialization_lib__plutus__PlutusData___hfab843e66e0f9428_2($0 | 0);
    core__ptr__drop_in_place_cardano_serialization_lib__plutus__PlutusData___hfab843e66e0f9428_2($0 + 56 | 0 | 0);
    $0 = $0 + 144 | 0;
    $1 = $1 + -144 | 0;
    if ($1) {
     continue label$2
    }
    break label$2;
   };
  }
 }
 
 function pointer_slot_bignum($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h7b63d9df2a892a8b($1 + 8 | 0 | 0, $0 | 0);
  i64toi32_i32$2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $2 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810($2 | 0, i64toi32_i32$1 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function pointer_tx_index_bignum($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h7b63d9df2a892a8b($1 + 8 | 0 | 0, $0 | 0);
  i64toi32_i32$2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $2 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810($2 | 0, i64toi32_i32$1 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function pointer_cert_index_bignum($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h7b63d9df2a892a8b($1 + 8 | 0 | 0, $0 | 0);
  i64toi32_i32$2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 20 | 0) >> 2] | 0;
  $2 = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810($2 | 0, i64toi32_i32$1 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function constrplutusdata_alternative($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h2f574964f7dad662($1 + 8 | 0 | 0, $0 | 0);
  i64toi32_i32$2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $2 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810($2 | 0, i64toi32_i32$1 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function exunits_mem($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h1f4aa39af4dc2942($1 + 8 | 0 | 0, $0 | 0);
  i64toi32_i32$2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $2 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810($2 | 0, i64toi32_i32$1 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function exunits_steps($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h1f4aa39af4dc2942($1 + 8 | 0 | 0, $0 | 0);
  i64toi32_i32$2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $2 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810($2 | 0, i64toi32_i32$1 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function redeemer_tag($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h388263144730eb6a($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAPU8[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 72 | 0) >> 0] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  $0 = $cardano_serialization_lib__plutus__RedeemerTag_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h6e4777f9244e5b69($0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function redeemer_index($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h388263144730eb6a($1 + 8 | 0 | 0, $0 | 0);
  i64toi32_i32$2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $2 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  $0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810($2 | 0, i64toi32_i32$1 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function rand_chacha__guts__read_u32le__he4399ba7da75efdd($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  HEAP32[($2 + 4 | 0) >> 2] = $1;
  label$1 : {
   if (($1 | 0) != (4 | 0)) {
    break label$1
   }
   $3 = $0;
   $1 = HEAPU8[$3 >> 0] | 0 | ((HEAPU8[($3 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[($3 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[($3 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
   global$0 = $2 + 32 | 0;
   return $1 | 0;
  }
  HEAP32[($2 + 8 | 0) >> 2] = 0;
  core__panicking__assert_failed__h797398ab1bf2772c(0 | 0, $2 + 4 | 0 | 0, 1074952 | 0, $2 + 8 | 0 | 0, 1075052 | 0);
  abort();
 }
 
 function $rand_core__error__Error_20as_20core__fmt__Display___fmt__hb03d363219c0d4bc($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 32 | 0;
  global$0 = $2;
  HEAP32[($2 + 20 | 0) >> 2] = 1;
  HEAP32[($2 + 4 | 0) >> 2] = 1;
  HEAP32[($2 + 8 | 0) >> 2] = 0;
  HEAP32[$2 >> 2] = 1075068;
  HEAP32[($2 + 28 | 0) >> 2] = 158;
  HEAP32[($2 + 24 | 0) >> 2] = $0;
  HEAP32[($2 + 16 | 0) >> 2] = $2 + 24 | 0;
  $1 = core__fmt__Formatter__write_fmt__h23f06c16d035978e($1 | 0, $2 | 0) | 0;
  global$0 = $2 + 32 | 0;
  return $1 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h90c9768825cdae1b($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  alloc__raw_vec__RawVec_T_2cA___grow_amortized__hf99f6d638db950d2($3 | 0, $0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($3 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    abort();
   }
   global$0 = $3 + 16 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hcd3bd1a8d7e51f52($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  alloc__raw_vec__RawVec_T_2cA___grow_amortized__h7088b8fc2d40299b($3 | 0, $0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($3 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    abort();
   }
   global$0 = $3 + 16 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h7b0a2c1df92d7167($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  alloc__raw_vec__RawVec_T_2cA___grow_amortized__he5593839a7b4f848($3 | 0, $0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($3 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    abort();
   }
   global$0 = $3 + 16 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter__SpecFromIter_T_2cI____from_iter__h6366b5bc3d433487($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $23 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  $4 = $2 - $1 | 0;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h5dada854c892eb3e($3 + 8 | 0 | 0, ($4 >>> 0 > $2 >>> 0 ? 0 : $4) | 0, 0 | 0);
  i64toi32_i32$0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  $23 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[$0 >> 2] = $23;
  HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend_T_2cI____spec_extend__he2a686a36d571fcb($0 | 0, $1 | 0, $2 | 0);
  global$0 = $3 + 16 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__he90fb3a4f4cd283b($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  alloc__raw_vec__RawVec_T_2cA___grow_amortized__h37c25786904aedf0($3 | 0, $0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($3 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    abort();
   }
   global$0 = $3 + 16 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hf485cf9a98f32d97($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  alloc__raw_vec__RawVec_T_2cA___grow_amortized__hb7acd97bd3480761($3 | 0, $0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($3 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    abort();
   }
   global$0 = $3 + 16 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend_T_2cI____spec_extend__h633257e263edf263($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
     if (((HEAP32[($0 + 4 | 0) >> 2] | 0) - $3 | 0) >>> 0 >= $1 >>> 0) {
      break label$3
     }
     alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hc9350e949460764e($0 | 0, $3 | 0, $1 | 0);
     $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
     break label$2;
    }
    if (!$1) {
     break label$1
    }
   }
   memset((HEAP32[$0 >> 2] | 0) + $3 | 0 | 0, $2 | 0, $1 | 0) | 0;
   HEAP32[($0 + 8 | 0) >> 2] = $3 + $1 | 0;
  }
 }
 
 function $cryptoxide__simd__fake__u32x4_20as_20core__ops__bit__Shl___shl__h81233ff1fb0a7e8f($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  HEAP32[($0 + 12 | 0) >> 2] = (HEAP32[($1 + 12 | 0) >> 2] | 0) << ((HEAP32[($2 + 12 | 0) >> 2] | 0) & 31 | 0) | 0;
  HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($1 + 8 | 0) >> 2] | 0) << ((HEAP32[($2 + 8 | 0) >> 2] | 0) & 31 | 0) | 0;
  HEAP32[($0 + 4 | 0) >> 2] = (HEAP32[($1 + 4 | 0) >> 2] | 0) << ((HEAP32[($2 + 4 | 0) >> 2] | 0) & 31 | 0) | 0;
  HEAP32[$0 >> 2] = (HEAP32[$1 >> 2] | 0) << ((HEAP32[$2 >> 2] | 0) & 31 | 0) | 0;
 }
 
 function $cryptoxide__simd__fake__u32x4_20as_20core__ops__bit__Shr___shr__ha0ba11d1f3a547e4($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  HEAP32[($0 + 12 | 0) >> 2] = (HEAP32[($1 + 12 | 0) >> 2] | 0) >>> ((HEAP32[($2 + 12 | 0) >> 2] | 0) & 31 | 0) | 0;
  HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($1 + 8 | 0) >> 2] | 0) >>> ((HEAP32[($2 + 8 | 0) >> 2] | 0) & 31 | 0) | 0;
  HEAP32[($0 + 4 | 0) >> 2] = (HEAP32[($1 + 4 | 0) >> 2] | 0) >>> ((HEAP32[($2 + 4 | 0) >> 2] | 0) & 31 | 0) | 0;
  HEAP32[$0 >> 2] = (HEAP32[$1 >> 2] | 0) >>> ((HEAP32[$2 >> 2] | 0) & 31 | 0) | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hc9350e949460764e($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  alloc__raw_vec__RawVec_T_2cA___grow_amortized__h2f5e280bbc8649ed($3 | 0, $0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($3 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    abort();
   }
   global$0 = $3 + 16 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hace6da240d5ba1ef($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  alloc__raw_vec__RawVec_T_2cA___grow_amortized__hb18dc3da0fa4253f($3 | 0, $0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($3 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    abort();
   }
   global$0 = $3 + 16 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hd0f2b8018c7d036d($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  alloc__raw_vec__RawVec_T_2cA___grow_amortized__hc340e5268af1101d($3 | 0, $0 | 0, $1 | 0, $2 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$3 >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($3 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    abort();
   }
   global$0 = $3 + 16 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function $core__iter__adapters__ResultShunt_I_2cE__20as_20core__iter__traits__iterator__Iterator___try_fold__haf6fbe5f8305961d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  HEAP32[($2 + 4 | 0) >> 2] = HEAP32[($1 + 12 | 0) >> 2] | 0;
  $core__iter__adapters__map__Map_I_2cF__20as_20core__iter__traits__iterator__Iterator___try_fold__ha2c2d2161829fd45($2 | 0, $1 | 0, $2 + 8 | 0 | 0, $2 + 4 | 0 | 0);
  $1 = HEAPU8[$2 >> 0] | 0;
  HEAP8[($0 + 1 | 0) >> 0] = HEAPU8[($2 + 1 | 0) >> 0] | 0;
  HEAP8[$0 >> 0] = $1 & ($1 | 0) != (2 | 0) | 0;
  global$0 = $2 + 16 | 0;
 }
 
 function memcmp($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0, $5 = 0;
  $3 = 0;
  label$1 : {
   if (!$2) {
    break label$1
   }
   label$2 : {
    label$3 : while (1) {
     $4 = HEAPU8[$0 >> 0] | 0;
     $5 = HEAPU8[$1 >> 0] | 0;
     if (($4 | 0) != ($5 | 0)) {
      break label$2
     }
     $0 = $0 + 1 | 0;
     $1 = $1 + 1 | 0;
     $2 = $2 + -1 | 0;
     if (!$2) {
      break label$1
     }
     continue label$3;
    };
   }
   $3 = $4 - $5 | 0;
  }
  return $3 | 0;
 }
 
 function alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__h0b2b0ab461f4128b($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  label$1 : {
   label$2 : {
    $3 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    if (!$3) {
     break label$2
    }
    HEAP32[($0 + 4 | 0) >> 2] = $3;
    HEAP32[($0 + 8 | 0) >> 2] = HEAPU16[($2 + 224 | 0) >> 1] | 0;
    HEAP32[$0 >> 2] = $1 + 1 | 0;
    break label$1;
   }
   HEAP32[($0 + 4 | 0) >> 2] = 0;
  }
  label$3 : {
   $0 = $1 ? 280 : 232;
   if (!$0) {
    break label$3
   }
   __rust_dealloc($2 | 0, $0 | 0, 8 | 0);
  }
 }
 
 function alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__h0fa9babfafe148cd($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  label$1 : {
   label$2 : {
    $3 = HEAP32[($2 + 176 | 0) >> 2] | 0;
    if (!$3) {
     break label$2
    }
    HEAP32[($0 + 4 | 0) >> 2] = $3;
    HEAP32[($0 + 8 | 0) >> 2] = HEAPU16[($2 + 312 | 0) >> 1] | 0;
    HEAP32[$0 >> 2] = $1 + 1 | 0;
    break label$1;
   }
   HEAP32[($0 + 4 | 0) >> 2] = 0;
  }
  label$3 : {
   $0 = $1 ? 368 : 320;
   if (!$0) {
    break label$3
   }
   __rust_dealloc($2 | 0, $0 | 0, 8 | 0);
  }
 }
 
 function alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__h1ca30957bd01a832($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  label$1 : {
   label$2 : {
    $3 = HEAP32[($2 + 1056 | 0) >> 2] | 0;
    if (!$3) {
     break label$2
    }
    HEAP32[($0 + 4 | 0) >> 2] = $3;
    HEAP32[($0 + 8 | 0) >> 2] = HEAPU16[($2 + 1060 | 0) >> 1] | 0;
    HEAP32[$0 >> 2] = $1 + 1 | 0;
    break label$1;
   }
   HEAP32[($0 + 4 | 0) >> 2] = 0;
  }
  label$3 : {
   $0 = $1 ? 1112 : 1064;
   if (!$0) {
    break label$3
   }
   __rust_dealloc($2 | 0, $0 | 0, 8 | 0);
  }
 }
 
 function alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__h43354c1ef1cf882f($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  label$1 : {
   label$2 : {
    $3 = HEAP32[$2 >> 2] | 0;
    if (!$3) {
     break label$2
    }
    HEAP32[($0 + 4 | 0) >> 2] = $3;
    HEAP32[($0 + 8 | 0) >> 2] = HEAPU16[($2 + 4 | 0) >> 1] | 0;
    HEAP32[$0 >> 2] = $1 + 1 | 0;
    break label$1;
   }
   HEAP32[($0 + 4 | 0) >> 2] = 0;
  }
  label$3 : {
   $0 = $1 ? 364 : 316;
   if (!$0) {
    break label$3
   }
   __rust_dealloc($2 | 0, $0 | 0, 4 | 0);
  }
 }
 
 function alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__h538f90b035d35bbd($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  label$1 : {
   label$2 : {
    $3 = HEAP32[($2 + 88 | 0) >> 2] | 0;
    if (!$3) {
     break label$2
    }
    HEAP32[($0 + 4 | 0) >> 2] = $3;
    HEAP32[($0 + 8 | 0) >> 2] = HEAPU16[($2 + 136 | 0) >> 1] | 0;
    HEAP32[$0 >> 2] = $1 + 1 | 0;
    break label$1;
   }
   HEAP32[($0 + 4 | 0) >> 2] = 0;
  }
  label$3 : {
   $0 = $1 ? 192 : 144;
   if (!$0) {
    break label$3
   }
   __rust_dealloc($2 | 0, $0 | 0, 8 | 0);
  }
 }
 
 function alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__h6b0721a0f3de48e5($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  label$1 : {
   label$2 : {
    $3 = HEAP32[$2 >> 2] | 0;
    if (!$3) {
     break label$2
    }
    HEAP32[($0 + 4 | 0) >> 2] = $3;
    HEAP32[($0 + 8 | 0) >> 2] = HEAPU16[($2 + 136 | 0) >> 1] | 0;
    HEAP32[$0 >> 2] = $1 + 1 | 0;
    break label$1;
   }
   HEAP32[($0 + 4 | 0) >> 2] = 0;
  }
  label$3 : {
   $0 = $1 ? 496 : 448;
   if (!$0) {
    break label$3
   }
   __rust_dealloc($2 | 0, $0 | 0, 4 | 0);
  }
 }
 
 function alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__h7882606ec619d1fb($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  label$1 : {
   label$2 : {
    $3 = HEAP32[$2 >> 2] | 0;
    if (!$3) {
     break label$2
    }
    HEAP32[($0 + 4 | 0) >> 2] = $3;
    HEAP32[($0 + 8 | 0) >> 2] = HEAPU16[($2 + 136 | 0) >> 1] | 0;
    HEAP32[$0 >> 2] = $1 + 1 | 0;
    break label$1;
   }
   HEAP32[($0 + 4 | 0) >> 2] = 0;
  }
  label$3 : {
   $0 = $1 ? 188 : 140;
   if (!$0) {
    break label$3
   }
   __rust_dealloc($2 | 0, $0 | 0, 4 | 0);
  }
 }
 
 function alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__h9fa0dc18db2ee8da($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  label$1 : {
   label$2 : {
    $3 = HEAP32[($2 + 1408 | 0) >> 2] | 0;
    if (!$3) {
     break label$2
    }
    HEAP32[($0 + 4 | 0) >> 2] = $3;
    HEAP32[($0 + 8 | 0) >> 2] = HEAPU16[($2 + 1544 | 0) >> 1] | 0;
    HEAP32[$0 >> 2] = $1 + 1 | 0;
    break label$1;
   }
   HEAP32[($0 + 4 | 0) >> 2] = 0;
  }
  label$3 : {
   $0 = $1 ? 1600 : 1552;
   if (!$0) {
    break label$3
   }
   __rust_dealloc($2 | 0, $0 | 0, 8 | 0);
  }
 }
 
 function alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__hc0a9a6c13e0b7288($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  label$1 : {
   label$2 : {
    $3 = HEAP32[($2 + 440 | 0) >> 2] | 0;
    if (!$3) {
     break label$2
    }
    HEAP32[($0 + 4 | 0) >> 2] = $3;
    HEAP32[($0 + 8 | 0) >> 2] = HEAPU16[($2 + 444 | 0) >> 1] | 0;
    HEAP32[$0 >> 2] = $1 + 1 | 0;
    break label$1;
   }
   HEAP32[($0 + 4 | 0) >> 2] = 0;
  }
  label$3 : {
   $0 = $1 ? 496 : 448;
   if (!$0) {
    break label$3
   }
   __rust_dealloc($2 | 0, $0 | 0, 8 | 0);
  }
 }
 
 function alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__hcf24682c7c7ea3d8($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  label$1 : {
   label$2 : {
    $3 = HEAP32[$2 >> 2] | 0;
    if (!$3) {
     break label$2
    }
    HEAP32[($0 + 4 | 0) >> 2] = $3;
    HEAP32[($0 + 8 | 0) >> 2] = HEAPU16[($2 + 136 | 0) >> 1] | 0;
    HEAP32[$0 >> 2] = $1 + 1 | 0;
    break label$1;
   }
   HEAP32[($0 + 4 | 0) >> 2] = 0;
  }
  label$3 : {
   $0 = $1 ? 496 : 448;
   if (!$0) {
    break label$3
   }
   __rust_dealloc($2 | 0, $0 | 0, 4 | 0);
  }
 }
 
 function alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__hda4ef3fecbd884df($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  label$1 : {
   label$2 : {
    $3 = HEAP32[$2 >> 2] | 0;
    if (!$3) {
     break label$2
    }
    HEAP32[($0 + 4 | 0) >> 2] = $3;
    HEAP32[($0 + 8 | 0) >> 2] = HEAPU16[($2 + 48 | 0) >> 1] | 0;
    HEAP32[$0 >> 2] = $1 + 1 | 0;
    break label$1;
   }
   HEAP32[($0 + 4 | 0) >> 2] = 0;
  }
  label$3 : {
   $0 = $1 ? 100 : 52;
   if (!$0) {
    break label$3
   }
   __rust_dealloc($2 | 0, $0 | 0, 4 | 0);
  }
 }
 
 function alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__he958d708f4ef7fcb($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  label$1 : {
   label$2 : {
    $3 = HEAP32[($2 + 1056 | 0) >> 2] | 0;
    if (!$3) {
     break label$2
    }
    HEAP32[($0 + 4 | 0) >> 2] = $3;
    HEAP32[($0 + 8 | 0) >> 2] = HEAPU16[($2 + 1456 | 0) >> 1] | 0;
    HEAP32[$0 >> 2] = $1 + 1 | 0;
    break label$1;
   }
   HEAP32[($0 + 4 | 0) >> 2] = 0;
  }
  label$3 : {
   $0 = $1 ? 1512 : 1464;
   if (!$0) {
    break label$3
   }
   __rust_dealloc($2 | 0, $0 | 0, 8 | 0);
  }
 }
 
 function alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__hee9d82fa4cb1d72f($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  label$1 : {
   label$2 : {
    $3 = HEAP32[$2 >> 2] | 0;
    if (!$3) {
     break label$2
    }
    HEAP32[($0 + 4 | 0) >> 2] = $3;
    HEAP32[($0 + 8 | 0) >> 2] = HEAPU16[($2 + 136 | 0) >> 1] | 0;
    HEAP32[$0 >> 2] = $1 + 1 | 0;
    break label$1;
   }
   HEAP32[($0 + 4 | 0) >> 2] = 0;
  }
  label$3 : {
   $0 = $1 ? 188 : 140;
   if (!$0) {
    break label$3
   }
   __rust_dealloc($2 | 0, $0 | 0, 4 | 0);
  }
 }
 
 function core__ptr__drop_in_place_cardano_serialization_lib__Header___h8385b81bf98ec4f1($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = $0 + 12 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = $0 + 24 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = $0 + 36 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $1 = $0 + 48 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $0 = $0 + 312 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
 }
 
 function transactionbody_set_validity_start_interval($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, $2 = 0, i64toi32_i32$1 = 0, $3 = 0, $17 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h238818d95bb6c551($2 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = $T_20as_20core__convert__Into_U____into__h09f19f33dddda692($1 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $17 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[(i64toi32_i32$0 + 120 | 0) >> 2] = $17;
  HEAP32[(i64toi32_i32$0 + 124 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  HEAP32[(i64toi32_i32$0 + 112 | 0) >> 2] = 1;
  HEAP32[(i64toi32_i32$0 + 116 | 0) >> 2] = i64toi32_i32$1;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, 0 | 0) | 0;
  global$0 = $2 + 16 | 0;
 }
 
 function transactionbody_set_validity_start_interval_bignum($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, $2 = 0, i64toi32_i32$1 = 0, $3 = 0, $17 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h238818d95bb6c551($2 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hf909e98cc9547671($1 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $17 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[(i64toi32_i32$0 + 120 | 0) >> 2] = $17;
  HEAP32[(i64toi32_i32$0 + 124 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  HEAP32[(i64toi32_i32$0 + 112 | 0) >> 2] = 1;
  HEAP32[(i64toi32_i32$0 + 116 | 0) >> 2] = i64toi32_i32$1;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, 0 | 0) | 0;
  global$0 = $2 + 16 | 0;
 }
 
 function mirtostakecredentials_len($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h74054450d591b36f($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 28 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function withdrawals_len($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h000099354d5ff519($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 28 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function proposedprotocolparameterupdates_len($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h2d6285fb6a1d44f8($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 28 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__ProtocolVersion_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h9cfa3ccfae475694($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $19 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if ($1) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h85bc9e9047d49895($2 + 8 | 0 | 0, $1 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 12 | 0, 4 | 0);
  $19 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $19;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  global$0 = $2 + 16 | 0;
 }
 
 function auxiliarydataset_len($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h786c2d78691f35ff($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 28 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h9bee2257dca46f01($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___shrink__h8bbb3d095485e93b($2 | 0, $0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$2 >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    abort();
   }
   global$0 = $2 + 16 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function __wbg_transactionoutputbuilder_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 112 | 0;
  global$0 = $1;
  $cardano_serialization_lib__output_builder__TransactionOutputBuilder_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h6ef627596ed138b8($1 + 8 | 0 | 0, $0 | 0);
  label$1 : {
   $0 = HEAPU8[($1 + 8 | 0) >> 0] | 0;
   if ((($0 << 29 | 0) >> 29 | 0 | 0) > (-1 | 0)) {
    break label$1
   }
   if (($0 | 0) == (5 | 0)) {
    break label$1
   }
   core__ptr__drop_in_place_core__option__Option_alloc__vec__Vec_u8_____ha5300c747747c3c8($1 + 8 | 0 | 4 | 0 | 0);
  }
  global$0 = $1 + 112 | 0;
 }
 
 function bigint_is_zero($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hb4a7701b5bc2a87c($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAPU8[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 12 | 0) >> 0] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return ($0 | 0) == (1 | 0) | 0;
 }
 
 function cardano_serialization_lib__utils__BigInt__to_str__h54985d40d9e183db($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 48 | 0;
  global$0 = $2;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[$0 >> 2] = HEAP32[(0 + 1057668 | 0) >> 2] | 0;
  core__fmt__Formatter__new__he219faf25326051b($2 | 0, $0 | 0, 1057336 | 0);
  label$1 : {
   if (!($num_bigint__bigint__BigInt_20as_20core__fmt__Display___fmt__h1c76768a124ae632($1 | 0, $2 | 0) | 0)) {
    break label$1
   }
   core__result__unwrap_failed__h27f43d993c3864a1(1057360 | 0, 55 | 0, $2 + 40 | 0 | 0, 1057552 | 0, 1057492 | 0);
   abort();
  }
  global$0 = $2 + 48 | 0;
 }
 
 function metadatamap_len($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h74f2437fd791f127($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 28 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function generaltransactionmetadata_len($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h670b86b1bfb2242f($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 28 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__hash__Hash___hash__had3058f1af5ae20b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  label$1 : {
   $2 = HEAP32[($0 + 32 | 0) >> 2] | 0;
   if (!$2) {
    break label$1
   }
   $0 = HEAP32[($2 + 100 | 0) >> 2] | 0;
   if (($0 | 0) == ($2 | 0)) {
    break label$1
   }
   if (!$0) {
    break label$1
   }
   label$2 : while (1) {
    $3 = HEAP32[($0 + 100 | 0) >> 2] | 0;
    $cardano_serialization_lib__metadata__TransactionMetadatumEnum_20as_20core__hash__Hash___hash__hfff2aa722e4e1880($0 | 0, $1 | 0);
    $cardano_serialization_lib__metadata__TransactionMetadatumEnum_20as_20core__hash__Hash___hash__hfff2aa722e4e1880($0 + 48 | 0 | 0, $1 | 0);
    if (($3 | 0) == ($2 | 0)) {
     break label$1
    }
    $0 = $3;
    if ($0) {
     continue label$2
    }
    break label$2;
   };
  }
 }
 
 function transactionbuilder_set_ttl($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, $2 = 0, i64toi32_i32$1 = 0, $3 = 0, $17 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h5566e1c7d4aafe35($2 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = $T_20as_20core__convert__Into_U____into__h09f19f33dddda692($1 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $17 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[(i64toi32_i32$0 + 280 | 0) >> 2] = $17;
  HEAP32[(i64toi32_i32$0 + 284 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  HEAP32[(i64toi32_i32$0 + 272 | 0) >> 2] = 1;
  HEAP32[(i64toi32_i32$0 + 276 | 0) >> 2] = i64toi32_i32$1;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, 0 | 0) | 0;
  global$0 = $2 + 16 | 0;
 }
 
 function transactionbuilder_set_validity_start_interval($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, $2 = 0, i64toi32_i32$1 = 0, $3 = 0, $17 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h5566e1c7d4aafe35($2 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = $T_20as_20core__convert__Into_U____into__h09f19f33dddda692($1 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $17 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[(i64toi32_i32$0 + 408 | 0) >> 2] = $17;
  HEAP32[(i64toi32_i32$0 + 412 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  HEAP32[(i64toi32_i32$0 + 400 | 0) >> 2] = 1;
  HEAP32[(i64toi32_i32$0 + 404 | 0) >> 2] = i64toi32_i32$1;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, 0 | 0) | 0;
  global$0 = $2 + 16 | 0;
 }
 
 function transactionbuilder_set_validity_start_interval_bignum($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, $2 = 0, i64toi32_i32$1 = 0, $3 = 0, $17 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h5566e1c7d4aafe35($2 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  $3 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hf909e98cc9547671($1 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $17 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[(i64toi32_i32$0 + 408 | 0) >> 2] = $17;
  HEAP32[(i64toi32_i32$0 + 412 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  HEAP32[(i64toi32_i32$0 + 400 | 0) >> 2] = 1;
  HEAP32[(i64toi32_i32$0 + 404 | 0) >> 2] = i64toi32_i32$1;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, 0 | 0) | 0;
  global$0 = $2 + 16 | 0;
 }
 
 function $cardano_serialization_lib__crypto__VRFCert_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hc597ed79f1e184d4($0) {
  $0 = $0 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $1 = 0, $7 = 0, $12 = 0, $17 = 0;
  label$1 : {
   $1 = __rust_alloc(28 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(28 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = $7;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $12 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 12 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $12;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$2 = $0 + 16 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $17 = i64toi32_i32$0;
  i64toi32_i32$0 = $1 + 20 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $17;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  return $1 | 0;
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hb600accf9d1c2a17($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[$0 >> 2] | 0;
   $1 = Math_imul($1, 28);
   label$2 : while (1) {
    label$3 : {
     if (!(HEAPU16[$0 >> 1] | 0)) {
      break label$3
     }
     $2 = $0 + 4 | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($2 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($2 | 0);
    }
    $0 = $0 + 28 | 0;
    $1 = $1 + -28 | 0;
    if ($1) {
     continue label$2
    }
    break label$2;
   };
  }
 }
 
 function $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__h52f1a1239f0bb749($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__next_or_end__hf4cf31cdff93ec77($1 | 0, $0 | 0);
  label$1 : {
   $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   if (!$2) {
    break label$1
   }
   label$2 : while (1) {
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hebed8fd85cb76c41(($2 + Math_imul(HEAP32[($1 + 8 | 0) >> 2] | 0, 12) | 0) + 4 | 0 | 0);
    $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__next_or_end__hf4cf31cdff93ec77($1 | 0, $0 | 0);
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if ($2) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $1 + 16 | 0;
 }
 
 function $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__h55ccecf13401bd6c($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__next_or_end__haeb0a9f36af8f317($1 | 0, $0 | 0);
  label$1 : {
   $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   if (!$2) {
    break label$1
   }
   label$2 : while (1) {
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h0265580a5be10b66(($2 + Math_imul(HEAP32[($1 + 8 | 0) >> 2] | 0, 12) | 0) + 4 | 0 | 0);
    $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__next_or_end__haeb0a9f36af8f317($1 | 0, $0 | 0);
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if ($2) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $1 + 16 | 0;
 }
 
 function $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__h6efa1169fdfacf7e($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__next_or_end__hfa088ac4e38a1cd5($1 | 0, $0 | 0);
  label$1 : {
   $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   if (!$2) {
    break label$1
   }
   label$2 : while (1) {
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h6c9f94f0f82ce2b5(($2 + Math_imul(HEAP32[($1 + 8 | 0) >> 2] | 0, 12) | 0) + 4 | 0 | 0);
    $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__next_or_end__hfa088ac4e38a1cd5($1 | 0, $0 | 0);
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if ($2) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $1 + 16 | 0;
 }
 
 function __wbg_txinputsbuilder_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  $cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hee313210dd0eeab7($1 | 0, $0 | 0);
  $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h7d849e3c4cfb66e1($1 + 64 | 0 | 0);
  $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h04a6b671c790649f($1 + 40 | 0 | 0);
  $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__h53e9081b9841de3b($1 | 0);
  label$1 : {
   if (!(HEAP32[($1 + 16 | 0) >> 2] | 0)) {
    break label$1
   }
   hashbrown__raw__RawTable_T_2cA___free_buckets__h34c0615f72d0114a($1 + 16 | 0 | 0);
  }
  $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__hb1ec706811634e79($1 + 52 | 0 | 0);
  global$0 = $1 + 80 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h2f0517af2eff7407($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___shrink__h45d229397ea2ceca($2 | 0, $0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$2 >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    abort();
   }
   global$0 = $2 + 16 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___shrink__h9d96a5e710402ac8($2 | 0, $0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$2 >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    abort();
   }
   global$0 = $2 + 16 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__h568c725c749c3744($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  label$1 : {
   label$2 : {
    $3 = HEAP32[($2 + 264 | 0) >> 2] | 0;
    if (!$3) {
     break label$2
    }
    HEAP32[($0 + 4 | 0) >> 2] = $3;
    HEAP32[($0 + 8 | 0) >> 2] = HEAPU16[($2 + 400 | 0) >> 1] | 0;
    HEAP32[$0 >> 2] = $1 + 1 | 0;
    break label$1;
   }
   HEAP32[($0 + 4 | 0) >> 2] = 0;
  }
  label$3 : {
   $0 = $1 ? 456 : 408;
   if (!$0) {
    break label$3
   }
   __rust_dealloc($2 | 0, $0 | 0, 8 | 0);
  }
 }
 
 function alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h3c2ae8f02af6ab27($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  alloc__raw_vec__RawVec_T_2cA___shrink__h4ebe6754097b6904($2 | 0, $0 | 0, $1 | 0);
  label$1 : {
   label$2 : {
    if ((HEAP32[$2 >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__alloc__handle_alloc_error__he269d8f1bff90960(HEAP32[($2 + 4 | 0) >> 2] | 0 | 0, $0 | 0);
    abort();
   }
   global$0 = $2 + 16 | 0;
   return;
  }
  alloc__raw_vec__capacity_overflow__h51312004a31f0ea6();
  abort();
 }
 
 function $cryptoxide__chacha20poly1305__Tag_20as_20core__cmp__PartialEq___eq__ha1b5a4e4dff7c1e7($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$5 = 0, $3$hi = 0, $2 = 0, $3 = 0, $4$hi = 0, $16 = 0, $18 = 0, $19 = 0, $4 = 0, $17 = 0, $17$hi = 0, $25 = 0, $25$hi = 0;
  i64toi32_i32$0 = 0;
  $3 = 0;
  $3$hi = i64toi32_i32$0;
  $2 = 0;
  label$1 : while (1) {
   i64toi32_i32$0 = $3$hi;
   $4 = $3;
   $4$hi = i64toi32_i32$0;
   i64toi32_i32$0 = 0;
   i64toi32_i32$2 = (HEAPU8[($1 + $2 | 0) >> 0] | 0) ^ (HEAPU8[($0 + $2 | 0) >> 0] | 0) | 0;
   i64toi32_i32$1 = 0;
   i64toi32_i32$3 = 255;
   i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
   $17 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
   $17$hi = i64toi32_i32$1;
   i64toi32_i32$1 = $3$hi;
   i64toi32_i32$0 = $3;
   i64toi32_i32$2 = $17$hi;
   i64toi32_i32$3 = $17;
   i64toi32_i32$2 = i64toi32_i32$1 | i64toi32_i32$2 | 0;
   $3 = i64toi32_i32$0 | i64toi32_i32$3 | 0;
   $3$hi = i64toi32_i32$2;
   $2 = $2 + 1 | 0;
   if (($2 | 0) != (16 | 0)) {
    continue label$1
   }
   break label$1;
  };
  i64toi32_i32$2 = $4$hi;
  i64toi32_i32$2 = $3$hi;
  i64toi32_i32$2 = 0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$0 = $3$hi;
  i64toi32_i32$3 = $3;
  i64toi32_i32$5 = (i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0) + i64toi32_i32$0 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 - i64toi32_i32$5 | 0;
  $25 = i64toi32_i32$1 - i64toi32_i32$3 | 0;
  $25$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $4$hi;
  i64toi32_i32$2 = $4;
  i64toi32_i32$1 = $25$hi;
  i64toi32_i32$3 = $25;
  i64toi32_i32$1 = i64toi32_i32$5 | i64toi32_i32$1 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  i64toi32_i32$2 = -1;
  i64toi32_i32$3 = -1;
  if ((i64toi32_i32$1 | 0) > (i64toi32_i32$2 | 0)) {
   $16 = 1
  } else {
   if ((i64toi32_i32$1 | 0) >= (i64toi32_i32$2 | 0)) {
    if (i64toi32_i32$5 >>> 0 <= i64toi32_i32$3 >>> 0) {
     $18 = 0
    } else {
     $18 = 1
    }
    $19 = $18;
   } else {
    $19 = 0
   }
   $16 = $19;
  }
  return $16 | 0;
 }
 
 function core__ptr__drop_in_place_std__io__Write__write_fmt__Adaptor__mut_20_5bu8_5d____he8cfb01d7b5518f6($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $3 = 0;
  label$1 : {
   if ((HEAPU8[($0 + 4 | 0) >> 0] | 0 | 0) != (3 | 0)) {
    break label$1
   }
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   FUNCTION_TABLE[HEAP32[(HEAP32[($1 + 4 | 0) >> 2] | 0) >> 2] | 0 | 0](HEAP32[$1 >> 2] | 0);
   label$2 : {
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    $3 = HEAP32[($2 + 4 | 0) >> 2] | 0;
    if (!$3) {
     break label$2
    }
    __rust_dealloc(HEAP32[$1 >> 2] | 0 | 0, $3 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0);
   }
   __rust_dealloc(HEAP32[($0 + 8 | 0) >> 2] | 0 | 0, 12 | 0, 4 | 0);
  }
 }
 
 function core__fmt__Formatter__pad_integral__write_prefix__hab8c9d07f4973a84($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     if (($1 | 0) == (1114112 | 0)) {
      break label$3
     }
     $4 = 1;
     if (FUNCTION_TABLE[HEAP32[((HEAP32[($0 + 28 | 0) >> 2] | 0) + 16 | 0) >> 2] | 0 | 0](HEAP32[($0 + 24 | 0) >> 2] | 0, $1) | 0) {
      break label$2
     }
    }
    if ($2) {
     break label$1
    }
    $4 = 0;
   }
   return $4 | 0;
  }
  return FUNCTION_TABLE[HEAP32[((HEAP32[($0 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($0 + 24 | 0) >> 2] | 0, $2, $3) | 0 | 0;
 }
 
 function protocolparamupdate_set_max_value_size($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h0a71cd742026514d($2 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  HEAP32[($0 + 352 | 0) >> 2] = $1;
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  HEAP32[($0 + 348 | 0) >> 2] = 1;
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, 0 | 0) | 0;
  global$0 = $2 + 16 | 0;
 }
 
 function protocolparamupdate_set_collateral_percentage($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h0a71cd742026514d($2 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  HEAP32[($0 + 360 | 0) >> 2] = $1;
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  HEAP32[($0 + 356 | 0) >> 2] = 1;
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, 0 | 0) | 0;
  global$0 = $2 + 16 | 0;
 }
 
 function protocolparamupdate_set_max_collateral_inputs($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h0a71cd742026514d($2 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($2 + 8 | 0) >> 2] | 0;
  HEAP32[($0 + 368 | 0) >> 2] = $1;
  $1 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  HEAP32[($0 + 364 | 0) >> 2] = 1;
  core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, 0 | 0) | 0;
  global$0 = $2 + 16 | 0;
 }
 
 function cardano_serialization_lib__chain_crypto__bech32__Error__data_invalid__hc2670bad9cc16601($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   $2 = __rust_alloc(12 | 0, 4 | 0) | 0;
   if ($2) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(12 | 0, 4 | 0);
   abort();
  }
  HEAP32[($0 + 4 | 0) >> 2] = $2;
  HEAP32[$0 >> 2] = 2;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  HEAP32[$2 >> 2] = HEAP32[$1 >> 2] | 0;
  HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($0 + 8 | 0) >> 2] = 1056536;
  HEAP32[($2 + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
 }
 
 function bignum_is_zero($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($1 + 8 | 0 | 0, $0 | 0);
  i64toi32_i32$2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $2 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return !($2 | i64toi32_i32$1 | 0) | 0;
 }
 
 function cryptoxide__cryptoutil__FixedBuffer_____next__h1344043422db2ab6($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = HEAP32[$0 >> 2] | 0;
  $2 = $1 + 16 | 0;
  HEAP32[$0 >> 2] = $2;
  label$1 : {
   label$2 : {
    if ($1 >>> 0 > -17 >>> 0) {
     break label$2
    }
    if ($2 >>> 0 > 128 >>> 0) {
     break label$1
    }
    return ($0 + $1 | 0) + 4 | 0 | 0;
   }
   core__slice__index__slice_index_order_fail__h71e247dec3f266ff($1 | 0, $2 | 0, 1102808 | 0);
   abort();
  }
  core__slice__index__slice_end_index_len_fail__h192505a15ac4b345($2 | 0, 128 | 0, 1102808 | 0);
  abort();
 }
 
 function core__iter__adapters__zip__Zip_A_2cB___new__h5300198459615e1f($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  HEAP32[($0 + 16 | 0) >> 2] = 0;
  HEAP32[($0 + 8 | 0) >> 2] = $3;
  HEAP32[($0 + 4 | 0) >> 2] = $2;
  HEAP32[$0 >> 2] = $1;
  $1 = $2 - $1 | 0;
  HEAP32[($0 + 24 | 0) >> 2] = $1;
  HEAP32[($0 + 12 | 0) >> 2] = $4;
  $4 = $4 - $3 | 0;
  HEAP32[($0 + 20 | 0) >> 2] = $1 >>> 0 > $4 >>> 0 ? $4 : $1;
 }
 
 function core__f64___impl_20f64___classify__h32c2038c9bc8621a($0) {
  $0 = +$0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, $2 = 0, $2$hi = 0, $3 = 0, $1 = 0, $3$hi = 0;
  label$1 : {
   wasm2js_scratch_store_f64(+$0);
   i64toi32_i32$0 = wasm2js_scratch_load_i32(1 | 0) | 0;
   $2 = wasm2js_scratch_load_i32(0 | 0) | 0;
   $2$hi = i64toi32_i32$0;
   i64toi32_i32$2 = $2;
   i64toi32_i32$1 = 2147483647;
   i64toi32_i32$3 = -1;
   i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
   if (!!(i64toi32_i32$2 & i64toi32_i32$3 | 0 | i64toi32_i32$1 | 0)) {
    break label$1
   }
   return 2 | 0;
  }
  label$2 : {
   label$3 : {
    i64toi32_i32$1 = $2$hi;
    i64toi32_i32$0 = $2;
    i64toi32_i32$2 = 2146435072;
    i64toi32_i32$3 = 0;
    i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$2 | 0;
    $3 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
    $3$hi = i64toi32_i32$2;
    i64toi32_i32$1 = $3;
    i64toi32_i32$0 = 2146435072;
    i64toi32_i32$3 = 0;
    if ((i64toi32_i32$1 | 0) == (i64toi32_i32$3 | 0) & (i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) | 0) {
     break label$3
    }
    $1 = 4;
    i64toi32_i32$1 = $3$hi;
    i64toi32_i32$3 = $3;
    i64toi32_i32$2 = 0;
    i64toi32_i32$0 = 0;
    if ((i64toi32_i32$3 | 0) != (i64toi32_i32$0 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$2 | 0) | 0) {
     break label$2
    }
    return 3 | 0;
   }
   i64toi32_i32$3 = $2$hi;
   i64toi32_i32$0 = $2;
   i64toi32_i32$1 = 1048575;
   i64toi32_i32$2 = -1;
   i64toi32_i32$1 = i64toi32_i32$3 & i64toi32_i32$1 | 0;
   $1 = !(i64toi32_i32$0 & i64toi32_i32$2 | 0 | i64toi32_i32$1 | 0);
  }
  return $1 | 0;
 }
 
 function core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__plutus__PlutusList____h410d2d25125e861e($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  label$1 : {
   if ((HEAPU8[($0 + 12 | 0) >> 0] | 0 | 0) == (3 | 0)) {
    break label$1
   }
   label$2 : {
    $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
    if (!$1) {
     break label$2
    }
    $2 = HEAP32[$0 >> 2] | 0;
    $1 = Math_imul($1, 48);
    label$3 : while (1) {
     core__ptr__drop_in_place_cardano_serialization_lib__plutus__PlutusData___hfab843e66e0f9428_2($2 | 0);
     $2 = $2 + 48 | 0;
     $1 = $1 + -48 | 0;
     if ($1) {
      continue label$3
     }
     break label$3;
    };
   }
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h36e817e704f6f25e($0 | 0);
  }
 }
 
 function transaction_is_valid($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h70df86682e940485($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAPU8[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 420 | 0) >> 0] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function transactioninputs_len($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hf2abefb15e68f011($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 8 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function transactionoutputs_len($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h6185b44b866d43f0($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 8 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function certificates_len($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h0d8537c364f480d5($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 8 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function transactioninput_index($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hd7bc050864a8d646($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[(HEAP32[($1 + 8 | 0) >> 2] | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function ed25519keyhashes_len($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h38787c785ea84973($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 8 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function relays_len($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hdcd31189477e1360($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 8 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function poolretirement_epoch($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h77d6f4a2273f50b5($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[(HEAP32[($1 + 8 | 0) >> 2] | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function certificate_kind($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h3b62e22150831bdc($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAPU8[(HEAP32[($1 + 8 | 0) >> 2] | 0) >> 0] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function moveinstantaneousreward_pot($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h84b5bdabb1c1c80b($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAPU8[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 48 | 0) >> 0] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function moveinstantaneousreward_kind($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h84b5bdabb1c1c80b($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[(HEAP32[($1 + 8 | 0) >> 2] | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__Ipv4_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h5d10bcbd75649752($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hc5dae48d2a6017b6($1 + 8 | 0 | 0, $0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($1 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  $2 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($0 | 0) | 0 | 0, 8 | 0, 4 | 0);
  global$0 = $1 + 16 | 0;
  return $2 | 0;
 }
 
 function relay_kind($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hb17ff77b9b324998($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAPU16[(HEAP32[($1 + 8 | 0) >> 2] | 0) >> 1] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function stakecredentials_len($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h99bd8393a0065b1d($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 8 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function rewardaddresses_len($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h18a4570cc8a3407a($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 8 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function transactionwitnessset_new() {
  var $0 = 0, $1 = 0;
  $0 = global$0 - 80 | 0;
  global$0 = $0;
  HEAP8[($0 + 60 | 0) >> 0] = 3;
  HEAP32[($0 + 64 | 0) >> 2] = 0;
  HEAP32[($0 + 36 | 0) >> 2] = 0;
  HEAP32[($0 + 24 | 0) >> 2] = 0;
  HEAP32[($0 + 12 | 0) >> 2] = 0;
  HEAP32[$0 >> 2] = 0;
  $1 = $cardano_serialization_lib__TransactionWitnessSet_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h15af3a22f8db3dff($0 | 0) | 0;
  global$0 = $0 + 80 | 0;
  return $1 | 0;
 }
 
 function scriptnofk_n($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__he533e1773e537fcd($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[(HEAP32[($1 + 8 | 0) >> 2] | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__TimelockStart_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h9937d451f04455a1($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hd050e13480afb3ab($1 + 8 | 0 | 0, $0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($1 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$0 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($0 + 12 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($0 | 0) | 0 | 0, 16 | 0, 8 | 0);
  global$0 = $1 + 16 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$1;
  return i64toi32_i32$0 | 0;
 }
 
 function $cardano_serialization_lib__TimelockExpiry_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hb0d6bb7b9aea3e82($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h732ca94bf7b0fcbd($1 + 8 | 0 | 0, $0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($1 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$0 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($0 + 12 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($0 | 0) | 0 | 0, 16 | 0, 8 | 0);
  global$0 = $1 + 16 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$1;
  return i64toi32_i32$0 | 0;
 }
 
 function nativescript_kind($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h6ed0b6b043905434($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAPU8[(HEAP32[($1 + 8 | 0) >> 2] | 0) >> 0] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function nativescripts_len($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hbfc7b2ba05921680($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 8 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function update_epoch($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h20ee1b39869b5e8f($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 40 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function genesishashes_len($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h419753218ead1831($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 8 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function scripthashes_len($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hca2e1c7f0251c418($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 8 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function protocolversion_major($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h42c8face5b925abb($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[(HEAP32[($1 + 8 | 0) >> 2] | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function protocolversion_minor($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h42c8face5b925abb($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function protocolversions_len($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__ha45853a045a59ee7($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 8 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function transactionbodies_len($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hfefec6c3ca92202d($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 8 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function transactionwitnesssets_len($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h0fe7af65622a319f($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 8 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function operationalcert_sequence_number($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h4b15d475a6cbc138($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[(HEAP32[($1 + 8 | 0) >> 2] | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function operationalcert_kes_period($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h4b15d475a6cbc138($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 4 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function headerbody_block_number($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h2ac16fcb64db16b5($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 8 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function headerbody_block_body_size($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h2ac16fcb64db16b5($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 60 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function assetnames_len($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h38bb6325d5b407e9($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 8 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function assets_len($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h91e3d4f7af3d2ccd($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 8 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function multiasset_len($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h9968e42c55861cec($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 8 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function mintassets_len($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h59b9713b6e595a95($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 8 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function mint_len($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h8348e40d8f63e5f1($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 8 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__NetworkId_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hd21586ed92357b19($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h0746217235ca17c1($1 + 8 | 0 | 0, $0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($1 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  $2 = HEAPU8[($0 + 4 | 0) >> 0] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($0 | 0) | 0 | 0, 8 | 0, 4 | 0);
  global$0 = $1 + 16 | 0;
  return $2 | 0;
 }
 
 function networkid_kind($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h4f79d4afa0b85c1a($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAPU8[(HEAP32[($1 + 8 | 0) >> 2] | 0) >> 0] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function __wbg_transactionoutputamountbuilder_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 128 | 0;
  global$0 = $1;
  $cardano_serialization_lib__output_builder__TransactionOutputAmountBuilder_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__ha2e5d09f03937507($1 | 0, $0 | 0);
  label$1 : {
   if ((HEAPU8[$1 >> 0] | 0) >>> 0 < 4 >>> 0) {
    break label$1
   }
   core__ptr__drop_in_place_core__option__Option_alloc__vec__Vec_u8_____ha5300c747747c3c8($1 | 4 | 0 | 0);
  }
  label$2 : {
   switch (HEAP32[($1 + 72 | 0) >> 2] | 0 | 0) {
   default:
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($1 + 76 | 0 | 0);
    break;
   case 0:
   case 2:
    break label$2;
   };
  }
  global$0 = $1 + 128 | 0;
 }
 
 function transactionunspentoutputs_len($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h2b38e1d613820f8e($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 8 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hf909e98cc9547671($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h8d7fffc515cd56d6($1 + 8 | 0 | 0, $0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($1 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  i64toi32_i32$0 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($0 + 12 | 0) >> 2] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($0 | 0) | 0 | 0, 16 | 0, 8 | 0);
  global$0 = $1 + 16 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$1;
  return i64toi32_i32$0 | 0;
 }
 
 function metadatalist_len($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h14eb25306bbe3311($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 8 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function transactionmetadatum_kind($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hc630c86c4ab6b26d($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[(HEAP32[($1 + 8 | 0) >> 2] | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function transactionmetadatumlabels_len($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h0497bf4a59b2a68b($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 8 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function vkeys_len($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hcbf9fa57042ff117($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 8 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function vkeywitnesses_len($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h2c8b1c7122d0d2b0($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 8 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function bootstrapwitnesses_len($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hab914e4e14c49c39($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 8 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function publickeys_size($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__he8e3d260cc550142($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 8 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h28dc4dde55fe2f07($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[$0 >> 2] | 0;
   $2 = $0 + Math_imul($1, 120) | 0;
   label$2 : while (1) {
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
    $1 = $0 + 12 | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
    $0 = $0 + 120 | 0;
    if (($0 | 0) != ($2 | 0)) {
     continue label$2
    }
    break label$2;
   };
  }
 }
 
 function plutuswitnesses_len($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hff8ea54f5a18a01d($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 8 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function txinputsbuilder_len($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h2150b2b2433b33e4($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 72 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function networkinfo_network_id($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hf87f6527083f250a($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAPU8[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 4 | 0) >> 0] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function networkinfo_protocol_magic($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hf87f6527083f250a($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[(HEAP32[($1 + 8 | 0) >> 2] | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function stakecredential_kind($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h7d8a0640f2deb41e($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAPU8[(HEAP32[($1 + 8 | 0) >> 2] | 0) >> 0] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function plutusscripts_len($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hbb8371c94476a171($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 8 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function costmdls_len($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h0e53d0166415c79c($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 8 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function languages_len($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h0848e1414118541a($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 8 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function plutusmap_len($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hc838c9a2ed8b7fab($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 8 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function plutusdata_kind($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hb1fd14a6870cafe2($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[(HEAP32[($1 + 8 | 0) >> 2] | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function plutuslist_len($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hd98e995abd746618($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 8 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__plutus__RedeemerTag_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h68accfd31b252935($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__he19e93a673b26304($1 + 8 | 0 | 0, $0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($1 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  $2 = HEAPU8[($0 + 4 | 0) >> 0] | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($0 | 0) | 0 | 0, 8 | 0, 4 | 0);
  global$0 = $1 + 16 | 0;
  return $2 | 0;
 }
 
 function redeemertag_kind($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h8eb054d444413163($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAPU8[(HEAP32[($1 + 8 | 0) >> 2] | 0) >> 0] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function redeemers_len($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h6789b4b005d0c63f($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 8 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function strings_len($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__h60bb016b22d9de75($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 8 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($2 | 0, (HEAP32[$2 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend__T_2ccore__slice__iter__Iter_T_____spec_extend__hbd860717b01c36cd($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  label$1 : {
   $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   $2 = $2 - $1 | 0;
   if (((HEAP32[($0 + 4 | 0) >> 2] | 0) - $3 | 0) >>> 0 >= $2 >>> 0) {
    break label$1
   }
   alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__he90fb3a4f4cd283b($0 | 0, $3 | 0, $2 | 0);
   $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  }
  memcpy((HEAP32[$0 >> 2] | 0) + $3 | 0 | 0, $1 | 0, $2 | 0) | 0;
  HEAP32[($0 + 8 | 0) >> 2] = $3 + $2 | 0;
 }
 
 function alloc__slice___impl_20alloc__borrow__ToOwned_20for_20_5bT_5d___to_owned__hd844e9587e1fb800($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $4 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h7a1502fe40e71cf9($3 + 8 | 0 | 0, $2 | 0, 0 | 0);
  $4 = HEAP32[($3 + 8 | 0) >> 2] | 0;
  HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($3 + 12 | 0) >> 2] | 0;
  HEAP32[$0 >> 2] = $4;
  memcpy($4 | 0, $1 | 0, $2 | 0) | 0;
  HEAP32[($0 + 8 | 0) >> 2] = $2;
  global$0 = $3 + 16 | 0;
 }
 
 function core__ptr__drop_in_place_rand_core__error__Error___h93f554cc6cc9aba6($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $2 = $0 + 12 | 0;
   FUNCTION_TABLE[HEAP32[(HEAP32[$2 >> 2] | 0) >> 2] | 0 | 0]($1);
   $1 = HEAP32[$2 >> 2] | 0;
   $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   $1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   $0 = $T_20as_20core__convert__Into_U____into__h6ba7948e905b65a3(HEAP32[($0 + 8 | 0) >> 2] | 0 | 0) | 0;
   if (!$1) {
    break label$1
   }
   __rust_dealloc($0 | 0, $1 | 0, $2 | 0);
  }
 }
 
 function cryptoxide__blake2b__Blake2b__blake2b__hfbfc741a485cb529($0, $1, $2, $3, $4, $5) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  $5 = $5 | 0;
  var $6 = 0, $7 = 0;
  $6 = global$0;
  $7 = $6;
  $6 = ($6 - 320 | 0) & -32 | 0;
  global$0 = $6;
  label$1 : {
   label$2 : {
    if ($5) {
     break label$2
    }
    cryptoxide__blake2b__Blake2b__new__h7b5a594785d7b8da($6 | 0, $1 | 0);
    break label$1;
   }
   cryptoxide__blake2b__Blake2b__new_keyed__h8b7c7390e3d049ce($6 | 0, $1 | 0, $4 | 0, $5 | 0);
  }
  cryptoxide__blake2b__Blake2b__update__hecb3567baa77731d($6 | 0, $2 | 0, $3 | 0);
  cryptoxide__blake2b__Blake2b__finalize__h8a0df5452d79555d($6 | 0, $0 | 0, $1 | 0);
  global$0 = $7;
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend__T_2ccore__slice__iter__Iter_T_____spec_extend__hd63284b6e6fa3c45($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  label$1 : {
   $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   $2 = $2 - $1 | 0;
   if (((HEAP32[($0 + 4 | 0) >> 2] | 0) - $3 | 0) >>> 0 >= $2 >>> 0) {
    break label$1
   }
   alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hace6da240d5ba1ef($0 | 0, $3 | 0, $2 | 0);
   $3 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  }
  memcpy((HEAP32[$0 >> 2] | 0) + $3 | 0 | 0, $1 | 0, $2 | 0) | 0;
  HEAP32[($0 + 8 | 0) >> 2] = $3 + $2 | 0;
 }
 
 function core__ptr__drop_in_place_cardano_serialization_lib__CertificateEnum___h537567b60c24bc16($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   label$2 : {
    $1 = HEAPU8[$0 >> 0] | 0;
    if ($1 >>> 0 > 5 >>> 0) {
     break label$2
    }
    if (($1 | 0) != (3 | 0)) {
     break label$1
    }
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h72de9eab2f0e4669($0 + 40 | 0 | 0);
    $1 = $0 + 52 | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hb600accf9d1c2a17($1 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h96b3170d440e3692($1 | 0);
    core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__PoolMetadata____hb1232757542ed318($0 + 64 | 0 | 0);
    return;
   }
   core__ptr__drop_in_place_cardano_serialization_lib__MIREnum___h06315a825cbe6fa9($0 + 8 | 0 | 0);
  }
 }
 
 function transaction_set_is_valid($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h86c452d6d75acdae($2 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($2 + 12 | 0) >> 2] | 0;
  HEAP8[((HEAP32[($2 + 8 | 0) >> 2] | 0) + 420 | 0) >> 0] = ($1 | 0) != (0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, 0 | 0) | 0;
  global$0 = $2 + 16 | 0;
 }
 
 function cardano_serialization_lib__metadata__TransactionMetadatumLabels__add__h167a70796c770223($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $2 = 0, $2$hi = 0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $2 = i64toi32_i32$0;
  $2$hi = i64toi32_i32$1;
  label$1 : {
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (($1 | 0) != (HEAP32[($0 + 4 | 0) >> 2] | 0 | 0)) {
    break label$1
   }
   alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h747ed10c49fb1468($0 | 0, $1 | 0, 1 | 0);
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  }
  i64toi32_i32$1 = $2$hi;
  i64toi32_i32$0 = (HEAP32[$0 >> 2] | 0) + ($1 << 3 | 0) | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $2;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($0 + 8 | 0) >> 2] | 0) + 1 | 0;
 }
 
 function $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__h5612307da16e6eb2($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $18 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h5dada854c892eb3e($3 + 8 | 0 | 0, ($2 - $1 | 0) >>> 7 | 0 | 0, 0 | 0);
  i64toi32_i32$0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[$0 >> 2] = $18;
  HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend_T_2cI____spec_extend__h0b164968e8398b77($0 | 0, $1 | 0, $2 | 0);
  global$0 = $3 + 16 | 0;
 }
 
 function $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter_nested__SpecFromIterNested_T_2cI____from_iter__h63a833c86dce75cf($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $18 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__h404b2b8ae2314e41($3 + 8 | 0 | 0, ($2 - $1 | 0) >>> 2 | 0 | 0, 0 | 0);
  i64toi32_i32$0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  $18 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[$0 >> 2] = $18;
  HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend_T_2cI____spec_extend__hbaad8954f24f14f7($0 | 0, $1 | 0, $2 | 0);
  global$0 = $3 + 16 | 0;
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___iter__h3ab6a151beb58e6b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  label$1 : {
   label$2 : {
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$2) {
     break label$2
    }
    $3 = HEAP32[$1 >> 2] | 0;
    alloc__collections__btree__navigate__full_range__h605bcb95cf10e0c9($0 | 0, $3 | 0, $2 | 0, $3 | 0, $2 | 0);
    $1 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    break label$1;
   }
   $1 = 0;
   HEAP32[($0 + 4 | 0) >> 2] = 0;
   HEAP32[($0 + 16 | 0) >> 2] = 0;
  }
  HEAP32[($0 + 24 | 0) >> 2] = $1;
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___iter__h677e802ff7e211c3($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  label$1 : {
   label$2 : {
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$2) {
     break label$2
    }
    $3 = HEAP32[$1 >> 2] | 0;
    alloc__collections__btree__navigate__full_range__hd4dadfd3315a2ab8($0 | 0, $3 | 0, $2 | 0, $3 | 0, $2 | 0);
    $1 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    break label$1;
   }
   $1 = 0;
   HEAP32[($0 + 4 | 0) >> 2] = 0;
   HEAP32[($0 + 16 | 0) >> 2] = 0;
  }
  HEAP32[($0 + 24 | 0) >> 2] = $1;
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___iter__h1146c826d3183069($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  label$1 : {
   label$2 : {
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$2) {
     break label$2
    }
    $3 = HEAP32[$1 >> 2] | 0;
    alloc__collections__btree__navigate__full_range__h5b801627b554f176($0 | 0, $3 | 0, $2 | 0, $3 | 0, $2 | 0);
    $1 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    break label$1;
   }
   $1 = 0;
   HEAP32[($0 + 4 | 0) >> 2] = 0;
   HEAP32[($0 + 16 | 0) >> 2] = 0;
  }
  HEAP32[($0 + 24 | 0) >> 2] = $1;
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___iter__hbe8f4ddb910904b5($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  label$1 : {
   label$2 : {
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$2) {
     break label$2
    }
    $3 = HEAP32[$1 >> 2] | 0;
    alloc__collections__btree__navigate__full_range__h7c512077c9eac29d($0 | 0, $3 | 0, $2 | 0, $3 | 0, $2 | 0);
    $1 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    break label$1;
   }
   $1 = 0;
   HEAP32[($0 + 4 | 0) >> 2] = 0;
   HEAP32[($0 + 16 | 0) >> 2] = 0;
  }
  HEAP32[($0 + 24 | 0) >> 2] = $1;
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___iter__h351d422ab5212013($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  label$1 : {
   label$2 : {
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$2) {
     break label$2
    }
    $3 = HEAP32[$1 >> 2] | 0;
    alloc__collections__btree__navigate__full_range__h627511b46f4298ce($0 | 0, $3 | 0, $2 | 0, $3 | 0, $2 | 0);
    $1 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    break label$1;
   }
   $1 = 0;
   HEAP32[($0 + 4 | 0) >> 2] = 0;
   HEAP32[($0 + 16 | 0) >> 2] = 0;
  }
  HEAP32[($0 + 24 | 0) >> 2] = $1;
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___iter__ha89c9458aca0228d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  label$1 : {
   label$2 : {
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$2) {
     break label$2
    }
    $3 = HEAP32[$1 >> 2] | 0;
    alloc__collections__btree__navigate__full_range__h02c0db9addfb9664($0 | 0, $3 | 0, $2 | 0, $3 | 0, $2 | 0);
    $1 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    break label$1;
   }
   $1 = 0;
   HEAP32[($0 + 4 | 0) >> 2] = 0;
   HEAP32[($0 + 16 | 0) >> 2] = 0;
  }
  HEAP32[($0 + 24 | 0) >> 2] = $1;
 }
 
 function core__ptr__drop_in_place_core__option__Option_serde_json__value__Value____h71c6802ef4477f6d($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAPU8[$0 >> 0] | 0;
   if (($1 | 0) == (6 | 0)) {
    break label$1
   }
   label$2 : {
    switch ($1 | 0) {
    default:
     $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h0198cfc402357e50($0 + 4 | 0 | 0);
     return;
    case 3:
     $0 = $0 + 4 | 0;
     $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
     $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
     return;
    case 0:
    case 1:
    case 2:
     break label$1;
    case 4:
     break label$2;
    };
   }
   $0 = $0 + 4 | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h2d454d4f9b2e44f3($0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h55384607e9cf45ad($0 | 0);
  }
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___iter__h721110b568622f84($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  label$1 : {
   label$2 : {
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$2) {
     break label$2
    }
    $3 = HEAP32[$1 >> 2] | 0;
    alloc__collections__btree__navigate__full_range__h390d32f14d48bfae($0 | 0, $3 | 0, $2 | 0, $3 | 0, $2 | 0);
    $1 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    break label$1;
   }
   $1 = 0;
   HEAP32[($0 + 4 | 0) >> 2] = 0;
   HEAP32[($0 + 16 | 0) >> 2] = 0;
  }
  HEAP32[($0 + 24 | 0) >> 2] = $1;
 }
 
 function $rand_core__os__OsRng_20as_20rand_core__RngCore___try_fill_bytes__h93c0b25b73811e88($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     $3 = getrandom__getrandom__h7071c2cc544ab52c($2 | 0, $3 | 0) | 0;
     if ($3) {
      break label$3
     }
     $2 = 0;
     break label$2;
    }
    $2 = __rust_alloc(4 | 0, 4 | 0) | 0;
    if (!$2) {
     break label$1
    }
    HEAP32[$2 >> 2] = $3;
   }
   HEAP32[($0 + 4 | 0) >> 2] = 1075076;
   HEAP32[$0 >> 2] = $2;
   return;
  }
  $T_20as_20core__convert__From_T____from__h649eab7147d45d59();
  alloc__alloc__handle_alloc_error__he269d8f1bff90960(4 | 0, 4 | 0);
  abort();
 }
 
 function js_sys__Uint8Array__raw_copy_to__h874a0eadd71a9314($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = wasm_bindgen__memory__hb08a0f84a5e95eb6() | 0;
  $3 = js_sys__WebAssembly__Memory__buffer____wbg_buffer_9e184d6f785de5ed__hbbd35f6f4e666239($2 | 0) | 0;
  $4 = js_sys__Uint8Array__new____wbg_new_e8101319e4cf95fc__h29b60a20cce29d79($3 | 0) | 0;
  label$1 : {
   if ($3 >>> 0 < 36 >>> 0) {
    break label$1
   }
   wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($3 | 0);
  }
  js_sys__Uint8Array__set____wbg_set_e8ae7b27314e8b98__h24bb59d4e6b448b6($4 | 0, HEAP32[$0 >> 2] | 0 | 0, $1 | 0);
  label$2 : {
   if ($4 >>> 0 < 36 >>> 0) {
    break label$2
   }
   wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($4 | 0);
  }
  label$3 : {
   if ($2 >>> 0 < 36 >>> 0) {
    break label$3
   }
   wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($2 | 0);
  }
 }
 
 function $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__iter__traits__collect__IntoIterator___into_iter__h78aadcd9a0523691($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  label$1 : {
   label$2 : {
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$2) {
     break label$2
    }
    $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    $1 = HEAP32[$1 >> 2] | 0;
    alloc__collections__btree__navigate__full_range__h226c3274998a98b7($0 | 0, $1 | 0, $2 | 0, $1 | 0, $2 | 0);
    break label$1;
   }
   $3 = 0;
   HEAP32[($0 + 4 | 0) >> 2] = 0;
   HEAP32[($0 + 16 | 0) >> 2] = 0;
  }
  HEAP32[($0 + 24 | 0) >> 2] = $3;
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___iter__hf725d43035c2a960($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  label$1 : {
   label$2 : {
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$2) {
     break label$2
    }
    $3 = HEAP32[$1 >> 2] | 0;
    alloc__collections__btree__navigate__full_range__hfebb6510e5fdd8d2($0 | 0, $3 | 0, $2 | 0, $3 | 0, $2 | 0);
    $1 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    break label$1;
   }
   $1 = 0;
   HEAP32[($0 + 4 | 0) >> 2] = 0;
   HEAP32[($0 + 16 | 0) >> 2] = 0;
  }
  HEAP32[($0 + 24 | 0) >> 2] = $1;
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___iter__h399ff91024363abb($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  label$1 : {
   label$2 : {
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$2) {
     break label$2
    }
    $3 = HEAP32[$1 >> 2] | 0;
    alloc__collections__btree__navigate__full_range__ha6ee6a591ac989ec($0 | 0, $3 | 0, $2 | 0, $3 | 0, $2 | 0);
    $1 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    break label$1;
   }
   $1 = 0;
   HEAP32[($0 + 4 | 0) >> 2] = 0;
   HEAP32[($0 + 16 | 0) >> 2] = 0;
  }
  HEAP32[($0 + 24 | 0) >> 2] = $1;
 }
 
 function alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Owned_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___pop_internal_level__h42385d1b71db96f4($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  label$1 : {
   $1 = HEAP32[$0 >> 2] | 0;
   if (!$1) {
    break label$1
   }
   HEAP32[$0 >> 2] = $1 + -1 | 0;
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   $2 = HEAP32[($1 + 448 | 0) >> 2] | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $2;
   HEAP32[$2 >> 2] = 0;
   __rust_dealloc($1 | 0, 496 | 0, 4 | 0);
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1048936 | 0, 33 | 0, 1048972 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Owned_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___pop_internal_level__hd8f9679535721f0f($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  label$1 : {
   $1 = HEAP32[$0 >> 2] | 0;
   if (!$1) {
    break label$1
   }
   HEAP32[$0 >> 2] = $1 + -1 | 0;
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   $2 = HEAP32[($1 + 232 | 0) >> 2] | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $2;
   HEAP32[($2 + 88 | 0) >> 2] = 0;
   __rust_dealloc($1 | 0, 280 | 0, 8 | 0);
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1048936 | 0, 33 | 0, 1048972 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Owned_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___pop_internal_level__hec5f5ba8681137fd($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  label$1 : {
   $1 = HEAP32[$0 >> 2] | 0;
   if (!$1) {
    break label$1
   }
   HEAP32[$0 >> 2] = $1 + -1 | 0;
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   $2 = HEAP32[($1 + 52 | 0) >> 2] | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $2;
   HEAP32[$2 >> 2] = 0;
   __rust_dealloc($1 | 0, 100 | 0, 4 | 0);
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1048936 | 0, 33 | 0, 1048972 | 0);
  abort();
 }
 
 function bigint_one() {
  var $0 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $11 = 0, $14 = 0, $1 = 0;
  $0 = global$0 - 32 | 0;
  global$0 = $0;
  cardano_serialization_lib__utils__BigInt__one__h46931845af9c14ed($0 | 0);
  i64toi32_i32$2 = $0 + 8 | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $11 = i64toi32_i32$0;
  i64toi32_i32$0 = ($0 + 16 | 0) + 8 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $11;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = $0;
  i64toi32_i32$1 = HEAP32[$0 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $14 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[($0 + 16 | 0) >> 2] = $14;
  HEAP32[($0 + 20 | 0) >> 2] = i64toi32_i32$0;
  $1 = $cardano_serialization_lib__utils__BigInt_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8699e08c5b3b0a6a($0 + 16 | 0 | 0) | 0;
  global$0 = $0 + 32 | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__chain_crypto__key__PublicKeyError_20as_20core__fmt__Debug___fmt__h1f0fefbe3c6c2411($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if ((HEAPU8[$0 >> 0] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1063548 | 0, 11 | 0);
    break label$1;
   }
   core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1063498 | 0, 16 | 0);
  }
  $1 = core__fmt__builders__DebugTuple__finish__hc3c3f1efaa75a6e2($2 | 0) | 0;
  global$0 = $2 + 16 | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__chain_crypto__key__SecretKeyError_20as_20core__fmt__Debug___fmt__h16a21777cd3bcaeb($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if ((HEAPU8[$0 >> 0] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1063548 | 0, 11 | 0);
    break label$1;
   }
   core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1063498 | 0, 16 | 0);
  }
  $1 = core__fmt__builders__DebugTuple__finish__hc3c3f1efaa75a6e2($2 | 0) | 0;
  global$0 = $2 + 16 | 0;
  return $1 | 0;
 }
 
 function cardano_serialization_lib__tx_builder__TransactionBuilder__min_fee__h0562480e064561ee($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0;
  $2 = global$0 - 528 | 0;
  global$0 = $2;
  $cardano_serialization_lib__tx_builder__TransactionBuilder_20as_20core__clone__Clone___clone__h4273e58f8bc63575($2 + 8 | 0 | 0, $1 | 0);
  i64toi32_i32$1 = $2 + 272 | 0;
  i64toi32_i32$0 = 1;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$1 = $2;
  i64toi32_i32$0 = 0;
  HEAP32[($2 + 264 | 0) >> 2] = 1;
  HEAP32[($2 + 268 | 0) >> 2] = i64toi32_i32$0;
  cardano_serialization_lib__tx_builder__min_fee__h8bb5ab8499f01c90($0 | 0, $2 + 8 | 0 | 0);
  core__ptr__drop_in_place_cardano_serialization_lib__tx_builder__TransactionBuilder___h053801e638e30160($2 + 8 | 0 | 0);
  global$0 = $2 + 528 | 0;
 }
 
 function bech32__ToBase32__to_base32__h098342a721ba9592($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[$0 >> 2] = HEAP32[(0 + 1067616 | 0) >> 2] | 0;
  label$1 : {
   if (!($T_20as_20bech32__ToBase32___write_base32__h3133b77327a53204($1 | 0, $0 | 0) | 0)) {
    break label$1
   }
   core__result__unwrap_failed__h27f43d993c3864a1(1067429 | 0, 43 | 0, $2 + 8 | 0 | 0, 1067472 | 0, 1067728 | 0);
   abort();
  }
  global$0 = $2 + 16 | 0;
 }
 
 function bech32__ToBase32__to_base32__h2c09e619bc088feb($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[$0 >> 2] = HEAP32[(0 + 1069072 | 0) >> 2] | 0;
  label$1 : {
   if (!($T_20as_20bech32__ToBase32___write_base32__h672b24da1834a039($1 | 0, $0 | 0) | 0)) {
    break label$1
   }
   core__result__unwrap_failed__h27f43d993c3864a1(1068996 | 0, 43 | 0, $2 + 8 | 0 | 0, 1069040 | 0, 1069372 | 0);
   abort();
  }
  global$0 = $2 + 16 | 0;
 }
 
 function pointer_new($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, $4 = 0, $4$hi = 0, $5 = 0, $5$hi = 0, $15 = 0;
  $3 = global$0 - 32 | 0;
  global$0 = $3;
  i64toi32_i32$0 = $T_20as_20core__convert__Into_U____into__h09f19f33dddda692($0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $4 = i64toi32_i32$0;
  $4$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $T_20as_20core__convert__Into_U____into__h09f19f33dddda692($1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  $5 = i64toi32_i32$1;
  $5$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $T_20as_20core__convert__Into_U____into__h09f19f33dddda692($2 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = $3;
  HEAP32[(i64toi32_i32$0 + 24 | 0) >> 2] = $15;
  HEAP32[(i64toi32_i32$0 + 28 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $5$hi;
  HEAP32[(i64toi32_i32$0 + 16 | 0) >> 2] = $5;
  HEAP32[(i64toi32_i32$0 + 20 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = $4$hi;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $4;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
  $0 = $cardano_serialization_lib__address__Pointer_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hce108dee3b07a283(i64toi32_i32$0 + 8 | 0 | 0) | 0;
  global$0 = i64toi32_i32$0 + 32 | 0;
  return $0 | 0;
 }
 
 function costmodel_new() {
  var $0 = 0, i64toi32_i32$1 = 0, $1 = 0;
  $0 = global$0 - 32 | 0;
  global$0 = $0;
  cardano_serialization_lib__plutus__CostModel__new__h4b1e476f7ee71636($0 | 0);
  HEAP32[(($0 + 16 | 0) + 8 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($0 + 16 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($0 + 20 | 0) >> 2] = i64toi32_i32$1;
  $1 = $cardano_serialization_lib__plutus__CostModel_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h131279c16539114c($0 + 16 | 0 | 0) | 0;
  global$0 = $0 + 32 | 0;
  return $1 | 0;
 }
 
 function txbuilderconstants_plutus_default_cost_models() {
  var $0 = 0, i64toi32_i32$1 = 0, $1 = 0;
  $0 = global$0 - 32 | 0;
  global$0 = $0;
  cardano_serialization_lib__tx_builder_constants__TxBuilderConstants__plutus_default_cost_models__hedeea22bf8716716($0 | 0);
  HEAP32[(($0 + 16 | 0) + 8 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($0 + 16 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($0 + 20 | 0) >> 2] = i64toi32_i32$1;
  $1 = $cardano_serialization_lib__plutus__Costmdls_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8003415a0e008f0e($0 + 16 | 0 | 0) | 0;
  global$0 = $0 + 32 | 0;
  return $1 | 0;
 }
 
 function getrandom__error__internal_desc__h19dfc27a2698807d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   label$2 : {
    $1 = $1 ^ -2147483648 | 0;
    if ($1 >>> 0 <= 13 >>> 0) {
     break label$2
    }
    $1 = 0;
    break label$1;
   }
   $2 = $1 << 2 | 0;
   $1 = HEAP32[($2 + 1075816 | 0) >> 2] | 0;
   $2 = HEAP32[($2 + 1075760 | 0) >> 2] | 0;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $2;
  HEAP32[$0 >> 2] = $1;
 }
 
 function $num_bigint__BigIntErrorKind_20as_20core__fmt__Debug___fmt__h3aa704244e803989($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if ((HEAPU8[$0 >> 0] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1077556 | 0, 5 | 0);
    break label$1;
   }
   core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1077544 | 0, 12 | 0);
  }
  $1 = core__fmt__builders__DebugTuple__finish__hc3c3f1efaa75a6e2($2 | 0) | 0;
  global$0 = $2 + 16 | 0;
  return $1 | 0;
 }
 
 function $num_bigint__ParseBigIntError_20as_20core__fmt__Debug___fmt__hbbb2316c40d87609($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $8 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  i64toi32_i32$0 = core__fmt__Formatter__debug_struct__h873400a11fe69724($1 | 0, 1077508 | 0, 16 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $8 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[$2 >> 2] = $8;
  HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($2 + 12 | 0) >> 2] = $0;
  core__fmt__builders__DebugStruct__field__hec833bfe02704935($2 | 0, 1077524 | 0, 4 | 0, $2 + 12 | 0 | 0, 1077528 | 0) | 0;
  $0 = core__fmt__builders__DebugStruct__finish__hb1eae1aa0e288840($2 | 0) | 0;
  global$0 = $2 + 16 | 0;
  return $0 | 0;
 }
 
 function $ed25519_bip32__derivation__DerivationError_20as_20core__fmt__Debug___fmt__h557dfa098358060a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if ((HEAPU8[$0 >> 0] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1101574 | 0, 15 | 0);
    break label$1;
   }
   core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1101552 | 0, 22 | 0);
  }
  $1 = core__fmt__builders__DebugTuple__finish__hc3c3f1efaa75a6e2($2 | 0) | 0;
  global$0 = $2 + 16 | 0;
  return $1 | 0;
 }
 
 function cryptoxide__curve25519__ge__GeP1P1__to_full__hee64a48e5ca8376f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0, $4 = 0;
  $2 = $1 + 120 | 0;
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($0 | 0, $1 | 0, $2 | 0);
  $3 = $1 + 40 | 0;
  $4 = $1 + 80 | 0;
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($0 + 40 | 0 | 0, $3 | 0, $4 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($0 + 80 | 0 | 0, $4 | 0, $2 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($0 + 120 | 0 | 0, $1 | 0, $3 | 0);
 }
 
 function core__panicking__panic__h2fd385a887c8bf13($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 32 | 0;
  global$0 = $3;
  HEAP32[($3 + 20 | 0) >> 2] = 0;
  HEAP32[($3 + 16 | 0) >> 2] = 1149204;
  HEAP32[($3 + 4 | 0) >> 2] = 1;
  HEAP32[($3 + 8 | 0) >> 2] = 0;
  HEAP32[($3 + 28 | 0) >> 2] = $1;
  HEAP32[($3 + 24 | 0) >> 2] = $0;
  HEAP32[$3 >> 2] = $3 + 24 | 0;
  core__panicking__panic_fmt__hbf21a3d4bbb82bf8($3 | 0, $2 | 0);
  abort();
 }
 
 function core__fmt__num___impl_20core__fmt__Display_20for_20i128___fmt__h32e59444f56cefa7($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$5 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, $3$hi = 0, i64toi32_i32$6 = 0, $3 = 0, $2 = 0, $2$hi = 0, $25 = 0, $26 = 0, $27 = 0, $28 = 0, $29 = 0, $30 = 0, $7 = 0, $7$hi = 0, $8 = 0, $8$hi = 0, $15 = 0, $15$hi = 0, $18 = 0, $19$hi = 0, $20$hi = 0, $21$hi = 0, $24 = 0, $24$hi = 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $2 = i64toi32_i32$0;
  $2$hi = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$0 = $2$hi;
  i64toi32_i32$3 = $2;
  i64toi32_i32$4 = i64toi32_i32$2 - i64toi32_i32$3 | 0;
  i64toi32_i32$6 = i64toi32_i32$2 >>> 0 < i64toi32_i32$3 >>> 0;
  i64toi32_i32$5 = i64toi32_i32$6 + i64toi32_i32$0 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 - i64toi32_i32$5 | 0;
  $7 = i64toi32_i32$4;
  $7$hi = i64toi32_i32$5;
  i64toi32_i32$5 = i64toi32_i32$0;
  $8 = i64toi32_i32$3;
  $8$hi = i64toi32_i32$5;
  i64toi32_i32$1 = $0 + 8 | 0;
  i64toi32_i32$5 = HEAP32[i64toi32_i32$1 >> 2] | 0;
  i64toi32_i32$2 = HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] | 0;
  $3 = i64toi32_i32$5;
  $3$hi = i64toi32_i32$2;
  i64toi32_i32$1 = i64toi32_i32$5;
  i64toi32_i32$5 = 0;
  i64toi32_i32$3 = 0;
  if ((i64toi32_i32$2 | 0) < (i64toi32_i32$5 | 0)) {
   $25 = 1
  } else {
   if ((i64toi32_i32$2 | 0) <= (i64toi32_i32$5 | 0)) {
    if (i64toi32_i32$1 >>> 0 >= i64toi32_i32$3 >>> 0) {
     $26 = 0
    } else {
     $26 = 1
    }
    $27 = $26;
   } else {
    $27 = 0
   }
   $25 = $27;
  }
  $0 = $25;
  i64toi32_i32$0 = $0;
  i64toi32_i32$1 = $7$hi;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$5 = i64toi32_i32$0 ? $7 : $8;
  i64toi32_i32$3 = i64toi32_i32$0 ? i64toi32_i32$1 : i64toi32_i32$2;
  $15 = i64toi32_i32$5;
  $15$hi = i64toi32_i32$3;
  i64toi32_i32$3 = $3$hi;
  i64toi32_i32$3 = $2$hi;
  i64toi32_i32$0 = $2;
  i64toi32_i32$5 = 0;
  i64toi32_i32$1 = 0;
  $18 = (i64toi32_i32$0 | 0) != (i64toi32_i32$1 | 0) | (i64toi32_i32$3 | 0) != (i64toi32_i32$5 | 0) | 0;
  i64toi32_i32$0 = 0;
  $19$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $3$hi;
  i64toi32_i32$1 = $3;
  i64toi32_i32$3 = $19$hi;
  i64toi32_i32$5 = $18;
  i64toi32_i32$2 = i64toi32_i32$1 + i64toi32_i32$5 | 0;
  i64toi32_i32$4 = i64toi32_i32$0 + i64toi32_i32$3 | 0;
  if (i64toi32_i32$2 >>> 0 < i64toi32_i32$5 >>> 0) {
   i64toi32_i32$4 = i64toi32_i32$4 + 1 | 0
  }
  $20$hi = i64toi32_i32$4;
  i64toi32_i32$4 = 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$1 = $20$hi;
  i64toi32_i32$5 = i64toi32_i32$2;
  i64toi32_i32$3 = i64toi32_i32$0 - i64toi32_i32$2 | 0;
  i64toi32_i32$6 = i64toi32_i32$0 >>> 0 < i64toi32_i32$2 >>> 0;
  i64toi32_i32$2 = i64toi32_i32$6 + i64toi32_i32$1 | 0;
  i64toi32_i32$2 = i64toi32_i32$4 - i64toi32_i32$2 | 0;
  $21$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $3$hi;
  i64toi32_i32$1 = $0;
  i64toi32_i32$2 = $21$hi;
  i64toi32_i32$0 = $3$hi;
  i64toi32_i32$5 = i64toi32_i32$1 ? i64toi32_i32$3 : $3;
  i64toi32_i32$4 = i64toi32_i32$1 ? i64toi32_i32$2 : i64toi32_i32$0;
  $24 = i64toi32_i32$5;
  $24$hi = i64toi32_i32$4;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$4 = i64toi32_i32$0;
  i64toi32_i32$1 = $3;
  i64toi32_i32$5 = -1;
  i64toi32_i32$2 = -1;
  if ((i64toi32_i32$0 | 0) > (i64toi32_i32$5 | 0)) {
   $28 = 1
  } else {
   if ((i64toi32_i32$4 | 0) >= (i64toi32_i32$5 | 0)) {
    if (i64toi32_i32$1 >>> 0 <= i64toi32_i32$2 >>> 0) {
     $29 = 0
    } else {
     $29 = 1
    }
    $30 = $29;
   } else {
    $30 = 0
   }
   $28 = $30;
  }
  i64toi32_i32$1 = $15$hi;
  i64toi32_i32$4 = $24$hi;
  return core__fmt__num__fmt_u128__h862fe9efac8e40f8($15 | 0, i64toi32_i32$1 | 0, $24 | 0, i64toi32_i32$4 | 0, $28 | 0, $1 | 0) | 0 | 0;
 }
 
 function transactionbody_remove_ttl($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h238818d95bb6c551($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
 }
 
 function $linked_hash_map__KeyRef_K__20as_20core__cmp__PartialEq___eq__h384b914ed9be434a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = 0;
  label$1 : {
   $0 = HEAP32[$0 >> 2] | 0;
   $1 = HEAP32[$1 >> 2] | 0;
   if ((HEAPU8[$0 >> 0] | 0 | 0) != (HEAPU8[$1 >> 0] | 0 | 0)) {
    break label$1
   }
   if ((HEAPU8[($0 + 1 | 0) >> 0] | 0 | 0) != (HEAPU8[($1 + 1 | 0) >> 0] | 0 | 0)) {
    break label$1
   }
   $2 = !(memcmp($0 + 2 | 0 | 0, $1 + 2 | 0 | 0, 28 | 0) | 0);
  }
  return $2 | 0;
 }
 
 function transactionbuilder_remove_script_data_hash($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h5566e1c7d4aafe35($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  HEAP8[((HEAP32[($1 + 8 | 0) >> 2] | 0) + 480 | 0) >> 0] = 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
 }
 
 function std__thread__local__LocalKey_T___with__h98ebb7adf7154db4($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   $0 = FUNCTION_TABLE[HEAP32[$0 >> 2] | 0 | 0]() | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__h03d182df15dd7aa6();
   core__result__unwrap_failed__h27f43d993c3864a1(1076316 | 0, 70 | 0, $1 + 8 | 0 | 0, 1076484 | 0, 1076468 | 0);
   abort();
  }
  $0 = wasm_bindgen____wbindgen_object_clone_ref__hf1c010c1b4d1cb75(HEAP32[$0 >> 2] | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return $0 | 0;
 }
 
 function $T_20as_20core__convert__Into_U____into__h9fa017df171d181a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[$0 >> 2] = HEAP32[(0 + 1077348 | 0) >> 2] | 0;
  label$1 : {
   if (!$1) {
    break label$1
   }
   alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h90c9768825cdae1b($0 | 0, 0 | 0, 1 | 0);
   $2 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   HEAP32[($0 + 8 | 0) >> 2] = $2 + 1 | 0;
   HEAP32[((HEAP32[$0 >> 2] | 0) + ($2 << 2 | 0) | 0) >> 2] = $1;
  }
 }
 
 function serde_json__error__Error__syntax__h11c9d7f40fe522f9($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   $3 = __rust_alloc(20 | 0, 4 | 0) | 0;
   if ($3) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(20 | 0, 4 | 0);
   abort();
  }
  HEAP32[($3 + 16 | 0) >> 2] = $2;
  HEAP32[($3 + 12 | 0) >> 2] = $1;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[$3 >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($3 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($3 + 8 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  return $3 | 0;
 }
 
 function cryptoxide__curve25519__ge__Ge__to_cached__h058a97fcf91788e4($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = $1 + 40 | 0;
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Add___add__he826ef0e90fce416($0 | 0, $2 | 0, $1 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Sub___sub__h676cb1e5fa77fb70($0 + 40 | 0 | 0, $2 | 0, $1 | 0);
  memcpy($0 + 80 | 0 | 0, $1 + 80 | 0 | 0, 40 | 0) | 0;
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($0 + 120 | 0 | 0, $1 + 120 | 0 | 0, 1104520 | 0);
 }
 
 function core__fmt__builders__DebugMap__finish__hdeb040f139645c75($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = 1;
  label$1 : {
   label$2 : {
    if (HEAPU8[($0 + 4 | 0) >> 0] | 0) {
     break label$2
    }
    if (HEAPU8[($0 + 6 | 0) >> 0] | 0) {
     break label$1
    }
    $0 = HEAP32[$0 >> 2] | 0;
    $1 = FUNCTION_TABLE[HEAP32[((HEAP32[($0 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($0 + 24 | 0) >> 2] | 0, 1149877, 1) | 0;
   }
   return $1 | 0;
  }
  core__panicking__panic__h2fd385a887c8bf13(1150072 | 0, 46 | 0, 1150120 | 0);
  abort();
 }
 
 function std__collections__hash__map__RandomState__new__KEYS____getit__h7c33a32c97166f29() {
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $0 = 0, i64toi32_i32$0 = 0, $8 = 0, $10 = 0;
  $0 = global$0 - 16 | 0;
  global$0 = $0;
  label$1 : {
   i64toi32_i32$2 = 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1177840 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1177844 | 0) >> 2] | 0;
   i64toi32_i32$2 = i64toi32_i32$0;
   i64toi32_i32$0 = 0;
   if ((i64toi32_i32$2 | 0) == (1 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
    break label$1
   }
   std__sys__wasm__common__hashmap_random_keys__h35a1ce888f441401($0 | 0);
   i64toi32_i32$1 = 0;
   i64toi32_i32$2 = 0;
   HEAP32[(i64toi32_i32$1 + 1177840 | 0) >> 2] = 1;
   HEAP32[(i64toi32_i32$1 + 1177844 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$2 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($0 + 12 | 0) >> 2] | 0;
   $8 = i64toi32_i32$2;
   i64toi32_i32$2 = 0;
   HEAP32[(i64toi32_i32$2 + 1177856 | 0) >> 2] = $8;
   HEAP32[(i64toi32_i32$2 + 1177860 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = HEAP32[$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   $10 = i64toi32_i32$1;
   i64toi32_i32$1 = 0;
   HEAP32[(i64toi32_i32$1 + 1177848 | 0) >> 2] = $10;
   HEAP32[(i64toi32_i32$1 + 1177852 | 0) >> 2] = i64toi32_i32$2;
  }
  global$0 = $0 + 16 | 0;
  return 1177848 | 0;
 }
 
 function std__collections__hash__map__RandomState__new__KEYS____getit__h7c33a32c97166f29_1() {
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $0 = 0, i64toi32_i32$0 = 0, $8 = 0, $10 = 0;
  $0 = global$0 - 16 | 0;
  global$0 = $0;
  label$1 : {
   i64toi32_i32$2 = 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1177840 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1177844 | 0) >> 2] | 0;
   i64toi32_i32$2 = i64toi32_i32$0;
   i64toi32_i32$0 = 0;
   if ((i64toi32_i32$2 | 0) == (1 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
    break label$1
   }
   std__sys__wasm__common__hashmap_random_keys__h35a1ce888f441401($0 | 0);
   i64toi32_i32$1 = 0;
   i64toi32_i32$2 = 0;
   HEAP32[(i64toi32_i32$1 + 1177840 | 0) >> 2] = 1;
   HEAP32[(i64toi32_i32$1 + 1177844 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$2 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($0 + 12 | 0) >> 2] | 0;
   $8 = i64toi32_i32$2;
   i64toi32_i32$2 = 0;
   HEAP32[(i64toi32_i32$2 + 1177856 | 0) >> 2] = $8;
   HEAP32[(i64toi32_i32$2 + 1177860 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = HEAP32[$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   $10 = i64toi32_i32$1;
   i64toi32_i32$1 = 0;
   HEAP32[(i64toi32_i32$1 + 1177848 | 0) >> 2] = $10;
   HEAP32[(i64toi32_i32$1 + 1177852 | 0) >> 2] = i64toi32_i32$2;
  }
  global$0 = $0 + 16 | 0;
  return 1177848 | 0;
 }
 
 function std__collections__hash__map__RandomState__new__KEYS____getit__h7c33a32c97166f29_2() {
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $0 = 0, i64toi32_i32$0 = 0, $8 = 0, $10 = 0;
  $0 = global$0 - 16 | 0;
  global$0 = $0;
  label$1 : {
   i64toi32_i32$2 = 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 1177840 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 1177844 | 0) >> 2] | 0;
   i64toi32_i32$2 = i64toi32_i32$0;
   i64toi32_i32$0 = 0;
   if ((i64toi32_i32$2 | 0) == (1 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
    break label$1
   }
   std__sys__wasm__common__hashmap_random_keys__h35a1ce888f441401($0 | 0);
   i64toi32_i32$1 = 0;
   i64toi32_i32$2 = 0;
   HEAP32[(i64toi32_i32$1 + 1177840 | 0) >> 2] = 1;
   HEAP32[(i64toi32_i32$1 + 1177844 | 0) >> 2] = i64toi32_i32$2;
   i64toi32_i32$2 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($0 + 12 | 0) >> 2] | 0;
   $8 = i64toi32_i32$2;
   i64toi32_i32$2 = 0;
   HEAP32[(i64toi32_i32$2 + 1177856 | 0) >> 2] = $8;
   HEAP32[(i64toi32_i32$2 + 1177860 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = HEAP32[$0 >> 2] | 0;
   i64toi32_i32$2 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   $10 = i64toi32_i32$1;
   i64toi32_i32$1 = 0;
   HEAP32[(i64toi32_i32$1 + 1177848 | 0) >> 2] = $10;
   HEAP32[(i64toi32_i32$1 + 1177852 | 0) >> 2] = i64toi32_i32$2;
  }
  global$0 = $0 + 16 | 0;
  return 1177848 | 0;
 }
 
 function __wbg_bootstrapwitness_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 128 | 0;
  global$0 = $1;
  $cardano_serialization_lib__crypto__BootstrapWitness_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h2fc8f9db9ae71e91($1 + 8 | 0 | 0, $0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 + 8 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 + 8 | 0 | 0);
  $0 = $1 + 20 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
  global$0 = $1 + 128 | 0;
 }
 
 function __wbg_vrfcert_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 32 | 0;
  global$0 = $1;
  $cardano_serialization_lib__crypto__VRFCert_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h98a7ab3de8a7dd6b($1 + 8 | 0 | 0, $0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 + 8 | 0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 + 8 | 0 | 0);
  $0 = $1 + 20 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
  global$0 = $1 + 32 | 0;
 }
 
 function $cardano_serialization_lib__plutus__Language_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hb597e561887e512b($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__he5bc187cb5257910($1 + 8 | 0 | 0, $0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($1 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($0 | 0) | 0 | 0, 4 | 0, 4 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function language_kind($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow__hfa98d20552a22c6d($1 + 8 | 0 | 0, $0 | 0);
  $0 = HEAP32[($1 + 12 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
  global$0 = $1 + 16 | 0;
  return 0 | 0;
 }
 
 function $cardano_serialization_lib__tx_builder_constants__TxBuilderConstants_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h09016ceebb56ff1b($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a();
   abort();
  }
  wasm_bindgen____rt__WasmRefCell_T___borrow_mut__ha2ebf5dc8c79bae5($1 + 8 | 0 | 0, $0 | 0);
  core__cell__Cell_T___replace__h74ad9f426af36be8(HEAP32[($1 + 12 | 0) >> 2] | 0 | 0, 0 | 0) | 0;
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($0 | 0) | 0 | 0, 4 | 0, 4 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function getrandom__getrandom__h7071c2cc544ab52c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   label$2 : {
    if ($1) {
     break label$2
    }
    $1 = 0;
    break label$1;
   }
   HEAP32[($2 + 12 | 0) >> 2] = $1;
   HEAP32[($2 + 8 | 0) >> 2] = $0;
   $1 = std__thread__local__LocalKey_T___with__ha120a3da9e0d1836(1076056 | 0, $2 + 8 | 0 | 0) | 0;
  }
  global$0 = $2 + 16 | 0;
  return $1 | 0;
 }
 
 function std__thread__local__lazy__LazyKeyInner_T___initialize__hc90c2bd45b0f5e51($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $3 = 0, $2 = 0, $4 = 0;
  $2 = FUNCTION_TABLE[$1 | 0]() | 0;
  $1 = $0 + 4 | 0;
  $3 = HEAP32[$1 >> 2] | 0;
  $4 = HEAP32[$0 >> 2] | 0;
  HEAP32[$1 >> 2] = $2;
  HEAP32[$0 >> 2] = 1;
  label$1 : {
   if (!$4) {
    break label$1
   }
   if ($3 >>> 0 < 36 >>> 0) {
    break label$1
   }
   wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($3 | 0);
  }
  return $1 | 0;
 }
 
 function cryptoxide__chacha20poly1305__pad16__hc43355684cd75a45($0, $1, $1$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $1$hi = $1$hi | 0;
  var $2 = 0, i64toi32_i32$1 = 0, $5 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  label$1 : {
   i64toi32_i32$1 = 0;
   i64toi32_i32$1 = $1$hi & i64toi32_i32$1 | 0;
   $1 = $1 & 15 | 0;
   $1$hi = i64toi32_i32$1;
   if (!($1 | i64toi32_i32$1 | 0)) {
    break label$1
   }
   i64toi32_i32$1 = 0;
   $5 = 0;
   HEAP8[($2 + 7 | 0) >> 0] = $5;
   HEAP8[($2 + 8 | 0) >> 0] = $5 >>> 8 | 0;
   HEAP8[($2 + 9 | 0) >> 0] = $5 >>> 16 | 0;
   HEAP8[($2 + 10 | 0) >> 0] = $5 >>> 24 | 0;
   HEAP8[($2 + 11 | 0) >> 0] = i64toi32_i32$1;
   HEAP8[($2 + 12 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
   HEAP8[($2 + 13 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
   HEAP8[($2 + 14 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
   i64toi32_i32$1 = 0;
   HEAP32[$2 >> 2] = 0;
   HEAP32[($2 + 4 | 0) >> 2] = i64toi32_i32$1;
   i64toi32_i32$1 = $1$hi;
   $cryptoxide__poly1305__Poly1305_20as_20cryptoxide__mac__Mac___input__h2055bc09e473001f($0 | 0, $2 | 0, 16 - $1 | 0 | 0);
  }
  global$0 = $2 + 16 | 0;
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_end__h15730bdff0d297bb($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__h0fa9babfafe148cd($1 | 0, HEAP32[$0 >> 2] | 0 | 0, HEAP32[($0 + 4 | 0) >> 2] | 0 | 0);
  label$1 : {
   label$2 : while (1) {
    $0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__h0fa9babfafe148cd($1 | 0, HEAP32[$1 >> 2] | 0 | 0, $0 | 0);
    continue label$2;
   };
  }
  global$0 = $1 + 16 | 0;
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_end__h44cd246d9b42f204($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__he958d708f4ef7fcb($1 | 0, HEAP32[$0 >> 2] | 0 | 0, HEAP32[($0 + 4 | 0) >> 2] | 0 | 0);
  label$1 : {
   label$2 : while (1) {
    $0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__he958d708f4ef7fcb($1 | 0, HEAP32[$1 >> 2] | 0 | 0, $0 | 0);
    continue label$2;
   };
  }
  global$0 = $1 + 16 | 0;
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_end__h790df841eabd6eb8($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__h43354c1ef1cf882f($1 | 0, HEAP32[$0 >> 2] | 0 | 0, HEAP32[($0 + 4 | 0) >> 2] | 0 | 0);
  label$1 : {
   label$2 : while (1) {
    $0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__h43354c1ef1cf882f($1 | 0, HEAP32[$1 >> 2] | 0 | 0, $0 | 0);
    continue label$2;
   };
  }
  global$0 = $1 + 16 | 0;
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_end__h7ac41c9387518bdc($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__h0b2b0ab461f4128b($1 | 0, HEAP32[$0 >> 2] | 0 | 0, HEAP32[($0 + 4 | 0) >> 2] | 0 | 0);
  label$1 : {
   label$2 : while (1) {
    $0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__h0b2b0ab461f4128b($1 | 0, HEAP32[$1 >> 2] | 0 | 0, $0 | 0);
    continue label$2;
   };
  }
  global$0 = $1 + 16 | 0;
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_end__h96916ab1c061eddf($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__hcf24682c7c7ea3d8($1 | 0, HEAP32[$0 >> 2] | 0 | 0, HEAP32[($0 + 4 | 0) >> 2] | 0 | 0);
  label$1 : {
   label$2 : while (1) {
    $0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__hcf24682c7c7ea3d8($1 | 0, HEAP32[$1 >> 2] | 0 | 0, $0 | 0);
    continue label$2;
   };
  }
  global$0 = $1 + 16 | 0;
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_end__h994fb02303f9a4bc($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__h7882606ec619d1fb($1 | 0, HEAP32[$0 >> 2] | 0 | 0, HEAP32[($0 + 4 | 0) >> 2] | 0 | 0);
  label$1 : {
   label$2 : while (1) {
    $0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__h7882606ec619d1fb($1 | 0, HEAP32[$1 >> 2] | 0 | 0, $0 | 0);
    continue label$2;
   };
  }
  global$0 = $1 + 16 | 0;
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_end__h9f0e6d9903ac5e2d($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__h6b0721a0f3de48e5($1 | 0, HEAP32[$0 >> 2] | 0 | 0, HEAP32[($0 + 4 | 0) >> 2] | 0 | 0);
  label$1 : {
   label$2 : while (1) {
    $0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__h6b0721a0f3de48e5($1 | 0, HEAP32[$1 >> 2] | 0 | 0, $0 | 0);
    continue label$2;
   };
  }
  global$0 = $1 + 16 | 0;
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_end__ha96e9d629fd4be4f($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__h9fa0dc18db2ee8da($1 | 0, HEAP32[$0 >> 2] | 0 | 0, HEAP32[($0 + 4 | 0) >> 2] | 0 | 0);
  label$1 : {
   label$2 : while (1) {
    $0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__h9fa0dc18db2ee8da($1 | 0, HEAP32[$1 >> 2] | 0 | 0, $0 | 0);
    continue label$2;
   };
  }
  global$0 = $1 + 16 | 0;
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_end__hac5e9ece4d257bcc($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__h1ca30957bd01a832($1 | 0, HEAP32[$0 >> 2] | 0 | 0, HEAP32[($0 + 4 | 0) >> 2] | 0 | 0);
  label$1 : {
   label$2 : while (1) {
    $0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__h1ca30957bd01a832($1 | 0, HEAP32[$1 >> 2] | 0 | 0, $0 | 0);
    continue label$2;
   };
  }
  global$0 = $1 + 16 | 0;
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_end__hbf6fe661aa5b2d49($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__hc0a9a6c13e0b7288($1 | 0, HEAP32[$0 >> 2] | 0 | 0, HEAP32[($0 + 4 | 0) >> 2] | 0 | 0);
  label$1 : {
   label$2 : while (1) {
    $0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__hc0a9a6c13e0b7288($1 | 0, HEAP32[$1 >> 2] | 0 | 0, $0 | 0);
    continue label$2;
   };
  }
  global$0 = $1 + 16 | 0;
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_end__hc1c221af8b4634e6($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__h538f90b035d35bbd($1 | 0, HEAP32[$0 >> 2] | 0 | 0, HEAP32[($0 + 4 | 0) >> 2] | 0 | 0);
  label$1 : {
   label$2 : while (1) {
    $0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__h538f90b035d35bbd($1 | 0, HEAP32[$1 >> 2] | 0 | 0, $0 | 0);
    continue label$2;
   };
  }
  global$0 = $1 + 16 | 0;
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_end__hd78561ccab159031($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__hda4ef3fecbd884df($1 | 0, HEAP32[$0 >> 2] | 0 | 0, HEAP32[($0 + 4 | 0) >> 2] | 0 | 0);
  label$1 : {
   label$2 : while (1) {
    $0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__hda4ef3fecbd884df($1 | 0, HEAP32[$1 >> 2] | 0 | 0, $0 | 0);
    continue label$2;
   };
  }
  global$0 = $1 + 16 | 0;
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_end__hd9e8c7d413dbbfb4($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__hee9d82fa4cb1d72f($1 | 0, HEAP32[$0 >> 2] | 0 | 0, HEAP32[($0 + 4 | 0) >> 2] | 0 | 0);
  label$1 : {
   label$2 : while (1) {
    $0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__hee9d82fa4cb1d72f($1 | 0, HEAP32[$1 >> 2] | 0 | 0, $0 | 0);
    continue label$2;
   };
  }
  global$0 = $1 + 16 | 0;
 }
 
 function core__ptr__drop_in_place_core__result__Result_cardano_serialization_lib__PoolRegistration_2ccardano_serialization_lib__error__DeserializeError____hd0bde1a1981b77c0($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0;
  $1 = $0 + 8 | 0;
  label$1 : {
   i64toi32_i32$0 = HEAP32[$0 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   i64toi32_i32$2 = i64toi32_i32$0;
   i64toi32_i32$0 = 0;
   if ((i64toi32_i32$2 | 0) != (0 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$0 | 0) | 0) {
    break label$1
   }
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h72de9eab2f0e4669($0 + 40 | 0 | 0);
   $1 = $1 + 44 | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hb600accf9d1c2a17($1 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h96b3170d440e3692($1 | 0);
   core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__PoolMetadata____hb1232757542ed318($0 + 64 | 0 | 0);
   return;
  }
  core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9($1 | 0);
 }
 
 function $cbor_event__value__ObjectKey_20as_20cbor_event__se__Serialize___serialize__h2d411ed28971169c($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   switch (HEAP32[$1 >> 2] | 0 | 0) {
   default:
    i64toi32_i32$2 = $1 + 8 | 0;
    i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
    cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($0 | 0, $2 | 0, 0 | 0, HEAP32[i64toi32_i32$2 >> 2] | 0 | 0, i64toi32_i32$1 | 0);
    return;
   case 1:
    cbor_event__se__Serializer_W___write_bytes__hdbf95a6224c8b5b8($0 | 0, $2 | 0, $1 + 4 | 0 | 0);
    return;
   case 2:
    break label$1;
   };
  }
  cbor_event__se__Serializer_W___write_text__hb80b098c4abeea7e($0 | 0, $2 | 0, $1 + 4 | 0 | 0);
 }
 
 function $cardano_serialization_lib__utils__Int_20as_20core__fmt__Debug___fmt__h722c5f6072e7fe71($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1057809 | 0, 3 | 0);
  HEAP32[($2 + 12 | 0) >> 2] = $0;
  core__fmt__builders__DebugTuple__field__h5e7e3e19ad5aa557($2 | 0, $2 + 12 | 0 | 0, 1058768 | 0) | 0;
  $0 = core__fmt__builders__DebugTuple__finish__hc3c3f1efaa75a6e2($2 | 0) | 0;
  global$0 = $2 + 16 | 0;
  return $0 | 0;
 }
 
 function core__ptr__drop_in_place_cardano_serialization_lib__NativeScript___h75320cd41c3d4d05($0) {
  $0 = $0 | 0;
  label$1 : {
   label$2 : {
    label$3 : {
     switch ((HEAPU8[$0 >> 0] | 0) + -1 | 0 | 0) {
     case 0:
      $0 = $0 + 4 | 0;
      break label$2;
     case 1:
      $0 = $0 + 4 | 0;
      break label$2;
     case 2:
      break label$3;
     default:
      break label$1;
     };
    }
    $0 = $0 + 8 | 0;
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc3d6ec99c05cee40($0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h0f78886c344617d4($0 | 0);
  }
 }
 
 function core__ptr__drop_in_place_cardano_serialization_lib__utils__TransactionUnspentOutput___h3ebb7f0562e4e672($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   if ((HEAPU8[$0 >> 0] | 0) >>> 0 < 4 >>> 0) {
    break label$1
   }
   $1 = $0 + 4 | 0;
   if (!(HEAP32[$1 >> 2] | 0)) {
    break label$1
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  }
  label$2 : {
   if (!(HEAP32[($0 + 72 | 0) >> 2] | 0)) {
    break label$2
   }
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($0 + 76 | 0 | 0);
  }
 }
 
 function $cardano_serialization_lib__metadata__MetadataMap_20as_20core__fmt__Debug___fmt__h3d9317a229daf747($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1059848 | 0, 11 | 0);
  HEAP32[($2 + 12 | 0) >> 2] = $0;
  core__fmt__builders__DebugTuple__field__h5e7e3e19ad5aa557($2 | 0, $2 + 12 | 0 | 0, 1060116 | 0) | 0;
  $0 = core__fmt__builders__DebugTuple__finish__hc3c3f1efaa75a6e2($2 | 0) | 0;
  global$0 = $2 + 16 | 0;
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__metadata__MetadataList_20as_20core__fmt__Debug___fmt__hff4392738482f58f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1059876 | 0, 12 | 0);
  HEAP32[($2 + 12 | 0) >> 2] = $0;
  core__fmt__builders__DebugTuple__field__h5e7e3e19ad5aa557($2 | 0, $2 + 12 | 0 | 0, 1060180 | 0) | 0;
  $0 = core__fmt__builders__DebugTuple__finish__hc3c3f1efaa75a6e2($2 | 0) | 0;
  global$0 = $2 + 16 | 0;
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__metadata__TransactionMetadatum_20as_20core__fmt__Debug___fmt__h4fe7646462d1b2ad($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1060320 | 0, 20 | 0);
  HEAP32[($2 + 12 | 0) >> 2] = $0;
  core__fmt__builders__DebugTuple__field__h5e7e3e19ad5aa557($2 | 0, $2 + 12 | 0 | 0, 1060340 | 0) | 0;
  $0 = core__fmt__builders__DebugTuple__finish__hc3c3f1efaa75a6e2($2 | 0) | 0;
  global$0 = $2 + 16 | 0;
  return $0 | 0;
 }
 
 function linked_hash_map__LinkedHashMap_K_2cV_2cS___drop_entries__h1abc9c1319548d23($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 32 | 0) >> 2] | 0;
   $0 = HEAP32[($1 + 56 | 0) >> 2] | 0;
   if (($0 | 0) == ($1 | 0)) {
    break label$1
   }
   label$2 : while (1) {
    $2 = HEAP32[($0 + 56 | 0) >> 2] | 0;
    core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatumEnum___h27fd15c9b26a768e($0 + 8 | 0 | 0);
    __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($0 | 0) | 0 | 0, 64 | 0, 8 | 0);
    $0 = $2;
    if (($0 | 0) != ($1 | 0)) {
     continue label$2
    }
    break label$2;
   };
  }
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hb0dac7347f907b29($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[$0 >> 2] | 0;
   $1 = $0 + Math_imul($1, 96) | 0;
   label$2 : while (1) {
    core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatum___headd2d1b596252cc_2($0 | 0);
    core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatum___headd2d1b596252cc_2($0 + 48 | 0 | 0);
    $0 = $0 + 96 | 0;
    if (($0 | 0) != ($1 | 0)) {
     continue label$2
    }
    break label$2;
   };
  }
 }
 
 function $cardano_serialization_lib__legacy_address__base58__Error_20as_20core__fmt__Debug___fmt__h95efd4e0115e0805($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($2 | 0, $1 | 0, 1070576 | 0, 13 | 0);
  HEAP32[($2 + 12 | 0) >> 2] = $0;
  core__fmt__builders__DebugTuple__field__h5e7e3e19ad5aa557($2 | 0, $2 + 12 | 0 | 0, 1070592 | 0) | 0;
  $0 = core__fmt__builders__DebugTuple__finish__hc3c3f1efaa75a6e2($2 | 0) | 0;
  global$0 = $2 + 16 | 0;
  return $0 | 0;
 }
 
 function ppv_lite86__generic__dmap2__h0af304cc753529fe($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  HEAP32[($0 + 12 | 0) >> 2] = (HEAP32[($2 + 12 | 0) >> 2] | 0) + (HEAP32[($1 + 12 | 0) >> 2] | 0) | 0;
  HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($2 + 8 | 0) >> 2] | 0) + (HEAP32[($1 + 8 | 0) >> 2] | 0) | 0;
  HEAP32[($0 + 4 | 0) >> 2] = (HEAP32[($2 + 4 | 0) >> 2] | 0) + (HEAP32[($1 + 4 | 0) >> 2] | 0) | 0;
  HEAP32[$0 >> 2] = (HEAP32[$2 >> 2] | 0) + (HEAP32[$1 >> 2] | 0) | 0;
 }
 
 function alloc__collections__btree__navigate___impl_20alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__Edge____deallocating_end__h41f43c368b12dfff($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__h568c725c749c3744($1 | 0, HEAP32[$0 >> 2] | 0 | 0, HEAP32[($0 + 4 | 0) >> 2] | 0 | 0);
  label$1 : {
   label$2 : while (1) {
    $0 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$0) {
     break label$1
    }
    alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___deallocate_and_ascend__h568c725c749c3744($1 | 0, HEAP32[$1 >> 2] | 0 | 0, $0 | 0);
    continue label$2;
   };
  }
  global$0 = $1 + 16 | 0;
 }
 
 function $alloc__vec__Vec_T__20as_20alloc__vec__spec_from_iter__SpecFromIter_T_2cI____from_iter__hd9e424f0851c7545($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $15 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  alloc__raw_vec__RawVec_T_2cA___allocate_in__hce83853681ce0f55($3 + 8 | 0 | 0, $1 | 0, 0 | 0);
  i64toi32_i32$0 = HEAP32[($3 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($3 + 12 | 0) >> 2] | 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  $15 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[$0 >> 2] = $15;
  HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$1;
  $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend_T_2cI____spec_extend__h633257e263edf263($0 | 0, $1 | 0, $2 | 0);
  global$0 = $3 + 16 | 0;
 }
 
 function $cryptoxide__simd__fake__u32x4_20as_20core__ops__arith__Add___add__h93056800a76fa877($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  HEAP32[($0 + 12 | 0) >> 2] = (HEAP32[($2 + 12 | 0) >> 2] | 0) + (HEAP32[($1 + 12 | 0) >> 2] | 0) | 0;
  HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($2 + 8 | 0) >> 2] | 0) + (HEAP32[($1 + 8 | 0) >> 2] | 0) | 0;
  HEAP32[($0 + 4 | 0) >> 2] = (HEAP32[($2 + 4 | 0) >> 2] | 0) + (HEAP32[($1 + 4 | 0) >> 2] | 0) | 0;
  HEAP32[$0 >> 2] = (HEAP32[$2 >> 2] | 0) + (HEAP32[$1 >> 2] | 0) | 0;
 }
 
 function $cryptoxide__simd__fake__u32x4_20as_20core__ops__arith__Sub___sub__h31fa90f2b2d1e09f($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  HEAP32[($0 + 12 | 0) >> 2] = (HEAP32[($1 + 12 | 0) >> 2] | 0) - (HEAP32[($2 + 12 | 0) >> 2] | 0) | 0;
  HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($1 + 8 | 0) >> 2] | 0) - (HEAP32[($2 + 8 | 0) >> 2] | 0) | 0;
  HEAP32[($0 + 4 | 0) >> 2] = (HEAP32[($1 + 4 | 0) >> 2] | 0) - (HEAP32[($2 + 4 | 0) >> 2] | 0) | 0;
  HEAP32[$0 >> 2] = (HEAP32[$1 >> 2] | 0) - (HEAP32[$2 >> 2] | 0) | 0;
 }
 
 function $cryptoxide__simd__fake__u32x4_20as_20core__ops__bit__BitXor___bitxor__h496945338e6fc19a($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  HEAP32[($0 + 12 | 0) >> 2] = (HEAP32[($2 + 12 | 0) >> 2] | 0) ^ (HEAP32[($1 + 12 | 0) >> 2] | 0) | 0;
  HEAP32[($0 + 8 | 0) >> 2] = (HEAP32[($2 + 8 | 0) >> 2] | 0) ^ (HEAP32[($1 + 8 | 0) >> 2] | 0) | 0;
  HEAP32[($0 + 4 | 0) >> 2] = (HEAP32[($2 + 4 | 0) >> 2] | 0) ^ (HEAP32[($1 + 4 | 0) >> 2] | 0) | 0;
  HEAP32[$0 >> 2] = (HEAP32[$2 >> 2] | 0) ^ (HEAP32[$1 >> 2] | 0) | 0;
 }
 
 function $std__panicking__begin_panic_handler__StrPanicPayload_20as_20core__panic__BoxMeUp___take_box__hcff4ba0e65e8e475($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $3 = HEAP32[$1 >> 2] | 0;
  label$1 : {
   $1 = __rust_alloc(8 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(8 | 0, 4 | 0);
   abort();
  }
  HEAP32[($1 + 4 | 0) >> 2] = $2;
  HEAP32[$1 >> 2] = $3;
  HEAP32[($0 + 4 | 0) >> 2] = 1144352;
  HEAP32[$0 >> 2] = $1;
 }
 
 function core__fmt__float___impl_20core__fmt__Debug_20for_20f64___fmt__h7a195f8cca75d85b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0.0;
  $2 = (HEAP32[$1 >> 2] | 0) & 1 | 0;
  $3 = +HEAPF64[$0 >> 3];
  label$1 : {
   if ((HEAP32[($1 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   return core__fmt__float__float_to_decimal_common_exact__heb1add03d918a3dc($1 | 0, +$3, $2 | 0, HEAP32[($1 + 20 | 0) >> 2] | 0 | 0) | 0 | 0;
  }
  return core__fmt__float__float_to_decimal_common_shortest__h571c75620c50b577($1 | 0, +$3, $2 | 0, 1 | 0) | 0 | 0;
 }
 
 function core__fmt__float___impl_20core__fmt__Display_20for_20f64___fmt__h9c24db217d9fbd1b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0.0;
  $2 = (HEAP32[$1 >> 2] | 0) & 1 | 0;
  $3 = +HEAPF64[$0 >> 3];
  label$1 : {
   if ((HEAP32[($1 + 16 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   return core__fmt__float__float_to_decimal_common_exact__heb1add03d918a3dc($1 | 0, +$3, $2 | 0, HEAP32[($1 + 20 | 0) >> 2] | 0 | 0) | 0 | 0;
  }
  return core__fmt__float__float_to_decimal_common_shortest__h571c75620c50b577($1 | 0, +$3, $2 | 0, 0 | 0) | 0 | 0;
 }
 
 function core__ptr__drop_in_place_cardano_serialization_lib__TransactionWitnessSet___h7d278d9502f6471a_1($0) {
  $0 = $0 | 0;
  label$1 : {
   if (!(HEAP32[$0 >> 2] | 0)) {
    break label$1
   }
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hdd0c057252922c46($0 | 0);
  }
  core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__NativeScripts____hdd7d461255ec800a($0 + 12 | 0 | 0);
  core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__crypto__BootstrapWitnesses____h365708acbcf06e1e($0 + 24 | 0 | 0);
  core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__plutus__PlutusScripts____h6be1d55eac328b7f($0 + 36 | 0 | 0);
  core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__plutus__PlutusList____h410d2d25125e861e($0 + 48 | 0 | 0);
  core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__plutus__Redeemers____hd7679bbdd61edccb($0 + 64 | 0 | 0);
 }
 
 function $cardano_serialization_lib__TransactionInputs_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__haa89884e18e43552($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   $1 = __rust_alloc(16 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(16 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__TransactionOutputs_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8e1ecfa37411bb92($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   $1 = __rust_alloc(16 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(16 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__Certificates_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h2d4d31bc412465af($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   $1 = __rust_alloc(16 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(16 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__Mint_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8fa2adeb6e27a027($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   $1 = __rust_alloc(16 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(16 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__Ed25519KeyHashes_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h2ef8a4685b78a9d8($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   $1 = __rust_alloc(16 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(16 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__Relays_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hf76c9eea02151e5d($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   $1 = __rust_alloc(16 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(16 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  return $1 | 0;
 }
 
 function __wbg_poolparams_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 192 | 0;
  global$0 = $1;
  $cardano_serialization_lib__PoolParams_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h7a4ff73f0e2cbbc8($1 | 0, $0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h72de9eab2f0e4669($1 + 32 | 0 | 0);
  $0 = $1 + 44 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hb600accf9d1c2a17($0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h96b3170d440e3692($0 | 0);
  core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__PoolMetadata____hb1232757542ed318($1 + 56 | 0 | 0);
  global$0 = $1 + 192 | 0;
 }
 
 function __wbg_poolregistration_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 192 | 0;
  global$0 = $1;
  $cardano_serialization_lib__PoolRegistration_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h123bf2891cf9f689($1 | 0, $0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h72de9eab2f0e4669($1 + 32 | 0 | 0);
  $0 = $1 + 44 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hb600accf9d1c2a17($0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h96b3170d440e3692($0 | 0);
  core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__PoolMetadata____hb1232757542ed318($1 + 56 | 0 | 0);
  global$0 = $1 + 192 | 0;
 }
 
 function __wbg_mirtostakecredentials_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  $cardano_serialization_lib__MIRToStakeCredentials_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__ha70d61c6c2223e85($1 + 8 | 0 | 0, $0 | 0);
  $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__hddd2979ebb13db27($1 + 8 | 0 | 0);
  label$1 : {
   if (!(HEAP32[($1 + 24 | 0) >> 2] | 0)) {
    break label$1
   }
   hashbrown__raw__RawTable_T_2cA___free_buckets__h78477753a901af0e($1 + 24 | 0 | 0);
  }
  global$0 = $1 + 48 | 0;
 }
 
 function $cardano_serialization_lib__StakeCredentials_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h4e7a6ae850e16266($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   $1 = __rust_alloc(16 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(16 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__Ipv6_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h2867aea60f7881bf($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $1 = 0, i64toi32_i32$0 = 0, $8 = 0, $9 = 0, $10 = 0, $7 = 0, $12 = 0;
  label$1 : {
   $1 = __rust_alloc(20 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(20 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$1 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $7 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  $8 = $7;
  HEAP8[($1 + 4 | 0) >> 0] = $8;
  HEAP8[($1 + 5 | 0) >> 0] = $8 >>> 8 | 0;
  HEAP8[($1 + 6 | 0) >> 0] = $8 >>> 16 | 0;
  HEAP8[($1 + 7 | 0) >> 0] = $8 >>> 24 | 0;
  HEAP8[($1 + 8 | 0) >> 0] = i64toi32_i32$1;
  HEAP8[($1 + 9 | 0) >> 0] = i64toi32_i32$1 >>> 8 | 0;
  HEAP8[($1 + 10 | 0) >> 0] = i64toi32_i32$1 >>> 16 | 0;
  HEAP8[($1 + 11 | 0) >> 0] = i64toi32_i32$1 >>> 24 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAPU8[i64toi32_i32$2 >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 1 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 2 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 3 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  i64toi32_i32$0 = HEAPU8[(i64toi32_i32$2 + 4 | 0) >> 0] | 0 | ((HEAPU8[(i64toi32_i32$2 + 5 | 0) >> 0] | 0) << 8 | 0) | 0 | ((HEAPU8[(i64toi32_i32$2 + 6 | 0) >> 0] | 0) << 16 | 0 | ((HEAPU8[(i64toi32_i32$2 + 7 | 0) >> 0] | 0) << 24 | 0) | 0) | 0;
  $12 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 12 | 0;
  $9 = $12;
  HEAP8[i64toi32_i32$1 >> 0] = $9;
  HEAP8[(i64toi32_i32$1 + 1 | 0) >> 0] = $9 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 2 | 0) >> 0] = $9 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 3 | 0) >> 0] = $9 >>> 24 | 0;
  $10 = i64toi32_i32$0;
  HEAP8[(i64toi32_i32$1 + 4 | 0) >> 0] = $10;
  HEAP8[(i64toi32_i32$1 + 5 | 0) >> 0] = $10 >>> 8 | 0;
  HEAP8[(i64toi32_i32$1 + 6 | 0) >> 0] = $10 >>> 16 | 0;
  HEAP8[(i64toi32_i32$1 + 7 | 0) >> 0] = $10 >>> 24 | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__URL_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h2e80070c22b420a7($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   $1 = __rust_alloc(16 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(16 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__DNSRecordAorAAAA_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__ha728e434ce197f30($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   $1 = __rust_alloc(16 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(16 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__DNSRecordSRV_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h86e52234694c0af8($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   $1 = __rust_alloc(16 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(16 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__SingleHostName_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hc318333b1b61f10d($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $7 = 0, $12 = 0;
  label$1 : {
   $1 = __rust_alloc(20 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(20 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 4 | 0) >> 2] = $7;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $12 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 12 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $12;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__MultiHostName_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h36c70b81dbc68c79($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   $1 = __rust_alloc(16 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(16 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__RewardAddresses_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hd844bb3a1f8d93b5($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   $1 = __rust_alloc(16 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(16 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  return $1 | 0;
 }
 
 function __wbg_withdrawals_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  $cardano_serialization_lib__Withdrawals_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h1b951f32831f8add($1 + 8 | 0 | 0, $0 | 0);
  $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__h16511d8898c4755a($1 + 8 | 0 | 0);
  label$1 : {
   if (!(HEAP32[($1 + 24 | 0) >> 2] | 0)) {
    break label$1
   }
   hashbrown__raw__RawTable_T_2cA___free_buckets__h04a09610ca2977a1($1 + 24 | 0 | 0);
  }
  global$0 = $1 + 48 | 0;
 }
 
 function $cardano_serialization_lib__NativeScripts_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hd952f91bbdbbead8($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   $1 = __rust_alloc(16 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(16 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__ScriptAll_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hef80bd8099d14009($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   $1 = __rust_alloc(16 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(16 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__ScriptAny_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hee8cbd3c8c833493($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   $1 = __rust_alloc(16 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(16 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__ScriptNOfK_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h0db7a3b086405587($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $7 = 0, $12 = 0;
  label$1 : {
   $1 = __rust_alloc(20 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(20 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 4 | 0) >> 2] = $7;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $12 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 12 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $12;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__GenesisHashes_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h78a61e795f735d84($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   $1 = __rust_alloc(16 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(16 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__ScriptHashes_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__ha80e71a64db891b6($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   $1 = __rust_alloc(16 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(16 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  return $1 | 0;
 }
 
 function __wbg_proposedprotocolparameterupdates_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  $cardano_serialization_lib__ProposedProtocolParameterUpdates_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h2d93daf5bda1e920($1 + 8 | 0 | 0, $0 | 0);
  $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__h88c250e8947434a9($1 + 8 | 0 | 0);
  label$1 : {
   if (!(HEAP32[($1 + 24 | 0) >> 2] | 0)) {
    break label$1
   }
   hashbrown__raw__RawTable_T_2cA___free_buckets__ha5e2f3faac433f39($1 + 24 | 0 | 0);
  }
  global$0 = $1 + 48 | 0;
 }
 
 function $cardano_serialization_lib__ProtocolVersions_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h22db0982b5b147a5($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   $1 = __rust_alloc(16 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(16 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__TransactionBodies_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h13219c098e12494e($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   $1 = __rust_alloc(16 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(16 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__TransactionWitnessSets_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h7db91b5cba584e3a($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   $1 = __rust_alloc(16 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(16 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  return $1 | 0;
 }
 
 function __wbg_auxiliarydataset_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  $cardano_serialization_lib__AuxiliaryDataSet_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__he211079221e925cb($1 + 8 | 0 | 0, $0 | 0);
  $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__h65524c00492b1305($1 + 8 | 0 | 0);
  label$1 : {
   if (!(HEAP32[($1 + 24 | 0) >> 2] | 0)) {
    break label$1
   }
   hashbrown__raw__RawTable_T_2cA___free_buckets__h03139504252f0030($1 + 24 | 0 | 0);
  }
  global$0 = $1 + 48 | 0;
 }
 
 function $cardano_serialization_lib__AssetName_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__haddaee8282ead41b($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   $1 = __rust_alloc(16 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(16 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__AssetNames_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h88f81c8607449c6b($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   $1 = __rust_alloc(16 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(16 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__Assets_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hf61728444da3586d($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   $1 = __rust_alloc(16 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(16 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__MultiAsset_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he6031c139f7594ac($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   $1 = __rust_alloc(16 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(16 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__MintAssets_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h828d55d3b5b95763($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   $1 = __rust_alloc(16 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(16 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  return $1 | 0;
 }
 
 function core__ptr__drop_in_place_serde_json__value__Value___h0088decf7dc316c7($0) {
  $0 = $0 | 0;
  label$1 : {
   switch (HEAPU8[$0 >> 0] | 0 | 0) {
   default:
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h0198cfc402357e50($0 + 4 | 0 | 0);
   case 0:
   case 1:
   case 2:
    return;
   case 3:
    $0 = $0 + 4 | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
    return;
   case 4:
    break label$1;
   };
  }
  $0 = $0 + 4 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h2d454d4f9b2e44f3($0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h55384607e9cf45ad($0 | 0);
 }
 
 function $cardano_serialization_lib__utils__TransactionUnspentOutputs_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__had502564c9c936e2($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   $1 = __rust_alloc(16 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(16 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__utils__BigInt_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8699e08c5b3b0a6a($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $7 = 0, $12 = 0;
  label$1 : {
   $1 = __rust_alloc(20 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(20 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 4 | 0) >> 2] = $7;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $12 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 12 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $12;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  return $1 | 0;
 }
 
 function core__ptr__drop_in_place_serde_json__value__Value___h0088decf7dc316c7_1($0) {
  $0 = $0 | 0;
  label$1 : {
   switch (HEAPU8[$0 >> 0] | 0 | 0) {
   default:
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h0198cfc402357e50($0 + 4 | 0 | 0);
   case 0:
   case 1:
   case 2:
    return;
   case 3:
    $0 = $0 + 4 | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
    return;
   case 4:
    break label$1;
   };
  }
  $0 = $0 + 4 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h2d454d4f9b2e44f3($0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h55384607e9cf45ad($0 | 0);
 }
 
 function __wbg_metadatamap_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  $cardano_serialization_lib__metadata__MetadataMap_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hcd311523d587d60f($1 + 8 | 0 | 0, $0 | 0);
  $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__hd17c55afb95953fd($1 + 8 | 0 | 0);
  label$1 : {
   if (!(HEAP32[($1 + 24 | 0) >> 2] | 0)) {
    break label$1
   }
   hashbrown__raw__RawTable_T_2cA___free_buckets__hf5781ccef5282b02($1 + 24 | 0 | 0);
  }
  global$0 = $1 + 48 | 0;
 }
 
 function $cardano_serialization_lib__metadata__MetadataList_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h726a255338699014($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   $1 = __rust_alloc(16 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(16 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  return $1 | 0;
 }
 
 function cardano_serialization_lib__metadata__TransactionMetadatum__as_list__he0dbba76ab1128da($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = 1;
  label$1 : {
   label$2 : {
    if ((HEAP32[$1 >> 2] | 0 | 0) != (1 | 0)) {
     break label$2
    }
    $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__hf69db734dd831996($0 + 4 | 0 | 0, $1 + 4 | 0 | 0);
    $2 = 0;
    break label$1;
   }
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1060489 | 0, 10 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  }
  HEAP32[$0 >> 2] = $2;
 }
 
 function cardano_serialization_lib__metadata__TransactionMetadatum__as_bytes__h9a588a46ad56b3fa($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  label$1 : {
   label$2 : {
    if ((HEAP32[$1 >> 2] | 0 | 0) != (3 | 0)) {
     break label$2
    }
    $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($0 + 4 | 0 | 0, $1 + 4 | 0 | 0);
    $1 = 0;
    break label$1;
   }
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1060509 | 0, 9 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
 }
 
 function cardano_serialization_lib__metadata__TransactionMetadatum__as_text__h4e821204929e96f1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  label$1 : {
   label$2 : {
    if ((HEAP32[$1 >> 2] | 0 | 0) != (4 | 0)) {
     break label$2
    }
    $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($0 + 4 | 0 | 0, $1 + 4 | 0 | 0);
    $1 = 0;
    break label$1;
   }
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1060518 | 0, 8 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
 }
 
 function $cardano_serialization_lib__metadata__TransactionMetadatumLabels_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h90a9618967dafb91($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   $1 = __rust_alloc(16 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(16 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  return $1 | 0;
 }
 
 function __wbg_generaltransactionmetadata_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  $cardano_serialization_lib__metadata__GeneralTransactionMetadata_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hf58c486b94e2e653($1 + 8 | 0 | 0, $0 | 0);
  $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__he275f3eb7df08493($1 + 8 | 0 | 0);
  label$1 : {
   if (!(HEAP32[($1 + 24 | 0) >> 2] | 0)) {
    break label$1
   }
   hashbrown__raw__RawTable_T_2cA___free_buckets__hfa29170569415d6b($1 + 24 | 0 | 0);
  }
  global$0 = $1 + 48 | 0;
 }
 
 function core__ptr__drop_in_place_serde_json__value__Value___h0088decf7dc316c7_2($0) {
  $0 = $0 | 0;
  label$1 : {
   switch (HEAPU8[$0 >> 0] | 0 | 0) {
   default:
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h0198cfc402357e50($0 + 4 | 0 | 0);
   case 0:
   case 1:
   case 2:
    return;
   case 3:
    $0 = $0 + 4 | 0;
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
    return;
   case 4:
    break label$1;
   };
  }
  $0 = $0 + 4 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h2d454d4f9b2e44f3($0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h55384607e9cf45ad($0 | 0);
 }
 
 function cardano_serialization_lib__tx_builder__TransactionBuilder__has_plutus_inputs__h1b9c6897141f0331($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder__get_plutus_input_scripts__h7e973282eea0f34a($1 | 0, $0 + 96 | 0 | 0);
  label$1 : {
   $0 = HEAP32[$1 >> 2] | 0;
   if (!$0) {
    break label$1
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h1bbffe174ae872d8($1 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h9b1d3bb47b46eeb8($1 | 0);
  }
  global$0 = $1 + 16 | 0;
  return ($0 | 0) != (0 | 0) | 0;
 }
 
 function $cardano_serialization_lib__crypto__Vkeys_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h5ad294e449690b5c($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   $1 = __rust_alloc(16 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(16 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__crypto__Vkeywitnesses_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h27fd70dd9b21a645($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   $1 = __rust_alloc(16 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(16 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__crypto__BootstrapWitnesses_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__ha47785b575a14436($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   $1 = __rust_alloc(16 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(16 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__crypto__PublicKeys_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h4087860bc5842f2d($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   $1 = __rust_alloc(16 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(16 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__crypto__KESSignature_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he0b1c3c8b6958e2e($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   $1 = __rust_alloc(16 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(16 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  return $1 | 0;
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd4b44cb226d8311d($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[$0 >> 2] | 0;
   $1 = Math_imul($1, 12);
   label$2 : while (1) {
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
    $0 = $0 + 12 | 0;
    $1 = $1 + -12 | 0;
    if ($1) {
     continue label$2
    }
    break label$2;
   };
  }
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h5af1c14f46bf1edb($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[$0 >> 2] | 0;
   $1 = Math_imul($1, 12);
   label$2 : while (1) {
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
    $0 = $0 + 12 | 0;
    $1 = $1 + -12 | 0;
    if ($1) {
     continue label$2
    }
    break label$2;
   };
  }
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__ha86416daa7863b38($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[$0 >> 2] | 0;
   $1 = Math_imul($1, 12);
   label$2 : while (1) {
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
    $0 = $0 + 12 | 0;
    $1 = $1 + -12 | 0;
    if ($1) {
     continue label$2
    }
    break label$2;
   };
  }
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__he37b42ff2b07ed41($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[$0 >> 2] | 0;
   $1 = Math_imul($1, 12);
   label$2 : while (1) {
    $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
    $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
    $0 = $0 + 12 | 0;
    $1 = $1 + -12 | 0;
    if ($1) {
     continue label$2
    }
    break label$2;
   };
  }
 }
 
 function $alloc__vec__into_iter__IntoIter_T_2cA__20as_20core__ops__drop__Drop___drop__hc4501e140b1d6e18($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $2 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  core__ptr__drop_in_place__5bserde_json__value__Value_5d___h6abbb734efb35ee7($2 | 0, ((HEAP32[($0 + 12 | 0) >> 2] | 0) - $2 | 0 | 0) / (24 | 0) | 0 | 0);
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 12 | 0) >> 2] = i64toi32_i32$1;
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h55384607e9cf45ad($1 + 8 | 0 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function $cardano_serialization_lib__tx_builder__tx_inputs_builder__PlutusWitnesses_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8895bf7926c04f4f($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   $1 = __rust_alloc(16 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(16 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__plutus__PlutusScript_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h588df014a764c544($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   $1 = __rust_alloc(16 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(16 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__plutus__PlutusScripts_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hca65427e7f610652($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   $1 = __rust_alloc(16 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(16 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__plutus__PlutusList_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h9a3fe5bcf5e2cc3a($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $7 = 0, $12 = 0;
  label$1 : {
   $1 = __rust_alloc(20 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(20 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$0;
  i64toi32_i32$0 = $1;
  HEAP32[($1 + 4 | 0) >> 2] = $7;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $12 = i64toi32_i32$1;
  i64toi32_i32$1 = $1 + 12 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $12;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__plutus__CostModel_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h131279c16539114c($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   $1 = __rust_alloc(16 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(16 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__plutus__Costmdls_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8003415a0e008f0e($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   $1 = __rust_alloc(16 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(16 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__plutus__Languages_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h685771a5e09c75ed($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   $1 = __rust_alloc(16 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(16 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__plutus__PlutusMap_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hc959583e66b458a0($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   $1 = __rust_alloc(16 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(16 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__plutus__Redeemers_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hb4f0431e16335b87($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   $1 = __rust_alloc(16 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(16 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__plutus__Strings_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he577c36628c95b6e($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   $1 = __rust_alloc(16 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(16 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($1 + 12 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  return $1 | 0;
 }
 
 function core__slice__cmp___impl_20core__cmp__Ord_20for_20_5bT_5d___cmp__h1f2092e0ba2f27ea($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  label$1 : {
   $0 = memcmp($0 | 0, $2 | 0, ($1 >>> 0 > $3 >>> 0 ? $3 : $1) | 0) | 0;
   if ($0) {
    break label$1
   }
   return ($1 >>> 0 < $3 >>> 0 ? -1 : ($1 | 0) != ($3 | 0)) | 0;
  }
  return (($0 | 0) < (0 | 0) ? -1 : 1) | 0;
 }
 
 function $cryptoxide__hmac__Hmac_D__20as_20cryptoxide__mac__Mac___reset__hbf8667f113797205($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cryptoxide__sha2__Sha512_20as_20cryptoxide__digest__Digest___reset__h100e33024dbb0407($0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h12ac465cd2b9ef75($1 + 8 | 0 | 0, $0 + 224 | 0 | 0);
  $cryptoxide__sha2__Sha512_20as_20cryptoxide__digest__Digest___input__h63322ce5a02a233a($0 | 0, HEAP32[($1 + 8 | 0) >> 2] | 0 | 0, HEAP32[($1 + 12 | 0) >> 2] | 0 | 0);
  HEAP8[($0 + 248 | 0) >> 0] = 0;
  global$0 = $1 + 16 | 0;
 }
 
 function $alloc__vec__Vec_bech32__u5__20as_20bech32__WriteBase32___write_u5__hb515549aebcd01f1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if ((HEAP32[($0 + 4 | 0) >> 2] | 0 | 0) != ($2 | 0)) {
    break label$1
   }
   alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hace6da240d5ba1ef($0 | 0, $2 | 0, 1 | 0);
   $2 = HEAP32[($0 + 8 | 0) >> 2] | 0;
  }
  HEAP32[($0 + 8 | 0) >> 2] = $2 + 1 | 0;
  HEAP8[((HEAP32[$0 >> 2] | 0) + $2 | 0) >> 0] = $1;
  return 0 | 0;
 }
 
 function $dlmalloc__sys__System_20as_20dlmalloc__Allocator___alloc__h1d32aef92d923b70($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, $10 = 0;
  $3 = __wasm_memory_grow($2 >>> 16 | 0 | 0);
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  $10 = $2 & -65536 | 0;
  $2 = ($3 | 0) == (-1 | 0);
  HEAP32[($0 + 4 | 0) >> 2] = $2 ? 0 : $10;
  HEAP32[$0 >> 2] = $2 ? 0 : $3 << 16 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__RelayEnum___serialize__h742c43d428b38e2a($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  label$1 : {
   switch (HEAPU16[$1 >> 1] | 0 | 0) {
   default:
    cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__SingleHostAddr___serialize__h544b90ba79e7b7c9($0 | 0, $1 + 2 | 0 | 0, $2 | 0);
    return;
   case 1:
    cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__SingleHostName___serialize__h1ca1f820778507e6($0 | 0, $1 + 4 | 0 | 0, $2 | 0);
    return;
   case 2:
    break label$1;
   };
  }
  cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__MultiHostName___serialize__h22530ddd6dac0df6($0 | 0, $1 + 4 | 0 | 0, $2 | 0);
 }
 
 function __wbg_transaction_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 432 | 0;
  global$0 = $1;
  $cardano_serialization_lib__Transaction_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hd805c00505bcf788($1 + 8 | 0 | 0, $0 | 0);
  core__ptr__drop_in_place_cardano_serialization_lib__TransactionBody___h9274013021a1d568_1($1 + 8 | 0 | 0);
  core__ptr__drop_in_place_cardano_serialization_lib__TransactionWitnessSet___h7d278d9502f6471a_1($1 + 352 | 0 | 0);
  core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__metadata__AuxiliaryData____ha98f6c5d89b7a772($1 + 280 | 0 | 0);
  global$0 = $1 + 432 | 0;
 }
 
 function linked_hash_map__LinkedHashMap_K_2cV_2cS___drop_entries__h37111127d817c283($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 32 | 0) >> 2] | 0;
   $0 = HEAP32[($1 + 408 | 0) >> 2] | 0;
   if (($0 | 0) == ($1 | 0)) {
    break label$1
   }
   label$2 : while (1) {
    $2 = HEAP32[($0 + 408 | 0) >> 2] | 0;
    core__ptr__drop_in_place_cardano_serialization_lib__ProtocolParamUpdate___h92eeb91cabd2847d_1($0 | 0);
    __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($0 | 0) | 0 | 0, 448 | 0, 8 | 0);
    $0 = $2;
    if (($0 | 0) != ($1 | 0)) {
     continue label$2
    }
    break label$2;
   };
  }
 }
 
 function linked_hash_map__LinkedHashMap_K_2cV_2cS___drop_entries__h6212a14c640f8f83($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 32 | 0) >> 2] | 0;
   $0 = HEAP32[($1 + 64 | 0) >> 2] | 0;
   if (($0 | 0) == ($1 | 0)) {
    break label$1
   }
   label$2 : while (1) {
    $2 = HEAP32[($0 + 64 | 0) >> 2] | 0;
    core__ptr__drop_in_place_cardano_serialization_lib__metadata__AuxiliaryData___hdde6d009d300f71d($0 | 0);
    __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($0 | 0) | 0 | 0, 80 | 0, 8 | 0);
    $0 = $2;
    if (($0 | 0) != ($1 | 0)) {
     continue label$2
    }
    break label$2;
   };
  }
 }
 
 function linked_hash_map__LinkedHashMap_K_2cV_2cS___drop_entries__h7c21284b35a5a639($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 32 | 0) >> 2] | 0;
   $0 = HEAP32[($1 + 152 | 0) >> 2] | 0;
   if (($0 | 0) == ($1 | 0)) {
    break label$1
   }
   label$2 : while (1) {
    $2 = HEAP32[($0 + 152 | 0) >> 2] | 0;
    core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__tx_builder__tx_inputs_builder__ScriptWitnessType____h04ba3cf23b50ffc0($0 | 0);
    __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($0 | 0) | 0 | 0, 192 | 0, 8 | 0);
    $0 = $2;
    if (($0 | 0) != ($1 | 0)) {
     continue label$2
    }
    break label$2;
   };
  }
 }
 
 function core__ptr__drop_in_place_alloc__boxed__Box_dyn_20std__error__Error_core__marker__Sync_core__marker__Send____h3635675e5a953b32($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  FUNCTION_TABLE[HEAP32[(HEAP32[($0 + 4 | 0) >> 2] | 0) >> 2] | 0 | 0](HEAP32[$0 >> 2] | 0);
  $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  $1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $0 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$0 >> 2] | 0 | 0) | 0;
  label$1 : {
   if (!$1) {
    break label$1
   }
   __rust_dealloc($0 | 0, $1 | 0, $2 | 0);
  }
 }
 
 function $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h3d696390b8f8d3c9($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   label$2 : {
    if (!(HEAP32[($1 + 8 | 0) >> 2] | 0)) {
     break label$2
    }
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$2) {
     break label$1
    }
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__clone_subtree__hea30e1a0150984fa($0 | 0, HEAP32[$1 >> 2] | 0 | 0, $2 | 0);
    return;
   }
   HEAP32[($0 + 4 | 0) >> 2] = 0;
   HEAP32[($0 + 8 | 0) >> 2] = 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1067386 | 0, 43 | 0, 1067908 | 0);
  abort();
 }
 
 function $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h6b2563f257cc6de2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   label$2 : {
    if (!(HEAP32[($1 + 8 | 0) >> 2] | 0)) {
     break label$2
    }
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$2) {
     break label$1
    }
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__clone_subtree__h5434fcebccdb4d74($0 | 0, HEAP32[$1 >> 2] | 0 | 0, $2 | 0);
    return;
   }
   HEAP32[($0 + 4 | 0) >> 2] = 0;
   HEAP32[($0 + 8 | 0) >> 2] = 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1067386 | 0, 43 | 0, 1067908 | 0);
  abort();
 }
 
 function $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h3f0faaa5740c6934($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   label$2 : {
    if (!(HEAP32[($1 + 8 | 0) >> 2] | 0)) {
     break label$2
    }
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$2) {
     break label$1
    }
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__clone_subtree__hc4de5541b53cd546($0 | 0, HEAP32[$1 >> 2] | 0 | 0, $2 | 0);
    return;
   }
   HEAP32[($0 + 4 | 0) >> 2] = 0;
   HEAP32[($0 + 8 | 0) >> 2] = 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1067386 | 0, 43 | 0, 1067908 | 0);
  abort();
 }
 
 function $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h4a35d7ddb2264390($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   label$2 : {
    if (!(HEAP32[($1 + 8 | 0) >> 2] | 0)) {
     break label$2
    }
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$2) {
     break label$1
    }
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__clone_subtree__hf11375d59f632633($0 | 0, HEAP32[$1 >> 2] | 0 | 0, $2 | 0);
    return;
   }
   HEAP32[($0 + 4 | 0) >> 2] = 0;
   HEAP32[($0 + 8 | 0) >> 2] = 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1067386 | 0, 43 | 0, 1067908 | 0);
  abort();
 }
 
 function $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h663a668224e1772a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   label$2 : {
    if (!(HEAP32[($1 + 8 | 0) >> 2] | 0)) {
     break label$2
    }
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$2) {
     break label$1
    }
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__clone_subtree__h6457b21d29182680($0 | 0, HEAP32[$1 >> 2] | 0 | 0, $2 | 0);
    return;
   }
   HEAP32[($0 + 4 | 0) >> 2] = 0;
   HEAP32[($0 + 8 | 0) >> 2] = 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1067386 | 0, 43 | 0, 1067908 | 0);
  abort();
 }
 
 function $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__hc97a6f621815d13c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   label$2 : {
    if (!(HEAP32[($1 + 8 | 0) >> 2] | 0)) {
     break label$2
    }
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$2) {
     break label$1
    }
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__clone_subtree__h1f9e2acc901ac417($0 | 0, HEAP32[$1 >> 2] | 0 | 0, $2 | 0);
    return;
   }
   HEAP32[($0 + 4 | 0) >> 2] = 0;
   HEAP32[($0 + 8 | 0) >> 2] = 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1067386 | 0, 43 | 0, 1067908 | 0);
  abort();
 }
 
 function $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__hf4eb1bac8cecd8c9($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   label$2 : {
    if (!(HEAP32[($1 + 8 | 0) >> 2] | 0)) {
     break label$2
    }
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$2) {
     break label$1
    }
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__clone_subtree__hce8ff294b4963e31($0 | 0, HEAP32[$1 >> 2] | 0 | 0, $2 | 0);
    return;
   }
   HEAP32[($0 + 4 | 0) >> 2] = 0;
   HEAP32[($0 + 8 | 0) >> 2] = 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1067386 | 0, 43 | 0, 1067908 | 0);
  abort();
 }
 
 function $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__hf5a9da539450c63e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   label$2 : {
    if (!(HEAP32[($1 + 8 | 0) >> 2] | 0)) {
     break label$2
    }
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$2) {
     break label$1
    }
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__clone_subtree__h7ba328195d29e47f($0 | 0, HEAP32[$1 >> 2] | 0 | 0, $2 | 0);
    return;
   }
   HEAP32[($0 + 4 | 0) >> 2] = 0;
   HEAP32[($0 + 8 | 0) >> 2] = 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1067386 | 0, 43 | 0, 1067908 | 0);
  abort();
 }
 
 function $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__hf9a33b4634734bb7($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   label$2 : {
    if (!(HEAP32[($1 + 8 | 0) >> 2] | 0)) {
     break label$2
    }
    $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
    if (!$2) {
     break label$1
    }
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__clone_subtree__h2916732d8c8f5a11($0 | 0, HEAP32[$1 >> 2] | 0 | 0, $2 | 0);
    return;
   }
   HEAP32[($0 + 4 | 0) >> 2] = 0;
   HEAP32[($0 + 8 | 0) >> 2] = 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1067386 | 0, 43 | 0, 1067908 | 0);
  abort();
 }
 
 function cryptoxide__ed25519__extended_to_public__hb7e9895dfbf0ff6d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 208 | 0;
  global$0 = $2;
  cryptoxide__curve25519__scalar__scalar64__Scalar__from_bytes__hcfeedd1974a72bb6($2 + 168 | 0 | 0, $1 | 0);
  cryptoxide__curve25519__ge__Ge__scalarmult_base__hfb711866362b33a6($2 + 8 | 0 | 0, $2 + 168 | 0 | 0);
  cryptoxide__curve25519__ge__Ge__to_bytes__hce32fa3f32cec513($0 | 0, $2 + 8 | 0 | 0);
  global$0 = $2 + 208 | 0;
 }
 
 function rust_begin_unwind($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $3 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $2 = core__option__Option_T___unwrap__h96fd28f0a1fc1e2b(core__panic__PanicInfo__location__h50b64b9c30ab247b($0 | 0) | 0 | 0, 1144264 | 0) | 0;
  $3 = core__option__Option_T___unwrap__h1337386e31e069fb(core__panic__PanicInfo__message__hf990209c674102c0($0 | 0) | 0 | 0) | 0;
  HEAP32[($1 + 8 | 0) >> 2] = $2;
  HEAP32[($1 + 4 | 0) >> 2] = $0;
  HEAP32[$1 >> 2] = $3;
  std__sys_common__backtrace____rust_end_short_backtrace__hf31049169beda171($1 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__KV___split__h678cd438a93e6f1b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = alloc__boxed__Box_T_2cA___new_uninit_in__hcce3eeaf87129ab3() | 0;
  HEAP16[($2 + 138 | 0) >> 1] = 0;
  HEAP32[$2 >> 2] = 0;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__h94ef26d698df746a($0 + 8 | 0 | 0, $1 | 0, $2 | 0);
  HEAP32[($0 + 52 | 0) >> 2] = $2;
  HEAP32[($0 + 48 | 0) >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  HEAP32[$0 >> 2] = HEAP32[$1 >> 2] | 0;
  HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$1;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__KV___split__h932ae7ef40994b5b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = alloc__boxed__Box_T_2cA___new_uninit_in__h0c9edbef1faf0ccf() | 0;
  HEAP16[($2 + 6 | 0) >> 1] = 0;
  HEAP32[$2 >> 2] = 0;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__h85dcc5ded7d0d8e9($0 + 16 | 0 | 0, $1 | 0, $2 | 0);
  HEAP32[($0 + 12 | 0) >> 2] = $2;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  HEAP32[$0 >> 2] = HEAP32[$1 >> 2] | 0;
  HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$1;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__KV___split__ha51648547f6ff2af($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = alloc__boxed__Box_T_2cA___new_uninit_in__h8bd6a5af2b5d8b6d() | 0;
  HEAP16[($2 + 138 | 0) >> 1] = 0;
  HEAP32[$2 >> 2] = 0;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__hf867250b9f689ec3($0 + 8 | 0 | 0, $1 | 0, $2 | 0);
  HEAP32[($0 + 52 | 0) >> 2] = $2;
  HEAP32[($0 + 48 | 0) >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  HEAP32[$0 >> 2] = HEAP32[$1 >> 2] | 0;
  HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$1;
 }
 
 function hashbrown__raw__RawTable_T_2cA___free_buckets__h3d4ebb1515e16a56($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $2 = 0, $5 = 0;
  label$1 : {
   $1 = HEAP32[$0 >> 2] | 0;
   $5 = $1;
   i64toi32_i32$0 = 0;
   i64toi32_i32$1 = 0;
   i64toi32_i32$1 = __wasm_i64_mul($1 + 1 | 0 | 0, i64toi32_i32$0 | 0, 24 | 0, i64toi32_i32$1 | 0) | 0;
   i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
   $1 = i64toi32_i32$1;
   $2 = ($5 + $1 | 0) + 5 | 0;
   if (!$2) {
    break label$1
   }
   __rust_dealloc((HEAP32[($0 + 4 | 0) >> 2] | 0) - $1 | 0 | 0, $2 | 0, 4 | 0);
  }
 }
 
 function hashbrown__raw__RawTable_T_2cA___free_buckets__h0d3b2bc1ee0c4acb($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $2 = 0, $5 = 0;
  label$1 : {
   $1 = HEAP32[$0 >> 2] | 0;
   $5 = $1;
   i64toi32_i32$0 = 0;
   i64toi32_i32$1 = 0;
   i64toi32_i32$1 = __wasm_i64_mul($1 + 1 | 0 | 0, i64toi32_i32$0 | 0, 28 | 0, i64toi32_i32$1 | 0) | 0;
   i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
   $1 = i64toi32_i32$1;
   $2 = ($5 + $1 | 0) + 5 | 0;
   if (!$2) {
    break label$1
   }
   __rust_dealloc((HEAP32[($0 + 4 | 0) >> 2] | 0) - $1 | 0 | 0, $2 | 0, 4 | 0);
  }
 }
 
 function hashbrown__raw__RawTable_T_2cA___free_buckets__h7c64645064a3fef1($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, $2 = 0, $5 = 0;
  label$1 : {
   $1 = HEAP32[$0 >> 2] | 0;
   $5 = $1;
   i64toi32_i32$0 = 0;
   i64toi32_i32$1 = 0;
   i64toi32_i32$1 = __wasm_i64_mul($1 + 1 | 0 | 0, i64toi32_i32$0 | 0, 12 | 0, i64toi32_i32$1 | 0) | 0;
   i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
   $1 = i64toi32_i32$1;
   $2 = ($5 + $1 | 0) + 5 | 0;
   if (!$2) {
    break label$1
   }
   __rust_dealloc((HEAP32[($0 + 4 | 0) >> 2] | 0) - $1 | 0 | 0, $2 | 0, 4 | 0);
  }
 }
 
 function cardano_serialization_lib__chain_crypto__bech32__Error__data_invalid__h845fc6de9cc87c9e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = __rust_alloc(1 | 0, 1 | 0) | 0;
   if ($2) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(1 | 0, 1 | 0);
   abort();
  }
  HEAP32[($0 + 4 | 0) >> 2] = $2;
  HEAP8[$2 >> 0] = $1;
  HEAP32[$0 >> 2] = 2;
  HEAP32[($0 + 8 | 0) >> 2] = 1056496;
 }
 
 function cardano_serialization_lib__chain_crypto__bech32__Error__data_invalid__he819388589c1a4db($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = __rust_alloc(1 | 0, 1 | 0) | 0;
   if ($2) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(1 | 0, 1 | 0);
   abort();
  }
  HEAP32[($0 + 4 | 0) >> 2] = $2;
  HEAP8[$2 >> 0] = $1;
  HEAP32[$0 >> 2] = 2;
  HEAP32[($0 + 8 | 0) >> 2] = 1056576;
 }
 
 function cardano_serialization_lib__metadata__TransactionMetadatum__as_map__h93c64120b048faea($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  label$1 : {
   label$2 : {
    if (HEAP32[$1 >> 2] | 0) {
     break label$2
    }
    $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__clone__Clone___clone__hdeea20968268d729($0 + 8 | 0 | 0, $1 + 8 | 0 | 0);
    $1 = 0;
    break label$1;
   }
   (wasm2js_i32$0 = $0, wasm2js_i32$1 = wasm_bindgen____wbindgen_string_new__h4b9436fdd8869b12(1060480 | 0, 9 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
 }
 
 function hex__encode__ha65497b593c9e23a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $1 | 0);
  hex__encode_to_iter__h3b9b5dcb85c2c5cd($0 | 0, 1067368 | 0, HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  global$0 = $2 + 16 | 0;
 }
 
 function $alloc__rc__Rc_T__20as_20core__ops__drop__Drop___drop__h9c6f1ce9a80847e3($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $0 = HEAP32[$0 >> 2] | 0;
  $1 = (HEAP32[$0 >> 2] | 0) + -1 | 0;
  HEAP32[$0 >> 2] = $1;
  label$1 : {
   if ($1) {
    break label$1
   }
   $1 = (HEAP32[($0 + 4 | 0) >> 2] | 0) + -1 | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   if ($1) {
    break label$1
   }
   __rust_dealloc($0 | 0, 344 | 0, 8 | 0);
  }
 }
 
 function $cbor_event__error__Error_20as_20core__convert__From_alloc__string__FromUtf8Error____from__hdc659cdcf1613a8b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $6 = 0, $16 = 0;
  HEAP8[$0 >> 0] = 14;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $6 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 4 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $6;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($0 + 20 | 0) >> 2] = HEAP32[(i64toi32_i32$2 + 16 | 0) >> 2] | 0;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $16 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 12 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $16;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
 }
 
 function memcpy($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  label$1 : {
   if (!$2) {
    break label$1
   }
   $3 = $0;
   label$2 : while (1) {
    HEAP8[$3 >> 0] = HEAPU8[$1 >> 0] | 0;
    $1 = $1 + 1 | 0;
    $3 = $3 + 1 | 0;
    $2 = $2 + -1 | 0;
    if ($2) {
     continue label$2
    }
    break label$2;
   };
  }
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__utils__Int_20as_20cbor_event__se__Serialize___serialize__h52978cec14c40013($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, $3$hi = 0, i64toi32_i32$3 = 0, $9 = 0, $10 = 0, $11 = 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $3 = i64toi32_i32$0;
  $3$hi = i64toi32_i32$1;
  label$1 : {
   i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
   i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   i64toi32_i32$2 = i64toi32_i32$1;
   i64toi32_i32$1 = 0;
   i64toi32_i32$3 = 0;
   if ((i64toi32_i32$0 | 0) < (i64toi32_i32$1 | 0)) {
    $9 = 1
   } else {
    if ((i64toi32_i32$0 | 0) <= (i64toi32_i32$1 | 0)) {
     if (i64toi32_i32$2 >>> 0 >= i64toi32_i32$3 >>> 0) {
      $10 = 0
     } else {
      $10 = 1
     }
     $11 = $10;
    } else {
     $11 = 0
    }
    $9 = $11;
   }
   if ($9) {
    break label$1
   }
   i64toi32_i32$2 = $3$hi;
   cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($0 | 0, $2 | 0, 0 | 0, $3 | 0, i64toi32_i32$2 | 0);
   return;
  }
  i64toi32_i32$2 = $3$hi;
  i64toi32_i32$3 = $3;
  i64toi32_i32$0 = -1;
  i64toi32_i32$1 = -1;
  i64toi32_i32$0 = i64toi32_i32$2 ^ i64toi32_i32$0 | 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($0 | 0, $2 | 0, 1 | 0, $3 ^ i64toi32_i32$1 | 0 | 0, i64toi32_i32$0 | 0);
 }
 
 function linked_hash_map__LinkedHashMap_K_2cV_2cS___drop_entries__h0f365ed47268b966($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 32 | 0) >> 2] | 0;
   $0 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   if (($0 | 0) == ($1 | 0)) {
    break label$1
   }
   label$2 : while (1) {
    $2 = HEAP32[($0 + 8 | 0) >> 2] | 0;
    __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($0 | 0) | 0 | 0, 48 | 0, 8 | 0);
    $0 = $2;
    if (($0 | 0) != ($1 | 0)) {
     continue label$2
    }
    break label$2;
   };
  }
 }
 
 function linked_hash_map__LinkedHashMap_K_2cV_2cS___drop_entries__h32fed5f9b7f36227($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 32 | 0) >> 2] | 0;
   $0 = HEAP32[($1 + 16 | 0) >> 2] | 0;
   if (($0 | 0) == ($1 | 0)) {
    break label$1
   }
   label$2 : while (1) {
    $2 = HEAP32[($0 + 16 | 0) >> 2] | 0;
    __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($0 | 0) | 0 | 0, 56 | 0, 8 | 0);
    $0 = $2;
    if (($0 | 0) != ($1 | 0)) {
     continue label$2
    }
    break label$2;
   };
  }
 }
 
 function $linked_hash_map__KeyRef_K__20as_20core__cmp__PartialEq___eq__h969d25de4a7a4343($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = 0;
  label$1 : {
   $0 = HEAP32[$0 >> 2] | 0;
   $1 = HEAP32[$1 >> 2] | 0;
   if ((HEAPU8[$0 >> 0] | 0 | 0) != (HEAPU8[$1 >> 0] | 0 | 0)) {
    break label$1
   }
   $2 = !(memcmp($0 + 1 | 0 | 0, $1 + 1 | 0 | 0, 28 | 0) | 0);
  }
  return $2 | 0;
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h000099354d5ff519($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h0350daea3c8d0cce($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h0497bf4a59b2a68b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h0848e1414118541a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h09a25d0fa720925e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h0a3b5f1cc5dc7523($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h0d8537c364f480d5($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h0e158f5408360d02($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h0e53d0166415c79c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h0fe7af65622a319f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h10da0fea03f0ac1d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h14eb25306bbe3311($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h1715449b8810f0c1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h17af7d9d2d20aa0f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h18a4570cc8a3407a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h1a6acf099b73960c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h1cb96e7b1dabbc55($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h1f4aa39af4dc2942($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h20ee1b39869b5e8f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h2150b2b2433b33e4($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h2338c90e0327d08b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h274f52f9a26a0dc8($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h27da893e95dd15cf($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h2ac16fcb64db16b5($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h2b38e1d613820f8e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h2c8b1c7122d0d2b0($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h2d6285fb6a1d44f8($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h2f574964f7dad662($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h30021c0122a7c8e6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h356c30395cf13adb($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h358f17571789b373($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h37dfbd2f31d951c1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h38603c546ca761f2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h38787c785ea84973($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h388263144730eb6a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h38bb6325d5b407e9($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h3b62e22150831bdc($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h415aed7c06a10866($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h419753218ead1831($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h41e273aed1ab619e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h42c8face5b925abb($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h449d6579c00e5aca($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h451504312a4b72d0($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h4b15d475a6cbc138($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h4f79d4afa0b85c1a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h4fe5a3e1c18388b1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h59b9713b6e595a95($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h5bcc7e1da6f9ff93($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h5db5149478ec5345($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h60bb016b22d9de75($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h60ca34959655b0d6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h6185b44b866d43f0($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h63771635114e9ad4($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h670b86b1bfb2242f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h6789b4b005d0c63f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h67eb974eba5bb4b0($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h6b7eaec1bcfb1ff8($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h6bd3a1ad9f257a81($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h6e50d398ad665042($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h6ed0b6b043905434($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h70df86682e940485($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h72d8bcf0a652eb89($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h74054450d591b36f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h74f2437fd791f127($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h76a11b605f70ebd5($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h76f3e067f9139bb4($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h77d6f4a2273f50b5($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h786c2d78691f35ff($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h78c51a186dbaf877($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h78f278b481f170f8($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h7b63d9df2a892a8b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h7b8fe8d9d71033fc($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h7d8a0640f2deb41e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h7fe2cd68d7de412a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h8308bd69a8eeb68f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h8348e40d8f63e5f1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h84b5bdabb1c1c80b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h84d192b5a1b597ea($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h8aa27fc1f3f1159b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h8caae7a957e11e51($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h8e1034a64e070b53($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h8eb054d444413163($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h8f4f32b29a620a40($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h91e3d4f7af3d2ccd($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h9606b27f8e88a40d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h96a5bfd90503076d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h98bfbcc994df632c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h9968e42c55861cec($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h99bd8393a0065b1d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h9c2d3a72ebf4d25f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h9c68abd5a6a78973($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__h9f3eeaa31aede5c7($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__ha28b58697d2aa221($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__ha45853a045a59ee7($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__haac84d0387ff0446($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__hab2c0cbdcb539b91($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__hab914e4e14c49c39($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__hae9c55c4e91ce40f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__hb0365aa08561904d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__hb17ff77b9b324998($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__hb1fd14a6870cafe2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__hb2360c57549df4d5($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__hb3e63bba3ecb8dc7($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__hb4a7701b5bc2a87c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__hbb8371c94476a171($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__hbebd755b3868aed3($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__hbec83ebdd86caafd($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__hbfc7b2ba05921680($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__hc466bac66f8af18e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__hc49defd7d95949da($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__hc630c86c4ab6b26d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__hc7fc7357c4bbb0b7($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__hc81980191b5e557a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__hc838c9a2ed8b7fab($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__hca2e1c7f0251c418($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__hcbf9fa57042ff117($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__hcc9e595588038ff3($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__hcfcf2a638924fc64($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__hd0c16785fb9ea7bd($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__hd2a6d676353c0b6c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__hd6fdee4274fe58a2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__hd7bc050864a8d646($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__hd84cc8f720a3dada($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__hd98e995abd746618($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__hdcd31189477e1360($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__hdd2a3d9c2413fc4e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__hdd9a557acdd7acfa($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__he0885d10b4548804($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__he533e1773e537fcd($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__he8e3d260cc550142($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__hf03f8ea4201fce5b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__hf2abefb15e68f011($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__hf3651990986a0e62($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__hf668a970fcd602f3($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__hf87f6527083f250a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__hfa98d20552a22c6d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__hfc784c950a3a2da2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__hfefec6c3ca92202d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow__hff8ea54f5a18a01d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   if (($2 | 0) == (-1 | 0)) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, $2 + 1 | 0 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__h43bfad66db8b3ade($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__next_or_end__h91b22591aa945f46($1 | 0, $0 | 0);
  label$1 : {
   if (!(HEAP32[($1 + 4 | 0) >> 2] | 0)) {
    break label$1
   }
   label$2 : while (1) {
    $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__next_or_end__h91b22591aa945f46($1 | 0, $0 | 0);
    if (HEAP32[($1 + 4 | 0) >> 2] | 0) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $1 + 16 | 0;
 }
 
 function $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__h61895ab898024b72($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__next_or_end__hf96b0f69fdd084ea($1 | 0, $0 | 0);
  label$1 : {
   if (!(HEAP32[($1 + 4 | 0) >> 2] | 0)) {
    break label$1
   }
   label$2 : while (1) {
    $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__next_or_end__hf96b0f69fdd084ea($1 | 0, $0 | 0);
    if (HEAP32[($1 + 4 | 0) >> 2] | 0) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $1 + 16 | 0;
 }
 
 function $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__hbd56bd5c906359e6($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__next_or_end__h0bbd2a4d146075f9($1 | 0, $0 | 0);
  label$1 : {
   if (!(HEAP32[($1 + 4 | 0) >> 2] | 0)) {
    break label$1
   }
   label$2 : while (1) {
    $alloc__collections__btree__map__Dropper_K_2cV__20as_20core__ops__drop__Drop___drop__next_or_end__h0bbd2a4d146075f9($1 | 0, $0 | 0);
    if (HEAP32[($1 + 4 | 0) >> 2] | 0) {
     continue label$2
    }
    break label$2;
   };
  }
  global$0 = $1 + 16 | 0;
 }
 
 function cardano_serialization_lib__plutus__PlutusMap__insert__h48ea63e22ae70233($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0;
  $4 = global$0 - 96 | 0;
  global$0 = $4;
  $cardano_serialization_lib__plutus__PlutusData_20as_20core__clone__Clone___clone__h63d1a98cc18f4609_2($4 | 0, $2 | 0);
  $cardano_serialization_lib__plutus__PlutusData_20as_20core__clone__Clone___clone__h63d1a98cc18f4609_2($4 + 48 | 0 | 0, $3 | 0);
  alloc__collections__btree__map__BTreeMap_K_2cV___insert__hb14f14f8e669d8cf($0 | 0, $1 | 0, $4 | 0, $4 + 48 | 0 | 0);
  global$0 = $4 + 96 | 0;
 }
 
 function ppv_lite86__generic__dmap__h79b8a89a90129183($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  (wasm2js_i32$0 = $0, wasm2js_i32$1 = __wasm_rotl_i32(HEAP32[($1 + 12 | 0) >> 2] | 0 | 0, 8 | 0) | 0), HEAP32[(wasm2js_i32$0 + 12 | 0) >> 2] = wasm2js_i32$1;
  (wasm2js_i32$0 = $0, wasm2js_i32$1 = __wasm_rotl_i32(HEAP32[($1 + 8 | 0) >> 2] | 0 | 0, 8 | 0) | 0), HEAP32[(wasm2js_i32$0 + 8 | 0) >> 2] = wasm2js_i32$1;
  (wasm2js_i32$0 = $0, wasm2js_i32$1 = __wasm_rotl_i32(HEAP32[($1 + 4 | 0) >> 2] | 0 | 0, 8 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  (wasm2js_i32$0 = $0, wasm2js_i32$1 = __wasm_rotl_i32(HEAP32[$1 >> 2] | 0 | 0, 8 | 0) | 0), HEAP32[wasm2js_i32$0 >> 2] = wasm2js_i32$1;
 }
 
 function ppv_lite86__generic__dmap__h8dc4284c5eb4ed5a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  (wasm2js_i32$0 = $0, wasm2js_i32$1 = __wasm_rotl_i32(HEAP32[($1 + 12 | 0) >> 2] | 0 | 0, 12 | 0) | 0), HEAP32[(wasm2js_i32$0 + 12 | 0) >> 2] = wasm2js_i32$1;
  (wasm2js_i32$0 = $0, wasm2js_i32$1 = __wasm_rotl_i32(HEAP32[($1 + 8 | 0) >> 2] | 0 | 0, 12 | 0) | 0), HEAP32[(wasm2js_i32$0 + 8 | 0) >> 2] = wasm2js_i32$1;
  (wasm2js_i32$0 = $0, wasm2js_i32$1 = __wasm_rotl_i32(HEAP32[($1 + 4 | 0) >> 2] | 0 | 0, 12 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  (wasm2js_i32$0 = $0, wasm2js_i32$1 = __wasm_rotl_i32(HEAP32[$1 >> 2] | 0 | 0, 12 | 0) | 0), HEAP32[wasm2js_i32$0 >> 2] = wasm2js_i32$1;
 }
 
 function ppv_lite86__generic__dmap__hc6c47356357b6261($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  (wasm2js_i32$0 = $0, wasm2js_i32$1 = __wasm_rotl_i32(HEAP32[($1 + 12 | 0) >> 2] | 0 | 0, 7 | 0) | 0), HEAP32[(wasm2js_i32$0 + 12 | 0) >> 2] = wasm2js_i32$1;
  (wasm2js_i32$0 = $0, wasm2js_i32$1 = __wasm_rotl_i32(HEAP32[($1 + 8 | 0) >> 2] | 0 | 0, 7 | 0) | 0), HEAP32[(wasm2js_i32$0 + 8 | 0) >> 2] = wasm2js_i32$1;
  (wasm2js_i32$0 = $0, wasm2js_i32$1 = __wasm_rotl_i32(HEAP32[($1 + 4 | 0) >> 2] | 0 | 0, 7 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  (wasm2js_i32$0 = $0, wasm2js_i32$1 = __wasm_rotl_i32(HEAP32[$1 >> 2] | 0 | 0, 7 | 0) | 0), HEAP32[wasm2js_i32$0 >> 2] = wasm2js_i32$1;
 }
 
 function ppv_lite86__generic__dmap__hd102a368e6d0db5e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  (wasm2js_i32$0 = $0, wasm2js_i32$1 = __wasm_rotl_i32(HEAP32[($1 + 12 | 0) >> 2] | 0 | 0, 16 | 0) | 0), HEAP32[(wasm2js_i32$0 + 12 | 0) >> 2] = wasm2js_i32$1;
  (wasm2js_i32$0 = $0, wasm2js_i32$1 = __wasm_rotl_i32(HEAP32[($1 + 8 | 0) >> 2] | 0 | 0, 16 | 0) | 0), HEAP32[(wasm2js_i32$0 + 8 | 0) >> 2] = wasm2js_i32$1;
  (wasm2js_i32$0 = $0, wasm2js_i32$1 = __wasm_rotl_i32(HEAP32[($1 + 4 | 0) >> 2] | 0 | 0, 16 | 0) | 0), HEAP32[(wasm2js_i32$0 + 4 | 0) >> 2] = wasm2js_i32$1;
  (wasm2js_i32$0 = $0, wasm2js_i32$1 = __wasm_rotl_i32(HEAP32[$1 >> 2] | 0 | 0, 16 | 0) | 0), HEAP32[wasm2js_i32$0 >> 2] = wasm2js_i32$1;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___current_memory__hca02c4a219cdf810($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[($1 + 4 | 0) >> 2] | 0;
   if (!$2) {
    break label$1
   }
   HEAP32[($0 + 8 | 0) >> 2] = 4;
   HEAP32[($0 + 4 | 0) >> 2] = $2 << 2 | 0;
   HEAP32[$0 >> 2] = HEAP32[$1 >> 2] | 0;
   return;
  }
  HEAP32[$0 >> 2] = 0;
 }
 
 function cryptoxide__curve25519__ge__GeP1P1__to_partial__h5f1785bbb90d5b59($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $11 = 0;
  $2 = $1 + 120 | 0;
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($0 | 0, $1 | 0, $2 | 0);
  $11 = $1 + 40 | 0;
  $1 = $1 + 80 | 0;
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($0 + 40 | 0 | 0, $11 | 0, $1 | 0);
  $_cryptoxide__curve25519__fe__fe64__Fe_20as_20core__ops__arith__Mul___mul__h5702661e270bb035($0 + 80 | 0 | 0, $1 | 0, $2 | 0);
 }
 
 function __wbindgen_malloc($0) {
  $0 = $0 | 0;
  label$1 : {
   if ($0 >>> 0 > -4 >>> 0) {
    break label$1
   }
   label$2 : {
    if ($0) {
     break label$2
    }
    return 4 | 0;
   }
   $0 = __rust_alloc($0 | 0, ($0 >>> 0 < -3 >>> 0) << 2 | 0 | 0) | 0;
   if (!$0) {
    break label$1
   }
   return $0 | 0;
  }
  wasm_bindgen____rt__malloc_failure__h5d7f43e474eb159a();
  abort();
 }
 
 function core__iter__adapters__step_by__StepBy_I___new__h21a520baea7dc9f1($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  label$1 : {
   if (!$3) {
    break label$1
   }
   HEAP8[($0 + 12 | 0) >> 0] = 1;
   HEAP32[($0 + 4 | 0) >> 2] = $2;
   HEAP32[$0 >> 2] = $1;
   HEAP32[($0 + 8 | 0) >> 2] = $3 + -1 | 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1142040 | 0, 27 | 0, 1142156 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__KV___split__h58fcbc0b41995e56($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = alloc__boxed__Box_T_2cA___new_uninit_in__h1d1537549f7a0074() | 0;
  HEAP16[($2 + 1458 | 0) >> 1] = 0;
  HEAP32[($2 + 1056 | 0) >> 2] = 0;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__hacdc9191bb753809($0 | 0, $1 | 0, $2 | 0);
  HEAP32[($0 + 148 | 0) >> 2] = $2;
  HEAP32[($0 + 144 | 0) >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  HEAP32[($0 + 136 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
  HEAP32[($0 + 140 | 0) >> 2] = i64toi32_i32$1;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__KV___split__h76d4343220eb9849($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = alloc__boxed__Box_T_2cA___new_uninit_in__h42dfd122c2fed30e() | 0;
  HEAP16[($2 + 1546 | 0) >> 1] = 0;
  HEAP32[($2 + 1408 | 0) >> 2] = 0;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__h23b19134df2dd8e0($0 | 0, $1 | 0, $2 | 0);
  HEAP32[($0 + 156 | 0) >> 2] = $2;
  HEAP32[($0 + 152 | 0) >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  HEAP32[($0 + 144 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
  HEAP32[($0 + 148 | 0) >> 2] = i64toi32_i32$1;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__KV___split__h844f4553f76d2c88($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = alloc__boxed__Box_T_2cA___new_uninit_in__h2ea6451c7ed438a4() | 0;
  HEAP16[($2 + 1062 | 0) >> 1] = 0;
  HEAP32[($2 + 1056 | 0) >> 2] = 0;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__h4a846a71d1392aee($0 | 0, $1 | 0, $2 | 0);
  HEAP32[($0 + 108 | 0) >> 2] = $2;
  HEAP32[($0 + 104 | 0) >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  HEAP32[($0 + 96 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
  HEAP32[($0 + 100 | 0) >> 2] = i64toi32_i32$1;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__KV___split__hba48e584646231bf($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = alloc__boxed__Box_T_2cA___new_uninit_in__h0005f5c05c0883da() | 0;
  HEAP16[($2 + 226 | 0) >> 1] = 0;
  HEAP32[($2 + 88 | 0) >> 2] = 0;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__he20e4b9e5ee43f9c($0 | 0, $1 | 0, $2 | 0);
  HEAP32[($0 + 36 | 0) >> 2] = $2;
  HEAP32[($0 + 32 | 0) >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  HEAP32[($0 + 24 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
  HEAP32[($0 + 28 | 0) >> 2] = i64toi32_i32$1;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__KV___split__hf19ab977dedf2ecc($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = alloc__boxed__Box_T_2cA___new_uninit_in__h637e1ec719c3dde5() | 0;
  HEAP16[($2 + 314 | 0) >> 1] = 0;
  HEAP32[($2 + 176 | 0) >> 2] = 0;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__h472347de6838beb9($0 | 0, $1 | 0, $2 | 0);
  HEAP32[($0 + 44 | 0) >> 2] = $2;
  HEAP32[($0 + 40 | 0) >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  HEAP32[($0 + 32 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
  HEAP32[($0 + 36 | 0) >> 2] = i64toi32_i32$1;
 }
 
 function __wbg_update_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  $cardano_serialization_lib__Update_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h686ee4a4a9e58709($1 | 0, $0 | 0);
  $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__h88c250e8947434a9($1 | 0);
  label$1 : {
   if (!(HEAP32[($1 + 16 | 0) >> 2] | 0)) {
    break label$1
   }
   hashbrown__raw__RawTable_T_2cA___free_buckets__ha5e2f3faac433f39($1 + 16 | 0 | 0);
  }
  global$0 = $1 + 48 | 0;
 }
 
 function hashbrown__raw__RawTable_T_2cA___free_buckets__hfa29170569415d6b($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $5 = 0;
  label$1 : {
   $1 = HEAP32[$0 >> 2] | 0;
   $5 = $1;
   $1 = ($1 << 3 | 0) + 8 | 0;
   $2 = ($5 + $1 | 0) + 5 | 0;
   if (!$2) {
    break label$1
   }
   __rust_dealloc((HEAP32[($0 + 4 | 0) >> 2] | 0) - $1 | 0 | 0, $2 | 0, 4 | 0);
  }
 }
 
 function hashbrown__raw__RawTable_T_2cA___free_buckets__h78477753a901af0e($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $5 = 0;
  label$1 : {
   $1 = HEAP32[$0 >> 2] | 0;
   $5 = $1;
   $1 = ($1 << 3 | 0) + 8 | 0;
   $2 = ($5 + $1 | 0) + 5 | 0;
   if (!$2) {
    break label$1
   }
   __rust_dealloc((HEAP32[($0 + 4 | 0) >> 2] | 0) - $1 | 0 | 0, $2 | 0, 4 | 0);
  }
 }
 
 function hashbrown__raw__RawTable_T_2cA___free_buckets__ha5e2f3faac433f39($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $5 = 0;
  label$1 : {
   $1 = HEAP32[$0 >> 2] | 0;
   $5 = $1;
   $1 = ($1 << 3 | 0) + 8 | 0;
   $2 = ($5 + $1 | 0) + 5 | 0;
   if (!$2) {
    break label$1
   }
   __rust_dealloc((HEAP32[($0 + 4 | 0) >> 2] | 0) - $1 | 0 | 0, $2 | 0, 4 | 0);
  }
 }
 
 function hashbrown__raw__RawTable_T_2cA___free_buckets__h03139504252f0030($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $5 = 0;
  label$1 : {
   $1 = HEAP32[$0 >> 2] | 0;
   $5 = $1;
   $1 = ($1 << 3 | 0) + 8 | 0;
   $2 = ($5 + $1 | 0) + 5 | 0;
   if (!$2) {
    break label$1
   }
   __rust_dealloc((HEAP32[($0 + 4 | 0) >> 2] | 0) - $1 | 0 | 0, $2 | 0, 4 | 0);
  }
 }
 
 function hashbrown__raw__RawTable_T_2cA___free_buckets__h34c0615f72d0114a($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $5 = 0;
  label$1 : {
   $1 = HEAP32[$0 >> 2] | 0;
   $5 = $1;
   $1 = ($1 << 3 | 0) + 8 | 0;
   $2 = ($5 + $1 | 0) + 5 | 0;
   if (!$2) {
    break label$1
   }
   __rust_dealloc((HEAP32[($0 + 4 | 0) >> 2] | 0) - $1 | 0 | 0, $2 | 0, 4 | 0);
  }
 }
 
 function hashbrown__raw__RawTable_T_2cA___free_buckets__hf5781ccef5282b02($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $5 = 0;
  label$1 : {
   $1 = HEAP32[$0 >> 2] | 0;
   $5 = $1;
   $1 = ($1 << 3 | 0) + 8 | 0;
   $2 = ($5 + $1 | 0) + 5 | 0;
   if (!$2) {
    break label$1
   }
   __rust_dealloc((HEAP32[($0 + 4 | 0) >> 2] | 0) - $1 | 0 | 0, $2 | 0, 4 | 0);
  }
 }
 
 function hashbrown__raw__RawTable_T_2cA___free_buckets__h04a09610ca2977a1($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0, $5 = 0;
  label$1 : {
   $1 = HEAP32[$0 >> 2] | 0;
   $5 = $1;
   $1 = ($1 << 3 | 0) + 8 | 0;
   $2 = ($5 + $1 | 0) + 5 | 0;
   if (!$2) {
    break label$1
   }
   __rust_dealloc((HEAP32[($0 + 4 | 0) >> 2] | 0) - $1 | 0 | 0, $2 | 0, 4 | 0);
  }
 }
 
 function __wbg_value_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 32 | 0;
  global$0 = $1;
  $cardano_serialization_lib__utils__Value_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h5b82be58e99ac2f6($1 + 8 | 0 | 0, $0 | 0);
  label$1 : {
   if (!(HEAP32[($1 + 16 | 0) >> 2] | 0)) {
    break label$1
   }
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($1 + 20 | 0 | 0);
  }
  global$0 = $1 + 32 | 0;
 }
 
 function $cardano_serialization_lib__utils__Int_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hac86427717971799($0, $0$hi, $1, $1$hi) {
  $0 = $0 | 0;
  $0$hi = $0$hi | 0;
  $1 = $1 | 0;
  $1$hi = $1$hi | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0;
  label$1 : {
   $2 = __rust_alloc(24 | 0, 8 | 0) | 0;
   if ($2) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(24 | 0, 8 | 0);
   abort();
  }
  i64toi32_i32$0 = $0$hi;
  i64toi32_i32$1 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[$2 >> 2] = 0;
  i64toi32_i32$0 = $1$hi;
  i64toi32_i32$1 = $2 + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $1;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  return $2 | 0;
 }
 
 function core__ptr__drop_in_place_serde_json__error__Error___h074362a9a9c9d71d($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     $1 = HEAP32[$0 >> 2] | 0;
     switch (HEAP32[$1 >> 2] | 0 | 0) {
     case 1:
      break label$2;
     case 0:
      break label$3;
     default:
      break label$1;
     };
    }
    core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_1($1 + 4 | 0 | 0);
    break label$1;
   }
   core__ptr__drop_in_place_std__io__error__Error___h33c863f956f9c357_2($1 + 4 | 0 | 0);
  }
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$0 >> 2] | 0 | 0) | 0 | 0, 20 | 0, 4 | 0);
 }
 
 function core__ptr__drop_in_place_cardano_serialization_lib__PoolParams___hacdf270b44917812($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h72de9eab2f0e4669($0 + 32 | 0 | 0);
  $1 = $0 + 44 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hb600accf9d1c2a17($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h96b3170d440e3692($1 | 0);
  label$1 : {
   if (!(HEAP32[($0 + 56 | 0) >> 2] | 0)) {
    break label$1
   }
   $0 = $0 + 56 | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
  }
 }
 
 function core__ptr__drop_in_place_cardano_serialization_lib__tx_builder__tx_inputs_builder__TxInputsBuilder___h60f2b953eb0eea7f($0) {
  $0 = $0 | 0;
  $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h7d849e3c4cfb66e1($0 + 64 | 0 | 0);
  $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h04a6b671c790649f($0 + 40 | 0 | 0);
  $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__h53e9081b9841de3b($0 | 0);
  label$1 : {
   if (!(HEAP32[($0 + 16 | 0) >> 2] | 0)) {
    break label$1
   }
   hashbrown__raw__RawTable_T_2cA___free_buckets__h34c0615f72d0114a($0 + 16 | 0 | 0);
  }
  $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__hb1ec706811634e79($0 + 52 | 0 | 0);
 }
 
 function plutuslist_new() {
  var $0 = 0, $1 = 0;
  $0 = global$0 - 16 | 0;
  global$0 = $0;
  HEAP8[($0 + 12 | 0) >> 0] = 2;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[$0 >> 2] = HEAP32[(0 + 1070736 | 0) >> 2] | 0;
  $1 = $cardano_serialization_lib__plutus__PlutusList_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h9a3fe5bcf5e2cc3a($0 | 0) | 0;
  global$0 = $0 + 16 | 0;
  return $1 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2calloc__collections__btree__node__marker__Leaf__2calloc__collections__btree__node__marker__KV___split__hc418ae44080ec59d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$1 = 0;
  $2 = alloc__boxed__Box_T_2cA___new_uninit_in__h8a2711313b9ea9b8() | 0;
  HEAP16[($2 + 402 | 0) >> 1] = 0;
  HEAP32[($2 + 264 | 0) >> 2] = 0;
  alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___split_leaf_data__h632fd5c0346b3032($0 | 0, $1 | 0, $2 | 0);
  HEAP32[($0 + 52 | 0) >> 2] = $2;
  HEAP32[($0 + 48 | 0) >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  HEAP32[($0 + 40 | 0) >> 2] = HEAP32[$1 >> 2] | 0;
  HEAP32[($0 + 44 | 0) >> 2] = i64toi32_i32$1;
 }
 
 function cryptoxide__sha2__Sha512__new__h57eb1a61fae5dfc3($0) {
  $0 = $0 | 0;
  var i64toi32_i32$0 = 0;
  memset($0 + 80 | 0 | 0, 0 | 0, 132 | 0) | 0;
  i64toi32_i32$0 = 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[($0 + 12 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  HEAP32[$0 >> 2] = 0;
  HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$0;
  memcpy($0 + 16 | 0 | 0, 1137368 | 0, 64 | 0) | 0;
  HEAP8[($0 + 216 | 0) >> 0] = 0;
 }
 
 function $bech32__Bech32Writer_20as_20core__ops__drop__Drop___drop__ha90a511234f1ea05($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  label$1 : {
   if (!(bech32__Bech32Writer__inner_finalize__h40926327c64dbb3a($0 | 0) | 0)) {
    break label$1
   }
   core__result__unwrap_failed__h27f43d993c3864a1(1138500 | 0, 45 | 0, $1 + 8 | 0 | 0, 1138224 | 0, 1138548 | 0);
   abort();
  }
  global$0 = $1 + 16 | 0;
 }
 
 function $hex__BytesToHexChars_20as_20core__iter__traits__iterator__Iterator___size_hint__h19408d5b08e7a45d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = 1;
  $1 = ((HEAP32[($1 + 4 | 0) >> 2] | 0) - (HEAP32[$1 >> 2] | 0) | 0) << 1 | 0 | (HEAP32[($1 + 12 | 0) >> 2] | 0 | 0) != (1114112 | 0) | 0;
  HEAP32[($0 + 8 | 0) >> 2] = $1;
  HEAP32[$0 >> 2] = $1;
 }
 
 function $alloc__string__String_20as_20core__fmt__Display___fmt__hc15dcc93124260dc($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $0 | 0);
  $1 = $str_20as_20core__fmt__Display___fmt__hdd03b40cdcec1d4f(HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, $1 | 0) | 0;
  global$0 = $2 + 16 | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__TransactionWitnessSet_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h15af3a22f8db3dff($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = __rust_alloc(80 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(80 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  memcpy($1 + 4 | 0 | 0, $0 | 0, 76 | 0) | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__TransactionInput_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hf06f9abbcbb78385($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = __rust_alloc(40 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(40 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  memcpy($1 + 4 | 0 | 0, $0 | 0, 36 | 0) | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__StakeDelegation_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hfbbb778a4aa15e31($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = __rust_alloc(64 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(64 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  memcpy($1 + 4 | 0 | 0, $0 | 0, 57 | 0) | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__PoolMetadata_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h92fec53606437ead($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = __rust_alloc(48 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(48 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  memcpy($1 + 4 | 0 | 0, $0 | 0, 44 | 0) | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__GenesisKeyDelegation_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h6614a0688d3f0486($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = __rust_alloc(92 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(92 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  memcpy($1 + 4 | 0 | 0, $0 | 0, 88 | 0) | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__OperationalCert_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h6c0829dce15a5d37($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = __rust_alloc(108 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(108 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  memcpy($1 + 4 | 0 | 0, $0 | 0, 104 | 0) | 0;
  return $1 | 0;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__h0a4730d8f7e64934($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $0 = HEAP32[$0 >> 2] | 0;
  label$1 : {
   if (core__fmt__Formatter__debug_lower_hex__h8226cdf2ca894293($1 | 0) | 0) {
    break label$1
   }
   label$2 : {
    if (core__fmt__Formatter__debug_upper_hex__h837fa1522c833b74($1 | 0) | 0) {
     break label$2
    }
    return core__fmt__num___impl_20core__fmt__Display_20for_20i128___fmt__h32e59444f56cefa7($0 | 0, $1 | 0) | 0 | 0;
   }
   return core__fmt__num___impl_20core__fmt__UpperHex_20for_20i128___fmt__hdc303003e4e4722e($0 | 0, $1 | 0) | 0 | 0;
  }
  return core__fmt__num___impl_20core__fmt__LowerHex_20for_20i128___fmt__h7d7478473e163f7b($0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $alloc__string__String_20as_20core__fmt__Display___fmt__hc15dcc93124260dc_1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $0 | 0);
  $1 = $str_20as_20core__fmt__Display___fmt__hdd03b40cdcec1d4f(HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, $1 | 0) | 0;
  global$0 = $2 + 16 | 0;
  return $1 | 0;
 }
 
 function __wbg_auxiliarydata_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 64 | 0;
  global$0 = $1;
  $cardano_serialization_lib__metadata__AuxiliaryData_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h85bc793a96c7fd5d($1 | 0, $0 | 0);
  core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__metadata__GeneralTransactionMetadata____h37a091753d7f028f($1 | 0);
  core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__NativeScripts____hdd7d461255ec800a_1($1 + 40 | 0 | 0);
  core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__plutus__PlutusScripts____h6be1d55eac328b7f_1($1 + 52 | 0 | 0);
  global$0 = $1 + 64 | 0;
 }
 
 function auxiliarydata_new() {
  var $0 = 0, $1 = 0;
  $0 = global$0 - 64 | 0;
  global$0 = $0;
  HEAP32[($0 + 52 | 0) >> 2] = 0;
  HEAP32[($0 + 40 | 0) >> 2] = 0;
  HEAP32[($0 + 20 | 0) >> 2] = 0;
  $1 = $cardano_serialization_lib__metadata__AuxiliaryData_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h48191cd5277961b5($0 | 0) | 0;
  global$0 = $0 + 64 | 0;
  return $1 | 0;
 }
 
 function linked_hash_map__LinkedHashMap_K_2cV_2cS___clear_free_list__h20fcb5b84a9220ce($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 36 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   label$2 : while (1) {
    $2 = HEAP32[($1 + 56 | 0) >> 2] | 0;
    __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 64 | 0, 8 | 0);
    $1 = $2;
    if ($1) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 36 | 0) >> 2] = 0;
 }
 
 function linked_hash_map__LinkedHashMap_K_2cV_2cS___clear_free_list__h4fa6a5e39af959e5($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 36 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   label$2 : while (1) {
    $2 = HEAP32[($1 + 408 | 0) >> 2] | 0;
    __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 448 | 0, 8 | 0);
    $1 = $2;
    if ($1) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 36 | 0) >> 2] = 0;
 }
 
 function linked_hash_map__LinkedHashMap_K_2cV_2cS___clear_free_list__h8c886adc889b8efe($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 36 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   label$2 : while (1) {
    $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
    __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 48 | 0, 8 | 0);
    $1 = $2;
    if ($1) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 36 | 0) >> 2] = 0;
 }
 
 function linked_hash_map__LinkedHashMap_K_2cV_2cS___clear_free_list__h8d5b3e27f5251a17($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 36 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   label$2 : while (1) {
    $2 = HEAP32[($1 + 64 | 0) >> 2] | 0;
    __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 80 | 0, 8 | 0);
    $1 = $2;
    if ($1) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 36 | 0) >> 2] = 0;
 }
 
 function linked_hash_map__LinkedHashMap_K_2cV_2cS___clear_free_list__ha63e4fc7bda9e0cd($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 36 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   label$2 : while (1) {
    $2 = HEAP32[($1 + 16 | 0) >> 2] | 0;
    __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 56 | 0, 8 | 0);
    $1 = $2;
    if ($1) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 36 | 0) >> 2] = 0;
 }
 
 function linked_hash_map__LinkedHashMap_K_2cV_2cS___clear_free_list__hb918ae2ca861e503($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 36 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   label$2 : while (1) {
    $2 = HEAP32[($1 + 152 | 0) >> 2] | 0;
    __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 192 | 0, 8 | 0);
    $1 = $2;
    if ($1) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 36 | 0) >> 2] = 0;
 }
 
 function linked_hash_map__LinkedHashMap_K_2cV_2cS___clear_free_list__hc9584b5de481db28($0) {
  $0 = $0 | 0;
  var $1 = 0, $2 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 36 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   label$2 : while (1) {
    $2 = HEAP32[($1 + 96 | 0) >> 2] | 0;
    __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 104 | 0, 8 | 0);
    $1 = $2;
    if ($1) {
     continue label$2
    }
    break label$2;
   };
  }
  HEAP32[($0 + 36 | 0) >> 2] = 0;
 }
 
 function core__ptr__drop_in_place_rand_os__OsRng___hfc4c0aad05eeb2e1($0) {
  $0 = $0 | 0;
  label$1 : {
   label$2 : {
    if (HEAP32[$0 >> 2] | 0) {
     break label$2
    }
    $0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
    if ($0 >>> 0 < 36 >>> 0) {
     break label$1
    }
    wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($0 | 0);
    return;
   }
   $0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if ($0 >>> 0 < 36 >>> 0) {
    break label$1
   }
   wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($0 | 0);
  }
 }
 
 function $alloc__string__String_20as_20core__fmt__Display___fmt__hc15dcc93124260dc_2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $0 | 0);
  $1 = $str_20as_20core__fmt__Display___fmt__hdd03b40cdcec1d4f(HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, $1 | 0) | 0;
  global$0 = $2 + 16 | 0;
  return $1 | 0;
 }
 
 function $alloc__string__String_20as_20core__fmt__Debug___fmt__h761c2dbab983b314($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $0 | 0);
  $1 = $str_20as_20core__fmt__Debug___fmt__hc85548718db4c6c4(HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, $1 | 0) | 0;
  global$0 = $2 + 16 | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__crypto__Bip32PrivateKey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h3aa14ad8597a0206($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = __rust_alloc(100 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(100 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  memcpy($1 + 4 | 0 | 0, $0 | 0, 96 | 0) | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__crypto__PrivateKey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h7ffc55fb5b040fec($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = __rust_alloc(72 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(72 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  memcpy($1 + 4 | 0 | 0, $0 | 0, 65 | 0) | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__crypto__Bip32PublicKey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h56f6677bb959345b($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = __rust_alloc(68 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(68 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  memcpy($1 + 4 | 0 | 0, $0 | 0, 64 | 0) | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__crypto__Ed25519Signature_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h20d7210aa6eb2b19($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = __rust_alloc(68 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(68 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  memcpy($1 + 4 | 0 | 0, $0 | 0, 64 | 0) | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__crypto__Vkeywitness_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hffa43ed1c5f00e23($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = __rust_alloc(100 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(100 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  memcpy($1 + 4 | 0 | 0, $0 | 0, 96 | 0) | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__crypto__BootstrapWitness_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hcc8c8e7beca3e936($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = __rust_alloc(124 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(124 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  memcpy($1 + 4 | 0 | 0, $0 | 0, 120 | 0) | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__crypto__LegacyDaedalusPrivateKey_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hb45e7bb29384ab7c($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = __rust_alloc(100 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(100 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  memcpy($1 + 4 | 0 | 0, $0 | 0, 96 | 0) | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__crypto__Nonce_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h3e2dae3d5c688227($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = __rust_alloc(40 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(40 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  memcpy($1 + 4 | 0 | 0, $0 | 0, 33 | 0) | 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__address__ByronAddress_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbc0eb32d6a95f2a3($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = __rust_alloc(56 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(56 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  memcpy($1 + 4 | 0 | 0, $0 | 0, 52 | 0) | 0;
  return $1 | 0;
 }
 
 function __wbg_address_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 64 | 0;
  global$0 = $1;
  $cardano_serialization_lib__address__Address_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h47880851d7dc8f1b($1 | 0, $0 | 0);
  label$1 : {
   if ((HEAPU8[$1 >> 0] | 0) >>> 0 < 4 >>> 0) {
    break label$1
   }
   core__ptr__drop_in_place_cardano_serialization_lib__legacy_address__address__ExtendedAddr___h2c1a18aefeee766f($1 | 4 | 0 | 0);
  }
  global$0 = $1 + 64 | 0;
 }
 
 function $cardano_serialization_lib__address__BaseAddress_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h9cfaf9e675023555($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = __rust_alloc(64 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(64 | 0, 4 | 0);
   abort();
  }
  HEAP32[$1 >> 2] = 0;
  memcpy($1 + 4 | 0 | 0, $0 | 0, 59 | 0) | 0;
  return $1 | 0;
 }
 
 function $alloc__string__String_20as_20core__fmt__Display___fmt__hc15dcc93124260dc_3($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $0 | 0);
  $1 = $str_20as_20core__fmt__Display___fmt__hdd03b40cdcec1d4f(HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, $1 | 0) | 0;
  global$0 = $2 + 16 | 0;
  return $1 | 0;
 }
 
 function $alloc__string__String_20as_20core__fmt__Display___fmt__hc15dcc93124260dc_4($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($2 + 8 | 0 | 0, $0 | 0);
  $1 = $str_20as_20core__fmt__Display___fmt__hdd03b40cdcec1d4f(HEAP32[($2 + 8 | 0) >> 2] | 0 | 0, HEAP32[($2 + 12 | 0) >> 2] | 0 | 0, $1 | 0) | 0;
  global$0 = $2 + 16 | 0;
  return $1 | 0;
 }
 
 function alloc__rc__Rc_T___new__h253fb66de434ba19($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = __rust_alloc(344 | 0, 8 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__h649eab7147d45d59();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(344 | 0, 8 | 0);
   abort();
  }
  memcpy($1 + 8 | 0 | 0, $0 | 0, 336 | 0) | 0;
  HEAP32[$1 >> 2] = 1;
  HEAP32[($1 + 4 | 0) >> 2] = 1;
  return $1 | 0;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__h5aab1cd297f9d759($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $0 = HEAP32[$0 >> 2] | 0;
  label$1 : {
   if (core__fmt__Formatter__debug_lower_hex__h8226cdf2ca894293($1 | 0) | 0) {
    break label$1
   }
   label$2 : {
    if (core__fmt__Formatter__debug_upper_hex__h837fa1522c833b74($1 | 0) | 0) {
     break label$2
    }
    return core__fmt__num__imp___impl_20core__fmt__Display_20for_20u32___fmt__h84f076c5e5d839ee($0 | 0, $1 | 0) | 0 | 0;
   }
   return core__fmt__num___impl_20core__fmt__UpperHex_20for_20i32___fmt__h135eeaf75c8aff9c($0 | 0, $1 | 0) | 0 | 0;
  }
  return core__fmt__num___impl_20core__fmt__LowerHex_20for_20i32___fmt__h9723d6e56c381fda($0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__h9a9275a0bae9e1ce($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $0 = HEAP32[$0 >> 2] | 0;
  label$1 : {
   if (core__fmt__Formatter__debug_lower_hex__h8226cdf2ca894293($1 | 0) | 0) {
    break label$1
   }
   label$2 : {
    if (core__fmt__Formatter__debug_upper_hex__h837fa1522c833b74($1 | 0) | 0) {
     break label$2
    }
    return core__fmt__num__imp___impl_20core__fmt__Display_20for_20u32___fmt__h84f076c5e5d839ee($0 | 0, $1 | 0) | 0 | 0;
   }
   return core__fmt__num___impl_20core__fmt__UpperHex_20for_20i32___fmt__h135eeaf75c8aff9c($0 | 0, $1 | 0) | 0 | 0;
  }
  return core__fmt__num___impl_20core__fmt__LowerHex_20for_20i32___fmt__h9723d6e56c381fda($0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__ha9b9c48de0cd5783($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $0 = HEAP32[$0 >> 2] | 0;
  label$1 : {
   if (core__fmt__Formatter__debug_lower_hex__h8226cdf2ca894293($1 | 0) | 0) {
    break label$1
   }
   label$2 : {
    if (core__fmt__Formatter__debug_upper_hex__h837fa1522c833b74($1 | 0) | 0) {
     break label$2
    }
    return core__fmt__num__imp___impl_20core__fmt__Display_20for_20u32___fmt__h84f076c5e5d839ee($0 | 0, $1 | 0) | 0 | 0;
   }
   return core__fmt__num___impl_20core__fmt__UpperHex_20for_20i32___fmt__h135eeaf75c8aff9c($0 | 0, $1 | 0) | 0 | 0;
  }
  return core__fmt__num___impl_20core__fmt__LowerHex_20for_20i32___fmt__h9723d6e56c381fda($0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__hbc55ae6123845c9d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $0 = HEAP32[$0 >> 2] | 0;
  label$1 : {
   if (core__fmt__Formatter__debug_lower_hex__h8226cdf2ca894293($1 | 0) | 0) {
    break label$1
   }
   label$2 : {
    if (core__fmt__Formatter__debug_upper_hex__h837fa1522c833b74($1 | 0) | 0) {
     break label$2
    }
    return core__fmt__num__imp___impl_20core__fmt__Display_20for_20u32___fmt__h84f076c5e5d839ee($0 | 0, $1 | 0) | 0 | 0;
   }
   return core__fmt__num___impl_20core__fmt__UpperHex_20for_20i32___fmt__h135eeaf75c8aff9c($0 | 0, $1 | 0) | 0 | 0;
  }
  return core__fmt__num___impl_20core__fmt__LowerHex_20for_20i32___fmt__h9723d6e56c381fda($0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__hcb80eba91dbd37c2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $0 = HEAP32[$0 >> 2] | 0;
  label$1 : {
   if (core__fmt__Formatter__debug_lower_hex__h8226cdf2ca894293($1 | 0) | 0) {
    break label$1
   }
   label$2 : {
    if (core__fmt__Formatter__debug_upper_hex__h837fa1522c833b74($1 | 0) | 0) {
     break label$2
    }
    return core__fmt__num__imp___impl_20core__fmt__Display_20for_20u8___fmt__hca5329c05d9840ca($0 | 0, $1 | 0) | 0 | 0;
   }
   return core__fmt__num___impl_20core__fmt__UpperHex_20for_20i8___fmt__h1e32f8c7db908eda($0 | 0, $1 | 0) | 0 | 0;
  }
  return core__fmt__num___impl_20core__fmt__LowerHex_20for_20i8___fmt__ha166b2b4b979058e($0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__h2dfc0297287b8632($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $0 = HEAP32[$0 >> 2] | 0;
  label$1 : {
   if (core__fmt__Formatter__debug_lower_hex__h8226cdf2ca894293($1 | 0) | 0) {
    break label$1
   }
   label$2 : {
    if (core__fmt__Formatter__debug_upper_hex__h837fa1522c833b74($1 | 0) | 0) {
     break label$2
    }
    return core__fmt__num__imp___impl_20core__fmt__Display_20for_20u32___fmt__h84f076c5e5d839ee($0 | 0, $1 | 0) | 0 | 0;
   }
   return core__fmt__num___impl_20core__fmt__UpperHex_20for_20i32___fmt__h135eeaf75c8aff9c($0 | 0, $1 | 0) | 0 | 0;
  }
  return core__fmt__num___impl_20core__fmt__LowerHex_20for_20i32___fmt__h9723d6e56c381fda($0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__h0f98a2adf9499463($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $0 = HEAP32[$0 >> 2] | 0;
  label$1 : {
   if (core__fmt__Formatter__debug_lower_hex__h8226cdf2ca894293($1 | 0) | 0) {
    break label$1
   }
   label$2 : {
    if (core__fmt__Formatter__debug_upper_hex__h837fa1522c833b74($1 | 0) | 0) {
     break label$2
    }
    return core__fmt__num__imp___impl_20core__fmt__Display_20for_20u8___fmt__hca5329c05d9840ca($0 | 0, $1 | 0) | 0 | 0;
   }
   return core__fmt__num___impl_20core__fmt__UpperHex_20for_20i8___fmt__h1e32f8c7db908eda($0 | 0, $1 | 0) | 0 | 0;
  }
  return core__fmt__num___impl_20core__fmt__LowerHex_20for_20i8___fmt__ha166b2b4b979058e($0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__h14ee2e0b3bc47c51($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $0 = HEAP32[$0 >> 2] | 0;
  label$1 : {
   if (core__fmt__Formatter__debug_lower_hex__h8226cdf2ca894293($1 | 0) | 0) {
    break label$1
   }
   label$2 : {
    if (core__fmt__Formatter__debug_upper_hex__h837fa1522c833b74($1 | 0) | 0) {
     break label$2
    }
    return core__fmt__num__imp___impl_20core__fmt__Display_20for_20u8___fmt__hca5329c05d9840ca($0 | 0, $1 | 0) | 0 | 0;
   }
   return core__fmt__num___impl_20core__fmt__UpperHex_20for_20i8___fmt__h1e32f8c7db908eda($0 | 0, $1 | 0) | 0 | 0;
  }
  return core__fmt__num___impl_20core__fmt__LowerHex_20for_20i8___fmt__ha166b2b4b979058e($0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__h86113fee927a2cf9($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $0 = HEAP32[$0 >> 2] | 0;
  label$1 : {
   if (core__fmt__Formatter__debug_lower_hex__h8226cdf2ca894293($1 | 0) | 0) {
    break label$1
   }
   label$2 : {
    if (core__fmt__Formatter__debug_upper_hex__h837fa1522c833b74($1 | 0) | 0) {
     break label$2
    }
    return core__fmt__num__imp___impl_20core__fmt__Display_20for_20u64___fmt__h6488d819d41312fb($0 | 0, $1 | 0) | 0 | 0;
   }
   return core__fmt__num___impl_20core__fmt__UpperHex_20for_20i64___fmt__h5a4e72e53e968338($0 | 0, $1 | 0) | 0 | 0;
  }
  return core__fmt__num___impl_20core__fmt__LowerHex_20for_20i64___fmt__h68614c2d2fa4b444($0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__h9e73891cae9c3301($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $0 = HEAP32[$0 >> 2] | 0;
  label$1 : {
   if (core__fmt__Formatter__debug_lower_hex__h8226cdf2ca894293($1 | 0) | 0) {
    break label$1
   }
   label$2 : {
    if (core__fmt__Formatter__debug_upper_hex__h837fa1522c833b74($1 | 0) | 0) {
     break label$2
    }
    return core__fmt__num__imp___impl_20core__fmt__Display_20for_20u32___fmt__h84f076c5e5d839ee($0 | 0, $1 | 0) | 0 | 0;
   }
   return core__fmt__num___impl_20core__fmt__UpperHex_20for_20i32___fmt__h135eeaf75c8aff9c($0 | 0, $1 | 0) | 0 | 0;
  }
  return core__fmt__num___impl_20core__fmt__LowerHex_20for_20i32___fmt__h9723d6e56c381fda($0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__ha0e987d2dd72fb1f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $0 = HEAP32[$0 >> 2] | 0;
  label$1 : {
   if (core__fmt__Formatter__debug_lower_hex__h8226cdf2ca894293($1 | 0) | 0) {
    break label$1
   }
   label$2 : {
    if (core__fmt__Formatter__debug_upper_hex__h837fa1522c833b74($1 | 0) | 0) {
     break label$2
    }
    return core__fmt__num__imp___impl_20core__fmt__Display_20for_20u32___fmt__h84f076c5e5d839ee($0 | 0, $1 | 0) | 0 | 0;
   }
   return core__fmt__num___impl_20core__fmt__UpperHex_20for_20i32___fmt__h135eeaf75c8aff9c($0 | 0, $1 | 0) | 0 | 0;
  }
  return core__fmt__num___impl_20core__fmt__LowerHex_20for_20i32___fmt__h9723d6e56c381fda($0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__h352d529ddfe8d4e2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $0 = HEAP32[$0 >> 2] | 0;
  label$1 : {
   if (core__fmt__Formatter__debug_lower_hex__h8226cdf2ca894293($1 | 0) | 0) {
    break label$1
   }
   label$2 : {
    if (core__fmt__Formatter__debug_upper_hex__h837fa1522c833b74($1 | 0) | 0) {
     break label$2
    }
    return core__fmt__num__imp___impl_20core__fmt__Display_20for_20u8___fmt__hca5329c05d9840ca($0 | 0, $1 | 0) | 0 | 0;
   }
   return core__fmt__num___impl_20core__fmt__UpperHex_20for_20i8___fmt__h1e32f8c7db908eda($0 | 0, $1 | 0) | 0 | 0;
  }
  return core__fmt__num___impl_20core__fmt__LowerHex_20for_20i8___fmt__ha166b2b4b979058e($0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__hf175ff9540f9b84c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $0 = HEAP32[$0 >> 2] | 0;
  label$1 : {
   if (core__fmt__Formatter__debug_lower_hex__h8226cdf2ca894293($1 | 0) | 0) {
    break label$1
   }
   label$2 : {
    if (core__fmt__Formatter__debug_upper_hex__h837fa1522c833b74($1 | 0) | 0) {
     break label$2
    }
    return core__fmt__num__imp___impl_20core__fmt__Display_20for_20u32___fmt__h84f076c5e5d839ee($0 | 0, $1 | 0) | 0 | 0;
   }
   return core__fmt__num___impl_20core__fmt__UpperHex_20for_20i32___fmt__h135eeaf75c8aff9c($0 | 0, $1 | 0) | 0 | 0;
  }
  return core__fmt__num___impl_20core__fmt__LowerHex_20for_20i32___fmt__h9723d6e56c381fda($0 | 0, $1 | 0) | 0 | 0;
 }
 
 function __rdl_alloc_zeroed($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   $1 = dlmalloc__Dlmalloc_A___malloc__h25d3e8a45fd7c029($0 | 0, $1 | 0) | 0;
   if (!$1) {
    break label$1
   }
   label$2 : {
    if (!($dlmalloc__sys__System_20as_20dlmalloc__Allocator___allocates_zeros__h4aa85cb289c3ef04(1177884 | 0) | 0)) {
     break label$2
    }
    if (dlmalloc__dlmalloc__Chunk__mmapped__h896a47bc7b87f942(dlmalloc__dlmalloc__Chunk__from_mem__h955f68080880f343($1 | 0) | 0 | 0) | 0) {
     break label$1
    }
   }
   memset($1 | 0, 0 | 0, $0 | 0) | 0;
  }
  return $1 | 0;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__h202c5e6de5e72ca0($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $0 = HEAP32[$0 >> 2] | 0;
  label$1 : {
   if (core__fmt__Formatter__debug_lower_hex__h8226cdf2ca894293($1 | 0) | 0) {
    break label$1
   }
   label$2 : {
    if (core__fmt__Formatter__debug_upper_hex__h837fa1522c833b74($1 | 0) | 0) {
     break label$2
    }
    return core__fmt__num__imp___impl_20core__fmt__Display_20for_20u8___fmt__hca5329c05d9840ca($0 | 0, $1 | 0) | 0 | 0;
   }
   return core__fmt__num___impl_20core__fmt__UpperHex_20for_20i8___fmt__h1e32f8c7db908eda($0 | 0, $1 | 0) | 0 | 0;
  }
  return core__fmt__num___impl_20core__fmt__LowerHex_20for_20i8___fmt__ha166b2b4b979058e($0 | 0, $1 | 0) | 0 | 0;
 }
 
 function core__fmt__Formatter__debug_tuple__hc6a56ab3631575b8($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  (wasm2js_i32$0 = $0, wasm2js_i32$1 = FUNCTION_TABLE[HEAP32[((HEAP32[($1 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($1 + 24 | 0) >> 2] | 0, $2, $3) | 0), HEAP8[(wasm2js_i32$0 + 8 | 0) >> 0] = wasm2js_i32$1;
  HEAP32[$0 >> 2] = $1;
  HEAP8[($0 + 9 | 0) >> 0] = !$3;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
 }
 
 function $cardano_serialization_lib__UnitInterval_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he6b97f3f09608ed8($0, $0$hi, $1, $1$hi) {
  $0 = $0 | 0;
  $0$hi = $0$hi | 0;
  $1 = $1 | 0;
  $1$hi = $1$hi | 0;
  var $2 = 0, i64toi32_i32$0 = 0;
  label$1 : {
   $2 = __rust_alloc(24 | 0, 8 | 0) | 0;
   if ($2) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(24 | 0, 8 | 0);
   abort();
  }
  i64toi32_i32$0 = $1$hi;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $0$hi;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[$2 >> 2] = 0;
  return $2 | 0;
 }
 
 function $cardano_serialization_lib__ProtocolVersion_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h721fdbbf560ad7f4($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = __rust_alloc(12 | 0, 4 | 0) | 0;
   if ($2) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(12 | 0, 4 | 0);
   abort();
  }
  HEAP32[($2 + 8 | 0) >> 2] = $1;
  HEAP32[($2 + 4 | 0) >> 2] = $0;
  HEAP32[$2 >> 2] = 0;
  return $2 | 0;
 }
 
 function cardano_serialization_lib__ProtocolVersions__get__hbee1839bc5ff0591($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, $3 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $17 = 0;
  label$1 : {
   $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   if ($3 >>> 0 > $2 >>> 0) {
    break label$1
   }
   core__panicking__panic_bounds_check__h808b524af17640b1($2 | 0, $3 | 0, 1054164 | 0);
   abort();
  }
  i64toi32_i32$2 = (HEAP32[$1 >> 2] | 0) + ($2 << 3 | 0) | 0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $17 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $17;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
 }
 
 function transactionoutputbuilder_new() {
  var $0 = 0, $1 = 0;
  $0 = global$0 - 112 | 0;
  global$0 = $0;
  HEAP8[($0 + 72 | 0) >> 0] = 0;
  HEAP8[($0 + 8 | 0) >> 0] = 5;
  $1 = $cardano_serialization_lib__output_builder__TransactionOutputBuilder_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h6f606fcbcfa27636($0 + 8 | 0 | 0) | 0;
  global$0 = $0 + 112 | 0;
  return $1 | 0;
 }
 
 function value_zero() {
  var $0 = 0, $1 = 0;
  $0 = global$0 - 32 | 0;
  global$0 = $0;
  HEAP32[($0 + 16 | 0) >> 2] = 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[($0 + 12 | 0) >> 2] = 0;
  $1 = $cardano_serialization_lib__utils__Value_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h50a1108e1e08f966($0 + 8 | 0 | 0) | 0;
  global$0 = $0 + 32 | 0;
  return $1 | 0;
 }
 
 function $linked_hash_map__LinkedHashMap_A_2cB_2cS__20as_20core__fmt__Debug___fmt__h35f30f182166235c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $8 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  i64toi32_i32$0 = core__fmt__Formatter__debug_map__hf479166f65445ffd($1 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $8 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $8;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  $0 = core__fmt__builders__DebugMap__finish__hdeb040f139645c75(core__fmt__builders__DebugMap__entries__hc6ee37e6fbcec1a8($2 + 8 | 0 | 0, $0 | 0) | 0 | 0) | 0;
  global$0 = $2 + 16 | 0;
  return $0 | 0;
 }
 
 function $cardano_serialization_lib__fees__LinearFee_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h715b61d52c5c7394($0, $0$hi, $1, $1$hi) {
  $0 = $0 | 0;
  $0$hi = $0$hi | 0;
  $1 = $1 | 0;
  $1$hi = $1$hi | 0;
  var $2 = 0, i64toi32_i32$0 = 0;
  label$1 : {
   $2 = __rust_alloc(24 | 0, 8 | 0) | 0;
   if ($2) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(24 | 0, 8 | 0);
   abort();
  }
  i64toi32_i32$0 = $1$hi;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $0$hi;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[$2 >> 2] = 0;
  return $2 | 0;
 }
 
 function core__ptr__drop_in_place_cardano_serialization_lib__TransactionOutput___h632b3a99817e6ac5($0) {
  $0 = $0 | 0;
  label$1 : {
   if ((HEAPU8[$0 >> 0] | 0) >>> 0 < 4 >>> 0) {
    break label$1
   }
   core__ptr__drop_in_place_cardano_serialization_lib__address__ByronAddress___he7d0684706668546($0 + 4 | 0 | 0);
  }
  label$2 : {
   if (!(HEAP32[($0 + 72 | 0) >> 2] | 0)) {
    break label$2
   }
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($0 + 76 | 0 | 0);
  }
 }
 
 function core__ptr__drop_in_place_cardano_serialization_lib__output_builder__TransactionOutputAmountBuilder___h4d21635c56401178($0) {
  $0 = $0 | 0;
  label$1 : {
   if ((HEAPU8[$0 >> 0] | 0) >>> 0 < 4 >>> 0) {
    break label$1
   }
   core__ptr__drop_in_place_cardano_serialization_lib__address__ByronAddress___he7d0684706668546($0 + 4 | 0 | 0);
  }
  label$2 : {
   switch (HEAP32[($0 + 72 | 0) >> 2] | 0 | 0) {
   default:
    $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($0 + 76 | 0 | 0);
    break;
   case 0:
   case 2:
    break label$2;
   };
  }
 }
 
 function core__ptr__drop_in_place_cardano_serialization_lib__TransactionOutput___h632b3a99817e6ac5_1($0) {
  $0 = $0 | 0;
  label$1 : {
   if ((HEAPU8[$0 >> 0] | 0) >>> 0 < 4 >>> 0) {
    break label$1
   }
   core__ptr__drop_in_place_core__option__Option_alloc__vec__Vec_u8_____ha5300c747747c3c8_1($0 + 4 | 0 | 0);
  }
  label$2 : {
   if (!(HEAP32[($0 + 72 | 0) >> 2] | 0)) {
    break label$2
   }
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($0 + 76 | 0 | 0);
  }
 }
 
 function $cardano_serialization_lib__address__NetworkInfo_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hb3f19bc65802218a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = __rust_alloc(12 | 0, 4 | 0) | 0;
   if ($2) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(12 | 0, 4 | 0);
   abort();
  }
  HEAP8[($2 + 8 | 0) >> 0] = $1;
  HEAP32[($2 + 4 | 0) >> 2] = $0;
  HEAP32[$2 >> 2] = 0;
  return $2 | 0;
 }
 
 function $cardano_serialization_lib__plutus__ExUnits_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h4867c49ddc624134($0, $0$hi, $1, $1$hi) {
  $0 = $0 | 0;
  $0$hi = $0$hi | 0;
  $1 = $1 | 0;
  $1$hi = $1$hi | 0;
  var $2 = 0, i64toi32_i32$0 = 0;
  label$1 : {
   $2 = __rust_alloc(24 | 0, 8 | 0) | 0;
   if ($2) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(24 | 0, 8 | 0);
   abort();
  }
  i64toi32_i32$0 = $1$hi;
  HEAP32[($2 + 16 | 0) >> 2] = $1;
  HEAP32[($2 + 20 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $0$hi;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[$2 >> 2] = 0;
  return $2 | 0;
 }
 
 function serde_json__de__from_str__h84312e5dc76b40c6($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  HEAP32[($3 + 8 | 0) >> 2] = 0;
  HEAP32[($3 + 4 | 0) >> 2] = $2;
  HEAP32[$3 >> 2] = $1;
  serde_json__de__from_trait__h0ba18435786ef501($0 | 0, $3 | 0);
  global$0 = $3 + 16 | 0;
 }
 
 function alloc__vec__Vec_T_2cA___into_boxed_slice__h6d3b430370c4c5ad($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   if ((HEAP32[($1 + 4 | 0) >> 2] | 0) >>> 0 <= $2 >>> 0) {
    break label$1
   }
   alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h3c2ae8f02af6ab27($1 | 0, $2 | 0);
   $2 = HEAP32[($1 + 8 | 0) >> 2] | 0;
  }
  HEAP32[($0 + 4 | 0) >> 2] = $2;
  HEAP32[$0 >> 2] = HEAP32[$1 >> 2] | 0;
 }
 
 function serde_json__error__Error__io__hab4c507df1786c7e($0, $0$hi) {
  $0 = $0 | 0;
  $0$hi = $0$hi | 0;
  var $1 = 0, i64toi32_i32$0 = 0;
  label$1 : {
   $1 = __rust_alloc(20 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(20 | 0, 4 | 0);
   abort();
  }
  i64toi32_i32$0 = 0;
  HEAP32[($1 + 12 | 0) >> 2] = 0;
  HEAP32[($1 + 16 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $0$hi;
  HEAP32[($1 + 4 | 0) >> 2] = $0;
  HEAP32[($1 + 8 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[$1 >> 2] = 1;
  return $1 | 0;
 }
 
 function $rand_os__wasm32_bindgen__OsRng_20as_20rand_os__OsRngImpl___fill_chunk__h6e9ee6e95d64d1a6($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  label$1 : {
   label$2 : {
    if ((HEAP32[$1 >> 2] | 0 | 0) == (1 | 0)) {
     break label$2
    }
    rand_os____wbg_shims__NodeCrypto__random_fill_sync____wbg_randomFillSync_1b52c8482374c55b__h054169d5fc75e020(HEAP32[($1 + 4 | 0) >> 2] | 0 | 0, $2 | 0, $3 | 0);
    break label$1;
   }
   rand_os____wbg_shims__BrowserCrypto__get_random_values____wbg_getRandomValues_1ef11e888e5228e9__ha019132b81f6681b(HEAP32[($1 + 4 | 0) >> 2] | 0 | 0, $2 | 0, $3 | 0);
  }
  HEAP8[($0 + 16 | 0) >> 0] = 5;
 }
 
 function core__ptr__drop_in_place_std__sync__poison__PoisonError_std__sync__mutex__MutexGuard__28_29_____h0f96ea93a2a17d67($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = HEAP32[$0 >> 2] | 0;
  label$1 : {
   if (HEAPU8[($0 + 4 | 0) >> 0] | 0) {
    break label$1
   }
   if (!((HEAP32[(0 + 1177836 | 0) >> 2] | 0) & 2147483647 | 0)) {
    break label$1
   }
   if (std__panicking__panic_count__is_zero_slow_path__h1d20871758c70487() | 0) {
    break label$1
   }
   HEAP8[($1 + 1 | 0) >> 0] = 1;
  }
  HEAP8[$1 >> 0] = 0;
 }
 
 function $std__thread__local__AccessError_20as_20core__fmt__Debug___fmt__h45e3defe85febb31($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $8 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  i64toi32_i32$0 = core__fmt__Formatter__debug_struct__h873400a11fe69724($1 | 0, 1142636 | 0, 11 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $8 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $8;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  $1 = core__fmt__builders__DebugStruct__finish__hb1eae1aa0e288840($2 + 8 | 0 | 0) | 0;
  global$0 = $2 + 16 | 0;
  return $1 | 0;
 }
 
 function std__panicking__begin_panic_fmt__h3dc1b0b65bbd6c17($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  (wasm2js_i32$0 = $2, wasm2js_i32$1 = core__panic__Location__caller__h274818dd12799e10($1 | 0) | 0), HEAP32[(wasm2js_i32$0 + 12 | 0) >> 2] = wasm2js_i32$1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  HEAP32[($2 + 4 | 0) >> 2] = 1142300;
  HEAP32[$2 >> 2] = 1142260;
  rust_begin_unwind($2 | 0);
  abort();
 }
 
 function $std__sync__poison__PoisonError_T__20as_20core__fmt__Debug___fmt__h1ed10cc42b8737e7($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $8 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  i64toi32_i32$0 = core__fmt__Formatter__debug_struct__h873400a11fe69724($1 | 0, 1144136 | 0, 11 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  $8 = i64toi32_i32$0;
  i64toi32_i32$0 = $2;
  HEAP32[($2 + 8 | 0) >> 2] = $8;
  HEAP32[($2 + 12 | 0) >> 2] = i64toi32_i32$1;
  $1 = core__fmt__builders__DebugStruct__finish_non_exhaustive__h85bef67279d23f66($2 + 8 | 0 | 0) | 0;
  global$0 = $2 + 16 | 0;
  return $1 | 0;
 }
 
 function cardano_serialization_lib__MultiAsset__get__had0c36a2c855d776($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  label$1 : {
   label$2 : {
    $1 = alloc__collections__btree__map__BTreeMap_K_2cV___get__h87541381570c4ffd($1 | 0, $2 | 0) | 0;
    if ($1) {
     break label$2
    }
    $1 = 0;
    break label$1;
   }
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h3f0faaa5740c6934($0 + 4 | 0 | 0, $1 | 0);
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
 }
 
 function transactioninputs_new() {
  var $0 = 0, $1 = 0;
  $0 = global$0 - 16 | 0;
  global$0 = $0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[$0 >> 2] = HEAP32[(0 + 1050220 | 0) >> 2] | 0;
  $1 = $cardano_serialization_lib__TransactionInputs_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__haa89884e18e43552($0 | 0) | 0;
  global$0 = $0 + 16 | 0;
  return $1 | 0;
 }
 
 function transactionoutputs_new() {
  var $0 = 0, $1 = 0;
  $0 = global$0 - 16 | 0;
  global$0 = $0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[$0 >> 2] = HEAP32[(0 + 1050204 | 0) >> 2] | 0;
  $1 = $cardano_serialization_lib__TransactionOutputs_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8e1ecfa37411bb92($0 | 0) | 0;
  global$0 = $0 + 16 | 0;
  return $1 | 0;
 }
 
 function certificates_new() {
  var $0 = 0, $1 = 0;
  $0 = global$0 - 16 | 0;
  global$0 = $0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[$0 >> 2] = HEAP32[(0 + 1050204 | 0) >> 2] | 0;
  $1 = $cardano_serialization_lib__Certificates_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h2d4d31bc412465af($0 | 0) | 0;
  global$0 = $0 + 16 | 0;
  return $1 | 0;
 }
 
 function cardano_serialization_lib__Certificates__get__h0f5581b1344389be($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  label$1 : {
   $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   if ($3 >>> 0 > $2 >>> 0) {
    break label$1
   }
   core__panicking__panic_bounds_check__h808b524af17640b1($2 | 0, $3 | 0, 1053240 | 0);
   abort();
  }
  $cardano_serialization_lib__Certificate_20as_20core__clone__Clone___clone__h097b7190e8dc0410($0 | 0, (HEAP32[$1 >> 2] | 0) + Math_imul($2, 200) | 0 | 0);
 }
 
 function ed25519keyhashes_new() {
  var $0 = 0, $1 = 0;
  $0 = global$0 - 16 | 0;
  global$0 = $0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[$0 >> 2] = HEAP32[(0 + 1050212 | 0) >> 2] | 0;
  $1 = $cardano_serialization_lib__Ed25519KeyHashes_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h2ef8a4685b78a9d8($0 | 0) | 0;
  global$0 = $0 + 16 | 0;
  return $1 | 0;
 }
 
 function relays_new() {
  var $0 = 0, $1 = 0;
  $0 = global$0 - 16 | 0;
  global$0 = $0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[$0 >> 2] = HEAP32[(0 + 1050220 | 0) >> 2] | 0;
  $1 = $cardano_serialization_lib__Relays_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hf76c9eea02151e5d($0 | 0) | 0;
  global$0 = $0 + 16 | 0;
  return $1 | 0;
 }
 
 function stakecredentials_new() {
  var $0 = 0, $1 = 0;
  $0 = global$0 - 16 | 0;
  global$0 = $0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[$0 >> 2] = HEAP32[(0 + 1050212 | 0) >> 2] | 0;
  $1 = $cardano_serialization_lib__StakeCredentials_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h4e7a6ae850e16266($0 | 0) | 0;
  global$0 = $0 + 16 | 0;
  return $1 | 0;
 }
 
 function rewardaddresses_new() {
  var $0 = 0, $1 = 0;
  $0 = global$0 - 16 | 0;
  global$0 = $0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[$0 >> 2] = HEAP32[(0 + 1050212 | 0) >> 2] | 0;
  $1 = $cardano_serialization_lib__RewardAddresses_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hd844bb3a1f8d93b5($0 | 0) | 0;
  global$0 = $0 + 16 | 0;
  return $1 | 0;
 }
 
 function nativescripts_new() {
  var $0 = 0, $1 = 0;
  $0 = global$0 - 16 | 0;
  global$0 = $0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[$0 >> 2] = HEAP32[(0 + 1050204 | 0) >> 2] | 0;
  $1 = $cardano_serialization_lib__NativeScripts_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hd952f91bbdbbead8($0 | 0) | 0;
  global$0 = $0 + 16 | 0;
  return $1 | 0;
 }
 
 function genesishashes_new() {
  var $0 = 0, $1 = 0;
  $0 = global$0 - 16 | 0;
  global$0 = $0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[$0 >> 2] = HEAP32[(0 + 1050212 | 0) >> 2] | 0;
  $1 = $cardano_serialization_lib__GenesisHashes_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h78a61e795f735d84($0 | 0) | 0;
  global$0 = $0 + 16 | 0;
  return $1 | 0;
 }
 
 function scripthashes_new() {
  var $0 = 0, $1 = 0;
  $0 = global$0 - 16 | 0;
  global$0 = $0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[$0 >> 2] = HEAP32[(0 + 1050212 | 0) >> 2] | 0;
  $1 = $cardano_serialization_lib__ScriptHashes_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__ha80e71a64db891b6($0 | 0) | 0;
  global$0 = $0 + 16 | 0;
  return $1 | 0;
 }
 
 function protocolversions_new() {
  var $0 = 0, $1 = 0;
  $0 = global$0 - 16 | 0;
  global$0 = $0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[$0 >> 2] = HEAP32[(0 + 1050220 | 0) >> 2] | 0;
  $1 = $cardano_serialization_lib__ProtocolVersions_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h22db0982b5b147a5($0 | 0) | 0;
  global$0 = $0 + 16 | 0;
  return $1 | 0;
 }
 
 function transactionbodies_new() {
  var $0 = 0, $1 = 0;
  $0 = global$0 - 16 | 0;
  global$0 = $0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[$0 >> 2] = HEAP32[(0 + 1050204 | 0) >> 2] | 0;
  $1 = $cardano_serialization_lib__TransactionBodies_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h13219c098e12494e($0 | 0) | 0;
  global$0 = $0 + 16 | 0;
  return $1 | 0;
 }
 
 function cardano_serialization_lib__TransactionBodies__get__hfcd5f03aff264f78($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  label$1 : {
   $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   if ($3 >>> 0 > $2 >>> 0) {
    break label$1
   }
   core__panicking__panic_bounds_check__h808b524af17640b1($2 | 0, $3 | 0, 1054212 | 0);
   abort();
  }
  $cardano_serialization_lib__TransactionBody_20as_20core__clone__Clone___clone__h8541427cda4fbd03($0 | 0, (HEAP32[$1 >> 2] | 0) + Math_imul($2, 272) | 0 | 0);
 }
 
 function transactionwitnesssets_new() {
  var $0 = 0, $1 = 0;
  $0 = global$0 - 16 | 0;
  global$0 = $0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[$0 >> 2] = HEAP32[(0 + 1050220 | 0) >> 2] | 0;
  $1 = $cardano_serialization_lib__TransactionWitnessSets_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h7db91b5cba584e3a($0 | 0) | 0;
  global$0 = $0 + 16 | 0;
  return $1 | 0;
 }
 
 function assetnames_new() {
  var $0 = 0, $1 = 0;
  $0 = global$0 - 16 | 0;
  global$0 = $0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[$0 >> 2] = HEAP32[(0 + 1050220 | 0) >> 2] | 0;
  $1 = $cardano_serialization_lib__AssetNames_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h88f81c8607449c6b($0 | 0) | 0;
  global$0 = $0 + 16 | 0;
  return $1 | 0;
 }
 
 function cardano_serialization_lib__AssetNames__get__hc0d49e00b9a5fbf3($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  label$1 : {
   $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   if ($3 >>> 0 > $2 >>> 0) {
    break label$1
   }
   core__panicking__panic_bounds_check__h808b524af17640b1($2 | 0, $3 | 0, 1054368 | 0);
   abort();
  }
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($0 | 0, (HEAP32[$1 >> 2] | 0) + Math_imul($2, 12) | 0 | 0);
 }
 
 function cardano_serialization_lib__Mint__get__h44e1f89db570ad02($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  label$1 : {
   label$2 : {
    $1 = alloc__collections__btree__map__BTreeMap_K_2cV___get__h1cff86883863eab1($1 | 0, $2 | 0) | 0;
    if ($1) {
     break label$2
    }
    $1 = 0;
    break label$1;
   }
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__clone__Clone___clone__h4a35d7ddb2264390($0 + 4 | 0 | 0, $1 | 0);
   $1 = 1;
  }
  HEAP32[$0 >> 2] = $1;
 }
 
 function $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h0a3e4540c50cd990($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $0 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$0 >> 2] | 0 | 0) | 0;
   $1 = Math_imul($1, 76);
   if (!$1) {
    break label$1
   }
   __rust_dealloc($0 | 0, $1 | 0, 4 | 0);
  }
 }
 
 function $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h0f78886c344617d4($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $0 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$0 >> 2] | 0 | 0) | 0;
   $1 = $1 << 5 | 0;
   if (!$1) {
    break label$1
   }
   __rust_dealloc($0 | 0, $1 | 0, 8 | 0);
  }
 }
 
 function $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h1737752c75bae0f3($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $0 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$0 >> 2] | 0 | 0) | 0;
   $1 = $1 << 3 | 0;
   if (!$1) {
    break label$1
   }
   __rust_dealloc($0 | 0, $1 | 0, 4 | 0);
  }
 }
 
 function $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h19d691521e7c48e6($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $0 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$0 >> 2] | 0 | 0) | 0;
   $1 = Math_imul($1, 12);
   if (!$1) {
    break label$1
   }
   __rust_dealloc($0 | 0, $1 | 0, 4 | 0);
  }
 }
 
 function $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h1f8037d956efeb38($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $0 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$0 >> 2] | 0 | 0) | 0;
   $1 = Math_imul($1, 12);
   if (!$1) {
    break label$1
   }
   __rust_dealloc($0 | 0, $1 | 0, 4 | 0);
  }
 }
 
 function $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h20290d2630d8c740($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $0 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$0 >> 2] | 0 | 0) | 0;
   $1 = Math_imul($1, 96);
   if (!$1) {
    break label$1
   }
   __rust_dealloc($0 | 0, $1 | 0, 8 | 0);
  }
 }
 
 function $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h28ea22ae705f999b($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $0 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$0 >> 2] | 0 | 0) | 0;
   $1 = $1 << 3 | 0;
   if (!$1) {
    break label$1
   }
   __rust_dealloc($0 | 0, $1 | 0, 4 | 0);
  }
 }
 
 function $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h2a00dda64f22da3c($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $0 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$0 >> 2] | 0 | 0) | 0;
   $1 = Math_imul($1, 12);
   if (!$1) {
    break label$1
   }
   __rust_dealloc($0 | 0, $1 | 0, 4 | 0);
  }
 }
 
 function $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h3633100df9c96e1e($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $0 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$0 >> 2] | 0 | 0) | 0;
   $1 = Math_imul($1, 12);
   if (!$1) {
    break label$1
   }
   __rust_dealloc($0 | 0, $1 | 0, 4 | 0);
  }
 }
 
 function $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h36e817e704f6f25e($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $0 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$0 >> 2] | 0 | 0) | 0;
   $1 = Math_imul($1, 48);
   if (!$1) {
    break label$1
   }
   __rust_dealloc($0 | 0, $1 | 0, 8 | 0);
  }
 }
 
 function $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h48e03889c2b030fa($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $0 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$0 >> 2] | 0 | 0) | 0;
   $1 = Math_imul($1, 168);
   if (!$1) {
    break label$1
   }
   __rust_dealloc($0 | 0, $1 | 0, 8 | 0);
  }
 }
 
 function $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h4c688d2d7e8a61fa($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $0 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$0 >> 2] | 0 | 0) | 0;
   $1 = Math_imul($1, 80);
   if (!$1) {
    break label$1
   }
   __rust_dealloc($0 | 0, $1 | 0, 8 | 0);
  }
 }
 
 function $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h5107e2b13c386680($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $0 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$0 >> 2] | 0 | 0) | 0;
   $1 = $1 << 7 | 0;
   if (!$1) {
    break label$1
   }
   __rust_dealloc($0 | 0, $1 | 0, 8 | 0);
  }
 }
 
 function $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h534428c4bbf875dd($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $0 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$0 >> 2] | 0 | 0) | 0;
   $1 = $1 << 5 | 0;
   if (!$1) {
    break label$1
   }
   __rust_dealloc($0 | 0, $1 | 0, 1 | 0);
  }
 }
 
 function $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h53c1f511db73a3dc($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $0 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$0 >> 2] | 0 | 0) | 0;
   $1 = $1 << 3 | 0;
   if (!$1) {
    break label$1
   }
   __rust_dealloc($0 | 0, $1 | 0, 8 | 0);
  }
 }
 
 function $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h72de9eab2f0e4669($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $0 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$0 >> 2] | 0 | 0) | 0;
   $1 = Math_imul($1, 28);
   if (!$1) {
    break label$1
   }
   __rust_dealloc($0 | 0, $1 | 0, 1 | 0);
  }
 }
 
 function $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h79e8c51775f4d5f8($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $0 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$0 >> 2] | 0 | 0) | 0;
   $1 = Math_imul($1, 120);
   if (!$1) {
    break label$1
   }
   __rust_dealloc($0 | 0, $1 | 0, 4 | 0);
  }
 }
 
 function $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h7ca18c2b7d174864($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $0 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$0 >> 2] | 0 | 0) | 0;
   $1 = Math_imul($1, 272);
   if (!$1) {
    break label$1
   }
   __rust_dealloc($0 | 0, $1 | 0, 8 | 0);
  }
 }
 
 function $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h81b8a37e31f2de30($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $0 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$0 >> 2] | 0 | 0) | 0;
   $1 = Math_imul($1, 48);
   if (!$1) {
    break label$1
   }
   __rust_dealloc($0 | 0, $1 | 0, 8 | 0);
  }
 }
 
 function $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h8809497f289c3544($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $0 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$0 >> 2] | 0 | 0) | 0;
   $1 = Math_imul($1, 24);
   if (!$1) {
    break label$1
   }
   __rust_dealloc($0 | 0, $1 | 0, 8 | 0);
  }
 }
 
 function $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h8a39c130794ac15a($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $0 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$0 >> 2] | 0 | 0) | 0;
   $1 = $1 << 5 | 0;
   if (!$1) {
    break label$1
   }
   __rust_dealloc($0 | 0, $1 | 0, 1 | 0);
  }
 }
 
 function $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h96b3170d440e3692($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $0 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$0 >> 2] | 0 | 0) | 0;
   $1 = Math_imul($1, 28);
   if (!$1) {
    break label$1
   }
   __rust_dealloc($0 | 0, $1 | 0, 4 | 0);
  }
 }
 
 function $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h98bad0b07702c13e($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $0 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$0 >> 2] | 0 | 0) | 0;
   $1 = Math_imul($1, 36);
   if (!$1) {
    break label$1
   }
   __rust_dealloc($0 | 0, $1 | 0, 4 | 0);
  }
 }
 
 function $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h9b1d3bb47b46eeb8($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $0 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$0 >> 2] | 0 | 0) | 0;
   $1 = Math_imul($1, 144);
   if (!$1) {
    break label$1
   }
   __rust_dealloc($0 | 0, $1 | 0, 8 | 0);
  }
 }
 
 function $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__ha1b43c51acf8124f($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $0 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$0 >> 2] | 0 | 0) | 0;
   $1 = Math_imul($1, 200);
   if (!$1) {
    break label$1
   }
   __rust_dealloc($0 | 0, $1 | 0, 8 | 0);
  }
 }
 
 function $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hbadab170a9e9861d($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $0 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$0 >> 2] | 0 | 0) | 0;
   $1 = $1 << 3 | 0;
   if (!$1) {
    break label$1
   }
   __rust_dealloc($0 | 0, $1 | 0, 8 | 0);
  }
 }
 
 function $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hd17502cd2c574696($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $0 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$0 >> 2] | 0 | 0) | 0;
   $1 = Math_imul($1, 28);
   if (!$1) {
    break label$1
   }
   __rust_dealloc($0 | 0, $1 | 0, 1 | 0);
  }
 }
 
 function $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hd4ac14c513c9516d($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $0 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$0 >> 2] | 0 | 0) | 0;
   $1 = Math_imul($1, 12);
   if (!$1) {
    break label$1
   }
   __rust_dealloc($0 | 0, $1 | 0, 4 | 0);
  }
 }
 
 function $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hdd0c057252922c46($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $0 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$0 >> 2] | 0 | 0) | 0;
   $1 = Math_imul($1, 96);
   if (!$1) {
    break label$1
   }
   __rust_dealloc($0 | 0, $1 | 0, 1 | 0);
  }
 }
 
 function $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hebb629eda405a6ec($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $0 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$0 >> 2] | 0 | 0) | 0;
   $1 = Math_imul($1, 28);
   if (!$1) {
    break label$1
   }
   __rust_dealloc($0 | 0, $1 | 0, 1 | 0);
  }
 }
 
 function $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hebed8fd85cb76c41($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $0 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$0 >> 2] | 0 | 0) | 0;
   $1 = $1 << 4 | 0;
   if (!$1) {
    break label$1
   }
   __rust_dealloc($0 | 0, $1 | 0, 8 | 0);
  }
 }
 
 function $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hf2b315b267dbf438($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $0 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$0 >> 2] | 0 | 0) | 0;
   $1 = Math_imul($1, 29);
   if (!$1) {
    break label$1
   }
   __rust_dealloc($0 | 0, $1 | 0, 1 | 0);
  }
 }
 
 function $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hf5b7c59907e4555e($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $0 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$0 >> 2] | 0 | 0) | 0;
   $1 = Math_imul($1, 30);
   if (!$1) {
    break label$1
   }
   __rust_dealloc($0 | 0, $1 | 0, 1 | 0);
  }
 }
 
 function transactionunspentoutputs_new() {
  var $0 = 0, $1 = 0;
  $0 = global$0 - 16 | 0;
  global$0 = $0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[$0 >> 2] = HEAP32[(0 + 1057676 | 0) >> 2] | 0;
  $1 = $cardano_serialization_lib__utils__TransactionUnspentOutputs_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__had502564c9c936e2($0 | 0) | 0;
  global$0 = $0 + 16 | 0;
  return $1 | 0;
 }
 
 function metadatalist_new() {
  var $0 = 0, $1 = 0;
  $0 = global$0 - 16 | 0;
  global$0 = $0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[$0 >> 2] = HEAP32[(0 + 1059252 | 0) >> 2] | 0;
  $1 = $cardano_serialization_lib__metadata__MetadataList_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h726a255338699014($0 | 0) | 0;
  global$0 = $0 + 16 | 0;
  return $1 | 0;
 }
 
 function transactionmetadatumlabels_new() {
  var $0 = 0, $1 = 0;
  $0 = global$0 - 16 | 0;
  global$0 = $0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[$0 >> 2] = HEAP32[(0 + 1059252 | 0) >> 2] | 0;
  $1 = $cardano_serialization_lib__metadata__TransactionMetadatumLabels_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h90a9618967dafb91($0 | 0) | 0;
  global$0 = $0 + 16 | 0;
  return $1 | 0;
 }
 
 function vkeys_new() {
  var $0 = 0, $1 = 0;
  $0 = global$0 - 16 | 0;
  global$0 = $0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[$0 >> 2] = HEAP32[(0 + 1066212 | 0) >> 2] | 0;
  $1 = $cardano_serialization_lib__crypto__Vkeys_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h5ad294e449690b5c($0 | 0) | 0;
  global$0 = $0 + 16 | 0;
  return $1 | 0;
 }
 
 function vkeywitnesses_new() {
  var $0 = 0, $1 = 0;
  $0 = global$0 - 16 | 0;
  global$0 = $0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[$0 >> 2] = HEAP32[(0 + 1066212 | 0) >> 2] | 0;
  $1 = $cardano_serialization_lib__crypto__Vkeywitnesses_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h27fd70dd9b21a645($0 | 0) | 0;
  global$0 = $0 + 16 | 0;
  return $1 | 0;
 }
 
 function bootstrapwitnesses_new() {
  var $0 = 0, $1 = 0;
  $0 = global$0 - 16 | 0;
  global$0 = $0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[$0 >> 2] = HEAP32[(0 + 1066220 | 0) >> 2] | 0;
  $1 = $cardano_serialization_lib__crypto__BootstrapWitnesses_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__ha47785b575a14436($0 | 0) | 0;
  global$0 = $0 + 16 | 0;
  return $1 | 0;
 }
 
 function publickeys_new() {
  var $0 = 0, $1 = 0;
  $0 = global$0 - 16 | 0;
  global$0 = $0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[$0 >> 2] = HEAP32[(0 + 1066212 | 0) >> 2] | 0;
  $1 = $cardano_serialization_lib__crypto__PublicKeys_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h4087860bc5842f2d($0 | 0) | 0;
  global$0 = $0 + 16 | 0;
  return $1 | 0;
 }
 
 function plutuswitnesses_new() {
  var $0 = 0, $1 = 0;
  $0 = global$0 - 16 | 0;
  global$0 = $0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[$0 >> 2] = HEAP32[(0 + 1069056 | 0) >> 2] | 0;
  $1 = $cardano_serialization_lib__tx_builder__tx_inputs_builder__PlutusWitnesses_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8895bf7926c04f4f($0 | 0) | 0;
  global$0 = $0 + 16 | 0;
  return $1 | 0;
 }
 
 function plutusscripts_new() {
  var $0 = 0, $1 = 0;
  $0 = global$0 - 16 | 0;
  global$0 = $0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[$0 >> 2] = HEAP32[(0 + 1070728 | 0) >> 2] | 0;
  $1 = $cardano_serialization_lib__plutus__PlutusScripts_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hca65427e7f610652($0 | 0) | 0;
  global$0 = $0 + 16 | 0;
  return $1 | 0;
 }
 
 function cardano_serialization_lib__plutus__PlutusScripts__get__h8b0a8416c3ca60a6($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  label$1 : {
   $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   if ($3 >>> 0 > $2 >>> 0) {
    break label$1
   }
   core__panicking__panic_bounds_check__h808b524af17640b1($2 | 0, $3 | 0, 1071312 | 0);
   abort();
  }
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h67b7904a4f07a1e3($0 | 0, (HEAP32[$1 >> 2] | 0) + Math_imul($2, 12) | 0 | 0);
 }
 
 function languages_new() {
  var $0 = 0, $1 = 0;
  $0 = global$0 - 16 | 0;
  global$0 = $0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[$0 >> 2] = HEAP32[(0 + 1070744 | 0) >> 2] | 0;
  $1 = $cardano_serialization_lib__plutus__Languages_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h685771a5e09c75ed($0 | 0) | 0;
  global$0 = $0 + 16 | 0;
  return $1 | 0;
 }
 
 function cardano_serialization_lib__plutus__PlutusList__get__hc927172b428c7408($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  label$1 : {
   $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   if ($3 >>> 0 > $2 >>> 0) {
    break label$1
   }
   core__panicking__panic_bounds_check__h808b524af17640b1($2 | 0, $3 | 0, 1071716 | 0);
   abort();
  }
  $cardano_serialization_lib__plutus__PlutusData_20as_20core__clone__Clone___clone__h63d1a98cc18f4609_2($0 | 0, (HEAP32[$1 >> 2] | 0) + Math_imul($2, 48) | 0 | 0);
 }
 
 function redeemers_new() {
  var $0 = 0, $1 = 0;
  $0 = global$0 - 16 | 0;
  global$0 = $0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[$0 >> 2] = HEAP32[(0 + 1070736 | 0) >> 2] | 0;
  $1 = $cardano_serialization_lib__plutus__Redeemers_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hb4f0431e16335b87($0 | 0) | 0;
  global$0 = $0 + 16 | 0;
  return $1 | 0;
 }
 
 function strings_new() {
  var $0 = 0, $1 = 0;
  $0 = global$0 - 16 | 0;
  global$0 = $0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[$0 >> 2] = HEAP32[(0 + 1070728 | 0) >> 2] | 0;
  $1 = $cardano_serialization_lib__plutus__Strings_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he577c36628c95b6e($0 | 0) | 0;
  global$0 = $0 + 16 | 0;
  return $1 | 0;
 }
 
 function cardano_serialization_lib__plutus__Strings__get__h79dff2673a5e7187($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  label$1 : {
   $3 = HEAP32[($1 + 8 | 0) >> 2] | 0;
   if ($3 >>> 0 > $2 >>> 0) {
    break label$1
   }
   core__panicking__panic_bounds_check__h808b524af17640b1($2 | 0, $3 | 0, 1071812 | 0);
   abort();
  }
  $alloc__string__String_20as_20core__clone__Clone___clone__ha1c184ffd1b99324($0 | 0, (HEAP32[$1 >> 2] | 0) + Math_imul($2, 12) | 0 | 0);
 }
 
 function std__sys_common__backtrace____rust_end_short_backtrace__h75f570b2d951b191($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  HEAP32[($1 + 8 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[$1 >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = i64toi32_i32$1;
  std__panicking__begin_panic___7b_7bclosure_7d_7d__h87b5758e0a383391($1 | 0);
  abort();
 }
 
 function cryptoxide__hmac__derive_key__h8cbec42a702c5a3a($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  label$1 : {
   if (!$1) {
    break label$1
   }
   label$2 : while (1) {
    HEAP8[$0 >> 0] = (HEAPU8[$0 >> 0] | 0) ^ $2 | 0;
    $0 = $0 + 1 | 0;
    $1 = $1 + -1 | 0;
    if ($1) {
     continue label$2
    }
    break label$2;
   };
  }
 }
 
 function cryptoxide__curve25519__ge__GePrecomp__maybe_set__h501e3b2851925ba0($0, $1, $2, $2$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  var i64toi32_i32$0 = 0;
  i64toi32_i32$0 = $2$hi;
  cryptoxide__constant_time__ct_array64_maybe_set__h78feb940adce935a($0 | 0, $1 | 0, $2 | 0, i64toi32_i32$0 | 0);
  cryptoxide__constant_time__ct_array64_maybe_set__h78feb940adce935a($0 + 40 | 0 | 0, $1 + 40 | 0 | 0, $2 | 0, i64toi32_i32$0 | 0);
  cryptoxide__constant_time__ct_array64_maybe_set__h78feb940adce935a($0 + 80 | 0 | 0, $1 + 80 | 0 | 0, $2 | 0, i64toi32_i32$0 | 0);
 }
 
 function std__sys_common__backtrace____rust_end_short_backtrace__hedea918946d28cea($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  HEAP32[($1 + 8 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[$1 >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = i64toi32_i32$1;
  std__panicking__begin_panic___7b_7bclosure_7d_7d__h116b254b03f8479b($1 | 0);
  abort();
 }
 
 function std__sys_common__backtrace____rust_end_short_backtrace__h07554449d90848f3($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  HEAP32[($1 + 8 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[$1 >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = i64toi32_i32$1;
  std__panicking__begin_panic___7b_7bclosure_7d_7d__h29d8e4472f2e2dbe($1 | 0);
  abort();
 }
 
 function std__sys_common__backtrace____rust_end_short_backtrace__hf31049169beda171($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  HEAP32[($1 + 8 | 0) >> 2] = HEAP32[($0 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[$1 >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 4 | 0) >> 2] = i64toi32_i32$1;
  std__panicking__begin_panic_handler___7b_7bclosure_7d_7d__h3e6db7c674e79203($1 | 0);
  abort();
 }
 
 function core__panicking__panic_fmt__hbf21a3d4bbb82bf8($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  HEAP32[($2 + 4 | 0) >> 2] = 1149512;
  HEAP32[$2 >> 2] = 1149204;
  rust_begin_unwind($2 | 0);
  abort();
 }
 
 function core__fmt__builders__DebugList__finish__h372f90da800e1030($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = 1;
  label$1 : {
   if (HEAPU8[($0 + 4 | 0) >> 0] | 0) {
    break label$1
   }
   $0 = HEAP32[$0 >> 2] | 0;
   $1 = FUNCTION_TABLE[HEAP32[((HEAP32[($0 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($0 + 24 | 0) >> 2] | 0, 1149920, 1) | 0;
  }
  return $1 | 0;
 }
 
 function core__fmt__Formatter__new__he219faf25326051b($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  HEAP8[($0 + 32 | 0) >> 0] = 3;
  HEAP32[$0 >> 2] = 0;
  HEAP32[($0 + 4 | 0) >> 2] = 32;
  HEAP32[($0 + 24 | 0) >> 2] = $1;
  HEAP32[($0 + 16 | 0) >> 2] = 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[($0 + 28 | 0) >> 2] = $2;
 }
 
 function memset($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0;
  label$1 : {
   if (!$2) {
    break label$1
   }
   $3 = $0;
   label$2 : while (1) {
    HEAP8[$3 >> 0] = $1;
    $3 = $3 + 1 | 0;
    $2 = $2 + -1 | 0;
    if ($2) {
     continue label$2
    }
    break label$2;
   };
  }
  return $0 | 0;
 }
 
 function core__ptr__drop_in_place_cardano_serialization_lib__MIREnum___h06315a825cbe6fa9($0) {
  $0 = $0 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0;
  label$1 : {
   i64toi32_i32$0 = HEAP32[$0 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   i64toi32_i32$2 = i64toi32_i32$0;
   i64toi32_i32$0 = 0;
   if ((i64toi32_i32$2 | 0) == (0 | 0) & (i64toi32_i32$1 | 0) == (i64toi32_i32$0 | 0) | 0) {
    break label$1
   }
   $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__hddd2979ebb13db27($0 + 8 | 0 | 0);
   $0 = $0 + 24 | 0;
   if (!(HEAP32[$0 >> 2] | 0)) {
    break label$1
   }
   hashbrown__raw__RawTable_T_2cA___free_buckets__h78477753a901af0e($0 | 0);
  }
 }
 
 function $cardano_serialization_lib__MultiAsset_20as_20core__cmp__PartialOrd___partial_cmp__h767e68b80e51259d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = $cardano_serialization_lib__MultiAsset_20as_20core__cmp__PartialOrd___partial_cmp__is_all_zeros__ha3c92144892c9bcb($0 | 0, $1 | 0) | 0;
  $0 = $cardano_serialization_lib__MultiAsset_20as_20core__cmp__PartialOrd___partial_cmp__is_all_zeros__ha3c92144892c9bcb($1 | 0, $0 | 0) | 0;
  label$1 : {
   if ($2) {
    break label$1
   }
   return ($0 ? 1 : 2) | 0;
  }
  return $0 + -1 | 0 | 0;
 }
 
 function __wbg_scriptnofk_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__ScriptNOfK_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h805aa8e4c47b1131($1 | 0, $0 | 0);
  $0 = $1 | 4 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc3d6ec99c05cee40($0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h0f78886c344617d4($0 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function cardano_serialization_lib__MultiAsset__get_asset__h0abde100680c5c0a($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $3 = 0, $3$hi = 0;
  i64toi32_i32$0 = 0;
  $3 = 0;
  $3$hi = i64toi32_i32$0;
  label$1 : {
   $0 = alloc__collections__btree__map__BTreeMap_K_2cV___get__h87541381570c4ffd($0 | 0, $1 | 0) | 0;
   if (!$0) {
    break label$1
   }
   $0 = alloc__collections__btree__map__BTreeMap_K_2cV___get__h825f34112f7eacbf($0 | 0, $2 | 0) | 0;
   if (!$0) {
    break label$1
   }
   i64toi32_i32$0 = HEAP32[$0 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   $3 = i64toi32_i32$0;
   $3$hi = i64toi32_i32$1;
  }
  i64toi32_i32$1 = $3$hi;
  i64toi32_i32$0 = $3;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$1;
  return i64toi32_i32$0 | 0;
 }
 
 function core__mem__maybe_uninit__MaybeUninit_T___assume_init_drop__h9493df6090141cf4($0) {
  $0 = $0 | 0;
  label$1 : {
   if ((HEAPU8[$0 >> 0] | 0) >>> 0 < 4 >>> 0) {
    break label$1
   }
   core__ptr__drop_in_place_core__option__Option_alloc__vec__Vec_u8_____ha5300c747747c3c8($0 + 4 | 0 | 0);
  }
  label$2 : {
   if (!(HEAP32[($0 + 72 | 0) >> 2] | 0)) {
    break label$2
   }
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($0 + 76 | 0 | 0);
  }
 }
 
 function cardano_serialization_lib__utils__BigInt__increment__h0dd310992170006f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  cardano_serialization_lib__utils__BigInt__one__h46931845af9c14ed($2 | 0);
  num_bigint__bigint__addition___impl_20core__ops__arith__Add__num_bigint__bigint__BigInt__20for_20_num_bigint__bigint__BigInt___add__h354544d3f4ae9625_1($0 | 0, $1 | 0, $2 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h19f76bdb6b4883ef($2 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h970b13f6299e0f2d($2 | 0);
  global$0 = $2 + 16 | 0;
 }
 
 function cardano_serialization_lib__crypto__PrivateKey__to_bech32__haf9748b54338b452($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = $1 + 1 | 0;
  label$1 : {
   if ((HEAPU8[$1 >> 0] | 0 | 0) == (1 | 0)) {
    break label$1
   }
   cardano_serialization_lib__chain_crypto__bech32__to_bech32_from_bytes__h58a287ff323357c6($0 | 0, $2 | 0, 64 | 0);
   return;
  }
  cardano_serialization_lib__chain_crypto__bech32__to_bech32_from_bytes__hb1c1076c8140bfd9($0 | 0, $2 | 0, 32 | 0);
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h009172765b98cd49($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h0118f8f5f8658202($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h01f36213dd513b30($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h04da9548c44845e2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h061555eda9801069($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h0746217235ca17c1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h078bb85e66acd6f6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h08b9ef3d4f949db8($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h0a71cd742026514d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h0bd7a1579e3c59b4($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h0dac3591c8fddd86($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h122253d178bb0a3d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h1227f23aa068e55a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h1305d160e0e385a5($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h14776c1c2f845163($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h17bb811378ba5c0a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h1ad0c5a49f4f60b7($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h1c32993c268a4012($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h1c3e5d7685536043($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h1c7f0e3050b987b8($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h1cc4e67284701531($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h1ee81fd4f1a62708($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h2148bae0d331f5e4($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h238818d95bb6c551($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h24c88156dad2ef97($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h24ec40b16d3308f2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h26d671c8c095c821($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h29efc310563dc83c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h2b41666efcf1cebf($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h2cc4f80e3a10a5cf($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h2e0ce7a7ba945683($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h3071e883f72e7ae8($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h35a89179297fae2a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h3b236b5d1445a759($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h3bcf83380d1abbd9($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h3c331aa05f471767($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h3dcba3638ab0c9bc($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h3e58b4ea37ee3a12($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h407e866bc710507b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h434e5e29ad9f2783($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h48ae624d339b329f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h4b2375a8f3b1678d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h4b93f864eaa742c0($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h4d1a812098c80b71($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h504db7e111ee10e7($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h524388c903ba8fc4($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h52c8cf155a794094($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h5343c37ad06efd21($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h5566e1c7d4aafe35($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h55a9e62aded28c25($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h56eea9784c6427d6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h57b86fe1cb305719($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h5835baad1f806fc3($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h5a93dad80b9e2f2c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h605a8c52555cadba($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h60cc26adb5968dc4($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h635fa27cde6b95a8($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h678179fab295364a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h6c10e1bb84be99c5($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h6d906a27126b3b1d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h6e4f06a418081d49($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h6f896cc1d65c94a7($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h70a9eb625118938d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h732ca94bf7b0fcbd($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h73abe51fb1a6aa1e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h7554f81066822c17($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h776bc08da2f877b7($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h7a45263e953750b2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h7b938c611a49001e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h7c125373284ebadf($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h7dc8ec51bf9127a6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h809036bdef3fe4e9($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h80a1b87584d9858b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h82461377cd035a44($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h82db26eaf8d53cff($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h83c09f1ed97d5b0f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h85bc9e9047d49895($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h86c452d6d75acdae($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h898a67bdbd736c3e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h8bccc78f842f4f24($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h8d7fffc515cd56d6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h8fa773adf60ecc95($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h93c478ef73ae4bb6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h94807ac56e362a92($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h998daf6406896aba($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__h9e52e116c2bb3e9f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__ha0a883bb3aca536a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__ha2d20d272947bf8a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__ha2ebf5dc8c79bae5($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__ha3e3459a4991b9a5($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__ha4e1a799acccbfd2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__ha58eebd50d56cad2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__ha65a927bae2fc7ee($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__ha681df4b192f3b9b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__ha76caa55a13a9b32($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__ha87586f3d6cffbc3($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__ha963d8c1f162247c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__ha9ddcb0fc94d348b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hb1904961fadb75a0($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hb231bc98a91fbbb7($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hb2d5e2416ce5f734($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hb2fe413b90565871($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hb5d69d43b863633b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hb627015b59398c63($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hbb430c180f3ec4b2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hbc201b8ccd6b711d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hbe92ab119edf5148($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hc08699f22fda04d6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hc3197a13809f41ef($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hc328745336482c29($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hc5dae48d2a6017b6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hc5dfe90718757ef2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hc62850cdf82b67ee($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hcc20539835b5bb39($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hccc847303139d236($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hcf0411f2252ca14a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hd050e13480afb3ab($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hd69c4b5985a5a825($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hd75e174e5b45254f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hda4ab87d1c9ee98a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hdb743999990312b6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__he19d9eeea00abf77($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__he19e93a673b26304($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__he31b94e8dd616f49($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__he564908227ef84d7($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__he5bc187cb5257910($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__he80be601c7107d4d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hed421792766cbc07($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hf0272a72391b2a3a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hf1389f409abb520e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hf14781561558cd9c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hf18176d31e9af7c8($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hf24f358605852732($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hf277c6a2d5f089a3($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hf5b35c737998120c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 8 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hfa9e4b95817026bf($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hfbdb71482669dd0b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hfc0a9a42b93da95d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hfedafe972002c954($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function wasm_bindgen____rt__WasmRefCell_T___borrow_mut__hff755cd032524cf1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   core__cell__Cell_T___replace__h74ad9f426af36be8($1 | 0, -1 | 0) | 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = $1 + 4 | 0;
   return;
  }
  wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7();
  abort();
 }
 
 function core__fmt__num___impl_20core__fmt__Debug_20for_20i32___fmt__h252cf9c2774e7ec3($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   label$2 : {
    if (core__fmt__Formatter__debug_lower_hex__h8226cdf2ca894293($1 | 0) | 0) {
     break label$2
    }
    if (core__fmt__Formatter__debug_upper_hex__h837fa1522c833b74($1 | 0) | 0) {
     break label$1
    }
    return core__fmt__num__imp___impl_20core__fmt__Display_20for_20i32___fmt__hc7b987a91b743964($0 | 0, $1 | 0) | 0 | 0;
   }
   return core__fmt__num___impl_20core__fmt__LowerHex_20for_20i32___fmt__h9723d6e56c381fda($0 | 0, $1 | 0) | 0 | 0;
  }
  return core__fmt__num___impl_20core__fmt__UpperHex_20for_20i32___fmt__h135eeaf75c8aff9c($0 | 0, $1 | 0) | 0 | 0;
 }
 
 function core__fmt__num___impl_20core__fmt__Debug_20for_20u32___fmt__h896d1993d65dfe18($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   label$2 : {
    if (core__fmt__Formatter__debug_lower_hex__h8226cdf2ca894293($1 | 0) | 0) {
     break label$2
    }
    if (core__fmt__Formatter__debug_upper_hex__h837fa1522c833b74($1 | 0) | 0) {
     break label$1
    }
    return core__fmt__num__imp___impl_20core__fmt__Display_20for_20u32___fmt__h84f076c5e5d839ee($0 | 0, $1 | 0) | 0 | 0;
   }
   return core__fmt__num___impl_20core__fmt__LowerHex_20for_20i32___fmt__h9723d6e56c381fda($0 | 0, $1 | 0) | 0 | 0;
  }
  return core__fmt__num___impl_20core__fmt__UpperHex_20for_20i32___fmt__h135eeaf75c8aff9c($0 | 0, $1 | 0) | 0 | 0;
 }
 
 function ed25519_bip32__key__XPrv__normalize_bytes_force3rd__hc83616bc3d9dd3b6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  HEAP8[$1 >> 0] = (HEAPU8[$1 >> 0] | 0) & 248 | 0;
  HEAP8[($1 + 31 | 0) >> 0] = (HEAPU8[($1 + 31 | 0) >> 0] | 0) & 31 | 0 | 64 | 0;
  memcpy($0 | 0, $1 | 0, 96 | 0) | 0;
 }
 
 function $cryptoxide__sha2__Sha512_20as_20cryptoxide__digest__Digest___reset__h100e33024dbb0407($0) {
  $0 = $0 | 0;
  var i64toi32_i32$0 = 0;
  i64toi32_i32$0 = 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[($0 + 12 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  HEAP32[$0 >> 2] = 0;
  HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[($0 + 80 | 0) >> 2] = 0;
  memcpy($0 + 16 | 0 | 0, 1137368 | 0, 64 | 0) | 0;
  HEAP8[($0 + 216 | 0) >> 0] = 0;
 }
 
 function core__fmt__num___impl_20core__fmt__Debug_20for_20i32___fmt__h252cf9c2774e7ec3_1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   label$2 : {
    if (core__fmt__Formatter__debug_lower_hex__h8226cdf2ca894293($1 | 0) | 0) {
     break label$2
    }
    if (core__fmt__Formatter__debug_upper_hex__h837fa1522c833b74($1 | 0) | 0) {
     break label$1
    }
    return core__fmt__num__imp___impl_20core__fmt__Display_20for_20i32___fmt__hc7b987a91b743964($0 | 0, $1 | 0) | 0 | 0;
   }
   return core__fmt__num___impl_20core__fmt__LowerHex_20for_20i32___fmt__h9723d6e56c381fda($0 | 0, $1 | 0) | 0 | 0;
  }
  return core__fmt__num___impl_20core__fmt__UpperHex_20for_20i32___fmt__h135eeaf75c8aff9c($0 | 0, $1 | 0) | 0 | 0;
 }
 
 function core__ptr__drop_in_place_std__ffi__c_str__NulError___h5ad11252a9c16486($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (!$0) {
    break label$1
   }
   __rust_dealloc($1 | 0, $0 | 0, 1 | 0);
  }
 }
 
 function dlmalloc__dlmalloc__Chunk__set_inuse__h3ef3278ef1a39233($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = (HEAP32[($0 + 4 | 0) >> 2] | 0) & 1 | 0 | $1 | 0 | 2 | 0;
  $0 = $0 + $1 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($0 + 4 | 0) >> 2] | 0 | 1 | 0;
 }
 
 function core__ptr__drop_in_place_cardano_serialization_lib__ProtocolParamUpdate___h92eeb91cabd2847d($0) {
  $0 = $0 | 0;
  label$1 : {
   if (!(HEAP32[($0 + 320 | 0) >> 2] | 0)) {
    break label$1
   }
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h1737752c75bae0f3($0 + 320 | 0 | 0);
  }
  label$2 : {
   if (!(HEAP32[($0 + 332 | 0) >> 2] | 0)) {
    break label$2
   }
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h5f5dc70d320637e0($0 + 336 | 0 | 0);
  }
 }
 
 function $cardano_serialization_lib__NetworkId_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hf6f78a05c9fd49e7($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = __rust_alloc(8 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(8 | 0, 4 | 0);
   abort();
  }
  HEAP8[($1 + 4 | 0) >> 0] = $0;
  HEAP32[$1 >> 2] = 0;
  return $1 | 0;
 }
 
 function __wbg_moveinstantaneousrewardscert_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 64 | 0;
  global$0 = $1;
  $cardano_serialization_lib__MoveInstantaneousRewardsCert_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hbde5b1f1e4006a22($1 + 8 | 0 | 0, $0 | 0);
  core__ptr__drop_in_place_cardano_serialization_lib__MIREnum___h06315a825cbe6fa9($1 + 8 | 0 | 0);
  global$0 = $1 + 64 | 0;
 }
 
 function __wbg_certificate_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 208 | 0;
  global$0 = $1;
  $cardano_serialization_lib__Certificate_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h850d5e2c1a1a2142($1 + 8 | 0 | 0, $0 | 0);
  core__ptr__drop_in_place_cardano_serialization_lib__CertificateEnum___h537567b60c24bc16($1 + 8 | 0 | 0);
  global$0 = $1 + 208 | 0;
 }
 
 function __wbg_moveinstantaneousreward_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 64 | 0;
  global$0 = $1;
  $cardano_serialization_lib__MoveInstantaneousReward_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h5288a22e542b635f($1 + 8 | 0 | 0, $0 | 0);
  core__ptr__drop_in_place_cardano_serialization_lib__MIREnum___h06315a825cbe6fa9($1 + 8 | 0 | 0);
  global$0 = $1 + 64 | 0;
 }
 
 function $cardano_serialization_lib__Ipv4_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h260bfd99906fbe36($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, $1 = 0, i64toi32_i32$1 = 0, i64toi32_i32$3 = 0, $8 = 0, $4 = 0, i64toi32_i32$0 = 0;
  label$1 : {
   $1 = __rust_alloc(8 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(8 | 0, 4 | 0);
   abort();
  }
  $4 = $1;
  i64toi32_i32$0 = 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $8 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $8 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  i64toi32_i32$2 = $4;
  HEAP32[i64toi32_i32$2 >> 2] = $8;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__TimelockStart_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h71f9779b79ae2a49($0, $0$hi) {
  $0 = $0 | 0;
  $0$hi = $0$hi | 0;
  var $1 = 0, i64toi32_i32$0 = 0;
  label$1 : {
   $1 = __rust_alloc(16 | 0, 8 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(16 | 0, 8 | 0);
   abort();
  }
  i64toi32_i32$0 = $0$hi;
  HEAP32[($1 + 8 | 0) >> 2] = $0;
  HEAP32[($1 + 12 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[$1 >> 2] = 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__TimelockExpiry_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h701c0b7035bdc4b4($0, $0$hi) {
  $0 = $0 | 0;
  $0$hi = $0$hi | 0;
  var $1 = 0, i64toi32_i32$0 = 0;
  label$1 : {
   $1 = __rust_alloc(16 | 0, 8 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(16 | 0, 8 | 0);
   abort();
  }
  i64toi32_i32$0 = $0$hi;
  HEAP32[($1 + 8 | 0) >> 2] = $0;
  HEAP32[($1 + 12 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[$1 >> 2] = 0;
  return $1 | 0;
 }
 
 function __wbg_protocolparamupdate_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 416 | 0;
  global$0 = $1;
  $cardano_serialization_lib__ProtocolParamUpdate_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h9e574c25b3cdebb6($1 + 8 | 0 | 0, $0 | 0);
  core__ptr__drop_in_place_cardano_serialization_lib__ProtocolParamUpdate___h92eeb91cabd2847d($1 + 8 | 0 | 0);
  global$0 = $1 + 416 | 0;
 }
 
 function __wbg_header_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 336 | 0;
  global$0 = $1;
  $cardano_serialization_lib__Header_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hbf99d73ed65f1411($1 + 8 | 0 | 0, $0 | 0);
  core__ptr__drop_in_place_cardano_serialization_lib__Header___h8385b81bf98ec4f1($1 + 8 | 0 | 0);
  global$0 = $1 + 336 | 0;
 }
 
 function __wbg_transactionunspentoutput_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 176 | 0;
  global$0 = $1;
  $cardano_serialization_lib__utils__TransactionUnspentOutput_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h5cd26c8e164e5e75($1 + 8 | 0 | 0, $0 | 0);
  core__ptr__drop_in_place_cardano_serialization_lib__utils__TransactionUnspentOutput___h3ebb7f0562e4e672($1 + 8 | 0 | 0);
  global$0 = $1 + 176 | 0;
 }
 
 function $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810($0, $0$hi) {
  $0 = $0 | 0;
  $0$hi = $0$hi | 0;
  var $1 = 0, i64toi32_i32$0 = 0;
  label$1 : {
   $1 = __rust_alloc(16 | 0, 8 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(16 | 0, 8 | 0);
   abort();
  }
  i64toi32_i32$0 = $0$hi;
  HEAP32[($1 + 8 | 0) >> 2] = $0;
  HEAP32[($1 + 12 | 0) >> 2] = i64toi32_i32$0;
  HEAP32[$1 >> 2] = 0;
  return $1 | 0;
 }
 
 function core__ptr__drop_in_place_cardano_serialization_lib__ProtocolParamUpdate___h92eeb91cabd2847d_1($0) {
  $0 = $0 | 0;
  label$1 : {
   if (!(HEAP32[($0 + 320 | 0) >> 2] | 0)) {
    break label$1
   }
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h1737752c75bae0f3($0 + 320 | 0 | 0);
  }
  label$2 : {
   if (!(HEAP32[($0 + 332 | 0) >> 2] | 0)) {
    break label$2
   }
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h5f5dc70d320637e0($0 + 336 | 0 | 0);
  }
 }
 
 function __wbg_transactionbuilder_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 528 | 0;
  global$0 = $1;
  $cardano_serialization_lib__tx_builder__TransactionBuilder_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h760cc738c646cf3e($1 + 8 | 0 | 0, $0 | 0);
  core__ptr__drop_in_place_cardano_serialization_lib__tx_builder__TransactionBuilder___h053801e638e30160($1 + 8 | 0 | 0);
  global$0 = $1 + 528 | 0;
 }
 
 function core__ptr__drop_in_place_cardano_serialization_lib__chain_crypto__bech32__Error___hc63804c7ffa39d5a($0) {
  $0 = $0 | 0;
  label$1 : {
   switch (HEAP32[$0 >> 2] | 0 | 0) {
   default:
    core__ptr__drop_in_place_alloc__boxed__Box_dyn_20std__error__Error_core__marker__Sync_core__marker__Send____h3635675e5a953b32($0 + 4 | 0 | 0);
   case 0:
    return;
   case 1:
    break label$1;
   };
  }
  $0 = $0 + 12 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
 }
 
 function nonce_new_identity() {
  var $0 = 0, $1 = 0;
  $0 = global$0 - 48 | 0;
  global$0 = $0;
  HEAP8[($0 + 8 | 0) >> 0] = 0;
  $1 = $cardano_serialization_lib__crypto__Nonce_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h3e2dae3d5c688227($0 + 8 | 0 | 0) | 0;
  global$0 = $0 + 48 | 0;
  return $1 | 0;
 }
 
 function __wbg_byronaddress_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 64 | 0;
  global$0 = $1;
  $cardano_serialization_lib__address__ByronAddress_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h2a0117dae22798e7($1 + 8 | 0 | 0, $0 | 0);
  core__ptr__drop_in_place_cardano_serialization_lib__legacy_address__address__ExtendedAddr___h2c1a18aefeee766f($1 + 8 | 0 | 0);
  global$0 = $1 + 64 | 0;
 }
 
 function $cardano_serialization_lib__plutus__RedeemerTag_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h6e4777f9244e5b69($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = __rust_alloc(8 | 0, 4 | 0) | 0;
   if ($1) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(8 | 0, 4 | 0);
   abort();
  }
  HEAP8[($1 + 4 | 0) >> 0] = $0;
  HEAP32[$1 >> 2] = 0;
  return $1 | 0;
 }
 
 function $cardano_serialization_lib__legacy_address__address__AddrType_20as_20cbor_event__se__Serialize___serialize__hfd384f59239299b2($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, $3 = 0, $3$hi = 0;
  i64toi32_i32$0 = 0;
  $3 = 0;
  $3$hi = i64toi32_i32$0;
  label$1 : {
   label$2 : {
    switch (HEAPU8[$1 >> 0] | 0 | 0) {
    case 1:
     i64toi32_i32$0 = 0;
     $3 = 1;
     $3$hi = i64toi32_i32$0;
     break label$1;
    case 2:
     break label$2;
    default:
     break label$1;
    };
   }
   i64toi32_i32$0 = 0;
   $3 = 2;
   $3$hi = i64toi32_i32$0;
  }
  i64toi32_i32$0 = $3$hi;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($0 | 0, $2 | 0, 0 | 0, $3 | 0, i64toi32_i32$0 | 0);
 }
 
 function std__panicking__begin_panic___7b_7bclosure_7d_7d__h87b5758e0a383391($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 12 | 0) >> 2] = i64toi32_i32$1;
  std__panicking__rust_panic_with_hook__he9bfe03219d715ba($1 + 8 | 0 | 0, 1077200 | 0, 0 | 0, HEAP32[($0 + 8 | 0) >> 2] | 0 | 0);
  abort();
 }
 
 function std__panicking__begin_panic__hf55b754840077f11($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  (wasm2js_i32$0 = $3, wasm2js_i32$1 = core__panic__Location__caller__h274818dd12799e10($2 | 0) | 0), HEAP32[(wasm2js_i32$0 + 8 | 0) >> 2] = wasm2js_i32$1;
  HEAP32[($3 + 4 | 0) >> 2] = $1;
  HEAP32[$3 >> 2] = $0;
  std__sys_common__backtrace____rust_end_short_backtrace__h75f570b2d951b191($3 | 0);
  abort();
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__Internal__2calloc__collections__btree__node__marker__Edge___descend__h3e2a2cdd3746a926($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  HEAP32[$0 >> 2] = (HEAP32[$1 >> 2] | 0) + -1 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = HEAP32[(((HEAP32[($1 + 4 | 0) >> 2] | 0) + ((HEAP32[($1 + 8 | 0) >> 2] | 0) << 2 | 0) | 0) + 408 | 0) >> 2] | 0;
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___ensure_is_owned__h192fdf462a287fc7($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   if (HEAP32[($0 + 4 | 0) >> 2] | 0) {
    break label$1
   }
   $1 = alloc__boxed__Box_T_2cA___new_uninit_in__h8a2711313b9ea9b8() | 0;
   HEAP16[($1 + 402 | 0) >> 1] = 0;
   HEAP32[($1 + 264 | 0) >> 2] = 0;
   HEAP32[($0 + 4 | 0) >> 2] = $1;
   HEAP32[$0 >> 2] = 0;
  }
  return $0 | 0;
 }
 
 function std__panicking__begin_panic___7b_7bclosure_7d_7d__h116b254b03f8479b($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 12 | 0) >> 2] = i64toi32_i32$1;
  std__panicking__rust_panic_with_hook__he9bfe03219d715ba($1 + 8 | 0 | 0, 1139092 | 0, 0 | 0, HEAP32[($0 + 8 | 0) >> 2] | 0 | 0);
  abort();
 }
 
 function std__panicking__begin_panic__h7de1da834ae32d4b($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  (wasm2js_i32$0 = $3, wasm2js_i32$1 = core__panic__Location__caller__h274818dd12799e10($2 | 0) | 0), HEAP32[(wasm2js_i32$0 + 8 | 0) >> 2] = wasm2js_i32$1;
  HEAP32[($3 + 4 | 0) >> 2] = $1;
  HEAP32[$3 >> 2] = $0;
  std__sys_common__backtrace____rust_end_short_backtrace__hedea918946d28cea($3 | 0);
  abort();
 }
 
 function std__panicking__begin_panic__h7867d4da632f3661($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var $3 = 0, wasm2js_i32$0 = 0, wasm2js_i32$1 = 0;
  $3 = global$0 - 16 | 0;
  global$0 = $3;
  (wasm2js_i32$0 = $3, wasm2js_i32$1 = core__panic__Location__caller__h274818dd12799e10($2 | 0) | 0), HEAP32[(wasm2js_i32$0 + 8 | 0) >> 2] = wasm2js_i32$1;
  HEAP32[($3 + 4 | 0) >> 2] = $1;
  HEAP32[$3 >> 2] = $0;
  std__sys_common__backtrace____rust_end_short_backtrace__h07554449d90848f3($3 | 0);
  abort();
 }
 
 function std__panicking__begin_panic___7b_7bclosure_7d_7d__h29d8e4472f2e2dbe($0) {
  $0 = $0 | 0;
  var $1 = 0, i64toi32_i32$1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  i64toi32_i32$1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  HEAP32[($1 + 8 | 0) >> 2] = HEAP32[$0 >> 2] | 0;
  HEAP32[($1 + 12 | 0) >> 2] = i64toi32_i32$1;
  std__panicking__rust_panic_with_hook__he9bfe03219d715ba($1 + 8 | 0 | 0, 1144368 | 0, 0 | 0, HEAP32[($0 + 8 | 0) >> 2] | 0 | 0);
  abort();
 }
 
 function core__fmt__num__imp___impl_20core__fmt__Display_20for_20i32___fmt__hc7b987a91b743964($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$5 = 0, i64toi32_i32$3 = 0, i64toi32_i32$2 = 0, i64toi32_i32$4 = 0, $5 = 0, $5$hi = 0, $9$hi = 0;
  $0 = HEAP32[$0 >> 2] | 0;
  i64toi32_i32$0 = 0;
  $5 = $0;
  $5$hi = i64toi32_i32$0;
  i64toi32_i32$1 = $0 ^ -1 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 >> 31 | 0;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 1;
  i64toi32_i32$4 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$1 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $9$hi = i64toi32_i32$5;
  $0 = ($0 | 0) > (-1 | 0);
  i64toi32_i32$1 = $0;
  i64toi32_i32$5 = $5$hi;
  i64toi32_i32$2 = $9$hi;
  i64toi32_i32$3 = $0 ? $5 : i64toi32_i32$4;
  i64toi32_i32$0 = $0 ? i64toi32_i32$5 : i64toi32_i32$2;
  return core__fmt__num__imp__fmt_u64__hf0469431dace4046(i64toi32_i32$3 | 0, i64toi32_i32$0 | 0, $0 | 0, $1 | 0) | 0 | 0;
 }
 
 function core__ptr__drop_in_place_cardano_serialization_lib__address__Address___ha7ee337124a79b19($0) {
  $0 = $0 | 0;
  label$1 : {
   if ((HEAPU8[$0 >> 0] | 0) >>> 0 < 4 >>> 0) {
    break label$1
   }
   $0 = $0 + 4 | 0;
   if (!(HEAP32[$0 >> 2] | 0)) {
    break label$1
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
  }
 }
 
 function serde_json__ser__format_escaped_str__h36c322c8ecbdeb72($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var i64toi32_i32$0 = 0, $4 = 0, i64toi32_i32$1 = 0;
  $4 = HEAP32[$0 >> 2] | 0;
  alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($4 | 0, 1068473 | 0, 1 | 0);
  i64toi32_i32$0 = serde_json__ser__format_escaped_str_contents__h319080b8e6932140($0 | 0, $0 | 0, $2 | 0, $3 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($4 | 0, 1068473 | 0, 1 | 0);
  i64toi32_i32$1 = 0;
  i64toi32_i32$0 = 4;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$1;
  return i64toi32_i32$0 | 0;
 }
 
 function $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h970b13f6299e0f2d($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $1 = $1 << 2 | 0;
   if (!$1) {
    break label$1
   }
   __rust_dealloc(HEAP32[$0 >> 2] | 0 | 0, $1 | 0, 4 | 0);
  }
 }
 
 function $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h515a508dccfbb69c($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $1 = $1 << 2 | 0;
   if (!$1) {
    break label$1
   }
   __rust_dealloc(HEAP32[$0 >> 2] | 0 | 0, $1 | 0, 4 | 0);
  }
 }
 
 function $serde_json__de__MapAccess_R__20as_20serde__de__MapAccess___next_value_seed__hacf927117f4e5996($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[$1 >> 2] | 0;
   $1 = serde_json__de__Deserializer_R___parse_object_colon__h753bf1256f280e80($2 | 0) | 0;
   if ($1) {
    break label$1
   }
   $_mut_20serde_json__de__Deserializer_R__20as_20serde__de__Deserializer___deserialize_any__hd0def79dc4acfc54($0 | 0, $2 | 0);
   return;
  }
  HEAP32[$0 >> 2] = 1;
  HEAP32[($0 + 4 | 0) >> 2] = $1;
 }
 
 function serde_json__value__from___impl_20core__convert__From_alloc__string__String__20for_20serde_json__value__Value___from__h17ccd46b161e8e23($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $6 = 0;
  HEAP8[$0 >> 0] = 3;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $6 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 4 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $6;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
 }
 
 function serde_json__value__from___impl_20core__convert__From_serde_json__map__Map_alloc__string__String_2cserde_json__value__Value___20for_20serde_json__value__Value___from__hd445317c7fcd41f3($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $6 = 0;
  HEAP8[$0 >> 0] = 5;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $6 = i64toi32_i32$0;
  i64toi32_i32$0 = $0 + 4 | 0;
  HEAP32[i64toi32_i32$0 >> 2] = $6;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($0 + 12 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
 }
 
 function $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h55384607e9cf45ad($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $1 = Math_imul($1, 24);
   if (!$1) {
    break label$1
   }
   __rust_dealloc(HEAP32[$0 >> 2] | 0 | 0, $1 | 0, 8 | 0);
  }
 }
 
 function cbor_event__types__Type__to_byte__h30363627277739c1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (($1 & 255 | 0) >>> 0 < 32 >>> 0) {
    break label$1
   }
   core__panicking__panic__h2fd385a887c8bf13(1139800 | 0, 36 | 0, 1139932 | 0);
   abort();
  }
  return $0 << 5 | 0 | $1 | 0 | 0;
 }
 
 function wasm_bindgen____rt__take_last_exception__h00302a7bf129f841($0) {
  $0 = $0 | 0;
  var i64toi32_i32$1 = 0, $1 = 0, $2 = 0;
  $1 = HEAP32[(0 + 1177764 | 0) >> 2] | 0;
  $2 = HEAP32[(0 + 1177768 | 0) >> 2] | 0;
  i64toi32_i32$1 = 0;
  HEAP32[(i64toi32_i32$1 + 1177764 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 1177768 | 0) >> 2] = 0;
  HEAP32[($0 + 4 | 0) >> 2] = $2;
  HEAP32[$0 >> 2] = ($1 | 0) == (1 | 0);
 }
 
 function core__ptr__drop_in_place_std__error___impl_20core__convert__From_alloc__string__String__20for_20alloc__boxed__Box_dyn_20std__error__Error_core__marker__Sync_core__marker__Send____from__StringError___h52d6038e8d6d32cd($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[$0 >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if (!$0) {
    break label$1
   }
   __rust_dealloc($1 | 0, $0 | 0, 1 | 0);
  }
 }
 
 function core__ptr__drop_in_place_std__panicking__begin_panic_handler__PanicPayload___hb3bb8c9b27bd594e($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   $0 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (!$0) {
    break label$1
   }
   __rust_dealloc($1 | 0, $0 | 0, 1 | 0);
  }
 }
 
 function rust_panic($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = global$0 - 16 | 0;
  global$0 = $2;
  HEAP32[($2 + 12 | 0) >> 2] = $1;
  HEAP32[($2 + 8 | 0) >> 2] = $0;
  __rust_start_panic($2 + 8 | 0 | 0) | 0;
  abort();
 }
 
 function dlmalloc__dlmalloc__Segment__holds__h401eff113aa2fd65($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0, $3 = 0;
  $2 = 0;
  label$1 : {
   $3 = HEAP32[$0 >> 2] | 0;
   if ($3 >>> 0 > $1 >>> 0) {
    break label$1
   }
   $2 = ($3 + (HEAP32[($0 + 4 | 0) >> 2] | 0) | 0) >>> 0 > $1 >>> 0;
  }
  return $2 | 0;
 }
 
 function core__ptr__drop_in_place_core__result__Result_cardano_serialization_lib__ScriptAll_2ccardano_serialization_lib__error__DeserializeError____hbd880b968031b052($0) {
  $0 = $0 | 0;
  label$1 : {
   if (HEAP32[$0 >> 2] | 0) {
    break label$1
   }
   $0 = $0 + 4 | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc3d6ec99c05cee40($0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h0f78886c344617d4($0 | 0);
   return;
  }
  core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9($0 + 8 | 0 | 0);
 }
 
 function core__ptr__drop_in_place_core__result__Result_cardano_serialization_lib__ScriptAny_2ccardano_serialization_lib__error__DeserializeError____h226dd032529da919($0) {
  $0 = $0 | 0;
  label$1 : {
   if (HEAP32[$0 >> 2] | 0) {
    break label$1
   }
   $0 = $0 + 4 | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc3d6ec99c05cee40($0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h0f78886c344617d4($0 | 0);
   return;
  }
  core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9($0 + 8 | 0 | 0);
 }
 
 function core__ptr__drop_in_place_core__result__Result_cardano_serialization_lib__MultiHostName_2ccardano_serialization_lib__error__DeserializeError____hebb1c6f92c0f8b11($0) {
  $0 = $0 | 0;
  label$1 : {
   if (HEAP32[$0 >> 2] | 0) {
    break label$1
   }
   $0 = $0 + 4 | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
   return;
  }
  core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9($0 + 8 | 0 | 0);
 }
 
 function core__ptr__drop_in_place_core__result__Result_cardano_serialization_lib__SingleHostName_2ccardano_serialization_lib__error__DeserializeError____hacb89d209b69983b($0) {
  $0 = $0 | 0;
  label$1 : {
   if (HEAP32[$0 >> 2] | 0) {
    break label$1
   }
   $0 = $0 + 4 | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
   return;
  }
  core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9($0 + 8 | 0 | 0);
 }
 
 function __wbg_certificates_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__Certificates_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h8f099e7b0499b7a3($1 | 0, $0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h07097b699c9c8f63($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__ha1b43c51acf8124f($1 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function __wbg_relays_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__Relays_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hd94de6e40e898f19($1 | 0, $0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hb600accf9d1c2a17($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h96b3170d440e3692($1 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function __wbg_url_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__URL_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h0b027dceb3465fa8($1 | 0, $0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function __wbg_dnsrecordaoraaaa_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__DNSRecordAorAAAA_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hc4f20f912382f9ac($1 | 0, $0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function __wbg_dnsrecordsrv_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__DNSRecordSRV_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h8f84187837c24089($1 | 0, $0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function __wbg_singlehostname_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__SingleHostName_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h59b8927a0bd593b1($1 | 0, $0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function __wbg_multihostname_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__MultiHostName_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h328453487bb71b9d($1 | 0, $0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function __wbg_poolmetadata_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  $cardano_serialization_lib__PoolMetadata_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h21c8a276cf9d0035($1 | 0, $0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  global$0 = $1 + 48 | 0;
 }
 
 function __wbg_scriptall_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__ScriptAll_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h69640ba2c20af1f4($1 | 0, $0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc3d6ec99c05cee40($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h0f78886c344617d4($1 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function __wbg_scriptany_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__ScriptAny_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h860535ffc5169bd5($1 | 0, $0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc3d6ec99c05cee40($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h0f78886c344617d4($1 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function __wbg_nativescripts_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__NativeScripts_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h0ac513c0d46c16e0($1 | 0, $0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc3d6ec99c05cee40($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h0f78886c344617d4($1 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function __wbg_transactionbodies_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__TransactionBodies_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h03066b841682f9b2($1 | 0, $0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h86cdf7dca21c8b48($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h7ca18c2b7d174864($1 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function __wbg_transactionwitnesssets_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__TransactionWitnessSets_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h47439a7417855d0d($1 | 0, $0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h50c1f6d5a01d91ba($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h0a3e4540c50cd990($1 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function __wbg_assetname_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__AssetName_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h47e91eaa082cd83a($1 | 0, $0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function __wbg_assetnames_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__AssetNames_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h4f6eb653cae27250($1 | 0, $0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__he37b42ff2b07ed41($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h19d691521e7c48e6($1 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function assets_new() {
  var $0 = 0, $1 = 0;
  $0 = global$0 - 16 | 0;
  global$0 = $0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  $1 = $cardano_serialization_lib__Assets_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hf61728444da3586d($0 | 0) | 0;
  global$0 = $0 + 16 | 0;
  return $1 | 0;
 }
 
 function multiasset_new() {
  var $0 = 0, $1 = 0;
  $0 = global$0 - 16 | 0;
  global$0 = $0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  $1 = $cardano_serialization_lib__MultiAsset_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__he6031c139f7594ac($0 | 0) | 0;
  global$0 = $0 + 16 | 0;
  return $1 | 0;
 }
 
 function mintassets_new() {
  var $0 = 0, $1 = 0;
  $0 = global$0 - 16 | 0;
  global$0 = $0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  $1 = $cardano_serialization_lib__MintAssets_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h828d55d3b5b95763($0 | 0) | 0;
  global$0 = $0 + 16 | 0;
  return $1 | 0;
 }
 
 function mint_new() {
  var $0 = 0, $1 = 0;
  $0 = global$0 - 16 | 0;
  global$0 = $0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  $1 = $cardano_serialization_lib__Mint_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8fa2adeb6e27a027($0 | 0) | 0;
  global$0 = $0 + 16 | 0;
  return $1 | 0;
 }
 
 function hashbrown__raw__Bucket_T___drop__ha8e556007b2a95eb($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $0 = HEAP32[$0 >> 2] | 0;
  $1 = $0 + -24 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  $0 = $0 + -12 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
 }
 
 function __wbg_bigint_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__utils__BigInt_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h357e7bbb28b1e3e1($1 | 0, $0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h19f76bdb6b4883ef($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h970b13f6299e0f2d($1 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function __wbg_bootstrapwitnesses_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__crypto__BootstrapWitnesses_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h2fdd75b2a1d8f23b($1 | 0, $0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h28dc4dde55fe2f07($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h79e8c51775f4d5f8($1 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function __wbg_kessignature_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__crypto__KESSignature_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h02d886869b7129a6($1 | 0, $0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function __wbg_plutuswitnesses_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__tx_builder__tx_inputs_builder__PlutusWitnesses_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h866260b7595d8928($1 | 0, $0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h1bbffe174ae872d8($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h9b1d3bb47b46eeb8($1 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function __wbg_plutusscript_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__plutus__PlutusScript_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__he5f731d402530c18($1 | 0, $0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function __wbg_plutusscripts_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__plutus__PlutusScripts_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h09ea19d5ec38c396($1 | 0, $0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd4b44cb226d8311d($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h3633100df9c96e1e($1 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function costmdls_new() {
  var $0 = 0, $1 = 0;
  $0 = global$0 - 16 | 0;
  global$0 = $0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  $1 = $cardano_serialization_lib__plutus__Costmdls_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h8003415a0e008f0e($0 | 0) | 0;
  global$0 = $0 + 16 | 0;
  return $1 | 0;
 }
 
 function plutusmap_new() {
  var $0 = 0, $1 = 0;
  $0 = global$0 - 16 | 0;
  global$0 = $0;
  HEAP32[($0 + 4 | 0) >> 2] = 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  $1 = $cardano_serialization_lib__plutus__PlutusMap_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hc959583e66b458a0($0 | 0) | 0;
  global$0 = $0 + 16 | 0;
  return $1 | 0;
 }
 
 function __wbg_redeemer_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  $cardano_serialization_lib__plutus__Redeemer_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hbcdc67bff96edc1d($1 | 0, $0 | 0);
  core__ptr__drop_in_place_cardano_serialization_lib__plutus__PlutusData___hfab843e66e0f9428_1($1 + 8 | 0 | 0);
  global$0 = $1 + 80 | 0;
 }
 
 function __wbg_strings_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__plutus__Strings_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h602d16eb9eff76e7($1 | 0, $0 | 0);
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__ha86416daa7863b38($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h1f8037d956efeb38($1 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function core__slice___impl_20_5bT_5d___copy_from_slice__h0f69c19ed1852955($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  label$1 : {
   if (($1 | 0) != ($3 | 0)) {
    break label$1
   }
   memcpy($0 | 0, $2 | 0, $1 | 0) | 0;
   return;
  }
  core__slice___impl_20_5bT_5d___copy_from_slice__len_mismatch_fail__h13bf5a0e1407b14d($1 | 0, $3 | 0, 1103120 | 0);
  abort();
 }
 
 function __wbindgen_realloc($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  label$1 : {
   label$2 : {
    if ($1 >>> 0 > -4 >>> 0) {
     break label$2
    }
    $1 = __rust_realloc($0 | 0, $1 | 0, 4 | 0, $2 | 0) | 0;
    if ($1) {
     break label$1
    }
   }
   wasm_bindgen____rt__malloc_failure__h5d7f43e474eb159a();
   abort();
  }
  return $1 | 0;
 }
 
 function dlmalloc__dlmalloc__Chunk__set_free_with_pinuse__hb6fcf1321e8edd9b($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  HEAP32[($2 + 4 | 0) >> 2] = (HEAP32[($2 + 4 | 0) >> 2] | 0) & -2 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $1 | 1 | 0;
  HEAP32[($0 + $1 | 0) >> 2] = $1;
 }
 
 function core__fmt__Formatter__debug_struct__h873400a11fe69724($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, i64toi32_i32$2 = 0, $12$hi = 0, $14$hi = 0;
  i64toi32_i32$4 = FUNCTION_TABLE[HEAP32[((HEAP32[($0 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($0 + 24 | 0) >> 2] | 0, $1, $2) | 0;
  i64toi32_i32$3 = i64toi32_i32$4 ? 0 : 0;
  i64toi32_i32$2 = i64toi32_i32$4 ? 1 : 0;
  $12$hi = i64toi32_i32$2;
  i64toi32_i32$2 = 0;
  $14$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $12$hi;
  i64toi32_i32$4 = i64toi32_i32$3;
  i64toi32_i32$3 = $14$hi;
  i64toi32_i32$3 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$4 | $0 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$3;
  return i64toi32_i32$4 | 0;
 }
 
 function core__fmt__Formatter__debug_list__h7939d45dcba19956($0) {
  $0 = $0 | 0;
  var i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, i64toi32_i32$2 = 0, $8$hi = 0, $10$hi = 0;
  i64toi32_i32$4 = FUNCTION_TABLE[HEAP32[((HEAP32[($0 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($0 + 24 | 0) >> 2] | 0, 1149900, 1) | 0;
  i64toi32_i32$3 = i64toi32_i32$4 ? 0 : 0;
  i64toi32_i32$2 = i64toi32_i32$4 ? 1 : 0;
  $8$hi = i64toi32_i32$2;
  i64toi32_i32$2 = 0;
  $10$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$4 = i64toi32_i32$3;
  i64toi32_i32$3 = $10$hi;
  i64toi32_i32$3 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$4 | $0 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$3;
  return i64toi32_i32$4 | 0;
 }
 
 function core__fmt__Formatter__debug_map__hf479166f65445ffd($0) {
  $0 = $0 | 0;
  var i64toi32_i32$4 = 0, i64toi32_i32$3 = 0, i64toi32_i32$2 = 0, $8$hi = 0, $10$hi = 0;
  i64toi32_i32$4 = FUNCTION_TABLE[HEAP32[((HEAP32[($0 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($0 + 24 | 0) >> 2] | 0, 1149899, 1) | 0;
  i64toi32_i32$3 = i64toi32_i32$4 ? 0 : 0;
  i64toi32_i32$2 = i64toi32_i32$4 ? 16777217 : 16777216;
  $8$hi = i64toi32_i32$2;
  i64toi32_i32$2 = 0;
  $10$hi = i64toi32_i32$2;
  i64toi32_i32$2 = $8$hi;
  i64toi32_i32$4 = i64toi32_i32$3;
  i64toi32_i32$3 = $10$hi;
  i64toi32_i32$3 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  i64toi32_i32$4 = i64toi32_i32$4 | $0 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$3;
  return i64toi32_i32$4 | 0;
 }
 
 function core__ptr__drop_in_place_core__result__Result_cardano_serialization_lib__ScriptNOfK_2ccardano_serialization_lib__error__DeserializeError____h17201b751208cb38($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = $0 + 8 | 0;
  label$1 : {
   if (HEAP32[$0 >> 2] | 0) {
    break label$1
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc3d6ec99c05cee40($1 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h0f78886c344617d4($1 | 0);
   return;
  }
  core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9($1 | 0);
 }
 
 function core__ptr__drop_in_place_core__result__Result_cardano_serialization_lib__MoveInstantaneousRewardsCert_2ccardano_serialization_lib__error__DeserializeError____h3f599aafe2c15b13($0) {
  $0 = $0 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, $1 = 0, i64toi32_i32$1 = 0;
  $1 = $0 + 8 | 0;
  label$1 : {
   i64toi32_i32$2 = $0;
   i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
   i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
   i64toi32_i32$2 = i64toi32_i32$0;
   i64toi32_i32$0 = 0;
   if ((i64toi32_i32$2 | 0) != (0 | 0) | (i64toi32_i32$1 | 0) != (i64toi32_i32$0 | 0) | 0) {
    break label$1
   }
   core__ptr__drop_in_place_cardano_serialization_lib__MIREnum___h06315a825cbe6fa9($1 | 0);
   return;
  }
  core__ptr__drop_in_place_cardano_serialization_lib__error__DeserializeError___hae75ef80cdb806d9($1 | 0);
 }
 
 function core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__Withdrawals____heaf2605773ce1c75($0) {
  $0 = $0 | 0;
  label$1 : {
   if (!(HEAP32[($0 + 20 | 0) >> 2] | 0)) {
    break label$1
   }
   $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__h16511d8898c4755a($0 | 0);
   if (!(HEAP32[($0 + 16 | 0) >> 2] | 0)) {
    break label$1
   }
   hashbrown__raw__RawTable_T_2cA___free_buckets__h04a09610ca2977a1($0 + 16 | 0 | 0);
  }
 }
 
 function core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__Update____hc1ce6150a8713009($0) {
  $0 = $0 | 0;
  label$1 : {
   if (!(HEAP32[($0 + 20 | 0) >> 2] | 0)) {
    break label$1
   }
   $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__h88c250e8947434a9($0 | 0);
   if (!(HEAP32[($0 + 16 | 0) >> 2] | 0)) {
    break label$1
   }
   hashbrown__raw__RawTable_T_2cA___free_buckets__ha5e2f3faac433f39($0 + 16 | 0 | 0);
  }
 }
 
 function core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $0 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$0 >> 2] | 0 | 0) | 0;
  label$1 : {
   if (!$1) {
    break label$1
   }
   __rust_dealloc($0 | 0, $1 | 0, 1 | 0);
  }
 }
 
 function core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__metadata__GeneralTransactionMetadata____h37a091753d7f028f($0) {
  $0 = $0 | 0;
  label$1 : {
   if (!(HEAP32[($0 + 20 | 0) >> 2] | 0)) {
    break label$1
   }
   $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__he275f3eb7df08493($0 | 0);
   if (!(HEAP32[($0 + 16 | 0) >> 2] | 0)) {
    break label$1
   }
   hashbrown__raw__RawTable_T_2cA___free_buckets__hfa29170569415d6b($0 + 16 | 0 | 0);
  }
 }
 
 function core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_1($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $0 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$0 >> 2] | 0 | 0) | 0;
  label$1 : {
   if (!$1) {
    break label$1
   }
   __rust_dealloc($0 | 0, $1 | 0, 1 | 0);
  }
 }
 
 function $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__he275f3eb7df08493($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 32 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   linked_hash_map__LinkedHashMap_K_2cV_2cS___drop_entries__h1abc9c1319548d23($0 | 0);
   __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 64 | 0, 8 | 0);
  }
  linked_hash_map__LinkedHashMap_K_2cV_2cS___clear_free_list__h20fcb5b84a9220ce($0 | 0);
 }
 
 function $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__h16511d8898c4755a($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 32 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   linked_hash_map__LinkedHashMap_K_2cV_2cS___drop_entries__h0f365ed47268b966($0 | 0);
   __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 48 | 0, 8 | 0);
  }
  linked_hash_map__LinkedHashMap_K_2cV_2cS___clear_free_list__h8c886adc889b8efe($0 | 0);
 }
 
 function $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__h53e9081b9841de3b($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 32 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   linked_hash_map__LinkedHashMap_K_2cV_2cS___drop_entries__h7c21284b35a5a639($0 | 0);
   __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 192 | 0, 8 | 0);
  }
  linked_hash_map__LinkedHashMap_K_2cV_2cS___clear_free_list__hb918ae2ca861e503($0 | 0);
 }
 
 function $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__h65524c00492b1305($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 32 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   linked_hash_map__LinkedHashMap_K_2cV_2cS___drop_entries__h6212a14c640f8f83($0 | 0);
   __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 80 | 0, 8 | 0);
  }
  linked_hash_map__LinkedHashMap_K_2cV_2cS___clear_free_list__h8d5b3e27f5251a17($0 | 0);
 }
 
 function $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__h88c250e8947434a9($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 32 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   linked_hash_map__LinkedHashMap_K_2cV_2cS___drop_entries__h37111127d817c283($0 | 0);
   __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 448 | 0, 8 | 0);
  }
  linked_hash_map__LinkedHashMap_K_2cV_2cS___clear_free_list__h4fa6a5e39af959e5($0 | 0);
 }
 
 function $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__hddd2979ebb13db27($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 32 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   linked_hash_map__LinkedHashMap_K_2cV_2cS___drop_entries__h32fed5f9b7f36227($0 | 0);
   __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($1 | 0) | 0 | 0, 56 | 0, 8 | 0);
  }
  linked_hash_map__LinkedHashMap_K_2cV_2cS___clear_free_list__ha63e4fc7bda9e0cd($0 | 0);
 }
 
 function core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__metadata__GeneralTransactionMetadata____h37a091753d7f028f_1($0) {
  $0 = $0 | 0;
  label$1 : {
   if (!(HEAP32[($0 + 20 | 0) >> 2] | 0)) {
    break label$1
   }
   $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__he275f3eb7df08493($0 | 0);
   if (!(HEAP32[($0 + 16 | 0) >> 2] | 0)) {
    break label$1
   }
   hashbrown__raw__RawTable_T_2cA___free_buckets__hfa29170569415d6b($0 + 16 | 0 | 0);
  }
 }
 
 function core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__Withdrawals____heaf2605773ce1c75_1($0) {
  $0 = $0 | 0;
  label$1 : {
   if (!(HEAP32[($0 + 20 | 0) >> 2] | 0)) {
    break label$1
   }
   $linked_hash_map__LinkedHashMap_K_2cV_2cS__20as_20core__ops__drop__Drop___drop__h16511d8898c4755a($0 | 0);
   if (!(HEAP32[($0 + 16 | 0) >> 2] | 0)) {
    break label$1
   }
   hashbrown__raw__RawTable_T_2cA___free_buckets__h04a09610ca2977a1($0 + 16 | 0 | 0);
  }
 }
 
 function core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_2($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $0 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$0 >> 2] | 0 | 0) | 0;
  label$1 : {
   if (!$1) {
    break label$1
   }
   __rust_dealloc($0 | 0, $1 | 0, 1 | 0);
  }
 }
 
 function core__ptr__drop_in_place_alloc__boxed__Box__5bu8_5d____h1049615268b5f7c4($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $0 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$0 >> 2] | 0 | 0) | 0;
  label$1 : {
   if (!$1) {
    break label$1
   }
   __rust_dealloc($0 | 0, $1 | 0, 1 | 0);
  }
 }
 
 function core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_3($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $0 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$0 >> 2] | 0 | 0) | 0;
  label$1 : {
   if (!$1) {
    break label$1
   }
   __rust_dealloc($0 | 0, $1 | 0, 1 | 0);
  }
 }
 
 function core__ptr__drop_in_place_alloc__boxed__Box_str____h1b4f7ba3c039dec0_4($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  $0 = $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$0 >> 2] | 0 | 0) | 0;
  label$1 : {
   if (!$1) {
    break label$1
   }
   __rust_dealloc($0 | 0, $1 | 0, 1 | 0);
  }
 }
 
 function $cardano_serialization_lib__plutus__Language_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h686a48dad777e160() {
  var $0 = 0;
  label$1 : {
   $0 = __rust_alloc(4 | 0, 4 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   alloc__alloc__handle_alloc_error__he269d8f1bff90960(4 | 0, 4 | 0);
   abort();
  }
  HEAP32[$0 >> 2] = 0;
  return $0 | 0;
 }
 
 function wasm_bindgen__convert__closures__invoke4_mut__hfbfcfbb1cf4e323a($0, $1, $2, $3, $4, $5) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  $5 = $5 | 0;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen__throw_str__h40ff0247f6a635d7(1076516 | 0, 48 | 0);
   abort();
  }
  return FUNCTION_TABLE[HEAP32[($1 + 12 | 0) >> 2] | 0 | 0]($0, $2, $3, $4, $5) | 0 | 0;
 }
 
 function num_bigint__biguint__subtraction___impl_20core__ops__arith__Sub__num_bigint__biguint__BigUint__20for_20num_bigint__biguint__BigUint___sub__hac2d36d0edc5bcae($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $12 = 0;
  num_bigint__biguint__subtraction___impl_20core__ops__arith__SubAssign__num_bigint__biguint__BigUint__20for_20num_bigint__biguint__BigUint___sub_assign__h4ea1a97f3b7bcde9($1 | 0, $2 | 0);
  HEAP32[($0 + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $12 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $12;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
 }
 
 function serde_json__value__from___impl_20core__convert__From_i64__20for_20serde_json__value__Value___from__hddac0ae92fa83545($0, $1, $1$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $1$hi = $1$hi | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, $9 = 0, $7 = 0;
  HEAP8[$0 >> 0] = 2;
  i64toi32_i32$0 = $1$hi;
  i64toi32_i32$1 = $0 + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $1;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  $7 = $0 + 8 | 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 63;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $9 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $9 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  i64toi32_i32$2 = $7;
  HEAP32[i64toi32_i32$2 >> 2] = $9;
  HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] = i64toi32_i32$1;
 }
 
 function core__iter__adapters__enumerate__Enumerate_I___new__h104ad29fe8f300cf($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0;
  HEAP32[($0 + 12 | 0) >> 2] = 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  HEAP32[$0 >> 2] = HEAP32[$1 >> 2] | 0;
  HEAP32[($0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[($0 + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
 }
 
 function core__fmt__num__imp___impl_20core__fmt__Display_20for_20i64___fmt__h555ee0b859ae0d36($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$5 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, i64toi32_i32$2 = 0, $3$hi = 0, $17 = 0, $3 = 0, $18 = 0, $19 = 0, $20 = 0, $2 = 0, $2$hi = 0, $6 = 0, $6$hi = 0, $10$hi = 0, $12 = 0, $12$hi = 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $2 = i64toi32_i32$0;
  $2$hi = i64toi32_i32$1;
  $6 = i64toi32_i32$0;
  $6$hi = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 63;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$1 >> 31 | 0;
   $17 = i64toi32_i32$1 >> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$1 >> i64toi32_i32$4 | 0;
   $17 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  $3 = $17;
  $3$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $6$hi;
  i64toi32_i32$1 = $6;
  i64toi32_i32$2 = $3$hi;
  i64toi32_i32$3 = $3;
  i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$3 | 0;
  i64toi32_i32$5 = i64toi32_i32$0 + i64toi32_i32$2 | 0;
  if (i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0) {
   i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
  }
  $10$hi = i64toi32_i32$5;
  i64toi32_i32$5 = $3$hi;
  i64toi32_i32$5 = $10$hi;
  i64toi32_i32$0 = i64toi32_i32$4;
  i64toi32_i32$1 = $3$hi;
  i64toi32_i32$3 = $3;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$1 | 0;
  $12 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  $12$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $2$hi;
  i64toi32_i32$5 = $2;
  i64toi32_i32$0 = -1;
  i64toi32_i32$3 = -1;
  if ((i64toi32_i32$1 | 0) > (i64toi32_i32$0 | 0)) {
   $18 = 1
  } else {
   if ((i64toi32_i32$1 | 0) >= (i64toi32_i32$0 | 0)) {
    if (i64toi32_i32$5 >>> 0 <= i64toi32_i32$3 >>> 0) {
     $19 = 0
    } else {
     $19 = 1
    }
    $20 = $19;
   } else {
    $20 = 0
   }
   $18 = $20;
  }
  i64toi32_i32$5 = $12$hi;
  return core__fmt__num__imp__fmt_u64__hf0469431dace4046($12 | 0, i64toi32_i32$5 | 0, $18 | 0, $1 | 0) | 0 | 0;
 }
 
 function __wbg_transactioninputs_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__TransactionInputs_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h1c7a61cc309722a9($1 | 0, $0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h98bad0b07702c13e($1 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function __wbg_transactionbody_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 272 | 0;
  global$0 = $1;
  $cardano_serialization_lib__TransactionBody_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__haffa981cfd1e3240($1 | 0, $0 | 0);
  core__ptr__drop_in_place_cardano_serialization_lib__TransactionBody___h9274013021a1d568_1($1 | 0);
  global$0 = $1 + 272 | 0;
 }
 
 function __wbg_transactioninput_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  $cardano_serialization_lib__TransactionInput_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hcada039a655d5072($1 + 8 | 0 | 0, $0 | 0);
  global$0 = $1 + 48 | 0;
 }
 
 function __wbg_transactionoutput_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 128 | 0;
  global$0 = $1;
  $cardano_serialization_lib__TransactionOutput_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h4bb11caa52896e6c($1 | 0, $0 | 0);
  core__ptr__drop_in_place_cardano_serialization_lib__TransactionOutput___h632b3a99817e6ac5_2($1 | 0);
  global$0 = $1 + 128 | 0;
 }
 
 function __wbg_ed25519keyhashes_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__Ed25519KeyHashes_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hee5d1abe59d78bf5($1 | 0, $0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h72de9eab2f0e4669($1 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function __wbg_genesiskeydelegation_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 96 | 0;
  global$0 = $1;
  $cardano_serialization_lib__GenesisKeyDelegation_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h999283eab0776d45($1 + 8 | 0 | 0, $0 | 0);
  global$0 = $1 + 96 | 0;
 }
 
 function __wbg_relay_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 32 | 0;
  global$0 = $1;
  $cardano_serialization_lib__Relay_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__haa46af776723fcc2($1 | 0, $0 | 0);
  core__ptr__drop_in_place_cardano_serialization_lib__RelayEnum___h969d1fa65912b879($1 | 0);
  global$0 = $1 + 32 | 0;
 }
 
 function __wbg_stakecredentials_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__StakeCredentials_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h829ea11109d33acc($1 | 0, $0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hf2b315b267dbf438($1 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function __wbg_rewardaddresses_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__RewardAddresses_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hcdf800cf37b3247e($1 | 0, $0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hf5b7c59907e4555e($1 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function __wbg_transactionwitnessset_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  $cardano_serialization_lib__TransactionWitnessSet_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h00e0a5bfc8cbadcd($1 | 0, $0 | 0);
  core__ptr__drop_in_place_cardano_serialization_lib__TransactionWitnessSet___h7d278d9502f6471a_1($1 | 0);
  global$0 = $1 + 80 | 0;
 }
 
 function __wbg_genesishashes_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__GenesisHashes_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h10b95e2982532a00($1 | 0, $0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hebb629eda405a6ec($1 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function __wbg_scripthashes_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__ScriptHashes_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__ha1b6a463a08200a3($1 | 0, $0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hd17502cd2c574696($1 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function __wbg_protocolversion_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__ProtocolVersion_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h9cfa3ccfae475694($1 + 8 | 0 | 0, $0 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function __wbg_protocolversions_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__ProtocolVersions_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h57b06560daba22b7($1 | 0, $0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h1737752c75bae0f3($1 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function __wbg_operationalcert_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 112 | 0;
  global$0 = $1;
  $cardano_serialization_lib__OperationalCert_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hd4431f5d7fa81d9e($1 + 8 | 0 | 0, $0 | 0);
  global$0 = $1 + 112 | 0;
 }
 
 function __wbg_assets_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__Assets_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h87a1c4ff7df56b93($1 | 0, $0 | 0);
  $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h6c9f94f0f82ce2b5($1 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function __wbg_multiasset_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__MultiAsset_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hbbf1fa03090b6b60($1 | 0, $0 | 0);
  $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($1 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function __wbg_mintassets_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__MintAssets_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h346090e2c1141630($1 | 0, $0 | 0);
  $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h0265580a5be10b66($1 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function __wbg_mint_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__Mint_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__ha22e70587b3386a3($1 | 0, $0 | 0);
  $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h3981a4152bf24dd0($1 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function __wbg_transactionmetadatum_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  $cardano_serialization_lib__metadata__TransactionMetadatum_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h5fd3565fc4e8c763($1 | 0, $0 | 0);
  core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatum___headd2d1b596252cc($1 | 0);
  global$0 = $1 + 48 | 0;
 }
 
 function __wbg_transactionmetadatumlabels_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__metadata__TransactionMetadatumLabels_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hd455b80b8fa28b24($1 | 0, $0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h53c1f511db73a3dc($1 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function core__ptr__drop_in_place_alloc__boxed__Box_linked_hash_map__Node_cardano_serialization_lib__metadata__TransactionMetadatum_2ccardano_serialization_lib__metadata__TransactionMetadatum_____hb84969c3100fb85b($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = HEAP32[$0 >> 2] | 0;
  core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatumEnum___h27fd15c9b26a768e($1 | 0);
  core__ptr__drop_in_place_cardano_serialization_lib__metadata__TransactionMetadatumEnum___h27fd15c9b26a768e($1 + 48 | 0 | 0);
  __rust_dealloc($T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b(HEAP32[$0 >> 2] | 0 | 0) | 0 | 0, 104 | 0, 8 | 0);
 }
 
 function __wbg_transactionbuilderconfigbuilder_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 144 | 0;
  global$0 = $1;
  $cardano_serialization_lib__tx_builder__TransactionBuilderConfigBuilder_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h371fb401323e5a64($1 + 8 | 0 | 0, $0 | 0);
  global$0 = $1 + 144 | 0;
 }
 
 function __wbg_bip32privatekey_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 96 | 0;
  global$0 = $1;
  $cardano_serialization_lib__crypto__Bip32PrivateKey_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__he08750f04da5ba39($1 | 0, $0 | 0);
  $ed25519_bip32__key__XPrv_20as_20core__ops__drop__Drop___drop__h041b586f91562314($1 | 0);
  global$0 = $1 + 96 | 0;
 }
 
 function __wbg_privatekey_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 80 | 0;
  global$0 = $1;
  $cardano_serialization_lib__crypto__PrivateKey_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hb039971b04c3a015($1 + 8 | 0 | 0, $0 | 0);
  global$0 = $1 + 80 | 0;
 }
 
 function __wbg_vkeys_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__crypto__Vkeys_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h3946458ff227fb6c($1 | 0, $0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h8a39c130794ac15a($1 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function __wbg_vkeywitnesses_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__crypto__Vkeywitnesses_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hfc014afe9914e142($1 | 0, $0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hdd0c057252922c46($1 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function __wbg_publickeys_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__crypto__PublicKeys_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h45febc60c137f200($1 | 0, $0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h534428c4bbf875dd($1 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function __wbg_nonce_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  $cardano_serialization_lib__crypto__Nonce_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hbc488b6feb4e7d5f($1 + 8 | 0 | 0, $0 | 0);
  global$0 = $1 + 48 | 0;
 }
 
 function __wbg_plutuswitness_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 144 | 0;
  global$0 = $1;
  $cardano_serialization_lib__tx_builder__tx_inputs_builder__PlutusWitness_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hf3febb4a8b9507dc($1 | 0, $0 | 0);
  core__ptr__drop_in_place_cardano_serialization_lib__tx_builder__tx_inputs_builder__PlutusWitness___he0a62919c4b71e2b($1 | 0);
  global$0 = $1 + 144 | 0;
 }
 
 function __wbg_networkinfo_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__address__NetworkInfo_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h79e98087973745ca($1 + 8 | 0 | 0, $0 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function __wbg_pointer_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 32 | 0;
  global$0 = $1;
  $cardano_serialization_lib__address__Pointer_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h02e1203ff329374c($1 + 8 | 0 | 0, $0 | 0);
  global$0 = $1 + 32 | 0;
 }
 
 function __wbg_pointeraddress_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 64 | 0;
  global$0 = $1;
  $cardano_serialization_lib__address__PointerAddress_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h725d0ed5db0bdcca($1 + 8 | 0 | 0, $0 | 0);
  global$0 = $1 + 64 | 0;
 }
 
 function __wbg_costmodel_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__plutus__CostModel_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h74e6f0d207e1a011($1 | 0, $0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hebed8fd85cb76c41($1 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function __wbg_costmdls_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__plutus__Costmdls_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hc9c090dbe2ba6b95($1 | 0, $0 | 0);
  $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h5f5dc70d320637e0($1 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function __wbg_plutusmap_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__plutus__PlutusMap_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hca9530ce8ba44c67($1 | 0, $0 | 0);
  $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h50a5c5eb0f530455($1 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function __wbg_plutusdata_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 48 | 0;
  global$0 = $1;
  $cardano_serialization_lib__plutus__PlutusData_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h08b7da506ccf1ae6($1 | 0, $0 | 0);
  core__ptr__drop_in_place_cardano_serialization_lib__plutus__PlutusData___hfab843e66e0f9428_1($1 | 0);
  global$0 = $1 + 48 | 0;
 }
 
 function wasm_bindgen__convert__closures__invoke3_mut__h0fd95d39ebdb2ca3($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen__throw_str__h40ff0247f6a635d7(1076516 | 0, 48 | 0);
   abort();
  }
  FUNCTION_TABLE[HEAP32[($1 + 12 | 0) >> 2] | 0 | 0]($0, $2, $3, $4);
 }
 
 function wasm_bindgen__convert__closures__invoke3_mut__h2f804e1660e004ee($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen__throw_str__h40ff0247f6a635d7(1076516 | 0, 48 | 0);
   abort();
  }
  return FUNCTION_TABLE[HEAP32[($1 + 12 | 0) >> 2] | 0 | 0]($0, $2, $3, $4) | 0 | 0;
 }
 
 function wasm_bindgen__convert__closures__invoke3_mut__h38a8d51409aeacf1($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen__throw_str__h40ff0247f6a635d7(1076516 | 0, 48 | 0);
   abort();
  }
  FUNCTION_TABLE[HEAP32[($1 + 12 | 0) >> 2] | 0 | 0]($0, $2, $3, $4);
 }
 
 function wasm_bindgen__convert__closures__invoke3_mut__h4abe3dcb75766dba($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = +$2;
  $3 = $3 | 0;
  $4 = $4 | 0;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen__throw_str__h40ff0247f6a635d7(1076516 | 0, 48 | 0);
   abort();
  }
  FUNCTION_TABLE[HEAP32[($1 + 12 | 0) >> 2] | 0 | 0]($0, $2, $3, $4);
 }
 
 function wasm_bindgen__convert__closures__invoke3_mut__h54bd9345afa3e98a($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen__throw_str__h40ff0247f6a635d7(1076516 | 0, 48 | 0);
   abort();
  }
  FUNCTION_TABLE[HEAP32[($1 + 12 | 0) >> 2] | 0 | 0]($0, $2, $3, $4);
 }
 
 function wasm_bindgen__convert__closures__invoke3_mut__h5b7f45c1ed00f9be($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen__throw_str__h40ff0247f6a635d7(1076516 | 0, 48 | 0);
   abort();
  }
  return FUNCTION_TABLE[HEAP32[($1 + 12 | 0) >> 2] | 0 | 0]($0, $2, $3, $4) | 0 | 0;
 }
 
 function wasm_bindgen__convert__closures__invoke3_mut__h6c4b094589ba48d8($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen__throw_str__h40ff0247f6a635d7(1076516 | 0, 48 | 0);
   abort();
  }
  FUNCTION_TABLE[HEAP32[($1 + 12 | 0) >> 2] | 0 | 0]($0, $2, $3, $4);
 }
 
 function wasm_bindgen__convert__closures__invoke3_mut__h95ca65c421627347($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = Math_fround($2);
  $3 = $3 | 0;
  $4 = $4 | 0;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen__throw_str__h40ff0247f6a635d7(1076516 | 0, 48 | 0);
   abort();
  }
  FUNCTION_TABLE[HEAP32[($1 + 12 | 0) >> 2] | 0 | 0]($0, $2, $3, $4);
 }
 
 function wasm_bindgen__convert__closures__invoke3_mut__had514eb5a932a259($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen__throw_str__h40ff0247f6a635d7(1076516 | 0, 48 | 0);
   abort();
  }
  FUNCTION_TABLE[HEAP32[($1 + 12 | 0) >> 2] | 0 | 0]($0, $2, $3, $4);
 }
 
 function wasm_bindgen__convert__closures__invoke3_mut__hb0b52aa9d64abd0e($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen__throw_str__h40ff0247f6a635d7(1076516 | 0, 48 | 0);
   abort();
  }
  FUNCTION_TABLE[HEAP32[($1 + 12 | 0) >> 2] | 0 | 0]($0, $2, $3, $4);
 }
 
 function wasm_bindgen__convert__closures__invoke3_mut__hdc4b9934268ea366($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen__throw_str__h40ff0247f6a635d7(1076516 | 0, 48 | 0);
   abort();
  }
  FUNCTION_TABLE[HEAP32[($1 + 12 | 0) >> 2] | 0 | 0]($0, $2, $3, $4);
 }
 
 function wasm_bindgen__convert__closures__invoke3_mut__hf2a270d18792658f($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen__throw_str__h40ff0247f6a635d7(1076516 | 0, 48 | 0);
   abort();
  }
  FUNCTION_TABLE[HEAP32[($1 + 12 | 0) >> 2] | 0 | 0]($0, $2, $3, $4);
 }
 
 function wasm_bindgen__convert__closures__invoke3_mut__hf79595a4cf51f127($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen__throw_str__h40ff0247f6a635d7(1076516 | 0, 48 | 0);
   abort();
  }
  FUNCTION_TABLE[HEAP32[($1 + 12 | 0) >> 2] | 0 | 0]($0, $2, $3, $4);
 }
 
 function alloc__vec__Vec_T_2cA___reserve__hd6ffa03575bd5508($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (((HEAP32[($0 + 4 | 0) >> 2] | 0) - $2 | 0) >>> 0 >= $1 >>> 0) {
    break label$1
   }
   alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h90c9768825cdae1b($0 | 0, $2 | 0, $1 | 0);
  }
 }
 
 function core__slice__cmp___impl_20core__cmp__PartialEq__5bB_5d__20for_20_5bA_5d___eq__h90e2e64d8666208c($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0;
  $4 = 0;
  label$1 : {
   if (($1 | 0) != ($3 | 0)) {
    break label$1
   }
   $4 = !(memcmp($0 | 0, $2 | 0, $1 | 0) | 0);
  }
  return $4 | 0;
 }
 
 function alloc__vec__Vec_T_2cA___reserve__h71af5692fa531ae6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (((HEAP32[($0 + 4 | 0) >> 2] | 0) - $2 | 0) >>> 0 >= $1 >>> 0) {
    break label$1
   }
   alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__h7b0a2c1df92d7167($0 | 0, $2 | 0, $1 | 0);
  }
 }
 
 function alloc__vec__Vec_T_2cA___reserve__h9cf757d86af8f187($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (((HEAP32[($0 + 4 | 0) >> 2] | 0) - $2 | 0) >>> 0 >= $1 >>> 0) {
    break label$1
   }
   alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__he90fb3a4f4cd283b($0 | 0, $2 | 0, $1 | 0);
  }
 }
 
 function alloc__vec__Vec_T_2cA___reserve__hd1fc8182517f0f4e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  label$1 : {
   $2 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if (((HEAP32[($0 + 4 | 0) >> 2] | 0) - $2 | 0) >>> 0 >= $1 >>> 0) {
    break label$1
   }
   alloc__raw_vec__RawVec_T_2cA___reserve__do_reserve_and_handle__hf485cf9a98f32d97($0 | 0, $2 | 0, $1 | 0);
  }
 }
 
 function core__str___impl_20str___starts_with__h83a49b4c2da4d8f5($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0;
  $4 = 0;
  label$1 : {
   if ($1 >>> 0 < $3 >>> 0) {
    break label$1
   }
   $4 = !(memcmp($2 | 0, $0 | 0, $3 | 0) | 0);
  }
  return $4 | 0;
 }
 
 function core__slice__cmp___impl_20core__cmp__PartialEq__5bB_5d__20for_20_5bA_5d___eq__hc3de93b036fcc30b($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  var $4 = 0;
  $4 = 0;
  label$1 : {
   if (($1 | 0) != ($3 | 0)) {
    break label$1
   }
   $4 = !(memcmp($0 | 0, $2 | 0, $1 | 0) | 0);
  }
  return $4 | 0;
 }
 
 function core__ptr__drop_in_place_cryptoxide__hmac__Hmac_cryptoxide__sha2__Sha512____hc18b32e73944f3e5($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = $0 + 224 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h3bd3d14231c65693($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hc61f5e215ed90985($1 | 0);
  $0 = $0 + 236 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h3bd3d14231c65693($0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hc61f5e215ed90985($0 | 0);
 }
 
 function $cryptoxide__hmac__Hmac_D__20as_20cryptoxide__mac__Mac___input__h8428084cca8543c2($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  label$1 : {
   if (HEAPU8[($0 + 248 | 0) >> 0] | 0) {
    break label$1
   }
   $cryptoxide__sha2__Sha512_20as_20cryptoxide__digest__Digest___input__h63322ce5a02a233a($0 | 0, $1 | 0, $2 | 0);
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1101716 | 0, 32 | 0, 1101748 | 0);
  abort();
 }
 
 function $cryptoxide__sha3__Sha3_256_20as_20cryptoxide__digest__Digest___input__hf816d8e33a17a244($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  label$1 : {
   if (HEAPU8[($0 + 208 | 0) >> 0] | 0) {
    break label$1
   }
   cryptoxide__hashing__sha3__Engine___2c____process__ha763ada6c2b386e3($0 | 0, $1 | 0, $2 | 0);
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1135784 | 0, 41 | 0, 1135956 | 0);
  abort();
 }
 
 function hex__BytesToHexChars__new__hd2404227bb55ee67($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  HEAP32[($0 + 12 | 0) >> 2] = 1114112;
  HEAP32[($0 + 8 | 0) >> 2] = $3;
  HEAP32[$0 >> 2] = $1;
  HEAP32[($0 + 4 | 0) >> 2] = $1 + $2 | 0;
 }
 
 function std__panicking__panic_count__is_zero_slow_path__h1d20871758c70487() {
  var i64toi32_i32$1 = 0;
  label$1 : {
   if ((HEAP32[(0 + 1178336 | 0) >> 2] | 0 | 0) != (1 | 0)) {
    break label$1
   }
   return !(HEAP32[(0 + 1178340 | 0) >> 2] | 0) | 0;
  }
  i64toi32_i32$1 = 0;
  HEAP32[(i64toi32_i32$1 + 1178336 | 0) >> 2] = 1;
  HEAP32[(i64toi32_i32$1 + 1178340 | 0) >> 2] = 0;
  return 1 | 0;
 }
 
 function dlmalloc__dlmalloc__Chunk__set_inuse_and_pinuse__hd70cd9b459f591b2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $1 | 3 | 0;
  $0 = $0 + $1 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($0 + 4 | 0) >> 2] | 0 | 1 | 0;
 }
 
 function hashbrown__raw__Fallibility__alloc_err__ha667b3bb2bd8a2c9($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  label$1 : {
   if ($1) {
    break label$1
   }
   HEAP32[($0 + 4 | 0) >> 2] = $3;
   HEAP32[$0 >> 2] = $2;
   return;
  }
  alloc__alloc__handle_alloc_error__he269d8f1bff90960($2 | 0, $3 | 0);
  abort();
 }
 
 function core__ptr__drop_in_place_cardano_serialization_lib__TransactionOutput___h632b3a99817e6ac5_2($0) {
  $0 = $0 | 0;
  core__ptr__drop_in_place_cardano_serialization_lib__address__Address___ha7ee337124a79b19($0 | 0);
  label$1 : {
   if (!(HEAP32[($0 + 72 | 0) >> 2] | 0)) {
    break label$1
   }
   $alloc__collections__btree__map__BTreeMap_K_2cV__20as_20core__ops__drop__Drop___drop__h8a86759877893a28($0 + 76 | 0 | 0);
  }
 }
 
 function cardano_serialization_lib__ProposedProtocolParameterUpdates__get__h44ec3d3b4f1a7a88($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  label$1 : {
   $1 = linked_hash_map__LinkedHashMap_K_2cV_2cS___get__hd0e4323bf75041b1($1 | 0, $2 | 0) | 0;
   if ($1) {
    break label$1
   }
   HEAP32[$0 >> 2] = 2;
   HEAP32[($0 + 4 | 0) >> 2] = 0;
   return;
  }
  $cardano_serialization_lib__ProtocolParamUpdate_20as_20core__clone__Clone___clone__h79b368642b010c69($0 | 0, $1 | 0);
 }
 
 function cardano_serialization_lib__utils__Value__compare__h76fa82c3757f53d2($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $1 = $cardano_serialization_lib__utils__Value_20as_20core__cmp__PartialOrd___partial_cmp__hb371960dec6e8a81($1 | 0, $2 | 0) | 0;
  HEAP8[($0 + 1 | 0) >> 0] = $1;
  HEAP8[$0 >> 0] = ($1 & 255 | 0 | 0) != (2 | 0);
 }
 
 function core__ptr__drop_in_place_cardano_serialization_lib__tx_builder__tx_inputs_builder__PlutusWitness___he0a62919c4b71e2b($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = $0 + 128 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($1 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($1 | 0);
  core__ptr__drop_in_place_cardano_serialization_lib__plutus__PlutusData___hfab843e66e0f9428_3($0 | 0);
  core__ptr__drop_in_place_cardano_serialization_lib__plutus__PlutusData___hfab843e66e0f9428_3($0 + 56 | 0 | 0);
 }
 
 function cardano_serialization_lib__plutus__Costmdls__get__hfda0a473e7b5be66($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  label$1 : {
   $1 = alloc__collections__btree__map__BTreeMap_K_2cV___get__h84ab4aba07ccb152($1 | 0, $2 | 0) | 0;
   if ($1) {
    break label$1
   }
   HEAP32[$0 >> 2] = 0;
   return;
  }
  $alloc__vec__Vec_T_2cA__20as_20core__clone__Clone___clone__h614c9de21e58255d($0 | 0, $1 | 0);
 }
 
 function cardano_serialization_lib__plutus__PlutusMap__get__hbb93cba378f24205($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  label$1 : {
   $1 = alloc__collections__btree__map__BTreeMap_K_2cV___get__h7872ab5b45891653($1 | 0, $2 | 0) | 0;
   if ($1) {
    break label$1
   }
   HEAP32[$0 >> 2] = 5;
   return;
  }
  $cardano_serialization_lib__plutus__PlutusData_20as_20core__clone__Clone___clone__h63d1a98cc18f4609_2($0 | 0, $1 | 0);
 }
 
 function getrandom__imp__RNG_SOURCE____getit__h6f31be58fa71e85e() {
  var $0 = 0;
  $0 = 1177728;
  label$1 : {
   if ((HEAP32[(0 + 1177728 | 0) >> 2] | 0 | 0) != (2 | 0)) {
    break label$1
   }
   $0 = std__thread__local__lazy__LazyKeyInner_T___initialize__hf3fcc641c491085f(1177728 | 0, 175 | 0) | 0;
  }
  return $0 | 0;
 }
 
 function js_sys__global__GLOBAL____getit__hd11b16d303143195() {
  var $0 = 0;
  $0 = 1177760;
  label$1 : {
   if ((HEAP32[(0 + 1177756 | 0) >> 2] | 0 | 0) == (1 | 0)) {
    break label$1
   }
   $0 = std__thread__local__lazy__LazyKeyInner_T___initialize__hc90c2bd45b0f5e51(1177756 | 0, 177 | 0) | 0;
  }
  return $0 | 0;
 }
 
 function wasm_bindgen__convert__closures__invoke2_mut__h1e7fc25dc8e0d8c0($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen__throw_str__h40ff0247f6a635d7(1076516 | 0, 48 | 0);
   abort();
  }
  FUNCTION_TABLE[HEAP32[($1 + 12 | 0) >> 2] | 0 | 0]($0, $2, $3);
 }
 
 function wasm_bindgen__convert__closures__invoke2_mut__heaa3d0181f430ec2($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen__throw_str__h40ff0247f6a635d7(1076516 | 0, 48 | 0);
   abort();
  }
  FUNCTION_TABLE[HEAP32[($1 + 12 | 0) >> 2] | 0 | 0]($0, $2, $3);
 }
 
 function alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Owned_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___new__h2d48df2c386b61df($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = alloc__boxed__Box_T_2cA___new_uninit_in__h8a2711313b9ea9b8() | 0;
  HEAP16[($1 + 402 | 0) >> 1] = 0;
  HEAP32[($1 + 264 | 0) >> 2] = 0;
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[$0 >> 2] = 0;
 }
 
 function alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___force__h59ee48980727210c($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[($0 + 8 | 0) >> 2] = $2;
  HEAP32[$0 >> 2] = ($1 | 0) != (0 | 0);
 }
 
 function alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2calloc__collections__btree__node__marker__LeafOrInternal___force__h8203d42018ada81e($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $1;
  HEAP32[($0 + 8 | 0) >> 2] = $2;
  HEAP32[$0 >> 2] = ($1 | 0) != (0 | 0);
 }
 
 function $_alloc__vec__Vec_T_2cA__20as_20core__iter__traits__collect__IntoIterator___into_iter__h770da9f254a2d1a7($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = HEAP32[$1 >> 2] | 0;
  HEAP32[$0 >> 2] = $2;
  HEAP32[($0 + 4 | 0) >> 2] = $2 + Math_imul(HEAP32[($1 + 8 | 0) >> 2] | 0, 24) | 0;
 }
 
 function serde_json__value__from___impl_20core__convert__From_u64__20for_20serde_json__value__Value___from__h063d95b839f3c127($0, $1, $1$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $1$hi = $1$hi | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0;
  HEAP8[$0 >> 0] = 2;
  i64toi32_i32$0 = $1$hi;
  i64toi32_i32$1 = $0 + 16 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $1;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$1 = $0 + 8 | 0;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
 }
 
 function $bool_20as_20core__fmt__Display___fmt__h95e81cc5f4a740bb($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAPU8[$0 >> 0] | 0) {
    break label$1
   }
   return core__fmt__Formatter__pad__h381b7c9eef015e8b($1 | 0, 1150580 | 0, 5 | 0) | 0 | 0;
  }
  return core__fmt__Formatter__pad__h381b7c9eef015e8b($1 | 0, 1150576 | 0, 4 | 0) | 0 | 0;
 }
 
 function core__ptr__drop_in_place_cardano_serialization_lib__RelayEnum___h969d1fa65912b879($0) {
  $0 = $0 | 0;
  label$1 : {
   if (!(HEAPU16[$0 >> 1] | 0)) {
    break label$1
   }
   $0 = $0 + 4 | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
  }
 }
 
 function __wbg_unitinterval_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__UnitInterval_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h5f35d1d54299ac98($1 | 0, $0 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function __wbg_stakeregistration_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 32 | 0;
  global$0 = $1;
  $cardano_serialization_lib__StakeRegistration_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h1d642bd792942469($1 | 0, $0 | 0);
  global$0 = $1 + 32 | 0;
 }
 
 function __wbg_stakederegistration_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 32 | 0;
  global$0 = $1;
  $cardano_serialization_lib__StakeDeregistration_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h7390bf7641b86627($1 | 0, $0 | 0);
  global$0 = $1 + 32 | 0;
 }
 
 function __wbg_stakedelegation_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 64 | 0;
  global$0 = $1;
  $cardano_serialization_lib__StakeDelegation_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h562eb806d5109811($1 | 0, $0 | 0);
  global$0 = $1 + 64 | 0;
 }
 
 function __wbg_poolretirement_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 32 | 0;
  global$0 = $1;
  $cardano_serialization_lib__PoolRetirement_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h16155183867eb2ad($1 | 0, $0 | 0);
  global$0 = $1 + 32 | 0;
 }
 
 function __wbg_ipv6_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__Ipv6_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h206d9a425c1d3d2e($1 | 0, $0 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function __wbg_singlehostaddr_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 32 | 0;
  global$0 = $1;
  $cardano_serialization_lib__SingleHostAddr_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h9b7c6207b2d568f8($1 | 0, $0 | 0);
  global$0 = $1 + 32 | 0;
 }
 
 function __wbg_scriptpubkey_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 32 | 0;
  global$0 = $1;
  $cardano_serialization_lib__ScriptPubkey_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h11ae1eec7d920302($1 | 0, $0 | 0);
  global$0 = $1 + 32 | 0;
 }
 
 function core__mem__maybe_uninit__MaybeUninit_T___assume_init_drop__h2b0add0f20d62517($0) {
  $0 = $0 | 0;
  label$1 : {
   if (!(HEAP32[$0 >> 2] | 0)) {
    break label$1
   }
   $0 = $0 + 4 | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
  }
 }
 
 function __wbg_int_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__utils__Int_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h465ce6bea3371e5b($1 | 0, $0 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function __wbg_linearfee_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__fees__LinearFee_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h59d19303ba276534($1 | 0, $0 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function __wbg_transactionbuilderconfig_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 96 | 0;
  global$0 = $1;
  $cardano_serialization_lib__tx_builder__TransactionBuilderConfig_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h597719a7183e4421($1 | 0, $0 | 0);
  global$0 = $1 + 96 | 0;
 }
 
 function __wbg_bip32publickey_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 64 | 0;
  global$0 = $1;
  $cardano_serialization_lib__crypto__Bip32PublicKey_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h3ce6e98e6160adf2($1 | 0, $0 | 0);
  global$0 = $1 + 64 | 0;
 }
 
 function __wbg_publickey_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 32 | 0;
  global$0 = $1;
  $cardano_serialization_lib__crypto__PublicKey_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h5170c950d068b816($1 | 0, $0 | 0);
  global$0 = $1 + 32 | 0;
 }
 
 function __wbg_vkey_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 32 | 0;
  global$0 = $1;
  $cardano_serialization_lib__crypto__Vkey_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hdce46b231f1d8799($1 | 0, $0 | 0);
  global$0 = $1 + 32 | 0;
 }
 
 function __wbg_vkeywitness_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 96 | 0;
  global$0 = $1;
  $cardano_serialization_lib__crypto__Vkeywitness_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h410d1e7c1dfb507d($1 | 0, $0 | 0);
  global$0 = $1 + 96 | 0;
 }
 
 function __wbg_ed25519signature_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 64 | 0;
  global$0 = $1;
  $cardano_serialization_lib__crypto__Ed25519Signature_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h06286e958fd68507($1 | 0, $0 | 0);
  global$0 = $1 + 64 | 0;
 }
 
 function __wbg_legacydaedalusprivatekey_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 96 | 0;
  global$0 = $1;
  $cardano_serialization_lib__crypto__LegacyDaedalusPrivateKey_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h01c57f5c14c20554($1 | 0, $0 | 0);
  global$0 = $1 + 96 | 0;
 }
 
 function __wbg_ed25519keyhash_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 32 | 0;
  global$0 = $1;
  $cardano_serialization_lib__crypto__Ed25519KeyHash_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hb04c1864cf0fd335($1 | 0, $0 | 0);
  global$0 = $1 + 32 | 0;
 }
 
 function __wbg_scripthash_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 32 | 0;
  global$0 = $1;
  $cardano_serialization_lib__crypto__ScriptHash_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h841a5f1b153ab9b0($1 | 0, $0 | 0);
  global$0 = $1 + 32 | 0;
 }
 
 function __wbg_transactionhash_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 32 | 0;
  global$0 = $1;
  $cardano_serialization_lib__crypto__TransactionHash_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h354802eb0ef8e301($1 | 0, $0 | 0);
  global$0 = $1 + 32 | 0;
 }
 
 function __wbg_genesisdelegatehash_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 32 | 0;
  global$0 = $1;
  $cardano_serialization_lib__crypto__GenesisDelegateHash_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h1f0ee653cb696cda($1 | 0, $0 | 0);
  global$0 = $1 + 32 | 0;
 }
 
 function __wbg_genesishash_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 32 | 0;
  global$0 = $1;
  $cardano_serialization_lib__crypto__GenesisHash_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h54f8e4796f67f1b1($1 | 0, $0 | 0);
  global$0 = $1 + 32 | 0;
 }
 
 function __wbg_auxiliarydatahash_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 32 | 0;
  global$0 = $1;
  $cardano_serialization_lib__crypto__AuxiliaryDataHash_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__ha0a8a46a2c186b22($1 | 0, $0 | 0);
  global$0 = $1 + 32 | 0;
 }
 
 function __wbg_poolmetadatahash_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 32 | 0;
  global$0 = $1;
  $cardano_serialization_lib__crypto__PoolMetadataHash_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h919da9d1bb69fb13($1 | 0, $0 | 0);
  global$0 = $1 + 32 | 0;
 }
 
 function __wbg_vrfkeyhash_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 32 | 0;
  global$0 = $1;
  $cardano_serialization_lib__crypto__VRFKeyHash_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h8eb38b87246da9fe($1 | 0, $0 | 0);
  global$0 = $1 + 32 | 0;
 }
 
 function __wbg_blockhash_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 32 | 0;
  global$0 = $1;
  $cardano_serialization_lib__crypto__BlockHash_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hb6c73b3486e647eb($1 | 0, $0 | 0);
  global$0 = $1 + 32 | 0;
 }
 
 function __wbg_datahash_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 32 | 0;
  global$0 = $1;
  $cardano_serialization_lib__crypto__DataHash_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h73047049c9205097($1 | 0, $0 | 0);
  global$0 = $1 + 32 | 0;
 }
 
 function __wbg_scriptdatahash_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 32 | 0;
  global$0 = $1;
  $cardano_serialization_lib__crypto__ScriptDataHash_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hf6e21216d0c6c529($1 | 0, $0 | 0);
  global$0 = $1 + 32 | 0;
 }
 
 function __wbg_vrfvkey_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 32 | 0;
  global$0 = $1;
  $cardano_serialization_lib__crypto__VRFVKey_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hd1275b0a7c70790b($1 | 0, $0 | 0);
  global$0 = $1 + 32 | 0;
 }
 
 function __wbg_kesvkey_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 32 | 0;
  global$0 = $1;
  $cardano_serialization_lib__crypto__KESVKey_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h2cd0f9edc6f9fec8($1 | 0, $0 | 0);
  global$0 = $1 + 32 | 0;
 }
 
 function __wbg_stakecredential_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 32 | 0;
  global$0 = $1;
  $cardano_serialization_lib__address__StakeCredential_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h79ea81cd54feaf34($1 | 0, $0 | 0);
  global$0 = $1 + 32 | 0;
 }
 
 function __wbg_baseaddress_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 64 | 0;
  global$0 = $1;
  $cardano_serialization_lib__address__BaseAddress_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h36ef0f3ec3fa9ba7($1 | 0, $0 | 0);
  global$0 = $1 + 64 | 0;
 }
 
 function __wbg_enterpriseaddress_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 32 | 0;
  global$0 = $1;
  $cardano_serialization_lib__address__EnterpriseAddress_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h54e74b049e3119f0($1 | 0, $0 | 0);
  global$0 = $1 + 32 | 0;
 }
 
 function __wbg_rewardaddress_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 32 | 0;
  global$0 = $1;
  $cardano_serialization_lib__address__RewardAddress_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__ha40e942e667fb45c($1 | 0, $0 | 0);
  global$0 = $1 + 32 | 0;
 }
 
 function __wbg_exunitprices_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 32 | 0;
  global$0 = $1;
  $cardano_serialization_lib__plutus__ExUnitPrices_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h5866688a6fa9afcf($1 | 0, $0 | 0);
  global$0 = $1 + 32 | 0;
 }
 
 function __wbg_exunits_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__plutus__ExUnits_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hee7fe190ca5421e8($1 | 0, $0 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function __wbg_languages_free($0) {
  $0 = $0 | 0;
  var $1 = 0;
  $1 = global$0 - 16 | 0;
  global$0 = $1;
  $cardano_serialization_lib__plutus__Languages_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h3c02acc30fcff953($1 | 0, $0 | 0);
  global$0 = $1 + 16 | 0;
 }
 
 function $T_20as_20core__convert__Into_U____into__h22fa69910ba5cfda($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, $9 = 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $4;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $9 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $9;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
 }
 
 function $T_20as_20core__convert__Into_U____into__hd2808ec68dba4890($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0, $9 = 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $4;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$2 = i64toi32_i32$2 + 8 | 0;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $9 = i64toi32_i32$1;
  i64toi32_i32$1 = $0 + 8 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $9;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
 }
 
 function wasm_bindgen__convert__closures__invoke1_mut__h2d25782e02bcec0e($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  label$1 : {
   if ($0) {
    break label$1
   }
   wasm_bindgen__throw_str__h40ff0247f6a635d7(1076516 | 0, 48 | 0);
   abort();
  }
  return FUNCTION_TABLE[HEAP32[($1 + 12 | 0) >> 2] | 0 | 0]($0, $2) | 0 | 0;
 }
 
 function $std__panicking__begin_panic__PanicPayload_A__20as_20core__panic__BoxMeUp___get__ha9ff4771f53410f5($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   std__process__abort__h4249b49a3db9128b();
   abort();
  }
  HEAP32[($0 + 4 | 0) >> 2] = 1077492;
  HEAP32[$0 >> 2] = $1;
 }
 
 function $T_20as_20core__convert__Into_U____into__hf947635aeddf134e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $4;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
 }
 
 function serde__ser__iterator_len_hint__h4043e0ddab155abd($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  HEAP32[$0 >> 2] = 1;
  HEAP32[($0 + 4 | 0) >> 2] = (((HEAP32[($1 + 4 | 0) >> 2] | 0) - (HEAP32[$1 >> 2] | 0) | 0) >>> 0) / (24 >>> 0) | 0;
 }
 
 function rand_core__error__Error__new__h7fdf5b19286dd417($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[($0 + 4 | 0) >> 2] = $3;
  HEAP32[$0 >> 2] = $2;
  HEAP8[($0 + 16 | 0) >> 0] = $1;
 }
 
 function $std__panicking__begin_panic__PanicPayload_A__20as_20core__panic__BoxMeUp___get__h2653af0829554d12($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   std__process__abort__h4249b49a3db9128b();
   abort();
  }
  HEAP32[($0 + 4 | 0) >> 2] = 1139112;
  HEAP32[$0 >> 2] = $1;
 }
 
 function hashbrown__raw__Fallibility__capacity_overflow__hd790516fe6877097($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if ($1) {
    break label$1
   }
   HEAP32[($0 + 4 | 0) >> 2] = 0;
   return;
  }
  core__panicking__panic__h2fd385a887c8bf13(1145516 | 0, 28 | 0, 1145624 | 0);
  abort();
 }
 
 function alloc__string___impl_20core__convert__From_alloc__string__String__20for_20alloc__vec__Vec_u8____from__hd5e271059b2a155b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $4;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
 }
 
 function core__ptr__drop_in_place_cardano_serialization_lib__error__Key___h6509e27f4cf6a188($0) {
  $0 = $0 | 0;
  label$1 : {
   if (HEAP32[$0 >> 2] | 0) {
    break label$1
   }
   $0 = $0 + 4 | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
  }
 }
 
 function core__ptr__drop_in_place_cardano_serialization_lib__error__Key___h6509e27f4cf6a188_1($0) {
  $0 = $0 | 0;
  label$1 : {
   if (HEAP32[$0 >> 2] | 0) {
    break label$1
   }
   $0 = $0 + 4 | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
  }
 }
 
 function core__ptr__drop_in_place_cardano_serialization_lib__error__Key___h6509e27f4cf6a188_2($0) {
  $0 = $0 | 0;
  label$1 : {
   if (HEAP32[$0 >> 2] | 0) {
    break label$1
   }
   $0 = $0 + 4 | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
  }
 }
 
 function core__ptr__drop_in_place_cardano_serialization_lib__error__Key___h6509e27f4cf6a188_3($0) {
  $0 = $0 | 0;
  label$1 : {
   if (HEAP32[$0 >> 2] | 0) {
    break label$1
   }
   $0 = $0 + 4 | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
  }
 }
 
 function alloc__boxed__Box_T_2cA___new_uninit_in__h0005f5c05c0883da() {
  var $0 = 0;
  label$1 : {
   $0 = alloc__boxed__Box_T_2cA___try_new_uninit_in__h401d8d37435da5bb() | 0;
   if (!$0) {
    break label$1
   }
   return $0 | 0;
  }
  alloc__alloc__handle_alloc_error__he269d8f1bff90960(232 | 0, 8 | 0);
  abort();
 }
 
 function alloc__boxed__Box_T_2cA___try_new_uninit_in__h401d8d37435da5bb() {
  var $0 = 0;
  label$1 : {
   $0 = __rust_alloc(232 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $0 = 0;
  }
  return $0 | 0;
 }
 
 function alloc__boxed__Box_T_2cA___new_uninit_in__h0285c5e433c8dfa2() {
  var $0 = 0;
  label$1 : {
   $0 = alloc__boxed__Box_T_2cA___try_new_uninit_in__hb8e133f379e45f18() | 0;
   if (!$0) {
    break label$1
   }
   return $0 | 0;
  }
  alloc__alloc__handle_alloc_error__he269d8f1bff90960(368 | 0, 8 | 0);
  abort();
 }
 
 function alloc__boxed__Box_T_2cA___try_new_uninit_in__hb8e133f379e45f18() {
  var $0 = 0;
  label$1 : {
   $0 = __rust_alloc(368 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $0 = 0;
  }
  return $0 | 0;
 }
 
 function alloc__boxed__Box_T_2cA___new_uninit_in__h030094152bc6ae31() {
  var $0 = 0;
  label$1 : {
   $0 = alloc__boxed__Box_T_2cA___try_new_uninit_in__h8cb1645bfaf7e8e5() | 0;
   if (!$0) {
    break label$1
   }
   return $0 | 0;
  }
  alloc__alloc__handle_alloc_error__he269d8f1bff90960(496 | 0, 4 | 0);
  abort();
 }
 
 function alloc__boxed__Box_T_2cA___try_new_uninit_in__h8cb1645bfaf7e8e5() {
  var $0 = 0;
  label$1 : {
   $0 = __rust_alloc(496 | 0, 4 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $0 = 0;
  }
  return $0 | 0;
 }
 
 function alloc__boxed__Box_T_2cA___new_uninit_in__h04cd43b67903c159() {
  var $0 = 0;
  label$1 : {
   $0 = alloc__boxed__Box_T_2cA___try_new_uninit_in__hda79bdf8e89d31bb() | 0;
   if (!$0) {
    break label$1
   }
   return $0 | 0;
  }
  alloc__alloc__handle_alloc_error__he269d8f1bff90960(140 | 0, 4 | 0);
  abort();
 }
 
 function alloc__boxed__Box_T_2cA___try_new_uninit_in__hda79bdf8e89d31bb() {
  var $0 = 0;
  label$1 : {
   $0 = __rust_alloc(140 | 0, 4 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $0 = 0;
  }
  return $0 | 0;
 }
 
 function alloc__boxed__Box_T_2cA___new_uninit_in__h0c9edbef1faf0ccf() {
  var $0 = 0;
  label$1 : {
   $0 = alloc__boxed__Box_T_2cA___try_new_uninit_in__hd7431fd4db453a1a() | 0;
   if (!$0) {
    break label$1
   }
   return $0 | 0;
  }
  alloc__alloc__handle_alloc_error__he269d8f1bff90960(316 | 0, 4 | 0);
  abort();
 }
 
 function alloc__boxed__Box_T_2cA___try_new_uninit_in__hd7431fd4db453a1a() {
  var $0 = 0;
  label$1 : {
   $0 = __rust_alloc(316 | 0, 4 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $0 = 0;
  }
  return $0 | 0;
 }
 
 function alloc__boxed__Box_T_2cA___new_uninit_in__h1d1537549f7a0074() {
  var $0 = 0;
  label$1 : {
   $0 = alloc__boxed__Box_T_2cA___try_new_uninit_in__hda423948f0f56a08() | 0;
   if (!$0) {
    break label$1
   }
   return $0 | 0;
  }
  alloc__alloc__handle_alloc_error__he269d8f1bff90960(1464 | 0, 8 | 0);
  abort();
 }
 
 function alloc__boxed__Box_T_2cA___try_new_uninit_in__hda423948f0f56a08() {
  var $0 = 0;
  label$1 : {
   $0 = __rust_alloc(1464 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $0 = 0;
  }
  return $0 | 0;
 }
 
 function alloc__boxed__Box_T_2cA___new_uninit_in__h2752ff92eca24da1() {
  var $0 = 0;
  label$1 : {
   $0 = alloc__boxed__Box_T_2cA___try_new_uninit_in__h3ba205dfdec0cd71() | 0;
   if (!$0) {
    break label$1
   }
   return $0 | 0;
  }
  alloc__alloc__handle_alloc_error__he269d8f1bff90960(280 | 0, 8 | 0);
  abort();
 }
 
 function alloc__boxed__Box_T_2cA___try_new_uninit_in__h3ba205dfdec0cd71() {
  var $0 = 0;
  label$1 : {
   $0 = __rust_alloc(280 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $0 = 0;
  }
  return $0 | 0;
 }
 
 function alloc__boxed__Box_T_2cA___new_uninit_in__h2ea6451c7ed438a4() {
  var $0 = 0;
  label$1 : {
   $0 = alloc__boxed__Box_T_2cA___try_new_uninit_in__h92e82f497c2a107f() | 0;
   if (!$0) {
    break label$1
   }
   return $0 | 0;
  }
  alloc__alloc__handle_alloc_error__he269d8f1bff90960(1064 | 0, 8 | 0);
  abort();
 }
 
 function alloc__boxed__Box_T_2cA___try_new_uninit_in__h92e82f497c2a107f() {
  var $0 = 0;
  label$1 : {
   $0 = __rust_alloc(1064 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $0 = 0;
  }
  return $0 | 0;
 }
 
 function alloc__boxed__Box_T_2cA___new_uninit_in__h3c49993511c7b2e3() {
  var $0 = 0;
  label$1 : {
   $0 = alloc__boxed__Box_T_2cA___try_new_uninit_in__hb2861d0cff2c36a7() | 0;
   if (!$0) {
    break label$1
   }
   return $0 | 0;
  }
  alloc__alloc__handle_alloc_error__he269d8f1bff90960(1512 | 0, 8 | 0);
  abort();
 }
 
 function alloc__boxed__Box_T_2cA___try_new_uninit_in__hb2861d0cff2c36a7() {
  var $0 = 0;
  label$1 : {
   $0 = __rust_alloc(1512 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $0 = 0;
  }
  return $0 | 0;
 }
 
 function alloc__boxed__Box_T_2cA___new_uninit_in__h3d7406b043db0321() {
  var $0 = 0;
  label$1 : {
   $0 = alloc__boxed__Box_T_2cA___try_new_uninit_in__h892a46e4af970f6b() | 0;
   if (!$0) {
    break label$1
   }
   return $0 | 0;
  }
  alloc__alloc__handle_alloc_error__he269d8f1bff90960(140 | 0, 4 | 0);
  abort();
 }
 
 function alloc__boxed__Box_T_2cA___try_new_uninit_in__h892a46e4af970f6b() {
  var $0 = 0;
  label$1 : {
   $0 = __rust_alloc(140 | 0, 4 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $0 = 0;
  }
  return $0 | 0;
 }
 
 function alloc__boxed__Box_T_2cA___new_uninit_in__h42dfd122c2fed30e() {
  var $0 = 0;
  label$1 : {
   $0 = alloc__boxed__Box_T_2cA___try_new_uninit_in__h5296e301c5f9bf8a() | 0;
   if (!$0) {
    break label$1
   }
   return $0 | 0;
  }
  alloc__alloc__handle_alloc_error__he269d8f1bff90960(1552 | 0, 8 | 0);
  abort();
 }
 
 function alloc__boxed__Box_T_2cA___try_new_uninit_in__h5296e301c5f9bf8a() {
  var $0 = 0;
  label$1 : {
   $0 = __rust_alloc(1552 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $0 = 0;
  }
  return $0 | 0;
 }
 
 function alloc__boxed__Box_T_2cA___new_uninit_in__h4be0289855654d00() {
  var $0 = 0;
  label$1 : {
   $0 = alloc__boxed__Box_T_2cA___try_new_uninit_in__h54eb4ebb28bd2e8e() | 0;
   if (!$0) {
    break label$1
   }
   return $0 | 0;
  }
  alloc__alloc__handle_alloc_error__he269d8f1bff90960(496 | 0, 4 | 0);
  abort();
 }
 
 function alloc__boxed__Box_T_2cA___try_new_uninit_in__h54eb4ebb28bd2e8e() {
  var $0 = 0;
  label$1 : {
   $0 = __rust_alloc(496 | 0, 4 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $0 = 0;
  }
  return $0 | 0;
 }
 
 function alloc__boxed__Box_T_2cA___new_uninit_in__h57df8859addacc9a() {
  var $0 = 0;
  label$1 : {
   $0 = alloc__boxed__Box_T_2cA___try_new_uninit_in__h4593762c6a71c0bc() | 0;
   if (!$0) {
    break label$1
   }
   return $0 | 0;
  }
  alloc__alloc__handle_alloc_error__he269d8f1bff90960(1600 | 0, 8 | 0);
  abort();
 }
 
 function alloc__boxed__Box_T_2cA___try_new_uninit_in__h4593762c6a71c0bc() {
  var $0 = 0;
  label$1 : {
   $0 = __rust_alloc(1600 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $0 = 0;
  }
  return $0 | 0;
 }
 
 function alloc__boxed__Box_T_2cA___new_uninit_in__h637e1ec719c3dde5() {
  var $0 = 0;
  label$1 : {
   $0 = alloc__boxed__Box_T_2cA___try_new_uninit_in__h76c63c4bd3ca9c89() | 0;
   if (!$0) {
    break label$1
   }
   return $0 | 0;
  }
  alloc__alloc__handle_alloc_error__he269d8f1bff90960(320 | 0, 8 | 0);
  abort();
 }
 
 function alloc__boxed__Box_T_2cA___try_new_uninit_in__h76c63c4bd3ca9c89() {
  var $0 = 0;
  label$1 : {
   $0 = __rust_alloc(320 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $0 = 0;
  }
  return $0 | 0;
 }
 
 function alloc__boxed__Box_T_2cA___new_uninit_in__h78d744dfd1820fc4() {
  var $0 = 0;
  label$1 : {
   $0 = alloc__boxed__Box_T_2cA___try_new_uninit_in__h5e49024e5e33548f() | 0;
   if (!$0) {
    break label$1
   }
   return $0 | 0;
  }
  alloc__alloc__handle_alloc_error__he269d8f1bff90960(144 | 0, 8 | 0);
  abort();
 }
 
 function alloc__boxed__Box_T_2cA___try_new_uninit_in__h5e49024e5e33548f() {
  var $0 = 0;
  label$1 : {
   $0 = __rust_alloc(144 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $0 = 0;
  }
  return $0 | 0;
 }
 
 function alloc__boxed__Box_T_2cA___new_uninit_in__h7bc2e41a812e1158() {
  var $0 = 0;
  label$1 : {
   $0 = alloc__boxed__Box_T_2cA___try_new_uninit_in__h0b59cb342e453aad() | 0;
   if (!$0) {
    break label$1
   }
   return $0 | 0;
  }
  alloc__alloc__handle_alloc_error__he269d8f1bff90960(192 | 0, 8 | 0);
  abort();
 }
 
 function alloc__boxed__Box_T_2cA___try_new_uninit_in__h0b59cb342e453aad() {
  var $0 = 0;
  label$1 : {
   $0 = __rust_alloc(192 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $0 = 0;
  }
  return $0 | 0;
 }
 
 function alloc__boxed__Box_T_2cA___new_uninit_in__h8bd6a5af2b5d8b6d() {
  var $0 = 0;
  label$1 : {
   $0 = alloc__boxed__Box_T_2cA___try_new_uninit_in__h99aa2b15a8961e79() | 0;
   if (!$0) {
    break label$1
   }
   return $0 | 0;
  }
  alloc__alloc__handle_alloc_error__he269d8f1bff90960(448 | 0, 4 | 0);
  abort();
 }
 
 function alloc__boxed__Box_T_2cA___try_new_uninit_in__h99aa2b15a8961e79() {
  var $0 = 0;
  label$1 : {
   $0 = __rust_alloc(448 | 0, 4 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $0 = 0;
  }
  return $0 | 0;
 }
 
 function alloc__boxed__Box_T_2cA___new_uninit_in__ha1c9e40f84881c6f() {
  var $0 = 0;
  label$1 : {
   $0 = alloc__boxed__Box_T_2cA___try_new_uninit_in__h4dc2ba6cdbf8702d() | 0;
   if (!$0) {
    break label$1
   }
   return $0 | 0;
  }
  alloc__alloc__handle_alloc_error__he269d8f1bff90960(100 | 0, 4 | 0);
  abort();
 }
 
 function alloc__boxed__Box_T_2cA___try_new_uninit_in__h4dc2ba6cdbf8702d() {
  var $0 = 0;
  label$1 : {
   $0 = __rust_alloc(100 | 0, 4 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $0 = 0;
  }
  return $0 | 0;
 }
 
 function alloc__boxed__Box_T_2cA___new_uninit_in__hbee8ec47f689ab87() {
  var $0 = 0;
  label$1 : {
   $0 = alloc__boxed__Box_T_2cA___try_new_uninit_in__hd1ae485cf5d0aa20() | 0;
   if (!$0) {
    break label$1
   }
   return $0 | 0;
  }
  alloc__alloc__handle_alloc_error__he269d8f1bff90960(188 | 0, 4 | 0);
  abort();
 }
 
 function alloc__boxed__Box_T_2cA___try_new_uninit_in__hd1ae485cf5d0aa20() {
  var $0 = 0;
  label$1 : {
   $0 = __rust_alloc(188 | 0, 4 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $0 = 0;
  }
  return $0 | 0;
 }
 
 function alloc__boxed__Box_T_2cA___new_uninit_in__hcce3eeaf87129ab3() {
  var $0 = 0;
  label$1 : {
   $0 = alloc__boxed__Box_T_2cA___try_new_uninit_in__h1af310840d33a3ab() | 0;
   if (!$0) {
    break label$1
   }
   return $0 | 0;
  }
  alloc__alloc__handle_alloc_error__he269d8f1bff90960(448 | 0, 4 | 0);
  abort();
 }
 
 function alloc__boxed__Box_T_2cA___try_new_uninit_in__h1af310840d33a3ab() {
  var $0 = 0;
  label$1 : {
   $0 = __rust_alloc(448 | 0, 4 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $0 = 0;
  }
  return $0 | 0;
 }
 
 function alloc__boxed__Box_T_2cA___new_uninit_in__he0c425f8ad462f5a() {
  var $0 = 0;
  label$1 : {
   $0 = alloc__boxed__Box_T_2cA___try_new_uninit_in__hb93fa26e3e852577() | 0;
   if (!$0) {
    break label$1
   }
   return $0 | 0;
  }
  alloc__alloc__handle_alloc_error__he269d8f1bff90960(188 | 0, 4 | 0);
  abort();
 }
 
 function alloc__boxed__Box_T_2cA___try_new_uninit_in__hb93fa26e3e852577() {
  var $0 = 0;
  label$1 : {
   $0 = __rust_alloc(188 | 0, 4 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $0 = 0;
  }
  return $0 | 0;
 }
 
 function alloc__boxed__Box_T_2cA___new_uninit_in__hef877667b5cd207e() {
  var $0 = 0;
  label$1 : {
   $0 = alloc__boxed__Box_T_2cA___try_new_uninit_in__h430ddcd99d595648() | 0;
   if (!$0) {
    break label$1
   }
   return $0 | 0;
  }
  alloc__alloc__handle_alloc_error__he269d8f1bff90960(364 | 0, 4 | 0);
  abort();
 }
 
 function alloc__boxed__Box_T_2cA___try_new_uninit_in__h430ddcd99d595648() {
  var $0 = 0;
  label$1 : {
   $0 = __rust_alloc(364 | 0, 4 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $0 = 0;
  }
  return $0 | 0;
 }
 
 function alloc__boxed__Box_T_2cA___new_uninit_in__hf695c4eb6d2b8dd9() {
  var $0 = 0;
  label$1 : {
   $0 = alloc__boxed__Box_T_2cA___try_new_uninit_in__h56100d8f3f61bdf1() | 0;
   if (!$0) {
    break label$1
   }
   return $0 | 0;
  }
  alloc__alloc__handle_alloc_error__he269d8f1bff90960(52 | 0, 4 | 0);
  abort();
 }
 
 function alloc__boxed__Box_T_2cA___try_new_uninit_in__h56100d8f3f61bdf1() {
  var $0 = 0;
  label$1 : {
   $0 = __rust_alloc(52 | 0, 4 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $0 = 0;
  }
  return $0 | 0;
 }
 
 function alloc__boxed__Box_T_2cA___new_uninit_in__hf8493d13156d19ba() {
  var $0 = 0;
  label$1 : {
   $0 = alloc__boxed__Box_T_2cA___try_new_uninit_in__hebceb8dcab02a0a7() | 0;
   if (!$0) {
    break label$1
   }
   return $0 | 0;
  }
  alloc__alloc__handle_alloc_error__he269d8f1bff90960(1112 | 0, 8 | 0);
  abort();
 }
 
 function alloc__boxed__Box_T_2cA___try_new_uninit_in__hebceb8dcab02a0a7() {
  var $0 = 0;
  label$1 : {
   $0 = __rust_alloc(1112 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $0 = 0;
  }
  return $0 | 0;
 }
 
 function core__ptr__drop_in_place_cardano_serialization_lib__error__Key___h6509e27f4cf6a188_4($0) {
  $0 = $0 | 0;
  label$1 : {
   if (HEAP32[$0 >> 2] | 0) {
    break label$1
   }
   $0 = $0 + 4 | 0;
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
  }
 }
 
 function alloc__vec__Vec_T_2cA___shrink_to_fit__ha42fb43b13607cf8($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 8 | 0) >> 2] | 0;
   if ((HEAP32[($0 + 4 | 0) >> 2] | 0) >>> 0 <= $1 >>> 0) {
    break label$1
   }
   alloc__raw_vec__RawVec_T_2cA___shrink_to_fit__h26d1819679d696a3($0 | 0, $1 | 0);
  }
 }
 
 function alloc__boxed__Box_T_2cA___new_uninit_in__h22083d1d420f57ec() {
  var $0 = 0;
  label$1 : {
   $0 = alloc__boxed__Box_T_2cA___try_new_uninit_in__hf40e7b14c1dfa3d2() | 0;
   if (!$0) {
    break label$1
   }
   return $0 | 0;
  }
  alloc__alloc__handle_alloc_error__he269d8f1bff90960(456 | 0, 8 | 0);
  abort();
 }
 
 function alloc__boxed__Box_T_2cA___try_new_uninit_in__hf40e7b14c1dfa3d2() {
  var $0 = 0;
  label$1 : {
   $0 = __rust_alloc(456 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $0 = 0;
  }
  return $0 | 0;
 }
 
 function alloc__boxed__Box_T_2cA___new_uninit_in__h8a2711313b9ea9b8() {
  var $0 = 0;
  label$1 : {
   $0 = alloc__boxed__Box_T_2cA___try_new_uninit_in__h6d9df9b67ccb47b9() | 0;
   if (!$0) {
    break label$1
   }
   return $0 | 0;
  }
  alloc__alloc__handle_alloc_error__he269d8f1bff90960(408 | 0, 8 | 0);
  abort();
 }
 
 function alloc__boxed__Box_T_2cA___try_new_uninit_in__h6d9df9b67ccb47b9() {
  var $0 = 0;
  label$1 : {
   $0 = __rust_alloc(408 | 0, 8 | 0) | 0;
   if ($0) {
    break label$1
   }
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31();
   $0 = 0;
  }
  return $0 | 0;
 }
 
 function $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   __rust_dealloc(HEAP32[$0 >> 2] | 0 | 0, $1 | 0, 1 | 0);
  }
 }
 
 function $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hc61f5e215ed90985($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   __rust_dealloc(HEAP32[$0 >> 2] | 0 | 0, $1 | 0, 1 | 0);
  }
 }
 
 function $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h899e85abb4c3d85f($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 4 | 0) >> 2] | 0;
   if (!$1) {
    break label$1
   }
   __rust_dealloc(HEAP32[$0 >> 2] | 0 | 0, $1 | 0, 1 | 0);
  }
 }
 
 function $std__panicking__begin_panic__PanicPayload_A__20as_20core__panic__BoxMeUp___get__h8da6bdf3862d82dd($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (HEAP32[$1 >> 2] | 0) {
    break label$1
   }
   abort();
  }
  HEAP32[($0 + 4 | 0) >> 2] = 1144352;
  HEAP32[$0 >> 2] = $1;
 }
 
 function dlmalloc__dlmalloc__TreeChunk__leftmost_child__h0e0ff04b08669a58($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = HEAP32[($0 + 16 | 0) >> 2] | 0;
   if ($1) {
    break label$1
   }
   $1 = HEAP32[($0 + 20 | 0) >> 2] | 0;
  }
  return $1 | 0;
 }
 
 function core__slice__iter___impl_20core__iter__traits__collect__IntoIterator_20for_20_mut_20_5bT_5d___into_iter__haf0161a4721f1f1a($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  HEAP32[$0 >> 2] = $1;
  HEAP32[($0 + 4 | 0) >> 2] = $1 + ($2 << 2 | 0) | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___right_edge__hb28718837482d3cf($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $4;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = (HEAP32[($1 + 8 | 0) >> 2] | 0) + 1 | 0;
 }
 
 function alloc__collections__btree__node__Handle_alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cNodeType__2calloc__collections__btree__node__marker__KV___right_edge__hf795564396a070fc($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, $4 = 0;
  i64toi32_i32$0 = HEAP32[$1 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[($1 + 4 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $4;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = (HEAP32[($1 + 8 | 0) >> 2] | 0) + 1 | 0;
 }
 
 function cryptoxide__sha3__Sha3_256__new__hb1af8a9803a96acf($0) {
  $0 = $0 | 0;
  $0 = memset($0 | 0, 0 | 0, 204 | 0) | 0;
  HEAP8[($0 + 208 | 0) >> 0] = 0;
  HEAP16[($0 + 204 | 0) >> 1] = 257;
 }
 
 function rust_oom($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = HEAP32[(0 + 1177820 | 0) >> 2] | 0;
  FUNCTION_TABLE[($2 ? $2 : 273) | 0]($0, $1);
  abort();
 }
 
 function dlmalloc__dlmalloc__leftshift_for_tree_index__hd82124830437cc05($0) {
  $0 = $0 | 0;
  return (($0 | 0) == (31 | 0) ? 0 : 25 - ($0 >>> 1 | 0) | 0) | 0;
 }
 
 function dlmalloc__dlmalloc__Chunk__set_size_and_pinuse_of_free_chunk__hbc4027d35960d532($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $1 | 1 | 0;
  HEAP32[($0 + $1 | 0) >> 2] = $1;
 }
 
 function $core__cell__BorrowError_20as_20core__fmt__Debug___fmt__h59eabedd7926e86a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return FUNCTION_TABLE[HEAP32[((HEAP32[($1 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($1 + 24 | 0) >> 2] | 0, 1149436, 11) | 0 | 0;
 }
 
 function $core__cell__BorrowMutError_20as_20core__fmt__Debug___fmt__h9f860b68220e7c3b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return FUNCTION_TABLE[HEAP32[((HEAP32[($1 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($1 + 24 | 0) >> 2] | 0, 1149447, 14) | 0 | 0;
 }
 
 function core__fmt__Formatter__write_str__h8d6b3db46091fabc($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  return FUNCTION_TABLE[HEAP32[((HEAP32[($0 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($0 + 24 | 0) >> 2] | 0, $1, $2) | 0 | 0;
 }
 
 function $core__fmt__Error_20as_20core__fmt__Debug___fmt__hdcebc0a03850ca30($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return FUNCTION_TABLE[HEAP32[((HEAP32[($1 + 28 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[($1 + 24 | 0) >> 2] | 0, 1153255, 5) | 0 | 0;
 }
 
 function core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__crypto__BootstrapWitnesses____h365708acbcf06e1e($0) {
  $0 = $0 | 0;
  label$1 : {
   if (!(HEAP32[$0 >> 2] | 0)) {
    break label$1
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h28dc4dde55fe2f07($0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h79e8c51775f4d5f8($0 | 0);
  }
 }
 
 function core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__PoolMetadata____hb1232757542ed318($0) {
  $0 = $0 | 0;
  label$1 : {
   if (!(HEAP32[$0 >> 2] | 0)) {
    break label$1
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
  }
 }
 
 function core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__Certificates____h3bab90286ab8bbb4($0) {
  $0 = $0 | 0;
  label$1 : {
   if (!(HEAP32[$0 >> 2] | 0)) {
    break label$1
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h07097b699c9c8f63($0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__ha1b43c51acf8124f($0 | 0);
  }
 }
 
 function core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__NativeScripts____hdd7d461255ec800a($0) {
  $0 = $0 | 0;
  label$1 : {
   if (!(HEAP32[$0 >> 2] | 0)) {
    break label$1
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc3d6ec99c05cee40($0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h0f78886c344617d4($0 | 0);
  }
 }
 
 function core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__plutus__PlutusScripts____h6be1d55eac328b7f($0) {
  $0 = $0 | 0;
  label$1 : {
   if (!(HEAP32[$0 >> 2] | 0)) {
    break label$1
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd4b44cb226d8311d($0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h3633100df9c96e1e($0 | 0);
  }
 }
 
 function $hashbrown__raw__RawTable_T_2cA__20as_20core__ops__drop__Drop___drop__h2ba76806c3733efb($0) {
  $0 = $0 | 0;
  label$1 : {
   if (!(HEAP32[$0 >> 2] | 0)) {
    break label$1
   }
   hashbrown__raw__RawTable_T_2cA___drop_elements__h5fa5723d63f72f04($0 | 0);
   hashbrown__raw__RawTable_T_2cA___free_buckets__h3d4ebb1515e16a56($0 | 0);
  }
 }
 
 function $hashbrown__raw__RawTable_T_2cA__20as_20core__ops__drop__Drop___drop__hc75129679f205904($0) {
  $0 = $0 | 0;
  label$1 : {
   if (!(HEAP32[$0 >> 2] | 0)) {
    break label$1
   }
   hashbrown__raw__RawTable_T_2cA___drop_elements__h9bc6ee4fef8cdf88($0 | 0);
   hashbrown__raw__RawTable_T_2cA___free_buckets__h7c64645064a3fef1($0 | 0);
  }
 }
 
 function core__ptr__drop_in_place_core__option__Option_alloc__vec__Vec_u8_____ha5300c747747c3c8($0) {
  $0 = $0 | 0;
  label$1 : {
   if (!(HEAP32[$0 >> 2] | 0)) {
    break label$1
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
  }
 }
 
 function core__ptr__drop_in_place_wasm_bindgen__JsValue___hfc6b1fe11860614d($0) {
  $0 = $0 | 0;
  label$1 : {
   $0 = HEAP32[$0 >> 2] | 0;
   if ($0 >>> 0 < 36 >>> 0) {
    break label$1
   }
   wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($0 | 0);
  }
 }
 
 function core__ptr__drop_in_place_core__option__Option_alloc__string__String____h8c3a778692ea673c($0) {
  $0 = $0 | 0;
  label$1 : {
   if (!(HEAP32[$0 >> 2] | 0)) {
    break label$1
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
  }
 }
 
 function core__ptr__drop_in_place_wasm_bindgen__JsValue___hfc6b1fe11860614d_1($0) {
  $0 = $0 | 0;
  label$1 : {
   $0 = HEAP32[$0 >> 2] | 0;
   if ($0 >>> 0 < 36 >>> 0) {
    break label$1
   }
   wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($0 | 0);
  }
 }
 
 function core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__NativeScripts____hdd7d461255ec800a_1($0) {
  $0 = $0 | 0;
  label$1 : {
   if (!(HEAP32[$0 >> 2] | 0)) {
    break label$1
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc3d6ec99c05cee40($0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h0f78886c344617d4($0 | 0);
  }
 }
 
 function core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__plutus__PlutusScripts____h6be1d55eac328b7f_1($0) {
  $0 = $0 | 0;
  label$1 : {
   if (!(HEAP32[$0 >> 2] | 0)) {
    break label$1
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd4b44cb226d8311d($0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h3633100df9c96e1e($0 | 0);
  }
 }
 
 function core__ptr__drop_in_place_wasm_bindgen__JsValue___hfc6b1fe11860614d_2($0) {
  $0 = $0 | 0;
  label$1 : {
   $0 = HEAP32[$0 >> 2] | 0;
   if ($0 >>> 0 < 36 >>> 0) {
    break label$1
   }
   wasm_bindgen____wbindgen_object_drop_ref__h0ad6c4ec50dd1c00($0 | 0);
  }
 }
 
 function core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__Certificates____h3bab90286ab8bbb4_1($0) {
  $0 = $0 | 0;
  label$1 : {
   if (!(HEAP32[$0 >> 2] | 0)) {
    break label$1
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h07097b699c9c8f63($0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__ha1b43c51acf8124f($0 | 0);
  }
 }
 
 function core__ptr__drop_in_place_cardano_serialization_lib__address__ByronAddress___he7d0684706668546($0) {
  $0 = $0 | 0;
  label$1 : {
   if (!(HEAP32[$0 >> 2] | 0)) {
    break label$1
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
  }
 }
 
 function core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__NativeScripts____hdd7d461255ec800a_2($0) {
  $0 = $0 | 0;
  label$1 : {
   if (!(HEAP32[$0 >> 2] | 0)) {
    break label$1
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc3d6ec99c05cee40($0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h0f78886c344617d4($0 | 0);
  }
 }
 
 function core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__plutus__PlutusScripts____h6be1d55eac328b7f_2($0) {
  $0 = $0 | 0;
  label$1 : {
   if (!(HEAP32[$0 >> 2] | 0)) {
    break label$1
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd4b44cb226d8311d($0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__h3633100df9c96e1e($0 | 0);
  }
 }
 
 function $wasm_bindgen____rt__Ref_T__20as_20core__ops__drop__Drop___drop__h2f35f6c2409f0658($0) {
  $0 = $0 | 0;
  $0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
 }
 
 function $wasm_bindgen____rt__Ref_T__20as_20core__ops__drop__Drop___drop__h692d78b609edc7c6($0) {
  $0 = $0 | 0;
  $0 = HEAP32[($0 + 4 | 0) >> 2] | 0;
  core__cell__Cell_T___replace__h74ad9f426af36be8($0 | 0, (HEAP32[$0 >> 2] | 0) + -1 | 0 | 0) | 0;
 }
 
 function core__ptr__drop_in_place_core__option__Option_alloc__vec__Vec_u8_____ha5300c747747c3c8_1($0) {
  $0 = $0 | 0;
  label$1 : {
   if (!(HEAP32[$0 >> 2] | 0)) {
    break label$1
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
  }
 }
 
 function core__ptr__drop_in_place_core__option__Option_cardano_serialization_lib__AssetName____h5e309155feaabc90($0) {
  $0 = $0 | 0;
  label$1 : {
   if (!(HEAP32[$0 >> 2] | 0)) {
    break label$1
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
  }
 }
 
 function core__ptr__drop_in_place_core__option__Option_alloc__vec__Vec_u8_____ha5300c747747c3c8_2($0) {
  $0 = $0 | 0;
  label$1 : {
   if (!(HEAP32[$0 >> 2] | 0)) {
    break label$1
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
  }
 }
 
 function core__ptr__drop_in_place_cardano_serialization_lib__legacy_address__address__ExtendedAddr___h2c1a18aefeee766f($0) {
  $0 = $0 | 0;
  label$1 : {
   if (!(HEAP32[$0 >> 2] | 0)) {
    break label$1
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
  }
 }
 
 function core__ptr__drop_in_place_core__option__Option_alloc__vec__Vec_u8_____ha5300c747747c3c8_3($0) {
  $0 = $0 | 0;
  label$1 : {
   if (!(HEAP32[$0 >> 2] | 0)) {
    break label$1
   }
   $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
   $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
  }
 }
 
 function $T_20as_20core__convert__Into_U____into__hf73aab12363aa299($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  HEAP32[($0 + 8 | 0) >> 2] = $2;
  HEAP32[($0 + 4 | 0) >> 2] = $2;
  HEAP32[$0 >> 2] = $1;
 }
 
 function alloc__slice__hack__into_vec__h7117771ce47e6987($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  HEAP32[($0 + 8 | 0) >> 2] = $2;
  HEAP32[($0 + 4 | 0) >> 2] = $2;
  HEAP32[$0 >> 2] = $1;
 }
 
 function alloc__slice__hack__into_vec__h7c95d082cf6730ee($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  HEAP32[($0 + 8 | 0) >> 2] = $2;
  HEAP32[($0 + 4 | 0) >> 2] = $2;
  HEAP32[$0 >> 2] = $1;
 }
 
 function alloc__vec__Vec_T_2cA___truncate__hb81c32e2ad35152a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if ((HEAP32[($0 + 8 | 0) >> 2] | 0) >>> 0 < $1 >>> 0) {
    break label$1
   }
   HEAP32[($0 + 8 | 0) >> 2] = $1;
  }
 }
 
 function core__iter__adapters__enumerate__Enumerate_I___new__hc289053b3fd6bbd7($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[($0 + 4 | 0) >> 2] = $2;
  HEAP32[$0 >> 2] = $1;
 }
 
 function alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType___first_edge__h9fd77210c962450d($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[($0 + 4 | 0) >> 2] = $2;
  HEAP32[$0 >> 2] = $1;
 }
 
 function alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType___first_edge__hcd03120285185059($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[($0 + 4 | 0) >> 2] = $2;
  HEAP32[$0 >> 2] = $1;
 }
 
 function serde_json__value__Value__as_object__hc4bb3712d47c3f95($0) {
  $0 = $0 | 0;
  return ((HEAPU8[$0 >> 0] | 0 | 0) == (5 | 0) ? $0 + 4 | 0 : 0) | 0;
 }
 
 function serde_json__value__Value__as_array__h2104f0d2dc692458($0) {
  $0 = $0 | 0;
  return ((HEAPU8[$0 >> 0] | 0 | 0) == (4 | 0) ? $0 + 4 | 0 : 0) | 0;
 }
 
 function core__iter__adapters__enumerate__Enumerate_I___new__h17b92aadb2bf6535($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  HEAP32[($0 + 8 | 0) >> 2] = 0;
  HEAP32[($0 + 4 | 0) >> 2] = $2;
  HEAP32[$0 >> 2] = $1;
 }
 
 function $_T_20as_20core__fmt__Display___fmt__h305b08520ae753cb($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $0 = HEAP32[$0 >> 2] | 0;
  return FUNCTION_TABLE[HEAP32[((HEAP32[($0 + 4 | 0) >> 2] | 0) + 32 | 0) >> 2] | 0 | 0](HEAP32[$0 >> 2] | 0, $1) | 0 | 0;
 }
 
 function bech32__Bech32Writer__finalize__h8ac49edb73d669a0($0) {
  $0 = $0 | 0;
  var $1 = 0;
  label$1 : {
   $1 = bech32__Bech32Writer__inner_finalize__h40926327c64dbb3a($0 | 0) | 0;
   if (!$1) {
    break label$1
   }
   $bech32__Bech32Writer_20as_20core__ops__drop__Drop___drop__ha90a511234f1ea05($0 | 0);
  }
  return $1 | 0;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__h0e0696b6b14acb55($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $0 = HEAP32[$0 >> 2] | 0;
  return FUNCTION_TABLE[HEAP32[((HEAP32[($0 + 4 | 0) >> 2] | 0) + 36 | 0) >> 2] | 0 | 0](HEAP32[$0 >> 2] | 0, $1) | 0 | 0;
 }
 
 function core__option__Option_T___unwrap__h1337386e31e069fb($0) {
  $0 = $0 | 0;
  label$1 : {
   if ($0) {
    break label$1
   }
   core__panicking__panic__h2fd385a887c8bf13(1142444 | 0, 43 | 0, 1144280 | 0);
   abort();
  }
  return $0 | 0;
 }
 
 function core__option__Option_T___unwrap__h96fd28f0a1fc1e2b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if ($0) {
    break label$1
   }
   core__panicking__panic__h2fd385a887c8bf13(1142444 | 0, 43 | 0, $1 | 0);
   abort();
  }
  return $0 | 0;
 }
 
 function dlmalloc__dlmalloc__align_up__h1071ebba4314c5a2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return (($0 + $1 | 0) + -1 | 0) & (0 - $1 | 0) | 0 | 0;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__he9f1572a33495ebd($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $0 = HEAP32[$0 >> 2] | 0;
  return $_5bT_5d_20as_20core__fmt__Debug___fmt__h6163fbf76721580f(HEAP32[$0 >> 2] | 0 | 0, HEAP32[($0 + 8 | 0) >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function __rust_realloc($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  return __rdl_realloc($0 | 0, $1 | 0, $2 | 0, $3 | 0) | 0 | 0;
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h7a0ed8a251b429e6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  HEAP32[$0 >> 2] = HEAP32[$1 >> 2] | 0;
 }
 
 function ppv_lite86__generic__dmap__h2188f233a7e87f48($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $4 = 0, $7 = 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $4;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $7;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
 }
 
 function ppv_lite86__generic__dmap__h395c045a41d385d9($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $4 = 0, $7 = 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $4;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $7;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
 }
 
 function core__array___impl_20core__iter__traits__collect__IntoIterator_20for_20__5bT_3b_20N_5d___into_iter__h9f5650cb2f49c0d3($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $1 + 64 | 0;
  HEAP32[$0 >> 2] = $1;
 }
 
 function ppv_lite86__generic__o_of_q__hb8b715d2ffb8bacd($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, i64toi32_i32$2 = 0, $4 = 0, $7 = 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 8 | 0) >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 12 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[(i64toi32_i32$0 + 8 | 0) >> 2] = $4;
  HEAP32[(i64toi32_i32$0 + 12 | 0) >> 2] = i64toi32_i32$1;
  i64toi32_i32$1 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$0 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $7 = i64toi32_i32$1;
  i64toi32_i32$1 = $0;
  HEAP32[i64toi32_i32$1 >> 2] = $7;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
 }
 
 function alloc__vec__Vec_T_2cA___extend_from_slice__hc94444ea46344854($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend__T_2ccore__slice__iter__Iter_T_____spec_extend__h5cdab7a667860bc4($0 | 0, $1 | 0, $1 + ($2 << 2 | 0) | 0 | 0);
 }
 
 function alloc__raw_vec__RawVec_T_2cA___set_ptr__hd0068d6c1847a835($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  HEAP32[$0 >> 2] = $1;
  HEAP32[($0 + 4 | 0) >> 2] = $2 >>> 2 | 0;
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h0f0d6987a7f36efc($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  HEAP32[$0 >> 2] = HEAP32[$1 >> 2] | 0;
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__DerefMut___deref_mut__h42fc515862cf6b48($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  HEAP32[$0 >> 2] = HEAP32[$1 >> 2] | 0;
 }
 
 function alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cType___key_area_mut__h4543b6fc78f35b24($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return ((HEAP32[($0 + 4 | 0) >> 2] | 0) + Math_imul($1, 12) | 0) + 268 | 0 | 0;
 }
 
 function $_mut_20W_20as_20core__fmt__Write___write_str__h59346aadf97d89b6($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend__T_2ccore__slice__iter__Iter_T_____spec_extend__hbd860717b01c36cd(HEAP32[$0 >> 2] | 0 | 0, $1 | 0, $1 + $2 | 0 | 0);
  return 0 | 0;
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h25def2337ddd4f0a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  HEAP32[$0 >> 2] = HEAP32[$1 >> 2] | 0;
 }
 
 function core__slice__iter___impl_20core__iter__traits__collect__IntoIterator_20for_20__5bT_5d___into_iter__hc96cff628f84e170($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $1 + $2 | 0;
  HEAP32[$0 >> 2] = $1;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__hfa1df4fb7d31ae74($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $0 = HEAP32[$0 >> 2] | 0;
  return $str_20as_20core__fmt__Debug___fmt__hc85548718db4c6c4(HEAP32[$0 >> 2] | 0 | 0, HEAP32[($0 + 8 | 0) >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $_T_20as_20core__fmt__Display___fmt__h171b21869b7cf20c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $0 = HEAP32[$0 >> 2] | 0;
  return $str_20as_20core__fmt__Display___fmt__hdd03b40cdcec1d4f(HEAP32[$0 >> 2] | 0 | 0, HEAP32[($0 + 4 | 0) >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__hdebab94a1b0ec07d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $0 = HEAP32[$0 >> 2] | 0;
  return $_5bT_5d_20as_20core__fmt__Debug___fmt__hf0dfc49f672cf2ca(HEAP32[$0 >> 2] | 0 | 0, HEAP32[($0 + 8 | 0) >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h64cd24c56ba7103e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  HEAP32[$0 >> 2] = HEAP32[$1 >> 2] | 0;
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__h12ac465cd2b9ef75($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  HEAP32[$0 >> 2] = HEAP32[$1 >> 2] | 0;
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__DerefMut___deref_mut__h1882e042320a120c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  HEAP32[$0 >> 2] = HEAP32[$1 >> 2] | 0;
 }
 
 function core__slice__iter___impl_20core__iter__traits__collect__IntoIterator_20for_20__5bT_5d___into_iter__h5de9df69b0713ffb($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $1 + $2 | 0;
  HEAP32[$0 >> 2] = $1;
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__heed2de4899f9d51c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  HEAP32[$0 >> 2] = HEAP32[$1 >> 2] | 0;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__haf265c26cefbcac9($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $0 = HEAP32[$0 >> 2] | 0;
  return $str_20as_20core__fmt__Debug___fmt__hc85548718db4c6c4(HEAP32[$0 >> 2] | 0 | 0, HEAP32[($0 + 4 | 0) >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $_T_20as_20core__fmt__Display___fmt__h43292718192d8f05($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $0 = HEAP32[$0 >> 2] | 0;
  return $str_20as_20core__fmt__Display___fmt__hdd03b40cdcec1d4f(HEAP32[$0 >> 2] | 0 | 0, HEAP32[($0 + 4 | 0) >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__hf5283f180f3146a3($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $0 = HEAP32[$0 >> 2] | 0;
  return $_5bT_5d_20as_20core__fmt__Debug___fmt__h83014c73d1c7e7bd(HEAP32[$0 >> 2] | 0 | 0, HEAP32[($0 + 8 | 0) >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20core__ops__deref__Deref___deref__hd769729f4df3c4c0($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = HEAP32[($1 + 8 | 0) >> 2] | 0;
  HEAP32[$0 >> 2] = HEAP32[$1 >> 2] | 0;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__hcb67af0487091295($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $0 = HEAP32[$0 >> 2] | 0;
  return $str_20as_20core__fmt__Debug___fmt__hc85548718db4c6c4(HEAP32[$0 >> 2] | 0 | 0, HEAP32[($0 + 8 | 0) >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $_T_20as_20core__fmt__Display___fmt__h662e6a4dcf046317($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $0 = HEAP32[$0 >> 2] | 0;
  return $str_20as_20core__fmt__Display___fmt__hdd03b40cdcec1d4f(HEAP32[$0 >> 2] | 0 | 0, HEAP32[($0 + 8 | 0) >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $cbor_event__error__Error_20as_20core__convert__From_std__io__error__Error____from__hd172f94a2e75bf41($0, $1, $1$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $1$hi = $1$hi | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0;
  HEAP8[$0 >> 0] = 16;
  i64toi32_i32$0 = $1$hi;
  i64toi32_i32$1 = $0 + 4 | 0;
  HEAP32[i64toi32_i32$1 >> 2] = $1;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
 }
 
 function __wbindgen_free($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  label$1 : {
   if (!$1) {
    break label$1
   }
   __rust_dealloc($0 | 0, $1 | 0, 4 | 0);
  }
 }
 
 function dlmalloc__dlmalloc__left_bits__hea1a8ecbc54c753a($0) {
  $0 = $0 | 0;
  $0 = $0 << 1 | 0;
  return $0 | (0 - $0 | 0) | 0 | 0;
 }
 
 function int_new_i32($0) {
  $0 = $0 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$4 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, $9 = 0, $4 = 0, $4$hi = 0, $6$hi = 0;
  i64toi32_i32$1 = $0;
  i64toi32_i32$0 = i64toi32_i32$1 >> 31 | 0;
  $4 = i64toi32_i32$1;
  $4$hi = i64toi32_i32$0;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 63;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$0 >> 31 | 0;
   $9 = i64toi32_i32$0 >> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$0 >> i64toi32_i32$4 | 0;
   $9 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  $6$hi = i64toi32_i32$1;
  i64toi32_i32$1 = $4$hi;
  i64toi32_i32$2 = $6$hi;
  return $cardano_serialization_lib__utils__Int_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hac86427717971799($4 | 0, i64toi32_i32$1 | 0, $9 | 0, i64toi32_i32$2 | 0) | 0 | 0;
 }
 
 function core__cell__Cell_T___replace__h74ad9f426af36be8($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var $2 = 0;
  $2 = HEAP32[$0 >> 2] | 0;
  HEAP32[$0 >> 2] = $1;
  return $2 | 0;
 }
 
 function $alloc__boxed__Box_T_2cA__20as_20core__fmt__Display___fmt__h2524da7abaae9d3c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return FUNCTION_TABLE[HEAP32[((HEAP32[($0 + 4 | 0) >> 2] | 0) + 32 | 0) >> 2] | 0 | 0](HEAP32[$0 >> 2] | 0, $1) | 0 | 0;
 }
 
 function $alloc__vec__Vec_u8__20as_20bech32__FromBase32___from_base32__h6e67b5484009b518($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  bech32__convert_bits__h33858259079f1ea0($0 | 0, $1 | 0, $2 | 0, 5 | 0, 8 | 0, 0 | 0);
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__he998d6e73e28558b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return FUNCTION_TABLE[HEAP32[((HEAP32[($0 + 4 | 0) >> 2] | 0) + 12 | 0) >> 2] | 0 | 0](HEAP32[$0 >> 2] | 0, $1) | 0 | 0;
 }
 
 function core__fmt__builders__DebugMap__entry__he6646ea181c84a56($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  return core__fmt__builders__DebugMap__value__h19c9df82a455cf6d(core__fmt__builders__DebugMap__key__h5f98dea42a0b977d($0 | 0, $1 | 0, $2 | 0) | 0 | 0, $3 | 0, $4 | 0) | 0 | 0;
 }
 
 function cardano_serialization_lib__serialization___impl_20cbor_event__se__Serialize_20for_20cardano_serialization_lib__NetworkId___serialize__h73892ae14f8b751c($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0;
  i64toi32_i32$1 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($0 | 0, $2 | 0, 0 | 0, HEAPU8[$1 >> 0] | 0 | 0, i64toi32_i32$1 | 0);
 }
 
 function std__error__Error__description__h50ef725cdf586bc7($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = 40;
  HEAP32[$0 >> 2] = 1061128;
 }
 
 function std__error__Error__description__hdb04605b8647d06d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = 40;
  HEAP32[$0 >> 2] = 1061128;
 }
 
 function std__error__Error__description__hfd6138aaf97ae865($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = 40;
  HEAP32[$0 >> 2] = 1061128;
 }
 
 function $cardano_serialization_lib__plutus__RedeemerTagKind_20as_20cbor_event__se__Serialize___serialize__h18a0e36a2b8a390e($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  var i64toi32_i32$1 = 0;
  i64toi32_i32$1 = 0;
  cbor_event__se__Serializer_W___write_type__h488e226e5ded2b4c($0 | 0, $2 | 0, 0 | 0, HEAPU8[$1 >> 0] | 0 | 0, i64toi32_i32$1 | 0);
 }
 
 function __rust_alloc($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return __rdl_alloc($0 | 0, $1 | 0) | 0 | 0;
 }
 
 function __rust_alloc_zeroed($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return __rdl_alloc_zeroed($0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $core__slice__iter__Iter_T__20as_20core__iter__traits__iterator__Iterator_____iterator_get_unchecked__h62b174a6566db0dc($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return (HEAP32[$0 >> 2] | 0) + ($1 << 4 | 0) | 0 | 0;
 }
 
 function $rand_chacha__chacha__Array64_T__20as_20core__convert__AsRef__5bT_5d____as_ref__h92537188a965f192($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = 64;
  HEAP32[$0 >> 2] = $1;
 }
 
 function $rand_chacha__chacha__Array64_T__20as_20core__convert__AsMut__5bT_5d____as_mut__h28c15f7aad85224d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = 64;
  HEAP32[$0 >> 2] = $1;
 }
 
 function ppv_lite86__generic__q_of_o__h249a42d67ddc4145($0, $1, $1$hi, $2, $2$hi) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $1$hi = $1$hi | 0;
  $2 = $2 | 0;
  $2$hi = $2$hi | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0;
  i64toi32_i32$0 = $2$hi;
  i64toi32_i32$1 = $0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = $2;
  HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = $1$hi;
  HEAP32[i64toi32_i32$1 >> 2] = $1;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
 }
 
 function core__fmt__ArgumentV1__new__h66761e613e2355ba($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $2;
  HEAP32[$0 >> 2] = $1;
 }
 
 function std__error__Error__description__h7aea421d34219fbb($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = 40;
  HEAP32[$0 >> 2] = 1075116;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__h2fbd287ca497afce($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return $str_20as_20core__fmt__Debug___fmt__hc85548718db4c6c4(HEAP32[$0 >> 2] | 0 | 0, HEAP32[($0 + 4 | 0) >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function core__iter__adapters__rev__Rev_T___new__h8896c06445f3ae2d($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $2;
  HEAP32[$0 >> 2] = $1;
 }
 
 function core__iter__adapters__rev__Rev_T___new__h91ca0d56df8c38ae($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $2;
  HEAP32[$0 >> 2] = $1;
 }
 
 function alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cType___val_area_mut__h4d6e54cf944c1a2a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return (HEAP32[($0 + 4 | 0) >> 2] | 0) + Math_imul($1, 24) | 0 | 0;
 }
 
 function alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $alloc__vec__Vec_T_2cA__20as_20alloc__vec__spec_extend__SpecExtend__T_2ccore__slice__iter__Iter_T_____spec_extend__hbd860717b01c36cd($0 | 0, $1 | 0, $1 + $2 | 0 | 0);
 }
 
 function core__iter__adapters__rev__Rev_T___new__h11ed92efd1d68010($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $2;
  HEAP32[$0 >> 2] = $1;
 }
 
 function core__fmt__ArgumentV1__new__h56a0e5bff2bd9085($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $2;
  HEAP32[$0 >> 2] = $1;
 }
 
 function core__fmt__ArgumentV1__new__ha12055661e6add2a($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $2;
  HEAP32[$0 >> 2] = $1;
 }
 
 function core__fmt__ArgumentV1__new__hfe8bfc123be7fc32($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $2;
  HEAP32[$0 >> 2] = $1;
 }
 
 function $T_20as_20core__convert__From_T____from__hdc7a25b0559550b4($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $2;
  HEAP32[$0 >> 2] = $1;
 }
 
 function $_T_20as_20core__fmt__Display___fmt__h64bb12b80b94ab78($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return $str_20as_20core__fmt__Display___fmt__hdd03b40cdcec1d4f(HEAP32[$0 >> 2] | 0 | 0, HEAP32[($0 + 4 | 0) >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function core__fmt__ArgumentV1__new__h021aa801e74cb4b6($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $2;
  HEAP32[$0 >> 2] = $1;
 }
 
 function core__fmt__ArgumentV1__new__h558c4eaf8ff4cba2($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $2;
  HEAP32[$0 >> 2] = $1;
 }
 
 function core__fmt__ArgumentV1__new__h5702524f4c8ddc75($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $2;
  HEAP32[$0 >> 2] = $1;
 }
 
 function core__fmt__ArgumentV1__new__hb80fee3ef14de7d5($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $2;
  HEAP32[$0 >> 2] = $1;
 }
 
 function core__fmt__ArgumentV1__new__hbd2b9e6635c55d43($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $2;
  HEAP32[$0 >> 2] = $1;
 }
 
 function core__fmt__ArgumentV1__new__hc180267ccf44df88($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $2;
  HEAP32[$0 >> 2] = $1;
 }
 
 function $_T_20as_20core__fmt__Display___fmt__h96e9527da2d2bc4d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return $str_20as_20core__fmt__Display___fmt__hdd03b40cdcec1d4f(HEAP32[$0 >> 2] | 0 | 0, HEAP32[($0 + 4 | 0) >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function cryptoxide__digest__Digest__output_bytes__h2bb3c7fed18288f4($0) {
  $0 = $0 | 0;
  return (($cryptoxide__sha2__Sha512_20as_20cryptoxide__digest__Digest___output_bits__h3225a21b01e3cca9($0 | 0) | 0) + 7 | 0) >>> 3 | 0 | 0;
 }
 
 function $ed25519_bip32__key__XPrv_20as_20core__convert__AsRef__5bu8_5d____as_ref__h44c8f06901e0335a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = 96;
  HEAP32[$0 >> 2] = $1;
 }
 
 function $ed25519_bip32__key__XPub_20as_20core__convert__AsRef__5bu8_5d____as_ref__h69a664c2b5ee8b25($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = 64;
  HEAP32[$0 >> 2] = $1;
 }
 
 function core__iter__adapters__take__Take_I___new__h57f06669aa0e5753($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  HEAP8[($0 + 4 | 0) >> 0] = $1;
  HEAP32[$0 >> 2] = $2;
 }
 
 function core__array___impl_20core__convert__TryFrom___5bT_5d__20for_20__5bT_3b_20N_5d___try_from__hcd1b24c5ed929e22($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return (($1 | 0) == (4 | 0) ? $0 : 0) | 0;
 }
 
 function core__array___impl_20core__convert__TryFrom___5bT_5d__20for_20__5bT_3b_20N_5d___try_from__hff8e53c357d25f23($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return (($1 | 0) == (32 | 0) ? $0 : 0) | 0;
 }
 
 function core__array___impl_20core__convert__TryFrom__mut_20_5bT_5d__20for_20_mut_20_5bT_3b_20N_5d___try_from__hec62152834a951b6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return (($1 | 0) == (8 | 0) ? $0 : 0) | 0;
 }
 
 function $_T_20as_20core__fmt__Display___fmt__h69d97a1df3c03254($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return $str_20as_20core__fmt__Display___fmt__hdd03b40cdcec1d4f(HEAP32[$0 >> 2] | 0 | 0, HEAP32[($0 + 4 | 0) >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function core__fmt__ArgumentV1__new__h25164bba1e78c05a($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $2;
  HEAP32[$0 >> 2] = $1;
 }
 
 function core__fmt__ArgumentV1__new__h3d5a6d2b66a66ab8($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $2;
  HEAP32[$0 >> 2] = $1;
 }
 
 function core__fmt__ArgumentV1__new__h55f06327b351e3f1($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $2;
  HEAP32[$0 >> 2] = $1;
 }
 
 function core__fmt__ArgumentV1__new__h67b517e324fc8963($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $2;
  HEAP32[$0 >> 2] = $1;
 }
 
 function $alloc__string__String_20as_20core__fmt__Display___fmt__hc15dcc93124260dc_5($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return $str_20as_20core__fmt__Display___fmt__hdd03b40cdcec1d4f(HEAP32[$0 >> 2] | 0 | 0, HEAP32[($0 + 8 | 0) >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function __wbindgen_exn_store($0) {
  $0 = $0 | 0;
  HEAP32[(0 + 1177768 | 0) >> 2] = $0;
  HEAP32[(0 + 1177764 | 0) >> 2] = 1;
 }
 
 function $T_20as_20core__convert__From_T____from__habe767dd23f4ed05($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $2;
  HEAP32[$0 >> 2] = $1;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__h4bd9dd630f0e137b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return $str_20as_20core__fmt__Debug___fmt__hc85548718db4c6c4(HEAP32[$0 >> 2] | 0 | 0, HEAP32[($0 + 4 | 0) >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $_T_20as_20core__fmt__Display___fmt__h1acaf975596d7be1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return $str_20as_20core__fmt__Display___fmt__hdd03b40cdcec1d4f(HEAP32[$0 >> 2] | 0 | 0, HEAP32[($0 + 4 | 0) >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $alloc__string__String_20as_20core__fmt__Debug___fmt__h761c2dbab983b314_1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return $str_20as_20core__fmt__Debug___fmt__hc85548718db4c6c4(HEAP32[$0 >> 2] | 0 | 0, HEAP32[($0 + 8 | 0) >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $alloc__string__String_20as_20core__fmt__Display___fmt__hc15dcc93124260dc_6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return $str_20as_20core__fmt__Display___fmt__hdd03b40cdcec1d4f(HEAP32[$0 >> 2] | 0 | 0, HEAP32[($0 + 8 | 0) >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $std__panicking__begin_panic_handler__StrPanicPayload_20as_20core__panic__BoxMeUp___get__h219bbb7050b46269($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = 1144352;
  HEAP32[$0 >> 2] = $1;
 }
 
 function std__sys__wasm__common__hashmap_random_keys__h35a1ce888f441401($0) {
  $0 = $0 | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0;
  i64toi32_i32$1 = $0;
  i64toi32_i32$0 = 0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = 2;
  HEAP32[(i64toi32_i32$1 + 12 | 0) >> 2] = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  HEAP32[i64toi32_i32$1 >> 2] = 1;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = i64toi32_i32$0;
 }
 
 function dlmalloc__dlmalloc__Chunk__cinuse__hfa8040b8ff348e52($0) {
  $0 = $0 | 0;
  return ((HEAPU8[($0 + 4 | 0) >> 0] | 0) & 2 | 0) >>> 1 | 0 | 0;
 }
 
 function dlmalloc__dlmalloc__Chunk__clear_pinuse__h2a00a020eb5c5082($0) {
  $0 = $0 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = (HEAP32[($0 + 4 | 0) >> 2] | 0) & -2 | 0;
 }
 
 function dlmalloc__dlmalloc__Chunk__inuse__h180ffa176be4dba6($0) {
  $0 = $0 | 0;
  return ((HEAP32[($0 + 4 | 0) >> 2] | 0) & 3 | 0 | 0) != (1 | 0) | 0;
 }
 
 function $_T_20as_20core__fmt__Display___fmt__h56c3642604b71e34($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return core__fmt__Formatter__pad__h381b7c9eef015e8b($1 | 0, HEAP32[$0 >> 2] | 0 | 0, HEAP32[($0 + 4 | 0) >> 2] | 0 | 0) | 0 | 0;
 }
 
 function core__fmt__Formatter__debug_lower_hex__h8226cdf2ca894293($0) {
  $0 = $0 | 0;
  return ((HEAPU8[$0 >> 0] | 0) & 16 | 0) >>> 4 | 0 | 0;
 }
 
 function core__fmt__Formatter__debug_upper_hex__h837fa1522c833b74($0) {
  $0 = $0 | 0;
  return ((HEAPU8[$0 >> 0] | 0) & 32 | 0) >>> 5 | 0 | 0;
 }
 
 function $alloc__string__String_20as_20core__fmt__Write___write_str__hed6694d3c7c6a012($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($0 | 0, $1 | 0, $2 | 0);
  return 0 | 0;
 }
 
 function $alloc__string__String_20as_20core__fmt__Write___write_str__hed6694d3c7c6a012_1($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($0 | 0, $1 | 0, $2 | 0);
  return 0 | 0;
 }
 
 function $alloc__string__String_20as_20core__fmt__Write___write_str__hed6694d3c7c6a012_2($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($0 | 0, $1 | 0, $2 | 0);
  return 0 | 0;
 }
 
 function $alloc__string__String_20as_20core__fmt__Write___write_str__hed6694d3c7c6a012_3($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($0 | 0, $1 | 0, $2 | 0);
  return 0 | 0;
 }
 
 function $alloc__string__String_20as_20core__fmt__Write___write_str__hed6694d3c7c6a012_4($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($0 | 0, $1 | 0, $2 | 0);
  return 0 | 0;
 }
 
 function $alloc__string__String_20as_20core__fmt__Write___write_str__hed6694d3c7c6a012_5($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  alloc__vec__Vec_T_2cA___extend_from_slice__h48c48aec23dfe5cb($0 | 0, $1 | 0, $2 | 0);
  return 0 | 0;
 }
 
 function __rust_dealloc($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  __rdl_dealloc($0 | 0, $1 | 0, $2 | 0);
  return;
 }
 
 function $rand_chacha__chacha__Array64_T__20as_20core__default__Default___default__hc22bd4d391ff716e($0) {
  $0 = $0 | 0;
  memset($0 | 0, 0 | 0, 256 | 0) | 0;
 }
 
 function js_sys__Uint8Array__subarray__h61dedba10f10fd0e($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  return js_sys__Uint8Array__subarray____wbg_subarray_901ede8318da52a6__h26391248f17215ed(HEAP32[$0 >> 2] | 0 | 0, $1 | 0, $2 | 0) | 0 | 0;
 }
 
 function rand_core__error__ErrorKind__should_retry__h9bc202e7c0f6515a($0) {
  $0 = $0 | 0;
  return ($0 & 255 | 0 | 0) != (0 | 0) | 0;
 }
 
 function rand_core__error__ErrorKind__should_wait__hbe6d5f14d015f403($0) {
  $0 = $0 | 0;
  return ($0 & 255 | 0 | 0) == (3 | 0) | 0;
 }
 
 function core__slice___impl_20_5bT_5d___clone_from_slice__h1742dfbd5d5d9efd($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  core__slice___impl_20_5bT_5d___copy_from_slice__h0f69c19ed1852955($0 | 0, $1 | 0, $2 | 0, $3 | 0);
 }
 
 function ed25519_bip32__key__XPrv__get_extended_mut__h396b8224008dfa18($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  core__slice___impl_20_5bT_5d___copy_from_slice__h0f69c19ed1852955($1 | 0, 64 | 0, $0 | 0, 64 | 0);
 }
 
 function $ed25519_bip32__key__XPrv_20as_20core__ops__drop__Drop___drop__h041b586f91562314($0) {
  $0 = $0 | 0;
  memset($0 | 0, 0 | 0, 96 | 0) | 0;
 }
 
 function ed25519_bip32__key__XPub__from_bytes__hd8f9fabe30c0d335($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  memcpy($0 | 0, $1 | 0, 64 | 0) | 0;
 }
 
 function ed25519_bip32__key__XPub__get_without_chaincode__h1b3f335862724d9d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  core__slice___impl_20_5bT_5d___copy_from_slice__h0f69c19ed1852955($1 | 0, 32 | 0, $0 | 0, 32 | 0);
 }
 
 function ed25519_bip32__key___impl_20core__convert__From_ed25519_bip32__key__XPub__20for_20_5bu8_3b_20__5d___from__h36378fdf85348fc4($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  memcpy($0 | 0, $1 | 0, 64 | 0) | 0;
 }
 
 function $cbor_event__types__Type_20as_20core__convert__From_u8____from__h07b856831bfcd5be($0) {
  $0 = $0 | 0;
  return ($0 & 224 | 0) >>> 5 | 0 | 0;
 }
 
 function std__sys__wasm__thread__Thread__sleep__h5b204e55015f2560() {
  std__panicking__begin_panic__h7867d4da632f3661(1145440 | 0, 11 | 0, 1145500 | 0);
  abort();
 }
 
 function $std__io__Guard_20as_20core__ops__drop__Drop___drop__h461f186cd487a5a1($0) {
  $0 = $0 | 0;
  HEAP32[((HEAP32[$0 >> 2] | 0) + 8 | 0) >> 2] = HEAP32[($0 + 4 | 0) >> 2] | 0;
 }
 
 function std__sys__wasm__condvar__Condvar__wait__hd180f854a5906989($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  std__panicking__begin_panic__h7867d4da632f3661(1145244 | 0, 26 | 0, 1145320 | 0);
  abort();
 }
 
 function dlmalloc__dlmalloc__least_bit__hdec43f25959d8304($0) {
  $0 = $0 | 0;
  return (0 - $0 | 0) & $0 | 0 | 0;
 }
 
 function dlmalloc__dlmalloc__Chunk__mmapped__h896a47bc7b87f942($0) {
  $0 = $0 | 0;
  return !((HEAPU8[($0 + 4 | 0) >> 0] | 0) & 3 | 0) | 0;
 }
 
 function dlmalloc__dlmalloc__Chunk__set_size_and_pinuse_of_inuse_chunk__hf4d697bb61df28bc($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  HEAP32[($0 + 4 | 0) >> 2] = $1 | 3 | 0;
 }
 
 function dlmalloc__dlmalloc__Segment__top__hf63c2d8a250d607b($0) {
  $0 = $0 | 0;
  return (HEAP32[$0 >> 2] | 0) + (HEAP32[($0 + 4 | 0) >> 2] | 0) | 0 | 0;
 }
 
 function $_mut_20W_20as_20core__fmt__Write___write_char__h60f487e2ced0041f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  alloc__string__String__push__hfac6e344dab69dd1(HEAP32[$0 >> 2] | 0 | 0, $1 | 0);
  return 0 | 0;
 }
 
 function alloc__raw_vec__capacity_overflow__h51312004a31f0ea6() {
  core__panicking__panic__h2fd385a887c8bf13(1145912 | 0, 17 | 0, 1145932 | 0);
  abort();
 }
 
 function core__ops__function__FnOnce__call_once__h44a533a080388641($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  HEAP32[$0 >> 2] | 0;
  label$1 : while (1) continue label$1;
 }
 
 function core__fmt__num__imp___impl_20core__fmt__Display_20for_20u32___fmt__h84f076c5e5d839ee($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0;
  i64toi32_i32$1 = 0;
  return core__fmt__num__imp__fmt_u64__hf0469431dace4046(HEAP32[$0 >> 2] | 0 | 0, i64toi32_i32$1 | 0, 1 | 0, $1 | 0) | 0 | 0;
 }
 
 function core__fmt__builders__DebugSet__entry__he7b13b90636ac2b8($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  core__fmt__builders__DebugInner__entry__hc1bb9451bcfce59d($0 | 0, $1 | 0, $2 | 0);
  return $0 | 0;
 }
 
 function $_mut_20W_20as_20core__fmt__Write___write_str__h46dcb95720f7397e($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  return $core__fmt__builders__PadAdapter_20as_20core__fmt__Write___write_str__h2104fbe324f8507b(HEAP32[$0 >> 2] | 0 | 0, $1 | 0, $2 | 0) | 0 | 0;
 }
 
 function core__fmt__num__imp___impl_20core__fmt__Display_20for_20u8___fmt__hca5329c05d9840ca($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$1 = 0;
  i64toi32_i32$1 = 0;
  return core__fmt__num__imp__fmt_u64__hf0469431dace4046(HEAPU8[$0 >> 0] | 0 | 0, i64toi32_i32$1 | 0, 1 | 0, $1 | 0) | 0 | 0;
 }
 
 function core__fmt__num__imp___impl_20core__fmt__Display_20for_20u64___fmt__h6488d819d41312fb($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$1 = 0;
  i64toi32_i32$2 = $0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  return core__fmt__num__imp__fmt_u64__hf0469431dace4046(HEAP32[i64toi32_i32$2 >> 2] | 0 | 0, i64toi32_i32$1 | 0, 1 | 0, $1 | 0) | 0 | 0;
 }
 
 function core__num___impl_20core__str__traits__FromStr_20for_20i128___from_str__hcd24f923cb24d499($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  core__num__from_str_radix__hec67a0886509d445($0 | 0, $1 | 0, $2 | 0, 10 | 0);
 }
 
 function __wbindgen_add_to_stack_pointer($0) {
  $0 = $0 | 0;
  global$0 = $0 + global$0 | 0;
  return global$0 | 0;
 }
 
 function core__ptr__drop_in_place_alloc__string__String___h73e7752754206ea3($0) {
  $0 = $0 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__h2b4a3bc8b86b3b01($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return $cardano_serialization_lib__utils__Int_20as_20core__fmt__Debug___fmt__h722c5f6072e7fe71(HEAP32[$0 >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function core__ptr__drop_in_place_alloc__string__String___h73e7752754206ea3_1($0) {
  $0 = $0 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__h396617286d1a2d93($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return $cardano_serialization_lib__metadata__MetadataMap_20as_20core__fmt__Debug___fmt__h3d9317a229daf747(HEAP32[$0 >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__haad37a6750526a31($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return $cardano_serialization_lib__metadata__MetadataList_20as_20core__fmt__Debug___fmt__hff4392738482f58f(HEAP32[$0 >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__hadd5b9ecb654d557($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return $cardano_serialization_lib__metadata__TransactionMetadatumEnum_20as_20core__fmt__Debug___fmt__hc14eef2169db3178(HEAP32[$0 >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__hc33b8a57fce2f1d4($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return $cardano_serialization_lib__metadata__TransactionMetadatum_20as_20core__fmt__Debug___fmt__h4fe7646462d1b2ad(HEAP32[$0 >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function core__ptr__drop_in_place_alloc__string__String___h73e7752754206ea3_2($0) {
  $0 = $0 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__h003cf3151c1e454b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return $cardano_serialization_lib__chain_crypto__sign__SignatureError_20as_20core__fmt__Debug___fmt__ha48c9453b982befc(HEAP32[$0 >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__h9ab81746e7498710($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return $linked_hash_map__LinkedHashMap_A_2cB_2cS__20as_20core__fmt__Debug___fmt__h35f30f182166235c(HEAP32[$0 >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $_T_20as_20core__fmt__Display___fmt__h96bc56ec575a7bd0($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return $cardano_serialization_lib__error__Key_20as_20core__fmt__Display___fmt__hebab90d6fb84080f(HEAP32[$0 >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $_T_20as_20core__fmt__Display___fmt__hb125e8a6463e2088($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return $cardano_serialization_lib__chain_crypto__sign__SignatureError_20as_20core__fmt__Display___fmt__hc1e2bc8a8ccd1f41(HEAP32[$0 >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $_T_20as_20core__fmt__Display___fmt__hd1afaeeeb58cf900($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return $cardano_serialization_lib__chain_crypto__key__PublicKeyError_20as_20core__fmt__Display___fmt__hc004f7b5f3685acc(HEAP32[$0 >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function core__ptr__drop_in_place_alloc__string__String___h73e7752754206ea3_3($0) {
  $0 = $0 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
 }
 
 function $_28_29_20as_20core__fmt__Debug___fmt__hccf17f88be497811($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return core__fmt__Formatter__pad__h381b7c9eef015e8b($1 | 0, 1067384 | 0, 2 | 0) | 0 | 0;
 }
 
 function $_28_29_20as_20core__fmt__Debug___fmt__hccf17f88be497811_1($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return core__fmt__Formatter__pad__h381b7c9eef015e8b($1 | 0, 1068688 | 0, 2 | 0) | 0 | 0;
 }
 
 function core__ptr__drop_in_place_alloc__string__String___h73e7752754206ea3_4($0) {
  $0 = $0 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__h8022ee0c495ac1af($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return $cardano_serialization_lib__legacy_address__base58__Error_20as_20core__fmt__Debug___fmt__h95efd4e0115e0805(HEAP32[$0 >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function core__ptr__drop_in_place_alloc__string__String___h73e7752754206ea3_5($0) {
  $0 = $0 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
 }
 
 function core__ptr__drop_in_place_alloc__string__FromUtf8Error___h8000ce6077c17165($0) {
  $0 = $0 | 0;
  $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0 | 0);
  $alloc__raw_vec__RawVec_T_2cA__20as_20core__ops__drop__Drop___drop__hfed3ce53c6527ce2($0 | 0);
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__h126e9e24d530c074($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return $cbor_event__error__Error_20as_20core__fmt__Debug___fmt__h24703f8b05f4c892(HEAP32[$0 >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__h3b47bddaf36efc84($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return $hex__error__FromHexError_20as_20core__fmt__Debug___fmt__ha7d55c24ed9afcca(HEAP32[$0 >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function __rust_alloc_error_handler($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  __rg_oom($0 | 0, $1 | 0);
  return;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__h53f1df4c1873d6ae($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return $num_bigint__BigIntErrorKind_20as_20core__fmt__Debug___fmt__h3aa704244e803989(HEAP32[$0 >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function alloc__collections__btree__node__NodeRef_BorrowType_2cK_2cV_2cType___reborrow__h3203744247f22569($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $4 = 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $4;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
 }
 
 function alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Mut_2cK_2cV_2cType___len_mut__h99e932b8979f4b92($0) {
  $0 = $0 | 0;
  return (HEAP32[($0 + 4 | 0) >> 2] | 0) + 402 | 0 | 0;
 }
 
 function alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Owned_2cK_2cV_2cType___borrow_mut__h53ccf72dd46326bf($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$1 = 0, $4 = 0;
  i64toi32_i32$2 = $1;
  i64toi32_i32$0 = HEAP32[i64toi32_i32$2 >> 2] | 0;
  i64toi32_i32$1 = HEAP32[(i64toi32_i32$2 + 4 | 0) >> 2] | 0;
  $4 = i64toi32_i32$0;
  i64toi32_i32$0 = $0;
  HEAP32[i64toi32_i32$0 >> 2] = $4;
  HEAP32[(i64toi32_i32$0 + 4 | 0) >> 2] = i64toi32_i32$1;
 }
 
 function $serde_json__error__Error_20as_20core__fmt__Display___fmt__h9e9840cbd4820f76($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return $serde_json__error__ErrorImpl_20as_20core__fmt__Display___fmt__h871d3b80149707c3(HEAP32[$0 >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $_T_20as_20core__fmt__Display___fmt__hde401ac1d6884c2b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return core__fmt__num__imp___impl_20core__fmt__Display_20for_20u32___fmt__h84f076c5e5d839ee(HEAP32[$0 >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__h4f7c3d7384581c5d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return $wasm_bindgen__JsValue_20as_20core__fmt__Debug___fmt__h609da9eb26b4fcb6(HEAP32[$0 >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function ed25519_bip32__key__XPrv__derive__h54fb92501f054667($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  ed25519_bip32__derivation__private__h3590740e7b55683f($0 | 0, $1 | 0, $2 | 0);
 }
 
 function ed25519_bip32__key__XPub__derive__h771befcd81af2ff6($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  ed25519_bip32__derivation__public__h71f1912d7f2e7689($0 | 0, $1 | 0, $2 | 0);
 }
 
 function $T_20as_20core__convert__TryInto_U____try_into__ha1ac58dc74faf560($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  core__array___impl_20core__convert__TryFrom___5bT_5d__20for_20_5bT_3b_20N_5d___try_from__h6b307791003c682f($0 | 0, $1 | 0, $2 | 0);
 }
 
 function $core__slice__iter__Iter_T__20as_20core__iter__traits__iterator__Iterator_____iterator_get_unchecked__h2e2d52c25f8395d6($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return (HEAP32[$0 >> 2] | 0) + $1 | 0 | 0;
 }
 
 function $core__slice__iter__IterMut_T__20as_20core__iter__traits__iterator__Iterator_____iterator_get_unchecked__h7ac01905d3a1b957($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return (HEAP32[$0 >> 2] | 0) + $1 | 0 | 0;
 }
 
 function $cryptoxide__blake2b__Blake2b_20as_20cryptoxide__digest__Digest___input__hf896b827e2ed32e6($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  cryptoxide__blake2b__Blake2b__update__hecb3567baa77731d($0 | 0, $1 | 0, $2 | 0);
 }
 
 function $cryptoxide__blake2b__Blake2b_20as_20cryptoxide__digest__Digest___result__h730aa000117361cb($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  cryptoxide__blake2b__Blake2b__finalize__h8a0df5452d79555d($0 | 0, $1 | 0, $2 | 0);
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__hd724da66daf71efd($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return $char_20as_20core__fmt__Debug___fmt__h09352abe59e90129(HEAP32[$0 >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__h328cb0f742fb0c89($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return $cbor_event__len__Len_20as_20core__fmt__Debug___fmt__hea16dfa439f453e5(HEAP32[$0 >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__h35ee7d96bb2d5d43($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return core__fmt__float___impl_20core__fmt__Debug_20for_20f64___fmt__h7a195f8cca75d85b(HEAP32[$0 >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__h6bd2b5ce49f88499($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return $bool_20as_20core__fmt__Display___fmt__h95e81cc5f4a740bb(HEAP32[$0 >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $_T_20as_20core__fmt__Binary___fmt__h237adc8341151b1c($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return core__fmt__num___impl_20core__fmt__Binary_20for_20i8___fmt__h95e145d0c624e1be(HEAP32[$0 >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $_T_20as_20core__fmt__Display___fmt__haaf6ada551131066($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return core__fmt__num__imp___impl_20core__fmt__Display_20for_20u32___fmt__h84f076c5e5d839ee(HEAP32[$0 >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $_T_20as_20core__fmt__Display___fmt__hf8bfa69300013565($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return core__fmt__num__imp___impl_20core__fmt__Display_20for_20u64___fmt__h6488d819d41312fb(HEAP32[$0 >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__h6ffc1e358c2279be($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return $alloc__string__FromUtf8Error_20as_20core__fmt__Debug___fmt__hfe44325d1a412cc5(HEAP32[$0 >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__h22c702bd66c5ce13($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return $cbor_event__types__Special_20as_20core__fmt__Debug___fmt__haaa42be3d895b1a3(HEAP32[$0 >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__hbddbe3db4f0c09ae($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return $cbor_event__types__Type_20as_20core__fmt__Debug___fmt__h132a3b04c55ccbc0(HEAP32[$0 >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__h5304d088372b045e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return $std__io__error__Error_20as_20core__fmt__Debug___fmt__hf1d86887ceb28c1f(HEAP32[$0 >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function wasm_bindgen__throw_str__h40ff0247f6a635d7($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  wasm_bindgen____wbindgen_throw__hcf6180e87a5e875d($0 | 0, $1 | 0);
  abort();
 }
 
 function wasm_bindgen____rt__throw_null__h1c7c08c9cef6040a() {
  wasm_bindgen__throw_str__h40ff0247f6a635d7(1141728 | 0, 27 | 0);
  abort();
 }
 
 function wasm_bindgen____rt__borrow_fail__h190855a7ba6992c7() {
  wasm_bindgen__throw_str__h40ff0247f6a635d7(1141755 | 0, 79 | 0);
  abort();
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__h4b7ac65500c0393d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return $char_20as_20core__fmt__Debug___fmt__h09352abe59e90129(HEAP32[$0 >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__h450b05090603950b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return $bool_20as_20core__fmt__Display___fmt__h95e81cc5f4a740bb(HEAP32[$0 >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__h5642facfe8f7744e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return $std__io__error__ErrorKind_20as_20core__fmt__Debug___fmt__hfd7e1b5a99fa67aa(HEAP32[$0 >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $_mut_20W_20as_20core__fmt__Write___write_char__hccff694a97429c55($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return core__fmt__Write__write_char__hcb93f82e62502192(HEAP32[$0 >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function std__sys_common__condvar__Condvar__wait__hd66c60e83901bc8f() {
  var $0 = 0;
  std__sys__wasm__condvar__Condvar__wait__hd180f854a5906989($0 | 0, $0 | 0);
  abort();
 }
 
 function dlmalloc__dlmalloc__Chunk__size__hbcf51483386243e4($0) {
  $0 = $0 | 0;
  return (HEAP32[($0 + 4 | 0) >> 2] | 0) & -8 | 0 | 0;
 }
 
 function dlmalloc__dlmalloc__Chunk__pinuse__h3f4a4f8063aa1f27($0) {
  $0 = $0 | 0;
  return (HEAP32[($0 + 4 | 0) >> 2] | 0) & 1 | 0 | 0;
 }
 
 function dlmalloc__dlmalloc__Segment__is_extern__hebd3849795a5a7f4($0) {
  $0 = $0 | 0;
  return (HEAP32[($0 + 12 | 0) >> 2] | 0) & 1 | 0 | 0;
 }
 
 function dlmalloc__dlmalloc__Segment__sys_flags__hb172c8f042b0bb42($0) {
  $0 = $0 | 0;
  return (HEAP32[($0 + 12 | 0) >> 2] | 0) >>> 1 | 0 | 0;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__h23f98de9ba642675($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return $core__str__error__Utf8Error_20as_20core__fmt__Debug___fmt__h3825c569e4d83e41(HEAP32[$0 >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function alloc__alloc__handle_alloc_error__he269d8f1bff90960($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  __rust_alloc_error_handler($0 | 0, $1 | 0);
  abort();
 }
 
 function __rg_oom($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  rust_oom($0 | 0, $1 | 0);
  abort();
 }
 
 function $core__num__error__TryFromIntError_20as_20core__fmt__Display___fmt__h0b3586d20b4066db($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return core__fmt__Formatter__pad__h381b7c9eef015e8b($1 | 0, 1149264 | 0, 47 | 0) | 0 | 0;
 }
 
 function $str_20as_20core__fmt__Display___fmt__hdd03b40cdcec1d4f($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  return core__fmt__Formatter__pad__h381b7c9eef015e8b($2 | 0, $0 | 0, $1 | 0) | 0 | 0;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__hd48a290fb581d84a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return core__fmt__Formatter__pad__h381b7c9eef015e8b($1 | 0, 1150620 | 0, 2 | 0) | 0 | 0;
 }
 
 function $_T_20as_20core__fmt__Debug___fmt__he5322a4e17e8a5dc($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return core__fmt__num___impl_20core__fmt__Debug_20for_20usize___fmt__h57d075c2d6ce4f59(HEAP32[$0 >> 2] | 0 | 0, $1 | 0) | 0 | 0;
 }
 
 function __wbg_ipv4_free($0) {
  $0 = $0 | 0;
  $cardano_serialization_lib__Ipv4_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h5d10bcbd75649752($0 | 0) | 0;
 }
 
 function __wbg_timelockstart_free($0) {
  $0 = $0 | 0;
  $cardano_serialization_lib__TimelockStart_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h9937d451f04455a1($0 | 0) | 0;
 }
 
 function timelockstart_new($0) {
  $0 = $0 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0;
  i64toi32_i32$0 = $T_20as_20core__convert__Into_U____into__h09f19f33dddda692($0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  return $cardano_serialization_lib__TimelockStart_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h71f9779b79ae2a49(i64toi32_i32$0 | 0, i64toi32_i32$1 | 0) | 0 | 0;
 }
 
 function __wbg_timelockexpiry_free($0) {
  $0 = $0 | 0;
  $cardano_serialization_lib__TimelockExpiry_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hb0d6bb7b9aea3e82($0 | 0) | 0;
 }
 
 function timelockexpiry_new($0) {
  $0 = $0 | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0;
  i64toi32_i32$0 = $T_20as_20core__convert__Into_U____into__h09f19f33dddda692($0 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
  return $cardano_serialization_lib__TimelockExpiry_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h701c0b7035bdc4b4(i64toi32_i32$0 | 0, i64toi32_i32$1 | 0) | 0 | 0;
 }
 
 function protocolversion_new($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return $cardano_serialization_lib__ProtocolVersion_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h721fdbbf560ad7f4($0 | 0, $1 | 0) | 0 | 0;
 }
 
 function __wbg_networkid_free($0) {
  $0 = $0 | 0;
  $cardano_serialization_lib__NetworkId_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hd21586ed92357b19($0 | 0) | 0;
 }
 
 function __wbg_bignum_free($0) {
  $0 = $0 | 0;
  $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hf909e98cc9547671($0 | 0) | 0;
 }
 
 function std__error__Error__cause__h89f1cdb59c8b681e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  HEAP32[$0 >> 2] = 0;
 }
 
 function std__error__Error__cause__hc11eaeb7a862392e($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  HEAP32[$0 >> 2] = 0;
 }
 
 function std__error__Error__cause__hf939149b8e48e454($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  HEAP32[$0 >> 2] = 0;
 }
 
 function std__error__Error__source__h36f14197a5bfd73b($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  HEAP32[$0 >> 2] = 0;
 }
 
 function std__error__Error__source__h6e9f7cbd378222f2($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  HEAP32[$0 >> 2] = 0;
 }
 
 function std__error__Error__source__hc2f2146fc957bb8d($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  HEAP32[$0 >> 2] = 0;
 }
 
 function networkinfo_new($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return $cardano_serialization_lib__address__NetworkInfo_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hb3f19bc65802218a($1 | 0, $0 | 0) | 0 | 0;
 }
 
 function networkinfo_testnet() {
  return $cardano_serialization_lib__address__NetworkInfo_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hb3f19bc65802218a(1097911063 | 0, 0 | 0) | 0 | 0;
 }
 
 function networkinfo_mainnet() {
  return $cardano_serialization_lib__address__NetworkInfo_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hb3f19bc65802218a(764824073 | 0, 1 | 0) | 0 | 0;
 }
 
 function __wbg_redeemertag_free($0) {
  $0 = $0 | 0;
  $cardano_serialization_lib__plutus__RedeemerTag_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h68accfd31b252935($0 | 0) | 0;
 }
 
 function std__error__Error__cause__hbb602d628bb1afd7($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  HEAP32[$0 >> 2] = 0;
 }
 
 function std__error__Error__source__h3bc2afb786ee1d16($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  HEAP32[$0 >> 2] = 0;
 }
 
 function alloc__vec__Vec_T_2cA___is_empty__h144b76bbfc7433d3($0) {
  $0 = $0 | 0;
  return !(HEAP32[($0 + 8 | 0) >> 2] | 0) | 0;
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___new__h241ee1a6e88d54c0($0) {
  $0 = $0 | 0;
  var i64toi32_i32$1 = 0;
  i64toi32_i32$1 = $0;
  HEAP32[(i64toi32_i32$1 + 4 | 0) >> 2] = 0;
  HEAP32[(i64toi32_i32$1 + 8 | 0) >> 2] = 0;
 }
 
 function wasm_bindgen__throw_val__hcf1b5c929d6fa472($0) {
  $0 = $0 | 0;
  wasm_bindgen____wbindgen_rethrow__h5656950dd1426493($0 | 0);
  abort();
 }
 
 function $std__io__error__Error_20as_20core__fmt__Debug___fmt__hf1d86887ceb28c1f($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return $std__io__error__Repr_20as_20core__fmt__Debug___fmt__h60bb01be6ded0137($0 | 0, $1 | 0) | 0 | 0;
 }
 
 function __rdl_alloc($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return dlmalloc__Dlmalloc_A___malloc__h25d3e8a45fd7c029($0 | 0, $1 | 0) | 0 | 0;
 }
 
 function dlmalloc__dlmalloc__Chunk__plus_offset__h7aa5253a4344ed9a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return $0 + $1 | 0 | 0;
 }
 
 function dlmalloc__dlmalloc__Chunk__minus_offset__h475b72a4870c7350($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return $0 - $1 | 0 | 0;
 }
 
 function dlmalloc__dlmalloc__Chunk__to_mem__he3242996ca597cec($0) {
  $0 = $0 | 0;
  return $0 + 8 | 0 | 0;
 }
 
 function dlmalloc__dlmalloc__Chunk__from_mem__h955f68080880f343($0) {
  $0 = $0 | 0;
  return $0 + -8 | 0 | 0;
 }
 
 function networkid_testnet() {
  return $cardano_serialization_lib__NetworkId_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hf6f78a05c9fd49e7(0 | 0) | 0 | 0;
 }
 
 function networkid_mainnet() {
  return $cardano_serialization_lib__NetworkId_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hf6f78a05c9fd49e7(1 | 0) | 0 | 0;
 }
 
 function bignum_zero() {
  return $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810(0 | 0, 0 | 0) | 0 | 0;
 }
 
 function bignum_one() {
  return $cardano_serialization_lib__utils__BigNum_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__hbf6fddccb4dca810(1 | 0, 0 | 0) | 0 | 0;
 }
 
 function __wbg_language_free($0) {
  $0 = $0 | 0;
  $cardano_serialization_lib__plutus__Language_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__hb597e561887e512b($0 | 0);
 }
 
 function redeemertag_new_spend() {
  return $cardano_serialization_lib__plutus__RedeemerTag_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h6e4777f9244e5b69(0 | 0) | 0 | 0;
 }
 
 function redeemertag_new_mint() {
  return $cardano_serialization_lib__plutus__RedeemerTag_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h6e4777f9244e5b69(1 | 0) | 0 | 0;
 }
 
 function redeemertag_new_cert() {
  return $cardano_serialization_lib__plutus__RedeemerTag_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h6e4777f9244e5b69(2 | 0) | 0 | 0;
 }
 
 function redeemertag_new_reward() {
  return $cardano_serialization_lib__plutus__RedeemerTag_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h6e4777f9244e5b69(3 | 0) | 0 | 0;
 }
 
 function __wbg_txbuilderconstants_free($0) {
  $0 = $0 | 0;
  $cardano_serialization_lib__tx_builder_constants__TxBuilderConstants_20as_20wasm_bindgen__convert__traits__FromWasmAbi___from_abi__h09016ceebb56ff1b($0 | 0);
 }
 
 function rand__rngs__thread__thread_rng__h15df01d3d7282652() {
  return std__thread__local__LocalKey_T___with__h3200a1a8d8585225(1074448 | 0) | 0 | 0;
 }
 
 function js_sys__global__hd98d5758cd3589c0() {
  return std__thread__local__LocalKey_T___with__h98ebb7adf7154db4(1076068 | 0) | 0 | 0;
 }
 
 function js_sys__Uint8Array__new_with_length__h1c6c89a5b3f70c07($0) {
  $0 = $0 | 0;
  return js_sys__Uint8Array__new_with_length____wbg_newwithlength_a8d1dbcbe703a5c6__h94c2bc7ccb6effb8($0 | 0) | 0 | 0;
 }
 
 function $T_20as_20core__convert__Into_U____into__h09f19f33dddda692($0) {
  $0 = $0 | 0;
  var i64toi32_i32$0 = 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$0;
  return $0 | 0;
 }
 
 function alloc__collections__btree__node__NodeRef_alloc__collections__btree__node__marker__Dying_2cK_2cV_2cType___as_leaf_dying__hb4e3fbf545555ed9($0) {
  $0 = $0 | 0;
  return HEAP32[($0 + 4 | 0) >> 2] | 0 | 0;
 }
 
 function alloc__collections__btree__map__BTreeMap_K_2cV___len__h9902d4fb7515c681($0) {
  $0 = $0 | 0;
  return HEAP32[($0 + 8 | 0) >> 2] | 0 | 0;
 }
 
 function wasm_bindgen____rt__malloc_failure__h5d7f43e474eb159a() {
  std__process__abort__h4249b49a3db9128b();
  abort();
 }
 
 function std__thread__sleep__h640fd39e45b76d4c($0, $0$hi, $1) {
  $0 = $0 | 0;
  $0$hi = $0$hi | 0;
  $1 = $1 | 0;
  std__sys__wasm__thread__Thread__sleep__h5b204e55015f2560();
  abort();
 }
 
 function __rdl_dealloc($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  dlmalloc__dlmalloc__Dlmalloc_A___free__h37f2ccb1260849b6($0 | 0);
 }
 
 function dlmalloc__dlmalloc__TreeChunk__next__h44ce6eba75e44ecf($0) {
  $0 = $0 | 0;
  return HEAP32[($0 + 12 | 0) >> 2] | 0 | 0;
 }
 
 function dlmalloc__dlmalloc__TreeChunk__prev__h4f72cebc901507fb($0) {
  $0 = $0 | 0;
  return HEAP32[($0 + 8 | 0) >> 2] | 0 | 0;
 }
 
 function core__panic__PanicInfo__message__hf990209c674102c0($0) {
  $0 = $0 | 0;
  return HEAP32[($0 + 8 | 0) >> 2] | 0 | 0;
 }
 
 function core__panic__PanicInfo__location__h50b64b9c30ab247b($0) {
  $0 = $0 | 0;
  return HEAP32[($0 + 12 | 0) >> 2] | 0 | 0;
 }
 
 function log2($0) {
  $0 = +$0;
  return +(+compiler_builtins__math__libm__log2__log2__hdd4a3a03f0936a68(+$0));
 }
 
 function std__error__Error__type_id__h6ecdad489073bfdf($0) {
  $0 = $0 | 0;
  i64toi32_i32$HIGH_BITS = -271702846;
  return 1040678008 | 0;
 }
 
 function std__error__Error__type_id__haf19978aef73c64a($0) {
  $0 = $0 | 0;
  i64toi32_i32$HIGH_BITS = 743213492;
  return -1524407171 | 0;
 }
 
 function std__error__Error__type_id__he3dc7f364810696a($0) {
  $0 = $0 | 0;
  i64toi32_i32$HIGH_BITS = 1090519194;
  return -1057086754 | 0;
 }
 
 function std__error__Error__backtrace__h18e109309cf07ace($0) {
  $0 = $0 | 0;
  return 0 | 0;
 }
 
 function std__error__Error__backtrace__h1b92301be9d152ad($0) {
  $0 = $0 | 0;
  return 0 | 0;
 }
 
 function std__error__Error__backtrace__h3b5992a8ca11fb6f($0) {
  $0 = $0 | 0;
  return 0 | 0;
 }
 
 function language_new_plutus_v1() {
  return $cardano_serialization_lib__plutus__Language_20as_20wasm_bindgen__convert__traits__IntoWasmAbi___into_abi__h686a48dad777e160() | 0 | 0;
 }
 
 function std__error__Error__type_id__h189003d8839d4184($0) {
  $0 = $0 | 0;
  i64toi32_i32$HIGH_BITS = -952109698;
  return 26591364 | 0;
 }
 
 function std__error__Error__backtrace__h750a1fd32b7fe9a5($0) {
  $0 = $0 | 0;
  return 0 | 0;
 }
 
 function $T_20as_20core__convert__From_T____from__hb95de13f265c6ef4($0) {
  $0 = $0 | 0;
  return $0 | 0;
 }
 
 function $T_20as_20core__convert__Into_U____into__ha09bc77f1ba4d1d1($0) {
  $0 = $0 | 0;
  return $0 | 0;
 }
 
 function $T_20as_20core__any__Any___type_id__he0380fd7a97945f6($0) {
  $0 = $0 | 0;
  i64toi32_i32$HIGH_BITS = 2129832222;
  return -322454284 | 0;
 }
 
 function $T_20as_20core__borrow__Borrow_T____borrow__h9271299964c542f1($0) {
  $0 = $0 | 0;
  return $0 | 0;
 }
 
 function $T_20as_20core__convert__From_T____from__h09bdeba94dd58819($0) {
  $0 = $0 | 0;
  return $0 | 0;
 }
 
 function $T_20as_20core__convert__Into_U____into__he8b76ade513ebd7b($0) {
  $0 = $0 | 0;
  return $0 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___allocator__hac7e8c134c0e2bb4($0) {
  $0 = $0 | 0;
  return $0 | 0;
 }
 
 function $T_20as_20core__convert__From_T____from__h2b3a9dc3dfc4c6ef($0) {
  $0 = $0 | 0;
  return $0 | 0;
 }
 
 function alloc__raw_vec__RawVec_T_2cA___allocator__hdb3b360b6f01e581($0) {
  $0 = $0 | 0;
  return $0 | 0;
 }
 
 function $cryptoxide__sha2__Sha512_20as_20cryptoxide__digest__Digest___output_bits__h3225a21b01e3cca9($0) {
  $0 = $0 | 0;
  return 512 | 0;
 }
 
 function $cryptoxide__sha2__Sha512_20as_20cryptoxide__digest__Digest___block_size__hdb82b30d40298b84($0) {
  $0 = $0 | 0;
  return 128 | 0;
 }
 
 function $T_20as_20core__convert__From_T____from__h4de36f70570b7473($0, $0$hi) {
  $0 = $0 | 0;
  $0$hi = $0$hi | 0;
  var i64toi32_i32$0 = 0;
  i64toi32_i32$0 = $0$hi;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$0;
  return $0 | 0;
 }
 
 function $T_20as_20core__any__Any___type_id__hd95ab0a6321f32a0($0) {
  $0 = $0 | 0;
  i64toi32_i32$HIGH_BITS = 2129832222;
  return -322454284 | 0;
 }
 
 function wasm_bindgen__memory__hb08a0f84a5e95eb6() {
  return wasm_bindgen____wbindgen_memory__he39953569aa4e74e() | 0 | 0;
 }
 
 function $T_20as_20core__convert__Into_U____into__h6ba7948e905b65a3($0) {
  $0 = $0 | 0;
  return $0 | 0;
 }
 
 function $T_20as_20core__any__Any___type_id__h75e12aaca4753e3d($0) {
  $0 = $0 | 0;
  i64toi32_i32$HIGH_BITS = 694082953;
  return 1463654102 | 0;
 }
 
 function $T_20as_20core__any__Any___type_id__ha776bc0eec1ceb2b($0) {
  $0 = $0 | 0;
  i64toi32_i32$HIGH_BITS = -526581453;
  return 1951090986 | 0;
 }
 
 function $T_20as_20core__any__Any___type_id__hff62f37f08b7e33d($0) {
  $0 = $0 | 0;
  i64toi32_i32$HIGH_BITS = 2129832222;
  return -322454284 | 0;
 }
 
 function std__process__abort__h4249b49a3db9128b() {
  abort();
 }
 
 function std__sys__wasm__common__decode_error_kind__h5a4431004f2950eb($0) {
  $0 = $0 | 0;
  return 40 | 0;
 }
 
 function __rust_start_panic($0) {
  $0 = $0 | 0;
  abort();
 }
 
 function dlmalloc__dlmalloc__Chunk__fencepost_head__hd9702b75b47fe031() {
  return 7 | 0;
 }
 
 function dlmalloc__dlmalloc__TreeChunk__chunk__h93f52b5b19dc8e79($0) {
  $0 = $0 | 0;
  return $0 | 0;
 }
 
 function $dlmalloc__sys__System_20as_20dlmalloc__Allocator___remap__h9cb2c0371550a3f8($0, $1, $2, $3, $4) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  $4 = $4 | 0;
  return 0 | 0;
 }
 
 function $dlmalloc__sys__System_20as_20dlmalloc__Allocator___free_part__hfb3b756bb73698d3($0, $1, $2, $3) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  $3 = $3 | 0;
  return 0 | 0;
 }
 
 function $dlmalloc__sys__System_20as_20dlmalloc__Allocator___free__h820779abf265185e($0, $1, $2) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  $2 = $2 | 0;
  return 0 | 0;
 }
 
 function $dlmalloc__sys__System_20as_20dlmalloc__Allocator___can_release_part__h23e00ec9580583cb($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
  return 0 | 0;
 }
 
 function $dlmalloc__sys__System_20as_20dlmalloc__Allocator___allocates_zeros__h4aa85cb289c3ef04($0) {
  $0 = $0 | 0;
  return 1 | 0;
 }
 
 function $dlmalloc__sys__System_20as_20dlmalloc__Allocator___page_size__h059ddbce5f954b7d($0) {
  $0 = $0 | 0;
  return 65536 | 0;
 }
 
 function hashbrown__raw__generic__Group__static_empty__hc5a7932fe1bdb1f1() {
  return 1145640 | 0;
 }
 
 function $T_20as_20core__any__Any___type_id__hc907f4034dbd0a64($0) {
  $0 = $0 | 0;
  i64toi32_i32$HIGH_BITS = -526581453;
  return 1951090986 | 0;
 }
 
 function core__panic__Location__caller__h274818dd12799e10($0) {
  $0 = $0 | 0;
  return $0 | 0;
 }
 
 function core__ptr__drop_in_place_core__fmt__Error___h485037a8fa312851($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place_core__array__TryFromSliceError___hc48a04ce4806cd2e($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place_core__array__TryFromSliceError___hc48a04ce4806cd2e_1($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place_cardano_serialization_lib__chain_crypto__key__PublicKeyError___h8875ef7c60bf0a5f($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place_cardano_serialization_lib__chain_crypto__key__SecretKeyError___hfaca729ce194302b($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place_cardano_serialization_lib__chain_crypto__sign__SignatureError___h07eeb8ab5232b07f($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__i128___he647b87223975998($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place_core__fmt__Error___h485037a8fa312851_1($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place_num_bigint__ParseBigIntError___h4209b66c1ad59342($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__alloc__vec__Vec_cardano_serialization_lib__metadata__TransactionMetadatum____h808f443fb4ca9736($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__linked_hash_map__LinkedHashMap_cardano_serialization_lib__metadata__TransactionMetadatum_2ccardano_serialization_lib__metadata__TransactionMetadatum____hec1579ce6dacd204($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place_core__fmt__Error___h485037a8fa312851_2($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__alloc__string__String___h522543eee5146f84($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__alloc__vec__Vec_u8____h5c8d9261a87424cd($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__cardano_serialization_lib__utils__Int___heb903b1147a9bc30($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__cardano_serialization_lib__metadata__MetadataMap___h7b595678c8689799($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__cardano_serialization_lib__metadata__MetadataList___h34174aa055018453($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__cardano_serialization_lib__metadata__TransactionMetadatumEnum___h27dc626d2ff569fe($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__usize___h598668a1d9f8a205($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__hex__error__FromHexError___hfc1348a5fcca3baf($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__cbor_event__types__Special___h18a6c572bdc6c4b5($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__cardano_serialization_lib__metadata__TransactionMetadatum___h2bb7404453b723c9($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__cardano_serialization_lib__chain_crypto__sign__SignatureError___hdb86ef3eb9b0beee($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place_bech32__Error___hb95291b1466c6dc4($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place_core__fmt__Error___h485037a8fa312851_3($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place_core__array__TryFromSliceError___hc48a04ce4806cd2e_2($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__28_29___h7157c4a2e1ac8f42($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__28_29___h7157c4a2e1ac8f42_1($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place_core__fmt__Error___h485037a8fa312851_4($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place_std__thread__local__AccessError___h9e391fbf265ff51a($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__usize___h598668a1d9f8a205_1($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place_bech32__Error___hb95291b1466c6dc4_1($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place_core__fmt__Error___h485037a8fa312851_5($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__cbor_event__error__Error___h9ea5b894b069c8f6($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__cardano_serialization_lib__legacy_address__base58__Error___hc75f13a3c97d0d17($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place_std__thread__local__AccessError___hd81d445558f87d22($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place_getrandom__error__Error___he5c31e4302f49944($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place_i32___hcd05c81a9a48ee1a($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place_u32___h558aa0e65b0ca649($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__str___h9271a7c969e51923($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place_std__thread__local__AccessError___hb8233780c11554b0($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place_std__thread__local__AccessError___h5df76f521a526538($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__usize___hdc84a1bdbd1af93e($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place_std__panicking__begin_panic__PanicPayload__str____hcd9fad046b6abc2d($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__str___h69350827c95d6614($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__num_bigint__BigIntErrorKind___hab61fa87e71fa35c($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__u32___h75098d33efcb5380($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__usize___hb93d831aa0560479($0) {
  $0 = $0 | 0;
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h19f76bdb6b4883ef($0) {
  $0 = $0 | 0;
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hb513c626355ab1b6($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__mut_20alloc__string__String___h23144315c7964254($0) {
  $0 = $0 | 0;
 }
 
 function $T_20as_20core__convert__From_T____from__h76063bbf12759602() {
  
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hd25e460cbc2048c7($0) {
  $0 = $0 | 0;
 }
 
 function $T_20as_20core__convert__From_T____from__hc3e19ca626cdeb31() {
  
 }
 
 function $T_20as_20core__convert__From_T____from__h05b3d0c185eed756() {
  
 }
 
 function core__ptr__drop_in_place__u8___h50fb7a8526c9f2ce($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place_core__array__TryFromSliceError___h8f6abe492ec10b06($0) {
  $0 = $0 | 0;
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__h3bd3d14231c65693($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__usize___h184ece860f2903fa($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__u8___hb56f51cee82d5a15($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__char___h1380dc6145df4a81($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place_core__fmt__Error___h7e729a863212f5dd($0) {
  $0 = $0 | 0;
 }
 
 function $alloc__vec__Vec_T_2cA__20as_20core__ops__drop__Drop___drop__hc91437b7d7fa2d3a($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place_std__panicking__begin_panic__PanicPayload__str____h990955a3d18d98f7($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__str___h0f9e933989059396($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__u64___h2687d5a7e90c9194($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__u8___hc879650f064e3222($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__f64___he931c28366501462($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__bool___hbe397e5a31d2d61c($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__u8___hc879650f064e3222_1($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__u8___hc879650f064e3222_2($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__u64___h2687d5a7e90c9194_1($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__usize___h77172d00b3cda2fa($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place___str___h1745347dcb8a9421($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__cbor_event__len__Len___hd4b619dc44c852a4($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__alloc__string__String___ha2d551f35b29906c($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__std__io__error__Error___h75e94b15230eecfd($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__cbor_event__types__Type___hdc15b9e51511171c($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__alloc__vec__Vec_u8____h61f99e980d8f5190($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__alloc__string__FromUtf8Error___h9da175c8264ce816($0) {
  $0 = $0 | 0;
 }
 
 function $T_20as_20core__convert__From_T____from__h03d182df15dd7aa6() {
  
 }
 
 function $T_20as_20core__convert__From_T____from__h649eab7147d45d59() {
  
 }
 
 function core__ptr__drop_in_place__char___h8bb41effa8165084($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__usize___h134a010e13e3f582($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__mut_20std__io__Write__write_fmt__Adaptor_alloc__vec__Vec_u8_____h5e74783d0185d756($0) {
  $0 = $0 | 0;
 }
 
 function std__alloc__default_alloc_error_hook__hcc8f6c14a1cf020a($0, $1) {
  $0 = $0 | 0;
  $1 = $1 | 0;
 }
 
 function core__ptr__drop_in_place__u8___ha5544e2185d0c057($0) {
  $0 = $0 | 0;
 }
 
 function core__ptr__drop_in_place__core__iter__adapters__copied__Copied_core__slice__iter__Iter_u8_____h3e9b71a079d16e03($0) {
  $0 = $0 | 0;
 }
 
 function _ZN17compiler_builtins3int3mul3Mul3mul17h070e9a1c69faec5bE(var$0, var$0$hi, var$1, var$1$hi) {
  var$0 = var$0 | 0;
  var$0$hi = var$0$hi | 0;
  var$1 = var$1 | 0;
  var$1$hi = var$1$hi | 0;
  var i64toi32_i32$4 = 0, i64toi32_i32$0 = 0, i64toi32_i32$1 = 0, var$2 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, var$3 = 0, var$4 = 0, var$5 = 0, $21 = 0, $22 = 0, var$6 = 0, $24 = 0, $17 = 0, $18 = 0, $23 = 0, $29 = 0, $45 = 0, $56$hi = 0, $62$hi = 0;
  i64toi32_i32$0 = var$1$hi;
  var$2 = var$1;
  var$4 = var$2 >>> 16 | 0;
  i64toi32_i32$0 = var$0$hi;
  var$3 = var$0;
  var$5 = var$3 >>> 16 | 0;
  $17 = Math_imul(var$4, var$5);
  $18 = var$2;
  i64toi32_i32$2 = var$3;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = 0;
   $21 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
   $21 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  $23 = $17 + Math_imul($18, $21) | 0;
  i64toi32_i32$1 = var$1$hi;
  i64toi32_i32$0 = var$1;
  i64toi32_i32$2 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $22 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   $22 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
  }
  $29 = $23 + Math_imul($22, var$3) | 0;
  var$2 = var$2 & 65535 | 0;
  var$3 = var$3 & 65535 | 0;
  var$6 = Math_imul(var$2, var$3);
  var$2 = (var$6 >>> 16 | 0) + Math_imul(var$2, var$5) | 0;
  $45 = $29 + (var$2 >>> 16 | 0) | 0;
  var$2 = (var$2 & 65535 | 0) + Math_imul(var$4, var$3) | 0;
  i64toi32_i32$2 = 0;
  i64toi32_i32$1 = $45 + (var$2 >>> 16 | 0) | 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 32;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
   $24 = 0;
  } else {
   i64toi32_i32$0 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$1 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$2 << i64toi32_i32$4 | 0) | 0;
   $24 = i64toi32_i32$1 << i64toi32_i32$4 | 0;
  }
  $56$hi = i64toi32_i32$0;
  i64toi32_i32$0 = 0;
  $62$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $56$hi;
  i64toi32_i32$2 = $24;
  i64toi32_i32$1 = $62$hi;
  i64toi32_i32$3 = var$2 << 16 | 0 | (var$6 & 65535 | 0) | 0;
  i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
  i64toi32_i32$2 = i64toi32_i32$2 | i64toi32_i32$3 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$1;
  return i64toi32_i32$2 | 0;
 }
 
 function _ZN17compiler_builtins3int4sdiv3Mod4mod_17h2cbb7bbf36e41d68E(var$0, var$0$hi, var$1, var$1$hi) {
  var$0 = var$0 | 0;
  var$0$hi = var$0$hi | 0;
  var$1 = var$1 | 0;
  var$1$hi = var$1$hi | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$4 = 0, i64toi32_i32$2 = 0, i64toi32_i32$0 = 0, i64toi32_i32$3 = 0, i64toi32_i32$5 = 0, var$2$hi = 0, i64toi32_i32$6 = 0, var$2 = 0, $20 = 0, $21 = 0, $7$hi = 0, $9 = 0, $9$hi = 0, $14$hi = 0, $16$hi = 0, $17$hi = 0, $19$hi = 0;
  i64toi32_i32$0 = var$0$hi;
  i64toi32_i32$2 = var$0;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 63;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$0 >> 31 | 0;
   $20 = i64toi32_i32$0 >> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$0 >> i64toi32_i32$4 | 0;
   $20 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
  }
  var$2 = $20;
  var$2$hi = i64toi32_i32$1;
  i64toi32_i32$1 = var$0$hi;
  i64toi32_i32$1 = var$2$hi;
  i64toi32_i32$0 = var$2;
  i64toi32_i32$2 = var$0$hi;
  i64toi32_i32$3 = var$0;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $7$hi = i64toi32_i32$2;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$2 = $7$hi;
  i64toi32_i32$1 = i64toi32_i32$0 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$0 = var$2$hi;
  i64toi32_i32$3 = var$2;
  i64toi32_i32$4 = i64toi32_i32$1 - i64toi32_i32$3 | 0;
  i64toi32_i32$6 = i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0;
  i64toi32_i32$5 = i64toi32_i32$6 + i64toi32_i32$0 | 0;
  i64toi32_i32$5 = i64toi32_i32$2 - i64toi32_i32$5 | 0;
  $9 = i64toi32_i32$4;
  $9$hi = i64toi32_i32$5;
  i64toi32_i32$5 = var$1$hi;
  i64toi32_i32$2 = var$1;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 63;
  i64toi32_i32$0 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$5 >> 31 | 0;
   $21 = i64toi32_i32$5 >> i64toi32_i32$0 | 0;
  } else {
   i64toi32_i32$1 = i64toi32_i32$5 >> i64toi32_i32$0 | 0;
   $21 = (((1 << i64toi32_i32$0 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$0 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$0 | 0) | 0;
  }
  var$0 = $21;
  var$0$hi = i64toi32_i32$1;
  i64toi32_i32$1 = var$1$hi;
  i64toi32_i32$1 = var$0$hi;
  i64toi32_i32$5 = var$0;
  i64toi32_i32$2 = var$1$hi;
  i64toi32_i32$3 = var$1;
  i64toi32_i32$2 = i64toi32_i32$1 ^ i64toi32_i32$2 | 0;
  $14$hi = i64toi32_i32$2;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$2 = $14$hi;
  i64toi32_i32$1 = i64toi32_i32$5 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$5 = var$0$hi;
  i64toi32_i32$3 = var$0;
  i64toi32_i32$0 = i64toi32_i32$1 - i64toi32_i32$3 | 0;
  i64toi32_i32$6 = i64toi32_i32$1 >>> 0 < i64toi32_i32$3 >>> 0;
  i64toi32_i32$4 = i64toi32_i32$6 + i64toi32_i32$5 | 0;
  i64toi32_i32$4 = i64toi32_i32$2 - i64toi32_i32$4 | 0;
  $16$hi = i64toi32_i32$4;
  i64toi32_i32$4 = $9$hi;
  i64toi32_i32$1 = $16$hi;
  i64toi32_i32$1 = __wasm_i64_urem($9 | 0, i64toi32_i32$4 | 0, i64toi32_i32$0 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$4 = i64toi32_i32$HIGH_BITS;
  $17$hi = i64toi32_i32$4;
  i64toi32_i32$4 = var$2$hi;
  i64toi32_i32$4 = $17$hi;
  i64toi32_i32$2 = i64toi32_i32$1;
  i64toi32_i32$1 = var$2$hi;
  i64toi32_i32$3 = var$2;
  i64toi32_i32$1 = i64toi32_i32$4 ^ i64toi32_i32$1 | 0;
  $19$hi = i64toi32_i32$1;
  i64toi32_i32$1 = var$2$hi;
  i64toi32_i32$1 = $19$hi;
  i64toi32_i32$4 = i64toi32_i32$2 ^ i64toi32_i32$3 | 0;
  i64toi32_i32$2 = var$2$hi;
  i64toi32_i32$5 = i64toi32_i32$4 - i64toi32_i32$3 | 0;
  i64toi32_i32$6 = i64toi32_i32$4 >>> 0 < i64toi32_i32$3 >>> 0;
  i64toi32_i32$0 = i64toi32_i32$6 + i64toi32_i32$2 | 0;
  i64toi32_i32$0 = i64toi32_i32$1 - i64toi32_i32$0 | 0;
  i64toi32_i32$4 = i64toi32_i32$5;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$0;
  return i64toi32_i32$4 | 0;
 }
 
 function _ZN17compiler_builtins3int4udiv10divmod_u6417h6026910b5ed08e40E(var$0, var$0$hi, var$1, var$1$hi) {
  var$0 = var$0 | 0;
  var$0$hi = var$0$hi | 0;
  var$1 = var$1 | 0;
  var$1$hi = var$1$hi | 0;
  var i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$4 = 0, i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$5 = 0, var$2 = 0, var$3 = 0, var$4 = 0, var$5 = 0, var$5$hi = 0, var$6 = 0, var$6$hi = 0, i64toi32_i32$6 = 0, $37 = 0, $38 = 0, $39 = 0, $40 = 0, $41 = 0, $42 = 0, $43 = 0, $44 = 0, var$8$hi = 0, $45 = 0, $46 = 0, $47 = 0, $48 = 0, var$7$hi = 0, $49 = 0, $63$hi = 0, $65 = 0, $65$hi = 0, $120$hi = 0, $129$hi = 0, $134$hi = 0, var$8 = 0, $140 = 0, $140$hi = 0, $142$hi = 0, $144 = 0, $144$hi = 0, $151 = 0, $151$hi = 0, $154$hi = 0, var$7 = 0, $165$hi = 0;
  label$1 : {
   label$2 : {
    label$3 : {
     label$4 : {
      label$5 : {
       label$6 : {
        label$7 : {
         label$8 : {
          label$9 : {
           label$10 : {
            label$11 : {
             i64toi32_i32$0 = var$0$hi;
             i64toi32_i32$2 = var$0;
             i64toi32_i32$1 = 0;
             i64toi32_i32$3 = 32;
             i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
             if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
              i64toi32_i32$1 = 0;
              $37 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
             } else {
              i64toi32_i32$1 = i64toi32_i32$0 >>> i64toi32_i32$4 | 0;
              $37 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$0 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
             }
             var$2 = $37;
             if (var$2) {
              block : {
               i64toi32_i32$1 = var$1$hi;
               var$3 = var$1;
               if (!var$3) {
                break label$11
               }
               i64toi32_i32$1 = var$1$hi;
               i64toi32_i32$0 = var$1;
               i64toi32_i32$2 = 0;
               i64toi32_i32$3 = 32;
               i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
               if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
                i64toi32_i32$2 = 0;
                $38 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
               } else {
                i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
                $38 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
               }
               var$4 = $38;
               if (!var$4) {
                break label$9
               }
               var$2 = Math_clz32(var$4) - Math_clz32(var$2) | 0;
               if (var$2 >>> 0 <= 31 >>> 0) {
                break label$8
               }
               break label$2;
              }
             }
             i64toi32_i32$2 = var$1$hi;
             i64toi32_i32$1 = var$1;
             i64toi32_i32$0 = 1;
             i64toi32_i32$3 = 0;
             if (i64toi32_i32$2 >>> 0 > i64toi32_i32$0 >>> 0 | ((i64toi32_i32$2 | 0) == (i64toi32_i32$0 | 0) & i64toi32_i32$1 >>> 0 >= i64toi32_i32$3 >>> 0 | 0) | 0) {
              break label$2
             }
             i64toi32_i32$1 = var$0$hi;
             var$2 = var$0;
             i64toi32_i32$1 = var$1$hi;
             var$3 = var$1;
             var$2 = (var$2 >>> 0) / (var$3 >>> 0) | 0;
             i64toi32_i32$1 = 0;
             __wasm_intrinsics_temp_i64 = var$0 - Math_imul(var$2, var$3) | 0;
             __wasm_intrinsics_temp_i64$hi = i64toi32_i32$1;
             i64toi32_i32$1 = 0;
             i64toi32_i32$2 = var$2;
             i64toi32_i32$HIGH_BITS = i64toi32_i32$1;
             return i64toi32_i32$2 | 0;
            }
            i64toi32_i32$2 = var$1$hi;
            i64toi32_i32$3 = var$1;
            i64toi32_i32$1 = 0;
            i64toi32_i32$0 = 32;
            i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
            if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
             i64toi32_i32$1 = 0;
             $39 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
            } else {
             i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
             $39 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$4 | 0) | 0;
            }
            var$3 = $39;
            i64toi32_i32$1 = var$0$hi;
            if (!var$0) {
             break label$7
            }
            if (!var$3) {
             break label$6
            }
            var$4 = var$3 + -1 | 0;
            if (var$4 & var$3 | 0) {
             break label$6
            }
            i64toi32_i32$1 = 0;
            i64toi32_i32$2 = var$4 & var$2 | 0;
            i64toi32_i32$3 = 0;
            i64toi32_i32$0 = 32;
            i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
            if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
             i64toi32_i32$3 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
             $40 = 0;
            } else {
             i64toi32_i32$3 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
             $40 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
            }
            $63$hi = i64toi32_i32$3;
            i64toi32_i32$3 = var$0$hi;
            i64toi32_i32$1 = var$0;
            i64toi32_i32$2 = 0;
            i64toi32_i32$0 = -1;
            i64toi32_i32$2 = i64toi32_i32$3 & i64toi32_i32$2 | 0;
            $65 = i64toi32_i32$1 & i64toi32_i32$0 | 0;
            $65$hi = i64toi32_i32$2;
            i64toi32_i32$2 = $63$hi;
            i64toi32_i32$3 = $40;
            i64toi32_i32$1 = $65$hi;
            i64toi32_i32$0 = $65;
            i64toi32_i32$1 = i64toi32_i32$2 | i64toi32_i32$1 | 0;
            __wasm_intrinsics_temp_i64 = i64toi32_i32$3 | i64toi32_i32$0 | 0;
            __wasm_intrinsics_temp_i64$hi = i64toi32_i32$1;
            i64toi32_i32$1 = 0;
            i64toi32_i32$3 = var$2 >>> ((__wasm_ctz_i32(var$3 | 0) | 0) & 31 | 0) | 0;
            i64toi32_i32$HIGH_BITS = i64toi32_i32$1;
            return i64toi32_i32$3 | 0;
           }
          }
          var$4 = var$3 + -1 | 0;
          if (!(var$4 & var$3 | 0)) {
           break label$5
          }
          var$2 = (Math_clz32(var$3) + 33 | 0) - Math_clz32(var$2) | 0;
          var$3 = 0 - var$2 | 0;
          break label$3;
         }
         var$3 = 63 - var$2 | 0;
         var$2 = var$2 + 1 | 0;
         break label$3;
        }
        var$4 = (var$2 >>> 0) / (var$3 >>> 0) | 0;
        i64toi32_i32$3 = 0;
        i64toi32_i32$2 = var$2 - Math_imul(var$4, var$3) | 0;
        i64toi32_i32$1 = 0;
        i64toi32_i32$0 = 32;
        i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
         i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
         $41 = 0;
        } else {
         i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$4 | 0) | 0;
         $41 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
        }
        __wasm_intrinsics_temp_i64 = $41;
        __wasm_intrinsics_temp_i64$hi = i64toi32_i32$1;
        i64toi32_i32$1 = 0;
        i64toi32_i32$2 = var$4;
        i64toi32_i32$HIGH_BITS = i64toi32_i32$1;
        return i64toi32_i32$2 | 0;
       }
       var$2 = Math_clz32(var$3) - Math_clz32(var$2) | 0;
       if (var$2 >>> 0 < 31 >>> 0) {
        break label$4
       }
       break label$2;
      }
      i64toi32_i32$2 = var$0$hi;
      i64toi32_i32$2 = 0;
      __wasm_intrinsics_temp_i64 = var$4 & var$0 | 0;
      __wasm_intrinsics_temp_i64$hi = i64toi32_i32$2;
      if ((var$3 | 0) == (1 | 0)) {
       break label$1
      }
      i64toi32_i32$2 = var$0$hi;
      i64toi32_i32$2 = 0;
      $120$hi = i64toi32_i32$2;
      i64toi32_i32$2 = var$0$hi;
      i64toi32_i32$3 = var$0;
      i64toi32_i32$1 = $120$hi;
      i64toi32_i32$0 = __wasm_ctz_i32(var$3 | 0) | 0;
      i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
      if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
       i64toi32_i32$1 = 0;
       $42 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
      } else {
       i64toi32_i32$1 = i64toi32_i32$2 >>> i64toi32_i32$4 | 0;
       $42 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$2 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$3 >>> i64toi32_i32$4 | 0) | 0;
      }
      i64toi32_i32$3 = $42;
      i64toi32_i32$HIGH_BITS = i64toi32_i32$1;
      return i64toi32_i32$3 | 0;
     }
     var$3 = 63 - var$2 | 0;
     var$2 = var$2 + 1 | 0;
    }
    i64toi32_i32$3 = var$0$hi;
    i64toi32_i32$3 = 0;
    $129$hi = i64toi32_i32$3;
    i64toi32_i32$3 = var$0$hi;
    i64toi32_i32$2 = var$0;
    i64toi32_i32$1 = $129$hi;
    i64toi32_i32$0 = var$2 & 63 | 0;
    i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
     i64toi32_i32$1 = 0;
     $43 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
    } else {
     i64toi32_i32$1 = i64toi32_i32$3 >>> i64toi32_i32$4 | 0;
     $43 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$3 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$2 >>> i64toi32_i32$4 | 0) | 0;
    }
    var$5 = $43;
    var$5$hi = i64toi32_i32$1;
    i64toi32_i32$1 = var$0$hi;
    i64toi32_i32$1 = 0;
    $134$hi = i64toi32_i32$1;
    i64toi32_i32$1 = var$0$hi;
    i64toi32_i32$3 = var$0;
    i64toi32_i32$2 = $134$hi;
    i64toi32_i32$0 = var$3 & 63 | 0;
    i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
     i64toi32_i32$2 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
     $44 = 0;
    } else {
     i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$3 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$1 << i64toi32_i32$4 | 0) | 0;
     $44 = i64toi32_i32$3 << i64toi32_i32$4 | 0;
    }
    var$0 = $44;
    var$0$hi = i64toi32_i32$2;
    label$13 : {
     if (var$2) {
      block3 : {
       i64toi32_i32$2 = var$1$hi;
       i64toi32_i32$1 = var$1;
       i64toi32_i32$3 = -1;
       i64toi32_i32$0 = -1;
       i64toi32_i32$4 = i64toi32_i32$1 + i64toi32_i32$0 | 0;
       i64toi32_i32$5 = i64toi32_i32$2 + i64toi32_i32$3 | 0;
       if (i64toi32_i32$4 >>> 0 < i64toi32_i32$0 >>> 0) {
        i64toi32_i32$5 = i64toi32_i32$5 + 1 | 0
       }
       var$8 = i64toi32_i32$4;
       var$8$hi = i64toi32_i32$5;
       label$15 : while (1) {
        i64toi32_i32$5 = var$5$hi;
        i64toi32_i32$2 = var$5;
        i64toi32_i32$1 = 0;
        i64toi32_i32$0 = 1;
        i64toi32_i32$3 = i64toi32_i32$0 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
         i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$3 | 0;
         $45 = 0;
        } else {
         i64toi32_i32$1 = ((1 << i64toi32_i32$3 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$3 | 0) | 0) | 0 | (i64toi32_i32$5 << i64toi32_i32$3 | 0) | 0;
         $45 = i64toi32_i32$2 << i64toi32_i32$3 | 0;
        }
        $140 = $45;
        $140$hi = i64toi32_i32$1;
        i64toi32_i32$1 = var$0$hi;
        i64toi32_i32$5 = var$0;
        i64toi32_i32$2 = 0;
        i64toi32_i32$0 = 63;
        i64toi32_i32$3 = i64toi32_i32$0 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
         i64toi32_i32$2 = 0;
         $46 = i64toi32_i32$1 >>> i64toi32_i32$3 | 0;
        } else {
         i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$3 | 0;
         $46 = (((1 << i64toi32_i32$3 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$3 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$3 | 0) | 0;
        }
        $142$hi = i64toi32_i32$2;
        i64toi32_i32$2 = $140$hi;
        i64toi32_i32$1 = $140;
        i64toi32_i32$5 = $142$hi;
        i64toi32_i32$0 = $46;
        i64toi32_i32$5 = i64toi32_i32$2 | i64toi32_i32$5 | 0;
        var$5 = i64toi32_i32$1 | i64toi32_i32$0 | 0;
        var$5$hi = i64toi32_i32$5;
        $144 = var$5;
        $144$hi = i64toi32_i32$5;
        i64toi32_i32$5 = var$8$hi;
        i64toi32_i32$5 = var$5$hi;
        i64toi32_i32$5 = var$8$hi;
        i64toi32_i32$2 = var$8;
        i64toi32_i32$1 = var$5$hi;
        i64toi32_i32$0 = var$5;
        i64toi32_i32$3 = i64toi32_i32$2 - i64toi32_i32$0 | 0;
        i64toi32_i32$6 = i64toi32_i32$2 >>> 0 < i64toi32_i32$0 >>> 0;
        i64toi32_i32$4 = i64toi32_i32$6 + i64toi32_i32$1 | 0;
        i64toi32_i32$4 = i64toi32_i32$5 - i64toi32_i32$4 | 0;
        i64toi32_i32$5 = i64toi32_i32$3;
        i64toi32_i32$2 = 0;
        i64toi32_i32$0 = 63;
        i64toi32_i32$1 = i64toi32_i32$0 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
         i64toi32_i32$2 = i64toi32_i32$4 >> 31 | 0;
         $47 = i64toi32_i32$4 >> i64toi32_i32$1 | 0;
        } else {
         i64toi32_i32$2 = i64toi32_i32$4 >> i64toi32_i32$1 | 0;
         $47 = (((1 << i64toi32_i32$1 | 0) - 1 | 0) & i64toi32_i32$4 | 0) << (32 - i64toi32_i32$1 | 0) | 0 | (i64toi32_i32$5 >>> i64toi32_i32$1 | 0) | 0;
        }
        var$6 = $47;
        var$6$hi = i64toi32_i32$2;
        i64toi32_i32$2 = var$1$hi;
        i64toi32_i32$2 = var$6$hi;
        i64toi32_i32$4 = var$6;
        i64toi32_i32$5 = var$1$hi;
        i64toi32_i32$0 = var$1;
        i64toi32_i32$5 = i64toi32_i32$2 & i64toi32_i32$5 | 0;
        $151 = i64toi32_i32$4 & i64toi32_i32$0 | 0;
        $151$hi = i64toi32_i32$5;
        i64toi32_i32$5 = $144$hi;
        i64toi32_i32$2 = $144;
        i64toi32_i32$4 = $151$hi;
        i64toi32_i32$0 = $151;
        i64toi32_i32$1 = i64toi32_i32$2 - i64toi32_i32$0 | 0;
        i64toi32_i32$6 = i64toi32_i32$2 >>> 0 < i64toi32_i32$0 >>> 0;
        i64toi32_i32$3 = i64toi32_i32$6 + i64toi32_i32$4 | 0;
        i64toi32_i32$3 = i64toi32_i32$5 - i64toi32_i32$3 | 0;
        var$5 = i64toi32_i32$1;
        var$5$hi = i64toi32_i32$3;
        i64toi32_i32$3 = var$0$hi;
        i64toi32_i32$5 = var$0;
        i64toi32_i32$2 = 0;
        i64toi32_i32$0 = 1;
        i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
        if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
         i64toi32_i32$2 = i64toi32_i32$5 << i64toi32_i32$4 | 0;
         $48 = 0;
        } else {
         i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$5 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$4 | 0) | 0;
         $48 = i64toi32_i32$5 << i64toi32_i32$4 | 0;
        }
        $154$hi = i64toi32_i32$2;
        i64toi32_i32$2 = var$7$hi;
        i64toi32_i32$2 = $154$hi;
        i64toi32_i32$3 = $48;
        i64toi32_i32$5 = var$7$hi;
        i64toi32_i32$0 = var$7;
        i64toi32_i32$5 = i64toi32_i32$2 | i64toi32_i32$5 | 0;
        var$0 = i64toi32_i32$3 | i64toi32_i32$0 | 0;
        var$0$hi = i64toi32_i32$5;
        i64toi32_i32$5 = var$6$hi;
        i64toi32_i32$2 = var$6;
        i64toi32_i32$3 = 0;
        i64toi32_i32$0 = 1;
        i64toi32_i32$3 = i64toi32_i32$5 & i64toi32_i32$3 | 0;
        var$6 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
        var$6$hi = i64toi32_i32$3;
        var$7 = var$6;
        var$7$hi = i64toi32_i32$3;
        var$2 = var$2 + -1 | 0;
        if (var$2) {
         continue label$15
        }
        break label$15;
       };
       break label$13;
      }
     }
    }
    i64toi32_i32$3 = var$5$hi;
    __wasm_intrinsics_temp_i64 = var$5;
    __wasm_intrinsics_temp_i64$hi = i64toi32_i32$3;
    i64toi32_i32$3 = var$0$hi;
    i64toi32_i32$5 = var$0;
    i64toi32_i32$2 = 0;
    i64toi32_i32$0 = 1;
    i64toi32_i32$4 = i64toi32_i32$0 & 31 | 0;
    if (32 >>> 0 <= (i64toi32_i32$0 & 63 | 0) >>> 0) {
     i64toi32_i32$2 = i64toi32_i32$5 << i64toi32_i32$4 | 0;
     $49 = 0;
    } else {
     i64toi32_i32$2 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$5 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$3 << i64toi32_i32$4 | 0) | 0;
     $49 = i64toi32_i32$5 << i64toi32_i32$4 | 0;
    }
    $165$hi = i64toi32_i32$2;
    i64toi32_i32$2 = var$6$hi;
    i64toi32_i32$2 = $165$hi;
    i64toi32_i32$3 = $49;
    i64toi32_i32$5 = var$6$hi;
    i64toi32_i32$0 = var$6;
    i64toi32_i32$5 = i64toi32_i32$2 | i64toi32_i32$5 | 0;
    i64toi32_i32$3 = i64toi32_i32$3 | i64toi32_i32$0 | 0;
    i64toi32_i32$HIGH_BITS = i64toi32_i32$5;
    return i64toi32_i32$3 | 0;
   }
   i64toi32_i32$3 = var$0$hi;
   __wasm_intrinsics_temp_i64 = var$0;
   __wasm_intrinsics_temp_i64$hi = i64toi32_i32$3;
   i64toi32_i32$3 = 0;
   var$0 = 0;
   var$0$hi = i64toi32_i32$3;
  }
  i64toi32_i32$3 = var$0$hi;
  i64toi32_i32$5 = var$0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$3;
  return i64toi32_i32$5 | 0;
 }
 
 function __wasm_ctz_i32(var$0) {
  var$0 = var$0 | 0;
  if (var$0) {
   return 31 - Math_clz32((var$0 + -1 | 0) ^ var$0 | 0) | 0 | 0
  }
  return 32 | 0;
 }
 
 function __wasm_i64_mul(var$0, var$0$hi, var$1, var$1$hi) {
  var$0 = var$0 | 0;
  var$0$hi = var$0$hi | 0;
  var$1 = var$1 | 0;
  var$1$hi = var$1$hi | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0;
  i64toi32_i32$0 = var$0$hi;
  i64toi32_i32$0 = var$1$hi;
  i64toi32_i32$0 = var$0$hi;
  i64toi32_i32$1 = var$1$hi;
  i64toi32_i32$1 = _ZN17compiler_builtins3int3mul3Mul3mul17h070e9a1c69faec5bE(var$0 | 0, i64toi32_i32$0 | 0, var$1 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$0;
  return i64toi32_i32$1 | 0;
 }
 
 function __wasm_i64_srem(var$0, var$0$hi, var$1, var$1$hi) {
  var$0 = var$0 | 0;
  var$0$hi = var$0$hi | 0;
  var$1 = var$1 | 0;
  var$1$hi = var$1$hi | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0;
  i64toi32_i32$0 = var$0$hi;
  i64toi32_i32$0 = var$1$hi;
  i64toi32_i32$0 = var$0$hi;
  i64toi32_i32$1 = var$1$hi;
  i64toi32_i32$1 = _ZN17compiler_builtins3int4sdiv3Mod4mod_17h2cbb7bbf36e41d68E(var$0 | 0, i64toi32_i32$0 | 0, var$1 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$0;
  return i64toi32_i32$1 | 0;
 }
 
 function __wasm_i64_udiv(var$0, var$0$hi, var$1, var$1$hi) {
  var$0 = var$0 | 0;
  var$0$hi = var$0$hi | 0;
  var$1 = var$1 | 0;
  var$1$hi = var$1$hi | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0;
  i64toi32_i32$0 = var$0$hi;
  i64toi32_i32$0 = var$1$hi;
  i64toi32_i32$0 = var$0$hi;
  i64toi32_i32$1 = var$1$hi;
  i64toi32_i32$1 = _ZN17compiler_builtins3int4udiv10divmod_u6417h6026910b5ed08e40E(var$0 | 0, i64toi32_i32$0 | 0, var$1 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$0;
  return i64toi32_i32$1 | 0;
 }
 
 function __wasm_i64_urem(var$0, var$0$hi, var$1, var$1$hi) {
  var$0 = var$0 | 0;
  var$0$hi = var$0$hi | 0;
  var$1 = var$1 | 0;
  var$1$hi = var$1$hi | 0;
  var i64toi32_i32$0 = 0, i64toi32_i32$1 = 0;
  i64toi32_i32$0 = var$0$hi;
  i64toi32_i32$0 = var$1$hi;
  i64toi32_i32$0 = var$0$hi;
  i64toi32_i32$1 = var$1$hi;
  i64toi32_i32$1 = _ZN17compiler_builtins3int4udiv10divmod_u6417h6026910b5ed08e40E(var$0 | 0, i64toi32_i32$0 | 0, var$1 | 0, i64toi32_i32$1 | 0) | 0;
  i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
  i64toi32_i32$0 = __wasm_intrinsics_temp_i64$hi;
  i64toi32_i32$1 = __wasm_intrinsics_temp_i64;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$0;
  return i64toi32_i32$1 | 0;
 }
 
 function __wasm_popcnt_i32(var$0) {
  var$0 = var$0 | 0;
  var var$1 = 0, $5 = 0;
  label$1 : {
   label$2 : while (1) {
    $5 = var$1;
    if (!var$0) {
     break label$1
    }
    var$0 = var$0 & (var$0 - 1 | 0) | 0;
    var$1 = var$1 + 1 | 0;
    continue label$2;
   };
  }
  return $5 | 0;
 }
 
 function __wasm_rotl_i32(var$0, var$1) {
  var$0 = var$0 | 0;
  var$1 = var$1 | 0;
  var var$2 = 0;
  var$2 = var$1 & 31 | 0;
  var$1 = (0 - var$1 | 0) & 31 | 0;
  return ((-1 >>> var$2 | 0) & var$0 | 0) << var$2 | 0 | (((-1 << var$1 | 0) & var$0 | 0) >>> var$1 | 0) | 0 | 0;
 }
 
 function __wasm_rotl_i64(var$0, var$0$hi, var$1, var$1$hi) {
  var$0 = var$0 | 0;
  var$0$hi = var$0$hi | 0;
  var$1 = var$1 | 0;
  var$1$hi = var$1$hi | 0;
  var i64toi32_i32$1 = 0, i64toi32_i32$0 = 0, i64toi32_i32$2 = 0, i64toi32_i32$3 = 0, i64toi32_i32$5 = 0, i64toi32_i32$4 = 0, var$2$hi = 0, var$2 = 0, $19 = 0, $20 = 0, $21 = 0, $22 = 0, $6$hi = 0, $8$hi = 0, $10 = 0, $10$hi = 0, $15$hi = 0, $17$hi = 0, $19$hi = 0;
  i64toi32_i32$0 = var$1$hi;
  i64toi32_i32$2 = var$1;
  i64toi32_i32$1 = 0;
  i64toi32_i32$3 = 63;
  i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$1 | 0;
  var$2 = i64toi32_i32$2 & i64toi32_i32$3 | 0;
  var$2$hi = i64toi32_i32$1;
  i64toi32_i32$1 = -1;
  i64toi32_i32$0 = -1;
  i64toi32_i32$2 = var$2$hi;
  i64toi32_i32$3 = var$2;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$2 = 0;
   $19 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
  } else {
   i64toi32_i32$2 = i64toi32_i32$1 >>> i64toi32_i32$4 | 0;
   $19 = (((1 << i64toi32_i32$4 | 0) - 1 | 0) & i64toi32_i32$1 | 0) << (32 - i64toi32_i32$4 | 0) | 0 | (i64toi32_i32$0 >>> i64toi32_i32$4 | 0) | 0;
  }
  $6$hi = i64toi32_i32$2;
  i64toi32_i32$2 = var$0$hi;
  i64toi32_i32$2 = $6$hi;
  i64toi32_i32$1 = $19;
  i64toi32_i32$0 = var$0$hi;
  i64toi32_i32$3 = var$0;
  i64toi32_i32$0 = i64toi32_i32$2 & i64toi32_i32$0 | 0;
  $8$hi = i64toi32_i32$0;
  i64toi32_i32$0 = var$2$hi;
  i64toi32_i32$0 = $8$hi;
  i64toi32_i32$2 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
  i64toi32_i32$1 = var$2$hi;
  i64toi32_i32$3 = var$2;
  i64toi32_i32$4 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
   $20 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$4 | 0) - 1 | 0) & (i64toi32_i32$2 >>> (32 - i64toi32_i32$4 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$4 | 0) | 0;
   $20 = i64toi32_i32$2 << i64toi32_i32$4 | 0;
  }
  $10 = $20;
  $10$hi = i64toi32_i32$1;
  i64toi32_i32$1 = var$1$hi;
  i64toi32_i32$1 = 0;
  i64toi32_i32$0 = 0;
  i64toi32_i32$2 = var$1$hi;
  i64toi32_i32$3 = var$1;
  i64toi32_i32$4 = i64toi32_i32$0 - i64toi32_i32$3 | 0;
  i64toi32_i32$5 = (i64toi32_i32$0 >>> 0 < i64toi32_i32$3 >>> 0) + i64toi32_i32$2 | 0;
  i64toi32_i32$5 = i64toi32_i32$1 - i64toi32_i32$5 | 0;
  i64toi32_i32$1 = i64toi32_i32$4;
  i64toi32_i32$0 = 0;
  i64toi32_i32$3 = 63;
  i64toi32_i32$0 = i64toi32_i32$5 & i64toi32_i32$0 | 0;
  var$1 = i64toi32_i32$1 & i64toi32_i32$3 | 0;
  var$1$hi = i64toi32_i32$0;
  i64toi32_i32$0 = -1;
  i64toi32_i32$5 = -1;
  i64toi32_i32$1 = var$1$hi;
  i64toi32_i32$3 = var$1;
  i64toi32_i32$2 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$1 = i64toi32_i32$5 << i64toi32_i32$2 | 0;
   $21 = 0;
  } else {
   i64toi32_i32$1 = ((1 << i64toi32_i32$2 | 0) - 1 | 0) & (i64toi32_i32$5 >>> (32 - i64toi32_i32$2 | 0) | 0) | 0 | (i64toi32_i32$0 << i64toi32_i32$2 | 0) | 0;
   $21 = i64toi32_i32$5 << i64toi32_i32$2 | 0;
  }
  $15$hi = i64toi32_i32$1;
  i64toi32_i32$1 = var$0$hi;
  i64toi32_i32$1 = $15$hi;
  i64toi32_i32$0 = $21;
  i64toi32_i32$5 = var$0$hi;
  i64toi32_i32$3 = var$0;
  i64toi32_i32$5 = i64toi32_i32$1 & i64toi32_i32$5 | 0;
  $17$hi = i64toi32_i32$5;
  i64toi32_i32$5 = var$1$hi;
  i64toi32_i32$5 = $17$hi;
  i64toi32_i32$1 = i64toi32_i32$0 & i64toi32_i32$3 | 0;
  i64toi32_i32$0 = var$1$hi;
  i64toi32_i32$3 = var$1;
  i64toi32_i32$2 = i64toi32_i32$3 & 31 | 0;
  if (32 >>> 0 <= (i64toi32_i32$3 & 63 | 0) >>> 0) {
   i64toi32_i32$0 = 0;
   $22 = i64toi32_i32$5 >>> i64toi32_i32$2 | 0;
  } else {
   i64toi32_i32$0 = i64toi32_i32$5 >>> i64toi32_i32$2 | 0;
   $22 = (((1 << i64toi32_i32$2 | 0) - 1 | 0) & i64toi32_i32$5 | 0) << (32 - i64toi32_i32$2 | 0) | 0 | (i64toi32_i32$1 >>> i64toi32_i32$2 | 0) | 0;
  }
  $19$hi = i64toi32_i32$0;
  i64toi32_i32$0 = $10$hi;
  i64toi32_i32$5 = $10;
  i64toi32_i32$1 = $19$hi;
  i64toi32_i32$3 = $22;
  i64toi32_i32$1 = i64toi32_i32$0 | i64toi32_i32$1 | 0;
  i64toi32_i32$5 = i64toi32_i32$5 | i64toi32_i32$3 | 0;
  i64toi32_i32$HIGH_BITS = i64toi32_i32$1;
  return i64toi32_i32$5 | 0;
 }
 
 var FUNCTION_TABLE = [null, $_T_20as_20core__fmt__Display___fmt__h64bb12b80b94ab78, $alloc__string__String_20as_20core__fmt__Display___fmt__hc15dcc93124260dc, core__ptr__drop_in_place_alloc__string__String___h73e7752754206ea3, $alloc__string__String_20as_20core__fmt__Write___write_str__hed6694d3c7c6a012, $alloc__string__String_20as_20core__fmt__Write___write_char__hcabdf1e70d08df58, core__fmt__Write__write_fmt__h3fa86b0857dbcda0, core__ptr__drop_in_place_core__fmt__Error___h485037a8fa312851, $core__fmt__Error_20as_20core__fmt__Debug___fmt__hdcebc0a03850ca30, core__ptr__drop_in_place_core__array__TryFromSliceError___hc48a04ce4806cd2e, $core__array__TryFromSliceError_20as_20core__fmt__Debug___fmt__h0fe98dc480ffbdbe, core__ptr__drop_in_place_cbor_event__error__Error___hbf0141ec70b68c45_3, $cbor_event__error__Error_20as_20core__fmt__Debug___fmt__h24703f8b05f4c892, core__ptr__drop_in_place_std__io__error__Error___h33c863f956f9c357, $std__io__error__Error_20as_20core__fmt__Debug___fmt__hf1d86887ceb28c1f, $bech32__Error_20as_20core__fmt__Display___fmt__hb94eedebff44411f, $_T_20as_20core__fmt__Display___fmt__h662e6a4dcf046317, $_T_20as_20core__fmt__Display___fmt__h171b21869b7cf20c, core__fmt__num___impl_20core__fmt__LowerHex_20for_20i64___fmt__h68614c2d2fa4b444, core__fmt__num___impl_20core__fmt__LowerHex_20for_20i32___fmt__h9723d6e56c381fda, core__fmt__num__imp___impl_20core__fmt__Display_20for_20u64___fmt__h6488d819d41312fb, core__ptr__drop_in_place_core__array__TryFromSliceError___hc48a04ce4806cd2e_1, core__ptr__drop_in_place_cardano_serialization_lib__chain_crypto__key__PublicKeyError___h8875ef7c60bf0a5f, std__error__Error__source__hc2f2146fc957bb8d, std__error__Error__type_id__haf19978aef73c64a, std__error__Error__backtrace__h1b92301be9d152ad, std__error__Error__description__hdb04605b8647d06d, std__error__Error__cause__hf939149b8e48e454, $cardano_serialization_lib__chain_crypto__key__PublicKeyError_20as_20core__fmt__Display___fmt__hc004f7b5f3685acc, $cardano_serialization_lib__chain_crypto__key__PublicKeyError_20as_20core__fmt__Debug___fmt__h1f0fefbe3c6c2411, core__ptr__drop_in_place_cardano_serialization_lib__chain_crypto__sign__SignatureError___h07eeb8ab5232b07f, std__error__Error__source__h36f14197a5bfd73b, std__error__Error__type_id__he3dc7f364810696a, std__error__Error__backtrace__h18e109309cf07ace, std__error__Error__description__hfd6138aaf97ae865, std__error__Error__cause__hc11eaeb7a862392e, $cardano_serialization_lib__chain_crypto__sign__SignatureError_20as_20core__fmt__Display___fmt__hc1e2bc8a8ccd1f41, $cardano_serialization_lib__chain_crypto__sign__SignatureError_20as_20core__fmt__Debug___fmt__ha48c9453b982befc, core__ptr__drop_in_place_cardano_serialization_lib__chain_crypto__key__SecretKeyError___hfaca729ce194302b, std__error__Error__source__h6e9f7cbd378222f2, std__error__Error__type_id__h6ecdad489073bfdf, std__error__Error__backtrace__h3b5992a8ca11fb6f, std__error__Error__description__h50ef725cdf586bc7, std__error__Error__cause__h89f1cdb59c8b681e, $cardano_serialization_lib__chain_crypto__key__SecretKeyError_20as_20core__fmt__Display___fmt__h216c4140a265d4e0, $cardano_serialization_lib__chain_crypto__key__SecretKeyError_20as_20core__fmt__Debug___fmt__h16a21777cd3bcaeb, core__fmt__num__imp___impl_20core__fmt__Display_20for_20u32___fmt__h84f076c5e5d839ee, $num_bigint__ParseBigIntError_20as_20core__fmt__Debug___fmt__hbbb2316c40d87609, $core__num__error__ParseIntError_20as_20core__fmt__Debug___fmt__h5fe67e0978fadfb5, $core__num__error__TryFromIntError_20as_20core__fmt__Display___fmt__h0b3586d20b4066db, core__fmt__num___impl_20core__fmt__Display_20for_20i128___fmt__h32e59444f56cefa7, std__collections__hash__map__RandomState__new__KEYS____getit__h7c33a32c97166f29, core__ptr__drop_in_place_alloc__string__String___h73e7752754206ea3_1, $alloc__string__String_20as_20core__fmt__Write___write_str__hed6694d3c7c6a012_1, $alloc__string__String_20as_20core__fmt__Write___write_char__hcabdf1e70d08df58_1, core__ptr__drop_in_place_core__fmt__Error___h485037a8fa312851_1, core__ptr__drop_in_place_wasm_bindgen__JsValue___hfc6b1fe11860614d, $wasm_bindgen__JsValue_20as_20core__fmt__Debug___fmt__h609da9eb26b4fcb6, core__ptr__drop_in_place_num_bigint__ParseBigIntError___h4209b66c1ad59342, core__ptr__drop_in_place_cbor_event__error__Error___hbf0141ec70b68c45_4, core__ptr__drop_in_place__i128___he647b87223975998, $_T_20as_20core__fmt__Debug___fmt__h0a4730d8f7e64934, $alloc__string__String_20as_20core__fmt__Display___fmt__hc15dcc93124260dc_1, $cardano_serialization_lib__metadata__TransactionMetadatumEnum_20as_20core__fmt__Debug___fmt__hc14eef2169db3178, $_T_20as_20core__fmt__Debug___fmt__hc33b8a57fce2f1d4, core__ptr__drop_in_place_alloc__string__String___h73e7752754206ea3_2, $alloc__string__String_20as_20core__fmt__Write___write_str__hed6694d3c7c6a012_2, $alloc__string__String_20as_20core__fmt__Write___write_char__hcabdf1e70d08df58_2, core__ptr__drop_in_place_core__fmt__Error___h485037a8fa312851_2, core__ptr__drop_in_place_cbor_event__error__Error___hbf0141ec70b68c45_5, core__ptr__drop_in_place_wasm_bindgen__JsValue___hfc6b1fe11860614d_1, core__ptr__drop_in_place__linked_hash_map__LinkedHashMap_cardano_serialization_lib__metadata__TransactionMetadatum_2ccardano_serialization_lib__metadata__TransactionMetadatum____hec1579ce6dacd204, $_T_20as_20core__fmt__Debug___fmt__h9ab81746e7498710, core__ptr__drop_in_place__alloc__vec__Vec_cardano_serialization_lib__metadata__TransactionMetadatum____h808f443fb4ca9736, $_T_20as_20core__fmt__Debug___fmt__he9f1572a33495ebd, core__ptr__drop_in_place__alloc__string__String___h522543eee5146f84, $_T_20as_20core__fmt__Debug___fmt__hfa1df4fb7d31ae74, core__ptr__drop_in_place__alloc__vec__Vec_u8____h5c8d9261a87424cd, $_T_20as_20core__fmt__Debug___fmt__hdebab94a1b0ec07d, core__ptr__drop_in_place__cardano_serialization_lib__utils__Int___heb903b1147a9bc30, $_T_20as_20core__fmt__Debug___fmt__h2b4a3bc8b86b3b01, core__ptr__drop_in_place__cardano_serialization_lib__metadata__MetadataList___h34174aa055018453, $_T_20as_20core__fmt__Debug___fmt__haad37a6750526a31, core__ptr__drop_in_place__cardano_serialization_lib__metadata__MetadataMap___h7b595678c8689799, $_T_20as_20core__fmt__Debug___fmt__h396617286d1a2d93, core__ptr__drop_in_place__cardano_serialization_lib__metadata__TransactionMetadatumEnum___h27dc626d2ff569fe, $_T_20as_20core__fmt__Debug___fmt__hadd5b9ecb654d557, $_T_20as_20core__fmt__Display___fmt__hf8bfa69300013565, $_T_20as_20core__fmt__Display___fmt__hde401ac1d6884c2b, $alloc__string__String_20as_20core__fmt__Display___fmt__hc15dcc93124260dc_2, $_T_20as_20core__fmt__Binary___fmt__h237adc8341151b1c, $_T_20as_20core__fmt__Display___fmt__h96bc56ec575a7bd0, $_T_20as_20core__fmt__Debug___fmt__h4f7c3d7384581c5d, $_T_20as_20core__fmt__Display___fmt__hd1afaeeeb58cf900, $_T_20as_20core__fmt__Display___fmt__hb125e8a6463e2088, $_T_20as_20core__fmt__Debug___fmt__hbddbe3db4f0c09ae, std__collections__hash__map__RandomState__new__KEYS____getit__h7c33a32c97166f29_1, core__ptr__drop_in_place__cardano_serialization_lib__metadata__TransactionMetadatum___h2bb7404453b723c9, core__ptr__drop_in_place__cbor_event__types__Special___h18a6c572bdc6c4b5, $_T_20as_20core__fmt__Debug___fmt__h22c702bd66c5ce13, core__ptr__drop_in_place__usize___h598668a1d9f8a205, $_T_20as_20core__fmt__Debug___fmt__hbc55ae6123845c9d, core__ptr__drop_in_place__hex__error__FromHexError___hfc1348a5fcca3baf, $_T_20as_20core__fmt__Debug___fmt__h3b47bddaf36efc84, core__ptr__drop_in_place__cardano_serialization_lib__chain_crypto__sign__SignatureError___hdb86ef3eb9b0beee, $_T_20as_20core__fmt__Debug___fmt__h003cf3151c1e454b, $alloc__string__String_20as_20core__fmt__Debug___fmt__h761c2dbab983b314, std__collections__hash__map__RandomState__new__KEYS____getit__h7c33a32c97166f29_2, core__ptr__drop_in_place_wasm_bindgen__JsValue___hfc6b1fe11860614d_2, $rand_core__error__Error_20as_20core__fmt__Display___fmt__hdeea39097fd9db57, $ed25519_bip32__derivation__DerivationError_20as_20core__fmt__Debug___fmt__h557dfa098358060a, $cardano_serialization_lib__chain_crypto__bech32__Error_20as_20core__fmt__Display___fmt__h243421bc8287f594, $cardano_serialization_lib__chain_crypto__sign__SignatureFromStrError_20as_20core__fmt__Debug___fmt__h48c955749b11c8b6, $bech32__Error_20as_20core__fmt__Debug___fmt__hbaf6712a5e4c483d, core__ptr__drop_in_place_alloc__string__String___h73e7752754206ea3_3, $alloc__string__String_20as_20core__fmt__Write___write_str__hed6694d3c7c6a012_3, $alloc__string__String_20as_20core__fmt__Write___write_char__hcabdf1e70d08df58_3, core__ptr__drop_in_place_core__fmt__Error___h485037a8fa312851_3, core__ptr__drop_in_place_bech32__Error___hb95291b1466c6dc4, core__ptr__drop_in_place_core__array__TryFromSliceError___hc48a04ce4806cd2e_2, core__ptr__drop_in_place_cbor_event__error__Error___hbf0141ec70b68c45_2, core__ptr__drop_in_place__28_29___h7157c4a2e1ac8f42, $_28_29_20as_20core__fmt__Debug___fmt__hccf17f88be497811, core__ptr__drop_in_place_alloc__string__String___h73e7752754206ea3_4, $alloc__string__String_20as_20core__fmt__Write___write_str__hed6694d3c7c6a012_4, $alloc__string__String_20as_20core__fmt__Write___write_char__hcabdf1e70d08df58_4, core__ptr__drop_in_place_std__thread__local__AccessError___h9e391fbf265ff51a, $std__thread__local__AccessError_20as_20core__fmt__Debug___fmt__h45e3defe85febb31, core__ptr__drop_in_place_core__fmt__Error___h485037a8fa312851_4, core__ptr__drop_in_place__28_29___h7157c4a2e1ac8f42_1, $_28_29_20as_20core__fmt__Debug___fmt__hccf17f88be497811_1, $cardano_serialization_lib__legacy_address__address__ExtendedAddr_20as_20core__fmt__Display___fmt__he356156b8bc4225c, $cardano_serialization_lib__legacy_address__address__ParseExtendedAddrError_20as_20core__fmt__Debug___fmt__hd53eb848259e4159, core__ptr__drop_in_place_alloc__string__String___h73e7752754206ea3_5, $alloc__string__String_20as_20core__fmt__Write___write_str__hed6694d3c7c6a012_5, $alloc__string__String_20as_20core__fmt__Write___write_char__hcabdf1e70d08df58_5, core__ptr__drop_in_place_core__fmt__Error___h485037a8fa312851_5, core__ptr__drop_in_place_bech32__Error___hb95291b1466c6dc4_1, core__ptr__drop_in_place_alloc__string__FromUtf8Error___h8000ce6077c17165, $alloc__string__FromUtf8Error_20as_20core__fmt__Debug___fmt__hfe44325d1a412cc5, core__ptr__drop_in_place_cbor_event__error__Error___hbf0141ec70b68c45, core__ptr__drop_in_place__usize___h598668a1d9f8a205_1, $alloc__string__String_20as_20core__fmt__Display___fmt__hc15dcc93124260dc_3, core__ptr__drop_in_place_std__io__error__Error___h33c863f956f9c357_3, core__ptr__drop_in_place_cbor_event__error__Error___hbf0141ec70b68c45_6, core__fmt__float___impl_20core__fmt__Display_20for_20f64___fmt__h9c24db217d9fbd1b, $core__fmt__Arguments_20as_20core__fmt__Display___fmt__h6f43420f70707126, $cbor_event__len__Len_20as_20core__fmt__Debug___fmt__hea16dfa439f453e5, $alloc__string__String_20as_20core__fmt__Display___fmt__hc15dcc93124260dc_4, $cardano_serialization_lib__legacy_address__address__Addr_20as_20core__fmt__Display___fmt__ha492d7f37bd81963, core__ptr__drop_in_place_cbor_event__error__Error___hbf0141ec70b68c45_1, core__ptr__drop_in_place__cardano_serialization_lib__legacy_address__base58__Error___hc75f13a3c97d0d17, $_T_20as_20core__fmt__Debug___fmt__h8022ee0c495ac1af, core__ptr__drop_in_place__cbor_event__error__Error___h9ea5b894b069c8f6, $_T_20as_20core__fmt__Debug___fmt__h126e9e24d530c074, $rand_core__error__Error_20as_20core__fmt__Display___fmt__hb03d363219c0d4bc, rand__rngs__thread__THREAD_RNG_KEY____getit__h0517a5ff212241c2, core__ptr__drop_in_place_std__thread__local__AccessError___hd81d445558f87d22, $alloc__boxed__Box_T_2cA__20as_20core__fmt__Display___fmt__h2524da7abaae9d3c, core__ptr__drop_in_place_getrandom__error__Error___he5c31e4302f49944, std__error__Error__source__h3bc2afb786ee1d16, std__error__Error__type_id__h189003d8839d4184, std__error__Error__backtrace__h750a1fd32b7fe9a5, std__error__Error__description__h7aea421d34219fbb, std__error__Error__cause__hbb602d628bb1afd7, $getrandom__error__Error_20as_20core__fmt__Display___fmt__hb78b9a6fe25169c3, $getrandom__error__Error_20as_20core__fmt__Debug___fmt__h34a0039dca79e077, core__fmt__num__imp___impl_20core__fmt__Display_20for_20i32___fmt__hc7b987a91b743964, core__ptr__drop_in_place_u32___h558aa0e65b0ca649, core__fmt__num___impl_20core__fmt__Debug_20for_20u32___fmt__h896d1993d65dfe18, core__ptr__drop_in_place__str___h9271a7c969e51923, $_T_20as_20core__fmt__Debug___fmt__h2fbd287ca497afce, core__ptr__drop_in_place_i32___hcd05c81a9a48ee1a, core__fmt__num___impl_20core__fmt__Debug_20for_20i32___fmt__h252cf9c2774e7ec3, core__ptr__drop_in_place_std__thread__local__AccessError___hb8233780c11554b0, getrandom__imp__RNG_SOURCE____init__hed786a00ff5c948f, getrandom__imp__RNG_SOURCE____getit__h6f31be58fa71e85e, js_sys__global__GLOBAL____init__h9ff3096551d06feb, js_sys__global__GLOBAL____getit__hd11b16d303143195, core__ptr__drop_in_place_std__thread__local__AccessError___h5df76f521a526538, core__ptr__drop_in_place__usize___hdc84a1bdbd1af93e, $_T_20as_20core__fmt__Debug___fmt__h5aab1cd297f9d759, wasm_bindgen__convert__closures__invoke1_mut__h2d25782e02bcec0e, wasm_bindgen__convert__closures__invoke2_mut__h1e7fc25dc8e0d8c0, wasm_bindgen__convert__closures__invoke2_mut__heaa3d0181f430ec2, wasm_bindgen__convert__closures__invoke3_mut__h38a8d51409aeacf1, wasm_bindgen__convert__closures__invoke3_mut__h54bd9345afa3e98a, wasm_bindgen__convert__closures__invoke3_mut__h0fd95d39ebdb2ca3, wasm_bindgen__convert__closures__invoke3_mut__hf79595a4cf51f127, wasm_bindgen__convert__closures__invoke3_mut__h2f804e1660e004ee, wasm_bindgen__convert__closures__invoke3_mut__h95ca65c421627347, wasm_bindgen__convert__closures__invoke3_mut__hc2deb07f81cdeff0, wasm_bindgen__convert__closures__invoke3_mut__hb0b52aa9d64abd0e, wasm_bindgen__convert__closures__invoke3_mut__h6c4b094589ba48d8, wasm_bindgen__convert__closures__invoke3_mut__h5b7f45c1ed00f9be, wasm_bindgen__convert__closures__invoke3_mut__h4abe3dcb75766dba, wasm_bindgen__convert__closures__invoke3_mut__had514eb5a932a259, wasm_bindgen__convert__closures__invoke3_mut__hf2a270d18792658f, wasm_bindgen__convert__closures__invoke3_mut__hdc4b9934268ea366, wasm_bindgen__convert__closures__invoke4_mut__hfbfcfbb1cf4e323a, core__ptr__drop_in_place_std__panicking__begin_panic__PanicPayload__str____hcd9fad046b6abc2d, $std__panicking__begin_panic__PanicPayload_A__20as_20core__panic__BoxMeUp___take_box__h0d941902bf061d86, $std__panicking__begin_panic__PanicPayload_A__20as_20core__panic__BoxMeUp___get__ha9ff4771f53410f5, core__ptr__drop_in_place__str___h69350827c95d6614, $T_20as_20core__any__Any___type_id__he0380fd7a97945f6, core__ptr__drop_in_place__num_bigint__BigIntErrorKind___hab61fa87e71fa35c, $_T_20as_20core__fmt__Debug___fmt__h53f1df4c1873d6ae, core__ptr__drop_in_place__usize___hb93d831aa0560479, $_T_20as_20core__fmt__Debug___fmt__h9a9275a0bae9e1ce, core__ptr__drop_in_place__u32___h75098d33efcb5380, $_T_20as_20core__fmt__Debug___fmt__ha9b9c48de0cd5783, core__ptr__drop_in_place__mut_20alloc__string__String___h23144315c7964254, $_mut_20W_20as_20core__fmt__Write___write_str__h59346aadf97d89b6, $_mut_20W_20as_20core__fmt__Write___write_char__h305d306f7f73d864, $_mut_20W_20as_20core__fmt__Write___write_fmt__hcec814b0071f5b88, $serde_json__error__ErrorCode_20as_20core__fmt__Display___fmt__h3ed16ca1538b4d8c, core__ptr__drop_in_place__u8___h50fb7a8526c9f2ce, $_T_20as_20core__fmt__Debug___fmt__hcb80eba91dbd37c2, $_T_20as_20core__fmt__Display___fmt__h305b08520ae753cb, $_T_20as_20core__fmt__Display___fmt__h96e9527da2d2bc4d, core__ptr__drop_in_place_core__array__TryFromSliceError___h8f6abe492ec10b06, core__ptr__drop_in_place__usize___h184ece860f2903fa, $_T_20as_20core__fmt__Debug___fmt__h2dfc0297287b8632, $char_20as_20core__fmt__Display___fmt__h3e8fd736f5ac7261, core__fmt__num__imp___impl_20core__fmt__Display_20for_20u8___fmt__hca5329c05d9840ca, core__ptr__drop_in_place_core__fmt__Error___h7e729a863212f5dd, core__ptr__drop_in_place__u8___hb56f51cee82d5a15, $_T_20as_20core__fmt__Debug___fmt__h0f98a2adf9499463, core__ptr__drop_in_place__char___h1380dc6145df4a81, $_T_20as_20core__fmt__Debug___fmt__hd724da66daf71efd, core__ptr__drop_in_place_std__panicking__begin_panic__PanicPayload__str____h990955a3d18d98f7, $std__panicking__begin_panic__PanicPayload_A__20as_20core__panic__BoxMeUp___take_box__h20a0a805c7aa4e6a, $std__panicking__begin_panic__PanicPayload_A__20as_20core__panic__BoxMeUp___get__h2653af0829554d12, core__ptr__drop_in_place__str___h0f9e933989059396, $T_20as_20core__any__Any___type_id__hd95ab0a6321f32a0, core__ptr__drop_in_place__u64___h2687d5a7e90c9194, $_T_20as_20core__fmt__Debug___fmt__h86113fee927a2cf9, $_T_20as_20core__fmt__Display___fmt__h69d97a1df3c03254, core__ptr__drop_in_place__f64___he931c28366501462, $_T_20as_20core__fmt__Debug___fmt__h35ee7d96bb2d5d43, core__ptr__drop_in_place__u8___hc879650f064e3222, $_T_20as_20core__fmt__Debug___fmt__h14ee2e0b3bc47c51, core__ptr__drop_in_place__bool___hbe397e5a31d2d61c, $_T_20as_20core__fmt__Debug___fmt__h6bd2b5ce49f88499, core__ptr__drop_in_place__u8___hc879650f064e3222_1, $_T_20as_20core__fmt__Display___fmt__haaf6ada551131066, $_T_20as_20core__fmt__Debug___fmt__h328cb0f742fb0c89, $_T_20as_20core__fmt__Display___fmt__h43292718192d8f05, $_T_20as_20core__fmt__Debug___fmt__hf5283f180f3146a3, core__ptr__drop_in_place__alloc__string__String___ha2d551f35b29906c, $_T_20as_20core__fmt__Debug___fmt__hcb67af0487091295, core__ptr__drop_in_place__std__io__error__Error___h75e94b15230eecfd, $_T_20as_20core__fmt__Debug___fmt__h5304d088372b045e, core__ptr__drop_in_place__cbor_event__types__Type___hdc15b9e51511171c, core__ptr__drop_in_place__alloc__vec__Vec_u8____h61f99e980d8f5190, core__ptr__drop_in_place__alloc__string__FromUtf8Error___h9da175c8264ce816, $_T_20as_20core__fmt__Debug___fmt__h6ffc1e358c2279be, core__ptr__drop_in_place__u64___h2687d5a7e90c9194_1, core__ptr__drop_in_place__cbor_event__len__Len___hd4b619dc44c852a4, core__ptr__drop_in_place___str___h1745347dcb8a9421, $_T_20as_20core__fmt__Debug___fmt__haf265c26cefbcac9, core__ptr__drop_in_place__u8___hc879650f064e3222_2, core__ptr__drop_in_place__usize___h77172d00b3cda2fa, $_T_20as_20core__fmt__Debug___fmt__h9e73891cae9c3301, $alloc__string__String_20as_20core__fmt__Display___fmt__hc15dcc93124260dc_5, $char_20as_20core__fmt__Debug___fmt__h09352abe59e90129, core__ptr__drop_in_place__char___h8bb41effa8165084, $_T_20as_20core__fmt__Debug___fmt__h4b7ac65500c0393d, core__ptr__drop_in_place__usize___h134a010e13e3f582, $_T_20as_20core__fmt__Debug___fmt__ha0e987d2dd72fb1f, $alloc__string__String_20as_20core__fmt__Display___fmt__hc15dcc93124260dc_6, $_T_20as_20core__fmt__Display___fmt__h1acaf975596d7be1, $std__io__error__Error_20as_20core__fmt__Display___fmt__h141afc8863ce4203, std__alloc__default_alloc_error_hook__hcc8f6c14a1cf020a, core__ptr__drop_in_place__mut_20std__io__Write__write_fmt__Adaptor_alloc__vec__Vec_u8_____h5e74783d0185d756, $_mut_20W_20as_20core__fmt__Write___write_str__h5cc7eeafff4b561c, $_mut_20W_20as_20core__fmt__Write___write_char__h71890a50e5130dc8, $_mut_20W_20as_20core__fmt__Write___write_fmt__hf48563f50d5bcc95, $_mut_20W_20as_20core__fmt__Write___write_str__haaed28c7ba29a6da, $_mut_20W_20as_20core__fmt__Write___write_char__hccff694a97429c55, $_mut_20W_20as_20core__fmt__Write___write_fmt__h284de65b17e90df8, $_mut_20W_20as_20core__fmt__Write___write_str__h849058aeb4ca6302, $_mut_20W_20as_20core__fmt__Write___write_char__h69954a901e174650, $_mut_20W_20as_20core__fmt__Write___write_fmt__ha6d75b03e87c4ef6, $_T_20as_20core__fmt__Debug___fmt__h352d529ddfe8d4e2, $T_20as_20core__any__Any___type_id__ha776bc0eec1ceb2b, core__ptr__drop_in_place_std__ffi__c_str__NulError___h5ad11252a9c16486, $std__ffi__c_str__NulError_20as_20core__fmt__Debug___fmt__h0a1850afe00eee75, $core__cell__BorrowMutError_20as_20core__fmt__Debug___fmt__h9f860b68220e7c3b, $core__cell__BorrowError_20as_20core__fmt__Debug___fmt__h59eabedd7926e86a, core__ptr__drop_in_place_std__sync__poison__PoisonError_std__sync__mutex__MutexGuard__28_29_____h0f96ea93a2a17d67, $std__sync__poison__PoisonError_T__20as_20core__fmt__Debug___fmt__h1ed10cc42b8737e7, $_T_20as_20core__fmt__Debug___fmt__h450b05090603950b, $_T_20as_20core__fmt__Debug___fmt__hf175ff9540f9b84c, $std__io__error__ErrorKind_20as_20core__fmt__Debug___fmt__hfd7e1b5a99fa67aa, $_T_20as_20core__fmt__Debug___fmt__h4bd9dd630f0e137b, core__fmt__num___impl_20core__fmt__Debug_20for_20i32___fmt__h252cf9c2774e7ec3_1, core__ptr__drop_in_place_std__error___impl_20core__convert__From_alloc__string__String__20for_20alloc__boxed__Box_dyn_20std__error__Error_core__marker__Sync_core__marker__Send____from__StringError___h52d6038e8d6d32cd, $alloc__string__String_20as_20core__fmt__Debug___fmt__h761c2dbab983b314_1, core__ptr__drop_in_place_std__io__Write__write_fmt__Adaptor__mut_20_5bu8_5d____he8cfb01d7b5518f6, $std__io__Write__write_fmt__Adaptor_T__20as_20core__fmt__Write___write_str__hed1d803889188a6e, core__fmt__Write__write_char__hc23b8976fd50d3f8, core__fmt__Write__write_fmt__h0cbab477b9b6e09a, $std__io__Write__write_fmt__Adaptor_T__20as_20core__fmt__Write___write_str__h58faaa242d229e31, core__fmt__Write__write_char__hcb93f82e62502192, core__fmt__Write__write_fmt__h54eed6b3773c9bff, std__sync__once__Once__call_once_force___7b_7bclosure_7d_7d__h6f10d52c889f7f0f, core__ops__function__FnOnce__call_once_7b_7bvtable_shim_7d_7d__h6aad3a2a7975ccb8, core__ptr__drop_in_place_std__panicking__begin_panic_handler__PanicPayload___hb3bb8c9b27bd594e, $std__panicking__begin_panic_handler__PanicPayload_20as_20core__panic__BoxMeUp___take_box__h93f407f6fea17636, $std__panicking__begin_panic_handler__PanicPayload_20as_20core__panic__BoxMeUp___get__h7b8b2eb260312b34, $std__panicking__begin_panic_handler__StrPanicPayload_20as_20core__panic__BoxMeUp___take_box__hcff4ba0e65e8e475, $std__panicking__begin_panic_handler__StrPanicPayload_20as_20core__panic__BoxMeUp___get__h219bbb7050b46269, $T_20as_20core__any__Any___type_id__h75e12aaca4753e3d, $T_20as_20core__any__Any___type_id__hff62f37f08b7e33d, $std__panicking__begin_panic__PanicPayload_A__20as_20core__panic__BoxMeUp___take_box__h0a41362e8345a8e4, $std__panicking__begin_panic__PanicPayload_A__20as_20core__panic__BoxMeUp___get__h8da6bdf3862d82dd, $_T_20as_20core__fmt__Debug___fmt__h2c023f18f1e8d53c, $_T_20as_20core__fmt__Debug___fmt__h5642facfe8f7744e, $_T_20as_20core__fmt__Debug___fmt__h0e0696b6b14acb55, core__ptr__drop_in_place__u8___ha5544e2185d0c057, $_mut_20W_20as_20core__fmt__Write___write_str__h68b76b1f98d36d88, $_mut_20W_20as_20core__fmt__Write___write_char__h60f487e2ced0041f, $_mut_20W_20as_20core__fmt__Write___write_fmt__hbe100d4644fc093f, $_T_20as_20core__fmt__Debug___fmt__h202c5e6de5e72ca0, $_T_20as_20core__fmt__Debug___fmt__h852d019cd14e864b, $_T_20as_20core__fmt__Debug___fmt__h23f98de9ba642675, core__ops__function__FnOnce__call_once__h44a533a080388641, $_T_20as_20core__fmt__Display___fmt__h56c3642604b71e34, $_T_20as_20core__fmt__Debug___fmt__he998d6e73e28558b, $core__ops__range__Range_Idx__20as_20core__fmt__Debug___fmt__h6d1aa02eafb6e5f6, core__ptr__drop_in_place__core__iter__adapters__copied__Copied_core__slice__iter__Iter_u8_____h3e9b71a079d16e03, $T_20as_20core__any__Any___type_id__hc907f4034dbd0a64, $_T_20as_20core__fmt__Debug___fmt__h735bfebae1d8ccce, $core__fmt__builders__PadAdapter_20as_20core__fmt__Write___write_str__h2104fbe324f8507b, core__fmt__Write__write_char__hc2121f3713b40ead, core__fmt__Write__write_fmt__hc16feab8d1848af1, $_T_20as_20core__fmt__Debug___fmt__h97cfc1079bb46c17, $_mut_20W_20as_20core__fmt__Write___write_str__h46dcb95720f7397e, $_mut_20W_20as_20core__fmt__Write___write_char__h4b23c146a3be0957, $_mut_20W_20as_20core__fmt__Write___write_fmt__hc3571e849f5ab2de, $_T_20as_20core__fmt__Debug___fmt__he5322a4e17e8a5dc, $_T_20as_20core__fmt__Debug___fmt__hd48a290fb581d84a, $_T_20as_20core__fmt__Debug___fmt__h7e0917d2cb8c0358, $_T_20as_20core__fmt__Debug___fmt__h8ad292a0ec5f3382];
 function __wasm_memory_size() {
  return buffer.byteLength / 65536 | 0;
 }
 
 function __wasm_memory_grow(pagesToAdd) {
  pagesToAdd = pagesToAdd | 0;
  var oldPages = __wasm_memory_size() | 0;
  var newPages = oldPages + pagesToAdd | 0;
  if ((oldPages < newPages) && (newPages < 65536)) {
   var newBuffer = new ArrayBuffer(Math_imul(newPages, 65536));
   var newHEAP8 = new global.Int8Array(newBuffer);
   newHEAP8.set(HEAP8);
   HEAP8 = newHEAP8;
   HEAP8 = new global.Int8Array(newBuffer);
   HEAP16 = new global.Int16Array(newBuffer);
   HEAP32 = new global.Int32Array(newBuffer);
   HEAPU8 = new global.Uint8Array(newBuffer);
   HEAPU16 = new global.Uint16Array(newBuffer);
   HEAPU32 = new global.Uint32Array(newBuffer);
   HEAPF32 = new global.Float32Array(newBuffer);
   HEAPF64 = new global.Float64Array(newBuffer);
   buffer = newBuffer;
  }
  return oldPages;
 }
 
 return {
  "memory": Object.create(Object.prototype, {
   "grow": {
    "value": __wasm_memory_grow
   }, 
   "buffer": {
    "get": function () {
     return buffer;
    }
    
   }
  }), 
  "__wbg_unitinterval_free": __wbg_unitinterval_free, 
  "unitinterval_to_bytes": unitinterval_to_bytes, 
  "unitinterval_from_bytes": unitinterval_from_bytes, 
  "unitinterval_numerator": unitinterval_numerator, 
  "unitinterval_denominator": unitinterval_denominator, 
  "unitinterval_new": unitinterval_new, 
  "__wbg_transaction_free": __wbg_transaction_free, 
  "transaction_to_bytes": transaction_to_bytes, 
  "transaction_from_bytes": transaction_from_bytes, 
  "transaction_body": transaction_body, 
  "transaction_witness_set": transaction_witness_set, 
  "transaction_is_valid": transaction_is_valid, 
  "transaction_auxiliary_data": transaction_auxiliary_data, 
  "transaction_set_is_valid": transaction_set_is_valid, 
  "transaction_new": transaction_new, 
  "__wbg_transactioninputs_free": __wbg_transactioninputs_free, 
  "transactioninputs_to_bytes": transactioninputs_to_bytes, 
  "transactioninputs_from_bytes": transactioninputs_from_bytes, 
  "transactioninputs_new": transactioninputs_new, 
  "transactioninputs_len": transactioninputs_len, 
  "transactioninputs_get": transactioninputs_get, 
  "transactioninputs_add": transactioninputs_add, 
  "__wbg_transactionoutputs_free": __wbg_transactionoutputs_free, 
  "transactionoutputs_to_bytes": transactionoutputs_to_bytes, 
  "transactionoutputs_from_bytes": transactionoutputs_from_bytes, 
  "transactionoutputs_new": transactionoutputs_new, 
  "transactionoutputs_len": transactionoutputs_len, 
  "transactionoutputs_get": transactionoutputs_get, 
  "transactionoutputs_add": transactionoutputs_add, 
  "__wbg_certificates_free": __wbg_certificates_free, 
  "certificates_to_bytes": certificates_to_bytes, 
  "certificates_from_bytes": certificates_from_bytes, 
  "certificates_new": certificates_new, 
  "certificates_len": certificates_len, 
  "certificates_get": certificates_get, 
  "certificates_add": certificates_add, 
  "__wbg_transactionbody_free": __wbg_transactionbody_free, 
  "transactionbody_to_bytes": transactionbody_to_bytes, 
  "transactionbody_from_bytes": transactionbody_from_bytes, 
  "transactionbody_inputs": transactionbody_inputs, 
  "transactionbody_outputs": transactionbody_outputs, 
  "transactionbody_fee": transactionbody_fee, 
  "transactionbody_ttl": transactionbody_ttl, 
  "transactionbody_ttl_bignum": transactionbody_ttl_bignum, 
  "transactionbody_set_ttl": transactionbody_set_ttl, 
  "transactionbody_remove_ttl": transactionbody_remove_ttl, 
  "transactionbody_set_certs": transactionbody_set_certs, 
  "transactionbody_certs": transactionbody_certs, 
  "transactionbody_set_withdrawals": transactionbody_set_withdrawals, 
  "transactionbody_withdrawals": transactionbody_withdrawals, 
  "transactionbody_set_update": transactionbody_set_update, 
  "transactionbody_update": transactionbody_update, 
  "transactionbody_set_auxiliary_data_hash": transactionbody_set_auxiliary_data_hash, 
  "transactionbody_auxiliary_data_hash": transactionbody_auxiliary_data_hash, 
  "transactionbody_set_validity_start_interval": transactionbody_set_validity_start_interval, 
  "transactionbody_set_validity_start_interval_bignum": transactionbody_set_validity_start_interval_bignum, 
  "transactionbody_validity_start_interval_bignum": transactionbody_validity_start_interval_bignum, 
  "transactionbody_validity_start_interval": transactionbody_validity_start_interval, 
  "transactionbody_set_mint": transactionbody_set_mint, 
  "transactionbody_mint": transactionbody_mint, 
  "transactionbody_multiassets": transactionbody_multiassets, 
  "transactionbody_set_script_data_hash": transactionbody_set_script_data_hash, 
  "transactionbody_script_data_hash": transactionbody_script_data_hash, 
  "transactionbody_set_collateral": transactionbody_set_collateral, 
  "transactionbody_collateral": transactionbody_collateral, 
  "transactionbody_set_required_signers": transactionbody_set_required_signers, 
  "transactionbody_required_signers": transactionbody_required_signers, 
  "transactionbody_set_network_id": transactionbody_set_network_id, 
  "transactionbody_network_id": transactionbody_network_id, 
  "transactionbody_new": transactionbody_new, 
  "transactionbody_new_tx_body": transactionbody_new_tx_body, 
  "__wbg_transactioninput_free": __wbg_transactioninput_free, 
  "transactioninput_to_bytes": transactioninput_to_bytes, 
  "transactioninput_from_bytes": transactioninput_from_bytes, 
  "transactioninput_transaction_id": transactioninput_transaction_id, 
  "transactioninput_index": transactioninput_index, 
  "transactioninput_new": transactioninput_new, 
  "__wbg_transactionoutput_free": __wbg_transactionoutput_free, 
  "transactionoutput_to_bytes": transactionoutput_to_bytes, 
  "transactionoutput_from_bytes": transactionoutput_from_bytes, 
  "transactionoutput_address": transactionoutput_address, 
  "transactionoutput_amount": transactionoutput_amount, 
  "transactionoutput_data_hash": transactionoutput_data_hash, 
  "transactionoutput_set_data_hash": transactionoutput_set_data_hash, 
  "transactionoutput_new": transactionoutput_new, 
  "__wbg_stakeregistration_free": __wbg_stakeregistration_free, 
  "stakeregistration_to_bytes": stakeregistration_to_bytes, 
  "stakeregistration_from_bytes": stakeregistration_from_bytes, 
  "stakeregistration_stake_credential": stakeregistration_stake_credential, 
  "stakeregistration_new": stakeregistration_new, 
  "__wbg_stakederegistration_free": __wbg_stakederegistration_free, 
  "stakederegistration_to_bytes": stakederegistration_to_bytes, 
  "stakederegistration_from_bytes": stakederegistration_from_bytes, 
  "stakederegistration_stake_credential": stakederegistration_stake_credential, 
  "stakederegistration_new": stakederegistration_new, 
  "__wbg_stakedelegation_free": __wbg_stakedelegation_free, 
  "stakedelegation_to_bytes": stakedelegation_to_bytes, 
  "stakedelegation_from_bytes": stakedelegation_from_bytes, 
  "stakedelegation_stake_credential": stakedelegation_stake_credential, 
  "stakedelegation_pool_keyhash": stakedelegation_pool_keyhash, 
  "stakedelegation_new": stakedelegation_new, 
  "__wbg_ed25519keyhashes_free": __wbg_ed25519keyhashes_free, 
  "ed25519keyhashes_to_bytes": ed25519keyhashes_to_bytes, 
  "ed25519keyhashes_from_bytes": ed25519keyhashes_from_bytes, 
  "ed25519keyhashes_new": ed25519keyhashes_new, 
  "ed25519keyhashes_len": ed25519keyhashes_len, 
  "ed25519keyhashes_get": ed25519keyhashes_get, 
  "ed25519keyhashes_add": ed25519keyhashes_add, 
  "ed25519keyhashes_to_option": ed25519keyhashes_to_option, 
  "__wbg_relays_free": __wbg_relays_free, 
  "relays_to_bytes": relays_to_bytes, 
  "relays_from_bytes": relays_from_bytes, 
  "relays_new": relays_new, 
  "relays_len": relays_len, 
  "relays_get": relays_get, 
  "relays_add": relays_add, 
  "__wbg_poolparams_free": __wbg_poolparams_free, 
  "poolparams_to_bytes": poolparams_to_bytes, 
  "poolparams_from_bytes": poolparams_from_bytes, 
  "poolparams_operator": poolparams_operator, 
  "poolparams_vrf_keyhash": poolparams_vrf_keyhash, 
  "poolparams_pledge": poolparams_pledge, 
  "poolparams_cost": poolparams_cost, 
  "poolparams_margin": poolparams_margin, 
  "poolparams_reward_account": poolparams_reward_account, 
  "poolparams_pool_owners": poolparams_pool_owners, 
  "poolparams_relays": poolparams_relays, 
  "poolparams_pool_metadata": poolparams_pool_metadata, 
  "poolparams_new": poolparams_new, 
  "__wbg_poolregistration_free": __wbg_poolregistration_free, 
  "poolregistration_to_bytes": poolregistration_to_bytes, 
  "poolregistration_from_bytes": poolregistration_from_bytes, 
  "poolregistration_pool_params": poolregistration_pool_params, 
  "poolregistration_new": poolregistration_new, 
  "__wbg_poolretirement_free": __wbg_poolretirement_free, 
  "poolretirement_to_bytes": poolretirement_to_bytes, 
  "poolretirement_from_bytes": poolretirement_from_bytes, 
  "poolretirement_pool_keyhash": poolretirement_pool_keyhash, 
  "poolretirement_epoch": poolretirement_epoch, 
  "poolretirement_new": poolretirement_new, 
  "__wbg_genesiskeydelegation_free": __wbg_genesiskeydelegation_free, 
  "genesiskeydelegation_to_bytes": genesiskeydelegation_to_bytes, 
  "genesiskeydelegation_from_bytes": genesiskeydelegation_from_bytes, 
  "genesiskeydelegation_genesishash": genesiskeydelegation_genesishash, 
  "genesiskeydelegation_genesis_delegate_hash": genesiskeydelegation_genesis_delegate_hash, 
  "genesiskeydelegation_vrf_keyhash": genesiskeydelegation_vrf_keyhash, 
  "genesiskeydelegation_new": genesiskeydelegation_new, 
  "__wbg_moveinstantaneousrewardscert_free": __wbg_moveinstantaneousrewardscert_free, 
  "moveinstantaneousrewardscert_to_bytes": moveinstantaneousrewardscert_to_bytes, 
  "moveinstantaneousrewardscert_from_bytes": moveinstantaneousrewardscert_from_bytes, 
  "moveinstantaneousrewardscert_move_instantaneous_reward": moveinstantaneousrewardscert_move_instantaneous_reward, 
  "moveinstantaneousrewardscert_new": moveinstantaneousrewardscert_new, 
  "__wbg_certificate_free": __wbg_certificate_free, 
  "certificate_to_bytes": certificate_to_bytes, 
  "certificate_from_bytes": certificate_from_bytes, 
  "certificate_new_stake_registration": certificate_new_stake_registration, 
  "certificate_new_stake_deregistration": certificate_new_stake_deregistration, 
  "certificate_new_stake_delegation": certificate_new_stake_delegation, 
  "certificate_new_pool_registration": certificate_new_pool_registration, 
  "certificate_new_pool_retirement": certificate_new_pool_retirement, 
  "certificate_new_genesis_key_delegation": certificate_new_genesis_key_delegation, 
  "certificate_new_move_instantaneous_rewards_cert": certificate_new_move_instantaneous_rewards_cert, 
  "certificate_kind": certificate_kind, 
  "certificate_as_stake_registration": certificate_as_stake_registration, 
  "certificate_as_stake_deregistration": certificate_as_stake_deregistration, 
  "certificate_as_stake_delegation": certificate_as_stake_delegation, 
  "certificate_as_pool_registration": certificate_as_pool_registration, 
  "certificate_as_pool_retirement": certificate_as_pool_retirement, 
  "certificate_as_genesis_key_delegation": certificate_as_genesis_key_delegation, 
  "certificate_as_move_instantaneous_rewards_cert": certificate_as_move_instantaneous_rewards_cert, 
  "__wbg_mirtostakecredentials_free": __wbg_mirtostakecredentials_free, 
  "mirtostakecredentials_to_bytes": mirtostakecredentials_to_bytes, 
  "mirtostakecredentials_from_bytes": mirtostakecredentials_from_bytes, 
  "mirtostakecredentials_new": mirtostakecredentials_new, 
  "mirtostakecredentials_len": mirtostakecredentials_len, 
  "mirtostakecredentials_insert": mirtostakecredentials_insert, 
  "mirtostakecredentials_get": mirtostakecredentials_get, 
  "mirtostakecredentials_keys": mirtostakecredentials_keys, 
  "__wbg_moveinstantaneousreward_free": __wbg_moveinstantaneousreward_free, 
  "moveinstantaneousreward_to_bytes": moveinstantaneousreward_to_bytes, 
  "moveinstantaneousreward_from_bytes": moveinstantaneousreward_from_bytes, 
  "moveinstantaneousreward_new_to_other_pot": moveinstantaneousreward_new_to_other_pot, 
  "moveinstantaneousreward_new_to_stake_creds": moveinstantaneousreward_new_to_stake_creds, 
  "moveinstantaneousreward_pot": moveinstantaneousreward_pot, 
  "moveinstantaneousreward_kind": moveinstantaneousreward_kind, 
  "moveinstantaneousreward_as_to_other_pot": moveinstantaneousreward_as_to_other_pot, 
  "moveinstantaneousreward_as_to_stake_creds": moveinstantaneousreward_as_to_stake_creds, 
  "__wbg_ipv4_free": __wbg_ipv4_free, 
  "ipv4_to_bytes": ipv4_to_bytes, 
  "ipv4_from_bytes": ipv4_from_bytes, 
  "ipv4_new": ipv4_new, 
  "ipv4_ip": ipv4_ip, 
  "__wbg_ipv6_free": __wbg_ipv6_free, 
  "ipv6_to_bytes": ipv6_to_bytes, 
  "ipv6_from_bytes": ipv6_from_bytes, 
  "ipv6_new": ipv6_new, 
  "ipv6_ip": ipv6_ip, 
  "__wbg_url_free": __wbg_url_free, 
  "url_to_bytes": url_to_bytes, 
  "url_from_bytes": url_from_bytes, 
  "url_new": url_new, 
  "url_url": url_url, 
  "__wbg_dnsrecordaoraaaa_free": __wbg_dnsrecordaoraaaa_free, 
  "dnsrecordaoraaaa_to_bytes": dnsrecordaoraaaa_to_bytes, 
  "dnsrecordaoraaaa_from_bytes": dnsrecordaoraaaa_from_bytes, 
  "dnsrecordaoraaaa_new": dnsrecordaoraaaa_new, 
  "dnsrecordaoraaaa_record": dnsrecordaoraaaa_record, 
  "__wbg_dnsrecordsrv_free": __wbg_dnsrecordsrv_free, 
  "dnsrecordsrv_to_bytes": dnsrecordsrv_to_bytes, 
  "dnsrecordsrv_from_bytes": dnsrecordsrv_from_bytes, 
  "dnsrecordsrv_new": dnsrecordsrv_new, 
  "dnsrecordsrv_record": dnsrecordsrv_record, 
  "__wbg_singlehostaddr_free": __wbg_singlehostaddr_free, 
  "singlehostaddr_to_bytes": singlehostaddr_to_bytes, 
  "singlehostaddr_from_bytes": singlehostaddr_from_bytes, 
  "singlehostaddr_port": singlehostaddr_port, 
  "singlehostaddr_ipv4": singlehostaddr_ipv4, 
  "singlehostaddr_ipv6": singlehostaddr_ipv6, 
  "singlehostaddr_new": singlehostaddr_new, 
  "__wbg_singlehostname_free": __wbg_singlehostname_free, 
  "singlehostname_to_bytes": singlehostname_to_bytes, 
  "singlehostname_from_bytes": singlehostname_from_bytes, 
  "singlehostname_port": singlehostname_port, 
  "singlehostname_dns_name": singlehostname_dns_name, 
  "singlehostname_new": singlehostname_new, 
  "__wbg_multihostname_free": __wbg_multihostname_free, 
  "multihostname_to_bytes": multihostname_to_bytes, 
  "multihostname_from_bytes": multihostname_from_bytes, 
  "multihostname_dns_name": multihostname_dns_name, 
  "multihostname_new": multihostname_new, 
  "__wbg_relay_free": __wbg_relay_free, 
  "relay_to_bytes": relay_to_bytes, 
  "relay_from_bytes": relay_from_bytes, 
  "relay_new_single_host_addr": relay_new_single_host_addr, 
  "relay_new_single_host_name": relay_new_single_host_name, 
  "relay_new_multi_host_name": relay_new_multi_host_name, 
  "relay_kind": relay_kind, 
  "relay_as_single_host_addr": relay_as_single_host_addr, 
  "relay_as_single_host_name": relay_as_single_host_name, 
  "relay_as_multi_host_name": relay_as_multi_host_name, 
  "__wbg_poolmetadata_free": __wbg_poolmetadata_free, 
  "poolmetadata_to_bytes": poolmetadata_to_bytes, 
  "poolmetadata_from_bytes": poolmetadata_from_bytes, 
  "poolmetadata_url": poolmetadata_url, 
  "poolmetadata_pool_metadata_hash": poolmetadata_pool_metadata_hash, 
  "poolmetadata_new": poolmetadata_new, 
  "__wbg_stakecredentials_free": __wbg_stakecredentials_free, 
  "stakecredentials_to_bytes": stakecredentials_to_bytes, 
  "stakecredentials_from_bytes": stakecredentials_from_bytes, 
  "stakecredentials_new": stakecredentials_new, 
  "stakecredentials_len": stakecredentials_len, 
  "stakecredentials_get": stakecredentials_get, 
  "stakecredentials_add": stakecredentials_add, 
  "__wbg_rewardaddresses_free": __wbg_rewardaddresses_free, 
  "rewardaddresses_to_bytes": rewardaddresses_to_bytes, 
  "rewardaddresses_from_bytes": rewardaddresses_from_bytes, 
  "rewardaddresses_new": rewardaddresses_new, 
  "rewardaddresses_len": rewardaddresses_len, 
  "rewardaddresses_get": rewardaddresses_get, 
  "rewardaddresses_add": rewardaddresses_add, 
  "__wbg_withdrawals_free": __wbg_withdrawals_free, 
  "withdrawals_to_bytes": withdrawals_to_bytes, 
  "withdrawals_from_bytes": withdrawals_from_bytes, 
  "withdrawals_new": withdrawals_new, 
  "withdrawals_len": withdrawals_len, 
  "withdrawals_insert": withdrawals_insert, 
  "withdrawals_get": withdrawals_get, 
  "withdrawals_keys": withdrawals_keys, 
  "__wbg_transactionwitnessset_free": __wbg_transactionwitnessset_free, 
  "transactionwitnessset_to_bytes": transactionwitnessset_to_bytes, 
  "transactionwitnessset_from_bytes": transactionwitnessset_from_bytes, 
  "transactionwitnessset_set_vkeys": transactionwitnessset_set_vkeys, 
  "transactionwitnessset_vkeys": transactionwitnessset_vkeys, 
  "transactionwitnessset_set_native_scripts": transactionwitnessset_set_native_scripts, 
  "transactionwitnessset_native_scripts": transactionwitnessset_native_scripts, 
  "transactionwitnessset_set_bootstraps": transactionwitnessset_set_bootstraps, 
  "transactionwitnessset_bootstraps": transactionwitnessset_bootstraps, 
  "transactionwitnessset_set_plutus_scripts": transactionwitnessset_set_plutus_scripts, 
  "transactionwitnessset_plutus_scripts": transactionwitnessset_plutus_scripts, 
  "transactionwitnessset_set_plutus_data": transactionwitnessset_set_plutus_data, 
  "transactionwitnessset_plutus_data": transactionwitnessset_plutus_data, 
  "transactionwitnessset_set_redeemers": transactionwitnessset_set_redeemers, 
  "transactionwitnessset_redeemers": transactionwitnessset_redeemers, 
  "transactionwitnessset_new": transactionwitnessset_new, 
  "__wbg_scriptpubkey_free": __wbg_scriptpubkey_free, 
  "scriptpubkey_to_bytes": scriptpubkey_to_bytes, 
  "scriptpubkey_from_bytes": scriptpubkey_from_bytes, 
  "scriptpubkey_addr_keyhash": scriptpubkey_addr_keyhash, 
  "scriptpubkey_new": scriptpubkey_new, 
  "__wbg_scriptall_free": __wbg_scriptall_free, 
  "scriptall_to_bytes": scriptall_to_bytes, 
  "scriptall_from_bytes": scriptall_from_bytes, 
  "scriptall_native_scripts": scriptall_native_scripts, 
  "scriptall_new": scriptall_new, 
  "__wbg_scriptany_free": __wbg_scriptany_free, 
  "scriptany_to_bytes": scriptany_to_bytes, 
  "scriptany_from_bytes": scriptany_from_bytes, 
  "scriptany_native_scripts": scriptany_native_scripts, 
  "scriptany_new": scriptany_new, 
  "__wbg_scriptnofk_free": __wbg_scriptnofk_free, 
  "scriptnofk_to_bytes": scriptnofk_to_bytes, 
  "scriptnofk_from_bytes": scriptnofk_from_bytes, 
  "scriptnofk_n": scriptnofk_n, 
  "scriptnofk_native_scripts": scriptnofk_native_scripts, 
  "scriptnofk_new": scriptnofk_new, 
  "__wbg_timelockstart_free": __wbg_timelockstart_free, 
  "timelockstart_to_bytes": timelockstart_to_bytes, 
  "timelockstart_from_bytes": timelockstart_from_bytes, 
  "timelockstart_slot": timelockstart_slot, 
  "timelockstart_slot_bignum": timelockstart_slot_bignum, 
  "timelockstart_new": timelockstart_new, 
  "timelockstart_new_timelockstart": timelockstart_new_timelockstart, 
  "__wbg_timelockexpiry_free": __wbg_timelockexpiry_free, 
  "timelockexpiry_to_bytes": timelockexpiry_to_bytes, 
  "timelockexpiry_from_bytes": timelockexpiry_from_bytes, 
  "timelockexpiry_slot": timelockexpiry_slot, 
  "timelockexpiry_slot_bignum": timelockexpiry_slot_bignum, 
  "timelockexpiry_new": timelockexpiry_new, 
  "timelockexpiry_new_timelockexpiry": timelockexpiry_new_timelockexpiry, 
  "__wbg_nativescript_free": __wbg_nativescript_free, 
  "nativescript_to_bytes": nativescript_to_bytes, 
  "nativescript_from_bytes": nativescript_from_bytes, 
  "nativescript_hash": nativescript_hash, 
  "nativescript_new_script_pubkey": nativescript_new_script_pubkey, 
  "nativescript_new_script_all": nativescript_new_script_all, 
  "nativescript_new_script_any": nativescript_new_script_any, 
  "nativescript_new_script_n_of_k": nativescript_new_script_n_of_k, 
  "nativescript_new_timelock_start": nativescript_new_timelock_start, 
  "nativescript_new_timelock_expiry": nativescript_new_timelock_expiry, 
  "nativescript_kind": nativescript_kind, 
  "nativescript_as_script_pubkey": nativescript_as_script_pubkey, 
  "nativescript_as_script_all": nativescript_as_script_all, 
  "nativescript_as_script_any": nativescript_as_script_any, 
  "nativescript_as_script_n_of_k": nativescript_as_script_n_of_k, 
  "nativescript_as_timelock_start": nativescript_as_timelock_start, 
  "nativescript_as_timelock_expiry": nativescript_as_timelock_expiry, 
  "nativescript_get_required_signers": nativescript_get_required_signers, 
  "__wbg_nativescripts_free": __wbg_nativescripts_free, 
  "nativescripts_new": nativescripts_new, 
  "nativescripts_len": nativescripts_len, 
  "nativescripts_get": nativescripts_get, 
  "nativescripts_add": nativescripts_add, 
  "__wbg_update_free": __wbg_update_free, 
  "update_to_bytes": update_to_bytes, 
  "update_from_bytes": update_from_bytes, 
  "update_proposed_protocol_parameter_updates": update_proposed_protocol_parameter_updates, 
  "update_epoch": update_epoch, 
  "update_new": update_new, 
  "__wbg_genesishashes_free": __wbg_genesishashes_free, 
  "genesishashes_to_bytes": genesishashes_to_bytes, 
  "genesishashes_from_bytes": genesishashes_from_bytes, 
  "genesishashes_new": genesishashes_new, 
  "genesishashes_len": genesishashes_len, 
  "genesishashes_get": genesishashes_get, 
  "genesishashes_add": genesishashes_add, 
  "__wbg_scripthashes_free": __wbg_scripthashes_free, 
  "scripthashes_to_bytes": scripthashes_to_bytes, 
  "scripthashes_from_bytes": scripthashes_from_bytes, 
  "scripthashes_new": scripthashes_new, 
  "scripthashes_len": scripthashes_len, 
  "scripthashes_get": scripthashes_get, 
  "scripthashes_add": scripthashes_add, 
  "__wbg_proposedprotocolparameterupdates_free": __wbg_proposedprotocolparameterupdates_free, 
  "proposedprotocolparameterupdates_to_bytes": proposedprotocolparameterupdates_to_bytes, 
  "proposedprotocolparameterupdates_from_bytes": proposedprotocolparameterupdates_from_bytes, 
  "proposedprotocolparameterupdates_new": proposedprotocolparameterupdates_new, 
  "proposedprotocolparameterupdates_len": proposedprotocolparameterupdates_len, 
  "proposedprotocolparameterupdates_insert": proposedprotocolparameterupdates_insert, 
  "proposedprotocolparameterupdates_get": proposedprotocolparameterupdates_get, 
  "proposedprotocolparameterupdates_keys": proposedprotocolparameterupdates_keys, 
  "__wbg_protocolversion_free": __wbg_protocolversion_free, 
  "protocolversion_to_bytes": protocolversion_to_bytes, 
  "protocolversion_from_bytes": protocolversion_from_bytes, 
  "protocolversion_major": protocolversion_major, 
  "protocolversion_minor": protocolversion_minor, 
  "protocolversion_new": protocolversion_new, 
  "__wbg_protocolversions_free": __wbg_protocolversions_free, 
  "protocolversions_to_bytes": protocolversions_to_bytes, 
  "protocolversions_from_bytes": protocolversions_from_bytes, 
  "protocolversions_new": protocolversions_new, 
  "protocolversions_len": protocolversions_len, 
  "protocolversions_get": protocolversions_get, 
  "protocolversions_add": protocolversions_add, 
  "__wbg_protocolparamupdate_free": __wbg_protocolparamupdate_free, 
  "protocolparamupdate_to_bytes": protocolparamupdate_to_bytes, 
  "protocolparamupdate_from_bytes": protocolparamupdate_from_bytes, 
  "protocolparamupdate_set_minfee_a": protocolparamupdate_set_minfee_a, 
  "protocolparamupdate_minfee_a": protocolparamupdate_minfee_a, 
  "protocolparamupdate_set_minfee_b": protocolparamupdate_set_minfee_b, 
  "protocolparamupdate_minfee_b": protocolparamupdate_minfee_b, 
  "protocolparamupdate_set_max_block_body_size": protocolparamupdate_set_max_block_body_size, 
  "protocolparamupdate_max_block_body_size": protocolparamupdate_max_block_body_size, 
  "protocolparamupdate_set_max_tx_size": protocolparamupdate_set_max_tx_size, 
  "protocolparamupdate_max_tx_size": protocolparamupdate_max_tx_size, 
  "protocolparamupdate_set_max_block_header_size": protocolparamupdate_set_max_block_header_size, 
  "protocolparamupdate_max_block_header_size": protocolparamupdate_max_block_header_size, 
  "protocolparamupdate_set_key_deposit": protocolparamupdate_set_key_deposit, 
  "protocolparamupdate_key_deposit": protocolparamupdate_key_deposit, 
  "protocolparamupdate_set_pool_deposit": protocolparamupdate_set_pool_deposit, 
  "protocolparamupdate_pool_deposit": protocolparamupdate_pool_deposit, 
  "protocolparamupdate_set_max_epoch": protocolparamupdate_set_max_epoch, 
  "protocolparamupdate_max_epoch": protocolparamupdate_max_epoch, 
  "protocolparamupdate_set_n_opt": protocolparamupdate_set_n_opt, 
  "protocolparamupdate_n_opt": protocolparamupdate_n_opt, 
  "protocolparamupdate_set_pool_pledge_influence": protocolparamupdate_set_pool_pledge_influence, 
  "protocolparamupdate_pool_pledge_influence": protocolparamupdate_pool_pledge_influence, 
  "protocolparamupdate_set_expansion_rate": protocolparamupdate_set_expansion_rate, 
  "protocolparamupdate_expansion_rate": protocolparamupdate_expansion_rate, 
  "protocolparamupdate_set_treasury_growth_rate": protocolparamupdate_set_treasury_growth_rate, 
  "protocolparamupdate_treasury_growth_rate": protocolparamupdate_treasury_growth_rate, 
  "protocolparamupdate_set_d": protocolparamupdate_set_d, 
  "protocolparamupdate_d": protocolparamupdate_d, 
  "protocolparamupdate_set_extra_entropy": protocolparamupdate_set_extra_entropy, 
  "protocolparamupdate_extra_entropy": protocolparamupdate_extra_entropy, 
  "protocolparamupdate_set_protocol_version": protocolparamupdate_set_protocol_version, 
  "protocolparamupdate_protocol_version": protocolparamupdate_protocol_version, 
  "protocolparamupdate_set_min_pool_cost": protocolparamupdate_set_min_pool_cost, 
  "protocolparamupdate_min_pool_cost": protocolparamupdate_min_pool_cost, 
  "protocolparamupdate_set_ada_per_utxo_byte": protocolparamupdate_set_ada_per_utxo_byte, 
  "protocolparamupdate_ada_per_utxo_byte": protocolparamupdate_ada_per_utxo_byte, 
  "protocolparamupdate_set_cost_models": protocolparamupdate_set_cost_models, 
  "protocolparamupdate_cost_models": protocolparamupdate_cost_models, 
  "protocolparamupdate_set_execution_costs": protocolparamupdate_set_execution_costs, 
  "protocolparamupdate_execution_costs": protocolparamupdate_execution_costs, 
  "protocolparamupdate_set_max_tx_ex_units": protocolparamupdate_set_max_tx_ex_units, 
  "protocolparamupdate_max_tx_ex_units": protocolparamupdate_max_tx_ex_units, 
  "protocolparamupdate_set_max_block_ex_units": protocolparamupdate_set_max_block_ex_units, 
  "protocolparamupdate_max_block_ex_units": protocolparamupdate_max_block_ex_units, 
  "protocolparamupdate_set_max_value_size": protocolparamupdate_set_max_value_size, 
  "protocolparamupdate_max_value_size": protocolparamupdate_max_value_size, 
  "protocolparamupdate_set_collateral_percentage": protocolparamupdate_set_collateral_percentage, 
  "protocolparamupdate_collateral_percentage": protocolparamupdate_collateral_percentage, 
  "protocolparamupdate_set_max_collateral_inputs": protocolparamupdate_set_max_collateral_inputs, 
  "protocolparamupdate_max_collateral_inputs": protocolparamupdate_max_collateral_inputs, 
  "protocolparamupdate_new": protocolparamupdate_new, 
  "__wbg_transactionbodies_free": __wbg_transactionbodies_free, 
  "transactionbodies_to_bytes": transactionbodies_to_bytes, 
  "transactionbodies_from_bytes": transactionbodies_from_bytes, 
  "transactionbodies_new": transactionbodies_new, 
  "transactionbodies_len": transactionbodies_len, 
  "transactionbodies_get": transactionbodies_get, 
  "transactionbodies_add": transactionbodies_add, 
  "__wbg_transactionwitnesssets_free": __wbg_transactionwitnesssets_free, 
  "transactionwitnesssets_to_bytes": transactionwitnesssets_to_bytes, 
  "transactionwitnesssets_from_bytes": transactionwitnesssets_from_bytes, 
  "transactionwitnesssets_new": transactionwitnesssets_new, 
  "transactionwitnesssets_len": transactionwitnesssets_len, 
  "transactionwitnesssets_get": transactionwitnesssets_get, 
  "transactionwitnesssets_add": transactionwitnesssets_add, 
  "__wbg_auxiliarydataset_free": __wbg_auxiliarydataset_free, 
  "auxiliarydataset_new": auxiliarydataset_new, 
  "auxiliarydataset_len": auxiliarydataset_len, 
  "auxiliarydataset_insert": auxiliarydataset_insert, 
  "auxiliarydataset_get": auxiliarydataset_get, 
  "auxiliarydataset_indices": auxiliarydataset_indices, 
  "__wbg_block_free": __wbg_block_free, 
  "block_to_bytes": block_to_bytes, 
  "block_from_bytes": block_from_bytes, 
  "block_header": block_header, 
  "block_transaction_bodies": block_transaction_bodies, 
  "block_transaction_witness_sets": block_transaction_witness_sets, 
  "block_auxiliary_data_set": block_auxiliary_data_set, 
  "block_invalid_transactions": block_invalid_transactions, 
  "block_new": block_new, 
  "__wbg_header_free": __wbg_header_free, 
  "header_to_bytes": header_to_bytes, 
  "header_from_bytes": header_from_bytes, 
  "header_header_body": header_header_body, 
  "header_body_signature": header_body_signature, 
  "header_new": header_new, 
  "__wbg_operationalcert_free": __wbg_operationalcert_free, 
  "operationalcert_to_bytes": operationalcert_to_bytes, 
  "operationalcert_from_bytes": operationalcert_from_bytes, 
  "operationalcert_hot_vkey": operationalcert_hot_vkey, 
  "operationalcert_sequence_number": operationalcert_sequence_number, 
  "operationalcert_kes_period": operationalcert_kes_period, 
  "operationalcert_sigma": operationalcert_sigma, 
  "operationalcert_new": operationalcert_new, 
  "__wbg_headerbody_free": __wbg_headerbody_free, 
  "headerbody_to_bytes": headerbody_to_bytes, 
  "headerbody_from_bytes": headerbody_from_bytes, 
  "headerbody_block_number": headerbody_block_number, 
  "headerbody_slot": headerbody_slot, 
  "headerbody_slot_bignum": headerbody_slot_bignum, 
  "headerbody_prev_hash": headerbody_prev_hash, 
  "headerbody_issuer_vkey": headerbody_issuer_vkey, 
  "headerbody_vrf_vkey": headerbody_vrf_vkey, 
  "headerbody_nonce_vrf": headerbody_nonce_vrf, 
  "headerbody_leader_vrf": headerbody_leader_vrf, 
  "headerbody_block_body_size": headerbody_block_body_size, 
  "headerbody_block_body_hash": headerbody_block_body_hash, 
  "headerbody_operational_cert": headerbody_operational_cert, 
  "headerbody_protocol_version": headerbody_protocol_version, 
  "headerbody_new": headerbody_new, 
  "headerbody_new_headerbody": headerbody_new_headerbody, 
  "__wbg_assetname_free": __wbg_assetname_free, 
  "assetname_to_bytes": assetname_to_bytes, 
  "assetname_from_bytes": assetname_from_bytes, 
  "assetname_new": assetname_new, 
  "assetname_name": assetname_name, 
  "__wbg_assetnames_free": __wbg_assetnames_free, 
  "assetnames_to_bytes": assetnames_to_bytes, 
  "assetnames_from_bytes": assetnames_from_bytes, 
  "assetnames_new": assetnames_new, 
  "assetnames_len": assetnames_len, 
  "assetnames_get": assetnames_get, 
  "assetnames_add": assetnames_add, 
  "__wbg_assets_free": __wbg_assets_free, 
  "assets_to_bytes": assets_to_bytes, 
  "assets_from_bytes": assets_from_bytes, 
  "assets_new": assets_new, 
  "assets_len": assets_len, 
  "assets_insert": assets_insert, 
  "assets_get": assets_get, 
  "assets_keys": assets_keys, 
  "__wbg_multiasset_free": __wbg_multiasset_free, 
  "multiasset_to_bytes": multiasset_to_bytes, 
  "multiasset_from_bytes": multiasset_from_bytes, 
  "multiasset_new": multiasset_new, 
  "multiasset_len": multiasset_len, 
  "multiasset_insert": multiasset_insert, 
  "multiasset_get": multiasset_get, 
  "multiasset_set_asset": multiasset_set_asset, 
  "multiasset_get_asset": multiasset_get_asset, 
  "multiasset_keys": multiasset_keys, 
  "multiasset_sub": multiasset_sub, 
  "__wbg_mintassets_free": __wbg_mintassets_free, 
  "mintassets_new": mintassets_new, 
  "mintassets_new_from_entry": mintassets_new_from_entry, 
  "mintassets_len": mintassets_len, 
  "mintassets_insert": mintassets_insert, 
  "mintassets_get": mintassets_get, 
  "mintassets_keys": mintassets_keys, 
  "__wbg_mint_free": __wbg_mint_free, 
  "mint_to_bytes": mint_to_bytes, 
  "mint_from_bytes": mint_from_bytes, 
  "mint_new": mint_new, 
  "mint_new_from_entry": mint_new_from_entry, 
  "mint_len": mint_len, 
  "mint_insert": mint_insert, 
  "mint_get": mint_get, 
  "mint_keys": mint_keys, 
  "mint_as_positive_multiasset": mint_as_positive_multiasset, 
  "mint_as_negative_multiasset": mint_as_negative_multiasset, 
  "__wbg_networkid_free": __wbg_networkid_free, 
  "networkid_to_bytes": networkid_to_bytes, 
  "networkid_from_bytes": networkid_from_bytes, 
  "networkid_testnet": networkid_testnet, 
  "networkid_mainnet": networkid_mainnet, 
  "networkid_kind": networkid_kind, 
  "__wbg_transactionoutputbuilder_free": __wbg_transactionoutputbuilder_free, 
  "transactionoutputbuilder_new": transactionoutputbuilder_new, 
  "transactionoutputbuilder_with_address": transactionoutputbuilder_with_address, 
  "transactionoutputbuilder_with_data_hash": transactionoutputbuilder_with_data_hash, 
  "transactionoutputbuilder_next": transactionoutputbuilder_next, 
  "__wbg_transactionoutputamountbuilder_free": __wbg_transactionoutputamountbuilder_free, 
  "transactionoutputamountbuilder_with_value": transactionoutputamountbuilder_with_value, 
  "transactionoutputamountbuilder_with_coin": transactionoutputamountbuilder_with_coin, 
  "transactionoutputamountbuilder_with_coin_and_asset": transactionoutputamountbuilder_with_coin_and_asset, 
  "transactionoutputamountbuilder_with_asset_and_min_required_coin": transactionoutputamountbuilder_with_asset_and_min_required_coin, 
  "transactionoutputamountbuilder_build": transactionoutputamountbuilder_build, 
  "__wbg_transactionunspentoutput_free": __wbg_transactionunspentoutput_free, 
  "transactionunspentoutput_to_bytes": transactionunspentoutput_to_bytes, 
  "transactionunspentoutput_from_bytes": transactionunspentoutput_from_bytes, 
  "transactionunspentoutput_new": transactionunspentoutput_new, 
  "transactionunspentoutput_input": transactionunspentoutput_input, 
  "transactionunspentoutput_output": transactionunspentoutput_output, 
  "__wbg_transactionunspentoutputs_free": __wbg_transactionunspentoutputs_free, 
  "transactionunspentoutputs_new": transactionunspentoutputs_new, 
  "transactionunspentoutputs_len": transactionunspentoutputs_len, 
  "transactionunspentoutputs_get": transactionunspentoutputs_get, 
  "transactionunspentoutputs_add": transactionunspentoutputs_add, 
  "__wbg_bignum_free": __wbg_bignum_free, 
  "bignum_to_bytes": bignum_to_bytes, 
  "bignum_from_bytes": bignum_from_bytes, 
  "bignum_from_str": bignum_from_str, 
  "bignum_to_str": bignum_to_str, 
  "bignum_zero": bignum_zero, 
  "bignum_one": bignum_one, 
  "bignum_is_zero": bignum_is_zero, 
  "bignum_checked_mul": bignum_checked_mul, 
  "bignum_checked_add": bignum_checked_add, 
  "bignum_checked_sub": bignum_checked_sub, 
  "bignum_clamped_sub": bignum_clamped_sub, 
  "bignum_compare": bignum_compare, 
  "__wbg_value_free": __wbg_value_free, 
  "value_to_bytes": value_to_bytes, 
  "value_from_bytes": value_from_bytes, 
  "value_new": value_new, 
  "value_new_from_assets": value_new_from_assets, 
  "value_zero": value_zero, 
  "value_is_zero": value_is_zero, 
  "value_coin": value_coin, 
  "value_set_coin": value_set_coin, 
  "value_multiasset": value_multiasset, 
  "value_set_multiasset": value_set_multiasset, 
  "value_checked_add": value_checked_add, 
  "value_checked_sub": value_checked_sub, 
  "value_clamped_sub": value_clamped_sub, 
  "value_compare": value_compare, 
  "__wbg_int_free": __wbg_int_free, 
  "int_to_bytes": int_to_bytes, 
  "int_from_bytes": int_from_bytes, 
  "int_new": int_new, 
  "int_new_negative": int_new_negative, 
  "int_new_i32": int_new_i32, 
  "int_is_positive": int_is_positive, 
  "int_as_positive": int_as_positive, 
  "int_as_negative": int_as_negative, 
  "int_as_i32": int_as_i32, 
  "int_as_i32_or_nothing": int_as_i32_or_nothing, 
  "int_as_i32_or_fail": int_as_i32_or_fail, 
  "int_to_str": int_to_str, 
  "__wbg_bigint_free": __wbg_bigint_free, 
  "bigint_to_bytes": bigint_to_bytes, 
  "bigint_from_bytes": bigint_from_bytes, 
  "bigint_is_zero": bigint_is_zero, 
  "bigint_as_u64": bigint_as_u64, 
  "bigint_from_str": bigint_from_str, 
  "bigint_to_str": bigint_to_str, 
  "bigint_add": bigint_add, 
  "bigint_mul": bigint_mul, 
  "bigint_one": bigint_one, 
  "bigint_increment": bigint_increment, 
  "bigint_div_ceil": bigint_div_ceil, 
  "make_daedalus_bootstrap_witness": make_daedalus_bootstrap_witness, 
  "make_icarus_bootstrap_witness": make_icarus_bootstrap_witness, 
  "make_vkey_witness": make_vkey_witness, 
  "hash_auxiliary_data": hash_auxiliary_data, 
  "hash_transaction": hash_transaction, 
  "hash_plutus_data": hash_plutus_data, 
  "hash_script_data": hash_script_data, 
  "get_implicit_input": get_implicit_input, 
  "get_deposit": get_deposit, 
  "min_ada_required": min_ada_required, 
  "encode_json_str_to_native_script": encode_json_str_to_native_script, 
  "__wbg_metadatamap_free": __wbg_metadatamap_free, 
  "metadatamap_to_bytes": metadatamap_to_bytes, 
  "metadatamap_from_bytes": metadatamap_from_bytes, 
  "metadatamap_new": metadatamap_new, 
  "metadatamap_len": metadatamap_len, 
  "metadatamap_insert": metadatamap_insert, 
  "metadatamap_insert_str": metadatamap_insert_str, 
  "metadatamap_insert_i32": metadatamap_insert_i32, 
  "metadatamap_get": metadatamap_get, 
  "metadatamap_get_str": metadatamap_get_str, 
  "metadatamap_get_i32": metadatamap_get_i32, 
  "metadatamap_has": metadatamap_has, 
  "metadatamap_keys": metadatamap_keys, 
  "__wbg_metadatalist_free": __wbg_metadatalist_free, 
  "metadatalist_to_bytes": metadatalist_to_bytes, 
  "metadatalist_from_bytes": metadatalist_from_bytes, 
  "metadatalist_new": metadatalist_new, 
  "metadatalist_len": metadatalist_len, 
  "metadatalist_get": metadatalist_get, 
  "metadatalist_add": metadatalist_add, 
  "__wbg_transactionmetadatum_free": __wbg_transactionmetadatum_free, 
  "transactionmetadatum_to_bytes": transactionmetadatum_to_bytes, 
  "transactionmetadatum_from_bytes": transactionmetadatum_from_bytes, 
  "transactionmetadatum_new_map": transactionmetadatum_new_map, 
  "transactionmetadatum_new_list": transactionmetadatum_new_list, 
  "transactionmetadatum_new_int": transactionmetadatum_new_int, 
  "transactionmetadatum_new_bytes": transactionmetadatum_new_bytes, 
  "transactionmetadatum_new_text": transactionmetadatum_new_text, 
  "transactionmetadatum_kind": transactionmetadatum_kind, 
  "transactionmetadatum_as_map": transactionmetadatum_as_map, 
  "transactionmetadatum_as_list": transactionmetadatum_as_list, 
  "transactionmetadatum_as_int": transactionmetadatum_as_int, 
  "transactionmetadatum_as_bytes": transactionmetadatum_as_bytes, 
  "transactionmetadatum_as_text": transactionmetadatum_as_text, 
  "__wbg_transactionmetadatumlabels_free": __wbg_transactionmetadatumlabels_free, 
  "transactionmetadatumlabels_to_bytes": transactionmetadatumlabels_to_bytes, 
  "transactionmetadatumlabels_from_bytes": transactionmetadatumlabels_from_bytes, 
  "transactionmetadatumlabels_new": transactionmetadatumlabels_new, 
  "transactionmetadatumlabels_len": transactionmetadatumlabels_len, 
  "transactionmetadatumlabels_get": transactionmetadatumlabels_get, 
  "transactionmetadatumlabels_add": transactionmetadatumlabels_add, 
  "__wbg_generaltransactionmetadata_free": __wbg_generaltransactionmetadata_free, 
  "generaltransactionmetadata_to_bytes": generaltransactionmetadata_to_bytes, 
  "generaltransactionmetadata_from_bytes": generaltransactionmetadata_from_bytes, 
  "generaltransactionmetadata_new": generaltransactionmetadata_new, 
  "generaltransactionmetadata_len": generaltransactionmetadata_len, 
  "generaltransactionmetadata_insert": generaltransactionmetadata_insert, 
  "generaltransactionmetadata_get": generaltransactionmetadata_get, 
  "generaltransactionmetadata_keys": generaltransactionmetadata_keys, 
  "__wbg_auxiliarydata_free": __wbg_auxiliarydata_free, 
  "auxiliarydata_to_bytes": auxiliarydata_to_bytes, 
  "auxiliarydata_from_bytes": auxiliarydata_from_bytes, 
  "auxiliarydata_new": auxiliarydata_new, 
  "auxiliarydata_metadata": auxiliarydata_metadata, 
  "auxiliarydata_set_metadata": auxiliarydata_set_metadata, 
  "auxiliarydata_native_scripts": auxiliarydata_native_scripts, 
  "auxiliarydata_set_native_scripts": auxiliarydata_set_native_scripts, 
  "auxiliarydata_plutus_scripts": auxiliarydata_plutus_scripts, 
  "auxiliarydata_set_plutus_scripts": auxiliarydata_set_plutus_scripts, 
  "encode_arbitrary_bytes_as_metadatum": encode_arbitrary_bytes_as_metadatum, 
  "decode_arbitrary_bytes_from_metadatum": decode_arbitrary_bytes_from_metadatum, 
  "encode_json_str_to_metadatum": encode_json_str_to_metadatum, 
  "decode_metadatum_to_json_str": decode_metadatum_to_json_str, 
  "__wbg_linearfee_free": __wbg_linearfee_free, 
  "linearfee_constant": linearfee_constant, 
  "linearfee_coefficient": linearfee_coefficient, 
  "linearfee_new": linearfee_new, 
  "min_fee": min_fee, 
  "calculate_ex_units_ceil_cost": calculate_ex_units_ceil_cost, 
  "min_script_fee": min_script_fee, 
  "__wbg_transactionbuilderconfig_free": __wbg_transactionbuilderconfig_free, 
  "__wbg_transactionbuilderconfigbuilder_free": __wbg_transactionbuilderconfigbuilder_free, 
  "transactionbuilderconfigbuilder_new": transactionbuilderconfigbuilder_new, 
  "transactionbuilderconfigbuilder_fee_algo": transactionbuilderconfigbuilder_fee_algo, 
  "transactionbuilderconfigbuilder_coins_per_utxo_word": transactionbuilderconfigbuilder_coins_per_utxo_word, 
  "transactionbuilderconfigbuilder_ex_unit_prices": transactionbuilderconfigbuilder_ex_unit_prices, 
  "transactionbuilderconfigbuilder_pool_deposit": transactionbuilderconfigbuilder_pool_deposit, 
  "transactionbuilderconfigbuilder_key_deposit": transactionbuilderconfigbuilder_key_deposit, 
  "transactionbuilderconfigbuilder_max_value_size": transactionbuilderconfigbuilder_max_value_size, 
  "transactionbuilderconfigbuilder_max_tx_size": transactionbuilderconfigbuilder_max_tx_size, 
  "transactionbuilderconfigbuilder_prefer_pure_change": transactionbuilderconfigbuilder_prefer_pure_change, 
  "transactionbuilderconfigbuilder_build": transactionbuilderconfigbuilder_build, 
  "__wbg_transactionbuilder_free": __wbg_transactionbuilder_free, 
  "transactionbuilder_add_inputs_from": transactionbuilder_add_inputs_from, 
  "transactionbuilder_set_inputs": transactionbuilder_set_inputs, 
  "transactionbuilder_set_collateral": transactionbuilder_set_collateral, 
  "transactionbuilder_add_key_input": transactionbuilder_add_key_input, 
  "transactionbuilder_add_script_input": transactionbuilder_add_script_input, 
  "transactionbuilder_add_native_script_input": transactionbuilder_add_native_script_input, 
  "transactionbuilder_add_plutus_script_input": transactionbuilder_add_plutus_script_input, 
  "transactionbuilder_add_bootstrap_input": transactionbuilder_add_bootstrap_input, 
  "transactionbuilder_add_input": transactionbuilder_add_input, 
  "transactionbuilder_count_missing_input_scripts": transactionbuilder_count_missing_input_scripts, 
  "transactionbuilder_add_required_native_input_scripts": transactionbuilder_add_required_native_input_scripts, 
  "transactionbuilder_add_required_plutus_input_scripts": transactionbuilder_add_required_plutus_input_scripts, 
  "transactionbuilder_get_native_input_scripts": transactionbuilder_get_native_input_scripts, 
  "transactionbuilder_get_plutus_input_scripts": transactionbuilder_get_plutus_input_scripts, 
  "transactionbuilder_fee_for_input": transactionbuilder_fee_for_input, 
  "transactionbuilder_add_output": transactionbuilder_add_output, 
  "transactionbuilder_fee_for_output": transactionbuilder_fee_for_output, 
  "transactionbuilder_set_fee": transactionbuilder_set_fee, 
  "transactionbuilder_set_ttl": transactionbuilder_set_ttl, 
  "transactionbuilder_set_ttl_bignum": transactionbuilder_set_ttl_bignum, 
  "transactionbuilder_set_validity_start_interval": transactionbuilder_set_validity_start_interval, 
  "transactionbuilder_set_validity_start_interval_bignum": transactionbuilder_set_validity_start_interval_bignum, 
  "transactionbuilder_set_certs": transactionbuilder_set_certs, 
  "transactionbuilder_set_withdrawals": transactionbuilder_set_withdrawals, 
  "transactionbuilder_get_auxiliary_data": transactionbuilder_get_auxiliary_data, 
  "transactionbuilder_set_auxiliary_data": transactionbuilder_set_auxiliary_data, 
  "transactionbuilder_set_metadata": transactionbuilder_set_metadata, 
  "transactionbuilder_add_metadatum": transactionbuilder_add_metadatum, 
  "transactionbuilder_add_json_metadatum": transactionbuilder_add_json_metadatum, 
  "transactionbuilder_add_json_metadatum_with_schema": transactionbuilder_add_json_metadatum_with_schema, 
  "transactionbuilder_set_mint": transactionbuilder_set_mint, 
  "transactionbuilder_get_mint": transactionbuilder_get_mint, 
  "transactionbuilder_get_mint_scripts": transactionbuilder_get_mint_scripts, 
  "transactionbuilder_set_mint_asset": transactionbuilder_set_mint_asset, 
  "transactionbuilder_add_mint_asset": transactionbuilder_add_mint_asset, 
  "transactionbuilder_add_mint_asset_and_output": transactionbuilder_add_mint_asset_and_output, 
  "transactionbuilder_add_mint_asset_and_output_min_required_coin": transactionbuilder_add_mint_asset_and_output_min_required_coin, 
  "transactionbuilder_new": transactionbuilder_new, 
  "transactionbuilder_get_explicit_input": transactionbuilder_get_explicit_input, 
  "transactionbuilder_get_implicit_input": transactionbuilder_get_implicit_input, 
  "transactionbuilder_get_total_input": transactionbuilder_get_total_input, 
  "transactionbuilder_get_total_output": transactionbuilder_get_total_output, 
  "transactionbuilder_get_explicit_output": transactionbuilder_get_explicit_output, 
  "transactionbuilder_get_deposit": transactionbuilder_get_deposit, 
  "transactionbuilder_get_fee_if_set": transactionbuilder_get_fee_if_set, 
  "transactionbuilder_add_change_if_needed": transactionbuilder_add_change_if_needed, 
  "transactionbuilder_calc_script_data_hash": transactionbuilder_calc_script_data_hash, 
  "transactionbuilder_set_script_data_hash": transactionbuilder_set_script_data_hash, 
  "transactionbuilder_remove_script_data_hash": transactionbuilder_remove_script_data_hash, 
  "transactionbuilder_add_required_signer": transactionbuilder_add_required_signer, 
  "transactionbuilder_full_size": transactionbuilder_full_size, 
  "transactionbuilder_output_sizes": transactionbuilder_output_sizes, 
  "transactionbuilder_build": transactionbuilder_build, 
  "transactionbuilder_build_tx": transactionbuilder_build_tx, 
  "transactionbuilder_build_tx_unsafe": transactionbuilder_build_tx_unsafe, 
  "transactionbuilder_min_fee": transactionbuilder_min_fee, 
  "__wbg_bip32privatekey_free": __wbg_bip32privatekey_free, 
  "bip32privatekey_derive": bip32privatekey_derive, 
  "bip32privatekey_from_128_xprv": bip32privatekey_from_128_xprv, 
  "bip32privatekey_to_128_xprv": bip32privatekey_to_128_xprv, 
  "bip32privatekey_generate_ed25519_bip32": bip32privatekey_generate_ed25519_bip32, 
  "bip32privatekey_to_raw_key": bip32privatekey_to_raw_key, 
  "bip32privatekey_to_public": bip32privatekey_to_public, 
  "bip32privatekey_from_bytes": bip32privatekey_from_bytes, 
  "bip32privatekey_as_bytes": bip32privatekey_as_bytes, 
  "bip32privatekey_from_bech32": bip32privatekey_from_bech32, 
  "bip32privatekey_to_bech32": bip32privatekey_to_bech32, 
  "bip32privatekey_from_bip39_entropy": bip32privatekey_from_bip39_entropy, 
  "bip32privatekey_chaincode": bip32privatekey_chaincode, 
  "__wbg_bip32publickey_free": __wbg_bip32publickey_free, 
  "bip32publickey_derive": bip32publickey_derive, 
  "bip32publickey_to_raw_key": bip32publickey_to_raw_key, 
  "bip32publickey_from_bytes": bip32publickey_from_bytes, 
  "bip32publickey_as_bytes": bip32publickey_as_bytes, 
  "bip32publickey_from_bech32": bip32publickey_from_bech32, 
  "bip32publickey_to_bech32": bip32publickey_to_bech32, 
  "bip32publickey_chaincode": bip32publickey_chaincode, 
  "__wbg_privatekey_free": __wbg_privatekey_free, 
  "privatekey_to_public": privatekey_to_public, 
  "privatekey_generate_ed25519": privatekey_generate_ed25519, 
  "privatekey_generate_ed25519extended": privatekey_generate_ed25519extended, 
  "privatekey_from_bech32": privatekey_from_bech32, 
  "privatekey_to_bech32": privatekey_to_bech32, 
  "privatekey_as_bytes": privatekey_as_bytes, 
  "privatekey_from_extended_bytes": privatekey_from_extended_bytes, 
  "privatekey_from_normal_bytes": privatekey_from_normal_bytes, 
  "privatekey_sign": privatekey_sign, 
  "__wbg_publickey_free": __wbg_publickey_free, 
  "publickey_from_bech32": publickey_from_bech32, 
  "publickey_to_bech32": publickey_to_bech32, 
  "publickey_as_bytes": publickey_as_bytes, 
  "publickey_from_bytes": publickey_from_bytes, 
  "publickey_verify": publickey_verify, 
  "publickey_hash": publickey_hash, 
  "__wbg_vkey_free": __wbg_vkey_free, 
  "vkey_to_bytes": vkey_to_bytes, 
  "vkey_from_bytes": vkey_from_bytes, 
  "vkey_new": vkey_new, 
  "vkey_public_key": vkey_public_key, 
  "__wbg_vkeys_free": __wbg_vkeys_free, 
  "vkeys_new": vkeys_new, 
  "vkeys_len": vkeys_len, 
  "vkeys_get": vkeys_get, 
  "vkeys_add": vkeys_add, 
  "__wbg_vkeywitness_free": __wbg_vkeywitness_free, 
  "vkeywitness_to_bytes": vkeywitness_to_bytes, 
  "vkeywitness_from_bytes": vkeywitness_from_bytes, 
  "vkeywitness_new": vkeywitness_new, 
  "vkeywitness_vkey": vkeywitness_vkey, 
  "vkeywitness_signature": vkeywitness_signature, 
  "__wbg_vkeywitnesses_free": __wbg_vkeywitnesses_free, 
  "vkeywitnesses_new": vkeywitnesses_new, 
  "vkeywitnesses_len": vkeywitnesses_len, 
  "vkeywitnesses_get": vkeywitnesses_get, 
  "vkeywitnesses_add": vkeywitnesses_add, 
  "__wbg_bootstrapwitness_free": __wbg_bootstrapwitness_free, 
  "bootstrapwitness_to_bytes": bootstrapwitness_to_bytes, 
  "bootstrapwitness_from_bytes": bootstrapwitness_from_bytes, 
  "bootstrapwitness_vkey": bootstrapwitness_vkey, 
  "bootstrapwitness_signature": bootstrapwitness_signature, 
  "bootstrapwitness_chain_code": bootstrapwitness_chain_code, 
  "bootstrapwitness_attributes": bootstrapwitness_attributes, 
  "bootstrapwitness_new": bootstrapwitness_new, 
  "__wbg_bootstrapwitnesses_free": __wbg_bootstrapwitnesses_free, 
  "bootstrapwitnesses_new": bootstrapwitnesses_new, 
  "bootstrapwitnesses_len": bootstrapwitnesses_len, 
  "bootstrapwitnesses_get": bootstrapwitnesses_get, 
  "bootstrapwitnesses_add": bootstrapwitnesses_add, 
  "__wbg_publickeys_free": __wbg_publickeys_free, 
  "publickeys_new": publickeys_new, 
  "publickeys_size": publickeys_size, 
  "publickeys_get": publickeys_get, 
  "publickeys_add": publickeys_add, 
  "__wbg_ed25519signature_free": __wbg_ed25519signature_free, 
  "ed25519signature_to_bytes": ed25519signature_to_bytes, 
  "ed25519signature_to_bech32": ed25519signature_to_bech32, 
  "ed25519signature_to_hex": ed25519signature_to_hex, 
  "ed25519signature_from_bech32": ed25519signature_from_bech32, 
  "ed25519signature_from_hex": ed25519signature_from_hex, 
  "ed25519signature_from_bytes": ed25519signature_from_bytes, 
  "__wbg_legacydaedalusprivatekey_free": __wbg_legacydaedalusprivatekey_free, 
  "legacydaedalusprivatekey_from_bytes": legacydaedalusprivatekey_from_bytes, 
  "legacydaedalusprivatekey_as_bytes": legacydaedalusprivatekey_as_bytes, 
  "legacydaedalusprivatekey_chaincode": legacydaedalusprivatekey_chaincode, 
  "__wbg_ed25519keyhash_free": __wbg_ed25519keyhash_free, 
  "ed25519keyhash_to_bytes": ed25519keyhash_to_bytes, 
  "ed25519keyhash_to_bech32": ed25519keyhash_to_bech32, 
  "ed25519keyhash_from_bech32": ed25519keyhash_from_bech32, 
  "ed25519keyhash_from_bytes": ed25519keyhash_from_bytes, 
  "__wbg_scripthash_free": __wbg_scripthash_free, 
  "scripthash_to_bytes": scripthash_to_bytes, 
  "scripthash_to_bech32": scripthash_to_bech32, 
  "scripthash_from_bech32": scripthash_from_bech32, 
  "scripthash_from_bytes": scripthash_from_bytes, 
  "__wbg_transactionhash_free": __wbg_transactionhash_free, 
  "transactionhash_to_bytes": transactionhash_to_bytes, 
  "transactionhash_to_bech32": transactionhash_to_bech32, 
  "transactionhash_from_bech32": transactionhash_from_bech32, 
  "transactionhash_from_bytes": transactionhash_from_bytes, 
  "__wbg_genesisdelegatehash_free": __wbg_genesisdelegatehash_free, 
  "genesisdelegatehash_to_bytes": genesisdelegatehash_to_bytes, 
  "genesisdelegatehash_to_bech32": genesisdelegatehash_to_bech32, 
  "genesisdelegatehash_from_bech32": genesisdelegatehash_from_bech32, 
  "genesisdelegatehash_from_bytes": genesisdelegatehash_from_bytes, 
  "__wbg_genesishash_free": __wbg_genesishash_free, 
  "genesishash_to_bytes": genesishash_to_bytes, 
  "genesishash_to_bech32": genesishash_to_bech32, 
  "genesishash_from_bech32": genesishash_from_bech32, 
  "genesishash_from_bytes": genesishash_from_bytes, 
  "__wbg_auxiliarydatahash_free": __wbg_auxiliarydatahash_free, 
  "auxiliarydatahash_to_bytes": auxiliarydatahash_to_bytes, 
  "auxiliarydatahash_to_bech32": auxiliarydatahash_to_bech32, 
  "auxiliarydatahash_from_bech32": auxiliarydatahash_from_bech32, 
  "auxiliarydatahash_from_bytes": auxiliarydatahash_from_bytes, 
  "__wbg_poolmetadatahash_free": __wbg_poolmetadatahash_free, 
  "poolmetadatahash_to_bytes": poolmetadatahash_to_bytes, 
  "poolmetadatahash_to_bech32": poolmetadatahash_to_bech32, 
  "poolmetadatahash_from_bech32": poolmetadatahash_from_bech32, 
  "poolmetadatahash_from_bytes": poolmetadatahash_from_bytes, 
  "__wbg_vrfkeyhash_free": __wbg_vrfkeyhash_free, 
  "vrfkeyhash_to_bytes": vrfkeyhash_to_bytes, 
  "vrfkeyhash_to_bech32": vrfkeyhash_to_bech32, 
  "vrfkeyhash_from_bech32": vrfkeyhash_from_bech32, 
  "vrfkeyhash_from_bytes": vrfkeyhash_from_bytes, 
  "__wbg_blockhash_free": __wbg_blockhash_free, 
  "blockhash_to_bytes": blockhash_to_bytes, 
  "blockhash_to_bech32": blockhash_to_bech32, 
  "blockhash_from_bech32": blockhash_from_bech32, 
  "blockhash_from_bytes": blockhash_from_bytes, 
  "__wbg_datahash_free": __wbg_datahash_free, 
  "datahash_to_bytes": datahash_to_bytes, 
  "datahash_to_bech32": datahash_to_bech32, 
  "datahash_from_bech32": datahash_from_bech32, 
  "datahash_from_bytes": datahash_from_bytes, 
  "__wbg_scriptdatahash_free": __wbg_scriptdatahash_free, 
  "scriptdatahash_to_bytes": scriptdatahash_to_bytes, 
  "scriptdatahash_to_bech32": scriptdatahash_to_bech32, 
  "scriptdatahash_from_bech32": scriptdatahash_from_bech32, 
  "scriptdatahash_from_bytes": scriptdatahash_from_bytes, 
  "__wbg_vrfvkey_free": __wbg_vrfvkey_free, 
  "vrfvkey_to_bytes": vrfvkey_to_bytes, 
  "vrfvkey_to_bech32": vrfvkey_to_bech32, 
  "vrfvkey_from_bech32": vrfvkey_from_bech32, 
  "vrfvkey_from_bytes": vrfvkey_from_bytes, 
  "__wbg_kesvkey_free": __wbg_kesvkey_free, 
  "kesvkey_to_bytes": kesvkey_to_bytes, 
  "kesvkey_to_bech32": kesvkey_to_bech32, 
  "kesvkey_from_bech32": kesvkey_from_bech32, 
  "kesvkey_from_bytes": kesvkey_from_bytes, 
  "__wbg_kessignature_free": __wbg_kessignature_free, 
  "kessignature_to_bytes": kessignature_to_bytes, 
  "kessignature_from_bytes": kessignature_from_bytes, 
  "__wbg_nonce_free": __wbg_nonce_free, 
  "nonce_to_bytes": nonce_to_bytes, 
  "nonce_from_bytes": nonce_from_bytes, 
  "nonce_new_identity": nonce_new_identity, 
  "nonce_new_from_hash": nonce_new_from_hash, 
  "nonce_get_hash": nonce_get_hash, 
  "__wbg_vrfcert_free": __wbg_vrfcert_free, 
  "vrfcert_to_bytes": vrfcert_to_bytes, 
  "vrfcert_from_bytes": vrfcert_from_bytes, 
  "vrfcert_output": vrfcert_output, 
  "vrfcert_proof": vrfcert_proof, 
  "vrfcert_new": vrfcert_new, 
  "__wbg_plutuswitness_free": __wbg_plutuswitness_free, 
  "plutuswitness_new": plutuswitness_new, 
  "plutuswitness_script": plutuswitness_script, 
  "plutuswitness_datum": plutuswitness_datum, 
  "plutuswitness_redeemer": plutuswitness_redeemer, 
  "__wbg_plutuswitnesses_free": __wbg_plutuswitnesses_free, 
  "plutuswitnesses_new": plutuswitnesses_new, 
  "plutuswitnesses_len": plutuswitnesses_len, 
  "plutuswitnesses_get": plutuswitnesses_get, 
  "plutuswitnesses_add": plutuswitnesses_add, 
  "__wbg_txinputsbuilder_free": __wbg_txinputsbuilder_free, 
  "txinputsbuilder_new": txinputsbuilder_new, 
  "txinputsbuilder_add_key_input": txinputsbuilder_add_key_input, 
  "txinputsbuilder_add_script_input": txinputsbuilder_add_script_input, 
  "txinputsbuilder_add_native_script_input": txinputsbuilder_add_native_script_input, 
  "txinputsbuilder_add_plutus_script_input": txinputsbuilder_add_plutus_script_input, 
  "txinputsbuilder_add_bootstrap_input": txinputsbuilder_add_bootstrap_input, 
  "txinputsbuilder_add_input": txinputsbuilder_add_input, 
  "txinputsbuilder_count_missing_input_scripts": txinputsbuilder_count_missing_input_scripts, 
  "txinputsbuilder_add_required_native_input_scripts": txinputsbuilder_add_required_native_input_scripts, 
  "txinputsbuilder_add_required_plutus_input_scripts": txinputsbuilder_add_required_plutus_input_scripts, 
  "txinputsbuilder_get_native_input_scripts": txinputsbuilder_get_native_input_scripts, 
  "txinputsbuilder_get_plutus_input_scripts": txinputsbuilder_get_plutus_input_scripts, 
  "txinputsbuilder_len": txinputsbuilder_len, 
  "txinputsbuilder_add_required_signer": txinputsbuilder_add_required_signer, 
  "txinputsbuilder_add_required_signers": txinputsbuilder_add_required_signers, 
  "txinputsbuilder_inputs": txinputsbuilder_inputs, 
  "txinputsbuilder_inputs_option": txinputsbuilder_inputs_option, 
  "encrypt_with_password": encrypt_with_password, 
  "decrypt_with_password": decrypt_with_password, 
  "__wbg_networkinfo_free": __wbg_networkinfo_free, 
  "networkinfo_new": networkinfo_new, 
  "networkinfo_network_id": networkinfo_network_id, 
  "networkinfo_protocol_magic": networkinfo_protocol_magic, 
  "networkinfo_testnet": networkinfo_testnet, 
  "networkinfo_mainnet": networkinfo_mainnet, 
  "__wbg_stakecredential_free": __wbg_stakecredential_free, 
  "stakecredential_from_keyhash": stakecredential_from_keyhash, 
  "stakecredential_from_scripthash": stakecredential_from_scripthash, 
  "stakecredential_to_keyhash": stakecredential_to_keyhash, 
  "stakecredential_to_scripthash": stakecredential_to_scripthash, 
  "stakecredential_kind": stakecredential_kind, 
  "stakecredential_to_bytes": stakecredential_to_bytes, 
  "stakecredential_from_bytes": stakecredential_from_bytes, 
  "__wbg_byronaddress_free": __wbg_byronaddress_free, 
  "byronaddress_to_base58": byronaddress_to_base58, 
  "byronaddress_to_bytes": byronaddress_to_bytes, 
  "byronaddress_from_bytes": byronaddress_from_bytes, 
  "byronaddress_byron_protocol_magic": byronaddress_byron_protocol_magic, 
  "byronaddress_attributes": byronaddress_attributes, 
  "byronaddress_network_id": byronaddress_network_id, 
  "byronaddress_from_base58": byronaddress_from_base58, 
  "byronaddress_icarus_from_key": byronaddress_icarus_from_key, 
  "byronaddress_is_valid": byronaddress_is_valid, 
  "byronaddress_to_address": byronaddress_to_address, 
  "byronaddress_from_address": byronaddress_from_address, 
  "__wbg_address_free": __wbg_address_free, 
  "address_from_bytes": address_from_bytes, 
  "address_to_bytes": address_to_bytes, 
  "address_to_bech32": address_to_bech32, 
  "address_from_bech32": address_from_bech32, 
  "address_network_id": address_network_id, 
  "__wbg_baseaddress_free": __wbg_baseaddress_free, 
  "baseaddress_new": baseaddress_new, 
  "baseaddress_payment_cred": baseaddress_payment_cred, 
  "baseaddress_stake_cred": baseaddress_stake_cred, 
  "baseaddress_to_address": baseaddress_to_address, 
  "baseaddress_from_address": baseaddress_from_address, 
  "__wbg_enterpriseaddress_free": __wbg_enterpriseaddress_free, 
  "enterpriseaddress_new": enterpriseaddress_new, 
  "enterpriseaddress_payment_cred": enterpriseaddress_payment_cred, 
  "enterpriseaddress_to_address": enterpriseaddress_to_address, 
  "enterpriseaddress_from_address": enterpriseaddress_from_address, 
  "__wbg_rewardaddress_free": __wbg_rewardaddress_free, 
  "rewardaddress_new": rewardaddress_new, 
  "rewardaddress_payment_cred": rewardaddress_payment_cred, 
  "rewardaddress_to_address": rewardaddress_to_address, 
  "rewardaddress_from_address": rewardaddress_from_address, 
  "__wbg_pointer_free": __wbg_pointer_free, 
  "pointer_new": pointer_new, 
  "pointer_new_pointer": pointer_new_pointer, 
  "pointer_slot": pointer_slot, 
  "pointer_tx_index": pointer_tx_index, 
  "pointer_cert_index": pointer_cert_index, 
  "pointer_slot_bignum": pointer_slot_bignum, 
  "pointer_tx_index_bignum": pointer_tx_index_bignum, 
  "pointer_cert_index_bignum": pointer_cert_index_bignum, 
  "__wbg_pointeraddress_free": __wbg_pointeraddress_free, 
  "pointeraddress_new": pointeraddress_new, 
  "pointeraddress_payment_cred": pointeraddress_payment_cred, 
  "pointeraddress_stake_pointer": pointeraddress_stake_pointer, 
  "pointeraddress_to_address": pointeraddress_to_address, 
  "pointeraddress_from_address": pointeraddress_from_address, 
  "__wbg_plutusscript_free": __wbg_plutusscript_free, 
  "plutusscript_to_bytes": plutusscript_to_bytes, 
  "plutusscript_from_bytes": plutusscript_from_bytes, 
  "plutusscript_new": plutusscript_new, 
  "plutusscript_bytes": plutusscript_bytes, 
  "plutusscript_hash": plutusscript_hash, 
  "__wbg_plutusscripts_free": __wbg_plutusscripts_free, 
  "plutusscripts_to_bytes": plutusscripts_to_bytes, 
  "plutusscripts_from_bytes": plutusscripts_from_bytes, 
  "plutusscripts_new": plutusscripts_new, 
  "plutusscripts_len": plutusscripts_len, 
  "plutusscripts_get": plutusscripts_get, 
  "plutusscripts_add": plutusscripts_add, 
  "__wbg_constrplutusdata_free": __wbg_constrplutusdata_free, 
  "constrplutusdata_to_bytes": constrplutusdata_to_bytes, 
  "constrplutusdata_from_bytes": constrplutusdata_from_bytes, 
  "constrplutusdata_alternative": constrplutusdata_alternative, 
  "constrplutusdata_data": constrplutusdata_data, 
  "constrplutusdata_new": constrplutusdata_new, 
  "__wbg_costmodel_free": __wbg_costmodel_free, 
  "costmodel_to_bytes": costmodel_to_bytes, 
  "costmodel_from_bytes": costmodel_from_bytes, 
  "costmodel_new": costmodel_new, 
  "costmodel_set": costmodel_set, 
  "costmodel_get": costmodel_get, 
  "__wbg_costmdls_free": __wbg_costmdls_free, 
  "costmdls_to_bytes": costmdls_to_bytes, 
  "costmdls_from_bytes": costmdls_from_bytes, 
  "costmdls_new": costmdls_new, 
  "costmdls_len": costmdls_len, 
  "costmdls_insert": costmdls_insert, 
  "costmdls_get": costmdls_get, 
  "costmdls_keys": costmdls_keys, 
  "__wbg_exunitprices_free": __wbg_exunitprices_free, 
  "exunitprices_to_bytes": exunitprices_to_bytes, 
  "exunitprices_from_bytes": exunitprices_from_bytes, 
  "exunitprices_mem_price": exunitprices_mem_price, 
  "exunitprices_step_price": exunitprices_step_price, 
  "exunitprices_new": exunitprices_new, 
  "__wbg_exunits_free": __wbg_exunits_free, 
  "exunits_to_bytes": exunits_to_bytes, 
  "exunits_from_bytes": exunits_from_bytes, 
  "exunits_mem": exunits_mem, 
  "exunits_steps": exunits_steps, 
  "exunits_new": exunits_new, 
  "__wbg_language_free": __wbg_language_free, 
  "language_to_bytes": language_to_bytes, 
  "language_from_bytes": language_from_bytes, 
  "language_new_plutus_v1": language_new_plutus_v1, 
  "language_kind": language_kind, 
  "__wbg_languages_free": __wbg_languages_free, 
  "languages_new": languages_new, 
  "languages_len": languages_len, 
  "languages_get": languages_get, 
  "languages_add": languages_add, 
  "__wbg_plutusmap_free": __wbg_plutusmap_free, 
  "plutusmap_to_bytes": plutusmap_to_bytes, 
  "plutusmap_from_bytes": plutusmap_from_bytes, 
  "plutusmap_new": plutusmap_new, 
  "plutusmap_len": plutusmap_len, 
  "plutusmap_insert": plutusmap_insert, 
  "plutusmap_get": plutusmap_get, 
  "plutusmap_keys": plutusmap_keys, 
  "__wbg_plutusdata_free": __wbg_plutusdata_free, 
  "plutusdata_to_bytes": plutusdata_to_bytes, 
  "plutusdata_from_bytes": plutusdata_from_bytes, 
  "plutusdata_new_constr_plutus_data": plutusdata_new_constr_plutus_data, 
  "plutusdata_new_empty_constr_plutus_data": plutusdata_new_empty_constr_plutus_data, 
  "plutusdata_new_map": plutusdata_new_map, 
  "plutusdata_new_list": plutusdata_new_list, 
  "plutusdata_new_integer": plutusdata_new_integer, 
  "plutusdata_new_bytes": plutusdata_new_bytes, 
  "plutusdata_kind": plutusdata_kind, 
  "plutusdata_as_constr_plutus_data": plutusdata_as_constr_plutus_data, 
  "plutusdata_as_map": plutusdata_as_map, 
  "plutusdata_as_list": plutusdata_as_list, 
  "plutusdata_as_integer": plutusdata_as_integer, 
  "plutusdata_as_bytes": plutusdata_as_bytes, 
  "__wbg_plutuslist_free": __wbg_plutuslist_free, 
  "plutuslist_to_bytes": plutuslist_to_bytes, 
  "plutuslist_from_bytes": plutuslist_from_bytes, 
  "plutuslist_new": plutuslist_new, 
  "plutuslist_len": plutuslist_len, 
  "plutuslist_get": plutuslist_get, 
  "plutuslist_add": plutuslist_add, 
  "__wbg_redeemer_free": __wbg_redeemer_free, 
  "redeemer_to_bytes": redeemer_to_bytes, 
  "redeemer_from_bytes": redeemer_from_bytes, 
  "redeemer_tag": redeemer_tag, 
  "redeemer_index": redeemer_index, 
  "redeemer_data": redeemer_data, 
  "redeemer_ex_units": redeemer_ex_units, 
  "redeemer_new": redeemer_new, 
  "__wbg_redeemertag_free": __wbg_redeemertag_free, 
  "redeemertag_to_bytes": redeemertag_to_bytes, 
  "redeemertag_from_bytes": redeemertag_from_bytes, 
  "redeemertag_new_spend": redeemertag_new_spend, 
  "redeemertag_new_mint": redeemertag_new_mint, 
  "redeemertag_new_cert": redeemertag_new_cert, 
  "redeemertag_new_reward": redeemertag_new_reward, 
  "redeemertag_kind": redeemertag_kind, 
  "__wbg_redeemers_free": __wbg_redeemers_free, 
  "redeemers_to_bytes": redeemers_to_bytes, 
  "redeemers_from_bytes": redeemers_from_bytes, 
  "redeemers_new": redeemers_new, 
  "redeemers_len": redeemers_len, 
  "redeemers_get": redeemers_get, 
  "redeemers_add": redeemers_add, 
  "redeemers_total_ex_units": redeemers_total_ex_units, 
  "__wbg_strings_free": __wbg_strings_free, 
  "strings_new": strings_new, 
  "strings_len": strings_len, 
  "strings_get": strings_get, 
  "strings_add": strings_add, 
  "__wbg_txbuilderconstants_free": __wbg_txbuilderconstants_free, 
  "txbuilderconstants_plutus_default_cost_models": txbuilderconstants_plutus_default_cost_models, 
  "__wbindgen_malloc": __wbindgen_malloc, 
  "__wbindgen_realloc": __wbindgen_realloc, 
  "__wbindgen_add_to_stack_pointer": __wbindgen_add_to_stack_pointer, 
  "__wbindgen_free": __wbindgen_free, 
  "__wbindgen_exn_store": __wbindgen_exn_store
 };
}

var memasmFunc = new ArrayBuffer(1179648);
var bufferView = new Uint8Array(memasmFunc);
for (var base64ReverseLookup = new Uint8Array(123/*'z'+1*/), i = 25; i >= 0; --i) {
    base64ReverseLookup[48+i] = 52+i; // '0-9'
    base64ReverseLookup[65+i] = i; // 'A-Z'
    base64ReverseLookup[97+i] = 26+i; // 'a-z'
  }
  base64ReverseLookup[43] = 62; // '+'
  base64ReverseLookup[47] = 63; // '/'
  /** @noinline Inlining this function would mean expanding the base64 string 4x times in the source code, which Closure seems to be happy to do. */
  function base64DecodeToExistingUint8Array(uint8Array, offset, b64) {
    var b1, b2, i = 0, j = offset, bLength = b64.length, end = offset + (bLength*3>>2) - (b64[bLength-2] == '=') - (b64[bLength-1] == '=');
    for (; i < bLength; i += 4) {
      b1 = base64ReverseLookup[b64.charCodeAt(i+1)];
      b2 = base64ReverseLookup[b64.charCodeAt(i+2)];
      uint8Array[j++] = base64ReverseLookup[b64.charCodeAt(i)] << 2 | b1 >> 4;
      if (j < end) uint8Array[j++] = b1 << 4 | b2 >> 2;
      if (j < end) uint8Array[j++] = b2 << 6 | base64ReverseLookup[b64.charCodeAt(i+3)];
    } 
  }
  base64DecodeToExistingUint8Array(bufferView, 1048576, "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");
base64DecodeToExistingUint8Array(bufferView, 1177728, "AgAAAAAAAAAAAAAAAAAAAAEAAAAAAAAA");
var retasmFunc = asmFunc({Math,Int8Array,Uint8Array,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array,NaN,Infinity}, {abort:function() { throw new Error('abort'); },__wbindgen_object_drop_ref,__wbindgen_string_new,__wbindgen_string_get,__wbg_getRandomValues_98117e9a7e993920,__wbg_randomFillSync_64cc7d048f228ca8,__wbg_process_2f24d6544ea7b200,__wbindgen_is_object,__wbg_versions_6164651e75405d4a,__wbg_node_4b517d861cbcb3bc,__wbindgen_is_string,__wbg_crypto_98fc271021c7d2ad,__wbg_msCrypto_a2cdb043d2bfe57f,__wbg_modulerequire_3440a4bcf44437db,__wbg_newnoargs_9fdd8f3961dd1bee,__wbg_call_ba36642bd901572b,__wbg_self_bb69a836a72ec6e9,__wbg_window_3304fc4b414c9693,__wbg_globalThis_e0d21cabc6630763,__wbg_global_8463719227271676,__wbindgen_is_undefined,__wbg_buffer_9e184d6f785de5ed,__wbg_new_e8101319e4cf95fc,__wbg_set_e8ae7b27314e8b98,__wbg_length_2d56cb37075fcfb1,__wbg_newwithlength_a8d1dbcbe703a5c6,__wbg_subarray_901ede8318da52a6,__wbindgen_object_clone_ref,__wbg_new_3a746f2619705add,__wbg_call_f54d3a6dadb199ca,__wbindgen_jsval_eq,__wbg_self_ac379e780a0d8b94,__wbg_crypto_1e4302b85d4f64a2,__wbg_getRandomValues_1b4ba144162a5c9e,__wbg_require_6461b1e9a0d7c34a,__wbg_randomFillSync_1b52c8482374c55b,__wbg_getRandomValues_1ef11e888e5228e9,__wbindgen_debug_string,__wbindgen_throw,__wbindgen_rethrow,__wbindgen_memory},memasmFunc);
export var memory = retasmFunc.memory;
export var __wbg_unitinterval_free = retasmFunc.__wbg_unitinterval_free;
export var unitinterval_to_bytes = retasmFunc.unitinterval_to_bytes;
export var unitinterval_from_bytes = retasmFunc.unitinterval_from_bytes;
export var unitinterval_numerator = retasmFunc.unitinterval_numerator;
export var unitinterval_denominator = retasmFunc.unitinterval_denominator;
export var unitinterval_new = retasmFunc.unitinterval_new;
export var __wbg_transaction_free = retasmFunc.__wbg_transaction_free;
export var transaction_to_bytes = retasmFunc.transaction_to_bytes;
export var transaction_from_bytes = retasmFunc.transaction_from_bytes;
export var transaction_body = retasmFunc.transaction_body;
export var transaction_witness_set = retasmFunc.transaction_witness_set;
export var transaction_is_valid = retasmFunc.transaction_is_valid;
export var transaction_auxiliary_data = retasmFunc.transaction_auxiliary_data;
export var transaction_set_is_valid = retasmFunc.transaction_set_is_valid;
export var transaction_new = retasmFunc.transaction_new;
export var __wbg_transactioninputs_free = retasmFunc.__wbg_transactioninputs_free;
export var transactioninputs_to_bytes = retasmFunc.transactioninputs_to_bytes;
export var transactioninputs_from_bytes = retasmFunc.transactioninputs_from_bytes;
export var transactioninputs_new = retasmFunc.transactioninputs_new;
export var transactioninputs_len = retasmFunc.transactioninputs_len;
export var transactioninputs_get = retasmFunc.transactioninputs_get;
export var transactioninputs_add = retasmFunc.transactioninputs_add;
export var __wbg_transactionoutputs_free = retasmFunc.__wbg_transactionoutputs_free;
export var transactionoutputs_to_bytes = retasmFunc.transactionoutputs_to_bytes;
export var transactionoutputs_from_bytes = retasmFunc.transactionoutputs_from_bytes;
export var transactionoutputs_new = retasmFunc.transactionoutputs_new;
export var transactionoutputs_len = retasmFunc.transactionoutputs_len;
export var transactionoutputs_get = retasmFunc.transactionoutputs_get;
export var transactionoutputs_add = retasmFunc.transactionoutputs_add;
export var __wbg_certificates_free = retasmFunc.__wbg_certificates_free;
export var certificates_to_bytes = retasmFunc.certificates_to_bytes;
export var certificates_from_bytes = retasmFunc.certificates_from_bytes;
export var certificates_new = retasmFunc.certificates_new;
export var certificates_len = retasmFunc.certificates_len;
export var certificates_get = retasmFunc.certificates_get;
export var certificates_add = retasmFunc.certificates_add;
export var __wbg_transactionbody_free = retasmFunc.__wbg_transactionbody_free;
export var transactionbody_to_bytes = retasmFunc.transactionbody_to_bytes;
export var transactionbody_from_bytes = retasmFunc.transactionbody_from_bytes;
export var transactionbody_inputs = retasmFunc.transactionbody_inputs;
export var transactionbody_outputs = retasmFunc.transactionbody_outputs;
export var transactionbody_fee = retasmFunc.transactionbody_fee;
export var transactionbody_ttl = retasmFunc.transactionbody_ttl;
export var transactionbody_ttl_bignum = retasmFunc.transactionbody_ttl_bignum;
export var transactionbody_set_ttl = retasmFunc.transactionbody_set_ttl;
export var transactionbody_remove_ttl = retasmFunc.transactionbody_remove_ttl;
export var transactionbody_set_certs = retasmFunc.transactionbody_set_certs;
export var transactionbody_certs = retasmFunc.transactionbody_certs;
export var transactionbody_set_withdrawals = retasmFunc.transactionbody_set_withdrawals;
export var transactionbody_withdrawals = retasmFunc.transactionbody_withdrawals;
export var transactionbody_set_update = retasmFunc.transactionbody_set_update;
export var transactionbody_update = retasmFunc.transactionbody_update;
export var transactionbody_set_auxiliary_data_hash = retasmFunc.transactionbody_set_auxiliary_data_hash;
export var transactionbody_auxiliary_data_hash = retasmFunc.transactionbody_auxiliary_data_hash;
export var transactionbody_set_validity_start_interval = retasmFunc.transactionbody_set_validity_start_interval;
export var transactionbody_set_validity_start_interval_bignum = retasmFunc.transactionbody_set_validity_start_interval_bignum;
export var transactionbody_validity_start_interval_bignum = retasmFunc.transactionbody_validity_start_interval_bignum;
export var transactionbody_validity_start_interval = retasmFunc.transactionbody_validity_start_interval;
export var transactionbody_set_mint = retasmFunc.transactionbody_set_mint;
export var transactionbody_mint = retasmFunc.transactionbody_mint;
export var transactionbody_multiassets = retasmFunc.transactionbody_multiassets;
export var transactionbody_set_script_data_hash = retasmFunc.transactionbody_set_script_data_hash;
export var transactionbody_script_data_hash = retasmFunc.transactionbody_script_data_hash;
export var transactionbody_set_collateral = retasmFunc.transactionbody_set_collateral;
export var transactionbody_collateral = retasmFunc.transactionbody_collateral;
export var transactionbody_set_required_signers = retasmFunc.transactionbody_set_required_signers;
export var transactionbody_required_signers = retasmFunc.transactionbody_required_signers;
export var transactionbody_set_network_id = retasmFunc.transactionbody_set_network_id;
export var transactionbody_network_id = retasmFunc.transactionbody_network_id;
export var transactionbody_new = retasmFunc.transactionbody_new;
export var transactionbody_new_tx_body = retasmFunc.transactionbody_new_tx_body;
export var __wbg_transactioninput_free = retasmFunc.__wbg_transactioninput_free;
export var transactioninput_to_bytes = retasmFunc.transactioninput_to_bytes;
export var transactioninput_from_bytes = retasmFunc.transactioninput_from_bytes;
export var transactioninput_transaction_id = retasmFunc.transactioninput_transaction_id;
export var transactioninput_index = retasmFunc.transactioninput_index;
export var transactioninput_new = retasmFunc.transactioninput_new;
export var __wbg_transactionoutput_free = retasmFunc.__wbg_transactionoutput_free;
export var transactionoutput_to_bytes = retasmFunc.transactionoutput_to_bytes;
export var transactionoutput_from_bytes = retasmFunc.transactionoutput_from_bytes;
export var transactionoutput_address = retasmFunc.transactionoutput_address;
export var transactionoutput_amount = retasmFunc.transactionoutput_amount;
export var transactionoutput_data_hash = retasmFunc.transactionoutput_data_hash;
export var transactionoutput_set_data_hash = retasmFunc.transactionoutput_set_data_hash;
export var transactionoutput_new = retasmFunc.transactionoutput_new;
export var __wbg_stakeregistration_free = retasmFunc.__wbg_stakeregistration_free;
export var stakeregistration_to_bytes = retasmFunc.stakeregistration_to_bytes;
export var stakeregistration_from_bytes = retasmFunc.stakeregistration_from_bytes;
export var stakeregistration_stake_credential = retasmFunc.stakeregistration_stake_credential;
export var stakeregistration_new = retasmFunc.stakeregistration_new;
export var __wbg_stakederegistration_free = retasmFunc.__wbg_stakederegistration_free;
export var stakederegistration_to_bytes = retasmFunc.stakederegistration_to_bytes;
export var stakederegistration_from_bytes = retasmFunc.stakederegistration_from_bytes;
export var stakederegistration_stake_credential = retasmFunc.stakederegistration_stake_credential;
export var stakederegistration_new = retasmFunc.stakederegistration_new;
export var __wbg_stakedelegation_free = retasmFunc.__wbg_stakedelegation_free;
export var stakedelegation_to_bytes = retasmFunc.stakedelegation_to_bytes;
export var stakedelegation_from_bytes = retasmFunc.stakedelegation_from_bytes;
export var stakedelegation_stake_credential = retasmFunc.stakedelegation_stake_credential;
export var stakedelegation_pool_keyhash = retasmFunc.stakedelegation_pool_keyhash;
export var stakedelegation_new = retasmFunc.stakedelegation_new;
export var __wbg_ed25519keyhashes_free = retasmFunc.__wbg_ed25519keyhashes_free;
export var ed25519keyhashes_to_bytes = retasmFunc.ed25519keyhashes_to_bytes;
export var ed25519keyhashes_from_bytes = retasmFunc.ed25519keyhashes_from_bytes;
export var ed25519keyhashes_new = retasmFunc.ed25519keyhashes_new;
export var ed25519keyhashes_len = retasmFunc.ed25519keyhashes_len;
export var ed25519keyhashes_get = retasmFunc.ed25519keyhashes_get;
export var ed25519keyhashes_add = retasmFunc.ed25519keyhashes_add;
export var ed25519keyhashes_to_option = retasmFunc.ed25519keyhashes_to_option;
export var __wbg_relays_free = retasmFunc.__wbg_relays_free;
export var relays_to_bytes = retasmFunc.relays_to_bytes;
export var relays_from_bytes = retasmFunc.relays_from_bytes;
export var relays_new = retasmFunc.relays_new;
export var relays_len = retasmFunc.relays_len;
export var relays_get = retasmFunc.relays_get;
export var relays_add = retasmFunc.relays_add;
export var __wbg_poolparams_free = retasmFunc.__wbg_poolparams_free;
export var poolparams_to_bytes = retasmFunc.poolparams_to_bytes;
export var poolparams_from_bytes = retasmFunc.poolparams_from_bytes;
export var poolparams_operator = retasmFunc.poolparams_operator;
export var poolparams_vrf_keyhash = retasmFunc.poolparams_vrf_keyhash;
export var poolparams_pledge = retasmFunc.poolparams_pledge;
export var poolparams_cost = retasmFunc.poolparams_cost;
export var poolparams_margin = retasmFunc.poolparams_margin;
export var poolparams_reward_account = retasmFunc.poolparams_reward_account;
export var poolparams_pool_owners = retasmFunc.poolparams_pool_owners;
export var poolparams_relays = retasmFunc.poolparams_relays;
export var poolparams_pool_metadata = retasmFunc.poolparams_pool_metadata;
export var poolparams_new = retasmFunc.poolparams_new;
export var __wbg_poolregistration_free = retasmFunc.__wbg_poolregistration_free;
export var poolregistration_to_bytes = retasmFunc.poolregistration_to_bytes;
export var poolregistration_from_bytes = retasmFunc.poolregistration_from_bytes;
export var poolregistration_pool_params = retasmFunc.poolregistration_pool_params;
export var poolregistration_new = retasmFunc.poolregistration_new;
export var __wbg_poolretirement_free = retasmFunc.__wbg_poolretirement_free;
export var poolretirement_to_bytes = retasmFunc.poolretirement_to_bytes;
export var poolretirement_from_bytes = retasmFunc.poolretirement_from_bytes;
export var poolretirement_pool_keyhash = retasmFunc.poolretirement_pool_keyhash;
export var poolretirement_epoch = retasmFunc.poolretirement_epoch;
export var poolretirement_new = retasmFunc.poolretirement_new;
export var __wbg_genesiskeydelegation_free = retasmFunc.__wbg_genesiskeydelegation_free;
export var genesiskeydelegation_to_bytes = retasmFunc.genesiskeydelegation_to_bytes;
export var genesiskeydelegation_from_bytes = retasmFunc.genesiskeydelegation_from_bytes;
export var genesiskeydelegation_genesishash = retasmFunc.genesiskeydelegation_genesishash;
export var genesiskeydelegation_genesis_delegate_hash = retasmFunc.genesiskeydelegation_genesis_delegate_hash;
export var genesiskeydelegation_vrf_keyhash = retasmFunc.genesiskeydelegation_vrf_keyhash;
export var genesiskeydelegation_new = retasmFunc.genesiskeydelegation_new;
export var __wbg_moveinstantaneousrewardscert_free = retasmFunc.__wbg_moveinstantaneousrewardscert_free;
export var moveinstantaneousrewardscert_to_bytes = retasmFunc.moveinstantaneousrewardscert_to_bytes;
export var moveinstantaneousrewardscert_from_bytes = retasmFunc.moveinstantaneousrewardscert_from_bytes;
export var moveinstantaneousrewardscert_move_instantaneous_reward = retasmFunc.moveinstantaneousrewardscert_move_instantaneous_reward;
export var moveinstantaneousrewardscert_new = retasmFunc.moveinstantaneousrewardscert_new;
export var __wbg_certificate_free = retasmFunc.__wbg_certificate_free;
export var certificate_to_bytes = retasmFunc.certificate_to_bytes;
export var certificate_from_bytes = retasmFunc.certificate_from_bytes;
export var certificate_new_stake_registration = retasmFunc.certificate_new_stake_registration;
export var certificate_new_stake_deregistration = retasmFunc.certificate_new_stake_deregistration;
export var certificate_new_stake_delegation = retasmFunc.certificate_new_stake_delegation;
export var certificate_new_pool_registration = retasmFunc.certificate_new_pool_registration;
export var certificate_new_pool_retirement = retasmFunc.certificate_new_pool_retirement;
export var certificate_new_genesis_key_delegation = retasmFunc.certificate_new_genesis_key_delegation;
export var certificate_new_move_instantaneous_rewards_cert = retasmFunc.certificate_new_move_instantaneous_rewards_cert;
export var certificate_kind = retasmFunc.certificate_kind;
export var certificate_as_stake_registration = retasmFunc.certificate_as_stake_registration;
export var certificate_as_stake_deregistration = retasmFunc.certificate_as_stake_deregistration;
export var certificate_as_stake_delegation = retasmFunc.certificate_as_stake_delegation;
export var certificate_as_pool_registration = retasmFunc.certificate_as_pool_registration;
export var certificate_as_pool_retirement = retasmFunc.certificate_as_pool_retirement;
export var certificate_as_genesis_key_delegation = retasmFunc.certificate_as_genesis_key_delegation;
export var certificate_as_move_instantaneous_rewards_cert = retasmFunc.certificate_as_move_instantaneous_rewards_cert;
export var __wbg_mirtostakecredentials_free = retasmFunc.__wbg_mirtostakecredentials_free;
export var mirtostakecredentials_to_bytes = retasmFunc.mirtostakecredentials_to_bytes;
export var mirtostakecredentials_from_bytes = retasmFunc.mirtostakecredentials_from_bytes;
export var mirtostakecredentials_new = retasmFunc.mirtostakecredentials_new;
export var mirtostakecredentials_len = retasmFunc.mirtostakecredentials_len;
export var mirtostakecredentials_insert = retasmFunc.mirtostakecredentials_insert;
export var mirtostakecredentials_get = retasmFunc.mirtostakecredentials_get;
export var mirtostakecredentials_keys = retasmFunc.mirtostakecredentials_keys;
export var __wbg_moveinstantaneousreward_free = retasmFunc.__wbg_moveinstantaneousreward_free;
export var moveinstantaneousreward_to_bytes = retasmFunc.moveinstantaneousreward_to_bytes;
export var moveinstantaneousreward_from_bytes = retasmFunc.moveinstantaneousreward_from_bytes;
export var moveinstantaneousreward_new_to_other_pot = retasmFunc.moveinstantaneousreward_new_to_other_pot;
export var moveinstantaneousreward_new_to_stake_creds = retasmFunc.moveinstantaneousreward_new_to_stake_creds;
export var moveinstantaneousreward_pot = retasmFunc.moveinstantaneousreward_pot;
export var moveinstantaneousreward_kind = retasmFunc.moveinstantaneousreward_kind;
export var moveinstantaneousreward_as_to_other_pot = retasmFunc.moveinstantaneousreward_as_to_other_pot;
export var moveinstantaneousreward_as_to_stake_creds = retasmFunc.moveinstantaneousreward_as_to_stake_creds;
export var __wbg_ipv4_free = retasmFunc.__wbg_ipv4_free;
export var ipv4_to_bytes = retasmFunc.ipv4_to_bytes;
export var ipv4_from_bytes = retasmFunc.ipv4_from_bytes;
export var ipv4_new = retasmFunc.ipv4_new;
export var ipv4_ip = retasmFunc.ipv4_ip;
export var __wbg_ipv6_free = retasmFunc.__wbg_ipv6_free;
export var ipv6_to_bytes = retasmFunc.ipv6_to_bytes;
export var ipv6_from_bytes = retasmFunc.ipv6_from_bytes;
export var ipv6_new = retasmFunc.ipv6_new;
export var ipv6_ip = retasmFunc.ipv6_ip;
export var __wbg_url_free = retasmFunc.__wbg_url_free;
export var url_to_bytes = retasmFunc.url_to_bytes;
export var url_from_bytes = retasmFunc.url_from_bytes;
export var url_new = retasmFunc.url_new;
export var url_url = retasmFunc.url_url;
export var __wbg_dnsrecordaoraaaa_free = retasmFunc.__wbg_dnsrecordaoraaaa_free;
export var dnsrecordaoraaaa_to_bytes = retasmFunc.dnsrecordaoraaaa_to_bytes;
export var dnsrecordaoraaaa_from_bytes = retasmFunc.dnsrecordaoraaaa_from_bytes;
export var dnsrecordaoraaaa_new = retasmFunc.dnsrecordaoraaaa_new;
export var dnsrecordaoraaaa_record = retasmFunc.dnsrecordaoraaaa_record;
export var __wbg_dnsrecordsrv_free = retasmFunc.__wbg_dnsrecordsrv_free;
export var dnsrecordsrv_to_bytes = retasmFunc.dnsrecordsrv_to_bytes;
export var dnsrecordsrv_from_bytes = retasmFunc.dnsrecordsrv_from_bytes;
export var dnsrecordsrv_new = retasmFunc.dnsrecordsrv_new;
export var dnsrecordsrv_record = retasmFunc.dnsrecordsrv_record;
export var __wbg_singlehostaddr_free = retasmFunc.__wbg_singlehostaddr_free;
export var singlehostaddr_to_bytes = retasmFunc.singlehostaddr_to_bytes;
export var singlehostaddr_from_bytes = retasmFunc.singlehostaddr_from_bytes;
export var singlehostaddr_port = retasmFunc.singlehostaddr_port;
export var singlehostaddr_ipv4 = retasmFunc.singlehostaddr_ipv4;
export var singlehostaddr_ipv6 = retasmFunc.singlehostaddr_ipv6;
export var singlehostaddr_new = retasmFunc.singlehostaddr_new;
export var __wbg_singlehostname_free = retasmFunc.__wbg_singlehostname_free;
export var singlehostname_to_bytes = retasmFunc.singlehostname_to_bytes;
export var singlehostname_from_bytes = retasmFunc.singlehostname_from_bytes;
export var singlehostname_port = retasmFunc.singlehostname_port;
export var singlehostname_dns_name = retasmFunc.singlehostname_dns_name;
export var singlehostname_new = retasmFunc.singlehostname_new;
export var __wbg_multihostname_free = retasmFunc.__wbg_multihostname_free;
export var multihostname_to_bytes = retasmFunc.multihostname_to_bytes;
export var multihostname_from_bytes = retasmFunc.multihostname_from_bytes;
export var multihostname_dns_name = retasmFunc.multihostname_dns_name;
export var multihostname_new = retasmFunc.multihostname_new;
export var __wbg_relay_free = retasmFunc.__wbg_relay_free;
export var relay_to_bytes = retasmFunc.relay_to_bytes;
export var relay_from_bytes = retasmFunc.relay_from_bytes;
export var relay_new_single_host_addr = retasmFunc.relay_new_single_host_addr;
export var relay_new_single_host_name = retasmFunc.relay_new_single_host_name;
export var relay_new_multi_host_name = retasmFunc.relay_new_multi_host_name;
export var relay_kind = retasmFunc.relay_kind;
export var relay_as_single_host_addr = retasmFunc.relay_as_single_host_addr;
export var relay_as_single_host_name = retasmFunc.relay_as_single_host_name;
export var relay_as_multi_host_name = retasmFunc.relay_as_multi_host_name;
export var __wbg_poolmetadata_free = retasmFunc.__wbg_poolmetadata_free;
export var poolmetadata_to_bytes = retasmFunc.poolmetadata_to_bytes;
export var poolmetadata_from_bytes = retasmFunc.poolmetadata_from_bytes;
export var poolmetadata_url = retasmFunc.poolmetadata_url;
export var poolmetadata_pool_metadata_hash = retasmFunc.poolmetadata_pool_metadata_hash;
export var poolmetadata_new = retasmFunc.poolmetadata_new;
export var __wbg_stakecredentials_free = retasmFunc.__wbg_stakecredentials_free;
export var stakecredentials_to_bytes = retasmFunc.stakecredentials_to_bytes;
export var stakecredentials_from_bytes = retasmFunc.stakecredentials_from_bytes;
export var stakecredentials_new = retasmFunc.stakecredentials_new;
export var stakecredentials_len = retasmFunc.stakecredentials_len;
export var stakecredentials_get = retasmFunc.stakecredentials_get;
export var stakecredentials_add = retasmFunc.stakecredentials_add;
export var __wbg_rewardaddresses_free = retasmFunc.__wbg_rewardaddresses_free;
export var rewardaddresses_to_bytes = retasmFunc.rewardaddresses_to_bytes;
export var rewardaddresses_from_bytes = retasmFunc.rewardaddresses_from_bytes;
export var rewardaddresses_new = retasmFunc.rewardaddresses_new;
export var rewardaddresses_len = retasmFunc.rewardaddresses_len;
export var rewardaddresses_get = retasmFunc.rewardaddresses_get;
export var rewardaddresses_add = retasmFunc.rewardaddresses_add;
export var __wbg_withdrawals_free = retasmFunc.__wbg_withdrawals_free;
export var withdrawals_to_bytes = retasmFunc.withdrawals_to_bytes;
export var withdrawals_from_bytes = retasmFunc.withdrawals_from_bytes;
export var withdrawals_new = retasmFunc.withdrawals_new;
export var withdrawals_len = retasmFunc.withdrawals_len;
export var withdrawals_insert = retasmFunc.withdrawals_insert;
export var withdrawals_get = retasmFunc.withdrawals_get;
export var withdrawals_keys = retasmFunc.withdrawals_keys;
export var __wbg_transactionwitnessset_free = retasmFunc.__wbg_transactionwitnessset_free;
export var transactionwitnessset_to_bytes = retasmFunc.transactionwitnessset_to_bytes;
export var transactionwitnessset_from_bytes = retasmFunc.transactionwitnessset_from_bytes;
export var transactionwitnessset_set_vkeys = retasmFunc.transactionwitnessset_set_vkeys;
export var transactionwitnessset_vkeys = retasmFunc.transactionwitnessset_vkeys;
export var transactionwitnessset_set_native_scripts = retasmFunc.transactionwitnessset_set_native_scripts;
export var transactionwitnessset_native_scripts = retasmFunc.transactionwitnessset_native_scripts;
export var transactionwitnessset_set_bootstraps = retasmFunc.transactionwitnessset_set_bootstraps;
export var transactionwitnessset_bootstraps = retasmFunc.transactionwitnessset_bootstraps;
export var transactionwitnessset_set_plutus_scripts = retasmFunc.transactionwitnessset_set_plutus_scripts;
export var transactionwitnessset_plutus_scripts = retasmFunc.transactionwitnessset_plutus_scripts;
export var transactionwitnessset_set_plutus_data = retasmFunc.transactionwitnessset_set_plutus_data;
export var transactionwitnessset_plutus_data = retasmFunc.transactionwitnessset_plutus_data;
export var transactionwitnessset_set_redeemers = retasmFunc.transactionwitnessset_set_redeemers;
export var transactionwitnessset_redeemers = retasmFunc.transactionwitnessset_redeemers;
export var transactionwitnessset_new = retasmFunc.transactionwitnessset_new;
export var __wbg_scriptpubkey_free = retasmFunc.__wbg_scriptpubkey_free;
export var scriptpubkey_to_bytes = retasmFunc.scriptpubkey_to_bytes;
export var scriptpubkey_from_bytes = retasmFunc.scriptpubkey_from_bytes;
export var scriptpubkey_addr_keyhash = retasmFunc.scriptpubkey_addr_keyhash;
export var scriptpubkey_new = retasmFunc.scriptpubkey_new;
export var __wbg_scriptall_free = retasmFunc.__wbg_scriptall_free;
export var scriptall_to_bytes = retasmFunc.scriptall_to_bytes;
export var scriptall_from_bytes = retasmFunc.scriptall_from_bytes;
export var scriptall_native_scripts = retasmFunc.scriptall_native_scripts;
export var scriptall_new = retasmFunc.scriptall_new;
export var __wbg_scriptany_free = retasmFunc.__wbg_scriptany_free;
export var scriptany_to_bytes = retasmFunc.scriptany_to_bytes;
export var scriptany_from_bytes = retasmFunc.scriptany_from_bytes;
export var scriptany_native_scripts = retasmFunc.scriptany_native_scripts;
export var scriptany_new = retasmFunc.scriptany_new;
export var __wbg_scriptnofk_free = retasmFunc.__wbg_scriptnofk_free;
export var scriptnofk_to_bytes = retasmFunc.scriptnofk_to_bytes;
export var scriptnofk_from_bytes = retasmFunc.scriptnofk_from_bytes;
export var scriptnofk_n = retasmFunc.scriptnofk_n;
export var scriptnofk_native_scripts = retasmFunc.scriptnofk_native_scripts;
export var scriptnofk_new = retasmFunc.scriptnofk_new;
export var __wbg_timelockstart_free = retasmFunc.__wbg_timelockstart_free;
export var timelockstart_to_bytes = retasmFunc.timelockstart_to_bytes;
export var timelockstart_from_bytes = retasmFunc.timelockstart_from_bytes;
export var timelockstart_slot = retasmFunc.timelockstart_slot;
export var timelockstart_slot_bignum = retasmFunc.timelockstart_slot_bignum;
export var timelockstart_new = retasmFunc.timelockstart_new;
export var timelockstart_new_timelockstart = retasmFunc.timelockstart_new_timelockstart;
export var __wbg_timelockexpiry_free = retasmFunc.__wbg_timelockexpiry_free;
export var timelockexpiry_to_bytes = retasmFunc.timelockexpiry_to_bytes;
export var timelockexpiry_from_bytes = retasmFunc.timelockexpiry_from_bytes;
export var timelockexpiry_slot = retasmFunc.timelockexpiry_slot;
export var timelockexpiry_slot_bignum = retasmFunc.timelockexpiry_slot_bignum;
export var timelockexpiry_new = retasmFunc.timelockexpiry_new;
export var timelockexpiry_new_timelockexpiry = retasmFunc.timelockexpiry_new_timelockexpiry;
export var __wbg_nativescript_free = retasmFunc.__wbg_nativescript_free;
export var nativescript_to_bytes = retasmFunc.nativescript_to_bytes;
export var nativescript_from_bytes = retasmFunc.nativescript_from_bytes;
export var nativescript_hash = retasmFunc.nativescript_hash;
export var nativescript_new_script_pubkey = retasmFunc.nativescript_new_script_pubkey;
export var nativescript_new_script_all = retasmFunc.nativescript_new_script_all;
export var nativescript_new_script_any = retasmFunc.nativescript_new_script_any;
export var nativescript_new_script_n_of_k = retasmFunc.nativescript_new_script_n_of_k;
export var nativescript_new_timelock_start = retasmFunc.nativescript_new_timelock_start;
export var nativescript_new_timelock_expiry = retasmFunc.nativescript_new_timelock_expiry;
export var nativescript_kind = retasmFunc.nativescript_kind;
export var nativescript_as_script_pubkey = retasmFunc.nativescript_as_script_pubkey;
export var nativescript_as_script_all = retasmFunc.nativescript_as_script_all;
export var nativescript_as_script_any = retasmFunc.nativescript_as_script_any;
export var nativescript_as_script_n_of_k = retasmFunc.nativescript_as_script_n_of_k;
export var nativescript_as_timelock_start = retasmFunc.nativescript_as_timelock_start;
export var nativescript_as_timelock_expiry = retasmFunc.nativescript_as_timelock_expiry;
export var nativescript_get_required_signers = retasmFunc.nativescript_get_required_signers;
export var __wbg_nativescripts_free = retasmFunc.__wbg_nativescripts_free;
export var nativescripts_new = retasmFunc.nativescripts_new;
export var nativescripts_len = retasmFunc.nativescripts_len;
export var nativescripts_get = retasmFunc.nativescripts_get;
export var nativescripts_add = retasmFunc.nativescripts_add;
export var __wbg_update_free = retasmFunc.__wbg_update_free;
export var update_to_bytes = retasmFunc.update_to_bytes;
export var update_from_bytes = retasmFunc.update_from_bytes;
export var update_proposed_protocol_parameter_updates = retasmFunc.update_proposed_protocol_parameter_updates;
export var update_epoch = retasmFunc.update_epoch;
export var update_new = retasmFunc.update_new;
export var __wbg_genesishashes_free = retasmFunc.__wbg_genesishashes_free;
export var genesishashes_to_bytes = retasmFunc.genesishashes_to_bytes;
export var genesishashes_from_bytes = retasmFunc.genesishashes_from_bytes;
export var genesishashes_new = retasmFunc.genesishashes_new;
export var genesishashes_len = retasmFunc.genesishashes_len;
export var genesishashes_get = retasmFunc.genesishashes_get;
export var genesishashes_add = retasmFunc.genesishashes_add;
export var __wbg_scripthashes_free = retasmFunc.__wbg_scripthashes_free;
export var scripthashes_to_bytes = retasmFunc.scripthashes_to_bytes;
export var scripthashes_from_bytes = retasmFunc.scripthashes_from_bytes;
export var scripthashes_new = retasmFunc.scripthashes_new;
export var scripthashes_len = retasmFunc.scripthashes_len;
export var scripthashes_get = retasmFunc.scripthashes_get;
export var scripthashes_add = retasmFunc.scripthashes_add;
export var __wbg_proposedprotocolparameterupdates_free = retasmFunc.__wbg_proposedprotocolparameterupdates_free;
export var proposedprotocolparameterupdates_to_bytes = retasmFunc.proposedprotocolparameterupdates_to_bytes;
export var proposedprotocolparameterupdates_from_bytes = retasmFunc.proposedprotocolparameterupdates_from_bytes;
export var proposedprotocolparameterupdates_new = retasmFunc.proposedprotocolparameterupdates_new;
export var proposedprotocolparameterupdates_len = retasmFunc.proposedprotocolparameterupdates_len;
export var proposedprotocolparameterupdates_insert = retasmFunc.proposedprotocolparameterupdates_insert;
export var proposedprotocolparameterupdates_get = retasmFunc.proposedprotocolparameterupdates_get;
export var proposedprotocolparameterupdates_keys = retasmFunc.proposedprotocolparameterupdates_keys;
export var __wbg_protocolversion_free = retasmFunc.__wbg_protocolversion_free;
export var protocolversion_to_bytes = retasmFunc.protocolversion_to_bytes;
export var protocolversion_from_bytes = retasmFunc.protocolversion_from_bytes;
export var protocolversion_major = retasmFunc.protocolversion_major;
export var protocolversion_minor = retasmFunc.protocolversion_minor;
export var protocolversion_new = retasmFunc.protocolversion_new;
export var __wbg_protocolversions_free = retasmFunc.__wbg_protocolversions_free;
export var protocolversions_to_bytes = retasmFunc.protocolversions_to_bytes;
export var protocolversions_from_bytes = retasmFunc.protocolversions_from_bytes;
export var protocolversions_new = retasmFunc.protocolversions_new;
export var protocolversions_len = retasmFunc.protocolversions_len;
export var protocolversions_get = retasmFunc.protocolversions_get;
export var protocolversions_add = retasmFunc.protocolversions_add;
export var __wbg_protocolparamupdate_free = retasmFunc.__wbg_protocolparamupdate_free;
export var protocolparamupdate_to_bytes = retasmFunc.protocolparamupdate_to_bytes;
export var protocolparamupdate_from_bytes = retasmFunc.protocolparamupdate_from_bytes;
export var protocolparamupdate_set_minfee_a = retasmFunc.protocolparamupdate_set_minfee_a;
export var protocolparamupdate_minfee_a = retasmFunc.protocolparamupdate_minfee_a;
export var protocolparamupdate_set_minfee_b = retasmFunc.protocolparamupdate_set_minfee_b;
export var protocolparamupdate_minfee_b = retasmFunc.protocolparamupdate_minfee_b;
export var protocolparamupdate_set_max_block_body_size = retasmFunc.protocolparamupdate_set_max_block_body_size;
export var protocolparamupdate_max_block_body_size = retasmFunc.protocolparamupdate_max_block_body_size;
export var protocolparamupdate_set_max_tx_size = retasmFunc.protocolparamupdate_set_max_tx_size;
export var protocolparamupdate_max_tx_size = retasmFunc.protocolparamupdate_max_tx_size;
export var protocolparamupdate_set_max_block_header_size = retasmFunc.protocolparamupdate_set_max_block_header_size;
export var protocolparamupdate_max_block_header_size = retasmFunc.protocolparamupdate_max_block_header_size;
export var protocolparamupdate_set_key_deposit = retasmFunc.protocolparamupdate_set_key_deposit;
export var protocolparamupdate_key_deposit = retasmFunc.protocolparamupdate_key_deposit;
export var protocolparamupdate_set_pool_deposit = retasmFunc.protocolparamupdate_set_pool_deposit;
export var protocolparamupdate_pool_deposit = retasmFunc.protocolparamupdate_pool_deposit;
export var protocolparamupdate_set_max_epoch = retasmFunc.protocolparamupdate_set_max_epoch;
export var protocolparamupdate_max_epoch = retasmFunc.protocolparamupdate_max_epoch;
export var protocolparamupdate_set_n_opt = retasmFunc.protocolparamupdate_set_n_opt;
export var protocolparamupdate_n_opt = retasmFunc.protocolparamupdate_n_opt;
export var protocolparamupdate_set_pool_pledge_influence = retasmFunc.protocolparamupdate_set_pool_pledge_influence;
export var protocolparamupdate_pool_pledge_influence = retasmFunc.protocolparamupdate_pool_pledge_influence;
export var protocolparamupdate_set_expansion_rate = retasmFunc.protocolparamupdate_set_expansion_rate;
export var protocolparamupdate_expansion_rate = retasmFunc.protocolparamupdate_expansion_rate;
export var protocolparamupdate_set_treasury_growth_rate = retasmFunc.protocolparamupdate_set_treasury_growth_rate;
export var protocolparamupdate_treasury_growth_rate = retasmFunc.protocolparamupdate_treasury_growth_rate;
export var protocolparamupdate_set_d = retasmFunc.protocolparamupdate_set_d;
export var protocolparamupdate_d = retasmFunc.protocolparamupdate_d;
export var protocolparamupdate_set_extra_entropy = retasmFunc.protocolparamupdate_set_extra_entropy;
export var protocolparamupdate_extra_entropy = retasmFunc.protocolparamupdate_extra_entropy;
export var protocolparamupdate_set_protocol_version = retasmFunc.protocolparamupdate_set_protocol_version;
export var protocolparamupdate_protocol_version = retasmFunc.protocolparamupdate_protocol_version;
export var protocolparamupdate_set_min_pool_cost = retasmFunc.protocolparamupdate_set_min_pool_cost;
export var protocolparamupdate_min_pool_cost = retasmFunc.protocolparamupdate_min_pool_cost;
export var protocolparamupdate_set_ada_per_utxo_byte = retasmFunc.protocolparamupdate_set_ada_per_utxo_byte;
export var protocolparamupdate_ada_per_utxo_byte = retasmFunc.protocolparamupdate_ada_per_utxo_byte;
export var protocolparamupdate_set_cost_models = retasmFunc.protocolparamupdate_set_cost_models;
export var protocolparamupdate_cost_models = retasmFunc.protocolparamupdate_cost_models;
export var protocolparamupdate_set_execution_costs = retasmFunc.protocolparamupdate_set_execution_costs;
export var protocolparamupdate_execution_costs = retasmFunc.protocolparamupdate_execution_costs;
export var protocolparamupdate_set_max_tx_ex_units = retasmFunc.protocolparamupdate_set_max_tx_ex_units;
export var protocolparamupdate_max_tx_ex_units = retasmFunc.protocolparamupdate_max_tx_ex_units;
export var protocolparamupdate_set_max_block_ex_units = retasmFunc.protocolparamupdate_set_max_block_ex_units;
export var protocolparamupdate_max_block_ex_units = retasmFunc.protocolparamupdate_max_block_ex_units;
export var protocolparamupdate_set_max_value_size = retasmFunc.protocolparamupdate_set_max_value_size;
export var protocolparamupdate_max_value_size = retasmFunc.protocolparamupdate_max_value_size;
export var protocolparamupdate_set_collateral_percentage = retasmFunc.protocolparamupdate_set_collateral_percentage;
export var protocolparamupdate_collateral_percentage = retasmFunc.protocolparamupdate_collateral_percentage;
export var protocolparamupdate_set_max_collateral_inputs = retasmFunc.protocolparamupdate_set_max_collateral_inputs;
export var protocolparamupdate_max_collateral_inputs = retasmFunc.protocolparamupdate_max_collateral_inputs;
export var protocolparamupdate_new = retasmFunc.protocolparamupdate_new;
export var __wbg_transactionbodies_free = retasmFunc.__wbg_transactionbodies_free;
export var transactionbodies_to_bytes = retasmFunc.transactionbodies_to_bytes;
export var transactionbodies_from_bytes = retasmFunc.transactionbodies_from_bytes;
export var transactionbodies_new = retasmFunc.transactionbodies_new;
export var transactionbodies_len = retasmFunc.transactionbodies_len;
export var transactionbodies_get = retasmFunc.transactionbodies_get;
export var transactionbodies_add = retasmFunc.transactionbodies_add;
export var __wbg_transactionwitnesssets_free = retasmFunc.__wbg_transactionwitnesssets_free;
export var transactionwitnesssets_to_bytes = retasmFunc.transactionwitnesssets_to_bytes;
export var transactionwitnesssets_from_bytes = retasmFunc.transactionwitnesssets_from_bytes;
export var transactionwitnesssets_new = retasmFunc.transactionwitnesssets_new;
export var transactionwitnesssets_len = retasmFunc.transactionwitnesssets_len;
export var transactionwitnesssets_get = retasmFunc.transactionwitnesssets_get;
export var transactionwitnesssets_add = retasmFunc.transactionwitnesssets_add;
export var __wbg_auxiliarydataset_free = retasmFunc.__wbg_auxiliarydataset_free;
export var auxiliarydataset_new = retasmFunc.auxiliarydataset_new;
export var auxiliarydataset_len = retasmFunc.auxiliarydataset_len;
export var auxiliarydataset_insert = retasmFunc.auxiliarydataset_insert;
export var auxiliarydataset_get = retasmFunc.auxiliarydataset_get;
export var auxiliarydataset_indices = retasmFunc.auxiliarydataset_indices;
export var __wbg_block_free = retasmFunc.__wbg_block_free;
export var block_to_bytes = retasmFunc.block_to_bytes;
export var block_from_bytes = retasmFunc.block_from_bytes;
export var block_header = retasmFunc.block_header;
export var block_transaction_bodies = retasmFunc.block_transaction_bodies;
export var block_transaction_witness_sets = retasmFunc.block_transaction_witness_sets;
export var block_auxiliary_data_set = retasmFunc.block_auxiliary_data_set;
export var block_invalid_transactions = retasmFunc.block_invalid_transactions;
export var block_new = retasmFunc.block_new;
export var __wbg_header_free = retasmFunc.__wbg_header_free;
export var header_to_bytes = retasmFunc.header_to_bytes;
export var header_from_bytes = retasmFunc.header_from_bytes;
export var header_header_body = retasmFunc.header_header_body;
export var header_body_signature = retasmFunc.header_body_signature;
export var header_new = retasmFunc.header_new;
export var __wbg_operationalcert_free = retasmFunc.__wbg_operationalcert_free;
export var operationalcert_to_bytes = retasmFunc.operationalcert_to_bytes;
export var operationalcert_from_bytes = retasmFunc.operationalcert_from_bytes;
export var operationalcert_hot_vkey = retasmFunc.operationalcert_hot_vkey;
export var operationalcert_sequence_number = retasmFunc.operationalcert_sequence_number;
export var operationalcert_kes_period = retasmFunc.operationalcert_kes_period;
export var operationalcert_sigma = retasmFunc.operationalcert_sigma;
export var operationalcert_new = retasmFunc.operationalcert_new;
export var __wbg_headerbody_free = retasmFunc.__wbg_headerbody_free;
export var headerbody_to_bytes = retasmFunc.headerbody_to_bytes;
export var headerbody_from_bytes = retasmFunc.headerbody_from_bytes;
export var headerbody_block_number = retasmFunc.headerbody_block_number;
export var headerbody_slot = retasmFunc.headerbody_slot;
export var headerbody_slot_bignum = retasmFunc.headerbody_slot_bignum;
export var headerbody_prev_hash = retasmFunc.headerbody_prev_hash;
export var headerbody_issuer_vkey = retasmFunc.headerbody_issuer_vkey;
export var headerbody_vrf_vkey = retasmFunc.headerbody_vrf_vkey;
export var headerbody_nonce_vrf = retasmFunc.headerbody_nonce_vrf;
export var headerbody_leader_vrf = retasmFunc.headerbody_leader_vrf;
export var headerbody_block_body_size = retasmFunc.headerbody_block_body_size;
export var headerbody_block_body_hash = retasmFunc.headerbody_block_body_hash;
export var headerbody_operational_cert = retasmFunc.headerbody_operational_cert;
export var headerbody_protocol_version = retasmFunc.headerbody_protocol_version;
export var headerbody_new = retasmFunc.headerbody_new;
export var headerbody_new_headerbody = retasmFunc.headerbody_new_headerbody;
export var __wbg_assetname_free = retasmFunc.__wbg_assetname_free;
export var assetname_to_bytes = retasmFunc.assetname_to_bytes;
export var assetname_from_bytes = retasmFunc.assetname_from_bytes;
export var assetname_new = retasmFunc.assetname_new;
export var assetname_name = retasmFunc.assetname_name;
export var __wbg_assetnames_free = retasmFunc.__wbg_assetnames_free;
export var assetnames_to_bytes = retasmFunc.assetnames_to_bytes;
export var assetnames_from_bytes = retasmFunc.assetnames_from_bytes;
export var assetnames_new = retasmFunc.assetnames_new;
export var assetnames_len = retasmFunc.assetnames_len;
export var assetnames_get = retasmFunc.assetnames_get;
export var assetnames_add = retasmFunc.assetnames_add;
export var __wbg_assets_free = retasmFunc.__wbg_assets_free;
export var assets_to_bytes = retasmFunc.assets_to_bytes;
export var assets_from_bytes = retasmFunc.assets_from_bytes;
export var assets_new = retasmFunc.assets_new;
export var assets_len = retasmFunc.assets_len;
export var assets_insert = retasmFunc.assets_insert;
export var assets_get = retasmFunc.assets_get;
export var assets_keys = retasmFunc.assets_keys;
export var __wbg_multiasset_free = retasmFunc.__wbg_multiasset_free;
export var multiasset_to_bytes = retasmFunc.multiasset_to_bytes;
export var multiasset_from_bytes = retasmFunc.multiasset_from_bytes;
export var multiasset_new = retasmFunc.multiasset_new;
export var multiasset_len = retasmFunc.multiasset_len;
export var multiasset_insert = retasmFunc.multiasset_insert;
export var multiasset_get = retasmFunc.multiasset_get;
export var multiasset_set_asset = retasmFunc.multiasset_set_asset;
export var multiasset_get_asset = retasmFunc.multiasset_get_asset;
export var multiasset_keys = retasmFunc.multiasset_keys;
export var multiasset_sub = retasmFunc.multiasset_sub;
export var __wbg_mintassets_free = retasmFunc.__wbg_mintassets_free;
export var mintassets_new = retasmFunc.mintassets_new;
export var mintassets_new_from_entry = retasmFunc.mintassets_new_from_entry;
export var mintassets_len = retasmFunc.mintassets_len;
export var mintassets_insert = retasmFunc.mintassets_insert;
export var mintassets_get = retasmFunc.mintassets_get;
export var mintassets_keys = retasmFunc.mintassets_keys;
export var __wbg_mint_free = retasmFunc.__wbg_mint_free;
export var mint_to_bytes = retasmFunc.mint_to_bytes;
export var mint_from_bytes = retasmFunc.mint_from_bytes;
export var mint_new = retasmFunc.mint_new;
export var mint_new_from_entry = retasmFunc.mint_new_from_entry;
export var mint_len = retasmFunc.mint_len;
export var mint_insert = retasmFunc.mint_insert;
export var mint_get = retasmFunc.mint_get;
export var mint_keys = retasmFunc.mint_keys;
export var mint_as_positive_multiasset = retasmFunc.mint_as_positive_multiasset;
export var mint_as_negative_multiasset = retasmFunc.mint_as_negative_multiasset;
export var __wbg_networkid_free = retasmFunc.__wbg_networkid_free;
export var networkid_to_bytes = retasmFunc.networkid_to_bytes;
export var networkid_from_bytes = retasmFunc.networkid_from_bytes;
export var networkid_testnet = retasmFunc.networkid_testnet;
export var networkid_mainnet = retasmFunc.networkid_mainnet;
export var networkid_kind = retasmFunc.networkid_kind;
export var __wbg_transactionoutputbuilder_free = retasmFunc.__wbg_transactionoutputbuilder_free;
export var transactionoutputbuilder_new = retasmFunc.transactionoutputbuilder_new;
export var transactionoutputbuilder_with_address = retasmFunc.transactionoutputbuilder_with_address;
export var transactionoutputbuilder_with_data_hash = retasmFunc.transactionoutputbuilder_with_data_hash;
export var transactionoutputbuilder_next = retasmFunc.transactionoutputbuilder_next;
export var __wbg_transactionoutputamountbuilder_free = retasmFunc.__wbg_transactionoutputamountbuilder_free;
export var transactionoutputamountbuilder_with_value = retasmFunc.transactionoutputamountbuilder_with_value;
export var transactionoutputamountbuilder_with_coin = retasmFunc.transactionoutputamountbuilder_with_coin;
export var transactionoutputamountbuilder_with_coin_and_asset = retasmFunc.transactionoutputamountbuilder_with_coin_and_asset;
export var transactionoutputamountbuilder_with_asset_and_min_required_coin = retasmFunc.transactionoutputamountbuilder_with_asset_and_min_required_coin;
export var transactionoutputamountbuilder_build = retasmFunc.transactionoutputamountbuilder_build;
export var __wbg_transactionunspentoutput_free = retasmFunc.__wbg_transactionunspentoutput_free;
export var transactionunspentoutput_to_bytes = retasmFunc.transactionunspentoutput_to_bytes;
export var transactionunspentoutput_from_bytes = retasmFunc.transactionunspentoutput_from_bytes;
export var transactionunspentoutput_new = retasmFunc.transactionunspentoutput_new;
export var transactionunspentoutput_input = retasmFunc.transactionunspentoutput_input;
export var transactionunspentoutput_output = retasmFunc.transactionunspentoutput_output;
export var __wbg_transactionunspentoutputs_free = retasmFunc.__wbg_transactionunspentoutputs_free;
export var transactionunspentoutputs_new = retasmFunc.transactionunspentoutputs_new;
export var transactionunspentoutputs_len = retasmFunc.transactionunspentoutputs_len;
export var transactionunspentoutputs_get = retasmFunc.transactionunspentoutputs_get;
export var transactionunspentoutputs_add = retasmFunc.transactionunspentoutputs_add;
export var __wbg_bignum_free = retasmFunc.__wbg_bignum_free;
export var bignum_to_bytes = retasmFunc.bignum_to_bytes;
export var bignum_from_bytes = retasmFunc.bignum_from_bytes;
export var bignum_from_str = retasmFunc.bignum_from_str;
export var bignum_to_str = retasmFunc.bignum_to_str;
export var bignum_zero = retasmFunc.bignum_zero;
export var bignum_one = retasmFunc.bignum_one;
export var bignum_is_zero = retasmFunc.bignum_is_zero;
export var bignum_checked_mul = retasmFunc.bignum_checked_mul;
export var bignum_checked_add = retasmFunc.bignum_checked_add;
export var bignum_checked_sub = retasmFunc.bignum_checked_sub;
export var bignum_clamped_sub = retasmFunc.bignum_clamped_sub;
export var bignum_compare = retasmFunc.bignum_compare;
export var __wbg_value_free = retasmFunc.__wbg_value_free;
export var value_to_bytes = retasmFunc.value_to_bytes;
export var value_from_bytes = retasmFunc.value_from_bytes;
export var value_new = retasmFunc.value_new;
export var value_new_from_assets = retasmFunc.value_new_from_assets;
export var value_zero = retasmFunc.value_zero;
export var value_is_zero = retasmFunc.value_is_zero;
export var value_coin = retasmFunc.value_coin;
export var value_set_coin = retasmFunc.value_set_coin;
export var value_multiasset = retasmFunc.value_multiasset;
export var value_set_multiasset = retasmFunc.value_set_multiasset;
export var value_checked_add = retasmFunc.value_checked_add;
export var value_checked_sub = retasmFunc.value_checked_sub;
export var value_clamped_sub = retasmFunc.value_clamped_sub;
export var value_compare = retasmFunc.value_compare;
export var __wbg_int_free = retasmFunc.__wbg_int_free;
export var int_to_bytes = retasmFunc.int_to_bytes;
export var int_from_bytes = retasmFunc.int_from_bytes;
export var int_new = retasmFunc.int_new;
export var int_new_negative = retasmFunc.int_new_negative;
export var int_new_i32 = retasmFunc.int_new_i32;
export var int_is_positive = retasmFunc.int_is_positive;
export var int_as_positive = retasmFunc.int_as_positive;
export var int_as_negative = retasmFunc.int_as_negative;
export var int_as_i32 = retasmFunc.int_as_i32;
export var int_as_i32_or_nothing = retasmFunc.int_as_i32_or_nothing;
export var int_as_i32_or_fail = retasmFunc.int_as_i32_or_fail;
export var int_to_str = retasmFunc.int_to_str;
export var __wbg_bigint_free = retasmFunc.__wbg_bigint_free;
export var bigint_to_bytes = retasmFunc.bigint_to_bytes;
export var bigint_from_bytes = retasmFunc.bigint_from_bytes;
export var bigint_is_zero = retasmFunc.bigint_is_zero;
export var bigint_as_u64 = retasmFunc.bigint_as_u64;
export var bigint_from_str = retasmFunc.bigint_from_str;
export var bigint_to_str = retasmFunc.bigint_to_str;
export var bigint_add = retasmFunc.bigint_add;
export var bigint_mul = retasmFunc.bigint_mul;
export var bigint_one = retasmFunc.bigint_one;
export var bigint_increment = retasmFunc.bigint_increment;
export var bigint_div_ceil = retasmFunc.bigint_div_ceil;
export var make_daedalus_bootstrap_witness = retasmFunc.make_daedalus_bootstrap_witness;
export var make_icarus_bootstrap_witness = retasmFunc.make_icarus_bootstrap_witness;
export var make_vkey_witness = retasmFunc.make_vkey_witness;
export var hash_auxiliary_data = retasmFunc.hash_auxiliary_data;
export var hash_transaction = retasmFunc.hash_transaction;
export var hash_plutus_data = retasmFunc.hash_plutus_data;
export var hash_script_data = retasmFunc.hash_script_data;
export var get_implicit_input = retasmFunc.get_implicit_input;
export var get_deposit = retasmFunc.get_deposit;
export var min_ada_required = retasmFunc.min_ada_required;
export var encode_json_str_to_native_script = retasmFunc.encode_json_str_to_native_script;
export var __wbg_metadatamap_free = retasmFunc.__wbg_metadatamap_free;
export var metadatamap_to_bytes = retasmFunc.metadatamap_to_bytes;
export var metadatamap_from_bytes = retasmFunc.metadatamap_from_bytes;
export var metadatamap_new = retasmFunc.metadatamap_new;
export var metadatamap_len = retasmFunc.metadatamap_len;
export var metadatamap_insert = retasmFunc.metadatamap_insert;
export var metadatamap_insert_str = retasmFunc.metadatamap_insert_str;
export var metadatamap_insert_i32 = retasmFunc.metadatamap_insert_i32;
export var metadatamap_get = retasmFunc.metadatamap_get;
export var metadatamap_get_str = retasmFunc.metadatamap_get_str;
export var metadatamap_get_i32 = retasmFunc.metadatamap_get_i32;
export var metadatamap_has = retasmFunc.metadatamap_has;
export var metadatamap_keys = retasmFunc.metadatamap_keys;
export var __wbg_metadatalist_free = retasmFunc.__wbg_metadatalist_free;
export var metadatalist_to_bytes = retasmFunc.metadatalist_to_bytes;
export var metadatalist_from_bytes = retasmFunc.metadatalist_from_bytes;
export var metadatalist_new = retasmFunc.metadatalist_new;
export var metadatalist_len = retasmFunc.metadatalist_len;
export var metadatalist_get = retasmFunc.metadatalist_get;
export var metadatalist_add = retasmFunc.metadatalist_add;
export var __wbg_transactionmetadatum_free = retasmFunc.__wbg_transactionmetadatum_free;
export var transactionmetadatum_to_bytes = retasmFunc.transactionmetadatum_to_bytes;
export var transactionmetadatum_from_bytes = retasmFunc.transactionmetadatum_from_bytes;
export var transactionmetadatum_new_map = retasmFunc.transactionmetadatum_new_map;
export var transactionmetadatum_new_list = retasmFunc.transactionmetadatum_new_list;
export var transactionmetadatum_new_int = retasmFunc.transactionmetadatum_new_int;
export var transactionmetadatum_new_bytes = retasmFunc.transactionmetadatum_new_bytes;
export var transactionmetadatum_new_text = retasmFunc.transactionmetadatum_new_text;
export var transactionmetadatum_kind = retasmFunc.transactionmetadatum_kind;
export var transactionmetadatum_as_map = retasmFunc.transactionmetadatum_as_map;
export var transactionmetadatum_as_list = retasmFunc.transactionmetadatum_as_list;
export var transactionmetadatum_as_int = retasmFunc.transactionmetadatum_as_int;
export var transactionmetadatum_as_bytes = retasmFunc.transactionmetadatum_as_bytes;
export var transactionmetadatum_as_text = retasmFunc.transactionmetadatum_as_text;
export var __wbg_transactionmetadatumlabels_free = retasmFunc.__wbg_transactionmetadatumlabels_free;
export var transactionmetadatumlabels_to_bytes = retasmFunc.transactionmetadatumlabels_to_bytes;
export var transactionmetadatumlabels_from_bytes = retasmFunc.transactionmetadatumlabels_from_bytes;
export var transactionmetadatumlabels_new = retasmFunc.transactionmetadatumlabels_new;
export var transactionmetadatumlabels_len = retasmFunc.transactionmetadatumlabels_len;
export var transactionmetadatumlabels_get = retasmFunc.transactionmetadatumlabels_get;
export var transactionmetadatumlabels_add = retasmFunc.transactionmetadatumlabels_add;
export var __wbg_generaltransactionmetadata_free = retasmFunc.__wbg_generaltransactionmetadata_free;
export var generaltransactionmetadata_to_bytes = retasmFunc.generaltransactionmetadata_to_bytes;
export var generaltransactionmetadata_from_bytes = retasmFunc.generaltransactionmetadata_from_bytes;
export var generaltransactionmetadata_new = retasmFunc.generaltransactionmetadata_new;
export var generaltransactionmetadata_len = retasmFunc.generaltransactionmetadata_len;
export var generaltransactionmetadata_insert = retasmFunc.generaltransactionmetadata_insert;
export var generaltransactionmetadata_get = retasmFunc.generaltransactionmetadata_get;
export var generaltransactionmetadata_keys = retasmFunc.generaltransactionmetadata_keys;
export var __wbg_auxiliarydata_free = retasmFunc.__wbg_auxiliarydata_free;
export var auxiliarydata_to_bytes = retasmFunc.auxiliarydata_to_bytes;
export var auxiliarydata_from_bytes = retasmFunc.auxiliarydata_from_bytes;
export var auxiliarydata_new = retasmFunc.auxiliarydata_new;
export var auxiliarydata_metadata = retasmFunc.auxiliarydata_metadata;
export var auxiliarydata_set_metadata = retasmFunc.auxiliarydata_set_metadata;
export var auxiliarydata_native_scripts = retasmFunc.auxiliarydata_native_scripts;
export var auxiliarydata_set_native_scripts = retasmFunc.auxiliarydata_set_native_scripts;
export var auxiliarydata_plutus_scripts = retasmFunc.auxiliarydata_plutus_scripts;
export var auxiliarydata_set_plutus_scripts = retasmFunc.auxiliarydata_set_plutus_scripts;
export var encode_arbitrary_bytes_as_metadatum = retasmFunc.encode_arbitrary_bytes_as_metadatum;
export var decode_arbitrary_bytes_from_metadatum = retasmFunc.decode_arbitrary_bytes_from_metadatum;
export var encode_json_str_to_metadatum = retasmFunc.encode_json_str_to_metadatum;
export var decode_metadatum_to_json_str = retasmFunc.decode_metadatum_to_json_str;
export var __wbg_linearfee_free = retasmFunc.__wbg_linearfee_free;
export var linearfee_constant = retasmFunc.linearfee_constant;
export var linearfee_coefficient = retasmFunc.linearfee_coefficient;
export var linearfee_new = retasmFunc.linearfee_new;
export var min_fee = retasmFunc.min_fee;
export var calculate_ex_units_ceil_cost = retasmFunc.calculate_ex_units_ceil_cost;
export var min_script_fee = retasmFunc.min_script_fee;
export var __wbg_transactionbuilderconfig_free = retasmFunc.__wbg_transactionbuilderconfig_free;
export var __wbg_transactionbuilderconfigbuilder_free = retasmFunc.__wbg_transactionbuilderconfigbuilder_free;
export var transactionbuilderconfigbuilder_new = retasmFunc.transactionbuilderconfigbuilder_new;
export var transactionbuilderconfigbuilder_fee_algo = retasmFunc.transactionbuilderconfigbuilder_fee_algo;
export var transactionbuilderconfigbuilder_coins_per_utxo_word = retasmFunc.transactionbuilderconfigbuilder_coins_per_utxo_word;
export var transactionbuilderconfigbuilder_ex_unit_prices = retasmFunc.transactionbuilderconfigbuilder_ex_unit_prices;
export var transactionbuilderconfigbuilder_pool_deposit = retasmFunc.transactionbuilderconfigbuilder_pool_deposit;
export var transactionbuilderconfigbuilder_key_deposit = retasmFunc.transactionbuilderconfigbuilder_key_deposit;
export var transactionbuilderconfigbuilder_max_value_size = retasmFunc.transactionbuilderconfigbuilder_max_value_size;
export var transactionbuilderconfigbuilder_max_tx_size = retasmFunc.transactionbuilderconfigbuilder_max_tx_size;
export var transactionbuilderconfigbuilder_prefer_pure_change = retasmFunc.transactionbuilderconfigbuilder_prefer_pure_change;
export var transactionbuilderconfigbuilder_build = retasmFunc.transactionbuilderconfigbuilder_build;
export var __wbg_transactionbuilder_free = retasmFunc.__wbg_transactionbuilder_free;
export var transactionbuilder_add_inputs_from = retasmFunc.transactionbuilder_add_inputs_from;
export var transactionbuilder_set_inputs = retasmFunc.transactionbuilder_set_inputs;
export var transactionbuilder_set_collateral = retasmFunc.transactionbuilder_set_collateral;
export var transactionbuilder_add_key_input = retasmFunc.transactionbuilder_add_key_input;
export var transactionbuilder_add_script_input = retasmFunc.transactionbuilder_add_script_input;
export var transactionbuilder_add_native_script_input = retasmFunc.transactionbuilder_add_native_script_input;
export var transactionbuilder_add_plutus_script_input = retasmFunc.transactionbuilder_add_plutus_script_input;
export var transactionbuilder_add_bootstrap_input = retasmFunc.transactionbuilder_add_bootstrap_input;
export var transactionbuilder_add_input = retasmFunc.transactionbuilder_add_input;
export var transactionbuilder_count_missing_input_scripts = retasmFunc.transactionbuilder_count_missing_input_scripts;
export var transactionbuilder_add_required_native_input_scripts = retasmFunc.transactionbuilder_add_required_native_input_scripts;
export var transactionbuilder_add_required_plutus_input_scripts = retasmFunc.transactionbuilder_add_required_plutus_input_scripts;
export var transactionbuilder_get_native_input_scripts = retasmFunc.transactionbuilder_get_native_input_scripts;
export var transactionbuilder_get_plutus_input_scripts = retasmFunc.transactionbuilder_get_plutus_input_scripts;
export var transactionbuilder_fee_for_input = retasmFunc.transactionbuilder_fee_for_input;
export var transactionbuilder_add_output = retasmFunc.transactionbuilder_add_output;
export var transactionbuilder_fee_for_output = retasmFunc.transactionbuilder_fee_for_output;
export var transactionbuilder_set_fee = retasmFunc.transactionbuilder_set_fee;
export var transactionbuilder_set_ttl = retasmFunc.transactionbuilder_set_ttl;
export var transactionbuilder_set_ttl_bignum = retasmFunc.transactionbuilder_set_ttl_bignum;
export var transactionbuilder_set_validity_start_interval = retasmFunc.transactionbuilder_set_validity_start_interval;
export var transactionbuilder_set_validity_start_interval_bignum = retasmFunc.transactionbuilder_set_validity_start_interval_bignum;
export var transactionbuilder_set_certs = retasmFunc.transactionbuilder_set_certs;
export var transactionbuilder_set_withdrawals = retasmFunc.transactionbuilder_set_withdrawals;
export var transactionbuilder_get_auxiliary_data = retasmFunc.transactionbuilder_get_auxiliary_data;
export var transactionbuilder_set_auxiliary_data = retasmFunc.transactionbuilder_set_auxiliary_data;
export var transactionbuilder_set_metadata = retasmFunc.transactionbuilder_set_metadata;
export var transactionbuilder_add_metadatum = retasmFunc.transactionbuilder_add_metadatum;
export var transactionbuilder_add_json_metadatum = retasmFunc.transactionbuilder_add_json_metadatum;
export var transactionbuilder_add_json_metadatum_with_schema = retasmFunc.transactionbuilder_add_json_metadatum_with_schema;
export var transactionbuilder_set_mint = retasmFunc.transactionbuilder_set_mint;
export var transactionbuilder_get_mint = retasmFunc.transactionbuilder_get_mint;
export var transactionbuilder_get_mint_scripts = retasmFunc.transactionbuilder_get_mint_scripts;
export var transactionbuilder_set_mint_asset = retasmFunc.transactionbuilder_set_mint_asset;
export var transactionbuilder_add_mint_asset = retasmFunc.transactionbuilder_add_mint_asset;
export var transactionbuilder_add_mint_asset_and_output = retasmFunc.transactionbuilder_add_mint_asset_and_output;
export var transactionbuilder_add_mint_asset_and_output_min_required_coin = retasmFunc.transactionbuilder_add_mint_asset_and_output_min_required_coin;
export var transactionbuilder_new = retasmFunc.transactionbuilder_new;
export var transactionbuilder_get_explicit_input = retasmFunc.transactionbuilder_get_explicit_input;
export var transactionbuilder_get_implicit_input = retasmFunc.transactionbuilder_get_implicit_input;
export var transactionbuilder_get_total_input = retasmFunc.transactionbuilder_get_total_input;
export var transactionbuilder_get_total_output = retasmFunc.transactionbuilder_get_total_output;
export var transactionbuilder_get_explicit_output = retasmFunc.transactionbuilder_get_explicit_output;
export var transactionbuilder_get_deposit = retasmFunc.transactionbuilder_get_deposit;
export var transactionbuilder_get_fee_if_set = retasmFunc.transactionbuilder_get_fee_if_set;
export var transactionbuilder_add_change_if_needed = retasmFunc.transactionbuilder_add_change_if_needed;
export var transactionbuilder_calc_script_data_hash = retasmFunc.transactionbuilder_calc_script_data_hash;
export var transactionbuilder_set_script_data_hash = retasmFunc.transactionbuilder_set_script_data_hash;
export var transactionbuilder_remove_script_data_hash = retasmFunc.transactionbuilder_remove_script_data_hash;
export var transactionbuilder_add_required_signer = retasmFunc.transactionbuilder_add_required_signer;
export var transactionbuilder_full_size = retasmFunc.transactionbuilder_full_size;
export var transactionbuilder_output_sizes = retasmFunc.transactionbuilder_output_sizes;
export var transactionbuilder_build = retasmFunc.transactionbuilder_build;
export var transactionbuilder_build_tx = retasmFunc.transactionbuilder_build_tx;
export var transactionbuilder_build_tx_unsafe = retasmFunc.transactionbuilder_build_tx_unsafe;
export var transactionbuilder_min_fee = retasmFunc.transactionbuilder_min_fee;
export var __wbg_bip32privatekey_free = retasmFunc.__wbg_bip32privatekey_free;
export var bip32privatekey_derive = retasmFunc.bip32privatekey_derive;
export var bip32privatekey_from_128_xprv = retasmFunc.bip32privatekey_from_128_xprv;
export var bip32privatekey_to_128_xprv = retasmFunc.bip32privatekey_to_128_xprv;
export var bip32privatekey_generate_ed25519_bip32 = retasmFunc.bip32privatekey_generate_ed25519_bip32;
export var bip32privatekey_to_raw_key = retasmFunc.bip32privatekey_to_raw_key;
export var bip32privatekey_to_public = retasmFunc.bip32privatekey_to_public;
export var bip32privatekey_from_bytes = retasmFunc.bip32privatekey_from_bytes;
export var bip32privatekey_as_bytes = retasmFunc.bip32privatekey_as_bytes;
export var bip32privatekey_from_bech32 = retasmFunc.bip32privatekey_from_bech32;
export var bip32privatekey_to_bech32 = retasmFunc.bip32privatekey_to_bech32;
export var bip32privatekey_from_bip39_entropy = retasmFunc.bip32privatekey_from_bip39_entropy;
export var bip32privatekey_chaincode = retasmFunc.bip32privatekey_chaincode;
export var __wbg_bip32publickey_free = retasmFunc.__wbg_bip32publickey_free;
export var bip32publickey_derive = retasmFunc.bip32publickey_derive;
export var bip32publickey_to_raw_key = retasmFunc.bip32publickey_to_raw_key;
export var bip32publickey_from_bytes = retasmFunc.bip32publickey_from_bytes;
export var bip32publickey_as_bytes = retasmFunc.bip32publickey_as_bytes;
export var bip32publickey_from_bech32 = retasmFunc.bip32publickey_from_bech32;
export var bip32publickey_to_bech32 = retasmFunc.bip32publickey_to_bech32;
export var bip32publickey_chaincode = retasmFunc.bip32publickey_chaincode;
export var __wbg_privatekey_free = retasmFunc.__wbg_privatekey_free;
export var privatekey_to_public = retasmFunc.privatekey_to_public;
export var privatekey_generate_ed25519 = retasmFunc.privatekey_generate_ed25519;
export var privatekey_generate_ed25519extended = retasmFunc.privatekey_generate_ed25519extended;
export var privatekey_from_bech32 = retasmFunc.privatekey_from_bech32;
export var privatekey_to_bech32 = retasmFunc.privatekey_to_bech32;
export var privatekey_as_bytes = retasmFunc.privatekey_as_bytes;
export var privatekey_from_extended_bytes = retasmFunc.privatekey_from_extended_bytes;
export var privatekey_from_normal_bytes = retasmFunc.privatekey_from_normal_bytes;
export var privatekey_sign = retasmFunc.privatekey_sign;
export var __wbg_publickey_free = retasmFunc.__wbg_publickey_free;
export var publickey_from_bech32 = retasmFunc.publickey_from_bech32;
export var publickey_to_bech32 = retasmFunc.publickey_to_bech32;
export var publickey_as_bytes = retasmFunc.publickey_as_bytes;
export var publickey_from_bytes = retasmFunc.publickey_from_bytes;
export var publickey_verify = retasmFunc.publickey_verify;
export var publickey_hash = retasmFunc.publickey_hash;
export var __wbg_vkey_free = retasmFunc.__wbg_vkey_free;
export var vkey_to_bytes = retasmFunc.vkey_to_bytes;
export var vkey_from_bytes = retasmFunc.vkey_from_bytes;
export var vkey_new = retasmFunc.vkey_new;
export var vkey_public_key = retasmFunc.vkey_public_key;
export var __wbg_vkeys_free = retasmFunc.__wbg_vkeys_free;
export var vkeys_new = retasmFunc.vkeys_new;
export var vkeys_len = retasmFunc.vkeys_len;
export var vkeys_get = retasmFunc.vkeys_get;
export var vkeys_add = retasmFunc.vkeys_add;
export var __wbg_vkeywitness_free = retasmFunc.__wbg_vkeywitness_free;
export var vkeywitness_to_bytes = retasmFunc.vkeywitness_to_bytes;
export var vkeywitness_from_bytes = retasmFunc.vkeywitness_from_bytes;
export var vkeywitness_new = retasmFunc.vkeywitness_new;
export var vkeywitness_vkey = retasmFunc.vkeywitness_vkey;
export var vkeywitness_signature = retasmFunc.vkeywitness_signature;
export var __wbg_vkeywitnesses_free = retasmFunc.__wbg_vkeywitnesses_free;
export var vkeywitnesses_new = retasmFunc.vkeywitnesses_new;
export var vkeywitnesses_len = retasmFunc.vkeywitnesses_len;
export var vkeywitnesses_get = retasmFunc.vkeywitnesses_get;
export var vkeywitnesses_add = retasmFunc.vkeywitnesses_add;
export var __wbg_bootstrapwitness_free = retasmFunc.__wbg_bootstrapwitness_free;
export var bootstrapwitness_to_bytes = retasmFunc.bootstrapwitness_to_bytes;
export var bootstrapwitness_from_bytes = retasmFunc.bootstrapwitness_from_bytes;
export var bootstrapwitness_vkey = retasmFunc.bootstrapwitness_vkey;
export var bootstrapwitness_signature = retasmFunc.bootstrapwitness_signature;
export var bootstrapwitness_chain_code = retasmFunc.bootstrapwitness_chain_code;
export var bootstrapwitness_attributes = retasmFunc.bootstrapwitness_attributes;
export var bootstrapwitness_new = retasmFunc.bootstrapwitness_new;
export var __wbg_bootstrapwitnesses_free = retasmFunc.__wbg_bootstrapwitnesses_free;
export var bootstrapwitnesses_new = retasmFunc.bootstrapwitnesses_new;
export var bootstrapwitnesses_len = retasmFunc.bootstrapwitnesses_len;
export var bootstrapwitnesses_get = retasmFunc.bootstrapwitnesses_get;
export var bootstrapwitnesses_add = retasmFunc.bootstrapwitnesses_add;
export var __wbg_publickeys_free = retasmFunc.__wbg_publickeys_free;
export var publickeys_new = retasmFunc.publickeys_new;
export var publickeys_size = retasmFunc.publickeys_size;
export var publickeys_get = retasmFunc.publickeys_get;
export var publickeys_add = retasmFunc.publickeys_add;
export var __wbg_ed25519signature_free = retasmFunc.__wbg_ed25519signature_free;
export var ed25519signature_to_bytes = retasmFunc.ed25519signature_to_bytes;
export var ed25519signature_to_bech32 = retasmFunc.ed25519signature_to_bech32;
export var ed25519signature_to_hex = retasmFunc.ed25519signature_to_hex;
export var ed25519signature_from_bech32 = retasmFunc.ed25519signature_from_bech32;
export var ed25519signature_from_hex = retasmFunc.ed25519signature_from_hex;
export var ed25519signature_from_bytes = retasmFunc.ed25519signature_from_bytes;
export var __wbg_legacydaedalusprivatekey_free = retasmFunc.__wbg_legacydaedalusprivatekey_free;
export var legacydaedalusprivatekey_from_bytes = retasmFunc.legacydaedalusprivatekey_from_bytes;
export var legacydaedalusprivatekey_as_bytes = retasmFunc.legacydaedalusprivatekey_as_bytes;
export var legacydaedalusprivatekey_chaincode = retasmFunc.legacydaedalusprivatekey_chaincode;
export var __wbg_ed25519keyhash_free = retasmFunc.__wbg_ed25519keyhash_free;
export var ed25519keyhash_to_bytes = retasmFunc.ed25519keyhash_to_bytes;
export var ed25519keyhash_to_bech32 = retasmFunc.ed25519keyhash_to_bech32;
export var ed25519keyhash_from_bech32 = retasmFunc.ed25519keyhash_from_bech32;
export var ed25519keyhash_from_bytes = retasmFunc.ed25519keyhash_from_bytes;
export var __wbg_scripthash_free = retasmFunc.__wbg_scripthash_free;
export var scripthash_to_bytes = retasmFunc.scripthash_to_bytes;
export var scripthash_to_bech32 = retasmFunc.scripthash_to_bech32;
export var scripthash_from_bech32 = retasmFunc.scripthash_from_bech32;
export var scripthash_from_bytes = retasmFunc.scripthash_from_bytes;
export var __wbg_transactionhash_free = retasmFunc.__wbg_transactionhash_free;
export var transactionhash_to_bytes = retasmFunc.transactionhash_to_bytes;
export var transactionhash_to_bech32 = retasmFunc.transactionhash_to_bech32;
export var transactionhash_from_bech32 = retasmFunc.transactionhash_from_bech32;
export var transactionhash_from_bytes = retasmFunc.transactionhash_from_bytes;
export var __wbg_genesisdelegatehash_free = retasmFunc.__wbg_genesisdelegatehash_free;
export var genesisdelegatehash_to_bytes = retasmFunc.genesisdelegatehash_to_bytes;
export var genesisdelegatehash_to_bech32 = retasmFunc.genesisdelegatehash_to_bech32;
export var genesisdelegatehash_from_bech32 = retasmFunc.genesisdelegatehash_from_bech32;
export var genesisdelegatehash_from_bytes = retasmFunc.genesisdelegatehash_from_bytes;
export var __wbg_genesishash_free = retasmFunc.__wbg_genesishash_free;
export var genesishash_to_bytes = retasmFunc.genesishash_to_bytes;
export var genesishash_to_bech32 = retasmFunc.genesishash_to_bech32;
export var genesishash_from_bech32 = retasmFunc.genesishash_from_bech32;
export var genesishash_from_bytes = retasmFunc.genesishash_from_bytes;
export var __wbg_auxiliarydatahash_free = retasmFunc.__wbg_auxiliarydatahash_free;
export var auxiliarydatahash_to_bytes = retasmFunc.auxiliarydatahash_to_bytes;
export var auxiliarydatahash_to_bech32 = retasmFunc.auxiliarydatahash_to_bech32;
export var auxiliarydatahash_from_bech32 = retasmFunc.auxiliarydatahash_from_bech32;
export var auxiliarydatahash_from_bytes = retasmFunc.auxiliarydatahash_from_bytes;
export var __wbg_poolmetadatahash_free = retasmFunc.__wbg_poolmetadatahash_free;
export var poolmetadatahash_to_bytes = retasmFunc.poolmetadatahash_to_bytes;
export var poolmetadatahash_to_bech32 = retasmFunc.poolmetadatahash_to_bech32;
export var poolmetadatahash_from_bech32 = retasmFunc.poolmetadatahash_from_bech32;
export var poolmetadatahash_from_bytes = retasmFunc.poolmetadatahash_from_bytes;
export var __wbg_vrfkeyhash_free = retasmFunc.__wbg_vrfkeyhash_free;
export var vrfkeyhash_to_bytes = retasmFunc.vrfkeyhash_to_bytes;
export var vrfkeyhash_to_bech32 = retasmFunc.vrfkeyhash_to_bech32;
export var vrfkeyhash_from_bech32 = retasmFunc.vrfkeyhash_from_bech32;
export var vrfkeyhash_from_bytes = retasmFunc.vrfkeyhash_from_bytes;
export var __wbg_blockhash_free = retasmFunc.__wbg_blockhash_free;
export var blockhash_to_bytes = retasmFunc.blockhash_to_bytes;
export var blockhash_to_bech32 = retasmFunc.blockhash_to_bech32;
export var blockhash_from_bech32 = retasmFunc.blockhash_from_bech32;
export var blockhash_from_bytes = retasmFunc.blockhash_from_bytes;
export var __wbg_datahash_free = retasmFunc.__wbg_datahash_free;
export var datahash_to_bytes = retasmFunc.datahash_to_bytes;
export var datahash_to_bech32 = retasmFunc.datahash_to_bech32;
export var datahash_from_bech32 = retasmFunc.datahash_from_bech32;
export var datahash_from_bytes = retasmFunc.datahash_from_bytes;
export var __wbg_scriptdatahash_free = retasmFunc.__wbg_scriptdatahash_free;
export var scriptdatahash_to_bytes = retasmFunc.scriptdatahash_to_bytes;
export var scriptdatahash_to_bech32 = retasmFunc.scriptdatahash_to_bech32;
export var scriptdatahash_from_bech32 = retasmFunc.scriptdatahash_from_bech32;
export var scriptdatahash_from_bytes = retasmFunc.scriptdatahash_from_bytes;
export var __wbg_vrfvkey_free = retasmFunc.__wbg_vrfvkey_free;
export var vrfvkey_to_bytes = retasmFunc.vrfvkey_to_bytes;
export var vrfvkey_to_bech32 = retasmFunc.vrfvkey_to_bech32;
export var vrfvkey_from_bech32 = retasmFunc.vrfvkey_from_bech32;
export var vrfvkey_from_bytes = retasmFunc.vrfvkey_from_bytes;
export var __wbg_kesvkey_free = retasmFunc.__wbg_kesvkey_free;
export var kesvkey_to_bytes = retasmFunc.kesvkey_to_bytes;
export var kesvkey_to_bech32 = retasmFunc.kesvkey_to_bech32;
export var kesvkey_from_bech32 = retasmFunc.kesvkey_from_bech32;
export var kesvkey_from_bytes = retasmFunc.kesvkey_from_bytes;
export var __wbg_kessignature_free = retasmFunc.__wbg_kessignature_free;
export var kessignature_to_bytes = retasmFunc.kessignature_to_bytes;
export var kessignature_from_bytes = retasmFunc.kessignature_from_bytes;
export var __wbg_nonce_free = retasmFunc.__wbg_nonce_free;
export var nonce_to_bytes = retasmFunc.nonce_to_bytes;
export var nonce_from_bytes = retasmFunc.nonce_from_bytes;
export var nonce_new_identity = retasmFunc.nonce_new_identity;
export var nonce_new_from_hash = retasmFunc.nonce_new_from_hash;
export var nonce_get_hash = retasmFunc.nonce_get_hash;
export var __wbg_vrfcert_free = retasmFunc.__wbg_vrfcert_free;
export var vrfcert_to_bytes = retasmFunc.vrfcert_to_bytes;
export var vrfcert_from_bytes = retasmFunc.vrfcert_from_bytes;
export var vrfcert_output = retasmFunc.vrfcert_output;
export var vrfcert_proof = retasmFunc.vrfcert_proof;
export var vrfcert_new = retasmFunc.vrfcert_new;
export var __wbg_plutuswitness_free = retasmFunc.__wbg_plutuswitness_free;
export var plutuswitness_new = retasmFunc.plutuswitness_new;
export var plutuswitness_script = retasmFunc.plutuswitness_script;
export var plutuswitness_datum = retasmFunc.plutuswitness_datum;
export var plutuswitness_redeemer = retasmFunc.plutuswitness_redeemer;
export var __wbg_plutuswitnesses_free = retasmFunc.__wbg_plutuswitnesses_free;
export var plutuswitnesses_new = retasmFunc.plutuswitnesses_new;
export var plutuswitnesses_len = retasmFunc.plutuswitnesses_len;
export var plutuswitnesses_get = retasmFunc.plutuswitnesses_get;
export var plutuswitnesses_add = retasmFunc.plutuswitnesses_add;
export var __wbg_txinputsbuilder_free = retasmFunc.__wbg_txinputsbuilder_free;
export var txinputsbuilder_new = retasmFunc.txinputsbuilder_new;
export var txinputsbuilder_add_key_input = retasmFunc.txinputsbuilder_add_key_input;
export var txinputsbuilder_add_script_input = retasmFunc.txinputsbuilder_add_script_input;
export var txinputsbuilder_add_native_script_input = retasmFunc.txinputsbuilder_add_native_script_input;
export var txinputsbuilder_add_plutus_script_input = retasmFunc.txinputsbuilder_add_plutus_script_input;
export var txinputsbuilder_add_bootstrap_input = retasmFunc.txinputsbuilder_add_bootstrap_input;
export var txinputsbuilder_add_input = retasmFunc.txinputsbuilder_add_input;
export var txinputsbuilder_count_missing_input_scripts = retasmFunc.txinputsbuilder_count_missing_input_scripts;
export var txinputsbuilder_add_required_native_input_scripts = retasmFunc.txinputsbuilder_add_required_native_input_scripts;
export var txinputsbuilder_add_required_plutus_input_scripts = retasmFunc.txinputsbuilder_add_required_plutus_input_scripts;
export var txinputsbuilder_get_native_input_scripts = retasmFunc.txinputsbuilder_get_native_input_scripts;
export var txinputsbuilder_get_plutus_input_scripts = retasmFunc.txinputsbuilder_get_plutus_input_scripts;
export var txinputsbuilder_len = retasmFunc.txinputsbuilder_len;
export var txinputsbuilder_add_required_signer = retasmFunc.txinputsbuilder_add_required_signer;
export var txinputsbuilder_add_required_signers = retasmFunc.txinputsbuilder_add_required_signers;
export var txinputsbuilder_inputs = retasmFunc.txinputsbuilder_inputs;
export var txinputsbuilder_inputs_option = retasmFunc.txinputsbuilder_inputs_option;
export var encrypt_with_password = retasmFunc.encrypt_with_password;
export var decrypt_with_password = retasmFunc.decrypt_with_password;
export var __wbg_networkinfo_free = retasmFunc.__wbg_networkinfo_free;
export var networkinfo_new = retasmFunc.networkinfo_new;
export var networkinfo_network_id = retasmFunc.networkinfo_network_id;
export var networkinfo_protocol_magic = retasmFunc.networkinfo_protocol_magic;
export var networkinfo_testnet = retasmFunc.networkinfo_testnet;
export var networkinfo_mainnet = retasmFunc.networkinfo_mainnet;
export var __wbg_stakecredential_free = retasmFunc.__wbg_stakecredential_free;
export var stakecredential_from_keyhash = retasmFunc.stakecredential_from_keyhash;
export var stakecredential_from_scripthash = retasmFunc.stakecredential_from_scripthash;
export var stakecredential_to_keyhash = retasmFunc.stakecredential_to_keyhash;
export var stakecredential_to_scripthash = retasmFunc.stakecredential_to_scripthash;
export var stakecredential_kind = retasmFunc.stakecredential_kind;
export var stakecredential_to_bytes = retasmFunc.stakecredential_to_bytes;
export var stakecredential_from_bytes = retasmFunc.stakecredential_from_bytes;
export var __wbg_byronaddress_free = retasmFunc.__wbg_byronaddress_free;
export var byronaddress_to_base58 = retasmFunc.byronaddress_to_base58;
export var byronaddress_to_bytes = retasmFunc.byronaddress_to_bytes;
export var byronaddress_from_bytes = retasmFunc.byronaddress_from_bytes;
export var byronaddress_byron_protocol_magic = retasmFunc.byronaddress_byron_protocol_magic;
export var byronaddress_attributes = retasmFunc.byronaddress_attributes;
export var byronaddress_network_id = retasmFunc.byronaddress_network_id;
export var byronaddress_from_base58 = retasmFunc.byronaddress_from_base58;
export var byronaddress_icarus_from_key = retasmFunc.byronaddress_icarus_from_key;
export var byronaddress_is_valid = retasmFunc.byronaddress_is_valid;
export var byronaddress_to_address = retasmFunc.byronaddress_to_address;
export var byronaddress_from_address = retasmFunc.byronaddress_from_address;
export var __wbg_address_free = retasmFunc.__wbg_address_free;
export var address_from_bytes = retasmFunc.address_from_bytes;
export var address_to_bytes = retasmFunc.address_to_bytes;
export var address_to_bech32 = retasmFunc.address_to_bech32;
export var address_from_bech32 = retasmFunc.address_from_bech32;
export var address_network_id = retasmFunc.address_network_id;
export var __wbg_baseaddress_free = retasmFunc.__wbg_baseaddress_free;
export var baseaddress_new = retasmFunc.baseaddress_new;
export var baseaddress_payment_cred = retasmFunc.baseaddress_payment_cred;
export var baseaddress_stake_cred = retasmFunc.baseaddress_stake_cred;
export var baseaddress_to_address = retasmFunc.baseaddress_to_address;
export var baseaddress_from_address = retasmFunc.baseaddress_from_address;
export var __wbg_enterpriseaddress_free = retasmFunc.__wbg_enterpriseaddress_free;
export var enterpriseaddress_new = retasmFunc.enterpriseaddress_new;
export var enterpriseaddress_payment_cred = retasmFunc.enterpriseaddress_payment_cred;
export var enterpriseaddress_to_address = retasmFunc.enterpriseaddress_to_address;
export var enterpriseaddress_from_address = retasmFunc.enterpriseaddress_from_address;
export var __wbg_rewardaddress_free = retasmFunc.__wbg_rewardaddress_free;
export var rewardaddress_new = retasmFunc.rewardaddress_new;
export var rewardaddress_payment_cred = retasmFunc.rewardaddress_payment_cred;
export var rewardaddress_to_address = retasmFunc.rewardaddress_to_address;
export var rewardaddress_from_address = retasmFunc.rewardaddress_from_address;
export var __wbg_pointer_free = retasmFunc.__wbg_pointer_free;
export var pointer_new = retasmFunc.pointer_new;
export var pointer_new_pointer = retasmFunc.pointer_new_pointer;
export var pointer_slot = retasmFunc.pointer_slot;
export var pointer_tx_index = retasmFunc.pointer_tx_index;
export var pointer_cert_index = retasmFunc.pointer_cert_index;
export var pointer_slot_bignum = retasmFunc.pointer_slot_bignum;
export var pointer_tx_index_bignum = retasmFunc.pointer_tx_index_bignum;
export var pointer_cert_index_bignum = retasmFunc.pointer_cert_index_bignum;
export var __wbg_pointeraddress_free = retasmFunc.__wbg_pointeraddress_free;
export var pointeraddress_new = retasmFunc.pointeraddress_new;
export var pointeraddress_payment_cred = retasmFunc.pointeraddress_payment_cred;
export var pointeraddress_stake_pointer = retasmFunc.pointeraddress_stake_pointer;
export var pointeraddress_to_address = retasmFunc.pointeraddress_to_address;
export var pointeraddress_from_address = retasmFunc.pointeraddress_from_address;
export var __wbg_plutusscript_free = retasmFunc.__wbg_plutusscript_free;
export var plutusscript_to_bytes = retasmFunc.plutusscript_to_bytes;
export var plutusscript_from_bytes = retasmFunc.plutusscript_from_bytes;
export var plutusscript_new = retasmFunc.plutusscript_new;
export var plutusscript_bytes = retasmFunc.plutusscript_bytes;
export var plutusscript_hash = retasmFunc.plutusscript_hash;
export var __wbg_plutusscripts_free = retasmFunc.__wbg_plutusscripts_free;
export var plutusscripts_to_bytes = retasmFunc.plutusscripts_to_bytes;
export var plutusscripts_from_bytes = retasmFunc.plutusscripts_from_bytes;
export var plutusscripts_new = retasmFunc.plutusscripts_new;
export var plutusscripts_len = retasmFunc.plutusscripts_len;
export var plutusscripts_get = retasmFunc.plutusscripts_get;
export var plutusscripts_add = retasmFunc.plutusscripts_add;
export var __wbg_constrplutusdata_free = retasmFunc.__wbg_constrplutusdata_free;
export var constrplutusdata_to_bytes = retasmFunc.constrplutusdata_to_bytes;
export var constrplutusdata_from_bytes = retasmFunc.constrplutusdata_from_bytes;
export var constrplutusdata_alternative = retasmFunc.constrplutusdata_alternative;
export var constrplutusdata_data = retasmFunc.constrplutusdata_data;
export var constrplutusdata_new = retasmFunc.constrplutusdata_new;
export var __wbg_costmodel_free = retasmFunc.__wbg_costmodel_free;
export var costmodel_to_bytes = retasmFunc.costmodel_to_bytes;
export var costmodel_from_bytes = retasmFunc.costmodel_from_bytes;
export var costmodel_new = retasmFunc.costmodel_new;
export var costmodel_set = retasmFunc.costmodel_set;
export var costmodel_get = retasmFunc.costmodel_get;
export var __wbg_costmdls_free = retasmFunc.__wbg_costmdls_free;
export var costmdls_to_bytes = retasmFunc.costmdls_to_bytes;
export var costmdls_from_bytes = retasmFunc.costmdls_from_bytes;
export var costmdls_new = retasmFunc.costmdls_new;
export var costmdls_len = retasmFunc.costmdls_len;
export var costmdls_insert = retasmFunc.costmdls_insert;
export var costmdls_get = retasmFunc.costmdls_get;
export var costmdls_keys = retasmFunc.costmdls_keys;
export var __wbg_exunitprices_free = retasmFunc.__wbg_exunitprices_free;
export var exunitprices_to_bytes = retasmFunc.exunitprices_to_bytes;
export var exunitprices_from_bytes = retasmFunc.exunitprices_from_bytes;
export var exunitprices_mem_price = retasmFunc.exunitprices_mem_price;
export var exunitprices_step_price = retasmFunc.exunitprices_step_price;
export var exunitprices_new = retasmFunc.exunitprices_new;
export var __wbg_exunits_free = retasmFunc.__wbg_exunits_free;
export var exunits_to_bytes = retasmFunc.exunits_to_bytes;
export var exunits_from_bytes = retasmFunc.exunits_from_bytes;
export var exunits_mem = retasmFunc.exunits_mem;
export var exunits_steps = retasmFunc.exunits_steps;
export var exunits_new = retasmFunc.exunits_new;
export var __wbg_language_free = retasmFunc.__wbg_language_free;
export var language_to_bytes = retasmFunc.language_to_bytes;
export var language_from_bytes = retasmFunc.language_from_bytes;
export var language_new_plutus_v1 = retasmFunc.language_new_plutus_v1;
export var language_kind = retasmFunc.language_kind;
export var __wbg_languages_free = retasmFunc.__wbg_languages_free;
export var languages_new = retasmFunc.languages_new;
export var languages_len = retasmFunc.languages_len;
export var languages_get = retasmFunc.languages_get;
export var languages_add = retasmFunc.languages_add;
export var __wbg_plutusmap_free = retasmFunc.__wbg_plutusmap_free;
export var plutusmap_to_bytes = retasmFunc.plutusmap_to_bytes;
export var plutusmap_from_bytes = retasmFunc.plutusmap_from_bytes;
export var plutusmap_new = retasmFunc.plutusmap_new;
export var plutusmap_len = retasmFunc.plutusmap_len;
export var plutusmap_insert = retasmFunc.plutusmap_insert;
export var plutusmap_get = retasmFunc.plutusmap_get;
export var plutusmap_keys = retasmFunc.plutusmap_keys;
export var __wbg_plutusdata_free = retasmFunc.__wbg_plutusdata_free;
export var plutusdata_to_bytes = retasmFunc.plutusdata_to_bytes;
export var plutusdata_from_bytes = retasmFunc.plutusdata_from_bytes;
export var plutusdata_new_constr_plutus_data = retasmFunc.plutusdata_new_constr_plutus_data;
export var plutusdata_new_empty_constr_plutus_data = retasmFunc.plutusdata_new_empty_constr_plutus_data;
export var plutusdata_new_map = retasmFunc.plutusdata_new_map;
export var plutusdata_new_list = retasmFunc.plutusdata_new_list;
export var plutusdata_new_integer = retasmFunc.plutusdata_new_integer;
export var plutusdata_new_bytes = retasmFunc.plutusdata_new_bytes;
export var plutusdata_kind = retasmFunc.plutusdata_kind;
export var plutusdata_as_constr_plutus_data = retasmFunc.plutusdata_as_constr_plutus_data;
export var plutusdata_as_map = retasmFunc.plutusdata_as_map;
export var plutusdata_as_list = retasmFunc.plutusdata_as_list;
export var plutusdata_as_integer = retasmFunc.plutusdata_as_integer;
export var plutusdata_as_bytes = retasmFunc.plutusdata_as_bytes;
export var __wbg_plutuslist_free = retasmFunc.__wbg_plutuslist_free;
export var plutuslist_to_bytes = retasmFunc.plutuslist_to_bytes;
export var plutuslist_from_bytes = retasmFunc.plutuslist_from_bytes;
export var plutuslist_new = retasmFunc.plutuslist_new;
export var plutuslist_len = retasmFunc.plutuslist_len;
export var plutuslist_get = retasmFunc.plutuslist_get;
export var plutuslist_add = retasmFunc.plutuslist_add;
export var __wbg_redeemer_free = retasmFunc.__wbg_redeemer_free;
export var redeemer_to_bytes = retasmFunc.redeemer_to_bytes;
export var redeemer_from_bytes = retasmFunc.redeemer_from_bytes;
export var redeemer_tag = retasmFunc.redeemer_tag;
export var redeemer_index = retasmFunc.redeemer_index;
export var redeemer_data = retasmFunc.redeemer_data;
export var redeemer_ex_units = retasmFunc.redeemer_ex_units;
export var redeemer_new = retasmFunc.redeemer_new;
export var __wbg_redeemertag_free = retasmFunc.__wbg_redeemertag_free;
export var redeemertag_to_bytes = retasmFunc.redeemertag_to_bytes;
export var redeemertag_from_bytes = retasmFunc.redeemertag_from_bytes;
export var redeemertag_new_spend = retasmFunc.redeemertag_new_spend;
export var redeemertag_new_mint = retasmFunc.redeemertag_new_mint;
export var redeemertag_new_cert = retasmFunc.redeemertag_new_cert;
export var redeemertag_new_reward = retasmFunc.redeemertag_new_reward;
export var redeemertag_kind = retasmFunc.redeemertag_kind;
export var __wbg_redeemers_free = retasmFunc.__wbg_redeemers_free;
export var redeemers_to_bytes = retasmFunc.redeemers_to_bytes;
export var redeemers_from_bytes = retasmFunc.redeemers_from_bytes;
export var redeemers_new = retasmFunc.redeemers_new;
export var redeemers_len = retasmFunc.redeemers_len;
export var redeemers_get = retasmFunc.redeemers_get;
export var redeemers_add = retasmFunc.redeemers_add;
export var redeemers_total_ex_units = retasmFunc.redeemers_total_ex_units;
export var __wbg_strings_free = retasmFunc.__wbg_strings_free;
export var strings_new = retasmFunc.strings_new;
export var strings_len = retasmFunc.strings_len;
export var strings_get = retasmFunc.strings_get;
export var strings_add = retasmFunc.strings_add;
export var __wbg_txbuilderconstants_free = retasmFunc.__wbg_txbuilderconstants_free;
export var txbuilderconstants_plutus_default_cost_models = retasmFunc.txbuilderconstants_plutus_default_cost_models;
export var __wbindgen_malloc = retasmFunc.__wbindgen_malloc;
export var __wbindgen_realloc = retasmFunc.__wbindgen_realloc;
export var __wbindgen_add_to_stack_pointer = retasmFunc.__wbindgen_add_to_stack_pointer;
export var __wbindgen_free = retasmFunc.__wbindgen_free;
export var __wbindgen_exn_store = retasmFunc.__wbindgen_exn_store;
